
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
'use strict';

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $1c29a66706a62afd$export$3ba232387fd5d6dd, (v) => $1c29a66706a62afd$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$3ba232387fd5d6dd;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
'use strict';
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
function $1c29a66706a62afd$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$3ba232387fd5d6dd = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
'use strict';

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$Lg(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$Sg(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Tg(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Ug = $0b2e6adb871a3b94$var$Og(!0), $0b2e6adb871a3b94$var$Vg = $0b2e6adb871a3b94$var$Og(!1), $0b2e6adb871a3b94$var$Wg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Xg = null, $0b2e6adb871a3b94$var$Yg = null, $0b2e6adb871a3b94$var$Zg = null;
function $0b2e6adb871a3b94$var$$g() {
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Xg = null;
}
function $0b2e6adb871a3b94$var$ah(a) {
    var b = $0b2e6adb871a3b94$var$Wg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    $0b2e6adb871a3b94$var$Xg = a;
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$dh = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$eh(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Yg) {
            if (null === $0b2e6adb871a3b94$var$Xg) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Yg = a;
            $0b2e6adb871a3b94$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Yg.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$fh = null;
function $0b2e6adb871a3b94$var$gh(a) {
    null === $0b2e6adb871a3b94$var$fh ? $0b2e6adb871a3b94$var$fh = [
        a
    ] : $0b2e6adb871a3b94$var$fh.push(a);
}
function $0b2e6adb871a3b94$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$ih(a, d);
}
function $0b2e6adb871a3b94$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$jh = !1;
function $0b2e6adb871a3b94$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$ih(a, c);
}
function $0b2e6adb871a3b94$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$th = {}, $0b2e6adb871a3b94$var$uh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$vh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$wh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th);
function $0b2e6adb871a3b94$var$xh(a) {
    if (a === $0b2e6adb871a3b94$var$th) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$yh(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$wh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, $0b2e6adb871a3b94$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, b);
}
function $0b2e6adb871a3b94$var$zh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$wh);
}
function $0b2e6adb871a3b94$var$Ah(a) {
    $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
    var b = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, c));
}
function $0b2e6adb871a3b94$var$Bh(a) {
    $0b2e6adb871a3b94$var$vh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh));
}
var $0b2e6adb871a3b94$var$L = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Dh = [];
function $0b2e6adb871a3b94$var$Eh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Dh.length; a++)$0b2e6adb871a3b94$var$Dh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Dh.length = 0;
}
var $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Hh = 0, $0b2e6adb871a3b94$var$M = null, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$Ih = !1, $0b2e6adb871a3b94$var$Jh = !1, $0b2e6adb871a3b94$var$Kh = 0, $0b2e6adb871a3b94$var$Lh = 0;
function $0b2e6adb871a3b94$var$P() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Nh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Hh = f;
    $0b2e6adb871a3b94$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Fh.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Oh : $0b2e6adb871a3b94$var$Ph;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Jh) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Qh;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Jh);
    }
    $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
    b = null !== $0b2e6adb871a3b94$var$N && null !== $0b2e6adb871a3b94$var$N.next;
    $0b2e6adb871a3b94$var$Hh = 0;
    $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
    $0b2e6adb871a3b94$var$Ih = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$Sh() {
    var a = 0 !== $0b2e6adb871a3b94$var$Kh;
    $0b2e6adb871a3b94$var$Kh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Uh() {
    if (null === $0b2e6adb871a3b94$var$N) {
        var a = $0b2e6adb871a3b94$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$N.next;
    var b = null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState : $0b2e6adb871a3b94$var$O.next;
    if (null !== b) $0b2e6adb871a3b94$var$O = b, $0b2e6adb871a3b94$var$N = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$N = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$N.memoizedState,
            baseState: $0b2e6adb871a3b94$var$N.baseState,
            baseQueue: $0b2e6adb871a3b94$var$N.baseQueue,
            queue: $0b2e6adb871a3b94$var$N.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    }
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$Wh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$M.lanes |= m;
                $0b2e6adb871a3b94$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$M.lanes |= f, $0b2e6adb871a3b94$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$Xh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$Yh() {}
function $0b2e6adb871a3b94$var$Zh(a, b) {
    var c = $0b2e6adb871a3b94$var$M, d = $0b2e6adb871a3b94$var$Uh(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$dh = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$$h($0b2e6adb871a3b94$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$O && $0b2e6adb871a3b94$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
}
function $0b2e6adb871a3b94$var$ai(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
    });
}
function $0b2e6adb871a3b94$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$ih(a, 1);
    null !== b && $0b2e6adb871a3b94$var$gi(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$hi(a) {
    var b = $0b2e6adb871a3b94$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ii.bind(null, $0b2e6adb871a3b94$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$ji() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$ki(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Th();
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$N) {
        var g = $0b2e6adb871a3b94$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Mh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$bi(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$mi(a, b) {
    return $0b2e6adb871a3b94$var$ki(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$$h(a, b) {
    return $0b2e6adb871a3b94$var$li(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$ni(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$oi(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$li(4, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$ri() {}
function $0b2e6adb871a3b94$var$si(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ti(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ui(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Hh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$dh = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$M.lanes |= c, $0b2e6adb871a3b94$var$rh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Gh.transition;
    $0b2e6adb871a3b94$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Gh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$wi() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$xi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, c);
    else if (c = $0b2e6adb871a3b94$var$hh(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$R();
        $0b2e6adb871a3b94$var$gi(c, a, d, e);
        $0b2e6adb871a3b94$var$Bi(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ii(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$hh(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$R(), $0b2e6adb871a3b94$var$gi(c, a, d, e), $0b2e6adb871a3b94$var$Bi(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$zi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$M || null !== b && b === $0b2e6adb871a3b94$var$M;
}
function $0b2e6adb871a3b94$var$Ai(a, b) {
    $0b2e6adb871a3b94$var$Jh = $0b2e6adb871a3b94$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$Rh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$P,
    useContext: $0b2e6adb871a3b94$var$P,
    useEffect: $0b2e6adb871a3b94$var$P,
    useImperativeHandle: $0b2e6adb871a3b94$var$P,
    useInsertionEffect: $0b2e6adb871a3b94$var$P,
    useLayoutEffect: $0b2e6adb871a3b94$var$P,
    useMemo: $0b2e6adb871a3b94$var$P,
    useReducer: $0b2e6adb871a3b94$var$P,
    useRef: $0b2e6adb871a3b94$var$P,
    useState: $0b2e6adb871a3b94$var$P,
    useDebugValue: $0b2e6adb871a3b94$var$P,
    useDeferredValue: $0b2e6adb871a3b94$var$P,
    useTransition: $0b2e6adb871a3b94$var$P,
    useMutableSource: $0b2e6adb871a3b94$var$P,
    useSyncExternalStore: $0b2e6adb871a3b94$var$P,
    useId: $0b2e6adb871a3b94$var$P,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Oh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ki(4194308, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$xi.bind(null, $0b2e6adb871a3b94$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$hi,
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$hi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$vi.bind(null, a[1]);
        $0b2e6adb871a3b94$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$M, e = $0b2e6adb871a3b94$var$Th();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$mi($0b2e6adb871a3b94$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$Th(), b = $0b2e6adb871a3b94$var$Q.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Ph = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Wh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Qh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Xh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return null === $0b2e6adb871a3b94$var$N ? b.memoizedState = a : $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $0b2e6adb871a3b94$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$R(), d = $0b2e6adb871a3b94$var$yi(a), e = $0b2e6adb871a3b94$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$nh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, d, c), $0b2e6adb871a3b94$var$oh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$eh(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $0b2e6adb871a3b94$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$eh(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Ni(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Oi || ($0b2e6adb871a3b94$var$Oi = !0, $0b2e6adb871a3b94$var$Pi = d);
        $0b2e6adb871a3b94$var$Li(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Qi(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Li(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Ri ? $0b2e6adb871a3b94$var$Ri = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$mh(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Wi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$dh = !1;
function $0b2e6adb871a3b94$var$Xi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Vg(b, null, c, d) : $0b2e6adb871a3b94$var$Ug(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$ch(b, e);
    d = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$bj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$dh = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$Zi(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$cj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj);
            $0b2e6adb871a3b94$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= d;
    $0b2e6adb871a3b94$var$Xi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$ch(b, e);
    c = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$ch(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$ij(a, b), $0b2e6adb871a3b94$var$Gi(b, c, d), $0b2e6adb871a3b94$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$eh(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$Hi(b, g, d, l);
        $0b2e6adb871a3b94$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof m && ($0b2e6adb871a3b94$var$Di(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$eh(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$Hi(b, g, d, k);
        $0b2e6adb871a3b94$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof y && ($0b2e6adb871a3b94$var$Di(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$jj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$jj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$Zi(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Ug(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Ug(b, null, h, f)) : $0b2e6adb871a3b94$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$yh(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$lj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Xi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$oj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$pj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$nj(c), b.memoizedState = $0b2e6adb871a3b94$var$mj, a) : $0b2e6adb871a3b94$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$Pg(h, f) : (f = $0b2e6adb871a3b94$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$qj(a, b) {
    b = $0b2e6adb871a3b94$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Ug(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$nj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Ki(f, d, void 0);
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$dh || h) {
        d = $0b2e6adb871a3b94$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$ih(a, e), $0b2e6adb871a3b94$var$gi(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$tj();
        d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$bh(a.return, b, c);
}
function $0b2e6adb871a3b94$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Xi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$kj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Ah(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$oj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
                a = $0b2e6adb871a3b94$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    return $0b2e6adb871a3b94$var$Zi(a, b, c);
}
var $0b2e6adb871a3b94$var$zj, $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj;
$0b2e6adb871a3b94$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Aj = function() {};
$0b2e6adb871a3b94$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Dj(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$zh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Aj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Bh(b);
            var e = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
                $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$L.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$Aj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Dj(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Gj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$L.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$fj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Ij(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Bh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L), null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Jj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Nj = !1;
function $0b2e6adb871a3b94$var$Oj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Nj;
    $0b2e6adb871a3b94$var$Nj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Xj = !1;
function $0b2e6adb871a3b94$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$Zj(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Lj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Xj = !0;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Mj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Yj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Kj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Xj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$Zj(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$dk(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Pj(3, a, a.return), $0b2e6adb871a3b94$var$Qj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Pj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$fk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$ek(a);
    }
}
function $0b2e6adb871a3b94$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$hk(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$ik(a, b, c);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Jj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Jj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$jk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$jk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$ik(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Jj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$kk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Rj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$gk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$jk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Qj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$lk = Math.ceil, $0b2e6adb871a3b94$var$mk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$fj = 0, $0b2e6adb871a3b94$var$ej = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$pk = null, $0b2e6adb871a3b94$var$rh = 0, $0b2e6adb871a3b94$var$qk = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = null, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$fk = 0, $0b2e6adb871a3b94$var$Gj = Infinity, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Oi = !1, $0b2e6adb871a3b94$var$Pi = null, $0b2e6adb871a3b94$var$Ri = null, $0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = null, $0b2e6adb871a3b94$var$xk = 0, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, $0b2e6adb871a3b94$var$Ak = -1, $0b2e6adb871a3b94$var$Bk = 0;
function $0b2e6adb871a3b94$var$R() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$Ak : $0b2e6adb871a3b94$var$Ak = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Bk && ($0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Bk;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$gi(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$yk) throw $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$Q) a === $0b2e6adb871a3b94$var$Q && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$qk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Ck(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Dk(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Ek.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Ek.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Fk(c, $0b2e6adb871a3b94$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Gk(a, b) {
    $0b2e6adb871a3b94$var$Ak = -1;
    $0b2e6adb871a3b94$var$Bk = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Hk() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Ik(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Jk();
        if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Kk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Lk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Mk(a, h);
        }
        $0b2e6adb871a3b94$var$$g();
        $0b2e6adb871a3b94$var$mk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Nk(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Ok(e) && (b = $0b2e6adb871a3b94$var$Ik(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Nk(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$fk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Gk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    var c = $0b2e6adb871a3b94$var$sk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Kk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Ik(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$tk = c, null !== b && $0b2e6adb871a3b94$var$Fj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Fj(a) {
    null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = a : $0b2e6adb871a3b94$var$tk.push.apply($0b2e6adb871a3b94$var$tk, a);
}
function $0b2e6adb871a3b94$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Ck(a, b) {
    b &= ~$0b2e6adb871a3b94$var$rk;
    b &= ~$0b2e6adb871a3b94$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Ek(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Nk(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, b), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Qk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Rk(a) {
    null !== $0b2e6adb871a3b94$var$wk && 0 === $0b2e6adb871a3b94$var$wk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$ok.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$ok.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Hj() {
    $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$ej.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$ej);
}
function $0b2e6adb871a3b94$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$zh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Eh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Bh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$zh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 10:
                $0b2e6adb871a3b94$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Hj();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$Q = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$Pg(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$fj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$pk = null;
    $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$qk = $0b2e6adb871a3b94$var$rh = 0;
    $0b2e6adb871a3b94$var$tk = $0b2e6adb871a3b94$var$sk = null;
    if (null !== $0b2e6adb871a3b94$var$fh) {
        for(b = 0; b < $0b2e6adb871a3b94$var$fh.length; b++)if (c = $0b2e6adb871a3b94$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$fh = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$$g();
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
            if ($0b2e6adb871a3b94$var$Ih) {
                for(var d = $0b2e6adb871a3b94$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Ih = !1;
            }
            $0b2e6adb871a3b94$var$Hh = 0;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            $0b2e6adb871a3b94$var$nk.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$pk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Si(f, l, b);
                            $0b2e6adb871a3b94$var$tj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Vi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ji(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$sk ? $0b2e6adb871a3b94$var$sk = [
                    f
                ] : $0b2e6adb871a3b94$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Ni(f, k, b);
                            $0b2e6adb871a3b94$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Qi(f, h, b);
                                $0b2e6adb871a3b94$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Sk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Jk() {
    var a = $0b2e6adb871a3b94$var$mk.current;
    $0b2e6adb871a3b94$var$mk.current = $0b2e6adb871a3b94$var$Rh;
    return null === a ? $0b2e6adb871a3b94$var$Rh : a;
}
function $0b2e6adb871a3b94$var$tj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$Q || 0 === ($0b2e6adb871a3b94$var$rh & 268435455) && 0 === ($0b2e6adb871a3b94$var$qk & 268435455) || $0b2e6adb871a3b94$var$Ck($0b2e6adb871a3b94$var$Q, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Ik(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Jk();
    if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Kk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Tk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Mk(a, e);
    }
    $0b2e6adb871a3b94$var$$g();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$mk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$Q = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Tk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Lk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Uk(a) {
    var b = $0b2e6adb871a3b94$var$Vk(a.alternate, a, $0b2e6adb871a3b94$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Sk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$nk.current = null;
}
function $0b2e6adb871a3b94$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Ej(c, b, $0b2e6adb871a3b94$var$fj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Pk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$ok.transition;
    try {
        $0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Wk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$ok.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Wk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Hk();
    while (null !== $0b2e6adb871a3b94$var$wk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$Q && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$vk || ($0b2e6adb871a3b94$var$vk = !0, $0b2e6adb871a3b94$var$Fk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$ok.transition;
        $0b2e6adb871a3b94$var$ok.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$nk.current = null;
        $0b2e6adb871a3b94$var$Oj(a, c);
        $0b2e6adb871a3b94$var$dk(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$hk(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$ok.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$vk && ($0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = a, $0b2e6adb871a3b94$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Ri = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Oi) throw $0b2e6adb871a3b94$var$Oi = !1, a = $0b2e6adb871a3b94$var$Pi, $0b2e6adb871a3b94$var$Pi = null, a;
    0 !== ($0b2e6adb871a3b94$var$xk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$zk ? $0b2e6adb871a3b94$var$yk++ : ($0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = a) : $0b2e6adb871a3b94$var$yk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Hk() {
    if (null !== $0b2e6adb871a3b94$var$wk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$xk), b = $0b2e6adb871a3b94$var$ok.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$ok.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$wk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$wk;
                $0b2e6adb871a3b94$var$wk = null;
                $0b2e6adb871a3b94$var$xk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Sj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Qj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$ok.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ji(c, b);
    b = $0b2e6adb871a3b94$var$Ni(a, b, 1);
    a = $0b2e6adb871a3b94$var$nh(a, b, 1);
    b = $0b2e6adb871a3b94$var$R();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Dk(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(d))) {
                a = $0b2e6adb871a3b94$var$Ji(c, a);
                a = $0b2e6adb871a3b94$var$Qi(b, a, 1);
                b = $0b2e6adb871a3b94$var$nh(b, a, 1);
                a = $0b2e6adb871a3b94$var$R();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$Q === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$fk ? $0b2e6adb871a3b94$var$Kk(a, 0) : $0b2e6adb871a3b94$var$rk |= c);
    $0b2e6adb871a3b94$var$Dk(a, b);
}
function $0b2e6adb871a3b94$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$R();
    a = $0b2e6adb871a3b94$var$ih(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Dk(a, c));
}
function $0b2e6adb871a3b94$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
function $0b2e6adb871a3b94$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
var $0b2e6adb871a3b94$var$Vk;
$0b2e6adb871a3b94$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$yj(a, b, c);
            $0b2e6adb871a3b94$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$ij(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$ch(b, c);
            e = $0b2e6adb871a3b94$var$Nh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$kh(b), e.updater = $0b2e6adb871a3b94$var$Ei, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$Ii(b, d, a, c), b = $0b2e6adb871a3b94$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$Zk(d);
                a = $0b2e6adb871a3b94$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$$i(null, b, d, $0b2e6adb871a3b94$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$kj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$lh(a, b);
                $0b2e6adb871a3b94$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Ah(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$gj(a, b), $0b2e6adb871a3b94$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$oj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Ug(b, null, d, c) : $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$Yi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$ch(b, c), e = $0b2e6adb871a3b94$var$eh(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Ci(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Ci(d.type, e), $0b2e6adb871a3b94$var$$i(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$ij(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$ch(b, c), $0b2e6adb871a3b94$var$Gi(b, d, e), $0b2e6adb871a3b94$var$Ii(b, d, e, c), $0b2e6adb871a3b94$var$jj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$xj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Fk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$$k(a, b, c, d);
}
function $0b2e6adb871a3b94$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$Zk(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Tg(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Tg(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$pj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$Qg(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$kh(f);
    return a;
}
function $0b2e6adb871a3b94$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$dl(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$el(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$dl(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$R();
    e = $0b2e6adb871a3b94$var$yi(c);
    f = $0b2e6adb871a3b94$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$nh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Dk(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$R(), g = $0b2e6adb871a3b94$var$yi(e);
    c = $0b2e6adb871a3b94$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$nh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$gi(a, e, g, f), $0b2e6adb871a3b94$var$oh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    $0b2e6adb871a3b94$var$hl(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$hl(a, b);
}
function $0b2e6adb871a3b94$var$jl() {
    return null;
}
var $0b2e6adb871a3b94$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ll(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.render = $0b2e6adb871a3b94$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$fl(a, b, null, null);
};
$0b2e6adb871a3b94$var$ml.prototype.unmount = $0b2e6adb871a3b94$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Rk(function() {
            $0b2e6adb871a3b94$var$fl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$pl() {}
function $0b2e6adb871a3b94$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$el(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$gl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$bl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$fl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$fl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$ql(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$gl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Dk(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Rk(function() {
                var b = $0b2e6adb871a3b94$var$ih(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$R();
                    $0b2e6adb871a3b94$var$gi(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$il(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$ih(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$il(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$yi(a), c = $0b2e6adb871a3b94$var$ih(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$il(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Rk;
var $0b2e6adb871a3b94$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Qk
    ]
}, $0b2e6adb871a3b94$var$tl = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$ul = {
    bundleType: $0b2e6adb871a3b94$var$tl.bundleType,
    version: $0b2e6adb871a3b94$var$tl.version,
    rendererPackageName: $0b2e6adb871a3b94$var$tl.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$tl.findFiberByHostInstance || $0b2e6adb871a3b94$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$vl.isDisabled && $0b2e6adb871a3b94$var$vl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$vl.inject($0b2e6adb871a3b94$var$ul), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$vl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$sl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$nl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$cl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ll(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Rk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$ol(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$rl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
'use strict';
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});



parcelRegister("iZZ9K", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $dd4d5cd9b8817e88$export$bf730a2d8bf68b42, (v) => $dd4d5cd9b8817e88$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $dd4d5cd9b8817e88$export$bf730a2d8bf68b42;
"use strict";

var $acw62 = parcelRequire("acw62");
function $dd4d5cd9b8817e88$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $dd4d5cd9b8817e88$var$objectIs = "function" === typeof Object.is ? Object.is : $dd4d5cd9b8817e88$var$is, $dd4d5cd9b8817e88$var$useSyncExternalStore = $acw62.useSyncExternalStore, $dd4d5cd9b8817e88$var$useRef = $acw62.useRef, $dd4d5cd9b8817e88$var$useEffect = $acw62.useEffect, $dd4d5cd9b8817e88$var$useMemo = $acw62.useMemo, $dd4d5cd9b8817e88$var$useDebugValue = $acw62.useDebugValue;
$dd4d5cd9b8817e88$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $dd4d5cd9b8817e88$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $dd4d5cd9b8817e88$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($dd4d5cd9b8817e88$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $dd4d5cd9b8817e88$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $dd4d5cd9b8817e88$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $dd4d5cd9b8817e88$var$useDebugValue(value);
    return value;
};

});

parcelRegister("kjyEk", function(module, exports) {
"use strict";

});

parcelRegister("joOgL", function(module, exports) {
/*! cpexcel.js (C) 2013-present SheetJS -- http://sheetjs.com */ /*jshint -W100 */ 
var $kjyEk = parcelRequire("kjyEk");
var $e1f740a9d01acc72$require$Buffer = $kjyEk.Buffer;
var $e1f740a9d01acc72$var$cptable = {
    version: "1.15.0"
};
$e1f740a9d01acc72$var$cptable[437] = function() {
    var d = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xef\xee\xec\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xf2\xfb\xf9\xff\xd6\xdc\xa2\xa3\xa5\u20A7\u0192\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\u2310\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
$e1f740a9d01acc72$var$cptable[620] = function() {
    var d = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\xc7\xfc\xe9\xe2\xe4\xe0\u0105\xe7\xea\xeb\xe8\xef\xee\u0107\xc4\u0104\u0118\u0119\u0142\xf4\xf6\u0106\xfb\xf9\u015A\xd6\xdc\xa2\u0141\xa5\u015B\u0192\u0179\u017B\xf3\xd3\u0144\u0143\u017A\u017C\xbf\u2310\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
$e1f740a9d01acc72$var$cptable[737] = function() {
    var d = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\u0391\u0392\u0393\u0394\u0395\u0396\u0397\u0398\u0399\u039A\u039B\u039C\u039D\u039E\u039F\u03A0\u03A1\u03A3\u03A4\u03A5\u03A6\u03A7\u03A8\u03A9\u03B1\u03B2\u03B3\u03B4\u03B5\u03B6\u03B7\u03B8\u03B9\u03BA\u03BB\u03BC\u03BD\u03BE\u03BF\u03C0\u03C1\u03C3\u03C2\u03C4\u03C5\u03C6\u03C7\u03C8\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03C9\u03AC\u03AD\u03AE\u03CA\u03AF\u03CC\u03CD\u03CB\u03CE\u0386\u0388\u0389\u038A\u038C\u038E\u038F\xb1\u2265\u2264\u03AA\u03AB\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
$e1f740a9d01acc72$var$cptable[850] = function() {
    var d = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xef\xee\xec\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xf2\xfb\xf9\xff\xd6\xdc\xf8\xa3\xd8\xd7\u0192\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\xae\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\xc1\xc2\xc0\xa9\u2563\u2551\u2557\u255D\xa2\xa5\u2510\u2514\u2534\u252C\u251C\u2500\u253C\xe3\xc3\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xa4\xf0\xd0\xca\xcb\xc8\u0131\xcd\xce\xcf\u2518\u250C\u2588\u2584\xa6\xcc\u2580\xd3\xdf\xd4\xd2\xf5\xd5\xb5\xfe\xde\xda\xdb\xd9\xfd\xdd\xaf\xb4\xad\xb1\u2017\xbe\xb6\xa7\xf7\xb8\xb0\xa8\xb7\xb9\xb3\xb2\u25A0\xa0", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
$e1f740a9d01acc72$var$cptable[852] = function() {
    var d = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\xc7\xfc\xe9\xe2\xe4\u016F\u0107\xe7\u0142\xeb\u0150\u0151\xee\u0179\xc4\u0106\xc9\u0139\u013A\xf4\xf6\u013D\u013E\u015A\u015B\xd6\xdc\u0164\u0165\u0141\xd7\u010D\xe1\xed\xf3\xfa\u0104\u0105\u017D\u017E\u0118\u0119\xac\u017A\u010C\u015F\xab\xbb\u2591\u2592\u2593\u2502\u2524\xc1\xc2\u011A\u015E\u2563\u2551\u2557\u255D\u017B\u017C\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u0102\u0103\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xa4\u0111\u0110\u010E\xcb\u010F\u0147\xcd\xce\u011B\u2518\u250C\u2588\u2584\u0162\u016E\u2580\xd3\xdf\xd4\u0143\u0144\u0148\u0160\u0161\u0154\xda\u0155\u0170\xfd\xdd\u0163\xb4\xad\u02DD\u02DB\u02C7\u02D8\xa7\xf7\xb8\xb0\xa8\u02D9\u0171\u0158\u0159\u25A0\xa0", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
$e1f740a9d01acc72$var$cptable[857] = function() {
    var d = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xef\xee\u0131\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xf2\xfb\xf9\u0130\xd6\xdc\xf8\xa3\xd8\u015E\u015F\xe1\xed\xf3\xfa\xf1\xd1\u011E\u011F\xbf\xae\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\xc1\xc2\xc0\xa9\u2563\u2551\u2557\u255D\xa2\xa5\u2510\u2514\u2534\u252C\u251C\u2500\u253C\xe3\xc3\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xa4\xba\xaa\xca\xcb\xc8\uFFFD\xcd\xce\xcf\u2518\u250C\u2588\u2584\xa6\xcc\u2580\xd3\xdf\xd4\xd2\xf5\xd5\xb5\uFFFD\xd7\xda\xdb\xd9\xec\xff\xaf\xb4\xad\xb1\uFFFD\xbe\xb6\xa7\xf7\xb8\xb0\xa8\xb7\xb9\xb3\xb2\u25A0\xa0", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
$e1f740a9d01acc72$var$cptable[861] = function() {
    var d = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xd0\xf0\xde\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xfe\xfb\xdd\xfd\xd6\xdc\xf8\xa3\xd8\u20A7\u0192\xe1\xed\xf3\xfa\xc1\xcd\xd3\xda\xbf\u2310\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
$e1f740a9d01acc72$var$cptable[865] = function() {
    var d = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xef\xee\xec\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xf2\xfb\xf9\xff\xd6\xdc\xf8\xa3\xd8\u20A7\u0192\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\u2310\xac\xbd\xbc\xa1\xab\xa4\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
$e1f740a9d01acc72$var$cptable[866] = function() {
    var d = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\u0401\u0451\u0404\u0454\u0407\u0457\u040E\u045E\xb0\u2219\xb7\u221A\u2116\xa4\u25A0\xa0", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
$e1f740a9d01acc72$var$cptable[874] = function() {
    var d = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\u20AC\uFFFD\uFFFD\uFFFD\uFFFD\u2026\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\xa0\u0E01\u0E02\u0E03\u0E04\u0E05\u0E06\u0E07\u0E08\u0E09\u0E0A\u0E0B\u0E0C\u0E0D\u0E0E\u0E0F\u0E10\u0E11\u0E12\u0E13\u0E14\u0E15\u0E16\u0E17\u0E18\u0E19\u0E1A\u0E1B\u0E1C\u0E1D\u0E1E\u0E1F\u0E20\u0E21\u0E22\u0E23\u0E24\u0E25\u0E26\u0E27\u0E28\u0E29\u0E2A\u0E2B\u0E2C\u0E2D\u0E2E\u0E2F\u0E30\u0E31\u0E32\u0E33\u0E34\u0E35\u0E36\u0E37\u0E38\u0E39\u0E3A\uFFFD\uFFFD\uFFFD\uFFFD\u0E3F\u0E40\u0E41\u0E42\u0E43\u0E44\u0E45\u0E46\u0E47\u0E48\u0E49\u0E4A\u0E4B\u0E4C\u0E4D\u0E4E\u0E4F\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59\u0E5A\u0E5B\uFFFD\uFFFD\uFFFD\uFFFD", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
$e1f740a9d01acc72$var$cptable[895] = function() {
    var d = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\u010C\xfc\xe9\u010F\xe4\u010E\u0164\u010D\u011B\u011A\u0139\xcd\u013E\u01EA\xc4\xc1\xc9\u017E\u017D\xf4\xf6\xd3\u016F\xda\xfd\xd6\xdc\u0160\u013D\xdd\u0158\u0165\xe1\xed\xf3\xfa\u0148\u0147\u016E\xd4\u0161\u0159\u0155\u0154\xbc\xa7\xab\xbb\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
$e1f740a9d01acc72$var$cptable[932] = function() {
    var d = [], e = {}, D = [], j;
    D[0] = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFF61\uFF62\uFF63\uFF64\uFF65\uFF66\uFF67\uFF68\uFF69\uFF6A\uFF6B\uFF6C\uFF6D\uFF6E\uFF6F\uFF70\uFF71\uFF72\uFF73\uFF74\uFF75\uFF76\uFF77\uFF78\uFF79\uFF7A\uFF7B\uFF7C\uFF7D\uFF7E\uFF7F\uFF80\uFF81\uFF82\uFF83\uFF84\uFF85\uFF86\uFF87\uFF88\uFF89\uFF8A\uFF8B\uFF8C\uFF8D\uFF8E\uFF8F\uFF90\uFF91\uFF92\uFF93\uFF94\uFF95\uFF96\uFF97\uFF98\uFF99\uFF9A\uFF9B\uFF9C\uFF9D\uFF9E\uFF9F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[0].length; ++j)if (D[0][j].charCodeAt(0) !== 0xFFFD) {
        e[D[0][j]] = 0 + j;
        d[0 + j] = D[0][j];
    }
    D[129] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u3000\u3001\u3002\uFF0C\uFF0E\u30FB\uFF1A\uFF1B\uFF1F\uFF01\u309B\u309C\xb4\uFF40\xa8\uFF3E\uFFE3\uFF3F\u30FD\u30FE\u309D\u309E\u3003\u4EDD\u3005\u3006\u3007\u30FC\u2015\u2010\uFF0F\uFF3C\uFF5E\u2225\uFF5C\u2026\u2025\u2018\u2019\u201C\u201D\uFF08\uFF09\u3014\u3015\uFF3B\uFF3D\uFF5B\uFF5D\u3008\u3009\u300A\u300B\u300C\u300D\u300E\u300F\u3010\u3011\uFF0B\uFF0D\xb1\xd7\uFFFD\xf7\uFF1D\u2260\uFF1C\uFF1E\u2266\u2267\u221E\u2234\u2642\u2640\xb0\u2032\u2033\u2103\uFFE5\uFF04\uFFE0\uFFE1\uFF05\uFF03\uFF06\uFF0A\uFF20\xa7\u2606\u2605\u25CB\u25CF\u25CE\u25C7\u25C6\u25A1\u25A0\u25B3\u25B2\u25BD\u25BC\u203B\u3012\u2192\u2190\u2191\u2193\u3013\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2208\u220B\u2286\u2287\u2282\u2283\u222A\u2229\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2227\u2228\uFFE2\u21D2\u21D4\u2200\u2203\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2220\u22A5\u2312\u2202\u2207\u2261\u2252\u226A\u226B\u221A\u223D\u221D\u2235\u222B\u222C\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u212B\u2030\u266F\u266D\u266A\u2020\u2021\xb6\uFFFD\uFFFD\uFFFD\uFFFD\u25EF\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[129].length; ++j)if (D[129][j].charCodeAt(0) !== 0xFFFD) {
        e[D[129][j]] = 33024 + j;
        d[33024 + j] = D[129][j];
    }
    D[130] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFF10\uFF11\uFF12\uFF13\uFF14\uFF15\uFF16\uFF17\uFF18\uFF19\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFF21\uFF22\uFF23\uFF24\uFF25\uFF26\uFF27\uFF28\uFF29\uFF2A\uFF2B\uFF2C\uFF2D\uFF2E\uFF2F\uFF30\uFF31\uFF32\uFF33\uFF34\uFF35\uFF36\uFF37\uFF38\uFF39\uFF3A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFF41\uFF42\uFF43\uFF44\uFF45\uFF46\uFF47\uFF48\uFF49\uFF4A\uFF4B\uFF4C\uFF4D\uFF4E\uFF4F\uFF50\uFF51\uFF52\uFF53\uFF54\uFF55\uFF56\uFF57\uFF58\uFF59\uFF5A\uFFFD\uFFFD\uFFFD\uFFFD\u3041\u3042\u3043\u3044\u3045\u3046\u3047\u3048\u3049\u304A\u304B\u304C\u304D\u304E\u304F\u3050\u3051\u3052\u3053\u3054\u3055\u3056\u3057\u3058\u3059\u305A\u305B\u305C\u305D\u305E\u305F\u3060\u3061\u3062\u3063\u3064\u3065\u3066\u3067\u3068\u3069\u306A\u306B\u306C\u306D\u306E\u306F\u3070\u3071\u3072\u3073\u3074\u3075\u3076\u3077\u3078\u3079\u307A\u307B\u307C\u307D\u307E\u307F\u3080\u3081\u3082\u3083\u3084\u3085\u3086\u3087\u3088\u3089\u308A\u308B\u308C\u308D\u308E\u308F\u3090\u3091\u3092\u3093\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[130].length; ++j)if (D[130][j].charCodeAt(0) !== 0xFFFD) {
        e[D[130][j]] = 33280 + j;
        d[33280 + j] = D[130][j];
    }
    D[131] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u30A1\u30A2\u30A3\u30A4\u30A5\u30A6\u30A7\u30A8\u30A9\u30AA\u30AB\u30AC\u30AD\u30AE\u30AF\u30B0\u30B1\u30B2\u30B3\u30B4\u30B5\u30B6\u30B7\u30B8\u30B9\u30BA\u30BB\u30BC\u30BD\u30BE\u30BF\u30C0\u30C1\u30C2\u30C3\u30C4\u30C5\u30C6\u30C7\u30C8\u30C9\u30CA\u30CB\u30CC\u30CD\u30CE\u30CF\u30D0\u30D1\u30D2\u30D3\u30D4\u30D5\u30D6\u30D7\u30D8\u30D9\u30DA\u30DB\u30DC\u30DD\u30DE\u30DF\uFFFD\u30E0\u30E1\u30E2\u30E3\u30E4\u30E5\u30E6\u30E7\u30E8\u30E9\u30EA\u30EB\u30EC\u30ED\u30EE\u30EF\u30F0\u30F1\u30F2\u30F3\u30F4\u30F5\u30F6\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0391\u0392\u0393\u0394\u0395\u0396\u0397\u0398\u0399\u039A\u039B\u039C\u039D\u039E\u039F\u03A0\u03A1\u03A3\u03A4\u03A5\u03A6\u03A7\u03A8\u03A9\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u03B1\u03B2\u03B3\u03B4\u03B5\u03B6\u03B7\u03B8\u03B9\u03BA\u03BB\u03BC\u03BD\u03BE\u03BF\u03C0\u03C1\u03C3\u03C4\u03C5\u03C6\u03C7\u03C8\u03C9\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[131].length; ++j)if (D[131][j].charCodeAt(0) !== 0xFFFD) {
        e[D[131][j]] = 33536 + j;
        d[33536 + j] = D[131][j];
    }
    D[132] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0410\u0411\u0412\u0413\u0414\u0415\u0401\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0430\u0431\u0432\u0433\u0434\u0435\u0451\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\uFFFD\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2500\u2502\u250C\u2510\u2518\u2514\u251C\u252C\u2524\u2534\u253C\u2501\u2503\u250F\u2513\u251B\u2517\u2523\u2533\u252B\u253B\u254B\u2520\u252F\u2528\u2537\u253F\u251D\u2530\u2525\u2538\u2542\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[132].length; ++j)if (D[132][j].charCodeAt(0) !== 0xFFFD) {
        e[D[132][j]] = 33792 + j;
        d[33792 + j] = D[132][j];
    }
    D[135] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2460\u2461\u2462\u2463\u2464\u2465\u2466\u2467\u2468\u2469\u246A\u246B\u246C\u246D\u246E\u246F\u2470\u2471\u2472\u2473\u2160\u2161\u2162\u2163\u2164\u2165\u2166\u2167\u2168\u2169\uFFFD\u3349\u3314\u3322\u334D\u3318\u3327\u3303\u3336\u3351\u3357\u330D\u3326\u3323\u332B\u334A\u333B\u339C\u339D\u339E\u338E\u338F\u33C4\u33A1\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u337B\uFFFD\u301D\u301F\u2116\u33CD\u2121\u32A4\u32A5\u32A6\u32A7\u32A8\u3231\u3232\u3239\u337E\u337D\u337C\u2252\u2261\u222B\u222E\u2211\u221A\u22A5\u2220\u221F\u22BF\u2235\u2229\u222A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[135].length; ++j)if (D[135][j].charCodeAt(0) !== 0xFFFD) {
        e[D[135][j]] = 34560 + j;
        d[34560 + j] = D[135][j];
    }
    D[136] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u4E9C\u5516\u5A03\u963F\u54C0\u611B\u6328\u59F6\u9022\u8475\u831C\u7A50\u60AA\u63E1\u6E25\u65ED\u8466\u82A6\u9BF5\u6893\u5727\u65A1\u6271\u5B9B\u59D0\u867B\u98F4\u7D62\u7DBE\u9B8E\u6216\u7C9F\u88B7\u5B89\u5EB5\u6309\u6697\u6848\u95C7\u978D\u674F\u4EE5\u4F0A\u4F4D\u4F9D\u5049\u56F2\u5937\u59D4\u5A01\u5C09\u60DF\u610F\u6170\u6613\u6905\u70BA\u754F\u7570\u79FB\u7DAD\u7DEF\u80C3\u840E\u8863\u8B02\u9055\u907A\u533B\u4E95\u4EA5\u57DF\u80B2\u90C1\u78EF\u4E00\u58F1\u6EA2\u9038\u7A32\u8328\u828B\u9C2F\u5141\u5370\u54BD\u54E1\u56E0\u59FB\u5F15\u98F2\u6DEB\u80E4\u852D\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[136].length; ++j)if (D[136][j].charCodeAt(0) !== 0xFFFD) {
        e[D[136][j]] = 34816 + j;
        d[34816 + j] = D[136][j];
    }
    D[137] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9662\u9670\u96A0\u97FB\u540B\u53F3\u5B87\u70CF\u7FBD\u8FC2\u96E8\u536F\u9D5C\u7ABA\u4E11\u7893\u81FC\u6E26\u5618\u5504\u6B1D\u851A\u9C3B\u59E5\u53A9\u6D66\u74DC\u958F\u5642\u4E91\u904B\u96F2\u834F\u990C\u53E1\u55B6\u5B30\u5F71\u6620\u66F3\u6804\u6C38\u6CF3\u6D29\u745B\u76C8\u7A4E\u9834\u82F1\u885B\u8A60\u92ED\u6DB2\u75AB\u76CA\u99C5\u60A6\u8B01\u8D8A\u95B2\u698E\u53AD\u5186\uFFFD\u5712\u5830\u5944\u5BB4\u5EF6\u6028\u63A9\u63F4\u6CBF\u6F14\u708E\u7114\u7159\u71D5\u733F\u7E01\u8276\u82D1\u8597\u9060\u925B\u9D1B\u5869\u65BC\u6C5A\u7525\u51F9\u592E\u5965\u5F80\u5FDC\u62BC\u65FA\u6A2A\u6B27\u6BB4\u738B\u7FC1\u8956\u9D2C\u9D0E\u9EC4\u5CA1\u6C96\u837B\u5104\u5C4B\u61B6\u81C6\u6876\u7261\u4E59\u4FFA\u5378\u6069\u6E29\u7A4F\u97F3\u4E0B\u5316\u4EEE\u4F55\u4F3D\u4FA1\u4F73\u52A0\u53EF\u5609\u590F\u5AC1\u5BB6\u5BE1\u79D1\u6687\u679C\u67B6\u6B4C\u6CB3\u706B\u73C2\u798D\u79BE\u7A3C\u7B87\u82B1\u82DB\u8304\u8377\u83EF\u83D3\u8766\u8AB2\u5629\u8CA8\u8FE6\u904E\u971E\u868A\u4FC4\u5CE8\u6211\u7259\u753B\u81E5\u82BD\u86FE\u8CC0\u96C5\u9913\u99D5\u4ECB\u4F1A\u89E3\u56DE\u584A\u58CA\u5EFB\u5FEB\u602A\u6094\u6062\u61D0\u6212\u62D0\u6539\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[137].length; ++j)if (D[137][j].charCodeAt(0) !== 0xFFFD) {
        e[D[137][j]] = 35072 + j;
        d[35072 + j] = D[137][j];
    }
    D[138] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9B41\u6666\u68B0\u6D77\u7070\u754C\u7686\u7D75\u82A5\u87F9\u958B\u968E\u8C9D\u51F1\u52BE\u5916\u54B3\u5BB3\u5D16\u6168\u6982\u6DAF\u788D\u84CB\u8857\u8A72\u93A7\u9AB8\u6D6C\u99A8\u86D9\u57A3\u67FF\u86CE\u920E\u5283\u5687\u5404\u5ED3\u62E1\u64B9\u683C\u6838\u6BBB\u7372\u78BA\u7A6B\u899A\u89D2\u8D6B\u8F03\u90ED\u95A3\u9694\u9769\u5B66\u5CB3\u697D\u984D\u984E\u639B\u7B20\u6A2B\uFFFD\u6A7F\u68B6\u9C0D\u6F5F\u5272\u559D\u6070\u62EC\u6D3B\u6E07\u6ED1\u845B\u8910\u8F44\u4E14\u9C39\u53F6\u691B\u6A3A\u9784\u682A\u515C\u7AC3\u84B2\u91DC\u938C\u565B\u9D28\u6822\u8305\u8431\u7CA5\u5208\u82C5\u74E6\u4E7E\u4F83\u51A0\u5BD2\u520A\u52D8\u52E7\u5DFB\u559A\u582A\u59E6\u5B8C\u5B98\u5BDB\u5E72\u5E79\u60A3\u611F\u6163\u61BE\u63DB\u6562\u67D1\u6853\u68FA\u6B3E\u6B53\u6C57\u6F22\u6F97\u6F45\u74B0\u7518\u76E3\u770B\u7AFF\u7BA1\u7C21\u7DE9\u7F36\u7FF0\u809D\u8266\u839E\u89B3\u8ACC\u8CAB\u9084\u9451\u9593\u9591\u95A2\u9665\u97D3\u9928\u8218\u4E38\u542B\u5CB8\u5DCC\u73A9\u764C\u773C\u5CA9\u7FEB\u8D0B\u96C1\u9811\u9854\u9858\u4F01\u4F0E\u5371\u559C\u5668\u57FA\u5947\u5B09\u5BC4\u5C90\u5E0C\u5E7E\u5FCC\u63EE\u673A\u65D7\u65E2\u671F\u68CB\u68C4\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[138].length; ++j)if (D[138][j].charCodeAt(0) !== 0xFFFD) {
        e[D[138][j]] = 35328 + j;
        d[35328 + j] = D[138][j];
    }
    D[139] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6A5F\u5E30\u6BC5\u6C17\u6C7D\u757F\u7948\u5B63\u7A00\u7D00\u5FBD\u898F\u8A18\u8CB4\u8D77\u8ECC\u8F1D\u98E2\u9A0E\u9B3C\u4E80\u507D\u5100\u5993\u5B9C\u622F\u6280\u64EC\u6B3A\u72A0\u7591\u7947\u7FA9\u87FB\u8ABC\u8B70\u63AC\u83CA\u97A0\u5409\u5403\u55AB\u6854\u6A58\u8A70\u7827\u6775\u9ECD\u5374\u5BA2\u811A\u8650\u9006\u4E18\u4E45\u4EC7\u4F11\u53CA\u5438\u5BAE\u5F13\u6025\u6551\uFFFD\u673D\u6C42\u6C72\u6CE3\u7078\u7403\u7A76\u7AAE\u7B08\u7D1A\u7CFE\u7D66\u65E7\u725B\u53BB\u5C45\u5DE8\u62D2\u62E0\u6319\u6E20\u865A\u8A31\u8DDD\u92F8\u6F01\u79A6\u9B5A\u4EA8\u4EAB\u4EAC\u4F9B\u4FA0\u50D1\u5147\u7AF6\u5171\u51F6\u5354\u5321\u537F\u53EB\u55AC\u5883\u5CE1\u5F37\u5F4A\u602F\u6050\u606D\u631F\u6559\u6A4B\u6CC1\u72C2\u72ED\u77EF\u80F8\u8105\u8208\u854E\u90F7\u93E1\u97FF\u9957\u9A5A\u4EF0\u51DD\u5C2D\u6681\u696D\u5C40\u66F2\u6975\u7389\u6850\u7C81\u50C5\u52E4\u5747\u5DFE\u9326\u65A4\u6B23\u6B3D\u7434\u7981\u79BD\u7B4B\u7DCA\u82B9\u83CC\u887F\u895F\u8B39\u8FD1\u91D1\u541F\u9280\u4E5D\u5036\u53E5\u533A\u72D7\u7396\u77E9\u82E6\u8EAF\u99C6\u99C8\u99D2\u5177\u611A\u865E\u55B0\u7A7A\u5076\u5BD3\u9047\u9685\u4E32\u6ADB\u91E7\u5C51\u5C48\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[139].length; ++j)if (D[139][j].charCodeAt(0) !== 0xFFFD) {
        e[D[139][j]] = 35584 + j;
        d[35584 + j] = D[139][j];
    }
    D[140] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6398\u7A9F\u6C93\u9774\u8F61\u7AAA\u718A\u9688\u7C82\u6817\u7E70\u6851\u936C\u52F2\u541B\u85AB\u8A13\u7FA4\u8ECD\u90E1\u5366\u8888\u7941\u4FC2\u50BE\u5211\u5144\u5553\u572D\u73EA\u578B\u5951\u5F62\u5F84\u6075\u6176\u6167\u61A9\u63B2\u643A\u656C\u666F\u6842\u6E13\u7566\u7A3D\u7CFB\u7D4C\u7D99\u7E4B\u7F6B\u830E\u834A\u86CD\u8A08\u8A63\u8B66\u8EFD\u981A\u9D8F\u82B8\u8FCE\u9BE8\uFFFD\u5287\u621F\u6483\u6FC0\u9699\u6841\u5091\u6B20\u6C7A\u6F54\u7A74\u7D50\u8840\u8A23\u6708\u4EF6\u5039\u5026\u5065\u517C\u5238\u5263\u55A7\u570F\u5805\u5ACC\u5EFA\u61B2\u61F8\u62F3\u6372\u691C\u6A29\u727D\u72AC\u732E\u7814\u786F\u7D79\u770C\u80A9\u898B\u8B19\u8CE2\u8ED2\u9063\u9375\u967A\u9855\u9A13\u9E78\u5143\u539F\u53B3\u5E7B\u5F26\u6E1B\u6E90\u7384\u73FE\u7D43\u8237\u8A00\u8AFA\u9650\u4E4E\u500B\u53E4\u547C\u56FA\u59D1\u5B64\u5DF1\u5EAB\u5F27\u6238\u6545\u67AF\u6E56\u72D0\u7CCA\u88B4\u80A1\u80E1\u83F0\u864E\u8A87\u8DE8\u9237\u96C7\u9867\u9F13\u4E94\u4E92\u4F0D\u5348\u5449\u543E\u5A2F\u5F8C\u5FA1\u609F\u68A7\u6A8E\u745A\u7881\u8A9E\u8AA4\u8B77\u9190\u4E5E\u9BC9\u4EA4\u4F7C\u4FAF\u5019\u5016\u5149\u516C\u529F\u52B9\u52FE\u539A\u53E3\u5411\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[140].length; ++j)if (D[140][j].charCodeAt(0) !== 0xFFFD) {
        e[D[140][j]] = 35840 + j;
        d[35840 + j] = D[140][j];
    }
    D[141] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u540E\u5589\u5751\u57A2\u597D\u5B54\u5B5D\u5B8F\u5DE5\u5DE7\u5DF7\u5E78\u5E83\u5E9A\u5EB7\u5F18\u6052\u614C\u6297\u62D8\u63A7\u653B\u6602\u6643\u66F4\u676D\u6821\u6897\u69CB\u6C5F\u6D2A\u6D69\u6E2F\u6E9D\u7532\u7687\u786C\u7A3F\u7CE0\u7D05\u7D18\u7D5E\u7DB1\u8015\u8003\u80AF\u80B1\u8154\u818F\u822A\u8352\u884C\u8861\u8B1B\u8CA2\u8CFC\u90CA\u9175\u9271\u783F\u92FC\u95A4\u964D\uFFFD\u9805\u9999\u9AD8\u9D3B\u525B\u52AB\u53F7\u5408\u58D5\u62F7\u6FE0\u8C6A\u8F5F\u9EB9\u514B\u523B\u544A\u56FD\u7A40\u9177\u9D60\u9ED2\u7344\u6F09\u8170\u7511\u5FFD\u60DA\u9AA8\u72DB\u8FBC\u6B64\u9803\u4ECA\u56F0\u5764\u58BE\u5A5A\u6068\u61C7\u660F\u6606\u6839\u68B1\u6DF7\u75D5\u7D3A\u826E\u9B42\u4E9B\u4F50\u53C9\u5506\u5D6F\u5DE6\u5DEE\u67FB\u6C99\u7473\u7802\u8A50\u9396\u88DF\u5750\u5EA7\u632B\u50B5\u50AC\u518D\u6700\u54C9\u585E\u59BB\u5BB0\u5F69\u624D\u63A1\u683D\u6B73\u6E08\u707D\u91C7\u7280\u7815\u7826\u796D\u658E\u7D30\u83DC\u88C1\u8F09\u969B\u5264\u5728\u6750\u7F6A\u8CA1\u51B4\u5742\u962A\u583A\u698A\u80B4\u54B2\u5D0E\u57FC\u7895\u9DFA\u4F5C\u524A\u548B\u643E\u6628\u6714\u67F5\u7A84\u7B56\u7D22\u932F\u685C\u9BAD\u7B39\u5319\u518A\u5237\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[141].length; ++j)if (D[141][j].charCodeAt(0) !== 0xFFFD) {
        e[D[141][j]] = 36096 + j;
        d[36096 + j] = D[141][j];
    }
    D[142] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5BDF\u62F6\u64AE\u64E6\u672D\u6BBA\u85A9\u96D1\u7690\u9BD6\u634C\u9306\u9BAB\u76BF\u6652\u4E09\u5098\u53C2\u5C71\u60E8\u6492\u6563\u685F\u71E6\u73CA\u7523\u7B97\u7E82\u8695\u8B83\u8CDB\u9178\u9910\u65AC\u66AB\u6B8B\u4ED5\u4ED4\u4F3A\u4F7F\u523A\u53F8\u53F2\u55E3\u56DB\u58EB\u59CB\u59C9\u59FF\u5B50\u5C4D\u5E02\u5E2B\u5FD7\u601D\u6307\u652F\u5B5C\u65AF\u65BD\u65E8\u679D\u6B62\uFFFD\u6B7B\u6C0F\u7345\u7949\u79C1\u7CF8\u7D19\u7D2B\u80A2\u8102\u81F3\u8996\u8A5E\u8A69\u8A66\u8A8C\u8AEE\u8CC7\u8CDC\u96CC\u98FC\u6B6F\u4E8B\u4F3C\u4F8D\u5150\u5B57\u5BFA\u6148\u6301\u6642\u6B21\u6ECB\u6CBB\u723E\u74BD\u75D4\u78C1\u793A\u800C\u8033\u81EA\u8494\u8F9E\u6C50\u9E7F\u5F0F\u8B58\u9D2B\u7AFA\u8EF8\u5B8D\u96EB\u4E03\u53F1\u57F7\u5931\u5AC9\u5BA4\u6089\u6E7F\u6F06\u75BE\u8CEA\u5B9F\u8500\u7BE0\u5072\u67F4\u829D\u5C61\u854A\u7E1E\u820E\u5199\u5C04\u6368\u8D66\u659C\u716E\u793E\u7D17\u8005\u8B1D\u8ECA\u906E\u86C7\u90AA\u501F\u52FA\u5C3A\u6753\u707C\u7235\u914C\u91C8\u932B\u82E5\u5BC2\u5F31\u60F9\u4E3B\u53D6\u5B88\u624B\u6731\u6B8A\u72E9\u73E0\u7A2E\u816B\u8DA3\u9152\u9996\u5112\u53D7\u546A\u5BFF\u6388\u6A39\u7DAC\u9700\u56DA\u53CE\u5468\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[142].length; ++j)if (D[142][j].charCodeAt(0) !== 0xFFFD) {
        e[D[142][j]] = 36352 + j;
        d[36352 + j] = D[142][j];
    }
    D[143] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5B97\u5C31\u5DDE\u4FEE\u6101\u62FE\u6D32\u79C0\u79CB\u7D42\u7E4D\u7FD2\u81ED\u821F\u8490\u8846\u8972\u8B90\u8E74\u8F2F\u9031\u914B\u916C\u96C6\u919C\u4EC0\u4F4F\u5145\u5341\u5F93\u620E\u67D4\u6C41\u6E0B\u7363\u7E26\u91CD\u9283\u53D4\u5919\u5BBF\u6DD1\u795D\u7E2E\u7C9B\u587E\u719F\u51FA\u8853\u8FF0\u4FCA\u5CFB\u6625\u77AC\u7AE3\u821C\u99FF\u51C6\u5FAA\u65EC\u696F\u6B89\u6DF3\uFFFD\u6E96\u6F64\u76FE\u7D14\u5DE1\u9075\u9187\u9806\u51E6\u521D\u6240\u6691\u66D9\u6E1A\u5EB6\u7DD2\u7F72\u66F8\u85AF\u85F7\u8AF8\u52A9\u53D9\u5973\u5E8F\u5F90\u6055\u92E4\u9664\u50B7\u511F\u52DD\u5320\u5347\u53EC\u54E8\u5546\u5531\u5617\u5968\u59BE\u5A3C\u5BB5\u5C06\u5C0F\u5C11\u5C1A\u5E84\u5E8A\u5EE0\u5F70\u627F\u6284\u62DB\u638C\u6377\u6607\u660C\u662D\u6676\u677E\u68A2\u6A1F\u6A35\u6CBC\u6D88\u6E09\u6E58\u713C\u7126\u7167\u75C7\u7701\u785D\u7901\u7965\u79F0\u7AE0\u7B11\u7CA7\u7D39\u8096\u83D6\u848B\u8549\u885D\u88F3\u8A1F\u8A3C\u8A54\u8A73\u8C61\u8CDE\u91A4\u9266\u937E\u9418\u969C\u9798\u4E0A\u4E08\u4E1E\u4E57\u5197\u5270\u57CE\u5834\u58CC\u5B22\u5E38\u60C5\u64FE\u6761\u6756\u6D44\u72B6\u7573\u7A63\u84B8\u8B72\u91B8\u9320\u5631\u57F4\u98FE\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[143].length; ++j)if (D[143][j].charCodeAt(0) !== 0xFFFD) {
        e[D[143][j]] = 36608 + j;
        d[36608 + j] = D[143][j];
    }
    D[144] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u62ED\u690D\u6B96\u71ED\u7E54\u8077\u8272\u89E6\u98DF\u8755\u8FB1\u5C3B\u4F38\u4FE1\u4FB5\u5507\u5A20\u5BDD\u5BE9\u5FC3\u614E\u632F\u65B0\u664B\u68EE\u699B\u6D78\u6DF1\u7533\u75B9\u771F\u795E\u79E6\u7D33\u81E3\u82AF\u85AA\u89AA\u8A3A\u8EAB\u8F9B\u9032\u91DD\u9707\u4EBA\u4EC1\u5203\u5875\u58EC\u5C0B\u751A\u5C3D\u814E\u8A0A\u8FC5\u9663\u976D\u7B25\u8ACF\u9808\u9162\u56F3\u53A8\uFFFD\u9017\u5439\u5782\u5E25\u63A8\u6C34\u708A\u7761\u7C8B\u7FE0\u8870\u9042\u9154\u9310\u9318\u968F\u745E\u9AC4\u5D07\u5D69\u6570\u67A2\u8DA8\u96DB\u636E\u6749\u6919\u83C5\u9817\u96C0\u88FE\u6F84\u647A\u5BF8\u4E16\u702C\u755D\u662F\u51C4\u5236\u52E2\u59D3\u5F81\u6027\u6210\u653F\u6574\u661F\u6674\u68F2\u6816\u6B63\u6E05\u7272\u751F\u76DB\u7CBE\u8056\u58F0\u88FD\u897F\u8AA0\u8A93\u8ACB\u901D\u9192\u9752\u9759\u6589\u7A0E\u8106\u96BB\u5E2D\u60DC\u621A\u65A5\u6614\u6790\u77F3\u7A4D\u7C4D\u7E3E\u810A\u8CAC\u8D64\u8DE1\u8E5F\u78A9\u5207\u62D9\u63A5\u6442\u6298\u8A2D\u7A83\u7BC0\u8AAC\u96EA\u7D76\u820C\u8749\u4ED9\u5148\u5343\u5360\u5BA3\u5C02\u5C16\u5DDD\u6226\u6247\u64B0\u6813\u6834\u6CC9\u6D45\u6D17\u67D3\u6F5C\u714E\u717D\u65CB\u7A7F\u7BAD\u7DDA\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[144].length; ++j)if (D[144][j].charCodeAt(0) !== 0xFFFD) {
        e[D[144][j]] = 36864 + j;
        d[36864 + j] = D[144][j];
    }
    D[145] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7E4A\u7FA8\u817A\u821B\u8239\u85A6\u8A6E\u8CCE\u8DF5\u9078\u9077\u92AD\u9291\u9583\u9BAE\u524D\u5584\u6F38\u7136\u5168\u7985\u7E55\u81B3\u7CCE\u564C\u5851\u5CA8\u63AA\u66FE\u66FD\u695A\u72D9\u758F\u758E\u790E\u7956\u79DF\u7C97\u7D20\u7D44\u8607\u8A34\u963B\u9061\u9F20\u50E7\u5275\u53CC\u53E2\u5009\u55AA\u58EE\u594F\u723D\u5B8B\u5C64\u531D\u60E3\u60F3\u635C\u6383\u633F\u63BB\uFFFD\u64CD\u65E9\u66F9\u5DE3\u69CD\u69FD\u6F15\u71E5\u4E89\u75E9\u76F8\u7A93\u7CDF\u7DCF\u7D9C\u8061\u8349\u8358\u846C\u84BC\u85FB\u88C5\u8D70\u9001\u906D\u9397\u971C\u9A12\u50CF\u5897\u618E\u81D3\u8535\u8D08\u9020\u4FC3\u5074\u5247\u5373\u606F\u6349\u675F\u6E2C\u8DB3\u901F\u4FD7\u5C5E\u8CCA\u65CF\u7D9A\u5352\u8896\u5176\u63C3\u5B58\u5B6B\u5C0A\u640D\u6751\u905C\u4ED6\u591A\u592A\u6C70\u8A51\u553E\u5815\u59A5\u60F0\u6253\u67C1\u8235\u6955\u9640\u99C4\u9A28\u4F53\u5806\u5BFE\u8010\u5CB1\u5E2F\u5F85\u6020\u614B\u6234\u66FF\u6CF0\u6EDE\u80CE\u817F\u82D4\u888B\u8CB8\u9000\u902E\u968A\u9EDB\u9BDB\u4EE3\u53F0\u5927\u7B2C\u918D\u984C\u9DF9\u6EDD\u7027\u5353\u5544\u5B85\u6258\u629E\u62D3\u6CA2\u6FEF\u7422\u8A17\u9438\u6FC1\u8AFE\u8338\u51E7\u86F8\u53EA\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[145].length; ++j)if (D[145][j].charCodeAt(0) !== 0xFFFD) {
        e[D[145][j]] = 37120 + j;
        d[37120 + j] = D[145][j];
    }
    D[146] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u53E9\u4F46\u9054\u8FB0\u596A\u8131\u5DFD\u7AEA\u8FBF\u68DA\u8C37\u72F8\u9C48\u6A3D\u8AB0\u4E39\u5358\u5606\u5766\u62C5\u63A2\u65E6\u6B4E\u6DE1\u6E5B\u70AD\u77ED\u7AEF\u7BAA\u7DBB\u803D\u80C6\u86CB\u8A95\u935B\u56E3\u58C7\u5F3E\u65AD\u6696\u6A80\u6BB5\u7537\u8AC7\u5024\u77E5\u5730\u5F1B\u6065\u667A\u6C60\u75F4\u7A1A\u7F6E\u81F4\u8718\u9045\u99B3\u7BC9\u755C\u7AF9\u7B51\u84C4\uFFFD\u9010\u79E9\u7A92\u8336\u5AE1\u7740\u4E2D\u4EF2\u5B99\u5FE0\u62BD\u663C\u67F1\u6CE8\u866B\u8877\u8A3B\u914E\u92F3\u99D0\u6A17\u7026\u732A\u82E7\u8457\u8CAF\u4E01\u5146\u51CB\u558B\u5BF5\u5E16\u5E33\u5E81\u5F14\u5F35\u5F6B\u5FB4\u61F2\u6311\u66A2\u671D\u6F6E\u7252\u753A\u773A\u8074\u8139\u8178\u8776\u8ABF\u8ADC\u8D85\u8DF3\u929A\u9577\u9802\u9CE5\u52C5\u6357\u76F4\u6715\u6C88\u73CD\u8CC3\u93AE\u9673\u6D25\u589C\u690E\u69CC\u8FFD\u939A\u75DB\u901A\u585A\u6802\u63B4\u69FB\u4F43\u6F2C\u67D8\u8FBB\u8526\u7DB4\u9354\u693F\u6F70\u576A\u58F7\u5B2C\u7D2C\u722A\u540A\u91E3\u9DB4\u4EAD\u4F4E\u505C\u5075\u5243\u8C9E\u5448\u5824\u5B9A\u5E1D\u5E95\u5EAD\u5EF7\u5F1F\u608C\u62B5\u633A\u63D0\u68AF\u6C40\u7887\u798E\u7A0B\u7DE0\u8247\u8A02\u8AE6\u8E44\u9013\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[146].length; ++j)if (D[146][j].charCodeAt(0) !== 0xFFFD) {
        e[D[146][j]] = 37376 + j;
        d[37376 + j] = D[146][j];
    }
    D[147] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u90B8\u912D\u91D8\u9F0E\u6CE5\u6458\u64E2\u6575\u6EF4\u7684\u7B1B\u9069\u93D1\u6EBA\u54F2\u5FB9\u64A4\u8F4D\u8FED\u9244\u5178\u586B\u5929\u5C55\u5E97\u6DFB\u7E8F\u751C\u8CBC\u8EE2\u985B\u70B9\u4F1D\u6BBF\u6FB1\u7530\u96FB\u514E\u5410\u5835\u5857\u59AC\u5C60\u5F92\u6597\u675C\u6E21\u767B\u83DF\u8CED\u9014\u90FD\u934D\u7825\u783A\u52AA\u5EA6\u571F\u5974\u6012\u5012\u515A\u51AC\uFFFD\u51CD\u5200\u5510\u5854\u5858\u5957\u5B95\u5CF6\u5D8B\u60BC\u6295\u642D\u6771\u6843\u68BC\u68DF\u76D7\u6DD8\u6E6F\u6D9B\u706F\u71C8\u5F53\u75D8\u7977\u7B49\u7B54\u7B52\u7CD6\u7D71\u5230\u8463\u8569\u85E4\u8A0E\u8B04\u8C46\u8E0F\u9003\u900F\u9419\u9676\u982D\u9A30\u95D8\u50CD\u52D5\u540C\u5802\u5C0E\u61A7\u649E\u6D1E\u77B3\u7AE5\u80F4\u8404\u9053\u9285\u5CE0\u9D07\u533F\u5F97\u5FB3\u6D9C\u7279\u7763\u79BF\u7BE4\u6BD2\u72EC\u8AAD\u6803\u6A61\u51F8\u7A81\u6934\u5C4A\u9CF6\u82EB\u5BC5\u9149\u701E\u5678\u5C6F\u60C7\u6566\u6C8C\u8C5A\u9041\u9813\u5451\u66C7\u920D\u5948\u90A3\u5185\u4E4D\u51EA\u8599\u8B0E\u7058\u637A\u934B\u6962\u99B4\u7E04\u7577\u5357\u6960\u8EDF\u96E3\u6C5D\u4E8C\u5C3C\u5F10\u8FE9\u5302\u8CD1\u8089\u8679\u5EFF\u65E5\u4E73\u5165\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[147].length; ++j)if (D[147][j].charCodeAt(0) !== 0xFFFD) {
        e[D[147][j]] = 37632 + j;
        d[37632 + j] = D[147][j];
    }
    D[148] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5982\u5C3F\u97EE\u4EFB\u598A\u5FCD\u8A8D\u6FE1\u79B0\u7962\u5BE7\u8471\u732B\u71B1\u5E74\u5FF5\u637B\u649A\u71C3\u7C98\u4E43\u5EFC\u4E4B\u57DC\u56A2\u60A9\u6FC3\u7D0D\u80FD\u8133\u81BF\u8FB2\u8997\u86A4\u5DF4\u628A\u64AD\u8987\u6777\u6CE2\u6D3E\u7436\u7834\u5A46\u7F75\u82AD\u99AC\u4FF3\u5EC3\u62DD\u6392\u6557\u676F\u76C3\u724C\u80CC\u80BA\u8F29\u914D\u500D\u57F9\u5A92\u6885\uFFFD\u6973\u7164\u72FD\u8CB7\u58F2\u8CE0\u966A\u9019\u877F\u79E4\u77E7\u8429\u4F2F\u5265\u535A\u62CD\u67CF\u6CCA\u767D\u7B94\u7C95\u8236\u8584\u8FEB\u66DD\u6F20\u7206\u7E1B\u83AB\u99C1\u9EA6\u51FD\u7BB1\u7872\u7BB8\u8087\u7B48\u6AE8\u5E61\u808C\u7551\u7560\u516B\u9262\u6E8C\u767A\u9197\u9AEA\u4F10\u7F70\u629C\u7B4F\u95A5\u9CE9\u567A\u5859\u86E4\u96BC\u4F34\u5224\u534A\u53CD\u53DB\u5E06\u642C\u6591\u677F\u6C3E\u6C4E\u7248\u72AF\u73ED\u7554\u7E41\u822C\u85E9\u8CA9\u7BC4\u91C6\u7169\u9812\u98EF\u633D\u6669\u756A\u76E4\u78D0\u8543\u86EE\u532A\u5351\u5426\u5983\u5E87\u5F7C\u60B2\u6249\u6279\u62AB\u6590\u6BD4\u6CCC\u75B2\u76AE\u7891\u79D8\u7DCB\u7F77\u80A5\u88AB\u8AB9\u8CBB\u907F\u975E\u98DB\u6A0B\u7C38\u5099\u5C3E\u5FAE\u6787\u6BD8\u7435\u7709\u7F8E\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[148].length; ++j)if (D[148][j].charCodeAt(0) !== 0xFFFD) {
        e[D[148][j]] = 37888 + j;
        d[37888 + j] = D[148][j];
    }
    D[149] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9F3B\u67CA\u7A17\u5339\u758B\u9AED\u5F66\u819D\u83F1\u8098\u5F3C\u5FC5\u7562\u7B46\u903C\u6867\u59EB\u5A9B\u7D10\u767E\u8B2C\u4FF5\u5F6A\u6A19\u6C37\u6F02\u74E2\u7968\u8868\u8A55\u8C79\u5EDF\u63CF\u75C5\u79D2\u82D7\u9328\u92F2\u849C\u86ED\u9C2D\u54C1\u5F6C\u658C\u6D5C\u7015\u8CA7\u8CD3\u983B\u654F\u74F6\u4E0D\u4ED8\u57E0\u592B\u5A66\u5BCC\u51A8\u5E03\u5E9C\u6016\u6276\u6577\uFFFD\u65A7\u666E\u6D6E\u7236\u7B26\u8150\u819A\u8299\u8B5C\u8CA0\u8CE6\u8D74\u961C\u9644\u4FAE\u64AB\u6B66\u821E\u8461\u856A\u90E8\u5C01\u6953\u98A8\u847A\u8557\u4F0F\u526F\u5FA9\u5E45\u670D\u798F\u8179\u8907\u8986\u6DF5\u5F17\u6255\u6CB8\u4ECF\u7269\u9B92\u5206\u543B\u5674\u58B3\u61A4\u626E\u711A\u596E\u7C89\u7CDE\u7D1B\u96F0\u6587\u805E\u4E19\u4F75\u5175\u5840\u5E63\u5E73\u5F0A\u67C4\u4E26\u853D\u9589\u965B\u7C73\u9801\u50FB\u58C1\u7656\u78A7\u5225\u77A5\u8511\u7B86\u504F\u5909\u7247\u7BC7\u7DE8\u8FBA\u8FD4\u904D\u4FBF\u52C9\u5A29\u5F01\u97AD\u4FDD\u8217\u92EA\u5703\u6355\u6B69\u752B\u88DC\u8F14\u7A42\u52DF\u5893\u6155\u620A\u66AE\u6BCD\u7C3F\u83E9\u5023\u4FF8\u5305\u5446\u5831\u5949\u5B9D\u5CF0\u5CEF\u5D29\u5E96\u62B1\u6367\u653E\u65B9\u670B\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[149].length; ++j)if (D[149][j].charCodeAt(0) !== 0xFFFD) {
        e[D[149][j]] = 38144 + j;
        d[38144 + j] = D[149][j];
    }
    D[150] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6CD5\u6CE1\u70F9\u7832\u7E2B\u80DE\u82B3\u840C\u84EC\u8702\u8912\u8A2A\u8C4A\u90A6\u92D2\u98FD\u9CF3\u9D6C\u4E4F\u4EA1\u508D\u5256\u574A\u59A8\u5E3D\u5FD8\u5FD9\u623F\u66B4\u671B\u67D0\u68D2\u5192\u7D21\u80AA\u81A8\u8B00\u8C8C\u8CBF\u927E\u9632\u5420\u982C\u5317\u50D5\u535C\u58A8\u64B2\u6734\u7267\u7766\u7A46\u91E6\u52C3\u6CA1\u6B86\u5800\u5E4C\u5954\u672C\u7FFB\u51E1\u76C6\uFFFD\u6469\u78E8\u9B54\u9EBB\u57CB\u59B9\u6627\u679A\u6BCE\u54E9\u69D9\u5E55\u819C\u6795\u9BAA\u67FE\u9C52\u685D\u4EA6\u4FE3\u53C8\u62B9\u672B\u6CAB\u8FC4\u4FAD\u7E6D\u9EBF\u4E07\u6162\u6E80\u6F2B\u8513\u5473\u672A\u9B45\u5DF3\u7B95\u5CAC\u5BC6\u871C\u6E4A\u84D1\u7A14\u8108\u5999\u7C8D\u6C11\u7720\u52D9\u5922\u7121\u725F\u77DB\u9727\u9D61\u690B\u5A7F\u5A18\u51A5\u540D\u547D\u660E\u76DF\u8FF7\u9298\u9CF4\u59EA\u725D\u6EC5\u514D\u68C9\u7DBF\u7DEC\u9762\u9EBA\u6478\u6A21\u8302\u5984\u5B5F\u6BDB\u731B\u76F2\u7DB2\u8017\u8499\u5132\u6728\u9ED9\u76EE\u6762\u52FF\u9905\u5C24\u623B\u7C7E\u8CB0\u554F\u60B6\u7D0B\u9580\u5301\u4E5F\u51B6\u591C\u723A\u8036\u91CE\u5F25\u77E2\u5384\u5F79\u7D04\u85AC\u8A33\u8E8D\u9756\u67F3\u85AE\u9453\u6109\u6108\u6CB9\u7652\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[150].length; ++j)if (D[150][j].charCodeAt(0) !== 0xFFFD) {
        e[D[150][j]] = 38400 + j;
        d[38400 + j] = D[150][j];
    }
    D[151] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8AED\u8F38\u552F\u4F51\u512A\u52C7\u53CB\u5BA5\u5E7D\u60A0\u6182\u63D6\u6709\u67DA\u6E67\u6D8C\u7336\u7337\u7531\u7950\u88D5\u8A98\u904A\u9091\u90F5\u96C4\u878D\u5915\u4E88\u4F59\u4E0E\u8A89\u8F3F\u9810\u50AD\u5E7C\u5996\u5BB9\u5EB8\u63DA\u63FA\u64C1\u66DC\u694A\u69D8\u6D0B\u6EB6\u7194\u7528\u7AAF\u7F8A\u8000\u8449\u84C9\u8981\u8B21\u8E0A\u9065\u967D\u990A\u617E\u6291\u6B32\uFFFD\u6C83\u6D74\u7FCC\u7FFC\u6DC0\u7F85\u87BA\u88F8\u6765\u83B1\u983C\u96F7\u6D1B\u7D61\u843D\u916A\u4E71\u5375\u5D50\u6B04\u6FEB\u85CD\u862D\u89A7\u5229\u540F\u5C65\u674E\u68A8\u7406\u7483\u75E2\u88CF\u88E1\u91CC\u96E2\u9678\u5F8B\u7387\u7ACB\u844E\u63A0\u7565\u5289\u6D41\u6E9C\u7409\u7559\u786B\u7C92\u9686\u7ADC\u9F8D\u4FB6\u616E\u65C5\u865C\u4E86\u4EAE\u50DA\u4E21\u51CC\u5BEE\u6599\u6881\u6DBC\u731F\u7642\u77AD\u7A1C\u7CE7\u826F\u8AD2\u907C\u91CF\u9675\u9818\u529B\u7DD1\u502B\u5398\u6797\u6DCB\u71D0\u7433\u81E8\u8F2A\u96A3\u9C57\u9E9F\u7460\u5841\u6D99\u7D2F\u985E\u4EE4\u4F36\u4F8B\u51B7\u52B1\u5DBA\u601C\u73B2\u793C\u82D3\u9234\u96B7\u96F6\u970A\u9E97\u9F62\u66A6\u6B74\u5217\u52A3\u70C8\u88C2\u5EC9\u604B\u6190\u6F23\u7149\u7C3E\u7DF4\u806F\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[151].length; ++j)if (D[151][j].charCodeAt(0) !== 0xFFFD) {
        e[D[151][j]] = 38656 + j;
        d[38656 + j] = D[151][j];
    }
    D[152] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u84EE\u9023\u932C\u5442\u9B6F\u6AD3\u7089\u8CC2\u8DEF\u9732\u52B4\u5A41\u5ECA\u5F04\u6717\u697C\u6994\u6D6A\u6F0F\u7262\u72FC\u7BED\u8001\u807E\u874B\u90CE\u516D\u9E93\u7984\u808B\u9332\u8AD6\u502D\u548C\u8A71\u6B6A\u8CC4\u8107\u60D1\u67A0\u9DF2\u4E99\u4E98\u9C10\u8A6B\u85C1\u8568\u6900\u6E7E\u7897\u8155\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5F0C\u4E10\u4E15\u4E2A\u4E31\u4E36\u4E3C\u4E3F\u4E42\u4E56\u4E58\u4E82\u4E85\u8C6B\u4E8A\u8212\u5F0D\u4E8E\u4E9E\u4E9F\u4EA0\u4EA2\u4EB0\u4EB3\u4EB6\u4ECE\u4ECD\u4EC4\u4EC6\u4EC2\u4ED7\u4EDE\u4EED\u4EDF\u4EF7\u4F09\u4F5A\u4F30\u4F5B\u4F5D\u4F57\u4F47\u4F76\u4F88\u4F8F\u4F98\u4F7B\u4F69\u4F70\u4F91\u4F6F\u4F86\u4F96\u5118\u4FD4\u4FDF\u4FCE\u4FD8\u4FDB\u4FD1\u4FDA\u4FD0\u4FE4\u4FE5\u501A\u5028\u5014\u502A\u5025\u5005\u4F1C\u4FF6\u5021\u5029\u502C\u4FFE\u4FEF\u5011\u5006\u5043\u5047\u6703\u5055\u5050\u5048\u505A\u5056\u506C\u5078\u5080\u509A\u5085\u50B4\u50B2\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[152].length; ++j)if (D[152][j].charCodeAt(0) !== 0xFFFD) {
        e[D[152][j]] = 38912 + j;
        d[38912 + j] = D[152][j];
    }
    D[153] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u50C9\u50CA\u50B3\u50C2\u50D6\u50DE\u50E5\u50ED\u50E3\u50EE\u50F9\u50F5\u5109\u5101\u5102\u5116\u5115\u5114\u511A\u5121\u513A\u5137\u513C\u513B\u513F\u5140\u5152\u514C\u5154\u5162\u7AF8\u5169\u516A\u516E\u5180\u5182\u56D8\u518C\u5189\u518F\u5191\u5193\u5195\u5196\u51A4\u51A6\u51A2\u51A9\u51AA\u51AB\u51B3\u51B1\u51B2\u51B0\u51B5\u51BD\u51C5\u51C9\u51DB\u51E0\u8655\u51E9\u51ED\uFFFD\u51F0\u51F5\u51FE\u5204\u520B\u5214\u520E\u5227\u522A\u522E\u5233\u5239\u524F\u5244\u524B\u524C\u525E\u5254\u526A\u5274\u5269\u5273\u527F\u527D\u528D\u5294\u5292\u5271\u5288\u5291\u8FA8\u8FA7\u52AC\u52AD\u52BC\u52B5\u52C1\u52CD\u52D7\u52DE\u52E3\u52E6\u98ED\u52E0\u52F3\u52F5\u52F8\u52F9\u5306\u5308\u7538\u530D\u5310\u530F\u5315\u531A\u5323\u532F\u5331\u5333\u5338\u5340\u5346\u5345\u4E17\u5349\u534D\u51D6\u535E\u5369\u536E\u5918\u537B\u5377\u5382\u5396\u53A0\u53A6\u53A5\u53AE\u53B0\u53B6\u53C3\u7C12\u96D9\u53DF\u66FC\u71EE\u53EE\u53E8\u53ED\u53FA\u5401\u543D\u5440\u542C\u542D\u543C\u542E\u5436\u5429\u541D\u544E\u548F\u5475\u548E\u545F\u5471\u5477\u5470\u5492\u547B\u5480\u5476\u5484\u5490\u5486\u54C7\u54A2\u54B8\u54A5\u54AC\u54C4\u54C8\u54A8\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[153].length; ++j)if (D[153][j].charCodeAt(0) !== 0xFFFD) {
        e[D[153][j]] = 39168 + j;
        d[39168 + j] = D[153][j];
    }
    D[154] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u54AB\u54C2\u54A4\u54BE\u54BC\u54D8\u54E5\u54E6\u550F\u5514\u54FD\u54EE\u54ED\u54FA\u54E2\u5539\u5540\u5563\u554C\u552E\u555C\u5545\u5556\u5557\u5538\u5533\u555D\u5599\u5580\u54AF\u558A\u559F\u557B\u557E\u5598\u559E\u55AE\u557C\u5583\u55A9\u5587\u55A8\u55DA\u55C5\u55DF\u55C4\u55DC\u55E4\u55D4\u5614\u55F7\u5616\u55FE\u55FD\u561B\u55F9\u564E\u5650\u71DF\u5634\u5636\u5632\u5638\uFFFD\u566B\u5664\u562F\u566C\u566A\u5686\u5680\u568A\u56A0\u5694\u568F\u56A5\u56AE\u56B6\u56B4\u56C2\u56BC\u56C1\u56C3\u56C0\u56C8\u56CE\u56D1\u56D3\u56D7\u56EE\u56F9\u5700\u56FF\u5704\u5709\u5708\u570B\u570D\u5713\u5718\u5716\u55C7\u571C\u5726\u5737\u5738\u574E\u573B\u5740\u574F\u5769\u57C0\u5788\u5761\u577F\u5789\u5793\u57A0\u57B3\u57A4\u57AA\u57B0\u57C3\u57C6\u57D4\u57D2\u57D3\u580A\u57D6\u57E3\u580B\u5819\u581D\u5872\u5821\u5862\u584B\u5870\u6BC0\u5852\u583D\u5879\u5885\u58B9\u589F\u58AB\u58BA\u58DE\u58BB\u58B8\u58AE\u58C5\u58D3\u58D1\u58D7\u58D9\u58D8\u58E5\u58DC\u58E4\u58DF\u58EF\u58FA\u58F9\u58FB\u58FC\u58FD\u5902\u590A\u5910\u591B\u68A6\u5925\u592C\u592D\u5932\u5938\u593E\u7AD2\u5955\u5950\u594E\u595A\u5958\u5962\u5960\u5967\u596C\u5969\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[154].length; ++j)if (D[154][j].charCodeAt(0) !== 0xFFFD) {
        e[D[154][j]] = 39424 + j;
        d[39424 + j] = D[154][j];
    }
    D[155] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5978\u5981\u599D\u4F5E\u4FAB\u59A3\u59B2\u59C6\u59E8\u59DC\u598D\u59D9\u59DA\u5A25\u5A1F\u5A11\u5A1C\u5A09\u5A1A\u5A40\u5A6C\u5A49\u5A35\u5A36\u5A62\u5A6A\u5A9A\u5ABC\u5ABE\u5ACB\u5AC2\u5ABD\u5AE3\u5AD7\u5AE6\u5AE9\u5AD6\u5AFA\u5AFB\u5B0C\u5B0B\u5B16\u5B32\u5AD0\u5B2A\u5B36\u5B3E\u5B43\u5B45\u5B40\u5B51\u5B55\u5B5A\u5B5B\u5B65\u5B69\u5B70\u5B73\u5B75\u5B78\u6588\u5B7A\u5B80\uFFFD\u5B83\u5BA6\u5BB8\u5BC3\u5BC7\u5BC9\u5BD4\u5BD0\u5BE4\u5BE6\u5BE2\u5BDE\u5BE5\u5BEB\u5BF0\u5BF6\u5BF3\u5C05\u5C07\u5C08\u5C0D\u5C13\u5C20\u5C22\u5C28\u5C38\u5C39\u5C41\u5C46\u5C4E\u5C53\u5C50\u5C4F\u5B71\u5C6C\u5C6E\u4E62\u5C76\u5C79\u5C8C\u5C91\u5C94\u599B\u5CAB\u5CBB\u5CB6\u5CBC\u5CB7\u5CC5\u5CBE\u5CC7\u5CD9\u5CE9\u5CFD\u5CFA\u5CED\u5D8C\u5CEA\u5D0B\u5D15\u5D17\u5D5C\u5D1F\u5D1B\u5D11\u5D14\u5D22\u5D1A\u5D19\u5D18\u5D4C\u5D52\u5D4E\u5D4B\u5D6C\u5D73\u5D76\u5D87\u5D84\u5D82\u5DA2\u5D9D\u5DAC\u5DAE\u5DBD\u5D90\u5DB7\u5DBC\u5DC9\u5DCD\u5DD3\u5DD2\u5DD6\u5DDB\u5DEB\u5DF2\u5DF5\u5E0B\u5E1A\u5E19\u5E11\u5E1B\u5E36\u5E37\u5E44\u5E43\u5E40\u5E4E\u5E57\u5E54\u5E5F\u5E62\u5E64\u5E47\u5E75\u5E76\u5E7A\u9EBC\u5E7F\u5EA0\u5EC1\u5EC2\u5EC8\u5ED0\u5ECF\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[155].length; ++j)if (D[155][j].charCodeAt(0) !== 0xFFFD) {
        e[D[155][j]] = 39680 + j;
        d[39680 + j] = D[155][j];
    }
    D[156] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5ED6\u5EE3\u5EDD\u5EDA\u5EDB\u5EE2\u5EE1\u5EE8\u5EE9\u5EEC\u5EF1\u5EF3\u5EF0\u5EF4\u5EF8\u5EFE\u5F03\u5F09\u5F5D\u5F5C\u5F0B\u5F11\u5F16\u5F29\u5F2D\u5F38\u5F41\u5F48\u5F4C\u5F4E\u5F2F\u5F51\u5F56\u5F57\u5F59\u5F61\u5F6D\u5F73\u5F77\u5F83\u5F82\u5F7F\u5F8A\u5F88\u5F91\u5F87\u5F9E\u5F99\u5F98\u5FA0\u5FA8\u5FAD\u5FBC\u5FD6\u5FFB\u5FE4\u5FF8\u5FF1\u5FDD\u60B3\u5FFF\u6021\u6060\uFFFD\u6019\u6010\u6029\u600E\u6031\u601B\u6015\u602B\u6026\u600F\u603A\u605A\u6041\u606A\u6077\u605F\u604A\u6046\u604D\u6063\u6043\u6064\u6042\u606C\u606B\u6059\u6081\u608D\u60E7\u6083\u609A\u6084\u609B\u6096\u6097\u6092\u60A7\u608B\u60E1\u60B8\u60E0\u60D3\u60B4\u5FF0\u60BD\u60C6\u60B5\u60D8\u614D\u6115\u6106\u60F6\u60F7\u6100\u60F4\u60FA\u6103\u6121\u60FB\u60F1\u610D\u610E\u6147\u613E\u6128\u6127\u614A\u613F\u613C\u612C\u6134\u613D\u6142\u6144\u6173\u6177\u6158\u6159\u615A\u616B\u6174\u616F\u6165\u6171\u615F\u615D\u6153\u6175\u6199\u6196\u6187\u61AC\u6194\u619A\u618A\u6191\u61AB\u61AE\u61CC\u61CA\u61C9\u61F7\u61C8\u61C3\u61C6\u61BA\u61CB\u7F79\u61CD\u61E6\u61E3\u61F6\u61FA\u61F4\u61FF\u61FD\u61FC\u61FE\u6200\u6208\u6209\u620D\u620C\u6214\u621B\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[156].length; ++j)if (D[156][j].charCodeAt(0) !== 0xFFFD) {
        e[D[156][j]] = 39936 + j;
        d[39936 + j] = D[156][j];
    }
    D[157] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u621E\u6221\u622A\u622E\u6230\u6232\u6233\u6241\u624E\u625E\u6263\u625B\u6260\u6268\u627C\u6282\u6289\u627E\u6292\u6293\u6296\u62D4\u6283\u6294\u62D7\u62D1\u62BB\u62CF\u62FF\u62C6\u64D4\u62C8\u62DC\u62CC\u62CA\u62C2\u62C7\u629B\u62C9\u630C\u62EE\u62F1\u6327\u6302\u6308\u62EF\u62F5\u6350\u633E\u634D\u641C\u634F\u6396\u638E\u6380\u63AB\u6376\u63A3\u638F\u6389\u639F\u63B5\u636B\uFFFD\u6369\u63BE\u63E9\u63C0\u63C6\u63E3\u63C9\u63D2\u63F6\u63C4\u6416\u6434\u6406\u6413\u6426\u6436\u651D\u6417\u6428\u640F\u6467\u646F\u6476\u644E\u652A\u6495\u6493\u64A5\u64A9\u6488\u64BC\u64DA\u64D2\u64C5\u64C7\u64BB\u64D8\u64C2\u64F1\u64E7\u8209\u64E0\u64E1\u62AC\u64E3\u64EF\u652C\u64F6\u64F4\u64F2\u64FA\u6500\u64FD\u6518\u651C\u6505\u6524\u6523\u652B\u6534\u6535\u6537\u6536\u6538\u754B\u6548\u6556\u6555\u654D\u6558\u655E\u655D\u6572\u6578\u6582\u6583\u8B8A\u659B\u659F\u65AB\u65B7\u65C3\u65C6\u65C1\u65C4\u65CC\u65D2\u65DB\u65D9\u65E0\u65E1\u65F1\u6772\u660A\u6603\u65FB\u6773\u6635\u6636\u6634\u661C\u664F\u6644\u6649\u6641\u665E\u665D\u6664\u6667\u6668\u665F\u6662\u6670\u6683\u6688\u668E\u6689\u6684\u6698\u669D\u66C1\u66B9\u66C9\u66BE\u66BC\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[157].length; ++j)if (D[157][j].charCodeAt(0) !== 0xFFFD) {
        e[D[157][j]] = 40192 + j;
        d[40192 + j] = D[157][j];
    }
    D[158] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u66C4\u66B8\u66D6\u66DA\u66E0\u663F\u66E6\u66E9\u66F0\u66F5\u66F7\u670F\u6716\u671E\u6726\u6727\u9738\u672E\u673F\u6736\u6741\u6738\u6737\u6746\u675E\u6760\u6759\u6763\u6764\u6789\u6770\u67A9\u677C\u676A\u678C\u678B\u67A6\u67A1\u6785\u67B7\u67EF\u67B4\u67EC\u67B3\u67E9\u67B8\u67E4\u67DE\u67DD\u67E2\u67EE\u67B9\u67CE\u67C6\u67E7\u6A9C\u681E\u6846\u6829\u6840\u684D\u6832\u684E\uFFFD\u68B3\u682B\u6859\u6863\u6877\u687F\u689F\u688F\u68AD\u6894\u689D\u689B\u6883\u6AAE\u68B9\u6874\u68B5\u68A0\u68BA\u690F\u688D\u687E\u6901\u68CA\u6908\u68D8\u6922\u6926\u68E1\u690C\u68CD\u68D4\u68E7\u68D5\u6936\u6912\u6904\u68D7\u68E3\u6925\u68F9\u68E0\u68EF\u6928\u692A\u691A\u6923\u6921\u68C6\u6979\u6977\u695C\u6978\u696B\u6954\u697E\u696E\u6939\u6974\u693D\u6959\u6930\u6961\u695E\u695D\u6981\u696A\u69B2\u69AE\u69D0\u69BF\u69C1\u69D3\u69BE\u69CE\u5BE8\u69CA\u69DD\u69BB\u69C3\u69A7\u6A2E\u6991\u69A0\u699C\u6995\u69B4\u69DE\u69E8\u6A02\u6A1B\u69FF\u6B0A\u69F9\u69F2\u69E7\u6A05\u69B1\u6A1E\u69ED\u6A14\u69EB\u6A0A\u6A12\u6AC1\u6A23\u6A13\u6A44\u6A0C\u6A72\u6A36\u6A78\u6A47\u6A62\u6A59\u6A66\u6A48\u6A38\u6A22\u6A90\u6A8D\u6AA0\u6A84\u6AA2\u6AA3\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[158].length; ++j)if (D[158][j].charCodeAt(0) !== 0xFFFD) {
        e[D[158][j]] = 40448 + j;
        d[40448 + j] = D[158][j];
    }
    D[159] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6A97\u8617\u6ABB\u6AC3\u6AC2\u6AB8\u6AB3\u6AAC\u6ADE\u6AD1\u6ADF\u6AAA\u6ADA\u6AEA\u6AFB\u6B05\u8616\u6AFA\u6B12\u6B16\u9B31\u6B1F\u6B38\u6B37\u76DC\u6B39\u98EE\u6B47\u6B43\u6B49\u6B50\u6B59\u6B54\u6B5B\u6B5F\u6B61\u6B78\u6B79\u6B7F\u6B80\u6B84\u6B83\u6B8D\u6B98\u6B95\u6B9E\u6BA4\u6BAA\u6BAB\u6BAF\u6BB2\u6BB1\u6BB3\u6BB7\u6BBC\u6BC6\u6BCB\u6BD3\u6BDF\u6BEC\u6BEB\u6BF3\u6BEF\uFFFD\u9EBE\u6C08\u6C13\u6C14\u6C1B\u6C24\u6C23\u6C5E\u6C55\u6C62\u6C6A\u6C82\u6C8D\u6C9A\u6C81\u6C9B\u6C7E\u6C68\u6C73\u6C92\u6C90\u6CC4\u6CF1\u6CD3\u6CBD\u6CD7\u6CC5\u6CDD\u6CAE\u6CB1\u6CBE\u6CBA\u6CDB\u6CEF\u6CD9\u6CEA\u6D1F\u884D\u6D36\u6D2B\u6D3D\u6D38\u6D19\u6D35\u6D33\u6D12\u6D0C\u6D63\u6D93\u6D64\u6D5A\u6D79\u6D59\u6D8E\u6D95\u6FE4\u6D85\u6DF9\u6E15\u6E0A\u6DB5\u6DC7\u6DE6\u6DB8\u6DC6\u6DEC\u6DDE\u6DCC\u6DE8\u6DD2\u6DC5\u6DFA\u6DD9\u6DE4\u6DD5\u6DEA\u6DEE\u6E2D\u6E6E\u6E2E\u6E19\u6E72\u6E5F\u6E3E\u6E23\u6E6B\u6E2B\u6E76\u6E4D\u6E1F\u6E43\u6E3A\u6E4E\u6E24\u6EFF\u6E1D\u6E38\u6E82\u6EAA\u6E98\u6EC9\u6EB7\u6ED3\u6EBD\u6EAF\u6EC4\u6EB2\u6ED4\u6ED5\u6E8F\u6EA5\u6EC2\u6E9F\u6F41\u6F11\u704C\u6EEC\u6EF8\u6EFE\u6F3F\u6EF2\u6F31\u6EEF\u6F32\u6ECC\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[159].length; ++j)if (D[159][j].charCodeAt(0) !== 0xFFFD) {
        e[D[159][j]] = 40704 + j;
        d[40704 + j] = D[159][j];
    }
    D[224] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6F3E\u6F13\u6EF7\u6F86\u6F7A\u6F78\u6F81\u6F80\u6F6F\u6F5B\u6FF3\u6F6D\u6F82\u6F7C\u6F58\u6F8E\u6F91\u6FC2\u6F66\u6FB3\u6FA3\u6FA1\u6FA4\u6FB9\u6FC6\u6FAA\u6FDF\u6FD5\u6FEC\u6FD4\u6FD8\u6FF1\u6FEE\u6FDB\u7009\u700B\u6FFA\u7011\u7001\u700F\u6FFE\u701B\u701A\u6F74\u701D\u7018\u701F\u7030\u703E\u7032\u7051\u7063\u7099\u7092\u70AF\u70F1\u70AC\u70B8\u70B3\u70AE\u70DF\u70CB\u70DD\uFFFD\u70D9\u7109\u70FD\u711C\u7119\u7165\u7155\u7188\u7166\u7162\u714C\u7156\u716C\u718F\u71FB\u7184\u7195\u71A8\u71AC\u71D7\u71B9\u71BE\u71D2\u71C9\u71D4\u71CE\u71E0\u71EC\u71E7\u71F5\u71FC\u71F9\u71FF\u720D\u7210\u721B\u7228\u722D\u722C\u7230\u7232\u723B\u723C\u723F\u7240\u7246\u724B\u7258\u7274\u727E\u7282\u7281\u7287\u7292\u7296\u72A2\u72A7\u72B9\u72B2\u72C3\u72C6\u72C4\u72CE\u72D2\u72E2\u72E0\u72E1\u72F9\u72F7\u500F\u7317\u730A\u731C\u7316\u731D\u7334\u732F\u7329\u7325\u733E\u734E\u734F\u9ED8\u7357\u736A\u7368\u7370\u7378\u7375\u737B\u737A\u73C8\u73B3\u73CE\u73BB\u73C0\u73E5\u73EE\u73DE\u74A2\u7405\u746F\u7425\u73F8\u7432\u743A\u7455\u743F\u745F\u7459\u7441\u745C\u7469\u7470\u7463\u746A\u7476\u747E\u748B\u749E\u74A7\u74CA\u74CF\u74D4\u73F1\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[224].length; ++j)if (D[224][j].charCodeAt(0) !== 0xFFFD) {
        e[D[224][j]] = 57344 + j;
        d[57344 + j] = D[224][j];
    }
    D[225] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u74E0\u74E3\u74E7\u74E9\u74EE\u74F2\u74F0\u74F1\u74F8\u74F7\u7504\u7503\u7505\u750C\u750E\u750D\u7515\u7513\u751E\u7526\u752C\u753C\u7544\u754D\u754A\u7549\u755B\u7546\u755A\u7569\u7564\u7567\u756B\u756D\u7578\u7576\u7586\u7587\u7574\u758A\u7589\u7582\u7594\u759A\u759D\u75A5\u75A3\u75C2\u75B3\u75C3\u75B5\u75BD\u75B8\u75BC\u75B1\u75CD\u75CA\u75D2\u75D9\u75E3\u75DE\u75FE\u75FF\uFFFD\u75FC\u7601\u75F0\u75FA\u75F2\u75F3\u760B\u760D\u7609\u761F\u7627\u7620\u7621\u7622\u7624\u7634\u7630\u763B\u7647\u7648\u7646\u765C\u7658\u7661\u7662\u7668\u7669\u766A\u7667\u766C\u7670\u7672\u7676\u7678\u767C\u7680\u7683\u7688\u768B\u768E\u7696\u7693\u7699\u769A\u76B0\u76B4\u76B8\u76B9\u76BA\u76C2\u76CD\u76D6\u76D2\u76DE\u76E1\u76E5\u76E7\u76EA\u862F\u76FB\u7708\u7707\u7704\u7729\u7724\u771E\u7725\u7726\u771B\u7737\u7738\u7747\u775A\u7768\u776B\u775B\u7765\u777F\u777E\u7779\u778E\u778B\u7791\u77A0\u779E\u77B0\u77B6\u77B9\u77BF\u77BC\u77BD\u77BB\u77C7\u77CD\u77D7\u77DA\u77DC\u77E3\u77EE\u77FC\u780C\u7812\u7926\u7820\u792A\u7845\u788E\u7874\u7886\u787C\u789A\u788C\u78A3\u78B5\u78AA\u78AF\u78D1\u78C6\u78CB\u78D4\u78BE\u78BC\u78C5\u78CA\u78EC\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[225].length; ++j)if (D[225][j].charCodeAt(0) !== 0xFFFD) {
        e[D[225][j]] = 57600 + j;
        d[57600 + j] = D[225][j];
    }
    D[226] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u78E7\u78DA\u78FD\u78F4\u7907\u7912\u7911\u7919\u792C\u792B\u7940\u7960\u7957\u795F\u795A\u7955\u7953\u797A\u797F\u798A\u799D\u79A7\u9F4B\u79AA\u79AE\u79B3\u79B9\u79BA\u79C9\u79D5\u79E7\u79EC\u79E1\u79E3\u7A08\u7A0D\u7A18\u7A19\u7A20\u7A1F\u7980\u7A31\u7A3B\u7A3E\u7A37\u7A43\u7A57\u7A49\u7A61\u7A62\u7A69\u9F9D\u7A70\u7A79\u7A7D\u7A88\u7A97\u7A95\u7A98\u7A96\u7AA9\u7AC8\u7AB0\uFFFD\u7AB6\u7AC5\u7AC4\u7ABF\u9083\u7AC7\u7ACA\u7ACD\u7ACF\u7AD5\u7AD3\u7AD9\u7ADA\u7ADD\u7AE1\u7AE2\u7AE6\u7AED\u7AF0\u7B02\u7B0F\u7B0A\u7B06\u7B33\u7B18\u7B19\u7B1E\u7B35\u7B28\u7B36\u7B50\u7B7A\u7B04\u7B4D\u7B0B\u7B4C\u7B45\u7B75\u7B65\u7B74\u7B67\u7B70\u7B71\u7B6C\u7B6E\u7B9D\u7B98\u7B9F\u7B8D\u7B9C\u7B9A\u7B8B\u7B92\u7B8F\u7B5D\u7B99\u7BCB\u7BC1\u7BCC\u7BCF\u7BB4\u7BC6\u7BDD\u7BE9\u7C11\u7C14\u7BE6\u7BE5\u7C60\u7C00\u7C07\u7C13\u7BF3\u7BF7\u7C17\u7C0D\u7BF6\u7C23\u7C27\u7C2A\u7C1F\u7C37\u7C2B\u7C3D\u7C4C\u7C43\u7C54\u7C4F\u7C40\u7C50\u7C58\u7C5F\u7C64\u7C56\u7C65\u7C6C\u7C75\u7C83\u7C90\u7CA4\u7CAD\u7CA2\u7CAB\u7CA1\u7CA8\u7CB3\u7CB2\u7CB1\u7CAE\u7CB9\u7CBD\u7CC0\u7CC5\u7CC2\u7CD8\u7CD2\u7CDC\u7CE2\u9B3B\u7CEF\u7CF2\u7CF4\u7CF6\u7CFA\u7D06\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[226].length; ++j)if (D[226][j].charCodeAt(0) !== 0xFFFD) {
        e[D[226][j]] = 57856 + j;
        d[57856 + j] = D[226][j];
    }
    D[227] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7D02\u7D1C\u7D15\u7D0A\u7D45\u7D4B\u7D2E\u7D32\u7D3F\u7D35\u7D46\u7D73\u7D56\u7D4E\u7D72\u7D68\u7D6E\u7D4F\u7D63\u7D93\u7D89\u7D5B\u7D8F\u7D7D\u7D9B\u7DBA\u7DAE\u7DA3\u7DB5\u7DC7\u7DBD\u7DAB\u7E3D\u7DA2\u7DAF\u7DDC\u7DB8\u7D9F\u7DB0\u7DD8\u7DDD\u7DE4\u7DDE\u7DFB\u7DF2\u7DE1\u7E05\u7E0A\u7E23\u7E21\u7E12\u7E31\u7E1F\u7E09\u7E0B\u7E22\u7E46\u7E66\u7E3B\u7E35\u7E39\u7E43\u7E37\uFFFD\u7E32\u7E3A\u7E67\u7E5D\u7E56\u7E5E\u7E59\u7E5A\u7E79\u7E6A\u7E69\u7E7C\u7E7B\u7E83\u7DD5\u7E7D\u8FAE\u7E7F\u7E88\u7E89\u7E8C\u7E92\u7E90\u7E93\u7E94\u7E96\u7E8E\u7E9B\u7E9C\u7F38\u7F3A\u7F45\u7F4C\u7F4D\u7F4E\u7F50\u7F51\u7F55\u7F54\u7F58\u7F5F\u7F60\u7F68\u7F69\u7F67\u7F78\u7F82\u7F86\u7F83\u7F88\u7F87\u7F8C\u7F94\u7F9E\u7F9D\u7F9A\u7FA3\u7FAF\u7FB2\u7FB9\u7FAE\u7FB6\u7FB8\u8B71\u7FC5\u7FC6\u7FCA\u7FD5\u7FD4\u7FE1\u7FE6\u7FE9\u7FF3\u7FF9\u98DC\u8006\u8004\u800B\u8012\u8018\u8019\u801C\u8021\u8028\u803F\u803B\u804A\u8046\u8052\u8058\u805A\u805F\u8062\u8068\u8073\u8072\u8070\u8076\u8079\u807D\u807F\u8084\u8086\u8085\u809B\u8093\u809A\u80AD\u5190\u80AC\u80DB\u80E5\u80D9\u80DD\u80C4\u80DA\u80D6\u8109\u80EF\u80F1\u811B\u8129\u8123\u812F\u814B\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[227].length; ++j)if (D[227][j].charCodeAt(0) !== 0xFFFD) {
        e[D[227][j]] = 58112 + j;
        d[58112 + j] = D[227][j];
    }
    D[228] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u968B\u8146\u813E\u8153\u8151\u80FC\u8171\u816E\u8165\u8166\u8174\u8183\u8188\u818A\u8180\u8182\u81A0\u8195\u81A4\u81A3\u815F\u8193\u81A9\u81B0\u81B5\u81BE\u81B8\u81BD\u81C0\u81C2\u81BA\u81C9\u81CD\u81D1\u81D9\u81D8\u81C8\u81DA\u81DF\u81E0\u81E7\u81FA\u81FB\u81FE\u8201\u8202\u8205\u8207\u820A\u820D\u8210\u8216\u8229\u822B\u8238\u8233\u8240\u8259\u8258\u825D\u825A\u825F\u8264\uFFFD\u8262\u8268\u826A\u826B\u822E\u8271\u8277\u8278\u827E\u828D\u8292\u82AB\u829F\u82BB\u82AC\u82E1\u82E3\u82DF\u82D2\u82F4\u82F3\u82FA\u8393\u8303\u82FB\u82F9\u82DE\u8306\u82DC\u8309\u82D9\u8335\u8334\u8316\u8332\u8331\u8340\u8339\u8350\u8345\u832F\u832B\u8317\u8318\u8385\u839A\u83AA\u839F\u83A2\u8396\u8323\u838E\u8387\u838A\u837C\u83B5\u8373\u8375\u83A0\u8389\u83A8\u83F4\u8413\u83EB\u83CE\u83FD\u8403\u83D8\u840B\u83C1\u83F7\u8407\u83E0\u83F2\u840D\u8422\u8420\u83BD\u8438\u8506\u83FB\u846D\u842A\u843C\u855A\u8484\u8477\u846B\u84AD\u846E\u8482\u8469\u8446\u842C\u846F\u8479\u8435\u84CA\u8462\u84B9\u84BF\u849F\u84D9\u84CD\u84BB\u84DA\u84D0\u84C1\u84C6\u84D6\u84A1\u8521\u84FF\u84F4\u8517\u8518\u852C\u851F\u8515\u8514\u84FC\u8540\u8563\u8558\u8548\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[228].length; ++j)if (D[228][j].charCodeAt(0) !== 0xFFFD) {
        e[D[228][j]] = 58368 + j;
        d[58368 + j] = D[228][j];
    }
    D[229] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8541\u8602\u854B\u8555\u8580\u85A4\u8588\u8591\u858A\u85A8\u856D\u8594\u859B\u85EA\u8587\u859C\u8577\u857E\u8590\u85C9\u85BA\u85CF\u85B9\u85D0\u85D5\u85DD\u85E5\u85DC\u85F9\u860A\u8613\u860B\u85FE\u85FA\u8606\u8622\u861A\u8630\u863F\u864D\u4E55\u8654\u865F\u8667\u8671\u8693\u86A3\u86A9\u86AA\u868B\u868C\u86B6\u86AF\u86C4\u86C6\u86B0\u86C9\u8823\u86AB\u86D4\u86DE\u86E9\u86EC\uFFFD\u86DF\u86DB\u86EF\u8712\u8706\u8708\u8700\u8703\u86FB\u8711\u8709\u870D\u86F9\u870A\u8734\u873F\u8737\u873B\u8725\u8729\u871A\u8760\u875F\u8778\u874C\u874E\u8774\u8757\u8768\u876E\u8759\u8753\u8763\u876A\u8805\u87A2\u879F\u8782\u87AF\u87CB\u87BD\u87C0\u87D0\u96D6\u87AB\u87C4\u87B3\u87C7\u87C6\u87BB\u87EF\u87F2\u87E0\u880F\u880D\u87FE\u87F6\u87F7\u880E\u87D2\u8811\u8816\u8815\u8822\u8821\u8831\u8836\u8839\u8827\u883B\u8844\u8842\u8852\u8859\u885E\u8862\u886B\u8881\u887E\u889E\u8875\u887D\u88B5\u8872\u8882\u8897\u8892\u88AE\u8899\u88A2\u888D\u88A4\u88B0\u88BF\u88B1\u88C3\u88C4\u88D4\u88D8\u88D9\u88DD\u88F9\u8902\u88FC\u88F4\u88E8\u88F2\u8904\u890C\u890A\u8913\u8943\u891E\u8925\u892A\u892B\u8941\u8944\u893B\u8936\u8938\u894C\u891D\u8960\u895E\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[229].length; ++j)if (D[229][j].charCodeAt(0) !== 0xFFFD) {
        e[D[229][j]] = 58624 + j;
        d[58624 + j] = D[229][j];
    }
    D[230] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8966\u8964\u896D\u896A\u896F\u8974\u8977\u897E\u8983\u8988\u898A\u8993\u8998\u89A1\u89A9\u89A6\u89AC\u89AF\u89B2\u89BA\u89BD\u89BF\u89C0\u89DA\u89DC\u89DD\u89E7\u89F4\u89F8\u8A03\u8A16\u8A10\u8A0C\u8A1B\u8A1D\u8A25\u8A36\u8A41\u8A5B\u8A52\u8A46\u8A48\u8A7C\u8A6D\u8A6C\u8A62\u8A85\u8A82\u8A84\u8AA8\u8AA1\u8A91\u8AA5\u8AA6\u8A9A\u8AA3\u8AC4\u8ACD\u8AC2\u8ADA\u8AEB\u8AF3\u8AE7\uFFFD\u8AE4\u8AF1\u8B14\u8AE0\u8AE2\u8AF7\u8ADE\u8ADB\u8B0C\u8B07\u8B1A\u8AE1\u8B16\u8B10\u8B17\u8B20\u8B33\u97AB\u8B26\u8B2B\u8B3E\u8B28\u8B41\u8B4C\u8B4F\u8B4E\u8B49\u8B56\u8B5B\u8B5A\u8B6B\u8B5F\u8B6C\u8B6F\u8B74\u8B7D\u8B80\u8B8C\u8B8E\u8B92\u8B93\u8B96\u8B99\u8B9A\u8C3A\u8C41\u8C3F\u8C48\u8C4C\u8C4E\u8C50\u8C55\u8C62\u8C6C\u8C78\u8C7A\u8C82\u8C89\u8C85\u8C8A\u8C8D\u8C8E\u8C94\u8C7C\u8C98\u621D\u8CAD\u8CAA\u8CBD\u8CB2\u8CB3\u8CAE\u8CB6\u8CC8\u8CC1\u8CE4\u8CE3\u8CDA\u8CFD\u8CFA\u8CFB\u8D04\u8D05\u8D0A\u8D07\u8D0F\u8D0D\u8D10\u9F4E\u8D13\u8CCD\u8D14\u8D16\u8D67\u8D6D\u8D71\u8D73\u8D81\u8D99\u8DC2\u8DBE\u8DBA\u8DCF\u8DDA\u8DD6\u8DCC\u8DDB\u8DCB\u8DEA\u8DEB\u8DDF\u8DE3\u8DFC\u8E08\u8E09\u8DFF\u8E1D\u8E1E\u8E10\u8E1F\u8E42\u8E35\u8E30\u8E34\u8E4A\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[230].length; ++j)if (D[230][j].charCodeAt(0) !== 0xFFFD) {
        e[D[230][j]] = 58880 + j;
        d[58880 + j] = D[230][j];
    }
    D[231] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8E47\u8E49\u8E4C\u8E50\u8E48\u8E59\u8E64\u8E60\u8E2A\u8E63\u8E55\u8E76\u8E72\u8E7C\u8E81\u8E87\u8E85\u8E84\u8E8B\u8E8A\u8E93\u8E91\u8E94\u8E99\u8EAA\u8EA1\u8EAC\u8EB0\u8EC6\u8EB1\u8EBE\u8EC5\u8EC8\u8ECB\u8EDB\u8EE3\u8EFC\u8EFB\u8EEB\u8EFE\u8F0A\u8F05\u8F15\u8F12\u8F19\u8F13\u8F1C\u8F1F\u8F1B\u8F0C\u8F26\u8F33\u8F3B\u8F39\u8F45\u8F42\u8F3E\u8F4C\u8F49\u8F46\u8F4E\u8F57\u8F5C\uFFFD\u8F62\u8F63\u8F64\u8F9C\u8F9F\u8FA3\u8FAD\u8FAF\u8FB7\u8FDA\u8FE5\u8FE2\u8FEA\u8FEF\u9087\u8FF4\u9005\u8FF9\u8FFA\u9011\u9015\u9021\u900D\u901E\u9016\u900B\u9027\u9036\u9035\u9039\u8FF8\u904F\u9050\u9051\u9052\u900E\u9049\u903E\u9056\u9058\u905E\u9068\u906F\u9076\u96A8\u9072\u9082\u907D\u9081\u9080\u908A\u9089\u908F\u90A8\u90AF\u90B1\u90B5\u90E2\u90E4\u6248\u90DB\u9102\u9112\u9119\u9132\u9130\u914A\u9156\u9158\u9163\u9165\u9169\u9173\u9172\u918B\u9189\u9182\u91A2\u91AB\u91AF\u91AA\u91B5\u91B4\u91BA\u91C0\u91C1\u91C9\u91CB\u91D0\u91D6\u91DF\u91E1\u91DB\u91FC\u91F5\u91F6\u921E\u91FF\u9214\u922C\u9215\u9211\u925E\u9257\u9245\u9249\u9264\u9248\u9295\u923F\u924B\u9250\u929C\u9296\u9293\u929B\u925A\u92CF\u92B9\u92B7\u92E9\u930F\u92FA\u9344\u932E\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[231].length; ++j)if (D[231][j].charCodeAt(0) !== 0xFFFD) {
        e[D[231][j]] = 59136 + j;
        d[59136 + j] = D[231][j];
    }
    D[232] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9319\u9322\u931A\u9323\u933A\u9335\u933B\u935C\u9360\u937C\u936E\u9356\u93B0\u93AC\u93AD\u9394\u93B9\u93D6\u93D7\u93E8\u93E5\u93D8\u93C3\u93DD\u93D0\u93C8\u93E4\u941A\u9414\u9413\u9403\u9407\u9410\u9436\u942B\u9435\u9421\u943A\u9441\u9452\u9444\u945B\u9460\u9462\u945E\u946A\u9229\u9470\u9475\u9477\u947D\u945A\u947C\u947E\u9481\u947F\u9582\u9587\u958A\u9594\u9596\u9598\u9599\uFFFD\u95A0\u95A8\u95A7\u95AD\u95BC\u95BB\u95B9\u95BE\u95CA\u6FF6\u95C3\u95CD\u95CC\u95D5\u95D4\u95D6\u95DC\u95E1\u95E5\u95E2\u9621\u9628\u962E\u962F\u9642\u964C\u964F\u964B\u9677\u965C\u965E\u965D\u965F\u9666\u9672\u966C\u968D\u9698\u9695\u9697\u96AA\u96A7\u96B1\u96B2\u96B0\u96B4\u96B6\u96B8\u96B9\u96CE\u96CB\u96C9\u96CD\u894D\u96DC\u970D\u96D5\u96F9\u9704\u9706\u9708\u9713\u970E\u9711\u970F\u9716\u9719\u9724\u972A\u9730\u9739\u973D\u973E\u9744\u9746\u9748\u9742\u9749\u975C\u9760\u9764\u9766\u9768\u52D2\u976B\u9771\u9779\u9785\u977C\u9781\u977A\u9786\u978B\u978F\u9790\u979C\u97A8\u97A6\u97A3\u97B3\u97B4\u97C3\u97C6\u97C8\u97CB\u97DC\u97ED\u9F4F\u97F2\u7ADF\u97F6\u97F5\u980F\u980C\u9838\u9824\u9821\u9837\u983D\u9846\u984F\u984B\u986B\u986F\u9870\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[232].length; ++j)if (D[232][j].charCodeAt(0) !== 0xFFFD) {
        e[D[232][j]] = 59392 + j;
        d[59392 + j] = D[232][j];
    }
    D[233] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9871\u9874\u9873\u98AA\u98AF\u98B1\u98B6\u98C4\u98C3\u98C6\u98E9\u98EB\u9903\u9909\u9912\u9914\u9918\u9921\u991D\u991E\u9924\u9920\u992C\u992E\u993D\u993E\u9942\u9949\u9945\u9950\u994B\u9951\u9952\u994C\u9955\u9997\u9998\u99A5\u99AD\u99AE\u99BC\u99DF\u99DB\u99DD\u99D8\u99D1\u99ED\u99EE\u99F1\u99F2\u99FB\u99F8\u9A01\u9A0F\u9A05\u99E2\u9A19\u9A2B\u9A37\u9A45\u9A42\u9A40\u9A43\uFFFD\u9A3E\u9A55\u9A4D\u9A5B\u9A57\u9A5F\u9A62\u9A65\u9A64\u9A69\u9A6B\u9A6A\u9AAD\u9AB0\u9ABC\u9AC0\u9ACF\u9AD1\u9AD3\u9AD4\u9ADE\u9ADF\u9AE2\u9AE3\u9AE6\u9AEF\u9AEB\u9AEE\u9AF4\u9AF1\u9AF7\u9AFB\u9B06\u9B18\u9B1A\u9B1F\u9B22\u9B23\u9B25\u9B27\u9B28\u9B29\u9B2A\u9B2E\u9B2F\u9B32\u9B44\u9B43\u9B4F\u9B4D\u9B4E\u9B51\u9B58\u9B74\u9B93\u9B83\u9B91\u9B96\u9B97\u9B9F\u9BA0\u9BA8\u9BB4\u9BC0\u9BCA\u9BB9\u9BC6\u9BCF\u9BD1\u9BD2\u9BE3\u9BE2\u9BE4\u9BD4\u9BE1\u9C3A\u9BF2\u9BF1\u9BF0\u9C15\u9C14\u9C09\u9C13\u9C0C\u9C06\u9C08\u9C12\u9C0A\u9C04\u9C2E\u9C1B\u9C25\u9C24\u9C21\u9C30\u9C47\u9C32\u9C46\u9C3E\u9C5A\u9C60\u9C67\u9C76\u9C78\u9CE7\u9CEC\u9CF0\u9D09\u9D08\u9CEB\u9D03\u9D06\u9D2A\u9D26\u9DAF\u9D23\u9D1F\u9D44\u9D15\u9D12\u9D41\u9D3F\u9D3E\u9D46\u9D48\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[233].length; ++j)if (D[233][j].charCodeAt(0) !== 0xFFFD) {
        e[D[233][j]] = 59648 + j;
        d[59648 + j] = D[233][j];
    }
    D[234] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9D5D\u9D5E\u9D64\u9D51\u9D50\u9D59\u9D72\u9D89\u9D87\u9DAB\u9D6F\u9D7A\u9D9A\u9DA4\u9DA9\u9DB2\u9DC4\u9DC1\u9DBB\u9DB8\u9DBA\u9DC6\u9DCF\u9DC2\u9DD9\u9DD3\u9DF8\u9DE6\u9DED\u9DEF\u9DFD\u9E1A\u9E1B\u9E1E\u9E75\u9E79\u9E7D\u9E81\u9E88\u9E8B\u9E8C\u9E92\u9E95\u9E91\u9E9D\u9EA5\u9EA9\u9EB8\u9EAA\u9EAD\u9761\u9ECC\u9ECE\u9ECF\u9ED0\u9ED4\u9EDC\u9EDE\u9EDD\u9EE0\u9EE5\u9EE8\u9EEF\uFFFD\u9EF4\u9EF6\u9EF7\u9EF9\u9EFB\u9EFC\u9EFD\u9F07\u9F08\u76B7\u9F15\u9F21\u9F2C\u9F3E\u9F4A\u9F52\u9F54\u9F63\u9F5F\u9F60\u9F61\u9F66\u9F67\u9F6C\u9F6A\u9F77\u9F72\u9F76\u9F95\u9F9C\u9FA0\u582F\u69C7\u9059\u7464\u51DC\u7199\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[234].length; ++j)if (D[234][j].charCodeAt(0) !== 0xFFFD) {
        e[D[234][j]] = 59904 + j;
        d[59904 + j] = D[234][j];
    }
    D[237] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7E8A\u891C\u9348\u9288\u84DC\u4FC9\u70BB\u6631\u68C8\u92F9\u66FB\u5F45\u4E28\u4EE1\u4EFC\u4F00\u4F03\u4F39\u4F56\u4F92\u4F8A\u4F9A\u4F94\u4FCD\u5040\u5022\u4FFF\u501E\u5046\u5070\u5042\u5094\u50F4\u50D8\u514A\u5164\u519D\u51BE\u51EC\u5215\u529C\u52A6\u52C0\u52DB\u5300\u5307\u5324\u5372\u5393\u53B2\u53DD\uFA0E\u549C\u548A\u54A9\u54FF\u5586\u5759\u5765\u57AC\u57C8\u57C7\uFA0F\uFFFD\uFA10\u589E\u58B2\u590B\u5953\u595B\u595D\u5963\u59A4\u59BA\u5B56\u5BC0\u752F\u5BD8\u5BEC\u5C1E\u5CA6\u5CBA\u5CF5\u5D27\u5D53\uFA11\u5D42\u5D6D\u5DB8\u5DB9\u5DD0\u5F21\u5F34\u5F67\u5FB7\u5FDE\u605D\u6085\u608A\u60DE\u60D5\u6120\u60F2\u6111\u6137\u6130\u6198\u6213\u62A6\u63F5\u6460\u649D\u64CE\u654E\u6600\u6615\u663B\u6609\u662E\u661E\u6624\u6665\u6657\u6659\uFA12\u6673\u6699\u66A0\u66B2\u66BF\u66FA\u670E\uF929\u6766\u67BB\u6852\u67C0\u6801\u6844\u68CF\uFA13\u6968\uFA14\u6998\u69E2\u6A30\u6A6B\u6A46\u6A73\u6A7E\u6AE2\u6AE4\u6BD6\u6C3F\u6C5C\u6C86\u6C6F\u6CDA\u6D04\u6D87\u6D6F\u6D96\u6DAC\u6DCF\u6DF8\u6DF2\u6DFC\u6E39\u6E5C\u6E27\u6E3C\u6EBF\u6F88\u6FB5\u6FF5\u7005\u7007\u7028\u7085\u70AB\u710F\u7104\u715C\u7146\u7147\uFA15\u71C1\u71FE\u72B1\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[237].length; ++j)if (D[237][j].charCodeAt(0) !== 0xFFFD) {
        e[D[237][j]] = 60672 + j;
        d[60672 + j] = D[237][j];
    }
    D[238] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u72BE\u7324\uFA16\u7377\u73BD\u73C9\u73D6\u73E3\u73D2\u7407\u73F5\u7426\u742A\u7429\u742E\u7462\u7489\u749F\u7501\u756F\u7682\u769C\u769E\u769B\u76A6\uFA17\u7746\u52AF\u7821\u784E\u7864\u787A\u7930\uFA18\uFA19\uFA1A\u7994\uFA1B\u799B\u7AD1\u7AE7\uFA1C\u7AEB\u7B9E\uFA1D\u7D48\u7D5C\u7DB7\u7DA0\u7DD6\u7E52\u7F47\u7FA1\uFA1E\u8301\u8362\u837F\u83C7\u83F6\u8448\u84B4\u8553\u8559\uFFFD\u856B\uFA1F\u85B0\uFA20\uFA21\u8807\u88F5\u8A12\u8A37\u8A79\u8AA7\u8ABE\u8ADF\uFA22\u8AF6\u8B53\u8B7F\u8CF0\u8CF4\u8D12\u8D76\uFA23\u8ECF\uFA24\uFA25\u9067\u90DE\uFA26\u9115\u9127\u91DA\u91D7\u91DE\u91ED\u91EE\u91E4\u91E5\u9206\u9210\u920A\u923A\u9240\u923C\u924E\u9259\u9251\u9239\u9267\u92A7\u9277\u9278\u92E7\u92D7\u92D9\u92D0\uFA27\u92D5\u92E0\u92D3\u9325\u9321\u92FB\uFA28\u931E\u92FF\u931D\u9302\u9370\u9357\u93A4\u93C6\u93DE\u93F8\u9431\u9445\u9448\u9592\uF9DC\uFA29\u969D\u96AF\u9733\u973B\u9743\u974D\u974F\u9751\u9755\u9857\u9865\uFA2A\uFA2B\u9927\uFA2C\u999E\u9A4E\u9AD9\u9ADC\u9B75\u9B72\u9B8F\u9BB1\u9BBB\u9C00\u9D70\u9D6B\uFA2D\u9E19\u9ED1\uFFFD\uFFFD\u2170\u2171\u2172\u2173\u2174\u2175\u2176\u2177\u2178\u2179\uFFE2\uFFE4\uFF07\uFF02\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[238].length; ++j)if (D[238][j].charCodeAt(0) !== 0xFFFD) {
        e[D[238][j]] = 60928 + j;
        d[60928 + j] = D[238][j];
    }
    D[250] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2170\u2171\u2172\u2173\u2174\u2175\u2176\u2177\u2178\u2179\u2160\u2161\u2162\u2163\u2164\u2165\u2166\u2167\u2168\u2169\uFFE2\uFFE4\uFF07\uFF02\u3231\u2116\u2121\u2235\u7E8A\u891C\u9348\u9288\u84DC\u4FC9\u70BB\u6631\u68C8\u92F9\u66FB\u5F45\u4E28\u4EE1\u4EFC\u4F00\u4F03\u4F39\u4F56\u4F92\u4F8A\u4F9A\u4F94\u4FCD\u5040\u5022\u4FFF\u501E\u5046\u5070\u5042\u5094\u50F4\u50D8\u514A\uFFFD\u5164\u519D\u51BE\u51EC\u5215\u529C\u52A6\u52C0\u52DB\u5300\u5307\u5324\u5372\u5393\u53B2\u53DD\uFA0E\u549C\u548A\u54A9\u54FF\u5586\u5759\u5765\u57AC\u57C8\u57C7\uFA0F\uFA10\u589E\u58B2\u590B\u5953\u595B\u595D\u5963\u59A4\u59BA\u5B56\u5BC0\u752F\u5BD8\u5BEC\u5C1E\u5CA6\u5CBA\u5CF5\u5D27\u5D53\uFA11\u5D42\u5D6D\u5DB8\u5DB9\u5DD0\u5F21\u5F34\u5F67\u5FB7\u5FDE\u605D\u6085\u608A\u60DE\u60D5\u6120\u60F2\u6111\u6137\u6130\u6198\u6213\u62A6\u63F5\u6460\u649D\u64CE\u654E\u6600\u6615\u663B\u6609\u662E\u661E\u6624\u6665\u6657\u6659\uFA12\u6673\u6699\u66A0\u66B2\u66BF\u66FA\u670E\uF929\u6766\u67BB\u6852\u67C0\u6801\u6844\u68CF\uFA13\u6968\uFA14\u6998\u69E2\u6A30\u6A6B\u6A46\u6A73\u6A7E\u6AE2\u6AE4\u6BD6\u6C3F\u6C5C\u6C86\u6C6F\u6CDA\u6D04\u6D87\u6D6F\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[250].length; ++j)if (D[250][j].charCodeAt(0) !== 0xFFFD) {
        e[D[250][j]] = 64000 + j;
        d[64000 + j] = D[250][j];
    }
    D[251] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6D96\u6DAC\u6DCF\u6DF8\u6DF2\u6DFC\u6E39\u6E5C\u6E27\u6E3C\u6EBF\u6F88\u6FB5\u6FF5\u7005\u7007\u7028\u7085\u70AB\u710F\u7104\u715C\u7146\u7147\uFA15\u71C1\u71FE\u72B1\u72BE\u7324\uFA16\u7377\u73BD\u73C9\u73D6\u73E3\u73D2\u7407\u73F5\u7426\u742A\u7429\u742E\u7462\u7489\u749F\u7501\u756F\u7682\u769C\u769E\u769B\u76A6\uFA17\u7746\u52AF\u7821\u784E\u7864\u787A\u7930\uFA18\uFA19\uFFFD\uFA1A\u7994\uFA1B\u799B\u7AD1\u7AE7\uFA1C\u7AEB\u7B9E\uFA1D\u7D48\u7D5C\u7DB7\u7DA0\u7DD6\u7E52\u7F47\u7FA1\uFA1E\u8301\u8362\u837F\u83C7\u83F6\u8448\u84B4\u8553\u8559\u856B\uFA1F\u85B0\uFA20\uFA21\u8807\u88F5\u8A12\u8A37\u8A79\u8AA7\u8ABE\u8ADF\uFA22\u8AF6\u8B53\u8B7F\u8CF0\u8CF4\u8D12\u8D76\uFA23\u8ECF\uFA24\uFA25\u9067\u90DE\uFA26\u9115\u9127\u91DA\u91D7\u91DE\u91ED\u91EE\u91E4\u91E5\u9206\u9210\u920A\u923A\u9240\u923C\u924E\u9259\u9251\u9239\u9267\u92A7\u9277\u9278\u92E7\u92D7\u92D9\u92D0\uFA27\u92D5\u92E0\u92D3\u9325\u9321\u92FB\uFA28\u931E\u92FF\u931D\u9302\u9370\u9357\u93A4\u93C6\u93DE\u93F8\u9431\u9445\u9448\u9592\uF9DC\uFA29\u969D\u96AF\u9733\u973B\u9743\u974D\u974F\u9751\u9755\u9857\u9865\uFA2A\uFA2B\u9927\uFA2C\u999E\u9A4E\u9AD9\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[251].length; ++j)if (D[251][j].charCodeAt(0) !== 0xFFFD) {
        e[D[251][j]] = 64256 + j;
        d[64256 + j] = D[251][j];
    }
    D[252] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9ADC\u9B75\u9B72\u9B8F\u9BB1\u9BBB\u9C00\u9D70\u9D6B\uFA2D\u9E19\u9ED1\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[252].length; ++j)if (D[252][j].charCodeAt(0) !== 0xFFFD) {
        e[D[252][j]] = 64512 + j;
        d[64512 + j] = D[252][j];
    }
    return {
        "enc": e,
        "dec": d
    };
}();
$e1f740a9d01acc72$var$cptable[936] = function() {
    var d = [], e = {}, D = [], j;
    D[0] = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\u20AC\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[0].length; ++j)if (D[0][j].charCodeAt(0) !== 0xFFFD) {
        e[D[0][j]] = 0 + j;
        d[0 + j] = D[0][j];
    }
    D[129] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u4E02\u4E04\u4E05\u4E06\u4E0F\u4E12\u4E17\u4E1F\u4E20\u4E21\u4E23\u4E26\u4E29\u4E2E\u4E2F\u4E31\u4E33\u4E35\u4E37\u4E3C\u4E40\u4E41\u4E42\u4E44\u4E46\u4E4A\u4E51\u4E55\u4E57\u4E5A\u4E5B\u4E62\u4E63\u4E64\u4E65\u4E67\u4E68\u4E6A\u4E6B\u4E6C\u4E6D\u4E6E\u4E6F\u4E72\u4E74\u4E75\u4E76\u4E77\u4E78\u4E79\u4E7A\u4E7B\u4E7C\u4E7D\u4E7F\u4E80\u4E81\u4E82\u4E83\u4E84\u4E85\u4E87\u4E8A\uFFFD\u4E90\u4E96\u4E97\u4E99\u4E9C\u4E9D\u4E9E\u4EA3\u4EAA\u4EAF\u4EB0\u4EB1\u4EB4\u4EB6\u4EB7\u4EB8\u4EB9\u4EBC\u4EBD\u4EBE\u4EC8\u4ECC\u4ECF\u4ED0\u4ED2\u4EDA\u4EDB\u4EDC\u4EE0\u4EE2\u4EE6\u4EE7\u4EE9\u4EED\u4EEE\u4EEF\u4EF1\u4EF4\u4EF8\u4EF9\u4EFA\u4EFC\u4EFE\u4F00\u4F02\u4F03\u4F04\u4F05\u4F06\u4F07\u4F08\u4F0B\u4F0C\u4F12\u4F13\u4F14\u4F15\u4F16\u4F1C\u4F1D\u4F21\u4F23\u4F28\u4F29\u4F2C\u4F2D\u4F2E\u4F31\u4F33\u4F35\u4F37\u4F39\u4F3B\u4F3E\u4F3F\u4F40\u4F41\u4F42\u4F44\u4F45\u4F47\u4F48\u4F49\u4F4A\u4F4B\u4F4C\u4F52\u4F54\u4F56\u4F61\u4F62\u4F66\u4F68\u4F6A\u4F6B\u4F6D\u4F6E\u4F71\u4F72\u4F75\u4F77\u4F78\u4F79\u4F7A\u4F7D\u4F80\u4F81\u4F82\u4F85\u4F86\u4F87\u4F8A\u4F8C\u4F8E\u4F90\u4F92\u4F93\u4F95\u4F96\u4F98\u4F99\u4F9A\u4F9C\u4F9E\u4F9F\u4FA1\u4FA2\uFFFD".split("");
    for(j = 0; j != D[129].length; ++j)if (D[129][j].charCodeAt(0) !== 0xFFFD) {
        e[D[129][j]] = 33024 + j;
        d[33024 + j] = D[129][j];
    }
    D[130] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u4FA4\u4FAB\u4FAD\u4FB0\u4FB1\u4FB2\u4FB3\u4FB4\u4FB6\u4FB7\u4FB8\u4FB9\u4FBA\u4FBB\u4FBC\u4FBD\u4FBE\u4FC0\u4FC1\u4FC2\u4FC6\u4FC7\u4FC8\u4FC9\u4FCB\u4FCC\u4FCD\u4FD2\u4FD3\u4FD4\u4FD5\u4FD6\u4FD9\u4FDB\u4FE0\u4FE2\u4FE4\u4FE5\u4FE7\u4FEB\u4FEC\u4FF0\u4FF2\u4FF4\u4FF5\u4FF6\u4FF7\u4FF9\u4FFB\u4FFC\u4FFD\u4FFF\u5000\u5001\u5002\u5003\u5004\u5005\u5006\u5007\u5008\u5009\u500A\uFFFD\u500B\u500E\u5010\u5011\u5013\u5015\u5016\u5017\u501B\u501D\u501E\u5020\u5022\u5023\u5024\u5027\u502B\u502F\u5030\u5031\u5032\u5033\u5034\u5035\u5036\u5037\u5038\u5039\u503B\u503D\u503F\u5040\u5041\u5042\u5044\u5045\u5046\u5049\u504A\u504B\u504D\u5050\u5051\u5052\u5053\u5054\u5056\u5057\u5058\u5059\u505B\u505D\u505E\u505F\u5060\u5061\u5062\u5063\u5064\u5066\u5067\u5068\u5069\u506A\u506B\u506D\u506E\u506F\u5070\u5071\u5072\u5073\u5074\u5075\u5078\u5079\u507A\u507C\u507D\u5081\u5082\u5083\u5084\u5086\u5087\u5089\u508A\u508B\u508C\u508E\u508F\u5090\u5091\u5092\u5093\u5094\u5095\u5096\u5097\u5098\u5099\u509A\u509B\u509C\u509D\u509E\u509F\u50A0\u50A1\u50A2\u50A4\u50A6\u50AA\u50AB\u50AD\u50AE\u50AF\u50B0\u50B1\u50B3\u50B4\u50B5\u50B6\u50B7\u50B8\u50B9\u50BC\uFFFD".split("");
    for(j = 0; j != D[130].length; ++j)if (D[130][j].charCodeAt(0) !== 0xFFFD) {
        e[D[130][j]] = 33280 + j;
        d[33280 + j] = D[130][j];
    }
    D[131] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u50BD\u50BE\u50BF\u50C0\u50C1\u50C2\u50C3\u50C4\u50C5\u50C6\u50C7\u50C8\u50C9\u50CA\u50CB\u50CC\u50CD\u50CE\u50D0\u50D1\u50D2\u50D3\u50D4\u50D5\u50D7\u50D8\u50D9\u50DB\u50DC\u50DD\u50DE\u50DF\u50E0\u50E1\u50E2\u50E3\u50E4\u50E5\u50E8\u50E9\u50EA\u50EB\u50EF\u50F0\u50F1\u50F2\u50F4\u50F6\u50F7\u50F8\u50F9\u50FA\u50FC\u50FD\u50FE\u50FF\u5100\u5101\u5102\u5103\u5104\u5105\u5108\uFFFD\u5109\u510A\u510C\u510D\u510E\u510F\u5110\u5111\u5113\u5114\u5115\u5116\u5117\u5118\u5119\u511A\u511B\u511C\u511D\u511E\u511F\u5120\u5122\u5123\u5124\u5125\u5126\u5127\u5128\u5129\u512A\u512B\u512C\u512D\u512E\u512F\u5130\u5131\u5132\u5133\u5134\u5135\u5136\u5137\u5138\u5139\u513A\u513B\u513C\u513D\u513E\u5142\u5147\u514A\u514C\u514E\u514F\u5150\u5152\u5153\u5157\u5158\u5159\u515B\u515D\u515E\u515F\u5160\u5161\u5163\u5164\u5166\u5167\u5169\u516A\u516F\u5172\u517A\u517E\u517F\u5183\u5184\u5186\u5187\u518A\u518B\u518E\u518F\u5190\u5191\u5193\u5194\u5198\u519A\u519D\u519E\u519F\u51A1\u51A3\u51A6\u51A7\u51A8\u51A9\u51AA\u51AD\u51AE\u51B4\u51B8\u51B9\u51BA\u51BE\u51BF\u51C1\u51C2\u51C3\u51C5\u51C8\u51CA\u51CD\u51CE\u51D0\u51D2\u51D3\u51D4\u51D5\u51D6\u51D7\uFFFD".split("");
    for(j = 0; j != D[131].length; ++j)if (D[131][j].charCodeAt(0) !== 0xFFFD) {
        e[D[131][j]] = 33536 + j;
        d[33536 + j] = D[131][j];
    }
    D[132] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u51D8\u51D9\u51DA\u51DC\u51DE\u51DF\u51E2\u51E3\u51E5\u51E6\u51E7\u51E8\u51E9\u51EA\u51EC\u51EE\u51F1\u51F2\u51F4\u51F7\u51FE\u5204\u5205\u5209\u520B\u520C\u520F\u5210\u5213\u5214\u5215\u521C\u521E\u521F\u5221\u5222\u5223\u5225\u5226\u5227\u522A\u522C\u522F\u5231\u5232\u5234\u5235\u523C\u523E\u5244\u5245\u5246\u5247\u5248\u5249\u524B\u524E\u524F\u5252\u5253\u5255\u5257\u5258\uFFFD\u5259\u525A\u525B\u525D\u525F\u5260\u5262\u5263\u5264\u5266\u5268\u526B\u526C\u526D\u526E\u5270\u5271\u5273\u5274\u5275\u5276\u5277\u5278\u5279\u527A\u527B\u527C\u527E\u5280\u5283\u5284\u5285\u5286\u5287\u5289\u528A\u528B\u528C\u528D\u528E\u528F\u5291\u5292\u5294\u5295\u5296\u5297\u5298\u5299\u529A\u529C\u52A4\u52A5\u52A6\u52A7\u52AE\u52AF\u52B0\u52B4\u52B5\u52B6\u52B7\u52B8\u52B9\u52BA\u52BB\u52BC\u52BD\u52C0\u52C1\u52C2\u52C4\u52C5\u52C6\u52C8\u52CA\u52CC\u52CD\u52CE\u52CF\u52D1\u52D3\u52D4\u52D5\u52D7\u52D9\u52DA\u52DB\u52DC\u52DD\u52DE\u52E0\u52E1\u52E2\u52E3\u52E5\u52E6\u52E7\u52E8\u52E9\u52EA\u52EB\u52EC\u52ED\u52EE\u52EF\u52F1\u52F2\u52F3\u52F4\u52F5\u52F6\u52F7\u52F8\u52FB\u52FC\u52FD\u5301\u5302\u5303\u5304\u5307\u5309\u530A\u530B\u530C\u530E\uFFFD".split("");
    for(j = 0; j != D[132].length; ++j)if (D[132][j].charCodeAt(0) !== 0xFFFD) {
        e[D[132][j]] = 33792 + j;
        d[33792 + j] = D[132][j];
    }
    D[133] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5311\u5312\u5313\u5314\u5318\u531B\u531C\u531E\u531F\u5322\u5324\u5325\u5327\u5328\u5329\u532B\u532C\u532D\u532F\u5330\u5331\u5332\u5333\u5334\u5335\u5336\u5337\u5338\u533C\u533D\u5340\u5342\u5344\u5346\u534B\u534C\u534D\u5350\u5354\u5358\u5359\u535B\u535D\u5365\u5368\u536A\u536C\u536D\u5372\u5376\u5379\u537B\u537C\u537D\u537E\u5380\u5381\u5383\u5387\u5388\u538A\u538E\u538F\uFFFD\u5390\u5391\u5392\u5393\u5394\u5396\u5397\u5399\u539B\u539C\u539E\u53A0\u53A1\u53A4\u53A7\u53AA\u53AB\u53AC\u53AD\u53AF\u53B0\u53B1\u53B2\u53B3\u53B4\u53B5\u53B7\u53B8\u53B9\u53BA\u53BC\u53BD\u53BE\u53C0\u53C3\u53C4\u53C5\u53C6\u53C7\u53CE\u53CF\u53D0\u53D2\u53D3\u53D5\u53DA\u53DC\u53DD\u53DE\u53E1\u53E2\u53E7\u53F4\u53FA\u53FE\u53FF\u5400\u5402\u5405\u5407\u540B\u5414\u5418\u5419\u541A\u541C\u5422\u5424\u5425\u542A\u5430\u5433\u5436\u5437\u543A\u543D\u543F\u5441\u5442\u5444\u5445\u5447\u5449\u544C\u544D\u544E\u544F\u5451\u545A\u545D\u545E\u545F\u5460\u5461\u5463\u5465\u5467\u5469\u546A\u546B\u546C\u546D\u546E\u546F\u5470\u5474\u5479\u547A\u547E\u547F\u5481\u5483\u5485\u5487\u5488\u5489\u548A\u548D\u5491\u5493\u5497\u5498\u549C\u549E\u549F\u54A0\u54A1\uFFFD".split("");
    for(j = 0; j != D[133].length; ++j)if (D[133][j].charCodeAt(0) !== 0xFFFD) {
        e[D[133][j]] = 34048 + j;
        d[34048 + j] = D[133][j];
    }
    D[134] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u54A2\u54A5\u54AE\u54B0\u54B2\u54B5\u54B6\u54B7\u54B9\u54BA\u54BC\u54BE\u54C3\u54C5\u54CA\u54CB\u54D6\u54D8\u54DB\u54E0\u54E1\u54E2\u54E3\u54E4\u54EB\u54EC\u54EF\u54F0\u54F1\u54F4\u54F5\u54F6\u54F7\u54F8\u54F9\u54FB\u54FE\u5500\u5502\u5503\u5504\u5505\u5508\u550A\u550B\u550C\u550D\u550E\u5512\u5513\u5515\u5516\u5517\u5518\u5519\u551A\u551C\u551D\u551E\u551F\u5521\u5525\u5526\uFFFD\u5528\u5529\u552B\u552D\u5532\u5534\u5535\u5536\u5538\u5539\u553A\u553B\u553D\u5540\u5542\u5545\u5547\u5548\u554B\u554C\u554D\u554E\u554F\u5551\u5552\u5553\u5554\u5557\u5558\u5559\u555A\u555B\u555D\u555E\u555F\u5560\u5562\u5563\u5568\u5569\u556B\u556F\u5570\u5571\u5572\u5573\u5574\u5579\u557A\u557D\u557F\u5585\u5586\u558C\u558D\u558E\u5590\u5592\u5593\u5595\u5596\u5597\u559A\u559B\u559E\u55A0\u55A1\u55A2\u55A3\u55A4\u55A5\u55A6\u55A8\u55A9\u55AA\u55AB\u55AC\u55AD\u55AE\u55AF\u55B0\u55B2\u55B4\u55B6\u55B8\u55BA\u55BC\u55BF\u55C0\u55C1\u55C2\u55C3\u55C6\u55C7\u55C8\u55CA\u55CB\u55CE\u55CF\u55D0\u55D5\u55D7\u55D8\u55D9\u55DA\u55DB\u55DE\u55E0\u55E2\u55E7\u55E9\u55ED\u55EE\u55F0\u55F1\u55F4\u55F6\u55F8\u55F9\u55FA\u55FB\u55FC\u55FF\u5602\u5603\u5604\u5605\uFFFD".split("");
    for(j = 0; j != D[134].length; ++j)if (D[134][j].charCodeAt(0) !== 0xFFFD) {
        e[D[134][j]] = 34304 + j;
        d[34304 + j] = D[134][j];
    }
    D[135] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5606\u5607\u560A\u560B\u560D\u5610\u5611\u5612\u5613\u5614\u5615\u5616\u5617\u5619\u561A\u561C\u561D\u5620\u5621\u5622\u5625\u5626\u5628\u5629\u562A\u562B\u562E\u562F\u5630\u5633\u5635\u5637\u5638\u563A\u563C\u563D\u563E\u5640\u5641\u5642\u5643\u5644\u5645\u5646\u5647\u5648\u5649\u564A\u564B\u564F\u5650\u5651\u5652\u5653\u5655\u5656\u565A\u565B\u565D\u565E\u565F\u5660\u5661\uFFFD\u5663\u5665\u5666\u5667\u566D\u566E\u566F\u5670\u5672\u5673\u5674\u5675\u5677\u5678\u5679\u567A\u567D\u567E\u567F\u5680\u5681\u5682\u5683\u5684\u5687\u5688\u5689\u568A\u568B\u568C\u568D\u5690\u5691\u5692\u5694\u5695\u5696\u5697\u5698\u5699\u569A\u569B\u569C\u569D\u569E\u569F\u56A0\u56A1\u56A2\u56A4\u56A5\u56A6\u56A7\u56A8\u56A9\u56AA\u56AB\u56AC\u56AD\u56AE\u56B0\u56B1\u56B2\u56B3\u56B4\u56B5\u56B6\u56B8\u56B9\u56BA\u56BB\u56BD\u56BE\u56BF\u56C0\u56C1\u56C2\u56C3\u56C4\u56C5\u56C6\u56C7\u56C8\u56C9\u56CB\u56CC\u56CD\u56CE\u56CF\u56D0\u56D1\u56D2\u56D3\u56D5\u56D6\u56D8\u56D9\u56DC\u56E3\u56E5\u56E6\u56E7\u56E8\u56E9\u56EA\u56EC\u56EE\u56EF\u56F2\u56F3\u56F6\u56F7\u56F8\u56FB\u56FC\u5700\u5701\u5702\u5705\u5707\u570B\u570C\u570D\u570E\u570F\u5710\u5711\uFFFD".split("");
    for(j = 0; j != D[135].length; ++j)if (D[135][j].charCodeAt(0) !== 0xFFFD) {
        e[D[135][j]] = 34560 + j;
        d[34560 + j] = D[135][j];
    }
    D[136] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5712\u5713\u5714\u5715\u5716\u5717\u5718\u5719\u571A\u571B\u571D\u571E\u5720\u5721\u5722\u5724\u5725\u5726\u5727\u572B\u5731\u5732\u5734\u5735\u5736\u5737\u5738\u573C\u573D\u573F\u5741\u5743\u5744\u5745\u5746\u5748\u5749\u574B\u5752\u5753\u5754\u5755\u5756\u5758\u5759\u5762\u5763\u5765\u5767\u576C\u576E\u5770\u5771\u5772\u5774\u5775\u5778\u5779\u577A\u577D\u577E\u577F\u5780\uFFFD\u5781\u5787\u5788\u5789\u578A\u578D\u578E\u578F\u5790\u5791\u5794\u5795\u5796\u5797\u5798\u5799\u579A\u579C\u579D\u579E\u579F\u57A5\u57A8\u57AA\u57AC\u57AF\u57B0\u57B1\u57B3\u57B5\u57B6\u57B7\u57B9\u57BA\u57BB\u57BC\u57BD\u57BE\u57BF\u57C0\u57C1\u57C4\u57C5\u57C6\u57C7\u57C8\u57C9\u57CA\u57CC\u57CD\u57D0\u57D1\u57D3\u57D6\u57D7\u57DB\u57DC\u57DE\u57E1\u57E2\u57E3\u57E5\u57E6\u57E7\u57E8\u57E9\u57EA\u57EB\u57EC\u57EE\u57F0\u57F1\u57F2\u57F3\u57F5\u57F6\u57F7\u57FB\u57FC\u57FE\u57FF\u5801\u5803\u5804\u5805\u5808\u5809\u580A\u580C\u580E\u580F\u5810\u5812\u5813\u5814\u5816\u5817\u5818\u581A\u581B\u581C\u581D\u581F\u5822\u5823\u5825\u5826\u5827\u5828\u5829\u582B\u582C\u582D\u582E\u582F\u5831\u5832\u5833\u5834\u5836\u5837\u5838\u5839\u583A\u583B\u583C\u583D\uFFFD".split("");
    for(j = 0; j != D[136].length; ++j)if (D[136][j].charCodeAt(0) !== 0xFFFD) {
        e[D[136][j]] = 34816 + j;
        d[34816 + j] = D[136][j];
    }
    D[137] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u583E\u583F\u5840\u5841\u5842\u5843\u5845\u5846\u5847\u5848\u5849\u584A\u584B\u584E\u584F\u5850\u5852\u5853\u5855\u5856\u5857\u5859\u585A\u585B\u585C\u585D\u585F\u5860\u5861\u5862\u5863\u5864\u5866\u5867\u5868\u5869\u586A\u586D\u586E\u586F\u5870\u5871\u5872\u5873\u5874\u5875\u5876\u5877\u5878\u5879\u587A\u587B\u587C\u587D\u587F\u5882\u5884\u5886\u5887\u5888\u588A\u588B\u588C\uFFFD\u588D\u588E\u588F\u5890\u5891\u5894\u5895\u5896\u5897\u5898\u589B\u589C\u589D\u58A0\u58A1\u58A2\u58A3\u58A4\u58A5\u58A6\u58A7\u58AA\u58AB\u58AC\u58AD\u58AE\u58AF\u58B0\u58B1\u58B2\u58B3\u58B4\u58B5\u58B6\u58B7\u58B8\u58B9\u58BA\u58BB\u58BD\u58BE\u58BF\u58C0\u58C2\u58C3\u58C4\u58C6\u58C7\u58C8\u58C9\u58CA\u58CB\u58CC\u58CD\u58CE\u58CF\u58D0\u58D2\u58D3\u58D4\u58D6\u58D7\u58D8\u58D9\u58DA\u58DB\u58DC\u58DD\u58DE\u58DF\u58E0\u58E1\u58E2\u58E3\u58E5\u58E6\u58E7\u58E8\u58E9\u58EA\u58ED\u58EF\u58F1\u58F2\u58F4\u58F5\u58F7\u58F8\u58FA\u58FB\u58FC\u58FD\u58FE\u58FF\u5900\u5901\u5903\u5905\u5906\u5908\u5909\u590A\u590B\u590C\u590E\u5910\u5911\u5912\u5913\u5917\u5918\u591B\u591D\u591E\u5920\u5921\u5922\u5923\u5926\u5928\u592C\u5930\u5932\u5933\u5935\u5936\u593B\uFFFD".split("");
    for(j = 0; j != D[137].length; ++j)if (D[137][j].charCodeAt(0) !== 0xFFFD) {
        e[D[137][j]] = 35072 + j;
        d[35072 + j] = D[137][j];
    }
    D[138] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u593D\u593E\u593F\u5940\u5943\u5945\u5946\u594A\u594C\u594D\u5950\u5952\u5953\u5959\u595B\u595C\u595D\u595E\u595F\u5961\u5963\u5964\u5966\u5967\u5968\u5969\u596A\u596B\u596C\u596D\u596E\u596F\u5970\u5971\u5972\u5975\u5977\u597A\u597B\u597C\u597E\u597F\u5980\u5985\u5989\u598B\u598C\u598E\u598F\u5990\u5991\u5994\u5995\u5998\u599A\u599B\u599C\u599D\u599F\u59A0\u59A1\u59A2\u59A6\uFFFD\u59A7\u59AC\u59AD\u59B0\u59B1\u59B3\u59B4\u59B5\u59B6\u59B7\u59B8\u59BA\u59BC\u59BD\u59BF\u59C0\u59C1\u59C2\u59C3\u59C4\u59C5\u59C7\u59C8\u59C9\u59CC\u59CD\u59CE\u59CF\u59D5\u59D6\u59D9\u59DB\u59DE\u59DF\u59E0\u59E1\u59E2\u59E4\u59E6\u59E7\u59E9\u59EA\u59EB\u59ED\u59EE\u59EF\u59F0\u59F1\u59F2\u59F3\u59F4\u59F5\u59F6\u59F7\u59F8\u59FA\u59FC\u59FD\u59FE\u5A00\u5A02\u5A0A\u5A0B\u5A0D\u5A0E\u5A0F\u5A10\u5A12\u5A14\u5A15\u5A16\u5A17\u5A19\u5A1A\u5A1B\u5A1D\u5A1E\u5A21\u5A22\u5A24\u5A26\u5A27\u5A28\u5A2A\u5A2B\u5A2C\u5A2D\u5A2E\u5A2F\u5A30\u5A33\u5A35\u5A37\u5A38\u5A39\u5A3A\u5A3B\u5A3D\u5A3E\u5A3F\u5A41\u5A42\u5A43\u5A44\u5A45\u5A47\u5A48\u5A4B\u5A4C\u5A4D\u5A4E\u5A4F\u5A50\u5A51\u5A52\u5A53\u5A54\u5A56\u5A57\u5A58\u5A59\u5A5B\u5A5C\u5A5D\u5A5E\u5A5F\u5A60\uFFFD".split("");
    for(j = 0; j != D[138].length; ++j)if (D[138][j].charCodeAt(0) !== 0xFFFD) {
        e[D[138][j]] = 35328 + j;
        d[35328 + j] = D[138][j];
    }
    D[139] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5A61\u5A63\u5A64\u5A65\u5A66\u5A68\u5A69\u5A6B\u5A6C\u5A6D\u5A6E\u5A6F\u5A70\u5A71\u5A72\u5A73\u5A78\u5A79\u5A7B\u5A7C\u5A7D\u5A7E\u5A80\u5A81\u5A82\u5A83\u5A84\u5A85\u5A86\u5A87\u5A88\u5A89\u5A8A\u5A8B\u5A8C\u5A8D\u5A8E\u5A8F\u5A90\u5A91\u5A93\u5A94\u5A95\u5A96\u5A97\u5A98\u5A99\u5A9C\u5A9D\u5A9E\u5A9F\u5AA0\u5AA1\u5AA2\u5AA3\u5AA4\u5AA5\u5AA6\u5AA7\u5AA8\u5AA9\u5AAB\u5AAC\uFFFD\u5AAD\u5AAE\u5AAF\u5AB0\u5AB1\u5AB4\u5AB6\u5AB7\u5AB9\u5ABA\u5ABB\u5ABC\u5ABD\u5ABF\u5AC0\u5AC3\u5AC4\u5AC5\u5AC6\u5AC7\u5AC8\u5ACA\u5ACB\u5ACD\u5ACE\u5ACF\u5AD0\u5AD1\u5AD3\u5AD5\u5AD7\u5AD9\u5ADA\u5ADB\u5ADD\u5ADE\u5ADF\u5AE2\u5AE4\u5AE5\u5AE7\u5AE8\u5AEA\u5AEC\u5AED\u5AEE\u5AEF\u5AF0\u5AF2\u5AF3\u5AF4\u5AF5\u5AF6\u5AF7\u5AF8\u5AF9\u5AFA\u5AFB\u5AFC\u5AFD\u5AFE\u5AFF\u5B00\u5B01\u5B02\u5B03\u5B04\u5B05\u5B06\u5B07\u5B08\u5B0A\u5B0B\u5B0C\u5B0D\u5B0E\u5B0F\u5B10\u5B11\u5B12\u5B13\u5B14\u5B15\u5B18\u5B19\u5B1A\u5B1B\u5B1C\u5B1D\u5B1E\u5B1F\u5B20\u5B21\u5B22\u5B23\u5B24\u5B25\u5B26\u5B27\u5B28\u5B29\u5B2A\u5B2B\u5B2C\u5B2D\u5B2E\u5B2F\u5B30\u5B31\u5B33\u5B35\u5B36\u5B38\u5B39\u5B3A\u5B3B\u5B3C\u5B3D\u5B3E\u5B3F\u5B41\u5B42\u5B43\u5B44\u5B45\u5B46\u5B47\uFFFD".split("");
    for(j = 0; j != D[139].length; ++j)if (D[139][j].charCodeAt(0) !== 0xFFFD) {
        e[D[139][j]] = 35584 + j;
        d[35584 + j] = D[139][j];
    }
    D[140] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5B48\u5B49\u5B4A\u5B4B\u5B4C\u5B4D\u5B4E\u5B4F\u5B52\u5B56\u5B5E\u5B60\u5B61\u5B67\u5B68\u5B6B\u5B6D\u5B6E\u5B6F\u5B72\u5B74\u5B76\u5B77\u5B78\u5B79\u5B7B\u5B7C\u5B7E\u5B7F\u5B82\u5B86\u5B8A\u5B8D\u5B8E\u5B90\u5B91\u5B92\u5B94\u5B96\u5B9F\u5BA7\u5BA8\u5BA9\u5BAC\u5BAD\u5BAE\u5BAF\u5BB1\u5BB2\u5BB7\u5BBA\u5BBB\u5BBC\u5BC0\u5BC1\u5BC3\u5BC8\u5BC9\u5BCA\u5BCB\u5BCD\u5BCE\u5BCF\uFFFD\u5BD1\u5BD4\u5BD5\u5BD6\u5BD7\u5BD8\u5BD9\u5BDA\u5BDB\u5BDC\u5BE0\u5BE2\u5BE3\u5BE6\u5BE7\u5BE9\u5BEA\u5BEB\u5BEC\u5BED\u5BEF\u5BF1\u5BF2\u5BF3\u5BF4\u5BF5\u5BF6\u5BF7\u5BFD\u5BFE\u5C00\u5C02\u5C03\u5C05\u5C07\u5C08\u5C0B\u5C0C\u5C0D\u5C0E\u5C10\u5C12\u5C13\u5C17\u5C19\u5C1B\u5C1E\u5C1F\u5C20\u5C21\u5C23\u5C26\u5C28\u5C29\u5C2A\u5C2B\u5C2D\u5C2E\u5C2F\u5C30\u5C32\u5C33\u5C35\u5C36\u5C37\u5C43\u5C44\u5C46\u5C47\u5C4C\u5C4D\u5C52\u5C53\u5C54\u5C56\u5C57\u5C58\u5C5A\u5C5B\u5C5C\u5C5D\u5C5F\u5C62\u5C64\u5C67\u5C68\u5C69\u5C6A\u5C6B\u5C6C\u5C6D\u5C70\u5C72\u5C73\u5C74\u5C75\u5C76\u5C77\u5C78\u5C7B\u5C7C\u5C7D\u5C7E\u5C80\u5C83\u5C84\u5C85\u5C86\u5C87\u5C89\u5C8A\u5C8B\u5C8E\u5C8F\u5C92\u5C93\u5C95\u5C9D\u5C9E\u5C9F\u5CA0\u5CA1\u5CA4\u5CA5\u5CA6\u5CA7\u5CA8\uFFFD".split("");
    for(j = 0; j != D[140].length; ++j)if (D[140][j].charCodeAt(0) !== 0xFFFD) {
        e[D[140][j]] = 35840 + j;
        d[35840 + j] = D[140][j];
    }
    D[141] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5CAA\u5CAE\u5CAF\u5CB0\u5CB2\u5CB4\u5CB6\u5CB9\u5CBA\u5CBB\u5CBC\u5CBE\u5CC0\u5CC2\u5CC3\u5CC5\u5CC6\u5CC7\u5CC8\u5CC9\u5CCA\u5CCC\u5CCD\u5CCE\u5CCF\u5CD0\u5CD1\u5CD3\u5CD4\u5CD5\u5CD6\u5CD7\u5CD8\u5CDA\u5CDB\u5CDC\u5CDD\u5CDE\u5CDF\u5CE0\u5CE2\u5CE3\u5CE7\u5CE9\u5CEB\u5CEC\u5CEE\u5CEF\u5CF1\u5CF2\u5CF3\u5CF4\u5CF5\u5CF6\u5CF7\u5CF8\u5CF9\u5CFA\u5CFC\u5CFD\u5CFE\u5CFF\u5D00\uFFFD\u5D01\u5D04\u5D05\u5D08\u5D09\u5D0A\u5D0B\u5D0C\u5D0D\u5D0F\u5D10\u5D11\u5D12\u5D13\u5D15\u5D17\u5D18\u5D19\u5D1A\u5D1C\u5D1D\u5D1F\u5D20\u5D21\u5D22\u5D23\u5D25\u5D28\u5D2A\u5D2B\u5D2C\u5D2F\u5D30\u5D31\u5D32\u5D33\u5D35\u5D36\u5D37\u5D38\u5D39\u5D3A\u5D3B\u5D3C\u5D3F\u5D40\u5D41\u5D42\u5D43\u5D44\u5D45\u5D46\u5D48\u5D49\u5D4D\u5D4E\u5D4F\u5D50\u5D51\u5D52\u5D53\u5D54\u5D55\u5D56\u5D57\u5D59\u5D5A\u5D5C\u5D5E\u5D5F\u5D60\u5D61\u5D62\u5D63\u5D64\u5D65\u5D66\u5D67\u5D68\u5D6A\u5D6D\u5D6E\u5D70\u5D71\u5D72\u5D73\u5D75\u5D76\u5D77\u5D78\u5D79\u5D7A\u5D7B\u5D7C\u5D7D\u5D7E\u5D7F\u5D80\u5D81\u5D83\u5D84\u5D85\u5D86\u5D87\u5D88\u5D89\u5D8A\u5D8B\u5D8C\u5D8D\u5D8E\u5D8F\u5D90\u5D91\u5D92\u5D93\u5D94\u5D95\u5D96\u5D97\u5D98\u5D9A\u5D9B\u5D9C\u5D9E\u5D9F\u5DA0\uFFFD".split("");
    for(j = 0; j != D[141].length; ++j)if (D[141][j].charCodeAt(0) !== 0xFFFD) {
        e[D[141][j]] = 36096 + j;
        d[36096 + j] = D[141][j];
    }
    D[142] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5DA1\u5DA2\u5DA3\u5DA4\u5DA5\u5DA6\u5DA7\u5DA8\u5DA9\u5DAA\u5DAB\u5DAC\u5DAD\u5DAE\u5DAF\u5DB0\u5DB1\u5DB2\u5DB3\u5DB4\u5DB5\u5DB6\u5DB8\u5DB9\u5DBA\u5DBB\u5DBC\u5DBD\u5DBE\u5DBF\u5DC0\u5DC1\u5DC2\u5DC3\u5DC4\u5DC6\u5DC7\u5DC8\u5DC9\u5DCA\u5DCB\u5DCC\u5DCE\u5DCF\u5DD0\u5DD1\u5DD2\u5DD3\u5DD4\u5DD5\u5DD6\u5DD7\u5DD8\u5DD9\u5DDA\u5DDC\u5DDF\u5DE0\u5DE3\u5DE4\u5DEA\u5DEC\u5DED\uFFFD\u5DF0\u5DF5\u5DF6\u5DF8\u5DF9\u5DFA\u5DFB\u5DFC\u5DFF\u5E00\u5E04\u5E07\u5E09\u5E0A\u5E0B\u5E0D\u5E0E\u5E12\u5E13\u5E17\u5E1E\u5E1F\u5E20\u5E21\u5E22\u5E23\u5E24\u5E25\u5E28\u5E29\u5E2A\u5E2B\u5E2C\u5E2F\u5E30\u5E32\u5E33\u5E34\u5E35\u5E36\u5E39\u5E3A\u5E3E\u5E3F\u5E40\u5E41\u5E43\u5E46\u5E47\u5E48\u5E49\u5E4A\u5E4B\u5E4D\u5E4E\u5E4F\u5E50\u5E51\u5E52\u5E53\u5E56\u5E57\u5E58\u5E59\u5E5A\u5E5C\u5E5D\u5E5F\u5E60\u5E63\u5E64\u5E65\u5E66\u5E67\u5E68\u5E69\u5E6A\u5E6B\u5E6C\u5E6D\u5E6E\u5E6F\u5E70\u5E71\u5E75\u5E77\u5E79\u5E7E\u5E81\u5E82\u5E83\u5E85\u5E88\u5E89\u5E8C\u5E8D\u5E8E\u5E92\u5E98\u5E9B\u5E9D\u5EA1\u5EA2\u5EA3\u5EA4\u5EA8\u5EA9\u5EAA\u5EAB\u5EAC\u5EAE\u5EAF\u5EB0\u5EB1\u5EB2\u5EB4\u5EBA\u5EBB\u5EBC\u5EBD\u5EBF\u5EC0\u5EC1\u5EC2\u5EC3\u5EC4\u5EC5\uFFFD".split("");
    for(j = 0; j != D[142].length; ++j)if (D[142][j].charCodeAt(0) !== 0xFFFD) {
        e[D[142][j]] = 36352 + j;
        d[36352 + j] = D[142][j];
    }
    D[143] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5EC6\u5EC7\u5EC8\u5ECB\u5ECC\u5ECD\u5ECE\u5ECF\u5ED0\u5ED4\u5ED5\u5ED7\u5ED8\u5ED9\u5EDA\u5EDC\u5EDD\u5EDE\u5EDF\u5EE0\u5EE1\u5EE2\u5EE3\u5EE4\u5EE5\u5EE6\u5EE7\u5EE9\u5EEB\u5EEC\u5EED\u5EEE\u5EEF\u5EF0\u5EF1\u5EF2\u5EF3\u5EF5\u5EF8\u5EF9\u5EFB\u5EFC\u5EFD\u5F05\u5F06\u5F07\u5F09\u5F0C\u5F0D\u5F0E\u5F10\u5F12\u5F14\u5F16\u5F19\u5F1A\u5F1C\u5F1D\u5F1E\u5F21\u5F22\u5F23\u5F24\uFFFD\u5F28\u5F2B\u5F2C\u5F2E\u5F30\u5F32\u5F33\u5F34\u5F35\u5F36\u5F37\u5F38\u5F3B\u5F3D\u5F3E\u5F3F\u5F41\u5F42\u5F43\u5F44\u5F45\u5F46\u5F47\u5F48\u5F49\u5F4A\u5F4B\u5F4C\u5F4D\u5F4E\u5F4F\u5F51\u5F54\u5F59\u5F5A\u5F5B\u5F5C\u5F5E\u5F5F\u5F60\u5F63\u5F65\u5F67\u5F68\u5F6B\u5F6E\u5F6F\u5F72\u5F74\u5F75\u5F76\u5F78\u5F7A\u5F7D\u5F7E\u5F7F\u5F83\u5F86\u5F8D\u5F8E\u5F8F\u5F91\u5F93\u5F94\u5F96\u5F9A\u5F9B\u5F9D\u5F9E\u5F9F\u5FA0\u5FA2\u5FA3\u5FA4\u5FA5\u5FA6\u5FA7\u5FA9\u5FAB\u5FAC\u5FAF\u5FB0\u5FB1\u5FB2\u5FB3\u5FB4\u5FB6\u5FB8\u5FB9\u5FBA\u5FBB\u5FBE\u5FBF\u5FC0\u5FC1\u5FC2\u5FC7\u5FC8\u5FCA\u5FCB\u5FCE\u5FD3\u5FD4\u5FD5\u5FDA\u5FDB\u5FDC\u5FDE\u5FDF\u5FE2\u5FE3\u5FE5\u5FE6\u5FE8\u5FE9\u5FEC\u5FEF\u5FF0\u5FF2\u5FF3\u5FF4\u5FF6\u5FF7\u5FF9\u5FFA\u5FFC\u6007\uFFFD".split("");
    for(j = 0; j != D[143].length; ++j)if (D[143][j].charCodeAt(0) !== 0xFFFD) {
        e[D[143][j]] = 36608 + j;
        d[36608 + j] = D[143][j];
    }
    D[144] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6008\u6009\u600B\u600C\u6010\u6011\u6013\u6017\u6018\u601A\u601E\u601F\u6022\u6023\u6024\u602C\u602D\u602E\u6030\u6031\u6032\u6033\u6034\u6036\u6037\u6038\u6039\u603A\u603D\u603E\u6040\u6044\u6045\u6046\u6047\u6048\u6049\u604A\u604C\u604E\u604F\u6051\u6053\u6054\u6056\u6057\u6058\u605B\u605C\u605E\u605F\u6060\u6061\u6065\u6066\u606E\u6071\u6072\u6074\u6075\u6077\u607E\u6080\uFFFD\u6081\u6082\u6085\u6086\u6087\u6088\u608A\u608B\u608E\u608F\u6090\u6091\u6093\u6095\u6097\u6098\u6099\u609C\u609E\u60A1\u60A2\u60A4\u60A5\u60A7\u60A9\u60AA\u60AE\u60B0\u60B3\u60B5\u60B6\u60B7\u60B9\u60BA\u60BD\u60BE\u60BF\u60C0\u60C1\u60C2\u60C3\u60C4\u60C7\u60C8\u60C9\u60CC\u60CD\u60CE\u60CF\u60D0\u60D2\u60D3\u60D4\u60D6\u60D7\u60D9\u60DB\u60DE\u60E1\u60E2\u60E3\u60E4\u60E5\u60EA\u60F1\u60F2\u60F5\u60F7\u60F8\u60FB\u60FC\u60FD\u60FE\u60FF\u6102\u6103\u6104\u6105\u6107\u610A\u610B\u610C\u6110\u6111\u6112\u6113\u6114\u6116\u6117\u6118\u6119\u611B\u611C\u611D\u611E\u6121\u6122\u6125\u6128\u6129\u612A\u612C\u612D\u612E\u612F\u6130\u6131\u6132\u6133\u6134\u6135\u6136\u6137\u6138\u6139\u613A\u613B\u613C\u613D\u613E\u6140\u6141\u6142\u6143\u6144\u6145\u6146\uFFFD".split("");
    for(j = 0; j != D[144].length; ++j)if (D[144][j].charCodeAt(0) !== 0xFFFD) {
        e[D[144][j]] = 36864 + j;
        d[36864 + j] = D[144][j];
    }
    D[145] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6147\u6149\u614B\u614D\u614F\u6150\u6152\u6153\u6154\u6156\u6157\u6158\u6159\u615A\u615B\u615C\u615E\u615F\u6160\u6161\u6163\u6164\u6165\u6166\u6169\u616A\u616B\u616C\u616D\u616E\u616F\u6171\u6172\u6173\u6174\u6176\u6178\u6179\u617A\u617B\u617C\u617D\u617E\u617F\u6180\u6181\u6182\u6183\u6184\u6185\u6186\u6187\u6188\u6189\u618A\u618C\u618D\u618F\u6190\u6191\u6192\u6193\u6195\uFFFD\u6196\u6197\u6198\u6199\u619A\u619B\u619C\u619E\u619F\u61A0\u61A1\u61A2\u61A3\u61A4\u61A5\u61A6\u61AA\u61AB\u61AD\u61AE\u61AF\u61B0\u61B1\u61B2\u61B3\u61B4\u61B5\u61B6\u61B8\u61B9\u61BA\u61BB\u61BC\u61BD\u61BF\u61C0\u61C1\u61C3\u61C4\u61C5\u61C6\u61C7\u61C9\u61CC\u61CD\u61CE\u61CF\u61D0\u61D3\u61D5\u61D6\u61D7\u61D8\u61D9\u61DA\u61DB\u61DC\u61DD\u61DE\u61DF\u61E0\u61E1\u61E2\u61E3\u61E4\u61E5\u61E7\u61E8\u61E9\u61EA\u61EB\u61EC\u61ED\u61EE\u61EF\u61F0\u61F1\u61F2\u61F3\u61F4\u61F6\u61F7\u61F8\u61F9\u61FA\u61FB\u61FC\u61FD\u61FE\u6200\u6201\u6202\u6203\u6204\u6205\u6207\u6209\u6213\u6214\u6219\u621C\u621D\u621E\u6220\u6223\u6226\u6227\u6228\u6229\u622B\u622D\u622F\u6230\u6231\u6232\u6235\u6236\u6238\u6239\u623A\u623B\u623C\u6242\u6244\u6245\u6246\u624A\uFFFD".split("");
    for(j = 0; j != D[145].length; ++j)if (D[145][j].charCodeAt(0) !== 0xFFFD) {
        e[D[145][j]] = 37120 + j;
        d[37120 + j] = D[145][j];
    }
    D[146] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u624F\u6250\u6255\u6256\u6257\u6259\u625A\u625C\u625D\u625E\u625F\u6260\u6261\u6262\u6264\u6265\u6268\u6271\u6272\u6274\u6275\u6277\u6278\u627A\u627B\u627D\u6281\u6282\u6283\u6285\u6286\u6287\u6288\u628B\u628C\u628D\u628E\u628F\u6290\u6294\u6299\u629C\u629D\u629E\u62A3\u62A6\u62A7\u62A9\u62AA\u62AD\u62AE\u62AF\u62B0\u62B2\u62B3\u62B4\u62B6\u62B7\u62B8\u62BA\u62BE\u62C0\u62C1\uFFFD\u62C3\u62CB\u62CF\u62D1\u62D5\u62DD\u62DE\u62E0\u62E1\u62E4\u62EA\u62EB\u62F0\u62F2\u62F5\u62F8\u62F9\u62FA\u62FB\u6300\u6303\u6304\u6305\u6306\u630A\u630B\u630C\u630D\u630F\u6310\u6312\u6313\u6314\u6315\u6317\u6318\u6319\u631C\u6326\u6327\u6329\u632C\u632D\u632E\u6330\u6331\u6333\u6334\u6335\u6336\u6337\u6338\u633B\u633C\u633E\u633F\u6340\u6341\u6344\u6347\u6348\u634A\u6351\u6352\u6353\u6354\u6356\u6357\u6358\u6359\u635A\u635B\u635C\u635D\u6360\u6364\u6365\u6366\u6368\u636A\u636B\u636C\u636F\u6370\u6372\u6373\u6374\u6375\u6378\u6379\u637C\u637D\u637E\u637F\u6381\u6383\u6384\u6385\u6386\u638B\u638D\u6391\u6393\u6394\u6395\u6397\u6399\u639A\u639B\u639C\u639D\u639E\u639F\u63A1\u63A4\u63A6\u63AB\u63AF\u63B1\u63B2\u63B5\u63B6\u63B9\u63BB\u63BD\u63BF\u63C0\uFFFD".split("");
    for(j = 0; j != D[146].length; ++j)if (D[146][j].charCodeAt(0) !== 0xFFFD) {
        e[D[146][j]] = 37376 + j;
        d[37376 + j] = D[146][j];
    }
    D[147] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u63C1\u63C2\u63C3\u63C5\u63C7\u63C8\u63CA\u63CB\u63CC\u63D1\u63D3\u63D4\u63D5\u63D7\u63D8\u63D9\u63DA\u63DB\u63DC\u63DD\u63DF\u63E2\u63E4\u63E5\u63E6\u63E7\u63E8\u63EB\u63EC\u63EE\u63EF\u63F0\u63F1\u63F3\u63F5\u63F7\u63F9\u63FA\u63FB\u63FC\u63FE\u6403\u6404\u6406\u6407\u6408\u6409\u640A\u640D\u640E\u6411\u6412\u6415\u6416\u6417\u6418\u6419\u641A\u641D\u641F\u6422\u6423\u6424\uFFFD\u6425\u6427\u6428\u6429\u642B\u642E\u642F\u6430\u6431\u6432\u6433\u6435\u6436\u6437\u6438\u6439\u643B\u643C\u643E\u6440\u6442\u6443\u6449\u644B\u644C\u644D\u644E\u644F\u6450\u6451\u6453\u6455\u6456\u6457\u6459\u645A\u645B\u645C\u645D\u645F\u6460\u6461\u6462\u6463\u6464\u6465\u6466\u6468\u646A\u646B\u646C\u646E\u646F\u6470\u6471\u6472\u6473\u6474\u6475\u6476\u6477\u647B\u647C\u647D\u647E\u647F\u6480\u6481\u6483\u6486\u6488\u6489\u648A\u648B\u648C\u648D\u648E\u648F\u6490\u6493\u6494\u6497\u6498\u649A\u649B\u649C\u649D\u649F\u64A0\u64A1\u64A2\u64A3\u64A5\u64A6\u64A7\u64A8\u64AA\u64AB\u64AF\u64B1\u64B2\u64B3\u64B4\u64B6\u64B9\u64BB\u64BD\u64BE\u64BF\u64C1\u64C3\u64C4\u64C6\u64C7\u64C8\u64C9\u64CA\u64CB\u64CC\u64CF\u64D1\u64D3\u64D4\u64D5\u64D6\u64D9\u64DA\uFFFD".split("");
    for(j = 0; j != D[147].length; ++j)if (D[147][j].charCodeAt(0) !== 0xFFFD) {
        e[D[147][j]] = 37632 + j;
        d[37632 + j] = D[147][j];
    }
    D[148] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u64DB\u64DC\u64DD\u64DF\u64E0\u64E1\u64E3\u64E5\u64E7\u64E8\u64E9\u64EA\u64EB\u64EC\u64ED\u64EE\u64EF\u64F0\u64F1\u64F2\u64F3\u64F4\u64F5\u64F6\u64F7\u64F8\u64F9\u64FA\u64FB\u64FC\u64FD\u64FE\u64FF\u6501\u6502\u6503\u6504\u6505\u6506\u6507\u6508\u650A\u650B\u650C\u650D\u650E\u650F\u6510\u6511\u6513\u6514\u6515\u6516\u6517\u6519\u651A\u651B\u651C\u651D\u651E\u651F\u6520\u6521\uFFFD\u6522\u6523\u6524\u6526\u6527\u6528\u6529\u652A\u652C\u652D\u6530\u6531\u6532\u6533\u6537\u653A\u653C\u653D\u6540\u6541\u6542\u6543\u6544\u6546\u6547\u654A\u654B\u654D\u654E\u6550\u6552\u6553\u6554\u6557\u6558\u655A\u655C\u655F\u6560\u6561\u6564\u6565\u6567\u6568\u6569\u656A\u656D\u656E\u656F\u6571\u6573\u6575\u6576\u6578\u6579\u657A\u657B\u657C\u657D\u657E\u657F\u6580\u6581\u6582\u6583\u6584\u6585\u6586\u6588\u6589\u658A\u658D\u658E\u658F\u6592\u6594\u6595\u6596\u6598\u659A\u659D\u659E\u65A0\u65A2\u65A3\u65A6\u65A8\u65AA\u65AC\u65AE\u65B1\u65B2\u65B3\u65B4\u65B5\u65B6\u65B7\u65B8\u65BA\u65BB\u65BE\u65BF\u65C0\u65C2\u65C7\u65C8\u65C9\u65CA\u65CD\u65D0\u65D1\u65D3\u65D4\u65D5\u65D8\u65D9\u65DA\u65DB\u65DC\u65DD\u65DE\u65DF\u65E1\u65E3\u65E4\u65EA\u65EB\uFFFD".split("");
    for(j = 0; j != D[148].length; ++j)if (D[148][j].charCodeAt(0) !== 0xFFFD) {
        e[D[148][j]] = 37888 + j;
        d[37888 + j] = D[148][j];
    }
    D[149] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u65F2\u65F3\u65F4\u65F5\u65F8\u65F9\u65FB\u65FC\u65FD\u65FE\u65FF\u6601\u6604\u6605\u6607\u6608\u6609\u660B\u660D\u6610\u6611\u6612\u6616\u6617\u6618\u661A\u661B\u661C\u661E\u6621\u6622\u6623\u6624\u6626\u6629\u662A\u662B\u662C\u662E\u6630\u6632\u6633\u6637\u6638\u6639\u663A\u663B\u663D\u663F\u6640\u6642\u6644\u6645\u6646\u6647\u6648\u6649\u664A\u664D\u664E\u6650\u6651\u6658\uFFFD\u6659\u665B\u665C\u665D\u665E\u6660\u6662\u6663\u6665\u6667\u6669\u666A\u666B\u666C\u666D\u6671\u6672\u6673\u6675\u6678\u6679\u667B\u667C\u667D\u667F\u6680\u6681\u6683\u6685\u6686\u6688\u6689\u668A\u668B\u668D\u668E\u668F\u6690\u6692\u6693\u6694\u6695\u6698\u6699\u669A\u669B\u669C\u669E\u669F\u66A0\u66A1\u66A2\u66A3\u66A4\u66A5\u66A6\u66A9\u66AA\u66AB\u66AC\u66AD\u66AF\u66B0\u66B1\u66B2\u66B3\u66B5\u66B6\u66B7\u66B8\u66BA\u66BB\u66BC\u66BD\u66BF\u66C0\u66C1\u66C2\u66C3\u66C4\u66C5\u66C6\u66C7\u66C8\u66C9\u66CA\u66CB\u66CC\u66CD\u66CE\u66CF\u66D0\u66D1\u66D2\u66D3\u66D4\u66D5\u66D6\u66D7\u66D8\u66DA\u66DE\u66DF\u66E0\u66E1\u66E2\u66E3\u66E4\u66E5\u66E7\u66E8\u66EA\u66EB\u66EC\u66ED\u66EE\u66EF\u66F1\u66F5\u66F6\u66F8\u66FA\u66FB\u66FD\u6701\u6702\u6703\uFFFD".split("");
    for(j = 0; j != D[149].length; ++j)if (D[149][j].charCodeAt(0) !== 0xFFFD) {
        e[D[149][j]] = 38144 + j;
        d[38144 + j] = D[149][j];
    }
    D[150] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6704\u6705\u6706\u6707\u670C\u670E\u670F\u6711\u6712\u6713\u6716\u6718\u6719\u671A\u671C\u671E\u6720\u6721\u6722\u6723\u6724\u6725\u6727\u6729\u672E\u6730\u6732\u6733\u6736\u6737\u6738\u6739\u673B\u673C\u673E\u673F\u6741\u6744\u6745\u6747\u674A\u674B\u674D\u6752\u6754\u6755\u6757\u6758\u6759\u675A\u675B\u675D\u6762\u6763\u6764\u6766\u6767\u676B\u676C\u676E\u6771\u6774\u6776\uFFFD\u6778\u6779\u677A\u677B\u677D\u6780\u6782\u6783\u6785\u6786\u6788\u678A\u678C\u678D\u678E\u678F\u6791\u6792\u6793\u6794\u6796\u6799\u679B\u679F\u67A0\u67A1\u67A4\u67A6\u67A9\u67AC\u67AE\u67B1\u67B2\u67B4\u67B9\u67BA\u67BB\u67BC\u67BD\u67BE\u67BF\u67C0\u67C2\u67C5\u67C6\u67C7\u67C8\u67C9\u67CA\u67CB\u67CC\u67CD\u67CE\u67D5\u67D6\u67D7\u67DB\u67DF\u67E1\u67E3\u67E4\u67E6\u67E7\u67E8\u67EA\u67EB\u67ED\u67EE\u67F2\u67F5\u67F6\u67F7\u67F8\u67F9\u67FA\u67FB\u67FC\u67FE\u6801\u6802\u6803\u6804\u6806\u680D\u6810\u6812\u6814\u6815\u6818\u6819\u681A\u681B\u681C\u681E\u681F\u6820\u6822\u6823\u6824\u6825\u6826\u6827\u6828\u682B\u682C\u682D\u682E\u682F\u6830\u6831\u6834\u6835\u6836\u683A\u683B\u683F\u6847\u684B\u684D\u684F\u6852\u6856\u6857\u6858\u6859\u685A\u685B\uFFFD".split("");
    for(j = 0; j != D[150].length; ++j)if (D[150][j].charCodeAt(0) !== 0xFFFD) {
        e[D[150][j]] = 38400 + j;
        d[38400 + j] = D[150][j];
    }
    D[151] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u685C\u685D\u685E\u685F\u686A\u686C\u686D\u686E\u686F\u6870\u6871\u6872\u6873\u6875\u6878\u6879\u687A\u687B\u687C\u687D\u687E\u687F\u6880\u6882\u6884\u6887\u6888\u6889\u688A\u688B\u688C\u688D\u688E\u6890\u6891\u6892\u6894\u6895\u6896\u6898\u6899\u689A\u689B\u689C\u689D\u689E\u689F\u68A0\u68A1\u68A3\u68A4\u68A5\u68A9\u68AA\u68AB\u68AC\u68AE\u68B1\u68B2\u68B4\u68B6\u68B7\u68B8\uFFFD\u68B9\u68BA\u68BB\u68BC\u68BD\u68BE\u68BF\u68C1\u68C3\u68C4\u68C5\u68C6\u68C7\u68C8\u68CA\u68CC\u68CE\u68CF\u68D0\u68D1\u68D3\u68D4\u68D6\u68D7\u68D9\u68DB\u68DC\u68DD\u68DE\u68DF\u68E1\u68E2\u68E4\u68E5\u68E6\u68E7\u68E8\u68E9\u68EA\u68EB\u68EC\u68ED\u68EF\u68F2\u68F3\u68F4\u68F6\u68F7\u68F8\u68FB\u68FD\u68FE\u68FF\u6900\u6902\u6903\u6904\u6906\u6907\u6908\u6909\u690A\u690C\u690F\u6911\u6913\u6914\u6915\u6916\u6917\u6918\u6919\u691A\u691B\u691C\u691D\u691E\u6921\u6922\u6923\u6925\u6926\u6927\u6928\u6929\u692A\u692B\u692C\u692E\u692F\u6931\u6932\u6933\u6935\u6936\u6937\u6938\u693A\u693B\u693C\u693E\u6940\u6941\u6943\u6944\u6945\u6946\u6947\u6948\u6949\u694A\u694B\u694C\u694D\u694E\u694F\u6950\u6951\u6952\u6953\u6955\u6956\u6958\u6959\u695B\u695C\u695F\uFFFD".split("");
    for(j = 0; j != D[151].length; ++j)if (D[151][j].charCodeAt(0) !== 0xFFFD) {
        e[D[151][j]] = 38656 + j;
        d[38656 + j] = D[151][j];
    }
    D[152] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6961\u6962\u6964\u6965\u6967\u6968\u6969\u696A\u696C\u696D\u696F\u6970\u6972\u6973\u6974\u6975\u6976\u697A\u697B\u697D\u697E\u697F\u6981\u6983\u6985\u698A\u698B\u698C\u698E\u698F\u6990\u6991\u6992\u6993\u6996\u6997\u6999\u699A\u699D\u699E\u699F\u69A0\u69A1\u69A2\u69A3\u69A4\u69A5\u69A6\u69A9\u69AA\u69AC\u69AE\u69AF\u69B0\u69B2\u69B3\u69B5\u69B6\u69B8\u69B9\u69BA\u69BC\u69BD\uFFFD\u69BE\u69BF\u69C0\u69C2\u69C3\u69C4\u69C5\u69C6\u69C7\u69C8\u69C9\u69CB\u69CD\u69CF\u69D1\u69D2\u69D3\u69D5\u69D6\u69D7\u69D8\u69D9\u69DA\u69DC\u69DD\u69DE\u69E1\u69E2\u69E3\u69E4\u69E5\u69E6\u69E7\u69E8\u69E9\u69EA\u69EB\u69EC\u69EE\u69EF\u69F0\u69F1\u69F3\u69F4\u69F5\u69F6\u69F7\u69F8\u69F9\u69FA\u69FB\u69FC\u69FE\u6A00\u6A01\u6A02\u6A03\u6A04\u6A05\u6A06\u6A07\u6A08\u6A09\u6A0B\u6A0C\u6A0D\u6A0E\u6A0F\u6A10\u6A11\u6A12\u6A13\u6A14\u6A15\u6A16\u6A19\u6A1A\u6A1B\u6A1C\u6A1D\u6A1E\u6A20\u6A22\u6A23\u6A24\u6A25\u6A26\u6A27\u6A29\u6A2B\u6A2C\u6A2D\u6A2E\u6A30\u6A32\u6A33\u6A34\u6A36\u6A37\u6A38\u6A39\u6A3A\u6A3B\u6A3C\u6A3F\u6A40\u6A41\u6A42\u6A43\u6A45\u6A46\u6A48\u6A49\u6A4A\u6A4B\u6A4C\u6A4D\u6A4E\u6A4F\u6A51\u6A52\u6A53\u6A54\u6A55\u6A56\u6A57\u6A5A\uFFFD".split("");
    for(j = 0; j != D[152].length; ++j)if (D[152][j].charCodeAt(0) !== 0xFFFD) {
        e[D[152][j]] = 38912 + j;
        d[38912 + j] = D[152][j];
    }
    D[153] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6A5C\u6A5D\u6A5E\u6A5F\u6A60\u6A62\u6A63\u6A64\u6A66\u6A67\u6A68\u6A69\u6A6A\u6A6B\u6A6C\u6A6D\u6A6E\u6A6F\u6A70\u6A72\u6A73\u6A74\u6A75\u6A76\u6A77\u6A78\u6A7A\u6A7B\u6A7D\u6A7E\u6A7F\u6A81\u6A82\u6A83\u6A85\u6A86\u6A87\u6A88\u6A89\u6A8A\u6A8B\u6A8C\u6A8D\u6A8F\u6A92\u6A93\u6A94\u6A95\u6A96\u6A98\u6A99\u6A9A\u6A9B\u6A9C\u6A9D\u6A9E\u6A9F\u6AA1\u6AA2\u6AA3\u6AA4\u6AA5\u6AA6\uFFFD\u6AA7\u6AA8\u6AAA\u6AAD\u6AAE\u6AAF\u6AB0\u6AB1\u6AB2\u6AB3\u6AB4\u6AB5\u6AB6\u6AB7\u6AB8\u6AB9\u6ABA\u6ABB\u6ABC\u6ABD\u6ABE\u6ABF\u6AC0\u6AC1\u6AC2\u6AC3\u6AC4\u6AC5\u6AC6\u6AC7\u6AC8\u6AC9\u6ACA\u6ACB\u6ACC\u6ACD\u6ACE\u6ACF\u6AD0\u6AD1\u6AD2\u6AD3\u6AD4\u6AD5\u6AD6\u6AD7\u6AD8\u6AD9\u6ADA\u6ADB\u6ADC\u6ADD\u6ADE\u6ADF\u6AE0\u6AE1\u6AE2\u6AE3\u6AE4\u6AE5\u6AE6\u6AE7\u6AE8\u6AE9\u6AEA\u6AEB\u6AEC\u6AED\u6AEE\u6AEF\u6AF0\u6AF1\u6AF2\u6AF3\u6AF4\u6AF5\u6AF6\u6AF7\u6AF8\u6AF9\u6AFA\u6AFB\u6AFC\u6AFD\u6AFE\u6AFF\u6B00\u6B01\u6B02\u6B03\u6B04\u6B05\u6B06\u6B07\u6B08\u6B09\u6B0A\u6B0B\u6B0C\u6B0D\u6B0E\u6B0F\u6B10\u6B11\u6B12\u6B13\u6B14\u6B15\u6B16\u6B17\u6B18\u6B19\u6B1A\u6B1B\u6B1C\u6B1D\u6B1E\u6B1F\u6B25\u6B26\u6B28\u6B29\u6B2A\u6B2B\u6B2C\u6B2D\u6B2E\uFFFD".split("");
    for(j = 0; j != D[153].length; ++j)if (D[153][j].charCodeAt(0) !== 0xFFFD) {
        e[D[153][j]] = 39168 + j;
        d[39168 + j] = D[153][j];
    }
    D[154] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6B2F\u6B30\u6B31\u6B33\u6B34\u6B35\u6B36\u6B38\u6B3B\u6B3C\u6B3D\u6B3F\u6B40\u6B41\u6B42\u6B44\u6B45\u6B48\u6B4A\u6B4B\u6B4D\u6B4E\u6B4F\u6B50\u6B51\u6B52\u6B53\u6B54\u6B55\u6B56\u6B57\u6B58\u6B5A\u6B5B\u6B5C\u6B5D\u6B5E\u6B5F\u6B60\u6B61\u6B68\u6B69\u6B6B\u6B6C\u6B6D\u6B6E\u6B6F\u6B70\u6B71\u6B72\u6B73\u6B74\u6B75\u6B76\u6B77\u6B78\u6B7A\u6B7D\u6B7E\u6B7F\u6B80\u6B85\u6B88\uFFFD\u6B8C\u6B8E\u6B8F\u6B90\u6B91\u6B94\u6B95\u6B97\u6B98\u6B99\u6B9C\u6B9D\u6B9E\u6B9F\u6BA0\u6BA2\u6BA3\u6BA4\u6BA5\u6BA6\u6BA7\u6BA8\u6BA9\u6BAB\u6BAC\u6BAD\u6BAE\u6BAF\u6BB0\u6BB1\u6BB2\u6BB6\u6BB8\u6BB9\u6BBA\u6BBB\u6BBC\u6BBD\u6BBE\u6BC0\u6BC3\u6BC4\u6BC6\u6BC7\u6BC8\u6BC9\u6BCA\u6BCC\u6BCE\u6BD0\u6BD1\u6BD8\u6BDA\u6BDC\u6BDD\u6BDE\u6BDF\u6BE0\u6BE2\u6BE3\u6BE4\u6BE5\u6BE6\u6BE7\u6BE8\u6BE9\u6BEC\u6BED\u6BEE\u6BF0\u6BF1\u6BF2\u6BF4\u6BF6\u6BF7\u6BF8\u6BFA\u6BFB\u6BFC\u6BFE\u6BFF\u6C00\u6C01\u6C02\u6C03\u6C04\u6C08\u6C09\u6C0A\u6C0B\u6C0C\u6C0E\u6C12\u6C17\u6C1C\u6C1D\u6C1E\u6C20\u6C23\u6C25\u6C2B\u6C2C\u6C2D\u6C31\u6C33\u6C36\u6C37\u6C39\u6C3A\u6C3B\u6C3C\u6C3E\u6C3F\u6C43\u6C44\u6C45\u6C48\u6C4B\u6C4C\u6C4D\u6C4E\u6C4F\u6C51\u6C52\u6C53\u6C56\u6C58\uFFFD".split("");
    for(j = 0; j != D[154].length; ++j)if (D[154][j].charCodeAt(0) !== 0xFFFD) {
        e[D[154][j]] = 39424 + j;
        d[39424 + j] = D[154][j];
    }
    D[155] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6C59\u6C5A\u6C62\u6C63\u6C65\u6C66\u6C67\u6C6B\u6C6C\u6C6D\u6C6E\u6C6F\u6C71\u6C73\u6C75\u6C77\u6C78\u6C7A\u6C7B\u6C7C\u6C7F\u6C80\u6C84\u6C87\u6C8A\u6C8B\u6C8D\u6C8E\u6C91\u6C92\u6C95\u6C96\u6C97\u6C98\u6C9A\u6C9C\u6C9D\u6C9E\u6CA0\u6CA2\u6CA8\u6CAC\u6CAF\u6CB0\u6CB4\u6CB5\u6CB6\u6CB7\u6CBA\u6CC0\u6CC1\u6CC2\u6CC3\u6CC6\u6CC7\u6CC8\u6CCB\u6CCD\u6CCE\u6CCF\u6CD1\u6CD2\u6CD8\uFFFD\u6CD9\u6CDA\u6CDC\u6CDD\u6CDF\u6CE4\u6CE6\u6CE7\u6CE9\u6CEC\u6CED\u6CF2\u6CF4\u6CF9\u6CFF\u6D00\u6D02\u6D03\u6D05\u6D06\u6D08\u6D09\u6D0A\u6D0D\u6D0F\u6D10\u6D11\u6D13\u6D14\u6D15\u6D16\u6D18\u6D1C\u6D1D\u6D1F\u6D20\u6D21\u6D22\u6D23\u6D24\u6D26\u6D28\u6D29\u6D2C\u6D2D\u6D2F\u6D30\u6D34\u6D36\u6D37\u6D38\u6D3A\u6D3F\u6D40\u6D42\u6D44\u6D49\u6D4C\u6D50\u6D55\u6D56\u6D57\u6D58\u6D5B\u6D5D\u6D5F\u6D61\u6D62\u6D64\u6D65\u6D67\u6D68\u6D6B\u6D6C\u6D6D\u6D70\u6D71\u6D72\u6D73\u6D75\u6D76\u6D79\u6D7A\u6D7B\u6D7D\u6D7E\u6D7F\u6D80\u6D81\u6D83\u6D84\u6D86\u6D87\u6D8A\u6D8B\u6D8D\u6D8F\u6D90\u6D92\u6D96\u6D97\u6D98\u6D99\u6D9A\u6D9C\u6DA2\u6DA5\u6DAC\u6DAD\u6DB0\u6DB1\u6DB3\u6DB4\u6DB6\u6DB7\u6DB9\u6DBA\u6DBB\u6DBC\u6DBD\u6DBE\u6DC1\u6DC2\u6DC3\u6DC8\u6DC9\u6DCA\uFFFD".split("");
    for(j = 0; j != D[155].length; ++j)if (D[155][j].charCodeAt(0) !== 0xFFFD) {
        e[D[155][j]] = 39680 + j;
        d[39680 + j] = D[155][j];
    }
    D[156] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6DCD\u6DCE\u6DCF\u6DD0\u6DD2\u6DD3\u6DD4\u6DD5\u6DD7\u6DDA\u6DDB\u6DDC\u6DDF\u6DE2\u6DE3\u6DE5\u6DE7\u6DE8\u6DE9\u6DEA\u6DED\u6DEF\u6DF0\u6DF2\u6DF4\u6DF5\u6DF6\u6DF8\u6DFA\u6DFD\u6DFE\u6DFF\u6E00\u6E01\u6E02\u6E03\u6E04\u6E06\u6E07\u6E08\u6E09\u6E0B\u6E0F\u6E12\u6E13\u6E15\u6E18\u6E19\u6E1B\u6E1C\u6E1E\u6E1F\u6E22\u6E26\u6E27\u6E28\u6E2A\u6E2C\u6E2E\u6E30\u6E31\u6E33\u6E35\uFFFD\u6E36\u6E37\u6E39\u6E3B\u6E3C\u6E3D\u6E3E\u6E3F\u6E40\u6E41\u6E42\u6E45\u6E46\u6E47\u6E48\u6E49\u6E4A\u6E4B\u6E4C\u6E4F\u6E50\u6E51\u6E52\u6E55\u6E57\u6E59\u6E5A\u6E5C\u6E5D\u6E5E\u6E60\u6E61\u6E62\u6E63\u6E64\u6E65\u6E66\u6E67\u6E68\u6E69\u6E6A\u6E6C\u6E6D\u6E6F\u6E70\u6E71\u6E72\u6E73\u6E74\u6E75\u6E76\u6E77\u6E78\u6E79\u6E7A\u6E7B\u6E7C\u6E7D\u6E80\u6E81\u6E82\u6E84\u6E87\u6E88\u6E8A\u6E8B\u6E8C\u6E8D\u6E8E\u6E91\u6E92\u6E93\u6E94\u6E95\u6E96\u6E97\u6E99\u6E9A\u6E9B\u6E9D\u6E9E\u6EA0\u6EA1\u6EA3\u6EA4\u6EA6\u6EA8\u6EA9\u6EAB\u6EAC\u6EAD\u6EAE\u6EB0\u6EB3\u6EB5\u6EB8\u6EB9\u6EBC\u6EBE\u6EBF\u6EC0\u6EC3\u6EC4\u6EC5\u6EC6\u6EC8\u6EC9\u6ECA\u6ECC\u6ECD\u6ECE\u6ED0\u6ED2\u6ED6\u6ED8\u6ED9\u6EDB\u6EDC\u6EDD\u6EE3\u6EE7\u6EEA\u6EEB\u6EEC\u6EED\u6EEE\u6EEF\uFFFD".split("");
    for(j = 0; j != D[156].length; ++j)if (D[156][j].charCodeAt(0) !== 0xFFFD) {
        e[D[156][j]] = 39936 + j;
        d[39936 + j] = D[156][j];
    }
    D[157] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6EF0\u6EF1\u6EF2\u6EF3\u6EF5\u6EF6\u6EF7\u6EF8\u6EFA\u6EFB\u6EFC\u6EFD\u6EFE\u6EFF\u6F00\u6F01\u6F03\u6F04\u6F05\u6F07\u6F08\u6F0A\u6F0B\u6F0C\u6F0D\u6F0E\u6F10\u6F11\u6F12\u6F16\u6F17\u6F18\u6F19\u6F1A\u6F1B\u6F1C\u6F1D\u6F1E\u6F1F\u6F21\u6F22\u6F23\u6F25\u6F26\u6F27\u6F28\u6F2C\u6F2E\u6F30\u6F32\u6F34\u6F35\u6F37\u6F38\u6F39\u6F3A\u6F3B\u6F3C\u6F3D\u6F3F\u6F40\u6F41\u6F42\uFFFD\u6F43\u6F44\u6F45\u6F48\u6F49\u6F4A\u6F4C\u6F4E\u6F4F\u6F50\u6F51\u6F52\u6F53\u6F54\u6F55\u6F56\u6F57\u6F59\u6F5A\u6F5B\u6F5D\u6F5F\u6F60\u6F61\u6F63\u6F64\u6F65\u6F67\u6F68\u6F69\u6F6A\u6F6B\u6F6C\u6F6F\u6F70\u6F71\u6F73\u6F75\u6F76\u6F77\u6F79\u6F7B\u6F7D\u6F7E\u6F7F\u6F80\u6F81\u6F82\u6F83\u6F85\u6F86\u6F87\u6F8A\u6F8B\u6F8F\u6F90\u6F91\u6F92\u6F93\u6F94\u6F95\u6F96\u6F97\u6F98\u6F99\u6F9A\u6F9B\u6F9D\u6F9E\u6F9F\u6FA0\u6FA2\u6FA3\u6FA4\u6FA5\u6FA6\u6FA8\u6FA9\u6FAA\u6FAB\u6FAC\u6FAD\u6FAE\u6FAF\u6FB0\u6FB1\u6FB2\u6FB4\u6FB5\u6FB7\u6FB8\u6FBA\u6FBB\u6FBC\u6FBD\u6FBE\u6FBF\u6FC1\u6FC3\u6FC4\u6FC5\u6FC6\u6FC7\u6FC8\u6FCA\u6FCB\u6FCC\u6FCD\u6FCE\u6FCF\u6FD0\u6FD3\u6FD4\u6FD5\u6FD6\u6FD7\u6FD8\u6FD9\u6FDA\u6FDB\u6FDC\u6FDD\u6FDF\u6FE2\u6FE3\u6FE4\u6FE5\uFFFD".split("");
    for(j = 0; j != D[157].length; ++j)if (D[157][j].charCodeAt(0) !== 0xFFFD) {
        e[D[157][j]] = 40192 + j;
        d[40192 + j] = D[157][j];
    }
    D[158] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6FE6\u6FE7\u6FE8\u6FE9\u6FEA\u6FEB\u6FEC\u6FED\u6FF0\u6FF1\u6FF2\u6FF3\u6FF4\u6FF5\u6FF6\u6FF7\u6FF8\u6FF9\u6FFA\u6FFB\u6FFC\u6FFD\u6FFE\u6FFF\u7000\u7001\u7002\u7003\u7004\u7005\u7006\u7007\u7008\u7009\u700A\u700B\u700C\u700D\u700E\u700F\u7010\u7012\u7013\u7014\u7015\u7016\u7017\u7018\u7019\u701C\u701D\u701E\u701F\u7020\u7021\u7022\u7024\u7025\u7026\u7027\u7028\u7029\u702A\uFFFD\u702B\u702C\u702D\u702E\u702F\u7030\u7031\u7032\u7033\u7034\u7036\u7037\u7038\u703A\u703B\u703C\u703D\u703E\u703F\u7040\u7041\u7042\u7043\u7044\u7045\u7046\u7047\u7048\u7049\u704A\u704B\u704D\u704E\u7050\u7051\u7052\u7053\u7054\u7055\u7056\u7057\u7058\u7059\u705A\u705B\u705C\u705D\u705F\u7060\u7061\u7062\u7063\u7064\u7065\u7066\u7067\u7068\u7069\u706A\u706E\u7071\u7072\u7073\u7074\u7077\u7079\u707A\u707B\u707D\u7081\u7082\u7083\u7084\u7086\u7087\u7088\u708B\u708C\u708D\u708F\u7090\u7091\u7093\u7097\u7098\u709A\u709B\u709E\u709F\u70A0\u70A1\u70A2\u70A3\u70A4\u70A5\u70A6\u70A7\u70A8\u70A9\u70AA\u70B0\u70B2\u70B4\u70B5\u70B6\u70BA\u70BE\u70BF\u70C4\u70C5\u70C6\u70C7\u70C9\u70CB\u70CC\u70CD\u70CE\u70CF\u70D0\u70D1\u70D2\u70D3\u70D4\u70D5\u70D6\u70D7\u70DA\uFFFD".split("");
    for(j = 0; j != D[158].length; ++j)if (D[158][j].charCodeAt(0) !== 0xFFFD) {
        e[D[158][j]] = 40448 + j;
        d[40448 + j] = D[158][j];
    }
    D[159] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u70DC\u70DD\u70DE\u70E0\u70E1\u70E2\u70E3\u70E5\u70EA\u70EE\u70F0\u70F1\u70F2\u70F3\u70F4\u70F5\u70F6\u70F8\u70FA\u70FB\u70FC\u70FE\u70FF\u7100\u7101\u7102\u7103\u7104\u7105\u7106\u7107\u7108\u710B\u710C\u710D\u710E\u710F\u7111\u7112\u7114\u7117\u711B\u711C\u711D\u711E\u711F\u7120\u7121\u7122\u7123\u7124\u7125\u7127\u7128\u7129\u712A\u712B\u712C\u712D\u712E\u7132\u7133\u7134\uFFFD\u7135\u7137\u7138\u7139\u713A\u713B\u713C\u713D\u713E\u713F\u7140\u7141\u7142\u7143\u7144\u7146\u7147\u7148\u7149\u714B\u714D\u714F\u7150\u7151\u7152\u7153\u7154\u7155\u7156\u7157\u7158\u7159\u715A\u715B\u715D\u715F\u7160\u7161\u7162\u7163\u7165\u7169\u716A\u716B\u716C\u716D\u716F\u7170\u7171\u7174\u7175\u7176\u7177\u7179\u717B\u717C\u717E\u717F\u7180\u7181\u7182\u7183\u7185\u7186\u7187\u7188\u7189\u718B\u718C\u718D\u718E\u7190\u7191\u7192\u7193\u7195\u7196\u7197\u719A\u719B\u719C\u719D\u719E\u71A1\u71A2\u71A3\u71A4\u71A5\u71A6\u71A7\u71A9\u71AA\u71AB\u71AD\u71AE\u71AF\u71B0\u71B1\u71B2\u71B4\u71B6\u71B7\u71B8\u71BA\u71BB\u71BC\u71BD\u71BE\u71BF\u71C0\u71C1\u71C2\u71C4\u71C5\u71C6\u71C7\u71C8\u71C9\u71CA\u71CB\u71CC\u71CD\u71CF\u71D0\u71D1\u71D2\u71D3\uFFFD".split("");
    for(j = 0; j != D[159].length; ++j)if (D[159][j].charCodeAt(0) !== 0xFFFD) {
        e[D[159][j]] = 40704 + j;
        d[40704 + j] = D[159][j];
    }
    D[160] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u71D6\u71D7\u71D8\u71D9\u71DA\u71DB\u71DC\u71DD\u71DE\u71DF\u71E1\u71E2\u71E3\u71E4\u71E6\u71E8\u71E9\u71EA\u71EB\u71EC\u71ED\u71EF\u71F0\u71F1\u71F2\u71F3\u71F4\u71F5\u71F6\u71F7\u71F8\u71FA\u71FB\u71FC\u71FD\u71FE\u71FF\u7200\u7201\u7202\u7203\u7204\u7205\u7207\u7208\u7209\u720A\u720B\u720C\u720D\u720E\u720F\u7210\u7211\u7212\u7213\u7214\u7215\u7216\u7217\u7218\u7219\u721A\uFFFD\u721B\u721C\u721E\u721F\u7220\u7221\u7222\u7223\u7224\u7225\u7226\u7227\u7229\u722B\u722D\u722E\u722F\u7232\u7233\u7234\u723A\u723C\u723E\u7240\u7241\u7242\u7243\u7244\u7245\u7246\u7249\u724A\u724B\u724E\u724F\u7250\u7251\u7253\u7254\u7255\u7257\u7258\u725A\u725C\u725E\u7260\u7263\u7264\u7265\u7268\u726A\u726B\u726C\u726D\u7270\u7271\u7273\u7274\u7276\u7277\u7278\u727B\u727C\u727D\u7282\u7283\u7285\u7286\u7287\u7288\u7289\u728C\u728E\u7290\u7291\u7293\u7294\u7295\u7296\u7297\u7298\u7299\u729A\u729B\u729C\u729D\u729E\u72A0\u72A1\u72A2\u72A3\u72A4\u72A5\u72A6\u72A7\u72A8\u72A9\u72AA\u72AB\u72AE\u72B1\u72B2\u72B3\u72B5\u72BA\u72BB\u72BC\u72BD\u72BE\u72BF\u72C0\u72C5\u72C6\u72C7\u72C9\u72CA\u72CB\u72CC\u72CF\u72D1\u72D3\u72D4\u72D5\u72D6\u72D8\u72DA\u72DB\uFFFD".split("");
    for(j = 0; j != D[160].length; ++j)if (D[160][j].charCodeAt(0) !== 0xFFFD) {
        e[D[160][j]] = 40960 + j;
        d[40960 + j] = D[160][j];
    }
    D[161] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u3000\u3001\u3002\xb7\u02C9\u02C7\xa8\u3003\u3005\u2014\uFF5E\u2016\u2026\u2018\u2019\u201C\u201D\u3014\u3015\u3008\u3009\u300A\u300B\u300C\u300D\u300E\u300F\u3016\u3017\u3010\u3011\xb1\xd7\xf7\u2236\u2227\u2228\u2211\u220F\u222A\u2229\u2208\u2237\u221A\u22A5\u2225\u2220\u2312\u2299\u222B\u222E\u2261\u224C\u2248\u223D\u221D\u2260\u226E\u226F\u2264\u2265\u221E\u2235\u2234\u2642\u2640\xb0\u2032\u2033\u2103\uFF04\xa4\uFFE0\uFFE1\u2030\xa7\u2116\u2606\u2605\u25CB\u25CF\u25CE\u25C7\u25C6\u25A1\u25A0\u25B3\u25B2\u203B\u2192\u2190\u2191\u2193\u3013\uFFFD".split("");
    for(j = 0; j != D[161].length; ++j)if (D[161][j].charCodeAt(0) !== 0xFFFD) {
        e[D[161][j]] = 41216 + j;
        d[41216 + j] = D[161][j];
    }
    D[162] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2170\u2171\u2172\u2173\u2174\u2175\u2176\u2177\u2178\u2179\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2488\u2489\u248A\u248B\u248C\u248D\u248E\u248F\u2490\u2491\u2492\u2493\u2494\u2495\u2496\u2497\u2498\u2499\u249A\u249B\u2474\u2475\u2476\u2477\u2478\u2479\u247A\u247B\u247C\u247D\u247E\u247F\u2480\u2481\u2482\u2483\u2484\u2485\u2486\u2487\u2460\u2461\u2462\u2463\u2464\u2465\u2466\u2467\u2468\u2469\uFFFD\uFFFD\u3220\u3221\u3222\u3223\u3224\u3225\u3226\u3227\u3228\u3229\uFFFD\uFFFD\u2160\u2161\u2162\u2163\u2164\u2165\u2166\u2167\u2168\u2169\u216A\u216B\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[162].length; ++j)if (D[162][j].charCodeAt(0) !== 0xFFFD) {
        e[D[162][j]] = 41472 + j;
        d[41472 + j] = D[162][j];
    }
    D[163] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFF01\uFF02\uFF03\uFFE5\uFF05\uFF06\uFF07\uFF08\uFF09\uFF0A\uFF0B\uFF0C\uFF0D\uFF0E\uFF0F\uFF10\uFF11\uFF12\uFF13\uFF14\uFF15\uFF16\uFF17\uFF18\uFF19\uFF1A\uFF1B\uFF1C\uFF1D\uFF1E\uFF1F\uFF20\uFF21\uFF22\uFF23\uFF24\uFF25\uFF26\uFF27\uFF28\uFF29\uFF2A\uFF2B\uFF2C\uFF2D\uFF2E\uFF2F\uFF30\uFF31\uFF32\uFF33\uFF34\uFF35\uFF36\uFF37\uFF38\uFF39\uFF3A\uFF3B\uFF3C\uFF3D\uFF3E\uFF3F\uFF40\uFF41\uFF42\uFF43\uFF44\uFF45\uFF46\uFF47\uFF48\uFF49\uFF4A\uFF4B\uFF4C\uFF4D\uFF4E\uFF4F\uFF50\uFF51\uFF52\uFF53\uFF54\uFF55\uFF56\uFF57\uFF58\uFF59\uFF5A\uFF5B\uFF5C\uFF5D\uFFE3\uFFFD".split("");
    for(j = 0; j != D[163].length; ++j)if (D[163][j].charCodeAt(0) !== 0xFFFD) {
        e[D[163][j]] = 41728 + j;
        d[41728 + j] = D[163][j];
    }
    D[164] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u3041\u3042\u3043\u3044\u3045\u3046\u3047\u3048\u3049\u304A\u304B\u304C\u304D\u304E\u304F\u3050\u3051\u3052\u3053\u3054\u3055\u3056\u3057\u3058\u3059\u305A\u305B\u305C\u305D\u305E\u305F\u3060\u3061\u3062\u3063\u3064\u3065\u3066\u3067\u3068\u3069\u306A\u306B\u306C\u306D\u306E\u306F\u3070\u3071\u3072\u3073\u3074\u3075\u3076\u3077\u3078\u3079\u307A\u307B\u307C\u307D\u307E\u307F\u3080\u3081\u3082\u3083\u3084\u3085\u3086\u3087\u3088\u3089\u308A\u308B\u308C\u308D\u308E\u308F\u3090\u3091\u3092\u3093\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[164].length; ++j)if (D[164][j].charCodeAt(0) !== 0xFFFD) {
        e[D[164][j]] = 41984 + j;
        d[41984 + j] = D[164][j];
    }
    D[165] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u30A1\u30A2\u30A3\u30A4\u30A5\u30A6\u30A7\u30A8\u30A9\u30AA\u30AB\u30AC\u30AD\u30AE\u30AF\u30B0\u30B1\u30B2\u30B3\u30B4\u30B5\u30B6\u30B7\u30B8\u30B9\u30BA\u30BB\u30BC\u30BD\u30BE\u30BF\u30C0\u30C1\u30C2\u30C3\u30C4\u30C5\u30C6\u30C7\u30C8\u30C9\u30CA\u30CB\u30CC\u30CD\u30CE\u30CF\u30D0\u30D1\u30D2\u30D3\u30D4\u30D5\u30D6\u30D7\u30D8\u30D9\u30DA\u30DB\u30DC\u30DD\u30DE\u30DF\u30E0\u30E1\u30E2\u30E3\u30E4\u30E5\u30E6\u30E7\u30E8\u30E9\u30EA\u30EB\u30EC\u30ED\u30EE\u30EF\u30F0\u30F1\u30F2\u30F3\u30F4\u30F5\u30F6\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[165].length; ++j)if (D[165][j].charCodeAt(0) !== 0xFFFD) {
        e[D[165][j]] = 42240 + j;
        d[42240 + j] = D[165][j];
    }
    D[166] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0391\u0392\u0393\u0394\u0395\u0396\u0397\u0398\u0399\u039A\u039B\u039C\u039D\u039E\u039F\u03A0\u03A1\u03A3\u03A4\u03A5\u03A6\u03A7\u03A8\u03A9\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u03B1\u03B2\u03B3\u03B4\u03B5\u03B6\u03B7\u03B8\u03B9\u03BA\u03BB\u03BC\u03BD\u03BE\u03BF\u03C0\u03C1\u03C3\u03C4\u03C5\u03C6\u03C7\u03C8\u03C9\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFE35\uFE36\uFE39\uFE3A\uFE3F\uFE40\uFE3D\uFE3E\uFE41\uFE42\uFE43\uFE44\uFFFD\uFFFD\uFE3B\uFE3C\uFE37\uFE38\uFE31\uFFFD\uFE33\uFE34\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[166].length; ++j)if (D[166][j].charCodeAt(0) !== 0xFFFD) {
        e[D[166][j]] = 42496 + j;
        d[42496 + j] = D[166][j];
    }
    D[167] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0410\u0411\u0412\u0413\u0414\u0415\u0401\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0430\u0431\u0432\u0433\u0434\u0435\u0451\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[167].length; ++j)if (D[167][j].charCodeAt(0) !== 0xFFFD) {
        e[D[167][j]] = 42752 + j;
        d[42752 + j] = D[167][j];
    }
    D[168] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u02CA\u02CB\u02D9\u2013\u2015\u2025\u2035\u2105\u2109\u2196\u2197\u2198\u2199\u2215\u221F\u2223\u2252\u2266\u2267\u22BF\u2550\u2551\u2552\u2553\u2554\u2555\u2556\u2557\u2558\u2559\u255A\u255B\u255C\u255D\u255E\u255F\u2560\u2561\u2562\u2563\u2564\u2565\u2566\u2567\u2568\u2569\u256A\u256B\u256C\u256D\u256E\u256F\u2570\u2571\u2572\u2573\u2581\u2582\u2583\u2584\u2585\u2586\u2587\uFFFD\u2588\u2589\u258A\u258B\u258C\u258D\u258E\u258F\u2593\u2594\u2595\u25BC\u25BD\u25E2\u25E3\u25E4\u25E5\u2609\u2295\u3012\u301D\u301E\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0101\xe1\u01CE\xe0\u0113\xe9\u011B\xe8\u012B\xed\u01D0\xec\u014D\xf3\u01D2\xf2\u016B\xfa\u01D4\xf9\u01D6\u01D8\u01DA\u01DC\xfc\xea\u0251\uFFFD\u0144\u0148\uFFFD\u0261\uFFFD\uFFFD\uFFFD\uFFFD\u3105\u3106\u3107\u3108\u3109\u310A\u310B\u310C\u310D\u310E\u310F\u3110\u3111\u3112\u3113\u3114\u3115\u3116\u3117\u3118\u3119\u311A\u311B\u311C\u311D\u311E\u311F\u3120\u3121\u3122\u3123\u3124\u3125\u3126\u3127\u3128\u3129\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[168].length; ++j)if (D[168][j].charCodeAt(0) !== 0xFFFD) {
        e[D[168][j]] = 43008 + j;
        d[43008 + j] = D[168][j];
    }
    D[169] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u3021\u3022\u3023\u3024\u3025\u3026\u3027\u3028\u3029\u32A3\u338E\u338F\u339C\u339D\u339E\u33A1\u33C4\u33CE\u33D1\u33D2\u33D5\uFE30\uFFE2\uFFE4\uFFFD\u2121\u3231\uFFFD\u2010\uFFFD\uFFFD\uFFFD\u30FC\u309B\u309C\u30FD\u30FE\u3006\u309D\u309E\uFE49\uFE4A\uFE4B\uFE4C\uFE4D\uFE4E\uFE4F\uFE50\uFE51\uFE52\uFE54\uFE55\uFE56\uFE57\uFE59\uFE5A\uFE5B\uFE5C\uFE5D\uFE5E\uFE5F\uFE60\uFE61\uFFFD\uFE62\uFE63\uFE64\uFE65\uFE66\uFE68\uFE69\uFE6A\uFE6B\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u3007\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2500\u2501\u2502\u2503\u2504\u2505\u2506\u2507\u2508\u2509\u250A\u250B\u250C\u250D\u250E\u250F\u2510\u2511\u2512\u2513\u2514\u2515\u2516\u2517\u2518\u2519\u251A\u251B\u251C\u251D\u251E\u251F\u2520\u2521\u2522\u2523\u2524\u2525\u2526\u2527\u2528\u2529\u252A\u252B\u252C\u252D\u252E\u252F\u2530\u2531\u2532\u2533\u2534\u2535\u2536\u2537\u2538\u2539\u253A\u253B\u253C\u253D\u253E\u253F\u2540\u2541\u2542\u2543\u2544\u2545\u2546\u2547\u2548\u2549\u254A\u254B\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[169].length; ++j)if (D[169][j].charCodeAt(0) !== 0xFFFD) {
        e[D[169][j]] = 43264 + j;
        d[43264 + j] = D[169][j];
    }
    D[170] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u72DC\u72DD\u72DF\u72E2\u72E3\u72E4\u72E5\u72E6\u72E7\u72EA\u72EB\u72F5\u72F6\u72F9\u72FD\u72FE\u72FF\u7300\u7302\u7304\u7305\u7306\u7307\u7308\u7309\u730B\u730C\u730D\u730F\u7310\u7311\u7312\u7314\u7318\u7319\u731A\u731F\u7320\u7323\u7324\u7326\u7327\u7328\u732D\u732F\u7330\u7332\u7333\u7335\u7336\u733A\u733B\u733C\u733D\u7340\u7341\u7342\u7343\u7344\u7345\u7346\u7347\u7348\uFFFD\u7349\u734A\u734B\u734C\u734E\u734F\u7351\u7353\u7354\u7355\u7356\u7358\u7359\u735A\u735B\u735C\u735D\u735E\u735F\u7361\u7362\u7363\u7364\u7365\u7366\u7367\u7368\u7369\u736A\u736B\u736E\u7370\u7371\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[170].length; ++j)if (D[170][j].charCodeAt(0) !== 0xFFFD) {
        e[D[170][j]] = 43520 + j;
        d[43520 + j] = D[170][j];
    }
    D[171] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7372\u7373\u7374\u7375\u7376\u7377\u7378\u7379\u737A\u737B\u737C\u737D\u737F\u7380\u7381\u7382\u7383\u7385\u7386\u7388\u738A\u738C\u738D\u738F\u7390\u7392\u7393\u7394\u7395\u7397\u7398\u7399\u739A\u739C\u739D\u739E\u73A0\u73A1\u73A3\u73A4\u73A5\u73A6\u73A7\u73A8\u73AA\u73AC\u73AD\u73B1\u73B4\u73B5\u73B6\u73B8\u73B9\u73BC\u73BD\u73BE\u73BF\u73C1\u73C3\u73C4\u73C5\u73C6\u73C7\uFFFD\u73CB\u73CC\u73CE\u73D2\u73D3\u73D4\u73D5\u73D6\u73D7\u73D8\u73DA\u73DB\u73DC\u73DD\u73DF\u73E1\u73E2\u73E3\u73E4\u73E6\u73E8\u73EA\u73EB\u73EC\u73EE\u73EF\u73F0\u73F1\u73F3\u73F4\u73F5\u73F6\u73F7\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[171].length; ++j)if (D[171][j].charCodeAt(0) !== 0xFFFD) {
        e[D[171][j]] = 43776 + j;
        d[43776 + j] = D[171][j];
    }
    D[172] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u73F8\u73F9\u73FA\u73FB\u73FC\u73FD\u73FE\u73FF\u7400\u7401\u7402\u7404\u7407\u7408\u740B\u740C\u740D\u740E\u7411\u7412\u7413\u7414\u7415\u7416\u7417\u7418\u7419\u741C\u741D\u741E\u741F\u7420\u7421\u7423\u7424\u7427\u7429\u742B\u742D\u742F\u7431\u7432\u7437\u7438\u7439\u743A\u743B\u743D\u743E\u743F\u7440\u7442\u7443\u7444\u7445\u7446\u7447\u7448\u7449\u744A\u744B\u744C\u744D\uFFFD\u744E\u744F\u7450\u7451\u7452\u7453\u7454\u7456\u7458\u745D\u7460\u7461\u7462\u7463\u7464\u7465\u7466\u7467\u7468\u7469\u746A\u746B\u746C\u746E\u746F\u7471\u7472\u7473\u7474\u7475\u7478\u7479\u747A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[172].length; ++j)if (D[172][j].charCodeAt(0) !== 0xFFFD) {
        e[D[172][j]] = 44032 + j;
        d[44032 + j] = D[172][j];
    }
    D[173] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u747B\u747C\u747D\u747F\u7482\u7484\u7485\u7486\u7488\u7489\u748A\u748C\u748D\u748F\u7491\u7492\u7493\u7494\u7495\u7496\u7497\u7498\u7499\u749A\u749B\u749D\u749F\u74A0\u74A1\u74A2\u74A3\u74A4\u74A5\u74A6\u74AA\u74AB\u74AC\u74AD\u74AE\u74AF\u74B0\u74B1\u74B2\u74B3\u74B4\u74B5\u74B6\u74B7\u74B8\u74B9\u74BB\u74BC\u74BD\u74BE\u74BF\u74C0\u74C1\u74C2\u74C3\u74C4\u74C5\u74C6\u74C7\uFFFD\u74C8\u74C9\u74CA\u74CB\u74CC\u74CD\u74CE\u74CF\u74D0\u74D1\u74D3\u74D4\u74D5\u74D6\u74D7\u74D8\u74D9\u74DA\u74DB\u74DD\u74DF\u74E1\u74E5\u74E7\u74E8\u74E9\u74EA\u74EB\u74EC\u74ED\u74F0\u74F1\u74F2\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[173].length; ++j)if (D[173][j].charCodeAt(0) !== 0xFFFD) {
        e[D[173][j]] = 44288 + j;
        d[44288 + j] = D[173][j];
    }
    D[174] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u74F3\u74F5\u74F8\u74F9\u74FA\u74FB\u74FC\u74FD\u74FE\u7500\u7501\u7502\u7503\u7505\u7506\u7507\u7508\u7509\u750A\u750B\u750C\u750E\u7510\u7512\u7514\u7515\u7516\u7517\u751B\u751D\u751E\u7520\u7521\u7522\u7523\u7524\u7526\u7527\u752A\u752E\u7534\u7536\u7539\u753C\u753D\u753F\u7541\u7542\u7543\u7544\u7546\u7547\u7549\u754A\u754D\u7550\u7551\u7552\u7553\u7555\u7556\u7557\u7558\uFFFD\u755D\u755E\u755F\u7560\u7561\u7562\u7563\u7564\u7567\u7568\u7569\u756B\u756C\u756D\u756E\u756F\u7570\u7571\u7573\u7575\u7576\u7577\u757A\u757B\u757C\u757D\u757E\u7580\u7581\u7582\u7584\u7585\u7587\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[174].length; ++j)if (D[174][j].charCodeAt(0) !== 0xFFFD) {
        e[D[174][j]] = 44544 + j;
        d[44544 + j] = D[174][j];
    }
    D[175] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7588\u7589\u758A\u758C\u758D\u758E\u7590\u7593\u7595\u7598\u759B\u759C\u759E\u75A2\u75A6\u75A7\u75A8\u75A9\u75AA\u75AD\u75B6\u75B7\u75BA\u75BB\u75BF\u75C0\u75C1\u75C6\u75CB\u75CC\u75CE\u75CF\u75D0\u75D1\u75D3\u75D7\u75D9\u75DA\u75DC\u75DD\u75DF\u75E0\u75E1\u75E5\u75E9\u75EC\u75ED\u75EE\u75EF\u75F2\u75F3\u75F5\u75F6\u75F7\u75F8\u75FA\u75FB\u75FD\u75FE\u7602\u7604\u7606\u7607\uFFFD\u7608\u7609\u760B\u760D\u760E\u760F\u7611\u7612\u7613\u7614\u7616\u761A\u761C\u761D\u761E\u7621\u7623\u7627\u7628\u762C\u762E\u762F\u7631\u7632\u7636\u7637\u7639\u763A\u763B\u763D\u7641\u7642\u7644\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[175].length; ++j)if (D[175][j].charCodeAt(0) !== 0xFFFD) {
        e[D[175][j]] = 44800 + j;
        d[44800 + j] = D[175][j];
    }
    D[176] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7645\u7646\u7647\u7648\u7649\u764A\u764B\u764E\u764F\u7650\u7651\u7652\u7653\u7655\u7657\u7658\u7659\u765A\u765B\u765D\u765F\u7660\u7661\u7662\u7664\u7665\u7666\u7667\u7668\u7669\u766A\u766C\u766D\u766E\u7670\u7671\u7672\u7673\u7674\u7675\u7676\u7677\u7679\u767A\u767C\u767F\u7680\u7681\u7683\u7685\u7689\u768A\u768C\u768D\u768F\u7690\u7692\u7694\u7695\u7697\u7698\u769A\u769B\uFFFD\u769C\u769D\u769E\u769F\u76A0\u76A1\u76A2\u76A3\u76A5\u76A6\u76A7\u76A8\u76A9\u76AA\u76AB\u76AC\u76AD\u76AF\u76B0\u76B3\u76B5\u76B6\u76B7\u76B8\u76B9\u76BA\u76BB\u76BC\u76BD\u76BE\u76C0\u76C1\u76C3\u554A\u963F\u57C3\u6328\u54CE\u5509\u54C0\u7691\u764C\u853C\u77EE\u827E\u788D\u7231\u9698\u978D\u6C28\u5B89\u4FFA\u6309\u6697\u5CB8\u80FA\u6848\u80AE\u6602\u76CE\u51F9\u6556\u71AC\u7FF1\u8884\u50B2\u5965\u61CA\u6FB3\u82AD\u634C\u6252\u53ED\u5427\u7B06\u516B\u75A4\u5DF4\u62D4\u8DCB\u9776\u628A\u8019\u575D\u9738\u7F62\u7238\u767D\u67CF\u767E\u6446\u4F70\u8D25\u62DC\u7A17\u6591\u73ED\u642C\u6273\u822C\u9881\u677F\u7248\u626E\u62CC\u4F34\u74E3\u534A\u529E\u7ECA\u90A6\u5E2E\u6886\u699C\u8180\u7ED1\u68D2\u78C5\u868C\u9551\u508D\u8C24\u82DE\u80DE\u5305\u8912\u5265\uFFFD".split("");
    for(j = 0; j != D[176].length; ++j)if (D[176][j].charCodeAt(0) !== 0xFFFD) {
        e[D[176][j]] = 45056 + j;
        d[45056 + j] = D[176][j];
    }
    D[177] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u76C4\u76C7\u76C9\u76CB\u76CC\u76D3\u76D5\u76D9\u76DA\u76DC\u76DD\u76DE\u76E0\u76E1\u76E2\u76E3\u76E4\u76E6\u76E7\u76E8\u76E9\u76EA\u76EB\u76EC\u76ED\u76F0\u76F3\u76F5\u76F6\u76F7\u76FA\u76FB\u76FD\u76FF\u7700\u7702\u7703\u7705\u7706\u770A\u770C\u770E\u770F\u7710\u7711\u7712\u7713\u7714\u7715\u7716\u7717\u7718\u771B\u771C\u771D\u771E\u7721\u7723\u7724\u7725\u7727\u772A\u772B\uFFFD\u772C\u772E\u7730\u7731\u7732\u7733\u7734\u7739\u773B\u773D\u773E\u773F\u7742\u7744\u7745\u7746\u7748\u7749\u774A\u774B\u774C\u774D\u774E\u774F\u7752\u7753\u7754\u7755\u7756\u7757\u7758\u7759\u775C\u8584\u96F9\u4FDD\u5821\u9971\u5B9D\u62B1\u62A5\u66B4\u8C79\u9C8D\u7206\u676F\u7891\u60B2\u5351\u5317\u8F88\u80CC\u8D1D\u94A1\u500D\u72C8\u5907\u60EB\u7119\u88AB\u5954\u82EF\u672C\u7B28\u5D29\u7EF7\u752D\u6CF5\u8E66\u8FF8\u903C\u9F3B\u6BD4\u9119\u7B14\u5F7C\u78A7\u84D6\u853D\u6BD5\u6BD9\u6BD6\u5E01\u5E87\u75F9\u95ED\u655D\u5F0A\u5FC5\u8F9F\u58C1\u81C2\u907F\u965B\u97AD\u8FB9\u7F16\u8D2C\u6241\u4FBF\u53D8\u535E\u8FA8\u8FA9\u8FAB\u904D\u6807\u5F6A\u8198\u8868\u9CD6\u618B\u522B\u762A\u5F6C\u658C\u6FD2\u6EE8\u5BBE\u6448\u5175\u51B0\u67C4\u4E19\u79C9\u997C\u70B3\uFFFD".split("");
    for(j = 0; j != D[177].length; ++j)if (D[177][j].charCodeAt(0) !== 0xFFFD) {
        e[D[177][j]] = 45312 + j;
        d[45312 + j] = D[177][j];
    }
    D[178] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u775D\u775E\u775F\u7760\u7764\u7767\u7769\u776A\u776D\u776E\u776F\u7770\u7771\u7772\u7773\u7774\u7775\u7776\u7777\u7778\u777A\u777B\u777C\u7781\u7782\u7783\u7786\u7787\u7788\u7789\u778A\u778B\u778F\u7790\u7793\u7794\u7795\u7796\u7797\u7798\u7799\u779A\u779B\u779C\u779D\u779E\u77A1\u77A3\u77A4\u77A6\u77A8\u77AB\u77AD\u77AE\u77AF\u77B1\u77B2\u77B4\u77B6\u77B7\u77B8\u77B9\u77BA\uFFFD\u77BC\u77BE\u77C0\u77C1\u77C2\u77C3\u77C4\u77C5\u77C6\u77C7\u77C8\u77C9\u77CA\u77CB\u77CC\u77CE\u77CF\u77D0\u77D1\u77D2\u77D3\u77D4\u77D5\u77D6\u77D8\u77D9\u77DA\u77DD\u77DE\u77DF\u77E0\u77E1\u77E4\u75C5\u5E76\u73BB\u83E0\u64AD\u62E8\u94B5\u6CE2\u535A\u52C3\u640F\u94C2\u7B94\u4F2F\u5E1B\u8236\u8116\u818A\u6E24\u6CCA\u9A73\u6355\u535C\u54FA\u8865\u57E0\u4E0D\u5E03\u6B65\u7C3F\u90E8\u6016\u64E6\u731C\u88C1\u6750\u624D\u8D22\u776C\u8E29\u91C7\u5F69\u83DC\u8521\u9910\u53C2\u8695\u6B8B\u60ED\u60E8\u707F\u82CD\u8231\u4ED3\u6CA7\u85CF\u64CD\u7CD9\u69FD\u66F9\u8349\u5395\u7B56\u4FA7\u518C\u6D4B\u5C42\u8E6D\u63D2\u53C9\u832C\u8336\u67E5\u78B4\u643D\u5BDF\u5C94\u5DEE\u8BE7\u62C6\u67F4\u8C7A\u6400\u63BA\u8749\u998B\u8C17\u7F20\u94F2\u4EA7\u9610\u98A4\u660C\u7316\uFFFD".split("");
    for(j = 0; j != D[178].length; ++j)if (D[178][j].charCodeAt(0) !== 0xFFFD) {
        e[D[178][j]] = 45568 + j;
        d[45568 + j] = D[178][j];
    }
    D[179] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u77E6\u77E8\u77EA\u77EF\u77F0\u77F1\u77F2\u77F4\u77F5\u77F7\u77F9\u77FA\u77FB\u77FC\u7803\u7804\u7805\u7806\u7807\u7808\u780A\u780B\u780E\u780F\u7810\u7813\u7815\u7819\u781B\u781E\u7820\u7821\u7822\u7824\u7828\u782A\u782B\u782E\u782F\u7831\u7832\u7833\u7835\u7836\u783D\u783F\u7841\u7842\u7843\u7844\u7846\u7848\u7849\u784A\u784B\u784D\u784F\u7851\u7853\u7854\u7858\u7859\u785A\uFFFD\u785B\u785C\u785E\u785F\u7860\u7861\u7862\u7863\u7864\u7865\u7866\u7867\u7868\u7869\u786F\u7870\u7871\u7872\u7873\u7874\u7875\u7876\u7878\u7879\u787A\u787B\u787D\u787E\u787F\u7880\u7881\u7882\u7883\u573A\u5C1D\u5E38\u957F\u507F\u80A0\u5382\u655E\u7545\u5531\u5021\u8D85\u6284\u949E\u671D\u5632\u6F6E\u5DE2\u5435\u7092\u8F66\u626F\u64A4\u63A3\u5F7B\u6F88\u90F4\u81E3\u8FB0\u5C18\u6668\u5FF1\u6C89\u9648\u8D81\u886C\u6491\u79F0\u57CE\u6A59\u6210\u5448\u4E58\u7A0B\u60E9\u6F84\u8BDA\u627F\u901E\u9A8B\u79E4\u5403\u75F4\u6301\u5319\u6C60\u8FDF\u5F1B\u9A70\u803B\u9F7F\u4F88\u5C3A\u8D64\u7FC5\u65A5\u70BD\u5145\u51B2\u866B\u5D07\u5BA0\u62BD\u916C\u7574\u8E0C\u7A20\u6101\u7B79\u4EC7\u7EF8\u7785\u4E11\u81ED\u521D\u51FA\u6A71\u53A8\u8E87\u9504\u96CF\u6EC1\u9664\u695A\uFFFD".split("");
    for(j = 0; j != D[179].length; ++j)if (D[179][j].charCodeAt(0) !== 0xFFFD) {
        e[D[179][j]] = 45824 + j;
        d[45824 + j] = D[179][j];
    }
    D[180] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7884\u7885\u7886\u7888\u788A\u788B\u788F\u7890\u7892\u7894\u7895\u7896\u7899\u789D\u789E\u78A0\u78A2\u78A4\u78A6\u78A8\u78A9\u78AA\u78AB\u78AC\u78AD\u78AE\u78AF\u78B5\u78B6\u78B7\u78B8\u78BA\u78BB\u78BC\u78BD\u78BF\u78C0\u78C2\u78C3\u78C4\u78C6\u78C7\u78C8\u78CC\u78CD\u78CE\u78CF\u78D1\u78D2\u78D3\u78D6\u78D7\u78D8\u78DA\u78DB\u78DC\u78DD\u78DE\u78DF\u78E0\u78E1\u78E2\u78E3\uFFFD\u78E4\u78E5\u78E6\u78E7\u78E9\u78EA\u78EB\u78ED\u78EE\u78EF\u78F0\u78F1\u78F3\u78F5\u78F6\u78F8\u78F9\u78FB\u78FC\u78FD\u78FE\u78FF\u7900\u7902\u7903\u7904\u7906\u7907\u7908\u7909\u790A\u790B\u790C\u7840\u50A8\u77D7\u6410\u89E6\u5904\u63E3\u5DDD\u7A7F\u693D\u4F20\u8239\u5598\u4E32\u75AE\u7A97\u5E62\u5E8A\u95EF\u521B\u5439\u708A\u6376\u9524\u5782\u6625\u693F\u9187\u5507\u6DF3\u7EAF\u8822\u6233\u7EF0\u75B5\u8328\u78C1\u96CC\u8F9E\u6148\u74F7\u8BCD\u6B64\u523A\u8D50\u6B21\u806A\u8471\u56F1\u5306\u4ECE\u4E1B\u51D1\u7C97\u918B\u7C07\u4FC3\u8E7F\u7BE1\u7A9C\u6467\u5D14\u50AC\u8106\u7601\u7CB9\u6DEC\u7FE0\u6751\u5B58\u5BF8\u78CB\u64AE\u6413\u63AA\u632B\u9519\u642D\u8FBE\u7B54\u7629\u6253\u5927\u5446\u6B79\u50A3\u6234\u5E26\u6B86\u4EE3\u8D37\u888B\u5F85\u902E\uFFFD".split("");
    for(j = 0; j != D[180].length; ++j)if (D[180][j].charCodeAt(0) !== 0xFFFD) {
        e[D[180][j]] = 46080 + j;
        d[46080 + j] = D[180][j];
    }
    D[181] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u790D\u790E\u790F\u7910\u7911\u7912\u7914\u7915\u7916\u7917\u7918\u7919\u791A\u791B\u791C\u791D\u791F\u7920\u7921\u7922\u7923\u7925\u7926\u7927\u7928\u7929\u792A\u792B\u792C\u792D\u792E\u792F\u7930\u7931\u7932\u7933\u7935\u7936\u7937\u7938\u7939\u793D\u793F\u7942\u7943\u7944\u7945\u7947\u794A\u794B\u794C\u794D\u794E\u794F\u7950\u7951\u7952\u7954\u7955\u7958\u7959\u7961\u7963\uFFFD\u7964\u7966\u7969\u796A\u796B\u796C\u796E\u7970\u7971\u7972\u7973\u7974\u7975\u7976\u7979\u797B\u797C\u797D\u797E\u797F\u7982\u7983\u7986\u7987\u7988\u7989\u798B\u798C\u798D\u798E\u7990\u7991\u7992\u6020\u803D\u62C5\u4E39\u5355\u90F8\u63B8\u80C6\u65E6\u6C2E\u4F46\u60EE\u6DE1\u8BDE\u5F39\u86CB\u5F53\u6321\u515A\u8361\u6863\u5200\u6363\u8E48\u5012\u5C9B\u7977\u5BFC\u5230\u7A3B\u60BC\u9053\u76D7\u5FB7\u5F97\u7684\u8E6C\u706F\u767B\u7B49\u77AA\u51F3\u9093\u5824\u4F4E\u6EF4\u8FEA\u654C\u7B1B\u72C4\u6DA4\u7FDF\u5AE1\u62B5\u5E95\u5730\u8482\u7B2C\u5E1D\u5F1F\u9012\u7F14\u98A0\u6382\u6EC7\u7898\u70B9\u5178\u975B\u57AB\u7535\u4F43\u7538\u5E97\u60E6\u5960\u6DC0\u6BBF\u7889\u53FC\u96D5\u51CB\u5201\u6389\u540A\u9493\u8C03\u8DCC\u7239\u789F\u8776\u8FED\u8C0D\u53E0\uFFFD".split("");
    for(j = 0; j != D[181].length; ++j)if (D[181][j].charCodeAt(0) !== 0xFFFD) {
        e[D[181][j]] = 46336 + j;
        d[46336 + j] = D[181][j];
    }
    D[182] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7993\u7994\u7995\u7996\u7997\u7998\u7999\u799B\u799C\u799D\u799E\u799F\u79A0\u79A1\u79A2\u79A3\u79A4\u79A5\u79A6\u79A8\u79A9\u79AA\u79AB\u79AC\u79AD\u79AE\u79AF\u79B0\u79B1\u79B2\u79B4\u79B5\u79B6\u79B7\u79B8\u79BC\u79BF\u79C2\u79C4\u79C5\u79C7\u79C8\u79CA\u79CC\u79CE\u79CF\u79D0\u79D3\u79D4\u79D6\u79D7\u79D9\u79DA\u79DB\u79DC\u79DD\u79DE\u79E0\u79E1\u79E2\u79E5\u79E8\u79EA\uFFFD\u79EC\u79EE\u79F1\u79F2\u79F3\u79F4\u79F5\u79F6\u79F7\u79F9\u79FA\u79FC\u79FE\u79FF\u7A01\u7A04\u7A05\u7A07\u7A08\u7A09\u7A0A\u7A0C\u7A0F\u7A10\u7A11\u7A12\u7A13\u7A15\u7A16\u7A18\u7A19\u7A1B\u7A1C\u4E01\u76EF\u53EE\u9489\u9876\u9F0E\u952D\u5B9A\u8BA2\u4E22\u4E1C\u51AC\u8463\u61C2\u52A8\u680B\u4F97\u606B\u51BB\u6D1E\u515C\u6296\u6597\u9661\u8C46\u9017\u75D8\u90FD\u7763\u6BD2\u728A\u72EC\u8BFB\u5835\u7779\u8D4C\u675C\u9540\u809A\u5EA6\u6E21\u5992\u7AEF\u77ED\u953B\u6BB5\u65AD\u7F0E\u5806\u5151\u961F\u5BF9\u58A9\u5428\u8E72\u6566\u987F\u56E4\u949D\u76FE\u9041\u6387\u54C6\u591A\u593A\u579B\u8EB2\u6735\u8DFA\u8235\u5241\u60F0\u5815\u86FE\u5CE8\u9E45\u4FC4\u989D\u8BB9\u5A25\u6076\u5384\u627C\u904F\u9102\u997F\u6069\u800C\u513F\u8033\u5C14\u9975\u6D31\u4E8C\uFFFD".split("");
    for(j = 0; j != D[182].length; ++j)if (D[182][j].charCodeAt(0) !== 0xFFFD) {
        e[D[182][j]] = 46592 + j;
        d[46592 + j] = D[182][j];
    }
    D[183] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7A1D\u7A1F\u7A21\u7A22\u7A24\u7A25\u7A26\u7A27\u7A28\u7A29\u7A2A\u7A2B\u7A2C\u7A2D\u7A2E\u7A2F\u7A30\u7A31\u7A32\u7A34\u7A35\u7A36\u7A38\u7A3A\u7A3E\u7A40\u7A41\u7A42\u7A43\u7A44\u7A45\u7A47\u7A48\u7A49\u7A4A\u7A4B\u7A4C\u7A4D\u7A4E\u7A4F\u7A50\u7A52\u7A53\u7A54\u7A55\u7A56\u7A58\u7A59\u7A5A\u7A5B\u7A5C\u7A5D\u7A5E\u7A5F\u7A60\u7A61\u7A62\u7A63\u7A64\u7A65\u7A66\u7A67\u7A68\uFFFD\u7A69\u7A6A\u7A6B\u7A6C\u7A6D\u7A6E\u7A6F\u7A71\u7A72\u7A73\u7A75\u7A7B\u7A7C\u7A7D\u7A7E\u7A82\u7A85\u7A87\u7A89\u7A8A\u7A8B\u7A8C\u7A8E\u7A8F\u7A90\u7A93\u7A94\u7A99\u7A9A\u7A9B\u7A9E\u7AA1\u7AA2\u8D30\u53D1\u7F5A\u7B4F\u4F10\u4E4F\u9600\u6CD5\u73D0\u85E9\u5E06\u756A\u7FFB\u6A0A\u77FE\u9492\u7E41\u51E1\u70E6\u53CD\u8FD4\u8303\u8D29\u72AF\u996D\u6CDB\u574A\u82B3\u65B9\u80AA\u623F\u9632\u59A8\u4EFF\u8BBF\u7EBA\u653E\u83F2\u975E\u5561\u98DE\u80A5\u532A\u8BFD\u5420\u80BA\u5E9F\u6CB8\u8D39\u82AC\u915A\u5429\u6C1B\u5206\u7EB7\u575F\u711A\u6C7E\u7C89\u594B\u4EFD\u5FFF\u6124\u7CAA\u4E30\u5C01\u67AB\u8702\u5CF0\u950B\u98CE\u75AF\u70FD\u9022\u51AF\u7F1D\u8BBD\u5949\u51E4\u4F5B\u5426\u592B\u6577\u80A4\u5B75\u6276\u62C2\u8F90\u5E45\u6C1F\u7B26\u4F0F\u4FD8\u670D\uFFFD".split("");
    for(j = 0; j != D[183].length; ++j)if (D[183][j].charCodeAt(0) !== 0xFFFD) {
        e[D[183][j]] = 46848 + j;
        d[46848 + j] = D[183][j];
    }
    D[184] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7AA3\u7AA4\u7AA7\u7AA9\u7AAA\u7AAB\u7AAE\u7AAF\u7AB0\u7AB1\u7AB2\u7AB4\u7AB5\u7AB6\u7AB7\u7AB8\u7AB9\u7ABA\u7ABB\u7ABC\u7ABD\u7ABE\u7AC0\u7AC1\u7AC2\u7AC3\u7AC4\u7AC5\u7AC6\u7AC7\u7AC8\u7AC9\u7ACA\u7ACC\u7ACD\u7ACE\u7ACF\u7AD0\u7AD1\u7AD2\u7AD3\u7AD4\u7AD5\u7AD7\u7AD8\u7ADA\u7ADB\u7ADC\u7ADD\u7AE1\u7AE2\u7AE4\u7AE7\u7AE8\u7AE9\u7AEA\u7AEB\u7AEC\u7AEE\u7AF0\u7AF1\u7AF2\u7AF3\uFFFD\u7AF4\u7AF5\u7AF6\u7AF7\u7AF8\u7AFB\u7AFC\u7AFE\u7B00\u7B01\u7B02\u7B05\u7B07\u7B09\u7B0C\u7B0D\u7B0E\u7B10\u7B12\u7B13\u7B16\u7B17\u7B18\u7B1A\u7B1C\u7B1D\u7B1F\u7B21\u7B22\u7B23\u7B27\u7B29\u7B2D\u6D6E\u6DAA\u798F\u88B1\u5F17\u752B\u629A\u8F85\u4FEF\u91DC\u65A7\u812F\u8151\u5E9C\u8150\u8D74\u526F\u8986\u8D4B\u590D\u5085\u4ED8\u961C\u7236\u8179\u8D1F\u5BCC\u8BA3\u9644\u5987\u7F1A\u5490\u5676\u560E\u8BE5\u6539\u6982\u9499\u76D6\u6E89\u5E72\u7518\u6746\u67D1\u7AFF\u809D\u8D76\u611F\u79C6\u6562\u8D63\u5188\u521A\u94A2\u7F38\u809B\u7EB2\u5C97\u6E2F\u6760\u7BD9\u768B\u9AD8\u818F\u7F94\u7CD5\u641E\u9550\u7A3F\u544A\u54E5\u6B4C\u6401\u6208\u9E3D\u80F3\u7599\u5272\u9769\u845B\u683C\u86E4\u9601\u9694\u94EC\u4E2A\u5404\u7ED9\u6839\u8DDF\u8015\u66F4\u5E9A\u7FB9\uFFFD".split("");
    for(j = 0; j != D[184].length; ++j)if (D[184][j].charCodeAt(0) !== 0xFFFD) {
        e[D[184][j]] = 47104 + j;
        d[47104 + j] = D[184][j];
    }
    D[185] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7B2F\u7B30\u7B32\u7B34\u7B35\u7B36\u7B37\u7B39\u7B3B\u7B3D\u7B3F\u7B40\u7B41\u7B42\u7B43\u7B44\u7B46\u7B48\u7B4A\u7B4D\u7B4E\u7B53\u7B55\u7B57\u7B59\u7B5C\u7B5E\u7B5F\u7B61\u7B63\u7B64\u7B65\u7B66\u7B67\u7B68\u7B69\u7B6A\u7B6B\u7B6C\u7B6D\u7B6F\u7B70\u7B73\u7B74\u7B76\u7B78\u7B7A\u7B7C\u7B7D\u7B7F\u7B81\u7B82\u7B83\u7B84\u7B86\u7B87\u7B88\u7B89\u7B8A\u7B8B\u7B8C\u7B8E\u7B8F\uFFFD\u7B91\u7B92\u7B93\u7B96\u7B98\u7B99\u7B9A\u7B9B\u7B9E\u7B9F\u7BA0\u7BA3\u7BA4\u7BA5\u7BAE\u7BAF\u7BB0\u7BB2\u7BB3\u7BB5\u7BB6\u7BB7\u7BB9\u7BBA\u7BBB\u7BBC\u7BBD\u7BBE\u7BBF\u7BC0\u7BC2\u7BC3\u7BC4\u57C2\u803F\u6897\u5DE5\u653B\u529F\u606D\u9F9A\u4F9B\u8EAC\u516C\u5BAB\u5F13\u5DE9\u6C5E\u62F1\u8D21\u5171\u94A9\u52FE\u6C9F\u82DF\u72D7\u57A2\u6784\u8D2D\u591F\u8F9C\u83C7\u5495\u7B8D\u4F30\u6CBD\u5B64\u59D1\u9F13\u53E4\u86CA\u9AA8\u8C37\u80A1\u6545\u987E\u56FA\u96C7\u522E\u74DC\u5250\u5BE1\u6302\u8902\u4E56\u62D0\u602A\u68FA\u5173\u5B98\u51A0\u89C2\u7BA1\u9986\u7F50\u60EF\u704C\u8D2F\u5149\u5E7F\u901B\u7470\u89C4\u572D\u7845\u5F52\u9F9F\u95FA\u8F68\u9B3C\u8BE1\u7678\u6842\u67DC\u8DEA\u8D35\u523D\u8F8A\u6EDA\u68CD\u9505\u90ED\u56FD\u679C\u88F9\u8FC7\u54C8\uFFFD".split("");
    for(j = 0; j != D[185].length; ++j)if (D[185][j].charCodeAt(0) !== 0xFFFD) {
        e[D[185][j]] = 47360 + j;
        d[47360 + j] = D[185][j];
    }
    D[186] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7BC5\u7BC8\u7BC9\u7BCA\u7BCB\u7BCD\u7BCE\u7BCF\u7BD0\u7BD2\u7BD4\u7BD5\u7BD6\u7BD7\u7BD8\u7BDB\u7BDC\u7BDE\u7BDF\u7BE0\u7BE2\u7BE3\u7BE4\u7BE7\u7BE8\u7BE9\u7BEB\u7BEC\u7BED\u7BEF\u7BF0\u7BF2\u7BF3\u7BF4\u7BF5\u7BF6\u7BF8\u7BF9\u7BFA\u7BFB\u7BFD\u7BFF\u7C00\u7C01\u7C02\u7C03\u7C04\u7C05\u7C06\u7C08\u7C09\u7C0A\u7C0D\u7C0E\u7C10\u7C11\u7C12\u7C13\u7C14\u7C15\u7C17\u7C18\u7C19\uFFFD\u7C1A\u7C1B\u7C1C\u7C1D\u7C1E\u7C20\u7C21\u7C22\u7C23\u7C24\u7C25\u7C28\u7C29\u7C2B\u7C2C\u7C2D\u7C2E\u7C2F\u7C30\u7C31\u7C32\u7C33\u7C34\u7C35\u7C36\u7C37\u7C39\u7C3A\u7C3B\u7C3C\u7C3D\u7C3E\u7C42\u9AB8\u5B69\u6D77\u6C26\u4EA5\u5BB3\u9A87\u9163\u61A8\u90AF\u97E9\u542B\u6DB5\u5BD2\u51FD\u558A\u7F55\u7FF0\u64BC\u634D\u65F1\u61BE\u608D\u710A\u6C57\u6C49\u592F\u676D\u822A\u58D5\u568E\u8C6A\u6BEB\u90DD\u597D\u8017\u53F7\u6D69\u5475\u559D\u8377\u83CF\u6838\u79BE\u548C\u4F55\u5408\u76D2\u8C89\u9602\u6CB3\u6DB8\u8D6B\u8910\u9E64\u8D3A\u563F\u9ED1\u75D5\u5F88\u72E0\u6068\u54FC\u4EA8\u6A2A\u8861\u6052\u8F70\u54C4\u70D8\u8679\u9E3F\u6D2A\u5B8F\u5F18\u7EA2\u5589\u4FAF\u7334\u543C\u539A\u5019\u540E\u547C\u4E4E\u5FFD\u745A\u58F6\u846B\u80E1\u8774\u72D0\u7CCA\u6E56\uFFFD".split("");
    for(j = 0; j != D[186].length; ++j)if (D[186][j].charCodeAt(0) !== 0xFFFD) {
        e[D[186][j]] = 47616 + j;
        d[47616 + j] = D[186][j];
    }
    D[187] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7C43\u7C44\u7C45\u7C46\u7C47\u7C48\u7C49\u7C4A\u7C4B\u7C4C\u7C4E\u7C4F\u7C50\u7C51\u7C52\u7C53\u7C54\u7C55\u7C56\u7C57\u7C58\u7C59\u7C5A\u7C5B\u7C5C\u7C5D\u7C5E\u7C5F\u7C60\u7C61\u7C62\u7C63\u7C64\u7C65\u7C66\u7C67\u7C68\u7C69\u7C6A\u7C6B\u7C6C\u7C6D\u7C6E\u7C6F\u7C70\u7C71\u7C72\u7C75\u7C76\u7C77\u7C78\u7C79\u7C7A\u7C7E\u7C7F\u7C80\u7C81\u7C82\u7C83\u7C84\u7C85\u7C86\u7C87\uFFFD\u7C88\u7C8A\u7C8B\u7C8C\u7C8D\u7C8E\u7C8F\u7C90\u7C93\u7C94\u7C96\u7C99\u7C9A\u7C9B\u7CA0\u7CA1\u7CA3\u7CA6\u7CA7\u7CA8\u7CA9\u7CAB\u7CAC\u7CAD\u7CAF\u7CB0\u7CB4\u7CB5\u7CB6\u7CB7\u7CB8\u7CBA\u7CBB\u5F27\u864E\u552C\u62A4\u4E92\u6CAA\u6237\u82B1\u54D7\u534E\u733E\u6ED1\u753B\u5212\u5316\u8BDD\u69D0\u5F8A\u6000\u6DEE\u574F\u6B22\u73AF\u6853\u8FD8\u7F13\u6362\u60A3\u5524\u75EA\u8C62\u7115\u6DA3\u5BA6\u5E7B\u8352\u614C\u9EC4\u78FA\u8757\u7C27\u7687\u51F0\u60F6\u714C\u6643\u5E4C\u604D\u8C0E\u7070\u6325\u8F89\u5FBD\u6062\u86D4\u56DE\u6BC1\u6094\u6167\u5349\u60E0\u6666\u8D3F\u79FD\u4F1A\u70E9\u6C47\u8BB3\u8BF2\u7ED8\u8364\u660F\u5A5A\u9B42\u6D51\u6DF7\u8C41\u6D3B\u4F19\u706B\u83B7\u6216\u60D1\u970D\u8D27\u7978\u51FB\u573E\u57FA\u673A\u7578\u7A3D\u79EF\u7B95\uFFFD".split("");
    for(j = 0; j != D[187].length; ++j)if (D[187][j].charCodeAt(0) !== 0xFFFD) {
        e[D[187][j]] = 47872 + j;
        d[47872 + j] = D[187][j];
    }
    D[188] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7CBF\u7CC0\u7CC2\u7CC3\u7CC4\u7CC6\u7CC9\u7CCB\u7CCE\u7CCF\u7CD0\u7CD1\u7CD2\u7CD3\u7CD4\u7CD8\u7CDA\u7CDB\u7CDD\u7CDE\u7CE1\u7CE2\u7CE3\u7CE4\u7CE5\u7CE6\u7CE7\u7CE9\u7CEA\u7CEB\u7CEC\u7CED\u7CEE\u7CF0\u7CF1\u7CF2\u7CF3\u7CF4\u7CF5\u7CF6\u7CF7\u7CF9\u7CFA\u7CFC\u7CFD\u7CFE\u7CFF\u7D00\u7D01\u7D02\u7D03\u7D04\u7D05\u7D06\u7D07\u7D08\u7D09\u7D0B\u7D0C\u7D0D\u7D0E\u7D0F\u7D10\uFFFD\u7D11\u7D12\u7D13\u7D14\u7D15\u7D16\u7D17\u7D18\u7D19\u7D1A\u7D1B\u7D1C\u7D1D\u7D1E\u7D1F\u7D21\u7D23\u7D24\u7D25\u7D26\u7D28\u7D29\u7D2A\u7D2C\u7D2D\u7D2E\u7D30\u7D31\u7D32\u7D33\u7D34\u7D35\u7D36\u808C\u9965\u8FF9\u6FC0\u8BA5\u9E21\u59EC\u7EE9\u7F09\u5409\u6781\u68D8\u8F91\u7C4D\u96C6\u53CA\u6025\u75BE\u6C72\u5373\u5AC9\u7EA7\u6324\u51E0\u810A\u5DF1\u84DF\u6280\u5180\u5B63\u4F0E\u796D\u5242\u60B8\u6D4E\u5BC4\u5BC2\u8BA1\u8BB0\u65E2\u5FCC\u9645\u5993\u7EE7\u7EAA\u5609\u67B7\u5939\u4F73\u5BB6\u52A0\u835A\u988A\u8D3E\u7532\u94BE\u5047\u7A3C\u4EF7\u67B6\u9A7E\u5AC1\u6B7C\u76D1\u575A\u5C16\u7B3A\u95F4\u714E\u517C\u80A9\u8270\u5978\u7F04\u8327\u68C0\u67EC\u78B1\u7877\u62E3\u6361\u7B80\u4FED\u526A\u51CF\u8350\u69DB\u9274\u8DF5\u8D31\u89C1\u952E\u7BAD\u4EF6\uFFFD".split("");
    for(j = 0; j != D[188].length; ++j)if (D[188][j].charCodeAt(0) !== 0xFFFD) {
        e[D[188][j]] = 48128 + j;
        d[48128 + j] = D[188][j];
    }
    D[189] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7D37\u7D38\u7D39\u7D3A\u7D3B\u7D3C\u7D3D\u7D3E\u7D3F\u7D40\u7D41\u7D42\u7D43\u7D44\u7D45\u7D46\u7D47\u7D48\u7D49\u7D4A\u7D4B\u7D4C\u7D4D\u7D4E\u7D4F\u7D50\u7D51\u7D52\u7D53\u7D54\u7D55\u7D56\u7D57\u7D58\u7D59\u7D5A\u7D5B\u7D5C\u7D5D\u7D5E\u7D5F\u7D60\u7D61\u7D62\u7D63\u7D64\u7D65\u7D66\u7D67\u7D68\u7D69\u7D6A\u7D6B\u7D6C\u7D6D\u7D6F\u7D70\u7D71\u7D72\u7D73\u7D74\u7D75\u7D76\uFFFD\u7D78\u7D79\u7D7A\u7D7B\u7D7C\u7D7D\u7D7E\u7D7F\u7D80\u7D81\u7D82\u7D83\u7D84\u7D85\u7D86\u7D87\u7D88\u7D89\u7D8A\u7D8B\u7D8C\u7D8D\u7D8E\u7D8F\u7D90\u7D91\u7D92\u7D93\u7D94\u7D95\u7D96\u7D97\u7D98\u5065\u8230\u5251\u996F\u6E10\u6E85\u6DA7\u5EFA\u50F5\u59DC\u5C06\u6D46\u6C5F\u7586\u848B\u6868\u5956\u8BB2\u5320\u9171\u964D\u8549\u6912\u7901\u7126\u80F6\u4EA4\u90CA\u6D47\u9A84\u5A07\u56BC\u6405\u94F0\u77EB\u4FA5\u811A\u72E1\u89D2\u997A\u7F34\u7EDE\u527F\u6559\u9175\u8F7F\u8F83\u53EB\u7A96\u63ED\u63A5\u7686\u79F8\u8857\u9636\u622A\u52AB\u8282\u6854\u6770\u6377\u776B\u7AED\u6D01\u7ED3\u89E3\u59D0\u6212\u85C9\u82A5\u754C\u501F\u4ECB\u75A5\u8BEB\u5C4A\u5DFE\u7B4B\u65A4\u91D1\u4ECA\u6D25\u895F\u7D27\u9526\u4EC5\u8C28\u8FDB\u9773\u664B\u7981\u8FD1\u70EC\u6D78\uFFFD".split("");
    for(j = 0; j != D[189].length; ++j)if (D[189][j].charCodeAt(0) !== 0xFFFD) {
        e[D[189][j]] = 48384 + j;
        d[48384 + j] = D[189][j];
    }
    D[190] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7D99\u7D9A\u7D9B\u7D9C\u7D9D\u7D9E\u7D9F\u7DA0\u7DA1\u7DA2\u7DA3\u7DA4\u7DA5\u7DA7\u7DA8\u7DA9\u7DAA\u7DAB\u7DAC\u7DAD\u7DAF\u7DB0\u7DB1\u7DB2\u7DB3\u7DB4\u7DB5\u7DB6\u7DB7\u7DB8\u7DB9\u7DBA\u7DBB\u7DBC\u7DBD\u7DBE\u7DBF\u7DC0\u7DC1\u7DC2\u7DC3\u7DC4\u7DC5\u7DC6\u7DC7\u7DC8\u7DC9\u7DCA\u7DCB\u7DCC\u7DCD\u7DCE\u7DCF\u7DD0\u7DD1\u7DD2\u7DD3\u7DD4\u7DD5\u7DD6\u7DD7\u7DD8\u7DD9\uFFFD\u7DDA\u7DDB\u7DDC\u7DDD\u7DDE\u7DDF\u7DE0\u7DE1\u7DE2\u7DE3\u7DE4\u7DE5\u7DE6\u7DE7\u7DE8\u7DE9\u7DEA\u7DEB\u7DEC\u7DED\u7DEE\u7DEF\u7DF0\u7DF1\u7DF2\u7DF3\u7DF4\u7DF5\u7DF6\u7DF7\u7DF8\u7DF9\u7DFA\u5C3D\u52B2\u8346\u5162\u830E\u775B\u6676\u9CB8\u4EAC\u60CA\u7CBE\u7CB3\u7ECF\u4E95\u8B66\u666F\u9888\u9759\u5883\u656C\u955C\u5F84\u75C9\u9756\u7ADF\u7ADE\u51C0\u70AF\u7A98\u63EA\u7A76\u7EA0\u7396\u97ED\u4E45\u7078\u4E5D\u9152\u53A9\u6551\u65E7\u81FC\u8205\u548E\u5C31\u759A\u97A0\u62D8\u72D9\u75BD\u5C45\u9A79\u83CA\u5C40\u5480\u77E9\u4E3E\u6CAE\u805A\u62D2\u636E\u5DE8\u5177\u8DDD\u8E1E\u952F\u4FF1\u53E5\u60E7\u70AC\u5267\u6350\u9E43\u5A1F\u5026\u7737\u5377\u7EE2\u6485\u652B\u6289\u6398\u5014\u7235\u89C9\u51B3\u8BC0\u7EDD\u5747\u83CC\u94A7\u519B\u541B\u5CFB\uFFFD".split("");
    for(j = 0; j != D[190].length; ++j)if (D[190][j].charCodeAt(0) !== 0xFFFD) {
        e[D[190][j]] = 48640 + j;
        d[48640 + j] = D[190][j];
    }
    D[191] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7DFB\u7DFC\u7DFD\u7DFE\u7DFF\u7E00\u7E01\u7E02\u7E03\u7E04\u7E05\u7E06\u7E07\u7E08\u7E09\u7E0A\u7E0B\u7E0C\u7E0D\u7E0E\u7E0F\u7E10\u7E11\u7E12\u7E13\u7E14\u7E15\u7E16\u7E17\u7E18\u7E19\u7E1A\u7E1B\u7E1C\u7E1D\u7E1E\u7E1F\u7E20\u7E21\u7E22\u7E23\u7E24\u7E25\u7E26\u7E27\u7E28\u7E29\u7E2A\u7E2B\u7E2C\u7E2D\u7E2E\u7E2F\u7E30\u7E31\u7E32\u7E33\u7E34\u7E35\u7E36\u7E37\u7E38\u7E39\uFFFD\u7E3A\u7E3C\u7E3D\u7E3E\u7E3F\u7E40\u7E42\u7E43\u7E44\u7E45\u7E46\u7E48\u7E49\u7E4A\u7E4B\u7E4C\u7E4D\u7E4E\u7E4F\u7E50\u7E51\u7E52\u7E53\u7E54\u7E55\u7E56\u7E57\u7E58\u7E59\u7E5A\u7E5B\u7E5C\u7E5D\u4FCA\u7AE3\u6D5A\u90E1\u9A8F\u5580\u5496\u5361\u54AF\u5F00\u63E9\u6977\u51EF\u6168\u520A\u582A\u52D8\u574E\u780D\u770B\u5EB7\u6177\u7CE0\u625B\u6297\u4EA2\u7095\u8003\u62F7\u70E4\u9760\u5777\u82DB\u67EF\u68F5\u78D5\u9897\u79D1\u58F3\u54B3\u53EF\u6E34\u514B\u523B\u5BA2\u8BFE\u80AF\u5543\u57A6\u6073\u5751\u542D\u7A7A\u6050\u5B54\u63A7\u62A0\u53E3\u6263\u5BC7\u67AF\u54ED\u7A9F\u82E6\u9177\u5E93\u88E4\u5938\u57AE\u630E\u8DE8\u80EF\u5757\u7B77\u4FA9\u5FEB\u5BBD\u6B3E\u5321\u7B50\u72C2\u6846\u77FF\u7736\u65F7\u51B5\u4E8F\u76D4\u5CBF\u7AA5\u8475\u594E\u9B41\u5080\uFFFD".split("");
    for(j = 0; j != D[191].length; ++j)if (D[191][j].charCodeAt(0) !== 0xFFFD) {
        e[D[191][j]] = 48896 + j;
        d[48896 + j] = D[191][j];
    }
    D[192] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7E5E\u7E5F\u7E60\u7E61\u7E62\u7E63\u7E64\u7E65\u7E66\u7E67\u7E68\u7E69\u7E6A\u7E6B\u7E6C\u7E6D\u7E6E\u7E6F\u7E70\u7E71\u7E72\u7E73\u7E74\u7E75\u7E76\u7E77\u7E78\u7E79\u7E7A\u7E7B\u7E7C\u7E7D\u7E7E\u7E7F\u7E80\u7E81\u7E83\u7E84\u7E85\u7E86\u7E87\u7E88\u7E89\u7E8A\u7E8B\u7E8C\u7E8D\u7E8E\u7E8F\u7E90\u7E91\u7E92\u7E93\u7E94\u7E95\u7E96\u7E97\u7E98\u7E99\u7E9A\u7E9C\u7E9D\u7E9E\uFFFD\u7EAE\u7EB4\u7EBB\u7EBC\u7ED6\u7EE4\u7EEC\u7EF9\u7F0A\u7F10\u7F1E\u7F37\u7F39\u7F3B\u7F3C\u7F3D\u7F3E\u7F3F\u7F40\u7F41\u7F43\u7F46\u7F47\u7F48\u7F49\u7F4A\u7F4B\u7F4C\u7F4D\u7F4E\u7F4F\u7F52\u7F53\u9988\u6127\u6E83\u5764\u6606\u6346\u56F0\u62EC\u6269\u5ED3\u9614\u5783\u62C9\u5587\u8721\u814A\u8FA3\u5566\u83B1\u6765\u8D56\u84DD\u5A6A\u680F\u62E6\u7BEE\u9611\u5170\u6F9C\u8C30\u63FD\u89C8\u61D2\u7F06\u70C2\u6EE5\u7405\u6994\u72FC\u5ECA\u90CE\u6717\u6D6A\u635E\u52B3\u7262\u8001\u4F6C\u59E5\u916A\u70D9\u6D9D\u52D2\u4E50\u96F7\u956D\u857E\u78CA\u7D2F\u5121\u5792\u64C2\u808B\u7C7B\u6CEA\u68F1\u695E\u51B7\u5398\u68A8\u7281\u9ECE\u7BF1\u72F8\u79BB\u6F13\u7406\u674E\u91CC\u9CA4\u793C\u8389\u8354\u540F\u6817\u4E3D\u5389\u52B1\u783E\u5386\u5229\u5088\u4F8B\u4FD0\uFFFD".split("");
    for(j = 0; j != D[192].length; ++j)if (D[192][j].charCodeAt(0) !== 0xFFFD) {
        e[D[192][j]] = 49152 + j;
        d[49152 + j] = D[192][j];
    }
    D[193] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7F56\u7F59\u7F5B\u7F5C\u7F5D\u7F5E\u7F60\u7F63\u7F64\u7F65\u7F66\u7F67\u7F6B\u7F6C\u7F6D\u7F6F\u7F70\u7F73\u7F75\u7F76\u7F77\u7F78\u7F7A\u7F7B\u7F7C\u7F7D\u7F7F\u7F80\u7F82\u7F83\u7F84\u7F85\u7F86\u7F87\u7F88\u7F89\u7F8B\u7F8D\u7F8F\u7F90\u7F91\u7F92\u7F93\u7F95\u7F96\u7F97\u7F98\u7F99\u7F9B\u7F9C\u7FA0\u7FA2\u7FA3\u7FA5\u7FA6\u7FA8\u7FA9\u7FAA\u7FAB\u7FAC\u7FAD\u7FAE\u7FB1\uFFFD\u7FB3\u7FB4\u7FB5\u7FB6\u7FB7\u7FBA\u7FBB\u7FBE\u7FC0\u7FC2\u7FC3\u7FC4\u7FC6\u7FC7\u7FC8\u7FC9\u7FCB\u7FCD\u7FCF\u7FD0\u7FD1\u7FD2\u7FD3\u7FD6\u7FD7\u7FD9\u7FDA\u7FDB\u7FDC\u7FDD\u7FDE\u7FE2\u7FE3\u75E2\u7ACB\u7C92\u6CA5\u96B6\u529B\u7483\u54E9\u4FE9\u8054\u83B2\u8FDE\u9570\u5EC9\u601C\u6D9F\u5E18\u655B\u8138\u94FE\u604B\u70BC\u7EC3\u7CAE\u51C9\u6881\u7CB1\u826F\u4E24\u8F86\u91CF\u667E\u4EAE\u8C05\u64A9\u804A\u50DA\u7597\u71CE\u5BE5\u8FBD\u6F66\u4E86\u6482\u9563\u5ED6\u6599\u5217\u88C2\u70C8\u52A3\u730E\u7433\u6797\u78F7\u9716\u4E34\u90BB\u9CDE\u6DCB\u51DB\u8D41\u541D\u62CE\u73B2\u83F1\u96F6\u9F84\u94C3\u4F36\u7F9A\u51CC\u7075\u9675\u5CAD\u9886\u53E6\u4EE4\u6E9C\u7409\u69B4\u786B\u998F\u7559\u5218\u7624\u6D41\u67F3\u516D\u9F99\u804B\u5499\u7B3C\u7ABF\uFFFD".split("");
    for(j = 0; j != D[193].length; ++j)if (D[193][j].charCodeAt(0) !== 0xFFFD) {
        e[D[193][j]] = 49408 + j;
        d[49408 + j] = D[193][j];
    }
    D[194] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7FE4\u7FE7\u7FE8\u7FEA\u7FEB\u7FEC\u7FED\u7FEF\u7FF2\u7FF4\u7FF5\u7FF6\u7FF7\u7FF8\u7FF9\u7FFA\u7FFD\u7FFE\u7FFF\u8002\u8007\u8008\u8009\u800A\u800E\u800F\u8011\u8013\u801A\u801B\u801D\u801E\u801F\u8021\u8023\u8024\u802B\u802C\u802D\u802E\u802F\u8030\u8032\u8034\u8039\u803A\u803C\u803E\u8040\u8041\u8044\u8045\u8047\u8048\u8049\u804E\u804F\u8050\u8051\u8053\u8055\u8056\u8057\uFFFD\u8059\u805B\u805C\u805D\u805E\u805F\u8060\u8061\u8062\u8063\u8064\u8065\u8066\u8067\u8068\u806B\u806C\u806D\u806E\u806F\u8070\u8072\u8073\u8074\u8075\u8076\u8077\u8078\u8079\u807A\u807B\u807C\u807D\u9686\u5784\u62E2\u9647\u697C\u5A04\u6402\u7BD3\u6F0F\u964B\u82A6\u5362\u9885\u5E90\u7089\u63B3\u5364\u864F\u9C81\u9E93\u788C\u9732\u8DEF\u8D42\u9E7F\u6F5E\u7984\u5F55\u9646\u622E\u9A74\u5415\u94DD\u4FA3\u65C5\u5C65\u5C61\u7F15\u8651\u6C2F\u5F8B\u7387\u6EE4\u7EFF\u5CE6\u631B\u5B6A\u6EE6\u5375\u4E71\u63A0\u7565\u62A1\u8F6E\u4F26\u4ED1\u6CA6\u7EB6\u8BBA\u841D\u87BA\u7F57\u903B\u9523\u7BA9\u9AA1\u88F8\u843D\u6D1B\u9A86\u7EDC\u5988\u9EBB\u739B\u7801\u8682\u9A6C\u9A82\u561B\u5417\u57CB\u4E70\u9EA6\u5356\u8FC8\u8109\u7792\u9992\u86EE\u6EE1\u8513\u66FC\u6162\u6F2B\uFFFD".split("");
    for(j = 0; j != D[194].length; ++j)if (D[194][j].charCodeAt(0) !== 0xFFFD) {
        e[D[194][j]] = 49664 + j;
        d[49664 + j] = D[194][j];
    }
    D[195] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u807E\u8081\u8082\u8085\u8088\u808A\u808D\u808E\u808F\u8090\u8091\u8092\u8094\u8095\u8097\u8099\u809E\u80A3\u80A6\u80A7\u80A8\u80AC\u80B0\u80B3\u80B5\u80B6\u80B8\u80B9\u80BB\u80C5\u80C7\u80C8\u80C9\u80CA\u80CB\u80CF\u80D0\u80D1\u80D2\u80D3\u80D4\u80D5\u80D8\u80DF\u80E0\u80E2\u80E3\u80E6\u80EE\u80F5\u80F7\u80F9\u80FB\u80FE\u80FF\u8100\u8101\u8103\u8104\u8105\u8107\u8108\u810B\uFFFD\u810C\u8115\u8117\u8119\u811B\u811C\u811D\u811F\u8120\u8121\u8122\u8123\u8124\u8125\u8126\u8127\u8128\u8129\u812A\u812B\u812D\u812E\u8130\u8133\u8134\u8135\u8137\u8139\u813A\u813B\u813C\u813D\u813F\u8C29\u8292\u832B\u76F2\u6C13\u5FD9\u83BD\u732B\u8305\u951A\u6BDB\u77DB\u94C6\u536F\u8302\u5192\u5E3D\u8C8C\u8D38\u4E48\u73AB\u679A\u6885\u9176\u9709\u7164\u6CA1\u7709\u5A92\u9541\u6BCF\u7F8E\u6627\u5BD0\u59B9\u5A9A\u95E8\u95F7\u4EEC\u840C\u8499\u6AAC\u76DF\u9530\u731B\u68A6\u5B5F\u772F\u919A\u9761\u7CDC\u8FF7\u8C1C\u5F25\u7C73\u79D8\u89C5\u6CCC\u871C\u5BC6\u5E42\u68C9\u7720\u7EF5\u5195\u514D\u52C9\u5A29\u7F05\u9762\u82D7\u63CF\u7784\u85D0\u79D2\u6E3A\u5E99\u5999\u8511\u706D\u6C11\u62BF\u76BF\u654F\u60AF\u95FD\u660E\u879F\u9E23\u94ED\u540D\u547D\u8C2C\u6478\uFFFD".split("");
    for(j = 0; j != D[195].length; ++j)if (D[195][j].charCodeAt(0) !== 0xFFFD) {
        e[D[195][j]] = 49920 + j;
        d[49920 + j] = D[195][j];
    }
    D[196] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8140\u8141\u8142\u8143\u8144\u8145\u8147\u8149\u814D\u814E\u814F\u8152\u8156\u8157\u8158\u815B\u815C\u815D\u815E\u815F\u8161\u8162\u8163\u8164\u8166\u8168\u816A\u816B\u816C\u816F\u8172\u8173\u8175\u8176\u8177\u8178\u8181\u8183\u8184\u8185\u8186\u8187\u8189\u818B\u818C\u818D\u818E\u8190\u8192\u8193\u8194\u8195\u8196\u8197\u8199\u819A\u819E\u819F\u81A0\u81A1\u81A2\u81A4\u81A5\uFFFD\u81A7\u81A9\u81AB\u81AC\u81AD\u81AE\u81AF\u81B0\u81B1\u81B2\u81B4\u81B5\u81B6\u81B7\u81B8\u81B9\u81BC\u81BD\u81BE\u81BF\u81C4\u81C5\u81C7\u81C8\u81C9\u81CB\u81CD\u81CE\u81CF\u81D0\u81D1\u81D2\u81D3\u6479\u8611\u6A21\u819C\u78E8\u6469\u9B54\u62B9\u672B\u83AB\u58A8\u9ED8\u6CAB\u6F20\u5BDE\u964C\u8C0B\u725F\u67D0\u62C7\u7261\u4EA9\u59C6\u6BCD\u5893\u66AE\u5E55\u52DF\u6155\u6728\u76EE\u7766\u7267\u7A46\u62FF\u54EA\u5450\u94A0\u90A3\u5A1C\u7EB3\u6C16\u4E43\u5976\u8010\u5948\u5357\u7537\u96BE\u56CA\u6320\u8111\u607C\u95F9\u6DD6\u5462\u9981\u5185\u5AE9\u80FD\u59AE\u9713\u502A\u6CE5\u5C3C\u62DF\u4F60\u533F\u817B\u9006\u6EBA\u852B\u62C8\u5E74\u78BE\u64B5\u637B\u5FF5\u5A18\u917F\u9E1F\u5C3F\u634F\u8042\u5B7D\u556E\u954A\u954D\u6D85\u60A8\u67E0\u72DE\u51DD\u5B81\uFFFD".split("");
    for(j = 0; j != D[196].length; ++j)if (D[196][j].charCodeAt(0) !== 0xFFFD) {
        e[D[196][j]] = 50176 + j;
        d[50176 + j] = D[196][j];
    }
    D[197] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u81D4\u81D5\u81D6\u81D7\u81D8\u81D9\u81DA\u81DB\u81DC\u81DD\u81DE\u81DF\u81E0\u81E1\u81E2\u81E4\u81E5\u81E6\u81E8\u81E9\u81EB\u81EE\u81EF\u81F0\u81F1\u81F2\u81F5\u81F6\u81F7\u81F8\u81F9\u81FA\u81FD\u81FF\u8203\u8207\u8208\u8209\u820A\u820B\u820E\u820F\u8211\u8213\u8215\u8216\u8217\u8218\u8219\u821A\u821D\u8220\u8224\u8225\u8226\u8227\u8229\u822E\u8232\u823A\u823C\u823D\u823F\uFFFD\u8240\u8241\u8242\u8243\u8245\u8246\u8248\u824A\u824C\u824D\u824E\u8250\u8251\u8252\u8253\u8254\u8255\u8256\u8257\u8259\u825B\u825C\u825D\u825E\u8260\u8261\u8262\u8263\u8264\u8265\u8266\u8267\u8269\u62E7\u6CDE\u725B\u626D\u94AE\u7EBD\u8113\u6D53\u519C\u5F04\u5974\u52AA\u6012\u5973\u6696\u8650\u759F\u632A\u61E6\u7CEF\u8BFA\u54E6\u6B27\u9E25\u6BB4\u85D5\u5455\u5076\u6CA4\u556A\u8DB4\u722C\u5E15\u6015\u7436\u62CD\u6392\u724C\u5F98\u6E43\u6D3E\u6500\u6F58\u76D8\u78D0\u76FC\u7554\u5224\u53DB\u4E53\u5E9E\u65C1\u802A\u80D6\u629B\u5486\u5228\u70AE\u888D\u8DD1\u6CE1\u5478\u80DA\u57F9\u88F4\u8D54\u966A\u914D\u4F69\u6C9B\u55B7\u76C6\u7830\u62A8\u70F9\u6F8E\u5F6D\u84EC\u68DA\u787C\u7BF7\u81A8\u670B\u9E4F\u6367\u78B0\u576F\u7812\u9739\u6279\u62AB\u5288\u7435\u6BD7\uFFFD".split("");
    for(j = 0; j != D[197].length; ++j)if (D[197][j].charCodeAt(0) !== 0xFFFD) {
        e[D[197][j]] = 50432 + j;
        d[50432 + j] = D[197][j];
    }
    D[198] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u826A\u826B\u826C\u826D\u8271\u8275\u8276\u8277\u8278\u827B\u827C\u8280\u8281\u8283\u8285\u8286\u8287\u8289\u828C\u8290\u8293\u8294\u8295\u8296\u829A\u829B\u829E\u82A0\u82A2\u82A3\u82A7\u82B2\u82B5\u82B6\u82BA\u82BB\u82BC\u82BF\u82C0\u82C2\u82C3\u82C5\u82C6\u82C9\u82D0\u82D6\u82D9\u82DA\u82DD\u82E2\u82E7\u82E8\u82E9\u82EA\u82EC\u82ED\u82EE\u82F0\u82F2\u82F3\u82F5\u82F6\u82F8\uFFFD\u82FA\u82FC\u82FD\u82FE\u82FF\u8300\u830A\u830B\u830D\u8310\u8312\u8313\u8316\u8318\u8319\u831D\u831E\u831F\u8320\u8321\u8322\u8323\u8324\u8325\u8326\u8329\u832A\u832E\u8330\u8332\u8337\u833B\u833D\u5564\u813E\u75B2\u76AE\u5339\u75DE\u50FB\u5C41\u8B6C\u7BC7\u504F\u7247\u9A97\u98D8\u6F02\u74E2\u7968\u6487\u77A5\u62FC\u9891\u8D2B\u54C1\u8058\u4E52\u576A\u82F9\u840D\u5E73\u51ED\u74F6\u8BC4\u5C4F\u5761\u6CFC\u9887\u5A46\u7834\u9B44\u8FEB\u7C95\u5256\u6251\u94FA\u4EC6\u8386\u8461\u83E9\u84B2\u57D4\u6734\u5703\u666E\u6D66\u8C31\u66DD\u7011\u671F\u6B3A\u6816\u621A\u59BB\u4E03\u51C4\u6F06\u67D2\u6C8F\u5176\u68CB\u5947\u6B67\u7566\u5D0E\u8110\u9F50\u65D7\u7948\u7941\u9A91\u8D77\u5C82\u4E5E\u4F01\u542F\u5951\u780C\u5668\u6C14\u8FC4\u5F03\u6C7D\u6CE3\u8BAB\u6390\uFFFD".split("");
    for(j = 0; j != D[198].length; ++j)if (D[198][j].charCodeAt(0) !== 0xFFFD) {
        e[D[198][j]] = 50688 + j;
        d[50688 + j] = D[198][j];
    }
    D[199] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u833E\u833F\u8341\u8342\u8344\u8345\u8348\u834A\u834B\u834C\u834D\u834E\u8353\u8355\u8356\u8357\u8358\u8359\u835D\u8362\u8370\u8371\u8372\u8373\u8374\u8375\u8376\u8379\u837A\u837E\u837F\u8380\u8381\u8382\u8383\u8384\u8387\u8388\u838A\u838B\u838C\u838D\u838F\u8390\u8391\u8394\u8395\u8396\u8397\u8399\u839A\u839D\u839F\u83A1\u83A2\u83A3\u83A4\u83A5\u83A6\u83A7\u83AC\u83AD\u83AE\uFFFD\u83AF\u83B5\u83BB\u83BE\u83BF\u83C2\u83C3\u83C4\u83C6\u83C8\u83C9\u83CB\u83CD\u83CE\u83D0\u83D1\u83D2\u83D3\u83D5\u83D7\u83D9\u83DA\u83DB\u83DE\u83E2\u83E3\u83E4\u83E6\u83E7\u83E8\u83EB\u83EC\u83ED\u6070\u6D3D\u7275\u6266\u948E\u94C5\u5343\u8FC1\u7B7E\u4EDF\u8C26\u4E7E\u9ED4\u94B1\u94B3\u524D\u6F5C\u9063\u6D45\u8C34\u5811\u5D4C\u6B20\u6B49\u67AA\u545B\u8154\u7F8C\u5899\u8537\u5F3A\u62A2\u6A47\u9539\u6572\u6084\u6865\u77A7\u4E54\u4FA8\u5DE7\u9798\u64AC\u7FD8\u5CED\u4FCF\u7A8D\u5207\u8304\u4E14\u602F\u7A83\u94A6\u4FB5\u4EB2\u79E6\u7434\u52E4\u82B9\u64D2\u79BD\u5BDD\u6C81\u9752\u8F7B\u6C22\u503E\u537F\u6E05\u64CE\u6674\u6C30\u60C5\u9877\u8BF7\u5E86\u743C\u7A77\u79CB\u4E18\u90B1\u7403\u6C42\u56DA\u914B\u6CC5\u8D8B\u533A\u86C6\u66F2\u8EAF\u5C48\u9A71\u6E20\uFFFD".split("");
    for(j = 0; j != D[199].length; ++j)if (D[199][j].charCodeAt(0) !== 0xFFFD) {
        e[D[199][j]] = 50944 + j;
        d[50944 + j] = D[199][j];
    }
    D[200] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u83EE\u83EF\u83F3\u83F4\u83F5\u83F6\u83F7\u83FA\u83FB\u83FC\u83FE\u83FF\u8400\u8402\u8405\u8407\u8408\u8409\u840A\u8410\u8412\u8413\u8414\u8415\u8416\u8417\u8419\u841A\u841B\u841E\u841F\u8420\u8421\u8422\u8423\u8429\u842A\u842B\u842C\u842D\u842E\u842F\u8430\u8432\u8433\u8434\u8435\u8436\u8437\u8439\u843A\u843B\u843E\u843F\u8440\u8441\u8442\u8443\u8444\u8445\u8447\u8448\u8449\uFFFD\u844A\u844B\u844C\u844D\u844E\u844F\u8450\u8452\u8453\u8454\u8455\u8456\u8458\u845D\u845E\u845F\u8460\u8462\u8464\u8465\u8466\u8467\u8468\u846A\u846E\u846F\u8470\u8472\u8474\u8477\u8479\u847B\u847C\u53D6\u5A36\u9F8B\u8DA3\u53BB\u5708\u98A7\u6743\u919B\u6CC9\u5168\u75CA\u62F3\u72AC\u5238\u529D\u7F3A\u7094\u7638\u5374\u9E4A\u69B7\u786E\u96C0\u88D9\u7FA4\u7136\u71C3\u5189\u67D3\u74E4\u58E4\u6518\u56B7\u8BA9\u9976\u6270\u7ED5\u60F9\u70ED\u58EC\u4EC1\u4EBA\u5FCD\u97E7\u4EFB\u8BA4\u5203\u598A\u7EAB\u6254\u4ECD\u65E5\u620E\u8338\u84C9\u8363\u878D\u7194\u6EB6\u5BB9\u7ED2\u5197\u63C9\u67D4\u8089\u8339\u8815\u5112\u5B7A\u5982\u8FB1\u4E73\u6C5D\u5165\u8925\u8F6F\u962E\u854A\u745E\u9510\u95F0\u6DA6\u82E5\u5F31\u6492\u6D12\u8428\u816E\u9CC3\u585E\u8D5B\u4E09\u53C1\uFFFD".split("");
    for(j = 0; j != D[200].length; ++j)if (D[200][j].charCodeAt(0) !== 0xFFFD) {
        e[D[200][j]] = 51200 + j;
        d[51200 + j] = D[200][j];
    }
    D[201] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u847D\u847E\u847F\u8480\u8481\u8483\u8484\u8485\u8486\u848A\u848D\u848F\u8490\u8491\u8492\u8493\u8494\u8495\u8496\u8498\u849A\u849B\u849D\u849E\u849F\u84A0\u84A2\u84A3\u84A4\u84A5\u84A6\u84A7\u84A8\u84A9\u84AA\u84AB\u84AC\u84AD\u84AE\u84B0\u84B1\u84B3\u84B5\u84B6\u84B7\u84BB\u84BC\u84BE\u84C0\u84C2\u84C3\u84C5\u84C6\u84C7\u84C8\u84CB\u84CC\u84CE\u84CF\u84D2\u84D4\u84D5\u84D7\uFFFD\u84D8\u84D9\u84DA\u84DB\u84DC\u84DE\u84E1\u84E2\u84E4\u84E7\u84E8\u84E9\u84EA\u84EB\u84ED\u84EE\u84EF\u84F1\u84F2\u84F3\u84F4\u84F5\u84F6\u84F7\u84F8\u84F9\u84FA\u84FB\u84FD\u84FE\u8500\u8501\u8502\u4F1E\u6563\u6851\u55D3\u4E27\u6414\u9A9A\u626B\u5AC2\u745F\u8272\u6DA9\u68EE\u50E7\u838E\u7802\u6740\u5239\u6C99\u7EB1\u50BB\u5565\u715E\u7B5B\u6652\u73CA\u82EB\u6749\u5C71\u5220\u717D\u886B\u95EA\u9655\u64C5\u8D61\u81B3\u5584\u6C55\u6247\u7F2E\u5892\u4F24\u5546\u8D4F\u664C\u4E0A\u5C1A\u88F3\u68A2\u634E\u7A0D\u70E7\u828D\u52FA\u97F6\u5C11\u54E8\u90B5\u7ECD\u5962\u8D4A\u86C7\u820C\u820D\u8D66\u6444\u5C04\u6151\u6D89\u793E\u8BBE\u7837\u7533\u547B\u4F38\u8EAB\u6DF1\u5A20\u7EC5\u795E\u6C88\u5BA1\u5A76\u751A\u80BE\u614E\u6E17\u58F0\u751F\u7525\u7272\u5347\u7EF3\uFFFD".split("");
    for(j = 0; j != D[201].length; ++j)if (D[201][j].charCodeAt(0) !== 0xFFFD) {
        e[D[201][j]] = 51456 + j;
        d[51456 + j] = D[201][j];
    }
    D[202] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8503\u8504\u8505\u8506\u8507\u8508\u8509\u850A\u850B\u850D\u850E\u850F\u8510\u8512\u8514\u8515\u8516\u8518\u8519\u851B\u851C\u851D\u851E\u8520\u8522\u8523\u8524\u8525\u8526\u8527\u8528\u8529\u852A\u852D\u852E\u852F\u8530\u8531\u8532\u8533\u8534\u8535\u8536\u853E\u853F\u8540\u8541\u8542\u8544\u8545\u8546\u8547\u854B\u854C\u854D\u854E\u854F\u8550\u8551\u8552\u8553\u8554\u8555\uFFFD\u8557\u8558\u855A\u855B\u855C\u855D\u855F\u8560\u8561\u8562\u8563\u8565\u8566\u8567\u8569\u856A\u856B\u856C\u856D\u856E\u856F\u8570\u8571\u8573\u8575\u8576\u8577\u8578\u857C\u857D\u857F\u8580\u8581\u7701\u76DB\u5269\u80DC\u5723\u5E08\u5931\u72EE\u65BD\u6E7F\u8BD7\u5C38\u8671\u5341\u77F3\u62FE\u65F6\u4EC0\u98DF\u8680\u5B9E\u8BC6\u53F2\u77E2\u4F7F\u5C4E\u9A76\u59CB\u5F0F\u793A\u58EB\u4E16\u67FF\u4E8B\u62ED\u8A93\u901D\u52BF\u662F\u55DC\u566C\u9002\u4ED5\u4F8D\u91CA\u9970\u6C0F\u5E02\u6043\u5BA4\u89C6\u8BD5\u6536\u624B\u9996\u5B88\u5BFF\u6388\u552E\u53D7\u7626\u517D\u852C\u67A2\u68B3\u6B8A\u6292\u8F93\u53D4\u8212\u6DD1\u758F\u4E66\u8D4E\u5B70\u719F\u85AF\u6691\u66D9\u7F72\u8700\u9ECD\u9F20\u5C5E\u672F\u8FF0\u6811\u675F\u620D\u7AD6\u5885\u5EB6\u6570\u6F31\uFFFD".split("");
    for(j = 0; j != D[202].length; ++j)if (D[202][j].charCodeAt(0) !== 0xFFFD) {
        e[D[202][j]] = 51712 + j;
        d[51712 + j] = D[202][j];
    }
    D[203] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8582\u8583\u8586\u8588\u8589\u858A\u858B\u858C\u858D\u858E\u8590\u8591\u8592\u8593\u8594\u8595\u8596\u8597\u8598\u8599\u859A\u859D\u859E\u859F\u85A0\u85A1\u85A2\u85A3\u85A5\u85A6\u85A7\u85A9\u85AB\u85AC\u85AD\u85B1\u85B2\u85B3\u85B4\u85B5\u85B6\u85B8\u85BA\u85BB\u85BC\u85BD\u85BE\u85BF\u85C0\u85C2\u85C3\u85C4\u85C5\u85C6\u85C7\u85C8\u85CA\u85CB\u85CC\u85CD\u85CE\u85D1\u85D2\uFFFD\u85D4\u85D6\u85D7\u85D8\u85D9\u85DA\u85DB\u85DD\u85DE\u85DF\u85E0\u85E1\u85E2\u85E3\u85E5\u85E6\u85E7\u85E8\u85EA\u85EB\u85EC\u85ED\u85EE\u85EF\u85F0\u85F1\u85F2\u85F3\u85F4\u85F5\u85F6\u85F7\u85F8\u6055\u5237\u800D\u6454\u8870\u7529\u5E05\u6813\u62F4\u971C\u53CC\u723D\u8C01\u6C34\u7761\u7A0E\u542E\u77AC\u987A\u821C\u8BF4\u7855\u6714\u70C1\u65AF\u6495\u5636\u601D\u79C1\u53F8\u4E1D\u6B7B\u8086\u5BFA\u55E3\u56DB\u4F3A\u4F3C\u9972\u5DF3\u677E\u8038\u6002\u9882\u9001\u5B8B\u8BBC\u8BF5\u641C\u8258\u64DE\u55FD\u82CF\u9165\u4FD7\u7D20\u901F\u7C9F\u50F3\u5851\u6EAF\u5BBF\u8BC9\u8083\u9178\u849C\u7B97\u867D\u968B\u968F\u7EE5\u9AD3\u788E\u5C81\u7A57\u9042\u96A7\u795F\u5B59\u635F\u7B0B\u84D1\u68AD\u5506\u7F29\u7410\u7D22\u9501\u6240\u584C\u4ED6\u5B83\u5979\u5854\uFFFD".split("");
    for(j = 0; j != D[203].length; ++j)if (D[203][j].charCodeAt(0) !== 0xFFFD) {
        e[D[203][j]] = 51968 + j;
        d[51968 + j] = D[203][j];
    }
    D[204] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u85F9\u85FA\u85FC\u85FD\u85FE\u8600\u8601\u8602\u8603\u8604\u8606\u8607\u8608\u8609\u860A\u860B\u860C\u860D\u860E\u860F\u8610\u8612\u8613\u8614\u8615\u8617\u8618\u8619\u861A\u861B\u861C\u861D\u861E\u861F\u8620\u8621\u8622\u8623\u8624\u8625\u8626\u8628\u862A\u862B\u862C\u862D\u862E\u862F\u8630\u8631\u8632\u8633\u8634\u8635\u8636\u8637\u8639\u863A\u863B\u863D\u863E\u863F\u8640\uFFFD\u8641\u8642\u8643\u8644\u8645\u8646\u8647\u8648\u8649\u864A\u864B\u864C\u8652\u8653\u8655\u8656\u8657\u8658\u8659\u865B\u865C\u865D\u865F\u8660\u8661\u8663\u8664\u8665\u8666\u8667\u8668\u8669\u866A\u736D\u631E\u8E4B\u8E0F\u80CE\u82D4\u62AC\u53F0\u6CF0\u915E\u592A\u6001\u6C70\u574D\u644A\u8D2A\u762B\u6EE9\u575B\u6A80\u75F0\u6F6D\u8C2D\u8C08\u5766\u6BEF\u8892\u78B3\u63A2\u53F9\u70AD\u6C64\u5858\u642A\u5802\u68E0\u819B\u5510\u7CD6\u5018\u8EBA\u6DCC\u8D9F\u70EB\u638F\u6D9B\u6ED4\u7EE6\u8404\u6843\u9003\u6DD8\u9676\u8BA8\u5957\u7279\u85E4\u817E\u75BC\u8A8A\u68AF\u5254\u8E22\u9511\u63D0\u9898\u8E44\u557C\u4F53\u66FF\u568F\u60D5\u6D95\u5243\u5C49\u5929\u6DFB\u586B\u7530\u751C\u606C\u8214\u8146\u6311\u6761\u8FE2\u773A\u8DF3\u8D34\u94C1\u5E16\u5385\u542C\u70C3\uFFFD".split("");
    for(j = 0; j != D[204].length; ++j)if (D[204][j].charCodeAt(0) !== 0xFFFD) {
        e[D[204][j]] = 52224 + j;
        d[52224 + j] = D[204][j];
    }
    D[205] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u866D\u866F\u8670\u8672\u8673\u8674\u8675\u8676\u8677\u8678\u8683\u8684\u8685\u8686\u8687\u8688\u8689\u868E\u868F\u8690\u8691\u8692\u8694\u8696\u8697\u8698\u8699\u869A\u869B\u869E\u869F\u86A0\u86A1\u86A2\u86A5\u86A6\u86AB\u86AD\u86AE\u86B2\u86B3\u86B7\u86B8\u86B9\u86BB\u86BC\u86BD\u86BE\u86BF\u86C1\u86C2\u86C3\u86C5\u86C8\u86CC\u86CD\u86D2\u86D3\u86D5\u86D6\u86D7\u86DA\u86DC\uFFFD\u86DD\u86E0\u86E1\u86E2\u86E3\u86E5\u86E6\u86E7\u86E8\u86EA\u86EB\u86EC\u86EF\u86F5\u86F6\u86F7\u86FA\u86FB\u86FC\u86FD\u86FF\u8701\u8704\u8705\u8706\u870B\u870C\u870E\u870F\u8710\u8711\u8714\u8716\u6C40\u5EF7\u505C\u4EAD\u5EAD\u633A\u8247\u901A\u6850\u916E\u77B3\u540C\u94DC\u5F64\u7AE5\u6876\u6345\u7B52\u7EDF\u75DB\u5077\u6295\u5934\u900F\u51F8\u79C3\u7A81\u56FE\u5F92\u9014\u6D82\u5C60\u571F\u5410\u5154\u6E4D\u56E2\u63A8\u9893\u817F\u8715\u892A\u9000\u541E\u5C6F\u81C0\u62D6\u6258\u8131\u9E35\u9640\u9A6E\u9A7C\u692D\u59A5\u62D3\u553E\u6316\u54C7\u86D9\u6D3C\u5A03\u74E6\u889C\u6B6A\u5916\u8C4C\u5F2F\u6E7E\u73A9\u987D\u4E38\u70F7\u5B8C\u7897\u633D\u665A\u7696\u60CB\u5B9B\u5A49\u4E07\u8155\u6C6A\u738B\u4EA1\u6789\u7F51\u5F80\u65FA\u671B\u5FD8\u5984\u5A01\uFFFD".split("");
    for(j = 0; j != D[205].length; ++j)if (D[205][j].charCodeAt(0) !== 0xFFFD) {
        e[D[205][j]] = 52480 + j;
        d[52480 + j] = D[205][j];
    }
    D[206] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8719\u871B\u871D\u871F\u8720\u8724\u8726\u8727\u8728\u872A\u872B\u872C\u872D\u872F\u8730\u8732\u8733\u8735\u8736\u8738\u8739\u873A\u873C\u873D\u8740\u8741\u8742\u8743\u8744\u8745\u8746\u874A\u874B\u874D\u874F\u8750\u8751\u8752\u8754\u8755\u8756\u8758\u875A\u875B\u875C\u875D\u875E\u875F\u8761\u8762\u8766\u8767\u8768\u8769\u876A\u876B\u876C\u876D\u876F\u8771\u8772\u8773\u8775\uFFFD\u8777\u8778\u8779\u877A\u877F\u8780\u8781\u8784\u8786\u8787\u8789\u878A\u878C\u878E\u878F\u8790\u8791\u8792\u8794\u8795\u8796\u8798\u8799\u879A\u879B\u879C\u879D\u879E\u87A0\u87A1\u87A2\u87A3\u87A4\u5DCD\u5FAE\u5371\u97E6\u8FDD\u6845\u56F4\u552F\u60DF\u4E3A\u6F4D\u7EF4\u82C7\u840E\u59D4\u4F1F\u4F2A\u5C3E\u7EAC\u672A\u851A\u5473\u754F\u80C3\u5582\u9B4F\u4F4D\u6E2D\u8C13\u5C09\u6170\u536B\u761F\u6E29\u868A\u6587\u95FB\u7EB9\u543B\u7A33\u7D0A\u95EE\u55E1\u7FC1\u74EE\u631D\u8717\u6DA1\u7A9D\u6211\u65A1\u5367\u63E1\u6C83\u5DEB\u545C\u94A8\u4E4C\u6C61\u8BEC\u5C4B\u65E0\u829C\u68A7\u543E\u5434\u6BCB\u6B66\u4E94\u6342\u5348\u821E\u4F0D\u4FAE\u575E\u620A\u96FE\u6664\u7269\u52FF\u52A1\u609F\u8BEF\u6614\u7199\u6790\u897F\u7852\u77FD\u6670\u563B\u5438\u9521\u727A\uFFFD".split("");
    for(j = 0; j != D[206].length; ++j)if (D[206][j].charCodeAt(0) !== 0xFFFD) {
        e[D[206][j]] = 52736 + j;
        d[52736 + j] = D[206][j];
    }
    D[207] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u87A5\u87A6\u87A7\u87A9\u87AA\u87AE\u87B0\u87B1\u87B2\u87B4\u87B6\u87B7\u87B8\u87B9\u87BB\u87BC\u87BE\u87BF\u87C1\u87C2\u87C3\u87C4\u87C5\u87C7\u87C8\u87C9\u87CC\u87CD\u87CE\u87CF\u87D0\u87D4\u87D5\u87D6\u87D7\u87D8\u87D9\u87DA\u87DC\u87DD\u87DE\u87DF\u87E1\u87E2\u87E3\u87E4\u87E6\u87E7\u87E8\u87E9\u87EB\u87EC\u87ED\u87EF\u87F0\u87F1\u87F2\u87F3\u87F4\u87F5\u87F6\u87F7\u87F8\uFFFD\u87FA\u87FB\u87FC\u87FD\u87FF\u8800\u8801\u8802\u8804\u8805\u8806\u8807\u8808\u8809\u880B\u880C\u880D\u880E\u880F\u8810\u8811\u8812\u8814\u8817\u8818\u8819\u881A\u881C\u881D\u881E\u881F\u8820\u8823\u7A00\u606F\u5E0C\u6089\u819D\u5915\u60DC\u7184\u70EF\u6EAA\u6C50\u7280\u6A84\u88AD\u5E2D\u4E60\u5AB3\u559C\u94E3\u6D17\u7CFB\u9699\u620F\u7EC6\u778E\u867E\u5323\u971E\u8F96\u6687\u5CE1\u4FA0\u72ED\u4E0B\u53A6\u590F\u5413\u6380\u9528\u5148\u4ED9\u9C9C\u7EA4\u54B8\u8D24\u8854\u8237\u95F2\u6D8E\u5F26\u5ACC\u663E\u9669\u73B0\u732E\u53BF\u817A\u9985\u7FA1\u5BAA\u9677\u9650\u7EBF\u76F8\u53A2\u9576\u9999\u7BB1\u8944\u6E58\u4E61\u7FD4\u7965\u8BE6\u60F3\u54CD\u4EAB\u9879\u5DF7\u6A61\u50CF\u5411\u8C61\u8427\u785D\u9704\u524A\u54EE\u56A3\u9500\u6D88\u5BB5\u6DC6\u6653\uFFFD".split("");
    for(j = 0; j != D[207].length; ++j)if (D[207][j].charCodeAt(0) !== 0xFFFD) {
        e[D[207][j]] = 52992 + j;
        d[52992 + j] = D[207][j];
    }
    D[208] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8824\u8825\u8826\u8827\u8828\u8829\u882A\u882B\u882C\u882D\u882E\u882F\u8830\u8831\u8833\u8834\u8835\u8836\u8837\u8838\u883A\u883B\u883D\u883E\u883F\u8841\u8842\u8843\u8846\u8847\u8848\u8849\u884A\u884B\u884E\u884F\u8850\u8851\u8852\u8853\u8855\u8856\u8858\u885A\u885B\u885C\u885D\u885E\u885F\u8860\u8866\u8867\u886A\u886D\u886F\u8871\u8873\u8874\u8875\u8876\u8878\u8879\u887A\uFFFD\u887B\u887C\u8880\u8883\u8886\u8887\u8889\u888A\u888C\u888E\u888F\u8890\u8891\u8893\u8894\u8895\u8897\u8898\u8899\u889A\u889B\u889D\u889E\u889F\u88A0\u88A1\u88A3\u88A5\u88A6\u88A7\u88A8\u88A9\u88AA\u5C0F\u5B5D\u6821\u8096\u5578\u7B11\u6548\u6954\u4E9B\u6B47\u874E\u978B\u534F\u631F\u643A\u90AA\u659C\u80C1\u8C10\u5199\u68B0\u5378\u87F9\u61C8\u6CC4\u6CFB\u8C22\u5C51\u85AA\u82AF\u950C\u6B23\u8F9B\u65B0\u5FFB\u5FC3\u4FE1\u8845\u661F\u8165\u7329\u60FA\u5174\u5211\u578B\u5F62\u90A2\u884C\u9192\u5E78\u674F\u6027\u59D3\u5144\u51F6\u80F8\u5308\u6C79\u96C4\u718A\u4F11\u4FEE\u7F9E\u673D\u55C5\u9508\u79C0\u8896\u7EE3\u589F\u620C\u9700\u865A\u5618\u987B\u5F90\u8BB8\u84C4\u9157\u53D9\u65ED\u5E8F\u755C\u6064\u7D6E\u5A7F\u7EEA\u7EED\u8F69\u55A7\u5BA3\u60AC\u65CB\u7384\uFFFD".split("");
    for(j = 0; j != D[208].length; ++j)if (D[208][j].charCodeAt(0) !== 0xFFFD) {
        e[D[208][j]] = 53248 + j;
        d[53248 + j] = D[208][j];
    }
    D[209] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u88AC\u88AE\u88AF\u88B0\u88B2\u88B3\u88B4\u88B5\u88B6\u88B8\u88B9\u88BA\u88BB\u88BD\u88BE\u88BF\u88C0\u88C3\u88C4\u88C7\u88C8\u88CA\u88CB\u88CC\u88CD\u88CF\u88D0\u88D1\u88D3\u88D6\u88D7\u88DA\u88DB\u88DC\u88DD\u88DE\u88E0\u88E1\u88E6\u88E7\u88E9\u88EA\u88EB\u88EC\u88ED\u88EE\u88EF\u88F2\u88F5\u88F6\u88F7\u88FA\u88FB\u88FD\u88FF\u8900\u8901\u8903\u8904\u8905\u8906\u8907\u8908\uFFFD\u8909\u890B\u890C\u890D\u890E\u890F\u8911\u8914\u8915\u8916\u8917\u8918\u891C\u891D\u891E\u891F\u8920\u8922\u8923\u8924\u8926\u8927\u8928\u8929\u892C\u892D\u892E\u892F\u8931\u8932\u8933\u8935\u8937\u9009\u7663\u7729\u7EDA\u9774\u859B\u5B66\u7A74\u96EA\u8840\u52CB\u718F\u5FAA\u65EC\u8BE2\u5BFB\u9A6F\u5DE1\u6B89\u6C5B\u8BAD\u8BAF\u900A\u8FC5\u538B\u62BC\u9E26\u9E2D\u5440\u4E2B\u82BD\u7259\u869C\u5D16\u8859\u6DAF\u96C5\u54D1\u4E9A\u8BB6\u7109\u54BD\u9609\u70DF\u6DF9\u76D0\u4E25\u7814\u8712\u5CA9\u5EF6\u8A00\u989C\u960E\u708E\u6CBF\u5944\u63A9\u773C\u884D\u6F14\u8273\u5830\u71D5\u538C\u781A\u96C1\u5501\u5F66\u7130\u5BB4\u8C1A\u9A8C\u6B83\u592E\u9E2F\u79E7\u6768\u626C\u4F6F\u75A1\u7F8A\u6D0B\u9633\u6C27\u4EF0\u75D2\u517B\u6837\u6F3E\u9080\u8170\u5996\u7476\uFFFD".split("");
    for(j = 0; j != D[209].length; ++j)if (D[209][j].charCodeAt(0) !== 0xFFFD) {
        e[D[209][j]] = 53504 + j;
        d[53504 + j] = D[209][j];
    }
    D[210] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8938\u8939\u893A\u893B\u893C\u893D\u893E\u893F\u8940\u8942\u8943\u8945\u8946\u8947\u8948\u8949\u894A\u894B\u894C\u894D\u894E\u894F\u8950\u8951\u8952\u8953\u8954\u8955\u8956\u8957\u8958\u8959\u895A\u895B\u895C\u895D\u8960\u8961\u8962\u8963\u8964\u8965\u8967\u8968\u8969\u896A\u896B\u896C\u896D\u896E\u896F\u8970\u8971\u8972\u8973\u8974\u8975\u8976\u8977\u8978\u8979\u897A\u897C\uFFFD\u897D\u897E\u8980\u8982\u8984\u8985\u8987\u8988\u8989\u898A\u898B\u898C\u898D\u898E\u898F\u8990\u8991\u8992\u8993\u8994\u8995\u8996\u8997\u8998\u8999\u899A\u899B\u899C\u899D\u899E\u899F\u89A0\u89A1\u6447\u5C27\u9065\u7A91\u8C23\u59DA\u54AC\u8200\u836F\u8981\u8000\u6930\u564E\u8036\u7237\u91CE\u51B6\u4E5F\u9875\u6396\u4E1A\u53F6\u66F3\u814B\u591C\u6DB2\u4E00\u58F9\u533B\u63D6\u94F1\u4F9D\u4F0A\u8863\u9890\u5937\u9057\u79FB\u4EEA\u80F0\u7591\u6C82\u5B9C\u59E8\u5F5D\u6905\u8681\u501A\u5DF2\u4E59\u77E3\u4EE5\u827A\u6291\u6613\u9091\u5C79\u4EBF\u5F79\u81C6\u9038\u8084\u75AB\u4EA6\u88D4\u610F\u6BC5\u5FC6\u4E49\u76CA\u6EA2\u8BE3\u8BAE\u8C0A\u8BD1\u5F02\u7FFC\u7FCC\u7ECE\u8335\u836B\u56E0\u6BB7\u97F3\u9634\u59FB\u541F\u94F6\u6DEB\u5BC5\u996E\u5C39\u5F15\u9690\uFFFD".split("");
    for(j = 0; j != D[210].length; ++j)if (D[210][j].charCodeAt(0) !== 0xFFFD) {
        e[D[210][j]] = 53760 + j;
        d[53760 + j] = D[210][j];
    }
    D[211] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u89A2\u89A3\u89A4\u89A5\u89A6\u89A7\u89A8\u89A9\u89AA\u89AB\u89AC\u89AD\u89AE\u89AF\u89B0\u89B1\u89B2\u89B3\u89B4\u89B5\u89B6\u89B7\u89B8\u89B9\u89BA\u89BB\u89BC\u89BD\u89BE\u89BF\u89C0\u89C3\u89CD\u89D3\u89D4\u89D5\u89D7\u89D8\u89D9\u89DB\u89DD\u89DF\u89E0\u89E1\u89E2\u89E4\u89E7\u89E8\u89E9\u89EA\u89EC\u89ED\u89EE\u89F0\u89F1\u89F2\u89F4\u89F5\u89F6\u89F7\u89F8\u89F9\u89FA\uFFFD\u89FB\u89FC\u89FD\u89FE\u89FF\u8A01\u8A02\u8A03\u8A04\u8A05\u8A06\u8A08\u8A09\u8A0A\u8A0B\u8A0C\u8A0D\u8A0E\u8A0F\u8A10\u8A11\u8A12\u8A13\u8A14\u8A15\u8A16\u8A17\u8A18\u8A19\u8A1A\u8A1B\u8A1C\u8A1D\u5370\u82F1\u6A31\u5A74\u9E70\u5E94\u7F28\u83B9\u8424\u8425\u8367\u8747\u8FCE\u8D62\u76C8\u5F71\u9896\u786C\u6620\u54DF\u62E5\u4F63\u81C3\u75C8\u5EB8\u96CD\u8E0A\u86F9\u548F\u6CF3\u6D8C\u6C38\u607F\u52C7\u7528\u5E7D\u4F18\u60A0\u5FE7\u5C24\u7531\u90AE\u94C0\u72B9\u6CB9\u6E38\u9149\u6709\u53CB\u53F3\u4F51\u91C9\u8BF1\u53C8\u5E7C\u8FC2\u6DE4\u4E8E\u76C2\u6986\u865E\u611A\u8206\u4F59\u4FDE\u903E\u9C7C\u6109\u6E1D\u6E14\u9685\u4E88\u5A31\u96E8\u4E0E\u5C7F\u79B9\u5B87\u8BED\u7FBD\u7389\u57DF\u828B\u90C1\u5401\u9047\u55BB\u5CEA\u5FA1\u6108\u6B32\u72F1\u80B2\u8A89\uFFFD".split("");
    for(j = 0; j != D[211].length; ++j)if (D[211][j].charCodeAt(0) !== 0xFFFD) {
        e[D[211][j]] = 54016 + j;
        d[54016 + j] = D[211][j];
    }
    D[212] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8A1E\u8A1F\u8A20\u8A21\u8A22\u8A23\u8A24\u8A25\u8A26\u8A27\u8A28\u8A29\u8A2A\u8A2B\u8A2C\u8A2D\u8A2E\u8A2F\u8A30\u8A31\u8A32\u8A33\u8A34\u8A35\u8A36\u8A37\u8A38\u8A39\u8A3A\u8A3B\u8A3C\u8A3D\u8A3F\u8A40\u8A41\u8A42\u8A43\u8A44\u8A45\u8A46\u8A47\u8A49\u8A4A\u8A4B\u8A4C\u8A4D\u8A4E\u8A4F\u8A50\u8A51\u8A52\u8A53\u8A54\u8A55\u8A56\u8A57\u8A58\u8A59\u8A5A\u8A5B\u8A5C\u8A5D\u8A5E\uFFFD\u8A5F\u8A60\u8A61\u8A62\u8A63\u8A64\u8A65\u8A66\u8A67\u8A68\u8A69\u8A6A\u8A6B\u8A6C\u8A6D\u8A6E\u8A6F\u8A70\u8A71\u8A72\u8A73\u8A74\u8A75\u8A76\u8A77\u8A78\u8A7A\u8A7B\u8A7C\u8A7D\u8A7E\u8A7F\u8A80\u6D74\u5BD3\u88D5\u9884\u8C6B\u9A6D\u9E33\u6E0A\u51A4\u5143\u57A3\u8881\u539F\u63F4\u8F95\u56ED\u5458\u5706\u733F\u6E90\u7F18\u8FDC\u82D1\u613F\u6028\u9662\u66F0\u7EA6\u8D8A\u8DC3\u94A5\u5CB3\u7CA4\u6708\u60A6\u9605\u8018\u4E91\u90E7\u5300\u9668\u5141\u8FD0\u8574\u915D\u6655\u97F5\u5B55\u531D\u7838\u6742\u683D\u54C9\u707E\u5BB0\u8F7D\u518D\u5728\u54B1\u6512\u6682\u8D5E\u8D43\u810F\u846C\u906D\u7CDF\u51FF\u85FB\u67A3\u65E9\u6FA1\u86A4\u8E81\u566A\u9020\u7682\u7076\u71E5\u8D23\u62E9\u5219\u6CFD\u8D3C\u600E\u589E\u618E\u66FE\u8D60\u624E\u55B3\u6E23\u672D\u8F67\uFFFD".split("");
    for(j = 0; j != D[212].length; ++j)if (D[212][j].charCodeAt(0) !== 0xFFFD) {
        e[D[212][j]] = 54272 + j;
        d[54272 + j] = D[212][j];
    }
    D[213] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8A81\u8A82\u8A83\u8A84\u8A85\u8A86\u8A87\u8A88\u8A8B\u8A8C\u8A8D\u8A8E\u8A8F\u8A90\u8A91\u8A92\u8A94\u8A95\u8A96\u8A97\u8A98\u8A99\u8A9A\u8A9B\u8A9C\u8A9D\u8A9E\u8A9F\u8AA0\u8AA1\u8AA2\u8AA3\u8AA4\u8AA5\u8AA6\u8AA7\u8AA8\u8AA9\u8AAA\u8AAB\u8AAC\u8AAD\u8AAE\u8AAF\u8AB0\u8AB1\u8AB2\u8AB3\u8AB4\u8AB5\u8AB6\u8AB7\u8AB8\u8AB9\u8ABA\u8ABB\u8ABC\u8ABD\u8ABE\u8ABF\u8AC0\u8AC1\u8AC2\uFFFD\u8AC3\u8AC4\u8AC5\u8AC6\u8AC7\u8AC8\u8AC9\u8ACA\u8ACB\u8ACC\u8ACD\u8ACE\u8ACF\u8AD0\u8AD1\u8AD2\u8AD3\u8AD4\u8AD5\u8AD6\u8AD7\u8AD8\u8AD9\u8ADA\u8ADB\u8ADC\u8ADD\u8ADE\u8ADF\u8AE0\u8AE1\u8AE2\u8AE3\u94E1\u95F8\u7728\u6805\u69A8\u548B\u4E4D\u70B8\u8BC8\u6458\u658B\u5B85\u7A84\u503A\u5BE8\u77BB\u6BE1\u8A79\u7C98\u6CBE\u76CF\u65A9\u8F97\u5D2D\u5C55\u8638\u6808\u5360\u6218\u7AD9\u6E5B\u7EFD\u6A1F\u7AE0\u5F70\u6F33\u5F20\u638C\u6DA8\u6756\u4E08\u5E10\u8D26\u4ED7\u80C0\u7634\u969C\u62DB\u662D\u627E\u6CBC\u8D75\u7167\u7F69\u5146\u8087\u53EC\u906E\u6298\u54F2\u86F0\u8F99\u8005\u9517\u8517\u8FD9\u6D59\u73CD\u659F\u771F\u7504\u7827\u81FB\u8D1E\u9488\u4FA6\u6795\u75B9\u8BCA\u9707\u632F\u9547\u9635\u84B8\u6323\u7741\u5F81\u72F0\u4E89\u6014\u6574\u62EF\u6B63\u653F\uFFFD".split("");
    for(j = 0; j != D[213].length; ++j)if (D[213][j].charCodeAt(0) !== 0xFFFD) {
        e[D[213][j]] = 54528 + j;
        d[54528 + j] = D[213][j];
    }
    D[214] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8AE4\u8AE5\u8AE6\u8AE7\u8AE8\u8AE9\u8AEA\u8AEB\u8AEC\u8AED\u8AEE\u8AEF\u8AF0\u8AF1\u8AF2\u8AF3\u8AF4\u8AF5\u8AF6\u8AF7\u8AF8\u8AF9\u8AFA\u8AFB\u8AFC\u8AFD\u8AFE\u8AFF\u8B00\u8B01\u8B02\u8B03\u8B04\u8B05\u8B06\u8B08\u8B09\u8B0A\u8B0B\u8B0C\u8B0D\u8B0E\u8B0F\u8B10\u8B11\u8B12\u8B13\u8B14\u8B15\u8B16\u8B17\u8B18\u8B19\u8B1A\u8B1B\u8B1C\u8B1D\u8B1E\u8B1F\u8B20\u8B21\u8B22\u8B23\uFFFD\u8B24\u8B25\u8B27\u8B28\u8B29\u8B2A\u8B2B\u8B2C\u8B2D\u8B2E\u8B2F\u8B30\u8B31\u8B32\u8B33\u8B34\u8B35\u8B36\u8B37\u8B38\u8B39\u8B3A\u8B3B\u8B3C\u8B3D\u8B3E\u8B3F\u8B40\u8B41\u8B42\u8B43\u8B44\u8B45\u5E27\u75C7\u90D1\u8BC1\u829D\u679D\u652F\u5431\u8718\u77E5\u80A2\u8102\u6C41\u4E4B\u7EC7\u804C\u76F4\u690D\u6B96\u6267\u503C\u4F84\u5740\u6307\u6B62\u8DBE\u53EA\u65E8\u7EB8\u5FD7\u631A\u63B7\u81F3\u81F4\u7F6E\u5E1C\u5CD9\u5236\u667A\u79E9\u7A1A\u8D28\u7099\u75D4\u6EDE\u6CBB\u7A92\u4E2D\u76C5\u5FE0\u949F\u8877\u7EC8\u79CD\u80BF\u91CD\u4EF2\u4F17\u821F\u5468\u5DDE\u6D32\u8BCC\u7CA5\u8F74\u8098\u5E1A\u5492\u76B1\u5B99\u663C\u9AA4\u73E0\u682A\u86DB\u6731\u732A\u8BF8\u8BDB\u9010\u7AF9\u70DB\u716E\u62C4\u77A9\u5631\u4E3B\u8457\u67F1\u52A9\u86C0\u8D2E\u94F8\u7B51\uFFFD".split("");
    for(j = 0; j != D[214].length; ++j)if (D[214][j].charCodeAt(0) !== 0xFFFD) {
        e[D[214][j]] = 54784 + j;
        d[54784 + j] = D[214][j];
    }
    D[215] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8B46\u8B47\u8B48\u8B49\u8B4A\u8B4B\u8B4C\u8B4D\u8B4E\u8B4F\u8B50\u8B51\u8B52\u8B53\u8B54\u8B55\u8B56\u8B57\u8B58\u8B59\u8B5A\u8B5B\u8B5C\u8B5D\u8B5E\u8B5F\u8B60\u8B61\u8B62\u8B63\u8B64\u8B65\u8B67\u8B68\u8B69\u8B6A\u8B6B\u8B6D\u8B6E\u8B6F\u8B70\u8B71\u8B72\u8B73\u8B74\u8B75\u8B76\u8B77\u8B78\u8B79\u8B7A\u8B7B\u8B7C\u8B7D\u8B7E\u8B7F\u8B80\u8B81\u8B82\u8B83\u8B84\u8B85\u8B86\uFFFD\u8B87\u8B88\u8B89\u8B8A\u8B8B\u8B8C\u8B8D\u8B8E\u8B8F\u8B90\u8B91\u8B92\u8B93\u8B94\u8B95\u8B96\u8B97\u8B98\u8B99\u8B9A\u8B9B\u8B9C\u8B9D\u8B9E\u8B9F\u8BAC\u8BB1\u8BBB\u8BC7\u8BD0\u8BEA\u8C09\u8C1E\u4F4F\u6CE8\u795D\u9A7B\u6293\u722A\u62FD\u4E13\u7816\u8F6C\u64B0\u8D5A\u7BC6\u6869\u5E84\u88C5\u5986\u649E\u58EE\u72B6\u690E\u9525\u8FFD\u8D58\u5760\u7F00\u8C06\u51C6\u6349\u62D9\u5353\u684C\u7422\u8301\u914C\u5544\u7740\u707C\u6D4A\u5179\u54A8\u8D44\u59FF\u6ECB\u6DC4\u5B5C\u7D2B\u4ED4\u7C7D\u6ED3\u5B50\u81EA\u6E0D\u5B57\u9B03\u68D5\u8E2A\u5B97\u7EFC\u603B\u7EB5\u90B9\u8D70\u594F\u63CD\u79DF\u8DB3\u5352\u65CF\u7956\u8BC5\u963B\u7EC4\u94BB\u7E82\u5634\u9189\u6700\u7F6A\u5C0A\u9075\u6628\u5DE6\u4F50\u67DE\u505A\u4F5C\u5750\u5EA7\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[215].length; ++j)if (D[215][j].charCodeAt(0) !== 0xFFFD) {
        e[D[215][j]] = 55040 + j;
        d[55040 + j] = D[215][j];
    }
    D[216] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8C38\u8C39\u8C3A\u8C3B\u8C3C\u8C3D\u8C3E\u8C3F\u8C40\u8C42\u8C43\u8C44\u8C45\u8C48\u8C4A\u8C4B\u8C4D\u8C4E\u8C4F\u8C50\u8C51\u8C52\u8C53\u8C54\u8C56\u8C57\u8C58\u8C59\u8C5B\u8C5C\u8C5D\u8C5E\u8C5F\u8C60\u8C63\u8C64\u8C65\u8C66\u8C67\u8C68\u8C69\u8C6C\u8C6D\u8C6E\u8C6F\u8C70\u8C71\u8C72\u8C74\u8C75\u8C76\u8C77\u8C7B\u8C7C\u8C7D\u8C7E\u8C7F\u8C80\u8C81\u8C83\u8C84\u8C86\u8C87\uFFFD\u8C88\u8C8B\u8C8D\u8C8E\u8C8F\u8C90\u8C91\u8C92\u8C93\u8C95\u8C96\u8C97\u8C99\u8C9A\u8C9B\u8C9C\u8C9D\u8C9E\u8C9F\u8CA0\u8CA1\u8CA2\u8CA3\u8CA4\u8CA5\u8CA6\u8CA7\u8CA8\u8CA9\u8CAA\u8CAB\u8CAC\u8CAD\u4E8D\u4E0C\u5140\u4E10\u5EFF\u5345\u4E15\u4E98\u4E1E\u9B32\u5B6C\u5669\u4E28\u79BA\u4E3F\u5315\u4E47\u592D\u723B\u536E\u6C10\u56DF\u80E4\u9997\u6BD3\u777E\u9F17\u4E36\u4E9F\u9F10\u4E5C\u4E69\u4E93\u8288\u5B5B\u556C\u560F\u4EC4\u538D\u539D\u53A3\u53A5\u53AE\u9765\u8D5D\u531A\u53F5\u5326\u532E\u533E\u8D5C\u5366\u5363\u5202\u5208\u520E\u522D\u5233\u523F\u5240\u524C\u525E\u5261\u525C\u84AF\u527D\u5282\u5281\u5290\u5293\u5182\u7F54\u4EBB\u4EC3\u4EC9\u4EC2\u4EE8\u4EE1\u4EEB\u4EDE\u4F1B\u4EF3\u4F22\u4F64\u4EF5\u4F25\u4F27\u4F09\u4F2B\u4F5E\u4F67\u6538\u4F5A\u4F5D\uFFFD".split("");
    for(j = 0; j != D[216].length; ++j)if (D[216][j].charCodeAt(0) !== 0xFFFD) {
        e[D[216][j]] = 55296 + j;
        d[55296 + j] = D[216][j];
    }
    D[217] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8CAE\u8CAF\u8CB0\u8CB1\u8CB2\u8CB3\u8CB4\u8CB5\u8CB6\u8CB7\u8CB8\u8CB9\u8CBA\u8CBB\u8CBC\u8CBD\u8CBE\u8CBF\u8CC0\u8CC1\u8CC2\u8CC3\u8CC4\u8CC5\u8CC6\u8CC7\u8CC8\u8CC9\u8CCA\u8CCB\u8CCC\u8CCD\u8CCE\u8CCF\u8CD0\u8CD1\u8CD2\u8CD3\u8CD4\u8CD5\u8CD6\u8CD7\u8CD8\u8CD9\u8CDA\u8CDB\u8CDC\u8CDD\u8CDE\u8CDF\u8CE0\u8CE1\u8CE2\u8CE3\u8CE4\u8CE5\u8CE6\u8CE7\u8CE8\u8CE9\u8CEA\u8CEB\u8CEC\uFFFD\u8CED\u8CEE\u8CEF\u8CF0\u8CF1\u8CF2\u8CF3\u8CF4\u8CF5\u8CF6\u8CF7\u8CF8\u8CF9\u8CFA\u8CFB\u8CFC\u8CFD\u8CFE\u8CFF\u8D00\u8D01\u8D02\u8D03\u8D04\u8D05\u8D06\u8D07\u8D08\u8D09\u8D0A\u8D0B\u8D0C\u8D0D\u4F5F\u4F57\u4F32\u4F3D\u4F76\u4F74\u4F91\u4F89\u4F83\u4F8F\u4F7E\u4F7B\u4FAA\u4F7C\u4FAC\u4F94\u4FE6\u4FE8\u4FEA\u4FC5\u4FDA\u4FE3\u4FDC\u4FD1\u4FDF\u4FF8\u5029\u504C\u4FF3\u502C\u500F\u502E\u502D\u4FFE\u501C\u500C\u5025\u5028\u507E\u5043\u5055\u5048\u504E\u506C\u507B\u50A5\u50A7\u50A9\u50BA\u50D6\u5106\u50ED\u50EC\u50E6\u50EE\u5107\u510B\u4EDD\u6C3D\u4F58\u4F65\u4FCE\u9FA0\u6C46\u7C74\u516E\u5DFD\u9EC9\u9998\u5181\u5914\u52F9\u530D\u8A07\u5310\u51EB\u5919\u5155\u4EA0\u5156\u4EB3\u886E\u88A4\u4EB5\u8114\u88D2\u7980\u5B34\u8803\u7FB8\u51AB\u51B1\u51BD\u51BC\uFFFD".split("");
    for(j = 0; j != D[217].length; ++j)if (D[217][j].charCodeAt(0) !== 0xFFFD) {
        e[D[217][j]] = 55552 + j;
        d[55552 + j] = D[217][j];
    }
    D[218] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8D0E\u8D0F\u8D10\u8D11\u8D12\u8D13\u8D14\u8D15\u8D16\u8D17\u8D18\u8D19\u8D1A\u8D1B\u8D1C\u8D20\u8D51\u8D52\u8D57\u8D5F\u8D65\u8D68\u8D69\u8D6A\u8D6C\u8D6E\u8D6F\u8D71\u8D72\u8D78\u8D79\u8D7A\u8D7B\u8D7C\u8D7D\u8D7E\u8D7F\u8D80\u8D82\u8D83\u8D86\u8D87\u8D88\u8D89\u8D8C\u8D8D\u8D8E\u8D8F\u8D90\u8D92\u8D93\u8D95\u8D96\u8D97\u8D98\u8D99\u8D9A\u8D9B\u8D9C\u8D9D\u8D9E\u8DA0\u8DA1\uFFFD\u8DA2\u8DA4\u8DA5\u8DA6\u8DA7\u8DA8\u8DA9\u8DAA\u8DAB\u8DAC\u8DAD\u8DAE\u8DAF\u8DB0\u8DB2\u8DB6\u8DB7\u8DB9\u8DBB\u8DBD\u8DC0\u8DC1\u8DC2\u8DC5\u8DC7\u8DC8\u8DC9\u8DCA\u8DCD\u8DD0\u8DD2\u8DD3\u8DD4\u51C7\u5196\u51A2\u51A5\u8BA0\u8BA6\u8BA7\u8BAA\u8BB4\u8BB5\u8BB7\u8BC2\u8BC3\u8BCB\u8BCF\u8BCE\u8BD2\u8BD3\u8BD4\u8BD6\u8BD8\u8BD9\u8BDC\u8BDF\u8BE0\u8BE4\u8BE8\u8BE9\u8BEE\u8BF0\u8BF3\u8BF6\u8BF9\u8BFC\u8BFF\u8C00\u8C02\u8C04\u8C07\u8C0C\u8C0F\u8C11\u8C12\u8C14\u8C15\u8C16\u8C19\u8C1B\u8C18\u8C1D\u8C1F\u8C20\u8C21\u8C25\u8C27\u8C2A\u8C2B\u8C2E\u8C2F\u8C32\u8C33\u8C35\u8C36\u5369\u537A\u961D\u9622\u9621\u9631\u962A\u963D\u963C\u9642\u9649\u9654\u965F\u9667\u966C\u9672\u9674\u9688\u968D\u9697\u96B0\u9097\u909B\u909D\u9099\u90AC\u90A1\u90B4\u90B3\u90B6\u90BA\uFFFD".split("");
    for(j = 0; j != D[218].length; ++j)if (D[218][j].charCodeAt(0) !== 0xFFFD) {
        e[D[218][j]] = 55808 + j;
        d[55808 + j] = D[218][j];
    }
    D[219] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8DD5\u8DD8\u8DD9\u8DDC\u8DE0\u8DE1\u8DE2\u8DE5\u8DE6\u8DE7\u8DE9\u8DED\u8DEE\u8DF0\u8DF1\u8DF2\u8DF4\u8DF6\u8DFC\u8DFE\u8DFF\u8E00\u8E01\u8E02\u8E03\u8E04\u8E06\u8E07\u8E08\u8E0B\u8E0D\u8E0E\u8E10\u8E11\u8E12\u8E13\u8E15\u8E16\u8E17\u8E18\u8E19\u8E1A\u8E1B\u8E1C\u8E20\u8E21\u8E24\u8E25\u8E26\u8E27\u8E28\u8E2B\u8E2D\u8E30\u8E32\u8E33\u8E34\u8E36\u8E37\u8E38\u8E3B\u8E3C\u8E3E\uFFFD\u8E3F\u8E43\u8E45\u8E46\u8E4C\u8E4D\u8E4E\u8E4F\u8E50\u8E53\u8E54\u8E55\u8E56\u8E57\u8E58\u8E5A\u8E5B\u8E5C\u8E5D\u8E5E\u8E5F\u8E60\u8E61\u8E62\u8E63\u8E64\u8E65\u8E67\u8E68\u8E6A\u8E6B\u8E6E\u8E71\u90B8\u90B0\u90CF\u90C5\u90BE\u90D0\u90C4\u90C7\u90D3\u90E6\u90E2\u90DC\u90D7\u90DB\u90EB\u90EF\u90FE\u9104\u9122\u911E\u9123\u9131\u912F\u9139\u9143\u9146\u520D\u5942\u52A2\u52AC\u52AD\u52BE\u54FF\u52D0\u52D6\u52F0\u53DF\u71EE\u77CD\u5EF4\u51F5\u51FC\u9B2F\u53B6\u5F01\u755A\u5DEF\u574C\u57A9\u57A1\u587E\u58BC\u58C5\u58D1\u5729\u572C\u572A\u5733\u5739\u572E\u572F\u575C\u573B\u5742\u5769\u5785\u576B\u5786\u577C\u577B\u5768\u576D\u5776\u5773\u57AD\u57A4\u578C\u57B2\u57CF\u57A7\u57B4\u5793\u57A0\u57D5\u57D8\u57DA\u57D9\u57D2\u57B8\u57F4\u57EF\u57F8\u57E4\u57DD\uFFFD".split("");
    for(j = 0; j != D[219].length; ++j)if (D[219][j].charCodeAt(0) !== 0xFFFD) {
        e[D[219][j]] = 56064 + j;
        d[56064 + j] = D[219][j];
    }
    D[220] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8E73\u8E75\u8E77\u8E78\u8E79\u8E7A\u8E7B\u8E7D\u8E7E\u8E80\u8E82\u8E83\u8E84\u8E86\u8E88\u8E89\u8E8A\u8E8B\u8E8C\u8E8D\u8E8E\u8E91\u8E92\u8E93\u8E95\u8E96\u8E97\u8E98\u8E99\u8E9A\u8E9B\u8E9D\u8E9F\u8EA0\u8EA1\u8EA2\u8EA3\u8EA4\u8EA5\u8EA6\u8EA7\u8EA8\u8EA9\u8EAA\u8EAD\u8EAE\u8EB0\u8EB1\u8EB3\u8EB4\u8EB5\u8EB6\u8EB7\u8EB8\u8EB9\u8EBB\u8EBC\u8EBD\u8EBE\u8EBF\u8EC0\u8EC1\u8EC2\uFFFD\u8EC3\u8EC4\u8EC5\u8EC6\u8EC7\u8EC8\u8EC9\u8ECA\u8ECB\u8ECC\u8ECD\u8ECF\u8ED0\u8ED1\u8ED2\u8ED3\u8ED4\u8ED5\u8ED6\u8ED7\u8ED8\u8ED9\u8EDA\u8EDB\u8EDC\u8EDD\u8EDE\u8EDF\u8EE0\u8EE1\u8EE2\u8EE3\u8EE4\u580B\u580D\u57FD\u57ED\u5800\u581E\u5819\u5844\u5820\u5865\u586C\u5881\u5889\u589A\u5880\u99A8\u9F19\u61FF\u8279\u827D\u827F\u828F\u828A\u82A8\u8284\u828E\u8291\u8297\u8299\u82AB\u82B8\u82BE\u82B0\u82C8\u82CA\u82E3\u8298\u82B7\u82AE\u82CB\u82CC\u82C1\u82A9\u82B4\u82A1\u82AA\u829F\u82C4\u82CE\u82A4\u82E1\u8309\u82F7\u82E4\u830F\u8307\u82DC\u82F4\u82D2\u82D8\u830C\u82FB\u82D3\u8311\u831A\u8306\u8314\u8315\u82E0\u82D5\u831C\u8351\u835B\u835C\u8308\u8392\u833C\u8334\u8331\u839B\u835E\u832F\u834F\u8347\u8343\u835F\u8340\u8317\u8360\u832D\u833A\u8333\u8366\u8365\uFFFD".split("");
    for(j = 0; j != D[220].length; ++j)if (D[220][j].charCodeAt(0) !== 0xFFFD) {
        e[D[220][j]] = 56320 + j;
        d[56320 + j] = D[220][j];
    }
    D[221] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8EE5\u8EE6\u8EE7\u8EE8\u8EE9\u8EEA\u8EEB\u8EEC\u8EED\u8EEE\u8EEF\u8EF0\u8EF1\u8EF2\u8EF3\u8EF4\u8EF5\u8EF6\u8EF7\u8EF8\u8EF9\u8EFA\u8EFB\u8EFC\u8EFD\u8EFE\u8EFF\u8F00\u8F01\u8F02\u8F03\u8F04\u8F05\u8F06\u8F07\u8F08\u8F09\u8F0A\u8F0B\u8F0C\u8F0D\u8F0E\u8F0F\u8F10\u8F11\u8F12\u8F13\u8F14\u8F15\u8F16\u8F17\u8F18\u8F19\u8F1A\u8F1B\u8F1C\u8F1D\u8F1E\u8F1F\u8F20\u8F21\u8F22\u8F23\uFFFD\u8F24\u8F25\u8F26\u8F27\u8F28\u8F29\u8F2A\u8F2B\u8F2C\u8F2D\u8F2E\u8F2F\u8F30\u8F31\u8F32\u8F33\u8F34\u8F35\u8F36\u8F37\u8F38\u8F39\u8F3A\u8F3B\u8F3C\u8F3D\u8F3E\u8F3F\u8F40\u8F41\u8F42\u8F43\u8F44\u8368\u831B\u8369\u836C\u836A\u836D\u836E\u83B0\u8378\u83B3\u83B4\u83A0\u83AA\u8393\u839C\u8385\u837C\u83B6\u83A9\u837D\u83B8\u837B\u8398\u839E\u83A8\u83BA\u83BC\u83C1\u8401\u83E5\u83D8\u5807\u8418\u840B\u83DD\u83FD\u83D6\u841C\u8438\u8411\u8406\u83D4\u83DF\u840F\u8403\u83F8\u83F9\u83EA\u83C5\u83C0\u8426\u83F0\u83E1\u845C\u8451\u845A\u8459\u8473\u8487\u8488\u847A\u8489\u8478\u843C\u8446\u8469\u8476\u848C\u848E\u8431\u846D\u84C1\u84CD\u84D0\u84E6\u84BD\u84D3\u84CA\u84BF\u84BA\u84E0\u84A1\u84B9\u84B4\u8497\u84E5\u84E3\u850C\u750D\u8538\u84F0\u8539\u851F\u853A\uFFFD".split("");
    for(j = 0; j != D[221].length; ++j)if (D[221][j].charCodeAt(0) !== 0xFFFD) {
        e[D[221][j]] = 56576 + j;
        d[56576 + j] = D[221][j];
    }
    D[222] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8F45\u8F46\u8F47\u8F48\u8F49\u8F4A\u8F4B\u8F4C\u8F4D\u8F4E\u8F4F\u8F50\u8F51\u8F52\u8F53\u8F54\u8F55\u8F56\u8F57\u8F58\u8F59\u8F5A\u8F5B\u8F5C\u8F5D\u8F5E\u8F5F\u8F60\u8F61\u8F62\u8F63\u8F64\u8F65\u8F6A\u8F80\u8F8C\u8F92\u8F9D\u8FA0\u8FA1\u8FA2\u8FA4\u8FA5\u8FA6\u8FA7\u8FAA\u8FAC\u8FAD\u8FAE\u8FAF\u8FB2\u8FB3\u8FB4\u8FB5\u8FB7\u8FB8\u8FBA\u8FBB\u8FBC\u8FBF\u8FC0\u8FC3\u8FC6\uFFFD\u8FC9\u8FCA\u8FCB\u8FCC\u8FCD\u8FCF\u8FD2\u8FD6\u8FD7\u8FDA\u8FE0\u8FE1\u8FE3\u8FE7\u8FEC\u8FEF\u8FF1\u8FF2\u8FF4\u8FF5\u8FF6\u8FFA\u8FFB\u8FFC\u8FFE\u8FFF\u9007\u9008\u900C\u900E\u9013\u9015\u9018\u8556\u853B\u84FF\u84FC\u8559\u8548\u8568\u8564\u855E\u857A\u77A2\u8543\u8572\u857B\u85A4\u85A8\u8587\u858F\u8579\u85AE\u859C\u8585\u85B9\u85B7\u85B0\u85D3\u85C1\u85DC\u85FF\u8627\u8605\u8629\u8616\u863C\u5EFE\u5F08\u593C\u5941\u8037\u5955\u595A\u5958\u530F\u5C22\u5C25\u5C2C\u5C34\u624C\u626A\u629F\u62BB\u62CA\u62DA\u62D7\u62EE\u6322\u62F6\u6339\u634B\u6343\u63AD\u63F6\u6371\u637A\u638E\u63B4\u636D\u63AC\u638A\u6369\u63AE\u63BC\u63F2\u63F8\u63E0\u63FF\u63C4\u63DE\u63CE\u6452\u63C6\u63BE\u6445\u6441\u640B\u641B\u6420\u640C\u6426\u6421\u645E\u6484\u646D\u6496\uFFFD".split("");
    for(j = 0; j != D[222].length; ++j)if (D[222][j].charCodeAt(0) !== 0xFFFD) {
        e[D[222][j]] = 56832 + j;
        d[56832 + j] = D[222][j];
    }
    D[223] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9019\u901C\u9023\u9024\u9025\u9027\u9028\u9029\u902A\u902B\u902C\u9030\u9031\u9032\u9033\u9034\u9037\u9039\u903A\u903D\u903F\u9040\u9043\u9045\u9046\u9048\u9049\u904A\u904B\u904C\u904E\u9054\u9055\u9056\u9059\u905A\u905C\u905D\u905E\u905F\u9060\u9061\u9064\u9066\u9067\u9069\u906A\u906B\u906C\u906F\u9070\u9071\u9072\u9073\u9076\u9077\u9078\u9079\u907A\u907B\u907C\u907E\u9081\uFFFD\u9084\u9085\u9086\u9087\u9089\u908A\u908C\u908D\u908E\u908F\u9090\u9092\u9094\u9096\u9098\u909A\u909C\u909E\u909F\u90A0\u90A4\u90A5\u90A7\u90A8\u90A9\u90AB\u90AD\u90B2\u90B7\u90BC\u90BD\u90BF\u90C0\u647A\u64B7\u64B8\u6499\u64BA\u64C0\u64D0\u64D7\u64E4\u64E2\u6509\u6525\u652E\u5F0B\u5FD2\u7519\u5F11\u535F\u53F1\u53FD\u53E9\u53E8\u53FB\u5412\u5416\u5406\u544B\u5452\u5453\u5454\u5456\u5443\u5421\u5457\u5459\u5423\u5432\u5482\u5494\u5477\u5471\u5464\u549A\u549B\u5484\u5476\u5466\u549D\u54D0\u54AD\u54C2\u54B4\u54D2\u54A7\u54A6\u54D3\u54D4\u5472\u54A3\u54D5\u54BB\u54BF\u54CC\u54D9\u54DA\u54DC\u54A9\u54AA\u54A4\u54DD\u54CF\u54DE\u551B\u54E7\u5520\u54FD\u5514\u54F3\u5522\u5523\u550F\u5511\u5527\u552A\u5567\u558F\u55B5\u5549\u556D\u5541\u5555\u553F\u5550\u553C\uFFFD".split("");
    for(j = 0; j != D[223].length; ++j)if (D[223][j].charCodeAt(0) !== 0xFFFD) {
        e[D[223][j]] = 57088 + j;
        d[57088 + j] = D[223][j];
    }
    D[224] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u90C2\u90C3\u90C6\u90C8\u90C9\u90CB\u90CC\u90CD\u90D2\u90D4\u90D5\u90D6\u90D8\u90D9\u90DA\u90DE\u90DF\u90E0\u90E3\u90E4\u90E5\u90E9\u90EA\u90EC\u90EE\u90F0\u90F1\u90F2\u90F3\u90F5\u90F6\u90F7\u90F9\u90FA\u90FB\u90FC\u90FF\u9100\u9101\u9103\u9105\u9106\u9107\u9108\u9109\u910A\u910B\u910C\u910D\u910E\u910F\u9110\u9111\u9112\u9113\u9114\u9115\u9116\u9117\u9118\u911A\u911B\u911C\uFFFD\u911D\u911F\u9120\u9121\u9124\u9125\u9126\u9127\u9128\u9129\u912A\u912B\u912C\u912D\u912E\u9130\u9132\u9133\u9134\u9135\u9136\u9137\u9138\u913A\u913B\u913C\u913D\u913E\u913F\u9140\u9141\u9142\u9144\u5537\u5556\u5575\u5576\u5577\u5533\u5530\u555C\u558B\u55D2\u5583\u55B1\u55B9\u5588\u5581\u559F\u557E\u55D6\u5591\u557B\u55DF\u55BD\u55BE\u5594\u5599\u55EA\u55F7\u55C9\u561F\u55D1\u55EB\u55EC\u55D4\u55E6\u55DD\u55C4\u55EF\u55E5\u55F2\u55F3\u55CC\u55CD\u55E8\u55F5\u55E4\u8F94\u561E\u5608\u560C\u5601\u5624\u5623\u55FE\u5600\u5627\u562D\u5658\u5639\u5657\u562C\u564D\u5662\u5659\u565C\u564C\u5654\u5686\u5664\u5671\u566B\u567B\u567C\u5685\u5693\u56AF\u56D4\u56D7\u56DD\u56E1\u56F5\u56EB\u56F9\u56FF\u5704\u570A\u5709\u571C\u5E0F\u5E19\u5E14\u5E11\u5E31\u5E3B\u5E3C\uFFFD".split("");
    for(j = 0; j != D[224].length; ++j)if (D[224][j].charCodeAt(0) !== 0xFFFD) {
        e[D[224][j]] = 57344 + j;
        d[57344 + j] = D[224][j];
    }
    D[225] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9145\u9147\u9148\u9151\u9153\u9154\u9155\u9156\u9158\u9159\u915B\u915C\u915F\u9160\u9166\u9167\u9168\u916B\u916D\u9173\u917A\u917B\u917C\u9180\u9181\u9182\u9183\u9184\u9186\u9188\u918A\u918E\u918F\u9193\u9194\u9195\u9196\u9197\u9198\u9199\u919C\u919D\u919E\u919F\u91A0\u91A1\u91A4\u91A5\u91A6\u91A7\u91A8\u91A9\u91AB\u91AC\u91B0\u91B1\u91B2\u91B3\u91B6\u91B7\u91B8\u91B9\u91BB\uFFFD\u91BC\u91BD\u91BE\u91BF\u91C0\u91C1\u91C2\u91C3\u91C4\u91C5\u91C6\u91C8\u91CB\u91D0\u91D2\u91D3\u91D4\u91D5\u91D6\u91D7\u91D8\u91D9\u91DA\u91DB\u91DD\u91DE\u91DF\u91E0\u91E1\u91E2\u91E3\u91E4\u91E5\u5E37\u5E44\u5E54\u5E5B\u5E5E\u5E61\u5C8C\u5C7A\u5C8D\u5C90\u5C96\u5C88\u5C98\u5C99\u5C91\u5C9A\u5C9C\u5CB5\u5CA2\u5CBD\u5CAC\u5CAB\u5CB1\u5CA3\u5CC1\u5CB7\u5CC4\u5CD2\u5CE4\u5CCB\u5CE5\u5D02\u5D03\u5D27\u5D26\u5D2E\u5D24\u5D1E\u5D06\u5D1B\u5D58\u5D3E\u5D34\u5D3D\u5D6C\u5D5B\u5D6F\u5D5D\u5D6B\u5D4B\u5D4A\u5D69\u5D74\u5D82\u5D99\u5D9D\u8C73\u5DB7\u5DC5\u5F73\u5F77\u5F82\u5F87\u5F89\u5F8C\u5F95\u5F99\u5F9C\u5FA8\u5FAD\u5FB5\u5FBC\u8862\u5F61\u72AD\u72B0\u72B4\u72B7\u72B8\u72C3\u72C1\u72CE\u72CD\u72D2\u72E8\u72EF\u72E9\u72F2\u72F4\u72F7\u7301\u72F3\u7303\u72FA\uFFFD".split("");
    for(j = 0; j != D[225].length; ++j)if (D[225][j].charCodeAt(0) !== 0xFFFD) {
        e[D[225][j]] = 57600 + j;
        d[57600 + j] = D[225][j];
    }
    D[226] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u91E6\u91E7\u91E8\u91E9\u91EA\u91EB\u91EC\u91ED\u91EE\u91EF\u91F0\u91F1\u91F2\u91F3\u91F4\u91F5\u91F6\u91F7\u91F8\u91F9\u91FA\u91FB\u91FC\u91FD\u91FE\u91FF\u9200\u9201\u9202\u9203\u9204\u9205\u9206\u9207\u9208\u9209\u920A\u920B\u920C\u920D\u920E\u920F\u9210\u9211\u9212\u9213\u9214\u9215\u9216\u9217\u9218\u9219\u921A\u921B\u921C\u921D\u921E\u921F\u9220\u9221\u9222\u9223\u9224\uFFFD\u9225\u9226\u9227\u9228\u9229\u922A\u922B\u922C\u922D\u922E\u922F\u9230\u9231\u9232\u9233\u9234\u9235\u9236\u9237\u9238\u9239\u923A\u923B\u923C\u923D\u923E\u923F\u9240\u9241\u9242\u9243\u9244\u9245\u72FB\u7317\u7313\u7321\u730A\u731E\u731D\u7315\u7322\u7339\u7325\u732C\u7338\u7331\u7350\u734D\u7357\u7360\u736C\u736F\u737E\u821B\u5925\u98E7\u5924\u5902\u9963\u9967\u9968\u9969\u996A\u996B\u996C\u9974\u9977\u997D\u9980\u9984\u9987\u998A\u998D\u9990\u9991\u9993\u9994\u9995\u5E80\u5E91\u5E8B\u5E96\u5EA5\u5EA0\u5EB9\u5EB5\u5EBE\u5EB3\u8D53\u5ED2\u5ED1\u5EDB\u5EE8\u5EEA\u81BA\u5FC4\u5FC9\u5FD6\u5FCF\u6003\u5FEE\u6004\u5FE1\u5FE4\u5FFE\u6005\u6006\u5FEA\u5FED\u5FF8\u6019\u6035\u6026\u601B\u600F\u600D\u6029\u602B\u600A\u603F\u6021\u6078\u6079\u607B\u607A\u6042\uFFFD".split("");
    for(j = 0; j != D[226].length; ++j)if (D[226][j].charCodeAt(0) !== 0xFFFD) {
        e[D[226][j]] = 57856 + j;
        d[57856 + j] = D[226][j];
    }
    D[227] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9246\u9247\u9248\u9249\u924A\u924B\u924C\u924D\u924E\u924F\u9250\u9251\u9252\u9253\u9254\u9255\u9256\u9257\u9258\u9259\u925A\u925B\u925C\u925D\u925E\u925F\u9260\u9261\u9262\u9263\u9264\u9265\u9266\u9267\u9268\u9269\u926A\u926B\u926C\u926D\u926E\u926F\u9270\u9271\u9272\u9273\u9275\u9276\u9277\u9278\u9279\u927A\u927B\u927C\u927D\u927E\u927F\u9280\u9281\u9282\u9283\u9284\u9285\uFFFD\u9286\u9287\u9288\u9289\u928A\u928B\u928C\u928D\u928F\u9290\u9291\u9292\u9293\u9294\u9295\u9296\u9297\u9298\u9299\u929A\u929B\u929C\u929D\u929E\u929F\u92A0\u92A1\u92A2\u92A3\u92A4\u92A5\u92A6\u92A7\u606A\u607D\u6096\u609A\u60AD\u609D\u6083\u6092\u608C\u609B\u60EC\u60BB\u60B1\u60DD\u60D8\u60C6\u60DA\u60B4\u6120\u6126\u6115\u6123\u60F4\u6100\u610E\u612B\u614A\u6175\u61AC\u6194\u61A7\u61B7\u61D4\u61F5\u5FDD\u96B3\u95E9\u95EB\u95F1\u95F3\u95F5\u95F6\u95FC\u95FE\u9603\u9604\u9606\u9608\u960A\u960B\u960C\u960D\u960F\u9612\u9615\u9616\u9617\u9619\u961A\u4E2C\u723F\u6215\u6C35\u6C54\u6C5C\u6C4A\u6CA3\u6C85\u6C90\u6C94\u6C8C\u6C68\u6C69\u6C74\u6C76\u6C86\u6CA9\u6CD0\u6CD4\u6CAD\u6CF7\u6CF8\u6CF1\u6CD7\u6CB2\u6CE0\u6CD6\u6CFA\u6CEB\u6CEE\u6CB1\u6CD3\u6CEF\u6CFE\uFFFD".split("");
    for(j = 0; j != D[227].length; ++j)if (D[227][j].charCodeAt(0) !== 0xFFFD) {
        e[D[227][j]] = 58112 + j;
        d[58112 + j] = D[227][j];
    }
    D[228] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u92A8\u92A9\u92AA\u92AB\u92AC\u92AD\u92AF\u92B0\u92B1\u92B2\u92B3\u92B4\u92B5\u92B6\u92B7\u92B8\u92B9\u92BA\u92BB\u92BC\u92BD\u92BE\u92BF\u92C0\u92C1\u92C2\u92C3\u92C4\u92C5\u92C6\u92C7\u92C9\u92CA\u92CB\u92CC\u92CD\u92CE\u92CF\u92D0\u92D1\u92D2\u92D3\u92D4\u92D5\u92D6\u92D7\u92D8\u92D9\u92DA\u92DB\u92DC\u92DD\u92DE\u92DF\u92E0\u92E1\u92E2\u92E3\u92E4\u92E5\u92E6\u92E7\u92E8\uFFFD\u92E9\u92EA\u92EB\u92EC\u92ED\u92EE\u92EF\u92F0\u92F1\u92F2\u92F3\u92F4\u92F5\u92F6\u92F7\u92F8\u92F9\u92FA\u92FB\u92FC\u92FD\u92FE\u92FF\u9300\u9301\u9302\u9303\u9304\u9305\u9306\u9307\u9308\u9309\u6D39\u6D27\u6D0C\u6D43\u6D48\u6D07\u6D04\u6D19\u6D0E\u6D2B\u6D4D\u6D2E\u6D35\u6D1A\u6D4F\u6D52\u6D54\u6D33\u6D91\u6D6F\u6D9E\u6DA0\u6D5E\u6D93\u6D94\u6D5C\u6D60\u6D7C\u6D63\u6E1A\u6DC7\u6DC5\u6DDE\u6E0E\u6DBF\u6DE0\u6E11\u6DE6\u6DDD\u6DD9\u6E16\u6DAB\u6E0C\u6DAE\u6E2B\u6E6E\u6E4E\u6E6B\u6EB2\u6E5F\u6E86\u6E53\u6E54\u6E32\u6E25\u6E44\u6EDF\u6EB1\u6E98\u6EE0\u6F2D\u6EE2\u6EA5\u6EA7\u6EBD\u6EBB\u6EB7\u6ED7\u6EB4\u6ECF\u6E8F\u6EC2\u6E9F\u6F62\u6F46\u6F47\u6F24\u6F15\u6EF9\u6F2F\u6F36\u6F4B\u6F74\u6F2A\u6F09\u6F29\u6F89\u6F8D\u6F8C\u6F78\u6F72\u6F7C\u6F7A\u6FD1\uFFFD".split("");
    for(j = 0; j != D[228].length; ++j)if (D[228][j].charCodeAt(0) !== 0xFFFD) {
        e[D[228][j]] = 58368 + j;
        d[58368 + j] = D[228][j];
    }
    D[229] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u930A\u930B\u930C\u930D\u930E\u930F\u9310\u9311\u9312\u9313\u9314\u9315\u9316\u9317\u9318\u9319\u931A\u931B\u931C\u931D\u931E\u931F\u9320\u9321\u9322\u9323\u9324\u9325\u9326\u9327\u9328\u9329\u932A\u932B\u932C\u932D\u932E\u932F\u9330\u9331\u9332\u9333\u9334\u9335\u9336\u9337\u9338\u9339\u933A\u933B\u933C\u933D\u933F\u9340\u9341\u9342\u9343\u9344\u9345\u9346\u9347\u9348\u9349\uFFFD\u934A\u934B\u934C\u934D\u934E\u934F\u9350\u9351\u9352\u9353\u9354\u9355\u9356\u9357\u9358\u9359\u935A\u935B\u935C\u935D\u935E\u935F\u9360\u9361\u9362\u9363\u9364\u9365\u9366\u9367\u9368\u9369\u936B\u6FC9\u6FA7\u6FB9\u6FB6\u6FC2\u6FE1\u6FEE\u6FDE\u6FE0\u6FEF\u701A\u7023\u701B\u7039\u7035\u704F\u705E\u5B80\u5B84\u5B95\u5B93\u5BA5\u5BB8\u752F\u9A9E\u6434\u5BE4\u5BEE\u8930\u5BF0\u8E47\u8B07\u8FB6\u8FD3\u8FD5\u8FE5\u8FEE\u8FE4\u8FE9\u8FE6\u8FF3\u8FE8\u9005\u9004\u900B\u9026\u9011\u900D\u9016\u9021\u9035\u9036\u902D\u902F\u9044\u9051\u9052\u9050\u9068\u9058\u9062\u905B\u66B9\u9074\u907D\u9082\u9088\u9083\u908B\u5F50\u5F57\u5F56\u5F58\u5C3B\u54AB\u5C50\u5C59\u5B71\u5C63\u5C66\u7FBC\u5F2A\u5F29\u5F2D\u8274\u5F3C\u9B3B\u5C6E\u5981\u5983\u598D\u59A9\u59AA\u59A3\uFFFD".split("");
    for(j = 0; j != D[229].length; ++j)if (D[229][j].charCodeAt(0) !== 0xFFFD) {
        e[D[229][j]] = 58624 + j;
        d[58624 + j] = D[229][j];
    }
    D[230] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u936C\u936D\u936E\u936F\u9370\u9371\u9372\u9373\u9374\u9375\u9376\u9377\u9378\u9379\u937A\u937B\u937C\u937D\u937E\u937F\u9380\u9381\u9382\u9383\u9384\u9385\u9386\u9387\u9388\u9389\u938A\u938B\u938C\u938D\u938E\u9390\u9391\u9392\u9393\u9394\u9395\u9396\u9397\u9398\u9399\u939A\u939B\u939C\u939D\u939E\u939F\u93A0\u93A1\u93A2\u93A3\u93A4\u93A5\u93A6\u93A7\u93A8\u93A9\u93AA\u93AB\uFFFD\u93AC\u93AD\u93AE\u93AF\u93B0\u93B1\u93B2\u93B3\u93B4\u93B5\u93B6\u93B7\u93B8\u93B9\u93BA\u93BB\u93BC\u93BD\u93BE\u93BF\u93C0\u93C1\u93C2\u93C3\u93C4\u93C5\u93C6\u93C7\u93C8\u93C9\u93CB\u93CC\u93CD\u5997\u59CA\u59AB\u599E\u59A4\u59D2\u59B2\u59AF\u59D7\u59BE\u5A05\u5A06\u59DD\u5A08\u59E3\u59D8\u59F9\u5A0C\u5A09\u5A32\u5A34\u5A11\u5A23\u5A13\u5A40\u5A67\u5A4A\u5A55\u5A3C\u5A62\u5A75\u80EC\u5AAA\u5A9B\u5A77\u5A7A\u5ABE\u5AEB\u5AB2\u5AD2\u5AD4\u5AB8\u5AE0\u5AE3\u5AF1\u5AD6\u5AE6\u5AD8\u5ADC\u5B09\u5B17\u5B16\u5B32\u5B37\u5B40\u5C15\u5C1C\u5B5A\u5B65\u5B73\u5B51\u5B53\u5B62\u9A75\u9A77\u9A78\u9A7A\u9A7F\u9A7D\u9A80\u9A81\u9A85\u9A88\u9A8A\u9A90\u9A92\u9A93\u9A96\u9A98\u9A9B\u9A9C\u9A9D\u9A9F\u9AA0\u9AA2\u9AA3\u9AA5\u9AA7\u7E9F\u7EA1\u7EA3\u7EA5\u7EA8\u7EA9\uFFFD".split("");
    for(j = 0; j != D[230].length; ++j)if (D[230][j].charCodeAt(0) !== 0xFFFD) {
        e[D[230][j]] = 58880 + j;
        d[58880 + j] = D[230][j];
    }
    D[231] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u93CE\u93CF\u93D0\u93D1\u93D2\u93D3\u93D4\u93D5\u93D7\u93D8\u93D9\u93DA\u93DB\u93DC\u93DD\u93DE\u93DF\u93E0\u93E1\u93E2\u93E3\u93E4\u93E5\u93E6\u93E7\u93E8\u93E9\u93EA\u93EB\u93EC\u93ED\u93EE\u93EF\u93F0\u93F1\u93F2\u93F3\u93F4\u93F5\u93F6\u93F7\u93F8\u93F9\u93FA\u93FB\u93FC\u93FD\u93FE\u93FF\u9400\u9401\u9402\u9403\u9404\u9405\u9406\u9407\u9408\u9409\u940A\u940B\u940C\u940D\uFFFD\u940E\u940F\u9410\u9411\u9412\u9413\u9414\u9415\u9416\u9417\u9418\u9419\u941A\u941B\u941C\u941D\u941E\u941F\u9420\u9421\u9422\u9423\u9424\u9425\u9426\u9427\u9428\u9429\u942A\u942B\u942C\u942D\u942E\u7EAD\u7EB0\u7EBE\u7EC0\u7EC1\u7EC2\u7EC9\u7ECB\u7ECC\u7ED0\u7ED4\u7ED7\u7EDB\u7EE0\u7EE1\u7EE8\u7EEB\u7EEE\u7EEF\u7EF1\u7EF2\u7F0D\u7EF6\u7EFA\u7EFB\u7EFE\u7F01\u7F02\u7F03\u7F07\u7F08\u7F0B\u7F0C\u7F0F\u7F11\u7F12\u7F17\u7F19\u7F1C\u7F1B\u7F1F\u7F21\u7F22\u7F23\u7F24\u7F25\u7F26\u7F27\u7F2A\u7F2B\u7F2C\u7F2D\u7F2F\u7F30\u7F31\u7F32\u7F33\u7F35\u5E7A\u757F\u5DDB\u753E\u9095\u738E\u7391\u73AE\u73A2\u739F\u73CF\u73C2\u73D1\u73B7\u73B3\u73C0\u73C9\u73C8\u73E5\u73D9\u987C\u740A\u73E9\u73E7\u73DE\u73BA\u73F2\u740F\u742A\u745B\u7426\u7425\u7428\u7430\u742E\u742C\uFFFD".split("");
    for(j = 0; j != D[231].length; ++j)if (D[231][j].charCodeAt(0) !== 0xFFFD) {
        e[D[231][j]] = 59136 + j;
        d[59136 + j] = D[231][j];
    }
    D[232] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u942F\u9430\u9431\u9432\u9433\u9434\u9435\u9436\u9437\u9438\u9439\u943A\u943B\u943C\u943D\u943F\u9440\u9441\u9442\u9443\u9444\u9445\u9446\u9447\u9448\u9449\u944A\u944B\u944C\u944D\u944E\u944F\u9450\u9451\u9452\u9453\u9454\u9455\u9456\u9457\u9458\u9459\u945A\u945B\u945C\u945D\u945E\u945F\u9460\u9461\u9462\u9463\u9464\u9465\u9466\u9467\u9468\u9469\u946A\u946C\u946D\u946E\u946F\uFFFD\u9470\u9471\u9472\u9473\u9474\u9475\u9476\u9477\u9478\u9479\u947A\u947B\u947C\u947D\u947E\u947F\u9480\u9481\u9482\u9483\u9484\u9491\u9496\u9498\u94C7\u94CF\u94D3\u94D4\u94DA\u94E6\u94FB\u951C\u9520\u741B\u741A\u7441\u745C\u7457\u7455\u7459\u7477\u746D\u747E\u749C\u748E\u7480\u7481\u7487\u748B\u749E\u74A8\u74A9\u7490\u74A7\u74D2\u74BA\u97EA\u97EB\u97EC\u674C\u6753\u675E\u6748\u6769\u67A5\u6787\u676A\u6773\u6798\u67A7\u6775\u67A8\u679E\u67AD\u678B\u6777\u677C\u67F0\u6809\u67D8\u680A\u67E9\u67B0\u680C\u67D9\u67B5\u67DA\u67B3\u67DD\u6800\u67C3\u67B8\u67E2\u680E\u67C1\u67FD\u6832\u6833\u6860\u6861\u684E\u6862\u6844\u6864\u6883\u681D\u6855\u6866\u6841\u6867\u6840\u683E\u684A\u6849\u6829\u68B5\u688F\u6874\u6877\u6893\u686B\u68C2\u696E\u68FC\u691F\u6920\u68F9\uFFFD".split("");
    for(j = 0; j != D[232].length; ++j)if (D[232][j].charCodeAt(0) !== 0xFFFD) {
        e[D[232][j]] = 59392 + j;
        d[59392 + j] = D[232][j];
    }
    D[233] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9527\u9533\u953D\u9543\u9548\u954B\u9555\u955A\u9560\u956E\u9574\u9575\u9577\u9578\u9579\u957A\u957B\u957C\u957D\u957E\u9580\u9581\u9582\u9583\u9584\u9585\u9586\u9587\u9588\u9589\u958A\u958B\u958C\u958D\u958E\u958F\u9590\u9591\u9592\u9593\u9594\u9595\u9596\u9597\u9598\u9599\u959A\u959B\u959C\u959D\u959E\u959F\u95A0\u95A1\u95A2\u95A3\u95A4\u95A5\u95A6\u95A7\u95A8\u95A9\u95AA\uFFFD\u95AB\u95AC\u95AD\u95AE\u95AF\u95B0\u95B1\u95B2\u95B3\u95B4\u95B5\u95B6\u95B7\u95B8\u95B9\u95BA\u95BB\u95BC\u95BD\u95BE\u95BF\u95C0\u95C1\u95C2\u95C3\u95C4\u95C5\u95C6\u95C7\u95C8\u95C9\u95CA\u95CB\u6924\u68F0\u690B\u6901\u6957\u68E3\u6910\u6971\u6939\u6960\u6942\u695D\u6984\u696B\u6980\u6998\u6978\u6934\u69CC\u6987\u6988\u69CE\u6989\u6966\u6963\u6979\u699B\u69A7\u69BB\u69AB\u69AD\u69D4\u69B1\u69C1\u69CA\u69DF\u6995\u69E0\u698D\u69FF\u6A2F\u69ED\u6A17\u6A18\u6A65\u69F2\u6A44\u6A3E\u6AA0\u6A50\u6A5B\u6A35\u6A8E\u6A79\u6A3D\u6A28\u6A58\u6A7C\u6A91\u6A90\u6AA9\u6A97\u6AAB\u7337\u7352\u6B81\u6B82\u6B87\u6B84\u6B92\u6B93\u6B8D\u6B9A\u6B9B\u6BA1\u6BAA\u8F6B\u8F6D\u8F71\u8F72\u8F73\u8F75\u8F76\u8F78\u8F77\u8F79\u8F7A\u8F7C\u8F7E\u8F81\u8F82\u8F84\u8F87\u8F8B\uFFFD".split("");
    for(j = 0; j != D[233].length; ++j)if (D[233][j].charCodeAt(0) !== 0xFFFD) {
        e[D[233][j]] = 59648 + j;
        d[59648 + j] = D[233][j];
    }
    D[234] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u95CC\u95CD\u95CE\u95CF\u95D0\u95D1\u95D2\u95D3\u95D4\u95D5\u95D6\u95D7\u95D8\u95D9\u95DA\u95DB\u95DC\u95DD\u95DE\u95DF\u95E0\u95E1\u95E2\u95E3\u95E4\u95E5\u95E6\u95E7\u95EC\u95FF\u9607\u9613\u9618\u961B\u961E\u9620\u9623\u9624\u9625\u9626\u9627\u9628\u9629\u962B\u962C\u962D\u962F\u9630\u9637\u9638\u9639\u963A\u963E\u9641\u9643\u964A\u964E\u964F\u9651\u9652\u9653\u9656\u9657\uFFFD\u9658\u9659\u965A\u965C\u965D\u965E\u9660\u9663\u9665\u9666\u966B\u966D\u966E\u966F\u9670\u9671\u9673\u9678\u9679\u967A\u967B\u967C\u967D\u967E\u967F\u9680\u9681\u9682\u9683\u9684\u9687\u9689\u968A\u8F8D\u8F8E\u8F8F\u8F98\u8F9A\u8ECE\u620B\u6217\u621B\u621F\u6222\u6221\u6225\u6224\u622C\u81E7\u74EF\u74F4\u74FF\u750F\u7511\u7513\u6534\u65EE\u65EF\u65F0\u660A\u6619\u6772\u6603\u6615\u6600\u7085\u66F7\u661D\u6634\u6631\u6636\u6635\u8006\u665F\u6654\u6641\u664F\u6656\u6661\u6657\u6677\u6684\u668C\u66A7\u669D\u66BE\u66DB\u66DC\u66E6\u66E9\u8D32\u8D33\u8D36\u8D3B\u8D3D\u8D40\u8D45\u8D46\u8D48\u8D49\u8D47\u8D4D\u8D55\u8D59\u89C7\u89CA\u89CB\u89CC\u89CE\u89CF\u89D0\u89D1\u726E\u729F\u725D\u7266\u726F\u727E\u727F\u7284\u728B\u728D\u728F\u7292\u6308\u6332\u63B0\uFFFD".split("");
    for(j = 0; j != D[234].length; ++j)if (D[234][j].charCodeAt(0) !== 0xFFFD) {
        e[D[234][j]] = 59904 + j;
        d[59904 + j] = D[234][j];
    }
    D[235] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u968C\u968E\u9691\u9692\u9693\u9695\u9696\u969A\u969B\u969D\u969E\u969F\u96A0\u96A1\u96A2\u96A3\u96A4\u96A5\u96A6\u96A8\u96A9\u96AA\u96AB\u96AC\u96AD\u96AE\u96AF\u96B1\u96B2\u96B4\u96B5\u96B7\u96B8\u96BA\u96BB\u96BF\u96C2\u96C3\u96C8\u96CA\u96CB\u96D0\u96D1\u96D3\u96D4\u96D6\u96D7\u96D8\u96D9\u96DA\u96DB\u96DC\u96DD\u96DE\u96DF\u96E1\u96E2\u96E3\u96E4\u96E5\u96E6\u96E7\u96EB\uFFFD\u96EC\u96ED\u96EE\u96F0\u96F1\u96F2\u96F4\u96F5\u96F8\u96FA\u96FB\u96FC\u96FD\u96FF\u9702\u9703\u9705\u970A\u970B\u970C\u9710\u9711\u9712\u9714\u9715\u9717\u9718\u9719\u971A\u971B\u971D\u971F\u9720\u643F\u64D8\u8004\u6BEA\u6BF3\u6BFD\u6BF5\u6BF9\u6C05\u6C07\u6C06\u6C0D\u6C15\u6C18\u6C19\u6C1A\u6C21\u6C29\u6C24\u6C2A\u6C32\u6535\u6555\u656B\u724D\u7252\u7256\u7230\u8662\u5216\u809F\u809C\u8093\u80BC\u670A\u80BD\u80B1\u80AB\u80AD\u80B4\u80B7\u80E7\u80E8\u80E9\u80EA\u80DB\u80C2\u80C4\u80D9\u80CD\u80D7\u6710\u80DD\u80EB\u80F1\u80F4\u80ED\u810D\u810E\u80F2\u80FC\u6715\u8112\u8C5A\u8136\u811E\u812C\u8118\u8132\u8148\u814C\u8153\u8174\u8159\u815A\u8171\u8160\u8169\u817C\u817D\u816D\u8167\u584D\u5AB5\u8188\u8182\u8191\u6ED5\u81A3\u81AA\u81CC\u6726\u81CA\u81BB\uFFFD".split("");
    for(j = 0; j != D[235].length; ++j)if (D[235][j].charCodeAt(0) !== 0xFFFD) {
        e[D[235][j]] = 60160 + j;
        d[60160 + j] = D[235][j];
    }
    D[236] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9721\u9722\u9723\u9724\u9725\u9726\u9727\u9728\u9729\u972B\u972C\u972E\u972F\u9731\u9733\u9734\u9735\u9736\u9737\u973A\u973B\u973C\u973D\u973F\u9740\u9741\u9742\u9743\u9744\u9745\u9746\u9747\u9748\u9749\u974A\u974B\u974C\u974D\u974E\u974F\u9750\u9751\u9754\u9755\u9757\u9758\u975A\u975C\u975D\u975F\u9763\u9764\u9766\u9767\u9768\u976A\u976B\u976C\u976D\u976E\u976F\u9770\u9771\uFFFD\u9772\u9775\u9777\u9778\u9779\u977A\u977B\u977D\u977E\u977F\u9780\u9781\u9782\u9783\u9784\u9786\u9787\u9788\u9789\u978A\u978C\u978E\u978F\u9790\u9793\u9795\u9796\u9797\u9799\u979A\u979B\u979C\u979D\u81C1\u81A6\u6B24\u6B37\u6B39\u6B43\u6B46\u6B59\u98D1\u98D2\u98D3\u98D5\u98D9\u98DA\u6BB3\u5F40\u6BC2\u89F3\u6590\u9F51\u6593\u65BC\u65C6\u65C4\u65C3\u65CC\u65CE\u65D2\u65D6\u7080\u709C\u7096\u709D\u70BB\u70C0\u70B7\u70AB\u70B1\u70E8\u70CA\u7110\u7113\u7116\u712F\u7131\u7173\u715C\u7168\u7145\u7172\u714A\u7178\u717A\u7198\u71B3\u71B5\u71A8\u71A0\u71E0\u71D4\u71E7\u71F9\u721D\u7228\u706C\u7118\u7166\u71B9\u623E\u623D\u6243\u6248\u6249\u793B\u7940\u7946\u7949\u795B\u795C\u7953\u795A\u7962\u7957\u7960\u796F\u7967\u797A\u7985\u798A\u799A\u79A7\u79B3\u5FD1\u5FD0\uFFFD".split("");
    for(j = 0; j != D[236].length; ++j)if (D[236][j].charCodeAt(0) !== 0xFFFD) {
        e[D[236][j]] = 60416 + j;
        d[60416 + j] = D[236][j];
    }
    D[237] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u979E\u979F\u97A1\u97A2\u97A4\u97A5\u97A6\u97A7\u97A8\u97A9\u97AA\u97AC\u97AE\u97B0\u97B1\u97B3\u97B5\u97B6\u97B7\u97B8\u97B9\u97BA\u97BB\u97BC\u97BD\u97BE\u97BF\u97C0\u97C1\u97C2\u97C3\u97C4\u97C5\u97C6\u97C7\u97C8\u97C9\u97CA\u97CB\u97CC\u97CD\u97CE\u97CF\u97D0\u97D1\u97D2\u97D3\u97D4\u97D5\u97D6\u97D7\u97D8\u97D9\u97DA\u97DB\u97DC\u97DD\u97DE\u97DF\u97E0\u97E1\u97E2\u97E3\uFFFD\u97E4\u97E5\u97E8\u97EE\u97EF\u97F0\u97F1\u97F2\u97F4\u97F7\u97F8\u97F9\u97FA\u97FB\u97FC\u97FD\u97FE\u97FF\u9800\u9801\u9802\u9803\u9804\u9805\u9806\u9807\u9808\u9809\u980A\u980B\u980C\u980D\u980E\u603C\u605D\u605A\u6067\u6041\u6059\u6063\u60AB\u6106\u610D\u615D\u61A9\u619D\u61CB\u61D1\u6206\u8080\u807F\u6C93\u6CF6\u6DFC\u77F6\u77F8\u7800\u7809\u7817\u7818\u7811\u65AB\u782D\u781C\u781D\u7839\u783A\u783B\u781F\u783C\u7825\u782C\u7823\u7829\u784E\u786D\u7856\u7857\u7826\u7850\u7847\u784C\u786A\u789B\u7893\u789A\u7887\u789C\u78A1\u78A3\u78B2\u78B9\u78A5\u78D4\u78D9\u78C9\u78EC\u78F2\u7905\u78F4\u7913\u7924\u791E\u7934\u9F9B\u9EF9\u9EFB\u9EFC\u76F1\u7704\u770D\u76F9\u7707\u7708\u771A\u7722\u7719\u772D\u7726\u7735\u7738\u7750\u7751\u7747\u7743\u775A\u7768\uFFFD".split("");
    for(j = 0; j != D[237].length; ++j)if (D[237][j].charCodeAt(0) !== 0xFFFD) {
        e[D[237][j]] = 60672 + j;
        d[60672 + j] = D[237][j];
    }
    D[238] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u980F\u9810\u9811\u9812\u9813\u9814\u9815\u9816\u9817\u9818\u9819\u981A\u981B\u981C\u981D\u981E\u981F\u9820\u9821\u9822\u9823\u9824\u9825\u9826\u9827\u9828\u9829\u982A\u982B\u982C\u982D\u982E\u982F\u9830\u9831\u9832\u9833\u9834\u9835\u9836\u9837\u9838\u9839\u983A\u983B\u983C\u983D\u983E\u983F\u9840\u9841\u9842\u9843\u9844\u9845\u9846\u9847\u9848\u9849\u984A\u984B\u984C\u984D\uFFFD\u984E\u984F\u9850\u9851\u9852\u9853\u9854\u9855\u9856\u9857\u9858\u9859\u985A\u985B\u985C\u985D\u985E\u985F\u9860\u9861\u9862\u9863\u9864\u9865\u9866\u9867\u9868\u9869\u986A\u986B\u986C\u986D\u986E\u7762\u7765\u777F\u778D\u777D\u7780\u778C\u7791\u779F\u77A0\u77B0\u77B5\u77BD\u753A\u7540\u754E\u754B\u7548\u755B\u7572\u7579\u7583\u7F58\u7F61\u7F5F\u8A48\u7F68\u7F74\u7F71\u7F79\u7F81\u7F7E\u76CD\u76E5\u8832\u9485\u9486\u9487\u948B\u948A\u948C\u948D\u948F\u9490\u9494\u9497\u9495\u949A\u949B\u949C\u94A3\u94A4\u94AB\u94AA\u94AD\u94AC\u94AF\u94B0\u94B2\u94B4\u94B6\u94B7\u94B8\u94B9\u94BA\u94BC\u94BD\u94BF\u94C4\u94C8\u94C9\u94CA\u94CB\u94CC\u94CD\u94CE\u94D0\u94D1\u94D2\u94D5\u94D6\u94D7\u94D9\u94D8\u94DB\u94DE\u94DF\u94E0\u94E2\u94E4\u94E5\u94E7\u94E8\u94EA\uFFFD".split("");
    for(j = 0; j != D[238].length; ++j)if (D[238][j].charCodeAt(0) !== 0xFFFD) {
        e[D[238][j]] = 60928 + j;
        d[60928 + j] = D[238][j];
    }
    D[239] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u986F\u9870\u9871\u9872\u9873\u9874\u988B\u988E\u9892\u9895\u9899\u98A3\u98A8\u98A9\u98AA\u98AB\u98AC\u98AD\u98AE\u98AF\u98B0\u98B1\u98B2\u98B3\u98B4\u98B5\u98B6\u98B7\u98B8\u98B9\u98BA\u98BB\u98BC\u98BD\u98BE\u98BF\u98C0\u98C1\u98C2\u98C3\u98C4\u98C5\u98C6\u98C7\u98C8\u98C9\u98CA\u98CB\u98CC\u98CD\u98CF\u98D0\u98D4\u98D6\u98D7\u98DB\u98DC\u98DD\u98E0\u98E1\u98E2\u98E3\u98E4\uFFFD\u98E5\u98E6\u98E9\u98EA\u98EB\u98EC\u98ED\u98EE\u98EF\u98F0\u98F1\u98F2\u98F3\u98F4\u98F5\u98F6\u98F7\u98F8\u98F9\u98FA\u98FB\u98FC\u98FD\u98FE\u98FF\u9900\u9901\u9902\u9903\u9904\u9905\u9906\u9907\u94E9\u94EB\u94EE\u94EF\u94F3\u94F4\u94F5\u94F7\u94F9\u94FC\u94FD\u94FF\u9503\u9502\u9506\u9507\u9509\u950A\u950D\u950E\u950F\u9512\u9513\u9514\u9515\u9516\u9518\u951B\u951D\u951E\u951F\u9522\u952A\u952B\u9529\u952C\u9531\u9532\u9534\u9536\u9537\u9538\u953C\u953E\u953F\u9542\u9535\u9544\u9545\u9546\u9549\u954C\u954E\u954F\u9552\u9553\u9554\u9556\u9557\u9558\u9559\u955B\u955E\u955F\u955D\u9561\u9562\u9564\u9565\u9566\u9567\u9568\u9569\u956A\u956B\u956C\u956F\u9571\u9572\u9573\u953A\u77E7\u77EC\u96C9\u79D5\u79ED\u79E3\u79EB\u7A06\u5D47\u7A03\u7A02\u7A1E\u7A14\uFFFD".split("");
    for(j = 0; j != D[239].length; ++j)if (D[239][j].charCodeAt(0) !== 0xFFFD) {
        e[D[239][j]] = 61184 + j;
        d[61184 + j] = D[239][j];
    }
    D[240] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9908\u9909\u990A\u990B\u990C\u990E\u990F\u9911\u9912\u9913\u9914\u9915\u9916\u9917\u9918\u9919\u991A\u991B\u991C\u991D\u991E\u991F\u9920\u9921\u9922\u9923\u9924\u9925\u9926\u9927\u9928\u9929\u992A\u992B\u992C\u992D\u992F\u9930\u9931\u9932\u9933\u9934\u9935\u9936\u9937\u9938\u9939\u993A\u993B\u993C\u993D\u993E\u993F\u9940\u9941\u9942\u9943\u9944\u9945\u9946\u9947\u9948\u9949\uFFFD\u994A\u994B\u994C\u994D\u994E\u994F\u9950\u9951\u9952\u9953\u9956\u9957\u9958\u9959\u995A\u995B\u995C\u995D\u995E\u995F\u9960\u9961\u9962\u9964\u9966\u9973\u9978\u9979\u997B\u997E\u9982\u9983\u9989\u7A39\u7A37\u7A51\u9ECF\u99A5\u7A70\u7688\u768E\u7693\u7699\u76A4\u74DE\u74E0\u752C\u9E20\u9E22\u9E28\u9E29\u9E2A\u9E2B\u9E2C\u9E32\u9E31\u9E36\u9E38\u9E37\u9E39\u9E3A\u9E3E\u9E41\u9E42\u9E44\u9E46\u9E47\u9E48\u9E49\u9E4B\u9E4C\u9E4E\u9E51\u9E55\u9E57\u9E5A\u9E5B\u9E5C\u9E5E\u9E63\u9E66\u9E67\u9E68\u9E69\u9E6A\u9E6B\u9E6C\u9E71\u9E6D\u9E73\u7592\u7594\u7596\u75A0\u759D\u75AC\u75A3\u75B3\u75B4\u75B8\u75C4\u75B1\u75B0\u75C3\u75C2\u75D6\u75CD\u75E3\u75E8\u75E6\u75E4\u75EB\u75E7\u7603\u75F1\u75FC\u75FF\u7610\u7600\u7605\u760C\u7617\u760A\u7625\u7618\u7615\u7619\uFFFD".split("");
    for(j = 0; j != D[240].length; ++j)if (D[240][j].charCodeAt(0) !== 0xFFFD) {
        e[D[240][j]] = 61440 + j;
        d[61440 + j] = D[240][j];
    }
    D[241] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u998C\u998E\u999A\u999B\u999C\u999D\u999E\u999F\u99A0\u99A1\u99A2\u99A3\u99A4\u99A6\u99A7\u99A9\u99AA\u99AB\u99AC\u99AD\u99AE\u99AF\u99B0\u99B1\u99B2\u99B3\u99B4\u99B5\u99B6\u99B7\u99B8\u99B9\u99BA\u99BB\u99BC\u99BD\u99BE\u99BF\u99C0\u99C1\u99C2\u99C3\u99C4\u99C5\u99C6\u99C7\u99C8\u99C9\u99CA\u99CB\u99CC\u99CD\u99CE\u99CF\u99D0\u99D1\u99D2\u99D3\u99D4\u99D5\u99D6\u99D7\u99D8\uFFFD\u99D9\u99DA\u99DB\u99DC\u99DD\u99DE\u99DF\u99E0\u99E1\u99E2\u99E3\u99E4\u99E5\u99E6\u99E7\u99E8\u99E9\u99EA\u99EB\u99EC\u99ED\u99EE\u99EF\u99F0\u99F1\u99F2\u99F3\u99F4\u99F5\u99F6\u99F7\u99F8\u99F9\u761B\u763C\u7622\u7620\u7640\u762D\u7630\u763F\u7635\u7643\u763E\u7633\u764D\u765E\u7654\u765C\u7656\u766B\u766F\u7FCA\u7AE6\u7A78\u7A79\u7A80\u7A86\u7A88\u7A95\u7AA6\u7AA0\u7AAC\u7AA8\u7AAD\u7AB3\u8864\u8869\u8872\u887D\u887F\u8882\u88A2\u88C6\u88B7\u88BC\u88C9\u88E2\u88CE\u88E3\u88E5\u88F1\u891A\u88FC\u88E8\u88FE\u88F0\u8921\u8919\u8913\u891B\u890A\u8934\u892B\u8936\u8941\u8966\u897B\u758B\u80E5\u76B2\u76B4\u77DC\u8012\u8014\u8016\u801C\u8020\u8022\u8025\u8026\u8027\u8029\u8028\u8031\u800B\u8035\u8043\u8046\u804D\u8052\u8069\u8071\u8983\u9878\u9880\u9883\uFFFD".split("");
    for(j = 0; j != D[241].length; ++j)if (D[241][j].charCodeAt(0) !== 0xFFFD) {
        e[D[241][j]] = 61696 + j;
        d[61696 + j] = D[241][j];
    }
    D[242] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u99FA\u99FB\u99FC\u99FD\u99FE\u99FF\u9A00\u9A01\u9A02\u9A03\u9A04\u9A05\u9A06\u9A07\u9A08\u9A09\u9A0A\u9A0B\u9A0C\u9A0D\u9A0E\u9A0F\u9A10\u9A11\u9A12\u9A13\u9A14\u9A15\u9A16\u9A17\u9A18\u9A19\u9A1A\u9A1B\u9A1C\u9A1D\u9A1E\u9A1F\u9A20\u9A21\u9A22\u9A23\u9A24\u9A25\u9A26\u9A27\u9A28\u9A29\u9A2A\u9A2B\u9A2C\u9A2D\u9A2E\u9A2F\u9A30\u9A31\u9A32\u9A33\u9A34\u9A35\u9A36\u9A37\u9A38\uFFFD\u9A39\u9A3A\u9A3B\u9A3C\u9A3D\u9A3E\u9A3F\u9A40\u9A41\u9A42\u9A43\u9A44\u9A45\u9A46\u9A47\u9A48\u9A49\u9A4A\u9A4B\u9A4C\u9A4D\u9A4E\u9A4F\u9A50\u9A51\u9A52\u9A53\u9A54\u9A55\u9A56\u9A57\u9A58\u9A59\u9889\u988C\u988D\u988F\u9894\u989A\u989B\u989E\u989F\u98A1\u98A2\u98A5\u98A6\u864D\u8654\u866C\u866E\u867F\u867A\u867C\u867B\u86A8\u868D\u868B\u86AC\u869D\u86A7\u86A3\u86AA\u8693\u86A9\u86B6\u86C4\u86B5\u86CE\u86B0\u86BA\u86B1\u86AF\u86C9\u86CF\u86B4\u86E9\u86F1\u86F2\u86ED\u86F3\u86D0\u8713\u86DE\u86F4\u86DF\u86D8\u86D1\u8703\u8707\u86F8\u8708\u870A\u870D\u8709\u8723\u873B\u871E\u8725\u872E\u871A\u873E\u8748\u8734\u8731\u8729\u8737\u873F\u8782\u8722\u877D\u877E\u877B\u8760\u8770\u874C\u876E\u878B\u8753\u8763\u877C\u8764\u8759\u8765\u8793\u87AF\u87A8\u87D2\uFFFD".split("");
    for(j = 0; j != D[242].length; ++j)if (D[242][j].charCodeAt(0) !== 0xFFFD) {
        e[D[242][j]] = 61952 + j;
        d[61952 + j] = D[242][j];
    }
    D[243] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9A5A\u9A5B\u9A5C\u9A5D\u9A5E\u9A5F\u9A60\u9A61\u9A62\u9A63\u9A64\u9A65\u9A66\u9A67\u9A68\u9A69\u9A6A\u9A6B\u9A72\u9A83\u9A89\u9A8D\u9A8E\u9A94\u9A95\u9A99\u9AA6\u9AA9\u9AAA\u9AAB\u9AAC\u9AAD\u9AAE\u9AAF\u9AB2\u9AB3\u9AB4\u9AB5\u9AB9\u9ABB\u9ABD\u9ABE\u9ABF\u9AC3\u9AC4\u9AC6\u9AC7\u9AC8\u9AC9\u9ACA\u9ACD\u9ACE\u9ACF\u9AD0\u9AD2\u9AD4\u9AD5\u9AD6\u9AD7\u9AD9\u9ADA\u9ADB\u9ADC\uFFFD\u9ADD\u9ADE\u9AE0\u9AE2\u9AE3\u9AE4\u9AE5\u9AE7\u9AE8\u9AE9\u9AEA\u9AEC\u9AEE\u9AF0\u9AF1\u9AF2\u9AF3\u9AF4\u9AF5\u9AF6\u9AF7\u9AF8\u9AFA\u9AFC\u9AFD\u9AFE\u9AFF\u9B00\u9B01\u9B02\u9B04\u9B05\u9B06\u87C6\u8788\u8785\u87AD\u8797\u8783\u87AB\u87E5\u87AC\u87B5\u87B3\u87CB\u87D3\u87BD\u87D1\u87C0\u87CA\u87DB\u87EA\u87E0\u87EE\u8816\u8813\u87FE\u880A\u881B\u8821\u8839\u883C\u7F36\u7F42\u7F44\u7F45\u8210\u7AFA\u7AFD\u7B08\u7B03\u7B04\u7B15\u7B0A\u7B2B\u7B0F\u7B47\u7B38\u7B2A\u7B19\u7B2E\u7B31\u7B20\u7B25\u7B24\u7B33\u7B3E\u7B1E\u7B58\u7B5A\u7B45\u7B75\u7B4C\u7B5D\u7B60\u7B6E\u7B7B\u7B62\u7B72\u7B71\u7B90\u7BA6\u7BA7\u7BB8\u7BAC\u7B9D\u7BA8\u7B85\u7BAA\u7B9C\u7BA2\u7BAB\u7BB4\u7BD1\u7BC1\u7BCC\u7BDD\u7BDA\u7BE5\u7BE6\u7BEA\u7C0C\u7BFE\u7BFC\u7C0F\u7C16\u7C0B\uFFFD".split("");
    for(j = 0; j != D[243].length; ++j)if (D[243][j].charCodeAt(0) !== 0xFFFD) {
        e[D[243][j]] = 62208 + j;
        d[62208 + j] = D[243][j];
    }
    D[244] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9B07\u9B09\u9B0A\u9B0B\u9B0C\u9B0D\u9B0E\u9B10\u9B11\u9B12\u9B14\u9B15\u9B16\u9B17\u9B18\u9B19\u9B1A\u9B1B\u9B1C\u9B1D\u9B1E\u9B20\u9B21\u9B22\u9B24\u9B25\u9B26\u9B27\u9B28\u9B29\u9B2A\u9B2B\u9B2C\u9B2D\u9B2E\u9B30\u9B31\u9B33\u9B34\u9B35\u9B36\u9B37\u9B38\u9B39\u9B3A\u9B3D\u9B3E\u9B3F\u9B40\u9B46\u9B4A\u9B4B\u9B4C\u9B4E\u9B50\u9B52\u9B53\u9B55\u9B56\u9B57\u9B58\u9B59\u9B5A\uFFFD\u9B5B\u9B5C\u9B5D\u9B5E\u9B5F\u9B60\u9B61\u9B62\u9B63\u9B64\u9B65\u9B66\u9B67\u9B68\u9B69\u9B6A\u9B6B\u9B6C\u9B6D\u9B6E\u9B6F\u9B70\u9B71\u9B72\u9B73\u9B74\u9B75\u9B76\u9B77\u9B78\u9B79\u9B7A\u9B7B\u7C1F\u7C2A\u7C26\u7C38\u7C41\u7C40\u81FE\u8201\u8202\u8204\u81EC\u8844\u8221\u8222\u8223\u822D\u822F\u8228\u822B\u8238\u823B\u8233\u8234\u823E\u8244\u8249\u824B\u824F\u825A\u825F\u8268\u887E\u8885\u8888\u88D8\u88DF\u895E\u7F9D\u7F9F\u7FA7\u7FAF\u7FB0\u7FB2\u7C7C\u6549\u7C91\u7C9D\u7C9C\u7C9E\u7CA2\u7CB2\u7CBC\u7CBD\u7CC1\u7CC7\u7CCC\u7CCD\u7CC8\u7CC5\u7CD7\u7CE8\u826E\u66A8\u7FBF\u7FCE\u7FD5\u7FE5\u7FE1\u7FE6\u7FE9\u7FEE\u7FF3\u7CF8\u7D77\u7DA6\u7DAE\u7E47\u7E9B\u9EB8\u9EB4\u8D73\u8D84\u8D94\u8D91\u8DB1\u8D67\u8D6D\u8C47\u8C49\u914A\u9150\u914E\u914F\u9164\uFFFD".split("");
    for(j = 0; j != D[244].length; ++j)if (D[244][j].charCodeAt(0) !== 0xFFFD) {
        e[D[244][j]] = 62464 + j;
        d[62464 + j] = D[244][j];
    }
    D[245] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9B7C\u9B7D\u9B7E\u9B7F\u9B80\u9B81\u9B82\u9B83\u9B84\u9B85\u9B86\u9B87\u9B88\u9B89\u9B8A\u9B8B\u9B8C\u9B8D\u9B8E\u9B8F\u9B90\u9B91\u9B92\u9B93\u9B94\u9B95\u9B96\u9B97\u9B98\u9B99\u9B9A\u9B9B\u9B9C\u9B9D\u9B9E\u9B9F\u9BA0\u9BA1\u9BA2\u9BA3\u9BA4\u9BA5\u9BA6\u9BA7\u9BA8\u9BA9\u9BAA\u9BAB\u9BAC\u9BAD\u9BAE\u9BAF\u9BB0\u9BB1\u9BB2\u9BB3\u9BB4\u9BB5\u9BB6\u9BB7\u9BB8\u9BB9\u9BBA\uFFFD\u9BBB\u9BBC\u9BBD\u9BBE\u9BBF\u9BC0\u9BC1\u9BC2\u9BC3\u9BC4\u9BC5\u9BC6\u9BC7\u9BC8\u9BC9\u9BCA\u9BCB\u9BCC\u9BCD\u9BCE\u9BCF\u9BD0\u9BD1\u9BD2\u9BD3\u9BD4\u9BD5\u9BD6\u9BD7\u9BD8\u9BD9\u9BDA\u9BDB\u9162\u9161\u9170\u9169\u916F\u917D\u917E\u9172\u9174\u9179\u918C\u9185\u9190\u918D\u9191\u91A2\u91A3\u91AA\u91AD\u91AE\u91AF\u91B5\u91B4\u91BA\u8C55\u9E7E\u8DB8\u8DEB\u8E05\u8E59\u8E69\u8DB5\u8DBF\u8DBC\u8DBA\u8DC4\u8DD6\u8DD7\u8DDA\u8DDE\u8DCE\u8DCF\u8DDB\u8DC6\u8DEC\u8DF7\u8DF8\u8DE3\u8DF9\u8DFB\u8DE4\u8E09\u8DFD\u8E14\u8E1D\u8E1F\u8E2C\u8E2E\u8E23\u8E2F\u8E3A\u8E40\u8E39\u8E35\u8E3D\u8E31\u8E49\u8E41\u8E42\u8E51\u8E52\u8E4A\u8E70\u8E76\u8E7C\u8E6F\u8E74\u8E85\u8E8F\u8E94\u8E90\u8E9C\u8E9E\u8C78\u8C82\u8C8A\u8C85\u8C98\u8C94\u659B\u89D6\u89DE\u89DA\u89DC\uFFFD".split("");
    for(j = 0; j != D[245].length; ++j)if (D[245][j].charCodeAt(0) !== 0xFFFD) {
        e[D[245][j]] = 62720 + j;
        d[62720 + j] = D[245][j];
    }
    D[246] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9BDC\u9BDD\u9BDE\u9BDF\u9BE0\u9BE1\u9BE2\u9BE3\u9BE4\u9BE5\u9BE6\u9BE7\u9BE8\u9BE9\u9BEA\u9BEB\u9BEC\u9BED\u9BEE\u9BEF\u9BF0\u9BF1\u9BF2\u9BF3\u9BF4\u9BF5\u9BF6\u9BF7\u9BF8\u9BF9\u9BFA\u9BFB\u9BFC\u9BFD\u9BFE\u9BFF\u9C00\u9C01\u9C02\u9C03\u9C04\u9C05\u9C06\u9C07\u9C08\u9C09\u9C0A\u9C0B\u9C0C\u9C0D\u9C0E\u9C0F\u9C10\u9C11\u9C12\u9C13\u9C14\u9C15\u9C16\u9C17\u9C18\u9C19\u9C1A\uFFFD\u9C1B\u9C1C\u9C1D\u9C1E\u9C1F\u9C20\u9C21\u9C22\u9C23\u9C24\u9C25\u9C26\u9C27\u9C28\u9C29\u9C2A\u9C2B\u9C2C\u9C2D\u9C2E\u9C2F\u9C30\u9C31\u9C32\u9C33\u9C34\u9C35\u9C36\u9C37\u9C38\u9C39\u9C3A\u9C3B\u89E5\u89EB\u89EF\u8A3E\u8B26\u9753\u96E9\u96F3\u96EF\u9706\u9701\u9708\u970F\u970E\u972A\u972D\u9730\u973E\u9F80\u9F83\u9F85\u9F86\u9F87\u9F88\u9F89\u9F8A\u9F8C\u9EFE\u9F0B\u9F0D\u96B9\u96BC\u96BD\u96CE\u96D2\u77BF\u96E0\u928E\u92AE\u92C8\u933E\u936A\u93CA\u938F\u943E\u946B\u9C7F\u9C82\u9C85\u9C86\u9C87\u9C88\u7A23\u9C8B\u9C8E\u9C90\u9C91\u9C92\u9C94\u9C95\u9C9A\u9C9B\u9C9E\u9C9F\u9CA0\u9CA1\u9CA2\u9CA3\u9CA5\u9CA6\u9CA7\u9CA8\u9CA9\u9CAB\u9CAD\u9CAE\u9CB0\u9CB1\u9CB2\u9CB3\u9CB4\u9CB5\u9CB6\u9CB7\u9CBA\u9CBB\u9CBC\u9CBD\u9CC4\u9CC5\u9CC6\u9CC7\u9CCA\u9CCB\uFFFD".split("");
    for(j = 0; j != D[246].length; ++j)if (D[246][j].charCodeAt(0) !== 0xFFFD) {
        e[D[246][j]] = 62976 + j;
        d[62976 + j] = D[246][j];
    }
    D[247] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9C3C\u9C3D\u9C3E\u9C3F\u9C40\u9C41\u9C42\u9C43\u9C44\u9C45\u9C46\u9C47\u9C48\u9C49\u9C4A\u9C4B\u9C4C\u9C4D\u9C4E\u9C4F\u9C50\u9C51\u9C52\u9C53\u9C54\u9C55\u9C56\u9C57\u9C58\u9C59\u9C5A\u9C5B\u9C5C\u9C5D\u9C5E\u9C5F\u9C60\u9C61\u9C62\u9C63\u9C64\u9C65\u9C66\u9C67\u9C68\u9C69\u9C6A\u9C6B\u9C6C\u9C6D\u9C6E\u9C6F\u9C70\u9C71\u9C72\u9C73\u9C74\u9C75\u9C76\u9C77\u9C78\u9C79\u9C7A\uFFFD\u9C7B\u9C7D\u9C7E\u9C80\u9C83\u9C84\u9C89\u9C8A\u9C8C\u9C8F\u9C93\u9C96\u9C97\u9C98\u9C99\u9C9D\u9CAA\u9CAC\u9CAF\u9CB9\u9CBE\u9CBF\u9CC0\u9CC1\u9CC2\u9CC8\u9CC9\u9CD1\u9CD2\u9CDA\u9CDB\u9CE0\u9CE1\u9CCC\u9CCD\u9CCE\u9CCF\u9CD0\u9CD3\u9CD4\u9CD5\u9CD7\u9CD8\u9CD9\u9CDC\u9CDD\u9CDF\u9CE2\u977C\u9785\u9791\u9792\u9794\u97AF\u97AB\u97A3\u97B2\u97B4\u9AB1\u9AB0\u9AB7\u9E58\u9AB6\u9ABA\u9ABC\u9AC1\u9AC0\u9AC5\u9AC2\u9ACB\u9ACC\u9AD1\u9B45\u9B43\u9B47\u9B49\u9B48\u9B4D\u9B51\u98E8\u990D\u992E\u9955\u9954\u9ADF\u9AE1\u9AE6\u9AEF\u9AEB\u9AFB\u9AED\u9AF9\u9B08\u9B0F\u9B13\u9B1F\u9B23\u9EBD\u9EBE\u7E3B\u9E82\u9E87\u9E88\u9E8B\u9E92\u93D6\u9E9D\u9E9F\u9EDB\u9EDC\u9EDD\u9EE0\u9EDF\u9EE2\u9EE9\u9EE7\u9EE5\u9EEA\u9EEF\u9F22\u9F2C\u9F2F\u9F39\u9F37\u9F3D\u9F3E\u9F44\uFFFD".split("");
    for(j = 0; j != D[247].length; ++j)if (D[247][j].charCodeAt(0) !== 0xFFFD) {
        e[D[247][j]] = 63232 + j;
        d[63232 + j] = D[247][j];
    }
    D[248] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9CE3\u9CE4\u9CE5\u9CE6\u9CE7\u9CE8\u9CE9\u9CEA\u9CEB\u9CEC\u9CED\u9CEE\u9CEF\u9CF0\u9CF1\u9CF2\u9CF3\u9CF4\u9CF5\u9CF6\u9CF7\u9CF8\u9CF9\u9CFA\u9CFB\u9CFC\u9CFD\u9CFE\u9CFF\u9D00\u9D01\u9D02\u9D03\u9D04\u9D05\u9D06\u9D07\u9D08\u9D09\u9D0A\u9D0B\u9D0C\u9D0D\u9D0E\u9D0F\u9D10\u9D11\u9D12\u9D13\u9D14\u9D15\u9D16\u9D17\u9D18\u9D19\u9D1A\u9D1B\u9D1C\u9D1D\u9D1E\u9D1F\u9D20\u9D21\uFFFD\u9D22\u9D23\u9D24\u9D25\u9D26\u9D27\u9D28\u9D29\u9D2A\u9D2B\u9D2C\u9D2D\u9D2E\u9D2F\u9D30\u9D31\u9D32\u9D33\u9D34\u9D35\u9D36\u9D37\u9D38\u9D39\u9D3A\u9D3B\u9D3C\u9D3D\u9D3E\u9D3F\u9D40\u9D41\u9D42\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[248].length; ++j)if (D[248][j].charCodeAt(0) !== 0xFFFD) {
        e[D[248][j]] = 63488 + j;
        d[63488 + j] = D[248][j];
    }
    D[249] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9D43\u9D44\u9D45\u9D46\u9D47\u9D48\u9D49\u9D4A\u9D4B\u9D4C\u9D4D\u9D4E\u9D4F\u9D50\u9D51\u9D52\u9D53\u9D54\u9D55\u9D56\u9D57\u9D58\u9D59\u9D5A\u9D5B\u9D5C\u9D5D\u9D5E\u9D5F\u9D60\u9D61\u9D62\u9D63\u9D64\u9D65\u9D66\u9D67\u9D68\u9D69\u9D6A\u9D6B\u9D6C\u9D6D\u9D6E\u9D6F\u9D70\u9D71\u9D72\u9D73\u9D74\u9D75\u9D76\u9D77\u9D78\u9D79\u9D7A\u9D7B\u9D7C\u9D7D\u9D7E\u9D7F\u9D80\u9D81\uFFFD\u9D82\u9D83\u9D84\u9D85\u9D86\u9D87\u9D88\u9D89\u9D8A\u9D8B\u9D8C\u9D8D\u9D8E\u9D8F\u9D90\u9D91\u9D92\u9D93\u9D94\u9D95\u9D96\u9D97\u9D98\u9D99\u9D9A\u9D9B\u9D9C\u9D9D\u9D9E\u9D9F\u9DA0\u9DA1\u9DA2\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[249].length; ++j)if (D[249][j].charCodeAt(0) !== 0xFFFD) {
        e[D[249][j]] = 63744 + j;
        d[63744 + j] = D[249][j];
    }
    D[250] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9DA3\u9DA4\u9DA5\u9DA6\u9DA7\u9DA8\u9DA9\u9DAA\u9DAB\u9DAC\u9DAD\u9DAE\u9DAF\u9DB0\u9DB1\u9DB2\u9DB3\u9DB4\u9DB5\u9DB6\u9DB7\u9DB8\u9DB9\u9DBA\u9DBB\u9DBC\u9DBD\u9DBE\u9DBF\u9DC0\u9DC1\u9DC2\u9DC3\u9DC4\u9DC5\u9DC6\u9DC7\u9DC8\u9DC9\u9DCA\u9DCB\u9DCC\u9DCD\u9DCE\u9DCF\u9DD0\u9DD1\u9DD2\u9DD3\u9DD4\u9DD5\u9DD6\u9DD7\u9DD8\u9DD9\u9DDA\u9DDB\u9DDC\u9DDD\u9DDE\u9DDF\u9DE0\u9DE1\uFFFD\u9DE2\u9DE3\u9DE4\u9DE5\u9DE6\u9DE7\u9DE8\u9DE9\u9DEA\u9DEB\u9DEC\u9DED\u9DEE\u9DEF\u9DF0\u9DF1\u9DF2\u9DF3\u9DF4\u9DF5\u9DF6\u9DF7\u9DF8\u9DF9\u9DFA\u9DFB\u9DFC\u9DFD\u9DFE\u9DFF\u9E00\u9E01\u9E02\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[250].length; ++j)if (D[250][j].charCodeAt(0) !== 0xFFFD) {
        e[D[250][j]] = 64000 + j;
        d[64000 + j] = D[250][j];
    }
    D[251] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9E03\u9E04\u9E05\u9E06\u9E07\u9E08\u9E09\u9E0A\u9E0B\u9E0C\u9E0D\u9E0E\u9E0F\u9E10\u9E11\u9E12\u9E13\u9E14\u9E15\u9E16\u9E17\u9E18\u9E19\u9E1A\u9E1B\u9E1C\u9E1D\u9E1E\u9E24\u9E27\u9E2E\u9E30\u9E34\u9E3B\u9E3C\u9E40\u9E4D\u9E50\u9E52\u9E53\u9E54\u9E56\u9E59\u9E5D\u9E5F\u9E60\u9E61\u9E62\u9E65\u9E6E\u9E6F\u9E72\u9E74\u9E75\u9E76\u9E77\u9E78\u9E79\u9E7A\u9E7B\u9E7C\u9E7D\u9E80\uFFFD\u9E81\u9E83\u9E84\u9E85\u9E86\u9E89\u9E8A\u9E8C\u9E8D\u9E8E\u9E8F\u9E90\u9E91\u9E94\u9E95\u9E96\u9E97\u9E98\u9E99\u9E9A\u9E9B\u9E9C\u9E9E\u9EA0\u9EA1\u9EA2\u9EA3\u9EA4\u9EA5\u9EA7\u9EA8\u9EA9\u9EAA\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[251].length; ++j)if (D[251][j].charCodeAt(0) !== 0xFFFD) {
        e[D[251][j]] = 64256 + j;
        d[64256 + j] = D[251][j];
    }
    D[252] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9EAB\u9EAC\u9EAD\u9EAE\u9EAF\u9EB0\u9EB1\u9EB2\u9EB3\u9EB5\u9EB6\u9EB7\u9EB9\u9EBA\u9EBC\u9EBF\u9EC0\u9EC1\u9EC2\u9EC3\u9EC5\u9EC6\u9EC7\u9EC8\u9ECA\u9ECB\u9ECC\u9ED0\u9ED2\u9ED3\u9ED5\u9ED6\u9ED7\u9ED9\u9EDA\u9EDE\u9EE1\u9EE3\u9EE4\u9EE6\u9EE8\u9EEB\u9EEC\u9EED\u9EEE\u9EF0\u9EF1\u9EF2\u9EF3\u9EF4\u9EF5\u9EF6\u9EF7\u9EF8\u9EFA\u9EFD\u9EFF\u9F00\u9F01\u9F02\u9F03\u9F04\u9F05\uFFFD\u9F06\u9F07\u9F08\u9F09\u9F0A\u9F0C\u9F0F\u9F11\u9F12\u9F14\u9F15\u9F16\u9F18\u9F1A\u9F1B\u9F1C\u9F1D\u9F1E\u9F1F\u9F21\u9F23\u9F24\u9F25\u9F26\u9F27\u9F28\u9F29\u9F2A\u9F2B\u9F2D\u9F2E\u9F30\u9F31\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[252].length; ++j)if (D[252][j].charCodeAt(0) !== 0xFFFD) {
        e[D[252][j]] = 64512 + j;
        d[64512 + j] = D[252][j];
    }
    D[253] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9F32\u9F33\u9F34\u9F35\u9F36\u9F38\u9F3A\u9F3C\u9F3F\u9F40\u9F41\u9F42\u9F43\u9F45\u9F46\u9F47\u9F48\u9F49\u9F4A\u9F4B\u9F4C\u9F4D\u9F4E\u9F4F\u9F52\u9F53\u9F54\u9F55\u9F56\u9F57\u9F58\u9F59\u9F5A\u9F5B\u9F5C\u9F5D\u9F5E\u9F5F\u9F60\u9F61\u9F62\u9F63\u9F64\u9F65\u9F66\u9F67\u9F68\u9F69\u9F6A\u9F6B\u9F6C\u9F6D\u9F6E\u9F6F\u9F70\u9F71\u9F72\u9F73\u9F74\u9F75\u9F76\u9F77\u9F78\uFFFD\u9F79\u9F7A\u9F7B\u9F7C\u9F7D\u9F7E\u9F81\u9F82\u9F8D\u9F8E\u9F8F\u9F90\u9F91\u9F92\u9F93\u9F94\u9F95\u9F96\u9F97\u9F98\u9F9C\u9F9D\u9F9E\u9FA1\u9FA2\u9FA3\u9FA4\u9FA5\uF92C\uF979\uF995\uF9E7\uF9F1\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[253].length; ++j)if (D[253][j].charCodeAt(0) !== 0xFFFD) {
        e[D[253][j]] = 64768 + j;
        d[64768 + j] = D[253][j];
    }
    D[254] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFA0C\uFA0D\uFA0E\uFA0F\uFA11\uFA13\uFA14\uFA18\uFA1F\uFA20\uFA21\uFA23\uFA24\uFA27\uFA28\uFA29\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[254].length; ++j)if (D[254][j].charCodeAt(0) !== 0xFFFD) {
        e[D[254][j]] = 65024 + j;
        d[65024 + j] = D[254][j];
    }
    return {
        "enc": e,
        "dec": d
    };
}();
$e1f740a9d01acc72$var$cptable[949] = function() {
    var d = [], e = {}, D = [], j;
    D[0] = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[0].length; ++j)if (D[0][j].charCodeAt(0) !== 0xFFFD) {
        e[D[0][j]] = 0 + j;
        d[0 + j] = D[0][j];
    }
    D[129] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uAC02\uAC03\uAC05\uAC06\uAC0B\uAC0C\uAC0D\uAC0E\uAC0F\uAC18\uAC1E\uAC1F\uAC21\uAC22\uAC23\uAC25\uAC26\uAC27\uAC28\uAC29\uAC2A\uAC2B\uAC2E\uAC32\uAC33\uAC34\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uAC35\uAC36\uAC37\uAC3A\uAC3B\uAC3D\uAC3E\uAC3F\uAC41\uAC42\uAC43\uAC44\uAC45\uAC46\uAC47\uAC48\uAC49\uAC4A\uAC4C\uAC4E\uAC4F\uAC50\uAC51\uAC52\uAC53\uAC55\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uAC56\uAC57\uAC59\uAC5A\uAC5B\uAC5D\uAC5E\uAC5F\uAC60\uAC61\uAC62\uAC63\uAC64\uAC65\uAC66\uAC67\uAC68\uAC69\uAC6A\uAC6B\uAC6C\uAC6D\uAC6E\uAC6F\uAC72\uAC73\uAC75\uAC76\uAC79\uAC7B\uAC7C\uAC7D\uAC7E\uAC7F\uAC82\uAC87\uAC88\uAC8D\uAC8E\uAC8F\uAC91\uAC92\uAC93\uAC95\uAC96\uAC97\uAC98\uAC99\uAC9A\uAC9B\uAC9E\uACA2\uACA3\uACA4\uACA5\uACA6\uACA7\uACAB\uACAD\uACAE\uACB1\uACB2\uACB3\uACB4\uACB5\uACB6\uACB7\uACBA\uACBE\uACBF\uACC0\uACC2\uACC3\uACC5\uACC6\uACC7\uACC9\uACCA\uACCB\uACCD\uACCE\uACCF\uACD0\uACD1\uACD2\uACD3\uACD4\uACD6\uACD8\uACD9\uACDA\uACDB\uACDC\uACDD\uACDE\uACDF\uACE2\uACE3\uACE5\uACE6\uACE9\uACEB\uACED\uACEE\uACF2\uACF4\uACF7\uACF8\uACF9\uACFA\uACFB\uACFE\uACFF\uAD01\uAD02\uAD03\uAD05\uAD07\uAD08\uAD09\uAD0A\uAD0B\uAD0E\uAD10\uAD12\uAD13\uFFFD".split("");
    for(j = 0; j != D[129].length; ++j)if (D[129][j].charCodeAt(0) !== 0xFFFD) {
        e[D[129][j]] = 33024 + j;
        d[33024 + j] = D[129][j];
    }
    D[130] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uAD14\uAD15\uAD16\uAD17\uAD19\uAD1A\uAD1B\uAD1D\uAD1E\uAD1F\uAD21\uAD22\uAD23\uAD24\uAD25\uAD26\uAD27\uAD28\uAD2A\uAD2B\uAD2E\uAD2F\uAD30\uAD31\uAD32\uAD33\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uAD36\uAD37\uAD39\uAD3A\uAD3B\uAD3D\uAD3E\uAD3F\uAD40\uAD41\uAD42\uAD43\uAD46\uAD48\uAD4A\uAD4B\uAD4C\uAD4D\uAD4E\uAD4F\uAD51\uAD52\uAD53\uAD55\uAD56\uAD57\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uAD59\uAD5A\uAD5B\uAD5C\uAD5D\uAD5E\uAD5F\uAD60\uAD62\uAD64\uAD65\uAD66\uAD67\uAD68\uAD69\uAD6A\uAD6B\uAD6E\uAD6F\uAD71\uAD72\uAD77\uAD78\uAD79\uAD7A\uAD7E\uAD80\uAD83\uAD84\uAD85\uAD86\uAD87\uAD8A\uAD8B\uAD8D\uAD8E\uAD8F\uAD91\uAD92\uAD93\uAD94\uAD95\uAD96\uAD97\uAD98\uAD99\uAD9A\uAD9B\uAD9E\uAD9F\uADA0\uADA1\uADA2\uADA3\uADA5\uADA6\uADA7\uADA8\uADA9\uADAA\uADAB\uADAC\uADAD\uADAE\uADAF\uADB0\uADB1\uADB2\uADB3\uADB4\uADB5\uADB6\uADB8\uADB9\uADBA\uADBB\uADBC\uADBD\uADBE\uADBF\uADC2\uADC3\uADC5\uADC6\uADC7\uADC9\uADCA\uADCB\uADCC\uADCD\uADCE\uADCF\uADD2\uADD4\uADD5\uADD6\uADD7\uADD8\uADD9\uADDA\uADDB\uADDD\uADDE\uADDF\uADE1\uADE2\uADE3\uADE5\uADE6\uADE7\uADE8\uADE9\uADEA\uADEB\uADEC\uADED\uADEE\uADEF\uADF0\uADF1\uADF2\uADF3\uADF4\uADF5\uADF6\uADF7\uFFFD".split("");
    for(j = 0; j != D[130].length; ++j)if (D[130][j].charCodeAt(0) !== 0xFFFD) {
        e[D[130][j]] = 33280 + j;
        d[33280 + j] = D[130][j];
    }
    D[131] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uADFA\uADFB\uADFD\uADFE\uAE02\uAE03\uAE04\uAE05\uAE06\uAE07\uAE0A\uAE0C\uAE0E\uAE0F\uAE10\uAE11\uAE12\uAE13\uAE15\uAE16\uAE17\uAE18\uAE19\uAE1A\uAE1B\uAE1C\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uAE1D\uAE1E\uAE1F\uAE20\uAE21\uAE22\uAE23\uAE24\uAE25\uAE26\uAE27\uAE28\uAE29\uAE2A\uAE2B\uAE2C\uAE2D\uAE2E\uAE2F\uAE32\uAE33\uAE35\uAE36\uAE39\uAE3B\uAE3C\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uAE3D\uAE3E\uAE3F\uAE42\uAE44\uAE47\uAE48\uAE49\uAE4B\uAE4F\uAE51\uAE52\uAE53\uAE55\uAE57\uAE58\uAE59\uAE5A\uAE5B\uAE5E\uAE62\uAE63\uAE64\uAE66\uAE67\uAE6A\uAE6B\uAE6D\uAE6E\uAE6F\uAE71\uAE72\uAE73\uAE74\uAE75\uAE76\uAE77\uAE7A\uAE7E\uAE7F\uAE80\uAE81\uAE82\uAE83\uAE86\uAE87\uAE88\uAE89\uAE8A\uAE8B\uAE8D\uAE8E\uAE8F\uAE90\uAE91\uAE92\uAE93\uAE94\uAE95\uAE96\uAE97\uAE98\uAE99\uAE9A\uAE9B\uAE9C\uAE9D\uAE9E\uAE9F\uAEA0\uAEA1\uAEA2\uAEA3\uAEA4\uAEA5\uAEA6\uAEA7\uAEA8\uAEA9\uAEAA\uAEAB\uAEAC\uAEAD\uAEAE\uAEAF\uAEB0\uAEB1\uAEB2\uAEB3\uAEB4\uAEB5\uAEB6\uAEB7\uAEB8\uAEB9\uAEBA\uAEBB\uAEBF\uAEC1\uAEC2\uAEC3\uAEC5\uAEC6\uAEC7\uAEC8\uAEC9\uAECA\uAECB\uAECE\uAED2\uAED3\uAED4\uAED5\uAED6\uAED7\uAEDA\uAEDB\uAEDD\uAEDE\uAEDF\uAEE0\uAEE1\uAEE2\uAEE3\uAEE4\uAEE5\uFFFD".split("");
    for(j = 0; j != D[131].length; ++j)if (D[131][j].charCodeAt(0) !== 0xFFFD) {
        e[D[131][j]] = 33536 + j;
        d[33536 + j] = D[131][j];
    }
    D[132] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uAEE6\uAEE7\uAEE9\uAEEA\uAEEC\uAEEE\uAEEF\uAEF0\uAEF1\uAEF2\uAEF3\uAEF5\uAEF6\uAEF7\uAEF9\uAEFA\uAEFB\uAEFD\uAEFE\uAEFF\uAF00\uAF01\uAF02\uAF03\uAF04\uAF05\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uAF06\uAF09\uAF0A\uAF0B\uAF0C\uAF0E\uAF0F\uAF11\uAF12\uAF13\uAF14\uAF15\uAF16\uAF17\uAF18\uAF19\uAF1A\uAF1B\uAF1C\uAF1D\uAF1E\uAF1F\uAF20\uAF21\uAF22\uAF23\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uAF24\uAF25\uAF26\uAF27\uAF28\uAF29\uAF2A\uAF2B\uAF2E\uAF2F\uAF31\uAF33\uAF35\uAF36\uAF37\uAF38\uAF39\uAF3A\uAF3B\uAF3E\uAF40\uAF44\uAF45\uAF46\uAF47\uAF4A\uAF4B\uAF4C\uAF4D\uAF4E\uAF4F\uAF51\uAF52\uAF53\uAF54\uAF55\uAF56\uAF57\uAF58\uAF59\uAF5A\uAF5B\uAF5E\uAF5F\uAF60\uAF61\uAF62\uAF63\uAF66\uAF67\uAF68\uAF69\uAF6A\uAF6B\uAF6C\uAF6D\uAF6E\uAF6F\uAF70\uAF71\uAF72\uAF73\uAF74\uAF75\uAF76\uAF77\uAF78\uAF7A\uAF7B\uAF7C\uAF7D\uAF7E\uAF7F\uAF81\uAF82\uAF83\uAF85\uAF86\uAF87\uAF89\uAF8A\uAF8B\uAF8C\uAF8D\uAF8E\uAF8F\uAF92\uAF93\uAF94\uAF96\uAF97\uAF98\uAF99\uAF9A\uAF9B\uAF9D\uAF9E\uAF9F\uAFA0\uAFA1\uAFA2\uAFA3\uAFA4\uAFA5\uAFA6\uAFA7\uAFA8\uAFA9\uAFAA\uAFAB\uAFAC\uAFAD\uAFAE\uAFAF\uAFB0\uAFB1\uAFB2\uAFB3\uAFB4\uAFB5\uAFB6\uAFB7\uAFBA\uAFBB\uAFBD\uAFBE\uFFFD".split("");
    for(j = 0; j != D[132].length; ++j)if (D[132][j].charCodeAt(0) !== 0xFFFD) {
        e[D[132][j]] = 33792 + j;
        d[33792 + j] = D[132][j];
    }
    D[133] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uAFBF\uAFC1\uAFC2\uAFC3\uAFC4\uAFC5\uAFC6\uAFCA\uAFCC\uAFCF\uAFD0\uAFD1\uAFD2\uAFD3\uAFD5\uAFD6\uAFD7\uAFD8\uAFD9\uAFDA\uAFDB\uAFDD\uAFDE\uAFDF\uAFE0\uAFE1\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uAFE2\uAFE3\uAFE4\uAFE5\uAFE6\uAFE7\uAFEA\uAFEB\uAFEC\uAFED\uAFEE\uAFEF\uAFF2\uAFF3\uAFF5\uAFF6\uAFF7\uAFF9\uAFFA\uAFFB\uAFFC\uAFFD\uAFFE\uAFFF\uB002\uB003\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB005\uB006\uB007\uB008\uB009\uB00A\uB00B\uB00D\uB00E\uB00F\uB011\uB012\uB013\uB015\uB016\uB017\uB018\uB019\uB01A\uB01B\uB01E\uB01F\uB020\uB021\uB022\uB023\uB024\uB025\uB026\uB027\uB029\uB02A\uB02B\uB02C\uB02D\uB02E\uB02F\uB030\uB031\uB032\uB033\uB034\uB035\uB036\uB037\uB038\uB039\uB03A\uB03B\uB03C\uB03D\uB03E\uB03F\uB040\uB041\uB042\uB043\uB046\uB047\uB049\uB04B\uB04D\uB04F\uB050\uB051\uB052\uB056\uB058\uB05A\uB05B\uB05C\uB05E\uB05F\uB060\uB061\uB062\uB063\uB064\uB065\uB066\uB067\uB068\uB069\uB06A\uB06B\uB06C\uB06D\uB06E\uB06F\uB070\uB071\uB072\uB073\uB074\uB075\uB076\uB077\uB078\uB079\uB07A\uB07B\uB07E\uB07F\uB081\uB082\uB083\uB085\uB086\uB087\uB088\uB089\uB08A\uB08B\uB08E\uB090\uB092\uB093\uB094\uB095\uB096\uB097\uB09B\uB09D\uB09E\uB0A3\uB0A4\uFFFD".split("");
    for(j = 0; j != D[133].length; ++j)if (D[133][j].charCodeAt(0) !== 0xFFFD) {
        e[D[133][j]] = 34048 + j;
        d[34048 + j] = D[133][j];
    }
    D[134] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB0A5\uB0A6\uB0A7\uB0AA\uB0B0\uB0B2\uB0B6\uB0B7\uB0B9\uB0BA\uB0BB\uB0BD\uB0BE\uB0BF\uB0C0\uB0C1\uB0C2\uB0C3\uB0C6\uB0CA\uB0CB\uB0CC\uB0CD\uB0CE\uB0CF\uB0D2\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB0D3\uB0D5\uB0D6\uB0D7\uB0D9\uB0DA\uB0DB\uB0DC\uB0DD\uB0DE\uB0DF\uB0E1\uB0E2\uB0E3\uB0E4\uB0E6\uB0E7\uB0E8\uB0E9\uB0EA\uB0EB\uB0EC\uB0ED\uB0EE\uB0EF\uB0F0\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB0F1\uB0F2\uB0F3\uB0F4\uB0F5\uB0F6\uB0F7\uB0F8\uB0F9\uB0FA\uB0FB\uB0FC\uB0FD\uB0FE\uB0FF\uB100\uB101\uB102\uB103\uB104\uB105\uB106\uB107\uB10A\uB10D\uB10E\uB10F\uB111\uB114\uB115\uB116\uB117\uB11A\uB11E\uB11F\uB120\uB121\uB122\uB126\uB127\uB129\uB12A\uB12B\uB12D\uB12E\uB12F\uB130\uB131\uB132\uB133\uB136\uB13A\uB13B\uB13C\uB13D\uB13E\uB13F\uB142\uB143\uB145\uB146\uB147\uB149\uB14A\uB14B\uB14C\uB14D\uB14E\uB14F\uB152\uB153\uB156\uB157\uB159\uB15A\uB15B\uB15D\uB15E\uB15F\uB161\uB162\uB163\uB164\uB165\uB166\uB167\uB168\uB169\uB16A\uB16B\uB16C\uB16D\uB16E\uB16F\uB170\uB171\uB172\uB173\uB174\uB175\uB176\uB177\uB17A\uB17B\uB17D\uB17E\uB17F\uB181\uB183\uB184\uB185\uB186\uB187\uB18A\uB18C\uB18E\uB18F\uB190\uB191\uB195\uB196\uB197\uB199\uB19A\uB19B\uB19D\uFFFD".split("");
    for(j = 0; j != D[134].length; ++j)if (D[134][j].charCodeAt(0) !== 0xFFFD) {
        e[D[134][j]] = 34304 + j;
        d[34304 + j] = D[134][j];
    }
    D[135] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB19E\uB19F\uB1A0\uB1A1\uB1A2\uB1A3\uB1A4\uB1A5\uB1A6\uB1A7\uB1A9\uB1AA\uB1AB\uB1AC\uB1AD\uB1AE\uB1AF\uB1B0\uB1B1\uB1B2\uB1B3\uB1B4\uB1B5\uB1B6\uB1B7\uB1B8\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB1B9\uB1BA\uB1BB\uB1BC\uB1BD\uB1BE\uB1BF\uB1C0\uB1C1\uB1C2\uB1C3\uB1C4\uB1C5\uB1C6\uB1C7\uB1C8\uB1C9\uB1CA\uB1CB\uB1CD\uB1CE\uB1CF\uB1D1\uB1D2\uB1D3\uB1D5\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB1D6\uB1D7\uB1D8\uB1D9\uB1DA\uB1DB\uB1DE\uB1E0\uB1E1\uB1E2\uB1E3\uB1E4\uB1E5\uB1E6\uB1E7\uB1EA\uB1EB\uB1ED\uB1EE\uB1EF\uB1F1\uB1F2\uB1F3\uB1F4\uB1F5\uB1F6\uB1F7\uB1F8\uB1FA\uB1FC\uB1FE\uB1FF\uB200\uB201\uB202\uB203\uB206\uB207\uB209\uB20A\uB20D\uB20E\uB20F\uB210\uB211\uB212\uB213\uB216\uB218\uB21A\uB21B\uB21C\uB21D\uB21E\uB21F\uB221\uB222\uB223\uB224\uB225\uB226\uB227\uB228\uB229\uB22A\uB22B\uB22C\uB22D\uB22E\uB22F\uB230\uB231\uB232\uB233\uB235\uB236\uB237\uB238\uB239\uB23A\uB23B\uB23D\uB23E\uB23F\uB240\uB241\uB242\uB243\uB244\uB245\uB246\uB247\uB248\uB249\uB24A\uB24B\uB24C\uB24D\uB24E\uB24F\uB250\uB251\uB252\uB253\uB254\uB255\uB256\uB257\uB259\uB25A\uB25B\uB25D\uB25E\uB25F\uB261\uB262\uB263\uB264\uB265\uB266\uB267\uB26A\uB26B\uB26C\uB26D\uB26E\uFFFD".split("");
    for(j = 0; j != D[135].length; ++j)if (D[135][j].charCodeAt(0) !== 0xFFFD) {
        e[D[135][j]] = 34560 + j;
        d[34560 + j] = D[135][j];
    }
    D[136] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB26F\uB270\uB271\uB272\uB273\uB276\uB277\uB278\uB279\uB27A\uB27B\uB27D\uB27E\uB27F\uB280\uB281\uB282\uB283\uB286\uB287\uB288\uB28A\uB28B\uB28C\uB28D\uB28E\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB28F\uB292\uB293\uB295\uB296\uB297\uB29B\uB29C\uB29D\uB29E\uB29F\uB2A2\uB2A4\uB2A7\uB2A8\uB2A9\uB2AB\uB2AD\uB2AE\uB2AF\uB2B1\uB2B2\uB2B3\uB2B5\uB2B6\uB2B7\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB2B8\uB2B9\uB2BA\uB2BB\uB2BC\uB2BD\uB2BE\uB2BF\uB2C0\uB2C1\uB2C2\uB2C3\uB2C4\uB2C5\uB2C6\uB2C7\uB2CA\uB2CB\uB2CD\uB2CE\uB2CF\uB2D1\uB2D3\uB2D4\uB2D5\uB2D6\uB2D7\uB2DA\uB2DC\uB2DE\uB2DF\uB2E0\uB2E1\uB2E3\uB2E7\uB2E9\uB2EA\uB2F0\uB2F1\uB2F2\uB2F6\uB2FC\uB2FD\uB2FE\uB302\uB303\uB305\uB306\uB307\uB309\uB30A\uB30B\uB30C\uB30D\uB30E\uB30F\uB312\uB316\uB317\uB318\uB319\uB31A\uB31B\uB31D\uB31E\uB31F\uB320\uB321\uB322\uB323\uB324\uB325\uB326\uB327\uB328\uB329\uB32A\uB32B\uB32C\uB32D\uB32E\uB32F\uB330\uB331\uB332\uB333\uB334\uB335\uB336\uB337\uB338\uB339\uB33A\uB33B\uB33C\uB33D\uB33E\uB33F\uB340\uB341\uB342\uB343\uB344\uB345\uB346\uB347\uB348\uB349\uB34A\uB34B\uB34C\uB34D\uB34E\uB34F\uB350\uB351\uB352\uB353\uB357\uB359\uB35A\uB35D\uB360\uB361\uB362\uB363\uFFFD".split("");
    for(j = 0; j != D[136].length; ++j)if (D[136][j].charCodeAt(0) !== 0xFFFD) {
        e[D[136][j]] = 34816 + j;
        d[34816 + j] = D[136][j];
    }
    D[137] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB366\uB368\uB36A\uB36C\uB36D\uB36F\uB372\uB373\uB375\uB376\uB377\uB379\uB37A\uB37B\uB37C\uB37D\uB37E\uB37F\uB382\uB386\uB387\uB388\uB389\uB38A\uB38B\uB38D\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB38E\uB38F\uB391\uB392\uB393\uB395\uB396\uB397\uB398\uB399\uB39A\uB39B\uB39C\uB39D\uB39E\uB39F\uB3A2\uB3A3\uB3A4\uB3A5\uB3A6\uB3A7\uB3A9\uB3AA\uB3AB\uB3AD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB3AE\uB3AF\uB3B0\uB3B1\uB3B2\uB3B3\uB3B4\uB3B5\uB3B6\uB3B7\uB3B8\uB3B9\uB3BA\uB3BB\uB3BC\uB3BD\uB3BE\uB3BF\uB3C0\uB3C1\uB3C2\uB3C3\uB3C6\uB3C7\uB3C9\uB3CA\uB3CD\uB3CF\uB3D1\uB3D2\uB3D3\uB3D6\uB3D8\uB3DA\uB3DC\uB3DE\uB3DF\uB3E1\uB3E2\uB3E3\uB3E5\uB3E6\uB3E7\uB3E9\uB3EA\uB3EB\uB3EC\uB3ED\uB3EE\uB3EF\uB3F0\uB3F1\uB3F2\uB3F3\uB3F4\uB3F5\uB3F6\uB3F7\uB3F8\uB3F9\uB3FA\uB3FB\uB3FD\uB3FE\uB3FF\uB400\uB401\uB402\uB403\uB404\uB405\uB406\uB407\uB408\uB409\uB40A\uB40B\uB40C\uB40D\uB40E\uB40F\uB411\uB412\uB413\uB414\uB415\uB416\uB417\uB419\uB41A\uB41B\uB41D\uB41E\uB41F\uB421\uB422\uB423\uB424\uB425\uB426\uB427\uB42A\uB42C\uB42D\uB42E\uB42F\uB430\uB431\uB432\uB433\uB435\uB436\uB437\uB438\uB439\uB43A\uB43B\uB43C\uB43D\uB43E\uB43F\uB440\uB441\uB442\uB443\uB444\uFFFD".split("");
    for(j = 0; j != D[137].length; ++j)if (D[137][j].charCodeAt(0) !== 0xFFFD) {
        e[D[137][j]] = 35072 + j;
        d[35072 + j] = D[137][j];
    }
    D[138] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB445\uB446\uB447\uB448\uB449\uB44A\uB44B\uB44C\uB44D\uB44E\uB44F\uB452\uB453\uB455\uB456\uB457\uB459\uB45A\uB45B\uB45C\uB45D\uB45E\uB45F\uB462\uB464\uB466\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB467\uB468\uB469\uB46A\uB46B\uB46D\uB46E\uB46F\uB470\uB471\uB472\uB473\uB474\uB475\uB476\uB477\uB478\uB479\uB47A\uB47B\uB47C\uB47D\uB47E\uB47F\uB481\uB482\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB483\uB484\uB485\uB486\uB487\uB489\uB48A\uB48B\uB48C\uB48D\uB48E\uB48F\uB490\uB491\uB492\uB493\uB494\uB495\uB496\uB497\uB498\uB499\uB49A\uB49B\uB49C\uB49E\uB49F\uB4A0\uB4A1\uB4A2\uB4A3\uB4A5\uB4A6\uB4A7\uB4A9\uB4AA\uB4AB\uB4AD\uB4AE\uB4AF\uB4B0\uB4B1\uB4B2\uB4B3\uB4B4\uB4B6\uB4B8\uB4BA\uB4BB\uB4BC\uB4BD\uB4BE\uB4BF\uB4C1\uB4C2\uB4C3\uB4C5\uB4C6\uB4C7\uB4C9\uB4CA\uB4CB\uB4CC\uB4CD\uB4CE\uB4CF\uB4D1\uB4D2\uB4D3\uB4D4\uB4D6\uB4D7\uB4D8\uB4D9\uB4DA\uB4DB\uB4DE\uB4DF\uB4E1\uB4E2\uB4E5\uB4E7\uB4E8\uB4E9\uB4EA\uB4EB\uB4EE\uB4F0\uB4F2\uB4F3\uB4F4\uB4F5\uB4F6\uB4F7\uB4F9\uB4FA\uB4FB\uB4FC\uB4FD\uB4FE\uB4FF\uB500\uB501\uB502\uB503\uB504\uB505\uB506\uB507\uB508\uB509\uB50A\uB50B\uB50C\uB50D\uB50E\uB50F\uB510\uB511\uB512\uB513\uB516\uB517\uB519\uB51A\uB51D\uFFFD".split("");
    for(j = 0; j != D[138].length; ++j)if (D[138][j].charCodeAt(0) !== 0xFFFD) {
        e[D[138][j]] = 35328 + j;
        d[35328 + j] = D[138][j];
    }
    D[139] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB51E\uB51F\uB520\uB521\uB522\uB523\uB526\uB52B\uB52C\uB52D\uB52E\uB52F\uB532\uB533\uB535\uB536\uB537\uB539\uB53A\uB53B\uB53C\uB53D\uB53E\uB53F\uB542\uB546\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB547\uB548\uB549\uB54A\uB54E\uB54F\uB551\uB552\uB553\uB555\uB556\uB557\uB558\uB559\uB55A\uB55B\uB55E\uB562\uB563\uB564\uB565\uB566\uB567\uB568\uB569\uB56A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB56B\uB56C\uB56D\uB56E\uB56F\uB570\uB571\uB572\uB573\uB574\uB575\uB576\uB577\uB578\uB579\uB57A\uB57B\uB57C\uB57D\uB57E\uB57F\uB580\uB581\uB582\uB583\uB584\uB585\uB586\uB587\uB588\uB589\uB58A\uB58B\uB58C\uB58D\uB58E\uB58F\uB590\uB591\uB592\uB593\uB594\uB595\uB596\uB597\uB598\uB599\uB59A\uB59B\uB59C\uB59D\uB59E\uB59F\uB5A2\uB5A3\uB5A5\uB5A6\uB5A7\uB5A9\uB5AC\uB5AD\uB5AE\uB5AF\uB5B2\uB5B6\uB5B7\uB5B8\uB5B9\uB5BA\uB5BE\uB5BF\uB5C1\uB5C2\uB5C3\uB5C5\uB5C6\uB5C7\uB5C8\uB5C9\uB5CA\uB5CB\uB5CE\uB5D2\uB5D3\uB5D4\uB5D5\uB5D6\uB5D7\uB5D9\uB5DA\uB5DB\uB5DC\uB5DD\uB5DE\uB5DF\uB5E0\uB5E1\uB5E2\uB5E3\uB5E4\uB5E5\uB5E6\uB5E7\uB5E8\uB5E9\uB5EA\uB5EB\uB5ED\uB5EE\uB5EF\uB5F0\uB5F1\uB5F2\uB5F3\uB5F4\uB5F5\uB5F6\uB5F7\uB5F8\uB5F9\uB5FA\uB5FB\uB5FC\uB5FD\uB5FE\uB5FF\uFFFD".split("");
    for(j = 0; j != D[139].length; ++j)if (D[139][j].charCodeAt(0) !== 0xFFFD) {
        e[D[139][j]] = 35584 + j;
        d[35584 + j] = D[139][j];
    }
    D[140] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB600\uB601\uB602\uB603\uB604\uB605\uB606\uB607\uB608\uB609\uB60A\uB60B\uB60C\uB60D\uB60E\uB60F\uB612\uB613\uB615\uB616\uB617\uB619\uB61A\uB61B\uB61C\uB61D\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB61E\uB61F\uB620\uB621\uB622\uB623\uB624\uB626\uB627\uB628\uB629\uB62A\uB62B\uB62D\uB62E\uB62F\uB630\uB631\uB632\uB633\uB635\uB636\uB637\uB638\uB639\uB63A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB63B\uB63C\uB63D\uB63E\uB63F\uB640\uB641\uB642\uB643\uB644\uB645\uB646\uB647\uB649\uB64A\uB64B\uB64C\uB64D\uB64E\uB64F\uB650\uB651\uB652\uB653\uB654\uB655\uB656\uB657\uB658\uB659\uB65A\uB65B\uB65C\uB65D\uB65E\uB65F\uB660\uB661\uB662\uB663\uB665\uB666\uB667\uB669\uB66A\uB66B\uB66C\uB66D\uB66E\uB66F\uB670\uB671\uB672\uB673\uB674\uB675\uB676\uB677\uB678\uB679\uB67A\uB67B\uB67C\uB67D\uB67E\uB67F\uB680\uB681\uB682\uB683\uB684\uB685\uB686\uB687\uB688\uB689\uB68A\uB68B\uB68C\uB68D\uB68E\uB68F\uB690\uB691\uB692\uB693\uB694\uB695\uB696\uB697\uB698\uB699\uB69A\uB69B\uB69E\uB69F\uB6A1\uB6A2\uB6A3\uB6A5\uB6A6\uB6A7\uB6A8\uB6A9\uB6AA\uB6AD\uB6AE\uB6AF\uB6B0\uB6B2\uB6B3\uB6B4\uB6B5\uB6B6\uB6B7\uB6B8\uB6B9\uB6BA\uB6BB\uB6BC\uB6BD\uB6BE\uB6BF\uB6C0\uB6C1\uB6C2\uFFFD".split("");
    for(j = 0; j != D[140].length; ++j)if (D[140][j].charCodeAt(0) !== 0xFFFD) {
        e[D[140][j]] = 35840 + j;
        d[35840 + j] = D[140][j];
    }
    D[141] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB6C3\uB6C4\uB6C5\uB6C6\uB6C7\uB6C8\uB6C9\uB6CA\uB6CB\uB6CC\uB6CD\uB6CE\uB6CF\uB6D0\uB6D1\uB6D2\uB6D3\uB6D5\uB6D6\uB6D7\uB6D8\uB6D9\uB6DA\uB6DB\uB6DC\uB6DD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB6DE\uB6DF\uB6E0\uB6E1\uB6E2\uB6E3\uB6E4\uB6E5\uB6E6\uB6E7\uB6E8\uB6E9\uB6EA\uB6EB\uB6EC\uB6ED\uB6EE\uB6EF\uB6F1\uB6F2\uB6F3\uB6F5\uB6F6\uB6F7\uB6F9\uB6FA\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB6FB\uB6FC\uB6FD\uB6FE\uB6FF\uB702\uB703\uB704\uB706\uB707\uB708\uB709\uB70A\uB70B\uB70C\uB70D\uB70E\uB70F\uB710\uB711\uB712\uB713\uB714\uB715\uB716\uB717\uB718\uB719\uB71A\uB71B\uB71C\uB71D\uB71E\uB71F\uB720\uB721\uB722\uB723\uB724\uB725\uB726\uB727\uB72A\uB72B\uB72D\uB72E\uB731\uB732\uB733\uB734\uB735\uB736\uB737\uB73A\uB73C\uB73D\uB73E\uB73F\uB740\uB741\uB742\uB743\uB745\uB746\uB747\uB749\uB74A\uB74B\uB74D\uB74E\uB74F\uB750\uB751\uB752\uB753\uB756\uB757\uB758\uB759\uB75A\uB75B\uB75C\uB75D\uB75E\uB75F\uB761\uB762\uB763\uB765\uB766\uB767\uB769\uB76A\uB76B\uB76C\uB76D\uB76E\uB76F\uB772\uB774\uB776\uB777\uB778\uB779\uB77A\uB77B\uB77E\uB77F\uB781\uB782\uB783\uB785\uB786\uB787\uB788\uB789\uB78A\uB78B\uB78E\uB793\uB794\uB795\uB79A\uB79B\uB79D\uB79E\uFFFD".split("");
    for(j = 0; j != D[141].length; ++j)if (D[141][j].charCodeAt(0) !== 0xFFFD) {
        e[D[141][j]] = 36096 + j;
        d[36096 + j] = D[141][j];
    }
    D[142] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB79F\uB7A1\uB7A2\uB7A3\uB7A4\uB7A5\uB7A6\uB7A7\uB7AA\uB7AE\uB7AF\uB7B0\uB7B1\uB7B2\uB7B3\uB7B6\uB7B7\uB7B9\uB7BA\uB7BB\uB7BC\uB7BD\uB7BE\uB7BF\uB7C0\uB7C1\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB7C2\uB7C3\uB7C4\uB7C5\uB7C6\uB7C8\uB7CA\uB7CB\uB7CC\uB7CD\uB7CE\uB7CF\uB7D0\uB7D1\uB7D2\uB7D3\uB7D4\uB7D5\uB7D6\uB7D7\uB7D8\uB7D9\uB7DA\uB7DB\uB7DC\uB7DD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB7DE\uB7DF\uB7E0\uB7E1\uB7E2\uB7E3\uB7E4\uB7E5\uB7E6\uB7E7\uB7E8\uB7E9\uB7EA\uB7EB\uB7EE\uB7EF\uB7F1\uB7F2\uB7F3\uB7F5\uB7F6\uB7F7\uB7F8\uB7F9\uB7FA\uB7FB\uB7FE\uB802\uB803\uB804\uB805\uB806\uB80A\uB80B\uB80D\uB80E\uB80F\uB811\uB812\uB813\uB814\uB815\uB816\uB817\uB81A\uB81C\uB81E\uB81F\uB820\uB821\uB822\uB823\uB826\uB827\uB829\uB82A\uB82B\uB82D\uB82E\uB82F\uB830\uB831\uB832\uB833\uB836\uB83A\uB83B\uB83C\uB83D\uB83E\uB83F\uB841\uB842\uB843\uB845\uB846\uB847\uB848\uB849\uB84A\uB84B\uB84C\uB84D\uB84E\uB84F\uB850\uB852\uB854\uB855\uB856\uB857\uB858\uB859\uB85A\uB85B\uB85E\uB85F\uB861\uB862\uB863\uB865\uB866\uB867\uB868\uB869\uB86A\uB86B\uB86E\uB870\uB872\uB873\uB874\uB875\uB876\uB877\uB879\uB87A\uB87B\uB87D\uB87E\uB87F\uB880\uB881\uB882\uB883\uB884\uFFFD".split("");
    for(j = 0; j != D[142].length; ++j)if (D[142][j].charCodeAt(0) !== 0xFFFD) {
        e[D[142][j]] = 36352 + j;
        d[36352 + j] = D[142][j];
    }
    D[143] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB885\uB886\uB887\uB888\uB889\uB88A\uB88B\uB88C\uB88E\uB88F\uB890\uB891\uB892\uB893\uB894\uB895\uB896\uB897\uB898\uB899\uB89A\uB89B\uB89C\uB89D\uB89E\uB89F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB8A0\uB8A1\uB8A2\uB8A3\uB8A4\uB8A5\uB8A6\uB8A7\uB8A9\uB8AA\uB8AB\uB8AC\uB8AD\uB8AE\uB8AF\uB8B1\uB8B2\uB8B3\uB8B5\uB8B6\uB8B7\uB8B9\uB8BA\uB8BB\uB8BC\uB8BD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB8BE\uB8BF\uB8C2\uB8C4\uB8C6\uB8C7\uB8C8\uB8C9\uB8CA\uB8CB\uB8CD\uB8CE\uB8CF\uB8D1\uB8D2\uB8D3\uB8D5\uB8D6\uB8D7\uB8D8\uB8D9\uB8DA\uB8DB\uB8DC\uB8DE\uB8E0\uB8E2\uB8E3\uB8E4\uB8E5\uB8E6\uB8E7\uB8EA\uB8EB\uB8ED\uB8EE\uB8EF\uB8F1\uB8F2\uB8F3\uB8F4\uB8F5\uB8F6\uB8F7\uB8FA\uB8FC\uB8FE\uB8FF\uB900\uB901\uB902\uB903\uB905\uB906\uB907\uB908\uB909\uB90A\uB90B\uB90C\uB90D\uB90E\uB90F\uB910\uB911\uB912\uB913\uB914\uB915\uB916\uB917\uB919\uB91A\uB91B\uB91C\uB91D\uB91E\uB91F\uB921\uB922\uB923\uB924\uB925\uB926\uB927\uB928\uB929\uB92A\uB92B\uB92C\uB92D\uB92E\uB92F\uB930\uB931\uB932\uB933\uB934\uB935\uB936\uB937\uB938\uB939\uB93A\uB93B\uB93E\uB93F\uB941\uB942\uB943\uB945\uB946\uB947\uB948\uB949\uB94A\uB94B\uB94D\uB94E\uB950\uB952\uB953\uB954\uB955\uB956\uB957\uFFFD".split("");
    for(j = 0; j != D[143].length; ++j)if (D[143][j].charCodeAt(0) !== 0xFFFD) {
        e[D[143][j]] = 36608 + j;
        d[36608 + j] = D[143][j];
    }
    D[144] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB95A\uB95B\uB95D\uB95E\uB95F\uB961\uB962\uB963\uB964\uB965\uB966\uB967\uB96A\uB96C\uB96E\uB96F\uB970\uB971\uB972\uB973\uB976\uB977\uB979\uB97A\uB97B\uB97D\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB97E\uB97F\uB980\uB981\uB982\uB983\uB986\uB988\uB98B\uB98C\uB98F\uB990\uB991\uB992\uB993\uB994\uB995\uB996\uB997\uB998\uB999\uB99A\uB99B\uB99C\uB99D\uB99E\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB99F\uB9A0\uB9A1\uB9A2\uB9A3\uB9A4\uB9A5\uB9A6\uB9A7\uB9A8\uB9A9\uB9AA\uB9AB\uB9AE\uB9AF\uB9B1\uB9B2\uB9B3\uB9B5\uB9B6\uB9B7\uB9B8\uB9B9\uB9BA\uB9BB\uB9BE\uB9C0\uB9C2\uB9C3\uB9C4\uB9C5\uB9C6\uB9C7\uB9CA\uB9CB\uB9CD\uB9D3\uB9D4\uB9D5\uB9D6\uB9D7\uB9DA\uB9DC\uB9DF\uB9E0\uB9E2\uB9E6\uB9E7\uB9E9\uB9EA\uB9EB\uB9ED\uB9EE\uB9EF\uB9F0\uB9F1\uB9F2\uB9F3\uB9F6\uB9FB\uB9FC\uB9FD\uB9FE\uB9FF\uBA02\uBA03\uBA04\uBA05\uBA06\uBA07\uBA09\uBA0A\uBA0B\uBA0C\uBA0D\uBA0E\uBA0F\uBA10\uBA11\uBA12\uBA13\uBA14\uBA16\uBA17\uBA18\uBA19\uBA1A\uBA1B\uBA1C\uBA1D\uBA1E\uBA1F\uBA20\uBA21\uBA22\uBA23\uBA24\uBA25\uBA26\uBA27\uBA28\uBA29\uBA2A\uBA2B\uBA2C\uBA2D\uBA2E\uBA2F\uBA30\uBA31\uBA32\uBA33\uBA34\uBA35\uBA36\uBA37\uBA3A\uBA3B\uBA3D\uBA3E\uBA3F\uBA41\uBA43\uBA44\uBA45\uBA46\uFFFD".split("");
    for(j = 0; j != D[144].length; ++j)if (D[144][j].charCodeAt(0) !== 0xFFFD) {
        e[D[144][j]] = 36864 + j;
        d[36864 + j] = D[144][j];
    }
    D[145] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBA47\uBA4A\uBA4C\uBA4F\uBA50\uBA51\uBA52\uBA56\uBA57\uBA59\uBA5A\uBA5B\uBA5D\uBA5E\uBA5F\uBA60\uBA61\uBA62\uBA63\uBA66\uBA6A\uBA6B\uBA6C\uBA6D\uBA6E\uBA6F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBA72\uBA73\uBA75\uBA76\uBA77\uBA79\uBA7A\uBA7B\uBA7C\uBA7D\uBA7E\uBA7F\uBA80\uBA81\uBA82\uBA86\uBA88\uBA89\uBA8A\uBA8B\uBA8D\uBA8E\uBA8F\uBA90\uBA91\uBA92\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBA93\uBA94\uBA95\uBA96\uBA97\uBA98\uBA99\uBA9A\uBA9B\uBA9C\uBA9D\uBA9E\uBA9F\uBAA0\uBAA1\uBAA2\uBAA3\uBAA4\uBAA5\uBAA6\uBAA7\uBAAA\uBAAD\uBAAE\uBAAF\uBAB1\uBAB3\uBAB4\uBAB5\uBAB6\uBAB7\uBABA\uBABC\uBABE\uBABF\uBAC0\uBAC1\uBAC2\uBAC3\uBAC5\uBAC6\uBAC7\uBAC9\uBACA\uBACB\uBACC\uBACD\uBACE\uBACF\uBAD0\uBAD1\uBAD2\uBAD3\uBAD4\uBAD5\uBAD6\uBAD7\uBADA\uBADB\uBADC\uBADD\uBADE\uBADF\uBAE0\uBAE1\uBAE2\uBAE3\uBAE4\uBAE5\uBAE6\uBAE7\uBAE8\uBAE9\uBAEA\uBAEB\uBAEC\uBAED\uBAEE\uBAEF\uBAF0\uBAF1\uBAF2\uBAF3\uBAF4\uBAF5\uBAF6\uBAF7\uBAF8\uBAF9\uBAFA\uBAFB\uBAFD\uBAFE\uBAFF\uBB01\uBB02\uBB03\uBB05\uBB06\uBB07\uBB08\uBB09\uBB0A\uBB0B\uBB0C\uBB0E\uBB10\uBB12\uBB13\uBB14\uBB15\uBB16\uBB17\uBB19\uBB1A\uBB1B\uBB1D\uBB1E\uBB1F\uBB21\uBB22\uBB23\uBB24\uBB25\uBB26\uBB27\uFFFD".split("");
    for(j = 0; j != D[145].length; ++j)if (D[145][j].charCodeAt(0) !== 0xFFFD) {
        e[D[145][j]] = 37120 + j;
        d[37120 + j] = D[145][j];
    }
    D[146] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBB28\uBB2A\uBB2C\uBB2D\uBB2E\uBB2F\uBB30\uBB31\uBB32\uBB33\uBB37\uBB39\uBB3A\uBB3F\uBB40\uBB41\uBB42\uBB43\uBB46\uBB48\uBB4A\uBB4B\uBB4C\uBB4E\uBB51\uBB52\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBB53\uBB55\uBB56\uBB57\uBB59\uBB5A\uBB5B\uBB5C\uBB5D\uBB5E\uBB5F\uBB60\uBB62\uBB64\uBB65\uBB66\uBB67\uBB68\uBB69\uBB6A\uBB6B\uBB6D\uBB6E\uBB6F\uBB70\uBB71\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBB72\uBB73\uBB74\uBB75\uBB76\uBB77\uBB78\uBB79\uBB7A\uBB7B\uBB7C\uBB7D\uBB7E\uBB7F\uBB80\uBB81\uBB82\uBB83\uBB84\uBB85\uBB86\uBB87\uBB89\uBB8A\uBB8B\uBB8D\uBB8E\uBB8F\uBB91\uBB92\uBB93\uBB94\uBB95\uBB96\uBB97\uBB98\uBB99\uBB9A\uBB9B\uBB9C\uBB9D\uBB9E\uBB9F\uBBA0\uBBA1\uBBA2\uBBA3\uBBA5\uBBA6\uBBA7\uBBA9\uBBAA\uBBAB\uBBAD\uBBAE\uBBAF\uBBB0\uBBB1\uBBB2\uBBB3\uBBB5\uBBB6\uBBB8\uBBB9\uBBBA\uBBBB\uBBBC\uBBBD\uBBBE\uBBBF\uBBC1\uBBC2\uBBC3\uBBC5\uBBC6\uBBC7\uBBC9\uBBCA\uBBCB\uBBCC\uBBCD\uBBCE\uBBCF\uBBD1\uBBD2\uBBD4\uBBD5\uBBD6\uBBD7\uBBD8\uBBD9\uBBDA\uBBDB\uBBDC\uBBDD\uBBDE\uBBDF\uBBE0\uBBE1\uBBE2\uBBE3\uBBE4\uBBE5\uBBE6\uBBE7\uBBE8\uBBE9\uBBEA\uBBEB\uBBEC\uBBED\uBBEE\uBBEF\uBBF0\uBBF1\uBBF2\uBBF3\uBBF4\uBBF5\uBBF6\uBBF7\uBBFA\uBBFB\uBBFD\uBBFE\uBC01\uFFFD".split("");
    for(j = 0; j != D[146].length; ++j)if (D[146][j].charCodeAt(0) !== 0xFFFD) {
        e[D[146][j]] = 37376 + j;
        d[37376 + j] = D[146][j];
    }
    D[147] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBC03\uBC04\uBC05\uBC06\uBC07\uBC0A\uBC0E\uBC10\uBC12\uBC13\uBC19\uBC1A\uBC20\uBC21\uBC22\uBC23\uBC26\uBC28\uBC2A\uBC2B\uBC2C\uBC2E\uBC2F\uBC32\uBC33\uBC35\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBC36\uBC37\uBC39\uBC3A\uBC3B\uBC3C\uBC3D\uBC3E\uBC3F\uBC42\uBC46\uBC47\uBC48\uBC4A\uBC4B\uBC4E\uBC4F\uBC51\uBC52\uBC53\uBC54\uBC55\uBC56\uBC57\uBC58\uBC59\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBC5A\uBC5B\uBC5C\uBC5E\uBC5F\uBC60\uBC61\uBC62\uBC63\uBC64\uBC65\uBC66\uBC67\uBC68\uBC69\uBC6A\uBC6B\uBC6C\uBC6D\uBC6E\uBC6F\uBC70\uBC71\uBC72\uBC73\uBC74\uBC75\uBC76\uBC77\uBC78\uBC79\uBC7A\uBC7B\uBC7C\uBC7D\uBC7E\uBC7F\uBC80\uBC81\uBC82\uBC83\uBC86\uBC87\uBC89\uBC8A\uBC8D\uBC8F\uBC90\uBC91\uBC92\uBC93\uBC96\uBC98\uBC9B\uBC9C\uBC9D\uBC9E\uBC9F\uBCA2\uBCA3\uBCA5\uBCA6\uBCA9\uBCAA\uBCAB\uBCAC\uBCAD\uBCAE\uBCAF\uBCB2\uBCB6\uBCB7\uBCB8\uBCB9\uBCBA\uBCBB\uBCBE\uBCBF\uBCC1\uBCC2\uBCC3\uBCC5\uBCC6\uBCC7\uBCC8\uBCC9\uBCCA\uBCCB\uBCCC\uBCCE\uBCD2\uBCD3\uBCD4\uBCD6\uBCD7\uBCD9\uBCDA\uBCDB\uBCDD\uBCDE\uBCDF\uBCE0\uBCE1\uBCE2\uBCE3\uBCE4\uBCE5\uBCE6\uBCE7\uBCE8\uBCE9\uBCEA\uBCEB\uBCEC\uBCED\uBCEE\uBCEF\uBCF0\uBCF1\uBCF2\uBCF3\uBCF7\uBCF9\uBCFA\uBCFB\uBCFD\uFFFD".split("");
    for(j = 0; j != D[147].length; ++j)if (D[147][j].charCodeAt(0) !== 0xFFFD) {
        e[D[147][j]] = 37632 + j;
        d[37632 + j] = D[147][j];
    }
    D[148] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBCFE\uBCFF\uBD00\uBD01\uBD02\uBD03\uBD06\uBD08\uBD0A\uBD0B\uBD0C\uBD0D\uBD0E\uBD0F\uBD11\uBD12\uBD13\uBD15\uBD16\uBD17\uBD18\uBD19\uBD1A\uBD1B\uBD1C\uBD1D\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBD1E\uBD1F\uBD20\uBD21\uBD22\uBD23\uBD25\uBD26\uBD27\uBD28\uBD29\uBD2A\uBD2B\uBD2D\uBD2E\uBD2F\uBD30\uBD31\uBD32\uBD33\uBD34\uBD35\uBD36\uBD37\uBD38\uBD39\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBD3A\uBD3B\uBD3C\uBD3D\uBD3E\uBD3F\uBD41\uBD42\uBD43\uBD44\uBD45\uBD46\uBD47\uBD4A\uBD4B\uBD4D\uBD4E\uBD4F\uBD51\uBD52\uBD53\uBD54\uBD55\uBD56\uBD57\uBD5A\uBD5B\uBD5C\uBD5D\uBD5E\uBD5F\uBD60\uBD61\uBD62\uBD63\uBD65\uBD66\uBD67\uBD69\uBD6A\uBD6B\uBD6C\uBD6D\uBD6E\uBD6F\uBD70\uBD71\uBD72\uBD73\uBD74\uBD75\uBD76\uBD77\uBD78\uBD79\uBD7A\uBD7B\uBD7C\uBD7D\uBD7E\uBD7F\uBD82\uBD83\uBD85\uBD86\uBD8B\uBD8C\uBD8D\uBD8E\uBD8F\uBD92\uBD94\uBD96\uBD97\uBD98\uBD9B\uBD9D\uBD9E\uBD9F\uBDA0\uBDA1\uBDA2\uBDA3\uBDA5\uBDA6\uBDA7\uBDA8\uBDA9\uBDAA\uBDAB\uBDAC\uBDAD\uBDAE\uBDAF\uBDB1\uBDB2\uBDB3\uBDB4\uBDB5\uBDB6\uBDB7\uBDB9\uBDBA\uBDBB\uBDBC\uBDBD\uBDBE\uBDBF\uBDC0\uBDC1\uBDC2\uBDC3\uBDC4\uBDC5\uBDC6\uBDC7\uBDC8\uBDC9\uBDCA\uBDCB\uBDCC\uBDCD\uBDCE\uBDCF\uBDD0\uBDD1\uFFFD".split("");
    for(j = 0; j != D[148].length; ++j)if (D[148][j].charCodeAt(0) !== 0xFFFD) {
        e[D[148][j]] = 37888 + j;
        d[37888 + j] = D[148][j];
    }
    D[149] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBDD2\uBDD3\uBDD6\uBDD7\uBDD9\uBDDA\uBDDB\uBDDD\uBDDE\uBDDF\uBDE0\uBDE1\uBDE2\uBDE3\uBDE4\uBDE5\uBDE6\uBDE7\uBDE8\uBDEA\uBDEB\uBDEC\uBDED\uBDEE\uBDEF\uBDF1\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBDF2\uBDF3\uBDF5\uBDF6\uBDF7\uBDF9\uBDFA\uBDFB\uBDFC\uBDFD\uBDFE\uBDFF\uBE01\uBE02\uBE04\uBE06\uBE07\uBE08\uBE09\uBE0A\uBE0B\uBE0E\uBE0F\uBE11\uBE12\uBE13\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBE15\uBE16\uBE17\uBE18\uBE19\uBE1A\uBE1B\uBE1E\uBE20\uBE21\uBE22\uBE23\uBE24\uBE25\uBE26\uBE27\uBE28\uBE29\uBE2A\uBE2B\uBE2C\uBE2D\uBE2E\uBE2F\uBE30\uBE31\uBE32\uBE33\uBE34\uBE35\uBE36\uBE37\uBE38\uBE39\uBE3A\uBE3B\uBE3C\uBE3D\uBE3E\uBE3F\uBE40\uBE41\uBE42\uBE43\uBE46\uBE47\uBE49\uBE4A\uBE4B\uBE4D\uBE4F\uBE50\uBE51\uBE52\uBE53\uBE56\uBE58\uBE5C\uBE5D\uBE5E\uBE5F\uBE62\uBE63\uBE65\uBE66\uBE67\uBE69\uBE6B\uBE6C\uBE6D\uBE6E\uBE6F\uBE72\uBE76\uBE77\uBE78\uBE79\uBE7A\uBE7E\uBE7F\uBE81\uBE82\uBE83\uBE85\uBE86\uBE87\uBE88\uBE89\uBE8A\uBE8B\uBE8E\uBE92\uBE93\uBE94\uBE95\uBE96\uBE97\uBE9A\uBE9B\uBE9C\uBE9D\uBE9E\uBE9F\uBEA0\uBEA1\uBEA2\uBEA3\uBEA4\uBEA5\uBEA6\uBEA7\uBEA9\uBEAA\uBEAB\uBEAC\uBEAD\uBEAE\uBEAF\uBEB0\uBEB1\uBEB2\uBEB3\uBEB4\uBEB5\uBEB6\uBEB7\uFFFD".split("");
    for(j = 0; j != D[149].length; ++j)if (D[149][j].charCodeAt(0) !== 0xFFFD) {
        e[D[149][j]] = 38144 + j;
        d[38144 + j] = D[149][j];
    }
    D[150] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBEB8\uBEB9\uBEBA\uBEBB\uBEBC\uBEBD\uBEBE\uBEBF\uBEC0\uBEC1\uBEC2\uBEC3\uBEC4\uBEC5\uBEC6\uBEC7\uBEC8\uBEC9\uBECA\uBECB\uBECC\uBECD\uBECE\uBECF\uBED2\uBED3\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBED5\uBED6\uBED9\uBEDA\uBEDB\uBEDC\uBEDD\uBEDE\uBEDF\uBEE1\uBEE2\uBEE6\uBEE7\uBEE8\uBEE9\uBEEA\uBEEB\uBEED\uBEEE\uBEEF\uBEF0\uBEF1\uBEF2\uBEF3\uBEF4\uBEF5\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBEF6\uBEF7\uBEF8\uBEF9\uBEFA\uBEFB\uBEFC\uBEFD\uBEFE\uBEFF\uBF00\uBF02\uBF03\uBF04\uBF05\uBF06\uBF07\uBF0A\uBF0B\uBF0C\uBF0D\uBF0E\uBF0F\uBF10\uBF11\uBF12\uBF13\uBF14\uBF15\uBF16\uBF17\uBF1A\uBF1E\uBF1F\uBF20\uBF21\uBF22\uBF23\uBF24\uBF25\uBF26\uBF27\uBF28\uBF29\uBF2A\uBF2B\uBF2C\uBF2D\uBF2E\uBF2F\uBF30\uBF31\uBF32\uBF33\uBF34\uBF35\uBF36\uBF37\uBF38\uBF39\uBF3A\uBF3B\uBF3C\uBF3D\uBF3E\uBF3F\uBF42\uBF43\uBF45\uBF46\uBF47\uBF49\uBF4A\uBF4B\uBF4C\uBF4D\uBF4E\uBF4F\uBF52\uBF53\uBF54\uBF56\uBF57\uBF58\uBF59\uBF5A\uBF5B\uBF5C\uBF5D\uBF5E\uBF5F\uBF60\uBF61\uBF62\uBF63\uBF64\uBF65\uBF66\uBF67\uBF68\uBF69\uBF6A\uBF6B\uBF6C\uBF6D\uBF6E\uBF6F\uBF70\uBF71\uBF72\uBF73\uBF74\uBF75\uBF76\uBF77\uBF78\uBF79\uBF7A\uBF7B\uBF7C\uBF7D\uBF7E\uBF7F\uBF80\uBF81\uBF82\uFFFD".split("");
    for(j = 0; j != D[150].length; ++j)if (D[150][j].charCodeAt(0) !== 0xFFFD) {
        e[D[150][j]] = 38400 + j;
        d[38400 + j] = D[150][j];
    }
    D[151] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBF83\uBF84\uBF85\uBF86\uBF87\uBF88\uBF89\uBF8A\uBF8B\uBF8C\uBF8D\uBF8E\uBF8F\uBF90\uBF91\uBF92\uBF93\uBF95\uBF96\uBF97\uBF98\uBF99\uBF9A\uBF9B\uBF9C\uBF9D\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBF9E\uBF9F\uBFA0\uBFA1\uBFA2\uBFA3\uBFA4\uBFA5\uBFA6\uBFA7\uBFA8\uBFA9\uBFAA\uBFAB\uBFAC\uBFAD\uBFAE\uBFAF\uBFB1\uBFB2\uBFB3\uBFB4\uBFB5\uBFB6\uBFB7\uBFB8\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBFB9\uBFBA\uBFBB\uBFBC\uBFBD\uBFBE\uBFBF\uBFC0\uBFC1\uBFC2\uBFC3\uBFC4\uBFC6\uBFC7\uBFC8\uBFC9\uBFCA\uBFCB\uBFCE\uBFCF\uBFD1\uBFD2\uBFD3\uBFD5\uBFD6\uBFD7\uBFD8\uBFD9\uBFDA\uBFDB\uBFDD\uBFDE\uBFE0\uBFE2\uBFE3\uBFE4\uBFE5\uBFE6\uBFE7\uBFE8\uBFE9\uBFEA\uBFEB\uBFEC\uBFED\uBFEE\uBFEF\uBFF0\uBFF1\uBFF2\uBFF3\uBFF4\uBFF5\uBFF6\uBFF7\uBFF8\uBFF9\uBFFA\uBFFB\uBFFC\uBFFD\uBFFE\uBFFF\uC000\uC001\uC002\uC003\uC004\uC005\uC006\uC007\uC008\uC009\uC00A\uC00B\uC00C\uC00D\uC00E\uC00F\uC010\uC011\uC012\uC013\uC014\uC015\uC016\uC017\uC018\uC019\uC01A\uC01B\uC01C\uC01D\uC01E\uC01F\uC020\uC021\uC022\uC023\uC024\uC025\uC026\uC027\uC028\uC029\uC02A\uC02B\uC02C\uC02D\uC02E\uC02F\uC030\uC031\uC032\uC033\uC034\uC035\uC036\uC037\uC038\uC039\uC03A\uC03B\uC03D\uC03E\uC03F\uFFFD".split("");
    for(j = 0; j != D[151].length; ++j)if (D[151][j].charCodeAt(0) !== 0xFFFD) {
        e[D[151][j]] = 38656 + j;
        d[38656 + j] = D[151][j];
    }
    D[152] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC040\uC041\uC042\uC043\uC044\uC045\uC046\uC047\uC048\uC049\uC04A\uC04B\uC04C\uC04D\uC04E\uC04F\uC050\uC052\uC053\uC054\uC055\uC056\uC057\uC059\uC05A\uC05B\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC05D\uC05E\uC05F\uC061\uC062\uC063\uC064\uC065\uC066\uC067\uC06A\uC06B\uC06C\uC06D\uC06E\uC06F\uC070\uC071\uC072\uC073\uC074\uC075\uC076\uC077\uC078\uC079\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC07A\uC07B\uC07C\uC07D\uC07E\uC07F\uC080\uC081\uC082\uC083\uC084\uC085\uC086\uC087\uC088\uC089\uC08A\uC08B\uC08C\uC08D\uC08E\uC08F\uC092\uC093\uC095\uC096\uC097\uC099\uC09A\uC09B\uC09C\uC09D\uC09E\uC09F\uC0A2\uC0A4\uC0A6\uC0A7\uC0A8\uC0A9\uC0AA\uC0AB\uC0AE\uC0B1\uC0B2\uC0B7\uC0B8\uC0B9\uC0BA\uC0BB\uC0BE\uC0C2\uC0C3\uC0C4\uC0C6\uC0C7\uC0CA\uC0CB\uC0CD\uC0CE\uC0CF\uC0D1\uC0D2\uC0D3\uC0D4\uC0D5\uC0D6\uC0D7\uC0DA\uC0DE\uC0DF\uC0E0\uC0E1\uC0E2\uC0E3\uC0E6\uC0E7\uC0E9\uC0EA\uC0EB\uC0ED\uC0EE\uC0EF\uC0F0\uC0F1\uC0F2\uC0F3\uC0F6\uC0F8\uC0FA\uC0FB\uC0FC\uC0FD\uC0FE\uC0FF\uC101\uC102\uC103\uC105\uC106\uC107\uC109\uC10A\uC10B\uC10C\uC10D\uC10E\uC10F\uC111\uC112\uC113\uC114\uC116\uC117\uC118\uC119\uC11A\uC11B\uC121\uC122\uC125\uC128\uC129\uC12A\uC12B\uC12E\uFFFD".split("");
    for(j = 0; j != D[152].length; ++j)if (D[152][j].charCodeAt(0) !== 0xFFFD) {
        e[D[152][j]] = 38912 + j;
        d[38912 + j] = D[152][j];
    }
    D[153] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC132\uC133\uC134\uC135\uC137\uC13A\uC13B\uC13D\uC13E\uC13F\uC141\uC142\uC143\uC144\uC145\uC146\uC147\uC14A\uC14E\uC14F\uC150\uC151\uC152\uC153\uC156\uC157\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC159\uC15A\uC15B\uC15D\uC15E\uC15F\uC160\uC161\uC162\uC163\uC166\uC16A\uC16B\uC16C\uC16D\uC16E\uC16F\uC171\uC172\uC173\uC175\uC176\uC177\uC179\uC17A\uC17B\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC17C\uC17D\uC17E\uC17F\uC180\uC181\uC182\uC183\uC184\uC186\uC187\uC188\uC189\uC18A\uC18B\uC18F\uC191\uC192\uC193\uC195\uC197\uC198\uC199\uC19A\uC19B\uC19E\uC1A0\uC1A2\uC1A3\uC1A4\uC1A6\uC1A7\uC1AA\uC1AB\uC1AD\uC1AE\uC1AF\uC1B1\uC1B2\uC1B3\uC1B4\uC1B5\uC1B6\uC1B7\uC1B8\uC1B9\uC1BA\uC1BB\uC1BC\uC1BE\uC1BF\uC1C0\uC1C1\uC1C2\uC1C3\uC1C5\uC1C6\uC1C7\uC1C9\uC1CA\uC1CB\uC1CD\uC1CE\uC1CF\uC1D0\uC1D1\uC1D2\uC1D3\uC1D5\uC1D6\uC1D9\uC1DA\uC1DB\uC1DC\uC1DD\uC1DE\uC1DF\uC1E1\uC1E2\uC1E3\uC1E5\uC1E6\uC1E7\uC1E9\uC1EA\uC1EB\uC1EC\uC1ED\uC1EE\uC1EF\uC1F2\uC1F4\uC1F5\uC1F6\uC1F7\uC1F8\uC1F9\uC1FA\uC1FB\uC1FE\uC1FF\uC201\uC202\uC203\uC205\uC206\uC207\uC208\uC209\uC20A\uC20B\uC20E\uC210\uC212\uC213\uC214\uC215\uC216\uC217\uC21A\uC21B\uC21D\uC21E\uC221\uC222\uC223\uFFFD".split("");
    for(j = 0; j != D[153].length; ++j)if (D[153][j].charCodeAt(0) !== 0xFFFD) {
        e[D[153][j]] = 39168 + j;
        d[39168 + j] = D[153][j];
    }
    D[154] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC224\uC225\uC226\uC227\uC22A\uC22C\uC22E\uC230\uC233\uC235\uC236\uC237\uC238\uC239\uC23A\uC23B\uC23C\uC23D\uC23E\uC23F\uC240\uC241\uC242\uC243\uC244\uC245\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC246\uC247\uC249\uC24A\uC24B\uC24C\uC24D\uC24E\uC24F\uC252\uC253\uC255\uC256\uC257\uC259\uC25A\uC25B\uC25C\uC25D\uC25E\uC25F\uC261\uC262\uC263\uC264\uC266\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC267\uC268\uC269\uC26A\uC26B\uC26E\uC26F\uC271\uC272\uC273\uC275\uC276\uC277\uC278\uC279\uC27A\uC27B\uC27E\uC280\uC282\uC283\uC284\uC285\uC286\uC287\uC28A\uC28B\uC28C\uC28D\uC28E\uC28F\uC291\uC292\uC293\uC294\uC295\uC296\uC297\uC299\uC29A\uC29C\uC29E\uC29F\uC2A0\uC2A1\uC2A2\uC2A3\uC2A6\uC2A7\uC2A9\uC2AA\uC2AB\uC2AE\uC2AF\uC2B0\uC2B1\uC2B2\uC2B3\uC2B6\uC2B8\uC2BA\uC2BB\uC2BC\uC2BD\uC2BE\uC2BF\uC2C0\uC2C1\uC2C2\uC2C3\uC2C4\uC2C5\uC2C6\uC2C7\uC2C8\uC2C9\uC2CA\uC2CB\uC2CC\uC2CD\uC2CE\uC2CF\uC2D0\uC2D1\uC2D2\uC2D3\uC2D4\uC2D5\uC2D6\uC2D7\uC2D8\uC2D9\uC2DA\uC2DB\uC2DE\uC2DF\uC2E1\uC2E2\uC2E5\uC2E6\uC2E7\uC2E8\uC2E9\uC2EA\uC2EE\uC2F0\uC2F2\uC2F3\uC2F4\uC2F5\uC2F7\uC2FA\uC2FD\uC2FE\uC2FF\uC301\uC302\uC303\uC304\uC305\uC306\uC307\uC30A\uC30B\uC30E\uC30F\uFFFD".split("");
    for(j = 0; j != D[154].length; ++j)if (D[154][j].charCodeAt(0) !== 0xFFFD) {
        e[D[154][j]] = 39424 + j;
        d[39424 + j] = D[154][j];
    }
    D[155] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC310\uC311\uC312\uC316\uC317\uC319\uC31A\uC31B\uC31D\uC31E\uC31F\uC320\uC321\uC322\uC323\uC326\uC327\uC32A\uC32B\uC32C\uC32D\uC32E\uC32F\uC330\uC331\uC332\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC333\uC334\uC335\uC336\uC337\uC338\uC339\uC33A\uC33B\uC33C\uC33D\uC33E\uC33F\uC340\uC341\uC342\uC343\uC344\uC346\uC347\uC348\uC349\uC34A\uC34B\uC34C\uC34D\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC34E\uC34F\uC350\uC351\uC352\uC353\uC354\uC355\uC356\uC357\uC358\uC359\uC35A\uC35B\uC35C\uC35D\uC35E\uC35F\uC360\uC361\uC362\uC363\uC364\uC365\uC366\uC367\uC36A\uC36B\uC36D\uC36E\uC36F\uC371\uC373\uC374\uC375\uC376\uC377\uC37A\uC37B\uC37E\uC37F\uC380\uC381\uC382\uC383\uC385\uC386\uC387\uC389\uC38A\uC38B\uC38D\uC38E\uC38F\uC390\uC391\uC392\uC393\uC394\uC395\uC396\uC397\uC398\uC399\uC39A\uC39B\uC39C\uC39D\uC39E\uC39F\uC3A0\uC3A1\uC3A2\uC3A3\uC3A4\uC3A5\uC3A6\uC3A7\uC3A8\uC3A9\uC3AA\uC3AB\uC3AC\uC3AD\uC3AE\uC3AF\uC3B0\uC3B1\uC3B2\uC3B3\uC3B4\uC3B5\uC3B6\uC3B7\uC3B8\uC3B9\uC3BA\uC3BB\uC3BC\uC3BD\uC3BE\uC3BF\uC3C1\uC3C2\uC3C3\uC3C4\uC3C5\uC3C6\uC3C7\uC3C8\uC3C9\uC3CA\uC3CB\uC3CC\uC3CD\uC3CE\uC3CF\uC3D0\uC3D1\uC3D2\uC3D3\uC3D4\uC3D5\uC3D6\uC3D7\uC3DA\uFFFD".split("");
    for(j = 0; j != D[155].length; ++j)if (D[155][j].charCodeAt(0) !== 0xFFFD) {
        e[D[155][j]] = 39680 + j;
        d[39680 + j] = D[155][j];
    }
    D[156] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC3DB\uC3DD\uC3DE\uC3E1\uC3E3\uC3E4\uC3E5\uC3E6\uC3E7\uC3EA\uC3EB\uC3EC\uC3EE\uC3EF\uC3F0\uC3F1\uC3F2\uC3F3\uC3F6\uC3F7\uC3F9\uC3FA\uC3FB\uC3FC\uC3FD\uC3FE\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC3FF\uC400\uC401\uC402\uC403\uC404\uC405\uC406\uC407\uC409\uC40A\uC40B\uC40C\uC40D\uC40E\uC40F\uC411\uC412\uC413\uC414\uC415\uC416\uC417\uC418\uC419\uC41A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC41B\uC41C\uC41D\uC41E\uC41F\uC420\uC421\uC422\uC423\uC425\uC426\uC427\uC428\uC429\uC42A\uC42B\uC42D\uC42E\uC42F\uC431\uC432\uC433\uC435\uC436\uC437\uC438\uC439\uC43A\uC43B\uC43E\uC43F\uC440\uC441\uC442\uC443\uC444\uC445\uC446\uC447\uC449\uC44A\uC44B\uC44C\uC44D\uC44E\uC44F\uC450\uC451\uC452\uC453\uC454\uC455\uC456\uC457\uC458\uC459\uC45A\uC45B\uC45C\uC45D\uC45E\uC45F\uC460\uC461\uC462\uC463\uC466\uC467\uC469\uC46A\uC46B\uC46D\uC46E\uC46F\uC470\uC471\uC472\uC473\uC476\uC477\uC478\uC47A\uC47B\uC47C\uC47D\uC47E\uC47F\uC481\uC482\uC483\uC484\uC485\uC486\uC487\uC488\uC489\uC48A\uC48B\uC48C\uC48D\uC48E\uC48F\uC490\uC491\uC492\uC493\uC495\uC496\uC497\uC498\uC499\uC49A\uC49B\uC49D\uC49E\uC49F\uC4A0\uC4A1\uC4A2\uC4A3\uC4A4\uC4A5\uC4A6\uC4A7\uC4A8\uC4A9\uFFFD".split("");
    for(j = 0; j != D[156].length; ++j)if (D[156][j].charCodeAt(0) !== 0xFFFD) {
        e[D[156][j]] = 39936 + j;
        d[39936 + j] = D[156][j];
    }
    D[157] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC4AA\uC4AB\uC4AC\uC4AD\uC4AE\uC4AF\uC4B0\uC4B1\uC4B2\uC4B3\uC4B4\uC4B5\uC4B6\uC4B7\uC4B9\uC4BA\uC4BB\uC4BD\uC4BE\uC4BF\uC4C0\uC4C1\uC4C2\uC4C3\uC4C4\uC4C5\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC4C6\uC4C7\uC4C8\uC4C9\uC4CA\uC4CB\uC4CC\uC4CD\uC4CE\uC4CF\uC4D0\uC4D1\uC4D2\uC4D3\uC4D4\uC4D5\uC4D6\uC4D7\uC4D8\uC4D9\uC4DA\uC4DB\uC4DC\uC4DD\uC4DE\uC4DF\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC4E0\uC4E1\uC4E2\uC4E3\uC4E4\uC4E5\uC4E6\uC4E7\uC4E8\uC4EA\uC4EB\uC4EC\uC4ED\uC4EE\uC4EF\uC4F2\uC4F3\uC4F5\uC4F6\uC4F7\uC4F9\uC4FB\uC4FC\uC4FD\uC4FE\uC502\uC503\uC504\uC505\uC506\uC507\uC508\uC509\uC50A\uC50B\uC50D\uC50E\uC50F\uC511\uC512\uC513\uC515\uC516\uC517\uC518\uC519\uC51A\uC51B\uC51D\uC51E\uC51F\uC520\uC521\uC522\uC523\uC524\uC525\uC526\uC527\uC52A\uC52B\uC52D\uC52E\uC52F\uC531\uC532\uC533\uC534\uC535\uC536\uC537\uC53A\uC53C\uC53E\uC53F\uC540\uC541\uC542\uC543\uC546\uC547\uC54B\uC54F\uC550\uC551\uC552\uC556\uC55A\uC55B\uC55C\uC55F\uC562\uC563\uC565\uC566\uC567\uC569\uC56A\uC56B\uC56C\uC56D\uC56E\uC56F\uC572\uC576\uC577\uC578\uC579\uC57A\uC57B\uC57E\uC57F\uC581\uC582\uC583\uC585\uC586\uC588\uC589\uC58A\uC58B\uC58E\uC590\uC592\uC593\uC594\uFFFD".split("");
    for(j = 0; j != D[157].length; ++j)if (D[157][j].charCodeAt(0) !== 0xFFFD) {
        e[D[157][j]] = 40192 + j;
        d[40192 + j] = D[157][j];
    }
    D[158] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC596\uC599\uC59A\uC59B\uC59D\uC59E\uC59F\uC5A1\uC5A2\uC5A3\uC5A4\uC5A5\uC5A6\uC5A7\uC5A8\uC5AA\uC5AB\uC5AC\uC5AD\uC5AE\uC5AF\uC5B0\uC5B1\uC5B2\uC5B3\uC5B6\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC5B7\uC5BA\uC5BF\uC5C0\uC5C1\uC5C2\uC5C3\uC5CB\uC5CD\uC5CF\uC5D2\uC5D3\uC5D5\uC5D6\uC5D7\uC5D9\uC5DA\uC5DB\uC5DC\uC5DD\uC5DE\uC5DF\uC5E2\uC5E4\uC5E6\uC5E7\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC5E8\uC5E9\uC5EA\uC5EB\uC5EF\uC5F1\uC5F2\uC5F3\uC5F5\uC5F8\uC5F9\uC5FA\uC5FB\uC602\uC603\uC604\uC609\uC60A\uC60B\uC60D\uC60E\uC60F\uC611\uC612\uC613\uC614\uC615\uC616\uC617\uC61A\uC61D\uC61E\uC61F\uC620\uC621\uC622\uC623\uC626\uC627\uC629\uC62A\uC62B\uC62F\uC631\uC632\uC636\uC638\uC63A\uC63C\uC63D\uC63E\uC63F\uC642\uC643\uC645\uC646\uC647\uC649\uC64A\uC64B\uC64C\uC64D\uC64E\uC64F\uC652\uC656\uC657\uC658\uC659\uC65A\uC65B\uC65E\uC65F\uC661\uC662\uC663\uC664\uC665\uC666\uC667\uC668\uC669\uC66A\uC66B\uC66D\uC66E\uC670\uC672\uC673\uC674\uC675\uC676\uC677\uC67A\uC67B\uC67D\uC67E\uC67F\uC681\uC682\uC683\uC684\uC685\uC686\uC687\uC68A\uC68C\uC68E\uC68F\uC690\uC691\uC692\uC693\uC696\uC697\uC699\uC69A\uC69B\uC69D\uC69E\uC69F\uC6A0\uC6A1\uC6A2\uC6A3\uC6A6\uFFFD".split("");
    for(j = 0; j != D[158].length; ++j)if (D[158][j].charCodeAt(0) !== 0xFFFD) {
        e[D[158][j]] = 40448 + j;
        d[40448 + j] = D[158][j];
    }
    D[159] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC6A8\uC6AA\uC6AB\uC6AC\uC6AD\uC6AE\uC6AF\uC6B2\uC6B3\uC6B5\uC6B6\uC6B7\uC6BB\uC6BC\uC6BD\uC6BE\uC6BF\uC6C2\uC6C4\uC6C6\uC6C7\uC6C8\uC6C9\uC6CA\uC6CB\uC6CE\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC6CF\uC6D1\uC6D2\uC6D3\uC6D5\uC6D6\uC6D7\uC6D8\uC6D9\uC6DA\uC6DB\uC6DE\uC6DF\uC6E2\uC6E3\uC6E4\uC6E5\uC6E6\uC6E7\uC6EA\uC6EB\uC6ED\uC6EE\uC6EF\uC6F1\uC6F2\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC6F3\uC6F4\uC6F5\uC6F6\uC6F7\uC6FA\uC6FB\uC6FC\uC6FE\uC6FF\uC700\uC701\uC702\uC703\uC706\uC707\uC709\uC70A\uC70B\uC70D\uC70E\uC70F\uC710\uC711\uC712\uC713\uC716\uC718\uC71A\uC71B\uC71C\uC71D\uC71E\uC71F\uC722\uC723\uC725\uC726\uC727\uC729\uC72A\uC72B\uC72C\uC72D\uC72E\uC72F\uC732\uC734\uC736\uC738\uC739\uC73A\uC73B\uC73E\uC73F\uC741\uC742\uC743\uC745\uC746\uC747\uC748\uC749\uC74B\uC74E\uC750\uC759\uC75A\uC75B\uC75D\uC75E\uC75F\uC761\uC762\uC763\uC764\uC765\uC766\uC767\uC769\uC76A\uC76C\uC76D\uC76E\uC76F\uC770\uC771\uC772\uC773\uC776\uC777\uC779\uC77A\uC77B\uC77F\uC780\uC781\uC782\uC786\uC78B\uC78C\uC78D\uC78F\uC792\uC793\uC795\uC799\uC79B\uC79C\uC79D\uC79E\uC79F\uC7A2\uC7A7\uC7A8\uC7A9\uC7AA\uC7AB\uC7AE\uC7AF\uC7B1\uC7B2\uC7B3\uC7B5\uC7B6\uC7B7\uFFFD".split("");
    for(j = 0; j != D[159].length; ++j)if (D[159][j].charCodeAt(0) !== 0xFFFD) {
        e[D[159][j]] = 40704 + j;
        d[40704 + j] = D[159][j];
    }
    D[160] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC7B8\uC7B9\uC7BA\uC7BB\uC7BE\uC7C2\uC7C3\uC7C4\uC7C5\uC7C6\uC7C7\uC7CA\uC7CB\uC7CD\uC7CF\uC7D1\uC7D2\uC7D3\uC7D4\uC7D5\uC7D6\uC7D7\uC7D9\uC7DA\uC7DB\uC7DC\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC7DE\uC7DF\uC7E0\uC7E1\uC7E2\uC7E3\uC7E5\uC7E6\uC7E7\uC7E9\uC7EA\uC7EB\uC7ED\uC7EE\uC7EF\uC7F0\uC7F1\uC7F2\uC7F3\uC7F4\uC7F5\uC7F6\uC7F7\uC7F8\uC7F9\uC7FA\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC7FB\uC7FC\uC7FD\uC7FE\uC7FF\uC802\uC803\uC805\uC806\uC807\uC809\uC80B\uC80C\uC80D\uC80E\uC80F\uC812\uC814\uC817\uC818\uC819\uC81A\uC81B\uC81E\uC81F\uC821\uC822\uC823\uC825\uC826\uC827\uC828\uC829\uC82A\uC82B\uC82E\uC830\uC832\uC833\uC834\uC835\uC836\uC837\uC839\uC83A\uC83B\uC83D\uC83E\uC83F\uC841\uC842\uC843\uC844\uC845\uC846\uC847\uC84A\uC84B\uC84E\uC84F\uC850\uC851\uC852\uC853\uC855\uC856\uC857\uC858\uC859\uC85A\uC85B\uC85C\uC85D\uC85E\uC85F\uC860\uC861\uC862\uC863\uC864\uC865\uC866\uC867\uC868\uC869\uC86A\uC86B\uC86C\uC86D\uC86E\uC86F\uC872\uC873\uC875\uC876\uC877\uC879\uC87B\uC87C\uC87D\uC87E\uC87F\uC882\uC884\uC888\uC889\uC88A\uC88E\uC88F\uC890\uC891\uC892\uC893\uC895\uC896\uC897\uC898\uC899\uC89A\uC89B\uC89C\uC89E\uC8A0\uC8A2\uC8A3\uC8A4\uFFFD".split("");
    for(j = 0; j != D[160].length; ++j)if (D[160][j].charCodeAt(0) !== 0xFFFD) {
        e[D[160][j]] = 40960 + j;
        d[40960 + j] = D[160][j];
    }
    D[161] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC8A5\uC8A6\uC8A7\uC8A9\uC8AA\uC8AB\uC8AC\uC8AD\uC8AE\uC8AF\uC8B0\uC8B1\uC8B2\uC8B3\uC8B4\uC8B5\uC8B6\uC8B7\uC8B8\uC8B9\uC8BA\uC8BB\uC8BE\uC8BF\uC8C0\uC8C1\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC8C2\uC8C3\uC8C5\uC8C6\uC8C7\uC8C9\uC8CA\uC8CB\uC8CD\uC8CE\uC8CF\uC8D0\uC8D1\uC8D2\uC8D3\uC8D6\uC8D8\uC8DA\uC8DB\uC8DC\uC8DD\uC8DE\uC8DF\uC8E2\uC8E3\uC8E5\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC8E6\uC8E7\uC8E8\uC8E9\uC8EA\uC8EB\uC8EC\uC8ED\uC8EE\uC8EF\uC8F0\uC8F1\uC8F2\uC8F3\uC8F4\uC8F6\uC8F7\uC8F8\uC8F9\uC8FA\uC8FB\uC8FE\uC8FF\uC901\uC902\uC903\uC907\uC908\uC909\uC90A\uC90B\uC90E\u3000\u3001\u3002\xb7\u2025\u2026\xa8\u3003\xad\u2015\u2225\uFF3C\u223C\u2018\u2019\u201C\u201D\u3014\u3015\u3008\u3009\u300A\u300B\u300C\u300D\u300E\u300F\u3010\u3011\xb1\xd7\xf7\u2260\u2264\u2265\u221E\u2234\xb0\u2032\u2033\u2103\u212B\uFFE0\uFFE1\uFFE5\u2642\u2640\u2220\u22A5\u2312\u2202\u2207\u2261\u2252\xa7\u203B\u2606\u2605\u25CB\u25CF\u25CE\u25C7\u25C6\u25A1\u25A0\u25B3\u25B2\u25BD\u25BC\u2192\u2190\u2191\u2193\u2194\u3013\u226A\u226B\u221A\u223D\u221D\u2235\u222B\u222C\u2208\u220B\u2286\u2287\u2282\u2283\u222A\u2229\u2227\u2228\uFFE2\uFFFD".split("");
    for(j = 0; j != D[161].length; ++j)if (D[161][j].charCodeAt(0) !== 0xFFFD) {
        e[D[161][j]] = 41216 + j;
        d[41216 + j] = D[161][j];
    }
    D[162] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC910\uC912\uC913\uC914\uC915\uC916\uC917\uC919\uC91A\uC91B\uC91C\uC91D\uC91E\uC91F\uC920\uC921\uC922\uC923\uC924\uC925\uC926\uC927\uC928\uC929\uC92A\uC92B\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC92D\uC92E\uC92F\uC930\uC931\uC932\uC933\uC935\uC936\uC937\uC938\uC939\uC93A\uC93B\uC93C\uC93D\uC93E\uC93F\uC940\uC941\uC942\uC943\uC944\uC945\uC946\uC947\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC948\uC949\uC94A\uC94B\uC94C\uC94D\uC94E\uC94F\uC952\uC953\uC955\uC956\uC957\uC959\uC95A\uC95B\uC95C\uC95D\uC95E\uC95F\uC962\uC964\uC965\uC966\uC967\uC968\uC969\uC96A\uC96B\uC96D\uC96E\uC96F\u21D2\u21D4\u2200\u2203\xb4\uFF5E\u02C7\u02D8\u02DD\u02DA\u02D9\xb8\u02DB\xa1\xbf\u02D0\u222E\u2211\u220F\xa4\u2109\u2030\u25C1\u25C0\u25B7\u25B6\u2664\u2660\u2661\u2665\u2667\u2663\u2299\u25C8\u25A3\u25D0\u25D1\u2592\u25A4\u25A5\u25A8\u25A7\u25A6\u25A9\u2668\u260F\u260E\u261C\u261E\xb6\u2020\u2021\u2195\u2197\u2199\u2196\u2198\u266D\u2669\u266A\u266C\u327F\u321C\u2116\u33C7\u2122\u33C2\u33D8\u2121\u20AC\xae\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[162].length; ++j)if (D[162][j].charCodeAt(0) !== 0xFFFD) {
        e[D[162][j]] = 41472 + j;
        d[41472 + j] = D[162][j];
    }
    D[163] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC971\uC972\uC973\uC975\uC976\uC977\uC978\uC979\uC97A\uC97B\uC97D\uC97E\uC97F\uC980\uC981\uC982\uC983\uC984\uC985\uC986\uC987\uC98A\uC98B\uC98D\uC98E\uC98F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC991\uC992\uC993\uC994\uC995\uC996\uC997\uC99A\uC99C\uC99E\uC99F\uC9A0\uC9A1\uC9A2\uC9A3\uC9A4\uC9A5\uC9A6\uC9A7\uC9A8\uC9A9\uC9AA\uC9AB\uC9AC\uC9AD\uC9AE\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC9AF\uC9B0\uC9B1\uC9B2\uC9B3\uC9B4\uC9B5\uC9B6\uC9B7\uC9B8\uC9B9\uC9BA\uC9BB\uC9BC\uC9BD\uC9BE\uC9BF\uC9C2\uC9C3\uC9C5\uC9C6\uC9C9\uC9CB\uC9CC\uC9CD\uC9CE\uC9CF\uC9D2\uC9D4\uC9D7\uC9D8\uC9DB\uFF01\uFF02\uFF03\uFF04\uFF05\uFF06\uFF07\uFF08\uFF09\uFF0A\uFF0B\uFF0C\uFF0D\uFF0E\uFF0F\uFF10\uFF11\uFF12\uFF13\uFF14\uFF15\uFF16\uFF17\uFF18\uFF19\uFF1A\uFF1B\uFF1C\uFF1D\uFF1E\uFF1F\uFF20\uFF21\uFF22\uFF23\uFF24\uFF25\uFF26\uFF27\uFF28\uFF29\uFF2A\uFF2B\uFF2C\uFF2D\uFF2E\uFF2F\uFF30\uFF31\uFF32\uFF33\uFF34\uFF35\uFF36\uFF37\uFF38\uFF39\uFF3A\uFF3B\uFFE6\uFF3D\uFF3E\uFF3F\uFF40\uFF41\uFF42\uFF43\uFF44\uFF45\uFF46\uFF47\uFF48\uFF49\uFF4A\uFF4B\uFF4C\uFF4D\uFF4E\uFF4F\uFF50\uFF51\uFF52\uFF53\uFF54\uFF55\uFF56\uFF57\uFF58\uFF59\uFF5A\uFF5B\uFF5C\uFF5D\uFFE3\uFFFD".split("");
    for(j = 0; j != D[163].length; ++j)if (D[163][j].charCodeAt(0) !== 0xFFFD) {
        e[D[163][j]] = 41728 + j;
        d[41728 + j] = D[163][j];
    }
    D[164] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC9DE\uC9DF\uC9E1\uC9E3\uC9E5\uC9E6\uC9E8\uC9E9\uC9EA\uC9EB\uC9EE\uC9F2\uC9F3\uC9F4\uC9F5\uC9F6\uC9F7\uC9FA\uC9FB\uC9FD\uC9FE\uC9FF\uCA01\uCA02\uCA03\uCA04\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCA05\uCA06\uCA07\uCA0A\uCA0E\uCA0F\uCA10\uCA11\uCA12\uCA13\uCA15\uCA16\uCA17\uCA19\uCA1A\uCA1B\uCA1C\uCA1D\uCA1E\uCA1F\uCA20\uCA21\uCA22\uCA23\uCA24\uCA25\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCA26\uCA27\uCA28\uCA2A\uCA2B\uCA2C\uCA2D\uCA2E\uCA2F\uCA30\uCA31\uCA32\uCA33\uCA34\uCA35\uCA36\uCA37\uCA38\uCA39\uCA3A\uCA3B\uCA3C\uCA3D\uCA3E\uCA3F\uCA40\uCA41\uCA42\uCA43\uCA44\uCA45\uCA46\u3131\u3132\u3133\u3134\u3135\u3136\u3137\u3138\u3139\u313A\u313B\u313C\u313D\u313E\u313F\u3140\u3141\u3142\u3143\u3144\u3145\u3146\u3147\u3148\u3149\u314A\u314B\u314C\u314D\u314E\u314F\u3150\u3151\u3152\u3153\u3154\u3155\u3156\u3157\u3158\u3159\u315A\u315B\u315C\u315D\u315E\u315F\u3160\u3161\u3162\u3163\u3164\u3165\u3166\u3167\u3168\u3169\u316A\u316B\u316C\u316D\u316E\u316F\u3170\u3171\u3172\u3173\u3174\u3175\u3176\u3177\u3178\u3179\u317A\u317B\u317C\u317D\u317E\u317F\u3180\u3181\u3182\u3183\u3184\u3185\u3186\u3187\u3188\u3189\u318A\u318B\u318C\u318D\u318E\uFFFD".split("");
    for(j = 0; j != D[164].length; ++j)if (D[164][j].charCodeAt(0) !== 0xFFFD) {
        e[D[164][j]] = 41984 + j;
        d[41984 + j] = D[164][j];
    }
    D[165] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCA47\uCA48\uCA49\uCA4A\uCA4B\uCA4E\uCA4F\uCA51\uCA52\uCA53\uCA55\uCA56\uCA57\uCA58\uCA59\uCA5A\uCA5B\uCA5E\uCA62\uCA63\uCA64\uCA65\uCA66\uCA67\uCA69\uCA6A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCA6B\uCA6C\uCA6D\uCA6E\uCA6F\uCA70\uCA71\uCA72\uCA73\uCA74\uCA75\uCA76\uCA77\uCA78\uCA79\uCA7A\uCA7B\uCA7C\uCA7E\uCA7F\uCA80\uCA81\uCA82\uCA83\uCA85\uCA86\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCA87\uCA88\uCA89\uCA8A\uCA8B\uCA8C\uCA8D\uCA8E\uCA8F\uCA90\uCA91\uCA92\uCA93\uCA94\uCA95\uCA96\uCA97\uCA99\uCA9A\uCA9B\uCA9C\uCA9D\uCA9E\uCA9F\uCAA0\uCAA1\uCAA2\uCAA3\uCAA4\uCAA5\uCAA6\uCAA7\u2170\u2171\u2172\u2173\u2174\u2175\u2176\u2177\u2178\u2179\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2160\u2161\u2162\u2163\u2164\u2165\u2166\u2167\u2168\u2169\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0391\u0392\u0393\u0394\u0395\u0396\u0397\u0398\u0399\u039A\u039B\u039C\u039D\u039E\u039F\u03A0\u03A1\u03A3\u03A4\u03A5\u03A6\u03A7\u03A8\u03A9\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u03B1\u03B2\u03B3\u03B4\u03B5\u03B6\u03B7\u03B8\u03B9\u03BA\u03BB\u03BC\u03BD\u03BE\u03BF\u03C0\u03C1\u03C3\u03C4\u03C5\u03C6\u03C7\u03C8\u03C9\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[165].length; ++j)if (D[165][j].charCodeAt(0) !== 0xFFFD) {
        e[D[165][j]] = 42240 + j;
        d[42240 + j] = D[165][j];
    }
    D[166] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCAA8\uCAA9\uCAAA\uCAAB\uCAAC\uCAAD\uCAAE\uCAAF\uCAB0\uCAB1\uCAB2\uCAB3\uCAB4\uCAB5\uCAB6\uCAB7\uCAB8\uCAB9\uCABA\uCABB\uCABE\uCABF\uCAC1\uCAC2\uCAC3\uCAC5\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCAC6\uCAC7\uCAC8\uCAC9\uCACA\uCACB\uCACE\uCAD0\uCAD2\uCAD4\uCAD5\uCAD6\uCAD7\uCADA\uCADB\uCADC\uCADD\uCADE\uCADF\uCAE1\uCAE2\uCAE3\uCAE4\uCAE5\uCAE6\uCAE7\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCAE8\uCAE9\uCAEA\uCAEB\uCAED\uCAEE\uCAEF\uCAF0\uCAF1\uCAF2\uCAF3\uCAF5\uCAF6\uCAF7\uCAF8\uCAF9\uCAFA\uCAFB\uCAFC\uCAFD\uCAFE\uCAFF\uCB00\uCB01\uCB02\uCB03\uCB04\uCB05\uCB06\uCB07\uCB09\uCB0A\u2500\u2502\u250C\u2510\u2518\u2514\u251C\u252C\u2524\u2534\u253C\u2501\u2503\u250F\u2513\u251B\u2517\u2523\u2533\u252B\u253B\u254B\u2520\u252F\u2528\u2537\u253F\u251D\u2530\u2525\u2538\u2542\u2512\u2511\u251A\u2519\u2516\u2515\u250E\u250D\u251E\u251F\u2521\u2522\u2526\u2527\u2529\u252A\u252D\u252E\u2531\u2532\u2535\u2536\u2539\u253A\u253D\u253E\u2540\u2541\u2543\u2544\u2545\u2546\u2547\u2548\u2549\u254A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[166].length; ++j)if (D[166][j].charCodeAt(0) !== 0xFFFD) {
        e[D[166][j]] = 42496 + j;
        d[42496 + j] = D[166][j];
    }
    D[167] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCB0B\uCB0C\uCB0D\uCB0E\uCB0F\uCB11\uCB12\uCB13\uCB15\uCB16\uCB17\uCB19\uCB1A\uCB1B\uCB1C\uCB1D\uCB1E\uCB1F\uCB22\uCB23\uCB24\uCB25\uCB26\uCB27\uCB28\uCB29\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCB2A\uCB2B\uCB2C\uCB2D\uCB2E\uCB2F\uCB30\uCB31\uCB32\uCB33\uCB34\uCB35\uCB36\uCB37\uCB38\uCB39\uCB3A\uCB3B\uCB3C\uCB3D\uCB3E\uCB3F\uCB40\uCB42\uCB43\uCB44\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCB45\uCB46\uCB47\uCB4A\uCB4B\uCB4D\uCB4E\uCB4F\uCB51\uCB52\uCB53\uCB54\uCB55\uCB56\uCB57\uCB5A\uCB5B\uCB5C\uCB5E\uCB5F\uCB60\uCB61\uCB62\uCB63\uCB65\uCB66\uCB67\uCB68\uCB69\uCB6A\uCB6B\uCB6C\u3395\u3396\u3397\u2113\u3398\u33C4\u33A3\u33A4\u33A5\u33A6\u3399\u339A\u339B\u339C\u339D\u339E\u339F\u33A0\u33A1\u33A2\u33CA\u338D\u338E\u338F\u33CF\u3388\u3389\u33C8\u33A7\u33A8\u33B0\u33B1\u33B2\u33B3\u33B4\u33B5\u33B6\u33B7\u33B8\u33B9\u3380\u3381\u3382\u3383\u3384\u33BA\u33BB\u33BC\u33BD\u33BE\u33BF\u3390\u3391\u3392\u3393\u3394\u2126\u33C0\u33C1\u338A\u338B\u338C\u33D6\u33C5\u33AD\u33AE\u33AF\u33DB\u33A9\u33AA\u33AB\u33AC\u33DD\u33D0\u33D3\u33C3\u33C9\u33DC\u33C6\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[167].length; ++j)if (D[167][j].charCodeAt(0) !== 0xFFFD) {
        e[D[167][j]] = 42752 + j;
        d[42752 + j] = D[167][j];
    }
    D[168] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCB6D\uCB6E\uCB6F\uCB70\uCB71\uCB72\uCB73\uCB74\uCB75\uCB76\uCB77\uCB7A\uCB7B\uCB7C\uCB7D\uCB7E\uCB7F\uCB80\uCB81\uCB82\uCB83\uCB84\uCB85\uCB86\uCB87\uCB88\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCB89\uCB8A\uCB8B\uCB8C\uCB8D\uCB8E\uCB8F\uCB90\uCB91\uCB92\uCB93\uCB94\uCB95\uCB96\uCB97\uCB98\uCB99\uCB9A\uCB9B\uCB9D\uCB9E\uCB9F\uCBA0\uCBA1\uCBA2\uCBA3\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCBA4\uCBA5\uCBA6\uCBA7\uCBA8\uCBA9\uCBAA\uCBAB\uCBAC\uCBAD\uCBAE\uCBAF\uCBB0\uCBB1\uCBB2\uCBB3\uCBB4\uCBB5\uCBB6\uCBB7\uCBB9\uCBBA\uCBBB\uCBBC\uCBBD\uCBBE\uCBBF\uCBC0\uCBC1\uCBC2\uCBC3\uCBC4\xc6\xd0\xaa\u0126\uFFFD\u0132\uFFFD\u013F\u0141\xd8\u0152\xba\xde\u0166\u014A\uFFFD\u3260\u3261\u3262\u3263\u3264\u3265\u3266\u3267\u3268\u3269\u326A\u326B\u326C\u326D\u326E\u326F\u3270\u3271\u3272\u3273\u3274\u3275\u3276\u3277\u3278\u3279\u327A\u327B\u24D0\u24D1\u24D2\u24D3\u24D4\u24D5\u24D6\u24D7\u24D8\u24D9\u24DA\u24DB\u24DC\u24DD\u24DE\u24DF\u24E0\u24E1\u24E2\u24E3\u24E4\u24E5\u24E6\u24E7\u24E8\u24E9\u2460\u2461\u2462\u2463\u2464\u2465\u2466\u2467\u2468\u2469\u246A\u246B\u246C\u246D\u246E\xbd\u2153\u2154\xbc\xbe\u215B\u215C\u215D\u215E\uFFFD".split("");
    for(j = 0; j != D[168].length; ++j)if (D[168][j].charCodeAt(0) !== 0xFFFD) {
        e[D[168][j]] = 43008 + j;
        d[43008 + j] = D[168][j];
    }
    D[169] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCBC5\uCBC6\uCBC7\uCBC8\uCBC9\uCBCA\uCBCB\uCBCC\uCBCD\uCBCE\uCBCF\uCBD0\uCBD1\uCBD2\uCBD3\uCBD5\uCBD6\uCBD7\uCBD8\uCBD9\uCBDA\uCBDB\uCBDC\uCBDD\uCBDE\uCBDF\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCBE0\uCBE1\uCBE2\uCBE3\uCBE5\uCBE6\uCBE8\uCBEA\uCBEB\uCBEC\uCBED\uCBEE\uCBEF\uCBF0\uCBF1\uCBF2\uCBF3\uCBF4\uCBF5\uCBF6\uCBF7\uCBF8\uCBF9\uCBFA\uCBFB\uCBFC\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCBFD\uCBFE\uCBFF\uCC00\uCC01\uCC02\uCC03\uCC04\uCC05\uCC06\uCC07\uCC08\uCC09\uCC0A\uCC0B\uCC0E\uCC0F\uCC11\uCC12\uCC13\uCC15\uCC16\uCC17\uCC18\uCC19\uCC1A\uCC1B\uCC1E\uCC1F\uCC20\uCC23\uCC24\xe6\u0111\xf0\u0127\u0131\u0133\u0138\u0140\u0142\xf8\u0153\xdf\xfe\u0167\u014B\u0149\u3200\u3201\u3202\u3203\u3204\u3205\u3206\u3207\u3208\u3209\u320A\u320B\u320C\u320D\u320E\u320F\u3210\u3211\u3212\u3213\u3214\u3215\u3216\u3217\u3218\u3219\u321A\u321B\u249C\u249D\u249E\u249F\u24A0\u24A1\u24A2\u24A3\u24A4\u24A5\u24A6\u24A7\u24A8\u24A9\u24AA\u24AB\u24AC\u24AD\u24AE\u24AF\u24B0\u24B1\u24B2\u24B3\u24B4\u24B5\u2474\u2475\u2476\u2477\u2478\u2479\u247A\u247B\u247C\u247D\u247E\u247F\u2480\u2481\u2482\xb9\xb2\xb3\u2074\u207F\u2081\u2082\u2083\u2084\uFFFD".split("");
    for(j = 0; j != D[169].length; ++j)if (D[169][j].charCodeAt(0) !== 0xFFFD) {
        e[D[169][j]] = 43264 + j;
        d[43264 + j] = D[169][j];
    }
    D[170] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCC25\uCC26\uCC2A\uCC2B\uCC2D\uCC2F\uCC31\uCC32\uCC33\uCC34\uCC35\uCC36\uCC37\uCC3A\uCC3F\uCC40\uCC41\uCC42\uCC43\uCC46\uCC47\uCC49\uCC4A\uCC4B\uCC4D\uCC4E\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCC4F\uCC50\uCC51\uCC52\uCC53\uCC56\uCC5A\uCC5B\uCC5C\uCC5D\uCC5E\uCC5F\uCC61\uCC62\uCC63\uCC65\uCC67\uCC69\uCC6A\uCC6B\uCC6C\uCC6D\uCC6E\uCC6F\uCC71\uCC72\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCC73\uCC74\uCC76\uCC77\uCC78\uCC79\uCC7A\uCC7B\uCC7C\uCC7D\uCC7E\uCC7F\uCC80\uCC81\uCC82\uCC83\uCC84\uCC85\uCC86\uCC87\uCC88\uCC89\uCC8A\uCC8B\uCC8C\uCC8D\uCC8E\uCC8F\uCC90\uCC91\uCC92\uCC93\u3041\u3042\u3043\u3044\u3045\u3046\u3047\u3048\u3049\u304A\u304B\u304C\u304D\u304E\u304F\u3050\u3051\u3052\u3053\u3054\u3055\u3056\u3057\u3058\u3059\u305A\u305B\u305C\u305D\u305E\u305F\u3060\u3061\u3062\u3063\u3064\u3065\u3066\u3067\u3068\u3069\u306A\u306B\u306C\u306D\u306E\u306F\u3070\u3071\u3072\u3073\u3074\u3075\u3076\u3077\u3078\u3079\u307A\u307B\u307C\u307D\u307E\u307F\u3080\u3081\u3082\u3083\u3084\u3085\u3086\u3087\u3088\u3089\u308A\u308B\u308C\u308D\u308E\u308F\u3090\u3091\u3092\u3093\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[170].length; ++j)if (D[170][j].charCodeAt(0) !== 0xFFFD) {
        e[D[170][j]] = 43520 + j;
        d[43520 + j] = D[170][j];
    }
    D[171] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCC94\uCC95\uCC96\uCC97\uCC9A\uCC9B\uCC9D\uCC9E\uCC9F\uCCA1\uCCA2\uCCA3\uCCA4\uCCA5\uCCA6\uCCA7\uCCAA\uCCAE\uCCAF\uCCB0\uCCB1\uCCB2\uCCB3\uCCB6\uCCB7\uCCB9\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCCBA\uCCBB\uCCBD\uCCBE\uCCBF\uCCC0\uCCC1\uCCC2\uCCC3\uCCC6\uCCC8\uCCCA\uCCCB\uCCCC\uCCCD\uCCCE\uCCCF\uCCD1\uCCD2\uCCD3\uCCD5\uCCD6\uCCD7\uCCD8\uCCD9\uCCDA\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCCDB\uCCDC\uCCDD\uCCDE\uCCDF\uCCE0\uCCE1\uCCE2\uCCE3\uCCE5\uCCE6\uCCE7\uCCE8\uCCE9\uCCEA\uCCEB\uCCED\uCCEE\uCCEF\uCCF1\uCCF2\uCCF3\uCCF4\uCCF5\uCCF6\uCCF7\uCCF8\uCCF9\uCCFA\uCCFB\uCCFC\uCCFD\u30A1\u30A2\u30A3\u30A4\u30A5\u30A6\u30A7\u30A8\u30A9\u30AA\u30AB\u30AC\u30AD\u30AE\u30AF\u30B0\u30B1\u30B2\u30B3\u30B4\u30B5\u30B6\u30B7\u30B8\u30B9\u30BA\u30BB\u30BC\u30BD\u30BE\u30BF\u30C0\u30C1\u30C2\u30C3\u30C4\u30C5\u30C6\u30C7\u30C8\u30C9\u30CA\u30CB\u30CC\u30CD\u30CE\u30CF\u30D0\u30D1\u30D2\u30D3\u30D4\u30D5\u30D6\u30D7\u30D8\u30D9\u30DA\u30DB\u30DC\u30DD\u30DE\u30DF\u30E0\u30E1\u30E2\u30E3\u30E4\u30E5\u30E6\u30E7\u30E8\u30E9\u30EA\u30EB\u30EC\u30ED\u30EE\u30EF\u30F0\u30F1\u30F2\u30F3\u30F4\u30F5\u30F6\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[171].length; ++j)if (D[171][j].charCodeAt(0) !== 0xFFFD) {
        e[D[171][j]] = 43776 + j;
        d[43776 + j] = D[171][j];
    }
    D[172] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCCFE\uCCFF\uCD00\uCD02\uCD03\uCD04\uCD05\uCD06\uCD07\uCD0A\uCD0B\uCD0D\uCD0E\uCD0F\uCD11\uCD12\uCD13\uCD14\uCD15\uCD16\uCD17\uCD1A\uCD1C\uCD1E\uCD1F\uCD20\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCD21\uCD22\uCD23\uCD25\uCD26\uCD27\uCD29\uCD2A\uCD2B\uCD2D\uCD2E\uCD2F\uCD30\uCD31\uCD32\uCD33\uCD34\uCD35\uCD36\uCD37\uCD38\uCD3A\uCD3B\uCD3C\uCD3D\uCD3E\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCD3F\uCD40\uCD41\uCD42\uCD43\uCD44\uCD45\uCD46\uCD47\uCD48\uCD49\uCD4A\uCD4B\uCD4C\uCD4D\uCD4E\uCD4F\uCD50\uCD51\uCD52\uCD53\uCD54\uCD55\uCD56\uCD57\uCD58\uCD59\uCD5A\uCD5B\uCD5D\uCD5E\uCD5F\u0410\u0411\u0412\u0413\u0414\u0415\u0401\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0430\u0431\u0432\u0433\u0434\u0435\u0451\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[172].length; ++j)if (D[172][j].charCodeAt(0) !== 0xFFFD) {
        e[D[172][j]] = 44032 + j;
        d[44032 + j] = D[172][j];
    }
    D[173] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCD61\uCD62\uCD63\uCD65\uCD66\uCD67\uCD68\uCD69\uCD6A\uCD6B\uCD6E\uCD70\uCD72\uCD73\uCD74\uCD75\uCD76\uCD77\uCD79\uCD7A\uCD7B\uCD7C\uCD7D\uCD7E\uCD7F\uCD80\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCD81\uCD82\uCD83\uCD84\uCD85\uCD86\uCD87\uCD89\uCD8A\uCD8B\uCD8C\uCD8D\uCD8E\uCD8F\uCD90\uCD91\uCD92\uCD93\uCD96\uCD97\uCD99\uCD9A\uCD9B\uCD9D\uCD9E\uCD9F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCDA0\uCDA1\uCDA2\uCDA3\uCDA6\uCDA8\uCDAA\uCDAB\uCDAC\uCDAD\uCDAE\uCDAF\uCDB1\uCDB2\uCDB3\uCDB4\uCDB5\uCDB6\uCDB7\uCDB8\uCDB9\uCDBA\uCDBB\uCDBC\uCDBD\uCDBE\uCDBF\uCDC0\uCDC1\uCDC2\uCDC3\uCDC5\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[173].length; ++j)if (D[173][j].charCodeAt(0) !== 0xFFFD) {
        e[D[173][j]] = 44288 + j;
        d[44288 + j] = D[173][j];
    }
    D[174] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCDC6\uCDC7\uCDC8\uCDC9\uCDCA\uCDCB\uCDCD\uCDCE\uCDCF\uCDD1\uCDD2\uCDD3\uCDD4\uCDD5\uCDD6\uCDD7\uCDD8\uCDD9\uCDDA\uCDDB\uCDDC\uCDDD\uCDDE\uCDDF\uCDE0\uCDE1\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCDE2\uCDE3\uCDE4\uCDE5\uCDE6\uCDE7\uCDE9\uCDEA\uCDEB\uCDED\uCDEE\uCDEF\uCDF1\uCDF2\uCDF3\uCDF4\uCDF5\uCDF6\uCDF7\uCDFA\uCDFC\uCDFE\uCDFF\uCE00\uCE01\uCE02\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCE03\uCE05\uCE06\uCE07\uCE09\uCE0A\uCE0B\uCE0D\uCE0E\uCE0F\uCE10\uCE11\uCE12\uCE13\uCE15\uCE16\uCE17\uCE18\uCE1A\uCE1B\uCE1C\uCE1D\uCE1E\uCE1F\uCE22\uCE23\uCE25\uCE26\uCE27\uCE29\uCE2A\uCE2B\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[174].length; ++j)if (D[174][j].charCodeAt(0) !== 0xFFFD) {
        e[D[174][j]] = 44544 + j;
        d[44544 + j] = D[174][j];
    }
    D[175] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCE2C\uCE2D\uCE2E\uCE2F\uCE32\uCE34\uCE36\uCE37\uCE38\uCE39\uCE3A\uCE3B\uCE3C\uCE3D\uCE3E\uCE3F\uCE40\uCE41\uCE42\uCE43\uCE44\uCE45\uCE46\uCE47\uCE48\uCE49\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCE4A\uCE4B\uCE4C\uCE4D\uCE4E\uCE4F\uCE50\uCE51\uCE52\uCE53\uCE54\uCE55\uCE56\uCE57\uCE5A\uCE5B\uCE5D\uCE5E\uCE62\uCE63\uCE64\uCE65\uCE66\uCE67\uCE6A\uCE6C\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCE6E\uCE6F\uCE70\uCE71\uCE72\uCE73\uCE76\uCE77\uCE79\uCE7A\uCE7B\uCE7D\uCE7E\uCE7F\uCE80\uCE81\uCE82\uCE83\uCE86\uCE88\uCE8A\uCE8B\uCE8C\uCE8D\uCE8E\uCE8F\uCE92\uCE93\uCE95\uCE96\uCE97\uCE99\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[175].length; ++j)if (D[175][j].charCodeAt(0) !== 0xFFFD) {
        e[D[175][j]] = 44800 + j;
        d[44800 + j] = D[175][j];
    }
    D[176] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCE9A\uCE9B\uCE9C\uCE9D\uCE9E\uCE9F\uCEA2\uCEA6\uCEA7\uCEA8\uCEA9\uCEAA\uCEAB\uCEAE\uCEAF\uCEB0\uCEB1\uCEB2\uCEB3\uCEB4\uCEB5\uCEB6\uCEB7\uCEB8\uCEB9\uCEBA\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCEBB\uCEBC\uCEBD\uCEBE\uCEBF\uCEC0\uCEC2\uCEC3\uCEC4\uCEC5\uCEC6\uCEC7\uCEC8\uCEC9\uCECA\uCECB\uCECC\uCECD\uCECE\uCECF\uCED0\uCED1\uCED2\uCED3\uCED4\uCED5\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCED6\uCED7\uCED8\uCED9\uCEDA\uCEDB\uCEDC\uCEDD\uCEDE\uCEDF\uCEE0\uCEE1\uCEE2\uCEE3\uCEE6\uCEE7\uCEE9\uCEEA\uCEED\uCEEE\uCEEF\uCEF0\uCEF1\uCEF2\uCEF3\uCEF6\uCEFA\uCEFB\uCEFC\uCEFD\uCEFE\uCEFF\uAC00\uAC01\uAC04\uAC07\uAC08\uAC09\uAC0A\uAC10\uAC11\uAC12\uAC13\uAC14\uAC15\uAC16\uAC17\uAC19\uAC1A\uAC1B\uAC1C\uAC1D\uAC20\uAC24\uAC2C\uAC2D\uAC2F\uAC30\uAC31\uAC38\uAC39\uAC3C\uAC40\uAC4B\uAC4D\uAC54\uAC58\uAC5C\uAC70\uAC71\uAC74\uAC77\uAC78\uAC7A\uAC80\uAC81\uAC83\uAC84\uAC85\uAC86\uAC89\uAC8A\uAC8B\uAC8C\uAC90\uAC94\uAC9C\uAC9D\uAC9F\uACA0\uACA1\uACA8\uACA9\uACAA\uACAC\uACAF\uACB0\uACB8\uACB9\uACBB\uACBC\uACBD\uACC1\uACC4\uACC8\uACCC\uACD5\uACD7\uACE0\uACE1\uACE4\uACE7\uACE8\uACEA\uACEC\uACEF\uACF0\uACF1\uACF3\uACF5\uACF6\uACFC\uACFD\uAD00\uAD04\uAD06\uFFFD".split("");
    for(j = 0; j != D[176].length; ++j)if (D[176][j].charCodeAt(0) !== 0xFFFD) {
        e[D[176][j]] = 45056 + j;
        d[45056 + j] = D[176][j];
    }
    D[177] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCF02\uCF03\uCF05\uCF06\uCF07\uCF09\uCF0A\uCF0B\uCF0C\uCF0D\uCF0E\uCF0F\uCF12\uCF14\uCF16\uCF17\uCF18\uCF19\uCF1A\uCF1B\uCF1D\uCF1E\uCF1F\uCF21\uCF22\uCF23\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCF25\uCF26\uCF27\uCF28\uCF29\uCF2A\uCF2B\uCF2E\uCF32\uCF33\uCF34\uCF35\uCF36\uCF37\uCF39\uCF3A\uCF3B\uCF3C\uCF3D\uCF3E\uCF3F\uCF40\uCF41\uCF42\uCF43\uCF44\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCF45\uCF46\uCF47\uCF48\uCF49\uCF4A\uCF4B\uCF4C\uCF4D\uCF4E\uCF4F\uCF50\uCF51\uCF52\uCF53\uCF56\uCF57\uCF59\uCF5A\uCF5B\uCF5D\uCF5E\uCF5F\uCF60\uCF61\uCF62\uCF63\uCF66\uCF68\uCF6A\uCF6B\uCF6C\uAD0C\uAD0D\uAD0F\uAD11\uAD18\uAD1C\uAD20\uAD29\uAD2C\uAD2D\uAD34\uAD35\uAD38\uAD3C\uAD44\uAD45\uAD47\uAD49\uAD50\uAD54\uAD58\uAD61\uAD63\uAD6C\uAD6D\uAD70\uAD73\uAD74\uAD75\uAD76\uAD7B\uAD7C\uAD7D\uAD7F\uAD81\uAD82\uAD88\uAD89\uAD8C\uAD90\uAD9C\uAD9D\uADA4\uADB7\uADC0\uADC1\uADC4\uADC8\uADD0\uADD1\uADD3\uADDC\uADE0\uADE4\uADF8\uADF9\uADFC\uADFF\uAE00\uAE01\uAE08\uAE09\uAE0B\uAE0D\uAE14\uAE30\uAE31\uAE34\uAE37\uAE38\uAE3A\uAE40\uAE41\uAE43\uAE45\uAE46\uAE4A\uAE4C\uAE4D\uAE4E\uAE50\uAE54\uAE56\uAE5C\uAE5D\uAE5F\uAE60\uAE61\uAE65\uAE68\uAE69\uAE6C\uAE70\uAE78\uFFFD".split("");
    for(j = 0; j != D[177].length; ++j)if (D[177][j].charCodeAt(0) !== 0xFFFD) {
        e[D[177][j]] = 45312 + j;
        d[45312 + j] = D[177][j];
    }
    D[178] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCF6D\uCF6E\uCF6F\uCF72\uCF73\uCF75\uCF76\uCF77\uCF79\uCF7A\uCF7B\uCF7C\uCF7D\uCF7E\uCF7F\uCF81\uCF82\uCF83\uCF84\uCF86\uCF87\uCF88\uCF89\uCF8A\uCF8B\uCF8D\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCF8E\uCF8F\uCF90\uCF91\uCF92\uCF93\uCF94\uCF95\uCF96\uCF97\uCF98\uCF99\uCF9A\uCF9B\uCF9C\uCF9D\uCF9E\uCF9F\uCFA0\uCFA2\uCFA3\uCFA4\uCFA5\uCFA6\uCFA7\uCFA9\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCFAA\uCFAB\uCFAC\uCFAD\uCFAE\uCFAF\uCFB1\uCFB2\uCFB3\uCFB4\uCFB5\uCFB6\uCFB7\uCFB8\uCFB9\uCFBA\uCFBB\uCFBC\uCFBD\uCFBE\uCFBF\uCFC0\uCFC1\uCFC2\uCFC3\uCFC5\uCFC6\uCFC7\uCFC8\uCFC9\uCFCA\uCFCB\uAE79\uAE7B\uAE7C\uAE7D\uAE84\uAE85\uAE8C\uAEBC\uAEBD\uAEBE\uAEC0\uAEC4\uAECC\uAECD\uAECF\uAED0\uAED1\uAED8\uAED9\uAEDC\uAEE8\uAEEB\uAEED\uAEF4\uAEF8\uAEFC\uAF07\uAF08\uAF0D\uAF10\uAF2C\uAF2D\uAF30\uAF32\uAF34\uAF3C\uAF3D\uAF3F\uAF41\uAF42\uAF43\uAF48\uAF49\uAF50\uAF5C\uAF5D\uAF64\uAF65\uAF79\uAF80\uAF84\uAF88\uAF90\uAF91\uAF95\uAF9C\uAFB8\uAFB9\uAFBC\uAFC0\uAFC7\uAFC8\uAFC9\uAFCB\uAFCD\uAFCE\uAFD4\uAFDC\uAFE8\uAFE9\uAFF0\uAFF1\uAFF4\uAFF8\uB000\uB001\uB004\uB00C\uB010\uB014\uB01C\uB01D\uB028\uB044\uB045\uB048\uB04A\uB04C\uB04E\uB053\uB054\uB055\uB057\uB059\uFFFD".split("");
    for(j = 0; j != D[178].length; ++j)if (D[178][j].charCodeAt(0) !== 0xFFFD) {
        e[D[178][j]] = 45568 + j;
        d[45568 + j] = D[178][j];
    }
    D[179] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCFCC\uCFCD\uCFCE\uCFCF\uCFD0\uCFD1\uCFD2\uCFD3\uCFD4\uCFD5\uCFD6\uCFD7\uCFD8\uCFD9\uCFDA\uCFDB\uCFDC\uCFDD\uCFDE\uCFDF\uCFE2\uCFE3\uCFE5\uCFE6\uCFE7\uCFE9\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCFEA\uCFEB\uCFEC\uCFED\uCFEE\uCFEF\uCFF2\uCFF4\uCFF6\uCFF7\uCFF8\uCFF9\uCFFA\uCFFB\uCFFD\uCFFE\uCFFF\uD001\uD002\uD003\uD005\uD006\uD007\uD008\uD009\uD00A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD00B\uD00C\uD00D\uD00E\uD00F\uD010\uD012\uD013\uD014\uD015\uD016\uD017\uD019\uD01A\uD01B\uD01C\uD01D\uD01E\uD01F\uD020\uD021\uD022\uD023\uD024\uD025\uD026\uD027\uD028\uD029\uD02A\uD02B\uD02C\uB05D\uB07C\uB07D\uB080\uB084\uB08C\uB08D\uB08F\uB091\uB098\uB099\uB09A\uB09C\uB09F\uB0A0\uB0A1\uB0A2\uB0A8\uB0A9\uB0AB\uB0AC\uB0AD\uB0AE\uB0AF\uB0B1\uB0B3\uB0B4\uB0B5\uB0B8\uB0BC\uB0C4\uB0C5\uB0C7\uB0C8\uB0C9\uB0D0\uB0D1\uB0D4\uB0D8\uB0E0\uB0E5\uB108\uB109\uB10B\uB10C\uB110\uB112\uB113\uB118\uB119\uB11B\uB11C\uB11D\uB123\uB124\uB125\uB128\uB12C\uB134\uB135\uB137\uB138\uB139\uB140\uB141\uB144\uB148\uB150\uB151\uB154\uB155\uB158\uB15C\uB160\uB178\uB179\uB17C\uB180\uB182\uB188\uB189\uB18B\uB18D\uB192\uB193\uB194\uB198\uB19C\uB1A8\uB1CC\uB1D0\uB1D4\uB1DC\uB1DD\uFFFD".split("");
    for(j = 0; j != D[179].length; ++j)if (D[179][j].charCodeAt(0) !== 0xFFFD) {
        e[D[179][j]] = 45824 + j;
        d[45824 + j] = D[179][j];
    }
    D[180] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD02E\uD02F\uD030\uD031\uD032\uD033\uD036\uD037\uD039\uD03A\uD03B\uD03D\uD03E\uD03F\uD040\uD041\uD042\uD043\uD046\uD048\uD04A\uD04B\uD04C\uD04D\uD04E\uD04F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD051\uD052\uD053\uD055\uD056\uD057\uD059\uD05A\uD05B\uD05C\uD05D\uD05E\uD05F\uD061\uD062\uD063\uD064\uD065\uD066\uD067\uD068\uD069\uD06A\uD06B\uD06E\uD06F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD071\uD072\uD073\uD075\uD076\uD077\uD078\uD079\uD07A\uD07B\uD07E\uD07F\uD080\uD082\uD083\uD084\uD085\uD086\uD087\uD088\uD089\uD08A\uD08B\uD08C\uD08D\uD08E\uD08F\uD090\uD091\uD092\uD093\uD094\uB1DF\uB1E8\uB1E9\uB1EC\uB1F0\uB1F9\uB1FB\uB1FD\uB204\uB205\uB208\uB20B\uB20C\uB214\uB215\uB217\uB219\uB220\uB234\uB23C\uB258\uB25C\uB260\uB268\uB269\uB274\uB275\uB27C\uB284\uB285\uB289\uB290\uB291\uB294\uB298\uB299\uB29A\uB2A0\uB2A1\uB2A3\uB2A5\uB2A6\uB2AA\uB2AC\uB2B0\uB2B4\uB2C8\uB2C9\uB2CC\uB2D0\uB2D2\uB2D8\uB2D9\uB2DB\uB2DD\uB2E2\uB2E4\uB2E5\uB2E6\uB2E8\uB2EB\uB2EC\uB2ED\uB2EE\uB2EF\uB2F3\uB2F4\uB2F5\uB2F7\uB2F8\uB2F9\uB2FA\uB2FB\uB2FF\uB300\uB301\uB304\uB308\uB310\uB311\uB313\uB314\uB315\uB31C\uB354\uB355\uB356\uB358\uB35B\uB35C\uB35E\uB35F\uB364\uB365\uFFFD".split("");
    for(j = 0; j != D[180].length; ++j)if (D[180][j].charCodeAt(0) !== 0xFFFD) {
        e[D[180][j]] = 46080 + j;
        d[46080 + j] = D[180][j];
    }
    D[181] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD095\uD096\uD097\uD098\uD099\uD09A\uD09B\uD09C\uD09D\uD09E\uD09F\uD0A0\uD0A1\uD0A2\uD0A3\uD0A6\uD0A7\uD0A9\uD0AA\uD0AB\uD0AD\uD0AE\uD0AF\uD0B0\uD0B1\uD0B2\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD0B3\uD0B6\uD0B8\uD0BA\uD0BB\uD0BC\uD0BD\uD0BE\uD0BF\uD0C2\uD0C3\uD0C5\uD0C6\uD0C7\uD0CA\uD0CB\uD0CC\uD0CD\uD0CE\uD0CF\uD0D2\uD0D6\uD0D7\uD0D8\uD0D9\uD0DA\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD0DB\uD0DE\uD0DF\uD0E1\uD0E2\uD0E3\uD0E5\uD0E6\uD0E7\uD0E8\uD0E9\uD0EA\uD0EB\uD0EE\uD0F2\uD0F3\uD0F4\uD0F5\uD0F6\uD0F7\uD0F9\uD0FA\uD0FB\uD0FC\uD0FD\uD0FE\uD0FF\uD100\uD101\uD102\uD103\uD104\uB367\uB369\uB36B\uB36E\uB370\uB371\uB374\uB378\uB380\uB381\uB383\uB384\uB385\uB38C\uB390\uB394\uB3A0\uB3A1\uB3A8\uB3AC\uB3C4\uB3C5\uB3C8\uB3CB\uB3CC\uB3CE\uB3D0\uB3D4\uB3D5\uB3D7\uB3D9\uB3DB\uB3DD\uB3E0\uB3E4\uB3E8\uB3FC\uB410\uB418\uB41C\uB420\uB428\uB429\uB42B\uB434\uB450\uB451\uB454\uB458\uB460\uB461\uB463\uB465\uB46C\uB480\uB488\uB49D\uB4A4\uB4A8\uB4AC\uB4B5\uB4B7\uB4B9\uB4C0\uB4C4\uB4C8\uB4D0\uB4D5\uB4DC\uB4DD\uB4E0\uB4E3\uB4E4\uB4E6\uB4EC\uB4ED\uB4EF\uB4F1\uB4F8\uB514\uB515\uB518\uB51B\uB51C\uB524\uB525\uB527\uB528\uB529\uB52A\uB530\uB531\uB534\uB538\uFFFD".split("");
    for(j = 0; j != D[181].length; ++j)if (D[181][j].charCodeAt(0) !== 0xFFFD) {
        e[D[181][j]] = 46336 + j;
        d[46336 + j] = D[181][j];
    }
    D[182] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD105\uD106\uD107\uD108\uD109\uD10A\uD10B\uD10C\uD10E\uD10F\uD110\uD111\uD112\uD113\uD114\uD115\uD116\uD117\uD118\uD119\uD11A\uD11B\uD11C\uD11D\uD11E\uD11F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD120\uD121\uD122\uD123\uD124\uD125\uD126\uD127\uD128\uD129\uD12A\uD12B\uD12C\uD12D\uD12E\uD12F\uD132\uD133\uD135\uD136\uD137\uD139\uD13B\uD13C\uD13D\uD13E\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD13F\uD142\uD146\uD147\uD148\uD149\uD14A\uD14B\uD14E\uD14F\uD151\uD152\uD153\uD155\uD156\uD157\uD158\uD159\uD15A\uD15B\uD15E\uD160\uD162\uD163\uD164\uD165\uD166\uD167\uD169\uD16A\uD16B\uD16D\uB540\uB541\uB543\uB544\uB545\uB54B\uB54C\uB54D\uB550\uB554\uB55C\uB55D\uB55F\uB560\uB561\uB5A0\uB5A1\uB5A4\uB5A8\uB5AA\uB5AB\uB5B0\uB5B1\uB5B3\uB5B4\uB5B5\uB5BB\uB5BC\uB5BD\uB5C0\uB5C4\uB5CC\uB5CD\uB5CF\uB5D0\uB5D1\uB5D8\uB5EC\uB610\uB611\uB614\uB618\uB625\uB62C\uB634\uB648\uB664\uB668\uB69C\uB69D\uB6A0\uB6A4\uB6AB\uB6AC\uB6B1\uB6D4\uB6F0\uB6F4\uB6F8\uB700\uB701\uB705\uB728\uB729\uB72C\uB72F\uB730\uB738\uB739\uB73B\uB744\uB748\uB74C\uB754\uB755\uB760\uB764\uB768\uB770\uB771\uB773\uB775\uB77C\uB77D\uB780\uB784\uB78C\uB78D\uB78F\uB790\uB791\uB792\uB796\uB797\uFFFD".split("");
    for(j = 0; j != D[182].length; ++j)if (D[182][j].charCodeAt(0) !== 0xFFFD) {
        e[D[182][j]] = 46592 + j;
        d[46592 + j] = D[182][j];
    }
    D[183] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD16E\uD16F\uD170\uD171\uD172\uD173\uD174\uD175\uD176\uD177\uD178\uD179\uD17A\uD17B\uD17D\uD17E\uD17F\uD180\uD181\uD182\uD183\uD185\uD186\uD187\uD189\uD18A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD18B\uD18C\uD18D\uD18E\uD18F\uD190\uD191\uD192\uD193\uD194\uD195\uD196\uD197\uD198\uD199\uD19A\uD19B\uD19C\uD19D\uD19E\uD19F\uD1A2\uD1A3\uD1A5\uD1A6\uD1A7\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD1A9\uD1AA\uD1AB\uD1AC\uD1AD\uD1AE\uD1AF\uD1B2\uD1B4\uD1B6\uD1B7\uD1B8\uD1B9\uD1BB\uD1BD\uD1BE\uD1BF\uD1C1\uD1C2\uD1C3\uD1C4\uD1C5\uD1C6\uD1C7\uD1C8\uD1C9\uD1CA\uD1CB\uD1CC\uD1CD\uD1CE\uD1CF\uB798\uB799\uB79C\uB7A0\uB7A8\uB7A9\uB7AB\uB7AC\uB7AD\uB7B4\uB7B5\uB7B8\uB7C7\uB7C9\uB7EC\uB7ED\uB7F0\uB7F4\uB7FC\uB7FD\uB7FF\uB800\uB801\uB807\uB808\uB809\uB80C\uB810\uB818\uB819\uB81B\uB81D\uB824\uB825\uB828\uB82C\uB834\uB835\uB837\uB838\uB839\uB840\uB844\uB851\uB853\uB85C\uB85D\uB860\uB864\uB86C\uB86D\uB86F\uB871\uB878\uB87C\uB88D\uB8A8\uB8B0\uB8B4\uB8B8\uB8C0\uB8C1\uB8C3\uB8C5\uB8CC\uB8D0\uB8D4\uB8DD\uB8DF\uB8E1\uB8E8\uB8E9\uB8EC\uB8F0\uB8F8\uB8F9\uB8FB\uB8FD\uB904\uB918\uB920\uB93C\uB93D\uB940\uB944\uB94C\uB94F\uB951\uB958\uB959\uB95C\uB960\uB968\uB969\uFFFD".split("");
    for(j = 0; j != D[183].length; ++j)if (D[183][j].charCodeAt(0) !== 0xFFFD) {
        e[D[183][j]] = 46848 + j;
        d[46848 + j] = D[183][j];
    }
    D[184] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD1D0\uD1D1\uD1D2\uD1D3\uD1D4\uD1D5\uD1D6\uD1D7\uD1D9\uD1DA\uD1DB\uD1DC\uD1DD\uD1DE\uD1DF\uD1E0\uD1E1\uD1E2\uD1E3\uD1E4\uD1E5\uD1E6\uD1E7\uD1E8\uD1E9\uD1EA\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD1EB\uD1EC\uD1ED\uD1EE\uD1EF\uD1F0\uD1F1\uD1F2\uD1F3\uD1F5\uD1F6\uD1F7\uD1F9\uD1FA\uD1FB\uD1FC\uD1FD\uD1FE\uD1FF\uD200\uD201\uD202\uD203\uD204\uD205\uD206\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD208\uD20A\uD20B\uD20C\uD20D\uD20E\uD20F\uD211\uD212\uD213\uD214\uD215\uD216\uD217\uD218\uD219\uD21A\uD21B\uD21C\uD21D\uD21E\uD21F\uD220\uD221\uD222\uD223\uD224\uD225\uD226\uD227\uD228\uD229\uB96B\uB96D\uB974\uB975\uB978\uB97C\uB984\uB985\uB987\uB989\uB98A\uB98D\uB98E\uB9AC\uB9AD\uB9B0\uB9B4\uB9BC\uB9BD\uB9BF\uB9C1\uB9C8\uB9C9\uB9CC\uB9CE\uB9CF\uB9D0\uB9D1\uB9D2\uB9D8\uB9D9\uB9DB\uB9DD\uB9DE\uB9E1\uB9E3\uB9E4\uB9E5\uB9E8\uB9EC\uB9F4\uB9F5\uB9F7\uB9F8\uB9F9\uB9FA\uBA00\uBA01\uBA08\uBA15\uBA38\uBA39\uBA3C\uBA40\uBA42\uBA48\uBA49\uBA4B\uBA4D\uBA4E\uBA53\uBA54\uBA55\uBA58\uBA5C\uBA64\uBA65\uBA67\uBA68\uBA69\uBA70\uBA71\uBA74\uBA78\uBA83\uBA84\uBA85\uBA87\uBA8C\uBAA8\uBAA9\uBAAB\uBAAC\uBAB0\uBAB2\uBAB8\uBAB9\uBABB\uBABD\uBAC4\uBAC8\uBAD8\uBAD9\uBAFC\uFFFD".split("");
    for(j = 0; j != D[184].length; ++j)if (D[184][j].charCodeAt(0) !== 0xFFFD) {
        e[D[184][j]] = 47104 + j;
        d[47104 + j] = D[184][j];
    }
    D[185] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD22A\uD22B\uD22E\uD22F\uD231\uD232\uD233\uD235\uD236\uD237\uD238\uD239\uD23A\uD23B\uD23E\uD240\uD242\uD243\uD244\uD245\uD246\uD247\uD249\uD24A\uD24B\uD24C\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD24D\uD24E\uD24F\uD250\uD251\uD252\uD253\uD254\uD255\uD256\uD257\uD258\uD259\uD25A\uD25B\uD25D\uD25E\uD25F\uD260\uD261\uD262\uD263\uD265\uD266\uD267\uD268\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD269\uD26A\uD26B\uD26C\uD26D\uD26E\uD26F\uD270\uD271\uD272\uD273\uD274\uD275\uD276\uD277\uD278\uD279\uD27A\uD27B\uD27C\uD27D\uD27E\uD27F\uD282\uD283\uD285\uD286\uD287\uD289\uD28A\uD28B\uD28C\uBB00\uBB04\uBB0D\uBB0F\uBB11\uBB18\uBB1C\uBB20\uBB29\uBB2B\uBB34\uBB35\uBB36\uBB38\uBB3B\uBB3C\uBB3D\uBB3E\uBB44\uBB45\uBB47\uBB49\uBB4D\uBB4F\uBB50\uBB54\uBB58\uBB61\uBB63\uBB6C\uBB88\uBB8C\uBB90\uBBA4\uBBA8\uBBAC\uBBB4\uBBB7\uBBC0\uBBC4\uBBC8\uBBD0\uBBD3\uBBF8\uBBF9\uBBFC\uBBFF\uBC00\uBC02\uBC08\uBC09\uBC0B\uBC0C\uBC0D\uBC0F\uBC11\uBC14\uBC15\uBC16\uBC17\uBC18\uBC1B\uBC1C\uBC1D\uBC1E\uBC1F\uBC24\uBC25\uBC27\uBC29\uBC2D\uBC30\uBC31\uBC34\uBC38\uBC40\uBC41\uBC43\uBC44\uBC45\uBC49\uBC4C\uBC4D\uBC50\uBC5D\uBC84\uBC85\uBC88\uBC8B\uBC8C\uBC8E\uBC94\uBC95\uBC97\uFFFD".split("");
    for(j = 0; j != D[185].length; ++j)if (D[185][j].charCodeAt(0) !== 0xFFFD) {
        e[D[185][j]] = 47360 + j;
        d[47360 + j] = D[185][j];
    }
    D[186] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD28D\uD28E\uD28F\uD292\uD293\uD294\uD296\uD297\uD298\uD299\uD29A\uD29B\uD29D\uD29E\uD29F\uD2A1\uD2A2\uD2A3\uD2A5\uD2A6\uD2A7\uD2A8\uD2A9\uD2AA\uD2AB\uD2AD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD2AE\uD2AF\uD2B0\uD2B2\uD2B3\uD2B4\uD2B5\uD2B6\uD2B7\uD2BA\uD2BB\uD2BD\uD2BE\uD2C1\uD2C3\uD2C4\uD2C5\uD2C6\uD2C7\uD2CA\uD2CC\uD2CD\uD2CE\uD2CF\uD2D0\uD2D1\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD2D2\uD2D3\uD2D5\uD2D6\uD2D7\uD2D9\uD2DA\uD2DB\uD2DD\uD2DE\uD2DF\uD2E0\uD2E1\uD2E2\uD2E3\uD2E6\uD2E7\uD2E8\uD2E9\uD2EA\uD2EB\uD2EC\uD2ED\uD2EE\uD2EF\uD2F2\uD2F3\uD2F5\uD2F6\uD2F7\uD2F9\uD2FA\uBC99\uBC9A\uBCA0\uBCA1\uBCA4\uBCA7\uBCA8\uBCB0\uBCB1\uBCB3\uBCB4\uBCB5\uBCBC\uBCBD\uBCC0\uBCC4\uBCCD\uBCCF\uBCD0\uBCD1\uBCD5\uBCD8\uBCDC\uBCF4\uBCF5\uBCF6\uBCF8\uBCFC\uBD04\uBD05\uBD07\uBD09\uBD10\uBD14\uBD24\uBD2C\uBD40\uBD48\uBD49\uBD4C\uBD50\uBD58\uBD59\uBD64\uBD68\uBD80\uBD81\uBD84\uBD87\uBD88\uBD89\uBD8A\uBD90\uBD91\uBD93\uBD95\uBD99\uBD9A\uBD9C\uBDA4\uBDB0\uBDB8\uBDD4\uBDD5\uBDD8\uBDDC\uBDE9\uBDF0\uBDF4\uBDF8\uBE00\uBE03\uBE05\uBE0C\uBE0D\uBE10\uBE14\uBE1C\uBE1D\uBE1F\uBE44\uBE45\uBE48\uBE4C\uBE4E\uBE54\uBE55\uBE57\uBE59\uBE5A\uBE5B\uBE60\uBE61\uBE64\uFFFD".split("");
    for(j = 0; j != D[186].length; ++j)if (D[186][j].charCodeAt(0) !== 0xFFFD) {
        e[D[186][j]] = 47616 + j;
        d[47616 + j] = D[186][j];
    }
    D[187] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD2FB\uD2FC\uD2FD\uD2FE\uD2FF\uD302\uD304\uD306\uD307\uD308\uD309\uD30A\uD30B\uD30F\uD311\uD312\uD313\uD315\uD317\uD318\uD319\uD31A\uD31B\uD31E\uD322\uD323\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD324\uD326\uD327\uD32A\uD32B\uD32D\uD32E\uD32F\uD331\uD332\uD333\uD334\uD335\uD336\uD337\uD33A\uD33E\uD33F\uD340\uD341\uD342\uD343\uD346\uD347\uD348\uD349\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD34A\uD34B\uD34C\uD34D\uD34E\uD34F\uD350\uD351\uD352\uD353\uD354\uD355\uD356\uD357\uD358\uD359\uD35A\uD35B\uD35C\uD35D\uD35E\uD35F\uD360\uD361\uD362\uD363\uD364\uD365\uD366\uD367\uD368\uD369\uBE68\uBE6A\uBE70\uBE71\uBE73\uBE74\uBE75\uBE7B\uBE7C\uBE7D\uBE80\uBE84\uBE8C\uBE8D\uBE8F\uBE90\uBE91\uBE98\uBE99\uBEA8\uBED0\uBED1\uBED4\uBED7\uBED8\uBEE0\uBEE3\uBEE4\uBEE5\uBEEC\uBF01\uBF08\uBF09\uBF18\uBF19\uBF1B\uBF1C\uBF1D\uBF40\uBF41\uBF44\uBF48\uBF50\uBF51\uBF55\uBF94\uBFB0\uBFC5\uBFCC\uBFCD\uBFD0\uBFD4\uBFDC\uBFDF\uBFE1\uC03C\uC051\uC058\uC05C\uC060\uC068\uC069\uC090\uC091\uC094\uC098\uC0A0\uC0A1\uC0A3\uC0A5\uC0AC\uC0AD\uC0AF\uC0B0\uC0B3\uC0B4\uC0B5\uC0B6\uC0BC\uC0BD\uC0BF\uC0C0\uC0C1\uC0C5\uC0C8\uC0C9\uC0CC\uC0D0\uC0D8\uC0D9\uC0DB\uC0DC\uC0DD\uC0E4\uFFFD".split("");
    for(j = 0; j != D[187].length; ++j)if (D[187][j].charCodeAt(0) !== 0xFFFD) {
        e[D[187][j]] = 47872 + j;
        d[47872 + j] = D[187][j];
    }
    D[188] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD36A\uD36B\uD36C\uD36D\uD36E\uD36F\uD370\uD371\uD372\uD373\uD374\uD375\uD376\uD377\uD378\uD379\uD37A\uD37B\uD37E\uD37F\uD381\uD382\uD383\uD385\uD386\uD387\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD388\uD389\uD38A\uD38B\uD38E\uD392\uD393\uD394\uD395\uD396\uD397\uD39A\uD39B\uD39D\uD39E\uD39F\uD3A1\uD3A2\uD3A3\uD3A4\uD3A5\uD3A6\uD3A7\uD3AA\uD3AC\uD3AE\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD3AF\uD3B0\uD3B1\uD3B2\uD3B3\uD3B5\uD3B6\uD3B7\uD3B9\uD3BA\uD3BB\uD3BD\uD3BE\uD3BF\uD3C0\uD3C1\uD3C2\uD3C3\uD3C6\uD3C7\uD3CA\uD3CB\uD3CC\uD3CD\uD3CE\uD3CF\uD3D1\uD3D2\uD3D3\uD3D4\uD3D5\uD3D6\uC0E5\uC0E8\uC0EC\uC0F4\uC0F5\uC0F7\uC0F9\uC100\uC104\uC108\uC110\uC115\uC11C\uC11D\uC11E\uC11F\uC120\uC123\uC124\uC126\uC127\uC12C\uC12D\uC12F\uC130\uC131\uC136\uC138\uC139\uC13C\uC140\uC148\uC149\uC14B\uC14C\uC14D\uC154\uC155\uC158\uC15C\uC164\uC165\uC167\uC168\uC169\uC170\uC174\uC178\uC185\uC18C\uC18D\uC18E\uC190\uC194\uC196\uC19C\uC19D\uC19F\uC1A1\uC1A5\uC1A8\uC1A9\uC1AC\uC1B0\uC1BD\uC1C4\uC1C8\uC1CC\uC1D4\uC1D7\uC1D8\uC1E0\uC1E4\uC1E8\uC1F0\uC1F1\uC1F3\uC1FC\uC1FD\uC200\uC204\uC20C\uC20D\uC20F\uC211\uC218\uC219\uC21C\uC21F\uC220\uC228\uC229\uC22B\uC22D\uFFFD".split("");
    for(j = 0; j != D[188].length; ++j)if (D[188][j].charCodeAt(0) !== 0xFFFD) {
        e[D[188][j]] = 48128 + j;
        d[48128 + j] = D[188][j];
    }
    D[189] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD3D7\uD3D9\uD3DA\uD3DB\uD3DC\uD3DD\uD3DE\uD3DF\uD3E0\uD3E2\uD3E4\uD3E5\uD3E6\uD3E7\uD3E8\uD3E9\uD3EA\uD3EB\uD3EE\uD3EF\uD3F1\uD3F2\uD3F3\uD3F5\uD3F6\uD3F7\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD3F8\uD3F9\uD3FA\uD3FB\uD3FE\uD400\uD402\uD403\uD404\uD405\uD406\uD407\uD409\uD40A\uD40B\uD40C\uD40D\uD40E\uD40F\uD410\uD411\uD412\uD413\uD414\uD415\uD416\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD417\uD418\uD419\uD41A\uD41B\uD41C\uD41E\uD41F\uD420\uD421\uD422\uD423\uD424\uD425\uD426\uD427\uD428\uD429\uD42A\uD42B\uD42C\uD42D\uD42E\uD42F\uD430\uD431\uD432\uD433\uD434\uD435\uD436\uD437\uC22F\uC231\uC232\uC234\uC248\uC250\uC251\uC254\uC258\uC260\uC265\uC26C\uC26D\uC270\uC274\uC27C\uC27D\uC27F\uC281\uC288\uC289\uC290\uC298\uC29B\uC29D\uC2A4\uC2A5\uC2A8\uC2AC\uC2AD\uC2B4\uC2B5\uC2B7\uC2B9\uC2DC\uC2DD\uC2E0\uC2E3\uC2E4\uC2EB\uC2EC\uC2ED\uC2EF\uC2F1\uC2F6\uC2F8\uC2F9\uC2FB\uC2FC\uC300\uC308\uC309\uC30C\uC30D\uC313\uC314\uC315\uC318\uC31C\uC324\uC325\uC328\uC329\uC345\uC368\uC369\uC36C\uC370\uC372\uC378\uC379\uC37C\uC37D\uC384\uC388\uC38C\uC3C0\uC3D8\uC3D9\uC3DC\uC3DF\uC3E0\uC3E2\uC3E8\uC3E9\uC3ED\uC3F4\uC3F5\uC3F8\uC408\uC410\uC424\uC42C\uC430\uFFFD".split("");
    for(j = 0; j != D[189].length; ++j)if (D[189][j].charCodeAt(0) !== 0xFFFD) {
        e[D[189][j]] = 48384 + j;
        d[48384 + j] = D[189][j];
    }
    D[190] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD438\uD439\uD43A\uD43B\uD43C\uD43D\uD43E\uD43F\uD441\uD442\uD443\uD445\uD446\uD447\uD448\uD449\uD44A\uD44B\uD44C\uD44D\uD44E\uD44F\uD450\uD451\uD452\uD453\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD454\uD455\uD456\uD457\uD458\uD459\uD45A\uD45B\uD45D\uD45E\uD45F\uD461\uD462\uD463\uD465\uD466\uD467\uD468\uD469\uD46A\uD46B\uD46C\uD46E\uD470\uD471\uD472\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD473\uD474\uD475\uD476\uD477\uD47A\uD47B\uD47D\uD47E\uD481\uD483\uD484\uD485\uD486\uD487\uD48A\uD48C\uD48E\uD48F\uD490\uD491\uD492\uD493\uD495\uD496\uD497\uD498\uD499\uD49A\uD49B\uD49C\uD49D\uC434\uC43C\uC43D\uC448\uC464\uC465\uC468\uC46C\uC474\uC475\uC479\uC480\uC494\uC49C\uC4B8\uC4BC\uC4E9\uC4F0\uC4F1\uC4F4\uC4F8\uC4FA\uC4FF\uC500\uC501\uC50C\uC510\uC514\uC51C\uC528\uC529\uC52C\uC530\uC538\uC539\uC53B\uC53D\uC544\uC545\uC548\uC549\uC54A\uC54C\uC54D\uC54E\uC553\uC554\uC555\uC557\uC558\uC559\uC55D\uC55E\uC560\uC561\uC564\uC568\uC570\uC571\uC573\uC574\uC575\uC57C\uC57D\uC580\uC584\uC587\uC58C\uC58D\uC58F\uC591\uC595\uC597\uC598\uC59C\uC5A0\uC5A9\uC5B4\uC5B5\uC5B8\uC5B9\uC5BB\uC5BC\uC5BD\uC5BE\uC5C4\uC5C5\uC5C6\uC5C7\uC5C8\uC5C9\uC5CA\uC5CC\uC5CE\uFFFD".split("");
    for(j = 0; j != D[190].length; ++j)if (D[190][j].charCodeAt(0) !== 0xFFFD) {
        e[D[190][j]] = 48640 + j;
        d[48640 + j] = D[190][j];
    }
    D[191] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD49E\uD49F\uD4A0\uD4A1\uD4A2\uD4A3\uD4A4\uD4A5\uD4A6\uD4A7\uD4A8\uD4AA\uD4AB\uD4AC\uD4AD\uD4AE\uD4AF\uD4B0\uD4B1\uD4B2\uD4B3\uD4B4\uD4B5\uD4B6\uD4B7\uD4B8\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD4B9\uD4BA\uD4BB\uD4BC\uD4BD\uD4BE\uD4BF\uD4C0\uD4C1\uD4C2\uD4C3\uD4C4\uD4C5\uD4C6\uD4C7\uD4C8\uD4C9\uD4CA\uD4CB\uD4CD\uD4CE\uD4CF\uD4D1\uD4D2\uD4D3\uD4D5\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD4D6\uD4D7\uD4D8\uD4D9\uD4DA\uD4DB\uD4DD\uD4DE\uD4E0\uD4E1\uD4E2\uD4E3\uD4E4\uD4E5\uD4E6\uD4E7\uD4E9\uD4EA\uD4EB\uD4ED\uD4EE\uD4EF\uD4F1\uD4F2\uD4F3\uD4F4\uD4F5\uD4F6\uD4F7\uD4F9\uD4FA\uD4FC\uC5D0\uC5D1\uC5D4\uC5D8\uC5E0\uC5E1\uC5E3\uC5E5\uC5EC\uC5ED\uC5EE\uC5F0\uC5F4\uC5F6\uC5F7\uC5FC\uC5FD\uC5FE\uC5FF\uC600\uC601\uC605\uC606\uC607\uC608\uC60C\uC610\uC618\uC619\uC61B\uC61C\uC624\uC625\uC628\uC62C\uC62D\uC62E\uC630\uC633\uC634\uC635\uC637\uC639\uC63B\uC640\uC641\uC644\uC648\uC650\uC651\uC653\uC654\uC655\uC65C\uC65D\uC660\uC66C\uC66F\uC671\uC678\uC679\uC67C\uC680\uC688\uC689\uC68B\uC68D\uC694\uC695\uC698\uC69C\uC6A4\uC6A5\uC6A7\uC6A9\uC6B0\uC6B1\uC6B4\uC6B8\uC6B9\uC6BA\uC6C0\uC6C1\uC6C3\uC6C5\uC6CC\uC6CD\uC6D0\uC6D4\uC6DC\uC6DD\uC6E0\uC6E1\uC6E8\uFFFD".split("");
    for(j = 0; j != D[191].length; ++j)if (D[191][j].charCodeAt(0) !== 0xFFFD) {
        e[D[191][j]] = 48896 + j;
        d[48896 + j] = D[191][j];
    }
    D[192] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD4FE\uD4FF\uD500\uD501\uD502\uD503\uD505\uD506\uD507\uD509\uD50A\uD50B\uD50D\uD50E\uD50F\uD510\uD511\uD512\uD513\uD516\uD518\uD519\uD51A\uD51B\uD51C\uD51D\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD51E\uD51F\uD520\uD521\uD522\uD523\uD524\uD525\uD526\uD527\uD528\uD529\uD52A\uD52B\uD52C\uD52D\uD52E\uD52F\uD530\uD531\uD532\uD533\uD534\uD535\uD536\uD537\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD538\uD539\uD53A\uD53B\uD53E\uD53F\uD541\uD542\uD543\uD545\uD546\uD547\uD548\uD549\uD54A\uD54B\uD54E\uD550\uD552\uD553\uD554\uD555\uD556\uD557\uD55A\uD55B\uD55D\uD55E\uD55F\uD561\uD562\uD563\uC6E9\uC6EC\uC6F0\uC6F8\uC6F9\uC6FD\uC704\uC705\uC708\uC70C\uC714\uC715\uC717\uC719\uC720\uC721\uC724\uC728\uC730\uC731\uC733\uC735\uC737\uC73C\uC73D\uC740\uC744\uC74A\uC74C\uC74D\uC74F\uC751\uC752\uC753\uC754\uC755\uC756\uC757\uC758\uC75C\uC760\uC768\uC76B\uC774\uC775\uC778\uC77C\uC77D\uC77E\uC783\uC784\uC785\uC787\uC788\uC789\uC78A\uC78E\uC790\uC791\uC794\uC796\uC797\uC798\uC79A\uC7A0\uC7A1\uC7A3\uC7A4\uC7A5\uC7A6\uC7AC\uC7AD\uC7B0\uC7B4\uC7BC\uC7BD\uC7BF\uC7C0\uC7C1\uC7C8\uC7C9\uC7CC\uC7CE\uC7D0\uC7D8\uC7DD\uC7E4\uC7E8\uC7EC\uC800\uC801\uC804\uC808\uC80A\uFFFD".split("");
    for(j = 0; j != D[192].length; ++j)if (D[192][j].charCodeAt(0) !== 0xFFFD) {
        e[D[192][j]] = 49152 + j;
        d[49152 + j] = D[192][j];
    }
    D[193] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD564\uD566\uD567\uD56A\uD56C\uD56E\uD56F\uD570\uD571\uD572\uD573\uD576\uD577\uD579\uD57A\uD57B\uD57D\uD57E\uD57F\uD580\uD581\uD582\uD583\uD586\uD58A\uD58B\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD58C\uD58D\uD58E\uD58F\uD591\uD592\uD593\uD594\uD595\uD596\uD597\uD598\uD599\uD59A\uD59B\uD59C\uD59D\uD59E\uD59F\uD5A0\uD5A1\uD5A2\uD5A3\uD5A4\uD5A6\uD5A7\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD5A8\uD5A9\uD5AA\uD5AB\uD5AC\uD5AD\uD5AE\uD5AF\uD5B0\uD5B1\uD5B2\uD5B3\uD5B4\uD5B5\uD5B6\uD5B7\uD5B8\uD5B9\uD5BA\uD5BB\uD5BC\uD5BD\uD5BE\uD5BF\uD5C0\uD5C1\uD5C2\uD5C3\uD5C4\uD5C5\uD5C6\uD5C7\uC810\uC811\uC813\uC815\uC816\uC81C\uC81D\uC820\uC824\uC82C\uC82D\uC82F\uC831\uC838\uC83C\uC840\uC848\uC849\uC84C\uC84D\uC854\uC870\uC871\uC874\uC878\uC87A\uC880\uC881\uC883\uC885\uC886\uC887\uC88B\uC88C\uC88D\uC894\uC89D\uC89F\uC8A1\uC8A8\uC8BC\uC8BD\uC8C4\uC8C8\uC8CC\uC8D4\uC8D5\uC8D7\uC8D9\uC8E0\uC8E1\uC8E4\uC8F5\uC8FC\uC8FD\uC900\uC904\uC905\uC906\uC90C\uC90D\uC90F\uC911\uC918\uC92C\uC934\uC950\uC951\uC954\uC958\uC960\uC961\uC963\uC96C\uC970\uC974\uC97C\uC988\uC989\uC98C\uC990\uC998\uC999\uC99B\uC99D\uC9C0\uC9C1\uC9C4\uC9C7\uC9C8\uC9CA\uC9D0\uC9D1\uC9D3\uFFFD".split("");
    for(j = 0; j != D[193].length; ++j)if (D[193][j].charCodeAt(0) !== 0xFFFD) {
        e[D[193][j]] = 49408 + j;
        d[49408 + j] = D[193][j];
    }
    D[194] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD5CA\uD5CB\uD5CD\uD5CE\uD5CF\uD5D1\uD5D3\uD5D4\uD5D5\uD5D6\uD5D7\uD5DA\uD5DC\uD5DE\uD5DF\uD5E0\uD5E1\uD5E2\uD5E3\uD5E6\uD5E7\uD5E9\uD5EA\uD5EB\uD5ED\uD5EE\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD5EF\uD5F0\uD5F1\uD5F2\uD5F3\uD5F6\uD5F8\uD5FA\uD5FB\uD5FC\uD5FD\uD5FE\uD5FF\uD602\uD603\uD605\uD606\uD607\uD609\uD60A\uD60B\uD60C\uD60D\uD60E\uD60F\uD612\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD616\uD617\uD618\uD619\uD61A\uD61B\uD61D\uD61E\uD61F\uD621\uD622\uD623\uD625\uD626\uD627\uD628\uD629\uD62A\uD62B\uD62C\uD62E\uD62F\uD630\uD631\uD632\uD633\uD634\uD635\uD636\uD637\uD63A\uD63B\uC9D5\uC9D6\uC9D9\uC9DA\uC9DC\uC9DD\uC9E0\uC9E2\uC9E4\uC9E7\uC9EC\uC9ED\uC9EF\uC9F0\uC9F1\uC9F8\uC9F9\uC9FC\uCA00\uCA08\uCA09\uCA0B\uCA0C\uCA0D\uCA14\uCA18\uCA29\uCA4C\uCA4D\uCA50\uCA54\uCA5C\uCA5D\uCA5F\uCA60\uCA61\uCA68\uCA7D\uCA84\uCA98\uCABC\uCABD\uCAC0\uCAC4\uCACC\uCACD\uCACF\uCAD1\uCAD3\uCAD8\uCAD9\uCAE0\uCAEC\uCAF4\uCB08\uCB10\uCB14\uCB18\uCB20\uCB21\uCB41\uCB48\uCB49\uCB4C\uCB50\uCB58\uCB59\uCB5D\uCB64\uCB78\uCB79\uCB9C\uCBB8\uCBD4\uCBE4\uCBE7\uCBE9\uCC0C\uCC0D\uCC10\uCC14\uCC1C\uCC1D\uCC21\uCC22\uCC27\uCC28\uCC29\uCC2C\uCC2E\uCC30\uCC38\uCC39\uCC3B\uFFFD".split("");
    for(j = 0; j != D[194].length; ++j)if (D[194][j].charCodeAt(0) !== 0xFFFD) {
        e[D[194][j]] = 49664 + j;
        d[49664 + j] = D[194][j];
    }
    D[195] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD63D\uD63E\uD63F\uD641\uD642\uD643\uD644\uD646\uD647\uD64A\uD64C\uD64E\uD64F\uD650\uD652\uD653\uD656\uD657\uD659\uD65A\uD65B\uD65D\uD65E\uD65F\uD660\uD661\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD662\uD663\uD664\uD665\uD666\uD668\uD66A\uD66B\uD66C\uD66D\uD66E\uD66F\uD672\uD673\uD675\uD676\uD677\uD678\uD679\uD67A\uD67B\uD67C\uD67D\uD67E\uD67F\uD680\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD681\uD682\uD684\uD686\uD687\uD688\uD689\uD68A\uD68B\uD68E\uD68F\uD691\uD692\uD693\uD695\uD696\uD697\uD698\uD699\uD69A\uD69B\uD69C\uD69E\uD6A0\uD6A2\uD6A3\uD6A4\uD6A5\uD6A6\uD6A7\uD6A9\uD6AA\uCC3C\uCC3D\uCC3E\uCC44\uCC45\uCC48\uCC4C\uCC54\uCC55\uCC57\uCC58\uCC59\uCC60\uCC64\uCC66\uCC68\uCC70\uCC75\uCC98\uCC99\uCC9C\uCCA0\uCCA8\uCCA9\uCCAB\uCCAC\uCCAD\uCCB4\uCCB5\uCCB8\uCCBC\uCCC4\uCCC5\uCCC7\uCCC9\uCCD0\uCCD4\uCCE4\uCCEC\uCCF0\uCD01\uCD08\uCD09\uCD0C\uCD10\uCD18\uCD19\uCD1B\uCD1D\uCD24\uCD28\uCD2C\uCD39\uCD5C\uCD60\uCD64\uCD6C\uCD6D\uCD6F\uCD71\uCD78\uCD88\uCD94\uCD95\uCD98\uCD9C\uCDA4\uCDA5\uCDA7\uCDA9\uCDB0\uCDC4\uCDCC\uCDD0\uCDE8\uCDEC\uCDF0\uCDF8\uCDF9\uCDFB\uCDFD\uCE04\uCE08\uCE0C\uCE14\uCE19\uCE20\uCE21\uCE24\uCE28\uCE30\uCE31\uCE33\uCE35\uFFFD".split("");
    for(j = 0; j != D[195].length; ++j)if (D[195][j].charCodeAt(0) !== 0xFFFD) {
        e[D[195][j]] = 49920 + j;
        d[49920 + j] = D[195][j];
    }
    D[196] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD6AB\uD6AD\uD6AE\uD6AF\uD6B1\uD6B2\uD6B3\uD6B4\uD6B5\uD6B6\uD6B7\uD6B8\uD6BA\uD6BC\uD6BD\uD6BE\uD6BF\uD6C0\uD6C1\uD6C2\uD6C3\uD6C6\uD6C7\uD6C9\uD6CA\uD6CB\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD6CD\uD6CE\uD6CF\uD6D0\uD6D2\uD6D3\uD6D5\uD6D6\uD6D8\uD6DA\uD6DB\uD6DC\uD6DD\uD6DE\uD6DF\uD6E1\uD6E2\uD6E3\uD6E5\uD6E6\uD6E7\uD6E9\uD6EA\uD6EB\uD6EC\uD6ED\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD6EE\uD6EF\uD6F1\uD6F2\uD6F3\uD6F4\uD6F6\uD6F7\uD6F8\uD6F9\uD6FA\uD6FB\uD6FE\uD6FF\uD701\uD702\uD703\uD705\uD706\uD707\uD708\uD709\uD70A\uD70B\uD70C\uD70D\uD70E\uD70F\uD710\uD712\uD713\uD714\uCE58\uCE59\uCE5C\uCE5F\uCE60\uCE61\uCE68\uCE69\uCE6B\uCE6D\uCE74\uCE75\uCE78\uCE7C\uCE84\uCE85\uCE87\uCE89\uCE90\uCE91\uCE94\uCE98\uCEA0\uCEA1\uCEA3\uCEA4\uCEA5\uCEAC\uCEAD\uCEC1\uCEE4\uCEE5\uCEE8\uCEEB\uCEEC\uCEF4\uCEF5\uCEF7\uCEF8\uCEF9\uCF00\uCF01\uCF04\uCF08\uCF10\uCF11\uCF13\uCF15\uCF1C\uCF20\uCF24\uCF2C\uCF2D\uCF2F\uCF30\uCF31\uCF38\uCF54\uCF55\uCF58\uCF5C\uCF64\uCF65\uCF67\uCF69\uCF70\uCF71\uCF74\uCF78\uCF80\uCF85\uCF8C\uCFA1\uCFA8\uCFB0\uCFC4\uCFE0\uCFE1\uCFE4\uCFE8\uCFF0\uCFF1\uCFF3\uCFF5\uCFFC\uD000\uD004\uD011\uD018\uD02D\uD034\uD035\uD038\uD03C\uFFFD".split("");
    for(j = 0; j != D[196].length; ++j)if (D[196][j].charCodeAt(0) !== 0xFFFD) {
        e[D[196][j]] = 50176 + j;
        d[50176 + j] = D[196][j];
    }
    D[197] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD715\uD716\uD717\uD71A\uD71B\uD71D\uD71E\uD71F\uD721\uD722\uD723\uD724\uD725\uD726\uD727\uD72A\uD72C\uD72E\uD72F\uD730\uD731\uD732\uD733\uD736\uD737\uD739\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD73A\uD73B\uD73D\uD73E\uD73F\uD740\uD741\uD742\uD743\uD745\uD746\uD748\uD74A\uD74B\uD74C\uD74D\uD74E\uD74F\uD752\uD753\uD755\uD75A\uD75B\uD75C\uD75D\uD75E\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD75F\uD762\uD764\uD766\uD767\uD768\uD76A\uD76B\uD76D\uD76E\uD76F\uD771\uD772\uD773\uD775\uD776\uD777\uD778\uD779\uD77A\uD77B\uD77E\uD77F\uD780\uD782\uD783\uD784\uD785\uD786\uD787\uD78A\uD78B\uD044\uD045\uD047\uD049\uD050\uD054\uD058\uD060\uD06C\uD06D\uD070\uD074\uD07C\uD07D\uD081\uD0A4\uD0A5\uD0A8\uD0AC\uD0B4\uD0B5\uD0B7\uD0B9\uD0C0\uD0C1\uD0C4\uD0C8\uD0C9\uD0D0\uD0D1\uD0D3\uD0D4\uD0D5\uD0DC\uD0DD\uD0E0\uD0E4\uD0EC\uD0ED\uD0EF\uD0F0\uD0F1\uD0F8\uD10D\uD130\uD131\uD134\uD138\uD13A\uD140\uD141\uD143\uD144\uD145\uD14C\uD14D\uD150\uD154\uD15C\uD15D\uD15F\uD161\uD168\uD16C\uD17C\uD184\uD188\uD1A0\uD1A1\uD1A4\uD1A8\uD1B0\uD1B1\uD1B3\uD1B5\uD1BA\uD1BC\uD1C0\uD1D8\uD1F4\uD1F8\uD207\uD209\uD210\uD22C\uD22D\uD230\uD234\uD23C\uD23D\uD23F\uD241\uD248\uD25C\uFFFD".split("");
    for(j = 0; j != D[197].length; ++j)if (D[197][j].charCodeAt(0) !== 0xFFFD) {
        e[D[197][j]] = 50432 + j;
        d[50432 + j] = D[197][j];
    }
    D[198] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD78D\uD78E\uD78F\uD791\uD792\uD793\uD794\uD795\uD796\uD797\uD79A\uD79C\uD79E\uD79F\uD7A0\uD7A1\uD7A2\uD7A3\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD264\uD280\uD281\uD284\uD288\uD290\uD291\uD295\uD29C\uD2A0\uD2A4\uD2AC\uD2B1\uD2B8\uD2B9\uD2BC\uD2BF\uD2C0\uD2C2\uD2C8\uD2C9\uD2CB\uD2D4\uD2D8\uD2DC\uD2E4\uD2E5\uD2F0\uD2F1\uD2F4\uD2F8\uD300\uD301\uD303\uD305\uD30C\uD30D\uD30E\uD310\uD314\uD316\uD31C\uD31D\uD31F\uD320\uD321\uD325\uD328\uD329\uD32C\uD330\uD338\uD339\uD33B\uD33C\uD33D\uD344\uD345\uD37C\uD37D\uD380\uD384\uD38C\uD38D\uD38F\uD390\uD391\uD398\uD399\uD39C\uD3A0\uD3A8\uD3A9\uD3AB\uD3AD\uD3B4\uD3B8\uD3BC\uD3C4\uD3C5\uD3C8\uD3C9\uD3D0\uD3D8\uD3E1\uD3E3\uD3EC\uD3ED\uD3F0\uD3F4\uD3FC\uD3FD\uD3FF\uD401\uFFFD".split("");
    for(j = 0; j != D[198].length; ++j)if (D[198][j].charCodeAt(0) !== 0xFFFD) {
        e[D[198][j]] = 50688 + j;
        d[50688 + j] = D[198][j];
    }
    D[199] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD408\uD41D\uD440\uD444\uD45C\uD460\uD464\uD46D\uD46F\uD478\uD479\uD47C\uD47F\uD480\uD482\uD488\uD489\uD48B\uD48D\uD494\uD4A9\uD4CC\uD4D0\uD4D4\uD4DC\uD4DF\uD4E8\uD4EC\uD4F0\uD4F8\uD4FB\uD4FD\uD504\uD508\uD50C\uD514\uD515\uD517\uD53C\uD53D\uD540\uD544\uD54C\uD54D\uD54F\uD551\uD558\uD559\uD55C\uD560\uD565\uD568\uD569\uD56B\uD56D\uD574\uD575\uD578\uD57C\uD584\uD585\uD587\uD588\uD589\uD590\uD5A5\uD5C8\uD5C9\uD5CC\uD5D0\uD5D2\uD5D8\uD5D9\uD5DB\uD5DD\uD5E4\uD5E5\uD5E8\uD5EC\uD5F4\uD5F5\uD5F7\uD5F9\uD600\uD601\uD604\uD608\uD610\uD611\uD613\uD614\uD615\uD61C\uD620\uFFFD".split("");
    for(j = 0; j != D[199].length; ++j)if (D[199][j].charCodeAt(0) !== 0xFFFD) {
        e[D[199][j]] = 50944 + j;
        d[50944 + j] = D[199][j];
    }
    D[200] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD624\uD62D\uD638\uD639\uD63C\uD640\uD645\uD648\uD649\uD64B\uD64D\uD651\uD654\uD655\uD658\uD65C\uD667\uD669\uD670\uD671\uD674\uD683\uD685\uD68C\uD68D\uD690\uD694\uD69D\uD69F\uD6A1\uD6A8\uD6AC\uD6B0\uD6B9\uD6BB\uD6C4\uD6C5\uD6C8\uD6CC\uD6D1\uD6D4\uD6D7\uD6D9\uD6E0\uD6E4\uD6E8\uD6F0\uD6F5\uD6FC\uD6FD\uD700\uD704\uD711\uD718\uD719\uD71C\uD720\uD728\uD729\uD72B\uD72D\uD734\uD735\uD738\uD73C\uD744\uD747\uD749\uD750\uD751\uD754\uD756\uD757\uD758\uD759\uD760\uD761\uD763\uD765\uD769\uD76C\uD770\uD774\uD77C\uD77D\uD781\uD788\uD789\uD78C\uD790\uD798\uD799\uD79B\uD79D\uFFFD".split("");
    for(j = 0; j != D[200].length; ++j)if (D[200][j].charCodeAt(0) !== 0xFFFD) {
        e[D[200][j]] = 51200 + j;
        d[51200 + j] = D[200][j];
    }
    D[202] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u4F3D\u4F73\u5047\u50F9\u52A0\u53EF\u5475\u54E5\u5609\u5AC1\u5BB6\u6687\u67B6\u67B7\u67EF\u6B4C\u73C2\u75C2\u7A3C\u82DB\u8304\u8857\u8888\u8A36\u8CC8\u8DCF\u8EFB\u8FE6\u99D5\u523B\u5374\u5404\u606A\u6164\u6BBC\u73CF\u811A\u89BA\u89D2\u95A3\u4F83\u520A\u58BE\u5978\u59E6\u5E72\u5E79\u61C7\u63C0\u6746\u67EC\u687F\u6F97\u764E\u770B\u78F5\u7A08\u7AFF\u7C21\u809D\u826E\u8271\u8AEB\u9593\u4E6B\u559D\u66F7\u6E34\u78A3\u7AED\u845B\u8910\u874E\u97A8\u52D8\u574E\u582A\u5D4C\u611F\u61BE\u6221\u6562\u67D1\u6A44\u6E1B\u7518\u75B3\u76E3\u77B0\u7D3A\u90AF\u9451\u9452\u9F95\uFFFD".split("");
    for(j = 0; j != D[202].length; ++j)if (D[202][j].charCodeAt(0) !== 0xFFFD) {
        e[D[202][j]] = 51712 + j;
        d[51712 + j] = D[202][j];
    }
    D[203] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5323\u5CAC\u7532\u80DB\u9240\u9598\u525B\u5808\u59DC\u5CA1\u5D17\u5EB7\u5F3A\u5F4A\u6177\u6C5F\u757A\u7586\u7CE0\u7D73\u7DB1\u7F8C\u8154\u8221\u8591\u8941\u8B1B\u92FC\u964D\u9C47\u4ECB\u4EF7\u500B\u51F1\u584F\u6137\u613E\u6168\u6539\u69EA\u6F11\u75A5\u7686\u76D6\u7B87\u82A5\u84CB\uF900\u93A7\u958B\u5580\u5BA2\u5751\uF901\u7CB3\u7FB9\u91B5\u5028\u53BB\u5C45\u5DE8\u62D2\u636E\u64DA\u64E7\u6E20\u70AC\u795B\u8DDD\u8E1E\uF902\u907D\u9245\u92F8\u4E7E\u4EF6\u5065\u5DFE\u5EFA\u6106\u6957\u8171\u8654\u8E47\u9375\u9A2B\u4E5E\u5091\u6770\u6840\u5109\u528D\u5292\u6AA2\uFFFD".split("");
    for(j = 0; j != D[203].length; ++j)if (D[203][j].charCodeAt(0) !== 0xFFFD) {
        e[D[203][j]] = 51968 + j;
        d[51968 + j] = D[203][j];
    }
    D[204] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u77BC\u9210\u9ED4\u52AB\u602F\u8FF2\u5048\u61A9\u63ED\u64CA\u683C\u6A84\u6FC0\u8188\u89A1\u9694\u5805\u727D\u72AC\u7504\u7D79\u7E6D\u80A9\u898B\u8B74\u9063\u9D51\u6289\u6C7A\u6F54\u7D50\u7F3A\u8A23\u517C\u614A\u7B9D\u8B19\u9257\u938C\u4EAC\u4FD3\u501E\u50BE\u5106\u52C1\u52CD\u537F\u5770\u5883\u5E9A\u5F91\u6176\u61AC\u64CE\u656C\u666F\u66BB\u66F4\u6897\u6D87\u7085\u70F1\u749F\u74A5\u74CA\u75D9\u786C\u78EC\u7ADF\u7AF6\u7D45\u7D93\u8015\u803F\u811B\u8396\u8B66\u8F15\u9015\u93E1\u9803\u9838\u9A5A\u9BE8\u4FC2\u5553\u583A\u5951\u5B63\u5C46\u60B8\u6212\u6842\u68B0\uFFFD".split("");
    for(j = 0; j != D[204].length; ++j)if (D[204][j].charCodeAt(0) !== 0xFFFD) {
        e[D[204][j]] = 52224 + j;
        d[52224 + j] = D[204][j];
    }
    D[205] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u68E8\u6EAA\u754C\u7678\u78CE\u7A3D\u7CFB\u7E6B\u7E7C\u8A08\u8AA1\u8C3F\u968E\u9DC4\u53E4\u53E9\u544A\u5471\u56FA\u59D1\u5B64\u5C3B\u5EAB\u62F7\u6537\u6545\u6572\u66A0\u67AF\u69C1\u6CBD\u75FC\u7690\u777E\u7A3F\u7F94\u8003\u80A1\u818F\u82E6\u82FD\u83F0\u85C1\u8831\u88B4\u8AA5\uF903\u8F9C\u932E\u96C7\u9867\u9AD8\u9F13\u54ED\u659B\u66F2\u688F\u7A40\u8C37\u9D60\u56F0\u5764\u5D11\u6606\u68B1\u68CD\u6EFE\u7428\u889E\u9BE4\u6C68\uF904\u9AA8\u4F9B\u516C\u5171\u529F\u5B54\u5DE5\u6050\u606D\u62F1\u63A7\u653B\u73D9\u7A7A\u86A3\u8CA2\u978F\u4E32\u5BE1\u6208\u679C\u74DC\uFFFD".split("");
    for(j = 0; j != D[205].length; ++j)if (D[205][j].charCodeAt(0) !== 0xFFFD) {
        e[D[205][j]] = 52480 + j;
        d[52480 + j] = D[205][j];
    }
    D[206] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u79D1\u83D3\u8A87\u8AB2\u8DE8\u904E\u934B\u9846\u5ED3\u69E8\u85FF\u90ED\uF905\u51A0\u5B98\u5BEC\u6163\u68FA\u6B3E\u704C\u742F\u74D8\u7BA1\u7F50\u83C5\u89C0\u8CAB\u95DC\u9928\u522E\u605D\u62EC\u9002\u4F8A\u5149\u5321\u58D9\u5EE3\u66E0\u6D38\u709A\u72C2\u73D6\u7B50\u80F1\u945B\u5366\u639B\u7F6B\u4E56\u5080\u584A\u58DE\u602A\u6127\u62D0\u69D0\u9B41\u5B8F\u7D18\u80B1\u8F5F\u4EA4\u50D1\u54AC\u55AC\u5B0C\u5DA0\u5DE7\u652A\u654E\u6821\u6A4B\u72E1\u768E\u77EF\u7D5E\u7FF9\u81A0\u854E\u86DF\u8F03\u8F4E\u90CA\u9903\u9A55\u9BAB\u4E18\u4E45\u4E5D\u4EC7\u4FF1\u5177\u52FE\uFFFD".split("");
    for(j = 0; j != D[206].length; ++j)if (D[206][j].charCodeAt(0) !== 0xFFFD) {
        e[D[206][j]] = 52736 + j;
        d[52736 + j] = D[206][j];
    }
    D[207] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5340\u53E3\u53E5\u548E\u5614\u5775\u57A2\u5BC7\u5D87\u5ED0\u61FC\u62D8\u6551\u67B8\u67E9\u69CB\u6B50\u6BC6\u6BEC\u6C42\u6E9D\u7078\u72D7\u7396\u7403\u77BF\u77E9\u7A76\u7D7F\u8009\u81FC\u8205\u820A\u82DF\u8862\u8B33\u8CFC\u8EC0\u9011\u90B1\u9264\u92B6\u99D2\u9A45\u9CE9\u9DD7\u9F9C\u570B\u5C40\u83CA\u97A0\u97AB\u9EB4\u541B\u7A98\u7FA4\u88D9\u8ECD\u90E1\u5800\u5C48\u6398\u7A9F\u5BAE\u5F13\u7A79\u7AAE\u828E\u8EAC\u5026\u5238\u52F8\u5377\u5708\u62F3\u6372\u6B0A\u6DC3\u7737\u53A5\u7357\u8568\u8E76\u95D5\u673A\u6AC3\u6F70\u8A6D\u8ECC\u994B\uF906\u6677\u6B78\u8CB4\uFFFD".split("");
    for(j = 0; j != D[207].length; ++j)if (D[207][j].charCodeAt(0) !== 0xFFFD) {
        e[D[207][j]] = 52992 + j;
        d[52992 + j] = D[207][j];
    }
    D[208] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9B3C\uF907\u53EB\u572D\u594E\u63C6\u69FB\u73EA\u7845\u7ABA\u7AC5\u7CFE\u8475\u898F\u8D73\u9035\u95A8\u52FB\u5747\u7547\u7B60\u83CC\u921E\uF908\u6A58\u514B\u524B\u5287\u621F\u68D8\u6975\u9699\u50C5\u52A4\u52E4\u61C3\u65A4\u6839\u69FF\u747E\u7B4B\u82B9\u83EB\u89B2\u8B39\u8FD1\u9949\uF909\u4ECA\u5997\u64D2\u6611\u6A8E\u7434\u7981\u79BD\u82A9\u887E\u887F\u895F\uF90A\u9326\u4F0B\u53CA\u6025\u6271\u6C72\u7D1A\u7D66\u4E98\u5162\u77DC\u80AF\u4F01\u4F0E\u5176\u5180\u55DC\u5668\u573B\u57FA\u57FC\u5914\u5947\u5993\u5BC4\u5C90\u5D0E\u5DF1\u5E7E\u5FCC\u6280\u65D7\u65E3\uFFFD".split("");
    for(j = 0; j != D[208].length; ++j)if (D[208][j].charCodeAt(0) !== 0xFFFD) {
        e[D[208][j]] = 53248 + j;
        d[53248 + j] = D[208][j];
    }
    D[209] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u671E\u671F\u675E\u68CB\u68C4\u6A5F\u6B3A\u6C23\u6C7D\u6C82\u6DC7\u7398\u7426\u742A\u7482\u74A3\u7578\u757F\u7881\u78EF\u7941\u7947\u7948\u797A\u7B95\u7D00\u7DBA\u7F88\u8006\u802D\u808C\u8A18\u8B4F\u8C48\u8D77\u9321\u9324\u98E2\u9951\u9A0E\u9A0F\u9A65\u9E92\u7DCA\u4F76\u5409\u62EE\u6854\u91D1\u55AB\u513A\uF90B\uF90C\u5A1C\u61E6\uF90D\u62CF\u62FF\uF90E\uF90F\uF910\uF911\uF912\uF913\u90A3\uF914\uF915\uF916\uF917\uF918\u8AFE\uF919\uF91A\uF91B\uF91C\u6696\uF91D\u7156\uF91E\uF91F\u96E3\uF920\u634F\u637A\u5357\uF921\u678F\u6960\u6E73\uF922\u7537\uF923\uF924\uF925\uFFFD".split("");
    for(j = 0; j != D[209].length; ++j)if (D[209][j].charCodeAt(0) !== 0xFFFD) {
        e[D[209][j]] = 53504 + j;
        d[53504 + j] = D[209][j];
    }
    D[210] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7D0D\uF926\uF927\u8872\u56CA\u5A18\uF928\uF929\uF92A\uF92B\uF92C\u4E43\uF92D\u5167\u5948\u67F0\u8010\uF92E\u5973\u5E74\u649A\u79CA\u5FF5\u606C\u62C8\u637B\u5BE7\u5BD7\u52AA\uF92F\u5974\u5F29\u6012\uF930\uF931\uF932\u7459\uF933\uF934\uF935\uF936\uF937\uF938\u99D1\uF939\uF93A\uF93B\uF93C\uF93D\uF93E\uF93F\uF940\uF941\uF942\uF943\u6FC3\uF944\uF945\u81BF\u8FB2\u60F1\uF946\uF947\u8166\uF948\uF949\u5C3F\uF94A\uF94B\uF94C\uF94D\uF94E\uF94F\uF950\uF951\u5AE9\u8A25\u677B\u7D10\uF952\uF953\uF954\uF955\uF956\uF957\u80FD\uF958\uF959\u5C3C\u6CE5\u533F\u6EBA\u591A\u8336\uFFFD".split("");
    for(j = 0; j != D[210].length; ++j)if (D[210][j].charCodeAt(0) !== 0xFFFD) {
        e[D[210][j]] = 53760 + j;
        d[53760 + j] = D[210][j];
    }
    D[211] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u4E39\u4EB6\u4F46\u55AE\u5718\u58C7\u5F56\u65B7\u65E6\u6A80\u6BB5\u6E4D\u77ED\u7AEF\u7C1E\u7DDE\u86CB\u8892\u9132\u935B\u64BB\u6FBE\u737A\u75B8\u9054\u5556\u574D\u61BA\u64D4\u66C7\u6DE1\u6E5B\u6F6D\u6FB9\u75F0\u8043\u81BD\u8541\u8983\u8AC7\u8B5A\u931F\u6C93\u7553\u7B54\u8E0F\u905D\u5510\u5802\u5858\u5E62\u6207\u649E\u68E0\u7576\u7CD6\u87B3\u9EE8\u4EE3\u5788\u576E\u5927\u5C0D\u5CB1\u5E36\u5F85\u6234\u64E1\u73B3\u81FA\u888B\u8CB8\u968A\u9EDB\u5B85\u5FB7\u60B3\u5012\u5200\u5230\u5716\u5835\u5857\u5C0E\u5C60\u5CF6\u5D8B\u5EA6\u5F92\u60BC\u6311\u6389\u6417\u6843\uFFFD".split("");
    for(j = 0; j != D[211].length; ++j)if (D[211][j].charCodeAt(0) !== 0xFFFD) {
        e[D[211][j]] = 54016 + j;
        d[54016 + j] = D[211][j];
    }
    D[212] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u68F9\u6AC2\u6DD8\u6E21\u6ED4\u6FE4\u71FE\u76DC\u7779\u79B1\u7A3B\u8404\u89A9\u8CED\u8DF3\u8E48\u9003\u9014\u9053\u90FD\u934D\u9676\u97DC\u6BD2\u7006\u7258\u72A2\u7368\u7763\u79BF\u7BE4\u7E9B\u8B80\u58A9\u60C7\u6566\u65FD\u66BE\u6C8C\u711E\u71C9\u8C5A\u9813\u4E6D\u7A81\u4EDD\u51AC\u51CD\u52D5\u540C\u61A7\u6771\u6850\u68DF\u6D1E\u6F7C\u75BC\u77B3\u7AE5\u80F4\u8463\u9285\u515C\u6597\u675C\u6793\u75D8\u7AC7\u8373\uF95A\u8C46\u9017\u982D\u5C6F\u81C0\u829A\u9041\u906F\u920D\u5F97\u5D9D\u6A59\u71C8\u767B\u7B49\u85E4\u8B04\u9127\u9A30\u5587\u61F6\uF95B\u7669\u7F85\uFFFD".split("");
    for(j = 0; j != D[212].length; ++j)if (D[212][j].charCodeAt(0) !== 0xFFFD) {
        e[D[212][j]] = 54272 + j;
        d[54272 + j] = D[212][j];
    }
    D[213] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u863F\u87BA\u88F8\u908F\uF95C\u6D1B\u70D9\u73DE\u7D61\u843D\uF95D\u916A\u99F1\uF95E\u4E82\u5375\u6B04\u6B12\u703E\u721B\u862D\u9E1E\u524C\u8FA3\u5D50\u64E5\u652C\u6B16\u6FEB\u7C43\u7E9C\u85CD\u8964\u89BD\u62C9\u81D8\u881F\u5ECA\u6717\u6D6A\u72FC\u7405\u746F\u8782\u90DE\u4F86\u5D0D\u5FA0\u840A\u51B7\u63A0\u7565\u4EAE\u5006\u5169\u51C9\u6881\u6A11\u7CAE\u7CB1\u7CE7\u826F\u8AD2\u8F1B\u91CF\u4FB6\u5137\u52F5\u5442\u5EEC\u616E\u623E\u65C5\u6ADA\u6FFE\u792A\u85DC\u8823\u95AD\u9A62\u9A6A\u9E97\u9ECE\u529B\u66C6\u6B77\u701D\u792B\u8F62\u9742\u6190\u6200\u6523\u6F23\uFFFD".split("");
    for(j = 0; j != D[213].length; ++j)if (D[213][j].charCodeAt(0) !== 0xFFFD) {
        e[D[213][j]] = 54528 + j;
        d[54528 + j] = D[213][j];
    }
    D[214] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7149\u7489\u7DF4\u806F\u84EE\u8F26\u9023\u934A\u51BD\u5217\u52A3\u6D0C\u70C8\u88C2\u5EC9\u6582\u6BAE\u6FC2\u7C3E\u7375\u4EE4\u4F36\u56F9\uF95F\u5CBA\u5DBA\u601C\u73B2\u7B2D\u7F9A\u7FCE\u8046\u901E\u9234\u96F6\u9748\u9818\u9F61\u4F8B\u6FA7\u79AE\u91B4\u96B7\u52DE\uF960\u6488\u64C4\u6AD3\u6F5E\u7018\u7210\u76E7\u8001\u8606\u865C\u8DEF\u8F05\u9732\u9B6F\u9DFA\u9E75\u788C\u797F\u7DA0\u83C9\u9304\u9E7F\u9E93\u8AD6\u58DF\u5F04\u6727\u7027\u74CF\u7C60\u807E\u5121\u7028\u7262\u78CA\u8CC2\u8CDA\u8CF4\u96F7\u4E86\u50DA\u5BEE\u5ED6\u6599\u71CE\u7642\u77AD\u804A\u84FC\uFFFD".split("");
    for(j = 0; j != D[214].length; ++j)if (D[214][j].charCodeAt(0) !== 0xFFFD) {
        e[D[214][j]] = 54784 + j;
        d[54784 + j] = D[214][j];
    }
    D[215] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u907C\u9B27\u9F8D\u58D8\u5A41\u5C62\u6A13\u6DDA\u6F0F\u763B\u7D2F\u7E37\u851E\u8938\u93E4\u964B\u5289\u65D2\u67F3\u69B4\u6D41\u6E9C\u700F\u7409\u7460\u7559\u7624\u786B\u8B2C\u985E\u516D\u622E\u9678\u4F96\u502B\u5D19\u6DEA\u7DB8\u8F2A\u5F8B\u6144\u6817\uF961\u9686\u52D2\u808B\u51DC\u51CC\u695E\u7A1C\u7DBE\u83F1\u9675\u4FDA\u5229\u5398\u540F\u550E\u5C65\u60A7\u674E\u68A8\u6D6C\u7281\u72F8\u7406\u7483\uF962\u75E2\u7C6C\u7F79\u7FB8\u8389\u88CF\u88E1\u91CC\u91D0\u96E2\u9BC9\u541D\u6F7E\u71D0\u7498\u85FA\u8EAA\u96A3\u9C57\u9E9F\u6797\u6DCB\u7433\u81E8\u9716\u782C\uFFFD".split("");
    for(j = 0; j != D[215].length; ++j)if (D[215][j].charCodeAt(0) !== 0xFFFD) {
        e[D[215][j]] = 55040 + j;
        d[55040 + j] = D[215][j];
    }
    D[216] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7ACB\u7B20\u7C92\u6469\u746A\u75F2\u78BC\u78E8\u99AC\u9B54\u9EBB\u5BDE\u5E55\u6F20\u819C\u83AB\u9088\u4E07\u534D\u5A29\u5DD2\u5F4E\u6162\u633D\u6669\u66FC\u6EFF\u6F2B\u7063\u779E\u842C\u8513\u883B\u8F13\u9945\u9C3B\u551C\u62B9\u672B\u6CAB\u8309\u896A\u977A\u4EA1\u5984\u5FD8\u5FD9\u671B\u7DB2\u7F54\u8292\u832B\u83BD\u8F1E\u9099\u57CB\u59B9\u5A92\u5BD0\u6627\u679A\u6885\u6BCF\u7164\u7F75\u8CB7\u8CE3\u9081\u9B45\u8108\u8C8A\u964C\u9A40\u9EA5\u5B5F\u6C13\u731B\u76F2\u76DF\u840C\u51AA\u8993\u514D\u5195\u52C9\u68C9\u6C94\u7704\u7720\u7DBF\u7DEC\u9762\u9EB5\u6EC5\uFFFD".split("");
    for(j = 0; j != D[216].length; ++j)if (D[216][j].charCodeAt(0) !== 0xFFFD) {
        e[D[216][j]] = 55296 + j;
        d[55296 + j] = D[216][j];
    }
    D[217] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8511\u51A5\u540D\u547D\u660E\u669D\u6927\u6E9F\u76BF\u7791\u8317\u84C2\u879F\u9169\u9298\u9CF4\u8882\u4FAE\u5192\u52DF\u59C6\u5E3D\u6155\u6478\u6479\u66AE\u67D0\u6A21\u6BCD\u6BDB\u725F\u7261\u7441\u7738\u77DB\u8017\u82BC\u8305\u8B00\u8B28\u8C8C\u6728\u6C90\u7267\u76EE\u7766\u7A46\u9DA9\u6B7F\u6C92\u5922\u6726\u8499\u536F\u5893\u5999\u5EDF\u63CF\u6634\u6773\u6E3A\u732B\u7AD7\u82D7\u9328\u52D9\u5DEB\u61AE\u61CB\u620A\u62C7\u64AB\u65E0\u6959\u6B66\u6BCB\u7121\u73F7\u755D\u7E46\u821E\u8302\u856A\u8AA3\u8CBF\u9727\u9D61\u58A8\u9ED8\u5011\u520E\u543B\u554F\u6587\uFFFD".split("");
    for(j = 0; j != D[217].length; ++j)if (D[217][j].charCodeAt(0) !== 0xFFFD) {
        e[D[217][j]] = 55552 + j;
        d[55552 + j] = D[217][j];
    }
    D[218] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6C76\u7D0A\u7D0B\u805E\u868A\u9580\u96EF\u52FF\u6C95\u7269\u5473\u5A9A\u5C3E\u5D4B\u5F4C\u5FAE\u672A\u68B6\u6963\u6E3C\u6E44\u7709\u7C73\u7F8E\u8587\u8B0E\u8FF7\u9761\u9EF4\u5CB7\u60B6\u610D\u61AB\u654F\u65FB\u65FC\u6C11\u6CEF\u739F\u73C9\u7DE1\u9594\u5BC6\u871C\u8B10\u525D\u535A\u62CD\u640F\u64B2\u6734\u6A38\u6CCA\u73C0\u749E\u7B94\u7C95\u7E1B\u818A\u8236\u8584\u8FEB\u96F9\u99C1\u4F34\u534A\u53CD\u53DB\u62CC\u642C\u6500\u6591\u69C3\u6CEE\u6F58\u73ED\u7554\u7622\u76E4\u76FC\u78D0\u78FB\u792C\u7D46\u822C\u87E0\u8FD4\u9812\u98EF\u52C3\u62D4\u64A5\u6E24\u6F51\uFFFD".split("");
    for(j = 0; j != D[218].length; ++j)if (D[218][j].charCodeAt(0) !== 0xFFFD) {
        e[D[218][j]] = 55808 + j;
        d[55808 + j] = D[218][j];
    }
    D[219] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u767C\u8DCB\u91B1\u9262\u9AEE\u9B43\u5023\u508D\u574A\u59A8\u5C28\u5E47\u5F77\u623F\u653E\u65B9\u65C1\u6609\u678B\u699C\u6EC2\u78C5\u7D21\u80AA\u8180\u822B\u82B3\u84A1\u868C\u8A2A\u8B17\u90A6\u9632\u9F90\u500D\u4FF3\uF963\u57F9\u5F98\u62DC\u6392\u676F\u6E43\u7119\u76C3\u80CC\u80DA\u88F4\u88F5\u8919\u8CE0\u8F29\u914D\u966A\u4F2F\u4F70\u5E1B\u67CF\u6822\u767D\u767E\u9B44\u5E61\u6A0A\u7169\u71D4\u756A\uF964\u7E41\u8543\u85E9\u98DC\u4F10\u7B4F\u7F70\u95A5\u51E1\u5E06\u68B5\u6C3E\u6C4E\u6CDB\u72AF\u7BC4\u8303\u6CD5\u743A\u50FB\u5288\u58C1\u64D8\u6A97\u74A7\u7656\uFFFD".split("");
    for(j = 0; j != D[219].length; ++j)if (D[219][j].charCodeAt(0) !== 0xFFFD) {
        e[D[219][j]] = 56064 + j;
        d[56064 + j] = D[219][j];
    }
    D[220] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u78A7\u8617\u95E2\u9739\uF965\u535E\u5F01\u8B8A\u8FA8\u8FAF\u908A\u5225\u77A5\u9C49\u9F08\u4E19\u5002\u5175\u5C5B\u5E77\u661E\u663A\u67C4\u68C5\u70B3\u7501\u75C5\u79C9\u7ADD\u8F27\u9920\u9A08\u4FDD\u5821\u5831\u5BF6\u666E\u6B65\u6D11\u6E7A\u6F7D\u73E4\u752B\u83E9\u88DC\u8913\u8B5C\u8F14\u4F0F\u50D5\u5310\u535C\u5B93\u5FA9\u670D\u798F\u8179\u832F\u8514\u8907\u8986\u8F39\u8F3B\u99A5\u9C12\u672C\u4E76\u4FF8\u5949\u5C01\u5CEF\u5CF0\u6367\u68D2\u70FD\u71A2\u742B\u7E2B\u84EC\u8702\u9022\u92D2\u9CF3\u4E0D\u4ED8\u4FEF\u5085\u5256\u526F\u5426\u5490\u57E0\u592B\u5A66\uFFFD".split("");
    for(j = 0; j != D[220].length; ++j)if (D[220][j].charCodeAt(0) !== 0xFFFD) {
        e[D[220][j]] = 56320 + j;
        d[56320 + j] = D[220][j];
    }
    D[221] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5B5A\u5B75\u5BCC\u5E9C\uF966\u6276\u6577\u65A7\u6D6E\u6EA5\u7236\u7B26\u7C3F\u7F36\u8150\u8151\u819A\u8240\u8299\u83A9\u8A03\u8CA0\u8CE6\u8CFB\u8D74\u8DBA\u90E8\u91DC\u961C\u9644\u99D9\u9CE7\u5317\u5206\u5429\u5674\u58B3\u5954\u596E\u5FFF\u61A4\u626E\u6610\u6C7E\u711A\u76C6\u7C89\u7CDE\u7D1B\u82AC\u8CC1\u96F0\uF967\u4F5B\u5F17\u5F7F\u62C2\u5D29\u670B\u68DA\u787C\u7E43\u9D6C\u4E15\u5099\u5315\u532A\u5351\u5983\u5A62\u5E87\u60B2\u618A\u6249\u6279\u6590\u6787\u69A7\u6BD4\u6BD6\u6BD7\u6BD8\u6CB8\uF968\u7435\u75FA\u7812\u7891\u79D5\u79D8\u7C83\u7DCB\u7FE1\u80A5\uFFFD".split("");
    for(j = 0; j != D[221].length; ++j)if (D[221][j].charCodeAt(0) !== 0xFFFD) {
        e[D[221][j]] = 56576 + j;
        d[56576 + j] = D[221][j];
    }
    D[222] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u813E\u81C2\u83F2\u871A\u88E8\u8AB9\u8B6C\u8CBB\u9119\u975E\u98DB\u9F3B\u56AC\u5B2A\u5F6C\u658C\u6AB3\u6BAF\u6D5C\u6FF1\u7015\u725D\u73AD\u8CA7\u8CD3\u983B\u6191\u6C37\u8058\u9A01\u4E4D\u4E8B\u4E9B\u4ED5\u4F3A\u4F3C\u4F7F\u4FDF\u50FF\u53F2\u53F8\u5506\u55E3\u56DB\u58EB\u5962\u5A11\u5BEB\u5BFA\u5C04\u5DF3\u5E2B\u5F99\u601D\u6368\u659C\u65AF\u67F6\u67FB\u68AD\u6B7B\u6C99\u6CD7\u6E23\u7009\u7345\u7802\u793E\u7940\u7960\u79C1\u7BE9\u7D17\u7D72\u8086\u820D\u838E\u84D1\u86C7\u88DF\u8A50\u8A5E\u8B1D\u8CDC\u8D66\u8FAD\u90AA\u98FC\u99DF\u9E9D\u524A\uF969\u6714\uF96A\uFFFD".split("");
    for(j = 0; j != D[222].length; ++j)if (D[222][j].charCodeAt(0) !== 0xFFFD) {
        e[D[222][j]] = 56832 + j;
        d[56832 + j] = D[222][j];
    }
    D[223] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5098\u522A\u5C71\u6563\u6C55\u73CA\u7523\u759D\u7B97\u849C\u9178\u9730\u4E77\u6492\u6BBA\u715E\u85A9\u4E09\uF96B\u6749\u68EE\u6E17\u829F\u8518\u886B\u63F7\u6F81\u9212\u98AF\u4E0A\u50B7\u50CF\u511F\u5546\u55AA\u5617\u5B40\u5C19\u5CE0\u5E38\u5E8A\u5EA0\u5EC2\u60F3\u6851\u6A61\u6E58\u723D\u7240\u72C0\u76F8\u7965\u7BB1\u7FD4\u88F3\u89F4\u8A73\u8C61\u8CDE\u971C\u585E\u74BD\u8CFD\u55C7\uF96C\u7A61\u7D22\u8272\u7272\u751F\u7525\uF96D\u7B19\u5885\u58FB\u5DBC\u5E8F\u5EB6\u5F90\u6055\u6292\u637F\u654D\u6691\u66D9\u66F8\u6816\u68F2\u7280\u745E\u7B6E\u7D6E\u7DD6\u7F72\uFFFD".split("");
    for(j = 0; j != D[223].length; ++j)if (D[223][j].charCodeAt(0) !== 0xFFFD) {
        e[D[223][j]] = 57088 + j;
        d[57088 + j] = D[223][j];
    }
    D[224] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u80E5\u8212\u85AF\u897F\u8A93\u901D\u92E4\u9ECD\u9F20\u5915\u596D\u5E2D\u60DC\u6614\u6673\u6790\u6C50\u6DC5\u6F5F\u77F3\u78A9\u84C6\u91CB\u932B\u4ED9\u50CA\u5148\u5584\u5B0B\u5BA3\u6247\u657E\u65CB\u6E32\u717D\u7401\u7444\u7487\u74BF\u766C\u79AA\u7DDA\u7E55\u7FA8\u817A\u81B3\u8239\u861A\u87EC\u8A75\u8DE3\u9078\u9291\u9425\u994D\u9BAE\u5368\u5C51\u6954\u6CC4\u6D29\u6E2B\u820C\u859B\u893B\u8A2D\u8AAA\u96EA\u9F67\u5261\u66B9\u6BB2\u7E96\u87FE\u8D0D\u9583\u965D\u651D\u6D89\u71EE\uF96E\u57CE\u59D3\u5BAC\u6027\u60FA\u6210\u661F\u665F\u7329\u73F9\u76DB\u7701\u7B6C\uFFFD".split("");
    for(j = 0; j != D[224].length; ++j)if (D[224][j].charCodeAt(0) !== 0xFFFD) {
        e[D[224][j]] = 57344 + j;
        d[57344 + j] = D[224][j];
    }
    D[225] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8056\u8072\u8165\u8AA0\u9192\u4E16\u52E2\u6B72\u6D17\u7A05\u7B39\u7D30\uF96F\u8CB0\u53EC\u562F\u5851\u5BB5\u5C0F\u5C11\u5DE2\u6240\u6383\u6414\u662D\u68B3\u6CBC\u6D88\u6EAF\u701F\u70A4\u71D2\u7526\u758F\u758E\u7619\u7B11\u7BE0\u7C2B\u7D20\u7D39\u852C\u856D\u8607\u8A34\u900D\u9061\u90B5\u92B7\u97F6\u9A37\u4FD7\u5C6C\u675F\u6D91\u7C9F\u7E8C\u8B16\u8D16\u901F\u5B6B\u5DFD\u640D\u84C0\u905C\u98E1\u7387\u5B8B\u609A\u677E\u6DDE\u8A1F\u8AA6\u9001\u980C\u5237\uF970\u7051\u788E\u9396\u8870\u91D7\u4FEE\u53D7\u55FD\u56DA\u5782\u58FD\u5AC2\u5B88\u5CAB\u5CC0\u5E25\u6101\uFFFD".split("");
    for(j = 0; j != D[225].length; ++j)if (D[225][j].charCodeAt(0) !== 0xFFFD) {
        e[D[225][j]] = 57600 + j;
        d[57600 + j] = D[225][j];
    }
    D[226] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u620D\u624B\u6388\u641C\u6536\u6578\u6A39\u6B8A\u6C34\u6D19\u6F31\u71E7\u72E9\u7378\u7407\u74B2\u7626\u7761\u79C0\u7A57\u7AEA\u7CB9\u7D8F\u7DAC\u7E61\u7F9E\u8129\u8331\u8490\u84DA\u85EA\u8896\u8AB0\u8B90\u8F38\u9042\u9083\u916C\u9296\u92B9\u968B\u96A7\u96A8\u96D6\u9700\u9808\u9996\u9AD3\u9B1A\u53D4\u587E\u5919\u5B70\u5BBF\u6DD1\u6F5A\u719F\u7421\u74B9\u8085\u83FD\u5DE1\u5F87\u5FAA\u6042\u65EC\u6812\u696F\u6A53\u6B89\u6D35\u6DF3\u73E3\u76FE\u77AC\u7B4D\u7D14\u8123\u821C\u8340\u84F4\u8563\u8A62\u8AC4\u9187\u931E\u9806\u99B4\u620C\u8853\u8FF0\u9265\u5D07\u5D27\uFFFD".split("");
    for(j = 0; j != D[226].length; ++j)if (D[226][j].charCodeAt(0) !== 0xFFFD) {
        e[D[226][j]] = 57856 + j;
        d[57856 + j] = D[226][j];
    }
    D[227] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5D69\u745F\u819D\u8768\u6FD5\u62FE\u7FD2\u8936\u8972\u4E1E\u4E58\u50E7\u52DD\u5347\u627F\u6607\u7E69\u8805\u965E\u4F8D\u5319\u5636\u59CB\u5AA4\u5C38\u5C4E\u5C4D\u5E02\u5F11\u6043\u65BD\u662F\u6642\u67BE\u67F4\u731C\u77E2\u793A\u7FC5\u8494\u84CD\u8996\u8A66\u8A69\u8AE1\u8C55\u8C7A\u57F4\u5BD4\u5F0F\u606F\u62ED\u690D\u6B96\u6E5C\u7184\u7BD2\u8755\u8B58\u8EFE\u98DF\u98FE\u4F38\u4F81\u4FE1\u547B\u5A20\u5BB8\u613C\u65B0\u6668\u71FC\u7533\u795E\u7D33\u814E\u81E3\u8398\u85AA\u85CE\u8703\u8A0A\u8EAB\u8F9B\uF971\u8FC5\u5931\u5BA4\u5BE6\u6089\u5BE9\u5C0B\u5FC3\u6C81\uFFFD".split("");
    for(j = 0; j != D[227].length; ++j)if (D[227][j].charCodeAt(0) !== 0xFFFD) {
        e[D[227][j]] = 58112 + j;
        d[58112 + j] = D[227][j];
    }
    D[228] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uF972\u6DF1\u700B\u751A\u82AF\u8AF6\u4EC0\u5341\uF973\u96D9\u6C0F\u4E9E\u4FC4\u5152\u555E\u5A25\u5CE8\u6211\u7259\u82BD\u83AA\u86FE\u8859\u8A1D\u963F\u96C5\u9913\u9D09\u9D5D\u580A\u5CB3\u5DBD\u5E44\u60E1\u6115\u63E1\u6A02\u6E25\u9102\u9354\u984E\u9C10\u9F77\u5B89\u5CB8\u6309\u664F\u6848\u773C\u96C1\u978D\u9854\u9B9F\u65A1\u8B01\u8ECB\u95BC\u5535\u5CA9\u5DD6\u5EB5\u6697\u764C\u83F4\u95C7\u58D3\u62BC\u72CE\u9D28\u4EF0\u592E\u600F\u663B\u6B83\u79E7\u9D26\u5393\u54C0\u57C3\u5D16\u611B\u66D6\u6DAF\u788D\u827E\u9698\u9744\u5384\u627C\u6396\u6DB2\u7E0A\u814B\u984D\uFFFD".split("");
    for(j = 0; j != D[228].length; ++j)if (D[228][j].charCodeAt(0) !== 0xFFFD) {
        e[D[228][j]] = 58368 + j;
        d[58368 + j] = D[228][j];
    }
    D[229] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6AFB\u7F4C\u9DAF\u9E1A\u4E5F\u503B\u51B6\u591C\u60F9\u63F6\u6930\u723A\u8036\uF974\u91CE\u5F31\uF975\uF976\u7D04\u82E5\u846F\u84BB\u85E5\u8E8D\uF977\u4F6F\uF978\uF979\u58E4\u5B43\u6059\u63DA\u6518\u656D\u6698\uF97A\u694A\u6A23\u6D0B\u7001\u716C\u75D2\u760D\u79B3\u7A70\uF97B\u7F8A\uF97C\u8944\uF97D\u8B93\u91C0\u967D\uF97E\u990A\u5704\u5FA1\u65BC\u6F01\u7600\u79A6\u8A9E\u99AD\u9B5A\u9F6C\u5104\u61B6\u6291\u6A8D\u81C6\u5043\u5830\u5F66\u7109\u8A00\u8AFA\u5B7C\u8616\u4FFA\u513C\u56B4\u5944\u63A9\u6DF9\u5DAA\u696D\u5186\u4E88\u4F59\uF97F\uF980\uF981\u5982\uF982\uFFFD".split("");
    for(j = 0; j != D[229].length; ++j)if (D[229][j].charCodeAt(0) !== 0xFFFD) {
        e[D[229][j]] = 58624 + j;
        d[58624 + j] = D[229][j];
    }
    D[230] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uF983\u6B5F\u6C5D\uF984\u74B5\u7916\uF985\u8207\u8245\u8339\u8F3F\u8F5D\uF986\u9918\uF987\uF988\uF989\u4EA6\uF98A\u57DF\u5F79\u6613\uF98B\uF98C\u75AB\u7E79\u8B6F\uF98D\u9006\u9A5B\u56A5\u5827\u59F8\u5A1F\u5BB4\uF98E\u5EF6\uF98F\uF990\u6350\u633B\uF991\u693D\u6C87\u6CBF\u6D8E\u6D93\u6DF5\u6F14\uF992\u70DF\u7136\u7159\uF993\u71C3\u71D5\uF994\u784F\u786F\uF995\u7B75\u7DE3\uF996\u7E2F\uF997\u884D\u8EDF\uF998\uF999\uF99A\u925B\uF99B\u9CF6\uF99C\uF99D\uF99E\u6085\u6D85\uF99F\u71B1\uF9A0\uF9A1\u95B1\u53AD\uF9A2\uF9A3\uF9A4\u67D3\uF9A5\u708E\u7130\u7430\u8276\u82D2\uFFFD".split("");
    for(j = 0; j != D[230].length; ++j)if (D[230][j].charCodeAt(0) !== 0xFFFD) {
        e[D[230][j]] = 58880 + j;
        d[58880 + j] = D[230][j];
    }
    D[231] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uF9A6\u95BB\u9AE5\u9E7D\u66C4\uF9A7\u71C1\u8449\uF9A8\uF9A9\u584B\uF9AA\uF9AB\u5DB8\u5F71\uF9AC\u6620\u668E\u6979\u69AE\u6C38\u6CF3\u6E36\u6F41\u6FDA\u701B\u702F\u7150\u71DF\u7370\uF9AD\u745B\uF9AE\u74D4\u76C8\u7A4E\u7E93\uF9AF\uF9B0\u82F1\u8A60\u8FCE\uF9B1\u9348\uF9B2\u9719\uF9B3\uF9B4\u4E42\u502A\uF9B5\u5208\u53E1\u66F3\u6C6D\u6FCA\u730A\u777F\u7A62\u82AE\u85DD\u8602\uF9B6\u88D4\u8A63\u8B7D\u8C6B\uF9B7\u92B3\uF9B8\u9713\u9810\u4E94\u4F0D\u4FC9\u50B2\u5348\u543E\u5433\u55DA\u5862\u58BA\u5967\u5A1B\u5BE4\u609F\uF9B9\u61CA\u6556\u65FF\u6664\u68A7\u6C5A\u6FB3\uFFFD".split("");
    for(j = 0; j != D[231].length; ++j)if (D[231][j].charCodeAt(0) !== 0xFFFD) {
        e[D[231][j]] = 59136 + j;
        d[59136 + j] = D[231][j];
    }
    D[232] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u70CF\u71AC\u7352\u7B7D\u8708\u8AA4\u9C32\u9F07\u5C4B\u6C83\u7344\u7389\u923A\u6EAB\u7465\u761F\u7A69\u7E15\u860A\u5140\u58C5\u64C1\u74EE\u7515\u7670\u7FC1\u9095\u96CD\u9954\u6E26\u74E6\u7AA9\u7AAA\u81E5\u86D9\u8778\u8A1B\u5A49\u5B8C\u5B9B\u68A1\u6900\u6D63\u73A9\u7413\u742C\u7897\u7DE9\u7FEB\u8118\u8155\u839E\u8C4C\u962E\u9811\u66F0\u5F80\u65FA\u6789\u6C6A\u738B\u502D\u5A03\u6B6A\u77EE\u5916\u5D6C\u5DCD\u7325\u754F\uF9BA\uF9BB\u50E5\u51F9\u582F\u592D\u5996\u59DA\u5BE5\uF9BC\uF9BD\u5DA2\u62D7\u6416\u6493\u64FE\uF9BE\u66DC\uF9BF\u6A48\uF9C0\u71FF\u7464\uF9C1\uFFFD".split("");
    for(j = 0; j != D[232].length; ++j)if (D[232][j].charCodeAt(0) !== 0xFFFD) {
        e[D[232][j]] = 59392 + j;
        d[59392 + j] = D[232][j];
    }
    D[233] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7A88\u7AAF\u7E47\u7E5E\u8000\u8170\uF9C2\u87EF\u8981\u8B20\u9059\uF9C3\u9080\u9952\u617E\u6B32\u6D74\u7E1F\u8925\u8FB1\u4FD1\u50AD\u5197\u52C7\u57C7\u5889\u5BB9\u5EB8\u6142\u6995\u6D8C\u6E67\u6EB6\u7194\u7462\u7528\u752C\u8073\u8338\u84C9\u8E0A\u9394\u93DE\uF9C4\u4E8E\u4F51\u5076\u512A\u53C8\u53CB\u53F3\u5B87\u5BD3\u5C24\u611A\u6182\u65F4\u725B\u7397\u7440\u76C2\u7950\u7991\u79B9\u7D06\u7FBD\u828B\u85D5\u865E\u8FC2\u9047\u90F5\u91EA\u9685\u96E8\u96E9\u52D6\u5F67\u65ED\u6631\u682F\u715C\u7A36\u90C1\u980A\u4E91\uF9C5\u6A52\u6B9E\u6F90\u7189\u8018\u82B8\u8553\uFFFD".split("");
    for(j = 0; j != D[233].length; ++j)if (D[233][j].charCodeAt(0) !== 0xFFFD) {
        e[D[233][j]] = 59648 + j;
        d[59648 + j] = D[233][j];
    }
    D[234] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u904B\u9695\u96F2\u97FB\u851A\u9B31\u4E90\u718A\u96C4\u5143\u539F\u54E1\u5713\u5712\u57A3\u5A9B\u5AC4\u5BC3\u6028\u613F\u63F4\u6C85\u6D39\u6E72\u6E90\u7230\u733F\u7457\u82D1\u8881\u8F45\u9060\uF9C6\u9662\u9858\u9D1B\u6708\u8D8A\u925E\u4F4D\u5049\u50DE\u5371\u570D\u59D4\u5A01\u5C09\u6170\u6690\u6E2D\u7232\u744B\u7DEF\u80C3\u840E\u8466\u853F\u875F\u885B\u8918\u8B02\u9055\u97CB\u9B4F\u4E73\u4F91\u5112\u516A\uF9C7\u552F\u55A9\u5B7A\u5BA5\u5E7C\u5E7D\u5EBE\u60A0\u60DF\u6108\u6109\u63C4\u6538\u6709\uF9C8\u67D4\u67DA\uF9C9\u6961\u6962\u6CB9\u6D27\uF9CA\u6E38\uF9CB\uFFFD".split("");
    for(j = 0; j != D[234].length; ++j)if (D[234][j].charCodeAt(0) !== 0xFFFD) {
        e[D[234][j]] = 59904 + j;
        d[59904 + j] = D[234][j];
    }
    D[235] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6FE1\u7336\u7337\uF9CC\u745C\u7531\uF9CD\u7652\uF9CE\uF9CF\u7DAD\u81FE\u8438\u88D5\u8A98\u8ADB\u8AED\u8E30\u8E42\u904A\u903E\u907A\u9149\u91C9\u936E\uF9D0\uF9D1\u5809\uF9D2\u6BD3\u8089\u80B2\uF9D3\uF9D4\u5141\u596B\u5C39\uF9D5\uF9D6\u6F64\u73A7\u80E4\u8D07\uF9D7\u9217\u958F\uF9D8\uF9D9\uF9DA\uF9DB\u807F\u620E\u701C\u7D68\u878D\uF9DC\u57A0\u6069\u6147\u6BB7\u8ABE\u9280\u96B1\u4E59\u541F\u6DEB\u852D\u9670\u97F3\u98EE\u63D6\u6CE3\u9091\u51DD\u61C9\u81BA\u9DF9\u4F9D\u501A\u5100\u5B9C\u610F\u61FF\u64EC\u6905\u6BC5\u7591\u77E3\u7FA9\u8264\u858F\u87FB\u8863\u8ABC\uFFFD".split("");
    for(j = 0; j != D[235].length; ++j)if (D[235][j].charCodeAt(0) !== 0xFFFD) {
        e[D[235][j]] = 60160 + j;
        d[60160 + j] = D[235][j];
    }
    D[236] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8B70\u91AB\u4E8C\u4EE5\u4F0A\uF9DD\uF9DE\u5937\u59E8\uF9DF\u5DF2\u5F1B\u5F5B\u6021\uF9E0\uF9E1\uF9E2\uF9E3\u723E\u73E5\uF9E4\u7570\u75CD\uF9E5\u79FB\uF9E6\u800C\u8033\u8084\u82E1\u8351\uF9E7\uF9E8\u8CBD\u8CB3\u9087\uF9E9\uF9EA\u98F4\u990C\uF9EB\uF9EC\u7037\u76CA\u7FCA\u7FCC\u7FFC\u8B1A\u4EBA\u4EC1\u5203\u5370\uF9ED\u54BD\u56E0\u59FB\u5BC5\u5F15\u5FCD\u6E6E\uF9EE\uF9EF\u7D6A\u8335\uF9F0\u8693\u8A8D\uF9F1\u976D\u9777\uF9F2\uF9F3\u4E00\u4F5A\u4F7E\u58F9\u65E5\u6EA2\u9038\u93B0\u99B9\u4EFB\u58EC\u598A\u59D9\u6041\uF9F4\uF9F5\u7A14\uF9F6\u834F\u8CC3\u5165\u5344\uFFFD".split("");
    for(j = 0; j != D[236].length; ++j)if (D[236][j].charCodeAt(0) !== 0xFFFD) {
        e[D[236][j]] = 60416 + j;
        d[60416 + j] = D[236][j];
    }
    D[237] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uF9F7\uF9F8\uF9F9\u4ECD\u5269\u5B55\u82BF\u4ED4\u523A\u54A8\u59C9\u59FF\u5B50\u5B57\u5B5C\u6063\u6148\u6ECB\u7099\u716E\u7386\u74F7\u75B5\u78C1\u7D2B\u8005\u81EA\u8328\u8517\u85C9\u8AEE\u8CC7\u96CC\u4F5C\u52FA\u56BC\u65AB\u6628\u707C\u70B8\u7235\u7DBD\u828D\u914C\u96C0\u9D72\u5B71\u68E7\u6B98\u6F7A\u76DE\u5C91\u66AB\u6F5B\u7BB4\u7C2A\u8836\u96DC\u4E08\u4ED7\u5320\u5834\u58BB\u58EF\u596C\u5C07\u5E33\u5E84\u5F35\u638C\u66B2\u6756\u6A1F\u6AA3\u6B0C\u6F3F\u7246\uF9FA\u7350\u748B\u7AE0\u7CA7\u8178\u81DF\u81E7\u838A\u846C\u8523\u8594\u85CF\u88DD\u8D13\u91AC\u9577\uFFFD".split("");
    for(j = 0; j != D[237].length; ++j)if (D[237][j].charCodeAt(0) !== 0xFFFD) {
        e[D[237][j]] = 60672 + j;
        d[60672 + j] = D[237][j];
    }
    D[238] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u969C\u518D\u54C9\u5728\u5BB0\u624D\u6750\u683D\u6893\u6E3D\u6ED3\u707D\u7E21\u88C1\u8CA1\u8F09\u9F4B\u9F4E\u722D\u7B8F\u8ACD\u931A\u4F47\u4F4E\u5132\u5480\u59D0\u5E95\u62B5\u6775\u696E\u6A17\u6CAE\u6E1A\u72D9\u732A\u75BD\u7BB8\u7D35\u82E7\u83F9\u8457\u85F7\u8A5B\u8CAF\u8E87\u9019\u90B8\u96CE\u9F5F\u52E3\u540A\u5AE1\u5BC2\u6458\u6575\u6EF4\u72C4\uF9FB\u7684\u7A4D\u7B1B\u7C4D\u7E3E\u7FDF\u837B\u8B2B\u8CCA\u8D64\u8DE1\u8E5F\u8FEA\u8FF9\u9069\u93D1\u4F43\u4F7A\u50B3\u5168\u5178\u524D\u526A\u5861\u587C\u5960\u5C08\u5C55\u5EDB\u609B\u6230\u6813\u6BBF\u6C08\u6FB1\uFFFD".split("");
    for(j = 0; j != D[238].length; ++j)if (D[238][j].charCodeAt(0) !== 0xFFFD) {
        e[D[238][j]] = 60928 + j;
        d[60928 + j] = D[238][j];
    }
    D[239] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u714E\u7420\u7530\u7538\u7551\u7672\u7B4C\u7B8B\u7BAD\u7BC6\u7E8F\u8A6E\u8F3E\u8F49\u923F\u9293\u9322\u942B\u96FB\u985A\u986B\u991E\u5207\u622A\u6298\u6D59\u7664\u7ACA\u7BC0\u7D76\u5360\u5CBE\u5E97\u6F38\u70B9\u7C98\u9711\u9B8E\u9EDE\u63A5\u647A\u8776\u4E01\u4E95\u4EAD\u505C\u5075\u5448\u59C3\u5B9A\u5E40\u5EAD\u5EF7\u5F81\u60C5\u633A\u653F\u6574\u65CC\u6676\u6678\u67FE\u6968\u6A89\u6B63\u6C40\u6DC0\u6DE8\u6E1F\u6E5E\u701E\u70A1\u738E\u73FD\u753A\u775B\u7887\u798E\u7A0B\u7A7D\u7CBE\u7D8E\u8247\u8A02\u8AEA\u8C9E\u912D\u914A\u91D8\u9266\u92CC\u9320\u9706\u9756\uFFFD".split("");
    for(j = 0; j != D[239].length; ++j)if (D[239][j].charCodeAt(0) !== 0xFFFD) {
        e[D[239][j]] = 61184 + j;
        d[61184 + j] = D[239][j];
    }
    D[240] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u975C\u9802\u9F0E\u5236\u5291\u557C\u5824\u5E1D\u5F1F\u608C\u63D0\u68AF\u6FDF\u796D\u7B2C\u81CD\u85BA\u88FD\u8AF8\u8E44\u918D\u9664\u969B\u973D\u984C\u9F4A\u4FCE\u5146\u51CB\u52A9\u5632\u5F14\u5F6B\u63AA\u64CD\u65E9\u6641\u66FA\u66F9\u671D\u689D\u68D7\u69FD\u6F15\u6F6E\u7167\u71E5\u722A\u74AA\u773A\u7956\u795A\u79DF\u7A20\u7A95\u7C97\u7CDF\u7D44\u7E70\u8087\u85FB\u86A4\u8A54\u8ABF\u8D99\u8E81\u9020\u906D\u91E3\u963B\u96D5\u9CE5\u65CF\u7C07\u8DB3\u93C3\u5B58\u5C0A\u5352\u62D9\u731D\u5027\u5B97\u5F9E\u60B0\u616B\u68D5\u6DD9\u742E\u7A2E\u7D42\u7D9C\u7E31\u816B\uFFFD".split("");
    for(j = 0; j != D[240].length; ++j)if (D[240][j].charCodeAt(0) !== 0xFFFD) {
        e[D[240][j]] = 61440 + j;
        d[61440 + j] = D[240][j];
    }
    D[241] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8E2A\u8E35\u937E\u9418\u4F50\u5750\u5DE6\u5EA7\u632B\u7F6A\u4E3B\u4F4F\u4F8F\u505A\u59DD\u80C4\u546A\u5468\u55FE\u594F\u5B99\u5DDE\u5EDA\u665D\u6731\u67F1\u682A\u6CE8\u6D32\u6E4A\u6F8D\u70B7\u73E0\u7587\u7C4C\u7D02\u7D2C\u7DA2\u821F\u86DB\u8A3B\u8A85\u8D70\u8E8A\u8F33\u9031\u914E\u9152\u9444\u99D0\u7AF9\u7CA5\u4FCA\u5101\u51C6\u57C8\u5BEF\u5CFB\u6659\u6A3D\u6D5A\u6E96\u6FEC\u710C\u756F\u7AE3\u8822\u9021\u9075\u96CB\u99FF\u8301\u4E2D\u4EF2\u8846\u91CD\u537D\u6ADB\u696B\u6C41\u847A\u589E\u618E\u66FE\u62EF\u70DD\u7511\u75C7\u7E52\u84B8\u8B49\u8D08\u4E4B\u53EA\uFFFD".split("");
    for(j = 0; j != D[241].length; ++j)if (D[241][j].charCodeAt(0) !== 0xFFFD) {
        e[D[241][j]] = 61696 + j;
        d[61696 + j] = D[241][j];
    }
    D[242] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u54AB\u5730\u5740\u5FD7\u6301\u6307\u646F\u652F\u65E8\u667A\u679D\u67B3\u6B62\u6C60\u6C9A\u6F2C\u77E5\u7825\u7949\u7957\u7D19\u80A2\u8102\u81F3\u829D\u82B7\u8718\u8A8C\uF9FC\u8D04\u8DBE\u9072\u76F4\u7A19\u7A37\u7E54\u8077\u5507\u55D4\u5875\u632F\u6422\u6649\u664B\u686D\u699B\u6B84\u6D25\u6EB1\u73CD\u7468\u74A1\u755B\u75B9\u76E1\u771E\u778B\u79E6\u7E09\u7E1D\u81FB\u852F\u8897\u8A3A\u8CD1\u8EEB\u8FB0\u9032\u93AD\u9663\u9673\u9707\u4F84\u53F1\u59EA\u5AC9\u5E19\u684E\u74C6\u75BE\u79E9\u7A92\u81A3\u86ED\u8CEA\u8DCC\u8FED\u659F\u6715\uF9FD\u57F7\u6F57\u7DDD\u8F2F\uFFFD".split("");
    for(j = 0; j != D[242].length; ++j)if (D[242][j].charCodeAt(0) !== 0xFFFD) {
        e[D[242][j]] = 61952 + j;
        d[61952 + j] = D[242][j];
    }
    D[243] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u93F6\u96C6\u5FB5\u61F2\u6F84\u4E14\u4F98\u501F\u53C9\u55DF\u5D6F\u5DEE\u6B21\u6B64\u78CB\u7B9A\uF9FE\u8E49\u8ECA\u906E\u6349\u643E\u7740\u7A84\u932F\u947F\u9F6A\u64B0\u6FAF\u71E6\u74A8\u74DA\u7AC4\u7C12\u7E82\u7CB2\u7E98\u8B9A\u8D0A\u947D\u9910\u994C\u5239\u5BDF\u64E6\u672D\u7D2E\u50ED\u53C3\u5879\u6158\u6159\u61FA\u65AC\u7AD9\u8B92\u8B96\u5009\u5021\u5275\u5531\u5A3C\u5EE0\u5F70\u6134\u655E\u660C\u6636\u66A2\u69CD\u6EC4\u6F32\u7316\u7621\u7A93\u8139\u8259\u83D6\u84BC\u50B5\u57F0\u5BC0\u5BE8\u5F69\u63A1\u7826\u7DB5\u83DC\u8521\u91C7\u91F5\u518A\u67F5\u7B56\uFFFD".split("");
    for(j = 0; j != D[243].length; ++j)if (D[243][j].charCodeAt(0) !== 0xFFFD) {
        e[D[243][j]] = 62208 + j;
        d[62208 + j] = D[243][j];
    }
    D[244] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8CAC\u51C4\u59BB\u60BD\u8655\u501C\uF9FF\u5254\u5C3A\u617D\u621A\u62D3\u64F2\u65A5\u6ECC\u7620\u810A\u8E60\u965F\u96BB\u4EDF\u5343\u5598\u5929\u5DDD\u64C5\u6CC9\u6DFA\u7394\u7A7F\u821B\u85A6\u8CE4\u8E10\u9077\u91E7\u95E1\u9621\u97C6\u51F8\u54F2\u5586\u5FB9\u64A4\u6F88\u7DB4\u8F1F\u8F4D\u9435\u50C9\u5C16\u6CBE\u6DFB\u751B\u77BB\u7C3D\u7C64\u8A79\u8AC2\u581E\u59BE\u5E16\u6377\u7252\u758A\u776B\u8ADC\u8CBC\u8F12\u5EF3\u6674\u6DF8\u807D\u83C1\u8ACB\u9751\u9BD6\uFA00\u5243\u66FF\u6D95\u6EEF\u7DE0\u8AE6\u902E\u905E\u9AD4\u521D\u527F\u54E8\u6194\u6284\u62DB\u68A2\uFFFD".split("");
    for(j = 0; j != D[244].length; ++j)if (D[244][j].charCodeAt(0) !== 0xFFFD) {
        e[D[244][j]] = 62464 + j;
        d[62464 + j] = D[244][j];
    }
    D[245] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6912\u695A\u6A35\u7092\u7126\u785D\u7901\u790E\u79D2\u7A0D\u8096\u8278\u82D5\u8349\u8549\u8C82\u8D85\u9162\u918B\u91AE\u4FC3\u56D1\u71ED\u77D7\u8700\u89F8\u5BF8\u5FD6\u6751\u90A8\u53E2\u585A\u5BF5\u60A4\u6181\u6460\u7E3D\u8070\u8525\u9283\u64AE\u50AC\u5D14\u6700\u589C\u62BD\u63A8\u690E\u6978\u6A1E\u6E6B\u76BA\u79CB\u82BB\u8429\u8ACF\u8DA8\u8FFD\u9112\u914B\u919C\u9310\u9318\u939A\u96DB\u9A36\u9C0D\u4E11\u755C\u795D\u7AFA\u7B51\u7BC9\u7E2E\u84C4\u8E59\u8E74\u8EF8\u9010\u6625\u693F\u7443\u51FA\u672E\u9EDC\u5145\u5FE0\u6C96\u87F2\u885D\u8877\u60B4\u81B5\u8403\uFFFD".split("");
    for(j = 0; j != D[245].length; ++j)if (D[245][j].charCodeAt(0) !== 0xFFFD) {
        e[D[245][j]] = 62720 + j;
        d[62720 + j] = D[245][j];
    }
    D[246] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8D05\u53D6\u5439\u5634\u5A36\u5C31\u708A\u7FE0\u805A\u8106\u81ED\u8DA3\u9189\u9A5F\u9DF2\u5074\u4EC4\u53A0\u60FB\u6E2C\u5C64\u4F88\u5024\u55E4\u5CD9\u5E5F\u6065\u6894\u6CBB\u6DC4\u71BE\u75D4\u75F4\u7661\u7A1A\u7A49\u7DC7\u7DFB\u7F6E\u81F4\u86A9\u8F1C\u96C9\u99B3\u9F52\u5247\u52C5\u98ED\u89AA\u4E03\u67D2\u6F06\u4FB5\u5BE2\u6795\u6C88\u6D78\u741B\u7827\u91DD\u937C\u87C4\u79E4\u7A31\u5FEB\u4ED6\u54A4\u553E\u58AE\u59A5\u60F0\u6253\u62D6\u6736\u6955\u8235\u9640\u99B1\u99DD\u502C\u5353\u5544\u577C\uFA01\u6258\uFA02\u64E2\u666B\u67DD\u6FC1\u6FEF\u7422\u7438\u8A17\uFFFD".split("");
    for(j = 0; j != D[246].length; ++j)if (D[246][j].charCodeAt(0) !== 0xFFFD) {
        e[D[246][j]] = 62976 + j;
        d[62976 + j] = D[246][j];
    }
    D[247] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9438\u5451\u5606\u5766\u5F48\u619A\u6B4E\u7058\u70AD\u7DBB\u8A95\u596A\u812B\u63A2\u7708\u803D\u8CAA\u5854\u642D\u69BB\u5B95\u5E11\u6E6F\uFA03\u8569\u514C\u53F0\u592A\u6020\u614B\u6B86\u6C70\u6CF0\u7B1E\u80CE\u82D4\u8DC6\u90B0\u98B1\uFA04\u64C7\u6FA4\u6491\u6504\u514E\u5410\u571F\u8A0E\u615F\u6876\uFA05\u75DB\u7B52\u7D71\u901A\u5806\u69CC\u817F\u892A\u9000\u9839\u5078\u5957\u59AC\u6295\u900F\u9B2A\u615D\u7279\u95D6\u5761\u5A46\u5DF4\u628A\u64AD\u64FA\u6777\u6CE2\u6D3E\u722C\u7436\u7834\u7F77\u82AD\u8DDB\u9817\u5224\u5742\u677F\u7248\u74E3\u8CA9\u8FA6\u9211\uFFFD".split("");
    for(j = 0; j != D[247].length; ++j)if (D[247][j].charCodeAt(0) !== 0xFFFD) {
        e[D[247][j]] = 63232 + j;
        d[63232 + j] = D[247][j];
    }
    D[248] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u962A\u516B\u53ED\u634C\u4F69\u5504\u6096\u6557\u6C9B\u6D7F\u724C\u72FD\u7A17\u8987\u8C9D\u5F6D\u6F8E\u70F9\u81A8\u610E\u4FBF\u504F\u6241\u7247\u7BC7\u7DE8\u7FE9\u904D\u97AD\u9A19\u8CB6\u576A\u5E73\u67B0\u840D\u8A55\u5420\u5B16\u5E63\u5EE2\u5F0A\u6583\u80BA\u853D\u9589\u965B\u4F48\u5305\u530D\u530F\u5486\u54FA\u5703\u5E03\u6016\u629B\u62B1\u6355\uFA06\u6CE1\u6D66\u75B1\u7832\u80DE\u812F\u82DE\u8461\u84B2\u888D\u8912\u900B\u92EA\u98FD\u9B91\u5E45\u66B4\u66DD\u7011\u7206\uFA07\u4FF5\u527D\u5F6A\u6153\u6753\u6A19\u6F02\u74E2\u7968\u8868\u8C79\u98C7\u98C4\u9A43\uFFFD".split("");
    for(j = 0; j != D[248].length; ++j)if (D[248][j].charCodeAt(0) !== 0xFFFD) {
        e[D[248][j]] = 63488 + j;
        d[63488 + j] = D[248][j];
    }
    D[249] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u54C1\u7A1F\u6953\u8AF7\u8C4A\u98A8\u99AE\u5F7C\u62AB\u75B2\u76AE\u88AB\u907F\u9642\u5339\u5F3C\u5FC5\u6CCC\u73CC\u7562\u758B\u7B46\u82FE\u999D\u4E4F\u903C\u4E0B\u4F55\u53A6\u590F\u5EC8\u6630\u6CB3\u7455\u8377\u8766\u8CC0\u9050\u971E\u9C15\u58D1\u5B78\u8650\u8B14\u9DB4\u5BD2\u6068\u608D\u65F1\u6C57\u6F22\u6FA3\u701A\u7F55\u7FF0\u9591\u9592\u9650\u97D3\u5272\u8F44\u51FD\u542B\u54B8\u5563\u558A\u6ABB\u6DB5\u7DD8\u8266\u929C\u9677\u9E79\u5408\u54C8\u76D2\u86E4\u95A4\u95D4\u965C\u4EA2\u4F09\u59EE\u5AE6\u5DF7\u6052\u6297\u676D\u6841\u6C86\u6E2F\u7F38\u809B\u822A\uFFFD".split("");
    for(j = 0; j != D[249].length; ++j)if (D[249][j].charCodeAt(0) !== 0xFFFD) {
        e[D[249][j]] = 63744 + j;
        d[63744 + j] = D[249][j];
    }
    D[250] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFA08\uFA09\u9805\u4EA5\u5055\u54B3\u5793\u595A\u5B69\u5BB3\u61C8\u6977\u6D77\u7023\u87F9\u89E3\u8A72\u8AE7\u9082\u99ED\u9AB8\u52BE\u6838\u5016\u5E78\u674F\u8347\u884C\u4EAB\u5411\u56AE\u73E6\u9115\u97FF\u9909\u9957\u9999\u5653\u589F\u865B\u8A31\u61B2\u6AF6\u737B\u8ED2\u6B47\u96AA\u9A57\u5955\u7200\u8D6B\u9769\u4FD4\u5CF4\u5F26\u61F8\u665B\u6CEB\u70AB\u7384\u73B9\u73FE\u7729\u774D\u7D43\u7D62\u7E23\u8237\u8852\uFA0A\u8CE2\u9249\u986F\u5B51\u7A74\u8840\u9801\u5ACC\u4FE0\u5354\u593E\u5CFD\u633E\u6D79\u72F9\u8105\u8107\u83A2\u92CF\u9830\u4EA8\u5144\u5211\u578B\uFFFD".split("");
    for(j = 0; j != D[250].length; ++j)if (D[250][j].charCodeAt(0) !== 0xFFFD) {
        e[D[250][j]] = 64000 + j;
        d[64000 + j] = D[250][j];
    }
    D[251] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5F62\u6CC2\u6ECE\u7005\u7050\u70AF\u7192\u73E9\u7469\u834A\u87A2\u8861\u9008\u90A2\u93A3\u99A8\u516E\u5F57\u60E0\u6167\u66B3\u8559\u8E4A\u91AF\u978B\u4E4E\u4E92\u547C\u58D5\u58FA\u597D\u5CB5\u5F27\u6236\u6248\u660A\u6667\u6BEB\u6D69\u6DCF\u6E56\u6EF8\u6F94\u6FE0\u6FE9\u705D\u72D0\u7425\u745A\u74E0\u7693\u795C\u7CCA\u7E1E\u80E1\u82A6\u846B\u84BF\u864E\u865F\u8774\u8B77\u8C6A\u93AC\u9800\u9865\u60D1\u6216\u9177\u5A5A\u660F\u6DF7\u6E3E\u743F\u9B42\u5FFD\u60DA\u7B0F\u54C4\u5F18\u6C5E\u6CD3\u6D2A\u70D8\u7D05\u8679\u8A0C\u9D3B\u5316\u548C\u5B05\u6A3A\u706B\u7575\uFFFD".split("");
    for(j = 0; j != D[251].length; ++j)if (D[251][j].charCodeAt(0) !== 0xFFFD) {
        e[D[251][j]] = 64256 + j;
        d[64256 + j] = D[251][j];
    }
    D[252] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u798D\u79BE\u82B1\u83EF\u8A71\u8B41\u8CA8\u9774\uFA0B\u64F4\u652B\u78BA\u78BB\u7A6B\u4E38\u559A\u5950\u5BA6\u5E7B\u60A3\u63DB\u6B61\u6665\u6853\u6E19\u7165\u74B0\u7D08\u9084\u9A69\u9C25\u6D3B\u6ED1\u733E\u8C41\u95CA\u51F0\u5E4C\u5FA8\u604D\u60F6\u6130\u614C\u6643\u6644\u69A5\u6CC1\u6E5F\u6EC9\u6F62\u714C\u749C\u7687\u7BC1\u7C27\u8352\u8757\u9051\u968D\u9EC3\u532F\u56DE\u5EFB\u5F8A\u6062\u6094\u61F7\u6666\u6703\u6A9C\u6DEE\u6FAE\u7070\u736A\u7E6A\u81BE\u8334\u86D4\u8AA8\u8CC4\u5283\u7372\u5B96\u6A6B\u9404\u54EE\u5686\u5B5D\u6548\u6585\u66C9\u689F\u6D8D\u6DC6\uFFFD".split("");
    for(j = 0; j != D[252].length; ++j)if (D[252][j].charCodeAt(0) !== 0xFFFD) {
        e[D[252][j]] = 64512 + j;
        d[64512 + j] = D[252][j];
    }
    D[253] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u723B\u80B4\u9175\u9A4D\u4FAF\u5019\u539A\u540E\u543C\u5589\u55C5\u5E3F\u5F8C\u673D\u7166\u73DD\u9005\u52DB\u52F3\u5864\u58CE\u7104\u718F\u71FB\u85B0\u8A13\u6688\u85A8\u55A7\u6684\u714A\u8431\u5349\u5599\u6BC1\u5F59\u5FBD\u63EE\u6689\u7147\u8AF1\u8F1D\u9EBE\u4F11\u643A\u70CB\u7566\u8667\u6064\u8B4E\u9DF8\u5147\u51F6\u5308\u6D36\u80F8\u9ED1\u6615\u6B23\u7098\u75D5\u5403\u5C79\u7D07\u8A16\u6B20\u6B3D\u6B46\u5438\u6070\u6D3D\u7FD5\u8208\u50D6\u51DE\u559C\u566B\u56CD\u59EC\u5B09\u5E0C\u6199\u6198\u6231\u665E\u66E6\u7199\u71B9\u71BA\u72A7\u79A7\u7A00\u7FB2\u8A70\uFFFD".split("");
    for(j = 0; j != D[253].length; ++j)if (D[253][j].charCodeAt(0) !== 0xFFFD) {
        e[D[253][j]] = 64768 + j;
        d[64768 + j] = D[253][j];
    }
    return {
        "enc": e,
        "dec": d
    };
}();
$e1f740a9d01acc72$var$cptable[950] = function() {
    var d = [], e = {}, D = [], j;
    D[0] = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[0].length; ++j)if (D[0][j].charCodeAt(0) !== 0xFFFD) {
        e[D[0][j]] = 0 + j;
        d[0 + j] = D[0][j];
    }
    D[161] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u3000\uFF0C\u3001\u3002\uFF0E\u2027\uFF1B\uFF1A\uFF1F\uFF01\uFE30\u2026\u2025\uFE50\uFE51\uFE52\xb7\uFE54\uFE55\uFE56\uFE57\uFF5C\u2013\uFE31\u2014\uFE33\u2574\uFE34\uFE4F\uFF08\uFF09\uFE35\uFE36\uFF5B\uFF5D\uFE37\uFE38\u3014\u3015\uFE39\uFE3A\u3010\u3011\uFE3B\uFE3C\u300A\u300B\uFE3D\uFE3E\u3008\u3009\uFE3F\uFE40\u300C\u300D\uFE41\uFE42\u300E\u300F\uFE43\uFE44\uFE59\uFE5A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFE5B\uFE5C\uFE5D\uFE5E\u2018\u2019\u201C\u201D\u301D\u301E\u2035\u2032\uFF03\uFF06\uFF0A\u203B\xa7\u3003\u25CB\u25CF\u25B3\u25B2\u25CE\u2606\u2605\u25C7\u25C6\u25A1\u25A0\u25BD\u25BC\u32A3\u2105\xaf\uFFE3\uFF3F\u02CD\uFE49\uFE4A\uFE4D\uFE4E\uFE4B\uFE4C\uFE5F\uFE60\uFE61\uFF0B\uFF0D\xd7\xf7\xb1\u221A\uFF1C\uFF1E\uFF1D\u2266\u2267\u2260\u221E\u2252\u2261\uFE62\uFE63\uFE64\uFE65\uFE66\uFF5E\u2229\u222A\u22A5\u2220\u221F\u22BF\u33D2\u33D1\u222B\u222E\u2235\u2234\u2640\u2642\u2295\u2299\u2191\u2193\u2190\u2192\u2196\u2197\u2199\u2198\u2225\u2223\uFF0F\uFFFD".split("");
    for(j = 0; j != D[161].length; ++j)if (D[161][j].charCodeAt(0) !== 0xFFFD) {
        e[D[161][j]] = 41216 + j;
        d[41216 + j] = D[161][j];
    }
    D[162] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFF3C\u2215\uFE68\uFF04\uFFE5\u3012\uFFE0\uFFE1\uFF05\uFF20\u2103\u2109\uFE69\uFE6A\uFE6B\u33D5\u339C\u339D\u339E\u33CE\u33A1\u338E\u338F\u33C4\xb0\u5159\u515B\u515E\u515D\u5161\u5163\u55E7\u74E9\u7CCE\u2581\u2582\u2583\u2584\u2585\u2586\u2587\u2588\u258F\u258E\u258D\u258C\u258B\u258A\u2589\u253C\u2534\u252C\u2524\u251C\u2594\u2500\u2502\u2595\u250C\u2510\u2514\u2518\u256D\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u256E\u2570\u256F\u2550\u255E\u256A\u2561\u25E2\u25E3\u25E5\u25E4\u2571\u2572\u2573\uFF10\uFF11\uFF12\uFF13\uFF14\uFF15\uFF16\uFF17\uFF18\uFF19\u2160\u2161\u2162\u2163\u2164\u2165\u2166\u2167\u2168\u2169\u3021\u3022\u3023\u3024\u3025\u3026\u3027\u3028\u3029\u5341\u5344\u5345\uFF21\uFF22\uFF23\uFF24\uFF25\uFF26\uFF27\uFF28\uFF29\uFF2A\uFF2B\uFF2C\uFF2D\uFF2E\uFF2F\uFF30\uFF31\uFF32\uFF33\uFF34\uFF35\uFF36\uFF37\uFF38\uFF39\uFF3A\uFF41\uFF42\uFF43\uFF44\uFF45\uFF46\uFF47\uFF48\uFF49\uFF4A\uFF4B\uFF4C\uFF4D\uFF4E\uFF4F\uFF50\uFF51\uFF52\uFF53\uFF54\uFF55\uFF56\uFFFD".split("");
    for(j = 0; j != D[162].length; ++j)if (D[162][j].charCodeAt(0) !== 0xFFFD) {
        e[D[162][j]] = 41472 + j;
        d[41472 + j] = D[162][j];
    }
    D[163] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFF57\uFF58\uFF59\uFF5A\u0391\u0392\u0393\u0394\u0395\u0396\u0397\u0398\u0399\u039A\u039B\u039C\u039D\u039E\u039F\u03A0\u03A1\u03A3\u03A4\u03A5\u03A6\u03A7\u03A8\u03A9\u03B1\u03B2\u03B3\u03B4\u03B5\u03B6\u03B7\u03B8\u03B9\u03BA\u03BB\u03BC\u03BD\u03BE\u03BF\u03C0\u03C1\u03C3\u03C4\u03C5\u03C6\u03C7\u03C8\u03C9\u3105\u3106\u3107\u3108\u3109\u310A\u310B\u310C\u310D\u310E\u310F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u3110\u3111\u3112\u3113\u3114\u3115\u3116\u3117\u3118\u3119\u311A\u311B\u311C\u311D\u311E\u311F\u3120\u3121\u3122\u3123\u3124\u3125\u3126\u3127\u3128\u3129\u02D9\u02C9\u02CA\u02C7\u02CB\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u20AC\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[163].length; ++j)if (D[163][j].charCodeAt(0) !== 0xFFFD) {
        e[D[163][j]] = 41728 + j;
        d[41728 + j] = D[163][j];
    }
    D[164] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u4E00\u4E59\u4E01\u4E03\u4E43\u4E5D\u4E86\u4E8C\u4EBA\u513F\u5165\u516B\u51E0\u5200\u5201\u529B\u5315\u5341\u535C\u53C8\u4E09\u4E0B\u4E08\u4E0A\u4E2B\u4E38\u51E1\u4E45\u4E48\u4E5F\u4E5E\u4E8E\u4EA1\u5140\u5203\u52FA\u5343\u53C9\u53E3\u571F\u58EB\u5915\u5927\u5973\u5B50\u5B51\u5B53\u5BF8\u5C0F\u5C22\u5C38\u5C71\u5DDD\u5DE5\u5DF1\u5DF2\u5DF3\u5DFE\u5E72\u5EFE\u5F0B\u5F13\u624D\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u4E11\u4E10\u4E0D\u4E2D\u4E30\u4E39\u4E4B\u5C39\u4E88\u4E91\u4E95\u4E92\u4E94\u4EA2\u4EC1\u4EC0\u4EC3\u4EC6\u4EC7\u4ECD\u4ECA\u4ECB\u4EC4\u5143\u5141\u5167\u516D\u516E\u516C\u5197\u51F6\u5206\u5207\u5208\u52FB\u52FE\u52FF\u5316\u5339\u5348\u5347\u5345\u535E\u5384\u53CB\u53CA\u53CD\u58EC\u5929\u592B\u592A\u592D\u5B54\u5C11\u5C24\u5C3A\u5C6F\u5DF4\u5E7B\u5EFF\u5F14\u5F15\u5FC3\u6208\u6236\u624B\u624E\u652F\u6587\u6597\u65A4\u65B9\u65E5\u66F0\u6708\u6728\u6B20\u6B62\u6B79\u6BCB\u6BD4\u6BDB\u6C0F\u6C34\u706B\u722A\u7236\u723B\u7247\u7259\u725B\u72AC\u738B\u4E19\uFFFD".split("");
    for(j = 0; j != D[164].length; ++j)if (D[164][j].charCodeAt(0) !== 0xFFFD) {
        e[D[164][j]] = 41984 + j;
        d[41984 + j] = D[164][j];
    }
    D[165] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u4E16\u4E15\u4E14\u4E18\u4E3B\u4E4D\u4E4F\u4E4E\u4EE5\u4ED8\u4ED4\u4ED5\u4ED6\u4ED7\u4EE3\u4EE4\u4ED9\u4EDE\u5145\u5144\u5189\u518A\u51AC\u51F9\u51FA\u51F8\u520A\u52A0\u529F\u5305\u5306\u5317\u531D\u4EDF\u534A\u5349\u5361\u5360\u536F\u536E\u53BB\u53EF\u53E4\u53F3\u53EC\u53EE\u53E9\u53E8\u53FC\u53F8\u53F5\u53EB\u53E6\u53EA\u53F2\u53F1\u53F0\u53E5\u53ED\u53FB\u56DB\u56DA\u5916\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u592E\u5931\u5974\u5976\u5B55\u5B83\u5C3C\u5DE8\u5DE7\u5DE6\u5E02\u5E03\u5E73\u5E7C\u5F01\u5F18\u5F17\u5FC5\u620A\u6253\u6254\u6252\u6251\u65A5\u65E6\u672E\u672C\u672A\u672B\u672D\u6B63\u6BCD\u6C11\u6C10\u6C38\u6C41\u6C40\u6C3E\u72AF\u7384\u7389\u74DC\u74E6\u7518\u751F\u7528\u7529\u7530\u7531\u7532\u7533\u758B\u767D\u76AE\u76BF\u76EE\u77DB\u77E2\u77F3\u793A\u79BE\u7A74\u7ACB\u4E1E\u4E1F\u4E52\u4E53\u4E69\u4E99\u4EA4\u4EA6\u4EA5\u4EFF\u4F09\u4F19\u4F0A\u4F15\u4F0D\u4F10\u4F11\u4F0F\u4EF2\u4EF6\u4EFB\u4EF0\u4EF3\u4EFD\u4F01\u4F0B\u5149\u5147\u5146\u5148\u5168\uFFFD".split("");
    for(j = 0; j != D[165].length; ++j)if (D[165][j].charCodeAt(0) !== 0xFFFD) {
        e[D[165][j]] = 42240 + j;
        d[42240 + j] = D[165][j];
    }
    D[166] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5171\u518D\u51B0\u5217\u5211\u5212\u520E\u5216\u52A3\u5308\u5321\u5320\u5370\u5371\u5409\u540F\u540C\u540A\u5410\u5401\u540B\u5404\u5411\u540D\u5408\u5403\u540E\u5406\u5412\u56E0\u56DE\u56DD\u5733\u5730\u5728\u572D\u572C\u572F\u5729\u5919\u591A\u5937\u5938\u5984\u5978\u5983\u597D\u5979\u5982\u5981\u5B57\u5B58\u5B87\u5B88\u5B85\u5B89\u5BFA\u5C16\u5C79\u5DDE\u5E06\u5E76\u5E74\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5F0F\u5F1B\u5FD9\u5FD6\u620E\u620C\u620D\u6210\u6263\u625B\u6258\u6536\u65E9\u65E8\u65EC\u65ED\u66F2\u66F3\u6709\u673D\u6734\u6731\u6735\u6B21\u6B64\u6B7B\u6C16\u6C5D\u6C57\u6C59\u6C5F\u6C60\u6C50\u6C55\u6C61\u6C5B\u6C4D\u6C4E\u7070\u725F\u725D\u767E\u7AF9\u7C73\u7CF8\u7F36\u7F8A\u7FBD\u8001\u8003\u800C\u8012\u8033\u807F\u8089\u808B\u808C\u81E3\u81EA\u81F3\u81FC\u820C\u821B\u821F\u826E\u8272\u827E\u866B\u8840\u884C\u8863\u897F\u9621\u4E32\u4EA8\u4F4D\u4F4F\u4F47\u4F57\u4F5E\u4F34\u4F5B\u4F55\u4F30\u4F50\u4F51\u4F3D\u4F3A\u4F38\u4F43\u4F54\u4F3C\u4F46\u4F63\uFFFD".split("");
    for(j = 0; j != D[166].length; ++j)if (D[166][j].charCodeAt(0) !== 0xFFFD) {
        e[D[166][j]] = 42496 + j;
        d[42496 + j] = D[166][j];
    }
    D[167] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u4F5C\u4F60\u4F2F\u4F4E\u4F36\u4F59\u4F5D\u4F48\u4F5A\u514C\u514B\u514D\u5175\u51B6\u51B7\u5225\u5224\u5229\u522A\u5228\u52AB\u52A9\u52AA\u52AC\u5323\u5373\u5375\u541D\u542D\u541E\u543E\u5426\u544E\u5427\u5446\u5443\u5433\u5448\u5442\u541B\u5429\u544A\u5439\u543B\u5438\u542E\u5435\u5436\u5420\u543C\u5440\u5431\u542B\u541F\u542C\u56EA\u56F0\u56E4\u56EB\u574A\u5751\u5740\u574D\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5747\u574E\u573E\u5750\u574F\u573B\u58EF\u593E\u599D\u5992\u59A8\u599E\u59A3\u5999\u5996\u598D\u59A4\u5993\u598A\u59A5\u5B5D\u5B5C\u5B5A\u5B5B\u5B8C\u5B8B\u5B8F\u5C2C\u5C40\u5C41\u5C3F\u5C3E\u5C90\u5C91\u5C94\u5C8C\u5DEB\u5E0C\u5E8F\u5E87\u5E8A\u5EF7\u5F04\u5F1F\u5F64\u5F62\u5F77\u5F79\u5FD8\u5FCC\u5FD7\u5FCD\u5FF1\u5FEB\u5FF8\u5FEA\u6212\u6211\u6284\u6297\u6296\u6280\u6276\u6289\u626D\u628A\u627C\u627E\u6279\u6273\u6292\u626F\u6298\u626E\u6295\u6293\u6291\u6286\u6539\u653B\u6538\u65F1\u66F4\u675F\u674E\u674F\u6750\u6751\u675C\u6756\u675E\u6749\u6746\u6760\uFFFD".split("");
    for(j = 0; j != D[167].length; ++j)if (D[167][j].charCodeAt(0) !== 0xFFFD) {
        e[D[167][j]] = 42752 + j;
        d[42752 + j] = D[167][j];
    }
    D[168] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6753\u6757\u6B65\u6BCF\u6C42\u6C5E\u6C99\u6C81\u6C88\u6C89\u6C85\u6C9B\u6C6A\u6C7A\u6C90\u6C70\u6C8C\u6C68\u6C96\u6C92\u6C7D\u6C83\u6C72\u6C7E\u6C74\u6C86\u6C76\u6C8D\u6C94\u6C98\u6C82\u7076\u707C\u707D\u7078\u7262\u7261\u7260\u72C4\u72C2\u7396\u752C\u752B\u7537\u7538\u7682\u76EF\u77E3\u79C1\u79C0\u79BF\u7A76\u7CFB\u7F55\u8096\u8093\u809D\u8098\u809B\u809A\u80B2\u826F\u8292\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u828B\u828D\u898B\u89D2\u8A00\u8C37\u8C46\u8C55\u8C9D\u8D64\u8D70\u8DB3\u8EAB\u8ECA\u8F9B\u8FB0\u8FC2\u8FC6\u8FC5\u8FC4\u5DE1\u9091\u90A2\u90AA\u90A6\u90A3\u9149\u91C6\u91CC\u9632\u962E\u9631\u962A\u962C\u4E26\u4E56\u4E73\u4E8B\u4E9B\u4E9E\u4EAB\u4EAC\u4F6F\u4F9D\u4F8D\u4F73\u4F7F\u4F6C\u4F9B\u4F8B\u4F86\u4F83\u4F70\u4F75\u4F88\u4F69\u4F7B\u4F96\u4F7E\u4F8F\u4F91\u4F7A\u5154\u5152\u5155\u5169\u5177\u5176\u5178\u51BD\u51FD\u523B\u5238\u5237\u523A\u5230\u522E\u5236\u5241\u52BE\u52BB\u5352\u5354\u5353\u5351\u5366\u5377\u5378\u5379\u53D6\u53D4\u53D7\u5473\u5475\uFFFD".split("");
    for(j = 0; j != D[168].length; ++j)if (D[168][j].charCodeAt(0) !== 0xFFFD) {
        e[D[168][j]] = 43008 + j;
        d[43008 + j] = D[168][j];
    }
    D[169] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5496\u5478\u5495\u5480\u547B\u5477\u5484\u5492\u5486\u547C\u5490\u5471\u5476\u548C\u549A\u5462\u5468\u548B\u547D\u548E\u56FA\u5783\u5777\u576A\u5769\u5761\u5766\u5764\u577C\u591C\u5949\u5947\u5948\u5944\u5954\u59BE\u59BB\u59D4\u59B9\u59AE\u59D1\u59C6\u59D0\u59CD\u59CB\u59D3\u59CA\u59AF\u59B3\u59D2\u59C5\u5B5F\u5B64\u5B63\u5B97\u5B9A\u5B98\u5B9C\u5B99\u5B9B\u5C1A\u5C48\u5C45\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5C46\u5CB7\u5CA1\u5CB8\u5CA9\u5CAB\u5CB1\u5CB3\u5E18\u5E1A\u5E16\u5E15\u5E1B\u5E11\u5E78\u5E9A\u5E97\u5E9C\u5E95\u5E96\u5EF6\u5F26\u5F27\u5F29\u5F80\u5F81\u5F7F\u5F7C\u5FDD\u5FE0\u5FFD\u5FF5\u5FFF\u600F\u6014\u602F\u6035\u6016\u602A\u6015\u6021\u6027\u6029\u602B\u601B\u6216\u6215\u623F\u623E\u6240\u627F\u62C9\u62CC\u62C4\u62BF\u62C2\u62B9\u62D2\u62DB\u62AB\u62D3\u62D4\u62CB\u62C8\u62A8\u62BD\u62BC\u62D0\u62D9\u62C7\u62CD\u62B5\u62DA\u62B1\u62D8\u62D6\u62D7\u62C6\u62AC\u62CE\u653E\u65A7\u65BC\u65FA\u6614\u6613\u660C\u6606\u6602\u660E\u6600\u660F\u6615\u660A\uFFFD".split("");
    for(j = 0; j != D[169].length; ++j)if (D[169][j].charCodeAt(0) !== 0xFFFD) {
        e[D[169][j]] = 43264 + j;
        d[43264 + j] = D[169][j];
    }
    D[170] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6607\u670D\u670B\u676D\u678B\u6795\u6771\u679C\u6773\u6777\u6787\u679D\u6797\u676F\u6770\u677F\u6789\u677E\u6790\u6775\u679A\u6793\u677C\u676A\u6772\u6B23\u6B66\u6B67\u6B7F\u6C13\u6C1B\u6CE3\u6CE8\u6CF3\u6CB1\u6CCC\u6CE5\u6CB3\u6CBD\u6CBE\u6CBC\u6CE2\u6CAB\u6CD5\u6CD3\u6CB8\u6CC4\u6CB9\u6CC1\u6CAE\u6CD7\u6CC5\u6CF1\u6CBF\u6CBB\u6CE1\u6CDB\u6CCA\u6CAC\u6CEF\u6CDC\u6CD6\u6CE0\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7095\u708E\u7092\u708A\u7099\u722C\u722D\u7238\u7248\u7267\u7269\u72C0\u72CE\u72D9\u72D7\u72D0\u73A9\u73A8\u739F\u73AB\u73A5\u753D\u759D\u7599\u759A\u7684\u76C2\u76F2\u76F4\u77E5\u77FD\u793E\u7940\u7941\u79C9\u79C8\u7A7A\u7A79\u7AFA\u7CFE\u7F54\u7F8C\u7F8B\u8005\u80BA\u80A5\u80A2\u80B1\u80A1\u80AB\u80A9\u80B4\u80AA\u80AF\u81E5\u81FE\u820D\u82B3\u829D\u8299\u82AD\u82BD\u829F\u82B9\u82B1\u82AC\u82A5\u82AF\u82B8\u82A3\u82B0\u82BE\u82B7\u864E\u8671\u521D\u8868\u8ECB\u8FCE\u8FD4\u8FD1\u90B5\u90B8\u90B1\u90B6\u91C7\u91D1\u9577\u9580\u961C\u9640\u963F\u963B\u9644\uFFFD".split("");
    for(j = 0; j != D[170].length; ++j)if (D[170][j].charCodeAt(0) !== 0xFFFD) {
        e[D[170][j]] = 43520 + j;
        d[43520 + j] = D[170][j];
    }
    D[171] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9642\u96B9\u96E8\u9752\u975E\u4E9F\u4EAD\u4EAE\u4FE1\u4FB5\u4FAF\u4FBF\u4FE0\u4FD1\u4FCF\u4FDD\u4FC3\u4FB6\u4FD8\u4FDF\u4FCA\u4FD7\u4FAE\u4FD0\u4FC4\u4FC2\u4FDA\u4FCE\u4FDE\u4FB7\u5157\u5192\u5191\u51A0\u524E\u5243\u524A\u524D\u524C\u524B\u5247\u52C7\u52C9\u52C3\u52C1\u530D\u5357\u537B\u539A\u53DB\u54AC\u54C0\u54A8\u54CE\u54C9\u54B8\u54A6\u54B3\u54C7\u54C2\u54BD\u54AA\u54C1\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u54C4\u54C8\u54AF\u54AB\u54B1\u54BB\u54A9\u54A7\u54BF\u56FF\u5782\u578B\u57A0\u57A3\u57A2\u57CE\u57AE\u5793\u5955\u5951\u594F\u594E\u5950\u59DC\u59D8\u59FF\u59E3\u59E8\u5A03\u59E5\u59EA\u59DA\u59E6\u5A01\u59FB\u5B69\u5BA3\u5BA6\u5BA4\u5BA2\u5BA5\u5C01\u5C4E\u5C4F\u5C4D\u5C4B\u5CD9\u5CD2\u5DF7\u5E1D\u5E25\u5E1F\u5E7D\u5EA0\u5EA6\u5EFA\u5F08\u5F2D\u5F65\u5F88\u5F85\u5F8A\u5F8B\u5F87\u5F8C\u5F89\u6012\u601D\u6020\u6025\u600E\u6028\u604D\u6070\u6068\u6062\u6046\u6043\u606C\u606B\u606A\u6064\u6241\u62DC\u6316\u6309\u62FC\u62ED\u6301\u62EE\u62FD\u6307\u62F1\u62F7\uFFFD".split("");
    for(j = 0; j != D[171].length; ++j)if (D[171][j].charCodeAt(0) !== 0xFFFD) {
        e[D[171][j]] = 43776 + j;
        d[43776 + j] = D[171][j];
    }
    D[172] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u62EF\u62EC\u62FE\u62F4\u6311\u6302\u653F\u6545\u65AB\u65BD\u65E2\u6625\u662D\u6620\u6627\u662F\u661F\u6628\u6631\u6624\u66F7\u67FF\u67D3\u67F1\u67D4\u67D0\u67EC\u67B6\u67AF\u67F5\u67E9\u67EF\u67C4\u67D1\u67B4\u67DA\u67E5\u67B8\u67CF\u67DE\u67F3\u67B0\u67D9\u67E2\u67DD\u67D2\u6B6A\u6B83\u6B86\u6BB5\u6BD2\u6BD7\u6C1F\u6CC9\u6D0B\u6D32\u6D2A\u6D41\u6D25\u6D0C\u6D31\u6D1E\u6D17\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6D3B\u6D3D\u6D3E\u6D36\u6D1B\u6CF5\u6D39\u6D27\u6D38\u6D29\u6D2E\u6D35\u6D0E\u6D2B\u70AB\u70BA\u70B3\u70AC\u70AF\u70AD\u70B8\u70AE\u70A4\u7230\u7272\u726F\u7274\u72E9\u72E0\u72E1\u73B7\u73CA\u73BB\u73B2\u73CD\u73C0\u73B3\u751A\u752D\u754F\u754C\u754E\u754B\u75AB\u75A4\u75A5\u75A2\u75A3\u7678\u7686\u7687\u7688\u76C8\u76C6\u76C3\u76C5\u7701\u76F9\u76F8\u7709\u770B\u76FE\u76FC\u7707\u77DC\u7802\u7814\u780C\u780D\u7946\u7949\u7948\u7947\u79B9\u79BA\u79D1\u79D2\u79CB\u7A7F\u7A81\u7AFF\u7AFD\u7C7D\u7D02\u7D05\u7D00\u7D09\u7D07\u7D04\u7D06\u7F38\u7F8E\u7FBF\u8004\uFFFD".split("");
    for(j = 0; j != D[172].length; ++j)if (D[172][j].charCodeAt(0) !== 0xFFFD) {
        e[D[172][j]] = 44032 + j;
        d[44032 + j] = D[172][j];
    }
    D[173] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8010\u800D\u8011\u8036\u80D6\u80E5\u80DA\u80C3\u80C4\u80CC\u80E1\u80DB\u80CE\u80DE\u80E4\u80DD\u81F4\u8222\u82E7\u8303\u8305\u82E3\u82DB\u82E6\u8304\u82E5\u8302\u8309\u82D2\u82D7\u82F1\u8301\u82DC\u82D4\u82D1\u82DE\u82D3\u82DF\u82EF\u8306\u8650\u8679\u867B\u867A\u884D\u886B\u8981\u89D4\u8A08\u8A02\u8A03\u8C9E\u8CA0\u8D74\u8D73\u8DB4\u8ECD\u8ECC\u8FF0\u8FE6\u8FE2\u8FEA\u8FE5\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8FED\u8FEB\u8FE4\u8FE8\u90CA\u90CE\u90C1\u90C3\u914B\u914A\u91CD\u9582\u9650\u964B\u964C\u964D\u9762\u9769\u97CB\u97ED\u97F3\u9801\u98A8\u98DB\u98DF\u9996\u9999\u4E58\u4EB3\u500C\u500D\u5023\u4FEF\u5026\u5025\u4FF8\u5029\u5016\u5006\u503C\u501F\u501A\u5012\u5011\u4FFA\u5000\u5014\u5028\u4FF1\u5021\u500B\u5019\u5018\u4FF3\u4FEE\u502D\u502A\u4FFE\u502B\u5009\u517C\u51A4\u51A5\u51A2\u51CD\u51CC\u51C6\u51CB\u5256\u525C\u5254\u525B\u525D\u532A\u537F\u539F\u539D\u53DF\u54E8\u5510\u5501\u5537\u54FC\u54E5\u54F2\u5506\u54FA\u5514\u54E9\u54ED\u54E1\u5509\u54EE\u54EA\uFFFD".split("");
    for(j = 0; j != D[173].length; ++j)if (D[173][j].charCodeAt(0) !== 0xFFFD) {
        e[D[173][j]] = 44288 + j;
        d[44288 + j] = D[173][j];
    }
    D[174] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u54E6\u5527\u5507\u54FD\u550F\u5703\u5704\u57C2\u57D4\u57CB\u57C3\u5809\u590F\u5957\u5958\u595A\u5A11\u5A18\u5A1C\u5A1F\u5A1B\u5A13\u59EC\u5A20\u5A23\u5A29\u5A25\u5A0C\u5A09\u5B6B\u5C58\u5BB0\u5BB3\u5BB6\u5BB4\u5BAE\u5BB5\u5BB9\u5BB8\u5C04\u5C51\u5C55\u5C50\u5CED\u5CFD\u5CFB\u5CEA\u5CE8\u5CF0\u5CF6\u5D01\u5CF4\u5DEE\u5E2D\u5E2B\u5EAB\u5EAD\u5EA7\u5F31\u5F92\u5F91\u5F90\u6059\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6063\u6065\u6050\u6055\u606D\u6069\u606F\u6084\u609F\u609A\u608D\u6094\u608C\u6085\u6096\u6247\u62F3\u6308\u62FF\u634E\u633E\u632F\u6355\u6342\u6346\u634F\u6349\u633A\u6350\u633D\u632A\u632B\u6328\u634D\u634C\u6548\u6549\u6599\u65C1\u65C5\u6642\u6649\u664F\u6643\u6652\u664C\u6645\u6641\u66F8\u6714\u6715\u6717\u6821\u6838\u6848\u6846\u6853\u6839\u6842\u6854\u6829\u68B3\u6817\u684C\u6851\u683D\u67F4\u6850\u6840\u683C\u6843\u682A\u6845\u6813\u6818\u6841\u6B8A\u6B89\u6BB7\u6C23\u6C27\u6C28\u6C26\u6C24\u6CF0\u6D6A\u6D95\u6D88\u6D87\u6D66\u6D78\u6D77\u6D59\u6D93\uFFFD".split("");
    for(j = 0; j != D[174].length; ++j)if (D[174][j].charCodeAt(0) !== 0xFFFD) {
        e[D[174][j]] = 44544 + j;
        d[44544 + j] = D[174][j];
    }
    D[175] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6D6C\u6D89\u6D6E\u6D5A\u6D74\u6D69\u6D8C\u6D8A\u6D79\u6D85\u6D65\u6D94\u70CA\u70D8\u70E4\u70D9\u70C8\u70CF\u7239\u7279\u72FC\u72F9\u72FD\u72F8\u72F7\u7386\u73ED\u7409\u73EE\u73E0\u73EA\u73DE\u7554\u755D\u755C\u755A\u7559\u75BE\u75C5\u75C7\u75B2\u75B3\u75BD\u75BC\u75B9\u75C2\u75B8\u768B\u76B0\u76CA\u76CD\u76CE\u7729\u771F\u7720\u7728\u77E9\u7830\u7827\u7838\u781D\u7834\u7837\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7825\u782D\u7820\u781F\u7832\u7955\u7950\u7960\u795F\u7956\u795E\u795D\u7957\u795A\u79E4\u79E3\u79E7\u79DF\u79E6\u79E9\u79D8\u7A84\u7A88\u7AD9\u7B06\u7B11\u7C89\u7D21\u7D17\u7D0B\u7D0A\u7D20\u7D22\u7D14\u7D10\u7D15\u7D1A\u7D1C\u7D0D\u7D19\u7D1B\u7F3A\u7F5F\u7F94\u7FC5\u7FC1\u8006\u8018\u8015\u8019\u8017\u803D\u803F\u80F1\u8102\u80F0\u8105\u80ED\u80F4\u8106\u80F8\u80F3\u8108\u80FD\u810A\u80FC\u80EF\u81ED\u81EC\u8200\u8210\u822A\u822B\u8228\u822C\u82BB\u832B\u8352\u8354\u834A\u8338\u8350\u8349\u8335\u8334\u834F\u8332\u8339\u8336\u8317\u8340\u8331\u8328\u8343\uFFFD".split("");
    for(j = 0; j != D[175].length; ++j)if (D[175][j].charCodeAt(0) !== 0xFFFD) {
        e[D[175][j]] = 44800 + j;
        d[44800 + j] = D[175][j];
    }
    D[176] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8654\u868A\u86AA\u8693\u86A4\u86A9\u868C\u86A3\u869C\u8870\u8877\u8881\u8882\u887D\u8879\u8A18\u8A10\u8A0E\u8A0C\u8A15\u8A0A\u8A17\u8A13\u8A16\u8A0F\u8A11\u8C48\u8C7A\u8C79\u8CA1\u8CA2\u8D77\u8EAC\u8ED2\u8ED4\u8ECF\u8FB1\u9001\u9006\u8FF7\u9000\u8FFA\u8FF4\u9003\u8FFD\u9005\u8FF8\u9095\u90E1\u90DD\u90E2\u9152\u914D\u914C\u91D8\u91DD\u91D7\u91DC\u91D9\u9583\u9662\u9663\u9661\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u965B\u965D\u9664\u9658\u965E\u96BB\u98E2\u99AC\u9AA8\u9AD8\u9B25\u9B32\u9B3C\u4E7E\u507A\u507D\u505C\u5047\u5043\u504C\u505A\u5049\u5065\u5076\u504E\u5055\u5075\u5074\u5077\u504F\u500F\u506F\u506D\u515C\u5195\u51F0\u526A\u526F\u52D2\u52D9\u52D8\u52D5\u5310\u530F\u5319\u533F\u5340\u533E\u53C3\u66FC\u5546\u556A\u5566\u5544\u555E\u5561\u5543\u554A\u5531\u5556\u554F\u5555\u552F\u5564\u5538\u552E\u555C\u552C\u5563\u5533\u5541\u5557\u5708\u570B\u5709\u57DF\u5805\u580A\u5806\u57E0\u57E4\u57FA\u5802\u5835\u57F7\u57F9\u5920\u5962\u5A36\u5A41\u5A49\u5A66\u5A6A\u5A40\uFFFD".split("");
    for(j = 0; j != D[176].length; ++j)if (D[176][j].charCodeAt(0) !== 0xFFFD) {
        e[D[176][j]] = 45056 + j;
        d[45056 + j] = D[176][j];
    }
    D[177] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5A3C\u5A62\u5A5A\u5A46\u5A4A\u5B70\u5BC7\u5BC5\u5BC4\u5BC2\u5BBF\u5BC6\u5C09\u5C08\u5C07\u5C60\u5C5C\u5C5D\u5D07\u5D06\u5D0E\u5D1B\u5D16\u5D22\u5D11\u5D29\u5D14\u5D19\u5D24\u5D27\u5D17\u5DE2\u5E38\u5E36\u5E33\u5E37\u5EB7\u5EB8\u5EB6\u5EB5\u5EBE\u5F35\u5F37\u5F57\u5F6C\u5F69\u5F6B\u5F97\u5F99\u5F9E\u5F98\u5FA1\u5FA0\u5F9C\u607F\u60A3\u6089\u60A0\u60A8\u60CB\u60B4\u60E6\u60BD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u60C5\u60BB\u60B5\u60DC\u60BC\u60D8\u60D5\u60C6\u60DF\u60B8\u60DA\u60C7\u621A\u621B\u6248\u63A0\u63A7\u6372\u6396\u63A2\u63A5\u6377\u6367\u6398\u63AA\u6371\u63A9\u6389\u6383\u639B\u636B\u63A8\u6384\u6388\u6399\u63A1\u63AC\u6392\u638F\u6380\u637B\u6369\u6368\u637A\u655D\u6556\u6551\u6559\u6557\u555F\u654F\u6558\u6555\u6554\u659C\u659B\u65AC\u65CF\u65CB\u65CC\u65CE\u665D\u665A\u6664\u6668\u6666\u665E\u66F9\u52D7\u671B\u6881\u68AF\u68A2\u6893\u68B5\u687F\u6876\u68B1\u68A7\u6897\u68B0\u6883\u68C4\u68AD\u6886\u6885\u6894\u689D\u68A8\u689F\u68A1\u6882\u6B32\u6BBA\uFFFD".split("");
    for(j = 0; j != D[177].length; ++j)if (D[177][j].charCodeAt(0) !== 0xFFFD) {
        e[D[177][j]] = 45312 + j;
        d[45312 + j] = D[177][j];
    }
    D[178] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6BEB\u6BEC\u6C2B\u6D8E\u6DBC\u6DF3\u6DD9\u6DB2\u6DE1\u6DCC\u6DE4\u6DFB\u6DFA\u6E05\u6DC7\u6DCB\u6DAF\u6DD1\u6DAE\u6DDE\u6DF9\u6DB8\u6DF7\u6DF5\u6DC5\u6DD2\u6E1A\u6DB5\u6DDA\u6DEB\u6DD8\u6DEA\u6DF1\u6DEE\u6DE8\u6DC6\u6DC4\u6DAA\u6DEC\u6DBF\u6DE6\u70F9\u7109\u710A\u70FD\u70EF\u723D\u727D\u7281\u731C\u731B\u7316\u7313\u7319\u7387\u7405\u740A\u7403\u7406\u73FE\u740D\u74E0\u74F6\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u74F7\u751C\u7522\u7565\u7566\u7562\u7570\u758F\u75D4\u75D5\u75B5\u75CA\u75CD\u768E\u76D4\u76D2\u76DB\u7737\u773E\u773C\u7736\u7738\u773A\u786B\u7843\u784E\u7965\u7968\u796D\u79FB\u7A92\u7A95\u7B20\u7B28\u7B1B\u7B2C\u7B26\u7B19\u7B1E\u7B2E\u7C92\u7C97\u7C95\u7D46\u7D43\u7D71\u7D2E\u7D39\u7D3C\u7D40\u7D30\u7D33\u7D44\u7D2F\u7D42\u7D32\u7D31\u7F3D\u7F9E\u7F9A\u7FCC\u7FCE\u7FD2\u801C\u804A\u8046\u812F\u8116\u8123\u812B\u8129\u8130\u8124\u8202\u8235\u8237\u8236\u8239\u838E\u839E\u8398\u8378\u83A2\u8396\u83BD\u83AB\u8392\u838A\u8393\u8389\u83A0\u8377\u837B\u837C\uFFFD".split("");
    for(j = 0; j != D[178].length; ++j)if (D[178][j].charCodeAt(0) !== 0xFFFD) {
        e[D[178][j]] = 45568 + j;
        d[45568 + j] = D[178][j];
    }
    D[179] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8386\u83A7\u8655\u5F6A\u86C7\u86C0\u86B6\u86C4\u86B5\u86C6\u86CB\u86B1\u86AF\u86C9\u8853\u889E\u8888\u88AB\u8892\u8896\u888D\u888B\u8993\u898F\u8A2A\u8A1D\u8A23\u8A25\u8A31\u8A2D\u8A1F\u8A1B\u8A22\u8C49\u8C5A\u8CA9\u8CAC\u8CAB\u8CA8\u8CAA\u8CA7\u8D67\u8D66\u8DBE\u8DBA\u8EDB\u8EDF\u9019\u900D\u901A\u9017\u9023\u901F\u901D\u9010\u9015\u901E\u9020\u900F\u9022\u9016\u901B\u9014\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u90E8\u90ED\u90FD\u9157\u91CE\u91F5\u91E6\u91E3\u91E7\u91ED\u91E9\u9589\u966A\u9675\u9673\u9678\u9670\u9674\u9676\u9677\u966C\u96C0\u96EA\u96E9\u7AE0\u7ADF\u9802\u9803\u9B5A\u9CE5\u9E75\u9E7F\u9EA5\u9EBB\u50A2\u508D\u5085\u5099\u5091\u5080\u5096\u5098\u509A\u6700\u51F1\u5272\u5274\u5275\u5269\u52DE\u52DD\u52DB\u535A\u53A5\u557B\u5580\u55A7\u557C\u558A\u559D\u5598\u5582\u559C\u55AA\u5594\u5587\u558B\u5583\u55B3\u55AE\u559F\u553E\u55B2\u559A\u55BB\u55AC\u55B1\u557E\u5589\u55AB\u5599\u570D\u582F\u582A\u5834\u5824\u5830\u5831\u5821\u581D\u5820\u58F9\u58FA\u5960\uFFFD".split("");
    for(j = 0; j != D[179].length; ++j)if (D[179][j].charCodeAt(0) !== 0xFFFD) {
        e[D[179][j]] = 45824 + j;
        d[45824 + j] = D[179][j];
    }
    D[180] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5A77\u5A9A\u5A7F\u5A92\u5A9B\u5AA7\u5B73\u5B71\u5BD2\u5BCC\u5BD3\u5BD0\u5C0A\u5C0B\u5C31\u5D4C\u5D50\u5D34\u5D47\u5DFD\u5E45\u5E3D\u5E40\u5E43\u5E7E\u5ECA\u5EC1\u5EC2\u5EC4\u5F3C\u5F6D\u5FA9\u5FAA\u5FA8\u60D1\u60E1\u60B2\u60B6\u60E0\u611C\u6123\u60FA\u6115\u60F0\u60FB\u60F4\u6168\u60F1\u610E\u60F6\u6109\u6100\u6112\u621F\u6249\u63A3\u638C\u63CF\u63C0\u63E9\u63C9\u63C6\u63CD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u63D2\u63E3\u63D0\u63E1\u63D6\u63ED\u63EE\u6376\u63F4\u63EA\u63DB\u6452\u63DA\u63F9\u655E\u6566\u6562\u6563\u6591\u6590\u65AF\u666E\u6670\u6674\u6676\u666F\u6691\u667A\u667E\u6677\u66FE\u66FF\u671F\u671D\u68FA\u68D5\u68E0\u68D8\u68D7\u6905\u68DF\u68F5\u68EE\u68E7\u68F9\u68D2\u68F2\u68E3\u68CB\u68CD\u690D\u6912\u690E\u68C9\u68DA\u696E\u68FB\u6B3E\u6B3A\u6B3D\u6B98\u6B96\u6BBC\u6BEF\u6C2E\u6C2F\u6C2C\u6E2F\u6E38\u6E54\u6E21\u6E32\u6E67\u6E4A\u6E20\u6E25\u6E23\u6E1B\u6E5B\u6E58\u6E24\u6E56\u6E6E\u6E2D\u6E26\u6E6F\u6E34\u6E4D\u6E3A\u6E2C\u6E43\u6E1D\u6E3E\u6ECB\uFFFD".split("");
    for(j = 0; j != D[180].length; ++j)if (D[180][j].charCodeAt(0) !== 0xFFFD) {
        e[D[180][j]] = 46080 + j;
        d[46080 + j] = D[180][j];
    }
    D[181] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6E89\u6E19\u6E4E\u6E63\u6E44\u6E72\u6E69\u6E5F\u7119\u711A\u7126\u7130\u7121\u7136\u716E\u711C\u724C\u7284\u7280\u7336\u7325\u7334\u7329\u743A\u742A\u7433\u7422\u7425\u7435\u7436\u7434\u742F\u741B\u7426\u7428\u7525\u7526\u756B\u756A\u75E2\u75DB\u75E3\u75D9\u75D8\u75DE\u75E0\u767B\u767C\u7696\u7693\u76B4\u76DC\u774F\u77ED\u785D\u786C\u786F\u7A0D\u7A08\u7A0B\u7A05\u7A00\u7A98\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7A97\u7A96\u7AE5\u7AE3\u7B49\u7B56\u7B46\u7B50\u7B52\u7B54\u7B4D\u7B4B\u7B4F\u7B51\u7C9F\u7CA5\u7D5E\u7D50\u7D68\u7D55\u7D2B\u7D6E\u7D72\u7D61\u7D66\u7D62\u7D70\u7D73\u5584\u7FD4\u7FD5\u800B\u8052\u8085\u8155\u8154\u814B\u8151\u814E\u8139\u8146\u813E\u814C\u8153\u8174\u8212\u821C\u83E9\u8403\u83F8\u840D\u83E0\u83C5\u840B\u83C1\u83EF\u83F1\u83F4\u8457\u840A\u83F0\u840C\u83CC\u83FD\u83F2\u83CA\u8438\u840E\u8404\u83DC\u8407\u83D4\u83DF\u865B\u86DF\u86D9\u86ED\u86D4\u86DB\u86E4\u86D0\u86DE\u8857\u88C1\u88C2\u88B1\u8983\u8996\u8A3B\u8A60\u8A55\u8A5E\u8A3C\u8A41\uFFFD".split("");
    for(j = 0; j != D[181].length; ++j)if (D[181][j].charCodeAt(0) !== 0xFFFD) {
        e[D[181][j]] = 46336 + j;
        d[46336 + j] = D[181][j];
    }
    D[182] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8A54\u8A5B\u8A50\u8A46\u8A34\u8A3A\u8A36\u8A56\u8C61\u8C82\u8CAF\u8CBC\u8CB3\u8CBD\u8CC1\u8CBB\u8CC0\u8CB4\u8CB7\u8CB6\u8CBF\u8CB8\u8D8A\u8D85\u8D81\u8DCE\u8DDD\u8DCB\u8DDA\u8DD1\u8DCC\u8DDB\u8DC6\u8EFB\u8EF8\u8EFC\u8F9C\u902E\u9035\u9031\u9038\u9032\u9036\u9102\u90F5\u9109\u90FE\u9163\u9165\u91CF\u9214\u9215\u9223\u9209\u921E\u920D\u9210\u9207\u9211\u9594\u958F\u958B\u9591\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9593\u9592\u958E\u968A\u968E\u968B\u967D\u9685\u9686\u968D\u9672\u9684\u96C1\u96C5\u96C4\u96C6\u96C7\u96EF\u96F2\u97CC\u9805\u9806\u9808\u98E7\u98EA\u98EF\u98E9\u98F2\u98ED\u99AE\u99AD\u9EC3\u9ECD\u9ED1\u4E82\u50AD\u50B5\u50B2\u50B3\u50C5\u50BE\u50AC\u50B7\u50BB\u50AF\u50C7\u527F\u5277\u527D\u52DF\u52E6\u52E4\u52E2\u52E3\u532F\u55DF\u55E8\u55D3\u55E6\u55CE\u55DC\u55C7\u55D1\u55E3\u55E4\u55EF\u55DA\u55E1\u55C5\u55C6\u55E5\u55C9\u5712\u5713\u585E\u5851\u5858\u5857\u585A\u5854\u586B\u584C\u586D\u584A\u5862\u5852\u584B\u5967\u5AC1\u5AC9\u5ACC\u5ABE\u5ABD\u5ABC\uFFFD".split("");
    for(j = 0; j != D[182].length; ++j)if (D[182][j].charCodeAt(0) !== 0xFFFD) {
        e[D[182][j]] = 46592 + j;
        d[46592 + j] = D[182][j];
    }
    D[183] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5AB3\u5AC2\u5AB2\u5D69\u5D6F\u5E4C\u5E79\u5EC9\u5EC8\u5F12\u5F59\u5FAC\u5FAE\u611A\u610F\u6148\u611F\u60F3\u611B\u60F9\u6101\u6108\u614E\u614C\u6144\u614D\u613E\u6134\u6127\u610D\u6106\u6137\u6221\u6222\u6413\u643E\u641E\u642A\u642D\u643D\u642C\u640F\u641C\u6414\u640D\u6436\u6416\u6417\u6406\u656C\u659F\u65B0\u6697\u6689\u6687\u6688\u6696\u6684\u6698\u668D\u6703\u6994\u696D\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u695A\u6977\u6960\u6954\u6975\u6930\u6982\u694A\u6968\u696B\u695E\u6953\u6979\u6986\u695D\u6963\u695B\u6B47\u6B72\u6BC0\u6BBF\u6BD3\u6BFD\u6EA2\u6EAF\u6ED3\u6EB6\u6EC2\u6E90\u6E9D\u6EC7\u6EC5\u6EA5\u6E98\u6EBC\u6EBA\u6EAB\u6ED1\u6E96\u6E9C\u6EC4\u6ED4\u6EAA\u6EA7\u6EB4\u714E\u7159\u7169\u7164\u7149\u7167\u715C\u716C\u7166\u714C\u7165\u715E\u7146\u7168\u7156\u723A\u7252\u7337\u7345\u733F\u733E\u746F\u745A\u7455\u745F\u745E\u7441\u743F\u7459\u745B\u745C\u7576\u7578\u7600\u75F0\u7601\u75F2\u75F1\u75FA\u75FF\u75F4\u75F3\u76DE\u76DF\u775B\u776B\u7766\u775E\u7763\uFFFD".split("");
    for(j = 0; j != D[183].length; ++j)if (D[183][j].charCodeAt(0) !== 0xFFFD) {
        e[D[183][j]] = 46848 + j;
        d[46848 + j] = D[183][j];
    }
    D[184] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7779\u776A\u776C\u775C\u7765\u7768\u7762\u77EE\u788E\u78B0\u7897\u7898\u788C\u7889\u787C\u7891\u7893\u787F\u797A\u797F\u7981\u842C\u79BD\u7A1C\u7A1A\u7A20\u7A14\u7A1F\u7A1E\u7A9F\u7AA0\u7B77\u7BC0\u7B60\u7B6E\u7B67\u7CB1\u7CB3\u7CB5\u7D93\u7D79\u7D91\u7D81\u7D8F\u7D5B\u7F6E\u7F69\u7F6A\u7F72\u7FA9\u7FA8\u7FA4\u8056\u8058\u8086\u8084\u8171\u8170\u8178\u8165\u816E\u8173\u816B\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8179\u817A\u8166\u8205\u8247\u8482\u8477\u843D\u8431\u8475\u8466\u846B\u8449\u846C\u845B\u843C\u8435\u8461\u8463\u8469\u846D\u8446\u865E\u865C\u865F\u86F9\u8713\u8708\u8707\u8700\u86FE\u86FB\u8702\u8703\u8706\u870A\u8859\u88DF\u88D4\u88D9\u88DC\u88D8\u88DD\u88E1\u88CA\u88D5\u88D2\u899C\u89E3\u8A6B\u8A72\u8A73\u8A66\u8A69\u8A70\u8A87\u8A7C\u8A63\u8AA0\u8A71\u8A85\u8A6D\u8A62\u8A6E\u8A6C\u8A79\u8A7B\u8A3E\u8A68\u8C62\u8C8A\u8C89\u8CCA\u8CC7\u8CC8\u8CC4\u8CB2\u8CC3\u8CC2\u8CC5\u8DE1\u8DDF\u8DE8\u8DEF\u8DF3\u8DFA\u8DEA\u8DE4\u8DE6\u8EB2\u8F03\u8F09\u8EFE\u8F0A\uFFFD".split("");
    for(j = 0; j != D[184].length; ++j)if (D[184][j].charCodeAt(0) !== 0xFFFD) {
        e[D[184][j]] = 47104 + j;
        d[47104 + j] = D[184][j];
    }
    D[185] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8F9F\u8FB2\u904B\u904A\u9053\u9042\u9054\u903C\u9055\u9050\u9047\u904F\u904E\u904D\u9051\u903E\u9041\u9112\u9117\u916C\u916A\u9169\u91C9\u9237\u9257\u9238\u923D\u9240\u923E\u925B\u924B\u9264\u9251\u9234\u9249\u924D\u9245\u9239\u923F\u925A\u9598\u9698\u9694\u9695\u96CD\u96CB\u96C9\u96CA\u96F7\u96FB\u96F9\u96F6\u9756\u9774\u9776\u9810\u9811\u9813\u980A\u9812\u980C\u98FC\u98F4\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u98FD\u98FE\u99B3\u99B1\u99B4\u9AE1\u9CE9\u9E82\u9F0E\u9F13\u9F20\u50E7\u50EE\u50E5\u50D6\u50ED\u50DA\u50D5\u50CF\u50D1\u50F1\u50CE\u50E9\u5162\u51F3\u5283\u5282\u5331\u53AD\u55FE\u5600\u561B\u5617\u55FD\u5614\u5606\u5609\u560D\u560E\u55F7\u5616\u561F\u5608\u5610\u55F6\u5718\u5716\u5875\u587E\u5883\u5893\u588A\u5879\u5885\u587D\u58FD\u5925\u5922\u5924\u596A\u5969\u5AE1\u5AE6\u5AE9\u5AD7\u5AD6\u5AD8\u5AE3\u5B75\u5BDE\u5BE7\u5BE1\u5BE5\u5BE6\u5BE8\u5BE2\u5BE4\u5BDF\u5C0D\u5C62\u5D84\u5D87\u5E5B\u5E63\u5E55\u5E57\u5E54\u5ED3\u5ED6\u5F0A\u5F46\u5F70\u5FB9\u6147\uFFFD".split("");
    for(j = 0; j != D[185].length; ++j)if (D[185][j].charCodeAt(0) !== 0xFFFD) {
        e[D[185][j]] = 47360 + j;
        d[47360 + j] = D[185][j];
    }
    D[186] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u613F\u614B\u6177\u6162\u6163\u615F\u615A\u6158\u6175\u622A\u6487\u6458\u6454\u64A4\u6478\u645F\u647A\u6451\u6467\u6434\u646D\u647B\u6572\u65A1\u65D7\u65D6\u66A2\u66A8\u669D\u699C\u69A8\u6995\u69C1\u69AE\u69D3\u69CB\u699B\u69B7\u69BB\u69AB\u69B4\u69D0\u69CD\u69AD\u69CC\u69A6\u69C3\u69A3\u6B49\u6B4C\u6C33\u6F33\u6F14\u6EFE\u6F13\u6EF4\u6F29\u6F3E\u6F20\u6F2C\u6F0F\u6F02\u6F22\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6EFF\u6EEF\u6F06\u6F31\u6F38\u6F32\u6F23\u6F15\u6F2B\u6F2F\u6F88\u6F2A\u6EEC\u6F01\u6EF2\u6ECC\u6EF7\u7194\u7199\u717D\u718A\u7184\u7192\u723E\u7292\u7296\u7344\u7350\u7464\u7463\u746A\u7470\u746D\u7504\u7591\u7627\u760D\u760B\u7609\u7613\u76E1\u76E3\u7784\u777D\u777F\u7761\u78C1\u789F\u78A7\u78B3\u78A9\u78A3\u798E\u798F\u798D\u7A2E\u7A31\u7AAA\u7AA9\u7AED\u7AEF\u7BA1\u7B95\u7B8B\u7B75\u7B97\u7B9D\u7B94\u7B8F\u7BB8\u7B87\u7B84\u7CB9\u7CBD\u7CBE\u7DBB\u7DB0\u7D9C\u7DBD\u7DBE\u7DA0\u7DCA\u7DB4\u7DB2\u7DB1\u7DBA\u7DA2\u7DBF\u7DB5\u7DB8\u7DAD\u7DD2\u7DC7\u7DAC\uFFFD".split("");
    for(j = 0; j != D[186].length; ++j)if (D[186][j].charCodeAt(0) !== 0xFFFD) {
        e[D[186][j]] = 47616 + j;
        d[47616 + j] = D[186][j];
    }
    D[187] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7F70\u7FE0\u7FE1\u7FDF\u805E\u805A\u8087\u8150\u8180\u818F\u8188\u818A\u817F\u8182\u81E7\u81FA\u8207\u8214\u821E\u824B\u84C9\u84BF\u84C6\u84C4\u8499\u849E\u84B2\u849C\u84CB\u84B8\u84C0\u84D3\u8490\u84BC\u84D1\u84CA\u873F\u871C\u873B\u8722\u8725\u8734\u8718\u8755\u8737\u8729\u88F3\u8902\u88F4\u88F9\u88F8\u88FD\u88E8\u891A\u88EF\u8AA6\u8A8C\u8A9E\u8AA3\u8A8D\u8AA1\u8A93\u8AA4\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8AAA\u8AA5\u8AA8\u8A98\u8A91\u8A9A\u8AA7\u8C6A\u8C8D\u8C8C\u8CD3\u8CD1\u8CD2\u8D6B\u8D99\u8D95\u8DFC\u8F14\u8F12\u8F15\u8F13\u8FA3\u9060\u9058\u905C\u9063\u9059\u905E\u9062\u905D\u905B\u9119\u9118\u911E\u9175\u9178\u9177\u9174\u9278\u9280\u9285\u9298\u9296\u927B\u9293\u929C\u92A8\u927C\u9291\u95A1\u95A8\u95A9\u95A3\u95A5\u95A4\u9699\u969C\u969B\u96CC\u96D2\u9700\u977C\u9785\u97F6\u9817\u9818\u98AF\u98B1\u9903\u9905\u990C\u9909\u99C1\u9AAF\u9AB0\u9AE6\u9B41\u9B42\u9CF4\u9CF6\u9CF3\u9EBC\u9F3B\u9F4A\u5104\u5100\u50FB\u50F5\u50F9\u5102\u5108\u5109\u5105\u51DC\uFFFD".split("");
    for(j = 0; j != D[187].length; ++j)if (D[187][j].charCodeAt(0) !== 0xFFFD) {
        e[D[187][j]] = 47872 + j;
        d[47872 + j] = D[187][j];
    }
    D[188] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5287\u5288\u5289\u528D\u528A\u52F0\u53B2\u562E\u563B\u5639\u5632\u563F\u5634\u5629\u5653\u564E\u5657\u5674\u5636\u562F\u5630\u5880\u589F\u589E\u58B3\u589C\u58AE\u58A9\u58A6\u596D\u5B09\u5AFB\u5B0B\u5AF5\u5B0C\u5B08\u5BEE\u5BEC\u5BE9\u5BEB\u5C64\u5C65\u5D9D\u5D94\u5E62\u5E5F\u5E61\u5EE2\u5EDA\u5EDF\u5EDD\u5EE3\u5EE0\u5F48\u5F71\u5FB7\u5FB5\u6176\u6167\u616E\u615D\u6155\u6182\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u617C\u6170\u616B\u617E\u61A7\u6190\u61AB\u618E\u61AC\u619A\u61A4\u6194\u61AE\u622E\u6469\u646F\u6479\u649E\u64B2\u6488\u6490\u64B0\u64A5\u6493\u6495\u64A9\u6492\u64AE\u64AD\u64AB\u649A\u64AC\u6499\u64A2\u64B3\u6575\u6577\u6578\u66AE\u66AB\u66B4\u66B1\u6A23\u6A1F\u69E8\u6A01\u6A1E\u6A19\u69FD\u6A21\u6A13\u6A0A\u69F3\u6A02\u6A05\u69ED\u6A11\u6B50\u6B4E\u6BA4\u6BC5\u6BC6\u6F3F\u6F7C\u6F84\u6F51\u6F66\u6F54\u6F86\u6F6D\u6F5B\u6F78\u6F6E\u6F8E\u6F7A\u6F70\u6F64\u6F97\u6F58\u6ED5\u6F6F\u6F60\u6F5F\u719F\u71AC\u71B1\u71A8\u7256\u729B\u734E\u7357\u7469\u748B\u7483\uFFFD".split("");
    for(j = 0; j != D[188].length; ++j)if (D[188][j].charCodeAt(0) !== 0xFFFD) {
        e[D[188][j]] = 48128 + j;
        d[48128 + j] = D[188][j];
    }
    D[189] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u747E\u7480\u757F\u7620\u7629\u761F\u7624\u7626\u7621\u7622\u769A\u76BA\u76E4\u778E\u7787\u778C\u7791\u778B\u78CB\u78C5\u78BA\u78CA\u78BE\u78D5\u78BC\u78D0\u7A3F\u7A3C\u7A40\u7A3D\u7A37\u7A3B\u7AAF\u7AAE\u7BAD\u7BB1\u7BC4\u7BB4\u7BC6\u7BC7\u7BC1\u7BA0\u7BCC\u7CCA\u7DE0\u7DF4\u7DEF\u7DFB\u7DD8\u7DEC\u7DDD\u7DE8\u7DE3\u7DDA\u7DDE\u7DE9\u7D9E\u7DD9\u7DF2\u7DF9\u7F75\u7F77\u7FAF\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7FE9\u8026\u819B\u819C\u819D\u81A0\u819A\u8198\u8517\u853D\u851A\u84EE\u852C\u852D\u8513\u8511\u8523\u8521\u8514\u84EC\u8525\u84FF\u8506\u8782\u8774\u8776\u8760\u8766\u8778\u8768\u8759\u8757\u874C\u8753\u885B\u885D\u8910\u8907\u8912\u8913\u8915\u890A\u8ABC\u8AD2\u8AC7\u8AC4\u8A95\u8ACB\u8AF8\u8AB2\u8AC9\u8AC2\u8ABF\u8AB0\u8AD6\u8ACD\u8AB6\u8AB9\u8ADB\u8C4C\u8C4E\u8C6C\u8CE0\u8CDE\u8CE6\u8CE4\u8CEC\u8CED\u8CE2\u8CE3\u8CDC\u8CEA\u8CE1\u8D6D\u8D9F\u8DA3\u8E2B\u8E10\u8E1D\u8E22\u8E0F\u8E29\u8E1F\u8E21\u8E1E\u8EBA\u8F1D\u8F1B\u8F1F\u8F29\u8F26\u8F2A\u8F1C\u8F1E\uFFFD".split("");
    for(j = 0; j != D[189].length; ++j)if (D[189][j].charCodeAt(0) !== 0xFFFD) {
        e[D[189][j]] = 48384 + j;
        d[48384 + j] = D[189][j];
    }
    D[190] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8F25\u9069\u906E\u9068\u906D\u9077\u9130\u912D\u9127\u9131\u9187\u9189\u918B\u9183\u92C5\u92BB\u92B7\u92EA\u92AC\u92E4\u92C1\u92B3\u92BC\u92D2\u92C7\u92F0\u92B2\u95AD\u95B1\u9704\u9706\u9707\u9709\u9760\u978D\u978B\u978F\u9821\u982B\u981C\u98B3\u990A\u9913\u9912\u9918\u99DD\u99D0\u99DF\u99DB\u99D1\u99D5\u99D2\u99D9\u9AB7\u9AEE\u9AEF\u9B27\u9B45\u9B44\u9B77\u9B6F\u9D06\u9D09\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9D03\u9EA9\u9EBE\u9ECE\u58A8\u9F52\u5112\u5118\u5114\u5110\u5115\u5180\u51AA\u51DD\u5291\u5293\u52F3\u5659\u566B\u5679\u5669\u5664\u5678\u566A\u5668\u5665\u5671\u566F\u566C\u5662\u5676\u58C1\u58BE\u58C7\u58C5\u596E\u5B1D\u5B34\u5B78\u5BF0\u5C0E\u5F4A\u61B2\u6191\u61A9\u618A\u61CD\u61B6\u61BE\u61CA\u61C8\u6230\u64C5\u64C1\u64CB\u64BB\u64BC\u64DA\u64C4\u64C7\u64C2\u64CD\u64BF\u64D2\u64D4\u64BE\u6574\u66C6\u66C9\u66B9\u66C4\u66C7\u66B8\u6A3D\u6A38\u6A3A\u6A59\u6A6B\u6A58\u6A39\u6A44\u6A62\u6A61\u6A4B\u6A47\u6A35\u6A5F\u6A48\u6B59\u6B77\u6C05\u6FC2\u6FB1\u6FA1\uFFFD".split("");
    for(j = 0; j != D[190].length; ++j)if (D[190][j].charCodeAt(0) !== 0xFFFD) {
        e[D[190][j]] = 48640 + j;
        d[48640 + j] = D[190][j];
    }
    D[191] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6FC3\u6FA4\u6FC1\u6FA7\u6FB3\u6FC0\u6FB9\u6FB6\u6FA6\u6FA0\u6FB4\u71BE\u71C9\u71D0\u71D2\u71C8\u71D5\u71B9\u71CE\u71D9\u71DC\u71C3\u71C4\u7368\u749C\u74A3\u7498\u749F\u749E\u74E2\u750C\u750D\u7634\u7638\u763A\u76E7\u76E5\u77A0\u779E\u779F\u77A5\u78E8\u78DA\u78EC\u78E7\u79A6\u7A4D\u7A4E\u7A46\u7A4C\u7A4B\u7ABA\u7BD9\u7C11\u7BC9\u7BE4\u7BDB\u7BE1\u7BE9\u7BE6\u7CD5\u7CD6\u7E0A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7E11\u7E08\u7E1B\u7E23\u7E1E\u7E1D\u7E09\u7E10\u7F79\u7FB2\u7FF0\u7FF1\u7FEE\u8028\u81B3\u81A9\u81A8\u81FB\u8208\u8258\u8259\u854A\u8559\u8548\u8568\u8569\u8543\u8549\u856D\u856A\u855E\u8783\u879F\u879E\u87A2\u878D\u8861\u892A\u8932\u8925\u892B\u8921\u89AA\u89A6\u8AE6\u8AFA\u8AEB\u8AF1\u8B00\u8ADC\u8AE7\u8AEE\u8AFE\u8B01\u8B02\u8AF7\u8AED\u8AF3\u8AF6\u8AFC\u8C6B\u8C6D\u8C93\u8CF4\u8E44\u8E31\u8E34\u8E42\u8E39\u8E35\u8F3B\u8F2F\u8F38\u8F33\u8FA8\u8FA6\u9075\u9074\u9078\u9072\u907C\u907A\u9134\u9192\u9320\u9336\u92F8\u9333\u932F\u9322\u92FC\u932B\u9304\u931A\uFFFD".split("");
    for(j = 0; j != D[191].length; ++j)if (D[191][j].charCodeAt(0) !== 0xFFFD) {
        e[D[191][j]] = 48896 + j;
        d[48896 + j] = D[191][j];
    }
    D[192] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9310\u9326\u9321\u9315\u932E\u9319\u95BB\u96A7\u96A8\u96AA\u96D5\u970E\u9711\u9716\u970D\u9713\u970F\u975B\u975C\u9766\u9798\u9830\u9838\u983B\u9837\u982D\u9839\u9824\u9910\u9928\u991E\u991B\u9921\u991A\u99ED\u99E2\u99F1\u9AB8\u9ABC\u9AFB\u9AED\u9B28\u9B91\u9D15\u9D23\u9D26\u9D28\u9D12\u9D1B\u9ED8\u9ED4\u9F8D\u9F9C\u512A\u511F\u5121\u5132\u52F5\u568E\u5680\u5690\u5685\u5687\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u568F\u58D5\u58D3\u58D1\u58CE\u5B30\u5B2A\u5B24\u5B7A\u5C37\u5C68\u5DBC\u5DBA\u5DBD\u5DB8\u5E6B\u5F4C\u5FBD\u61C9\u61C2\u61C7\u61E6\u61CB\u6232\u6234\u64CE\u64CA\u64D8\u64E0\u64F0\u64E6\u64EC\u64F1\u64E2\u64ED\u6582\u6583\u66D9\u66D6\u6A80\u6A94\u6A84\u6AA2\u6A9C\u6ADB\u6AA3\u6A7E\u6A97\u6A90\u6AA0\u6B5C\u6BAE\u6BDA\u6C08\u6FD8\u6FF1\u6FDF\u6FE0\u6FDB\u6FE4\u6FEB\u6FEF\u6F80\u6FEC\u6FE1\u6FE9\u6FD5\u6FEE\u6FF0\u71E7\u71DF\u71EE\u71E6\u71E5\u71ED\u71EC\u71F4\u71E0\u7235\u7246\u7370\u7372\u74A9\u74B0\u74A6\u74A8\u7646\u7642\u764C\u76EA\u77B3\u77AA\u77B0\u77AC\uFFFD".split("");
    for(j = 0; j != D[192].length; ++j)if (D[192][j].charCodeAt(0) !== 0xFFFD) {
        e[D[192][j]] = 49152 + j;
        d[49152 + j] = D[192][j];
    }
    D[193] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u77A7\u77AD\u77EF\u78F7\u78FA\u78F4\u78EF\u7901\u79A7\u79AA\u7A57\u7ABF\u7C07\u7C0D\u7BFE\u7BF7\u7C0C\u7BE0\u7CE0\u7CDC\u7CDE\u7CE2\u7CDF\u7CD9\u7CDD\u7E2E\u7E3E\u7E46\u7E37\u7E32\u7E43\u7E2B\u7E3D\u7E31\u7E45\u7E41\u7E34\u7E39\u7E48\u7E35\u7E3F\u7E2F\u7F44\u7FF3\u7FFC\u8071\u8072\u8070\u806F\u8073\u81C6\u81C3\u81BA\u81C2\u81C0\u81BF\u81BD\u81C9\u81BE\u81E8\u8209\u8271\u85AA\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8584\u857E\u859C\u8591\u8594\u85AF\u859B\u8587\u85A8\u858A\u8667\u87C0\u87D1\u87B3\u87D2\u87C6\u87AB\u87BB\u87BA\u87C8\u87CB\u893B\u8936\u8944\u8938\u893D\u89AC\u8B0E\u8B17\u8B19\u8B1B\u8B0A\u8B20\u8B1D\u8B04\u8B10\u8C41\u8C3F\u8C73\u8CFA\u8CFD\u8CFC\u8CF8\u8CFB\u8DA8\u8E49\u8E4B\u8E48\u8E4A\u8F44\u8F3E\u8F42\u8F45\u8F3F\u907F\u907D\u9084\u9081\u9082\u9080\u9139\u91A3\u919E\u919C\u934D\u9382\u9328\u9375\u934A\u9365\u934B\u9318\u937E\u936C\u935B\u9370\u935A\u9354\u95CA\u95CB\u95CC\u95C8\u95C6\u96B1\u96B8\u96D6\u971C\u971E\u97A0\u97D3\u9846\u98B6\u9935\u9A01\uFFFD".split("");
    for(j = 0; j != D[193].length; ++j)if (D[193][j].charCodeAt(0) !== 0xFFFD) {
        e[D[193][j]] = 49408 + j;
        d[49408 + j] = D[193][j];
    }
    D[194] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u99FF\u9BAE\u9BAB\u9BAA\u9BAD\u9D3B\u9D3F\u9E8B\u9ECF\u9EDE\u9EDC\u9EDD\u9EDB\u9F3E\u9F4B\u53E2\u5695\u56AE\u58D9\u58D8\u5B38\u5F5D\u61E3\u6233\u64F4\u64F2\u64FE\u6506\u64FA\u64FB\u64F7\u65B7\u66DC\u6726\u6AB3\u6AAC\u6AC3\u6ABB\u6AB8\u6AC2\u6AAE\u6AAF\u6B5F\u6B78\u6BAF\u7009\u700B\u6FFE\u7006\u6FFA\u7011\u700F\u71FB\u71FC\u71FE\u71F8\u7377\u7375\u74A7\u74BF\u7515\u7656\u7658\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7652\u77BD\u77BF\u77BB\u77BC\u790E\u79AE\u7A61\u7A62\u7A60\u7AC4\u7AC5\u7C2B\u7C27\u7C2A\u7C1E\u7C23\u7C21\u7CE7\u7E54\u7E55\u7E5E\u7E5A\u7E61\u7E52\u7E59\u7F48\u7FF9\u7FFB\u8077\u8076\u81CD\u81CF\u820A\u85CF\u85A9\u85CD\u85D0\u85C9\u85B0\u85BA\u85B9\u85A6\u87EF\u87EC\u87F2\u87E0\u8986\u89B2\u89F4\u8B28\u8B39\u8B2C\u8B2B\u8C50\u8D05\u8E59\u8E63\u8E66\u8E64\u8E5F\u8E55\u8EC0\u8F49\u8F4D\u9087\u9083\u9088\u91AB\u91AC\u91D0\u9394\u938A\u9396\u93A2\u93B3\u93AE\u93AC\u93B0\u9398\u939A\u9397\u95D4\u95D6\u95D0\u95D5\u96E2\u96DC\u96D9\u96DB\u96DE\u9724\u97A3\u97A6\uFFFD".split("");
    for(j = 0; j != D[194].length; ++j)if (D[194][j].charCodeAt(0) !== 0xFFFD) {
        e[D[194][j]] = 49664 + j;
        d[49664 + j] = D[194][j];
    }
    D[195] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u97AD\u97F9\u984D\u984F\u984C\u984E\u9853\u98BA\u993E\u993F\u993D\u992E\u99A5\u9A0E\u9AC1\u9B03\u9B06\u9B4F\u9B4E\u9B4D\u9BCA\u9BC9\u9BFD\u9BC8\u9BC0\u9D51\u9D5D\u9D60\u9EE0\u9F15\u9F2C\u5133\u56A5\u58DE\u58DF\u58E2\u5BF5\u9F90\u5EEC\u61F2\u61F7\u61F6\u61F5\u6500\u650F\u66E0\u66DD\u6AE5\u6ADD\u6ADA\u6AD3\u701B\u701F\u7028\u701A\u701D\u7015\u7018\u7206\u720D\u7258\u72A2\u7378\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u737A\u74BD\u74CA\u74E3\u7587\u7586\u765F\u7661\u77C7\u7919\u79B1\u7A6B\u7A69\u7C3E\u7C3F\u7C38\u7C3D\u7C37\u7C40\u7E6B\u7E6D\u7E79\u7E69\u7E6A\u7F85\u7E73\u7FB6\u7FB9\u7FB8\u81D8\u85E9\u85DD\u85EA\u85D5\u85E4\u85E5\u85F7\u87FB\u8805\u880D\u87F9\u87FE\u8960\u895F\u8956\u895E\u8B41\u8B5C\u8B58\u8B49\u8B5A\u8B4E\u8B4F\u8B46\u8B59\u8D08\u8D0A\u8E7C\u8E72\u8E87\u8E76\u8E6C\u8E7A\u8E74\u8F54\u8F4E\u8FAD\u908A\u908B\u91B1\u91AE\u93E1\u93D1\u93DF\u93C3\u93C8\u93DC\u93DD\u93D6\u93E2\u93CD\u93D8\u93E4\u93D7\u93E8\u95DC\u96B4\u96E3\u972A\u9727\u9761\u97DC\u97FB\u985E\uFFFD".split("");
    for(j = 0; j != D[195].length; ++j)if (D[195][j].charCodeAt(0) !== 0xFFFD) {
        e[D[195][j]] = 49920 + j;
        d[49920 + j] = D[195][j];
    }
    D[196] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9858\u985B\u98BC\u9945\u9949\u9A16\u9A19\u9B0D\u9BE8\u9BE7\u9BD6\u9BDB\u9D89\u9D61\u9D72\u9D6A\u9D6C\u9E92\u9E97\u9E93\u9EB4\u52F8\u56A8\u56B7\u56B6\u56B4\u56BC\u58E4\u5B40\u5B43\u5B7D\u5BF6\u5DC9\u61F8\u61FA\u6518\u6514\u6519\u66E6\u6727\u6AEC\u703E\u7030\u7032\u7210\u737B\u74CF\u7662\u7665\u7926\u792A\u792C\u792B\u7AC7\u7AF6\u7C4C\u7C43\u7C4D\u7CEF\u7CF0\u8FAE\u7E7D\u7E7C\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7E82\u7F4C\u8000\u81DA\u8266\u85FB\u85F9\u8611\u85FA\u8606\u860B\u8607\u860A\u8814\u8815\u8964\u89BA\u89F8\u8B70\u8B6C\u8B66\u8B6F\u8B5F\u8B6B\u8D0F\u8D0D\u8E89\u8E81\u8E85\u8E82\u91B4\u91CB\u9418\u9403\u93FD\u95E1\u9730\u98C4\u9952\u9951\u99A8\u9A2B\u9A30\u9A37\u9A35\u9C13\u9C0D\u9E79\u9EB5\u9EE8\u9F2F\u9F5F\u9F63\u9F61\u5137\u5138\u56C1\u56C0\u56C2\u5914\u5C6C\u5DCD\u61FC\u61FE\u651D\u651C\u6595\u66E9\u6AFB\u6B04\u6AFA\u6BB2\u704C\u721B\u72A7\u74D6\u74D4\u7669\u77D3\u7C50\u7E8F\u7E8C\u7FBC\u8617\u862D\u861A\u8823\u8822\u8821\u881F\u896A\u896C\u89BD\u8B74\uFFFD".split("");
    for(j = 0; j != D[196].length; ++j)if (D[196][j].charCodeAt(0) !== 0xFFFD) {
        e[D[196][j]] = 50176 + j;
        d[50176 + j] = D[196][j];
    }
    D[197] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8B77\u8B7D\u8D13\u8E8A\u8E8D\u8E8B\u8F5F\u8FAF\u91BA\u942E\u9433\u9435\u943A\u9438\u9432\u942B\u95E2\u9738\u9739\u9732\u97FF\u9867\u9865\u9957\u9A45\u9A43\u9A40\u9A3E\u9ACF\u9B54\u9B51\u9C2D\u9C25\u9DAF\u9DB4\u9DC2\u9DB8\u9E9D\u9EEF\u9F19\u9F5C\u9F66\u9F67\u513C\u513B\u56C8\u56CA\u56C9\u5B7F\u5DD4\u5DD2\u5F4E\u61FF\u6524\u6B0A\u6B61\u7051\u7058\u7380\u74E4\u758A\u766E\u766C\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u79B3\u7C60\u7C5F\u807E\u807D\u81DF\u8972\u896F\u89FC\u8B80\u8D16\u8D17\u8E91\u8E93\u8F61\u9148\u9444\u9451\u9452\u973D\u973E\u97C3\u97C1\u986B\u9955\u9A55\u9A4D\u9AD2\u9B1A\u9C49\u9C31\u9C3E\u9C3B\u9DD3\u9DD7\u9F34\u9F6C\u9F6A\u9F94\u56CC\u5DD6\u6200\u6523\u652B\u652A\u66EC\u6B10\u74DA\u7ACA\u7C64\u7C63\u7C65\u7E93\u7E96\u7E94\u81E2\u8638\u863F\u8831\u8B8A\u9090\u908F\u9463\u9460\u9464\u9768\u986F\u995C\u9A5A\u9A5B\u9A57\u9AD3\u9AD4\u9AD1\u9C54\u9C57\u9C56\u9DE5\u9E9F\u9EF4\u56D1\u58E9\u652C\u705E\u7671\u7672\u77D7\u7F50\u7F88\u8836\u8839\u8862\u8B93\u8B92\uFFFD".split("");
    for(j = 0; j != D[197].length; ++j)if (D[197][j].charCodeAt(0) !== 0xFFFD) {
        e[D[197][j]] = 50432 + j;
        d[50432 + j] = D[197][j];
    }
    D[198] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8B96\u8277\u8D1B\u91C0\u946A\u9742\u9748\u9744\u97C6\u9870\u9A5F\u9B22\u9B58\u9C5F\u9DF9\u9DFA\u9E7C\u9E7D\u9F07\u9F77\u9F72\u5EF3\u6B16\u7063\u7C6C\u7C6E\u883B\u89C0\u8EA1\u91C1\u9472\u9470\u9871\u995E\u9AD6\u9B23\u9ECC\u7064\u77DA\u8B9A\u9477\u97C9\u9A62\u9A65\u7E9C\u8B9C\u8EAA\u91C5\u947D\u947E\u947C\u9C77\u9C78\u9EF7\u8C54\u947F\u9E1A\u7228\u9A6A\u9B31\u9E1B\u9E1E\u7C72\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[198].length; ++j)if (D[198][j].charCodeAt(0) !== 0xFFFD) {
        e[D[198][j]] = 50688 + j;
        d[50688 + j] = D[198][j];
    }
    D[201] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u4E42\u4E5C\u51F5\u531A\u5382\u4E07\u4E0C\u4E47\u4E8D\u56D7\uFA0C\u5C6E\u5F73\u4E0F\u5187\u4E0E\u4E2E\u4E93\u4EC2\u4EC9\u4EC8\u5198\u52FC\u536C\u53B9\u5720\u5903\u592C\u5C10\u5DFF\u65E1\u6BB3\u6BCC\u6C14\u723F\u4E31\u4E3C\u4EE8\u4EDC\u4EE9\u4EE1\u4EDD\u4EDA\u520C\u531C\u534C\u5722\u5723\u5917\u592F\u5B81\u5B84\u5C12\u5C3B\u5C74\u5C73\u5E04\u5E80\u5E82\u5FC9\u6209\u6250\u6C15\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6C36\u6C43\u6C3F\u6C3B\u72AE\u72B0\u738A\u79B8\u808A\u961E\u4F0E\u4F18\u4F2C\u4EF5\u4F14\u4EF1\u4F00\u4EF7\u4F08\u4F1D\u4F02\u4F05\u4F22\u4F13\u4F04\u4EF4\u4F12\u51B1\u5213\u5209\u5210\u52A6\u5322\u531F\u534D\u538A\u5407\u56E1\u56DF\u572E\u572A\u5734\u593C\u5980\u597C\u5985\u597B\u597E\u5977\u597F\u5B56\u5C15\u5C25\u5C7C\u5C7A\u5C7B\u5C7E\u5DDF\u5E75\u5E84\u5F02\u5F1A\u5F74\u5FD5\u5FD4\u5FCF\u625C\u625E\u6264\u6261\u6266\u6262\u6259\u6260\u625A\u6265\u65EF\u65EE\u673E\u6739\u6738\u673B\u673A\u673F\u673C\u6733\u6C18\u6C46\u6C52\u6C5C\u6C4F\u6C4A\u6C54\u6C4B\uFFFD".split("");
    for(j = 0; j != D[201].length; ++j)if (D[201][j].charCodeAt(0) !== 0xFFFD) {
        e[D[201][j]] = 51456 + j;
        d[51456 + j] = D[201][j];
    }
    D[202] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6C4C\u7071\u725E\u72B4\u72B5\u738E\u752A\u767F\u7A75\u7F51\u8278\u827C\u8280\u827D\u827F\u864D\u897E\u9099\u9097\u9098\u909B\u9094\u9622\u9624\u9620\u9623\u4F56\u4F3B\u4F62\u4F49\u4F53\u4F64\u4F3E\u4F67\u4F52\u4F5F\u4F41\u4F58\u4F2D\u4F33\u4F3F\u4F61\u518F\u51B9\u521C\u521E\u5221\u52AD\u52AE\u5309\u5363\u5372\u538E\u538F\u5430\u5437\u542A\u5454\u5445\u5419\u541C\u5425\u5418\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u543D\u544F\u5441\u5428\u5424\u5447\u56EE\u56E7\u56E5\u5741\u5745\u574C\u5749\u574B\u5752\u5906\u5940\u59A6\u5998\u59A0\u5997\u598E\u59A2\u5990\u598F\u59A7\u59A1\u5B8E\u5B92\u5C28\u5C2A\u5C8D\u5C8F\u5C88\u5C8B\u5C89\u5C92\u5C8A\u5C86\u5C93\u5C95\u5DE0\u5E0A\u5E0E\u5E8B\u5E89\u5E8C\u5E88\u5E8D\u5F05\u5F1D\u5F78\u5F76\u5FD2\u5FD1\u5FD0\u5FED\u5FE8\u5FEE\u5FF3\u5FE1\u5FE4\u5FE3\u5FFA\u5FEF\u5FF7\u5FFB\u6000\u5FF4\u623A\u6283\u628C\u628E\u628F\u6294\u6287\u6271\u627B\u627A\u6270\u6281\u6288\u6277\u627D\u6272\u6274\u6537\u65F0\u65F4\u65F3\u65F2\u65F5\u6745\u6747\uFFFD".split("");
    for(j = 0; j != D[202].length; ++j)if (D[202][j].charCodeAt(0) !== 0xFFFD) {
        e[D[202][j]] = 51712 + j;
        d[51712 + j] = D[202][j];
    }
    D[203] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6759\u6755\u674C\u6748\u675D\u674D\u675A\u674B\u6BD0\u6C19\u6C1A\u6C78\u6C67\u6C6B\u6C84\u6C8B\u6C8F\u6C71\u6C6F\u6C69\u6C9A\u6C6D\u6C87\u6C95\u6C9C\u6C66\u6C73\u6C65\u6C7B\u6C8E\u7074\u707A\u7263\u72BF\u72BD\u72C3\u72C6\u72C1\u72BA\u72C5\u7395\u7397\u7393\u7394\u7392\u753A\u7539\u7594\u7595\u7681\u793D\u8034\u8095\u8099\u8090\u8092\u809C\u8290\u828F\u8285\u828E\u8291\u8293\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u828A\u8283\u8284\u8C78\u8FC9\u8FBF\u909F\u90A1\u90A5\u909E\u90A7\u90A0\u9630\u9628\u962F\u962D\u4E33\u4F98\u4F7C\u4F85\u4F7D\u4F80\u4F87\u4F76\u4F74\u4F89\u4F84\u4F77\u4F4C\u4F97\u4F6A\u4F9A\u4F79\u4F81\u4F78\u4F90\u4F9C\u4F94\u4F9E\u4F92\u4F82\u4F95\u4F6B\u4F6E\u519E\u51BC\u51BE\u5235\u5232\u5233\u5246\u5231\u52BC\u530A\u530B\u533C\u5392\u5394\u5487\u547F\u5481\u5491\u5482\u5488\u546B\u547A\u547E\u5465\u546C\u5474\u5466\u548D\u546F\u5461\u5460\u5498\u5463\u5467\u5464\u56F7\u56F9\u576F\u5772\u576D\u576B\u5771\u5770\u5776\u5780\u5775\u577B\u5773\u5774\u5762\uFFFD".split("");
    for(j = 0; j != D[203].length; ++j)if (D[203][j].charCodeAt(0) !== 0xFFFD) {
        e[D[203][j]] = 51968 + j;
        d[51968 + j] = D[203][j];
    }
    D[204] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5768\u577D\u590C\u5945\u59B5\u59BA\u59CF\u59CE\u59B2\u59CC\u59C1\u59B6\u59BC\u59C3\u59D6\u59B1\u59BD\u59C0\u59C8\u59B4\u59C7\u5B62\u5B65\u5B93\u5B95\u5C44\u5C47\u5CAE\u5CA4\u5CA0\u5CB5\u5CAF\u5CA8\u5CAC\u5C9F\u5CA3\u5CAD\u5CA2\u5CAA\u5CA7\u5C9D\u5CA5\u5CB6\u5CB0\u5CA6\u5E17\u5E14\u5E19\u5F28\u5F22\u5F23\u5F24\u5F54\u5F82\u5F7E\u5F7D\u5FDE\u5FE5\u602D\u6026\u6019\u6032\u600B\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6034\u600A\u6017\u6033\u601A\u601E\u602C\u6022\u600D\u6010\u602E\u6013\u6011\u600C\u6009\u601C\u6214\u623D\u62AD\u62B4\u62D1\u62BE\u62AA\u62B6\u62CA\u62AE\u62B3\u62AF\u62BB\u62A9\u62B0\u62B8\u653D\u65A8\u65BB\u6609\u65FC\u6604\u6612\u6608\u65FB\u6603\u660B\u660D\u6605\u65FD\u6611\u6610\u66F6\u670A\u6785\u676C\u678E\u6792\u6776\u677B\u6798\u6786\u6784\u6774\u678D\u678C\u677A\u679F\u6791\u6799\u6783\u677D\u6781\u6778\u6779\u6794\u6B25\u6B80\u6B7E\u6BDE\u6C1D\u6C93\u6CEC\u6CEB\u6CEE\u6CD9\u6CB6\u6CD4\u6CAD\u6CE7\u6CB7\u6CD0\u6CC2\u6CBA\u6CC3\u6CC6\u6CED\u6CF2\uFFFD".split("");
    for(j = 0; j != D[204].length; ++j)if (D[204][j].charCodeAt(0) !== 0xFFFD) {
        e[D[204][j]] = 52224 + j;
        d[52224 + j] = D[204][j];
    }
    D[205] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6CD2\u6CDD\u6CB4\u6C8A\u6C9D\u6C80\u6CDE\u6CC0\u6D30\u6CCD\u6CC7\u6CB0\u6CF9\u6CCF\u6CE9\u6CD1\u7094\u7098\u7085\u7093\u7086\u7084\u7091\u7096\u7082\u709A\u7083\u726A\u72D6\u72CB\u72D8\u72C9\u72DC\u72D2\u72D4\u72DA\u72CC\u72D1\u73A4\u73A1\u73AD\u73A6\u73A2\u73A0\u73AC\u739D\u74DD\u74E8\u753F\u7540\u753E\u758C\u7598\u76AF\u76F3\u76F1\u76F0\u76F5\u77F8\u77FC\u77F9\u77FB\u77FA\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u77F7\u7942\u793F\u79C5\u7A78\u7A7B\u7AFB\u7C75\u7CFD\u8035\u808F\u80AE\u80A3\u80B8\u80B5\u80AD\u8220\u82A0\u82C0\u82AB\u829A\u8298\u829B\u82B5\u82A7\u82AE\u82BC\u829E\u82BA\u82B4\u82A8\u82A1\u82A9\u82C2\u82A4\u82C3\u82B6\u82A2\u8670\u866F\u866D\u866E\u8C56\u8FD2\u8FCB\u8FD3\u8FCD\u8FD6\u8FD5\u8FD7\u90B2\u90B4\u90AF\u90B3\u90B0\u9639\u963D\u963C\u963A\u9643\u4FCD\u4FC5\u4FD3\u4FB2\u4FC9\u4FCB\u4FC1\u4FD4\u4FDC\u4FD9\u4FBB\u4FB3\u4FDB\u4FC7\u4FD6\u4FBA\u4FC0\u4FB9\u4FEC\u5244\u5249\u52C0\u52C2\u533D\u537C\u5397\u5396\u5399\u5398\u54BA\u54A1\u54AD\u54A5\u54CF\uFFFD".split("");
    for(j = 0; j != D[205].length; ++j)if (D[205][j].charCodeAt(0) !== 0xFFFD) {
        e[D[205][j]] = 52480 + j;
        d[52480 + j] = D[205][j];
    }
    D[206] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u54C3\u830D\u54B7\u54AE\u54D6\u54B6\u54C5\u54C6\u54A0\u5470\u54BC\u54A2\u54BE\u5472\u54DE\u54B0\u57B5\u579E\u579F\u57A4\u578C\u5797\u579D\u579B\u5794\u5798\u578F\u5799\u57A5\u579A\u5795\u58F4\u590D\u5953\u59E1\u59DE\u59EE\u5A00\u59F1\u59DD\u59FA\u59FD\u59FC\u59F6\u59E4\u59F2\u59F7\u59DB\u59E9\u59F3\u59F5\u59E0\u59FE\u59F4\u59ED\u5BA8\u5C4C\u5CD0\u5CD8\u5CCC\u5CD7\u5CCB\u5CDB\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5CDE\u5CDA\u5CC9\u5CC7\u5CCA\u5CD6\u5CD3\u5CD4\u5CCF\u5CC8\u5CC6\u5CCE\u5CDF\u5CF8\u5DF9\u5E21\u5E22\u5E23\u5E20\u5E24\u5EB0\u5EA4\u5EA2\u5E9B\u5EA3\u5EA5\u5F07\u5F2E\u5F56\u5F86\u6037\u6039\u6054\u6072\u605E\u6045\u6053\u6047\u6049\u605B\u604C\u6040\u6042\u605F\u6024\u6044\u6058\u6066\u606E\u6242\u6243\u62CF\u630D\u630B\u62F5\u630E\u6303\u62EB\u62F9\u630F\u630C\u62F8\u62F6\u6300\u6313\u6314\u62FA\u6315\u62FB\u62F0\u6541\u6543\u65AA\u65BF\u6636\u6621\u6632\u6635\u661C\u6626\u6622\u6633\u662B\u663A\u661D\u6634\u6639\u662E\u670F\u6710\u67C1\u67F2\u67C8\u67BA\uFFFD".split("");
    for(j = 0; j != D[206].length; ++j)if (D[206][j].charCodeAt(0) !== 0xFFFD) {
        e[D[206][j]] = 52736 + j;
        d[52736 + j] = D[206][j];
    }
    D[207] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u67DC\u67BB\u67F8\u67D8\u67C0\u67B7\u67C5\u67EB\u67E4\u67DF\u67B5\u67CD\u67B3\u67F7\u67F6\u67EE\u67E3\u67C2\u67B9\u67CE\u67E7\u67F0\u67B2\u67FC\u67C6\u67ED\u67CC\u67AE\u67E6\u67DB\u67FA\u67C9\u67CA\u67C3\u67EA\u67CB\u6B28\u6B82\u6B84\u6BB6\u6BD6\u6BD8\u6BE0\u6C20\u6C21\u6D28\u6D34\u6D2D\u6D1F\u6D3C\u6D3F\u6D12\u6D0A\u6CDA\u6D33\u6D04\u6D19\u6D3A\u6D1A\u6D11\u6D00\u6D1D\u6D42\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6D01\u6D18\u6D37\u6D03\u6D0F\u6D40\u6D07\u6D20\u6D2C\u6D08\u6D22\u6D09\u6D10\u70B7\u709F\u70BE\u70B1\u70B0\u70A1\u70B4\u70B5\u70A9\u7241\u7249\u724A\u726C\u7270\u7273\u726E\u72CA\u72E4\u72E8\u72EB\u72DF\u72EA\u72E6\u72E3\u7385\u73CC\u73C2\u73C8\u73C5\u73B9\u73B6\u73B5\u73B4\u73EB\u73BF\u73C7\u73BE\u73C3\u73C6\u73B8\u73CB\u74EC\u74EE\u752E\u7547\u7548\u75A7\u75AA\u7679\u76C4\u7708\u7703\u7704\u7705\u770A\u76F7\u76FB\u76FA\u77E7\u77E8\u7806\u7811\u7812\u7805\u7810\u780F\u780E\u7809\u7803\u7813\u794A\u794C\u794B\u7945\u7944\u79D5\u79CD\u79CF\u79D6\u79CE\u7A80\uFFFD".split("");
    for(j = 0; j != D[207].length; ++j)if (D[207][j].charCodeAt(0) !== 0xFFFD) {
        e[D[207][j]] = 52992 + j;
        d[52992 + j] = D[207][j];
    }
    D[208] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7A7E\u7AD1\u7B00\u7B01\u7C7A\u7C78\u7C79\u7C7F\u7C80\u7C81\u7D03\u7D08\u7D01\u7F58\u7F91\u7F8D\u7FBE\u8007\u800E\u800F\u8014\u8037\u80D8\u80C7\u80E0\u80D1\u80C8\u80C2\u80D0\u80C5\u80E3\u80D9\u80DC\u80CA\u80D5\u80C9\u80CF\u80D7\u80E6\u80CD\u81FF\u8221\u8294\u82D9\u82FE\u82F9\u8307\u82E8\u8300\u82D5\u833A\u82EB\u82D6\u82F4\u82EC\u82E1\u82F2\u82F5\u830C\u82FB\u82F6\u82F0\u82EA\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u82E4\u82E0\u82FA\u82F3\u82ED\u8677\u8674\u867C\u8673\u8841\u884E\u8867\u886A\u8869\u89D3\u8A04\u8A07\u8D72\u8FE3\u8FE1\u8FEE\u8FE0\u90F1\u90BD\u90BF\u90D5\u90C5\u90BE\u90C7\u90CB\u90C8\u91D4\u91D3\u9654\u964F\u9651\u9653\u964A\u964E\u501E\u5005\u5007\u5013\u5022\u5030\u501B\u4FF5\u4FF4\u5033\u5037\u502C\u4FF6\u4FF7\u5017\u501C\u5020\u5027\u5035\u502F\u5031\u500E\u515A\u5194\u5193\u51CA\u51C4\u51C5\u51C8\u51CE\u5261\u525A\u5252\u525E\u525F\u5255\u5262\u52CD\u530E\u539E\u5526\u54E2\u5517\u5512\u54E7\u54F3\u54E4\u551A\u54FF\u5504\u5508\u54EB\u5511\u5505\u54F1\uFFFD".split("");
    for(j = 0; j != D[208].length; ++j)if (D[208][j].charCodeAt(0) !== 0xFFFD) {
        e[D[208][j]] = 53248 + j;
        d[53248 + j] = D[208][j];
    }
    D[209] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u550A\u54FB\u54F7\u54F8\u54E0\u550E\u5503\u550B\u5701\u5702\u57CC\u5832\u57D5\u57D2\u57BA\u57C6\u57BD\u57BC\u57B8\u57B6\u57BF\u57C7\u57D0\u57B9\u57C1\u590E\u594A\u5A19\u5A16\u5A2D\u5A2E\u5A15\u5A0F\u5A17\u5A0A\u5A1E\u5A33\u5B6C\u5BA7\u5BAD\u5BAC\u5C03\u5C56\u5C54\u5CEC\u5CFF\u5CEE\u5CF1\u5CF7\u5D00\u5CF9\u5E29\u5E28\u5EA8\u5EAE\u5EAA\u5EAC\u5F33\u5F30\u5F67\u605D\u605A\u6067\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6041\u60A2\u6088\u6080\u6092\u6081\u609D\u6083\u6095\u609B\u6097\u6087\u609C\u608E\u6219\u6246\u62F2\u6310\u6356\u632C\u6344\u6345\u6336\u6343\u63E4\u6339\u634B\u634A\u633C\u6329\u6341\u6334\u6358\u6354\u6359\u632D\u6347\u6333\u635A\u6351\u6338\u6357\u6340\u6348\u654A\u6546\u65C6\u65C3\u65C4\u65C2\u664A\u665F\u6647\u6651\u6712\u6713\u681F\u681A\u6849\u6832\u6833\u683B\u684B\u684F\u6816\u6831\u681C\u6835\u682B\u682D\u682F\u684E\u6844\u6834\u681D\u6812\u6814\u6826\u6828\u682E\u684D\u683A\u6825\u6820\u6B2C\u6B2F\u6B2D\u6B31\u6B34\u6B6D\u8082\u6B88\u6BE6\u6BE4\uFFFD".split("");
    for(j = 0; j != D[209].length; ++j)if (D[209][j].charCodeAt(0) !== 0xFFFD) {
        e[D[209][j]] = 53504 + j;
        d[53504 + j] = D[209][j];
    }
    D[210] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6BE8\u6BE3\u6BE2\u6BE7\u6C25\u6D7A\u6D63\u6D64\u6D76\u6D0D\u6D61\u6D92\u6D58\u6D62\u6D6D\u6D6F\u6D91\u6D8D\u6DEF\u6D7F\u6D86\u6D5E\u6D67\u6D60\u6D97\u6D70\u6D7C\u6D5F\u6D82\u6D98\u6D2F\u6D68\u6D8B\u6D7E\u6D80\u6D84\u6D16\u6D83\u6D7B\u6D7D\u6D75\u6D90\u70DC\u70D3\u70D1\u70DD\u70CB\u7F39\u70E2\u70D7\u70D2\u70DE\u70E0\u70D4\u70CD\u70C5\u70C6\u70C7\u70DA\u70CE\u70E1\u7242\u7278\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7277\u7276\u7300\u72FA\u72F4\u72FE\u72F6\u72F3\u72FB\u7301\u73D3\u73D9\u73E5\u73D6\u73BC\u73E7\u73E3\u73E9\u73DC\u73D2\u73DB\u73D4\u73DD\u73DA\u73D7\u73D8\u73E8\u74DE\u74DF\u74F4\u74F5\u7521\u755B\u755F\u75B0\u75C1\u75BB\u75C4\u75C0\u75BF\u75B6\u75BA\u768A\u76C9\u771D\u771B\u7710\u7713\u7712\u7723\u7711\u7715\u7719\u771A\u7722\u7727\u7823\u782C\u7822\u7835\u782F\u7828\u782E\u782B\u7821\u7829\u7833\u782A\u7831\u7954\u795B\u794F\u795C\u7953\u7952\u7951\u79EB\u79EC\u79E0\u79EE\u79ED\u79EA\u79DC\u79DE\u79DD\u7A86\u7A89\u7A85\u7A8B\u7A8C\u7A8A\u7A87\u7AD8\u7B10\uFFFD".split("");
    for(j = 0; j != D[210].length; ++j)if (D[210][j].charCodeAt(0) !== 0xFFFD) {
        e[D[210][j]] = 53760 + j;
        d[53760 + j] = D[210][j];
    }
    D[211] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7B04\u7B13\u7B05\u7B0F\u7B08\u7B0A\u7B0E\u7B09\u7B12\u7C84\u7C91\u7C8A\u7C8C\u7C88\u7C8D\u7C85\u7D1E\u7D1D\u7D11\u7D0E\u7D18\u7D16\u7D13\u7D1F\u7D12\u7D0F\u7D0C\u7F5C\u7F61\u7F5E\u7F60\u7F5D\u7F5B\u7F96\u7F92\u7FC3\u7FC2\u7FC0\u8016\u803E\u8039\u80FA\u80F2\u80F9\u80F5\u8101\u80FB\u8100\u8201\u822F\u8225\u8333\u832D\u8344\u8319\u8351\u8325\u8356\u833F\u8341\u8326\u831C\u8322\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8342\u834E\u831B\u832A\u8308\u833C\u834D\u8316\u8324\u8320\u8337\u832F\u8329\u8347\u8345\u834C\u8353\u831E\u832C\u834B\u8327\u8348\u8653\u8652\u86A2\u86A8\u8696\u868D\u8691\u869E\u8687\u8697\u8686\u868B\u869A\u8685\u86A5\u8699\u86A1\u86A7\u8695\u8698\u868E\u869D\u8690\u8694\u8843\u8844\u886D\u8875\u8876\u8872\u8880\u8871\u887F\u886F\u8883\u887E\u8874\u887C\u8A12\u8C47\u8C57\u8C7B\u8CA4\u8CA3\u8D76\u8D78\u8DB5\u8DB7\u8DB6\u8ED1\u8ED3\u8FFE\u8FF5\u9002\u8FFF\u8FFB\u9004\u8FFC\u8FF6\u90D6\u90E0\u90D9\u90DA\u90E3\u90DF\u90E5\u90D8\u90DB\u90D7\u90DC\u90E4\u9150\uFFFD".split("");
    for(j = 0; j != D[211].length; ++j)if (D[211][j].charCodeAt(0) !== 0xFFFD) {
        e[D[211][j]] = 54016 + j;
        d[54016 + j] = D[211][j];
    }
    D[212] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u914E\u914F\u91D5\u91E2\u91DA\u965C\u965F\u96BC\u98E3\u9ADF\u9B2F\u4E7F\u5070\u506A\u5061\u505E\u5060\u5053\u504B\u505D\u5072\u5048\u504D\u5041\u505B\u504A\u5062\u5015\u5045\u505F\u5069\u506B\u5063\u5064\u5046\u5040\u506E\u5073\u5057\u5051\u51D0\u526B\u526D\u526C\u526E\u52D6\u52D3\u532D\u539C\u5575\u5576\u553C\u554D\u5550\u5534\u552A\u5551\u5562\u5536\u5535\u5530\u5552\u5545\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u550C\u5532\u5565\u554E\u5539\u5548\u552D\u553B\u5540\u554B\u570A\u5707\u57FB\u5814\u57E2\u57F6\u57DC\u57F4\u5800\u57ED\u57FD\u5808\u57F8\u580B\u57F3\u57CF\u5807\u57EE\u57E3\u57F2\u57E5\u57EC\u57E1\u580E\u57FC\u5810\u57E7\u5801\u580C\u57F1\u57E9\u57F0\u580D\u5804\u595C\u5A60\u5A58\u5A55\u5A67\u5A5E\u5A38\u5A35\u5A6D\u5A50\u5A5F\u5A65\u5A6C\u5A53\u5A64\u5A57\u5A43\u5A5D\u5A52\u5A44\u5A5B\u5A48\u5A8E\u5A3E\u5A4D\u5A39\u5A4C\u5A70\u5A69\u5A47\u5A51\u5A56\u5A42\u5A5C\u5B72\u5B6E\u5BC1\u5BC0\u5C59\u5D1E\u5D0B\u5D1D\u5D1A\u5D20\u5D0C\u5D28\u5D0D\u5D26\u5D25\u5D0F\uFFFD".split("");
    for(j = 0; j != D[212].length; ++j)if (D[212][j].charCodeAt(0) !== 0xFFFD) {
        e[D[212][j]] = 54272 + j;
        d[54272 + j] = D[212][j];
    }
    D[213] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5D30\u5D12\u5D23\u5D1F\u5D2E\u5E3E\u5E34\u5EB1\u5EB4\u5EB9\u5EB2\u5EB3\u5F36\u5F38\u5F9B\u5F96\u5F9F\u608A\u6090\u6086\u60BE\u60B0\u60BA\u60D3\u60D4\u60CF\u60E4\u60D9\u60DD\u60C8\u60B1\u60DB\u60B7\u60CA\u60BF\u60C3\u60CD\u60C0\u6332\u6365\u638A\u6382\u637D\u63BD\u639E\u63AD\u639D\u6397\u63AB\u638E\u636F\u6387\u6390\u636E\u63AF\u6375\u639C\u636D\u63AE\u637C\u63A4\u633B\u639F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6378\u6385\u6381\u6391\u638D\u6370\u6553\u65CD\u6665\u6661\u665B\u6659\u665C\u6662\u6718\u6879\u6887\u6890\u689C\u686D\u686E\u68AE\u68AB\u6956\u686F\u68A3\u68AC\u68A9\u6875\u6874\u68B2\u688F\u6877\u6892\u687C\u686B\u6872\u68AA\u6880\u6871\u687E\u689B\u6896\u688B\u68A0\u6889\u68A4\u6878\u687B\u6891\u688C\u688A\u687D\u6B36\u6B33\u6B37\u6B38\u6B91\u6B8F\u6B8D\u6B8E\u6B8C\u6C2A\u6DC0\u6DAB\u6DB4\u6DB3\u6E74\u6DAC\u6DE9\u6DE2\u6DB7\u6DF6\u6DD4\u6E00\u6DC8\u6DE0\u6DDF\u6DD6\u6DBE\u6DE5\u6DDC\u6DDD\u6DDB\u6DF4\u6DCA\u6DBD\u6DED\u6DF0\u6DBA\u6DD5\u6DC2\u6DCF\u6DC9\uFFFD".split("");
    for(j = 0; j != D[213].length; ++j)if (D[213][j].charCodeAt(0) !== 0xFFFD) {
        e[D[213][j]] = 54528 + j;
        d[54528 + j] = D[213][j];
    }
    D[214] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6DD0\u6DF2\u6DD3\u6DFD\u6DD7\u6DCD\u6DE3\u6DBB\u70FA\u710D\u70F7\u7117\u70F4\u710C\u70F0\u7104\u70F3\u7110\u70FC\u70FF\u7106\u7113\u7100\u70F8\u70F6\u710B\u7102\u710E\u727E\u727B\u727C\u727F\u731D\u7317\u7307\u7311\u7318\u730A\u7308\u72FF\u730F\u731E\u7388\u73F6\u73F8\u73F5\u7404\u7401\u73FD\u7407\u7400\u73FA\u73FC\u73FF\u740C\u740B\u73F4\u7408\u7564\u7563\u75CE\u75D2\u75CF\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u75CB\u75CC\u75D1\u75D0\u768F\u7689\u76D3\u7739\u772F\u772D\u7731\u7732\u7734\u7733\u773D\u7725\u773B\u7735\u7848\u7852\u7849\u784D\u784A\u784C\u7826\u7845\u7850\u7964\u7967\u7969\u796A\u7963\u796B\u7961\u79BB\u79FA\u79F8\u79F6\u79F7\u7A8F\u7A94\u7A90\u7B35\u7B47\u7B34\u7B25\u7B30\u7B22\u7B24\u7B33\u7B18\u7B2A\u7B1D\u7B31\u7B2B\u7B2D\u7B2F\u7B32\u7B38\u7B1A\u7B23\u7C94\u7C98\u7C96\u7CA3\u7D35\u7D3D\u7D38\u7D36\u7D3A\u7D45\u7D2C\u7D29\u7D41\u7D47\u7D3E\u7D3F\u7D4A\u7D3B\u7D28\u7F63\u7F95\u7F9C\u7F9D\u7F9B\u7FCA\u7FCB\u7FCD\u7FD0\u7FD1\u7FC7\u7FCF\u7FC9\u801F\uFFFD".split("");
    for(j = 0; j != D[214].length; ++j)if (D[214][j].charCodeAt(0) !== 0xFFFD) {
        e[D[214][j]] = 54784 + j;
        d[54784 + j] = D[214][j];
    }
    D[215] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u801E\u801B\u8047\u8043\u8048\u8118\u8125\u8119\u811B\u812D\u811F\u812C\u811E\u8121\u8115\u8127\u811D\u8122\u8211\u8238\u8233\u823A\u8234\u8232\u8274\u8390\u83A3\u83A8\u838D\u837A\u8373\u83A4\u8374\u838F\u8381\u8395\u8399\u8375\u8394\u83A9\u837D\u8383\u838C\u839D\u839B\u83AA\u838B\u837E\u83A5\u83AF\u8388\u8397\u83B0\u837F\u83A6\u8387\u83AE\u8376\u839A\u8659\u8656\u86BF\u86B7\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u86C2\u86C1\u86C5\u86BA\u86B0\u86C8\u86B9\u86B3\u86B8\u86CC\u86B4\u86BB\u86BC\u86C3\u86BD\u86BE\u8852\u8889\u8895\u88A8\u88A2\u88AA\u889A\u8891\u88A1\u889F\u8898\u88A7\u8899\u889B\u8897\u88A4\u88AC\u888C\u8893\u888E\u8982\u89D6\u89D9\u89D5\u8A30\u8A27\u8A2C\u8A1E\u8C39\u8C3B\u8C5C\u8C5D\u8C7D\u8CA5\u8D7D\u8D7B\u8D79\u8DBC\u8DC2\u8DB9\u8DBF\u8DC1\u8ED8\u8EDE\u8EDD\u8EDC\u8ED7\u8EE0\u8EE1\u9024\u900B\u9011\u901C\u900C\u9021\u90EF\u90EA\u90F0\u90F4\u90F2\u90F3\u90D4\u90EB\u90EC\u90E9\u9156\u9158\u915A\u9153\u9155\u91EC\u91F4\u91F1\u91F3\u91F8\u91E4\u91F9\u91EA\uFFFD".split("");
    for(j = 0; j != D[215].length; ++j)if (D[215][j].charCodeAt(0) !== 0xFFFD) {
        e[D[215][j]] = 55040 + j;
        d[55040 + j] = D[215][j];
    }
    D[216] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u91EB\u91F7\u91E8\u91EE\u957A\u9586\u9588\u967C\u966D\u966B\u9671\u966F\u96BF\u976A\u9804\u98E5\u9997\u509B\u5095\u5094\u509E\u508B\u50A3\u5083\u508C\u508E\u509D\u5068\u509C\u5092\u5082\u5087\u515F\u51D4\u5312\u5311\u53A4\u53A7\u5591\u55A8\u55A5\u55AD\u5577\u5645\u55A2\u5593\u5588\u558F\u55B5\u5581\u55A3\u5592\u55A4\u557D\u558C\u55A6\u557F\u5595\u55A1\u558E\u570C\u5829\u5837\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5819\u581E\u5827\u5823\u5828\u57F5\u5848\u5825\u581C\u581B\u5833\u583F\u5836\u582E\u5839\u5838\u582D\u582C\u583B\u5961\u5AAF\u5A94\u5A9F\u5A7A\u5AA2\u5A9E\u5A78\u5AA6\u5A7C\u5AA5\u5AAC\u5A95\u5AAE\u5A37\u5A84\u5A8A\u5A97\u5A83\u5A8B\u5AA9\u5A7B\u5A7D\u5A8C\u5A9C\u5A8F\u5A93\u5A9D\u5BEA\u5BCD\u5BCB\u5BD4\u5BD1\u5BCA\u5BCE\u5C0C\u5C30\u5D37\u5D43\u5D6B\u5D41\u5D4B\u5D3F\u5D35\u5D51\u5D4E\u5D55\u5D33\u5D3A\u5D52\u5D3D\u5D31\u5D59\u5D42\u5D39\u5D49\u5D38\u5D3C\u5D32\u5D36\u5D40\u5D45\u5E44\u5E41\u5F58\u5FA6\u5FA5\u5FAB\u60C9\u60B9\u60CC\u60E2\u60CE\u60C4\u6114\uFFFD".split("");
    for(j = 0; j != D[216].length; ++j)if (D[216][j].charCodeAt(0) !== 0xFFFD) {
        e[D[216][j]] = 55296 + j;
        d[55296 + j] = D[216][j];
    }
    D[217] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u60F2\u610A\u6116\u6105\u60F5\u6113\u60F8\u60FC\u60FE\u60C1\u6103\u6118\u611D\u6110\u60FF\u6104\u610B\u624A\u6394\u63B1\u63B0\u63CE\u63E5\u63E8\u63EF\u63C3\u649D\u63F3\u63CA\u63E0\u63F6\u63D5\u63F2\u63F5\u6461\u63DF\u63BE\u63DD\u63DC\u63C4\u63D8\u63D3\u63C2\u63C7\u63CC\u63CB\u63C8\u63F0\u63D7\u63D9\u6532\u6567\u656A\u6564\u655C\u6568\u6565\u658C\u659D\u659E\u65AE\u65D0\u65D2\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u667C\u666C\u667B\u6680\u6671\u6679\u666A\u6672\u6701\u690C\u68D3\u6904\u68DC\u692A\u68EC\u68EA\u68F1\u690F\u68D6\u68F7\u68EB\u68E4\u68F6\u6913\u6910\u68F3\u68E1\u6907\u68CC\u6908\u6970\u68B4\u6911\u68EF\u68C6\u6914\u68F8\u68D0\u68FD\u68FC\u68E8\u690B\u690A\u6917\u68CE\u68C8\u68DD\u68DE\u68E6\u68F4\u68D1\u6906\u68D4\u68E9\u6915\u6925\u68C7\u6B39\u6B3B\u6B3F\u6B3C\u6B94\u6B97\u6B99\u6B95\u6BBD\u6BF0\u6BF2\u6BF3\u6C30\u6DFC\u6E46\u6E47\u6E1F\u6E49\u6E88\u6E3C\u6E3D\u6E45\u6E62\u6E2B\u6E3F\u6E41\u6E5D\u6E73\u6E1C\u6E33\u6E4B\u6E40\u6E51\u6E3B\u6E03\u6E2E\u6E5E\uFFFD".split("");
    for(j = 0; j != D[217].length; ++j)if (D[217][j].charCodeAt(0) !== 0xFFFD) {
        e[D[217][j]] = 55552 + j;
        d[55552 + j] = D[217][j];
    }
    D[218] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6E68\u6E5C\u6E61\u6E31\u6E28\u6E60\u6E71\u6E6B\u6E39\u6E22\u6E30\u6E53\u6E65\u6E27\u6E78\u6E64\u6E77\u6E55\u6E79\u6E52\u6E66\u6E35\u6E36\u6E5A\u7120\u711E\u712F\u70FB\u712E\u7131\u7123\u7125\u7122\u7132\u711F\u7128\u713A\u711B\u724B\u725A\u7288\u7289\u7286\u7285\u728B\u7312\u730B\u7330\u7322\u7331\u7333\u7327\u7332\u732D\u7326\u7323\u7335\u730C\u742E\u742C\u7430\u742B\u7416\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u741A\u7421\u742D\u7431\u7424\u7423\u741D\u7429\u7420\u7432\u74FB\u752F\u756F\u756C\u75E7\u75DA\u75E1\u75E6\u75DD\u75DF\u75E4\u75D7\u7695\u7692\u76DA\u7746\u7747\u7744\u774D\u7745\u774A\u774E\u774B\u774C\u77DE\u77EC\u7860\u7864\u7865\u785C\u786D\u7871\u786A\u786E\u7870\u7869\u7868\u785E\u7862\u7974\u7973\u7972\u7970\u7A02\u7A0A\u7A03\u7A0C\u7A04\u7A99\u7AE6\u7AE4\u7B4A\u7B3B\u7B44\u7B48\u7B4C\u7B4E\u7B40\u7B58\u7B45\u7CA2\u7C9E\u7CA8\u7CA1\u7D58\u7D6F\u7D63\u7D53\u7D56\u7D67\u7D6A\u7D4F\u7D6D\u7D5C\u7D6B\u7D52\u7D54\u7D69\u7D51\u7D5F\u7D4E\u7F3E\u7F3F\u7F65\uFFFD".split("");
    for(j = 0; j != D[218].length; ++j)if (D[218][j].charCodeAt(0) !== 0xFFFD) {
        e[D[218][j]] = 55808 + j;
        d[55808 + j] = D[218][j];
    }
    D[219] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7F66\u7FA2\u7FA0\u7FA1\u7FD7\u8051\u804F\u8050\u80FE\u80D4\u8143\u814A\u8152\u814F\u8147\u813D\u814D\u813A\u81E6\u81EE\u81F7\u81F8\u81F9\u8204\u823C\u823D\u823F\u8275\u833B\u83CF\u83F9\u8423\u83C0\u83E8\u8412\u83E7\u83E4\u83FC\u83F6\u8410\u83C6\u83C8\u83EB\u83E3\u83BF\u8401\u83DD\u83E5\u83D8\u83FF\u83E1\u83CB\u83CE\u83D6\u83F5\u83C9\u8409\u840F\u83DE\u8411\u8406\u83C2\u83F3\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u83D5\u83FA\u83C7\u83D1\u83EA\u8413\u83C3\u83EC\u83EE\u83C4\u83FB\u83D7\u83E2\u841B\u83DB\u83FE\u86D8\u86E2\u86E6\u86D3\u86E3\u86DA\u86EA\u86DD\u86EB\u86DC\u86EC\u86E9\u86D7\u86E8\u86D1\u8848\u8856\u8855\u88BA\u88D7\u88B9\u88B8\u88C0\u88BE\u88B6\u88BC\u88B7\u88BD\u88B2\u8901\u88C9\u8995\u8998\u8997\u89DD\u89DA\u89DB\u8A4E\u8A4D\u8A39\u8A59\u8A40\u8A57\u8A58\u8A44\u8A45\u8A52\u8A48\u8A51\u8A4A\u8A4C\u8A4F\u8C5F\u8C81\u8C80\u8CBA\u8CBE\u8CB0\u8CB9\u8CB5\u8D84\u8D80\u8D89\u8DD8\u8DD3\u8DCD\u8DC7\u8DD6\u8DDC\u8DCF\u8DD5\u8DD9\u8DC8\u8DD7\u8DC5\u8EEF\u8EF7\u8EFA\uFFFD".split("");
    for(j = 0; j != D[219].length; ++j)if (D[219][j].charCodeAt(0) !== 0xFFFD) {
        e[D[219][j]] = 56064 + j;
        d[56064 + j] = D[219][j];
    }
    D[220] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8EF9\u8EE6\u8EEE\u8EE5\u8EF5\u8EE7\u8EE8\u8EF6\u8EEB\u8EF1\u8EEC\u8EF4\u8EE9\u902D\u9034\u902F\u9106\u912C\u9104\u90FF\u90FC\u9108\u90F9\u90FB\u9101\u9100\u9107\u9105\u9103\u9161\u9164\u915F\u9162\u9160\u9201\u920A\u9225\u9203\u921A\u9226\u920F\u920C\u9200\u9212\u91FF\u91FD\u9206\u9204\u9227\u9202\u921C\u9224\u9219\u9217\u9205\u9216\u957B\u958D\u958C\u9590\u9687\u967E\u9688\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9689\u9683\u9680\u96C2\u96C8\u96C3\u96F1\u96F0\u976C\u9770\u976E\u9807\u98A9\u98EB\u9CE6\u9EF9\u4E83\u4E84\u4EB6\u50BD\u50BF\u50C6\u50AE\u50C4\u50CA\u50B4\u50C8\u50C2\u50B0\u50C1\u50BA\u50B1\u50CB\u50C9\u50B6\u50B8\u51D7\u527A\u5278\u527B\u527C\u55C3\u55DB\u55CC\u55D0\u55CB\u55CA\u55DD\u55C0\u55D4\u55C4\u55E9\u55BF\u55D2\u558D\u55CF\u55D5\u55E2\u55D6\u55C8\u55F2\u55CD\u55D9\u55C2\u5714\u5853\u5868\u5864\u584F\u584D\u5849\u586F\u5855\u584E\u585D\u5859\u5865\u585B\u583D\u5863\u5871\u58FC\u5AC7\u5AC4\u5ACB\u5ABA\u5AB8\u5AB1\u5AB5\u5AB0\u5ABF\u5AC8\u5ABB\u5AC6\uFFFD".split("");
    for(j = 0; j != D[220].length; ++j)if (D[220][j].charCodeAt(0) !== 0xFFFD) {
        e[D[220][j]] = 56320 + j;
        d[56320 + j] = D[220][j];
    }
    D[221] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5AB7\u5AC0\u5ACA\u5AB4\u5AB6\u5ACD\u5AB9\u5A90\u5BD6\u5BD8\u5BD9\u5C1F\u5C33\u5D71\u5D63\u5D4A\u5D65\u5D72\u5D6C\u5D5E\u5D68\u5D67\u5D62\u5DF0\u5E4F\u5E4E\u5E4A\u5E4D\u5E4B\u5EC5\u5ECC\u5EC6\u5ECB\u5EC7\u5F40\u5FAF\u5FAD\u60F7\u6149\u614A\u612B\u6145\u6136\u6132\u612E\u6146\u612F\u614F\u6129\u6140\u6220\u9168\u6223\u6225\u6224\u63C5\u63F1\u63EB\u6410\u6412\u6409\u6420\u6424\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6433\u6443\u641F\u6415\u6418\u6439\u6437\u6422\u6423\u640C\u6426\u6430\u6428\u6441\u6435\u642F\u640A\u641A\u6440\u6425\u6427\u640B\u63E7\u641B\u642E\u6421\u640E\u656F\u6592\u65D3\u6686\u668C\u6695\u6690\u668B\u668A\u6699\u6694\u6678\u6720\u6966\u695F\u6938\u694E\u6962\u6971\u693F\u6945\u696A\u6939\u6942\u6957\u6959\u697A\u6948\u6949\u6935\u696C\u6933\u693D\u6965\u68F0\u6978\u6934\u6969\u6940\u696F\u6944\u6976\u6958\u6941\u6974\u694C\u693B\u694B\u6937\u695C\u694F\u6951\u6932\u6952\u692F\u697B\u693C\u6B46\u6B45\u6B43\u6B42\u6B48\u6B41\u6B9B\uFA0D\u6BFB\u6BFC\uFFFD".split("");
    for(j = 0; j != D[221].length; ++j)if (D[221][j].charCodeAt(0) !== 0xFFFD) {
        e[D[221][j]] = 56576 + j;
        d[56576 + j] = D[221][j];
    }
    D[222] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6BF9\u6BF7\u6BF8\u6E9B\u6ED6\u6EC8\u6E8F\u6EC0\u6E9F\u6E93\u6E94\u6EA0\u6EB1\u6EB9\u6EC6\u6ED2\u6EBD\u6EC1\u6E9E\u6EC9\u6EB7\u6EB0\u6ECD\u6EA6\u6ECF\u6EB2\u6EBE\u6EC3\u6EDC\u6ED8\u6E99\u6E92\u6E8E\u6E8D\u6EA4\u6EA1\u6EBF\u6EB3\u6ED0\u6ECA\u6E97\u6EAE\u6EA3\u7147\u7154\u7152\u7163\u7160\u7141\u715D\u7162\u7172\u7178\u716A\u7161\u7142\u7158\u7143\u714B\u7170\u715F\u7150\u7153\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7144\u714D\u715A\u724F\u728D\u728C\u7291\u7290\u728E\u733C\u7342\u733B\u733A\u7340\u734A\u7349\u7444\u744A\u744B\u7452\u7451\u7457\u7440\u744F\u7450\u744E\u7442\u7446\u744D\u7454\u74E1\u74FF\u74FE\u74FD\u751D\u7579\u7577\u6983\u75EF\u760F\u7603\u75F7\u75FE\u75FC\u75F9\u75F8\u7610\u75FB\u75F6\u75ED\u75F5\u75FD\u7699\u76B5\u76DD\u7755\u775F\u7760\u7752\u7756\u775A\u7769\u7767\u7754\u7759\u776D\u77E0\u7887\u789A\u7894\u788F\u7884\u7895\u7885\u7886\u78A1\u7883\u7879\u7899\u7880\u7896\u787B\u797C\u7982\u797D\u7979\u7A11\u7A18\u7A19\u7A12\u7A17\u7A15\u7A22\u7A13\uFFFD".split("");
    for(j = 0; j != D[222].length; ++j)if (D[222][j].charCodeAt(0) !== 0xFFFD) {
        e[D[222][j]] = 56832 + j;
        d[56832 + j] = D[222][j];
    }
    D[223] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7A1B\u7A10\u7AA3\u7AA2\u7A9E\u7AEB\u7B66\u7B64\u7B6D\u7B74\u7B69\u7B72\u7B65\u7B73\u7B71\u7B70\u7B61\u7B78\u7B76\u7B63\u7CB2\u7CB4\u7CAF\u7D88\u7D86\u7D80\u7D8D\u7D7F\u7D85\u7D7A\u7D8E\u7D7B\u7D83\u7D7C\u7D8C\u7D94\u7D84\u7D7D\u7D92\u7F6D\u7F6B\u7F67\u7F68\u7F6C\u7FA6\u7FA5\u7FA7\u7FDB\u7FDC\u8021\u8164\u8160\u8177\u815C\u8169\u815B\u8162\u8172\u6721\u815E\u8176\u8167\u816F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8144\u8161\u821D\u8249\u8244\u8240\u8242\u8245\u84F1\u843F\u8456\u8476\u8479\u848F\u848D\u8465\u8451\u8440\u8486\u8467\u8430\u844D\u847D\u845A\u8459\u8474\u8473\u845D\u8507\u845E\u8437\u843A\u8434\u847A\u8443\u8478\u8432\u8445\u8429\u83D9\u844B\u842F\u8442\u842D\u845F\u8470\u8439\u844E\u844C\u8452\u846F\u84C5\u848E\u843B\u8447\u8436\u8433\u8468\u847E\u8444\u842B\u8460\u8454\u846E\u8450\u870B\u8704\u86F7\u870C\u86FA\u86D6\u86F5\u874D\u86F8\u870E\u8709\u8701\u86F6\u870D\u8705\u88D6\u88CB\u88CD\u88CE\u88DE\u88DB\u88DA\u88CC\u88D0\u8985\u899B\u89DF\u89E5\u89E4\uFFFD".split("");
    for(j = 0; j != D[223].length; ++j)if (D[223][j].charCodeAt(0) !== 0xFFFD) {
        e[D[223][j]] = 57088 + j;
        d[57088 + j] = D[223][j];
    }
    D[224] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u89E1\u89E0\u89E2\u89DC\u89E6\u8A76\u8A86\u8A7F\u8A61\u8A3F\u8A77\u8A82\u8A84\u8A75\u8A83\u8A81\u8A74\u8A7A\u8C3C\u8C4B\u8C4A\u8C65\u8C64\u8C66\u8C86\u8C84\u8C85\u8CCC\u8D68\u8D69\u8D91\u8D8C\u8D8E\u8D8F\u8D8D\u8D93\u8D94\u8D90\u8D92\u8DF0\u8DE0\u8DEC\u8DF1\u8DEE\u8DD0\u8DE9\u8DE3\u8DE2\u8DE7\u8DF2\u8DEB\u8DF4\u8F06\u8EFF\u8F01\u8F00\u8F05\u8F07\u8F08\u8F02\u8F0B\u9052\u903F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9044\u9049\u903D\u9110\u910D\u910F\u9111\u9116\u9114\u910B\u910E\u916E\u916F\u9248\u9252\u9230\u923A\u9266\u9233\u9265\u925E\u9283\u922E\u924A\u9246\u926D\u926C\u924F\u9260\u9267\u926F\u9236\u9261\u9270\u9231\u9254\u9263\u9250\u9272\u924E\u9253\u924C\u9256\u9232\u959F\u959C\u959E\u959B\u9692\u9693\u9691\u9697\u96CE\u96FA\u96FD\u96F8\u96F5\u9773\u9777\u9778\u9772\u980F\u980D\u980E\u98AC\u98F6\u98F9\u99AF\u99B2\u99B0\u99B5\u9AAD\u9AAB\u9B5B\u9CEA\u9CED\u9CE7\u9E80\u9EFD\u50E6\u50D4\u50D7\u50E8\u50F3\u50DB\u50EA\u50DD\u50E4\u50D3\u50EC\u50F0\u50EF\u50E3\u50E0\uFFFD".split("");
    for(j = 0; j != D[224].length; ++j)if (D[224][j].charCodeAt(0) !== 0xFFFD) {
        e[D[224][j]] = 57344 + j;
        d[57344 + j] = D[224][j];
    }
    D[225] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u51D8\u5280\u5281\u52E9\u52EB\u5330\u53AC\u5627\u5615\u560C\u5612\u55FC\u560F\u561C\u5601\u5613\u5602\u55FA\u561D\u5604\u55FF\u55F9\u5889\u587C\u5890\u5898\u5886\u5881\u587F\u5874\u588B\u587A\u5887\u5891\u588E\u5876\u5882\u5888\u587B\u5894\u588F\u58FE\u596B\u5ADC\u5AEE\u5AE5\u5AD5\u5AEA\u5ADA\u5AED\u5AEB\u5AF3\u5AE2\u5AE0\u5ADB\u5AEC\u5ADE\u5ADD\u5AD9\u5AE8\u5ADF\u5B77\u5BE0\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5BE3\u5C63\u5D82\u5D80\u5D7D\u5D86\u5D7A\u5D81\u5D77\u5D8A\u5D89\u5D88\u5D7E\u5D7C\u5D8D\u5D79\u5D7F\u5E58\u5E59\u5E53\u5ED8\u5ED1\u5ED7\u5ECE\u5EDC\u5ED5\u5ED9\u5ED2\u5ED4\u5F44\u5F43\u5F6F\u5FB6\u612C\u6128\u6141\u615E\u6171\u6173\u6152\u6153\u6172\u616C\u6180\u6174\u6154\u617A\u615B\u6165\u613B\u616A\u6161\u6156\u6229\u6227\u622B\u642B\u644D\u645B\u645D\u6474\u6476\u6472\u6473\u647D\u6475\u6466\u64A6\u644E\u6482\u645E\u645C\u644B\u6453\u6460\u6450\u647F\u643F\u646C\u646B\u6459\u6465\u6477\u6573\u65A0\u66A1\u66A0\u669F\u6705\u6704\u6722\u69B1\u69B6\u69C9\uFFFD".split("");
    for(j = 0; j != D[225].length; ++j)if (D[225][j].charCodeAt(0) !== 0xFFFD) {
        e[D[225][j]] = 57600 + j;
        d[57600 + j] = D[225][j];
    }
    D[226] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u69A0\u69CE\u6996\u69B0\u69AC\u69BC\u6991\u6999\u698E\u69A7\u698D\u69A9\u69BE\u69AF\u69BF\u69C4\u69BD\u69A4\u69D4\u69B9\u69CA\u699A\u69CF\u69B3\u6993\u69AA\u69A1\u699E\u69D9\u6997\u6990\u69C2\u69B5\u69A5\u69C6\u6B4A\u6B4D\u6B4B\u6B9E\u6B9F\u6BA0\u6BC3\u6BC4\u6BFE\u6ECE\u6EF5\u6EF1\u6F03\u6F25\u6EF8\u6F37\u6EFB\u6F2E\u6F09\u6F4E\u6F19\u6F1A\u6F27\u6F18\u6F3B\u6F12\u6EED\u6F0A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6F36\u6F73\u6EF9\u6EEE\u6F2D\u6F40\u6F30\u6F3C\u6F35\u6EEB\u6F07\u6F0E\u6F43\u6F05\u6EFD\u6EF6\u6F39\u6F1C\u6EFC\u6F3A\u6F1F\u6F0D\u6F1E\u6F08\u6F21\u7187\u7190\u7189\u7180\u7185\u7182\u718F\u717B\u7186\u7181\u7197\u7244\u7253\u7297\u7295\u7293\u7343\u734D\u7351\u734C\u7462\u7473\u7471\u7475\u7472\u7467\u746E\u7500\u7502\u7503\u757D\u7590\u7616\u7608\u760C\u7615\u7611\u760A\u7614\u76B8\u7781\u777C\u7785\u7782\u776E\u7780\u776F\u777E\u7783\u78B2\u78AA\u78B4\u78AD\u78A8\u787E\u78AB\u789E\u78A5\u78A0\u78AC\u78A2\u78A4\u7998\u798A\u798B\u7996\u7995\u7994\u7993\uFFFD".split("");
    for(j = 0; j != D[226].length; ++j)if (D[226][j].charCodeAt(0) !== 0xFFFD) {
        e[D[226][j]] = 57856 + j;
        d[57856 + j] = D[226][j];
    }
    D[227] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7997\u7988\u7992\u7990\u7A2B\u7A4A\u7A30\u7A2F\u7A28\u7A26\u7AA8\u7AAB\u7AAC\u7AEE\u7B88\u7B9C\u7B8A\u7B91\u7B90\u7B96\u7B8D\u7B8C\u7B9B\u7B8E\u7B85\u7B98\u5284\u7B99\u7BA4\u7B82\u7CBB\u7CBF\u7CBC\u7CBA\u7DA7\u7DB7\u7DC2\u7DA3\u7DAA\u7DC1\u7DC0\u7DC5\u7D9D\u7DCE\u7DC4\u7DC6\u7DCB\u7DCC\u7DAF\u7DB9\u7D96\u7DBC\u7D9F\u7DA6\u7DAE\u7DA9\u7DA1\u7DC9\u7F73\u7FE2\u7FE3\u7FE5\u7FDE\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8024\u805D\u805C\u8189\u8186\u8183\u8187\u818D\u818C\u818B\u8215\u8497\u84A4\u84A1\u849F\u84BA\u84CE\u84C2\u84AC\u84AE\u84AB\u84B9\u84B4\u84C1\u84CD\u84AA\u849A\u84B1\u84D0\u849D\u84A7\u84BB\u84A2\u8494\u84C7\u84CC\u849B\u84A9\u84AF\u84A8\u84D6\u8498\u84B6\u84CF\u84A0\u84D7\u84D4\u84D2\u84DB\u84B0\u8491\u8661\u8733\u8723\u8728\u876B\u8740\u872E\u871E\u8721\u8719\u871B\u8743\u872C\u8741\u873E\u8746\u8720\u8732\u872A\u872D\u873C\u8712\u873A\u8731\u8735\u8742\u8726\u8727\u8738\u8724\u871A\u8730\u8711\u88F7\u88E7\u88F1\u88F2\u88FA\u88FE\u88EE\u88FC\u88F6\u88FB\uFFFD".split("");
    for(j = 0; j != D[227].length; ++j)if (D[227][j].charCodeAt(0) !== 0xFFFD) {
        e[D[227][j]] = 58112 + j;
        d[58112 + j] = D[227][j];
    }
    D[228] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u88F0\u88EC\u88EB\u899D\u89A1\u899F\u899E\u89E9\u89EB\u89E8\u8AAB\u8A99\u8A8B\u8A92\u8A8F\u8A96\u8C3D\u8C68\u8C69\u8CD5\u8CCF\u8CD7\u8D96\u8E09\u8E02\u8DFF\u8E0D\u8DFD\u8E0A\u8E03\u8E07\u8E06\u8E05\u8DFE\u8E00\u8E04\u8F10\u8F11\u8F0E\u8F0D\u9123\u911C\u9120\u9122\u911F\u911D\u911A\u9124\u9121\u911B\u917A\u9172\u9179\u9173\u92A5\u92A4\u9276\u929B\u927A\u92A0\u9294\u92AA\u928D\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u92A6\u929A\u92AB\u9279\u9297\u927F\u92A3\u92EE\u928E\u9282\u9295\u92A2\u927D\u9288\u92A1\u928A\u9286\u928C\u9299\u92A7\u927E\u9287\u92A9\u929D\u928B\u922D\u969E\u96A1\u96FF\u9758\u977D\u977A\u977E\u9783\u9780\u9782\u977B\u9784\u9781\u977F\u97CE\u97CD\u9816\u98AD\u98AE\u9902\u9900\u9907\u999D\u999C\u99C3\u99B9\u99BB\u99BA\u99C2\u99BD\u99C7\u9AB1\u9AE3\u9AE7\u9B3E\u9B3F\u9B60\u9B61\u9B5F\u9CF1\u9CF2\u9CF5\u9EA7\u50FF\u5103\u5130\u50F8\u5106\u5107\u50F6\u50FE\u510B\u510C\u50FD\u510A\u528B\u528C\u52F1\u52EF\u5648\u5642\u564C\u5635\u5641\u564A\u5649\u5646\u5658\uFFFD".split("");
    for(j = 0; j != D[228].length; ++j)if (D[228][j].charCodeAt(0) !== 0xFFFD) {
        e[D[228][j]] = 58368 + j;
        d[58368 + j] = D[228][j];
    }
    D[229] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u565A\u5640\u5633\u563D\u562C\u563E\u5638\u562A\u563A\u571A\u58AB\u589D\u58B1\u58A0\u58A3\u58AF\u58AC\u58A5\u58A1\u58FF\u5AFF\u5AF4\u5AFD\u5AF7\u5AF6\u5B03\u5AF8\u5B02\u5AF9\u5B01\u5B07\u5B05\u5B0F\u5C67\u5D99\u5D97\u5D9F\u5D92\u5DA2\u5D93\u5D95\u5DA0\u5D9C\u5DA1\u5D9A\u5D9E\u5E69\u5E5D\u5E60\u5E5C\u7DF3\u5EDB\u5EDE\u5EE1\u5F49\u5FB2\u618B\u6183\u6179\u61B1\u61B0\u61A2\u6189\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u619B\u6193\u61AF\u61AD\u619F\u6192\u61AA\u61A1\u618D\u6166\u61B3\u622D\u646E\u6470\u6496\u64A0\u6485\u6497\u649C\u648F\u648B\u648A\u648C\u64A3\u649F\u6468\u64B1\u6498\u6576\u657A\u6579\u657B\u65B2\u65B3\u66B5\u66B0\u66A9\u66B2\u66B7\u66AA\u66AF\u6A00\u6A06\u6A17\u69E5\u69F8\u6A15\u69F1\u69E4\u6A20\u69FF\u69EC\u69E2\u6A1B\u6A1D\u69FE\u6A27\u69F2\u69EE\u6A14\u69F7\u69E7\u6A40\u6A08\u69E6\u69FB\u6A0D\u69FC\u69EB\u6A09\u6A04\u6A18\u6A25\u6A0F\u69F6\u6A26\u6A07\u69F4\u6A16\u6B51\u6BA5\u6BA3\u6BA2\u6BA6\u6C01\u6C00\u6BFF\u6C02\u6F41\u6F26\u6F7E\u6F87\u6FC6\u6F92\uFFFD".split("");
    for(j = 0; j != D[229].length; ++j)if (D[229][j].charCodeAt(0) !== 0xFFFD) {
        e[D[229][j]] = 58624 + j;
        d[58624 + j] = D[229][j];
    }
    D[230] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6F8D\u6F89\u6F8C\u6F62\u6F4F\u6F85\u6F5A\u6F96\u6F76\u6F6C\u6F82\u6F55\u6F72\u6F52\u6F50\u6F57\u6F94\u6F93\u6F5D\u6F00\u6F61\u6F6B\u6F7D\u6F67\u6F90\u6F53\u6F8B\u6F69\u6F7F\u6F95\u6F63\u6F77\u6F6A\u6F7B\u71B2\u71AF\u719B\u71B0\u71A0\u719A\u71A9\u71B5\u719D\u71A5\u719E\u71A4\u71A1\u71AA\u719C\u71A7\u71B3\u7298\u729A\u7358\u7352\u735E\u735F\u7360\u735D\u735B\u7361\u735A\u7359\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7362\u7487\u7489\u748A\u7486\u7481\u747D\u7485\u7488\u747C\u7479\u7508\u7507\u757E\u7625\u761E\u7619\u761D\u761C\u7623\u761A\u7628\u761B\u769C\u769D\u769E\u769B\u778D\u778F\u7789\u7788\u78CD\u78BB\u78CF\u78CC\u78D1\u78CE\u78D4\u78C8\u78C3\u78C4\u78C9\u799A\u79A1\u79A0\u799C\u79A2\u799B\u6B76\u7A39\u7AB2\u7AB4\u7AB3\u7BB7\u7BCB\u7BBE\u7BAC\u7BCE\u7BAF\u7BB9\u7BCA\u7BB5\u7CC5\u7CC8\u7CCC\u7CCB\u7DF7\u7DDB\u7DEA\u7DE7\u7DD7\u7DE1\u7E03\u7DFA\u7DE6\u7DF6\u7DF1\u7DF0\u7DEE\u7DDF\u7F76\u7FAC\u7FB0\u7FAD\u7FED\u7FEB\u7FEA\u7FEC\u7FE6\u7FE8\u8064\u8067\u81A3\u819F\uFFFD".split("");
    for(j = 0; j != D[230].length; ++j)if (D[230][j].charCodeAt(0) !== 0xFFFD) {
        e[D[230][j]] = 58880 + j;
        d[58880 + j] = D[230][j];
    }
    D[231] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u819E\u8195\u81A2\u8199\u8197\u8216\u824F\u8253\u8252\u8250\u824E\u8251\u8524\u853B\u850F\u8500\u8529\u850E\u8509\u850D\u851F\u850A\u8527\u851C\u84FB\u852B\u84FA\u8508\u850C\u84F4\u852A\u84F2\u8515\u84F7\u84EB\u84F3\u84FC\u8512\u84EA\u84E9\u8516\u84FE\u8528\u851D\u852E\u8502\u84FD\u851E\u84F6\u8531\u8526\u84E7\u84E8\u84F0\u84EF\u84F9\u8518\u8520\u8530\u850B\u8519\u852F\u8662\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8756\u8763\u8764\u8777\u87E1\u8773\u8758\u8754\u875B\u8752\u8761\u875A\u8751\u875E\u876D\u876A\u8750\u874E\u875F\u875D\u876F\u876C\u877A\u876E\u875C\u8765\u874F\u877B\u8775\u8762\u8767\u8769\u885A\u8905\u890C\u8914\u890B\u8917\u8918\u8919\u8906\u8916\u8911\u890E\u8909\u89A2\u89A4\u89A3\u89ED\u89F0\u89EC\u8ACF\u8AC6\u8AB8\u8AD3\u8AD1\u8AD4\u8AD5\u8ABB\u8AD7\u8ABE\u8AC0\u8AC5\u8AD8\u8AC3\u8ABA\u8ABD\u8AD9\u8C3E\u8C4D\u8C8F\u8CE5\u8CDF\u8CD9\u8CE8\u8CDA\u8CDD\u8CE7\u8DA0\u8D9C\u8DA1\u8D9B\u8E20\u8E23\u8E25\u8E24\u8E2E\u8E15\u8E1B\u8E16\u8E11\u8E19\u8E26\u8E27\uFFFD".split("");
    for(j = 0; j != D[231].length; ++j)if (D[231][j].charCodeAt(0) !== 0xFFFD) {
        e[D[231][j]] = 59136 + j;
        d[59136 + j] = D[231][j];
    }
    D[232] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8E14\u8E12\u8E18\u8E13\u8E1C\u8E17\u8E1A\u8F2C\u8F24\u8F18\u8F1A\u8F20\u8F23\u8F16\u8F17\u9073\u9070\u906F\u9067\u906B\u912F\u912B\u9129\u912A\u9132\u9126\u912E\u9185\u9186\u918A\u9181\u9182\u9184\u9180\u92D0\u92C3\u92C4\u92C0\u92D9\u92B6\u92CF\u92F1\u92DF\u92D8\u92E9\u92D7\u92DD\u92CC\u92EF\u92C2\u92E8\u92CA\u92C8\u92CE\u92E6\u92CD\u92D5\u92C9\u92E0\u92DE\u92E7\u92D1\u92D3\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u92B5\u92E1\u92C6\u92B4\u957C\u95AC\u95AB\u95AE\u95B0\u96A4\u96A2\u96D3\u9705\u9708\u9702\u975A\u978A\u978E\u9788\u97D0\u97CF\u981E\u981D\u9826\u9829\u9828\u9820\u981B\u9827\u98B2\u9908\u98FA\u9911\u9914\u9916\u9917\u9915\u99DC\u99CD\u99CF\u99D3\u99D4\u99CE\u99C9\u99D6\u99D8\u99CB\u99D7\u99CC\u9AB3\u9AEC\u9AEB\u9AF3\u9AF2\u9AF1\u9B46\u9B43\u9B67\u9B74\u9B71\u9B66\u9B76\u9B75\u9B70\u9B68\u9B64\u9B6C\u9CFC\u9CFA\u9CFD\u9CFF\u9CF7\u9D07\u9D00\u9CF9\u9CFB\u9D08\u9D05\u9D04\u9E83\u9ED3\u9F0F\u9F10\u511C\u5113\u5117\u511A\u5111\u51DE\u5334\u53E1\u5670\u5660\u566E\uFFFD".split("");
    for(j = 0; j != D[232].length; ++j)if (D[232][j].charCodeAt(0) !== 0xFFFD) {
        e[D[232][j]] = 59392 + j;
        d[59392 + j] = D[232][j];
    }
    D[233] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5673\u5666\u5663\u566D\u5672\u565E\u5677\u571C\u571B\u58C8\u58BD\u58C9\u58BF\u58BA\u58C2\u58BC\u58C6\u5B17\u5B19\u5B1B\u5B21\u5B14\u5B13\u5B10\u5B16\u5B28\u5B1A\u5B20\u5B1E\u5BEF\u5DAC\u5DB1\u5DA9\u5DA7\u5DB5\u5DB0\u5DAE\u5DAA\u5DA8\u5DB2\u5DAD\u5DAF\u5DB4\u5E67\u5E68\u5E66\u5E6F\u5EE9\u5EE7\u5EE6\u5EE8\u5EE5\u5F4B\u5FBC\u619D\u61A8\u6196\u61C5\u61B4\u61C6\u61C1\u61CC\u61BA\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u61BF\u61B8\u618C\u64D7\u64D6\u64D0\u64CF\u64C9\u64BD\u6489\u64C3\u64DB\u64F3\u64D9\u6533\u657F\u657C\u65A2\u66C8\u66BE\u66C0\u66CA\u66CB\u66CF\u66BD\u66BB\u66BA\u66CC\u6723\u6A34\u6A66\u6A49\u6A67\u6A32\u6A68\u6A3E\u6A5D\u6A6D\u6A76\u6A5B\u6A51\u6A28\u6A5A\u6A3B\u6A3F\u6A41\u6A6A\u6A64\u6A50\u6A4F\u6A54\u6A6F\u6A69\u6A60\u6A3C\u6A5E\u6A56\u6A55\u6A4D\u6A4E\u6A46\u6B55\u6B54\u6B56\u6BA7\u6BAA\u6BAB\u6BC8\u6BC7\u6C04\u6C03\u6C06\u6FAD\u6FCB\u6FA3\u6FC7\u6FBC\u6FCE\u6FC8\u6F5E\u6FC4\u6FBD\u6F9E\u6FCA\u6FA8\u7004\u6FA5\u6FAE\u6FBA\u6FAC\u6FAA\u6FCF\u6FBF\u6FB8\uFFFD".split("");
    for(j = 0; j != D[233].length; ++j)if (D[233][j].charCodeAt(0) !== 0xFFFD) {
        e[D[233][j]] = 59648 + j;
        d[59648 + j] = D[233][j];
    }
    D[234] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6FA2\u6FC9\u6FAB\u6FCD\u6FAF\u6FB2\u6FB0\u71C5\u71C2\u71BF\u71B8\u71D6\u71C0\u71C1\u71CB\u71D4\u71CA\u71C7\u71CF\u71BD\u71D8\u71BC\u71C6\u71DA\u71DB\u729D\u729E\u7369\u7366\u7367\u736C\u7365\u736B\u736A\u747F\u749A\u74A0\u7494\u7492\u7495\u74A1\u750B\u7580\u762F\u762D\u7631\u763D\u7633\u763C\u7635\u7632\u7630\u76BB\u76E6\u779A\u779D\u77A1\u779C\u779B\u77A2\u77A3\u7795\u7799\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7797\u78DD\u78E9\u78E5\u78EA\u78DE\u78E3\u78DB\u78E1\u78E2\u78ED\u78DF\u78E0\u79A4\u7A44\u7A48\u7A47\u7AB6\u7AB8\u7AB5\u7AB1\u7AB7\u7BDE\u7BE3\u7BE7\u7BDD\u7BD5\u7BE5\u7BDA\u7BE8\u7BF9\u7BD4\u7BEA\u7BE2\u7BDC\u7BEB\u7BD8\u7BDF\u7CD2\u7CD4\u7CD7\u7CD0\u7CD1\u7E12\u7E21\u7E17\u7E0C\u7E1F\u7E20\u7E13\u7E0E\u7E1C\u7E15\u7E1A\u7E22\u7E0B\u7E0F\u7E16\u7E0D\u7E14\u7E25\u7E24\u7F43\u7F7B\u7F7C\u7F7A\u7FB1\u7FEF\u802A\u8029\u806C\u81B1\u81A6\u81AE\u81B9\u81B5\u81AB\u81B0\u81AC\u81B4\u81B2\u81B7\u81A7\u81F2\u8255\u8256\u8257\u8556\u8545\u856B\u854D\u8553\u8561\u8558\uFFFD".split("");
    for(j = 0; j != D[234].length; ++j)if (D[234][j].charCodeAt(0) !== 0xFFFD) {
        e[D[234][j]] = 59904 + j;
        d[59904 + j] = D[234][j];
    }
    D[235] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8540\u8546\u8564\u8541\u8562\u8544\u8551\u8547\u8563\u853E\u855B\u8571\u854E\u856E\u8575\u8555\u8567\u8560\u858C\u8566\u855D\u8554\u8565\u856C\u8663\u8665\u8664\u879B\u878F\u8797\u8793\u8792\u8788\u8781\u8796\u8798\u8779\u8787\u87A3\u8785\u8790\u8791\u879D\u8784\u8794\u879C\u879A\u8789\u891E\u8926\u8930\u892D\u892E\u8927\u8931\u8922\u8929\u8923\u892F\u892C\u891F\u89F1\u8AE0\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8AE2\u8AF2\u8AF4\u8AF5\u8ADD\u8B14\u8AE4\u8ADF\u8AF0\u8AC8\u8ADE\u8AE1\u8AE8\u8AFF\u8AEF\u8AFB\u8C91\u8C92\u8C90\u8CF5\u8CEE\u8CF1\u8CF0\u8CF3\u8D6C\u8D6E\u8DA5\u8DA7\u8E33\u8E3E\u8E38\u8E40\u8E45\u8E36\u8E3C\u8E3D\u8E41\u8E30\u8E3F\u8EBD\u8F36\u8F2E\u8F35\u8F32\u8F39\u8F37\u8F34\u9076\u9079\u907B\u9086\u90FA\u9133\u9135\u9136\u9193\u9190\u9191\u918D\u918F\u9327\u931E\u9308\u931F\u9306\u930F\u937A\u9338\u933C\u931B\u9323\u9312\u9301\u9346\u932D\u930E\u930D\u92CB\u931D\u92FA\u9325\u9313\u92F9\u92F7\u9334\u9302\u9324\u92FF\u9329\u9339\u9335\u932A\u9314\u930C\uFFFD".split("");
    for(j = 0; j != D[235].length; ++j)if (D[235][j].charCodeAt(0) !== 0xFFFD) {
        e[D[235][j]] = 60160 + j;
        d[60160 + j] = D[235][j];
    }
    D[236] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u930B\u92FE\u9309\u9300\u92FB\u9316\u95BC\u95CD\u95BE\u95B9\u95BA\u95B6\u95BF\u95B5\u95BD\u96A9\u96D4\u970B\u9712\u9710\u9799\u9797\u9794\u97F0\u97F8\u9835\u982F\u9832\u9924\u991F\u9927\u9929\u999E\u99EE\u99EC\u99E5\u99E4\u99F0\u99E3\u99EA\u99E9\u99E7\u9AB9\u9ABF\u9AB4\u9ABB\u9AF6\u9AFA\u9AF9\u9AF7\u9B33\u9B80\u9B85\u9B87\u9B7C\u9B7E\u9B7B\u9B82\u9B93\u9B92\u9B90\u9B7A\u9B95\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9B7D\u9B88\u9D25\u9D17\u9D20\u9D1E\u9D14\u9D29\u9D1D\u9D18\u9D22\u9D10\u9D19\u9D1F\u9E88\u9E86\u9E87\u9EAE\u9EAD\u9ED5\u9ED6\u9EFA\u9F12\u9F3D\u5126\u5125\u5122\u5124\u5120\u5129\u52F4\u5693\u568C\u568D\u5686\u5684\u5683\u567E\u5682\u567F\u5681\u58D6\u58D4\u58CF\u58D2\u5B2D\u5B25\u5B32\u5B23\u5B2C\u5B27\u5B26\u5B2F\u5B2E\u5B7B\u5BF1\u5BF2\u5DB7\u5E6C\u5E6A\u5FBE\u5FBB\u61C3\u61B5\u61BC\u61E7\u61E0\u61E5\u61E4\u61E8\u61DE\u64EF\u64E9\u64E3\u64EB\u64E4\u64E8\u6581\u6580\u65B6\u65DA\u66D2\u6A8D\u6A96\u6A81\u6AA5\u6A89\u6A9F\u6A9B\u6AA1\u6A9E\u6A87\u6A93\u6A8E\uFFFD".split("");
    for(j = 0; j != D[236].length; ++j)if (D[236][j].charCodeAt(0) !== 0xFFFD) {
        e[D[236][j]] = 60416 + j;
        d[60416 + j] = D[236][j];
    }
    D[237] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6A95\u6A83\u6AA8\u6AA4\u6A91\u6A7F\u6AA6\u6A9A\u6A85\u6A8C\u6A92\u6B5B\u6BAD\u6C09\u6FCC\u6FA9\u6FF4\u6FD4\u6FE3\u6FDC\u6FED\u6FE7\u6FE6\u6FDE\u6FF2\u6FDD\u6FE2\u6FE8\u71E1\u71F1\u71E8\u71F2\u71E4\u71F0\u71E2\u7373\u736E\u736F\u7497\u74B2\u74AB\u7490\u74AA\u74AD\u74B1\u74A5\u74AF\u7510\u7511\u7512\u750F\u7584\u7643\u7648\u7649\u7647\u76A4\u76E9\u77B5\u77AB\u77B2\u77B7\u77B6\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u77B4\u77B1\u77A8\u77F0\u78F3\u78FD\u7902\u78FB\u78FC\u78F2\u7905\u78F9\u78FE\u7904\u79AB\u79A8\u7A5C\u7A5B\u7A56\u7A58\u7A54\u7A5A\u7ABE\u7AC0\u7AC1\u7C05\u7C0F\u7BF2\u7C00\u7BFF\u7BFB\u7C0E\u7BF4\u7C0B\u7BF3\u7C02\u7C09\u7C03\u7C01\u7BF8\u7BFD\u7C06\u7BF0\u7BF1\u7C10\u7C0A\u7CE8\u7E2D\u7E3C\u7E42\u7E33\u9848\u7E38\u7E2A\u7E49\u7E40\u7E47\u7E29\u7E4C\u7E30\u7E3B\u7E36\u7E44\u7E3A\u7F45\u7F7F\u7F7E\u7F7D\u7FF4\u7FF2\u802C\u81BB\u81C4\u81CC\u81CA\u81C5\u81C7\u81BC\u81E9\u825B\u825A\u825C\u8583\u8580\u858F\u85A7\u8595\u85A0\u858B\u85A3\u857B\u85A4\u859A\u859E\uFFFD".split("");
    for(j = 0; j != D[237].length; ++j)if (D[237][j].charCodeAt(0) !== 0xFFFD) {
        e[D[237][j]] = 60672 + j;
        d[60672 + j] = D[237][j];
    }
    D[238] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8577\u857C\u8589\u85A1\u857A\u8578\u8557\u858E\u8596\u8586\u858D\u8599\u859D\u8581\u85A2\u8582\u8588\u8585\u8579\u8576\u8598\u8590\u859F\u8668\u87BE\u87AA\u87AD\u87C5\u87B0\u87AC\u87B9\u87B5\u87BC\u87AE\u87C9\u87C3\u87C2\u87CC\u87B7\u87AF\u87C4\u87CA\u87B4\u87B6\u87BF\u87B8\u87BD\u87DE\u87B2\u8935\u8933\u893C\u893E\u8941\u8952\u8937\u8942\u89AD\u89AF\u89AE\u89F2\u89F3\u8B1E\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8B18\u8B16\u8B11\u8B05\u8B0B\u8B22\u8B0F\u8B12\u8B15\u8B07\u8B0D\u8B08\u8B06\u8B1C\u8B13\u8B1A\u8C4F\u8C70\u8C72\u8C71\u8C6F\u8C95\u8C94\u8CF9\u8D6F\u8E4E\u8E4D\u8E53\u8E50\u8E4C\u8E47\u8F43\u8F40\u9085\u907E\u9138\u919A\u91A2\u919B\u9199\u919F\u91A1\u919D\u91A0\u93A1\u9383\u93AF\u9364\u9356\u9347\u937C\u9358\u935C\u9376\u9349\u9350\u9351\u9360\u936D\u938F\u934C\u936A\u9379\u9357\u9355\u9352\u934F\u9371\u9377\u937B\u9361\u935E\u9363\u9367\u9380\u934E\u9359\u95C7\u95C0\u95C9\u95C3\u95C5\u95B7\u96AE\u96B0\u96AC\u9720\u971F\u9718\u971D\u9719\u979A\u97A1\u979C\uFFFD".split("");
    for(j = 0; j != D[238].length; ++j)if (D[238][j].charCodeAt(0) !== 0xFFFD) {
        e[D[238][j]] = 60928 + j;
        d[60928 + j] = D[238][j];
    }
    D[239] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u979E\u979D\u97D5\u97D4\u97F1\u9841\u9844\u984A\u9849\u9845\u9843\u9925\u992B\u992C\u992A\u9933\u9932\u992F\u992D\u9931\u9930\u9998\u99A3\u99A1\u9A02\u99FA\u99F4\u99F7\u99F9\u99F8\u99F6\u99FB\u99FD\u99FE\u99FC\u9A03\u9ABE\u9AFE\u9AFD\u9B01\u9AFC\u9B48\u9B9A\u9BA8\u9B9E\u9B9B\u9BA6\u9BA1\u9BA5\u9BA4\u9B86\u9BA2\u9BA0\u9BAF\u9D33\u9D41\u9D67\u9D36\u9D2E\u9D2F\u9D31\u9D38\u9D30\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9D45\u9D42\u9D43\u9D3E\u9D37\u9D40\u9D3D\u7FF5\u9D2D\u9E8A\u9E89\u9E8D\u9EB0\u9EC8\u9EDA\u9EFB\u9EFF\u9F24\u9F23\u9F22\u9F54\u9FA0\u5131\u512D\u512E\u5698\u569C\u5697\u569A\u569D\u5699\u5970\u5B3C\u5C69\u5C6A\u5DC0\u5E6D\u5E6E\u61D8\u61DF\u61ED\u61EE\u61F1\u61EA\u61F0\u61EB\u61D6\u61E9\u64FF\u6504\u64FD\u64F8\u6501\u6503\u64FC\u6594\u65DB\u66DA\u66DB\u66D8\u6AC5\u6AB9\u6ABD\u6AE1\u6AC6\u6ABA\u6AB6\u6AB7\u6AC7\u6AB4\u6AAD\u6B5E\u6BC9\u6C0B\u7007\u700C\u700D\u7001\u7005\u7014\u700E\u6FFF\u7000\u6FFB\u7026\u6FFC\u6FF7\u700A\u7201\u71FF\u71F9\u7203\u71FD\u7376\uFFFD".split("");
    for(j = 0; j != D[239].length; ++j)if (D[239][j].charCodeAt(0) !== 0xFFFD) {
        e[D[239][j]] = 61184 + j;
        d[61184 + j] = D[239][j];
    }
    D[240] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u74B8\u74C0\u74B5\u74C1\u74BE\u74B6\u74BB\u74C2\u7514\u7513\u765C\u7664\u7659\u7650\u7653\u7657\u765A\u76A6\u76BD\u76EC\u77C2\u77BA\u78FF\u790C\u7913\u7914\u7909\u7910\u7912\u7911\u79AD\u79AC\u7A5F\u7C1C\u7C29\u7C19\u7C20\u7C1F\u7C2D\u7C1D\u7C26\u7C28\u7C22\u7C25\u7C30\u7E5C\u7E50\u7E56\u7E63\u7E58\u7E62\u7E5F\u7E51\u7E60\u7E57\u7E53\u7FB5\u7FB3\u7FF7\u7FF8\u8075\u81D1\u81D2\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u81D0\u825F\u825E\u85B4\u85C6\u85C0\u85C3\u85C2\u85B3\u85B5\u85BD\u85C7\u85C4\u85BF\u85CB\u85CE\u85C8\u85C5\u85B1\u85B6\u85D2\u8624\u85B8\u85B7\u85BE\u8669\u87E7\u87E6\u87E2\u87DB\u87EB\u87EA\u87E5\u87DF\u87F3\u87E4\u87D4\u87DC\u87D3\u87ED\u87D8\u87E3\u87A4\u87D7\u87D9\u8801\u87F4\u87E8\u87DD\u8953\u894B\u894F\u894C\u8946\u8950\u8951\u8949\u8B2A\u8B27\u8B23\u8B33\u8B30\u8B35\u8B47\u8B2F\u8B3C\u8B3E\u8B31\u8B25\u8B37\u8B26\u8B36\u8B2E\u8B24\u8B3B\u8B3D\u8B3A\u8C42\u8C75\u8C99\u8C98\u8C97\u8CFE\u8D04\u8D02\u8D00\u8E5C\u8E62\u8E60\u8E57\u8E56\u8E5E\u8E65\u8E67\uFFFD".split("");
    for(j = 0; j != D[240].length; ++j)if (D[240][j].charCodeAt(0) !== 0xFFFD) {
        e[D[240][j]] = 61440 + j;
        d[61440 + j] = D[240][j];
    }
    D[241] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8E5B\u8E5A\u8E61\u8E5D\u8E69\u8E54\u8F46\u8F47\u8F48\u8F4B\u9128\u913A\u913B\u913E\u91A8\u91A5\u91A7\u91AF\u91AA\u93B5\u938C\u9392\u93B7\u939B\u939D\u9389\u93A7\u938E\u93AA\u939E\u93A6\u9395\u9388\u9399\u939F\u938D\u93B1\u9391\u93B2\u93A4\u93A8\u93B4\u93A3\u93A5\u95D2\u95D3\u95D1\u96B3\u96D7\u96DA\u5DC2\u96DF\u96D8\u96DD\u9723\u9722\u9725\u97AC\u97AE\u97A8\u97AB\u97A4\u97AA\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u97A2\u97A5\u97D7\u97D9\u97D6\u97D8\u97FA\u9850\u9851\u9852\u98B8\u9941\u993C\u993A\u9A0F\u9A0B\u9A09\u9A0D\u9A04\u9A11\u9A0A\u9A05\u9A07\u9A06\u9AC0\u9ADC\u9B08\u9B04\u9B05\u9B29\u9B35\u9B4A\u9B4C\u9B4B\u9BC7\u9BC6\u9BC3\u9BBF\u9BC1\u9BB5\u9BB8\u9BD3\u9BB6\u9BC4\u9BB9\u9BBD\u9D5C\u9D53\u9D4F\u9D4A\u9D5B\u9D4B\u9D59\u9D56\u9D4C\u9D57\u9D52\u9D54\u9D5F\u9D58\u9D5A\u9E8E\u9E8C\u9EDF\u9F01\u9F00\u9F16\u9F25\u9F2B\u9F2A\u9F29\u9F28\u9F4C\u9F55\u5134\u5135\u5296\u52F7\u53B4\u56AB\u56AD\u56A6\u56A7\u56AA\u56AC\u58DA\u58DD\u58DB\u5912\u5B3D\u5B3E\u5B3F\u5DC3\u5E70\uFFFD".split("");
    for(j = 0; j != D[241].length; ++j)if (D[241][j].charCodeAt(0) !== 0xFFFD) {
        e[D[241][j]] = 61696 + j;
        d[61696 + j] = D[241][j];
    }
    D[242] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5FBF\u61FB\u6507\u6510\u650D\u6509\u650C\u650E\u6584\u65DE\u65DD\u66DE\u6AE7\u6AE0\u6ACC\u6AD1\u6AD9\u6ACB\u6ADF\u6ADC\u6AD0\u6AEB\u6ACF\u6ACD\u6ADE\u6B60\u6BB0\u6C0C\u7019\u7027\u7020\u7016\u702B\u7021\u7022\u7023\u7029\u7017\u7024\u701C\u702A\u720C\u720A\u7207\u7202\u7205\u72A5\u72A6\u72A4\u72A3\u72A1\u74CB\u74C5\u74B7\u74C3\u7516\u7660\u77C9\u77CA\u77C4\u77F1\u791D\u791B\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7921\u791C\u7917\u791E\u79B0\u7A67\u7A68\u7C33\u7C3C\u7C39\u7C2C\u7C3B\u7CEC\u7CEA\u7E76\u7E75\u7E78\u7E70\u7E77\u7E6F\u7E7A\u7E72\u7E74\u7E68\u7F4B\u7F4A\u7F83\u7F86\u7FB7\u7FFD\u7FFE\u8078\u81D7\u81D5\u8264\u8261\u8263\u85EB\u85F1\u85ED\u85D9\u85E1\u85E8\u85DA\u85D7\u85EC\u85F2\u85F8\u85D8\u85DF\u85E3\u85DC\u85D1\u85F0\u85E6\u85EF\u85DE\u85E2\u8800\u87FA\u8803\u87F6\u87F7\u8809\u880C\u880B\u8806\u87FC\u8808\u87FF\u880A\u8802\u8962\u895A\u895B\u8957\u8961\u895C\u8958\u895D\u8959\u8988\u89B7\u89B6\u89F6\u8B50\u8B48\u8B4A\u8B40\u8B53\u8B56\u8B54\u8B4B\u8B55\uFFFD".split("");
    for(j = 0; j != D[242].length; ++j)if (D[242][j].charCodeAt(0) !== 0xFFFD) {
        e[D[242][j]] = 61952 + j;
        d[61952 + j] = D[242][j];
    }
    D[243] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8B51\u8B42\u8B52\u8B57\u8C43\u8C77\u8C76\u8C9A\u8D06\u8D07\u8D09\u8DAC\u8DAA\u8DAD\u8DAB\u8E6D\u8E78\u8E73\u8E6A\u8E6F\u8E7B\u8EC2\u8F52\u8F51\u8F4F\u8F50\u8F53\u8FB4\u9140\u913F\u91B0\u91AD\u93DE\u93C7\u93CF\u93C2\u93DA\u93D0\u93F9\u93EC\u93CC\u93D9\u93A9\u93E6\u93CA\u93D4\u93EE\u93E3\u93D5\u93C4\u93CE\u93C0\u93D2\u93E7\u957D\u95DA\u95DB\u96E1\u9729\u972B\u972C\u9728\u9726\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u97B3\u97B7\u97B6\u97DD\u97DE\u97DF\u985C\u9859\u985D\u9857\u98BF\u98BD\u98BB\u98BE\u9948\u9947\u9943\u99A6\u99A7\u9A1A\u9A15\u9A25\u9A1D\u9A24\u9A1B\u9A22\u9A20\u9A27\u9A23\u9A1E\u9A1C\u9A14\u9AC2\u9B0B\u9B0A\u9B0E\u9B0C\u9B37\u9BEA\u9BEB\u9BE0\u9BDE\u9BE4\u9BE6\u9BE2\u9BF0\u9BD4\u9BD7\u9BEC\u9BDC\u9BD9\u9BE5\u9BD5\u9BE1\u9BDA\u9D77\u9D81\u9D8A\u9D84\u9D88\u9D71\u9D80\u9D78\u9D86\u9D8B\u9D8C\u9D7D\u9D6B\u9D74\u9D75\u9D70\u9D69\u9D85\u9D73\u9D7B\u9D82\u9D6F\u9D79\u9D7F\u9D87\u9D68\u9E94\u9E91\u9EC0\u9EFC\u9F2D\u9F40\u9F41\u9F4D\u9F56\u9F57\u9F58\u5337\u56B2\uFFFD".split("");
    for(j = 0; j != D[243].length; ++j)if (D[243][j].charCodeAt(0) !== 0xFFFD) {
        e[D[243][j]] = 62208 + j;
        d[62208 + j] = D[243][j];
    }
    D[244] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u56B5\u56B3\u58E3\u5B45\u5DC6\u5DC7\u5EEE\u5EEF\u5FC0\u5FC1\u61F9\u6517\u6516\u6515\u6513\u65DF\u66E8\u66E3\u66E4\u6AF3\u6AF0\u6AEA\u6AE8\u6AF9\u6AF1\u6AEE\u6AEF\u703C\u7035\u702F\u7037\u7034\u7031\u7042\u7038\u703F\u703A\u7039\u7040\u703B\u7033\u7041\u7213\u7214\u72A8\u737D\u737C\u74BA\u76AB\u76AA\u76BE\u76ED\u77CC\u77CE\u77CF\u77CD\u77F2\u7925\u7923\u7927\u7928\u7924\u7929\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u79B2\u7A6E\u7A6C\u7A6D\u7AF7\u7C49\u7C48\u7C4A\u7C47\u7C45\u7CEE\u7E7B\u7E7E\u7E81\u7E80\u7FBA\u7FFF\u8079\u81DB\u81D9\u820B\u8268\u8269\u8622\u85FF\u8601\u85FE\u861B\u8600\u85F6\u8604\u8609\u8605\u860C\u85FD\u8819\u8810\u8811\u8817\u8813\u8816\u8963\u8966\u89B9\u89F7\u8B60\u8B6A\u8B5D\u8B68\u8B63\u8B65\u8B67\u8B6D\u8DAE\u8E86\u8E88\u8E84\u8F59\u8F56\u8F57\u8F55\u8F58\u8F5A\u908D\u9143\u9141\u91B7\u91B5\u91B2\u91B3\u940B\u9413\u93FB\u9420\u940F\u9414\u93FE\u9415\u9410\u9428\u9419\u940D\u93F5\u9400\u93F7\u9407\u940E\u9416\u9412\u93FA\u9409\u93F8\u940A\u93FF\uFFFD".split("");
    for(j = 0; j != D[244].length; ++j)if (D[244][j].charCodeAt(0) !== 0xFFFD) {
        e[D[244][j]] = 62464 + j;
        d[62464 + j] = D[244][j];
    }
    D[245] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u93FC\u940C\u93F6\u9411\u9406\u95DE\u95E0\u95DF\u972E\u972F\u97B9\u97BB\u97FD\u97FE\u9860\u9862\u9863\u985F\u98C1\u98C2\u9950\u994E\u9959\u994C\u994B\u9953\u9A32\u9A34\u9A31\u9A2C\u9A2A\u9A36\u9A29\u9A2E\u9A38\u9A2D\u9AC7\u9ACA\u9AC6\u9B10\u9B12\u9B11\u9C0B\u9C08\u9BF7\u9C05\u9C12\u9BF8\u9C40\u9C07\u9C0E\u9C06\u9C17\u9C14\u9C09\u9D9F\u9D99\u9DA4\u9D9D\u9D92\u9D98\u9D90\u9D9B\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9DA0\u9D94\u9D9C\u9DAA\u9D97\u9DA1\u9D9A\u9DA2\u9DA8\u9D9E\u9DA3\u9DBF\u9DA9\u9D96\u9DA6\u9DA7\u9E99\u9E9B\u9E9A\u9EE5\u9EE4\u9EE7\u9EE6\u9F30\u9F2E\u9F5B\u9F60\u9F5E\u9F5D\u9F59\u9F91\u513A\u5139\u5298\u5297\u56C3\u56BD\u56BE\u5B48\u5B47\u5DCB\u5DCF\u5EF1\u61FD\u651B\u6B02\u6AFC\u6B03\u6AF8\u6B00\u7043\u7044\u704A\u7048\u7049\u7045\u7046\u721D\u721A\u7219\u737E\u7517\u766A\u77D0\u792D\u7931\u792F\u7C54\u7C53\u7CF2\u7E8A\u7E87\u7E88\u7E8B\u7E86\u7E8D\u7F4D\u7FBB\u8030\u81DD\u8618\u862A\u8626\u861F\u8623\u861C\u8619\u8627\u862E\u8621\u8620\u8629\u861E\u8625\uFFFD".split("");
    for(j = 0; j != D[245].length; ++j)if (D[245][j].charCodeAt(0) !== 0xFFFD) {
        e[D[245][j]] = 62720 + j;
        d[62720 + j] = D[245][j];
    }
    D[246] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8829\u881D\u881B\u8820\u8824\u881C\u882B\u884A\u896D\u8969\u896E\u896B\u89FA\u8B79\u8B78\u8B45\u8B7A\u8B7B\u8D10\u8D14\u8DAF\u8E8E\u8E8C\u8F5E\u8F5B\u8F5D\u9146\u9144\u9145\u91B9\u943F\u943B\u9436\u9429\u943D\u943C\u9430\u9439\u942A\u9437\u942C\u9440\u9431\u95E5\u95E4\u95E3\u9735\u973A\u97BF\u97E1\u9864\u98C9\u98C6\u98C0\u9958\u9956\u9A39\u9A3D\u9A46\u9A44\u9A42\u9A41\u9A3A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9A3F\u9ACD\u9B15\u9B17\u9B18\u9B16\u9B3A\u9B52\u9C2B\u9C1D\u9C1C\u9C2C\u9C23\u9C28\u9C29\u9C24\u9C21\u9DB7\u9DB6\u9DBC\u9DC1\u9DC7\u9DCA\u9DCF\u9DBE\u9DC5\u9DC3\u9DBB\u9DB5\u9DCE\u9DB9\u9DBA\u9DAC\u9DC8\u9DB1\u9DAD\u9DCC\u9DB3\u9DCD\u9DB2\u9E7A\u9E9C\u9EEB\u9EEE\u9EED\u9F1B\u9F18\u9F1A\u9F31\u9F4E\u9F65\u9F64\u9F92\u4EB9\u56C6\u56C5\u56CB\u5971\u5B4B\u5B4C\u5DD5\u5DD1\u5EF2\u6521\u6520\u6526\u6522\u6B0B\u6B08\u6B09\u6C0D\u7055\u7056\u7057\u7052\u721E\u721F\u72A9\u737F\u74D8\u74D5\u74D9\u74D7\u766D\u76AD\u7935\u79B4\u7A70\u7A71\u7C57\u7C5C\u7C59\u7C5B\u7C5A\uFFFD".split("");
    for(j = 0; j != D[246].length; ++j)if (D[246][j].charCodeAt(0) !== 0xFFFD) {
        e[D[246][j]] = 62976 + j;
        d[62976 + j] = D[246][j];
    }
    D[247] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7CF4\u7CF1\u7E91\u7F4F\u7F87\u81DE\u826B\u8634\u8635\u8633\u862C\u8632\u8636\u882C\u8828\u8826\u882A\u8825\u8971\u89BF\u89BE\u89FB\u8B7E\u8B84\u8B82\u8B86\u8B85\u8B7F\u8D15\u8E95\u8E94\u8E9A\u8E92\u8E90\u8E96\u8E97\u8F60\u8F62\u9147\u944C\u9450\u944A\u944B\u944F\u9447\u9445\u9448\u9449\u9446\u973F\u97E3\u986A\u9869\u98CB\u9954\u995B\u9A4E\u9A53\u9A54\u9A4C\u9A4F\u9A48\u9A4A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9A49\u9A52\u9A50\u9AD0\u9B19\u9B2B\u9B3B\u9B56\u9B55\u9C46\u9C48\u9C3F\u9C44\u9C39\u9C33\u9C41\u9C3C\u9C37\u9C34\u9C32\u9C3D\u9C36\u9DDB\u9DD2\u9DDE\u9DDA\u9DCB\u9DD0\u9DDC\u9DD1\u9DDF\u9DE9\u9DD9\u9DD8\u9DD6\u9DF5\u9DD5\u9DDD\u9EB6\u9EF0\u9F35\u9F33\u9F32\u9F42\u9F6B\u9F95\u9FA2\u513D\u5299\u58E8\u58E7\u5972\u5B4D\u5DD8\u882F\u5F4F\u6201\u6203\u6204\u6529\u6525\u6596\u66EB\u6B11\u6B12\u6B0F\u6BCA\u705B\u705A\u7222\u7382\u7381\u7383\u7670\u77D4\u7C67\u7C66\u7E95\u826C\u863A\u8640\u8639\u863C\u8631\u863B\u863E\u8830\u8832\u882E\u8833\u8976\u8974\u8973\u89FE\uFFFD".split("");
    for(j = 0; j != D[247].length; ++j)if (D[247][j].charCodeAt(0) !== 0xFFFD) {
        e[D[247][j]] = 63232 + j;
        d[63232 + j] = D[247][j];
    }
    D[248] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8B8C\u8B8E\u8B8B\u8B88\u8C45\u8D19\u8E98\u8F64\u8F63\u91BC\u9462\u9455\u945D\u9457\u945E\u97C4\u97C5\u9800\u9A56\u9A59\u9B1E\u9B1F\u9B20\u9C52\u9C58\u9C50\u9C4A\u9C4D\u9C4B\u9C55\u9C59\u9C4C\u9C4E\u9DFB\u9DF7\u9DEF\u9DE3\u9DEB\u9DF8\u9DE4\u9DF6\u9DE1\u9DEE\u9DE6\u9DF2\u9DF0\u9DE2\u9DEC\u9DF4\u9DF3\u9DE8\u9DED\u9EC2\u9ED0\u9EF2\u9EF3\u9F06\u9F1C\u9F38\u9F37\u9F36\u9F43\u9F4F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9F71\u9F70\u9F6E\u9F6F\u56D3\u56CD\u5B4E\u5C6D\u652D\u66ED\u66EE\u6B13\u705F\u7061\u705D\u7060\u7223\u74DB\u74E5\u77D5\u7938\u79B7\u79B6\u7C6A\u7E97\u7F89\u826D\u8643\u8838\u8837\u8835\u884B\u8B94\u8B95\u8E9E\u8E9F\u8EA0\u8E9D\u91BE\u91BD\u91C2\u946B\u9468\u9469\u96E5\u9746\u9743\u9747\u97C7\u97E5\u9A5E\u9AD5\u9B59\u9C63\u9C67\u9C66\u9C62\u9C5E\u9C60\u9E02\u9DFE\u9E07\u9E03\u9E06\u9E05\u9E00\u9E01\u9E09\u9DFF\u9DFD\u9E04\u9EA0\u9F1E\u9F46\u9F74\u9F75\u9F76\u56D4\u652E\u65B8\u6B18\u6B19\u6B17\u6B1A\u7062\u7226\u72AA\u77D8\u77D9\u7939\u7C69\u7C6B\u7CF6\u7E9A\uFFFD".split("");
    for(j = 0; j != D[248].length; ++j)if (D[248][j].charCodeAt(0) !== 0xFFFD) {
        e[D[248][j]] = 63488 + j;
        d[63488 + j] = D[248][j];
    }
    D[249] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7E98\u7E9B\u7E99\u81E0\u81E1\u8646\u8647\u8648\u8979\u897A\u897C\u897B\u89FF\u8B98\u8B99\u8EA5\u8EA4\u8EA3\u946E\u946D\u946F\u9471\u9473\u9749\u9872\u995F\u9C68\u9C6E\u9C6D\u9E0B\u9E0D\u9E10\u9E0F\u9E12\u9E11\u9EA1\u9EF5\u9F09\u9F47\u9F78\u9F7B\u9F7A\u9F79\u571E\u7066\u7C6F\u883C\u8DB2\u8EA6\u91C3\u9474\u9478\u9476\u9475\u9A60\u9C74\u9C73\u9C71\u9C75\u9E14\u9E13\u9EF6\u9F0A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9FA4\u7068\u7065\u7CF7\u866A\u883E\u883D\u883F\u8B9E\u8C9C\u8EA9\u8EC9\u974B\u9873\u9874\u98CC\u9961\u99AB\u9A64\u9A66\u9A67\u9B24\u9E15\u9E17\u9F48\u6207\u6B1E\u7227\u864C\u8EA8\u9482\u9480\u9481\u9A69\u9A68\u9B2E\u9E19\u7229\u864B\u8B9F\u9483\u9C79\u9EB7\u7675\u9A6B\u9C7A\u9E1D\u7069\u706A\u9EA4\u9F7E\u9F49\u9F98\u7881\u92B9\u88CF\u58BB\u6052\u7CA7\u5AFA\u2554\u2566\u2557\u2560\u256C\u2563\u255A\u2569\u255D\u2552\u2564\u2555\u255E\u256A\u2561\u2558\u2567\u255B\u2553\u2565\u2556\u255F\u256B\u2562\u2559\u2568\u255C\u2551\u2550\u256D\u256E\u2570\u256F\u2593\uFFFD".split("");
    for(j = 0; j != D[249].length; ++j)if (D[249][j].charCodeAt(0) !== 0xFFFD) {
        e[D[249][j]] = 63744 + j;
        d[63744 + j] = D[249][j];
    }
    return {
        "enc": e,
        "dec": d
    };
}();
$e1f740a9d01acc72$var$cptable[1250] = function() {
    var d = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\u20AC\uFFFD\u201A\uFFFD\u201E\u2026\u2020\u2021\uFFFD\u2030\u0160\u2039\u015A\u0164\u017D\u0179\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\u2122\u0161\u203A\u015B\u0165\u017E\u017A\xa0\u02C7\u02D8\u0141\xa4\u0104\xa6\xa7\xa8\xa9\u015E\xab\xac\xad\xae\u017B\xb0\xb1\u02DB\u0142\xb4\xb5\xb6\xb7\xb8\u0105\u015F\xbb\u013D\u02DD\u013E\u017C\u0154\xc1\xc2\u0102\xc4\u0139\u0106\xc7\u010C\xc9\u0118\xcb\u011A\xcd\xce\u010E\u0110\u0143\u0147\xd3\xd4\u0150\xd6\xd7\u0158\u016E\xda\u0170\xdc\xdd\u0162\xdf\u0155\xe1\xe2\u0103\xe4\u013A\u0107\xe7\u010D\xe9\u0119\xeb\u011B\xed\xee\u010F\u0111\u0144\u0148\xf3\xf4\u0151\xf6\xf7\u0159\u016F\xfa\u0171\xfc\xfd\u0163\u02D9", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
$e1f740a9d01acc72$var$cptable[1251] = function() {
    var d = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\u0402\u0403\u201A\u0453\u201E\u2026\u2020\u2021\u20AC\u2030\u0409\u2039\u040A\u040C\u040B\u040F\u0452\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\u2122\u0459\u203A\u045A\u045C\u045B\u045F\xa0\u040E\u045E\u0408\xa4\u0490\xa6\xa7\u0401\xa9\u0404\xab\xac\xad\xae\u0407\xb0\xb1\u0406\u0456\u0491\xb5\xb6\xb7\u0451\u2116\u0454\xbb\u0458\u0405\u0455\u0457\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
$e1f740a9d01acc72$var$cptable[1252] = function() {
    var d = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\u20AC\uFFFD\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\u0160\u2039\u0152\uFFFD\u017D\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\u0161\u203A\u0153\uFFFD\u017E\u0178\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\xd0\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\xdd\xde\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\xf0\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\xfd\xfe\xff", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
$e1f740a9d01acc72$var$cptable[1253] = function() {
    var d = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\u20AC\uFFFD\u201A\u0192\u201E\u2026\u2020\u2021\uFFFD\u2030\uFFFD\u2039\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\u2122\uFFFD\u203A\uFFFD\uFFFD\uFFFD\uFFFD\xa0\u0385\u0386\xa3\xa4\xa5\xa6\xa7\xa8\xa9\uFFFD\xab\xac\xad\xae\u2015\xb0\xb1\xb2\xb3\u0384\xb5\xb6\xb7\u0388\u0389\u038A\xbb\u038C\xbd\u038E\u038F\u0390\u0391\u0392\u0393\u0394\u0395\u0396\u0397\u0398\u0399\u039A\u039B\u039C\u039D\u039E\u039F\u03A0\u03A1\uFFFD\u03A3\u03A4\u03A5\u03A6\u03A7\u03A8\u03A9\u03AA\u03AB\u03AC\u03AD\u03AE\u03AF\u03B0\u03B1\u03B2\u03B3\u03B4\u03B5\u03B6\u03B7\u03B8\u03B9\u03BA\u03BB\u03BC\u03BD\u03BE\u03BF\u03C0\u03C1\u03C2\u03C3\u03C4\u03C5\u03C6\u03C7\u03C8\u03C9\u03CA\u03CB\u03CC\u03CD\u03CE\uFFFD", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
$e1f740a9d01acc72$var$cptable[1254] = function() {
    var d = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\u20AC\uFFFD\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\u0160\u2039\u0152\uFFFD\uFFFD\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\u0161\u203A\u0153\uFFFD\uFFFD\u0178\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\u011E\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\u0130\u015E\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\u011F\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\u0131\u015F\xff", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
$e1f740a9d01acc72$var$cptable[1255] = function() {
    var d = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\u20AC\uFFFD\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\uFFFD\u2039\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\uFFFD\u203A\uFFFD\uFFFD\uFFFD\uFFFD\xa0\xa1\xa2\xa3\u20AA\xa5\xa6\xa7\xa8\xa9\xd7\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xf7\xbb\xbc\xbd\xbe\xbf\u05B0\u05B1\u05B2\u05B3\u05B4\u05B5\u05B6\u05B7\u05B8\u05B9\uFFFD\u05BB\u05BC\u05BD\u05BE\u05BF\u05C0\u05C1\u05C2\u05C3\u05F0\u05F1\u05F2\u05F3\u05F4\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u05D0\u05D1\u05D2\u05D3\u05D4\u05D5\u05D6\u05D7\u05D8\u05D9\u05DA\u05DB\u05DC\u05DD\u05DE\u05DF\u05E0\u05E1\u05E2\u05E3\u05E4\u05E5\u05E6\u05E7\u05E8\u05E9\u05EA\uFFFD\uFFFD\u200E\u200F\uFFFD", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
$e1f740a9d01acc72$var$cptable[1256] = function() {
    var d = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\u20AC\u067E\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\u0679\u2039\u0152\u0686\u0698\u0688\u06AF\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u06A9\u2122\u0691\u203A\u0153\u200C\u200D\u06BA\xa0\u060C\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\u06BE\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\u061B\xbb\xbc\xbd\xbe\u061F\u06C1\u0621\u0622\u0623\u0624\u0625\u0626\u0627\u0628\u0629\u062A\u062B\u062C\u062D\u062E\u062F\u0630\u0631\u0632\u0633\u0634\u0635\u0636\xd7\u0637\u0638\u0639\u063A\u0640\u0641\u0642\u0643\xe0\u0644\xe2\u0645\u0646\u0647\u0648\xe7\xe8\xe9\xea\xeb\u0649\u064A\xee\xef\u064B\u064C\u064D\u064E\xf4\u064F\u0650\xf7\u0651\xf9\u0652\xfb\xfc\u200E\u200F\u06D2", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
$e1f740a9d01acc72$var$cptable[1257] = function() {
    var d = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\u20AC\uFFFD\u201A\uFFFD\u201E\u2026\u2020\u2021\uFFFD\u2030\uFFFD\u2039\uFFFD\xa8\u02C7\xb8\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\u2122\uFFFD\u203A\uFFFD\xaf\u02DB\uFFFD\xa0\uFFFD\xa2\xa3\xa4\uFFFD\xa6\xa7\xd8\xa9\u0156\xab\xac\xad\xae\xc6\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xf8\xb9\u0157\xbb\xbc\xbd\xbe\xe6\u0104\u012E\u0100\u0106\xc4\xc5\u0118\u0112\u010C\xc9\u0179\u0116\u0122\u0136\u012A\u013B\u0160\u0143\u0145\xd3\u014C\xd5\xd6\xd7\u0172\u0141\u015A\u016A\xdc\u017B\u017D\xdf\u0105\u012F\u0101\u0107\xe4\xe5\u0119\u0113\u010D\xe9\u017A\u0117\u0123\u0137\u012B\u013C\u0161\u0144\u0146\xf3\u014D\xf5\xf6\xf7\u0173\u0142\u015B\u016B\xfc\u017C\u017E\u02D9", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
$e1f740a9d01acc72$var$cptable[1258] = function() {
    var d = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\u20AC\uFFFD\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\uFFFD\u2039\u0152\uFFFD\uFFFD\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\uFFFD\u203A\u0153\uFFFD\uFFFD\u0178\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\u0102\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\u0300\xcd\xce\xcf\u0110\xd1\u0309\xd3\xd4\u01A0\xd6\xd7\xd8\xd9\xda\xdb\xdc\u01AF\u0303\xdf\xe0\xe1\xe2\u0103\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\u0301\xed\xee\xef\u0111\xf1\u0323\xf3\xf4\u01A1\xf6\xf7\xf8\xf9\xfa\xfb\xfc\u01B0\u20AB\xff", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
$e1f740a9d01acc72$var$cptable[10000] = function() {
    var d = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u2126\xe6\xf8\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u2044\xa4\u2039\u203A\uFB01\uFB02\u2021\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uFFFD\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
$e1f740a9d01acc72$var$cptable[10006] = function() {
    var d = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\xc4\xb9\xb2\xc9\xb3\xd6\xdc\u0385\xe0\xe2\xe4\u0384\xa8\xe7\xe9\xe8\xea\xeb\xa3\u2122\xee\xef\u2022\xbd\u2030\xf4\xf6\xa6\xad\xf9\xfb\xfc\u2020\u0393\u0394\u0398\u039B\u039E\u03A0\xdf\xae\xa9\u03A3\u03AA\xa7\u2260\xb0\u0387\u0391\xb1\u2264\u2265\xa5\u0392\u0395\u0396\u0397\u0399\u039A\u039C\u03A6\u03AB\u03A8\u03A9\u03AC\u039D\xac\u039F\u03A1\u2248\u03A4\xab\xbb\u2026\xa0\u03A5\u03A7\u0386\u0388\u0153\u2013\u2015\u201C\u201D\u2018\u2019\xf7\u0389\u038A\u038C\u038E\u03AD\u03AE\u03AF\u03CC\u038F\u03CD\u03B1\u03B2\u03C8\u03B4\u03B5\u03C6\u03B3\u03B7\u03B9\u03BE\u03BA\u03BB\u03BC\u03BD\u03BF\u03C0\u03CE\u03C1\u03C3\u03C4\u03B8\u03C9\u03C2\u03C7\u03C5\u03B6\u03CA\u03CB\u0390\u03B0\uFFFD", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
$e1f740a9d01acc72$var$cptable[10007] = function() {
    var d = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u2020\xb0\xa2\xa3\xa7\u2022\xb6\u0406\xae\xa9\u2122\u0402\u0452\u2260\u0403\u0453\u221E\xb1\u2264\u2265\u0456\xb5\u2202\u0408\u0404\u0454\u0407\u0457\u0409\u0459\u040A\u045A\u0458\u0405\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\u040B\u045B\u040C\u045C\u0455\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u201E\u040E\u045E\u040F\u045F\u2116\u0401\u0451\u044F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\xa4", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
$e1f740a9d01acc72$var$cptable[10008] = function() {
    var d = [], e = {}, D = [], j;
    D[0] = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\x80\uF8D8\uF8D9\uF8DA\uF8DB\uF8DC\uF8DD\uF8DE\uF8DF\uF8E0\uF8E1\uF8E2\uF8E3\uF8E4\uF8E5\uF8E6\uF8E7\uF8E8\uF8E9\uF8EA\uF8EB\uF8EC\uF8ED\uF8EE\uF8EF\uF8F0\uF8F1\uF8F2\uF8F3\uF8F4\uF8F5\uF8F6\uF8F7\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uF8F8\uF8F9\uF8FA\uF8FB\uF8FC\uF8FD\uF8FE\uF8FF".split("");
    for(j = 0; j != D[0].length; ++j)if (D[0][j].charCodeAt(0) !== 0xFFFD) {
        e[D[0][j]] = 0 + j;
        d[0 + j] = D[0][j];
    }
    D[161] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u3000\u3001\u3002\u30FB\u02C9\u02C7\xa8\u3003\u3005\u2015\uFF5E\uFFFD\u2026\u2018\u2019\u201C\u201D\u3014\u3015\u3008\u3009\u300A\u300B\u300C\u300D\u300E\u300F\u3016\u3017\u3010\u3011\xb1\xd7\xf7\u2236\u2227\u2228\u2211\u220F\u222A\u2229\u2208\u2237\u221A\u22A5\u2225\u2220\u2312\u2299\u222B\u222E\u2261\u224C\u2248\u223D\u221D\u2260\u226E\u226F\u2264\u2265\u221E\u2235\u2234\u2642\u2640\xb0\u2032\u2033\u2103\uFF04\xa4\uFFE0\uFFE1\u2030\xa7\u2116\u2606\u2605\u25CB\u25CF\u25CE\u25C7\u25C6\u25A1\u25A0\u25B3\u25B2\u203B\u2192\u2190\u2191\u2193\u3013\uFFFD".split("");
    for(j = 0; j != D[161].length; ++j)if (D[161][j].charCodeAt(0) !== 0xFFFD) {
        e[D[161][j]] = 41216 + j;
        d[41216 + j] = D[161][j];
    }
    D[162] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2488\u2489\u248A\u248B\u248C\u248D\u248E\u248F\u2490\u2491\u2492\u2493\u2494\u2495\u2496\u2497\u2498\u2499\u249A\u249B\u2474\u2475\u2476\u2477\u2478\u2479\u247A\u247B\u247C\u247D\u247E\u247F\u2480\u2481\u2482\u2483\u2484\u2485\u2486\u2487\u2460\u2461\u2462\u2463\u2464\u2465\u2466\u2467\u2468\u2469\uFFFD\uFFFD\u3220\u3221\u3222\u3223\u3224\u3225\u3226\u3227\u3228\u3229\uFFFD\uFFFD\u2160\u2161\u2162\u2163\u2164\u2165\u2166\u2167\u2168\u2169\u216A\u216B\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[162].length; ++j)if (D[162][j].charCodeAt(0) !== 0xFFFD) {
        e[D[162][j]] = 41472 + j;
        d[41472 + j] = D[162][j];
    }
    D[163] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFF01\uFF02\uFF03\uFFE5\uFF05\uFF06\uFF07\uFF08\uFF09\uFF0A\uFF0B\uFF0C\uFF0D\uFF0E\uFF0F\uFF10\uFF11\uFF12\uFF13\uFF14\uFF15\uFF16\uFF17\uFF18\uFF19\uFF1A\uFF1B\uFF1C\uFF1D\uFF1E\uFF1F\uFF20\uFF21\uFF22\uFF23\uFF24\uFF25\uFF26\uFF27\uFF28\uFF29\uFF2A\uFF2B\uFF2C\uFF2D\uFF2E\uFF2F\uFF30\uFF31\uFF32\uFF33\uFF34\uFF35\uFF36\uFF37\uFF38\uFF39\uFF3A\uFF3B\uFF3C\uFF3D\uFF3E\uFF3F\uFF40\uFF41\uFF42\uFF43\uFF44\uFF45\uFF46\uFF47\uFF48\uFF49\uFF4A\uFF4B\uFF4C\uFF4D\uFF4E\uFF4F\uFF50\uFF51\uFF52\uFF53\uFF54\uFF55\uFF56\uFF57\uFF58\uFF59\uFF5A\uFF5B\uFF5C\uFF5D\uFFE3\uFFFD".split("");
    for(j = 0; j != D[163].length; ++j)if (D[163][j].charCodeAt(0) !== 0xFFFD) {
        e[D[163][j]] = 41728 + j;
        d[41728 + j] = D[163][j];
    }
    D[164] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u3041\u3042\u3043\u3044\u3045\u3046\u3047\u3048\u3049\u304A\u304B\u304C\u304D\u304E\u304F\u3050\u3051\u3052\u3053\u3054\u3055\u3056\u3057\u3058\u3059\u305A\u305B\u305C\u305D\u305E\u305F\u3060\u3061\u3062\u3063\u3064\u3065\u3066\u3067\u3068\u3069\u306A\u306B\u306C\u306D\u306E\u306F\u3070\u3071\u3072\u3073\u3074\u3075\u3076\u3077\u3078\u3079\u307A\u307B\u307C\u307D\u307E\u307F\u3080\u3081\u3082\u3083\u3084\u3085\u3086\u3087\u3088\u3089\u308A\u308B\u308C\u308D\u308E\u308F\u3090\u3091\u3092\u3093\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[164].length; ++j)if (D[164][j].charCodeAt(0) !== 0xFFFD) {
        e[D[164][j]] = 41984 + j;
        d[41984 + j] = D[164][j];
    }
    D[165] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u30A1\u30A2\u30A3\u30A4\u30A5\u30A6\u30A7\u30A8\u30A9\u30AA\u30AB\u30AC\u30AD\u30AE\u30AF\u30B0\u30B1\u30B2\u30B3\u30B4\u30B5\u30B6\u30B7\u30B8\u30B9\u30BA\u30BB\u30BC\u30BD\u30BE\u30BF\u30C0\u30C1\u30C2\u30C3\u30C4\u30C5\u30C6\u30C7\u30C8\u30C9\u30CA\u30CB\u30CC\u30CD\u30CE\u30CF\u30D0\u30D1\u30D2\u30D3\u30D4\u30D5\u30D6\u30D7\u30D8\u30D9\u30DA\u30DB\u30DC\u30DD\u30DE\u30DF\u30E0\u30E1\u30E2\u30E3\u30E4\u30E5\u30E6\u30E7\u30E8\u30E9\u30EA\u30EB\u30EC\u30ED\u30EE\u30EF\u30F0\u30F1\u30F2\u30F3\u30F4\u30F5\u30F6\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[165].length; ++j)if (D[165][j].charCodeAt(0) !== 0xFFFD) {
        e[D[165][j]] = 42240 + j;
        d[42240 + j] = D[165][j];
    }
    D[166] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0391\u0392\u0393\u0394\u0395\u0396\u0397\u0398\u0399\u039A\u039B\u039C\u039D\u039E\u039F\u03A0\u03A1\u03A3\u03A4\u03A5\u03A6\u03A7\u03A8\u03A9\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u03B1\u03B2\u03B3\u03B4\u03B5\u03B6\u03B7\u03B8\u03B9\u03BA\u03BB\u03BC\u03BD\u03BE\u03BF\u03C0\u03C1\u03C3\u03C4\u03C5\u03C6\u03C7\u03C8\u03C9\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[166].length; ++j)if (D[166][j].charCodeAt(0) !== 0xFFFD) {
        e[D[166][j]] = 42496 + j;
        d[42496 + j] = D[166][j];
    }
    D[167] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0410\u0411\u0412\u0413\u0414\u0415\u0401\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0430\u0431\u0432\u0433\u0434\u0435\u0451\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[167].length; ++j)if (D[167][j].charCodeAt(0) !== 0xFFFD) {
        e[D[167][j]] = 42752 + j;
        d[42752 + j] = D[167][j];
    }
    D[168] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0101\xe1\u01CE\xe0\u0113\xe9\u011B\xe8\u012B\xed\u01D0\xec\u014D\xf3\u01D2\xf2\u016B\xfa\u01D4\xf9\u01D6\u01D8\u01DA\u01DC\xfc\xea\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u3105\u3106\u3107\u3108\u3109\u310A\u310B\u310C\u310D\u310E\u310F\u3110\u3111\u3112\u3113\u3114\u3115\u3116\u3117\u3118\u3119\u311A\u311B\u311C\u311D\u311E\u311F\u3120\u3121\u3122\u3123\u3124\u3125\u3126\u3127\u3128\u3129\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[168].length; ++j)if (D[168][j].charCodeAt(0) !== 0xFFFD) {
        e[D[168][j]] = 43008 + j;
        d[43008 + j] = D[168][j];
    }
    D[169] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2500\u2501\u2502\u2503\u2504\u2505\u2506\u2507\u2508\u2509\u250A\u250B\u250C\u250D\u250E\u250F\u2510\u2511\u2512\u2513\u2514\u2515\u2516\u2517\u2518\u2519\u251A\u251B\u251C\u251D\u251E\u251F\u2520\u2521\u2522\u2523\u2524\u2525\u2526\u2527\u2528\u2529\u252A\u252B\u252C\u252D\u252E\u252F\u2530\u2531\u2532\u2533\u2534\u2535\u2536\u2537\u2538\u2539\u253A\u253B\u253C\u253D\u253E\u253F\u2540\u2541\u2542\u2543\u2544\u2545\u2546\u2547\u2548\u2549\u254A\u254B\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[169].length; ++j)if (D[169][j].charCodeAt(0) !== 0xFFFD) {
        e[D[169][j]] = 43264 + j;
        d[43264 + j] = D[169][j];
    }
    D[176] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u554A\u963F\u57C3\u6328\u54CE\u5509\u54C0\u7691\u764C\u853C\u77EE\u827E\u788D\u7231\u9698\u978D\u6C28\u5B89\u4FFA\u6309\u6697\u5CB8\u80FA\u6848\u80AE\u6602\u76CE\u51F9\u6556\u71AC\u7FF1\u8884\u50B2\u5965\u61CA\u6FB3\u82AD\u634C\u6252\u53ED\u5427\u7B06\u516B\u75A4\u5DF4\u62D4\u8DCB\u9776\u628A\u8019\u575D\u9738\u7F62\u7238\u767D\u67CF\u767E\u6446\u4F70\u8D25\u62DC\u7A17\u6591\u73ED\u642C\u6273\u822C\u9881\u677F\u7248\u626E\u62CC\u4F34\u74E3\u534A\u529E\u7ECA\u90A6\u5E2E\u6886\u699C\u8180\u7ED1\u68D2\u78C5\u868C\u9551\u508D\u8C24\u82DE\u80DE\u5305\u8912\u5265\uFFFD".split("");
    for(j = 0; j != D[176].length; ++j)if (D[176][j].charCodeAt(0) !== 0xFFFD) {
        e[D[176][j]] = 45056 + j;
        d[45056 + j] = D[176][j];
    }
    D[177] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8584\u96F9\u4FDD\u5821\u9971\u5B9D\u62B1\u62A5\u66B4\u8C79\u9C8D\u7206\u676F\u7891\u60B2\u5351\u5317\u8F88\u80CC\u8D1D\u94A1\u500D\u72C8\u5907\u60EB\u7119\u88AB\u5954\u82EF\u672C\u7B28\u5D29\u7EF7\u752D\u6CF5\u8E66\u8FF8\u903C\u9F3B\u6BD4\u9119\u7B14\u5F7C\u78A7\u84D6\u853D\u6BD5\u6BD9\u6BD6\u5E01\u5E87\u75F9\u95ED\u655D\u5F0A\u5FC5\u8F9F\u58C1\u81C2\u907F\u965B\u97AD\u8FB9\u7F16\u8D2C\u6241\u4FBF\u53D8\u535E\u8FA8\u8FA9\u8FAB\u904D\u6807\u5F6A\u8198\u8868\u9CD6\u618B\u522B\u762A\u5F6C\u658C\u6FD2\u6EE8\u5BBE\u6448\u5175\u51B0\u67C4\u4E19\u79C9\u997C\u70B3\uFFFD".split("");
    for(j = 0; j != D[177].length; ++j)if (D[177][j].charCodeAt(0) !== 0xFFFD) {
        e[D[177][j]] = 45312 + j;
        d[45312 + j] = D[177][j];
    }
    D[178] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u75C5\u5E76\u73BB\u83E0\u64AD\u62E8\u94B5\u6CE2\u535A\u52C3\u640F\u94C2\u7B94\u4F2F\u5E1B\u8236\u8116\u818A\u6E24\u6CCA\u9A73\u6355\u535C\u54FA\u8865\u57E0\u4E0D\u5E03\u6B65\u7C3F\u90E8\u6016\u64E6\u731C\u88C1\u6750\u624D\u8D22\u776C\u8E29\u91C7\u5F69\u83DC\u8521\u9910\u53C2\u8695\u6B8B\u60ED\u60E8\u707F\u82CD\u8231\u4ED3\u6CA7\u85CF\u64CD\u7CD9\u69FD\u66F9\u8349\u5395\u7B56\u4FA7\u518C\u6D4B\u5C42\u8E6D\u63D2\u53C9\u832C\u8336\u67E5\u78B4\u643D\u5BDF\u5C94\u5DEE\u8BE7\u62C6\u67F4\u8C7A\u6400\u63BA\u8749\u998B\u8C17\u7F20\u94F2\u4EA7\u9610\u98A4\u660C\u7316\uFFFD".split("");
    for(j = 0; j != D[178].length; ++j)if (D[178][j].charCodeAt(0) !== 0xFFFD) {
        e[D[178][j]] = 45568 + j;
        d[45568 + j] = D[178][j];
    }
    D[179] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u573A\u5C1D\u5E38\u957F\u507F\u80A0\u5382\u655E\u7545\u5531\u5021\u8D85\u6284\u949E\u671D\u5632\u6F6E\u5DE2\u5435\u7092\u8F66\u626F\u64A4\u63A3\u5F7B\u6F88\u90F4\u81E3\u8FB0\u5C18\u6668\u5FF1\u6C89\u9648\u8D81\u886C\u6491\u79F0\u57CE\u6A59\u6210\u5448\u4E58\u7A0B\u60E9\u6F84\u8BDA\u627F\u901E\u9A8B\u79E4\u5403\u75F4\u6301\u5319\u6C60\u8FDF\u5F1B\u9A70\u803B\u9F7F\u4F88\u5C3A\u8D64\u7FC5\u65A5\u70BD\u5145\u51B2\u866B\u5D07\u5BA0\u62BD\u916C\u7574\u8E0C\u7A20\u6101\u7B79\u4EC7\u7EF8\u7785\u4E11\u81ED\u521D\u51FA\u6A71\u53A8\u8E87\u9504\u96CF\u6EC1\u9664\u695A\uFFFD".split("");
    for(j = 0; j != D[179].length; ++j)if (D[179][j].charCodeAt(0) !== 0xFFFD) {
        e[D[179][j]] = 45824 + j;
        d[45824 + j] = D[179][j];
    }
    D[180] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7840\u50A8\u77D7\u6410\u89E6\u5904\u63E3\u5DDD\u7A7F\u693D\u4F20\u8239\u5598\u4E32\u75AE\u7A97\u5E62\u5E8A\u95EF\u521B\u5439\u708A\u6376\u9524\u5782\u6625\u693F\u9187\u5507\u6DF3\u7EAF\u8822\u6233\u7EF0\u75B5\u8328\u78C1\u96CC\u8F9E\u6148\u74F7\u8BCD\u6B64\u523A\u8D50\u6B21\u806A\u8471\u56F1\u5306\u4ECE\u4E1B\u51D1\u7C97\u918B\u7C07\u4FC3\u8E7F\u7BE1\u7A9C\u6467\u5D14\u50AC\u8106\u7601\u7CB9\u6DEC\u7FE0\u6751\u5B58\u5BF8\u78CB\u64AE\u6413\u63AA\u632B\u9519\u642D\u8FBE\u7B54\u7629\u6253\u5927\u5446\u6B79\u50A3\u6234\u5E26\u6B86\u4EE3\u8D37\u888B\u5F85\u902E\uFFFD".split("");
    for(j = 0; j != D[180].length; ++j)if (D[180][j].charCodeAt(0) !== 0xFFFD) {
        e[D[180][j]] = 46080 + j;
        d[46080 + j] = D[180][j];
    }
    D[181] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6020\u803D\u62C5\u4E39\u5355\u90F8\u63B8\u80C6\u65E6\u6C2E\u4F46\u60EE\u6DE1\u8BDE\u5F39\u86CB\u5F53\u6321\u515A\u8361\u6863\u5200\u6363\u8E48\u5012\u5C9B\u7977\u5BFC\u5230\u7A3B\u60BC\u9053\u76D7\u5FB7\u5F97\u7684\u8E6C\u706F\u767B\u7B49\u77AA\u51F3\u9093\u5824\u4F4E\u6EF4\u8FEA\u654C\u7B1B\u72C4\u6DA4\u7FDF\u5AE1\u62B5\u5E95\u5730\u8482\u7B2C\u5E1D\u5F1F\u9012\u7F14\u98A0\u6382\u6EC7\u7898\u70B9\u5178\u975B\u57AB\u7535\u4F43\u7538\u5E97\u60E6\u5960\u6DC0\u6BBF\u7889\u53FC\u96D5\u51CB\u5201\u6389\u540A\u9493\u8C03\u8DCC\u7239\u789F\u8776\u8FED\u8C0D\u53E0\uFFFD".split("");
    for(j = 0; j != D[181].length; ++j)if (D[181][j].charCodeAt(0) !== 0xFFFD) {
        e[D[181][j]] = 46336 + j;
        d[46336 + j] = D[181][j];
    }
    D[182] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u4E01\u76EF\u53EE\u9489\u9876\u9F0E\u952D\u5B9A\u8BA2\u4E22\u4E1C\u51AC\u8463\u61C2\u52A8\u680B\u4F97\u606B\u51BB\u6D1E\u515C\u6296\u6597\u9661\u8C46\u9017\u75D8\u90FD\u7763\u6BD2\u728A\u72EC\u8BFB\u5835\u7779\u8D4C\u675C\u9540\u809A\u5EA6\u6E21\u5992\u7AEF\u77ED\u953B\u6BB5\u65AD\u7F0E\u5806\u5151\u961F\u5BF9\u58A9\u5428\u8E72\u6566\u987F\u56E4\u949D\u76FE\u9041\u6387\u54C6\u591A\u593A\u579B\u8EB2\u6735\u8DFA\u8235\u5241\u60F0\u5815\u86FE\u5CE8\u9E45\u4FC4\u989D\u8BB9\u5A25\u6076\u5384\u627C\u904F\u9102\u997F\u6069\u800C\u513F\u8033\u5C14\u9975\u6D31\u4E8C\uFFFD".split("");
    for(j = 0; j != D[182].length; ++j)if (D[182][j].charCodeAt(0) !== 0xFFFD) {
        e[D[182][j]] = 46592 + j;
        d[46592 + j] = D[182][j];
    }
    D[183] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8D30\u53D1\u7F5A\u7B4F\u4F10\u4E4F\u9600\u6CD5\u73D0\u85E9\u5E06\u756A\u7FFB\u6A0A\u77FE\u9492\u7E41\u51E1\u70E6\u53CD\u8FD4\u8303\u8D29\u72AF\u996D\u6CDB\u574A\u82B3\u65B9\u80AA\u623F\u9632\u59A8\u4EFF\u8BBF\u7EBA\u653E\u83F2\u975E\u5561\u98DE\u80A5\u532A\u8BFD\u5420\u80BA\u5E9F\u6CB8\u8D39\u82AC\u915A\u5429\u6C1B\u5206\u7EB7\u575F\u711A\u6C7E\u7C89\u594B\u4EFD\u5FFF\u6124\u7CAA\u4E30\u5C01\u67AB\u8702\u5CF0\u950B\u98CE\u75AF\u70FD\u9022\u51AF\u7F1D\u8BBD\u5949\u51E4\u4F5B\u5426\u592B\u6577\u80A4\u5B75\u6276\u62C2\u8F90\u5E45\u6C1F\u7B26\u4F0F\u4FD8\u670D\uFFFD".split("");
    for(j = 0; j != D[183].length; ++j)if (D[183][j].charCodeAt(0) !== 0xFFFD) {
        e[D[183][j]] = 46848 + j;
        d[46848 + j] = D[183][j];
    }
    D[184] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6D6E\u6DAA\u798F\u88B1\u5F17\u752B\u629A\u8F85\u4FEF\u91DC\u65A7\u812F\u8151\u5E9C\u8150\u8D74\u526F\u8986\u8D4B\u590D\u5085\u4ED8\u961C\u7236\u8179\u8D1F\u5BCC\u8BA3\u9644\u5987\u7F1A\u5490\u5676\u560E\u8BE5\u6539\u6982\u9499\u76D6\u6E89\u5E72\u7518\u6746\u67D1\u7AFF\u809D\u8D76\u611F\u79C6\u6562\u8D63\u5188\u521A\u94A2\u7F38\u809B\u7EB2\u5C97\u6E2F\u6760\u7BD9\u768B\u9AD8\u818F\u7F94\u7CD5\u641E\u9550\u7A3F\u544A\u54E5\u6B4C\u6401\u6208\u9E3D\u80F3\u7599\u5272\u9769\u845B\u683C\u86E4\u9601\u9694\u94EC\u4E2A\u5404\u7ED9\u6839\u8DDF\u8015\u66F4\u5E9A\u7FB9\uFFFD".split("");
    for(j = 0; j != D[184].length; ++j)if (D[184][j].charCodeAt(0) !== 0xFFFD) {
        e[D[184][j]] = 47104 + j;
        d[47104 + j] = D[184][j];
    }
    D[185] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u57C2\u803F\u6897\u5DE5\u653B\u529F\u606D\u9F9A\u4F9B\u8EAC\u516C\u5BAB\u5F13\u5DE9\u6C5E\u62F1\u8D21\u5171\u94A9\u52FE\u6C9F\u82DF\u72D7\u57A2\u6784\u8D2D\u591F\u8F9C\u83C7\u5495\u7B8D\u4F30\u6CBD\u5B64\u59D1\u9F13\u53E4\u86CA\u9AA8\u8C37\u80A1\u6545\u987E\u56FA\u96C7\u522E\u74DC\u5250\u5BE1\u6302\u8902\u4E56\u62D0\u602A\u68FA\u5173\u5B98\u51A0\u89C2\u7BA1\u9986\u7F50\u60EF\u704C\u8D2F\u5149\u5E7F\u901B\u7470\u89C4\u572D\u7845\u5F52\u9F9F\u95FA\u8F68\u9B3C\u8BE1\u7678\u6842\u67DC\u8DEA\u8D35\u523D\u8F8A\u6EDA\u68CD\u9505\u90ED\u56FD\u679C\u88F9\u8FC7\u54C8\uFFFD".split("");
    for(j = 0; j != D[185].length; ++j)if (D[185][j].charCodeAt(0) !== 0xFFFD) {
        e[D[185][j]] = 47360 + j;
        d[47360 + j] = D[185][j];
    }
    D[186] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9AB8\u5B69\u6D77\u6C26\u4EA5\u5BB3\u9A87\u9163\u61A8\u90AF\u97E9\u542B\u6DB5\u5BD2\u51FD\u558A\u7F55\u7FF0\u64BC\u634D\u65F1\u61BE\u608D\u710A\u6C57\u6C49\u592F\u676D\u822A\u58D5\u568E\u8C6A\u6BEB\u90DD\u597D\u8017\u53F7\u6D69\u5475\u559D\u8377\u83CF\u6838\u79BE\u548C\u4F55\u5408\u76D2\u8C89\u9602\u6CB3\u6DB8\u8D6B\u8910\u9E64\u8D3A\u563F\u9ED1\u75D5\u5F88\u72E0\u6068\u54FC\u4EA8\u6A2A\u8861\u6052\u8F70\u54C4\u70D8\u8679\u9E3F\u6D2A\u5B8F\u5F18\u7EA2\u5589\u4FAF\u7334\u543C\u539A\u5019\u540E\u547C\u4E4E\u5FFD\u745A\u58F6\u846B\u80E1\u8774\u72D0\u7CCA\u6E56\uFFFD".split("");
    for(j = 0; j != D[186].length; ++j)if (D[186][j].charCodeAt(0) !== 0xFFFD) {
        e[D[186][j]] = 47616 + j;
        d[47616 + j] = D[186][j];
    }
    D[187] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5F27\u864E\u552C\u62A4\u4E92\u6CAA\u6237\u82B1\u54D7\u534E\u733E\u6ED1\u753B\u5212\u5316\u8BDD\u69D0\u5F8A\u6000\u6DEE\u574F\u6B22\u73AF\u6853\u8FD8\u7F13\u6362\u60A3\u5524\u75EA\u8C62\u7115\u6DA3\u5BA6\u5E7B\u8352\u614C\u9EC4\u78FA\u8757\u7C27\u7687\u51F0\u60F6\u714C\u6643\u5E4C\u604D\u8C0E\u7070\u6325\u8F89\u5FBD\u6062\u86D4\u56DE\u6BC1\u6094\u6167\u5349\u60E0\u6666\u8D3F\u79FD\u4F1A\u70E9\u6C47\u8BB3\u8BF2\u7ED8\u8364\u660F\u5A5A\u9B42\u6D51\u6DF7\u8C41\u6D3B\u4F19\u706B\u83B7\u6216\u60D1\u970D\u8D27\u7978\u51FB\u573E\u57FA\u673A\u7578\u7A3D\u79EF\u7B95\uFFFD".split("");
    for(j = 0; j != D[187].length; ++j)if (D[187][j].charCodeAt(0) !== 0xFFFD) {
        e[D[187][j]] = 47872 + j;
        d[47872 + j] = D[187][j];
    }
    D[188] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u808C\u9965\u8FF9\u6FC0\u8BA5\u9E21\u59EC\u7EE9\u7F09\u5409\u6781\u68D8\u8F91\u7C4D\u96C6\u53CA\u6025\u75BE\u6C72\u5373\u5AC9\u7EA7\u6324\u51E0\u810A\u5DF1\u84DF\u6280\u5180\u5B63\u4F0E\u796D\u5242\u60B8\u6D4E\u5BC4\u5BC2\u8BA1\u8BB0\u65E2\u5FCC\u9645\u5993\u7EE7\u7EAA\u5609\u67B7\u5939\u4F73\u5BB6\u52A0\u835A\u988A\u8D3E\u7532\u94BE\u5047\u7A3C\u4EF7\u67B6\u9A7E\u5AC1\u6B7C\u76D1\u575A\u5C16\u7B3A\u95F4\u714E\u517C\u80A9\u8270\u5978\u7F04\u8327\u68C0\u67EC\u78B1\u7877\u62E3\u6361\u7B80\u4FED\u526A\u51CF\u8350\u69DB\u9274\u8DF5\u8D31\u89C1\u952E\u7BAD\u4EF6\uFFFD".split("");
    for(j = 0; j != D[188].length; ++j)if (D[188][j].charCodeAt(0) !== 0xFFFD) {
        e[D[188][j]] = 48128 + j;
        d[48128 + j] = D[188][j];
    }
    D[189] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5065\u8230\u5251\u996F\u6E10\u6E85\u6DA7\u5EFA\u50F5\u59DC\u5C06\u6D46\u6C5F\u7586\u848B\u6868\u5956\u8BB2\u5320\u9171\u964D\u8549\u6912\u7901\u7126\u80F6\u4EA4\u90CA\u6D47\u9A84\u5A07\u56BC\u6405\u94F0\u77EB\u4FA5\u811A\u72E1\u89D2\u997A\u7F34\u7EDE\u527F\u6559\u9175\u8F7F\u8F83\u53EB\u7A96\u63ED\u63A5\u7686\u79F8\u8857\u9636\u622A\u52AB\u8282\u6854\u6770\u6377\u776B\u7AED\u6D01\u7ED3\u89E3\u59D0\u6212\u85C9\u82A5\u754C\u501F\u4ECB\u75A5\u8BEB\u5C4A\u5DFE\u7B4B\u65A4\u91D1\u4ECA\u6D25\u895F\u7D27\u9526\u4EC5\u8C28\u8FDB\u9773\u664B\u7981\u8FD1\u70EC\u6D78\uFFFD".split("");
    for(j = 0; j != D[189].length; ++j)if (D[189][j].charCodeAt(0) !== 0xFFFD) {
        e[D[189][j]] = 48384 + j;
        d[48384 + j] = D[189][j];
    }
    D[190] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5C3D\u52B2\u8346\u5162\u830E\u775B\u6676\u9CB8\u4EAC\u60CA\u7CBE\u7CB3\u7ECF\u4E95\u8B66\u666F\u9888\u9759\u5883\u656C\u955C\u5F84\u75C9\u9756\u7ADF\u7ADE\u51C0\u70AF\u7A98\u63EA\u7A76\u7EA0\u7396\u97ED\u4E45\u7078\u4E5D\u9152\u53A9\u6551\u65E7\u81FC\u8205\u548E\u5C31\u759A\u97A0\u62D8\u72D9\u75BD\u5C45\u9A79\u83CA\u5C40\u5480\u77E9\u4E3E\u6CAE\u805A\u62D2\u636E\u5DE8\u5177\u8DDD\u8E1E\u952F\u4FF1\u53E5\u60E7\u70AC\u5267\u6350\u9E43\u5A1F\u5026\u7737\u5377\u7EE2\u6485\u652B\u6289\u6398\u5014\u7235\u89C9\u51B3\u8BC0\u7EDD\u5747\u83CC\u94A7\u519B\u541B\u5CFB\uFFFD".split("");
    for(j = 0; j != D[190].length; ++j)if (D[190][j].charCodeAt(0) !== 0xFFFD) {
        e[D[190][j]] = 48640 + j;
        d[48640 + j] = D[190][j];
    }
    D[191] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u4FCA\u7AE3\u6D5A\u90E1\u9A8F\u5580\u5496\u5361\u54AF\u5F00\u63E9\u6977\u51EF\u6168\u520A\u582A\u52D8\u574E\u780D\u770B\u5EB7\u6177\u7CE0\u625B\u6297\u4EA2\u7095\u8003\u62F7\u70E4\u9760\u5777\u82DB\u67EF\u68F5\u78D5\u9897\u79D1\u58F3\u54B3\u53EF\u6E34\u514B\u523B\u5BA2\u8BFE\u80AF\u5543\u57A6\u6073\u5751\u542D\u7A7A\u6050\u5B54\u63A7\u62A0\u53E3\u6263\u5BC7\u67AF\u54ED\u7A9F\u82E6\u9177\u5E93\u88E4\u5938\u57AE\u630E\u8DE8\u80EF\u5757\u7B77\u4FA9\u5FEB\u5BBD\u6B3E\u5321\u7B50\u72C2\u6846\u77FF\u7736\u65F7\u51B5\u4E8F\u76D4\u5CBF\u7AA5\u8475\u594E\u9B41\u5080\uFFFD".split("");
    for(j = 0; j != D[191].length; ++j)if (D[191][j].charCodeAt(0) !== 0xFFFD) {
        e[D[191][j]] = 48896 + j;
        d[48896 + j] = D[191][j];
    }
    D[192] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9988\u6127\u6E83\u5764\u6606\u6346\u56F0\u62EC\u6269\u5ED3\u9614\u5783\u62C9\u5587\u8721\u814A\u8FA3\u5566\u83B1\u6765\u8D56\u84DD\u5A6A\u680F\u62E6\u7BEE\u9611\u5170\u6F9C\u8C30\u63FD\u89C8\u61D2\u7F06\u70C2\u6EE5\u7405\u6994\u72FC\u5ECA\u90CE\u6717\u6D6A\u635E\u52B3\u7262\u8001\u4F6C\u59E5\u916A\u70D9\u6D9D\u52D2\u4E50\u96F7\u956D\u857E\u78CA\u7D2F\u5121\u5792\u64C2\u808B\u7C7B\u6CEA\u68F1\u695E\u51B7\u5398\u68A8\u7281\u9ECE\u7BF1\u72F8\u79BB\u6F13\u7406\u674E\u91CC\u9CA4\u793C\u8389\u8354\u540F\u6817\u4E3D\u5389\u52B1\u783E\u5386\u5229\u5088\u4F8B\u4FD0\uFFFD".split("");
    for(j = 0; j != D[192].length; ++j)if (D[192][j].charCodeAt(0) !== 0xFFFD) {
        e[D[192][j]] = 49152 + j;
        d[49152 + j] = D[192][j];
    }
    D[193] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u75E2\u7ACB\u7C92\u6CA5\u96B6\u529B\u7483\u54E9\u4FE9\u8054\u83B2\u8FDE\u9570\u5EC9\u601C\u6D9F\u5E18\u655B\u8138\u94FE\u604B\u70BC\u7EC3\u7CAE\u51C9\u6881\u7CB1\u826F\u4E24\u8F86\u91CF\u667E\u4EAE\u8C05\u64A9\u804A\u50DA\u7597\u71CE\u5BE5\u8FBD\u6F66\u4E86\u6482\u9563\u5ED6\u6599\u5217\u88C2\u70C8\u52A3\u730E\u7433\u6797\u78F7\u9716\u4E34\u90BB\u9CDE\u6DCB\u51DB\u8D41\u541D\u62CE\u73B2\u83F1\u96F6\u9F84\u94C3\u4F36\u7F9A\u51CC\u7075\u9675\u5CAD\u9886\u53E6\u4EE4\u6E9C\u7409\u69B4\u786B\u998F\u7559\u5218\u7624\u6D41\u67F3\u516D\u9F99\u804B\u5499\u7B3C\u7ABF\uFFFD".split("");
    for(j = 0; j != D[193].length; ++j)if (D[193][j].charCodeAt(0) !== 0xFFFD) {
        e[D[193][j]] = 49408 + j;
        d[49408 + j] = D[193][j];
    }
    D[194] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9686\u5784\u62E2\u9647\u697C\u5A04\u6402\u7BD3\u6F0F\u964B\u82A6\u5362\u9885\u5E90\u7089\u63B3\u5364\u864F\u9C81\u9E93\u788C\u9732\u8DEF\u8D42\u9E7F\u6F5E\u7984\u5F55\u9646\u622E\u9A74\u5415\u94DD\u4FA3\u65C5\u5C65\u5C61\u7F15\u8651\u6C2F\u5F8B\u7387\u6EE4\u7EFF\u5CE6\u631B\u5B6A\u6EE6\u5375\u4E71\u63A0\u7565\u62A1\u8F6E\u4F26\u4ED1\u6CA6\u7EB6\u8BBA\u841D\u87BA\u7F57\u903B\u9523\u7BA9\u9AA1\u88F8\u843D\u6D1B\u9A86\u7EDC\u5988\u9EBB\u739B\u7801\u8682\u9A6C\u9A82\u561B\u5417\u57CB\u4E70\u9EA6\u5356\u8FC8\u8109\u7792\u9992\u86EE\u6EE1\u8513\u66FC\u6162\u6F2B\uFFFD".split("");
    for(j = 0; j != D[194].length; ++j)if (D[194][j].charCodeAt(0) !== 0xFFFD) {
        e[D[194][j]] = 49664 + j;
        d[49664 + j] = D[194][j];
    }
    D[195] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8C29\u8292\u832B\u76F2\u6C13\u5FD9\u83BD\u732B\u8305\u951A\u6BDB\u77DB\u94C6\u536F\u8302\u5192\u5E3D\u8C8C\u8D38\u4E48\u73AB\u679A\u6885\u9176\u9709\u7164\u6CA1\u7709\u5A92\u9541\u6BCF\u7F8E\u6627\u5BD0\u59B9\u5A9A\u95E8\u95F7\u4EEC\u840C\u8499\u6AAC\u76DF\u9530\u731B\u68A6\u5B5F\u772F\u919A\u9761\u7CDC\u8FF7\u8C1C\u5F25\u7C73\u79D8\u89C5\u6CCC\u871C\u5BC6\u5E42\u68C9\u7720\u7EF5\u5195\u514D\u52C9\u5A29\u7F05\u9762\u82D7\u63CF\u7784\u85D0\u79D2\u6E3A\u5E99\u5999\u8511\u706D\u6C11\u62BF\u76BF\u654F\u60AF\u95FD\u660E\u879F\u9E23\u94ED\u540D\u547D\u8C2C\u6478\uFFFD".split("");
    for(j = 0; j != D[195].length; ++j)if (D[195][j].charCodeAt(0) !== 0xFFFD) {
        e[D[195][j]] = 49920 + j;
        d[49920 + j] = D[195][j];
    }
    D[196] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6479\u8611\u6A21\u819C\u78E8\u6469\u9B54\u62B9\u672B\u83AB\u58A8\u9ED8\u6CAB\u6F20\u5BDE\u964C\u8C0B\u725F\u67D0\u62C7\u7261\u4EA9\u59C6\u6BCD\u5893\u66AE\u5E55\u52DF\u6155\u6728\u76EE\u7766\u7267\u7A46\u62FF\u54EA\u5450\u94A0\u90A3\u5A1C\u7EB3\u6C16\u4E43\u5976\u8010\u5948\u5357\u7537\u96BE\u56CA\u6320\u8111\u607C\u95F9\u6DD6\u5462\u9981\u5185\u5AE9\u80FD\u59AE\u9713\u502A\u6CE5\u5C3C\u62DF\u4F60\u533F\u817B\u9006\u6EBA\u852B\u62C8\u5E74\u78BE\u64B5\u637B\u5FF5\u5A18\u917F\u9E1F\u5C3F\u634F\u8042\u5B7D\u556E\u954A\u954D\u6D85\u60A8\u67E0\u72DE\u51DD\u5B81\uFFFD".split("");
    for(j = 0; j != D[196].length; ++j)if (D[196][j].charCodeAt(0) !== 0xFFFD) {
        e[D[196][j]] = 50176 + j;
        d[50176 + j] = D[196][j];
    }
    D[197] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u62E7\u6CDE\u725B\u626D\u94AE\u7EBD\u8113\u6D53\u519C\u5F04\u5974\u52AA\u6012\u5973\u6696\u8650\u759F\u632A\u61E6\u7CEF\u8BFA\u54E6\u6B27\u9E25\u6BB4\u85D5\u5455\u5076\u6CA4\u556A\u8DB4\u722C\u5E15\u6015\u7436\u62CD\u6392\u724C\u5F98\u6E43\u6D3E\u6500\u6F58\u76D8\u78D0\u76FC\u7554\u5224\u53DB\u4E53\u5E9E\u65C1\u802A\u80D6\u629B\u5486\u5228\u70AE\u888D\u8DD1\u6CE1\u5478\u80DA\u57F9\u88F4\u8D54\u966A\u914D\u4F69\u6C9B\u55B7\u76C6\u7830\u62A8\u70F9\u6F8E\u5F6D\u84EC\u68DA\u787C\u7BF7\u81A8\u670B\u9E4F\u6367\u78B0\u576F\u7812\u9739\u6279\u62AB\u5288\u7435\u6BD7\uFFFD".split("");
    for(j = 0; j != D[197].length; ++j)if (D[197][j].charCodeAt(0) !== 0xFFFD) {
        e[D[197][j]] = 50432 + j;
        d[50432 + j] = D[197][j];
    }
    D[198] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5564\u813E\u75B2\u76AE\u5339\u75DE\u50FB\u5C41\u8B6C\u7BC7\u504F\u7247\u9A97\u98D8\u6F02\u74E2\u7968\u6487\u77A5\u62FC\u9891\u8D2B\u54C1\u8058\u4E52\u576A\u82F9\u840D\u5E73\u51ED\u74F6\u8BC4\u5C4F\u5761\u6CFC\u9887\u5A46\u7834\u9B44\u8FEB\u7C95\u5256\u6251\u94FA\u4EC6\u8386\u8461\u83E9\u84B2\u57D4\u6734\u5703\u666E\u6D66\u8C31\u66DD\u7011\u671F\u6B3A\u6816\u621A\u59BB\u4E03\u51C4\u6F06\u67D2\u6C8F\u5176\u68CB\u5947\u6B67\u7566\u5D0E\u8110\u9F50\u65D7\u7948\u7941\u9A91\u8D77\u5C82\u4E5E\u4F01\u542F\u5951\u780C\u5668\u6C14\u8FC4\u5F03\u6C7D\u6CE3\u8BAB\u6390\uFFFD".split("");
    for(j = 0; j != D[198].length; ++j)if (D[198][j].charCodeAt(0) !== 0xFFFD) {
        e[D[198][j]] = 50688 + j;
        d[50688 + j] = D[198][j];
    }
    D[199] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6070\u6D3D\u7275\u6266\u948E\u94C5\u5343\u8FC1\u7B7E\u4EDF\u8C26\u4E7E\u9ED4\u94B1\u94B3\u524D\u6F5C\u9063\u6D45\u8C34\u5811\u5D4C\u6B20\u6B49\u67AA\u545B\u8154\u7F8C\u5899\u8537\u5F3A\u62A2\u6A47\u9539\u6572\u6084\u6865\u77A7\u4E54\u4FA8\u5DE7\u9798\u64AC\u7FD8\u5CED\u4FCF\u7A8D\u5207\u8304\u4E14\u602F\u7A83\u94A6\u4FB5\u4EB2\u79E6\u7434\u52E4\u82B9\u64D2\u79BD\u5BDD\u6C81\u9752\u8F7B\u6C22\u503E\u537F\u6E05\u64CE\u6674\u6C30\u60C5\u9877\u8BF7\u5E86\u743C\u7A77\u79CB\u4E18\u90B1\u7403\u6C42\u56DA\u914B\u6CC5\u8D8B\u533A\u86C6\u66F2\u8EAF\u5C48\u9A71\u6E20\uFFFD".split("");
    for(j = 0; j != D[199].length; ++j)if (D[199][j].charCodeAt(0) !== 0xFFFD) {
        e[D[199][j]] = 50944 + j;
        d[50944 + j] = D[199][j];
    }
    D[200] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u53D6\u5A36\u9F8B\u8DA3\u53BB\u5708\u98A7\u6743\u919B\u6CC9\u5168\u75CA\u62F3\u72AC\u5238\u529D\u7F3A\u7094\u7638\u5374\u9E4A\u69B7\u786E\u96C0\u88D9\u7FA4\u7136\u71C3\u5189\u67D3\u74E4\u58E4\u6518\u56B7\u8BA9\u9976\u6270\u7ED5\u60F9\u70ED\u58EC\u4EC1\u4EBA\u5FCD\u97E7\u4EFB\u8BA4\u5203\u598A\u7EAB\u6254\u4ECD\u65E5\u620E\u8338\u84C9\u8363\u878D\u7194\u6EB6\u5BB9\u7ED2\u5197\u63C9\u67D4\u8089\u8339\u8815\u5112\u5B7A\u5982\u8FB1\u4E73\u6C5D\u5165\u8925\u8F6F\u962E\u854A\u745E\u9510\u95F0\u6DA6\u82E5\u5F31\u6492\u6D12\u8428\u816E\u9CC3\u585E\u8D5B\u4E09\u53C1\uFFFD".split("");
    for(j = 0; j != D[200].length; ++j)if (D[200][j].charCodeAt(0) !== 0xFFFD) {
        e[D[200][j]] = 51200 + j;
        d[51200 + j] = D[200][j];
    }
    D[201] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u4F1E\u6563\u6851\u55D3\u4E27\u6414\u9A9A\u626B\u5AC2\u745F\u8272\u6DA9\u68EE\u50E7\u838E\u7802\u6740\u5239\u6C99\u7EB1\u50BB\u5565\u715E\u7B5B\u6652\u73CA\u82EB\u6749\u5C71\u5220\u717D\u886B\u95EA\u9655\u64C5\u8D61\u81B3\u5584\u6C55\u6247\u7F2E\u5892\u4F24\u5546\u8D4F\u664C\u4E0A\u5C1A\u88F3\u68A2\u634E\u7A0D\u70E7\u828D\u52FA\u97F6\u5C11\u54E8\u90B5\u7ECD\u5962\u8D4A\u86C7\u820C\u820D\u8D66\u6444\u5C04\u6151\u6D89\u793E\u8BBE\u7837\u7533\u547B\u4F38\u8EAB\u6DF1\u5A20\u7EC5\u795E\u6C88\u5BA1\u5A76\u751A\u80BE\u614E\u6E17\u58F0\u751F\u7525\u7272\u5347\u7EF3\uFFFD".split("");
    for(j = 0; j != D[201].length; ++j)if (D[201][j].charCodeAt(0) !== 0xFFFD) {
        e[D[201][j]] = 51456 + j;
        d[51456 + j] = D[201][j];
    }
    D[202] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7701\u76DB\u5269\u80DC\u5723\u5E08\u5931\u72EE\u65BD\u6E7F\u8BD7\u5C38\u8671\u5341\u77F3\u62FE\u65F6\u4EC0\u98DF\u8680\u5B9E\u8BC6\u53F2\u77E2\u4F7F\u5C4E\u9A76\u59CB\u5F0F\u793A\u58EB\u4E16\u67FF\u4E8B\u62ED\u8A93\u901D\u52BF\u662F\u55DC\u566C\u9002\u4ED5\u4F8D\u91CA\u9970\u6C0F\u5E02\u6043\u5BA4\u89C6\u8BD5\u6536\u624B\u9996\u5B88\u5BFF\u6388\u552E\u53D7\u7626\u517D\u852C\u67A2\u68B3\u6B8A\u6292\u8F93\u53D4\u8212\u6DD1\u758F\u4E66\u8D4E\u5B70\u719F\u85AF\u6691\u66D9\u7F72\u8700\u9ECD\u9F20\u5C5E\u672F\u8FF0\u6811\u675F\u620D\u7AD6\u5885\u5EB6\u6570\u6F31\uFFFD".split("");
    for(j = 0; j != D[202].length; ++j)if (D[202][j].charCodeAt(0) !== 0xFFFD) {
        e[D[202][j]] = 51712 + j;
        d[51712 + j] = D[202][j];
    }
    D[203] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6055\u5237\u800D\u6454\u8870\u7529\u5E05\u6813\u62F4\u971C\u53CC\u723D\u8C01\u6C34\u7761\u7A0E\u542E\u77AC\u987A\u821C\u8BF4\u7855\u6714\u70C1\u65AF\u6495\u5636\u601D\u79C1\u53F8\u4E1D\u6B7B\u8086\u5BFA\u55E3\u56DB\u4F3A\u4F3C\u9972\u5DF3\u677E\u8038\u6002\u9882\u9001\u5B8B\u8BBC\u8BF5\u641C\u8258\u64DE\u55FD\u82CF\u9165\u4FD7\u7D20\u901F\u7C9F\u50F3\u5851\u6EAF\u5BBF\u8BC9\u8083\u9178\u849C\u7B97\u867D\u968B\u968F\u7EE5\u9AD3\u788E\u5C81\u7A57\u9042\u96A7\u795F\u5B59\u635F\u7B0B\u84D1\u68AD\u5506\u7F29\u7410\u7D22\u9501\u6240\u584C\u4ED6\u5B83\u5979\u5854\uFFFD".split("");
    for(j = 0; j != D[203].length; ++j)if (D[203][j].charCodeAt(0) !== 0xFFFD) {
        e[D[203][j]] = 51968 + j;
        d[51968 + j] = D[203][j];
    }
    D[204] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u736D\u631E\u8E4B\u8E0F\u80CE\u82D4\u62AC\u53F0\u6CF0\u915E\u592A\u6001\u6C70\u574D\u644A\u8D2A\u762B\u6EE9\u575B\u6A80\u75F0\u6F6D\u8C2D\u8C08\u5766\u6BEF\u8892\u78B3\u63A2\u53F9\u70AD\u6C64\u5858\u642A\u5802\u68E0\u819B\u5510\u7CD6\u5018\u8EBA\u6DCC\u8D9F\u70EB\u638F\u6D9B\u6ED4\u7EE6\u8404\u6843\u9003\u6DD8\u9676\u8BA8\u5957\u7279\u85E4\u817E\u75BC\u8A8A\u68AF\u5254\u8E22\u9511\u63D0\u9898\u8E44\u557C\u4F53\u66FF\u568F\u60D5\u6D95\u5243\u5C49\u5929\u6DFB\u586B\u7530\u751C\u606C\u8214\u8146\u6311\u6761\u8FE2\u773A\u8DF3\u8D34\u94C1\u5E16\u5385\u542C\u70C3\uFFFD".split("");
    for(j = 0; j != D[204].length; ++j)if (D[204][j].charCodeAt(0) !== 0xFFFD) {
        e[D[204][j]] = 52224 + j;
        d[52224 + j] = D[204][j];
    }
    D[205] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6C40\u5EF7\u505C\u4EAD\u5EAD\u633A\u8247\u901A\u6850\u916E\u77B3\u540C\u94DC\u5F64\u7AE5\u6876\u6345\u7B52\u7EDF\u75DB\u5077\u6295\u5934\u900F\u51F8\u79C3\u7A81\u56FE\u5F92\u9014\u6D82\u5C60\u571F\u5410\u5154\u6E4D\u56E2\u63A8\u9893\u817F\u8715\u892A\u9000\u541E\u5C6F\u81C0\u62D6\u6258\u8131\u9E35\u9640\u9A6E\u9A7C\u692D\u59A5\u62D3\u553E\u6316\u54C7\u86D9\u6D3C\u5A03\u74E6\u889C\u6B6A\u5916\u8C4C\u5F2F\u6E7E\u73A9\u987D\u4E38\u70F7\u5B8C\u7897\u633D\u665A\u7696\u60CB\u5B9B\u5A49\u4E07\u8155\u6C6A\u738B\u4EA1\u6789\u7F51\u5F80\u65FA\u671B\u5FD8\u5984\u5A01\uFFFD".split("");
    for(j = 0; j != D[205].length; ++j)if (D[205][j].charCodeAt(0) !== 0xFFFD) {
        e[D[205][j]] = 52480 + j;
        d[52480 + j] = D[205][j];
    }
    D[206] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5DCD\u5FAE\u5371\u97E6\u8FDD\u6845\u56F4\u552F\u60DF\u4E3A\u6F4D\u7EF4\u82C7\u840E\u59D4\u4F1F\u4F2A\u5C3E\u7EAC\u672A\u851A\u5473\u754F\u80C3\u5582\u9B4F\u4F4D\u6E2D\u8C13\u5C09\u6170\u536B\u761F\u6E29\u868A\u6587\u95FB\u7EB9\u543B\u7A33\u7D0A\u95EE\u55E1\u7FC1\u74EE\u631D\u8717\u6DA1\u7A9D\u6211\u65A1\u5367\u63E1\u6C83\u5DEB\u545C\u94A8\u4E4C\u6C61\u8BEC\u5C4B\u65E0\u829C\u68A7\u543E\u5434\u6BCB\u6B66\u4E94\u6342\u5348\u821E\u4F0D\u4FAE\u575E\u620A\u96FE\u6664\u7269\u52FF\u52A1\u609F\u8BEF\u6614\u7199\u6790\u897F\u7852\u77FD\u6670\u563B\u5438\u9521\u727A\uFFFD".split("");
    for(j = 0; j != D[206].length; ++j)if (D[206][j].charCodeAt(0) !== 0xFFFD) {
        e[D[206][j]] = 52736 + j;
        d[52736 + j] = D[206][j];
    }
    D[207] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7A00\u606F\u5E0C\u6089\u819D\u5915\u60DC\u7184\u70EF\u6EAA\u6C50\u7280\u6A84\u88AD\u5E2D\u4E60\u5AB3\u559C\u94E3\u6D17\u7CFB\u9699\u620F\u7EC6\u778E\u867E\u5323\u971E\u8F96\u6687\u5CE1\u4FA0\u72ED\u4E0B\u53A6\u590F\u5413\u6380\u9528\u5148\u4ED9\u9C9C\u7EA4\u54B8\u8D24\u8854\u8237\u95F2\u6D8E\u5F26\u5ACC\u663E\u9669\u73B0\u732E\u53BF\u817A\u9985\u7FA1\u5BAA\u9677\u9650\u7EBF\u76F8\u53A2\u9576\u9999\u7BB1\u8944\u6E58\u4E61\u7FD4\u7965\u8BE6\u60F3\u54CD\u4EAB\u9879\u5DF7\u6A61\u50CF\u5411\u8C61\u8427\u785D\u9704\u524A\u54EE\u56A3\u9500\u6D88\u5BB5\u6DC6\u6653\uFFFD".split("");
    for(j = 0; j != D[207].length; ++j)if (D[207][j].charCodeAt(0) !== 0xFFFD) {
        e[D[207][j]] = 52992 + j;
        d[52992 + j] = D[207][j];
    }
    D[208] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5C0F\u5B5D\u6821\u8096\u5578\u7B11\u6548\u6954\u4E9B\u6B47\u874E\u978B\u534F\u631F\u643A\u90AA\u659C\u80C1\u8C10\u5199\u68B0\u5378\u87F9\u61C8\u6CC4\u6CFB\u8C22\u5C51\u85AA\u82AF\u950C\u6B23\u8F9B\u65B0\u5FFB\u5FC3\u4FE1\u8845\u661F\u8165\u7329\u60FA\u5174\u5211\u578B\u5F62\u90A2\u884C\u9192\u5E78\u674F\u6027\u59D3\u5144\u51F6\u80F8\u5308\u6C79\u96C4\u718A\u4F11\u4FEE\u7F9E\u673D\u55C5\u9508\u79C0\u8896\u7EE3\u589F\u620C\u9700\u865A\u5618\u987B\u5F90\u8BB8\u84C4\u9157\u53D9\u65ED\u5E8F\u755C\u6064\u7D6E\u5A7F\u7EEA\u7EED\u8F69\u55A7\u5BA3\u60AC\u65CB\u7384\uFFFD".split("");
    for(j = 0; j != D[208].length; ++j)if (D[208][j].charCodeAt(0) !== 0xFFFD) {
        e[D[208][j]] = 53248 + j;
        d[53248 + j] = D[208][j];
    }
    D[209] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9009\u7663\u7729\u7EDA\u9774\u859B\u5B66\u7A74\u96EA\u8840\u52CB\u718F\u5FAA\u65EC\u8BE2\u5BFB\u9A6F\u5DE1\u6B89\u6C5B\u8BAD\u8BAF\u900A\u8FC5\u538B\u62BC\u9E26\u9E2D\u5440\u4E2B\u82BD\u7259\u869C\u5D16\u8859\u6DAF\u96C5\u54D1\u4E9A\u8BB6\u7109\u54BD\u9609\u70DF\u6DF9\u76D0\u4E25\u7814\u8712\u5CA9\u5EF6\u8A00\u989C\u960E\u708E\u6CBF\u5944\u63A9\u773C\u884D\u6F14\u8273\u5830\u71D5\u538C\u781A\u96C1\u5501\u5F66\u7130\u5BB4\u8C1A\u9A8C\u6B83\u592E\u9E2F\u79E7\u6768\u626C\u4F6F\u75A1\u7F8A\u6D0B\u9633\u6C27\u4EF0\u75D2\u517B\u6837\u6F3E\u9080\u8170\u5996\u7476\uFFFD".split("");
    for(j = 0; j != D[209].length; ++j)if (D[209][j].charCodeAt(0) !== 0xFFFD) {
        e[D[209][j]] = 53504 + j;
        d[53504 + j] = D[209][j];
    }
    D[210] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6447\u5C27\u9065\u7A91\u8C23\u59DA\u54AC\u8200\u836F\u8981\u8000\u6930\u564E\u8036\u7237\u91CE\u51B6\u4E5F\u9875\u6396\u4E1A\u53F6\u66F3\u814B\u591C\u6DB2\u4E00\u58F9\u533B\u63D6\u94F1\u4F9D\u4F0A\u8863\u9890\u5937\u9057\u79FB\u4EEA\u80F0\u7591\u6C82\u5B9C\u59E8\u5F5D\u6905\u8681\u501A\u5DF2\u4E59\u77E3\u4EE5\u827A\u6291\u6613\u9091\u5C79\u4EBF\u5F79\u81C6\u9038\u8084\u75AB\u4EA6\u88D4\u610F\u6BC5\u5FC6\u4E49\u76CA\u6EA2\u8BE3\u8BAE\u8C0A\u8BD1\u5F02\u7FFC\u7FCC\u7ECE\u8335\u836B\u56E0\u6BB7\u97F3\u9634\u59FB\u541F\u94F6\u6DEB\u5BC5\u996E\u5C39\u5F15\u9690\uFFFD".split("");
    for(j = 0; j != D[210].length; ++j)if (D[210][j].charCodeAt(0) !== 0xFFFD) {
        e[D[210][j]] = 53760 + j;
        d[53760 + j] = D[210][j];
    }
    D[211] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5370\u82F1\u6A31\u5A74\u9E70\u5E94\u7F28\u83B9\u8424\u8425\u8367\u8747\u8FCE\u8D62\u76C8\u5F71\u9896\u786C\u6620\u54DF\u62E5\u4F63\u81C3\u75C8\u5EB8\u96CD\u8E0A\u86F9\u548F\u6CF3\u6D8C\u6C38\u607F\u52C7\u7528\u5E7D\u4F18\u60A0\u5FE7\u5C24\u7531\u90AE\u94C0\u72B9\u6CB9\u6E38\u9149\u6709\u53CB\u53F3\u4F51\u91C9\u8BF1\u53C8\u5E7C\u8FC2\u6DE4\u4E8E\u76C2\u6986\u865E\u611A\u8206\u4F59\u4FDE\u903E\u9C7C\u6109\u6E1D\u6E14\u9685\u4E88\u5A31\u96E8\u4E0E\u5C7F\u79B9\u5B87\u8BED\u7FBD\u7389\u57DF\u828B\u90C1\u5401\u9047\u55BB\u5CEA\u5FA1\u6108\u6B32\u72F1\u80B2\u8A89\uFFFD".split("");
    for(j = 0; j != D[211].length; ++j)if (D[211][j].charCodeAt(0) !== 0xFFFD) {
        e[D[211][j]] = 54016 + j;
        d[54016 + j] = D[211][j];
    }
    D[212] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6D74\u5BD3\u88D5\u9884\u8C6B\u9A6D\u9E33\u6E0A\u51A4\u5143\u57A3\u8881\u539F\u63F4\u8F95\u56ED\u5458\u5706\u733F\u6E90\u7F18\u8FDC\u82D1\u613F\u6028\u9662\u66F0\u7EA6\u8D8A\u8DC3\u94A5\u5CB3\u7CA4\u6708\u60A6\u9605\u8018\u4E91\u90E7\u5300\u9668\u5141\u8FD0\u8574\u915D\u6655\u97F5\u5B55\u531D\u7838\u6742\u683D\u54C9\u707E\u5BB0\u8F7D\u518D\u5728\u54B1\u6512\u6682\u8D5E\u8D43\u810F\u846C\u906D\u7CDF\u51FF\u85FB\u67A3\u65E9\u6FA1\u86A4\u8E81\u566A\u9020\u7682\u7076\u71E5\u8D23\u62E9\u5219\u6CFD\u8D3C\u600E\u589E\u618E\u66FE\u8D60\u624E\u55B3\u6E23\u672D\u8F67\uFFFD".split("");
    for(j = 0; j != D[212].length; ++j)if (D[212][j].charCodeAt(0) !== 0xFFFD) {
        e[D[212][j]] = 54272 + j;
        d[54272 + j] = D[212][j];
    }
    D[213] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u94E1\u95F8\u7728\u6805\u69A8\u548B\u4E4D\u70B8\u8BC8\u6458\u658B\u5B85\u7A84\u503A\u5BE8\u77BB\u6BE1\u8A79\u7C98\u6CBE\u76CF\u65A9\u8F97\u5D2D\u5C55\u8638\u6808\u5360\u6218\u7AD9\u6E5B\u7EFD\u6A1F\u7AE0\u5F70\u6F33\u5F20\u638C\u6DA8\u6756\u4E08\u5E10\u8D26\u4ED7\u80C0\u7634\u969C\u62DB\u662D\u627E\u6CBC\u8D75\u7167\u7F69\u5146\u8087\u53EC\u906E\u6298\u54F2\u86F0\u8F99\u8005\u9517\u8517\u8FD9\u6D59\u73CD\u659F\u771F\u7504\u7827\u81FB\u8D1E\u9488\u4FA6\u6795\u75B9\u8BCA\u9707\u632F\u9547\u9635\u84B8\u6323\u7741\u5F81\u72F0\u4E89\u6014\u6574\u62EF\u6B63\u653F\uFFFD".split("");
    for(j = 0; j != D[213].length; ++j)if (D[213][j].charCodeAt(0) !== 0xFFFD) {
        e[D[213][j]] = 54528 + j;
        d[54528 + j] = D[213][j];
    }
    D[214] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5E27\u75C7\u90D1\u8BC1\u829D\u679D\u652F\u5431\u8718\u77E5\u80A2\u8102\u6C41\u4E4B\u7EC7\u804C\u76F4\u690D\u6B96\u6267\u503C\u4F84\u5740\u6307\u6B62\u8DBE\u53EA\u65E8\u7EB8\u5FD7\u631A\u63B7\u81F3\u81F4\u7F6E\u5E1C\u5CD9\u5236\u667A\u79E9\u7A1A\u8D28\u7099\u75D4\u6EDE\u6CBB\u7A92\u4E2D\u76C5\u5FE0\u949F\u8877\u7EC8\u79CD\u80BF\u91CD\u4EF2\u4F17\u821F\u5468\u5DDE\u6D32\u8BCC\u7CA5\u8F74\u8098\u5E1A\u5492\u76B1\u5B99\u663C\u9AA4\u73E0\u682A\u86DB\u6731\u732A\u8BF8\u8BDB\u9010\u7AF9\u70DB\u716E\u62C4\u77A9\u5631\u4E3B\u8457\u67F1\u52A9\u86C0\u8D2E\u94F8\u7B51\uFFFD".split("");
    for(j = 0; j != D[214].length; ++j)if (D[214][j].charCodeAt(0) !== 0xFFFD) {
        e[D[214][j]] = 54784 + j;
        d[54784 + j] = D[214][j];
    }
    D[215] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u4F4F\u6CE8\u795D\u9A7B\u6293\u722A\u62FD\u4E13\u7816\u8F6C\u64B0\u8D5A\u7BC6\u6869\u5E84\u88C5\u5986\u649E\u58EE\u72B6\u690E\u9525\u8FFD\u8D58\u5760\u7F00\u8C06\u51C6\u6349\u62D9\u5353\u684C\u7422\u8301\u914C\u5544\u7740\u707C\u6D4A\u5179\u54A8\u8D44\u59FF\u6ECB\u6DC4\u5B5C\u7D2B\u4ED4\u7C7D\u6ED3\u5B50\u81EA\u6E0D\u5B57\u9B03\u68D5\u8E2A\u5B97\u7EFC\u603B\u7EB5\u90B9\u8D70\u594F\u63CD\u79DF\u8DB3\u5352\u65CF\u7956\u8BC5\u963B\u7EC4\u94BB\u7E82\u5634\u9189\u6700\u7F6A\u5C0A\u9075\u6628\u5DE6\u4F50\u67DE\u505A\u4F5C\u5750\u5EA7\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[215].length; ++j)if (D[215][j].charCodeAt(0) !== 0xFFFD) {
        e[D[215][j]] = 55040 + j;
        d[55040 + j] = D[215][j];
    }
    D[216] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u4E8D\u4E0C\u5140\u4E10\u5EFF\u5345\u4E15\u4E98\u4E1E\u9B32\u5B6C\u5669\u4E28\u79BA\u4E3F\u5315\u4E47\u592D\u723B\u536E\u6C10\u56DF\u80E4\u9997\u6BD3\u777E\u9F17\u4E36\u4E9F\u9F10\u4E5C\u4E69\u4E93\u8288\u5B5B\u556C\u560F\u4EC4\u538D\u539D\u53A3\u53A5\u53AE\u9765\u8D5D\u531A\u53F5\u5326\u532E\u533E\u8D5C\u5366\u5363\u5202\u5208\u520E\u522D\u5233\u523F\u5240\u524C\u525E\u5261\u525C\u84AF\u527D\u5282\u5281\u5290\u5293\u5182\u7F54\u4EBB\u4EC3\u4EC9\u4EC2\u4EE8\u4EE1\u4EEB\u4EDE\u4F1B\u4EF3\u4F22\u4F64\u4EF5\u4F25\u4F27\u4F09\u4F2B\u4F5E\u4F67\u6538\u4F5A\u4F5D\uFFFD".split("");
    for(j = 0; j != D[216].length; ++j)if (D[216][j].charCodeAt(0) !== 0xFFFD) {
        e[D[216][j]] = 55296 + j;
        d[55296 + j] = D[216][j];
    }
    D[217] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u4F5F\u4F57\u4F32\u4F3D\u4F76\u4F74\u4F91\u4F89\u4F83\u4F8F\u4F7E\u4F7B\u4FAA\u4F7C\u4FAC\u4F94\u4FE6\u4FE8\u4FEA\u4FC5\u4FDA\u4FE3\u4FDC\u4FD1\u4FDF\u4FF8\u5029\u504C\u4FF3\u502C\u500F\u502E\u502D\u4FFE\u501C\u500C\u5025\u5028\u507E\u5043\u5055\u5048\u504E\u506C\u507B\u50A5\u50A7\u50A9\u50BA\u50D6\u5106\u50ED\u50EC\u50E6\u50EE\u5107\u510B\u4EDD\u6C3D\u4F58\u4F65\u4FCE\u9FA0\u6C46\u7C74\u516E\u5DFD\u9EC9\u9998\u5181\u5914\u52F9\u530D\u8A07\u5310\u51EB\u5919\u5155\u4EA0\u5156\u4EB3\u886E\u88A4\u4EB5\u8114\u88D2\u7980\u5B34\u8803\u7FB8\u51AB\u51B1\u51BD\u51BC\uFFFD".split("");
    for(j = 0; j != D[217].length; ++j)if (D[217][j].charCodeAt(0) !== 0xFFFD) {
        e[D[217][j]] = 55552 + j;
        d[55552 + j] = D[217][j];
    }
    D[218] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u51C7\u5196\u51A2\u51A5\u8BA0\u8BA6\u8BA7\u8BAA\u8BB4\u8BB5\u8BB7\u8BC2\u8BC3\u8BCB\u8BCF\u8BCE\u8BD2\u8BD3\u8BD4\u8BD6\u8BD8\u8BD9\u8BDC\u8BDF\u8BE0\u8BE4\u8BE8\u8BE9\u8BEE\u8BF0\u8BF3\u8BF6\u8BF9\u8BFC\u8BFF\u8C00\u8C02\u8C04\u8C07\u8C0C\u8C0F\u8C11\u8C12\u8C14\u8C15\u8C16\u8C19\u8C1B\u8C18\u8C1D\u8C1F\u8C20\u8C21\u8C25\u8C27\u8C2A\u8C2B\u8C2E\u8C2F\u8C32\u8C33\u8C35\u8C36\u5369\u537A\u961D\u9622\u9621\u9631\u962A\u963D\u963C\u9642\u9649\u9654\u965F\u9667\u966C\u9672\u9674\u9688\u968D\u9697\u96B0\u9097\u909B\u909D\u9099\u90AC\u90A1\u90B4\u90B3\u90B6\u90BA\uFFFD".split("");
    for(j = 0; j != D[218].length; ++j)if (D[218][j].charCodeAt(0) !== 0xFFFD) {
        e[D[218][j]] = 55808 + j;
        d[55808 + j] = D[218][j];
    }
    D[219] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u90B8\u90B0\u90CF\u90C5\u90BE\u90D0\u90C4\u90C7\u90D3\u90E6\u90E2\u90DC\u90D7\u90DB\u90EB\u90EF\u90FE\u9104\u9122\u911E\u9123\u9131\u912F\u9139\u9143\u9146\u520D\u5942\u52A2\u52AC\u52AD\u52BE\u54FF\u52D0\u52D6\u52F0\u53DF\u71EE\u77CD\u5EF4\u51F5\u51FC\u9B2F\u53B6\u5F01\u755A\u5DEF\u574C\u57A9\u57A1\u587E\u58BC\u58C5\u58D1\u5729\u572C\u572A\u5733\u5739\u572E\u572F\u575C\u573B\u5742\u5769\u5785\u576B\u5786\u577C\u577B\u5768\u576D\u5776\u5773\u57AD\u57A4\u578C\u57B2\u57CF\u57A7\u57B4\u5793\u57A0\u57D5\u57D8\u57DA\u57D9\u57D2\u57B8\u57F4\u57EF\u57F8\u57E4\u57DD\uFFFD".split("");
    for(j = 0; j != D[219].length; ++j)if (D[219][j].charCodeAt(0) !== 0xFFFD) {
        e[D[219][j]] = 56064 + j;
        d[56064 + j] = D[219][j];
    }
    D[220] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u580B\u580D\u57FD\u57ED\u5800\u581E\u5819\u5844\u5820\u5865\u586C\u5881\u5889\u589A\u5880\u99A8\u9F19\u61FF\u8279\u827D\u827F\u828F\u828A\u82A8\u8284\u828E\u8291\u8297\u8299\u82AB\u82B8\u82BE\u82B0\u82C8\u82CA\u82E3\u8298\u82B7\u82AE\u82CB\u82CC\u82C1\u82A9\u82B4\u82A1\u82AA\u829F\u82C4\u82CE\u82A4\u82E1\u8309\u82F7\u82E4\u830F\u8307\u82DC\u82F4\u82D2\u82D8\u830C\u82FB\u82D3\u8311\u831A\u8306\u8314\u8315\u82E0\u82D5\u831C\u8351\u835B\u835C\u8308\u8392\u833C\u8334\u8331\u839B\u835E\u832F\u834F\u8347\u8343\u835F\u8340\u8317\u8360\u832D\u833A\u8333\u8366\u8365\uFFFD".split("");
    for(j = 0; j != D[220].length; ++j)if (D[220][j].charCodeAt(0) !== 0xFFFD) {
        e[D[220][j]] = 56320 + j;
        d[56320 + j] = D[220][j];
    }
    D[221] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8368\u831B\u8369\u836C\u836A\u836D\u836E\u83B0\u8378\u83B3\u83B4\u83A0\u83AA\u8393\u839C\u8385\u837C\u83B6\u83A9\u837D\u83B8\u837B\u8398\u839E\u83A8\u83BA\u83BC\u83C1\u8401\u83E5\u83D8\u5807\u8418\u840B\u83DD\u83FD\u83D6\u841C\u8438\u8411\u8406\u83D4\u83DF\u840F\u8403\u83F8\u83F9\u83EA\u83C5\u83C0\u8426\u83F0\u83E1\u845C\u8451\u845A\u8459\u8473\u8487\u8488\u847A\u8489\u8478\u843C\u8446\u8469\u8476\u848C\u848E\u8431\u846D\u84C1\u84CD\u84D0\u84E6\u84BD\u84D3\u84CA\u84BF\u84BA\u84E0\u84A1\u84B9\u84B4\u8497\u84E5\u84E3\u850C\u750D\u8538\u84F0\u8539\u851F\u853A\uFFFD".split("");
    for(j = 0; j != D[221].length; ++j)if (D[221][j].charCodeAt(0) !== 0xFFFD) {
        e[D[221][j]] = 56576 + j;
        d[56576 + j] = D[221][j];
    }
    D[222] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8556\u853B\u84FF\u84FC\u8559\u8548\u8568\u8564\u855E\u857A\u77A2\u8543\u8572\u857B\u85A4\u85A8\u8587\u858F\u8579\u85AE\u859C\u8585\u85B9\u85B7\u85B0\u85D3\u85C1\u85DC\u85FF\u8627\u8605\u8629\u8616\u863C\u5EFE\u5F08\u593C\u5941\u8037\u5955\u595A\u5958\u530F\u5C22\u5C25\u5C2C\u5C34\u624C\u626A\u629F\u62BB\u62CA\u62DA\u62D7\u62EE\u6322\u62F6\u6339\u634B\u6343\u63AD\u63F6\u6371\u637A\u638E\u63B4\u636D\u63AC\u638A\u6369\u63AE\u63BC\u63F2\u63F8\u63E0\u63FF\u63C4\u63DE\u63CE\u6452\u63C6\u63BE\u6445\u6441\u640B\u641B\u6420\u640C\u6426\u6421\u645E\u6484\u646D\u6496\uFFFD".split("");
    for(j = 0; j != D[222].length; ++j)if (D[222][j].charCodeAt(0) !== 0xFFFD) {
        e[D[222][j]] = 56832 + j;
        d[56832 + j] = D[222][j];
    }
    D[223] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u647A\u64B7\u64B8\u6499\u64BA\u64C0\u64D0\u64D7\u64E4\u64E2\u6509\u6525\u652E\u5F0B\u5FD2\u7519\u5F11\u535F\u53F1\u53FD\u53E9\u53E8\u53FB\u5412\u5416\u5406\u544B\u5452\u5453\u5454\u5456\u5443\u5421\u5457\u5459\u5423\u5432\u5482\u5494\u5477\u5471\u5464\u549A\u549B\u5484\u5476\u5466\u549D\u54D0\u54AD\u54C2\u54B4\u54D2\u54A7\u54A6\u54D3\u54D4\u5472\u54A3\u54D5\u54BB\u54BF\u54CC\u54D9\u54DA\u54DC\u54A9\u54AA\u54A4\u54DD\u54CF\u54DE\u551B\u54E7\u5520\u54FD\u5514\u54F3\u5522\u5523\u550F\u5511\u5527\u552A\u5567\u558F\u55B5\u5549\u556D\u5541\u5555\u553F\u5550\u553C\uFFFD".split("");
    for(j = 0; j != D[223].length; ++j)if (D[223][j].charCodeAt(0) !== 0xFFFD) {
        e[D[223][j]] = 57088 + j;
        d[57088 + j] = D[223][j];
    }
    D[224] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5537\u5556\u5575\u5576\u5577\u5533\u5530\u555C\u558B\u55D2\u5583\u55B1\u55B9\u5588\u5581\u559F\u557E\u55D6\u5591\u557B\u55DF\u55BD\u55BE\u5594\u5599\u55EA\u55F7\u55C9\u561F\u55D1\u55EB\u55EC\u55D4\u55E6\u55DD\u55C4\u55EF\u55E5\u55F2\u55F3\u55CC\u55CD\u55E8\u55F5\u55E4\u8F94\u561E\u5608\u560C\u5601\u5624\u5623\u55FE\u5600\u5627\u562D\u5658\u5639\u5657\u562C\u564D\u5662\u5659\u565C\u564C\u5654\u5686\u5664\u5671\u566B\u567B\u567C\u5685\u5693\u56AF\u56D4\u56D7\u56DD\u56E1\u56F5\u56EB\u56F9\u56FF\u5704\u570A\u5709\u571C\u5E0F\u5E19\u5E14\u5E11\u5E31\u5E3B\u5E3C\uFFFD".split("");
    for(j = 0; j != D[224].length; ++j)if (D[224][j].charCodeAt(0) !== 0xFFFD) {
        e[D[224][j]] = 57344 + j;
        d[57344 + j] = D[224][j];
    }
    D[225] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5E37\u5E44\u5E54\u5E5B\u5E5E\u5E61\u5C8C\u5C7A\u5C8D\u5C90\u5C96\u5C88\u5C98\u5C99\u5C91\u5C9A\u5C9C\u5CB5\u5CA2\u5CBD\u5CAC\u5CAB\u5CB1\u5CA3\u5CC1\u5CB7\u5CC4\u5CD2\u5CE4\u5CCB\u5CE5\u5D02\u5D03\u5D27\u5D26\u5D2E\u5D24\u5D1E\u5D06\u5D1B\u5D58\u5D3E\u5D34\u5D3D\u5D6C\u5D5B\u5D6F\u5D5D\u5D6B\u5D4B\u5D4A\u5D69\u5D74\u5D82\u5D99\u5D9D\u8C73\u5DB7\u5DC5\u5F73\u5F77\u5F82\u5F87\u5F89\u5F8C\u5F95\u5F99\u5F9C\u5FA8\u5FAD\u5FB5\u5FBC\u8862\u5F61\u72AD\u72B0\u72B4\u72B7\u72B8\u72C3\u72C1\u72CE\u72CD\u72D2\u72E8\u72EF\u72E9\u72F2\u72F4\u72F7\u7301\u72F3\u7303\u72FA\uFFFD".split("");
    for(j = 0; j != D[225].length; ++j)if (D[225][j].charCodeAt(0) !== 0xFFFD) {
        e[D[225][j]] = 57600 + j;
        d[57600 + j] = D[225][j];
    }
    D[226] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u72FB\u7317\u7313\u7321\u730A\u731E\u731D\u7315\u7322\u7339\u7325\u732C\u7338\u7331\u7350\u734D\u7357\u7360\u736C\u736F\u737E\u821B\u5925\u98E7\u5924\u5902\u9963\u9967\u9968\u9969\u996A\u996B\u996C\u9974\u9977\u997D\u9980\u9984\u9987\u998A\u998D\u9990\u9991\u9993\u9994\u9995\u5E80\u5E91\u5E8B\u5E96\u5EA5\u5EA0\u5EB9\u5EB5\u5EBE\u5EB3\u8D53\u5ED2\u5ED1\u5EDB\u5EE8\u5EEA\u81BA\u5FC4\u5FC9\u5FD6\u5FCF\u6003\u5FEE\u6004\u5FE1\u5FE4\u5FFE\u6005\u6006\u5FEA\u5FED\u5FF8\u6019\u6035\u6026\u601B\u600F\u600D\u6029\u602B\u600A\u603F\u6021\u6078\u6079\u607B\u607A\u6042\uFFFD".split("");
    for(j = 0; j != D[226].length; ++j)if (D[226][j].charCodeAt(0) !== 0xFFFD) {
        e[D[226][j]] = 57856 + j;
        d[57856 + j] = D[226][j];
    }
    D[227] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u606A\u607D\u6096\u609A\u60AD\u609D\u6083\u6092\u608C\u609B\u60EC\u60BB\u60B1\u60DD\u60D8\u60C6\u60DA\u60B4\u6120\u6126\u6115\u6123\u60F4\u6100\u610E\u612B\u614A\u6175\u61AC\u6194\u61A7\u61B7\u61D4\u61F5\u5FDD\u96B3\u95E9\u95EB\u95F1\u95F3\u95F5\u95F6\u95FC\u95FE\u9603\u9604\u9606\u9608\u960A\u960B\u960C\u960D\u960F\u9612\u9615\u9616\u9617\u9619\u961A\u4E2C\u723F\u6215\u6C35\u6C54\u6C5C\u6C4A\u6CA3\u6C85\u6C90\u6C94\u6C8C\u6C68\u6C69\u6C74\u6C76\u6C86\u6CA9\u6CD0\u6CD4\u6CAD\u6CF7\u6CF8\u6CF1\u6CD7\u6CB2\u6CE0\u6CD6\u6CFA\u6CEB\u6CEE\u6CB1\u6CD3\u6CEF\u6CFE\uFFFD".split("");
    for(j = 0; j != D[227].length; ++j)if (D[227][j].charCodeAt(0) !== 0xFFFD) {
        e[D[227][j]] = 58112 + j;
        d[58112 + j] = D[227][j];
    }
    D[228] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6D39\u6D27\u6D0C\u6D43\u6D48\u6D07\u6D04\u6D19\u6D0E\u6D2B\u6D4D\u6D2E\u6D35\u6D1A\u6D4F\u6D52\u6D54\u6D33\u6D91\u6D6F\u6D9E\u6DA0\u6D5E\u6D93\u6D94\u6D5C\u6D60\u6D7C\u6D63\u6E1A\u6DC7\u6DC5\u6DDE\u6E0E\u6DBF\u6DE0\u6E11\u6DE6\u6DDD\u6DD9\u6E16\u6DAB\u6E0C\u6DAE\u6E2B\u6E6E\u6E4E\u6E6B\u6EB2\u6E5F\u6E86\u6E53\u6E54\u6E32\u6E25\u6E44\u6EDF\u6EB1\u6E98\u6EE0\u6F2D\u6EE2\u6EA5\u6EA7\u6EBD\u6EBB\u6EB7\u6ED7\u6EB4\u6ECF\u6E8F\u6EC2\u6E9F\u6F62\u6F46\u6F47\u6F24\u6F15\u6EF9\u6F2F\u6F36\u6F4B\u6F74\u6F2A\u6F09\u6F29\u6F89\u6F8D\u6F8C\u6F78\u6F72\u6F7C\u6F7A\u6FD1\uFFFD".split("");
    for(j = 0; j != D[228].length; ++j)if (D[228][j].charCodeAt(0) !== 0xFFFD) {
        e[D[228][j]] = 58368 + j;
        d[58368 + j] = D[228][j];
    }
    D[229] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6FC9\u6FA7\u6FB9\u6FB6\u6FC2\u6FE1\u6FEE\u6FDE\u6FE0\u6FEF\u701A\u7023\u701B\u7039\u7035\u704F\u705E\u5B80\u5B84\u5B95\u5B93\u5BA5\u5BB8\u752F\u9A9E\u6434\u5BE4\u5BEE\u8930\u5BF0\u8E47\u8B07\u8FB6\u8FD3\u8FD5\u8FE5\u8FEE\u8FE4\u8FE9\u8FE6\u8FF3\u8FE8\u9005\u9004\u900B\u9026\u9011\u900D\u9016\u9021\u9035\u9036\u902D\u902F\u9044\u9051\u9052\u9050\u9068\u9058\u9062\u905B\u66B9\u9074\u907D\u9082\u9088\u9083\u908B\u5F50\u5F57\u5F56\u5F58\u5C3B\u54AB\u5C50\u5C59\u5B71\u5C63\u5C66\u7FBC\u5F2A\u5F29\u5F2D\u8274\u5F3C\u9B3B\u5C6E\u5981\u5983\u598D\u59A9\u59AA\u59A3\uFFFD".split("");
    for(j = 0; j != D[229].length; ++j)if (D[229][j].charCodeAt(0) !== 0xFFFD) {
        e[D[229][j]] = 58624 + j;
        d[58624 + j] = D[229][j];
    }
    D[230] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5997\u59CA\u59AB\u599E\u59A4\u59D2\u59B2\u59AF\u59D7\u59BE\u5A05\u5A06\u59DD\u5A08\u59E3\u59D8\u59F9\u5A0C\u5A09\u5A32\u5A34\u5A11\u5A23\u5A13\u5A40\u5A67\u5A4A\u5A55\u5A3C\u5A62\u5A75\u80EC\u5AAA\u5A9B\u5A77\u5A7A\u5ABE\u5AEB\u5AB2\u5AD2\u5AD4\u5AB8\u5AE0\u5AE3\u5AF1\u5AD6\u5AE6\u5AD8\u5ADC\u5B09\u5B17\u5B16\u5B32\u5B37\u5B40\u5C15\u5C1C\u5B5A\u5B65\u5B73\u5B51\u5B53\u5B62\u9A75\u9A77\u9A78\u9A7A\u9A7F\u9A7D\u9A80\u9A81\u9A85\u9A88\u9A8A\u9A90\u9A92\u9A93\u9A96\u9A98\u9A9B\u9A9C\u9A9D\u9A9F\u9AA0\u9AA2\u9AA3\u9AA5\u9AA7\u7E9F\u7EA1\u7EA3\u7EA5\u7EA8\u7EA9\uFFFD".split("");
    for(j = 0; j != D[230].length; ++j)if (D[230][j].charCodeAt(0) !== 0xFFFD) {
        e[D[230][j]] = 58880 + j;
        d[58880 + j] = D[230][j];
    }
    D[231] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7EAD\u7EB0\u7EBE\u7EC0\u7EC1\u7EC2\u7EC9\u7ECB\u7ECC\u7ED0\u7ED4\u7ED7\u7EDB\u7EE0\u7EE1\u7EE8\u7EEB\u7EEE\u7EEF\u7EF1\u7EF2\u7F0D\u7EF6\u7EFA\u7EFB\u7EFE\u7F01\u7F02\u7F03\u7F07\u7F08\u7F0B\u7F0C\u7F0F\u7F11\u7F12\u7F17\u7F19\u7F1C\u7F1B\u7F1F\u7F21\u7F22\u7F23\u7F24\u7F25\u7F26\u7F27\u7F2A\u7F2B\u7F2C\u7F2D\u7F2F\u7F30\u7F31\u7F32\u7F33\u7F35\u5E7A\u757F\u5DDB\u753E\u9095\u738E\u7391\u73AE\u73A2\u739F\u73CF\u73C2\u73D1\u73B7\u73B3\u73C0\u73C9\u73C8\u73E5\u73D9\u987C\u740A\u73E9\u73E7\u73DE\u73BA\u73F2\u740F\u742A\u745B\u7426\u7425\u7428\u7430\u742E\u742C\uFFFD".split("");
    for(j = 0; j != D[231].length; ++j)if (D[231][j].charCodeAt(0) !== 0xFFFD) {
        e[D[231][j]] = 59136 + j;
        d[59136 + j] = D[231][j];
    }
    D[232] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u741B\u741A\u7441\u745C\u7457\u7455\u7459\u7477\u746D\u747E\u749C\u748E\u7480\u7481\u7487\u748B\u749E\u74A8\u74A9\u7490\u74A7\u74D2\u74BA\u97EA\u97EB\u97EC\u674C\u6753\u675E\u6748\u6769\u67A5\u6787\u676A\u6773\u6798\u67A7\u6775\u67A8\u679E\u67AD\u678B\u6777\u677C\u67F0\u6809\u67D8\u680A\u67E9\u67B0\u680C\u67D9\u67B5\u67DA\u67B3\u67DD\u6800\u67C3\u67B8\u67E2\u680E\u67C1\u67FD\u6832\u6833\u6860\u6861\u684E\u6862\u6844\u6864\u6883\u681D\u6855\u6866\u6841\u6867\u6840\u683E\u684A\u6849\u6829\u68B5\u688F\u6874\u6877\u6893\u686B\u68C2\u696E\u68FC\u691F\u6920\u68F9\uFFFD".split("");
    for(j = 0; j != D[232].length; ++j)if (D[232][j].charCodeAt(0) !== 0xFFFD) {
        e[D[232][j]] = 59392 + j;
        d[59392 + j] = D[232][j];
    }
    D[233] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6924\u68F0\u690B\u6901\u6957\u68E3\u6910\u6971\u6939\u6960\u6942\u695D\u6984\u696B\u6980\u6998\u6978\u6934\u69CC\u6987\u6988\u69CE\u6989\u6966\u6963\u6979\u699B\u69A7\u69BB\u69AB\u69AD\u69D4\u69B1\u69C1\u69CA\u69DF\u6995\u69E0\u698D\u69FF\u6A2F\u69ED\u6A17\u6A18\u6A65\u69F2\u6A44\u6A3E\u6AA0\u6A50\u6A5B\u6A35\u6A8E\u6A79\u6A3D\u6A28\u6A58\u6A7C\u6A91\u6A90\u6AA9\u6A97\u6AAB\u7337\u7352\u6B81\u6B82\u6B87\u6B84\u6B92\u6B93\u6B8D\u6B9A\u6B9B\u6BA1\u6BAA\u8F6B\u8F6D\u8F71\u8F72\u8F73\u8F75\u8F76\u8F78\u8F77\u8F79\u8F7A\u8F7C\u8F7E\u8F81\u8F82\u8F84\u8F87\u8F8B\uFFFD".split("");
    for(j = 0; j != D[233].length; ++j)if (D[233][j].charCodeAt(0) !== 0xFFFD) {
        e[D[233][j]] = 59648 + j;
        d[59648 + j] = D[233][j];
    }
    D[234] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8F8D\u8F8E\u8F8F\u8F98\u8F9A\u8ECE\u620B\u6217\u621B\u621F\u6222\u6221\u6225\u6224\u622C\u81E7\u74EF\u74F4\u74FF\u750F\u7511\u7513\u6534\u65EE\u65EF\u65F0\u660A\u6619\u6772\u6603\u6615\u6600\u7085\u66F7\u661D\u6634\u6631\u6636\u6635\u8006\u665F\u6654\u6641\u664F\u6656\u6661\u6657\u6677\u6684\u668C\u66A7\u669D\u66BE\u66DB\u66DC\u66E6\u66E9\u8D32\u8D33\u8D36\u8D3B\u8D3D\u8D40\u8D45\u8D46\u8D48\u8D49\u8D47\u8D4D\u8D55\u8D59\u89C7\u89CA\u89CB\u89CC\u89CE\u89CF\u89D0\u89D1\u726E\u729F\u725D\u7266\u726F\u727E\u727F\u7284\u728B\u728D\u728F\u7292\u6308\u6332\u63B0\uFFFD".split("");
    for(j = 0; j != D[234].length; ++j)if (D[234][j].charCodeAt(0) !== 0xFFFD) {
        e[D[234][j]] = 59904 + j;
        d[59904 + j] = D[234][j];
    }
    D[235] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u643F\u64D8\u8004\u6BEA\u6BF3\u6BFD\u6BF5\u6BF9\u6C05\u6C07\u6C06\u6C0D\u6C15\u6C18\u6C19\u6C1A\u6C21\u6C29\u6C24\u6C2A\u6C32\u6535\u6555\u656B\u724D\u7252\u7256\u7230\u8662\u5216\u809F\u809C\u8093\u80BC\u670A\u80BD\u80B1\u80AB\u80AD\u80B4\u80B7\u80E7\u80E8\u80E9\u80EA\u80DB\u80C2\u80C4\u80D9\u80CD\u80D7\u6710\u80DD\u80EB\u80F1\u80F4\u80ED\u810D\u810E\u80F2\u80FC\u6715\u8112\u8C5A\u8136\u811E\u812C\u8118\u8132\u8148\u814C\u8153\u8174\u8159\u815A\u8171\u8160\u8169\u817C\u817D\u816D\u8167\u584D\u5AB5\u8188\u8182\u8191\u6ED5\u81A3\u81AA\u81CC\u6726\u81CA\u81BB\uFFFD".split("");
    for(j = 0; j != D[235].length; ++j)if (D[235][j].charCodeAt(0) !== 0xFFFD) {
        e[D[235][j]] = 60160 + j;
        d[60160 + j] = D[235][j];
    }
    D[236] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u81C1\u81A6\u6B24\u6B37\u6B39\u6B43\u6B46\u6B59\u98D1\u98D2\u98D3\u98D5\u98D9\u98DA\u6BB3\u5F40\u6BC2\u89F3\u6590\u9F51\u6593\u65BC\u65C6\u65C4\u65C3\u65CC\u65CE\u65D2\u65D6\u7080\u709C\u7096\u709D\u70BB\u70C0\u70B7\u70AB\u70B1\u70E8\u70CA\u7110\u7113\u7116\u712F\u7131\u7173\u715C\u7168\u7145\u7172\u714A\u7178\u717A\u7198\u71B3\u71B5\u71A8\u71A0\u71E0\u71D4\u71E7\u71F9\u721D\u7228\u706C\u7118\u7166\u71B9\u623E\u623D\u6243\u6248\u6249\u793B\u7940\u7946\u7949\u795B\u795C\u7953\u795A\u7962\u7957\u7960\u796F\u7967\u797A\u7985\u798A\u799A\u79A7\u79B3\u5FD1\u5FD0\uFFFD".split("");
    for(j = 0; j != D[236].length; ++j)if (D[236][j].charCodeAt(0) !== 0xFFFD) {
        e[D[236][j]] = 60416 + j;
        d[60416 + j] = D[236][j];
    }
    D[237] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u603C\u605D\u605A\u6067\u6041\u6059\u6063\u60AB\u6106\u610D\u615D\u61A9\u619D\u61CB\u61D1\u6206\u8080\u807F\u6C93\u6CF6\u6DFC\u77F6\u77F8\u7800\u7809\u7817\u7818\u7811\u65AB\u782D\u781C\u781D\u7839\u783A\u783B\u781F\u783C\u7825\u782C\u7823\u7829\u784E\u786D\u7856\u7857\u7826\u7850\u7847\u784C\u786A\u789B\u7893\u789A\u7887\u789C\u78A1\u78A3\u78B2\u78B9\u78A5\u78D4\u78D9\u78C9\u78EC\u78F2\u7905\u78F4\u7913\u7924\u791E\u7934\u9F9B\u9EF9\u9EFB\u9EFC\u76F1\u7704\u770D\u76F9\u7707\u7708\u771A\u7722\u7719\u772D\u7726\u7735\u7738\u7750\u7751\u7747\u7743\u775A\u7768\uFFFD".split("");
    for(j = 0; j != D[237].length; ++j)if (D[237][j].charCodeAt(0) !== 0xFFFD) {
        e[D[237][j]] = 60672 + j;
        d[60672 + j] = D[237][j];
    }
    D[238] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7762\u7765\u777F\u778D\u777D\u7780\u778C\u7791\u779F\u77A0\u77B0\u77B5\u77BD\u753A\u7540\u754E\u754B\u7548\u755B\u7572\u7579\u7583\u7F58\u7F61\u7F5F\u8A48\u7F68\u7F74\u7F71\u7F79\u7F81\u7F7E\u76CD\u76E5\u8832\u9485\u9486\u9487\u948B\u948A\u948C\u948D\u948F\u9490\u9494\u9497\u9495\u949A\u949B\u949C\u94A3\u94A4\u94AB\u94AA\u94AD\u94AC\u94AF\u94B0\u94B2\u94B4\u94B6\u94B7\u94B8\u94B9\u94BA\u94BC\u94BD\u94BF\u94C4\u94C8\u94C9\u94CA\u94CB\u94CC\u94CD\u94CE\u94D0\u94D1\u94D2\u94D5\u94D6\u94D7\u94D9\u94D8\u94DB\u94DE\u94DF\u94E0\u94E2\u94E4\u94E5\u94E7\u94E8\u94EA\uFFFD".split("");
    for(j = 0; j != D[238].length; ++j)if (D[238][j].charCodeAt(0) !== 0xFFFD) {
        e[D[238][j]] = 60928 + j;
        d[60928 + j] = D[238][j];
    }
    D[239] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u94E9\u94EB\u94EE\u94EF\u94F3\u94F4\u94F5\u94F7\u94F9\u94FC\u94FD\u94FF\u9503\u9502\u9506\u9507\u9509\u950A\u950D\u950E\u950F\u9512\u9513\u9514\u9515\u9516\u9518\u951B\u951D\u951E\u951F\u9522\u952A\u952B\u9529\u952C\u9531\u9532\u9534\u9536\u9537\u9538\u953C\u953E\u953F\u9542\u9535\u9544\u9545\u9546\u9549\u954C\u954E\u954F\u9552\u9553\u9554\u9556\u9557\u9558\u9559\u955B\u955E\u955F\u955D\u9561\u9562\u9564\u9565\u9566\u9567\u9568\u9569\u956A\u956B\u956C\u956F\u9571\u9572\u9573\u953A\u77E7\u77EC\u96C9\u79D5\u79ED\u79E3\u79EB\u7A06\u5D47\u7A03\u7A02\u7A1E\u7A14\uFFFD".split("");
    for(j = 0; j != D[239].length; ++j)if (D[239][j].charCodeAt(0) !== 0xFFFD) {
        e[D[239][j]] = 61184 + j;
        d[61184 + j] = D[239][j];
    }
    D[240] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7A39\u7A37\u7A51\u9ECF\u99A5\u7A70\u7688\u768E\u7693\u7699\u76A4\u74DE\u74E0\u752C\u9E20\u9E22\u9E28\u9E29\u9E2A\u9E2B\u9E2C\u9E32\u9E31\u9E36\u9E38\u9E37\u9E39\u9E3A\u9E3E\u9E41\u9E42\u9E44\u9E46\u9E47\u9E48\u9E49\u9E4B\u9E4C\u9E4E\u9E51\u9E55\u9E57\u9E5A\u9E5B\u9E5C\u9E5E\u9E63\u9E66\u9E67\u9E68\u9E69\u9E6A\u9E6B\u9E6C\u9E71\u9E6D\u9E73\u7592\u7594\u7596\u75A0\u759D\u75AC\u75A3\u75B3\u75B4\u75B8\u75C4\u75B1\u75B0\u75C3\u75C2\u75D6\u75CD\u75E3\u75E8\u75E6\u75E4\u75EB\u75E7\u7603\u75F1\u75FC\u75FF\u7610\u7600\u7605\u760C\u7617\u760A\u7625\u7618\u7615\u7619\uFFFD".split("");
    for(j = 0; j != D[240].length; ++j)if (D[240][j].charCodeAt(0) !== 0xFFFD) {
        e[D[240][j]] = 61440 + j;
        d[61440 + j] = D[240][j];
    }
    D[241] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u761B\u763C\u7622\u7620\u7640\u762D\u7630\u763F\u7635\u7643\u763E\u7633\u764D\u765E\u7654\u765C\u7656\u766B\u766F\u7FCA\u7AE6\u7A78\u7A79\u7A80\u7A86\u7A88\u7A95\u7AA6\u7AA0\u7AAC\u7AA8\u7AAD\u7AB3\u8864\u8869\u8872\u887D\u887F\u8882\u88A2\u88C6\u88B7\u88BC\u88C9\u88E2\u88CE\u88E3\u88E5\u88F1\u891A\u88FC\u88E8\u88FE\u88F0\u8921\u8919\u8913\u891B\u890A\u8934\u892B\u8936\u8941\u8966\u897B\u758B\u80E5\u76B2\u76B4\u77DC\u8012\u8014\u8016\u801C\u8020\u8022\u8025\u8026\u8027\u8029\u8028\u8031\u800B\u8035\u8043\u8046\u804D\u8052\u8069\u8071\u8983\u9878\u9880\u9883\uFFFD".split("");
    for(j = 0; j != D[241].length; ++j)if (D[241][j].charCodeAt(0) !== 0xFFFD) {
        e[D[241][j]] = 61696 + j;
        d[61696 + j] = D[241][j];
    }
    D[242] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9889\u988C\u988D\u988F\u9894\u989A\u989B\u989E\u989F\u98A1\u98A2\u98A5\u98A6\u864D\u8654\u866C\u866E\u867F\u867A\u867C\u867B\u86A8\u868D\u868B\u86AC\u869D\u86A7\u86A3\u86AA\u8693\u86A9\u86B6\u86C4\u86B5\u86CE\u86B0\u86BA\u86B1\u86AF\u86C9\u86CF\u86B4\u86E9\u86F1\u86F2\u86ED\u86F3\u86D0\u8713\u86DE\u86F4\u86DF\u86D8\u86D1\u8703\u8707\u86F8\u8708\u870A\u870D\u8709\u8723\u873B\u871E\u8725\u872E\u871A\u873E\u8748\u8734\u8731\u8729\u8737\u873F\u8782\u8722\u877D\u877E\u877B\u8760\u8770\u874C\u876E\u878B\u8753\u8763\u877C\u8764\u8759\u8765\u8793\u87AF\u87A8\u87D2\uFFFD".split("");
    for(j = 0; j != D[242].length; ++j)if (D[242][j].charCodeAt(0) !== 0xFFFD) {
        e[D[242][j]] = 61952 + j;
        d[61952 + j] = D[242][j];
    }
    D[243] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u87C6\u8788\u8785\u87AD\u8797\u8783\u87AB\u87E5\u87AC\u87B5\u87B3\u87CB\u87D3\u87BD\u87D1\u87C0\u87CA\u87DB\u87EA\u87E0\u87EE\u8816\u8813\u87FE\u880A\u881B\u8821\u8839\u883C\u7F36\u7F42\u7F44\u7F45\u8210\u7AFA\u7AFD\u7B08\u7B03\u7B04\u7B15\u7B0A\u7B2B\u7B0F\u7B47\u7B38\u7B2A\u7B19\u7B2E\u7B31\u7B20\u7B25\u7B24\u7B33\u7B3E\u7B1E\u7B58\u7B5A\u7B45\u7B75\u7B4C\u7B5D\u7B60\u7B6E\u7B7B\u7B62\u7B72\u7B71\u7B90\u7BA6\u7BA7\u7BB8\u7BAC\u7B9D\u7BA8\u7B85\u7BAA\u7B9C\u7BA2\u7BAB\u7BB4\u7BD1\u7BC1\u7BCC\u7BDD\u7BDA\u7BE5\u7BE6\u7BEA\u7C0C\u7BFE\u7BFC\u7C0F\u7C16\u7C0B\uFFFD".split("");
    for(j = 0; j != D[243].length; ++j)if (D[243][j].charCodeAt(0) !== 0xFFFD) {
        e[D[243][j]] = 62208 + j;
        d[62208 + j] = D[243][j];
    }
    D[244] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7C1F\u7C2A\u7C26\u7C38\u7C41\u7C40\u81FE\u8201\u8202\u8204\u81EC\u8844\u8221\u8222\u8223\u822D\u822F\u8228\u822B\u8238\u823B\u8233\u8234\u823E\u8244\u8249\u824B\u824F\u825A\u825F\u8268\u887E\u8885\u8888\u88D8\u88DF\u895E\u7F9D\u7F9F\u7FA7\u7FAF\u7FB0\u7FB2\u7C7C\u6549\u7C91\u7C9D\u7C9C\u7C9E\u7CA2\u7CB2\u7CBC\u7CBD\u7CC1\u7CC7\u7CCC\u7CCD\u7CC8\u7CC5\u7CD7\u7CE8\u826E\u66A8\u7FBF\u7FCE\u7FD5\u7FE5\u7FE1\u7FE6\u7FE9\u7FEE\u7FF3\u7CF8\u7D77\u7DA6\u7DAE\u7E47\u7E9B\u9EB8\u9EB4\u8D73\u8D84\u8D94\u8D91\u8DB1\u8D67\u8D6D\u8C47\u8C49\u914A\u9150\u914E\u914F\u9164\uFFFD".split("");
    for(j = 0; j != D[244].length; ++j)if (D[244][j].charCodeAt(0) !== 0xFFFD) {
        e[D[244][j]] = 62464 + j;
        d[62464 + j] = D[244][j];
    }
    D[245] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9162\u9161\u9170\u9169\u916F\u917D\u917E\u9172\u9174\u9179\u918C\u9185\u9190\u918D\u9191\u91A2\u91A3\u91AA\u91AD\u91AE\u91AF\u91B5\u91B4\u91BA\u8C55\u9E7E\u8DB8\u8DEB\u8E05\u8E59\u8E69\u8DB5\u8DBF\u8DBC\u8DBA\u8DC4\u8DD6\u8DD7\u8DDA\u8DDE\u8DCE\u8DCF\u8DDB\u8DC6\u8DEC\u8DF7\u8DF8\u8DE3\u8DF9\u8DFB\u8DE4\u8E09\u8DFD\u8E14\u8E1D\u8E1F\u8E2C\u8E2E\u8E23\u8E2F\u8E3A\u8E40\u8E39\u8E35\u8E3D\u8E31\u8E49\u8E41\u8E42\u8E51\u8E52\u8E4A\u8E70\u8E76\u8E7C\u8E6F\u8E74\u8E85\u8E8F\u8E94\u8E90\u8E9C\u8E9E\u8C78\u8C82\u8C8A\u8C85\u8C98\u8C94\u659B\u89D6\u89DE\u89DA\u89DC\uFFFD".split("");
    for(j = 0; j != D[245].length; ++j)if (D[245][j].charCodeAt(0) !== 0xFFFD) {
        e[D[245][j]] = 62720 + j;
        d[62720 + j] = D[245][j];
    }
    D[246] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u89E5\u89EB\u89EF\u8A3E\u8B26\u9753\u96E9\u96F3\u96EF\u9706\u9701\u9708\u970F\u970E\u972A\u972D\u9730\u973E\u9F80\u9F83\u9F85\u9F86\u9F87\u9F88\u9F89\u9F8A\u9F8C\u9EFE\u9F0B\u9F0D\u96B9\u96BC\u96BD\u96CE\u96D2\u77BF\u96E0\u928E\u92AE\u92C8\u933E\u936A\u93CA\u938F\u943E\u946B\u9C7F\u9C82\u9C85\u9C86\u9C87\u9C88\u7A23\u9C8B\u9C8E\u9C90\u9C91\u9C92\u9C94\u9C95\u9C9A\u9C9B\u9C9E\u9C9F\u9CA0\u9CA1\u9CA2\u9CA3\u9CA5\u9CA6\u9CA7\u9CA8\u9CA9\u9CAB\u9CAD\u9CAE\u9CB0\u9CB1\u9CB2\u9CB3\u9CB4\u9CB5\u9CB6\u9CB7\u9CBA\u9CBB\u9CBC\u9CBD\u9CC4\u9CC5\u9CC6\u9CC7\u9CCA\u9CCB\uFFFD".split("");
    for(j = 0; j != D[246].length; ++j)if (D[246][j].charCodeAt(0) !== 0xFFFD) {
        e[D[246][j]] = 62976 + j;
        d[62976 + j] = D[246][j];
    }
    D[247] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9CCC\u9CCD\u9CCE\u9CCF\u9CD0\u9CD3\u9CD4\u9CD5\u9CD7\u9CD8\u9CD9\u9CDC\u9CDD\u9CDF\u9CE2\u977C\u9785\u9791\u9792\u9794\u97AF\u97AB\u97A3\u97B2\u97B4\u9AB1\u9AB0\u9AB7\u9E58\u9AB6\u9ABA\u9ABC\u9AC1\u9AC0\u9AC5\u9AC2\u9ACB\u9ACC\u9AD1\u9B45\u9B43\u9B47\u9B49\u9B48\u9B4D\u9B51\u98E8\u990D\u992E\u9955\u9954\u9ADF\u9AE1\u9AE6\u9AEF\u9AEB\u9AFB\u9AED\u9AF9\u9B08\u9B0F\u9B13\u9B1F\u9B23\u9EBD\u9EBE\u7E3B\u9E82\u9E87\u9E88\u9E8B\u9E92\u93D6\u9E9D\u9E9F\u9EDB\u9EDC\u9EDD\u9EE0\u9EDF\u9EE2\u9EE9\u9EE7\u9EE5\u9EEA\u9EEF\u9F22\u9F2C\u9F2F\u9F39\u9F37\u9F3D\u9F3E\u9F44\uFFFD".split("");
    for(j = 0; j != D[247].length; ++j)if (D[247][j].charCodeAt(0) !== 0xFFFD) {
        e[D[247][j]] = 63232 + j;
        d[63232 + j] = D[247][j];
    }
    return {
        "enc": e,
        "dec": d
    };
}();
$e1f740a9d01acc72$var$cptable[10029] = function() {
    var d = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\xc4\u0100\u0101\xc9\u0104\xd6\xdc\xe1\u0105\u010C\xe4\u010D\u0106\u0107\xe9\u0179\u017A\u010E\xed\u010F\u0112\u0113\u0116\xf3\u0117\xf4\xf6\xf5\xfa\u011A\u011B\xfc\u2020\xb0\u0118\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\u0119\xa8\u2260\u0123\u012E\u012F\u012A\u2264\u2265\u012B\u0136\u2202\u2211\u0142\u013B\u013C\u013D\u013E\u0139\u013A\u0145\u0146\u0143\xac\u221A\u0144\u0147\u2206\xab\xbb\u2026\xa0\u0148\u0150\xd5\u0151\u014C\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\u014D\u0154\u0155\u0158\u2039\u203A\u0159\u0156\u0157\u0160\u201A\u201E\u0161\u015A\u015B\xc1\u0164\u0165\xcd\u017D\u017E\u016A\xd3\xd4\u016B\u016E\xda\u016F\u0170\u0171\u0172\u0173\xdd\xfd\u0137\u017B\u0141\u017C\u0122\u02C7", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
$e1f740a9d01acc72$var$cptable[10079] = function() {
    var d = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\xdd\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u2126\xe6\xf8\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u2044\xa4\xd0\xf0\xde\xfe\xfd\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uFFFD\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
$e1f740a9d01acc72$var$cptable[10081] = function() {
    var d = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u2126\xe6\xf8\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u011E\u011F\u0130\u0131\u015E\u015F\u2021\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uFFFD\xd2\xda\xdb\xd9\uFFFD\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
$e1f740a9d01acc72$var$cptable[28591] = function() {
    var d = "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\xd0\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\xdd\xde\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\xf0\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\xfd\xfe\xff", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
// eslint-disable-next-line no-undef
if (module.exports && typeof DO_NOT_EXPORT_CODEPAGE === 'undefined') module.exports = $e1f740a9d01acc72$var$cptable;
/*! cputils.js (C) 2013-present SheetJS -- http://sheetjs.com */ /* vim: set ft=javascript: */ /*jshint newcap: false */ (function(root, factory) {
    /*jshint ignore:start */ /*eslint-disable */ "use strict";
    if (typeof $e1f740a9d01acc72$var$cptable === "undefined") {
        var cpt = $e1f740a9d01acc72$var$cptable;
        if (module.exports && typeof DO_NOT_EXPORT_CODEPAGE === 'undefined') module.exports = factory(cpt);
        else root.cptable = factory(cpt);
    } else $e1f740a9d01acc72$var$cptable = factory($e1f740a9d01acc72$var$cptable);
/*eslint-enable */ /*jshint ignore:end */ })(module.exports, function(cpt) {
    "use strict";
    /*global module, Buffer */ var magic = {
        "1200": "utf16le",
        "1201": "utf16be",
        "12000": "utf32le",
        "12001": "utf32be",
        "16969": "utf64le",
        "20127": "ascii",
        "65000": "utf7",
        "65001": "utf8"
    };
    var sbcs_cache = [
        874,
        1250,
        1251,
        1252,
        1253,
        1254,
        1255,
        1256,
        10000
    ];
    var dbcs_cache = [
        932,
        936,
        949,
        950
    ];
    var magic_cache = [
        65001
    ];
    var magic_decode = {};
    var magic_encode = {};
    var cpdcache = {};
    var cpecache = {};
    var sfcc = function sfcc(x) {
        return String.fromCharCode(x);
    };
    var cca = function cca(x) {
        return x.charCodeAt(0);
    };
    var has_buf = typeof $e1f740a9d01acc72$require$Buffer !== 'undefined';
    var Buffer_from = function() {};
    if (has_buf) {
        var nbfs = !$e1f740a9d01acc72$require$Buffer.from;
        if (!nbfs) try {
            $e1f740a9d01acc72$require$Buffer.from("foo", "utf8");
        } catch (e) {
            nbfs = true;
        }
        Buffer_from = nbfs ? function(buf, enc) {
            return enc ? new $e1f740a9d01acc72$require$Buffer(buf, enc) : new $e1f740a9d01acc72$require$Buffer(buf);
        } : $e1f740a9d01acc72$require$Buffer.from.bind($e1f740a9d01acc72$require$Buffer);
        // $FlowIgnore
        if (!$e1f740a9d01acc72$require$Buffer.allocUnsafe) $e1f740a9d01acc72$require$Buffer.allocUnsafe = function(n) {
            return new $e1f740a9d01acc72$require$Buffer(n);
        };
        var mdl = 1024, mdb = $e1f740a9d01acc72$require$Buffer.allocUnsafe(mdl);
        var make_EE = function make_EE(E) {
            var EE = $e1f740a9d01acc72$require$Buffer.allocUnsafe(65536);
            for(var i = 0; i < 65536; ++i)EE[i] = 0;
            var keys = Object.keys(E), len = keys.length;
            for(var ee = 0, e = keys[ee]; ee < len; ++ee){
                if (!(e = keys[ee])) continue;
                EE[e.charCodeAt(0)] = E[e];
            }
            return EE;
        };
        var sbcs_encode = function make_sbcs_encode(cp) {
            var EE = make_EE(cpt[cp].enc);
            return function sbcs_e(data, ofmt) {
                var len = data.length;
                var out, i = 0, j = 0, D = 0, w = 0;
                if (typeof data === 'string') {
                    out = $e1f740a9d01acc72$require$Buffer.allocUnsafe(len);
                    for(i = 0; i < len; ++i)out[i] = EE[data.charCodeAt(i)];
                } else if ($e1f740a9d01acc72$require$Buffer.isBuffer(data)) {
                    out = $e1f740a9d01acc72$require$Buffer.allocUnsafe(2 * len);
                    j = 0;
                    for(i = 0; i < len; ++i){
                        D = data[i];
                        if (D < 128) out[j++] = EE[D];
                        else if (D < 224) {
                            out[j++] = EE[((D & 31) << 6) + (data[i + 1] & 63)];
                            ++i;
                        } else if (D < 240) {
                            out[j++] = EE[((D & 15) << 12) + ((data[i + 1] & 63) << 6) + (data[i + 2] & 63)];
                            i += 2;
                        } else {
                            w = ((D & 7) << 18) + ((data[i + 1] & 63) << 12) + ((data[i + 2] & 63) << 6) + (data[i + 3] & 63);
                            i += 3;
                            if (w < 65536) out[j++] = EE[w];
                            else {
                                w -= 65536;
                                out[j++] = EE[0xD800 + (w >> 10 & 1023)];
                                out[j++] = EE[0xDC00 + (w & 1023)];
                            }
                        }
                    }
                    out = out.slice(0, j);
                } else {
                    out = $e1f740a9d01acc72$require$Buffer.allocUnsafe(len);
                    for(i = 0; i < len; ++i)out[i] = EE[data[i].charCodeAt(0)];
                }
                if (!ofmt || ofmt === 'buf') return out;
                if (ofmt !== 'arr') return out.toString('binary');
                return [].slice.call(out);
            };
        };
        var sbcs_decode = function make_sbcs_decode(cp) {
            var D = cpt[cp].dec;
            var DD = $e1f740a9d01acc72$require$Buffer.allocUnsafe(131072), d = 0, c = "";
            for(d = 0; d < D.length; ++d){
                if (!(c = D[d])) continue;
                var w = c.charCodeAt(0);
                DD[2 * d] = w & 255;
                DD[2 * d + 1] = w >> 8;
            }
            return function sbcs_d(data) {
                var len = data.length, i = 0, j = 0;
                if (2 * len > mdl) {
                    mdl = 2 * len;
                    mdb = $e1f740a9d01acc72$require$Buffer.allocUnsafe(mdl);
                }
                if ($e1f740a9d01acc72$require$Buffer.isBuffer(data)) for(i = 0; i < len; i++){
                    j = 2 * data[i];
                    mdb[2 * i] = DD[j];
                    mdb[2 * i + 1] = DD[j + 1];
                }
                else if (typeof data === "string") for(i = 0; i < len; i++){
                    j = 2 * data.charCodeAt(i);
                    mdb[2 * i] = DD[j];
                    mdb[2 * i + 1] = DD[j + 1];
                }
                else for(i = 0; i < len; i++){
                    j = 2 * data[i];
                    mdb[2 * i] = DD[j];
                    mdb[2 * i + 1] = DD[j + 1];
                }
                return mdb.slice(0, 2 * len).toString('ucs2');
            };
        };
        var dbcs_encode = function make_dbcs_encode(cp) {
            var E = cpt[cp].enc;
            var EE = $e1f740a9d01acc72$require$Buffer.allocUnsafe(131072);
            for(var i = 0; i < 131072; ++i)EE[i] = 0;
            var keys = Object.keys(E);
            for(var ee = 0, e = keys[ee]; ee < keys.length; ++ee){
                if (!(e = keys[ee])) continue;
                var f = e.charCodeAt(0);
                EE[2 * f] = E[e] & 255;
                EE[2 * f + 1] = E[e] >> 8;
            }
            return function dbcs_e(data, ofmt) {
                var len = data.length, out = $e1f740a9d01acc72$require$Buffer.allocUnsafe(2 * len), i = 0, j = 0, jj = 0, k = 0, D = 0;
                if (typeof data === 'string') {
                    for(i = k = 0; i < len; ++i){
                        j = data.charCodeAt(i) * 2;
                        out[k++] = EE[j + 1] || EE[j];
                        if (EE[j + 1] > 0) out[k++] = EE[j];
                    }
                    out = out.slice(0, k);
                } else if ($e1f740a9d01acc72$require$Buffer.isBuffer(data)) {
                    for(i = k = 0; i < len; ++i){
                        D = data[i];
                        if (D < 128) j = D;
                        else if (D < 224) {
                            j = ((D & 31) << 6) + (data[i + 1] & 63);
                            ++i;
                        } else if (D < 240) {
                            j = ((D & 15) << 12) + ((data[i + 1] & 63) << 6) + (data[i + 2] & 63);
                            i += 2;
                        } else {
                            j = ((D & 7) << 18) + ((data[i + 1] & 63) << 12) + ((data[i + 2] & 63) << 6) + (data[i + 3] & 63);
                            i += 3;
                        }
                        if (j < 65536) {
                            j *= 2;
                            out[k++] = EE[j + 1] || EE[j];
                            if (EE[j + 1] > 0) out[k++] = EE[j];
                        } else {
                            jj = j - 65536;
                            j = 2 * (0xD800 + (jj >> 10 & 1023));
                            out[k++] = EE[j + 1] || EE[j];
                            if (EE[j + 1] > 0) out[k++] = EE[j];
                            j = 2 * (0xDC00 + (jj & 1023));
                            out[k++] = EE[j + 1] || EE[j];
                            if (EE[j + 1] > 0) out[k++] = EE[j];
                        }
                    }
                    out = out.slice(0, k);
                } else for(i = k = 0; i < len; i++){
                    j = data[i].charCodeAt(0) * 2;
                    out[k++] = EE[j + 1] || EE[j];
                    if (EE[j + 1] > 0) out[k++] = EE[j];
                }
                if (!ofmt || ofmt === 'buf') return out;
                if (ofmt !== 'arr') return out.toString('binary');
                return [].slice.call(out);
            };
        };
        var dbcs_decode = function make_dbcs_decode(cp) {
            var D = cpt[cp].dec;
            var DD = $e1f740a9d01acc72$require$Buffer.allocUnsafe(131072), d = 0, c, w = 0, j = 0, i = 0;
            for(i = 0; i < 65536; ++i){
                DD[2 * i] = 0xFF;
                DD[2 * i + 1] = 0xFD;
            }
            for(d = 0; d < D.length; ++d){
                if (!(c = D[d])) continue;
                w = c.charCodeAt(0);
                j = 2 * d;
                DD[j] = w & 255;
                DD[j + 1] = w >> 8;
            }
            return function dbcs_d(data) {
                var len = data.length, out = $e1f740a9d01acc72$require$Buffer.allocUnsafe(2 * len), i = 0, j = 0, k = 0;
                if ($e1f740a9d01acc72$require$Buffer.isBuffer(data)) for(i = 0; i < len; i++){
                    j = 2 * data[i];
                    if (DD[j] === 0xFF && DD[j + 1] === 0xFD) {
                        j = 2 * ((data[i] << 8) + data[i + 1]);
                        ++i;
                    }
                    out[k++] = DD[j];
                    out[k++] = DD[j + 1];
                }
                else if (typeof data === "string") for(i = 0; i < len; i++){
                    j = 2 * data.charCodeAt(i);
                    if (DD[j] === 0xFF && DD[j + 1] === 0xFD) {
                        j = 2 * ((data.charCodeAt(i) << 8) + data.charCodeAt(i + 1));
                        ++i;
                    }
                    out[k++] = DD[j];
                    out[k++] = DD[j + 1];
                }
                else for(i = 0; i < len; i++){
                    j = 2 * data[i];
                    if (DD[j] === 0xFF && DD[j + 1] === 0xFD) {
                        j = 2 * ((data[i] << 8) + data[i + 1]);
                        ++i;
                    }
                    out[k++] = DD[j];
                    out[k++] = DD[j + 1];
                }
                return out.slice(0, k).toString('ucs2');
            };
        };
        magic_decode[65001] = function utf8_d(data) {
            if (typeof data === "string") return utf8_d(data.split("").map(cca));
            var len = data.length, w = 0, ww = 0;
            if (4 * len > mdl) {
                mdl = 4 * len;
                mdb = $e1f740a9d01acc72$require$Buffer.allocUnsafe(mdl);
            }
            var i = 0;
            if (len >= 3 && data[0] == 0xEF) {
                if (data[1] == 0xBB && data[2] == 0xBF) i = 3;
            }
            for(var j = 1, k = 0, D = 0; i < len; i += j){
                j = 1;
                D = data[i];
                if (D < 128) w = D;
                else if (D < 224) {
                    w = (D & 31) * 64 + (data[i + 1] & 63);
                    j = 2;
                } else if (D < 240) {
                    w = ((D & 15) << 12) + (data[i + 1] & 63) * 64 + (data[i + 2] & 63);
                    j = 3;
                } else {
                    w = (D & 7) * 262144 + ((data[i + 1] & 63) << 12) + (data[i + 2] & 63) * 64 + (data[i + 3] & 63);
                    j = 4;
                }
                if (w < 65536) {
                    mdb[k++] = w & 255;
                    mdb[k++] = w >> 8;
                } else {
                    w -= 65536;
                    ww = 0xD800 + (w >> 10 & 1023);
                    w = 0xDC00 + (w & 1023);
                    mdb[k++] = ww & 255;
                    mdb[k++] = ww >>> 8;
                    mdb[k++] = w & 255;
                    mdb[k++] = w >>> 8 & 255;
                }
            }
            return mdb.slice(0, k).toString('ucs2');
        };
        magic_encode[65001] = function utf8_e(data, ofmt) {
            if (has_buf && $e1f740a9d01acc72$require$Buffer.isBuffer(data)) {
                if (!ofmt || ofmt === 'buf') return data;
                if (ofmt !== 'arr') return data.toString('binary');
                return [].slice.call(data);
            }
            var len = data.length, w = 0, ww = 0, j = 0;
            var direct = typeof data === "string";
            if (4 * len > mdl) {
                mdl = 4 * len;
                mdb = $e1f740a9d01acc72$require$Buffer.allocUnsafe(mdl);
            }
            for(var i = 0; i < len; ++i){
                w = direct ? data.charCodeAt(i) : data[i].charCodeAt(0);
                if (w <= 0x007F) mdb[j++] = w;
                else if (w <= 0x07FF) {
                    mdb[j++] = 192 + (w >> 6);
                    mdb[j++] = 128 + (w & 63);
                } else if (w >= 0xD800 && w <= 0xDFFF) {
                    w -= 0xD800;
                    ++i;
                    ww = (direct ? data.charCodeAt(i) : data[i].charCodeAt(0)) - 0xDC00 + (w << 10);
                    mdb[j++] = 240 + (ww >>> 18 & 0x07);
                    mdb[j++] = 144 + (ww >>> 12 & 0x3F);
                    mdb[j++] = 128 + (ww >>> 6 & 0x3F);
                    mdb[j++] = 128 + (ww & 0x3F);
                } else {
                    mdb[j++] = 224 + (w >> 12);
                    mdb[j++] = 128 + (w >> 6 & 63);
                    mdb[j++] = 128 + (w & 63);
                }
            }
            if (!ofmt || ofmt === 'buf') return mdb.slice(0, j);
            if (ofmt !== 'arr') return mdb.slice(0, j).toString('binary');
            return [].slice.call(mdb, 0, j);
        };
    }
    var encache = function encache() {
        if (has_buf) {
            if (cpdcache[sbcs_cache[0]]) return;
            var i = 0, s = 0;
            for(i = 0; i < sbcs_cache.length; ++i){
                s = sbcs_cache[i];
                if (cpt[s]) {
                    cpdcache[s] = sbcs_decode(s);
                    cpecache[s] = sbcs_encode(s);
                }
            }
            for(i = 0; i < dbcs_cache.length; ++i){
                s = dbcs_cache[i];
                if (cpt[s]) {
                    cpdcache[s] = dbcs_decode(s);
                    cpecache[s] = dbcs_encode(s);
                }
            }
            for(i = 0; i < magic_cache.length; ++i){
                s = magic_cache[i];
                if (magic_decode[s]) cpdcache[s] = magic_decode[s];
                if (magic_encode[s]) cpecache[s] = magic_encode[s];
            }
        }
    };
    var null_enc = function(data, ofmt) {
        return "";
    };
    var cp_decache = function cp_decache(cp) {
        delete cpdcache[cp];
        delete cpecache[cp];
    };
    var decache = function decache() {
        if (has_buf) {
            if (!cpdcache[sbcs_cache[0]]) return;
            sbcs_cache.forEach(cp_decache);
            dbcs_cache.forEach(cp_decache);
            magic_cache.forEach(cp_decache);
        }
        last_enc = null_enc;
        last_cp = 0;
    };
    var cache = {
        encache: encache,
        decache: decache,
        sbcs: sbcs_cache,
        dbcs: dbcs_cache
    };
    encache();
    var BM = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    var SetD = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'(),-./:?";
    var last_enc = null_enc, last_cp = 0;
    var encode = function encode(cp, data, ofmt) {
        if (cp === last_cp && last_enc) return last_enc(data, ofmt);
        if (cpecache[cp]) {
            last_enc = cpecache[last_cp = cp];
            return last_enc(data, ofmt);
        }
        if (has_buf && $e1f740a9d01acc72$require$Buffer.isBuffer(data)) data = data.toString('utf8');
        var len = data.length;
        var out = has_buf ? $e1f740a9d01acc72$require$Buffer.allocUnsafe(4 * len) : [], w = 0, i = 0, j = 0, ww = 0;
        var C = cpt[cp], E, M = "";
        var isstr = typeof data === 'string';
        if (C && (E = C.enc)) for(i = 0; i < len; ++i, ++j){
            w = E[isstr ? data.charAt(i) : data[i]];
            if (w > 255) {
                out[j] = w >> 8;
                out[++j] = w & 255;
            } else out[j] = w & 255;
        }
        else if (M = magic[cp]) switch(M){
            case "utf8":
                if (has_buf && isstr) {
                    out = Buffer_from(data, M);
                    j = out.length;
                    break;
                }
                for(i = 0; i < len; ++i, ++j){
                    w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
                    if (w <= 0x007F) out[j] = w;
                    else if (w <= 0x07FF) {
                        out[j] = 192 + (w >> 6);
                        out[++j] = 128 + (w & 63);
                    } else if (w >= 0xD800 && w <= 0xDFFF) {
                        w -= 0xD800;
                        ww = (isstr ? data.charCodeAt(++i) : data[++i].charCodeAt(0)) - 0xDC00 + (w << 10);
                        out[j] = 240 + (ww >>> 18 & 0x07);
                        out[++j] = 144 + (ww >>> 12 & 0x3F);
                        out[++j] = 128 + (ww >>> 6 & 0x3F);
                        out[++j] = 128 + (ww & 0x3F);
                    } else {
                        out[j] = 224 + (w >> 12);
                        out[++j] = 128 + (w >> 6 & 63);
                        out[++j] = 128 + (w & 63);
                    }
                }
                break;
            case "ascii":
                if (has_buf && typeof data === "string") {
                    out = Buffer_from(data, M);
                    j = out.length;
                    break;
                }
                for(i = 0; i < len; ++i, ++j){
                    w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
                    if (w <= 0x007F) out[j] = w;
                    else throw new Error("bad ascii " + w);
                }
                break;
            case "utf16le":
                if (has_buf && typeof data === "string") {
                    out = Buffer_from(data, M);
                    j = out.length;
                    break;
                }
                for(i = 0; i < len; ++i){
                    w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
                    out[j++] = w & 255;
                    out[j++] = w >> 8;
                }
                break;
            case "utf16be":
                for(i = 0; i < len; ++i){
                    w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
                    out[j++] = w >> 8;
                    out[j++] = w & 255;
                }
                break;
            case "utf32le":
                for(i = 0; i < len; ++i){
                    w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
                    if (w >= 0xD800 && w <= 0xDFFF) w = 0x10000 + (w - 0xD800 << 10) + (data[++i].charCodeAt(0) - 0xDC00);
                    out[j++] = w & 255;
                    w >>= 8;
                    out[j++] = w & 255;
                    w >>= 8;
                    out[j++] = w & 255;
                    w >>= 8;
                    out[j++] = w & 255;
                }
                break;
            case "utf32be":
                for(i = 0; i < len; ++i){
                    w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
                    if (w >= 0xD800 && w <= 0xDFFF) w = 0x10000 + (w - 0xD800 << 10) + (data[++i].charCodeAt(0) - 0xDC00);
                    out[j + 3] = w & 255;
                    w >>= 8;
                    out[j + 2] = w & 255;
                    w >>= 8;
                    out[j + 1] = w & 255;
                    w >>= 8;
                    out[j] = w & 255;
                    j += 4;
                }
                break;
            case "utf7":
                for(i = 0; i < len; i++){
                    var c = isstr ? data.charAt(i) : data[i].charAt(0);
                    if (c === "+") {
                        out[j++] = 0x2b;
                        out[j++] = 0x2d;
                        continue;
                    }
                    if (SetD.indexOf(c) > -1) {
                        out[j++] = c.charCodeAt(0);
                        continue;
                    }
                    var tt = encode(1201, c);
                    out[j++] = 0x2b;
                    out[j++] = BM.charCodeAt(tt[0] >> 2);
                    out[j++] = BM.charCodeAt(((tt[0] & 0x03) << 4) + ((tt[1] || 0) >> 4));
                    out[j++] = BM.charCodeAt(((tt[1] & 0x0F) << 2) + ((tt[2] || 0) >> 6));
                    out[j++] = 0x2d;
                }
                break;
            default:
                throw new Error("Unsupported magic: " + cp + " " + magic[cp]);
        }
        else throw new Error("Unrecognized CP: " + cp);
        out = out.slice(0, j);
        if (!has_buf) return ofmt == 'str' ? out.map(sfcc).join("") : out;
        if (!ofmt || ofmt === 'buf') return out;
        if (ofmt !== 'arr') return out.toString('binary');
        return [].slice.call(out);
    };
    var decode = function decode(cp, data) {
        var F;
        if (F = cpdcache[cp]) return F(data);
        if (typeof data === "string") return decode(cp, data.split("").map(cca));
        var len = data.length, out = new Array(len), s = "", w = 0, i = 0, j = 1, k = 0, ww = 0;
        var C = cpt[cp], D, M = "";
        if (C && (D = C.dec)) for(i = 0; i < len; i += j){
            j = 2;
            s = D[(data[i] << 8) + data[i + 1]];
            if (!s) {
                j = 1;
                s = D[data[i]];
            }
            if (!s) throw new Error('Unrecognized code: ' + data[i] + ' ' + data[i + j - 1] + ' ' + i + ' ' + j + ' ' + D[data[i]]);
            out[k++] = s;
        }
        else if (M = magic[cp]) switch(M){
            case "utf8":
                if (len >= 3 && data[0] == 0xEF) {
                    if (data[1] == 0xBB && data[2] == 0xBF) i = 3;
                }
                for(; i < len; i += j){
                    j = 1;
                    if (data[i] < 128) w = data[i];
                    else if (data[i] < 224) {
                        w = (data[i] & 31) * 64 + (data[i + 1] & 63);
                        j = 2;
                    } else if (data[i] < 240) {
                        w = ((data[i] & 15) << 12) + (data[i + 1] & 63) * 64 + (data[i + 2] & 63);
                        j = 3;
                    } else {
                        w = (data[i] & 7) * 262144 + ((data[i + 1] & 63) << 12) + (data[i + 2] & 63) * 64 + (data[i + 3] & 63);
                        j = 4;
                    }
                    if (w < 65536) out[k++] = String.fromCharCode(w);
                    else {
                        w -= 65536;
                        ww = 0xD800 + (w >> 10 & 1023);
                        w = 0xDC00 + (w & 1023);
                        out[k++] = String.fromCharCode(ww);
                        out[k++] = String.fromCharCode(w);
                    }
                }
                break;
            case "ascii":
                if (has_buf && $e1f740a9d01acc72$require$Buffer.isBuffer(data)) return data.toString(M);
                for(i = 0; i < len; i++)out[i] = String.fromCharCode(data[i]);
                k = len;
                break;
            case "utf16le":
                if (len >= 2 && data[0] == 0xFF) {
                    if (data[1] == 0xFE) i = 2;
                }
                if (has_buf && $e1f740a9d01acc72$require$Buffer.isBuffer(data)) return data.toString(M);
                j = 2;
                for(; i + 1 < len; i += j)out[k++] = String.fromCharCode((data[i + 1] << 8) + data[i]);
                break;
            case "utf16be":
                if (len >= 2 && data[0] == 0xFE) {
                    if (data[1] == 0xFF) i = 2;
                }
                j = 2;
                for(; i + 1 < len; i += j)out[k++] = String.fromCharCode((data[i] << 8) + data[i + 1]);
                break;
            case "utf32le":
                if (len >= 4 && data[0] == 0xFF) {
                    if (data[1] == 0xFE && data[2] === 0 && data[3] === 0) i = 4;
                }
                j = 4;
                for(; i < len; i += j){
                    w = (data[i + 3] << 24) + (data[i + 2] << 16) + (data[i + 1] << 8) + data[i];
                    if (w > 0xFFFF) {
                        w -= 0x10000;
                        out[k++] = String.fromCharCode(0xD800 + (w >> 10 & 0x3FF));
                        out[k++] = String.fromCharCode(0xDC00 + (w & 0x3FF));
                    } else out[k++] = String.fromCharCode(w);
                }
                break;
            case "utf32be":
                if (len >= 4 && data[3] == 0xFF) {
                    if (data[2] == 0xFE && data[1] === 0 && data[0] === 0) i = 4;
                }
                j = 4;
                for(; i < len; i += j){
                    w = (data[i] << 24) + (data[i + 1] << 16) + (data[i + 2] << 8) + data[i + 3];
                    if (w > 0xFFFF) {
                        w -= 0x10000;
                        out[k++] = String.fromCharCode(0xD800 + (w >> 10 & 0x3FF));
                        out[k++] = String.fromCharCode(0xDC00 + (w & 0x3FF));
                    } else out[k++] = String.fromCharCode(w);
                }
                break;
            case "utf7":
                if (len >= 4 && data[0] == 0x2B && data[1] == 0x2F && data[2] == 0x76) {
                    if (len >= 5 && data[3] == 0x38 && data[4] == 0x2D) i = 5;
                    else if (data[3] == 0x38 || data[3] == 0x39 || data[3] == 0x2B || data[3] == 0x2F) i = 4;
                }
                for(; i < len; i += j){
                    if (data[i] !== 0x2b) {
                        j = 1;
                        out[k++] = String.fromCharCode(data[i]);
                        continue;
                    }
                    j = 1;
                    if (data[i + 1] === 0x2d) {
                        j = 2;
                        out[k++] = "+";
                        continue;
                    }
                    // eslint-disable-next-line no-useless-escape
                    while(String.fromCharCode(data[i + j]).match(/[A-Za-z0-9+\/]/))j++;
                    var dash = 0;
                    if (data[i + j] === 0x2d) {
                        ++j;
                        dash = 1;
                    }
                    var tt = [];
                    var o64 = "";
                    var c1 = 0, c2 = 0, c3 = 0;
                    var e1 = 0, e2 = 0, e3 = 0, e4 = 0;
                    for(var l = 1; l < j - dash;){
                        e1 = BM.indexOf(String.fromCharCode(data[i + l++]));
                        e2 = BM.indexOf(String.fromCharCode(data[i + l++]));
                        c1 = e1 << 2 | e2 >> 4;
                        tt.push(c1);
                        e3 = BM.indexOf(String.fromCharCode(data[i + l++]));
                        if (e3 === -1) break;
                        c2 = (e2 & 15) << 4 | e3 >> 2;
                        tt.push(c2);
                        e4 = BM.indexOf(String.fromCharCode(data[i + l++]));
                        if (e4 === -1) break;
                        c3 = (e3 & 3) << 6 | e4;
                        if (e4 < 64) tt.push(c3);
                    }
                    o64 = decode(1201, tt);
                    for(l = 0; l < o64.length; ++l)out[k++] = o64.charAt(l);
                }
                break;
            default:
                throw new Error("Unsupported magic: " + cp + " " + magic[cp]);
        }
        else throw new Error("Unrecognized CP: " + cp);
        return out.slice(0, k).join("");
    };
    var hascp = function hascp(cp) {
        return !!(cpt[cp] || magic[cp]);
    };
    cpt.utils = {
        decode: decode,
        encode: encode,
        hascp: hascp,
        magic: magic,
        cache: cache
    };
    return cpt;
});

});

parcelRegister("7Asxf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $586207b015d42b2f$export$1e511d4a378977f5, (v) => $586207b015d42b2f$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $586207b015d42b2f$export$2e2bcd8739ae039, (v) => $586207b015d42b2f$export$2e2bcd8739ae039 = v);
var $586207b015d42b2f$export$1e511d4a378977f5;
var $586207b015d42b2f$export$2e2bcd8739ae039;
"use strict";
$586207b015d42b2f$export$1e511d4a378977f5 = true;
$586207b015d42b2f$export$2e2bcd8739ae039 = $586207b015d42b2f$var$createWebStorage;

var $586207b015d42b2f$var$_getStorage = $586207b015d42b2f$var$_interopRequireDefault((parcelRequire("kagwK")));
function $586207b015d42b2f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $586207b015d42b2f$var$createWebStorage(type) {
    var storage = (0, $586207b015d42b2f$var$_getStorage.default)(type);
    return {
        getItem: function getItem(key) {
            return new Promise(function(resolve, reject) {
                resolve(storage.getItem(key));
            });
        },
        setItem: function setItem(key, item) {
            return new Promise(function(resolve, reject) {
                resolve(storage.setItem(key, item));
            });
        },
        removeItem: function removeItem(key) {
            return new Promise(function(resolve, reject) {
                resolve(storage.removeItem(key));
            });
        }
    };
}

});
parcelRegister("kagwK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $eae18fc1294d0f44$export$1e511d4a378977f5, (v) => $eae18fc1294d0f44$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $eae18fc1294d0f44$export$2e2bcd8739ae039, (v) => $eae18fc1294d0f44$export$2e2bcd8739ae039 = v);
var $eae18fc1294d0f44$export$1e511d4a378977f5;
var $eae18fc1294d0f44$export$2e2bcd8739ae039;
"use strict";
$eae18fc1294d0f44$export$1e511d4a378977f5 = true;
$eae18fc1294d0f44$export$2e2bcd8739ae039 = $eae18fc1294d0f44$var$getStorage;
function $eae18fc1294d0f44$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $eae18fc1294d0f44$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $eae18fc1294d0f44$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $eae18fc1294d0f44$var$_typeof(obj);
}
function $eae18fc1294d0f44$var$noop() {}
var $eae18fc1294d0f44$var$noopStorage = {
    getItem: $eae18fc1294d0f44$var$noop,
    setItem: $eae18fc1294d0f44$var$noop,
    removeItem: $eae18fc1294d0f44$var$noop
};
function $eae18fc1294d0f44$var$hasStorage(storageType) {
    if ((typeof self === "undefined" ? "undefined" : $eae18fc1294d0f44$var$_typeof(self)) !== 'object' || !(storageType in self)) return false;
    try {
        var storage = self[storageType];
        var testKey = "redux-persist ".concat(storageType, " test");
        storage.setItem(testKey, 'test');
        storage.getItem(testKey);
        storage.removeItem(testKey);
    } catch (e) {
        return false;
    }
    return true;
}
function $eae18fc1294d0f44$var$getStorage(type) {
    var storageType = "".concat(type, "Storage");
    if ($eae18fc1294d0f44$var$hasStorage(storageType)) return self[storageType];
    else return $eae18fc1294d0f44$var$noopStorage;
}

});


var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("1b2ls"));


parcelRequire("acw62");
var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
'use strict';
var $11492dca620dcaa5$exports = {};
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

$11492dca620dcaa5$exports = (parcelRequire("Xw6Mv"));


var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $11492dca620dcaa5$exports.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $11492dca620dcaa5$exports.hydrateRoot;


/**
 * React Router DOM v6.30.6
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

/**
 * @remix-run/router v1.23.4
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $1d34d5c4a288b213$var$_extends() {
    return $1d34d5c4a288b213$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1d34d5c4a288b213$var$_extends.apply(null, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $1d34d5c4a288b213$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($1d34d5c4a288b213$export$e19cd5f9376f8cee || ($1d34d5c4a288b213$export$e19cd5f9376f8cee = {}));
const $1d34d5c4a288b213$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $1d34d5c4a288b213$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $1d34d5c4a288b213$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $1d34d5c4a288b213$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $1d34d5c4a288b213$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $1d34d5c4a288b213$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $1d34d5c4a288b213$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $1d34d5c4a288b213$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $1d34d5c4a288b213$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $1d34d5c4a288b213$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $1d34d5c4a288b213$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $1d34d5c4a288b213$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $1d34d5c4a288b213$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $1d34d5c4a288b213$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($1d34d5c4a288b213$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $1d34d5c4a288b213$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $1d34d5c4a288b213$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($1d34d5c4a288b213$var$ResultType || ($1d34d5c4a288b213$var$ResultType = {}));
const $1d34d5c4a288b213$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $1d34d5c4a288b213$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $1d34d5c4a288b213$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $1d34d5c4a288b213$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($1d34d5c4a288b213$var$isIndexRoute(route)) {
            let indexRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $1d34d5c4a288b213$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $1d34d5c4a288b213$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $1d34d5c4a288b213$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $1d34d5c4a288b213$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $1d34d5c4a288b213$var$flattenRoutes(routes);
    $1d34d5c4a288b213$var$rankRouteBranches(branches);
    let matches = null;
    let decoded = $1d34d5c4a288b213$export$30d21fd6d7295f52(pathname);
    for(let i = 0; matches == null && i < branches.length; ++i)// Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    matches = $1d34d5c4a288b213$var$matchRouteBranch(branches[i], decoded, allowPartial);
    return matches;
}
function $1d34d5c4a288b213$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $1d34d5c4a288b213$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $1d34d5c4a288b213$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $1d34d5c4a288b213$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $1d34d5c4a288b213$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $1d34d5c4a288b213$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $1d34d5c4a288b213$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $1d34d5c4a288b213$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $1d34d5c4a288b213$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $1d34d5c4a288b213$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $1d34d5c4a288b213$var$paramRe = /^:[\w-]+$/;
const $1d34d5c4a288b213$var$dynamicSegmentValue = 3;
const $1d34d5c4a288b213$var$indexRouteValue = 2;
const $1d34d5c4a288b213$var$emptySegmentValue = 1;
const $1d34d5c4a288b213$var$staticSegmentValue = 10;
const $1d34d5c4a288b213$var$splatPenalty = -2;
const $1d34d5c4a288b213$var$isSplat = (s)=>s === "*";
function $1d34d5c4a288b213$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($1d34d5c4a288b213$var$isSplat)) initialScore += $1d34d5c4a288b213$var$splatPenalty;
    if (index) initialScore += $1d34d5c4a288b213$var$indexRouteValue;
    return segments.filter((s)=>!$1d34d5c4a288b213$var$isSplat(s)).reduce((score, segment)=>score + ($1d34d5c4a288b213$var$paramRe.test(segment) ? $1d34d5c4a288b213$var$dynamicSegmentValue : segment === "" ? $1d34d5c4a288b213$var$emptySegmentValue : $1d34d5c4a288b213$var$staticSegmentValue), initialScore);
}
function $1d34d5c4a288b213$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $1d34d5c4a288b213$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $1d34d5c4a288b213$export$a5c6d149b50c1d86($1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $1d34d5c4a288b213$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $1d34d5c4a288b213$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $1d34d5c4a288b213$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $1d34d5c4a288b213$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $1d34d5c4a288b213$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $1d34d5c4a288b213$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $1d34d5c4a288b213$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $1d34d5c4a288b213$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        toPathname = $1d34d5c4a288b213$var$removeDoubleSlashes(toPathname);
        if (toPathname.startsWith("/")) pathname = $1d34d5c4a288b213$var$resolvePathname(toPathname.substring(1), "/");
        else pathname = $1d34d5c4a288b213$var$resolvePathname(toPathname, fromPathname);
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $1d34d5c4a288b213$var$normalizeSearch(search),
        hash: $1d34d5c4a288b213$var$normalizeHash(hash)
    };
}
function $1d34d5c4a288b213$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $1d34d5c4a288b213$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $1d34d5c4a288b213$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $1d34d5c4a288b213$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $1d34d5c4a288b213$export$8ccf933b0513f8d0(toArg);
    else {
        to = $1d34d5c4a288b213$var$_extends({}, toArg);
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $1d34d5c4a288b213$var$getInvalidPathError("?", "pathname", "search", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "pathname", "hash", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
const $1d34d5c4a288b213$var$removeDoubleSlashes = (path)=>path.replace(/\/\/+/g, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$export$86d9a7913e44197e = (paths)=>$1d34d5c4a288b213$var$removeDoubleSlashes(paths.join("/"));
/**
 * @private
 */ const $1d34d5c4a288b213$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $1d34d5c4a288b213$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $1d34d5c4a288b213$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $1d34d5c4a288b213$export$4051a07651545597(data, init) {
    return new $1d34d5c4a288b213$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $1d34d5c4a288b213$export$42a99a7a4bc0e76a extends Error {
}
class $1d34d5c4a288b213$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $1d34d5c4a288b213$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $1d34d5c4a288b213$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $1d34d5c4a288b213$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $1d34d5c4a288b213$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $1d34d5c4a288b213$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $1d34d5c4a288b213$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $1d34d5c4a288b213$var$unwrapTrackedPromise(value) {
    if (!$1d34d5c4a288b213$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $1d34d5c4a288b213$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $1d34d5c4a288b213$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $1d34d5c4a288b213$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $1d34d5c4a288b213$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $1d34d5c4a288b213$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $1d34d5c4a288b213$var$validMutationMethods = new Set($1d34d5c4a288b213$var$validMutationMethodsArr);
const $1d34d5c4a288b213$var$validRequestMethodsArr = [
    "get",
    ...$1d34d5c4a288b213$var$validMutationMethodsArr
];
const $1d34d5c4a288b213$var$validRequestMethods = new Set($1d34d5c4a288b213$var$validRequestMethodsArr);
const $1d34d5c4a288b213$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $1d34d5c4a288b213$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $1d34d5c4a288b213$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $1d34d5c4a288b213$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $1d34d5c4a288b213$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$1d34d5c4a288b213$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$1d34d5c4a288b213$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $1d34d5c4a288b213$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $1d34d5c4a288b213$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$1d34d5c4a288b213$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $1d34d5c4a288b213$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $1d34d5c4a288b213$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($1d34d5c4a288b213$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $1d34d5c4a288b213$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $1d34d5c4a288b213$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $1d34d5c4a288b213$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $1d34d5c4a288b213$var$findNearestBoundary(matches).route.id,
            {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($1d34d5c4a288b213$var$isErrorResult(result) && $1d34d5c4a288b213$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $1d34d5c4a288b213$var$_extends({
            matches: updatedMatches || matches
        }, $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $1d34d5c4a288b213$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $1d34d5c4a288b213$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $1d34d5c4a288b213$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $1d34d5c4a288b213$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $1d34d5c4a288b213$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $1d34d5c4a288b213$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($1d34d5c4a288b213$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $1d34d5c4a288b213$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $1d34d5c4a288b213$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $1d34d5c4a288b213$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $1d34d5c4a288b213$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $1d34d5c4a288b213$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $1d34d5c4a288b213$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $1d34d5c4a288b213$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult) || $1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(actionResult)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $1d34d5c4a288b213$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $1d34d5c4a288b213$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $1d34d5c4a288b213$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) result = await $1d34d5c4a288b213$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $1d34d5c4a288b213$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $1d34d5c4a288b213$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace : $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $1d34d5c4a288b213$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $1d34d5c4a288b213$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $1d34d5c4a288b213$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $1d34d5c4a288b213$var$ResultType.redirect,
                response: $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $1d34d5c4a288b213$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: $1d34d5c4a288b213$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $1d34d5c4a288b213$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $1d34d5c4a288b213$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $1d34d5c4a288b213$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $1d34d5c4a288b213$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $1d34d5c4a288b213$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $1d34d5c4a288b213$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$1d34d5c4a288b213$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $1d34d5c4a288b213$export$4d0306f8f6a4585b = Symbol("deferred");
function $1d34d5c4a288b213$export$3336b097a6fbc59a(routes, opts) {
    $1d34d5c4a288b213$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD") {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $1d34d5c4a288b213$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $1d34d5c4a288b213$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$1d34d5c4a288b213$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $1d34d5c4a288b213$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($1d34d5c4a288b213$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $1d34d5c4a288b213$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $1d34d5c4a288b213$var$isResponse(result) ? result : $1d34d5c4a288b213$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($1d34d5c4a288b213$var$isDataStrategyResult(e) && $1d34d5c4a288b213$var$isResponse(e.result)) {
                if (e.type === $1d34d5c4a288b213$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($1d34d5c4a288b213$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($1d34d5c4a288b213$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $1d34d5c4a288b213$var$_extends({}, context, {
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $1d34d5c4a288b213$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $1d34d5c4a288b213$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategy || $1d34d5c4a288b213$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($1d34d5c4a288b213$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $1d34d5c4a288b213$export$fec11da027c70692(routes, context, error) {
    let newContext = $1d34d5c4a288b213$var$_extends({}, context, {
        statusCode: $1d34d5c4a288b213$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $1d34d5c4a288b213$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $1d34d5c4a288b213$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $1d34d5c4a288b213$export$cae722b0cc860f13(to ? to : ".", $1d34d5c4a288b213$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $1d34d5c4a288b213$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $1d34d5c4a288b213$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $1d34d5c4a288b213$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $1d34d5c4a288b213$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$1d34d5c4a288b213$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$1d34d5c4a288b213$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $1d34d5c4a288b213$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $1d34d5c4a288b213$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $1d34d5c4a288b213$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $1d34d5c4a288b213$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $1d34d5c4a288b213$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $1d34d5c4a288b213$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $1d34d5c4a288b213$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($1d34d5c4a288b213$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $1d34d5c4a288b213$var$shouldRevalidateLoader(match, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $1d34d5c4a288b213$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $1d34d5c4a288b213$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $1d34d5c4a288b213$var$shouldRevalidateLoader(fetcherMatch, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $1d34d5c4a288b213$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $1d34d5c4a288b213$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $1d34d5c4a288b213$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $1d34d5c4a288b213$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$1d34d5c4a288b213$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $1d34d5c4a288b213$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$1d34d5c4a288b213$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $1d34d5c4a288b213$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $1d34d5c4a288b213$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $1d34d5c4a288b213$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$1d34d5c4a288b213$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $1d34d5c4a288b213$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $1d34d5c4a288b213$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $1d34d5c4a288b213$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $1d34d5c4a288b213$var$ResultType.data,
                result: undefined
            });
        };
        return $1d34d5c4a288b213$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $1d34d5c4a288b213$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $1d34d5c4a288b213$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($1d34d5c4a288b213$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: e
            };
        }
        if (type === $1d34d5c4a288b213$var$ResultType.error) return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: new $1d34d5c4a288b213$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $1d34d5c4a288b213$var$ResultType.error) {
        if ($1d34d5c4a288b213$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: new $1d34d5c4a288b213$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: result,
            statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($1d34d5c4a288b213$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $1d34d5c4a288b213$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($1d34d5c4a288b213$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $1d34d5c4a288b213$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $1d34d5c4a288b213$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    // Match Chrome's behavior:
    // https://github.com/chromium/chromium/blob/216dbeb61db0c667e62082e5f5400a32d6983df3/content/public/common/url_utils.cc#L82
    let invalidProtocols = [
        "about:",
        "blob:",
        "chrome:",
        "chrome-untrusted:",
        "content:",
        "data:",
        "devtools:",
        "file:",
        "filesystem:",
        // eslint-disable-next-line no-script-url
        "javascript:"
    ];
    if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return $1d34d5c4a288b213$var$removeDoubleSlashes(url.pathname) + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $1d34d5c4a288b213$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($1d34d5c4a288b213$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $1d34d5c4a288b213$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $1d34d5c4a288b213$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $1d34d5c4a288b213$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $1d34d5c4a288b213$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $1d34d5c4a288b213$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($1d34d5c4a288b213$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $1d34d5c4a288b213$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $1d34d5c4a288b213$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $1d34d5c4a288b213$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $1d34d5c4a288b213$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $1d34d5c4a288b213$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $1d34d5c4a288b213$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $1d34d5c4a288b213$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $1d34d5c4a288b213$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) : path;
    return $1d34d5c4a288b213$export$fe53371bee54353d($1d34d5c4a288b213$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $1d34d5c4a288b213$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $1d34d5c4a288b213$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $1d34d5c4a288b213$var$ResultType.data || result.type === $1d34d5c4a288b213$var$ResultType.error);
}
function $1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result) {
    return $1d34d5c4a288b213$var$isResponse(result.result) && $1d34d5c4a288b213$var$redirectStatusCodes.has(result.result.status);
}
function $1d34d5c4a288b213$var$isDeferredResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.deferred;
}
function $1d34d5c4a288b213$var$isErrorResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.error;
}
function $1d34d5c4a288b213$var$isRedirectResult(result) {
    return (result && result.type) === $1d34d5c4a288b213$var$ResultType.redirect;
}
function $1d34d5c4a288b213$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $1d34d5c4a288b213$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $1d34d5c4a288b213$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $1d34d5c4a288b213$var$isRedirectResponse(result) {
    if (!$1d34d5c4a288b213$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $1d34d5c4a288b213$var$isValidMethod(method) {
    return $1d34d5c4a288b213$var$validRequestMethods.has(method.toLowerCase());
}
function $1d34d5c4a288b213$var$isMutationMethod(method) {
    return $1d34d5c4a288b213$var$validMutationMethods.has(method.toLowerCase());
}
async function $1d34d5c4a288b213$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($1d34d5c4a288b213$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $1d34d5c4a288b213$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $1d34d5c4a288b213$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $1d34d5c4a288b213$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $1d34d5c4a288b213$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $1d34d5c4a288b213$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $1d34d5c4a288b213$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $1d34d5c4a288b213$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $1d34d5c4a288b213$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $1d34d5c4a288b213$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $1d34d5c4a288b213$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $1d34d5c4a288b213$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $1d34d5c4a288b213$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.30.6
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

function $7939e29d663dd3ed$var$_extends() {
    return $7939e29d663dd3ed$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7939e29d663dd3ed$var$_extends.apply(null, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $7939e29d663dd3ed$export$3add0d5dce533e2e = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$145dfa71566a64dc = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$var$AwaitContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $7939e29d663dd3ed$export$26749e8557646306 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$c7914228fb69b0f5 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$9072aa6dd1f93057 = /*#__PURE__*/ $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $7939e29d663dd3ed$var$RouteErrorContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $7939e29d663dd3ed$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $7939e29d663dd3ed$export$9c954a9d03d32f4a() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $7939e29d663dd3ed$export$45d76561a5302f2b() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $7939e29d663dd3ed$export$1b3f31771c5d07c() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $7939e29d663dd3ed$export$6c330e8992e8a295(pattern) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$81336c211d5ff295)(pattern, (0, $1d34d5c4a288b213$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $7939e29d663dd3ed$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $acw62.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $7939e29d663dd3ed$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $7939e29d663dd3ed$var$useNavigateStable() : $7939e29d663dd3ed$var$useNavigateUnstable();
}
function $7939e29d663dd3ed$var$useNavigateUnstable() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$OutletContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $7939e29d663dd3ed$export$4138103a3ae699cc() {
    return $acw62.useContext($7939e29d663dd3ed$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $7939e29d663dd3ed$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $7939e29d663dd3ed$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $7939e29d663dd3ed$export$5d3fca4a98652595(routes, locationArg) {
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: parentMatches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $1d34d5c4a288b213$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $7939e29d663dd3ed$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7939e29d663dd3ed$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7939e29d663dd3ed$var$DefaultErrorComponent() {
    let error = $7939e29d663dd3ed$export$ed527bf60f6e05f2();
    let message = (0, $1d34d5c4a288b213$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $7939e29d663dd3ed$var$defaultErrorElement = /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DefaultErrorComponent, null);
class $7939e29d663dd3ed$var$RenderErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $7939e29d663dd3ed$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7939e29d663dd3ed$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $7939e29d663dd3ed$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $7939e29d663dd3ed$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $7939e29d663dd3ed$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($7939e29d663dd3ed$var$DataRouterHook || {});
var $7939e29d663dd3ed$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($7939e29d663dd3ed$var$DataRouterStateHook || {});
function $7939e29d663dd3ed$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $7939e29d663dd3ed$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $7939e29d663dd3ed$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($7939e29d663dd3ed$export$145dfa71566a64dc);
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
function $7939e29d663dd3ed$var$useRouteContext(hookName) {
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $7939e29d663dd3ed$var$useCurrentRouteId(hookName) {
    let route = $7939e29d663dd3ed$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $7939e29d663dd3ed$export$5fc8298006ad9e58() {
    return $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7939e29d663dd3ed$export$d0fd4b7106de2769() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7939e29d663dd3ed$export$600dc272ed516c15() {
    let dataRouterContext = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseRevalidator);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRevalidator);
    return $acw62.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7939e29d663dd3ed$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseMatches);
    return $acw62.useMemo(()=>matches.map((m)=>(0, $1d34d5c4a288b213$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7939e29d663dd3ed$export$1448a5050d252c4d() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7939e29d663dd3ed$export$fd5d37484eab868d(routeId) {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7939e29d663dd3ed$export$fdc00f3f26066d5e() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseActionData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7939e29d663dd3ed$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $acw62.useContext($7939e29d663dd3ed$var$RouteErrorContext);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$17f53340677d5831() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $7939e29d663dd3ed$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7939e29d663dd3ed$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseBlocker);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $7939e29d663dd3ed$var$_extends({}, currentLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $7939e29d663dd3ed$var$_extends({}, nextLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $acw62.useEffect(()=>{
        let key = String(++$7939e29d663dd3ed$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $1d34d5c4a288b213$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $7939e29d663dd3ed$var$useNavigateStable() {
    let { router: router } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseNavigateStable);
    let id = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $7939e29d663dd3ed$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$alreadyWarned$1 = {};
function $7939e29d663dd3ed$var$warningOnce(key, cond, message) {
    if (!cond && !$7939e29d663dd3ed$var$alreadyWarned$1[key]) $7939e29d663dd3ed$var$alreadyWarned$1[key] = true;
}
const $7939e29d663dd3ed$var$alreadyWarned = {};
function $7939e29d663dd3ed$var$warnOnce(key, message) {}
const $7939e29d663dd3ed$var$logDeprecation = (flag, msg, link)=>$7939e29d663dd3ed$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $7939e29d663dd3ed$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $7939e29d663dd3ed$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $7939e29d663dd3ed$var$START_TRANSITION = "startTransition";
const $7939e29d663dd3ed$var$startTransitionImpl = $acw62[$7939e29d663dd3ed$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7939e29d663dd3ed$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        if (v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl) $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $acw62.useEffect(()=>$7939e29d663dd3ed$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $7939e29d663dd3ed$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $7939e29d663dd3ed$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl ? $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>$7939e29d663dd3ed$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $7939e29d663dd3ed$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let navigate = $7939e29d663dd3ed$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, (0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $7939e29d663dd3ed$export$910ae8079b2c2852(props) {
    return $7939e29d663dd3ed$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $7939e29d663dd3ed$export$e7b0ac011bb776c6(_props) {
    (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $7939e29d663dd3ed$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $7939e29d663dd3ed$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $7939e29d663dd3ed$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $7939e29d663dd3ed$export$5d3fca4a98652595($7939e29d663dd3ed$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7939e29d663dd3ed$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$ResolveAwait, null, children));
}
var $7939e29d663dd3ed$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($7939e29d663dd3ed$var$AwaitRenderStatus || {});
const $7939e29d663dd3ed$var$neverSettledPromise = new Promise(()=>{});
class $7939e29d663dd3ed$var$AwaitErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $7939e29d663dd3ed$var$AwaitRenderStatus.error : "_data" in promise ? $7939e29d663dd3ed$var$AwaitRenderStatus.success : $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && promise._error instanceof (0, $1d34d5c4a288b213$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $7939e29d663dd3ed$var$neverSettledPromise;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $7939e29d663dd3ed$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $7939e29d663dd3ed$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $7939e29d663dd3ed$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7939e29d663dd3ed$export$e7b0ac011bb776c6) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7939e29d663dd3ed$export$daf73786167a7f72(matches) {
    return $7939e29d663dd3ed$var$_renderMatches(matches);
}
function $7939e29d663dd3ed$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $acw62.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $acw62.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $acw62.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $7939e29d663dd3ed$export$f30f7e456d254e83(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $7939e29d663dd3ed$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $7939e29d663dd3ed$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $040dbb9c344a508d$var$_extends() {
    return $040dbb9c344a508d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $040dbb9c344a508d$var$_extends.apply(null, arguments);
}
function $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
const $040dbb9c344a508d$var$defaultMethod = "get";
const $040dbb9c344a508d$var$defaultEncType = "application/x-www-form-urlencoded";
function $040dbb9c344a508d$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $040dbb9c344a508d$var$isButtonElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $040dbb9c344a508d$var$isFormElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $040dbb9c344a508d$var$isInputElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $040dbb9c344a508d$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $040dbb9c344a508d$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$040dbb9c344a508d$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $040dbb9c344a508d$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $040dbb9c344a508d$var$_formDataSupportsSubmitter = null;
function $040dbb9c344a508d$var$isFormDataSubmitterSupported() {
    if ($040dbb9c344a508d$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = true;
    }
    return $040dbb9c344a508d$var$_formDataSupportsSubmitter;
}
const $040dbb9c344a508d$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $040dbb9c344a508d$var$getFormEncType(encType) {
    if (encType != null && !$040dbb9c344a508d$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($040dbb9c344a508d$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        formData = new FormData(target);
    } else if ($040dbb9c344a508d$var$isButtonElement(target) || $040dbb9c344a508d$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("formenctype")) || $040dbb9c344a508d$var$getFormEncType(form.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$040dbb9c344a508d$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($040dbb9c344a508d$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $040dbb9c344a508d$var$defaultMethod;
        action = null;
        encType = $040dbb9c344a508d$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $040dbb9c344a508d$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $040dbb9c344a508d$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $040dbb9c344a508d$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $040dbb9c344a508d$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $040dbb9c344a508d$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $040dbb9c344a508d$export$1f3f55432a00e06d(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $040dbb9c344a508d$var$_extends({}, state, {
        errors: $040dbb9c344a508d$var$deserializeErrors(state.errors)
    });
    return state;
}
function $040dbb9c344a508d$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $1d34d5c4a288b213$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $040dbb9c344a508d$export$7ad602f0e94e62d1 = /*#__PURE__*/ $acw62.createContext({
    isTransitioning: false
});
const $040dbb9c344a508d$export$148fd98d095596d4 = /*#__PURE__*/ $acw62.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $040dbb9c344a508d$var$START_TRANSITION = "startTransition";
const $040dbb9c344a508d$var$startTransitionImpl = $acw62[$040dbb9c344a508d$var$START_TRANSITION];
const $040dbb9c344a508d$var$FLUSH_SYNC = "flushSync";
const $040dbb9c344a508d$var$flushSyncImpl = $11492dca620dcaa5$exports[$040dbb9c344a508d$var$FLUSH_SYNC];
const $040dbb9c344a508d$var$USE_ID = "useId";
const $040dbb9c344a508d$var$useIdImpl = $acw62[$040dbb9c344a508d$var$USE_ID];
function $040dbb9c344a508d$var$startTransitionSafe(cb) {
    if ($040dbb9c344a508d$var$startTransitionImpl) $040dbb9c344a508d$var$startTransitionImpl(cb);
    else cb();
}
function $040dbb9c344a508d$var$flushSyncSafe(cb) {
    if ($040dbb9c344a508d$var$flushSyncImpl) $040dbb9c344a508d$var$flushSyncImpl(cb);
    else cb();
}
class $040dbb9c344a508d$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $040dbb9c344a508d$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let [pendingState, setPendingState] = $acw62.useState();
    let [vtContext, setVtContext] = $acw62.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $acw62.useState();
    let [transition, setTransition] = $acw62.useState();
    let [interruption, setInterruption] = $acw62.useState();
    let fetcherData = $acw62.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $acw62.useCallback((cb)=>{
        if (v7_startTransition) $040dbb9c344a508d$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $acw62.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $040dbb9c344a508d$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $040dbb9c344a508d$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $acw62.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $040dbb9c344a508d$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $acw62.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $acw62.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $040dbb9c344a508d$var$MemoizedDataRoutes = /*#__PURE__*/ $acw62.memo($040dbb9c344a508d$var$DataRoutes);
function $040dbb9c344a508d$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $7939e29d663dd3ed$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $040dbb9c344a508d$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $040dbb9c344a508d$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $040dbb9c344a508d$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $040dbb9c344a508d$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $040dbb9c344a508d$export$a6c7ac8248d6e38a = /*#__PURE__*/ $acw62.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref7, $040dbb9c344a508d$var$_excluded);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($040dbb9c344a508d$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $7939e29d663dd3ed$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $040dbb9c344a508d$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $acw62.createElement("a", $040dbb9c344a508d$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $040dbb9c344a508d$export$b0d92dbee9b5b60d = /*#__PURE__*/ $acw62.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref8, $040dbb9c344a508d$var$_excluded2);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let routerState = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $040dbb9c344a508d$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a6c7ac8248d6e38a, $040dbb9c344a508d$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $040dbb9c344a508d$export$a7fed597f4b8afd8 = /*#__PURE__*/ $acw62.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $040dbb9c344a508d$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref9, $040dbb9c344a508d$var$_excluded3);
    let submit = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let formAction = $040dbb9c344a508d$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $acw62.createElement("form", $040dbb9c344a508d$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $040dbb9c344a508d$export$11aac1aab828f1fa(_ref0) {
    let { getKey: getKey, storageKey: storageKey } = _ref0;
    $040dbb9c344a508d$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $040dbb9c344a508d$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($040dbb9c344a508d$var$DataRouterHook || ($040dbb9c344a508d$var$DataRouterHook = {}));
var $040dbb9c344a508d$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($040dbb9c344a508d$var$DataRouterStateHook || ($040dbb9c344a508d$var$DataRouterStateHook = {}));
// Internal hooks
function $040dbb9c344a508d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $040dbb9c344a508d$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext((0, $7939e29d663dd3ed$export$3add0d5dce533e2e));
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $040dbb9c344a508d$var$useDataRouterState(hookName) {
    let state = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $040dbb9c344a508d$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($040dbb9c344a508d$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $1d34d5c4a288b213$export$fe53371bee54353d)(location) === (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $040dbb9c344a508d$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $acw62.useRef($040dbb9c344a508d$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $040dbb9c344a508d$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $040dbb9c344a508d$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $040dbb9c344a508d$var$fetcherId = 0;
let $040dbb9c344a508d$var$getUniqueFetcherId = ()=>"__" + String(++$040dbb9c344a508d$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $040dbb9c344a508d$export$47c85c6e3a081d3() {
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let currentRouteId = (0, $7939e29d663dd3ed$export$5fc8298006ad9e58)();
    return $acw62.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $040dbb9c344a508d$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $040dbb9c344a508d$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $040dbb9c344a508d$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let routeContext = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    !routeContext && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $040dbb9c344a508d$var$_extends({}, (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $040dbb9c344a508d$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseFetcher);
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $acw62.useContext($040dbb9c344a508d$export$148fd98d095596d4);
    let route = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $040dbb9c344a508d$var$useIdImpl ? $040dbb9c344a508d$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $acw62.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($040dbb9c344a508d$var$getUniqueFetcherId());
    // Registration/cleanup
    $acw62.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $acw62.useCallback((href, opts)=>{
        !routeId && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let submit = $acw62.useCallback((target, opts)=>{
        submitImpl(target, $040dbb9c344a508d$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $acw62.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a7fed597f4b8afd8, $040dbb9c344a508d$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $1d34d5c4a288b213$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>$040dbb9c344a508d$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $040dbb9c344a508d$export$fa996778a3a31087() {
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref1)=>{
        let [key, fetcher] = _ref1;
        return $040dbb9c344a508d$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $040dbb9c344a508d$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $040dbb9c344a508d$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let matches = (0, $7939e29d663dd3ed$export$2378eb7f5ff86053)();
    let navigation = (0, $7939e29d663dd3ed$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $040dbb9c344a508d$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $040dbb9c344a508d$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($040dbb9c344a508d$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $040dbb9c344a508d$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($040dbb9c344a508d$var$_extends({}, location, {
                    pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($040dbb9c344a508d$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $040dbb9c344a508d$export$39f4eb3dbd812741(_ref10) {
    let { when: when, message: message } = _ref10;
    let blocker = (0, $7939e29d663dd3ed$export$b273b3273281a049)(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $040dbb9c344a508d$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $acw62.useContext($040dbb9c344a508d$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.useViewTransitionState);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



var $acw62 = parcelRequire("acw62");
var $701b6c0516155145$exports = {};
'use strict';

$701b6c0516155145$exports = (parcelRequire("iZZ9K"));


var $55388fc2f116d4d7$var$__defProp = Object.defineProperty;
var $55388fc2f116d4d7$var$__defProps = Object.defineProperties;
var $55388fc2f116d4d7$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $55388fc2f116d4d7$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $55388fc2f116d4d7$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $55388fc2f116d4d7$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $55388fc2f116d4d7$var$__defNormalProp = (obj, key, value)=>key in obj ? $55388fc2f116d4d7$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $55388fc2f116d4d7$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($55388fc2f116d4d7$var$__hasOwnProp.call(b, prop)) $55388fc2f116d4d7$var$__defNormalProp(a, prop, b[prop]);
    if ($55388fc2f116d4d7$var$__getOwnPropSymbols) {
        for (var prop of $55388fc2f116d4d7$var$__getOwnPropSymbols(b))if ($55388fc2f116d4d7$var$__propIsEnum.call(b, prop)) $55388fc2f116d4d7$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $55388fc2f116d4d7$var$__spreadProps = (a, b)=>$55388fc2f116d4d7$var$__defProps(a, $55388fc2f116d4d7$var$__getOwnPropDescs(b));
var $55388fc2f116d4d7$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($55388fc2f116d4d7$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $55388fc2f116d4d7$var$__getOwnPropSymbols) {
        for (var prop of $55388fc2f116d4d7$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $55388fc2f116d4d7$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
// src/utils/react-is.ts
var $55388fc2f116d4d7$var$IS_REACT_19 = /* @__PURE__ */ $acw62.version.startsWith("19");
var $55388fc2f116d4d7$var$REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for($55388fc2f116d4d7$var$IS_REACT_19 ? "react.transitional.element" : "react.element");
var $55388fc2f116d4d7$var$REACT_PORTAL_TYPE = /* @__PURE__ */ Symbol.for("react.portal");
var $55388fc2f116d4d7$var$REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment");
var $55388fc2f116d4d7$var$REACT_STRICT_MODE_TYPE = /* @__PURE__ */ Symbol.for("react.strict_mode");
var $55388fc2f116d4d7$var$REACT_PROFILER_TYPE = /* @__PURE__ */ Symbol.for("react.profiler");
var $55388fc2f116d4d7$var$REACT_CONSUMER_TYPE = /* @__PURE__ */ Symbol.for("react.consumer");
var $55388fc2f116d4d7$var$REACT_CONTEXT_TYPE = /* @__PURE__ */ Symbol.for("react.context");
var $55388fc2f116d4d7$var$REACT_FORWARD_REF_TYPE = /* @__PURE__ */ Symbol.for("react.forward_ref");
var $55388fc2f116d4d7$var$REACT_SUSPENSE_TYPE = /* @__PURE__ */ Symbol.for("react.suspense");
var $55388fc2f116d4d7$var$REACT_SUSPENSE_LIST_TYPE = /* @__PURE__ */ Symbol.for("react.suspense_list");
var $55388fc2f116d4d7$var$REACT_MEMO_TYPE = /* @__PURE__ */ Symbol.for("react.memo");
var $55388fc2f116d4d7$var$REACT_LAZY_TYPE = /* @__PURE__ */ Symbol.for("react.lazy");
var $55388fc2f116d4d7$var$REACT_OFFSCREEN_TYPE = /* @__PURE__ */ Symbol.for("react.offscreen");
var $55388fc2f116d4d7$var$REACT_CLIENT_REFERENCE = /* @__PURE__ */ Symbol.for("react.client.reference");
var $55388fc2f116d4d7$var$ForwardRef = $55388fc2f116d4d7$var$REACT_FORWARD_REF_TYPE;
var $55388fc2f116d4d7$var$Memo = $55388fc2f116d4d7$var$REACT_MEMO_TYPE;
function $55388fc2f116d4d7$var$isValidElementType(type) {
    return typeof type === "string" || typeof type === "function" || type === $55388fc2f116d4d7$var$REACT_FRAGMENT_TYPE || type === $55388fc2f116d4d7$var$REACT_PROFILER_TYPE || type === $55388fc2f116d4d7$var$REACT_STRICT_MODE_TYPE || type === $55388fc2f116d4d7$var$REACT_SUSPENSE_TYPE || type === $55388fc2f116d4d7$var$REACT_SUSPENSE_LIST_TYPE || type === $55388fc2f116d4d7$var$REACT_OFFSCREEN_TYPE || typeof type === "object" && type !== null && (type.$$typeof === $55388fc2f116d4d7$var$REACT_LAZY_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_MEMO_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_CONTEXT_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_CONSUMER_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) ? true : false;
}
function $55388fc2f116d4d7$var$typeOf(object) {
    if (typeof object === "object" && object !== null) {
        const { $$typeof: $$typeof } = object;
        switch($$typeof){
            case $55388fc2f116d4d7$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $55388fc2f116d4d7$var$REACT_FRAGMENT_TYPE:
                    case $55388fc2f116d4d7$var$REACT_PROFILER_TYPE:
                    case $55388fc2f116d4d7$var$REACT_STRICT_MODE_TYPE:
                    case $55388fc2f116d4d7$var$REACT_SUSPENSE_TYPE:
                    case $55388fc2f116d4d7$var$REACT_SUSPENSE_LIST_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $55388fc2f116d4d7$var$REACT_CONTEXT_TYPE:
                            case $55388fc2f116d4d7$var$REACT_FORWARD_REF_TYPE:
                            case $55388fc2f116d4d7$var$REACT_LAZY_TYPE:
                            case $55388fc2f116d4d7$var$REACT_MEMO_TYPE:
                                return object;
                            case $55388fc2f116d4d7$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $55388fc2f116d4d7$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
function $55388fc2f116d4d7$var$isContextConsumer(object) {
    return $55388fc2f116d4d7$var$IS_REACT_19 ? $55388fc2f116d4d7$var$typeOf(object) === $55388fc2f116d4d7$var$REACT_CONSUMER_TYPE : $55388fc2f116d4d7$var$typeOf(object) === $55388fc2f116d4d7$var$REACT_CONTEXT_TYPE;
}
function $55388fc2f116d4d7$var$isMemo(object) {
    return $55388fc2f116d4d7$var$typeOf(object) === $55388fc2f116d4d7$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $55388fc2f116d4d7$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $55388fc2f116d4d7$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $55388fc2f116d4d7$var$warning(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $55388fc2f116d4d7$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $55388fc2f116d4d7$var$verify(mapStateToProps, "mapStateToProps");
    $55388fc2f116d4d7$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $55388fc2f116d4d7$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $55388fc2f116d4d7$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $55388fc2f116d4d7$var$finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _b, options = $55388fc2f116d4d7$var$__objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $55388fc2f116d4d7$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $55388fc2f116d4d7$var$bindActionCreators(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $55388fc2f116d4d7$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    const proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $55388fc2f116d4d7$var$verifyPlainObject(value, displayName, methodName) {
    if (!$55388fc2f116d4d7$var$isPlainObject(value)) $55388fc2f116d4d7$var$warning(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}
// src/connect/wrapMapToProps.ts
function $55388fc2f116d4d7$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $55388fc2f116d4d7$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $55388fc2f116d4d7$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $55388fc2f116d4d7$var$getDependsOnOwnProps(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $55388fc2f116d4d7$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $55388fc2f116d4d7$var$createInvalidArgFactory(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}
// src/connect/mapDispatchToProps.ts
function $55388fc2f116d4d7$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? $55388fc2f116d4d7$var$wrapMapToPropsConstant((dispatch)=>// @ts-ignore
        $55388fc2f116d4d7$var$bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? $55388fc2f116d4d7$var$wrapMapToPropsConstant((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $55388fc2f116d4d7$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $55388fc2f116d4d7$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $55388fc2f116d4d7$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $55388fc2f116d4d7$var$wrapMapToPropsConstant(()=>({})) : typeof mapStateToProps === "function" ? // @ts-ignore
    $55388fc2f116d4d7$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $55388fc2f116d4d7$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $55388fc2f116d4d7$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return $55388fc2f116d4d7$var$__spreadValues($55388fc2f116d4d7$var$__spreadValues($55388fc2f116d4d7$var$__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function $55388fc2f116d4d7$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $55388fc2f116d4d7$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? ()=>$55388fc2f116d4d7$var$defaultMergeProps : typeof mergeProps === "function" ? $55388fc2f116d4d7$var$wrapMergePropsFunc(mergeProps) : $55388fc2f116d4d7$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $55388fc2f116d4d7$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $55388fc2f116d4d7$var$createListenerCollection() {
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            $55388fc2f116d4d7$var$defaultNoopBatch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            const listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            const listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $55388fc2f116d4d7$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $55388fc2f116d4d7$var$createSubscription(store, parentSub) {
    let unsubscribe;
    let listeners = $55388fc2f116d4d7$var$nullListeners;
    let subscriptionsAmount = 0;
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener);
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $55388fc2f116d4d7$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $55388fc2f116d4d7$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $55388fc2f116d4d7$var$canUseDOM = ()=>!!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $55388fc2f116d4d7$var$isDOM = /* @__PURE__ */ $55388fc2f116d4d7$var$canUseDOM();
var $55388fc2f116d4d7$var$isRunningInReactNative = ()=>typeof navigator !== "undefined" && navigator.product === "ReactNative";
var $55388fc2f116d4d7$var$isReactNative = /* @__PURE__ */ $55388fc2f116d4d7$var$isRunningInReactNative();
var $55388fc2f116d4d7$var$getUseIsomorphicLayoutEffect = ()=>$55388fc2f116d4d7$var$isDOM || $55388fc2f116d4d7$var$isReactNative ? $acw62.useLayoutEffect : $acw62.useEffect;
var $55388fc2f116d4d7$var$useIsomorphicLayoutEffect = /* @__PURE__ */ $55388fc2f116d4d7$var$getUseIsomorphicLayoutEffect();
// src/utils/shallowEqual.ts
function $55388fc2f116d4d7$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $55388fc2f116d4d7$export$d36bdfa510afb180(objA, objB) {
    if ($55388fc2f116d4d7$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$55388fc2f116d4d7$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $55388fc2f116d4d7$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $55388fc2f116d4d7$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $55388fc2f116d4d7$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $55388fc2f116d4d7$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $55388fc2f116d4d7$var$TYPE_STATICS = {
    [$55388fc2f116d4d7$var$ForwardRef]: $55388fc2f116d4d7$var$FORWARD_REF_STATICS,
    [$55388fc2f116d4d7$var$Memo]: $55388fc2f116d4d7$var$MEMO_STATICS
};
function $55388fc2f116d4d7$var$getStatics(component) {
    if ($55388fc2f116d4d7$var$isMemo(component)) return $55388fc2f116d4d7$var$MEMO_STATICS;
    return $55388fc2f116d4d7$var$TYPE_STATICS[component["$$typeof"]] || $55388fc2f116d4d7$var$REACT_STATICS;
}
var $55388fc2f116d4d7$var$defineProperty = Object.defineProperty;
var $55388fc2f116d4d7$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $55388fc2f116d4d7$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $55388fc2f116d4d7$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $55388fc2f116d4d7$var$getPrototypeOf = Object.getPrototypeOf;
var $55388fc2f116d4d7$var$objectPrototype = Object.prototype;
function $55388fc2f116d4d7$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($55388fc2f116d4d7$var$objectPrototype) {
            const inheritedComponent = $55388fc2f116d4d7$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $55388fc2f116d4d7$var$objectPrototype) $55388fc2f116d4d7$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        let keys = $55388fc2f116d4d7$var$getOwnPropertyNames(sourceComponent);
        if ($55388fc2f116d4d7$var$getOwnPropertySymbols) keys = keys.concat($55388fc2f116d4d7$var$getOwnPropertySymbols(sourceComponent));
        const targetStatics = $55388fc2f116d4d7$var$getStatics(targetComponent);
        const sourceStatics = $55388fc2f116d4d7$var$getStatics(sourceComponent);
        for(let i = 0; i < keys.length; ++i){
            const key = keys[i];
            if (!$55388fc2f116d4d7$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                const descriptor = $55388fc2f116d4d7$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $55388fc2f116d4d7$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/Context.ts
var $55388fc2f116d4d7$var$ContextKey = /* @__PURE__ */ Symbol.for(`react-redux-context`);
var $55388fc2f116d4d7$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $55388fc2f116d4d7$var$getContext() {
    var _a;
    if (!$acw62.createContext) return {};
    const contextMap = (_a = $55388fc2f116d4d7$var$gT[$55388fc2f116d4d7$var$ContextKey]) != null ? _a : $55388fc2f116d4d7$var$gT[$55388fc2f116d4d7$var$ContextKey] = /* @__PURE__ */ new Map();
    let realContext = contextMap.get($acw62.createContext);
    if (!realContext) {
        realContext = $acw62.createContext(null);
        contextMap.set($acw62.createContext, realContext);
    }
    return realContext;
}
var $55388fc2f116d4d7$export$cc80c08dc91f1c00 = /* @__PURE__ */ $55388fc2f116d4d7$var$getContext();
// src/components/connect.tsx
var $55388fc2f116d4d7$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $55388fc2f116d4d7$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $55388fc2f116d4d7$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $55388fc2f116d4d7$var$useIsomorphicLayoutEffect(()=>effectFunc(...effectArgs), dependencies);
}
function $55388fc2f116d4d7$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $55388fc2f116d4d7$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return ()=>{};
    let didUnsubscribe = false;
    let lastThrownError = null;
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) return;
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $55388fc2f116d4d7$var$strictEqual(a, b) {
    return a === b;
}
var $55388fc2f116d4d7$var$hasWarnedAboutDeprecatedPureOption = false;
function $55388fc2f116d4d7$var$_connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $55388fc2f116d4d7$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = $55388fc2f116d4d7$export$d36bdfa510afb180, areStatePropsEqual: areStatePropsEqual = $55388fc2f116d4d7$export$d36bdfa510afb180, areMergedPropsEqual: areMergedPropsEqual = $55388fc2f116d4d7$export$d36bdfa510afb180, forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = $55388fc2f116d4d7$export$cc80c08dc91f1c00 } = {}) {
    const Context = context;
    const initMapStateToProps = $55388fc2f116d4d7$var$mapStateToPropsFactory(mapStateToProps);
    const initMapDispatchToProps = $55388fc2f116d4d7$var$mapDispatchToPropsFactory(mapDispatchToProps);
    const initMergeProps = $55388fc2f116d4d7$var$mergePropsFactory(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $acw62.useMemo(()=>{
                const _a = props, { reactReduxForwardedRef: reactReduxForwardedRef2 } = _a, wrapperProps2 = $55388fc2f116d4d7$var$__objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]);
            const ContextToUse = $acw62.useMemo(()=>{
                let ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            const contextValue = $acw62.useContext(ContextToUse);
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $acw62.useMemo(()=>{
                return $55388fc2f116d4d7$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $acw62.useMemo(()=>{
                if (!shouldHandleStateChanges) return $55388fc2f116d4d7$var$NO_SUBSCRIPTION_ARRAY;
                const subscription2 = $55388fc2f116d4d7$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                const notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]);
            const overriddenContextValue = $acw62.useMemo(()=>{
                if (didStoreComeFromProps) return contextValue;
                return $55388fc2f116d4d7$var$__spreadProps($55388fc2f116d4d7$var$__spreadValues({}, contextValue), {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            const lastChildProps = $acw62.useRef(void 0);
            const lastWrapperProps = $acw62.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $acw62.useRef(void 0);
            const renderIsScheduled = $acw62.useRef(false);
            const isMounted = $acw62.useRef(false);
            const latestSubscriptionCallbackError = $acw62.useRef(void 0);
            $55388fc2f116d4d7$var$useIsomorphicLayoutEffect(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $acw62.useMemo(()=>{
                const selector = ()=>{
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            const subscribeForReact = $acw62.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $55388fc2f116d4d7$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $55388fc2f116d4d7$var$useIsomorphicLayoutEffectWithArgs($55388fc2f116d4d7$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $acw62.useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `
The error may be correlated with this previous error:
${latestSubscriptionCallbackError.current.stack}

`;
                throw err;
            }
            $55388fc2f116d4d7$var$useIsomorphicLayoutEffect(()=>{
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            const renderedWrappedComponent = $acw62.useMemo(()=>{
                return(// @ts-ignore
                /* @__PURE__ */ $acw62.createElement(WrappedComponent, $55388fc2f116d4d7$var$__spreadProps($55388fc2f116d4d7$var$__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            const renderedChild = $acw62.useMemo(()=>{
                if (shouldHandleStateChanges) return /* @__PURE__ */ $acw62.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $acw62.memo(ConnectFunction);
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $acw62.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $acw62.createElement(Connect, $55388fc2f116d4d7$var$__spreadProps($55388fc2f116d4d7$var$__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $55388fc2f116d4d7$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $55388fc2f116d4d7$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $55388fc2f116d4d7$export$64605811ab45167f = $55388fc2f116d4d7$var$_connect;
var $55388fc2f116d4d7$export$8807b5ba46f9d0b7 = $55388fc2f116d4d7$var$_connect;
// src/components/Provider.tsx
function $55388fc2f116d4d7$var$Provider(providerProps) {
    const { children: children, context: context, serverState: serverState, store: store } = providerProps;
    const contextValue = $acw62.useMemo(()=>{
        const subscription = $55388fc2f116d4d7$var$createSubscription(store);
        const baseContextValue = {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : void 0
        };
        return baseContextValue;
    }, [
        store,
        serverState
    ]);
    const previousState = $acw62.useMemo(()=>store.getState(), [
        store
    ]);
    $55388fc2f116d4d7$var$useIsomorphicLayoutEffect(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || $55388fc2f116d4d7$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $acw62.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $55388fc2f116d4d7$export$2881499e37b75b9a = $55388fc2f116d4d7$var$Provider;
// src/hooks/useReduxContext.ts
function $55388fc2f116d4d7$var$createReduxContextHook(context = $55388fc2f116d4d7$export$cc80c08dc91f1c00) {
    return function useReduxContext2() {
        const contextValue = $acw62.useContext(context);
        return contextValue;
    };
}
var $55388fc2f116d4d7$var$useReduxContext = /* @__PURE__ */ $55388fc2f116d4d7$var$createReduxContextHook();
// src/hooks/useStore.ts
function $55388fc2f116d4d7$export$671dba69185d0304(context = $55388fc2f116d4d7$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $55388fc2f116d4d7$export$cc80c08dc91f1c00 ? $55388fc2f116d4d7$var$useReduxContext : // @ts-ignore
    $55388fc2f116d4d7$var$createReduxContextHook(context);
    const useStore2 = ()=>{
        const { store: store } = useReduxContext2();
        return store;
    };
    Object.assign(useStore2, {
        withTypes: ()=>useStore2
    });
    return useStore2;
}
var $55388fc2f116d4d7$export$6ccbb43953eebf8 = /* @__PURE__ */ $55388fc2f116d4d7$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $55388fc2f116d4d7$export$bc9b55530897c558(context = $55388fc2f116d4d7$export$cc80c08dc91f1c00) {
    const useStore2 = context === $55388fc2f116d4d7$export$cc80c08dc91f1c00 ? $55388fc2f116d4d7$export$6ccbb43953eebf8 : $55388fc2f116d4d7$export$671dba69185d0304(context);
    const useDispatch2 = ()=>{
        const store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: ()=>useDispatch2
    });
    return useDispatch2;
}
var $55388fc2f116d4d7$export$8ad76b76a4c905f8 = /* @__PURE__ */ $55388fc2f116d4d7$export$bc9b55530897c558();
var $55388fc2f116d4d7$var$refEquality = (a, b)=>a === b;
function $55388fc2f116d4d7$export$2b53f90d2bd1cbfb(context = $55388fc2f116d4d7$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $55388fc2f116d4d7$export$cc80c08dc91f1c00 ? $55388fc2f116d4d7$var$useReduxContext : $55388fc2f116d4d7$var$createReduxContextHook(context);
    const useSelector2 = (selector, equalityFnOrOptions = {})=>{
        const { equalityFn: equalityFn = $55388fc2f116d4d7$var$refEquality } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const reduxContext = useReduxContext2();
        const { store: store, subscription: subscription, getServerState: getServerState } = reduxContext;
        const firstRun = $acw62.useRef(true);
        const wrappedSelector = $acw62.useCallback({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector
        ]);
        const selectedState = (0, $701b6c0516155145$exports.useSyncExternalStoreWithSelector)(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $acw62.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: ()=>useSelector2
    });
    return useSelector2;
}
var $55388fc2f116d4d7$export$2105062e25df4afe = /* @__PURE__ */ $55388fc2f116d4d7$export$2b53f90d2bd1cbfb();
// src/exports.ts
var $55388fc2f116d4d7$export$712ea50be43a7858 = $55388fc2f116d4d7$var$defaultNoopBatch;




var $acw62 = parcelRequire("acw62");



var $7484f88fafffadc1$exports = {};

$parcel$export($7484f88fafffadc1$exports, "IcAdd", () => $4c1f85da286cc021$export$27c4cbfb69a3e993);
$parcel$export($7484f88fafffadc1$exports, "IcAddCircle", () => $492c3793f2565770$export$869af20d98048fdb);
$parcel$export($7484f88fafffadc1$exports, "IcBarcode", () => $c785181df5f05ff0$export$a8e06849d04b5a6f);
$parcel$export($7484f88fafffadc1$exports, "IcCalendar", () => $8575d8a7579bc216$export$50599049b1f53719);
$parcel$export($7484f88fafffadc1$exports, "IcCamera", () => $9317423e48146c30$export$7e1befdbe52b3f32);
$parcel$export($7484f88fafffadc1$exports, "IcCloseRemove", () => $41afd5d0591e38b4$export$464f071bbd2cc5e5);
$parcel$export($7484f88fafffadc1$exports, "IcConfirm", () => $81c2e361146d997a$export$5753b5c18d35b7d0);
$parcel$export($7484f88fafffadc1$exports, "IcCopy", () => $e7017ca5d1211e2a$export$d1bc6c264a68b09f);
$parcel$export($7484f88fafffadc1$exports, "IcDownload", () => $60bea030b4289a81$export$bb264a5644c93858);
$parcel$export($7484f88fafffadc1$exports, "IcDownloads", () => $a444653678cb64a6$export$7123f6ef4f453bfb);
$parcel$export($7484f88fafffadc1$exports, "IcEdit", () => $e784d250820e9f29$export$16866440f7f6c8dd);
$parcel$export($7484f88fafffadc1$exports, "IcEditPen", () => $482699419fe250fb$export$55e8bf91189d440f);
$parcel$export($7484f88fafffadc1$exports, "IcExport", () => $29de726ee5eab1bd$export$aca4755275c34537);
$parcel$export($7484f88fafffadc1$exports, "IcFavorite", () => $e91f6485634b0b2d$export$cf9fe37d44aabb87);
$parcel$export($7484f88fafffadc1$exports, "IcFilter", () => $a9dbc27ea69a373d$export$26f46b9510140fcc);
$parcel$export($7484f88fafffadc1$exports, "IcFlipCamera", () => $5dbebc00dddb0397$export$f368e7c219601d0);
$parcel$export($7484f88fafffadc1$exports, "IcForward", () => $5bfc417138d8f1d0$export$78755581f96e0e89);
$parcel$export($7484f88fafffadc1$exports, "IcFullscreenMode", () => $dd63bed1b06632eb$export$bbb3e4be3b42bb9e);
$parcel$export($7484f88fafffadc1$exports, "IcFullscreenModeOff", () => $6ecf4bf16682bccb$export$65093953efbe81ce);
$parcel$export($7484f88fafffadc1$exports, "IcImport", () => $a9954b6e730b1bf2$export$78b80e1f11d67211);
$parcel$export($7484f88fafffadc1$exports, "IcLike", () => $7eac34319dc0f080$export$cbfc8e31e81d3925);
$parcel$export($7484f88fafffadc1$exports, "IcMinimise", () => $c36840204c0c4394$export$28b4ffe30999880e);
$parcel$export($7484f88fafffadc1$exports, "IcMinus", () => $c15dabd2350ae6f1$export$a112cdf9589f07b2);
$parcel$export($7484f88fafffadc1$exports, "IcNotification", () => $22260c4a50157a1d$export$c69b4469075788f4);
$parcel$export($7484f88fafffadc1$exports, "IcNotificationOff", () => $dffc3e9b8ee65686$export$184395fb225b1980);
$parcel$export($7484f88fafffadc1$exports, "IcOpenWith", () => $2a74a59a4eabdf30$export$8d8d10bea6cba17d);
$parcel$export($7484f88fafffadc1$exports, "IcPaste", () => $e6603180443fef86$export$3ff4a916a5aef516);
$parcel$export($7484f88fafffadc1$exports, "IcQrCode", () => $3d7d7f73cd2510e3$export$b085f0ec027ff450);
$parcel$export($7484f88fafffadc1$exports, "IcReply", () => $e6d412d90124b081$export$d8f8141123df49e9);
$parcel$export($7484f88fafffadc1$exports, "IcReplyAll", () => $3ef05a732320915e$export$ee5a0a2b44c8bf7b);
$parcel$export($7484f88fafffadc1$exports, "IcScanQrCode", () => $e85b4fcc36284356$export$b8634ccdc50979ab);
$parcel$export($7484f88fafffadc1$exports, "IcSendMessage", () => $5f9a066e7f58c8de$export$ea9aaa46ca2083e7);
$parcel$export($7484f88fafffadc1$exports, "IcShare", () => $fa655b85abce0796$export$d7bcdec678388771);
$parcel$export($7484f88fafffadc1$exports, "IcSort", () => $c07aaad5de81ca37$export$d802d08b192014d8);
$parcel$export($7484f88fafffadc1$exports, "IcSwap", () => $3f6fa4229d34bf2e$export$7d8d98dd3a766908);
$parcel$export($7484f88fafffadc1$exports, "IcTag", () => $b0cb2302c39973bb$export$af82b8856b912f54);
$parcel$export($7484f88fafffadc1$exports, "IcTime", () => $8c66bf8a36364e42$export$7f3df200d95b839b);
$parcel$export($7484f88fafffadc1$exports, "IcTrash", () => $80b96fbfbd3172e6$export$f4fff73cae16f2b9);
$parcel$export($7484f88fafffadc1$exports, "IcUpload", () => $170225ee6a03579c$export$7a525547346e73a);
$parcel$export($7484f88fafffadc1$exports, "IcUpload1", () => $137d0dfc17372d44$export$904ccf4b059cd9b2);
$parcel$export($7484f88fafffadc1$exports, "IcUploads", () => $9a1d7adf13d086c8$export$6a26d7605291833e);
$parcel$export($7484f88fafffadc1$exports, "IcVisible", () => $35aa9dff24458a00$export$fd7adc84612ab6c3);
$parcel$export($7484f88fafffadc1$exports, "IcVisibleOff", () => $1158e373884bc031$export$2deae51be13efc65);
$parcel$export($7484f88fafffadc1$exports, "IcCard", () => $d736a2a789a742e1$export$d4c35c8bf2c76a77);
$parcel$export($7484f88fafffadc1$exports, "IcCart", () => $e2e2422c14c24c30$export$c7056e444d073e5f);
$parcel$export($7484f88fafffadc1$exports, "IcCcv", () => $b69b9808a49ff611$export$626a5c1c628bf04f);
$parcel$export($7484f88fafffadc1$exports, "IcJiopay", () => $86b1b79c3c2f8f62$export$ba660c68f7598614);
$parcel$export($7484f88fafffadc1$exports, "IcRupee", () => $887f7325e59b5272$export$39cc7d72735656c0);
$parcel$export($7484f88fafffadc1$exports, "IcRupeeCoin", () => $90bdcbe23c465361$export$300912d25f93283a);
$parcel$export($7484f88fafffadc1$exports, "IcLock", () => $ece07e19d3bb23fe$export$445280d67fff5a51);
$parcel$export($7484f88fafffadc1$exports, "IcAlert", () => $3aec256720105e9c$export$eb2e66ed6f7f4580);
$parcel$export($7484f88fafffadc1$exports, "IcError", () => $1b5ba81d287aab3e$export$7e7b259dce3cfe53);
$parcel$export($7484f88fafffadc1$exports, "IcErrorColored", () => $87c0f97f25197d00$export$ed1619aa732c6643);
$parcel$export($7484f88fafffadc1$exports, "IcExclamation", () => $424fd8c04912da5a$export$58992a8aa3d7330d);
$parcel$export($7484f88fafffadc1$exports, "IcHelp", () => $add8a63bd690a801$export$efe9dd4bbd32421a);
$parcel$export($7484f88fafffadc1$exports, "IcInfo", () => $f2a56b92690f077c$export$556fe0871d9b7899);
$parcel$export($7484f88fafffadc1$exports, "IcMessageSend", () => $f20e5c46cb036732$export$cc2840fa1985b883);
$parcel$export($7484f88fafffadc1$exports, "IcSmileyHappy", () => $aede1794a6cdc7a9$export$f528a1ee477aaf33);
$parcel$export($7484f88fafffadc1$exports, "IcSmileyUnhappy", () => $32b7d64435ad8d7d$export$b675dff6d0b6c0c8);
$parcel$export($7484f88fafffadc1$exports, "IcStar", () => $eaaa4115f4b10cc9$export$e5c12eca07fe7b2d);
$parcel$export($7484f88fafffadc1$exports, "IcSuccess", () => $5a00847d48e39b4f$export$13b8539f4be0c);
$parcel$export($7484f88fafffadc1$exports, "IcSuccessColored", () => $dd949b1a0491130c$export$50c1b72d39add9);
$parcel$export($7484f88fafffadc1$exports, "IcWarning", () => $45f8c8717b087f21$export$ff711dd56629d4f5);
$parcel$export($7484f88fafffadc1$exports, "IcWarningColored", () => $7dab575aad091c08$export$47407925ae9f1f0e);
$parcel$export($7484f88fafffadc1$exports, "IcJioDot", () => $fc7e21f78fe2b481$export$faf9e552d710fc5c);
$parcel$export($7484f88fafffadc1$exports, "IcJioDotExclude", () => $9a08af96ef429fe7$export$b15d2693bd1dee35);
$parcel$export($7484f88fafffadc1$exports, "IcJioDotJiofinanceColoured", () => $e93a0cbebb073b75$export$3d9cd62ef287ff59);
$parcel$export($7484f88fafffadc1$exports, "IcLocation", () => $a2a7fa360d9e5b06$export$d586aed94de44e82);
$parcel$export($7484f88fafffadc1$exports, "IcLocationOff", () => $71ffb9683d52e4d1$export$8fe68ed1b5ac245c);
$parcel$export($7484f88fafffadc1$exports, "IcMap", () => $b319dcf7d3363cf8$export$af0a72b1e9c547c5);
$parcel$export($7484f88fafffadc1$exports, "IcMyLocation", () => $aeccc785c2557670$export$51e681bf0729a333);
$parcel$export($7484f88fafffadc1$exports, "IcBrokenImage", () => $2ec6e55380d31e07$export$58f9be5875231b2);
$parcel$export($7484f88fafffadc1$exports, "IcImage", () => $7a6acfb156a88414$export$4736cab3fc47e2fb);
$parcel$export($7484f88fafffadc1$exports, "IcMic", () => $ce2d37347311037b$export$c1c61a3da2c48ae4);
$parcel$export($7484f88fafffadc1$exports, "IcMicOff", () => $5ab3776403d77391$export$4f5b8d1e98c25c06);
$parcel$export($7484f88fafffadc1$exports, "IcPause", () => $5ac5f7859b261b8c$export$1eb29c5f2b0051d3);
$parcel$export($7484f88fafffadc1$exports, "IcPlay", () => $8449ed9a443d9574$export$a93378bd68e53d32);
$parcel$export($7484f88fafffadc1$exports, "IcAppSwitcher", () => $29064e5ed5e1f396$export$af0536a50732761b);
$parcel$export($7484f88fafffadc1$exports, "IcArrowBack", () => $92450cc98193c6d3$export$aed2803299c2cf67);
$parcel$export($7484f88fafffadc1$exports, "IcArrowNext", () => $d8752f0f494f2380$export$a1075cdfac2f932);
$parcel$export($7484f88fafffadc1$exports, "IcBack", () => $575ba915d2bd5d5b$export$740276c76f223dd4);
$parcel$export($7484f88fafffadc1$exports, "IcBurgerMenu", () => $fc255cc0cffe8df6$export$3bb087c30947880a);
$parcel$export($7484f88fafffadc1$exports, "IcChevronDown", () => $fdc94045ec0e5793$export$ec7db1c418c1ec5a);
$parcel$export($7484f88fafffadc1$exports, "IcChevronLeft", () => $1b63d62cdd4af45e$export$8203b8a87ae185f);
$parcel$export($7484f88fafffadc1$exports, "IcChevronRight", () => $735120fcd87dd052$export$a477256bf52ac2f7);
$parcel$export($7484f88fafffadc1$exports, "IcChevronUp", () => $9efe7828a40b52f7$export$acd925e63e14000f);
$parcel$export($7484f88fafffadc1$exports, "IcClose", () => $4b407a2b367f43e3$export$48672c81f0c3f574);
$parcel$export($7484f88fafffadc1$exports, "IcFirstpage", () => $4c01e0333386e8c5$export$885ccec48f920b92);
$parcel$export($7484f88fafffadc1$exports, "IcHome", () => $a612d6b4674022e7$export$10426ed6ef0ab637);
$parcel$export($7484f88fafffadc1$exports, "IcLastpage", () => $bc0db77fbff65188$export$1093b8f29e1cf10c);
$parcel$export($7484f88fafffadc1$exports, "IcLogin", () => $304780aca3b3a13a$export$a883bfa83ec843c8);
$parcel$export($7484f88fafffadc1$exports, "IcLogout", () => $10a623943a1be9a9$export$5c4cc728e7726d4e);
$parcel$export($7484f88fafffadc1$exports, "IcMoreHorizontal", () => $ffc7075420fce577$export$f6c2e7c657f578c5);
$parcel$export($7484f88fafffadc1$exports, "IcMoreVertical", () => $31b79cb94a7f2481$export$76eade3e6c39fefd);
$parcel$export($7484f88fafffadc1$exports, "IcNext", () => $b59efb8c56ba82c0$export$17beb55fda7072f9);
$parcel$export($7484f88fafffadc1$exports, "IcSearch", () => $52f7703976716e4f$export$6da2c307edd95198);
$parcel$export($7484f88fafffadc1$exports, "IcSettings", () => $7aed0775866c148c$export$f7d6d35bb50c6222);
$parcel$export($7484f88fafffadc1$exports, "IcProfile", () => $2f5be6df98c377a7$export$8c6932a2fedd46e4);
$parcel$export($7484f88fafffadc1$exports, "IcUser", () => $807fef1d289a1edd$export$255f0ef2dfc5eb49);

const $4c1f85da286cc021$export$27c4cbfb69a3e993 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 11h-7V4a1 1 0 00-2 0v7H4a1 1 0 000 2h7v7a1 1 0 002 0v-7h7a1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $492c3793f2565770$export$869af20d98048fdb = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zm4 11h-3v3a1 1 0 01-2 0v-3H8a1 1 0 010-2h3V8a1 1 0 012 0v3h3a1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $c785181df5f05ff0$export$a8e06849d04b5a6f = (v)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...v,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7 20H5a1 1 0 01-1-1v-2a1 1 0 10-2 0v2a3 3 0 003 3h2a1 1 0 000-2zM19 2h-2a1 1 0 100 2h2a1 1 0 011 1v2a1 1 0 002 0V5a3 3 0 00-3-3zM8 7a1 1 0 00-1 1v8a1 1 0 102 0V8a1 1 0 00-1-1zM3 8a1 1 0 001-1V5a1 1 0 011-1h2a1 1 0 000-2H5a3 3 0 00-3 3v2a1 1 0 001 1zm9-1a1 1 0 00-1 1v8a1 1 0 002 0V8a1 1 0 00-1-1zm9 9a1 1 0 00-1 1v2a1 1 0 01-1 1h-2a1 1 0 000 2h2a3 3 0 003-3v-2a1 1 0 00-1-1zm-4 0V8a1 1 0 00-2 0v8a1 1 0 002 0z",
            fill: "currentColor"
        })
    });



const $8575d8a7579bc216$export$50599049b1f53719 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 3h-1a1 1 0 00-2 0H9a1 1 0 00-2 0H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-3-3zm-4.5 14a1 1 0 01-2 0v-3.59l-.29.3a1.004 1.004 0 11-1.42-1.42l2-2a.999.999 0 011.09-.21 1 1 0 01.62.92v6zM19 7H5V6a1 1 0 011-1h1a1 1 0 002 0h6a1 1 0 002 0h1a1 1 0 011 1v1z",
            fill: "currentColor"
        })
    });



const $9317423e48146c30$export$7e1befdbe52b3f32 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 7h-.9a1 1 0 01-.84-.47l-1-1.6a2 2 0 00-1.7-.93H9.44a2 2 0 00-1.69.93l-1 1.6A1 1 0 015.9 7H5a3 3 0 00-3 3v7a3 3 0 003 3h14a3 3 0 003-3v-7a3 3 0 00-3-3zm-7 9a3 3 0 110-5.999A3 3 0 0112 16z",
            fill: "currentColor"
        })
    });



const $41afd5d0591e38b4$export$464f071bbd2cc5e5 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zm3.71 12.29a1.002 1.002 0 01-.325 1.639 1 1 0 01-1.095-.219L12 13.41l-2.29 2.3a1 1 0 01-1.639-.325 1 1 0 01.219-1.095l2.3-2.29-2.3-2.29a1.004 1.004 0 011.42-1.42l2.29 2.3 2.29-2.3a1.004 1.004 0 011.42 1.42L13.41 12l2.3 2.29z",
            fill: "currentColor"
        })
    });



const $81c2e361146d997a$export$5753b5c18d35b7d0 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M9 19a1.002 1.002 0 01-.71-.29l-5-5a1.004 1.004 0 111.42-1.42L9 16.59l10.29-10.3a1.004 1.004 0 111.42 1.42l-11 11A1 1 0 019 19z",
            fill: "currentColor"
        })
    });



const $e7017ca5d1211e2a$export$d1bc6c264a68b09f = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M13 8H5a3 3 0 00-3 3v8a3 3 0 003 3h8a3 3 0 003-3v-8a3 3 0 00-3-3zm6-6h-8a3 3 0 00-3 3v1h5a5 5 0 015 5v5h1a3 3 0 003-3V5a3 3 0 00-3-3z",
            fill: "currentColor"
        })
    });



const $60bea030b4289a81$export$bb264a5644c93858 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 20H8c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1zM16.71 10.29a.996.996 0 00-1.41 0l-2.29 2.29V4.99c0-.55-.45-1-1-1s-1 .45-1 1v7.59l-2.29-2.29a.996.996 0 10-1.41 1.41l4 4c.2.2.45.29.71.29.26 0 .51-.1.71-.29l4-4a.996.996 0 000-1.41h-.02z",
            fill: "currentColor"
        })
    });



const $a444653678cb64a6$export$7123f6ef4f453bfb = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M22 12a10 10 0 10-20 0 10 10 0 0020 0zm-10.71 4.71l-3-3a1.001 1.001 0 01.325-1.639 1 1 0 011.095.219l1.29 1.3V8a1 1 0 012 0v5.59l1.29-1.3a1.004 1.004 0 111.42 1.42l-3 3a1 1 0 01-.33.21 1 1 0 01-.76 0 1.001 1.001 0 01-.33-.21z",
            fill: "currentColor"
        })
    });



const $e784d250820e9f29$export$16866440f7f6c8dd = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M11.06 10.82l-.62.62A1.51 1.51 0 0010 12.5V14h1.5a1.51 1.51 0 001.06-.44l.62-.62 7.38-7.38a1.5 1.5 0 10-2.12-2.12l-7.38 7.38zM11.5 16H8v-3.5A3.49 3.49 0 019 10l7-7H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V8l-7 7a3.487 3.487 0 01-2.5 1z",
            fill: "currentColor"
        })
    });



const $482699419fe250fb$export$55e8bf91189d440f = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.5 4.5a3.54 3.54 0 00-5 0l-.29.29 5 5 .29-.29a3.54 3.54 0 000-5zm-13.95 9a3 3 0 00-.76 1.3l-1 3.65a1.5 1.5 0 001.81 1.81l3.65-1.05a3 3 0 001.3-.76l7.24-7.24-5-5-7.24 7.29z",
            fill: "currentColor"
        })
    });



const $29de726ee5eab1bd$export$aca4755275c34537 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M9.71 6.71L11 5.41V16a1 1 0 102 0V5.41l1.29 1.3a1 1 0 001.639-.325 1 1 0 00-.219-1.095l-3-3a1 1 0 00-1.42 0l-3 3a1.004 1.004 0 001.42 1.42zM20 12a1 1 0 00-1 1v6a1 1 0 01-1 1H6a1 1 0 01-1-1v-6a1 1 0 00-2 0v6a3 3 0 003 3h12a3 3 0 003-3v-6a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $e91f6485634b0b2d$export$cf9fe37d44aabb87 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15.6 4A5.6 5.6 0 0012 5.46 5.6 5.6 0 008.4 4 5.36 5.36 0 003 9.44c0 3.37 2.63 6.43 7.16 10.56l.49.45a2 2 0 002.7 0l.49-.44C18.37 15.86 21 12.8 21 9.44A5.36 5.36 0 0015.6 4z",
            fill: "currentColor"
        })
    });



const $a9dbc27ea69a373d$export$26f46b9510140fcc = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 11H7a1 1 0 000 2h10a1 1 0 000-2zm-3 6h-4a1 1 0 000 2h4a1 1 0 000-2zm6-12H4a1 1 0 000 2h16a1 1 0 100-2z",
            fill: "currentColor"
        })
    });



const $5dbebc00dddb0397$export$f368e7c219601d0 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.12 7.88A2.99 2.99 0 0019 7h-.9c-.17 0-.34-.05-.48-.13a.908.908 0 01-.36-.34l-1-1.6c-.19-.29-.44-.52-.73-.69-.3-.16-.64-.24-.97-.24H9.44c-.34 0-.67.08-.97.25-.29.16-.54.39-.72.68l-1 1.6c-.09.14-.22.26-.37.34-.15.09-.31.13-.48.13H5c-.8 0-1.56.31-2.13.88C2.3 8.45 2 9.2 2 10v7c0 .79.31 1.56.87 2.12.57.56 1.33.88 2.13.88h14c.79 0 1.55-.32 2.12-.88.56-.56.88-1.33.88-2.12v-7c0-.8-.32-1.56-.88-2.12zM8 16c-.26 0-.51-.1-.71-.29l-2-2A.996.996 0 116.7 12.3l.33.33c.2-2.58 2.33-4.62 4.96-4.62.39 0 .8.06 1.25.17.53.14.85.68.72 1.22-.14.54-.69.85-1.22.72a3.16 3.16 0 00-.75-.11c-1.5 0-2.73 1.1-2.95 2.54l.25-.25a.996.996 0 111.41 1.41l-2 2c-.2.2-.45.29-.71.29H8zm10.71-2.29c-.2.2-.45.29-.71.29-.26 0-.51-.1-.71-.29l-.33-.33C16.76 15.96 14.63 18 12 18c-.39 0-.8-.06-1.25-.17-.53-.14-.85-.68-.72-1.22.14-.54.68-.85 1.22-.72.29.07.52.11.75.11 1.5 0 2.73-1.1 2.95-2.54l-.25.25a.996.996 0 11-1.41-1.41l2-2a.996.996 0 011.41 0l2 2c.39.39.39 1.02 0 1.41h.01z",
            fill: "currentColor"
        })
    });



const $5bfc417138d8f1d0$export$78755581f96e0e89 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.41 9.59l-5-5a2 2 0 00-2.18-.44A2 2 0 0013 6v2S2.75 9.86 2 19.84A1.09 1.09 0 003.07 21a1.08 1.08 0 001-.78C4.68 18.39 6.67 14 13 14v2a2 2 0 001.23 1.85 2 2 0 002.18-.44l5-5a2 2 0 000-2.82z",
            fill: "currentColor"
        })
    });



const $dd63bed1b06632eb$export$bbb3e4be3b42bb9e = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm.92 13.38c-.15.37-.52.62-.92.62H9c-.55 0-1-.45-1-1v-3c0-.4.24-.77.62-.92.38-.16.8-.07 1.09.22l3 3c.29.29.37.72.22 1.09l-.01-.01zM16 12c0 .4-.24.77-.62.92a.995.995 0 01-1.09-.21l-3-3c-.29-.29-.37-.72-.22-1.09.15-.37.52-.62.92-.62h3c.55 0 1 .45 1 1v3H16z",
            fill: "currentColor"
        })
    });



const $6ecf4bf16682bccb$export$65093953efbe81ce = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-.5 14.5c0 .4-.24.77-.62.92a.995.995 0 01-1.09-.21l-3-3c-.29-.29-.37-.72-.22-1.09.15-.37.52-.62.92-.62h3c.55 0 1 .45 1 1v3h.01zm5.92-5.62c-.15.37-.52.62-.92.62h-3c-.55 0-1-.45-1-1v-3c0-.4.24-.77.62-.92.38-.16.8-.07 1.09.22l3 3c.29.29.37.72.22 1.09l-.01-.01z",
            fill: "currentColor"
        })
    });



const $a9954b6e730b1bf2$export$78b80e1f11d67211 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M11.29 16.71a1.002 1.002 0 001.42 0l3-3a1.004 1.004 0 10-1.42-1.42L13 13.59V3a1 1 0 00-2 0v10.59l-1.29-1.3a1.004 1.004 0 10-1.42 1.42l3 3zM20 12a1 1 0 00-1 1v6a1 1 0 01-1 1H6a1 1 0 01-1-1v-6a1 1 0 10-2 0v6a3 3 0 003 3h12a3 3 0 003-3v-6a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $7eac34319dc0f080$export$cbfc8e31e81d3925 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M3 11v7a2 2 0 002 2h2V9H5a2 2 0 00-2 2zm17.24-1A3 3 0 0018 9h-4V5.08a2 2 0 00-3.94-.57l-1 4A2.12 2.12 0 009 9v11h8.44a3 3 0 003-2.67l.55-5a2.999 2.999 0 00-.75-2.33z",
            fill: "currentColor"
        })
    });



const $c36840204c0c4394$export$28b4ffe30999880e = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zm4 11H8a1 1 0 010-2h8a1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $c15dabd2350ae6f1$export$a112cdf9589f07b2 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M3.293 11.293A1 1 0 014 11h16a1 1 0 010 2H4a1 1 0 01-.707-1.707z",
            fill: "currentColor"
        })
    });



const $22260c4a50157a1d$export$c69b4469075788f4 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21 16h-1v-6a8 8 0 00-16 0v6H3a1 1 0 000 2h18a1 1 0 000-2zm-9 6a3 3 0 003-3H9a3 3 0 003 3z",
            fill: "currentColor"
        })
    });



const $dffc3e9b8ee65686$export$184395fb225b1980 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a8 8 0 00-8 8v5.76L16.42 3.34A7.89 7.89 0 0012 2zm9 14h-1v-6a8.001 8.001 0 00-.89-3.66L20.49 5a1.055 1.055 0 00-.745-1.799A1.053 1.053 0 0019 3.51L3.51 19A1.055 1.055 0 005 20.49L7.44 18H21a1 1 0 100-2zm-9 6a3 3 0 003-3H9a3 3 0 003 3z",
            fill: "currentColor"
        })
    });



const $2a74a59a4eabdf30$export$8d8d10bea6cba17d = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 11a1 1 0 00-1 1v6a1 1 0 01-1 1H6a1 1 0 01-1-1V6a1 1 0 011-1h6a1 1 0 100-2H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3v-6a1 1 0 00-1-1zm.92-7.38a1 1 0 00-.54-.54A1 1 0 0020 3h-4a1 1 0 100 2h1.59l-6.3 6.29a1.002 1.002 0 00.325 1.639 1 1 0 001.095-.219L19 6.41V8a1 1 0 002 0V4a1.001 1.001 0 00-.08-.38z",
            fill: "currentColor"
        })
    });



const $e6603180443fef86$export$3ff4a916a5aef516 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 2h-8a3 3 0 00-3 3v3H5a3 3 0 00-3 3v8a3 3 0 003 3h8a3 3 0 003-3v-3h3a3 3 0 003-3V5a3 3 0 00-3-3zm1 11a1 1 0 01-1 1h-3v-3a3 3 0 00-3-3h-3V5a1 1 0 011-1h8a1 1 0 011 1v8z",
            fill: "currentColor"
        })
    });



const $3d7d7f73cd2510e3$export$b085f0ec027ff450 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7 15H5c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h2c1.1 0 2-.9 2-2v-2c0-1.1-.9-2-2-2zm5-6c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1s-1 .45-1 1v4c0 .55.45 1 1 1zm7-6h-2c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h2c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5 9h2c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2zm14 2h-2c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h2c1.1 0 2-.9 2-2v-2c0-1.1-.9-2-2-2zm1 8h-7v-6c0-1.1-.9-2-2-2H4c-.55 0-1 .45-1 1s.45 1 1 1h7v6c0 1.1.9 2 2 2h7c.55 0 1-.45 1-1s-.45-1-1-1z",
            fill: "currentColor"
        })
    });



const $e6d412d90124b081$export$d8f8141123df49e9 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M2.59 9.59l5-5a2 2 0 012.18-.44A2 2 0 0111 6v2s10.25 1.86 11 11.84A1.09 1.09 0 0120.93 21a1.08 1.08 0 01-1-.78C19.32 18.39 17.33 14 11 14v2a2 2 0 01-1.23 1.85 2 2 0 01-2.18-.44l-5-5a2 2 0 010-2.82z",
            fill: "currentColor"
        })
    });



const $3ef05a732320915e$export$ee5a0a2b44c8bf7b = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M11 9V7a2 2 0 00-1.23-1.85 2 2 0 00-2.18.44l-5 5a2 2 0 000 2.82l5 5a2 2 0 002.18.44A2 2 0 0011 17v-2c6.33 0 8.32 4.39 8.85 6.22a1.08 1.08 0 001 .78A1.09 1.09 0 0022 20.84C21.25 10.86 11 9 11 9zm2-2v.44a16.37 16.37 0 019 6.81v-.14c-.57-7.63-8.41-9-8.41-9V3.53A1.53 1.53 0 0011 2.45l-.76.76c.1 0 .21 0 .31.09A4 4 0 0113 7z",
            fill: "currentColor"
        })
    });



const $e85b4fcc36284356$export$b8634ccdc50979ab = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M6 7v2a1 1 0 001 1h2a1 1 0 001-1V7a1 1 0 00-1-1H7a1 1 0 00-1 1zM3 8a1 1 0 001-1V5a1 1 0 011-1h2a1 1 0 000-2H5a3 3 0 00-3 3v2a1 1 0 001 1zm9 2a1 1 0 001-1V7a1 1 0 00-2 0v2a1 1 0 001 1zm3 5h2a1 1 0 001-1v-2a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zm0-5h2a1 1 0 001-1V7a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zm6 6a1 1 0 00-1 1v2a1 1 0 01-1 1h-2a1 1 0 000 2h2a3 3 0 003-3v-2a1 1 0 00-1-1zM19 2h-2a1 1 0 100 2h2a1 1 0 011 1v2a1 1 0 002 0V5a3 3 0 00-3-3zm-1 15a1 1 0 00-1-1h-4v-4a1 1 0 00-1-1H7a1 1 0 000 2h4v4a1 1 0 001 1h5a1 1 0 001-1zm-9-3H7a1 1 0 00-1 1v2a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 00-1-1zm-2 6H5a1 1 0 01-1-1v-2a1 1 0 10-2 0v2a3 3 0 003 3h2a1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $5f9a066e7f58c8de$export$ea9aaa46ca2083e7 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.79 10.16l-14-6A2 2 0 005 4a2 2 0 00-1.965 2.398 2 2 0 00.355.792L6.76 12l-3.35 4.79a2 2 0 002.38 3.05l14-6a2 2 0 000-3.68z",
            fill: "currentColor"
        })
    });



const $fa655b85abce0796$export$d7bcdec678388771 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 15a3 3 0 00-2.15.91L8 12.27c.005-.09.005-.18 0-.27.005-.09.005-.18 0-.27l7.88-3.64A3 3 0 1015 6c-.005.09-.005.18 0 .27L7.15 9.91a3 3 0 100 4.18L15 17.73c-.005.09-.005.18 0 .27a3 3 0 103-3z",
            fill: "currentColor"
        })
    });



const $c07aaad5de81ca37$export$d802d08b192014d8 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10.29 14.29L8 16.59V6a1 1 0 00-2 0v10.59l-2.29-2.3a1.004 1.004 0 00-1.42 1.42l4 4a.998.998 0 001.42 0l4-4a1 1 0 000-1.42 1.002 1.002 0 00-1.42 0zm11.42-6l-4-4a1 1 0 00-1.42 0l-4 4a1 1 0 00.326 1.639 1 1 0 001.094-.22L16 7.41V18a1 1 0 102 0V7.41l2.29 2.3a1.004 1.004 0 001.42-1.42z",
            fill: "currentColor"
        })
    });



const $3f6fa4229d34bf2e$export$7d8d98dd3a766908 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M9 12a1.002 1.002 0 001.006-1 1 1 0 00-.296-.71L7.41 8H18a1 1 0 100-2H7.41l2.3-2.29a1.004 1.004 0 10-1.42-1.42l-4 4a1 1 0 000 1.42l4 4A1 1 0 009 12zm10.71 4.29l-4-4a1 1 0 00-1.42 0 1 1 0 000 1.42l2.3 2.29H6a1 1 0 100 2h10.59l-2.3 2.29a1.004 1.004 0 101.42 1.42l4-4a.999.999 0 000-1.42z",
            fill: "currentColor"
        })
    });



const $b0cb2302c39973bb$export$af82b8856b912f54 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M22 10.53l-.7-5.24a3 3 0 00-2.59-2.59L13.47 2a3 3 0 00-2.5.86L2.88 11a3 3 0 000 4.24l5.91 5.91a3 3 0 004.24 0L21.12 13a3.052 3.052 0 00.88-2.47zM16.5 9a1.5 1.5 0 110-3 1.5 1.5 0 010 3z",
            fill: "currentColor"
        })
    });



const $8c66bf8a36364e42$export$7f3df200d95b839b = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zm1 11a1 1 0 01-1 1H9a1 1 0 010-2h2V9a1 1 0 012 0v4z",
            fill: "currentColor"
        })
    });



const $80b96fbfbd3172e6$export$f4fff73cae16f2b9 = (v)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...v,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 6h-2V5a3 3 0 00-3-3H9a3 3 0 00-3 3v1H4a1 1 0 000 2h1v11a3 3 0 003 3h8a3 3 0 003-3V8h1a1 1 0 100-2zM9 18a1 1 0 11-2 0v-7a1 1 0 112 0v7zm4 0a1 1 0 01-2 0v-7a1 1 0 012 0v7zm4 0a1 1 0 01-2 0v-7a1 1 0 012 0v7zM8 5a1 1 0 011-1h6a1 1 0 011 1v1H8V5z",
            fill: "currentColor"
        })
    });



const $170225ee6a03579c$export$7a525547346e73a = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7.71 8.71L11 5.41V17a1 1 0 102 0V5.41l3.29 3.3a.999.999 0 001.42 0 1.001 1.001 0 000-1.42l-5-5a1 1 0 00-1.42 0l-5 5a1.004 1.004 0 101.42 1.42zM17 20H7a1 1 0 000 2h10a1 1 0 100-2z",
            fill: "currentColor"
        })
    });



const $137d0dfc17372d44$export$904ccf4b059cd9b2 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 9h-1a1 1 0 100 2h1a1 1 0 011 1v7a1 1 0 01-1 1H7a1 1 0 01-1-1v-7a1 1 0 011-1h1a1 1 0 100-2H7a3 3 0 00-3 3v7a3 3 0 003 3h10a3 3 0 003-3v-7a3 3 0 00-3-3zM9.71 6.71L11 5.41V16a1 1 0 102 0V5.41l1.29 1.3a1 1 0 001.639-.325 1 1 0 00-.219-1.095l-3-3a1 1 0 00-1.42 0l-3 3a1.004 1.004 0 001.42 1.42z",
            fill: "currentColor"
        })
    });



const $9a1d7adf13d086c8$export$6a26d7605291833e = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M2 12a10 10 0 1020 0 10 10 0 00-20 0zm10.71-4.71l3 3a1.002 1.002 0 01-.325 1.639 1 1 0 01-1.095-.219L13 10.41V16a1 1 0 01-2 0v-5.59l-1.29 1.3a1.004 1.004 0 11-1.42-1.42l3-3a1 1 0 01.33-.21 1 1 0 01.76 0 1 1 0 01.33.21z",
            fill: "currentColor"
        })
    });



const $35aa9dff24458a00$export$fd7adc84612ab6c3 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.69 10.74A10.87 10.87 0 0012 5a10.87 10.87 0 00-9.69 5.74 2.74 2.74 0 000 2.52A10.87 10.87 0 0012 19a10.87 10.87 0 009.69-5.74 2.74 2.74 0 000-2.52zm-9.1 4.2a3 3 0 11-1.183-5.881 3 3 0 011.183 5.881z",
            fill: "currentColor"
        })
    });



const $1158e373884bc031$export$2deae51be13efc65 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.69 10.74A10.539 10.539 0 0018.41 7l-3.7 3.69a3 3 0 01-4 4L20.49 5a1.052 1.052 0 00-.342-1.719A1.053 1.053 0 0019 3.51L3.51 19a1.052 1.052 0 001.148 1.718c.128-.053.244-.13.342-.228L7.42 18c1.439.652 3 .993 4.58 1a10.87 10.87 0 009.69-5.74 2.74 2.74 0 000-2.52zm-7.23-5.45A11 11 0 0012 5a10.87 10.87 0 00-9.69 5.74 2.74 2.74 0 000 2.52c.469.889 1.061 1.707 1.76 2.43l10.39-10.4z",
            fill: "currentColor"
        })
    });



const $d736a2a789a742e1$export$d4c35c8bf2c76a77 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 5H4a2 2 0 00-2 2v2h20V7a2 2 0 00-2-2zM2 17a2 2 0 002 2h16a2 2 0 002-2v-6H2v6zm3-2h3a1 1 0 010 2H5a1 1 0 010-2z",
            fill: "currentColor"
        })
    });



const $e2e2422c14c24c30$export$c7056e444d073e5f = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M8.5 19a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm9 0a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm4.12-12.17A2 2 0 0020 6H6.58l-.41-1.52A2 2 0 004.23 3H3a1 1 0 000 2h1.23l2.83 10.48A2 2 0 009 17h8.67a2 2 0 001.89-1.37l2.34-7a2 2 0 00-.28-1.8z",
            fill: "currentColor"
        })
    });



const $b69b9808a49ff611$export$626a5c1c628bf04f = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 5H4a2 2 0 00-2 2v2h20V7a2 2 0 00-2-2zM2 17a2 2 0 002 2h16a2 2 0 002-2v-6H2v6zm17-4a1 1 0 110 2 1 1 0 010-2zm-3 0a1 1 0 110 2 1 1 0 010-2zm-3 0a1 1 0 110 2 1 1 0 010-2z",
            fill: "currentColor"
        })
    });



const $86b1b79c3c2f8f62$export$ba660c68f7598614 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M22 12c0 5.523-4.477 10-10 10-4.478 0-8.268-2.943-9.542-7H6a1 1 0 100-2H2.05a10.118 10.118 0 010-2H14a1 1 0 100-2H2.458c.22-.703.517-1.373.88-2H11a1 1 0 100-2H4.859A9.97 9.97 0 0112 2c5.523 0 10 4.477 10 10z",
            fill: "currentColor"
        })
    });



const $887f7325e59b5272$export$39cc7d72735656c0 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 8h-2.1c-.15-.74-.47-1.42-.91-2H17c.55 0 1-.45 1-1s-.45-1-1-1H7c-.55 0-1 .45-1 1s.45 1 1 1h3a3 3 0 012.82 2H7c-.55 0-1 .45-1 1s.45 1 1 1h5.83a3.001 3.001 0 01-2.81 2H7s-.07 0-.11.01h-.05c-.05 0-.09.02-.14.03-.02 0-.03 0-.05.01-.04.02-.09.04-.13.06-.02 0-.03.02-.05.03-.04.02-.08.05-.11.08-.02.01-.03.02-.05.04l-.1.1c0 .01-.02.02-.03.03v.01c-.03.04-.05.08-.07.12l-.03.06c-.01.03-.03.07-.04.1 0 .03-.02.06-.03.09 0 .03 0 .05-.01.08 0 .04-.01.08-.01.12v.07c0 .04 0 .09.01.13 0 .02.01.04.02.06.01.04.02.08.04.13 0 .02.02.04.02.05.02.04.04.08.07.12 0 .01.02.03.03.04.03.04.06.08.09.11.01.01.02.02.04.03.03.02.05.05.08.07l8 6c.18.14.39.2.6.2.3 0 .6-.14.8-.4.33-.44.24-1.07-.2-1.4l-5.6-4.2c2.41 0 4.43-1.72 4.9-4h2.1c.55 0 1-.45 1-1s-.45-1-1-1L17 8z",
            fill: "currentColor"
        })
    });



const $90bdcbe23c465361$export$300912d25f93283a = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zm4 8a1 1 0 010 2h-1.14a4 4 0 01-2.61 2.78l2.26 1.36a1 1 0 01-1.02 1.72l-5-3s-.06-.06-.09-.08a.67.67 0 01-.15-.14l-.11-.15a1 1 0 01-.08-.18 1.18 1.18 0 010-.2L8 14v-.07a1.29 1.29 0 010-.19c.017-.065.04-.129.07-.19v-.06c0-.06.06-.06.08-.09a.91.91 0 01.3-.26l.16-.08h.21L9 13h2a2 2 0 001.72-1H8a1 1 0 010-2h4.72A2 2 0 0011 9H8a1 1 0 010-2h8a1 1 0 110 2h-1.56c.187.312.328.649.42 1H16z",
            fill: "currentColor"
        })
    });



const $ece07e19d3bb23fe$export$445280d67fff5a51 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 7h-1V6a4 4 0 10-8 0v1H7a3 3 0 00-3 3v9a3 3 0 003 3h10a3 3 0 003-3v-9a3 3 0 00-3-3zm-5 9a2 2 0 110-4 2 2 0 010 4zm2-9h-4V6a2 2 0 114 0v1z",
            fill: "currentColor"
        })
    });



const $3aec256720105e9c$export$eb2e66ed6f7f4580 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.74 18l-8-14a2 2 0 00-3.48 0l-8 14A2 2 0 004 21h16a2 2 0 001.74-3zM11 7a1 1 0 012 0v6a1 1 0 11-2 0V7zm1 12a1.5 1.5 0 110-2.999 1.5 1.5 0 010 3z",
            fill: "currentColor"
        })
    });



const $1b5ba81d287aab3e$export$7e7b259dce3cfe53 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zm3.71 12.29a1.002 1.002 0 01-.325 1.639 1 1 0 01-1.095-.219L12 13.41l-2.29 2.3a1 1 0 01-1.639-.325 1 1 0 01.219-1.095l2.3-2.29-2.3-2.29a1.004 1.004 0 011.42-1.42l2.29 2.3 2.29-2.3a1.004 1.004 0 011.42 1.42L13.41 12l2.3 2.29z",
            fill: "currentColor"
        })
    });



const $87c0f97f25197d00$export$ed1619aa732c6643 = (i)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...i,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: 12,
                cy: 12,
                r: 10,
                fill: "#fff"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 2a10 10 0 100 20 10 10 0 000-20zm3.71 12.29a1.002 1.002 0 01-.325 1.639 1 1 0 01-1.095-.219L12 13.41l-2.29 2.3a1 1 0 01-1.639-.325 1 1 0 01.219-1.095l2.3-2.29-2.3-2.29a1.004 1.004 0 011.42-1.42l2.29 2.3 2.29-2.3a1.004 1.004 0 011.42 1.42L13.41 12l2.3 2.29z",
                fill: "#F50031"
            })
        ]
    });



const $424fd8c04912da5a$export$58992a8aa3d7330d = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 17a1 1 0 001-1V3a1 1 0 00-2 0v13a1 1 0 001 1zm0 2a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
            fill: "currentColor"
        })
    });



const $add8a63bd690a801$export$efe9dd4bbd32421a = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12.095 1.617c-5.79 0-10.5 4.71-10.5 10.5s4.71 10.5 10.5 10.5 10.5-4.71 10.5-10.5-4.71-10.5-10.5-10.5zm.685 14.378a.73.73 0 01-.723.732h-.055a.728.728 0 01-.722-.732v-.035a.73.73 0 01.722-.733h.055c.398 0 .723.328.723.733v.035zm1.28-4.213c-.34.38-.748.705-1.04 1.125-.153.22-.163.185-.258.443-.077.21-.03.5-.14.705-.177.33-.545.427-.895.28-.41-.175-.472-.588-.445-.985.03-.453.1-.645.325-1.048.215-.382.533-.69.835-1 .51-.522 1.28-1.435.448-2.067-.733-.558-1.728-.145-1.925.715-.09.392-.22.732-.613.862-.292.098-.605.028-.787-.222-.48-.658.137-1.835.625-2.32 1.247-1.243 3.74-.938 4.415.767l-.008-.017c-.017-.04-.025-.065-.027-.073.002.01.015.04.027.073l.008.017.032.085c-.005-.012-.017-.047-.032-.082.395.987.147 1.97-.545 2.742z",
            fill: "currentColor"
        })
    });



const $f2a56b92690f077c$export$556fe0871d9b7899 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zm0 3.5a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm2 12h-4a1 1 0 010-2h1v-3h-1a1 1 0 010-2h2a1 1 0 011 1v4h1a1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $f20e5c46cb036732$export$cc2840fa1985b883 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M9 19a1.002 1.002 0 01-.71-.29l-5-5a1.004 1.004 0 111.42-1.42L9 16.59l10.29-10.3a1.004 1.004 0 111.42 1.42l-11 11A1 1 0 019 19z",
            fill: "currentColor"
        })
    });



const $aede1794a6cdc7a9$export$f528a1ee477aaf33 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zm3.5 6a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm-7 0a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm8.58 7.16a5.77 5.77 0 01-.78 1 .472.472 0 01-.06.09 5.617 5.617 0 01-.7.59 5.769 5.769 0 01-1.95.94h-.16a4.515 4.515 0 01-.53.11H11.12a4.515 4.515 0 01-.53-.11h-.16a5.769 5.769 0 01-1.95-.94 5.614 5.614 0 01-.7-.59.47.47 0 01-.06-.09 5.771 5.771 0 01-.78-1 1 1 0 111.67-1.06c.183.292.401.561.65.8.149.14.31.268.48.38l.1.07a4.14 4.14 0 004.32 0l.1-.07c.17-.112.332-.24.48-.38a4.21 4.21 0 00.65-.8 1 1 0 111.69 1.06z",
            fill: "currentColor"
        })
    });



const $32b7d64435ad8d7d$export$b675dff6d0b6c0c8 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zm3.5 6a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm-7 0a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm8.26 8.85a1 1 0 01-1.37-.32 4 4 0 00-6.78 0 1 1 0 11-1.69-1.06 6 6 0 0110.16 0 1.002 1.002 0 01-.32 1.38z",
            fill: "currentColor"
        })
    });



const $eaaa4115f4b10cc9$export$e5c12eca07fe7b2d = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.37 9.61a1.964 1.964 0 00-.58-.856 1.896 1.896 0 00-.94-.428l-4.235-.646-1.899-4.087a1.963 1.963 0 00-.702-.798 1.917 1.917 0 00-1.016-.295c-.361 0-.712.105-1.016.295a1.85 1.85 0 00-.703.798L8.38 7.68l-4.273.646c-.342.057-.674.2-.94.428a1.964 1.964 0 00-.58.855 1.91 1.91 0 00.447 1.901l3.124 3.213-.74 4.553c-.058.351-.01.712.123 1.036.133.323.36.608.655.817.313.238.703.37 1.102.38.332 0 .655-.076.95-.237l3.788-2.091 3.788 2.09c.285.162.618.248.95.238a1.9 1.9 0 001.101-.351c.285-.21.513-.485.655-.818.133-.323.181-.684.124-1.036l-.74-4.552 3.123-3.213c.228-.257.37-.58.437-.922a1.91 1.91 0 00-.104-1.008z",
            fill: "currentColor"
        })
    });



const $5a00847d48e39b4f$export$13b8539f4be0c = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zm5.21 7.71l-6 6a1.002 1.002 0 01-1.42 0l-3-3a1.003 1.003 0 111.42-1.42l2.29 2.3 5.29-5.3a1.004 1.004 0 011.42 1.42z",
            fill: "currentColor"
        })
    });



const $dd949b1a0491130c$export$50c1b72d39add9 = (i)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...i,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: 12,
                cy: 12,
                r: 10,
                fill: "#fff"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 2a10 10 0 100 20 10 10 0 000-20zm5.21 7.71l-6 6a1.002 1.002 0 01-1.42 0l-3-3a1.003 1.003 0 111.42-1.42l2.29 2.3 5.29-5.3a1.004 1.004 0 011.42 1.42z",
                fill: "#25AB21"
            })
        ]
    });



const $45f8c8717b087f21$export$ff711dd56629d4f5 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zm-1 4.5a1 1 0 012 0v6a1 1 0 01-2 0v-6zm1 12a1.5 1.5 0 110-3 1.5 1.5 0 010 3z",
            fill: "currentColor"
        })
    });



const $7dab575aad091c08$export$47407925ae9f1f0e = (i)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...i,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: 12,
                cy: 12,
                r: 10,
                fill: "#fff"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 2a10 10 0 100 20 10 10 0 000-20zm-1 4.5a1 1 0 012 0v6a1 1 0 01-2 0v-6zm1 12a1.5 1.5 0 110-3 1.5 1.5 0 010 3z",
                fill: "#F06D0F"
            })
        ]
    });



const $fc7e21f78fe2b481$export$faf9e552d710fc5c = (l)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: [
            (0, $7b02d682eb115277$exports.jsxs)("g", {
                clipPath: "url(#ic_jio_dot_svg__clip0_5207_79934)",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("rect", {
                        width: 24,
                        height: 24,
                        rx: 12,
                        fill: "#3535F3"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M8.478 7.237h-.4c-.76 0-1.174.428-1.174 1.285v4.129c0 1.063-.359 1.436-1.201 1.436-.663 0-1.202-.29-1.63-.815-.041-.055-.91.36-.91 1.381 0 1.105 1.034 1.782 2.955 1.782 2.333 0 3.563-1.174 3.563-3.742V8.521c-.002-.856-.416-1.285-1.203-1.285zm9.3 2.017c-2.265 0-3.77 1.436-3.77 3.577 0 2.196 1.45 3.605 3.728 3.605 2.265 0 3.756-1.409 3.756-3.59.001-2.156-1.477-3.592-3.714-3.592zm-.028 5.15c-.884 0-1.491-.648-1.491-1.574 0-.91.622-1.56 1.491-1.56.87 0 1.491.65 1.491 1.574 0 .898-.634 1.56-1.49 1.56zm-5.656-5.082h-.277c-.676 0-1.187.318-1.187 1.285v4.419c0 .98.497 1.285 1.215 1.285h.277c.676 0 1.16-.332 1.16-1.285v-4.42c0-.993-.47-1.284-1.188-1.284zm-.152-3.203c-.856 0-1.395.484-1.395 1.243 0 .773.553 1.256 1.436 1.256.857 0 1.395-.483 1.395-1.256s-.552-1.243-1.436-1.243z",
                        fill: "#fff"
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsx)("defs", {
                children: (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                    id: "ic_jio_dot_svg__clip0_5207_79934",
                    children: (0, $7b02d682eb115277$exports.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h24v24H0z"
                    })
                })
            })
        ]
    });



const $9a08af96ef429fe7$export$b15d2693bd1dee35 = (i)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...i,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("g", {
                clipPath: "url(#ic_jio_dot_exclude_svg__clip0_7826_127526)",
                children: (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M12 0C5.372 0 0 5.373 0 12s5.372 12 12 12 12-5.372 12-12S18.627 0 12 0zM9.68 12.693c0 2.568-1.23 3.742-3.564 3.742-1.92 0-2.955-.677-2.955-1.781 0-1.023.87-1.437.91-1.382.429.525.967.815 1.63.815.843 0 1.202-.373 1.202-1.436v-4.13c0-.855.414-1.284 1.173-1.284h.4c.788 0 1.202.429 1.202 1.285l.001 4.17zm3.601 2.333c0 .953-.483 1.285-1.16 1.285h-.277c-.718 0-1.215-.304-1.215-1.285v-4.418c0-.968.511-1.285 1.187-1.285h.277c.718 0 1.187.29 1.187 1.285l.001 4.418zm-1.298-6.407c-.883 0-1.436-.484-1.436-1.257 0-.76.539-1.243 1.395-1.243.884 0 1.436.47 1.436 1.243 0 .774-.538 1.257-1.395 1.257zm5.753 7.816c-2.279 0-3.728-1.409-3.728-3.605 0-2.14 1.505-3.576 3.77-3.576 2.237 0 3.715 1.436 3.715 3.59 0 2.182-1.493 3.591-3.757 3.591zm.014-5.165c-.87 0-1.491.65-1.491 1.56 0 .926.607 1.575 1.491 1.575.856 0 1.492-.663 1.492-1.56 0-.926-.622-1.575-1.492-1.575z",
                    fill: "#3535F3"
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)("defs", {
                children: (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                    id: "ic_jio_dot_exclude_svg__clip0_7826_127526",
                    children: (0, $7b02d682eb115277$exports.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h24v24H0z"
                    })
                })
            })
        ]
    });



const $e93a0cbebb073b75$export$3d9cd62ef287ff59 = (_)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ..._,
        children: [
            (0, $7b02d682eb115277$exports.jsxs)("g", {
                clipPath: "url(#ic_jio_dot_jiofinance_coloured_svg__clip0_51184_147799)",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("rect", {
                        width: 24,
                        height: 24,
                        rx: 12,
                        fill: "url(#ic_jio_dot_jiofinance_coloured_svg__paint0_linear_51184_147799)"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M8.478 7.237h-.4c-.76 0-1.174.428-1.174 1.285v4.129c0 1.063-.359 1.436-1.201 1.436-.663 0-1.202-.29-1.63-.815-.041-.055-.91.36-.91 1.381 0 1.105 1.034 1.782 2.955 1.782 2.333 0 3.563-1.174 3.563-3.742V8.521c-.002-.856-.416-1.285-1.203-1.285zm9.3 2.017c-2.265 0-3.77 1.436-3.77 3.577 0 2.196 1.45 3.605 3.728 3.605 2.265 0 3.756-1.409 3.756-3.59.001-2.156-1.477-3.592-3.714-3.592zm-.028 5.15c-.884 0-1.491-.648-1.491-1.574 0-.91.622-1.56 1.491-1.56.87 0 1.491.65 1.491 1.574 0 .898-.634 1.56-1.49 1.56zm-5.656-5.082h-.277c-.676 0-1.187.318-1.187 1.285v4.419c0 .98.497 1.285 1.215 1.285h.277c.676 0 1.16-.332 1.16-1.285v-4.42c0-.993-.47-1.284-1.188-1.284zm-.152-3.203c-.856 0-1.395.484-1.395 1.243 0 .773.553 1.256 1.436 1.256.857 0 1.395-.483 1.395-1.256s-.552-1.243-1.436-1.243z",
                        fill: "#fff"
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsxs)("defs", {
                children: [
                    (0, $7b02d682eb115277$exports.jsxs)("linearGradient", {
                        id: "ic_jio_dot_jiofinance_coloured_svg__paint0_linear_51184_147799",
                        x1: .045,
                        y1: .045,
                        x2: 24.027,
                        y2: 24.027,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)("stop", {
                                offset: .08,
                                stopColor: "#F3B561"
                            }),
                            (0, $7b02d682eb115277$exports.jsx)("stop", {
                                offset: .45,
                                stopColor: "#F6C586"
                            }),
                            (0, $7b02d682eb115277$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#C78724"
                            })
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                        id: "ic_jio_dot_jiofinance_coloured_svg__clip0_51184_147799",
                        children: (0, $7b02d682eb115277$exports.jsx)("path", {
                            fill: "#fff",
                            d: "M0 0h24v24H0z"
                        })
                    })
                ]
            })
        ]
    });



const $a2a7fa360d9e5b06$export$d586aed94de44e82 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a7.82 7.82 0 00-8 7.6c0 5.08 5.91 11.14 6.59 11.81a2 2 0 002.82 0C14.09 20.74 20 14.68 20 9.6A7.82 7.82 0 0012 2zm0 11a3 3 0 110-6 3 3 0 010 6z",
            fill: "currentColor"
        })
    });



const $71ffb9683d52e4d1$export$8fe68ed1b5ac245c = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.49 3.51a1.001 1.001 0 00-1.45 0L3.51 19A1.054 1.054 0 105 20.49l2.6-2.61a33.48 33.48 0 003 3.53 2 2 0 002.82 0C14.09 20.74 20 14.68 20 9.6c-.001-1.16-.282-2.302-.82-3.33L20.49 5a1.001 1.001 0 000-1.49zM9.08 10.67A2.93 2.93 0 019 10a3 3 0 013-3c.225.001.45.028.67.08l3.79-3.78A8.21 8.21 0 0012 2a7.82 7.82 0 00-8 7.6 10.84 10.84 0 001.36 4.79l3.72-3.72z",
            fill: "currentColor"
        })
    });



const $b319dcf7d3363cf8$export$af0a72b1e9c547c5 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M2 4.91v8.71a3 3 0 001 2.28L7.81 20c.202.17.437.295.69.37V6.64L4.37 3.69A1.5 1.5 0 002 4.91zm19.12 3.21l-4-4a2.069 2.069 0 00-.58-.4V16.5l2.94 2.94A1.5 1.5 0 0022 18.38v-8.14a3 3 0 00-.88-2.12zM9.5 6.71V20.4c.277-.043.54-.15.77-.31l5.23-3.73V3.52a2.08 2.08 0 00-.83.24L9.5 6.71z",
            fill: "currentColor"
        })
    });



const $aeccc785c2557670$export$51e681bf0729a333 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.32 2.17L3.14 9.29a1.9 1.9 0 00.62 3.64l6.77.54.54 6.77a1.9 1.9 0 003.64.62l7.12-16.18a1.9 1.9 0 00-2.51-2.51z",
            fill: "currentColor"
        })
    });



const $2ec6e55380d31e07$export$58f9be5875231b2 = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M6 9.5c0 .83.67 1.5 1.5 1.5S9 10.33 9 9.5 8.33 8 7.5 8 6 8.67 6 9.5zM19 4h-5.4l-2.31 2h7.7c.55 0 1 .45 1 1v6.7l-3.83-3.45c-.38-.34-.96-.34-1.34 0l-2.01 1.83.54.9a1 1 0 01-.22 1.28l-2.08 1.73 2.08 1.73c.23.19.36.47.36.77 0 .3-.13.58-.36.77l-.88.73h6.74c1.65 0 3-1.35 3-3V7c0-1.65-1.35-3-3-3H19zM8.5 16c0-.3.13-.58.36-.77l.85-.71-1.57-1.3c-.38-.31-.93-.3-1.3.02L4 15.76V7c0-.55.45-1 1-1h3.24l2.31-2H5C3.35 4 2 5.35 2 7v10c0 1.65 1.35 3 3 3h4.14l1.8-1.5-2.08-1.73A.992.992 0 018.5 16z",
            fill: "currentColor"
        })
    });



const $7a6acfb156a88414$export$4736cab3fc47e2fb = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M8.5 7a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM18 3H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-3-3zm1 9.09l-2.79-2.8a1 1 0 00-1.42 0l-4.29 4.3-1.29-1.3a1 1 0 00-1.42 0L5 15.09V6a1 1 0 011-1h12a1 1 0 011 1v6.09z",
            fill: "currentColor"
        })
    });



const $ce2d37347311037b$export$c1c61a3da2c48ae4 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 15a3 3 0 003-3V5a3 3 0 00-6 0v7a3 3 0 003 3zm6-5a1 1 0 00-1 1v1a5 5 0 11-10 0v-1a1 1 0 10-2 0v1a7 7 0 1014 0v-1a1 1 0 00-1-1zm-3 10H9a1 1 0 000 2h6a1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $5ab3776403d77391$export$4f5b8d1e98c25c06 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7.07 12.69A5.2 5.2 0 017 12v-1a1 1 0 10-2 0v1a7 7 0 00.41 2.34l1.66-1.65zM12 2a3 3 0 00-3 3v5.76l6-6A3 3 0 0012 2zm3 18H9a1 1 0 000 2h6a1 1 0 100-2zm-3-5a3 3 0 003-3v-1.56L20.49 5a1.055 1.055 0 00-.745-1.799A1.053 1.053 0 0019 3.51L3.51 19A1.055 1.055 0 005 20.49l2.87-2.88A7 7 0 0019 12v-1a1 1 0 00-2 0v1a5 5 0 01-7.73 4.18l1.46-1.47A3 3 0 0012 15z",
            fill: "currentColor"
        })
    });



const $5ac5f7859b261b8c$export$1eb29c5f2b0051d3 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M8.5 4A1.5 1.5 0 007 5.5v13a1.5 1.5 0 003 0v-13A1.5 1.5 0 008.5 4zm7 0A1.5 1.5 0 0014 5.5v13a1.5 1.5 0 103 0v-13A1.5 1.5 0 0015.5 4z",
            fill: "currentColor"
        })
    });



const $8449ed9a443d9574$export$a93378bd68e53d32 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.15 10.36l-10-7A2 2 0 008 3a1.88 1.88 0 00-.92.23A2 2 0 006 5v14a2 2 0 001.08 1.77c.282.154.599.233.92.23a2 2 0 001.15-.36l10-7a2 2 0 000-3.28z",
            fill: "currentColor"
        })
    });



const $29064e5ed5e1f396$export$af0536a50732761b = (s)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...s,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 3c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm7 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5 3c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm7 7c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm7 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM5 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm7 7c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm7 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM5 17c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z",
            fill: "currentColor"
        })
    });



const $92450cc98193c6d3$export$aed2803299c2cf67 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M2.29 12.71l6 6a1.004 1.004 0 101.42-1.42L5.41 13H21a1 1 0 100-2H5.41l4.3-4.29a1 1 0 000-1.42 1 1 0 00-1.42 0l-6 6a1 1 0 000 1.42z",
            fill: "currentColor"
        })
    });



const $d8752f0f494f2380$export$a1075cdfac2f932 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.71 11.29l-6-6a1.004 1.004 0 10-1.42 1.42l4.3 4.29H3a1 1 0 100 2h15.59l-4.3 4.29a1 1 0 000 1.42 1.002 1.002 0 001.42 0l6-6a1.002 1.002 0 000-1.42z",
            fill: "currentColor"
        })
    });



const $575ba915d2bd5d5b$export$740276c76f223dd4 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15 20a1.003 1.003 0 01-.71-.29l-7-7a1 1 0 010-1.42l7-7a1.005 1.005 0 011.42 1.42L9.41 12l6.3 6.29a.997.997 0 01.219 1.095.999.999 0 01-.93.615z",
            fill: "currentColor"
        })
    });



const $fc255cc0cffe8df6$export$3bb087c30947880a = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4 7h16a1 1 0 100-2H4a1 1 0 000 2zm16 10H4a1 1 0 000 2h16a1 1 0 000-2zm0-6H4a1 1 0 000 2h16a1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $fdc94045ec0e5793$export$ec7db1c418c1ec5a = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 15a1.002 1.002 0 01-.71-.29l-4-4a1.004 1.004 0 111.42-1.42l3.29 3.3 3.29-3.3a1.004 1.004 0 111.42 1.42l-4 4A1.001 1.001 0 0112 15z",
            fill: "currentColor"
        })
    });



const $1b63d62cdd4af45e$export$8203b8a87ae185f = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M14 17a1.003 1.003 0 01-.71-.29l-4-4a1 1 0 010-1.42l4-4a1.005 1.005 0 011.42 1.42L11.41 12l3.3 3.29a.997.997 0 01.219 1.095.999.999 0 01-.93.615z",
            fill: "currentColor"
        })
    });



const $735120fcd87dd052$export$a477256bf52ac2f7 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10 17a1.002 1.002 0 01-1.006-1 1 1 0 01.296-.71l3.3-3.29-3.3-3.29a1.004 1.004 0 011.42-1.42l4 4a.997.997 0 01.219 1.095.999.999 0 01-.22.325l-4 4A1 1 0 0110 17z",
            fill: "currentColor"
        })
    });



const $9efe7828a40b52f7$export$acd925e63e14000f = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 15a.998.998 0 01-.71-.29L12 11.41l-3.29 3.3a1.004 1.004 0 01-1.42-1.42l4-4a.999.999 0 011.42 0l4 4A1.001 1.001 0 0116 15z",
            fill: "currentColor"
        })
    });



const $4b407a2b367f43e3$export$48672c81f0c3f574 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M13.41 12l6.3-6.29a1.004 1.004 0 00-1.42-1.42L12 10.59l-6.29-6.3a1.004 1.004 0 10-1.42 1.42l6.3 6.29-6.3 6.29a.999.999 0 000 1.42 1 1 0 001.42 0l6.29-6.3 6.29 6.3a1.001 1.001 0 001.639-.325 1 1 0 00-.22-1.095L13.41 12z",
            fill: "currentColor"
        })
    });



const $4c01e0333386e8c5$export$885ccec48f920b92 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7 4c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1s1-.45 1-1V5c0-.55-.45-1-1-1zm5.41 8l6.29-6.29a.996.996 0 10-1.41-1.41l-7 7a.996.996 0 000 1.41l7 7c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 000-1.41l-6.29-6.29-.01-.01z",
            fill: "currentColor"
        })
    });



const $a612d6b4674022e7$export$10426ed6ef0ab637 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.47 9.31L13.85 2.7a2.8 2.8 0 00-3.7 0L2.53 9.31A1.53 1.53 0 003.45 12H4v7a3 3 0 003 3h3v-6h4v6h3a3 3 0 003-3v-7h.55a1.53 1.53 0 00.92-2.69z",
            fill: "currentColor"
        })
    });



const $bc0db77fbff65188$export$1093b8f29e1cf10c = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M6.71 4.29A.996.996 0 105.3 5.7l6.29 6.29-6.29 6.29a.996.996 0 00.71 1.7c.26 0 .51-.1.71-.29l7-7a.996.996 0 000-1.41L6.71 4.29zM17 4c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1s1-.45 1-1V5c0-.55-.45-1-1-1z",
            fill: "currentColor"
        })
    });



const $304780aca3b3a13a$export$a883bfa83ec843c8 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10.29 14.29a1.002 1.002 0 00.325 1.639 1 1 0 001.095-.219l3-3a1.002 1.002 0 000-1.42l-3-3a1.004 1.004 0 00-1.42 1.42l1.3 1.29H3a1 1 0 000 2h8.59l-1.3 1.29zM12 2a10.06 10.06 0 00-8.09 4.13 1 1 0 00.575 1.565A1 1 0 005.53 7.31a8 8 0 110 9.38 1.002 1.002 0 10-1.62 1.18A10 10 0 1012 2z",
            fill: "currentColor"
        })
    });



const $10a623943a1be9a9$export$5c4cc728e7726d4e = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17.87 3.91a1 1 0 00-1.58.966 1 1 0 00.4.654 8 8 0 11-9.38 0 1.002 1.002 0 00-1.18-1.62 10 10 0 1011.74 0zM12 8a1 1 0 001-1V3a1 1 0 00-2 0v4a1 1 0 001 1z",
            fill: "currentColor"
        })
    });



const $ffc7075420fce577$export$f6c2e7c657f578c5 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M5.5 10.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm6.5 0a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm6.5 0a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
            fill: "currentColor"
        })
    });



const $31b79cb94a7f2481$export$76eade3e6c39fefd = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 7a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm0 10a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm0-6.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
            fill: "currentColor"
        })
    });



const $b59efb8c56ba82c0$export$17beb55fda7072f9 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M9 20a1.002 1.002 0 01-1.006-1 1 1 0 01.296-.71l6.3-6.29-6.3-6.29a1.004 1.004 0 011.42-1.42l7 7a.997.997 0 01.219 1.095.999.999 0 01-.22.325l-7 7A1 1 0 019 20z",
            fill: "currentColor"
        })
    });



const $52f7703976716e4f$export$6da2c307edd95198 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10.004 2a7 7 0 015.6 11.19l6.11 6.1a1.002 1.002 0 01-.325 1.639.999.999 0 01-1.095-.219l-6.1-6.11A7 7 0 1110.004 2zm0 12a5 5 0 100-10 5 5 0 000 10z",
            fill: "currentColor"
        })
    });



const $7aed0775866c148c$export$f7d6d35bb50c6222 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.43 13.4L19 12.58v-1.16l1.43-.82a2 2 0 00.73-2.73l-1-1.74a2 2 0 00-2.73-.73l-1.18.68-.25.15-1-.58V4a2 2 0 00-2-2h-2a2 2 0 00-2 2v1.65l-.25.14-.75.44-.25-.15-1.18-.68a2 2 0 00-2.73.73l-1 1.74a2 2 0 00.73 2.73l1.43.82v1.16l-1.43.82a2 2 0 00-.73 2.73l1 1.74a2 2 0 002.73.73L8 17.77l1 .58V20a2 2 0 002 2h2a2 2 0 002-2v-1.65l1-.58 1.43.83a2 2 0 002.73-.73l1-1.74a2 2 0 00-.73-2.73zM12 15a3 3 0 110-6 3 3 0 010 6z",
            fill: "currentColor"
        })
    });



const $2f5be6df98c377a7$export$8c6932a2fedd46e4 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16 6a4 4 0 11-8 0 4 4 0 018 0zm4 10.5c0 3.038-3.582 5.5-8 5.5s-8-2.462-8-5.5S7.582 11 12 11s8 2.462 8 5.5z",
            fill: "currentColor"
        })
    });



const $807fef1d289a1edd$export$255f0ef2dfc5eb49 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zm0 4a3 3 0 110 6 3 3 0 010-6zm0 14a8 8 0 01-6.54-3.41C6.46 15.08 9 14 12 14s5.54 1.08 6.54 2.59A8 8 0 0112 20z",
            fill: "currentColor"
        })
    });




function $bff35c0dd9851fab$export$629a2bd3f5a49ecc(obj) {
    if (obj === null || typeof obj !== "object") return obj;
    if (Array.isArray(obj)) {
        const newArray = [];
        for(let i = 0; i < obj.length; i++)newArray[i] = $bff35c0dd9851fab$export$629a2bd3f5a49ecc(obj[i]);
        return newArray;
    }
    const newObj = {};
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = $bff35c0dd9851fab$export$629a2bd3f5a49ecc(obj[key]);
    return newObj;
}
function $bff35c0dd9851fab$export$79b2f7037acddd43(collection, iteratee) {
    if (Array.isArray(collection)) for (const item of collection)iteratee(item);
    else {
        const keys = Object.keys(collection);
        for (const key of keys)iteratee(collection[key], key);
    }
}
const $bff35c0dd9851fab$export$b460b275d6c6aa0 = (object, predicate)=>{
    if (typeof predicate !== "function") throw new TypeError("Predicate must be a function");
    const result = {};
    for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key], key)) result[key] = object[key];
    return result;
};
const $bff35c0dd9851fab$export$30a06c8d3562193f = (obj, props)=>{
    obj = {
        ...obj
    };
    props.forEach((prop)=>delete obj[prop]);
    return obj;
};
const $bff35c0dd9851fab$export$d7a617dda645b4e3 = (obj, check)=>{
    obj = {
        ...obj
    };
    Object.entries(obj).forEach(([key, value])=>check(value, key) && delete obj[key]);
    return obj;
};
const $bff35c0dd9851fab$export$3988ae62b71be9a3 = (obj, path, defValue)=>{
    if (!path) return void 0;
    const pathArray = Array.isArray(path) ? path : path.match(/([^[.\]])+/g);
    const result = pathArray?.reduce((prevObj, key)=>prevObj && prevObj[key], obj);
    return result === void 0 ? defValue : result;
};
const $bff35c0dd9851fab$export$2cbec9495984f5d9 = (str)=>`${str.charAt(0).toUpperCase()}${str.slice(1).toLowerCase()}`;
const $bff35c0dd9851fab$export$61fc7d43ac8f84b0 = (fn, wait, immediate = false)=>{
    let timeoutId;
    return function(...args) {
        const later = ()=>{
            timeoutId = null;
            if (!immediate) fn.apply(this, args);
        };
        const callNow = immediate && !timeoutId;
        timeoutId !== null && clearTimeout(timeoutId);
        timeoutId = setTimeout(later, wait);
        if (callNow) fn.apply(this, args);
    };
};
const $bff35c0dd9851fab$export$5fe300a9008e2bfc = (value)=>value.replace(/[{}]/g, "");
const $bff35c0dd9851fab$export$7d15b64cf5a3a4c4 = (value, min, max)=>Math.max(min, Math.min(value, max));
function $bff35c0dd9851fab$export$4950aa0f605343fb(base, ...rest) {
    let second;
    rest = rest.filter(Boolean);
    if (rest.length > 1) {
        const [first, ...others] = rest;
        second = $bff35c0dd9851fab$export$4950aa0f605343fb(first, ...others);
    } else if (rest.length === 1) second = rest[0];
    else return base;
    return $bff35c0dd9851fab$var$mergeObject(base, second);
}
function $bff35c0dd9851fab$var$mergeObject(base, second) {
    const merged = {};
    const keys = [
        ...Object.keys(base),
        ...Object.keys(second)
    ];
    for (const key of keys){
        if (!(key in second)) merged[key] = base[key];
        else if (!(key in base)) merged[key] = second[key];
        else merged[key] = $bff35c0dd9851fab$var$mergeValues(base[key], second[key]);
    }
    return merged;
}
function $bff35c0dd9851fab$var$mergeValues(base, second) {
    if ($bff35c0dd9851fab$var$isObject(base) && $bff35c0dd9851fab$var$isObject(second)) return $bff35c0dd9851fab$var$mergeObject(base, second);
    return second;
}
function $bff35c0dd9851fab$var$isObject(value) {
    return typeof value === "object" && value !== null && !Array.isArray(value);
}
const $bff35c0dd9851fab$export$1839ba460459a826 = (s)=>s?.replace(/./, (m)=>m.toUpperCase());
const $bff35c0dd9851fab$export$8a7688a96d852767 = (s, separator = "-")=>s.split(separator).map((segment, index)=>index === 0 ? segment : $bff35c0dd9851fab$export$1839ba460459a826(segment)).join("");
const $bff35c0dd9851fab$export$26c6f48841fe1a8a = (s, separator = "-")=>s.split(separator).map($bff35c0dd9851fab$export$1839ba460459a826).join("");
const $bff35c0dd9851fab$export$3e672a90535a3744 = (inputString)=>inputString.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/([0-9])([a-zA-Z])/g, "$1-$2").replace(/([a-zA-Z])([0-9])/g, "$1-$2").replace(/\s+/g, "-").toLowerCase();
function $bff35c0dd9851fab$export$848d71df1f759bc(hex) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16) / 255,
        g: parseInt(result[2], 16) / 255,
        b: parseInt(result[3], 16) / 255
    } : {
        r: 0,
        g: 0,
        b: 0
    };
}
function $bff35c0dd9851fab$export$b7d58db314e0ac27(obj) {
    return globalThis.structuredClone ? globalThis.structuredClone(obj) : JSON.parse(JSON.stringify(obj));
}
const $bff35c0dd9851fab$export$feae9a740c003485 = (string)=>{
    return string.replace(/\W+/g, " ").split(/ |\B(?=[A-Z])/).map((word)=>word.toLowerCase()).join("_");
};


var $6eea7234d56610fe$var$buffer = {};
var $6eea7234d56610fe$var$base64Js = {};
$6eea7234d56610fe$var$base64Js.byteLength = $6eea7234d56610fe$var$byteLength;
$6eea7234d56610fe$var$base64Js.toByteArray = $6eea7234d56610fe$var$toByteArray;
$6eea7234d56610fe$var$base64Js.fromByteArray = $6eea7234d56610fe$var$fromByteArray;
var $6eea7234d56610fe$var$lookup = [];
var $6eea7234d56610fe$var$revLookup = [];
var $6eea7234d56610fe$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $6eea7234d56610fe$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $6eea7234d56610fe$var$i = 0, $6eea7234d56610fe$var$len = $6eea7234d56610fe$var$code.length; $6eea7234d56610fe$var$i < $6eea7234d56610fe$var$len; ++$6eea7234d56610fe$var$i){
    $6eea7234d56610fe$var$lookup[$6eea7234d56610fe$var$i] = $6eea7234d56610fe$var$code[$6eea7234d56610fe$var$i];
    $6eea7234d56610fe$var$revLookup[$6eea7234d56610fe$var$code.charCodeAt($6eea7234d56610fe$var$i)] = $6eea7234d56610fe$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$6eea7234d56610fe$var$revLookup['-'.charCodeAt(0)] = 62;
$6eea7234d56610fe$var$revLookup['_'.charCodeAt(0)] = 63;
function $6eea7234d56610fe$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $6eea7234d56610fe$var$byteLength(b64) {
    var lens = $6eea7234d56610fe$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $6eea7234d56610fe$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $6eea7234d56610fe$var$toByteArray(b64) {
    var tmp;
    var lens = $6eea7234d56610fe$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $6eea7234d56610fe$var$Arr($6eea7234d56610fe$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $6eea7234d56610fe$var$revLookup[b64.charCodeAt(i)] << 18 | $6eea7234d56610fe$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $6eea7234d56610fe$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $6eea7234d56610fe$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $6eea7234d56610fe$var$revLookup[b64.charCodeAt(i)] << 2 | $6eea7234d56610fe$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $6eea7234d56610fe$var$revLookup[b64.charCodeAt(i)] << 10 | $6eea7234d56610fe$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $6eea7234d56610fe$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $6eea7234d56610fe$var$tripletToBase64(num) {
    return $6eea7234d56610fe$var$lookup[num >> 18 & 0x3F] + $6eea7234d56610fe$var$lookup[num >> 12 & 0x3F] + $6eea7234d56610fe$var$lookup[num >> 6 & 0x3F] + $6eea7234d56610fe$var$lookup[num & 0x3F];
}
function $6eea7234d56610fe$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($6eea7234d56610fe$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $6eea7234d56610fe$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
    var parts = [];
    var maxChunkLength = 16383; // must be multiple of 3
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($6eea7234d56610fe$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($6eea7234d56610fe$var$lookup[tmp >> 2] + $6eea7234d56610fe$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($6eea7234d56610fe$var$lookup[tmp >> 10] + $6eea7234d56610fe$var$lookup[tmp >> 4 & 0x3F] + $6eea7234d56610fe$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}
var $6eea7234d56610fe$var$ieee754 = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ $6eea7234d56610fe$var$ieee754.read = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$6eea7234d56610fe$var$ieee754.write = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ (function(exports) {
    const base64 = $6eea7234d56610fe$var$base64Js;
    const ieee754$1 = $6eea7234d56610fe$var$ieee754;
    const customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
     ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
     : null;
    exports.Buffer = Buffer;
    exports.SlowBuffer = SlowBuffer;
    exports.INSPECT_MAX_BYTES = 50;
    const K_MAX_LENGTH = 0x7fffffff;
    exports.kMaxLength = K_MAX_LENGTH;
    const { Uint8Array: GlobalUint8Array, ArrayBuffer: GlobalArrayBuffer, SharedArrayBuffer: GlobalSharedArrayBuffer } = globalThis;
    /**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
	 *               implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * We report that the browser does not support typed arrays if the are not subclassable
	 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
	 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
	 * for __proto__ and has a buggy typed array implementation.
	 */ Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
    if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
    function typedArraySupport() {
        // Can typed array instances can be augmented?
        try {
            const arr = new GlobalUint8Array(1);
            const proto = {
                foo: function() {
                    return 42;
                }
            };
            Object.setPrototypeOf(proto, GlobalUint8Array.prototype);
            Object.setPrototypeOf(arr, proto);
            return arr.foo() === 42;
        } catch (e) {
            return false;
        }
    }
    Object.defineProperty(Buffer.prototype, 'parent', {
        enumerable: true,
        get: function() {
            if (!Buffer.isBuffer(this)) return undefined;
            return this.buffer;
        }
    });
    Object.defineProperty(Buffer.prototype, 'offset', {
        enumerable: true,
        get: function() {
            if (!Buffer.isBuffer(this)) return undefined;
            return this.byteOffset;
        }
    });
    function createBuffer(length) {
        if (length > K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
        // Return an augmented `Uint8Array` instance
        const buf = new GlobalUint8Array(length);
        Object.setPrototypeOf(buf, Buffer.prototype);
        return buf;
    }
    /**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */ function Buffer(arg, encodingOrOffset, length) {
        // Common case.
        if (typeof arg === 'number') {
            if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
            return allocUnsafe(arg);
        }
        return from(arg, encodingOrOffset, length);
    }
    Buffer.poolSize = 8192; // not used by this implementation
    function from(value, encodingOrOffset, length) {
        if (typeof value === 'string') return fromString(value, encodingOrOffset);
        if (GlobalArrayBuffer.isView(value)) return fromArrayView(value);
        if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
        if (isInstance(value, GlobalArrayBuffer) || value && isInstance(value.buffer, GlobalArrayBuffer)) return fromArrayBuffer(value, encodingOrOffset, length);
        if (typeof GlobalSharedArrayBuffer !== 'undefined' && (isInstance(value, GlobalSharedArrayBuffer) || value && isInstance(value.buffer, GlobalSharedArrayBuffer))) return fromArrayBuffer(value, encodingOrOffset, length);
        if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
        const valueOf = value.valueOf && value.valueOf();
        if (valueOf != null && valueOf !== value) return Buffer.from(valueOf, encodingOrOffset, length);
        const b = fromObject(value);
        if (b) return b;
        if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
        throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    }
    /**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/ Buffer.from = function(value, encodingOrOffset, length) {
        return from(value, encodingOrOffset, length);
    };
    // Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
    // https://github.com/feross/buffer/pull/148
    Object.setPrototypeOf(Buffer.prototype, GlobalUint8Array.prototype);
    Object.setPrototypeOf(Buffer, GlobalUint8Array);
    function assertSize(size) {
        if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
        else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
    }
    function alloc(size, fill, encoding) {
        assertSize(size);
        if (size <= 0) return createBuffer(size);
        if (fill !== undefined) // Only pay attention to encoding if it's a string. This
        // prevents accidentally sending in a number that would
        // be interpreted as a start offset.
        return typeof encoding === 'string' ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
        return createBuffer(size);
    }
    /**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/ Buffer.alloc = function(size, fill, encoding) {
        return alloc(size, fill, encoding);
    };
    function allocUnsafe(size) {
        assertSize(size);
        return createBuffer(size < 0 ? 0 : checked(size) | 0);
    }
    /**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */ Buffer.allocUnsafe = function(size) {
        return allocUnsafe(size);
    };
    /**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */ Buffer.allocUnsafeSlow = function(size) {
        return allocUnsafe(size);
    };
    function fromString(string, encoding) {
        if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
        if (!Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        const length = byteLength(string, encoding) | 0;
        let buf = createBuffer(length);
        const actual = buf.write(string, encoding);
        if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
        // cause everything after the first invalid character to be ignored. (e.g.
        // 'abxxcd' will be treated as 'ab')
        buf = buf.slice(0, actual);
        return buf;
    }
    function fromArrayLike(array) {
        const length = array.length < 0 ? 0 : checked(array.length) | 0;
        const buf = createBuffer(length);
        for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
        return buf;
    }
    function fromArrayView(arrayView) {
        if (isInstance(arrayView, GlobalUint8Array)) {
            const copy = new GlobalUint8Array(arrayView);
            return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
        }
        return fromArrayLike(arrayView);
    }
    function fromArrayBuffer(array, byteOffset, length) {
        if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
        if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
        let buf;
        if (byteOffset === undefined && length === undefined) buf = new GlobalUint8Array(array);
        else if (length === undefined) buf = new GlobalUint8Array(array, byteOffset);
        else buf = new GlobalUint8Array(array, byteOffset, length);
        // Return an augmented `Uint8Array` instance
        Object.setPrototypeOf(buf, Buffer.prototype);
        return buf;
    }
    function fromObject(obj) {
        if (Buffer.isBuffer(obj)) {
            const len = checked(obj.length) | 0;
            const buf = createBuffer(len);
            if (buf.length === 0) return buf;
            obj.copy(buf, 0, 0, len);
            return buf;
        }
        if (obj.length !== undefined) {
            if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) return createBuffer(0);
            return fromArrayLike(obj);
        }
        if (obj.type === 'Buffer' && Array.isArray(obj.data)) return fromArrayLike(obj.data);
    }
    function checked(length) {
        // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
        // length is NaN (which is otherwise coerced to zero.)
        if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + ' bytes');
        return length | 0;
    }
    function SlowBuffer(length) {
        if (+length != length) length = 0;
        return Buffer.alloc(+length);
    }
    Buffer.isBuffer = function isBuffer(b) {
        return b != null && b._isBuffer === true && b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
        ;
    };
    Buffer.compare = function compare(a, b) {
        if (isInstance(a, GlobalUint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
        if (isInstance(b, GlobalUint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
        if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
        if (a === b) return 0;
        let x = a.length;
        let y = b.length;
        for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
            x = a[i];
            y = b[i];
            break;
        }
        if (x < y) return -1;
        if (y < x) return 1;
        return 0;
    };
    Buffer.isEncoding = function isEncoding(encoding) {
        switch(String(encoding).toLowerCase()){
            case 'hex':
            case 'utf8':
            case 'utf-8':
            case 'ascii':
            case 'latin1':
            case 'binary':
            case 'base64':
            case 'ucs2':
            case 'ucs-2':
            case 'utf16le':
            case 'utf-16le':
                return true;
            default:
                return false;
        }
    };
    Buffer.concat = function concat(list, length) {
        if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
        if (list.length === 0) return Buffer.alloc(0);
        let i;
        if (length === undefined) {
            length = 0;
            for(i = 0; i < list.length; ++i)length += list[i].length;
        }
        const buffer = Buffer.allocUnsafe(length);
        let pos = 0;
        for(i = 0; i < list.length; ++i){
            let buf = list[i];
            if (isInstance(buf, GlobalUint8Array)) {
                if (pos + buf.length > buffer.length) {
                    if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf);
                    buf.copy(buffer, pos);
                } else GlobalUint8Array.prototype.set.call(buffer, buf, pos);
            } else if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
            else buf.copy(buffer, pos);
            pos += buf.length;
        }
        return buffer;
    };
    function byteLength(string, encoding) {
        if (Buffer.isBuffer(string)) return string.length;
        if (GlobalArrayBuffer.isView(string) || isInstance(string, GlobalArrayBuffer)) return string.byteLength;
        if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
        const len = string.length;
        const mustMatch = arguments.length > 2 && arguments[2] === true;
        if (!mustMatch && len === 0) return 0;
        // Use a for loop to avoid recursion
        let loweredCase = false;
        for(;;)switch(encoding){
            case 'ascii':
            case 'latin1':
            case 'binary':
                return len;
            case 'utf8':
            case 'utf-8':
                return utf8ToBytes(string).length;
            case 'ucs2':
            case 'ucs-2':
            case 'utf16le':
            case 'utf-16le':
                return len * 2;
            case 'hex':
                return len >>> 1;
            case 'base64':
                return base64ToBytes(string).length;
            default:
                if (loweredCase) return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
                ;
                encoding = ('' + encoding).toLowerCase();
                loweredCase = true;
        }
    }
    Buffer.byteLength = byteLength;
    function slowToString(encoding, start, end) {
        let loweredCase = false;
        // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
        // property of a typed array.
        // This behaves neither like String nor Uint8Array in that we set start/end
        // to their upper/lower bounds if the value passed is out of range.
        // undefined is handled specially as per ECMA-262 6th Edition,
        // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
        if (start === undefined || start < 0) start = 0;
        // Return early if start > this.length. Done here to prevent potential uint32
        // coercion fail below.
        if (start > this.length) return '';
        if (end === undefined || end > this.length) end = this.length;
        if (end <= 0) return '';
        // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
        end >>>= 0;
        start >>>= 0;
        if (end <= start) return '';
        if (!encoding) encoding = 'utf8';
        while(true)switch(encoding){
            case 'hex':
                return hexSlice(this, start, end);
            case 'utf8':
            case 'utf-8':
                return utf8Slice(this, start, end);
            case 'ascii':
                return asciiSlice(this, start, end);
            case 'latin1':
            case 'binary':
                return latin1Slice(this, start, end);
            case 'base64':
                return base64Slice(this, start, end);
            case 'ucs2':
            case 'ucs-2':
            case 'utf16le':
            case 'utf-16le':
                return utf16leSlice(this, start, end);
            default:
                if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
                encoding = (encoding + '').toLowerCase();
                loweredCase = true;
        }
    }
    // This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
    // to detect a Buffer instance. It's not possible to use `instanceof Buffer`
    // reliably in a browserify context because there could be multiple different
    // copies of the 'buffer' package in use. This method works even for Buffer
    // instances that were created from another copy of the `buffer` package.
    // See: https://github.com/feross/buffer/issues/154
    Buffer.prototype._isBuffer = true;
    function swap(b, n, m) {
        const i = b[n];
        b[n] = b[m];
        b[m] = i;
    }
    Buffer.prototype.swap16 = function swap16() {
        const len = this.length;
        if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
        for(let i = 0; i < len; i += 2)swap(this, i, i + 1);
        return this;
    };
    Buffer.prototype.swap32 = function swap32() {
        const len = this.length;
        if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
        for(let i = 0; i < len; i += 4){
            swap(this, i, i + 3);
            swap(this, i + 1, i + 2);
        }
        return this;
    };
    Buffer.prototype.swap64 = function swap64() {
        const len = this.length;
        if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
        for(let i = 0; i < len; i += 8){
            swap(this, i, i + 7);
            swap(this, i + 1, i + 6);
            swap(this, i + 2, i + 5);
            swap(this, i + 3, i + 4);
        }
        return this;
    };
    Buffer.prototype.toString = function toString() {
        const length = this.length;
        if (length === 0) return '';
        if (arguments.length === 0) return utf8Slice(this, 0, length);
        return slowToString.apply(this, arguments);
    };
    Buffer.prototype.toLocaleString = Buffer.prototype.toString;
    Buffer.prototype.equals = function equals(b) {
        if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
        if (this === b) return true;
        return Buffer.compare(this, b) === 0;
    };
    Buffer.prototype.inspect = function inspect() {
        let str = '';
        const max = exports.INSPECT_MAX_BYTES;
        str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
        if (this.length > max) str += ' ... ';
        return '<Buffer ' + str + '>';
    };
    if (customInspectSymbol) Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
    Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
        if (isInstance(target, GlobalUint8Array)) target = Buffer.from(target, target.offset, target.byteLength);
        if (!Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
        if (start === undefined) start = 0;
        if (end === undefined) end = target ? target.length : 0;
        if (thisStart === undefined) thisStart = 0;
        if (thisEnd === undefined) thisEnd = this.length;
        if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
        if (thisStart >= thisEnd && start >= end) return 0;
        if (thisStart >= thisEnd) return -1;
        if (start >= end) return 1;
        start >>>= 0;
        end >>>= 0;
        thisStart >>>= 0;
        thisEnd >>>= 0;
        if (this === target) return 0;
        let x = thisEnd - thisStart;
        let y = end - start;
        const len = Math.min(x, y);
        const thisCopy = this.slice(thisStart, thisEnd);
        const targetCopy = target.slice(start, end);
        for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
            x = thisCopy[i];
            y = targetCopy[i];
            break;
        }
        if (x < y) return -1;
        if (y < x) return 1;
        return 0;
    };
    // Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
    // OR the last index of `val` in `buffer` at offset <= `byteOffset`.
    //
    // Arguments:
    // - buffer - a Buffer to search
    // - val - a string, Buffer, or number
    // - byteOffset - an index into `buffer`; will be clamped to an int32
    // - encoding - an optional encoding, relevant is val is a string
    // - dir - true for indexOf, false for lastIndexOf
    function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
        // Empty buffer means no match
        if (buffer.length === 0) return -1;
        // Normalize byteOffset
        if (typeof byteOffset === 'string') {
            encoding = byteOffset;
            byteOffset = 0;
        } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
        else if (byteOffset < -2147483648) byteOffset = -2147483648;
        byteOffset = +byteOffset; // Coerce to Number.
        if (numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
        byteOffset = dir ? 0 : buffer.length - 1;
        // Normalize byteOffset: negative offsets start from the end of the buffer
        if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
        if (byteOffset >= buffer.length) {
            if (dir) return -1;
            else byteOffset = buffer.length - 1;
        } else if (byteOffset < 0) {
            if (dir) byteOffset = 0;
            else return -1;
        }
        // Normalize val
        if (typeof val === 'string') val = Buffer.from(val, encoding);
        // Finally, search either indexOf (if dir is true) or lastIndexOf
        if (Buffer.isBuffer(val)) {
            // Special case: looking for empty string/buffer always fails
            if (val.length === 0) return -1;
            return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
        } else if (typeof val === 'number') {
            val = val & 0xFF; // Search for a byte value [0-255]
            if (typeof GlobalUint8Array.prototype.indexOf === 'function') {
                if (dir) return GlobalUint8Array.prototype.indexOf.call(buffer, val, byteOffset);
                else return GlobalUint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
            }
            return arrayIndexOf(buffer, [
                val
            ], byteOffset, encoding, dir);
        }
        throw new TypeError('val must be string, number or Buffer');
    }
    function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
        let indexSize = 1;
        let arrLength = arr.length;
        let valLength = val.length;
        if (encoding !== undefined) {
            encoding = String(encoding).toLowerCase();
            if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
                if (arr.length < 2 || val.length < 2) return -1;
                indexSize = 2;
                arrLength /= 2;
                valLength /= 2;
                byteOffset /= 2;
            }
        }
        function read(buf, i) {
            if (indexSize === 1) return buf[i];
            else return buf.readUInt16BE(i * indexSize);
        }
        let i;
        if (dir) {
            let foundIndex = -1;
            for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
                if (foundIndex === -1) foundIndex = i;
                if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
            } else {
                if (foundIndex !== -1) i -= i - foundIndex;
                foundIndex = -1;
            }
        } else {
            if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
            for(i = byteOffset; i >= 0; i--){
                let found = true;
                for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                    found = false;
                    break;
                }
                if (found) return i;
            }
        }
        return -1;
    }
    Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
        return this.indexOf(val, byteOffset, encoding) !== -1;
    };
    Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
        return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
    };
    Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
        return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
    };
    function hexWrite(buf, string, offset, length) {
        offset = Number(offset) || 0;
        const remaining = buf.length - offset;
        if (!length) length = remaining;
        else {
            length = Number(length);
            if (length > remaining) length = remaining;
        }
        const strLen = string.length;
        if (length > strLen / 2) length = strLen / 2;
        let i;
        for(i = 0; i < length; ++i){
            const parsed = parseInt(string.substr(i * 2, 2), 16);
            if (numberIsNaN(parsed)) return i;
            buf[offset + i] = parsed;
        }
        return i;
    }
    function utf8Write(buf, string, offset, length) {
        return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
    }
    function asciiWrite(buf, string, offset, length) {
        return blitBuffer(asciiToBytes(string), buf, offset, length);
    }
    function base64Write(buf, string, offset, length) {
        return blitBuffer(base64ToBytes(string), buf, offset, length);
    }
    function ucs2Write(buf, string, offset, length) {
        return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
    }
    Buffer.prototype.write = function write(string, offset, length, encoding) {
        // Buffer#write(string)
        if (offset === undefined) {
            encoding = 'utf8';
            length = this.length;
            offset = 0;
        // Buffer#write(string, encoding)
        } else if (length === undefined && typeof offset === 'string') {
            encoding = offset;
            length = this.length;
            offset = 0;
        // Buffer#write(string, offset[, length][, encoding])
        } else if (isFinite(offset)) {
            offset = offset >>> 0;
            if (isFinite(length)) {
                length = length >>> 0;
                if (encoding === undefined) encoding = 'utf8';
            } else {
                encoding = length;
                length = undefined;
            }
        } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
        const remaining = this.length - offset;
        if (length === undefined || length > remaining) length = remaining;
        if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
        if (!encoding) encoding = 'utf8';
        let loweredCase = false;
        for(;;)switch(encoding){
            case 'hex':
                return hexWrite(this, string, offset, length);
            case 'utf8':
            case 'utf-8':
                return utf8Write(this, string, offset, length);
            case 'ascii':
            case 'latin1':
            case 'binary':
                return asciiWrite(this, string, offset, length);
            case 'base64':
                // Warning: maxLength not taken into account in base64Write
                return base64Write(this, string, offset, length);
            case 'ucs2':
            case 'ucs-2':
            case 'utf16le':
            case 'utf-16le':
                return ucs2Write(this, string, offset, length);
            default:
                if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
                encoding = ('' + encoding).toLowerCase();
                loweredCase = true;
        }
    };
    Buffer.prototype.toJSON = function toJSON() {
        return {
            type: 'Buffer',
            data: Array.prototype.slice.call(this._arr || this, 0)
        };
    };
    function base64Slice(buf, start, end) {
        if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
        else return base64.fromByteArray(buf.slice(start, end));
    }
    function utf8Slice(buf, start, end) {
        end = Math.min(buf.length, end);
        const res = [];
        let i = start;
        while(i < end){
            const firstByte = buf[i];
            let codePoint = null;
            let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
            if (i + bytesPerSequence <= end) {
                let secondByte, thirdByte, fourthByte, tempCodePoint;
                switch(bytesPerSequence){
                    case 1:
                        if (firstByte < 0x80) codePoint = firstByte;
                        break;
                    case 2:
                        secondByte = buf[i + 1];
                        if ((secondByte & 0xC0) === 0x80) {
                            tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                            if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                        }
                        break;
                    case 3:
                        secondByte = buf[i + 1];
                        thirdByte = buf[i + 2];
                        if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                        }
                        break;
                    case 4:
                        secondByte = buf[i + 1];
                        thirdByte = buf[i + 2];
                        fourthByte = buf[i + 3];
                        if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                        }
                }
            }
            if (codePoint === null) {
                // we did not generate a valid codePoint so insert a
                // replacement char (U+FFFD) and advance only 1 byte
                codePoint = 0xFFFD;
                bytesPerSequence = 1;
            } else if (codePoint > 0xFFFF) {
                // encode to utf16 (surrogate pair dance)
                codePoint -= 0x10000;
                res.push(codePoint >>> 10 & 0x3FF | 0xD800);
                codePoint = 0xDC00 | codePoint & 0x3FF;
            }
            res.push(codePoint);
            i += bytesPerSequence;
        }
        return decodeCodePointsArray(res);
    }
    // Based on http://stackoverflow.com/a/22747272/680742, the browser with
    // the lowest limit is Chrome, with 0x10000 args.
    // We go 1 magnitude less, for safety
    const MAX_ARGUMENTS_LENGTH = 0x1000;
    function decodeCodePointsArray(codePoints) {
        const len = codePoints.length;
        if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
        ;
        // Decode in chunks to avoid "call stack size exceeded".
        let res = '';
        let i = 0;
        while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
        return res;
    }
    function asciiSlice(buf, start, end) {
        let ret = '';
        end = Math.min(buf.length, end);
        for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
        return ret;
    }
    function latin1Slice(buf, start, end) {
        let ret = '';
        end = Math.min(buf.length, end);
        for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
        return ret;
    }
    function hexSlice(buf, start, end) {
        const len = buf.length;
        if (!start || start < 0) start = 0;
        if (!end || end < 0 || end > len) end = len;
        let out = '';
        for(let i = start; i < end; ++i)out += hexSliceLookupTable[buf[i]];
        return out;
    }
    function utf16leSlice(buf, start, end) {
        const bytes = buf.slice(start, end);
        let res = '';
        // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
        for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
        return res;
    }
    Buffer.prototype.slice = function slice(start, end) {
        const len = this.length;
        start = ~~start;
        end = end === undefined ? len : ~~end;
        if (start < 0) {
            start += len;
            if (start < 0) start = 0;
        } else if (start > len) start = len;
        if (end < 0) {
            end += len;
            if (end < 0) end = 0;
        } else if (end > len) end = len;
        if (end < start) end = start;
        const newBuf = this.subarray(start, end);
        // Return an augmented `Uint8Array` instance
        Object.setPrototypeOf(newBuf, Buffer.prototype);
        return newBuf;
    };
    /*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */ function checkOffset(offset, ext, length) {
        if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
        if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
    }
    Buffer.prototype.readUintLE = Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
        offset = offset >>> 0;
        byteLength = byteLength >>> 0;
        if (!noAssert) checkOffset(offset, byteLength, this.length);
        let val = this[offset];
        let mul = 1;
        let i = 0;
        while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
        return val;
    };
    Buffer.prototype.readUintBE = Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
        offset = offset >>> 0;
        byteLength = byteLength >>> 0;
        if (!noAssert) checkOffset(offset, byteLength, this.length);
        let val = this[offset + --byteLength];
        let mul = 1;
        while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
        return val;
    };
    Buffer.prototype.readUint8 = Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 1, this.length);
        return this[offset];
    };
    Buffer.prototype.readUint16LE = Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 2, this.length);
        return this[offset] | this[offset + 1] << 8;
    };
    Buffer.prototype.readUint16BE = Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 2, this.length);
        return this[offset] << 8 | this[offset + 1];
    };
    Buffer.prototype.readUint32LE = Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
    };
    Buffer.prototype.readUint32BE = Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
    };
    Buffer.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE(offset) {
        offset = offset >>> 0;
        validateNumber(offset, 'offset');
        const first = this[offset];
        const last = this[offset + 7];
        if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
        const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
        const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
        return BigInt(lo) + (BigInt(hi) << BigInt(32));
    });
    Buffer.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE(offset) {
        offset = offset >>> 0;
        validateNumber(offset, 'offset');
        const first = this[offset];
        const last = this[offset + 7];
        if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
        const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
        const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
        return (BigInt(hi) << BigInt(32)) + BigInt(lo);
    });
    Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
        offset = offset >>> 0;
        byteLength = byteLength >>> 0;
        if (!noAssert) checkOffset(offset, byteLength, this.length);
        let val = this[offset];
        let mul = 1;
        let i = 0;
        while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
        mul *= 0x80;
        if (val >= mul) val -= Math.pow(2, 8 * byteLength);
        return val;
    };
    Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
        offset = offset >>> 0;
        byteLength = byteLength >>> 0;
        if (!noAssert) checkOffset(offset, byteLength, this.length);
        let i = byteLength;
        let mul = 1;
        let val = this[offset + --i];
        while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
        mul *= 0x80;
        if (val >= mul) val -= Math.pow(2, 8 * byteLength);
        return val;
    };
    Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 1, this.length);
        if (!(this[offset] & 0x80)) return this[offset];
        return (0xff - this[offset] + 1) * -1;
    };
    Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 2, this.length);
        const val = this[offset] | this[offset + 1] << 8;
        return val & 0x8000 ? val | 0xFFFF0000 : val;
    };
    Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 2, this.length);
        const val = this[offset + 1] | this[offset] << 8;
        return val & 0x8000 ? val | 0xFFFF0000 : val;
    };
    Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
    };
    Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
    };
    Buffer.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE(offset) {
        offset = offset >>> 0;
        validateNumber(offset, 'offset');
        const first = this[offset];
        const last = this[offset + 7];
        if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
        const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24); // Overflow
        return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
    });
    Buffer.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE(offset) {
        offset = offset >>> 0;
        validateNumber(offset, 'offset');
        const first = this[offset];
        const last = this[offset + 7];
        if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
        const val = (first << 24) + // Overflow
        this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
        return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
    });
    Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return ieee754$1.read(this, offset, true, 23, 4);
    };
    Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return ieee754$1.read(this, offset, false, 23, 4);
    };
    Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 8, this.length);
        return ieee754$1.read(this, offset, true, 52, 8);
    };
    Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 8, this.length);
        return ieee754$1.read(this, offset, false, 52, 8);
    };
    function checkInt(buf, value, offset, ext, max, min) {
        if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
        if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
        if (offset + ext > buf.length) throw new RangeError('Index out of range');
    }
    Buffer.prototype.writeUintLE = Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
        value = +value;
        offset = offset >>> 0;
        byteLength = byteLength >>> 0;
        if (!noAssert) {
            const maxBytes = Math.pow(2, 8 * byteLength) - 1;
            checkInt(this, value, offset, byteLength, maxBytes, 0);
        }
        let mul = 1;
        let i = 0;
        this[offset] = value & 0xFF;
        while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
        return offset + byteLength;
    };
    Buffer.prototype.writeUintBE = Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
        value = +value;
        offset = offset >>> 0;
        byteLength = byteLength >>> 0;
        if (!noAssert) {
            const maxBytes = Math.pow(2, 8 * byteLength) - 1;
            checkInt(this, value, offset, byteLength, maxBytes, 0);
        }
        let i = byteLength - 1;
        let mul = 1;
        this[offset + i] = value & 0xFF;
        while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
        return offset + byteLength;
    };
    Buffer.prototype.writeUint8 = Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
        this[offset] = value & 0xff;
        return offset + 1;
    };
    Buffer.prototype.writeUint16LE = Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        return offset + 2;
    };
    Buffer.prototype.writeUint16BE = Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
        return offset + 2;
    };
    Buffer.prototype.writeUint32LE = Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
        this[offset + 3] = value >>> 24;
        this[offset + 2] = value >>> 16;
        this[offset + 1] = value >>> 8;
        this[offset] = value & 0xff;
        return offset + 4;
    };
    Buffer.prototype.writeUint32BE = Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
        return offset + 4;
    };
    function wrtBigUInt64LE(buf, value, offset, min, max) {
        checkIntBI(value, min, max, buf, offset, 7);
        let lo = Number(value & BigInt(0xffffffff));
        buf[offset++] = lo;
        lo = lo >> 8;
        buf[offset++] = lo;
        lo = lo >> 8;
        buf[offset++] = lo;
        lo = lo >> 8;
        buf[offset++] = lo;
        let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
        buf[offset++] = hi;
        hi = hi >> 8;
        buf[offset++] = hi;
        hi = hi >> 8;
        buf[offset++] = hi;
        hi = hi >> 8;
        buf[offset++] = hi;
        return offset;
    }
    function wrtBigUInt64BE(buf, value, offset, min, max) {
        checkIntBI(value, min, max, buf, offset, 7);
        let lo = Number(value & BigInt(0xffffffff));
        buf[offset + 7] = lo;
        lo = lo >> 8;
        buf[offset + 6] = lo;
        lo = lo >> 8;
        buf[offset + 5] = lo;
        lo = lo >> 8;
        buf[offset + 4] = lo;
        let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
        buf[offset + 3] = hi;
        hi = hi >> 8;
        buf[offset + 2] = hi;
        hi = hi >> 8;
        buf[offset + 1] = hi;
        hi = hi >> 8;
        buf[offset] = hi;
        return offset + 8;
    }
    Buffer.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
        return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
    });
    Buffer.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
        return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
    });
    Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) {
            const limit = Math.pow(2, 8 * byteLength - 1);
            checkInt(this, value, offset, byteLength, limit - 1, -limit);
        }
        let i = 0;
        let mul = 1;
        let sub = 0;
        this[offset] = value & 0xFF;
        while(++i < byteLength && (mul *= 0x100)){
            if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
            this[offset + i] = (value / mul >> 0) - sub & 0xFF;
        }
        return offset + byteLength;
    };
    Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) {
            const limit = Math.pow(2, 8 * byteLength - 1);
            checkInt(this, value, offset, byteLength, limit - 1, -limit);
        }
        let i = byteLength - 1;
        let mul = 1;
        let sub = 0;
        this[offset + i] = value & 0xFF;
        while(--i >= 0 && (mul *= 0x100)){
            if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
            this[offset + i] = (value / mul >> 0) - sub & 0xFF;
        }
        return offset + byteLength;
    };
    Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
        if (value < 0) value = 0xff + value + 1;
        this[offset] = value & 0xff;
        return offset + 1;
    };
    Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        return offset + 2;
    };
    Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
        return offset + 2;
    };
    Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        this[offset + 2] = value >>> 16;
        this[offset + 3] = value >>> 24;
        return offset + 4;
    };
    Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
        if (value < 0) value = 0xffffffff + value + 1;
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
        return offset + 4;
    };
    Buffer.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
        return wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
    });
    Buffer.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
        return wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
    });
    function checkIEEE754(buf, value, offset, ext, max, min) {
        if (offset + ext > buf.length) throw new RangeError('Index out of range');
        if (offset < 0) throw new RangeError('Index out of range');
    }
    function writeFloat(buf, value, offset, littleEndian, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkIEEE754(buf, value, offset, 4);
        ieee754$1.write(buf, value, offset, littleEndian, 23, 4);
        return offset + 4;
    }
    Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
        return writeFloat(this, value, offset, true, noAssert);
    };
    Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
        return writeFloat(this, value, offset, false, noAssert);
    };
    function writeDouble(buf, value, offset, littleEndian, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkIEEE754(buf, value, offset, 8);
        ieee754$1.write(buf, value, offset, littleEndian, 52, 8);
        return offset + 8;
    }
    Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
        return writeDouble(this, value, offset, true, noAssert);
    };
    Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
        return writeDouble(this, value, offset, false, noAssert);
    };
    // copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
    Buffer.prototype.copy = function copy(target, targetStart, start, end) {
        if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
        if (!start) start = 0;
        if (!end && end !== 0) end = this.length;
        if (targetStart >= target.length) targetStart = target.length;
        if (!targetStart) targetStart = 0;
        if (end > 0 && end < start) end = start;
        // Copy 0 bytes; we're done
        if (end === start) return 0;
        if (target.length === 0 || this.length === 0) return 0;
        // Fatal error conditions
        if (targetStart < 0) throw new RangeError('targetStart out of bounds');
        if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
        if (end < 0) throw new RangeError('sourceEnd out of bounds');
        // Are we oob?
        if (end > this.length) end = this.length;
        if (target.length - targetStart < end - start) end = target.length - targetStart + start;
        const len = end - start;
        if (this === target && typeof GlobalUint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
        this.copyWithin(targetStart, start, end);
        else GlobalUint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
        return len;
    };
    // Usage:
    //    buffer.fill(number[, offset[, end]])
    //    buffer.fill(buffer[, offset[, end]])
    //    buffer.fill(string[, offset[, end]][, encoding])
    Buffer.prototype.fill = function fill(val, start, end, encoding) {
        // Handle string cases:
        if (typeof val === 'string') {
            if (typeof start === 'string') {
                encoding = start;
                start = 0;
                end = this.length;
            } else if (typeof end === 'string') {
                encoding = end;
                end = this.length;
            }
            if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
            if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
            if (val.length === 1) {
                const code = val.charCodeAt(0);
                if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
                val = code;
            }
        } else if (typeof val === 'number') val = val & 255;
        else if (typeof val === 'boolean') val = Number(val);
        // Invalid ranges are not set to a default, so can range check early.
        if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
        if (end <= start) return this;
        start = start >>> 0;
        end = end === undefined ? this.length : end >>> 0;
        if (!val) val = 0;
        let i;
        if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
        else {
            const bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
            const len = bytes.length;
            if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
            for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
        }
        return this;
    };
    // CUSTOM ERRORS
    // =============
    // Simplified versions from Node, changed for Buffer-only usage
    const errors = {};
    function E(sym, getMessage, Base) {
        errors[sym] = class NodeError extends Base {
            constructor(){
                super();
                Object.defineProperty(this, 'message', {
                    value: getMessage.apply(this, arguments),
                    writable: true,
                    configurable: true
                });
                // Add the error code to the name to include it in the stack trace.
                this.name = `${this.name} [${sym}]`;
                // Access the stack to generate the error message including the error code
                // from the name.
                this.stack; // eslint-disable-line no-unused-expressions
                // Reset the name to the actual name.
                delete this.name;
            }
            get code() {
                return sym;
            }
            set code(value) {
                Object.defineProperty(this, 'code', {
                    configurable: true,
                    enumerable: true,
                    value: value,
                    writable: true
                });
            }
            toString() {
                return `${this.name} [${sym}]: ${this.message}`;
            }
        };
    }
    E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
        if (name) return `${name} is outside of buffer bounds`;
        return 'Attempt to access memory outside buffer bounds';
    }, RangeError);
    E('ERR_INVALID_ARG_TYPE', function(name, actual) {
        return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
    }, TypeError);
    E('ERR_OUT_OF_RANGE', function(str, range, input) {
        let msg = `The value of "${str}" is out of range.`;
        let received = input;
        if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = addNumericalSeparator(String(input));
        else if (typeof input === 'bigint') {
            received = String(input);
            if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = addNumericalSeparator(received);
            received += 'n';
        }
        msg += ` It must be ${range}. Received ${received}`;
        return msg;
    }, RangeError);
    function addNumericalSeparator(val) {
        let res = '';
        let i = val.length;
        const start = val[0] === '-' ? 1 : 0;
        for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
        return `${val.slice(0, i)}${res}`;
    }
    // CHECK FUNCTIONS
    // ===============
    function checkBounds(buf, offset, byteLength) {
        validateNumber(offset, 'offset');
        if (buf[offset] === undefined || buf[offset + byteLength] === undefined) boundsError(offset, buf.length - (byteLength + 1));
    }
    function checkIntBI(value, min, max, buf, offset, byteLength) {
        if (value > max || value < min) {
            const n = typeof min === 'bigint' ? 'n' : '';
            let range;
            if (byteLength > 3) {
                if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
                else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
            } else range = `>= ${min}${n} and <= ${max}${n}`;
            throw new errors.ERR_OUT_OF_RANGE('value', range, value);
        }
        checkBounds(buf, offset, byteLength);
    }
    function validateNumber(value, name) {
        if (typeof value !== 'number') throw new errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
    }
    function boundsError(value, length, type) {
        if (Math.floor(value) !== value) {
            validateNumber(value, type);
            throw new errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
        }
        if (length < 0) throw new errors.ERR_BUFFER_OUT_OF_BOUNDS();
        throw new errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
    }
    // HELPER FUNCTIONS
    // ================
    const INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
    function base64clean(str) {
        // Node takes equal signs as end of the Base64 encoding
        str = str.split('=')[0];
        // Node strips out invalid characters like \n and \t from the string, base64-js does not
        str = str.trim().replace(INVALID_BASE64_RE, '');
        // Node converts strings with length < 2 to ''
        if (str.length < 2) return '';
        // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
        while(str.length % 4 !== 0)str = str + '=';
        return str;
    }
    function utf8ToBytes(string, units) {
        units = units || Infinity;
        let codePoint;
        const length = string.length;
        let leadSurrogate = null;
        const bytes = [];
        for(let i = 0; i < length; ++i){
            codePoint = string.charCodeAt(i);
            // is surrogate component
            if (codePoint > 0xD7FF && codePoint < 0xE000) {
                // last char was a lead
                if (!leadSurrogate) {
                    // no lead yet
                    if (codePoint > 0xDBFF) {
                        // unexpected trail
                        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                        continue;
                    } else if (i + 1 === length) {
                        // unpaired lead
                        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                        continue;
                    }
                    // valid lead
                    leadSurrogate = codePoint;
                    continue;
                }
                // 2 leads in a row
                if (codePoint < 0xDC00) {
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    leadSurrogate = codePoint;
                    continue;
                }
                // valid surrogate pair
                codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
            } else if (leadSurrogate) // valid bmp char, but last char was a lead
            {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
            }
            leadSurrogate = null;
            // encode utf8
            if (codePoint < 0x80) {
                if ((units -= 1) < 0) break;
                bytes.push(codePoint);
            } else if (codePoint < 0x800) {
                if ((units -= 2) < 0) break;
                bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
            } else if (codePoint < 0x10000) {
                if ((units -= 3) < 0) break;
                bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
            } else if (codePoint < 0x110000) {
                if ((units -= 4) < 0) break;
                bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
            } else throw new Error('Invalid code point');
        }
        return bytes;
    }
    function asciiToBytes(str) {
        const byteArray = [];
        for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
        byteArray.push(str.charCodeAt(i) & 0xFF);
        return byteArray;
    }
    function utf16leToBytes(str, units) {
        let c, hi, lo;
        const byteArray = [];
        for(let i = 0; i < str.length; ++i){
            if ((units -= 2) < 0) break;
            c = str.charCodeAt(i);
            hi = c >> 8;
            lo = c % 256;
            byteArray.push(lo);
            byteArray.push(hi);
        }
        return byteArray;
    }
    function base64ToBytes(str) {
        return base64.toByteArray(base64clean(str));
    }
    function blitBuffer(src, dst, offset, length) {
        let i;
        for(i = 0; i < length; ++i){
            if (i + offset >= dst.length || i >= src.length) break;
            dst[i + offset] = src[i];
        }
        return i;
    }
    // ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
    // the `instanceof` check but they should be treated as of that type.
    // See: https://github.com/feross/buffer/issues/166
    function isInstance(obj, type) {
        return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
    }
    function numberIsNaN(obj) {
        // For IE11 support
        return obj !== obj // eslint-disable-line no-self-compare
        ;
    }
    // Create lookup table for `toString('hex')`
    // See: https://github.com/feross/buffer/issues/219
    const hexSliceLookupTable = function() {
        const alphabet = '0123456789abcdef';
        const table = new Array(256);
        for(let i = 0; i < 16; ++i){
            const i16 = i * 16;
            for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
        }
        return table;
    }();
    // Return not function with Error if BigInt not supported
    function defineBigIntMethod(fn) {
        return typeof BigInt === 'undefined' ? BufferBigIntNotDefined : fn;
    }
    function BufferBigIntNotDefined() {
        throw new Error('BigInt not supported');
    }
})($6eea7234d56610fe$var$buffer);
const $6eea7234d56610fe$var$Buffer = $6eea7234d56610fe$var$buffer.Buffer;
const $6eea7234d56610fe$var$container = {
    display: "flex",
    outline: "none",
    gap: "0px",
    "flex-direction": "row",
    width: "fit-content",
    height: "fit-content",
    "border-style": "solid",
    "border-width": "0px",
    "padding-top": "0px",
    "padding-right": "0px",
    "padding-bottom": "0px",
    "padding-left": "0px",
    opacity: "100",
    "background-color": "transparent",
    "box-sizing": "border-box",
    "border-radius": "0px",
    "flex-shrink": "initial"
};
const $6eea7234d56610fe$var$input = {
    "border-style": "solid",
    "border-width": "0px"
};
const $6eea7234d56610fe$var$text = {
    display: "inline",
    "text-align": "start",
    "text-decoration": "none"
};
const $6eea7234d56610fe$var$icon = {
    display: "flex"
};
const $6eea7234d56610fe$var$loader = {
    display: "inline-block"
};
const $6eea7234d56610fe$var$image = {
    display: "block",
    width: "100%"
};
const $6eea7234d56610fe$var$slot = {
    display: "flex"
};
const $6eea7234d56610fe$export$bb974f6f0c330fb = {
    container: $6eea7234d56610fe$var$container,
    input: $6eea7234d56610fe$var$input,
    text: $6eea7234d56610fe$var$text,
    icon: $6eea7234d56610fe$var$icon,
    loader: $6eea7234d56610fe$var$loader,
    image: $6eea7234d56610fe$var$image,
    slot: $6eea7234d56610fe$var$slot
};
const $6eea7234d56610fe$var$layerDefaults$1 = /*#__PURE__*/ Object.freeze(/*#__PURE__*/ Object.defineProperty({
    __proto__: null,
    container: $6eea7234d56610fe$var$container,
    default: $6eea7234d56610fe$export$bb974f6f0c330fb,
    icon: $6eea7234d56610fe$var$icon,
    image: $6eea7234d56610fe$var$image,
    input: $6eea7234d56610fe$var$input,
    loader: $6eea7234d56610fe$var$loader,
    slot: $6eea7234d56610fe$var$slot,
    text: $6eea7234d56610fe$var$text
}, Symbol.toStringTag, {
    value: 'Module'
}));
const $6eea7234d56610fe$var$prefixMap = {
    "background-color": "bg",
    color: "text",
    "border-color": "stroke"
};
const $6eea7234d56610fe$var$colorClassRuleHandler = (rule, ruleVal, tokens)=>{
    if (!$6eea7234d56610fe$export$859883d4ec9c7db4.brandResolverFn) return;
    if (typeof ruleVal === "object") {
        console.warn("Object values are not supported");
        return;
    }
    const resolved = $6eea7234d56610fe$export$859883d4ec9c7db4.brandResolverFn(rule, ruleVal, tokens, false);
    const prefix = $6eea7234d56610fe$var$prefixMap[rule];
    if (resolved?.value === "transparent") return `${prefix}-transparent`;
    const scale = resolved?.key?.split(".")[1];
    if (scale) {
        const klass = `${prefix}-${tokens["appearance"]}-${scale}`;
        return klass;
    }
    return void 0;
};
const $6eea7234d56610fe$export$e9552252b443446 = {
    "background-color": $6eea7234d56610fe$var$colorClassRuleHandler,
    color: $6eea7234d56610fe$var$colorClassRuleHandler,
    "border-color": $6eea7234d56610fe$var$colorClassRuleHandler,
    "font-size": ()=>null,
    "line-height": ()=>null,
    "letter-spacing": ()=>null,
    "font-weight": ()=>null
};
const $6eea7234d56610fe$var$defaults = $6eea7234d56610fe$var$layerDefaults$1;
const $6eea7234d56610fe$var$tokenSuffixShortKey = {
    default: "d",
    hover: "h",
    focus: "f",
    active: "a",
    visited: "v"
};
const $6eea7234d56610fe$var$tokenRuleShortKey = {
    "align-items": "al-it",
    "aspect-ratio": "as-rt",
    "background-color": "bg-cl",
    "blur-radius": "bl-rd",
    "border-color": "br-cl",
    "border-radius": "br-rd",
    "border-style": "br-st",
    "border-width": "br-wd",
    "border-top-width": "brt-wd",
    "border-right-width": "brr-wd",
    "border-bottom-width": "brb-wd",
    "border-left-width": "brl-w",
    "border-top-color": "brt-cl",
    "border-right-color": "brr-cl",
    "border-bottom-color": "brb-cl",
    "border-left-color": "brl-cl",
    "border-top-left-radius": "brtl-r",
    "border-top-right-radius": "brtr-r",
    "border-bottom-right-radius": "brbr-r",
    "border-bottom-left-radius": "brbl-r",
    bottom: "bt",
    "box-shadow": "bx-sh",
    "box-sizing": "bx-sz",
    color: "cl",
    cursor: "cur",
    display: "dis",
    flex: "fx",
    "flex-direction": "fx-dr",
    "font-family": "fo-fm",
    "font-size": "fo-sz",
    "font-weight": "fo-wt",
    gap: "gp",
    height: "ht",
    "justify-content": "js-ct",
    left: "lt",
    "letter-spacing": "lt-sp",
    "line-height": "ln-ht",
    "max-height": "mx-ht",
    "max-width": "mx-wd",
    "min-height": "mn-ht",
    "min-width": "mn-wd",
    opacity: "op",
    outline: "ol",
    overflow: "ov",
    "padding-bottom": "pd-b",
    "padding-left": "pd-l",
    "padding-right": "pd-r",
    "padding-top": "pd-t",
    "pointer-events": "pe",
    position: "pos",
    right: "rt",
    rotate: "rot",
    "text-align": "tx-al",
    "text-decoration": "tx-dc",
    "text-overflow": "tx-ol",
    "text-transform": "tx-tf",
    "object-fit": "oj-ft",
    "object-position": "oj-ps",
    size: "sz",
    up: "up",
    width: "wd",
    "z-index": "zi"
};
function $6eea7234d56610fe$export$92b70e511152790f(layerName) {
    return layerName.split("-").pop();
}
function $6eea7234d56610fe$export$82c717ab02da3bac(componentName, layerName) {
    return `${componentName}-${layerName}`;
}
function $6eea7234d56610fe$export$31e4419873013369(hierarchy) {
    const root = hierarchy;
    if (typeof root === "object") return Object.keys(root)[0];
    return "";
}
function $6eea7234d56610fe$export$8bf78da42833d414(hierarchy) {
    if (typeof hierarchy === "string") return [
        hierarchy
    ];
    const root = $6eea7234d56610fe$export$31e4419873013369(hierarchy);
    const layers = [
        root
    ];
    const children = hierarchy[root] ?? [];
    for (const child of children)layers.push(...$6eea7234d56610fe$export$8bf78da42833d414(child));
    return layers;
}
function $6eea7234d56610fe$export$ce4be320c9b7d5be(json) {
    const base = (0, $bff35c0dd9851fab$export$b7d58db314e0ac27)(json.base);
    for(const prop in json.variant){
        const propObj = json.variant[prop];
        for(const key in propObj){
            const variant = propObj[key];
            for(const layer in variant)base[layer] = $6eea7234d56610fe$var$handleInvariantBaseMap(base[layer], variant[layer]);
        }
    }
    for(const layer in json.api.data || {}){
        for (const apiItem of Object.keys(json.api.data?.[layer] || {}))if (base[layer]?.[apiItem]) delete base[layer][apiItem];
    }
    const combinations = $6eea7234d56610fe$var$getAllCombinations({}, json);
    for(const layer in combinations)base[layer] = $6eea7234d56610fe$var$handleInvariantBaseMap(base[layer], combinations[layer]);
    for(const layer in base)for(const key in base[layer]){
        const value = base[layer][key];
        if (String(value).includes("&color")) delete base[layer][key];
    }
    return base;
}
function $6eea7234d56610fe$var$handleInvariantBaseMap(baseItem, variantItem) {
    const { behavior: variantBehavior, ...variantBaseMap } = variantItem;
    if (!baseItem) return baseItem;
    const { behavior: behavior, ...baseMap } = baseItem;
    baseItem = $6eea7234d56610fe$var$removeVariantProps(baseMap, variantBaseMap);
    if (!behavior || !variantBehavior) return behavior ? {
        ...baseItem,
        behavior: behavior
    } : baseItem;
    for(const pseudo in variantBehavior){
        const pseudoBaseMap = behavior?.[pseudo];
        if (!pseudoBaseMap) continue;
        const pseudoVariantBaseMap = variantBehavior[pseudo];
        behavior[pseudo] = $6eea7234d56610fe$var$removeVariantProps(pseudoBaseMap, pseudoVariantBaseMap);
    }
    return behavior ? {
        ...baseItem,
        behavior: behavior
    } : baseItem;
}
function $6eea7234d56610fe$var$removeVariantProps(baseMap, variantBaseMap) {
    if (!baseMap) return baseMap;
    for(const property in variantBaseMap){
        const value = variantBaseMap[property];
        if (typeof value === "object" && !Array.isArray(value)) {
            baseMap[property] = $6eea7234d56610fe$var$removeVariantProps(baseMap[property], value);
            continue;
        }
        if (property in baseMap) delete baseMap[property];
    }
    function handleObject(baseMap2) {
        for(const property in baseMap2){
            const value = baseMap2[property];
            if (!value) continue;
            if (typeof value === "string") {
                if (value.includes("&") || value.includes("%")) delete baseMap2[property];
            } else if (typeof value === "object" && !Array.isArray(value)) handleObject(value);
        }
    }
    handleObject(baseMap);
    return baseMap;
}
const $6eea7234d56610fe$export$c1260eec73bdf31d = (componentName, layer)=>`j-${componentName}-${layer}`;
const $6eea7234d56610fe$export$437bd2c771393299 = (componentName, layer, rule, includeComponentName)=>{
    const shortRule = $6eea7234d56610fe$var$tokenRuleShortKey[rule] || rule;
    const layerKey = $6eea7234d56610fe$export$92b70e511152790f(layer);
    if (!includeComponentName || layerKey !== "container") return `--${layer}-${shortRule}`;
    return `--${componentName.toLowerCase()}--${layer}-${shortRule}`;
};
const $6eea7234d56610fe$export$246d3e180f7f2ea = (componentName, layer, rule, includeComponentName, pseudo)=>{
    const cssVar = $6eea7234d56610fe$export$437bd2c771393299(componentName, layer, rule, includeComponentName);
    if (pseudo) return `${cssVar}-${$6eea7234d56610fe$var$tokenSuffixShortKey[pseudo] || pseudo}`;
    return cssVar;
};
const $6eea7234d56610fe$export$2ee1162feea7fbb0 = (componentName, layer, rule, value, isInvariant, pseudo, tokens)=>{
    return $6eea7234d56610fe$var$createStyleRule(componentName, layer, rule, [
        rule
    ], value, isInvariant, pseudo, tokens);
};
const $6eea7234d56610fe$export$e8ddbfc1e3d5162b = (componentName, layer, rule, variables, value, isInvariant, pseudo, tokens)=>{
    return $6eea7234d56610fe$var$createStyleRule(componentName, layer, rule, variables, value, isInvariant, pseudo, tokens);
};
const $6eea7234d56610fe$var$RULE_DEFAULTS = {
    translate: "0px",
    rotate: "0deg",
    scale: "1",
    "border-top-width": "0px",
    "border-right-width": "0px",
    "border-bottom-width": "0px",
    "border-left-width": "0px"
};
function $6eea7234d56610fe$var$createStyleRule(componentName, layer, rule, variables, value, isInvariant, pseudo, tokens) {
    const left = rule;
    const right = variables.map((variable, index)=>{
        const ruleDef = $6eea7234d56610fe$var$RULE_DEFAULTS[rule];
        const variableValue = Array.isArray(value) ? value[index] : value;
        const baseCssVar = $6eea7234d56610fe$export$437bd2c771393299(componentName, layer, variable, tokens?.["brandVersion"] === "jio-v2");
        if (tokens && isInvariant && typeof variableValue !== "object") {
            const resolved = $6eea7234d56610fe$export$37bc2ce5722481d2(rule, variableValue, tokens);
            if (resolved) return resolved;
        }
        if (tokens && typeof variableValue !== "object") {
            const resolved = $6eea7234d56610fe$export$37bc2ce5722481d2(rule, variableValue, tokens);
            if (resolved) {
                if (ruleDef && resolved.includes("var(")) {
                    const innermostVar = /var\(\s*--[^,)]+\)/;
                    const resolvedWithDefault = resolved.replace(innermostVar, (match)=>`${match.slice(0, -1)}, ${ruleDef})`);
                    return `var(${baseCssVar}, ${resolvedWithDefault})`;
                }
                return `var(${baseCssVar}, ${resolved})`;
            }
        }
        const cssVar = ruleDef ? `var(${baseCssVar}, ${ruleDef})` : `var(${baseCssVar})`;
        return pseudo ? `var(${$6eea7234d56610fe$export$246d3e180f7f2ea(componentName, layer, variable, tokens?.["brandVersion"] === "jio-v2", pseudo)}, ${cssVar})` : cssVar;
    }).join(" ");
    return {
        [left]: right
    };
}
function $6eea7234d56610fe$export$c52007b28a606662(componentName, layer, rule, value, pseudo, tokens) {
    return {
        [$6eea7234d56610fe$export$246d3e180f7f2ea(componentName, layer, rule, tokens?.["brandVersion"] === "jio-v2" && !pseudo, pseudo)]: value?.toString()
    };
}
function $6eea7234d56610fe$export$6ebbb579f04445e(componentName, layer, rule, ruleVal, pseudo, layerMap, tokens) {
    if (rule in $6eea7234d56610fe$export$95994f4e1548c018) return $6eea7234d56610fe$export$95994f4e1548c018[rule](componentName, layer, rule, ruleVal, pseudo, layerMap, tokens);
    return {};
}
function $6eea7234d56610fe$export$a8136d362b12b985(rule, ruleVal, tokens, pseudo) {
    if (rule in $6eea7234d56610fe$export$e9552252b443446) return $6eea7234d56610fe$export$e9552252b443446[rule](rule, ruleVal, tokens, pseudo);
    return void 0;
}
const $6eea7234d56610fe$export$875845b80e4c01b3 = (layer, length = 1)=>layer.split("-").map((x, index, arr)=>index !== arr.length - 1 ? x.slice(0, length) : x).filter(Boolean).join("-");
function $6eea7234d56610fe$export$43447905499a2c3e(componentName, layer, layerMap, invariantsMap, layerShortKey, pseudo, tokens) {
    const newTokens = {
        ...tokens
    };
    Object.keys(invariantsMap || {}).forEach((key2)=>{
        if (key2 in newTokens) newTokens[key2] = invariantsMap?.[key2]?.toString() ?? newTokens[key2];
    });
    const brandDefaults = $6eea7234d56610fe$export$859883d4ec9c7db4.defaults ?? {};
    const layerCSSVars = {};
    const layerClasses = [];
    const key = !pseudo && $6eea7234d56610fe$export$92b70e511152790f(layer);
    if (newTokens && newTokens?.["brandVersion"] === "jio-v2") {
        if (key && brandDefaults[key]) layerMap = (0, $bff35c0dd9851fab$export$4950aa0f605343fb)(brandDefaults[key] ?? {}, layerMap);
    } else if (key && ($6eea7234d56610fe$var$defaults[key] || brandDefaults[key])) layerMap = (0, $bff35c0dd9851fab$export$4950aa0f605343fb)($6eea7234d56610fe$var$defaults[key] ?? {}, brandDefaults[key] ?? {}, layerMap);
    for(const rule in layerMap){
        if (invariantsMap?.[rule]) continue;
        const useClasses = rule in $6eea7234d56610fe$export$e9552252b443446 && newTokens && newTokens?.["brandVersion"] === "jio-v2" && // String(layerMap[rule]).includes('&') &&
        !pseudo;
        if (useClasses) {
            const klass = $6eea7234d56610fe$export$a8136d362b12b985(rule, layerMap[rule], newTokens);
            if (klass) {
                layerClasses.push(klass);
                continue;
            }
            if (klass === null) continue;
        }
        Object.assign(layerCSSVars, $6eea7234d56610fe$export$6ebbb579f04445e(componentName, layerShortKey, rule, layerMap[rule], pseudo, layerMap, tokens));
    }
    return {
        styles: layerCSSVars,
        classes: layerClasses
    };
}
const $6eea7234d56610fe$export$beb192a6dc60a1a7 = [
    "appearance",
    "surface",
    "strokeSurface",
    "color",
    "background-color",
    "border-color",
    "fill"
];
function $6eea7234d56610fe$export$5cc69797806ce5c5(tokens, baseMap) {
    const colorProperty = Object.keys(baseMap || {}).find((key)=>key.endsWith("color") && !key.includes("border"));
    const borderColorProperty = Object.keys(baseMap || {}).find((key)=>key.includes("border"));
    const colorToken = (0, $bff35c0dd9851fab$export$5fe300a9008e2bfc)(String(baseMap?.[colorProperty ?? ""]) || "");
    const borderColorToken = (0, $bff35c0dd9851fab$export$5fe300a9008e2bfc)(String(baseMap?.[borderColorProperty ?? ""]) || "");
    const surface = colorToken?.split("_")?.[2];
    const strokeSurface = borderColorToken?.split("_")?.[2];
    const baseSurface = baseMap?.["surface"]?.toString();
    const baseStrokeSurface = baseMap?.["strokeSurface"]?.toString();
    const newTokens = {
        ...tokens,
        surface: baseSurface || surface || tokens["surface"],
        strokeSurface: baseStrokeSurface || strokeSurface || tokens["strokeSurface"]
    };
    if (tokens?.["brandVersion"] === "jio-v2" && $6eea7234d56610fe$export$859883d4ec9c7db4.updateFlatTokens) {
        const updatedTokens = $6eea7234d56610fe$export$859883d4ec9c7db4.updateFlatTokens({
            ...newTokens
        });
        updatedTokens["parentScale"] = newTokens["scale"];
        return updatedTokens;
    }
    return newTokens;
}
function $6eea7234d56610fe$export$8c51a6ab64fc75e8(component, base, variant, config) {
    for(const prop in variant)if (prop in component) {
        const propValues = Object.keys(variant[prop]);
        const matchIndex = propValues.indexOf($6eea7234d56610fe$var$getProp(component, prop));
        if (matchIndex > -1) base = (0, $bff35c0dd9851fab$export$4950aa0f605343fb)(base, variant[prop][propValues[matchIndex]]);
    } else base = (0, $bff35c0dd9851fab$export$4950aa0f605343fb)(base, variant[prop][String(config?.[0]?.values?.[0])]);
    return base;
}
function $6eea7234d56610fe$var$getProp(component, prop) {
    return Object(component)[prop]?.toString?.() ?? "";
}
function $6eea7234d56610fe$export$376823fb52709d2f(component, base, combinations, combinationConfigs, config) {
    combinationConfigs.forEach((combinationConfig, configIndex)=>{
        let partialCombination = combinations[configIndex];
        for (const prop of combinationConfig){
            if (prop in component && component[prop] !== void 0) partialCombination = partialCombination[$6eea7234d56610fe$var$getProp(component, prop)];
            else {
                const defaultValue = config?.[prop].values?.[0];
                if (typeof defaultValue !== "undefined") partialCombination = partialCombination[defaultValue.toString()];
            }
            if (!partialCombination) break;
        }
        base = (0, $bff35c0dd9851fab$export$4950aa0f605343fb)(base, partialCombination);
    });
    return base;
}
function $6eea7234d56610fe$export$14c44c1e95c03f0a(json) {
    let combined = {
        ...json.base
    };
    for(const prop in json.variant){
        const propObj = json.variant[prop];
        for(const key in propObj)combined = $6eea7234d56610fe$var$mergeWithBooleanAnd(combined, propObj[key]);
    }
    combined = $6eea7234d56610fe$var$getAllCombinations(combined, json);
    combined = $6eea7234d56610fe$var$combineBehaviors(combined);
    return combined;
}
function $6eea7234d56610fe$var$mergeWithBooleanAnd(base, second) {
    const merged = {};
    const keys = [
        ...Object.keys(base),
        ...Object.keys(second)
    ];
    for (const key of keys){
        if (!(key in second)) merged[key] = base[key];
        else if (!(key in base)) merged[key] = second[key];
        else merged[key] = $6eea7234d56610fe$var$mergeValues(base[key], second[key]);
    }
    return merged;
}
function $6eea7234d56610fe$var$mergeValues(base, second) {
    if ($6eea7234d56610fe$var$isObject(base) && $6eea7234d56610fe$var$isObject(second)) return $6eea7234d56610fe$var$mergeWithBooleanAnd(base, second);
    else if ($6eea7234d56610fe$var$isArray(base) && $6eea7234d56610fe$var$isArray(second)) return [
        ...base,
        ...second
    ];
    else if (typeof base === "boolean" && typeof second === "boolean") return base && second;
    return second;
}
function $6eea7234d56610fe$var$isObject(value) {
    return typeof value === "object" && value !== null && !Array.isArray(value);
}
function $6eea7234d56610fe$var$isArray(value) {
    return Array.isArray(value);
}
function $6eea7234d56610fe$var$getAllCombinations(combined, json) {
    const { combination: combination, combination_config: combination_config } = json;
    if (combination && combination_config) for(let index = 0; index < combination_config.length; index++){
        const config = combination_config[index];
        const comb = combination[index];
        combined = (0, $bff35c0dd9851fab$export$4950aa0f605343fb)(combined, $6eea7234d56610fe$var$getCombination(comb, config));
    }
    return combined;
}
function $6eea7234d56610fe$var$combineBehaviors(combined) {
    for(const layer in combined){
        let baseMap = combined[layer];
        for(const pseudo in baseMap.behavior)baseMap = (0, $bff35c0dd9851fab$export$4950aa0f605343fb)(baseMap, baseMap.behavior[pseudo]);
        combined[layer] = baseMap;
    }
    return combined;
}
function $6eea7234d56610fe$var$getCombination(currentCombination, configKeys) {
    if (configKeys.length === 0) return {};
    else if (configKeys.length === 1) {
        const bases = Object.values(currentCombination);
        return (0, $bff35c0dd9851fab$export$4950aa0f605343fb)(bases[0], ...bases.slice(1));
    }
    const remainingKeys = configKeys.slice(1);
    const combinations = Object.values(currentCombination);
    let result = {};
    for (const comb of combinations){
        const base = $6eea7234d56610fe$var$getCombination(comb, remainingKeys);
        result = (0, $bff35c0dd9851fab$export$4950aa0f605343fb)(result, base);
    }
    return result;
}
const $6eea7234d56610fe$var$BufferConverter = (value)=>{
    return $6eea7234d56610fe$var$Buffer.from(value, "base64").toString("utf-8");
};
const $6eea7234d56610fe$export$9cc362b209501dfe = (value)=>{
    if (!value) return {};
    const converter = typeof window === "undefined" ? $6eea7234d56610fe$var$BufferConverter : window.atob;
    const objectString = converter(value);
    return JSON.parse(objectString || "{}");
};
const $6eea7234d56610fe$export$b46037aad3580cfb = (value)=>{
    return window.btoa(JSON.stringify(value));
};
const $6eea7234d56610fe$export$2b19bce00ae0a812 = /%([A-Za-z]+)/;
function $6eea7234d56610fe$export$61b94149aeb1f59(api) {
    const config = api.config;
    const data = api.data;
    const defaultProps = {};
    for(const key in config){
        const item = config[key];
        if (item.values) {
            const index = item.defaultIndex ?? 0;
            const value = item.values[index] ?? item.values[0];
            if (value) defaultProps[key] = value;
        }
    }
    for(const layer in data){
        const datum = data[layer];
        for(const key in datum){
            const item = datum[key];
            if (item.values) {
                const index = item.defaultIndex ?? 0;
                const value = item.values[index] ?? item.values[0];
                if (value) defaultProps[key] = value;
            }
        }
    }
    return defaultProps;
}
function $6eea7234d56610fe$export$2ea6a22288ddba23(api) {
    const { data: data, config: config } = api;
    if (config?.["appearance"]) {
        const item = config["appearance"];
        if (item.defaultIndex) return item.values?.[item.defaultIndex].toString() ?? item.values?.[0].toString() ?? "auto";
    } else for(const layer in data){
        const datum = data[layer];
        for(const key in datum){
            const item = datum[key];
            if (item.name === "appearance" && item.type === "enum") return item.values?.[0]?.toString() ?? "auto";
        }
    }
    return "auto";
}
function $6eea7234d56610fe$export$bdcbab1cb38db489(val) {
    return typeof val === "string" && /{.*}/.test(val);
}
const $6eea7234d56610fe$var$defaultCSSVarRuleHandler = (component, layer, rule, value, pseudo, _, tokens)=>{
    if (typeof value === "object") {
        console.warn("Cannot process Object directly");
        return {};
    }
    value = $6eea7234d56610fe$export$37bc2ce5722481d2(rule, value, tokens);
    return $6eea7234d56610fe$export$c52007b28a606662(component, layer, rule, value, pseudo, tokens);
};
const $6eea7234d56610fe$var$lineHeightCSSVarRuleHandler = (component, layer, rule, value, pseudo, _, tokens)=>{
    if (typeof value === "object") {
        console.warn("Cannot process Object directly");
        return {};
    }
    value = $6eea7234d56610fe$export$37bc2ce5722481d2(rule, value, tokens);
    if (tokens?.["brandVersion"] === "jio-v2" && !String(value).endsWith("%")) value = `calc(${value} * 1%)`;
    return $6eea7234d56610fe$export$c52007b28a606662(component, layer, rule, value, pseudo, tokens);
};
const $6eea7234d56610fe$var$colorCSSVarRuleHandler = (component, layer, rule, value, pseudo, _, tokens)=>{
    if (typeof value === "object") {
        console.warn("Cannot process Object directly");
        return {};
    }
    const originalValue = value;
    value = $6eea7234d56610fe$export$37bc2ce5722481d2(rule, value, tokens);
    if (String(originalValue).includes("elevated")) {
        const bgVarItems = String(value).split(",");
        const [bgColor, shadowColor, x1, y1, r1, x2, y2, r2, borderColor, borderWidth] = String(bgVarItems[1] || value).split(";");
        return {
            ...$6eea7234d56610fe$export$c52007b28a606662(component, layer, rule, bgColor, pseudo, tokens),
            ...borderWidth ? $6eea7234d56610fe$export$c52007b28a606662(component, layer, "border-width", `${borderWidth}px`, pseudo, tokens) : {},
            ...x1 || x2 || y1 || y2 || r1 || r2 ? $6eea7234d56610fe$export$c52007b28a606662(component, layer, "box-shadow", `${x1}px ${y1}px ${r1}px ${shadowColor}, ${x2}px ${y2}px ${r2}px ${shadowColor}`, pseudo, tokens) : {},
            ...$6eea7234d56610fe$export$c52007b28a606662(component, layer, "border-color", `${borderColor}`, pseudo, tokens)
        };
    }
    return $6eea7234d56610fe$export$c52007b28a606662(component, layer, rule, value, pseudo, tokens);
};
const $6eea7234d56610fe$var$isCSSVar = (value)=>value.startsWith("var(--");
const $6eea7234d56610fe$var$dimensionsCSSVarRuleHandler = (component, layer, rule, value, pseudo, _, tokens)=>{
    const supportedValues = [
        "100%",
        "fit-content",
        "max",
        "min",
        "intrinsicSize.max",
        "intrinsicSize.min"
    ];
    if (typeof value === "object") {
        console.warn("Cannot process Object directly");
        return {};
    }
    const layerParts = layer.split("-");
    const baseLayer = layerParts[layerParts.length - 1];
    value = $6eea7234d56610fe$export$37bc2ce5722481d2(rule, value, tokens);
    if (!supportedValues.includes(value) && !$6eea7234d56610fe$var$isCSSVar(value)) {
        if (isNaN(parseFloat(value))) value = $6eea7234d56610fe$export$bb974f6f0c330fb[baseLayer]?.[rule];
    }
    if (value === "max") value = "100%";
    if (value === "min") value = "fit-content";
    if (value === "intrinsicSize.max") value = "unset";
    return $6eea7234d56610fe$export$c52007b28a606662(component, layer, rule, value, pseudo, tokens);
};
const $6eea7234d56610fe$var$borderGradientColorCSSVarRuleHandler = (component, layer, _, value, pseudo)=>{
    if (typeof value === "object") return $6eea7234d56610fe$var$handleBorderGradientColorObject(component, layer, "border-image", value, pseudo);
    return $6eea7234d56610fe$var$defaultCSSVarRuleHandler(component, layer, "border-image", value, pseudo);
};
const $6eea7234d56610fe$var$backgroundGradientColorCSSVarRuleHandler = (component, layer, _, value, pseudo)=>{
    if (typeof value === "object") return $6eea7234d56610fe$var$handleBackgroundGradientColorObject(component, layer, "background-image", value, pseudo);
    return $6eea7234d56610fe$var$defaultCSSVarRuleHandler(component, layer, "background-image", value, pseudo);
};
const $6eea7234d56610fe$var$handleBackgroundGradientColorObject = (componentName, layer, rule, ruleVal, pseudo, _layerMap, tokens)=>{
    const { type: type, colors: colors, angle: angle } = ruleVal;
    const colorStops = Array.from(colors).join(",");
    if (type === "radial") {
        const resolvedValue = `radial-gradient(circle, ${colorStops})`;
        return $6eea7234d56610fe$export$c52007b28a606662(componentName, layer, rule, resolvedValue, pseudo, tokens);
    } else if (type === "linear") {
        const degAngle = $6eea7234d56610fe$export$95c38a73fd251991("rotate", angle ?? 180);
        const resolvedValue = `linear-gradient(${degAngle}, ${colorStops})`;
        return $6eea7234d56610fe$export$c52007b28a606662(componentName, layer, rule, resolvedValue, pseudo, tokens);
    }
    console.warn("Unknown background gradient in", componentName, layer);
    return {};
};
const $6eea7234d56610fe$var$handleBorderGradientColorObject = (componentName, layer, rule, ruleVal, pseudo, _layerMap, tokens)=>{
    const { type: type, colors: colors, width: width } = ruleVal;
    const typeMap = {
        radial: "radial-gradient",
        linear: "linear-gradient"
    };
    const colorStops = colors.join(",");
    const resolvedValue = `${typeMap[type]}(circle,${colorStops}) ${width}`;
    return $6eea7234d56610fe$export$c52007b28a606662(componentName, layer, rule, resolvedValue, pseudo, tokens);
};
const $6eea7234d56610fe$var$sizeCSSVarRuleHandler = (component, layer, _rule, value, pseudo, layerMap, tokens)=>({
        ...$6eea7234d56610fe$var$defaultCSSVarRuleHandler(component, layer, "height", value, pseudo, layerMap, tokens),
        ...$6eea7234d56610fe$var$dimensionsCSSVarRuleHandler(component, layer, "width", value, pseudo, layerMap, tokens)
    });
const $6eea7234d56610fe$var$boxShadowCSSVarRuleHandler = (componentName, layer, rule, ruleVal, pseudo, layerMap, tokens)=>{
    if (typeof ruleVal === "object") return $6eea7234d56610fe$var$handleBoxShadowObject(componentName, layer, rule, ruleVal, pseudo, tokens);
    return $6eea7234d56610fe$var$defaultCSSVarRuleHandler(componentName, layer, rule, ruleVal, pseudo, layerMap, tokens);
};
const $6eea7234d56610fe$var$boxShadowOrderedKeys = [
    "x",
    "y",
    "blur",
    "spread",
    "color"
];
const $6eea7234d56610fe$var$BOX_SHADOW_RULE_MAP = {
    x: "padding",
    y: "padding",
    blur: "padding",
    spread: "padding",
    color: "color"
};
function $6eea7234d56610fe$var$handleBoxShadowObject(componentName, layer, rule, ruleVal, pseudo, tokens) {
    const values = [];
    for (const key of $6eea7234d56610fe$var$boxShadowOrderedKeys){
        if (!(key in ruleVal)) continue;
        const value = ruleVal[key];
        const rule2 = $6eea7234d56610fe$var$BOX_SHADOW_RULE_MAP[key];
        const resolved = $6eea7234d56610fe$export$37bc2ce5722481d2(rule2, value, tokens);
        values.push(resolved);
    }
    return $6eea7234d56610fe$export$c52007b28a606662(componentName, layer, rule, values.join(" "), pseudo, tokens);
}
const $6eea7234d56610fe$var$flexDirectionCSSVarRuleHandler = (componentName, layer, rule, value, pseudo, _layerMap, tokens)=>{
    if (typeof value === "object") {
        console.warn("Cannot process Object directly");
        return {};
    }
    value = $6eea7234d56610fe$export$37bc2ce5722481d2(rule, value, tokens);
    const result = {};
    let position = "static";
    if (value.includes("stack")) {
        value = "row";
        position = "relative";
    }
    Object.assign(result, $6eea7234d56610fe$export$c52007b28a606662(componentName, layer, rule, value, pseudo, tokens), $6eea7234d56610fe$export$c52007b28a606662(componentName, layer, "position", position, pseudo, tokens));
    return result;
};
const $6eea7234d56610fe$var$borderWidthCSSVarRuleHandler = (componentName, layer, rule, ruleVal, pseudo, _, tokens)=>{
    if (typeof ruleVal === "object") {
        console.warn("Cannot process Object directly");
        return {};
    }
    ruleVal = $6eea7234d56610fe$export$37bc2ce5722481d2(rule, ruleVal, tokens);
    return $6eea7234d56610fe$export$c52007b28a606662(componentName, layer, rule, ruleVal, pseudo, tokens);
};
const $6eea7234d56610fe$var$blurRadiusCSSVarRuleHandler = (componentName, layer, rule, ruleVal, pseudo, _layerMap, tokens)=>{
    if (rule === "blur-radius") rule = "filter";
    else rule = "backdrop-filter";
    if (typeof ruleVal === "object") {
        console.warn("Cannot process Object directly");
        return {};
    }
    ruleVal = $6eea7234d56610fe$export$37bc2ce5722481d2(rule, ruleVal, tokens);
    ruleVal = `blur(${ruleVal})`;
    return $6eea7234d56610fe$export$c52007b28a606662(componentName, layer, "filter", ruleVal, pseudo, tokens);
};
const $6eea7234d56610fe$var$borderRulesMap = {
    "border-radius": [
        "border-top-left-radius",
        "border-top-right-radius",
        "border-bottom-right-radius",
        "border-bottom-left-radius"
    ],
    "border-width": [
        "border-top-width",
        "border-right-width",
        "border-bottom-width",
        "border-left-width"
    ],
    "border-color": [
        "border-top-color",
        "border-right-color",
        "border-bottom-color",
        "border-left-color"
    ]
};
function $6eea7234d56610fe$var$getBorderRules(rule) {
    return $6eea7234d56610fe$var$borderRulesMap[rule] || [];
}
const $6eea7234d56610fe$var$borderCSSVarRuleHandler = (componentName, layer, rule, ruleVal, pseudo, _layerMap, tokens)=>$6eea7234d56610fe$var$getBorderRules(rule).map((r)=>{
        if (typeof ruleVal === "object") {
            console.warn("Cannot process Object directly");
            return {};
        }
        ruleVal = $6eea7234d56610fe$export$37bc2ce5722481d2(rule, ruleVal, tokens);
        return $6eea7234d56610fe$export$c52007b28a606662(componentName, layer, r, ruleVal, pseudo, tokens);
    }).reduce((a, b)=>({
            ...a,
            ...b
        }), {});
const $6eea7234d56610fe$var$zIndexCSSVarRuleHandler = (componentName, layer, rule, value, pseudo, _layerMap, tokens)=>{
    if (typeof value === "object") {
        console.warn("Cannot process Object directly");
        return {};
    }
    value = $6eea7234d56610fe$export$37bc2ce5722481d2(rule, value, tokens);
    let position = "static";
    const num = parseInt(value);
    if (num !== 0) position = "absolute";
    return {
        ...$6eea7234d56610fe$export$c52007b28a606662(componentName, layer, rule, value, pseudo, tokens),
        ...$6eea7234d56610fe$export$c52007b28a606662(componentName, layer, "position", position, pseudo, tokens)
    };
};
const $6eea7234d56610fe$var$disabledCSSVarRuleHandler = (component, layer, _rule, value, pseudo, _layerMap, tokens)=>{
    if (typeof value === "object") {
        console.warn("Cannot process Object directly");
        return {};
    }
    value = $6eea7234d56610fe$export$37bc2ce5722481d2("pointer-events", value, tokens);
    value = !value || value === "false" ? "auto" : "none";
    return $6eea7234d56610fe$export$c52007b28a606662(component, layer, "pointer-events", value, pseudo, tokens);
};
const $6eea7234d56610fe$var$paddingCSSVarRuleHandler = (componentName, layer, rule, value, pseudo, layerMap, tokens)=>{
    if (typeof value === "object") {
        console.warn("Cannot process Object directly");
        return {};
    }
    value = $6eea7234d56610fe$export$37bc2ce5722481d2(rule, value, tokens);
    const paddingValue = $6eea7234d56610fe$export$c52007b28a606662(componentName, layer, rule, value, pseudo, tokens);
    const direction = rule.split("-")[1];
    const borderWidthRule = `border-${direction}-width`;
    const borderWidthValue = layerMap?.[borderWidthRule] || layerMap?.["border-width"];
    if (borderWidthValue) {
        const borderWidthCSSVar = $6eea7234d56610fe$var$borderWidthCSSVarRuleHandler(componentName, layer, borderWidthRule, borderWidthValue, pseudo, layerMap, tokens);
        const val = Object.values(borderWidthCSSVar)[0];
        if (val) {
            const key = Object.keys(paddingValue)[0];
            paddingValue[key] = `calc(${paddingValue[key]} - ${val})`;
        }
    }
    return paddingValue;
};
const $6eea7234d56610fe$var$buttonVectorRuleMap = {
    "fill-color": "color",
    "stroke-color": "color"
};
const $6eea7234d56610fe$var$skeletonRuleMap = {
    "primary-color": "color",
    "secondary-color": "color"
};
const $6eea7234d56610fe$var$inputRuleMap = {
    "inactive-color": "color",
    "active-color": "color",
    "ball-size": "height",
    "ball-color": "color",
    "ball-border-color": "color",
    "ball-border-width": "border-width",
    "track-height": "height",
    "placeholder-color": "color",
    "placeholder-font-family": "font-family",
    "placeholder-font-size": "font-size",
    "placeholder-line-height": "line-height",
    "placeholder-letter-spacing": "letter-spacing",
    "placeholder-font-weight": "font-weight",
    "input-color": "color",
    "input-font-family": "font-family",
    "input-font-size": "font-size",
    "input-line-height": "line-height",
    "input-letter-spacing": "letter-spacing",
    "input-font-weight": "font-weight",
    "resize-color": "color",
    "cursor-color": "color"
};
const $6eea7234d56610fe$var$inputCSSVarRuleHandler = (componentName, layer, rule, value, pseudo, _, tokens)=>{
    if (typeof value === "object") {
        console.warn("Cannot process Object directly");
        return {};
    }
    value = $6eea7234d56610fe$export$37bc2ce5722481d2($6eea7234d56610fe$var$inputRuleMap[rule], value, tokens);
    if (rule === "input-line-height") return $6eea7234d56610fe$var$lineHeightCSSVarRuleHandler(componentName, layer, rule, value, pseudo, _, tokens);
    return $6eea7234d56610fe$export$c52007b28a606662(componentName, layer, rule, value, pseudo, tokens);
};
const $6eea7234d56610fe$var$buttonVectorCSSVarRuleHandler = (componentName, layer, rule, value, pseudo, _layerMap, tokens)=>{
    if (typeof value === "object") {
        console.warn("Cannot process Object directly");
        return {};
    }
    value = $6eea7234d56610fe$export$37bc2ce5722481d2($6eea7234d56610fe$var$buttonVectorRuleMap[rule], value, tokens);
    return $6eea7234d56610fe$export$c52007b28a606662(componentName, layer, `--${rule}`, value, pseudo, tokens);
};
const $6eea7234d56610fe$var$cursorCSSVarRuleHandler = (componentName, layer, _rule, value, pseudo, layerMap, tokens)=>$6eea7234d56610fe$var$defaultCSSVarRuleHandler(componentName, layer, "cursor", value, pseudo, layerMap, tokens);
const $6eea7234d56610fe$var$skeletonCSSVarRuleHandler = (componentName, layer, rule, value, pseudo, _layerMap, tokens)=>{
    if (typeof value === "object") {
        console.warn("Cannot process Object directly");
        return {};
    }
    value = $6eea7234d56610fe$export$37bc2ce5722481d2($6eea7234d56610fe$var$skeletonRuleMap[rule], value, tokens);
    return $6eea7234d56610fe$export$c52007b28a606662(componentName, layer, rule, value, pseudo, tokens);
};
const $6eea7234d56610fe$var$transitonTimingFunctionHandler = (componentName, layer, rule, value, pseudo, _layerMap, tokens)=>{
    if (typeof value === "object") {
        console.warn("Cannot process Object directly");
        return {};
    }
    value = $6eea7234d56610fe$export$37bc2ce5722481d2(rule, value, tokens);
    value = `cubic-bezier${value}`;
    return $6eea7234d56610fe$export$c52007b28a606662(componentName, layer, rule, value, pseudo, tokens);
};
const $6eea7234d56610fe$var$transitonDurationHandler = (componentName, layer, rule, value, pseudo, _layerMap, tokens)=>{
    if (typeof value === "object") {
        console.warn("Cannot process Object directly");
        return {};
    }
    value = $6eea7234d56610fe$export$37bc2ce5722481d2(rule, value, tokens);
    rule = "transition-duration";
    return $6eea7234d56610fe$export$c52007b28a606662(componentName, layer, rule, value, pseudo, tokens);
};
const $6eea7234d56610fe$var$transformCSSVarRuleHandler = (componentName, layer, rule, ruleVal, pseudo, layerMap, tokens)=>{
    const [ruleName, direction] = rule.split("-");
    if (!direction) return $6eea7234d56610fe$var$defaultCSSVarRuleHandler(componentName, layer, ruleName, ruleVal, pseudo, layerMap, tokens);
    if (direction) {
        if (typeof ruleVal === "object") {
            console.warn("Cannot process Object directly");
            return {};
        }
        ruleVal = $6eea7234d56610fe$export$37bc2ce5722481d2(ruleName, ruleVal, tokens);
        if (ruleName === "rotate") ruleVal = `${direction} ${ruleVal}`;
        return $6eea7234d56610fe$export$c52007b28a606662(componentName, layer, rule, ruleVal, pseudo, tokens);
    }
    return {};
};
const $6eea7234d56610fe$var$TRANSITION_PROPERTY_MAP = {
    "translate-x": "translate",
    "translate-y": "translate",
    "translate-z": "translate",
    "scale-x": "scale",
    "scale-y": "scale",
    "scale-z": "scale",
    "rotate-x": "rotate",
    "rotate-y": "rotate",
    "rotate-z": "rotate"
};
const $6eea7234d56610fe$var$transitionCSSVarRuleHandler = (componentName, layer, _rule, value, pseudo, layerMap, tokens)=>{
    if (typeof value !== "object" || !value) {
        console.warn("Transition needs to be object.");
        return {};
    }
    const { property: property, duration: duration, "timing-function": timingFunction, delay: delay } = value;
    const result = {};
    if (property) {
        const props = Array().concat(property);
        Object.assign(result, $6eea7234d56610fe$var$defaultCSSVarRuleHandler(componentName, layer, "transition-property", props.map((prop)=>$6eea7234d56610fe$var$TRANSITION_PROPERTY_MAP[prop] ?? prop).join(", "), pseudo, layerMap, tokens));
    }
    if (duration) Object.assign(result, $6eea7234d56610fe$var$transitonDurationHandler(componentName, layer, "transition-duration", duration, pseudo, layerMap, tokens));
    if (timingFunction) Object.assign(result, $6eea7234d56610fe$var$defaultCSSVarRuleHandler(componentName, layer, "transition-timing-function", timingFunction, pseudo, layerMap, tokens));
    if (delay) Object.assign(result, $6eea7234d56610fe$var$defaultCSSVarRuleHandler(componentName, layer, "transition-delay", delay, pseudo, layerMap, tokens));
    return result;
};
const $6eea7234d56610fe$var$clipFirstHalfCSSVarRuleHandler = (componentName, layer, _rule, value, pseudo, _layerMap, tokens)=>{
    const rule = "clip-path";
    if (typeof value === "object") {
        console.warn("Cannot process Object directly");
        return {};
    }
    value = $6eea7234d56610fe$export$37bc2ce5722481d2(rule, value);
    const baseVar = $6eea7234d56610fe$export$437bd2c771393299(componentName, layer, "--clip-value", tokens?.["brandVersion"] === "jio-v2");
    if (value) value = `inset(0 var(${baseVar}, 0) 0 0)`;
    else value = `inset(0 0 0 var(${baseVar}, 0))`;
    return $6eea7234d56610fe$export$c52007b28a606662(componentName, layer, rule, value, pseudo, tokens);
};
const $6eea7234d56610fe$var$clipValueCSSVarRuleHandler = (componentName, layer, _rule, value, pseudo, layerMap, tokens)=>{
    const rule = "clip-path";
    if (typeof value === "object") {
        console.warn("Cannot process Object directly");
        return {};
    }
    value = $6eea7234d56610fe$export$37bc2ce5722481d2(rule, value, tokens);
    const clipFirstHalf = layerMap?.["clip-first-half"];
    if (clipFirstHalf) value = `inset(0 ${value ?? 0} 0 0)`;
    else value = `inset(0 0 0 ${value ?? 0})`;
    return $6eea7234d56610fe$export$c52007b28a606662(componentName, layer, rule, value, pseudo, tokens);
};
const $6eea7234d56610fe$var$linearGradientOpacityHandler = (componentName, layer, _rule, value, pseudo, _layerMap, tokens)=>{
    if (!Array.isArray(value)) {
        console.warn("Invalid color format", value);
        return {};
    }
    const cssVars = value.map((value2, i)=>{
        const numberValue = value2.split("%")[0];
        const decimalValue = parseFloat(numberValue) + "%";
        return $6eea7234d56610fe$export$c52007b28a606662(componentName, layer, "linear-gradient-opacity-" + i, decimalValue, pseudo, tokens);
    });
    return cssVars.reduce((acc, cssVar)=>({
            ...acc,
            ...cssVar
        }), {});
};
const $6eea7234d56610fe$var$linearGradientHandler = (componentName, layer, _rule, value, pseudo, _layerMap, tokens)=>{
    if (!Array.isArray(value)) {
        console.warn("Invalid color format", value);
        return {};
    }
    const colors = value.map((value2, i)=>{
        const color = $6eea7234d56610fe$export$6a176e754d54672("color", value2, tokens || {});
        const opacity = `var(--${componentName.toLowerCase()}--${layer}-linear-gradient-opacity-${i})`;
        if (color.startsWith("oklch")) return `oklch(from ${color} l c h / ${opacity})`;
        const { r: r, g: g, b: b } = (0, $bff35c0dd9851fab$export$848d71df1f759bc)(color);
        return `rgba(${r},${g},${b}, )`;
    });
    const endCSSVar = `var(--${componentName.toLowerCase()}--${layer}-linear-gradient-end,bottom)`;
    const gradient = `linear-gradient(to ${endCSSVar},${colors.join(",")} )`;
    return $6eea7234d56610fe$export$c52007b28a606662(componentName, layer, "background-image", gradient, pseudo, tokens);
};
const $6eea7234d56610fe$var$transitionCSSVarRules = {
    "transition-timing-function": $6eea7234d56610fe$var$transitonTimingFunctionHandler,
    "transition-duration": $6eea7234d56610fe$var$transitonDurationHandler,
    "transition-property": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "transition-delay": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    transition: $6eea7234d56610fe$var$transitionCSSVarRuleHandler,
    "enter-animation-duration": $6eea7234d56610fe$var$transitonDurationHandler,
    "exit-animation-duration": $6eea7234d56610fe$var$transitonDurationHandler,
    "animation-duration": $6eea7234d56610fe$var$transitonDurationHandler
};
const $6eea7234d56610fe$var$inputCSSVarRules = {
    "inactive-color": $6eea7234d56610fe$var$inputCSSVarRuleHandler,
    "active-color": $6eea7234d56610fe$var$inputCSSVarRuleHandler,
    "ball-size": $6eea7234d56610fe$var$inputCSSVarRuleHandler,
    "ball-color": $6eea7234d56610fe$var$inputCSSVarRuleHandler,
    "ball-border-color": $6eea7234d56610fe$var$inputCSSVarRuleHandler,
    "ball-border-width": $6eea7234d56610fe$var$inputCSSVarRuleHandler,
    "track-height": $6eea7234d56610fe$var$inputCSSVarRuleHandler,
    "placeholder-color": $6eea7234d56610fe$var$inputCSSVarRuleHandler,
    "placeholder-font-family": $6eea7234d56610fe$var$inputCSSVarRuleHandler,
    "placeholder-font-size": $6eea7234d56610fe$var$inputCSSVarRuleHandler,
    "placeholder-line-height": $6eea7234d56610fe$var$inputCSSVarRuleHandler,
    "placeholder-letter-spacing": $6eea7234d56610fe$var$inputCSSVarRuleHandler,
    "placeholder-font-weight": $6eea7234d56610fe$var$inputCSSVarRuleHandler,
    "input-color": $6eea7234d56610fe$var$inputCSSVarRuleHandler,
    "input-font-family": $6eea7234d56610fe$var$inputCSSVarRuleHandler,
    "input-font-size": $6eea7234d56610fe$var$inputCSSVarRuleHandler,
    "input-line-height": $6eea7234d56610fe$var$inputCSSVarRuleHandler,
    "input-letter-spacing": $6eea7234d56610fe$var$inputCSSVarRuleHandler,
    "input-font-weight": $6eea7234d56610fe$var$inputCSSVarRuleHandler,
    "resize-color": $6eea7234d56610fe$var$inputCSSVarRuleHandler,
    "cursor-color": $6eea7234d56610fe$var$inputCSSVarRuleHandler
};
const $6eea7234d56610fe$var$skeletonCSSVarRules = {
    "primary-color": $6eea7234d56610fe$var$skeletonCSSVarRuleHandler,
    "secondary-color": $6eea7234d56610fe$var$skeletonCSSVarRuleHandler
};
const $6eea7234d56610fe$var$buttonVectorCSSVarRules = {
    "fill-color": $6eea7234d56610fe$var$buttonVectorCSSVarRuleHandler,
    "stroke-color": $6eea7234d56610fe$var$buttonVectorCSSVarRuleHandler
};
const $6eea7234d56610fe$var$clipCSSVarRules = {
    "clip-first-half": $6eea7234d56610fe$var$clipFirstHalfCSSVarRuleHandler,
    "clip-value": $6eea7234d56610fe$var$clipValueCSSVarRuleHandler
};
const $6eea7234d56610fe$export$95994f4e1548c018 = {
    "align-items": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "aspect-ratio": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "background-blur": $6eea7234d56610fe$var$blurRadiusCSSVarRuleHandler,
    "background-gradient-color": $6eea7234d56610fe$var$backgroundGradientColorCSSVarRuleHandler,
    "background-image": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "background-repeat": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "blur-radius": $6eea7234d56610fe$var$blurRadiusCSSVarRuleHandler,
    "border-color": $6eea7234d56610fe$var$borderCSSVarRuleHandler,
    "border-radius": $6eea7234d56610fe$var$borderCSSVarRuleHandler,
    "border-style": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "border-width": $6eea7234d56610fe$var$borderCSSVarRuleHandler,
    "border-top-width": $6eea7234d56610fe$var$borderWidthCSSVarRuleHandler,
    "border-right-width": $6eea7234d56610fe$var$borderWidthCSSVarRuleHandler,
    "border-bottom-width": $6eea7234d56610fe$var$borderWidthCSSVarRuleHandler,
    "border-left-width": $6eea7234d56610fe$var$borderWidthCSSVarRuleHandler,
    "border-top-color": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "border-right-color": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "border-bottom-color": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "border-left-color": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "border-gradient-color": $6eea7234d56610fe$var$borderGradientColorCSSVarRuleHandler,
    "border-top-left-radius": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "border-top-right-radius": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "border-bottom-right-radius": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "border-bottom-left-radius": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    bottom: $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "box-shadow": $6eea7234d56610fe$var$boxShadowCSSVarRuleHandler,
    "box-sizing": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    cursor: $6eea7234d56610fe$var$cursorCSSVarRuleHandler,
    display: $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    disabled: $6eea7234d56610fe$var$disabledCSSVarRuleHandler,
    flex: $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "flex-shrink": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "flex-direction": $6eea7234d56610fe$var$flexDirectionCSSVarRuleHandler,
    "flex-wrap": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "font-family": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "font-size": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "font-weight": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    gap: $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    height: $6eea7234d56610fe$var$dimensionsCSSVarRuleHandler,
    "justify-content": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    left: $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "letter-spacing": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "line-height": $6eea7234d56610fe$var$lineHeightCSSVarRuleHandler,
    "max-height": $6eea7234d56610fe$var$dimensionsCSSVarRuleHandler,
    "max-width": $6eea7234d56610fe$var$dimensionsCSSVarRuleHandler,
    "min-height": $6eea7234d56610fe$var$dimensionsCSSVarRuleHandler,
    "min-width": $6eea7234d56610fe$var$dimensionsCSSVarRuleHandler,
    opacity: $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    outline: $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    overflow: $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "padding-bottom": $6eea7234d56610fe$var$paddingCSSVarRuleHandler,
    "padding-left": $6eea7234d56610fe$var$paddingCSSVarRuleHandler,
    "padding-right": $6eea7234d56610fe$var$paddingCSSVarRuleHandler,
    "padding-top": $6eea7234d56610fe$var$paddingCSSVarRuleHandler,
    "pointer-events": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    position: $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    right: $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    rotate: $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "rotate-x": $6eea7234d56610fe$var$transformCSSVarRuleHandler,
    "rotate-y": $6eea7234d56610fe$var$transformCSSVarRuleHandler,
    "rotate-z": $6eea7234d56610fe$var$transformCSSVarRuleHandler,
    translate: $6eea7234d56610fe$var$transformCSSVarRuleHandler,
    "translate-x": $6eea7234d56610fe$var$transformCSSVarRuleHandler,
    "translate-y": $6eea7234d56610fe$var$transformCSSVarRuleHandler,
    "translate-z": $6eea7234d56610fe$var$transformCSSVarRuleHandler,
    scale: $6eea7234d56610fe$var$transformCSSVarRuleHandler,
    "scale-x": $6eea7234d56610fe$var$transformCSSVarRuleHandler,
    "scale-y": $6eea7234d56610fe$var$transformCSSVarRuleHandler,
    "scale-z": $6eea7234d56610fe$var$transformCSSVarRuleHandler,
    "text-align": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "text-decoration": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "text-overflow": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "text-transform": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "object-fit": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "object-position": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    size: $6eea7234d56610fe$var$sizeCSSVarRuleHandler,
    up: $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "web-cursor": $6eea7234d56610fe$var$cursorCSSVarRuleHandler,
    width: $6eea7234d56610fe$var$dimensionsCSSVarRuleHandler,
    "z-index": $6eea7234d56610fe$var$zIndexCSSVarRuleHandler,
    "linear-gradient-start": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "linear-gradient-end": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    "linear-gradient-colors": $6eea7234d56610fe$var$linearGradientHandler,
    "linear-gradient-opacity": $6eea7234d56610fe$var$linearGradientOpacityHandler,
    ...$6eea7234d56610fe$var$inputCSSVarRules,
    ...$6eea7234d56610fe$var$skeletonCSSVarRules,
    ...$6eea7234d56610fe$var$transitionCSSVarRules,
    ...$6eea7234d56610fe$var$buttonVectorCSSVarRules,
    ...$6eea7234d56610fe$var$clipCSSVarRules,
    "font-style": $6eea7234d56610fe$var$defaultCSSVarRuleHandler,
    color: $6eea7234d56610fe$var$colorCSSVarRuleHandler,
    "background-color": $6eea7234d56610fe$var$colorCSSVarRuleHandler
};
function $6eea7234d56610fe$export$37bc2ce5722481d2(rule, value, tokens) {
    if (value?.toString().includes("&")) return $6eea7234d56610fe$export$6a176e754d54672(rule, String(value), tokens || {});
    if ($6eea7234d56610fe$export$bdcbab1cb38db489(value)) value = $6eea7234d56610fe$export$6404fd1becf96b61(rule, value);
    else value = $6eea7234d56610fe$export$95c38a73fd251991(rule, value);
    return value;
}
const $6eea7234d56610fe$export$585f0f7ef40c9f0 = (tokenString)=>`--${(0, $bff35c0dd9851fab$export$3e672a90535a3744)((0, $bff35c0dd9851fab$export$5fe300a9008e2bfc)(tokenString.replace(/\./g, "-")))}`;
class $6eea7234d56610fe$var$Color {
    color;
    colorInstance;
    alpha = 1;
    constructor(color, alpha = 1){
        this.color = color;
        this.alpha = alpha;
        if (!this.colorInstance) this.colorInstance = new $6eea7234d56610fe$var$Color(color);
    }
    to(format) {
        console.info(format);
        return this.colorInstance;
    }
    toString(data) {
        console.info(data);
        return this.color;
    }
    mix(color, value) {
        console.info(color, value);
        return this.colorInstance;
    }
}
const $6eea7234d56610fe$var$alphaColorModifier = (hexColor, alpha)=>{
    let color = new $6eea7234d56610fe$var$Color(hexColor);
    color = color.to("hsl");
    color.alpha = Math.max(0, Math.min(1, Number(alpha)));
    const newColor = new $6eea7234d56610fe$var$Color(color.toString({
        inGamut: true,
        precision: 3
    }));
    return newColor.to("srgb").toString({
        format: "hex"
    });
};
const $6eea7234d56610fe$var$mixColorModifier = (firstColor, secondColor, parameter)=>{
    const color = new $6eea7234d56610fe$var$Color(firstColor);
    const mixColor = new $6eea7234d56610fe$var$Color(secondColor.toString());
    const mixValue = Math.max(0, Math.min(1, Number(parameter)));
    const newColor = new $6eea7234d56610fe$var$Color(color.mix(mixColor, mixValue).toString({}));
    return newColor.to("srgb").toString({
        format: "hex"
    });
};
const $6eea7234d56610fe$var$COLOR_MODIFIER_MAP = {
    alpha: $6eea7234d56610fe$var$alphaColorModifier,
    mix: $6eea7234d56610fe$var$mixColorModifier
};
const $6eea7234d56610fe$var$functionRegex = /(\w+)\(([\w.# ,-]+)\)/;
const $6eea7234d56610fe$var$mulRegex = /(-?[\d.]+)\*(-?[\d.]+)/;
const $6eea7234d56610fe$var$divRegex = /(-?[\d.]+)\/(-?[\d.]+)/;
const $6eea7234d56610fe$var$addRegex = /(-?[\d.]+)\+(-?[\d.]+)/;
const $6eea7234d56610fe$var$subRegex = /(-?[\d.]+)-(-?[\d.]+)/;
const $6eea7234d56610fe$var$expRegex = /(-?[\d.]+)\^(-?[\d.]+)/;
const $6eea7234d56610fe$var$parensRegex = /\((-?[\d.]+)\)/;
function $6eea7234d56610fe$var$colorModify(args) {
    const [type, ...values] = args;
    try {
        return $6eea7234d56610fe$var$COLOR_MODIFIER_MAP[type](...values);
    } catch (e) {
        console.warn("wrong input for type in colorModifier: ", type);
        return "";
    }
}
const $6eea7234d56610fe$var$functionMap = {
    floor: ([value])=>Math.floor(parseFloat(value)).toString(),
    round: ([value])=>Math.round(parseFloat(value)).toString(),
    min: (args)=>Math.min(...args.map(parseFloat)).toString(),
    max: (args)=>Math.max(...args.map(parseFloat)).toString(),
    colorModify: $6eea7234d56610fe$var$colorModify
};
const $6eea7234d56610fe$var$operators = [
    [
        $6eea7234d56610fe$var$expRegex,
        (first, second)=>(parseFloat(first) ** parseFloat(second)).toString()
    ],
    [
        $6eea7234d56610fe$var$mulRegex,
        (first, second)=>(parseFloat(first) * parseFloat(second)).toString()
    ],
    [
        $6eea7234d56610fe$var$divRegex,
        (first, second)=>(parseFloat(first) / parseFloat(second)).toString()
    ],
    [
        $6eea7234d56610fe$var$addRegex,
        (first, second)=>(parseFloat(first) + parseFloat(second)).toString()
    ],
    [
        $6eea7234d56610fe$var$subRegex,
        (first, second)=>(parseFloat(first) - parseFloat(second)).toString()
    ],
    [
        $6eea7234d56610fe$var$functionRegex,
        (name, argsString)=>{
            if (name in $6eea7234d56610fe$var$functionMap) return $6eea7234d56610fe$var$functionMap[name](argsString.split(","));
            return "";
        }
    ],
    [
        $6eea7234d56610fe$var$parensRegex,
        (value)=>value
    ]
];
function $6eea7234d56610fe$var$parseMaths(key) {
    if (!$6eea7234d56610fe$var$operators.find(([op])=>op.test(key))) return key;
    let value = key.replace(/[ ']/g, "");
    let operator;
    while(operator = $6eea7234d56610fe$var$operators.find(([op])=>op.test(value))){
        const [op, callback] = operator;
        const match = value.match(op);
        if (match) {
            const left = match[1];
            const right = match[2];
            const replacement = callback(left, right);
            const replaced = value.replace(op, replacement);
            if (replaced === "") break;
            value = replaced.replace(/ /g, "");
        }
    }
    return value;
}
const $6eea7234d56610fe$var$colorJsons = [
    "color"
];
const $6eea7234d56610fe$var$borderRadiusJsons = [
    "borderRadius"
];
const $6eea7234d56610fe$var$sizeJsons = [
    "sizing",
    "layout"
];
const $6eea7234d56610fe$var$borderWidthJsons = [
    "borderWidth",
    ...$6eea7234d56610fe$var$sizeJsons
];
const $6eea7234d56610fe$var$letterSpacingJSONs = [
    "letterSpacing",
    "typography"
];
const $6eea7234d56610fe$var$fontSizeJsons = [
    "fontSizes"
];
const $6eea7234d56610fe$var$lineHeightJsons = [
    "lineHeights",
    "typography"
];
const $6eea7234d56610fe$var$fontFamilyJsons = [
    "fontFamilies",
    "typography"
];
const $6eea7234d56610fe$var$fontWeightJsons = [
    "fontWeights",
    "typography"
];
const $6eea7234d56610fe$var$spacingJsons = [
    "spacing"
];
const $6eea7234d56610fe$var$otherJsons = [
    "layout"
];
const $6eea7234d56610fe$var$opacityJsons = [
    "opacity"
];
const $6eea7234d56610fe$var$shadowsJsons = [
    "shadows"
];
const $6eea7234d56610fe$var$textDecorationJsons = [
    "textDecoration"
];
const $6eea7234d56610fe$var$textTransformJsons = [
    "textCase"
];
const $6eea7234d56610fe$var$transitionDurationJSONs = [
    "transitionsDuration"
];
const $6eea7234d56610fe$var$transitionTimingFunctionJSONs = [
    "transitions"
];
const $6eea7234d56610fe$export$a8c2fb75d5b0e0e = {
    "background-color": $6eea7234d56610fe$var$colorJsons,
    "background-image": $6eea7234d56610fe$var$colorJsons,
    "border-color": $6eea7234d56610fe$var$colorJsons,
    "border-top-color": $6eea7234d56610fe$var$colorJsons,
    "border-right-color": $6eea7234d56610fe$var$colorJsons,
    "border-bottom-color": $6eea7234d56610fe$var$colorJsons,
    "border-left-color": $6eea7234d56610fe$var$colorJsons,
    color: $6eea7234d56610fe$var$colorJsons,
    "border-radius": $6eea7234d56610fe$var$borderRadiusJsons,
    "border-top-left-radius": $6eea7234d56610fe$var$borderRadiusJsons,
    "border-top-right-radius": $6eea7234d56610fe$var$borderRadiusJsons,
    "border-bottom-right-radius": $6eea7234d56610fe$var$borderRadiusJsons,
    "border-bottom-left-radius": $6eea7234d56610fe$var$borderRadiusJsons,
    "border-width": $6eea7234d56610fe$var$borderWidthJsons,
    "border-top-width": $6eea7234d56610fe$var$borderWidthJsons,
    "border-right-width": $6eea7234d56610fe$var$borderWidthJsons,
    "border-bottom-width": $6eea7234d56610fe$var$borderWidthJsons,
    "border-left-width": $6eea7234d56610fe$var$borderWidthJsons,
    "blur-radius": $6eea7234d56610fe$var$sizeJsons,
    filter: $6eea7234d56610fe$var$sizeJsons,
    height: $6eea7234d56610fe$var$sizeJsons,
    "max-height": $6eea7234d56610fe$var$sizeJsons,
    "min-height": $6eea7234d56610fe$var$sizeJsons,
    width: $6eea7234d56610fe$var$sizeJsons,
    "max-width": $6eea7234d56610fe$var$sizeJsons,
    "min-width": $6eea7234d56610fe$var$sizeJsons,
    size: $6eea7234d56610fe$var$sizeJsons,
    "font-size": $6eea7234d56610fe$var$fontSizeJsons,
    "line-height": $6eea7234d56610fe$var$lineHeightJsons,
    "font-family": $6eea7234d56610fe$var$fontFamilyJsons,
    "font-weight": $6eea7234d56610fe$var$fontWeightJsons,
    gap: $6eea7234d56610fe$var$spacingJsons,
    padding: $6eea7234d56610fe$var$spacingJsons,
    "padding-left": $6eea7234d56610fe$var$spacingJsons,
    "padding-right": $6eea7234d56610fe$var$spacingJsons,
    "padding-top": $6eea7234d56610fe$var$spacingJsons,
    "padding-bottom": $6eea7234d56610fe$var$spacingJsons,
    "box-shadow": $6eea7234d56610fe$var$shadowsJsons,
    "text-decoration": $6eea7234d56610fe$var$textDecorationJsons,
    opacity: $6eea7234d56610fe$var$opacityJsons,
    "aspect-ratio": $6eea7234d56610fe$var$otherJsons,
    "flex-direction": $6eea7234d56610fe$var$otherJsons,
    "align-items": $6eea7234d56610fe$var$otherJsons,
    "justify-content": $6eea7234d56610fe$var$otherJsons,
    display: $6eea7234d56610fe$var$otherJsons,
    "font-style": $6eea7234d56610fe$var$otherJsons,
    outline: $6eea7234d56610fe$var$otherJsons,
    "text-align": $6eea7234d56610fe$var$otherJsons,
    rotate: $6eea7234d56610fe$var$otherJsons,
    "letter-spacing": $6eea7234d56610fe$var$letterSpacingJSONs,
    "border-gradient-color": $6eea7234d56610fe$var$colorJsons,
    "linear-gradient-colors": $6eea7234d56610fe$var$colorJsons,
    "text-transform": $6eea7234d56610fe$var$textTransformJsons,
    "enter-animation-duration": $6eea7234d56610fe$var$transitionDurationJSONs,
    "exit-animation-duration": $6eea7234d56610fe$var$transitionDurationJSONs,
    "transition-timing-function": $6eea7234d56610fe$var$transitionTimingFunctionJSONs,
    "transition-duration": $6eea7234d56610fe$var$transitionDurationJSONs,
    "transition-property": $6eea7234d56610fe$var$otherJsons
};
const $6eea7234d56610fe$var$RN_TOKEN_OVERRIDES = {
    "{label.3xs.lineheight}": "110.00000238418579"
};
class $6eea7234d56610fe$export$859883d4ec9c7db4 {
    static constants = {};
    static defaults;
    static fetchTokenMemo = {};
    static switchablesMemo = {};
    static componentTokensMemo = {};
    static brandSwitchableFn;
    static updateFlatTokens;
    static brandResolverFn;
    static brandComponentFn;
    static getDensityMap;
    static getColorsMap;
    static getSwitchables(tokens) {
        const tokensKey = JSON.stringify(tokens);
        const switchables = this.switchablesMemo[tokensKey] ?? this.brandSwitchableFn?.(tokens) ?? {};
        this.switchablesMemo[tokensKey] = switchables;
        return switchables;
    }
    /**
   * Use this to register the brand provided by the user
   * @param brand The brand object to register
   */ static registerBrand(brand) {
        this.constants = brand.tokens;
        this.defaults = brand.defaults;
        this.brandSwitchableFn = brand.getSwitchableTokens;
        this.brandComponentFn = brand.getComponentTokens;
        this.brandResolverFn = brand.brandResolverFn;
        this.updateFlatTokens = brand.updateFlatTokens;
        this.getDensityMap = brand.getDensityMap;
        this.getColorsMap = brand.getColorsMap;
        this.fetchTokenMemo = {};
        this.switchablesMemo = {};
        this.componentTokensMemo = {};
    }
    static registerAdditionalTokens(tokens) {
        this.constants["extras"] = tokens;
    }
    static getValue(rule, key, tokens, forceValue) {
        if ($6eea7234d56610fe$export$859883d4ec9c7db4.brandResolverFn && String(key).includes("&")) {
            const { value: brandValue, key: brandKey } = $6eea7234d56610fe$export$859883d4ec9c7db4.brandResolverFn(rule, key, tokens || {}, forceValue) ?? {};
            if (brandKey) {
                if (!forceValue) return `var(${$6eea7234d56610fe$export$585f0f7ef40c9f0(brandKey.replace(/f-(\d+)/, "f-m$1"))})`;
                return brandValue;
            }
            if (typeof brandValue !== "undefined") return $6eea7234d56610fe$export$95c38a73fd251991(rule, brandValue);
        }
        const [jsonKey, ...fallbacks] = $6eea7234d56610fe$export$a8c2fb75d5b0e0e[rule] ?? [];
        if (!jsonKey) return void 0;
        let json = this.constants[jsonKey];
        const switchables = this.getSwitchables(tokens);
        if (!json) json = switchables?.[jsonKey];
        if (this.constants["extras"]) fallbacks.push("extras");
        let value = json?.[key];
        if (value === void 0) for (const fallback2 of fallbacks){
            json = this.constants[fallback2] ?? switchables?.[fallback2];
            value = json?.[key];
            if (value !== void 0) break;
        }
        return value;
    }
    static getComponentToken(key, metaCompName) {
        key = (0, $bff35c0dd9851fab$export$5fe300a9008e2bfc)(key);
        if (metaCompName in this.componentTokensMemo) return this.componentTokensMemo[metaCompName]?.[key];
        const compTokens = this.brandComponentFn?.(metaCompName);
        this.componentTokensMemo[metaCompName] = compTokens;
        return compTokens?.[key];
    }
    static getApplicableTokens(tokens) {
        const switchables = this.getSwitchables(tokens);
        const merged = (0, $bff35c0dd9851fab$export$4950aa0f605343fb)(this.constants, switchables);
        const tokenKeys = Object.keys(tokens);
        const result = {};
        for(const folderKey in merged){
            const folder = merged[folderKey];
            const filtered = Object.entries(folder || {}).reduce((acc, [key, value])=>{
                if (typeof value === "string" && tokenKeys.some((token)=>value.includes(`$${token}`))) acc[key] = value;
                return acc;
            }, {});
            result[folderKey] = filtered;
        }
        return result;
    }
}
const $6eea7234d56610fe$var$assignTypes = {
    sizing: "size",
    spacing: "padding",
    "font-families": "font-family",
    "font-sizes": "font-size",
    "font-weights": "font-weight",
    "line-heights": "line-height",
    "text-case": "text-transform",
    "transitions-duration": "transition-duration",
    transitions: "transition-timing-function",
    typography: "font-family",
    lineHeights: "line-height",
    fontFamilies: "font-family",
    letterSpacing: "letter-spacing",
    fontWeights: "font-weight",
    fontSizes: "font-size",
    textCase: "text-transform",
    platform: "size"
};
function $6eea7234d56610fe$export$c59eaf4f26921ab2(folder, key, tokens) {
    const rule = $6eea7234d56610fe$var$assignTypes[folder] ?? folder;
    return $6eea7234d56610fe$export$6a176e754d54672(rule, key, tokens);
}
function $6eea7234d56610fe$export$6a176e754d54672(rule, key, tokens, forceValue = false) {
    const memoKey = $6eea7234d56610fe$var$getMemoKey(rule, key, tokens);
    if (memoKey in $6eea7234d56610fe$export$859883d4ec9c7db4.fetchTokenMemo) return $6eea7234d56610fe$export$859883d4ec9c7db4.fetchTokenMemo[memoKey];
    let raw = $6eea7234d56610fe$var$parseKey(rule, key, tokens, forceValue);
    if ($6eea7234d56610fe$var$RN_TOKEN_OVERRIDES[key]) raw = $6eea7234d56610fe$var$RN_TOKEN_OVERRIDES[key];
    let value = String(key)?.includes("column") ? raw : $6eea7234d56610fe$export$95c38a73fd251991(rule, raw);
    if (rule === "line-height" && tokens?.["brandVersion"] === "jio-v2") value = value.replace("px", "%");
    if ($6eea7234d56610fe$export$a8c2fb75d5b0e0e[rule]?.includes("sizing")) {
        value = value === "max" ? "100%" : value;
        value = value === "min" ? "100%" : value;
        value = value === "negativeMax" ? "-100%" : value;
        value = value === "intrinsicSize.max" ? "max-content" : value;
    }
    if (rule?.includes("transition-timing-function")) value = `cubic-bezier(${value})`;
    $6eea7234d56610fe$export$859883d4ec9c7db4.fetchTokenMemo[memoKey] = value;
    return value;
}
const $6eea7234d56610fe$var$getNestedFallbacks = (variables)=>{
    if (variables.length > 1) return `var(${variables[0]}, ${$6eea7234d56610fe$var$getNestedFallbacks(variables.slice(1))})`;
    return `var(${variables[0]})`;
};
function $6eea7234d56610fe$export$6404fd1becf96b61(rule, key) {
    const jsons = $6eea7234d56610fe$export$a8c2fb75d5b0e0e[rule] ?? $6eea7234d56610fe$var$otherJsons;
    return $6eea7234d56610fe$var$getNestedFallbacks(jsons.map((json)=>$6eea7234d56610fe$export$585f0f7ef40c9f0(json ? `${json}-${key}` : key)));
}
const $6eea7234d56610fe$var$tokenReg = /{([\w\-.$]+)}/;
const $6eea7234d56610fe$var$pureTokenReg = /^{([&%?\w\-.]+)}$/;
const $6eea7234d56610fe$var$pureTokenRegWithSwitchable = /^{([&%?\w\-.$]+)}$/;
const $6eea7234d56610fe$var$pureValue = /^[[\],\w\d?%\-. #$]+$/;
function $6eea7234d56610fe$var$getMemoKey(rule, key, tokens) {
    return rule + key + JSON.stringify(tokens);
}
function $6eea7234d56610fe$var$parseKey(rule, key, tokens, forceValue) {
    let value;
    if ($6eea7234d56610fe$var$pureTokenReg.test(key)) {
        key = (0, $bff35c0dd9851fab$export$5fe300a9008e2bfc)(key);
        value = $6eea7234d56610fe$export$859883d4ec9c7db4.getValue(rule, key, tokens, forceValue);
    } else if ($6eea7234d56610fe$var$pureTokenRegWithSwitchable.test(key)) {
        key = $6eea7234d56610fe$var$replaceTokens((0, $bff35c0dd9851fab$export$5fe300a9008e2bfc)(key), tokens);
        value = $6eea7234d56610fe$export$859883d4ec9c7db4.getValue(rule, key, tokens, forceValue);
    } else value = key;
    if (value === void 0) {
        if (key.includes("typography")) return key;
        return "";
    } else if (typeof value !== "string") return value.toString();
    if ($6eea7234d56610fe$var$pureTokenReg.test(value)) return $6eea7234d56610fe$var$parseKey(rule, value, tokens, forceValue);
    if ($6eea7234d56610fe$var$pureTokenRegWithSwitchable.test(value)) {
        if (Object.keys(tokens).length === 0) {
            console.warn(`No tokens provided, cannot resolve ${key}, ${value}`);
            return "";
        }
        const switched = $6eea7234d56610fe$var$replaceTokens(value, tokens);
        return $6eea7234d56610fe$var$parseKey(rule, switched, tokens, forceValue);
    }
    if ($6eea7234d56610fe$var$tokenReg.test(value)) value = $6eea7234d56610fe$var$handleNonPureTokens(rule, value, tokens, forceValue);
    if ($6eea7234d56610fe$var$pureValue.test(value) || value.startsWith("color-mix")) return value;
    const mathParsed = $6eea7234d56610fe$var$parseMaths(value);
    return mathParsed;
}
function $6eea7234d56610fe$var$handleNonPureTokens(rule, value, tokens, forceValue) {
    let match;
    while(match = $6eea7234d56610fe$var$tokenReg.exec(value)){
        const replacement = $6eea7234d56610fe$var$parseKey(rule, match[0], tokens, forceValue);
        value = value.replace($6eea7234d56610fe$var$tokenReg, replacement);
    }
    return value;
}
const $6eea7234d56610fe$var$UNITS_MAP = {
    filter: "px",
    "backdrop-filter": "px",
    "background-blur": "px",
    "blur-radius": "px",
    "border-radius": "px",
    "border-top-left-radius": "px",
    "border-top-right-radius": "px",
    "border-bottom-right-radius": "px",
    "border-bottom-left-radius": "px",
    "border-width": "px",
    "border-top-width": "px",
    "border-right-width": "px",
    "border-bottom-width": "px",
    "border-left-width": "px",
    height: "px",
    width: "px",
    size: "px",
    "font-size": "px",
    "line-height": "px",
    gap: "px",
    padding: "px",
    "padding-left": "px",
    "padding-right": "px",
    "padding-top": "px",
    "padding-bottom": "px",
    "letter-spacing": "px",
    outline: "%",
    rotate: "deg",
    "transition-duration": "ms",
    "transition-delay": "ms",
    "exit-animation-duration": "ms",
    "enter-animation-duration": "ms",
    "animation-duration": "ms"
};
const $6eea7234d56610fe$var$unitRules = Object.keys($6eea7234d56610fe$var$UNITS_MAP);
const $6eea7234d56610fe$export$fe0319385f0cf5a7 = [
    "px",
    "%",
    "deg",
    "vw",
    "em",
    "rem",
    "vh",
    "ms"
];
function $6eea7234d56610fe$var$needsUnits(value, match) {
    const notString = typeof value !== "string";
    const noMatch = !match;
    if (notString || noMatch) return Boolean(match);
    const isNotNumber = isNaN(parseInt(value));
    const hasUnits = $6eea7234d56610fe$export$fe0319385f0cf5a7.some((unit)=>value.includes(unit));
    return !(isNotNumber || hasUnits);
}
function $6eea7234d56610fe$export$95c38a73fd251991(rule, value) {
    const match = $6eea7234d56610fe$var$unitRules.find((unit)=>rule.includes(unit)) ?? "";
    if ($6eea7234d56610fe$var$needsUnits(value, match)) return `${value}${$6eea7234d56610fe$var$UNITS_MAP[match]}`;
    return value.toString();
}
const $6eea7234d56610fe$var$fallback = {
    lang: "en",
    platform: "desktop"
};
function $6eea7234d56610fe$var$replaceTokens(key, tokens) {
    tokens = {
        ...$6eea7234d56610fe$var$fallback,
        ...tokens
    };
    return Object.entries(tokens).filter(([, value])=>value).reduce((key2, [token, value])=>{
        return key2.replace(RegExp(`\\$${token}`, "g"), value.toString());
    }, key);
}
const $6eea7234d56610fe$var$permittedKeys = /* @__PURE__ */ new Set([
    "slot_layers",
    "hidden",
    "show",
    "behavior",
    "value",
    "web-tag"
]);
function $6eea7234d56610fe$var$getAllRequiredBaseLayers(base, props, getAllAmpersandTokenLayers = false, getPercentageTokens = []) {
    const hiddenLayers = {};
    for(const layer in base){
        const layerObj = base[layer];
        const layerKey = $6eea7234d56610fe$export$92b70e511152790f(layer);
        for(const key in layerObj){
            const value = layerObj[key];
            if (typeof value !== "string") {
                hiddenLayers[layer] ??= {};
                hiddenLayers[layer][key] = value;
                continue;
            }
            const hasAmpersandKey = typeof value === "string" && value.includes("&") && (value.includes("stroke") || key.includes("color") || key.includes("fill"));
            const hasPercentKey = typeof value === "string" && value.includes("%");
            const matchedKey = hasPercentKey && value.match($6eea7234d56610fe$export$2b19bce00ae0a812)?.[1];
            const hasPercentToken = matchedKey && getPercentageTokens.includes(matchedKey);
            if (getAllAmpersandTokenLayers && hasAmpersandKey || hasPercentToken || $6eea7234d56610fe$var$permittedKeys.has(key) || layerKey?.startsWith("jds_") || // include all molecule layers
            layerKey?.endsWith("arc")) {
                hiddenLayers[layer] ??= {};
                hiddenLayers[layer][key] = hasPercentKey ? $6eea7234d56610fe$export$cf44b2f1c9caafc4(value, props) : value;
            }
        }
    }
    return hiddenLayers;
}
function $6eea7234d56610fe$export$cf44b2f1c9caafc4(value, props) {
    const match = value.match($6eea7234d56610fe$export$2b19bce00ae0a812);
    if (!match) return value;
    const key = match[1];
    const replacement = props[key];
    if (replacement === void 0) return value;
    return value.replace(`%${key}`, replacement?.toString() ?? "");
}
function $6eea7234d56610fe$export$e025e4ac3d283105(component, json, config = {
    transformer: false,
    getAmpersandTokens: false,
    getAllBaseLayers: true,
    getPercentageTokens: []
}) {
    const { transformer: transformer = false, getAllBaseLayers: getAllBaseLayers = false, getAmpersandTokens: getAmpersandTokens = false, getPercentageTokens: getPercentageTokens = [] } = config;
    let base = getAllBaseLayers ? (0, $bff35c0dd9851fab$export$b7d58db314e0ac27)(json.base) : $6eea7234d56610fe$var$getAllRequiredBaseLayers((0, $bff35c0dd9851fab$export$b7d58db314e0ac27)(json.base), component, getAmpersandTokens, getPercentageTokens);
    base = $6eea7234d56610fe$export$8c51a6ab64fc75e8(component, base, json.variant, json.api.config);
    if (json.combination && json.combination_config) base = $6eea7234d56610fe$export$376823fb52709d2f(component, base, json.combination, json.combination_config, json.api.config);
    base = $6eea7234d56610fe$export$2918ee16067fdfba(base, json.metadata?.["name"]);
    return json.api.data && !transformer ? $6eea7234d56610fe$var$removeNoDataLayers(base, component, json.api.data) : base;
}
function $6eea7234d56610fe$var$removeNoDataLayers(base, component, data) {
    for(const layer in base){
        if (base[layer]["hidden"]) continue;
        const layerType = $6eea7234d56610fe$export$92b70e511152790f(layer);
        const datum = data[layer];
        if (layerType === "icon" || layerType === "text" || layerType === "image") {
            const value = datum?.["value"];
            const name = value?.name;
            if (!name || name.includes(".")) continue;
            const val = component[value.name] || base[layer]["value"];
            if (val === void 0 || val === null || val === "") base[layer]["hidden"] = true;
        }
    }
    return base;
}
function $6eea7234d56610fe$export$a1a0a7262a295961(componentName, base, hierarchy, invariants = {}, tokens) {
    const layerKeySet = /* @__PURE__ */ new Set();
    return $6eea7234d56610fe$var$drawComponentHierarchy(componentName, hierarchy, base, invariants, layerKeySet, tokens);
}
function $6eea7234d56610fe$var$drawComponentHierarchy(componentName, hierarchy, base, invariants, layerKeySet, tokens) {
    const root = $6eea7234d56610fe$export$31e4419873013369(hierarchy) || hierarchy;
    if ($6eea7234d56610fe$export$859883d4ec9c7db4.updateFlatTokens && tokens && tokens?.["brandVersion"] === "jio-v2" && // layerKey === 'container' && // not sure
    Object.keys(base[root] ?? {}).some((key)=>$6eea7234d56610fe$export$beb192a6dc60a1a7.includes(key))) tokens = $6eea7234d56610fe$export$5cc69797806ce5c5(tokens, base[root]);
    const children = typeof hierarchy === "string" ? [] : hierarchy[root];
    const { styles: rootVars, classes: rootClasses } = $6eea7234d56610fe$var$drawComponentBase(componentName, root, base[root], invariants[root], tokens);
    if (children?.length) {
        const childrenVars = {};
        const childrenClasses = {};
        let hasVisibleChildren = false;
        for (const child of children){
            const childRoot = typeof child === "string" ? child : $6eea7234d56610fe$export$31e4419873013369(child);
            if (typeof child === "string") {
                let newTokens = tokens;
                if ($6eea7234d56610fe$export$859883d4ec9c7db4.updateFlatTokens && tokens && tokens?.["brandVersion"] === "jio-v2" && // layerKey === 'container' && // not sure
                Object.keys(base[childRoot] ?? {}).some((key)=>$6eea7234d56610fe$export$beb192a6dc60a1a7.includes(key))) newTokens = $6eea7234d56610fe$export$5cc69797806ce5c5(tokens, base[childRoot]);
                const visible = !base[child]?.["hidden"];
                hasVisibleChildren ||= visible;
                const childVars = $6eea7234d56610fe$var$drawComponentBase(componentName, child, base[child], invariants[child], newTokens);
                Object.assign(childrenVars, childVars.styles);
                Object.assign(childrenClasses, childVars.classes);
            } else {
                const childLayer = $6eea7234d56610fe$export$31e4419873013369(child);
                const childVars = $6eea7234d56610fe$var$drawComponentHierarchy(componentName, child, base, invariants, layerKeySet, tokens);
                const visible = !base[childLayer]?.["hidden"];
                hasVisibleChildren ||= visible;
                Object.assign(childrenVars, childVars.styles);
                Object.assign(childrenClasses, childVars.classes);
            }
        }
        const combinedVars = {
            ...rootVars,
            ...childrenVars
        };
        const combinedClasses = {
            ...rootClasses,
            ...childrenClasses
        };
        base[root] ??= {};
        if (hasVisibleChildren || base[root]["show"]) return {
            styles: combinedVars,
            classes: combinedClasses
        };
        base[root]["hidden"] = true;
        return {
            styles: combinedVars,
            classes: combinedClasses
        };
    }
    return {
        styles: rootVars,
        classes: rootClasses
    };
}
function $6eea7234d56610fe$var$drawComponentBase(componentName, layer, baseMap, invariantsMap, tokens) {
    if (!baseMap) return {
        styles: {},
        classes: {}
    };
    const baseCSSVars = {};
    const baseClasses = {};
    const { behavior: behavior = {}, ...layerObj } = baseMap;
    const layerKey = $6eea7234d56610fe$export$92b70e511152790f(layer);
    const isV3 = tokens?.["brandVersion"] === "jio-v2";
    const { styles: layerStyle, classes: layerClasses } = $6eea7234d56610fe$export$43447905499a2c3e(componentName, layer, layerObj, isV3 ? invariantsMap : {}, layer, void 0, tokens);
    if (isV3 && layerKey && [
        "icon",
        "text",
        "jds_text2",
        "jds_icon2",
        "container",
        "jds_container2"
    ].includes(layerKey)) {
        behavior["hover"] = behavior["hover"] || {};
        behavior["active"] = behavior["active"] || {};
        if (layerKey === "icon" || layerKey === "text" || layerKey === "jds_text2" || layerKey === "jds_icon2") {
            if (layerObj["color"]) {
                behavior["hover"]["color"] = layerObj["color"];
                behavior["active"]["color"] = layerObj["color"];
            }
        } else {
            if (layerObj["background-color"]) {
                behavior["hover"]["background-color"] = layerObj["background-color"];
                behavior["active"]["background-color"] = layerObj["background-color"];
            }
            if (layerObj["border-color"]) {
                behavior["hover"]["border-color"] = layerObj["border-color"];
                behavior["active"]["border-color"] = layerObj["border-color"];
            }
        }
    }
    Object.assign(baseCSSVars, layerStyle);
    baseClasses[layer] = layerClasses;
    for(const pseudo in behavior){
        const merged = (0, $bff35c0dd9851fab$export$4950aa0f605343fb)(layerObj, behavior[pseudo]);
        const behaviorInvariants = invariantsMap?.behavior?.[pseudo];
        const { styles: pseudoLayerStyle, classes: pseudoLayerClasses } = $6eea7234d56610fe$export$43447905499a2c3e(componentName, layer, isV3 ? behavior[pseudo] : merged, isV3 ? behaviorInvariants : void 0, layer, pseudo, tokens ? {
            ...tokens,
            state: pseudo
        } : void 0);
        Object.assign(baseCSSVars, pseudoLayerStyle);
        baseClasses[layer] = baseClasses[layer].concat(pseudoLayerClasses);
    }
    return {
        styles: baseCSSVars,
        classes: baseClasses
    };
}
const $6eea7234d56610fe$export$d72eddc0980b68c9 = (custom)=>{
    const [, base64] = custom?.split("--") || [];
    const convertedCustom = $6eea7234d56610fe$export$9cc362b209501dfe(base64);
    return convertedCustom;
};
function $6eea7234d56610fe$var$withComponentTokensHelper(baseMap, metaCompName, fallback) {
    for(const key in baseMap){
        const value = baseMap[key];
        if (typeof value === "object") baseMap[key] = $6eea7234d56610fe$var$withComponentTokensHelper(baseMap[key], metaCompName, fallback);
        else if (typeof value === "string") {
            const replacement = metaCompName ? $6eea7234d56610fe$export$859883d4ec9c7db4.getComponentToken(value, metaCompName) : void 0;
            let icon, text;
            if (fallback === "icon") icon = $6eea7234d56610fe$export$859883d4ec9c7db4.getComponentToken(value, "JDSIcon");
            else if (fallback === "text") text = $6eea7234d56610fe$export$859883d4ec9c7db4.getComponentToken(value, "JDSText");
            baseMap[key] = replacement ?? icon ?? text ?? value;
        }
    }
    return baseMap;
}
function $6eea7234d56610fe$export$2918ee16067fdfba(base, metaCompName) {
    for(const layer in base){
        const baseMap = base[layer];
        const fallback = layer.includes("icon") ? "icon" : layer.includes("text") ? "text" : void 0;
        base[layer] = $6eea7234d56610fe$var$withComponentTokensHelper(baseMap, metaCompName, fallback);
    }
    return base;
}
function $6eea7234d56610fe$export$d785cbf77f40ae28(func, details) {
    const start = performance.now();
    const result = func();
    const end = performance.now();
    setTimeout(()=>{
        console.log(`Time Taken${details ? ` for ${details}` : ""}: ${end - start}`);
    });
    return result;
}
const $6eea7234d56610fe$export$b81511b7d77b08 = (reference, defaultValues)=>{
    Object.keys(defaultValues).forEach((prop)=>{
        if (reference[prop] === void 0) reference[prop] = defaultValues[prop];
    });
    return reference;
};
const $6eea7234d56610fe$export$460dbca19df1617d = (hex)=>{
    const hexRegex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3}|[A-Fa-f0-9]{8})$/;
    return hexRegex.test(hex);
};




const $f8fd43f1ee3f8cd8$var$crimson = {
    "crimson.100": {
        "crimson.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.600": {
            contrast: 8.873419280265287,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.700": {
            contrast: 12.816158124839067,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.800": {
            contrast: 17.879308557844908,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 92
        },
        "crimson.900": {
            contrast: 20.86889538110057,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84.5
        },
        "crimson.1000": {
            contrast: 24.841138749445182,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77.5
        },
        "crimson.1100": {
            contrast: 28.89606289883126,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "crimson.1200": {
            contrast: 33.605776673427265,
            lc60: 100,
            lc45: 100,
            lc30: 93.5,
            lc10: 65.5
        },
        "crimson.1300": {
            contrast: 38.306027679116184,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 60.5
        },
        "crimson.1400": {
            contrast: 42.64514951811362,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 56.5
        },
        "crimson.1500": {
            contrast: 47.47529732205652,
            lc60: 100,
            lc45: 96.5,
            lc30: 76.5,
            lc10: 53
        },
        "crimson.1600": {
            contrast: 52.56370163199136,
            lc60: 100,
            lc45: 90.5,
            lc30: 72,
            lc10: 50
        },
        "crimson.1700": {
            contrast: 57.72965128501034,
            lc60: 100,
            lc45: 86,
            lc30: 68,
            lc10: 47
        },
        "crimson.1800": {
            contrast: 63.023347963082365,
            lc60: 97,
            lc45: 81,
            lc30: 64.5,
            lc10: 45
        },
        "crimson.1900": {
            contrast: 68.85804401615995,
            lc60: 91.5,
            lc45: 77,
            lc30: 61,
            lc10: 42.5
        },
        "crimson.2000": {
            contrast: 74.85090888815226,
            lc60: 87,
            lc45: 73,
            lc30: 58,
            lc10: 40.5
        },
        "crimson.2100": {
            contrast: 81.22304524651815,
            lc60: 82.5,
            lc45: 69.5,
            lc30: 55,
            lc10: 38.5
        },
        "crimson.2200": {
            contrast: 87.52099208798967,
            lc60: 79,
            lc45: 66.5,
            lc30: 52.5,
            lc10: 36.5
        },
        "crimson.2300": {
            contrast: 94.18208733230342,
            lc60: 75.5,
            lc45: 63,
            lc30: 50,
            lc10: 35
        },
        "crimson.2400": {
            contrast: 101.14994627278368,
            lc60: 72,
            lc45: 60.5,
            lc30: 48,
            lc10: 33.5
        },
        "crimson.2500": {
            contrast: 107.88473318309848,
            lc60: 69,
            lc45: 58,
            lc30: 46,
            lc10: 32
        }
    },
    "crimson.200": {
        "crimson.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.600": {
            contrast: 8.410581638478499,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.700": {
            contrast: 12.35332048305228,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.800": {
            contrast: 17.41647091605812,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91.5
        },
        "crimson.900": {
            contrast: 20.406057739313784,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82.5
        },
        "crimson.1000": {
            contrast: 24.37830110765839,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74.5
        },
        "crimson.1100": {
            contrast: 28.433225257044466,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "crimson.1200": {
            contrast: 33.14293903164047,
            lc60: 100,
            lc45: 100,
            lc30: 93.5,
            lc10: 61
        },
        "crimson.1300": {
            contrast: 37.84319003732939,
            lc60: 100,
            lc45: 100,
            lc30: 86,
            lc10: 56.5
        },
        "crimson.1400": {
            contrast: 42.18231187632683,
            lc60: 100,
            lc45: 100,
            lc30: 80.5,
            lc10: 53
        },
        "crimson.1500": {
            contrast: 47.012459680269735,
            lc60: 100,
            lc45: 97,
            lc30: 75,
            lc10: 49.5
        },
        "crimson.1600": {
            contrast: 52.10086399020456,
            lc60: 100,
            lc45: 91,
            lc30: 70,
            lc10: 46.5
        },
        "crimson.1700": {
            contrast: 57.26681364322354,
            lc60: 100,
            lc45: 85.5,
            lc30: 66,
            lc10: 44
        },
        "crimson.1800": {
            contrast: 62.56051032129558,
            lc60: 97,
            lc45: 80.5,
            lc30: 62.5,
            lc10: 41
        },
        "crimson.1900": {
            contrast: 68.39520637437315,
            lc60: 91.5,
            lc45: 76,
            lc30: 59,
            lc10: 39.5
        },
        "crimson.2000": {
            contrast: 74.38807124636547,
            lc60: 87,
            lc45: 72,
            lc30: 56,
            lc10: 37.5
        },
        "crimson.2100": {
            contrast: 80.76020760473138,
            lc60: 82,
            lc45: 68.5,
            lc30: 53,
            lc10: 35.5
        },
        "crimson.2200": {
            contrast: 87.05815444620288,
            lc60: 78,
            lc45: 65,
            lc30: 50.5,
            lc10: 34
        },
        "crimson.2300": {
            contrast: 93.71924969051662,
            lc60: 74.5,
            lc45: 62,
            lc30: 48.5,
            lc10: 32.5
        },
        "crimson.2400": {
            contrast: 100.6871086309969,
            lc60: 71,
            lc45: 59.5,
            lc30: 46,
            lc10: 31
        },
        "crimson.2500": {
            contrast: 107.42189554131167,
            lc60: 68,
            lc45: 56.5,
            lc30: 44.5,
            lc10: 29.5
        }
    },
    "crimson.300": {
        "crimson.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.700": {
            contrast: 10.912292294581205,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.800": {
            contrast: 15.975442727587048,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95.5
        },
        "crimson.900": {
            contrast: 18.965029550842708,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85.5
        },
        "crimson.1000": {
            contrast: 22.937272919187315,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75
        },
        "crimson.1100": {
            contrast: 26.992197068573386,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67
        },
        "crimson.1200": {
            contrast: 31.701910843169394,
            lc60: 100,
            lc45: 100,
            lc30: 96,
            lc10: 60.5
        },
        "crimson.1300": {
            contrast: 36.40216184885831,
            lc60: 100,
            lc45: 100,
            lc30: 87.5,
            lc10: 55
        },
        "crimson.1400": {
            contrast: 40.74128368785575,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 51.5
        },
        "crimson.1500": {
            contrast: 45.571431491798656,
            lc60: 100,
            lc45: 99,
            lc30: 75.5,
            lc10: 48
        },
        "crimson.1600": {
            contrast: 50.659835801733486,
            lc60: 100,
            lc45: 92,
            lc30: 70,
            lc10: 45
        },
        "crimson.1700": {
            contrast: 55.82578545475248,
            lc60: 100,
            lc45: 86.5,
            lc30: 66,
            lc10: 42.5
        },
        "crimson.1800": {
            contrast: 61.1194821328245,
            lc60: 98.5,
            lc45: 81,
            lc30: 62.5,
            lc10: 40.5
        },
        "crimson.1900": {
            contrast: 66.95417818590208,
            lc60: 93,
            lc45: 76.5,
            lc30: 59,
            lc10: 38.5
        },
        "crimson.2000": {
            contrast: 72.94704305789439,
            lc60: 87.5,
            lc45: 72.5,
            lc30: 56,
            lc10: 36.5
        },
        "crimson.2100": {
            contrast: 79.31917941626028,
            lc60: 83,
            lc45: 69,
            lc30: 53,
            lc10: 35
        },
        "crimson.2200": {
            contrast: 85.6171262577318,
            lc60: 79,
            lc45: 65.5,
            lc30: 50.5,
            lc10: 33
        },
        "crimson.2300": {
            contrast: 92.27822150204555,
            lc60: 75,
            lc45: 62.5,
            lc30: 48,
            lc10: 32
        },
        "crimson.2400": {
            contrast: 99.2460804425258,
            lc60: 72,
            lc45: 59.5,
            lc30: 46,
            lc10: 30.5
        },
        "crimson.2500": {
            contrast: 105.9808673528406,
            lc60: 69,
            lc45: 57,
            lc30: 44.5,
            lc10: 29.5
        }
    },
    "crimson.400": {
        "crimson.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.700": {
            contrast: 9.07788575268778,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.800": {
            contrast: 14.141036185693622,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.900": {
            contrast: 17.130623008949286,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 90.5
        },
        "crimson.1000": {
            contrast: 21.102866377293893,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77.5
        },
        "crimson.1100": {
            contrast: 25.157790526679968,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68.5
        },
        "crimson.1200": {
            contrast: 29.867504301275975,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61
        },
        "crimson.1300": {
            contrast: 34.56775530696489,
            lc60: 100,
            lc45: 100,
            lc30: 90,
            lc10: 55.5
        },
        "crimson.1400": {
            contrast: 38.906877145962326,
            lc60: 100,
            lc45: 100,
            lc30: 83,
            lc10: 51
        },
        "crimson.1500": {
            contrast: 43.73702494990523,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 47.5
        },
        "crimson.1600": {
            contrast: 48.82542925984006,
            lc60: 100,
            lc45: 94,
            lc30: 71,
            lc10: 44.5
        },
        "crimson.1700": {
            contrast: 53.99137891285905,
            lc60: 100,
            lc45: 88,
            lc30: 66.5,
            lc10: 42
        },
        "crimson.1800": {
            contrast: 59.28507559093108,
            lc60: 100,
            lc45: 82.5,
            lc30: 63,
            lc10: 40
        },
        "crimson.1900": {
            contrast: 65.11977164400867,
            lc60: 94.5,
            lc45: 77.5,
            lc30: 59,
            lc10: 37.5
        },
        "crimson.2000": {
            contrast: 71.11263651600098,
            lc60: 89,
            lc45: 73.5,
            lc30: 56,
            lc10: 36
        },
        "crimson.2100": {
            contrast: 77.48477287436687,
            lc60: 84,
            lc45: 69.5,
            lc30: 53.5,
            lc10: 34
        },
        "crimson.2200": {
            contrast: 83.78271971583838,
            lc60: 80,
            lc45: 66,
            lc30: 50.5,
            lc10: 33
        },
        "crimson.2300": {
            contrast: 90.44381496015214,
            lc60: 76,
            lc45: 63,
            lc30: 48.5,
            lc10: 31.5
        },
        "crimson.2400": {
            contrast: 97.41167390063238,
            lc60: 72.5,
            lc45: 60,
            lc30: 46.5,
            lc10: 30
        },
        "crimson.2500": {
            contrast: 104.14646081094719,
            lc60: 69.5,
            lc45: 57.5,
            lc30: 44.5,
            lc10: 29
        }
    },
    "crimson.500": {
        "crimson.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.800": {
            contrast: 11.436692150355107,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.900": {
            contrast: 14.42627897361077,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1000": {
            contrast: 18.398522341955378,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85
        },
        "crimson.1100": {
            contrast: 22.453446491341452,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "crimson.1200": {
            contrast: 27.163160265937456,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "crimson.1300": {
            contrast: 31.863411271626376,
            lc60: 100,
            lc45: 100,
            lc30: 95.5,
            lc10: 57
        },
        "crimson.1400": {
            contrast: 36.20253311062381,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 52.5
        },
        "crimson.1500": {
            contrast: 41.03268091456672,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 48.5
        },
        "crimson.1600": {
            contrast: 46.12108522450155,
            lc60: 100,
            lc45: 98,
            lc30: 73.5,
            lc10: 45.5
        },
        "crimson.1700": {
            contrast: 51.28703487752053,
            lc60: 100,
            lc45: 91,
            lc30: 69,
            lc10: 43
        },
        "crimson.1800": {
            contrast: 56.580731555592564,
            lc60: 100,
            lc45: 85,
            lc30: 64.5,
            lc10: 40.5
        },
        "crimson.1900": {
            contrast: 62.41542760867015,
            lc60: 97,
            lc45: 80,
            lc30: 61,
            lc10: 38.5
        },
        "crimson.2000": {
            contrast: 68.40829248066245,
            lc60: 91.5,
            lc45: 75.5,
            lc30: 57.5,
            lc10: 36.5
        },
        "crimson.2100": {
            contrast: 74.78042883902836,
            lc60: 86,
            lc45: 71,
            lc30: 54.5,
            lc10: 35
        },
        "crimson.2200": {
            contrast: 81.07837568049987,
            lc60: 82,
            lc45: 67.5,
            lc30: 52,
            lc10: 33
        },
        "crimson.2300": {
            contrast: 87.73947092481362,
            lc60: 77.5,
            lc45: 64.5,
            lc30: 49.5,
            lc10: 32
        },
        "crimson.2400": {
            contrast: 94.70732986529387,
            lc60: 74,
            lc45: 61.5,
            lc30: 47.5,
            lc10: 30.5
        },
        "crimson.2500": {
            contrast: 101.44211677560865,
            lc60: 71,
            lc45: 59,
            lc30: 45.5,
            lc10: 29.5
        }
    },
    "crimson.600": {
        "crimson.100": {
            contrast: 10.28111424463956,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.200": {
            contrast: 9.661057815952624,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.300": {
            contrast: 7.783968931682822,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.800": {
            contrast: 7.707446820700143,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.900": {
            contrast: 10.697033643955805,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1000": {
            contrast: 14.669277012300416,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1100": {
            contrast: 18.724201161686494,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84.5
        },
        "crimson.1200": {
            contrast: 23.4339149362825,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "crimson.1300": {
            contrast: 28.134165941971418,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63
        },
        "crimson.1400": {
            contrast: 32.47328778096885,
            lc60: 100,
            lc45: 100,
            lc30: 94,
            lc10: 56.5
        },
        "crimson.1500": {
            contrast: 37.30343558491176,
            lc60: 100,
            lc45: 100,
            lc30: 85.5,
            lc10: 52
        },
        "crimson.1600": {
            contrast: 42.39183989484658,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 48
        },
        "crimson.1700": {
            contrast: 47.55778954786557,
            lc60: 100,
            lc45: 96,
            lc30: 73,
            lc10: 45
        },
        "crimson.1800": {
            contrast: 52.851486225937606,
            lc60: 100,
            lc45: 89.5,
            lc30: 68,
            lc10: 42.5
        },
        "crimson.1900": {
            contrast: 58.68618227901518,
            lc60: 100,
            lc45: 83.5,
            lc30: 63.5,
            lc10: 40.5
        },
        "crimson.2000": {
            contrast: 64.6790471510075,
            lc60: 95,
            lc45: 78.5,
            lc30: 60,
            lc10: 38.5
        },
        "crimson.2100": {
            contrast: 71.05118350937339,
            lc60: 89.5,
            lc45: 74,
            lc30: 57,
            lc10: 36.5
        },
        "crimson.2200": {
            contrast: 77.3491303508449,
            lc60: 84.5,
            lc45: 70,
            lc30: 54,
            lc10: 35
        },
        "crimson.2300": {
            contrast: 84.01022559515864,
            lc60: 80,
            lc45: 66.5,
            lc30: 51.5,
            lc10: 33.5
        },
        "crimson.2400": {
            contrast: 90.9780845356389,
            lc60: 76.5,
            lc45: 63.5,
            lc30: 49,
            lc10: 32
        },
        "crimson.2500": {
            contrast: 97.7128714459537,
            lc60: 73,
            lc45: 60.5,
            lc30: 47,
            lc10: 30.5
        }
    },
    "crimson.700": {
        "crimson.100": {
            contrast: 14.564400026875028,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.200": {
            contrast: 13.944343598188091,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.300": {
            contrast: 12.067254713918288,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.400": {
            contrast: 9.765839376449522,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1000": {
            contrast: 10.900198008585498,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1100": {
            contrast: 14.955122157971573,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1200": {
            contrast: 19.66483593256758,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81.5
        },
        "crimson.1300": {
            contrast: 24.3650869382565,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "crimson.1400": {
            contrast: 28.704208777253932,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63
        },
        "crimson.1500": {
            contrast: 33.53435658119684,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 57
        },
        "crimson.1600": {
            contrast: 38.62276089113166,
            lc60: 100,
            lc45: 100,
            lc30: 84,
            lc10: 52
        },
        "crimson.1700": {
            contrast: 43.78871054415065,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 48.5
        },
        "crimson.1800": {
            contrast: 49.08240722222268,
            lc60: 100,
            lc45: 94,
            lc30: 72,
            lc10: 45.5
        },
        "crimson.1900": {
            contrast: 54.91710327530026,
            lc60: 100,
            lc45: 87.5,
            lc30: 67,
            lc10: 43
        },
        "crimson.2000": {
            contrast: 60.90996814729258,
            lc60: 99,
            lc45: 82,
            lc30: 63.5,
            lc10: 40.5
        },
        "crimson.2100": {
            contrast: 67.28210450565848,
            lc60: 92.5,
            lc45: 77,
            lc30: 59.5,
            lc10: 38.5
        },
        "crimson.2200": {
            contrast: 73.58005134713,
            lc60: 87.5,
            lc45: 73,
            lc30: 56.5,
            lc10: 36.5
        },
        "crimson.2300": {
            contrast: 80.24114659144374,
            lc60: 83,
            lc45: 69.5,
            lc30: 54,
            lc10: 35
        },
        "crimson.2400": {
            contrast: 87.209005531924,
            lc60: 79,
            lc45: 65.5,
            lc30: 51,
            lc10: 33.5
        },
        "crimson.2500": {
            contrast: 93.94379244223879,
            lc60: 75,
            lc45: 63,
            lc30: 49,
            lc10: 32
        }
    },
    "crimson.800": {
        "crimson.100": {
            contrast: 19.94098547041679,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53
        },
        "crimson.200": {
            contrast: 19.320929041729855,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "crimson.300": {
            contrast: 17.443840157460055,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79.5
        },
        "crimson.400": {
            contrast: 15.142424819991284,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98
        },
        "crimson.500": {
            contrast: 11.876471970729515,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.600": {
            contrast: 7.5471148870613405,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1100": {
            contrast: 10.059533424846354,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1200": {
            contrast: 14.769247199442361,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1300": {
            contrast: 19.46949820513128,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83
        },
        "crimson.1400": {
            contrast: 23.808620044128716,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72.5
        },
        "crimson.1500": {
            contrast: 28.638767848071616,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64.5
        },
        "crimson.1600": {
            contrast: 33.72717215800645,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 58.5
        },
        "crimson.1700": {
            contrast: 38.89312181102543,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 53.5
        },
        "crimson.1800": {
            contrast: 44.18681848909746,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 49.5
        },
        "crimson.1900": {
            contrast: 50.02151454217504,
            lc60: 100,
            lc45: 93.5,
            lc30: 72.5,
            lc10: 46.5
        },
        "crimson.2000": {
            contrast: 56.01437941416737,
            lc60: 100,
            lc45: 87,
            lc30: 67.5,
            lc10: 44
        },
        "crimson.2100": {
            contrast: 62.38651577253326,
            lc60: 97.5,
            lc45: 81.5,
            lc30: 63.5,
            lc10: 41.5
        },
        "crimson.2200": {
            contrast: 68.68446261400477,
            lc60: 91.5,
            lc45: 77,
            lc30: 60.5,
            lc10: 39.5
        },
        "crimson.2300": {
            contrast: 75.34555785831853,
            lc60: 87,
            lc45: 73,
            lc30: 57,
            lc10: 37.5
        },
        "crimson.2400": {
            contrast: 82.31341679879878,
            lc60: 82,
            lc45: 69,
            lc30: 54,
            lc10: 36
        },
        "crimson.2500": {
            contrast: 89.04820370911357,
            lc60: 78.5,
            lc45: 66,
            lc30: 51.5,
            lc10: 34.5
        }
    },
    "crimson.900": {
        "crimson.100": {
            contrast: 23.06267702072904,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 45
        },
        "crimson.200": {
            contrast: 22.442620592042104,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54
        },
        "crimson.300": {
            contrast: 20.5655317077723,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65
        },
        "crimson.400": {
            contrast: 18.264116370303533,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78.5
        },
        "crimson.500": {
            contrast: 14.998163521041766,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.600": {
            contrast: 10.668806437373588,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1200": {
            contrast: 11.854215050625646,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1300": {
            contrast: 16.554466056314563,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 92.5
        },
        "crimson.1400": {
            contrast: 20.893587895312,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76.5
        },
        "crimson.1500": {
            contrast: 25.723735699254902,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65.5
        },
        "crimson.1600": {
            contrast: 30.812140009189736,
            lc60: 100,
            lc45: 100,
            lc30: 97.5,
            lc10: 58
        },
        "crimson.1700": {
            contrast: 35.978089662208724,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 52.5
        },
        "crimson.1800": {
            contrast: 41.271786340280755,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 47.5
        },
        "crimson.1900": {
            contrast: 47.10648239335833,
            lc60: 100,
            lc45: 96.5,
            lc30: 73,
            lc10: 44
        },
        "crimson.2000": {
            contrast: 53.09934726535065,
            lc60: 100,
            lc45: 89,
            lc30: 67,
            lc10: 41
        },
        "crimson.2100": {
            contrast: 59.47148362371654,
            lc60: 100,
            lc45: 82.5,
            lc30: 62.5,
            lc10: 38.5
        },
        "crimson.2200": {
            contrast: 65.76943046518805,
            lc60: 93.5,
            lc45: 77,
            lc30: 58.5,
            lc10: 36.5
        },
        "crimson.2300": {
            contrast: 72.43052570950181,
            lc60: 88,
            lc45: 72,
            lc30: 55,
            lc10: 34
        },
        "crimson.2400": {
            contrast: 79.39838464998206,
            lc60: 83,
            lc45: 68,
            lc30: 52,
            lc10: 32.5
        },
        "crimson.2500": {
            contrast: 86.13317156029684,
            lc60: 78.5,
            lc45: 64.5,
            lc30: 49,
            lc10: 31
        }
    },
    "crimson.1000": {
        "crimson.100": {
            contrast: 27.15947311121527,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 38.5
        },
        "crimson.200": {
            contrast: 26.539416682528337,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 46
        },
        "crimson.300": {
            contrast: 24.66232779825854,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54
        },
        "crimson.400": {
            contrast: 22.36091246078977,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63
        },
        "crimson.500": {
            contrast: 19.094959611528,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76.5
        },
        "crimson.600": {
            contrast: 14.765602527859825,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.700": {
            contrast: 10.537954568108884,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1200": {
            contrast: 7.957004859172027,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1300": {
            contrast: 12.657255864860945,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1400": {
            contrast: 16.996377703858382,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89.5
        },
        "crimson.1500": {
            contrast: 21.826525507801286,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "crimson.1600": {
            contrast: 26.91492981773611,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "crimson.1700": {
            contrast: 32.0808794707551,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 56
        },
        "crimson.1800": {
            contrast: 37.374576148827124,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 49.5
        },
        "crimson.1900": {
            contrast: 43.2092722019047,
            lc60: 100,
            lc45: 100,
            lc30: 76,
            lc10: 45
        },
        "crimson.2000": {
            contrast: 49.20213707389702,
            lc60: 100,
            lc45: 94,
            lc30: 69.5,
            lc10: 41.5
        },
        "crimson.2100": {
            contrast: 55.57427343226292,
            lc60: 100,
            lc45: 86,
            lc30: 64.5,
            lc10: 38.5
        },
        "crimson.2200": {
            contrast: 61.872220273734435,
            lc60: 97.5,
            lc45: 79.5,
            lc30: 59.5,
            lc10: 35.5
        },
        "crimson.2300": {
            contrast: 68.53331551804818,
            lc60: 91,
            lc45: 74.5,
            lc30: 55.5,
            lc10: 33.5
        },
        "crimson.2400": {
            contrast: 75.50117445852844,
            lc60: 85,
            lc45: 69.5,
            lc30: 52.5,
            lc10: 31.5
        },
        "crimson.2500": {
            contrast: 82.23596136884322,
            lc60: 80,
            lc45: 65.5,
            lc30: 49.5,
            lc10: 30
        }
    },
    "crimson.1100": {
        "crimson.100": {
            contrast: 31.289292158582988,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 34.5
        },
        "crimson.200": {
            contrast: 30.669235729896055,
            lc60: 100,
            lc45: 100,
            lc30: 93,
            lc10: 40
        },
        "crimson.300": {
            contrast: 28.79214684562626,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 45.5
        },
        "crimson.400": {
            contrast: 26.490731508157484,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 52
        },
        "crimson.500": {
            contrast: 23.22477865889572,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61.5
        },
        "crimson.600": {
            contrast: 18.89542157522754,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77
        },
        "crimson.700": {
            contrast: 14.667773615476602,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.800": {
            contrast: 9.34084147325128,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1300": {
            contrast: 8.653843271393521,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1400": {
            contrast: 12.992965110390958,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1500": {
            contrast: 17.823112914333862,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86
        },
        "crimson.1600": {
            contrast: 22.911517224268692,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70.5
        },
        "crimson.1700": {
            contrast: 28.077466877287677,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "crimson.1800": {
            contrast: 33.37116355535971,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 53.5
        },
        "crimson.1900": {
            contrast: 39.20585960843728,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 47.5
        },
        "crimson.2000": {
            contrast: 45.198724480429604,
            lc60: 100,
            lc45: 99.5,
            lc30: 74,
            lc10: 43.5
        },
        "crimson.2100": {
            contrast: 51.5708608387955,
            lc60: 100,
            lc45: 90.5,
            lc30: 67,
            lc10: 39.5
        },
        "crimson.2200": {
            contrast: 57.86880768026701,
            lc60: 100,
            lc45: 83,
            lc30: 61.5,
            lc10: 37
        },
        "crimson.2300": {
            contrast: 64.52990292458077,
            lc60: 95,
            lc45: 77,
            lc30: 57,
            lc10: 34
        },
        "crimson.2400": {
            contrast: 71.49776186506102,
            lc60: 88,
            lc45: 71.5,
            lc30: 53,
            lc10: 31.5
        },
        "crimson.2500": {
            contrast: 78.2325487753758,
            lc60: 82.5,
            lc45: 67.5,
            lc30: 50.5,
            lc10: 30
        }
    },
    "crimson.1200": {
        "crimson.100": {
            contrast: 36.028451790740164,
            lc60: 100,
            lc45: 100,
            lc30: 63,
            lc10: 30
        },
        "crimson.200": {
            contrast: 35.40839536205323,
            lc60: 100,
            lc45: 100,
            lc30: 72,
            lc10: 34.5
        },
        "crimson.300": {
            contrast: 33.53130647778343,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 38.5
        },
        "crimson.400": {
            contrast: 31.229891140314663,
            lc60: 100,
            lc45: 100,
            lc30: 93,
            lc10: 43.5
        },
        "crimson.500": {
            contrast: 27.96393829105289,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 50
        },
        "crimson.600": {
            contrast: 23.634581207384716,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59
        },
        "crimson.700": {
            contrast: 19.406933247633777,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "crimson.800": {
            contrast: 14.080001105408455,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.900": {
            contrast: 10.978446632868891,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1400": {
            contrast: 8.314935550892837,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1500": {
            contrast: 13.14508335483574,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1600": {
            contrast: 18.23348766477057,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84.5
        },
        "crimson.1700": {
            contrast: 23.399437317789555,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69.5
        },
        "crimson.1800": {
            contrast: 28.69313399586158,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59
        },
        "crimson.1900": {
            contrast: 34.527830048939165,
            lc60: 100,
            lc45: 100,
            lc30: 89.5,
            lc10: 51.5
        },
        "crimson.2000": {
            contrast: 40.520694920931476,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 46
        },
        "crimson.2100": {
            contrast: 46.892831279297376,
            lc60: 100,
            lc45: 97,
            lc30: 71,
            lc10: 41.5
        },
        "crimson.2200": {
            contrast: 53.19077812076889,
            lc60: 100,
            lc45: 88.5,
            lc30: 65,
            lc10: 38
        },
        "crimson.2300": {
            contrast: 59.85187336508264,
            lc60: 100,
            lc45: 81,
            lc30: 60,
            lc10: 34.5
        },
        "crimson.2400": {
            contrast: 66.8197323055629,
            lc60: 92.5,
            lc45: 74.5,
            lc30: 55,
            lc10: 32.5
        },
        "crimson.2500": {
            contrast: 73.55451921587768,
            lc60: 86,
            lc45: 70,
            lc30: 51.5,
            lc10: 30.5
        }
    },
    "crimson.1300": {
        "crimson.100": {
            contrast: 40.704046820658334,
            lc60: 100,
            lc45: 100,
            lc30: 55,
            lc10: 27
        },
        "crimson.200": {
            contrast: 40.083990391971405,
            lc60: 100,
            lc45: 100,
            lc30: 62,
            lc10: 30.5
        },
        "crimson.300": {
            contrast: 38.2069015077016,
            lc60: 100,
            lc45: 100,
            lc30: 69.5,
            lc10: 33.5
        },
        "crimson.400": {
            contrast: 35.905486170232834,
            lc60: 100,
            lc45: 100,
            lc30: 77.5,
            lc10: 37.5
        },
        "crimson.500": {
            contrast: 32.63953332097106,
            lc60: 100,
            lc45: 100,
            lc30: 89.5,
            lc10: 42.5
        },
        "crimson.600": {
            contrast: 28.310176237302887,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 49
        },
        "crimson.700": {
            contrast: 24.082528277551948,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "crimson.800": {
            contrast: 18.755596135326627,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74.5
        },
        "crimson.900": {
            contrast: 15.654041662787064,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95
        },
        "crimson.1000": {
            contrast: 11.575276451208042,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1100": {
            contrast: 7.455008089412709,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1500": {
            contrast: 8.449554031263077,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1600": {
            contrast: 13.537958341197903,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1700": {
            contrast: 18.70390799421689,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83
        },
        "crimson.1800": {
            contrast: 23.997604672288922,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68.5
        },
        "crimson.1900": {
            contrast: 29.832300725366494,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "crimson.2000": {
            contrast: 35.82516559735882,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 50
        },
        "crimson.2100": {
            contrast: 42.19730195572471,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 44.5
        },
        "crimson.2200": {
            contrast: 48.495248797196226,
            lc60: 100,
            lc45: 94,
            lc30: 69.5,
            lc10: 40
        },
        "crimson.2300": {
            contrast: 55.15634404150996,
            lc60: 100,
            lc45: 86,
            lc30: 63.5,
            lc10: 37
        },
        "crimson.2400": {
            contrast: 62.124202981990216,
            lc60: 97.5,
            lc45: 78.5,
            lc30: 58,
            lc10: 33.5
        },
        "crimson.2500": {
            contrast: 68.858989892305,
            lc60: 90.5,
            lc45: 73,
            lc30: 53.5,
            lc10: 31
        }
    },
    "crimson.1400": {
        "crimson.100": {
            contrast: 44.97792069372642,
            lc60: 100,
            lc45: 100,
            lc30: 50,
            lc10: 25
        },
        "crimson.200": {
            contrast: 44.35786426503949,
            lc60: 100,
            lc45: 100,
            lc30: 55.5,
            lc10: 28
        },
        "crimson.300": {
            contrast: 42.480775380769686,
            lc60: 100,
            lc45: 100,
            lc30: 61,
            lc10: 30
        },
        "crimson.400": {
            contrast: 40.17936004330092,
            lc60: 100,
            lc45: 100,
            lc30: 67.5,
            lc10: 33
        },
        "crimson.500": {
            contrast: 36.91340719403915,
            lc60: 100,
            lc45: 100,
            lc30: 76,
            lc10: 36.5
        },
        "crimson.600": {
            contrast: 32.584050110370974,
            lc60: 100,
            lc45: 100,
            lc30: 89,
            lc10: 41
        },
        "crimson.700": {
            contrast: 28.35640215062003,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 47
        },
        "crimson.800": {
            contrast: 23.02947000839471,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58
        },
        "crimson.900": {
            contrast: 19.927915535855146,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73
        },
        "crimson.1000": {
            contrast: 15.849150324276124,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 94
        },
        "crimson.1100": {
            contrast: 11.728881962480791,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1600": {
            contrast: 9.181707732453779,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1700": {
            contrast: 14.347657385472765,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1800": {
            contrast: 19.641354063544796,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79
        },
        "crimson.1900": {
            contrast: 25.476050116622368,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65
        },
        "crimson.2000": {
            contrast: 31.46891498861469,
            lc60: 100,
            lc45: 100,
            lc30: 96,
            lc10: 55
        },
        "crimson.2100": {
            contrast: 37.84105134698058,
            lc60: 100,
            lc45: 100,
            lc30: 83,
            lc10: 47.5
        },
        "crimson.2200": {
            contrast: 44.13899818845209,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 42.5
        },
        "crimson.2300": {
            contrast: 50.80009343276585,
            lc60: 100,
            lc45: 91,
            lc30: 66.5,
            lc10: 38
        },
        "crimson.2400": {
            contrast: 57.7679523732461,
            lc60: 100,
            lc45: 82.5,
            lc30: 60,
            lc10: 34.5
        },
        "crimson.2500": {
            contrast: 64.50273928356089,
            lc60: 94.5,
            lc45: 76,
            lc30: 55.5,
            lc10: 32.5
        }
    },
    "crimson.1500": {
        "crimson.100": {
            contrast: 49.69242551709676,
            lc60: 100,
            lc45: 73,
            lc30: 45,
            lc10: 22.5
        },
        "crimson.200": {
            contrast: 49.072369088409815,
            lc60: 100,
            lc45: 80.5,
            lc30: 50,
            lc10: 25
        },
        "crimson.300": {
            contrast: 47.19528020414002,
            lc60: 100,
            lc45: 89.5,
            lc30: 54,
            lc10: 27
        },
        "crimson.400": {
            contrast: 44.89386486667125,
            lc60: 100,
            lc45: 100,
            lc30: 59,
            lc10: 29
        },
        "crimson.500": {
            contrast: 41.627912017409486,
            lc60: 100,
            lc45: 100,
            lc30: 65,
            lc10: 31.5
        },
        "crimson.600": {
            contrast: 37.29855493374131,
            lc60: 100,
            lc45: 100,
            lc30: 73.5,
            lc10: 35
        },
        "crimson.700": {
            contrast: 33.07090697399037,
            lc60: 100,
            lc45: 100,
            lc30: 86,
            lc10: 39.5
        },
        "crimson.800": {
            contrast: 27.743974831765044,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 45.5
        },
        "crimson.900": {
            contrast: 24.642420359225483,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "crimson.1000": {
            contrast: 20.56365514764646,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "crimson.1100": {
            contrast: 16.44338678585113,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 90.5
        },
        "crimson.1200": {
            contrast: 11.70566692746402,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1700": {
            contrast: 9.476372175681222,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1800": {
            contrast: 14.770068853753251,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1900": {
            contrast: 20.60476490683083,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77
        },
        "crimson.2000": {
            contrast: 26.597629778823144,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61.5
        },
        "crimson.2100": {
            contrast: 32.96976613718904,
            lc60: 100,
            lc45: 100,
            lc30: 92.5,
            lc10: 52.5
        },
        "crimson.2200": {
            contrast: 39.267712978660555,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 45.5
        },
        "crimson.2300": {
            contrast: 45.9288082229743,
            lc60: 100,
            lc45: 98.5,
            lc30: 71.5,
            lc10: 40.5
        },
        "crimson.2400": {
            contrast: 52.89666716345456,
            lc60: 100,
            lc45: 88,
            lc30: 64,
            lc10: 36.5
        },
        "crimson.2500": {
            contrast: 59.63145407376934,
            lc60: 100,
            lc45: 80,
            lc30: 58,
            lc10: 33
        }
    },
    "crimson.1600": {
        "crimson.100": {
            contrast: 54.61473069151117,
            lc60: 100,
            lc45: 64.5,
            lc30: 41,
            lc10: 21
        },
        "crimson.200": {
            contrast: 53.99467426282424,
            lc60: 100,
            lc45: 70.5,
            lc30: 45,
            lc10: 22.5
        },
        "crimson.300": {
            contrast: 52.11758537855443,
            lc60: 100,
            lc45: 76.5,
            lc30: 48,
            lc10: 24
        },
        "crimson.400": {
            contrast: 49.81617004108566,
            lc60: 100,
            lc45: 83.5,
            lc30: 52,
            lc10: 26
        },
        "crimson.500": {
            contrast: 46.5502171918239,
            lc60: 100,
            lc45: 94,
            lc30: 56,
            lc10: 28
        },
        "crimson.600": {
            contrast: 42.22086010815572,
            lc60: 100,
            lc45: 100,
            lc30: 62.5,
            lc10: 30.5
        },
        "crimson.700": {
            contrast: 37.99321214840477,
            lc60: 100,
            lc45: 100,
            lc30: 70.5,
            lc10: 33
        },
        "crimson.800": {
            contrast: 32.666280006179456,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 38
        },
        "crimson.900": {
            contrast: 29.56472553363989,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 46
        },
        "crimson.1000": {
            contrast: 25.48596032206087,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "crimson.1100": {
            contrast: 21.36569196026554,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68.5
        },
        "crimson.1200": {
            contrast: 16.627972101878434,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 90
        },
        "crimson.1300": {
            contrast: 11.944835353435893,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1400": {
            contrast: 7.657003568757423,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1800": {
            contrast: 9.615301954011654,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1900": {
            contrast: 15.449998007089233,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 96.5
        },
        "crimson.2000": {
            contrast: 21.442862879081552,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74
        },
        "crimson.2100": {
            contrast: 27.81499923744744,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59
        },
        "crimson.2200": {
            contrast: 34.11294607891895,
            lc60: 100,
            lc45: 100,
            lc30: 90,
            lc10: 51
        },
        "crimson.2300": {
            contrast: 40.7740413232327,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 44
        },
        "crimson.2400": {
            contrast: 47.741900263712964,
            lc60: 100,
            lc45: 95,
            lc30: 68.5,
            lc10: 38.5
        },
        "crimson.2500": {
            contrast: 54.47668717402774,
            lc60: 100,
            lc45: 85.5,
            lc30: 61.5,
            lc10: 34.5
        }
    },
    "crimson.1700": {
        "crimson.100": {
            contrast: 59.56993459153078,
            lc60: 100,
            lc45: 58.5,
            lc30: 37.5,
            lc10: 19
        },
        "crimson.200": {
            contrast: 58.94987816284385,
            lc60: 100,
            lc45: 63.5,
            lc30: 41,
            lc10: 20.5
        },
        "crimson.300": {
            contrast: 57.07278927857404,
            lc60: 100,
            lc45: 68,
            lc30: 43.5,
            lc10: 22
        },
        "crimson.400": {
            contrast: 54.77137394110528,
            lc60: 100,
            lc45: 73.5,
            lc30: 46,
            lc10: 23
        },
        "crimson.500": {
            contrast: 51.50542109184351,
            lc60: 100,
            lc45: 80,
            lc30: 49.5,
            lc10: 24.5
        },
        "crimson.600": {
            contrast: 47.17606400817533,
            lc60: 100,
            lc45: 91.5,
            lc30: 54,
            lc10: 26.5
        },
        "crimson.700": {
            contrast: 42.94841604842439,
            lc60: 100,
            lc45: 100,
            lc30: 59.5,
            lc10: 28.5
        },
        "crimson.800": {
            contrast: 37.62148390619907,
            lc60: 100,
            lc45: 100,
            lc30: 68.5,
            lc10: 32
        },
        "crimson.900": {
            contrast: 34.5199294336595,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 38
        },
        "crimson.1000": {
            contrast: 30.441164222080484,
            lc60: 100,
            lc45: 100,
            lc30: 97,
            lc10: 45.5
        },
        "crimson.1100": {
            contrast: 26.320895860285148,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54
        },
        "crimson.1200": {
            contrast: 21.583176001898046,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "crimson.1300": {
            contrast: 16.900039253455507,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88
        },
        "crimson.1400": {
            contrast: 12.612207468777036,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1500": {
            contrast: 7.8751409622927815,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1900": {
            contrast: 10.194483618654008,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.2000": {
            contrast: 16.187348490646325,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 94
        },
        "crimson.2100": {
            contrast: 22.55948484901222,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70.5
        },
        "crimson.2200": {
            contrast: 28.857431690483732,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "crimson.2300": {
            contrast: 35.51852693479748,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 48
        },
        "crimson.2400": {
            contrast: 42.48638587527774,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 41.5
        },
        "crimson.2500": {
            contrast: 49.221172785592515,
            lc60: 100,
            lc45: 92.5,
            lc30: 66.5,
            lc10: 36.5
        }
    },
    "crimson.1800": {
        "crimson.100": {
            contrast: 64.60756131060131,
            lc60: 77.5,
            lc45: 54,
            lc30: 35,
            lc10: 17.5
        },
        "crimson.200": {
            contrast: 63.98750488191437,
            lc60: 84,
            lc45: 57.5,
            lc30: 37.5,
            lc10: 19
        },
        "crimson.300": {
            contrast: 62.110415997644566,
            lc60: 91,
            lc45: 61,
            lc30: 39.5,
            lc10: 20
        },
        "crimson.400": {
            contrast: 59.80900066017581,
            lc60: 100,
            lc45: 65.5,
            lc30: 42,
            lc10: 21
        },
        "crimson.500": {
            contrast: 56.54304781091404,
            lc60: 100,
            lc45: 70,
            lc30: 44,
            lc10: 22
        },
        "crimson.600": {
            contrast: 52.213690727245854,
            lc60: 100,
            lc45: 78,
            lc30: 47.5,
            lc10: 24
        },
        "crimson.700": {
            contrast: 47.98604276749492,
            lc60: 100,
            lc45: 88.5,
            lc30: 51.5,
            lc10: 25.5
        },
        "crimson.800": {
            contrast: 42.65911062526959,
            lc60: 100,
            lc45: 100,
            lc30: 58,
            lc10: 27.5
        },
        "crimson.900": {
            contrast: 39.55755615273003,
            lc60: 100,
            lc45: 100,
            lc30: 68,
            lc10: 33
        },
        "crimson.1000": {
            contrast: 35.47879094115101,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 38
        },
        "crimson.1100": {
            contrast: 31.358522579355675,
            lc60: 100,
            lc45: 100,
            lc30: 94,
            lc10: 44
        },
        "crimson.1200": {
            contrast: 26.620802720968566,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54
        },
        "crimson.1300": {
            contrast: 21.937665972526034,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "crimson.1400": {
            contrast: 17.649834187847564,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84
        },
        "crimson.1500": {
            contrast: 12.912767681363308,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1600": {
            contrast: 7.959519679146858,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.2000": {
            contrast: 10.780474727547496,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.2100": {
            contrast: 17.152611085913392,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 90
        },
        "crimson.2200": {
            contrast: 23.450557927384903,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "crimson.2300": {
            contrast: 30.11165317169865,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 55
        },
        "crimson.2400": {
            contrast: 37.07951211217891,
            lc60: 100,
            lc45: 100,
            lc30: 83.5,
            lc10: 46
        },
        "crimson.2500": {
            contrast: 43.81429902249369,
            lc60: 100,
            lc45: 100,
            lc30: 72.5,
            lc10: 40
        }
    },
    "crimson.1900": {
        "crimson.100": {
            contrast: 70.11700780773035,
            lc60: 69,
            lc45: 49.5,
            lc30: 32,
            lc10: 16.5
        },
        "crimson.200": {
            contrast: 69.49695137904341,
            lc60: 74,
            lc45: 52.5,
            lc30: 34,
            lc10: 17.5
        },
        "crimson.300": {
            contrast: 67.6198624947736,
            lc60: 78.5,
            lc45: 55.5,
            lc30: 36,
            lc10: 18.5
        },
        "crimson.400": {
            contrast: 65.31844715730483,
            lc60: 84,
            lc45: 58.5,
            lc30: 37.5,
            lc10: 19
        },
        "crimson.500": {
            contrast: 62.05249430804307,
            lc60: 93,
            lc45: 62,
            lc30: 39.5,
            lc10: 20
        },
        "crimson.600": {
            contrast: 57.72313722437489,
            lc60: 100,
            lc45: 67,
            lc30: 42,
            lc10: 21
        },
        "crimson.700": {
            contrast: 53.495489264623956,
            lc60: 100,
            lc45: 73.5,
            lc30: 45,
            lc10: 22.5
        },
        "crimson.800": {
            contrast: 48.168557122398624,
            lc60: 100,
            lc45: 86,
            lc30: 49,
            lc10: 24
        },
        "crimson.900": {
            contrast: 45.06700264985906,
            lc60: 100,
            lc45: 99,
            lc30: 57.5,
            lc10: 28
        },
        "crimson.1000": {
            contrast: 40.98823743828004,
            lc60: 100,
            lc45: 100,
            lc30: 66,
            lc10: 32.5
        },
        "crimson.1100": {
            contrast: 36.867969076484705,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 37
        },
        "crimson.1200": {
            contrast: 32.1302492180976,
            lc60: 100,
            lc45: 100,
            lc30: 91.5,
            lc10: 43
        },
        "crimson.1300": {
            contrast: 27.44711246965506,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 52
        },
        "crimson.1400": {
            contrast: 23.159280684976594,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "crimson.1500": {
            contrast: 18.42221417849234,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80.5
        },
        "crimson.1600": {
            contrast: 13.46896617627589,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1700": {
            contrast: 8.475573877408028,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.2100": {
            contrast: 11.169954961436938,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.2200": {
            contrast: 17.467901802908443,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87
        },
        "crimson.2300": {
            contrast: 24.128997047222196,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "crimson.2400": {
            contrast: 31.096855987702448,
            lc60: 100,
            lc45: 100,
            lc30: 96.5,
            lc10: 53
        },
        "crimson.2500": {
            contrast: 37.83164289801723,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 45
        }
    },
    "crimson.2000": {
        "crimson.100": {
            contrast: 75.73275897548362,
            lc60: 63.5,
            lc45: 45.5,
            lc30: 30,
            lc10: 15
        },
        "crimson.200": {
            contrast: 75.11270254679668,
            lc60: 67,
            lc45: 48.5,
            lc30: 31.5,
            lc10: 16.5
        },
        "crimson.300": {
            contrast: 73.23561366252687,
            lc60: 70.5,
            lc45: 50.5,
            lc30: 33,
            lc10: 17
        },
        "crimson.400": {
            contrast: 70.93419832505812,
            lc60: 74.5,
            lc45: 52.5,
            lc30: 34.5,
            lc10: 17.5
        },
        "crimson.500": {
            contrast: 67.66824547579635,
            lc60: 80,
            lc45: 55.5,
            lc30: 35.5,
            lc10: 18.5
        },
        "crimson.600": {
            contrast: 63.33888839212817,
            lc60: 88.5,
            lc45: 59,
            lc30: 38,
            lc10: 19
        },
        "crimson.700": {
            contrast: 59.11124043237722,
            lc60: 100,
            lc45: 64,
            lc30: 40,
            lc10: 20
        },
        "crimson.800": {
            contrast: 53.784308290151905,
            lc60: 100,
            lc45: 71,
            lc30: 42.5,
            lc10: 21
        },
        "crimson.900": {
            contrast: 50.68275381761234,
            lc60: 100,
            lc45: 81.5,
            lc30: 49.5,
            lc10: 25
        },
        "crimson.1000": {
            contrast: 46.60398860603331,
            lc60: 100,
            lc45: 94,
            lc30: 56.5,
            lc10: 28.5
        },
        "crimson.1100": {
            contrast: 42.48372024423798,
            lc60: 100,
            lc45: 100,
            lc30: 64,
            lc10: 31.5
        },
        "crimson.1200": {
            contrast: 37.74600038585088,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 36.5
        },
        "crimson.1300": {
            contrast: 33.062863637408334,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 42
        },
        "crimson.1400": {
            contrast: 28.775031852729864,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 50
        },
        "crimson.1500": {
            contrast: 24.037965346245613,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60.5
        },
        "crimson.1600": {
            contrast: 19.084717344029162,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77.5
        },
        "crimson.1700": {
            contrast: 14.091325045161302,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1800": {
            contrast: 9.008159767006592,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.2200": {
            contrast: 11.299560623034882,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.2300": {
            contrast: 17.96065586734863,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84.5
        },
        "crimson.2400": {
            contrast: 24.92851480782889,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "crimson.2500": {
            contrast: 31.66330171814367,
            lc60: 100,
            lc45: 100,
            lc30: 94.5,
            lc10: 52
        }
    },
    "crimson.2100": {
        "crimson.100": {
            contrast: 81.65997887413087,
            lc60: 58,
            lc45: 42,
            lc30: 28,
            lc10: 14.5
        },
        "crimson.200": {
            contrast: 81.03992244544392,
            lc60: 61.5,
            lc45: 44.5,
            lc30: 29.5,
            lc10: 15
        },
        "crimson.300": {
            contrast: 79.16283356117412,
            lc60: 64,
            lc45: 46,
            lc30: 30,
            lc10: 15.5
        },
        "crimson.400": {
            contrast: 76.86141822370537,
            lc60: 67,
            lc45: 48,
            lc30: 31.5,
            lc10: 16
        },
        "crimson.500": {
            contrast: 73.59546537444358,
            lc60: 70.5,
            lc45: 50,
            lc30: 32.5,
            lc10: 16.5
        },
        "crimson.600": {
            contrast: 69.26610829077542,
            lc60: 76,
            lc45: 53,
            lc30: 34,
            lc10: 17.5
        },
        "crimson.700": {
            contrast: 65.03846033102447,
            lc60: 83.5,
            lc45: 55.5,
            lc30: 35.5,
            lc10: 18
        },
        "crimson.800": {
            contrast: 59.71152818879914,
            lc60: 100,
            lc45: 60.5,
            lc30: 38,
            lc10: 19
        },
        "crimson.900": {
            contrast: 56.60997371625959,
            lc60: 100,
            lc45: 69.5,
            lc30: 43.5,
            lc10: 22
        },
        "crimson.1000": {
            contrast: 52.53120850468056,
            lc60: 100,
            lc45: 79,
            lc30: 48.5,
            lc10: 24.5
        },
        "crimson.1100": {
            contrast: 48.41094014288523,
            lc60: 100,
            lc45: 89,
            lc30: 54.5,
            lc10: 27
        },
        "crimson.1200": {
            contrast: 43.67322028449813,
            lc60: 100,
            lc45: 100,
            lc30: 62.5,
            lc10: 30.5
        },
        "crimson.1300": {
            contrast: 38.990083536055586,
            lc60: 100,
            lc45: 100,
            lc30: 71.5,
            lc10: 35
        },
        "crimson.1400": {
            contrast: 34.70225175137712,
            lc60: 100,
            lc45: 100,
            lc30: 83,
            lc10: 40.5
        },
        "crimson.1500": {
            contrast: 29.96518524489286,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 48
        },
        "crimson.1600": {
            contrast: 25.011937242676407,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59
        },
        "crimson.1700": {
            contrast: 20.018544943808553,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75.5
        },
        "crimson.1800": {
            contrast: 14.935379665653844,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1900": {
            contrast: 9.368919849383493,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.2300": {
            contrast: 11.377674339747957,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.2400": {
            contrast: 18.345533280228214,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84.5
        },
        "crimson.2500": {
            contrast: 25.08032019054299,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64.5
        }
    },
    "crimson.2200": {
        "crimson.100": {
            contrast: 87.47716229120596,
            lc60: 53.5,
            lc45: 39,
            lc30: 26,
            lc10: 13.5
        },
        "crimson.200": {
            contrast: 86.857105862519,
            lc60: 56.5,
            lc45: 41,
            lc30: 27,
            lc10: 14
        },
        "crimson.300": {
            contrast: 84.98001697824921,
            lc60: 58.5,
            lc45: 42.5,
            lc30: 28,
            lc10: 14.5
        },
        "crimson.400": {
            contrast: 82.67860164078046,
            lc60: 61,
            lc45: 44,
            lc30: 29,
            lc10: 15
        },
        "crimson.500": {
            contrast: 79.41264879151869,
            lc60: 63.5,
            lc45: 46,
            lc30: 30,
            lc10: 15.5
        },
        "crimson.600": {
            contrast: 75.0832917078505,
            lc60: 67.5,
            lc45: 47.5,
            lc30: 31.5,
            lc10: 16
        },
        "crimson.700": {
            contrast: 70.85564374809957,
            lc60: 72,
            lc45: 50,
            lc30: 32,
            lc10: 16.5
        },
        "crimson.800": {
            contrast: 65.52871160587424,
            lc60: 80.5,
            lc45: 53.5,
            lc30: 34,
            lc10: 17.5
        },
        "crimson.900": {
            contrast: 62.42715713333467,
            lc60: 92,
            lc45: 61,
            lc30: 39,
            lc10: 20
        },
        "crimson.1000": {
            contrast: 58.34839192175566,
            lc60: 100,
            lc45: 68,
            lc30: 43,
            lc10: 22
        },
        "crimson.1100": {
            contrast: 54.228123559960316,
            lc60: 100,
            lc45: 76,
            lc30: 47.5,
            lc10: 24
        },
        "crimson.1200": {
            contrast: 49.490403701573214,
            lc60: 100,
            lc45: 87,
            lc30: 54,
            lc10: 27
        },
        "crimson.1300": {
            contrast: 44.80726695313068,
            lc60: 100,
            lc45: 100,
            lc30: 60.5,
            lc10: 30
        },
        "crimson.1400": {
            contrast: 40.519435168452205,
            lc60: 100,
            lc45: 100,
            lc30: 69,
            lc10: 34
        },
        "crimson.1500": {
            contrast: 35.78236866196795,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 39.5
        },
        "crimson.1600": {
            contrast: 30.829120659751503,
            lc60: 100,
            lc45: 100,
            lc30: 97,
            lc10: 47.5
        },
        "crimson.1700": {
            contrast: 25.835728360883635,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "crimson.1800": {
            contrast: 20.752563082728933,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72.5
        },
        "crimson.1900": {
            contrast: 15.186103266458584,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98.5
        },
        "crimson.2000": {
            contrast: 9.505012778783492,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.2400": {
            contrast: 11.816294383937038,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.2500": {
            contrast: 18.551081294251816,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84
        }
    },
    "crimson.2300": {
        "crimson.100": {
            contrast: 93.58872827911867,
            lc60: 50,
            lc45: 37,
            lc30: 24.5,
            lc10: 12.5
        },
        "crimson.200": {
            contrast: 92.96867185043173,
            lc60: 52.5,
            lc45: 38.5,
            lc30: 25.5,
            lc10: 13.5
        },
        "crimson.300": {
            contrast: 91.09158296616192,
            lc60: 54,
            lc45: 39.5,
            lc30: 26,
            lc10: 13.5
        },
        "crimson.400": {
            contrast: 88.79016762869317,
            lc60: 56,
            lc45: 40.5,
            lc30: 27,
            lc10: 14
        },
        "crimson.500": {
            contrast: 85.52421477943139,
            lc60: 58,
            lc45: 42,
            lc30: 27.5,
            lc10: 14.5
        },
        "crimson.600": {
            contrast: 81.19485769576322,
            lc60: 61,
            lc45: 43.5,
            lc30: 28.5,
            lc10: 15
        },
        "crimson.700": {
            contrast: 76.96720973601228,
            lc60: 64,
            lc45: 45.5,
            lc30: 29.5,
            lc10: 15.5
        },
        "crimson.800": {
            contrast: 71.64027759378695,
            lc60: 69.5,
            lc45: 48,
            lc30: 31,
            lc10: 16
        },
        "crimson.900": {
            contrast: 68.53872312124739,
            lc60: 78.5,
            lc45: 54,
            lc30: 35,
            lc10: 18
        },
        "crimson.1000": {
            contrast: 64.45995790966836,
            lc60: 87.5,
            lc45: 60,
            lc30: 38.5,
            lc10: 20
        },
        "crimson.1100": {
            contrast: 60.339689547873036,
            lc60: 98.5,
            lc45: 66,
            lc30: 42,
            lc10: 21.5
        },
        "crimson.1200": {
            contrast: 55.60196968948592,
            lc60: 100,
            lc45: 74,
            lc30: 46.5,
            lc10: 24
        },
        "crimson.1300": {
            contrast: 50.91883294104339,
            lc60: 100,
            lc45: 84,
            lc30: 52,
            lc10: 26.5
        },
        "crimson.1400": {
            contrast: 46.631001156364924,
            lc60: 100,
            lc45: 95,
            lc30: 58.5,
            lc10: 29
        },
        "crimson.1500": {
            contrast: 41.89393464988066,
            lc60: 100,
            lc45: 100,
            lc30: 67,
            lc10: 33
        },
        "crimson.1600": {
            contrast: 36.94068664766421,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 39
        },
        "crimson.1700": {
            contrast: 31.94729434879635,
            lc60: 100,
            lc45: 100,
            lc30: 92.5,
            lc10: 47
        },
        "crimson.1800": {
            contrast: 26.864129070641646,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56
        },
        "crimson.1900": {
            contrast: 21.297669254371296,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "crimson.2000": {
            contrast: 15.616578766696204,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 96.5
        },
        "crimson.2100": {
            contrast: 9.61301041103883,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.2500": {
            contrast: 11.62220753722709,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "crimson.2400": {
        "crimson.100": {
            contrast: 99.93986350811063,
            lc60: 46.5,
            lc45: 34.5,
            lc30: 23,
            lc10: 12
        },
        "crimson.200": {
            contrast: 99.31980707942368,
            lc60: 48.5,
            lc45: 36,
            lc30: 24,
            lc10: 12.5
        },
        "crimson.300": {
            contrast: 97.44271819515387,
            lc60: 50,
            lc45: 36.5,
            lc30: 24.5,
            lc10: 13
        },
        "crimson.400": {
            contrast: 95.14130285768513,
            lc60: 51.5,
            lc45: 37.5,
            lc30: 25,
            lc10: 13
        },
        "crimson.500": {
            contrast: 91.87535000842334,
            lc60: 53,
            lc45: 39,
            lc30: 25.5,
            lc10: 13
        },
        "crimson.600": {
            contrast: 87.54599292475517,
            lc60: 55.5,
            lc45: 40,
            lc30: 26.5,
            lc10: 13.5
        },
        "crimson.700": {
            contrast: 83.31834496500423,
            lc60: 57.5,
            lc45: 41.5,
            lc30: 27,
            lc10: 14
        },
        "crimson.800": {
            contrast: 77.9914128227789,
            lc60: 61,
            lc45: 43.5,
            lc30: 28,
            lc10: 14.5
        },
        "crimson.900": {
            contrast: 74.88985835023935,
            lc60: 69,
            lc45: 49,
            lc30: 31.5,
            lc10: 16.5
        },
        "crimson.1000": {
            contrast: 70.81109313866033,
            lc60: 76,
            lc45: 53.5,
            lc30: 34.5,
            lc10: 18
        },
        "crimson.1100": {
            contrast: 66.690824776865,
            lc60: 84,
            lc45: 58,
            lc30: 37.5,
            lc10: 19.5
        },
        "crimson.1200": {
            contrast: 61.953104918477884,
            lc60: 95,
            lc45: 65,
            lc30: 41.5,
            lc10: 21.5
        },
        "crimson.1300": {
            contrast: 57.26996817003535,
            lc60: 100,
            lc45: 71.5,
            lc30: 45.5,
            lc10: 23
        },
        "crimson.1400": {
            contrast: 52.98213638535687,
            lc60: 100,
            lc45: 80,
            lc30: 51,
            lc10: 26
        },
        "crimson.1500": {
            contrast: 48.24506987887261,
            lc60: 100,
            lc45: 91,
            lc30: 57,
            lc10: 29
        },
        "crimson.1600": {
            contrast: 43.291821876656165,
            lc60: 100,
            lc45: 100,
            lc30: 65,
            lc10: 33.5
        },
        "crimson.1700": {
            contrast: 38.298429577788305,
            lc60: 100,
            lc45: 100,
            lc30: 75.5,
            lc10: 38.5
        },
        "crimson.1800": {
            contrast: 33.2152642996336,
            lc60: 100,
            lc45: 100,
            lc30: 89,
            lc10: 44.5
        },
        "crimson.1900": {
            contrast: 27.64880448336325,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54.5
        },
        "crimson.2000": {
            contrast: 21.96771399568816,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "crimson.2100": {
            contrast: 15.964145640030786,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 94
        },
        "crimson.2200": {
            contrast: 10.06512520752201,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "crimson.2500": {
        "crimson.100": {
            contrast: 106.04067321268862,
            lc60: 44,
            lc45: 32.5,
            lc30: 21.5,
            lc10: 11.5
        },
        "crimson.200": {
            contrast: 105.42061678400168,
            lc60: 45.5,
            lc45: 33.5,
            lc30: 22.5,
            lc10: 12
        },
        "crimson.300": {
            contrast: 103.54352789973187,
            lc60: 46.5,
            lc45: 34.5,
            lc30: 23,
            lc10: 12
        },
        "crimson.400": {
            contrast: 101.2421125622631,
            lc60: 48,
            lc45: 35.5,
            lc30: 23.5,
            lc10: 12
        },
        "crimson.500": {
            contrast: 97.97615971300132,
            lc60: 49.5,
            lc45: 36,
            lc30: 24,
            lc10: 12.5
        },
        "crimson.600": {
            contrast: 93.64680262933315,
            lc60: 51,
            lc45: 37,
            lc30: 24.5,
            lc10: 13
        },
        "crimson.700": {
            contrast: 89.4191546695822,
            lc60: 53,
            lc45: 38.5,
            lc30: 25.5,
            lc10: 13.5
        },
        "crimson.800": {
            contrast: 84.09222252735688,
            lc60: 55.5,
            lc45: 40,
            lc30: 26,
            lc10: 13.5
        },
        "crimson.900": {
            contrast: 80.99066805481733,
            lc60: 62,
            lc45: 44.5,
            lc30: 29,
            lc10: 15.5
        },
        "crimson.1000": {
            contrast: 76.9119028432383,
            lc60: 68,
            lc45: 48.5,
            lc30: 31.5,
            lc10: 16.5
        },
        "crimson.1100": {
            contrast: 72.79163448144297,
            lc60: 74,
            lc45: 52.5,
            lc30: 34,
            lc10: 17.5
        },
        "crimson.1200": {
            contrast: 68.05391462305586,
            lc60: 81.5,
            lc45: 57.5,
            lc30: 37.5,
            lc10: 19.5
        },
        "crimson.1300": {
            contrast: 63.37077787461332,
            lc60: 91.5,
            lc45: 63.5,
            lc30: 41,
            lc10: 21.5
        },
        "crimson.1400": {
            contrast: 59.08294608993485,
            lc60: 100,
            lc45: 69.5,
            lc30: 45,
            lc10: 23
        },
        "crimson.1500": {
            contrast: 54.345879583450596,
            lc60: 100,
            lc45: 78,
            lc30: 50,
            lc10: 25.5
        },
        "crimson.1600": {
            contrast: 49.392631581234134,
            lc60: 100,
            lc45: 88.5,
            lc30: 56.5,
            lc10: 28.5
        },
        "crimson.1700": {
            contrast: 44.399239282366274,
            lc60: 100,
            lc45: 100,
            lc30: 64.5,
            lc10: 33
        },
        "crimson.1800": {
            contrast: 39.31607400421157,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 38
        },
        "crimson.1900": {
            contrast: 33.74961418794122,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 45
        },
        "crimson.2000": {
            contrast: 28.06852370026613,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "crimson.2100": {
            contrast: 22.06495534460876,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "crimson.2200": {
            contrast: 16.16593491209998,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93.5
        },
        "crimson.2300": {
            contrast: 9.961472820262385,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    }
};
const $f8fd43f1ee3f8cd8$var$neutral = {
    "neutral.100": {
        "neutral.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.600": {
            contrast: 8.366961173586047,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.700": {
            contrast: 12.590250558615693,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.800": {
            contrast: 17.197013373984785,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93.5
        },
        "neutral.900": {
            contrast: 21.75428542494453,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83
        },
        "neutral.1000": {
            contrast: 26.008308993672237,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75.5
        },
        "neutral.1100": {
            contrast: 30.457434854569943,
            lc60: 100,
            lc45: 100,
            lc30: 98.5,
            lc10: 69
        },
        "neutral.1200": {
            contrast: 35.570239665269995,
            lc60: 100,
            lc45: 100,
            lc30: 90.5,
            lc10: 63
        },
        "neutral.1300": {
            contrast: 40.54254276837638,
            lc60: 100,
            lc45: 100,
            lc30: 84,
            lc10: 58.5
        },
        "neutral.1400": {
            contrast: 45.07757728949064,
            lc60: 100,
            lc45: 99.5,
            lc30: 79,
            lc10: 55
        },
        "neutral.1500": {
            contrast: 49.81784515925999,
            lc60: 100,
            lc45: 93.5,
            lc30: 74,
            lc10: 52
        },
        "neutral.1600": {
            contrast: 55.01058726445677,
            lc60: 100,
            lc45: 88.5,
            lc30: 70,
            lc10: 49
        },
        "neutral.1700": {
            contrast: 60.069832282190475,
            lc60: 99.5,
            lc45: 83.5,
            lc30: 66,
            lc10: 46.5
        },
        "neutral.1800": {
            contrast: 65.09775711428387,
            lc60: 94.5,
            lc45: 79.5,
            lc30: 63,
            lc10: 44
        },
        "neutral.1900": {
            contrast: 70.82938054154853,
            lc60: 90,
            lc45: 76,
            lc30: 60,
            lc10: 42
        },
        "neutral.2000": {
            contrast: 76.70501676428657,
            lc60: 86,
            lc45: 72,
            lc30: 57,
            lc10: 40
        },
        "neutral.2100": {
            contrast: 82.28243165168517,
            lc60: 82,
            lc45: 69,
            lc30: 54.5,
            lc10: 38
        },
        "neutral.2200": {
            contrast: 88.4255523763984,
            lc60: 78.5,
            lc45: 65.5,
            lc30: 52,
            lc10: 36.5
        },
        "neutral.2300": {
            contrast: 94.8846536000372,
            lc60: 75,
            lc45: 63,
            lc30: 49.5,
            lc10: 35
        },
        "neutral.2400": {
            contrast: 101.3437952081248,
            lc60: 72,
            lc45: 60.5,
            lc30: 47.5,
            lc10: 33.5
        },
        "neutral.2500": {
            contrast: 107.88473318309848,
            lc60: 69,
            lc45: 58,
            lc30: 46,
            lc10: 32
        }
    },
    "neutral.200": {
        "neutral.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.600": {
            contrast: 8.09484159898223,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.700": {
            contrast: 12.318130984011875,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.800": {
            contrast: 16.924893799380968,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93.5
        },
        "neutral.900": {
            contrast: 21.482165850340717,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81
        },
        "neutral.1000": {
            contrast: 25.736189419068417,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72.5
        },
        "neutral.1100": {
            contrast: 30.185315279966122,
            lc60: 100,
            lc45: 100,
            lc30: 99.5,
            lc10: 65.5
        },
        "neutral.1200": {
            contrast: 35.298120090666174,
            lc60: 100,
            lc45: 100,
            lc30: 90,
            lc10: 59.5
        },
        "neutral.1300": {
            contrast: 40.27042319377256,
            lc60: 100,
            lc45: 100,
            lc30: 83,
            lc10: 54.5
        },
        "neutral.1400": {
            contrast: 44.80545771488682,
            lc60: 100,
            lc45: 100,
            lc30: 77.5,
            lc10: 51
        },
        "neutral.1500": {
            contrast: 49.54572558465616,
            lc60: 100,
            lc45: 94,
            lc30: 72.5,
            lc10: 47.5
        },
        "neutral.1600": {
            contrast: 54.738467689852946,
            lc60: 100,
            lc45: 88,
            lc30: 68,
            lc10: 44.5
        },
        "neutral.1700": {
            contrast: 59.79771270758665,
            lc60: 100,
            lc45: 83,
            lc30: 64,
            lc10: 42
        },
        "neutral.1800": {
            contrast: 64.82563753968003,
            lc60: 95,
            lc45: 78.5,
            lc30: 60.5,
            lc10: 40
        },
        "neutral.1900": {
            contrast: 70.55726096694471,
            lc60: 89.5,
            lc45: 74.5,
            lc30: 57.5,
            lc10: 38
        },
        "neutral.2000": {
            contrast: 76.43289718968275,
            lc60: 85,
            lc45: 70.5,
            lc30: 54.5,
            lc10: 36
        },
        "neutral.2100": {
            contrast: 82.01031207708137,
            lc60: 81,
            lc45: 67.5,
            lc30: 52,
            lc10: 34
        },
        "neutral.2200": {
            contrast: 88.15343280179458,
            lc60: 77.5,
            lc45: 64,
            lc30: 49.5,
            lc10: 32.5
        },
        "neutral.2300": {
            contrast: 94.61253402543338,
            lc60: 74,
            lc45: 61,
            lc30: 47.5,
            lc10: 31
        },
        "neutral.2400": {
            contrast: 101.071675633521,
            lc60: 70.5,
            lc45: 58.5,
            lc30: 45,
            lc10: 29.5
        },
        "neutral.2500": {
            contrast: 107.61261360849466,
            lc60: 67.5,
            lc45: 56,
            lc30: 43.5,
            lc10: 28.5
        }
    },
    "neutral.300": {
        "neutral.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.700": {
            contrast: 11.153597938371501,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.800": {
            contrast: 15.760360753740594,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 97
        },
        "neutral.900": {
            contrast: 20.31763280470034,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81.5
        },
        "neutral.1000": {
            contrast: 24.57165637342805,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "neutral.1100": {
            contrast: 29.020782234325747,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63.5
        },
        "neutral.1200": {
            contrast: 34.13358704502579,
            lc60: 100,
            lc45: 100,
            lc30: 91.5,
            lc10: 57
        },
        "neutral.1300": {
            contrast: 39.10589014813218,
            lc60: 100,
            lc45: 100,
            lc30: 83,
            lc10: 52
        },
        "neutral.1400": {
            contrast: 43.640924669246445,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 48
        },
        "neutral.1500": {
            contrast: 48.38119253901579,
            lc60: 100,
            lc45: 95,
            lc30: 71,
            lc10: 44.5
        },
        "neutral.1600": {
            contrast: 53.57393464421257,
            lc60: 100,
            lc45: 88,
            lc30: 66.5,
            lc10: 41.5
        },
        "neutral.1700": {
            contrast: 58.633179661946265,
            lc60: 100,
            lc45: 82.5,
            lc30: 62.5,
            lc10: 39
        },
        "neutral.1800": {
            contrast: 63.66110449403967,
            lc60: 95.5,
            lc45: 78,
            lc30: 59,
            lc10: 37
        },
        "neutral.1900": {
            contrast: 69.39272792130434,
            lc60: 90,
            lc45: 73.5,
            lc30: 55.5,
            lc10: 35
        },
        "neutral.2000": {
            contrast: 75.26836414404238,
            lc60: 85,
            lc45: 69.5,
            lc30: 52.5,
            lc10: 33
        },
        "neutral.2100": {
            contrast: 80.84577903144098,
            lc60: 81,
            lc45: 66,
            lc30: 49.5,
            lc10: 31
        },
        "neutral.2200": {
            contrast: 86.9888997561542,
            lc60: 77,
            lc45: 62.5,
            lc30: 47,
            lc10: 29.5
        },
        "neutral.2300": {
            contrast: 93.448000979793,
            lc60: 73,
            lc45: 59.5,
            lc30: 44.5,
            lc10: 28
        },
        "neutral.2400": {
            contrast: 99.9071425878806,
            lc60: 69.5,
            lc45: 57,
            lc30: 42.5,
            lc10: 27
        },
        "neutral.2500": {
            contrast: 106.44808056285429,
            lc60: 66.5,
            lc45: 54.5,
            lc30: 41,
            lc10: 25.5
        }
    },
    "neutral.400": {
        "neutral.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.700": {
            contrast: 9.502937171776669,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.800": {
            contrast: 14.109699987145763,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.900": {
            contrast: 18.66697203810551,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85.5
        },
        "neutral.1000": {
            contrast: 22.920995606833213,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "neutral.1100": {
            contrast: 27.37012146773091,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64.5
        },
        "neutral.1200": {
            contrast: 32.48292627843096,
            lc60: 100,
            lc45: 100,
            lc30: 94,
            lc10: 57
        },
        "neutral.1300": {
            contrast: 37.45522938153735,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 50.5
        },
        "neutral.1400": {
            contrast: 41.99026390265161,
            lc60: 100,
            lc45: 100,
            lc30: 77.5,
            lc10: 46.5
        },
        "neutral.1500": {
            contrast: 46.73053177242096,
            lc60: 100,
            lc45: 97,
            lc30: 72,
            lc10: 43
        },
        "neutral.1600": {
            contrast: 51.92327387761774,
            lc60: 100,
            lc45: 89.5,
            lc30: 66.5,
            lc10: 40
        },
        "neutral.1700": {
            contrast: 56.98251889535144,
            lc60: 100,
            lc45: 83.5,
            lc30: 62,
            lc10: 37.5
        },
        "neutral.1800": {
            contrast: 62.01044372744483,
            lc60: 97.5,
            lc45: 78.5,
            lc30: 58,
            lc10: 35
        },
        "neutral.1900": {
            contrast: 67.7420671547095,
            lc60: 91,
            lc45: 73.5,
            lc30: 54.5,
            lc10: 33
        },
        "neutral.2000": {
            contrast: 73.61770337744754,
            lc60: 86,
            lc45: 69,
            lc30: 51,
            lc10: 31
        },
        "neutral.2100": {
            contrast: 79.19511826484614,
            lc60: 81.5,
            lc45: 65.5,
            lc30: 48.5,
            lc10: 29
        },
        "neutral.2200": {
            contrast: 85.33823898955937,
            lc60: 77,
            lc45: 62,
            lc30: 46,
            lc10: 27.5
        },
        "neutral.2300": {
            contrast: 91.79734021319817,
            lc60: 73,
            lc45: 59,
            lc30: 43.5,
            lc10: 26
        },
        "neutral.2400": {
            contrast: 98.25648182128576,
            lc60: 69.5,
            lc45: 56,
            lc30: 41.5,
            lc10: 25
        },
        "neutral.2500": {
            contrast: 104.79741979625945,
            lc60: 66.5,
            lc45: 53.5,
            lc30: 39.5,
            lc10: 23.5
        }
    },
    "neutral.500": {
        "neutral.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.800": {
            contrast: 11.375354131407011,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.900": {
            contrast: 15.93262618236676,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 94.5
        },
        "neutral.1000": {
            contrast: 20.186649751094464,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78
        },
        "neutral.1100": {
            contrast: 24.63577561199217,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "neutral.1200": {
            contrast: 29.74858042269221,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58
        },
        "neutral.1300": {
            contrast: 34.7208835257986,
            lc60: 100,
            lc45: 100,
            lc30: 89,
            lc10: 51
        },
        "neutral.1400": {
            contrast: 39.25591804691286,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 46
        },
        "neutral.1500": {
            contrast: 43.99618591668221,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 42.5
        },
        "neutral.1600": {
            contrast: 49.188928021878986,
            lc60: 100,
            lc45: 93.5,
            lc30: 67.5,
            lc10: 38.5
        },
        "neutral.1700": {
            contrast: 54.24817303961269,
            lc60: 100,
            lc45: 86,
            lc30: 63,
            lc10: 36
        },
        "neutral.1800": {
            contrast: 59.27609787170608,
            lc60: 100,
            lc45: 80.5,
            lc30: 58.5,
            lc10: 33.5
        },
        "neutral.1900": {
            contrast: 65.00772129897075,
            lc60: 94,
            lc45: 75.5,
            lc30: 54.5,
            lc10: 31
        },
        "neutral.2000": {
            contrast: 70.88335752170879,
            lc60: 88,
            lc45: 70.5,
            lc30: 51,
            lc10: 29
        },
        "neutral.2100": {
            contrast: 76.46077240910739,
            lc60: 83,
            lc45: 66.5,
            lc30: 48,
            lc10: 27.5
        },
        "neutral.2200": {
            contrast: 82.60389313382062,
            lc60: 78,
            lc45: 62.5,
            lc30: 45.5,
            lc10: 26
        },
        "neutral.2300": {
            contrast: 89.06299435745942,
            lc60: 74,
            lc45: 59,
            lc30: 43,
            lc10: 24.5
        },
        "neutral.2400": {
            contrast: 95.52213596554702,
            lc60: 70,
            lc45: 56,
            lc30: 40.5,
            lc10: 23.5
        },
        "neutral.2500": {
            contrast: 102.0630739405207,
            lc60: 66.5,
            lc45: 53,
            lc30: 38.5,
            lc10: 22
        }
    },
    "neutral.600": {
        "neutral.100": {
            contrast: 9.723504986922668,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.200": {
            contrast: 9.357781370612631,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.300": {
            contrast: 7.827148071570118,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.800": {
            contrast: 7.506068813666074,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.900": {
            contrast: 12.063340864625822,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1000": {
            contrast: 16.317364433353525,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 92.5
        },
        "neutral.1100": {
            contrast: 20.766490294251234,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77
        },
        "neutral.1200": {
            contrast: 25.87929510495128,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "neutral.1300": {
            contrast: 30.851598208057666,
            lc60: 100,
            lc45: 100,
            lc30: 98,
            lc10: 55
        },
        "neutral.1400": {
            contrast: 35.38663272917193,
            lc60: 100,
            lc45: 100,
            lc30: 87.5,
            lc10: 49
        },
        "neutral.1500": {
            contrast: 40.126900598941276,
            lc60: 100,
            lc45: 100,
            lc30: 79,
            lc10: 44.5
        },
        "neutral.1600": {
            contrast: 45.319642704138055,
            lc60: 100,
            lc45: 99.5,
            lc30: 71.5,
            lc10: 40.5
        },
        "neutral.1700": {
            contrast: 50.378887721871756,
            lc60: 100,
            lc45: 91.5,
            lc30: 65.5,
            lc10: 37
        },
        "neutral.1800": {
            contrast: 55.406812553965146,
            lc60: 100,
            lc45: 84.5,
            lc30: 61,
            lc10: 34.5
        },
        "neutral.1900": {
            contrast: 61.13843598122982,
            lc60: 98.5,
            lc45: 78,
            lc30: 56,
            lc10: 32
        },
        "neutral.2000": {
            contrast: 67.01407220396786,
            lc60: 91.5,
            lc45: 72.5,
            lc30: 52,
            lc10: 29.5
        },
        "neutral.2100": {
            contrast: 72.59148709136646,
            lc60: 86,
            lc45: 68.5,
            lc30: 49,
            lc10: 28
        },
        "neutral.2200": {
            contrast: 78.73460781607969,
            lc60: 80.5,
            lc45: 64,
            lc30: 46,
            lc10: 26
        },
        "neutral.2300": {
            contrast: 85.19370903971848,
            lc60: 75.5,
            lc45: 60.5,
            lc30: 43.5,
            lc10: 24.5
        },
        "neutral.2400": {
            contrast: 91.65285064780608,
            lc60: 71.5,
            lc45: 57,
            lc30: 41,
            lc10: 23
        },
        "neutral.2500": {
            contrast: 98.19378862277975,
            lc60: 67.5,
            lc45: 54,
            lc30: 39,
            lc10: 22
        }
    },
    "neutral.700": {
        "neutral.100": {
            contrast: 14.321495386167626,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.200": {
            contrast: 13.955771769857591,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.300": {
            contrast: 12.425138470815078,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.400": {
            contrast: 10.330193175904926,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.900": {
            contrast: 8.030413837942493,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1000": {
            contrast: 12.284437406670198,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1100": {
            contrast: 16.733563267567906,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91.5
        },
        "neutral.1200": {
            contrast: 21.846368078267954,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73
        },
        "neutral.1300": {
            contrast: 26.818671181374338,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61
        },
        "neutral.1400": {
            contrast: 31.3537057024886,
            lc60: 100,
            lc45: 100,
            lc30: 96.5,
            lc10: 53.5
        },
        "neutral.1500": {
            contrast: 36.093973572257944,
            lc60: 100,
            lc45: 100,
            lc30: 85.5,
            lc10: 47.5
        },
        "neutral.1600": {
            contrast: 41.28671567745472,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 42.5
        },
        "neutral.1700": {
            contrast: 46.345960695188424,
            lc60: 100,
            lc45: 97.5,
            lc30: 69.5,
            lc10: 38.5
        },
        "neutral.1800": {
            contrast: 51.373885527281814,
            lc60: 100,
            lc45: 89.5,
            lc30: 64,
            lc10: 35.5
        },
        "neutral.1900": {
            contrast: 57.105508954546494,
            lc60: 100,
            lc45: 82,
            lc30: 58.5,
            lc10: 32.5
        },
        "neutral.2000": {
            contrast: 62.981145177284525,
            lc60: 95.5,
            lc45: 75.5,
            lc30: 54,
            lc10: 30
        },
        "neutral.2100": {
            contrast: 68.55856006468314,
            lc60: 89.5,
            lc45: 70.5,
            lc30: 50.5,
            lc10: 28
        },
        "neutral.2200": {
            contrast: 74.70168078939636,
            lc60: 83.5,
            lc45: 66,
            lc30: 47,
            lc10: 26.5
        },
        "neutral.2300": {
            contrast: 81.16078201303515,
            lc60: 78,
            lc45: 61.5,
            lc30: 44,
            lc10: 24.5
        },
        "neutral.2400": {
            contrast: 87.61992362112275,
            lc60: 73.5,
            lc45: 58,
            lc30: 41.5,
            lc10: 23
        },
        "neutral.2500": {
            contrast: 94.16086159609642,
            lc60: 69.5,
            lc45: 55,
            lc30: 39,
            lc10: 22
        }
    },
    "neutral.800": {
        "neutral.100": {
            contrast: 19.22340923915762,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "neutral.200": {
            contrast: 18.85768562284758,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65
        },
        "neutral.300": {
            contrast: 17.327052323805066,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79.5
        },
        "neutral.400": {
            contrast: 15.232107028894914,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 97
        },
        "neutral.500": {
            contrast: 11.897803001867507,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.600": {
            contrast: 7.378681199683134,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1000": {
            contrast: 7.83467396184593,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1100": {
            contrast: 12.283799822743635,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1200": {
            contrast: 17.396604633443683,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87
        },
        "neutral.1300": {
            contrast: 22.368907736550074,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "neutral.1400": {
            contrast: 26.903942257664326,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "neutral.1500": {
            contrast: 31.64421012743367,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 52
        },
        "neutral.1600": {
            contrast: 36.83695223263045,
            lc60: 100,
            lc45: 100,
            lc30: 84,
            lc10: 45.5
        },
        "neutral.1700": {
            contrast: 41.89619725036415,
            lc60: 100,
            lc45: 100,
            lc30: 75.5,
            lc10: 41
        },
        "neutral.1800": {
            contrast: 46.924122082457544,
            lc60: 100,
            lc45: 96,
            lc30: 68.5,
            lc10: 37
        },
        "neutral.1900": {
            contrast: 52.655745509722216,
            lc60: 100,
            lc45: 87,
            lc30: 62,
            lc10: 33.5
        },
        "neutral.2000": {
            contrast: 58.531381732460254,
            lc60: 100,
            lc45: 80,
            lc30: 57,
            lc10: 30.5
        },
        "neutral.2100": {
            contrast: 64.10879661985885,
            lc60: 94.5,
            lc45: 74,
            lc30: 53,
            lc10: 28.5
        },
        "neutral.2200": {
            contrast: 70.25191734457208,
            lc60: 87.5,
            lc45: 68.5,
            lc30: 49,
            lc10: 26.5
        },
        "neutral.2300": {
            contrast: 76.71101856821087,
            lc60: 81.5,
            lc45: 64,
            lc30: 45.5,
            lc10: 24.5
        },
        "neutral.2400": {
            contrast: 83.17016017629848,
            lc60: 76.5,
            lc45: 60,
            lc30: 42.5,
            lc10: 23
        },
        "neutral.2500": {
            contrast: 89.71109815127215,
            lc60: 72,
            lc45: 56.5,
            lc30: 40,
            lc10: 21.5
        }
    },
    "neutral.900": {
        "neutral.100": {
            contrast: 23.98060782356903,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 43.5
        },
        "neutral.200": {
            contrast: 23.614884207258992,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 50.5
        },
        "neutral.300": {
            contrast: 22.08425090821648,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "neutral.400": {
            contrast: 19.98930561330633,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "neutral.500": {
            contrast: 16.65500158627892,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 90
        },
        "neutral.600": {
            contrast: 12.135879784094547,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.700": {
            contrast: 7.599251407367317,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1100": {
            contrast: 7.839476216193154,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1200": {
            contrast: 12.952281026893203,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1300": {
            contrast: 17.92458412999959,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85.5
        },
        "neutral.1400": {
            contrast: 22.459618651113853,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69.5
        },
        "neutral.1500": {
            contrast: 27.199886520883194,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59
        },
        "neutral.1600": {
            contrast: 32.39262862607997,
            lc60: 100,
            lc45: 100,
            lc30: 93,
            lc10: 50.5
        },
        "neutral.1700": {
            contrast: 37.45187364381367,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 44.5
        },
        "neutral.1800": {
            contrast: 42.47979847590707,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 40
        },
        "neutral.1900": {
            contrast: 48.21142190317174,
            lc60: 100,
            lc45: 94,
            lc30: 66,
            lc10: 36
        },
        "neutral.2000": {
            contrast: 54.08705812590977,
            lc60: 100,
            lc45: 85.5,
            lc30: 60,
            lc10: 32.5
        },
        "neutral.2100": {
            contrast: 59.66447301330838,
            lc60: 100,
            lc45: 78.5,
            lc30: 55.5,
            lc10: 30
        },
        "neutral.2200": {
            contrast: 65.80759373802161,
            lc60: 92,
            lc45: 72.5,
            lc30: 51,
            lc10: 27.5
        },
        "neutral.2300": {
            contrast: 72.2666949616604,
            lc60: 85.5,
            lc45: 67,
            lc30: 47,
            lc10: 25.5
        },
        "neutral.2400": {
            contrast: 78.725836569748,
            lc60: 79.5,
            lc45: 62.5,
            lc30: 44,
            lc10: 23.5
        },
        "neutral.2500": {
            contrast: 85.26677454472167,
            lc60: 74.5,
            lc45: 58.5,
            lc30: 41,
            lc10: 22
        }
    },
    "neutral.1000": {
        "neutral.100": {
            contrast: 28.353289001218197,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 37.5
        },
        "neutral.200": {
            contrast: 27.98756538490817,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 43
        },
        "neutral.300": {
            contrast: 26.456932085865652,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 50.5
        },
        "neutral.400": {
            contrast: 24.361986790955502,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58
        },
        "neutral.500": {
            contrast: 21.027682763928095,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "neutral.600": {
            contrast: 16.508560961743722,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 90
        },
        "neutral.700": {
            contrast: 11.97193258501649,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1200": {
            contrast: 8.771587525825433,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1300": {
            contrast: 13.74389062893182,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1400": {
            contrast: 18.27892515004608,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83.5
        },
        "neutral.1500": {
            contrast: 23.01919301981543,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "neutral.1600": {
            contrast: 28.211935125012204,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "neutral.1700": {
            contrast: 33.271180142745905,
            lc60: 100,
            lc45: 100,
            lc30: 91,
            lc10: 49
        },
        "neutral.1800": {
            contrast: 38.299104974839295,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 43.5
        },
        "neutral.1900": {
            contrast: 44.030728402103975,
            lc60: 100,
            lc45: 100,
            lc30: 71.5,
            lc10: 38.5
        },
        "neutral.2000": {
            contrast: 49.90636462484201,
            lc60: 100,
            lc45: 91,
            lc30: 64,
            lc10: 34.5
        },
        "neutral.2100": {
            contrast: 55.483779512240616,
            lc60: 100,
            lc45: 83,
            lc30: 58.5,
            lc10: 31.5
        },
        "neutral.2200": {
            contrast: 61.626900236953844,
            lc60: 97.5,
            lc45: 76,
            lc30: 53.5,
            lc10: 28.5
        },
        "neutral.2300": {
            contrast: 68.08600146059263,
            lc60: 90,
            lc45: 70,
            lc30: 49.5,
            lc10: 26.5
        },
        "neutral.2400": {
            contrast: 74.54514306868023,
            lc60: 83,
            lc45: 65,
            lc30: 45.5,
            lc10: 24.5
        },
        "neutral.2500": {
            contrast: 81.0860810436539,
            lc60: 77.5,
            lc45: 60.5,
            lc30: 42.5,
            lc10: 22.5
        }
    },
    "neutral.1100": {
        "neutral.100": {
            contrast: 32.866886229088514,
            lc60: 100,
            lc45: 100,
            lc30: 72.5,
            lc10: 33
        },
        "neutral.200": {
            contrast: 32.50116261277849,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 37
        },
        "neutral.300": {
            contrast: 30.970529313735966,
            lc60: 100,
            lc45: 100,
            lc30: 94,
            lc10: 42.5
        },
        "neutral.400": {
            contrast: 28.87558401882582,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 48.5
        },
        "neutral.500": {
            contrast: 25.54127999179841,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58
        },
        "neutral.600": {
            contrast: 21.02215818961404,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "neutral.700": {
            contrast: 16.48552981288681,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91.5
        },
        "neutral.800": {
            contrast: 11.630531118675375,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1300": {
            contrast: 9.34267537902383,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1400": {
            contrast: 13.877709900138091,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1500": {
            contrast: 18.617977769907437,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82
        },
        "neutral.1600": {
            contrast: 23.810719875104216,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "neutral.1700": {
            contrast: 28.869964892837913,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "neutral.1800": {
            contrast: 33.897889724931304,
            lc60: 100,
            lc45: 100,
            lc30: 90,
            lc10: 48.5
        },
        "neutral.1900": {
            contrast: 39.62951315219598,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 42
        },
        "neutral.2000": {
            contrast: 45.50514937493402,
            lc60: 100,
            lc45: 99,
            lc30: 69.5,
            lc10: 37
        },
        "neutral.2100": {
            contrast: 51.08256426233262,
            lc60: 100,
            lc45: 89,
            lc30: 63,
            lc10: 33.5
        },
        "neutral.2200": {
            contrast: 57.22568498704585,
            lc60: 100,
            lc45: 81,
            lc30: 57,
            lc10: 30.5
        },
        "neutral.2300": {
            contrast: 63.68478621068464,
            lc60: 95,
            lc45: 73.5,
            lc30: 52,
            lc10: 27.5
        },
        "neutral.2400": {
            contrast: 70.14392781877223,
            lc60: 87.5,
            lc45: 68,
            lc30: 48,
            lc10: 25.5
        },
        "neutral.2500": {
            contrast: 76.68486579374591,
            lc60: 81,
            lc45: 63,
            lc30: 44,
            lc10: 23.5
        }
    },
    "neutral.1200": {
        "neutral.100": {
            contrast: 37.98878267466405,
            lc60: 100,
            lc45: 100,
            lc30: 59,
            lc10: 28.5
        },
        "neutral.200": {
            contrast: 37.62305905835402,
            lc60: 100,
            lc45: 100,
            lc30: 66,
            lc10: 32
        },
        "neutral.300": {
            contrast: 36.0924257593115,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 36
        },
        "neutral.400": {
            contrast: 33.997480464401356,
            lc60: 100,
            lc45: 100,
            lc30: 83.5,
            lc10: 40.5
        },
        "neutral.500": {
            contrast: 30.663176437373945,
            lc60: 100,
            lc45: 100,
            lc30: 96.5,
            lc10: 47
        },
        "neutral.600": {
            contrast: 26.144054635189573,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "neutral.700": {
            contrast: 21.607426258462343,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "neutral.800": {
            contrast: 16.75242756425091,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89
        },
        "neutral.900": {
            contrast: 12.02568051006633,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1000": {
            contrast: 7.669803890143571,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1400": {
            contrast: 8.787971827874784,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1500": {
            contrast: 13.528239697644128,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1600": {
            contrast: 18.720981802840907,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81.5
        },
        "neutral.1700": {
            contrast: 23.780226820574608,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65.5
        },
        "neutral.1800": {
            contrast: 28.808151652668002,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "neutral.1900": {
            contrast: 34.539775079932674,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 47.5
        },
        "neutral.2000": {
            contrast: 40.41541130267071,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 41
        },
        "neutral.2100": {
            contrast: 45.992826190069316,
            lc60: 100,
            lc45: 98,
            lc30: 68.5,
            lc10: 36.5
        },
        "neutral.2200": {
            contrast: 52.13594691478254,
            lc60: 100,
            lc45: 87.5,
            lc30: 61.5,
            lc10: 33
        },
        "neutral.2300": {
            contrast: 58.59504813842135,
            lc60: 100,
            lc45: 79.5,
            lc30: 55.5,
            lc10: 29.5
        },
        "neutral.2400": {
            contrast: 65.05418974650894,
            lc60: 93,
            lc45: 72.5,
            lc30: 50.5,
            lc10: 27
        },
        "neutral.2500": {
            contrast: 71.5951277214826,
            lc60: 85.5,
            lc45: 66.5,
            lc30: 46.5,
            lc10: 24.5
        }
    },
    "neutral.1300": {
        "neutral.100": {
            contrast: 42.91174078787491,
            lc60: 100,
            lc45: 100,
            lc30: 52.5,
            lc10: 26
        },
        "neutral.200": {
            contrast: 42.546017171564884,
            lc60: 100,
            lc45: 100,
            lc30: 57.5,
            lc10: 28.5
        },
        "neutral.300": {
            contrast: 41.015383872522364,
            lc60: 100,
            lc45: 100,
            lc30: 65,
            lc10: 32
        },
        "neutral.400": {
            contrast: 38.92043857761222,
            lc60: 100,
            lc45: 100,
            lc30: 72,
            lc10: 35.5
        },
        "neutral.500": {
            contrast: 35.58613455058481,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 41
        },
        "neutral.600": {
            contrast: 31.067012748400437,
            lc60: 100,
            lc45: 100,
            lc30: 96.5,
            lc10: 48
        },
        "neutral.700": {
            contrast: 26.530384371673204,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "neutral.800": {
            contrast: 21.67538567746177,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "neutral.900": {
            contrast: 16.948638623277194,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89
        },
        "neutral.1000": {
            contrast: 12.592762003354432,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1100": {
            contrast: 8.086664277932398,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1500": {
            contrast: 8.549209382359349,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1600": {
            contrast: 13.741951487556129,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1700": {
            contrast: 18.80119650528983,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82
        },
        "neutral.1800": {
            contrast: 23.82912133738322,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "neutral.1900": {
            contrast: 29.560744764647893,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54
        },
        "neutral.2000": {
            contrast: 35.43638098738593,
            lc60: 100,
            lc45: 100,
            lc30: 85.5,
            lc10: 46
        },
        "neutral.2100": {
            contrast: 41.013795874784535,
            lc60: 100,
            lc45: 100,
            lc30: 75,
            lc10: 40.5
        },
        "neutral.2200": {
            contrast: 47.15691659949776,
            lc60: 100,
            lc45: 95.5,
            lc30: 66,
            lc10: 35.5
        },
        "neutral.2300": {
            contrast: 53.61601782313655,
            lc60: 100,
            lc45: 85.5,
            lc30: 59,
            lc10: 32
        },
        "neutral.2400": {
            contrast: 60.07515943122416,
            lc60: 99.5,
            lc45: 77.5,
            lc30: 53.5,
            lc10: 29
        },
        "neutral.2500": {
            contrast: 66.61609740619781,
            lc60: 91,
            lc45: 70.5,
            lc30: 49,
            lc10: 26.5
        }
    },
    "neutral.1400": {
        "neutral.100": {
            contrast: 47.35749537902972,
            lc60: 100,
            lc45: 80,
            lc30: 47,
            lc10: 23.5
        },
        "neutral.200": {
            contrast: 46.991771762719694,
            lc60: 100,
            lc45: 87.5,
            lc30: 51.5,
            lc10: 26
        },
        "neutral.300": {
            contrast: 45.46113846367717,
            lc60: 100,
            lc45: 97.5,
            lc30: 57.5,
            lc10: 29
        },
        "neutral.400": {
            contrast: 43.366193168767026,
            lc60: 100,
            lc45: 100,
            lc30: 63.5,
            lc10: 31.5
        },
        "neutral.500": {
            contrast: 40.03188914173961,
            lc60: 100,
            lc45: 100,
            lc30: 71.5,
            lc10: 36
        },
        "neutral.600": {
            contrast: 35.51276733955524,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 41.5
        },
        "neutral.700": {
            contrast: 30.976138962828013,
            lc60: 100,
            lc45: 100,
            lc30: 96.5,
            lc10: 48.5
        },
        "neutral.800": {
            contrast: 26.121140268616582,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58
        },
        "neutral.900": {
            contrast: 21.394393214432004,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "neutral.1000": {
            contrast: 17.038516594509243,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88.5
        },
        "neutral.1100": {
            contrast: 12.53241886908721,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1200": {
            contrast: 7.408274634352259,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1600": {
            contrast: 9.178230530289554,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1700": {
            contrast: 14.237475548023257,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1800": {
            contrast: 19.26540038011665,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79.5
        },
        "neutral.1900": {
            contrast: 24.99702380738132,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "neutral.2000": {
            contrast: 30.87266003011936,
            lc60: 100,
            lc45: 100,
            lc30: 97,
            lc10: 51.5
        },
        "neutral.2100": {
            contrast: 36.45007491751796,
            lc60: 100,
            lc45: 100,
            lc30: 84,
            lc10: 44.5
        },
        "neutral.2200": {
            contrast: 42.59319564223119,
            lc60: 100,
            lc45: 100,
            lc30: 73,
            lc10: 38.5
        },
        "neutral.2300": {
            contrast: 49.052296865869984,
            lc60: 100,
            lc45: 92,
            lc30: 64.5,
            lc10: 34
        },
        "neutral.2400": {
            contrast: 55.51143847395758,
            lc60: 100,
            lc45: 82.5,
            lc30: 57.5,
            lc10: 30.5
        },
        "neutral.2500": {
            contrast: 62.05237644893125,
            lc60: 96.5,
            lc45: 74.5,
            lc30: 52,
            lc10: 27.5
        }
    },
    "neutral.1500": {
        "neutral.100": {
            contrast: 51.963878834425,
            lc60: 100,
            lc45: 68.5,
            lc30: 43,
            lc10: 21.5
        },
        "neutral.200": {
            contrast: 51.59815521811497,
            lc60: 100,
            lc45: 74.5,
            lc30: 47,
            lc10: 23.5
        },
        "neutral.300": {
            contrast: 50.067521919072455,
            lc60: 100,
            lc45: 82.5,
            lc30: 52,
            lc10: 26
        },
        "neutral.400": {
            contrast: 47.9725766241623,
            lc60: 100,
            lc45: 90,
            lc30: 57,
            lc10: 28.5
        },
        "neutral.500": {
            contrast: 44.63827259713489,
            lc60: 100,
            lc45: 100,
            lc30: 64,
            lc10: 32
        },
        "neutral.600": {
            contrast: 40.11915079495052,
            lc60: 100,
            lc45: 100,
            lc30: 72.5,
            lc10: 36.5
        },
        "neutral.700": {
            contrast: 35.58252241822329,
            lc60: 100,
            lc45: 100,
            lc30: 83.5,
            lc10: 42
        },
        "neutral.800": {
            contrast: 30.727523724011856,
            lc60: 100,
            lc45: 100,
            lc30: 97.5,
            lc10: 49
        },
        "neutral.900": {
            contrast: 26.000776669827275,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58
        },
        "neutral.1000": {
            contrast: 21.644900049904518,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "neutral.1100": {
            contrast: 17.138802324482484,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88
        },
        "neutral.1200": {
            contrast: 12.014658089747535,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1700": {
            contrast: 9.44626656217838,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1800": {
            contrast: 14.47419139427177,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1900": {
            contrast: 20.205814821536446,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74.5
        },
        "neutral.2000": {
            contrast: 26.081451044274484,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59
        },
        "neutral.2100": {
            contrast: 31.658865931673084,
            lc60: 100,
            lc45: 100,
            lc30: 95.5,
            lc10: 49.5
        },
        "neutral.2200": {
            contrast: 37.80198665638631,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 42.5
        },
        "neutral.2300": {
            contrast: 44.26108788002511,
            lc60: 100,
            lc45: 100,
            lc30: 70,
            lc10: 37
        },
        "neutral.2400": {
            contrast: 50.720229488112714,
            lc60: 100,
            lc45: 90,
            lc30: 62,
            lc10: 32.5
        },
        "neutral.2500": {
            contrast: 57.26116746308637,
            lc60: 100,
            lc45: 80.5,
            lc30: 56,
            lc10: 29
        }
    },
    "neutral.1600": {
        "neutral.100": {
            contrast: 56.96684150006792,
            lc60: 100,
            lc45: 61.5,
            lc30: 39.5,
            lc10: 19.5
        },
        "neutral.200": {
            contrast: 56.60111788375788,
            lc60: 100,
            lc45: 66.5,
            lc30: 42.5,
            lc10: 21.5
        },
        "neutral.300": {
            contrast: 55.07048458471536,
            lc60: 100,
            lc45: 73,
            lc30: 47,
            lc10: 23.5
        },
        "neutral.400": {
            contrast: 52.975539289805205,
            lc60: 100,
            lc45: 79.5,
            lc30: 51,
            lc10: 25.5
        },
        "neutral.500": {
            contrast: 49.641235262777805,
            lc60: 100,
            lc45: 88,
            lc30: 56.5,
            lc10: 28.5
        },
        "neutral.600": {
            contrast: 45.12211346059343,
            lc60: 100,
            lc45: 99.5,
            lc30: 63.5,
            lc10: 32
        },
        "neutral.700": {
            contrast: 40.5854850838662,
            lc60: 100,
            lc45: 100,
            lc30: 72,
            lc10: 36
        },
        "neutral.800": {
            contrast: 35.73048638965477,
            lc60: 100,
            lc45: 100,
            lc30: 83,
            lc10: 42
        },
        "neutral.900": {
            contrast: 31.003739335470186,
            lc60: 100,
            lc45: 100,
            lc30: 96,
            lc10: 49
        },
        "neutral.1000": {
            contrast: 26.647862715547426,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "neutral.1100": {
            contrast: 22.141764990125395,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "neutral.1200": {
            contrast: 17.017620755390446,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88
        },
        "neutral.1300": {
            contrast: 12.082846362317998,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1400": {
            contrast: 7.619053637141171,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1800": {
            contrast: 9.203078261628805,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1900": {
            contrast: 14.934701688893481,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2000": {
            contrast: 20.810337911631517,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74.5
        },
        "neutral.2100": {
            contrast: 26.387752799030118,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "neutral.2200": {
            contrast: 32.530873523743345,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 49.5
        },
        "neutral.2300": {
            contrast: 38.98997474738214,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 42
        },
        "neutral.2400": {
            contrast: 45.44911635546974,
            lc60: 100,
            lc45: 99,
            lc30: 68,
            lc10: 36.5
        },
        "neutral.2500": {
            contrast: 51.9900543304434,
            lc60: 100,
            lc45: 87.5,
            lc30: 60.5,
            lc10: 32.5
        }
    },
    "neutral.1700": {
        "neutral.100": {
            contrast: 61.80171081707244,
            lc60: 85,
            lc45: 56.5,
            lc30: 36,
            lc10: 18.5
        },
        "neutral.200": {
            contrast: 61.4359872007624,
            lc60: 91.5,
            lc45: 61,
            lc30: 39,
            lc10: 20
        },
        "neutral.300": {
            contrast: 59.905353901719884,
            lc60: 100,
            lc45: 66.5,
            lc30: 43,
            lc10: 22
        },
        "neutral.400": {
            contrast: 57.81040860680974,
            lc60: 100,
            lc45: 72,
            lc30: 46,
            lc10: 24
        },
        "neutral.500": {
            contrast: 54.47610457978232,
            lc60: 100,
            lc45: 79.5,
            lc30: 51,
            lc10: 26
        },
        "neutral.600": {
            contrast: 49.95698277759794,
            lc60: 100,
            lc45: 88,
            lc30: 57,
            lc10: 29
        },
        "neutral.700": {
            contrast: 45.42035440087072,
            lc60: 100,
            lc45: 98.5,
            lc30: 63.5,
            lc10: 33
        },
        "neutral.800": {
            contrast: 40.56535570665929,
            lc60: 100,
            lc45: 100,
            lc30: 72,
            lc10: 37.5
        },
        "neutral.900": {
            contrast: 35.838608652474704,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 42.5
        },
        "neutral.1000": {
            contrast: 31.482732032551947,
            lc60: 100,
            lc45: 100,
            lc30: 94.5,
            lc10: 49
        },
        "neutral.1100": {
            contrast: 26.976634307129917,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "neutral.1200": {
            contrast: 21.85249007239497,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "neutral.1300": {
            contrast: 16.91771567932252,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 90.5
        },
        "neutral.1400": {
            contrast: 12.453922954145694,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1500": {
            contrast: 7.822086097911382,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1900": {
            contrast: 9.778180122855087,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2000": {
            contrast: 15.653816345593125,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 94.5
        },
        "neutral.2100": {
            contrast: 21.23123123299173,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72
        },
        "neutral.2200": {
            contrast: 27.374351957704953,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "neutral.2300": {
            contrast: 33.83345318134375,
            lc60: 100,
            lc45: 100,
            lc30: 89,
            lc10: 47
        },
        "neutral.2400": {
            contrast: 40.29259478943135,
            lc60: 100,
            lc45: 100,
            lc30: 76,
            lc10: 40
        },
        "neutral.2500": {
            contrast: 46.833532764405014,
            lc60: 100,
            lc45: 96.5,
            lc30: 66.5,
            lc10: 35
        }
    },
    "neutral.1800": {
        "neutral.100": {
            contrast: 66.5713033333199,
            lc60: 73.5,
            lc45: 52,
            lc30: 34,
            lc10: 17
        },
        "neutral.200": {
            contrast: 66.20557971700987,
            lc60: 79,
            lc45: 56,
            lc30: 36.5,
            lc10: 18.5
        },
        "neutral.300": {
            contrast: 64.67494641796735,
            lc60: 86,
            lc45: 61,
            lc30: 39.5,
            lc10: 20
        },
        "neutral.400": {
            contrast: 62.580001123057194,
            lc60: 92.5,
            lc45: 65.5,
            lc30: 42.5,
            lc10: 21.5
        },
        "neutral.500": {
            contrast: 59.245697096029794,
            lc60: 100,
            lc45: 72,
            lc30: 47,
            lc10: 24
        },
        "neutral.600": {
            contrast: 54.72657529384543,
            lc60: 100,
            lc45: 79.5,
            lc30: 52,
            lc10: 26.5
        },
        "neutral.700": {
            contrast: 50.18994691711819,
            lc60: 100,
            lc45: 88.5,
            lc30: 57.5,
            lc10: 29.5
        },
        "neutral.800": {
            contrast: 45.33494822290676,
            lc60: 100,
            lc45: 99,
            lc30: 64.5,
            lc10: 33
        },
        "neutral.900": {
            contrast: 40.608201168722175,
            lc60: 100,
            lc45: 100,
            lc30: 72.5,
            lc10: 37
        },
        "neutral.1000": {
            contrast: 36.252324548799415,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 42
        },
        "neutral.1100": {
            contrast: 31.746226823377384,
            lc60: 100,
            lc45: 100,
            lc30: 94.5,
            lc10: 48.5
        },
        "neutral.1200": {
            contrast: 26.62208258864243,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58
        },
        "neutral.1300": {
            contrast: 21.687308195569983,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70.5
        },
        "neutral.1400": {
            contrast: 17.22351547039316,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87.5
        },
        "neutral.1500": {
            contrast: 12.591678614158846,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1600": {
            contrast: 7.55387140575656,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2000": {
            contrast: 10.510265432804895,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2100": {
            contrast: 16.0876803202035,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 94.5
        },
        "neutral.2200": {
            contrast: 22.230801044916724,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70.5
        },
        "neutral.2300": {
            contrast: 28.689902268555517,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "neutral.2400": {
            contrast: 35.14904387664311,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 46.5
        },
        "neutral.2500": {
            contrast: 41.68998185161678,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 39.5
        }
    },
    "neutral.1900": {
        "neutral.100": {
            contrast: 71.96892761421948,
            lc60: 67,
            lc45: 48,
            lc30: 31.5,
            lc10: 16
        },
        "neutral.200": {
            contrast: 71.60320399790945,
            lc60: 71.5,
            lc45: 51.5,
            lc30: 33.5,
            lc10: 17
        },
        "neutral.300": {
            contrast: 70.07257069886693,
            lc60: 77.5,
            lc45: 55.5,
            lc30: 36,
            lc10: 18.5
        },
        "neutral.400": {
            contrast: 67.97762540395678,
            lc60: 83,
            lc45: 59.5,
            lc30: 38.5,
            lc10: 20
        },
        "neutral.500": {
            contrast: 64.64332137692938,
            lc60: 90.5,
            lc45: 65,
            lc30: 42.5,
            lc10: 22
        },
        "neutral.600": {
            contrast: 60.124199574745,
            lc60: 99.5,
            lc45: 71.5,
            lc30: 46.5,
            lc10: 24
        },
        "neutral.700": {
            contrast: 55.58757119801777,
            lc60: 100,
            lc45: 78.5,
            lc30: 51,
            lc10: 26
        },
        "neutral.800": {
            contrast: 50.73257250380634,
            lc60: 100,
            lc45: 87.5,
            lc30: 56.5,
            lc10: 29
        },
        "neutral.900": {
            contrast: 46.00582544962176,
            lc60: 100,
            lc45: 97,
            lc30: 63.5,
            lc10: 32.5
        },
        "neutral.1000": {
            contrast: 41.649948829699,
            lc60: 100,
            lc45: 100,
            lc30: 70.5,
            lc10: 36.5
        },
        "neutral.1100": {
            contrast: 37.14385110427696,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 41
        },
        "neutral.1200": {
            contrast: 32.01970686954201,
            lc60: 100,
            lc45: 100,
            lc30: 93,
            lc10: 47.5
        },
        "neutral.1300": {
            contrast: 27.084932476469564,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "neutral.1400": {
            contrast: 22.621139751292738,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68.5
        },
        "neutral.1500": {
            contrast: 17.98930289505843,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85.5
        },
        "neutral.1600": {
            contrast: 12.95149568665614,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1700": {
            contrast: 8.076349554670522,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2100": {
            contrast: 10.202825603179782,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2200": {
            contrast: 16.345946327893007,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91.5
        },
        "neutral.2300": {
            contrast: 22.8050475515318,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "neutral.2400": {
            contrast: 29.264189159619402,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54
        },
        "neutral.2500": {
            contrast: 35.805127134593064,
            lc60: 100,
            lc45: 100,
            lc30: 85.5,
            lc10: 45
        }
    },
    "neutral.2000": {
        "neutral.100": {
            contrast: 77.46191663690823,
            lc60: 61.5,
            lc45: 44.5,
            lc30: 29,
            lc10: 15
        },
        "neutral.200": {
            contrast: 77.09619302059821,
            lc60: 66,
            lc45: 47.5,
            lc30: 31,
            lc10: 16
        },
        "neutral.300": {
            contrast: 75.56555972155569,
            lc60: 71,
            lc45: 51.5,
            lc30: 33.5,
            lc10: 17.5
        },
        "neutral.400": {
            contrast: 73.47061442664553,
            lc60: 75.5,
            lc45: 55,
            lc30: 36,
            lc10: 18.5
        },
        "neutral.500": {
            contrast: 70.13631039961811,
            lc60: 82,
            lc45: 59.5,
            lc30: 39,
            lc10: 20
        },
        "neutral.600": {
            contrast: 65.61718859743375,
            lc60: 89.5,
            lc45: 64.5,
            lc30: 42.5,
            lc10: 22
        },
        "neutral.700": {
            contrast: 61.080560220706516,
            lc60: 98,
            lc45: 71,
            lc30: 46.5,
            lc10: 24
        },
        "neutral.800": {
            contrast: 56.225561526495085,
            lc60: 100,
            lc45: 78,
            lc30: 51,
            lc10: 26.5
        },
        "neutral.900": {
            contrast: 51.49881447231051,
            lc60: 100,
            lc45: 86,
            lc30: 56.5,
            lc10: 29
        },
        "neutral.1000": {
            contrast: 47.142937852387746,
            lc60: 100,
            lc45: 95,
            lc30: 62,
            lc10: 32
        },
        "neutral.1100": {
            contrast: 42.63684012696571,
            lc60: 100,
            lc45: 100,
            lc30: 69.5,
            lc10: 36
        },
        "neutral.1200": {
            contrast: 37.51269589223077,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 41
        },
        "neutral.1300": {
            contrast: 32.577921499158315,
            lc60: 100,
            lc45: 100,
            lc30: 91.5,
            lc10: 47.5
        },
        "neutral.1400": {
            contrast: 28.114128773981484,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "neutral.1500": {
            contrast: 23.482291917747176,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65.5
        },
        "neutral.1600": {
            contrast: 18.444484709344888,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82.5
        },
        "neutral.1700": {
            contrast: 13.569338577359272,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1800": {
            contrast: 8.754091024606884,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2200": {
            contrast: 10.291164375544643,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2300": {
            contrast: 16.75026559918344,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91
        },
        "neutral.2400": {
            contrast: 23.209407207271042,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "neutral.2500": {
            contrast: 29.750345182244704,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54
        }
    },
    "neutral.2100": {
        "neutral.100": {
            contrast: 82.64126048899873,
            lc60: 57,
            lc45: 42,
            lc30: 27.5,
            lc10: 14.5
        },
        "neutral.200": {
            contrast: 82.27553687268868,
            lc60: 61,
            lc45: 44.5,
            lc30: 29,
            lc10: 15.5
        },
        "neutral.300": {
            contrast: 80.74490357364617,
            lc60: 65.5,
            lc45: 47.5,
            lc30: 31.5,
            lc10: 16.5
        },
        "neutral.400": {
            contrast: 78.64995827873601,
            lc60: 69.5,
            lc45: 50.5,
            lc30: 33.5,
            lc10: 17.5
        },
        "neutral.500": {
            contrast: 75.31565425170861,
            lc60: 75,
            lc45: 55,
            lc30: 36,
            lc10: 18.5
        },
        "neutral.600": {
            contrast: 70.79653244952424,
            lc60: 81.5,
            lc45: 59,
            lc30: 39,
            lc10: 20
        },
        "neutral.700": {
            contrast: 66.259904072797,
            lc60: 88.5,
            lc45: 64.5,
            lc30: 42.5,
            lc10: 22
        },
        "neutral.800": {
            contrast: 61.404905378585575,
            lc60: 97,
            lc45: 70.5,
            lc30: 46.5,
            lc10: 24
        },
        "neutral.900": {
            contrast: 56.67815832440098,
            lc60: 100,
            lc45: 77.5,
            lc30: 51,
            lc10: 26
        },
        "neutral.1000": {
            contrast: 52.322281704478236,
            lc60: 100,
            lc45: 84.5,
            lc30: 56,
            lc10: 28.5
        },
        "neutral.1100": {
            contrast: 47.81618397905619,
            lc60: 100,
            lc45: 93,
            lc30: 61.5,
            lc10: 31.5
        },
        "neutral.1200": {
            contrast: 42.69203974432125,
            lc60: 100,
            lc45: 100,
            lc30: 70,
            lc10: 35.5
        },
        "neutral.1300": {
            contrast: 37.7572653512488,
            lc60: 100,
            lc45: 100,
            lc30: 79,
            lc10: 40.5
        },
        "neutral.1400": {
            contrast: 33.293472626071974,
            lc60: 100,
            lc45: 100,
            lc30: 90,
            lc10: 46.5
        },
        "neutral.1500": {
            contrast: 28.661635769837662,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54
        },
        "neutral.1600": {
            contrast: 23.623828561435374,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64.5
        },
        "neutral.1700": {
            contrast: 18.748682429449758,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81
        },
        "neutral.1800": {
            contrast: 13.93343487669737,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1900": {
            contrast: 8.477516123124515,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2300": {
            contrast: 10.983498250605415,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2400": {
            contrast: 17.442639858693013,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88
        },
        "neutral.2500": {
            contrast: 23.98357783366668,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        }
    },
    "neutral.2200": {
        "neutral.100": {
            contrast: 88.3095044885901,
            lc60: 53.5,
            lc45: 39,
            lc30: 26,
            lc10: 13.5
        },
        "neutral.200": {
            contrast: 87.94378087228006,
            lc60: 56.5,
            lc45: 41.5,
            lc30: 27.5,
            lc10: 14
        },
        "neutral.300": {
            contrast: 86.41314757323754,
            lc60: 60.5,
            lc45: 44.5,
            lc30: 29.5,
            lc10: 15
        },
        "neutral.400": {
            contrast: 84.31820227832739,
            lc60: 64,
            lc45: 47,
            lc30: 31,
            lc10: 16
        },
        "neutral.500": {
            contrast: 80.98389825129998,
            lc60: 69,
            lc45: 50.5,
            lc30: 33.5,
            lc10: 17.5
        },
        "neutral.600": {
            contrast: 76.46477644911562,
            lc60: 74.5,
            lc45: 54.5,
            lc30: 36,
            lc10: 18.5
        },
        "neutral.700": {
            contrast: 71.92814807238838,
            lc60: 80.5,
            lc45: 59,
            lc30: 39,
            lc10: 20
        },
        "neutral.800": {
            contrast: 67.07314937817695,
            lc60: 87.5,
            lc45: 64,
            lc30: 42.5,
            lc10: 22
        },
        "neutral.900": {
            contrast: 62.34640232399236,
            lc60: 95.5,
            lc45: 70,
            lc30: 46,
            lc10: 24
        },
        "neutral.1000": {
            contrast: 57.990525704069604,
            lc60: 100,
            lc45: 76,
            lc30: 50,
            lc10: 26
        },
        "neutral.1100": {
            contrast: 53.484427978647574,
            lc60: 100,
            lc45: 83,
            lc30: 55,
            lc10: 28.5
        },
        "neutral.1200": {
            contrast: 48.360283743912625,
            lc60: 100,
            lc45: 92.5,
            lc30: 61.5,
            lc10: 32
        },
        "neutral.1300": {
            contrast: 43.42550935084017,
            lc60: 100,
            lc45: 100,
            lc30: 68.5,
            lc10: 35.5
        },
        "neutral.1400": {
            contrast: 38.96171662566334,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 40
        },
        "neutral.1500": {
            contrast: 34.329879769429034,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 45.5
        },
        "neutral.1600": {
            contrast: 29.292072561026743,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53.5
        },
        "neutral.1700": {
            contrast: 24.416926429041133,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63.5
        },
        "neutral.1800": {
            contrast: 19.601678876288744,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78
        },
        "neutral.1900": {
            contrast: 14.145760122715888,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2000": {
            contrast: 8.586685335948916,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2400": {
            contrast: 11.07058191625551,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2500": {
            contrast: 17.61151989122917,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87.5
        }
    },
    "neutral.2300": {
        "neutral.100": {
            contrast: 94.23100016377755,
            lc60: 50,
            lc45: 36.5,
            lc30: 24,
            lc10: 12.5
        },
        "neutral.200": {
            contrast: 93.8652765474675,
            lc60: 52.5,
            lc45: 38.5,
            lc30: 25.5,
            lc10: 13.5
        },
        "neutral.300": {
            contrast: 92.33464324842498,
            lc60: 56,
            lc45: 41.5,
            lc30: 27.5,
            lc10: 14.5
        },
        "neutral.400": {
            contrast: 90.23969795351483,
            lc60: 59.5,
            lc45: 43.5,
            lc30: 29,
            lc10: 15
        },
        "neutral.500": {
            contrast: 86.90539392648743,
            lc60: 63.5,
            lc45: 47,
            lc30: 31,
            lc10: 16.5
        },
        "neutral.600": {
            contrast: 82.38627212430306,
            lc60: 68.5,
            lc45: 50.5,
            lc30: 33.5,
            lc10: 17.5
        },
        "neutral.700": {
            contrast: 77.84964374757583,
            lc60: 73.5,
            lc45: 54,
            lc30: 36,
            lc10: 19
        },
        "neutral.800": {
            contrast: 72.9946450533644,
            lc60: 79.5,
            lc45: 58.5,
            lc30: 39,
            lc10: 20.5
        },
        "neutral.900": {
            contrast: 68.26789799917981,
            lc60: 86,
            lc45: 63.5,
            lc30: 42,
            lc10: 22
        },
        "neutral.1000": {
            contrast: 63.912021379257055,
            lc60: 93,
            lc45: 68.5,
            lc30: 45.5,
            lc10: 24
        },
        "neutral.1100": {
            contrast: 59.40592365383501,
            lc60: 100,
            lc45: 74.5,
            lc30: 49.5,
            lc10: 26
        },
        "neutral.1200": {
            contrast: 54.28177941910006,
            lc60: 100,
            lc45: 82,
            lc30: 54.5,
            lc10: 28.5
        },
        "neutral.1300": {
            contrast: 49.34700502602761,
            lc60: 100,
            lc45: 91,
            lc30: 60.5,
            lc10: 32
        },
        "neutral.1400": {
            contrast: 44.88321230085079,
            lc60: 100,
            lc45: 100,
            lc30: 66.5,
            lc10: 35
        },
        "neutral.1500": {
            contrast: 40.251375444616485,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 39.5
        },
        "neutral.1600": {
            contrast: 35.21356823621419,
            lc60: 100,
            lc45: 100,
            lc30: 85.5,
            lc10: 45
        },
        "neutral.1700": {
            contrast: 30.338422104228574,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 52.5
        },
        "neutral.1800": {
            contrast: 25.523174551476185,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61.5
        },
        "neutral.1900": {
            contrast: 20.067255797903332,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76.5
        },
        "neutral.2000": {
            contrast: 14.508181011136362,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2100": {
            contrast: 9.260663491357151,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2500": {
            contrast: 10.89007226952084,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "neutral.2400": {
        "neutral.100": {
            contrast: 100.11597231997993,
            lc60: 46.5,
            lc45: 34,
            lc30: 23,
            lc10: 12
        },
        "neutral.200": {
            contrast: 99.75024870366987,
            lc60: 49.5,
            lc45: 36,
            lc30: 24,
            lc10: 12.5
        },
        "neutral.300": {
            contrast: 98.21961540462738,
            lc60: 52.5,
            lc45: 38.5,
            lc30: 25.5,
            lc10: 13.5
        },
        "neutral.400": {
            contrast: 96.1246701097172,
            lc60: 55,
            lc45: 40.5,
            lc30: 27,
            lc10: 14
        },
        "neutral.500": {
            contrast: 92.7903660826898,
            lc60: 59,
            lc45: 43.5,
            lc30: 29,
            lc10: 15
        },
        "neutral.600": {
            contrast: 88.27124428050543,
            lc60: 63,
            lc45: 46.5,
            lc30: 31,
            lc10: 16
        },
        "neutral.700": {
            contrast: 83.73461590377819,
            lc60: 67.5,
            lc45: 50,
            lc30: 33,
            lc10: 17.5
        },
        "neutral.800": {
            contrast: 78.87961720956676,
            lc60: 72.5,
            lc45: 53.5,
            lc30: 35.5,
            lc10: 18.5
        },
        "neutral.900": {
            contrast: 74.15287015538217,
            lc60: 78,
            lc45: 57.5,
            lc30: 38.5,
            lc10: 20
        },
        "neutral.1000": {
            contrast: 69.79699353545942,
            lc60: 84,
            lc45: 62,
            lc30: 41.5,
            lc10: 21.5
        },
        "neutral.1100": {
            contrast: 65.29089581003738,
            lc60: 90.5,
            lc45: 67,
            lc30: 44.5,
            lc10: 23
        },
        "neutral.1200": {
            contrast: 60.166751575302435,
            lc60: 99.5,
            lc45: 73,
            lc30: 49,
            lc10: 25.5
        },
        "neutral.1300": {
            contrast: 55.23197718222998,
            lc60: 100,
            lc45: 80,
            lc30: 53.5,
            lc10: 28
        },
        "neutral.1400": {
            contrast: 50.76818445705317,
            lc60: 100,
            lc45: 88,
            lc30: 58.5,
            lc10: 30.5
        },
        "neutral.1500": {
            contrast: 46.13634760081886,
            lc60: 100,
            lc45: 97,
            lc30: 64.5,
            lc10: 34
        },
        "neutral.1600": {
            contrast: 41.09854039241657,
            lc60: 100,
            lc45: 100,
            lc30: 73,
            lc10: 38
        },
        "neutral.1700": {
            contrast: 36.22339426043094,
            lc60: 100,
            lc45: 100,
            lc30: 83,
            lc10: 43.5
        },
        "neutral.1800": {
            contrast: 31.408146707678558,
            lc60: 100,
            lc45: 100,
            lc30: 95.5,
            lc10: 50
        },
        "neutral.1900": {
            contrast: 25.952227954105705,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "neutral.2000": {
            contrast: 20.393153167338735,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75.5
        },
        "neutral.2100": {
            contrast: 15.145635647559525,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98
        },
        "neutral.2200": {
            contrast: 9.39664766018005,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "neutral.2500": {
        "neutral.100": {
            contrast: 106.04067321268862,
            lc60: 44,
            lc45: 32.5,
            lc30: 21.5,
            lc10: 11.5
        },
        "neutral.200": {
            contrast: 105.67494959637858,
            lc60: 46,
            lc45: 34.5,
            lc30: 22.5,
            lc10: 12
        },
        "neutral.300": {
            contrast: 104.14431629733605,
            lc60: 49,
            lc45: 36.5,
            lc30: 24,
            lc10: 12.5
        },
        "neutral.400": {
            contrast: 102.0493710024259,
            lc60: 51.5,
            lc45: 38,
            lc30: 25.5,
            lc10: 13.5
        },
        "neutral.500": {
            contrast: 98.71506697539849,
            lc60: 55,
            lc45: 40.5,
            lc30: 27,
            lc10: 14
        },
        "neutral.600": {
            contrast: 94.19594517321411,
            lc60: 58.5,
            lc45: 43.5,
            lc30: 29,
            lc10: 15
        },
        "neutral.700": {
            contrast: 89.65931679648688,
            lc60: 62.5,
            lc45: 46.5,
            lc30: 31,
            lc10: 16
        },
        "neutral.800": {
            contrast: 84.80431810227545,
            lc60: 67,
            lc45: 50,
            lc30: 33,
            lc10: 17.5
        },
        "neutral.900": {
            contrast: 80.07757104809086,
            lc60: 72,
            lc45: 53.5,
            lc30: 35.5,
            lc10: 18.5
        },
        "neutral.1000": {
            contrast: 75.72169442816812,
            lc60: 77,
            lc45: 57,
            lc30: 38,
            lc10: 20
        },
        "neutral.1100": {
            contrast: 71.21559670274607,
            lc60: 82.5,
            lc45: 61,
            lc30: 40.5,
            lc10: 21.5
        },
        "neutral.1200": {
            contrast: 66.09145246801113,
            lc60: 90,
            lc45: 66.5,
            lc30: 44,
            lc10: 23.5
        },
        "neutral.1300": {
            contrast: 61.15667807493866,
            lc60: 97.5,
            lc45: 72.5,
            lc30: 48,
            lc10: 25.5
        },
        "neutral.1400": {
            contrast: 56.692885349761845,
            lc60: 100,
            lc45: 78.5,
            lc30: 52,
            lc10: 27.5
        },
        "neutral.1500": {
            contrast: 52.06104849352754,
            lc60: 100,
            lc45: 86,
            lc30: 57,
            lc10: 30
        },
        "neutral.1600": {
            contrast: 47.02324128512525,
            lc60: 100,
            lc45: 95.5,
            lc30: 63.5,
            lc10: 33.5
        },
        "neutral.1700": {
            contrast: 42.14809515313963,
            lc60: 100,
            lc45: 100,
            lc30: 71,
            lc10: 37.5
        },
        "neutral.1800": {
            contrast: 37.33284760038724,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 42.5
        },
        "neutral.1900": {
            contrast: 31.87692884681439,
            lc60: 100,
            lc45: 100,
            lc30: 94,
            lc10: 50
        },
        "neutral.2000": {
            contrast: 26.31785406004742,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "neutral.2100": {
            contrast: 21.070336540268208,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "neutral.2200": {
            contrast: 15.321348552888736,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98
        },
        "neutral.2300": {
            contrast: 9.309043917434105,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    }
};
const $f8fd43f1ee3f8cd8$var$green = {
    "green.100": {
        "green.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.600": {
            contrast: 9.65156398319264,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.700": {
            contrast: 14.439676789537712,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.800": {
            contrast: 19.276479420763838,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88
        },
        "green.900": {
            contrast: 24.051226631961406,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78.5
        },
        "green.1000": {
            contrast: 28.700385904081855,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "green.1100": {
            contrast: 33.56306405222742,
            lc60: 100,
            lc45: 100,
            lc30: 94,
            lc10: 65
        },
        "green.1200": {
            contrast: 38.63108155525363,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 60
        },
        "green.1300": {
            contrast: 44.328938152235104,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 55.5
        },
        "green.1400": {
            contrast: 48.71789679229603,
            lc60: 100,
            lc45: 95,
            lc30: 75,
            lc10: 52.5
        },
        "green.1500": {
            contrast: 53.31173160825175,
            lc60: 100,
            lc45: 90.5,
            lc30: 71.5,
            lc10: 49.5
        },
        "green.1600": {
            contrast: 58.099909128157826,
            lc60: 100,
            lc45: 85.5,
            lc30: 67.5,
            lc10: 47
        },
        "green.1700": {
            contrast: 63.53722434966376,
            lc60: 96,
            lc45: 81,
            lc30: 64,
            lc10: 44.5
        },
        "green.1800": {
            contrast: 69.13945750584531,
            lc60: 91.5,
            lc45: 76.5,
            lc30: 61,
            lc10: 42.5
        },
        "green.1900": {
            contrast: 74.49510458475933,
            lc60: 87.5,
            lc45: 73,
            lc30: 58,
            lc10: 40.5
        },
        "green.2000": {
            contrast: 79.87687819652875,
            lc60: 83.5,
            lc45: 70,
            lc30: 55.5,
            lc10: 39
        },
        "green.2100": {
            contrast: 85.68674018781846,
            lc60: 80,
            lc45: 67,
            lc30: 53.5,
            lc10: 37
        },
        "green.2200": {
            contrast: 91.43785535455999,
            lc60: 77,
            lc45: 64.5,
            lc30: 51,
            lc10: 35.5
        },
        "green.2300": {
            contrast: 97.07887582529496,
            lc60: 74,
            lc45: 62,
            lc30: 49,
            lc10: 34
        },
        "green.2400": {
            contrast: 102.71647949316747,
            lc60: 71.5,
            lc45: 60,
            lc30: 47.5,
            lc10: 33
        },
        "green.2500": {
            contrast: 107.88473318309848,
            lc60: 69,
            lc45: 58,
            lc30: 46,
            lc10: 32
        }
    },
    "green.200": {
        "green.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.600": {
            contrast: 9.232381345373856,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.700": {
            contrast: 14.020494151718927,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.800": {
            contrast: 18.857296782945056,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86.5
        },
        "green.900": {
            contrast: 23.632043994142624,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75.5
        },
        "green.1000": {
            contrast: 28.281203266263066,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "green.1100": {
            contrast: 33.14388141440863,
            lc60: 100,
            lc45: 100,
            lc30: 93.5,
            lc10: 61
        },
        "green.1200": {
            contrast: 38.21189891743485,
            lc60: 100,
            lc45: 100,
            lc30: 85.5,
            lc10: 55.5
        },
        "green.1300": {
            contrast: 43.90975551441632,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 50.5
        },
        "green.1400": {
            contrast: 48.29871415447725,
            lc60: 100,
            lc45: 95,
            lc30: 73,
            lc10: 48
        },
        "green.1500": {
            contrast: 52.89254897043296,
            lc60: 100,
            lc45: 90,
            lc30: 69,
            lc10: 45.5
        },
        "green.1600": {
            contrast: 57.680726490339026,
            lc60: 100,
            lc45: 85,
            lc30: 65,
            lc10: 42.5
        },
        "green.1700": {
            contrast: 63.11804171184497,
            lc60: 96.5,
            lc45: 79.5,
            lc30: 61.5,
            lc10: 40
        },
        "green.1800": {
            contrast: 68.72027486802652,
            lc60: 91,
            lc45: 75,
            lc30: 58,
            lc10: 38
        },
        "green.1900": {
            contrast: 74.07592194694054,
            lc60: 87,
            lc45: 72,
            lc30: 55.5,
            lc10: 36
        },
        "green.2000": {
            contrast: 79.45769555870996,
            lc60: 82.5,
            lc45: 68,
            lc30: 53,
            lc10: 34.5
        },
        "green.2100": {
            contrast: 85.26755754999967,
            lc60: 79,
            lc45: 65.5,
            lc30: 50.5,
            lc10: 33
        },
        "green.2200": {
            contrast: 91.01867271674121,
            lc60: 75.5,
            lc45: 62.5,
            lc30: 48,
            lc10: 31.5
        },
        "green.2300": {
            contrast: 96.65969318747617,
            lc60: 72.5,
            lc45: 60,
            lc30: 46,
            lc10: 30.5
        },
        "green.2400": {
            contrast: 102.29729685534868,
            lc60: 70,
            lc45: 58,
            lc30: 44.5,
            lc10: 29.5
        },
        "green.2500": {
            contrast: 107.46555054527968,
            lc60: 67.5,
            lc45: 56,
            lc30: 43.5,
            lc10: 28.5
        }
    },
    "green.300": {
        "green.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.600": {
            contrast: 7.8510404699223,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.700": {
            contrast: 12.63915327626737,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.800": {
            contrast: 17.4759559074935,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89.5
        },
        "green.900": {
            contrast: 22.250703118691067,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75.5
        },
        "green.1000": {
            contrast: 26.899862390811506,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "green.1100": {
            contrast: 31.76254053895708,
            lc60: 100,
            lc45: 100,
            lc30: 95.5,
            lc10: 59
        },
        "green.1200": {
            contrast: 36.830558041983295,
            lc60: 100,
            lc45: 100,
            lc30: 86,
            lc10: 53
        },
        "green.1300": {
            contrast: 42.52841463896477,
            lc60: 100,
            lc45: 100,
            lc30: 77.5,
            lc10: 48
        },
        "green.1400": {
            contrast: 46.91737327902569,
            lc60: 100,
            lc45: 96.5,
            lc30: 73,
            lc10: 45
        },
        "green.1500": {
            contrast: 51.511208094981406,
            lc60: 100,
            lc45: 91,
            lc30: 68,
            lc10: 42
        },
        "green.1600": {
            contrast: 56.299385614887484,
            lc60: 100,
            lc45: 85,
            lc30: 64,
            lc10: 40
        },
        "green.1700": {
            contrast: 61.736700836393425,
            lc60: 97.5,
            lc45: 79.5,
            lc30: 59.5,
            lc10: 37
        },
        "green.1800": {
            contrast: 67.33893399257498,
            lc60: 91.5,
            lc45: 75,
            lc30: 56.5,
            lc10: 35
        },
        "green.1900": {
            contrast: 72.69458107148898,
            lc60: 87,
            lc45: 71,
            lc30: 53,
            lc10: 33
        },
        "green.2000": {
            contrast: 78.07635468325842,
            lc60: 83,
            lc45: 67.5,
            lc30: 51,
            lc10: 32
        },
        "green.2100": {
            contrast: 83.88621667454812,
            lc60: 78.5,
            lc45: 64.5,
            lc30: 48.5,
            lc10: 30
        },
        "green.2200": {
            contrast: 89.63733184128965,
            lc60: 75,
            lc45: 61.5,
            lc30: 46,
            lc10: 28.5
        },
        "green.2300": {
            contrast: 95.27835231202462,
            lc60: 72,
            lc45: 59,
            lc30: 44.5,
            lc10: 27.5
        },
        "green.2400": {
            contrast: 100.91595597989713,
            lc60: 69,
            lc45: 56.5,
            lc30: 43,
            lc10: 26.5
        },
        "green.2500": {
            contrast: 106.08420966982813,
            lc60: 67,
            lc45: 55,
            lc30: 41.5,
            lc10: 26
        }
    },
    "green.400": {
        "green.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.700": {
            contrast: 10.607220346182219,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.800": {
            contrast: 15.44402297740835,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 97
        },
        "green.900": {
            contrast: 20.218770188605916,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79.5
        },
        "green.1000": {
            contrast: 24.867929460726366,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "green.1100": {
            contrast: 29.730607608871924,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59
        },
        "green.1200": {
            contrast: 34.79862511189814,
            lc60: 100,
            lc45: 100,
            lc30: 89,
            lc10: 52.5
        },
        "green.1300": {
            contrast: 40.496481708879614,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 47
        },
        "green.1400": {
            contrast: 44.885440348940534,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 43.5
        },
        "green.1500": {
            contrast: 49.47927516489625,
            lc60: 100,
            lc45: 93,
            lc30: 68,
            lc10: 40.5
        },
        "green.1600": {
            contrast: 54.26745268480233,
            lc60: 100,
            lc45: 86.5,
            lc30: 64,
            lc10: 38
        },
        "green.1700": {
            contrast: 59.70476790630826,
            lc60: 100,
            lc45: 81,
            lc30: 59.5,
            lc10: 35
        },
        "green.1800": {
            contrast: 65.30700106248982,
            lc60: 93.5,
            lc45: 75.5,
            lc30: 55.5,
            lc10: 33
        },
        "green.1900": {
            contrast: 70.66264814140382,
            lc60: 88.5,
            lc45: 71,
            lc30: 52.5,
            lc10: 31.5
        },
        "green.2000": {
            contrast: 76.04442175317327,
            lc60: 83.5,
            lc45: 67.5,
            lc30: 50,
            lc10: 30
        },
        "green.2100": {
            contrast: 81.85428374446296,
            lc60: 79,
            lc45: 64,
            lc30: 47.5,
            lc10: 28
        },
        "green.2200": {
            contrast: 87.60539891120449,
            lc60: 75.5,
            lc45: 61,
            lc30: 45,
            lc10: 27
        },
        "green.2300": {
            contrast: 93.24641938193948,
            lc60: 72,
            lc45: 58.5,
            lc30: 43,
            lc10: 26
        },
        "green.2400": {
            contrast: 98.88402304981196,
            lc60: 69.5,
            lc45: 56,
            lc30: 41.5,
            lc10: 25
        },
        "green.2500": {
            contrast: 104.05227673974298,
            lc60: 67,
            lc45: 54.5,
            lc30: 40.5,
            lc10: 24.5
        }
    },
    "green.500": {
        "green.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.700": {
            contrast: 7.6512273907677715,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.800": {
            contrast: 12.4880300219939,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.900": {
            contrast: 17.26277723319147,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88.5
        },
        "green.1000": {
            contrast: 21.911936505311918,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73
        },
        "green.1100": {
            contrast: 26.77461465345748,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62
        },
        "green.1200": {
            contrast: 31.842632156483695,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 54
        },
        "green.1300": {
            contrast: 37.54048875346517,
            lc60: 100,
            lc45: 100,
            lc30: 83,
            lc10: 47.5
        },
        "green.1400": {
            contrast: 41.92944739352609,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 43.5
        },
        "green.1500": {
            contrast: 46.523282209481806,
            lc60: 100,
            lc45: 97,
            lc30: 70.5,
            lc10: 40.5
        },
        "green.1600": {
            contrast: 51.311459729387884,
            lc60: 100,
            lc45: 90,
            lc30: 65.5,
            lc10: 37.5
        },
        "green.1700": {
            contrast: 56.74877495089382,
            lc60: 100,
            lc45: 83.5,
            lc30: 60,
            lc10: 35
        },
        "green.1800": {
            contrast: 62.35100810707538,
            lc60: 97,
            lc45: 77,
            lc30: 56.5,
            lc10: 32
        },
        "green.1900": {
            contrast: 67.70665518598939,
            lc60: 91,
            lc45: 73,
            lc30: 53,
            lc10: 30.5
        },
        "green.2000": {
            contrast: 73.08842879775882,
            lc60: 86,
            lc45: 69,
            lc30: 50,
            lc10: 29
        },
        "green.2100": {
            contrast: 78.89829078904852,
            lc60: 81,
            lc45: 64.5,
            lc30: 47,
            lc10: 27.5
        },
        "green.2200": {
            contrast: 84.64940595579004,
            lc60: 77,
            lc45: 61.5,
            lc30: 45,
            lc10: 26
        },
        "green.2300": {
            contrast: 90.29042642652503,
            lc60: 73,
            lc45: 59,
            lc30: 43,
            lc10: 25.5
        },
        "green.2400": {
            contrast: 95.92803009439751,
            lc60: 70.5,
            lc45: 56.5,
            lc30: 41.5,
            lc10: 24.5
        },
        "green.2500": {
            contrast: 101.09628378432853,
            lc60: 68,
            lc45: 55,
            lc30: 40.5,
            lc10: 24
        }
    },
    "green.600": {
        "green.100": {
            contrast: 11.13432494707484,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.200": {
            contrast: 10.572346229643648,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.300": {
            contrast: 8.769487489070388,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.800": {
            contrast: 8.364190146184654,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.900": {
            contrast: 13.138937357382222,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1000": {
            contrast: 17.788096629502668,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86
        },
        "green.1100": {
            contrast: 22.650774777648234,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "green.1200": {
            contrast: 27.71879228067445,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "green.1300": {
            contrast: 33.416648877655916,
            lc60: 100,
            lc45: 100,
            lc30: 91.5,
            lc10: 51
        },
        "green.1400": {
            contrast: 37.805607517716844,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 46
        },
        "green.1500": {
            contrast: 42.39944233367255,
            lc60: 100,
            lc45: 100,
            lc30: 75.5,
            lc10: 42.5
        },
        "green.1600": {
            contrast: 47.18761985357863,
            lc60: 100,
            lc45: 96,
            lc30: 69,
            lc10: 39
        },
        "green.1700": {
            contrast: 52.624935075084565,
            lc60: 100,
            lc45: 88,
            lc30: 63.5,
            lc10: 36
        },
        "green.1800": {
            contrast: 58.22716823126613,
            lc60: 100,
            lc45: 81.5,
            lc30: 59,
            lc10: 32.5
        },
        "green.1900": {
            contrast: 63.58281531018014,
            lc60: 95.5,
            lc45: 75.5,
            lc30: 54.5,
            lc10: 30.5
        },
        "green.2000": {
            contrast: 68.96458892194957,
            lc60: 89.5,
            lc45: 71,
            lc30: 51.5,
            lc10: 29
        },
        "green.2100": {
            contrast: 74.77445091323926,
            lc60: 84,
            lc45: 67,
            lc30: 48.5,
            lc10: 27.5
        },
        "green.2200": {
            contrast: 80.52556607998079,
            lc60: 79.5,
            lc45: 63.5,
            lc30: 46,
            lc10: 26
        },
        "green.2300": {
            contrast: 86.16658655071578,
            lc60: 75.5,
            lc45: 60.5,
            lc30: 44,
            lc10: 25
        },
        "green.2400": {
            contrast: 91.80419021858826,
            lc60: 72,
            lc45: 58,
            lc30: 42,
            lc10: 24
        },
        "green.2500": {
            contrast: 96.97244390851927,
            lc60: 69.5,
            lc45: 56,
            lc30: 41,
            lc10: 23.5
        }
    },
    "green.700": {
        "green.100": {
            contrast: 16.30203662974804,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72
        },
        "green.200": {
            contrast: 15.740057912316855,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89.5
        },
        "green.300": {
            contrast: 13.937199171743591,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.400": {
            contrast: 11.38744490258874,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.500": {
            contrast: 7.828500745282087,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.900": {
            contrast: 8.54668054497581,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1000": {
            contrast: 13.195839817096255,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1100": {
            contrast: 18.058517965241823,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85
        },
        "green.1200": {
            contrast: 23.126535468268035,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "green.1300": {
            contrast: 28.824392065249505,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "green.1400": {
            contrast: 33.21335070531043,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 51
        },
        "green.1500": {
            contrast: 37.80718552126615,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 46
        },
        "green.1600": {
            contrast: 42.59536304117223,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 41
        },
        "green.1700": {
            contrast: 48.03267826267816,
            lc60: 100,
            lc45: 95,
            lc30: 67.5,
            lc10: 37.5
        },
        "green.1800": {
            contrast: 53.63491141885972,
            lc60: 100,
            lc45: 86.5,
            lc30: 62,
            lc10: 34.5
        },
        "green.1900": {
            contrast: 58.99055849777374,
            lc60: 100,
            lc45: 80,
            lc30: 57,
            lc10: 32
        },
        "green.2000": {
            contrast: 64.37233210954317,
            lc60: 94.5,
            lc45: 75,
            lc30: 53.5,
            lc10: 30
        },
        "green.2100": {
            contrast: 70.18219410083286,
            lc60: 88,
            lc45: 69.5,
            lc30: 50,
            lc10: 28
        },
        "green.2200": {
            contrast: 75.93330926757437,
            lc60: 82.5,
            lc45: 66,
            lc30: 47,
            lc10: 26.5
        },
        "green.2300": {
            contrast: 81.57432973830937,
            lc60: 78.5,
            lc45: 62.5,
            lc30: 45,
            lc10: 25.5
        },
        "green.2400": {
            contrast: 87.21193340618186,
            lc60: 75,
            lc45: 59.5,
            lc30: 43.5,
            lc10: 24.5
        },
        "green.2500": {
            contrast: 92.38018709611286,
            lc60: 72,
            lc45: 57.5,
            lc30: 42,
            lc10: 24
        }
    },
    "green.800": {
        "green.100": {
            contrast: 21.404313928498926,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 48.5
        },
        "green.200": {
            contrast: 20.842335211067734,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58.5
        },
        "green.300": {
            contrast: 19.039476470494474,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "green.400": {
            contrast: 16.489722201339625,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88.5
        },
        "green.500": {
            contrast: 12.93077804403297,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.600": {
            contrast: 8.16961024915516,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1000": {
            contrast: 8.503591147675941,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1100": {
            contrast: 13.366269295821509,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1200": {
            contrast: 18.434286798847722,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82.5
        },
        "green.1300": {
            contrast: 24.132143395829196,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65
        },
        "green.1400": {
            contrast: 28.521102035890117,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "green.1500": {
            contrast: 33.114936851845826,
            lc60: 100,
            lc45: 100,
            lc30: 91.5,
            lc10: 50.5
        },
        "green.1600": {
            contrast: 37.903114371751904,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 45.5
        },
        "green.1700": {
            contrast: 43.340429593257845,
            lc60: 100,
            lc45: 100,
            lc30: 73,
            lc10: 40.5
        },
        "green.1800": {
            contrast: 48.9426627494394,
            lc60: 100,
            lc45: 93,
            lc30: 66.5,
            lc10: 36
        },
        "green.1900": {
            contrast: 54.29830982835341,
            lc60: 100,
            lc45: 86,
            lc30: 61,
            lc10: 33
        },
        "green.2000": {
            contrast: 59.68008344012284,
            lc60: 100,
            lc45: 79.5,
            lc30: 56.5,
            lc10: 31
        },
        "green.2100": {
            contrast: 65.48994543141255,
            lc60: 92.5,
            lc45: 73.5,
            lc30: 52.5,
            lc10: 29
        },
        "green.2200": {
            contrast: 71.24106059815406,
            lc60: 87,
            lc45: 69,
            lc30: 49,
            lc10: 27
        },
        "green.2300": {
            contrast: 76.88208106888905,
            lc60: 82.5,
            lc45: 65,
            lc30: 46.5,
            lc10: 26
        },
        "green.2400": {
            contrast: 82.51968473676155,
            lc60: 78,
            lc45: 62,
            lc30: 44.5,
            lc10: 25
        },
        "green.2500": {
            contrast: 87.68793842669254,
            lc60: 74.5,
            lc45: 60,
            lc30: 43,
            lc10: 24.5
        }
    },
    "green.900": {
        "green.100": {
            contrast: 26.349062378359804,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 39.5
        },
        "green.200": {
            contrast: 25.787083660928616,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 47
        },
        "green.300": {
            contrast: 23.98422492035536,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "green.400": {
            contrast: 21.43447065120051,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66.5
        },
        "green.500": {
            contrast: 17.875526493893858,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83
        },
        "green.600": {
            contrast: 13.114358699016046,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.700": {
            contrast: 8.008205274418536,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1100": {
            contrast: 8.691318134148899,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1200": {
            contrast: 13.759335637175116,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1300": {
            contrast: 19.457192234156587,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78.5
        },
        "green.1400": {
            contrast: 23.84615087421751,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "green.1500": {
            contrast: 28.43998569017322,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "green.1600": {
            contrast: 33.228163210079295,
            lc60: 100,
            lc45: 100,
            lc30: 91,
            lc10: 50.5
        },
        "green.1700": {
            contrast: 38.66547843158523,
            lc60: 100,
            lc45: 100,
            lc30: 80.5,
            lc10: 43.5
        },
        "green.1800": {
            contrast: 44.2677115877668,
            lc60: 100,
            lc45: 100,
            lc30: 72,
            lc10: 39
        },
        "green.1900": {
            contrast: 49.62335866668081,
            lc60: 100,
            lc45: 91.5,
            lc30: 65,
            lc10: 35.5
        },
        "green.2000": {
            contrast: 55.00513227845023,
            lc60: 100,
            lc45: 84.5,
            lc30: 60.5,
            lc10: 33
        },
        "green.2100": {
            contrast: 60.81499426973993,
            lc60: 98.5,
            lc45: 78,
            lc30: 55.5,
            lc10: 30.5
        },
        "green.2200": {
            contrast: 66.56610943648145,
            lc60: 91.5,
            lc45: 73,
            lc30: 51.5,
            lc10: 28.5
        },
        "green.2300": {
            contrast: 72.20712990721644,
            lc60: 86,
            lc45: 68.5,
            lc30: 49,
            lc10: 27
        },
        "green.2400": {
            contrast: 77.84473357508894,
            lc60: 81.5,
            lc45: 65,
            lc30: 46.5,
            lc10: 26
        },
        "green.2500": {
            contrast: 83.01298726501993,
            lc60: 78,
            lc45: 62.5,
            lc30: 45,
            lc10: 25.5
        }
    },
    "green.1000": {
        "green.100": {
            contrast: 31.091107726238086,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 34.5
        },
        "green.200": {
            contrast: 30.529129008806898,
            lc60: 100,
            lc45: 100,
            lc30: 94,
            lc10: 40
        },
        "green.300": {
            contrast: 28.726270268233637,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 46.5
        },
        "green.400": {
            contrast: 26.17651599907879,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54.5
        },
        "green.500": {
            contrast: 22.61757184177214,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65.5
        },
        "green.600": {
            contrast: 17.85640404689433,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84
        },
        "green.700": {
            contrast: 12.750250622296818,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.800": {
            contrast: 7.689499906647697,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1200": {
            contrast: 9.172626187354888,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1300": {
            contrast: 14.870482784336359,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1400": {
            contrast: 19.259441424397288,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79
        },
        "green.1500": {
            contrast: 23.853276240352997,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "green.1600": {
            contrast: 28.641453760259072,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "green.1700": {
            contrast: 34.07876898176501,
            lc60: 100,
            lc45: 100,
            lc30: 89.5,
            lc10: 49
        },
        "green.1800": {
            contrast: 39.68100213794657,
            lc60: 100,
            lc45: 100,
            lc30: 79,
            lc10: 43
        },
        "green.1900": {
            contrast: 45.03664921686058,
            lc60: 100,
            lc45: 99.5,
            lc30: 70,
            lc10: 39
        },
        "green.2000": {
            contrast: 50.41842282863001,
            lc60: 100,
            lc45: 90.5,
            lc30: 64.5,
            lc10: 35
        },
        "green.2100": {
            contrast: 56.22828481991971,
            lc60: 100,
            lc45: 83,
            lc30: 59,
            lc10: 32.5
        },
        "green.2200": {
            contrast: 61.97939998666124,
            lc60: 97,
            lc45: 77,
            lc30: 54.5,
            lc10: 30.5
        },
        "green.2300": {
            contrast: 67.62042045739621,
            lc60: 91,
            lc45: 72,
            lc30: 51.5,
            lc10: 28.5
        },
        "green.2400": {
            contrast: 73.2580241252687,
            lc60: 85.5,
            lc45: 68,
            lc30: 49,
            lc10: 27.5
        },
        "green.2500": {
            contrast: 78.42627781519971,
            lc60: 81.5,
            lc45: 65,
            lc30: 47,
            lc10: 27
        }
    },
    "green.1100": {
        "green.100": {
            contrast: 35.985726351734044,
            lc60: 100,
            lc45: 100,
            lc30: 63,
            lc10: 30
        },
        "green.200": {
            contrast: 35.423747634302856,
            lc60: 100,
            lc45: 100,
            lc30: 72,
            lc10: 34.5
        },
        "green.300": {
            contrast: 33.62088889372959,
            lc60: 100,
            lc45: 100,
            lc30: 83,
            lc10: 39.5
        },
        "green.400": {
            contrast: 31.071134624574743,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 45.5
        },
        "green.500": {
            contrast: 27.512190467268088,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53.5
        },
        "green.600": {
            contrast: 22.751022672390278,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65.5
        },
        "green.700": {
            contrast: 17.64486924779277,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85
        },
        "green.800": {
            contrast: 12.584118532143648,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.900": {
            contrast: 7.664507650445833,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1300": {
            contrast: 10.04127529615729,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1400": {
            contrast: 14.430233936218215,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1500": {
            contrast: 19.02406875217393,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80
        },
        "green.1600": {
            contrast: 23.812246272080003,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "green.1700": {
            contrast: 29.24956149358594,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "green.1800": {
            contrast: 34.8517946497675,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 47.5
        },
        "green.1900": {
            contrast: 40.20744172868151,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 42.5
        },
        "green.2000": {
            contrast: 45.58921534045094,
            lc60: 100,
            lc45: 98.5,
            lc30: 70,
            lc10: 38.5
        },
        "green.2100": {
            contrast: 51.39907733174064,
            lc60: 100,
            lc45: 89.5,
            lc30: 63,
            lc10: 35
        },
        "green.2200": {
            contrast: 57.15019249848217,
            lc60: 100,
            lc45: 82,
            lc30: 59,
            lc10: 32
        },
        "green.2300": {
            contrast: 62.79121296921715,
            lc60: 96.5,
            lc45: 76.5,
            lc30: 54.5,
            lc10: 30.5
        },
        "green.2400": {
            contrast: 68.42881663708964,
            lc60: 90,
            lc45: 71.5,
            lc30: 52,
            lc10: 29
        },
        "green.2500": {
            contrast: 73.59707032702065,
            lc60: 85.5,
            lc45: 68.5,
            lc30: 49.5,
            lc10: 28
        }
    },
    "green.1200": {
        "green.100": {
            contrast: 41.02556777925482,
            lc60: 100,
            lc45: 100,
            lc30: 54.5,
            lc10: 27
        },
        "green.200": {
            contrast: 40.46358906182363,
            lc60: 100,
            lc45: 100,
            lc30: 61.5,
            lc10: 31
        },
        "green.300": {
            contrast: 38.66073032125038,
            lc60: 100,
            lc45: 100,
            lc30: 69.5,
            lc10: 35
        },
        "green.400": {
            contrast: 36.11097605209553,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 39.5
        },
        "green.500": {
            contrast: 32.55203189478887,
            lc60: 100,
            lc45: 100,
            lc30: 90.5,
            lc10: 45.5
        },
        "green.600": {
            contrast: 27.79086409991106,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54
        },
        "green.700": {
            contrast: 22.684710675313553,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67
        },
        "green.800": {
            contrast: 17.623959959664433,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86.5
        },
        "green.900": {
            contrast: 12.704349077966615,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1000": {
            contrast: 7.974438920971948,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1400": {
            contrast: 9.366505646080434,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1500": {
            contrast: 13.960340462036147,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1600": {
            contrast: 18.748517981942225,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81
        },
        "green.1700": {
            contrast: 24.185833203448162,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65
        },
        "green.1800": {
            contrast: 29.788066359629717,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54.5
        },
        "green.1900": {
            contrast: 35.14371343854373,
            lc60: 100,
            lc45: 100,
            lc30: 87.5,
            lc10: 47.5
        },
        "green.2000": {
            contrast: 40.52548705031316,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 42
        },
        "green.2100": {
            contrast: 46.33534904160286,
            lc60: 100,
            lc45: 97.5,
            lc30: 69.5,
            lc10: 38
        },
        "green.2200": {
            contrast: 52.08646420834439,
            lc60: 100,
            lc45: 88.5,
            lc30: 63.5,
            lc10: 35
        },
        "green.2300": {
            contrast: 57.72748467907937,
            lc60: 100,
            lc45: 81.5,
            lc30: 58.5,
            lc10: 32
        },
        "green.2400": {
            contrast: 63.36508834695186,
            lc60: 95.5,
            lc45: 76,
            lc30: 55,
            lc10: 31
        },
        "green.2500": {
            contrast: 68.53334203688286,
            lc60: 90,
            lc45: 72,
            lc30: 52.5,
            lc10: 30
        }
    },
    "green.1300": {
        "green.100": {
            contrast: 46.626313068761974,
            lc60: 100,
            lc45: 83,
            lc30: 48.5,
            lc10: 24
        },
        "green.200": {
            contrast: 46.064334351330785,
            lc60: 100,
            lc45: 92.5,
            lc30: 53.5,
            lc10: 27
        },
        "green.300": {
            contrast: 44.26147561075753,
            lc60: 100,
            lc45: 100,
            lc30: 60,
            lc10: 30
        },
        "green.400": {
            contrast: 41.711721341602676,
            lc60: 100,
            lc45: 100,
            lc30: 67,
            lc10: 33.5
        },
        "green.500": {
            contrast: 38.15277718429602,
            lc60: 100,
            lc45: 100,
            lc30: 75.5,
            lc10: 38
        },
        "green.600": {
            contrast: 33.39160938941821,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 44.5
        },
        "green.700": {
            contrast: 28.2854559648207,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53
        },
        "green.800": {
            contrast: 23.22470524917158,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65
        },
        "green.900": {
            contrast: 18.305094367473764,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82.5
        },
        "green.1000": {
            contrast: 13.5751842104791,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1100": {
            contrast: 8.682309228712569,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1500": {
            contrast: 8.234146936597506,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1600": {
            contrast: 13.022324456503586,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1700": {
            contrast: 18.459639678009523,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83.5
        },
        "green.1800": {
            contrast: 24.06187283419108,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67
        },
        "green.1900": {
            contrast: 29.41751991310509,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56
        },
        "green.2000": {
            contrast: 34.79929352487452,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 49
        },
        "green.2100": {
            contrast: 40.60915551616422,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 43.5
        },
        "green.2200": {
            contrast: 46.36027068290575,
            lc60: 100,
            lc45: 97.5,
            lc30: 70,
            lc10: 38.5
        },
        "green.2300": {
            contrast: 52.00129115364073,
            lc60: 100,
            lc45: 88.5,
            lc30: 64.5,
            lc10: 36
        },
        "green.2400": {
            contrast: 57.63889482151322,
            lc60: 100,
            lc45: 82.5,
            lc30: 60,
            lc10: 33.5
        },
        "green.2500": {
            contrast: 62.807148511444225,
            lc60: 96.5,
            lc45: 77.5,
            lc30: 56.5,
            lc10: 32.5
        }
    },
    "green.1400": {
        "green.100": {
            contrast: 50.898483623972304,
            lc60: 100,
            lc45: 70,
            lc30: 44,
            lc10: 22
        },
        "green.200": {
            contrast: 50.336504906541116,
            lc60: 100,
            lc45: 78,
            lc30: 49,
            lc10: 24.5
        },
        "green.300": {
            contrast: 48.53364616596786,
            lc60: 100,
            lc45: 87,
            lc30: 54.5,
            lc10: 27.5
        },
        "green.400": {
            contrast: 45.983891896813006,
            lc60: 100,
            lc45: 96.5,
            lc30: 60.5,
            lc10: 30.5
        },
        "green.500": {
            contrast: 42.42494773950635,
            lc60: 100,
            lc45: 100,
            lc30: 67,
            lc10: 34
        },
        "green.600": {
            contrast: 37.66377994462854,
            lc60: 100,
            lc45: 100,
            lc30: 77.5,
            lc10: 39.5
        },
        "green.700": {
            contrast: 32.55762652003103,
            lc60: 100,
            lc45: 100,
            lc30: 91,
            lc10: 46
        },
        "green.800": {
            contrast: 27.496875804381908,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "green.900": {
            contrast: 22.577264922684094,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "green.1000": {
            contrast: 17.847354765689428,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85
        },
        "green.1100": {
            contrast: 12.954479783922897,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1200": {
            contrast: 7.906244094606428,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1600": {
            contrast: 8.589927363441449,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1700": {
            contrast: 14.027242584947386,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1800": {
            contrast: 19.629475741128942,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77.5
        },
        "green.1900": {
            contrast: 24.985122820042957,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "green.2000": {
            contrast: 30.366896431812386,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 53.5
        },
        "green.2100": {
            contrast: 36.17675842310208,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 46.5
        },
        "green.2200": {
            contrast: 41.927873589843614,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 40.5
        },
        "green.2300": {
            contrast: 47.56889406057859,
            lc60: 100,
            lc45: 95,
            lc30: 68,
            lc10: 37.5
        },
        "green.2400": {
            contrast: 53.20649772845108,
            lc60: 100,
            lc45: 87,
            lc30: 62,
            lc10: 35
        },
        "green.2500": {
            contrast: 58.37475141838209,
            lc60: 100,
            lc45: 81,
            lc30: 59,
            lc10: 33.5
        }
    },
    "green.1500": {
        "green.100": {
            contrast: 55.33477703583771,
            lc60: 100,
            lc45: 63.5,
            lc30: 40.5,
            lc10: 20.5
        },
        "green.200": {
            contrast: 54.772798318406515,
            lc60: 100,
            lc45: 70.5,
            lc30: 44.5,
            lc10: 22.5
        },
        "green.300": {
            contrast: 52.96993957783326,
            lc60: 100,
            lc45: 77.5,
            lc30: 49.5,
            lc10: 25
        },
        "green.400": {
            contrast: 50.42018530867841,
            lc60: 100,
            lc45: 85.5,
            lc30: 54.5,
            lc10: 27.5
        },
        "green.500": {
            contrast: 46.86124115137175,
            lc60: 100,
            lc45: 95.5,
            lc30: 60.5,
            lc10: 31
        },
        "green.600": {
            contrast: 42.100073356493944,
            lc60: 100,
            lc45: 100,
            lc30: 69,
            lc10: 35
        },
        "green.700": {
            contrast: 36.99391993189643,
            lc60: 100,
            lc45: 100,
            lc30: 79,
            lc10: 39.5
        },
        "green.800": {
            contrast: 31.933169216247308,
            lc60: 100,
            lc45: 100,
            lc30: 93,
            lc10: 46.5
        },
        "green.900": {
            contrast: 27.013558334549494,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "green.1000": {
            contrast: 22.28364817755483,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "green.1100": {
            contrast: 17.3907731957883,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87
        },
        "green.1200": {
            contrast: 12.342537506471828,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1700": {
            contrast: 9.369520308151529,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1800": {
            contrast: 14.971753464333087,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1900": {
            contrast: 20.327400543247098,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75.5
        },
        "green.2000": {
            contrast: 25.709174155016523,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61.5
        },
        "green.2100": {
            contrast: 31.519036146306224,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 52.5
        },
        "green.2200": {
            contrast: 37.270151313047755,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 45
        },
        "green.2300": {
            contrast: 42.911171783782734,
            lc60: 100,
            lc45: 100,
            lc30: 73,
            lc10: 40
        },
        "green.2400": {
            contrast: 48.548775451655224,
            lc60: 100,
            lc45: 93.5,
            lc30: 67,
            lc10: 36.5
        },
        "green.2500": {
            contrast: 53.717029141586224,
            lc60: 100,
            lc45: 86.5,
            lc30: 62.5,
            lc10: 35.5
        }
    },
    "green.1600": {
        "green.100": {
            contrast: 59.92356095479333,
            lc60: 100,
            lc45: 58.5,
            lc30: 37.5,
            lc10: 19
        },
        "green.200": {
            contrast: 59.36158223736213,
            lc60: 100,
            lc45: 64,
            lc30: 41.5,
            lc10: 21
        },
        "green.300": {
            contrast: 57.55872349678888,
            lc60: 100,
            lc45: 70,
            lc30: 45.5,
            lc10: 23
        },
        "green.400": {
            contrast: 55.00896922763402,
            lc60: 100,
            lc45: 77,
            lc30: 49,
            lc10: 25.5
        },
        "green.500": {
            contrast: 51.450025070327364,
            lc60: 100,
            lc45: 85,
            lc30: 54.5,
            lc10: 28
        },
        "green.600": {
            contrast: 46.68885727544956,
            lc60: 100,
            lc45: 95,
            lc30: 61,
            lc10: 30.5
        },
        "green.700": {
            contrast: 41.58270385085204,
            lc60: 100,
            lc45: 100,
            lc30: 70,
            lc10: 35
        },
        "green.800": {
            contrast: 36.52195313520292,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 41
        },
        "green.900": {
            contrast: 31.60234225350511,
            lc60: 100,
            lc45: 100,
            lc30: 94,
            lc10: 48
        },
        "green.1000": {
            contrast: 26.87243209651044,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "green.1100": {
            contrast: 21.979557114743915,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "green.1200": {
            contrast: 16.931321425427445,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88.5
        },
        "green.1300": {
            contrast: 11.31037665561974,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1800": {
            contrast: 10.098408436608056,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1900": {
            contrast: 15.454055515522066,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98
        },
        "green.2000": {
            contrast: 20.835829127291497,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74
        },
        "green.2100": {
            contrast: 26.645691118581194,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60.5
        },
        "green.2200": {
            contrast: 32.39680628532272,
            lc60: 100,
            lc45: 100,
            lc30: 93,
            lc10: 50.5
        },
        "green.2300": {
            contrast: 38.0378267560577,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 44.5
        },
        "green.2400": {
            contrast: 43.675430423930194,
            lc60: 100,
            lc45: 100,
            lc30: 73,
            lc10: 40.5
        },
        "green.2500": {
            contrast: 48.843684113861194,
            lc60: 100,
            lc45: 93.5,
            lc30: 67,
            lc10: 37
        }
    },
    "green.1700": {
        "green.100": {
            contrast: 65.094547924645,
            lc60: 76.5,
            lc45: 53,
            lc30: 34.5,
            lc10: 17.5
        },
        "green.200": {
            contrast: 64.5325692072138,
            lc60: 83.5,
            lc45: 58.5,
            lc30: 38,
            lc10: 19.5
        },
        "green.300": {
            contrast: 62.729710466640555,
            lc60: 91.5,
            lc45: 64,
            lc30: 41,
            lc10: 21
        },
        "green.400": {
            contrast: 60.17995619748569,
            lc60: 99.5,
            lc45: 69,
            lc30: 44.5,
            lc10: 23
        },
        "green.500": {
            contrast: 56.62101204017904,
            lc60: 100,
            lc45: 75.5,
            lc30: 49,
            lc10: 25.5
        },
        "green.600": {
            contrast: 51.859844245301225,
            lc60: 100,
            lc45: 84.5,
            lc30: 55,
            lc10: 27.5
        },
        "green.700": {
            contrast: 46.75369082070372,
            lc60: 100,
            lc45: 96,
            lc30: 61.5,
            lc10: 31
        },
        "green.800": {
            contrast: 41.692940105054596,
            lc60: 100,
            lc45: 100,
            lc30: 70,
            lc10: 35.5
        },
        "green.900": {
            contrast: 36.77332922335678,
            lc60: 100,
            lc45: 100,
            lc30: 80.5,
            lc10: 41
        },
        "green.1000": {
            contrast: 32.04341906636211,
            lc60: 100,
            lc45: 100,
            lc30: 92.5,
            lc10: 46.5
        },
        "green.1100": {
            contrast: 27.150544084595584,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "green.1200": {
            contrast: 22.102308395279117,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "green.1300": {
            contrast: 16.48136362547141,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 90.5
        },
        "green.1400": {
            contrast: 12.186789321663008,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1500": {
            contrast: 7.721336414894712,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1900": {
            contrast: 9.898714533619705,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2000": {
            contrast: 15.280488145389134,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98
        },
        "green.2100": {
            contrast: 21.090350136678833,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73
        },
        "green.2200": {
            contrast: 26.84146530342036,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60.5
        },
        "green.2300": {
            contrast: 32.482485774155336,
            lc60: 100,
            lc45: 100,
            lc30: 93,
            lc10: 52
        },
        "green.2400": {
            contrast: 38.12008944202783,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 44.5
        },
        "green.2500": {
            contrast: 43.28834313195883,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 41.5
        }
    },
    "green.1800": {
        "green.100": {
            contrast: 70.38165981613783,
            lc60: 69,
            lc45: 49.5,
            lc30: 32,
            lc10: 16.5
        },
        "green.200": {
            contrast: 69.81968109870664,
            lc60: 74.5,
            lc45: 53.5,
            lc30: 35,
            lc10: 18
        },
        "green.300": {
            contrast: 68.01682235813338,
            lc60: 81,
            lc45: 58,
            lc30: 37.5,
            lc10: 19.5
        },
        "green.400": {
            contrast: 65.46706808897852,
            lc60: 88,
            lc45: 62.5,
            lc30: 41,
            lc10: 21
        },
        "green.500": {
            contrast: 61.908123931671874,
            lc60: 95.5,
            lc45: 68,
            lc30: 44.5,
            lc10: 23
        },
        "green.600": {
            contrast: 57.14695613679407,
            lc60: 100,
            lc45: 75.5,
            lc30: 48.5,
            lc10: 25.5
        },
        "green.700": {
            contrast: 52.04080271219655,
            lc60: 100,
            lc45: 84,
            lc30: 54.5,
            lc10: 28
        },
        "green.800": {
            contrast: 46.98005199654743,
            lc60: 100,
            lc45: 94.5,
            lc30: 61.5,
            lc10: 31.5
        },
        "green.900": {
            contrast: 42.06044111484962,
            lc60: 100,
            lc45: 100,
            lc30: 69,
            lc10: 35.5
        },
        "green.1000": {
            contrast: 37.330530957854954,
            lc60: 100,
            lc45: 100,
            lc30: 79,
            lc10: 39.5
        },
        "green.1100": {
            contrast: 32.43765597608842,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 46.5
        },
        "green.1200": {
            contrast: 27.389420286771948,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "green.1300": {
            contrast: 21.768475516964248,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "green.1400": {
            contrast: 17.473901213155845,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85.5
        },
        "green.1500": {
            contrast: 13.008448306387551,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1600": {
            contrast: 8.383618124643718,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2000": {
            contrast: 9.534653616047915,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2100": {
            contrast: 15.344515607337614,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 97.5
        },
        "green.2200": {
            contrast: 21.095630774079144,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73
        },
        "green.2300": {
            contrast: 26.73665124481412,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60.5
        },
        "green.2400": {
            contrast: 32.37425491268661,
            lc60: 100,
            lc45: 100,
            lc30: 93.5,
            lc10: 52.5
        },
        "green.2500": {
            contrast: 37.542508602617616,
            lc60: 100,
            lc45: 100,
            lc30: 83.5,
            lc10: 47
        }
    },
    "green.1900": {
        "green.100": {
            contrast: 75.4004968954039,
            lc60: 63.5,
            lc45: 46,
            lc30: 30,
            lc10: 15.5
        },
        "green.200": {
            contrast: 74.8385181779727,
            lc60: 69,
            lc45: 49.5,
            lc30: 32.5,
            lc10: 16.5
        },
        "green.300": {
            contrast: 73.03565943739945,
            lc60: 74,
            lc45: 53.5,
            lc30: 35,
            lc10: 18
        },
        "green.400": {
            contrast: 70.48590516824459,
            lc60: 80,
            lc45: 57.5,
            lc30: 37.5,
            lc10: 19.5
        },
        "green.500": {
            contrast: 66.92696101093793,
            lc60: 86.5,
            lc45: 62.5,
            lc30: 41,
            lc10: 21
        },
        "green.600": {
            contrast: 62.16579321606013,
            lc60: 95.5,
            lc45: 68,
            lc30: 45,
            lc10: 23
        },
        "green.700": {
            contrast: 57.05963979146262,
            lc60: 100,
            lc45: 76,
            lc30: 49.5,
            lc10: 25
        },
        "green.800": {
            contrast: 51.998889075813494,
            lc60: 100,
            lc45: 84.5,
            lc30: 55.5,
            lc10: 28
        },
        "green.900": {
            contrast: 47.07927819411568,
            lc60: 100,
            lc45: 94.5,
            lc30: 61,
            lc10: 31.5
        },
        "green.1000": {
            contrast: 42.34936803712102,
            lc60: 100,
            lc45: 100,
            lc30: 69,
            lc10: 34.5
        },
        "green.1100": {
            contrast: 37.456493055354485,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 40
        },
        "green.1200": {
            contrast: 32.408257366038015,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 46.5
        },
        "green.1300": {
            contrast: 26.787312596230308,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56
        },
        "green.1400": {
            contrast: 22.492738292421908,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67
        },
        "green.1500": {
            contrast: 18.027285385653613,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83.5
        },
        "green.1600": {
            contrast: 13.402455203909783,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1700": {
            contrast: 8.184167526094559,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2100": {
            contrast: 9.832165243954776,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2200": {
            contrast: 15.583280410696307,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 97.5
        },
        "green.2300": {
            contrast: 21.224300881431287,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "green.2400": {
            contrast: 26.861904549303777,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62
        },
        "green.2500": {
            contrast: 32.03015823923478,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 54
        }
    },
    "green.2000": {
        "green.100": {
            contrast: 80.41139510306854,
            lc60: 59,
            lc45: 43,
            lc30: 28,
            lc10: 14.5
        },
        "green.200": {
            contrast: 79.84941638563734,
            lc60: 63.5,
            lc45: 46,
            lc30: 30.5,
            lc10: 16
        },
        "green.300": {
            contrast: 78.04655764506407,
            lc60: 68.5,
            lc45: 49.5,
            lc30: 33,
            lc10: 16.5
        },
        "green.400": {
            contrast: 75.49680337590922,
            lc60: 73.5,
            lc45: 53.5,
            lc30: 35,
            lc10: 18
        },
        "green.500": {
            contrast: 71.93785921860257,
            lc60: 79.5,
            lc45: 57,
            lc30: 37.5,
            lc10: 19.5
        },
        "green.600": {
            contrast: 67.17669142372476,
            lc60: 86.5,
            lc45: 62.5,
            lc30: 40.5,
            lc10: 21.5
        },
        "green.700": {
            contrast: 62.070537999127254,
            lc60: 96,
            lc45: 68.5,
            lc30: 45,
            lc10: 23
        },
        "green.800": {
            contrast: 57.00978728347813,
            lc60: 100,
            lc45: 76.5,
            lc30: 49.5,
            lc10: 25.5
        },
        "green.900": {
            contrast: 52.09017640178032,
            lc60: 100,
            lc45: 84.5,
            lc30: 55,
            lc10: 28.5
        },
        "green.1000": {
            contrast: 47.360266244785656,
            lc60: 100,
            lc45: 94.5,
            lc30: 60.5,
            lc10: 31
        },
        "green.1100": {
            contrast: 42.467391263019124,
            lc60: 100,
            lc45: 100,
            lc30: 69,
            lc10: 35
        },
        "green.1200": {
            contrast: 37.41915557370265,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 39.5
        },
        "green.1300": {
            contrast: 31.798210803894943,
            lc60: 100,
            lc45: 100,
            lc30: 94.5,
            lc10: 46
        },
        "green.1400": {
            contrast: 27.503636500086543,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "green.1500": {
            contrast: 23.038183593318248,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "green.1600": {
            contrast: 18.41335341157442,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82
        },
        "green.1700": {
            contrast: 13.195065733759195,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1800": {
            contrast: 7.852764673802079,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2200": {
            contrast: 10.026148398370468,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2300": {
            contrast: 15.667168869105444,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 97
        },
        "green.2400": {
            contrast: 21.30477253697794,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75.5
        },
        "green.2500": {
            contrast: 26.473026226908935,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63
        }
    },
    "green.2100": {
        "green.100": {
            contrast: 85.7869543288261,
            lc60: 55,
            lc45: 40,
            lc30: 26.5,
            lc10: 13.5
        },
        "green.200": {
            contrast: 85.2249756113949,
            lc60: 59,
            lc45: 43,
            lc30: 28.5,
            lc10: 15
        },
        "green.300": {
            contrast: 83.42211687082163,
            lc60: 63,
            lc45: 46,
            lc30: 30.5,
            lc10: 15.5
        },
        "green.400": {
            contrast: 80.87236260166678,
            lc60: 67.5,
            lc45: 49,
            lc30: 32.5,
            lc10: 16.5
        },
        "green.500": {
            contrast: 77.31341844436012,
            lc60: 72.5,
            lc45: 53,
            lc30: 35,
            lc10: 18
        },
        "green.600": {
            contrast: 72.55225064948232,
            lc60: 78.5,
            lc45: 57,
            lc30: 37.5,
            lc10: 19.5
        },
        "green.700": {
            contrast: 67.44609722488481,
            lc60: 86.5,
            lc45: 62.5,
            lc30: 40.5,
            lc10: 21
        },
        "green.800": {
            contrast: 62.38534650923568,
            lc60: 95,
            lc45: 68.5,
            lc30: 45,
            lc10: 23.5
        },
        "green.900": {
            contrast: 57.46573562753788,
            lc60: 100,
            lc45: 75.5,
            lc30: 49,
            lc10: 25
        },
        "green.1000": {
            contrast: 52.735825470543205,
            lc60: 100,
            lc45: 83,
            lc30: 53.5,
            lc10: 27.5
        },
        "green.1100": {
            contrast: 47.84295048877668,
            lc60: 100,
            lc45: 93,
            lc30: 60,
            lc10: 30.5
        },
        "green.1200": {
            contrast: 42.7947147994602,
            lc60: 100,
            lc45: 100,
            lc30: 67.5,
            lc10: 34.5
        },
        "green.1300": {
            contrast: 37.1737700296525,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 39.5
        },
        "green.1400": {
            contrast: 32.8791957258441,
            lc60: 100,
            lc45: 100,
            lc30: 91,
            lc10: 45.5
        },
        "green.1500": {
            contrast: 28.413742819075804,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54
        },
        "green.1600": {
            contrast: 23.788912637331975,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "green.1700": {
            contrast: 18.570624959516753,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81
        },
        "green.1800": {
            contrast: 13.228323899559635,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1900": {
            contrast: 8.151126911833156,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2300": {
            contrast: 9.649098275988903,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2400": {
            contrast: 15.286701943861397,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 97
        },
        "green.2500": {
            contrast: 20.454955633792398,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78
        }
    },
    "green.2200": {
        "green.100": {
            contrast: 91.0758022454034,
            lc60: 52,
            lc45: 37.5,
            lc30: 25,
            lc10: 13
        },
        "green.200": {
            contrast: 90.5138235279722,
            lc60: 55,
            lc45: 40.5,
            lc30: 26.5,
            lc10: 14
        },
        "green.300": {
            contrast: 88.71096478739892,
            lc60: 58.5,
            lc45: 43,
            lc30: 28.5,
            lc10: 15
        },
        "green.400": {
            contrast: 86.16121051824408,
            lc60: 62.5,
            lc45: 45.5,
            lc30: 30,
            lc10: 15.5
        },
        "green.500": {
            contrast: 82.60226636093743,
            lc60: 67,
            lc45: 48.5,
            lc30: 32.5,
            lc10: 17
        },
        "green.600": {
            contrast: 77.84109856605961,
            lc60: 72.5,
            lc45: 52.5,
            lc30: 35,
            lc10: 18.5
        },
        "green.700": {
            contrast: 72.7349451414621,
            lc60: 79,
            lc45: 57,
            lc30: 37.5,
            lc10: 19.5
        },
        "green.800": {
            contrast: 67.674194425813,
            lc60: 86,
            lc45: 62.5,
            lc30: 41,
            lc10: 21.5
        },
        "green.900": {
            contrast: 62.754583544115185,
            lc60: 94.5,
            lc45: 68,
            lc30: 44.5,
            lc10: 23
        },
        "green.1000": {
            contrast: 58.02467338712051,
            lc60: 100,
            lc45: 74.5,
            lc30: 48.5,
            lc10: 25
        },
        "green.1100": {
            contrast: 53.13179840535398,
            lc60: 100,
            lc45: 82,
            lc30: 53,
            lc10: 27
        },
        "green.1200": {
            contrast: 48.083562716037505,
            lc60: 100,
            lc45: 92.5,
            lc30: 59,
            lc10: 30.5
        },
        "green.1300": {
            contrast: 42.462617946229805,
            lc60: 100,
            lc45: 100,
            lc30: 67.5,
            lc10: 34
        },
        "green.1400": {
            contrast: 38.1680436424214,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 39
        },
        "green.1500": {
            contrast: 33.70259073565311,
            lc60: 100,
            lc45: 100,
            lc30: 87.5,
            lc10: 45
        },
        "green.1600": {
            contrast: 29.077760553909275,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 52.5
        },
        "green.1700": {
            contrast: 23.859472876094053,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "green.1800": {
            contrast: 18.517171816136937,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82.5
        },
        "green.1900": {
            contrast: 13.439974828410458,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2000": {
            contrast: 8.365356996907144,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2400": {
            contrast: 9.311289841035693,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2500": {
            contrast: 14.479543530966692,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "green.2300": {
        "green.100": {
            contrast: 96.23414575538301,
            lc60: 49,
            lc45: 35.5,
            lc30: 24,
            lc10: 12.5
        },
        "green.200": {
            contrast: 95.67216703795182,
            lc60: 51.5,
            lc45: 38,
            lc30: 25,
            lc10: 13
        },
        "green.300": {
            contrast: 93.86930829737857,
            lc60: 55,
            lc45: 40.5,
            lc30: 26.5,
            lc10: 14
        },
        "green.400": {
            contrast: 91.3195540282237,
            lc60: 58.5,
            lc45: 42.5,
            lc30: 28.5,
            lc10: 14.5
        },
        "green.500": {
            contrast: 87.76060987091707,
            lc60: 62,
            lc45: 45.5,
            lc30: 30,
            lc10: 16
        },
        "green.600": {
            contrast: 82.99944207603926,
            lc60: 67,
            lc45: 48.5,
            lc30: 32,
            lc10: 16.5
        },
        "green.700": {
            contrast: 77.89328865144172,
            lc60: 72,
            lc45: 52.5,
            lc30: 35,
            lc10: 18
        },
        "green.800": {
            contrast: 72.83253793579262,
            lc60: 78,
            lc45: 57,
            lc30: 38,
            lc10: 19.5
        },
        "green.900": {
            contrast: 67.91292705409481,
            lc60: 85,
            lc45: 62,
            lc30: 40.5,
            lc10: 21
        },
        "green.1000": {
            contrast: 63.18301689710013,
            lc60: 93.5,
            lc45: 67,
            lc30: 44,
            lc10: 22.5
        },
        "green.1100": {
            contrast: 58.29014191533361,
            lc60: 100,
            lc45: 73.5,
            lc30: 47.5,
            lc10: 24
        },
        "green.1200": {
            contrast: 53.241906226017136,
            lc60: 100,
            lc45: 81.5,
            lc30: 53,
            lc10: 27
        },
        "green.1300": {
            contrast: 47.62096145620943,
            lc60: 100,
            lc45: 93,
            lc30: 58.5,
            lc10: 30
        },
        "green.1400": {
            contrast: 43.326387152401026,
            lc60: 100,
            lc45: 100,
            lc30: 67,
            lc10: 34
        },
        "green.1500": {
            contrast: 38.860934245632734,
            lc60: 100,
            lc45: 100,
            lc30: 75,
            lc10: 38.5
        },
        "green.1600": {
            contrast: 34.2361040638889,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 44.5
        },
        "green.1700": {
            contrast: 29.017816386073676,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 52
        },
        "green.1800": {
            contrast: 23.67551532611656,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63.5
        },
        "green.1900": {
            contrast: 18.598318338390087,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80
        },
        "green.2000": {
            contrast: 13.523700506886769,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2100": {
            contrast: 8.07407327730191,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2500": {
            contrast: 8.601921953002076,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "green.2400": {
        "green.100": {
            contrast: 101.36215905381283,
            lc60: 46,
            lc45: 34,
            lc30: 22.5,
            lc10: 11.5
        },
        "green.200": {
            contrast: 100.80018033638163,
            lc60: 49,
            lc45: 36,
            lc30: 24,
            lc10: 12.5
        },
        "green.300": {
            contrast: 98.99732159580836,
            lc60: 51.5,
            lc45: 38,
            lc30: 25.5,
            lc10: 13
        },
        "green.400": {
            contrast: 96.4475673266535,
            lc60: 54.5,
            lc45: 40,
            lc30: 26.5,
            lc10: 14
        },
        "green.500": {
            contrast: 92.88862316934686,
            lc60: 58,
            lc45: 42.5,
            lc30: 28,
            lc10: 15
        },
        "green.600": {
            contrast: 88.12745537446904,
            lc60: 62,
            lc45: 45.5,
            lc30: 30,
            lc10: 16
        },
        "green.700": {
            contrast: 83.02130194987153,
            lc60: 66.5,
            lc45: 48.5,
            lc30: 32,
            lc10: 16.5
        },
        "green.800": {
            contrast: 77.96055123422241,
            lc60: 72,
            lc45: 52.5,
            lc30: 34.5,
            lc10: 18
        },
        "green.900": {
            contrast: 73.0409403525246,
            lc60: 77.5,
            lc45: 56,
            lc30: 37,
            lc10: 19
        },
        "green.1000": {
            contrast: 68.31103019552992,
            lc60: 84.5,
            lc45: 60.5,
            lc30: 39.5,
            lc10: 20.5
        },
        "green.1100": {
            contrast: 63.41815521376339,
            lc60: 93,
            lc45: 65.5,
            lc30: 43,
            lc10: 22.5
        },
        "green.1200": {
            contrast: 58.36991952444692,
            lc60: 100,
            lc45: 72.5,
            lc30: 47,
            lc10: 24.5
        },
        "green.1300": {
            contrast: 52.74897475463922,
            lc60: 100,
            lc45: 82,
            lc30: 52,
            lc10: 26.5
        },
        "green.1400": {
            contrast: 48.454400450830825,
            lc60: 100,
            lc45: 91.5,
            lc30: 58,
            lc10: 30
        },
        "green.1500": {
            contrast: 43.988947544062526,
            lc60: 100,
            lc45: 100,
            lc30: 65.5,
            lc10: 33.5
        },
        "green.1600": {
            contrast: 39.364117362318694,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 37.5
        },
        "green.1700": {
            contrast: 34.14582968450347,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 43.5
        },
        "green.1800": {
            contrast: 28.803528624546352,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51.5
        },
        "green.1900": {
            contrast: 23.72633163681988,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "green.2000": {
            contrast: 18.651713805316565,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80
        },
        "green.2100": {
            contrast: 13.202086575731704,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2200": {
            contrast: 7.8349121706460485,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "green.2500": {
        "green.100": {
            contrast: 106.04067321268862,
            lc60: 44,
            lc45: 32.5,
            lc30: 21.5,
            lc10: 11.5
        },
        "green.200": {
            contrast: 105.47869449525741,
            lc60: 46.5,
            lc45: 34,
            lc30: 23,
            lc10: 12
        },
        "green.300": {
            contrast: 103.67583575468416,
            lc60: 49,
            lc45: 36,
            lc30: 24,
            lc10: 12.5
        },
        "green.400": {
            contrast: 101.12608148552931,
            lc60: 51.5,
            lc45: 38,
            lc30: 25,
            lc10: 13.5
        },
        "green.500": {
            contrast: 97.56713732822263,
            lc60: 54.5,
            lc45: 40,
            lc30: 26.5,
            lc10: 14
        },
        "green.600": {
            contrast: 92.80596953334484,
            lc60: 58,
            lc45: 42.5,
            lc30: 28,
            lc10: 14.5
        },
        "green.700": {
            contrast: 87.69981610874731,
            lc60: 62,
            lc45: 45.5,
            lc30: 30,
            lc10: 16
        },
        "green.800": {
            contrast: 82.63906539309819,
            lc60: 66.5,
            lc45: 48.5,
            lc30: 32.5,
            lc10: 17
        },
        "green.900": {
            contrast: 77.71945451140037,
            lc60: 71.5,
            lc45: 51.5,
            lc30: 34,
            lc10: 18
        },
        "green.1000": {
            contrast: 72.98954435440572,
            lc60: 77,
            lc45: 55,
            lc30: 36.5,
            lc10: 18.5
        },
        "green.1100": {
            contrast: 68.09666937263918,
            lc60: 84,
            lc45: 60,
            lc30: 39,
            lc10: 20
        },
        "green.1200": {
            contrast: 63.04843368332271,
            lc60: 93.5,
            lc45: 65.5,
            lc30: 42.5,
            lc10: 21.5
        },
        "green.1300": {
            contrast: 57.42748891351501,
            lc60: 100,
            lc45: 72.5,
            lc30: 46,
            lc10: 23.5
        },
        "green.1400": {
            contrast: 53.1329146097066,
            lc60: 100,
            lc45: 81,
            lc30: 51.5,
            lc10: 26
        },
        "green.1500": {
            contrast: 48.66746170293831,
            lc60: 100,
            lc45: 90.5,
            lc30: 57,
            lc10: 29.5
        },
        "green.1600": {
            contrast: 44.04263152119448,
            lc60: 100,
            lc45: 100,
            lc30: 64,
            lc10: 32.5
        },
        "green.1700": {
            contrast: 38.82434384337925,
            lc60: 100,
            lc45: 100,
            lc30: 75,
            lc10: 37.5
        },
        "green.1800": {
            contrast: 33.48204278342214,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 43.5
        },
        "green.1900": {
            contrast: 28.40484579569566,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 52
        },
        "green.2000": {
            contrast: 23.33022796419235,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63
        },
        "green.2100": {
            contrast: 17.880600734607487,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83
        },
        "green.2200": {
            contrast: 12.513426329521835,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    }
};
const $f8fd43f1ee3f8cd8$var$marigold = {
    "marigold.100": {
        "marigold.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.600": {
            contrast: 8.31173919905272,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.700": {
            contrast: 12.249290357639028,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.800": {
            contrast: 16.850597778297637,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 94.5
        },
        "marigold.900": {
            contrast: 21.239794632782882,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84
        },
        "marigold.1000": {
            contrast: 25.469335012469536,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76
        },
        "marigold.1100": {
            contrast: 29.984389748738426,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "marigold.1200": {
            contrast: 34.69349350296007,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 64
        },
        "marigold.1300": {
            contrast: 39.59015208938245,
            lc60: 100,
            lc45: 100,
            lc30: 85,
            lc10: 59
        },
        "marigold.1400": {
            contrast: 44.1237579629117,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 55.5
        },
        "marigold.1500": {
            contrast: 49.06497859262817,
            lc60: 100,
            lc45: 95,
            lc30: 75,
            lc10: 52
        },
        "marigold.1600": {
            contrast: 53.771616286078284,
            lc60: 100,
            lc45: 89.5,
            lc30: 71,
            lc10: 49.5
        },
        "marigold.1700": {
            contrast: 58.71201126305032,
            lc60: 100,
            lc45: 85,
            lc30: 67,
            lc10: 47
        },
        "marigold.1800": {
            contrast: 65.4196142981686,
            lc60: 94.5,
            lc45: 79.5,
            lc30: 63,
            lc10: 44
        },
        "marigold.1900": {
            contrast: 69.9792972944084,
            lc60: 90.5,
            lc45: 76,
            lc30: 60.5,
            lc10: 42
        },
        "marigold.2000": {
            contrast: 76.10305974263872,
            lc60: 86,
            lc45: 72.5,
            lc30: 57,
            lc10: 39.5
        },
        "marigold.2100": {
            contrast: 82.18449988388986,
            lc60: 82,
            lc45: 69,
            lc30: 54.5,
            lc10: 38
        },
        "marigold.2200": {
            contrast: 88.4288225801912,
            lc60: 78.5,
            lc45: 66,
            lc30: 52,
            lc10: 36
        },
        "marigold.2300": {
            contrast: 94.90500952190216,
            lc60: 75,
            lc45: 63,
            lc30: 50,
            lc10: 34.5
        },
        "marigold.2400": {
            contrast: 101.52379614543689,
            lc60: 72,
            lc45: 60.5,
            lc30: 47.5,
            lc10: 33
        },
        "marigold.2500": {
            contrast: 107.88473318309848,
            lc60: 69,
            lc45: 58,
            lc30: 46,
            lc10: 32
        }
    },
    "marigold.200": {
        "marigold.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.600": {
            contrast: 7.984669838744956,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.700": {
            contrast: 11.922220997331264,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.800": {
            contrast: 16.523528417989873,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 94
        },
        "marigold.900": {
            contrast: 20.912725272475114,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82.5
        },
        "marigold.1000": {
            contrast: 25.142265652161772,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "marigold.1100": {
            contrast: 29.65732038843065,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66.5
        },
        "marigold.1200": {
            contrast: 34.3664241426523,
            lc60: 100,
            lc45: 100,
            lc30: 91.5,
            lc10: 60.5
        },
        "marigold.1300": {
            contrast: 39.26308272907469,
            lc60: 100,
            lc45: 100,
            lc30: 84,
            lc10: 55.5
        },
        "marigold.1400": {
            contrast: 43.796688602603936,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 51.5
        },
        "marigold.1500": {
            contrast: 48.7379092323204,
            lc60: 100,
            lc45: 94.5,
            lc30: 73,
            lc10: 48
        },
        "marigold.1600": {
            contrast: 53.44454692577052,
            lc60: 100,
            lc45: 89,
            lc30: 69,
            lc10: 45.5
        },
        "marigold.1700": {
            contrast: 58.38494190274256,
            lc60: 100,
            lc45: 84,
            lc30: 65,
            lc10: 43
        },
        "marigold.1800": {
            contrast: 65.09254493786084,
            lc60: 94.5,
            lc45: 78.5,
            lc30: 60.5,
            lc10: 40
        },
        "marigold.1900": {
            contrast: 69.65222793410064,
            lc60: 90.5,
            lc45: 74.5,
            lc30: 57.5,
            lc10: 38
        },
        "marigold.2000": {
            contrast: 75.77599038233096,
            lc60: 85.5,
            lc45: 70.5,
            lc30: 54.5,
            lc10: 36
        },
        "marigold.2100": {
            contrast: 81.85743052358208,
            lc60: 81.5,
            lc45: 67,
            lc30: 52,
            lc10: 34.5
        },
        "marigold.2200": {
            contrast: 88.10175321988342,
            lc60: 77,
            lc45: 64,
            lc30: 49.5,
            lc10: 32.5
        },
        "marigold.2300": {
            contrast: 94.5779401615944,
            lc60: 74,
            lc45: 61,
            lc30: 47.5,
            lc10: 31
        },
        "marigold.2400": {
            contrast: 101.19672678512912,
            lc60: 70.5,
            lc45: 58.5,
            lc30: 45.5,
            lc10: 30
        },
        "marigold.2500": {
            contrast: 107.5576638227907,
            lc60: 67.5,
            lc45: 56.5,
            lc30: 43.5,
            lc10: 29
        }
    },
    "marigold.300": {
        "marigold.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.700": {
            contrast: 10.784797913503352,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.800": {
            contrast: 15.38610533416196,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98
        },
        "marigold.900": {
            contrast: 19.775302188647203,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82.5
        },
        "marigold.1000": {
            contrast: 24.00484256833386,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73
        },
        "marigold.1100": {
            contrast: 28.519897304602747,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64.5
        },
        "marigold.1200": {
            contrast: 33.22900105882438,
            lc60: 100,
            lc45: 100,
            lc30: 93,
            lc10: 58
        },
        "marigold.1300": {
            contrast: 38.12565964524677,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 52.5
        },
        "marigold.1400": {
            contrast: 42.65926551877602,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 49
        },
        "marigold.1500": {
            contrast: 47.60048614849249,
            lc60: 100,
            lc45: 96,
            lc30: 72.5,
            lc10: 45
        },
        "marigold.1600": {
            contrast: 52.307123841942605,
            lc60: 100,
            lc45: 89.5,
            lc30: 68,
            lc10: 42
        },
        "marigold.1700": {
            contrast: 57.24751881891464,
            lc60: 100,
            lc45: 84.5,
            lc30: 63.5,
            lc10: 39.5
        },
        "marigold.1800": {
            contrast: 63.95512185403292,
            lc60: 95.5,
            lc45: 78,
            lc30: 58.5,
            lc10: 36.5
        },
        "marigold.1900": {
            contrast: 68.51480485027271,
            lc60: 91,
            lc45: 74.5,
            lc30: 56,
            lc10: 35.5
        },
        "marigold.2000": {
            contrast: 74.63856729850305,
            lc60: 85.5,
            lc45: 70,
            lc30: 52.5,
            lc10: 33
        },
        "marigold.2100": {
            contrast: 80.72000743975417,
            lc60: 81,
            lc45: 66.5,
            lc30: 50.5,
            lc10: 31.5
        },
        "marigold.2200": {
            contrast: 86.96433013605551,
            lc60: 77,
            lc45: 63,
            lc30: 47.5,
            lc10: 30
        },
        "marigold.2300": {
            contrast: 93.44051707776649,
            lc60: 73,
            lc45: 60,
            lc30: 45.5,
            lc10: 28.5
        },
        "marigold.2400": {
            contrast: 100.0593037013012,
            lc60: 70,
            lc45: 57,
            lc30: 43.5,
            lc10: 27.5
        },
        "marigold.2500": {
            contrast: 106.42024073896279,
            lc60: 67,
            lc45: 55,
            lc30: 41.5,
            lc10: 26.5
        }
    },
    "marigold.400": {
        "marigold.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.700": {
            contrast: 9.088367644302132,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.800": {
            contrast: 13.689675064960738,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.900": {
            contrast: 18.078871919445984,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87
        },
        "marigold.1000": {
            contrast: 22.308412299132637,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75
        },
        "marigold.1100": {
            contrast: 26.823467035401528,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65
        },
        "marigold.1200": {
            contrast: 31.532570789623165,
            lc60: 100,
            lc45: 100,
            lc30: 96,
            lc10: 57.5
        },
        "marigold.1300": {
            contrast: 36.429229376045555,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 51.5
        },
        "marigold.1400": {
            contrast: 40.962835249574795,
            lc60: 100,
            lc45: 100,
            lc30: 79,
            lc10: 47.5
        },
        "marigold.1500": {
            contrast: 45.90405587929127,
            lc60: 100,
            lc45: 98.5,
            lc30: 73,
            lc10: 43.5
        },
        "marigold.1600": {
            contrast: 50.61069357274138,
            lc60: 100,
            lc45: 91.5,
            lc30: 67.5,
            lc10: 40.5
        },
        "marigold.1700": {
            contrast: 55.55108854971343,
            lc60: 100,
            lc45: 85.5,
            lc30: 63,
            lc10: 38
        },
        "marigold.1800": {
            contrast: 62.258691584831695,
            lc60: 97,
            lc45: 78.5,
            lc30: 58,
            lc10: 35
        },
        "marigold.1900": {
            contrast: 66.8183745810715,
            lc60: 92,
            lc45: 74.5,
            lc30: 55,
            lc10: 33
        },
        "marigold.2000": {
            contrast: 72.94213702930182,
            lc60: 86.5,
            lc45: 70,
            lc30: 52,
            lc10: 31.5
        },
        "marigold.2100": {
            contrast: 79.02357717055295,
            lc60: 81.5,
            lc45: 66,
            lc30: 49,
            lc10: 29.5
        },
        "marigold.2200": {
            contrast: 85.2678998668543,
            lc60: 77.5,
            lc45: 62.5,
            lc30: 46.5,
            lc10: 28
        },
        "marigold.2300": {
            contrast: 91.74408680856526,
            lc60: 73.5,
            lc45: 59.5,
            lc30: 44.5,
            lc10: 27
        },
        "marigold.2400": {
            contrast: 98.36287343209999,
            lc60: 70,
            lc45: 56.5,
            lc30: 42,
            lc10: 25.5
        },
        "marigold.2500": {
            contrast: 104.72381046976157,
            lc60: 67,
            lc45: 54.5,
            lc30: 40.5,
            lc10: 24.5
        }
    },
    "marigold.500": {
        "marigold.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.800": {
            contrast: 11.022159001868282,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.900": {
            contrast: 15.411355856353525,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 97.5
        },
        "marigold.1000": {
            contrast: 19.64089623604018,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80
        },
        "marigold.1100": {
            contrast: 24.155950972309068,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68.5
        },
        "marigold.1200": {
            contrast: 28.865054726530705,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59
        },
        "marigold.1300": {
            contrast: 33.76171331295309,
            lc60: 100,
            lc45: 100,
            lc30: 91,
            lc10: 52.5
        },
        "marigold.1400": {
            contrast: 38.29531918648234,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 47.5
        },
        "marigold.1500": {
            contrast: 43.236539816198814,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 43
        },
        "marigold.1600": {
            contrast: 47.943177509648926,
            lc60: 100,
            lc45: 95,
            lc30: 69,
            lc10: 39.5
        },
        "marigold.1700": {
            contrast: 52.88357248662096,
            lc60: 100,
            lc45: 88,
            lc30: 64,
            lc10: 37
        },
        "marigold.1800": {
            contrast: 59.59117552173924,
            lc60: 100,
            lc45: 80.5,
            lc30: 58.5,
            lc10: 33.5
        },
        "marigold.1900": {
            contrast: 64.15085851797903,
            lc60: 95,
            lc45: 76,
            lc30: 55.5,
            lc10: 32
        },
        "marigold.2000": {
            contrast: 70.27462096620935,
            lc60: 88.5,
            lc45: 71,
            lc30: 51.5,
            lc10: 30
        },
        "marigold.2100": {
            contrast: 76.35606110746049,
            lc60: 83,
            lc45: 66.5,
            lc30: 48.5,
            lc10: 28
        },
        "marigold.2200": {
            contrast: 82.60038380376183,
            lc60: 78.5,
            lc45: 63,
            lc30: 46,
            lc10: 26.5
        },
        "marigold.2300": {
            contrast: 89.0765707454728,
            lc60: 74,
            lc45: 59.5,
            lc30: 43.5,
            lc10: 25.5
        },
        "marigold.2400": {
            contrast: 95.69535736900751,
            lc60: 70.5,
            lc45: 56.5,
            lc30: 41.5,
            lc10: 24.5
        },
        "marigold.2500": {
            contrast: 102.0562944066691,
            lc60: 67,
            lc45: 54,
            lc30: 39.5,
            lc10: 23
        }
    },
    "marigold.600": {
        "marigold.100": {
            contrast: 9.662592703199044,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.200": {
            contrast: 9.223428069237556,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.300": {
            contrast: 7.730243268761812,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.900": {
            contrast: 11.601238491615925,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1000": {
            contrast: 15.830778871302575,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95.5
        },
        "marigold.1100": {
            contrast: 20.345833607571464,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78
        },
        "marigold.1200": {
            contrast: 25.0549373617931,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65.5
        },
        "marigold.1300": {
            contrast: 29.951595948215488,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56
        },
        "marigold.1400": {
            contrast: 34.48520182174474,
            lc60: 100,
            lc45: 100,
            lc30: 89,
            lc10: 50.5
        },
        "marigold.1500": {
            contrast: 39.42642245146121,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 45
        },
        "marigold.1600": {
            contrast: 44.133060144911326,
            lc60: 100,
            lc45: 100,
            lc30: 73,
            lc10: 41
        },
        "marigold.1700": {
            contrast: 49.073455121883356,
            lc60: 100,
            lc45: 93.5,
            lc30: 66.5,
            lc10: 38
        },
        "marigold.1800": {
            contrast: 55.78105815700164,
            lc60: 100,
            lc45: 84,
            lc30: 60.5,
            lc10: 34.5
        },
        "marigold.1900": {
            contrast: 60.34074115324143,
            lc60: 99.5,
            lc45: 79,
            lc30: 56.5,
            lc10: 32
        },
        "marigold.2000": {
            contrast: 66.46450360147176,
            lc60: 92,
            lc45: 73,
            lc30: 53,
            lc10: 30
        },
        "marigold.2100": {
            contrast: 72.54594374272288,
            lc60: 86,
            lc45: 68.5,
            lc30: 49.5,
            lc10: 28
        },
        "marigold.2200": {
            contrast: 78.79026643902422,
            lc60: 81,
            lc45: 64.5,
            lc30: 47,
            lc10: 26.5
        },
        "marigold.2300": {
            contrast: 85.2664533807352,
            lc60: 76,
            lc45: 60.5,
            lc30: 44,
            lc10: 25
        },
        "marigold.2400": {
            contrast: 91.8852400042699,
            lc60: 71.5,
            lc45: 57.5,
            lc30: 42,
            lc10: 24
        },
        "marigold.2500": {
            contrast: 98.24617704193149,
            lc60: 68.5,
            lc45: 54.5,
            lc30: 40,
            lc10: 23
        }
    },
    "marigold.700": {
        "marigold.100": {
            contrast: 13.95434251979194,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.200": {
            contrast: 13.51517788583045,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.300": {
            contrast: 12.021993085354707,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.400": {
            contrast: 9.871275038765075,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.900": {
            contrast: 7.8433028991888945,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1000": {
            contrast: 12.07284327887555,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1100": {
            contrast: 16.58789801514444,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91
        },
        "marigold.1200": {
            contrast: 21.297001769366076,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74
        },
        "marigold.1300": {
            contrast: 26.193660355788456,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62
        },
        "marigold.1400": {
            contrast: 30.727266229317706,
            lc60: 100,
            lc45: 100,
            lc30: 97.5,
            lc10: 54.5
        },
        "marigold.1500": {
            contrast: 35.66848685903418,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 48
        },
        "marigold.1600": {
            contrast: 40.375124552484294,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 43
        },
        "marigold.1700": {
            contrast: 45.315519529456324,
            lc60: 100,
            lc45: 99,
            lc30: 71,
            lc10: 39.5
        },
        "marigold.1800": {
            contrast: 52.02312256457461,
            lc60: 100,
            lc45: 88.5,
            lc30: 63,
            lc10: 35.5
        },
        "marigold.1900": {
            contrast: 56.5828055608144,
            lc60: 100,
            lc45: 82.5,
            lc30: 59,
            lc10: 32.5
        },
        "marigold.2000": {
            contrast: 62.70656800904473,
            lc60: 96.5,
            lc45: 76.5,
            lc30: 54.5,
            lc10: 30.5
        },
        "marigold.2100": {
            contrast: 68.78800815029585,
            lc60: 89.5,
            lc45: 71,
            lc30: 51,
            lc10: 28.5
        },
        "marigold.2200": {
            contrast: 75.03233084659719,
            lc60: 83.5,
            lc45: 66.5,
            lc30: 47.5,
            lc10: 26.5
        },
        "marigold.2300": {
            contrast: 81.50851778830817,
            lc60: 78.5,
            lc45: 62.5,
            lc30: 45,
            lc10: 25.5
        },
        "marigold.2400": {
            contrast: 88.12730441184289,
            lc60: 74,
            lc45: 59,
            lc30: 42.5,
            lc10: 24
        },
        "marigold.2500": {
            contrast: 94.48824144950446,
            lc60: 70.5,
            lc45: 56.5,
            lc30: 40.5,
            lc10: 23
        }
    },
    "marigold.800": {
        "marigold.100": {
            contrast: 18.858305718680445,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "marigold.200": {
            contrast: 18.419141084718955,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "marigold.300": {
            contrast: 16.925956284243213,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82.5
        },
        "marigold.400": {
            contrast: 14.775238237653584,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.500": {
            contrast: 11.524599853794628,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1000": {
            contrast: 7.631907953236415,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1100": {
            contrast: 12.146962689505303,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1200": {
            contrast: 16.85606644372694,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89.5
        },
        "marigold.1300": {
            contrast: 21.75272503014933,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "marigold.1400": {
            contrast: 26.28633090367857,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61
        },
        "marigold.1500": {
            contrast: 31.227551533395047,
            lc60: 100,
            lc45: 100,
            lc30: 96,
            lc10: 53
        },
        "marigold.1600": {
            contrast: 35.93418922684516,
            lc60: 100,
            lc45: 100,
            lc30: 85,
            lc10: 47
        },
        "marigold.1700": {
            contrast: 40.8745842038172,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 42
        },
        "marigold.1800": {
            contrast: 47.58218723893547,
            lc60: 100,
            lc45: 95,
            lc30: 67.5,
            lc10: 37
        },
        "marigold.1900": {
            contrast: 52.14187023517527,
            lc60: 100,
            lc45: 88,
            lc30: 63,
            lc10: 35
        },
        "marigold.2000": {
            contrast: 58.2656326834056,
            lc60: 100,
            lc45: 80.5,
            lc30: 57,
            lc10: 31.5
        },
        "marigold.2100": {
            contrast: 64.34707282465672,
            lc60: 94,
            lc45: 74,
            lc30: 53,
            lc10: 29.5
        },
        "marigold.2200": {
            contrast: 70.59139552095807,
            lc60: 87.5,
            lc45: 69.5,
            lc30: 49.5,
            lc10: 27.5
        },
        "marigold.2300": {
            contrast: 77.06758246266904,
            lc60: 81.5,
            lc45: 64.5,
            lc30: 46.5,
            lc10: 26
        },
        "marigold.2400": {
            contrast: 83.68636908620375,
            lc60: 77,
            lc45: 61,
            lc30: 43.5,
            lc10: 24.5
        },
        "marigold.2500": {
            contrast: 90.04730612386534,
            lc60: 72.5,
            lc45: 57.5,
            lc30: 41.5,
            lc10: 23
        }
    },
    "marigold.900": {
        "marigold.100": {
            contrast: 23.44755732039726,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 44.5
        },
        "marigold.200": {
            contrast: 23.008392686435766,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 52
        },
        "marigold.300": {
            contrast: 21.515207885960024,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61
        },
        "marigold.400": {
            contrast: 19.364489839370393,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "marigold.500": {
            contrast: 16.113851455511437,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93
        },
        "marigold.600": {
            contrast: 11.662798115433892,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.700": {
            contrast: 7.4291195326659345,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1100": {
            contrast: 7.870050115891451,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1200": {
            contrast: 12.579153870113089,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1300": {
            contrast: 17.475812456535476,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87
        },
        "marigold.1400": {
            contrast: 22.009418330064726,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "marigold.1500": {
            contrast: 26.95063895978119,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59
        },
        "marigold.1600": {
            contrast: 31.657276653231314,
            lc60: 100,
            lc45: 100,
            lc30: 96,
            lc10: 51.5
        },
        "marigold.1700": {
            contrast: 36.59767163020335,
            lc60: 100,
            lc45: 100,
            lc30: 84,
            lc10: 45.5
        },
        "marigold.1800": {
            contrast: 43.305274665321626,
            lc60: 100,
            lc45: 100,
            lc30: 72.5,
            lc10: 39.5
        },
        "marigold.1900": {
            contrast: 47.86495766156141,
            lc60: 100,
            lc45: 94.5,
            lc30: 66.5,
            lc10: 36.5
        },
        "marigold.2000": {
            contrast: 53.98872010979174,
            lc60: 100,
            lc45: 86,
            lc30: 61,
            lc10: 33
        },
        "marigold.2100": {
            contrast: 60.07016025104288,
            lc60: 99.5,
            lc45: 78.5,
            lc30: 55.5,
            lc10: 31
        },
        "marigold.2200": {
            contrast: 66.31448294734422,
            lc60: 92,
            lc45: 73,
            lc30: 52,
            lc10: 28
        },
        "marigold.2300": {
            contrast: 72.79066988905518,
            lc60: 85.5,
            lc45: 68,
            lc30: 48,
            lc10: 27
        },
        "marigold.2400": {
            contrast: 79.4094565125899,
            lc60: 80,
            lc45: 63,
            lc30: 45,
            lc10: 25
        },
        "marigold.2500": {
            contrast: 85.77039355025148,
            lc60: 75,
            lc45: 59.5,
            lc30: 43,
            lc10: 23.5
        }
    },
    "marigold.1000": {
        "marigold.100": {
            contrast: 27.802541687172578,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 38
        },
        "marigold.200": {
            contrast: 27.363377053211096,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 44
        },
        "marigold.300": {
            contrast: 25.870192252735347,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51
        },
        "marigold.400": {
            contrast: 23.719474206145723,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "marigold.500": {
            contrast: 20.468835822286767,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73
        },
        "marigold.600": {
            contrast: 16.017782482209224,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93
        },
        "marigold.700": {
            contrast: 11.784103899441261,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1200": {
            contrast: 8.4260870035389,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1300": {
            contrast: 13.322745589961288,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1400": {
            contrast: 17.856351463490537,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85.5
        },
        "marigold.1500": {
            contrast: 22.797572093207005,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "marigold.1600": {
            contrast: 27.504209786657125,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58.5
        },
        "marigold.1700": {
            contrast: 32.44460476362916,
            lc60: 100,
            lc45: 100,
            lc30: 93,
            lc10: 49.5
        },
        "marigold.1800": {
            contrast: 39.15220779874743,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 43
        },
        "marigold.1900": {
            contrast: 43.71189079498723,
            lc60: 100,
            lc45: 100,
            lc30: 72,
            lc10: 39
        },
        "marigold.2000": {
            contrast: 49.83565324321756,
            lc60: 100,
            lc45: 91.5,
            lc30: 64.5,
            lc10: 35.5
        },
        "marigold.2100": {
            contrast: 55.917093384468686,
            lc60: 100,
            lc45: 83,
            lc30: 58.5,
            lc10: 32.5
        },
        "marigold.2200": {
            contrast: 62.16141608077002,
            lc60: 97,
            lc45: 76.5,
            lc30: 54.5,
            lc10: 30
        },
        "marigold.2300": {
            contrast: 68.637603022481,
            lc60: 89.5,
            lc45: 71,
            lc30: 50.5,
            lc10: 28
        },
        "marigold.2400": {
            contrast: 75.25638964601572,
            lc60: 83.5,
            lc45: 66,
            lc30: 47,
            lc10: 26
        },
        "marigold.2500": {
            contrast: 81.61732668367728,
            lc60: 78,
            lc45: 62,
            lc30: 44.5,
            lc10: 25
        }
    },
    "marigold.1100": {
        "marigold.100": {
            contrast: 32.389627430872565,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 33.5
        },
        "marigold.200": {
            contrast: 31.950462796911083,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 37.5
        },
        "marigold.300": {
            contrast: 30.457277996435334,
            lc60: 100,
            lc45: 100,
            lc30: 96.5,
            lc10: 43
        },
        "marigold.400": {
            contrast: 28.306559949845706,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 49.5
        },
        "marigold.500": {
            contrast: 25.05592156598675,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "marigold.600": {
            contrast: 20.604868225909208,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72
        },
        "marigold.700": {
            contrast: 16.37118964314125,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91
        },
        "marigold.800": {
            contrast: 11.515458996341588,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1300": {
            contrast: 8.85952652607723,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1400": {
            contrast: 13.39313239960648,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1500": {
            contrast: 18.33435302932295,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82.5
        },
        "marigold.1600": {
            contrast: 23.040990722773067,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "marigold.1700": {
            contrast: 27.981385699745097,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "marigold.1800": {
            contrast: 34.68898873486337,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 47.5
        },
        "marigold.1900": {
            contrast: 39.248671731103165,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 42.5
        },
        "marigold.2000": {
            contrast: 45.372434179333496,
            lc60: 100,
            lc45: 99,
            lc30: 69.5,
            lc10: 37.5
        },
        "marigold.2100": {
            contrast: 51.453874320584625,
            lc60: 100,
            lc45: 89,
            lc30: 62.5,
            lc10: 34
        },
        "marigold.2200": {
            contrast: 57.69819701688596,
            lc60: 100,
            lc45: 81.5,
            lc30: 57.5,
            lc10: 31.5
        },
        "marigold.2300": {
            contrast: 64.17438395859695,
            lc60: 94,
            lc45: 74,
            lc30: 53,
            lc10: 29
        },
        "marigold.2400": {
            contrast: 70.79317058213167,
            lc60: 87,
            lc45: 69.5,
            lc30: 49.5,
            lc10: 27
        },
        "marigold.2500": {
            contrast: 77.15410761979324,
            lc60: 81.5,
            lc45: 65,
            lc30: 46,
            lc10: 25.5
        }
    },
    "marigold.1200": {
        "marigold.100": {
            contrast: 37.115011023217825,
            lc60: 100,
            lc45: 100,
            lc30: 60.5,
            lc10: 29.5
        },
        "marigold.200": {
            contrast: 36.67584638925634,
            lc60: 100,
            lc45: 100,
            lc30: 67.5,
            lc10: 33
        },
        "marigold.300": {
            contrast: 35.1826615887806,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 37
        },
        "marigold.400": {
            contrast: 33.031943542190966,
            lc60: 100,
            lc45: 100,
            lc30: 86,
            lc10: 42
        },
        "marigold.500": {
            contrast: 29.78130515833201,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 49.5
        },
        "marigold.600": {
            contrast: 25.330251818254464,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59
        },
        "marigold.700": {
            contrast: 21.096573235486506,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72
        },
        "marigold.800": {
            contrast: 16.240842588686846,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 92.5
        },
        "marigold.900": {
            contrast: 11.682210261326572,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1000": {
            contrast: 7.345203541280688,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1400": {
            contrast: 8.709200203002029,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1500": {
            contrast: 13.650420832718499,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1600": {
            contrast: 18.35705852616862,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83.5
        },
        "marigold.1700": {
            contrast: 23.297453503140648,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67
        },
        "marigold.1800": {
            contrast: 30.005056538258923,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 53
        },
        "marigold.1900": {
            contrast: 34.56473953449872,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 47.5
        },
        "marigold.2000": {
            contrast: 40.68850198272905,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 41
        },
        "marigold.2100": {
            contrast: 46.76994212398017,
            lc60: 100,
            lc45: 96,
            lc30: 68,
            lc10: 37
        },
        "marigold.2200": {
            contrast: 53.01426482028152,
            lc60: 100,
            lc45: 87,
            lc30: 61.5,
            lc10: 34
        },
        "marigold.2300": {
            contrast: 59.49045176199249,
            lc60: 100,
            lc45: 79.5,
            lc30: 56.5,
            lc10: 31
        },
        "marigold.2400": {
            contrast: 66.10923838552722,
            lc60: 92,
            lc45: 73,
            lc30: 52,
            lc10: 28.5
        },
        "marigold.2500": {
            contrast: 72.47017542318878,
            lc60: 86,
            lc45: 68,
            lc30: 48.5,
            lc10: 26.5
        }
    },
    "marigold.1300": {
        "marigold.100": {
            contrast: 41.97290435051576,
            lc60: 100,
            lc45: 100,
            lc30: 53,
            lc10: 26.5
        },
        "marigold.200": {
            contrast: 41.53373971655428,
            lc60: 100,
            lc45: 100,
            lc30: 59.5,
            lc10: 29
        },
        "marigold.300": {
            contrast: 40.04055491607853,
            lc60: 100,
            lc45: 100,
            lc30: 66.5,
            lc10: 32.5
        },
        "marigold.400": {
            contrast: 37.8898368694889,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 36.5
        },
        "marigold.500": {
            contrast: 34.63919848562995,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 42
        },
        "marigold.600": {
            contrast: 30.188145145552404,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 49.5
        },
        "marigold.700": {
            contrast: 25.95446656278444,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58
        },
        "marigold.800": {
            contrast: 21.098735915984783,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "marigold.900": {
            contrast: 16.540103588624508,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 90
        },
        "marigold.1000": {
            contrast: 12.203096868578625,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1100": {
            contrast: 7.624732529700753,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1500": {
            contrast: 8.752100120734898,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1600": {
            contrast: 13.458737814185016,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1700": {
            contrast: 18.39913279115705,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82.5
        },
        "marigold.1800": {
            contrast: 25.106735826275322,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "marigold.1900": {
            contrast: 29.666418822515116,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54.5
        },
        "marigold.2000": {
            contrast: 35.79018127074545,
            lc60: 100,
            lc45: 100,
            lc30: 86,
            lc10: 46
        },
        "marigold.2100": {
            contrast: 41.87162141199657,
            lc60: 100,
            lc45: 100,
            lc30: 75,
            lc10: 41
        },
        "marigold.2200": {
            contrast: 48.11594410829792,
            lc60: 100,
            lc45: 94.5,
            lc30: 66.5,
            lc10: 37
        },
        "marigold.2300": {
            contrast: 54.59213105000889,
            lc60: 100,
            lc45: 85,
            lc30: 60.5,
            lc10: 33.5
        },
        "marigold.2400": {
            contrast: 61.2109176735436,
            lc60: 98,
            lc45: 77.5,
            lc30: 55.5,
            lc10: 30.5
        },
        "marigold.2500": {
            contrast: 67.57185471120518,
            lc60: 90.5,
            lc45: 72,
            lc30: 51.5,
            lc10: 28.5
        }
    },
    "marigold.1400": {
        "marigold.100": {
            contrast: 46.425734526265295,
            lc60: 100,
            lc45: 83.5,
            lc30: 48.5,
            lc10: 24
        },
        "marigold.200": {
            contrast: 45.98656989230381,
            lc60: 100,
            lc45: 92.5,
            lc30: 53,
            lc10: 26.5
        },
        "marigold.300": {
            contrast: 44.49338509182807,
            lc60: 100,
            lc45: 100,
            lc30: 59,
            lc10: 29.5
        },
        "marigold.400": {
            contrast: 42.342667045238436,
            lc60: 100,
            lc45: 100,
            lc30: 65.5,
            lc10: 33
        },
        "marigold.500": {
            contrast: 39.09202866137948,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 36.5
        },
        "marigold.600": {
            contrast: 34.64097532130193,
            lc60: 100,
            lc45: 100,
            lc30: 85,
            lc10: 42
        },
        "marigold.700": {
            contrast: 30.407296738533972,
            lc60: 100,
            lc45: 100,
            lc30: 98.5,
            lc10: 49.5
        },
        "marigold.800": {
            contrast: 25.551566091734312,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59
        },
        "marigold.900": {
            contrast: 20.99293376437404,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "marigold.1000": {
            contrast: 16.65592704432816,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 90
        },
        "marigold.1100": {
            contrast: 12.07756270545029,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1200": {
            contrast: 7.3514239792295255,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1600": {
            contrast: 8.900798383588713,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1700": {
            contrast: 13.841193360560746,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1800": {
            contrast: 20.548796395679023,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74
        },
        "marigold.1900": {
            contrast: 25.108479391918813,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63
        },
        "marigold.2000": {
            contrast: 31.232241840149143,
            lc60: 100,
            lc45: 100,
            lc30: 96,
            lc10: 52
        },
        "marigold.2100": {
            contrast: 37.31368198140027,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 45
        },
        "marigold.2200": {
            contrast: 43.55800467770161,
            lc60: 100,
            lc45: 100,
            lc30: 73,
            lc10: 40.5
        },
        "marigold.2300": {
            contrast: 50.03419161941258,
            lc60: 100,
            lc45: 91,
            lc30: 65,
            lc10: 35.5
        },
        "marigold.2400": {
            contrast: 56.65297824294729,
            lc60: 100,
            lc45: 82.5,
            lc30: 59,
            lc10: 33
        },
        "marigold.2500": {
            contrast: 63.01391528060888,
            lc60: 96.5,
            lc45: 76,
            lc30: 54.5,
            lc10: 30.5
        }
    },
    "marigold.1500": {
        "marigold.100": {
            contrast: 51.23488381948847,
            lc60: 100,
            lc45: 69.5,
            lc30: 44,
            lc10: 22
        },
        "marigold.200": {
            contrast: 50.79571918552699,
            lc60: 100,
            lc45: 76.5,
            lc30: 48,
            lc10: 24
        },
        "marigold.300": {
            contrast: 49.302534385051246,
            lc60: 100,
            lc45: 84.5,
            lc30: 53,
            lc10: 26.5
        },
        "marigold.400": {
            contrast: 47.151816338461614,
            lc60: 100,
            lc45: 92.5,
            lc30: 58,
            lc10: 29
        },
        "marigold.500": {
            contrast: 43.90117795460266,
            lc60: 100,
            lc45: 100,
            lc30: 65,
            lc10: 32.5
        },
        "marigold.600": {
            contrast: 39.450124614525116,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 37
        },
        "marigold.700": {
            contrast: 35.21644603175715,
            lc60: 100,
            lc45: 100,
            lc30: 84,
            lc10: 42.5
        },
        "marigold.800": {
            contrast: 30.360715384957487,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 50
        },
        "marigold.900": {
            contrast: 25.80208305759722,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59
        },
        "marigold.1000": {
            contrast: 21.465076337551338,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "marigold.1100": {
            contrast: 16.88671199867347,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88.5
        },
        "marigold.1200": {
            contrast: 12.160573272452705,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1700": {
            contrast: 8.850760774088632,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1800": {
            contrast: 15.558363809206908,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95.5
        },
        "marigold.1900": {
            contrast: 20.1180468054467,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77
        },
        "marigold.2000": {
            contrast: 26.24180925367703,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60.5
        },
        "marigold.2100": {
            contrast: 32.323249394928155,
            lc60: 100,
            lc45: 100,
            lc30: 93.5,
            lc10: 51
        },
        "marigold.2200": {
            contrast: 38.56757209122949,
            lc60: 100,
            lc45: 100,
            lc30: 80.5,
            lc10: 44.5
        },
        "marigold.2300": {
            contrast: 45.043759032940464,
            lc60: 100,
            lc45: 99,
            lc30: 71.5,
            lc10: 39.5
        },
        "marigold.2400": {
            contrast: 51.66254565647518,
            lc60: 100,
            lc45: 89,
            lc30: 63,
            lc10: 35.5
        },
        "marigold.2500": {
            contrast: 58.02348269413676,
            lc60: 100,
            lc45: 81.5,
            lc30: 58.5,
            lc10: 32.5
        }
    },
    "marigold.1600": {
        "marigold.100": {
            contrast: 55.77702163296222,
            lc60: 100,
            lc45: 63,
            lc30: 40,
            lc10: 20
        },
        "marigold.200": {
            contrast: 55.337856999000735,
            lc60: 100,
            lc45: 69,
            lc30: 44,
            lc10: 22.5
        },
        "marigold.300": {
            contrast: 53.84467219852499,
            lc60: 100,
            lc45: 75.5,
            lc30: 48,
            lc10: 24.5
        },
        "marigold.400": {
            contrast: 51.69395415193536,
            lc60: 100,
            lc45: 82,
            lc30: 52.5,
            lc10: 26.5
        },
        "marigold.500": {
            contrast: 48.4433157680764,
            lc60: 100,
            lc45: 91,
            lc30: 58,
            lc10: 29.5
        },
        "marigold.600": {
            contrast: 43.99226242799886,
            lc60: 100,
            lc45: 100,
            lc30: 65,
            lc10: 33.5
        },
        "marigold.700": {
            contrast: 39.7585838452309,
            lc60: 100,
            lc45: 100,
            lc30: 73.5,
            lc10: 37
        },
        "marigold.800": {
            contrast: 34.90285319843123,
            lc60: 100,
            lc45: 100,
            lc30: 85,
            lc10: 43
        },
        "marigold.900": {
            contrast: 30.344220871070966,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 50
        },
        "marigold.1000": {
            contrast: 26.00721415102508,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58.5
        },
        "marigold.1100": {
            contrast: 21.428849812147213,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70.5
        },
        "marigold.1200": {
            contrast: 16.702711085926445,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 90.5
        },
        "marigold.1300": {
            contrast: 11.834801178465948,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1400": {
            contrast: 7.365323785246145,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1800": {
            contrast: 10.784646618748637,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1900": {
            contrast: 15.344329614988428,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98.5
        },
        "marigold.2000": {
            contrast: 21.46809206321876,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72
        },
        "marigold.2100": {
            contrast: 27.549532204469884,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "marigold.2200": {
            contrast: 33.79385490077122,
            lc60: 100,
            lc45: 100,
            lc30: 90,
            lc10: 50.5
        },
        "marigold.2300": {
            contrast: 40.27004184248219,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 43
        },
        "marigold.2400": {
            contrast: 46.88882846601691,
            lc60: 100,
            lc45: 96,
            lc30: 69,
            lc10: 38.5
        },
        "marigold.2500": {
            contrast: 53.24976550367849,
            lc60: 100,
            lc45: 87.5,
            lc30: 63,
            lc10: 34.5
        }
    },
    "marigold.1700": {
        "marigold.100": {
            contrast: 60.50773626357404,
            lc60: 91,
            lc45: 57.5,
            lc30: 37,
            lc10: 19
        },
        "marigold.200": {
            contrast: 60.068571629612556,
            lc60: 99,
            lc45: 63,
            lc30: 40.5,
            lc10: 20.5
        },
        "marigold.300": {
            contrast: 58.5753868291368,
            lc60: 100,
            lc45: 68,
            lc30: 44,
            lc10: 22.5
        },
        "marigold.400": {
            contrast: 56.42466878254717,
            lc60: 100,
            lc45: 74,
            lc30: 47.5,
            lc10: 24.5
        },
        "marigold.500": {
            contrast: 53.174030398688224,
            lc60: 100,
            lc45: 81.5,
            lc30: 52.5,
            lc10: 27
        },
        "marigold.600": {
            contrast: 48.722977058610674,
            lc60: 100,
            lc45: 90.5,
            lc30: 58.5,
            lc10: 30
        },
        "marigold.700": {
            contrast: 44.489298475842716,
            lc60: 100,
            lc45: 100,
            lc30: 65.5,
            lc10: 33
        },
        "marigold.800": {
            contrast: 39.633567829043045,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 38
        },
        "marigold.900": {
            contrast: 35.07493550168278,
            lc60: 100,
            lc45: 100,
            lc30: 85,
            lc10: 43
        },
        "marigold.1000": {
            contrast: 30.737928781636896,
            lc60: 100,
            lc45: 100,
            lc30: 97.5,
            lc10: 50
        },
        "marigold.1100": {
            contrast: 26.159564442759027,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58.5
        },
        "marigold.1200": {
            contrast: 21.433425716538267,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "marigold.1300": {
            contrast: 16.565515809077766,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 90.5
        },
        "marigold.1400": {
            contrast: 12.096038415857963,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1900": {
            contrast: 10.31396151422643,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.2000": {
            contrast: 16.43772396245676,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 92.5
        },
        "marigold.2100": {
            contrast: 22.519164103707887,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70.5
        },
        "marigold.2200": {
            contrast: 28.76348680000923,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "marigold.2300": {
            contrast: 35.239673741720196,
            lc60: 100,
            lc45: 100,
            lc30: 87.5,
            lc10: 48.5
        },
        "marigold.2400": {
            contrast: 41.85846036525491,
            lc60: 100,
            lc45: 100,
            lc30: 76,
            lc10: 42.5
        },
        "marigold.2500": {
            contrast: 48.2193974029165,
            lc60: 100,
            lc45: 94,
            lc30: 68,
            lc10: 38
        }
    },
    "marigold.1800": {
        "marigold.100": {
            contrast: 66.87548992963627,
            lc60: 73,
            lc45: 52,
            lc30: 33.5,
            lc10: 17
        },
        "marigold.200": {
            contrast: 66.43632529567478,
            lc60: 79,
            lc45: 56,
            lc30: 36,
            lc10: 18.5
        },
        "marigold.300": {
            contrast: 64.94314049519903,
            lc60: 85.5,
            lc45: 60.5,
            lc30: 39.5,
            lc10: 20
        },
        "marigold.400": {
            contrast: 62.7924224486094,
            lc60: 92,
            lc45: 65,
            lc30: 42,
            lc10: 21.5
        },
        "marigold.500": {
            contrast: 59.541784064750445,
            lc60: 100,
            lc45: 71,
            lc30: 46,
            lc10: 23.5
        },
        "marigold.600": {
            contrast: 55.090730724672895,
            lc60: 100,
            lc45: 79,
            lc30: 51,
            lc10: 26
        },
        "marigold.700": {
            contrast: 50.857052141904944,
            lc60: 100,
            lc45: 86.5,
            lc30: 56,
            lc10: 29
        },
        "marigold.800": {
            contrast: 46.00132149510527,
            lc60: 100,
            lc45: 97,
            lc30: 63.5,
            lc10: 32
        },
        "marigold.900": {
            contrast: 41.44268916774501,
            lc60: 100,
            lc45: 100,
            lc30: 71,
            lc10: 36.5
        },
        "marigold.1000": {
            contrast: 37.105682447699124,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 41
        },
        "marigold.1100": {
            contrast: 32.52731810882125,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 47
        },
        "marigold.1200": {
            contrast: 27.801179382600488,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54.5
        },
        "marigold.1300": {
            contrast: 22.93326947513999,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67
        },
        "marigold.1400": {
            contrast: 18.463792081920186,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81.5
        },
        "marigold.1500": {
            contrast: 13.629325064874278,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1600": {
            contrast: 9.05681386497683,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.2000": {
            contrast: 9.578437050084764,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.2100": {
            contrast: 15.659877191335895,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95.5
        },
        "marigold.2200": {
            contrast: 21.904199887637237,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72.5
        },
        "marigold.2300": {
            contrast: 28.380386829348197,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "marigold.2400": {
            contrast: 34.999173452882914,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 49
        },
        "marigold.2500": {
            contrast: 41.3601104905445,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 43
        }
    },
    "marigold.1900": {
        "marigold.100": {
            contrast: 71.17090949876933,
            lc60: 68,
            lc45: 48.5,
            lc30: 31.5,
            lc10: 16
        },
        "marigold.200": {
            contrast: 70.73174486480784,
            lc60: 73,
            lc45: 52.5,
            lc30: 34,
            lc10: 17.5
        },
        "marigold.300": {
            contrast: 69.23856006433209,
            lc60: 78.5,
            lc45: 56.5,
            lc30: 36.5,
            lc10: 19
        },
        "marigold.400": {
            contrast: 67.08784201774246,
            lc60: 84.5,
            lc45: 60.5,
            lc30: 39.5,
            lc10: 20
        },
        "marigold.500": {
            contrast: 63.83720363388351,
            lc60: 92,
            lc45: 66,
            lc30: 43,
            lc10: 22
        },
        "marigold.600": {
            contrast: 59.38615029380596,
            lc60: 100,
            lc45: 72.5,
            lc30: 47,
            lc10: 24
        },
        "marigold.700": {
            contrast: 55.152471711038,
            lc60: 100,
            lc45: 79,
            lc30: 51.5,
            lc10: 26.5
        },
        "marigold.800": {
            contrast: 50.29674106423834,
            lc60: 100,
            lc45: 88,
            lc30: 57,
            lc10: 29
        },
        "marigold.900": {
            contrast: 45.73810873687806,
            lc60: 100,
            lc45: 98,
            lc30: 63.5,
            lc10: 33
        },
        "marigold.1000": {
            contrast: 41.40110201683218,
            lc60: 100,
            lc45: 100,
            lc30: 71,
            lc10: 36
        },
        "marigold.1100": {
            contrast: 36.822737677954315,
            lc60: 100,
            lc45: 100,
            lc30: 80.5,
            lc10: 41
        },
        "marigold.1200": {
            contrast: 32.09659895173355,
            lc60: 100,
            lc45: 100,
            lc30: 93,
            lc10: 47.5
        },
        "marigold.1300": {
            contrast: 27.228689044273047,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56
        },
        "marigold.1400": {
            contrast: 22.75921165105325,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "marigold.1500": {
            contrast: 17.92474463400734,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84.5
        },
        "marigold.1600": {
            contrast: 13.352233434109891,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1700": {
            contrast: 8.58369477165104,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.2100": {
            contrast: 10.979083490170826,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.2200": {
            contrast: 17.223406186472168,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89
        },
        "marigold.2300": {
            contrast: 23.699593128183135,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68.5
        },
        "marigold.2400": {
            contrast: 30.31837975171785,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 56
        },
        "marigold.2500": {
            contrast: 36.679316789379435,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 47
        }
    },
    "marigold.2000": {
        "marigold.100": {
            contrast: 76.90094085814016,
            lc60: 62.5,
            lc45: 45,
            lc30: 29.5,
            lc10: 15
        },
        "marigold.200": {
            contrast: 76.46177622417866,
            lc60: 66.5,
            lc45: 48,
            lc30: 31.5,
            lc10: 16.5
        },
        "marigold.300": {
            contrast: 74.96859142370292,
            lc60: 71.5,
            lc45: 51.5,
            lc30: 34,
            lc10: 17.5
        },
        "marigold.400": {
            contrast: 72.81787337711329,
            lc60: 76,
            lc45: 55,
            lc30: 36,
            lc10: 18.5
        },
        "marigold.500": {
            contrast: 69.56723499325435,
            lc60: 82.5,
            lc45: 59.5,
            lc30: 39,
            lc10: 20
        },
        "marigold.600": {
            contrast: 65.1161816531768,
            lc60: 90,
            lc45: 65,
            lc30: 42.5,
            lc10: 22
        },
        "marigold.700": {
            contrast: 60.88250307040883,
            lc60: 98,
            lc45: 70.5,
            lc30: 46,
            lc10: 24
        },
        "marigold.800": {
            contrast: 56.026772423609174,
            lc60: 100,
            lc45: 78,
            lc30: 50.5,
            lc10: 26
        },
        "marigold.900": {
            contrast: 51.4681400962489,
            lc60: 100,
            lc45: 86,
            lc30: 55.5,
            lc10: 29
        },
        "marigold.1000": {
            contrast: 47.13113337620302,
            lc60: 100,
            lc45: 94.5,
            lc30: 62,
            lc10: 32
        },
        "marigold.1100": {
            contrast: 42.55276903732514,
            lc60: 100,
            lc45: 100,
            lc30: 68.5,
            lc10: 35.5
        },
        "marigold.1200": {
            contrast: 37.82663031110438,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 40
        },
        "marigold.1300": {
            contrast: 32.95872040364388,
            lc60: 100,
            lc45: 100,
            lc30: 90,
            lc10: 46
        },
        "marigold.1400": {
            contrast: 28.489243010424076,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53.5
        },
        "marigold.1500": {
            contrast: 23.65477599337817,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "marigold.1600": {
            contrast: 19.082264793480725,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80
        },
        "marigold.1700": {
            contrast: 14.313726131021873,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1800": {
            contrast: 7.885826387843456,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.2200": {
            contrast: 10.915726941543506,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.2300": {
            contrast: 17.391913883254475,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88.5
        },
        "marigold.2400": {
            contrast: 24.01070050678919,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "marigold.2500": {
            contrast: 30.37163754445077,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 54.5
        }
    },
    "marigold.2100": {
        "marigold.100": {
            contrast: 82.5505968237916,
            lc60: 57.5,
            lc45: 42,
            lc30: 27.5,
            lc10: 14
        },
        "marigold.200": {
            contrast: 82.11143218983011,
            lc60: 61,
            lc45: 44.5,
            lc30: 29.5,
            lc10: 15
        },
        "marigold.300": {
            contrast: 80.61824738935437,
            lc60: 65.5,
            lc45: 47.5,
            lc30: 31,
            lc10: 16
        },
        "marigold.400": {
            contrast: 78.46752934276473,
            lc60: 69.5,
            lc45: 50.5,
            lc30: 33.5,
            lc10: 17
        },
        "marigold.500": {
            contrast: 75.21689095890578,
            lc60: 75,
            lc45: 54.5,
            lc30: 36,
            lc10: 18.5
        },
        "marigold.600": {
            contrast: 70.76583761882824,
            lc60: 81,
            lc45: 58.5,
            lc30: 39,
            lc10: 20
        },
        "marigold.700": {
            contrast: 66.53215903606029,
            lc60: 87.5,
            lc45: 63.5,
            lc30: 41.5,
            lc10: 21.5
        },
        "marigold.800": {
            contrast: 61.67642838926062,
            lc60: 96.5,
            lc45: 69.5,
            lc30: 46,
            lc10: 24
        },
        "marigold.900": {
            contrast: 57.117796061900336,
            lc60: 100,
            lc45: 76,
            lc30: 50,
            lc10: 25.5
        },
        "marigold.1000": {
            contrast: 52.78078934185446,
            lc60: 100,
            lc45: 83,
            lc30: 54.5,
            lc10: 28
        },
        "marigold.1100": {
            contrast: 48.20242500297659,
            lc60: 100,
            lc45: 92,
            lc30: 60,
            lc10: 31
        },
        "marigold.1200": {
            contrast: 43.47628627675583,
            lc60: 100,
            lc45: 100,
            lc30: 67.5,
            lc10: 34.5
        },
        "marigold.1300": {
            contrast: 38.60837636929532,
            lc60: 100,
            lc45: 100,
            lc30: 76,
            lc10: 39
        },
        "marigold.1400": {
            contrast: 34.138898976075524,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 44.5
        },
        "marigold.1500": {
            contrast: 29.304431959029614,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51
        },
        "marigold.1600": {
            contrast: 24.731920759132166,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61
        },
        "marigold.1700": {
            contrast: 19.963382096673314,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74.5
        },
        "marigold.1800": {
            contrast: 13.5354823534949,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1900": {
            contrast: 9.193914800042483,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.2300": {
            contrast: 11.105265995822885,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.2400": {
            contrast: 17.724052619357604,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87.5
        },
        "marigold.2500": {
            contrast: 24.084989657019186,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67
        }
    },
    "marigold.2200": {
        "marigold.100": {
            contrast: 88.31251220415398,
            lc60: 53.5,
            lc45: 39,
            lc30: 26,
            lc10: 13.5
        },
        "marigold.200": {
            contrast: 87.87334757019248,
            lc60: 56.5,
            lc45: 41,
            lc30: 27.5,
            lc10: 14
        },
        "marigold.300": {
            contrast: 86.38016276971673,
            lc60: 60.5,
            lc45: 44,
            lc30: 29,
            lc10: 15
        },
        "marigold.400": {
            contrast: 84.2294447231271,
            lc60: 64,
            lc45: 46.5,
            lc30: 30.5,
            lc10: 16
        },
        "marigold.500": {
            contrast: 80.97880633926815,
            lc60: 68.5,
            lc45: 50,
            lc30: 33,
            lc10: 17
        },
        "marigold.600": {
            contrast: 76.52775299919061,
            lc60: 73.5,
            lc45: 54,
            lc30: 35.5,
            lc10: 18.5
        },
        "marigold.700": {
            contrast: 72.29407441642266,
            lc60: 79,
            lc45: 57.5,
            lc30: 38,
            lc10: 19.5
        },
        "marigold.800": {
            contrast: 67.43834376962299,
            lc60: 86.5,
            lc45: 63,
            lc30: 41.5,
            lc10: 21.5
        },
        "marigold.900": {
            contrast: 62.87971144226272,
            lc60: 94.5,
            lc45: 68,
            lc30: 44.5,
            lc10: 23
        },
        "marigold.1000": {
            contrast: 58.54270472221683,
            lc60: 100,
            lc45: 73.5,
            lc30: 48,
            lc10: 25.5
        },
        "marigold.1100": {
            contrast: 53.96434038333896,
            lc60: 100,
            lc45: 81,
            lc30: 52.5,
            lc10: 27
        },
        "marigold.1200": {
            contrast: 49.238201657118196,
            lc60: 100,
            lc45: 90,
            lc30: 58.5,
            lc10: 30
        },
        "marigold.1300": {
            contrast: 44.370291749657696,
            lc60: 100,
            lc45: 100,
            lc30: 65.5,
            lc10: 33.5
        },
        "marigold.1400": {
            contrast: 39.9008143564379,
            lc60: 100,
            lc45: 100,
            lc30: 73,
            lc10: 37
        },
        "marigold.1500": {
            contrast: 35.06634733939199,
            lc60: 100,
            lc45: 100,
            lc30: 83.5,
            lc10: 42.5
        },
        "marigold.1600": {
            contrast: 30.49383613949454,
            lc60: 100,
            lc45: 100,
            lc30: 98,
            lc10: 49
        },
        "marigold.1700": {
            contrast: 25.725297477035685,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58
        },
        "marigold.1800": {
            contrast: 19.29739773385727,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78.5
        },
        "marigold.1900": {
            contrast: 14.955830180404856,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.2000": {
            contrast: 9.157717754014937,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.2400": {
            contrast: 11.247185320587324,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.2500": {
            contrast: 17.60812235824891,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86.5
        }
    },
    "marigold.2300": {
        "marigold.100": {
            contrast: 94.24960267741133,
            lc60: 50,
            lc45: 36.5,
            lc30: 24.5,
            lc10: 12.5
        },
        "marigold.200": {
            contrast: 93.81043804344985,
            lc60: 52.5,
            lc45: 38.5,
            lc30: 25.5,
            lc10: 13.5
        },
        "marigold.300": {
            contrast: 92.3172532429741,
            lc60: 56,
            lc45: 41,
            lc30: 27,
            lc10: 14
        },
        "marigold.400": {
            contrast: 90.16653519638447,
            lc60: 59,
            lc45: 43.5,
            lc30: 28.5,
            lc10: 15
        },
        "marigold.500": {
            contrast: 86.91589681252552,
            lc60: 63,
            lc45: 46,
            lc30: 30.5,
            lc10: 16
        },
        "marigold.600": {
            contrast: 82.46484347244798,
            lc60: 67,
            lc45: 49.5,
            lc30: 33,
            lc10: 17
        },
        "marigold.700": {
            contrast: 78.23116488968003,
            lc60: 72,
            lc45: 52.5,
            lc30: 34.5,
            lc10: 18
        },
        "marigold.800": {
            contrast: 73.37543424288036,
            lc60: 78,
            lc45: 56.5,
            lc30: 37.5,
            lc10: 19.5
        },
        "marigold.900": {
            contrast: 68.81680191552007,
            lc60: 84.5,
            lc45: 61.5,
            lc30: 40,
            lc10: 21
        },
        "marigold.1000": {
            contrast: 64.4797951954742,
            lc60: 91,
            lc45: 66,
            lc30: 43,
            lc10: 22.5
        },
        "marigold.1100": {
            contrast: 59.901430856596335,
            lc60: 100,
            lc45: 71.5,
            lc30: 47,
            lc10: 24.5
        },
        "marigold.1200": {
            contrast: 55.17529213037557,
            lc60: 100,
            lc45: 78.5,
            lc30: 51,
            lc10: 26.5
        },
        "marigold.1300": {
            contrast: 50.30738222291507,
            lc60: 100,
            lc45: 87.5,
            lc30: 56.5,
            lc10: 29
        },
        "marigold.1400": {
            contrast: 45.83790482969526,
            lc60: 100,
            lc45: 97.5,
            lc30: 62.5,
            lc10: 31.5
        },
        "marigold.1500": {
            contrast: 41.00343781264935,
            lc60: 100,
            lc45: 100,
            lc30: 70.5,
            lc10: 35.5
        },
        "marigold.1600": {
            contrast: 36.430926612751904,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 41
        },
        "marigold.1700": {
            contrast: 31.662387950293052,
            lc60: 100,
            lc45: 100,
            lc30: 94,
            lc10: 46
        },
        "marigold.1800": {
            contrast: 25.234488207114637,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "marigold.1900": {
            contrast: 20.892920653662223,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "marigold.2000": {
            contrast: 15.094808227272305,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98.5
        },
        "marigold.2100": {
            contrast: 9.371170032514646,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.2500": {
            contrast: 10.868855943374408,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "marigold.2400": {
        "marigold.100": {
            contrast: 100.27947290908156,
            lc60: 46.5,
            lc45: 34,
            lc30: 23,
            lc10: 12
        },
        "marigold.200": {
            contrast: 99.84030827512008,
            lc60: 49,
            lc45: 36,
            lc30: 24,
            lc10: 12.5
        },
        "marigold.300": {
            contrast: 98.34712347464432,
            lc60: 52,
            lc45: 38,
            lc30: 25.5,
            lc10: 13.5
        },
        "marigold.400": {
            contrast: 96.1964054280547,
            lc60: 54.5,
            lc45: 40,
            lc30: 26.5,
            lc10: 14
        },
        "marigold.500": {
            contrast: 92.94576704419575,
            lc60: 58,
            lc45: 42.5,
            lc30: 28.5,
            lc10: 15
        },
        "marigold.600": {
            contrast: 88.4947137041182,
            lc60: 62,
            lc45: 45.5,
            lc30: 30.5,
            lc10: 15.5
        },
        "marigold.700": {
            contrast: 84.26103512135023,
            lc60: 66,
            lc45: 48.5,
            lc30: 32,
            lc10: 16.5
        },
        "marigold.800": {
            contrast: 79.40530447455058,
            lc60: 71,
            lc45: 52,
            lc30: 34.5,
            lc10: 18
        },
        "marigold.900": {
            contrast: 74.8466721471903,
            lc60: 76,
            lc45: 55.5,
            lc30: 37,
            lc10: 19
        },
        "marigold.1000": {
            contrast: 70.50966542714441,
            lc60: 81.5,
            lc45: 59.5,
            lc30: 39,
            lc10: 20
        },
        "marigold.1100": {
            contrast: 65.93130108826655,
            lc60: 88.5,
            lc45: 64,
            lc30: 42,
            lc10: 22
        },
        "marigold.1200": {
            contrast: 61.20516236204578,
            lc60: 97,
            lc45: 69.5,
            lc30: 45.5,
            lc10: 23.5
        },
        "marigold.1300": {
            contrast: 56.33725245458528,
            lc60: 100,
            lc45: 76.5,
            lc30: 49.5,
            lc10: 26
        },
        "marigold.1400": {
            contrast: 51.867775061365485,
            lc60: 100,
            lc45: 84,
            lc30: 54.5,
            lc10: 28
        },
        "marigold.1500": {
            contrast: 47.033308044319575,
            lc60: 100,
            lc45: 94.5,
            lc30: 60.5,
            lc10: 31
        },
        "marigold.1600": {
            contrast: 42.46079684442213,
            lc60: 100,
            lc45: 100,
            lc30: 67.5,
            lc10: 34.5
        },
        "marigold.1700": {
            contrast: 37.692258181963275,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 38
        },
        "marigold.1800": {
            contrast: 31.264358438784857,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 47.5
        },
        "marigold.1900": {
            contrast: 26.922790885332443,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "marigold.2000": {
            contrast: 21.12467845894253,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "marigold.2100": {
            contrast: 15.401040264184868,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98.5
        },
        "marigold.2200": {
            contrast: 9.557096051606745,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "marigold.2500": {
        "marigold.100": {
            contrast: 106.04067321268862,
            lc60: 44,
            lc45: 32.5,
            lc30: 21.5,
            lc10: 11.5
        },
        "marigold.200": {
            contrast: 105.60150857872712,
            lc60: 46,
            lc45: 34,
            lc30: 23,
            lc10: 12
        },
        "marigold.300": {
            contrast: 104.10832377825136,
            lc60: 48.5,
            lc45: 36,
            lc30: 24,
            lc10: 12.5
        },
        "marigold.400": {
            contrast: 101.95760573166174,
            lc60: 51,
            lc45: 37.5,
            lc30: 25,
            lc10: 13
        },
        "marigold.500": {
            contrast: 98.70696734780276,
            lc60: 54,
            lc45: 40,
            lc30: 26.5,
            lc10: 14
        },
        "marigold.600": {
            contrast: 94.25591400772524,
            lc60: 57.5,
            lc45: 42.5,
            lc30: 28.5,
            lc10: 15
        },
        "marigold.700": {
            contrast: 90.02223542495727,
            lc60: 61,
            lc45: 45,
            lc30: 29.5,
            lc10: 15.5
        },
        "marigold.800": {
            contrast: 85.1665047781576,
            lc60: 65,
            lc45: 48,
            lc30: 32,
            lc10: 16.5
        },
        "marigold.900": {
            contrast: 80.60787245079733,
            lc60: 69.5,
            lc45: 51,
            lc30: 33.5,
            lc10: 18
        },
        "marigold.1000": {
            contrast: 76.27086573075145,
            lc60: 74,
            lc45: 54,
            lc30: 36,
            lc10: 19
        },
        "marigold.1100": {
            contrast: 71.69250139187359,
            lc60: 80,
            lc45: 58,
            lc30: 38.5,
            lc10: 20
        },
        "marigold.1200": {
            contrast: 66.96636266565282,
            lc60: 87,
            lc45: 62.5,
            lc30: 41,
            lc10: 21
        },
        "marigold.1300": {
            contrast: 62.09845275819232,
            lc60: 95,
            lc45: 68,
            lc30: 44.5,
            lc10: 23.5
        },
        "marigold.1400": {
            contrast: 57.62897536497251,
            lc60: 100,
            lc45: 74,
            lc30: 48,
            lc10: 25
        },
        "marigold.1500": {
            contrast: 52.79450834792661,
            lc60: 100,
            lc45: 82.5,
            lc30: 52.5,
            lc10: 27.5
        },
        "marigold.1600": {
            contrast: 48.22199714802916,
            lc60: 100,
            lc45: 92,
            lc30: 58.5,
            lc10: 30
        },
        "marigold.1700": {
            contrast: 43.45345848557031,
            lc60: 100,
            lc45: 100,
            lc30: 65.5,
            lc10: 33.5
        },
        "marigold.1800": {
            contrast: 37.02555874239189,
            lc60: 100,
            lc45: 100,
            lc30: 79,
            lc10: 39.5
        },
        "marigold.1900": {
            contrast: 32.68399118893947,
            lc60: 100,
            lc45: 100,
            lc30: 90.5,
            lc10: 45.5
        },
        "marigold.2000": {
            contrast: 26.88587876254956,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "marigold.2100": {
            contrast: 21.1622405677919,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "marigold.2200": {
            contrast: 15.318296355213779,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98.5
        },
        "marigold.2300": {
            contrast: 9.29014612648781,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    }
};
const $f8fd43f1ee3f8cd8$var$orange = {
    "orange.100": {
        "orange.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.600": {
            contrast: 8.075873581658634,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.700": {
            contrast: 12.150668498133674,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.800": {
            contrast: 16.695149017978974,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 94.5
        },
        "orange.900": {
            contrast: 21.02213922368927,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84
        },
        "orange.1000": {
            contrast: 25.233026527246516,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76.5
        },
        "orange.1100": {
            contrast: 29.640505142740587,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69.5
        },
        "orange.1200": {
            contrast: 34.23571041575511,
            lc60: 100,
            lc45: 100,
            lc30: 92.5,
            lc10: 64.5
        },
        "orange.1300": {
            contrast: 39.20781801855704,
            lc60: 100,
            lc45: 100,
            lc30: 85.5,
            lc10: 59.5
        },
        "orange.1400": {
            contrast: 43.508208043077055,
            lc60: 100,
            lc45: 100,
            lc30: 80.5,
            lc10: 56
        },
        "orange.1500": {
            contrast: 48.352381967684664,
            lc60: 100,
            lc45: 95.5,
            lc30: 75.5,
            lc10: 52.5
        },
        "orange.1600": {
            contrast: 51.460489800053075,
            lc60: 100,
            lc45: 92,
            lc30: 73,
            lc10: 50.5
        },
        "orange.1700": {
            contrast: 56.25177927596776,
            lc60: 100,
            lc45: 87,
            lc30: 69,
            lc10: 48
        },
        "orange.1800": {
            contrast: 63.03332280701394,
            lc60: 97,
            lc45: 81.5,
            lc30: 64.5,
            lc10: 45
        },
        "orange.1900": {
            contrast: 69.51942763834877,
            lc60: 91,
            lc45: 76.5,
            lc30: 60.5,
            lc10: 42.5
        },
        "orange.2000": {
            contrast: 75.35873133307595,
            lc60: 87,
            lc45: 73,
            lc30: 57.5,
            lc10: 40
        },
        "orange.2100": {
            contrast: 81.56506167439983,
            lc60: 82.5,
            lc45: 69.5,
            lc30: 55,
            lc10: 38
        },
        "orange.2200": {
            contrast: 87.73630939720172,
            lc60: 78.5,
            lc45: 66,
            lc30: 52.5,
            lc10: 36.5
        },
        "orange.2300": {
            contrast: 94.1572936264026,
            lc60: 75.5,
            lc45: 63.5,
            lc30: 50,
            lc10: 35
        },
        "orange.2400": {
            contrast: 100.87823369975094,
            lc60: 72,
            lc45: 60.5,
            lc30: 48,
            lc10: 33.5
        },
        "orange.2500": {
            contrast: 107.88473318309848,
            lc60: 69,
            lc45: 58,
            lc30: 46,
            lc10: 32
        }
    },
    "orange.200": {
        "orange.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.600": {
            contrast: 7.715142203439404,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.700": {
            contrast: 11.789937119914445,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.800": {
            contrast: 16.334417639759742,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95.5
        },
        "orange.900": {
            contrast: 20.661407845470038,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83
        },
        "orange.1000": {
            contrast: 24.872295149027288,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74
        },
        "orange.1100": {
            contrast: 29.279773764521348,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66.5
        },
        "orange.1200": {
            contrast: 33.87497903753588,
            lc60: 100,
            lc45: 100,
            lc30: 92.5,
            lc10: 60.5
        },
        "orange.1300": {
            contrast: 38.84708664033781,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 55.5
        },
        "orange.1400": {
            contrast: 43.14747666485782,
            lc60: 100,
            lc45: 100,
            lc30: 79,
            lc10: 51.5
        },
        "orange.1500": {
            contrast: 47.99165058946543,
            lc60: 100,
            lc45: 95.5,
            lc30: 74,
            lc10: 48.5
        },
        "orange.1600": {
            contrast: 51.09975842183384,
            lc60: 100,
            lc45: 91.5,
            lc30: 71,
            lc10: 46.5
        },
        "orange.1700": {
            contrast: 55.891047897748535,
            lc60: 100,
            lc45: 86.5,
            lc30: 66.5,
            lc10: 44
        },
        "orange.1800": {
            contrast: 62.672591428794696,
            lc60: 97,
            lc45: 80.5,
            lc30: 62,
            lc10: 40.5
        },
        "orange.1900": {
            contrast: 69.15869626012953,
            lc60: 91,
            lc45: 75.5,
            lc30: 58,
            lc10: 38.5
        },
        "orange.2000": {
            contrast: 74.99799995485672,
            lc60: 86,
            lc45: 71.5,
            lc30: 55.5,
            lc10: 36.5
        },
        "orange.2100": {
            contrast: 81.2043302961806,
            lc60: 81.5,
            lc45: 67.5,
            lc30: 52.5,
            lc10: 35
        },
        "orange.2200": {
            contrast: 87.37557801898251,
            lc60: 78,
            lc45: 64.5,
            lc30: 50,
            lc10: 33
        },
        "orange.2300": {
            contrast: 93.79656224818336,
            lc60: 74,
            lc45: 61.5,
            lc30: 48,
            lc10: 31.5
        },
        "orange.2400": {
            contrast: 100.51750232153171,
            lc60: 71,
            lc45: 59,
            lc30: 45.5,
            lc10: 30.5
        },
        "orange.2500": {
            contrast: 107.52400180487925,
            lc60: 68,
            lc45: 56.5,
            lc30: 43.5,
            lc10: 29
        }
    },
    "orange.300": {
        "orange.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.700": {
            contrast: 10.694082337750405,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.800": {
            contrast: 15.238562857595703,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98.5
        },
        "orange.900": {
            contrast: 19.565553063305995,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83.5
        },
        "orange.1000": {
            contrast: 23.77644036686325,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "orange.1100": {
            contrast: 28.18391898235731,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65
        },
        "orange.1200": {
            contrast: 32.77912425537183,
            lc60: 100,
            lc45: 100,
            lc30: 94,
            lc10: 58.5
        },
        "orange.1300": {
            contrast: 37.75123185817377,
            lc60: 100,
            lc45: 100,
            lc30: 85.5,
            lc10: 53
        },
        "orange.1400": {
            contrast: 42.05162188269378,
            lc60: 100,
            lc45: 100,
            lc30: 79,
            lc10: 49
        },
        "orange.1500": {
            contrast: 46.89579580730138,
            lc60: 100,
            lc45: 97,
            lc30: 73,
            lc10: 46
        },
        "orange.1600": {
            contrast: 50.0039036396698,
            lc60: 100,
            lc45: 92.5,
            lc30: 69.5,
            lc10: 43.5
        },
        "orange.1700": {
            contrast: 54.79519311558448,
            lc60: 100,
            lc45: 87,
            lc30: 65.5,
            lc10: 41
        },
        "orange.1800": {
            contrast: 61.57673664663066,
            lc60: 98,
            lc45: 80,
            lc30: 60.5,
            lc10: 38.5
        },
        "orange.1900": {
            contrast: 68.06284147796549,
            lc60: 91.5,
            lc45: 74.5,
            lc30: 56.5,
            lc10: 35.5
        },
        "orange.2000": {
            contrast: 73.90214517269268,
            lc60: 86,
            lc45: 71,
            lc30: 53.5,
            lc10: 34
        },
        "orange.2100": {
            contrast: 80.10847551401655,
            lc60: 81.5,
            lc45: 67,
            lc30: 50.5,
            lc10: 32.5
        },
        "orange.2200": {
            contrast: 86.27972323681846,
            lc60: 77.5,
            lc45: 64,
            lc30: 48,
            lc10: 30.5
        },
        "orange.2300": {
            contrast: 92.70070746601932,
            lc60: 74,
            lc45: 61,
            lc30: 46,
            lc10: 29
        },
        "orange.2400": {
            contrast: 99.42164753936765,
            lc60: 70.5,
            lc45: 58,
            lc30: 44,
            lc10: 28
        },
        "orange.2500": {
            contrast: 106.4281470227152,
            lc60: 67,
            lc45: 55.5,
            lc30: 42,
            lc10: 27
        }
    },
    "orange.400": {
        "orange.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.700": {
            contrast: 8.975066682250308,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.800": {
            contrast: 13.519547202095605,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.900": {
            contrast: 17.8465374078059,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88
        },
        "orange.1000": {
            contrast: 22.05742471136315,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74.5
        },
        "orange.1100": {
            contrast: 26.464903326857215,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65.5
        },
        "orange.1200": {
            contrast: 31.06010859987174,
            lc60: 100,
            lc45: 100,
            lc30: 97,
            lc10: 58
        },
        "orange.1300": {
            contrast: 36.03221620267367,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 52
        },
        "orange.1400": {
            contrast: 40.332606227193686,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 48
        },
        "orange.1500": {
            contrast: 45.176780151801296,
            lc60: 100,
            lc45: 99.5,
            lc30: 73.5,
            lc10: 44
        },
        "orange.1600": {
            contrast: 48.2848879841697,
            lc60: 100,
            lc45: 94.5,
            lc30: 70,
            lc10: 42
        },
        "orange.1700": {
            contrast: 53.076177460084395,
            lc60: 100,
            lc45: 88.5,
            lc30: 65.5,
            lc10: 39
        },
        "orange.1800": {
            contrast: 59.857720991130556,
            lc60: 100,
            lc45: 81,
            lc30: 60,
            lc10: 36
        },
        "orange.1900": {
            contrast: 66.34382582246539,
            lc60: 92.5,
            lc45: 75.5,
            lc30: 56,
            lc10: 33.5
        },
        "orange.2000": {
            contrast: 72.18312951719258,
            lc60: 87,
            lc45: 70.5,
            lc30: 53,
            lc10: 32
        },
        "orange.2100": {
            contrast: 78.38945985851647,
            lc60: 82,
            lc45: 66.5,
            lc30: 49.5,
            lc10: 30.5
        },
        "orange.2200": {
            contrast: 84.56070758131837,
            lc60: 78,
            lc45: 63.5,
            lc30: 47.5,
            lc10: 29
        },
        "orange.2300": {
            contrast: 90.98169181051924,
            lc60: 74,
            lc45: 60,
            lc30: 45,
            lc10: 27.5
        },
        "orange.2400": {
            contrast: 97.70263188386755,
            lc60: 70.5,
            lc45: 57.5,
            lc30: 43,
            lc10: 26.5
        },
        "orange.2500": {
            contrast: 104.7091313672151,
            lc60: 67,
            lc45: 54.5,
            lc30: 41,
            lc10: 25
        }
    },
    "orange.500": {
        "orange.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.800": {
            contrast: 10.867181945079492,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.900": {
            contrast: 15.194172150789786,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98.5
        },
        "orange.1000": {
            contrast: 19.40505945434704,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81
        },
        "orange.1100": {
            contrast: 23.812538069841104,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "orange.1200": {
            contrast: 28.40774334285563,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "orange.1300": {
            contrast: 33.37985094565756,
            lc60: 100,
            lc45: 100,
            lc30: 91.5,
            lc10: 53
        },
        "orange.1400": {
            contrast: 37.68024097017757,
            lc60: 100,
            lc45: 100,
            lc30: 83,
            lc10: 48
        },
        "orange.1500": {
            contrast: 42.52441489478518,
            lc60: 100,
            lc45: 100,
            lc30: 76,
            lc10: 43.5
        },
        "orange.1600": {
            contrast: 45.63252272715359,
            lc60: 100,
            lc45: 99,
            lc30: 72,
            lc10: 41.5
        },
        "orange.1700": {
            contrast: 50.42381220306829,
            lc60: 100,
            lc45: 91.5,
            lc30: 66.5,
            lc10: 38.5
        },
        "orange.1800": {
            contrast: 57.20535573411445,
            lc60: 100,
            lc45: 83,
            lc30: 60.5,
            lc10: 35.5
        },
        "orange.1900": {
            contrast: 63.69146056544929,
            lc60: 95.5,
            lc45: 76.5,
            lc30: 56,
            lc10: 32.5
        },
        "orange.2000": {
            contrast: 69.53076426017647,
            lc60: 89.5,
            lc45: 72,
            lc30: 52.5,
            lc10: 31
        },
        "orange.2100": {
            contrast: 75.73709460150036,
            lc60: 84,
            lc45: 67.5,
            lc30: 49.5,
            lc10: 29
        },
        "orange.2200": {
            contrast: 81.90834232430225,
            lc60: 79,
            lc45: 64,
            lc30: 46.5,
            lc10: 28
        },
        "orange.2300": {
            contrast: 88.32932655350312,
            lc60: 75,
            lc45: 60.5,
            lc30: 44.5,
            lc10: 26.5
        },
        "orange.2400": {
            contrast: 95.05026662685144,
            lc60: 71,
            lc45: 57.5,
            lc30: 42,
            lc10: 25
        },
        "orange.2500": {
            contrast: 102.05676611019898,
            lc60: 67.5,
            lc45: 54.5,
            lc30: 40,
            lc10: 24
        }
    },
    "orange.600": {
        "orange.100": {
            contrast: 9.40216725946286,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.200": {
            contrast: 8.91807859056306,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.300": {
            contrast: 7.480036832289944,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.900": {
            contrast: 11.607236284541017,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1000": {
            contrast: 15.81812358809827,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95.5
        },
        "orange.1100": {
            contrast: 20.225602203592334,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77.5
        },
        "orange.1200": {
            contrast: 24.820807476606863,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65.5
        },
        "orange.1300": {
            contrast: 29.79291507940879,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "orange.1400": {
            contrast: 34.0933051039288,
            lc60: 100,
            lc45: 100,
            lc30: 90,
            lc10: 50.5
        },
        "orange.1500": {
            contrast: 38.93747902853641,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 45.5
        },
        "orange.1600": {
            contrast: 42.04558686090482,
            lc60: 100,
            lc45: 100,
            lc30: 76,
            lc10: 43
        },
        "orange.1700": {
            contrast: 46.83687633681951,
            lc60: 100,
            lc45: 97,
            lc30: 69.5,
            lc10: 39.5
        },
        "orange.1800": {
            contrast: 53.61841986786568,
            lc60: 100,
            lc45: 87,
            lc30: 63,
            lc10: 35.5
        },
        "orange.1900": {
            contrast: 60.104524699200525,
            lc60: 99.5,
            lc45: 79.5,
            lc30: 58,
            lc10: 33
        },
        "orange.2000": {
            contrast: 65.9438283939277,
            lc60: 93,
            lc45: 74.5,
            lc30: 54.5,
            lc10: 31
        },
        "orange.2100": {
            contrast: 72.15015873525158,
            lc60: 87,
            lc45: 69.5,
            lc30: 50.5,
            lc10: 29
        },
        "orange.2200": {
            contrast: 78.32140645805349,
            lc60: 81.5,
            lc45: 65.5,
            lc30: 48,
            lc10: 27.5
        },
        "orange.2300": {
            contrast: 84.74239068725434,
            lc60: 77,
            lc45: 62,
            lc30: 45,
            lc10: 26
        },
        "orange.2400": {
            contrast: 91.46333076060267,
            lc60: 72.5,
            lc45: 58.5,
            lc30: 42.5,
            lc10: 25
        },
        "orange.2500": {
            contrast: 98.46983024395021,
            lc60: 69,
            lc45: 55.5,
            lc30: 40.5,
            lc10: 24
        }
    },
    "orange.700": {
        "orange.100": {
            contrast: 13.848021976937272,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.200": {
            contrast: 13.36393330803747,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.300": {
            contrast: 11.925891549764355,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.400": {
            contrast: 9.746669911529459,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.900": {
            contrast: 7.720286682838301,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1000": {
            contrast: 11.931173986395551,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1100": {
            contrast: 16.338652601889617,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93
        },
        "orange.1200": {
            contrast: 20.933857874904145,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75.5
        },
        "orange.1300": {
            contrast: 25.90596547770608,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63
        },
        "orange.1400": {
            contrast: 30.206355502226078,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 55.5
        },
        "orange.1500": {
            contrast: 35.05052942683369,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 49
        },
        "orange.1600": {
            contrast: 38.1586372592021,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 45
        },
        "orange.1700": {
            contrast: 42.94992673511679,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 41
        },
        "orange.1800": {
            contrast: 49.73147026616297,
            lc60: 100,
            lc45: 92,
            lc30: 66.5,
            lc10: 37
        },
        "orange.1900": {
            contrast: 56.21757509749779,
            lc60: 100,
            lc45: 83.5,
            lc30: 60,
            lc10: 34
        },
        "orange.2000": {
            contrast: 62.05687879222498,
            lc60: 97,
            lc45: 77.5,
            lc30: 56,
            lc10: 31.5
        },
        "orange.2100": {
            contrast: 68.26320913354887,
            lc60: 90,
            lc45: 72,
            lc30: 52,
            lc10: 29.5
        },
        "orange.2200": {
            contrast: 74.43445685635076,
            lc60: 84.5,
            lc45: 68,
            lc30: 49,
            lc10: 28
        },
        "orange.2300": {
            contrast: 80.85544108555163,
            lc60: 79.5,
            lc45: 63.5,
            lc30: 46,
            lc10: 26.5
        },
        "orange.2400": {
            contrast: 87.57638115889995,
            lc60: 75,
            lc45: 60,
            lc30: 43.5,
            lc10: 25
        },
        "orange.2500": {
            contrast: 94.58288064224749,
            lc60: 70.5,
            lc45: 56.5,
            lc30: 41.5,
            lc10: 23.5
        }
    },
    "orange.800": {
        "orange.100": {
            contrast: 18.6942981939604,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "orange.200": {
            contrast: 18.2102095250606,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "orange.300": {
            contrast: 16.772167766787483,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84
        },
        "orange.400": {
            contrast: 14.592946128552587,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.500": {
            contrast: 11.361155857855568,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1000": {
            contrast: 7.546388186112997,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1100": {
            contrast: 11.953866801607063,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1200": {
            contrast: 16.549072074621588,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 92
        },
        "orange.1300": {
            contrast: 21.521179677423522,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "orange.1400": {
            contrast: 25.82156970194353,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "orange.1500": {
            contrast: 30.665743626551134,
            lc60: 100,
            lc45: 100,
            lc30: 98.5,
            lc10: 54
        },
        "orange.1600": {
            contrast: 33.77385145891955,
            lc60: 100,
            lc45: 100,
            lc30: 90.5,
            lc10: 49.5
        },
        "orange.1700": {
            contrast: 38.56514093483424,
            lc60: 100,
            lc45: 100,
            lc30: 80.5,
            lc10: 44.5
        },
        "orange.1800": {
            contrast: 45.34668446588041,
            lc60: 100,
            lc45: 99,
            lc30: 70.5,
            lc10: 39.5
        },
        "orange.1900": {
            contrast: 51.83278929721526,
            lc60: 100,
            lc45: 89,
            lc30: 63.5,
            lc10: 35.5
        },
        "orange.2000": {
            contrast: 57.67209299194243,
            lc60: 100,
            lc45: 81.5,
            lc30: 58.5,
            lc10: 33
        },
        "orange.2100": {
            contrast: 63.87842333326632,
            lc60: 95,
            lc45: 75.5,
            lc30: 54,
            lc10: 31
        },
        "orange.2200": {
            contrast: 70.04967105606819,
            lc60: 88,
            lc45: 70.5,
            lc30: 50.5,
            lc10: 29
        },
        "orange.2300": {
            contrast: 76.47065528526909,
            lc60: 82.5,
            lc45: 66,
            lc30: 48,
            lc10: 27.5
        },
        "orange.2400": {
            contrast: 83.1915953586174,
            lc60: 77.5,
            lc45: 62,
            lc30: 45,
            lc10: 26
        },
        "orange.2500": {
            contrast: 90.19809484196493,
            lc60: 73,
            lc45: 58.5,
            lc30: 42.5,
            lc10: 24
        }
    },
    "orange.900": {
        "orange.100": {
            contrast: 23.221759058276245,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 44.5
        },
        "orange.200": {
            contrast: 22.737670389376444,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 52
        },
        "orange.300": {
            contrast: 21.299628631103328,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61.5
        },
        "orange.400": {
            contrast: 19.120406992868435,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74
        },
        "orange.500": {
            contrast: 15.888616722171417,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93.5
        },
        "orange.600": {
            contrast: 11.693349759077847,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.700": {
            contrast: 7.308395465159122,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1100": {
            contrast: 7.739084179235942,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1200": {
            contrast: 12.334289452250468,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1300": {
            contrast: 17.3063970550524,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89
        },
        "orange.1400": {
            contrast: 21.606787079572413,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73
        },
        "orange.1500": {
            contrast: 26.45096100418002,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61
        },
        "orange.1600": {
            contrast: 29.55906883654843,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "orange.1700": {
            contrast: 34.35035831246312,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 48.5
        },
        "orange.1800": {
            contrast: 41.1319018435093,
            lc60: 100,
            lc45: 100,
            lc30: 76,
            lc10: 42
        },
        "orange.1900": {
            contrast: 47.618006674844125,
            lc60: 100,
            lc45: 95.5,
            lc30: 68,
            lc10: 38
        },
        "orange.2000": {
            contrast: 53.45731036957131,
            lc60: 100,
            lc45: 86.5,
            lc30: 62,
            lc10: 34.5
        },
        "orange.2100": {
            contrast: 59.663640710895194,
            lc60: 100,
            lc45: 79.5,
            lc30: 57.5,
            lc10: 32
        },
        "orange.2200": {
            contrast: 65.83488843369709,
            lc60: 92.5,
            lc45: 73.5,
            lc30: 53,
            lc10: 30
        },
        "orange.2300": {
            contrast: 72.25587266289796,
            lc60: 86,
            lc45: 69,
            lc30: 49.5,
            lc10: 28
        },
        "orange.2400": {
            contrast: 78.97681273624629,
            lc60: 80.5,
            lc45: 64,
            lc30: 46.5,
            lc10: 26.5
        },
        "orange.2500": {
            contrast: 85.98331221959381,
            lc60: 75.5,
            lc45: 60.5,
            lc30: 43.5,
            lc10: 25
        }
    },
    "orange.1000": {
        "orange.100": {
            contrast: 27.560785244775293,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 38.5
        },
        "orange.200": {
            contrast: 27.0766965758755,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 44.5
        },
        "orange.300": {
            contrast: 25.63865481760238,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51.5
        },
        "orange.400": {
            contrast: 23.459433179367487,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "orange.500": {
            contrast: 20.22764290867047,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "orange.600": {
            contrast: 16.0323759455769,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93
        },
        "orange.700": {
            contrast: 11.647421651658174,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1200": {
            contrast: 8.201086127649619,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1300": {
            contrast: 13.173193730451551,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1400": {
            contrast: 17.473583754971564,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87
        },
        "orange.1500": {
            contrast: 22.317757679579167,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69.5
        },
        "orange.1600": {
            contrast: 25.42586551194758,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63
        },
        "orange.1700": {
            contrast: 30.217154987862273,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 53.5
        },
        "orange.1800": {
            contrast: 36.99869851890844,
            lc60: 100,
            lc45: 100,
            lc30: 83.5,
            lc10: 45.5
        },
        "orange.1900": {
            contrast: 43.484803350243276,
            lc60: 100,
            lc45: 100,
            lc30: 73,
            lc10: 40.5
        },
        "orange.2000": {
            contrast: 49.32410704497047,
            lc60: 100,
            lc45: 93,
            lc30: 66.5,
            lc10: 37
        },
        "orange.2100": {
            contrast: 55.53043738629434,
            lc60: 100,
            lc45: 84,
            lc30: 60.5,
            lc10: 33.5
        },
        "orange.2200": {
            contrast: 61.70168510909624,
            lc60: 98,
            lc45: 77.5,
            lc30: 56,
            lc10: 31
        },
        "orange.2300": {
            contrast: 68.12266933829711,
            lc60: 90,
            lc45: 72,
            lc30: 52,
            lc10: 29
        },
        "orange.2400": {
            contrast: 74.84360941164545,
            lc60: 84,
            lc45: 67.5,
            lc30: 48.5,
            lc10: 27
        },
        "orange.2500": {
            contrast: 81.85010889499297,
            lc60: 78.5,
            lc45: 63,
            lc30: 45,
            lc10: 25.5
        }
    },
    "orange.1100": {
        "orange.100": {
            contrast: 32.04229998359682,
            lc60: 100,
            lc45: 100,
            lc30: 76,
            lc10: 33.5
        },
        "orange.200": {
            contrast: 31.558211314697026,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 38.5
        },
        "orange.300": {
            contrast: 30.12016955642391,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 44
        },
        "orange.400": {
            contrast: 27.940947918189014,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 50.5
        },
        "orange.500": {
            contrast: 24.709157647492,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "orange.600": {
            contrast: 20.51389068439843,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73
        },
        "orange.700": {
            contrast: 16.128936390479705,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93
        },
        "orange.800": {
            contrast: 11.330800215403771,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1300": {
            contrast: 8.818125736199514,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1400": {
            contrast: 13.118515760719527,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1500": {
            contrast: 17.96268968532713,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84.5
        },
        "orange.1600": {
            contrast: 21.070797517695546,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74
        },
        "orange.1700": {
            contrast: 25.862086993610234,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61.5
        },
        "orange.1800": {
            contrast: 32.64363052465641,
            lc60: 100,
            lc45: 100,
            lc30: 93.5,
            lc10: 50.5
        },
        "orange.1900": {
            contrast: 39.129735355991244,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 44
        },
        "orange.2000": {
            contrast: 44.96903905071842,
            lc60: 100,
            lc45: 100,
            lc30: 71.5,
            lc10: 40
        },
        "orange.2100": {
            contrast: 51.1753693920423,
            lc60: 100,
            lc45: 89.5,
            lc30: 64.5,
            lc10: 36
        },
        "orange.2200": {
            contrast: 57.3466171148442,
            lc60: 100,
            lc45: 82,
            lc30: 59,
            lc10: 33
        },
        "orange.2300": {
            contrast: 63.767601344045076,
            lc60: 95,
            lc45: 76,
            lc30: 54.5,
            lc10: 30.5
        },
        "orange.2400": {
            contrast: 70.4885414173934,
            lc60: 87.5,
            lc45: 70,
            lc30: 50.5,
            lc10: 28.5
        },
        "orange.2500": {
            contrast: 77.49504090074093,
            lc60: 82,
            lc45: 65.5,
            lc30: 47.5,
            lc10: 27
        }
    },
    "orange.1200": {
        "orange.100": {
            contrast: 36.658061044497195,
            lc60: 100,
            lc45: 100,
            lc30: 61.5,
            lc10: 29.5
        },
        "orange.200": {
            contrast: 36.173972375597394,
            lc60: 100,
            lc45: 100,
            lc30: 69.5,
            lc10: 33.5
        },
        "orange.300": {
            contrast: 34.73593061732427,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 37.5
        },
        "orange.400": {
            contrast: 32.556708979089386,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 43
        },
        "orange.500": {
            contrast: 29.324918708392367,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 50
        },
        "orange.600": {
            contrast: 25.129651745298798,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "orange.700": {
            contrast: 20.744697451380073,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72
        },
        "orange.800": {
            contrast: 15.946561276304141,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 94
        },
        "orange.900": {
            contrast: 11.449845736086095,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1400": {
            contrast: 8.550186396090345,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1500": {
            contrast: 13.39436032069795,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1600": {
            contrast: 16.502468153066363,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91
        },
        "orange.1700": {
            contrast: 21.29375762898105,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73
        },
        "orange.1800": {
            contrast: 28.075301160027223,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "orange.1900": {
            contrast: 34.56140599136206,
            lc60: 100,
            lc45: 100,
            lc30: 89,
            lc10: 48.5
        },
        "orange.2000": {
            contrast: 40.40070968608924,
            lc60: 100,
            lc45: 100,
            lc30: 77.5,
            lc10: 43.5
        },
        "orange.2100": {
            contrast: 46.60704002741312,
            lc60: 100,
            lc45: 97,
            lc30: 69.5,
            lc10: 39
        },
        "orange.2200": {
            contrast: 52.778287750215014,
            lc60: 100,
            lc45: 87.5,
            lc30: 63.5,
            lc10: 35
        },
        "orange.2300": {
            contrast: 59.19927197941588,
            lc60: 100,
            lc45: 80.5,
            lc30: 58,
            lc10: 32.5
        },
        "orange.2400": {
            contrast: 65.92021205276423,
            lc60: 92.5,
            lc45: 74,
            lc30: 53.5,
            lc10: 30
        },
        "orange.2500": {
            contrast: 72.92671153611175,
            lc60: 86,
            lc45: 68.5,
            lc30: 49.5,
            lc10: 28
        }
    },
    "orange.1300": {
        "orange.100": {
            contrast: 41.595480885569195,
            lc60: 100,
            lc45: 100,
            lc30: 53.5,
            lc10: 26.5
        },
        "orange.200": {
            contrast: 41.1113922166694,
            lc60: 100,
            lc45: 100,
            lc30: 60,
            lc10: 29.5
        },
        "orange.300": {
            contrast: 39.67335045839628,
            lc60: 100,
            lc45: 100,
            lc30: 67,
            lc10: 33
        },
        "orange.400": {
            contrast: 37.494128820161386,
            lc60: 100,
            lc45: 100,
            lc30: 75,
            lc10: 37
        },
        "orange.500": {
            contrast: 34.26233854946437,
            lc60: 100,
            lc45: 100,
            lc30: 86,
            lc10: 42
        },
        "orange.600": {
            contrast: 30.067071586370798,
            lc60: 100,
            lc45: 100,
            lc30: 99.5,
            lc10: 49.5
        },
        "orange.700": {
            contrast: 25.682117292452073,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58
        },
        "orange.800": {
            contrast: 20.883981117376145,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72
        },
        "orange.900": {
            contrast: 16.3872655771581,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 92
        },
        "orange.1000": {
            contrast: 12.066690481342974,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1100": {
            contrast: 7.5943155506857245,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1500": {
            contrast: 8.422919200436333,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1600": {
            contrast: 11.531027032804747,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1700": {
            contrast: 16.322316508719435,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 92.5
        },
        "orange.1800": {
            contrast: 23.103860039765607,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "orange.1900": {
            contrast: 29.589964871100445,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "orange.2000": {
            contrast: 35.42926856582763,
            lc60: 100,
            lc45: 100,
            lc30: 87.5,
            lc10: 48.5
        },
        "orange.2100": {
            contrast: 41.635598907151504,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 42.5
        },
        "orange.2200": {
            contrast: 47.806846629953405,
            lc60: 100,
            lc45: 95,
            lc30: 69,
            lc10: 38.5
        },
        "orange.2300": {
            contrast: 54.22783085915427,
            lc60: 100,
            lc45: 86.5,
            lc30: 62.5,
            lc10: 35.5
        },
        "orange.2400": {
            contrast: 60.9487709325026,
            lc60: 98.5,
            lc45: 79,
            lc30: 57.5,
            lc10: 32
        },
        "orange.2500": {
            contrast: 67.95527041585014,
            lc60: 91,
            lc45: 73,
            lc30: 52.5,
            lc10: 30
        }
    },
    "orange.1400": {
        "orange.100": {
            contrast: 45.8235125665224,
            lc60: 100,
            lc45: 87,
            lc30: 49,
            lc10: 24.5
        },
        "orange.200": {
            contrast: 45.3394238976226,
            lc60: 100,
            lc45: 96.5,
            lc30: 54,
            lc10: 27
        },
        "orange.300": {
            contrast: 43.90138213934948,
            lc60: 100,
            lc45: 100,
            lc30: 60,
            lc10: 30
        },
        "orange.400": {
            contrast: 41.722160501114594,
            lc60: 100,
            lc45: 100,
            lc30: 66,
            lc10: 33.5
        },
        "orange.500": {
            contrast: 38.490370230417575,
            lc60: 100,
            lc45: 100,
            lc30: 75,
            lc10: 38
        },
        "orange.600": {
            contrast: 34.29510326732401,
            lc60: 100,
            lc45: 100,
            lc30: 86,
            lc10: 43
        },
        "orange.700": {
            contrast: 29.91014897340528,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 50
        },
        "orange.800": {
            contrast: 25.112012798329346,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60.5
        },
        "orange.900": {
            contrast: 20.615297258111305,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "orange.1000": {
            contrast: 16.29472216229618,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 92
        },
        "orange.1100": {
            contrast: 11.822347231638933,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1700": {
            contrast: 12.001025319733266,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1800": {
            contrast: 18.78256885077944,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82.5
        },
        "orange.1900": {
            contrast: 25.268673682114272,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64.5
        },
        "orange.2000": {
            contrast: 31.107977376841454,
            lc60: 100,
            lc45: 100,
            lc30: 96.5,
            lc10: 55.5
        },
        "orange.2100": {
            contrast: 37.31430771816534,
            lc60: 100,
            lc45: 100,
            lc30: 84,
            lc10: 48
        },
        "orange.2200": {
            contrast: 43.48555544096723,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 42
        },
        "orange.2300": {
            contrast: 49.9065396701681,
            lc60: 100,
            lc45: 92,
            lc30: 67,
            lc10: 38.5
        },
        "orange.2400": {
            contrast: 56.62747974351643,
            lc60: 100,
            lc45: 83.5,
            lc30: 61,
            lc10: 34.5
        },
        "orange.2500": {
            contrast: 63.63397922686396,
            lc60: 95,
            lc45: 76.5,
            lc30: 55.5,
            lc10: 32
        }
    },
    "orange.1500": {
        "orange.100": {
            contrast: 50.543994820474026,
            lc60: 100,
            lc45: 71.5,
            lc30: 44,
            lc10: 22
        },
        "orange.200": {
            contrast: 50.05990615157423,
            lc60: 100,
            lc45: 78.5,
            lc30: 48.5,
            lc10: 25
        },
        "orange.300": {
            contrast: 48.62186439330111,
            lc60: 100,
            lc45: 86,
            lc30: 53.5,
            lc10: 27
        },
        "orange.400": {
            contrast: 46.44264275506621,
            lc60: 100,
            lc45: 94.5,
            lc30: 59,
            lc10: 29.5
        },
        "orange.500": {
            contrast: 43.21085248436919,
            lc60: 100,
            lc45: 100,
            lc30: 66,
            lc10: 33.5
        },
        "orange.600": {
            contrast: 39.015585521275625,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 37.5
        },
        "orange.700": {
            contrast: 34.63063122735689,
            lc60: 100,
            lc45: 100,
            lc30: 85,
            lc10: 43.5
        },
        "orange.800": {
            contrast: 29.832495052280965,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 50.5
        },
        "orange.900": {
            contrast: 25.335779512062924,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "orange.1000": {
            contrast: 21.015204416247798,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72
        },
        "orange.1100": {
            contrast: 16.54282948559055,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91.5
        },
        "orange.1200": {
            contrast: 11.927109442285428,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1800": {
            contrast: 13.893148848240292,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1900": {
            contrast: 20.37925367957513,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78
        },
        "orange.2000": {
            contrast: 26.21855737430231,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "orange.2100": {
            contrast: 32.42488771562619,
            lc60: 100,
            lc45: 100,
            lc30: 94.5,
            lc10: 54.5
        },
        "orange.2200": {
            contrast: 38.596135438428085,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 47
        },
        "orange.2300": {
            contrast: 45.01711966762896,
            lc60: 100,
            lc45: 99.5,
            lc30: 73,
            lc10: 41.5
        },
        "orange.2400": {
            contrast: 51.738059740977285,
            lc60: 100,
            lc45: 89.5,
            lc30: 66,
            lc10: 38
        },
        "orange.2500": {
            contrast: 58.7445592243248,
            lc60: 100,
            lc45: 82,
            lc30: 60,
            lc10: 34.5
        }
    },
    "orange.1600": {
        "orange.100": {
            contrast: 53.5511639894776,
            lc60: 100,
            lc45: 66,
            lc30: 42,
            lc10: 21
        },
        "orange.200": {
            contrast: 53.06707532057781,
            lc60: 100,
            lc45: 72.5,
            lc30: 46,
            lc10: 23
        },
        "orange.300": {
            contrast: 51.629033562304684,
            lc60: 100,
            lc45: 79,
            lc30: 50,
            lc10: 25
        },
        "orange.400": {
            contrast: 49.4498119240698,
            lc60: 100,
            lc45: 86.5,
            lc30: 55,
            lc10: 27.5
        },
        "orange.500": {
            contrast: 46.21802165337278,
            lc60: 100,
            lc45: 96.5,
            lc30: 61,
            lc10: 30.5
        },
        "orange.600": {
            contrast: 42.02275469027921,
            lc60: 100,
            lc45: 100,
            lc30: 69,
            lc10: 34.5
        },
        "orange.700": {
            contrast: 37.63780039636048,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 39
        },
        "orange.800": {
            contrast: 32.83966422128455,
            lc60: 100,
            lc45: 100,
            lc30: 90.5,
            lc10: 45.5
        },
        "orange.900": {
            contrast: 28.342948681066503,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53.5
        },
        "orange.1000": {
            contrast: 24.022373585251387,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63
        },
        "orange.1100": {
            contrast: 19.549998654594138,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77.5
        },
        "orange.1200": {
            contrast: 14.934278611289015,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1300": {
            contrast: 9.987459438422675,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1800": {
            contrast: 10.744781397262864,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1900": {
            contrast: 17.230886228597704,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88.5
        },
        "orange.2000": {
            contrast: 23.070189923324882,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "orange.2100": {
            contrast: 29.27652026464876,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58
        },
        "orange.2200": {
            contrast: 35.44776798745065,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 49.5
        },
        "orange.2300": {
            contrast: 41.86875221665153,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 44.5
        },
        "orange.2400": {
            contrast: 48.58969228999985,
            lc60: 100,
            lc45: 94,
            lc30: 68.5,
            lc10: 39.5
        },
        "orange.2500": {
            contrast: 55.59619177334738,
            lc60: 100,
            lc45: 84.5,
            lc30: 61.5,
            lc10: 35.5
        }
    },
    "orange.1700": {
        "orange.100": {
            contrast: 58.156456295737414,
            lc60: 100,
            lc45: 60,
            lc30: 38.5,
            lc10: 19.5
        },
        "orange.200": {
            contrast: 57.6723676268376,
            lc60: 100,
            lc45: 65.5,
            lc30: 42,
            lc10: 21.5
        },
        "orange.300": {
            contrast: 56.23432586856448,
            lc60: 100,
            lc45: 71.5,
            lc30: 46,
            lc10: 23
        },
        "orange.400": {
            contrast: 54.05510423032959,
            lc60: 100,
            lc45: 78,
            lc30: 50,
            lc10: 25
        },
        "orange.500": {
            contrast: 50.82331395963258,
            lc60: 100,
            lc45: 85.5,
            lc30: 55,
            lc10: 27.5
        },
        "orange.600": {
            contrast: 46.628046996539005,
            lc60: 100,
            lc45: 95.5,
            lc30: 61,
            lc10: 31
        },
        "orange.700": {
            contrast: 42.243092702620274,
            lc60: 100,
            lc45: 100,
            lc30: 69,
            lc10: 35
        },
        "orange.800": {
            contrast: 37.44495652754435,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 40
        },
        "orange.900": {
            contrast: 32.94824098732631,
            lc60: 100,
            lc45: 100,
            lc30: 90,
            lc10: 45.5
        },
        "orange.1000": {
            contrast: 28.627665891511178,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53
        },
        "orange.1100": {
            contrast: 24.155290960853932,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63.5
        },
        "orange.1200": {
            contrast: 19.539570917548808,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77.5
        },
        "orange.1300": {
            contrast: 14.59275174468247,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1400": {
            contrast: 10.349626413494454,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1900": {
            contrast: 12.361539916228232,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.2000": {
            contrast: 18.200843610955413,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84.5
        },
        "orange.2100": {
            contrast: 24.40717395227929,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67
        },
        "orange.2200": {
            contrast: 30.578421675081184,
            lc60: 100,
            lc45: 100,
            lc30: 98,
            lc10: 56
        },
        "orange.2300": {
            contrast: 36.99940590428206,
            lc60: 100,
            lc45: 100,
            lc30: 83.5,
            lc10: 48
        },
        "orange.2400": {
            contrast: 43.72034597763038,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 42
        },
        "orange.2500": {
            contrast: 50.72684546097791,
            lc60: 100,
            lc45: 90.5,
            lc30: 65.5,
            lc10: 37
        }
    },
    "orange.1800": {
        "orange.100": {
            contrast: 64.61701752335,
            lc60: 77.5,
            lc45: 54,
            lc30: 35,
            lc10: 18
        },
        "orange.200": {
            contrast: 64.13292885445018,
            lc60: 84,
            lc45: 58,
            lc30: 37.5,
            lc10: 19
        },
        "orange.300": {
            contrast: 62.69488709617708,
            lc60: 90.5,
            lc45: 62.5,
            lc30: 40.5,
            lc10: 20.5
        },
        "orange.400": {
            contrast: 60.51566545794218,
            lc60: 98,
            lc45: 67.5,
            lc30: 44,
            lc10: 22
        },
        "orange.500": {
            contrast: 57.28387518724516,
            lc60: 100,
            lc45: 74,
            lc30: 47.5,
            lc10: 24.5
        },
        "orange.600": {
            contrast: 53.08860822415159,
            lc60: 100,
            lc45: 82,
            lc30: 52.5,
            lc10: 26.5
        },
        "orange.700": {
            contrast: 48.70365393023287,
            lc60: 100,
            lc45: 90.5,
            lc30: 58.5,
            lc10: 29.5
        },
        "orange.800": {
            contrast: 43.90551775515694,
            lc60: 100,
            lc45: 100,
            lc30: 66,
            lc10: 33.5
        },
        "orange.900": {
            contrast: 39.408802214938895,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 37.5
        },
        "orange.1000": {
            contrast: 35.088227119123765,
            lc60: 100,
            lc45: 100,
            lc30: 84,
            lc10: 42.5
        },
        "orange.1100": {
            contrast: 30.61585218846652,
            lc60: 100,
            lc45: 100,
            lc30: 97.5,
            lc10: 49
        },
        "orange.1200": {
            contrast: 26.0001321451614,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "orange.1300": {
            contrast: 21.05331297229506,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "orange.1400": {
            contrast: 16.810187641107042,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 90
        },
        "orange.1500": {
            contrast: 12.065824282347354,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1600": {
            contrast: 9.03983739201478,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.2000": {
            contrast: 11.278089649106912,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.2100": {
            contrast: 17.48441999043079,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87.5
        },
        "orange.2200": {
            contrast: 23.65566771323269,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "orange.2300": {
            contrast: 30.076651942433557,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 55.5
        },
        "orange.2400": {
            contrast: 36.79759201578188,
            lc60: 100,
            lc45: 100,
            lc30: 84,
            lc10: 47
        },
        "orange.2500": {
            contrast: 43.80409149912941,
            lc60: 100,
            lc45: 100,
            lc30: 73.5,
            lc10: 40.5
        }
    },
    "orange.1900": {
        "orange.100": {
            contrast: 70.73884640056399,
            lc60: 68.5,
            lc45: 49,
            lc30: 32,
            lc10: 16.5
        },
        "orange.200": {
            contrast: 70.25475773166417,
            lc60: 73.5,
            lc45: 52.5,
            lc30: 34,
            lc10: 17.5
        },
        "orange.300": {
            contrast: 68.81671597339107,
            lc60: 79,
            lc45: 56.5,
            lc30: 37,
            lc10: 19
        },
        "orange.400": {
            contrast: 66.63749433515616,
            lc60: 85,
            lc45: 60.5,
            lc30: 39.5,
            lc10: 20
        },
        "orange.500": {
            contrast: 63.405704064459144,
            lc60: 92.5,
            lc45: 65.5,
            lc30: 42.5,
            lc10: 21.5
        },
        "orange.600": {
            contrast: 59.21043710136558,
            lc60: 100,
            lc45: 71.5,
            lc30: 46.5,
            lc10: 24
        },
        "orange.700": {
            contrast: 54.82548280744686,
            lc60: 100,
            lc45: 79,
            lc30: 51,
            lc10: 26
        },
        "orange.800": {
            contrast: 50.02734663237093,
            lc60: 100,
            lc45: 88,
            lc30: 56.5,
            lc10: 29
        },
        "orange.900": {
            contrast: 45.53063109215288,
            lc60: 100,
            lc45: 98.5,
            lc30: 63.5,
            lc10: 32.5
        },
        "orange.1000": {
            contrast: 41.21005599633775,
            lc60: 100,
            lc45: 100,
            lc30: 70,
            lc10: 35.5
        },
        "orange.1100": {
            contrast: 36.737681065680505,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 40.5
        },
        "orange.1200": {
            contrast: 32.12196102237538,
            lc60: 100,
            lc45: 100,
            lc30: 93,
            lc10: 46
        },
        "orange.1300": {
            contrast: 27.175141849509043,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54
        },
        "orange.1400": {
            contrast: 22.932016518321028,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64.5
        },
        "orange.1500": {
            contrast: 18.187653159561336,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81.5
        },
        "orange.1600": {
            contrast: 15.161666269228766,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 99
        },
        "orange.1700": {
            contrast: 10.522472949582998,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.2100": {
            contrast: 10.83235919288982,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.2200": {
            contrast: 17.00360691569172,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89
        },
        "orange.2300": {
            contrast: 23.424591144892588,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "orange.2400": {
            contrast: 30.14553121824091,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 55
        },
        "orange.2500": {
            contrast: 37.152030701588444,
            lc60: 100,
            lc45: 100,
            lc30: 83,
            lc10: 46
        }
    },
    "orange.2000": {
        "orange.100": {
            contrast: 76.20673619493331,
            lc60: 62.5,
            lc45: 45.5,
            lc30: 29.5,
            lc10: 15.5
        },
        "orange.200": {
            contrast: 75.7226475260335,
            lc60: 67,
            lc45: 48.5,
            lc30: 31.5,
            lc10: 16
        },
        "orange.300": {
            contrast: 74.28460576776038,
            lc60: 71.5,
            lc45: 51.5,
            lc30: 34,
            lc10: 17.5
        },
        "orange.400": {
            contrast: 72.10538412952549,
            lc60: 76.5,
            lc45: 55,
            lc30: 36,
            lc10: 18.5
        },
        "orange.500": {
            contrast: 68.87359385882847,
            lc60: 83,
            lc45: 59.5,
            lc30: 39,
            lc10: 20
        },
        "orange.600": {
            contrast: 64.67832689573491,
            lc60: 90.5,
            lc45: 64.5,
            lc30: 42,
            lc10: 21.5
        },
        "orange.700": {
            contrast: 60.29337260181619,
            lc60: 99.5,
            lc45: 70.5,
            lc30: 45.5,
            lc10: 23.5
        },
        "orange.800": {
            contrast: 55.495236426740256,
            lc60: 100,
            lc45: 78,
            lc30: 50.5,
            lc10: 26
        },
        "orange.900": {
            contrast: 50.9985208865222,
            lc60: 100,
            lc45: 85.5,
            lc30: 55.5,
            lc10: 28.5
        },
        "orange.1000": {
            contrast: 46.677945790707085,
            lc60: 100,
            lc45: 95.5,
            lc30: 61,
            lc10: 31
        },
        "orange.1100": {
            contrast: 42.20557086004983,
            lc60: 100,
            lc45: 100,
            lc30: 67.5,
            lc10: 35
        },
        "orange.1200": {
            contrast: 37.58985081674471,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 39
        },
        "orange.1300": {
            contrast: 32.643031643878366,
            lc60: 100,
            lc45: 100,
            lc30: 91,
            lc10: 44.5
        },
        "orange.1400": {
            contrast: 28.399906312690355,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51.5
        },
        "orange.1500": {
            contrast: 23.655542953930667,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61
        },
        "orange.1600": {
            contrast: 20.62955606359809,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "orange.1700": {
            contrast: 15.990362743952327,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93
        },
        "orange.1800": {
            contrast: 9.4725892241505,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.2200": {
            contrast: 10.991146131891913,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.2300": {
            contrast: 17.412130361092785,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88.5
        },
        "orange.2400": {
            contrast: 24.13307043444111,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66.5
        },
        "orange.2500": {
            contrast: 31.139569917788634,
            lc60: 100,
            lc45: 100,
            lc30: 96.5,
            lc10: 53.5
        }
    },
    "orange.2100": {
        "orange.100": {
            contrast: 81.97690489555734,
            lc60: 58,
            lc45: 42,
            lc30: 27.5,
            lc10: 14.5
        },
        "orange.200": {
            contrast: 81.49281622665752,
            lc60: 61.5,
            lc45: 44.5,
            lc30: 29,
            lc10: 15.5
        },
        "orange.300": {
            contrast: 80.05477446838441,
            lc60: 65.5,
            lc45: 47.5,
            lc30: 31,
            lc10: 16
        },
        "orange.400": {
            contrast: 77.87555283014952,
            lc60: 69.5,
            lc45: 50.5,
            lc30: 33,
            lc10: 17
        },
        "orange.500": {
            contrast: 74.6437625594525,
            lc60: 75,
            lc45: 54,
            lc30: 35.5,
            lc10: 18.5
        },
        "orange.600": {
            contrast: 70.44849559635892,
            lc60: 81,
            lc45: 58.5,
            lc30: 38,
            lc10: 19.5
        },
        "orange.700": {
            contrast: 66.06354130244021,
            lc60: 88,
            lc45: 63,
            lc30: 41.5,
            lc10: 21.5
        },
        "orange.800": {
            contrast: 61.26540512736428,
            lc60: 97,
            lc45: 69,
            lc30: 44.5,
            lc10: 23
        },
        "orange.900": {
            contrast: 56.768689587146234,
            lc60: 100,
            lc45: 75.5,
            lc30: 49,
            lc10: 25.5
        },
        "orange.1000": {
            contrast: 52.44811449133111,
            lc60: 100,
            lc45: 82.5,
            lc30: 53.5,
            lc10: 27
        },
        "orange.1100": {
            contrast: 47.97573956067386,
            lc60: 100,
            lc45: 92.5,
            lc30: 58.5,
            lc10: 30
        },
        "orange.1200": {
            contrast: 43.360019517368734,
            lc60: 100,
            lc45: 100,
            lc30: 65.5,
            lc10: 33
        },
        "orange.1300": {
            contrast: 38.4132003445024,
            lc60: 100,
            lc45: 100,
            lc30: 75,
            lc10: 37
        },
        "orange.1400": {
            contrast: 34.17007501331438,
            lc60: 100,
            lc45: 100,
            lc30: 85,
            lc10: 41.5
        },
        "orange.1500": {
            contrast: 29.425711654554693,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 48.5
        },
        "orange.1600": {
            contrast: 26.399724764222114,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54
        },
        "orange.1700": {
            contrast: 21.760531444576355,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "orange.1800": {
            contrast: 15.242757924774525,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98.5
        },
        "orange.1900": {
            contrast: 9.057122145442587,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.2300": {
            contrast: 10.998874050400298,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.2400": {
            contrast: 17.719814123748623,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85.5
        },
        "orange.2500": {
            contrast: 24.726313607096152,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        }
    },
    "orange.2200": {
        "orange.100": {
            contrast: 87.67535943583144,
            lc60: 53.5,
            lc45: 39.5,
            lc30: 26,
            lc10: 13.5
        },
        "orange.200": {
            contrast: 87.19127076693162,
            lc60: 56.5,
            lc45: 41.5,
            lc30: 27.5,
            lc10: 14.5
        },
        "orange.300": {
            contrast: 85.75322900865852,
            lc60: 60.5,
            lc45: 44,
            lc30: 29,
            lc10: 15
        },
        "orange.400": {
            contrast: 83.57400737042362,
            lc60: 63.5,
            lc45: 46.5,
            lc30: 30.5,
            lc10: 16
        },
        "orange.500": {
            contrast: 80.3422170997266,
            lc60: 68.5,
            lc45: 49.5,
            lc30: 33,
            lc10: 17
        },
        "orange.600": {
            contrast: 76.14695013663304,
            lc60: 73.5,
            lc45: 53.5,
            lc30: 35,
            lc10: 18
        },
        "orange.700": {
            contrast: 71.76199584271431,
            lc60: 79.5,
            lc45: 57,
            lc30: 37.5,
            lc10: 19.5
        },
        "orange.800": {
            contrast: 66.96385966763839,
            lc60: 86.5,
            lc45: 62,
            lc30: 41,
            lc10: 21
        },
        "orange.900": {
            contrast: 62.46714412742034,
            lc60: 94.5,
            lc45: 67.5,
            lc30: 44,
            lc10: 22.5
        },
        "orange.1000": {
            contrast: 58.146569031605225,
            lc60: 100,
            lc45: 73,
            lc30: 47,
            lc10: 24.5
        },
        "orange.1100": {
            contrast: 53.67419410094796,
            lc60: 100,
            lc45: 80.5,
            lc30: 51.5,
            lc10: 26
        },
        "orange.1200": {
            contrast: 49.05847405764284,
            lc60: 100,
            lc45: 89.5,
            lc30: 57,
            lc10: 28.5
        },
        "orange.1300": {
            contrast: 44.1116548847765,
            lc60: 100,
            lc45: 100,
            lc30: 63.5,
            lc10: 32
        },
        "orange.1400": {
            contrast: 39.86852955358848,
            lc60: 100,
            lc45: 100,
            lc30: 71,
            lc10: 35.5
        },
        "orange.1500": {
            contrast: 35.124166194828796,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 40
        },
        "orange.1600": {
            contrast: 32.09817930449622,
            lc60: 100,
            lc45: 100,
            lc30: 91.5,
            lc10: 44.5
        },
        "orange.1700": {
            contrast: 27.458985984850454,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53.5
        },
        "orange.1800": {
            contrast: 20.94121246504863,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "orange.1900": {
            contrast: 14.75557668571669,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.2000": {
            contrast: 9.223399781665726,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.2400": {
            contrast: 11.32097266867248,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.2500": {
            contrast: 18.32747215202001,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83
        }
    },
    "orange.2300": {
        "orange.100": {
            contrast: 93.56605443752673,
            lc60: 50,
            lc45: 36.5,
            lc30: 24.5,
            lc10: 12.5
        },
        "orange.200": {
            contrast: 93.08196576862692,
            lc60: 53,
            lc45: 39,
            lc30: 26,
            lc10: 13.5
        },
        "orange.300": {
            contrast: 91.6439240103538,
            lc60: 55.5,
            lc45: 41,
            lc30: 27,
            lc10: 14
        },
        "orange.400": {
            contrast: 89.46470237211891,
            lc60: 58.5,
            lc45: 43,
            lc30: 28.5,
            lc10: 15
        },
        "orange.500": {
            contrast: 86.23291210142189,
            lc60: 62.5,
            lc45: 45.5,
            lc30: 30.5,
            lc10: 15.5
        },
        "orange.600": {
            contrast: 82.03764513832833,
            lc60: 67,
            lc45: 49,
            lc30: 32,
            lc10: 17
        },
        "orange.700": {
            contrast: 77.6526908444096,
            lc60: 72,
            lc45: 52.5,
            lc30: 34.5,
            lc10: 18
        },
        "orange.800": {
            contrast: 72.85455466933367,
            lc60: 77.5,
            lc45: 56.5,
            lc30: 37,
            lc10: 19
        },
        "orange.900": {
            contrast: 68.35783912911562,
            lc60: 84,
            lc45: 60.5,
            lc30: 39.5,
            lc10: 20.5
        },
        "orange.1000": {
            contrast: 64.03726403330049,
            lc60: 91.5,
            lc45: 65,
            lc30: 42.5,
            lc10: 22
        },
        "orange.1100": {
            contrast: 59.56488910264325,
            lc60: 100,
            lc45: 70.5,
            lc30: 46,
            lc10: 23.5
        },
        "orange.1200": {
            contrast: 54.94916905933812,
            lc60: 100,
            lc45: 77.5,
            lc30: 50,
            lc10: 25.5
        },
        "orange.1300": {
            contrast: 50.002349886471784,
            lc60: 100,
            lc45: 87.5,
            lc30: 55,
            lc10: 28
        },
        "orange.1400": {
            contrast: 45.75922455528377,
            lc60: 100,
            lc45: 97.5,
            lc30: 60.5,
            lc10: 30.5
        },
        "orange.1500": {
            contrast: 41.01486119652408,
            lc60: 100,
            lc45: 100,
            lc30: 68,
            lc10: 33.5
        },
        "orange.1600": {
            contrast: 37.98887430619151,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 37
        },
        "orange.1700": {
            contrast: 33.34968098654574,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 43.5
        },
        "orange.1800": {
            contrast: 26.831907466743914,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "orange.1900": {
            contrast: 20.64627168741198,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73
        },
        "orange.2000": {
            contrast: 15.114094783361018,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98.5
        },
        "orange.2100": {
            contrast: 9.269124175155836,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.2500": {
            contrast: 11.648040216374653,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "orange.2400": {
        "orange.100": {
            contrast: 99.69296490513103,
            lc60: 47,
            lc45: 34.5,
            lc30: 23,
            lc10: 12
        },
        "orange.200": {
            contrast: 99.20887623623122,
            lc60: 49.5,
            lc45: 36.5,
            lc30: 24,
            lc10: 12.5
        },
        "orange.300": {
            contrast: 97.7708344779581,
            lc60: 51.5,
            lc45: 38,
            lc30: 25.5,
            lc10: 13.5
        },
        "orange.400": {
            contrast: 95.59161283972321,
            lc60: 54.5,
            lc45: 40,
            lc30: 26.5,
            lc10: 14
        },
        "orange.500": {
            contrast: 92.35982256902619,
            lc60: 58,
            lc45: 42,
            lc30: 28,
            lc10: 14.5
        },
        "orange.600": {
            contrast: 88.16455560593262,
            lc60: 61.5,
            lc45: 44.5,
            lc30: 30,
            lc10: 15.5
        },
        "orange.700": {
            contrast: 83.77960131201391,
            lc60: 65.5,
            lc45: 48,
            lc30: 31.5,
            lc10: 16.5
        },
        "orange.800": {
            contrast: 78.98146513693798,
            lc60: 70.5,
            lc45: 51,
            lc30: 33.5,
            lc10: 17.5
        },
        "orange.900": {
            contrast: 74.48474959671992,
            lc60: 75.5,
            lc45: 55,
            lc30: 36,
            lc10: 19
        },
        "orange.1000": {
            contrast: 70.16417450090479,
            lc60: 81.5,
            lc45: 58.5,
            lc30: 38.5,
            lc10: 20
        },
        "orange.1100": {
            contrast: 65.69179957024754,
            lc60: 88.5,
            lc45: 63,
            lc30: 41,
            lc10: 21.5
        },
        "orange.1200": {
            contrast: 61.07607952694243,
            lc60: 97.5,
            lc45: 68,
            lc30: 44.5,
            lc10: 22.5
        },
        "orange.1300": {
            contrast: 56.129260354076095,
            lc60: 100,
            lc45: 75.5,
            lc30: 48,
            lc10: 25
        },
        "orange.1400": {
            contrast: 51.886135022888084,
            lc60: 100,
            lc45: 82.5,
            lc30: 52,
            lc10: 27
        },
        "orange.1500": {
            contrast: 47.141771664128385,
            lc60: 100,
            lc45: 93.5,
            lc30: 57.5,
            lc10: 29
        },
        "orange.1600": {
            contrast: 44.115784773795816,
            lc60: 100,
            lc45: 100,
            lc30: 62.5,
            lc10: 31
        },
        "orange.1700": {
            contrast: 39.476591454150046,
            lc60: 100,
            lc45: 100,
            lc30: 73,
            lc10: 36
        },
        "orange.1800": {
            contrast: 32.95881793434822,
            lc60: 100,
            lc45: 100,
            lc30: 89.5,
            lc10: 44.5
        },
        "orange.1900": {
            contrast: 26.77318215501628,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "orange.2000": {
            contrast: 21.241005250965316,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72.5
        },
        "orange.2100": {
            contrast: 15.396034642760137,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98.5
        },
        "orange.2200": {
            contrast: 9.617125771345696,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "orange.2500": {
        "orange.100": {
            contrast: 106.04067321268862,
            lc60: 44,
            lc45: 32.5,
            lc30: 21.5,
            lc10: 11.5
        },
        "orange.200": {
            contrast: 105.5565845437888,
            lc60: 46,
            lc45: 34,
            lc30: 22.5,
            lc10: 12
        },
        "orange.300": {
            contrast: 104.11854278551569,
            lc60: 48.5,
            lc45: 35.5,
            lc30: 24,
            lc10: 12.5
        },
        "orange.400": {
            contrast: 101.9393211472808,
            lc60: 50.5,
            lc45: 37,
            lc30: 25,
            lc10: 13
        },
        "orange.500": {
            contrast: 98.70753087658376,
            lc60: 53.5,
            lc45: 39,
            lc30: 26,
            lc10: 13.5
        },
        "orange.600": {
            contrast: 94.51226391349019,
            lc60: 56.5,
            lc45: 41.5,
            lc30: 27.5,
            lc10: 14.5
        },
        "orange.700": {
            contrast: 90.12730961957148,
            lc60: 60,
            lc45: 44,
            lc30: 29.5,
            lc10: 15.5
        },
        "orange.800": {
            contrast: 85.32917344449554,
            lc60: 64,
            lc45: 46.5,
            lc30: 31,
            lc10: 16
        },
        "orange.900": {
            contrast: 80.83245790427749,
            lc60: 68.5,
            lc45: 50,
            lc30: 33,
            lc10: 17.5
        },
        "orange.1000": {
            contrast: 76.51188280846236,
            lc60: 72.5,
            lc45: 52.5,
            lc30: 35,
            lc10: 18.5
        },
        "orange.1100": {
            contrast: 72.03950787780511,
            lc60: 78.5,
            lc45: 56.5,
            lc30: 37,
            lc10: 19
        },
        "orange.1200": {
            contrast: 67.42378783449999,
            lc60: 85,
            lc45: 60.5,
            lc30: 39.5,
            lc10: 20.5
        },
        "orange.1300": {
            contrast: 62.476968661633656,
            lc60: 94,
            lc45: 65.5,
            lc30: 42.5,
            lc10: 22
        },
        "orange.1400": {
            contrast: 58.233843330445644,
            lc60: 100,
            lc45: 71.5,
            lc30: 46,
            lc10: 23.5
        },
        "orange.1500": {
            contrast: 53.48947997168595,
            lc60: 100,
            lc45: 79,
            lc30: 50,
            lc10: 25.5
        },
        "orange.1600": {
            contrast: 50.46349308135337,
            lc60: 100,
            lc45: 85.5,
            lc30: 53.5,
            lc10: 27
        },
        "orange.1700": {
            contrast: 45.82429976170761,
            lc60: 100,
            lc45: 97.5,
            lc30: 61.5,
            lc10: 31
        },
        "orange.1800": {
            contrast: 39.306526241905786,
            lc60: 100,
            lc45: 100,
            lc30: 73.5,
            lc10: 37.5
        },
        "orange.1900": {
            contrast: 33.12089046257384,
            lc60: 100,
            lc45: 100,
            lc30: 89,
            lc10: 45.5
        },
        "orange.2000": {
            contrast: 27.588713558522883,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "orange.2100": {
            contrast: 21.743742950317703,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "orange.2200": {
            contrast: 15.964834078903262,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93.5
        },
        "orange.2300": {
            contrast: 9.984503886760745,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    }
};
const $f8fd43f1ee3f8cd8$var$pink = {
    "pink.100": {
        "pink.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.600": {
            contrast: 8.52191564180787,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.700": {
            contrast: 12.407266976937958,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.800": {
            contrast: 16.80924616780218,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 94.5
        },
        "pink.900": {
            contrast: 21.060860930907968,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84
        },
        "pink.1000": {
            contrast: 24.823143439913068,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77
        },
        "pink.1100": {
            contrast: 30.736866618948493,
            lc60: 100,
            lc45: 100,
            lc30: 98.5,
            lc10: 68.5
        },
        "pink.1200": {
            contrast: 33.18894431585209,
            lc60: 100,
            lc45: 100,
            lc30: 94,
            lc10: 65.5
        },
        "pink.1300": {
            contrast: 37.588924368545065,
            lc60: 100,
            lc45: 100,
            lc30: 87.5,
            lc10: 61
        },
        "pink.1400": {
            contrast: 41.86581670425226,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 57
        },
        "pink.1500": {
            contrast: 46.41426197242764,
            lc60: 100,
            lc45: 98,
            lc30: 77.5,
            lc10: 54
        },
        "pink.1600": {
            contrast: 51.24201123803706,
            lc60: 100,
            lc45: 92.5,
            lc30: 73,
            lc10: 51
        },
        "pink.1700": {
            contrast: 56.75804881315566,
            lc60: 100,
            lc45: 87,
            lc30: 68.5,
            lc10: 48
        },
        "pink.1800": {
            contrast: 62.366992621062245,
            lc60: 97.5,
            lc45: 82,
            lc30: 64.5,
            lc10: 45
        },
        "pink.1900": {
            contrast: 68.41485420594044,
            lc60: 92,
            lc45: 77.5,
            lc30: 61,
            lc10: 42.5
        },
        "pink.2000": {
            contrast: 74.34377672926571,
            lc60: 87.5,
            lc45: 73.5,
            lc30: 58,
            lc10: 40.5
        },
        "pink.2100": {
            contrast: 80.72355771413858,
            lc60: 83,
            lc45: 70,
            lc30: 55,
            lc10: 38.5
        },
        "pink.2200": {
            contrast: 87.11282503205602,
            lc60: 79,
            lc45: 66.5,
            lc30: 52.5,
            lc10: 36.5
        },
        "pink.2300": {
            contrast: 93.85322876797147,
            lc60: 75.5,
            lc45: 63.5,
            lc30: 50,
            lc10: 35
        },
        "pink.2400": {
            contrast: 100.92578873905642,
            lc60: 72,
            lc45: 60.5,
            lc30: 48,
            lc10: 33.5
        },
        "pink.2500": {
            contrast: 107.88473318309848,
            lc60: 69,
            lc45: 58,
            lc30: 46,
            lc10: 32
        }
    },
    "pink.200": {
        "pink.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.600": {
            contrast: 8.169627483251848,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.700": {
            contrast: 12.054978818381933,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.800": {
            contrast: 16.456958009246158,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95
        },
        "pink.900": {
            contrast: 20.70857277235195,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83
        },
        "pink.1000": {
            contrast: 24.470855281357043,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74.5
        },
        "pink.1100": {
            contrast: 30.38457846039247,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 65
        },
        "pink.1200": {
            contrast: 32.83665615729607,
            lc60: 100,
            lc45: 100,
            lc30: 94,
            lc10: 62
        },
        "pink.1300": {
            contrast: 37.236636209989044,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 57
        },
        "pink.1400": {
            contrast: 41.51352854569624,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 53.5
        },
        "pink.1500": {
            contrast: 46.06197381387162,
            lc60: 100,
            lc45: 98,
            lc30: 75.5,
            lc10: 49.5
        },
        "pink.1600": {
            contrast: 50.88972307948102,
            lc60: 100,
            lc45: 92,
            lc30: 71,
            lc10: 46.5
        },
        "pink.1700": {
            contrast: 56.405760654599646,
            lc60: 100,
            lc45: 86,
            lc30: 66.5,
            lc10: 44
        },
        "pink.1800": {
            contrast: 62.014704462506224,
            lc60: 98,
            lc45: 81,
            lc30: 62.5,
            lc10: 41
        },
        "pink.1900": {
            contrast: 68.06256604738444,
            lc60: 92,
            lc45: 76,
            lc30: 59,
            lc10: 39
        },
        "pink.2000": {
            contrast: 73.99148857070969,
            lc60: 87,
            lc45: 72,
            lc30: 56,
            lc10: 37
        },
        "pink.2100": {
            contrast: 80.37126955558256,
            lc60: 82,
            lc45: 68.5,
            lc30: 53,
            lc10: 35
        },
        "pink.2200": {
            contrast: 86.76053687350002,
            lc60: 78,
            lc45: 65,
            lc30: 50.5,
            lc10: 33.5
        },
        "pink.2300": {
            contrast: 93.50094060941547,
            lc60: 74.5,
            lc45: 62,
            lc30: 48,
            lc10: 32
        },
        "pink.2400": {
            contrast: 100.57350058050041,
            lc60: 71,
            lc45: 59.5,
            lc30: 46,
            lc10: 30.5
        },
        "pink.2500": {
            contrast: 107.53244502454244,
            lc60: 68,
            lc45: 56.5,
            lc30: 44,
            lc10: 29
        }
    },
    "pink.300": {
        "pink.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.700": {
            contrast: 10.77041311089608,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.800": {
            contrast: 15.1723923017603,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 99.5
        },
        "pink.900": {
            contrast: 19.424007064866093,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84
        },
        "pink.1000": {
            contrast: 23.186289573871193,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74.5
        },
        "pink.1100": {
            contrast: 29.10001275290662,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63.5
        },
        "pink.1200": {
            contrast: 31.552090449810215,
            lc60: 100,
            lc45: 100,
            lc30: 96.5,
            lc10: 60
        },
        "pink.1300": {
            contrast: 35.95207050250319,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 54.5
        },
        "pink.1400": {
            contrast: 40.228962838210386,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 50.5
        },
        "pink.1500": {
            contrast: 44.777408106385764,
            lc60: 100,
            lc45: 100,
            lc30: 75.5,
            lc10: 47.5
        },
        "pink.1600": {
            contrast: 49.60515737199517,
            lc60: 100,
            lc45: 93.5,
            lc30: 70.5,
            lc10: 45
        },
        "pink.1700": {
            contrast: 55.121194947113786,
            lc60: 100,
            lc45: 86.5,
            lc30: 66,
            lc10: 42
        },
        "pink.1800": {
            contrast: 60.73013875502037,
            lc60: 99,
            lc45: 81.5,
            lc30: 62,
            lc10: 39.5
        },
        "pink.1900": {
            contrast: 66.77800033989857,
            lc60: 92.5,
            lc45: 76.5,
            lc30: 58,
            lc10: 37.5
        },
        "pink.2000": {
            contrast: 72.70692286322384,
            lc60: 87.5,
            lc45: 72,
            lc30: 55,
            lc10: 35.5
        },
        "pink.2100": {
            contrast: 79.08670384809669,
            lc60: 83,
            lc45: 68,
            lc30: 52.5,
            lc10: 34
        },
        "pink.2200": {
            contrast: 85.47597116601415,
            lc60: 78.5,
            lc45: 65,
            lc30: 49.5,
            lc10: 32.5
        },
        "pink.2300": {
            contrast: 92.2163749019296,
            lc60: 74.5,
            lc45: 62,
            lc30: 47.5,
            lc10: 31
        },
        "pink.2400": {
            contrast: 99.28893487301454,
            lc60: 71.5,
            lc45: 59,
            lc30: 45.5,
            lc10: 29.5
        },
        "pink.2500": {
            contrast: 106.24787931705659,
            lc60: 68,
            lc45: 56.5,
            lc30: 43.5,
            lc10: 28.5
        }
    },
    "pink.400": {
        "pink.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.700": {
            contrast: 8.872015901151324,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.800": {
            contrast: 13.273995092015545,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.900": {
            contrast: 17.52560985512133,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88.5
        },
        "pink.1000": {
            contrast: 21.28789236412644,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76.5
        },
        "pink.1100": {
            contrast: 27.20161554316186,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63.5
        },
        "pink.1200": {
            contrast: 29.653693240065458,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "pink.1300": {
            contrast: 34.05367329275843,
            lc60: 100,
            lc45: 100,
            lc30: 91,
            lc10: 54.5
        },
        "pink.1400": {
            contrast: 38.33056562846563,
            lc60: 100,
            lc45: 100,
            lc30: 83.5,
            lc10: 50
        },
        "pink.1500": {
            contrast: 42.879010896641006,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 46.5
        },
        "pink.1600": {
            contrast: 47.70676016225042,
            lc60: 100,
            lc45: 95.5,
            lc30: 72,
            lc10: 44
        },
        "pink.1700": {
            contrast: 53.222797737369035,
            lc60: 100,
            lc45: 89,
            lc30: 67,
            lc10: 41.5
        },
        "pink.1800": {
            contrast: 58.831741545275605,
            lc60: 100,
            lc45: 83,
            lc30: 63,
            lc10: 39.5
        },
        "pink.1900": {
            contrast: 64.87960313015381,
            lc60: 94.5,
            lc45: 77.5,
            lc30: 59,
            lc10: 37
        },
        "pink.2000": {
            contrast: 70.80852565347907,
            lc60: 89,
            lc45: 73.5,
            lc30: 56,
            lc10: 35.5
        },
        "pink.2100": {
            contrast: 77.18830663835195,
            lc60: 84,
            lc45: 69.5,
            lc30: 53,
            lc10: 34
        },
        "pink.2200": {
            contrast: 83.5775739562694,
            lc60: 80,
            lc45: 66,
            lc30: 50.5,
            lc10: 32.5
        },
        "pink.2300": {
            contrast: 90.31797769218485,
            lc60: 76,
            lc45: 63,
            lc30: 48,
            lc10: 31
        },
        "pink.2400": {
            contrast: 97.39053766326978,
            lc60: 72,
            lc45: 59.5,
            lc30: 46,
            lc10: 30
        },
        "pink.2500": {
            contrast: 104.34948210731183,
            lc60: 69,
            lc45: 57,
            lc30: 44,
            lc10: 28.5
        }
    },
    "pink.500": {
        "pink.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.800": {
            contrast: 10.675410675210081,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.900": {
            contrast: 14.927025438315871,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1000": {
            contrast: 18.68930794732097,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84
        },
        "pink.1100": {
            contrast: 24.6030311263564,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "pink.1200": {
            contrast: 27.055108823259992,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "pink.1300": {
            contrast: 31.45508887595297,
            lc60: 100,
            lc45: 100,
            lc30: 96,
            lc10: 55.5
        },
        "pink.1400": {
            contrast: 35.73198121166016,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 51
        },
        "pink.1500": {
            contrast: 40.28042647983554,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 47
        },
        "pink.1600": {
            contrast: 45.10817574544495,
            lc60: 100,
            lc45: 99.5,
            lc30: 74,
            lc10: 44.5
        },
        "pink.1700": {
            contrast: 50.62421332056356,
            lc60: 100,
            lc45: 92,
            lc30: 68.5,
            lc10: 42
        },
        "pink.1800": {
            contrast: 56.233157128470154,
            lc60: 100,
            lc45: 85.5,
            lc30: 64.5,
            lc10: 39.5
        },
        "pink.1900": {
            contrast: 62.281018713348345,
            lc60: 97,
            lc45: 80,
            lc30: 60.5,
            lc10: 37.5
        },
        "pink.2000": {
            contrast: 68.2099412366736,
            lc60: 91.5,
            lc45: 75,
            lc30: 57,
            lc10: 35.5
        },
        "pink.2100": {
            contrast: 74.58972222154647,
            lc60: 86,
            lc45: 71,
            lc30: 54,
            lc10: 34
        },
        "pink.2200": {
            contrast: 80.97898953946392,
            lc60: 81.5,
            lc45: 67.5,
            lc30: 51.5,
            lc10: 32.5
        },
        "pink.2300": {
            contrast: 87.71939327537939,
            lc60: 77.5,
            lc45: 64,
            lc30: 49,
            lc10: 31.5
        },
        "pink.2400": {
            contrast: 94.79195324646432,
            lc60: 74,
            lc45: 61,
            lc30: 47,
            lc10: 30
        },
        "pink.2500": {
            contrast: 101.75089769050636,
            lc60: 70,
            lc45: 58,
            lc30: 44.5,
            lc10: 29
        }
    },
    "pink.600": {
        "pink.100": {
            contrast: 9.894306924753202,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.200": {
            contrast: 9.421481604228262,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.300": {
            contrast: 7.739677532346192,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.900": {
            contrast: 11.222861433606946,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1000": {
            contrast: 14.985143942612044,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1100": {
            contrast: 20.89886712164747,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76
        },
        "pink.1200": {
            contrast: 23.35094481855107,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69.5
        },
        "pink.1300": {
            contrast: 27.750924871244038,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61
        },
        "pink.1400": {
            contrast: 32.027817206951234,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 54.5
        },
        "pink.1500": {
            contrast: 36.57626247512661,
            lc60: 100,
            lc45: 100,
            lc30: 85.5,
            lc10: 50
        },
        "pink.1600": {
            contrast: 41.40401174073602,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 47
        },
        "pink.1700": {
            contrast: 46.920049315854634,
            lc60: 100,
            lc45: 97,
            lc30: 72.5,
            lc10: 44
        },
        "pink.1800": {
            contrast: 52.52899312376121,
            lc60: 100,
            lc45: 89.5,
            lc30: 67.5,
            lc10: 41.5
        },
        "pink.1900": {
            contrast: 58.576854708639424,
            lc60: 100,
            lc45: 83.5,
            lc30: 63,
            lc10: 39
        },
        "pink.2000": {
            contrast: 64.50577723196467,
            lc60: 95,
            lc45: 78,
            lc30: 59.5,
            lc10: 37
        },
        "pink.2100": {
            contrast: 70.88555821683755,
            lc60: 89,
            lc45: 73.5,
            lc30: 56,
            lc10: 35.5
        },
        "pink.2200": {
            contrast: 77.27482553475501,
            lc60: 84.5,
            lc45: 69.5,
            lc30: 53.5,
            lc10: 34
        },
        "pink.2300": {
            contrast: 84.01522927067045,
            lc60: 80,
            lc45: 66,
            lc30: 50.5,
            lc10: 32.5
        },
        "pink.2400": {
            contrast: 91.08778924175539,
            lc60: 76,
            lc45: 63,
            lc30: 48.5,
            lc10: 31
        },
        "pink.2500": {
            contrast: 98.04673368579742,
            lc60: 72.5,
            lc45: 60,
            lc30: 46,
            lc10: 30
        }
    },
    "pink.700": {
        "pink.100": {
            contrast: 14.124536233205937,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.200": {
            contrast: 13.651710912680995,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.300": {
            contrast: 11.969906840798924,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.400": {
            contrast: 9.576733555993563,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.900": {
            contrast: 7.512720979195531,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1000": {
            contrast: 11.27500348820063,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1100": {
            contrast: 17.188726667236057,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89
        },
        "pink.1200": {
            contrast: 19.640804364139658,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80
        },
        "pink.1300": {
            contrast: 24.04078441683263,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "pink.1400": {
            contrast: 28.31767675253982,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "pink.1500": {
            contrast: 32.8661220207152,
            lc60: 100,
            lc45: 100,
            lc30: 93,
            lc10: 54
        },
        "pink.1600": {
            contrast: 37.693871286324615,
            lc60: 100,
            lc45: 100,
            lc30: 84,
            lc10: 50
        },
        "pink.1700": {
            contrast: 43.209908861443225,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 47
        },
        "pink.1800": {
            contrast: 48.81885266934981,
            lc60: 100,
            lc45: 94,
            lc30: 71.5,
            lc10: 44
        },
        "pink.1900": {
            contrast: 54.86671425422801,
            lc60: 100,
            lc45: 87,
            lc30: 66.5,
            lc10: 41
        },
        "pink.2000": {
            contrast: 60.79563677755328,
            lc60: 99,
            lc45: 81.5,
            lc30: 62,
            lc10: 39
        },
        "pink.2100": {
            contrast: 67.17541776242614,
            lc60: 92.5,
            lc45: 76.5,
            lc30: 58.5,
            lc10: 37
        },
        "pink.2200": {
            contrast: 73.5646850803436,
            lc60: 87,
            lc45: 72.5,
            lc30: 55.5,
            lc10: 35
        },
        "pink.2300": {
            contrast: 80.30508881625904,
            lc60: 82.5,
            lc45: 68.5,
            lc30: 52.5,
            lc10: 33.5
        },
        "pink.2400": {
            contrast: 87.37764878734397,
            lc60: 78.5,
            lc45: 65,
            lc30: 50,
            lc10: 32.5
        },
        "pink.2500": {
            contrast: 94.33659323138602,
            lc60: 74.5,
            lc45: 62,
            lc30: 48,
            lc10: 31
        }
    },
    "pink.800": {
        "pink.100": {
            contrast: 18.814687870981235,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "pink.200": {
            contrast: 18.341862550456295,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68.5
        },
        "pink.300": {
            contrast: 16.660058478574225,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85
        },
        "pink.400": {
            contrast: 14.266885193768864,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.500": {
            contrast: 11.116868444622616,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1100": {
            contrast: 12.939556367081382,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1200": {
            contrast: 15.391634063984982,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 97.5
        },
        "pink.1300": {
            contrast: 19.791614116677955,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79
        },
        "pink.1400": {
            contrast: 24.06850645238515,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "pink.1500": {
            contrast: 28.616951720560525,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "pink.1600": {
            contrast: 33.444700986169934,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 55
        },
        "pink.1700": {
            contrast: 38.96073856128855,
            lc60: 100,
            lc45: 100,
            lc30: 83.5,
            lc10: 51
        },
        "pink.1800": {
            contrast: 44.56968236919513,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 47.5
        },
        "pink.1900": {
            contrast: 50.61754395407333,
            lc60: 100,
            lc45: 92,
            lc30: 70.5,
            lc10: 44.5
        },
        "pink.2000": {
            contrast: 56.546466477398596,
            lc60: 100,
            lc45: 86,
            lc30: 66,
            lc10: 42
        },
        "pink.2100": {
            contrast: 62.92624746227147,
            lc60: 97,
            lc45: 80.5,
            lc30: 62,
            lc10: 39.5
        },
        "pink.2200": {
            contrast: 69.31551478018892,
            lc60: 91,
            lc45: 75.5,
            lc30: 58.5,
            lc10: 37.5
        },
        "pink.2300": {
            contrast: 76.05591851610436,
            lc60: 86,
            lc45: 71.5,
            lc30: 55.5,
            lc10: 36
        },
        "pink.2400": {
            contrast: 83.12847848718931,
            lc60: 81,
            lc45: 67.5,
            lc30: 52.5,
            lc10: 34.5
        },
        "pink.2500": {
            contrast: 90.08742293123136,
            lc60: 77,
            lc45: 64.5,
            lc30: 50,
            lc10: 32.5
        }
    },
    "pink.900": {
        "pink.100": {
            contrast: 23.261942186407257,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 44.5
        },
        "pink.200": {
            contrast: 22.78911686588231,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 52.5
        },
        "pink.300": {
            contrast: 21.10731279400024,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63.5
        },
        "pink.400": {
            contrast: 18.71413950919488,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77
        },
        "pink.500": {
            contrast: 15.564122760048631,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 96.5
        },
        "pink.600": {
            contrast: 11.249038066044692,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1100": {
            contrast: 8.797572655226773,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1200": {
            contrast: 11.249650352130372,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1300": {
            contrast: 15.649630404823345,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 96.5
        },
        "pink.1400": {
            contrast: 19.92652274053054,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79.5
        },
        "pink.1500": {
            contrast: 24.47496800870592,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68.5
        },
        "pink.1600": {
            contrast: 29.302717274315327,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62
        },
        "pink.1700": {
            contrast: 34.818754849433944,
            lc60: 100,
            lc45: 100,
            lc30: 90,
            lc10: 56
        },
        "pink.1800": {
            contrast: 40.42769865734052,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 51.5
        },
        "pink.1900": {
            contrast: 46.47556024221873,
            lc60: 100,
            lc45: 97.5,
            lc30: 75.5,
            lc10: 48
        },
        "pink.2000": {
            contrast: 52.40448276554398,
            lc60: 100,
            lc45: 90.5,
            lc30: 70,
            lc10: 45.5
        },
        "pink.2100": {
            contrast: 58.784263750416855,
            lc60: 100,
            lc45: 84.5,
            lc30: 66,
            lc10: 42.5
        },
        "pink.2200": {
            contrast: 65.17353106833431,
            lc60: 95,
            lc45: 79,
            lc30: 62,
            lc10: 40.5
        },
        "pink.2300": {
            contrast: 71.91393480424976,
            lc60: 89.5,
            lc45: 74.5,
            lc30: 58.5,
            lc10: 38.5
        },
        "pink.2400": {
            contrast: 78.98649477533469,
            lc60: 84,
            lc45: 70.5,
            lc30: 55.5,
            lc10: 36.5
        },
        "pink.2500": {
            contrast: 85.94543921937674,
            lc60: 80,
            lc45: 67,
            lc30: 53,
            lc10: 35
        }
    },
    "pink.1000": {
        "pink.100": {
            contrast: 27.14103327770957,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 39
        },
        "pink.200": {
            contrast: 26.668207957184638,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 45
        },
        "pink.300": {
            contrast: 24.98640388530257,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53.5
        },
        "pink.400": {
            contrast: 22.5932306004972,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63
        },
        "pink.500": {
            contrast: 19.443213851350954,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77
        },
        "pink.600": {
            contrast: 15.128129157347017,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 99
        },
        "pink.700": {
            contrast: 10.954377948687641,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1200": {
            contrast: 7.557885020226979,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1300": {
            contrast: 11.957865072919951,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1400": {
            contrast: 16.234757408627146,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 94
        },
        "pink.1500": {
            contrast: 20.783202676802524,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78
        },
        "pink.1600": {
            contrast: 25.61095194241193,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68.5
        },
        "pink.1700": {
            contrast: 31.126989517530546,
            lc60: 100,
            lc45: 100,
            lc30: 97.5,
            lc10: 62
        },
        "pink.1800": {
            contrast: 36.735933325437124,
            lc60: 100,
            lc45: 100,
            lc30: 87.5,
            lc10: 56.5
        },
        "pink.1900": {
            contrast: 42.78379491031533,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 52
        },
        "pink.2000": {
            contrast: 48.712717433640584,
            lc60: 100,
            lc45: 95,
            lc30: 74.5,
            lc10: 48.5
        },
        "pink.2100": {
            contrast: 55.09249841851344,
            lc60: 100,
            lc45: 88,
            lc30: 69,
            lc10: 45.5
        },
        "pink.2200": {
            contrast: 61.4817657364309,
            lc60: 98.5,
            lc45: 83,
            lc30: 64.5,
            lc10: 43
        },
        "pink.2300": {
            contrast: 68.22216947234637,
            lc60: 92.5,
            lc45: 77.5,
            lc30: 61.5,
            lc10: 41
        },
        "pink.2400": {
            contrast: 75.29472944343128,
            lc60: 87,
            lc45: 73.5,
            lc30: 58,
            lc10: 38.5
        },
        "pink.2500": {
            contrast: 82.25367388747333,
            lc60: 82.5,
            lc45: 69.5,
            lc30: 54.5,
            lc10: 36.5
        }
    },
    "pink.1100": {
        "pink.100": {
            contrast: 33.14852601612051,
            lc60: 100,
            lc45: 100,
            lc30: 71.5,
            lc10: 32.5
        },
        "pink.200": {
            contrast: 32.67570069559557,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 37
        },
        "pink.300": {
            contrast: 30.993896623713503,
            lc60: 100,
            lc45: 100,
            lc30: 94,
            lc10: 43
        },
        "pink.400": {
            contrast: 28.60072333890814,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 49
        },
        "pink.500": {
            contrast: 25.45070658976189,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "pink.600": {
            contrast: 21.135621895757954,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70.5
        },
        "pink.700": {
            contrast: 16.961870687098575,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88
        },
        "pink.800": {
            contrast: 12.317621098050543,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.900": {
            contrast: 7.900345529595314,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1400": {
            contrast: 10.388625925718948,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1500": {
            contrast: 14.937071193894328,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1600": {
            contrast: 19.76482045950374,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84
        },
        "pink.1700": {
            contrast: 25.28085803462235,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72.5
        },
        "pink.1800": {
            contrast: 30.88980184252893,
            lc60: 100,
            lc45: 100,
            lc30: 98,
            lc10: 66
        },
        "pink.1900": {
            contrast: 36.93766342740714,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 59
        },
        "pink.2000": {
            contrast: 42.86658595073239,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 55
        },
        "pink.2100": {
            contrast: 49.24636693560526,
            lc60: 100,
            lc45: 95,
            lc30: 75.5,
            lc10: 51
        },
        "pink.2200": {
            contrast: 55.635634253522724,
            lc60: 100,
            lc45: 88,
            lc30: 70,
            lc10: 48.5
        },
        "pink.2300": {
            contrast: 62.376037989438146,
            lc60: 98,
            lc45: 82.5,
            lc30: 66,
            lc10: 45
        },
        "pink.2400": {
            contrast: 69.4485979605231,
            lc60: 91.5,
            lc45: 78,
            lc30: 62,
            lc10: 42.5
        },
        "pink.2500": {
            contrast: 76.40754240456515,
            lc60: 87,
            lc45: 73.5,
            lc30: 59,
            lc10: 40.5
        }
    },
    "pink.1200": {
        "pink.100": {
            contrast: 35.611303520731845,
            lc60: 100,
            lc45: 100,
            lc30: 64,
            lc10: 30.5
        },
        "pink.200": {
            contrast: 35.138478200206904,
            lc60: 100,
            lc45: 100,
            lc30: 72.5,
            lc10: 34.5
        },
        "pink.300": {
            contrast: 33.456674128324835,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 40
        },
        "pink.400": {
            contrast: 31.06350084351948,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 45
        },
        "pink.500": {
            contrast: 27.913484094373224,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 52.5
        },
        "pink.600": {
            contrast: 23.598399400369292,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63
        },
        "pink.700": {
            contrast: 19.424648191709913,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77.5
        },
        "pink.800": {
            contrast: 14.780398602661881,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.900": {
            contrast: 10.36312303420665,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1400": {
            contrast: 7.950763941922776,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1500": {
            contrast: 12.499209210098156,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1600": {
            contrast: 17.326958475707563,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 90.5
        },
        "pink.1700": {
            contrast: 22.842996050826176,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75
        },
        "pink.1800": {
            contrast: 28.451939858732757,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65.5
        },
        "pink.1900": {
            contrast: 34.49980144361096,
            lc60: 100,
            lc45: 100,
            lc30: 91.5,
            lc10: 58.5
        },
        "pink.2000": {
            contrast: 40.42872396693622,
            lc60: 100,
            lc45: 100,
            lc30: 83,
            lc10: 53.5
        },
        "pink.2100": {
            contrast: 46.80850495180909,
            lc60: 100,
            lc45: 97,
            lc30: 75.5,
            lc10: 49
        },
        "pink.2200": {
            contrast: 53.19777226972654,
            lc60: 100,
            lc45: 90,
            lc30: 70,
            lc10: 45.5
        },
        "pink.2300": {
            contrast: 59.938176005641985,
            lc60: 100,
            lc45: 83.5,
            lc30: 65,
            lc10: 42
        },
        "pink.2400": {
            contrast: 67.01073597672692,
            lc60: 93,
            lc45: 78,
            lc30: 61,
            lc10: 39.5
        },
        "pink.2500": {
            contrast: 73.96968042076897,
            lc60: 88,
            lc45: 73.5,
            lc30: 57,
            lc10: 37.5
        }
    },
    "pink.1300": {
        "pink.100": {
            contrast: 39.993929380418464,
            lc60: 100,
            lc45: 100,
            lc30: 56,
            lc10: 27.5
        },
        "pink.200": {
            contrast: 39.521104059893524,
            lc60: 100,
            lc45: 100,
            lc30: 63,
            lc10: 31
        },
        "pink.300": {
            contrast: 37.839299988011454,
            lc60: 100,
            lc45: 100,
            lc30: 71,
            lc10: 35
        },
        "pink.400": {
            contrast: 35.44612670320609,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 39.5
        },
        "pink.500": {
            contrast: 32.296109954059844,
            lc60: 100,
            lc45: 100,
            lc30: 91.5,
            lc10: 44.5
        },
        "pink.600": {
            contrast: 27.9810252600559,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 52
        },
        "pink.700": {
            contrast: 23.80727405139653,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "pink.800": {
            contrast: 19.163024462348496,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77.5
        },
        "pink.900": {
            contrast: 14.745748893893266,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1000": {
            contrast: 10.88353751965882,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1500": {
            contrast: 8.106523520844656,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1600": {
            contrast: 12.934272786454065,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1700": {
            contrast: 18.45031036157268,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86
        },
        "pink.1800": {
            contrast: 24.059254169479257,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72
        },
        "pink.1900": {
            contrast: 30.107115754357462,
            lc60: 100,
            lc45: 100,
            lc30: 99.5,
            lc10: 62
        },
        "pink.2000": {
            contrast: 36.03603827768272,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 55.5
        },
        "pink.2100": {
            contrast: 42.41581926255559,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 49.5
        },
        "pink.2200": {
            contrast: 48.805086580473045,
            lc60: 100,
            lc45: 94.5,
            lc30: 72,
            lc10: 45.5
        },
        "pink.2300": {
            contrast: 55.54549031638849,
            lc60: 100,
            lc45: 86.5,
            lc30: 66.5,
            lc10: 41.5
        },
        "pink.2400": {
            contrast: 62.61805028747342,
            lc60: 97,
            lc45: 80.5,
            lc30: 61.5,
            lc10: 38.5
        },
        "pink.2500": {
            contrast: 69.57699473151547,
            lc60: 90.5,
            lc45: 75,
            lc30: 57.5,
            lc10: 36
        }
    },
    "pink.1400": {
        "pink.100": {
            contrast: 44.2131152740578,
            lc60: 100,
            lc45: 100,
            lc30: 50.5,
            lc10: 25
        },
        "pink.200": {
            contrast: 43.74028995353286,
            lc60: 100,
            lc45: 100,
            lc30: 56.5,
            lc10: 28
        },
        "pink.300": {
            contrast: 42.05848588165079,
            lc60: 100,
            lc45: 100,
            lc30: 63,
            lc10: 31
        },
        "pink.400": {
            contrast: 39.665312596845425,
            lc60: 100,
            lc45: 100,
            lc30: 70,
            lc10: 34.5
        },
        "pink.500": {
            contrast: 36.51529584769918,
            lc60: 100,
            lc45: 100,
            lc30: 79,
            lc10: 38.5
        },
        "pink.600": {
            contrast: 32.20021115369524,
            lc60: 100,
            lc45: 100,
            lc30: 91.5,
            lc10: 44.5
        },
        "pink.700": {
            contrast: 28.026459945035864,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51.5
        },
        "pink.800": {
            contrast: 23.38221035598783,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "pink.900": {
            contrast: 18.9649347875326,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78
        },
        "pink.1000": {
            contrast: 15.102723413298156,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 99
        },
        "pink.1100": {
            contrast: 9.106561156101405,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1600": {
            contrast: 8.643859887501003,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1700": {
            contrast: 14.159897462619616,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1800": {
            contrast: 19.768841270526195,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81.5
        },
        "pink.1900": {
            contrast: 25.8167028554044,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68.5
        },
        "pink.2000": {
            contrast: 31.74562537872966,
            lc60: 100,
            lc45: 100,
            lc30: 96,
            lc10: 59.5
        },
        "pink.2100": {
            contrast: 38.12540636360253,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 52.5
        },
        "pink.2200": {
            contrast: 44.51467368151999,
            lc60: 100,
            lc45: 100,
            lc30: 76,
            lc10: 47.5
        },
        "pink.2300": {
            contrast: 51.25507741743542,
            lc60: 100,
            lc45: 91.5,
            lc30: 69.5,
            lc10: 43
        },
        "pink.2400": {
            contrast: 58.32763738852036,
            lc60: 100,
            lc45: 84,
            lc30: 64,
            lc10: 39.5
        },
        "pink.2500": {
            contrast: 65.2865818325624,
            lc60: 94.5,
            lc45: 78,
            lc30: 59,
            lc10: 36.5
        }
    },
    "pink.1500": {
        "pink.100": {
            contrast: 48.660450306100266,
            lc60: 100,
            lc45: 75.5,
            lc30: 46,
            lc10: 23
        },
        "pink.200": {
            contrast: 48.187624985575326,
            lc60: 100,
            lc45: 84,
            lc30: 51,
            lc10: 25.5
        },
        "pink.300": {
            contrast: 46.50582091369326,
            lc60: 100,
            lc45: 93,
            lc30: 56,
            lc10: 28
        },
        "pink.400": {
            contrast: 44.1126476288879,
            lc60: 100,
            lc45: 100,
            lc30: 61.5,
            lc10: 30.5
        },
        "pink.500": {
            contrast: 40.96263087974165,
            lc60: 100,
            lc45: 100,
            lc30: 68,
            lc10: 34
        },
        "pink.600": {
            contrast: 36.64754618573771,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 38.5
        },
        "pink.700": {
            contrast: 32.473794977078335,
            lc60: 100,
            lc45: 100,
            lc30: 90.5,
            lc10: 43.5
        },
        "pink.800": {
            contrast: 27.8295453880303,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51
        },
        "pink.900": {
            contrast: 23.412269819575073,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60.5
        },
        "pink.1000": {
            contrast: 19.550058445340632,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73
        },
        "pink.1100": {
            contrast: 13.553896188143879,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1200": {
            contrast: 11.091094324937181,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1700": {
            contrast: 9.576733292249832,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1800": {
            contrast: 15.185677100156415,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 99
        },
        "pink.1900": {
            contrast: 21.23353868503462,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77.5
        },
        "pink.2000": {
            contrast: 27.162461208359872,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "pink.2100": {
            contrast: 33.542242193232745,
            lc60: 100,
            lc45: 100,
            lc30: 92.5,
            lc10: 55.5
        },
        "pink.2200": {
            contrast: 39.931509511150196,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 49
        },
        "pink.2300": {
            contrast: 46.671913247065646,
            lc60: 100,
            lc45: 97.5,
            lc30: 72.5,
            lc10: 44
        },
        "pink.2400": {
            contrast: 53.74447321815058,
            lc60: 100,
            lc45: 88.5,
            lc30: 66,
            lc10: 40
        },
        "pink.2500": {
            contrast: 60.70341766219263,
            lc60: 99,
            lc45: 80.5,
            lc30: 60.5,
            lc10: 36.5
        }
    },
    "pink.1600": {
        "pink.100": {
            contrast: 53.340303824956806,
            lc60: 100,
            lc45: 66,
            lc30: 42,
            lc10: 21
        },
        "pink.200": {
            contrast: 52.867478504431865,
            lc60: 100,
            lc45: 72.5,
            lc30: 46,
            lc10: 23.5
        },
        "pink.300": {
            contrast: 51.18567443254979,
            lc60: 100,
            lc45: 79.5,
            lc30: 50,
            lc10: 25
        },
        "pink.400": {
            contrast: 48.79250114774444,
            lc60: 100,
            lc45: 87,
            lc30: 54,
            lc10: 27
        },
        "pink.500": {
            contrast: 45.642484398598185,
            lc60: 100,
            lc45: 97.5,
            lc30: 59.5,
            lc10: 29.5
        },
        "pink.600": {
            contrast: 41.32739970459424,
            lc60: 100,
            lc45: 100,
            lc30: 66.5,
            lc10: 32.5
        },
        "pink.700": {
            contrast: 37.15364849593487,
            lc60: 100,
            lc45: 100,
            lc30: 75.5,
            lc10: 36
        },
        "pink.800": {
            contrast: 32.50939890688683,
            lc60: 100,
            lc45: 100,
            lc30: 89,
            lc10: 40.5
        },
        "pink.900": {
            contrast: 28.092123338431602,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 47
        },
        "pink.1000": {
            contrast: 24.22991196419716,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54
        },
        "pink.1100": {
            contrast: 18.23374970700041,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "pink.1200": {
            contrast: 15.770947843793712,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93
        },
        "pink.1300": {
            contrast: 11.382209031042581,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1800": {
            contrast: 10.300033891051388,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1900": {
            contrast: 16.347895475929594,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 94
        },
        "pink.2000": {
            contrast: 22.276817999254853,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72.5
        },
        "pink.2100": {
            contrast: 28.65659898412772,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "pink.2200": {
            contrast: 35.04586630204518,
            lc60: 100,
            lc45: 100,
            lc30: 89,
            lc10: 51
        },
        "pink.2300": {
            contrast: 41.78627003796062,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 45
        },
        "pink.2400": {
            contrast: 48.85883000904555,
            lc60: 100,
            lc45: 93.5,
            lc30: 68.5,
            lc10: 40
        },
        "pink.2500": {
            contrast: 55.8177744530876,
            lc60: 100,
            lc45: 84.5,
            lc30: 62,
            lc10: 36
        }
    },
    "pink.1700": {
        "pink.100": {
            contrast: 58.64102792513084,
            lc60: 100,
            lc45: 59.5,
            lc30: 38.5,
            lc10: 19.5
        },
        "pink.200": {
            contrast: 58.16820260460589,
            lc60: 100,
            lc45: 65,
            lc30: 41.5,
            lc10: 21
        },
        "pink.300": {
            contrast: 56.48639853272384,
            lc60: 100,
            lc45: 70,
            lc30: 45,
            lc10: 22.5
        },
        "pink.400": {
            contrast: 54.093225247918475,
            lc60: 100,
            lc45: 75,
            lc30: 47.5,
            lc10: 24
        },
        "pink.500": {
            contrast: 50.94320849877222,
            lc60: 100,
            lc45: 83,
            lc30: 51.5,
            lc10: 25.5
        },
        "pink.600": {
            contrast: 46.62812380476828,
            lc60: 100,
            lc45: 94.5,
            lc30: 56.5,
            lc10: 28
        },
        "pink.700": {
            contrast: 42.454372596108904,
            lc60: 100,
            lc45: 100,
            lc30: 63,
            lc10: 30.5
        },
        "pink.800": {
            contrast: 37.81012300706087,
            lc60: 100,
            lc45: 100,
            lc30: 71.5,
            lc10: 33.5
        },
        "pink.900": {
            contrast: 33.392847438605635,
            lc60: 100,
            lc45: 100,
            lc30: 83.5,
            lc10: 37
        },
        "pink.1000": {
            contrast: 29.530636064371198,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 41.5
        },
        "pink.1100": {
            contrast: 23.534473807174447,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 50.5
        },
        "pink.1200": {
            contrast: 21.071671943967747,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "pink.1300": {
            contrast: 16.68293313121662,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86
        },
        "pink.1400": {
            contrast: 12.45107321527737,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1500": {
            contrast: 7.983760096756151,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1900": {
            contrast: 10.74136572635437,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.2000": {
            contrast: 16.67028824967963,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91.5
        },
        "pink.2100": {
            contrast: 23.0500692345525,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "pink.2200": {
            contrast: 29.439336552469953,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "pink.2300": {
            contrast: 36.179740288385396,
            lc60: 100,
            lc45: 100,
            lc30: 86,
            lc10: 48.5
        },
        "pink.2400": {
            contrast: 43.25230025947033,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 42.5
        },
        "pink.2500": {
            contrast: 50.21124470351238,
            lc60: 100,
            lc45: 91.5,
            lc30: 66,
            lc10: 37.5
        }
    },
    "pink.1800": {
        "pink.100": {
            contrast: 63.98504128605945,
            lc60: 79,
            lc45: 54,
            lc30: 35,
            lc10: 18
        },
        "pink.200": {
            contrast: 63.5122159655345,
            lc60: 85,
            lc45: 58.5,
            lc30: 38,
            lc10: 19.5
        },
        "pink.300": {
            contrast: 61.830411893652446,
            lc60: 92.5,
            lc45: 62.5,
            lc30: 40,
            lc10: 20.5
        },
        "pink.400": {
            contrast: 59.43723860884709,
            lc60: 100,
            lc45: 66.5,
            lc30: 42.5,
            lc10: 21.5
        },
        "pink.500": {
            contrast: 56.28722185970083,
            lc60: 100,
            lc45: 72,
            lc30: 45.5,
            lc10: 22.5
        },
        "pink.600": {
            contrast: 51.972137165696886,
            lc60: 100,
            lc45: 80,
            lc30: 49.5,
            lc10: 25
        },
        "pink.700": {
            contrast: 47.79838595703752,
            lc60: 100,
            lc45: 90,
            lc30: 53.5,
            lc10: 26.5
        },
        "pink.800": {
            contrast: 43.15413636798948,
            lc60: 100,
            lc45: 100,
            lc30: 59,
            lc10: 28.5
        },
        "pink.900": {
            contrast: 38.73686079953425,
            lc60: 100,
            lc45: 100,
            lc30: 66.5,
            lc10: 31
        },
        "pink.1000": {
            contrast: 34.87464942529981,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 34
        },
        "pink.1100": {
            contrast: 28.878487168103057,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 38.5
        },
        "pink.1200": {
            contrast: 26.415685304896357,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 47
        },
        "pink.1300": {
            contrast: 22.026946492145232,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60.5
        },
        "pink.1400": {
            contrast: 17.795086576205982,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78.5
        },
        "pink.1500": {
            contrast: 13.327773457684764,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1600": {
            contrast: 8.62012847643698,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.2000": {
            contrast: 10.944851388049603,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.2100": {
            contrast: 17.324632372922473,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88.5
        },
        "pink.2200": {
            contrast: 23.71389969083993,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "pink.2300": {
            contrast: 30.45430342675537,
            lc60: 100,
            lc45: 100,
            lc30: 98.5,
            lc10: 55.5
        },
        "pink.2400": {
            contrast: 37.5268633978403,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 46.5
        },
        "pink.2500": {
            contrast: 44.485807841882355,
            lc60: 100,
            lc45: 100,
            lc30: 72,
            lc10: 40.5
        }
    },
    "pink.1900": {
        "pink.100": {
            contrast: 69.70002005610566,
            lc60: 69.5,
            lc45: 49.5,
            lc30: 32.5,
            lc10: 16.5
        },
        "pink.200": {
            contrast: 69.22719473558071,
            lc60: 74.5,
            lc45: 53,
            lc30: 34.5,
            lc10: 17.5
        },
        "pink.300": {
            contrast: 67.54539066369865,
            lc60: 79.5,
            lc45: 56.5,
            lc30: 36.5,
            lc10: 18.5
        },
        "pink.400": {
            contrast: 65.15221737889328,
            lc60: 85,
            lc45: 59,
            lc30: 38,
            lc10: 19.5
        },
        "pink.500": {
            contrast: 62.00220062974704,
            lc60: 94,
            lc45: 63,
            lc30: 40.5,
            lc10: 20.5
        },
        "pink.600": {
            contrast: 57.687115935743094,
            lc60: 100,
            lc45: 69,
            lc30: 43,
            lc10: 22
        },
        "pink.700": {
            contrast: 53.513364727083726,
            lc60: 100,
            lc45: 75,
            lc30: 46,
            lc10: 23
        },
        "pink.800": {
            contrast: 48.86911513803569,
            lc60: 100,
            lc45: 86,
            lc30: 50.5,
            lc10: 24.5
        },
        "pink.900": {
            contrast: 44.45183956958046,
            lc60: 100,
            lc45: 100,
            lc30: 54.5,
            lc10: 26.5
        },
        "pink.1000": {
            contrast: 40.58962819534601,
            lc60: 100,
            lc45: 100,
            lc30: 60,
            lc10: 28
        },
        "pink.1100": {
            contrast: 34.59346593814926,
            lc60: 100,
            lc45: 100,
            lc30: 72,
            lc10: 31
        },
        "pink.1200": {
            contrast: 32.13066407494256,
            lc60: 100,
            lc45: 100,
            lc30: 87.5,
            lc10: 37
        },
        "pink.1300": {
            contrast: 27.74192526219143,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 46
        },
        "pink.1400": {
            contrast: 23.510065346252187,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56
        },
        "pink.1500": {
            contrast: 19.04275222773097,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74
        },
        "pink.1600": {
            contrast: 14.335107246483187,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1700": {
            contrast: 8.995165050599168,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.2100": {
            contrast: 11.125709972429872,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.2200": {
            contrast: 17.51497729034733,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88
        },
        "pink.2300": {
            contrast: 24.25538102626277,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66.5
        },
        "pink.2400": {
            contrast: 31.327940997347703,
            lc60: 100,
            lc45: 100,
            lc30: 96.5,
            lc10: 53.5
        },
        "pink.2500": {
            contrast: 38.28688544138975,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 45.5
        }
    },
    "pink.2000": {
        "pink.100": {
            contrast: 75.2591388438285,
            lc60: 64,
            lc45: 46,
            lc30: 30,
            lc10: 15.5
        },
        "pink.200": {
            contrast: 74.78631352330355,
            lc60: 68,
            lc45: 49,
            lc30: 32,
            lc10: 16.5
        },
        "pink.300": {
            contrast: 73.10450945142149,
            lc60: 71.5,
            lc45: 51,
            lc30: 33.5,
            lc10: 17
        },
        "pink.400": {
            contrast: 70.71133616661614,
            lc60: 75,
            lc45: 53.5,
            lc30: 34.5,
            lc10: 18
        },
        "pink.500": {
            contrast: 67.56131941746987,
            lc60: 81,
            lc45: 56.5,
            lc30: 36.5,
            lc10: 19
        },
        "pink.600": {
            contrast: 63.24623472346593,
            lc60: 90,
            lc45: 60.5,
            lc30: 38.5,
            lc10: 19.5
        },
        "pink.700": {
            contrast: 59.072483514806564,
            lc60: 100,
            lc45: 65.5,
            lc30: 41,
            lc10: 20.5
        },
        "pink.800": {
            contrast: 54.42823392575852,
            lc60: 100,
            lc45: 71.5,
            lc30: 43.5,
            lc10: 22
        },
        "pink.900": {
            contrast: 50.0109583573033,
            lc60: 100,
            lc45: 80,
            lc30: 46.5,
            lc10: 23
        },
        "pink.1000": {
            contrast: 46.148746983068854,
            lc60: 100,
            lc45: 94,
            lc30: 50.5,
            lc10: 24.5
        },
        "pink.1100": {
            contrast: 40.1525847258721,
            lc60: 100,
            lc45: 100,
            lc30: 56.5,
            lc10: 26
        },
        "pink.1200": {
            contrast: 37.6897828626654,
            lc60: 100,
            lc45: 100,
            lc30: 67,
            lc10: 31
        },
        "pink.1300": {
            contrast: 33.301044049914275,
            lc60: 100,
            lc45: 100,
            lc30: 83.5,
            lc10: 36.5
        },
        "pink.1400": {
            contrast: 29.06918413397503,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 43.5
        },
        "pink.1500": {
            contrast: 24.60187101545381,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "pink.1600": {
            contrast: 19.894226034206028,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72.5
        },
        "pink.1700": {
            contrast: 14.554283838322007,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1800": {
            contrast: 9.163037526896305,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.2200": {
            contrast: 11.414254858205751,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.2300": {
            contrast: 18.154658594121198,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85
        },
        "pink.2400": {
            contrast: 25.227218565206133,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "pink.2500": {
            contrast: 32.186163009248176,
            lc60: 100,
            lc45: 100,
            lc30: 93.5,
            lc10: 51
        }
    },
    "pink.2100": {
        "pink.100": {
            contrast: 81.19691789907402,
            lc60: 58.5,
            lc45: 42.5,
            lc30: 28,
            lc10: 14.5
        },
        "pink.200": {
            contrast: 80.72409257854906,
            lc60: 62,
            lc45: 45,
            lc30: 29.5,
            lc10: 15
        },
        "pink.300": {
            contrast: 79.042288506667,
            lc60: 65,
            lc45: 47,
            lc30: 30.5,
            lc10: 16
        },
        "pink.400": {
            contrast: 76.64911522186165,
            lc60: 67.5,
            lc45: 48.5,
            lc30: 31.5,
            lc10: 16.5
        },
        "pink.500": {
            contrast: 73.4990984727154,
            lc60: 71.5,
            lc45: 50.5,
            lc30: 33,
            lc10: 17
        },
        "pink.600": {
            contrast: 69.18401377871145,
            lc60: 77.5,
            lc45: 54,
            lc30: 35,
            lc10: 18
        },
        "pink.700": {
            contrast: 65.01026257005208,
            lc60: 85,
            lc45: 57,
            lc30: 36.5,
            lc10: 18.5
        },
        "pink.800": {
            contrast: 60.36601298100403,
            lc60: 98,
            lc45: 61.5,
            lc30: 38.5,
            lc10: 19.5
        },
        "pink.900": {
            contrast: 55.94873741254882,
            lc60: 100,
            lc45: 67,
            lc30: 41,
            lc10: 20.5
        },
        "pink.1000": {
            contrast: 52.086526038314375,
            lc60: 100,
            lc45: 73,
            lc30: 43,
            lc10: 21.5
        },
        "pink.1100": {
            contrast: 46.090363781117624,
            lc60: 100,
            lc45: 91.5,
            lc30: 47.5,
            lc10: 22.5
        },
        "pink.1200": {
            contrast: 43.627561917910924,
            lc60: 100,
            lc45: 100,
            lc30: 54.5,
            lc10: 26
        },
        "pink.1300": {
            contrast: 39.238823105159796,
            lc60: 100,
            lc45: 100,
            lc30: 65.5,
            lc10: 30.5
        },
        "pink.1400": {
            contrast: 35.00696318922055,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 35.5
        },
        "pink.1500": {
            contrast: 30.539650070699327,
            lc60: 100,
            lc45: 100,
            lc30: 96.5,
            lc10: 43.5
        },
        "pink.1600": {
            contrast: 25.832005089451542,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "pink.1700": {
            contrast: 20.492062893567528,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "pink.1800": {
            contrast: 15.100816582141825,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 99
        },
        "pink.1900": {
            contrast: 9.327413566081605,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.2300": {
            contrast: 11.56569339463902,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.2400": {
            contrast: 18.638253365723955,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83
        },
        "pink.2500": {
            contrast: 25.597197809765998,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63.5
        }
    },
    "pink.2200": {
        "pink.100": {
            contrast: 87.10132798309273,
            lc60: 54,
            lc45: 39.5,
            lc30: 26,
            lc10: 13.5
        },
        "pink.200": {
            contrast: 86.62850266256777,
            lc60: 57,
            lc45: 41.5,
            lc30: 27.5,
            lc10: 14
        },
        "pink.300": {
            contrast: 84.94669859068573,
            lc60: 59.5,
            lc45: 43.5,
            lc30: 28.5,
            lc10: 15
        },
        "pink.400": {
            contrast: 82.55352530588034,
            lc60: 61.5,
            lc45: 44.5,
            lc30: 29.5,
            lc10: 15
        },
        "pink.500": {
            contrast: 79.40350855673411,
            lc60: 64.5,
            lc45: 46.5,
            lc30: 30.5,
            lc10: 15.5
        },
        "pink.600": {
            contrast: 75.08842386273015,
            lc60: 68.5,
            lc45: 48.5,
            lc30: 32,
            lc10: 16
        },
        "pink.700": {
            contrast: 70.91467265407077,
            lc60: 73.5,
            lc45: 51,
            lc30: 33,
            lc10: 17
        },
        "pink.800": {
            contrast: 66.27042306502274,
            lc60: 80.5,
            lc45: 54.5,
            lc30: 35,
            lc10: 17.5
        },
        "pink.900": {
            contrast: 61.853147496567516,
            lc60: 91.5,
            lc45: 58,
            lc30: 36.5,
            lc10: 18.5
        },
        "pink.1000": {
            contrast: 57.99093612233308,
            lc60: 100,
            lc45: 62,
            lc30: 38,
            lc10: 19
        },
        "pink.1100": {
            contrast: 51.994773865136324,
            lc60: 100,
            lc45: 69.5,
            lc30: 40.5,
            lc10: 20
        },
        "pink.1200": {
            contrast: 49.531972001929624,
            lc60: 100,
            lc45: 81,
            lc30: 46.5,
            lc10: 23
        },
        "pink.1300": {
            contrast: 45.143233189178495,
            lc60: 100,
            lc45: 99,
            lc30: 54.5,
            lc10: 26.5
        },
        "pink.1400": {
            contrast: 40.91137327323925,
            lc60: 100,
            lc45: 100,
            lc30: 63,
            lc10: 30
        },
        "pink.1500": {
            contrast: 36.44406015471803,
            lc60: 100,
            lc45: 100,
            lc30: 75.5,
            lc10: 35
        },
        "pink.1600": {
            contrast: 31.73641517347025,
            lc60: 100,
            lc45: 100,
            lc30: 92.5,
            lc10: 43.5
        },
        "pink.1700": {
            contrast: 26.396472977586228,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "pink.1800": {
            contrast: 21.005226666160528,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "pink.1900": {
            contrast: 15.23182365010031,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98.5
        },
        "pink.2000": {
            contrast: 9.608578663501428,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.2400": {
            contrast: 12.015954023526632,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.2500": {
            contrast: 18.97489846756868,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81.5
        }
    },
    "pink.2300": {
        "pink.100": {
            contrast: 93.28794298184863,
            lc60: 50.5,
            lc45: 37,
            lc30: 24.5,
            lc10: 13
        },
        "pink.200": {
            contrast: 92.81511766132368,
            lc60: 53,
            lc45: 39,
            lc30: 25.5,
            lc10: 13.5
        },
        "pink.300": {
            contrast: 91.13331358944163,
            lc60: 54.5,
            lc45: 40,
            lc30: 26.5,
            lc10: 14
        },
        "pink.400": {
            contrast: 88.74014030463626,
            lc60: 56,
            lc45: 41,
            lc30: 27,
            lc10: 14
        },
        "pink.500": {
            contrast: 85.59012355549001,
            lc60: 58.5,
            lc45: 42.5,
            lc30: 28,
            lc10: 14.5
        },
        "pink.600": {
            contrast: 81.27503886148607,
            lc60: 62,
            lc45: 44.5,
            lc30: 29,
            lc10: 15
        },
        "pink.700": {
            contrast: 77.10128765282668,
            lc60: 65.5,
            lc45: 46,
            lc30: 30,
            lc10: 15.5
        },
        "pink.800": {
            contrast: 72.45703806377865,
            lc60: 70,
            lc45: 48.5,
            lc30: 31.5,
            lc10: 16
        },
        "pink.900": {
            contrast: 68.03976249532343,
            lc60: 75.5,
            lc45: 51,
            lc30: 32.5,
            lc10: 17
        },
        "pink.1000": {
            contrast: 64.17755112108898,
            lc60: 83,
            lc45: 54,
            lc30: 34,
            lc10: 17.5
        },
        "pink.1100": {
            contrast: 58.18138886389224,
            lc60: 100,
            lc45: 59,
            lc30: 36,
            lc10: 18
        },
        "pink.1200": {
            contrast: 55.718587000685524,
            lc60: 100,
            lc45: 66.5,
            lc30: 40.5,
            lc10: 20.5
        },
        "pink.1300": {
            contrast: 51.3298481879344,
            lc60: 100,
            lc45: 78.5,
            lc30: 47,
            lc10: 23.5
        },
        "pink.1400": {
            contrast: 47.09798827199516,
            lc60: 100,
            lc45: 91.5,
            lc30: 52.5,
            lc10: 26
        },
        "pink.1500": {
            contrast: 42.63067515347394,
            lc60: 100,
            lc45: 100,
            lc30: 61.5,
            lc10: 30
        },
        "pink.1600": {
            contrast: 37.923030172226156,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 36.5
        },
        "pink.1700": {
            contrast: 32.58308797634214,
            lc60: 100,
            lc45: 100,
            lc30: 90,
            lc10: 44.5
        },
        "pink.1800": {
            contrast: 27.19184166491643,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54
        },
        "pink.1900": {
            contrast: 21.41843864885622,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "pink.2000": {
            contrast: 15.795193662257336,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 94.5
        },
        "pink.2100": {
            contrast: 9.781512424332313,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.2500": {
            contrast: 11.964821667346046,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "pink.2400": {
        "pink.100": {
            contrast: 99.73618138843224,
            lc60: 47,
            lc45: 34.5,
            lc30: 23,
            lc10: 12
        },
        "pink.200": {
            contrast: 99.2633560679073,
            lc60: 49,
            lc45: 36,
            lc30: 24,
            lc10: 12.5
        },
        "pink.300": {
            contrast: 97.58155199602524,
            lc60: 50.5,
            lc45: 37,
            lc30: 24.5,
            lc10: 13
        },
        "pink.400": {
            contrast: 95.18837871121988,
            lc60: 52,
            lc45: 37.5,
            lc30: 25.5,
            lc10: 13
        },
        "pink.500": {
            contrast: 92.03836196207362,
            lc60: 53.5,
            lc45: 39,
            lc30: 25.5,
            lc10: 13.5
        },
        "pink.600": {
            contrast: 87.72327726806968,
            lc60: 56,
            lc45: 40.5,
            lc30: 27,
            lc10: 14
        },
        "pink.700": {
            contrast: 83.54952605941031,
            lc60: 58.5,
            lc45: 42,
            lc30: 27.5,
            lc10: 14.5
        },
        "pink.800": {
            contrast: 78.90527647036228,
            lc60: 62,
            lc45: 43.5,
            lc30: 28.5,
            lc10: 14.5
        },
        "pink.900": {
            contrast: 74.48800090190704,
            lc60: 65.5,
            lc45: 45.5,
            lc30: 29.5,
            lc10: 15.5
        },
        "pink.1000": {
            contrast: 70.6257895276726,
            lc60: 70,
            lc45: 47.5,
            lc30: 31,
            lc10: 16
        },
        "pink.1100": {
            contrast: 64.62962727047585,
            lc60: 79.5,
            lc45: 51,
            lc30: 32.5,
            lc10: 16.5
        },
        "pink.1200": {
            contrast: 62.16682540726916,
            lc60: 90.5,
            lc45: 57,
            lc30: 36,
            lc10: 18
        },
        "pink.1300": {
            contrast: 57.778086594518015,
            lc60: 100,
            lc45: 65.5,
            lc30: 41,
            lc10: 20.5
        },
        "pink.1400": {
            contrast: 53.54622667857877,
            lc60: 100,
            lc45: 74.5,
            lc30: 45.5,
            lc10: 22.5
        },
        "pink.1500": {
            contrast: 49.07891356005756,
            lc60: 100,
            lc45: 86.5,
            lc30: 52,
            lc10: 26
        },
        "pink.1600": {
            contrast: 44.37126857880977,
            lc60: 100,
            lc45: 100,
            lc30: 62,
            lc10: 31
        },
        "pink.1700": {
            contrast: 39.031326382925755,
            lc60: 100,
            lc45: 100,
            lc30: 73,
            lc10: 37
        },
        "pink.1800": {
            contrast: 33.64008007150005,
            lc60: 100,
            lc45: 100,
            lc30: 87.5,
            lc10: 44.5
        },
        "pink.1900": {
            contrast: 27.86667705543983,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53.5
        },
        "pink.2000": {
            contrast: 22.24343206884095,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "pink.2100": {
            contrast: 16.229750830915926,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 92
        },
        "pink.2200": {
            contrast: 10.242763067476183,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "pink.2500": {
        "pink.100": {
            contrast: 106.04067321268862,
            lc60: 44,
            lc45: 32.5,
            lc30: 21.5,
            lc10: 11.5
        },
        "pink.200": {
            contrast: 105.56784789216367,
            lc60: 46,
            lc45: 34,
            lc30: 22.5,
            lc10: 12
        },
        "pink.300": {
            contrast: 103.8860438202816,
            lc60: 47.5,
            lc45: 34.5,
            lc30: 23,
            lc10: 12.5
        },
        "pink.400": {
            contrast: 101.49287053547624,
            lc60: 48,
            lc45: 35,
            lc30: 23.5,
            lc10: 12
        },
        "pink.500": {
            contrast: 98.34285378632998,
            lc60: 49.5,
            lc45: 36.5,
            lc30: 24.5,
            lc10: 12.5
        },
        "pink.600": {
            contrast: 94.02776909232603,
            lc60: 51.5,
            lc45: 37.5,
            lc30: 25,
            lc10: 13
        },
        "pink.700": {
            contrast: 89.85401788366664,
            lc60: 53.5,
            lc45: 39,
            lc30: 25.5,
            lc10: 13.5
        },
        "pink.800": {
            contrast: 85.20976829461861,
            lc60: 56,
            lc45: 40,
            lc30: 26.5,
            lc10: 13.5
        },
        "pink.900": {
            contrast: 80.79249272616339,
            lc60: 58.5,
            lc45: 41.5,
            lc30: 27,
            lc10: 14
        },
        "pink.1000": {
            contrast: 76.93028135192895,
            lc60: 61.5,
            lc45: 43.5,
            lc30: 28,
            lc10: 14.5
        },
        "pink.1100": {
            contrast: 70.9341190947322,
            lc60: 67,
            lc45: 45.5,
            lc30: 29,
            lc10: 15
        },
        "pink.1200": {
            contrast: 68.4713172315255,
            lc60: 75,
            lc45: 50.5,
            lc30: 32.5,
            lc10: 16.5
        },
        "pink.1300": {
            contrast: 64.08257841877437,
            lc60: 86.5,
            lc45: 57.5,
            lc30: 36.5,
            lc10: 18.5
        },
        "pink.1400": {
            contrast: 59.85071850283512,
            lc60: 100,
            lc45: 64,
            lc30: 40,
            lc10: 20.5
        },
        "pink.1500": {
            contrast: 55.38340538431391,
            lc60: 100,
            lc45: 72.5,
            lc30: 45,
            lc10: 23
        },
        "pink.1600": {
            contrast: 50.675760403066114,
            lc60: 100,
            lc45: 85,
            lc30: 53,
            lc10: 27
        },
        "pink.1700": {
            contrast: 45.3358182071821,
            lc60: 100,
            lc45: 98.5,
            lc30: 62,
            lc10: 31.5
        },
        "pink.1800": {
            contrast: 39.9445718957564,
            lc60: 100,
            lc45: 100,
            lc30: 72.5,
            lc10: 37
        },
        "pink.1900": {
            contrast: 34.17116887969618,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 44.5
        },
        "pink.2000": {
            contrast: 28.547923893097295,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54
        },
        "pink.2100": {
            contrast: 22.534242655172275,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68.5
        },
        "pink.2200": {
            contrast: 16.54725489173253,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 92
        },
        "pink.2300": {
            contrast: 10.266989491669868,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    }
};
const $f8fd43f1ee3f8cd8$var$purple = {
    "purple.100": {
        "purple.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.600": {
            contrast: 8.053459220444278,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.700": {
            contrast: 11.810635871538256,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.800": {
            contrast: 16.408706518046316,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95.5
        },
        "purple.900": {
            contrast: 19.52743424233644,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87.5
        },
        "purple.1000": {
            contrast: 23.529303945592357,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79.5
        },
        "purple.1100": {
            contrast: 27.933795878367583,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72.5
        },
        "purple.1200": {
            contrast: 32.50432517762015,
            lc60: 100,
            lc45: 100,
            lc30: 95.5,
            lc10: 66
        },
        "purple.1300": {
            contrast: 37.75780143481969,
            lc60: 100,
            lc45: 100,
            lc30: 87.5,
            lc10: 61
        },
        "purple.1400": {
            contrast: 42.35950880803199,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 57
        },
        "purple.1500": {
            contrast: 47.6052907298007,
            lc60: 100,
            lc45: 96.5,
            lc30: 76.5,
            lc10: 53
        },
        "purple.1600": {
            contrast: 52.517142752061666,
            lc60: 100,
            lc45: 91,
            lc30: 72,
            lc10: 50
        },
        "purple.1700": {
            contrast: 58.210780126896026,
            lc60: 100,
            lc45: 85.5,
            lc30: 68,
            lc10: 47
        },
        "purple.1800": {
            contrast: 63.50601675848413,
            lc60: 96.5,
            lc45: 81,
            lc30: 64,
            lc10: 44.5
        },
        "purple.1900": {
            contrast: 69.4199867476389,
            lc60: 91.5,
            lc45: 76.5,
            lc30: 60.5,
            lc10: 42
        },
        "purple.2000": {
            contrast: 75.32242584011826,
            lc60: 86.5,
            lc45: 73,
            lc30: 57.5,
            lc10: 40
        },
        "purple.2100": {
            contrast: 81.43971855715829,
            lc60: 82.5,
            lc45: 69.5,
            lc30: 55,
            lc10: 38
        },
        "purple.2200": {
            contrast: 87.7624963227358,
            lc60: 79,
            lc45: 66,
            lc30: 52.5,
            lc10: 36.5
        },
        "purple.2300": {
            contrast: 94.28242921926659,
            lc60: 75.5,
            lc45: 63,
            lc30: 50,
            lc10: 35
        },
        "purple.2400": {
            contrast: 100.99207161507782,
            lc60: 72,
            lc45: 60.5,
            lc30: 48,
            lc10: 33.5
        },
        "purple.2500": {
            contrast: 107.88473318309848,
            lc60: 69,
            lc45: 58,
            lc30: 46,
            lc10: 32
        }
    },
    "purple.200": {
        "purple.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.600": {
            contrast: 7.535774029891567,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.700": {
            contrast: 11.292950680985545,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.800": {
            contrast: 15.891021327493608,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 96.5
        },
        "purple.900": {
            contrast: 19.00974905178373,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86.5
        },
        "purple.1000": {
            contrast: 23.011618755039645,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77.5
        },
        "purple.1100": {
            contrast: 27.41611068781487,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69.5
        },
        "purple.1200": {
            contrast: 31.986639987067438,
            lc60: 100,
            lc45: 100,
            lc30: 95.5,
            lc10: 63
        },
        "purple.1300": {
            contrast: 37.24011624426697,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 58
        },
        "purple.1400": {
            contrast: 41.84182361747928,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 54
        },
        "purple.1500": {
            contrast: 47.08760553924798,
            lc60: 100,
            lc45: 97,
            lc30: 75,
            lc10: 50.5
        },
        "purple.1600": {
            contrast: 51.999457561508954,
            lc60: 100,
            lc45: 91,
            lc30: 71,
            lc10: 47.5
        },
        "purple.1700": {
            contrast: 57.693094936343314,
            lc60: 100,
            lc45: 85,
            lc30: 66.5,
            lc10: 44.5
        },
        "purple.1800": {
            contrast: 62.988331567931425,
            lc60: 96.5,
            lc45: 80.5,
            lc30: 62.5,
            lc10: 42
        },
        "purple.1900": {
            contrast: 68.9023015570862,
            lc60: 91.5,
            lc45: 76,
            lc30: 59.5,
            lc10: 40
        },
        "purple.2000": {
            contrast: 74.80474064956555,
            lc60: 86.5,
            lc45: 72.5,
            lc30: 56.5,
            lc10: 38
        },
        "purple.2100": {
            contrast: 80.92203336660559,
            lc60: 82,
            lc45: 68.5,
            lc30: 53.5,
            lc10: 36
        },
        "purple.2200": {
            contrast: 87.24481113218309,
            lc60: 78.5,
            lc45: 65.5,
            lc30: 51,
            lc10: 34.5
        },
        "purple.2300": {
            contrast: 93.76474402871389,
            lc60: 75,
            lc45: 62.5,
            lc30: 49,
            lc10: 33
        },
        "purple.2400": {
            contrast: 100.47438642452511,
            lc60: 71.5,
            lc45: 59.5,
            lc30: 46.5,
            lc10: 31.5
        },
        "purple.2500": {
            contrast: 107.36704799254578,
            lc60: 68.5,
            lc45: 57,
            lc30: 44.5,
            lc10: 30
        }
    },
    "purple.300": {
        "purple.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.700": {
            contrast: 10.109456473073763,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.800": {
            contrast: 14.707527119581822,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.900": {
            contrast: 17.826254843871943,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89
        },
        "purple.1000": {
            contrast: 21.828124547127867,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78
        },
        "purple.1100": {
            contrast: 26.232616479903086,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "purple.1200": {
            contrast: 30.80314577915566,
            lc60: 100,
            lc45: 100,
            lc30: 98,
            lc10: 62.5
        },
        "purple.1300": {
            contrast: 36.05662203635519,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 56.5
        },
        "purple.1400": {
            contrast: 40.6583294095675,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 53
        },
        "purple.1500": {
            contrast: 45.9041113313362,
            lc60: 100,
            lc45: 98.5,
            lc30: 75.5,
            lc10: 49
        },
        "purple.1600": {
            contrast: 50.81596335359717,
            lc60: 100,
            lc45: 92.5,
            lc30: 71,
            lc10: 46.5
        },
        "purple.1700": {
            contrast: 56.50960072843153,
            lc60: 100,
            lc45: 86,
            lc30: 66.5,
            lc10: 43
        },
        "purple.1800": {
            contrast: 61.80483736001964,
            lc60: 97.5,
            lc45: 81,
            lc30: 62.5,
            lc10: 41
        },
        "purple.1900": {
            contrast: 67.71880734917441,
            lc60: 92.5,
            lc45: 76.5,
            lc30: 59,
            lc10: 39
        },
        "purple.2000": {
            contrast: 73.62124644165377,
            lc60: 87,
            lc45: 72.5,
            lc30: 56,
            lc10: 37
        },
        "purple.2100": {
            contrast: 79.7385391586938,
            lc60: 82.5,
            lc45: 68.5,
            lc30: 53,
            lc10: 35.5
        },
        "purple.2200": {
            contrast: 86.0613169242713,
            lc60: 79,
            lc45: 65.5,
            lc30: 50.5,
            lc10: 33.5
        },
        "purple.2300": {
            contrast: 92.5812498208021,
            lc60: 75.5,
            lc45: 62.5,
            lc30: 48.5,
            lc10: 32
        },
        "purple.2400": {
            contrast: 99.29089221661333,
            lc60: 71.5,
            lc45: 59.5,
            lc30: 46,
            lc10: 30.5
        },
        "purple.2500": {
            contrast: 106.18355378463397,
            lc60: 68.5,
            lc45: 57,
            lc30: 44.5,
            lc10: 29.5
        }
    },
    "purple.400": {
        "purple.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.700": {
            contrast: 8.367769199767029,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.800": {
            contrast: 12.965839846275088,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.900": {
            contrast: 16.08456757056521,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95
        },
        "purple.1000": {
            contrast: 20.08643727382113,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81
        },
        "purple.1100": {
            contrast: 24.49092920659636,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "purple.1200": {
            contrast: 29.06145850584892,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "purple.1300": {
            contrast: 34.314934763048456,
            lc60: 100,
            lc45: 100,
            lc30: 91,
            lc10: 57
        },
        "purple.1400": {
            contrast: 38.91664213626076,
            lc60: 100,
            lc45: 100,
            lc30: 84,
            lc10: 53
        },
        "purple.1500": {
            contrast: 44.162424058029465,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 49
        },
        "purple.1600": {
            contrast: 49.07427608029044,
            lc60: 100,
            lc45: 94,
            lc30: 72,
            lc10: 46
        },
        "purple.1700": {
            contrast: 54.767913455124784,
            lc60: 100,
            lc45: 87.5,
            lc30: 67,
            lc10: 43
        },
        "purple.1800": {
            contrast: 60.06315008671289,
            lc60: 99.5,
            lc45: 82.5,
            lc30: 63.5,
            lc10: 40.5
        },
        "purple.1900": {
            contrast: 65.97712007586767,
            lc60: 93.5,
            lc45: 77.5,
            lc30: 59.5,
            lc10: 39
        },
        "purple.2000": {
            contrast: 71.87955916834701,
            lc60: 88.5,
            lc45: 73.5,
            lc30: 56.5,
            lc10: 36.5
        },
        "purple.2100": {
            contrast: 77.99685188538706,
            lc60: 84,
            lc45: 69.5,
            lc30: 53.5,
            lc10: 35
        },
        "purple.2200": {
            contrast: 84.31962965096456,
            lc60: 80,
            lc45: 66,
            lc30: 51,
            lc10: 33.5
        },
        "purple.2300": {
            contrast: 90.83956254749536,
            lc60: 75.5,
            lc45: 63,
            lc30: 48.5,
            lc10: 31.5
        },
        "purple.2400": {
            contrast: 97.54920494330658,
            lc60: 72.5,
            lc45: 60,
            lc30: 46.5,
            lc10: 30.5
        },
        "purple.2500": {
            contrast: 104.44186651132723,
            lc60: 69.5,
            lc45: 57.5,
            lc30: 44.5,
            lc10: 29
        }
    },
    "purple.500": {
        "purple.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.800": {
            contrast: 10.56193980918392,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.900": {
            contrast: 13.680667533474045,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1000": {
            contrast: 17.682537236729964,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88.5
        },
        "purple.1100": {
            contrast: 22.087029169505193,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76
        },
        "purple.1200": {
            contrast: 26.65755846875776,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66.5
        },
        "purple.1300": {
            contrast: 31.911034725957293,
            lc60: 100,
            lc45: 100,
            lc30: 95.5,
            lc10: 59.5
        },
        "purple.1400": {
            contrast: 36.5127420991696,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 55
        },
        "purple.1500": {
            contrast: 41.7585240209383,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 50.5
        },
        "purple.1600": {
            contrast: 46.67037604319927,
            lc60: 100,
            lc45: 97.5,
            lc30: 74.5,
            lc10: 47.5
        },
        "purple.1700": {
            contrast: 52.36401341803363,
            lc60: 100,
            lc45: 90.5,
            lc30: 69,
            lc10: 44
        },
        "purple.1800": {
            contrast: 57.65925004962173,
            lc60: 100,
            lc45: 84.5,
            lc30: 64.5,
            lc10: 41.5
        },
        "purple.1900": {
            contrast: 63.57322003877651,
            lc60: 96,
            lc45: 79.5,
            lc30: 61,
            lc10: 39
        },
        "purple.2000": {
            contrast: 69.47565913125587,
            lc60: 90.5,
            lc45: 75,
            lc30: 57.5,
            lc10: 37
        },
        "purple.2100": {
            contrast: 75.5929518482959,
            lc60: 85.5,
            lc45: 71,
            lc30: 54.5,
            lc10: 35.5
        },
        "purple.2200": {
            contrast: 81.9157296138734,
            lc60: 81.5,
            lc45: 67.5,
            lc30: 51.5,
            lc10: 33.5
        },
        "purple.2300": {
            contrast: 88.4356625104042,
            lc60: 77.5,
            lc45: 64,
            lc30: 49.5,
            lc10: 32
        },
        "purple.2400": {
            contrast: 95.14530490621542,
            lc60: 73.5,
            lc45: 61,
            lc30: 47,
            lc10: 30.5
        },
        "purple.2500": {
            contrast: 102.03796647423609,
            lc60: 70.5,
            lc45: 58.5,
            lc30: 45,
            lc10: 29
        }
    },
    "purple.600": {
        "purple.100": {
            contrast: 9.377397279489102,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.200": {
            contrast: 8.684486664539167,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.900": {
            contrast: 10.133775805337763,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1000": {
            contrast: 14.135645508593687,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1100": {
            contrast: 18.540137441368916,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86
        },
        "purple.1200": {
            contrast: 23.11066674062148,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74.5
        },
        "purple.1300": {
            contrast: 28.364142997821013,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64.5
        },
        "purple.1400": {
            contrast: 32.96585037103332,
            lc60: 100,
            lc45: 100,
            lc30: 93.5,
            lc10: 59
        },
        "purple.1500": {
            contrast: 38.21163229280202,
            lc60: 100,
            lc45: 100,
            lc30: 85,
            lc10: 54
        },
        "purple.1600": {
            contrast: 43.12348431506299,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 50
        },
        "purple.1700": {
            contrast: 48.81712168989735,
            lc60: 100,
            lc45: 94.5,
            lc30: 73,
            lc10: 46.5
        },
        "purple.1800": {
            contrast: 54.11235832148545,
            lc60: 100,
            lc45: 88.5,
            lc30: 68.5,
            lc10: 44
        },
        "purple.1900": {
            contrast: 60.02632831064022,
            lc60: 99.5,
            lc45: 83,
            lc30: 64,
            lc10: 41
        },
        "purple.2000": {
            contrast: 65.9287674031196,
            lc60: 94,
            lc45: 78,
            lc30: 60,
            lc10: 39
        },
        "purple.2100": {
            contrast: 72.04606012015962,
            lc60: 88.5,
            lc45: 73.5,
            lc30: 57,
            lc10: 36.5
        },
        "purple.2200": {
            contrast: 78.36883788573711,
            lc60: 84,
            lc45: 70,
            lc30: 54,
            lc10: 35
        },
        "purple.2300": {
            contrast: 84.88877078226793,
            lc60: 79.5,
            lc45: 66,
            lc30: 51,
            lc10: 33
        },
        "purple.2400": {
            contrast: 91.59841317807914,
            lc60: 75.5,
            lc45: 63,
            lc30: 48.5,
            lc10: 31.5
        },
        "purple.2500": {
            contrast: 98.49107474609978,
            lc60: 72,
            lc45: 60,
            lc30: 46.5,
            lc10: 30
        }
    },
    "purple.700": {
        "purple.100": {
            contrast: 13.481017345375879,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.200": {
            contrast: 12.788106730425945,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.300": {
            contrast: 11.243673357583425,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.400": {
            contrast: 9.047618773663691,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1000": {
            contrast: 10.553562063361957,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1100": {
            contrast: 14.958053996137185,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1200": {
            contrast: 19.52858329538975,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84
        },
        "purple.1300": {
            contrast: 24.782059552589285,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "purple.1400": {
            contrast: 29.383766925801584,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65
        },
        "purple.1500": {
            contrast: 34.6295488475703,
            lc60: 100,
            lc45: 100,
            lc30: 91,
            lc10: 59
        },
        "purple.1600": {
            contrast: 39.541400869831264,
            lc60: 100,
            lc45: 100,
            lc30: 83.5,
            lc10: 54.5
        },
        "purple.1700": {
            contrast: 45.23503824466562,
            lc60: 100,
            lc45: 99.5,
            lc30: 77.5,
            lc10: 50
        },
        "purple.1800": {
            contrast: 50.53027487625372,
            lc60: 100,
            lc45: 92.5,
            lc30: 72,
            lc10: 46.5
        },
        "purple.1900": {
            contrast: 56.4442448654085,
            lc60: 100,
            lc45: 86.5,
            lc30: 67,
            lc10: 43.5
        },
        "purple.2000": {
            contrast: 62.34668395788785,
            lc60: 97.5,
            lc45: 81,
            lc30: 63,
            lc10: 41
        },
        "purple.2100": {
            contrast: 68.46397667492788,
            lc60: 92,
            lc45: 76.5,
            lc30: 59.5,
            lc10: 38.5
        },
        "purple.2200": {
            contrast: 74.78675444050539,
            lc60: 86.5,
            lc45: 72,
            lc30: 56,
            lc10: 36.5
        },
        "purple.2300": {
            contrast: 81.30668733703618,
            lc60: 82,
            lc45: 68.5,
            lc30: 53,
            lc10: 35
        },
        "purple.2400": {
            contrast: 88.01632973284741,
            lc60: 78,
            lc45: 65.5,
            lc30: 50.5,
            lc10: 33
        },
        "purple.2500": {
            contrast: 94.90899130086805,
            lc60: 74.5,
            lc45: 62,
            lc30: 48,
            lc10: 31.5
        }
    },
    "purple.800": {
        "purple.100": {
            contrast: 18.39180063926081,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58.5
        },
        "purple.200": {
            contrast: 17.698890024310877,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "purple.300": {
            contrast: 16.154456651468358,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88.5
        },
        "purple.400": {
            contrast: 13.958402067548628,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.500": {
            contrast: 11.036201731264297,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1100": {
            contrast: 10.524882620165357,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1200": {
            contrast: 15.095411919417923,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 99
        },
        "purple.1300": {
            contrast: 20.348888176617457,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80
        },
        "purple.1400": {
            contrast: 24.950595549829764,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "purple.1500": {
            contrast: 30.196377471598467,
            lc60: 100,
            lc45: 100,
            lc30: 99.5,
            lc10: 61
        },
        "purple.1600": {
            contrast: 35.10822949385943,
            lc60: 100,
            lc45: 100,
            lc30: 89.5,
            lc10: 55.5
        },
        "purple.1700": {
            contrast: 40.80186686869379,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 49.5
        },
        "purple.1800": {
            contrast: 46.0971035002819,
            lc60: 100,
            lc45: 98,
            lc30: 74,
            lc10: 46.5
        },
        "purple.1900": {
            contrast: 52.011073489436676,
            lc60: 100,
            lc45: 90.5,
            lc30: 69,
            lc10: 42.5
        },
        "purple.2000": {
            contrast: 57.913512581916024,
            lc60: 100,
            lc45: 84.5,
            lc30: 63.5,
            lc10: 39.5
        },
        "purple.2100": {
            contrast: 64.03080529895607,
            lc60: 95.5,
            lc45: 78.5,
            lc30: 59.5,
            lc10: 37
        },
        "purple.2200": {
            contrast: 70.35358306453355,
            lc60: 89.5,
            lc45: 73.5,
            lc30: 55.5,
            lc10: 34.5
        },
        "purple.2300": {
            contrast: 76.87351596106436,
            lc60: 84,
            lc45: 69,
            lc30: 52.5,
            lc10: 32.5
        },
        "purple.2400": {
            contrast: 83.58315835687559,
            lc60: 79.5,
            lc45: 65.5,
            lc30: 49.5,
            lc10: 31
        },
        "purple.2500": {
            contrast: 90.47581992489624,
            lc60: 75.5,
            lc45: 62,
            lc30: 47,
            lc10: 29.5
        }
    },
    "purple.900": {
        "purple.100": {
            contrast: 21.666314473251372,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 47.5
        },
        "purple.200": {
            contrast: 20.973403858301438,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58
        },
        "purple.300": {
            contrast: 19.42897048545892,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68.5
        },
        "purple.400": {
            contrast: 17.232915901539187,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83
        },
        "purple.500": {
            contrast: 14.310715565254858,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.600": {
            contrast: 10.162283955397486,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1100": {
            contrast: 7.492285289881891,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1200": {
            contrast: 12.062814589134454,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1300": {
            contrast: 17.316290846333988,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89
        },
        "purple.1400": {
            contrast: 21.9179982195463,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75
        },
        "purple.1500": {
            contrast: 27.163780141315,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63.5
        },
        "purple.1600": {
            contrast: 32.07563216357596,
            lc60: 100,
            lc45: 100,
            lc30: 95.5,
            lc10: 56.5
        },
        "purple.1700": {
            contrast: 37.76926953841032,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 50.5
        },
        "purple.1800": {
            contrast: 43.06450616999843,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 46
        },
        "purple.1900": {
            contrast: 48.9784761591532,
            lc60: 100,
            lc45: 94,
            lc30: 70,
            lc10: 41.5
        },
        "purple.2000": {
            contrast: 54.88091525163256,
            lc60: 100,
            lc45: 86.5,
            lc30: 64.5,
            lc10: 38.5
        },
        "purple.2100": {
            contrast: 60.99820796867259,
            lc60: 98.5,
            lc45: 80,
            lc30: 59.5,
            lc10: 35.5
        },
        "purple.2200": {
            contrast: 67.32098573425009,
            lc60: 92,
            lc45: 74.5,
            lc30: 55.5,
            lc10: 33
        },
        "purple.2300": {
            contrast: 73.84091863078089,
            lc60: 86,
            lc45: 70,
            lc30: 52,
            lc10: 31
        },
        "purple.2400": {
            contrast: 80.55056102659212,
            lc60: 80.5,
            lc45: 66,
            lc30: 49,
            lc10: 29
        },
        "purple.2500": {
            contrast: 87.44322259461276,
            lc60: 76,
            lc45: 62,
            lc30: 46,
            lc10: 27.5
        }
    },
    "purple.1000": {
        "purple.100": {
            contrast: 25.812470949963128,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 41
        },
        "purple.200": {
            contrast: 25.119560335013198,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 48
        },
        "purple.300": {
            contrast: 23.575126962170682,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "purple.400": {
            contrast: 21.379072378250953,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64.5
        },
        "purple.500": {
            contrast: 18.456872041966623,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78.5
        },
        "purple.600": {
            contrast: 14.308440432109249,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.700": {
            contrast: 10.261739193150937,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1200": {
            contrast: 8.14544923024596,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1300": {
            contrast: 13.398925487445496,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1400": {
            contrast: 18.0006328606578,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87
        },
        "purple.1500": {
            contrast: 23.24641478242651,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70.5
        },
        "purple.1600": {
            contrast: 28.15826680468747,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60.5
        },
        "purple.1700": {
            contrast: 33.85190417952183,
            lc60: 100,
            lc45: 100,
            lc30: 90.5,
            lc10: 53
        },
        "purple.1800": {
            contrast: 39.147140811109935,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 47.5
        },
        "purple.1900": {
            contrast: 45.0611108002647,
            lc60: 100,
            lc45: 99.5,
            lc30: 73.5,
            lc10: 42.5
        },
        "purple.2000": {
            contrast: 50.96354989274406,
            lc60: 100,
            lc45: 91,
            lc30: 67,
            lc10: 39
        },
        "purple.2100": {
            contrast: 57.0808426097841,
            lc60: 100,
            lc45: 83.5,
            lc30: 61,
            lc10: 36
        },
        "purple.2200": {
            contrast: 63.40362037536159,
            lc60: 96,
            lc45: 77.5,
            lc30: 56.5,
            lc10: 33
        },
        "purple.2300": {
            contrast: 69.9235532718924,
            lc60: 89,
            lc45: 72,
            lc30: 53,
            lc10: 31
        },
        "purple.2400": {
            contrast: 76.63319566770362,
            lc60: 83.5,
            lc45: 67.5,
            lc30: 49,
            lc10: 29
        },
        "purple.2500": {
            contrast: 83.52585723572426,
            lc60: 78.5,
            lc45: 63,
            lc30: 46,
            lc10: 27
        }
    },
    "purple.1100": {
        "purple.100": {
            contrast: 30.313649551273635,
            lc60: 100,
            lc45: 100,
            lc30: 89,
            lc10: 35
        },
        "purple.200": {
            contrast: 29.620738936323704,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 40.5
        },
        "purple.300": {
            contrast: 28.07630556348118,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 46
        },
        "purple.400": {
            contrast: 25.880250979561453,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 52
        },
        "purple.500": {
            contrast: 22.95805064327713,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60.5
        },
        "purple.600": {
            contrast: 18.809619033419757,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75.5
        },
        "purple.700": {
            contrast: 14.762917794461442,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.800": {
            contrast: 9.902130966426673,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1300": {
            contrast: 9.057794621502895,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1400": {
            contrast: 13.659501994715201,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1500": {
            contrast: 18.905283916483906,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82.5
        },
        "purple.1600": {
            contrast: 23.817135938744872,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68.5
        },
        "purple.1700": {
            contrast: 29.51077331357923,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58.5
        },
        "purple.1800": {
            contrast: 34.80600994516734,
            lc60: 100,
            lc45: 100,
            lc30: 89,
            lc10: 51
        },
        "purple.1900": {
            contrast: 40.71997993432211,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 45.5
        },
        "purple.2000": {
            contrast: 46.62241902680147,
            lc60: 100,
            lc45: 97,
            lc30: 70.5,
            lc10: 41
        },
        "purple.2100": {
            contrast: 52.7397117438415,
            lc60: 100,
            lc45: 88.5,
            lc30: 64.5,
            lc10: 37
        },
        "purple.2200": {
            contrast: 59.062489509418995,
            lc60: 100,
            lc45: 81.5,
            lc30: 59,
            lc10: 33.5
        },
        "purple.2300": {
            contrast: 65.58242240594979,
            lc60: 93,
            lc45: 74.5,
            lc30: 54.5,
            lc10: 31
        },
        "purple.2400": {
            contrast: 72.29206480176103,
            lc60: 86.5,
            lc45: 69.5,
            lc30: 50.5,
            lc10: 29
        },
        "purple.2500": {
            contrast: 79.18472636978167,
            lc60: 80.5,
            lc45: 65,
            lc30: 47,
            lc10: 27
        }
    },
    "purple.1200": {
        "purple.100": {
            contrast: 34.92523364687459,
            lc60: 100,
            lc45: 100,
            lc30: 65.5,
            lc10: 31
        },
        "purple.200": {
            contrast: 34.23232303192466,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 35
        },
        "purple.300": {
            contrast: 32.68788965908213,
            lc60: 100,
            lc45: 100,
            lc30: 84,
            lc10: 38.5
        },
        "purple.400": {
            contrast: 30.491835075162406,
            lc60: 100,
            lc45: 100,
            lc30: 96.5,
            lc10: 42.5
        },
        "purple.500": {
            contrast: 27.569634738878072,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 48.5
        },
        "purple.600": {
            contrast: 23.421203129020704,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "purple.700": {
            contrast: 19.374501890062394,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70.5
        },
        "purple.800": {
            contrast: 14.513715062027623,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.900": {
            contrast: 11.263307965368623,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1400": {
            contrast: 9.125867223942423,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1500": {
            contrast: 14.371649145711126,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1600": {
            contrast: 19.283501167972094,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80.5
        },
        "purple.1700": {
            contrast: 24.977138542806458,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65
        },
        "purple.1800": {
            contrast: 30.27237517439456,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 56
        },
        "purple.1900": {
            contrast: 36.186345163549326,
            lc60: 100,
            lc45: 100,
            lc30: 86,
            lc10: 48
        },
        "purple.2000": {
            contrast: 42.08878425602868,
            lc60: 100,
            lc45: 100,
            lc30: 75.5,
            lc10: 43
        },
        "purple.2100": {
            contrast: 48.206076973068726,
            lc60: 100,
            lc45: 94.5,
            lc30: 68,
            lc10: 38.5
        },
        "purple.2200": {
            contrast: 54.52885473864622,
            lc60: 100,
            lc45: 86,
            lc30: 62,
            lc10: 35
        },
        "purple.2300": {
            contrast: 61.04878763517703,
            lc60: 98,
            lc45: 78.5,
            lc30: 56.5,
            lc10: 32
        },
        "purple.2400": {
            contrast: 67.75843003098824,
            lc60: 90.5,
            lc45: 72,
            lc30: 52,
            lc10: 29
        },
        "purple.2500": {
            contrast: 74.6510915990089,
            lc60: 84,
            lc45: 67,
            lc30: 48.5,
            lc10: 27
        }
    },
    "purple.1300": {
        "purple.100": {
            contrast: 40.161262120171884,
            lc60: 100,
            lc45: 100,
            lc30: 55.5,
            lc10: 27.5
        },
        "purple.200": {
            contrast: 39.46835150522195,
            lc60: 100,
            lc45: 100,
            lc30: 62,
            lc10: 30.5
        },
        "purple.300": {
            contrast: 37.923918132379434,
            lc60: 100,
            lc45: 100,
            lc30: 68,
            lc10: 33
        },
        "purple.400": {
            contrast: 35.72786354845971,
            lc60: 100,
            lc45: 100,
            lc30: 76,
            lc10: 36
        },
        "purple.500": {
            contrast: 32.80566321217538,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 40
        },
        "purple.600": {
            contrast: 28.657231602318014,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 45
        },
        "purple.700": {
            contrast: 24.610530363359697,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51.5
        },
        "purple.800": {
            contrast: 19.749743535324924,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "purple.900": {
            contrast: 16.499336438665928,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 90.5
        },
        "purple.1000": {
            contrast: 12.374554872690672,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1100": {
            contrast: 7.886340335305032,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1500": {
            contrast: 9.128513871500772,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1600": {
            contrast: 14.040365893761741,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1700": {
            contrast: 19.7340032685961,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79.5
        },
        "purple.1800": {
            contrast: 25.0292399001842,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "purple.1900": {
            contrast: 30.943209889338974,
            lc60: 100,
            lc45: 100,
            lc30: 96.5,
            lc10: 54
        },
        "purple.2000": {
            contrast: 36.84564898181833,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 47
        },
        "purple.2100": {
            contrast: 42.962941698858366,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 41.5
        },
        "purple.2200": {
            contrast: 49.285719464435864,
            lc60: 100,
            lc45: 92.5,
            lc30: 66.5,
            lc10: 36.5
        },
        "purple.2300": {
            contrast: 55.805652360966675,
            lc60: 100,
            lc45: 84,
            lc30: 60,
            lc10: 33
        },
        "purple.2400": {
            contrast: 62.515294756777884,
            lc60: 96.5,
            lc45: 76,
            lc30: 54.5,
            lc10: 30.5
        },
        "purple.2500": {
            contrast: 69.40795632479853,
            lc60: 89,
            lc45: 70,
            lc30: 50,
            lc10: 28
        }
    },
    "purple.1400": {
        "purple.100": {
            contrast: 44.69774288703743,
            lc60: 100,
            lc45: 100,
            lc30: 50,
            lc10: 25
        },
        "purple.200": {
            contrast: 44.0048322720875,
            lc60: 100,
            lc45: 100,
            lc30: 55,
            lc10: 27
        },
        "purple.300": {
            contrast: 42.46039889924498,
            lc60: 100,
            lc45: 100,
            lc30: 59.5,
            lc10: 29.5
        },
        "purple.400": {
            contrast: 40.264344315325246,
            lc60: 100,
            lc45: 100,
            lc30: 65,
            lc10: 31
        },
        "purple.500": {
            contrast: 37.34214397904092,
            lc60: 100,
            lc45: 100,
            lc30: 72,
            lc10: 34
        },
        "purple.600": {
            contrast: 33.19371236918355,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 37.5
        },
        "purple.700": {
            contrast: 29.147011130225238,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 42.5
        },
        "purple.800": {
            contrast: 24.286224302190465,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "purple.900": {
            contrast: 21.03581720553147,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "purple.1000": {
            contrast: 16.911035639556214,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87.5
        },
        "purple.1100": {
            contrast: 12.422821102170573,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1200": {
            contrast: 7.814719579886963,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1600": {
            contrast: 9.422513362341569,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1700": {
            contrast: 15.116150737175927,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98.5
        },
        "purple.1800": {
            contrast: 20.411387368764032,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76.5
        },
        "purple.1900": {
            contrast: 26.3253573579188,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61.5
        },
        "purple.2000": {
            contrast: 32.22779645039815,
            lc60: 100,
            lc45: 100,
            lc30: 94,
            lc10: 51
        },
        "purple.2100": {
            contrast: 38.34508916743819,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 44.5
        },
        "purple.2200": {
            contrast: 44.667866933015695,
            lc60: 100,
            lc45: 100,
            lc30: 71,
            lc10: 39
        },
        "purple.2300": {
            contrast: 51.1877998295465,
            lc60: 100,
            lc45: 89.5,
            lc30: 63.5,
            lc10: 35
        },
        "purple.2400": {
            contrast: 57.89744222535771,
            lc60: 100,
            lc45: 81,
            lc30: 57.5,
            lc10: 31.5
        },
        "purple.2500": {
            contrast: 64.79010379337835,
            lc60: 93.5,
            lc45: 73.5,
            lc30: 52.5,
            lc10: 29
        }
    },
    "purple.1500": {
        "purple.100": {
            contrast: 49.81872189887193,
            lc60: 100,
            lc45: 72.5,
            lc30: 45,
            lc10: 22.5
        },
        "purple.200": {
            contrast: 49.125811283922005,
            lc60: 100,
            lc45: 79.5,
            lc30: 48.5,
            lc10: 24.5
        },
        "purple.300": {
            contrast: 47.58137791107948,
            lc60: 100,
            lc45: 87,
            lc30: 52,
            lc10: 26
        },
        "purple.400": {
            contrast: 45.38532332715975,
            lc60: 100,
            lc45: 97.5,
            lc30: 56,
            lc10: 27.5
        },
        "purple.500": {
            contrast: 42.463122990875426,
            lc60: 100,
            lc45: 100,
            lc30: 61,
            lc10: 29
        },
        "purple.600": {
            contrast: 38.31469138101806,
            lc60: 100,
            lc45: 100,
            lc30: 68.5,
            lc10: 32
        },
        "purple.700": {
            contrast: 34.267990142059745,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 35
        },
        "purple.800": {
            contrast: 29.407203314024976,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 43.5
        },
        "purple.900": {
            contrast: 26.156796217365972,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 52.5
        },
        "purple.1000": {
            contrast: 22.032014651390718,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64.5
        },
        "purple.1100": {
            contrast: 17.54380011400508,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84
        },
        "purple.1200": {
            contrast: 12.93569859172147,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1300": {
            contrast: 7.692914605228348,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1700": {
            contrast: 9.826097686260754,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1800": {
            contrast: 15.121334317848861,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98.5
        },
        "purple.1900": {
            contrast: 21.03530430700363,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74
        },
        "purple.2000": {
            contrast: 26.937743399482983,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "purple.2100": {
            contrast: 33.05503611652302,
            lc60: 100,
            lc45: 100,
            lc30: 91,
            lc10: 49.5
        },
        "purple.2200": {
            contrast: 39.37781388210052,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 42.5
        },
        "purple.2300": {
            contrast: 45.89774677863132,
            lc60: 100,
            lc45: 98,
            lc30: 69,
            lc10: 37
        },
        "purple.2400": {
            contrast: 52.607389174442545,
            lc60: 100,
            lc45: 87,
            lc30: 62,
            lc10: 33
        },
        "purple.2500": {
            contrast: 59.50005074246319,
            lc60: 100,
            lc45: 78.5,
            lc30: 55.5,
            lc10: 30
        }
    },
    "purple.1600": {
        "purple.100": {
            contrast: 54.569884313017525,
            lc60: 100,
            lc45: 64.5,
            lc30: 41,
            lc10: 21
        },
        "purple.200": {
            contrast: 53.87697369806759,
            lc60: 100,
            lc45: 69.5,
            lc30: 44,
            lc10: 22.5
        },
        "purple.300": {
            contrast: 52.332540325225075,
            lc60: 100,
            lc45: 74.5,
            lc30: 46.5,
            lc10: 23
        },
        "purple.400": {
            contrast: 50.13648574130535,
            lc60: 100,
            lc45: 80.5,
            lc30: 49.5,
            lc10: 24.5
        },
        "purple.500": {
            contrast: 47.214285405021016,
            lc60: 100,
            lc45: 91,
            lc30: 53.5,
            lc10: 26.5
        },
        "purple.600": {
            contrast: 43.06585379516365,
            lc60: 100,
            lc45: 100,
            lc30: 58.5,
            lc10: 28
        },
        "purple.700": {
            contrast: 39.019152556205334,
            lc60: 100,
            lc45: 100,
            lc30: 64.5,
            lc10: 30
        },
        "purple.800": {
            contrast: 34.15836572817056,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 37.5
        },
        "purple.900": {
            contrast: 30.907958631511562,
            lc60: 100,
            lc45: 100,
            lc30: 95.5,
            lc10: 44
        },
        "purple.1000": {
            contrast: 26.7831770655363,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 52.5
        },
        "purple.1100": {
            contrast: 22.294962528150666,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65.5
        },
        "purple.1200": {
            contrast: 17.68686100586706,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83.5
        },
        "purple.1300": {
            contrast: 12.444077019373937,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1400": {
            contrast: 7.893445064351509,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1800": {
            contrast: 10.145237955553077,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1900": {
            contrast: 16.059207944707847,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93.5
        },
        "purple.2000": {
            contrast: 21.961647037187202,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "purple.2100": {
            contrast: 28.078939754227232,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "purple.2200": {
            contrast: 34.401717519804734,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 48
        },
        "purple.2300": {
            contrast: 40.92165041633554,
            lc60: 100,
            lc45: 100,
            lc30: 76,
            lc10: 40.5
        },
        "purple.2400": {
            contrast: 47.631292812146754,
            lc60: 100,
            lc45: 95,
            lc30: 67,
            lc10: 35.5
        },
        "purple.2500": {
            contrast: 54.5239543801674,
            lc60: 100,
            lc45: 85,
            lc30: 59.5,
            lc10: 31.5
        }
    },
    "purple.1700": {
        "purple.100": {
            contrast: 60.029413343156726,
            lc60: 97,
            lc45: 58.5,
            lc30: 37.5,
            lc10: 19
        },
        "purple.200": {
            contrast: 59.33650272820679,
            lc60: 100,
            lc45: 62,
            lc30: 40,
            lc10: 20.5
        },
        "purple.300": {
            contrast: 57.79206935536426,
            lc60: 100,
            lc45: 66,
            lc30: 42,
            lc10: 21
        },
        "purple.400": {
            contrast: 55.59601477144454,
            lc60: 100,
            lc45: 70,
            lc30: 44,
            lc10: 22
        },
        "purple.500": {
            contrast: 52.6738144351602,
            lc60: 100,
            lc45: 76,
            lc30: 47,
            lc10: 23.5
        },
        "purple.600": {
            contrast: 48.525382825302835,
            lc60: 100,
            lc45: 85.5,
            lc30: 50,
            lc10: 25
        },
        "purple.700": {
            contrast: 44.47868158634452,
            lc60: 100,
            lc45: 100,
            lc30: 54.5,
            lc10: 26
        },
        "purple.800": {
            contrast: 39.61789475830975,
            lc60: 100,
            lc45: 100,
            lc30: 66,
            lc10: 32
        },
        "purple.900": {
            contrast: 36.36748766165075,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 37
        },
        "purple.1000": {
            contrast: 32.242706095675494,
            lc60: 100,
            lc45: 100,
            lc30: 90.5,
            lc10: 42.5
        },
        "purple.1100": {
            contrast: 27.754491558289857,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51
        },
        "purple.1200": {
            contrast: 23.146390036006245,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63.5
        },
        "purple.1300": {
            contrast: 17.903606049513126,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83
        },
        "purple.1400": {
            contrast: 13.3529740944907,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1500": {
            contrast: 8.20762113435153,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1900": {
            contrast: 10.265880941862038,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.2000": {
            contrast: 16.16832003434139,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93
        },
        "purple.2100": {
            contrast: 22.285612751381425,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "purple.2200": {
            contrast: 28.608390516958927,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "purple.2300": {
            contrast: 35.128323413489724,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 47
        },
        "purple.2400": {
            contrast: 41.83796580930095,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 40.5
        },
        "purple.2500": {
            contrast: 48.73062737732159,
            lc60: 100,
            lc45: 93,
            lc30: 65,
            lc10: 35.5
        }
    },
    "purple.1800": {
        "purple.100": {
            contrast: 65.06498328445505,
            lc60: 76.5,
            lc45: 53.5,
            lc30: 34.5,
            lc10: 17.5
        },
        "purple.200": {
            contrast: 64.37207266950512,
            lc60: 82,
            lc45: 56.5,
            lc30: 36.5,
            lc10: 18.5
        },
        "purple.300": {
            contrast: 62.82763929666258,
            lc60: 87.5,
            lc45: 59.5,
            lc30: 38.5,
            lc10: 19.5
        },
        "purple.400": {
            contrast: 60.63158471274286,
            lc60: 96.5,
            lc45: 62.5,
            lc30: 40,
            lc10: 20
        },
        "purple.500": {
            contrast: 57.70938437645854,
            lc60: 100,
            lc45: 67,
            lc30: 42.5,
            lc10: 21
        },
        "purple.600": {
            contrast: 53.56095276660117,
            lc60: 100,
            lc45: 73,
            lc30: 45,
            lc10: 22.5
        },
        "purple.700": {
            contrast: 49.51425152764285,
            lc60: 100,
            lc45: 81.5,
            lc30: 47.5,
            lc10: 23.5
        },
        "purple.800": {
            contrast: 44.65346469960808,
            lc60: 100,
            lc45: 100,
            lc30: 57,
            lc10: 28
        },
        "purple.900": {
            contrast: 41.403057602949076,
            lc60: 100,
            lc45: 100,
            lc30: 65,
            lc10: 32
        },
        "purple.1000": {
            contrast: 37.27827603697382,
            lc60: 100,
            lc45: 100,
            lc30: 75.5,
            lc10: 37
        },
        "purple.1100": {
            contrast: 32.790061499588184,
            lc60: 100,
            lc45: 100,
            lc30: 89.5,
            lc10: 43
        },
        "purple.1200": {
            contrast: 28.181959977304572,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51
        },
        "purple.1300": {
            contrast: 22.93917599081146,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "purple.1400": {
            contrast: 18.388544035789028,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82
        },
        "purple.1500": {
            contrast: 13.24319107564986,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1600": {
            contrast: 8.462102227062191,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.2000": {
            contrast: 10.757982334916344,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.2100": {
            contrast: 16.87527505195638,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 90.5
        },
        "purple.2200": {
            contrast: 23.198052817533878,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "purple.2300": {
            contrast: 29.71798571406468,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54.5
        },
        "purple.2400": {
            contrast: 36.4276281098759,
            lc60: 100,
            lc45: 100,
            lc30: 84,
            lc10: 45.5
        },
        "purple.2500": {
            contrast: 43.32028967789655,
            lc60: 100,
            lc45: 100,
            lc30: 72,
            lc10: 39
        }
    },
    "purple.1900": {
        "purple.100": {
            contrast: 70.64538493793631,
            lc60: 68.5,
            lc45: 49,
            lc30: 32,
            lc10: 16.5
        },
        "purple.200": {
            contrast: 69.95247432298638,
            lc60: 72.5,
            lc45: 51.5,
            lc30: 33.5,
            lc10: 17
        },
        "purple.300": {
            contrast: 68.40804095014386,
            lc60: 76.5,
            lc45: 53.5,
            lc30: 35,
            lc10: 18
        },
        "purple.400": {
            contrast: 66.21198636622412,
            lc60: 81.5,
            lc45: 56.5,
            lc30: 36.5,
            lc10: 18.5
        },
        "purple.500": {
            contrast: 63.2897860299398,
            lc60: 88.5,
            lc45: 59.5,
            lc30: 38,
            lc10: 19
        },
        "purple.600": {
            contrast: 59.141354420082436,
            lc60: 100,
            lc45: 63.5,
            lc30: 40,
            lc10: 20
        },
        "purple.700": {
            contrast: 55.09465318112412,
            lc60: 100,
            lc45: 68.5,
            lc30: 42,
            lc10: 21.5
        },
        "purple.800": {
            contrast: 50.233866353089354,
            lc60: 100,
            lc45: 82.5,
            lc30: 49.5,
            lc10: 24.5
        },
        "purple.900": {
            contrast: 46.98345925643035,
            lc60: 100,
            lc45: 93,
            lc30: 55.5,
            lc10: 27.5
        },
        "purple.1000": {
            contrast: 42.858677690455096,
            lc60: 100,
            lc45: 100,
            lc30: 64,
            lc10: 31.5
        },
        "purple.1100": {
            contrast: 38.37046315306946,
            lc60: 100,
            lc45: 100,
            lc30: 73.5,
            lc10: 36.5
        },
        "purple.1200": {
            contrast: 33.76236163078584,
            lc60: 100,
            lc45: 100,
            lc30: 86,
            lc10: 42
        },
        "purple.1300": {
            contrast: 28.51957764429272,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51.5
        },
        "purple.1400": {
            contrast: 23.968945689270296,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "purple.1500": {
            contrast: 18.82359272913113,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79.5
        },
        "purple.1600": {
            contrast: 14.042503880543459,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1700": {
            contrast: 8.540591965229336,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.2100": {
            contrast: 10.809216113830642,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.2200": {
            contrast: 17.131993879408142,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87
        },
        "purple.2300": {
            contrast: 23.65192677593895,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65.5
        },
        "purple.2400": {
            contrast: 30.361569171750162,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 52
        },
        "purple.2500": {
            contrast: 37.25423073977081,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 43.5
        }
    },
    "purple.2000": {
        "purple.100": {
            contrast: 76.1728598910314,
            lc60: 63,
            lc45: 45,
            lc30: 30,
            lc10: 15.5
        },
        "purple.200": {
            contrast: 75.47994927608146,
            lc60: 66,
            lc45: 47.5,
            lc30: 31,
            lc10: 16
        },
        "purple.300": {
            contrast: 73.93551590323894,
            lc60: 69,
            lc45: 49,
            lc30: 32.5,
            lc10: 16.5
        },
        "purple.400": {
            contrast: 71.7394613193192,
            lc60: 72.5,
            lc45: 51.5,
            lc30: 33.5,
            lc10: 17
        },
        "purple.500": {
            contrast: 68.81726098303488,
            lc60: 77,
            lc45: 54,
            lc30: 35,
            lc10: 18
        },
        "purple.600": {
            contrast: 64.66882937317752,
            lc60: 84.5,
            lc45: 57,
            lc30: 36.5,
            lc10: 18.5
        },
        "purple.700": {
            contrast: 60.6221281342192,
            lc60: 97,
            lc45: 60.5,
            lc30: 38,
            lc10: 19
        },
        "purple.800": {
            contrast: 55.761341306184434,
            lc60: 100,
            lc45: 70.5,
            lc30: 44,
            lc10: 22
        },
        "purple.900": {
            contrast: 52.51093420952543,
            lc60: 100,
            lc45: 79.5,
            lc30: 49.5,
            lc10: 25
        },
        "purple.1000": {
            contrast: 48.386152643550176,
            lc60: 100,
            lc45: 90,
            lc30: 55.5,
            lc10: 28
        },
        "purple.1100": {
            contrast: 43.89793810616454,
            lc60: 100,
            lc45: 100,
            lc30: 63,
            lc10: 31.5
        },
        "purple.1200": {
            contrast: 39.28983658388092,
            lc60: 100,
            lc45: 100,
            lc30: 72.5,
            lc10: 35.5
        },
        "purple.1300": {
            contrast: 34.047052597387804,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 43
        },
        "purple.1400": {
            contrast: 29.49642064236538,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51
        },
        "purple.1500": {
            contrast: 24.35106768222621,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61.5
        },
        "purple.1600": {
            contrast: 19.56997883363854,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77
        },
        "purple.1700": {
            contrast: 14.068066918324416,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1800": {
            contrast: 8.98638481245433,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.2200": {
            contrast: 11.054781204417097,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.2300": {
            contrast: 17.5747141009479,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87
        },
        "purple.2400": {
            contrast: 24.28435649675912,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65.5
        },
        "purple.2500": {
            contrast: 31.177018064779766,
            lc60: 100,
            lc45: 100,
            lc30: 96.5,
            lc10: 52
        }
    },
    "purple.2100": {
        "purple.100": {
            contrast: 81.86077089183266,
            lc60: 58,
            lc45: 42,
            lc30: 27.5,
            lc10: 14.5
        },
        "purple.200": {
            contrast: 81.16786027688272,
            lc60: 60.5,
            lc45: 44,
            lc30: 29,
            lc10: 15
        },
        "purple.300": {
            contrast: 79.6234269040402,
            lc60: 63,
            lc45: 45.5,
            lc30: 30,
            lc10: 15.5
        },
        "purple.400": {
            contrast: 77.42737232012047,
            lc60: 65.5,
            lc45: 47,
            lc30: 31,
            lc10: 16
        },
        "purple.500": {
            contrast: 74.50517198383614,
            lc60: 69,
            lc45: 49,
            lc30: 32,
            lc10: 16.5
        },
        "purple.600": {
            contrast: 70.35674037397878,
            lc60: 73.5,
            lc45: 51.5,
            lc30: 33.5,
            lc10: 17
        },
        "purple.700": {
            contrast: 66.31003913502046,
            lc60: 80,
            lc45: 54,
            lc30: 34.5,
            lc10: 17.5
        },
        "purple.800": {
            contrast: 61.44925230698569,
            lc60: 95,
            lc45: 62,
            lc30: 39.5,
            lc10: 20
        },
        "purple.900": {
            contrast: 58.1988452103267,
            lc60: 100,
            lc45: 69.5,
            lc30: 44,
            lc10: 22.5
        },
        "purple.1000": {
            contrast: 54.07406364435143,
            lc60: 100,
            lc45: 77.5,
            lc30: 49,
            lc10: 24.5
        },
        "purple.1100": {
            contrast: 49.585849106965796,
            lc60: 100,
            lc45: 87.5,
            lc30: 55,
            lc10: 28
        },
        "purple.1200": {
            contrast: 44.977747584682184,
            lc60: 100,
            lc45: 100,
            lc30: 62.5,
            lc10: 31.5
        },
        "purple.1300": {
            contrast: 39.73496359818906,
            lc60: 100,
            lc45: 100,
            lc30: 72,
            lc10: 37
        },
        "purple.1400": {
            contrast: 35.18433164316663,
            lc60: 100,
            lc45: 100,
            lc30: 84,
            lc10: 42
        },
        "purple.1500": {
            contrast: 30.038978683027462,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 50.5
        },
        "purple.1600": {
            contrast: 25.257889834439794,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60.5
        },
        "purple.1700": {
            contrast: 19.755977919125673,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76.5
        },
        "purple.1800": {
            contrast: 14.67429581325559,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1900": {
            contrast: 9.035490112059588,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.2300": {
            contrast: 11.253754715966668,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.2400": {
            contrast: 17.963397111777883,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84.5
        },
        "purple.2500": {
            contrast: 24.856058679798533,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63.5
        }
    },
    "purple.2200": {
        "purple.100": {
            contrast: 87.69946120099071,
            lc60: 54,
            lc45: 39,
            lc30: 26,
            lc10: 13.5
        },
        "purple.200": {
            contrast: 87.00655058604077,
            lc60: 56,
            lc45: 40.5,
            lc30: 27,
            lc10: 14
        },
        "purple.300": {
            contrast: 85.46211721319825,
            lc60: 58,
            lc45: 42,
            lc30: 28,
            lc10: 14.5
        },
        "purple.400": {
            contrast: 83.26606262927852,
            lc60: 60,
            lc45: 43.5,
            lc30: 28.5,
            lc10: 14.5
        },
        "purple.500": {
            contrast: 80.3438622929942,
            lc60: 62.5,
            lc45: 45,
            lc30: 29.5,
            lc10: 15
        },
        "purple.600": {
            contrast: 76.19543068313683,
            lc60: 66,
            lc45: 47,
            lc30: 30.5,
            lc10: 15.5
        },
        "purple.700": {
            contrast: 72.14872944417851,
            lc60: 70,
            lc45: 49,
            lc30: 31.5,
            lc10: 16.5
        },
        "purple.800": {
            contrast: 67.28794261614375,
            lc60: 81,
            lc45: 55.5,
            lc30: 35.5,
            lc10: 18.5
        },
        "purple.900": {
            contrast: 64.03753551948475,
            lc60: 89.5,
            lc45: 61.5,
            lc30: 39.5,
            lc10: 20.5
        },
        "purple.1000": {
            contrast: 59.91275395350949,
            lc60: 100,
            lc45: 68,
            lc30: 43.5,
            lc10: 22
        },
        "purple.1100": {
            contrast: 55.42453941612385,
            lc60: 100,
            lc45: 76,
            lc30: 48.5,
            lc10: 25
        },
        "purple.1200": {
            contrast: 50.81643789384024,
            lc60: 100,
            lc45: 85,
            lc30: 54.5,
            lc10: 27.5
        },
        "purple.1300": {
            contrast: 45.57365390734712,
            lc60: 100,
            lc45: 98.5,
            lc30: 62,
            lc10: 31.5
        },
        "purple.1400": {
            contrast: 41.0230219523247,
            lc60: 100,
            lc45: 100,
            lc30: 71,
            lc10: 36
        },
        "purple.1500": {
            contrast: 35.87766899218553,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 42.5
        },
        "purple.1600": {
            contrast: 31.09658014359785,
            lc60: 100,
            lc45: 100,
            lc30: 96.5,
            lc10: 50
        },
        "purple.1700": {
            contrast: 25.59466822828373,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "purple.1800": {
            contrast: 20.512986122413647,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74
        },
        "purple.1900": {
            contrast: 14.874180421217648,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.2000": {
            contrast: 9.281796348163947,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.2400": {
            contrast: 11.407613510150133,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.2500": {
            contrast: 18.30027507817078,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84.5
        }
    },
    "purple.2300": {
        "purple.100": {
            contrast: 93.68048538669683,
            lc60: 50,
            lc45: 37,
            lc30: 24,
            lc10: 12.5
        },
        "purple.200": {
            contrast: 92.98757477174689,
            lc60: 52,
            lc45: 38,
            lc30: 25,
            lc10: 13
        },
        "purple.300": {
            contrast: 91.44314139890437,
            lc60: 53.5,
            lc45: 39,
            lc30: 26,
            lc10: 13.5
        },
        "purple.400": {
            contrast: 89.24708681498464,
            lc60: 55.5,
            lc45: 40,
            lc30: 26.5,
            lc10: 14
        },
        "purple.500": {
            contrast: 86.32488647870032,
            lc60: 57,
            lc45: 41.5,
            lc30: 27,
            lc10: 14.5
        },
        "purple.600": {
            contrast: 82.17645486884295,
            lc60: 60,
            lc45: 43,
            lc30: 28.5,
            lc10: 14.5
        },
        "purple.700": {
            contrast: 78.12975362988463,
            lc60: 62.5,
            lc45: 44.5,
            lc30: 29.5,
            lc10: 15
        },
        "purple.800": {
            contrast: 73.26896680184987,
            lc60: 71.5,
            lc45: 50.5,
            lc30: 33,
            lc10: 17
        },
        "purple.900": {
            contrast: 70.01855970519087,
            lc60: 78.5,
            lc45: 55.5,
            lc30: 36,
            lc10: 18.5
        },
        "purple.1000": {
            contrast: 65.89377813921561,
            lc60: 86.5,
            lc45: 60.5,
            lc30: 39.5,
            lc10: 20
        },
        "purple.1100": {
            contrast: 61.40556360182997,
            lc60: 96.5,
            lc45: 67,
            lc30: 43.5,
            lc10: 22.5
        },
        "purple.1200": {
            contrast: 56.79746207954636,
            lc60: 100,
            lc45: 75,
            lc30: 48,
            lc10: 25
        },
        "purple.1300": {
            contrast: 51.55467809305324,
            lc60: 100,
            lc45: 85,
            lc30: 54.5,
            lc10: 28
        },
        "purple.1400": {
            contrast: 47.004046138030816,
            lc60: 100,
            lc45: 95,
            lc30: 61,
            lc10: 31.5
        },
        "purple.1500": {
            contrast: 41.858693177891645,
            lc60: 100,
            lc45: 100,
            lc30: 70.5,
            lc10: 36.5
        },
        "purple.1600": {
            contrast: 37.07760432930397,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 40.5
        },
        "purple.1700": {
            contrast: 31.57569241398985,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 48.5
        },
        "purple.1800": {
            contrast: 26.494010308119766,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58
        },
        "purple.1900": {
            contrast: 20.855204606923767,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "purple.2000": {
            contrast: 15.262820533870064,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98.5
        },
        "purple.2100": {
            contrast: 9.501262171653087,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.2500": {
            contrast: 11.517657696811284,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "purple.2400": {
        "purple.100": {
            contrast: 99.79641402523757,
            lc60: 47,
            lc45: 34.5,
            lc30: 23,
            lc10: 12
        },
        "purple.200": {
            contrast: 99.10350341028763,
            lc60: 48.5,
            lc45: 35.5,
            lc30: 24,
            lc10: 12.5
        },
        "purple.300": {
            contrast: 97.5590700374451,
            lc60: 50,
            lc45: 36.5,
            lc30: 24,
            lc10: 12.5
        },
        "purple.400": {
            contrast: 95.36301545352536,
            lc60: 51.5,
            lc45: 37.5,
            lc30: 25,
            lc10: 13
        },
        "purple.500": {
            contrast: 92.44081511724104,
            lc60: 53,
            lc45: 38.5,
            lc30: 25.5,
            lc10: 13
        },
        "purple.600": {
            contrast: 88.29238350738368,
            lc60: 55,
            lc45: 40,
            lc30: 26.5,
            lc10: 13.5
        },
        "purple.700": {
            contrast: 84.24568226842536,
            lc60: 57,
            lc45: 41,
            lc30: 27,
            lc10: 14
        },
        "purple.800": {
            contrast: 79.3848954403906,
            lc60: 64.5,
            lc45: 46,
            lc30: 30.5,
            lc10: 16
        },
        "purple.900": {
            contrast: 76.1344883437316,
            lc60: 70.5,
            lc45: 50.5,
            lc30: 33,
            lc10: 17
        },
        "purple.1000": {
            contrast: 72.00970677775634,
            lc60: 76.5,
            lc45: 55,
            lc30: 36,
            lc10: 18.5
        },
        "purple.1100": {
            contrast: 67.52149224037069,
            lc60: 84.5,
            lc45: 60,
            lc30: 39.5,
            lc10: 20.5
        },
        "purple.1200": {
            contrast: 62.91339071808709,
            lc60: 93.5,
            lc45: 66.5,
            lc30: 43,
            lc10: 22
        },
        "purple.1300": {
            contrast: 57.67060673159396,
            lc60: 100,
            lc45: 74,
            lc30: 48,
            lc10: 25
        },
        "purple.1400": {
            contrast: 53.11997477657153,
            lc60: 100,
            lc45: 82,
            lc30: 53.5,
            lc10: 27.5
        },
        "purple.1500": {
            contrast: 47.974621816432375,
            lc60: 100,
            lc45: 93,
            lc30: 61,
            lc10: 31.5
        },
        "purple.1600": {
            contrast: 43.1935329678447,
            lc60: 100,
            lc45: 100,
            lc30: 68,
            lc10: 35.5
        },
        "purple.1700": {
            contrast: 37.69162105253057,
            lc60: 100,
            lc45: 100,
            lc30: 79,
            lc10: 41.5
        },
        "purple.1800": {
            contrast: 32.60993894666049,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 48
        },
        "purple.1900": {
            contrast: 26.97113324546449,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "purple.2000": {
            contrast: 21.378749172410792,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "purple.2100": {
            contrast: 15.617190810193812,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95.5
        },
        "purple.2200": {
            contrast: 9.696119515373018,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "purple.2500": {
        "purple.100": {
            contrast: 106.04067321268862,
            lc60: 44,
            lc45: 32.5,
            lc30: 21.5,
            lc10: 11.5
        },
        "purple.200": {
            contrast: 105.34776259773868,
            lc60: 45.5,
            lc45: 33.5,
            lc30: 22.5,
            lc10: 11.5
        },
        "purple.300": {
            contrast: 103.80332922489615,
            lc60: 46.5,
            lc45: 34.5,
            lc30: 22.5,
            lc10: 12
        },
        "purple.400": {
            contrast: 101.60727464097643,
            lc60: 48,
            lc45: 35,
            lc30: 23.5,
            lc10: 12
        },
        "purple.500": {
            contrast: 98.68507430469208,
            lc60: 49,
            lc45: 36,
            lc30: 24,
            lc10: 12.5
        },
        "purple.600": {
            contrast: 94.53664269483471,
            lc60: 50.5,
            lc45: 37,
            lc30: 24.5,
            lc10: 13
        },
        "purple.700": {
            contrast: 90.4899414558764,
            lc60: 52.5,
            lc45: 38.5,
            lc30: 25,
            lc10: 13.5
        },
        "purple.800": {
            contrast: 85.62915462784163,
            lc60: 58.5,
            lc45: 42.5,
            lc30: 28,
            lc10: 14.5
        },
        "purple.900": {
            contrast: 82.37874753118264,
            lc60: 63.5,
            lc45: 46,
            lc30: 30.5,
            lc10: 16
        },
        "purple.1000": {
            contrast: 78.25396596520737,
            lc60: 69,
            lc45: 50,
            lc30: 33,
            lc10: 17
        },
        "purple.1100": {
            contrast: 73.76575142782174,
            lc60: 75.5,
            lc45: 54,
            lc30: 35.5,
            lc10: 18.5
        },
        "purple.1200": {
            contrast: 69.15764990553814,
            lc60: 83,
            lc45: 59.5,
            lc30: 39,
            lc10: 20.5
        },
        "purple.1300": {
            contrast: 63.914865919045006,
            lc60: 92,
            lc45: 65.5,
            lc30: 43.5,
            lc10: 22.5
        },
        "purple.1400": {
            contrast: 59.364233964022574,
            lc60: 100,
            lc45: 72.5,
            lc30: 47.5,
            lc10: 24.5
        },
        "purple.1500": {
            contrast: 54.2188810038834,
            lc60: 100,
            lc45: 81,
            lc30: 53.5,
            lc10: 27.5
        },
        "purple.1600": {
            contrast: 49.43779215529573,
            lc60: 100,
            lc45: 90,
            lc30: 59,
            lc10: 31
        },
        "purple.1700": {
            contrast: 43.935880239981614,
            lc60: 100,
            lc45: 100,
            lc30: 67.5,
            lc10: 35.5
        },
        "purple.1800": {
            contrast: 38.85419813411153,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 40.5
        },
        "purple.1900": {
            contrast: 33.21539243291552,
            lc60: 100,
            lc45: 100,
            lc30: 89.5,
            lc10: 47
        },
        "purple.2000": {
            contrast: 27.623008359861828,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "purple.2100": {
            contrast: 21.86144999764485,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70.5
        },
        "purple.2200": {
            contrast: 15.940378702824058,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 94
        },
        "purple.2300": {
            contrast: 9.868269147861264,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    }
};
const $f8fd43f1ee3f8cd8$var$red = {
    "red.100": {
        "red.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.600": {
            contrast: 8.99933938517341,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.700": {
            contrast: 12.930704354893956,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.800": {
            contrast: 17.357706246932928,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93
        },
        "red.900": {
            contrast: 21.632519677872935,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83
        },
        "red.1000": {
            contrast: 25.680706835622473,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75.5
        },
        "red.1100": {
            contrast: 30.63441828497517,
            lc60: 100,
            lc45: 100,
            lc30: 98.5,
            lc10: 68.5
        },
        "red.1200": {
            contrast: 33.88419632536158,
            lc60: 100,
            lc45: 100,
            lc30: 93,
            lc10: 65
        },
        "red.1300": {
            contrast: 38.23891487899771,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 60.5
        },
        "red.1400": {
            contrast: 42.612635485696096,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 56.5
        },
        "red.1500": {
            contrast: 47.22659056120414,
            lc60: 100,
            lc45: 97,
            lc30: 77,
            lc10: 53.5
        },
        "red.1600": {
            contrast: 52.40904212149671,
            lc60: 100,
            lc45: 91,
            lc30: 72,
            lc10: 50
        },
        "red.1700": {
            contrast: 57.71491570011832,
            lc60: 100,
            lc45: 86,
            lc30: 68,
            lc10: 47.5
        },
        "red.1800": {
            contrast: 63.42516777646263,
            lc60: 96.5,
            lc45: 81,
            lc30: 64,
            lc10: 44.5
        },
        "red.1900": {
            contrast: 69.00897938603612,
            lc60: 91.5,
            lc45: 77,
            lc30: 61,
            lc10: 42.5
        },
        "red.2000": {
            contrast: 75.04546607253786,
            lc60: 87,
            lc45: 73,
            lc30: 57.5,
            lc10: 40.5
        },
        "red.2100": {
            contrast: 81.46753817732639,
            lc60: 82.5,
            lc45: 69.5,
            lc30: 55,
            lc10: 38.5
        },
        "red.2200": {
            contrast: 87.43842011894479,
            lc60: 79,
            lc45: 66.5,
            lc30: 52.5,
            lc10: 36.5
        },
        "red.2300": {
            contrast: 94.0948932484666,
            lc60: 75.5,
            lc45: 63.5,
            lc30: 50,
            lc10: 35
        },
        "red.2400": {
            contrast: 101.10402380615125,
            lc60: 72,
            lc45: 60.5,
            lc30: 48,
            lc10: 33.5
        },
        "red.2500": {
            contrast: 107.88473318309848,
            lc60: 69,
            lc45: 58,
            lc30: 46,
            lc10: 32
        }
    },
    "red.200": {
        "red.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.600": {
            contrast: 8.433072911527068,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.700": {
            contrast: 12.364437881247618,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.800": {
            contrast: 16.791439773286584,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93.5
        },
        "red.900": {
            contrast: 21.066253204226594,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81
        },
        "red.1000": {
            contrast: 25.114440361976133,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72.5
        },
        "red.1100": {
            contrast: 30.068151811328818,
            lc60: 100,
            lc45: 100,
            lc30: 99.5,
            lc10: 65
        },
        "red.1200": {
            contrast: 33.31792985171524,
            lc60: 100,
            lc45: 100,
            lc30: 93,
            lc10: 60.5
        },
        "red.1300": {
            contrast: 37.67264840535137,
            lc60: 100,
            lc45: 100,
            lc30: 86,
            lc10: 56.5
        },
        "red.1400": {
            contrast: 42.046369012049745,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 52.5
        },
        "red.1500": {
            contrast: 46.66032408755779,
            lc60: 100,
            lc45: 97.5,
            lc30: 75,
            lc10: 49.5
        },
        "red.1600": {
            contrast: 51.84277564785037,
            lc60: 100,
            lc45: 91,
            lc30: 70.5,
            lc10: 46.5
        },
        "red.1700": {
            contrast: 57.14864922647197,
            lc60: 100,
            lc45: 85.5,
            lc30: 66.5,
            lc10: 44
        },
        "red.1800": {
            contrast: 62.858901302816285,
            lc60: 97,
            lc45: 80.5,
            lc30: 62,
            lc10: 41.5
        },
        "red.1900": {
            contrast: 68.44271291238978,
            lc60: 92,
            lc45: 76,
            lc30: 59,
            lc10: 39.5
        },
        "red.2000": {
            contrast: 74.47919959889153,
            lc60: 86.5,
            lc45: 72,
            lc30: 56,
            lc10: 37.5
        },
        "red.2100": {
            contrast: 80.90127170368004,
            lc60: 82,
            lc45: 68.5,
            lc30: 53,
            lc10: 36
        },
        "red.2200": {
            contrast: 86.87215364529845,
            lc60: 78.5,
            lc45: 65.5,
            lc30: 51,
            lc10: 34.5
        },
        "red.2300": {
            contrast: 93.52862677482025,
            lc60: 75,
            lc45: 62.5,
            lc30: 48.5,
            lc10: 33
        },
        "red.2400": {
            contrast: 100.5377573325049,
            lc60: 71.5,
            lc45: 59.5,
            lc30: 46.5,
            lc10: 31.5
        },
        "red.2500": {
            contrast: 107.31846670945214,
            lc60: 68.5,
            lc45: 57,
            lc30: 44.5,
            lc10: 30
        }
    },
    "red.300": {
        "red.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.700": {
            contrast: 11.025690046624122,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.800": {
            contrast: 15.452691938663094,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 97.5
        },
        "red.900": {
            contrast: 19.7275053696031,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82.5
        },
        "red.1000": {
            contrast: 23.77569252735264,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72.5
        },
        "red.1100": {
            contrast: 28.729403976705335,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63.5
        },
        "red.1200": {
            contrast: 31.979182017091745,
            lc60: 100,
            lc45: 100,
            lc30: 95.5,
            lc10: 59
        },
        "red.1300": {
            contrast: 36.33390057072787,
            lc60: 100,
            lc45: 100,
            lc30: 87.5,
            lc10: 54.5
        },
        "red.1400": {
            contrast: 40.707621177426255,
            lc60: 100,
            lc45: 100,
            lc30: 80.5,
            lc10: 50.5
        },
        "red.1500": {
            contrast: 45.32157625293431,
            lc60: 100,
            lc45: 99,
            lc30: 75,
            lc10: 47.5
        },
        "red.1600": {
            contrast: 50.50402781322687,
            lc60: 100,
            lc45: 92.5,
            lc30: 70.5,
            lc10: 45
        },
        "red.1700": {
            contrast: 55.80990139184847,
            lc60: 100,
            lc45: 86.5,
            lc30: 66,
            lc10: 42.5
        },
        "red.1800": {
            contrast: 61.52015346819278,
            lc60: 98,
            lc45: 81,
            lc30: 62,
            lc10: 40
        },
        "red.1900": {
            contrast: 67.10396507776628,
            lc60: 92.5,
            lc45: 76.5,
            lc30: 59,
            lc10: 38
        },
        "red.2000": {
            contrast: 73.14045176426802,
            lc60: 87.5,
            lc45: 72.5,
            lc30: 56,
            lc10: 36.5
        },
        "red.2100": {
            contrast: 79.56252386905655,
            lc60: 82.5,
            lc45: 68.5,
            lc30: 53,
            lc10: 35
        },
        "red.2200": {
            contrast: 85.53340581067495,
            lc60: 79,
            lc45: 65.5,
            lc30: 51,
            lc10: 33
        },
        "red.2300": {
            contrast: 92.18987894019676,
            lc60: 75.5,
            lc45: 62.5,
            lc30: 48,
            lc10: 32
        },
        "red.2400": {
            contrast: 99.19900949788139,
            lc60: 72,
            lc45: 59.5,
            lc30: 46,
            lc10: 30.5
        },
        "red.2500": {
            contrast: 105.97971887482862,
            lc60: 69,
            lc45: 57,
            lc30: 44.5,
            lc10: 29.5
        }
    },
    "red.400": {
        "red.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.700": {
            contrast: 9.202599496828487,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.800": {
            contrast: 13.629601388867457,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.900": {
            contrast: 17.904414819807464,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87.5
        },
        "red.1000": {
            contrast: 21.952601977557006,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75
        },
        "red.1100": {
            contrast: 26.90631342690969,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64.5
        },
        "red.1200": {
            contrast: 30.156091467296115,
            lc60: 100,
            lc45: 100,
            lc30: 99.5,
            lc10: 59.5
        },
        "red.1300": {
            contrast: 34.51081002093224,
            lc60: 100,
            lc45: 100,
            lc30: 90,
            lc10: 54
        },
        "red.1400": {
            contrast: 38.88453062763062,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 50.5
        },
        "red.1500": {
            contrast: 43.49848570313866,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 47
        },
        "red.1600": {
            contrast: 48.68093726343125,
            lc60: 100,
            lc45: 94.5,
            lc30: 71,
            lc10: 44.5
        },
        "red.1700": {
            contrast: 53.98681084205285,
            lc60: 100,
            lc45: 88,
            lc30: 67,
            lc10: 42
        },
        "red.1800": {
            contrast: 59.69706291839716,
            lc60: 100,
            lc45: 82.5,
            lc30: 63,
            lc10: 40
        },
        "red.1900": {
            contrast: 65.28087452797064,
            lc60: 94,
            lc45: 78,
            lc30: 59.5,
            lc10: 38
        },
        "red.2000": {
            contrast: 71.3173612144724,
            lc60: 88.5,
            lc45: 73.5,
            lc30: 56.5,
            lc10: 36
        },
        "red.2100": {
            contrast: 77.73943331926093,
            lc60: 84,
            lc45: 69.5,
            lc30: 53.5,
            lc10: 34.5
        },
        "red.2200": {
            contrast: 83.71031526087933,
            lc60: 80,
            lc45: 66.5,
            lc30: 51,
            lc10: 33
        },
        "red.2300": {
            contrast: 90.36678839040113,
            lc60: 76.5,
            lc45: 63,
            lc30: 48.5,
            lc10: 32
        },
        "red.2400": {
            contrast: 97.37591894808575,
            lc60: 72.5,
            lc45: 60.5,
            lc30: 46.5,
            lc10: 30.5
        },
        "red.2500": {
            contrast: 104.15662832503301,
            lc60: 69.5,
            lc45: 58,
            lc30: 44.5,
            lc10: 29.5
        }
    },
    "red.500": {
        "red.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.800": {
            contrast: 10.943910852663585,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.900": {
            contrast: 15.218724283603596,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 99
        },
        "red.1000": {
            contrast: 19.266911441353134,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81
        },
        "red.1100": {
            contrast: 24.220622890705826,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "red.1200": {
            contrast: 27.470400931092236,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62
        },
        "red.1300": {
            contrast: 31.825119484728358,
            lc60: 100,
            lc45: 100,
            lc30: 95.5,
            lc10: 55.5
        },
        "red.1400": {
            contrast: 36.198840091426746,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 51
        },
        "red.1500": {
            contrast: 40.8127951669348,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 48
        },
        "red.1600": {
            contrast: 45.99524672722736,
            lc60: 100,
            lc45: 98,
            lc30: 73.5,
            lc10: 45
        },
        "red.1700": {
            contrast: 51.30112030584897,
            lc60: 100,
            lc45: 91,
            lc30: 69,
            lc10: 42.5
        },
        "red.1800": {
            contrast: 57.01137238219328,
            lc60: 100,
            lc45: 85,
            lc30: 64.5,
            lc10: 40.5
        },
        "red.1900": {
            contrast: 62.59518399176677,
            lc60: 97,
            lc45: 80,
            lc30: 60.5,
            lc10: 38.5
        },
        "red.2000": {
            contrast: 68.63167067826852,
            lc60: 91.5,
            lc45: 75,
            lc30: 57.5,
            lc10: 36.5
        },
        "red.2100": {
            contrast: 75.05374278305705,
            lc60: 86,
            lc45: 71,
            lc30: 54.5,
            lc10: 35
        },
        "red.2200": {
            contrast: 81.02462472467545,
            lc60: 81.5,
            lc45: 67.5,
            lc30: 52,
            lc10: 33.5
        },
        "red.2300": {
            contrast: 87.68109785419725,
            lc60: 77.5,
            lc45: 64.5,
            lc30: 49.5,
            lc10: 32
        },
        "red.2400": {
            contrast: 94.69022841188189,
            lc60: 74,
            lc45: 61.5,
            lc30: 47.5,
            lc10: 30.5
        },
        "red.2500": {
            contrast: 101.47093778882912,
            lc60: 71,
            lc45: 59,
            lc30: 45.5,
            lc10: 29.5
        }
    },
    "red.600": {
        "red.100": {
            contrast: 10.419466771446096,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.200": {
            contrast: 9.662129880528576,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.300": {
            contrast: 7.920852864967563,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.900": {
            contrast: 11.340964896610387,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1000": {
            contrast: 15.389152054359922,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98
        },
        "red.1100": {
            contrast: 20.342863503712614,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77.5
        },
        "red.1200": {
            contrast: 23.59264154409903,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "red.1300": {
            contrast: 27.947360097735153,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61
        },
        "red.1400": {
            contrast: 32.321080704433534,
            lc60: 100,
            lc45: 100,
            lc30: 94,
            lc10: 55
        },
        "red.1500": {
            contrast: 36.935035779941586,
            lc60: 100,
            lc45: 100,
            lc30: 85.5,
            lc10: 51.5
        },
        "red.1600": {
            contrast: 42.117487340234156,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 48
        },
        "red.1700": {
            contrast: 47.423360918855764,
            lc60: 100,
            lc45: 96.5,
            lc30: 73,
            lc10: 45.5
        },
        "red.1800": {
            contrast: 53.133612995200075,
            lc60: 100,
            lc45: 89,
            lc30: 68,
            lc10: 43
        },
        "red.1900": {
            contrast: 58.71742460477357,
            lc60: 100,
            lc45: 83.5,
            lc30: 64,
            lc10: 41
        },
        "red.2000": {
            contrast: 64.75391129127532,
            lc60: 94.5,
            lc45: 78.5,
            lc30: 60,
            lc10: 38.5
        },
        "red.2100": {
            contrast: 71.17598339606384,
            lc60: 89.5,
            lc45: 74,
            lc30: 57,
            lc10: 37
        },
        "red.2200": {
            contrast: 77.14686533768224,
            lc60: 84.5,
            lc45: 70.5,
            lc30: 54.5,
            lc10: 35.5
        },
        "red.2300": {
            contrast: 83.80333846720406,
            lc60: 80,
            lc45: 67,
            lc30: 51.5,
            lc10: 33.5
        },
        "red.2400": {
            contrast: 90.81246902488868,
            lc60: 76.5,
            lc45: 63.5,
            lc30: 49.5,
            lc10: 32.5
        },
        "red.2500": {
            contrast: 97.59317840183591,
            lc60: 73,
            lc45: 61,
            lc30: 47.5,
            lc10: 31
        }
    },
    "red.700": {
        "red.100": {
            contrast: 14.687457263790904,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.200": {
            contrast: 13.93012037287339,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.300": {
            contrast: 12.188843357312374,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.400": {
            contrast: 9.901433795732675,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.900": {
            contrast: 7.581466224482787,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1000": {
            contrast: 11.629653382232325,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1100": {
            contrast: 16.58336483158502,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91.5
        },
        "red.1200": {
            contrast: 19.833142871971436,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79.5
        },
        "red.1300": {
            contrast: 24.187861425607558,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68.5
        },
        "red.1400": {
            contrast: 28.56158203230594,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61
        },
        "red.1500": {
            contrast: 33.17553710781399,
            lc60: 100,
            lc45: 100,
            lc30: 93,
            lc10: 56
        },
        "red.1600": {
            contrast: 38.35798866810656,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 51.5
        },
        "red.1700": {
            contrast: 43.663862246728165,
            lc60: 100,
            lc45: 100,
            lc30: 77.5,
            lc10: 48.5
        },
        "red.1800": {
            contrast: 49.37411432307247,
            lc60: 100,
            lc45: 94,
            lc30: 72,
            lc10: 45
        },
        "red.1900": {
            contrast: 54.957925932645956,
            lc60: 100,
            lc45: 87.5,
            lc30: 67,
            lc10: 43
        },
        "red.2000": {
            contrast: 60.99441261914771,
            lc60: 99,
            lc45: 82,
            lc30: 63.5,
            lc10: 40.5
        },
        "red.2100": {
            contrast: 67.41648472393624,
            lc60: 92.5,
            lc45: 77,
            lc30: 59.5,
            lc10: 38.5
        },
        "red.2200": {
            contrast: 73.38736666555464,
            lc60: 88,
            lc45: 73,
            lc30: 57,
            lc10: 37
        },
        "red.2300": {
            contrast: 80.04383979507645,
            lc60: 83,
            lc45: 69.5,
            lc30: 54,
            lc10: 35
        },
        "red.2400": {
            contrast: 87.05297035276108,
            lc60: 79,
            lc45: 66,
            lc30: 51.5,
            lc10: 34
        },
        "red.2500": {
            contrast: 93.8336797297083,
            lc60: 75.5,
            lc45: 63,
            lc30: 49,
            lc10: 32.5
        }
    },
    "red.800": {
        "red.100": {
            contrast: 19.3925922789712,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "red.200": {
            contrast: 18.635255388053682,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "red.300": {
            contrast: 16.893978372492665,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84
        },
        "red.400": {
            contrast: 14.606568810912965,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.500": {
            contrast: 11.36224481612181,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1000": {
            contrast: 7.3510316560069215,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1100": {
            contrast: 12.304743105359616,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1200": {
            contrast: 15.554521145746032,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 96
        },
        "red.1300": {
            contrast: 19.90923969938215,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80
        },
        "red.1400": {
            contrast: 24.28296030608054,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "red.1500": {
            contrast: 28.896915381588585,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "red.1600": {
            contrast: 34.079366941881155,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 56.5
        },
        "red.1700": {
            contrast: 39.385240520502755,
            lc60: 100,
            lc45: 100,
            lc30: 83.5,
            lc10: 52.5
        },
        "red.1800": {
            contrast: 45.09549259684707,
            lc60: 100,
            lc45: 99.5,
            lc30: 76.5,
            lc10: 49
        },
        "red.1900": {
            contrast: 50.67930420642056,
            lc60: 100,
            lc45: 92.5,
            lc30: 71.5,
            lc10: 46.5
        },
        "red.2000": {
            contrast: 56.7157908929223,
            lc60: 100,
            lc45: 86.5,
            lc30: 67,
            lc10: 43.5
        },
        "red.2100": {
            contrast: 63.13786299771083,
            lc60: 96.5,
            lc45: 81,
            lc30: 63,
            lc10: 41
        },
        "red.2200": {
            contrast: 69.10874493932924,
            lc60: 91.5,
            lc45: 76.5,
            lc30: 60,
            lc10: 39.5
        },
        "red.2300": {
            contrast: 75.76521806885104,
            lc60: 86.5,
            lc45: 72.5,
            lc30: 56.5,
            lc10: 37.5
        },
        "red.2400": {
            contrast: 82.77434862653567,
            lc60: 82,
            lc45: 68.5,
            lc30: 53.5,
            lc10: 36
        },
        "red.2500": {
            contrast: 89.5550580034829,
            lc60: 78,
            lc45: 65.5,
            lc30: 51.5,
            lc10: 34.5
        }
    },
    "red.900": {
        "red.100": {
            contrast: 23.854536174256044,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 43.5
        },
        "red.200": {
            contrast: 23.097199283338522,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53.5
        },
        "red.300": {
            contrast: 21.355922267777512,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63
        },
        "red.400": {
            contrast: 19.068512706197815,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75.5
        },
        "red.500": {
            contrast: 15.82418871140666,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 94.5
        },
        "red.600": {
            contrast: 11.324367017935957,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1100": {
            contrast: 8.135693293499893,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1200": {
            contrast: 11.385471333886308,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1300": {
            contrast: 15.740189887522432,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95.5
        },
        "red.1400": {
            contrast: 20.113910494220814,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80.5
        },
        "red.1500": {
            contrast: 24.727865569728866,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70.5
        },
        "red.1600": {
            contrast: 29.910317130021436,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63.5
        },
        "red.1700": {
            contrast: 35.21619070864303,
            lc60: 100,
            lc45: 100,
            lc30: 90,
            lc10: 58.5
        },
        "red.1800": {
            contrast: 40.92644278498735,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 54
        },
        "red.1900": {
            contrast: 46.51025439456084,
            lc60: 100,
            lc45: 97.5,
            lc30: 76.5,
            lc10: 50.5
        },
        "red.2000": {
            contrast: 52.546741081062585,
            lc60: 100,
            lc45: 91,
            lc30: 71.5,
            lc10: 47
        },
        "red.2100": {
            contrast: 58.96881318585112,
            lc60: 100,
            lc45: 85,
            lc30: 67,
            lc10: 44.5
        },
        "red.2200": {
            contrast: 64.93969512746952,
            lc60: 95.5,
            lc45: 80.5,
            lc30: 63,
            lc10: 42.5
        },
        "red.2300": {
            contrast: 71.59616825699132,
            lc60: 90,
            lc45: 75.5,
            lc30: 60,
            lc10: 40.5
        },
        "red.2400": {
            contrast: 78.60529881467595,
            lc60: 85,
            lc45: 71.5,
            lc30: 57,
            lc10: 38
        },
        "red.2500": {
            contrast: 85.38600819162319,
            lc60: 81,
            lc45: 68.5,
            lc30: 54,
            lc10: 36.5
        }
    },
    "red.1000": {
        "red.100": {
            contrast: 28.018638267451436,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 38
        },
        "red.200": {
            contrast: 27.261301376533915,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 45.5
        },
        "red.300": {
            contrast: 25.520024360972904,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53
        },
        "red.400": {
            contrast: 23.23261479939321,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61.5
        },
        "red.500": {
            contrast: 19.98829080460205,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74.5
        },
        "red.600": {
            contrast: 15.488469111131353,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 96.5
        },
        "red.700": {
            contrast: 11.275434181577907,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1200": {
            contrast: 7.408500730239681,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1300": {
            contrast: 11.763219283875806,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1400": {
            contrast: 16.13693989057419,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 94.5
        },
        "red.1500": {
            contrast: 20.750894966082235,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81
        },
        "red.1600": {
            contrast: 25.933346526374805,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "red.1700": {
            contrast: 31.239220104996406,
            lc60: 100,
            lc45: 100,
            lc30: 97,
            lc10: 64.5
        },
        "red.1800": {
            contrast: 36.949472181340724,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 58.5
        },
        "red.1900": {
            contrast: 42.53328379091421,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 54.5
        },
        "red.2000": {
            contrast: 48.569770477415965,
            lc60: 100,
            lc45: 95,
            lc30: 75.5,
            lc10: 51
        },
        "red.2100": {
            contrast: 54.991842582204484,
            lc60: 100,
            lc45: 89,
            lc30: 70.5,
            lc10: 47.5
        },
        "red.2200": {
            contrast: 60.962724523822885,
            lc60: 98.5,
            lc45: 84,
            lc30: 66.5,
            lc10: 45.5
        },
        "red.2300": {
            contrast: 67.6191976533447,
            lc60: 93,
            lc45: 78.5,
            lc30: 63,
            lc10: 43
        },
        "red.2400": {
            contrast: 74.62832821102933,
            lc60: 88,
            lc45: 74.5,
            lc30: 59.5,
            lc10: 41
        },
        "red.2500": {
            contrast: 81.40903758797656,
            lc60: 83.5,
            lc45: 71,
            lc30: 56.5,
            lc10: 39
        }
    },
    "red.1100": {
        "red.100": {
            contrast: 33.04529223024395,
            lc60: 100,
            lc45: 100,
            lc30: 72,
            lc10: 32.5
        },
        "red.200": {
            contrast: 32.28795533932644,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 38.5
        },
        "red.300": {
            contrast: 30.54667832376542,
            lc60: 100,
            lc45: 100,
            lc30: 96.5,
            lc10: 44
        },
        "red.400": {
            contrast: 28.259268762185723,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 50
        },
        "red.500": {
            contrast: 25.014944767394564,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59
        },
        "red.600": {
            contrast: 20.515123073923867,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73
        },
        "red.700": {
            contrast: 16.302088144370426,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91.5
        },
        "red.800": {
            contrast: 11.641076171253259,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1400": {
            contrast: 11.23713190037604,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1500": {
            contrast: 15.851086975884087,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 97
        },
        "red.1600": {
            contrast: 21.03353853617666,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82
        },
        "red.1700": {
            contrast: 26.33941211479826,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73
        },
        "red.1800": {
            contrast: 32.049664191142575,
            lc60: 100,
            lc45: 100,
            lc30: 96,
            lc10: 66
        },
        "red.1900": {
            contrast: 37.63347580071606,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 60.5
        },
        "red.2000": {
            contrast: 43.66996248721781,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 56
        },
        "red.2100": {
            contrast: 50.09203459200634,
            lc60: 100,
            lc45: 94,
            lc30: 75.5,
            lc10: 52
        },
        "red.2200": {
            contrast: 56.062916533624744,
            lc60: 100,
            lc45: 88,
            lc30: 71,
            lc10: 49
        },
        "red.2300": {
            contrast: 62.71938966314655,
            lc60: 97.5,
            lc45: 83,
            lc30: 66.5,
            lc10: 46
        },
        "red.2400": {
            contrast: 69.72852022083119,
            lc60: 91.5,
            lc45: 78,
            lc30: 63,
            lc10: 44
        },
        "red.2500": {
            contrast: 76.5092295977784,
            lc60: 87,
            lc45: 74,
            lc30: 59.5,
            lc10: 41.5
        }
    },
    "red.1200": {
        "red.100": {
            contrast: 36.30684628696691,
            lc60: 100,
            lc45: 100,
            lc30: 62.5,
            lc10: 30
        },
        "red.200": {
            contrast: 35.54950939604939,
            lc60: 100,
            lc45: 100,
            lc30: 72.5,
            lc10: 35
        },
        "red.300": {
            contrast: 33.80823238048838,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 39.5
        },
        "red.400": {
            contrast: 31.520822818908677,
            lc60: 100,
            lc45: 100,
            lc30: 92.5,
            lc10: 44.5
        },
        "red.500": {
            contrast: 28.276498824117525,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51.5
        },
        "red.600": {
            contrast: 23.776677130646824,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "red.700": {
            contrast: 19.56364220109338,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76
        },
        "red.800": {
            contrast: 14.902630227976216,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.900": {
            contrast: 10.46917995090649,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1400": {
            contrast: 8.005000508282569,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1500": {
            contrast: 12.618955583790617,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1600": {
            contrast: 17.80140714408319,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89
        },
        "red.1700": {
            contrast: 23.10728072270479,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75.5
        },
        "red.1800": {
            contrast: 28.8175327990491,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65.5
        },
        "red.1900": {
            contrast: 34.40134440862259,
            lc60: 100,
            lc45: 100,
            lc30: 91.5,
            lc10: 59
        },
        "red.2000": {
            contrast: 40.43783109512434,
            lc60: 100,
            lc45: 100,
            lc30: 83,
            lc10: 54
        },
        "red.2100": {
            contrast: 46.859903199912864,
            lc60: 100,
            lc45: 97,
            lc30: 75.5,
            lc10: 49
        },
        "red.2200": {
            contrast: 52.830785141531265,
            lc60: 100,
            lc45: 90.5,
            lc30: 70.5,
            lc10: 46
        },
        "red.2300": {
            contrast: 59.48725827105308,
            lc60: 100,
            lc45: 84,
            lc30: 65.5,
            lc10: 43
        },
        "red.2400": {
            contrast: 66.49638882873771,
            lc60: 93.5,
            lc45: 78.5,
            lc30: 61,
            lc10: 40.5
        },
        "red.2500": {
            contrast: 73.27709820568494,
            lc60: 88,
            lc45: 73.5,
            lc30: 58,
            lc10: 38
        }
    },
    "red.1300": {
        "red.100": {
            contrast: 40.63763514279447,
            lc60: 100,
            lc45: 100,
            lc30: 55,
            lc10: 27
        },
        "red.200": {
            contrast: 39.88029825187696,
            lc60: 100,
            lc45: 100,
            lc30: 63,
            lc10: 31
        },
        "red.300": {
            contrast: 38.13902123631594,
            lc60: 100,
            lc45: 100,
            lc30: 70.5,
            lc10: 34.5
        },
        "red.400": {
            contrast: 35.85161167473625,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 38.5
        },
        "red.500": {
            contrast: 32.60728767994509,
            lc60: 100,
            lc45: 100,
            lc30: 90.5,
            lc10: 44
        },
        "red.600": {
            contrast: 28.107465986474388,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51
        },
        "red.700": {
            contrast: 23.894431056920947,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60.5
        },
        "red.800": {
            contrast: 19.233419083803778,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76.5
        },
        "red.900": {
            contrast: 14.799968806734057,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1000": {
            contrast: 10.652367335510668,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1500": {
            contrast: 8.268068375600706,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1600": {
            contrast: 13.45051993589328,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1700": {
            contrast: 18.75639351451488,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85.5
        },
        "red.1800": {
            contrast: 24.466645590859194,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "red.1900": {
            contrast: 30.050457200432685,
            lc60: 100,
            lc45: 100,
            lc30: 99.5,
            lc10: 62.5
        },
        "red.2000": {
            contrast: 36.08694388693443,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 55
        },
        "red.2100": {
            contrast: 42.509015991722954,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 49.5
        },
        "red.2200": {
            contrast: 48.479897933341356,
            lc60: 100,
            lc45: 95,
            lc30: 72.5,
            lc10: 45.5
        },
        "red.2300": {
            contrast: 55.13637106286316,
            lc60: 100,
            lc45: 87,
            lc30: 66.5,
            lc10: 42
        },
        "red.2400": {
            contrast: 62.14550162054779,
            lc60: 97.5,
            lc45: 80.5,
            lc30: 61.5,
            lc10: 39
        },
        "red.2500": {
            contrast: 68.92621099749502,
            lc60: 91,
            lc45: 75.5,
            lc30: 57.5,
            lc10: 36.5
        }
    },
    "red.1400": {
        "red.100": {
            contrast: 44.946036522850406,
            lc60: 100,
            lc45: 100,
            lc30: 50,
            lc10: 25
        },
        "red.200": {
            contrast: 44.188699631932884,
            lc60: 100,
            lc45: 100,
            lc30: 56,
            lc10: 27.5
        },
        "red.300": {
            contrast: 42.447422616371874,
            lc60: 100,
            lc45: 100,
            lc30: 62.5,
            lc10: 30.5
        },
        "red.400": {
            contrast: 40.16001305479218,
            lc60: 100,
            lc45: 100,
            lc30: 68.5,
            lc10: 34
        },
        "red.500": {
            contrast: 36.91568906000102,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 37.5
        },
        "red.600": {
            contrast: 32.41586736653032,
            lc60: 100,
            lc45: 100,
            lc30: 90,
            lc10: 43
        },
        "red.700": {
            contrast: 28.202832436976877,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 50
        },
        "red.800": {
            contrast: 23.541820463859718,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "red.900": {
            contrast: 19.10837018678999,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75
        },
        "red.1000": {
            contrast: 14.960768715566603,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1100": {
            contrast: 9.942660755291852,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1600": {
            contrast: 9.059762589121176,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1700": {
            contrast: 14.365636167742778,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1800": {
            contrast: 20.075888244087093,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80
        },
        "red.1900": {
            contrast: 25.659699853660577,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "red.2000": {
            contrast: 31.696186540162323,
            lc60: 100,
            lc45: 100,
            lc30: 95.5,
            lc10: 58
        },
        "red.2100": {
            contrast: 38.118258644950856,
            lc60: 100,
            lc45: 100,
            lc30: 84,
            lc10: 51
        },
        "red.2200": {
            contrast: 44.08914058656925,
            lc60: 100,
            lc45: 100,
            lc30: 76,
            lc10: 47
        },
        "red.2300": {
            contrast: 50.745613716091064,
            lc60: 100,
            lc45: 91.5,
            lc30: 69,
            lc10: 42.5
        },
        "red.2400": {
            contrast: 57.75474427377569,
            lc60: 100,
            lc45: 83.5,
            lc30: 63,
            lc10: 39
        },
        "red.2500": {
            contrast: 64.53545365072291,
            lc60: 95,
            lc45: 77.5,
            lc30: 58.5,
            lc10: 36
        }
    },
    "red.1500": {
        "red.100": {
            contrast: 49.45070930374808,
            lc60: 100,
            lc45: 73.5,
            lc30: 45,
            lc10: 22.5
        },
        "red.200": {
            contrast: 48.69337241283056,
            lc60: 100,
            lc45: 82.5,
            lc30: 50.5,
            lc10: 25.5
        },
        "red.300": {
            contrast: 46.952095397269545,
            lc60: 100,
            lc45: 91,
            lc30: 55,
            lc10: 27.5
        },
        "red.400": {
            contrast: 44.66468583568985,
            lc60: 100,
            lc45: 100,
            lc30: 59.5,
            lc10: 29.5
        },
        "red.500": {
            contrast: 41.42036184089869,
            lc60: 100,
            lc45: 100,
            lc30: 66.5,
            lc10: 32.5
        },
        "red.600": {
            contrast: 36.92054014742799,
            lc60: 100,
            lc45: 100,
            lc30: 75.5,
            lc10: 36.5
        },
        "red.700": {
            contrast: 32.70750521787454,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 40.5
        },
        "red.800": {
            contrast: 28.046493244757375,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 47.5
        },
        "red.900": {
            contrast: 23.61304296768766,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "red.1000": {
            contrast: 19.46544149646427,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "red.1100": {
            contrast: 14.447333536189522,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1200": {
            contrast: 11.185347106501414,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1700": {
            contrast: 9.712997844921208,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1800": {
            contrast: 15.42324992126552,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 97
        },
        "red.1900": {
            contrast: 21.00706153083901,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76.5
        },
        "red.2000": {
            contrast: 27.043548217340753,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63
        },
        "red.2100": {
            contrast: 33.46562032212928,
            lc60: 100,
            lc45: 100,
            lc30: 91.5,
            lc10: 53.5
        },
        "red.2200": {
            contrast: 39.436502263747684,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 47.5
        },
        "red.2300": {
            contrast: 46.09297539326949,
            lc60: 100,
            lc45: 98,
            lc30: 72,
            lc10: 42.5
        },
        "red.2400": {
            contrast: 53.102105950954126,
            lc60: 100,
            lc45: 88,
            lc30: 65,
            lc10: 38
        },
        "red.2500": {
            contrast: 59.88281532790135,
            lc60: 100,
            lc45: 80.5,
            lc30: 59.5,
            lc10: 35
        }
    },
    "red.1600": {
        "red.100": {
            contrast: 54.46574648098434,
            lc60: 100,
            lc45: 64.5,
            lc30: 41,
            lc10: 21
        },
        "red.200": {
            contrast: 53.70840959006682,
            lc60: 100,
            lc45: 71,
            lc30: 45,
            lc10: 22.5
        },
        "red.300": {
            contrast: 51.967132574505804,
            lc60: 100,
            lc45: 77,
            lc30: 48.5,
            lc10: 24.5
        },
        "red.400": {
            contrast: 49.67972301292611,
            lc60: 100,
            lc45: 84,
            lc30: 52,
            lc10: 26
        },
        "red.500": {
            contrast: 46.43539901813495,
            lc60: 100,
            lc45: 95,
            lc30: 57,
            lc10: 28
        },
        "red.600": {
            contrast: 41.93557732466425,
            lc60: 100,
            lc45: 100,
            lc30: 63,
            lc10: 30.5
        },
        "red.700": {
            contrast: 37.7225423951108,
            lc60: 100,
            lc45: 100,
            lc30: 72,
            lc10: 34
        },
        "red.800": {
            contrast: 33.06153042199364,
            lc60: 100,
            lc45: 100,
            lc30: 85.5,
            lc10: 38
        },
        "red.900": {
            contrast: 28.628080144923917,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 42.5
        },
        "red.1000": {
            contrast: 24.48047867370053,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 50
        },
        "red.1100": {
            contrast: 19.46237071342578,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "red.1200": {
            contrast: 16.200384283737673,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87.5
        },
        "red.1300": {
            contrast: 11.862428132724254,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1400": {
            contrast: 7.540031197718705,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1800": {
            contrast: 10.174127193441942,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1900": {
            contrast: 15.757938803015433,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 96.5
        },
        "red.2000": {
            contrast: 21.794425489517177,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "red.2100": {
            contrast: 28.2164975943057,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "red.2200": {
            contrast: 34.18737953592411,
            lc60: 100,
            lc45: 100,
            lc30: 89.5,
            lc10: 51
        },
        "red.2300": {
            contrast: 40.843852665445915,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 44
        },
        "red.2400": {
            contrast: 47.85298322313054,
            lc60: 100,
            lc45: 95,
            lc30: 69,
            lc10: 39
        },
        "red.2500": {
            contrast: 54.63369260007778,
            lc60: 100,
            lc45: 86,
            lc30: 62,
            lc10: 35
        }
    },
    "red.1700": {
        "red.100": {
            contrast: 59.55585680987468,
            lc60: 100,
            lc45: 58.5,
            lc30: 37.5,
            lc10: 19
        },
        "red.200": {
            contrast: 58.79851991895717,
            lc60: 100,
            lc45: 63.5,
            lc30: 40.5,
            lc10: 21
        },
        "red.300": {
            contrast: 57.057242903396144,
            lc60: 100,
            lc45: 68.5,
            lc30: 43.5,
            lc10: 22
        },
        "red.400": {
            contrast: 54.76983334181645,
            lc60: 100,
            lc45: 73.5,
            lc30: 46,
            lc10: 23
        },
        "red.500": {
            contrast: 51.52550934702529,
            lc60: 100,
            lc45: 80.5,
            lc30: 49.5,
            lc10: 25
        },
        "red.600": {
            contrast: 47.02568765355459,
            lc60: 100,
            lc45: 92.5,
            lc30: 54,
            lc10: 26.5
        },
        "red.700": {
            contrast: 42.81265272400115,
            lc60: 100,
            lc45: 100,
            lc30: 60,
            lc10: 29
        },
        "red.800": {
            contrast: 38.15164075088398,
            lc60: 100,
            lc45: 100,
            lc30: 68,
            lc10: 31.5
        },
        "red.900": {
            contrast: 33.71819047381426,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 35
        },
        "red.1000": {
            contrast: 29.570589002590868,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 39
        },
        "red.1100": {
            contrast: 24.552481042316124,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 45
        },
        "red.1200": {
            contrast: 21.290494612628017,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "red.1300": {
            contrast: 16.952538461614594,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83.5
        },
        "red.1400": {
            contrast: 12.630141526609048,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1500": {
            contrast: 8.104109454916973,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1900": {
            contrast: 10.360440159577571,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.2000": {
            contrast: 16.396926846079314,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 92.5
        },
        "red.2100": {
            contrast: 22.818998950867844,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "red.2200": {
            contrast: 28.78988089248624,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "red.2300": {
            contrast: 35.44635402200805,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 48.5
        },
        "red.2400": {
            contrast: 42.45548457969268,
            lc60: 100,
            lc45: 100,
            lc30: 75,
            lc10: 42
        },
        "red.2500": {
            contrast: 49.23619395663991,
            lc60: 100,
            lc45: 92.5,
            lc30: 66.5,
            lc10: 37
        }
    },
    "red.1800": {
        "red.100": {
            contrast: 64.98838470124927,
            lc60: 76.5,
            lc45: 53.5,
            lc30: 34.5,
            lc10: 17.5
        },
        "red.200": {
            contrast: 64.23104781033176,
            lc60: 83,
            lc45: 57.5,
            lc30: 37,
            lc10: 19
        },
        "red.300": {
            contrast: 62.489770794770735,
            lc60: 90,
            lc45: 61,
            lc30: 39,
            lc10: 20
        },
        "red.400": {
            contrast: 60.202361233191034,
            lc60: 99,
            lc45: 64,
            lc30: 41,
            lc10: 20.5
        },
        "red.500": {
            contrast: 56.95803723839988,
            lc60: 100,
            lc45: 69.5,
            lc30: 44,
            lc10: 22
        },
        "red.600": {
            contrast: 52.458215544929175,
            lc60: 100,
            lc45: 77,
            lc30: 47,
            lc10: 23
        },
        "red.700": {
            contrast: 48.24518061537574,
            lc60: 100,
            lc45: 87.5,
            lc30: 51,
            lc10: 25
        },
        "red.800": {
            contrast: 43.58416864225856,
            lc60: 100,
            lc45: 100,
            lc30: 56.5,
            lc10: 27
        },
        "red.900": {
            contrast: 39.150718365188844,
            lc60: 100,
            lc45: 100,
            lc30: 62.5,
            lc10: 29
        },
        "red.1000": {
            contrast: 35.003116893965455,
            lc60: 100,
            lc45: 100,
            lc30: 72,
            lc10: 31.5
        },
        "red.1100": {
            contrast: 29.985008933690704,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 35
        },
        "red.1200": {
            contrast: 26.723022504002596,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 45
        },
        "red.1300": {
            contrast: 22.385066352989178,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59
        },
        "red.1400": {
            contrast: 18.06266941798363,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79
        },
        "red.1500": {
            contrast: 13.536637346291558,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1600": {
            contrast: 8.49036883823636,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.2000": {
            contrast: 10.563782723538734,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.2100": {
            contrast: 16.98585482832726,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89.5
        },
        "red.2200": {
            contrast: 22.956736769945664,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69.5
        },
        "red.2300": {
            contrast: 29.613209899467467,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56
        },
        "red.2400": {
            contrast: 36.622340457152106,
            lc60: 100,
            lc45: 100,
            lc30: 84,
            lc10: 47
        },
        "red.2500": {
            contrast: 43.40304983409933,
            lc60: 100,
            lc45: 100,
            lc30: 73,
            lc10: 40.5
        }
    },
    "red.1900": {
        "red.100": {
            contrast: 70.2589651322685,
            lc60: 69,
            lc45: 49,
            lc30: 32,
            lc10: 16.5
        },
        "red.200": {
            contrast: 69.50162824135099,
            lc60: 73.5,
            lc45: 52.5,
            lc30: 34,
            lc10: 17.5
        },
        "red.300": {
            contrast: 67.76035122578996,
            lc60: 78.5,
            lc45: 55,
            lc30: 35.5,
            lc10: 18
        },
        "red.400": {
            contrast: 65.47294166421027,
            lc60: 83.5,
            lc45: 58,
            lc30: 37.5,
            lc10: 19
        },
        "red.500": {
            contrast: 62.228617669419116,
            lc60: 92.5,
            lc45: 62,
            lc30: 39.5,
            lc10: 20
        },
        "red.600": {
            contrast: 57.72879597594841,
            lc60: 100,
            lc45: 66.5,
            lc30: 41.5,
            lc10: 21
        },
        "red.700": {
            contrast: 53.51576104639497,
            lc60: 100,
            lc45: 73.5,
            lc30: 45,
            lc10: 22.5
        },
        "red.800": {
            contrast: 48.854749073277794,
            lc60: 100,
            lc45: 84,
            lc30: 48.5,
            lc10: 23.5
        },
        "red.900": {
            contrast: 44.42129879620808,
            lc60: 100,
            lc45: 100,
            lc30: 52.5,
            lc10: 25.5
        },
        "red.1000": {
            contrast: 40.27369732498469,
            lc60: 100,
            lc45: 100,
            lc30: 58,
            lc10: 26.5
        },
        "red.1100": {
            contrast: 35.25558936470994,
            lc60: 100,
            lc45: 100,
            lc30: 67.5,
            lc10: 29.5
        },
        "red.1200": {
            contrast: 31.99360293502183,
            lc60: 100,
            lc45: 100,
            lc30: 86,
            lc10: 36
        },
        "red.1300": {
            contrast: 27.655646784008407,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 45
        },
        "red.1400": {
            contrast: 23.333249849002865,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "red.1500": {
            contrast: 18.807217777310793,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76.5
        },
        "red.1600": {
            contrast: 13.760949269255592,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1700": {
            contrast: 8.631726983321062,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.2100": {
            contrast: 11.259378005882581,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.2200": {
            contrast: 17.230259947500983,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89.5
        },
        "red.2300": {
            contrast: 23.88673307702279,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "red.2400": {
            contrast: 30.89586363470742,
            lc60: 100,
            lc45: 100,
            lc30: 97.5,
            lc10: 54
        },
        "red.2500": {
            contrast: 37.67657301165465,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 45.5
        }
    },
    "red.2000": {
        "red.100": {
            contrast: 75.91438325955498,
            lc60: 63,
            lc45: 45.5,
            lc30: 30,
            lc10: 15
        },
        "red.200": {
            contrast: 75.15704636863747,
            lc60: 66.5,
            lc45: 48,
            lc30: 31,
            lc10: 16
        },
        "red.300": {
            contrast: 73.41576935307646,
            lc60: 70,
            lc45: 50,
            lc30: 33,
            lc10: 17
        },
        "red.400": {
            contrast: 71.12835979149675,
            lc60: 74,
            lc45: 52,
            lc30: 34,
            lc10: 17
        },
        "red.500": {
            contrast: 67.8840357967056,
            lc60: 79.5,
            lc45: 55,
            lc30: 35.5,
            lc10: 18.5
        },
        "red.600": {
            contrast: 63.384214103234896,
            lc60: 88.5,
            lc45: 58.5,
            lc30: 37.5,
            lc10: 19
        },
        "red.700": {
            contrast: 59.17117917368145,
            lc60: 100,
            lc45: 63.5,
            lc30: 39.5,
            lc10: 20
        },
        "red.800": {
            contrast: 54.51016720056428,
            lc60: 100,
            lc45: 69.5,
            lc30: 42.5,
            lc10: 21
        },
        "red.900": {
            contrast: 50.07671692349456,
            lc60: 100,
            lc45: 78,
            lc30: 45,
            lc10: 22
        },
        "red.1000": {
            contrast: 45.929115452271176,
            lc60: 100,
            lc45: 92.5,
            lc30: 48.5,
            lc10: 23
        },
        "red.1100": {
            contrast: 40.91100749199642,
            lc60: 100,
            lc45: 100,
            lc30: 54,
            lc10: 25
        },
        "red.1200": {
            contrast: 37.64902106230832,
            lc60: 100,
            lc45: 100,
            lc30: 66.5,
            lc10: 30.5
        },
        "red.1300": {
            contrast: 33.3110649112949,
            lc60: 100,
            lc45: 100,
            lc30: 83,
            lc10: 36.5
        },
        "red.1400": {
            contrast: 28.988667976289346,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 45
        },
        "red.1500": {
            contrast: 24.462635904597278,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "red.1600": {
            contrast: 19.41636739654208,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76
        },
        "red.1700": {
            contrast: 14.287145110607547,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1800": {
            contrast: 8.805256211202222,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.2200": {
            contrast: 11.016354997655123,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.2300": {
            contrast: 17.67282812717693,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86.5
        },
        "red.2400": {
            contrast: 24.681958684861563,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65
        },
        "red.2500": {
            contrast: 31.462668061808785,
            lc60: 100,
            lc45: 100,
            lc30: 96,
            lc10: 52.5
        }
    },
    "red.2100": {
        "red.100": {
            contrast: 81.88654795859196,
            lc60: 58,
            lc45: 42,
            lc30: 28,
            lc10: 14.5
        },
        "red.200": {
            contrast: 81.12921106767445,
            lc60: 60.5,
            lc45: 44.5,
            lc30: 29,
            lc10: 15
        },
        "red.300": {
            contrast: 79.38793405211342,
            lc60: 63.5,
            lc45: 46,
            lc30: 30,
            lc10: 15.5
        },
        "red.400": {
            contrast: 77.10052449053373,
            lc60: 66,
            lc45: 47.5,
            lc30: 31,
            lc10: 16
        },
        "red.500": {
            contrast: 73.85620049574257,
            lc60: 70,
            lc45: 50,
            lc30: 32.5,
            lc10: 16.5
        },
        "red.600": {
            contrast: 69.35637880227188,
            lc60: 75.5,
            lc45: 52,
            lc30: 34,
            lc10: 17.5
        },
        "red.700": {
            contrast: 65.14334387271843,
            lc60: 83,
            lc45: 55.5,
            lc30: 35.5,
            lc10: 18
        },
        "red.800": {
            contrast: 60.48233189960126,
            lc60: 97,
            lc45: 60,
            lc30: 37,
            lc10: 18.5
        },
        "red.900": {
            contrast: 56.048881622531546,
            lc60: 100,
            lc45: 64.5,
            lc30: 39.5,
            lc10: 19.5
        },
        "red.1000": {
            contrast: 51.90128015130815,
            lc60: 100,
            lc45: 70.5,
            lc30: 41.5,
            lc10: 20.5
        },
        "red.1100": {
            contrast: 46.883172191033395,
            lc60: 100,
            lc45: 85,
            lc30: 45,
            lc10: 22
        },
        "red.1200": {
            contrast: 43.621185761345295,
            lc60: 100,
            lc45: 100,
            lc30: 54,
            lc10: 26
        },
        "red.1300": {
            contrast: 39.28322961033187,
            lc60: 100,
            lc45: 100,
            lc30: 65.5,
            lc10: 31
        },
        "red.1400": {
            contrast: 34.96083267532632,
            lc60: 100,
            lc45: 100,
            lc30: 79,
            lc10: 36.5
        },
        "red.1500": {
            contrast: 30.434800603634248,
            lc60: 100,
            lc45: 100,
            lc30: 98.5,
            lc10: 45
        },
        "red.1600": {
            contrast: 25.388532095579052,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "red.1700": {
            contrast: 20.259309809644524,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73
        },
        "red.1800": {
            contrast: 14.777420910239197,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1900": {
            contrast: 9.451967677721187,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.2300": {
            contrast: 11.037422896539361,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.2400": {
            contrast: 18.046553454223993,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86
        },
        "red.2500": {
            contrast: 24.82726283117122,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65
        }
    },
    "red.2200": {
        "red.100": {
            contrast: 87.40114403344587,
            lc60: 54,
            lc45: 39,
            lc30: 26,
            lc10: 13.5
        },
        "red.200": {
            contrast: 86.64380714252835,
            lc60: 56.5,
            lc45: 41,
            lc30: 27,
            lc10: 14
        },
        "red.300": {
            contrast: 84.90253012696733,
            lc60: 58.5,
            lc45: 42.5,
            lc30: 28,
            lc10: 14.5
        },
        "red.400": {
            contrast: 82.61512056538764,
            lc60: 60.5,
            lc45: 44,
            lc30: 29,
            lc10: 15
        },
        "red.500": {
            contrast: 79.37079657059648,
            lc60: 63.5,
            lc45: 45.5,
            lc30: 30,
            lc10: 15.5
        },
        "red.600": {
            contrast: 74.87097487712579,
            lc60: 67.5,
            lc45: 47.5,
            lc30: 31,
            lc10: 16
        },
        "red.700": {
            contrast: 70.65793994757233,
            lc60: 72.5,
            lc45: 50,
            lc30: 32.5,
            lc10: 16.5
        },
        "red.800": {
            contrast: 65.99692797445516,
            lc60: 79.5,
            lc45: 53,
            lc30: 34,
            lc10: 17.5
        },
        "red.900": {
            contrast: 61.56347769738545,
            lc60: 91.5,
            lc45: 56.5,
            lc30: 35,
            lc10: 18
        },
        "red.1000": {
            contrast: 57.415876226162055,
            lc60: 100,
            lc45: 60,
            lc30: 37,
            lc10: 18.5
        },
        "red.1100": {
            contrast: 52.397768265887315,
            lc60: 100,
            lc45: 67.5,
            lc30: 39.5,
            lc10: 19.5
        },
        "red.1200": {
            contrast: 49.1357818361992,
            lc60: 100,
            lc45: 81,
            lc30: 46.5,
            lc10: 23
        },
        "red.1300": {
            contrast: 44.797825685185785,
            lc60: 100,
            lc45: 100,
            lc30: 55.5,
            lc10: 27
        },
        "red.1400": {
            contrast: 40.47542875018023,
            lc60: 100,
            lc45: 100,
            lc30: 65,
            lc10: 31.5
        },
        "red.1500": {
            contrast: 35.949396678488164,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 38
        },
        "red.1600": {
            contrast: 30.903128170432964,
            lc60: 100,
            lc45: 100,
            lc30: 96,
            lc10: 46.5
        },
        "red.1700": {
            contrast: 25.773905884498433,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58
        },
        "red.1800": {
            contrast: 20.29201698509311,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75
        },
        "red.1900": {
            contrast: 14.966563752575096,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.2000": {
            contrast: 9.245140827215032,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.2400": {
            contrast: 11.856117122041399,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.2500": {
            contrast: 18.636826498988626,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83.5
        }
    },
    "red.2300": {
        "red.100": {
            contrast: 93.50898689665044,
            lc60: 50,
            lc45: 37,
            lc30: 24.5,
            lc10: 12.5
        },
        "red.200": {
            contrast: 92.75165000573293,
            lc60: 52,
            lc45: 38,
            lc30: 25.5,
            lc10: 13
        },
        "red.300": {
            contrast: 91.0103729901719,
            lc60: 54,
            lc45: 39.5,
            lc30: 26,
            lc10: 13.5
        },
        "red.400": {
            contrast: 88.72296342859222,
            lc60: 55.5,
            lc45: 40.5,
            lc30: 26.5,
            lc10: 14
        },
        "red.500": {
            contrast: 85.47863943380105,
            lc60: 58,
            lc45: 42,
            lc30: 27.5,
            lc10: 14.5
        },
        "red.600": {
            contrast: 80.97881774033036,
            lc60: 60.5,
            lc45: 43.5,
            lc30: 28.5,
            lc10: 15
        },
        "red.700": {
            contrast: 76.76578281077691,
            lc60: 64,
            lc45: 45.5,
            lc30: 29.5,
            lc10: 15.5
        },
        "red.800": {
            contrast: 72.10477083765974,
            lc60: 68.5,
            lc45: 47.5,
            lc30: 31,
            lc10: 16
        },
        "red.900": {
            contrast: 67.67132056059002,
            lc60: 74,
            lc45: 50,
            lc30: 31.5,
            lc10: 16.5
        },
        "red.1000": {
            contrast: 63.52371908936664,
            lc60: 82.5,
            lc45: 52.5,
            lc30: 33,
            lc10: 17
        },
        "red.1100": {
            contrast: 58.50561112909188,
            lc60: 100,
            lc45: 57,
            lc30: 35,
            lc10: 17.5
        },
        "red.1200": {
            contrast: 55.24362469940378,
            lc60: 100,
            lc45: 67,
            lc30: 40.5,
            lc10: 20
        },
        "red.1300": {
            contrast: 50.90566854839036,
            lc60: 100,
            lc45: 79.5,
            lc30: 47.5,
            lc10: 23.5
        },
        "red.1400": {
            contrast: 46.58327161338481,
            lc60: 100,
            lc45: 93.5,
            lc30: 54.5,
            lc10: 27
        },
        "red.1500": {
            contrast: 42.05723954169273,
            lc60: 100,
            lc45: 100,
            lc30: 65,
            lc10: 32
        },
        "red.1600": {
            contrast: 37.01097103363754,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 38.5
        },
        "red.1700": {
            contrast: 31.881748747703003,
            lc60: 100,
            lc45: 100,
            lc30: 93,
            lc10: 46.5
        },
        "red.1800": {
            contrast: 26.39985984829768,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "red.1900": {
            contrast: 21.07440661577967,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72.5
        },
        "red.2000": {
            contrast: 15.352983690419606,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98.5
        },
        "red.2100": {
            contrast: 9.303637697126597,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.2500": {
            contrast: 11.713054096587616,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "red.2400": {
        "red.100": {
            contrast: 99.89813913449495,
            lc60: 46.5,
            lc45: 34.5,
            lc30: 23,
            lc10: 12
        },
        "red.200": {
            contrast: 99.14080224357743,
            lc60: 48.5,
            lc45: 35.5,
            lc30: 23.5,
            lc10: 12.5
        },
        "red.300": {
            contrast: 97.39952522801642,
            lc60: 50,
            lc45: 36.5,
            lc30: 24.5,
            lc10: 13
        },
        "red.400": {
            contrast: 95.11211566643671,
            lc60: 51,
            lc45: 37.5,
            lc30: 25,
            lc10: 13
        },
        "red.500": {
            contrast: 91.86779167164556,
            lc60: 53,
            lc45: 38.5,
            lc30: 25.5,
            lc10: 13
        },
        "red.600": {
            contrast: 87.36796997817487,
            lc60: 55,
            lc45: 40,
            lc30: 26.5,
            lc10: 13.5
        },
        "red.700": {
            contrast: 83.15493504862141,
            lc60: 57.5,
            lc45: 41.5,
            lc30: 27,
            lc10: 14
        },
        "red.800": {
            contrast: 78.49392307550424,
            lc60: 61,
            lc45: 43,
            lc30: 28,
            lc10: 14.5
        },
        "red.900": {
            contrast: 74.06047279843453,
            lc60: 64.5,
            lc45: 45,
            lc30: 29,
            lc10: 15
        },
        "red.1000": {
            contrast: 69.91287132721114,
            lc60: 68.5,
            lc45: 46.5,
            lc30: 30,
            lc10: 15.5
        },
        "red.1100": {
            contrast: 64.89476336693639,
            lc60: 76.5,
            lc45: 50,
            lc30: 31,
            lc10: 16
        },
        "red.1200": {
            contrast: 61.63277693724829,
            lc60: 91.5,
            lc45: 57.5,
            lc30: 36,
            lc10: 18.5
        },
        "red.1300": {
            contrast: 57.29482078623486,
            lc60: 100,
            lc45: 66.5,
            lc30: 41.5,
            lc10: 21
        },
        "red.1400": {
            contrast: 52.97242385122931,
            lc60: 100,
            lc45: 76.5,
            lc30: 47.5,
            lc10: 23.5
        },
        "red.1500": {
            contrast: 48.44639177953724,
            lc60: 100,
            lc45: 89.5,
            lc30: 55,
            lc10: 27.5
        },
        "red.1600": {
            contrast: 43.40012327148204,
            lc60: 100,
            lc45: 100,
            lc30: 64.5,
            lc10: 32.5
        },
        "red.1700": {
            contrast: 38.270900985547506,
            lc60: 100,
            lc45: 100,
            lc30: 76,
            lc10: 38
        },
        "red.1800": {
            contrast: 32.789012086142186,
            lc60: 100,
            lc45: 100,
            lc30: 90,
            lc10: 45.5
        },
        "red.1900": {
            contrast: 27.46355885362417,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "red.2000": {
            contrast: 21.74213592826411,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70.5
        },
        "red.2100": {
            contrast: 15.692789934971103,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 96
        },
        "red.2200": {
            contrast: 10.100530819754026,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "red.2500": {
        "red.100": {
            contrast: 106.04067321268862,
            lc60: 44,
            lc45: 32.5,
            lc30: 21.5,
            lc10: 11.5
        },
        "red.200": {
            contrast: 105.28333632177109,
            lc60: 45.5,
            lc45: 33.5,
            lc30: 22.5,
            lc10: 11.5
        },
        "red.300": {
            contrast: 103.54205930621008,
            lc60: 46.5,
            lc45: 34.5,
            lc30: 23,
            lc10: 12
        },
        "red.400": {
            contrast: 101.25464974463038,
            lc60: 48,
            lc45: 35,
            lc30: 23.5,
            lc10: 12
        },
        "red.500": {
            contrast: 98.0103257498392,
            lc60: 49,
            lc45: 36,
            lc30: 24,
            lc10: 12.5
        },
        "red.600": {
            contrast: 93.5105040563685,
            lc60: 51,
            lc45: 37,
            lc30: 24.5,
            lc10: 13
        },
        "red.700": {
            contrast: 89.29746912681506,
            lc60: 52.5,
            lc45: 38,
            lc30: 25,
            lc10: 13
        },
        "red.800": {
            contrast: 84.6364571536979,
            lc60: 55.5,
            lc45: 39.5,
            lc30: 26,
            lc10: 13.5
        },
        "red.900": {
            contrast: 80.20300687662817,
            lc60: 57.5,
            lc45: 41,
            lc30: 26.5,
            lc10: 13.5
        },
        "red.1000": {
            contrast: 76.05540540540478,
            lc60: 60.5,
            lc45: 42,
            lc30: 27.5,
            lc10: 14
        },
        "red.1100": {
            contrast: 71.03729744513004,
            lc60: 65,
            lc45: 44.5,
            lc30: 28.5,
            lc10: 15
        },
        "red.1200": {
            contrast: 67.77531101544193,
            lc60: 75.5,
            lc45: 51,
            lc30: 32.5,
            lc10: 16.5
        },
        "red.1300": {
            contrast: 63.4373548644285,
            lc60: 88.5,
            lc45: 58,
            lc30: 37,
            lc10: 18.5
        },
        "red.1400": {
            contrast: 59.11495792942295,
            lc60: 100,
            lc45: 66,
            lc30: 41.5,
            lc10: 21.5
        },
        "red.1500": {
            contrast: 54.58892585773087,
            lc60: 100,
            lc45: 76,
            lc30: 48,
            lc10: 24.5
        },
        "red.1600": {
            contrast: 49.54265734967569,
            lc60: 100,
            lc45: 88,
            lc30: 55.5,
            lc10: 28.5
        },
        "red.1700": {
            contrast: 44.41343506374116,
            lc60: 100,
            lc45: 100,
            lc30: 64,
            lc10: 33
        },
        "red.1800": {
            contrast: 38.93154616433583,
            lc60: 100,
            lc45: 100,
            lc30: 75,
            lc10: 38.5
        },
        "red.1900": {
            contrast: 33.60609293181782,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 45.5
        },
        "red.2000": {
            contrast: 27.88467000645775,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "red.2100": {
            contrast: 21.835324013164747,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "red.2200": {
            contrast: 16.243064897947672,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93.5
        },
        "red.2300": {
            contrast: 10.04247011649673,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    }
};
const $f8fd43f1ee3f8cd8$var$sky = {
    "sky.100": {
        "sky.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.600": {
            contrast: 9.149152113849798,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.700": {
            contrast: 13.22591958736922,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.800": {
            contrast: 18.321682611742762,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 90.5
        },
        "sky.900": {
            contrast: 22.974953695318813,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80.5
        },
        "sky.1000": {
            contrast: 28.40326762085162,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72
        },
        "sky.1100": {
            contrast: 31.756110235907652,
            lc60: 100,
            lc45: 100,
            lc30: 96.5,
            lc10: 67.5
        },
        "sky.1200": {
            contrast: 36.69480218103717,
            lc60: 100,
            lc45: 100,
            lc30: 89,
            lc10: 62
        },
        "sky.1300": {
            contrast: 41.82328180856772,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 57.5
        },
        "sky.1400": {
            contrast: 46.26443100249285,
            lc60: 100,
            lc45: 98,
            lc30: 77.5,
            lc10: 54
        },
        "sky.1500": {
            contrast: 50.89300517046439,
            lc60: 100,
            lc45: 93,
            lc30: 73.5,
            lc10: 51
        },
        "sky.1600": {
            contrast: 56.113986390955894,
            lc60: 100,
            lc45: 87,
            lc30: 69,
            lc10: 48.5
        },
        "sky.1700": {
            contrast: 61.12225576253696,
            lc60: 98.5,
            lc45: 83,
            lc30: 66,
            lc10: 45.5
        },
        "sky.1800": {
            contrast: 66.2781059649632,
            lc60: 94,
            lc45: 79,
            lc30: 62,
            lc10: 43.5
        },
        "sky.1900": {
            contrast: 71.63512417330111,
            lc60: 89.5,
            lc45: 75,
            lc30: 59.5,
            lc10: 41.5
        },
        "sky.2000": {
            contrast: 77.29425361038213,
            lc60: 85.5,
            lc45: 71.5,
            lc30: 56.5,
            lc10: 39.5
        },
        "sky.2100": {
            contrast: 83.31405476069837,
            lc60: 81.5,
            lc45: 68.5,
            lc30: 54,
            lc10: 37.5
        },
        "sky.2200": {
            contrast: 89.21310152266025,
            lc60: 78,
            lc45: 65.5,
            lc30: 52,
            lc10: 36
        },
        "sky.2300": {
            contrast: 95.17679401555318,
            lc60: 75,
            lc45: 63,
            lc30: 49.5,
            lc10: 34.5
        },
        "sky.2400": {
            contrast: 101.50253619428344,
            lc60: 72,
            lc45: 60.5,
            lc30: 47.5,
            lc10: 33
        },
        "sky.2500": {
            contrast: 107.88473318309848,
            lc60: 69,
            lc45: 58,
            lc30: 46,
            lc10: 32
        }
    },
    "sky.200": {
        "sky.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.600": {
            contrast: 8.777028014574894,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.700": {
            contrast: 12.853795488094317,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.800": {
            contrast: 17.94955851246786,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 90.5
        },
        "sky.900": {
            contrast: 22.602829596043907,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78.5
        },
        "sky.1000": {
            contrast: 28.031143521576713,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "sky.1100": {
            contrast: 31.383986136632746,
            lc60: 100,
            lc45: 100,
            lc30: 96.5,
            lc10: 64
        },
        "sky.1200": {
            contrast: 36.322678081762255,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 58
        },
        "sky.1300": {
            contrast: 41.451157709292815,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 53.5
        },
        "sky.1400": {
            contrast: 45.89230690321794,
            lc60: 100,
            lc45: 98.5,
            lc30: 76,
            lc10: 50
        },
        "sky.1500": {
            contrast: 50.520881071189486,
            lc60: 100,
            lc45: 92.5,
            lc30: 71.5,
            lc10: 47
        },
        "sky.1600": {
            contrast: 55.741862291681,
            lc60: 100,
            lc45: 86.5,
            lc30: 67,
            lc10: 44
        },
        "sky.1700": {
            contrast: 60.75013166326205,
            lc60: 99,
            lc45: 82,
            lc30: 63,
            lc10: 41.5
        },
        "sky.1800": {
            contrast: 65.9059818656883,
            lc60: 94,
            lc45: 77.5,
            lc30: 59.5,
            lc10: 39.5
        },
        "sky.1900": {
            contrast: 71.2630000740262,
            lc60: 89,
            lc45: 73.5,
            lc30: 57,
            lc10: 37.5
        },
        "sky.2000": {
            contrast: 76.92212951110722,
            lc60: 84.5,
            lc45: 70,
            lc30: 54.5,
            lc10: 35.5
        },
        "sky.2100": {
            contrast: 82.94193066142347,
            lc60: 80.5,
            lc45: 67,
            lc30: 51.5,
            lc10: 34
        },
        "sky.2200": {
            contrast: 88.84097742338535,
            lc60: 77,
            lc45: 64,
            lc30: 49,
            lc10: 32.5
        },
        "sky.2300": {
            contrast: 94.80466991627829,
            lc60: 73.5,
            lc45: 61,
            lc30: 47.5,
            lc10: 31
        },
        "sky.2400": {
            contrast: 101.13041209500852,
            lc60: 70.5,
            lc45: 58.5,
            lc30: 45,
            lc10: 29.5
        },
        "sky.2500": {
            contrast: 107.51260908382356,
            lc60: 68,
            lc45: 56,
            lc30: 43.5,
            lc10: 28.5
        }
    },
    "sky.300": {
        "sky.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.600": {
            contrast: 7.545766678539813,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.700": {
            contrast: 11.622534152059236,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.800": {
            contrast: 16.718297176432777,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93
        },
        "sky.900": {
            contrast: 21.37156826000883,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78.5
        },
        "sky.1000": {
            contrast: 26.79988218554163,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "sky.1100": {
            contrast: 30.152724800597664,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 62
        },
        "sky.1200": {
            contrast: 35.09141674572718,
            lc60: 100,
            lc45: 100,
            lc30: 89.5,
            lc10: 55.5
        },
        "sky.1300": {
            contrast: 40.21989637325773,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 50.5
        },
        "sky.1400": {
            contrast: 44.66104556718286,
            lc60: 100,
            lc45: 100,
            lc30: 75.5,
            lc10: 47
        },
        "sky.1500": {
            contrast: 49.2896197351544,
            lc60: 100,
            lc45: 93.5,
            lc30: 70.5,
            lc10: 44
        },
        "sky.1600": {
            contrast: 54.51060095564591,
            lc60: 100,
            lc45: 87.5,
            lc30: 66,
            lc10: 41
        },
        "sky.1700": {
            contrast: 59.51887032722697,
            lc60: 100,
            lc45: 82,
            lc30: 62,
            lc10: 38.5
        },
        "sky.1800": {
            contrast: 64.6747205296532,
            lc60: 94.5,
            lc45: 77.5,
            lc30: 58,
            lc10: 36.5
        },
        "sky.1900": {
            contrast: 70.0317387379911,
            lc60: 89,
            lc45: 73.5,
            lc30: 55,
            lc10: 34.5
        },
        "sky.2000": {
            contrast: 75.69086817507214,
            lc60: 85,
            lc45: 69,
            lc30: 52.5,
            lc10: 33
        },
        "sky.2100": {
            contrast: 81.71066932538838,
            lc60: 80.5,
            lc45: 66,
            lc30: 49.5,
            lc10: 31.5
        },
        "sky.2200": {
            contrast: 87.60971608735026,
            lc60: 76.5,
            lc45: 63,
            lc30: 47.5,
            lc10: 29.5
        },
        "sky.2300": {
            contrast: 93.5734085802432,
            lc60: 73.5,
            lc45: 60,
            lc30: 45,
            lc10: 28.5
        },
        "sky.2400": {
            contrast: 99.89915075897343,
            lc60: 70,
            lc45: 57.5,
            lc30: 43.5,
            lc10: 27.5
        },
        "sky.2500": {
            contrast: 106.28134774778847,
            lc60: 67,
            lc45: 55,
            lc30: 41.5,
            lc10: 26.5
        }
    },
    "sky.400": {
        "sky.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.700": {
            contrast: 9.68980179361858,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.800": {
            contrast: 14.78556481799212,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.900": {
            contrast: 19.43883590156817,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82
        },
        "sky.1000": {
            contrast: 24.867149827100977,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68.5
        },
        "sky.1100": {
            contrast: 28.219992442157004,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62
        },
        "sky.1200": {
            contrast: 33.15868438728652,
            lc60: 100,
            lc45: 100,
            lc30: 92.5,
            lc10: 55
        },
        "sky.1300": {
            contrast: 38.28716401481707,
            lc60: 100,
            lc45: 100,
            lc30: 83,
            lc10: 49.5
        },
        "sky.1400": {
            contrast: 42.7283132087422,
            lc60: 100,
            lc45: 100,
            lc30: 76,
            lc10: 45.5
        },
        "sky.1500": {
            contrast: 47.35688737671374,
            lc60: 100,
            lc45: 96,
            lc30: 71,
            lc10: 42
        },
        "sky.1600": {
            contrast: 52.577868597205246,
            lc60: 100,
            lc45: 89,
            lc30: 65.5,
            lc10: 39
        },
        "sky.1700": {
            contrast: 57.58613796878631,
            lc60: 100,
            lc45: 83,
            lc30: 61.5,
            lc10: 36.5
        },
        "sky.1800": {
            contrast: 62.74198817121255,
            lc60: 96.5,
            lc45: 78,
            lc30: 58,
            lc10: 34.5
        },
        "sky.1900": {
            contrast: 68.09900637955046,
            lc60: 91,
            lc45: 73.5,
            lc30: 54.5,
            lc10: 32.5
        },
        "sky.2000": {
            contrast: 73.75813581663148,
            lc60: 85.5,
            lc45: 69.5,
            lc30: 51.5,
            lc10: 31
        },
        "sky.2100": {
            contrast: 79.77793696694772,
            lc60: 81,
            lc45: 66,
            lc30: 48.5,
            lc10: 29.5
        },
        "sky.2200": {
            contrast: 85.6769837289096,
            lc60: 77,
            lc45: 62.5,
            lc30: 46.5,
            lc10: 28
        },
        "sky.2300": {
            contrast: 91.64067622180254,
            lc60: 73.5,
            lc45: 59.5,
            lc30: 44,
            lc10: 27
        },
        "sky.2400": {
            contrast: 97.96641840053279,
            lc60: 70,
            lc45: 57,
            lc30: 42.5,
            lc10: 26
        },
        "sky.2500": {
            contrast: 104.34861538934783,
            lc60: 67,
            lc45: 54.5,
            lc30: 40.5,
            lc10: 24.5
        }
    },
    "sky.500": {
        "sky.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.800": {
            contrast: 11.987368271314027,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.900": {
            contrast: 16.640639354890077,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91
        },
        "sky.1000": {
            contrast: 22.068953280422885,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73
        },
        "sky.1100": {
            contrast: 25.421795895478915,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65
        },
        "sky.1200": {
            contrast: 30.360487840608428,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 57
        },
        "sky.1300": {
            contrast: 35.48896746813898,
            lc60: 100,
            lc45: 100,
            lc30: 87.5,
            lc10: 51
        },
        "sky.1400": {
            contrast: 39.930116662064115,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 46.5
        },
        "sky.1500": {
            contrast: 44.558690830035644,
            lc60: 100,
            lc45: 100,
            lc30: 73,
            lc10: 42.5
        },
        "sky.1600": {
            contrast: 49.779672050527154,
            lc60: 100,
            lc45: 92,
            lc30: 67,
            lc10: 39
        },
        "sky.1700": {
            contrast: 54.78794142210822,
            lc60: 100,
            lc45: 85.5,
            lc30: 62,
            lc10: 36.5
        },
        "sky.1800": {
            contrast: 59.94379162453446,
            lc60: 100,
            lc45: 80,
            lc30: 58.5,
            lc10: 34
        },
        "sky.1900": {
            contrast: 65.30080983287236,
            lc60: 93.5,
            lc45: 75,
            lc30: 54.5,
            lc10: 32
        },
        "sky.2000": {
            contrast: 70.95993926995338,
            lc60: 88,
            lc45: 70.5,
            lc30: 51.5,
            lc10: 30.5
        },
        "sky.2100": {
            contrast: 76.97974042026962,
            lc60: 83,
            lc45: 66.5,
            lc30: 49,
            lc10: 28.5
        },
        "sky.2200": {
            contrast: 82.87878718223152,
            lc60: 78.5,
            lc45: 63,
            lc30: 46,
            lc10: 27
        },
        "sky.2300": {
            contrast: 88.84247967512445,
            lc60: 74.5,
            lc45: 60,
            lc30: 44,
            lc10: 26
        },
        "sky.2400": {
            contrast: 95.16822185385469,
            lc60: 71,
            lc45: 57.5,
            lc30: 42,
            lc10: 24.5
        },
        "sky.2500": {
            contrast: 101.55041884266973,
            lc60: 67.5,
            lc45: 54.5,
            lc30: 40,
            lc10: 23.5
        }
    },
    "sky.600": {
        "sky.100": {
            contrast: 10.583925744965377,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.200": {
            contrast: 10.084643971197993,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.300": {
            contrast: 8.472383760283089,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.800": {
            contrast: 7.887660878756858,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.900": {
            contrast: 12.540931962332907,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1000": {
            contrast: 17.969245887865714,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85
        },
        "sky.1100": {
            contrast: 21.322088502921748,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75
        },
        "sky.1200": {
            contrast: 26.260780448051257,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63.5
        },
        "sky.1300": {
            contrast: 31.389260075581817,
            lc60: 100,
            lc45: 100,
            lc30: 96.5,
            lc10: 54.5
        },
        "sky.1400": {
            contrast: 35.830409269506944,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 49
        },
        "sky.1500": {
            contrast: 40.45898343747848,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 44.5
        },
        "sky.1600": {
            contrast: 45.67996465796999,
            lc60: 100,
            lc45: 98.5,
            lc30: 71,
            lc10: 40.5
        },
        "sky.1700": {
            contrast: 50.68823402955105,
            lc60: 100,
            lc45: 91,
            lc30: 65.5,
            lc10: 37.5
        },
        "sky.1800": {
            contrast: 55.8440842319773,
            lc60: 100,
            lc45: 84.5,
            lc30: 61,
            lc10: 35
        },
        "sky.1900": {
            contrast: 61.20110244031519,
            lc60: 98,
            lc45: 78.5,
            lc30: 56.5,
            lc10: 32.5
        },
        "sky.2000": {
            contrast: 66.86023187739622,
            lc60: 92,
            lc45: 73,
            lc30: 53,
            lc10: 30.5
        },
        "sky.2100": {
            contrast: 72.88003302771246,
            lc60: 86,
            lc45: 69,
            lc30: 50,
            lc10: 28.5
        },
        "sky.2200": {
            contrast: 78.77907978967434,
            lc60: 81,
            lc45: 65,
            lc30: 47.5,
            lc10: 27
        },
        "sky.2300": {
            contrast: 84.74277228256727,
            lc60: 77,
            lc45: 62,
            lc30: 45,
            lc10: 26
        },
        "sky.2400": {
            contrast: 91.06851446129753,
            lc60: 73,
            lc45: 58.5,
            lc30: 42.5,
            lc10: 24.5
        },
        "sky.2500": {
            contrast: 97.45071145011256,
            lc60: 69.5,
            lc45: 56,
            lc30: 41,
            lc10: 23.5
        }
    },
    "sky.700": {
        "sky.100": {
            contrast: 15.004278631008988,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 97
        },
        "sky.200": {
            contrast: 14.504996857241604,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.300": {
            contrast: 12.8927366463267,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.400": {
            contrast: 10.45540354455369,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.900": {
            contrast: 8.639964034139625,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1000": {
            contrast: 14.068277959672432,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1100": {
            contrast: 17.421120574728466,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88
        },
        "sky.1200": {
            contrast: 22.35981251985798,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "sky.1300": {
            contrast: 27.48829214738853,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "sky.1400": {
            contrast: 31.929441341313662,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 53
        },
        "sky.1500": {
            contrast: 36.5580155092852,
            lc60: 100,
            lc45: 100,
            lc30: 85,
            lc10: 47.5
        },
        "sky.1600": {
            contrast: 41.77899672977671,
            lc60: 100,
            lc45: 100,
            lc30: 76,
            lc10: 42.5
        },
        "sky.1700": {
            contrast: 46.787266101357766,
            lc60: 100,
            lc45: 96.5,
            lc30: 69,
            lc10: 39
        },
        "sky.1800": {
            contrast: 51.94311630378401,
            lc60: 100,
            lc45: 89,
            lc30: 64,
            lc10: 36
        },
        "sky.1900": {
            contrast: 57.3001345121219,
            lc60: 100,
            lc45: 82.5,
            lc30: 59,
            lc10: 33
        },
        "sky.2000": {
            contrast: 62.95926394920293,
            lc60: 96,
            lc45: 76.5,
            lc30: 55,
            lc10: 31
        },
        "sky.2100": {
            contrast: 68.97906509951916,
            lc60: 89.5,
            lc45: 71,
            lc30: 51.5,
            lc10: 29
        },
        "sky.2200": {
            contrast: 74.87811186148106,
            lc60: 84,
            lc45: 67.5,
            lc30: 48.5,
            lc10: 27.5
        },
        "sky.2300": {
            contrast: 80.84180435437399,
            lc60: 79,
            lc45: 63.5,
            lc30: 46.5,
            lc10: 26
        },
        "sky.2400": {
            contrast: 87.16754653310424,
            lc60: 75,
            lc45: 60.5,
            lc30: 43.5,
            lc10: 25
        },
        "sky.2500": {
            contrast: 93.54974352191925,
            lc60: 71.5,
            lc45: 57,
            lc30: 41.5,
            lc10: 23.5
        }
    },
    "sky.800": {
        "sky.100": {
            contrast: 20.40517670923636,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51
        },
        "sky.200": {
            contrast: 19.90589493546898,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61.5
        },
        "sky.300": {
            contrast: 18.293634724554074,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75
        },
        "sky.400": {
            contrast: 15.856301622781062,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93
        },
        "sky.500": {
            contrast: 12.469114544972692,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.600": {
            contrast: 7.712966279404795,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1000": {
            contrast: 9.136453471507103,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1100": {
            contrast: 12.489296086563137,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1200": {
            contrast: 17.42798803169265,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87
        },
        "sky.1300": {
            contrast: 22.556467659223202,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69.5
        },
        "sky.1400": {
            contrast: 26.997616853148333,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "sky.1500": {
            contrast: 31.626191021119865,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 52.5
        },
        "sky.1600": {
            contrast: 36.84717224161138,
            lc60: 100,
            lc45: 100,
            lc30: 84,
            lc10: 46.5
        },
        "sky.1700": {
            contrast: 41.85544161319243,
            lc60: 100,
            lc45: 100,
            lc30: 75.5,
            lc10: 42
        },
        "sky.1800": {
            contrast: 47.011291815618684,
            lc60: 100,
            lc45: 96.5,
            lc30: 69,
            lc10: 39
        },
        "sky.1900": {
            contrast: 52.368310023956575,
            lc60: 100,
            lc45: 88.5,
            lc30: 63.5,
            lc10: 35.5
        },
        "sky.2000": {
            contrast: 58.02743946103761,
            lc60: 100,
            lc45: 81.5,
            lc30: 58,
            lc10: 33
        },
        "sky.2100": {
            contrast: 64.04724061135386,
            lc60: 94.5,
            lc45: 75,
            lc30: 54,
            lc10: 30.5
        },
        "sky.2200": {
            contrast: 69.94628737331574,
            lc60: 88.5,
            lc45: 70.5,
            lc30: 51,
            lc10: 29
        },
        "sky.2300": {
            contrast: 75.90997986620867,
            lc60: 83.5,
            lc45: 66.5,
            lc30: 48,
            lc10: 27
        },
        "sky.2400": {
            contrast: 82.2357220449389,
            lc60: 78.5,
            lc45: 62.5,
            lc30: 45.5,
            lc10: 25.5
        },
        "sky.2500": {
            contrast: 88.61791903375395,
            lc60: 74,
            lc45: 59.5,
            lc30: 43,
            lc10: 24.5
        }
    },
    "sky.900": {
        "sky.100": {
            contrast: 25.241538044251115,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 41.5
        },
        "sky.200": {
            contrast: 24.74225627048374,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 48.5
        },
        "sky.300": {
            contrast: 23.129996059568832,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "sky.400": {
            contrast: 20.69266295779582,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "sky.500": {
            contrast: 17.30547587998745,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86.5
        },
        "sky.600": {
            contrast: 12.549327614419553,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.700": {
            contrast: 8.184989951310602,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1100": {
            contrast: 7.941490903165999,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1200": {
            contrast: 12.88018284829551,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1300": {
            contrast: 18.008662475826064,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84.5
        },
        "sky.1400": {
            contrast: 22.4498116697512,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "sky.1500": {
            contrast: 27.078385837722728,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "sky.1600": {
            contrast: 32.29936705821424,
            lc60: 100,
            lc45: 100,
            lc30: 93.5,
            lc10: 51
        },
        "sky.1700": {
            contrast: 37.3076364297953,
            lc60: 100,
            lc45: 100,
            lc30: 83,
            lc10: 46.5
        },
        "sky.1800": {
            contrast: 42.46348663222154,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 42
        },
        "sky.1900": {
            contrast: 47.820504840559444,
            lc60: 100,
            lc45: 95,
            lc30: 67.5,
            lc10: 38
        },
        "sky.2000": {
            contrast: 53.479634277640464,
            lc60: 100,
            lc45: 87,
            lc30: 62,
            lc10: 35
        },
        "sky.2100": {
            contrast: 59.499435427956705,
            lc60: 100,
            lc45: 79.5,
            lc30: 57,
            lc10: 32
        },
        "sky.2200": {
            contrast: 65.3984821899186,
            lc60: 93.5,
            lc45: 74.5,
            lc30: 53.5,
            lc10: 30
        },
        "sky.2300": {
            contrast: 71.36217468281151,
            lc60: 87,
            lc45: 69.5,
            lc30: 50,
            lc10: 28
        },
        "sky.2400": {
            contrast: 77.68791686154177,
            lc60: 81.5,
            lc45: 65,
            lc30: 47,
            lc10: 26.5
        },
        "sky.2500": {
            contrast: 84.0701138503568,
            lc60: 77,
            lc45: 61.5,
            lc30: 44.5,
            lc10: 25
        }
    },
    "sky.1000": {
        "sky.100": {
            contrast: 30.789975740814036,
            lc60: 100,
            lc45: 100,
            lc30: 83.5,
            lc10: 35
        },
        "sky.200": {
            contrast: 30.290693967046657,
            lc60: 100,
            lc45: 100,
            lc30: 96.5,
            lc10: 40
        },
        "sky.300": {
            contrast: 28.67843375613175,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 46.5
        },
        "sky.400": {
            contrast: 26.24110065435874,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54
        },
        "sky.500": {
            contrast: 22.853913576550376,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65
        },
        "sky.600": {
            contrast: 18.097765310982474,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83
        },
        "sky.700": {
            contrast: 13.733427647873524,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.800": {
            contrast: 8.380704403256651,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1200": {
            contrast: 7.530406484133222,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1300": {
            contrast: 12.658886111663778,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1400": {
            contrast: 17.10003530558891,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88
        },
        "sky.1500": {
            contrast: 21.728609473560443,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72.5
        },
        "sky.1600": {
            contrast: 26.94959069405195,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61
        },
        "sky.1700": {
            contrast: 31.95786006563301,
            lc60: 100,
            lc45: 100,
            lc30: 94.5,
            lc10: 52.5
        },
        "sky.1800": {
            contrast: 37.11371026805925,
            lc60: 100,
            lc45: 100,
            lc30: 83.5,
            lc10: 46.5
        },
        "sky.1900": {
            contrast: 42.470728476397156,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 41.5
        },
        "sky.2000": {
            contrast: 48.12985791347817,
            lc60: 100,
            lc45: 94.5,
            lc30: 67.5,
            lc10: 37.5
        },
        "sky.2100": {
            contrast: 54.14965906379442,
            lc60: 100,
            lc45: 85.5,
            lc30: 62,
            lc10: 34
        },
        "sky.2200": {
            contrast: 60.04870582575631,
            lc60: 99.5,
            lc45: 79.5,
            lc30: 57,
            lc10: 31.5
        },
        "sky.2300": {
            contrast: 66.01239831864925,
            lc60: 92.5,
            lc45: 74,
            lc30: 53,
            lc10: 30
        },
        "sky.2400": {
            contrast: 72.33814049737947,
            lc60: 86.5,
            lc45: 69,
            lc30: 49.5,
            lc10: 28.5
        },
        "sky.2500": {
            contrast: 78.72033748619451,
            lc60: 81,
            lc45: 64.5,
            lc30: 47,
            lc10: 27
        }
    },
    "sky.1100": {
        "sky.100": {
            contrast: 34.174085101830954,
            lc60: 100,
            lc45: 100,
            lc30: 68,
            lc10: 31.5
        },
        "sky.200": {
            contrast: 33.674803328063575,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 36.5
        },
        "sky.300": {
            contrast: 32.062543117148664,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 41.5
        },
        "sky.400": {
            contrast: 29.625210015375657,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 48
        },
        "sky.500": {
            contrast: 26.23802293756729,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "sky.600": {
            contrast: 21.481874671999392,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "sky.700": {
            contrast: 17.117537008890444,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88
        },
        "sky.800": {
            contrast: 11.764813764273569,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1300": {
            contrast: 9.33368065342138,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1400": {
            contrast: 13.774829847346512,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1500": {
            contrast: 18.403404015318046,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83.5
        },
        "sky.1600": {
            contrast: 23.624385235809562,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66.5
        },
        "sky.1700": {
            contrast: 28.632654607390613,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "sky.1800": {
            contrast: 33.78850480981686,
            lc60: 100,
            lc45: 100,
            lc30: 90,
            lc10: 49
        },
        "sky.1900": {
            contrast: 39.14552301815476,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 43.5
        },
        "sky.2000": {
            contrast: 44.804652455235775,
            lc60: 100,
            lc45: 100,
            lc30: 71.5,
            lc10: 38.5
        },
        "sky.2100": {
            contrast: 50.82445360555202,
            lc60: 100,
            lc45: 90.5,
            lc30: 64.5,
            lc10: 35
        },
        "sky.2200": {
            contrast: 56.723500367513914,
            lc60: 100,
            lc45: 83,
            lc30: 59,
            lc10: 32.5
        },
        "sky.2300": {
            contrast: 62.68719286040684,
            lc60: 96.5,
            lc45: 77,
            lc30: 54.5,
            lc10: 30.5
        },
        "sky.2400": {
            contrast: 69.01293503913709,
            lc60: 89,
            lc45: 71,
            lc30: 50.5,
            lc10: 28
        },
        "sky.2500": {
            contrast: 75.39513202795212,
            lc60: 83.5,
            lc45: 66.5,
            lc30: 47.5,
            lc10: 26
        }
    },
    "sky.1200": {
        "sky.100": {
            contrast: 39.10693439076658,
            lc60: 100,
            lc45: 100,
            lc30: 57,
            lc10: 28
        },
        "sky.200": {
            contrast: 38.60765261699921,
            lc60: 100,
            lc45: 100,
            lc30: 64.5,
            lc10: 31.5
        },
        "sky.300": {
            contrast: 36.99539240608431,
            lc60: 100,
            lc45: 100,
            lc30: 73,
            lc10: 35.5
        },
        "sky.400": {
            contrast: 34.55805930431129,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 40.5
        },
        "sky.500": {
            contrast: 31.170872226502922,
            lc60: 100,
            lc45: 100,
            lc30: 95.5,
            lc10: 47
        },
        "sky.600": {
            contrast: 26.414723960935028,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56
        },
        "sky.700": {
            contrast: 22.050386297826073,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "sky.800": {
            contrast: 16.6976630532092,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89.5
        },
        "sky.900": {
            contrast: 11.888780393295361,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1400": {
            contrast: 8.85113955721624,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1500": {
            contrast: 13.479713725187773,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1600": {
            contrast: 18.700694945679285,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82.5
        },
        "sky.1700": {
            contrast: 23.708964317260342,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "sky.1800": {
            contrast: 28.864814519686583,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "sky.1900": {
            contrast: 34.22183272802449,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 48.5
        },
        "sky.2000": {
            contrast: 39.8809621651055,
            lc60: 100,
            lc45: 100,
            lc30: 77.5,
            lc10: 42.5
        },
        "sky.2100": {
            contrast: 45.90076331542175,
            lc60: 100,
            lc45: 98,
            lc30: 69.5,
            lc10: 38.5
        },
        "sky.2200": {
            contrast: 51.79981007738365,
            lc60: 100,
            lc45: 88.5,
            lc30: 63.5,
            lc10: 34.5
        },
        "sky.2300": {
            contrast: 57.76350257027657,
            lc60: 100,
            lc45: 81,
            lc30: 58,
            lc10: 31.5
        },
        "sky.2400": {
            contrast: 64.08924474900681,
            lc60: 94.5,
            lc45: 74.5,
            lc30: 53.5,
            lc10: 29.5
        },
        "sky.2500": {
            contrast: 70.47144173782185,
            lc60: 87.5,
            lc45: 69,
            lc30: 49.5,
            lc10: 27.5
        }
    },
    "sky.1300": {
        "sky.100": {
            contrast: 44.17133883222164,
            lc60: 100,
            lc45: 100,
            lc30: 51,
            lc10: 25.5
        },
        "sky.200": {
            contrast: 43.672057058454264,
            lc60: 100,
            lc45: 100,
            lc30: 56.5,
            lc10: 28.5
        },
        "sky.300": {
            contrast: 42.05979684753936,
            lc60: 100,
            lc45: 100,
            lc30: 63,
            lc10: 31.5
        },
        "sky.400": {
            contrast: 39.62246374576635,
            lc60: 100,
            lc45: 100,
            lc30: 70.5,
            lc10: 35.5
        },
        "sky.500": {
            contrast: 36.23527666795798,
            lc60: 100,
            lc45: 100,
            lc30: 80.5,
            lc10: 40.5
        },
        "sky.600": {
            contrast: 31.479128402390078,
            lc60: 100,
            lc45: 100,
            lc30: 94,
            lc10: 47.5
        },
        "sky.700": {
            contrast: 27.11479073928113,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "sky.800": {
            contrast: 21.76206749466426,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "sky.900": {
            contrast: 16.95318483475042,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89.5
        },
        "sky.1000": {
            contrast: 11.420890419857724,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1100": {
            contrast: 8.039526857141329,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1500": {
            contrast: 8.337617214292242,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1600": {
            contrast: 13.558598434783756,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1700": {
            contrast: 18.56686780636481,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82
        },
        "sky.1800": {
            contrast: 23.72271800879106,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "sky.1900": {
            contrast: 29.079736217128954,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "sky.2000": {
            contrast: 34.738865654209974,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 47.5
        },
        "sky.2100": {
            contrast: 40.75866680452622,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 41.5
        },
        "sky.2200": {
            contrast: 46.65771356648811,
            lc60: 100,
            lc45: 96.5,
            lc30: 68.5,
            lc10: 37.5
        },
        "sky.2300": {
            contrast: 52.62140605938104,
            lc60: 100,
            lc45: 88,
            lc30: 62,
            lc10: 34
        },
        "sky.2400": {
            contrast: 58.94714823811128,
            lc60: 100,
            lc45: 79.5,
            lc30: 57,
            lc10: 31
        },
        "sky.2500": {
            contrast: 65.32934522692632,
            lc60: 93,
            lc45: 73.5,
            lc30: 52.5,
            lc10: 29
        }
    },
    "sky.1400": {
        "sky.100": {
            contrast: 48.5145612995213,
            lc60: 100,
            lc45: 76,
            lc30: 46,
            lc10: 23.5
        },
        "sky.200": {
            contrast: 48.01527952575392,
            lc60: 100,
            lc45: 84,
            lc30: 51,
            lc10: 26
        },
        "sky.300": {
            contrast: 46.403019314839014,
            lc60: 100,
            lc45: 93,
            lc30: 56.5,
            lc10: 28.5
        },
        "sky.400": {
            contrast: 43.965686213066,
            lc60: 100,
            lc45: 100,
            lc30: 62.5,
            lc10: 32
        },
        "sky.500": {
            contrast: 40.57849913525763,
            lc60: 100,
            lc45: 100,
            lc30: 70.5,
            lc10: 35.5
        },
        "sky.600": {
            contrast: 35.822350869689735,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 40.5
        },
        "sky.700": {
            contrast: 31.45801320658078,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 46.5
        },
        "sky.800": {
            contrast: 26.105289961963912,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "sky.900": {
            contrast: 21.29640730205007,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "sky.1000": {
            contrast: 15.764112887157374,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 96
        },
        "sky.1100": {
            contrast: 12.382749324440978,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1200": {
            contrast: 7.445299141244038,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1600": {
            contrast: 9.083961119813793,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1700": {
            contrast: 14.092230491394849,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1800": {
            contrast: 19.248080693821095,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79.5
        },
        "sky.1900": {
            contrast: 24.605098902158993,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "sky.2000": {
            contrast: 30.264228339240013,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 53.5
        },
        "sky.2100": {
            contrast: 36.28402948955626,
            lc60: 100,
            lc45: 100,
            lc30: 85,
            lc10: 46
        },
        "sky.2200": {
            contrast: 42.183076251518145,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 40.5
        },
        "sky.2300": {
            contrast: 48.146768744411084,
            lc60: 100,
            lc45: 94,
            lc30: 66.5,
            lc10: 36.5
        },
        "sky.2400": {
            contrast: 54.472510923141314,
            lc60: 100,
            lc45: 85.5,
            lc30: 60.5,
            lc10: 33.5
        },
        "sky.2500": {
            contrast: 60.85470791195635,
            lc60: 98.5,
            lc45: 77.5,
            lc30: 55.5,
            lc10: 30.5
        }
    },
    "sky.1500": {
        "sky.100": {
            contrast: 53.00330625892802,
            lc60: 100,
            lc45: 66.5,
            lc30: 42.5,
            lc10: 21.5
        },
        "sky.200": {
            contrast: 52.50402448516064,
            lc60: 100,
            lc45: 73.5,
            lc30: 46.5,
            lc10: 23.5
        },
        "sky.300": {
            contrast: 50.89176427424573,
            lc60: 100,
            lc45: 80.5,
            lc30: 51,
            lc10: 26
        },
        "sky.400": {
            contrast: 48.454431172472724,
            lc60: 100,
            lc45: 89,
            lc30: 56.5,
            lc10: 28.5
        },
        "sky.500": {
            contrast: 45.067244094664346,
            lc60: 100,
            lc45: 99.5,
            lc30: 63,
            lc10: 31.5
        },
        "sky.600": {
            contrast: 40.31109582909645,
            lc60: 100,
            lc45: 100,
            lc30: 72,
            lc10: 35.5
        },
        "sky.700": {
            contrast: 35.946758165987504,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 40.5
        },
        "sky.800": {
            contrast: 30.59403492137062,
            lc60: 100,
            lc45: 100,
            lc30: 97.5,
            lc10: 48.5
        },
        "sky.900": {
            contrast: 25.78515226145679,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58
        },
        "sky.1000": {
            contrast: 20.252857846564094,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "sky.1100": {
            contrast: 16.8714942838477,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88.5
        },
        "sky.1200": {
            contrast: 11.934044100650757,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1700": {
            contrast: 9.409176955918861,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1800": {
            contrast: 14.565027158345107,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1900": {
            contrast: 19.922045366683005,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77
        },
        "sky.2000": {
            contrast: 25.58117480376402,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61.5
        },
        "sky.2100": {
            contrast: 31.60097595408027,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 51.5
        },
        "sky.2200": {
            contrast: 37.50002271604216,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 45
        },
        "sky.2300": {
            contrast: 43.46371520893509,
            lc60: 100,
            lc45: 100,
            lc30: 72.5,
            lc10: 40
        },
        "sky.2400": {
            contrast: 49.78945738766534,
            lc60: 100,
            lc45: 91.5,
            lc30: 65,
            lc10: 36
        },
        "sky.2500": {
            contrast: 56.17165437648036,
            lc60: 100,
            lc45: 83,
            lc30: 59,
            lc10: 32.5
        }
    },
    "sky.1600": {
        "sky.100": {
            contrast: 58.02450320770176,
            lc60: 100,
            lc45: 60,
            lc30: 39,
            lc10: 19.5
        },
        "sky.200": {
            contrast: 57.52522143393437,
            lc60: 100,
            lc45: 66,
            lc30: 42.5,
            lc10: 21.5
        },
        "sky.300": {
            contrast: 55.91296122301947,
            lc60: 100,
            lc45: 72,
            lc30: 46.5,
            lc10: 23.5
        },
        "sky.400": {
            contrast: 53.475628121246466,
            lc60: 100,
            lc45: 79,
            lc30: 50.5,
            lc10: 26
        },
        "sky.500": {
            contrast: 50.088441043438095,
            lc60: 100,
            lc45: 87,
            lc30: 55.5,
            lc10: 28.5
        },
        "sky.600": {
            contrast: 45.332292777870194,
            lc60: 100,
            lc45: 99.5,
            lc30: 62.5,
            lc10: 31.5
        },
        "sky.700": {
            contrast: 40.967955114761246,
            lc60: 100,
            lc45: 100,
            lc30: 70.5,
            lc10: 35.5
        },
        "sky.800": {
            contrast: 35.61523187014436,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 41.5
        },
        "sky.900": {
            contrast: 30.806349210230533,
            lc60: 100,
            lc45: 100,
            lc30: 96.5,
            lc10: 48.5
        },
        "sky.1000": {
            contrast: 25.274054795337836,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59
        },
        "sky.1100": {
            contrast: 21.89269123262144,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "sky.1200": {
            contrast: 16.9552410494245,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88
        },
        "sky.1300": {
            contrast: 11.876481245443346,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1400": {
            contrast: 7.51388196494123,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1800": {
            contrast: 9.260515844566703,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1900": {
            contrast: 14.617534052904603,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2000": {
            contrast: 20.276663489985623,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76
        },
        "sky.2100": {
            contrast: 26.296464640301863,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61
        },
        "sky.2200": {
            contrast: 32.195511402263755,
            lc60: 100,
            lc45: 100,
            lc30: 93.5,
            lc10: 51.5
        },
        "sky.2300": {
            contrast: 38.15920389515669,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 45
        },
        "sky.2400": {
            contrast: 44.484946073886924,
            lc60: 100,
            lc45: 100,
            lc30: 71.5,
            lc10: 39.5
        },
        "sky.2500": {
            contrast: 50.867143062701956,
            lc60: 100,
            lc45: 90,
            lc30: 64,
            lc10: 35
        }
    },
    "sky.1700": {
        "sky.100": {
            contrast: 62.8028794055255,
            lc60: 82,
            lc45: 55.5,
            lc30: 36,
            lc10: 18
        },
        "sky.200": {
            contrast: 62.3035976317581,
            lc60: 89,
            lc45: 60.5,
            lc30: 39,
            lc10: 20
        },
        "sky.300": {
            contrast: 60.691337420843205,
            lc60: 97,
            lc45: 65.5,
            lc30: 42.5,
            lc10: 21.5
        },
        "sky.400": {
            contrast: 58.2540043190702,
            lc60: 100,
            lc45: 71,
            lc30: 45.5,
            lc10: 23.5
        },
        "sky.500": {
            contrast: 54.86681724126182,
            lc60: 100,
            lc45: 78,
            lc30: 50,
            lc10: 26
        },
        "sky.600": {
            contrast: 50.110668975693926,
            lc60: 100,
            lc45: 87.5,
            lc30: 56,
            lc10: 28
        },
        "sky.700": {
            contrast: 45.74633131258498,
            lc60: 100,
            lc45: 97.5,
            lc30: 62.5,
            lc10: 31.5
        },
        "sky.800": {
            contrast: 40.3936080679681,
            lc60: 100,
            lc45: 100,
            lc30: 72,
            lc10: 36
        },
        "sky.900": {
            contrast: 35.58472540805426,
            lc60: 100,
            lc45: 100,
            lc30: 83,
            lc10: 41.5
        },
        "sky.1000": {
            contrast: 30.052430993161565,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 49.5
        },
        "sky.1100": {
            contrast: 26.671067430445174,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "sky.1200": {
            contrast: 21.733617247248233,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69.5
        },
        "sky.1300": {
            contrast: 16.65485744326708,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 90.5
        },
        "sky.1400": {
            contrast: 12.292258162764961,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1500": {
            contrast: 7.777185997545259,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1900": {
            contrast: 9.50881585399975,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2000": {
            contrast: 15.16794529108077,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98
        },
        "sky.2100": {
            contrast: 21.187746441397014,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "sky.2200": {
            contrast: 27.086793203358905,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "sky.2300": {
            contrast: 33.05048569625183,
            lc60: 100,
            lc45: 100,
            lc30: 91,
            lc10: 50.5
        },
        "sky.2400": {
            contrast: 39.37622787498207,
            lc60: 100,
            lc45: 100,
            lc30: 79,
            lc10: 43
        },
        "sky.2500": {
            contrast: 45.75842486379711,
            lc60: 100,
            lc45: 98,
            lc30: 69.5,
            lc10: 38
        }
    },
    "sky.1800": {
        "sky.100": {
            contrast: 67.68620284112733,
            lc60: 72,
            lc45: 51,
            lc30: 33,
            lc10: 17
        },
        "sky.200": {
            contrast: 67.18692106735993,
            lc60: 78,
            lc45: 55.5,
            lc30: 36,
            lc10: 18.5
        },
        "sky.300": {
            contrast: 65.57466085644504,
            lc60: 84.5,
            lc45: 60,
            lc30: 39,
            lc10: 20
        },
        "sky.400": {
            contrast: 63.13732775467202,
            lc60: 91.5,
            lc45: 65,
            lc30: 42,
            lc10: 21.5
        },
        "sky.500": {
            contrast: 59.75014067686365,
            lc60: 100,
            lc45: 70.5,
            lc30: 45.5,
            lc10: 23.5
        },
        "sky.600": {
            contrast: 54.99399241129576,
            lc60: 100,
            lc45: 78,
            lc30: 50.5,
            lc10: 26
        },
        "sky.700": {
            contrast: 50.6296547481868,
            lc60: 100,
            lc45: 86.5,
            lc30: 56,
            lc10: 28
        },
        "sky.800": {
            contrast: 45.27693150356993,
            lc60: 100,
            lc45: 99.5,
            lc30: 63.5,
            lc10: 32
        },
        "sky.900": {
            contrast: 40.4680488436561,
            lc60: 100,
            lc45: 100,
            lc30: 71.5,
            lc10: 36.5
        },
        "sky.1000": {
            contrast: 34.935754428763396,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 41.5
        },
        "sky.1100": {
            contrast: 31.554390866047,
            lc60: 100,
            lc45: 100,
            lc30: 94.5,
            lc10: 47.5
        },
        "sky.1200": {
            contrast: 26.61694068285006,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "sky.1300": {
            contrast: 21.53818087886891,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70.5
        },
        "sky.1400": {
            contrast: 17.175581598366794,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87.5
        },
        "sky.1500": {
            contrast: 12.66050943314709,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1600": {
            contrast: 7.602836130106433,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2000": {
            contrast: 9.889412533567329,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2100": {
            contrast: 15.909213683883575,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 94
        },
        "sky.2200": {
            contrast: 21.808260445845466,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72.5
        },
        "sky.2300": {
            contrast: 27.77195293873839,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59
        },
        "sky.2400": {
            contrast: 34.09769511746863,
            lc60: 100,
            lc45: 100,
            lc30: 89,
            lc10: 49
        },
        "sky.2500": {
            contrast: 40.479892106283664,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 42
        }
    },
    "sky.1900": {
        "sky.100": {
            contrast: 72.72453441078027,
            lc60: 66.5,
            lc45: 47.5,
            lc30: 31,
            lc10: 16
        },
        "sky.200": {
            contrast: 72.22525263701287,
            lc60: 71.5,
            lc45: 51,
            lc30: 33.5,
            lc10: 17.5
        },
        "sky.300": {
            contrast: 70.61299242609796,
            lc60: 76.5,
            lc45: 55,
            lc30: 36,
            lc10: 18.5
        },
        "sky.400": {
            contrast: 68.17565932432495,
            lc60: 83,
            lc45: 59,
            lc30: 38.5,
            lc10: 19.5
        },
        "sky.500": {
            contrast: 64.78847224651658,
            lc60: 90,
            lc45: 64,
            lc30: 41.5,
            lc10: 21.5
        },
        "sky.600": {
            contrast: 60.03232398094869,
            lc60: 99.5,
            lc45: 70.5,
            lc30: 45.5,
            lc10: 23.5
        },
        "sky.700": {
            contrast: 55.667986317839734,
            lc60: 100,
            lc45: 77.5,
            lc30: 50,
            lc10: 26
        },
        "sky.800": {
            contrast: 50.31526307322286,
            lc60: 100,
            lc45: 87.5,
            lc30: 56,
            lc10: 28.5
        },
        "sky.900": {
            contrast: 45.506380413309024,
            lc60: 100,
            lc45: 98,
            lc30: 62.5,
            lc10: 32
        },
        "sky.1000": {
            contrast: 39.97408599841633,
            lc60: 100,
            lc45: 100,
            lc30: 72,
            lc10: 37
        },
        "sky.1100": {
            contrast: 36.59272243569993,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 40.5
        },
        "sky.1200": {
            contrast: 31.655272252502993,
            lc60: 100,
            lc45: 100,
            lc30: 94.5,
            lc10: 47.5
        },
        "sky.1300": {
            contrast: 26.57651244852184,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "sky.1400": {
            contrast: 22.213913168019722,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "sky.1500": {
            contrast: 17.69884100280002,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85
        },
        "sky.1600": {
            contrast: 12.641167699759364,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1700": {
            contrast: 7.821678931058876,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2100": {
            contrast: 10.405424443020955,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2200": {
            contrast: 16.304471204982846,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 94
        },
        "sky.2300": {
            contrast: 22.268163697875774,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "sky.2400": {
            contrast: 28.593905876606012,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "sky.2500": {
            contrast: 34.97610286542105,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 48
        }
    },
    "sky.2000": {
        "sky.100": {
            contrast: 78.01065618060473,
            lc60: 61,
            lc45: 44.5,
            lc30: 29,
            lc10: 15
        },
        "sky.200": {
            contrast: 77.51137440683733,
            lc60: 65.5,
            lc45: 47,
            lc30: 31,
            lc10: 16
        },
        "sky.300": {
            contrast: 75.89911419592244,
            lc60: 70.5,
            lc45: 51,
            lc30: 33.5,
            lc10: 17.5
        },
        "sky.400": {
            contrast: 73.46178109414943,
            lc60: 75.5,
            lc45: 54,
            lc30: 35.5,
            lc10: 18.5
        },
        "sky.500": {
            contrast: 70.07459401634105,
            lc60: 81,
            lc45: 58.5,
            lc30: 38.5,
            lc10: 19.5
        },
        "sky.600": {
            contrast: 65.31844575077315,
            lc60: 89,
            lc45: 64,
            lc30: 41.5,
            lc10: 21.5
        },
        "sky.700": {
            contrast: 60.954108087664196,
            lc60: 98,
            lc45: 69.5,
            lc30: 45,
            lc10: 23.5
        },
        "sky.800": {
            contrast: 55.60138484304733,
            lc60: 100,
            lc45: 77.5,
            lc30: 50,
            lc10: 25.5
        },
        "sky.900": {
            contrast: 50.79250218313349,
            lc60: 100,
            lc45: 86,
            lc30: 55.5,
            lc10: 28.5
        },
        "sky.1000": {
            contrast: 45.26020776824079,
            lc60: 100,
            lc45: 99,
            lc30: 63,
            lc10: 32
        },
        "sky.1100": {
            contrast: 41.878844205524395,
            lc60: 100,
            lc45: 100,
            lc30: 69,
            lc10: 35
        },
        "sky.1200": {
            contrast: 36.94139402232746,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 40.5
        },
        "sky.1300": {
            contrast: 31.862634218346304,
            lc60: 100,
            lc45: 100,
            lc30: 94.5,
            lc10: 47.5
        },
        "sky.1400": {
            contrast: 27.500034937844188,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "sky.1500": {
            contrast: 22.98496277262449,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "sky.1600": {
            contrast: 17.92728946958383,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84.5
        },
        "sky.1700": {
            contrast: 13.10780070088334,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1800": {
            contrast: 8.176451999839793,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2200": {
            contrast: 10.470338243665692,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2300": {
            contrast: 16.434030736558622,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 92.5
        },
        "sky.2400": {
            contrast: 22.759772915288863,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "sky.2500": {
            contrast: 29.14196990410389,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        }
    },
    "sky.2100": {
        "sky.100": {
            contrast: 83.59573246170248,
            lc60: 56.5,
            lc45: 41,
            lc30: 27.5,
            lc10: 14
        },
        "sky.200": {
            contrast: 83.09645068793509,
            lc60: 60.5,
            lc45: 44,
            lc30: 29,
            lc10: 15
        },
        "sky.300": {
            contrast: 81.48419047702019,
            lc60: 64.5,
            lc45: 47,
            lc30: 31,
            lc10: 16
        },
        "sky.400": {
            contrast: 79.04685737524719,
            lc60: 68.5,
            lc45: 50,
            lc30: 32.5,
            lc10: 17
        },
        "sky.500": {
            contrast: 75.65967029743881,
            lc60: 74,
            lc45: 53.5,
            lc30: 35,
            lc10: 18
        },
        "sky.600": {
            contrast: 70.9035220318709,
            lc60: 80.5,
            lc45: 58,
            lc30: 38,
            lc10: 19.5
        },
        "sky.700": {
            contrast: 66.53918436876197,
            lc60: 87.5,
            lc45: 63,
            lc30: 41,
            lc10: 21
        },
        "sky.800": {
            contrast: 61.186461124145076,
            lc60: 97,
            lc45: 69,
            lc30: 44.5,
            lc10: 23
        },
        "sky.900": {
            contrast: 56.37757846423125,
            lc60: 100,
            lc45: 76,
            lc30: 49.5,
            lc10: 25
        },
        "sky.1000": {
            contrast: 50.845284049338545,
            lc60: 100,
            lc45: 85.5,
            lc30: 54.5,
            lc10: 28
        },
        "sky.1100": {
            contrast: 47.46392048662214,
            lc60: 100,
            lc45: 94,
            lc30: 60.5,
            lc10: 31
        },
        "sky.1200": {
            contrast: 42.526470303425214,
            lc60: 100,
            lc45: 100,
            lc30: 68,
            lc10: 35
        },
        "sky.1300": {
            contrast: 37.44771049944406,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 40
        },
        "sky.1400": {
            contrast: 33.08511121894194,
            lc60: 100,
            lc45: 100,
            lc30: 89.5,
            lc10: 46
        },
        "sky.1500": {
            contrast: 28.570039053722233,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53.5
        },
        "sky.1600": {
            contrast: 23.51236575068158,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65.5
        },
        "sky.1700": {
            contrast: 18.692876981981094,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81.5
        },
        "sky.1800": {
            contrast: 13.761528280937549,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1900": {
            contrast: 8.667685075665933,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2300": {
            contrast: 10.207027135643521,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2400": {
            contrast: 16.53276931437376,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 92.5
        },
        "sky.2500": {
            contrast: 22.91496630318879,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        }
    },
    "sky.2200": {
        "sky.100": {
            contrast: 89.03354985546635,
            lc60: 53,
            lc45: 38.5,
            lc30: 25.5,
            lc10: 13.5
        },
        "sky.200": {
            contrast: 88.53426808169897,
            lc60: 56,
            lc45: 41,
            lc30: 27.5,
            lc10: 14.5
        },
        "sky.300": {
            contrast: 86.92200787078406,
            lc60: 60,
            lc45: 43.5,
            lc30: 28.5,
            lc10: 15
        },
        "sky.400": {
            contrast: 84.48467476901105,
            lc60: 63.5,
            lc45: 46,
            lc30: 30.5,
            lc10: 16
        },
        "sky.500": {
            contrast: 81.09748769120269,
            lc60: 67.5,
            lc45: 49.5,
            lc30: 32.5,
            lc10: 17
        },
        "sky.600": {
            contrast: 76.34133942563479,
            lc60: 73.5,
            lc45: 53,
            lc30: 35,
            lc10: 18
        },
        "sky.700": {
            contrast: 71.97700176252584,
            lc60: 79,
            lc45: 57,
            lc30: 37.5,
            lc10: 19.5
        },
        "sky.800": {
            contrast: 66.62427851790895,
            lc60: 87,
            lc45: 62.5,
            lc30: 40.5,
            lc10: 21
        },
        "sky.900": {
            contrast: 61.815395857995114,
            lc60: 96,
            lc45: 68,
            lc30: 44.5,
            lc10: 22.5
        },
        "sky.1000": {
            contrast: 56.283101443102424,
            lc60: 100,
            lc45: 76,
            lc30: 49,
            lc10: 25
        },
        "sky.1100": {
            contrast: 52.90173788038602,
            lc60: 100,
            lc45: 82,
            lc30: 53,
            lc10: 27.5
        },
        "sky.1200": {
            contrast: 47.96428769718909,
            lc60: 100,
            lc45: 92.5,
            lc30: 60,
            lc10: 30.5
        },
        "sky.1300": {
            contrast: 42.88552789320793,
            lc60: 100,
            lc45: 100,
            lc30: 68,
            lc10: 35
        },
        "sky.1400": {
            contrast: 38.52292861270581,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 39.5
        },
        "sky.1500": {
            contrast: 34.00785644748611,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 45
        },
        "sky.1600": {
            contrast: 28.95018314444545,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 52
        },
        "sky.1700": {
            contrast: 24.13069437574497,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "sky.1800": {
            contrast: 19.199345674701423,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78.5
        },
        "sky.1900": {
            contrast: 14.105502469429808,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2000": {
            contrast: 8.755031533052625,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2400": {
            contrast: 10.410945831755496,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2500": {
            contrast: 16.79314282057053,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89.5
        }
    },
    "sky.2300": {
        "sky.100": {
            contrast: 94.49794161093563,
            lc60: 50,
            lc45: 36.5,
            lc30: 24,
            lc10: 12.5
        },
        "sky.200": {
            contrast: 93.99865983716825,
            lc60: 52.5,
            lc45: 38.5,
            lc30: 25.5,
            lc10: 13.5
        },
        "sky.300": {
            contrast: 92.38639962625335,
            lc60: 55.5,
            lc45: 41,
            lc30: 27,
            lc10: 14.5
        },
        "sky.400": {
            contrast: 89.94906652448033,
            lc60: 59,
            lc45: 43,
            lc30: 28.5,
            lc10: 15
        },
        "sky.500": {
            contrast: 86.56187944667197,
            lc60: 62.5,
            lc45: 45.5,
            lc30: 30.5,
            lc10: 16
        },
        "sky.600": {
            contrast: 81.80573118110405,
            lc60: 67,
            lc45: 49,
            lc30: 32.5,
            lc10: 17
        },
        "sky.700": {
            contrast: 77.44139351799511,
            lc60: 72,
            lc45: 52.5,
            lc30: 34,
            lc10: 18
        },
        "sky.800": {
            contrast: 72.08867027337823,
            lc60: 78.5,
            lc45: 57,
            lc30: 37.5,
            lc10: 19.5
        },
        "sky.900": {
            contrast: 67.27978761346439,
            lc60: 85.5,
            lc45: 61.5,
            lc30: 40.5,
            lc10: 20.5
        },
        "sky.1000": {
            contrast: 61.7474931985717,
            lc60: 96,
            lc45: 67.5,
            lc30: 44,
            lc10: 22.5
        },
        "sky.1100": {
            contrast: 58.366129635855316,
            lc60: 100,
            lc45: 73,
            lc30: 47.5,
            lc10: 24.5
        },
        "sky.1200": {
            contrast: 53.428679452658365,
            lc60: 100,
            lc45: 81.5,
            lc30: 53,
            lc10: 27.5
        },
        "sky.1300": {
            contrast: 48.34991964867721,
            lc60: 100,
            lc45: 91.5,
            lc30: 59,
            lc10: 30.5
        },
        "sky.1400": {
            contrast: 43.98732036817509,
            lc60: 100,
            lc45: 100,
            lc30: 66,
            lc10: 34
        },
        "sky.1500": {
            contrast: 39.47224820295539,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 38
        },
        "sky.1600": {
            contrast: 34.41457489991473,
            lc60: 100,
            lc45: 100,
            lc30: 86,
            lc10: 44
        },
        "sky.1700": {
            contrast: 29.595086131214245,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51
        },
        "sky.1800": {
            contrast: 24.663737430170706,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61.5
        },
        "sky.1900": {
            contrast: 19.569894224899087,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77.5
        },
        "sky.2000": {
            contrast: 14.219423288521904,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2100": {
            contrast: 8.559975567535291,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2500": {
            contrast: 10.585563856697522,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "sky.2400": {
        "sky.100": {
            contrast: 100.26016319661417,
            lc60: 46.5,
            lc45: 34.5,
            lc30: 23,
            lc10: 12
        },
        "sky.200": {
            contrast: 99.76088142284677,
            lc60: 49,
            lc45: 36,
            lc30: 24,
            lc10: 12.5
        },
        "sky.300": {
            contrast: 98.14862121193187,
            lc60: 52,
            lc45: 38,
            lc30: 25.5,
            lc10: 13.5
        },
        "sky.400": {
            contrast: 95.71128811015886,
            lc60: 54.5,
            lc45: 40,
            lc30: 27,
            lc10: 14
        },
        "sky.500": {
            contrast: 92.3241010323505,
            lc60: 58,
            lc45: 42.5,
            lc30: 28,
            lc10: 14.5
        },
        "sky.600": {
            contrast: 87.5679527667826,
            lc60: 62,
            lc45: 45.5,
            lc30: 30,
            lc10: 16
        },
        "sky.700": {
            contrast: 83.20361510367364,
            lc60: 65.5,
            lc45: 48,
            lc30: 32,
            lc10: 16.5
        },
        "sky.800": {
            contrast: 77.85089185905677,
            lc60: 72,
            lc45: 52,
            lc30: 34.5,
            lc10: 18
        },
        "sky.900": {
            contrast: 73.04200919914294,
            lc60: 77.5,
            lc45: 56,
            lc30: 36.5,
            lc10: 19
        },
        "sky.1000": {
            contrast: 67.50971478425024,
            lc60: 85,
            lc45: 61,
            lc30: 39.5,
            lc10: 20.5
        },
        "sky.1100": {
            contrast: 64.12835122153383,
            lc60: 92,
            lc45: 65.5,
            lc30: 43,
            lc10: 22
        },
        "sky.1200": {
            contrast: 59.190901038336904,
            lc60: 100,
            lc45: 72.5,
            lc30: 47.5,
            lc10: 24.5
        },
        "sky.1300": {
            contrast: 54.11214123435575,
            lc60: 100,
            lc45: 80.5,
            lc30: 52.5,
            lc10: 27
        },
        "sky.1400": {
            contrast: 49.74954195385363,
            lc60: 100,
            lc45: 89,
            lc30: 57,
            lc10: 30
        },
        "sky.1500": {
            contrast: 45.23446978863393,
            lc60: 100,
            lc45: 99,
            lc30: 63.5,
            lc10: 33.5
        },
        "sky.1600": {
            contrast: 40.17679648559327,
            lc60: 100,
            lc45: 100,
            lc30: 73,
            lc10: 37.5
        },
        "sky.1700": {
            contrast: 35.357307716892784,
            lc60: 100,
            lc45: 100,
            lc30: 84,
            lc10: 42.5
        },
        "sky.1800": {
            contrast: 30.425959015849237,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 50
        },
        "sky.1900": {
            contrast: 25.332115810577623,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60.5
        },
        "sky.2000": {
            contrast: 19.98164487420044,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77
        },
        "sky.2100": {
            contrast: 14.322197153213828,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2200": {
            contrast: 8.806036006423868,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "sky.2500": {
        "sky.100": {
            contrast: 106.04067321268862,
            lc60: 44,
            lc45: 32.5,
            lc30: 21.5,
            lc10: 11.5
        },
        "sky.200": {
            contrast: 105.54139143892122,
            lc60: 46,
            lc45: 34,
            lc30: 23,
            lc10: 12
        },
        "sky.300": {
            contrast: 103.92913122800631,
            lc60: 48.5,
            lc45: 36,
            lc30: 24,
            lc10: 12.5
        },
        "sky.400": {
            contrast: 101.4917981262333,
            lc60: 51,
            lc45: 37.5,
            lc30: 25,
            lc10: 13
        },
        "sky.500": {
            contrast: 98.10461104842493,
            lc60: 54,
            lc45: 39.5,
            lc30: 26.5,
            lc10: 14
        },
        "sky.600": {
            contrast: 93.34846278285703,
            lc60: 57.5,
            lc45: 42,
            lc30: 28,
            lc10: 14.5
        },
        "sky.700": {
            contrast: 88.98412511974807,
            lc60: 61,
            lc45: 44.5,
            lc30: 29.5,
            lc10: 15.5
        },
        "sky.800": {
            contrast: 83.63140187513119,
            lc60: 65.5,
            lc45: 47.5,
            lc30: 31.5,
            lc10: 16.5
        },
        "sky.900": {
            contrast: 78.82251921521737,
            lc60: 70.5,
            lc45: 51,
            lc30: 34,
            lc10: 17.5
        },
        "sky.1000": {
            contrast: 73.29022480032467,
            lc60: 76.5,
            lc45: 55,
            lc30: 36.5,
            lc10: 18.5
        },
        "sky.1100": {
            contrast: 69.90886123760826,
            lc60: 82,
            lc45: 59,
            lc30: 38.5,
            lc10: 20.5
        },
        "sky.1200": {
            contrast: 64.97141105441133,
            lc60: 90.5,
            lc45: 65,
            lc30: 42.5,
            lc10: 22
        },
        "sky.1300": {
            contrast: 59.89265125043018,
            lc60: 100,
            lc45: 71.5,
            lc30: 47,
            lc10: 24.5
        },
        "sky.1400": {
            contrast: 55.53005196992806,
            lc60: 100,
            lc45: 78.5,
            lc30: 51.5,
            lc10: 26.5
        },
        "sky.1500": {
            contrast: 51.01497980470836,
            lc60: 100,
            lc45: 86.5,
            lc30: 56,
            lc10: 29
        },
        "sky.1600": {
            contrast: 45.9573065016677,
            lc60: 100,
            lc45: 97.5,
            lc30: 62.5,
            lc10: 33
        },
        "sky.1700": {
            contrast: 41.137817732967214,
            lc60: 100,
            lc45: 100,
            lc30: 71,
            lc10: 37
        },
        "sky.1800": {
            contrast: 36.20646903192367,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 42
        },
        "sky.1900": {
            contrast: 31.112625826652053,
            lc60: 100,
            lc45: 100,
            lc30: 97,
            lc10: 49
        },
        "sky.2000": {
            contrast: 25.762154890274868,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "sky.2100": {
            contrast: 20.10270716928826,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76.5
        },
        "sky.2200": {
            contrast: 14.586546022498299,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2300": {
            contrast: 9.037859435618984,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    }
};
const $f8fd43f1ee3f8cd8$var$navi = {
    "navi.100": {
        "navi.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.600": {
            contrast: 8.117362957694422,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.700": {
            contrast: 12.066030444495398,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.800": {
            contrast: 16.830010840240035,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 94
        },
        "navi.900": {
            contrast: 21.298899048368988,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83.5
        },
        "navi.1000": {
            contrast: 25.488342881294844,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76
        },
        "navi.1100": {
            contrast: 29.948174361125236,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69.5
        },
        "navi.1200": {
            contrast: 34.94529181270277,
            lc60: 100,
            lc45: 100,
            lc30: 91.5,
            lc10: 63.5
        },
        "navi.1300": {
            contrast: 40.072008919266096,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 59
        },
        "navi.1400": {
            contrast: 44.67740436172771,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 55
        },
        "navi.1500": {
            contrast: 49.42843483919055,
            lc60: 100,
            lc45: 94,
            lc30: 74.5,
            lc10: 52
        },
        "navi.1600": {
            contrast: 54.54239220109749,
            lc60: 100,
            lc45: 89,
            lc30: 70.5,
            lc10: 49
        },
        "navi.1700": {
            contrast: 59.62025504187709,
            lc60: 100,
            lc45: 84,
            lc30: 66.5,
            lc10: 46.5
        },
        "navi.1800": {
            contrast: 65.35876306373056,
            lc60: 94.5,
            lc45: 79.5,
            lc30: 63,
            lc10: 43.5
        },
        "navi.1900": {
            contrast: 70.84264329389485,
            lc60: 90,
            lc45: 75.5,
            lc30: 59.5,
            lc10: 42
        },
        "navi.2000": {
            contrast: 76.54055396842463,
            lc60: 86,
            lc45: 72.5,
            lc30: 57,
            lc10: 40
        },
        "navi.2100": {
            contrast: 82.55763905828711,
            lc60: 82,
            lc45: 69,
            lc30: 54.5,
            lc10: 38
        },
        "navi.2200": {
            contrast: 88.66270486383215,
            lc60: 78.5,
            lc45: 66,
            lc30: 52,
            lc10: 36.5
        },
        "navi.2300": {
            contrast: 94.62567466648164,
            lc60: 75,
            lc45: 63,
            lc30: 50,
            lc10: 35
        },
        "navi.2400": {
            contrast: 101.09702089769303,
            lc60: 72,
            lc45: 60.5,
            lc30: 48,
            lc10: 33.5
        },
        "navi.2500": {
            contrast: 107.88473318309848,
            lc60: 69,
            lc45: 58,
            lc30: 46,
            lc10: 32
        }
    },
    "navi.200": {
        "navi.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.600": {
            contrast: 7.573085993167397,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.700": {
            contrast: 11.521753479968375,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.800": {
            contrast: 16.285733875713007,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95
        },
        "navi.900": {
            contrast: 20.754622083841966,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82.5
        },
        "navi.1000": {
            contrast: 24.944065916767823,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74
        },
        "navi.1100": {
            contrast: 29.403897396598204,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67
        },
        "navi.1200": {
            contrast: 34.401014848175734,
            lc60: 100,
            lc45: 100,
            lc30: 91.5,
            lc10: 61
        },
        "navi.1300": {
            contrast: 39.52773195473907,
            lc60: 100,
            lc45: 100,
            lc30: 84,
            lc10: 56.5
        },
        "navi.1400": {
            contrast: 44.13312739720068,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 52.5
        },
        "navi.1500": {
            contrast: 48.884157874663515,
            lc60: 100,
            lc45: 95,
            lc30: 73.5,
            lc10: 49.5
        },
        "navi.1600": {
            contrast: 53.99811523657046,
            lc60: 100,
            lc45: 89,
            lc30: 69,
            lc10: 46.5
        },
        "navi.1700": {
            contrast: 59.075978077350065,
            lc60: 100,
            lc45: 84,
            lc30: 65.5,
            lc10: 44
        },
        "navi.1800": {
            contrast: 64.81448609920353,
            lc60: 95,
            lc45: 79,
            lc30: 61.5,
            lc10: 42
        },
        "navi.1900": {
            contrast: 70.29836632936784,
            lc60: 90,
            lc45: 75,
            lc30: 58.5,
            lc10: 39.5
        },
        "navi.2000": {
            contrast: 75.9962770038976,
            lc60: 85.5,
            lc45: 71.5,
            lc30: 56,
            lc10: 37.5
        },
        "navi.2100": {
            contrast: 82.01336209376008,
            lc60: 81.5,
            lc45: 68,
            lc30: 53.5,
            lc10: 36
        },
        "navi.2200": {
            contrast: 88.11842789930513,
            lc60: 78,
            lc45: 65,
            lc30: 51,
            lc10: 34.5
        },
        "navi.2300": {
            contrast: 94.08139770195461,
            lc60: 75,
            lc45: 62.5,
            lc30: 49,
            lc10: 33
        },
        "navi.2400": {
            contrast: 100.55274393316603,
            lc60: 71.5,
            lc45: 59.5,
            lc30: 47,
            lc10: 31.5
        },
        "navi.2500": {
            contrast: 107.34045621857145,
            lc60: 68.5,
            lc45: 57.5,
            lc30: 45,
            lc10: 30.5
        }
    },
    "navi.300": {
        "navi.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.700": {
            contrast: 10.068729426559408,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.800": {
            contrast: 14.832709822304041,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.900": {
            contrast: 19.301598030432995,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86.5
        },
        "navi.1000": {
            contrast: 23.491041863358856,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76.5
        },
        "navi.1100": {
            contrast: 27.950873343189237,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68.5
        },
        "navi.1200": {
            contrast: 32.94799079476677,
            lc60: 100,
            lc45: 100,
            lc30: 94.5,
            lc10: 62.5
        },
        "navi.1300": {
            contrast: 38.0747079013301,
            lc60: 100,
            lc45: 100,
            lc30: 85.5,
            lc10: 57
        },
        "navi.1400": {
            contrast: 42.68010334379171,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 53
        },
        "navi.1500": {
            contrast: 47.43113382125455,
            lc60: 100,
            lc45: 96.5,
            lc30: 75,
            lc10: 50
        },
        "navi.1600": {
            contrast: 52.545091183161496,
            lc60: 100,
            lc45: 90,
            lc30: 70.5,
            lc10: 47
        },
        "navi.1700": {
            contrast: 57.6229540239411,
            lc60: 100,
            lc45: 85,
            lc30: 66.5,
            lc10: 44.5
        },
        "navi.1800": {
            contrast: 63.36146204579457,
            lc60: 96,
            lc45: 80.5,
            lc30: 62.5,
            lc10: 42
        },
        "navi.1900": {
            contrast: 68.84534227595887,
            lc60: 91,
            lc45: 76.5,
            lc30: 59.5,
            lc10: 40
        },
        "navi.2000": {
            contrast: 74.54325295048862,
            lc60: 87,
            lc45: 72.5,
            lc30: 57,
            lc10: 38
        },
        "navi.2100": {
            contrast: 80.56033804035111,
            lc60: 82.5,
            lc45: 69,
            lc30: 54,
            lc10: 36.5
        },
        "navi.2200": {
            contrast: 86.66540384589615,
            lc60: 79,
            lc45: 66,
            lc30: 51.5,
            lc10: 35
        },
        "navi.2300": {
            contrast: 92.62837364854563,
            lc60: 75.5,
            lc45: 63,
            lc30: 49.5,
            lc10: 33.5
        },
        "navi.2400": {
            contrast: 99.09971987975702,
            lc60: 72.5,
            lc45: 60.5,
            lc30: 47.5,
            lc10: 32
        },
        "navi.2500": {
            contrast: 105.88743216516248,
            lc60: 69.5,
            lc45: 58,
            lc30: 45.5,
            lc10: 31
        }
    },
    "navi.400": {
        "navi.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.700": {
            contrast: 8.134743128338974,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.800": {
            contrast: 12.898723524083607,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.900": {
            contrast: 17.36761173221256,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91
        },
        "navi.1000": {
            contrast: 21.557055565138423,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81
        },
        "navi.1100": {
            contrast: 26.016887044968804,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72
        },
        "navi.1200": {
            contrast: 31.014004496546338,
            lc60: 100,
            lc45: 100,
            lc30: 97.5,
            lc10: 65
        },
        "navi.1300": {
            contrast: 36.14072160310967,
            lc60: 100,
            lc45: 100,
            lc30: 89,
            lc10: 59
        },
        "navi.1400": {
            contrast: 40.74611704557128,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 55
        },
        "navi.1500": {
            contrast: 45.49714752303412,
            lc60: 100,
            lc45: 99.5,
            lc30: 77.5,
            lc10: 51.5
        },
        "navi.1600": {
            contrast: 50.611104884941064,
            lc60: 100,
            lc45: 93,
            lc30: 72,
            lc10: 48.5
        },
        "navi.1700": {
            contrast: 55.68896772572065,
            lc60: 100,
            lc45: 87.5,
            lc30: 68,
            lc10: 45.5
        },
        "navi.1800": {
            contrast: 61.427475747574135,
            lc60: 98.5,
            lc45: 82.5,
            lc30: 64.5,
            lc10: 43
        },
        "navi.1900": {
            contrast: 66.91135597773842,
            lc60: 93.5,
            lc45: 78,
            lc30: 61,
            lc10: 41.5
        },
        "navi.2000": {
            contrast: 72.60926665226819,
            lc60: 88.5,
            lc45: 74.5,
            lc30: 58,
            lc10: 39
        },
        "navi.2100": {
            contrast: 78.62635174213068,
            lc60: 84,
            lc45: 70.5,
            lc30: 55,
            lc10: 37.5
        },
        "navi.2200": {
            contrast: 84.73141754767572,
            lc60: 80.5,
            lc45: 67,
            lc30: 52.5,
            lc10: 36
        },
        "navi.2300": {
            contrast: 90.6943873503252,
            lc60: 77,
            lc45: 64.5,
            lc30: 50.5,
            lc10: 34.5
        },
        "navi.2400": {
            contrast: 97.16573358153659,
            lc60: 74,
            lc45: 61.5,
            lc30: 48.5,
            lc10: 33
        },
        "navi.2500": {
            contrast: 103.95344586694205,
            lc60: 70.5,
            lc45: 59,
            lc30: 46.5,
            lc10: 31.5
        }
    },
    "navi.500": {
        "navi.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.800": {
            contrast: 10.897457621003316,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.900": {
            contrast: 15.366345829132266,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98.5
        },
        "navi.1000": {
            contrast: 19.555789662058125,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82.5
        },
        "navi.1100": {
            contrast: 24.015621141888513,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "navi.1200": {
            contrast: 29.012738593466047,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "navi.1300": {
            contrast: 34.13945570002937,
            lc60: 100,
            lc45: 100,
            lc30: 91,
            lc10: 56
        },
        "navi.1400": {
            contrast: 38.74485114249098,
            lc60: 100,
            lc45: 100,
            lc30: 83,
            lc10: 51.5
        },
        "navi.1500": {
            contrast: 43.49588161995383,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 47.5
        },
        "navi.1600": {
            contrast: 48.609838981860776,
            lc60: 100,
            lc45: 94.5,
            lc30: 71,
            lc10: 44
        },
        "navi.1700": {
            contrast: 53.68770182264036,
            lc60: 100,
            lc45: 88,
            lc30: 66.5,
            lc10: 41.5
        },
        "navi.1800": {
            contrast: 59.42620984449385,
            lc60: 100,
            lc45: 82.5,
            lc30: 62.5,
            lc10: 38.5
        },
        "navi.1900": {
            contrast: 64.91009007465814,
            lc60: 94.5,
            lc45: 77.5,
            lc30: 58.5,
            lc10: 36.5
        },
        "navi.2000": {
            contrast: 70.60800074918791,
            lc60: 89.5,
            lc45: 73,
            lc30: 55.5,
            lc10: 34.5
        },
        "navi.2100": {
            contrast: 76.62508583905037,
            lc60: 84,
            lc45: 69.5,
            lc30: 52.5,
            lc10: 33
        },
        "navi.2200": {
            contrast: 82.73015164459542,
            lc60: 80,
            lc45: 66,
            lc30: 49.5,
            lc10: 31
        },
        "navi.2300": {
            contrast: 88.69312144724492,
            lc60: 76.5,
            lc45: 62.5,
            lc30: 47.5,
            lc10: 30
        },
        "navi.2400": {
            contrast: 95.1644676784563,
            lc60: 72.5,
            lc45: 59.5,
            lc30: 45.5,
            lc10: 28.5
        },
        "navi.2500": {
            contrast: 101.95217996386174,
            lc60: 69.5,
            lc45: 57,
            lc30: 43.5,
            lc10: 27
        }
    },
    "navi.600": {
        "navi.100": {
            contrast: 9.448006942622463,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.200": {
            contrast: 8.719819476675008,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.800": {
            contrast: 7.375779672220194,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.900": {
            contrast: 11.84466788034915,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1000": {
            contrast: 16.034111713275006,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95
        },
        "navi.1100": {
            contrast: 20.493943193105395,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78.5
        },
        "navi.1200": {
            contrast: 25.49106064468292,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66.5
        },
        "navi.1300": {
            contrast: 30.617777751246255,
            lc60: 100,
            lc45: 100,
            lc30: 98,
            lc10: 57.5
        },
        "navi.1400": {
            contrast: 35.223173193707865,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 52
        },
        "navi.1500": {
            contrast: 39.974203671170706,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 48
        },
        "navi.1600": {
            contrast: 45.08816103307765,
            lc60: 100,
            lc45: 99.5,
            lc30: 73.5,
            lc10: 43.5
        },
        "navi.1700": {
            contrast: 50.16602387385725,
            lc60: 100,
            lc45: 92,
            lc30: 68,
            lc10: 40.5
        },
        "navi.1800": {
            contrast: 55.90453189571072,
            lc60: 100,
            lc45: 85,
            lc30: 63,
            lc10: 37.5
        },
        "navi.1900": {
            contrast: 61.388412125875014,
            lc60: 98,
            lc45: 79.5,
            lc30: 59,
            lc10: 35
        },
        "navi.2000": {
            contrast: 67.08632280040479,
            lc60: 92,
            lc45: 74.5,
            lc30: 55.5,
            lc10: 33
        },
        "navi.2100": {
            contrast: 73.10340789026726,
            lc60: 86.5,
            lc45: 70,
            lc30: 52,
            lc10: 31.5
        },
        "navi.2200": {
            contrast: 79.2084736958123,
            lc60: 82,
            lc45: 66.5,
            lc30: 49,
            lc10: 30
        },
        "navi.2300": {
            contrast: 85.1714434984618,
            lc60: 77.5,
            lc45: 63,
            lc30: 47,
            lc10: 28.5
        },
        "navi.2400": {
            contrast: 91.64278972967318,
            lc60: 73.5,
            lc45: 60,
            lc30: 44.5,
            lc10: 27
        },
        "navi.2500": {
            contrast: 98.43050201507863,
            lc60: 70,
            lc45: 57,
            lc30: 42.5,
            lc10: 25.5
        }
    },
    "navi.700": {
        "navi.100": {
            contrast: 13.756732557462406,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.200": {
            contrast: 13.028545091514951,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.300": {
            contrast: 11.140235573968946,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.400": {
            contrast: 8.720584413191661,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.900": {
            contrast: 8.078246897948546,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1000": {
            contrast: 12.267690730874406,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1100": {
            contrast: 16.72752221070479,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 90.5
        },
        "navi.1200": {
            contrast: 21.724639662282325,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74
        },
        "navi.1300": {
            contrast: 26.85135676884565,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "navi.1400": {
            contrast: 31.45675221130726,
            lc60: 100,
            lc45: 100,
            lc30: 96.5,
            lc10: 55
        },
        "navi.1500": {
            contrast: 36.2077826887701,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 49
        },
        "navi.1600": {
            contrast: 41.32174005067705,
            lc60: 100,
            lc45: 100,
            lc30: 77.5,
            lc10: 45
        },
        "navi.1700": {
            contrast: 46.399602891456645,
            lc60: 100,
            lc45: 97.5,
            lc30: 71.5,
            lc10: 41
        },
        "navi.1800": {
            contrast: 52.13811091331012,
            lc60: 100,
            lc45: 89,
            lc30: 65,
            lc10: 38
        },
        "navi.1900": {
            contrast: 57.62199114347442,
            lc60: 100,
            lc45: 82.5,
            lc30: 60.5,
            lc10: 35.5
        },
        "navi.2000": {
            contrast: 63.319901818004176,
            lc60: 96,
            lc45: 77,
            lc30: 56.5,
            lc10: 33
        },
        "navi.2100": {
            contrast: 69.33698690786665,
            lc60: 89.5,
            lc45: 72,
            lc30: 52.5,
            lc10: 31
        },
        "navi.2200": {
            contrast: 75.4420527134117,
            lc60: 84,
            lc45: 67.5,
            lc30: 49.5,
            lc10: 29
        },
        "navi.2300": {
            contrast: 81.4050225160612,
            lc60: 79.5,
            lc45: 64,
            lc30: 47,
            lc10: 27.5
        },
        "navi.2400": {
            contrast: 87.87636874727258,
            lc60: 75,
            lc45: 60.5,
            lc30: 44.5,
            lc10: 26
        },
        "navi.2500": {
            contrast: 94.664081032678,
            lc60: 71.5,
            lc45: 57.5,
            lc30: 42.5,
            lc10: 24.5
        }
    },
    "navi.800": {
        "navi.100": {
            contrast: 18.836591483186453,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "navi.200": {
            contrast: 18.108404017238993,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "navi.300": {
            contrast: 16.220094499692987,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84
        },
        "navi.400": {
            contrast: 13.800443338915708,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.500": {
            contrast: 11.378589739596547,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1000": {
            contrast: 7.670888449502023,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1100": {
            contrast: 12.13071992933241,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1200": {
            contrast: 17.12783738090994,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89.5
        },
        "navi.1300": {
            contrast: 22.254554487473275,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72
        },
        "navi.1400": {
            contrast: 26.859949929934874,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61.5
        },
        "navi.1500": {
            contrast: 31.610980407397722,
            lc60: 100,
            lc45: 100,
            lc30: 95.5,
            lc10: 53.5
        },
        "navi.1600": {
            contrast: 36.72493776930467,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 48
        },
        "navi.1700": {
            contrast: 41.80280061008426,
            lc60: 100,
            lc45: 100,
            lc30: 76,
            lc10: 43
        },
        "navi.1800": {
            contrast: 47.54130863193774,
            lc60: 100,
            lc45: 95.5,
            lc30: 69,
            lc10: 39
        },
        "navi.1900": {
            contrast: 53.025188862102034,
            lc60: 100,
            lc45: 88,
            lc30: 64,
            lc10: 36
        },
        "navi.2000": {
            contrast: 58.72309953663181,
            lc60: 100,
            lc45: 81,
            lc30: 59,
            lc10: 33.5
        },
        "navi.2100": {
            contrast: 64.74018462649428,
            lc60: 94,
            lc45: 75.5,
            lc30: 54.5,
            lc10: 31.5
        },
        "navi.2200": {
            contrast: 70.84525043203932,
            lc60: 87.5,
            lc45: 70.5,
            lc30: 51,
            lc10: 29
        },
        "navi.2300": {
            contrast: 76.80822023468882,
            lc60: 82.5,
            lc45: 66.5,
            lc30: 48,
            lc10: 27.5
        },
        "navi.2400": {
            contrast: 83.2795664659002,
            lc60: 77.5,
            lc45: 62.5,
            lc30: 45.5,
            lc10: 26
        },
        "navi.2500": {
            contrast: 90.06727875130564,
            lc60: 73.5,
            lc45: 59,
            lc30: 43,
            lc10: 24.5
        }
    },
    "navi.900": {
        "navi.100": {
            contrast: 23.508842861871777,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 44.5
        },
        "navi.200": {
            contrast: 22.780655395924317,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51.5
        },
        "navi.300": {
            contrast: 20.89234587837832,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58
        },
        "navi.400": {
            contrast: 18.47269471760103,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "navi.500": {
            contrast: 16.050841118281873,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 92
        },
        "navi.600": {
            contrast: 11.935316199708154,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.700": {
            contrast: 7.685691245675312,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1100": {
            contrast: 7.776002395080944,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1200": {
            contrast: 12.773119846658476,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1300": {
            contrast: 17.899836953221808,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85.5
        },
        "navi.1400": {
            contrast: 22.505232395683414,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70.5
        },
        "navi.1500": {
            contrast: 27.25626287314625,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "navi.1600": {
            contrast: 32.370220235053196,
            lc60: 100,
            lc45: 100,
            lc30: 94,
            lc10: 52.5
        },
        "navi.1700": {
            contrast: 37.44808307583279,
            lc60: 100,
            lc45: 100,
            lc30: 83,
            lc10: 46.5
        },
        "navi.1800": {
            contrast: 43.186591097686275,
            lc60: 100,
            lc45: 100,
            lc30: 73.5,
            lc10: 41
        },
        "navi.1900": {
            contrast: 48.67047132785057,
            lc60: 100,
            lc45: 93.5,
            lc30: 67,
            lc10: 38
        },
        "navi.2000": {
            contrast: 54.36838200238032,
            lc60: 100,
            lc45: 86,
            lc30: 62,
            lc10: 34.5
        },
        "navi.2100": {
            contrast: 60.385467092242806,
            lc60: 99.5,
            lc45: 79,
            lc30: 57,
            lc10: 32
        },
        "navi.2200": {
            contrast: 66.49053289778784,
            lc60: 92,
            lc45: 73.5,
            lc30: 53,
            lc10: 30
        },
        "navi.2300": {
            contrast: 72.45350270043735,
            lc60: 86,
            lc45: 68.5,
            lc30: 49.5,
            lc10: 28
        },
        "navi.2400": {
            contrast: 78.92484893164874,
            lc60: 80.5,
            lc45: 64.5,
            lc30: 46.5,
            lc10: 26
        },
        "navi.2500": {
            contrast: 85.71256121705416,
            lc60: 75.5,
            lc45: 60.5,
            lc30: 43.5,
            lc10: 24.5
        }
    },
    "navi.1000": {
        "navi.100": {
            contrast: 27.821980148968773,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 38
        },
        "navi.200": {
            contrast: 27.093792683021316,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 43.5
        },
        "navi.300": {
            contrast: 25.205483165475318,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 47.5
        },
        "navi.400": {
            contrast: 22.785832004698033,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53
        },
        "navi.500": {
            contrast: 20.363978405378873,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "navi.600": {
            contrast: 16.248453486805154,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91.5
        },
        "navi.700": {
            contrast: 11.998828532772313,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1200": {
            contrast: 8.659157415616473,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1300": {
            contrast: 13.785874522179808,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1400": {
            contrast: 18.391269964641413,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83
        },
        "navi.1500": {
            contrast: 23.142300442104254,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "navi.1600": {
            contrast: 28.2562578040112,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58
        },
        "navi.1700": {
            contrast: 33.334120644790794,
            lc60: 100,
            lc45: 100,
            lc30: 91,
            lc10: 50.5
        },
        "navi.1800": {
            contrast: 39.07262866664427,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 44
        },
        "navi.1900": {
            contrast: 44.556508896808566,
            lc60: 100,
            lc45: 100,
            lc30: 71.5,
            lc10: 39.5
        },
        "navi.2000": {
            contrast: 50.254419571338325,
            lc60: 100,
            lc45: 91,
            lc30: 65,
            lc10: 36.5
        },
        "navi.2100": {
            contrast: 56.27150466120081,
            lc60: 100,
            lc45: 83,
            lc30: 59.5,
            lc10: 33.5
        },
        "navi.2200": {
            contrast: 62.37657046674586,
            lc60: 97,
            lc45: 76.5,
            lc30: 55,
            lc10: 31
        },
        "navi.2300": {
            contrast: 68.33954026939534,
            lc60: 90,
            lc45: 71.5,
            lc30: 51,
            lc10: 29
        },
        "navi.2400": {
            contrast: 74.81088650060673,
            lc60: 83.5,
            lc45: 66.5,
            lc30: 47.5,
            lc10: 27
        },
        "navi.2500": {
            contrast: 81.59859878601218,
            lc60: 78.5,
            lc45: 62,
            lc30: 44.5,
            lc10: 25
        }
    },
    "navi.1100": {
        "navi.100": {
            contrast: 32.353064604462645,
            lc60: 100,
            lc45: 100,
            lc30: 75,
            lc10: 33.5
        },
        "navi.200": {
            contrast: 31.62487713851519,
            lc60: 100,
            lc45: 100,
            lc30: 85,
            lc10: 37
        },
        "navi.300": {
            contrast: 29.736567620969183,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 40
        },
        "navi.400": {
            contrast: 27.316916460191898,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 43
        },
        "navi.500": {
            contrast: 24.895062860872745,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54.5
        },
        "navi.600": {
            contrast: 20.779537942299022,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "navi.700": {
            contrast: 16.529912988266183,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91
        },
        "navi.800": {
            contrast: 11.500434166203636,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1300": {
            contrast: 9.37729536175571,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1400": {
            contrast: 13.982690804217315,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1500": {
            contrast: 18.733721281680157,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82.5
        },
        "navi.1600": {
            contrast: 23.847678643587102,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "navi.1700": {
            contrast: 28.925541484366697,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56
        },
        "navi.1800": {
            contrast: 34.664049506220174,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 49
        },
        "navi.1900": {
            contrast: 40.14792973638447,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 43.5
        },
        "navi.2000": {
            contrast: 45.845840410914235,
            lc60: 100,
            lc45: 98,
            lc30: 70,
            lc10: 39
        },
        "navi.2100": {
            contrast: 51.86292550077671,
            lc60: 100,
            lc45: 89,
            lc30: 63.5,
            lc10: 35
        },
        "navi.2200": {
            contrast: 57.96799130632175,
            lc60: 100,
            lc45: 81,
            lc30: 58,
            lc10: 32
        },
        "navi.2300": {
            contrast: 63.93096110897124,
            lc60: 94.5,
            lc45: 75,
            lc30: 53.5,
            lc10: 29.5
        },
        "navi.2400": {
            contrast: 70.40230734018263,
            lc60: 87.5,
            lc45: 69,
            lc30: 49.5,
            lc10: 27.5
        },
        "navi.2500": {
            contrast: 77.19001962558806,
            lc60: 81.5,
            lc45: 64,
            lc30: 46.5,
            lc10: 25.5
        }
    },
    "navi.1200": {
        "navi.100": {
            contrast: 37.36613934681494,
            lc60: 100,
            lc45: 100,
            lc30: 60,
            lc10: 29
        },
        "navi.200": {
            contrast: 36.63795188086748,
            lc60: 100,
            lc45: 100,
            lc30: 66.5,
            lc10: 32.5
        },
        "navi.300": {
            contrast: 34.749642363321485,
            lc60: 100,
            lc45: 100,
            lc30: 72.5,
            lc10: 34.5
        },
        "navi.400": {
            contrast: 32.32999120254419,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 36
        },
        "navi.500": {
            contrast: 29.908137603225043,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 45
        },
        "navi.600": {
            contrast: 25.792612684651324,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "navi.700": {
            contrast: 21.54298773061848,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68.5
        },
        "navi.800": {
            contrast: 16.513508908555934,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 90
        },
        "navi.900": {
            contrast: 11.872377236834671,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1000": {
            contrast: 7.576951585408179,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1400": {
            contrast: 9.011628339273287,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1500": {
            contrast: 13.762658816736128,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1600": {
            contrast: 18.876616178643072,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82.5
        },
        "navi.1700": {
            contrast: 23.954479019422674,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66.5
        },
        "navi.1800": {
            contrast: 29.692987041276147,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "navi.1900": {
            contrast: 35.17686727144044,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 47.5
        },
        "navi.2000": {
            contrast: 40.8747779459702,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 42
        },
        "navi.2100": {
            contrast: 46.891863035832685,
            lc60: 100,
            lc45: 96,
            lc30: 68.5,
            lc10: 37.5
        },
        "navi.2200": {
            contrast: 52.99692884137772,
            lc60: 100,
            lc45: 87,
            lc30: 62,
            lc10: 34
        },
        "navi.2300": {
            contrast: 58.95989864402722,
            lc60: 100,
            lc45: 80,
            lc30: 57,
            lc10: 31
        },
        "navi.2400": {
            contrast: 65.4312448752386,
            lc60: 93,
            lc45: 73.5,
            lc30: 52,
            lc10: 28.5
        },
        "navi.2500": {
            contrast: 72.21895716064404,
            lc60: 86,
            lc45: 68,
            lc30: 48,
            lc10: 26.5
        }
    },
    "navi.1300": {
        "navi.100": {
            contrast: 42.44813765708673,
            lc60: 100,
            lc45: 100,
            lc30: 52.5,
            lc10: 26
        },
        "navi.200": {
            contrast: 41.719950191139276,
            lc60: 100,
            lc45: 100,
            lc30: 58,
            lc10: 28.5
        },
        "navi.300": {
            contrast: 39.83164067359328,
            lc60: 100,
            lc45: 100,
            lc30: 61.5,
            lc10: 29.5
        },
        "navi.400": {
            contrast: 37.41198951281599,
            lc60: 100,
            lc45: 100,
            lc30: 66.5,
            lc10: 31.5
        },
        "navi.500": {
            contrast: 34.990135913496836,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 37.5
        },
        "navi.600": {
            contrast: 30.874610994923113,
            lc60: 100,
            lc45: 100,
            lc30: 96,
            lc10: 45.5
        },
        "navi.700": {
            contrast: 26.62498604089027,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54.5
        },
        "navi.800": {
            contrast: 21.595507218827727,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68.5
        },
        "navi.900": {
            contrast: 16.954375547106466,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88
        },
        "navi.1000": {
            contrast: 12.65894989567997,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1100": {
            contrast: 8.136497395440909,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1500": {
            contrast: 8.632115407678041,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1600": {
            contrast: 13.746072769584986,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1700": {
            contrast: 18.823935610364583,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81.5
        },
        "navi.1800": {
            contrast: 24.56244363221806,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "navi.1900": {
            contrast: 30.04632386238235,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 54
        },
        "navi.2000": {
            contrast: 35.74423453691212,
            lc60: 100,
            lc45: 100,
            lc30: 85.5,
            lc10: 46.5
        },
        "navi.2100": {
            contrast: 41.76131962677459,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 40.5
        },
        "navi.2200": {
            contrast: 47.86638543231964,
            lc60: 100,
            lc45: 95,
            lc30: 66.5,
            lc10: 36
        },
        "navi.2300": {
            contrast: 53.829355234969135,
            lc60: 100,
            lc45: 85.5,
            lc30: 60.5,
            lc10: 33
        },
        "navi.2400": {
            contrast: 60.300701466180506,
            lc60: 99.5,
            lc45: 78.5,
            lc30: 55,
            lc10: 30
        },
        "navi.2500": {
            contrast: 67.08841375158596,
            lc60: 91,
            lc45: 71.5,
            lc30: 50.5,
            lc10: 27.5
        }
    },
    "navi.1400": {
        "navi.100": {
            contrast: 46.96678341959484,
            lc60: 100,
            lc45: 81.5,
            lc30: 47.5,
            lc10: 23.5
        },
        "navi.200": {
            contrast: 46.23859595364739,
            lc60: 100,
            lc45: 90,
            lc30: 51.5,
            lc10: 26
        },
        "navi.300": {
            contrast: 44.350286436101385,
            lc60: 100,
            lc45: 100,
            lc30: 54.5,
            lc10: 27
        },
        "navi.400": {
            contrast: 41.9306352753241,
            lc60: 100,
            lc45: 100,
            lc30: 57,
            lc10: 28
        },
        "navi.500": {
            contrast: 39.50878167600494,
            lc60: 100,
            lc45: 100,
            lc30: 68.5,
            lc10: 33.5
        },
        "navi.600": {
            contrast: 35.393256757431224,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 39
        },
        "navi.700": {
            contrast: 31.14363180339838,
            lc60: 100,
            lc45: 100,
            lc30: 95.5,
            lc10: 46.5
        },
        "navi.800": {
            contrast: 26.114152981335835,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "navi.900": {
            contrast: 21.473021309614577,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70.5
        },
        "navi.1000": {
            contrast: 17.177595658188082,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87.5
        },
        "navi.1100": {
            contrast: 12.65514315794902,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1200": {
            contrast: 7.641048080056478,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1600": {
            contrast: 9.113553593248822,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1700": {
            contrast: 14.19141643402842,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1800": {
            contrast: 19.9299244558819,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77
        },
        "navi.1900": {
            contrast: 25.413804686046188,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62
        },
        "navi.2000": {
            contrast: 31.111715360575953,
            lc60: 100,
            lc45: 100,
            lc30: 96.5,
            lc10: 52
        },
        "navi.2100": {
            contrast: 37.12880045043843,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 45
        },
        "navi.2200": {
            contrast: 43.23386625598348,
            lc60: 100,
            lc45: 100,
            lc30: 72.5,
            lc10: 39.5
        },
        "navi.2300": {
            contrast: 49.19683605863297,
            lc60: 100,
            lc45: 92.5,
            lc30: 65,
            lc10: 35.5
        },
        "navi.2400": {
            contrast: 55.668182289844346,
            lc60: 100,
            lc45: 83.5,
            lc30: 58.5,
            lc10: 32
        },
        "navi.2500": {
            contrast: 62.45589457524979,
            lc60: 96.5,
            lc45: 76,
            lc30: 53.5,
            lc10: 29
        }
    },
    "navi.1500": {
        "navi.100": {
            contrast: 51.58693513150306,
            lc60: 100,
            lc45: 69,
            lc30: 43.5,
            lc10: 22
        },
        "navi.200": {
            contrast: 50.85874766555561,
            lc60: 100,
            lc45: 75,
            lc30: 47,
            lc10: 23.5
        },
        "navi.300": {
            contrast: 48.970438148009606,
            lc60: 100,
            lc45: 80,
            lc30: 49,
            lc10: 24.5
        },
        "navi.400": {
            contrast: 46.550786987232314,
            lc60: 100,
            lc45: 89,
            lc30: 50.5,
            lc10: 25
        },
        "navi.500": {
            contrast: 44.128933387913165,
            lc60: 100,
            lc45: 100,
            lc30: 60,
            lc10: 29.5
        },
        "navi.600": {
            contrast: 40.013408469339446,
            lc60: 100,
            lc45: 100,
            lc30: 70,
            lc10: 34
        },
        "navi.700": {
            contrast: 35.7637835153066,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 39.5
        },
        "navi.800": {
            contrast: 30.734304693244052,
            lc60: 100,
            lc45: 100,
            lc30: 96.5,
            lc10: 47
        },
        "navi.900": {
            contrast: 26.09317302152279,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "navi.1000": {
            contrast: 21.797747370096303,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69.5
        },
        "navi.1100": {
            contrast: 17.27529486985724,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87.5
        },
        "navi.1200": {
            contrast: 12.261199791964698,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1700": {
            contrast: 9.391049252181395,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1800": {
            contrast: 15.129557274034871,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98
        },
        "navi.1900": {
            contrast: 20.613437504199165,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74.5
        },
        "navi.2000": {
            contrast: 26.311348178728927,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60.5
        },
        "navi.2100": {
            contrast: 32.328433268591404,
            lc60: 100,
            lc45: 100,
            lc30: 93.5,
            lc10: 50.5
        },
        "navi.2200": {
            contrast: 38.43349907413645,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 43.5
        },
        "navi.2300": {
            contrast: 44.396468876785946,
            lc60: 100,
            lc45: 100,
            lc30: 70.5,
            lc10: 38.5
        },
        "navi.2400": {
            contrast: 50.86781510799733,
            lc60: 100,
            lc45: 90,
            lc30: 63,
            lc10: 34.5
        },
        "navi.2500": {
            contrast: 57.655527393402764,
            lc60: 100,
            lc45: 80.5,
            lc30: 56.5,
            lc10: 31
        }
    },
    "navi.1600": {
        "navi.100": {
            contrast: 56.51749705760878,
            lc60: 100,
            lc45: 62,
            lc30: 39.5,
            lc10: 20
        },
        "navi.200": {
            contrast: 55.789309591661315,
            lc60: 100,
            lc45: 66.5,
            lc30: 42.5,
            lc10: 21
        },
        "navi.300": {
            contrast: 53.90100007411532,
            lc60: 100,
            lc45: 70,
            lc30: 43.5,
            lc10: 22
        },
        "navi.400": {
            contrast: 51.48134891333803,
            lc60: 100,
            lc45: 74.5,
            lc30: 45.5,
            lc10: 22.5
        },
        "navi.500": {
            contrast: 49.059495314018875,
            lc60: 100,
            lc45: 86.5,
            lc30: 53,
            lc10: 26
        },
        "navi.600": {
            contrast: 44.943970395445156,
            lc60: 100,
            lc45: 100,
            lc30: 61,
            lc10: 30
        },
        "navi.700": {
            contrast: 40.69434544141231,
            lc60: 100,
            lc45: 100,
            lc30: 70,
            lc10: 34.5
        },
        "navi.800": {
            contrast: 35.664866619349766,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 40.5
        },
        "navi.900": {
            contrast: 31.0237349476285,
            lc60: 100,
            lc45: 100,
            lc30: 96.5,
            lc10: 47
        },
        "navi.1000": {
            contrast: 26.728309296202006,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "navi.1100": {
            contrast: 22.20585679596295,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "navi.1200": {
            contrast: 17.19176171807041,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87
        },
        "navi.1300": {
            contrast: 12.098595124801244,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1400": {
            contrast: 7.562271041681537,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1800": {
            contrast: 9.94026338949691,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1900": {
            contrast: 15.424143619661205,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98
        },
        "navi.2000": {
            contrast: 21.122054294190967,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74
        },
        "navi.2100": {
            contrast: 27.13913938405344,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "navi.2200": {
            contrast: 33.24420518959849,
            lc60: 100,
            lc45: 100,
            lc30: 90.5,
            lc10: 49.5
        },
        "navi.2300": {
            contrast: 39.20717499224798,
            lc60: 100,
            lc45: 100,
            lc30: 79,
            lc10: 42.5
        },
        "navi.2400": {
            contrast: 45.67852122345936,
            lc60: 100,
            lc45: 98.5,
            lc30: 69,
            lc10: 37
        },
        "navi.2500": {
            contrast: 52.4662335088648,
            lc60: 100,
            lc45: 87,
            lc30: 61.5,
            lc10: 33
        }
    },
    "navi.1700": {
        "navi.100": {
            contrast: 61.37356034001633,
            lc60: 86.5,
            lc45: 56.5,
            lc30: 36.5,
            lc10: 19
        },
        "navi.200": {
            contrast: 60.64537287406886,
            lc60: 94,
            lc45: 60.5,
            lc30: 38.5,
            lc10: 19.5
        },
        "navi.300": {
            contrast: 58.75706335652286,
            lc60: 100,
            lc45: 62.5,
            lc30: 40,
            lc10: 20.5
        },
        "navi.400": {
            contrast: 56.337412195745586,
            lc60: 100,
            lc45: 65,
            lc30: 41,
            lc10: 20.5
        },
        "navi.500": {
            contrast: 53.915558596426415,
            lc60: 100,
            lc45: 76,
            lc30: 47.5,
            lc10: 23.5
        },
        "navi.600": {
            contrast: 49.800033677852696,
            lc60: 100,
            lc45: 86.5,
            lc30: 54,
            lc10: 27
        },
        "navi.700": {
            contrast: 45.55040872381986,
            lc60: 100,
            lc45: 98,
            lc30: 61,
            lc10: 30.5
        },
        "navi.800": {
            contrast: 40.52092990175731,
            lc60: 100,
            lc45: 100,
            lc30: 70.5,
            lc10: 35.5
        },
        "navi.900": {
            contrast: 35.879798230036045,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 40.5
        },
        "navi.1000": {
            contrast: 31.584372578609553,
            lc60: 100,
            lc45: 100,
            lc30: 94,
            lc10: 46.5
        },
        "navi.1100": {
            contrast: 27.061920078370495,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56
        },
        "navi.1200": {
            contrast: 22.047825000477957,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68.5
        },
        "navi.1300": {
            contrast: 16.954658407208793,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89
        },
        "navi.1400": {
            contrast: 12.418334324089084,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1500": {
            contrast: 7.77320798930115,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1900": {
            contrast: 10.2504591682515,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2000": {
            contrast: 15.948369842781263,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95
        },
        "navi.2100": {
            contrast: 21.965454932643738,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "navi.2200": {
            contrast: 28.07052073818878,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "navi.2300": {
            contrast: 34.03349054083827,
            lc60: 100,
            lc45: 100,
            lc30: 89,
            lc10: 48.5
        },
        "navi.2400": {
            contrast: 40.50483677204966,
            lc60: 100,
            lc45: 100,
            lc30: 76,
            lc10: 42
        },
        "navi.2500": {
            contrast: 47.2925490574551,
            lc60: 100,
            lc45: 95.5,
            lc30: 66.5,
            lc10: 36.5
        }
    },
    "navi.1800": {
        "navi.100": {
            contrast: 66.8179897177483,
            lc60: 73.5,
            lc45: 52,
            lc30: 34,
            lc10: 17
        },
        "navi.200": {
            contrast: 66.08980225180083,
            lc60: 78,
            lc45: 54.5,
            lc30: 35.5,
            lc10: 18
        },
        "navi.300": {
            contrast: 64.20149273425484,
            lc60: 82,
            lc45: 56.5,
            lc30: 36.5,
            lc10: 18.5
        },
        "navi.400": {
            contrast: 61.78184157347756,
            lc60: 89,
            lc45: 58,
            lc30: 37,
            lc10: 19
        },
        "navi.500": {
            contrast: 59.35998797415839,
            lc60: 100,
            lc45: 66.5,
            lc30: 42.5,
            lc10: 21.5
        },
        "navi.600": {
            contrast: 55.24446305558468,
            lc60: 100,
            lc45: 75.5,
            lc30: 47.5,
            lc10: 24
        },
        "navi.700": {
            contrast: 50.994838101551835,
            lc60: 100,
            lc45: 84.5,
            lc30: 53.5,
            lc10: 27
        },
        "navi.800": {
            contrast: 45.965359279489284,
            lc60: 100,
            lc45: 97.5,
            lc30: 60.5,
            lc10: 31
        },
        "navi.900": {
            contrast: 41.32422760776802,
            lc60: 100,
            lc45: 100,
            lc30: 69.5,
            lc10: 35
        },
        "navi.1000": {
            contrast: 37.028801956341525,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 39.5
        },
        "navi.1100": {
            contrast: 32.50634945610247,
            lc60: 100,
            lc45: 100,
            lc30: 91,
            lc10: 46
        },
        "navi.1200": {
            contrast: 27.492254378209925,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "navi.1300": {
            contrast: 22.399087784940765,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "navi.1400": {
            contrast: 17.862763701821056,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84.5
        },
        "navi.1500": {
            contrast: 13.217637367033122,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1600": {
            contrast: 8.253323471450594,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2000": {
            contrast: 10.078303208726341,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2100": {
            contrast: 16.095388298588816,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 94.5
        },
        "navi.2200": {
            contrast: 22.20045410413386,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "navi.2300": {
            contrast: 28.163423906783354,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "navi.2400": {
            contrast: 34.634770137994735,
            lc60: 100,
            lc45: 100,
            lc30: 87.5,
            lc10: 48
        },
        "navi.2500": {
            contrast: 41.42248242340017,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 41
        }
    },
    "navi.1900": {
        "navi.100": {
            contrast: 71.98137127848554,
            lc60: 67,
            lc45: 48,
            lc30: 31.5,
            lc10: 16
        },
        "navi.200": {
            contrast: 71.25318381253808,
            lc60: 70.5,
            lc45: 50.5,
            lc30: 33,
            lc10: 16.5
        },
        "navi.300": {
            contrast: 69.36487429499208,
            lc60: 73,
            lc45: 51.5,
            lc30: 33.5,
            lc10: 17
        },
        "navi.400": {
            contrast: 66.9452231342148,
            lc60: 76.5,
            lc45: 53,
            lc30: 34,
            lc10: 17.5
        },
        "navi.500": {
            contrast: 64.52336953489562,
            lc60: 87,
            lc45: 60,
            lc30: 38.5,
            lc10: 19.5
        },
        "navi.600": {
            contrast: 60.4078446163219,
            lc60: 99,
            lc45: 67,
            lc30: 43,
            lc10: 22
        },
        "navi.700": {
            contrast: 56.15821966228906,
            lc60: 100,
            lc45: 75,
            lc30: 48,
            lc10: 24.5
        },
        "navi.800": {
            contrast: 51.12874084022651,
            lc60: 100,
            lc45: 85,
            lc30: 54,
            lc10: 27.5
        },
        "navi.900": {
            contrast: 46.48760916850526,
            lc60: 100,
            lc45: 95.5,
            lc30: 61,
            lc10: 31
        },
        "navi.1000": {
            contrast: 42.19218351707876,
            lc60: 100,
            lc45: 100,
            lc30: 68.5,
            lc10: 34.5
        },
        "navi.1100": {
            contrast: 37.669731016839705,
            lc60: 100,
            lc45: 100,
            lc30: 77.5,
            lc10: 38.5
        },
        "navi.1200": {
            contrast: 32.655635938947164,
            lc60: 100,
            lc45: 100,
            lc30: 91,
            lc10: 45.5
        },
        "navi.1300": {
            contrast: 27.562469345677997,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "navi.1400": {
            contrast: 23.02614526255829,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "navi.1500": {
            contrast: 18.381018927770356,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82
        },
        "navi.1600": {
            contrast: 13.416705032187831,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1700": {
            contrast: 8.520760278567115,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2100": {
            contrast: 10.464390440009636,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2200": {
            contrast: 16.569456245554683,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91.5
        },
        "navi.2300": {
            contrast: 22.532426048204172,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70.5
        },
        "navi.2400": {
            contrast: 29.00377227941555,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56
        },
        "navi.2500": {
            contrast: 35.79148456482099,
            lc60: 100,
            lc45: 100,
            lc30: 85.5,
            lc10: 46.5
        }
    },
    "navi.2000": {
        "navi.100": {
            contrast: 77.3086897650424,
            lc60: 61.5,
            lc45: 44.5,
            lc30: 29,
            lc10: 15
        },
        "navi.200": {
            contrast: 76.58050229909496,
            lc60: 64.5,
            lc45: 46.5,
            lc30: 30.5,
            lc10: 16
        },
        "navi.300": {
            contrast: 74.69219278154894,
            lc60: 66.5,
            lc45: 47.5,
            lc30: 31,
            lc10: 16
        },
        "navi.400": {
            contrast: 72.27254162077166,
            lc60: 68.5,
            lc45: 48.5,
            lc30: 31.5,
            lc10: 16
        },
        "navi.500": {
            contrast: 69.8506880214525,
            lc60: 77.5,
            lc45: 55,
            lc30: 35.5,
            lc10: 18
        },
        "navi.600": {
            contrast: 65.73516310287877,
            lc60: 86.5,
            lc45: 60.5,
            lc30: 39,
            lc10: 20
        },
        "navi.700": {
            contrast: 61.48553814884594,
            lc60: 96,
            lc45: 67,
            lc30: 43,
            lc10: 22
        },
        "navi.800": {
            contrast: 56.45605932678339,
            lc60: 100,
            lc45: 75,
            lc30: 48,
            lc10: 24.5
        },
        "navi.900": {
            contrast: 51.81492765506213,
            lc60: 100,
            lc45: 84,
            lc30: 53.5,
            lc10: 27.5
        },
        "navi.1000": {
            contrast: 47.51950200363564,
            lc60: 100,
            lc45: 93.5,
            lc30: 60,
            lc10: 30.5
        },
        "navi.1100": {
            contrast: 42.997049503396575,
            lc60: 100,
            lc45: 100,
            lc30: 67,
            lc10: 34
        },
        "navi.1200": {
            contrast: 37.982954425504026,
            lc60: 100,
            lc45: 100,
            lc30: 77.5,
            lc10: 39.5
        },
        "navi.1300": {
            contrast: 32.889787832234866,
            lc60: 100,
            lc45: 100,
            lc30: 90.5,
            lc10: 46
        },
        "navi.1400": {
            contrast: 28.35346374911516,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54
        },
        "navi.1500": {
            contrast: 23.708337414327225,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "navi.1600": {
            contrast: 18.744023518744697,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81.5
        },
        "navi.1700": {
            contrast: 13.848078765123983,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1800": {
            contrast: 8.3516636377119,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2200": {
            contrast: 10.698084096706562,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2300": {
            contrast: 16.66105389935605,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91
        },
        "navi.2400": {
            contrast: 23.132400130567436,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "navi.2500": {
            contrast: 29.92011241597287,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54
        }
    },
    "navi.2100": {
        "navi.100": {
            contrast: 82.89599110873581,
            lc60: 57,
            lc45: 41.5,
            lc30: 27.5,
            lc10: 14
        },
        "navi.200": {
            contrast: 82.16780364278834,
            lc60: 59.5,
            lc45: 43.5,
            lc30: 28.5,
            lc10: 14.5
        },
        "navi.300": {
            contrast: 80.27949412524235,
            lc60: 60.5,
            lc45: 44,
            lc30: 29,
            lc10: 15
        },
        "navi.400": {
            contrast: 77.85984296446506,
            lc60: 62.5,
            lc45: 45,
            lc30: 29,
            lc10: 15
        },
        "navi.500": {
            contrast: 75.43798936514591,
            lc60: 70,
            lc45: 50,
            lc30: 33,
            lc10: 17
        },
        "navi.600": {
            contrast: 71.32246444657218,
            lc60: 77,
            lc45: 55,
            lc30: 36,
            lc10: 18.5
        },
        "navi.700": {
            contrast: 67.07283949253934,
            lc60: 85.5,
            lc45: 60.5,
            lc30: 39,
            lc10: 20.5
        },
        "navi.800": {
            contrast: 62.04336067047679,
            lc60: 95,
            lc45: 67,
            lc30: 43.5,
            lc10: 22.5
        },
        "navi.900": {
            contrast: 57.40222899875553,
            lc60: 100,
            lc45: 74.5,
            lc30: 48,
            lc10: 24.5
        },
        "navi.1000": {
            contrast: 53.106803347329034,
            lc60: 100,
            lc45: 81.5,
            lc30: 53,
            lc10: 27
        },
        "navi.1100": {
            contrast: 48.58435084708997,
            lc60: 100,
            lc45: 91,
            lc30: 58.5,
            lc10: 30.5
        },
        "navi.1200": {
            contrast: 43.57025576919744,
            lc60: 100,
            lc45: 100,
            lc30: 66,
            lc10: 34.5
        },
        "navi.1300": {
            contrast: 38.47708917592828,
            lc60: 100,
            lc45: 100,
            lc30: 76,
            lc10: 38.5
        },
        "navi.1400": {
            contrast: 33.94076509280856,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 45
        },
        "navi.1500": {
            contrast: 29.29563875802063,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 52
        },
        "navi.1600": {
            contrast: 24.331324862438105,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63.5
        },
        "navi.1700": {
            contrast: 19.435380108817387,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79
        },
        "navi.1800": {
            contrast: 13.938964981405306,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1900": {
            contrast: 8.719660906931836,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2300": {
            contrast: 10.439503187790814,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2400": {
            contrast: 16.9108494190022,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91
        },
        "navi.2500": {
            contrast: 23.698561704407638,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        }
    },
    "navi.2200": {
        "navi.100": {
            contrast: 88.52759546049491,
            lc60: 53,
            lc45: 39,
            lc30: 25.5,
            lc10: 13
        },
        "navi.200": {
            contrast: 87.79940799454745,
            lc60: 55,
            lc45: 40.5,
            lc30: 26.5,
            lc10: 14
        },
        "navi.300": {
            contrast: 85.91109847700145,
            lc60: 56,
            lc45: 41,
            lc30: 27,
            lc10: 14
        },
        "navi.400": {
            contrast: 83.49144731622417,
            lc60: 57,
            lc45: 41.5,
            lc30: 27.5,
            lc10: 14
        },
        "navi.500": {
            contrast: 81.069593716905,
            lc60: 64,
            lc45: 46,
            lc30: 30,
            lc10: 15.5
        },
        "navi.600": {
            contrast: 76.95406879833128,
            lc60: 70,
            lc45: 50.5,
            lc30: 33,
            lc10: 17
        },
        "navi.700": {
            contrast: 72.70444384429844,
            lc60: 76.5,
            lc45: 55,
            lc30: 36,
            lc10: 18.5
        },
        "navi.800": {
            contrast: 67.6749650222359,
            lc60: 85,
            lc45: 60.5,
            lc30: 40,
            lc10: 20.5
        },
        "navi.900": {
            contrast: 63.03383335051463,
            lc60: 93.5,
            lc45: 66.5,
            lc30: 43.5,
            lc10: 22.5
        },
        "navi.1000": {
            contrast: 58.73840769908812,
            lc60: 100,
            lc45: 72.5,
            lc30: 47.5,
            lc10: 24.5
        },
        "navi.1100": {
            contrast: 54.21595519884907,
            lc60: 100,
            lc45: 80.5,
            lc30: 52,
            lc10: 27
        },
        "navi.1200": {
            contrast: 49.20186012095653,
            lc60: 100,
            lc45: 89.5,
            lc30: 58,
            lc10: 30
        },
        "navi.1300": {
            contrast: 44.108693527687365,
            lc60: 100,
            lc45: 100,
            lc30: 65.5,
            lc10: 34
        },
        "navi.1400": {
            contrast: 39.572369444567656,
            lc60: 100,
            lc45: 100,
            lc30: 75,
            lc10: 38
        },
        "navi.1500": {
            contrast: 34.927243109779724,
            lc60: 100,
            lc45: 100,
            lc30: 85,
            lc10: 43.5
        },
        "navi.1600": {
            contrast: 29.9629292141972,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51.5
        },
        "navi.1700": {
            contrast: 25.06698446057648,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61.5
        },
        "navi.1800": {
            contrast: 19.570569333164396,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78.5
        },
        "navi.1900": {
            contrast: 14.351265258690932,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2000": {
            contrast: 8.95993517829224,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2400": {
            contrast: 10.577406575736358,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2500": {
            contrast: 17.3651188611418,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87.5
        }
    },
    "navi.2300": {
        "navi.100": {
            contrast: 93.99429732830377,
            lc60: 50,
            lc45: 36.5,
            lc30: 24,
            lc10: 12.5
        },
        "navi.200": {
            contrast: 93.26610986235633,
            lc60: 51.5,
            lc45: 38,
            lc30: 25,
            lc10: 13
        },
        "navi.300": {
            contrast: 91.37780034481032,
            lc60: 52.5,
            lc45: 38,
            lc30: 25.5,
            lc10: 13.5
        },
        "navi.400": {
            contrast: 88.95814918403303,
            lc60: 53,
            lc45: 38.5,
            lc30: 25.5,
            lc10: 13
        },
        "navi.500": {
            contrast: 86.53629558471387,
            lc60: 59,
            lc45: 43,
            lc30: 28.5,
            lc10: 15
        },
        "navi.600": {
            contrast: 82.42077066614014,
            lc60: 64,
            lc45: 47,
            lc30: 31,
            lc10: 16
        },
        "navi.700": {
            contrast: 78.17114571210732,
            lc60: 70,
            lc45: 51,
            lc30: 33,
            lc10: 17
        },
        "navi.800": {
            contrast: 73.14166689004476,
            lc60: 77,
            lc45: 55.5,
            lc30: 36.5,
            lc10: 19
        },
        "navi.900": {
            contrast: 68.5005352183235,
            lc60: 84,
            lc45: 60.5,
            lc30: 39.5,
            lc10: 20.5
        },
        "navi.1000": {
            contrast: 64.205109566897,
            lc60: 91.5,
            lc45: 65.5,
            lc30: 43,
            lc10: 22
        },
        "navi.1100": {
            contrast: 59.68265706665795,
            lc60: 100,
            lc45: 71.5,
            lc30: 46.5,
            lc10: 24
        },
        "navi.1200": {
            contrast: 54.668561988765404,
            lc60: 100,
            lc45: 80,
            lc30: 52,
            lc10: 26.5
        },
        "navi.1300": {
            contrast: 49.57539539549624,
            lc60: 100,
            lc45: 89.5,
            lc30: 57.5,
            lc10: 30
        },
        "navi.1400": {
            contrast: 45.039071312376535,
            lc60: 100,
            lc45: 99.5,
            lc30: 64.5,
            lc10: 33.5
        },
        "navi.1500": {
            contrast: 40.393944977588596,
            lc60: 100,
            lc45: 100,
            lc30: 73,
            lc10: 37.5
        },
        "navi.1600": {
            contrast: 35.42963108200607,
            lc60: 100,
            lc45: 100,
            lc30: 83.5,
            lc10: 43.5
        },
        "navi.1700": {
            contrast: 30.533686328385357,
            lc60: 100,
            lc45: 100,
            lc30: 98,
            lc10: 50.5
        },
        "navi.1800": {
            contrast: 25.037271200973272,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62
        },
        "navi.1900": {
            contrast: 19.817967126499806,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78
        },
        "navi.2000": {
            contrast: 14.426637046101115,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2100": {
            contrast: 8.765736302952277,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2500": {
            contrast: 11.159979652178965,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "navi.2400": {
        "navi.100": {
            contrast: 99.89177625879418,
            lc60: 47,
            lc45: 34.5,
            lc30: 23,
            lc10: 12
        },
        "navi.200": {
            contrast: 99.16358879284671,
            lc60: 48.5,
            lc45: 35.5,
            lc30: 23.5,
            lc10: 12.5
        },
        "navi.300": {
            contrast: 97.27527927530072,
            lc60: 49,
            lc45: 36,
            lc30: 24,
            lc10: 12.5
        },
        "navi.400": {
            contrast: 94.85562811452344,
            lc60: 49.5,
            lc45: 36.5,
            lc30: 24,
            lc10: 12.5
        },
        "navi.500": {
            contrast: 92.43377451520428,
            lc60: 54.5,
            lc45: 40,
            lc30: 26.5,
            lc10: 13.5
        },
        "navi.600": {
            contrast: 88.31824959663057,
            lc60: 59,
            lc45: 43,
            lc30: 28.5,
            lc10: 15
        },
        "navi.700": {
            contrast: 84.06862464259771,
            lc60: 64,
            lc45: 46.5,
            lc30: 31,
            lc10: 16
        },
        "navi.800": {
            contrast: 79.03914582053517,
            lc60: 70,
            lc45: 50.5,
            lc30: 33.5,
            lc10: 17.5
        },
        "navi.900": {
            contrast: 74.3980141488139,
            lc60: 76,
            lc45: 55,
            lc30: 36.5,
            lc10: 19
        },
        "navi.1000": {
            contrast: 70.10258849738742,
            lc60: 82,
            lc45: 59.5,
            lc30: 39,
            lc10: 20.5
        },
        "navi.1100": {
            contrast: 65.58013599714835,
            lc60: 89,
            lc45: 64.5,
            lc30: 42.5,
            lc10: 22.5
        },
        "navi.1200": {
            contrast: 60.56604091925581,
            lc60: 98.5,
            lc45: 71,
            lc30: 46.5,
            lc10: 24
        },
        "navi.1300": {
            contrast: 55.472874325986645,
            lc60: 100,
            lc45: 78.5,
            lc30: 51.5,
            lc10: 26.5
        },
        "navi.1400": {
            contrast: 50.93655024286694,
            lc60: 100,
            lc45: 86.5,
            lc30: 56.5,
            lc10: 29.5
        },
        "navi.1500": {
            contrast: 46.291423908079004,
            lc60: 100,
            lc45: 97,
            lc30: 63,
            lc10: 32.5
        },
        "navi.1600": {
            contrast: 41.327110012496476,
            lc60: 100,
            lc45: 100,
            lc30: 71.5,
            lc10: 36.5
        },
        "navi.1700": {
            contrast: 36.43116525887576,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 42
        },
        "navi.1800": {
            contrast: 30.93475013146368,
            lc60: 100,
            lc45: 100,
            lc30: 97,
            lc10: 50
        },
        "navi.1900": {
            contrast: 25.71544605699021,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "navi.2000": {
            contrast: 20.32411597659152,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75.5
        },
        "navi.2100": {
            contrast: 14.663215233442683,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2200": {
            contrast: 8.951130795251263,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "navi.2500": {
        "navi.100": {
            contrast: 106.04067321268862,
            lc60: 44,
            lc45: 32.5,
            lc30: 21.5,
            lc10: 11.5
        },
        "navi.200": {
            contrast: 105.31248574674115,
            lc60: 45.5,
            lc45: 33.5,
            lc30: 22.5,
            lc10: 12
        },
        "navi.300": {
            contrast: 103.42417622919515,
            lc60: 46,
            lc45: 33.5,
            lc30: 22.5,
            lc10: 12
        },
        "navi.400": {
            contrast: 101.00452506841786,
            lc60: 46,
            lc45: 34,
            lc30: 22.5,
            lc10: 12
        },
        "navi.500": {
            contrast: 98.58267146909868,
            lc60: 51,
            lc45: 37.5,
            lc30: 25,
            lc10: 13
        },
        "navi.600": {
            contrast: 94.46714655052496,
            lc60: 55,
            lc45: 40,
            lc30: 26.5,
            lc10: 14
        },
        "navi.700": {
            contrast: 90.21752159649213,
            lc60: 59,
            lc45: 43,
            lc30: 28.5,
            lc10: 15
        },
        "navi.800": {
            contrast: 85.18804277442959,
            lc60: 64,
            lc45: 46.5,
            lc30: 31,
            lc10: 16
        },
        "navi.900": {
            contrast: 80.54691110270832,
            lc60: 69,
            lc45: 50.5,
            lc30: 33.5,
            lc10: 17.5
        },
        "navi.1000": {
            contrast: 76.25148545128182,
            lc60: 74,
            lc45: 54,
            lc30: 36,
            lc10: 18.5
        },
        "navi.1100": {
            contrast: 71.72903295104277,
            lc60: 80,
            lc45: 58,
            lc30: 38.5,
            lc10: 20
        },
        "navi.1200": {
            contrast: 66.71493787315022,
            lc60: 87.5,
            lc45: 63.5,
            lc30: 42,
            lc10: 22
        },
        "navi.1300": {
            contrast: 61.62177127988105,
            lc60: 97,
            lc45: 69.5,
            lc30: 45.5,
            lc10: 24
        },
        "navi.1400": {
            contrast: 57.08544719676135,
            lc60: 100,
            lc45: 76,
            lc30: 50,
            lc10: 26.5
        },
        "navi.1500": {
            contrast: 52.44032086197342,
            lc60: 100,
            lc45: 84,
            lc30: 55,
            lc10: 29
        },
        "navi.1600": {
            contrast: 47.47600696639089,
            lc60: 100,
            lc45: 93.5,
            lc30: 61.5,
            lc10: 32.5
        },
        "navi.1700": {
            contrast: 42.58006221277017,
            lc60: 100,
            lc45: 100,
            lc30: 69,
            lc10: 36.5
        },
        "navi.1800": {
            contrast: 37.08364708535809,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 42.5
        },
        "navi.1900": {
            contrast: 31.86434301088462,
            lc60: 100,
            lc45: 100,
            lc30: 94,
            lc10: 50
        },
        "navi.2000": {
            contrast: 26.47301293048593,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "navi.2100": {
            contrast: 20.812112187337096,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75
        },
        "navi.2200": {
            contrast: 15.100027749145676,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98.5
        },
        "navi.2300": {
            contrast: 9.54949856452588,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    }
};
const $f8fd43f1ee3f8cd8$var$violet = {
    "violet.100": {
        "violet.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.600": {
            contrast: 8.021621128930056,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.700": {
            contrast: 12.006175363982127,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.800": {
            contrast: 16.065937446174292,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 96.5
        },
        "violet.900": {
            contrast: 20.037516239409438,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86.5
        },
        "violet.1000": {
            contrast: 23.872988444421463,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79
        },
        "violet.1100": {
            contrast: 28.028856617201274,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72.5
        },
        "violet.1200": {
            contrast: 31.091523963561556,
            lc60: 100,
            lc45: 100,
            lc30: 98,
            lc10: 68
        },
        "violet.1300": {
            contrast: 37.183276434356074,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 61.5
        },
        "violet.1400": {
            contrast: 41.51381154923055,
            lc60: 100,
            lc45: 100,
            lc30: 83,
            lc10: 57.5
        },
        "violet.1500": {
            contrast: 46.256587787092165,
            lc60: 100,
            lc45: 98,
            lc30: 77.5,
            lc10: 54
        },
        "violet.1600": {
            contrast: 51.069545281052505,
            lc60: 100,
            lc45: 92.5,
            lc30: 73,
            lc10: 51
        },
        "violet.1700": {
            contrast: 56.310645079484935,
            lc60: 100,
            lc45: 87,
            lc30: 69,
            lc10: 48
        },
        "violet.1800": {
            contrast: 61.83943680712674,
            lc60: 98,
            lc45: 82,
            lc30: 65,
            lc10: 45.5
        },
        "violet.1900": {
            contrast: 67.52003819106858,
            lc60: 93,
            lc45: 78,
            lc30: 61.5,
            lc10: 43
        },
        "violet.2000": {
            contrast: 73.36696865003674,
            lc60: 88,
            lc45: 74,
            lc30: 58.5,
            lc10: 40.5
        },
        "violet.2100": {
            contrast: 80.08752353583577,
            lc60: 83.5,
            lc45: 70,
            lc30: 55.5,
            lc10: 38.5
        },
        "violet.2200": {
            contrast: 86.69457023589052,
            lc60: 79,
            lc45: 66.5,
            lc30: 52.5,
            lc10: 36.5
        },
        "violet.2300": {
            contrast: 93.35009452127872,
            lc60: 76,
            lc45: 63.5,
            lc30: 50,
            lc10: 35
        },
        "violet.2400": {
            contrast: 100.85853646693488,
            lc60: 72,
            lc45: 60.5,
            lc30: 48,
            lc10: 33.5
        },
        "violet.2500": {
            contrast: 107.88473318309848,
            lc60: 69,
            lc45: 58,
            lc30: 46,
            lc10: 32
        }
    },
    "violet.200": {
        "violet.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.600": {
            contrast: 7.643877448650843,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.700": {
            contrast: 11.628431683702917,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.800": {
            contrast: 15.688193765895084,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 97
        },
        "violet.900": {
            contrast: 19.65977255913023,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85
        },
        "violet.1000": {
            contrast: 23.495244764142257,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76
        },
        "violet.1100": {
            contrast: 27.65111293692207,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "violet.1200": {
            contrast: 30.71378028328235,
            lc60: 100,
            lc45: 100,
            lc30: 98.5,
            lc10: 64.5
        },
        "violet.1300": {
            contrast: 36.805532754076864,
            lc60: 100,
            lc45: 100,
            lc30: 87.5,
            lc10: 57.5
        },
        "violet.1400": {
            contrast: 41.13606786895134,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 54
        },
        "violet.1500": {
            contrast: 45.878844106812956,
            lc60: 100,
            lc45: 98.5,
            lc30: 76,
            lc10: 50
        },
        "violet.1600": {
            contrast: 50.6918016007733,
            lc60: 100,
            lc45: 92.5,
            lc30: 71,
            lc10: 47
        },
        "violet.1700": {
            contrast: 55.93290139920571,
            lc60: 100,
            lc45: 86.5,
            lc30: 67,
            lc10: 44
        },
        "violet.1800": {
            contrast: 61.461693126847514,
            lc60: 98,
            lc45: 81.5,
            lc30: 63,
            lc10: 41.5
        },
        "violet.1900": {
            contrast: 67.14229451078936,
            lc60: 93,
            lc45: 77,
            lc30: 59.5,
            lc10: 39.5
        },
        "violet.2000": {
            contrast: 72.98922496975752,
            lc60: 88,
            lc45: 72.5,
            lc30: 56.5,
            lc10: 37.5
        },
        "violet.2100": {
            contrast: 79.70977985555656,
            lc60: 83,
            lc45: 69,
            lc30: 53,
            lc10: 35.5
        },
        "violet.2200": {
            contrast: 86.3168265556113,
            lc60: 78.5,
            lc45: 65,
            lc30: 50.5,
            lc10: 33.5
        },
        "violet.2300": {
            contrast: 92.97235084099951,
            lc60: 75,
            lc45: 62,
            lc30: 48.5,
            lc10: 32
        },
        "violet.2400": {
            contrast: 100.48079278665567,
            lc60: 71,
            lc45: 59.5,
            lc30: 46,
            lc10: 31
        },
        "violet.2500": {
            contrast: 107.50698950281925,
            lc60: 68,
            lc45: 56.5,
            lc30: 44,
            lc10: 29.5
        }
    },
    "violet.300": {
        "violet.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.700": {
            contrast: 10.472732160746734,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.800": {
            contrast: 14.532494242938899,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.900": {
            contrast: 18.504073036174045,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86.5
        },
        "violet.1000": {
            contrast: 22.339545241186073,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76
        },
        "violet.1100": {
            contrast: 26.495413413965878,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "violet.1200": {
            contrast: 29.55808076032616,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "violet.1300": {
            contrast: 35.64983323112068,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 55.5
        },
        "violet.1400": {
            contrast: 39.98036834599515,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 51.5
        },
        "violet.1500": {
            contrast: 44.723144583856765,
            lc60: 100,
            lc45: 100,
            lc30: 76,
            lc10: 48
        },
        "violet.1600": {
            contrast: 49.53610207781711,
            lc60: 100,
            lc45: 93.5,
            lc30: 71,
            lc10: 44.5
        },
        "violet.1700": {
            contrast: 54.777201876249535,
            lc60: 100,
            lc45: 87,
            lc30: 66,
            lc10: 42
        },
        "violet.1800": {
            contrast: 60.30599360389134,
            lc60: 99.5,
            lc45: 81.5,
            lc30: 62,
            lc10: 39.5
        },
        "violet.1900": {
            contrast: 65.98659498783319,
            lc60: 93.5,
            lc45: 76.5,
            lc30: 58.5,
            lc10: 37.5
        },
        "violet.2000": {
            contrast: 71.83352544680133,
            lc60: 88,
            lc45: 72.5,
            lc30: 55,
            lc10: 35
        },
        "violet.2100": {
            contrast: 78.55408033260038,
            lc60: 83,
            lc45: 68.5,
            lc30: 52,
            lc10: 33.5
        },
        "violet.2200": {
            contrast: 85.16112703265513,
            lc60: 78.5,
            lc45: 64.5,
            lc30: 49.5,
            lc10: 32
        },
        "violet.2300": {
            contrast: 91.81665131804333,
            lc60: 75,
            lc45: 61.5,
            lc30: 47.5,
            lc10: 30.5
        },
        "violet.2400": {
            contrast: 99.32509326369949,
            lc60: 71,
            lc45: 59,
            lc30: 45,
            lc10: 29
        },
        "violet.2500": {
            contrast: 106.35128997986307,
            lc60: 68,
            lc45: 56,
            lc30: 43,
            lc10: 28
        }
    },
    "violet.400": {
        "violet.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.700": {
            contrast: 8.828133340852434,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.800": {
            contrast: 12.887895423044599,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.900": {
            contrast: 16.859474216279743,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91.5
        },
        "violet.1000": {
            contrast: 20.69494642129177,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78.5
        },
        "violet.1100": {
            contrast: 24.850814594071583,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "violet.1200": {
            contrast: 27.91348194043186,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63.5
        },
        "violet.1300": {
            contrast: 34.005234411226375,
            lc60: 100,
            lc45: 100,
            lc30: 91,
            lc10: 54.5
        },
        "violet.1400": {
            contrast: 38.335769526100854,
            lc60: 100,
            lc45: 100,
            lc30: 83,
            lc10: 50.5
        },
        "violet.1500": {
            contrast: 43.07854576396247,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 46.5
        },
        "violet.1600": {
            contrast: 47.89150325792281,
            lc60: 100,
            lc45: 95.5,
            lc30: 71,
            lc10: 43.5
        },
        "violet.1700": {
            contrast: 53.13260305635523,
            lc60: 100,
            lc45: 88.5,
            lc30: 66,
            lc10: 40.5
        },
        "violet.1800": {
            contrast: 58.66139478399703,
            lc60: 100,
            lc45: 82.5,
            lc30: 62,
            lc10: 38
        },
        "violet.1900": {
            contrast: 64.34199616793887,
            lc60: 94.5,
            lc45: 77.5,
            lc30: 58,
            lc10: 36
        },
        "violet.2000": {
            contrast: 70.18892662690703,
            lc60: 89.5,
            lc45: 73,
            lc30: 55,
            lc10: 34
        },
        "violet.2100": {
            contrast: 76.90948151270608,
            lc60: 84,
            lc45: 68.5,
            lc30: 52,
            lc10: 32.5
        },
        "violet.2200": {
            contrast: 83.51652821276083,
            lc60: 79.5,
            lc45: 65,
            lc30: 49,
            lc10: 31
        },
        "violet.2300": {
            contrast: 90.17205249814903,
            lc60: 75.5,
            lc45: 62,
            lc30: 47,
            lc10: 30
        },
        "violet.2400": {
            contrast: 97.68049444380519,
            lc60: 71.5,
            lc45: 58.5,
            lc30: 45,
            lc10: 28.5
        },
        "violet.2500": {
            contrast: 104.70669115996878,
            lc60: 68.5,
            lc45: 56,
            lc30: 43,
            lc10: 27
        }
    },
    "violet.500": {
        "violet.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.800": {
            contrast: 10.369185866552453,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.900": {
            contrast: 14.3407646597876,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1000": {
            contrast: 18.176236864799627,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85.5
        },
        "violet.1100": {
            contrast: 22.33210503757944,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73
        },
        "violet.1200": {
            contrast: 25.394772383939717,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66.5
        },
        "violet.1300": {
            contrast: 31.48652485473423,
            lc60: 100,
            lc45: 100,
            lc30: 96,
            lc10: 56.5
        },
        "violet.1400": {
            contrast: 35.817059969608714,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 51.5
        },
        "violet.1500": {
            contrast: 40.559836207470326,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 47.5
        },
        "violet.1600": {
            contrast: 45.372793701430666,
            lc60: 100,
            lc45: 99.5,
            lc30: 73.5,
            lc10: 44
        },
        "violet.1700": {
            contrast: 50.61389349986308,
            lc60: 100,
            lc45: 91.5,
            lc30: 68,
            lc10: 41
        },
        "violet.1800": {
            contrast: 56.142685227504884,
            lc60: 100,
            lc45: 85,
            lc30: 63.5,
            lc10: 38
        },
        "violet.1900": {
            contrast: 61.823286611446726,
            lc60: 97.5,
            lc45: 79.5,
            lc30: 59.5,
            lc10: 36
        },
        "violet.2000": {
            contrast: 67.67021707041489,
            lc60: 91.5,
            lc45: 74.5,
            lc30: 56,
            lc10: 34
        },
        "violet.2100": {
            contrast: 74.39077195621394,
            lc60: 86,
            lc45: 70,
            lc30: 52.5,
            lc10: 32.5
        },
        "violet.2200": {
            contrast: 80.99781865626868,
            lc60: 81,
            lc45: 66.5,
            lc30: 50,
            lc10: 31
        },
        "violet.2300": {
            contrast: 87.65334294165687,
            lc60: 77,
            lc45: 63,
            lc30: 47.5,
            lc10: 30
        },
        "violet.2400": {
            contrast: 95.16178488731303,
            lc60: 73,
            lc45: 59.5,
            lc30: 45.5,
            lc10: 28.5
        },
        "violet.2500": {
            contrast: 102.18798160347662,
            lc60: 69.5,
            lc45: 57,
            lc30: 43.5,
            lc10: 27.5
        }
    },
    "violet.600": {
        "violet.100": {
            contrast: 9.342206669233615,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.200": {
            contrast: 8.835432807002402,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.300": {
            contrast: 7.320823165487382,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.900": {
            contrast: 10.674031391903888,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1000": {
            contrast: 14.509503596915915,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1100": {
            contrast: 18.665371769695728,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84
        },
        "violet.1200": {
            contrast: 21.72803911605601,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74
        },
        "violet.1300": {
            contrast: 27.819791586850524,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62
        },
        "violet.1400": {
            contrast: 32.15032670172499,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 55.5
        },
        "violet.1500": {
            contrast: 36.89310293958661,
            lc60: 100,
            lc45: 100,
            lc30: 85.5,
            lc10: 50.5
        },
        "violet.1600": {
            contrast: 41.70606043354695,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 46.5
        },
        "violet.1700": {
            contrast: 46.947160231979375,
            lc60: 100,
            lc45: 97,
            lc30: 72,
            lc10: 43
        },
        "violet.1800": {
            contrast: 52.475951959621185,
            lc60: 100,
            lc45: 89.5,
            lc30: 67,
            lc10: 40
        },
        "violet.1900": {
            contrast: 58.15655334356302,
            lc60: 100,
            lc45: 83,
            lc30: 62.5,
            lc10: 38
        },
        "violet.2000": {
            contrast: 64.00348380253118,
            lc60: 95.5,
            lc45: 78,
            lc30: 58.5,
            lc10: 36
        },
        "violet.2100": {
            contrast: 70.72403868833021,
            lc60: 89.5,
            lc45: 73,
            lc30: 55.5,
            lc10: 34
        },
        "violet.2200": {
            contrast: 77.33108538838496,
            lc60: 83.5,
            lc45: 69,
            lc30: 52,
            lc10: 32.5
        },
        "violet.2300": {
            contrast: 83.98660967377317,
            lc60: 79.5,
            lc45: 65.5,
            lc30: 49.5,
            lc10: 31.5
        },
        "violet.2400": {
            contrast: 91.49505161942932,
            lc60: 75.5,
            lc45: 62,
            lc30: 47.5,
            lc10: 30
        },
        "violet.2500": {
            contrast: 98.52124833559292,
            lc60: 71.5,
            lc45: 59.5,
            lc30: 45.5,
            lc10: 28.5
        }
    },
    "violet.700": {
        "violet.100": {
            contrast: 13.692148886430402,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.200": {
            contrast: 13.185375024199194,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.300": {
            contrast: 11.670765382684174,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.400": {
            contrast: 9.587757736082855,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1000": {
            contrast: 10.709749262533172,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1100": {
            contrast: 14.865617435312984,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1200": {
            contrast: 17.928284781673263,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87.5
        },
        "violet.1300": {
            contrast: 24.020037252467784,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69.5
        },
        "violet.1400": {
            contrast: 28.350572367342252,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62
        },
        "violet.1500": {
            contrast: 33.093348605203865,
            lc60: 100,
            lc45: 100,
            lc30: 93,
            lc10: 55.5
        },
        "violet.1600": {
            contrast: 37.90630609916421,
            lc60: 100,
            lc45: 100,
            lc30: 84,
            lc10: 50.5
        },
        "violet.1700": {
            contrast: 43.14740589759663,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 46.5
        },
        "violet.1800": {
            contrast: 48.67619762523844,
            lc60: 100,
            lc45: 94.5,
            lc30: 71,
            lc10: 43
        },
        "violet.1900": {
            contrast: 54.35679900918028,
            lc60: 100,
            lc45: 87.5,
            lc30: 66,
            lc10: 41
        },
        "violet.2000": {
            contrast: 60.20372946814844,
            lc60: 99.5,
            lc45: 82,
            lc30: 62,
            lc10: 38.5
        },
        "violet.2100": {
            contrast: 66.92428435394747,
            lc60: 92.5,
            lc45: 76.5,
            lc30: 58,
            lc10: 36.5
        },
        "violet.2200": {
            contrast: 73.53133105400222,
            lc60: 87,
            lc45: 72,
            lc30: 55,
            lc10: 35
        },
        "violet.2300": {
            contrast: 80.18685533939043,
            lc60: 82.5,
            lc45: 68,
            lc30: 52.5,
            lc10: 33.5
        },
        "violet.2400": {
            contrast: 87.69529728504658,
            lc60: 78,
            lc45: 64.5,
            lc30: 50,
            lc10: 32
        },
        "violet.2500": {
            contrast: 94.72149400121016,
            lc60: 74,
            lc45: 62,
            lc30: 48,
            lc10: 31
        }
    },
    "violet.800": {
        "violet.100": {
            contrast: 18.029329360355387,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60.5
        },
        "violet.200": {
            contrast: 17.522555498124174,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "violet.300": {
            contrast: 16.00794585660915,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 90
        },
        "violet.400": {
            contrast: 13.92493821000784,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.500": {
            contrast: 10.853084051845965,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1100": {
            contrast: 10.952056078249075,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1200": {
            contrast: 14.014723424609357,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1300": {
            contrast: 20.10647589540387,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79.5
        },
        "violet.1400": {
            contrast: 24.43701101027835,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "violet.1500": {
            contrast: 29.179787248139956,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60.5
        },
        "violet.1600": {
            contrast: 33.99274474210031,
            lc60: 100,
            lc45: 100,
            lc30: 91.5,
            lc10: 53.5
        },
        "violet.1700": {
            contrast: 39.23384454053272,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 49
        },
        "violet.1800": {
            contrast: 44.76263626817453,
            lc60: 100,
            lc45: 100,
            lc30: 75,
            lc10: 45
        },
        "violet.1900": {
            contrast: 50.443237652116366,
            lc60: 100,
            lc45: 92,
            lc30: 69,
            lc10: 42
        },
        "violet.2000": {
            contrast: 56.290168111084526,
            lc60: 100,
            lc45: 85,
            lc30: 64.5,
            lc10: 39
        },
        "violet.2100": {
            contrast: 63.01072299688357,
            lc60: 96.5,
            lc45: 79,
            lc30: 60,
            lc10: 37
        },
        "violet.2200": {
            contrast: 69.61776969693832,
            lc60: 90.5,
            lc45: 74.5,
            lc30: 56.5,
            lc10: 35.5
        },
        "violet.2300": {
            contrast: 76.27329398232654,
            lc60: 85,
            lc45: 70,
            lc30: 53.5,
            lc10: 33.5
        },
        "violet.2400": {
            contrast: 83.78173592798267,
            lc60: 80,
            lc45: 66,
            lc30: 50.5,
            lc10: 32
        },
        "violet.2500": {
            contrast: 90.80793264414626,
            lc60: 76,
            lc45: 63,
            lc30: 48.5,
            lc10: 31
        }
    },
    "violet.900": {
        "violet.100": {
            contrast: 22.198086017927906,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 46.5
        },
        "violet.200": {
            contrast: 21.691312155696696,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "violet.300": {
            contrast: 20.176702514181674,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "violet.400": {
            contrast: 18.093694867580357,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79
        },
        "violet.500": {
            contrast: 15.021840709418482,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 99
        },
        "violet.600": {
            contrast: 10.72868926629143,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1200": {
            contrast: 10.15225642621907,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1300": {
            contrast: 16.244008897013586,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93
        },
        "violet.1400": {
            contrast: 20.57454401188806,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77.5
        },
        "violet.1500": {
            contrast: 25.31732024974967,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65
        },
        "violet.1600": {
            contrast: 30.13027774371002,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 57.5
        },
        "violet.1700": {
            contrast: 35.37137754214244,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 51
        },
        "violet.1800": {
            contrast: 40.90016926978425,
            lc60: 100,
            lc45: 100,
            lc30: 79,
            lc10: 46.5
        },
        "violet.1900": {
            contrast: 46.580770653726084,
            lc60: 100,
            lc45: 97,
            lc30: 72,
            lc10: 42.5
        },
        "violet.2000": {
            contrast: 52.427701112694244,
            lc60: 100,
            lc45: 89,
            lc30: 66.5,
            lc10: 39
        },
        "violet.2100": {
            contrast: 59.14825599849328,
            lc60: 100,
            lc45: 82,
            lc30: 61.5,
            lc10: 37
        },
        "violet.2200": {
            contrast: 65.75530269854804,
            lc60: 93.5,
            lc45: 76.5,
            lc30: 57.5,
            lc10: 34.5
        },
        "violet.2300": {
            contrast: 72.41082698393623,
            lc60: 87.5,
            lc45: 71.5,
            lc30: 54,
            lc10: 33
        },
        "violet.2400": {
            contrast: 79.91926892959239,
            lc60: 82,
            lc45: 67,
            lc30: 50.5,
            lc10: 31
        },
        "violet.2500": {
            contrast: 86.94546564575597,
            lc60: 77.5,
            lc45: 63.5,
            lc30: 48,
            lc10: 30
        }
    },
    "violet.1000": {
        "violet.100": {
            contrast: 26.165916569642583,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 40.5
        },
        "violet.200": {
            contrast: 25.659142707411377,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 47
        },
        "violet.300": {
            contrast: 24.144533065896358,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54.5
        },
        "violet.400": {
            contrast: 22.06152541929504,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "violet.500": {
            contrast: 18.989671261133168,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78.5
        },
        "violet.600": {
            contrast: 14.696519818006115,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.700": {
            contrast: 10.40658228792826,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1300": {
            contrast: 12.486725829610535,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1400": {
            contrast: 16.817260944485014,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 90.5
        },
        "violet.1500": {
            contrast: 21.560037182346623,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74
        },
        "violet.1600": {
            contrast: 26.372994676306966,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63.5
        },
        "violet.1700": {
            contrast: 31.61409447473939,
            lc60: 100,
            lc45: 100,
            lc30: 96,
            lc10: 55.5
        },
        "violet.1800": {
            contrast: 37.1428862023812,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 49
        },
        "violet.1900": {
            contrast: 42.82348758632303,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 45
        },
        "violet.2000": {
            contrast: 48.6704180452912,
            lc60: 100,
            lc45: 94.5,
            lc30: 69.5,
            lc10: 41
        },
        "violet.2100": {
            contrast: 55.39097293109023,
            lc60: 100,
            lc45: 86,
            lc30: 64,
            lc10: 38.5
        },
        "violet.2200": {
            contrast: 61.998019631144984,
            lc60: 97.5,
            lc45: 79.5,
            lc30: 59,
            lc10: 35.5
        },
        "violet.2300": {
            contrast: 68.6535439165332,
            lc60: 91,
            lc45: 74,
            lc30: 56,
            lc10: 33.5
        },
        "violet.2400": {
            contrast: 76.16198586218934,
            lc60: 84.5,
            lc45: 69,
            lc30: 52,
            lc10: 31.5
        },
        "violet.2500": {
            contrast: 83.18818257835292,
            lc60: 79.5,
            lc45: 65.5,
            lc30: 49,
            lc10: 30
        }
    },
    "violet.1100": {
        "violet.100": {
            contrast: 30.410149252266887,
            lc60: 100,
            lc45: 100,
            lc30: 87.5,
            lc10: 35
        },
        "violet.200": {
            contrast: 29.90337539003568,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 40.5
        },
        "violet.300": {
            contrast: 28.38876574852066,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 46.5
        },
        "violet.400": {
            contrast: 26.305758101919345,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53
        },
        "violet.500": {
            contrast: 23.23390394375747,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63
        },
        "violet.600": {
            contrast: 18.94075250063042,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78
        },
        "violet.700": {
            contrast: 14.650814970552565,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.800": {
            contrast: 10.35800563063397,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1300": {
            contrast: 8.38926295921561,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1400": {
            contrast: 12.719798074090088,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1500": {
            contrast: 17.4625743119517,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87.5
        },
        "violet.1600": {
            contrast: 22.275531805912046,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72
        },
        "violet.1700": {
            contrast: 27.51663160434446,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61.5
        },
        "violet.1800": {
            contrast: 33.04542333198627,
            lc60: 100,
            lc45: 100,
            lc30: 92.5,
            lc10: 53.5
        },
        "violet.1900": {
            contrast: 38.72602471592811,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 47.5
        },
        "violet.2000": {
            contrast: 44.572955174896265,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 43.5
        },
        "violet.2100": {
            contrast: 51.293510060695304,
            lc60: 100,
            lc45: 90.5,
            lc30: 67.5,
            lc10: 40
        },
        "violet.2200": {
            contrast: 57.90055676075006,
            lc60: 100,
            lc45: 83.5,
            lc30: 62,
            lc10: 37
        },
        "violet.2300": {
            contrast: 64.55608104613826,
            lc60: 94.5,
            lc45: 77.5,
            lc30: 57.5,
            lc10: 34.5
        },
        "violet.2400": {
            contrast: 72.0645229917944,
            lc60: 88,
            lc45: 71.5,
            lc30: 53.5,
            lc10: 32.5
        },
        "violet.2500": {
            contrast: 79.09071970795799,
            lc60: 82,
            lc45: 67.5,
            lc30: 50.5,
            lc10: 30.5
        }
    },
    "violet.1200": {
        "violet.100": {
            contrast: 33.50568852249586,
            lc60: 100,
            lc45: 100,
            lc30: 70,
            lc10: 32
        },
        "violet.200": {
            contrast: 32.99891466026465,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 37
        },
        "violet.300": {
            contrast: 31.48430501874963,
            lc60: 100,
            lc45: 100,
            lc30: 91,
            lc10: 41.5
        },
        "violet.400": {
            contrast: 29.401297372148317,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 47.5
        },
        "violet.500": {
            contrast: 26.329443213986437,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "violet.600": {
            contrast: 22.036291770859386,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "violet.700": {
            contrast: 17.746354240781535,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83
        },
        "violet.800": {
            contrast: 13.45354490086294,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.900": {
            contrast: 9.315280532169856,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1400": {
            contrast: 9.684492937970388,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1500": {
            contrast: 14.427269175832,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1600": {
            contrast: 19.240226669792342,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81.5
        },
        "violet.1700": {
            contrast: 24.481326468224765,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67
        },
        "violet.1800": {
            contrast: 30.01011819586657,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 56.5
        },
        "violet.1900": {
            contrast: 35.6907195798084,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 49.5
        },
        "violet.2000": {
            contrast: 41.53765003877656,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 45
        },
        "violet.2100": {
            contrast: 48.25820492457561,
            lc60: 100,
            lc45: 94.5,
            lc30: 69.5,
            lc10: 41
        },
        "violet.2200": {
            contrast: 54.86525162463036,
            lc60: 100,
            lc45: 86.5,
            lc30: 63.5,
            lc10: 37.5
        },
        "violet.2300": {
            contrast: 61.52077591001856,
            lc60: 97.5,
            lc45: 79.5,
            lc30: 59,
            lc10: 34.5
        },
        "violet.2400": {
            contrast: 69.0292178556747,
            lc60: 90.5,
            lc45: 73.5,
            lc30: 54.5,
            lc10: 32.5
        },
        "violet.2500": {
            contrast: 76.05541457183828,
            lc60: 84,
            lc45: 68.5,
            lc30: 51,
            lc10: 30.5
        }
    },
    "violet.1300": {
        "violet.100": {
            contrast: 39.591734741741945,
            lc60: 100,
            lc45: 100,
            lc30: 56.5,
            lc10: 27.5
        },
        "violet.200": {
            contrast: 39.084960879510746,
            lc60: 100,
            lc45: 100,
            lc30: 63.5,
            lc10: 31.5
        },
        "violet.300": {
            contrast: 37.570351237995716,
            lc60: 100,
            lc45: 100,
            lc30: 71,
            lc10: 35
        },
        "violet.400": {
            contrast: 35.487343591394406,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 38.5
        },
        "violet.500": {
            contrast: 32.41548943323252,
            lc60: 100,
            lc45: 100,
            lc30: 90.5,
            lc10: 44
        },
        "violet.600": {
            contrast: 28.12233799010548,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 50.5
        },
        "violet.700": {
            contrast: 23.83240046002762,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59
        },
        "violet.800": {
            contrast: 19.53959112010903,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75
        },
        "violet.900": {
            contrast: 15.401326751415947,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 97
        },
        "violet.1000": {
            contrast: 11.452968825583081,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1500": {
            contrast: 8.354755466683784,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1600": {
            contrast: 13.167712960644126,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1700": {
            contrast: 18.408812759076547,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84.5
        },
        "violet.1800": {
            contrast: 23.93760448671836,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "violet.1900": {
            contrast: 29.61820587066019,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58
        },
        "violet.2000": {
            contrast: 35.46513632962835,
            lc60: 100,
            lc45: 100,
            lc30: 87.5,
            lc10: 50
        },
        "violet.2100": {
            contrast: 42.18569121542739,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 44.5
        },
        "violet.2200": {
            contrast: 48.79273791548214,
            lc60: 100,
            lc45: 93.5,
            lc30: 69,
            lc10: 40
        },
        "violet.2300": {
            contrast: 55.448262200870346,
            lc60: 100,
            lc45: 85.5,
            lc30: 63,
            lc10: 36.5
        },
        "violet.2400": {
            contrast: 62.9567041465265,
            lc60: 96.5,
            lc45: 78,
            lc30: 57.5,
            lc10: 33.5
        },
        "violet.2500": {
            contrast: 69.98290086269007,
            lc60: 89.5,
            lc45: 72.5,
            lc30: 53,
            lc10: 31.5
        }
    },
    "violet.1400": {
        "violet.100": {
            contrast: 43.86727862082987,
            lc60: 100,
            lc45: 100,
            lc30: 51,
            lc10: 25
        },
        "violet.200": {
            contrast: 43.360504758598665,
            lc60: 100,
            lc45: 100,
            lc30: 57,
            lc10: 28.5
        },
        "violet.300": {
            contrast: 41.84589511708365,
            lc60: 100,
            lc45: 100,
            lc30: 63,
            lc10: 31
        },
        "violet.400": {
            contrast: 39.76288747048233,
            lc60: 100,
            lc45: 100,
            lc30: 69.5,
            lc10: 34
        },
        "violet.500": {
            contrast: 36.69103331232046,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 38
        },
        "violet.600": {
            contrast: 32.397881869193405,
            lc60: 100,
            lc45: 100,
            lc30: 90.5,
            lc10: 43
        },
        "violet.700": {
            contrast: 28.107944339115548,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 49
        },
        "violet.800": {
            contrast: 23.81513499919696,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "violet.900": {
            contrast: 19.676870630503878,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74.5
        },
        "violet.1000": {
            contrast: 15.72851270467101,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 94.5
        },
        "violet.1100": {
            contrast: 11.496027613379777,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1200": {
            contrast: 8.403718163962488,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1600": {
            contrast: 8.825234698038331,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1700": {
            contrast: 14.066334496470754,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1800": {
            contrast: 19.595126224112562,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80
        },
        "violet.1900": {
            contrast: 25.275727608054392,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65
        },
        "violet.2000": {
            contrast: 31.122658067022552,
            lc60: 100,
            lc45: 100,
            lc30: 97,
            lc10: 55
        },
        "violet.2100": {
            contrast: 37.843212952821595,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 47.5
        },
        "violet.2200": {
            contrast: 44.45025965287635,
            lc60: 100,
            lc45: 100,
            lc30: 73.5,
            lc10: 41.5
        },
        "violet.2300": {
            contrast: 51.10578393826455,
            lc60: 100,
            lc45: 90.5,
            lc30: 66,
            lc10: 38.5
        },
        "violet.2400": {
            contrast: 58.61422588392069,
            lc60: 100,
            lc45: 81.5,
            lc30: 60,
            lc10: 35
        },
        "violet.2500": {
            contrast: 65.64042260008429,
            lc60: 93,
            lc45: 75,
            lc30: 55.5,
            lc10: 32
        }
    },
    "violet.1500": {
        "violet.100": {
            contrast: 48.506923323029724,
            lc60: 100,
            lc45: 76,
            lc30: 46,
            lc10: 23
        },
        "violet.200": {
            contrast: 48.000149460798525,
            lc60: 100,
            lc45: 84,
            lc30: 51,
            lc10: 25.5
        },
        "violet.300": {
            contrast: 46.4855398192835,
            lc60: 100,
            lc45: 93,
            lc30: 56,
            lc10: 28
        },
        "violet.400": {
            contrast: 44.402532172682186,
            lc60: 100,
            lc45: 100,
            lc30: 61,
            lc10: 30
        },
        "violet.500": {
            contrast: 41.330678014520316,
            lc60: 100,
            lc45: 100,
            lc30: 67,
            lc10: 33
        },
        "violet.600": {
            contrast: 37.03752657139326,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 37
        },
        "violet.700": {
            contrast: 32.74758904131541,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 41
        },
        "violet.800": {
            contrast: 28.45477970139681,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 48.5
        },
        "violet.900": {
            contrast: 24.316515332703734,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "violet.1000": {
            contrast: 20.368157406870864,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72
        },
        "violet.1100": {
            contrast: 16.135672315579633,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91.5
        },
        "violet.1200": {
            contrast: 13.043362866162344,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1700": {
            contrast: 9.288538836565156,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1800": {
            contrast: 14.817330564206966,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1900": {
            contrast: 20.4979319481488,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77
        },
        "violet.2000": {
            contrast: 26.344862407116953,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62
        },
        "violet.2100": {
            contrast: 33.065417292916,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 52.5
        },
        "violet.2200": {
            contrast: 39.672463992970755,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 45
        },
        "violet.2300": {
            contrast: 46.32798827835895,
            lc60: 100,
            lc45: 98,
            lc30: 71,
            lc10: 41
        },
        "violet.2400": {
            contrast: 53.836430224015096,
            lc60: 100,
            lc45: 87,
            lc30: 63.5,
            lc10: 36
        },
        "violet.2500": {
            contrast: 60.86262694017868,
            lc60: 99,
            lc45: 79.5,
            lc30: 58,
            lc10: 33.5
        }
    },
    "violet.1600": {
        "violet.100": {
            contrast: 53.173796904693006,
            lc60: 100,
            lc45: 66.5,
            lc30: 42,
            lc10: 21
        },
        "violet.200": {
            contrast: 52.6670230424618,
            lc60: 100,
            lc45: 73,
            lc30: 46.5,
            lc10: 23
        },
        "violet.300": {
            contrast: 51.15241340094677,
            lc60: 100,
            lc45: 79.5,
            lc30: 50,
            lc10: 25
        },
        "violet.400": {
            contrast: 49.06940575434546,
            lc60: 100,
            lc45: 86.5,
            lc30: 54,
            lc10: 27
        },
        "violet.500": {
            contrast: 45.997551596183584,
            lc60: 100,
            lc45: 97,
            lc30: 59.5,
            lc10: 29.5
        },
        "violet.600": {
            contrast: 41.70440015305654,
            lc60: 100,
            lc45: 100,
            lc30: 66,
            lc10: 32.5
        },
        "violet.700": {
            contrast: 37.414462622978675,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 35.5
        },
        "violet.800": {
            contrast: 33.121653283060084,
            lc60: 100,
            lc45: 100,
            lc30: 87.5,
            lc10: 41
        },
        "violet.900": {
            contrast: 28.983388914367005,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 48.5
        },
        "violet.1000": {
            contrast: 25.035030988534135,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "violet.1100": {
            contrast: 20.802545897242908,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "violet.1200": {
            contrast: 17.71023644782562,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84
        },
        "violet.1300": {
            contrast: 11.618766712211052,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1400": {
            contrast: 7.330954681947145,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1800": {
            contrast: 9.947365576015867,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1900": {
            contrast: 15.627966959957707,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 96.5
        },
        "violet.2000": {
            contrast: 21.474897418925863,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "violet.2100": {
            contrast: 28.195452304724906,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59
        },
        "violet.2200": {
            contrast: 34.802499004779655,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 49.5
        },
        "violet.2300": {
            contrast: 41.45802329016786,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 43.5
        },
        "violet.2400": {
            contrast: 48.96646523582401,
            lc60: 100,
            lc45: 93,
            lc30: 68,
            lc10: 38.5
        },
        "violet.2500": {
            contrast: 55.9926619519876,
            lc60: 100,
            lc45: 84,
            lc30: 61,
            lc10: 35.5
        }
    },
    "violet.1700": {
        "violet.100": {
            contrast: 58.21281870508499,
            lc60: 100,
            lc45: 60,
            lc30: 38.5,
            lc10: 19.5
        },
        "violet.200": {
            contrast: 57.706044842853764,
            lc60: 100,
            lc45: 65.5,
            lc30: 42,
            lc10: 21.5
        },
        "violet.300": {
            contrast: 56.19143520133875,
            lc60: 100,
            lc45: 71,
            lc30: 45,
            lc10: 23
        },
        "violet.400": {
            contrast: 54.10842755473744,
            lc60: 100,
            lc45: 76,
            lc30: 48.5,
            lc10: 24.5
        },
        "violet.500": {
            contrast: 51.036573396575555,
            lc60: 100,
            lc45: 83.5,
            lc30: 52.5,
            lc10: 26.5
        },
        "violet.600": {
            contrast: 46.74342195344851,
            lc60: 100,
            lc45: 94,
            lc30: 57,
            lc10: 28.5
        },
        "violet.700": {
            contrast: 42.45348442337066,
            lc60: 100,
            lc45: 100,
            lc30: 62.5,
            lc10: 30.5
        },
        "violet.800": {
            contrast: 38.16067508345206,
            lc60: 100,
            lc45: 100,
            lc30: 72,
            lc10: 34.5
        },
        "violet.900": {
            contrast: 34.022410714758976,
            lc60: 100,
            lc45: 100,
            lc30: 85,
            lc10: 41
        },
        "violet.1000": {
            contrast: 30.074052788926114,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 47
        },
        "violet.1100": {
            contrast: 25.841567697634883,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "violet.1200": {
            contrast: 22.749258248217593,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64.5
        },
        "violet.1300": {
            contrast: 16.657788512603027,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89
        },
        "violet.1400": {
            contrast: 12.369976482339121,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1500": {
            contrast: 7.709874915442032,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1900": {
            contrast: 10.30221006355485,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.2000": {
            contrast: 16.14914052252301,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 94.5
        },
        "violet.2100": {
            contrast: 22.869695408322052,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69.5
        },
        "violet.2200": {
            contrast: 29.476742108376797,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "violet.2300": {
            contrast: 36.132266393765,
            lc60: 100,
            lc45: 100,
            lc30: 86,
            lc10: 48
        },
        "violet.2400": {
            contrast: 43.64070833942115,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 42
        },
        "violet.2500": {
            contrast: 50.666905055584735,
            lc60: 100,
            lc45: 91,
            lc30: 65.5,
            lc10: 37
        }
    },
    "violet.1800": {
        "violet.100": {
            contrast: 63.484262667268275,
            lc60: 80,
            lc45: 55,
            lc30: 35.5,
            lc10: 18
        },
        "violet.200": {
            contrast: 62.97748880503706,
            lc60: 86.5,
            lc45: 59,
            lc30: 38.5,
            lc10: 19.5
        },
        "violet.300": {
            contrast: 61.46287916352203,
            lc60: 94,
            lc45: 63.5,
            lc30: 41,
            lc10: 21
        },
        "violet.400": {
            contrast: 59.37987151692074,
            lc60: 100,
            lc45: 68,
            lc30: 43.5,
            lc10: 22
        },
        "violet.500": {
            contrast: 56.30801735875885,
            lc60: 100,
            lc45: 73,
            lc30: 46.5,
            lc10: 23.5
        },
        "violet.600": {
            contrast: 52.0148659156318,
            lc60: 100,
            lc45: 80.5,
            lc30: 50,
            lc10: 25
        },
        "violet.700": {
            contrast: 47.724928385553945,
            lc60: 100,
            lc45: 90.5,
            lc30: 54.5,
            lc10: 27
        },
        "violet.800": {
            contrast: 43.43211904563535,
            lc60: 100,
            lc45: 100,
            lc30: 61,
            lc10: 30
        },
        "violet.900": {
            contrast: 39.29385467694227,
            lc60: 100,
            lc45: 100,
            lc30: 70.5,
            lc10: 35
        },
        "violet.1000": {
            contrast: 35.34549675110941,
            lc60: 100,
            lc45: 100,
            lc30: 80.5,
            lc10: 38.5
        },
        "violet.1100": {
            contrast: 31.113011659818174,
            lc60: 100,
            lc45: 100,
            lc30: 95.5,
            lc10: 45
        },
        "violet.1200": {
            contrast: 28.020702210400884,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51
        },
        "violet.1300": {
            contrast: 21.92923247478632,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67
        },
        "violet.1400": {
            contrast: 17.641420444522414,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84
        },
        "violet.1500": {
            contrast: 12.981318877625322,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1600": {
            contrast: 8.28695873681906,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.2000": {
            contrast: 10.507553403153514,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.2100": {
            contrast: 17.228108288952555,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88.5
        },
        "violet.2200": {
            contrast: 23.83515498900731,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "violet.2300": {
            contrast: 30.490679274395504,
            lc60: 100,
            lc45: 100,
            lc30: 98,
            lc10: 56
        },
        "violet.2400": {
            contrast: 37.999121220051656,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 46
        },
        "violet.2500": {
            contrast: 45.025317936215245,
            lc60: 100,
            lc45: 99.5,
            lc30: 71.5,
            lc10: 40
        }
    },
    "violet.1900": {
        "violet.100": {
            contrast: 68.85737373885154,
            lc60: 70.5,
            lc45: 50,
            lc30: 33,
            lc10: 16.5
        },
        "violet.200": {
            contrast: 68.35059987662032,
            lc60: 75.5,
            lc45: 54,
            lc30: 35,
            lc10: 18
        },
        "violet.300": {
            contrast: 66.8359902351053,
            lc60: 81.5,
            lc45: 57.5,
            lc30: 37.5,
            lc10: 19
        },
        "violet.400": {
            contrast: 64.752982588504,
            lc60: 87,
            lc45: 61,
            lc30: 39.5,
            lc10: 20.5
        },
        "violet.500": {
            contrast: 61.68112843034211,
            lc60: 95.5,
            lc45: 65,
            lc30: 42,
            lc10: 21.5
        },
        "violet.600": {
            contrast: 57.38797698721506,
            lc60: 100,
            lc45: 70.5,
            lc30: 44.5,
            lc10: 22.5
        },
        "violet.700": {
            contrast: 53.098039457137205,
            lc60: 100,
            lc45: 76.5,
            lc30: 47.5,
            lc10: 24
        },
        "violet.800": {
            contrast: 48.80523011721861,
            lc60: 100,
            lc45: 87.5,
            lc30: 52.5,
            lc10: 26
        },
        "violet.900": {
            contrast: 44.66696574852553,
            lc60: 100,
            lc45: 100,
            lc30: 60.5,
            lc10: 30
        },
        "violet.1000": {
            contrast: 40.71860782269267,
            lc60: 100,
            lc45: 100,
            lc30: 67.5,
            lc10: 33
        },
        "violet.1100": {
            contrast: 36.48612273140143,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 37
        },
        "violet.1200": {
            contrast: 33.393813281984144,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 42
        },
        "violet.1300": {
            contrast: 27.302343546369574,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53
        },
        "violet.1400": {
            contrast: 23.01453151610567,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "violet.1500": {
            contrast: 18.35442994920858,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81
        },
        "violet.1600": {
            contrast: 13.66006980840232,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1700": {
            contrast: 8.584186376537756,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.2100": {
            contrast: 11.408426769727722,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.2200": {
            contrast: 18.01547346978247,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85
        },
        "violet.2300": {
            contrast: 24.670997755170674,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64.5
        },
        "violet.2400": {
            contrast: 32.179439700826826,
            lc60: 100,
            lc45: 100,
            lc30: 94.5,
            lc10: 52.5
        },
        "violet.2500": {
            contrast: 39.2056364169904,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 44.5
        }
    },
    "violet.2000": {
        "violet.100": {
            contrast: 74.34606353178759,
            lc60: 64.5,
            lc45: 46,
            lc30: 30.5,
            lc10: 15.5
        },
        "violet.200": {
            contrast: 73.83928966955638,
            lc60: 69,
            lc45: 49.5,
            lc30: 32.5,
            lc10: 17
        },
        "violet.300": {
            contrast: 72.32468002804136,
            lc60: 73,
            lc45: 52.5,
            lc30: 34,
            lc10: 17.5
        },
        "violet.400": {
            contrast: 70.24167238144004,
            lc60: 78,
            lc45: 55.5,
            lc30: 36,
            lc10: 18.5
        },
        "violet.500": {
            contrast: 67.16981822327817,
            lc60: 83.5,
            lc45: 58.5,
            lc30: 38,
            lc10: 19.5
        },
        "violet.600": {
            contrast: 62.87666678015111,
            lc60: 92,
            lc45: 62.5,
            lc30: 40,
            lc10: 20.5
        },
        "violet.700": {
            contrast: 58.58672925007327,
            lc60: 100,
            lc45: 66.5,
            lc30: 42,
            lc10: 21
        },
        "violet.800": {
            contrast: 54.29391991015468,
            lc60: 100,
            lc45: 74.5,
            lc30: 46.5,
            lc10: 23
        },
        "violet.900": {
            contrast: 50.155655541461584,
            lc60: 100,
            lc45: 85,
            lc30: 52.5,
            lc10: 26
        },
        "violet.1000": {
            contrast: 46.207297615628725,
            lc60: 100,
            lc45: 95.5,
            lc30: 58,
            lc10: 29
        },
        "violet.1100": {
            contrast: 41.97481252433749,
            lc60: 100,
            lc45: 100,
            lc30: 65.5,
            lc10: 32
        },
        "violet.1200": {
            contrast: 38.8825030749202,
            lc60: 100,
            lc45: 100,
            lc30: 72,
            lc10: 36
        },
        "violet.1300": {
            contrast: 32.79103333930563,
            lc60: 100,
            lc45: 100,
            lc30: 89.5,
            lc10: 43.5
        },
        "violet.1400": {
            contrast: 28.503221309041727,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51
        },
        "violet.1500": {
            contrast: 23.84311974214464,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62
        },
        "violet.1600": {
            contrast: 19.148759601338377,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78.5
        },
        "violet.1700": {
            contrast: 14.072876169473814,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1800": {
            contrast: 8.755479217640099,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.2200": {
            contrast: 12.002654515511463,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.2300": {
            contrast: 18.658178800899663,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83.5
        },
        "violet.2400": {
            contrast: 26.166620746555814,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63
        },
        "violet.2500": {
            contrast: 33.19281746271939,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 51.5
        }
    },
    "violet.2100": {
        "violet.100": {
            contrast: 80.60689492891142,
            lc60: 59,
            lc45: 42.5,
            lc30: 28,
            lc10: 14.5
        },
        "violet.200": {
            contrast: 80.1001210666802,
            lc60: 62.5,
            lc45: 45,
            lc30: 29.5,
            lc10: 15.5
        },
        "violet.300": {
            contrast: 78.58551142516518,
            lc60: 66,
            lc45: 48,
            lc30: 31,
            lc10: 16.5
        },
        "violet.400": {
            contrast: 76.50250377856386,
            lc60: 69.5,
            lc45: 50,
            lc30: 32.5,
            lc10: 17
        },
        "violet.500": {
            contrast: 73.430649620402,
            lc60: 73,
            lc45: 52.5,
            lc30: 34,
            lc10: 17.5
        },
        "violet.600": {
            contrast: 69.13749817727495,
            lc60: 79,
            lc45: 55,
            lc30: 35.5,
            lc10: 18.5
        },
        "violet.700": {
            contrast: 64.84756064719708,
            lc60: 86,
            lc45: 58,
            lc30: 37,
            lc10: 19
        },
        "violet.800": {
            contrast: 60.5547513072785,
            lc60: 97.5,
            lc45: 64,
            lc30: 40.5,
            lc10: 20.5
        },
        "violet.900": {
            contrast: 56.41648693858542,
            lc60: 100,
            lc45: 71.5,
            lc30: 45,
            lc10: 22.5
        },
        "violet.1000": {
            contrast: 52.46812901275255,
            lc60: 100,
            lc45: 79,
            lc30: 49,
            lc10: 25
        },
        "violet.1100": {
            contrast: 48.23564392146131,
            lc60: 100,
            lc45: 90,
            lc30: 55,
            lc10: 27
        },
        "violet.1200": {
            contrast: 45.143334472044025,
            lc60: 100,
            lc45: 99,
            lc30: 60,
            lc10: 29.5
        },
        "violet.1300": {
            contrast: 39.05186473642946,
            lc60: 100,
            lc45: 100,
            lc30: 72,
            lc10: 35.5
        },
        "violet.1400": {
            contrast: 34.76405270616555,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 41
        },
        "violet.1500": {
            contrast: 30.103951139268464,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 48
        },
        "violet.1600": {
            contrast: 25.4095909984622,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58
        },
        "violet.1700": {
            contrast: 20.33370756659764,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73
        },
        "violet.1800": {
            contrast: 15.016310614763922,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 99
        },
        "violet.1900": {
            contrast: 9.589142171112659,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.2300": {
            contrast: 11.72052910430258,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.2400": {
            contrast: 19.22897104995873,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80.5
        },
        "violet.2500": {
            contrast: 26.255167766122312,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62
        }
    },
    "violet.2200": {
        "violet.100": {
            contrast: 86.71603979783785,
            lc60: 54.5,
            lc45: 39.5,
            lc30: 26,
            lc10: 13.5
        },
        "violet.200": {
            contrast: 86.20926593560662,
            lc60: 57.5,
            lc45: 42,
            lc30: 27.5,
            lc10: 14.5
        },
        "violet.300": {
            contrast: 84.6946562940916,
            lc60: 60,
            lc45: 44,
            lc30: 29,
            lc10: 15
        },
        "violet.400": {
            contrast: 82.6116486474903,
            lc60: 63,
            lc45: 45.5,
            lc30: 30,
            lc10: 15.5
        },
        "violet.500": {
            contrast: 79.53979448932841,
            lc60: 66,
            lc45: 47.5,
            lc30: 31,
            lc10: 16
        },
        "violet.600": {
            contrast: 75.24664304620137,
            lc60: 69.5,
            lc45: 49.5,
            lc30: 32.5,
            lc10: 16.5
        },
        "violet.700": {
            contrast: 70.95670551612352,
            lc60: 74,
            lc45: 51.5,
            lc30: 33.5,
            lc10: 17
        },
        "violet.800": {
            contrast: 66.66389617620493,
            lc60: 82.5,
            lc45: 56,
            lc30: 36,
            lc10: 18
        },
        "violet.900": {
            contrast: 62.525631807511836,
            lc60: 93,
            lc45: 62.5,
            lc30: 40,
            lc10: 20.5
        },
        "violet.1000": {
            contrast: 58.57727388167897,
            lc60: 100,
            lc45: 68,
            lc30: 43,
            lc10: 22
        },
        "violet.1100": {
            contrast: 54.344788790387746,
            lc60: 100,
            lc45: 76,
            lc30: 47.5,
            lc10: 23.5
        },
        "violet.1200": {
            contrast: 51.252479340970446,
            lc60: 100,
            lc45: 83,
            lc30: 51.5,
            lc10: 26
        },
        "violet.1300": {
            contrast: 45.161009605355886,
            lc60: 100,
            lc45: 98.5,
            lc30: 60.5,
            lc10: 30
        },
        "violet.1400": {
            contrast: 40.87319757509197,
            lc60: 100,
            lc45: 100,
            lc30: 68,
            lc10: 33.5
        },
        "violet.1500": {
            contrast: 36.21309600819489,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 39
        },
        "violet.1600": {
            contrast: 31.518735867388624,
            lc60: 100,
            lc45: 100,
            lc30: 94,
            lc10: 45.5
        },
        "violet.1700": {
            contrast: 26.44285243552406,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "violet.1800": {
            contrast: 21.12545548369035,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70.5
        },
        "violet.1900": {
            contrast: 15.698287040039085,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95
        },
        "violet.2000": {
            contrast: 10.147371225897578,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.2400": {
            contrast: 12.382900319849988,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.2500": {
            contrast: 19.40909703601357,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80
        }
    },
    "violet.2300": {
        "violet.100": {
            contrast: 92.8275737152036,
            lc60: 50.5,
            lc45: 37,
            lc30: 24.5,
            lc10: 13
        },
        "violet.200": {
            contrast: 92.32079985297239,
            lc60: 53,
            lc45: 39,
            lc30: 25.5,
            lc10: 13.5
        },
        "violet.300": {
            contrast: 90.80619021145736,
            lc60: 55.5,
            lc45: 40.5,
            lc30: 26.5,
            lc10: 14
        },
        "violet.400": {
            contrast: 88.72318256485605,
            lc60: 57.5,
            lc45: 42,
            lc30: 28,
            lc10: 14.5
        },
        "violet.500": {
            contrast: 85.65132840669418,
            lc60: 60,
            lc45: 43.5,
            lc30: 28.5,
            lc10: 15
        },
        "violet.600": {
            contrast: 81.35817696356712,
            lc60: 62.5,
            lc45: 45,
            lc30: 29.5,
            lc10: 15.5
        },
        "violet.700": {
            contrast: 77.06823943348925,
            lc60: 65.5,
            lc45: 46.5,
            lc30: 30.5,
            lc10: 15.5
        },
        "violet.800": {
            contrast: 72.77543009357068,
            lc60: 71.5,
            lc45: 50,
            lc30: 32.5,
            lc10: 17
        },
        "violet.900": {
            contrast: 68.63716572487758,
            lc60: 80,
            lc45: 55.5,
            lc30: 36,
            lc10: 18.5
        },
        "violet.1000": {
            contrast: 64.68880779904472,
            lc60: 87.5,
            lc45: 60,
            lc30: 38.5,
            lc10: 19.5
        },
        "violet.1100": {
            contrast: 60.45632270775349,
            lc60: 98.5,
            lc45: 65,
            lc30: 41.5,
            lc10: 21
        },
        "violet.1200": {
            contrast: 57.3640132583362,
            lc60: 100,
            lc45: 71,
            lc30: 45,
            lc10: 23
        },
        "violet.1300": {
            contrast: 51.272543522721634,
            lc60: 100,
            lc45: 83,
            lc30: 51.5,
            lc10: 26
        },
        "violet.1400": {
            contrast: 46.984731492457726,
            lc60: 100,
            lc45: 93.5,
            lc30: 58,
            lc10: 29
        },
        "violet.1500": {
            contrast: 42.324629925560636,
            lc60: 100,
            lc45: 100,
            lc30: 66,
            lc10: 33
        },
        "violet.1600": {
            contrast: 37.630269784754375,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 38
        },
        "violet.1700": {
            contrast: 32.554386352889814,
            lc60: 100,
            lc45: 100,
            lc30: 90,
            lc10: 45
        },
        "violet.1800": {
            contrast: 27.236989401056093,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54.5
        },
        "violet.1900": {
            contrast: 21.809820957404835,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "violet.2000": {
            contrast: 16.25890514326333,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93
        },
        "violet.2100": {
            contrast: 9.91903651105554,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.2500": {
            contrast: 12.488895525162208,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "violet.2400": {
        "violet.100": {
            contrast: 99.6750641519469,
            lc60: 47,
            lc45: 34.5,
            lc30: 23,
            lc10: 12
        },
        "violet.200": {
            contrast: 99.16829028971567,
            lc60: 49,
            lc45: 36,
            lc30: 24,
            lc10: 12.5
        },
        "violet.300": {
            contrast: 97.65368064820065,
            lc60: 51,
            lc45: 37.5,
            lc30: 25,
            lc10: 13
        },
        "violet.400": {
            contrast: 95.57067300159935,
            lc60: 52.5,
            lc45: 39,
            lc30: 25.5,
            lc10: 13.5
        },
        "violet.500": {
            contrast: 92.49881884343748,
            lc60: 54.5,
            lc45: 40,
            lc30: 26.5,
            lc10: 13.5
        },
        "violet.600": {
            contrast: 88.20566740031042,
            lc60: 56.5,
            lc45: 41,
            lc30: 27,
            lc10: 14
        },
        "violet.700": {
            contrast: 83.91572987023257,
            lc60: 58.5,
            lc45: 42,
            lc30: 27.5,
            lc10: 14.5
        },
        "violet.800": {
            contrast: 79.62292053031398,
            lc60: 63,
            lc45: 45,
            lc30: 29.5,
            lc10: 15
        },
        "violet.900": {
            contrast: 75.48465616162089,
            lc60: 69.5,
            lc45: 49.5,
            lc30: 32,
            lc10: 16.5
        },
        "violet.1000": {
            contrast: 71.53629823578802,
            lc60: 75,
            lc45: 52.5,
            lc30: 34.5,
            lc10: 18
        },
        "violet.1100": {
            contrast: 67.3038131444968,
            lc60: 82,
            lc45: 57,
            lc30: 37,
            lc10: 19
        },
        "violet.1200": {
            contrast: 64.2115036950795,
            lc60: 89.5,
            lc45: 61,
            lc30: 39.5,
            lc10: 20.5
        },
        "violet.1300": {
            contrast: 58.120033959464934,
            lc60: 100,
            lc45: 70,
            lc30: 44.5,
            lc10: 23
        },
        "violet.1400": {
            contrast: 53.832221929201026,
            lc60: 100,
            lc45: 78,
            lc30: 49.5,
            lc10: 25.5
        },
        "violet.1500": {
            contrast: 49.17212036230394,
            lc60: 100,
            lc45: 88.5,
            lc30: 55,
            lc10: 28
        },
        "violet.1600": {
            contrast: 44.477760221497675,
            lc60: 100,
            lc45: 100,
            lc30: 62.5,
            lc10: 31.5
        },
        "violet.1700": {
            contrast: 39.401876789633114,
            lc60: 100,
            lc45: 100,
            lc30: 72.5,
            lc10: 36.5
        },
        "violet.1800": {
            contrast: 34.08447983779939,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 43.5
        },
        "violet.1900": {
            contrast: 28.65731139414813,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51.5
        },
        "violet.2000": {
            contrast: 23.106395580006627,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65.5
        },
        "violet.2100": {
            contrast: 16.766526947798837,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91
        },
        "violet.2200": {
            contrast: 10.572529730735928,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "violet.2500": {
        "violet.100": {
            contrast: 106.04067321268862,
            lc60: 44,
            lc45: 32.5,
            lc30: 21.5,
            lc10: 11.5
        },
        "violet.200": {
            contrast: 105.53389935045739,
            lc60: 46,
            lc45: 34,
            lc30: 22.5,
            lc10: 12
        },
        "violet.300": {
            contrast: 104.01928970894237,
            lc60: 47.5,
            lc45: 35,
            lc30: 23,
            lc10: 12.5
        },
        "violet.400": {
            contrast: 101.93628206234106,
            lc60: 49,
            lc45: 36,
            lc30: 24,
            lc10: 12.5
        },
        "violet.500": {
            contrast: 98.86442790417917,
            lc60: 50.5,
            lc45: 37,
            lc30: 24.5,
            lc10: 13
        },
        "violet.600": {
            contrast: 94.57127646105212,
            lc60: 51.5,
            lc45: 38,
            lc30: 25,
            lc10: 13
        },
        "violet.700": {
            contrast: 90.28133893097427,
            lc60: 53.5,
            lc45: 39,
            lc30: 25.5,
            lc10: 13.5
        },
        "violet.800": {
            contrast: 85.98852959105568,
            lc60: 57,
            lc45: 41,
            lc30: 27,
            lc10: 14
        },
        "violet.900": {
            contrast: 81.8502652223626,
            lc60: 62,
            lc45: 45,
            lc30: 29.5,
            lc10: 15
        },
        "violet.1000": {
            contrast: 77.90190729652973,
            lc60: 66.5,
            lc45: 47.5,
            lc30: 31,
            lc10: 16
        },
        "violet.1100": {
            contrast: 73.66942220523849,
            lc60: 72,
            lc45: 50.5,
            lc30: 33.5,
            lc10: 17.5
        },
        "violet.1200": {
            contrast: 70.5771127558212,
            lc60: 77,
            lc45: 54.5,
            lc30: 35,
            lc10: 18.5
        },
        "violet.1300": {
            contrast: 64.48564302020664,
            lc60: 88.5,
            lc45: 61.5,
            lc30: 40,
            lc10: 20.5
        },
        "violet.1400": {
            contrast: 60.19783098994272,
            lc60: 99,
            lc45: 67.5,
            lc30: 43.5,
            lc10: 22.5
        },
        "violet.1500": {
            contrast: 55.53772942304563,
            lc60: 100,
            lc45: 75.5,
            lc30: 48,
            lc10: 24.5
        },
        "violet.1600": {
            contrast: 50.84336928223938,
            lc60: 100,
            lc45: 85,
            lc30: 54,
            lc10: 27.5
        },
        "violet.1700": {
            contrast: 45.76748585037481,
            lc60: 100,
            lc45: 97,
            lc30: 61,
            lc10: 31.5
        },
        "violet.1800": {
            contrast: 40.4500888985411,
            lc60: 100,
            lc45: 100,
            lc30: 70.5,
            lc10: 36
        },
        "violet.1900": {
            contrast: 35.022920454889835,
            lc60: 100,
            lc45: 100,
            lc30: 84,
            lc10: 42.5
        },
        "violet.2000": {
            contrast: 29.472004640748327,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51.5
        },
        "violet.2100": {
            contrast: 23.13213600854054,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65
        },
        "violet.2200": {
            contrast: 16.93813879147763,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88.5
        },
        "violet.2300": {
            contrast: 10.73456899674881,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    }
};
const $f8fd43f1ee3f8cd8$var$gold = {
    "gold.100": {
        "gold.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.700": {
            contrast: 7.785550668996548,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.800": {
            contrast: 10.411236051605243,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.900": {
            contrast: 13.179506008308781,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1000": {
            contrast: 16.845986470147956,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93
        },
        "gold.1100": {
            contrast: 20.71272606513296,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82.5
        },
        "gold.1200": {
            contrast: 24.890785881104247,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74
        },
        "gold.1300": {
            contrast: 29.260943471116736,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67
        },
        "gold.1400": {
            contrast: 33.940757946530596,
            lc60: 100,
            lc45: 100,
            lc30: 92.5,
            lc10: 61
        },
        "gold.1500": {
            contrast: 38.80945032155926,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 55.5
        },
        "gold.1600": {
            contrast: 44.67929937976691,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 51
        },
        "gold.1700": {
            contrast: 50.95906187848522,
            lc60: 100,
            lc45: 92,
            lc30: 70.5,
            lc10: 46.5
        },
        "gold.1800": {
            contrast: 56.7740696646039,
            lc60: 100,
            lc45: 85.5,
            lc30: 66,
            lc10: 43.5
        },
        "gold.1900": {
            contrast: 63.54357080763432,
            lc60: 96.5,
            lc45: 79.5,
            lc30: 61,
            lc10: 40.5
        },
        "gold.2000": {
            contrast: 72.3996648377026,
            lc60: 88,
            lc45: 73,
            lc30: 56,
            lc10: 37
        },
        "gold.2100": {
            contrast: 81.75057557426906,
            lc60: 81,
            lc45: 67,
            lc30: 52,
            lc10: 34
        },
        "gold.2200": {
            contrast: 90.18314865828478,
            lc60: 76,
            lc45: 63,
            lc30: 48.5,
            lc10: 32
        },
        "gold.2300": {
            contrast: 96.71134704009945,
            lc60: 72.5,
            lc45: 60,
            lc30: 46.5,
            lc10: 30.5
        },
        "gold.2400": {
            contrast: 101.59505486353697,
            lc60: 70,
            lc45: 58,
            lc30: 45,
            lc10: 29.5
        },
        "gold.2500": {
            contrast: 107.56173245542702,
            lc60: 67.5,
            lc45: 56,
            lc30: 43.5,
            lc10: 28.5
        }
    },
    "gold.200": {
        "gold.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.800": {
            contrast: 9.713984711141816,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.900": {
            contrast: 12.48225466784535,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1000": {
            contrast: 16.14873512968453,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95.5
        },
        "gold.1100": {
            contrast: 20.01547472466953,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83
        },
        "gold.1200": {
            contrast: 24.19353454064082,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "gold.1300": {
            contrast: 28.56369213065331,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65.5
        },
        "gold.1400": {
            contrast: 33.24350660606717,
            lc60: 100,
            lc45: 100,
            lc30: 93,
            lc10: 59
        },
        "gold.1500": {
            contrast: 38.11219898109583,
            lc60: 100,
            lc45: 100,
            lc30: 85,
            lc10: 53.5
        },
        "gold.1600": {
            contrast: 43.98204803930348,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 48.5
        },
        "gold.1700": {
            contrast: 50.2618105380218,
            lc60: 100,
            lc45: 92.5,
            lc30: 70,
            lc10: 44
        },
        "gold.1800": {
            contrast: 56.076818324140476,
            lc60: 100,
            lc45: 85.5,
            lc30: 65,
            lc10: 41
        },
        "gold.1900": {
            contrast: 62.8463194671709,
            lc60: 96.5,
            lc45: 79.5,
            lc30: 60,
            lc10: 38
        },
        "gold.2000": {
            contrast: 71.70241349723918,
            lc60: 88,
            lc45: 72,
            lc30: 55,
            lc10: 34.5
        },
        "gold.2100": {
            contrast: 81.05332423380564,
            lc60: 81,
            lc45: 66.5,
            lc30: 50.5,
            lc10: 32
        },
        "gold.2200": {
            contrast: 89.48589731782135,
            lc60: 75.5,
            lc45: 62,
            lc30: 47,
            lc10: 29.5
        },
        "gold.2300": {
            contrast: 96.01409569963603,
            lc60: 72,
            lc45: 59,
            lc30: 45,
            lc10: 28.5
        },
        "gold.2400": {
            contrast: 100.89780352307356,
            lc60: 69.5,
            lc45: 57,
            lc30: 43.5,
            lc10: 27.5
        },
        "gold.2500": {
            contrast: 106.86448111496358,
            lc60: 67,
            lc45: 55,
            lc30: 41.5,
            lc10: 26.5
        }
    },
    "gold.300": {
        "gold.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.800": {
            contrast: 8.703887990655074,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.900": {
            contrast: 11.472157947358607,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1000": {
            contrast: 15.138638409197785,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 99
        },
        "gold.1100": {
            contrast: 19.005378004182788,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84
        },
        "gold.1200": {
            contrast: 23.183437820154076,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "gold.1300": {
            contrast: 27.553595410166565,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65
        },
        "gold.1400": {
            contrast: 32.23340988558043,
            lc60: 100,
            lc45: 100,
            lc30: 94.5,
            lc10: 58.5
        },
        "gold.1500": {
            contrast: 37.10210226060909,
            lc60: 100,
            lc45: 100,
            lc30: 86,
            lc10: 53
        },
        "gold.1600": {
            contrast: 42.97195131881674,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 47.5
        },
        "gold.1700": {
            contrast: 49.25171381753505,
            lc60: 100,
            lc45: 93.5,
            lc30: 70,
            lc10: 43
        },
        "gold.1800": {
            contrast: 55.06672160365373,
            lc60: 100,
            lc45: 86,
            lc30: 64.5,
            lc10: 39.5
        },
        "gold.1900": {
            contrast: 61.83622274668416,
            lc60: 97.5,
            lc45: 79.5,
            lc30: 59.5,
            lc10: 36.5
        },
        "gold.2000": {
            contrast: 70.69231677675243,
            lc60: 89,
            lc45: 72,
            lc30: 54,
            lc10: 33
        },
        "gold.2100": {
            contrast: 80.04322751331891,
            lc60: 81,
            lc45: 66,
            lc30: 49.5,
            lc10: 30.5
        },
        "gold.2200": {
            contrast: 88.47580059733463,
            lc60: 75.5,
            lc45: 61.5,
            lc30: 46,
            lc10: 28.5
        },
        "gold.2300": {
            contrast: 95.00399897914929,
            lc60: 72,
            lc45: 58,
            lc30: 43.5,
            lc10: 27
        },
        "gold.2400": {
            contrast: 99.88770680258679,
            lc60: 69.5,
            lc45: 56.5,
            lc30: 42.5,
            lc10: 26
        },
        "gold.2500": {
            contrast: 105.85438439447685,
            lc60: 66.5,
            lc45: 54,
            lc30: 40.5,
            lc10: 25
        }
    },
    "gold.400": {
        "gold.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.900": {
            contrast: 9.884341245437644,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1000": {
            contrast: 13.550821707276825,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1100": {
            contrast: 17.417561302261827,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89
        },
        "gold.1200": {
            contrast: 21.59562111823311,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76
        },
        "gold.1300": {
            contrast: 25.965778708245608,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "gold.1400": {
            contrast: 30.64559318365947,
            lc60: 100,
            lc45: 100,
            lc30: 98,
            lc10: 58.5
        },
        "gold.1500": {
            contrast: 35.51428555868813,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 52.5
        },
        "gold.1600": {
            contrast: 41.384134616895786,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 46.5
        },
        "gold.1700": {
            contrast: 47.6638971156141,
            lc60: 100,
            lc45: 95.5,
            lc30: 70,
            lc10: 42
        },
        "gold.1800": {
            contrast: 53.47890490173277,
            lc60: 100,
            lc45: 87.5,
            lc30: 64.5,
            lc10: 38.5
        },
        "gold.1900": {
            contrast: 60.24840604476319,
            lc60: 99.5,
            lc45: 80,
            lc30: 59,
            lc10: 35
        },
        "gold.2000": {
            contrast: 69.10450007483148,
            lc60: 89.5,
            lc45: 72.5,
            lc30: 53,
            lc10: 32
        },
        "gold.2100": {
            contrast: 78.45541081139794,
            lc60: 81.5,
            lc45: 66,
            lc30: 48.5,
            lc10: 29
        },
        "gold.2200": {
            contrast: 86.88798389541365,
            lc60: 75.5,
            lc45: 61,
            lc30: 45,
            lc10: 26.5
        },
        "gold.2300": {
            contrast: 93.41618227722833,
            lc60: 72,
            lc45: 58,
            lc30: 42.5,
            lc10: 25.5
        },
        "gold.2400": {
            contrast: 98.29989010066583,
            lc60: 69.5,
            lc45: 56,
            lc30: 41.5,
            lc10: 24.5
        },
        "gold.2500": {
            contrast: 104.2665676925559,
            lc60: 66.5,
            lc45: 53.5,
            lc30: 39.5,
            lc10: 23.5
        }
    },
    "gold.500": {
        "gold.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.900": {
            contrast: 8.19902399640118,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1000": {
            contrast: 11.865504458240359,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1100": {
            contrast: 15.732244053225362,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 96.5
        },
        "gold.1200": {
            contrast: 19.91030386919665,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80.5
        },
        "gold.1300": {
            contrast: 24.280461459209143,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "gold.1400": {
            contrast: 28.96027593462301,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "gold.1500": {
            contrast: 33.828968309651664,
            lc60: 100,
            lc45: 100,
            lc30: 91,
            lc10: 52.5
        },
        "gold.1600": {
            contrast: 39.69881736785932,
            lc60: 100,
            lc45: 100,
            lc30: 80.5,
            lc10: 46.5
        },
        "gold.1700": {
            contrast: 45.97857986657762,
            lc60: 100,
            lc45: 98.5,
            lc30: 71.5,
            lc10: 41.5
        },
        "gold.1800": {
            contrast: 51.7935876526963,
            lc60: 100,
            lc45: 89.5,
            lc30: 65.5,
            lc10: 37.5
        },
        "gold.1900": {
            contrast: 58.56308879572673,
            lc60: 100,
            lc45: 81.5,
            lc30: 59.5,
            lc10: 34.5
        },
        "gold.2000": {
            contrast: 67.419182825795,
            lc60: 91,
            lc45: 73,
            lc30: 53,
            lc10: 30.5
        },
        "gold.2100": {
            contrast: 76.77009356236148,
            lc60: 83,
            lc45: 66,
            lc30: 48,
            lc10: 28
        },
        "gold.2200": {
            contrast: 85.2026666463772,
            lc60: 76.5,
            lc45: 61.5,
            lc30: 44.5,
            lc10: 26
        },
        "gold.2300": {
            contrast: 91.73086502819186,
            lc60: 72.5,
            lc45: 58,
            lc30: 42,
            lc10: 24.5
        },
        "gold.2400": {
            contrast: 96.61457285162936,
            lc60: 69.5,
            lc45: 56,
            lc30: 40.5,
            lc10: 23.5
        },
        "gold.2500": {
            contrast: 102.58125044351942,
            lc60: 66.5,
            lc45: 53.5,
            lc30: 39,
            lc10: 22.5
        }
    },
    "gold.600": {
        "gold.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1000": {
            contrast: 9.767508838565709,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1100": {
            contrast: 13.634248433550711,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1200": {
            contrast: 17.812308249521998,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87
        },
        "gold.1300": {
            contrast: 22.18246583953449,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72.5
        },
        "gold.1400": {
            contrast: 26.862280314948357,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62
        },
        "gold.1500": {
            contrast: 31.730972689977015,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 54.5
        },
        "gold.1600": {
            contrast: 37.600821748184664,
            lc60: 100,
            lc45: 100,
            lc30: 83,
            lc10: 47.5
        },
        "gold.1700": {
            contrast: 43.88058424690297,
            lc60: 100,
            lc45: 100,
            lc30: 73.5,
            lc10: 42
        },
        "gold.1800": {
            contrast: 49.695592033021654,
            lc60: 100,
            lc45: 92,
            lc30: 66.5,
            lc10: 38
        },
        "gold.1900": {
            contrast: 56.46509317605207,
            lc60: 100,
            lc45: 83.5,
            lc30: 60,
            lc10: 34.5
        },
        "gold.2000": {
            contrast: 65.32118720612036,
            lc60: 93.5,
            lc45: 74.5,
            lc30: 54,
            lc10: 31
        },
        "gold.2100": {
            contrast: 74.67209794268682,
            lc60: 84,
            lc45: 67,
            lc30: 48.5,
            lc10: 28
        },
        "gold.2200": {
            contrast: 83.10467102670253,
            lc60: 77.5,
            lc45: 62,
            lc30: 45,
            lc10: 26
        },
        "gold.2300": {
            contrast: 89.6328694085172,
            lc60: 73,
            lc45: 58.5,
            lc30: 42.5,
            lc10: 24
        },
        "gold.2400": {
            contrast: 94.51657723195473,
            lc60: 70.5,
            lc45: 56.5,
            lc30: 40.5,
            lc10: 23.5
        },
        "gold.2500": {
            contrast: 100.48325482384477,
            lc60: 67.5,
            lc45: 53.5,
            lc30: 39,
            lc10: 22.5
        }
    },
    "gold.700": {
        "gold.100": {
            contrast: 9.004541108755134,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.200": {
            contrast: 8.083385813679946,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1000": {
            contrast: 7.723109068446339,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1100": {
            contrast: 11.58984866343134,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1200": {
            contrast: 15.767908479402628,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 96
        },
        "gold.1300": {
            contrast: 20.13806606941512,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78.5
        },
        "gold.1400": {
            contrast: 24.81788054482898,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "gold.1500": {
            contrast: 29.68657291985764,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "gold.1600": {
            contrast: 35.556421978065295,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 49
        },
        "gold.1700": {
            contrast: 41.8361844767836,
            lc60: 100,
            lc45: 100,
            lc30: 76,
            lc10: 43
        },
        "gold.1800": {
            contrast: 47.651192262902285,
            lc60: 100,
            lc45: 95,
            lc30: 68,
            lc10: 38.5
        },
        "gold.1900": {
            contrast: 54.420693405932695,
            lc60: 100,
            lc45: 86,
            lc30: 62,
            lc10: 34.5
        },
        "gold.2000": {
            contrast: 63.27678743600098,
            lc60: 95.5,
            lc45: 76,
            lc30: 54.5,
            lc10: 30.5
        },
        "gold.2100": {
            contrast: 72.62769817256745,
            lc60: 86,
            lc45: 68,
            lc30: 49,
            lc10: 27.5
        },
        "gold.2200": {
            contrast: 81.06027125658316,
            lc60: 79,
            lc45: 62.5,
            lc30: 45,
            lc10: 25.5
        },
        "gold.2300": {
            contrast: 87.58846963839785,
            lc60: 74,
            lc45: 59,
            lc30: 42.5,
            lc10: 24.5
        },
        "gold.2400": {
            contrast: 92.47217746183536,
            lc60: 71.5,
            lc45: 56.5,
            lc30: 41,
            lc10: 23
        },
        "gold.2500": {
            contrast: 98.43885505372538,
            lc60: 68,
            lc45: 54,
            lc30: 39,
            lc10: 22
        }
    },
    "gold.800": {
        "gold.100": {
            contrast: 11.88098967719541,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.200": {
            contrast: 10.959834382120222,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.300": {
            contrast: 9.656070663983199,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.400": {
            contrast: 7.6644007917479575,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1100": {
            contrast: 9.09031378418412,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1200": {
            contrast: 13.268373600155408,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1300": {
            contrast: 17.6385311901679,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87
        },
        "gold.1400": {
            contrast: 22.318345665581766,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72
        },
        "gold.1500": {
            contrast: 27.187038040610425,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60.5
        },
        "gold.1600": {
            contrast: 33.05688709881807,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 51.5
        },
        "gold.1700": {
            contrast: 39.336649597536386,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 44.5
        },
        "gold.1800": {
            contrast: 45.15165738365506,
            lc60: 100,
            lc45: 99.5,
            lc30: 71.5,
            lc10: 40
        },
        "gold.1900": {
            contrast: 51.92115852668549,
            lc60: 100,
            lc45: 89,
            lc30: 63.5,
            lc10: 35.5
        },
        "gold.2000": {
            contrast: 60.777252556753766,
            lc60: 98.5,
            lc45: 78.5,
            lc30: 56,
            lc10: 31.5
        },
        "gold.2100": {
            contrast: 70.12816329332023,
            lc60: 88,
            lc45: 70,
            lc30: 50,
            lc10: 27.5
        },
        "gold.2200": {
            contrast: 78.56073637733594,
            lc60: 80.5,
            lc45: 64,
            lc30: 45.5,
            lc10: 25.5
        },
        "gold.2300": {
            contrast: 85.08893475915062,
            lc60: 75.5,
            lc45: 60,
            lc30: 43,
            lc10: 24
        },
        "gold.2400": {
            contrast: 89.97264258258814,
            lc60: 72.5,
            lc45: 57.5,
            lc30: 41.5,
            lc10: 23
        },
        "gold.2500": {
            contrast: 95.93932017447815,
            lc60: 69,
            lc45: 54.5,
            lc30: 39,
            lc10: 22
        }
    },
    "gold.900": {
        "gold.100": {
            contrast: 14.86695266296418,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.200": {
            contrast: 13.945797367888993,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.300": {
            contrast: 12.64203364975197,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.400": {
            contrast: 10.650363777516727,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.500": {
            contrast: 8.596363877225265,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1200": {
            contrast: 10.612586709252971,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1300": {
            contrast: 14.982744299265462,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1400": {
            contrast: 19.66255877467933,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78.5
        },
        "gold.1500": {
            contrast: 24.531251149707987,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65.5
        },
        "gold.1600": {
            contrast: 30.401100207915636,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 54.5
        },
        "gold.1700": {
            contrast: 36.680862706633945,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 46.5
        },
        "gold.1800": {
            contrast: 42.49587049275262,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 41
        },
        "gold.1900": {
            contrast: 49.26537163578305,
            lc60: 100,
            lc45: 92.5,
            lc30: 66,
            lc10: 36.5
        },
        "gold.2000": {
            contrast: 58.12146566585133,
            lc60: 100,
            lc45: 80.5,
            lc30: 57.5,
            lc10: 32
        },
        "gold.2100": {
            contrast: 67.4723764024178,
            lc60: 90.5,
            lc45: 72,
            lc30: 51,
            lc10: 28.5
        },
        "gold.2200": {
            contrast: 75.90494948643351,
            lc60: 82.5,
            lc45: 65,
            lc30: 46.5,
            lc10: 26
        },
        "gold.2300": {
            contrast: 82.43314786824817,
            lc60: 77.5,
            lc45: 61.5,
            lc30: 43.5,
            lc10: 24.5
        },
        "gold.2400": {
            contrast: 87.31685569168569,
            lc60: 74,
            lc45: 58.5,
            lc30: 42,
            lc10: 23.5
        },
        "gold.2500": {
            contrast: 93.28353328357574,
            lc60: 70.5,
            lc45: 55.5,
            lc30: 39.5,
            lc10: 22
        }
    },
    "gold.1000": {
        "gold.100": {
            contrast: 18.760159336742753,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65.5
        },
        "gold.200": {
            contrast: 17.839004041667565,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75.5
        },
        "gold.300": {
            contrast: 16.53524032353054,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87
        },
        "gold.400": {
            contrast: 14.543570451295295,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.500": {
            contrast: 12.489570551003833,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.600": {
            contrast: 9.999460579932002,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.700": {
            contrast: 7.629945295943609,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1300": {
            contrast: 11.437518549476378,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1400": {
            contrast: 16.117333024890243,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93
        },
        "gold.1500": {
            contrast: 20.9860253999189,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74
        },
        "gold.1600": {
            contrast: 26.85587445812655,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "gold.1700": {
            contrast: 33.13563695684486,
            lc60: 100,
            lc45: 100,
            lc30: 91.5,
            lc10: 49.5
        },
        "gold.1800": {
            contrast: 38.95064474296354,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 43.5
        },
        "gold.1900": {
            contrast: 45.720145885993965,
            lc60: 100,
            lc45: 98,
            lc30: 70,
            lc10: 38
        },
        "gold.2000": {
            contrast: 54.57623991606224,
            lc60: 100,
            lc45: 84.5,
            lc30: 60,
            lc10: 32.5
        },
        "gold.2100": {
            contrast: 63.927150652628704,
            lc60: 94.5,
            lc45: 74.5,
            lc30: 52.5,
            lc10: 28.5
        },
        "gold.2200": {
            contrast: 72.35972373664443,
            lc60: 85.5,
            lc45: 67.5,
            lc30: 48,
            lc10: 26
        },
        "gold.2300": {
            contrast: 78.8879221184591,
            lc60: 80,
            lc45: 63,
            lc30: 45,
            lc10: 24.5
        },
        "gold.2400": {
            contrast: 83.77162994189662,
            lc60: 76,
            lc45: 60,
            lc30: 43,
            lc10: 23.5
        },
        "gold.2500": {
            contrast: 89.73830753378664,
            lc60: 72,
            lc45: 56.5,
            lc30: 40.5,
            lc10: 22.5
        }
    },
    "gold.1100": {
        "gold.100": {
            contrast: 22.802128643639016,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 52
        },
        "gold.200": {
            contrast: 21.880973348563828,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58.5
        },
        "gold.300": {
            contrast: 20.577209630426804,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "gold.400": {
            contrast: 18.585539758191562,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77.5
        },
        "gold.500": {
            contrast: 16.5315398579001,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 90
        },
        "gold.600": {
            contrast: 14.041429886828269,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.700": {
            contrast: 11.671914602839875,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.800": {
            contrast: 8.836783352759912,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1300": {
            contrast: 7.669233777729581,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1400": {
            contrast: 12.349048253143447,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1500": {
            contrast: 17.217740628172105,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87.5
        },
        "gold.1600": {
            contrast: 23.087589686379758,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68.5
        },
        "gold.1700": {
            contrast: 29.36735218509806,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "gold.1800": {
            contrast: 35.18235997121674,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 47.5
        },
        "gold.1900": {
            contrast: 41.951861114247166,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 40
        },
        "gold.2000": {
            contrast: 50.80795514431545,
            lc60: 100,
            lc45: 90,
            lc30: 63.5,
            lc10: 34.5
        },
        "gold.2100": {
            contrast: 60.158865880881905,
            lc60: 99.5,
            lc45: 78,
            lc30: 55,
            lc10: 30
        },
        "gold.2200": {
            contrast: 68.59143896489762,
            lc60: 89,
            lc45: 70,
            lc30: 49.5,
            lc10: 27
        },
        "gold.2300": {
            contrast: 75.11963734671231,
            lc60: 83,
            lc45: 65,
            lc30: 46.5,
            lc10: 25
        },
        "gold.2400": {
            contrast: 80.00334517014981,
            lc60: 78.5,
            lc45: 62,
            lc30: 44,
            lc10: 24
        },
        "gold.2500": {
            contrast: 85.97002276203985,
            lc60: 74.5,
            lc45: 58.5,
            lc30: 41.5,
            lc10: 22.5
        }
    },
    "gold.1200": {
        "gold.100": {
            contrast: 27.10736258117122,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 44
        },
        "gold.200": {
            contrast: 26.186207286096035,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 49
        },
        "gold.300": {
            contrast: 24.882443567959015,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54.5
        },
        "gold.400": {
            contrast: 22.89077369572377,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "gold.500": {
            contrast: 20.836773795432308,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "gold.600": {
            contrast: 18.346663824360476,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81.5
        },
        "gold.700": {
            contrast: 15.977148540372083,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93.5
        },
        "gold.800": {
            contrast: 13.142017290292118,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.900": {
            contrast: 10.191323808433959,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1400": {
            contrast: 8.24808347101446,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1500": {
            contrast: 13.116775846043119,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1600": {
            contrast: 18.98662490425077,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80
        },
        "gold.1700": {
            contrast: 25.266387402969077,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62
        },
        "gold.1800": {
            contrast: 31.081395189087758,
            lc60: 100,
            lc45: 100,
            lc30: 97,
            lc10: 51.5
        },
        "gold.1900": {
            contrast: 37.850896332118175,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 43.5
        },
        "gold.2000": {
            contrast: 46.70699036218647,
            lc60: 100,
            lc45: 97,
            lc30: 68,
            lc10: 37
        },
        "gold.2100": {
            contrast: 56.05790109875293,
            lc60: 100,
            lc45: 82.5,
            lc30: 58,
            lc10: 31.5
        },
        "gold.2200": {
            contrast: 64.49047418276864,
            lc60: 93.5,
            lc45: 73.5,
            lc30: 52,
            lc10: 28
        },
        "gold.2300": {
            contrast: 71.01867256458331,
            lc60: 87,
            lc45: 68,
            lc30: 48,
            lc10: 26
        },
        "gold.2400": {
            contrast: 75.90238038802084,
            lc60: 82,
            lc45: 64,
            lc30: 45.5,
            lc10: 25
        },
        "gold.2500": {
            contrast: 81.86905797991085,
            lc60: 77.5,
            lc45: 60.5,
            lc30: 42.5,
            lc10: 23.5
        }
    },
    "gold.1300": {
        "gold.100": {
            contrast: 31.551410458994344,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 38
        },
        "gold.200": {
            contrast: 30.630255163919152,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 41.5
        },
        "gold.300": {
            contrast: 29.326491445782132,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 46
        },
        "gold.400": {
            contrast: 27.334821573546886,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 52
        },
        "gold.500": {
            contrast: 25.280821673255428,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "gold.600": {
            contrast: 22.790711702183593,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65
        },
        "gold.700": {
            contrast: 20.421196418195205,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73
        },
        "gold.800": {
            contrast: 17.58606516811524,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84.5
        },
        "gold.900": {
            contrast: 14.635371686257079,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1000": {
            contrast: 10.778072668904015,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1500": {
            contrast: 8.79881913527373,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1600": {
            contrast: 14.668668193481379,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1700": {
            contrast: 20.94843069219969,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "gold.1800": {
            contrast: 26.76343847831837,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58.5
        },
        "gold.1900": {
            contrast: 33.53293962134879,
            lc60: 100,
            lc45: 100,
            lc30: 91,
            lc10: 48
        },
        "gold.2000": {
            contrast: 42.38903365141707,
            lc60: 100,
            lc45: 100,
            lc30: 73,
            lc10: 39.5
        },
        "gold.2100": {
            contrast: 51.73994438798354,
            lc60: 100,
            lc45: 88,
            lc30: 62,
            lc10: 33.5
        },
        "gold.2200": {
            contrast: 60.17251747199926,
            lc60: 99.5,
            lc45: 77.5,
            lc30: 55,
            lc10: 29.5
        },
        "gold.2300": {
            contrast: 66.70071585381392,
            lc60: 91.5,
            lc45: 71,
            lc30: 50.5,
            lc10: 27
        },
        "gold.2400": {
            contrast: 71.58442367725144,
            lc60: 86,
            lc45: 68,
            lc30: 47.5,
            lc10: 26
        },
        "gold.2500": {
            contrast: 77.55110126914147,
            lc60: 80.5,
            lc45: 63,
            lc30: 44.5,
            lc10: 24
        }
    },
    "gold.1400": {
        "gold.100": {
            contrast: 36.25234119834072,
            lc60: 100,
            lc45: 100,
            lc30: 69,
            lc10: 33.5
        },
        "gold.200": {
            contrast: 35.33118590326552,
            lc60: 100,
            lc45: 100,
            lc30: 75,
            lc10: 36.5
        },
        "gold.300": {
            contrast: 34.02742218512851,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 40
        },
        "gold.400": {
            contrast: 32.035752312893266,
            lc60: 100,
            lc45: 100,
            lc30: 90.5,
            lc10: 44
        },
        "gold.500": {
            contrast: 29.981752412601796,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 49
        },
        "gold.600": {
            contrast: 27.49164244152997,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54
        },
        "gold.700": {
            contrast: 25.122127157541573,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "gold.800": {
            contrast: 22.286995907461613,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "gold.900": {
            contrast: 19.336302425603453,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78.5
        },
        "gold.1000": {
            contrast: 15.479003408250389,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 97
        },
        "gold.1100": {
            contrast: 11.463832892021403,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1600": {
            contrast: 10.01631378169067,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1700": {
            contrast: 16.29607628040898,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 92
        },
        "gold.1800": {
            contrast: 22.11108406652766,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "gold.1900": {
            contrast: 28.88058520955808,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54.5
        },
        "gold.2000": {
            contrast: 37.73667923962636,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 43.5
        },
        "gold.2100": {
            contrast: 47.08758997619283,
            lc60: 100,
            lc45: 96,
            lc30: 67,
            lc10: 36
        },
        "gold.2200": {
            contrast: 55.52016306020854,
            lc60: 100,
            lc45: 83,
            lc30: 58.5,
            lc10: 31.5
        },
        "gold.2300": {
            contrast: 62.048361442023214,
            lc60: 97,
            lc45: 75.5,
            lc30: 53.5,
            lc10: 29
        },
        "gold.2400": {
            contrast: 66.93206926546073,
            lc60: 91,
            lc45: 71,
            lc30: 50.5,
            lc10: 27
        },
        "gold.2500": {
            contrast: 72.89874685735076,
            lc60: 85,
            lc45: 66.5,
            lc30: 47,
            lc10: 25.5
        }
    },
    "gold.1500": {
        "gold.100": {
            contrast: 41.087314199091885,
            lc60: 100,
            lc45: 100,
            lc30: 60,
            lc10: 30
        },
        "gold.200": {
            contrast: 40.16615890401669,
            lc60: 100,
            lc45: 100,
            lc30: 65,
            lc10: 32
        },
        "gold.300": {
            contrast: 38.86239518587967,
            lc60: 100,
            lc45: 100,
            lc30: 70,
            lc10: 34.5
        },
        "gold.400": {
            contrast: 36.87072531364443,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 38
        },
        "gold.500": {
            contrast: 34.81672541335296,
            lc60: 100,
            lc45: 100,
            lc30: 84,
            lc10: 41
        },
        "gold.600": {
            contrast: 32.32661544228113,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 45
        },
        "gold.700": {
            contrast: 29.957100158292743,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 49
        },
        "gold.800": {
            contrast: 27.121968908212775,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "gold.900": {
            contrast: 24.17127542635462,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62
        },
        "gold.1000": {
            contrast: 20.313976409001555,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74
        },
        "gold.1100": {
            contrast: 16.29880589277257,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93
        },
        "gold.1200": {
            contrast: 12.011884949274659,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1300": {
            contrast: 7.57698042660461,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1700": {
            contrast: 11.428161600883074,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1800": {
            contrast: 17.243169387001757,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89
        },
        "gold.1900": {
            contrast: 24.012670530032175,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65.5
        },
        "gold.2000": {
            contrast: 32.86876456010046,
            lc60: 100,
            lc45: 100,
            lc30: 92.5,
            lc10: 49
        },
        "gold.2100": {
            contrast: 42.21967529666693,
            lc60: 100,
            lc45: 100,
            lc30: 73.5,
            lc10: 40
        },
        "gold.2200": {
            contrast: 50.65224838068264,
            lc60: 100,
            lc45: 90,
            lc30: 63,
            lc10: 34
        },
        "gold.2300": {
            contrast: 57.180446762497304,
            lc60: 100,
            lc45: 81,
            lc30: 57,
            lc10: 30.5
        },
        "gold.2400": {
            contrast: 62.06415458593483,
            lc60: 97,
            lc45: 75.5,
            lc30: 53.5,
            lc10: 29
        },
        "gold.2500": {
            contrast: 68.03083217782485,
            lc60: 90,
            lc45: 70.5,
            lc30: 49.5,
            lc10: 26.5
        }
    },
    "gold.1600": {
        "gold.100": {
            contrast: 46.85028912132791,
            lc60: 100,
            lc45: 88.5,
            lc30: 52,
            lc10: 26.5
        },
        "gold.200": {
            contrast: 45.929133826252716,
            lc60: 100,
            lc45: 95,
            lc30: 56,
            lc10: 28
        },
        "gold.300": {
            contrast: 44.625370108115696,
            lc60: 100,
            lc45: 100,
            lc30: 60,
            lc10: 30
        },
        "gold.400": {
            contrast: 42.633700235880454,
            lc60: 100,
            lc45: 100,
            lc30: 65,
            lc10: 32.5
        },
        "gold.500": {
            contrast: 40.57970033558899,
            lc60: 100,
            lc45: 100,
            lc30: 70.5,
            lc10: 35
        },
        "gold.600": {
            contrast: 38.08959036451716,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 38
        },
        "gold.700": {
            contrast: 35.720075080528765,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 41
        },
        "gold.800": {
            contrast: 32.8849438304488,
            lc60: 100,
            lc45: 100,
            lc30: 90.5,
            lc10: 45
        },
        "gold.900": {
            contrast: 29.934250348590634,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 50
        },
        "gold.1000": {
            contrast: 26.076951331237574,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58
        },
        "gold.1100": {
            contrast: 22.061780815008593,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "gold.1200": {
            contrast: 17.77485987151068,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85.5
        },
        "gold.1300": {
            contrast: 13.339955348840633,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1400": {
            contrast: 8.6390968577471,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1800": {
            contrast: 11.340631802622761,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1900": {
            contrast: 18.11013294565318,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83.5
        },
        "gold.2000": {
            contrast: 26.96622697572146,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58.5
        },
        "gold.2100": {
            contrast: 36.31713771228793,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 44.5
        },
        "gold.2200": {
            contrast: 44.749710796303646,
            lc60: 100,
            lc45: 100,
            lc30: 70,
            lc10: 37.5
        },
        "gold.2300": {
            contrast: 51.27790917811831,
            lc60: 100,
            lc45: 89,
            lc30: 62.5,
            lc10: 34
        },
        "gold.2400": {
            contrast: 56.16161700155582,
            lc60: 100,
            lc45: 82.5,
            lc30: 58,
            lc10: 31
        },
        "gold.2500": {
            contrast: 62.128294593445865,
            lc60: 97,
            lc45: 76,
            lc30: 53,
            lc10: 29
        }
    },
    "gold.1700": {
        "gold.100": {
            contrast: 52.945232970151736,
            lc60: 100,
            lc45: 72.5,
            lc30: 46,
            lc10: 23
        },
        "gold.200": {
            contrast: 52.02407767507654,
            lc60: 100,
            lc45: 77.5,
            lc30: 49,
            lc10: 24.5
        },
        "gold.300": {
            contrast: 50.72031395693952,
            lc60: 100,
            lc45: 82.5,
            lc30: 52.5,
            lc10: 26
        },
        "gold.400": {
            contrast: 48.72864408470428,
            lc60: 100,
            lc45: 88.5,
            lc30: 56.5,
            lc10: 28.5
        },
        "gold.500": {
            contrast: 46.67464418441282,
            lc60: 100,
            lc45: 95.5,
            lc30: 60.5,
            lc10: 30.5
        },
        "gold.600": {
            contrast: 44.18453421334099,
            lc60: 100,
            lc45: 100,
            lc30: 65,
            lc10: 32.5
        },
        "gold.700": {
            contrast: 41.81501892935259,
            lc60: 100,
            lc45: 100,
            lc30: 69,
            lc10: 35
        },
        "gold.800": {
            contrast: 38.97988767927263,
            lc60: 100,
            lc45: 100,
            lc30: 75,
            lc10: 37.5
        },
        "gold.900": {
            contrast: 36.02919419741447,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 41
        },
        "gold.1000": {
            contrast: 32.1718951800614,
            lc60: 100,
            lc45: 100,
            lc30: 93,
            lc10: 47
        },
        "gold.1100": {
            contrast: 28.15672466383242,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54
        },
        "gold.1200": {
            contrast: 23.869803720334513,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "gold.1300": {
            contrast: 19.434899197664464,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78.5
        },
        "gold.1400": {
            contrast: 14.73404070657093,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1500": {
            contrast: 9.889904490630755,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1900": {
            contrast: 11.758995444549308,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.2000": {
            contrast: 20.615089474617594,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74
        },
        "gold.2100": {
            contrast: 29.966000211184056,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53.5
        },
        "gold.2200": {
            contrast: 38.398573295199775,
            lc60: 100,
            lc45: 100,
            lc30: 80.5,
            lc10: 43
        },
        "gold.2300": {
            contrast: 44.92677167701444,
            lc60: 100,
            lc45: 100,
            lc30: 70.5,
            lc10: 38.5
        },
        "gold.2400": {
            contrast: 49.810479500451954,
            lc60: 100,
            lc45: 91.5,
            lc30: 65,
            lc10: 34.5
        },
        "gold.2500": {
            contrast: 55.77715709234199,
            lc60: 100,
            lc45: 83,
            lc30: 58.5,
            lc10: 31.5
        }
    },
    "gold.1800": {
        "gold.100": {
            contrast: 58.53157692829172,
            lc60: 100,
            lc45: 64.5,
            lc30: 41.5,
            lc10: 21
        },
        "gold.200": {
            contrast: 57.61042163321651,
            lc60: 100,
            lc45: 68.5,
            lc30: 44,
            lc10: 22
        },
        "gold.300": {
            contrast: 56.3066579150795,
            lc60: 100,
            lc45: 72.5,
            lc30: 46.5,
            lc10: 23.5
        },
        "gold.400": {
            contrast: 54.314988042844256,
            lc60: 100,
            lc45: 77.5,
            lc30: 50,
            lc10: 25
        },
        "gold.500": {
            contrast: 52.26098814255279,
            lc60: 100,
            lc45: 83,
            lc30: 53.5,
            lc10: 26.5
        },
        "gold.600": {
            contrast: 49.77087817148096,
            lc60: 100,
            lc45: 88,
            lc30: 57,
            lc10: 28.5
        },
        "gold.700": {
            contrast: 47.40136288749257,
            lc60: 100,
            lc45: 94,
            lc30: 60.5,
            lc10: 30.5
        },
        "gold.800": {
            contrast: 44.5662316374126,
            lc60: 100,
            lc45: 100,
            lc30: 65,
            lc10: 32.5
        },
        "gold.900": {
            contrast: 41.61553815555444,
            lc60: 100,
            lc45: 100,
            lc30: 70,
            lc10: 35
        },
        "gold.1000": {
            contrast: 37.758239138201375,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 39.5
        },
        "gold.1100": {
            contrast: 33.74306862197239,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 44.5
        },
        "gold.1200": {
            contrast: 29.45614767847448,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51.5
        },
        "gold.1300": {
            contrast: 25.021243155804434,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61
        },
        "gold.1400": {
            contrast: 20.320384664710904,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75
        },
        "gold.1500": {
            contrast: 15.476248448770729,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 96.5
        },
        "gold.1600": {
            contrast: 9.691346991968725,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.2000": {
            contrast: 14.703794466028942,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.2100": {
            contrast: 24.054705202595407,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "gold.2200": {
            contrast: 32.487278286611115,
            lc60: 100,
            lc45: 100,
            lc30: 93,
            lc10: 51
        },
        "gold.2300": {
            contrast: 39.015476668425784,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 43.5
        },
        "gold.2400": {
            contrast: 43.8991844918633,
            lc60: 100,
            lc45: 100,
            lc30: 72.5,
            lc10: 39.5
        },
        "gold.2500": {
            contrast: 49.865862083753335,
            lc60: 100,
            lc45: 92,
            lc30: 65,
            lc10: 35.5
        }
    },
    "gold.1900": {
        "gold.100": {
            contrast: 64.97274687999605,
            lc60: 82,
            lc45: 57.5,
            lc30: 37,
            lc10: 19
        },
        "gold.200": {
            contrast: 64.05159158492086,
            lc60: 87,
            lc45: 61,
            lc30: 39.5,
            lc10: 20
        },
        "gold.300": {
            contrast: 62.747827866783844,
            lc60: 91.5,
            lc45: 64,
            lc30: 41.5,
            lc10: 21
        },
        "gold.400": {
            contrast: 60.75615799454861,
            lc60: 98,
            lc45: 68.5,
            lc30: 44.5,
            lc10: 22.5
        },
        "gold.500": {
            contrast: 58.70215809425714,
            lc60: 100,
            lc45: 72.5,
            lc30: 47,
            lc10: 24
        },
        "gold.600": {
            contrast: 56.21204812318531,
            lc60: 100,
            lc45: 76.5,
            lc30: 50,
            lc10: 25.5
        },
        "gold.700": {
            contrast: 53.84253283919692,
            lc60: 100,
            lc45: 80.5,
            lc30: 52.5,
            lc10: 26.5
        },
        "gold.800": {
            contrast: 51.00740158911695,
            lc60: 100,
            lc45: 86,
            lc30: 56,
            lc10: 28.5
        },
        "gold.900": {
            contrast: 48.05670810725879,
            lc60: 100,
            lc45: 92.5,
            lc30: 60,
            lc10: 30.5
        },
        "gold.1000": {
            contrast: 44.19940908990572,
            lc60: 100,
            lc45: 100,
            lc30: 66,
            lc10: 33.5
        },
        "gold.1100": {
            contrast: 40.184238573676744,
            lc60: 100,
            lc45: 100,
            lc30: 73,
            lc10: 37.5
        },
        "gold.1200": {
            contrast: 35.89731763017883,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 42
        },
        "gold.1300": {
            contrast: 31.462413107508784,
            lc60: 100,
            lc45: 100,
            lc30: 95.5,
            lc10: 48
        },
        "gold.1400": {
            contrast: 26.76155461641525,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "gold.1500": {
            contrast: 21.917418400475082,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "gold.1600": {
            contrast: 16.132516943673075,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 92.5
        },
        "gold.1700": {
            contrast: 10.002647901948967,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.2000": {
            contrast: 7.78908765341868,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.2100": {
            contrast: 17.13999838998515,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89.5
        },
        "gold.2200": {
            contrast: 25.572571474000856,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62
        },
        "gold.2300": {
            contrast: 32.10076985581553,
            lc60: 100,
            lc45: 100,
            lc30: 94.5,
            lc10: 52
        },
        "gold.2400": {
            contrast: 36.98447767925304,
            lc60: 100,
            lc45: 100,
            lc30: 84,
            lc10: 45.5
        },
        "gold.2500": {
            contrast: 42.95115527114307,
            lc60: 100,
            lc45: 100,
            lc30: 73.5,
            lc10: 40
        }
    },
    "gold.2000": {
        "gold.100": {
            contrast: 73.30947334912055,
            lc60: 70,
            lc45: 50.5,
            lc30: 33,
            lc10: 17
        },
        "gold.200": {
            contrast: 72.38831805404537,
            lc60: 74,
            lc45: 53,
            lc30: 34.5,
            lc10: 18
        },
        "gold.300": {
            contrast: 71.08455433590835,
            lc60: 77.5,
            lc45: 55.5,
            lc30: 36.5,
            lc10: 19
        },
        "gold.400": {
            contrast: 69.09288446367312,
            lc60: 82,
            lc45: 59,
            lc30: 38.5,
            lc10: 20
        },
        "gold.500": {
            contrast: 67.03888456338164,
            lc60: 86,
            lc45: 62,
            lc30: 40.5,
            lc10: 21
        },
        "gold.600": {
            contrast: 64.54877459230981,
            lc60: 91.5,
            lc45: 65.5,
            lc30: 42.5,
            lc10: 22
        },
        "gold.700": {
            contrast: 62.17925930832141,
            lc60: 95.5,
            lc45: 69,
            lc30: 45,
            lc10: 23
        },
        "gold.800": {
            contrast: 59.34412805824145,
            lc60: 100,
            lc45: 72.5,
            lc30: 47.5,
            lc10: 24.5
        },
        "gold.900": {
            contrast: 56.393434576383285,
            lc60: 100,
            lc45: 77,
            lc30: 50.5,
            lc10: 26
        },
        "gold.1000": {
            contrast: 52.536135559030214,
            lc60: 100,
            lc45: 84,
            lc30: 55,
            lc10: 28
        },
        "gold.1100": {
            contrast: 48.520965042801244,
            lc60: 100,
            lc45: 91.5,
            lc30: 60,
            lc10: 30.5
        },
        "gold.1200": {
            contrast: 44.234044099303325,
            lc60: 100,
            lc45: 100,
            lc30: 67,
            lc10: 34.5
        },
        "gold.1300": {
            contrast: 39.79913957663328,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 38.5
        },
        "gold.1400": {
            contrast: 35.098281085539746,
            lc60: 100,
            lc45: 100,
            lc30: 85,
            lc10: 43.5
        },
        "gold.1500": {
            contrast: 30.254144869599575,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 51.5
        },
        "gold.1600": {
            contrast: 24.469243412797574,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "gold.1700": {
            contrast: 18.339374371073465,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83
        },
        "gold.1800": {
            contrast: 12.71141729943098,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.2100": {
            contrast: 8.045323229888272,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.2200": {
            contrast: 16.477896313903987,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 92.5
        },
        "gold.2300": {
            contrast: 23.00609469571865,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "gold.2400": {
            contrast: 27.889802519156166,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59
        },
        "gold.2500": {
            contrast: 33.8564801110462,
            lc60: 100,
            lc45: 100,
            lc30: 89.5,
            lc10: 49.5
        }
    },
    "gold.2100": {
        "gold.100": {
            contrast: 82.01416235796822,
            lc60: 61.5,
            lc45: 44.5,
            lc30: 29.5,
            lc10: 15.5
        },
        "gold.200": {
            contrast: 81.09300706289302,
            lc60: 64.5,
            lc45: 47,
            lc30: 30.5,
            lc10: 16
        },
        "gold.300": {
            contrast: 79.789243344756,
            lc60: 67.5,
            lc45: 49,
            lc30: 32,
            lc10: 17
        },
        "gold.400": {
            contrast: 77.79757347252077,
            lc60: 71,
            lc45: 51.5,
            lc30: 34,
            lc10: 17.5
        },
        "gold.500": {
            contrast: 75.7435735722293,
            lc60: 74.5,
            lc45: 54.5,
            lc30: 35.5,
            lc10: 18.5
        },
        "gold.600": {
            contrast: 73.25346360115746,
            lc60: 78,
            lc45: 57,
            lc30: 37.5,
            lc10: 19.5
        },
        "gold.700": {
            contrast: 70.88394831716907,
            lc60: 81.5,
            lc45: 59,
            lc30: 39,
            lc10: 20
        },
        "gold.800": {
            contrast: 68.0488170670891,
            lc60: 85.5,
            lc45: 62,
            lc30: 41,
            lc10: 21
        },
        "gold.900": {
            contrast: 65.09812358523095,
            lc60: 90.5,
            lc45: 66,
            lc30: 43,
            lc10: 22.5
        },
        "gold.1000": {
            contrast: 61.24082456787788,
            lc60: 97,
            lc45: 71,
            lc30: 46,
            lc10: 24
        },
        "gold.1100": {
            contrast: 57.2256540516489,
            lc60: 100,
            lc45: 76,
            lc30: 50.5,
            lc10: 26
        },
        "gold.1200": {
            contrast: 52.938733108150984,
            lc60: 100,
            lc45: 83.5,
            lc30: 55,
            lc10: 29
        },
        "gold.1300": {
            contrast: 48.50382858548093,
            lc60: 100,
            lc45: 92,
            lc30: 61,
            lc10: 31.5
        },
        "gold.1400": {
            contrast: 43.802970094387405,
            lc60: 100,
            lc45: 100,
            lc30: 67.5,
            lc10: 35
        },
        "gold.1500": {
            contrast: 38.95883387844723,
            lc60: 100,
            lc45: 100,
            lc30: 75.5,
            lc10: 40
        },
        "gold.1600": {
            contrast: 33.173932421645226,
            lc60: 100,
            lc45: 100,
            lc30: 90,
            lc10: 46
        },
        "gold.1700": {
            contrast: 27.04406337992112,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "gold.1800": {
            contrast: 21.416106308278636,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "gold.1900": {
            contrast: 14.916564860409013,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.2300": {
            contrast: 13.349462976676351,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.2400": {
            contrast: 18.233170800113868,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85
        },
        "gold.2500": {
            contrast: 24.1998483920039,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67
        }
    },
    "gold.2200": {
        "gold.100": {
            contrast: 89.78734923224421,
            lc60: 55.5,
            lc45: 40.5,
            lc30: 27,
            lc10: 14
        },
        "gold.200": {
            contrast: 88.86619393716902,
            lc60: 58,
            lc45: 42.5,
            lc30: 28,
            lc10: 14.5
        },
        "gold.300": {
            contrast: 87.562430219032,
            lc60: 60.5,
            lc45: 44.5,
            lc30: 29.5,
            lc10: 15.5
        },
        "gold.400": {
            contrast: 85.57076034679676,
            lc60: 63.5,
            lc45: 46.5,
            lc30: 31,
            lc10: 16
        },
        "gold.500": {
            contrast: 83.51676044650529,
            lc60: 66.5,
            lc45: 48.5,
            lc30: 32,
            lc10: 17
        },
        "gold.600": {
            contrast: 81.02665047543346,
            lc60: 69,
            lc45: 50.5,
            lc30: 33.5,
            lc10: 17.5
        },
        "gold.700": {
            contrast: 78.65713519144506,
            lc60: 72,
            lc45: 53,
            lc30: 34.5,
            lc10: 18
        },
        "gold.800": {
            contrast: 75.8220039413651,
            lc60: 75.5,
            lc45: 55,
            lc30: 36.5,
            lc10: 19
        },
        "gold.900": {
            contrast: 72.87131045950693,
            lc60: 79,
            lc45: 57.5,
            lc30: 38.5,
            lc10: 20
        },
        "gold.1000": {
            contrast: 69.01401144215387,
            lc60: 84.5,
            lc45: 62,
            lc30: 41,
            lc10: 21
        },
        "gold.1100": {
            contrast: 64.9988409259249,
            lc60: 91,
            lc45: 66.5,
            lc30: 43.5,
            lc10: 22.5
        },
        "gold.1200": {
            contrast: 60.71191998242698,
            lc60: 98.5,
            lc45: 72,
            lc30: 47,
            lc10: 24.5
        },
        "gold.1300": {
            contrast: 56.27701545975693,
            lc60: 100,
            lc45: 77.5,
            lc30: 51.5,
            lc10: 26.5
        },
        "gold.1400": {
            contrast: 51.5761569686634,
            lc60: 100,
            lc45: 86,
            lc30: 57,
            lc10: 29.5
        },
        "gold.1500": {
            contrast: 46.73202075272322,
            lc60: 100,
            lc45: 96,
            lc30: 62.5,
            lc10: 32
        },
        "gold.1600": {
            contrast: 40.94711929592122,
            lc60: 100,
            lc45: 100,
            lc30: 72.5,
            lc10: 37.5
        },
        "gold.1700": {
            contrast: 34.81725025419711,
            lc60: 100,
            lc45: 100,
            lc30: 86,
            lc10: 44
        },
        "gold.1800": {
            contrast: 29.189293182554625,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53
        },
        "gold.1900": {
            contrast: 22.689751734685007,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67
        },
        "gold.2000": {
            contrast: 14.262436988231949,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.2400": {
            contrast: 9.482093665310536,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.2500": {
            contrast: 15.448771257200569,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98
        }
    },
    "gold.2300": {
        "gold.100": {
            contrast: 95.7598051056606,
            lc60: 51.5,
            lc45: 38,
            lc30: 25,
            lc10: 13
        },
        "gold.200": {
            contrast: 94.83864981058541,
            lc60: 54,
            lc45: 39.5,
            lc30: 26,
            lc10: 13.5
        },
        "gold.300": {
            contrast: 93.53488609244839,
            lc60: 56,
            lc45: 41.5,
            lc30: 27,
            lc10: 14
        },
        "gold.400": {
            contrast: 91.54321622021315,
            lc60: 59,
            lc45: 43,
            lc30: 28.5,
            lc10: 15
        },
        "gold.500": {
            contrast: 89.48921631992168,
            lc60: 61,
            lc45: 45,
            lc30: 30,
            lc10: 15.5
        },
        "gold.600": {
            contrast: 86.99910634884985,
            lc60: 63.5,
            lc45: 46.5,
            lc30: 31,
            lc10: 16.5
        },
        "gold.700": {
            contrast: 84.62959106486146,
            lc60: 66,
            lc45: 48.5,
            lc30: 32,
            lc10: 17
        },
        "gold.800": {
            contrast: 81.79445981478149,
            lc60: 69,
            lc45: 50.5,
            lc30: 33.5,
            lc10: 17.5
        },
        "gold.900": {
            contrast: 78.84376633292334,
            lc60: 72.5,
            lc45: 53,
            lc30: 35,
            lc10: 18.5
        },
        "gold.1000": {
            contrast: 74.98646731557027,
            lc60: 76.5,
            lc45: 56,
            lc30: 37,
            lc10: 19.5
        },
        "gold.1100": {
            contrast: 70.97129679934129,
            lc60: 82,
            lc45: 60,
            lc30: 40,
            lc10: 21
        },
        "gold.1200": {
            contrast: 66.68437585584338,
            lc60: 88.5,
            lc45: 65,
            lc30: 43,
            lc10: 22
        },
        "gold.1300": {
            contrast: 62.249471333173325,
            lc60: 95.5,
            lc45: 69.5,
            lc30: 46,
            lc10: 24
        },
        "gold.1400": {
            contrast: 57.54861284207979,
            lc60: 100,
            lc45: 76.5,
            lc30: 50,
            lc10: 26
        },
        "gold.1500": {
            contrast: 52.704476626139616,
            lc60: 100,
            lc45: 83.5,
            lc30: 55.5,
            lc10: 28.5
        },
        "gold.1600": {
            contrast: 46.91957516933761,
            lc60: 100,
            lc45: 95,
            lc30: 62.5,
            lc10: 32.5
        },
        "gold.1700": {
            contrast: 40.789706127613506,
            lc60: 100,
            lc45: 100,
            lc30: 71.5,
            lc10: 37
        },
        "gold.1800": {
            contrast: 35.16174905597102,
            lc60: 100,
            lc45: 100,
            lc30: 85,
            lc10: 43.5
        },
        "gold.1900": {
            contrast: 28.662207608101397,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53.5
        },
        "gold.2000": {
            contrast: 20.234892861648344,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75
        },
        "gold.2100": {
            contrast: 11.419210012587461,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.2500": {
            contrast: 8.648379700766737,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "gold.2400": {
        "gold.100": {
            contrast: 100.20376752577316,
            lc60: 49,
            lc45: 36,
            lc30: 24,
            lc10: 12.5
        },
        "gold.200": {
            contrast: 99.28261223069795,
            lc60: 51,
            lc45: 37.5,
            lc30: 25,
            lc10: 13
        },
        "gold.300": {
            contrast: 97.97884851256093,
            lc60: 53,
            lc45: 39,
            lc30: 26,
            lc10: 13.5
        },
        "gold.400": {
            contrast: 95.98717864032568,
            lc60: 55.5,
            lc45: 41,
            lc30: 27,
            lc10: 14.5
        },
        "gold.500": {
            contrast: 93.93317874003422,
            lc60: 58,
            lc45: 42.5,
            lc30: 28.5,
            lc10: 14.5
        },
        "gold.600": {
            contrast: 91.44306876896239,
            lc60: 60,
            lc45: 44.5,
            lc30: 29.5,
            lc10: 15.5
        },
        "gold.700": {
            contrast: 89.073553484974,
            lc60: 62.5,
            lc45: 45.5,
            lc30: 30.5,
            lc10: 16
        },
        "gold.800": {
            contrast: 86.23842223489403,
            lc60: 65,
            lc45: 47.5,
            lc30: 32,
            lc10: 16.5
        },
        "gold.900": {
            contrast: 83.28772875303586,
            lc60: 67.5,
            lc45: 50,
            lc30: 33,
            lc10: 17.5
        },
        "gold.1000": {
            contrast: 79.43042973568281,
            lc60: 72,
            lc45: 53,
            lc30: 35,
            lc10: 18.5
        },
        "gold.1100": {
            contrast: 75.41525921945382,
            lc60: 76.5,
            lc45: 56,
            lc30: 37,
            lc10: 19.5
        },
        "gold.1200": {
            contrast: 71.12833827595591,
            lc60: 82,
            lc45: 60,
            lc30: 40,
            lc10: 21
        },
        "gold.1300": {
            contrast: 66.69343375328586,
            lc60: 88.5,
            lc45: 65,
            lc30: 43,
            lc10: 22
        },
        "gold.1400": {
            contrast: 61.99257526219233,
            lc60: 96,
            lc45: 70,
            lc30: 46.5,
            lc10: 24
        },
        "gold.1500": {
            contrast: 57.14843904625215,
            lc60: 100,
            lc45: 76.5,
            lc30: 50.5,
            lc10: 26.5
        },
        "gold.1600": {
            contrast: 51.36353758945015,
            lc60: 100,
            lc45: 86,
            lc30: 56.5,
            lc10: 29
        },
        "gold.1700": {
            contrast: 45.23366854772604,
            lc60: 100,
            lc45: 99,
            lc30: 64.5,
            lc10: 33.5
        },
        "gold.1800": {
            contrast: 39.605711476083556,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 37.5
        },
        "gold.1900": {
            contrast: 33.10617002821393,
            lc60: 100,
            lc45: 100,
            lc30: 89.5,
            lc10: 45.5
        },
        "gold.2000": {
            contrast: 24.678855281760878,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "gold.2100": {
            contrast: 15.863172432699995,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95.5
        },
        "gold.2200": {
            contrast: 7.977986019953469,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "gold.2500": {
        "gold.100": {
            contrast: 105.60694178022172,
            lc60: 46.5,
            lc45: 34.5,
            lc30: 22.5,
            lc10: 12
        },
        "gold.200": {
            contrast: 104.68578648514652,
            lc60: 48.5,
            lc45: 35.5,
            lc30: 24,
            lc10: 12.5
        },
        "gold.300": {
            contrast: 103.3820227670095,
            lc60: 50,
            lc45: 37,
            lc30: 25,
            lc10: 13
        },
        "gold.400": {
            contrast: 101.39035289477427,
            lc60: 52.5,
            lc45: 38.5,
            lc30: 26,
            lc10: 13.5
        },
        "gold.500": {
            contrast: 99.3363529944828,
            lc60: 54,
            lc45: 40,
            lc30: 27,
            lc10: 14
        },
        "gold.600": {
            contrast: 96.84624302341095,
            lc60: 56,
            lc45: 41.5,
            lc30: 27.5,
            lc10: 14.5
        },
        "gold.700": {
            contrast: 94.47672773942256,
            lc60: 58,
            lc45: 43,
            lc30: 28.5,
            lc10: 15
        },
        "gold.800": {
            contrast: 91.64159648934259,
            lc60: 60.5,
            lc45: 44.5,
            lc30: 29.5,
            lc10: 16
        },
        "gold.900": {
            contrast: 88.69090300748444,
            lc60: 63,
            lc45: 46.5,
            lc30: 31,
            lc10: 16
        },
        "gold.1000": {
            contrast: 84.83360399013137,
            lc60: 66.5,
            lc45: 49,
            lc30: 33,
            lc10: 17.5
        },
        "gold.1100": {
            contrast: 80.81843347390239,
            lc60: 70.5,
            lc45: 52,
            lc30: 35,
            lc10: 18.5
        },
        "gold.1200": {
            contrast: 76.53151253040447,
            lc60: 75.5,
            lc45: 55.5,
            lc30: 37,
            lc10: 19.5
        },
        "gold.1300": {
            contrast: 72.09660800773443,
            lc60: 81,
            lc45: 59,
            lc30: 39.5,
            lc10: 20.5
        },
        "gold.1400": {
            contrast: 67.39574951664089,
            lc60: 87,
            lc45: 63.5,
            lc30: 42.5,
            lc10: 22
        },
        "gold.1500": {
            contrast: 62.55161330070072,
            lc60: 95,
            lc45: 69,
            lc30: 46,
            lc10: 24
        },
        "gold.1600": {
            contrast: 56.76671184389872,
            lc60: 100,
            lc45: 77,
            lc30: 50.5,
            lc10: 26.5
        },
        "gold.1700": {
            contrast: 50.636842802174606,
            lc60: 100,
            lc45: 87,
            lc30: 57,
            lc10: 29.5
        },
        "gold.1800": {
            contrast: 45.00888573053212,
            lc60: 100,
            lc45: 99,
            lc30: 65,
            lc10: 33.5
        },
        "gold.1900": {
            contrast: 38.5093442826625,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 39
        },
        "gold.2000": {
            contrast: 30.082029536209443,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 51.5
        },
        "gold.2100": {
            contrast: 21.266346687148562,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72.5
        },
        "gold.2200": {
            contrast: 13.381160274402035,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.2300": {
            contrast: 7.31501975489734,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    }
};
const $f8fd43f1ee3f8cd8$var$warning = {
    "warning.100": {
        "warning.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.600": {
            contrast: 8.076176467005913,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.700": {
            contrast: 12.114639140804615,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.800": {
            contrast: 16.645836476141334,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95
        },
        "warning.900": {
            contrast: 20.96305106382024,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84.5
        },
        "warning.1000": {
            contrast: 25.152865974978724,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76.5
        },
        "warning.1100": {
            contrast: 29.527966263116458,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "warning.1200": {
            contrast: 34.08694731467085,
            lc60: 100,
            lc45: 100,
            lc30: 92.5,
            lc10: 64.5
        },
        "warning.1300": {
            contrast: 39.04100268180725,
            lc60: 100,
            lc45: 100,
            lc30: 86,
            lc10: 59.5
        },
        "warning.1400": {
            contrast: 45.31369943532885,
            lc60: 100,
            lc45: 99.5,
            lc30: 78.5,
            lc10: 54.5
        },
        "warning.1500": {
            contrast: 47.86228105607289,
            lc60: 100,
            lc45: 96.5,
            lc30: 76,
            lc10: 53
        },
        "warning.1600": {
            contrast: 52.6589417057721,
            lc60: 100,
            lc45: 91,
            lc30: 72,
            lc10: 50
        },
        "warning.1700": {
            contrast: 58.07600698190595,
            lc60: 100,
            lc45: 85.5,
            lc30: 68,
            lc10: 47
        },
        "warning.1800": {
            contrast: 63.604068912099486,
            lc60: 96.5,
            lc45: 81,
            lc30: 64,
            lc10: 44.5
        },
        "warning.1900": {
            contrast: 69.32878210382822,
            lc60: 91.5,
            lc45: 77,
            lc30: 60.5,
            lc10: 42.5
        },
        "warning.2000": {
            contrast: 75.12056576657689,
            lc60: 86.5,
            lc45: 73,
            lc30: 58,
            lc10: 40.5
        },
        "warning.2100": {
            contrast: 81.29331994715598,
            lc60: 82.5,
            lc45: 69.5,
            lc30: 55,
            lc10: 38
        },
        "warning.2200": {
            contrast: 87.81113485871532,
            lc60: 78.5,
            lc45: 66,
            lc30: 52.5,
            lc10: 36.5
        },
        "warning.2300": {
            contrast: 94.23961406073825,
            lc60: 75,
            lc45: 63.5,
            lc30: 50,
            lc10: 35
        },
        "warning.2400": {
            contrast: 100.92288292979201,
            lc60: 72,
            lc45: 60.5,
            lc30: 48,
            lc10: 33.5
        },
        "warning.2500": {
            contrast: 107.88473318309848,
            lc60: 69,
            lc45: 58,
            lc30: 46,
            lc10: 32
        }
    },
    "warning.200": {
        "warning.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.600": {
            contrast: 7.68740429807305,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.700": {
            contrast: 11.725866971871755,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.800": {
            contrast: 16.25706430720847,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95
        },
        "warning.900": {
            contrast: 20.57427889488738,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83
        },
        "warning.1000": {
            contrast: 24.76409380604586,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74
        },
        "warning.1100": {
            contrast: 29.13919409418359,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66.5
        },
        "warning.1200": {
            contrast: 33.698175145737984,
            lc60: 100,
            lc45: 100,
            lc30: 92.5,
            lc10: 61
        },
        "warning.1300": {
            contrast: 38.65223051287438,
            lc60: 100,
            lc45: 100,
            lc30: 85,
            lc10: 55.5
        },
        "warning.1400": {
            contrast: 44.92492726639598,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 50.5
        },
        "warning.1500": {
            contrast: 47.473508887140014,
            lc60: 100,
            lc45: 96.5,
            lc30: 74.5,
            lc10: 49
        },
        "warning.1600": {
            contrast: 52.27016953683924,
            lc60: 100,
            lc45: 90.5,
            lc30: 70,
            lc10: 46
        },
        "warning.1700": {
            contrast: 57.687234812973074,
            lc60: 100,
            lc45: 85,
            lc30: 65.5,
            lc10: 43
        },
        "warning.1800": {
            contrast: 63.215296743166626,
            lc60: 96.5,
            lc45: 80,
            lc30: 61.5,
            lc10: 41
        },
        "warning.1900": {
            contrast: 68.94000993489536,
            lc60: 91,
            lc45: 75.5,
            lc30: 58.5,
            lc10: 38.5
        },
        "warning.2000": {
            contrast: 74.73179359764403,
            lc60: 86.5,
            lc45: 72,
            lc30: 55.5,
            lc10: 37
        },
        "warning.2100": {
            contrast: 80.90454777822312,
            lc60: 82,
            lc45: 68.5,
            lc30: 53,
            lc10: 35
        },
        "warning.2200": {
            contrast: 87.42236268978246,
            lc60: 78,
            lc45: 64.5,
            lc30: 50,
            lc10: 33.5
        },
        "warning.2300": {
            contrast: 93.85084189180539,
            lc60: 74.5,
            lc45: 62,
            lc30: 48,
            lc10: 32
        },
        "warning.2400": {
            contrast: 100.53411076085916,
            lc60: 71,
            lc45: 59.5,
            lc30: 46,
            lc10: 30.5
        },
        "warning.2500": {
            contrast: 107.4959610141656,
            lc60: 68,
            lc45: 56.5,
            lc30: 44,
            lc10: 29.5
        }
    },
    "warning.300": {
        "warning.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.700": {
            contrast: 10.589945645837314,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.800": {
            contrast: 15.121142981174032,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 99
        },
        "warning.900": {
            contrast: 19.43835756885294,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84
        },
        "warning.1000": {
            contrast: 23.62817248001142,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74
        },
        "warning.1100": {
            contrast: 28.003272768149152,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65.5
        },
        "warning.1200": {
            contrast: 32.56225381970354,
            lc60: 100,
            lc45: 100,
            lc30: 94.5,
            lc10: 59
        },
        "warning.1300": {
            contrast: 37.51630918683994,
            lc60: 100,
            lc45: 100,
            lc30: 85.5,
            lc10: 53.5
        },
        "warning.1400": {
            contrast: 43.78900594036155,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 48
        },
        "warning.1500": {
            contrast: 46.33758756110558,
            lc60: 100,
            lc45: 98,
            lc30: 73.5,
            lc10: 46
        },
        "warning.1600": {
            contrast: 51.1342482108048,
            lc60: 100,
            lc45: 91.5,
            lc30: 69,
            lc10: 43
        },
        "warning.1700": {
            contrast: 56.551313486938646,
            lc60: 100,
            lc45: 85,
            lc30: 64,
            lc10: 40.5
        },
        "warning.1800": {
            contrast: 62.07937541713219,
            lc60: 97.5,
            lc45: 80,
            lc30: 60,
            lc10: 38
        },
        "warning.1900": {
            contrast: 67.80408860886091,
            lc60: 92,
            lc45: 75,
            lc30: 57,
            lc10: 35.5
        },
        "warning.2000": {
            contrast: 73.59587227160958,
            lc60: 86.5,
            lc45: 71,
            lc30: 53.5,
            lc10: 34
        },
        "warning.2100": {
            contrast: 79.76862645218867,
            lc60: 81.5,
            lc45: 67,
            lc30: 51,
            lc10: 32.5
        },
        "warning.2200": {
            contrast: 86.28644136374803,
            lc60: 77.5,
            lc45: 64,
            lc30: 48.5,
            lc10: 31
        },
        "warning.2300": {
            contrast: 92.71492056577094,
            lc60: 74,
            lc45: 61,
            lc30: 46,
            lc10: 29.5
        },
        "warning.2400": {
            contrast: 99.39818943482472,
            lc60: 70.5,
            lc45: 58,
            lc30: 44,
            lc10: 28.5
        },
        "warning.2500": {
            contrast: 106.36003968813117,
            lc60: 67.5,
            lc45: 55.5,
            lc30: 42,
            lc10: 27
        }
    },
    "warning.400": {
        "warning.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.700": {
            contrast: 8.920475480177435,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.800": {
            contrast: 13.451672815514154,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.900": {
            contrast: 17.768887403193062,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88.5
        },
        "warning.1000": {
            contrast: 21.95870231435154,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75.5
        },
        "warning.1100": {
            contrast: 26.33380260248927,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66.5
        },
        "warning.1200": {
            contrast: 30.892783654043665,
            lc60: 100,
            lc45: 100,
            lc30: 97.5,
            lc10: 58.5
        },
        "warning.1300": {
            contrast: 35.84683902118007,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 52.5
        },
        "warning.1400": {
            contrast: 42.119535774701674,
            lc60: 100,
            lc45: 100,
            lc30: 77.5,
            lc10: 46.5
        },
        "warning.1500": {
            contrast: 44.66811739544569,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 44.5
        },
        "warning.1600": {
            contrast: 49.46477804514492,
            lc60: 100,
            lc45: 93,
            lc30: 68.5,
            lc10: 41.5
        },
        "warning.1700": {
            contrast: 54.88184332127876,
            lc60: 100,
            lc45: 86.5,
            lc30: 64,
            lc10: 38.5
        },
        "warning.1800": {
            contrast: 60.40990525147231,
            lc60: 99.5,
            lc45: 80.5,
            lc30: 60,
            lc10: 36.5
        },
        "warning.1900": {
            contrast: 66.13461844320103,
            lc60: 92.5,
            lc45: 75.5,
            lc30: 56,
            lc10: 34
        },
        "warning.2000": {
            contrast: 71.92640210594969,
            lc60: 87.5,
            lc45: 71,
            lc30: 53,
            lc10: 32.5
        },
        "warning.2100": {
            contrast: 78.09915628652878,
            lc60: 82.5,
            lc45: 67,
            lc30: 50,
            lc10: 30.5
        },
        "warning.2200": {
            contrast: 84.61697119808814,
            lc60: 78,
            lc45: 63.5,
            lc30: 47.5,
            lc10: 29
        },
        "warning.2300": {
            contrast: 91.04545040011106,
            lc60: 74,
            lc45: 60.5,
            lc30: 45.5,
            lc10: 28
        },
        "warning.2400": {
            contrast: 97.72871926916481,
            lc60: 70.5,
            lc45: 57.5,
            lc30: 43,
            lc10: 26.5
        },
        "warning.2500": {
            contrast: 104.69056952247129,
            lc60: 67,
            lc45: 55,
            lc30: 41,
            lc10: 25.5
        }
    },
    "warning.500": {
        "warning.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.800": {
            contrast: 10.917745555101257,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.900": {
            contrast: 15.234960142780166,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98.5
        },
        "warning.1000": {
            contrast: 19.424775053938646,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81
        },
        "warning.1100": {
            contrast: 23.79987534207638,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "warning.1200": {
            contrast: 28.35885639363077,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60.5
        },
        "warning.1300": {
            contrast: 33.312911760767165,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 53
        },
        "warning.1400": {
            contrast: 39.58560851428877,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 46.5
        },
        "warning.1500": {
            contrast: 42.1341901350328,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 44.5
        },
        "warning.1600": {
            contrast: 46.93085078473202,
            lc60: 100,
            lc45: 96.5,
            lc30: 70.5,
            lc10: 41
        },
        "warning.1700": {
            contrast: 52.34791606086586,
            lc60: 100,
            lc45: 89,
            lc30: 64.5,
            lc10: 37.5
        },
        "warning.1800": {
            contrast: 57.875977991059415,
            lc60: 100,
            lc45: 82.5,
            lc30: 60.5,
            lc10: 35
        },
        "warning.1900": {
            contrast: 63.60069118278814,
            lc60: 95.5,
            lc45: 76.5,
            lc30: 56,
            lc10: 33
        },
        "warning.2000": {
            contrast: 69.3924748455368,
            lc60: 89.5,
            lc45: 72.5,
            lc30: 53,
            lc10: 31
        },
        "warning.2100": {
            contrast: 75.56522902611589,
            lc60: 84,
            lc45: 67.5,
            lc30: 49.5,
            lc10: 29.5
        },
        "warning.2200": {
            contrast: 82.08304393767524,
            lc60: 79.5,
            lc45: 64,
            lc30: 47,
            lc10: 28
        },
        "warning.2300": {
            contrast: 88.51152313969817,
            lc60: 75,
            lc45: 60.5,
            lc30: 45,
            lc10: 26.5
        },
        "warning.2400": {
            contrast: 95.19479200875193,
            lc60: 71.5,
            lc45: 57.5,
            lc30: 42.5,
            lc10: 25.5
        },
        "warning.2500": {
            contrast: 102.15664226205838,
            lc60: 67.5,
            lc45: 55,
            lc30: 40.5,
            lc10: 24.5
        }
    },
    "warning.600": {
        "warning.100": {
            contrast: 9.402501950355903,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.200": {
            contrast: 8.88102875217364,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.300": {
            contrast: 7.392408184487195,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.900": {
            contrast: 11.547861036510485,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1000": {
            contrast: 15.737675947668963,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 96
        },
        "warning.1100": {
            contrast: 20.112776235806695,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79
        },
        "warning.1200": {
            contrast: 24.67175728736109,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66.5
        },
        "warning.1300": {
            contrast: 29.625812654497487,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "warning.1400": {
            contrast: 35.898509408019095,
            lc60: 100,
            lc45: 100,
            lc30: 86,
            lc10: 48.5
        },
        "warning.1500": {
            contrast: 38.44709102876311,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 46
        },
        "warning.1600": {
            contrast: 43.24375167846233,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 42
        },
        "warning.1700": {
            contrast: 48.66081695459618,
            lc60: 100,
            lc45: 93.5,
            lc30: 67.5,
            lc10: 38.5
        },
        "warning.1800": {
            contrast: 54.18887888478972,
            lc60: 100,
            lc45: 86.5,
            lc30: 62.5,
            lc10: 36
        },
        "warning.1900": {
            contrast: 59.913592076518455,
            lc60: 100,
            lc45: 79.5,
            lc30: 58,
            lc10: 33.5
        },
        "warning.2000": {
            contrast: 65.70537573926711,
            lc60: 93,
            lc45: 74.5,
            lc30: 54,
            lc10: 31.5
        },
        "warning.2100": {
            contrast: 71.8781299198462,
            lc60: 87,
            lc45: 70,
            lc30: 51.5,
            lc10: 29.5
        },
        "warning.2200": {
            contrast: 78.39594483140556,
            lc60: 81.5,
            lc45: 65.5,
            lc30: 48,
            lc10: 28
        },
        "warning.2300": {
            contrast: 84.82442403342849,
            lc60: 77,
            lc45: 62,
            lc30: 45.5,
            lc10: 26.5
        },
        "warning.2400": {
            contrast: 91.50769290248223,
            lc60: 73,
            lc45: 58.5,
            lc30: 43,
            lc10: 25.5
        },
        "warning.2500": {
            contrast: 98.4695431557887,
            lc60: 69,
            lc45: 56,
            lc30: 41,
            lc10: 24
        }
    },
    "warning.700": {
        "warning.100": {
            contrast: 13.80916623157784,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.200": {
            contrast: 13.287693033395579,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.300": {
            contrast: 11.799072465709134,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.400": {
            contrast: 9.684700333739459,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.900": {
            contrast: 7.6957667405983035,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1000": {
            contrast: 11.885581651756782,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1100": {
            contrast: 16.260681939894514,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93
        },
        "warning.1200": {
            contrast: 20.819662991448908,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75.5
        },
        "warning.1300": {
            contrast: 25.773718358585306,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63
        },
        "warning.1400": {
            contrast: 32.046415112106914,
            lc60: 100,
            lc45: 100,
            lc30: 94,
            lc10: 52.5
        },
        "warning.1500": {
            contrast: 34.59499673285094,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 49.5
        },
        "warning.1600": {
            contrast: 39.39165738255016,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 44.5
        },
        "warning.1700": {
            contrast: 44.808722658684,
            lc60: 100,
            lc45: 100,
            lc30: 72,
            lc10: 40.5
        },
        "warning.1800": {
            contrast: 50.33678458887755,
            lc60: 100,
            lc45: 91,
            lc30: 66,
            lc10: 37
        },
        "warning.1900": {
            contrast: 56.06149778060626,
            lc60: 100,
            lc45: 84,
            lc30: 60.5,
            lc10: 34.5
        },
        "warning.2000": {
            contrast: 61.85328144335494,
            lc60: 97,
            lc45: 77.5,
            lc30: 56.5,
            lc10: 32
        },
        "warning.2100": {
            contrast: 68.02603562393404,
            lc60: 91,
            lc45: 72.5,
            lc30: 52.5,
            lc10: 30
        },
        "warning.2200": {
            contrast: 74.54385053549338,
            lc60: 84.5,
            lc45: 68,
            lc30: 49,
            lc10: 28.5
        },
        "warning.2300": {
            contrast: 80.97232973751629,
            lc60: 79.5,
            lc45: 64,
            lc30: 46.5,
            lc10: 27
        },
        "warning.2400": {
            contrast: 87.65559860657005,
            lc60: 75,
            lc45: 60,
            lc30: 44,
            lc10: 25.5
        },
        "warning.2500": {
            contrast: 94.6174488598765,
            lc60: 71,
            lc45: 57,
            lc30: 41.5,
            lc10: 24.5
        }
    },
    "warning.800": {
        "warning.100": {
            contrast: 18.64224801352612,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "warning.200": {
            contrast: 18.120774815343857,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69.5
        },
        "warning.300": {
            contrast: 16.632154247657414,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85
        },
        "warning.400": {
            contrast: 14.517782115687735,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.500": {
            contrast: 11.428504487673887,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1000": {
            contrast: 7.514051513006318,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1100": {
            contrast: 11.889151801144049,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1200": {
            contrast: 16.448132852698443,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91.5
        },
        "warning.1300": {
            contrast: 21.40218821983484,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73
        },
        "warning.1400": {
            contrast: 27.674884973356445,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58.5
        },
        "warning.1500": {
            contrast: 30.223466594100472,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 54.5
        },
        "warning.1600": {
            contrast: 35.02012724379969,
            lc60: 100,
            lc45: 100,
            lc30: 87.5,
            lc10: 48
        },
        "warning.1700": {
            contrast: 40.43719251993353,
            lc60: 100,
            lc45: 100,
            lc30: 77.5,
            lc10: 42.5
        },
        "warning.1800": {
            contrast: 45.96525445012708,
            lc60: 100,
            lc45: 98,
            lc30: 70,
            lc10: 39
        },
        "warning.1900": {
            contrast: 51.6899676418558,
            lc60: 100,
            lc45: 89.5,
            lc30: 64,
            lc10: 36
        },
        "warning.2000": {
            contrast: 57.48175130460448,
            lc60: 100,
            lc45: 82,
            lc30: 59.5,
            lc10: 33.5
        },
        "warning.2100": {
            contrast: 63.65450548518356,
            lc60: 95,
            lc45: 76,
            lc30: 55,
            lc10: 31
        },
        "warning.2200": {
            contrast: 70.17232039674292,
            lc60: 88.5,
            lc45: 70.5,
            lc30: 51.5,
            lc10: 29.5
        },
        "warning.2300": {
            contrast: 76.60079959876583,
            lc60: 83,
            lc45: 66.5,
            lc30: 48,
            lc10: 27.5
        },
        "warning.2400": {
            contrast: 83.2840684678196,
            lc60: 78,
            lc45: 62,
            lc30: 45.5,
            lc10: 26
        },
        "warning.2500": {
            contrast: 90.24591872112605,
            lc60: 73.5,
            lc45: 59,
            lc30: 43,
            lc10: 24.5
        }
    },
    "warning.900": {
        "warning.100": {
            contrast: 23.160430116561816,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 44.5
        },
        "warning.200": {
            contrast: 22.638956918379556,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53
        },
        "warning.300": {
            contrast: 21.150336350693113,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "warning.400": {
            contrast: 19.035964218723432,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74.5
        },
        "warning.500": {
            contrast: 15.946686590709588,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93.5
        },
        "warning.600": {
            contrast: 11.631691408074396,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1100": {
            contrast: 7.684333317586469,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1200": {
            contrast: 12.243314369140862,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1300": {
            contrast: 17.19736973627726,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88
        },
        "warning.1400": {
            contrast: 23.470066489798867,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67
        },
        "warning.1500": {
            contrast: 26.01864811054289,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62
        },
        "warning.1600": {
            contrast: 30.815308760242115,
            lc60: 100,
            lc45: 100,
            lc30: 97,
            lc10: 53.5
        },
        "warning.1700": {
            contrast: 36.23237403637596,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 47
        },
        "warning.1800": {
            contrast: 41.7604359665695,
            lc60: 100,
            lc45: 100,
            lc30: 76,
            lc10: 42
        },
        "warning.1900": {
            contrast: 47.48514915829822,
            lc60: 100,
            lc45: 95.5,
            lc30: 68,
            lc10: 38
        },
        "warning.2000": {
            contrast: 53.2769328210469,
            lc60: 100,
            lc45: 87,
            lc30: 62.5,
            lc10: 35
        },
        "warning.2100": {
            contrast: 59.44968700162598,
            lc60: 100,
            lc45: 80,
            lc30: 57.5,
            lc10: 32.5
        },
        "warning.2200": {
            contrast: 65.96750191318534,
            lc60: 92.5,
            lc45: 74,
            lc30: 53.5,
            lc10: 30.5
        },
        "warning.2300": {
            contrast: 72.39598111520826,
            lc60: 86.5,
            lc45: 69,
            lc30: 50.5,
            lc10: 28.5
        },
        "warning.2400": {
            contrast: 79.079249984262,
            lc60: 81,
            lc45: 65,
            lc30: 47,
            lc10: 27
        },
        "warning.2500": {
            contrast: 86.04110023756847,
            lc60: 76,
            lc45: 61,
            lc30: 44.5,
            lc10: 25.5
        }
    },
    "warning.1000": {
        "warning.100": {
            contrast: 27.478736635250712,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 38.5
        },
        "warning.200": {
            contrast: 26.957263437068452,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 44.5
        },
        "warning.300": {
            contrast: 25.468642869382013,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51.5
        },
        "warning.400": {
            contrast: 23.35427073741233,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60.5
        },
        "warning.500": {
            contrast: 20.26499310939849,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73
        },
        "warning.600": {
            contrast: 15.949997926763299,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93
        },
        "warning.700": {
            contrast: 11.603771018857925,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1200": {
            contrast: 8.13126814396516,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1300": {
            contrast: 13.08532351110156,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1400": {
            contrast: 19.358020264623164,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79.5
        },
        "warning.1500": {
            contrast: 21.90660188536719,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "warning.1600": {
            contrast: 26.703262535066408,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "warning.1700": {
            contrast: 32.12032781120025,
            lc60: 100,
            lc45: 100,
            lc30: 94,
            lc10: 51
        },
        "warning.1800": {
            contrast: 37.6483897413938,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 45.5
        },
        "warning.1900": {
            contrast: 43.37310293312252,
            lc60: 100,
            lc45: 100,
            lc30: 73.5,
            lc10: 41
        },
        "warning.2000": {
            contrast: 49.164886595871195,
            lc60: 100,
            lc45: 93,
            lc30: 67,
            lc10: 37.5
        },
        "warning.2100": {
            contrast: 55.33764077645027,
            lc60: 100,
            lc45: 84.5,
            lc30: 61,
            lc10: 34.5
        },
        "warning.2200": {
            contrast: 61.85545568800964,
            lc60: 97,
            lc45: 78,
            lc30: 56,
            lc10: 31.5
        },
        "warning.2300": {
            contrast: 68.28393489003255,
            lc60: 90.5,
            lc45: 72,
            lc30: 52.5,
            lc10: 29.5
        },
        "warning.2400": {
            contrast: 74.96720375908632,
            lc60: 84.5,
            lc45: 67,
            lc30: 49,
            lc10: 28
        },
        "warning.2500": {
            contrast: 81.92905401239278,
            lc60: 79,
            lc45: 63,
            lc30: 46,
            lc10: 26.5
        }
    },
    "warning.1100": {
        "warning.100": {
            contrast: 31.92856433334461,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 33.5
        },
        "warning.200": {
            contrast: 31.40709113516235,
            lc60: 100,
            lc45: 100,
            lc30: 87.5,
            lc10: 38.5
        },
        "warning.300": {
            contrast: 29.918470567475907,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 44
        },
        "warning.400": {
            contrast: 27.80409843550623,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 50
        },
        "warning.500": {
            contrast: 24.714820807492384,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "warning.600": {
            contrast: 20.399825624857197,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "warning.700": {
            contrast: 16.05359871695182,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93
        },
        "warning.800": {
            contrast: 11.268686108234965,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1300": {
            contrast: 8.762849056339771,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1400": {
            contrast: 15.035545809861379,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98.5
        },
        "warning.1500": {
            contrast: 17.584127430605406,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86
        },
        "warning.1600": {
            contrast: 22.38078808030463,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69.5
        },
        "warning.1700": {
            contrast: 27.797853356438463,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59
        },
        "warning.1800": {
            contrast: 33.32591528663201,
            lc60: 100,
            lc45: 100,
            lc30: 91,
            lc10: 50.5
        },
        "warning.1900": {
            contrast: 39.050628478360736,
            lc60: 100,
            lc45: 100,
            lc30: 80.5,
            lc10: 44.5
        },
        "warning.2000": {
            contrast: 44.842412141109406,
            lc60: 100,
            lc45: 100,
            lc30: 71.5,
            lc10: 40
        },
        "warning.2100": {
            contrast: 51.01516632168849,
            lc60: 100,
            lc45: 90,
            lc30: 65,
            lc10: 36.5
        },
        "warning.2200": {
            contrast: 57.532981233247845,
            lc60: 100,
            lc45: 82,
            lc30: 59.5,
            lc10: 34
        },
        "warning.2300": {
            contrast: 63.961460435270766,
            lc60: 95,
            lc45: 76,
            lc30: 55,
            lc10: 31.5
        },
        "warning.2400": {
            contrast: 70.64472930432453,
            lc60: 88,
            lc45: 70.5,
            lc30: 51.5,
            lc10: 29
        },
        "warning.2500": {
            contrast: 77.60657955763098,
            lc60: 82,
            lc45: 65.5,
            lc30: 47.5,
            lc10: 27.5
        }
    },
    "warning.1200": {
        "warning.100": {
            contrast: 36.50946091033647,
            lc60: 100,
            lc45: 100,
            lc30: 61.5,
            lc10: 30
        },
        "warning.200": {
            contrast: 35.987987712154215,
            lc60: 100,
            lc45: 100,
            lc30: 69.5,
            lc10: 33.5
        },
        "warning.300": {
            contrast: 34.49936714446777,
            lc60: 100,
            lc45: 100,
            lc30: 79,
            lc10: 38.5
        },
        "warning.400": {
            contrast: 32.38499501249809,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 43
        },
        "warning.500": {
            contrast: 29.29571738448424,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 50
        },
        "warning.600": {
            contrast: 24.980722201849055,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "warning.700": {
            contrast: 20.634495293943683,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73
        },
        "warning.800": {
            contrast: 15.849582685226823,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95
        },
        "warning.900": {
            contrast: 11.362240127064155,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1400": {
            contrast: 10.503981858874445,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1500": {
            contrast: 13.05256347961847,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1600": {
            contrast: 17.849224129317694,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85.5
        },
        "warning.1700": {
            contrast: 23.26628940545153,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "warning.1800": {
            contrast: 28.79435133564508,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "warning.1900": {
            contrast: 34.5190645273738,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 49.5
        },
        "warning.2000": {
            contrast: 40.31084819012247,
            lc60: 100,
            lc45: 100,
            lc30: 79,
            lc10: 44
        },
        "warning.2100": {
            contrast: 46.48360237070156,
            lc60: 100,
            lc45: 97.5,
            lc30: 70,
            lc10: 39.5
        },
        "warning.2200": {
            contrast: 53.00141728226091,
            lc60: 100,
            lc45: 88,
            lc30: 63.5,
            lc10: 36
        },
        "warning.2300": {
            contrast: 59.42989648428384,
            lc60: 100,
            lc45: 80.5,
            lc30: 58.5,
            lc10: 33
        },
        "warning.2400": {
            contrast: 66.11316535333759,
            lc60: 93,
            lc45: 74.5,
            lc30: 54,
            lc10: 31
        },
        "warning.2500": {
            contrast: 73.07501560664406,
            lc60: 86,
            lc45: 69,
            lc30: 50.5,
            lc10: 29
        }
    },
    "warning.1300": {
        "warning.100": {
            contrast: 41.43071166870881,
            lc60: 100,
            lc45: 100,
            lc30: 54,
            lc10: 27
        },
        "warning.200": {
            contrast: 40.909238470526546,
            lc60: 100,
            lc45: 100,
            lc30: 60.5,
            lc10: 30
        },
        "warning.300": {
            contrast: 39.42061790284011,
            lc60: 100,
            lc45: 100,
            lc30: 67.5,
            lc10: 33.5
        },
        "warning.400": {
            contrast: 37.306245770870426,
            lc60: 100,
            lc45: 100,
            lc30: 75,
            lc10: 37.5
        },
        "warning.500": {
            contrast: 34.21696814285658,
            lc60: 100,
            lc45: 100,
            lc30: 85.5,
            lc10: 42.5
        },
        "warning.600": {
            contrast: 29.90197296022139,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 50
        },
        "warning.700": {
            contrast: 25.55574605231602,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59
        },
        "warning.800": {
            contrast: 20.770833443599162,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73
        },
        "warning.900": {
            contrast: 16.283490885436493,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 92.5
        },
        "warning.1000": {
            contrast: 11.983712296762016,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1100": {
            contrast: 7.543165211494446,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1500": {
            contrast: 8.1000565962939,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1600": {
            contrast: 12.89671724599312,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1700": {
            contrast: 18.31378252212696,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83
        },
        "warning.1800": {
            contrast: 23.84184445232051,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "warning.1900": {
            contrast: 29.56655764404923,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "warning.2000": {
            contrast: 35.3583413067979,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 49.5
        },
        "warning.2100": {
            contrast: 41.53109548737699,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 43.5
        },
        "warning.2200": {
            contrast: 48.04891039893634,
            lc60: 100,
            lc45: 95,
            lc30: 69,
            lc10: 39.5
        },
        "warning.2300": {
            contrast: 54.477389600959256,
            lc60: 100,
            lc45: 86.5,
            lc30: 62.5,
            lc10: 36
        },
        "warning.2400": {
            contrast: 61.16065847001302,
            lc60: 98,
            lc45: 79.5,
            lc30: 57.5,
            lc10: 33.5
        },
        "warning.2500": {
            contrast: 68.12250872331947,
            lc60: 90.5,
            lc45: 73.5,
            lc30: 53.5,
            lc10: 30.5
        }
    },
    "warning.1400": {
        "warning.100": {
            contrast: 47.58789631538573,
            lc60: 100,
            lc45: 79,
            lc30: 47,
            lc10: 23.5
        },
        "warning.200": {
            contrast: 47.06642311720347,
            lc60: 100,
            lc45: 87.5,
            lc30: 52,
            lc10: 26
        },
        "warning.300": {
            contrast: 45.577802549517024,
            lc60: 100,
            lc45: 97,
            lc30: 57.5,
            lc10: 28.5
        },
        "warning.400": {
            contrast: 43.46343041754735,
            lc60: 100,
            lc45: 100,
            lc30: 63.5,
            lc10: 31.5
        },
        "warning.500": {
            contrast: 40.374152789533504,
            lc60: 100,
            lc45: 100,
            lc30: 71,
            lc10: 35.5
        },
        "warning.600": {
            contrast: 36.05915760689831,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 41
        },
        "warning.700": {
            contrast: 31.712930698992942,
            lc60: 100,
            lc45: 100,
            lc30: 93.5,
            lc10: 47
        },
        "warning.800": {
            contrast: 26.92801809027608,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56
        },
        "warning.900": {
            contrast: 22.440675532113417,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67
        },
        "warning.1000": {
            contrast: 18.14089694343894,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83
        },
        "warning.1100": {
            contrast: 13.700349858171368,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1200": {
            contrast: 9.119747619410825,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1700": {
            contrast: 12.005482581691783,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1800": {
            contrast: 17.53354451188533,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88.5
        },
        "warning.1900": {
            contrast: 23.258257703614056,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69.5
        },
        "warning.2000": {
            contrast: 29.050041366362723,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58.5
        },
        "warning.2100": {
            contrast: 35.22279554694181,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 51
        },
        "warning.2200": {
            contrast: 41.740610458501166,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 44
        },
        "warning.2300": {
            contrast: 48.16908966052408,
            lc60: 100,
            lc45: 95,
            lc30: 69.5,
            lc10: 40
        },
        "warning.2400": {
            contrast: 54.85235852957784,
            lc60: 100,
            lc45: 86,
            lc30: 63,
            lc10: 36
        },
        "warning.2500": {
            contrast: 61.81420878288429,
            lc60: 97.5,
            lc45: 78.5,
            lc30: 57.5,
            lc10: 33
        }
    },
    "warning.1500": {
        "warning.100": {
            contrast: 50.06831644897465,
            lc60: 100,
            lc45: 72,
            lc30: 44.5,
            lc10: 22.5
        },
        "warning.200": {
            contrast: 49.54684325079239,
            lc60: 100,
            lc45: 79.5,
            lc30: 49.5,
            lc10: 25
        },
        "warning.300": {
            contrast: 48.05822268310595,
            lc60: 100,
            lc45: 88,
            lc30: 54.5,
            lc10: 27.5
        },
        "warning.400": {
            contrast: 45.94385055113627,
            lc60: 100,
            lc45: 96,
            lc30: 59.5,
            lc10: 30
        },
        "warning.500": {
            contrast: 42.854572923122426,
            lc60: 100,
            lc45: 100,
            lc30: 66.5,
            lc10: 33.5
        },
        "warning.600": {
            contrast: 38.53957774048723,
            lc60: 100,
            lc45: 100,
            lc30: 76,
            lc10: 38
        },
        "warning.700": {
            contrast: 34.193350832581864,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 43.5
        },
        "warning.800": {
            contrast: 29.408438223865,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51.5
        },
        "warning.900": {
            contrast: 24.92109566570234,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61
        },
        "warning.1000": {
            contrast: 20.62131707702786,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "warning.1100": {
            contrast: 16.18076999176029,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93.5
        },
        "warning.1200": {
            contrast: 11.600167752999749,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1700": {
            contrast: 9.431501624836848,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1800": {
            contrast: 14.959563555030398,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1900": {
            contrast: 20.68427674675912,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77
        },
        "warning.2000": {
            contrast: 26.476060409507784,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63.5
        },
        "warning.2100": {
            contrast: 32.64881459008687,
            lc60: 100,
            lc45: 100,
            lc30: 93.5,
            lc10: 53
        },
        "warning.2200": {
            contrast: 39.16662950164623,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 46.5
        },
        "warning.2300": {
            contrast: 45.59510870366915,
            lc60: 100,
            lc45: 98.5,
            lc30: 72,
            lc10: 41.5
        },
        "warning.2400": {
            contrast: 52.2783775727229,
            lc60: 100,
            lc45: 89,
            lc30: 64.5,
            lc10: 37
        },
        "warning.2500": {
            contrast: 59.240227826029354,
            lc60: 100,
            lc45: 81,
            lc30: 59.5,
            lc10: 34.5
        }
    },
    "warning.1600": {
        "warning.100": {
            contrast: 54.70645697771091,
            lc60: 100,
            lc45: 64,
            lc30: 41,
            lc10: 20.5
        },
        "warning.200": {
            contrast: 54.184983779528636,
            lc60: 100,
            lc45: 70.5,
            lc30: 45,
            lc10: 22.5
        },
        "warning.300": {
            contrast: 52.696363211842204,
            lc60: 100,
            lc45: 77,
            lc30: 49.5,
            lc10: 24.5
        },
        "warning.400": {
            contrast: 50.58199107987252,
            lc60: 100,
            lc45: 84,
            lc30: 53.5,
            lc10: 27
        },
        "warning.500": {
            contrast: 47.49271345185867,
            lc60: 100,
            lc45: 93,
            lc30: 59,
            lc10: 30
        },
        "warning.600": {
            contrast: 43.17771826922348,
            lc60: 100,
            lc45: 100,
            lc30: 66.5,
            lc10: 33.5
        },
        "warning.700": {
            contrast: 38.83149136131811,
            lc60: 100,
            lc45: 100,
            lc30: 75,
            lc10: 38
        },
        "warning.800": {
            contrast: 34.04657875260125,
            lc60: 100,
            lc45: 100,
            lc30: 87.5,
            lc10: 44
        },
        "warning.900": {
            contrast: 29.559236194438583,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 50.5
        },
        "warning.1000": {
            contrast: 25.25945760576411,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "warning.1100": {
            contrast: 20.81891052049654,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72.5
        },
        "warning.1200": {
            contrast: 16.238308281735996,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 92
        },
        "warning.1300": {
            contrast: 11.307982442798581,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1800": {
            contrast: 10.0993282374133,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1900": {
            contrast: 15.82404142914202,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 94.5
        },
        "warning.2000": {
            contrast: 21.615825091890688,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74
        },
        "warning.2100": {
            contrast: 27.788579272469775,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "warning.2200": {
            contrast: 34.30639418402913,
            lc60: 100,
            lc45: 100,
            lc30: 89.5,
            lc10: 51.5
        },
        "warning.2300": {
            contrast: 40.73487338605205,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 45
        },
        "warning.2400": {
            contrast: 47.41814225510581,
            lc60: 100,
            lc45: 96,
            lc30: 69.5,
            lc10: 39.5
        },
        "warning.2500": {
            contrast: 54.379992508412265,
            lc60: 100,
            lc45: 86,
            lc30: 62.5,
            lc10: 35.5
        }
    },
    "warning.1700": {
        "warning.100": {
            contrast: 59.90073843013375,
            lc60: 100,
            lc45: 58,
            lc30: 37.5,
            lc10: 19
        },
        "warning.200": {
            contrast: 59.379265231951486,
            lc60: 100,
            lc45: 63.5,
            lc30: 41,
            lc10: 20.5
        },
        "warning.300": {
            contrast: 57.89064466426505,
            lc60: 100,
            lc45: 68.5,
            lc30: 44,
            lc10: 22
        },
        "warning.400": {
            contrast: 55.776272532295366,
            lc60: 100,
            lc45: 74.5,
            lc30: 48,
            lc10: 24.5
        },
        "warning.500": {
            contrast: 52.68699490428151,
            lc60: 100,
            lc45: 82,
            lc30: 52.5,
            lc10: 26.5
        },
        "warning.600": {
            contrast: 48.37199972164633,
            lc60: 100,
            lc45: 91.5,
            lc30: 58.5,
            lc10: 30
        },
        "warning.700": {
            contrast: 44.02577281374096,
            lc60: 100,
            lc45: 100,
            lc30: 65.5,
            lc10: 33
        },
        "warning.800": {
            contrast: 39.24086020502409,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 37.5
        },
        "warning.900": {
            contrast: 34.753517646861425,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 43
        },
        "warning.1000": {
            contrast: 30.45373905818695,
            lc60: 100,
            lc45: 100,
            lc30: 98,
            lc10: 50
        },
        "warning.1100": {
            contrast: 26.01319197291938,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "warning.1200": {
            contrast: 21.432589734158842,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "warning.1300": {
            contrast: 16.502263895221425,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 90
        },
        "warning.1400": {
            contrast: 10.321435529914694,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1500": {
            contrast: 7.8279493764634545,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1900": {
            contrast: 10.312105156542245,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.2000": {
            contrast: 16.103888819290916,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 94
        },
        "warning.2100": {
            contrast: 22.276642999870003,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72
        },
        "warning.2200": {
            contrast: 28.794457911429355,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58
        },
        "warning.2300": {
            contrast: 35.222937113452275,
            lc60: 100,
            lc45: 100,
            lc30: 87.5,
            lc10: 49
        },
        "warning.2400": {
            contrast: 41.90620598250604,
            lc60: 100,
            lc45: 100,
            lc30: 76,
            lc10: 42.5
        },
        "warning.2500": {
            contrast: 48.86805623581248,
            lc60: 100,
            lc45: 93,
            lc30: 67,
            lc10: 37.5
        }
    },
    "warning.1800": {
        "warning.100": {
            contrast: 65.15786908391841,
            lc60: 76,
            lc45: 53.5,
            lc30: 34.5,
            lc10: 17.5
        },
        "warning.200": {
            contrast: 64.63639588573615,
            lc60: 82.5,
            lc45: 57.5,
            lc30: 37.5,
            lc10: 19
        },
        "warning.300": {
            contrast: 63.14777531804972,
            lc60: 89.5,
            lc45: 62.5,
            lc30: 40,
            lc10: 20.5
        },
        "warning.400": {
            contrast: 61.03340318608004,
            lc60: 96.5,
            lc45: 67,
            lc30: 43,
            lc10: 22
        },
        "warning.500": {
            contrast: 57.94412555806618,
            lc60: 100,
            lc45: 73,
            lc30: 47,
            lc10: 24
        },
        "warning.600": {
            contrast: 53.629130375431004,
            lc60: 100,
            lc45: 80.5,
            lc30: 52,
            lc10: 26.5
        },
        "warning.700": {
            contrast: 49.28290346752562,
            lc60: 100,
            lc45: 89.5,
            lc30: 57.5,
            lc10: 29
        },
        "warning.800": {
            contrast: 44.49799085880876,
            lc60: 100,
            lc45: 100,
            lc30: 65,
            lc10: 32.5
        },
        "warning.900": {
            contrast: 40.010648300646096,
            lc60: 100,
            lc45: 100,
            lc30: 73,
            lc10: 36.5
        },
        "warning.1000": {
            contrast: 35.71086971197162,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 41.5
        },
        "warning.1100": {
            contrast: 31.27032262670405,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 48
        },
        "warning.1200": {
            contrast: 26.689720387943506,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "warning.1300": {
            contrast: 21.759394549006096,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "warning.1400": {
            contrast: 15.578566183699364,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 96.5
        },
        "warning.1500": {
            contrast: 13.085080030248122,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1600": {
            contrast: 8.41745672854894,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.2000": {
            contrast: 10.455746031433813,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.2100": {
            contrast: 16.628500212012902,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91.5
        },
        "warning.2200": {
            contrast: 23.146315123572254,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "warning.2300": {
            contrast: 29.57479432559517,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56
        },
        "warning.2400": {
            contrast: 36.25806319464893,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 47.5
        },
        "warning.2500": {
            contrast: 43.219913447955385,
            lc60: 100,
            lc45: 100,
            lc30: 73,
            lc10: 41
        }
    },
    "warning.1900": {
        "warning.100": {
            contrast: 70.55965400385227,
            lc60: 68.5,
            lc45: 49,
            lc30: 32,
            lc10: 16.5
        },
        "warning.200": {
            contrast: 70.03818080567001,
            lc60: 73.5,
            lc45: 52.5,
            lc30: 34.5,
            lc10: 17.5
        },
        "warning.300": {
            contrast: 68.54956023798357,
            lc60: 79,
            lc45: 56.5,
            lc30: 37,
            lc10: 19
        },
        "warning.400": {
            contrast: 66.4351881060139,
            lc60: 85,
            lc45: 60.5,
            lc30: 39.5,
            lc10: 20
        },
        "warning.500": {
            contrast: 63.34591047800004,
            lc60: 92.5,
            lc45: 65.5,
            lc30: 42.5,
            lc10: 22
        },
        "warning.600": {
            contrast: 59.03091529536486,
            lc60: 100,
            lc45: 71.5,
            lc30: 46.5,
            lc10: 23.5
        },
        "warning.700": {
            contrast: 54.68468838745948,
            lc60: 100,
            lc45: 79,
            lc30: 51,
            lc10: 26
        },
        "warning.800": {
            contrast: 49.89977577874263,
            lc60: 100,
            lc45: 88,
            lc30: 56.5,
            lc10: 28.5
        },
        "warning.900": {
            contrast: 45.412433220579956,
            lc60: 100,
            lc45: 98.5,
            lc30: 63,
            lc10: 31.5
        },
        "warning.1000": {
            contrast: 41.112654631905485,
            lc60: 100,
            lc45: 100,
            lc30: 69.5,
            lc10: 35
        },
        "warning.1100": {
            contrast: 36.67210754663791,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 40
        },
        "warning.1200": {
            contrast: 32.09150530787737,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 45.5
        },
        "warning.1300": {
            contrast: 27.16117946893995,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53
        },
        "warning.1400": {
            contrast: 20.980351103633225,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "warning.1500": {
            contrast: 18.486864950181985,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80.5
        },
        "warning.1600": {
            contrast: 13.819241648482802,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1700": {
            contrast: 8.584628255304406,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.2100": {
            contrast: 10.756547043836825,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.2200": {
            contrast: 17.274361955396184,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89
        },
        "warning.2300": {
            contrast: 23.7028411574191,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "warning.2400": {
            contrast: 30.386110026472856,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 55
        },
        "warning.2500": {
            contrast: 37.347960279779315,
            lc60: 100,
            lc45: 100,
            lc30: 83,
            lc10: 46
        }
    },
    "warning.2000": {
        "warning.100": {
            contrast: 75.98447953710291,
            lc60: 63,
            lc45: 45.5,
            lc30: 30,
            lc10: 15.5
        },
        "warning.200": {
            contrast: 75.46300633892065,
            lc60: 67,
            lc45: 48.5,
            lc30: 31.5,
            lc10: 16.5
        },
        "warning.300": {
            contrast: 73.97438577123421,
            lc60: 72,
            lc45: 52,
            lc30: 34,
            lc10: 17.5
        },
        "warning.400": {
            contrast: 71.86001363926454,
            lc60: 76.5,
            lc45: 55,
            lc30: 36,
            lc10: 18.5
        },
        "warning.500": {
            contrast: 68.77073601125068,
            lc60: 82.5,
            lc45: 59.5,
            lc30: 39,
            lc10: 20
        },
        "warning.600": {
            contrast: 64.45574082861549,
            lc60: 90.5,
            lc45: 64.5,
            lc30: 42,
            lc10: 21.5
        },
        "warning.700": {
            contrast: 60.109513920710114,
            lc60: 99.5,
            lc45: 70,
            lc30: 45.5,
            lc10: 23.5
        },
        "warning.800": {
            contrast: 55.32460131199326,
            lc60: 100,
            lc45: 77.5,
            lc30: 50,
            lc10: 26
        },
        "warning.900": {
            contrast: 50.837258753830596,
            lc60: 100,
            lc45: 86,
            lc30: 55,
            lc10: 28
        },
        "warning.1000": {
            contrast: 46.53748016515611,
            lc60: 100,
            lc45: 95.5,
            lc30: 61,
            lc10: 30.5
        },
        "warning.1100": {
            contrast: 42.096933079888544,
            lc60: 100,
            lc45: 100,
            lc30: 68,
            lc10: 34.5
        },
        "warning.1200": {
            contrast: 37.516330841128,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 38
        },
        "warning.1300": {
            contrast: 32.58600500219059,
            lc60: 100,
            lc45: 100,
            lc30: 90.5,
            lc10: 43.5
        },
        "warning.1400": {
            contrast: 26.40517663688386,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54.5
        },
        "warning.1500": {
            contrast: 23.911690483432622,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60.5
        },
        "warning.1600": {
            contrast: 19.244067181733435,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77.5
        },
        "warning.1700": {
            contrast: 14.00945378855504,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1800": {
            contrast: 8.704207912997726,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.2200": {
            contrast: 11.311618277258479,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.2300": {
            contrast: 17.740097479281395,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86.5
        },
        "warning.2400": {
            contrast: 24.423366348335154,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65.5
        },
        "warning.2500": {
            contrast: 31.38521660164161,
            lc60: 100,
            lc45: 100,
            lc30: 96,
            lc10: 52.5
        }
    },
    "warning.2100": {
        "warning.100": {
            contrast: 81.72510799471475,
            lc60: 58,
            lc45: 42,
            lc30: 27.5,
            lc10: 14.5
        },
        "warning.200": {
            contrast: 81.20363479653248,
            lc60: 61.5,
            lc45: 44.5,
            lc30: 29.5,
            lc10: 15.5
        },
        "warning.300": {
            contrast: 79.71501422884604,
            lc60: 65.5,
            lc45: 47.5,
            lc30: 31,
            lc10: 16
        },
        "warning.400": {
            contrast: 77.60064209687637,
            lc60: 69.5,
            lc45: 50.5,
            lc30: 33,
            lc10: 17
        },
        "warning.500": {
            contrast: 74.51136446886252,
            lc60: 74.5,
            lc45: 54,
            lc30: 35.5,
            lc10: 18.5
        },
        "warning.600": {
            contrast: 70.19636928622732,
            lc60: 81,
            lc45: 58,
            lc30: 38,
            lc10: 19.5
        },
        "warning.700": {
            contrast: 65.85014237832196,
            lc60: 88,
            lc45: 63,
            lc30: 41,
            lc10: 21.5
        },
        "warning.800": {
            contrast: 61.065229769605104,
            lc60: 97.5,
            lc45: 69,
            lc30: 44.5,
            lc10: 23
        },
        "warning.900": {
            contrast: 56.57788721144244,
            lc60: 100,
            lc45: 75.5,
            lc30: 48.5,
            lc10: 25
        },
        "warning.1000": {
            contrast: 52.27810862276796,
            lc60: 100,
            lc45: 82.5,
            lc30: 53.5,
            lc10: 27
        },
        "warning.1100": {
            contrast: 47.837561537500385,
            lc60: 100,
            lc45: 92.5,
            lc30: 58,
            lc10: 29.5
        },
        "warning.1200": {
            contrast: 43.256959298739844,
            lc60: 100,
            lc45: 100,
            lc30: 64.5,
            lc10: 32.5
        },
        "warning.1300": {
            contrast: 38.32663345980243,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 37
        },
        "warning.1400": {
            contrast: 32.1458050944957,
            lc60: 100,
            lc45: 100,
            lc30: 91.5,
            lc10: 43.5
        },
        "warning.1500": {
            contrast: 29.65231894104446,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 47.5
        },
        "warning.1600": {
            contrast: 24.984695639345276,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58.5
        },
        "warning.1700": {
            contrast: 19.750082246166876,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75
        },
        "warning.1800": {
            contrast: 14.444836370609565,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1900": {
            contrast: 8.986510828330127,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.2300": {
            contrast: 11.362468196447809,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.2400": {
            contrast: 18.04573706550157,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86
        },
        "warning.2500": {
            contrast: 25.00758731880802,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65
        }
    },
    "warning.2200": {
        "warning.100": {
            contrast: 87.7442251181507,
            lc60: 53.5,
            lc45: 39.5,
            lc30: 26,
            lc10: 13.5
        },
        "warning.200": {
            contrast: 87.22275191996843,
            lc60: 56.5,
            lc45: 41.5,
            lc30: 27.5,
            lc10: 14.5
        },
        "warning.300": {
            contrast: 85.73413135228199,
            lc60: 60,
            lc45: 44,
            lc30: 29,
            lc10: 15
        },
        "warning.400": {
            contrast: 83.61975922031232,
            lc60: 63.5,
            lc45: 46.5,
            lc30: 30.5,
            lc10: 16
        },
        "warning.500": {
            contrast: 80.53048159229846,
            lc60: 68,
            lc45: 49,
            lc30: 32.5,
            lc10: 17
        },
        "warning.600": {
            contrast: 76.21548640966328,
            lc60: 73,
            lc45: 53,
            lc30: 35,
            lc10: 18
        },
        "warning.700": {
            contrast: 71.8692595017579,
            lc60: 79,
            lc45: 56.5,
            lc30: 37.5,
            lc10: 19.5
        },
        "warning.800": {
            contrast: 67.08434689304104,
            lc60: 86,
            lc45: 61.5,
            lc30: 40,
            lc10: 20.5
        },
        "warning.900": {
            contrast: 62.59700433487838,
            lc60: 94,
            lc45: 67,
            lc30: 43.5,
            lc10: 22.5
        },
        "warning.1000": {
            contrast: 58.29722574620389,
            lc60: 100,
            lc45: 72.5,
            lc30: 46.5,
            lc10: 24
        },
        "warning.1100": {
            contrast: 53.85667866093633,
            lc60: 100,
            lc45: 79,
            lc30: 51,
            lc10: 25.5
        },
        "warning.1200": {
            contrast: 49.276076422175784,
            lc60: 100,
            lc45: 88.5,
            lc30: 55.5,
            lc10: 28
        },
        "warning.1300": {
            contrast: 44.34575058323837,
            lc60: 100,
            lc45: 100,
            lc30: 62,
            lc10: 31.5
        },
        "warning.1400": {
            contrast: 38.16492221793164,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 36.5
        },
        "warning.1500": {
            contrast: 35.6714360644804,
            lc60: 100,
            lc45: 100,
            lc30: 80.5,
            lc10: 39
        },
        "warning.1600": {
            contrast: 31.00381276278122,
            lc60: 100,
            lc45: 100,
            lc30: 96,
            lc10: 46
        },
        "warning.1700": {
            contrast: 25.76919936960282,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "warning.1800": {
            contrast: 20.463953494045512,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72.5
        },
        "warning.1900": {
            contrast: 15.005627951766071,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 99
        },
        "warning.2000": {
            contrast: 9.517263311264056,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.2400": {
            contrast: 11.287909106239669,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.2500": {
            contrast: 18.249759359546125,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85
        }
    },
    "warning.2300": {
        "warning.100": {
            contrast: 93.64133437755066,
            lc60: 50,
            lc45: 36.5,
            lc30: 24.5,
            lc10: 12.5
        },
        "warning.200": {
            contrast: 93.1198611793684,
            lc60: 52.5,
            lc45: 38.5,
            lc30: 25.5,
            lc10: 13.5
        },
        "warning.300": {
            contrast: 91.63124061168195,
            lc60: 55.5,
            lc45: 41,
            lc30: 27,
            lc10: 14
        },
        "warning.400": {
            contrast: 89.51686847971227,
            lc60: 58.5,
            lc45: 43,
            lc30: 28.5,
            lc10: 14.5
        },
        "warning.500": {
            contrast: 86.42759085169843,
            lc60: 62.5,
            lc45: 45.5,
            lc30: 30,
            lc10: 16
        },
        "warning.600": {
            contrast: 82.11259566906325,
            lc60: 66.5,
            lc45: 48,
            lc30: 32,
            lc10: 16.5
        },
        "warning.700": {
            contrast: 77.76636876115785,
            lc60: 71.5,
            lc45: 51.5,
            lc30: 34,
            lc10: 17.5
        },
        "warning.800": {
            contrast: 72.981456152441,
            lc60: 77,
            lc45: 55.5,
            lc30: 36.5,
            lc10: 19
        },
        "warning.900": {
            contrast: 68.49411359427833,
            lc60: 83.5,
            lc45: 59.5,
            lc30: 39,
            lc10: 20
        },
        "warning.1000": {
            contrast: 64.19433500560385,
            lc60: 91,
            lc45: 64.5,
            lc30: 42,
            lc10: 21.5
        },
        "warning.1100": {
            contrast: 59.753787920336286,
            lc60: 100,
            lc45: 70,
            lc30: 45.5,
            lc10: 23.5
        },
        "warning.1200": {
            contrast: 55.17318568157575,
            lc60: 100,
            lc45: 76.5,
            lc30: 49,
            lc10: 25.5
        },
        "warning.1300": {
            contrast: 50.24285984263833,
            lc60: 100,
            lc45: 86,
            lc30: 53.5,
            lc10: 27.5
        },
        "warning.1400": {
            contrast: 44.0620314773316,
            lc60: 100,
            lc45: 100,
            lc30: 62.5,
            lc10: 31
        },
        "warning.1500": {
            contrast: 41.568545323880365,
            lc60: 100,
            lc45: 100,
            lc30: 67,
            lc10: 33.5
        },
        "warning.1600": {
            contrast: 36.900922022181184,
            lc60: 100,
            lc45: 100,
            lc30: 77.5,
            lc10: 38
        },
        "warning.1700": {
            contrast: 31.66630862900278,
            lc60: 100,
            lc45: 100,
            lc30: 93.5,
            lc10: 45.5
        },
        "warning.1800": {
            contrast: 26.36106275344547,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56
        },
        "warning.1900": {
            contrast: 20.902737211166034,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "warning.2000": {
            contrast: 15.41437257066402,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 97.5
        },
        "warning.2100": {
            contrast: 9.599608181694656,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.2500": {
            contrast: 11.562268977404988,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "warning.2400": {
        "warning.100": {
            contrast: 99.73354073616065,
            lc60: 47,
            lc45: 34.5,
            lc30: 23,
            lc10: 12
        },
        "warning.200": {
            contrast: 99.21206753797837,
            lc60: 49,
            lc45: 36,
            lc30: 24,
            lc10: 12.5
        },
        "warning.300": {
            contrast: 97.72344697029193,
            lc60: 51.5,
            lc45: 38,
            lc30: 25,
            lc10: 13
        },
        "warning.400": {
            contrast: 95.60907483832224,
            lc60: 54,
            lc45: 40,
            lc30: 26.5,
            lc10: 13.5
        },
        "warning.500": {
            contrast: 92.5197972103084,
            lc60: 57.5,
            lc45: 42,
            lc30: 27.5,
            lc10: 15
        },
        "warning.600": {
            contrast: 88.20480202767321,
            lc60: 61,
            lc45: 44.5,
            lc30: 29.5,
            lc10: 15.5
        },
        "warning.700": {
            contrast: 83.85857511976785,
            lc60: 65,
            lc45: 47,
            lc30: 31.5,
            lc10: 16
        },
        "warning.800": {
            contrast: 79.07366251105098,
            lc60: 70,
            lc45: 50.5,
            lc30: 33.5,
            lc10: 17.5
        },
        "warning.900": {
            contrast: 74.58631995288832,
            lc60: 75,
            lc45: 54,
            lc30: 35.5,
            lc10: 18.5
        },
        "warning.1000": {
            contrast: 70.28654136421383,
            lc60: 81,
            lc45: 58,
            lc30: 38,
            lc10: 20
        },
        "warning.1100": {
            contrast: 65.84599427894628,
            lc60: 87.5,
            lc45: 62,
            lc30: 40.5,
            lc10: 21
        },
        "warning.1200": {
            contrast: 61.26539204018573,
            lc60: 97,
            lc45: 67,
            lc30: 43.5,
            lc10: 22.5
        },
        "warning.1300": {
            contrast: 56.33506620124831,
            lc60: 100,
            lc45: 74,
            lc30: 47.5,
            lc10: 24.5
        },
        "warning.1400": {
            contrast: 50.154237835941586,
            lc60: 100,
            lc45: 86,
            lc30: 53.5,
            lc10: 27
        },
        "warning.1500": {
            contrast: 47.66075168249034,
            lc60: 100,
            lc45: 92.5,
            lc30: 57,
            lc10: 28.5
        },
        "warning.1600": {
            contrast: 42.993128380791156,
            lc60: 100,
            lc45: 100,
            lc30: 65,
            lc10: 32.5
        },
        "warning.1700": {
            contrast: 37.758514987612756,
            lc60: 100,
            lc45: 100,
            lc30: 76,
            lc10: 38.5
        },
        "warning.1800": {
            contrast: 32.453269112055445,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 46
        },
        "warning.1900": {
            contrast: 26.99494356977601,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "warning.2000": {
            contrast: 21.506578929273996,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "warning.2100": {
            contrast: 15.69181454030463,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 96
        },
        "warning.2200": {
            contrast: 9.58782525991452,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "warning.2500": {
        "warning.100": {
            contrast: 106.04067321268862,
            lc60: 44,
            lc45: 32.5,
            lc30: 21.5,
            lc10: 11.5
        },
        "warning.200": {
            contrast: 105.51920001450634,
            lc60: 46,
            lc45: 34,
            lc30: 22.5,
            lc10: 12
        },
        "warning.300": {
            contrast: 104.0305794468199,
            lc60: 48,
            lc45: 35.5,
            lc30: 24,
            lc10: 12.5
        },
        "warning.400": {
            contrast: 101.91620731485023,
            lc60: 50.5,
            lc45: 37,
            lc30: 24.5,
            lc10: 13
        },
        "warning.500": {
            contrast: 98.82692968683637,
            lc60: 53,
            lc45: 39,
            lc30: 26,
            lc10: 13.5
        },
        "warning.600": {
            contrast: 94.51193450420118,
            lc60: 56,
            lc45: 41.5,
            lc30: 27.5,
            lc10: 14.5
        },
        "warning.700": {
            contrast: 90.1657075962958,
            lc60: 59.5,
            lc45: 43.5,
            lc30: 29,
            lc10: 15
        },
        "warning.800": {
            contrast: 85.38079498757895,
            lc60: 63.5,
            lc45: 46,
            lc30: 31,
            lc10: 16
        },
        "warning.900": {
            contrast: 80.89345242941627,
            lc60: 68,
            lc45: 49,
            lc30: 32.5,
            lc10: 17
        },
        "warning.1000": {
            contrast: 76.5936738407418,
            lc60: 72,
            lc45: 52,
            lc30: 34.5,
            lc10: 18
        },
        "warning.1100": {
            contrast: 72.15312675547422,
            lc60: 77.5,
            lc45: 56,
            lc30: 36.5,
            lc10: 19
        },
        "warning.1200": {
            contrast: 67.57252451671368,
            lc60: 84.5,
            lc45: 60,
            lc30: 39,
            lc10: 20
        },
        "warning.1300": {
            contrast: 62.64219867777627,
            lc60: 93.5,
            lc45: 65,
            lc30: 42,
            lc10: 21.5
        },
        "warning.1400": {
            contrast: 56.46137031246954,
            lc60: 100,
            lc45: 73.5,
            lc30: 46.5,
            lc10: 24
        },
        "warning.1500": {
            contrast: 53.9678841590183,
            lc60: 100,
            lc45: 78,
            lc30: 49.5,
            lc10: 25
        },
        "warning.1600": {
            contrast: 49.30026085731911,
            lc60: 100,
            lc45: 88.5,
            lc30: 56,
            lc10: 28.5
        },
        "warning.1700": {
            contrast: 44.06564746414072,
            lc60: 100,
            lc45: 100,
            lc30: 64.5,
            lc10: 32.5
        },
        "warning.1800": {
            contrast: 38.760401588583406,
            lc60: 100,
            lc45: 100,
            lc30: 75.5,
            lc10: 38
        },
        "warning.1900": {
            contrast: 33.30207604630397,
            lc60: 100,
            lc45: 100,
            lc30: 89.5,
            lc10: 45.5
        },
        "warning.2000": {
            contrast: 27.81371140580195,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "warning.2100": {
            contrast: 21.99894701683259,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70.5
        },
        "warning.2200": {
            contrast: 15.89495773644248,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95.5
        },
        "warning.2300": {
            contrast: 9.908037562505259,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    }
};
const $f8fd43f1ee3f8cd8$var$mint = {
    "mint.100": {
        "mint.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.600": {
            contrast: 9.480470919659547,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.700": {
            contrast: 13.728143049701533,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.800": {
            contrast: 18.6603994332892,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89.5
        },
        "mint.900": {
            contrast: 23.55135388448177,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79
        },
        "mint.1000": {
            contrast: 27.909479174916974,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72
        },
        "mint.1100": {
            contrast: 32.881832495712736,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 66
        },
        "mint.1200": {
            contrast: 37.631006101409845,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 61
        },
        "mint.1300": {
            contrast: 43.01190489727612,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 56.5
        },
        "mint.1400": {
            contrast: 48.12126610136416,
            lc60: 100,
            lc45: 96,
            lc30: 76,
            lc10: 52.5
        },
        "mint.1500": {
            contrast: 52.500126426363224,
            lc60: 100,
            lc45: 91,
            lc30: 72,
            lc10: 50
        },
        "mint.1600": {
            contrast: 55.458574806556285,
            lc60: 100,
            lc45: 88,
            lc30: 69.5,
            lc10: 48.5
        },
        "mint.1700": {
            contrast: 61.23230513200103,
            lc60: 98.5,
            lc45: 82.5,
            lc30: 65.5,
            lc10: 45.5
        },
        "mint.1800": {
            contrast: 67.2440162676256,
            lc60: 93,
            lc45: 78.5,
            lc30: 62,
            lc10: 43.5
        },
        "mint.1900": {
            contrast: 73.6735924939767,
            lc60: 88,
            lc45: 74,
            lc30: 58.5,
            lc10: 40.5
        },
        "mint.2000": {
            contrast: 79.20035863628493,
            lc60: 84,
            lc45: 70.5,
            lc30: 55.5,
            lc10: 39
        },
        "mint.2100": {
            contrast: 84.95957988643967,
            lc60: 80.5,
            lc45: 67.5,
            lc30: 53.5,
            lc10: 37
        },
        "mint.2200": {
            contrast: 90.46871497721347,
            lc60: 77,
            lc45: 65,
            lc30: 51.5,
            lc10: 36
        },
        "mint.2300": {
            contrast: 96.36179494230913,
            lc60: 74,
            lc45: 62.5,
            lc30: 49.5,
            lc10: 34
        },
        "mint.2400": {
            contrast: 102.34319828009501,
            lc60: 71.5,
            lc45: 60,
            lc30: 47.5,
            lc10: 33
        },
        "mint.2500": {
            contrast: 107.88473318309848,
            lc60: 69,
            lc45: 58,
            lc30: 46,
            lc10: 32
        }
    },
    "mint.200": {
        "mint.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.600": {
            contrast: 9.079668034096198,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.700": {
            contrast: 13.327340164138182,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.800": {
            contrast: 18.259596547725852,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88.5
        },
        "mint.900": {
            contrast: 23.15055099891842,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76.5
        },
        "mint.1000": {
            contrast: 27.508676289353616,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68.5
        },
        "mint.1100": {
            contrast: 32.48102961014938,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 62
        },
        "mint.1200": {
            contrast: 37.230203215846494,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 56.5
        },
        "mint.1300": {
            contrast: 42.61110201171277,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 52
        },
        "mint.1400": {
            contrast: 47.7204632158008,
            lc60: 100,
            lc45: 96,
            lc30: 74,
            lc10: 48
        },
        "mint.1500": {
            contrast: 52.09932354079987,
            lc60: 100,
            lc45: 91,
            lc30: 69.5,
            lc10: 45.5
        },
        "mint.1600": {
            contrast: 55.05777192099293,
            lc60: 100,
            lc45: 87,
            lc30: 67,
            lc10: 44
        },
        "mint.1700": {
            contrast: 60.83150224643767,
            lc60: 99,
            lc45: 81.5,
            lc30: 63,
            lc10: 41
        },
        "mint.1800": {
            contrast: 66.84321338206225,
            lc60: 92.5,
            lc45: 77,
            lc30: 59,
            lc10: 39
        },
        "mint.1900": {
            contrast: 73.27278960841335,
            lc60: 87,
            lc45: 72.5,
            lc30: 55.5,
            lc10: 36.5
        },
        "mint.2000": {
            contrast: 78.79955575072157,
            lc60: 83,
            lc45: 68.5,
            lc30: 53,
            lc10: 34.5
        },
        "mint.2100": {
            contrast: 84.55877700087633,
            lc60: 79.5,
            lc45: 65.5,
            lc30: 50.5,
            lc10: 33.5
        },
        "mint.2200": {
            contrast: 90.06791209165011,
            lc60: 76,
            lc45: 63,
            lc30: 48.5,
            lc10: 32
        },
        "mint.2300": {
            contrast: 95.96099205674578,
            lc60: 73,
            lc45: 60.5,
            lc30: 46.5,
            lc10: 30.5
        },
        "mint.2400": {
            contrast: 101.94239539453164,
            lc60: 70,
            lc45: 58,
            lc30: 45,
            lc10: 29.5
        },
        "mint.2500": {
            contrast: 107.48393029753511,
            lc60: 67.5,
            lc45: 56,
            lc30: 43,
            lc10: 28.5
        }
    },
    "mint.300": {
        "mint.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.600": {
            contrast: 7.7760683574008045,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.700": {
            contrast: 12.023740487442788,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.800": {
            contrast: 16.955996871030457,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 92
        },
        "mint.900": {
            contrast: 21.846951322223028,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77
        },
        "mint.1000": {
            contrast: 26.205076612658225,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "mint.1100": {
            contrast: 31.177429933453986,
            lc60: 100,
            lc45: 100,
            lc30: 97.5,
            lc10: 60
        },
        "mint.1200": {
            contrast: 35.9266035391511,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 54.5
        },
        "mint.1300": {
            contrast: 41.30750233501737,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 49.5
        },
        "mint.1400": {
            contrast: 46.416863539105414,
            lc60: 100,
            lc45: 97,
            lc30: 73.5,
            lc10: 45.5
        },
        "mint.1500": {
            contrast: 50.79572386410448,
            lc60: 100,
            lc45: 91.5,
            lc30: 69,
            lc10: 42.5
        },
        "mint.1600": {
            contrast: 53.754172244297536,
            lc60: 100,
            lc45: 87.5,
            lc30: 66.5,
            lc10: 41
        },
        "mint.1700": {
            contrast: 59.52790256974229,
            lc60: 100,
            lc45: 82,
            lc30: 61.5,
            lc10: 38
        },
        "mint.1800": {
            contrast: 65.53961370536685,
            lc60: 94,
            lc45: 76,
            lc30: 57.5,
            lc10: 36
        },
        "mint.1900": {
            contrast: 71.96918993171796,
            lc60: 87.5,
            lc45: 71.5,
            lc30: 54,
            lc10: 33.5
        },
        "mint.2000": {
            contrast: 77.49595607402618,
            lc60: 83,
            lc45: 68,
            lc30: 51,
            lc10: 31.5
        },
        "mint.2100": {
            contrast: 83.25517732418093,
            lc60: 79,
            lc45: 64.5,
            lc30: 48.5,
            lc10: 30.5
        },
        "mint.2200": {
            contrast: 88.76431241495473,
            lc60: 75.5,
            lc45: 62,
            lc30: 46.5,
            lc10: 29
        },
        "mint.2300": {
            contrast: 94.65739238005038,
            lc60: 72.5,
            lc45: 59,
            lc30: 44.5,
            lc10: 28
        },
        "mint.2400": {
            contrast: 100.63879571783627,
            lc60: 69.5,
            lc45: 57,
            lc30: 43,
            lc10: 27
        },
        "mint.2500": {
            contrast: 106.18033062083974,
            lc60: 67,
            lc45: 55,
            lc30: 41.5,
            lc10: 26
        }
    },
    "mint.400": {
        "mint.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.700": {
            contrast: 10.137711616240896,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.800": {
            contrast: 15.069967999828565,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 99
        },
        "mint.900": {
            contrast: 19.960922451021133,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80
        },
        "mint.1000": {
            contrast: 24.319047741456338,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "mint.1100": {
            contrast: 29.2914010622521,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "mint.1200": {
            contrast: 34.040574667949215,
            lc60: 100,
            lc45: 100,
            lc30: 90.5,
            lc10: 53.5
        },
        "mint.1300": {
            contrast: 39.42147346381548,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 48
        },
        "mint.1400": {
            contrast: 44.53083466790353,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 44
        },
        "mint.1500": {
            contrast: 48.90969499290259,
            lc60: 100,
            lc45: 93.5,
            lc30: 69,
            lc10: 41
        },
        "mint.1600": {
            contrast: 51.86814337309564,
            lc60: 100,
            lc45: 89.5,
            lc30: 66,
            lc10: 39
        },
        "mint.1700": {
            contrast: 57.641873698540394,
            lc60: 100,
            lc45: 83,
            lc30: 61.5,
            lc10: 36.5
        },
        "mint.1800": {
            contrast: 63.653584834164946,
            lc60: 96,
            lc45: 76.5,
            lc30: 56.5,
            lc10: 34
        },
        "mint.1900": {
            contrast: 70.08316106051605,
            lc60: 89,
            lc45: 72,
            lc30: 53,
            lc10: 31.5
        },
        "mint.2000": {
            contrast: 75.60992720282428,
            lc60: 84,
            lc45: 68,
            lc30: 50.5,
            lc10: 30
        },
        "mint.2100": {
            contrast: 81.36914845297903,
            lc60: 79.5,
            lc45: 64.5,
            lc30: 47.5,
            lc10: 28.5
        },
        "mint.2200": {
            contrast: 86.87828354375281,
            lc60: 76,
            lc45: 61.5,
            lc30: 45.5,
            lc10: 27.5
        },
        "mint.2300": {
            contrast: 92.7713635088485,
            lc60: 72.5,
            lc45: 58.5,
            lc30: 43.5,
            lc10: 26
        },
        "mint.2400": {
            contrast: 98.75276684663436,
            lc60: 69.5,
            lc45: 56,
            lc30: 42,
            lc10: 25
        },
        "mint.2500": {
            contrast: 104.29430174963782,
            lc60: 67,
            lc45: 54.5,
            lc30: 40.5,
            lc10: 24.5
        }
    },
    "mint.500": {
        "mint.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.800": {
            contrast: 12.12765648337992,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.900": {
            contrast: 17.01861093457249,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89.5
        },
        "mint.1000": {
            contrast: 21.376736225007694,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74.5
        },
        "mint.1100": {
            contrast: 26.34908954580345,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63
        },
        "mint.1200": {
            contrast: 31.098263151500564,
            lc60: 100,
            lc45: 100,
            lc30: 97,
            lc10: 55.5
        },
        "mint.1300": {
            contrast: 36.47916194736683,
            lc60: 100,
            lc45: 100,
            lc30: 85.5,
            lc10: 49
        },
        "mint.1400": {
            contrast: 41.58852315145488,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 44
        },
        "mint.1500": {
            contrast: 45.96738347645394,
            lc60: 100,
            lc45: 97.5,
            lc30: 71,
            lc10: 40.5
        },
        "mint.1600": {
            contrast: 48.925831856646994,
            lc60: 100,
            lc45: 93,
            lc30: 68,
            lc10: 38.5
        },
        "mint.1700": {
            contrast: 54.699562182091746,
            lc60: 100,
            lc45: 85.5,
            lc30: 62.5,
            lc10: 35.5
        },
        "mint.1800": {
            contrast: 60.711273317716305,
            lc60: 98.5,
            lc45: 79.5,
            lc30: 57,
            lc10: 33
        },
        "mint.1900": {
            contrast: 67.14084954406742,
            lc60: 91.5,
            lc45: 73,
            lc30: 53,
            lc10: 30.5
        },
        "mint.2000": {
            contrast: 72.66761568637564,
            lc60: 86,
            lc45: 68.5,
            lc30: 50,
            lc10: 29
        },
        "mint.2100": {
            contrast: 78.42683693653039,
            lc60: 81.5,
            lc45: 65,
            lc30: 47.5,
            lc10: 27
        },
        "mint.2200": {
            contrast: 83.93597202730419,
            lc60: 77.5,
            lc45: 62,
            lc30: 45.5,
            lc10: 26.5
        },
        "mint.2300": {
            contrast: 89.82905199239984,
            lc60: 73.5,
            lc45: 59.5,
            lc30: 43.5,
            lc10: 25
        },
        "mint.2400": {
            contrast: 95.81045533018572,
            lc60: 70,
            lc45: 56.5,
            lc30: 41,
            lc10: 24
        },
        "mint.2500": {
            contrast: 101.3519902331892,
            lc60: 68,
            lc45: 54.5,
            lc30: 40,
            lc10: 23.5
        }
    },
    "mint.600": {
        "mint.100": {
            contrast: 10.94708342402034,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.200": {
            contrast: 10.409581048946102,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.300": {
            contrast: 8.705598230195875,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.800": {
            contrast: 7.911065039365277,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.900": {
            contrast: 12.802019490557845,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1000": {
            contrast: 17.160144780993047,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89
        },
        "mint.1100": {
            contrast: 22.132498101788812,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72
        },
        "mint.1200": {
            contrast: 26.88167170748593,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61
        },
        "mint.1300": {
            contrast: 32.26257050335219,
            lc60: 100,
            lc45: 100,
            lc30: 94.5,
            lc10: 52.5
        },
        "mint.1400": {
            contrast: 37.371931707440226,
            lc60: 100,
            lc45: 100,
            lc30: 84,
            lc10: 46.5
        },
        "mint.1500": {
            contrast: 41.75079203243929,
            lc60: 100,
            lc45: 100,
            lc30: 75.5,
            lc10: 42.5
        },
        "mint.1600": {
            contrast: 44.70924041263235,
            lc60: 100,
            lc45: 100,
            lc30: 71.5,
            lc10: 40.5
        },
        "mint.1700": {
            contrast: 50.48297073807709,
            lc60: 100,
            lc45: 91,
            lc30: 65,
            lc10: 36.5
        },
        "mint.1800": {
            contrast: 56.49468187370166,
            lc60: 100,
            lc45: 83,
            lc30: 60,
            lc10: 33.5
        },
        "mint.1900": {
            contrast: 62.92425810005277,
            lc60: 96,
            lc45: 76.5,
            lc30: 55,
            lc10: 31
        },
        "mint.2000": {
            contrast: 68.45102424236099,
            lc60: 89.5,
            lc45: 71.5,
            lc30: 51.5,
            lc10: 29.5
        },
        "mint.2100": {
            contrast: 74.21024549251575,
            lc60: 84.5,
            lc45: 67.5,
            lc30: 48,
            lc10: 27
        },
        "mint.2200": {
            contrast: 79.71938058328954,
            lc60: 80,
            lc45: 63.5,
            lc30: 46,
            lc10: 26
        },
        "mint.2300": {
            contrast: 85.6124605483852,
            lc60: 76,
            lc45: 60.5,
            lc30: 44,
            lc10: 25.5
        },
        "mint.2400": {
            contrast: 91.59386388617106,
            lc60: 72,
            lc45: 58,
            lc30: 42,
            lc10: 24
        },
        "mint.2500": {
            contrast: 97.13539878917453,
            lc60: 69.5,
            lc45: 56,
            lc30: 40.5,
            lc10: 23
        }
    },
    "mint.700": {
        "mint.100": {
            contrast: 15.542188323314349,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79.5
        },
        "mint.200": {
            contrast: 15.004685948240107,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 99
        },
        "mint.300": {
            contrast: 13.300703129489886,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.400": {
            contrast: 10.926142507296307,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.500": {
            contrast: 7.370912928084773,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.900": {
            contrast: 8.732848355408564,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1000": {
            contrast: 13.090973645843768,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1100": {
            contrast: 18.06332696663953,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84.5
        },
        "mint.1200": {
            contrast: 22.812500572336646,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69.5
        },
        "mint.1300": {
            contrast: 28.19339936820291,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58
        },
        "mint.1400": {
            contrast: 33.30276057229095,
            lc60: 100,
            lc45: 100,
            lc30: 91,
            lc10: 50.5
        },
        "mint.1500": {
            contrast: 37.68162089729002,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 45.5
        },
        "mint.1600": {
            contrast: 40.64006927748307,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 42.5
        },
        "mint.1700": {
            contrast: 46.41379960292782,
            lc60: 100,
            lc45: 97.5,
            lc30: 69.5,
            lc10: 38.5
        },
        "mint.1800": {
            contrast: 52.42551073855238,
            lc60: 100,
            lc45: 88,
            lc30: 63,
            lc10: 35
        },
        "mint.1900": {
            contrast: 58.8550869649035,
            lc60: 100,
            lc45: 80.5,
            lc30: 57,
            lc10: 32
        },
        "mint.2000": {
            contrast: 64.38185310721173,
            lc60: 94.5,
            lc45: 74.5,
            lc30: 53.5,
            lc10: 30
        },
        "mint.2100": {
            contrast: 70.14107435736646,
            lc60: 88,
            lc45: 70,
            lc30: 49.5,
            lc10: 27.5
        },
        "mint.2200": {
            contrast: 75.65020944814025,
            lc60: 83,
            lc45: 66,
            lc30: 47,
            lc10: 26.5
        },
        "mint.2300": {
            contrast: 81.54328941323593,
            lc60: 78.5,
            lc45: 62,
            lc30: 45,
            lc10: 25.5
        },
        "mint.2400": {
            contrast: 87.52469275102179,
            lc60: 74.5,
            lc45: 59.5,
            lc30: 43,
            lc10: 24
        },
        "mint.2500": {
            contrast: 93.06622765402525,
            lc60: 71.5,
            lc45: 57,
            lc30: 41,
            lc10: 24
        }
    },
    "mint.800": {
        "mint.100": {
            contrast: 20.760048407004177,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 50
        },
        "mint.200": {
            contrast: 20.222546031929937,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "mint.300": {
            contrast: 18.518563213179714,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73
        },
        "mint.400": {
            contrast: 16.14400259098614,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 90
        },
        "mint.500": {
            contrast: 12.588773011774604,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.600": {
            contrast: 7.7099284586560834,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1000": {
            contrast: 8.312949554431304,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1100": {
            contrast: 13.285302875227067,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1200": {
            contrast: 18.034476480924184,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86
        },
        "mint.1300": {
            contrast: 23.41537527679045,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68.5
        },
        "mint.1400": {
            contrast: 28.52473648087848,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "mint.1500": {
            contrast: 32.90359680587755,
            lc60: 100,
            lc45: 100,
            lc30: 91.5,
            lc10: 49.5
        },
        "mint.1600": {
            contrast: 35.86204518607061,
            lc60: 100,
            lc45: 100,
            lc30: 85,
            lc10: 46
        },
        "mint.1700": {
            contrast: 41.635775511515355,
            lc60: 100,
            lc45: 100,
            lc30: 75.5,
            lc10: 41
        },
        "mint.1800": {
            contrast: 47.647486647139914,
            lc60: 100,
            lc45: 94.5,
            lc30: 67.5,
            lc10: 36.5
        },
        "mint.1900": {
            contrast: 54.07706287349102,
            lc60: 100,
            lc45: 86,
            lc30: 61,
            lc10: 33
        },
        "mint.2000": {
            contrast: 59.60382901579925,
            lc60: 100,
            lc45: 79,
            lc30: 56,
            lc10: 31
        },
        "mint.2100": {
            contrast: 65.363050265954,
            lc60: 93,
            lc45: 73.5,
            lc30: 52,
            lc10: 29
        },
        "mint.2200": {
            contrast: 70.87218535672778,
            lc60: 87.5,
            lc45: 69,
            lc30: 49.5,
            lc10: 27
        },
        "mint.2300": {
            contrast: 76.76526532182346,
            lc60: 82,
            lc45: 65,
            lc30: 46.5,
            lc10: 26
        },
        "mint.2400": {
            contrast: 82.74666865960933,
            lc60: 77.5,
            lc45: 62,
            lc30: 44.5,
            lc10: 25
        },
        "mint.2500": {
            contrast: 88.2882035626128,
            lc60: 74,
            lc45: 59,
            lc30: 43,
            lc10: 24
        }
    },
    "mint.900": {
        "mint.100": {
            contrast: 25.835158995897917,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 40.5
        },
        "mint.200": {
            contrast: 25.297656620823677,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 47.5
        },
        "mint.300": {
            contrast: 23.593673802073457,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "mint.400": {
            contrast: 21.219113179879884,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67
        },
        "mint.500": {
            contrast: 17.66388360066835,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84.5
        },
        "mint.600": {
            contrast: 12.785039047549827,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.700": {
            contrast: 8.24642890808001,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1100": {
            contrast: 8.501297848886177,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1200": {
            contrast: 13.250471454583293,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1300": {
            contrast: 18.631370250449557,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81.5
        },
        "mint.1400": {
            contrast: 23.740731454537602,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65.5
        },
        "mint.1500": {
            contrast: 28.119591779536663,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "mint.1600": {
            contrast: 31.07804015972972,
            lc60: 100,
            lc45: 100,
            lc30: 96.5,
            lc10: 52
        },
        "mint.1700": {
            contrast: 36.85177048517447,
            lc60: 100,
            lc45: 100,
            lc30: 83.5,
            lc10: 45
        },
        "mint.1800": {
            contrast: 42.863481620799035,
            lc60: 100,
            lc45: 100,
            lc30: 73.5,
            lc10: 39.5
        },
        "mint.1900": {
            contrast: 49.29305784715014,
            lc60: 100,
            lc45: 92.5,
            lc30: 65,
            lc10: 35.5
        },
        "mint.2000": {
            contrast: 54.819823989458364,
            lc60: 100,
            lc45: 84.5,
            lc30: 60,
            lc10: 32.5
        },
        "mint.2100": {
            contrast: 60.579045239613116,
            lc60: 99.5,
            lc45: 78,
            lc30: 55,
            lc10: 30.5
        },
        "mint.2200": {
            contrast: 66.0881803303869,
            lc60: 92.5,
            lc45: 73,
            lc30: 51.5,
            lc10: 28.5
        },
        "mint.2300": {
            contrast: 71.98126029548257,
            lc60: 86.5,
            lc45: 68.5,
            lc30: 48.5,
            lc10: 27
        },
        "mint.2400": {
            contrast: 77.96266363326843,
            lc60: 81.5,
            lc45: 64.5,
            lc30: 46,
            lc10: 26
        },
        "mint.2500": {
            contrast: 83.5041985362719,
            lc60: 77.5,
            lc45: 62,
            lc30: 44.5,
            lc10: 25
        }
    },
    "mint.1000": {
        "mint.100": {
            contrast: 30.288960573689145,
            lc60: 100,
            lc45: 100,
            lc30: 89,
            lc10: 35.5
        },
        "mint.200": {
            contrast: 29.751458198614905,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 41
        },
        "mint.300": {
            contrast: 28.047475379864682,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 47.5
        },
        "mint.400": {
            contrast: 25.672914757671112,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "mint.500": {
            contrast: 22.117685178459574,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67
        },
        "mint.600": {
            contrast: 17.238840625341055,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87
        },
        "mint.700": {
            contrast: 12.700230485871236,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.800": {
            contrast: 7.527303372199682,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1200": {
            contrast: 8.955044318520242,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1300": {
            contrast: 14.33594311438651,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1400": {
            contrast: 19.44530431847455,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79
        },
        "mint.1500": {
            contrast: 23.824164643473615,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "mint.1600": {
            contrast: 26.78261302366667,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "mint.1700": {
            contrast: 32.556343349111415,
            lc60: 100,
            lc45: 100,
            lc30: 93.5,
            lc10: 50.5
        },
        "mint.1800": {
            contrast: 38.56805448473598,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 43.5
        },
        "mint.1900": {
            contrast: 44.99763071108709,
            lc60: 100,
            lc45: 100,
            lc30: 70.5,
            lc10: 38
        },
        "mint.2000": {
            contrast: 50.52439685339532,
            lc60: 100,
            lc45: 90.5,
            lc30: 64,
            lc10: 34
        },
        "mint.2100": {
            contrast: 56.28361810355006,
            lc60: 100,
            lc45: 83,
            lc30: 59,
            lc10: 31.5
        },
        "mint.2200": {
            contrast: 61.79275319432384,
            lc60: 97.5,
            lc45: 77,
            lc30: 55,
            lc10: 30
        },
        "mint.2300": {
            contrast: 67.68583315941953,
            lc60: 90.5,
            lc45: 71.5,
            lc30: 51.5,
            lc10: 28.5
        },
        "mint.2400": {
            contrast: 73.6672364972054,
            lc60: 85,
            lc45: 67.5,
            lc30: 48.5,
            lc10: 26.5
        },
        "mint.2500": {
            contrast: 79.20877140020886,
            lc60: 80.5,
            lc45: 64,
            lc30: 46.5,
            lc10: 26.5
        }
    },
    "mint.1100": {
        "mint.100": {
            contrast: 35.303685160653096,
            lc60: 100,
            lc45: 100,
            lc30: 64.5,
            lc10: 31
        },
        "mint.200": {
            contrast: 34.76618278557886,
            lc60: 100,
            lc45: 100,
            lc30: 73.5,
            lc10: 35
        },
        "mint.300": {
            contrast: 33.062199966828636,
            lc60: 100,
            lc45: 100,
            lc30: 84,
            lc10: 40
        },
        "mint.400": {
            contrast: 30.687639344635066,
            lc60: 100,
            lc45: 100,
            lc30: 96,
            lc10: 46
        },
        "mint.500": {
            contrast: 27.132409765423525,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54
        },
        "mint.600": {
            contrast: 22.25356521230501,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67
        },
        "mint.700": {
            contrast: 17.71495507283519,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85
        },
        "mint.800": {
            contrast: 12.542027959163635,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.900": {
            contrast: 7.494380865910956,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1300": {
            contrast: 9.402596537787913,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1400": {
            contrast: 14.511957741875955,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1500": {
            contrast: 18.890818066875024,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80
        },
        "mint.1600": {
            contrast: 21.84926644706808,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "mint.1700": {
            contrast: 27.622996772512824,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "mint.1800": {
            contrast: 33.63470790813739,
            lc60: 100,
            lc45: 100,
            lc30: 90.5,
            lc10: 48.5
        },
        "mint.1900": {
            contrast: 40.064284134488496,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 42
        },
        "mint.2000": {
            contrast: 45.59105027679672,
            lc60: 100,
            lc45: 98.5,
            lc30: 69.5,
            lc10: 37.5
        },
        "mint.2100": {
            contrast: 51.350271526951474,
            lc60: 100,
            lc45: 89,
            lc30: 63,
            lc10: 34.5
        },
        "mint.2200": {
            contrast: 56.85940661772526,
            lc60: 100,
            lc45: 82,
            lc30: 58.5,
            lc10: 31.5
        },
        "mint.2300": {
            contrast: 62.752486582820936,
            lc60: 96.5,
            lc45: 76,
            lc30: 54.5,
            lc10: 30
        },
        "mint.2400": {
            contrast: 68.7338899206068,
            lc60: 90,
            lc45: 71,
            lc30: 51,
            lc10: 28.5
        },
        "mint.2500": {
            contrast: 74.27542482361027,
            lc60: 85,
            lc45: 68,
            lc30: 48.5,
            lc10: 27.5
        }
    },
    "mint.1200": {
        "mint.100": {
            contrast: 40.03563213360987,
            lc60: 100,
            lc45: 100,
            lc30: 56,
            lc10: 28
        },
        "mint.200": {
            contrast: 39.49812975853563,
            lc60: 100,
            lc45: 100,
            lc30: 63.5,
            lc10: 31.5
        },
        "mint.300": {
            contrast: 37.79414693978541,
            lc60: 100,
            lc45: 100,
            lc30: 71.5,
            lc10: 35.5
        },
        "mint.400": {
            contrast: 35.419586317591836,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 40
        },
        "mint.500": {
            contrast: 31.8643567383803,
            lc60: 100,
            lc45: 100,
            lc30: 93.5,
            lc10: 46.5
        },
        "mint.600": {
            contrast: 26.985512185261783,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56
        },
        "mint.700": {
            contrast: 22.446902045791965,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "mint.800": {
            contrast: 17.27397493212041,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88
        },
        "mint.900": {
            contrast: 12.226327838867729,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1000": {
            contrast: 7.7853550139353676,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1400": {
            contrast: 9.771408664977043,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1500": {
            contrast: 14.150268989976109,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1600": {
            contrast: 17.108717370169167,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88
        },
        "mint.1700": {
            contrast: 22.882447695613912,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "mint.1800": {
            contrast: 28.894158831238475,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "mint.1900": {
            contrast: 35.32373505758958,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 47
        },
        "mint.2000": {
            contrast: 40.850501199897806,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 41.5
        },
        "mint.2100": {
            contrast: 46.60972245005256,
            lc60: 100,
            lc45: 97,
            lc30: 68.5,
            lc10: 37
        },
        "mint.2200": {
            contrast: 52.11885754082635,
            lc60: 100,
            lc45: 88.5,
            lc30: 63,
            lc10: 34.5
        },
        "mint.2300": {
            contrast: 58.01193750592202,
            lc60: 100,
            lc45: 81,
            lc30: 58,
            lc10: 32
        },
        "mint.2400": {
            contrast: 63.99334084370788,
            lc60: 94.5,
            lc45: 75.5,
            lc30: 54.5,
            lc10: 30
        },
        "mint.2500": {
            contrast: 69.53487574671135,
            lc60: 89,
            lc45: 71,
            lc30: 51.5,
            lc10: 29
        }
    },
    "mint.1300": {
        "mint.100": {
            contrast: 45.337429153235036,
            lc60: 100,
            lc45: 91.5,
            lc30: 49.5,
            lc10: 24.5
        },
        "mint.200": {
            contrast: 44.799926778160795,
            lc60: 100,
            lc45: 100,
            lc30: 55.5,
            lc10: 27.5
        },
        "mint.300": {
            contrast: 43.095943959410576,
            lc60: 100,
            lc45: 100,
            lc30: 62,
            lc10: 30.5
        },
        "mint.400": {
            contrast: 40.721383337217,
            lc60: 100,
            lc45: 100,
            lc30: 69,
            lc10: 34
        },
        "mint.500": {
            contrast: 37.166153758005464,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 39
        },
        "mint.600": {
            contrast: 32.28730920488695,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 45.5
        },
        "mint.700": {
            contrast: 27.748699065417128,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54
        },
        "mint.800": {
            contrast: 22.575771951745573,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66.5
        },
        "mint.900": {
            contrast: 17.528124858492895,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85.5
        },
        "mint.1000": {
            contrast: 13.087152033560532,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1100": {
            contrast: 8.075833414890916,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1500": {
            contrast: 8.749044442646568,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1600": {
            contrast: 11.707492822839624,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1700": {
            contrast: 17.48122314828437,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87.5
        },
        "mint.1800": {
            contrast: 23.492934283908937,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "mint.1900": {
            contrast: 29.922510510260043,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "mint.2000": {
            contrast: 35.449276652568265,
            lc60: 100,
            lc45: 100,
            lc30: 86,
            lc10: 47
        },
        "mint.2100": {
            contrast: 41.20849790272302,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 41
        },
        "mint.2200": {
            contrast: 46.717632993496814,
            lc60: 100,
            lc45: 96.5,
            lc30: 68.5,
            lc10: 38
        },
        "mint.2300": {
            contrast: 52.61071295859247,
            lc60: 100,
            lc45: 88,
            lc30: 63,
            lc10: 35.5
        },
        "mint.2400": {
            contrast: 58.592116296378336,
            lc60: 100,
            lc45: 81,
            lc30: 58.5,
            lc10: 32.5
        },
        "mint.2500": {
            contrast: 64.1336511993818,
            lc60: 95,
            lc45: 76,
            lc30: 55,
            lc10: 31.5
        }
    },
    "mint.1400": {
        "mint.100": {
            contrast: 50.31973199864909,
            lc60: 100,
            lc45: 71.5,
            lc30: 44.5,
            lc10: 22.5
        },
        "mint.200": {
            contrast: 49.78222962357486,
            lc60: 100,
            lc45: 79.5,
            lc30: 49.5,
            lc10: 25
        },
        "mint.300": {
            contrast: 48.07824680482463,
            lc60: 100,
            lc45: 88,
            lc30: 55,
            lc10: 27.5
        },
        "mint.400": {
            contrast: 45.70368618263105,
            lc60: 100,
            lc45: 97,
            lc30: 60.5,
            lc10: 30.5
        },
        "mint.500": {
            contrast: 42.14845660341952,
            lc60: 100,
            lc45: 100,
            lc30: 68,
            lc10: 34
        },
        "mint.600": {
            contrast: 37.269612050301006,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 39.5
        },
        "mint.700": {
            contrast: 32.73100191083118,
            lc60: 100,
            lc45: 100,
            lc30: 91,
            lc10: 45.5
        },
        "mint.800": {
            contrast: 27.558074797159627,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "mint.900": {
            contrast: 22.510427703906945,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "mint.1000": {
            contrast: 18.069454878974586,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83.5
        },
        "mint.1100": {
            contrast: 13.05813626030497,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1200": {
            contrast: 8.31984078384158,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1700": {
            contrast: 12.325899591766953,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1800": {
            contrast: 18.337610727391517,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83
        },
        "mint.1900": {
            contrast: 24.767186953742623,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "mint.2000": {
            contrast: 30.293953096050846,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 53.5
        },
        "mint.2100": {
            contrast: 36.053174346205594,
            lc60: 100,
            lc45: 100,
            lc30: 85,
            lc10: 46.5
        },
        "mint.2200": {
            contrast: 41.56230943697939,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 42.5
        },
        "mint.2300": {
            contrast: 47.455389402075056,
            lc60: 100,
            lc45: 95,
            lc30: 69,
            lc10: 38.5
        },
        "mint.2400": {
            contrast: 53.43679273986092,
            lc60: 100,
            lc45: 87,
            lc30: 63.5,
            lc10: 35.5
        },
        "mint.2500": {
            contrast: 58.97832764286439,
            lc60: 100,
            lc45: 81.5,
            lc30: 60,
            lc10: 33.5
        }
    },
    "mint.1500": {
        "mint.100": {
            contrast: 54.55349301201987,
            lc60: 100,
            lc45: 64.5,
            lc30: 41,
            lc10: 20.5
        },
        "mint.200": {
            contrast: 54.015990636945624,
            lc60: 100,
            lc45: 71,
            lc30: 45.5,
            lc10: 23
        },
        "mint.300": {
            contrast: 52.312007818195404,
            lc60: 100,
            lc45: 78.5,
            lc30: 50,
            lc10: 25
        },
        "mint.400": {
            contrast: 49.93744719600183,
            lc60: 100,
            lc45: 86,
            lc30: 55,
            lc10: 27.5
        },
        "mint.500": {
            contrast: 46.382217616790285,
            lc60: 100,
            lc45: 96,
            lc30: 61.5,
            lc10: 30.5
        },
        "mint.600": {
            contrast: 41.50337306367177,
            lc60: 100,
            lc45: 100,
            lc30: 70,
            lc10: 35
        },
        "mint.700": {
            contrast: 36.96476292420195,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 40
        },
        "mint.800": {
            contrast: 31.791835810530394,
            lc60: 100,
            lc45: 100,
            lc30: 94,
            lc10: 47
        },
        "mint.900": {
            contrast: 26.744188717277716,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "mint.1000": {
            contrast: 22.303215892345353,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "mint.1100": {
            contrast: 17.291897273675737,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87
        },
        "mint.1200": {
            contrast: 12.55360179721235,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1700": {
            contrast: 7.888801080521635,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1800": {
            contrast: 13.900512216146199,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1900": {
            contrast: 20.330088442497303,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75.5
        },
        "mint.2000": {
            contrast: 25.85685458480553,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61
        },
        "mint.2100": {
            contrast: 31.616075834960277,
            lc60: 100,
            lc45: 100,
            lc30: 95.5,
            lc10: 52.5
        },
        "mint.2200": {
            contrast: 37.12521092573407,
            lc60: 100,
            lc45: 100,
            lc30: 83,
            lc10: 45.5
        },
        "mint.2300": {
            contrast: 43.01829089082973,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 41.5
        },
        "mint.2400": {
            contrast: 48.999694228615596,
            lc60: 100,
            lc45: 93.5,
            lc30: 67.5,
            lc10: 37.5
        },
        "mint.2500": {
            contrast: 54.54122913161906,
            lc60: 100,
            lc45: 85.5,
            lc30: 63,
            lc10: 35
        }
    },
    "mint.1600": {
        "mint.100": {
            contrast: 57.39648027702011,
            lc60: 100,
            lc45: 61.5,
            lc30: 39.5,
            lc10: 20
        },
        "mint.200": {
            contrast: 56.85897790194587,
            lc60: 100,
            lc45: 67,
            lc30: 43,
            lc10: 22
        },
        "mint.300": {
            contrast: 55.154995083195644,
            lc60: 100,
            lc45: 73.5,
            lc30: 47.5,
            lc10: 24
        },
        "mint.400": {
            contrast: 52.780434461002066,
            lc60: 100,
            lc45: 80,
            lc30: 52,
            lc10: 26.5
        },
        "mint.500": {
            contrast: 49.22520488179054,
            lc60: 100,
            lc45: 89,
            lc30: 57.5,
            lc10: 29.5
        },
        "mint.600": {
            contrast: 44.34636032867202,
            lc60: 100,
            lc45: 100,
            lc30: 65.5,
            lc10: 33
        },
        "mint.700": {
            contrast: 39.8077501892022,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 37.5
        },
        "mint.800": {
            contrast: 34.63482307553065,
            lc60: 100,
            lc45: 100,
            lc30: 86,
            lc10: 44
        },
        "mint.900": {
            contrast: 29.587175982277962,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 52
        },
        "mint.1000": {
            contrast: 25.1462031573456,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61
        },
        "mint.1100": {
            contrast: 20.134884538675987,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76.5
        },
        "mint.1200": {
            contrast: 15.396589062212595,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98.5
        },
        "mint.1300": {
            contrast: 10.07778139388712,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1800": {
            contrast: 10.893545085204604,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1900": {
            contrast: 17.32312131155571,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89
        },
        "mint.2000": {
            contrast: 22.849887453863936,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69.5
        },
        "mint.2100": {
            contrast: 28.609108704018688,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "mint.2200": {
            contrast: 34.11824379479248,
            lc60: 100,
            lc45: 100,
            lc30: 90,
            lc10: 49.5
        },
        "mint.2300": {
            contrast: 40.01132375988814,
            lc60: 100,
            lc45: 100,
            lc30: 79,
            lc10: 44
        },
        "mint.2400": {
            contrast: 45.992727097674006,
            lc60: 100,
            lc45: 98,
            lc30: 70.5,
            lc10: 40
        },
        "mint.2500": {
            contrast: 51.534262000677465,
            lc60: 100,
            lc45: 90.5,
            lc30: 65.5,
            lc10: 38
        }
    },
    "mint.1700": {
        "mint.100": {
            contrast: 62.90748120982007,
            lc60: 81.5,
            lc45: 55.5,
            lc30: 35.5,
            lc10: 18.5
        },
        "mint.200": {
            contrast: 62.36997883474583,
            lc60: 89,
            lc45: 60.5,
            lc30: 39,
            lc10: 20
        },
        "mint.300": {
            contrast: 60.6659960159956,
            lc60: 97,
            lc45: 66,
            lc30: 42.5,
            lc10: 22
        },
        "mint.400": {
            contrast: 58.291435393802026,
            lc60: 100,
            lc45: 72,
            lc30: 46,
            lc10: 24
        },
        "mint.500": {
            contrast: 54.7362058145905,
            lc60: 100,
            lc45: 79,
            lc30: 51,
            lc10: 26
        },
        "mint.600": {
            contrast: 49.85736126147198,
            lc60: 100,
            lc45: 89,
            lc30: 57,
            lc10: 29.5
        },
        "mint.700": {
            contrast: 45.31875112200216,
            lc60: 100,
            lc45: 99.5,
            lc30: 64,
            lc10: 33
        },
        "mint.800": {
            contrast: 40.14582400833061,
            lc60: 100,
            lc45: 100,
            lc30: 73,
            lc10: 38
        },
        "mint.900": {
            contrast: 35.09817691507792,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 42.5
        },
        "mint.1000": {
            contrast: 30.657204090145555,
            lc60: 100,
            lc45: 100,
            lc30: 97.5,
            lc10: 49
        },
        "mint.1100": {
            contrast: 25.645885471475943,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59
        },
        "mint.1200": {
            contrast: 20.907589995012554,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72
        },
        "mint.1300": {
            contrast: 15.588782326687078,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95.5
        },
        "mint.1400": {
            contrast: 10.581844589888226,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1900": {
            contrast: 11.434815497741054,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2000": {
            contrast: 16.96158164004928,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88.5
        },
        "mint.2100": {
            contrast: 22.72080289020403,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70.5
        },
        "mint.2200": {
            contrast: 28.22993798097782,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58.5
        },
        "mint.2300": {
            contrast: 34.12301794607348,
            lc60: 100,
            lc45: 100,
            lc30: 89.5,
            lc10: 49.5
        },
        "mint.2400": {
            contrast: 40.104421283859345,
            lc60: 100,
            lc45: 100,
            lc30: 79,
            lc10: 44.5
        },
        "mint.2500": {
            contrast: 45.64595618686281,
            lc60: 100,
            lc45: 99,
            lc30: 71.5,
            lc10: 41
        }
    },
    "mint.1800": {
        "mint.100": {
            contrast: 68.59724499616141,
            lc60: 71,
            lc45: 50.5,
            lc30: 32.5,
            lc10: 17
        },
        "mint.200": {
            contrast: 68.05974262108718,
            lc60: 77,
            lc45: 55,
            lc30: 35.5,
            lc10: 18.5
        },
        "mint.300": {
            contrast: 66.35575980233695,
            lc60: 83.5,
            lc45: 59.5,
            lc30: 38.5,
            lc10: 20
        },
        "mint.400": {
            contrast: 63.98119918014336,
            lc60: 90,
            lc45: 64.5,
            lc30: 42,
            lc10: 21.5
        },
        "mint.500": {
            contrast: 60.425969600931836,
            lc60: 98.5,
            lc45: 70.5,
            lc30: 45.5,
            lc10: 23.5
        },
        "mint.600": {
            contrast: 55.54712504781332,
            lc60: 100,
            lc45: 77.5,
            lc30: 51,
            lc10: 26
        },
        "mint.700": {
            contrast: 51.00851490834351,
            lc60: 100,
            lc45: 86,
            lc30: 56.5,
            lc10: 29
        },
        "mint.800": {
            contrast: 45.835587794671945,
            lc60: 100,
            lc45: 97.5,
            lc30: 64,
            lc10: 33
        },
        "mint.900": {
            contrast: 40.78794070141926,
            lc60: 100,
            lc45: 100,
            lc30: 72.5,
            lc10: 36.5
        },
        "mint.1000": {
            contrast: 36.3469678764869,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 41.5
        },
        "mint.1100": {
            contrast: 31.335649257817284,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 48.5
        },
        "mint.1200": {
            contrast: 26.597353781353895,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "mint.1300": {
            contrast: 21.278546113028423,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "mint.1400": {
            contrast: 16.27160837622957,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93
        },
        "mint.1500": {
            contrast: 12.010869933583818,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1600": {
            contrast: 9.146850751137842,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2000": {
            contrast: 10.804558255759336,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2100": {
            contrast: 16.563779505914088,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91
        },
        "mint.2200": {
            contrast: 22.07291459668788,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72
        },
        "mint.2300": {
            contrast: 27.965994561783543,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58.5
        },
        "mint.2400": {
            contrast: 33.9473978995694,
            lc60: 100,
            lc45: 100,
            lc30: 89.5,
            lc10: 51.5
        },
        "mint.2500": {
            contrast: 39.48893280257287,
            lc60: 100,
            lc45: 100,
            lc30: 80.5,
            lc10: 45.5
        }
    },
    "mint.1900": {
        "mint.100": {
            contrast: 74.63279773458746,
            lc60: 64.5,
            lc45: 46,
            lc30: 30,
            lc10: 15.5
        },
        "mint.200": {
            contrast: 74.09529535951322,
            lc60: 69.5,
            lc45: 50,
            lc30: 32.5,
            lc10: 17
        },
        "mint.300": {
            contrast: 72.39131254076298,
            lc60: 75,
            lc45: 54,
            lc30: 35.5,
            lc10: 18
        },
        "mint.400": {
            contrast: 70.0167519185694,
            lc60: 80.5,
            lc45: 58,
            lc30: 38,
            lc10: 19.5
        },
        "mint.500": {
            contrast: 66.46152233935787,
            lc60: 87.5,
            lc45: 63,
            lc30: 41.5,
            lc10: 21.5
        },
        "mint.600": {
            contrast: 61.58267778623935,
            lc60: 96.5,
            lc45: 69,
            lc30: 45,
            lc10: 23.5
        },
        "mint.700": {
            contrast: 57.044067646769534,
            lc60: 100,
            lc45: 76,
            lc30: 49.5,
            lc10: 26
        },
        "mint.800": {
            contrast: 51.87114053309798,
            lc60: 100,
            lc45: 85,
            lc30: 55.5,
            lc10: 28
        },
        "mint.900": {
            contrast: 46.8234934398453,
            lc60: 100,
            lc45: 95.5,
            lc30: 62,
            lc10: 31.5
        },
        "mint.1000": {
            contrast: 42.382520614912934,
            lc60: 100,
            lc45: 100,
            lc30: 69.5,
            lc10: 35.5
        },
        "mint.1100": {
            contrast: 37.37120199624332,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 40.5
        },
        "mint.1200": {
            contrast: 32.63290651977992,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 47
        },
        "mint.1300": {
            contrast: 27.31409885145445,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "mint.1400": {
            contrast: 22.307161114655603,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "mint.1500": {
            contrast: 18.04642267200985,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83
        },
        "mint.1600": {
            contrast: 15.182403489563875,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98
        },
        "mint.1700": {
            contrast: 9.624373971937883,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2100": {
            contrast: 9.951735544010331,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2200": {
            contrast: 15.460870634784122,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 97.5
        },
        "mint.2300": {
            contrast: 21.353950599879784,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74
        },
        "mint.2400": {
            contrast: 27.335353937665648,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61
        },
        "mint.2500": {
            contrast: 32.87688884066911,
            lc60: 100,
            lc45: 100,
            lc30: 93,
            lc10: 54
        }
    },
    "mint.2000": {
        "mint.100": {
            contrast: 79.78320356621668,
            lc60: 59.5,
            lc45: 43,
            lc30: 28.5,
            lc10: 14.5
        },
        "mint.200": {
            contrast: 79.24570119114244,
            lc60: 64.5,
            lc45: 46.5,
            lc30: 31,
            lc10: 15.5
        },
        "mint.300": {
            contrast: 77.54171837239221,
            lc60: 69,
            lc45: 50,
            lc30: 32.5,
            lc10: 17
        },
        "mint.400": {
            contrast: 75.16715775019864,
            lc60: 74,
            lc45: 53.5,
            lc30: 35,
            lc10: 18
        },
        "mint.500": {
            contrast: 71.6119281709871,
            lc60: 80,
            lc45: 58,
            lc30: 38,
            lc10: 19.5
        },
        "mint.600": {
            contrast: 66.73308361786859,
            lc60: 87.5,
            lc45: 63,
            lc30: 41.5,
            lc10: 21.5
        },
        "mint.700": {
            contrast: 62.19447347839877,
            lc60: 95,
            lc45: 69,
            lc30: 45.5,
            lc10: 23.5
        },
        "mint.800": {
            contrast: 57.021546364727214,
            lc60: 100,
            lc45: 76.5,
            lc30: 50,
            lc10: 26
        },
        "mint.900": {
            contrast: 51.97389927147454,
            lc60: 100,
            lc45: 84.5,
            lc30: 55.5,
            lc10: 28.5
        },
        "mint.1000": {
            contrast: 47.53292644654218,
            lc60: 100,
            lc45: 93.5,
            lc30: 61.5,
            lc10: 31.5
        },
        "mint.1100": {
            contrast: 42.52160782787256,
            lc60: 100,
            lc45: 100,
            lc30: 68.5,
            lc10: 35.5
        },
        "mint.1200": {
            contrast: 37.783312351409165,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 40.5
        },
        "mint.1300": {
            contrast: 32.46450468308369,
            lc60: 100,
            lc45: 100,
            lc30: 91.5,
            lc10: 46
        },
        "mint.1400": {
            contrast: 27.45756694628484,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "mint.1500": {
            contrast: 23.196828503639093,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65.5
        },
        "mint.1600": {
            contrast: 20.332809321193114,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75
        },
        "mint.1700": {
            contrast: 14.774779803567123,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1800": {
            contrast: 9.028356768949337,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2200": {
            contrast: 9.756518685674374,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2300": {
            contrast: 15.649598650770036,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 97
        },
        "mint.2400": {
            contrast: 21.631001988555905,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "mint.2500": {
            contrast: 27.17253689155936,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        }
    },
    "mint.2100": {
        "mint.100": {
            contrast: 85.1159964267422,
            lc60: 55.5,
            lc45: 40.5,
            lc30: 26.5,
            lc10: 14
        },
        "mint.200": {
            contrast: 84.57849405166796,
            lc60: 59.5,
            lc45: 43.5,
            lc30: 28.5,
            lc10: 14.5
        },
        "mint.300": {
            contrast: 82.87451123291773,
            lc60: 63.5,
            lc45: 46.5,
            lc30: 30.5,
            lc10: 15.5
        },
        "mint.400": {
            contrast: 80.49995061072414,
            lc60: 68,
            lc45: 49,
            lc30: 32.5,
            lc10: 17
        },
        "mint.500": {
            contrast: 76.94472103151261,
            lc60: 73,
            lc45: 53,
            lc30: 35,
            lc10: 18
        },
        "mint.600": {
            contrast: 72.0658764783941,
            lc60: 79.5,
            lc45: 57.5,
            lc30: 38,
            lc10: 20
        },
        "mint.700": {
            contrast: 67.52726633892429,
            lc60: 86.5,
            lc45: 62.5,
            lc30: 41,
            lc10: 21.5
        },
        "mint.800": {
            contrast: 62.35433922525273,
            lc60: 95,
            lc45: 69,
            lc30: 45.5,
            lc10: 23
        },
        "mint.900": {
            contrast: 57.30669213200006,
            lc60: 100,
            lc45: 75.5,
            lc30: 49.5,
            lc10: 25.5
        },
        "mint.1000": {
            contrast: 52.865719307067685,
            lc60: 100,
            lc45: 83,
            lc30: 54.5,
            lc10: 28
        },
        "mint.1100": {
            contrast: 47.854400688398066,
            lc60: 100,
            lc45: 93,
            lc30: 60.5,
            lc10: 31
        },
        "mint.1200": {
            contrast: 43.11610521193468,
            lc60: 100,
            lc45: 100,
            lc30: 67.5,
            lc10: 34.5
        },
        "mint.1300": {
            contrast: 37.797297543609204,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 40
        },
        "mint.1400": {
            contrast: 32.79035980681035,
            lc60: 100,
            lc45: 100,
            lc30: 91,
            lc10: 45
        },
        "mint.1500": {
            contrast: 28.529621364164605,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 52.5
        },
        "mint.1600": {
            contrast: 25.665602181718626,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59
        },
        "mint.1700": {
            contrast: 20.107572664092636,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75.5
        },
        "mint.1800": {
            contrast: 14.361149629474848,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1900": {
            contrast: 8.25715722285998,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2300": {
            contrast: 9.686271093108601,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2400": {
            contrast: 15.667674430894468,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 97
        },
        "mint.2500": {
            contrast: 21.20920933389793,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76
        }
    },
    "mint.2200": {
        "mint.100": {
            contrast: 90.18672274297299,
            lc60: 52,
            lc45: 38,
            lc30: 25,
            lc10: 13
        },
        "mint.200": {
            contrast: 89.64922036789875,
            lc60: 55.5,
            lc45: 41,
            lc30: 27,
            lc10: 14
        },
        "mint.300": {
            contrast: 87.94523754914852,
            lc60: 59.5,
            lc45: 43.5,
            lc30: 28.5,
            lc10: 15
        },
        "mint.400": {
            contrast: 85.57067692695493,
            lc60: 63,
            lc45: 46,
            lc30: 30.5,
            lc10: 15.5
        },
        "mint.500": {
            contrast: 82.0154473477434,
            lc60: 67,
            lc45: 49,
            lc30: 32.5,
            lc10: 17
        },
        "mint.600": {
            contrast: 77.13660279462489,
            lc60: 73.5,
            lc45: 53,
            lc30: 35,
            lc10: 18.5
        },
        "mint.700": {
            contrast: 72.59799265515508,
            lc60: 79,
            lc45: 57.5,
            lc30: 38,
            lc10: 19.5
        },
        "mint.800": {
            contrast: 67.42506554148352,
            lc60: 86.5,
            lc45: 62.5,
            lc30: 41,
            lc10: 21.5
        },
        "mint.900": {
            contrast: 62.37741844823083,
            lc60: 95.5,
            lc45: 68.5,
            lc30: 44.5,
            lc10: 23.5
        },
        "mint.1000": {
            contrast: 57.93644562329847,
            lc60: 100,
            lc45: 74.5,
            lc30: 49,
            lc10: 25
        },
        "mint.1100": {
            contrast: 52.925127004628855,
            lc60: 100,
            lc45: 83,
            lc30: 53.5,
            lc10: 28
        },
        "mint.1200": {
            contrast: 48.18683152816546,
            lc60: 100,
            lc45: 92,
            lc30: 59.5,
            lc10: 30
        },
        "mint.1300": {
            contrast: 42.86802385983999,
            lc60: 100,
            lc45: 100,
            lc30: 67.5,
            lc10: 34.5
        },
        "mint.1400": {
            contrast: 37.86108612304114,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 38.5
        },
        "mint.1500": {
            contrast: 33.60034768039539,
            lc60: 100,
            lc45: 100,
            lc30: 87.5,
            lc10: 44
        },
        "mint.1600": {
            contrast: 30.736328497949412,
            lc60: 100,
            lc45: 100,
            lc30: 97,
            lc10: 49
        },
        "mint.1700": {
            contrast: 25.178298980323422,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "mint.1800": {
            contrast: 19.431875945705638,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77.5
        },
        "mint.1900": {
            contrast: 13.32788353909077,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2000": {
            contrast: 8.112745158537605,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2400": {
            contrast: 9.946168905087852,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2500": {
            contrast: 15.487703808091313,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 96
        }
    },
    "mint.2300": {
        "mint.100": {
            contrast: 95.57996718000533,
            lc60: 49,
            lc45: 36,
            lc30: 23.5,
            lc10: 12.5
        },
        "mint.200": {
            contrast: 95.04246480493109,
            lc60: 52.5,
            lc45: 38,
            lc30: 25.5,
            lc10: 13.5
        },
        "mint.300": {
            contrast: 93.33848198618085,
            lc60: 55.5,
            lc45: 40.5,
            lc30: 27,
            lc10: 14
        },
        "mint.400": {
            contrast: 90.96392136398728,
            lc60: 58.5,
            lc45: 43,
            lc30: 28.5,
            lc10: 15
        },
        "mint.500": {
            contrast: 87.40869178477575,
            lc60: 62.5,
            lc45: 45.5,
            lc30: 30,
            lc10: 16
        },
        "mint.600": {
            contrast: 82.52984723165723,
            lc60: 67.5,
            lc45: 49,
            lc30: 32.5,
            lc10: 17
        },
        "mint.700": {
            contrast: 77.99123709218742,
            lc60: 72,
            lc45: 53,
            lc30: 35,
            lc10: 18
        },
        "mint.800": {
            contrast: 72.81830997851586,
            lc60: 78.5,
            lc45: 57,
            lc30: 37.5,
            lc10: 20
        },
        "mint.900": {
            contrast: 67.77066288526316,
            lc60: 86,
            lc45: 62,
            lc30: 40.5,
            lc10: 21
        },
        "mint.1000": {
            contrast: 63.32969006033081,
            lc60: 93.5,
            lc45: 67,
            lc30: 44,
            lc10: 23
        },
        "mint.1100": {
            contrast: 58.3183714416612,
            lc60: 100,
            lc45: 73,
            lc30: 48,
            lc10: 24.5
        },
        "mint.1200": {
            contrast: 53.58007596519781,
            lc60: 100,
            lc45: 81.5,
            lc30: 52.5,
            lc10: 27
        },
        "mint.1300": {
            contrast: 48.26126829687233,
            lc60: 100,
            lc45: 91,
            lc30: 58.5,
            lc10: 30
        },
        "mint.1400": {
            contrast: 43.25433056007348,
            lc60: 100,
            lc45: 100,
            lc30: 65.5,
            lc10: 33
        },
        "mint.1500": {
            contrast: 38.99359211742773,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 37.5
        },
        "mint.1600": {
            contrast: 36.12957293498175,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 40.5
        },
        "mint.1700": {
            contrast: 30.571543417355763,
            lc60: 100,
            lc45: 100,
            lc30: 97,
            lc10: 48
        },
        "mint.1800": {
            contrast: 24.82512038273798,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "mint.1900": {
            contrast: 18.721127976123107,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81
        },
        "mint.2000": {
            contrast: 13.505989595569945,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2100": {
            contrast: 8.100409077088306,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2500": {
            contrast: 9.349960366753612,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "mint.2400": {
        "mint.100": {
            contrast: 101.02342835624228,
            lc60: 46,
            lc45: 34,
            lc30: 22.5,
            lc10: 12
        },
        "mint.200": {
            contrast: 100.48592598116804,
            lc60: 49,
            lc45: 36,
            lc30: 24,
            lc10: 12.5
        },
        "mint.300": {
            contrast: 98.78194316241779,
            lc60: 52,
            lc45: 38,
            lc30: 25.5,
            lc10: 13
        },
        "mint.400": {
            contrast: 96.4073825402242,
            lc60: 54.5,
            lc45: 40,
            lc30: 26.5,
            lc10: 14
        },
        "mint.500": {
            contrast: 92.85215296101268,
            lc60: 57.5,
            lc45: 42.5,
            lc30: 28.5,
            lc10: 15
        },
        "mint.600": {
            contrast: 87.97330840789415,
            lc60: 62,
            lc45: 45.5,
            lc30: 30,
            lc10: 15.5
        },
        "mint.700": {
            contrast: 83.43469826842434,
            lc60: 66.5,
            lc45: 48.5,
            lc30: 32,
            lc10: 17
        },
        "mint.800": {
            contrast: 78.26177115475278,
            lc60: 72,
            lc45: 52,
            lc30: 34.5,
            lc10: 18
        },
        "mint.900": {
            contrast: 73.2141240615001,
            lc60: 78,
            lc45: 56,
            lc30: 37,
            lc10: 19.5
        },
        "mint.1000": {
            contrast: 68.77315123656774,
            lc60: 83.5,
            lc45: 60.5,
            lc30: 40,
            lc10: 20.5
        },
        "mint.1100": {
            contrast: 63.761832617898115,
            lc60: 92.5,
            lc45: 65.5,
            lc30: 43,
            lc10: 22.5
        },
        "mint.1200": {
            contrast: 59.02353714143474,
            lc60: 100,
            lc45: 71.5,
            lc30: 46.5,
            lc10: 24
        },
        "mint.1300": {
            contrast: 53.70472947310926,
            lc60: 100,
            lc45: 80,
            lc30: 51,
            lc10: 26
        },
        "mint.1400": {
            contrast: 48.6977917363104,
            lc60: 100,
            lc45: 90.5,
            lc30: 56.5,
            lc10: 28.5
        },
        "mint.1500": {
            contrast: 44.437053293664654,
            lc60: 100,
            lc45: 100,
            lc30: 63.5,
            lc10: 32
        },
        "mint.1600": {
            contrast: 41.573034111218675,
            lc60: 100,
            lc45: 100,
            lc30: 68.5,
            lc10: 34.5
        },
        "mint.1700": {
            contrast: 36.015004593592685,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 40
        },
        "mint.1800": {
            contrast: 30.2685815589749,
            lc60: 100,
            lc45: 100,
            lc30: 98.5,
            lc10: 48
        },
        "mint.1900": {
            contrast: 24.164589152360037,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61
        },
        "mint.2000": {
            contrast: 18.94945077180687,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78
        },
        "mint.2100": {
            contrast: 13.54387025332523,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2200": {
            contrast: 8.398793595681086,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "mint.2500": {
        "mint.100": {
            contrast: 106.04067321268862,
            lc60: 44,
            lc45: 32.5,
            lc30: 21.5,
            lc10: 11.5
        },
        "mint.200": {
            contrast: 105.50317083761438,
            lc60: 46.5,
            lc45: 34.5,
            lc30: 22.5,
            lc10: 12
        },
        "mint.300": {
            contrast: 103.79918801886414,
            lc60: 49,
            lc45: 36,
            lc30: 24,
            lc10: 12.5
        },
        "mint.400": {
            contrast: 101.42462739667056,
            lc60: 51.5,
            lc45: 37.5,
            lc30: 25,
            lc10: 13.5
        },
        "mint.500": {
            contrast: 97.86939781745902,
            lc60: 54,
            lc45: 40,
            lc30: 26.5,
            lc10: 14
        },
        "mint.600": {
            contrast: 92.9905532643405,
            lc60: 58,
            lc45: 42.5,
            lc30: 28,
            lc10: 15
        },
        "mint.700": {
            contrast: 88.45194312487068,
            lc60: 61.5,
            lc45: 45.5,
            lc30: 30,
            lc10: 15.5
        },
        "mint.800": {
            contrast: 83.27901601119912,
            lc60: 66.5,
            lc45: 48,
            lc30: 32,
            lc10: 17
        },
        "mint.900": {
            contrast: 78.23136891794645,
            lc60: 71,
            lc45: 52,
            lc30: 34,
            lc10: 18
        },
        "mint.1000": {
            contrast: 73.79039609301408,
            lc60: 76.5,
            lc45: 55.5,
            lc30: 36.5,
            lc10: 18.5
        },
        "mint.1100": {
            contrast: 68.77907747434446,
            lc60: 83,
            lc45: 59.5,
            lc30: 39,
            lc10: 20.5
        },
        "mint.1200": {
            contrast: 64.04078199788108,
            lc60: 92,
            lc45: 64.5,
            lc30: 42,
            lc10: 21.5
        },
        "mint.1300": {
            contrast: 58.72197432955561,
            lc60: 100,
            lc45: 71,
            lc30: 45.5,
            lc10: 23.5
        },
        "mint.1400": {
            contrast: 53.715036592756746,
            lc60: 100,
            lc45: 79,
            lc30: 49.5,
            lc10: 25.5
        },
        "mint.1500": {
            contrast: 49.454298150111,
            lc60: 100,
            lc45: 88.5,
            lc30: 55,
            lc10: 28.5
        },
        "mint.1600": {
            contrast: 46.59027896766502,
            lc60: 100,
            lc45: 94.5,
            lc30: 58.5,
            lc10: 29.5
        },
        "mint.1700": {
            contrast: 41.03224945003903,
            lc60: 100,
            lc45: 100,
            lc30: 69,
            lc10: 34.5
        },
        "mint.1800": {
            contrast: 35.28582641542125,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 40
        },
        "mint.1900": {
            contrast: 29.18183400880638,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 49
        },
        "mint.2000": {
            contrast: 23.966695628253213,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61
        },
        "mint.2100": {
            contrast: 18.561115109771578,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81
        },
        "mint.2200": {
            contrast: 13.416038452127433,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2300": {
            contrast: 7.938506181199497,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    }
};
const $f8fd43f1ee3f8cd8$var$negative = {
    "negative.100": {
        "negative.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.600": {
            contrast: 8.858041284614874,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.700": {
            contrast: 12.791498070046686,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.800": {
            contrast: 17.221272923749474,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93.5
        },
        "negative.900": {
            contrast: 21.509851438930742,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83.5
        },
        "negative.1000": {
            contrast: 25.56157036127881,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76
        },
        "negative.1100": {
            contrast: 29.800614311126942,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "negative.1200": {
            contrast: 35.20346068108589,
            lc60: 100,
            lc45: 100,
            lc30: 91,
            lc10: 63.5
        },
        "negative.1300": {
            contrast: 38.5347780100951,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 60.5
        },
        "negative.1400": {
            contrast: 42.60954031789987,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 57
        },
        "negative.1500": {
            contrast: 47.24732667747278,
            lc60: 100,
            lc45: 97,
            lc30: 77,
            lc10: 53.5
        },
        "negative.1600": {
            contrast: 52.36263284181245,
            lc60: 100,
            lc45: 91,
            lc30: 72,
            lc10: 50
        },
        "negative.1700": {
            contrast: 57.63719359842978,
            lc60: 100,
            lc45: 86,
            lc30: 68,
            lc10: 47
        },
        "negative.1800": {
            contrast: 63.12093302842009,
            lc60: 97,
            lc45: 81.5,
            lc30: 64.5,
            lc10: 44.5
        },
        "negative.1900": {
            contrast: 69.016780808529,
            lc60: 91.5,
            lc45: 77,
            lc30: 61,
            lc10: 42.5
        },
        "negative.2000": {
            contrast: 74.9150630272176,
            lc60: 87,
            lc45: 73.5,
            lc30: 58,
            lc10: 40
        },
        "negative.2100": {
            contrast: 81.4063209386647,
            lc60: 82.5,
            lc45: 69.5,
            lc30: 55,
            lc10: 38
        },
        "negative.2200": {
            contrast: 87.81825720622926,
            lc60: 78.5,
            lc45: 66,
            lc30: 52.5,
            lc10: 36.5
        },
        "negative.2300": {
            contrast: 94.06194075214171,
            lc60: 75.5,
            lc45: 63.5,
            lc30: 50,
            lc10: 35
        },
        "negative.2400": {
            contrast: 101.21944681618791,
            lc60: 72,
            lc45: 60.5,
            lc30: 47.5,
            lc10: 33.5
        },
        "negative.2500": {
            contrast: 107.88473318309848,
            lc60: 69,
            lc45: 58,
            lc30: 46,
            lc10: 32
        }
    },
    "negative.200": {
        "negative.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.600": {
            contrast: 8.329638774416665,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.700": {
            contrast: 12.263095559848477,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.800": {
            contrast: 16.692870413551265,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93.5
        },
        "negative.900": {
            contrast: 20.981448928732533,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81
        },
        "negative.1000": {
            contrast: 25.033167851080606,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72.5
        },
        "negative.1100": {
            contrast: 29.272211800928737,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "negative.1200": {
            contrast: 34.67505817088769,
            lc60: 100,
            lc45: 100,
            lc30: 91,
            lc10: 59
        },
        "negative.1300": {
            contrast: 38.00637549989689,
            lc60: 100,
            lc45: 100,
            lc30: 85.5,
            lc10: 56
        },
        "negative.1400": {
            contrast: 42.081137807701666,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 52.5
        },
        "negative.1500": {
            contrast: 46.718924167274565,
            lc60: 100,
            lc45: 97.5,
            lc30: 74.5,
            lc10: 49
        },
        "negative.1600": {
            contrast: 51.834230331614236,
            lc60: 100,
            lc45: 91,
            lc30: 70,
            lc10: 46.5
        },
        "negative.1700": {
            contrast: 57.10879108823157,
            lc60: 100,
            lc45: 85.5,
            lc30: 66,
            lc10: 44
        },
        "negative.1800": {
            contrast: 62.592530518221864,
            lc60: 97,
            lc45: 80.5,
            lc30: 62.5,
            lc10: 41.5
        },
        "negative.1900": {
            contrast: 68.48837829833079,
            lc60: 91.5,
            lc45: 76,
            lc30: 59,
            lc10: 39
        },
        "negative.2000": {
            contrast: 74.3866605170194,
            lc60: 86.5,
            lc45: 72,
            lc30: 56,
            lc10: 37.5
        },
        "negative.2100": {
            contrast: 80.87791842846649,
            lc60: 82,
            lc45: 68.5,
            lc30: 53,
            lc10: 36
        },
        "negative.2200": {
            contrast: 87.28985469603106,
            lc60: 78,
            lc45: 65,
            lc30: 50.5,
            lc10: 34
        },
        "negative.2300": {
            contrast: 93.53353824194349,
            lc60: 75,
            lc45: 62.5,
            lc30: 48.5,
            lc10: 33
        },
        "negative.2400": {
            contrast: 100.69104430598968,
            lc60: 71.5,
            lc45: 59.5,
            lc30: 46.5,
            lc10: 31.5
        },
        "negative.2500": {
            contrast: 107.35633067290024,
            lc60: 68.5,
            lc45: 57,
            lc30: 44.5,
            lc10: 30
        }
    },
    "negative.300": {
        "negative.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.700": {
            contrast: 10.888541479345054,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.800": {
            contrast: 15.318316333047843,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98.5
        },
        "negative.900": {
            contrast: 19.60689484822911,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83
        },
        "negative.1000": {
            contrast: 23.658613770577183,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73
        },
        "negative.1100": {
            contrast: 27.897657720425308,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65
        },
        "negative.1200": {
            contrast: 33.30050409038426,
            lc60: 100,
            lc45: 100,
            lc30: 92.5,
            lc10: 57
        },
        "negative.1300": {
            contrast: 36.63182141939346,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 54
        },
        "negative.1400": {
            contrast: 40.70658372719823,
            lc60: 100,
            lc45: 100,
            lc30: 80.5,
            lc10: 50.5
        },
        "negative.1500": {
            contrast: 45.34437008677114,
            lc60: 100,
            lc45: 99,
            lc30: 75,
            lc10: 47.5
        },
        "negative.1600": {
            contrast: 50.45967625111082,
            lc60: 100,
            lc45: 92.5,
            lc30: 70,
            lc10: 44.5
        },
        "negative.1700": {
            contrast: 55.73423700772815,
            lc60: 100,
            lc45: 86.5,
            lc30: 66,
            lc10: 42.5
        },
        "negative.1800": {
            contrast: 61.21797643771845,
            lc60: 98.5,
            lc45: 81.5,
            lc30: 62,
            lc10: 40.5
        },
        "negative.1900": {
            contrast: 67.11382421782737,
            lc60: 92.5,
            lc45: 77,
            lc30: 59,
            lc10: 38.5
        },
        "negative.2000": {
            contrast: 73.01210643651596,
            lc60: 87.5,
            lc45: 72.5,
            lc30: 56,
            lc10: 37
        },
        "negative.2100": {
            contrast: 79.50336434796307,
            lc60: 83,
            lc45: 69,
            lc30: 53,
            lc10: 34.5
        },
        "negative.2200": {
            contrast: 85.91530061552763,
            lc60: 79,
            lc45: 65.5,
            lc30: 50.5,
            lc10: 33.5
        },
        "negative.2300": {
            contrast: 92.15898416144007,
            lc60: 75,
            lc45: 62.5,
            lc30: 48.5,
            lc10: 32
        },
        "negative.2400": {
            contrast: 99.31649022548625,
            lc60: 71.5,
            lc45: 59.5,
            lc30: 46.5,
            lc10: 31
        },
        "negative.2500": {
            contrast: 105.98177659239683,
            lc60: 69,
            lc45: 57,
            lc30: 44.5,
            lc10: 29.5
        }
    },
    "negative.400": {
        "negative.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.700": {
            contrast: 9.05705529045204,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.800": {
            contrast: 13.486830144154824,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.900": {
            contrast: 17.775408659336094,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88
        },
        "negative.1000": {
            contrast: 21.827127581684167,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75.5
        },
        "negative.1100": {
            contrast: 26.06617153153229,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "negative.1200": {
            contrast: 31.46901790149124,
            lc60: 100,
            lc45: 100,
            lc30: 96.5,
            lc10: 57.5
        },
        "negative.1300": {
            contrast: 34.800335230500444,
            lc60: 100,
            lc45: 100,
            lc30: 89,
            lc10: 53
        },
        "negative.1400": {
            contrast: 38.87509753830521,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 50
        },
        "negative.1500": {
            contrast: 43.512883897878126,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 47
        },
        "negative.1600": {
            contrast: 48.628190062217804,
            lc60: 100,
            lc45: 94.5,
            lc30: 71,
            lc10: 44.5
        },
        "negative.1700": {
            contrast: 53.90275081883513,
            lc60: 100,
            lc45: 88,
            lc30: 66.5,
            lc10: 41.5
        },
        "negative.1800": {
            contrast: 59.38649024882543,
            lc60: 100,
            lc45: 82.5,
            lc30: 63,
            lc10: 39.5
        },
        "negative.1900": {
            contrast: 65.28233802893436,
            lc60: 94,
            lc45: 78,
            lc30: 59,
            lc10: 37.5
        },
        "negative.2000": {
            contrast: 71.18062024762295,
            lc60: 89,
            lc45: 73.5,
            lc30: 56.5,
            lc10: 36
        },
        "negative.2100": {
            contrast: 77.67187815907006,
            lc60: 84,
            lc45: 69.5,
            lc30: 53,
            lc10: 34.5
        },
        "negative.2200": {
            contrast: 84.0838144266346,
            lc60: 79.5,
            lc45: 66,
            lc30: 50.5,
            lc10: 33
        },
        "negative.2300": {
            contrast: 90.32749797254705,
            lc60: 76,
            lc45: 63,
            lc30: 48.5,
            lc10: 31.5
        },
        "negative.2400": {
            contrast: 97.48500403659325,
            lc60: 72.5,
            lc45: 60,
            lc30: 46.5,
            lc10: 30
        },
        "negative.2500": {
            contrast: 104.15029040350383,
            lc60: 69.5,
            lc45: 57.5,
            lc30: 44.5,
            lc10: 29
        }
    },
    "negative.500": {
        "negative.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.800": {
            contrast: 10.789857796462519,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.900": {
            contrast: 15.078436311643785,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 99
        },
        "negative.1000": {
            contrast: 19.130155233991864,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82
        },
        "negative.1100": {
            contrast: 23.369199183839992,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "negative.1200": {
            contrast: 28.772045553798936,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59
        },
        "negative.1300": {
            contrast: 32.10336288280814,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 54.5
        },
        "negative.1400": {
            contrast: 36.17812519061292,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 51.5
        },
        "negative.1500": {
            contrast: 40.81591155018582,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 48
        },
        "negative.1600": {
            contrast: 45.931217714525495,
            lc60: 100,
            lc45: 98.5,
            lc30: 73.5,
            lc10: 45
        },
        "negative.1700": {
            contrast: 51.20577847114283,
            lc60: 100,
            lc45: 91.5,
            lc30: 69,
            lc10: 43
        },
        "negative.1800": {
            contrast: 56.68951790113312,
            lc60: 100,
            lc45: 85,
            lc30: 64.5,
            lc10: 40.5
        },
        "negative.1900": {
            contrast: 62.585365681242045,
            lc60: 97,
            lc45: 79.5,
            lc30: 61,
            lc10: 38.5
        },
        "negative.2000": {
            contrast: 68.48364789993063,
            lc60: 91.5,
            lc45: 75.5,
            lc30: 58,
            lc10: 36.5
        },
        "negative.2100": {
            contrast: 74.97490581137775,
            lc60: 86,
            lc45: 71.5,
            lc30: 54.5,
            lc10: 35
        },
        "negative.2200": {
            contrast: 81.3868420789423,
            lc60: 81.5,
            lc45: 67.5,
            lc30: 52,
            lc10: 33.5
        },
        "negative.2300": {
            contrast: 87.63052562485474,
            lc60: 77.5,
            lc45: 64.5,
            lc30: 49.5,
            lc10: 32.5
        },
        "negative.2400": {
            contrast: 94.78803168890092,
            lc60: 74,
            lc45: 61.5,
            lc30: 47.5,
            lc10: 31
        },
        "negative.2500": {
            contrast: 101.45331805581151,
            lc60: 71,
            lc45: 59,
            lc30: 45.5,
            lc10: 29.5
        }
    },
    "negative.600": {
        "negative.100": {
            contrast: 10.264210249605032,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.200": {
            contrast: 9.55707843590558,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.300": {
            contrast: 7.768227636409695,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.900": {
            contrast: 11.352603892090698,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1000": {
            contrast: 15.404322814438775,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98
        },
        "negative.1100": {
            contrast: 19.643366764286903,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80
        },
        "negative.1200": {
            contrast: 25.04621313424585,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65.5
        },
        "negative.1300": {
            contrast: 28.377530463255052,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59
        },
        "negative.1400": {
            contrast: 32.452292771059824,
            lc60: 100,
            lc45: 100,
            lc30: 94,
            lc10: 55
        },
        "negative.1500": {
            contrast: 37.09007913063273,
            lc60: 100,
            lc45: 100,
            lc30: 85.5,
            lc10: 51.5
        },
        "negative.1600": {
            contrast: 42.20538529497241,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 47.5
        },
        "negative.1700": {
            contrast: 47.479946051589735,
            lc60: 100,
            lc45: 96.5,
            lc30: 72.5,
            lc10: 44.5
        },
        "negative.1800": {
            contrast: 52.963685481580036,
            lc60: 100,
            lc45: 89.5,
            lc30: 68,
            lc10: 42.5
        },
        "negative.1900": {
            contrast: 58.85953326168896,
            lc60: 100,
            lc45: 83.5,
            lc30: 64,
            lc10: 40.5
        },
        "negative.2000": {
            contrast: 64.75781548037756,
            lc60: 94.5,
            lc45: 78.5,
            lc30: 60,
            lc10: 38.5
        },
        "negative.2100": {
            contrast: 71.24907339182465,
            lc60: 89,
            lc45: 74,
            lc30: 57,
            lc10: 36.5
        },
        "negative.2200": {
            contrast: 77.66100965938921,
            lc60: 84.5,
            lc45: 70,
            lc30: 54,
            lc10: 35
        },
        "negative.2300": {
            contrast: 83.90469320530165,
            lc60: 80,
            lc45: 66.5,
            lc30: 51.5,
            lc10: 33.5
        },
        "negative.2400": {
            contrast: 91.06219926934783,
            lc60: 76,
            lc45: 63.5,
            lc30: 49,
            lc10: 32
        },
        "negative.2500": {
            contrast: 97.72748563625841,
            lc60: 73,
            lc45: 60.5,
            lc30: 47,
            lc10: 30.5
        }
    },
    "negative.700": {
        "negative.100": {
            contrast: 14.537898269828217,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.200": {
            contrast: 13.830766456128766,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.300": {
            contrast: 12.041915656632879,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.400": {
            contrast: 9.744059489512878,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.900": {
            contrast: 7.5926120739504634,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1000": {
            contrast: 11.644330996298539,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1100": {
            contrast: 15.883374946146667,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95.5
        },
        "negative.1200": {
            contrast: 21.286221316105618,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74
        },
        "negative.1300": {
            contrast: 24.61753864511482,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65.5
        },
        "negative.1400": {
            contrast: 28.69230095291959,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "negative.1500": {
            contrast: 33.3300873124925,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 55.5
        },
        "negative.1600": {
            contrast: 38.445393476832166,
            lc60: 100,
            lc45: 100,
            lc30: 84,
            lc10: 51.5
        },
        "negative.1700": {
            contrast: 43.7199542334495,
            lc60: 100,
            lc45: 100,
            lc30: 77.5,
            lc10: 48.5
        },
        "negative.1800": {
            contrast: 49.20369366343979,
            lc60: 100,
            lc45: 94,
            lc30: 72,
            lc10: 45
        },
        "negative.1900": {
            contrast: 55.099541443548716,
            lc60: 100,
            lc45: 87,
            lc30: 67.5,
            lc10: 42.5
        },
        "negative.2000": {
            contrast: 60.997823662237316,
            lc60: 99,
            lc45: 82,
            lc30: 63.5,
            lc10: 41
        },
        "negative.2100": {
            contrast: 67.48908157368442,
            lc60: 92.5,
            lc45: 77,
            lc30: 59.5,
            lc10: 39
        },
        "negative.2200": {
            contrast: 73.90101784124899,
            lc60: 87.5,
            lc45: 73,
            lc30: 56.5,
            lc10: 36.5
        },
        "negative.2300": {
            contrast: 80.14470138716142,
            lc60: 83,
            lc45: 69.5,
            lc30: 54,
            lc10: 35
        },
        "negative.2400": {
            contrast: 87.30220745120761,
            lc60: 78.5,
            lc45: 65.5,
            lc30: 51,
            lc10: 33.5
        },
        "negative.2500": {
            contrast: 93.96749381811817,
            lc60: 75,
            lc45: 63,
            lc30: 49,
            lc10: 32
        }
    },
    "negative.800": {
        "negative.100": {
            contrast: 19.248957750358333,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "negative.200": {
            contrast: 18.54182593665888,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "negative.300": {
            contrast: 16.752975137162995,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84.5
        },
        "negative.400": {
            contrast: 14.455118970042994,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.500": {
            contrast: 11.1977214105761,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1000": {
            contrast: 7.364381520827498,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1100": {
            contrast: 11.603425470675626,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1200": {
            contrast: 17.006271840634575,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89
        },
        "negative.1300": {
            contrast: 20.33758916964378,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77.5
        },
        "negative.1400": {
            contrast: 24.41235147744855,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68.5
        },
        "negative.1500": {
            contrast: 29.050137837021456,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62
        },
        "negative.1600": {
            contrast: 34.16544400136113,
            lc60: 100,
            lc45: 100,
            lc30: 91,
            lc10: 57
        },
        "negative.1700": {
            contrast: 39.44000475797846,
            lc60: 100,
            lc45: 100,
            lc30: 83.5,
            lc10: 52.5
        },
        "negative.1800": {
            contrast: 44.923744187968765,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 49
        },
        "negative.1900": {
            contrast: 50.81959196807768,
            lc60: 100,
            lc45: 92.5,
            lc30: 71.5,
            lc10: 46
        },
        "negative.2000": {
            contrast: 56.717874186766274,
            lc60: 100,
            lc45: 86,
            lc30: 67,
            lc10: 44
        },
        "negative.2100": {
            contrast: 63.209132098213374,
            lc60: 96.5,
            lc45: 80.5,
            lc30: 63.5,
            lc10: 41.5
        },
        "negative.2200": {
            contrast: 69.62106836577794,
            lc60: 91,
            lc45: 76.5,
            lc30: 59.5,
            lc10: 39.5
        },
        "negative.2300": {
            contrast: 75.86475191169038,
            lc60: 86.5,
            lc45: 72.5,
            lc30: 56.5,
            lc10: 37.5
        },
        "negative.2400": {
            contrast: 83.02225797573655,
            lc60: 81.5,
            lc45: 68.5,
            lc30: 54,
            lc10: 36
        },
        "negative.2500": {
            contrast: 89.68754434264713,
            lc60: 78,
            lc45: 65.5,
            lc30: 51.5,
            lc10: 34.5
        }
    },
    "negative.900": {
        "negative.100": {
            contrast: 23.727475970548138,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 44
        },
        "negative.200": {
            contrast: 23.020344156848687,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53.5
        },
        "negative.300": {
            contrast: 21.2314933573528,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63.5
        },
        "negative.400": {
            contrast: 18.933637190232798,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76
        },
        "negative.500": {
            contrast: 15.676239630765904,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95.5
        },
        "negative.600": {
            contrast: 11.350257166162592,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1100": {
            contrast: 7.421981093700541,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1200": {
            contrast: 12.82482746365949,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1300": {
            contrast: 16.156144792668695,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93
        },
        "negative.1400": {
            contrast: 20.230907100473466,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80
        },
        "negative.1500": {
            contrast: 24.868693460046373,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69.5
        },
        "negative.1600": {
            contrast: 29.983999624386048,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63
        },
        "negative.1700": {
            contrast: 35.25856038100338,
            lc60: 100,
            lc45: 100,
            lc30: 90,
            lc10: 58
        },
        "negative.1800": {
            contrast: 40.74229981099368,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 53.5
        },
        "negative.1900": {
            contrast: 46.6381475911026,
            lc60: 100,
            lc45: 97.5,
            lc30: 76,
            lc10: 50
        },
        "negative.2000": {
            contrast: 52.536429809791194,
            lc60: 100,
            lc45: 91,
            lc30: 71,
            lc10: 47
        },
        "negative.2100": {
            contrast: 59.027687721238294,
            lc60: 100,
            lc45: 85,
            lc30: 66.5,
            lc10: 44.5
        },
        "negative.2200": {
            contrast: 65.43962398880286,
            lc60: 94.5,
            lc45: 80,
            lc30: 62.5,
            lc10: 42
        },
        "negative.2300": {
            contrast: 71.6833075347153,
            lc60: 89.5,
            lc45: 75.5,
            lc30: 59.5,
            lc10: 39.5
        },
        "negative.2400": {
            contrast: 78.84081359876149,
            lc60: 84.5,
            lc45: 71.5,
            lc30: 56.5,
            lc10: 37.5
        },
        "negative.2500": {
            contrast: 85.50609996567205,
            lc60: 80.5,
            lc45: 68,
            lc30: 53.5,
            lc10: 36
        }
    },
    "negative.1000": {
        "negative.100": {
            contrast: 27.89685591242272,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 38
        },
        "negative.200": {
            contrast: 27.18972409872327,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 45.5
        },
        "negative.300": {
            contrast: 25.400873299227385,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53
        },
        "negative.400": {
            contrast: 23.103017132107386,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62
        },
        "negative.500": {
            contrast: 19.845619572640494,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75
        },
        "negative.600": {
            contrast: 15.519637108037182,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 96.5
        },
        "negative.700": {
            contrast: 11.301542165206785,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1200": {
            contrast: 8.845172296312935,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1300": {
            contrast: 12.17648962532214,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1400": {
            contrast: 16.251251933126913,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 94.5
        },
        "negative.1500": {
            contrast: 20.88903829269982,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80.5
        },
        "negative.1600": {
            contrast: 26.00434445703949,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70.5
        },
        "negative.1700": {
            contrast: 31.27890521365682,
            lc60: 100,
            lc45: 100,
            lc30: 97,
            lc10: 64.5
        },
        "negative.1800": {
            contrast: 36.76264464364712,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 59
        },
        "negative.1900": {
            contrast: 42.658492423756044,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 54.5
        },
        "negative.2000": {
            contrast: 48.556774642444644,
            lc60: 100,
            lc45: 95,
            lc30: 76,
            lc10: 51.5
        },
        "negative.2100": {
            contrast: 55.048032553891744,
            lc60: 100,
            lc45: 88.5,
            lc30: 70.5,
            lc10: 48
        },
        "negative.2200": {
            contrast: 61.4599688214563,
            lc60: 98.5,
            lc45: 83.5,
            lc30: 66,
            lc10: 45.5
        },
        "negative.2300": {
            contrast: 67.70365236736875,
            lc60: 93,
            lc45: 79,
            lc30: 63,
            lc10: 43
        },
        "negative.2400": {
            contrast: 74.86115843141494,
            lc60: 87.5,
            lc45: 74.5,
            lc30: 59,
            lc10: 40.5
        },
        "negative.2500": {
            contrast: 81.5264447983255,
            lc60: 83.5,
            lc45: 70.5,
            lc30: 56.5,
            lc10: 38.5
        }
    },
    "negative.1100": {
        "negative.100": {
            contrast: 32.20405213364943,
            lc60: 100,
            lc45: 100,
            lc30: 75.5,
            lc10: 33.5
        },
        "negative.200": {
            contrast: 31.49692031994997,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 39.5
        },
        "negative.300": {
            contrast: 29.708069520454096,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 45.5
        },
        "negative.400": {
            contrast: 27.41021335333409,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 52
        },
        "negative.500": {
            contrast: 24.152815793867198,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61.5
        },
        "negative.600": {
            contrast: 19.826833329263888,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76
        },
        "negative.700": {
            contrast: 15.60873838643349,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 96.5
        },
        "negative.800": {
            contrast: 10.942349355511041,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1300": {
            contrast: 7.98637031236004,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1400": {
            contrast: 12.06113262016481,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1500": {
            contrast: 16.69891897973772,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93.5
        },
        "negative.1600": {
            contrast: 21.814225144077394,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80
        },
        "negative.1700": {
            contrast: 27.088785900694724,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "negative.1800": {
            contrast: 32.572525330685025,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 65.5
        },
        "negative.1900": {
            contrast: 38.46837311079394,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 60
        },
        "negative.2000": {
            contrast: 44.36665532948254,
            lc60: 100,
            lc45: 100,
            lc30: 80.5,
            lc10: 55.5
        },
        "negative.2100": {
            contrast: 50.85791324092964,
            lc60: 100,
            lc45: 93,
            lc30: 74.5,
            lc10: 51.5
        },
        "negative.2200": {
            contrast: 57.26984950849421,
            lc60: 100,
            lc45: 87,
            lc30: 70,
            lc10: 49
        },
        "negative.2300": {
            contrast: 63.51353305440664,
            lc60: 96.5,
            lc45: 82.5,
            lc30: 66,
            lc10: 46
        },
        "negative.2400": {
            contrast: 70.67103911845282,
            lc60: 91,
            lc45: 77.5,
            lc30: 62.5,
            lc10: 43.5
        },
        "negative.2500": {
            contrast: 77.3363254853634,
            lc60: 86,
            lc45: 73.5,
            lc30: 59,
            lc10: 41.5
        }
    },
    "negative.1200": {
        "negative.100": {
            contrast: 37.62346659507132,
            lc60: 100,
            lc45: 100,
            lc30: 59.5,
            lc10: 29
        },
        "negative.200": {
            contrast: 36.916334781371866,
            lc60: 100,
            lc45: 100,
            lc30: 69,
            lc10: 33.5
        },
        "negative.300": {
            contrast: 35.12748398187599,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 38
        },
        "negative.400": {
            contrast: 32.82962781475599,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 43
        },
        "negative.500": {
            contrast: 29.57223025528909,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 49.5
        },
        "negative.600": {
            contrast: 25.24624779068578,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59
        },
        "negative.700": {
            contrast: 21.028152847855385,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "negative.800": {
            contrast: 16.361763816932935,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91.5
        },
        "negative.900": {
            contrast: 11.912210675514318,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1000": {
            contrast: 7.759625428967292,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1500": {
            contrast: 11.323899104898977,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1600": {
            contrast: 16.439205269238652,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95
        },
        "negative.1700": {
            contrast: 21.713766025855982,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83.5
        },
        "negative.1800": {
            contrast: 27.197505455846283,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74.5
        },
        "negative.1900": {
            contrast: 33.093353235955206,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 68
        },
        "negative.2000": {
            contrast: 38.9916354546438,
            lc60: 100,
            lc45: 100,
            lc30: 87.5,
            lc10: 62.5
        },
        "negative.2100": {
            contrast: 45.482893366090906,
            lc60: 100,
            lc45: 99,
            lc30: 80.5,
            lc10: 58
        },
        "negative.2200": {
            contrast: 51.89482963365546,
            lc60: 100,
            lc45: 92.5,
            lc30: 75.5,
            lc10: 54
        },
        "negative.2300": {
            contrast: 58.13851317956791,
            lc60: 100,
            lc45: 87.5,
            lc30: 71,
            lc10: 51
        },
        "negative.2400": {
            contrast: 65.29601924361408,
            lc60: 95.5,
            lc45: 82,
            lc30: 66.5,
            lc10: 48
        },
        "negative.2500": {
            contrast: 71.96130561052466,
            lc60: 90.5,
            lc45: 77.5,
            lc30: 63.5,
            lc10: 45
        }
    },
    "negative.1300": {
        "negative.100": {
            contrast: 40.9303345658432,
            lc60: 100,
            lc45: 100,
            lc30: 55,
            lc10: 27
        },
        "negative.200": {
            contrast: 40.22320275214374,
            lc60: 100,
            lc45: 100,
            lc30: 62.5,
            lc10: 31
        },
        "negative.300": {
            contrast: 38.43435195264786,
            lc60: 100,
            lc45: 100,
            lc30: 70.5,
            lc10: 34.5
        },
        "negative.400": {
            contrast: 36.136495785527856,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 38.5
        },
        "negative.500": {
            contrast: 32.87909822606096,
            lc60: 100,
            lc45: 100,
            lc30: 89.5,
            lc10: 44
        },
        "negative.600": {
            contrast: 28.553115761457654,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51.5
        },
        "negative.700": {
            contrast: 24.33502081862726,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61
        },
        "negative.800": {
            contrast: 19.66863178770481,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76.5
        },
        "negative.900": {
            contrast: 15.21907864628619,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 99
        },
        "negative.1000": {
            contrast: 11.066493399739164,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1500": {
            contrast: 7.992427024942238,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1600": {
            contrast: 13.107733189281912,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1700": {
            contrast: 18.382293945899242,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88.5
        },
        "negative.1800": {
            contrast: 23.866033375889543,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76
        },
        "negative.1900": {
            contrast: 29.76188115599846,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "negative.2000": {
            contrast: 35.66016337468706,
            lc60: 100,
            lc45: 100,
            lc30: 90.5,
            lc10: 61
        },
        "negative.2100": {
            contrast: 42.15142128613416,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 55
        },
        "negative.2200": {
            contrast: 48.56335755369873,
            lc60: 100,
            lc45: 95.5,
            lc30: 75.5,
            lc10: 50.5
        },
        "negative.2300": {
            contrast: 54.80704109961116,
            lc60: 100,
            lc45: 88.5,
            lc30: 70.5,
            lc10: 47
        },
        "negative.2400": {
            contrast: 61.96454716365734,
            lc60: 98,
            lc45: 82.5,
            lc30: 65,
            lc10: 43.5
        },
        "negative.2500": {
            contrast: 68.62983353056792,
            lc60: 92,
            lc45: 77.5,
            lc30: 61,
            lc10: 40.5
        }
    },
    "negative.1400": {
        "negative.100": {
            contrast: 44.94300120731152,
            lc60: 100,
            lc45: 100,
            lc30: 50,
            lc10: 25
        },
        "negative.200": {
            contrast: 44.23586939361208,
            lc60: 100,
            lc45: 100,
            lc30: 56.5,
            lc10: 28
        },
        "negative.300": {
            contrast: 42.44701859411618,
            lc60: 100,
            lc45: 100,
            lc30: 62,
            lc10: 31
        },
        "negative.400": {
            contrast: 40.149162426996185,
            lc60: 100,
            lc45: 100,
            lc30: 69,
            lc10: 34
        },
        "negative.500": {
            contrast: 36.89176486752929,
            lc60: 100,
            lc45: 100,
            lc30: 77.5,
            lc10: 37.5
        },
        "negative.600": {
            contrast: 32.56578240292598,
            lc60: 100,
            lc45: 100,
            lc30: 90,
            lc10: 43
        },
        "negative.700": {
            contrast: 28.34768746009558,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 50
        },
        "negative.800": {
            contrast: 23.681298429173133,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "negative.900": {
            contrast: 19.231745287754517,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75.5
        },
        "negative.1000": {
            contrast: 15.07916004120749,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 99
        },
        "negative.1100": {
            contrast: 10.780239861234142,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1600": {
            contrast: 9.016467493016602,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1700": {
            contrast: 14.29102824963393,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1800": {
            contrast: 19.774767679624233,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82
        },
        "negative.1900": {
            contrast: 25.670615459733153,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68.5
        },
        "negative.2000": {
            contrast: 31.56889767842175,
            lc60: 100,
            lc45: 100,
            lc30: 96.5,
            lc10: 59.5
        },
        "negative.2100": {
            contrast: 38.06015558986885,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 52
        },
        "negative.2200": {
            contrast: 44.47209185743341,
            lc60: 100,
            lc45: 100,
            lc30: 76,
            lc10: 46.5
        },
        "negative.2300": {
            contrast: 50.71577540334585,
            lc60: 100,
            lc45: 92,
            lc30: 69.5,
            lc10: 42.5
        },
        "negative.2400": {
            contrast: 57.87328146739205,
            lc60: 100,
            lc45: 84,
            lc30: 63.5,
            lc10: 39
        },
        "negative.2500": {
            contrast: 64.53856783430261,
            lc60: 95,
            lc45: 78,
            lc30: 58.5,
            lc10: 36
        }
    },
    "negative.1500": {
        "negative.100": {
            contrast: 49.47086673863442,
            lc60: 100,
            lc45: 73.5,
            lc30: 45.5,
            lc10: 22.5
        },
        "negative.200": {
            contrast: 48.763734924934965,
            lc60: 100,
            lc45: 82,
            lc30: 50.5,
            lc10: 25
        },
        "negative.300": {
            contrast: 46.97488412543909,
            lc60: 100,
            lc45: 91,
            lc30: 55,
            lc10: 27.5
        },
        "negative.400": {
            contrast: 44.67702795831908,
            lc60: 100,
            lc45: 100,
            lc30: 59.5,
            lc10: 29.5
        },
        "negative.500": {
            contrast: 41.419630398852185,
            lc60: 100,
            lc45: 100,
            lc30: 66.5,
            lc10: 32.5
        },
        "negative.600": {
            contrast: 37.09364793424888,
            lc60: 100,
            lc45: 100,
            lc30: 75.5,
            lc10: 36
        },
        "negative.700": {
            contrast: 32.87555299141848,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 41
        },
        "negative.800": {
            contrast: 28.209163960496035,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 47
        },
        "negative.900": {
            contrast: 23.759610819077416,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "negative.1000": {
            contrast: 19.607025572530393,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "negative.1100": {
            contrast: 15.308105392557044,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95
        },
        "negative.1200": {
            contrast: 9.88747455932878,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1700": {
            contrast: 9.61432046979816,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1800": {
            contrast: 15.098059899788463,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 99
        },
        "negative.1900": {
            contrast: 20.993907679897383,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77
        },
        "negative.2000": {
            contrast: 26.89218989858598,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "negative.2100": {
            contrast: 33.383447810033076,
            lc60: 100,
            lc45: 100,
            lc30: 92.5,
            lc10: 54
        },
        "negative.2200": {
            contrast: 39.795384077597646,
            lc60: 100,
            lc45: 100,
            lc30: 80.5,
            lc10: 47
        },
        "negative.2300": {
            contrast: 46.039067623510086,
            lc60: 100,
            lc45: 98,
            lc30: 72.5,
            lc10: 42.5
        },
        "negative.2400": {
            contrast: 53.19657368755627,
            lc60: 100,
            lc45: 88.5,
            lc30: 65.5,
            lc10: 38.5
        },
        "negative.2500": {
            contrast: 59.86186005446683,
            lc60: 100,
            lc45: 81,
            lc30: 59.5,
            lc10: 34.5
        }
    },
    "negative.1600": {
        "negative.100": {
            contrast: 54.42103278265055,
            lc60: 100,
            lc45: 64.5,
            lc30: 41,
            lc10: 20.5
        },
        "negative.200": {
            contrast: 53.71390096895109,
            lc60: 100,
            lc45: 71,
            lc30: 45,
            lc10: 23
        },
        "negative.300": {
            contrast: 51.92505016945521,
            lc60: 100,
            lc45: 77,
            lc30: 48.5,
            lc10: 24.5
        },
        "negative.400": {
            contrast: 49.62719400233521,
            lc60: 100,
            lc45: 84.5,
            lc30: 52.5,
            lc10: 26
        },
        "negative.500": {
            contrast: 46.369796442868314,
            lc60: 100,
            lc45: 95,
            lc30: 57,
            lc10: 28
        },
        "negative.600": {
            contrast: 42.043813978265,
            lc60: 100,
            lc45: 100,
            lc30: 63.5,
            lc10: 30.5
        },
        "negative.700": {
            contrast: 37.82571903543461,
            lc60: 100,
            lc45: 100,
            lc30: 72,
            lc10: 34
        },
        "negative.800": {
            contrast: 33.15933000451216,
            lc60: 100,
            lc45: 100,
            lc30: 85,
            lc10: 38
        },
        "negative.900": {
            contrast: 28.709776863093534,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 43
        },
        "negative.1000": {
            contrast: 24.55719161654651,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 49
        },
        "negative.1100": {
            contrast: 20.258271436573164,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "negative.1200": {
            contrast: 14.837640603344898,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1300": {
            contrast: 11.52427425418139,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1400": {
            contrast: 7.4983649507893215,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1800": {
            contrast: 9.91700175954254,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1900": {
            contrast: 15.812849539651461,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95
        },
        "negative.2000": {
            contrast: 21.71113175834006,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "negative.2100": {
            contrast: 28.20238966978716,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "negative.2200": {
            contrast: 34.61432593735172,
            lc60: 100,
            lc45: 100,
            lc30: 89,
            lc10: 51.5
        },
        "negative.2300": {
            contrast: 40.858009483264155,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 45
        },
        "negative.2400": {
            contrast: 48.015515547310336,
            lc60: 100,
            lc45: 95.5,
            lc30: 69.5,
            lc10: 39
        },
        "negative.2500": {
            contrast: 54.68080191422091,
            lc60: 100,
            lc45: 86,
            lc30: 62.5,
            lc10: 35.5
        }
    },
    "negative.1700": {
        "negative.100": {
            contrast: 59.48159905210023,
            lc60: 100,
            lc45: 59,
            lc30: 38,
            lc10: 19
        },
        "negative.200": {
            contrast: 58.774467238400774,
            lc60: 100,
            lc45: 63.5,
            lc30: 41,
            lc10: 20.5
        },
        "negative.300": {
            contrast: 56.9856164389049,
            lc60: 100,
            lc45: 68,
            lc30: 43.5,
            lc10: 22
        },
        "negative.400": {
            contrast: 54.68776027178489,
            lc60: 100,
            lc45: 74,
            lc30: 46.5,
            lc10: 23.5
        },
        "negative.500": {
            contrast: 51.430362712318,
            lc60: 100,
            lc45: 80.5,
            lc30: 50,
            lc10: 25
        },
        "negative.600": {
            contrast: 47.10438024771469,
            lc60: 100,
            lc45: 92.5,
            lc30: 54.5,
            lc10: 27
        },
        "negative.700": {
            contrast: 42.88628530488429,
            lc60: 100,
            lc45: 100,
            lc30: 60,
            lc10: 29.5
        },
        "negative.800": {
            contrast: 38.21989627396184,
            lc60: 100,
            lc45: 100,
            lc30: 68,
            lc10: 32
        },
        "negative.900": {
            contrast: 33.770343132543225,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 35.5
        },
        "negative.1000": {
            contrast: 29.617757885996195,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 38.5
        },
        "negative.1100": {
            contrast: 25.31883770602285,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 44
        },
        "negative.1200": {
            contrast: 19.898206872794585,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53.5
        },
        "negative.1300": {
            contrast: 16.58484052363108,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81
        },
        "negative.1400": {
            contrast: 12.558931220239009,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1500": {
            contrast: 8.009584041842754,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1900": {
            contrast: 10.447467216225325,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.2000": {
            contrast: 16.345749434913923,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 92.5
        },
        "negative.2100": {
            contrast: 22.83700734636103,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "negative.2200": {
            contrast: 29.248943613925587,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "negative.2300": {
            contrast: 35.49262715983802,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 48.5
        },
        "negative.2400": {
            contrast: 42.650133223884204,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 42
        },
        "negative.2500": {
            contrast: 49.31541959079478,
            lc60: 100,
            lc45: 92.5,
            lc30: 67,
            lc10: 37
        }
    },
    "negative.1800": {
        "negative.100": {
            contrast: 64.70006687729004,
            lc60: 77,
            lc45: 53.5,
            lc30: 35,
            lc10: 17.5
        },
        "negative.200": {
            contrast: 63.992935063590586,
            lc60: 83.5,
            lc45: 58,
            lc30: 37,
            lc10: 19
        },
        "negative.300": {
            contrast: 62.2040842640947,
            lc60: 90.5,
            lc45: 61,
            lc30: 39.5,
            lc10: 20
        },
        "negative.400": {
            contrast: 59.9062280969747,
            lc60: 100,
            lc45: 65,
            lc30: 41.5,
            lc10: 21
        },
        "negative.500": {
            contrast: 56.64883053750781,
            lc60: 100,
            lc45: 70,
            lc30: 44,
            lc10: 22
        },
        "negative.600": {
            contrast: 52.322848072904506,
            lc60: 100,
            lc45: 78,
            lc30: 47.5,
            lc10: 24
        },
        "negative.700": {
            contrast: 48.10475313007411,
            lc60: 100,
            lc45: 88.5,
            lc30: 51.5,
            lc10: 25.5
        },
        "negative.800": {
            contrast: 43.438364099151656,
            lc60: 100,
            lc45: 100,
            lc30: 56.5,
            lc10: 27
        },
        "negative.900": {
            contrast: 38.98881095773304,
            lc60: 100,
            lc45: 100,
            lc30: 63.5,
            lc10: 29.5
        },
        "negative.1000": {
            contrast: 34.83622571118601,
            lc60: 100,
            lc45: 100,
            lc30: 72.5,
            lc10: 31.5
        },
        "negative.1100": {
            contrast: 30.53730553121266,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 34.5
        },
        "negative.1200": {
            contrast: 25.116674697984397,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 39
        },
        "negative.1300": {
            contrast: 21.80330834882089,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54
        },
        "negative.1400": {
            contrast: 17.777399045428822,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79.5
        },
        "negative.1500": {
            contrast: 13.228051867032564,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1600": {
            contrast: 8.247076062150803,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.2000": {
            contrast: 10.744764411200961,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.2100": {
            contrast: 17.236022322648065,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88
        },
        "negative.2200": {
            contrast: 23.647958590212628,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "negative.2300": {
            contrast: 29.891642136125057,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56
        },
        "negative.2400": {
            contrast: 37.049148200171246,
            lc60: 100,
            lc45: 100,
            lc30: 83.5,
            lc10: 47
        },
        "negative.2500": {
            contrast: 43.71443456708182,
            lc60: 100,
            lc45: 100,
            lc30: 72,
            lc10: 40
        }
    },
    "negative.1900": {
        "negative.100": {
            contrast: 70.26630175434997,
            lc60: 69,
            lc45: 49,
            lc30: 32,
            lc10: 16.5
        },
        "negative.200": {
            contrast: 69.5591699406505,
            lc60: 73.5,
            lc45: 52.5,
            lc30: 34,
            lc10: 17.5
        },
        "negative.300": {
            contrast: 67.77031914115463,
            lc60: 78.5,
            lc45: 55,
            lc30: 35.5,
            lc10: 18
        },
        "negative.400": {
            contrast: 65.47246297403463,
            lc60: 84,
            lc45: 58,
            lc30: 37.5,
            lc10: 19
        },
        "negative.500": {
            contrast: 62.21506541456774,
            lc60: 92.5,
            lc45: 61.5,
            lc30: 39,
            lc10: 20
        },
        "negative.600": {
            contrast: 57.88908294996443,
            lc60: 100,
            lc45: 66.5,
            lc30: 42,
            lc10: 21
        },
        "negative.700": {
            contrast: 53.670988007134035,
            lc60: 100,
            lc45: 73,
            lc30: 44.5,
            lc10: 22.5
        },
        "negative.800": {
            contrast: 49.004598976211575,
            lc60: 100,
            lc45: 82.5,
            lc30: 48,
            lc10: 23.5
        },
        "negative.900": {
            contrast: 44.55504583479296,
            lc60: 100,
            lc45: 100,
            lc30: 53,
            lc10: 25
        },
        "negative.1000": {
            contrast: 40.40246058824594,
            lc60: 100,
            lc45: 100,
            lc30: 57,
            lc10: 26.5
        },
        "negative.1100": {
            contrast: 36.103540408272586,
            lc60: 100,
            lc45: 100,
            lc30: 65,
            lc10: 28.5
        },
        "negative.1200": {
            contrast: 30.682909575044327,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 31.5
        },
        "negative.1300": {
            contrast: 27.369543225880815,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 40
        },
        "negative.1400": {
            contrast: 23.343633922488745,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "negative.1500": {
            contrast: 18.794286744092492,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76.5
        },
        "negative.1600": {
            contrast: 13.813310939210732,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1700": {
            contrast: 8.71394291539785,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.2100": {
            contrast: 11.19014523325457,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.2200": {
            contrast: 17.602081500819132,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87
        },
        "negative.2300": {
            contrast: 23.845765046731568,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "negative.2400": {
            contrast: 31.003271110777753,
            lc60: 100,
            lc45: 100,
            lc30: 97.5,
            lc10: 54
        },
        "negative.2500": {
            contrast: 37.668557477688324,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 45
        }
    },
    "negative.2000": {
        "negative.100": {
            contrast: 75.79265322568037,
            lc60: 63,
            lc45: 45.5,
            lc30: 30,
            lc10: 15.5
        },
        "negative.200": {
            contrast: 75.08552141198092,
            lc60: 66.5,
            lc45: 48,
            lc30: 31.5,
            lc10: 16
        },
        "negative.300": {
            contrast: 73.29667061248503,
            lc60: 70,
            lc45: 50.5,
            lc30: 32.5,
            lc10: 16.5
        },
        "negative.400": {
            contrast: 70.99881444536503,
            lc60: 74,
            lc45: 52.5,
            lc30: 34,
            lc10: 17.5
        },
        "negative.500": {
            contrast: 67.74141688589813,
            lc60: 79.5,
            lc45: 55,
            lc30: 35.5,
            lc10: 18
        },
        "negative.600": {
            contrast: 63.415434421294826,
            lc60: 88.5,
            lc45: 59,
            lc30: 37.5,
            lc10: 19
        },
        "negative.700": {
            contrast: 59.19733947846444,
            lc60: 100,
            lc45: 63.5,
            lc30: 40,
            lc10: 20
        },
        "negative.800": {
            contrast: 54.53095044754199,
            lc60: 100,
            lc45: 69,
            lc30: 42,
            lc10: 21
        },
        "negative.900": {
            contrast: 50.081397306123364,
            lc60: 100,
            lc45: 78,
            lc30: 45.5,
            lc10: 22
        },
        "negative.1000": {
            contrast: 45.92881205957634,
            lc60: 100,
            lc45: 92,
            lc30: 48,
            lc10: 23
        },
        "negative.1100": {
            contrast: 41.62989187960299,
            lc60: 100,
            lc45: 100,
            lc30: 52,
            lc10: 24
        },
        "negative.1200": {
            contrast: 36.20926104637473,
            lc60: 100,
            lc45: 100,
            lc30: 59.5,
            lc10: 26
        },
        "negative.1300": {
            contrast: 32.89589469721121,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 33
        },
        "negative.1400": {
            contrast: 28.869985393819146,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 44.5
        },
        "negative.1500": {
            contrast: 24.320638215422893,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "negative.1600": {
            contrast: 19.33966241054113,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75
        },
        "negative.1700": {
            contrast: 14.24029438672825,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1800": {
            contrast: 8.974651911406676,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.2200": {
            contrast: 11.530670494838283,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.2300": {
            contrast: 17.77435404075072,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86.5
        },
        "negative.2400": {
            contrast: 24.9318601047969,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "negative.2500": {
            contrast: 31.59714647170747,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 52
        }
    },
    "negative.2100": {
        "negative.100": {
            contrast: 81.82982432380616,
            lc60: 58,
            lc45: 42,
            lc30: 27.5,
            lc10: 14.5
        },
        "negative.200": {
            contrast: 81.1226925101067,
            lc60: 61,
            lc45: 44.5,
            lc30: 29,
            lc10: 15
        },
        "negative.300": {
            contrast: 79.33384171061081,
            lc60: 63.5,
            lc45: 45.5,
            lc30: 30,
            lc10: 15.5
        },
        "negative.400": {
            contrast: 77.03598554349081,
            lc60: 66.5,
            lc45: 47.5,
            lc30: 31.5,
            lc10: 16
        },
        "negative.500": {
            contrast: 73.77858798402393,
            lc60: 70,
            lc45: 49.5,
            lc30: 32,
            lc10: 17
        },
        "negative.600": {
            contrast: 69.45260551942062,
            lc60: 75.5,
            lc45: 52.5,
            lc30: 34,
            lc10: 17.5
        },
        "negative.700": {
            contrast: 65.23451057659022,
            lc60: 83,
            lc45: 55.5,
            lc30: 35.5,
            lc10: 18
        },
        "negative.800": {
            contrast: 60.56812154566777,
            lc60: 97,
            lc45: 59.5,
            lc30: 37,
            lc10: 19
        },
        "negative.900": {
            contrast: 56.11856840424916,
            lc60: 100,
            lc45: 64.5,
            lc30: 39.5,
            lc10: 19.5
        },
        "negative.1000": {
            contrast: 51.96598315770212,
            lc60: 100,
            lc45: 70.5,
            lc30: 41,
            lc10: 20.5
        },
        "negative.1100": {
            contrast: 47.66706297772878,
            lc60: 100,
            lc45: 80.5,
            lc30: 44.5,
            lc10: 21.5
        },
        "negative.1200": {
            contrast: 42.24643214450051,
            lc60: 100,
            lc45: 100,
            lc30: 48,
            lc10: 23
        },
        "negative.1300": {
            contrast: 38.933065795337,
            lc60: 100,
            lc45: 100,
            lc30: 59.5,
            lc10: 27.5
        },
        "negative.1400": {
            contrast: 34.90715649194493,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 36
        },
        "negative.1500": {
            contrast: 30.357809313548678,
            lc60: 100,
            lc45: 100,
            lc30: 98.5,
            lc10: 45
        },
        "negative.1600": {
            contrast: 25.37683350866692,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "negative.1700": {
            contrast: 20.277465484854037,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73
        },
        "negative.1800": {
            contrast: 15.011823009532463,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98.5
        },
        "negative.1900": {
            contrast: 9.3878264674419,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.2300": {
            contrast: 11.067835250593195,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.2400": {
            contrast: 18.22534131463938,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84
        },
        "negative.2500": {
            contrast: 24.89062768154995,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        }
    },
    "negative.2200": {
        "negative.100": {
            contrast: 87.7507799004434,
            lc60: 53.5,
            lc45: 39.5,
            lc30: 26,
            lc10: 13.5
        },
        "negative.200": {
            contrast: 87.04364808674396,
            lc60: 56.5,
            lc45: 41,
            lc30: 27,
            lc10: 14
        },
        "negative.300": {
            contrast: 85.25479728724807,
            lc60: 58,
            lc45: 42,
            lc30: 28,
            lc10: 14.5
        },
        "negative.400": {
            contrast: 82.95694112012806,
            lc60: 60.5,
            lc45: 43.5,
            lc30: 29,
            lc10: 15
        },
        "negative.500": {
            contrast: 79.69954356066117,
            lc60: 63.5,
            lc45: 45.5,
            lc30: 29.5,
            lc10: 15.5
        },
        "negative.600": {
            contrast: 75.37356109605786,
            lc60: 67,
            lc45: 47.5,
            lc30: 31,
            lc10: 16
        },
        "negative.700": {
            contrast: 71.15546615322745,
            lc60: 71.5,
            lc45: 50,
            lc30: 32,
            lc10: 16.5
        },
        "negative.800": {
            contrast: 66.489077122305,
            lc60: 78,
            lc45: 52.5,
            lc30: 33.5,
            lc10: 17
        },
        "negative.900": {
            contrast: 62.03952398088639,
            lc60: 89.5,
            lc45: 56,
            lc30: 35,
            lc10: 17.5
        },
        "negative.1000": {
            contrast: 57.88693873433937,
            lc60: 100,
            lc45: 59.5,
            lc30: 36.5,
            lc10: 18
        },
        "negative.1100": {
            contrast: 53.58801855436602,
            lc60: 100,
            lc45: 64.5,
            lc30: 38,
            lc10: 19
        },
        "negative.1200": {
            contrast: 48.16738772113776,
            lc60: 100,
            lc45: 75,
            lc30: 41,
            lc10: 20
        },
        "negative.1300": {
            contrast: 44.85402137197425,
            lc60: 100,
            lc45: 100,
            lc30: 50,
            lc10: 24
        },
        "negative.1400": {
            contrast: 40.82811206858218,
            lc60: 100,
            lc45: 100,
            lc30: 64,
            lc10: 30.5
        },
        "negative.1500": {
            contrast: 36.27876489018592,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 37
        },
        "negative.1600": {
            contrast: 31.29778908530416,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 45
        },
        "negative.1700": {
            contrast: 26.198421061491278,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "negative.1800": {
            contrast: 20.93277858616971,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "negative.1900": {
            contrast: 15.308782044079145,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98.5
        },
        "negative.2000": {
            contrast: 9.718001731863753,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.2400": {
            contrast: 11.57707565502799,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.2500": {
            contrast: 18.24236202193856,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85.5
        }
    },
    "negative.2300": {
        "negative.100": {
            contrast: 93.47884918645065,
            lc60: 50,
            lc45: 36.5,
            lc30: 24.5,
            lc10: 12.5
        },
        "negative.200": {
            contrast: 92.77171737275118,
            lc60: 52,
            lc45: 38,
            lc30: 25.5,
            lc10: 13
        },
        "negative.300": {
            contrast: 90.98286657325531,
            lc60: 54,
            lc45: 39.5,
            lc30: 26,
            lc10: 13.5
        },
        "negative.400": {
            contrast: 88.6850104061353,
            lc60: 55.5,
            lc45: 40.5,
            lc30: 26.5,
            lc10: 14
        },
        "negative.500": {
            contrast: 85.42761284666841,
            lc60: 57.5,
            lc45: 42,
            lc30: 27.5,
            lc10: 14.5
        },
        "negative.600": {
            contrast: 81.1016303820651,
            lc60: 61,
            lc45: 43.5,
            lc30: 28.5,
            lc10: 15
        },
        "negative.700": {
            contrast: 76.8835354392347,
            lc60: 64,
            lc45: 45.5,
            lc30: 29.5,
            lc10: 15.5
        },
        "negative.800": {
            contrast: 72.21714640831226,
            lc60: 68,
            lc45: 47,
            lc30: 30.5,
            lc10: 15.5
        },
        "negative.900": {
            contrast: 67.76759326689364,
            lc60: 74,
            lc45: 50,
            lc30: 32,
            lc10: 16.5
        },
        "negative.1000": {
            contrast: 63.61500802034661,
            lc60: 82,
            lc45: 52.5,
            lc30: 33,
            lc10: 16.5
        },
        "negative.1100": {
            contrast: 59.31608784037326,
            lc60: 100,
            lc45: 55,
            lc30: 34,
            lc10: 17
        },
        "negative.1200": {
            contrast: 53.895457007145,
            lc60: 100,
            lc45: 60.5,
            lc30: 36,
            lc10: 18
        },
        "negative.1300": {
            contrast: 50.58209065798148,
            lc60: 100,
            lc45: 74.5,
            lc30: 43,
            lc10: 21.5
        },
        "negative.1400": {
            contrast: 46.55618135458941,
            lc60: 100,
            lc45: 93.5,
            lc30: 54.5,
            lc10: 26.5
        },
        "negative.1500": {
            contrast: 42.00683417619316,
            lc60: 100,
            lc45: 100,
            lc30: 65,
            lc10: 31.5
        },
        "negative.1600": {
            contrast: 37.0258583713114,
            lc60: 100,
            lc45: 100,
            lc30: 77.5,
            lc10: 38
        },
        "negative.1700": {
            contrast: 31.926490347498515,
            lc60: 100,
            lc45: 100,
            lc30: 92.5,
            lc10: 45.5
        },
        "negative.1800": {
            contrast: 26.660847872176944,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56
        },
        "negative.1900": {
            contrast: 21.036851330086385,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72.5
        },
        "negative.2000": {
            contrast: 15.446071017870992,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 96
        },
        "negative.2100": {
            contrast: 9.330991254531366,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.2500": {
            contrast: 11.747385945300524,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "negative.2400": {
        "negative.100": {
            contrast: 100.00300723447944,
            lc60: 47,
            lc45: 34.5,
            lc30: 23,
            lc10: 12
        },
        "negative.200": {
            contrast: 99.29587542077996,
            lc60: 48.5,
            lc45: 35.5,
            lc30: 23.5,
            lc10: 12.5
        },
        "negative.300": {
            contrast: 97.5070246212841,
            lc60: 50,
            lc45: 36.5,
            lc30: 24,
            lc10: 12.5
        },
        "negative.400": {
            contrast: 95.20916845416409,
            lc60: 51,
            lc45: 37.5,
            lc30: 25,
            lc10: 13
        },
        "negative.500": {
            contrast: 91.95177089469719,
            lc60: 53,
            lc45: 38.5,
            lc30: 25.5,
            lc10: 13.5
        },
        "negative.600": {
            contrast: 87.62578843009389,
            lc60: 55.5,
            lc45: 40,
            lc30: 26.5,
            lc10: 13.5
        },
        "negative.700": {
            contrast: 83.40769348726349,
            lc60: 57.5,
            lc45: 41.5,
            lc30: 27,
            lc10: 14
        },
        "negative.800": {
            contrast: 78.74130445634104,
            lc60: 60.5,
            lc45: 43,
            lc30: 28,
            lc10: 14.5
        },
        "negative.900": {
            contrast: 74.29175131492242,
            lc60: 64.5,
            lc45: 45,
            lc30: 29,
            lc10: 15
        },
        "negative.1000": {
            contrast: 70.13916606837539,
            lc60: 68.5,
            lc45: 46.5,
            lc30: 29.5,
            lc10: 15
        },
        "negative.1100": {
            contrast: 65.84024588840205,
            lc60: 74,
            lc45: 48.5,
            lc30: 31,
            lc10: 15.5
        },
        "negative.1200": {
            contrast: 60.41961505517378,
            lc60: 92.5,
            lc45: 52,
            lc30: 32,
            lc10: 16
        },
        "negative.1300": {
            contrast: 57.10624870601026,
            lc60: 100,
            lc45: 61.5,
            lc30: 38,
            lc10: 19
        },
        "negative.1400": {
            contrast: 53.08033940261821,
            lc60: 100,
            lc45: 76,
            lc30: 46.5,
            lc10: 23.5
        },
        "negative.1500": {
            contrast: 48.53099222422195,
            lc60: 100,
            lc45: 89,
            lc30: 55,
            lc10: 27.5
        },
        "negative.1600": {
            contrast: 43.55001641934018,
            lc60: 100,
            lc45: 100,
            lc30: 63.5,
            lc10: 32
        },
        "negative.1700": {
            contrast: 38.4506483955273,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 37.5
        },
        "negative.1800": {
            contrast: 33.18500592020573,
            lc60: 100,
            lc45: 100,
            lc30: 89,
            lc10: 44.5
        },
        "negative.1900": {
            contrast: 27.561009378115166,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "negative.2000": {
            contrast: 21.970229065899776,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "negative.2100": {
            contrast: 15.85514930256015,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 94
        },
        "negative.2200": {
            contrast: 9.8506407323477,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "negative.2500": {
        "negative.100": {
            contrast: 106.04067321268862,
            lc60: 44,
            lc45: 32.5,
            lc30: 21.5,
            lc10: 11.5
        },
        "negative.200": {
            contrast: 105.33354139898915,
            lc60: 45.5,
            lc45: 33.5,
            lc30: 22.5,
            lc10: 12
        },
        "negative.300": {
            contrast: 103.54469059949326,
            lc60: 46.5,
            lc45: 34.5,
            lc30: 23,
            lc10: 12
        },
        "negative.400": {
            contrast: 101.24683443237326,
            lc60: 48,
            lc45: 35.5,
            lc30: 23.5,
            lc10: 12
        },
        "negative.500": {
            contrast: 97.98943687290637,
            lc60: 49,
            lc45: 36,
            lc30: 24,
            lc10: 12.5
        },
        "negative.600": {
            contrast: 93.66345440830305,
            lc60: 51,
            lc45: 37.5,
            lc30: 25,
            lc10: 13
        },
        "negative.700": {
            contrast: 89.44535946547266,
            lc60: 53,
            lc45: 38.5,
            lc30: 25,
            lc10: 13.5
        },
        "negative.800": {
            contrast: 84.77897043455022,
            lc60: 55,
            lc45: 39.5,
            lc30: 26,
            lc10: 13.5
        },
        "negative.900": {
            contrast: 80.32941729313158,
            lc60: 58,
            lc45: 41,
            lc30: 27,
            lc10: 14
        },
        "negative.1000": {
            contrast: 76.17683204658456,
            lc60: 60.5,
            lc45: 42.5,
            lc30: 27.5,
            lc10: 14
        },
        "negative.1100": {
            contrast: 71.87791186661121,
            lc60: 64,
            lc45: 44,
            lc30: 28.5,
            lc10: 14.5
        },
        "negative.1200": {
            contrast: 66.45728103338296,
            lc60: 70.5,
            lc45: 46,
            lc30: 29.5,
            lc10: 15
        },
        "negative.1300": {
            contrast: 63.14391468421944,
            lc60: 85,
            lc45: 54.5,
            lc30: 34.5,
            lc10: 17.5
        },
        "negative.1400": {
            contrast: 59.11800538082736,
            lc60: 100,
            lc45: 66,
            lc30: 41.5,
            lc10: 21
        },
        "negative.1500": {
            contrast: 54.568658202431116,
            lc60: 100,
            lc45: 76.5,
            lc30: 48,
            lc10: 24.5
        },
        "negative.1600": {
            contrast: 49.58768239754935,
            lc60: 100,
            lc45: 87.5,
            lc30: 55.5,
            lc10: 28.5
        },
        "negative.1700": {
            contrast: 44.48831437373647,
            lc60: 100,
            lc45: 100,
            lc30: 64,
            lc10: 32.5
        },
        "negative.1800": {
            contrast: 39.222671898414895,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 38.5
        },
        "negative.1900": {
            contrast: 33.598675356324335,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 45.5
        },
        "negative.2000": {
            contrast: 28.007895044108942,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "negative.2100": {
            contrast: 21.89281528076932,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70.5
        },
        "negative.2200": {
            contrast: 15.888306710556868,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 94
        },
        "negative.2300": {
            contrast: 10.073082194784567,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    }
};
const $f8fd43f1ee3f8cd8$var$positive = {
    "positive.100": {
        "positive.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.600": {
            contrast: 9.81515493613894,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.700": {
            contrast: 14.542304567260175,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.800": {
            contrast: 19.67730972117696,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87
        },
        "positive.900": {
            contrast: 24.425831449014833,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78
        },
        "positive.1000": {
            contrast: 29.04007089665641,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "positive.1100": {
            contrast: 33.86653657253203,
            lc60: 100,
            lc45: 100,
            lc30: 93,
            lc10: 65
        },
        "positive.1200": {
            contrast: 38.93918752533884,
            lc60: 100,
            lc45: 100,
            lc30: 86,
            lc10: 60
        },
        "positive.1300": {
            contrast: 45.28230277245376,
            lc60: 100,
            lc45: 99.5,
            lc30: 78.5,
            lc10: 55
        },
        "positive.1400": {
            contrast: 48.723370107696674,
            lc60: 100,
            lc45: 95,
            lc30: 75.5,
            lc10: 52.5
        },
        "positive.1500": {
            contrast: 53.76068620910945,
            lc60: 100,
            lc45: 90,
            lc30: 71,
            lc10: 49.5
        },
        "positive.1600": {
            contrast: 58.24489471818557,
            lc60: 100,
            lc45: 85,
            lc30: 67.5,
            lc10: 47
        },
        "positive.1700": {
            contrast: 63.407928083748274,
            lc60: 96.5,
            lc45: 81,
            lc30: 64,
            lc10: 44.5
        },
        "positive.1800": {
            contrast: 68.51582279169143,
            lc60: 92,
            lc45: 77.5,
            lc30: 61,
            lc10: 42.5
        },
        "positive.1900": {
            contrast: 73.93667684103768,
            lc60: 88,
            lc45: 73.5,
            lc30: 58.5,
            lc10: 40.5
        },
        "positive.2000": {
            contrast: 79.21537147213381,
            lc60: 84,
            lc45: 70.5,
            lc30: 56,
            lc10: 39
        },
        "positive.2100": {
            contrast: 84.84193775682745,
            lc60: 80.5,
            lc45: 67.5,
            lc30: 53.5,
            lc10: 37.5
        },
        "positive.2200": {
            contrast: 90.41261085799682,
            lc60: 77,
            lc45: 65,
            lc30: 51.5,
            lc10: 35.5
        },
        "positive.2300": {
            contrast: 95.96647147481355,
            lc60: 74.5,
            lc45: 62.5,
            lc30: 49.5,
            lc10: 34.5
        },
        "positive.2400": {
            contrast: 101.90172545161896,
            lc60: 71.5,
            lc45: 60,
            lc30: 48,
            lc10: 33
        },
        "positive.2500": {
            contrast: 107.88473318309848,
            lc60: 69,
            lc45: 58,
            lc30: 46,
            lc10: 32
        }
    },
    "positive.200": {
        "positive.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.600": {
            contrast: 9.476969714564074,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.700": {
            contrast: 14.20411934568531,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.800": {
            contrast: 19.339124499602097,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86
        },
        "positive.900": {
            contrast: 24.087646227439965,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75.5
        },
        "positive.1000": {
            contrast: 28.701885675081545,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "positive.1100": {
            contrast: 33.52835135095715,
            lc60: 100,
            lc45: 100,
            lc30: 93,
            lc10: 61.5
        },
        "positive.1200": {
            contrast: 38.60100230376396,
            lc60: 100,
            lc45: 100,
            lc30: 85,
            lc10: 56
        },
        "positive.1300": {
            contrast: 44.944117550878886,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 50.5
        },
        "positive.1400": {
            contrast: 48.3851848861218,
            lc60: 100,
            lc45: 95,
            lc30: 73.5,
            lc10: 48
        },
        "positive.1500": {
            contrast: 53.42250098753458,
            lc60: 100,
            lc45: 89,
            lc30: 68.5,
            lc10: 45.5
        },
        "positive.1600": {
            contrast: 57.90670949661071,
            lc60: 100,
            lc45: 84.5,
            lc30: 65,
            lc10: 43
        },
        "positive.1700": {
            contrast: 63.069742862173406,
            lc60: 96.5,
            lc45: 80,
            lc30: 61.5,
            lc10: 41
        },
        "positive.1800": {
            contrast: 68.17763757011657,
            lc60: 92,
            lc45: 75.5,
            lc30: 58.5,
            lc10: 38.5
        },
        "positive.1900": {
            contrast: 73.59849161946282,
            lc60: 87.5,
            lc45: 72,
            lc30: 55.5,
            lc10: 36.5
        },
        "positive.2000": {
            contrast: 78.87718625055894,
            lc60: 83,
            lc45: 69,
            lc30: 53,
            lc10: 35
        },
        "positive.2100": {
            contrast: 84.50375253525257,
            lc60: 79.5,
            lc45: 65.5,
            lc30: 50.5,
            lc10: 33.5
        },
        "positive.2200": {
            contrast: 90.07442563642195,
            lc60: 76,
            lc45: 63,
            lc30: 48.5,
            lc10: 32
        },
        "positive.2300": {
            contrast: 95.62828625323867,
            lc60: 73,
            lc45: 60.5,
            lc30: 46.5,
            lc10: 31
        },
        "positive.2400": {
            contrast: 101.56354023004408,
            lc60: 70,
            lc45: 58.5,
            lc30: 45,
            lc10: 29.5
        },
        "positive.2500": {
            contrast: 107.54654796152361,
            lc60: 67.5,
            lc45: 56,
            lc30: 43,
            lc10: 28.5
        }
    },
    "positive.300": {
        "positive.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.600": {
            contrast: 8.195453043788138,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.700": {
            contrast: 12.92260267490937,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.800": {
            contrast: 18.057607828826157,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88.5
        },
        "positive.900": {
            contrast: 22.806129556664025,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75.5
        },
        "positive.1000": {
            contrast: 27.420369004305606,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66.5
        },
        "positive.1100": {
            contrast: 32.246834680181216,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 59.5
        },
        "positive.1200": {
            contrast: 37.319485632988034,
            lc60: 100,
            lc45: 100,
            lc30: 85.5,
            lc10: 53.5
        },
        "positive.1300": {
            contrast: 43.66260088010295,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 47.5
        },
        "positive.1400": {
            contrast: 47.10366821534587,
            lc60: 100,
            lc45: 96.5,
            lc30: 72.5,
            lc10: 45.5
        },
        "positive.1500": {
            contrast: 52.14098431675864,
            lc60: 100,
            lc45: 90,
            lc30: 67.5,
            lc10: 42
        },
        "positive.1600": {
            contrast: 56.625192825834766,
            lc60: 100,
            lc45: 85,
            lc30: 63.5,
            lc10: 39.5
        },
        "positive.1700": {
            contrast: 61.78822619139748,
            lc60: 97.5,
            lc45: 80,
            lc30: 60,
            lc10: 37
        },
        "positive.1800": {
            contrast: 66.89612089934064,
            lc60: 92.5,
            lc45: 75,
            lc30: 56.5,
            lc10: 35.5
        },
        "positive.1900": {
            contrast: 72.31697494868689,
            lc60: 87.5,
            lc45: 71.5,
            lc30: 53.5,
            lc10: 33.5
        },
        "positive.2000": {
            contrast: 77.595669579783,
            lc60: 83,
            lc45: 68,
            lc30: 51,
            lc10: 31.5
        },
        "positive.2100": {
            contrast: 83.22223586447664,
            lc60: 79.5,
            lc45: 64.5,
            lc30: 49,
            lc10: 30.5
        },
        "positive.2200": {
            contrast: 88.79290896564602,
            lc60: 75.5,
            lc45: 61.5,
            lc30: 46.5,
            lc10: 29
        },
        "positive.2300": {
            contrast: 94.34676958246274,
            lc60: 72.5,
            lc45: 59.5,
            lc30: 44.5,
            lc10: 28
        },
        "positive.2400": {
            contrast: 100.28202355926814,
            lc60: 69.5,
            lc45: 57,
            lc30: 43,
            lc10: 27
        },
        "positive.2500": {
            contrast: 106.26503129074767,
            lc60: 67,
            lc45: 54.5,
            lc30: 41,
            lc10: 26
        }
    },
    "positive.400": {
        "positive.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.700": {
            contrast: 10.860049654422863,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.800": {
            contrast: 15.995054808339646,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95.5
        },
        "positive.900": {
            contrast: 20.743576536177518,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79
        },
        "positive.1000": {
            contrast: 25.357815983819094,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "positive.1100": {
            contrast: 30.184281659694705,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 59.5
        },
        "positive.1200": {
            contrast: 35.256932612501515,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 53
        },
        "positive.1300": {
            contrast: 41.60004785961644,
            lc60: 100,
            lc45: 100,
            lc30: 77.5,
            lc10: 46
        },
        "positive.1400": {
            contrast: 45.04111519485935,
            lc60: 100,
            lc45: 99.5,
            lc30: 73.5,
            lc10: 43.5
        },
        "positive.1500": {
            contrast: 50.07843129627213,
            lc60: 100,
            lc45: 92.5,
            lc30: 67.5,
            lc10: 40.5
        },
        "positive.1600": {
            contrast: 54.562639805348255,
            lc60: 100,
            lc45: 86.5,
            lc30: 64,
            lc10: 37.5
        },
        "positive.1700": {
            contrast: 59.725673170910966,
            lc60: 100,
            lc45: 80.5,
            lc30: 59.5,
            lc10: 35.5
        },
        "positive.1800": {
            contrast: 64.83356787885413,
            lc60: 94,
            lc45: 76,
            lc30: 56,
            lc10: 33
        },
        "positive.1900": {
            contrast: 70.25442192820036,
            lc60: 88.5,
            lc45: 71.5,
            lc30: 53,
            lc10: 31.5
        },
        "positive.2000": {
            contrast: 75.5331165592965,
            lc60: 84,
            lc45: 68,
            lc30: 50.5,
            lc10: 30
        },
        "positive.2100": {
            contrast: 81.15968284399013,
            lc60: 80,
            lc45: 64.5,
            lc30: 47.5,
            lc10: 28
        },
        "positive.2200": {
            contrast: 86.73035594515952,
            lc60: 76.5,
            lc45: 61.5,
            lc30: 45.5,
            lc10: 27.5
        },
        "positive.2300": {
            contrast: 92.28421656197622,
            lc60: 73,
            lc45: 59,
            lc30: 43.5,
            lc10: 26
        },
        "positive.2400": {
            contrast: 98.21947053878162,
            lc60: 69.5,
            lc45: 56.5,
            lc30: 41.5,
            lc10: 25
        },
        "positive.2500": {
            contrast: 104.20247827026114,
            lc60: 67,
            lc45: 54,
            lc30: 40,
            lc10: 24
        }
    },
    "positive.500": {
        "positive.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.700": {
            contrast: 7.8042912635796835,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.800": {
            contrast: 12.939296417496472,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.900": {
            contrast: 17.68781814533434,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87
        },
        "positive.1000": {
            contrast: 22.302057592975924,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72.5
        },
        "positive.1100": {
            contrast: 27.128523268851534,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62
        },
        "positive.1200": {
            contrast: 32.20117422165834,
            lc60: 100,
            lc45: 100,
            lc30: 94,
            lc10: 54
        },
        "positive.1300": {
            contrast: 38.544289468773265,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 47
        },
        "positive.1400": {
            contrast: 41.985356804016185,
            lc60: 100,
            lc45: 100,
            lc30: 76,
            lc10: 44
        },
        "positive.1500": {
            contrast: 47.022672905428955,
            lc60: 100,
            lc45: 96,
            lc30: 70,
            lc10: 40
        },
        "positive.1600": {
            contrast: 51.50688141450508,
            lc60: 100,
            lc45: 89.5,
            lc30: 65,
            lc10: 37.5
        },
        "positive.1700": {
            contrast: 56.6699147800678,
            lc60: 100,
            lc45: 83.5,
            lc30: 60,
            lc10: 35
        },
        "positive.1800": {
            contrast: 61.77780948801096,
            lc60: 97.5,
            lc45: 78,
            lc30: 56.5,
            lc10: 32.5
        },
        "positive.1900": {
            contrast: 67.19866353735719,
            lc60: 91.5,
            lc45: 73,
            lc30: 53.5,
            lc10: 31
        },
        "positive.2000": {
            contrast: 72.47735816845334,
            lc60: 86,
            lc45: 69.5,
            lc30: 50.5,
            lc10: 29
        },
        "positive.2100": {
            contrast: 78.10392445314696,
            lc60: 81.5,
            lc45: 65.5,
            lc30: 47.5,
            lc10: 28
        },
        "positive.2200": {
            contrast: 83.67459755431634,
            lc60: 77.5,
            lc45: 62,
            lc30: 45.5,
            lc10: 26.5
        },
        "positive.2300": {
            contrast: 89.22845817113304,
            lc60: 74,
            lc45: 59.5,
            lc30: 43.5,
            lc10: 25
        },
        "positive.2400": {
            contrast: 95.16371214793845,
            lc60: 71,
            lc45: 56.5,
            lc30: 42,
            lc10: 24.5
        },
        "positive.2500": {
            contrast: 101.14671987941797,
            lc60: 67.5,
            lc45: 54.5,
            lc30: 40,
            lc10: 23.5
        }
    },
    "positive.600": {
        "positive.100": {
            contrast: 11.313172454626057,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.200": {
            contrast: 10.859167541132283,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.300": {
            contrast: 9.180620186678388,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.800": {
            contrast: 8.609130780523708,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.900": {
            contrast: 13.357652508361578,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1000": {
            contrast: 17.971891956003162,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86
        },
        "positive.1100": {
            contrast: 22.798357631878773,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70.5
        },
        "positive.1200": {
            contrast: 27.871008584685576,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "positive.1300": {
            contrast: 34.2141238318005,
            lc60: 100,
            lc45: 100,
            lc30: 89.5,
            lc10: 49.5
        },
        "positive.1400": {
            contrast: 37.65519116704342,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 46
        },
        "positive.1500": {
            contrast: 42.69250726845619,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 42
        },
        "positive.1600": {
            contrast: 47.176715777532316,
            lc60: 100,
            lc45: 96,
            lc30: 69,
            lc10: 39
        },
        "positive.1700": {
            contrast: 52.33974914309503,
            lc60: 100,
            lc45: 88.5,
            lc30: 64,
            lc10: 35.5
        },
        "positive.1800": {
            contrast: 57.44764385103819,
            lc60: 100,
            lc45: 82.5,
            lc30: 59.5,
            lc10: 33.5
        },
        "positive.1900": {
            contrast: 62.868497900384426,
            lc60: 96,
            lc45: 76.5,
            lc30: 55.5,
            lc10: 31.5
        },
        "positive.2000": {
            contrast: 68.14719253148056,
            lc60: 90,
            lc45: 72,
            lc30: 52,
            lc10: 29.5
        },
        "positive.2100": {
            contrast: 73.77375881617418,
            lc60: 85,
            lc45: 67.5,
            lc30: 49,
            lc10: 28
        },
        "positive.2200": {
            contrast: 79.34443191734356,
            lc60: 80.5,
            lc45: 64.5,
            lc30: 46.5,
            lc10: 26.5
        },
        "positive.2300": {
            contrast: 84.89829253416028,
            lc60: 76.5,
            lc45: 61.5,
            lc30: 44.5,
            lc10: 25.5
        },
        "positive.2400": {
            contrast: 90.83354651096568,
            lc60: 73,
            lc45: 58.5,
            lc30: 42.5,
            lc10: 24.5
        },
        "positive.2500": {
            contrast: 96.8165542424452,
            lc60: 69.5,
            lc45: 56,
            lc30: 40.5,
            lc10: 24
        }
    },
    "positive.700": {
        "positive.100": {
            contrast: 16.411421032138183,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "positive.200": {
            contrast: 15.957416118644405,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86
        },
        "positive.300": {
            contrast: 14.278868764190507,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.400": {
            contrast: 11.681960757807062,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.500": {
            contrast: 7.99742913160079,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.900": {
            contrast: 8.822238772246363,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1000": {
            contrast: 13.436478219887945,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1100": {
            contrast: 18.26294389576356,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83.5
        },
        "positive.1200": {
            contrast: 23.335594848570366,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "positive.1300": {
            contrast: 29.67871009568529,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "positive.1400": {
            contrast: 33.1197774309282,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 51
        },
        "positive.1500": {
            contrast: 38.15709353234098,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 45.5
        },
        "positive.1600": {
            contrast: 42.641302041417106,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 41
        },
        "positive.1700": {
            contrast: 47.80433540697982,
            lc60: 100,
            lc45: 95,
            lc30: 68,
            lc10: 37.5
        },
        "positive.1800": {
            contrast: 52.91223011492298,
            lc60: 100,
            lc45: 87.5,
            lc30: 62.5,
            lc10: 35
        },
        "positive.1900": {
            contrast: 58.33308416426921,
            lc60: 100,
            lc45: 81,
            lc30: 58,
            lc10: 33
        },
        "positive.2000": {
            contrast: 63.611778795365346,
            lc60: 95,
            lc45: 75.5,
            lc30: 54.5,
            lc10: 30.5
        },
        "positive.2100": {
            contrast: 69.23834508005898,
            lc60: 89,
            lc45: 71,
            lc30: 51.5,
            lc10: 29
        },
        "positive.2200": {
            contrast: 74.80901818122835,
            lc60: 84,
            lc45: 67,
            lc30: 48.5,
            lc10: 27.5
        },
        "positive.2300": {
            contrast: 80.36287879804507,
            lc60: 80,
            lc45: 63.5,
            lc30: 46,
            lc10: 26
        },
        "positive.2400": {
            contrast: 86.29813277485047,
            lc60: 75.5,
            lc45: 60.5,
            lc30: 43.5,
            lc10: 25.5
        },
        "positive.2500": {
            contrast: 92.28114050632999,
            lc60: 72.5,
            lc45: 58,
            lc30: 42,
            lc10: 24
        }
    },
    "positive.800": {
        "positive.100": {
            contrast: 21.82266822486706,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 47.5
        },
        "positive.200": {
            contrast: 21.368663311373286,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "positive.300": {
            contrast: 19.69011595691939,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "positive.400": {
            contrast: 17.093207950535938,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84
        },
        "positive.500": {
            contrast: 13.408676324329669,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.600": {
            contrast: 8.411625491682994,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1000": {
            contrast: 8.452355531236847,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1100": {
            contrast: 13.278821207112463,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1200": {
            contrast: 18.351472159919272,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84.5
        },
        "positive.1300": {
            contrast: 24.694587407034195,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "positive.1400": {
            contrast: 28.135654742277104,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "positive.1500": {
            contrast: 33.17297084368989,
            lc60: 100,
            lc45: 100,
            lc30: 91.5,
            lc10: 50.5
        },
        "positive.1600": {
            contrast: 37.65717935276601,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 46
        },
        "positive.1700": {
            contrast: 42.82021271832871,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 40.5
        },
        "positive.1800": {
            contrast: 47.92810742627188,
            lc60: 100,
            lc45: 94.5,
            lc30: 68,
            lc10: 37.5
        },
        "positive.1900": {
            contrast: 53.34896147561812,
            lc60: 100,
            lc45: 87,
            lc30: 62,
            lc10: 34.5
        },
        "positive.2000": {
            contrast: 58.62765610671424,
            lc60: 100,
            lc45: 81,
            lc30: 57.5,
            lc10: 32.5
        },
        "positive.2100": {
            contrast: 64.25422239140788,
            lc60: 94.5,
            lc45: 75,
            lc30: 54.5,
            lc10: 30
        },
        "positive.2200": {
            contrast: 69.82489549257726,
            lc60: 89,
            lc45: 71,
            lc30: 51.5,
            lc10: 28.5
        },
        "positive.2300": {
            contrast: 75.37875610939398,
            lc60: 83.5,
            lc45: 67,
            lc30: 48.5,
            lc10: 27.5
        },
        "positive.2400": {
            contrast: 81.31401008619937,
            lc60: 79,
            lc45: 63,
            lc30: 46,
            lc10: 26
        },
        "positive.2500": {
            contrast: 87.29701781767889,
            lc60: 75,
            lc45: 60.5,
            lc30: 44,
            lc10: 25.5
        }
    },
    "positive.900": {
        "positive.100": {
            contrast: 26.73364115847448,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 40
        },
        "positive.200": {
            contrast: 26.279636244980708,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 46
        },
        "positive.300": {
            contrast: 24.601088890526814,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54
        },
        "positive.400": {
            contrast: 22.004180884143366,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65.5
        },
        "positive.500": {
            contrast: 18.319649257937098,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82
        },
        "positive.600": {
            contrast: 13.322598425290424,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.700": {
            contrast: 8.284476220572042,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1100": {
            contrast: 8.626418127703598,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1200": {
            contrast: 13.699069080510407,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1300": {
            contrast: 20.042184327625332,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76.5
        },
        "positive.1400": {
            contrast: 23.483251662868245,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "positive.1500": {
            contrast: 28.520567764281026,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "positive.1600": {
            contrast: 33.004776273357145,
            lc60: 100,
            lc45: 100,
            lc30: 92.5,
            lc10: 51
        },
        "positive.1700": {
            contrast: 38.167809638919856,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 45.5
        },
        "positive.1800": {
            contrast: 43.275704346863016,
            lc60: 100,
            lc45: 100,
            lc30: 73.5,
            lc10: 40.5
        },
        "positive.1900": {
            contrast: 48.696558396209255,
            lc60: 100,
            lc45: 93,
            lc30: 67,
            lc10: 37
        },
        "positive.2000": {
            contrast: 53.97525302730538,
            lc60: 100,
            lc45: 86,
            lc30: 62,
            lc10: 35
        },
        "positive.2100": {
            contrast: 59.601819311999016,
            lc60: 100,
            lc45: 80,
            lc30: 57.5,
            lc10: 32.5
        },
        "positive.2200": {
            contrast: 65.1724924131684,
            lc60: 93.5,
            lc45: 74.5,
            lc30: 54.5,
            lc10: 30
        },
        "positive.2300": {
            contrast: 70.7263530299851,
            lc60: 88,
            lc45: 70.5,
            lc30: 51.5,
            lc10: 29
        },
        "positive.2400": {
            contrast: 76.6616070067905,
            lc60: 83,
            lc45: 66.5,
            lc30: 48.5,
            lc10: 28
        },
        "positive.2500": {
            contrast: 82.64461473827002,
            lc60: 78.5,
            lc45: 63,
            lc30: 46,
            lc10: 26
        }
    },
    "positive.1000": {
        "positive.100": {
            contrast: 31.435077008065083,
            lc60: 100,
            lc45: 100,
            lc30: 79,
            lc10: 34
        },
        "positive.200": {
            contrast: 30.98107209457131,
            lc60: 100,
            lc45: 100,
            lc30: 90,
            lc10: 38.5
        },
        "positive.300": {
            contrast: 29.302524740117413,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 45
        },
        "positive.400": {
            contrast: 26.705616733733965,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 52.5
        },
        "positive.500": {
            contrast: 23.021085107527703,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "positive.600": {
            contrast: 18.024034274881025,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82.5
        },
        "positive.700": {
            contrast: 12.985912070162644,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.800": {
            contrast: 7.61778213593393,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1200": {
            contrast: 9.144395225657597,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1300": {
            contrast: 15.48751047277252,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 96
        },
        "positive.1400": {
            contrast: 18.928577808015433,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81
        },
        "positive.1500": {
            contrast: 23.965893909428214,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "positive.1600": {
            contrast: 28.45010241850433,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "positive.1700": {
            contrast: 33.61313578406704,
            lc60: 100,
            lc45: 100,
            lc30: 90.5,
            lc10: 50.5
        },
        "positive.1800": {
            contrast: 38.7210304920102,
            lc60: 100,
            lc45: 100,
            lc30: 80.5,
            lc10: 44.5
        },
        "positive.1900": {
            contrast: 44.14188454135644,
            lc60: 100,
            lc45: 100,
            lc30: 73,
            lc10: 40
        },
        "positive.2000": {
            contrast: 49.42057917245257,
            lc60: 100,
            lc45: 93,
            lc30: 66.5,
            lc10: 37
        },
        "positive.2100": {
            contrast: 55.04714545714619,
            lc60: 100,
            lc45: 85.5,
            lc30: 61,
            lc10: 34.5
        },
        "positive.2200": {
            contrast: 60.61781855831557,
            lc60: 99.5,
            lc45: 79,
            lc30: 57.5,
            lc10: 32.5
        },
        "positive.2300": {
            contrast: 66.1716791751323,
            lc60: 92.5,
            lc45: 74.5,
            lc30: 54,
            lc10: 30.5
        },
        "positive.2400": {
            contrast: 72.1069331519377,
            lc60: 86.5,
            lc45: 69.5,
            lc30: 51,
            lc10: 29
        },
        "positive.2500": {
            contrast: 78.08994088341721,
            lc60: 82,
            lc45: 66,
            lc30: 48.5,
            lc10: 28
        }
    },
    "positive.1100": {
        "positive.100": {
            contrast: 36.2891937130518,
            lc60: 100,
            lc45: 100,
            lc30: 62,
            lc10: 30
        },
        "positive.200": {
            contrast: 35.835188799558026,
            lc60: 100,
            lc45: 100,
            lc30: 70,
            lc10: 33.5
        },
        "positive.300": {
            contrast: 34.15664144510413,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 38
        },
        "positive.400": {
            contrast: 31.559733438720684,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 44
        },
        "positive.500": {
            contrast: 27.875201812514412,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 52
        },
        "positive.600": {
            contrast: 22.878150979867737,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64.5
        },
        "positive.700": {
            contrast: 17.840028775149356,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83.5
        },
        "positive.800": {
            contrast: 12.471898840920643,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.900": {
            contrast: 7.584794977246144,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1300": {
            contrast: 10.692266987789296,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1400": {
            contrast: 14.133334323032209,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1500": {
            contrast: 19.170650424444986,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80
        },
        "positive.1600": {
            contrast: 23.65485893352111,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "positive.1700": {
            contrast: 28.817892299083812,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "positive.1800": {
            contrast: 33.92578700702698,
            lc60: 100,
            lc45: 100,
            lc30: 90,
            lc10: 50.5
        },
        "positive.1900": {
            contrast: 39.346641056373215,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 44
        },
        "positive.2000": {
            contrast: 44.625335687469345,
            lc60: 100,
            lc45: 100,
            lc30: 72.5,
            lc10: 40
        },
        "positive.2100": {
            contrast: 50.25190197216298,
            lc60: 100,
            lc45: 91.5,
            lc30: 66,
            lc10: 37
        },
        "positive.2200": {
            contrast: 55.82257507333236,
            lc60: 100,
            lc45: 84.5,
            lc30: 60.5,
            lc10: 34.5
        },
        "positive.2300": {
            contrast: 61.376435690149066,
            lc60: 98.5,
            lc45: 78.5,
            lc30: 57,
            lc10: 32
        },
        "positive.2400": {
            contrast: 67.31168966695446,
            lc60: 91.5,
            lc45: 73.5,
            lc30: 53.5,
            lc10: 30.5
        },
        "positive.2500": {
            contrast: 73.294697398434,
            lc60: 86,
            lc45: 69.5,
            lc30: 50.5,
            lc10: 29.5
        }
    },
    "positive.1200": {
        "positive.100": {
            contrast: 41.33011641631036,
            lc60: 100,
            lc45: 100,
            lc30: 54,
            lc10: 27
        },
        "positive.200": {
            contrast: 40.876111502816585,
            lc60: 100,
            lc45: 100,
            lc30: 60.5,
            lc10: 30
        },
        "positive.300": {
            contrast: 39.19756414836269,
            lc60: 100,
            lc45: 100,
            lc30: 68,
            lc10: 33.5
        },
        "positive.400": {
            contrast: 36.600656141979236,
            lc60: 100,
            lc45: 100,
            lc30: 77.5,
            lc10: 38.5
        },
        "positive.500": {
            contrast: 32.91612451577297,
            lc60: 100,
            lc45: 100,
            lc30: 90,
            lc10: 44.5
        },
        "positive.600": {
            contrast: 27.919073683126292,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53.5
        },
        "positive.700": {
            contrast: 22.880951478407916,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "positive.800": {
            contrast: 17.512821544179204,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86.5
        },
        "positive.900": {
            contrast: 12.625717680504703,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1000": {
            contrast: 7.935483404787509,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1400": {
            contrast: 9.063204280158864,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1500": {
            contrast: 14.100520381571641,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1600": {
            contrast: 18.584728890647764,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83
        },
        "positive.1700": {
            contrast: 23.74776225621047,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "positive.1800": {
            contrast: 28.85565696415363,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58
        },
        "positive.1900": {
            contrast: 34.27651101349987,
            lc60: 100,
            lc45: 100,
            lc30: 89.5,
            lc10: 49
        },
        "positive.2000": {
            contrast: 39.555205644596,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 44
        },
        "positive.2100": {
            contrast: 45.18177192928963,
            lc60: 100,
            lc45: 99,
            lc30: 71.5,
            lc10: 40
        },
        "positive.2200": {
            contrast: 50.752445030459015,
            lc60: 100,
            lc45: 91,
            lc30: 66,
            lc10: 37
        },
        "positive.2300": {
            contrast: 56.30630564727572,
            lc60: 100,
            lc45: 83.5,
            lc30: 61,
            lc10: 34
        },
        "positive.2400": {
            contrast: 62.241559624081134,
            lc60: 97,
            lc45: 78,
            lc30: 56.5,
            lc10: 32
        },
        "positive.2500": {
            contrast: 68.22456735556064,
            lc60: 90.5,
            lc45: 72.5,
            lc30: 53.5,
            lc10: 30
        }
    },
    "positive.1300": {
        "positive.100": {
            contrast: 47.557266300568834,
            lc60: 100,
            lc45: 79,
            lc30: 47,
            lc10: 23.5
        },
        "positive.200": {
            contrast: 47.103261387075065,
            lc60: 100,
            lc45: 87,
            lc30: 52.5,
            lc10: 26
        },
        "positive.300": {
            contrast: 45.42471403262117,
            lc60: 100,
            lc45: 98,
            lc30: 58.5,
            lc10: 29
        },
        "positive.400": {
            contrast: 42.82780602623772,
            lc60: 100,
            lc45: 100,
            lc30: 65.5,
            lc10: 32.5
        },
        "positive.500": {
            contrast: 39.143274400031444,
            lc60: 100,
            lc45: 100,
            lc30: 73.5,
            lc10: 37
        },
        "positive.600": {
            contrast: 34.14622356738477,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 43.5
        },
        "positive.700": {
            contrast: 29.108101362666396,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51.5
        },
        "positive.800": {
            contrast: 23.73997142843768,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "positive.900": {
            contrast: 18.85286756476318,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81
        },
        "positive.1000": {
            contrast: 14.162633289045987,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1100": {
            contrast: 9.30957086785094,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1500": {
            contrast: 7.721833515608051,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1600": {
            contrast: 12.206042024684171,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1700": {
            contrast: 17.36907539024688,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87
        },
        "positive.1800": {
            contrast: 22.476970098190044,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "positive.1900": {
            contrast: 27.897824147536276,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58.5
        },
        "positive.2000": {
            contrast: 33.176518778632406,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 51.5
        },
        "positive.2100": {
            contrast: 38.80308506332604,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 44.5
        },
        "positive.2200": {
            contrast: 44.37375816449542,
            lc60: 100,
            lc45: 100,
            lc30: 72,
            lc10: 40.5
        },
        "positive.2300": {
            contrast: 49.927618781312134,
            lc60: 100,
            lc45: 92,
            lc30: 65.5,
            lc10: 37
        },
        "positive.2400": {
            contrast: 55.86287275811753,
            lc60: 100,
            lc45: 84,
            lc30: 60.5,
            lc10: 34
        },
        "positive.2500": {
            contrast: 61.84588048959706,
            lc60: 97.5,
            lc45: 78,
            lc30: 56.5,
            lc10: 32.5
        }
    },
    "positive.1400": {
        "positive.100": {
            contrast: 50.903790091423396,
            lc60: 100,
            lc45: 70.5,
            lc30: 44,
            lc10: 22
        },
        "positive.200": {
            contrast: 50.44978517792962,
            lc60: 100,
            lc45: 77,
            lc30: 48,
            lc10: 24
        },
        "positive.300": {
            contrast: 48.77123782347572,
            lc60: 100,
            lc45: 85.5,
            lc30: 53.5,
            lc10: 27
        },
        "positive.400": {
            contrast: 46.17432981709228,
            lc60: 100,
            lc45: 95.5,
            lc30: 59.5,
            lc10: 30
        },
        "positive.500": {
            contrast: 42.489798190886006,
            lc60: 100,
            lc45: 100,
            lc30: 67.5,
            lc10: 34
        },
        "positive.600": {
            contrast: 37.49274735823933,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 39.5
        },
        "positive.700": {
            contrast: 32.45462515352096,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 46
        },
        "positive.800": {
            contrast: 27.08649521929224,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56
        },
        "positive.900": {
            contrast: 22.19939135561774,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "positive.1000": {
            contrast: 17.509157079900547,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85.5
        },
        "positive.1100": {
            contrast: 12.6560946587055,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1200": {
            contrast: 7.60618730003871,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1600": {
            contrast: 8.729374445355425,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1700": {
            contrast: 13.892407810918131,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1800": {
            contrast: 19.000302518861297,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81
        },
        "positive.1900": {
            contrast: 24.421156568207532,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "positive.2000": {
            contrast: 29.699851199303662,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54.5
        },
        "positive.2100": {
            contrast: 35.32641748399729,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 48
        },
        "positive.2200": {
            contrast: 40.89709058516667,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 43.5
        },
        "positive.2300": {
            contrast: 46.450951201983386,
            lc60: 100,
            lc45: 97.5,
            lc30: 69.5,
            lc10: 38.5
        },
        "positive.2400": {
            contrast: 52.38620517878878,
            lc60: 100,
            lc45: 88,
            lc30: 63.5,
            lc10: 36
        },
        "positive.2500": {
            contrast: 58.369212910268296,
            lc60: 100,
            lc45: 81.5,
            lc30: 59,
            lc10: 33
        }
    },
    "positive.1500": {
        "positive.100": {
            contrast: 55.76651463002552,
            lc60: 100,
            lc45: 63,
            lc30: 40.5,
            lc10: 20
        },
        "positive.200": {
            contrast: 55.31250971653176,
            lc60: 100,
            lc45: 69,
            lc30: 44,
            lc10: 22
        },
        "positive.300": {
            contrast: 53.633962362077845,
            lc60: 100,
            lc45: 76.5,
            lc30: 49,
            lc10: 24.5
        },
        "positive.400": {
            contrast: 51.0370543556944,
            lc60: 100,
            lc45: 84,
            lc30: 53.5,
            lc10: 27
        },
        "positive.500": {
            contrast: 47.352522729488136,
            lc60: 100,
            lc45: 94,
            lc30: 59.5,
            lc10: 30.5
        },
        "positive.600": {
            contrast: 42.35547189684146,
            lc60: 100,
            lc45: 100,
            lc30: 68.5,
            lc10: 35
        },
        "positive.700": {
            contrast: 37.31734969212308,
            lc60: 100,
            lc45: 100,
            lc30: 79,
            lc10: 40
        },
        "positive.800": {
            contrast: 31.949219757894365,
            lc60: 100,
            lc45: 100,
            lc30: 93,
            lc10: 46.5
        },
        "positive.900": {
            contrast: 27.06211589421986,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "positive.1000": {
            contrast: 22.371881618502673,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "positive.1100": {
            contrast: 17.518819197307625,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84.5
        },
        "positive.1200": {
            contrast: 12.468911838640834,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1700": {
            contrast: 8.784067876642803,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1800": {
            contrast: 13.891962584585965,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1900": {
            contrast: 19.312816633932204,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80
        },
        "positive.2000": {
            contrast: 24.591511265028334,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "positive.2100": {
            contrast: 30.21807754972196,
            lc60: 100,
            lc45: 100,
            lc30: 98.5,
            lc10: 54.5
        },
        "positive.2200": {
            contrast: 35.788750650891345,
            lc60: 100,
            lc45: 100,
            lc30: 85.5,
            lc10: 48
        },
        "positive.2300": {
            contrast: 41.34261126770806,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 42.5
        },
        "positive.2400": {
            contrast: 47.27786524451346,
            lc60: 100,
            lc45: 96,
            lc30: 69,
            lc10: 38.5
        },
        "positive.2500": {
            contrast: 53.26087297599298,
            lc60: 100,
            lc45: 87,
            lc30: 63,
            lc10: 35.5
        }
    },
    "positive.1600": {
        "positive.100": {
            contrast: 60.061980173423,
            lc60: 96.5,
            lc45: 58,
            lc30: 37.5,
            lc10: 19
        },
        "positive.200": {
            contrast: 59.60797525992923,
            lc60: 100,
            lc45: 63.5,
            lc30: 40.5,
            lc10: 20.5
        },
        "positive.300": {
            contrast: 57.92942790547533,
            lc60: 100,
            lc45: 69.5,
            lc30: 44.5,
            lc10: 22.5
        },
        "positive.400": {
            contrast: 55.33251989909188,
            lc60: 100,
            lc45: 76.5,
            lc30: 49,
            lc10: 25
        },
        "positive.500": {
            contrast: 51.64798827288561,
            lc60: 100,
            lc45: 84.5,
            lc30: 54.5,
            lc10: 27.5
        },
        "positive.600": {
            contrast: 46.650937440238934,
            lc60: 100,
            lc45: 96,
            lc30: 61,
            lc10: 31.5
        },
        "positive.700": {
            contrast: 41.612815235520564,
            lc60: 100,
            lc45: 100,
            lc30: 70,
            lc10: 35
        },
        "positive.800": {
            contrast: 36.24468530129184,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 41
        },
        "positive.900": {
            contrast: 31.357581437617345,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 47
        },
        "positive.1000": {
            contrast: 26.66734716190015,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56
        },
        "positive.1100": {
            contrast: 21.814284740705105,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69.5
        },
        "positive.1200": {
            contrast: 16.76437738203831,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89
        },
        "positive.1300": {
            contrast: 10.51345638895863,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1800": {
            contrast: 9.32692795353633,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1900": {
            contrast: 14.74778200288257,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2000": {
            contrast: 20.026476633978703,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76.5
        },
        "positive.2100": {
            contrast: 25.653042918672327,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "positive.2200": {
            contrast: 31.223716019841707,
            lc60: 100,
            lc45: 100,
            lc30: 96.5,
            lc10: 54
        },
        "positive.2300": {
            contrast: 36.777576636658424,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 46.5
        },
        "positive.2400": {
            contrast: 42.71283061346382,
            lc60: 100,
            lc45: 100,
            lc30: 75,
            lc10: 41.5
        },
        "positive.2500": {
            contrast: 48.69583834494334,
            lc60: 100,
            lc45: 94,
            lc30: 67.5,
            lc10: 38
        }
    },
    "positive.1700": {
        "positive.100": {
            contrast: 64.9720502205043,
            lc60: 76.5,
            lc45: 53.5,
            lc30: 34.5,
            lc10: 17.5
        },
        "positive.200": {
            contrast: 64.51804530701052,
            lc60: 83,
            lc45: 58,
            lc30: 37.5,
            lc10: 19
        },
        "positive.300": {
            contrast: 62.83949795255662,
            lc60: 91,
            lc45: 63,
            lc30: 41,
            lc10: 21
        },
        "positive.400": {
            contrast: 60.242589946173176,
            lc60: 99,
            lc45: 69,
            lc30: 45,
            lc10: 23
        },
        "positive.500": {
            contrast: 56.5580583199669,
            lc60: 100,
            lc45: 75.5,
            lc30: 49,
            lc10: 25.5
        },
        "positive.600": {
            contrast: 51.56100748732023,
            lc60: 100,
            lc45: 85,
            lc30: 55.5,
            lc10: 27.5
        },
        "positive.700": {
            contrast: 46.52288528260185,
            lc60: 100,
            lc45: 95.5,
            lc30: 62,
            lc10: 31.5
        },
        "positive.800": {
            contrast: 41.154755348373136,
            lc60: 100,
            lc45: 100,
            lc30: 70.5,
            lc10: 35.5
        },
        "positive.900": {
            contrast: 36.26765148469863,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 41
        },
        "positive.1000": {
            contrast: 31.57741720898144,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 46.5
        },
        "positive.1100": {
            contrast: 26.724354787786393,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "positive.1200": {
            contrast: 21.674447429119606,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69.5
        },
        "positive.1300": {
            contrast: 15.423526436039925,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98.5
        },
        "positive.1400": {
            contrast: 12.05895377343102,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1900": {
            contrast: 9.472640108639443,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2000": {
            contrast: 14.751334739735574,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2100": {
            contrast: 20.377901024429203,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77.5
        },
        "positive.2200": {
            contrast: 25.948574125598583,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62
        },
        "positive.2300": {
            contrast: 31.502434742415293,
            lc60: 100,
            lc45: 100,
            lc30: 96,
            lc10: 53
        },
        "positive.2400": {
            contrast: 37.437688719220695,
            lc60: 100,
            lc45: 100,
            lc30: 83.5,
            lc10: 46.5
        },
        "positive.2500": {
            contrast: 43.42069645070022,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 40.5
        }
    },
    "positive.1800": {
        "positive.100": {
            contrast: 69.79504028161581,
            lc60: 69.5,
            lc45: 50,
            lc30: 32.5,
            lc10: 16.5
        },
        "positive.200": {
            contrast: 69.34103536812202,
            lc60: 75,
            lc45: 54,
            lc30: 35,
            lc10: 18
        },
        "positive.300": {
            contrast: 67.66248801366814,
            lc60: 81.5,
            lc45: 58,
            lc30: 38,
            lc10: 19.5
        },
        "positive.400": {
            contrast: 65.06558000728468,
            lc60: 88.5,
            lc45: 63.5,
            lc30: 41,
            lc10: 21
        },
        "positive.500": {
            contrast: 61.38104838107841,
            lc60: 97,
            lc45: 69,
            lc30: 45,
            lc10: 23.5
        },
        "positive.600": {
            contrast: 56.38399754843174,
            lc60: 100,
            lc45: 76.5,
            lc30: 50,
            lc10: 25.5
        },
        "positive.700": {
            contrast: 51.34587534371337,
            lc60: 100,
            lc45: 85,
            lc30: 55,
            lc10: 28.5
        },
        "positive.800": {
            contrast: 45.97774540948464,
            lc60: 100,
            lc45: 97.5,
            lc30: 62,
            lc10: 31.5
        },
        "positive.900": {
            contrast: 41.09064154581014,
            lc60: 100,
            lc45: 100,
            lc30: 70,
            lc10: 35
        },
        "positive.1000": {
            contrast: 36.40040727009295,
            lc60: 100,
            lc45: 100,
            lc30: 80.5,
            lc10: 40.5
        },
        "positive.1100": {
            contrast: 31.5473448488979,
            lc60: 100,
            lc45: 100,
            lc30: 94.5,
            lc10: 46
        },
        "positive.1200": {
            contrast: 26.497437490231114,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56
        },
        "positive.1300": {
            contrast: 20.246516497151433,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75
        },
        "positive.1400": {
            contrast: 16.881943834542525,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 90
        },
        "positive.1500": {
            contrast: 11.98694836241252,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1600": {
            contrast: 7.657403325613138,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2000": {
            contrast: 9.513820754927512,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2100": {
            contrast: 15.140387039621139,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 97.5
        },
        "positive.2200": {
            contrast: 20.711060140790522,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76.5
        },
        "positive.2300": {
            contrast: 26.26492075760723,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62
        },
        "positive.2400": {
            contrast: 32.20017473441263,
            lc60: 100,
            lc45: 100,
            lc30: 93.5,
            lc10: 52.5
        },
        "positive.2500": {
            contrast: 38.18318246589215,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 46
        }
    },
    "positive.1900": {
        "positive.100": {
            contrast: 74.8787316996483,
            lc60: 64,
            lc45: 46,
            lc30: 30.5,
            lc10: 15.5
        },
        "positive.200": {
            contrast: 74.42472678615452,
            lc60: 69,
            lc45: 50,
            lc30: 32.5,
            lc10: 16.5
        },
        "positive.300": {
            contrast: 72.74617943170063,
            lc60: 74.5,
            lc45: 53.5,
            lc30: 35,
            lc10: 18
        },
        "positive.400": {
            contrast: 70.14927142531717,
            lc60: 80.5,
            lc45: 58,
            lc30: 38,
            lc10: 19.5
        },
        "positive.500": {
            contrast: 66.4647397991109,
            lc60: 87.5,
            lc45: 63,
            lc30: 41,
            lc10: 21
        },
        "positive.600": {
            contrast: 61.46768896646424,
            lc60: 96.5,
            lc45: 69.5,
            lc30: 45,
            lc10: 23
        },
        "positive.700": {
            contrast: 56.42956676174585,
            lc60: 100,
            lc45: 76.5,
            lc30: 49.5,
            lc10: 25
        },
        "positive.800": {
            contrast: 51.061436827517134,
            lc60: 100,
            lc45: 86,
            lc30: 55,
            lc10: 28.5
        },
        "positive.900": {
            contrast: 46.17433296384264,
            lc60: 100,
            lc45: 96.5,
            lc30: 61.5,
            lc10: 31.5
        },
        "positive.1000": {
            contrast: 41.48409868812544,
            lc60: 100,
            lc45: 100,
            lc30: 69.5,
            lc10: 34.5
        },
        "positive.1100": {
            contrast: 36.631036266930394,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 40
        },
        "positive.1200": {
            contrast: 31.581128908263604,
            lc60: 100,
            lc45: 100,
            lc30: 94.5,
            lc10: 46
        },
        "positive.1300": {
            contrast: 25.330207915183923,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59
        },
        "positive.1400": {
            contrast: 21.965635252575023,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68.5
        },
        "positive.1500": {
            contrast: 17.070639780445017,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89
        },
        "positive.1600": {
            contrast: 12.74109474364563,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1700": {
            contrast: 7.786098762416592,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2100": {
            contrast: 9.562978696034136,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2200": {
            contrast: 15.133651797203518,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 99
        },
        "positive.2300": {
            contrast: 20.687512414020233,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76.5
        },
        "positive.2400": {
            contrast: 26.622766390825632,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61.5
        },
        "positive.2500": {
            contrast: 32.60577412230516,
            lc60: 100,
            lc45: 100,
            lc30: 93,
            lc10: 52
        }
    },
    "positive.2000": {
        "positive.100": {
            contrast: 79.79714915796265,
            lc60: 59.5,
            lc45: 43.5,
            lc30: 28.5,
            lc10: 14.5
        },
        "positive.200": {
            contrast: 79.34314424446887,
            lc60: 64,
            lc45: 46,
            lc30: 30.5,
            lc10: 15.5
        },
        "positive.300": {
            contrast: 77.66459689001496,
            lc60: 69,
            lc45: 50,
            lc30: 32.5,
            lc10: 17
        },
        "positive.400": {
            contrast: 75.06768888363152,
            lc60: 74,
            lc45: 53.5,
            lc30: 35.5,
            lc10: 18.5
        },
        "positive.500": {
            contrast: 71.38315725742524,
            lc60: 80,
            lc45: 58,
            lc30: 38,
            lc10: 19.5
        },
        "positive.600": {
            contrast: 66.38610642477859,
            lc60: 87.5,
            lc45: 63,
            lc30: 41.5,
            lc10: 21.5
        },
        "positive.700": {
            contrast: 61.347984220060205,
            lc60: 97,
            lc45: 69,
            lc30: 45.5,
            lc10: 23
        },
        "positive.800": {
            contrast: 55.979854285831486,
            lc60: 100,
            lc45: 77,
            lc30: 50,
            lc10: 25.5
        },
        "positive.900": {
            contrast: 51.09275042215698,
            lc60: 100,
            lc45: 85.5,
            lc30: 54.5,
            lc10: 28.5
        },
        "positive.1000": {
            contrast: 46.402516146439794,
            lc60: 100,
            lc45: 96,
            lc30: 60.5,
            lc10: 31
        },
        "positive.1100": {
            contrast: 41.549453725244746,
            lc60: 100,
            lc45: 100,
            lc30: 69,
            lc10: 34
        },
        "positive.1200": {
            contrast: 36.49954636657795,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 40
        },
        "positive.1300": {
            contrast: 30.24862537349827,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 48.5
        },
        "positive.1400": {
            contrast: 26.884052710889367,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "positive.1500": {
            contrast: 21.98905723875936,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68.5
        },
        "positive.1600": {
            contrast: 17.659512201959977,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85.5
        },
        "positive.1700": {
            contrast: 12.704516220730941,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1800": {
            contrast: 7.831587465434431,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2200": {
            contrast: 9.684894432467082,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2300": {
            contrast: 15.238755049283794,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 97
        },
        "positive.2400": {
            contrast: 21.174009026089198,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75.5
        },
        "positive.2500": {
            contrast: 27.157016757568712,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61
        }
    },
    "positive.2100": {
        "positive.100": {
            contrast: 85.0073982655697,
            lc60: 55.5,
            lc45: 40.5,
            lc30: 27,
            lc10: 14
        },
        "positive.200": {
            contrast: 84.55339335207593,
            lc60: 59.5,
            lc45: 43.5,
            lc30: 28.5,
            lc10: 15
        },
        "positive.300": {
            contrast: 82.87484599762203,
            lc60: 63.5,
            lc45: 46.5,
            lc30: 30.5,
            lc10: 16
        },
        "positive.400": {
            contrast: 80.27793799123859,
            lc60: 68,
            lc45: 49.5,
            lc30: 32.5,
            lc10: 17
        },
        "positive.500": {
            contrast: 76.59340636503231,
            lc60: 73.5,
            lc45: 53,
            lc30: 35,
            lc10: 18
        },
        "positive.600": {
            contrast: 71.59635553238564,
            lc60: 79.5,
            lc45: 58,
            lc30: 38,
            lc10: 20
        },
        "positive.700": {
            contrast: 66.55823332766727,
            lc60: 87.5,
            lc45: 63,
            lc30: 41,
            lc10: 21
        },
        "positive.800": {
            contrast: 61.19010339343854,
            lc60: 97,
            lc45: 69.5,
            lc30: 45,
            lc10: 23
        },
        "positive.900": {
            contrast: 56.302999529764044,
            lc60: 100,
            lc45: 75.5,
            lc30: 49,
            lc10: 25
        },
        "positive.1000": {
            contrast: 51.612765254046856,
            lc60: 100,
            lc45: 84.5,
            lc30: 53.5,
            lc10: 27.5
        },
        "positive.1100": {
            contrast: 46.75970283285181,
            lc60: 100,
            lc45: 95,
            lc30: 60.5,
            lc10: 30.5
        },
        "positive.1200": {
            contrast: 41.70979547418502,
            lc60: 100,
            lc45: 100,
            lc30: 68.5,
            lc10: 34
        },
        "positive.1300": {
            contrast: 35.45887448110533,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 41
        },
        "positive.1400": {
            contrast: 32.094301818496426,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 46
        },
        "positive.1500": {
            contrast: 27.199306346366427,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54.5
        },
        "positive.1600": {
            contrast: 22.869761309567046,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65
        },
        "positive.1700": {
            contrast: 17.914765328338007,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85
        },
        "positive.1800": {
            contrast: 13.041836573041495,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1900": {
            contrast: 7.899663312594904,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2300": {
            contrast: 9.412945683424805,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2400": {
            contrast: 15.348199660230208,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 96.5
        },
        "positive.2500": {
            contrast: 21.33120739170973,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74
        }
    },
    "positive.2200": {
        "positive.100": {
            contrast: 90.13522703779137,
            lc60: 52,
            lc45: 38,
            lc30: 25.5,
            lc10: 13
        },
        "positive.200": {
            contrast: 89.68122212429759,
            lc60: 55.5,
            lc45: 41,
            lc30: 27,
            lc10: 14
        },
        "positive.300": {
            contrast: 88.0026747698437,
            lc60: 59.5,
            lc45: 43.5,
            lc30: 28.5,
            lc10: 15
        },
        "positive.400": {
            contrast: 85.40576676346025,
            lc60: 63.5,
            lc45: 46.5,
            lc30: 30.5,
            lc10: 16
        },
        "positive.500": {
            contrast: 81.72123513725397,
            lc60: 67.5,
            lc45: 49,
            lc30: 32.5,
            lc10: 17
        },
        "positive.600": {
            contrast: 76.7241843046073,
            lc60: 73,
            lc45: 53.5,
            lc30: 35,
            lc10: 18.5
        },
        "positive.700": {
            contrast: 71.68606209988891,
            lc60: 80,
            lc45: 57.5,
            lc30: 38,
            lc10: 19.5
        },
        "positive.800": {
            contrast: 66.3179321656602,
            lc60: 87.5,
            lc45: 62.5,
            lc30: 40.5,
            lc10: 21
        },
        "positive.900": {
            contrast: 61.4308283019857,
            lc60: 97,
            lc45: 68.5,
            lc30: 44.5,
            lc10: 22.5
        },
        "positive.1000": {
            contrast: 56.74059402626851,
            lc60: 100,
            lc45: 74.5,
            lc30: 48,
            lc10: 24.5
        },
        "positive.1100": {
            contrast: 51.887531605073455,
            lc60: 100,
            lc45: 83.5,
            lc30: 53,
            lc10: 27
        },
        "positive.1200": {
            contrast: 46.83762424640667,
            lc60: 100,
            lc45: 94.5,
            lc30: 60,
            lc10: 30
        },
        "positive.1300": {
            contrast: 40.58670325332699,
            lc60: 100,
            lc45: 100,
            lc30: 70.5,
            lc10: 35.5
        },
        "positive.1400": {
            contrast: 37.22213059071808,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 38.5
        },
        "positive.1500": {
            contrast: 32.327135118588075,
            lc60: 100,
            lc45: 100,
            lc30: 91.5,
            lc10: 46
        },
        "positive.1600": {
            contrast: 27.997590081788694,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54
        },
        "positive.1700": {
            contrast: 23.042594100559658,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65
        },
        "positive.1800": {
            contrast: 18.169665345263148,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83.5
        },
        "positive.1900": {
            contrast: 13.027492084816556,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2000": {
            contrast: 8.047121016003276,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2400": {
            contrast: 9.56304414108474,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2500": {
            contrast: 15.546051872564263,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 96
        }
    },
    "positive.2300": {
        "positive.100": {
            contrast: 95.21913219519756,
            lc60: 49,
            lc45: 36,
            lc30: 24,
            lc10: 12.5
        },
        "positive.200": {
            contrast: 94.7651272817038,
            lc60: 52,
            lc45: 38,
            lc30: 25.5,
            lc10: 13.5
        },
        "positive.300": {
            contrast: 93.08657992724989,
            lc60: 55.5,
            lc45: 40.5,
            lc30: 27,
            lc10: 14
        },
        "positive.400": {
            contrast: 90.48967192086644,
            lc60: 59,
            lc45: 43,
            lc30: 28.5,
            lc10: 15
        },
        "positive.500": {
            contrast: 86.80514029466016,
            lc60: 63,
            lc45: 46,
            lc30: 30.5,
            lc10: 16
        },
        "positive.600": {
            contrast: 81.80808946201351,
            lc60: 67.5,
            lc45: 49.5,
            lc30: 33,
            lc10: 17
        },
        "positive.700": {
            contrast: 76.76996725729512,
            lc60: 72.5,
            lc45: 53,
            lc30: 34.5,
            lc10: 18.5
        },
        "positive.800": {
            contrast: 71.4018373230664,
            lc60: 80,
            lc45: 57.5,
            lc30: 37.5,
            lc10: 19.5
        },
        "positive.900": {
            contrast: 66.51473345939189,
            lc60: 86.5,
            lc45: 62,
            lc30: 40,
            lc10: 21
        },
        "positive.1000": {
            contrast: 61.82449918367471,
            lc60: 96,
            lc45: 67,
            lc30: 43.5,
            lc10: 22.5
        },
        "positive.1100": {
            contrast: 56.971436762479655,
            lc60: 100,
            lc45: 74,
            lc30: 47.5,
            lc10: 24
        },
        "positive.1200": {
            contrast: 51.92152940381287,
            lc60: 100,
            lc45: 83.5,
            lc30: 53,
            lc10: 27
        },
        "positive.1300": {
            contrast: 45.670608410733195,
            lc60: 100,
            lc45: 98,
            lc30: 62,
            lc10: 31
        },
        "positive.1400": {
            contrast: 42.30603574812429,
            lc60: 100,
            lc45: 100,
            lc30: 67.5,
            lc10: 34.5
        },
        "positive.1500": {
            contrast: 37.41104027599428,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 38.5
        },
        "positive.1600": {
            contrast: 33.08149523919489,
            lc60: 100,
            lc45: 100,
            lc30: 89,
            lc10: 45
        },
        "positive.1700": {
            contrast: 28.126499257965857,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 52.5
        },
        "positive.1800": {
            contrast: 23.253570502669348,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65
        },
        "positive.1900": {
            contrast: 18.11139724222276,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82.5
        },
        "positive.2000": {
            contrast: 13.131026173409483,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2100": {
            contrast: 7.849710800194935,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2500": {
            contrast: 9.762242403476714,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "positive.2400": {
        "positive.100": {
            contrast: 100.6226721112042,
            lc60: 46.5,
            lc45: 34,
            lc30: 22.5,
            lc10: 12
        },
        "positive.200": {
            contrast: 100.16866719771042,
            lc60: 49.5,
            lc45: 36,
            lc30: 24,
            lc10: 12.5
        },
        "positive.300": {
            contrast: 98.49011984325652,
            lc60: 52,
            lc45: 38.5,
            lc30: 25.5,
            lc10: 13
        },
        "positive.400": {
            contrast: 95.89321183687306,
            lc60: 55,
            lc45: 40.5,
            lc30: 27,
            lc10: 14
        },
        "positive.500": {
            contrast: 92.2086802106668,
            lc60: 58,
            lc45: 43,
            lc30: 28.5,
            lc10: 15
        },
        "positive.600": {
            contrast: 87.21162937802013,
            lc60: 62.5,
            lc45: 45.5,
            lc30: 30.5,
            lc10: 16
        },
        "positive.700": {
            contrast: 82.17350717330174,
            lc60: 67,
            lc45: 49,
            lc30: 32.5,
            lc10: 17
        },
        "positive.800": {
            contrast: 76.80537723907302,
            lc60: 72,
            lc45: 52.5,
            lc30: 34.5,
            lc10: 18
        },
        "positive.900": {
            contrast: 71.91827337539853,
            lc60: 78.5,
            lc45: 56,
            lc30: 36.5,
            lc10: 19
        },
        "positive.1000": {
            contrast: 67.22803909968134,
            lc60: 85,
            lc45: 60.5,
            lc30: 39,
            lc10: 20.5
        },
        "positive.1100": {
            contrast: 62.374976678486284,
            lc60: 94.5,
            lc45: 66,
            lc30: 42.5,
            lc10: 22
        },
        "positive.1200": {
            contrast: 57.3250693198195,
            lc60: 100,
            lc45: 73.5,
            lc30: 47,
            lc10: 23.5
        },
        "positive.1300": {
            contrast: 51.07414832673981,
            lc60: 100,
            lc45: 85.5,
            lc30: 54,
            lc10: 27.5
        },
        "positive.1400": {
            contrast: 47.70957566413091,
            lc60: 100,
            lc45: 92,
            lc30: 58.5,
            lc10: 29.5
        },
        "positive.1500": {
            contrast: 42.8145801920009,
            lc60: 100,
            lc45: 100,
            lc30: 66.5,
            lc10: 34
        },
        "positive.1600": {
            contrast: 38.485035155201516,
            lc60: 100,
            lc45: 100,
            lc30: 75,
            lc10: 38
        },
        "positive.1700": {
            contrast: 33.53003917397248,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 44.5
        },
        "positive.1800": {
            contrast: 28.657110418675973,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 52
        },
        "positive.1900": {
            contrast: 23.514937158229383,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65
        },
        "positive.2000": {
            contrast: 18.534566089416103,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80.5
        },
        "positive.2100": {
            contrast: 13.25325071620156,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2200": {
            contrast: 8.050312407977803,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "positive.2500": {
        "positive.100": {
            contrast: 106.04067321268862,
            lc60: 44,
            lc45: 32.5,
            lc30: 21.5,
            lc10: 11.5
        },
        "positive.200": {
            contrast: 105.58666829919483,
            lc60: 46.5,
            lc45: 34.5,
            lc30: 23,
            lc10: 12
        },
        "positive.300": {
            contrast: 103.90812094474093,
            lc60: 49,
            lc45: 36.5,
            lc30: 24,
            lc10: 12.5
        },
        "positive.400": {
            contrast: 101.3112129383575,
            lc60: 52,
            lc45: 38,
            lc30: 25.5,
            lc10: 13.5
        },
        "positive.500": {
            contrast: 97.6266813121512,
            lc60: 54.5,
            lc45: 40,
            lc30: 27,
            lc10: 14
        },
        "positive.600": {
            contrast: 92.62963047950453,
            lc60: 58,
            lc45: 43,
            lc30: 28.5,
            lc10: 15
        },
        "positive.700": {
            contrast: 87.59150827478615,
            lc60: 62,
            lc45: 45,
            lc30: 30,
            lc10: 15.5
        },
        "positive.800": {
            contrast: 82.22337834055745,
            lc60: 66,
            lc45: 48.5,
            lc30: 32,
            lc10: 16.5
        },
        "positive.900": {
            contrast: 77.33627447688292,
            lc60: 71,
            lc45: 51,
            lc30: 33.5,
            lc10: 17.5
        },
        "positive.1000": {
            contrast: 72.64604020116575,
            lc60: 76.5,
            lc45: 54.5,
            lc30: 35.5,
            lc10: 18.5
        },
        "positive.1100": {
            contrast: 67.79297777997068,
            lc60: 84,
            lc45: 59.5,
            lc30: 38.5,
            lc10: 20
        },
        "positive.1200": {
            contrast: 62.743070421303905,
            lc60: 93,
            lc45: 65.5,
            lc30: 42,
            lc10: 21.5
        },
        "positive.1300": {
            contrast: 56.492149428224224,
            lc60: 100,
            lc45: 74.5,
            lc30: 48,
            lc10: 24.5
        },
        "positive.1400": {
            contrast: 53.127576765615316,
            lc60: 100,
            lc45: 81,
            lc30: 51.5,
            lc10: 26.5
        },
        "positive.1500": {
            contrast: 48.23258129348531,
            lc60: 100,
            lc45: 91.5,
            lc30: 57.5,
            lc10: 29.5
        },
        "positive.1600": {
            contrast: 43.90303625668593,
            lc60: 100,
            lc45: 100,
            lc30: 65,
            lc10: 33
        },
        "positive.1700": {
            contrast: 38.94804027545689,
            lc60: 100,
            lc45: 100,
            lc30: 75,
            lc10: 37.5
        },
        "positive.1800": {
            contrast: 34.07511152016038,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 44
        },
        "positive.1900": {
            contrast: 28.932938259713787,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51
        },
        "positive.2000": {
            contrast: 23.952567190900513,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63.5
        },
        "positive.2100": {
            contrast: 18.671251817685967,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81.5
        },
        "positive.2200": {
            contrast: 13.46831350946221,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2300": {
            contrast: 8.305142526869119,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    }
};
const $f8fd43f1ee3f8cd8$var$reliance = {
    "reliance.100": {
        "reliance.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.600": {
            contrast: 7.856643854144956,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.700": {
            contrast: 10.835876369540113,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.800": {
            contrast: 14.461056514547963,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.900": {
            contrast: 18.825147752500566,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89
        },
        "reliance.1000": {
            contrast: 24.024746134650535,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78.5
        },
        "reliance.1100": {
            contrast: 28.705247513560998,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "reliance.1200": {
            contrast: 34.50998246018645,
            lc60: 100,
            lc45: 100,
            lc30: 92.5,
            lc10: 64.5
        },
        "reliance.1300": {
            contrast: 39.6611094790222,
            lc60: 100,
            lc45: 100,
            lc30: 85,
            lc10: 59
        },
        "reliance.1400": {
            contrast: 44.4883124407606,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 55.5
        },
        "reliance.1500": {
            contrast: 49.367323646410895,
            lc60: 100,
            lc45: 94,
            lc30: 74.5,
            lc10: 52
        },
        "reliance.1600": {
            contrast: 54.46688804543418,
            lc60: 100,
            lc45: 89,
            lc30: 70.5,
            lc10: 49
        },
        "reliance.1700": {
            contrast: 59.53586860247893,
            lc60: 100,
            lc45: 84,
            lc30: 67,
            lc10: 46.5
        },
        "reliance.1800": {
            contrast: 65.26618283360766,
            lc60: 94.5,
            lc45: 79.5,
            lc30: 63,
            lc10: 44
        },
        "reliance.1900": {
            contrast: 70.74266391151131,
            lc60: 90.5,
            lc45: 75.5,
            lc30: 60,
            lc10: 42
        },
        "reliance.2000": {
            contrast: 76.54055396842463,
            lc60: 86,
            lc45: 72.5,
            lc30: 57,
            lc10: 40
        },
        "reliance.2100": {
            contrast: 82.55763905828711,
            lc60: 82,
            lc45: 69,
            lc30: 54.5,
            lc10: 38
        },
        "reliance.2200": {
            contrast: 88.66270486383215,
            lc60: 78.5,
            lc45: 66,
            lc30: 52,
            lc10: 36.5
        },
        "reliance.2300": {
            contrast: 94.62567466648164,
            lc60: 75,
            lc45: 63,
            lc30: 50,
            lc10: 35
        },
        "reliance.2400": {
            contrast: 101.09702089769303,
            lc60: 72,
            lc45: 60.5,
            lc30: 48,
            lc10: 33.5
        },
        "reliance.2500": {
            contrast: 107.88473318309848,
            lc60: 69,
            lc45: 58,
            lc30: 46,
            lc10: 32
        }
    },
    "reliance.200": {
        "reliance.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.600": {
            contrast: 7.341036864282781,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.700": {
            contrast: 10.320269379677939,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.800": {
            contrast: 13.945449524685788,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.900": {
            contrast: 18.30954076263839,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89
        },
        "reliance.1000": {
            contrast: 23.509139144788357,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76.5
        },
        "reliance.1100": {
            contrast: 28.189640523698824,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68.5
        },
        "reliance.1200": {
            contrast: 33.99437547032427,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 61
        },
        "reliance.1300": {
            contrast: 39.14550248916002,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 56
        },
        "reliance.1400": {
            contrast: 43.97270545089843,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 52.5
        },
        "reliance.1500": {
            contrast: 48.851716656548724,
            lc60: 100,
            lc45: 94.5,
            lc30: 73.5,
            lc10: 49
        },
        "reliance.1600": {
            contrast: 53.951281055572,
            lc60: 100,
            lc45: 88.5,
            lc30: 69,
            lc10: 46
        },
        "reliance.1700": {
            contrast: 59.02026161261675,
            lc60: 100,
            lc45: 84,
            lc30: 65,
            lc10: 44
        },
        "reliance.1800": {
            contrast: 64.75057584374548,
            lc60: 95,
            lc45: 79,
            lc30: 61.5,
            lc10: 41
        },
        "reliance.1900": {
            contrast: 70.22705692164915,
            lc60: 90,
            lc45: 75,
            lc30: 58.5,
            lc10: 39.5
        },
        "reliance.2000": {
            contrast: 76.02494697856244,
            lc60: 85.5,
            lc45: 71.5,
            lc30: 55.5,
            lc10: 37.5
        },
        "reliance.2100": {
            contrast: 82.04203206842493,
            lc60: 81.5,
            lc45: 68,
            lc30: 53,
            lc10: 35.5
        },
        "reliance.2200": {
            contrast: 88.14709787396997,
            lc60: 77.5,
            lc45: 65,
            lc30: 50.5,
            lc10: 34
        },
        "reliance.2300": {
            contrast: 94.11006767661945,
            lc60: 74.5,
            lc45: 62.5,
            lc30: 48.5,
            lc10: 32.5
        },
        "reliance.2400": {
            contrast: 100.58141390783086,
            lc60: 71.5,
            lc45: 59.5,
            lc30: 46.5,
            lc10: 31.5
        },
        "reliance.2500": {
            contrast: 107.36912619323628,
            lc60: 68.5,
            lc45: 57,
            lc30: 44.5,
            lc10: 30
        }
    },
    "reliance.300": {
        "reliance.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.700": {
            contrast: 8.95440937668147,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.800": {
            contrast: 12.579589521689321,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.900": {
            contrast: 16.94368075964193,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93
        },
        "reliance.1000": {
            contrast: 22.14327914179189,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78.5
        },
        "reliance.1100": {
            contrast: 26.82378052070235,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69.5
        },
        "reliance.1200": {
            contrast: 32.6285154673278,
            lc60: 100,
            lc45: 100,
            lc30: 94.5,
            lc10: 62
        },
        "reliance.1300": {
            contrast: 37.77964248616355,
            lc60: 100,
            lc45: 100,
            lc30: 85.5,
            lc10: 56
        },
        "reliance.1400": {
            contrast: 42.606845447901954,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 52.5
        },
        "reliance.1500": {
            contrast: 47.48585665355225,
            lc60: 100,
            lc45: 96.5,
            lc30: 74.5,
            lc10: 49
        },
        "reliance.1600": {
            contrast: 52.58542105257553,
            lc60: 100,
            lc45: 90,
            lc30: 70,
            lc10: 46
        },
        "reliance.1700": {
            contrast: 57.65440160962028,
            lc60: 100,
            lc45: 85.5,
            lc30: 65.5,
            lc10: 43.5
        },
        "reliance.1800": {
            contrast: 63.38471584074901,
            lc60: 96,
            lc45: 80,
            lc30: 62,
            lc10: 41
        },
        "reliance.1900": {
            contrast: 68.86119691865267,
            lc60: 91,
            lc45: 76,
            lc30: 59,
            lc10: 39
        },
        "reliance.2000": {
            contrast: 74.65908697556598,
            lc60: 86.5,
            lc45: 72,
            lc30: 56,
            lc10: 37.5
        },
        "reliance.2100": {
            contrast: 80.67617206542846,
            lc60: 82.5,
            lc45: 68.5,
            lc30: 53.5,
            lc10: 35.5
        },
        "reliance.2200": {
            contrast: 86.7812378709735,
            lc60: 78.5,
            lc45: 65.5,
            lc30: 51,
            lc10: 34
        },
        "reliance.2300": {
            contrast: 92.744207673623,
            lc60: 75,
            lc45: 63,
            lc30: 49,
            lc10: 32.5
        },
        "reliance.2400": {
            contrast: 99.21555390483438,
            lc60: 72,
            lc45: 60,
            lc30: 47,
            lc10: 31.5
        },
        "reliance.2500": {
            contrast: 106.00326619023983,
            lc60: 69,
            lc45: 57.5,
            lc30: 45,
            lc10: 30
        }
    },
    "reliance.400": {
        "reliance.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.800": {
            contrast: 10.883582980947978,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.900": {
            contrast: 15.247674218900581,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 99
        },
        "reliance.1000": {
            contrast: 20.44727260105055,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81.5
        },
        "reliance.1100": {
            contrast: 25.12777397996101,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "reliance.1200": {
            contrast: 30.932508926586454,
            lc60: 100,
            lc45: 100,
            lc30: 97.5,
            lc10: 62
        },
        "reliance.1300": {
            contrast: 36.08363594542221,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 56.5
        },
        "reliance.1400": {
            contrast: 40.91083890716061,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 52.5
        },
        "reliance.1500": {
            contrast: 45.78985011281091,
            lc60: 100,
            lc45: 98.5,
            lc30: 75.5,
            lc10: 49
        },
        "reliance.1600": {
            contrast: 50.88941451183418,
            lc60: 100,
            lc45: 92,
            lc30: 71,
            lc10: 45.5
        },
        "reliance.1700": {
            contrast: 55.95839506887893,
            lc60: 100,
            lc45: 86.5,
            lc30: 66.5,
            lc10: 43.5
        },
        "reliance.1800": {
            contrast: 61.68870930000766,
            lc60: 97.5,
            lc45: 81,
            lc30: 62.5,
            lc10: 40.5
        },
        "reliance.1900": {
            contrast: 67.16519037791133,
            lc60: 92.5,
            lc45: 77,
            lc30: 59.5,
            lc10: 38.5
        },
        "reliance.2000": {
            contrast: 72.96308043482463,
            lc60: 87.5,
            lc45: 73,
            lc30: 56.5,
            lc10: 37
        },
        "reliance.2100": {
            contrast: 78.98016552468711,
            lc60: 83.5,
            lc45: 69.5,
            lc30: 53.5,
            lc10: 35
        },
        "reliance.2200": {
            contrast: 85.08523133023216,
            lc60: 79.5,
            lc45: 66,
            lc30: 51,
            lc10: 33.5
        },
        "reliance.2300": {
            contrast: 91.04820113288164,
            lc60: 76,
            lc45: 63,
            lc30: 49,
            lc10: 32
        },
        "reliance.2400": {
            contrast: 97.51954736409304,
            lc60: 72.5,
            lc45: 60,
            lc30: 47,
            lc10: 30.5
        },
        "reliance.2500": {
            contrast: 104.30725964949848,
            lc60: 69.5,
            lc45: 57.5,
            lc30: 44.5,
            lc10: 29.5
        }
    },
    "reliance.500": {
        "reliance.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.800": {
            contrast: 8.517088332861753,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.900": {
            contrast: 12.881179570814357,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1000": {
            contrast: 18.080777952964322,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86.5
        },
        "reliance.1100": {
            contrast: 22.761279331874785,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "reliance.1200": {
            contrast: 28.56601427850023,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63
        },
        "reliance.1300": {
            contrast: 33.717141297335985,
            lc60: 100,
            lc45: 100,
            lc30: 91.5,
            lc10: 56.5
        },
        "reliance.1400": {
            contrast: 38.544344259074386,
            lc60: 100,
            lc45: 100,
            lc30: 83.5,
            lc10: 52
        },
        "reliance.1500": {
            contrast: 43.423355464724686,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 47.5
        },
        "reliance.1600": {
            contrast: 48.52291986374796,
            lc60: 100,
            lc45: 94.5,
            lc30: 71.5,
            lc10: 44.5
        },
        "reliance.1700": {
            contrast: 53.591900420792705,
            lc60: 100,
            lc45: 88.5,
            lc30: 66.5,
            lc10: 42
        },
        "reliance.1800": {
            contrast: 59.322214651921435,
            lc60: 100,
            lc45: 82.5,
            lc30: 63,
            lc10: 39
        },
        "reliance.1900": {
            contrast: 64.79869572982511,
            lc60: 95,
            lc45: 78,
            lc30: 59,
            lc10: 37
        },
        "reliance.2000": {
            contrast: 70.5965857867384,
            lc60: 89.5,
            lc45: 73.5,
            lc30: 56,
            lc10: 35.5
        },
        "reliance.2100": {
            contrast: 76.61367087660088,
            lc60: 84.5,
            lc45: 69.5,
            lc30: 53,
            lc10: 33.5
        },
        "reliance.2200": {
            contrast: 82.71873668214593,
            lc60: 80,
            lc45: 66,
            lc30: 50,
            lc10: 32
        },
        "reliance.2300": {
            contrast: 88.68170648479541,
            lc60: 76.5,
            lc45: 63,
            lc30: 48,
            lc10: 30.5
        },
        "reliance.2400": {
            contrast: 95.1530527160068,
            lc60: 73,
            lc45: 60,
            lc30: 46,
            lc10: 29
        },
        "reliance.2500": {
            contrast: 101.94076500141225,
            lc60: 69.5,
            lc45: 57.5,
            lc30: 44,
            lc10: 28
        }
    },
    "reliance.600": {
        "reliance.100": {
            contrast: 9.159734176051897,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.200": {
            contrast: 8.469581752447437,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.900": {
            contrast: 9.617962314912052,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1000": {
            contrast: 14.817560697062019,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1100": {
            contrast: 19.498062075972484,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82
        },
        "reliance.1200": {
            contrast: 25.30279702259793,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68.5
        },
        "reliance.1300": {
            contrast: 30.453924041433684,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 59.5
        },
        "reliance.1400": {
            contrast: 35.28112700317209,
            lc60: 100,
            lc45: 100,
            lc30: 89,
            lc10: 54
        },
        "reliance.1500": {
            contrast: 40.16013820882238,
            lc60: 100,
            lc45: 100,
            lc30: 80.5,
            lc10: 49
        },
        "reliance.1600": {
            contrast: 45.25970260784566,
            lc60: 100,
            lc45: 99.5,
            lc30: 74.5,
            lc10: 45.5
        },
        "reliance.1700": {
            contrast: 50.32868316489041,
            lc60: 100,
            lc45: 92,
            lc30: 69,
            lc10: 42
        },
        "reliance.1800": {
            contrast: 56.05899739601914,
            lc60: 100,
            lc45: 85.5,
            lc30: 64.5,
            lc10: 39.5
        },
        "reliance.1900": {
            contrast: 61.5354784739228,
            lc60: 98,
            lc45: 80,
            lc30: 60.5,
            lc10: 37
        },
        "reliance.2000": {
            contrast: 67.33336853083611,
            lc60: 92,
            lc45: 75,
            lc30: 57,
            lc10: 35
        },
        "reliance.2100": {
            contrast: 73.35045362069859,
            lc60: 86.5,
            lc45: 71,
            lc30: 53.5,
            lc10: 33
        },
        "reliance.2200": {
            contrast: 79.45551942624363,
            lc60: 82,
            lc45: 67,
            lc30: 51,
            lc10: 31.5
        },
        "reliance.2300": {
            contrast: 85.41848922889312,
            lc60: 78.5,
            lc45: 64,
            lc30: 48.5,
            lc10: 30.5
        },
        "reliance.2400": {
            contrast: 91.8898354601045,
            lc60: 74.5,
            lc45: 61,
            lc30: 46,
            lc10: 29
        },
        "reliance.2500": {
            contrast: 98.67754774550995,
            lc60: 70.5,
            lc45: 58,
            lc30: 44,
            lc10: 27.5
        }
    },
    "reliance.700": {
        "reliance.100": {
            contrast: 12.425150850610489,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.200": {
            contrast: 11.734998427006033,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.300": {
            contrast: 9.956655422166113,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.400": {
            contrast: 7.825124480429977,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1000": {
            contrast: 11.98217678016585,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1100": {
            contrast: 16.662678159076314,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91.5
        },
        "reliance.1200": {
            contrast: 22.467413105701763,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "reliance.1300": {
            contrast: 27.61854012453751,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63
        },
        "reliance.1400": {
            contrast: 32.44574308627592,
            lc60: 100,
            lc45: 100,
            lc30: 94,
            lc10: 56.5
        },
        "reliance.1500": {
            contrast: 37.32475429192621,
            lc60: 100,
            lc45: 100,
            lc30: 85.5,
            lc10: 50.5
        },
        "reliance.1600": {
            contrast: 42.424318690949484,
            lc60: 100,
            lc45: 100,
            lc30: 77.5,
            lc10: 47
        },
        "reliance.1700": {
            contrast: 47.49329924799424,
            lc60: 100,
            lc45: 96,
            lc30: 71.5,
            lc10: 43
        },
        "reliance.1800": {
            contrast: 53.22361347912297,
            lc60: 100,
            lc45: 88.5,
            lc30: 66.5,
            lc10: 39.5
        },
        "reliance.1900": {
            contrast: 58.70009455702663,
            lc60: 100,
            lc45: 82.5,
            lc30: 62,
            lc10: 37.5
        },
        "reliance.2000": {
            contrast: 64.49798461393993,
            lc60: 95,
            lc45: 77.5,
            lc30: 58,
            lc10: 35.5
        },
        "reliance.2100": {
            contrast: 70.51506970380241,
            lc60: 89,
            lc45: 72.5,
            lc30: 54.5,
            lc10: 33
        },
        "reliance.2200": {
            contrast: 76.62013550934745,
            lc60: 84,
            lc45: 68.5,
            lc30: 51.5,
            lc10: 31.5
        },
        "reliance.2300": {
            contrast: 82.58310531199696,
            lc60: 80,
            lc45: 65,
            lc30: 49,
            lc10: 30
        },
        "reliance.2400": {
            contrast: 89.05445154320834,
            lc60: 76,
            lc45: 61.5,
            lc30: 46.5,
            lc10: 28.5
        },
        "reliance.2500": {
            contrast: 95.84216382861376,
            lc60: 71.5,
            lc45: 58.5,
            lc30: 44,
            lc10: 27
        }
    },
    "reliance.800": {
        "reliance.100": {
            contrast: 16.32482826475614,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "reliance.200": {
            contrast: 15.63467584115168,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 90
        },
        "reliance.300": {
            contrast: 13.856332836311763,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.400": {
            contrast: 11.724801894575629,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.500": {
            contrast: 8.853209290266378,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1000": {
            contrast: 8.499568335620138,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1100": {
            contrast: 13.180069714530601,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1200": {
            contrast: 18.98480466115605,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82.5
        },
        "reliance.1300": {
            contrast: 24.135931679991803,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "reliance.1400": {
            contrast: 28.963134641730203,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "reliance.1500": {
            contrast: 33.8421458473805,
            lc60: 100,
            lc45: 100,
            lc30: 90.5,
            lc10: 53.5
        },
        "reliance.1600": {
            contrast: 38.94171024640378,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 48
        },
        "reliance.1700": {
            contrast: 44.010690803448526,
            lc60: 100,
            lc45: 100,
            lc30: 75,
            lc10: 44.5
        },
        "reliance.1800": {
            contrast: 49.741005034577256,
            lc60: 100,
            lc45: 93,
            lc30: 68.5,
            lc10: 40.5
        },
        "reliance.1900": {
            contrast: 55.21748611248092,
            lc60: 100,
            lc45: 86,
            lc30: 63.5,
            lc10: 37.5
        },
        "reliance.2000": {
            contrast: 61.01537616939423,
            lc60: 98.5,
            lc45: 79.5,
            lc30: 59,
            lc10: 35
        },
        "reliance.2100": {
            contrast: 67.0324612592567,
            lc60: 92,
            lc45: 74.5,
            lc30: 55,
            lc10: 33
        },
        "reliance.2200": {
            contrast: 73.13752706480174,
            lc60: 86,
            lc45: 70,
            lc30: 52,
            lc10: 31
        },
        "reliance.2300": {
            contrast: 79.10049686745124,
            lc60: 81.5,
            lc45: 66.5,
            lc30: 49,
            lc10: 29.5
        },
        "reliance.2400": {
            contrast: 85.57184309866263,
            lc60: 77.5,
            lc45: 62.5,
            lc30: 46.5,
            lc10: 28
        },
        "reliance.2500": {
            contrast: 92.35955538406806,
            lc60: 73.5,
            lc45: 59.5,
            lc30: 44,
            lc10: 26.5
        }
    },
    "reliance.900": {
        "reliance.100": {
            contrast: 20.932484243351336,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 50
        },
        "reliance.200": {
            contrast: 20.242331819746877,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "reliance.300": {
            contrast: 18.46398881490696,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70.5
        },
        "reliance.400": {
            contrast: 16.33245787317082,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86.5
        },
        "reliance.500": {
            contrast: 13.460865268861575,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.600": {
            contrast: 9.642652374995965,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1100": {
            contrast: 8.948268689246776,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1200": {
            contrast: 14.753003635872226,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1300": {
            contrast: 19.904130654707977,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79
        },
        "reliance.1400": {
            contrast: 24.73133361644638,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66.5
        },
        "reliance.1500": {
            contrast: 29.610344822096675,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "reliance.1600": {
            contrast: 34.70990922111995,
            lc60: 100,
            lc45: 100,
            lc30: 89,
            lc10: 51.5
        },
        "reliance.1700": {
            contrast: 39.7788897781647,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 46
        },
        "reliance.1800": {
            contrast: 45.50920400929343,
            lc60: 100,
            lc45: 98.5,
            lc30: 72.5,
            lc10: 41.5
        },
        "reliance.1900": {
            contrast: 50.9856850871971,
            lc60: 100,
            lc45: 91,
            lc30: 66.5,
            lc10: 38
        },
        "reliance.2000": {
            contrast: 56.7835751441104,
            lc60: 100,
            lc45: 83.5,
            lc30: 61,
            lc10: 35
        },
        "reliance.2100": {
            contrast: 62.800660233972884,
            lc60: 96.5,
            lc45: 77.5,
            lc30: 57,
            lc10: 33
        },
        "reliance.2200": {
            contrast: 68.90572603951793,
            lc60: 90,
            lc45: 72.5,
            lc30: 53,
            lc10: 31
        },
        "reliance.2300": {
            contrast: 74.86869584216741,
            lc60: 84.5,
            lc45: 68,
            lc30: 50,
            lc10: 29.5
        },
        "reliance.2400": {
            contrast: 81.3400420733788,
            lc60: 79.5,
            lc45: 64,
            lc30: 47,
            lc10: 27.5
        },
        "reliance.2500": {
            contrast: 88.12775435878424,
            lc60: 75,
            lc45: 60.5,
            lc30: 44.5,
            lc10: 26
        }
    },
    "reliance.1000": {
        "reliance.100": {
            contrast: 26.32185940334617,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 40
        },
        "reliance.200": {
            contrast: 25.631706979741715,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 47
        },
        "reliance.300": {
            contrast: 23.8533639749018,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 52.5
        },
        "reliance.400": {
            contrast: 21.721833033165662,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61
        },
        "reliance.500": {
            contrast: 18.850240428856416,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76
        },
        "reliance.600": {
            contrast: 15.032027534990808,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 99
        },
        "reliance.700": {
            contrast: 11.813788892071228,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.800": {
            contrast: 7.958435699012307,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1200": {
            contrast: 9.664268140783633,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1300": {
            contrast: 14.815395159619385,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1400": {
            contrast: 19.64259812135779,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80
        },
        "reliance.1500": {
            contrast: 24.521609327008083,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "reliance.1600": {
            contrast: 29.62117372603136,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "reliance.1700": {
            contrast: 34.690154283076104,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 50.5
        },
        "reliance.1800": {
            contrast: 40.420468514204835,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 45
        },
        "reliance.1900": {
            contrast: 45.8969495921085,
            lc60: 100,
            lc45: 98.5,
            lc30: 71,
            lc10: 41
        },
        "reliance.2000": {
            contrast: 51.69483964902181,
            lc60: 100,
            lc45: 90,
            lc30: 65,
            lc10: 37
        },
        "reliance.2100": {
            contrast: 57.71192473888428,
            lc60: 100,
            lc45: 82,
            lc30: 59.5,
            lc10: 34.5
        },
        "reliance.2200": {
            contrast: 63.81699054442933,
            lc60: 95,
            lc45: 76,
            lc30: 55.5,
            lc10: 31.5
        },
        "reliance.2300": {
            contrast: 69.77996034707881,
            lc60: 89,
            lc45: 71,
            lc30: 52,
            lc10: 29.5
        },
        "reliance.2400": {
            contrast: 76.2513065782902,
            lc60: 83.5,
            lc45: 66.5,
            lc30: 48.5,
            lc10: 28
        },
        "reliance.2500": {
            contrast: 83.03901886369565,
            lc60: 77.5,
            lc45: 62.5,
            lc30: 45.5,
            lc10: 26
        }
    },
    "reliance.1100": {
        "reliance.100": {
            contrast: 31.096032936607216,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 34
        },
        "reliance.200": {
            contrast: 30.40588051300276,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 39.5
        },
        "reliance.300": {
            contrast: 28.627537508162842,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 43.5
        },
        "reliance.400": {
            contrast: 26.496006566426704,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 49
        },
        "reliance.500": {
            contrast: 23.624413962117462,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59
        },
        "reliance.600": {
            contrast: 19.80620106825185,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73
        },
        "reliance.700": {
            contrast: 16.58796242533227,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89.5
        },
        "reliance.800": {
            contrast: 12.73260923227335,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.900": {
            contrast: 8.16311965898063,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1300": {
            contrast: 10.197841535704175,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1400": {
            contrast: 15.02504449744258,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98.5
        },
        "reliance.1500": {
            contrast: 19.904055703092872,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79
        },
        "reliance.1600": {
            contrast: 25.003620102116148,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65
        },
        "reliance.1700": {
            contrast: 30.072600659160898,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 56
        },
        "reliance.1800": {
            contrast: 35.80291489028963,
            lc60: 100,
            lc45: 100,
            lc30: 86,
            lc10: 48.5
        },
        "reliance.1900": {
            contrast: 41.27939596819329,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 43.5
        },
        "reliance.2000": {
            contrast: 47.0772860251066,
            lc60: 100,
            lc45: 96.5,
            lc30: 69.5,
            lc10: 39
        },
        "reliance.2100": {
            contrast: 53.09437111496907,
            lc60: 100,
            lc45: 88,
            lc30: 63,
            lc10: 35.5
        },
        "reliance.2200": {
            contrast: 59.19943692051412,
            lc60: 100,
            lc45: 80.5,
            lc30: 58,
            lc10: 32.5
        },
        "reliance.2300": {
            contrast: 65.16240672316361,
            lc60: 93.5,
            lc45: 74.5,
            lc30: 54,
            lc10: 30.5
        },
        "reliance.2400": {
            contrast: 71.63375295437501,
            lc60: 86.5,
            lc45: 69,
            lc30: 50,
            lc10: 28.5
        },
        "reliance.2500": {
            contrast: 78.42146523978043,
            lc60: 81,
            lc45: 64.5,
            lc30: 47,
            lc10: 26.5
        }
    },
    "reliance.1200": {
        "reliance.100": {
            contrast: 36.93189382981721,
            lc60: 100,
            lc45: 100,
            lc30: 61,
            lc10: 30
        },
        "reliance.200": {
            contrast: 36.24174140621276,
            lc60: 100,
            lc45: 100,
            lc30: 68.5,
            lc10: 33
        },
        "reliance.300": {
            contrast: 34.46339840137284,
            lc60: 100,
            lc45: 100,
            lc30: 75.5,
            lc10: 36
        },
        "reliance.400": {
            contrast: 32.331867459636705,
            lc60: 100,
            lc45: 100,
            lc30: 86,
            lc10: 39.5
        },
        "reliance.500": {
            contrast: 29.460274855327455,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 46
        },
        "reliance.600": {
            contrast: 25.64206196146185,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54.5
        },
        "reliance.700": {
            contrast: 22.423823318542272,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "reliance.800": {
            contrast: 18.56847012548335,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80
        },
        "reliance.900": {
            contrast: 13.998980552190632,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1000": {
            contrast: 8.637776269582023,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1400": {
            contrast: 9.256795765804524,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1500": {
            contrast: 14.135806971454818,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1600": {
            contrast: 19.235371370478095,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81.5
        },
        "reliance.1700": {
            contrast: 24.304351927522845,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "reliance.1800": {
            contrast: 30.034666158651568,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 55
        },
        "reliance.1900": {
            contrast: 35.51114723655523,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 48.5
        },
        "reliance.2000": {
            contrast: 41.30903729346854,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 42.5
        },
        "reliance.2100": {
            contrast: 47.32612238333102,
            lc60: 100,
            lc45: 95.5,
            lc30: 68.5,
            lc10: 38
        },
        "reliance.2200": {
            contrast: 53.431188188876064,
            lc60: 100,
            lc45: 87,
            lc30: 62,
            lc10: 34.5
        },
        "reliance.2300": {
            contrast: 59.39415799152555,
            lc60: 100,
            lc45: 79.5,
            lc30: 57.5,
            lc10: 32
        },
        "reliance.2400": {
            contrast: 65.86550422273693,
            lc60: 92.5,
            lc45: 73.5,
            lc30: 53,
            lc10: 29.5
        },
        "reliance.2500": {
            contrast: 72.65321650814238,
            lc60: 85.5,
            lc45: 68,
            lc30: 49,
            lc10: 27
        }
    },
    "reliance.1300": {
        "reliance.100": {
            contrast: 42.04291669605252,
            lc60: 100,
            lc45: 100,
            lc30: 53.5,
            lc10: 26
        },
        "reliance.200": {
            contrast: 41.35276427244807,
            lc60: 100,
            lc45: 100,
            lc30: 58.5,
            lc10: 29
        },
        "reliance.300": {
            contrast: 39.57442126760816,
            lc60: 100,
            lc45: 100,
            lc30: 63.5,
            lc10: 31
        },
        "reliance.400": {
            contrast: 37.44289032587202,
            lc60: 100,
            lc45: 100,
            lc30: 70,
            lc10: 33.5
        },
        "reliance.500": {
            contrast: 34.57129772156277,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 38.5
        },
        "reliance.600": {
            contrast: 30.75308482769716,
            lc60: 100,
            lc45: 100,
            lc30: 96,
            lc10: 44.5
        },
        "reliance.700": {
            contrast: 27.534846184777585,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 50.5
        },
        "reliance.800": {
            contrast: 23.67949299171866,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61
        },
        "reliance.900": {
            contrast: 19.110003418425944,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77.5
        },
        "reliance.1000": {
            contrast: 13.748799135817336,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1100": {
            contrast: 8.986869667605193,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1500": {
            contrast: 8.983269929958148,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1600": {
            contrast: 14.082834328981427,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1700": {
            contrast: 19.151814886026173,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80.5
        },
        "reliance.1800": {
            contrast: 24.882129117154903,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64.5
        },
        "reliance.1900": {
            contrast: 30.358610195058567,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 54.5
        },
        "reliance.2000": {
            contrast: 36.15650025197187,
            lc60: 100,
            lc45: 100,
            lc30: 85.5,
            lc10: 47
        },
        "reliance.2100": {
            contrast: 42.173585341834354,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 41.5
        },
        "reliance.2200": {
            contrast: 48.27865114737939,
            lc60: 100,
            lc45: 94,
            lc30: 67,
            lc10: 37
        },
        "reliance.2300": {
            contrast: 54.24162095002889,
            lc60: 100,
            lc45: 86,
            lc30: 61,
            lc10: 34
        },
        "reliance.2400": {
            contrast: 60.71296718124027,
            lc60: 99,
            lc45: 78.5,
            lc30: 55.5,
            lc10: 31
        },
        "reliance.2500": {
            contrast: 67.5006794666457,
            lc60: 90.5,
            lc45: 72,
            lc30: 51,
            lc10: 28.5
        }
    },
    "reliance.1400": {
        "reliance.100": {
            contrast: 46.78205852633386,
            lc60: 100,
            lc45: 82,
            lc30: 47.5,
            lc10: 24
        },
        "reliance.200": {
            contrast: 46.09190610272941,
            lc60: 100,
            lc45: 91.5,
            lc30: 52,
            lc10: 26
        },
        "reliance.300": {
            contrast: 44.31356309788949,
            lc60: 100,
            lc45: 100,
            lc30: 55.5,
            lc10: 27
        },
        "reliance.400": {
            contrast: 42.182032156153355,
            lc60: 100,
            lc45: 100,
            lc30: 60,
            lc10: 29
        },
        "reliance.500": {
            contrast: 39.310439551844105,
            lc60: 100,
            lc45: 100,
            lc30: 69,
            lc10: 33
        },
        "reliance.600": {
            contrast: 35.492226657978506,
            lc60: 100,
            lc45: 100,
            lc30: 79,
            lc10: 38
        },
        "reliance.700": {
            contrast: 32.27398801505892,
            lc60: 100,
            lc45: 100,
            lc30: 90,
            lc10: 42
        },
        "reliance.800": {
            contrast: 28.418634821999994,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 50
        },
        "reliance.900": {
            contrast: 23.849145248707284,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61
        },
        "reliance.1000": {
            contrast: 18.487940966098677,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80
        },
        "reliance.1100": {
            contrast: 13.726011497886532,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1200": {
            contrast: 7.891065589828031,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1600": {
            contrast: 9.228668612881291,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1700": {
            contrast: 14.297649169926038,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1800": {
            contrast: 20.02796340105477,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77.5
        },
        "reliance.1900": {
            contrast: 25.504444478958433,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63
        },
        "reliance.2000": {
            contrast: 31.30233453587174,
            lc60: 100,
            lc45: 100,
            lc30: 96,
            lc10: 53
        },
        "reliance.2100": {
            contrast: 37.31941962573421,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 45.5
        },
        "reliance.2200": {
            contrast: 43.42448543127926,
            lc60: 100,
            lc45: 100,
            lc30: 72.5,
            lc10: 40
        },
        "reliance.2300": {
            contrast: 49.38745523392875,
            lc60: 100,
            lc45: 92.5,
            lc30: 65.5,
            lc10: 36
        },
        "reliance.2400": {
            contrast: 55.85880146514013,
            lc60: 100,
            lc45: 83.5,
            lc30: 59,
            lc10: 32.5
        },
        "reliance.2500": {
            contrast: 62.64651375054557,
            lc60: 96.5,
            lc45: 75.5,
            lc30: 54,
            lc10: 29.5
        }
    },
    "reliance.1500": {
        "reliance.100": {
            contrast: 51.52775718343,
            lc60: 100,
            lc45: 69,
            lc30: 43.5,
            lc10: 22
        },
        "reliance.200": {
            contrast: 50.83760475982554,
            lc60: 100,
            lc45: 75,
            lc30: 47,
            lc10: 23.5
        },
        "reliance.300": {
            contrast: 49.05926175498563,
            lc60: 100,
            lc45: 80.5,
            lc30: 49.5,
            lc10: 24.5
        },
        "reliance.400": {
            contrast: 46.92773081324949,
            lc60: 100,
            lc45: 89.5,
            lc30: 53,
            lc10: 26
        },
        "reliance.500": {
            contrast: 44.05613820894024,
            lc60: 100,
            lc45: 100,
            lc30: 59.5,
            lc10: 29.5
        },
        "reliance.600": {
            contrast: 40.23792531507463,
            lc60: 100,
            lc45: 100,
            lc30: 67.5,
            lc10: 32.5
        },
        "reliance.700": {
            contrast: 37.01968667215505,
            lc60: 100,
            lc45: 100,
            lc30: 75,
            lc10: 36.5
        },
        "reliance.800": {
            contrast: 33.164333479096136,
            lc60: 100,
            lc45: 100,
            lc30: 87.5,
            lc10: 42
        },
        "reliance.900": {
            contrast: 28.594843905803412,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 50
        },
        "reliance.1000": {
            contrast: 23.233639623194804,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63
        },
        "reliance.1100": {
            contrast: 18.471710154982667,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81
        },
        "reliance.1200": {
            contrast: 12.636764246924162,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1300": {
            contrast: 7.515316105721745,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1700": {
            contrast: 9.368538641061267,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1800": {
            contrast: 15.098852872189997,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98
        },
        "reliance.1900": {
            contrast: 20.575333950093665,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74.5
        },
        "reliance.2000": {
            contrast: 26.373224007006968,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60.5
        },
        "reliance.2100": {
            contrast: 32.390309096869444,
            lc60: 100,
            lc45: 100,
            lc30: 93.5,
            lc10: 50.5
        },
        "reliance.2200": {
            contrast: 38.49537490241449,
            lc60: 100,
            lc45: 100,
            lc30: 80.5,
            lc10: 43.5
        },
        "reliance.2300": {
            contrast: 44.45834470506398,
            lc60: 100,
            lc45: 100,
            lc30: 70.5,
            lc10: 38.5
        },
        "reliance.2400": {
            contrast: 50.929690936275364,
            lc60: 100,
            lc45: 89.5,
            lc30: 63,
            lc10: 34.5
        },
        "reliance.2500": {
            contrast: 57.7174032216808,
            lc60: 100,
            lc45: 80.5,
            lc30: 56.5,
            lc10: 31
        }
    },
    "reliance.1600": {
        "reliance.100": {
            contrast: 56.44500150838022,
            lc60: 100,
            lc45: 62.5,
            lc30: 40,
            lc10: 20
        },
        "reliance.200": {
            contrast: 55.754849084775756,
            lc60: 100,
            lc45: 67,
            lc30: 43,
            lc10: 21.5
        },
        "reliance.300": {
            contrast: 53.976506079935845,
            lc60: 100,
            lc45: 70.5,
            lc30: 44.5,
            lc10: 22
        },
        "reliance.400": {
            contrast: 51.844975138199715,
            lc60: 100,
            lc45: 76.5,
            lc30: 47.5,
            lc10: 23.5
        },
        "reliance.500": {
            contrast: 48.973382533890465,
            lc60: 100,
            lc45: 86.5,
            lc30: 52.5,
            lc10: 26
        },
        "reliance.600": {
            contrast: 45.15516964002485,
            lc60: 100,
            lc45: 99,
            lc30: 58.5,
            lc10: 29
        },
        "reliance.700": {
            contrast: 41.93693099710528,
            lc60: 100,
            lc45: 100,
            lc30: 64.5,
            lc10: 31.5
        },
        "reliance.800": {
            contrast: 38.081577804046354,
            lc60: 100,
            lc45: 100,
            lc30: 73.5,
            lc10: 35.5
        },
        "reliance.900": {
            contrast: 33.51208823075364,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 42.5
        },
        "reliance.1000": {
            contrast: 28.15088394814503,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51
        },
        "reliance.1100": {
            contrast: 23.388954479932885,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63
        },
        "reliance.1200": {
            contrast: 17.554008571874384,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86
        },
        "reliance.1300": {
            contrast: 12.432560430671966,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1400": {
            contrast: 7.675357656130545,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1800": {
            contrast: 9.924458269298043,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1900": {
            contrast: 15.400939347201708,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98
        },
        "reliance.2000": {
            contrast: 21.198829404115013,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74
        },
        "reliance.2100": {
            contrast: 27.21591449397749,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "reliance.2200": {
            contrast: 33.32098029952253,
            lc60: 100,
            lc45: 100,
            lc30: 90.5,
            lc10: 49.5
        },
        "reliance.2300": {
            contrast: 39.28395010217202,
            lc60: 100,
            lc45: 100,
            lc30: 79,
            lc10: 43
        },
        "reliance.2400": {
            contrast: 45.755296333383406,
            lc60: 100,
            lc45: 98,
            lc30: 69,
            lc10: 38
        },
        "reliance.2500": {
            contrast: 52.543008618788846,
            lc60: 100,
            lc45: 87,
            lc30: 61.5,
            lc10: 33.5
        }
    },
    "reliance.1700": {
        "reliance.100": {
            contrast: 61.293164208485074,
            lc60: 87,
            lc45: 57,
            lc30: 36.5,
            lc10: 19
        },
        "reliance.200": {
            contrast: 60.603011784880614,
            lc60: 94.5,
            lc45: 61,
            lc30: 39,
            lc10: 19.5
        },
        "reliance.300": {
            contrast: 58.8246687800407,
            lc60: 100,
            lc45: 63.5,
            lc30: 40.5,
            lc10: 20.5
        },
        "reliance.400": {
            contrast: 56.693137838304565,
            lc60: 100,
            lc45: 67.5,
            lc30: 42.5,
            lc10: 21.5
        },
        "reliance.500": {
            contrast: 53.821545233995316,
            lc60: 100,
            lc45: 75.5,
            lc30: 47,
            lc10: 23.5
        },
        "reliance.600": {
            contrast: 50.0033323401297,
            lc60: 100,
            lc45: 84,
            lc30: 51.5,
            lc10: 26
        },
        "reliance.700": {
            contrast: 46.78509369721013,
            lc60: 100,
            lc45: 94,
            lc30: 56.5,
            lc10: 28.5
        },
        "reliance.800": {
            contrast: 42.92974050415121,
            lc60: 100,
            lc45: 100,
            lc30: 63.5,
            lc10: 31.5
        },
        "reliance.900": {
            contrast: 38.36025093085849,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 36.5
        },
        "reliance.1000": {
            contrast: 32.99904664824988,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 44
        },
        "reliance.1100": {
            contrast: 28.237117180037735,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 52
        },
        "reliance.1200": {
            contrast: 22.402171271979242,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "reliance.1300": {
            contrast: 17.28072313077682,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87.5
        },
        "reliance.1400": {
            contrast: 12.523520356235398,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1500": {
            contrast: 7.752351505892483,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1900": {
            contrast: 10.236621052631692,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2000": {
            contrast: 16.034511109544997,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95
        },
        "reliance.2100": {
            contrast: 22.051596199407474,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "reliance.2200": {
            contrast: 28.156662004952516,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "reliance.2300": {
            contrast: 34.119631807602005,
            lc60: 100,
            lc45: 100,
            lc30: 89,
            lc10: 48
        },
        "reliance.2400": {
            contrast: 40.59097803881339,
            lc60: 100,
            lc45: 100,
            lc30: 76,
            lc10: 41.5
        },
        "reliance.2500": {
            contrast: 47.37869032421883,
            lc60: 100,
            lc45: 95.5,
            lc30: 66.5,
            lc10: 36
        }
    },
    "reliance.1800": {
        "reliance.100": {
            contrast: 66.7304987086115,
            lc60: 73.5,
            lc45: 52,
            lc30: 34,
            lc10: 17
        },
        "reliance.200": {
            contrast: 66.04034628500705,
            lc60: 78.5,
            lc45: 55,
            lc30: 35.5,
            lc10: 18.5
        },
        "reliance.300": {
            contrast: 64.26200328016714,
            lc60: 83,
            lc45: 57.5,
            lc30: 36.5,
            lc10: 19
        },
        "reliance.400": {
            contrast: 62.130472338431,
            lc60: 90,
            lc45: 60,
            lc30: 38.5,
            lc10: 19.5
        },
        "reliance.500": {
            contrast: 59.25887973412174,
            lc60: 100,
            lc45: 66,
            lc30: 42,
            lc10: 21
        },
        "reliance.600": {
            contrast: 55.440666840256135,
            lc60: 100,
            lc45: 73,
            lc30: 45.5,
            lc10: 23
        },
        "reliance.700": {
            contrast: 52.222428197336555,
            lc60: 100,
            lc45: 80,
            lc30: 50,
            lc10: 25
        },
        "reliance.800": {
            contrast: 48.36707500427765,
            lc60: 100,
            lc45: 90,
            lc30: 55,
            lc10: 28
        },
        "reliance.900": {
            contrast: 43.797585430984924,
            lc60: 100,
            lc45: 100,
            lc30: 63.5,
            lc10: 31.5
        },
        "reliance.1000": {
            contrast: 38.43638114837631,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 36.5
        },
        "reliance.1100": {
            contrast: 33.67445168016417,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 42.5
        },
        "reliance.1200": {
            contrast: 27.83950577210567,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 52.5
        },
        "reliance.1300": {
            contrast: 22.718057630903253,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "reliance.1400": {
            contrast: 17.96085485636183,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84.5
        },
        "reliance.1500": {
            contrast: 13.189686006018913,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1600": {
            contrast: 8.238874713159186,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2000": {
            contrast: 10.173192129493366,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2100": {
            contrast: 16.190277219355846,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 94
        },
        "reliance.2200": {
            contrast: 22.295343024900887,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "reliance.2300": {
            contrast: 28.258312827550373,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "reliance.2400": {
            contrast: 34.72965905876176,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 47.5
        },
        "reliance.2500": {
            contrast: 41.517371344167195,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 40.5
        }
    },
    "reliance.1900": {
        "reliance.100": {
            contrast: 71.887561358508,
            lc60: 67,
            lc45: 48,
            lc30: 31.5,
            lc10: 16
        },
        "reliance.200": {
            contrast: 71.19740893490354,
            lc60: 71,
            lc45: 50.5,
            lc30: 33,
            lc10: 17
        },
        "reliance.300": {
            contrast: 69.41906593006362,
            lc60: 74,
            lc45: 52,
            lc30: 34,
            lc10: 17.5
        },
        "reliance.400": {
            contrast: 67.2875349883275,
            lc60: 78.5,
            lc45: 55,
            lc30: 35.5,
            lc10: 18
        },
        "reliance.500": {
            contrast: 64.41594238401824,
            lc60: 87,
            lc45: 59.5,
            lc30: 38.5,
            lc10: 19.5
        },
        "reliance.600": {
            contrast: 60.59772949015263,
            lc60: 98,
            lc45: 65,
            lc30: 41.5,
            lc10: 21.5
        },
        "reliance.700": {
            contrast: 57.37949084723305,
            lc60: 100,
            lc45: 70.5,
            lc30: 44.5,
            lc10: 22.5
        },
        "reliance.800": {
            contrast: 53.52413765417413,
            lc60: 100,
            lc45: 78,
            lc30: 49.5,
            lc10: 25
        },
        "reliance.900": {
            contrast: 48.95464808088141,
            lc60: 100,
            lc45: 89,
            lc30: 55.5,
            lc10: 28
        },
        "reliance.1000": {
            contrast: 43.5934437982728,
            lc60: 100,
            lc45: 100,
            lc30: 64.5,
            lc10: 32.5
        },
        "reliance.1100": {
            contrast: 38.831514330060664,
            lc60: 100,
            lc45: 100,
            lc30: 73.5,
            lc10: 37
        },
        "reliance.1200": {
            contrast: 32.996568422002156,
            lc60: 100,
            lc45: 100,
            lc30: 90,
            lc10: 44
        },
        "reliance.1300": {
            contrast: 27.87512028079974,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53
        },
        "reliance.1400": {
            contrast: 23.11791750625832,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65
        },
        "reliance.1500": {
            contrast: 18.346748655915405,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82
        },
        "reliance.1600": {
            contrast: 13.395937363055676,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1700": {
            contrast: 8.508057847409232,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2100": {
            contrast: 10.567230217370186,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2200": {
            contrast: 16.67229602291523,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91.5
        },
        "reliance.2300": {
            contrast: 22.635265825564723,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "reliance.2400": {
            contrast: 29.106612056776104,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56
        },
        "reliance.2500": {
            contrast: 35.89432434218154,
            lc60: 100,
            lc45: 100,
            lc30: 85.5,
            lc10: 46.5
        }
    },
    "reliance.2000": {
        "reliance.100": {
            contrast: 77.3086897650424,
            lc60: 61.5,
            lc45: 44.5,
            lc30: 29,
            lc10: 15
        },
        "reliance.200": {
            contrast: 76.61853734143794,
            lc60: 65,
            lc45: 47,
            lc30: 30.5,
            lc10: 16
        },
        "reliance.300": {
            contrast: 74.84019433659803,
            lc60: 67,
            lc45: 48,
            lc30: 31.5,
            lc10: 16
        },
        "reliance.400": {
            contrast: 72.7086633948619,
            lc60: 70.5,
            lc45: 50.5,
            lc30: 32.5,
            lc10: 17
        },
        "reliance.500": {
            contrast: 69.83707079055263,
            lc60: 77,
            lc45: 54,
            lc30: 35.5,
            lc10: 18.5
        },
        "reliance.600": {
            contrast: 66.01885789668704,
            lc60: 84.5,
            lc45: 58.5,
            lc30: 38,
            lc10: 19.5
        },
        "reliance.700": {
            contrast: 62.80061925376745,
            lc60: 92,
            lc45: 63,
            lc30: 40.5,
            lc10: 21
        },
        "reliance.800": {
            contrast: 58.94526606070853,
            lc60: 100,
            lc45: 69,
            lc30: 44,
            lc10: 22.5
        },
        "reliance.900": {
            contrast: 54.37577648741582,
            lc60: 100,
            lc45: 77,
            lc30: 49,
            lc10: 25.5
        },
        "reliance.1000": {
            contrast: 49.01457220480721,
            lc60: 100,
            lc45: 89,
            lc30: 56,
            lc10: 28.5
        },
        "reliance.1100": {
            contrast: 44.252642736595064,
            lc60: 100,
            lc45: 100,
            lc30: 63.5,
            lc10: 32.5
        },
        "reliance.1200": {
            contrast: 38.41769682853656,
            lc60: 100,
            lc45: 100,
            lc30: 75.5,
            lc10: 38
        },
        "reliance.1300": {
            contrast: 33.29624868733415,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 44.5
        },
        "reliance.1400": {
            contrast: 28.53904591279272,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53
        },
        "reliance.1500": {
            contrast: 23.76787706244981,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "reliance.1600": {
            contrast: 18.81706576959008,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80.5
        },
        "reliance.1700": {
            contrast: 13.929186253943637,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1800": {
            contrast: 8.440048003314446,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2200": {
            contrast: 10.698084096706562,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2300": {
            contrast: 16.66105389935605,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91
        },
        "reliance.2400": {
            contrast: 23.132400130567436,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "reliance.2500": {
            contrast: 29.92011241597287,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54
        }
    },
    "reliance.2100": {
        "reliance.100": {
            contrast: 82.89599110873581,
            lc60: 57,
            lc45: 41.5,
            lc30: 27.5,
            lc10: 14
        },
        "reliance.200": {
            contrast: 82.20583868513135,
            lc60: 60,
            lc45: 43.5,
            lc30: 28.5,
            lc10: 15
        },
        "reliance.300": {
            contrast: 80.42749568029143,
            lc60: 61.5,
            lc45: 44.5,
            lc30: 29,
            lc10: 15
        },
        "reliance.400": {
            contrast: 78.2959647385553,
            lc60: 64.5,
            lc45: 46,
            lc30: 30,
            lc10: 15.5
        },
        "reliance.500": {
            contrast: 75.42437213424604,
            lc60: 69.5,
            lc45: 49.5,
            lc30: 32.5,
            lc10: 17
        },
        "reliance.600": {
            contrast: 71.60615924038044,
            lc60: 75,
            lc45: 53,
            lc30: 34.5,
            lc10: 18
        },
        "reliance.700": {
            contrast: 68.38792059746086,
            lc60: 80.5,
            lc45: 57,
            lc30: 36.5,
            lc10: 19
        },
        "reliance.800": {
            contrast: 64.53256740440195,
            lc60: 88.5,
            lc45: 61.5,
            lc30: 40,
            lc10: 20.5
        },
        "reliance.900": {
            contrast: 59.963077831109224,
            lc60: 100,
            lc45: 69,
            lc30: 44,
            lc10: 23
        },
        "reliance.1000": {
            contrast: 54.60187354850061,
            lc60: 100,
            lc45: 78,
            lc30: 50,
            lc10: 25.5
        },
        "reliance.1100": {
            contrast: 49.83994408028847,
            lc60: 100,
            lc45: 88,
            lc30: 56,
            lc10: 28.5
        },
        "reliance.1200": {
            contrast: 44.00499817222997,
            lc60: 100,
            lc45: 100,
            lc30: 64.5,
            lc10: 33
        },
        "reliance.1300": {
            contrast: 38.88355003102755,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 38
        },
        "reliance.1400": {
            contrast: 34.12634725648613,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 44.5
        },
        "reliance.1500": {
            contrast: 29.35517840614321,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 52
        },
        "reliance.1600": {
            contrast: 24.404367113283485,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "reliance.1700": {
            contrast: 19.51648759763704,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78.5
        },
        "reliance.1800": {
            contrast: 14.027349347007853,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1900": {
            contrast: 8.814541763707792,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2300": {
            contrast: 10.439503187790814,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2400": {
            contrast: 16.9108494190022,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91
        },
        "reliance.2500": {
            contrast: 23.698561704407638,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        }
    },
    "reliance.2200": {
        "reliance.100": {
            contrast: 88.52759546049491,
            lc60: 53,
            lc45: 39,
            lc30: 25.5,
            lc10: 13
        },
        "reliance.200": {
            contrast: 87.83744303689043,
            lc60: 55.5,
            lc45: 40.5,
            lc30: 27,
            lc10: 14
        },
        "reliance.300": {
            contrast: 86.05910003205052,
            lc60: 57,
            lc45: 41.5,
            lc30: 27.5,
            lc10: 14
        },
        "reliance.400": {
            contrast: 83.92756909031439,
            lc60: 59,
            lc45: 43,
            lc30: 28,
            lc10: 14.5
        },
        "reliance.500": {
            contrast: 81.05597648600514,
            lc60: 63,
            lc45: 46,
            lc30: 30,
            lc10: 15.5
        },
        "reliance.600": {
            contrast: 77.23776359213953,
            lc60: 68,
            lc45: 48.5,
            lc30: 32,
            lc10: 16.5
        },
        "reliance.700": {
            contrast: 74.01952494921996,
            lc60: 72.5,
            lc45: 51.5,
            lc30: 34,
            lc10: 17.5
        },
        "reliance.800": {
            contrast: 70.16417175616104,
            lc60: 79,
            lc45: 56,
            lc30: 36,
            lc10: 18.5
        },
        "reliance.900": {
            contrast: 65.59468218286831,
            lc60: 87.5,
            lc45: 61.5,
            lc30: 40,
            lc10: 20.5
        },
        "reliance.1000": {
            contrast: 60.2334779002597,
            lc60: 99.5,
            lc45: 69,
            lc30: 45,
            lc10: 23
        },
        "reliance.1100": {
            contrast: 55.47154843204757,
            lc60: 100,
            lc45: 76.5,
            lc30: 50,
            lc10: 25.5
        },
        "reliance.1200": {
            contrast: 49.63660252398906,
            lc60: 100,
            lc45: 88,
            lc30: 56.5,
            lc10: 29
        },
        "reliance.1300": {
            contrast: 44.51515438278664,
            lc60: 100,
            lc45: 100,
            lc30: 64.5,
            lc10: 33
        },
        "reliance.1400": {
            contrast: 39.75795160824522,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 37.5
        },
        "reliance.1500": {
            contrast: 34.986782757902304,
            lc60: 100,
            lc45: 100,
            lc30: 85,
            lc10: 43.5
        },
        "reliance.1600": {
            contrast: 30.03597146504258,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 51.5
        },
        "reliance.1700": {
            contrast: 25.148091949396132,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61.5
        },
        "reliance.1800": {
            contrast: 19.658953698766947,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78
        },
        "reliance.1900": {
            contrast: 14.446146115466888,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2000": {
            contrast: 8.95993517829224,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2400": {
            contrast: 10.577406575736358,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2500": {
            contrast: 17.3651188611418,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87.5
        }
    },
    "reliance.2300": {
        "reliance.100": {
            contrast: 93.99429732830377,
            lc60: 50,
            lc45: 36.5,
            lc30: 24,
            lc10: 12.5
        },
        "reliance.200": {
            contrast: 93.30414490469931,
            lc60: 52,
            lc45: 38,
            lc30: 25.5,
            lc10: 13
        },
        "reliance.300": {
            contrast: 91.5258018998594,
            lc60: 53,
            lc45: 39,
            lc30: 25.5,
            lc10: 13.5
        },
        "reliance.400": {
            contrast: 89.39427095812327,
            lc60: 55,
            lc45: 40,
            lc30: 26.5,
            lc10: 14
        },
        "reliance.500": {
            contrast: 86.52267835381402,
            lc60: 58.5,
            lc45: 42.5,
            lc30: 28,
            lc10: 14.5
        },
        "reliance.600": {
            contrast: 82.70446545994841,
            lc60: 62,
            lc45: 45,
            lc30: 30,
            lc10: 15.5
        },
        "reliance.700": {
            contrast: 79.48622681702882,
            lc60: 66,
            lc45: 47.5,
            lc30: 31.5,
            lc10: 16.5
        },
        "reliance.800": {
            contrast: 75.6308736239699,
            lc60: 71.5,
            lc45: 51.5,
            lc30: 34,
            lc10: 17.5
        },
        "reliance.900": {
            contrast: 71.06138405067719,
            lc60: 79,
            lc45: 56.5,
            lc30: 37,
            lc10: 19
        },
        "reliance.1000": {
            contrast: 65.70017976806858,
            lc60: 87.5,
            lc45: 62,
            lc30: 41,
            lc10: 21
        },
        "reliance.1100": {
            contrast: 60.938250299856435,
            lc60: 98,
            lc45: 68.5,
            lc30: 44.5,
            lc10: 23
        },
        "reliance.1200": {
            contrast: 55.103304391797934,
            lc60: 100,
            lc45: 78,
            lc30: 50.5,
            lc10: 26
        },
        "reliance.1300": {
            contrast: 49.98185625059553,
            lc60: 100,
            lc45: 87.5,
            lc30: 57,
            lc10: 29
        },
        "reliance.1400": {
            contrast: 45.224653476054094,
            lc60: 100,
            lc45: 99,
            lc30: 64.5,
            lc10: 33
        },
        "reliance.1500": {
            contrast: 40.45348462571118,
            lc60: 100,
            lc45: 100,
            lc30: 73,
            lc10: 37.5
        },
        "reliance.1600": {
            contrast: 35.50267333285145,
            lc60: 100,
            lc45: 100,
            lc30: 83.5,
            lc10: 43.5
        },
        "reliance.1700": {
            contrast: 30.614793817205012,
            lc60: 100,
            lc45: 100,
            lc30: 97.5,
            lc10: 50.5
        },
        "reliance.1800": {
            contrast: 25.125655566575816,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62
        },
        "reliance.1900": {
            contrast: 19.91284798327576,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77
        },
        "reliance.2000": {
            contrast: 14.426637046101115,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2100": {
            contrast: 8.765736302952277,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2500": {
            contrast: 11.159979652178965,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "reliance.2400": {
        "reliance.100": {
            contrast: 99.89177625879418,
            lc60: 47,
            lc45: 34.5,
            lc30: 23,
            lc10: 12
        },
        "reliance.200": {
            contrast: 99.20162383518972,
            lc60: 48.5,
            lc45: 35.5,
            lc30: 24,
            lc10: 12.5
        },
        "reliance.300": {
            contrast: 97.4232808303498,
            lc60: 49.5,
            lc45: 36.5,
            lc30: 24,
            lc10: 12.5
        },
        "reliance.400": {
            contrast: 95.29174988861368,
            lc60: 51,
            lc45: 37,
            lc30: 25,
            lc10: 13
        },
        "reliance.500": {
            contrast: 92.42015728430442,
            lc60: 54,
            lc45: 39.5,
            lc30: 26.5,
            lc10: 13.5
        },
        "reliance.600": {
            contrast: 88.60194439043882,
            lc60: 57.5,
            lc45: 42,
            lc30: 28,
            lc10: 14.5
        },
        "reliance.700": {
            contrast: 85.38370574751923,
            lc60: 60.5,
            lc45: 44,
            lc30: 29,
            lc10: 15
        },
        "reliance.800": {
            contrast: 81.52835255446031,
            lc60: 65,
            lc45: 47,
            lc30: 31,
            lc10: 16
        },
        "reliance.900": {
            contrast: 76.9588629811676,
            lc60: 71,
            lc45: 51,
            lc30: 33.5,
            lc10: 17.5
        },
        "reliance.1000": {
            contrast: 71.59765869855899,
            lc60: 79,
            lc45: 56,
            lc30: 37,
            lc10: 19.5
        },
        "reliance.1100": {
            contrast: 66.83572923034684,
            lc60: 86,
            lc45: 62,
            lc30: 40,
            lc10: 21
        },
        "reliance.1200": {
            contrast: 61.00078332228834,
            lc60: 98,
            lc45: 69.5,
            lc30: 45,
            lc10: 23.5
        },
        "reliance.1300": {
            contrast: 55.87933518108592,
            lc60: 100,
            lc45: 77.5,
            lc30: 50,
            lc10: 26
        },
        "reliance.1400": {
            contrast: 51.12213240654451,
            lc60: 100,
            lc45: 86.5,
            lc30: 56,
            lc10: 29
        },
        "reliance.1500": {
            contrast: 46.350963556201584,
            lc60: 100,
            lc45: 96.5,
            lc30: 63,
            lc10: 32
        },
        "reliance.1600": {
            contrast: 41.40015226334185,
            lc60: 100,
            lc45: 100,
            lc30: 71.5,
            lc10: 36.5
        },
        "reliance.1700": {
            contrast: 36.51227274769541,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 42
        },
        "reliance.1800": {
            contrast: 31.023134497066224,
            lc60: 100,
            lc45: 100,
            lc30: 97,
            lc10: 50
        },
        "reliance.1900": {
            contrast: 25.81032691376616,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "reliance.2000": {
            contrast: 20.32411597659152,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75.5
        },
        "reliance.2100": {
            contrast: 14.663215233442683,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2200": {
            contrast: 8.951130795251263,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "reliance.2500": {
        "reliance.100": {
            contrast: 106.04067321268862,
            lc60: 44,
            lc45: 32.5,
            lc30: 21.5,
            lc10: 11.5
        },
        "reliance.200": {
            contrast: 105.35052078908413,
            lc60: 45.5,
            lc45: 33.5,
            lc30: 22.5,
            lc10: 11.5
        },
        "reliance.300": {
            contrast: 103.57217778424423,
            lc60: 46,
            lc45: 34,
            lc30: 22.5,
            lc10: 12
        },
        "reliance.400": {
            contrast: 101.44064684250809,
            lc60: 47.5,
            lc45: 35,
            lc30: 23.5,
            lc10: 12.5
        },
        "reliance.500": {
            contrast: 98.56905423819883,
            lc60: 50.5,
            lc45: 37,
            lc30: 24.5,
            lc10: 13
        },
        "reliance.600": {
            contrast: 94.75084134433322,
            lc60: 53,
            lc45: 39,
            lc30: 25.5,
            lc10: 13.5
        },
        "reliance.700": {
            contrast: 91.53260270141365,
            lc60: 56,
            lc45: 41,
            lc30: 27,
            lc10: 14
        },
        "reliance.800": {
            contrast: 87.67724950835472,
            lc60: 59.5,
            lc45: 43.5,
            lc30: 28.5,
            lc10: 15
        },
        "reliance.900": {
            contrast: 83.107759935062,
            lc60: 64.5,
            lc45: 47,
            lc30: 31,
            lc10: 16
        },
        "reliance.1000": {
            contrast: 77.7465556524534,
            lc60: 71,
            lc45: 51.5,
            lc30: 34,
            lc10: 17.5
        },
        "reliance.1100": {
            contrast: 72.98462618424125,
            lc60: 77,
            lc45: 56,
            lc30: 37,
            lc10: 19
        },
        "reliance.1200": {
            contrast: 67.14968027618275,
            lc60: 86,
            lc45: 62,
            lc30: 41,
            lc10: 21.5
        },
        "reliance.1300": {
            contrast: 62.028232134980335,
            lc60: 95.5,
            lc45: 68.5,
            lc30: 45.5,
            lc10: 23.5
        },
        "reliance.1400": {
            contrast: 57.27102936043892,
            lc60: 100,
            lc45: 75.5,
            lc30: 50,
            lc10: 26
        },
        "reliance.1500": {
            contrast: 52.499860510096,
            lc60: 100,
            lc45: 83.5,
            lc30: 55,
            lc10: 29
        },
        "reliance.1600": {
            contrast: 47.54904921723627,
            lc60: 100,
            lc45: 93.5,
            lc30: 61.5,
            lc10: 32.5
        },
        "reliance.1700": {
            contrast: 42.66116970158983,
            lc60: 100,
            lc45: 100,
            lc30: 69,
            lc10: 36.5
        },
        "reliance.1800": {
            contrast: 37.17203145096064,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 42.5
        },
        "reliance.1900": {
            contrast: 31.959223867660576,
            lc60: 100,
            lc45: 100,
            lc30: 94,
            lc10: 49
        },
        "reliance.2000": {
            contrast: 26.47301293048593,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "reliance.2100": {
            contrast: 20.812112187337096,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75
        },
        "reliance.2200": {
            contrast: 15.100027749145676,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98.5
        },
        "reliance.2300": {
            contrast: 9.54949856452588,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    }
};
const $f8fd43f1ee3f8cd8$var$informative = {
    "informative.100": {
        "informative.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.600": {
            contrast: 8.789175117329142,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.700": {
            contrast: 13.19911114934481,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.800": {
            contrast: 17.805967000186975,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91.5
        },
        "informative.900": {
            contrast: 22.52800707966106,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81.5
        },
        "informative.1000": {
            contrast: 26.809005202443558,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74
        },
        "informative.1100": {
            contrast: 31.27864705676512,
            lc60: 100,
            lc45: 100,
            lc30: 97.5,
            lc10: 68
        },
        "informative.1200": {
            contrast: 36.28144539710574,
            lc60: 100,
            lc45: 100,
            lc30: 89.5,
            lc10: 62.5
        },
        "informative.1300": {
            contrast: 41.486392369038164,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 57.5
        },
        "informative.1400": {
            contrast: 45.9163990580774,
            lc60: 100,
            lc45: 99,
            lc30: 78,
            lc10: 54.5
        },
        "informative.1500": {
            contrast: 50.467845606301665,
            lc60: 100,
            lc45: 93.5,
            lc30: 73.5,
            lc10: 51.5
        },
        "informative.1600": {
            contrast: 55.39654801148147,
            lc60: 100,
            lc45: 88,
            lc30: 69.5,
            lc10: 48.5
        },
        "informative.1700": {
            contrast: 60.694150090667186,
            lc60: 99,
            lc45: 83,
            lc30: 66,
            lc10: 46
        },
        "informative.1800": {
            contrast: 65.81007794340718,
            lc60: 94.5,
            lc45: 79,
            lc30: 62.5,
            lc10: 44
        },
        "informative.1900": {
            contrast: 71.20477956197155,
            lc60: 89.5,
            lc45: 75.5,
            lc30: 59.5,
            lc10: 41.5
        },
        "informative.2000": {
            contrast: 76.87813201102341,
            lc60: 85.5,
            lc45: 72,
            lc30: 57,
            lc10: 39.5
        },
        "informative.2100": {
            contrast: 82.6664854845638,
            lc60: 81.5,
            lc45: 69,
            lc30: 54.5,
            lc10: 38
        },
        "informative.2200": {
            contrast: 88.8231770943698,
            lc60: 78,
            lc45: 66,
            lc30: 52,
            lc10: 36
        },
        "informative.2300": {
            contrast: 94.95831913195244,
            lc60: 75,
            lc45: 63,
            lc30: 49.5,
            lc10: 34.5
        },
        "informative.2400": {
            contrast: 101.41680411074985,
            lc60: 72,
            lc45: 60.5,
            lc30: 48,
            lc10: 33.5
        },
        "informative.2500": {
            contrast: 107.88473318309848,
            lc60: 69,
            lc45: 58,
            lc30: 46,
            lc10: 32
        }
    },
    "informative.200": {
        "informative.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.600": {
            contrast: 8.416343169173128,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.700": {
            contrast: 12.826279201188798,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.800": {
            contrast: 17.433135052030956,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91
        },
        "informative.900": {
            contrast: 22.155175131505047,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79
        },
        "informative.1000": {
            contrast: 26.43617325428754,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70.5
        },
        "informative.1100": {
            contrast: 30.905815108609104,
            lc60: 100,
            lc45: 100,
            lc30: 98,
            lc10: 64
        },
        "informative.1200": {
            contrast: 35.90861344894972,
            lc60: 100,
            lc45: 100,
            lc30: 89,
            lc10: 58.5
        },
        "informative.1300": {
            contrast: 41.11356042088215,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 53.5
        },
        "informative.1400": {
            contrast: 45.543567109921376,
            lc60: 100,
            lc45: 98.5,
            lc30: 76.5,
            lc10: 49.5
        },
        "informative.1500": {
            contrast: 50.095013658145646,
            lc60: 100,
            lc45: 93,
            lc30: 72,
            lc10: 47
        },
        "informative.1600": {
            contrast: 55.02371606332546,
            lc60: 100,
            lc45: 87.5,
            lc30: 67.5,
            lc10: 44
        },
        "informative.1700": {
            contrast: 60.32131814251118,
            lc60: 99.5,
            lc45: 82.5,
            lc30: 63.5,
            lc10: 42
        },
        "informative.1800": {
            contrast: 65.43724599525117,
            lc60: 94.5,
            lc45: 78,
            lc30: 60,
            lc10: 40
        },
        "informative.1900": {
            contrast: 70.83194761381554,
            lc60: 89.5,
            lc45: 74,
            lc30: 57,
            lc10: 38
        },
        "informative.2000": {
            contrast: 76.5053000628674,
            lc60: 85,
            lc45: 70.5,
            lc30: 54.5,
            lc10: 35.5
        },
        "informative.2100": {
            contrast: 82.29365353640779,
            lc60: 81,
            lc45: 67.5,
            lc30: 51.5,
            lc10: 34
        },
        "informative.2200": {
            contrast: 88.45034514621379,
            lc60: 77,
            lc45: 64,
            lc30: 49.5,
            lc10: 32.5
        },
        "informative.2300": {
            contrast: 94.58548718379642,
            lc60: 74,
            lc45: 61,
            lc30: 47.5,
            lc10: 31.5
        },
        "informative.2400": {
            contrast: 101.04397216259385,
            lc60: 70.5,
            lc45: 58.5,
            lc30: 45,
            lc10: 30
        },
        "informative.2500": {
            contrast: 107.51190123494246,
            lc60: 67.5,
            lc45: 56,
            lc30: 43.5,
            lc10: 28.5
        }
    },
    "informative.300": {
        "informative.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.700": {
            contrast: 11.546815857768037,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.800": {
            contrast: 16.153671708610197,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95.5
        },
        "informative.900": {
            contrast: 20.875711788084285,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80
        },
        "informative.1000": {
            contrast: 25.156709910866777,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70.5
        },
        "informative.1100": {
            contrast: 29.626351765188343,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63
        },
        "informative.1200": {
            contrast: 34.629150105528964,
            lc60: 100,
            lc45: 100,
            lc30: 90,
            lc10: 56.5
        },
        "informative.1300": {
            contrast: 39.83409707746139,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 51
        },
        "informative.1400": {
            contrast: 44.26410376650062,
            lc60: 100,
            lc45: 100,
            lc30: 76,
            lc10: 47.5
        },
        "informative.1500": {
            contrast: 48.81555031472489,
            lc60: 100,
            lc45: 94,
            lc30: 71,
            lc10: 44
        },
        "informative.1600": {
            contrast: 53.74425271990469,
            lc60: 100,
            lc45: 88,
            lc30: 66.5,
            lc10: 41.5
        },
        "informative.1700": {
            contrast: 59.04185479909042,
            lc60: 100,
            lc45: 82.5,
            lc30: 62,
            lc10: 39
        },
        "informative.1800": {
            contrast: 64.1577826518304,
            lc60: 95,
            lc45: 78,
            lc30: 58.5,
            lc10: 36.5
        },
        "informative.1900": {
            contrast: 69.55248427039477,
            lc60: 90,
            lc45: 73.5,
            lc30: 55.5,
            lc10: 34.5
        },
        "informative.2000": {
            contrast: 75.22583671944663,
            lc60: 85,
            lc45: 70,
            lc30: 53,
            lc10: 33
        },
        "informative.2100": {
            contrast: 81.01419019298703,
            lc60: 81,
            lc45: 66.5,
            lc30: 50.5,
            lc10: 31.5
        },
        "informative.2200": {
            contrast: 87.17088180279303,
            lc60: 77,
            lc45: 63,
            lc30: 47.5,
            lc10: 30
        },
        "informative.2300": {
            contrast: 93.30602384037564,
            lc60: 73.5,
            lc45: 60.5,
            lc30: 45.5,
            lc10: 28.5
        },
        "informative.2400": {
            contrast: 99.76450881917306,
            lc60: 70,
            lc45: 57.5,
            lc30: 43.5,
            lc10: 27.5
        },
        "informative.2500": {
            contrast: 106.2324378915217,
            lc60: 67.5,
            lc45: 55,
            lc30: 42,
            lc10: 26.5
        }
    },
    "informative.400": {
        "informative.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.700": {
            contrast: 9.712492240346851,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.800": {
            contrast: 14.319348091189013,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.900": {
            contrast: 19.0413881706631,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83.5
        },
        "informative.1000": {
            contrast: 23.322386293445593,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "informative.1100": {
            contrast: 27.792028147767155,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "informative.1200": {
            contrast: 32.79482648810777,
            lc60: 100,
            lc45: 100,
            lc30: 93.5,
            lc10: 55.5
        },
        "informative.1300": {
            contrast: 37.999773460040196,
            lc60: 100,
            lc45: 100,
            lc30: 84,
            lc10: 49.5
        },
        "informative.1400": {
            contrast: 42.429780149079434,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 46
        },
        "informative.1500": {
            contrast: 46.9812266973037,
            lc60: 100,
            lc45: 96.5,
            lc30: 71.5,
            lc10: 42.5
        },
        "informative.1600": {
            contrast: 51.909929102483495,
            lc60: 100,
            lc45: 89.5,
            lc30: 66.5,
            lc10: 40
        },
        "informative.1700": {
            contrast: 57.207531181669225,
            lc60: 100,
            lc45: 83.5,
            lc30: 62,
            lc10: 37
        },
        "informative.1800": {
            contrast: 62.32345903440921,
            lc60: 97,
            lc45: 78.5,
            lc30: 58,
            lc10: 35
        },
        "informative.1900": {
            contrast: 67.71816065297358,
            lc60: 91.5,
            lc45: 74,
            lc30: 54.5,
            lc10: 33
        },
        "informative.2000": {
            contrast: 73.39151310202544,
            lc60: 86,
            lc45: 70,
            lc30: 52,
            lc10: 31
        },
        "informative.2100": {
            contrast: 79.17986657556582,
            lc60: 81.5,
            lc45: 66.5,
            lc30: 49,
            lc10: 29.5
        },
        "informative.2200": {
            contrast: 85.33655818537184,
            lc60: 77.5,
            lc45: 63,
            lc30: 47,
            lc10: 28
        },
        "informative.2300": {
            contrast: 91.47170022295447,
            lc60: 73.5,
            lc45: 60,
            lc30: 44.5,
            lc10: 27
        },
        "informative.2400": {
            contrast: 97.93018520175187,
            lc60: 70.5,
            lc45: 57.5,
            lc30: 42.5,
            lc10: 26
        },
        "informative.2500": {
            contrast: 104.39811427410051,
            lc60: 67,
            lc45: 54.5,
            lc30: 41,
            lc10: 24.5
        }
    },
    "informative.500": {
        "informative.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.800": {
            contrast: 11.63856099915965,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.900": {
            contrast: 16.36060107863374,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 92.5
        },
        "informative.1000": {
            contrast: 20.641599201416234,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77
        },
        "informative.1100": {
            contrast: 25.111241055737793,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "informative.1200": {
            contrast: 30.11403939607841,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 57
        },
        "informative.1300": {
            contrast: 35.31898636801084,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 50.5
        },
        "informative.1400": {
            contrast: 39.74899305705007,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 46
        },
        "informative.1500": {
            contrast: 44.300439605274335,
            lc60: 100,
            lc45: 100,
            lc30: 73,
            lc10: 42.5
        },
        "informative.1600": {
            contrast: 49.22914201045414,
            lc60: 100,
            lc45: 92.5,
            lc30: 68,
            lc10: 39
        },
        "informative.1700": {
            contrast: 54.52674408963987,
            lc60: 100,
            lc45: 86.5,
            lc30: 62.5,
            lc10: 37
        },
        "informative.1800": {
            contrast: 59.642671942379856,
            lc60: 100,
            lc45: 80.5,
            lc30: 58.5,
            lc10: 34.5
        },
        "informative.1900": {
            contrast: 65.03737356094422,
            lc60: 94,
            lc45: 75.5,
            lc30: 55.5,
            lc10: 32.5
        },
        "informative.2000": {
            contrast: 70.71072600999608,
            lc60: 88,
            lc45: 71,
            lc30: 52,
            lc10: 30.5
        },
        "informative.2100": {
            contrast: 76.49907948353646,
            lc60: 83.5,
            lc45: 67,
            lc30: 49,
            lc10: 29
        },
        "informative.2200": {
            contrast: 82.65577109334248,
            lc60: 78.5,
            lc45: 63.5,
            lc30: 46.5,
            lc10: 27.5
        },
        "informative.2300": {
            contrast: 88.79091313092509,
            lc60: 74.5,
            lc45: 60.5,
            lc30: 44.5,
            lc10: 26
        },
        "informative.2400": {
            contrast: 95.2493981097225,
            lc60: 71,
            lc45: 57,
            lc30: 42.5,
            lc10: 25
        },
        "informative.2500": {
            contrast: 101.71732718207113,
            lc60: 67.5,
            lc45: 54.5,
            lc30: 40.5,
            lc10: 24
        }
    },
    "informative.600": {
        "informative.100": {
            contrast: 10.188489672952905,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.200": {
            contrast: 9.688264111838475,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.300": {
            contrast: 8.013992774415113,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.800": {
            contrast: 7.714156207965457,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.900": {
            contrast: 12.436196287439543,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1000": {
            contrast: 16.71719441022204,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91
        },
        "informative.1100": {
            contrast: 21.186836264543604,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74.5
        },
        "informative.1200": {
            contrast: 26.189634604884223,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "informative.1300": {
            contrast: 31.39458157681665,
            lc60: 100,
            lc45: 100,
            lc30: 96,
            lc10: 54
        },
        "informative.1400": {
            contrast: 35.82458826585588,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 48.5
        },
        "informative.1500": {
            contrast: 40.37603481408014,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 44
        },
        "informative.1600": {
            contrast: 45.304737219259955,
            lc60: 100,
            lc45: 99.5,
            lc30: 71.5,
            lc10: 41
        },
        "informative.1700": {
            contrast: 50.60233929844568,
            lc60: 100,
            lc45: 91,
            lc30: 66.5,
            lc10: 37.5
        },
        "informative.1800": {
            contrast: 55.718267151185664,
            lc60: 100,
            lc45: 84.5,
            lc30: 61.5,
            lc10: 35
        },
        "informative.1900": {
            contrast: 61.11296876975003,
            lc60: 98.5,
            lc45: 79,
            lc30: 57.5,
            lc10: 33
        },
        "informative.2000": {
            contrast: 66.78632121880189,
            lc60: 92,
            lc45: 74,
            lc30: 54,
            lc10: 31
        },
        "informative.2100": {
            contrast: 72.57467469234228,
            lc60: 86.5,
            lc45: 69.5,
            lc30: 50.5,
            lc10: 29.5
        },
        "informative.2200": {
            contrast: 78.73136630214829,
            lc60: 81,
            lc45: 65,
            lc30: 48,
            lc10: 27.5
        },
        "informative.2300": {
            contrast: 84.8665083397309,
            lc60: 77,
            lc45: 62,
            lc30: 45.5,
            lc10: 26
        },
        "informative.2400": {
            contrast: 91.32499331852831,
            lc60: 73,
            lc45: 58.5,
            lc30: 43,
            lc10: 25
        },
        "informative.2500": {
            contrast: 97.79292239087695,
            lc60: 69.5,
            lc45: 56,
            lc30: 41,
            lc10: 23.5
        }
    },
    "informative.700": {
        "informative.100": {
            contrast: 14.975527567308877,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.200": {
            contrast: 14.475302006194447,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.300": {
            contrast: 12.801030668771086,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.400": {
            contrast: 10.487924981675182,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.900": {
            contrast: 8.218810316676842,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1000": {
            contrast: 12.499808439459336,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1100": {
            contrast: 16.969450293780902,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89.5
        },
        "informative.1200": {
            contrast: 21.97224863412152,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "informative.1300": {
            contrast: 27.177195606053946,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "informative.1400": {
            contrast: 31.607202295093177,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 52.5
        },
        "informative.1500": {
            contrast: 36.15864884331744,
            lc60: 100,
            lc45: 100,
            lc30: 85,
            lc10: 47.5
        },
        "informative.1600": {
            contrast: 41.08735124849724,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 43.5
        },
        "informative.1700": {
            contrast: 46.384953327682965,
            lc60: 100,
            lc45: 97.5,
            lc30: 69.5,
            lc10: 39.5
        },
        "informative.1800": {
            contrast: 51.500881180422965,
            lc60: 100,
            lc45: 89.5,
            lc30: 65,
            lc10: 36.5
        },
        "informative.1900": {
            contrast: 56.895582798987334,
            lc60: 100,
            lc45: 83,
            lc30: 60.5,
            lc10: 34.5
        },
        "informative.2000": {
            contrast: 62.568935248039196,
            lc60: 96.5,
            lc45: 77.5,
            lc30: 56,
            lc10: 32
        },
        "informative.2100": {
            contrast: 68.35728872157956,
            lc60: 90,
            lc45: 72.5,
            lc30: 52.5,
            lc10: 30
        },
        "informative.2200": {
            contrast: 74.51398033138558,
            lc60: 85,
            lc45: 68,
            lc30: 49.5,
            lc10: 28
        },
        "informative.2300": {
            contrast: 80.64912236896821,
            lc60: 79.5,
            lc45: 64,
            lc30: 46.5,
            lc10: 26.5
        },
        "informative.2400": {
            contrast: 87.10760734776561,
            lc60: 75,
            lc45: 60,
            lc30: 44,
            lc10: 25
        },
        "informative.2500": {
            contrast: 93.57553642011423,
            lc60: 71,
            lc45: 57,
            lc30: 42,
            lc10: 24
        }
    },
    "informative.800": {
        "informative.100": {
            contrast: 19.863947162983855,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53
        },
        "informative.200": {
            contrast: 19.363721601869425,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63.5
        },
        "informative.300": {
            contrast: 17.689450264446062,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78
        },
        "informative.400": {
            contrast: 15.37634457735016,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 97
        },
        "informative.500": {
            contrast: 12.126191027012329,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.600": {
            contrast: 7.561315757785272,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1000": {
            contrast: 8.043776078991547,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1100": {
            contrast: 12.513417933313114,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1200": {
            contrast: 17.516216273653733,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87
        },
        "informative.1300": {
            contrast: 22.72116324558616,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "informative.1400": {
            contrast: 27.151169934625386,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "informative.1500": {
            contrast: 31.70261648284965,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 52.5
        },
        "informative.1600": {
            contrast: 36.63131888802946,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 47.5
        },
        "informative.1700": {
            contrast: 41.928920967215184,
            lc60: 100,
            lc45: 100,
            lc30: 75.5,
            lc10: 42
        },
        "informative.1800": {
            contrast: 47.04484881995518,
            lc60: 100,
            lc45: 96.5,
            lc30: 69.5,
            lc10: 39
        },
        "informative.1900": {
            contrast: 52.43955043851955,
            lc60: 100,
            lc45: 88.5,
            lc30: 64,
            lc10: 36
        },
        "informative.2000": {
            contrast: 58.11290288757141,
            lc60: 100,
            lc45: 82,
            lc30: 59,
            lc10: 33.5
        },
        "informative.2100": {
            contrast: 63.90125636111179,
            lc60: 94.5,
            lc45: 76,
            lc30: 55,
            lc10: 31
        },
        "informative.2200": {
            contrast: 70.0579479709178,
            lc60: 88.5,
            lc45: 71,
            lc30: 51.5,
            lc10: 29
        },
        "informative.2300": {
            contrast: 76.19309000850042,
            lc60: 83,
            lc45: 67,
            lc30: 48.5,
            lc10: 27.5
        },
        "informative.2400": {
            contrast: 82.65157498729782,
            lc60: 78.5,
            lc45: 63,
            lc30: 45.5,
            lc10: 26
        },
        "informative.2500": {
            contrast: 89.11950405964645,
            lc60: 74,
            lc45: 59.5,
            lc30: 43,
            lc10: 24.5
        }
    },
    "informative.900": {
        "informative.100": {
            contrast: 24.780455241038943,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 42.5
        },
        "informative.200": {
            contrast: 24.28022967992451,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 49
        },
        "informative.300": {
            contrast: 22.60595834250115,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58.5
        },
        "informative.400": {
            contrast: 20.292852655405248,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "informative.500": {
            contrast: 17.04269910506742,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88
        },
        "informative.600": {
            contrast: 12.477823835840363,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.700": {
            contrast: 7.752345847717625,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1100": {
            contrast: 7.902471473996404,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1200": {
            contrast: 12.905269814337023,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1300": {
            contrast: 18.110216786269447,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84.5
        },
        "informative.1400": {
            contrast: 22.540223475308682,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69.5
        },
        "informative.1500": {
            contrast: 27.09167002353294,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "informative.1600": {
            contrast: 32.02037242871275,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 52.5
        },
        "informative.1700": {
            contrast: 37.31797450789847,
            lc60: 100,
            lc45: 100,
            lc30: 83,
            lc10: 46
        },
        "informative.1800": {
            contrast: 42.433902360638456,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 42.5
        },
        "informative.1900": {
            contrast: 47.82860397920283,
            lc60: 100,
            lc45: 95,
            lc30: 68.5,
            lc10: 38.5
        },
        "informative.2000": {
            contrast: 53.501956428254694,
            lc60: 100,
            lc45: 87,
            lc30: 63,
            lc10: 35.5
        },
        "informative.2100": {
            contrast: 59.29030990179507,
            lc60: 100,
            lc45: 80.5,
            lc30: 58.5,
            lc10: 32.5
        },
        "informative.2200": {
            contrast: 65.44700151160107,
            lc60: 93,
            lc45: 74.5,
            lc30: 54,
            lc10: 30.5
        },
        "informative.2300": {
            contrast: 71.58214354918371,
            lc60: 87.5,
            lc45: 70,
            lc30: 50.5,
            lc10: 29
        },
        "informative.2400": {
            contrast: 78.04062852798111,
            lc60: 81.5,
            lc45: 65.5,
            lc30: 47.5,
            lc10: 27
        },
        "informative.2500": {
            contrast: 84.50855760032974,
            lc60: 77,
            lc45: 61.5,
            lc30: 44.5,
            lc10: 25.5
        }
    },
    "informative.1000": {
        "informative.100": {
            contrast: 29.16983067219658,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 37
        },
        "informative.200": {
            contrast: 28.66960511108215,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 42
        },
        "informative.300": {
            contrast: 26.995333773658786,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 49
        },
        "informative.400": {
            contrast: 24.682228086562887,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "informative.500": {
            contrast: 21.43207453622506,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "informative.600": {
            contrast: 16.867199266998004,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88.5
        },
        "informative.700": {
            contrast: 12.141721278875266,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1200": {
            contrast: 8.692783610690435,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1300": {
            contrast: 13.897730582622861,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1400": {
            contrast: 18.327737271662095,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84
        },
        "informative.1500": {
            contrast: 22.879183819886357,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69.5
        },
        "informative.1600": {
            contrast: 27.807886225066163,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59
        },
        "informative.1700": {
            contrast: 33.105488304251885,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 51
        },
        "informative.1800": {
            contrast: 38.22141615699188,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 45.5
        },
        "informative.1900": {
            contrast: 43.61611777555625,
            lc60: 100,
            lc45: 100,
            lc30: 73.5,
            lc10: 41.5
        },
        "informative.2000": {
            contrast: 49.2894702246081,
            lc60: 100,
            lc45: 93,
            lc30: 67,
            lc10: 38
        },
        "informative.2100": {
            contrast: 55.077823698148485,
            lc60: 100,
            lc45: 85.5,
            lc30: 62,
            lc10: 35
        },
        "informative.2200": {
            contrast: 61.234515307954496,
            lc60: 98.5,
            lc45: 78.5,
            lc30: 57,
            lc10: 32
        },
        "informative.2300": {
            contrast: 67.36965734553712,
            lc60: 91.5,
            lc45: 73,
            lc30: 53,
            lc10: 29.5
        },
        "informative.2400": {
            contrast: 73.82814232433452,
            lc60: 85,
            lc45: 68,
            lc30: 49.5,
            lc10: 28
        },
        "informative.2500": {
            contrast: 80.29607139668316,
            lc60: 80,
            lc45: 63.5,
            lc30: 46.5,
            lc10: 26
        }
    },
    "informative.1100": {
        "informative.100": {
            contrast: 33.69400044721556,
            lc60: 100,
            lc45: 100,
            lc30: 69,
            lc10: 32
        },
        "informative.200": {
            contrast: 33.19377488610113,
            lc60: 100,
            lc45: 100,
            lc30: 79,
            lc10: 36.5
        },
        "informative.300": {
            contrast: 31.519503548677775,
            lc60: 100,
            lc45: 100,
            lc30: 90.5,
            lc10: 42
        },
        "informative.400": {
            contrast: 29.206397861581866,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 48
        },
        "informative.500": {
            contrast: 25.956244311244042,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "informative.600": {
            contrast: 21.391369042016986,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "informative.700": {
            contrast: 16.66589105389425,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89.5
        },
        "informative.800": {
            contrast: 11.822015493836727,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1300": {
            contrast: 9.471219716160597,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1400": {
            contrast: 13.901226405199829,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1500": {
            contrast: 18.45267295342409,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84
        },
        "informative.1600": {
            contrast: 23.381375358603897,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "informative.1700": {
            contrast: 28.678977437789616,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58
        },
        "informative.1800": {
            contrast: 33.79490529052961,
            lc60: 100,
            lc45: 100,
            lc30: 90.5,
            lc10: 50.5
        },
        "informative.1900": {
            contrast: 39.189606909093975,
            lc60: 100,
            lc45: 100,
            lc30: 80.5,
            lc10: 46
        },
        "informative.2000": {
            contrast: 44.862959358145844,
            lc60: 100,
            lc45: 100,
            lc30: 72.5,
            lc10: 41
        },
        "informative.2100": {
            contrast: 50.651312831686226,
            lc60: 100,
            lc45: 91,
            lc30: 66,
            lc10: 37.5
        },
        "informative.2200": {
            contrast: 56.80800444149223,
            lc60: 100,
            lc45: 83,
            lc30: 60.5,
            lc10: 34
        },
        "informative.2300": {
            contrast: 62.943146479074855,
            lc60: 96,
            lc45: 77,
            lc30: 56,
            lc10: 31.5
        },
        "informative.2400": {
            contrast: 69.40163145787226,
            lc60: 89.5,
            lc45: 72,
            lc30: 52,
            lc10: 30
        },
        "informative.2500": {
            contrast: 75.8695605302209,
            lc60: 83.5,
            lc45: 67,
            lc30: 49,
            lc10: 28
        }
    },
    "informative.1200": {
        "informative.100": {
            contrast: 38.69626839442489,
            lc60: 100,
            lc45: 100,
            lc30: 58,
            lc10: 28.5
        },
        "informative.200": {
            contrast: 38.19604283331046,
            lc60: 100,
            lc45: 100,
            lc30: 65.5,
            lc10: 32
        },
        "informative.300": {
            contrast: 36.521771495887094,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 36.5
        },
        "informative.400": {
            contrast: 34.208665808791196,
            lc60: 100,
            lc45: 100,
            lc30: 83.5,
            lc10: 41
        },
        "informative.500": {
            contrast: 30.958512258453357,
            lc60: 100,
            lc45: 100,
            lc30: 96.5,
            lc10: 47.5
        },
        "informative.600": {
            contrast: 26.393636989226305,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "informative.700": {
            contrast: 21.668159001103575,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "informative.800": {
            contrast: 16.82428344104605,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89.5
        },
        "informative.900": {
            contrast: 11.937148119873466,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1000": {
            contrast: 7.562811417963229,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1400": {
            contrast: 8.916310245674413,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1500": {
            contrast: 13.467756793898678,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1600": {
            contrast: 18.396459199078482,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83.5
        },
        "informative.1700": {
            contrast: 23.694061278264204,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68.5
        },
        "informative.1800": {
            contrast: 28.809989131004194,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58
        },
        "informative.1900": {
            contrast: 34.20469074956856,
            lc60: 100,
            lc45: 100,
            lc30: 90,
            lc10: 51.5
        },
        "informative.2000": {
            contrast: 39.878043198620425,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 46
        },
        "informative.2100": {
            contrast: 45.66639667216081,
            lc60: 100,
            lc45: 98.5,
            lc30: 72.5,
            lc10: 41
        },
        "informative.2200": {
            contrast: 51.82308828196681,
            lc60: 100,
            lc45: 89.5,
            lc30: 65.5,
            lc10: 37
        },
        "informative.2300": {
            contrast: 57.95823031954944,
            lc60: 100,
            lc45: 82,
            lc30: 60,
            lc10: 34
        },
        "informative.2400": {
            contrast: 64.41671529834684,
            lc60: 95,
            lc45: 76.5,
            lc30: 55,
            lc10: 31.5
        },
        "informative.2500": {
            contrast: 70.88464437069547,
            lc60: 88,
            lc45: 70.5,
            lc30: 52,
            lc10: 29.5
        }
    },
    "informative.1300": {
        "informative.100": {
            contrast: 43.84032956971635,
            lc60: 100,
            lc45: 100,
            lc30: 51,
            lc10: 25
        },
        "informative.200": {
            contrast: 43.34010400860192,
            lc60: 100,
            lc45: 100,
            lc30: 57,
            lc10: 28.5
        },
        "informative.300": {
            contrast: 41.66583267117856,
            lc60: 100,
            lc45: 100,
            lc30: 64,
            lc10: 32
        },
        "informative.400": {
            contrast: 39.35272698408266,
            lc60: 100,
            lc45: 100,
            lc30: 71.5,
            lc10: 35.5
        },
        "informative.500": {
            contrast: 36.10257343374483,
            lc60: 100,
            lc45: 100,
            lc30: 80.5,
            lc10: 40.5
        },
        "informative.600": {
            contrast: 31.537698164517774,
            lc60: 100,
            lc45: 100,
            lc30: 94,
            lc10: 47
        },
        "informative.700": {
            contrast: 26.812220176395034,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "informative.800": {
            contrast: 21.968344616337514,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "informative.900": {
            contrast: 17.081209295164932,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88.5
        },
        "informative.1000": {
            contrast: 12.706872593254696,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1100": {
            contrast: 8.188517386508193,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1500": {
            contrast: 8.251091887444913,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1600": {
            contrast: 13.179794292624722,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1700": {
            contrast: 18.477396371810443,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85.5
        },
        "informative.1800": {
            contrast: 23.593324224550436,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69.5
        },
        "informative.1900": {
            contrast: 28.9880258431148,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "informative.2000": {
            contrast: 34.66137829216666,
            lc60: 100,
            lc45: 100,
            lc30: 90,
            lc10: 52
        },
        "informative.2100": {
            contrast: 40.44973176570704,
            lc60: 100,
            lc45: 100,
            lc30: 79,
            lc10: 45.5
        },
        "informative.2200": {
            contrast: 46.60642337551305,
            lc60: 100,
            lc45: 97,
            lc30: 72,
            lc10: 41
        },
        "informative.2300": {
            contrast: 52.74156541309568,
            lc60: 100,
            lc45: 88.5,
            lc30: 65,
            lc10: 38
        },
        "informative.2400": {
            contrast: 59.200050391893086,
            lc60: 100,
            lc45: 81.5,
            lc30: 60,
            lc10: 34.5
        },
        "informative.2500": {
            contrast: 65.66797946424171,
            lc60: 93,
            lc45: 75,
            lc30: 55,
            lc10: 31.5
        }
    },
    "informative.1400": {
        "informative.100": {
            contrast: 48.17552977613624,
            lc60: 100,
            lc45: 77,
            lc30: 46.5,
            lc10: 23
        },
        "informative.200": {
            contrast: 47.67530421502181,
            lc60: 100,
            lc45: 85.5,
            lc30: 51.5,
            lc10: 26
        },
        "informative.300": {
            contrast: 46.00103287759844,
            lc60: 100,
            lc45: 95.5,
            lc30: 57.5,
            lc10: 29
        },
        "informative.400": {
            contrast: 43.68792719050254,
            lc60: 100,
            lc45: 100,
            lc30: 63.5,
            lc10: 32
        },
        "informative.500": {
            contrast: 40.43777364016471,
            lc60: 100,
            lc45: 100,
            lc30: 71.5,
            lc10: 36
        },
        "informative.600": {
            contrast: 35.872898370937655,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 41
        },
        "informative.700": {
            contrast: 31.147420382814918,
            lc60: 100,
            lc45: 100,
            lc30: 96,
            lc10: 48.5
        },
        "informative.800": {
            contrast: 26.303544822757395,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "informative.900": {
            contrast: 21.416409501584816,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "informative.1000": {
            contrast: 17.042072799674578,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89
        },
        "informative.1100": {
            contrast: 12.523717592928078,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1200": {
            contrast: 7.517683463488603,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1600": {
            contrast: 8.717863440809701,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1700": {
            contrast: 14.015465519995423,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1800": {
            contrast: 19.131393372735417,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83
        },
        "informative.1900": {
            contrast: 24.526094991299782,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "informative.2000": {
            contrast: 30.19944744035164,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 58.5
        },
        "informative.2100": {
            contrast: 35.98780091389202,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 50.5
        },
        "informative.2200": {
            contrast: 42.14449252369803,
            lc60: 100,
            lc45: 100,
            lc30: 77.5,
            lc10: 44.5
        },
        "informative.2300": {
            contrast: 48.27963456128066,
            lc60: 100,
            lc45: 94.5,
            lc30: 69.5,
            lc10: 40.5
        },
        "informative.2400": {
            contrast: 54.73811954007807,
            lc60: 100,
            lc45: 86.5,
            lc30: 63.5,
            lc10: 37
        },
        "informative.2500": {
            contrast: 61.20604861242669,
            lc60: 98.5,
            lc45: 79.5,
            lc30: 58,
            lc10: 33.5
        }
    },
    "informative.1500": {
        "informative.100": {
            contrast: 52.59250549408462,
            lc60: 100,
            lc45: 67.5,
            lc30: 42.5,
            lc10: 21.5
        },
        "informative.200": {
            contrast: 52.092279932970186,
            lc60: 100,
            lc45: 74,
            lc30: 47,
            lc10: 23.5
        },
        "informative.300": {
            contrast: 50.41800859554682,
            lc60: 100,
            lc45: 81.5,
            lc30: 52,
            lc10: 26
        },
        "informative.400": {
            contrast: 48.10490290845093,
            lc60: 100,
            lc45: 89.5,
            lc30: 57,
            lc10: 28.5
        },
        "informative.500": {
            contrast: 44.8547493581131,
            lc60: 100,
            lc45: 100,
            lc30: 63.5,
            lc10: 31.5
        },
        "informative.600": {
            contrast: 40.28987408888604,
            lc60: 100,
            lc45: 100,
            lc30: 71.5,
            lc10: 36
        },
        "informative.700": {
            contrast: 35.564396100763304,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 41.5
        },
        "informative.800": {
            contrast: 30.72052054070578,
            lc60: 100,
            lc45: 100,
            lc30: 97.5,
            lc10: 48.5
        },
        "informative.900": {
            contrast: 25.8333852195332,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58
        },
        "informative.1000": {
            contrast: 21.459048517622968,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "informative.1100": {
            contrast: 16.940693310876465,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89
        },
        "informative.1200": {
            contrast: 11.934659181436992,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1700": {
            contrast: 9.412026509514765,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1800": {
            contrast: 14.52795436225476,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1900": {
            contrast: 19.92265598081913,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78.5
        },
        "informative.2000": {
            contrast: 25.596008429870988,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64.5
        },
        "informative.2100": {
            contrast: 31.384361903411367,
            lc60: 100,
            lc45: 100,
            lc30: 96,
            lc10: 54
        },
        "informative.2200": {
            contrast: 37.54105351321738,
            lc60: 100,
            lc45: 100,
            lc30: 83.5,
            lc10: 46.5
        },
        "informative.2300": {
            contrast: 43.6761955508,
            lc60: 100,
            lc45: 100,
            lc30: 73.5,
            lc10: 41
        },
        "informative.2400": {
            contrast: 50.13468052959741,
            lc60: 100,
            lc45: 91.5,
            lc30: 65.5,
            lc10: 36.5
        },
        "informative.2500": {
            contrast: 56.60260960194603,
            lc60: 100,
            lc45: 83,
            lc30: 59.5,
            lc10: 33
        }
    },
    "informative.1600": {
        "informative.100": {
            contrast: 57.33701207889255,
            lc60: 100,
            lc45: 61.5,
            lc30: 39.5,
            lc10: 19.5
        },
        "informative.200": {
            contrast: 56.836786517778116,
            lc60: 100,
            lc45: 66.5,
            lc30: 43,
            lc10: 21.5
        },
        "informative.300": {
            contrast: 55.162515180354745,
            lc60: 100,
            lc45: 73,
            lc30: 47,
            lc10: 23.5
        },
        "informative.400": {
            contrast: 52.84940949325885,
            lc60: 100,
            lc45: 80,
            lc30: 51.5,
            lc10: 25.5
        },
        "informative.500": {
            contrast: 49.59925594292102,
            lc60: 100,
            lc45: 88.5,
            lc30: 56.5,
            lc10: 28.5
        },
        "informative.600": {
            contrast: 45.03438067369396,
            lc60: 100,
            lc45: 99.5,
            lc30: 63,
            lc10: 31.5
        },
        "informative.700": {
            contrast: 40.30890268557122,
            lc60: 100,
            lc45: 100,
            lc30: 72,
            lc10: 36
        },
        "informative.800": {
            contrast: 35.4650271255137,
            lc60: 100,
            lc45: 100,
            lc30: 83.5,
            lc10: 41.5
        },
        "informative.900": {
            contrast: 30.577891804341117,
            lc60: 100,
            lc45: 100,
            lc30: 97.5,
            lc10: 48.5
        },
        "informative.1000": {
            contrast: 26.203555102430876,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "informative.1100": {
            contrast: 21.685199895684377,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69.5
        },
        "informative.1200": {
            contrast: 16.679165766244903,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88.5
        },
        "informative.1300": {
            contrast: 11.521216592084413,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1800": {
            contrast: 9.522723777040563,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1900": {
            contrast: 14.91742539560493,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2000": {
            contrast: 20.59077784465679,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77
        },
        "informative.2100": {
            contrast: 26.379131318197167,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61.5
        },
        "informative.2200": {
            contrast: 32.53582292800318,
            lc60: 100,
            lc45: 100,
            lc30: 93.5,
            lc10: 51.5
        },
        "informative.2300": {
            contrast: 38.6709649655858,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 44.5
        },
        "informative.2400": {
            contrast: 45.12944994438321,
            lc60: 100,
            lc45: 99.5,
            lc30: 71,
            lc10: 39
        },
        "informative.2500": {
            contrast: 51.597379016731836,
            lc60: 100,
            lc45: 89.5,
            lc30: 64,
            lc10: 34.5
        }
    },
    "informative.1700": {
        "informative.100": {
            contrast: 62.395807560879526,
            lc60: 83,
            lc45: 56,
            lc30: 36,
            lc10: 18.5
        },
        "informative.200": {
            contrast: 61.895581999765085,
            lc60: 90.5,
            lc45: 60.5,
            lc30: 39,
            lc10: 20
        },
        "informative.300": {
            contrast: 60.22131066234172,
            lc60: 99,
            lc45: 66,
            lc30: 42.5,
            lc10: 22
        },
        "informative.400": {
            contrast: 57.908204975245816,
            lc60: 100,
            lc45: 71.5,
            lc30: 46.5,
            lc10: 23.5
        },
        "informative.500": {
            contrast: 54.65805142490798,
            lc60: 100,
            lc45: 78.5,
            lc30: 50.5,
            lc10: 25.5
        },
        "informative.600": {
            contrast: 50.09317615568093,
            lc60: 100,
            lc45: 87.5,
            lc30: 56,
            lc10: 28
        },
        "informative.700": {
            contrast: 45.367698167558196,
            lc60: 100,
            lc45: 98.5,
            lc30: 63,
            lc10: 31.5
        },
        "informative.800": {
            contrast: 40.52382260750067,
            lc60: 100,
            lc45: 100,
            lc30: 71.5,
            lc10: 36
        },
        "informative.900": {
            contrast: 35.63668728632809,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 41
        },
        "informative.1000": {
            contrast: 31.262350584417852,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 47
        },
        "informative.1100": {
            contrast: 26.743995377671354,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54.5
        },
        "informative.1200": {
            contrast: 21.73796124823188,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67
        },
        "informative.1300": {
            contrast: 16.580012074071387,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89
        },
        "informative.1400": {
            contrast: 12.225952223689408,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1500": {
            contrast: 7.783578035685222,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1900": {
            contrast: 9.515903475087338,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2000": {
            contrast: 15.1892559241392,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98
        },
        "informative.2100": {
            contrast: 20.977609397679583,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75
        },
        "informative.2200": {
            contrast: 27.134301007485583,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60.5
        },
        "informative.2300": {
            contrast: 33.269443045068215,
            lc60: 100,
            lc45: 100,
            lc30: 91.5,
            lc10: 50.5
        },
        "informative.2400": {
            contrast: 39.727928023865616,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 43.5
        },
        "informative.2500": {
            contrast: 46.19585709621424,
            lc60: 100,
            lc45: 97.5,
            lc30: 68.5,
            lc10: 38
        }
    },
    "informative.1800": {
        "informative.100": {
            contrast: 67.24433865357481,
            lc60: 72.5,
            lc45: 51.5,
            lc30: 33.5,
            lc10: 17
        },
        "informative.200": {
            contrast: 66.7441130924604,
            lc60: 78.5,
            lc45: 55.5,
            lc30: 36,
            lc10: 18.5
        },
        "informative.300": {
            contrast: 65.06984175503703,
            lc60: 85.5,
            lc45: 60.5,
            lc30: 39,
            lc10: 20
        },
        "informative.400": {
            contrast: 62.75673606794112,
            lc60: 92,
            lc45: 65,
            lc30: 42,
            lc10: 21.5
        },
        "informative.500": {
            contrast: 59.50658251760329,
            lc60: 100,
            lc45: 71,
            lc30: 46,
            lc10: 23
        },
        "informative.600": {
            contrast: 54.94170724837624,
            lc60: 100,
            lc45: 78,
            lc30: 50.5,
            lc10: 25.5
        },
        "informative.700": {
            contrast: 50.2162292602535,
            lc60: 100,
            lc45: 87,
            lc30: 55.5,
            lc10: 28.5
        },
        "informative.800": {
            contrast: 45.37235370019598,
            lc60: 100,
            lc45: 98.5,
            lc30: 62.5,
            lc10: 31.5
        },
        "informative.900": {
            contrast: 40.485218379023394,
            lc60: 100,
            lc45: 100,
            lc30: 71.5,
            lc10: 36
        },
        "informative.1000": {
            contrast: 36.110881677113156,
            lc60: 100,
            lc45: 100,
            lc30: 80.5,
            lc10: 40.5
        },
        "informative.1100": {
            contrast: 31.592526470366657,
            lc60: 100,
            lc45: 100,
            lc30: 93.5,
            lc10: 46
        },
        "informative.1200": {
            contrast: 26.58649234092718,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "informative.1300": {
            contrast: 21.42854316676669,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "informative.1400": {
            contrast: 17.07448331638471,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85.5
        },
        "informative.1500": {
            contrast: 12.632109128380526,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1600": {
            contrast: 7.85387567082525,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2000": {
            contrast: 9.953226818426856,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2100": {
            contrast: 15.741580291967239,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95.5
        },
        "informative.2200": {
            contrast: 21.898271901773246,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "informative.2300": {
            contrast: 28.033413939355867,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58
        },
        "informative.2400": {
            contrast: 34.491898918153275,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 49
        },
        "informative.2500": {
            contrast: 40.9598279905019,
            lc60: 100,
            lc45: 100,
            lc30: 76,
            lc10: 42
        }
    },
    "informative.1900": {
        "informative.100": {
            contrast: 72.3210624798527,
            lc60: 66.5,
            lc45: 48,
            lc30: 31.5,
            lc10: 16
        },
        "informative.200": {
            contrast: 71.82083691873827,
            lc60: 71.5,
            lc45: 51.5,
            lc30: 33.5,
            lc10: 17
        },
        "informative.300": {
            contrast: 70.14656558131489,
            lc60: 77.5,
            lc45: 55.5,
            lc30: 36,
            lc10: 18.5
        },
        "informative.400": {
            contrast: 67.83345989421899,
            lc60: 83.5,
            lc45: 59,
            lc30: 38.5,
            lc10: 20
        },
        "informative.500": {
            contrast: 64.58330634388115,
            lc60: 90,
            lc45: 64,
            lc30: 41.5,
            lc10: 21.5
        },
        "informative.600": {
            contrast: 60.0184310746541,
            lc60: 99.5,
            lc45: 70,
            lc30: 45.5,
            lc10: 23.5
        },
        "informative.700": {
            contrast: 55.29295308653137,
            lc60: 100,
            lc45: 77.5,
            lc30: 50,
            lc10: 25.5
        },
        "informative.800": {
            contrast: 50.44907752647384,
            lc60: 100,
            lc45: 86.5,
            lc30: 55,
            lc10: 28
        },
        "informative.900": {
            contrast: 45.56194220530126,
            lc60: 100,
            lc45: 98,
            lc30: 62,
            lc10: 31.5
        },
        "informative.1000": {
            contrast: 41.187605503391026,
            lc60: 100,
            lc45: 100,
            lc30: 69,
            lc10: 34.5
        },
        "informative.1100": {
            contrast: 36.66925029664452,
            lc60: 100,
            lc45: 100,
            lc30: 79,
            lc10: 38.5
        },
        "informative.1200": {
            contrast: 31.66321616720505,
            lc60: 100,
            lc45: 100,
            lc30: 93,
            lc10: 44.5
        },
        "informative.1300": {
            contrast: 26.505266993044557,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53.5
        },
        "informative.1400": {
            contrast: 22.151207142662578,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "informative.1500": {
            contrast: 17.708832954658394,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85.5
        },
        "informative.1600": {
            contrast: 12.930599497103115,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1700": {
            contrast: 7.829013464145687,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2100": {
            contrast: 10.200685875845952,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2200": {
            contrast: 16.35737748565196,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93.5
        },
        "informative.2300": {
            contrast: 22.492519523234584,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70.5
        },
        "informative.2400": {
            contrast: 28.951004502031992,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "informative.2500": {
            contrast: 35.41893357438061,
            lc60: 100,
            lc45: 100,
            lc30: 86,
            lc10: 47
        }
    },
    "informative.2000": {
        "informative.100": {
            contrast: 77.62317302718502,
            lc60: 61.5,
            lc45: 44.5,
            lc30: 29,
            lc10: 15
        },
        "informative.200": {
            contrast: 77.12294746607058,
            lc60: 66,
            lc45: 47.5,
            lc30: 31,
            lc10: 16
        },
        "informative.300": {
            contrast: 75.44867612864722,
            lc60: 70.5,
            lc45: 51,
            lc30: 33.5,
            lc10: 17
        },
        "informative.400": {
            contrast: 73.13557044155132,
            lc60: 75.5,
            lc45: 54,
            lc30: 35.5,
            lc10: 18.5
        },
        "informative.500": {
            contrast: 69.88541689121348,
            lc60: 81,
            lc45: 58.5,
            lc30: 38,
            lc10: 19.5
        },
        "informative.600": {
            contrast: 65.32054162198642,
            lc60: 89,
            lc45: 63.5,
            lc30: 41.5,
            lc10: 21.5
        },
        "informative.700": {
            contrast: 60.5950636338637,
            lc60: 98.5,
            lc45: 69,
            lc30: 45,
            lc10: 23
        },
        "informative.800": {
            contrast: 55.75118807380617,
            lc60: 100,
            lc45: 77,
            lc30: 49.5,
            lc10: 25
        },
        "informative.900": {
            contrast: 50.86405275263359,
            lc60: 100,
            lc45: 85.5,
            lc30: 55,
            lc10: 28
        },
        "informative.1000": {
            contrast: 46.48971605072335,
            lc60: 100,
            lc45: 95.5,
            lc30: 60.5,
            lc10: 30
        },
        "informative.1100": {
            contrast: 41.97136084397685,
            lc60: 100,
            lc45: 100,
            lc30: 67.5,
            lc10: 33.5
        },
        "informative.1200": {
            contrast: 36.965326714537376,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 38
        },
        "informative.1300": {
            contrast: 31.807377540376887,
            lc60: 100,
            lc45: 100,
            lc30: 93,
            lc10: 43
        },
        "informative.1400": {
            contrast: 27.453317689994904,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51
        },
        "informative.1500": {
            contrast: 23.01094350199072,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64.5
        },
        "informative.1600": {
            contrast: 18.232710044435443,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82
        },
        "informative.1700": {
            contrast: 13.131124011478015,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1800": {
            contrast: 8.235418198061641,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2200": {
            contrast: 10.510072717989086,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2300": {
            contrast: 16.645214755571715,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 90.5
        },
        "informative.2400": {
            contrast: 23.10369973436912,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "informative.2500": {
            contrast: 29.571628806717744,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54
        }
    },
    "informative.2100": {
        "informative.100": {
            contrast: 82.99671769955278,
            lc60: 57,
            lc45: 41.5,
            lc30: 27.5,
            lc10: 14
        },
        "informative.200": {
            contrast: 82.49649213843836,
            lc60: 61,
            lc45: 44.5,
            lc30: 29.5,
            lc10: 15
        },
        "informative.300": {
            contrast: 80.82222080101498,
            lc60: 65,
            lc45: 47,
            lc30: 31,
            lc10: 16
        },
        "informative.400": {
            contrast: 78.50911511391908,
            lc60: 69,
            lc45: 50.5,
            lc30: 33,
            lc10: 17
        },
        "informative.500": {
            contrast: 75.25896156358125,
            lc60: 74,
            lc45: 53.5,
            lc30: 35,
            lc10: 18
        },
        "informative.600": {
            contrast: 70.6940862943542,
            lc60: 80.5,
            lc45: 58,
            lc30: 37.5,
            lc10: 19.5
        },
        "informative.700": {
            contrast: 65.96860830623146,
            lc60: 88,
            lc45: 62.5,
            lc30: 41,
            lc10: 21
        },
        "informative.800": {
            contrast: 61.12473274617394,
            lc60: 97,
            lc45: 68.5,
            lc30: 44.5,
            lc10: 22.5
        },
        "informative.900": {
            contrast: 56.237597425001354,
            lc60: 100,
            lc45: 75.5,
            lc30: 49,
            lc10: 25
        },
        "informative.1000": {
            contrast: 51.86326072309112,
            lc60: 100,
            lc45: 83.5,
            lc30: 53,
            lc10: 27
        },
        "informative.1100": {
            contrast: 47.34490551634462,
            lc60: 100,
            lc45: 93,
            lc30: 58,
            lc10: 29
        },
        "informative.1200": {
            contrast: 42.33887138690514,
            lc60: 100,
            lc45: 100,
            lc30: 65.5,
            lc10: 33
        },
        "informative.1300": {
            contrast: 37.18092221274465,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 36.5
        },
        "informative.1400": {
            contrast: 32.82686236236267,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 41.5
        },
        "informative.1500": {
            contrast: 28.38448817435848,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51
        },
        "informative.1600": {
            contrast: 23.606254716803207,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "informative.1700": {
            contrast: 18.50466868384578,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81.5
        },
        "informative.1800": {
            contrast: 13.608962870429403,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1900": {
            contrast: 8.476801753369585,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2300": {
            contrast: 10.659409989612062,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2400": {
            contrast: 17.11789496840947,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89
        },
        "informative.2500": {
            contrast: 23.585824040758094,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        }
    },
    "informative.2200": {
        "informative.100": {
            contrast: 88.67513951268116,
            lc60: 53,
            lc45: 39,
            lc30: 25.5,
            lc10: 13
        },
        "informative.200": {
            contrast: 88.17491395156671,
            lc60: 56.5,
            lc45: 41,
            lc30: 27,
            lc10: 14
        },
        "informative.300": {
            contrast: 86.50064261414336,
            lc60: 60,
            lc45: 43.5,
            lc30: 29,
            lc10: 15
        },
        "informative.400": {
            contrast: 84.18753692704745,
            lc60: 63.5,
            lc45: 46.5,
            lc30: 30.5,
            lc10: 16
        },
        "informative.500": {
            contrast: 80.93738337670962,
            lc60: 67.5,
            lc45: 49,
            lc30: 32.5,
            lc10: 16.5
        },
        "informative.600": {
            contrast: 76.37250810748256,
            lc60: 72.5,
            lc45: 53,
            lc30: 34.5,
            lc10: 18
        },
        "informative.700": {
            contrast: 71.64703011935983,
            lc60: 79,
            lc45: 57,
            lc30: 37.5,
            lc10: 19.5
        },
        "informative.800": {
            contrast: 66.80315455930231,
            lc60: 86.5,
            lc45: 61.5,
            lc30: 40,
            lc10: 20.5
        },
        "informative.900": {
            contrast: 61.916019238129714,
            lc60: 95.5,
            lc45: 67,
            lc30: 43.5,
            lc10: 22.5
        },
        "informative.1000": {
            contrast: 57.541682536219476,
            lc60: 100,
            lc45: 73.5,
            lc30: 47,
            lc10: 24.5
        },
        "informative.1100": {
            contrast: 53.02332732947298,
            lc60: 100,
            lc45: 80.5,
            lc30: 51,
            lc10: 25.5
        },
        "informative.1200": {
            contrast: 48.01729320003351,
            lc60: 100,
            lc45: 92,
            lc30: 57,
            lc10: 28.5
        },
        "informative.1300": {
            contrast: 42.85934402587302,
            lc60: 100,
            lc45: 100,
            lc30: 63.5,
            lc10: 31.5
        },
        "informative.1400": {
            contrast: 38.505284175491035,
            lc60: 100,
            lc45: 100,
            lc30: 72.5,
            lc10: 35
        },
        "informative.1500": {
            contrast: 34.06290998748685,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 42
        },
        "informative.1600": {
            contrast: 29.284676529931573,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51.5
        },
        "informative.1700": {
            contrast: 24.18309049697415,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63
        },
        "informative.1800": {
            contrast: 19.287384683557775,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79
        },
        "informative.1900": {
            contrast: 14.155223566497954,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2000": {
            contrast: 8.789025361613835,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2400": {
            contrast: 10.730442486383982,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2500": {
            contrast: 17.19837155873261,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88.5
        }
    },
    "informative.2300": {
        "informative.100": {
            contrast: 94.29831861213405,
            lc60: 50,
            lc45: 36.5,
            lc30: 24,
            lc10: 12.5
        },
        "informative.200": {
            contrast: 93.79809305101962,
            lc60: 52.5,
            lc45: 38.5,
            lc30: 25.5,
            lc10: 13.5
        },
        "informative.300": {
            contrast: 92.12382171359627,
            lc60: 56,
            lc45: 40.5,
            lc30: 27.5,
            lc10: 14
        },
        "informative.400": {
            contrast: 89.81071602650036,
            lc60: 59,
            lc45: 43,
            lc30: 28.5,
            lc10: 14.5
        },
        "informative.500": {
            contrast: 86.56056247616253,
            lc60: 62,
            lc45: 45.5,
            lc30: 30,
            lc10: 15.5
        },
        "informative.600": {
            contrast: 81.99568720693547,
            lc60: 67,
            lc45: 48.5,
            lc30: 32,
            lc10: 17
        },
        "informative.700": {
            contrast: 77.27020921881274,
            lc60: 72,
            lc45: 52.5,
            lc30: 34.5,
            lc10: 17.5
        },
        "informative.800": {
            contrast: 72.4263336587552,
            lc60: 77.5,
            lc45: 56,
            lc30: 37,
            lc10: 19
        },
        "informative.900": {
            contrast: 67.53919833758263,
            lc60: 85.5,
            lc45: 61,
            lc30: 39.5,
            lc10: 20
        },
        "informative.1000": {
            contrast: 63.164861635672395,
            lc60: 93,
            lc45: 66,
            lc30: 42.5,
            lc10: 22
        },
        "informative.1100": {
            contrast: 58.646506428925896,
            lc60: 100,
            lc45: 71.5,
            lc30: 45.5,
            lc10: 23.5
        },
        "informative.1200": {
            contrast: 53.64047229948642,
            lc60: 100,
            lc45: 79,
            lc30: 50,
            lc10: 25
        },
        "informative.1300": {
            contrast: 48.482523125325926,
            lc60: 100,
            lc45: 89.5,
            lc30: 55,
            lc10: 27.5
        },
        "informative.1400": {
            contrast: 44.12846327494395,
            lc60: 100,
            lc45: 100,
            lc30: 62.5,
            lc10: 30.5
        },
        "informative.1500": {
            contrast: 39.686089086939766,
            lc60: 100,
            lc45: 100,
            lc30: 72,
            lc10: 36.5
        },
        "informative.1600": {
            contrast: 34.907855629384485,
            lc60: 100,
            lc45: 100,
            lc30: 85,
            lc10: 42.5
        },
        "informative.1700": {
            contrast: 29.806269596427054,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 50.5
        },
        "informative.1800": {
            contrast: 24.910563783010684,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61
        },
        "informative.1900": {
            contrast: 19.778402665950864,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76
        },
        "informative.2000": {
            contrast: 14.412204461066743,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2100": {
            contrast: 8.967645921269916,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2500": {
            contrast: 10.813292062104379,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "informative.2400": {
        "informative.100": {
            contrast: 100.18229182589755,
            lc60: 46.5,
            lc45: 34.5,
            lc30: 22.5,
            lc10: 12
        },
        "informative.200": {
            contrast: 99.68206626478312,
            lc60: 49,
            lc45: 36,
            lc30: 24,
            lc10: 12.5
        },
        "informative.300": {
            contrast: 98.00779492735975,
            lc60: 52,
            lc45: 38,
            lc30: 25.5,
            lc10: 13.5
        },
        "informative.400": {
            contrast: 95.69468924026386,
            lc60: 54.5,
            lc45: 40,
            lc30: 26.5,
            lc10: 14
        },
        "informative.500": {
            contrast: 92.44453568992603,
            lc60: 57.5,
            lc45: 42.5,
            lc30: 28,
            lc10: 14.5
        },
        "informative.600": {
            contrast: 87.87966042069895,
            lc60: 61.5,
            lc45: 45,
            lc30: 30,
            lc10: 15.5
        },
        "informative.700": {
            contrast: 83.15418243257623,
            lc60: 65.5,
            lc45: 48,
            lc30: 31.5,
            lc10: 16.5
        },
        "informative.800": {
            contrast: 78.31030687251871,
            lc60: 70.5,
            lc45: 51.5,
            lc30: 34,
            lc10: 17.5
        },
        "informative.900": {
            contrast: 73.42317155134612,
            lc60: 76.5,
            lc45: 55,
            lc30: 36,
            lc10: 19
        },
        "informative.1000": {
            contrast: 69.04883484943588,
            lc60: 83,
            lc45: 59,
            lc30: 38.5,
            lc10: 20
        },
        "informative.1100": {
            contrast: 64.53047964268939,
            lc60: 90.5,
            lc45: 63.5,
            lc30: 41.5,
            lc10: 21
        },
        "informative.1200": {
            contrast: 59.5244455132499,
            lc60: 100,
            lc45: 69,
            lc30: 44.5,
            lc10: 23
        },
        "informative.1300": {
            contrast: 54.36649633908942,
            lc60: 100,
            lc45: 77.5,
            lc30: 48.5,
            lc10: 25
        },
        "informative.1400": {
            contrast: 50.012436488707436,
            lc60: 100,
            lc45: 86.5,
            lc30: 53.5,
            lc10: 27
        },
        "informative.1500": {
            contrast: 45.57006230070325,
            lc60: 100,
            lc45: 98,
            lc30: 62,
            lc10: 31.5
        },
        "informative.1600": {
            contrast: 40.79182884314797,
            lc60: 100,
            lc45: 100,
            lc30: 71.5,
            lc10: 36
        },
        "informative.1700": {
            contrast: 35.69024281019054,
            lc60: 100,
            lc45: 100,
            lc30: 83,
            lc10: 42
        },
        "informative.1800": {
            contrast: 30.79453699677417,
            lc60: 100,
            lc45: 100,
            lc30: 97,
            lc10: 50
        },
        "informative.1900": {
            contrast: 25.66237587971435,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "informative.2000": {
            contrast: 20.296177674830233,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76
        },
        "informative.2100": {
            contrast: 14.851619135033403,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2200": {
            contrast: 9.09191217998789,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "informative.2500": {
        "informative.100": {
            contrast: 106.04067321268862,
            lc60: 44,
            lc45: 32.5,
            lc30: 21.5,
            lc10: 11.5
        },
        "informative.200": {
            contrast: 105.54044765157417,
            lc60: 46.5,
            lc45: 34,
            lc30: 23,
            lc10: 12
        },
        "informative.300": {
            contrast: 103.8661763141508,
            lc60: 49,
            lc45: 36,
            lc30: 24,
            lc10: 12.5
        },
        "informative.400": {
            contrast: 101.55307062705492,
            lc60: 51,
            lc45: 37.5,
            lc30: 25,
            lc10: 13
        },
        "informative.500": {
            contrast: 98.30291707671707,
            lc60: 53.5,
            lc45: 39.5,
            lc30: 26.5,
            lc10: 14
        },
        "informative.600": {
            contrast: 93.73804180749002,
            lc60: 57,
            lc45: 41.5,
            lc30: 28,
            lc10: 15
        },
        "informative.700": {
            contrast: 89.01256381936727,
            lc60: 60.5,
            lc45: 44.5,
            lc30: 29.5,
            lc10: 15.5
        },
        "informative.800": {
            contrast: 84.16868825930975,
            lc60: 65,
            lc45: 47.5,
            lc30: 31.5,
            lc10: 16.5
        },
        "informative.900": {
            contrast: 79.28155293813718,
            lc60: 69.5,
            lc45: 50.5,
            lc30: 33.5,
            lc10: 17.5
        },
        "informative.1000": {
            contrast: 74.90721623622693,
            lc60: 74.5,
            lc45: 54,
            lc30: 35,
            lc10: 18.5
        },
        "informative.1100": {
            contrast: 70.38886102948044,
            lc60: 80.5,
            lc45: 57.5,
            lc30: 37.5,
            lc10: 19.5
        },
        "informative.1200": {
            contrast: 65.38282690004095,
            lc60: 88.5,
            lc45: 62.5,
            lc30: 40.5,
            lc10: 20.5
        },
        "informative.1300": {
            contrast: 60.22487772588047,
            lc60: 99.5,
            lc45: 68,
            lc30: 43.5,
            lc10: 22.5
        },
        "informative.1400": {
            contrast: 55.87081787549848,
            lc60: 100,
            lc45: 75,
            lc30: 47.5,
            lc10: 24
        },
        "informative.1500": {
            contrast: 51.428443687494294,
            lc60: 100,
            lc45: 85,
            lc30: 54.5,
            lc10: 27.5
        },
        "informative.1600": {
            contrast: 46.65021022993902,
            lc60: 100,
            lc45: 95.5,
            lc30: 61.5,
            lc10: 32
        },
        "informative.1700": {
            contrast: 41.54862419698159,
            lc60: 100,
            lc45: 100,
            lc30: 70,
            lc10: 36.5
        },
        "informative.1800": {
            contrast: 36.65291838356522,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 42
        },
        "informative.1900": {
            contrast: 31.5207572665054,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 49
        },
        "informative.2000": {
            contrast: 26.15455906162128,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58.5
        },
        "informative.2100": {
            contrast: 20.710000521824455,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "informative.2200": {
            contrast: 14.95029356677894,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2300": {
            contrast: 9.240656633742825,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    }
};
const $f8fd43f1ee3f8cd8$var$saffron = {
    "saffron.100": {
        "saffron.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.600": {
            contrast: 8.205958711184731,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.700": {
            contrast: 12.113108637724752,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.800": {
            contrast: 16.633727584296626,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.900": {
            contrast: 20.908441233185744,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1000": {
            contrast: 24.90836850969926,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1100": {
            contrast: 29.457057936650845,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1200": {
            contrast: 33.81788700107938,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.1300": {
            contrast: 38.743681696936314,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.1400": {
            contrast: 43.13600665861986,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.1500": {
            contrast: 47.2890601243057,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.1600": {
            contrast: 50.94750665750751,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.1700": {
            contrast: 56.127798583200864,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.1800": {
            contrast: 62.462115284182275,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.1900": {
            contrast: 69.20816602253419,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2000": {
            contrast: 75.264142360225,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2100": {
            contrast: 81.3198294326547,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2200": {
            contrast: 87.76147265475224,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2300": {
            contrast: 94.28870844287997,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2400": {
            contrast: 101.1273587637044,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2500": {
            contrast: 107.88473318309848,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        }
    },
    "saffron.200": {
        "saffron.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.600": {
            contrast: 7.817146543639872,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.700": {
            contrast: 11.724296470179892,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.800": {
            contrast: 16.244915416751766,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.900": {
            contrast: 20.519629065640885,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1000": {
            contrast: 24.5195563421544,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1100": {
            contrast: 29.06824576910598,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1200": {
            contrast: 33.429074833534514,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.1300": {
            contrast: 38.35486952939145,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.1400": {
            contrast: 42.747194491075,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.1500": {
            contrast: 46.900247956760836,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.1600": {
            contrast: 50.558694489962654,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.1700": {
            contrast: 55.738986415656,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.1800": {
            contrast: 62.07330311663741,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.1900": {
            contrast: 68.81935385498934,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2000": {
            contrast: 74.87533019268014,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2100": {
            contrast: 80.93101726510984,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2200": {
            contrast: 87.37266048720738,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2300": {
            contrast: 93.89989627533511,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2400": {
            contrast: 100.73854659615955,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2500": {
            contrast: 107.4959210155536,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        }
    },
    "saffron.300": {
        "saffron.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.700": {
            contrast: 10.578764393236876,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.800": {
            contrast: 15.099383339808748,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.900": {
            contrast: 19.37409698869787,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1000": {
            contrast: 23.374024265211382,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1100": {
            contrast: 27.922713692162965,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1200": {
            contrast: 32.2835427565915,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.1300": {
            contrast: 37.20933745244843,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.1400": {
            contrast: 41.60166241413198,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.1500": {
            contrast: 45.75471587981782,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.1600": {
            contrast: 49.41316241301964,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.1700": {
            contrast: 54.59345433871299,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.1800": {
            contrast: 60.9277710396944,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.1900": {
            contrast: 67.67382177804632,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2000": {
            contrast: 73.72979811573713,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2100": {
            contrast: 79.78548518816683,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2200": {
            contrast: 86.22712841026437,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2300": {
            contrast: 92.7543641983921,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2400": {
            contrast: 99.59301451921652,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2500": {
            contrast: 106.35038893861059,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        }
    },
    "saffron.400": {
        "saffron.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.700": {
            contrast: 8.902428989613027,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.800": {
            contrast: 13.423047936184899,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.900": {
            contrast: 17.69776158507402,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1000": {
            contrast: 21.697688861587533,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1100": {
            contrast: 26.24637828853912,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1200": {
            contrast: 30.607207352967652,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1300": {
            contrast: 35.53300204882458,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.1400": {
            contrast: 39.92532701050813,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.1500": {
            contrast: 44.07838047619396,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.1600": {
            contrast: 47.736827009395775,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.1700": {
            contrast: 52.91711893508912,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.1800": {
            contrast: 59.25143563607054,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.1900": {
            contrast: 65.99748637442246,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2000": {
            contrast: 72.05346271211327,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2100": {
            contrast: 78.10914978454296,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2200": {
            contrast: 84.5507930066405,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2300": {
            contrast: 91.07802879476823,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2400": {
            contrast: 97.91667911559266,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2500": {
            contrast: 104.67405353498674,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        }
    },
    "saffron.500": {
        "saffron.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.800": {
            contrast: 10.891490192102504,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.900": {
            contrast: 15.166203840991624,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1000": {
            contrast: 19.166131117505138,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1100": {
            contrast: 23.714820544456725,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1200": {
            contrast: 28.075649608885257,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1300": {
            contrast: 33.001444304742186,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.1400": {
            contrast: 37.393769266425736,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.1500": {
            contrast: 41.54682273211157,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.1600": {
            contrast: 45.20526926531338,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.1700": {
            contrast: 50.38556119100674,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.1800": {
            contrast: 56.71987789198815,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.1900": {
            contrast: 63.46592863034006,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2000": {
            contrast: 69.52190496803087,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2100": {
            contrast: 75.57759204046057,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2200": {
            contrast: 82.01923526255811,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2300": {
            contrast: 88.54647105068584,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2400": {
            contrast: 95.38512137151028,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2500": {
            contrast: 102.14249579090435,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        }
    },
    "saffron.600": {
        "saffron.100": {
            contrast: 9.545849040790229,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.200": {
            contrast: 9.024322539958622,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.300": {
            contrast: 7.523303064209955,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.900": {
            contrast: 11.370210638607345,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1000": {
            contrast: 15.370137915120857,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1100": {
            contrast: 19.918827342072444,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1200": {
            contrast: 24.279656406500973,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1300": {
            contrast: 29.205451102357905,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1400": {
            contrast: 33.597776064041454,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.1500": {
            contrast: 37.75082952972729,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.1600": {
            contrast: 41.40927606292911,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.1700": {
            contrast: 46.589567988622456,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.1800": {
            contrast: 52.923884689603874,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.1900": {
            contrast: 59.66993542795579,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2000": {
            contrast: 65.7259117656466,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2100": {
            contrast: 71.78159883807629,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2200": {
            contrast: 78.22324206017383,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2300": {
            contrast: 84.75047784830156,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2400": {
            contrast: 91.58912816912598,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2500": {
            contrast: 98.34650258852005,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        }
    },
    "saffron.700": {
        "saffron.100": {
            contrast: 13.807515500965204,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.200": {
            contrast: 13.285989000133593,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.300": {
            contrast: 11.784969524384925,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.400": {
            contrast: 9.66249005740771,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.900": {
            contrast: 7.642625271653635,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1000": {
            contrast: 11.642552548167151,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1100": {
            contrast: 16.191241975118732,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1200": {
            contrast: 20.55207103954727,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1300": {
            contrast: 25.477865735404198,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1400": {
            contrast: 29.87019069708775,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1500": {
            contrast: 34.02324416277359,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.1600": {
            contrast: 37.681690695975405,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.1700": {
            contrast: 42.86198262166875,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.1800": {
            contrast: 49.19629932265016,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.1900": {
            contrast: 55.94235006100209,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2000": {
            contrast: 61.998326398692896,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2100": {
            contrast: 68.05401347112259,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2200": {
            contrast: 74.49565669322013,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2300": {
            contrast: 81.02289248134785,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2400": {
            contrast: 87.8615428021723,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2500": {
            contrast: 94.61891722156635,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        }
    },
    "saffron.800": {
        "saffron.100": {
            contrast: 18.629465215516948,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87.5
        },
        "saffron.200": {
            contrast: 18.107938714685336,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 92
        },
        "saffron.300": {
            contrast: 16.606919238936673,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 97.5
        },
        "saffron.400": {
            contrast: 14.484439771959453,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.500": {
            contrast: 11.398800307475469,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1100": {
            contrast: 11.829986053200466,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1200": {
            contrast: 16.190815117629,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1300": {
            contrast: 21.11660981348593,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1400": {
            contrast: 25.50893477516948,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1500": {
            contrast: 29.661988240855315,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1600": {
            contrast: 33.320434774057134,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.1700": {
            contrast: 38.50072669975047,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.1800": {
            contrast: 44.83504340073189,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.1900": {
            contrast: 51.58109413908382,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2000": {
            contrast: 57.637070476774625,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2100": {
            contrast: 63.692757549204316,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2200": {
            contrast: 70.13440077130187,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2300": {
            contrast: 76.6616365594296,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2400": {
            contrast: 83.50028688025402,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2500": {
            contrast: 90.25766129964808,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        }
    },
    "saffron.900": {
        "saffron.100": {
            contrast: 23.103737817974853,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80
        },
        "saffron.200": {
            contrast: 22.58221131714325,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84
        },
        "saffron.300": {
            contrast: 21.08119184139458,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88
        },
        "saffron.400": {
            contrast: 18.958712374417363,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93.5
        },
        "saffron.500": {
            contrast: 15.873072909933375,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.600": {
            contrast: 11.43390371714214,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1100": {
            contrast: 7.666827793522563,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1200": {
            contrast: 12.027656857951097,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1300": {
            contrast: 16.953451553808026,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1400": {
            contrast: 21.34577651549158,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1500": {
            contrast: 25.498829981177412,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1600": {
            contrast: 29.157276514379227,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1700": {
            contrast: 34.337568440072566,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.1800": {
            contrast: 40.671885141053984,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.1900": {
            contrast: 47.4179358794059,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2000": {
            contrast: 53.47391221709671,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2100": {
            contrast: 59.5295992895264,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2200": {
            contrast: 65.97124251162396,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2300": {
            contrast: 72.49847829975168,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2400": {
            contrast: 79.33712862057611,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2500": {
            contrast: 86.09450303997018,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        }
    },
    "saffron.1000": {
        "saffron.100": {
            contrast: 27.22835442382979,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75
        },
        "saffron.200": {
            contrast: 26.706827922998183,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79
        },
        "saffron.300": {
            contrast: 25.205808447249517,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82.5
        },
        "saffron.400": {
            contrast: 23.083328980272302,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87
        },
        "saffron.500": {
            contrast: 19.997689515788316,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93
        },
        "saffron.600": {
            contrast: 15.55852032299708,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.700": {
            contrast: 11.355020063318946,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1200": {
            contrast: 8.10293751671828,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1300": {
            contrast: 13.02873221257521,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1400": {
            contrast: 17.421057174258763,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1500": {
            contrast: 21.5741106399446,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1600": {
            contrast: 25.232557173146414,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1700": {
            contrast: 30.412849098839757,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1800": {
            contrast: 36.747165799821175,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.1900": {
            contrast: 43.493216538173094,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.2000": {
            contrast: 49.5491928758639,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2100": {
            contrast: 55.60487994829359,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2200": {
            contrast: 62.04652317039114,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2300": {
            contrast: 68.57375895851887,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2400": {
            contrast: 75.4124092793433,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2500": {
            contrast: 82.16978369873736,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        }
    },
    "saffron.1100": {
        "saffron.100": {
            contrast: 31.856884105760113,
            lc60: 100,
            lc45: 100,
            lc30: 92.5,
            lc10: 70.5
        },
        "saffron.200": {
            contrast: 31.335357604928504,
            lc60: 100,
            lc45: 100,
            lc30: 97.5,
            lc10: 73.5
        },
        "saffron.300": {
            contrast: 29.834338129179837,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77
        },
        "saffron.400": {
            contrast: 27.71185866220262,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81
        },
        "saffron.500": {
            contrast: 24.626219197718637,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86
        },
        "saffron.600": {
            contrast: 20.187050004927404,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 92.5
        },
        "saffron.700": {
            contrast: 15.98354974524927,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.800": {
            contrast: 11.209683135574998,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1300": {
            contrast: 8.535797432094762,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1400": {
            contrast: 12.928122393778313,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1500": {
            contrast: 17.08117585946415,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1600": {
            contrast: 20.739622392665968,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1700": {
            contrast: 25.91991431835931,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1800": {
            contrast: 32.25423101934072,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.1900": {
            contrast: 39.00028175769265,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.2000": {
            contrast: 45.05625809538345,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.2100": {
            contrast: 51.11194516781315,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2200": {
            contrast: 57.55358838991068,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2300": {
            contrast: 64.08082417803841,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2400": {
            contrast: 70.91947449886284,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2500": {
            contrast: 77.67684891825691,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        }
    },
    "saffron.1200": {
        "saffron.100": {
            contrast: 36.24056001456831,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 66
        },
        "saffron.200": {
            contrast: 35.7190335137367,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 69
        },
        "saffron.300": {
            contrast: 34.218014037988034,
            lc60: 100,
            lc45: 100,
            lc30: 91.5,
            lc10: 72
        },
        "saffron.400": {
            contrast: 32.095534571010816,
            lc60: 100,
            lc45: 100,
            lc30: 97,
            lc10: 75.5
        },
        "saffron.500": {
            contrast: 29.009895106526834,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80.5
        },
        "saffron.600": {
            contrast: 24.5707259137356,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86
        },
        "saffron.700": {
            contrast: 20.367225654057467,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 92
        },
        "saffron.800": {
            contrast: 15.593359044383192,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.900": {
            contrast: 11.14972048706388,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1400": {
            contrast: 8.59445166702448,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1500": {
            contrast: 12.747505132710312,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1600": {
            contrast: 16.405951665912134,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1700": {
            contrast: 21.586243591605474,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1800": {
            contrast: 27.920560292586888,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1900": {
            contrast: 34.66661103093881,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.2000": {
            contrast: 40.72258736862962,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.2100": {
            contrast: 46.77827444105931,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2200": {
            contrast: 53.219917663156856,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2300": {
            contrast: 59.747153451284575,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2400": {
            contrast: 66.585803772109,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2500": {
            contrast: 73.34317819150307,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        }
    },
    "saffron.1300": {
        "saffron.100": {
            contrast: 41.13689131859541,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 61.5
        },
        "saffron.200": {
            contrast: 40.6153648177638,
            lc60: 100,
            lc45: 100,
            lc30: 80.5,
            lc10: 64.5
        },
        "saffron.300": {
            contrast: 39.11434534201514,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 67.5
        },
        "saffron.400": {
            contrast: 36.991865875037924,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 70.5
        },
        "saffron.500": {
            contrast: 33.90622641055393,
            lc60: 100,
            lc45: 100,
            lc30: 94.5,
            lc10: 74.5
        },
        "saffron.600": {
            contrast: 29.467057217762697,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79
        },
        "saffron.700": {
            contrast: 25.263556958084564,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84.5
        },
        "saffron.800": {
            contrast: 20.489690348410296,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91.5
        },
        "saffron.900": {
            contrast: 16.046051791090978,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 99.5
        },
        "saffron.1000": {
            contrast: 11.939467189696282,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1100": {
            contrast: 7.320948523907246,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1500": {
            contrast: 7.82483634075353,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1600": {
            contrast: 11.483282873955346,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1700": {
            contrast: 16.663574799648693,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1800": {
            contrast: 22.997891500630104,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1900": {
            contrast: 29.743942238982022,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.2000": {
            contrast: 35.79991857667283,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.2100": {
            contrast: 41.85560564910252,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.2200": {
            contrast: 48.29724887120007,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2300": {
            contrast: 54.82448465932779,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2400": {
            contrast: 61.66313498015222,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2500": {
            contrast: 68.42050939954629,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        }
    },
    "saffron.1400": {
        "saffron.100": {
            contrast: 45.459019821791514,
            lc60: 100,
            lc45: 100,
            lc30: 72,
            lc10: 58
        },
        "saffron.200": {
            contrast: 44.9374933209599,
            lc60: 100,
            lc45: 100,
            lc30: 75,
            lc10: 60.5
        },
        "saffron.300": {
            contrast: 43.436473845211246,
            lc60: 100,
            lc45: 100,
            lc30: 79,
            lc10: 63
        },
        "saffron.400": {
            contrast: 41.31399437823403,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 66
        },
        "saffron.500": {
            contrast: 38.22835491375004,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 69.5
        },
        "saffron.600": {
            contrast: 33.789185720958805,
            lc60: 100,
            lc45: 100,
            lc30: 94.5,
            lc10: 73.5
        },
        "saffron.700": {
            contrast: 29.585685461280676,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79
        },
        "saffron.800": {
            contrast: 24.8118188516064,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84.5
        },
        "saffron.900": {
            contrast: 20.368180294287086,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91.5
        },
        "saffron.1000": {
            contrast: 16.261595692892385,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 99
        },
        "saffron.1100": {
            contrast: 11.643077027103354,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1700": {
            contrast: 12.25179526022898,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1800": {
            contrast: 18.586111961210392,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1900": {
            contrast: 25.33216269956231,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.2000": {
            contrast: 31.388139037253115,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.2100": {
            contrast: 37.44382610968281,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.2200": {
            contrast: 43.88546933178035,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.2300": {
            contrast: 50.412705119908075,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2400": {
            contrast: 57.25135544073251,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2500": {
            contrast: 64.00872986012658,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        }
    },
    "saffron.1500": {
        "saffron.100": {
            contrast: 49.51143323537025,
            lc60: 100,
            lc45: 86,
            lc30: 68,
            lc10: 54.5
        },
        "saffron.200": {
            contrast: 48.98990673453865,
            lc60: 100,
            lc45: 89.5,
            lc30: 71,
            lc10: 56.5
        },
        "saffron.300": {
            contrast: 47.48888725878998,
            lc60: 100,
            lc45: 95,
            lc30: 74.5,
            lc10: 59
        },
        "saffron.400": {
            contrast: 45.36640779181276,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 61.5
        },
        "saffron.500": {
            contrast: 42.28076832732878,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 65
        },
        "saffron.600": {
            contrast: 37.84159913453754,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 69.5
        },
        "saffron.700": {
            contrast: 33.63809887485941,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 73.5
        },
        "saffron.800": {
            contrast: 28.864232265185137,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78.5
        },
        "saffron.900": {
            contrast: 24.420593707865827,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84.5
        },
        "saffron.1000": {
            contrast: 20.314009106471126,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91
        },
        "saffron.1100": {
            contrast: 15.695490440682091,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1200": {
            contrast: 11.312409945800603,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1700": {
            contrast: 8.06274973831791,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1800": {
            contrast: 14.397066439299325,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1900": {
            contrast: 21.143117177651245,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.2000": {
            contrast: 27.19909351534205,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.2100": {
            contrast: 33.25478058777174,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.2200": {
            contrast: 39.69642380986929,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.2300": {
            contrast: 46.223659597997006,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2400": {
            contrast: 53.06230991882145,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2500": {
            contrast: 59.81968433821551,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        }
    },
    "saffron.1600": {
        "saffron.100": {
            contrast: 53.055945599098465,
            lc60: 100,
            lc45: 80.5,
            lc30: 64.5,
            lc10: 51.5
        },
        "saffron.200": {
            contrast: 52.53441909826686,
            lc60: 100,
            lc45: 84,
            lc30: 67.5,
            lc10: 53.5
        },
        "saffron.300": {
            contrast: 51.033399622518196,
            lc60: 100,
            lc45: 88,
            lc30: 70.5,
            lc10: 55.5
        },
        "saffron.400": {
            contrast: 48.910920155540985,
            lc60: 100,
            lc45: 93.5,
            lc30: 73.5,
            lc10: 58.5
        },
        "saffron.500": {
            contrast: 45.82528069105699,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 61
        },
        "saffron.600": {
            contrast: 41.38611149826576,
            lc60: 100,
            lc45: 100,
            lc30: 83.5,
            lc10: 65
        },
        "saffron.700": {
            contrast: 37.182611238587626,
            lc60: 100,
            lc45: 100,
            lc30: 89,
            lc10: 68.5
        },
        "saffron.800": {
            contrast: 32.40874462891335,
            lc60: 100,
            lc45: 100,
            lc30: 97,
            lc10: 73.5
        },
        "saffron.900": {
            contrast: 27.965106071594036,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79
        },
        "saffron.1000": {
            contrast: 23.858521470199342,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84.5
        },
        "saffron.1100": {
            contrast: 19.24000280441031,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93
        },
        "saffron.1200": {
            contrast: 14.85692230952882,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1300": {
            contrast: 9.952088675651899,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1800": {
            contrast: 10.693780769877446,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1900": {
            contrast: 17.439831508229364,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.2000": {
            contrast: 23.495807845920165,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.2100": {
            contrast: 29.551494918349864,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.2200": {
            contrast: 35.99313814044741,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.2300": {
            contrast: 42.520373928575125,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.2400": {
            contrast: 49.35902424939956,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2500": {
            contrast: 56.116398668793636,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        }
    },
    "saffron.1700": {
        "saffron.100": {
            contrast: 58.037731299858706,
            lc60: 100,
            lc45: 74.5,
            lc30: 60,
            lc10: 47
        },
        "saffron.200": {
            contrast: 57.51620479902711,
            lc60: 100,
            lc45: 78,
            lc30: 62.5,
            lc10: 49.5
        },
        "saffron.300": {
            contrast: 56.01518532327843,
            lc60: 100,
            lc45: 82,
            lc30: 65.5,
            lc10: 51.5
        },
        "saffron.400": {
            contrast: 53.89270585630121,
            lc60: 100,
            lc45: 86,
            lc30: 68.5,
            lc10: 53.5
        },
        "saffron.500": {
            contrast: 50.80706639181722,
            lc60: 100,
            lc45: 91.5,
            lc30: 72,
            lc10: 56.5
        },
        "saffron.600": {
            contrast: 46.36789719902599,
            lc60: 100,
            lc45: 99,
            lc30: 77,
            lc10: 59.5
        },
        "saffron.700": {
            contrast: 42.16439693934786,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 63
        },
        "saffron.800": {
            contrast: 37.39053032967358,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 67.5
        },
        "saffron.900": {
            contrast: 32.94689177235427,
            lc60: 100,
            lc45: 100,
            lc30: 95.5,
            lc10: 71.5
        },
        "saffron.1000": {
            contrast: 28.840307170959573,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77
        },
        "saffron.1100": {
            contrast: 24.22178850517054,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83
        },
        "saffron.1200": {
            contrast: 19.838708010289054,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91
        },
        "saffron.1300": {
            contrast: 14.933874376412131,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1400": {
            contrast: 10.596936985148508,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1900": {
            contrast: 12.176513317425282,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2000": {
            contrast: 18.232489655116087,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.2100": {
            contrast: 24.28817672754579,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.2200": {
            contrast: 30.72981994964333,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.2300": {
            contrast: 37.25705573777105,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.2400": {
            contrast: 44.09570605859548,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.2500": {
            contrast: 50.85308047798954,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        }
    },
    "saffron.1800": {
        "saffron.100": {
            contrast: 64.07529599672435,
            lc60: 86.5,
            lc45: 68.5,
            lc30: 55,
            lc10: 42.5
        },
        "saffron.200": {
            contrast: 63.553769495892745,
            lc60: 90.5,
            lc45: 71.5,
            lc30: 57,
            lc10: 44.5
        },
        "saffron.300": {
            contrast: 62.05275002014407,
            lc60: 96.5,
            lc45: 75,
            lc30: 59.5,
            lc10: 46
        },
        "saffron.400": {
            contrast: 59.93027055316686,
            lc60: 100,
            lc45: 78.5,
            lc30: 62,
            lc10: 48
        },
        "saffron.500": {
            contrast: 56.844631088682874,
            lc60: 100,
            lc45: 82.5,
            lc30: 65.5,
            lc10: 50.5
        },
        "saffron.600": {
            contrast: 52.405461895891634,
            lc60: 100,
            lc45: 89,
            lc30: 69.5,
            lc10: 53.5
        },
        "saffron.700": {
            contrast: 48.2019616362135,
            lc60: 100,
            lc45: 95.5,
            lc30: 74,
            lc10: 56.5
        },
        "saffron.800": {
            contrast: 43.42809502653922,
            lc60: 100,
            lc45: 100,
            lc30: 79,
            lc10: 60
        },
        "saffron.900": {
            contrast: 38.984456469219914,
            lc60: 100,
            lc45: 100,
            lc30: 85,
            lc10: 64.5
        },
        "saffron.1000": {
            contrast: 34.87787186782521,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 68
        },
        "saffron.1100": {
            contrast: 30.259353202036177,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "saffron.1200": {
            contrast: 25.87627270715469,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79
        },
        "saffron.1300": {
            contrast: 20.97143907327777,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88
        },
        "saffron.1400": {
            contrast: 16.63450168201415,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 97.5
        },
        "saffron.1500": {
            contrast: 12.562492287989132,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1600": {
            contrast: 8.996618397751483,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2000": {
            contrast: 11.767917454184392,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2100": {
            contrast: 17.82360452661409,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.2200": {
            contrast: 24.265247748711634,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.2300": {
            contrast: 30.792483536839356,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.2400": {
            contrast: 37.631133857663784,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.2500": {
            contrast: 44.38850827705785,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        }
    },
    "saffron.1900": {
        "saffron.100": {
            contrast: 70.44626137415935,
            lc60: 77,
            lc45: 62.5,
            lc30: 49.5,
            lc10: 37.5
        },
        "saffron.200": {
            contrast: 69.92473487332774,
            lc60: 81,
            lc45: 65,
            lc30: 51.5,
            lc10: 39
        },
        "saffron.300": {
            contrast: 68.42371539757906,
            lc60: 85,
            lc45: 68,
            lc30: 53.5,
            lc10: 40.5
        },
        "saffron.400": {
            contrast: 66.30123593060185,
            lc60: 89.5,
            lc45: 71,
            lc30: 56,
            lc10: 42.5
        },
        "saffron.500": {
            contrast: 63.21559646611787,
            lc60: 95.5,
            lc45: 75,
            lc30: 59,
            lc10: 44.5
        },
        "saffron.600": {
            contrast: 58.776427273326625,
            lc60: 100,
            lc45: 80.5,
            lc30: 62.5,
            lc10: 47.5
        },
        "saffron.700": {
            contrast: 54.572927013648496,
            lc60: 100,
            lc45: 85.5,
            lc30: 66,
            lc10: 49.5
        },
        "saffron.800": {
            contrast: 49.79906040397422,
            lc60: 100,
            lc45: 92.5,
            lc30: 70.5,
            lc10: 53
        },
        "saffron.900": {
            contrast: 45.355421846654906,
            lc60: 100,
            lc45: 100,
            lc30: 75.5,
            lc10: 56
        },
        "saffron.1000": {
            contrast: 41.24883724526021,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 59
        },
        "saffron.1100": {
            contrast: 36.63031857947118,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 63
        },
        "saffron.1200": {
            contrast: 32.24723808458968,
            lc60: 100,
            lc45: 100,
            lc30: 97,
            lc10: 68
        },
        "saffron.1300": {
            contrast: 27.342404450712763,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74.5
        },
        "saffron.1400": {
            contrast: 23.005467059449145,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82.5
        },
        "saffron.1500": {
            contrast: 18.93345766542413,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91.5
        },
        "saffron.1600": {
            contrast: 15.36758377518648,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1700": {
            contrast: 10.349561158063475,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2100": {
            contrast: 10.907003308105049,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2200": {
            contrast: 17.34864653020259,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.2300": {
            contrast: 23.875882318330312,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.2400": {
            contrast: 30.714532639154747,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.2500": {
            contrast: 37.47190705854881,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        }
    },
    "saffron.2000": {
        "saffron.100": {
            contrast: 76.11847308355877,
            lc60: 71.5,
            lc45: 57,
            lc30: 44.5,
            lc10: 33.5
        },
        "saffron.200": {
            contrast: 75.59694658272717,
            lc60: 74.5,
            lc45: 60,
            lc30: 46.5,
            lc10: 34.5
        },
        "saffron.300": {
            contrast: 74.0959271069785,
            lc60: 78,
            lc45: 62.5,
            lc30: 48.5,
            lc10: 36
        },
        "saffron.400": {
            contrast: 71.97344764000128,
            lc60: 82,
            lc45: 65,
            lc30: 50.5,
            lc10: 37.5
        },
        "saffron.500": {
            contrast: 68.88780817551729,
            lc60: 86.5,
            lc45: 68.5,
            lc30: 53.5,
            lc10: 39
        },
        "saffron.600": {
            contrast: 64.44863898272605,
            lc60: 93.5,
            lc45: 73.5,
            lc30: 56.5,
            lc10: 42
        },
        "saffron.700": {
            contrast: 60.24513872304792,
            lc60: 100,
            lc45: 77.5,
            lc30: 59.5,
            lc10: 44
        },
        "saffron.800": {
            contrast: 55.47127211337364,
            lc60: 100,
            lc45: 83,
            lc30: 63.5,
            lc10: 46.5
        },
        "saffron.900": {
            contrast: 51.02763355605433,
            lc60: 100,
            lc45: 90,
            lc30: 68,
            lc10: 49.5
        },
        "saffron.1000": {
            contrast: 46.92104895465963,
            lc60: 100,
            lc45: 97.5,
            lc30: 72,
            lc10: 51.5
        },
        "saffron.1100": {
            contrast: 42.3025302888706,
            lc60: 100,
            lc45: 100,
            lc30: 77.5,
            lc10: 55.5
        },
        "saffron.1200": {
            contrast: 37.919449793989116,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 59
        },
        "saffron.1300": {
            contrast: 33.01461616011218,
            lc60: 100,
            lc45: 100,
            lc30: 94,
            lc10: 64.5
        },
        "saffron.1400": {
            contrast: 28.67767876884857,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70.5
        },
        "saffron.1500": {
            contrast: 24.60566937482355,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77.5
        },
        "saffron.1600": {
            contrast: 21.039795484585902,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86
        },
        "saffron.1700": {
            contrast: 16.0217728674629,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 99
        },
        "saffron.1800": {
            contrast: 9.931256367156,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2200": {
            contrast: 11.113873700885266,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2300": {
            contrast: 17.641109489012987,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.2400": {
            contrast: 24.47975980983742,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.2500": {
            contrast: 31.237134229231483,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        }
    },
    "saffron.2100": {
        "saffron.100": {
            contrast: 81.74967511411249,
            lc60: 66,
            lc45: 52.5,
            lc30: 40.5,
            lc10: 29
        },
        "saffron.200": {
            contrast: 81.22814861328088,
            lc60: 68.5,
            lc45: 54.5,
            lc30: 42.5,
            lc10: 30
        },
        "saffron.300": {
            contrast: 79.72712913753222,
            lc60: 71.5,
            lc45: 57,
            lc30: 44,
            lc10: 31.5
        },
        "saffron.400": {
            contrast: 77.604649670555,
            lc60: 75,
            lc45: 59.5,
            lc30: 46,
            lc10: 33
        },
        "saffron.500": {
            contrast: 74.51901020607103,
            lc60: 79.5,
            lc45: 62.5,
            lc30: 48,
            lc10: 34.5
        },
        "saffron.600": {
            contrast: 70.07984101327979,
            lc60: 85,
            lc45: 66.5,
            lc30: 51,
            lc10: 36
        },
        "saffron.700": {
            contrast: 65.87634075360165,
            lc60: 91,
            lc45: 70.5,
            lc30: 53.5,
            lc10: 38.5
        },
        "saffron.800": {
            contrast: 61.10247414392737,
            lc60: 99.5,
            lc45: 75,
            lc30: 57,
            lc10: 40.5
        },
        "saffron.900": {
            contrast: 56.65883558660805,
            lc60: 100,
            lc45: 81,
            lc30: 60.5,
            lc10: 43
        },
        "saffron.1000": {
            contrast: 52.552250985213355,
            lc60: 100,
            lc45: 86.5,
            lc30: 64,
            lc10: 45.5
        },
        "saffron.1100": {
            contrast: 47.93373231942433,
            lc60: 100,
            lc45: 95,
            lc30: 68.5,
            lc10: 48
        },
        "saffron.1200": {
            contrast: 43.55065182454283,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 51.5
        },
        "saffron.1300": {
            contrast: 38.64581819066591,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 55
        },
        "saffron.1400": {
            contrast: 34.30888079940229,
            lc60: 100,
            lc45: 100,
            lc30: 90.5,
            lc10: 60
        },
        "saffron.1500": {
            contrast: 30.236871405377276,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "saffron.1600": {
            contrast: 26.67099751513963,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "saffron.1700": {
            contrast: 21.652974898016623,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85
        },
        "saffron.1800": {
            contrast: 15.562458397709728,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1900": {
            contrast: 9.125728049146474,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2300": {
            contrast: 11.384125070473159,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2400": {
            contrast: 18.222775391297592,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.2500": {
            contrast: 24.980149810691657,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        }
    },
    "saffron.2200": {
        "saffron.100": {
            contrast: 87.69851905582422,
            lc60: 60.5,
            lc45: 47.5,
            lc30: 35.5,
            lc10: 24.5
        },
        "saffron.200": {
            contrast: 87.17699255499261,
            lc60: 63,
            lc45: 49.5,
            lc30: 37,
            lc10: 26
        },
        "saffron.300": {
            contrast: 85.67597307924393,
            lc60: 66,
            lc45: 51.5,
            lc30: 39,
            lc10: 27
        },
        "saffron.400": {
            contrast: 83.55349361226672,
            lc60: 69,
            lc45: 54,
            lc30: 40.5,
            lc10: 28
        },
        "saffron.500": {
            contrast: 80.46785414778273,
            lc60: 72.5,
            lc45: 57,
            lc30: 42.5,
            lc10: 29.5
        },
        "saffron.600": {
            contrast: 76.0286849549915,
            lc60: 77,
            lc45: 60,
            lc30: 45,
            lc10: 31.5
        },
        "saffron.700": {
            contrast: 71.82518469531337,
            lc60: 82,
            lc45: 63.5,
            lc30: 47.5,
            lc10: 32.5
        },
        "saffron.800": {
            contrast: 67.05131808563908,
            lc60: 89,
            lc45: 68,
            lc30: 50,
            lc10: 34.5
        },
        "saffron.900": {
            contrast: 62.60767952831977,
            lc60: 96.5,
            lc45: 72.5,
            lc30: 53.5,
            lc10: 36.5
        },
        "saffron.1000": {
            contrast: 58.50109492692509,
            lc60: 100,
            lc45: 77,
            lc30: 56.5,
            lc10: 38.5
        },
        "saffron.1100": {
            contrast: 53.88257626113605,
            lc60: 100,
            lc45: 83.5,
            lc30: 60.5,
            lc10: 40.5
        },
        "saffron.1200": {
            contrast: 49.499495766254554,
            lc60: 100,
            lc45: 91.5,
            lc30: 64.5,
            lc10: 43
        },
        "saffron.1300": {
            contrast: 44.594662132377636,
            lc60: 100,
            lc45: 100,
            lc30: 70.5,
            lc10: 46
        },
        "saffron.1400": {
            contrast: 40.25772474111402,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 50.5
        },
        "saffron.1500": {
            contrast: 36.185715347089,
            lc60: 100,
            lc45: 100,
            lc30: 85.5,
            lc10: 55
        },
        "saffron.1600": {
            contrast: 32.61984145685135,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 61.5
        },
        "saffron.1700": {
            contrast: 27.60181883972834,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "saffron.1800": {
            contrast: 21.511302339421448,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84.5
        },
        "saffron.1900": {
            contrast: 15.074571990858193,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2000": {
            contrast: 9.335912372586346,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2400": {
            contrast: 11.543963821165606,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2500": {
            contrast: 18.30133824055967,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        }
    },
    "saffron.2300": {
        "saffron.100": {
            contrast: 93.68622709435557,
            lc60: 55,
            lc45: 42.5,
            lc30: 31.5,
            lc10: 20.5
        },
        "saffron.200": {
            contrast: 93.16470059352396,
            lc60: 57,
            lc45: 44.5,
            lc30: 32.5,
            lc10: 21
        },
        "saffron.300": {
            contrast: 91.6636811177753,
            lc60: 60,
            lc45: 46,
            lc30: 33.5,
            lc10: 22.5
        },
        "saffron.400": {
            contrast: 89.54120165079809,
            lc60: 62.5,
            lc45: 48.5,
            lc30: 35,
            lc10: 23
        },
        "saffron.500": {
            contrast: 86.45556218631411,
            lc60: 66,
            lc45: 50.5,
            lc30: 37,
            lc10: 24.5
        },
        "saffron.600": {
            contrast: 82.01639299352286,
            lc60: 70,
            lc45: 54,
            lc30: 39.5,
            lc10: 26
        },
        "saffron.700": {
            contrast: 77.81289273384473,
            lc60: 74.5,
            lc45: 57,
            lc30: 41,
            lc10: 27
        },
        "saffron.800": {
            contrast: 73.03902612417045,
            lc60: 80,
            lc45: 60.5,
            lc30: 44,
            lc10: 28.5
        },
        "saffron.900": {
            contrast: 68.59538756685114,
            lc60: 86,
            lc45: 64.5,
            lc30: 46,
            lc10: 30
        },
        "saffron.1000": {
            contrast: 64.48880296545644,
            lc60: 92.5,
            lc45: 68,
            lc30: 48.5,
            lc10: 31.5
        },
        "saffron.1100": {
            contrast: 59.87028429966741,
            lc60: 100,
            lc45: 73.5,
            lc30: 52,
            lc10: 33.5
        },
        "saffron.1200": {
            contrast: 55.48720380478592,
            lc60: 100,
            lc45: 79.5,
            lc30: 55.5,
            lc10: 35.5
        },
        "saffron.1300": {
            contrast: 50.582370170908995,
            lc60: 100,
            lc45: 88,
            lc30: 60.5,
            lc10: 38
        },
        "saffron.1400": {
            contrast: 46.24543277964538,
            lc60: 100,
            lc45: 99,
            lc30: 66,
            lc10: 41
        },
        "saffron.1500": {
            contrast: 42.17342338562035,
            lc60: 100,
            lc45: 100,
            lc30: 72.5,
            lc10: 44.5
        },
        "saffron.1600": {
            contrast: 38.607549495382706,
            lc60: 100,
            lc45: 100,
            lc30: 80.5,
            lc10: 49.5
        },
        "saffron.1700": {
            contrast: 33.589526878259704,
            lc60: 100,
            lc45: 100,
            lc30: 92.5,
            lc10: 57
        },
        "saffron.1800": {
            contrast: 27.499010377952803,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "saffron.1900": {
            contrast: 21.062280029389555,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83.5
        },
        "saffron.2000": {
            contrast: 15.323620411117709,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2100": {
            contrast: 9.619601914171115,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2500": {
            contrast: 11.511114978516723,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "saffron.2400": {
        "saffron.100": {
            contrast: 99.91934109687449,
            lc60: 49.5,
            lc45: 38,
            lc30: 26.5,
            lc10: 16
        },
        "saffron.200": {
            contrast: 99.3978145960429,
            lc60: 52,
            lc45: 39,
            lc30: 28,
            lc10: 17
        },
        "saffron.300": {
            contrast: 97.89679512029423,
            lc60: 54,
            lc45: 41,
            lc30: 29,
            lc10: 17.5
        },
        "saffron.400": {
            contrast: 95.774315653317,
            lc60: 56.5,
            lc45: 43,
            lc30: 30,
            lc10: 18.5
        },
        "saffron.500": {
            contrast: 92.68867618883303,
            lc60: 59.5,
            lc45: 45,
            lc30: 31.5,
            lc10: 19
        },
        "saffron.600": {
            contrast: 88.24950699604179,
            lc60: 63,
            lc45: 48,
            lc30: 33.5,
            lc10: 20.5
        },
        "saffron.700": {
            contrast: 84.04600673636365,
            lc60: 67,
            lc45: 50,
            lc30: 35,
            lc10: 21
        },
        "saffron.800": {
            contrast: 79.27214012668938,
            lc60: 71.5,
            lc45: 53.5,
            lc30: 37,
            lc10: 22.5
        },
        "saffron.900": {
            contrast: 74.82850156937005,
            lc60: 76.5,
            lc45: 56.5,
            lc30: 39.5,
            lc10: 23.5
        },
        "saffron.1000": {
            contrast: 70.72191696797537,
            lc60: 81.5,
            lc45: 60,
            lc30: 41.5,
            lc10: 25
        },
        "saffron.1100": {
            contrast: 66.10339830218633,
            lc60: 89,
            lc45: 64.5,
            lc30: 44,
            lc10: 26
        },
        "saffron.1200": {
            contrast: 61.72031780730484,
            lc60: 98.5,
            lc45: 69,
            lc30: 46.5,
            lc10: 28
        },
        "saffron.1300": {
            contrast: 56.81548417342792,
            lc60: 100,
            lc45: 75.5,
            lc30: 50.5,
            lc10: 29.5
        },
        "saffron.1400": {
            contrast: 52.4785467821643,
            lc60: 100,
            lc45: 83,
            lc30: 55,
            lc10: 32
        },
        "saffron.1500": {
            contrast: 48.406537388139284,
            lc60: 100,
            lc45: 93,
            lc30: 60,
            lc10: 35
        },
        "saffron.1600": {
            contrast: 44.84066349790163,
            lc60: 100,
            lc45: 100,
            lc30: 66.5,
            lc10: 39
        },
        "saffron.1700": {
            contrast: 39.82264088077863,
            lc60: 100,
            lc45: 100,
            lc30: 77.5,
            lc10: 44.5
        },
        "saffron.1800": {
            contrast: 33.73212438047173,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 53.5
        },
        "saffron.1900": {
            contrast: 27.295394031908476,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65
        },
        "saffron.2000": {
            contrast: 21.556734413636633,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80.5
        },
        "saffron.2100": {
            contrast: 15.852715916690041,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2200": {
            contrast: 9.82000255699912,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "saffron.2500": {
        "saffron.100": {
            contrast: 106.04067321268862,
            lc60: 44.5,
            lc45: 33.5,
            lc30: 22.5,
            lc10: 12
        },
        "saffron.200": {
            contrast: 105.519146711857,
            lc60: 46.5,
            lc45: 34.5,
            lc30: 23,
            lc10: 12.5
        },
        "saffron.300": {
            contrast: 104.01812723610833,
            lc60: 48.5,
            lc45: 36,
            lc30: 24.5,
            lc10: 13.5
        },
        "saffron.400": {
            contrast: 101.89564776913112,
            lc60: 50.5,
            lc45: 37.5,
            lc30: 25.5,
            lc10: 13.5
        },
        "saffron.500": {
            contrast: 98.81000830464711,
            lc60: 53.5,
            lc45: 39.5,
            lc30: 26,
            lc10: 14
        },
        "saffron.600": {
            contrast: 94.37083911185587,
            lc60: 57,
            lc45: 42,
            lc30: 28,
            lc10: 15
        },
        "saffron.700": {
            contrast: 90.16733885217775,
            lc60: 59.5,
            lc45: 44,
            lc30: 29.5,
            lc10: 15.5
        },
        "saffron.800": {
            contrast: 85.39347224250348,
            lc60: 63.5,
            lc45: 46.5,
            lc30: 31,
            lc10: 17
        },
        "saffron.900": {
            contrast: 80.94983368518417,
            lc60: 68,
            lc45: 49.5,
            lc30: 33,
            lc10: 17.5
        },
        "saffron.1000": {
            contrast: 76.84324908378946,
            lc60: 72,
            lc45: 52.5,
            lc30: 34.5,
            lc10: 18.5
        },
        "saffron.1100": {
            contrast: 72.22473041800043,
            lc60: 78,
            lc45: 55.5,
            lc30: 37,
            lc10: 20
        },
        "saffron.1200": {
            contrast: 67.84164992311895,
            lc60: 84.5,
            lc45: 59.5,
            lc30: 39,
            lc10: 20.5
        },
        "saffron.1300": {
            contrast: 62.936816289242024,
            lc60: 95,
            lc45: 64.5,
            lc30: 41.5,
            lc10: 22
        },
        "saffron.1400": {
            contrast: 58.59987889797841,
            lc60: 100,
            lc45: 70.5,
            lc30: 45,
            lc10: 24
        },
        "saffron.1500": {
            contrast: 54.527869503953376,
            lc60: 100,
            lc45: 77.5,
            lc30: 49.5,
            lc10: 26
        },
        "saffron.1600": {
            contrast: 50.96199561371573,
            lc60: 100,
            lc45: 86.5,
            lc30: 55,
            lc10: 28.5
        },
        "saffron.1700": {
            contrast: 45.94397299659273,
            lc60: 100,
            lc45: 100,
            lc30: 63,
            lc10: 33
        },
        "saffron.1800": {
            contrast: 39.85345649628583,
            lc60: 100,
            lc45: 100,
            lc30: 75,
            lc10: 39
        },
        "saffron.1900": {
            contrast: 33.41672614772258,
            lc60: 100,
            lc45: 100,
            lc30: 91.5,
            lc10: 48
        },
        "saffron.2000": {
            contrast: 27.678066529450728,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58
        },
        "saffron.2100": {
            contrast: 21.974048032504136,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "saffron.2200": {
            contrast: 15.941334672813214,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2300": {
            contrast: 9.86243687133773,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    }
};
const $f8fd43f1ee3f8cd8$var$indigo = {
    "indigo.100": {
        "indigo.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.600": {
            contrast: 7.965790458130313,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.700": {
            contrast: 10.960749645107665,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.800": {
            contrast: 15.227361556657664,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.900": {
            contrast: 19.431619565456952,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 90.5
        },
        "indigo.1000": {
            contrast: 24.306344103782838,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80.5
        },
        "indigo.1100": {
            contrast: 28.783423858063788,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "indigo.1200": {
            contrast: 33.7168335008944,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 67
        },
        "indigo.1300": {
            contrast: 38.76624143351852,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 62
        },
        "indigo.1400": {
            contrast: 43.573253064410636,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 57.5
        },
        "indigo.1500": {
            contrast: 48.572018151285654,
            lc60: 100,
            lc45: 97,
            lc30: 77,
            lc10: 54.5
        },
        "indigo.1600": {
            contrast: 53.35908012142506,
            lc60: 100,
            lc45: 91,
            lc30: 72.5,
            lc10: 51
        },
        "indigo.1700": {
            contrast: 58.855334330346864,
            lc60: 100,
            lc45: 86,
            lc30: 68,
            lc10: 48
        },
        "indigo.1800": {
            contrast: 64.6119568907903,
            lc60: 96,
            lc45: 81,
            lc30: 64.5,
            lc10: 45.5
        },
        "indigo.1900": {
            contrast: 70.2106627378178,
            lc60: 91.5,
            lc45: 77,
            lc30: 61.5,
            lc10: 43
        },
        "indigo.2000": {
            contrast: 76.01333066880579,
            lc60: 87,
            lc45: 73.5,
            lc30: 58.5,
            lc10: 41
        },
        "indigo.2100": {
            contrast: 82.13497683707338,
            lc60: 83,
            lc45: 69.5,
            lc30: 55.5,
            lc10: 39
        },
        "indigo.2200": {
            contrast: 88.32330207932317,
            lc60: 79,
            lc45: 66.5,
            lc30: 53.5,
            lc10: 37.5
        },
        "indigo.2300": {
            contrast: 94.36985908929962,
            lc60: 76,
            lc45: 64,
            lc30: 51,
            lc10: 36
        },
        "indigo.2400": {
            contrast: 101.03966032678929,
            lc60: 73,
            lc45: 61.5,
            lc30: 48.5,
            lc10: 34.5
        },
        "indigo.2500": {
            contrast: 107.88473318309848,
            lc60: 69.5,
            lc45: 59,
            lc30: 46.5,
            lc10: 33
        }
    },
    "indigo.200": {
        "indigo.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.600": {
            contrast: 7.39595363701525,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.700": {
            contrast: 10.3909128239926,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.800": {
            contrast: 14.657524735542601,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.900": {
            contrast: 18.86178274434189,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91
        },
        "indigo.1000": {
            contrast: 23.73650728266777,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79
        },
        "indigo.1100": {
            contrast: 28.213587036948724,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "indigo.1200": {
            contrast: 33.14699667977934,
            lc60: 100,
            lc45: 100,
            lc30: 95.5,
            lc10: 65
        },
        "indigo.1300": {
            contrast: 38.196404612403455,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 59.5
        },
        "indigo.1400": {
            contrast: 43.00341624329557,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 55
        },
        "indigo.1500": {
            contrast: 48.00218133017059,
            lc60: 100,
            lc45: 97,
            lc30: 76.5,
            lc10: 52
        },
        "indigo.1600": {
            contrast: 52.78924330031,
            lc60: 100,
            lc45: 91.5,
            lc30: 71.5,
            lc10: 49
        },
        "indigo.1700": {
            contrast: 58.285497509231796,
            lc60: 100,
            lc45: 86,
            lc30: 67.5,
            lc10: 46
        },
        "indigo.1800": {
            contrast: 64.04212006967522,
            lc60: 97,
            lc45: 81,
            lc30: 64,
            lc10: 43.5
        },
        "indigo.1900": {
            contrast: 69.64082591670274,
            lc60: 91.5,
            lc45: 77,
            lc30: 60.5,
            lc10: 41.5
        },
        "indigo.2000": {
            contrast: 75.44349384769072,
            lc60: 87,
            lc45: 73,
            lc30: 57,
            lc10: 39.5
        },
        "indigo.2100": {
            contrast: 81.56514001595832,
            lc60: 83,
            lc45: 69.5,
            lc30: 55,
            lc10: 37.5
        },
        "indigo.2200": {
            contrast: 87.75346525820812,
            lc60: 79,
            lc45: 66,
            lc30: 52,
            lc10: 36
        },
        "indigo.2300": {
            contrast: 93.80002226818455,
            lc60: 76,
            lc45: 63.5,
            lc30: 50,
            lc10: 34.5
        },
        "indigo.2400": {
            contrast: 100.46982350567421,
            lc60: 72.5,
            lc45: 60.5,
            lc30: 48,
            lc10: 33
        },
        "indigo.2500": {
            contrast: 107.31489636198341,
            lc60: 69.5,
            lc45: 58,
            lc30: 46,
            lc10: 31.5
        }
    },
    "indigo.300": {
        "indigo.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.700": {
            contrast: 9.17526408625352,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.800": {
            contrast: 13.441875997803518,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.900": {
            contrast: 17.64613400660281,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 94
        },
        "indigo.1000": {
            contrast: 22.520858544928693,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80.5
        },
        "indigo.1100": {
            contrast: 26.99793829920964,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72.5
        },
        "indigo.1200": {
            contrast: 31.931347942040254,
            lc60: 100,
            lc45: 100,
            lc30: 98,
            lc10: 64.5
        },
        "indigo.1300": {
            contrast: 36.980755874664375,
            lc60: 100,
            lc45: 100,
            lc30: 89.5,
            lc10: 59
        },
        "indigo.1400": {
            contrast: 41.78776750555648,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 55
        },
        "indigo.1500": {
            contrast: 46.7865325924315,
            lc60: 100,
            lc45: 99,
            lc30: 77,
            lc10: 51.5
        },
        "indigo.1600": {
            contrast: 51.57359456257091,
            lc60: 100,
            lc45: 92.5,
            lc30: 72.5,
            lc10: 48.5
        },
        "indigo.1700": {
            contrast: 57.06984877149273,
            lc60: 100,
            lc45: 87,
            lc30: 68,
            lc10: 45.5
        },
        "indigo.1800": {
            contrast: 62.82647133193615,
            lc60: 98,
            lc45: 81.5,
            lc30: 64,
            lc10: 43
        },
        "indigo.1900": {
            contrast: 68.42517717896366,
            lc60: 92.5,
            lc45: 77,
            lc30: 60.5,
            lc10: 40.5
        },
        "indigo.2000": {
            contrast: 74.22784510995164,
            lc60: 88,
            lc45: 73.5,
            lc30: 57,
            lc10: 39
        },
        "indigo.2100": {
            contrast: 80.34949127821923,
            lc60: 83.5,
            lc45: 69.5,
            lc30: 54.5,
            lc10: 37
        },
        "indigo.2200": {
            contrast: 86.53781652046904,
            lc60: 79.5,
            lc45: 66,
            lc30: 52,
            lc10: 35
        },
        "indigo.2300": {
            contrast: 92.58437353044549,
            lc60: 76,
            lc45: 63.5,
            lc30: 49.5,
            lc10: 34
        },
        "indigo.2400": {
            contrast: 99.25417476793513,
            lc60: 73,
            lc45: 60.5,
            lc30: 47.5,
            lc10: 32.5
        },
        "indigo.2500": {
            contrast: 106.09924762424431,
            lc60: 69.5,
            lc45: 58.5,
            lc30: 46,
            lc10: 31
        }
    },
    "indigo.400": {
        "indigo.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.700": {
            contrast: 7.45674346986753,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.800": {
            contrast: 11.72335538141753,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.900": {
            contrast: 15.927613390216818,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1000": {
            contrast: 20.802337928542702,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84.5
        },
        "indigo.1100": {
            contrast: 25.279417682823652,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74.5
        },
        "indigo.1200": {
            contrast: 30.212827325654263,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66.5
        },
        "indigo.1300": {
            contrast: 35.26223525827839,
            lc60: 100,
            lc45: 100,
            lc30: 91.5,
            lc10: 60.5
        },
        "indigo.1400": {
            contrast: 40.06924688917049,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 55.5
        },
        "indigo.1500": {
            contrast: 45.06801197604551,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 52
        },
        "indigo.1600": {
            contrast: 49.85507394618492,
            lc60: 100,
            lc45: 95,
            lc30: 73.5,
            lc10: 48.5
        },
        "indigo.1700": {
            contrast: 55.35132815510673,
            lc60: 100,
            lc45: 88.5,
            lc30: 69,
            lc10: 46
        },
        "indigo.1800": {
            contrast: 61.10795071555015,
            lc60: 99.5,
            lc45: 83,
            lc30: 64.5,
            lc10: 43
        },
        "indigo.1900": {
            contrast: 66.70665656257766,
            lc60: 94,
            lc45: 78.5,
            lc30: 61,
            lc10: 41
        },
        "indigo.2000": {
            contrast: 72.50932449356566,
            lc60: 89,
            lc45: 74,
            lc30: 58,
            lc10: 39
        },
        "indigo.2100": {
            contrast: 78.63097066183325,
            lc60: 84.5,
            lc45: 70.5,
            lc30: 55,
            lc10: 37
        },
        "indigo.2200": {
            contrast: 84.81929590408303,
            lc60: 80.5,
            lc45: 67.5,
            lc30: 52.5,
            lc10: 35
        },
        "indigo.2300": {
            contrast: 90.86585291405949,
            lc60: 77,
            lc45: 64.5,
            lc30: 50,
            lc10: 34
        },
        "indigo.2400": {
            contrast: 97.53565415154914,
            lc60: 73.5,
            lc45: 61.5,
            lc30: 48,
            lc10: 32.5
        },
        "indigo.2500": {
            contrast: 104.38072700785834,
            lc60: 70.5,
            lc45: 59,
            lc30: 46,
            lc10: 31
        }
    },
    "indigo.500": {
        "indigo.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.800": {
            contrast: 9.24011191888848,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.900": {
            contrast: 13.444369927687772,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1000": {
            contrast: 18.319094466013652,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91.5
        },
        "indigo.1100": {
            contrast: 22.796174220294603,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80
        },
        "indigo.1200": {
            contrast: 27.729583863125214,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "indigo.1300": {
            contrast: 32.77899179574933,
            lc60: 100,
            lc45: 100,
            lc30: 96,
            lc10: 63
        },
        "indigo.1400": {
            contrast: 37.58600342664144,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 58
        },
        "indigo.1500": {
            contrast: 42.584768513516465,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 53.5
        },
        "indigo.1600": {
            contrast: 47.37183048365588,
            lc60: 100,
            lc45: 98,
            lc30: 76,
            lc10: 50.5
        },
        "indigo.1700": {
            contrast: 52.868084692577675,
            lc60: 100,
            lc45: 91,
            lc30: 71,
            lc10: 47
        },
        "indigo.1800": {
            contrast: 58.6247072530211,
            lc60: 100,
            lc45: 85.5,
            lc30: 66.5,
            lc10: 44.5
        },
        "indigo.1900": {
            contrast: 64.2234131000486,
            lc60: 96.5,
            lc45: 80.5,
            lc30: 62.5,
            lc10: 41.5
        },
        "indigo.2000": {
            contrast: 70.0260810310366,
            lc60: 91.5,
            lc45: 76,
            lc30: 59,
            lc10: 39.5
        },
        "indigo.2100": {
            contrast: 76.1477271993042,
            lc60: 86,
            lc45: 72,
            lc30: 56.5,
            lc10: 37.5
        },
        "indigo.2200": {
            contrast: 82.33605244155399,
            lc60: 82,
            lc45: 68.5,
            lc30: 53.5,
            lc10: 36
        },
        "indigo.2300": {
            contrast: 88.38260945153044,
            lc60: 78.5,
            lc45: 65.5,
            lc30: 51,
            lc10: 34
        },
        "indigo.2400": {
            contrast: 95.05241068902009,
            lc60: 75,
            lc45: 62.5,
            lc30: 48.5,
            lc10: 33
        },
        "indigo.2500": {
            contrast: 101.89748354532928,
            lc60: 71.5,
            lc45: 60,
            lc30: 46.5,
            lc10: 31.5
        }
    },
    "indigo.600": {
        "indigo.100": {
            contrast: 9.280478554779798,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.200": {
            contrast: 8.518410662217246,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.900": {
            contrast: 10.121038607271057,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1000": {
            contrast: 14.995763145596941,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1100": {
            contrast: 19.47284289987789,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88.5
        },
        "indigo.1200": {
            contrast: 24.406252542708508,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77
        },
        "indigo.1300": {
            contrast: 29.455660475332625,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68.5
        },
        "indigo.1400": {
            contrast: 34.262672106224734,
            lc60: 100,
            lc45: 100,
            lc30: 93.5,
            lc10: 62.5
        },
        "indigo.1500": {
            contrast: 39.26143719309975,
            lc60: 100,
            lc45: 100,
            lc30: 86,
            lc10: 57.5
        },
        "indigo.1600": {
            contrast: 44.04849916323917,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 53.5
        },
        "indigo.1700": {
            contrast: 49.54475337216097,
            lc60: 100,
            lc45: 95,
            lc30: 74.5,
            lc10: 49.5
        },
        "indigo.1800": {
            contrast: 55.3013759326044,
            lc60: 100,
            lc45: 89,
            lc30: 69.5,
            lc10: 46.5
        },
        "indigo.1900": {
            contrast: 60.90008177963189,
            lc60: 100,
            lc45: 84,
            lc30: 65.5,
            lc10: 44
        },
        "indigo.2000": {
            contrast: 66.7027497106199,
            lc60: 94.5,
            lc45: 79,
            lc30: 61.5,
            lc10: 42
        },
        "indigo.2100": {
            contrast: 72.82439587888747,
            lc60: 89,
            lc45: 74.5,
            lc30: 58.5,
            lc10: 39
        },
        "indigo.2200": {
            contrast: 79.01272112113728,
            lc60: 84.5,
            lc45: 71,
            lc30: 55.5,
            lc10: 37
        },
        "indigo.2300": {
            contrast: 85.05927813111373,
            lc60: 80.5,
            lc45: 68,
            lc30: 53,
            lc10: 35.5
        },
        "indigo.2400": {
            contrast: 91.7290793686034,
            lc60: 77,
            lc45: 64.5,
            lc30: 50.5,
            lc10: 34
        },
        "indigo.2500": {
            contrast: 98.57415222491255,
            lc60: 73.5,
            lc45: 61.5,
            lc30: 48,
            lc10: 32.5
        }
    },
    "indigo.700": {
        "indigo.100": {
            contrast: 12.560735953191033,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.200": {
            contrast: 11.798668060628481,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.300": {
            contrast: 10.215178151515806,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.400": {
            contrast: 8.051604289706225,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1000": {
            contrast: 12.144370959402966,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1100": {
            contrast: 16.62145071368392,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 97
        },
        "indigo.1200": {
            contrast: 21.554860356514535,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79.5
        },
        "indigo.1300": {
            contrast: 26.60426828913865,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69.5
        },
        "indigo.1400": {
            contrast: 31.41127992003076,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 61
        },
        "indigo.1500": {
            contrast: 36.410045006905776,
            lc60: 100,
            lc45: 100,
            lc30: 89,
            lc10: 55
        },
        "indigo.1600": {
            contrast: 41.197106977045195,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 50.5
        },
        "indigo.1700": {
            contrast: 46.693361185967,
            lc60: 100,
            lc45: 99,
            lc30: 74.5,
            lc10: 46
        },
        "indigo.1800": {
            contrast: 52.449983746410425,
            lc60: 100,
            lc45: 90.5,
            lc30: 68.5,
            lc10: 43
        },
        "indigo.1900": {
            contrast: 58.04868959343793,
            lc60: 100,
            lc45: 84.5,
            lc30: 64,
            lc10: 40
        },
        "indigo.2000": {
            contrast: 63.851357524425914,
            lc60: 96.5,
            lc45: 79,
            lc30: 59.5,
            lc10: 37.5
        },
        "indigo.2100": {
            contrast: 69.97300369269351,
            lc60: 90.5,
            lc45: 74,
            lc30: 56,
            lc10: 35
        },
        "indigo.2200": {
            contrast: 76.16132893494331,
            lc60: 85.5,
            lc45: 70,
            lc30: 53,
            lc10: 33.5
        },
        "indigo.2300": {
            contrast: 82.20788594491975,
            lc60: 80.5,
            lc45: 66.5,
            lc30: 50,
            lc10: 31.5
        },
        "indigo.2400": {
            contrast: 88.8776871824094,
            lc60: 77,
            lc45: 62.5,
            lc30: 48,
            lc10: 29.5
        },
        "indigo.2500": {
            contrast: 95.72276003871859,
            lc60: 73,
            lc45: 59.5,
            lc30: 45.5,
            lc10: 28.5
        }
    },
    "indigo.800": {
        "indigo.100": {
            contrast: 17.14024638478992,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74
        },
        "indigo.200": {
            contrast: 16.37817849222737,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93.5
        },
        "indigo.300": {
            contrast: 14.794688583114693,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.400": {
            contrast: 12.631114721305112,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.500": {
            contrast: 9.61701428337734,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1000": {
            contrast: 8.040994817103062,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1100": {
            contrast: 12.518074571384014,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1200": {
            contrast: 17.45148421421463,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93.5
        },
        "indigo.1300": {
            contrast: 22.500892146838744,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76.5
        },
        "indigo.1400": {
            contrast: 27.307903777730854,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65.5
        },
        "indigo.1500": {
            contrast: 32.306668864605875,
            lc60: 100,
            lc45: 100,
            lc30: 97,
            lc10: 58
        },
        "indigo.1600": {
            contrast: 37.09373083474529,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 52
        },
        "indigo.1700": {
            contrast: 42.58998504366709,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 47
        },
        "indigo.1800": {
            contrast: 48.34660760411052,
            lc60: 100,
            lc45: 96.5,
            lc30: 71.5,
            lc10: 43
        },
        "indigo.1900": {
            contrast: 53.94531345113802,
            lc60: 100,
            lc45: 88.5,
            lc30: 66,
            lc10: 40
        },
        "indigo.2000": {
            contrast: 59.747981382126014,
            lc60: 100,
            lc45: 82.5,
            lc30: 61,
            lc10: 37
        },
        "indigo.2100": {
            contrast: 65.8696275503936,
            lc60: 94,
            lc45: 76,
            lc30: 57,
            lc10: 34.5
        },
        "indigo.2200": {
            contrast: 72.05795279264339,
            lc60: 88,
            lc45: 71.5,
            lc30: 53.5,
            lc10: 32
        },
        "indigo.2300": {
            contrast: 78.10450980261984,
            lc60: 83,
            lc45: 67.5,
            lc30: 50,
            lc10: 30.5
        },
        "indigo.2400": {
            contrast: 84.77431104010951,
            lc60: 78.5,
            lc45: 63.5,
            lc30: 47,
            lc10: 28.5
        },
        "indigo.2500": {
            contrast: 91.61938389641868,
            lc60: 73.5,
            lc45: 60.5,
            lc30: 44.5,
            lc10: 27
        }
    },
    "indigo.900": {
        "indigo.100": {
            contrast: 21.566311949215986,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 52
        },
        "indigo.200": {
            contrast: 20.804244056653438,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "indigo.300": {
            contrast: 19.22075414754076,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73
        },
        "indigo.400": {
            contrast: 17.05718028573118,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89.5
        },
        "indigo.500": {
            contrast: 14.043079847803408,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.600": {
            contrast: 10.15766350772622,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1100": {
            contrast: 8.43535963535486,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1200": {
            contrast: 13.368769278185475,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1300": {
            contrast: 18.418177210809596,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89
        },
        "indigo.1400": {
            contrast: 23.2251888417017,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "indigo.1500": {
            contrast: 28.223953928576723,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "indigo.1600": {
            contrast: 33.01101589871613,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 55.5
        },
        "indigo.1700": {
            contrast: 38.507270107637936,
            lc60: 100,
            lc45: 100,
            lc30: 84,
            lc10: 49.5
        },
        "indigo.1800": {
            contrast: 44.26389266808136,
            lc60: 100,
            lc45: 100,
            lc30: 75.5,
            lc10: 44.5
        },
        "indigo.1900": {
            contrast: 49.86259851510887,
            lc60: 100,
            lc45: 93.5,
            lc30: 69.5,
            lc10: 40.5
        },
        "indigo.2000": {
            contrast: 55.665266446096865,
            lc60: 100,
            lc45: 86,
            lc30: 63,
            lc10: 37
        },
        "indigo.2100": {
            contrast: 61.78691261436444,
            lc60: 99,
            lc45: 80,
            lc30: 58.5,
            lc10: 34.5
        },
        "indigo.2200": {
            contrast: 67.97523785661424,
            lc60: 91.5,
            lc45: 74,
            lc30: 54,
            lc10: 32
        },
        "indigo.2300": {
            contrast: 74.0217948665907,
            lc60: 86,
            lc45: 69.5,
            lc30: 51,
            lc10: 30
        },
        "indigo.2400": {
            contrast: 80.69159610408036,
            lc60: 80.5,
            lc45: 65,
            lc30: 48,
            lc10: 28
        },
        "indigo.2500": {
            contrast: 87.53666896038953,
            lc60: 76,
            lc45: 61,
            lc30: 45,
            lc10: 26.5
        }
    },
    "indigo.1000": {
        "indigo.100": {
            contrast: 26.611022274641694,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 42.5
        },
        "indigo.200": {
            contrast: 25.84895438207915,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 48.5
        },
        "indigo.300": {
            contrast: 24.26546447296647,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54.5
        },
        "indigo.400": {
            contrast: 22.101890611156893,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "indigo.500": {
            contrast: 19.08779017322912,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77
        },
        "indigo.600": {
            contrast: 15.202373833151931,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.700": {
            contrast: 11.969115301809119,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.800": {
            contrast: 7.439985326275321,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1200": {
            contrast: 8.59423836931789,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1300": {
            contrast: 13.643646301942008,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1400": {
            contrast: 18.45065793283412,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89.5
        },
        "indigo.1500": {
            contrast: 23.44942301970914,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72.5
        },
        "indigo.1600": {
            contrast: 28.23648498984855,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62
        },
        "indigo.1700": {
            contrast: 33.73273919877035,
            lc60: 100,
            lc45: 100,
            lc30: 93.5,
            lc10: 53.5
        },
        "indigo.1800": {
            contrast: 39.48936175921378,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 48
        },
        "indigo.1900": {
            contrast: 45.08806760624128,
            lc60: 100,
            lc45: 100,
            lc30: 73.5,
            lc10: 43
        },
        "indigo.2000": {
            contrast: 50.89073553722927,
            lc60: 100,
            lc45: 91.5,
            lc30: 67,
            lc10: 39
        },
        "indigo.2100": {
            contrast: 57.01238170549687,
            lc60: 100,
            lc45: 84.5,
            lc30: 61,
            lc10: 35.5
        },
        "indigo.2200": {
            contrast: 63.20070694774667,
            lc60: 97,
            lc45: 77.5,
            lc30: 56.5,
            lc10: 33
        },
        "indigo.2300": {
            contrast: 69.2472639577231,
            lc60: 90,
            lc45: 72,
            lc30: 52.5,
            lc10: 30
        },
        "indigo.2400": {
            contrast: 75.91706519521276,
            lc60: 84.5,
            lc45: 67,
            lc30: 49,
            lc10: 28.5
        },
        "indigo.2500": {
            contrast: 82.76213805152194,
            lc60: 79,
            lc45: 63,
            lc30: 46,
            lc10: 26
        }
    },
    "indigo.1100": {
        "indigo.100": {
            contrast: 31.175222873440244,
            lc60: 100,
            lc45: 100,
            lc30: 91.5,
            lc10: 37
        },
        "indigo.200": {
            contrast: 30.4131549808777,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 41
        },
        "indigo.300": {
            contrast: 28.82966507176502,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 45.5
        },
        "indigo.400": {
            contrast: 26.666091209955447,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51
        },
        "indigo.500": {
            contrast: 23.651990772027673,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58.5
        },
        "indigo.600": {
            contrast: 19.766574431950485,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "indigo.700": {
            contrast: 16.53331590060767,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95.5
        },
        "indigo.800": {
            contrast: 12.004185925073873,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.900": {
            contrast: 7.612662326682296,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1300": {
            contrast: 9.225581168206972,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1400": {
            contrast: 14.032592799099083,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1500": {
            contrast: 19.031357885974103,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85.5
        },
        "indigo.1600": {
            contrast: 23.81841985611352,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "indigo.1700": {
            contrast: 29.31467406503532,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "indigo.1800": {
            contrast: 35.071296625478745,
            lc60: 100,
            lc45: 100,
            lc30: 89.5,
            lc10: 51.5
        },
        "indigo.1900": {
            contrast: 40.67000247250625,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 45.5
        },
        "indigo.2000": {
            contrast: 46.472670403494234,
            lc60: 100,
            lc45: 99,
            lc30: 71.5,
            lc10: 41
        },
        "indigo.2100": {
            contrast: 52.59431657176182,
            lc60: 100,
            lc45: 89.5,
            lc30: 65,
            lc10: 37
        },
        "indigo.2200": {
            contrast: 58.78264181401162,
            lc60: 100,
            lc45: 81.5,
            lc30: 59,
            lc10: 34
        },
        "indigo.2300": {
            contrast: 64.82919882398808,
            lc60: 95,
            lc45: 75.5,
            lc30: 54.5,
            lc10: 31.5
        },
        "indigo.2400": {
            contrast: 71.49900006147773,
            lc60: 88,
            lc45: 69.5,
            lc30: 50.5,
            lc10: 29
        },
        "indigo.2500": {
            contrast: 78.3440729177869,
            lc60: 81.5,
            lc45: 65,
            lc30: 47,
            lc10: 27.5
        }
    },
    "indigo.1200": {
        "indigo.100": {
            contrast: 36.139521150700006,
            lc60: 100,
            lc45: 100,
            lc30: 66,
            lc10: 32
        },
        "indigo.200": {
            contrast: 35.37745325813746,
            lc60: 100,
            lc45: 100,
            lc30: 73.5,
            lc10: 35.5
        },
        "indigo.300": {
            contrast: 33.79396334902478,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 38.5
        },
        "indigo.400": {
            contrast: 31.6303894872152,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 42.5
        },
        "indigo.500": {
            contrast: 28.61628904928743,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 46.5
        },
        "indigo.600": {
            contrast: 24.730872709210242,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53.5
        },
        "indigo.700": {
            contrast: 21.49761417786743,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "indigo.800": {
            contrast: 16.968484202333634,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93.5
        },
        "indigo.900": {
            contrast: 12.576960603942055,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1000": {
            contrast: 7.557303600581419,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1400": {
            contrast: 9.132391854293516,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1500": {
            contrast: 14.131156941168538,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1600": {
            contrast: 18.91821891130795,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86
        },
        "indigo.1700": {
            contrast: 24.414473120229754,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "indigo.1800": {
            contrast: 30.171095680673172,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "indigo.1900": {
            contrast: 35.76980152770068,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 49.5
        },
        "indigo.2000": {
            contrast: 41.57246945868867,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 44
        },
        "indigo.2100": {
            contrast: 47.694115626956254,
            lc60: 100,
            lc45: 96.5,
            lc30: 69.5,
            lc10: 39
        },
        "indigo.2200": {
            contrast: 53.882440869206064,
            lc60: 100,
            lc45: 87.5,
            lc30: 63,
            lc10: 35.5
        },
        "indigo.2300": {
            contrast: 59.928997879182496,
            lc60: 100,
            lc45: 80.5,
            lc30: 57,
            lc10: 32.5
        },
        "indigo.2400": {
            contrast: 66.59879911667215,
            lc60: 93,
            lc45: 73.5,
            lc30: 52.5,
            lc10: 30
        },
        "indigo.2500": {
            contrast: 73.44387197298134,
            lc60: 86,
            lc45: 68,
            lc30: 48.5,
            lc10: 28
        }
    },
    "indigo.1300": {
        "indigo.100": {
            contrast: 41.159192030825025,
            lc60: 100,
            lc45: 100,
            lc30: 56.5,
            lc10: 28.5
        },
        "indigo.200": {
            contrast: 40.39712413826248,
            lc60: 100,
            lc45: 100,
            lc30: 62,
            lc10: 31
        },
        "indigo.300": {
            contrast: 38.8136342291498,
            lc60: 100,
            lc45: 100,
            lc30: 67,
            lc10: 33.5
        },
        "indigo.400": {
            contrast: 36.650060367340224,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 36
        },
        "indigo.500": {
            contrast: 33.63595992941245,
            lc60: 100,
            lc45: 100,
            lc30: 85,
            lc10: 39
        },
        "indigo.600": {
            contrast: 29.75054358933526,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 42.5
        },
        "indigo.700": {
            contrast: 26.517285057992453,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "indigo.800": {
            contrast: 21.988155082458654,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69.5
        },
        "indigo.900": {
            contrast: 17.59663148406708,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89.5
        },
        "indigo.1000": {
            contrast: 12.57697448070644,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1100": {
            contrast: 8.02406674170401,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1500": {
            contrast: 9.085186400991255,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1600": {
            contrast: 13.872248371130668,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1700": {
            contrast: 19.36850258005247,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84
        },
        "indigo.1800": {
            contrast: 25.12512514049589,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66.5
        },
        "indigo.1900": {
            contrast: 30.7238309875234,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56
        },
        "indigo.2000": {
            contrast: 36.52649891851139,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 48.5
        },
        "indigo.2100": {
            contrast: 42.648145086778975,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 42.5
        },
        "indigo.2200": {
            contrast: 48.83647032902878,
            lc60: 100,
            lc45: 94.5,
            lc30: 68,
            lc10: 38
        },
        "indigo.2300": {
            contrast: 54.88302733900522,
            lc60: 100,
            lc45: 86,
            lc30: 61,
            lc10: 35
        },
        "indigo.2400": {
            contrast: 61.552828576494875,
            lc60: 99,
            lc45: 78.5,
            lc30: 55.5,
            lc10: 31.5
        },
        "indigo.2500": {
            contrast: 68.39790143280406,
            lc60: 90.5,
            lc45: 71.5,
            lc30: 51.5,
            lc10: 28
        }
    },
    "indigo.1400": {
        "indigo.100": {
            contrast: 45.887183234924365,
            lc60: 100,
            lc45: 100,
            lc30: 50.5,
            lc10: 26
        },
        "indigo.200": {
            contrast: 45.125115342361816,
            lc60: 100,
            lc45: 100,
            lc30: 55,
            lc10: 28
        },
        "indigo.300": {
            contrast: 43.54162543324914,
            lc60: 100,
            lc45: 100,
            lc30: 58.5,
            lc10: 29.5
        },
        "indigo.400": {
            contrast: 41.37805157143956,
            lc60: 100,
            lc45: 100,
            lc30: 63,
            lc10: 31.5
        },
        "indigo.500": {
            contrast: 38.36395113351179,
            lc60: 100,
            lc45: 100,
            lc30: 69.5,
            lc10: 33.5
        },
        "indigo.600": {
            contrast: 34.4785347934346,
            lc60: 100,
            lc45: 100,
            lc30: 80.5,
            lc10: 36.5
        },
        "indigo.700": {
            contrast: 31.245276262091785,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 45.5
        },
        "indigo.800": {
            contrast: 26.716146286557986,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "indigo.900": {
            contrast: 22.324622688166414,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69.5
        },
        "indigo.1000": {
            contrast: 17.304965684805776,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93
        },
        "indigo.1100": {
            contrast: 12.752057945803347,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1200": {
            contrast: 7.789275621441768,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1600": {
            contrast: 9.042821652172387,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1700": {
            contrast: 14.539075861094188,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1800": {
            contrast: 20.29569842153761,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81.5
        },
        "indigo.1900": {
            contrast: 25.894404268565115,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64.5
        },
        "indigo.2000": {
            contrast: 31.697072199553105,
            lc60: 100,
            lc45: 100,
            lc30: 97.5,
            lc10: 54
        },
        "indigo.2100": {
            contrast: 37.8187183678207,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 46.5
        },
        "indigo.2200": {
            contrast: 44.0070436100705,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 41
        },
        "indigo.2300": {
            contrast: 50.05360062004694,
            lc60: 100,
            lc45: 93.5,
            lc30: 65.5,
            lc10: 37
        },
        "indigo.2400": {
            contrast: 56.7234018575366,
            lc60: 100,
            lc45: 83,
            lc30: 59,
            lc10: 33.5
        },
        "indigo.2500": {
            contrast: 63.56847471384577,
            lc60: 96,
            lc45: 75.5,
            lc30: 53.5,
            lc10: 30
        }
    },
    "indigo.1500": {
        "indigo.100": {
            contrast: 50.75703302421763,
            lc60: 100,
            lc45: 73,
            lc30: 46,
            lc10: 24
        },
        "indigo.200": {
            contrast: 49.99496513165508,
            lc60: 100,
            lc45: 79,
            lc30: 48.5,
            lc10: 25
        },
        "indigo.300": {
            contrast: 48.4114752225424,
            lc60: 100,
            lc45: 86.5,
            lc30: 52,
            lc10: 26.5
        },
        "indigo.400": {
            contrast: 46.24790136073282,
            lc60: 100,
            lc45: 98,
            lc30: 55,
            lc10: 28
        },
        "indigo.500": {
            contrast: 43.233800922805045,
            lc60: 100,
            lc45: 100,
            lc30: 60,
            lc10: 29.5
        },
        "indigo.600": {
            contrast: 39.34838458272786,
            lc60: 100,
            lc45: 100,
            lc30: 66,
            lc10: 31.5
        },
        "indigo.700": {
            contrast: 36.11512605138504,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 39
        },
        "indigo.800": {
            contrast: 31.58599607585124,
            lc60: 100,
            lc45: 100,
            lc30: 97,
            lc10: 47
        },
        "indigo.900": {
            contrast: 27.19447247745967,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "indigo.1000": {
            contrast: 22.174815474099034,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "indigo.1100": {
            contrast: 17.621907735096602,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91
        },
        "indigo.1200": {
            contrast: 12.659125410735028,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1300": {
            contrast: 7.630815978866819,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1700": {
            contrast: 9.49295890280301,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1800": {
            contrast: 15.249581463246434,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1900": {
            contrast: 20.84828731027394,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79
        },
        "indigo.2000": {
            contrast: 26.650955241261933,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "indigo.2100": {
            contrast: 32.772601409529514,
            lc60: 100,
            lc45: 100,
            lc30: 94.5,
            lc10: 53.5
        },
        "indigo.2200": {
            contrast: 38.96092665177932,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 46
        },
        "indigo.2300": {
            contrast: 45.00748366175576,
            lc60: 100,
            lc45: 100,
            lc30: 72,
            lc10: 39.5
        },
        "indigo.2400": {
            contrast: 51.67728489924542,
            lc60: 100,
            lc45: 90,
            lc30: 64.5,
            lc10: 35
        },
        "indigo.2500": {
            contrast: 58.52235775555461,
            lc60: 100,
            lc45: 81,
            lc30: 57.5,
            lc10: 31.5
        }
    },
    "indigo.1600": {
        "indigo.100": {
            contrast: 55.38032462523653,
            lc60: 100,
            lc45: 65,
            lc30: 42,
            lc10: 22
        },
        "indigo.200": {
            contrast: 54.61825673267398,
            lc60: 100,
            lc45: 69.5,
            lc30: 44.5,
            lc10: 23
        },
        "indigo.300": {
            contrast: 53.0347668235613,
            lc60: 100,
            lc45: 74.5,
            lc30: 47,
            lc10: 24
        },
        "indigo.400": {
            contrast: 50.871192961751724,
            lc60: 100,
            lc45: 80.5,
            lc30: 49.5,
            lc10: 25
        },
        "indigo.500": {
            contrast: 47.857092523823944,
            lc60: 100,
            lc45: 91,
            lc30: 53,
            lc10: 26.5
        },
        "indigo.600": {
            contrast: 43.97167618374675,
            lc60: 100,
            lc45: 100,
            lc30: 57,
            lc10: 28.5
        },
        "indigo.700": {
            contrast: 40.738417652403946,
            lc60: 100,
            lc45: 100,
            lc30: 69,
            lc10: 34.5
        },
        "indigo.800": {
            contrast: 36.20928767687015,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 40.5
        },
        "indigo.900": {
            contrast: 31.817764078478568,
            lc60: 100,
            lc45: 100,
            lc30: 96,
            lc10: 47.5
        },
        "indigo.1000": {
            contrast: 26.798107075117933,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58.5
        },
        "indigo.1100": {
            contrast: 22.245199336115505,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "indigo.1200": {
            contrast: 17.282417011753928,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 92.5
        },
        "indigo.1300": {
            contrast: 12.25410757988572,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1400": {
            contrast: 7.509550016252639,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1800": {
            contrast: 10.396152674279941,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1900": {
            contrast: 15.994858521307446,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2000": {
            contrast: 21.797526452295436,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76
        },
        "indigo.2100": {
            contrast: 27.919172620563025,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60.5
        },
        "indigo.2200": {
            contrast: 34.10749786281283,
            lc60: 100,
            lc45: 100,
            lc30: 91.5,
            lc10: 50.5
        },
        "indigo.2300": {
            contrast: 40.15405487278927,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 44
        },
        "indigo.2400": {
            contrast: 46.823856110278925,
            lc60: 100,
            lc45: 98,
            lc30: 69.5,
            lc10: 38.5
        },
        "indigo.2500": {
            contrast: 53.668928966588105,
            lc60: 100,
            lc45: 87.5,
            lc30: 61.5,
            lc10: 34
        }
    },
    "indigo.1700": {
        "indigo.100": {
            contrast: 60.64444299892975,
            lc60: 100,
            lc45: 59,
            lc30: 38.5,
            lc10: 20
        },
        "indigo.200": {
            contrast: 59.882375106367206,
            lc60: 100,
            lc45: 62.5,
            lc30: 40.5,
            lc10: 21
        },
        "indigo.300": {
            contrast: 58.29888519725452,
            lc60: 100,
            lc45: 66,
            lc30: 42.5,
            lc10: 22.5
        },
        "indigo.400": {
            contrast: 56.135311335444946,
            lc60: 100,
            lc45: 69.5,
            lc30: 44.5,
            lc10: 22.5
        },
        "indigo.500": {
            contrast: 53.121210897517166,
            lc60: 100,
            lc45: 75.5,
            lc30: 46.5,
            lc10: 24
        },
        "indigo.600": {
            contrast: 49.23579455743998,
            lc60: 100,
            lc45: 84.5,
            lc30: 49.5,
            lc10: 25
        },
        "indigo.700": {
            contrast: 46.00253602609717,
            lc60: 100,
            lc45: 99.5,
            lc30: 59,
            lc10: 30
        },
        "indigo.800": {
            contrast: 41.47340605056337,
            lc60: 100,
            lc45: 100,
            lc30: 69.5,
            lc10: 35
        },
        "indigo.900": {
            contrast: 37.0818824521718,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 40
        },
        "indigo.1000": {
            contrast: 32.062225448811155,
            lc60: 100,
            lc45: 100,
            lc30: 95.5,
            lc10: 48
        },
        "indigo.1100": {
            contrast: 27.509317709808727,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "indigo.1200": {
            contrast: 22.54653538544715,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70.5
        },
        "indigo.1300": {
            contrast: 17.518225953578945,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 92.5
        },
        "indigo.1400": {
            contrast: 12.773668389945863,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1500": {
            contrast: 7.878968209636864,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1900": {
            contrast: 10.399109569631598,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2000": {
            contrast: 16.201777500619592,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98.5
        },
        "indigo.2100": {
            contrast: 22.32342366888718,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74
        },
        "indigo.2200": {
            contrast: 28.51174891113698,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "indigo.2300": {
            contrast: 34.55830592111342,
            lc60: 100,
            lc45: 100,
            lc30: 90,
            lc10: 50.5
        },
        "indigo.2400": {
            contrast: 41.22810715860308,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 42.5
        },
        "indigo.2500": {
            contrast: 48.07318001491227,
            lc60: 100,
            lc45: 95.5,
            lc30: 67.5,
            lc10: 37
        }
    },
    "indigo.1800": {
        "indigo.100": {
            contrast: 66.11192226121287,
            lc60: 76.5,
            lc45: 53.5,
            lc30: 35,
            lc10: 18.5
        },
        "indigo.200": {
            contrast: 65.34985436865031,
            lc60: 81,
            lc45: 56.5,
            lc30: 37,
            lc10: 19
        },
        "indigo.300": {
            contrast: 63.76636445953763,
            lc60: 87,
            lc45: 59,
            lc30: 38.5,
            lc10: 20
        },
        "indigo.400": {
            contrast: 61.60279059772805,
            lc60: 96.5,
            lc45: 62,
            lc30: 39.5,
            lc10: 20.5
        },
        "indigo.500": {
            contrast: 58.58869015980027,
            lc60: 100,
            lc45: 66,
            lc30: 42,
            lc10: 22
        },
        "indigo.600": {
            contrast: 54.70327381972309,
            lc60: 100,
            lc45: 71,
            lc30: 44.5,
            lc10: 22.5
        },
        "indigo.700": {
            contrast: 51.470015288380274,
            lc60: 100,
            lc45: 83.5,
            lc30: 51.5,
            lc10: 27
        },
        "indigo.800": {
            contrast: 46.940885312846476,
            lc60: 100,
            lc45: 97,
            lc30: 59.5,
            lc10: 31
        },
        "indigo.900": {
            contrast: 42.5493617144549,
            lc60: 100,
            lc45: 100,
            lc30: 68,
            lc10: 35
        },
        "indigo.1000": {
            contrast: 37.52970471109426,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 40.5
        },
        "indigo.1100": {
            contrast: 32.97679697209183,
            lc60: 100,
            lc45: 100,
            lc30: 93.5,
            lc10: 47
        },
        "indigo.1200": {
            contrast: 28.014014647730257,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "indigo.1300": {
            contrast: 22.985705215862048,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "indigo.1400": {
            contrast: 18.24114765222897,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88
        },
        "indigo.1500": {
            contrast: 13.34644747191997,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1600": {
            contrast: 8.69283409343919,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2000": {
            contrast: 10.316339182597575,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2100": {
            contrast: 16.437985350865166,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98.5
        },
        "indigo.2200": {
            contrast: 22.626310593114965,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "indigo.2300": {
            contrast: 28.672867603091408,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58.5
        },
        "indigo.2400": {
            contrast: 35.34266884058106,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 48
        },
        "indigo.2500": {
            contrast: 42.18774169689024,
            lc60: 100,
            lc45: 100,
            lc30: 75,
            lc10: 41
        }
    },
    "indigo.1900": {
        "indigo.100": {
            contrast: 71.38818953602593,
            lc60: 69,
            lc45: 49.5,
            lc30: 32.5,
            lc10: 17
        },
        "indigo.200": {
            contrast: 70.62612164346338,
            lc60: 72.5,
            lc45: 51.5,
            lc30: 34,
            lc10: 18
        },
        "indigo.300": {
            contrast: 69.0426317343507,
            lc60: 76.5,
            lc45: 53.5,
            lc30: 35,
            lc10: 18.5
        },
        "indigo.400": {
            contrast: 66.87905787254113,
            lc60: 81,
            lc45: 56.5,
            lc30: 36.5,
            lc10: 19
        },
        "indigo.500": {
            contrast: 63.864957434613345,
            lc60: 88.5,
            lc45: 59,
            lc30: 38,
            lc10: 20
        },
        "indigo.600": {
            contrast: 59.97954109453616,
            lc60: 100,
            lc45: 62.5,
            lc30: 39.5,
            lc10: 20.5
        },
        "indigo.700": {
            contrast: 56.74628256319334,
            lc60: 100,
            lc45: 72.5,
            lc30: 46,
            lc10: 24
        },
        "indigo.800": {
            contrast: 52.21715258765954,
            lc60: 100,
            lc45: 83.5,
            lc30: 52.5,
            lc10: 28
        },
        "indigo.900": {
            contrast: 47.825628989267976,
            lc60: 100,
            lc45: 94.5,
            lc30: 59.5,
            lc10: 31
        },
        "indigo.1000": {
            contrast: 42.805971985907334,
            lc60: 100,
            lc45: 100,
            lc30: 68.5,
            lc10: 35.5
        },
        "indigo.1100": {
            contrast: 38.253064246904906,
            lc60: 100,
            lc45: 100,
            lc30: 79,
            lc10: 40.5
        },
        "indigo.1200": {
            contrast: 33.29028192254333,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 47.5
        },
        "indigo.1300": {
            contrast: 28.26197249067512,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56
        },
        "indigo.1400": {
            contrast: 23.517414927042044,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "indigo.1500": {
            contrast: 18.622714746733042,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85.5
        },
        "indigo.1600": {
            contrast: 13.969101368252263,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1700": {
            contrast: 8.663085532059107,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2100": {
            contrast: 10.691680589058214,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2200": {
            contrast: 16.880005831308015,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95
        },
        "indigo.2300": {
            contrast: 22.92656284128446,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73
        },
        "indigo.2400": {
            contrast: 29.59636407877412,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58
        },
        "indigo.2500": {
            contrast: 36.441436935083296,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 48
        }
    },
    "indigo.2000": {
        "indigo.100": {
            contrast: 76.81728656680659,
            lc60: 63.5,
            lc45: 46,
            lc30: 30.5,
            lc10: 16
        },
        "indigo.200": {
            contrast: 76.05521867424403,
            lc60: 66,
            lc45: 48,
            lc30: 31.5,
            lc10: 17
        },
        "indigo.300": {
            contrast: 74.47172876513135,
            lc60: 69,
            lc45: 49.5,
            lc30: 33,
            lc10: 17
        },
        "indigo.400": {
            contrast: 72.30815490332176,
            lc60: 72,
            lc45: 51.5,
            lc30: 33.5,
            lc10: 18
        },
        "indigo.500": {
            contrast: 69.294054465394,
            lc60: 77,
            lc45: 53.5,
            lc30: 35,
            lc10: 18.5
        },
        "indigo.600": {
            contrast: 65.40863812531683,
            lc60: 83.5,
            lc45: 56,
            lc30: 36.5,
            lc10: 19
        },
        "indigo.700": {
            contrast: 62.175379593974014,
            lc60: 96,
            lc45: 65,
            lc30: 42.5,
            lc10: 21.5
        },
        "indigo.800": {
            contrast: 57.6462496184402,
            lc60: 100,
            lc45: 73.5,
            lc30: 47.5,
            lc10: 24.5
        },
        "indigo.900": {
            contrast: 53.25472602004863,
            lc60: 100,
            lc45: 82.5,
            lc30: 52.5,
            lc10: 27.5
        },
        "indigo.1000": {
            contrast: 48.235069016687994,
            lc60: 100,
            lc45: 94.5,
            lc30: 59.5,
            lc10: 31.5
        },
        "indigo.1100": {
            contrast: 43.68216127768556,
            lc60: 100,
            lc45: 100,
            lc30: 68,
            lc10: 35
        },
        "indigo.1200": {
            contrast: 38.71937895332398,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 40.5
        },
        "indigo.1300": {
            contrast: 33.69106952145577,
            lc60: 100,
            lc45: 100,
            lc30: 91.5,
            lc10: 47.5
        },
        "indigo.1400": {
            contrast: 28.94651195782269,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "indigo.1500": {
            contrast: 24.051811777513695,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "indigo.1600": {
            contrast: 19.398198399032914,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83.5
        },
        "indigo.1700": {
            contrast: 14.092182562839758,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1800": {
            contrast: 8.573484569355495,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2200": {
            contrast: 10.902798874835268,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2300": {
            contrast: 16.949355884811713,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95
        },
        "indigo.2400": {
            contrast: 23.619157122301374,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70.5
        },
        "indigo.2500": {
            contrast: 30.464229978610547,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        }
    },
    "indigo.2100": {
        "indigo.100": {
            contrast: 82.50474547456749,
            lc60: 58.5,
            lc45: 42.5,
            lc30: 28,
            lc10: 15
        },
        "indigo.200": {
            contrast: 81.74267758200493,
            lc60: 60.5,
            lc45: 44.5,
            lc30: 29.5,
            lc10: 15.5
        },
        "indigo.300": {
            contrast: 80.15918767289224,
            lc60: 63,
            lc45: 46,
            lc30: 30,
            lc10: 16
        },
        "indigo.400": {
            contrast: 77.99561381108268,
            lc60: 65.5,
            lc45: 47,
            lc30: 31,
            lc10: 16.5
        },
        "indigo.500": {
            contrast: 74.9815133731549,
            lc60: 69,
            lc45: 49,
            lc30: 32,
            lc10: 17
        },
        "indigo.600": {
            contrast: 71.09609703307771,
            lc60: 73,
            lc45: 51,
            lc30: 33.5,
            lc10: 17.5
        },
        "indigo.700": {
            contrast: 67.86283850173488,
            lc60: 83,
            lc45: 58.5,
            lc30: 38,
            lc10: 20
        },
        "indigo.800": {
            contrast: 63.33370852620109,
            lc60: 94,
            lc45: 66,
            lc30: 42.5,
            lc10: 22.5
        },
        "indigo.900": {
            contrast: 58.94218492780953,
            lc60: 100,
            lc45: 72.5,
            lc30: 47.5,
            lc10: 24.5
        },
        "indigo.1000": {
            contrast: 53.92252792444889,
            lc60: 100,
            lc45: 82,
            lc30: 53.5,
            lc10: 28
        },
        "indigo.1100": {
            contrast: 49.369620185446465,
            lc60: 100,
            lc45: 91.5,
            lc30: 59,
            lc10: 31.5
        },
        "indigo.1200": {
            contrast: 44.40683786108488,
            lc60: 100,
            lc45: 100,
            lc30: 67,
            lc10: 35.5
        },
        "indigo.1300": {
            contrast: 39.37852842921667,
            lc60: 100,
            lc45: 100,
            lc30: 77.5,
            lc10: 40.5
        },
        "indigo.1400": {
            contrast: 34.63397086558359,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 46.5
        },
        "indigo.1500": {
            contrast: 29.739270685274587,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "indigo.1600": {
            contrast: 25.085657306793813,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65
        },
        "indigo.1700": {
            contrast: 19.779641470600655,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80.5
        },
        "indigo.1800": {
            contrast: 14.260943477116395,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1900": {
            contrast: 8.928335238256185,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2300": {
            contrast: 10.621396365388938,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2400": {
            contrast: 17.291197602878597,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 92.5
        },
        "indigo.2500": {
            contrast: 24.136270459187774,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        }
    },
    "indigo.2200": {
        "indigo.100": {
            contrast: 88.21545639709896,
            lc60: 54.5,
            lc45: 40,
            lc30: 26.5,
            lc10: 14.5
        },
        "indigo.200": {
            contrast: 87.4533885045364,
            lc60: 56.5,
            lc45: 41,
            lc30: 27.5,
            lc10: 15
        },
        "indigo.300": {
            contrast: 85.86989859542373,
            lc60: 58,
            lc45: 42.5,
            lc30: 28,
            lc10: 15
        },
        "indigo.400": {
            contrast: 83.70632473361415,
            lc60: 60,
            lc45: 43.5,
            lc30: 29,
            lc10: 15
        },
        "indigo.500": {
            contrast: 80.69222429568637,
            lc60: 62.5,
            lc45: 45,
            lc30: 29.5,
            lc10: 15.5
        },
        "indigo.600": {
            contrast: 76.80680795560917,
            lc60: 65.5,
            lc45: 46.5,
            lc30: 31,
            lc10: 16
        },
        "indigo.700": {
            contrast: 73.57354942426637,
            lc60: 74.5,
            lc45: 53.5,
            lc30: 35,
            lc10: 19
        },
        "indigo.800": {
            contrast: 69.04441944873257,
            lc60: 83.5,
            lc45: 59,
            lc30: 39,
            lc10: 20.5
        },
        "indigo.900": {
            contrast: 64.65289585034101,
            lc60: 91.5,
            lc45: 64.5,
            lc30: 42.5,
            lc10: 22.5
        },
        "indigo.1000": {
            contrast: 59.633238846980355,
            lc60: 100,
            lc45: 73,
            lc30: 48,
            lc10: 25.5
        },
        "indigo.1100": {
            contrast: 55.08033110797793,
            lc60: 100,
            lc45: 80,
            lc30: 52.5,
            lc10: 28
        },
        "indigo.1200": {
            contrast: 50.11754878361635,
            lc60: 100,
            lc45: 89.5,
            lc30: 59,
            lc10: 31.5
        },
        "indigo.1300": {
            contrast: 45.08923935174815,
            lc60: 100,
            lc45: 100,
            lc30: 66,
            lc10: 35
        },
        "indigo.1400": {
            contrast: 40.34468178811507,
            lc60: 100,
            lc45: 100,
            lc30: 75,
            lc10: 40
        },
        "indigo.1500": {
            contrast: 35.449981607806066,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 46
        },
        "indigo.1600": {
            contrast: 30.79636822932529,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53
        },
        "indigo.1700": {
            contrast: 25.490352393132127,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63
        },
        "indigo.1800": {
            contrast: 19.971654399647868,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80.5
        },
        "indigo.1900": {
            contrast: 14.639046160787661,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2000": {
            contrast: 9.145361659451574,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2400": {
            contrast: 10.872675696661076,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2500": {
            contrast: 17.717748552970257,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 92
        }
    },
    "indigo.2300": {
        "indigo.100": {
            contrast: 93.76042793347862,
            lc60: 51,
            lc45: 37.5,
            lc30: 25,
            lc10: 13.5
        },
        "indigo.200": {
            contrast: 92.99836004091607,
            lc60: 53,
            lc45: 39,
            lc30: 26,
            lc10: 13.5
        },
        "indigo.300": {
            contrast: 91.4148701318034,
            lc60: 54,
            lc45: 40,
            lc30: 26.5,
            lc10: 14
        },
        "indigo.400": {
            contrast: 89.25129626999383,
            lc60: 55.5,
            lc45: 40.5,
            lc30: 27,
            lc10: 14.5
        },
        "indigo.500": {
            contrast: 86.23719583206604,
            lc60: 57.5,
            lc45: 42,
            lc30: 28,
            lc10: 15
        },
        "indigo.600": {
            contrast: 82.35177949198885,
            lc60: 60,
            lc45: 43.5,
            lc30: 28.5,
            lc10: 15
        },
        "indigo.700": {
            contrast: 79.11852096064604,
            lc60: 68,
            lc45: 49,
            lc30: 32.5,
            lc10: 17
        },
        "indigo.800": {
            contrast: 74.58939098511225,
            lc60: 75,
            lc45: 54.5,
            lc30: 36,
            lc10: 19
        },
        "indigo.900": {
            contrast: 70.19786738672067,
            lc60: 82.5,
            lc45: 59,
            lc30: 39,
            lc10: 20.5
        },
        "indigo.1000": {
            contrast: 65.17821038336002,
            lc60: 91.5,
            lc45: 65.5,
            lc30: 43,
            lc10: 23
        },
        "indigo.1100": {
            contrast: 60.6253026443576,
            lc60: 100,
            lc45: 71.5,
            lc30: 47.5,
            lc10: 25
        },
        "indigo.1200": {
            contrast: 55.66252031999602,
            lc60: 100,
            lc45: 79.5,
            lc30: 52.5,
            lc10: 28
        },
        "indigo.1300": {
            contrast: 50.63421088812782,
            lc60: 100,
            lc45: 89.5,
            lc30: 59,
            lc10: 31.5
        },
        "indigo.1400": {
            contrast: 45.88965332449474,
            lc60: 100,
            lc45: 100,
            lc30: 65.5,
            lc10: 35
        },
        "indigo.1500": {
            contrast: 40.994953144185736,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 39.5
        },
        "indigo.1600": {
            contrast: 36.34133976570496,
            lc60: 100,
            lc45: 100,
            lc30: 85,
            lc10: 45.5
        },
        "indigo.1700": {
            contrast: 31.035323929511797,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 53.5
        },
        "indigo.1800": {
            contrast: 25.516625936027538,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "indigo.1900": {
            contrast: 20.18401769716733,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80
        },
        "indigo.2000": {
            contrast: 14.690333195831244,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2100": {
            contrast: 8.928473300615382,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2500": {
            contrast: 11.426557231477766,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "indigo.2400": {
        "indigo.100": {
            contrast: 99.8396566589299,
            lc60: 48,
            lc45: 35,
            lc30: 24,
            lc10: 12.5
        },
        "indigo.200": {
            contrast: 99.07758876636736,
            lc60: 49,
            lc45: 36,
            lc30: 24.5,
            lc10: 13
        },
        "indigo.300": {
            contrast: 97.49409885725467,
            lc60: 50.5,
            lc45: 37,
            lc30: 25,
            lc10: 13.5
        },
        "indigo.400": {
            contrast: 95.3305249954451,
            lc60: 51.5,
            lc45: 38,
            lc30: 25.5,
            lc10: 13.5
        },
        "indigo.500": {
            contrast: 92.31642455751731,
            lc60: 53.5,
            lc45: 39,
            lc30: 26,
            lc10: 14
        },
        "indigo.600": {
            contrast: 88.43100821744012,
            lc60: 55,
            lc45: 40,
            lc30: 26.5,
            lc10: 14.5
        },
        "indigo.700": {
            contrast: 85.19774968609731,
            lc60: 61.5,
            lc45: 45,
            lc30: 29.5,
            lc10: 16
        },
        "indigo.800": {
            contrast: 80.66861971056352,
            lc60: 68,
            lc45: 49.5,
            lc30: 33,
            lc10: 17.5
        },
        "indigo.900": {
            contrast: 76.27709611217195,
            lc60: 74,
            lc45: 53.5,
            lc30: 35.5,
            lc10: 19
        },
        "indigo.1000": {
            contrast: 71.2574391088113,
            lc60: 81,
            lc45: 59,
            lc30: 39,
            lc10: 20.5
        },
        "indigo.1100": {
            contrast: 66.70453136980888,
            lc60: 89,
            lc45: 64.5,
            lc30: 42.5,
            lc10: 22.5
        },
        "indigo.1200": {
            contrast: 61.74174904544729,
            lc60: 98,
            lc45: 71,
            lc30: 47,
            lc10: 25
        },
        "indigo.1300": {
            contrast: 56.713439613579084,
            lc60: 100,
            lc45: 78.5,
            lc30: 51.5,
            lc10: 27.5
        },
        "indigo.1400": {
            contrast: 51.96888204994601,
            lc60: 100,
            lc45: 86.5,
            lc30: 57,
            lc10: 30.5
        },
        "indigo.1500": {
            contrast: 47.074181869637,
            lc60: 100,
            lc45: 97,
            lc30: 64.5,
            lc10: 34
        },
        "indigo.1600": {
            contrast: 42.42056849115623,
            lc60: 100,
            lc45: 100,
            lc30: 72,
            lc10: 38.5
        },
        "indigo.1700": {
            contrast: 37.11455265496307,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 44.5
        },
        "indigo.1800": {
            contrast: 31.595854661478807,
            lc60: 100,
            lc45: 100,
            lc30: 97.5,
            lc10: 52.5
        },
        "indigo.1900": {
            contrast: 26.263246422618597,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "indigo.2000": {
            contrast: 20.769561921282513,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77.5
        },
        "indigo.2100": {
            contrast: 15.007702026066653,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2200": {
            contrast: 9.215770139924672,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "indigo.2500": {
        "indigo.100": {
            contrast: 106.04067321268862,
            lc60: 44.5,
            lc45: 33.5,
            lc30: 22.5,
            lc10: 12
        },
        "indigo.200": {
            contrast: 105.27860532012605,
            lc60: 46,
            lc45: 34,
            lc30: 23,
            lc10: 12.5
        },
        "indigo.300": {
            contrast: 103.69511541101338,
            lc60: 47,
            lc45: 35,
            lc30: 23.5,
            lc10: 12.5
        },
        "indigo.400": {
            contrast: 101.53154154920381,
            lc60: 48,
            lc45: 35.5,
            lc30: 24,
            lc10: 13
        },
        "indigo.500": {
            contrast: 98.51744111127601,
            lc60: 49.5,
            lc45: 36.5,
            lc30: 24.5,
            lc10: 13.5
        },
        "indigo.600": {
            contrast: 94.63202477119881,
            lc60: 51,
            lc45: 37,
            lc30: 25,
            lc10: 13.5
        },
        "indigo.700": {
            contrast: 91.39876623985602,
            lc60: 57,
            lc45: 42,
            lc30: 28,
            lc10: 15
        },
        "indigo.800": {
            contrast: 86.86963626432221,
            lc60: 62.5,
            lc45: 45.5,
            lc30: 30.5,
            lc10: 16.5
        },
        "indigo.900": {
            contrast: 82.47811266593065,
            lc60: 67,
            lc45: 49.5,
            lc30: 33,
            lc10: 18
        },
        "indigo.1000": {
            contrast: 77.45845566256999,
            lc60: 73.5,
            lc45: 53.5,
            lc30: 36,
            lc10: 19.5
        },
        "indigo.1100": {
            contrast: 72.90554792356757,
            lc60: 79.5,
            lc45: 58,
            lc30: 39,
            lc10: 21
        },
        "indigo.1200": {
            contrast: 67.94276559920598,
            lc60: 87.5,
            lc45: 63.5,
            lc30: 42.5,
            lc10: 22.5
        },
        "indigo.1300": {
            contrast: 62.91445616733778,
            lc60: 96.5,
            lc45: 69.5,
            lc30: 46.5,
            lc10: 25.5
        },
        "indigo.1400": {
            contrast: 58.16989860370471,
            lc60: 100,
            lc45: 76.5,
            lc30: 51,
            lc10: 27.5
        },
        "indigo.1500": {
            contrast: 53.27519842339571,
            lc60: 100,
            lc45: 85,
            lc30: 56,
            lc10: 30
        },
        "indigo.1600": {
            contrast: 48.62158504491493,
            lc60: 100,
            lc45: 94,
            lc30: 62.5,
            lc10: 33.5
        },
        "indigo.1700": {
            contrast: 43.31556920872177,
            lc60: 100,
            lc45: 100,
            lc30: 71,
            lc10: 38
        },
        "indigo.1800": {
            contrast: 37.7968712152375,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 44
        },
        "indigo.1900": {
            contrast: 32.46426297637729,
            lc60: 100,
            lc45: 100,
            lc30: 96,
            lc10: 51.5
        },
        "indigo.2000": {
            contrast: 26.970578475041208,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62
        },
        "indigo.2100": {
            contrast: 21.20871857982535,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77.5
        },
        "indigo.2200": {
            contrast: 15.41678669368337,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2300": {
            contrast: 9.787065069774279,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    }
};
const $f8fd43f1ee3f8cd8$var$contrast = /*#__PURE__*/ Object.freeze(/*#__PURE__*/ Object.defineProperty({
    __proto__: null,
    crimson: $f8fd43f1ee3f8cd8$var$crimson,
    gold: $f8fd43f1ee3f8cd8$var$gold,
    green: $f8fd43f1ee3f8cd8$var$green,
    indigo: $f8fd43f1ee3f8cd8$var$indigo,
    informative: $f8fd43f1ee3f8cd8$var$informative,
    marigold: $f8fd43f1ee3f8cd8$var$marigold,
    mint: $f8fd43f1ee3f8cd8$var$mint,
    navi: $f8fd43f1ee3f8cd8$var$navi,
    negative: $f8fd43f1ee3f8cd8$var$negative,
    neutral: $f8fd43f1ee3f8cd8$var$neutral,
    orange: $f8fd43f1ee3f8cd8$var$orange,
    pink: $f8fd43f1ee3f8cd8$var$pink,
    positive: $f8fd43f1ee3f8cd8$var$positive,
    purple: $f8fd43f1ee3f8cd8$var$purple,
    red: $f8fd43f1ee3f8cd8$var$red,
    reliance: $f8fd43f1ee3f8cd8$var$reliance,
    saffron: $f8fd43f1ee3f8cd8$var$saffron,
    sky: $f8fd43f1ee3f8cd8$var$sky,
    violet: $f8fd43f1ee3f8cd8$var$violet,
    warning: $f8fd43f1ee3f8cd8$var$warning
}, Symbol.toStringTag, {
    value: 'Module'
}));
const $f8fd43f1ee3f8cd8$var$brand = {
    density: {
        compact: {
            min: 14,
            max: 18,
            advanced: {
                c1: 1,
                c2: 1.1,
                c3: 1.13
            }
        },
        "default": {
            min: 16,
            max: 20,
            advanced: {
                c1: 2,
                c2: 1.125,
                c3: 1.185
            }
        },
        open: {
            min: 17,
            max: 22,
            advanced: {
                c1: 3,
                c2: 1.15,
                c3: 1.195
            }
        }
    },
    typography: {
        display: {
            m: 6
        },
        headline: {
            m: 2
        },
        title: {
            m: 0
        },
        label: {
            m: 0
        },
        body: {
            m: 0
        },
        paragraph: {
            m: 0
        },
        font: {
            family: ""
        }
    },
    spacing: {
        component: {
            m: -2
        },
        pattern: {
            m: 0
        },
        layout: {
            m: 6
        }
    },
    gap: {
        component: {
            m: -2
        },
        pattern: {
            m: 0
        },
        layout: {
            m: 6
        }
    },
    shape: {
        component: {
            m: -2
        },
        pattern: {
            m: 0
        },
        layout: {
            m: 6
        }
    },
    dimension: {
        stroke: {
            m: 0
        }
    },
    motion: {
        duration: {
            m: -1
        },
        offset: {
            m: -5
        }
    }
};
const $f8fd43f1ee3f8cd8$var$foundation = {
    step: {
        surface: {
            minimal: 1,
            minimalDecreased: -1,
            subtle: 2,
            subtleDecreased: -2,
            moderate: 3,
            moderateDecreased: -3
        },
        mode: {
            dim: 3
        },
        event: {
            hover: 1,
            active: 2
        }
    },
    contrast: {
        surface: {
            bold: 45,
            boldA11y: 60,
            heavy: 60
        },
        content: {
            moderate: 60,
            heavy: 60
        },
        stroke: {
            minimal: 10,
            moderate: 30,
            heavy: 60,
            bold: 60
        }
    },
    baseValue: {
        dimension: {
            stroke: 1
        },
        motion: {
            reduced: 100,
            discreet: 200,
            expressive: 300
        }
    },
    scaleFactor: {
        spacing: {
            pattern: 2,
            layout: 2,
            component: 1
        },
        gap: {
            pattern: 2,
            layout: 2,
            component: 1
        },
        shape: {
            pattern: 2,
            layout: 2,
            component: 1
        },
        typography: {
            display: 1,
            headline: 2,
            title: 2,
            label: 1,
            body: 1,
            paragraph: 1
        },
        motion: {
            duration: 1,
            offset: 2
        }
    }
};
const $f8fd43f1ee3f8cd8$var$colors = {
    "candy.100": "oklch(0% 0 0)",
    "candy.200": "oklch(15.95% 0.0508 10.51)",
    "candy.300": "oklch(21.93% 0.0786 9.87)",
    "candy.400": "oklch(27.05% 0.1022 9.86)",
    "candy.500": "oklch(31.96% 0.1215 9.4)",
    "candy.600": "oklch(37.07% 0.1419 9.58)",
    "candy.700": "oklch(41.42% 0.1619 9.38)",
    "candy.800": "oklch(46.1% 0.1823 9.74)",
    "candy.900": "oklch(50.03% 0.1944 9.75)",
    "candy.1000": "oklch(53.54% 0.2041 9.88)",
    "candy.1100": "oklch(57.03% 0.2138 9.64)",
    "candy.1200": "oklch(60.5% 0.2202 9.63)",
    "candy.1300": "oklch(63% 0.2222 9.8)",
    "candy.1400": "oklch(65.87% 0.2232 9.68)",
    "candy.1500": "oklch(69% 0.206 9.59)",
    "candy.1600": "oklch(72.54% 0.175 9.98)",
    "candy.1700": "oklch(75.49% 0.1516 9.67)",
    "candy.1800": "oklch(79.08% 0.1244 9.67)",
    "candy.1900": "oklch(82.02% 0.1036 9.82)",
    "candy.2000": "oklch(85.11% 0.0832 9.65)",
    "candy.2100": "oklch(87.93% 0.0657 9.1)",
    "candy.2200": "oklch(91% 0.0474 9.98)",
    "candy.2300": "oklch(93.89% 0.0301 7.52)",
    "candy.2400": "oklch(96.97% 0.0153 7.48)",
    "candy.2500": "oklch(100% 0 118.64)",
    "candy.base": "1400",
    "candy.light": "1700",
    "candy.midnight": "1300",
    "cobalt.100": "oklch(0% 0 0)",
    "cobalt.200": "oklch(16% 0.08 270.67)",
    "cobalt.300": "oklch(22.02% 0.142 270.67)",
    "cobalt.400": "oklch(26.97% 0.175 270.67)",
    "cobalt.500": "oklch(31.97% 0.208 270.67)",
    "cobalt.600": "oklch(37.01% 0.241 270.67)",
    "cobalt.700": "oklch(41.46% 0.258 270.67)",
    "cobalt.800": "oklch(45% 0.264 270.67)",
    "cobalt.900": "oklch(48.72% 0.2679 270.67)",
    "cobalt.1000": "oklch(52.4% 0.265 270.67)",
    "cobalt.1100": "oklch(56% 0.242 270.67)",
    "cobalt.1200": "oklch(60% 0.217 270.67)",
    "cobalt.1300": "oklch(64.02% 0.192 270.67)",
    "cobalt.1400": "oklch(67.01% 0.174 270.67)",
    "cobalt.1500": "oklch(70.02% 0.156 270.67)",
    "cobalt.1600": "oklch(72.98% 0.139 270.67)",
    "cobalt.1700": "oklch(75.99% 0.122 270.67)",
    "cobalt.1800": "oklch(79.01% 0.105 270.67)",
    "cobalt.1900": "oklch(82.01% 0.089 270.67)",
    "cobalt.2000": "oklch(84.98% 0.073 270.67)",
    "cobalt.2100": "oklch(88.01% 0.058 270.67)",
    "cobalt.2200": "oklch(91.01% 0.043 270.67)",
    "cobalt.2300": "oklch(93.98% 0.028 270.67)",
    "cobalt.2400": "oklch(97.01% 0.014 270.67)",
    "cobalt.2500": "oklch(100% 0 137.33)",
    "cobalt.base": "1300",
    "cobalt.light": "1400",
    "cobalt.midnight": "1200",
    "coral.100": "oklch(0% 0 0)",
    "coral.200": "oklch(15.86% 0.0576 33.53)",
    "coral.300": "oklch(22.03% 0.0789 34.13)",
    "coral.400": "oklch(27% 0.0968 34.13)",
    "coral.500": "oklch(32.01% 0.1114 34.18)",
    "coral.600": "oklch(36.9% 0.1306 33.92)",
    "coral.700": "oklch(41.46% 0.1452 34.03)",
    "coral.800": "oklch(45.94% 0.1565 34.09)",
    "coral.900": "oklch(50.11% 0.1693 34.01)",
    "coral.1000": "oklch(53.55% 0.1799 34.16)",
    "coral.1100": "oklch(56.9% 0.1881 33.97)",
    "coral.1200": "oklch(60.49% 0.1914 34.27)",
    "coral.1300": "oklch(64.06% 0.1918 34.17)",
    "coral.1400": "oklch(67.08% 0.1922 34.17)",
    "coral.1500": "oklch(69.96% 0.1934 34.06)",
    "coral.1600": "oklch(73% 0.168 33.69)",
    "coral.1700": "oklch(75.99% 0.145 33.81)",
    "coral.1800": "oklch(79.08% 0.1227 34.56)",
    "coral.1900": "oklch(82.01% 0.1024 34.15)",
    "coral.2000": "oklch(84.97% 0.0813 33.84)",
    "coral.2100": "oklch(88.01% 0.0645 33.86)",
    "coral.2200": "oklch(90.96% 0.0456 33.15)",
    "coral.2300": "oklch(94.11% 0.0302 35.49)",
    "coral.2400": "oklch(97.05% 0.0146 33.07)",
    "coral.2500": "oklch(100% 0 118.64)",
    "coral.base": "1500",
    "coral.light": "1800",
    "coral.midnight": "1200",
    "crimson.100": "oklch(0% 0 0)",
    "crimson.200": "oklch(16.04% 0.052 22.18)",
    "crimson.300": "oklch(22.01% 0.0887 22.07)",
    "crimson.400": "oklch(27.1% 0.1078 22.49)",
    "crimson.500": "oklch(32% 0.1289 22.07)",
    "crimson.600": "oklch(37.02% 0.1492 22.16)",
    "crimson.700": "oklch(41.47% 0.1671 22.02)",
    "crimson.800": "oklch(46.6% 0.1878 22.26)",
    "crimson.900": "oklch(49.93% 0.1858 22.03)",
    "crimson.1000": "oklch(53.55% 0.1863 22.47)",
    "crimson.1100": "oklch(56.94% 0.1862 22.35)",
    "crimson.1200": "oklch(60.59% 0.1862 22.16)",
    "crimson.1300": "oklch(64% 0.1856 22.19)",
    "crimson.1400": "oklch(66.95% 0.1793 22.48)",
    "crimson.1500": "oklch(70.03% 0.1654 22.28)",
    "crimson.1600": "oklch(73.1% 0.1522 22.46)",
    "crimson.1700": "oklch(76.05% 0.1364 22.39)",
    "crimson.1800": "oklch(78.96% 0.1216 22)",
    "crimson.1900": "oklch(81.98% 0.101 22.46)",
    "crimson.2000": "oklch(84.98% 0.0817 21.69)",
    "crimson.2100": "oklch(88.05% 0.0631 22.05)",
    "crimson.2200": "oklch(91% 0.0463 22.96)",
    "crimson.2300": "oklch(94.03% 0.0299 22.78)",
    "crimson.2400": "oklch(97.11% 0.0141 22.76)",
    "crimson.2500": "oklch(100% 0 118.64)",
    "crimson.base": "800",
    "crimson.light": "1100",
    "crimson.midnight": "700",
    "emerald.100": "oklch(0% 0 0)",
    "emerald.200": "oklch(16.01% 0.0195 170.26)",
    "emerald.300": "oklch(22.13% 0.0341 171.93)",
    "emerald.400": "oklch(27.05% 0.048 172.46)",
    "emerald.500": "oklch(32.06% 0.0624 171.57)",
    "emerald.600": "oklch(37.11% 0.072 171.24)",
    "emerald.700": "oklch(41.38% 0.0793 172.77)",
    "emerald.800": "oklch(46.06% 0.0897 171.6)",
    "emerald.900": "oklch(50.09% 0.0972 171.94)",
    "emerald.1000": "oklch(53.46% 0.1032 171.85)",
    "emerald.1100": "oklch(57.04% 0.1102 172.03)",
    "emerald.1200": "oklch(60.56% 0.1171 172.18)",
    "emerald.1300": "oklch(64.08% 0.123 172.17)",
    "emerald.1400": "oklch(66.6% 0.129 172.08)",
    "emerald.1500": "oklch(69.89% 0.1317 172.21)",
    "emerald.1600": "oklch(72.96% 0.1322 171.98)",
    "emerald.1700": "oklch(75.88% 0.1295 172.48)",
    "emerald.1800": "oklch(79.11% 0.1263 172.27)",
    "emerald.1900": "oklch(81.92% 0.1196 172.02)",
    "emerald.2000": "oklch(85.06% 0.1122 172.34)",
    "emerald.2100": "oklch(87.9% 0.0999 172.33)",
    "emerald.2200": "oklch(90.95% 0.0843 172.28)",
    "emerald.2300": "oklch(94.02% 0.0646 171.71)",
    "emerald.2400": "oklch(97.01% 0.0376 171.58)",
    "emerald.2500": "oklch(100% 0 118.64)",
    "emerald.base": "1400",
    "emerald.light": "1600",
    "emerald.midnight": "1300",
    "gold.100": "oklch(0% 0 0)",
    "gold.200": "oklch(15.87% 0.0156 74.03)",
    "gold.300": "oklch(22.16% 0.0302 76.28)",
    "gold.400": "oklch(26.88% 0.0415 74.85)",
    "gold.500": "oklch(32.04% 0.0521 76.3)",
    "gold.600": "oklch(36.88% 0.0634 74.65)",
    "gold.700": "oklch(41.55% 0.0761 74.64)",
    "gold.800": "oklch(45.99% 0.0862 74.66)",
    "gold.900": "oklch(49.99% 0.0962 74.73)",
    "gold.1000": "oklch(53.46% 0.1041 74.84)",
    "gold.1100": "oklch(56.88% 0.1117 74.92)",
    "gold.1200": "oklch(60.46% 0.1176 75.19)",
    "gold.1300": "oklch(64.12% 0.1244 75.06)",
    "gold.1400": "oklch(66.97% 0.1297 75.08)",
    "gold.1500": "oklch(70.02% 0.1322 74.91)",
    "gold.1600": "oklch(72.94% 0.1339 75.12)",
    "gold.1700": "oklch(75.81% 0.1407 75.03)",
    "gold.1800": "oklch(78.97% 0.1319 74.53)",
    "gold.1900": "oklch(82.04% 0.1282 75.64)",
    "gold.2000": "oklch(84.96% 0.1214 75.09)",
    "gold.2100": "oklch(87.96% 0.1008 74.55)",
    "gold.2200": "oklch(91.03% 0.0738 74.61)",
    "gold.2300": "oklch(93.95% 0.0484 74.2)",
    "gold.2400": "oklch(96.95% 0.0237 73.62)",
    "gold.2500": "oklch(100% 0 118.64)",
    "gold.base": "1700",
    "gold.light": "1800",
    "gold.midnight": "1600",
    "grape.100": "oklch(0% 0 0)",
    "grape.200": "oklch(16% 0.074 325.04)",
    "grape.300": "oklch(21.94% 0.102 325.42)",
    "grape.400": "oklch(26.91% 0.125 325.57)",
    "grape.500": "oklch(31.98% 0.149 325.5)",
    "grape.600": "oklch(36.97% 0.172 325.54)",
    "grape.700": "oklch(40.83% 0.1901 325.87)",
    "grape.800": "oklch(45% 0.19 325.75)",
    "grape.900": "oklch(49.59% 0.19 326.02)",
    "grape.1000": "oklch(53.62% 0.19 325.94)",
    "grape.1100": "oklch(56.92% 0.19 325.83)",
    "grape.1200": "oklch(60.49% 0.19 325.78)",
    "grape.1300": "oklch(63.99% 0.19 326.08)",
    "grape.1400": "oklch(67.02% 0.19 325.98)",
    "grape.1500": "oklch(70.02% 0.19 325.82)",
    "grape.1600": "oklch(73.01% 0.19 326.03)",
    "grape.1700": "oklch(75.91% 0.182 325.86)",
    "grape.1800": "oklch(78.94% 0.176 326.06)",
    "grape.1900": "oklch(81.92% 0.16 325.82)",
    "grape.2000": "oklch(84.95% 0.139 325.56)",
    "grape.2100": "oklch(87.98% 0.11 325.82)",
    "grape.2200": "oklch(90.89% 0.081 325.49)",
    "grape.2300": "oklch(93.95% 0.054 326)",
    "grape.2400": "oklch(96.94% 0.027 325.78)",
    "grape.2500": "oklch(100% 0 137.33)",
    "grape.base": "700",
    "grape.light": "1000",
    "grape.midnight": "600",
    "green.100": "oklch(0% 0 0)",
    "green.200": "oklch(16.07% 0.0398 151.11)",
    "green.300": "oklch(22.08% 0.0571 152.8)",
    "green.400": "oklch(27.14% 0.0694 152.56)",
    "green.500": "oklch(31.92% 0.0818 152.75)",
    "green.600": "oklch(36.87% 0.0941 153.1)",
    "green.700": "oklch(41.62% 0.1072 152.96)",
    "green.800": "oklch(45.99% 0.118 152.86)",
    "green.900": "oklch(49.9% 0.1289 152.86)",
    "green.1000": "oklch(53.47% 0.1379 152.94)",
    "green.1100": "oklch(56.99% 0.1467 153)",
    "green.1200": "oklch(60.47% 0.155 152.94)",
    "green.1300": "oklch(64.14% 0.1653 152.96)",
    "green.1400": "oklch(67.09% 0.1621 152.98)",
    "green.1500": "oklch(69.97% 0.1603 152.83)",
    "green.1600": "oklch(72.88% 0.1574 152.95)",
    "green.1700": "oklch(76.02% 0.1558 152.86)",
    "green.1800": "oklch(79.14% 0.1542 152.78)",
    "green.1900": "oklch(82.06% 0.1504 152.58)",
    "green.2000": "oklch(84.98% 0.1398 152.67)",
    "green.2100": "oklch(88.06% 0.1265 152.48)",
    "green.2200": "oklch(91.08% 0.1086 152.7)",
    "green.2300": "oklch(94.08% 0.0818 152.13)",
    "green.2400": "oklch(97.13% 0.0452 152.19)",
    "green.2500": "oklch(100% 0 118.64)",
    "green.base": "1300",
    "green.light": "1600",
    "green.midnight": "1200",
    "indigo.100": "oklch(0% 0 0)",
    "indigo.200": "oklch(15.97% 0.096 280.85)",
    "indigo.300": "oklch(21.9% 0.1318 280.75)",
    "indigo.400": "oklch(26.95% 0.1621 280.77)",
    "indigo.500": "oklch(31.99% 0.192 281.12)",
    "indigo.600": "oklch(36.75% 0.2209 280.93)",
    "indigo.700": "oklch(41% 0.22 281.11)",
    "indigo.800": "oklch(45.54% 0.2208 281.08)",
    "indigo.900": "oklch(49.45% 0.2196 281)",
    "indigo.1000": "oklch(53.53% 0.2135 280.99)",
    "indigo.1100": "oklch(57% 0.2078 280.99)",
    "indigo.1200": "oklch(60.54% 0.1977 280.68)",
    "indigo.1300": "oklch(63.96% 0.1856 281.18)",
    "indigo.1400": "oklch(67.04% 0.1736 281.02)",
    "indigo.1500": "oklch(70.08% 0.1601 280.65)",
    "indigo.1600": "oklch(72.89% 0.1436 280.9)",
    "indigo.1700": "oklch(75.98% 0.1257 280.97)",
    "indigo.1800": "oklch(79.12% 0.1078 280.72)",
    "indigo.1900": "oklch(82.07% 0.0915 280.75)",
    "indigo.2000": "oklch(85.04% 0.0753 280.53)",
    "indigo.2100": "oklch(88.08% 0.0594 280.93)",
    "indigo.2200": "oklch(91.05% 0.0438 279.85)",
    "indigo.2300": "oklch(93.91% 0.0297 281.67)",
    "indigo.2400": "oklch(96.96% 0.0147 281.96)",
    "indigo.2500": "oklch(100% 0 118.64)",
    "indigo.base": "600",
    "indigo.light": "900",
    "indigo.midnight": "500",
    "informative.100": "oklch(0% 0 0)",
    "informative.200": "oklch(16% 0.041 249.22)",
    "informative.300": "oklch(22.02% 0.06 249.22)",
    "informative.400": "oklch(26.97% 0.074 249.22)",
    "informative.500": "oklch(31.97% 0.088 249.22)",
    "informative.600": "oklch(37.01% 0.103 249.22)",
    "informative.700": "oklch(41.46% 0.114 249.22)",
    "informative.800": "oklch(46% 0.127 249.22)",
    "informative.900": "oklch(49.97% 0.138 249.22)",
    "informative.1000": "oklch(53.5% 0.147 249.22)",
    "informative.1100": "oklch(57% 0.157 249.22)",
    "informative.1200": "oklch(60.49% 0.167 249.22)",
    "informative.1300": "oklch(64.02% 0.177 249.22)",
    "informative.1400": "oklch(66.98% 0.1827 249.22)",
    "informative.1500": "oklch(70.02% 0.164 249.22)",
    "informative.1600": "oklch(72.98% 0.146 249.22)",
    "informative.1700": "oklch(75.99% 0.128 249.22)",
    "informative.1800": "oklch(79.01% 0.108 249.22)",
    "informative.1900": "oklch(82.01% 0.089 249.22)",
    "informative.2000": "oklch(84.98% 0.072 249.22)",
    "informative.2100": "oklch(88.01% 0.055 249.22)",
    "informative.2200": "oklch(91.01% 0.038 249.22)",
    "informative.2300": "oklch(93.98% 0.024 249.22)",
    "informative.2400": "oklch(97.01% 0.01 249.22)",
    "informative.2500": "oklch(100% 0 137.33)",
    "informative.base": "1400",
    "informative.light": "1500",
    "informative.midnight": "1300",
    "lotus.100": "oklch(0% 0 0)",
    "lotus.200": "oklch(15.78% 0.063 342.19)",
    "lotus.300": "oklch(22.04% 0.0946 342.79)",
    "lotus.400": "oklch(26.99% 0.1163 341.75)",
    "lotus.500": "oklch(31.92% 0.1361 342.35)",
    "lotus.600": "oklch(37.04% 0.1559 342.12)",
    "lotus.700": "oklch(41.47% 0.178 341.89)",
    "lotus.800": "oklch(46.08% 0.1968 342.57)",
    "lotus.900": "oklch(49.97% 0.2151 342.16)",
    "lotus.1000": "oklch(53.57% 0.2304 342.28)",
    "lotus.1100": "oklch(56.97% 0.2378 342.12)",
    "lotus.1200": "oklch(60.52% 0.2482 342.42)",
    "lotus.1300": "oklch(64.13% 0.2553 342.25)",
    "lotus.1400": "oklch(66.99% 0.2502 342.41)",
    "lotus.1500": "oklch(70% 0.2417 342.17)",
    "lotus.1600": "oklch(72.97% 0.2207 342.29)",
    "lotus.1700": "oklch(76.04% 0.189 342.2)",
    "lotus.1800": "oklch(78.99% 0.1604 342.1)",
    "lotus.1900": "oklch(82.06% 0.1322 342.21)",
    "lotus.2000": "oklch(85.01% 0.1069 342.38)",
    "lotus.2100": "oklch(87.96% 0.0839 341.96)",
    "lotus.2200": "oklch(91.01% 0.0611 341.7)",
    "lotus.2300": "oklch(93.91% 0.0396 342.79)",
    "lotus.2400": "oklch(96.95% 0.0199 340.69)",
    "lotus.2500": "oklch(100% 0 118.64)",
    "lotus.base": "1400",
    "lotus.light": "1500",
    "lotus.midnight": "1300",
    "marigold.100": "oklch(0% 0 0)",
    "marigold.200": "oklch(16.09% 0.0327 64.2)",
    "marigold.300": "oklch(22.08% 0.0481 63.47)",
    "marigold.400": "oklch(26.98% 0.0596 64.23)",
    "marigold.500": "oklch(32.11% 0.069 67.19)",
    "marigold.600": "oklch(37.12% 0.0808 66.69)",
    "marigold.700": "oklch(41.42% 0.092 64.77)",
    "marigold.800": "oklch(45.96% 0.1024 63.13)",
    "marigold.900": "oklch(49.93% 0.112 62.44)",
    "marigold.1000": "oklch(53.49% 0.1215 61.81)",
    "marigold.1100": "oklch(57.04% 0.129 62.1)",
    "marigold.1200": "oklch(60.53% 0.1367 62.54)",
    "marigold.1300": "oklch(63.98% 0.1442 62.84)",
    "marigold.1400": "oklch(66.99% 0.1496 64.33)",
    "marigold.1500": "oklch(70.09% 0.1522 67.27)",
    "marigold.1600": "oklch(72.98% 0.1584 67.44)",
    "marigold.1700": "oklch(75.86% 0.1617 69.58)",
    "marigold.1800": "oklch(79.49% 0.1607 75.3)",
    "marigold.1900": "oklch(81.97% 0.1528 75.07)",
    "marigold.2000": "oklch(85.08% 0.1355 77.48)",
    "marigold.2100": "oklch(88.03% 0.1139 81.16)",
    "marigold.2200": "oklch(91.01% 0.092 84.47)",
    "marigold.2300": "oklch(94% 0.0638 89.57)",
    "marigold.2400": "oklch(97.09% 0.0329 89.85)",
    "marigold.2500": "oklch(100% 0 118.64)",
    "marigold.base": "1800",
    "marigold.light": "2100",
    "marigold.midnight": "1500",
    "mint.100": "oklch(0% 0 0)",
    "mint.200": "oklch(16.09% 0.0275 194.77)",
    "mint.300": "oklch(22.05% 0.0376 194.77)",
    "mint.400": "oklch(26.91% 0.0459 194.76)",
    "mint.500": "oklch(31.93% 0.054 194.79)",
    "mint.600": "oklch(37.04% 0.0632 194.76)",
    "mint.700": "oklch(41.41% 0.0697 194.79)",
    "mint.800": "oklch(45.91% 0.0778 194.78)",
    "mint.900": "oklch(50.01% 0.0849 194.78)",
    "mint.1000": "oklch(53.41% 0.0908 194.78)",
    "mint.1100": "oklch(57.07% 0.0971 194.77)",
    "mint.1200": "oklch(60.36% 0.1027 194.77)",
    "mint.1300": "oklch(63.91% 0.1088 194.77)",
    "mint.1400": "oklch(67.13% 0.1142 194.77)",
    "mint.1500": "oklch(69.87% 0.1159 194.83)",
    "mint.1600": "oklch(71.63% 0.1181 194.84)",
    "mint.1700": "oklch(75.03% 0.1181 194.93)",
    "mint.1800": "oklch(78.42% 0.1178 195.02)",
    "mint.1900": "oklch(81.96% 0.1138 194.46)",
    "mint.2000": "oklch(84.9% 0.1098 194.55)",
    "mint.2100": "oklch(87.98% 0.0979 194.72)",
    "mint.2200": "oklch(90.94% 0.0781 194.86)",
    "mint.2300": "oklch(94.02% 0.0575 194.87)",
    "mint.2400": "oklch(97.1% 0.0331 194.32)",
    "mint.2500": "oklch(100% 0 118.64)",
    "mint.base": "1600",
    "mint.light": "1900",
    "mint.midnight": "1500",
    "navi.100": "oklch(0% 0 0)",
    "navi.200": "oklch(16.09% 0.093 265.66)",
    "navi.300": "oklch(22.02% 0.148 264.76)",
    "navi.400": "oklch(27.08% 0.1859 264.96)",
    "navi.500": "oklch(32.06% 0.1855 265.01)",
    "navi.600": "oklch(37% 0.1869 264.99)",
    "navi.700": "oklch(41.4% 0.1857 265.09)",
    "navi.800": "oklch(46.08% 0.1862 265.01)",
    "navi.900": "oklch(50.05% 0.1835 265.02)",
    "navi.1000": "oklch(53.5% 0.1821 265.14)",
    "navi.1100": "oklch(56.95% 0.1806 265.2)",
    "navi.1200": "oklch(60.57% 0.1763 265.1)",
    "navi.1300": "oklch(64.05% 0.1693 264.72)",
    "navi.1400": "oklch(67.05% 0.1617 265.08)",
    "navi.1500": "oklch(70.03% 0.1545 265.11)",
    "navi.1600": "oklch(73.05% 0.1388 264.63)",
    "navi.1700": "oklch(75.96% 0.1223 265.13)",
    "navi.1800": "oklch(79.14% 0.1049 264.95)",
    "navi.1900": "oklch(82.07% 0.0891 264.8)",
    "navi.2000": "oklch(85.04% 0.0735 264.44)",
    "navi.2100": "oklch(88.07% 0.0579 264.7)",
    "navi.2200": "oklch(91.06% 0.0429 263.69)",
    "navi.2300": "oklch(93.93% 0.0287 266.37)",
    "navi.2400": "oklch(96.92% 0.0144 264.5)",
    "navi.2500": "oklch(100% 0 118.64)",
    "navi.base": "700",
    "navi.light": "1000",
    "navi.midnight": "600",
    "negative.100": "oklch(0% 0 0)",
    "negative.200": "oklch(15.92% 0.0602 24.54)",
    "negative.300": "oklch(21.98% 0.0888 23.18)",
    "negative.400": "oklch(27.07% 0.108 23.71)",
    "negative.500": "oklch(31.96% 0.1291 23.51)",
    "negative.600": "oklch(37.04% 0.1489 23.52)",
    "negative.700": "oklch(41.46% 0.1669 23.53)",
    "negative.800": "oklch(45.94% 0.1856 23.54)",
    "negative.900": "oklch(50.01% 0.2013 23.62)",
    "negative.1000": "oklch(53.5% 0.2162 23.6)",
    "negative.1100": "oklch(57.02% 0.2301 23.5)",
    "negative.1200": "oklch(61.19% 0.2472 23.53)",
    "negative.1300": "oklch(64.05% 0.2453 23.56)",
    "negative.1400": "oklch(67.06% 0.2169 23.57)",
    "negative.1500": "oklch(70.03% 0.1907 23.39)",
    "negative.1600": "oklch(73.07% 0.1656 23.73)",
    "negative.1700": "oklch(76.04% 0.1427 23.55)",
    "negative.1800": "oklch(78.98% 0.1194 23.23)",
    "negative.1900": "oklch(82% 0.0952 24.09)",
    "negative.2000": "oklch(84.93% 0.0748 23.84)",
    "negative.2100": "oklch(88.07% 0.0562 23.7)",
    "negative.2200": "oklch(91.06% 0.0394 23.71)",
    "negative.2300": "oklch(93.9% 0.0243 23.85)",
    "negative.2400": "oklch(97.09% 0.0098 25.08)",
    "negative.2500": "oklch(100% 0 118.64)",
    "negative.base": "1400",
    "negative.light": "1500",
    "negative.midnight": "600",
    "neutral.100": "oklch(0% 0 0)",
    "neutral.200": "oklch(15.93% 0.0065 270.98)",
    "neutral.300": "oklch(22.13% 0.0066 258.36)",
    "neutral.400": "oklch(26.87% 0.0097 268.31)",
    "neutral.500": "oklch(32.05% 0.0115 264.4)",
    "neutral.600": "oklch(37.04% 0.0131 261.74)",
    "neutral.700": "oklch(41.53% 0.0164 262.31)",
    "neutral.800": "oklch(45.96% 0.0174 264.39)",
    "neutral.900": "oklch(49.97% 0.0166 268.34)",
    "neutral.1000": "oklch(53.44% 0.0149 266.61)",
    "neutral.1100": "oklch(56.85% 0.0132 264.46)",
    "neutral.1200": "oklch(60.55% 0.0116 261.78)",
    "neutral.1300": "oklch(63.98% 0.011 267.31)",
    "neutral.1400": "oklch(66.96% 0.0109 267.32)",
    "neutral.1500": "oklch(69.95% 0.009 271.28)",
    "neutral.1600": "oklch(73.07% 0.008 260.73)",
    "neutral.1700": "oklch(76.03% 0.0074 268.53)",
    "neutral.1800": "oklch(78.85% 0.006 264.53)",
    "neutral.1900": "oklch(81.96% 0.0047 258.33)",
    "neutral.2000": "oklch(85.04% 0.0035 247.86)",
    "neutral.2100": "oklch(87.9% 0.003 264.53)",
    "neutral.2200": "oklch(90.92% 0.0017 247.84)",
    "neutral.2300": "oklch(94.04% 0.0013 286.37)",
    "neutral.2400": "oklch(97.04% 0.0013 286.37)",
    "neutral.2500": "oklch(100% 0 118.64)",
    "neutral.base": "200",
    "neutral.light": "300",
    "neutral.midnight": "100",
    "olive.100": "oklch(0% 0 0)",
    "olive.200": "oklch(16% 0.0441 146.75)",
    "olive.300": "oklch(21.97% 0.0642 147.64)",
    "olive.400": "oklch(27% 0.078 147.45)",
    "olive.500": "oklch(32.05% 0.0938 147.56)",
    "olive.600": "oklch(37% 0.1065 147.96)",
    "olive.700": "oklch(41.41% 0.1198 148.02)",
    "olive.800": "oklch(46.05% 0.1327 148.05)",
    "olive.900": "oklch(49.96% 0.144 148.16)",
    "olive.1000": "oklch(54.7% 0.1559 148.53)",
    "olive.1100": "oklch(57.04% 0.1541 148.59)",
    "olive.1200": "oklch(60.38% 0.152 148.16)",
    "olive.1300": "oklch(63.98% 0.1495 148.22)",
    "olive.1400": "oklch(67.1% 0.1509 147.87)",
    "olive.1500": "oklch(70.03% 0.1482 147.87)",
    "olive.1600": "oklch(72.96% 0.1453 147.8)",
    "olive.1700": "oklch(75.93% 0.1417 147.44)",
    "olive.1800": "oklch(78.94% 0.1358 147.6)",
    "olive.1900": "oklch(82.05% 0.1286 147.2)",
    "olive.2000": "oklch(84.98% 0.1178 147.42)",
    "olive.2100": "oklch(88.06% 0.1045 147.33)",
    "olive.2200": "oklch(91.04% 0.0878 147.2)",
    "olive.2300": "oklch(94.01% 0.0661 147)",
    "olive.2400": "oklch(97.06% 0.0384 147.64)",
    "olive.2500": "oklch(100% 0 118.64)",
    "olive.base": "1000",
    "olive.light": "1200",
    "olive.midnight": "900",
    "orange.100": "oklch(0% 0 0)",
    "orange.200": "oklch(16.15% 0.0379 50.75)",
    "orange.300": "oklch(21.91% 0.0565 51.77)",
    "orange.400": "oklch(26.97% 0.07 51.34)",
    "orange.500": "oklch(32.15% 0.0831 51.61)",
    "orange.600": "oklch(36.96% 0.0965 50.87)",
    "orange.700": "oklch(41.46% 0.1064 51.72)",
    "orange.800": "oklch(46% 0.1191 51.17)",
    "orange.900": "oklch(49.94% 0.1304 50.9)",
    "orange.1000": "oklch(53.51% 0.1393 51.11)",
    "orange.1100": "oklch(57.03% 0.1481 51.29)",
    "orange.1200": "oklch(60.49% 0.1566 51.37)",
    "orange.1300": "oklch(64.05% 0.166 51.27)",
    "orange.1400": "oklch(66.98% 0.1734 51.49)",
    "orange.1500": "oklch(70.15% 0.1824 51.19)",
    "orange.1600": "oklch(72.1% 0.1803 51.26)",
    "orange.1700": "oklch(74.97% 0.163 51.09)",
    "orange.1800": "oklch(78.6% 0.139 51.51)",
    "orange.1900": "oklch(82.06% 0.1132 51.53)",
    "orange.2000": "oklch(85.01% 0.0917 51.03)",
    "orange.2100": "oklch(88.04% 0.0716 51.46)",
    "orange.2200": "oklch(90.97% 0.0521 49.98)",
    "orange.2300": "oklch(93.93% 0.0343 50.21)",
    "orange.2400": "oklch(96.95% 0.0169 50.44)",
    "orange.2500": "oklch(100% 0 118.64)",
    "orange.base": "1600",
    "orange.light": "1900",
    "orange.midnight": "1300",
    "peach.100": "oklch(0% 0 0)",
    "peach.200": "oklch(15.84% 0.0409 51.83)",
    "peach.300": "oklch(22.1% 0.0599 48.33)",
    "peach.400": "oklch(26.97% 0.0741 47.45)",
    "peach.500": "oklch(31.97% 0.0879 47.43)",
    "peach.600": "oklch(36.97% 0.102 47.02)",
    "peach.700": "oklch(41.46% 0.1137 47.14)",
    "peach.800": "oklch(46% 0.126 47.19)",
    "peach.900": "oklch(49.97% 0.1343 47.02)",
    "peach.1000": "oklch(53.56% 0.1421 46.73)",
    "peach.1100": "oklch(56.97% 0.146 46.59)",
    "peach.1200": "oklch(60.49% 0.149 46.13)",
    "peach.1300": "oklch(64.02% 0.149 46.18)",
    "peach.1400": "oklch(67.07% 0.1498 46.69)",
    "peach.1500": "oklch(69.96% 0.15 46.55)",
    "peach.1600": "oklch(73.08% 0.1518 46.22)",
    "peach.1700": "oklch(76.07% 0.146 46.46)",
    "peach.1800": "oklch(78.91% 0.132 47.06)",
    "peach.1900": "oklch(82% 0.109 47.02)",
    "peach.2000": "oklch(85.11% 0.0885 47.65)",
    "peach.2100": "oklch(87.94% 0.0694 46.53)",
    "peach.2200": "oklch(91.02% 0.0507 47.5)",
    "peach.2300": "oklch(93.98% 0.0329 46.4)",
    "peach.2400": "oklch(96.97% 0.0162 46.57)",
    "peach.2500": "oklch(100% 0 118.64)",
    "peach.base": "1600",
    "peach.light": "1900",
    "peach.midnight": "1300",
    "peacock.100": "oklch(0% 0 0)",
    "peacock.200": "oklch(15.91% 0.0134 177.8)",
    "peacock.300": "oklch(22.04% 0.0283 179.48)",
    "peacock.400": "oklch(26.82% 0.0378 181.06)",
    "peacock.500": "oklch(32.05% 0.0485 180.32)",
    "peacock.600": "oklch(37.11% 0.0584 179.81)",
    "peacock.700": "oklch(41.38% 0.066 180.43)",
    "peacock.800": "oklch(45.9% 0.0734 180.97)",
    "peacock.900": "oklch(50% 0.0801 180.13)",
    "peacock.1000": "oklch(53.38% 0.086 180.3)",
    "peacock.1100": "oklch(57.12% 0.0905 180.32)",
    "peacock.1200": "oklch(60.51% 0.0942 180.22)",
    "peacock.1300": "oklch(63.88% 0.0974 180.94)",
    "peacock.1400": "oklch(67.1% 0.1025 180.13)",
    "peacock.1500": "oklch(69.96% 0.1022 180.33)",
    "peacock.1600": "oklch(73.41% 0.1074 180.43)",
    "peacock.1700": "oklch(76.06% 0.1043 180.25)",
    "peacock.1800": "oklch(79.11% 0.1046 180.5)",
    "peacock.1900": "oklch(82% 0.1021 180.38)",
    "peacock.2000": "oklch(85.01% 0.0975 180.76)",
    "peacock.2100": "oklch(87.92% 0.0894 180.62)",
    "peacock.2200": "oklch(90.93% 0.0795 181.06)",
    "peacock.2300": "oklch(94.04% 0.0638 180.27)",
    "peacock.2400": "oklch(97% 0.0418 179.87)",
    "peacock.2500": "oklch(100% 0 118.64)",
    "peacock.base": "1600",
    "peacock.light": "1700",
    "peacock.midnight": "1500",
    "pink.100": "oklch(0% 0 0)",
    "pink.200": "oklch(15.97% 0.0432 349.21)",
    "pink.300": "oklch(22.01% 0.0817 351.21)",
    "pink.400": "oklch(26.93% 0.112 350.76)",
    "pink.500": "oklch(31.95% 0.1329 350.82)",
    "pink.600": "oklch(37.08% 0.1534 350.72)",
    "pink.700": "oklch(41.51% 0.1719 350.94)",
    "pink.800": "oklch(46.05% 0.1909 350.95)",
    "pink.900": "oklch(50.05% 0.2082 350.79)",
    "pink.1000": "oklch(53.43% 0.222 350.72)",
    "pink.1100": "oklch(58.28% 0.2425 350.72)",
    "pink.1200": "oklch(60.46% 0.242 350.51)",
    "pink.1300": "oklch(63.95% 0.2402 350.8)",
    "pink.1400": "oklch(67.02% 0.24 350.61)",
    "pink.1500": "oklch(70.05% 0.227 350.84)",
    "pink.1600": "oklch(72.93% 0.1986 350.82)",
    "pink.1700": "oklch(76.02% 0.17 350.63)",
    "pink.1800": "oklch(79.01% 0.1436 350.88)",
    "pink.1900": "oklch(82.09% 0.1185 350.83)",
    "pink.2000": "oklch(85.01% 0.0965 350.54)",
    "pink.2100": "oklch(88.03% 0.0747 350.54)",
    "pink.2200": "oklch(90.97% 0.0548 350.43)",
    "pink.2300": "oklch(93.98% 0.0353 350.87)",
    "pink.2400": "oklch(97.06% 0.0164 353.63)",
    "pink.2500": "oklch(100% 0 118.64)",
    "pink.base": "1100",
    "pink.light": "1400",
    "pink.midnight": "1000",
    "positive.100": "oklch(0% 0 0)",
    "positive.200": "oklch(16.13% 0.0228 141.37)",
    "positive.300": "oklch(22.07% 0.0464 141.91)",
    "positive.400": "oklch(27.13% 0.0709 142.4)",
    "positive.500": "oklch(31.97% 0.0944 142.49)",
    "positive.600": "oklch(37.03% 0.1162 142.5)",
    "positive.700": "oklch(41.6% 0.1362 142.54)",
    "positive.800": "oklch(46.11% 0.1543 142.49)",
    "positive.900": "oklch(49.92% 0.1698 142.49)",
    "positive.1000": "oklch(53.44% 0.1818 142.49)",
    "positive.1100": "oklch(56.96% 0.1917 142.5)",
    "positive.1200": "oklch(60.49% 0.1999 142.48)",
    "positive.1300": "oklch(64.72% 0.204 142.5)",
    "positive.1400": "oklch(66.97% 0.202 142.48)",
    "positive.1500": "oklch(70.1% 0.2002 142.55)",
    "positive.1600": "oklch(72.86% 0.1917 142.52)",
    "positive.1700": "oklch(75.92% 0.1839 142.44)",
    "positive.1800": "oklch(78.89% 0.17 142.46)",
    "positive.1900": "oklch(81.96% 0.1538 142.67)",
    "positive.2000": "oklch(84.9% 0.1355 142.35)",
    "positive.2100": "oklch(87.95% 0.1146 142.45)",
    "positive.2200": "oklch(90.93% 0.09 142.46)",
    "positive.2300": "oklch(93.87% 0.0618 142.21)",
    "positive.2400": "oklch(96.94% 0.0324 142.49)",
    "positive.2500": "oklch(100% 0 118.64)",
    "positive.base": "1500",
    "positive.light": "1600",
    "positive.midnight": "800",
    "purple.100": "oklch(0% 0 0)",
    "purple.200": "oklch(16.05% 0.0872 296.68)",
    "purple.300": "oklch(21.92% 0.12 295.49)",
    "purple.400": "oklch(27.07% 0.1477 296.11)",
    "purple.500": "oklch(31.97% 0.175 295.54)",
    "purple.600": "oklch(37.04% 0.2024 295.91)",
    "purple.700": "oklch(41.5% 0.2269 295.76)",
    "purple.800": "oklch(46.83% 0.2417 295.88)",
    "purple.900": "oklch(49.93% 0.24 295.79)",
    "purple.1000": "oklch(53.47% 0.239 295.9)",
    "purple.1100": "oklch(57.08% 0.238 295.97)",
    "purple.1200": "oklch(60.55% 0.23 296.01)",
    "purple.1300": "oklch(64.03% 0.217 296.09)",
    "purple.1400": "oklch(66.92% 0.198 295.83)",
    "purple.1500": "oklch(70.08% 0.178 296)",
    "purple.1600": "oklch(72.91% 0.158 295.91)",
    "purple.1700": "oklch(76.06% 0.138 295.74)",
    "purple.1800": "oklch(78.92% 0.1206 295.95)",
    "purple.1900": "oklch(81.99% 0.1014 295.56)",
    "purple.2000": "oklch(84.97% 0.0839 296.03)",
    "purple.2100": "oklch(87.97% 0.0666 296.46)",
    "purple.2200": "oklch(90.97% 0.0496 296.85)",
    "purple.2300": "oklch(93.98% 0.0327 297.21)",
    "purple.2400": "oklch(96.99% 0.0162 297.52)",
    "purple.2500": "oklch(100% 0 118.64)",
    "purple.base": "800",
    "purple.light": "1100",
    "purple.midnight": "700",
    "red.100": "oklch(0% 0 0)",
    "red.200": "oklch(15.93% 0.0641 20.03)",
    "red.300": "oklch(22.02% 0.0886 21.01)",
    "red.400": "oklch(26.88% 0.1098 27.84)",
    "red.500": "oklch(31.93% 0.1294 27.8)",
    "red.600": "oklch(37.07% 0.1515 27.91)",
    "red.700": "oklch(41.53% 0.1691 27.82)",
    "red.800": "oklch(46.06% 0.1872 27.86)",
    "red.900": "oklch(50.01% 0.204 27.98)",
    "red.1000": "oklch(53.57% 0.2182 27.95)",
    "red.1100": "oklch(57.68% 0.2341 27.91)",
    "red.1200": "oklch(60.48% 0.232 27.85)",
    "red.1300": "oklch(64% 0.226 27.87)",
    "red.1400": "oklch(67% 0.215 27.86)",
    "red.1500": "oklch(69.95% 0.191 27.82)",
    "red.1600": "oklch(73.04% 0.1661 27.9)",
    "red.1700": "oklch(76.03% 0.143 28.07)",
    "red.1800": "oklch(79.11% 0.1208 28.12)",
    "red.1900": "oklch(82.01% 0.101 27.66)",
    "red.2000": "oklch(85.03% 0.0815 27.28)",
    "red.2100": "oklch(88.13% 0.0629 28.11)",
    "red.2200": "oklch(90.94% 0.0467 26.21)",
    "red.2300": "oklch(93.97% 0.0303 27.75)",
    "red.2400": "oklch(97.08% 0.0143 28.01)",
    "red.2500": "oklch(100% 0 118.64)",
    "red.base": "1100",
    "red.light": "1400",
    "red.midnight": "800",
    "reliance.100": "oklch(0% 0 0)",
    "reliance.200": "oklch(16.06% 0.0879 263.69)",
    "reliance.300": "oklch(21.99% 0.1407 264.22)",
    "reliance.400": "oklch(26.97% 0.172 264.53)",
    "reliance.500": "oklch(31.94% 0.1904 264.3)",
    "reliance.600": "oklch(36.55% 0.208 264.33)",
    "reliance.700": "oklch(40.1% 0.218 264.38)",
    "reliance.800": "oklch(43.92% 0.2209 264.39)",
    "reliance.900": "oklch(48.1% 0.219 264.36)",
    "reliance.1000": "oklch(52.45% 0.217 264.53)",
    "reliance.1100": "oklch(56.07% 0.214 264.3)",
    "reliance.1200": "oklch(60.44% 0.205 264.4)",
    "reliance.1300": "oklch(63.88% 0.192 264.5)",
    "reliance.1400": "oklch(66.96% 0.1725 264.6)",
    "reliance.1500": "oklch(69.97% 0.1565 264.58)",
    "reliance.1600": "oklch(72.99% 0.1392 264.26)",
    "reliance.1700": "oklch(75.91% 0.1227 264.7)",
    "reliance.1800": "oklch(79.08% 0.1052 264.44)",
    "reliance.1900": "oklch(82.01% 0.0895 264.19)",
    "reliance.2000": "oklch(85.04% 0.0735 264.44)",
    "reliance.2100": "oklch(88.07% 0.0579 264.7)",
    "reliance.2200": "oklch(91.06% 0.0429 263.69)",
    "reliance.2300": "oklch(93.93% 0.0287 266.37)",
    "reliance.2400": "oklch(96.92% 0.0144 264.5)",
    "reliance.2500": "oklch(100% 0 118.64)",
    "reliance.base": "700",
    "reliance.light": "1100",
    "reliance.midnight": "600",
    "sand.100": "oklch(0% 0 0)",
    "sand.200": "oklch(16.01% 0.0209 58.51)",
    "sand.300": "oklch(22% 0.0348 55.04)",
    "sand.400": "oklch(26.91% 0.046 57.17)",
    "sand.500": "oklch(31.88% 0.0538 57.36)",
    "sand.600": "oklch(36.92% 0.0643 56.67)",
    "sand.700": "oklch(41.52% 0.0722 57.59)",
    "sand.800": "oklch(46.03% 0.0786 57.03)",
    "sand.900": "oklch(49.96% 0.0839 57.07)",
    "sand.1000": "oklch(53.5% 0.0885 56.48)",
    "sand.1100": "oklch(56.94% 0.0893 56.95)",
    "sand.1200": "oklch(60.48% 0.0905 56.26)",
    "sand.1300": "oklch(64.05% 0.0902 57.16)",
    "sand.1400": "oklch(67.07% 0.0904 56.87)",
    "sand.1500": "oklch(69.95% 0.0896 57.04)",
    "sand.1600": "oklch(72.92% 0.0898 56.69)",
    "sand.1700": "oklch(75.61% 0.0925 57.06)",
    "sand.1800": "oklch(78.95% 0.09 57.09)",
    "sand.1900": "oklch(82% 0.0832 57.29)",
    "sand.2000": "oklch(84.93% 0.0784 56.35)",
    "sand.2100": "oklch(88.01% 0.0682 57.35)",
    "sand.2200": "oklch(91.05% 0.0557 57.35)",
    "sand.2300": "oklch(94.05% 0.0365 58.05)",
    "sand.2400": "oklch(96.92% 0.0177 53.99)",
    "sand.2500": "oklch(100% 0 118.64)",
    "sand.base": "1700",
    "sand.light": "1800",
    "sand.midnight": "1600",
    "scarlet.100": "oklch(0% 0 0)",
    "scarlet.200": "oklch(15.96% 0.0527 28.72)",
    "scarlet.300": "oklch(21.88% 0.0898 29.25)",
    "scarlet.400": "oklch(26.95% 0.1093 29.62)",
    "scarlet.500": "oklch(32.04% 0.1315 29.24)",
    "scarlet.600": "oklch(37.09% 0.1514 29.11)",
    "scarlet.700": "oklch(41.44% 0.17 29.24)",
    "scarlet.800": "oklch(46.01% 0.1878 29.25)",
    "scarlet.900": "oklch(49.94% 0.2049 29.23)",
    "scarlet.1000": "oklch(52.1% 0.2138 29.24)",
    "scarlet.1100": "oklch(55.05% 0.2119 29.23)",
    "scarlet.1200": "oklch(59.41% 0.2097 29.29)",
    "scarlet.1300": "oklch(63.11% 0.206 29.26)",
    "scarlet.1400": "oklch(66.52% 0.1976 29.4)",
    "scarlet.1500": "oklch(70.01% 0.1865 29.12)",
    "scarlet.1600": "oklch(72.99% 0.1667 29.1)",
    "scarlet.1700": "oklch(75.99% 0.1435 29.05)",
    "scarlet.1800": "oklch(79.07% 0.1213 29.31)",
    "scarlet.1900": "oklch(81.97% 0.1015 29.11)",
    "scarlet.2000": "oklch(84.89% 0.0809 29.21)",
    "scarlet.2100": "oklch(88.11% 0.0631 29.28)",
    "scarlet.2200": "oklch(91.1% 0.046 29.64)",
    "scarlet.2300": "oklch(93.97% 0.0303 27.75)",
    "scarlet.2400": "oklch(97.05% 0.0146 33.07)",
    "scarlet.2500": "oklch(100% 0 118.64)",
    "scarlet.base": "1000",
    "scarlet.light": "1300",
    "scarlet.midnight": "900",
    "sky.100": "oklch(0% 0 0)",
    "sky.200": "oklch(16% 0.035 237.96)",
    "sky.300": "oklch(22.02% 0.048 237.96)",
    "sky.400": "oklch(26.97% 0.06 237.96)",
    "sky.500": "oklch(31.97% 0.07 237.96)",
    "sky.600": "oklch(37.01% 0.082 237.96)",
    "sky.700": "oklch(41.46% 0.092 237.96)",
    "sky.800": "oklch(46% 0.102 237.96)",
    "sky.900": "oklch(49.97% 0.11 237.96)",
    "sky.1000": "oklch(54.36% 0.1205 237.96)",
    "sky.1100": "oklch(57% 0.12 237.96)",
    "sky.1200": "oklch(60.49% 0.12 237.96)",
    "sky.1300": "oklch(64.02% 0.12 237.96)",
    "sky.1400": "oklch(67.01% 0.12 237.96)",
    "sky.1500": "oklch(70.02% 0.118 237.96)",
    "sky.1600": "oklch(72.98% 0.114 237.96)",
    "sky.1700": "oklch(75.99% 0.108 237.96)",
    "sky.1800": "oklch(79% 0.102 237.96)",
    "sky.1900": "oklch(82.01% 0.094 237.96)",
    "sky.2000": "oklch(84.98% 0.084 237.96)",
    "sky.2100": "oklch(88.01% 0.066 237.96)",
    "sky.2200": "oklch(91.01% 0.049 237.96)",
    "sky.2300": "oklch(93.98% 0.032 237.96)",
    "sky.2400": "oklch(97.01% 0.016 237.96)",
    "sky.2500": "oklch(100% 0 137.33)",
    "sky.base": "1000",
    "sky.light": "1300",
    "sky.midnight": "900",
    "tulip.100": "oklch(0% 0 0)",
    "tulip.200": "oklch(16.01% 0.056 20.35)",
    "tulip.300": "oklch(22.02% 0.0819 20.54)",
    "tulip.400": "oklch(27.01% 0.1026 19.78)",
    "tulip.500": "oklch(31.92% 0.1208 19.84)",
    "tulip.600": "oklch(37% 0.1408 20.01)",
    "tulip.700": "oklch(41.4% 0.1565 19.99)",
    "tulip.800": "oklch(45.98% 0.1747 19.95)",
    "tulip.900": "oklch(50.06% 0.1906 20.09)",
    "tulip.1000": "oklch(53.54% 0.2032 20.03)",
    "tulip.1100": "oklch(57.56% 0.2124 19.88)",
    "tulip.1200": "oklch(60.96% 0.219 20.13)",
    "tulip.1300": "oklch(65.25% 0.2219 20)",
    "tulip.1400": "oklch(67.66% 0.2122 20.02)",
    "tulip.1500": "oklch(70.06% 0.1911 20.18)",
    "tulip.1600": "oklch(73.07% 0.1661 20.29)",
    "tulip.1700": "oklch(76.02% 0.1432 19.95)",
    "tulip.1800": "oklch(78.98% 0.1177 20.03)",
    "tulip.1900": "oklch(82.03% 0.097 20.15)",
    "tulip.2000": "oklch(84.92% 0.0768 19.79)",
    "tulip.2100": "oklch(87.91% 0.0606 19.63)",
    "tulip.2200": "oklch(91.06% 0.0427 21.54)",
    "tulip.2300": "oklch(93.97% 0.0287 20.33)",
    "tulip.2400": "oklch(97.03% 0.013 23.19)",
    "tulip.2500": "oklch(100% 0 118.64)",
    "tulip.base": "1300",
    "tulip.light": "1600",
    "tulip.midnight": "1200",
    "violet.100": "oklch(0% 0 0)",
    "violet.200": "oklch(16.08% 0.0544 327.75)",
    "violet.300": "oklch(22.06% 0.0866 326.98)",
    "violet.400": "oklch(26.97% 0.1113 326.57)",
    "violet.500": "oklch(31.97% 0.1399 326.45)",
    "violet.600": "oklch(36.95% 0.1675 326.87)",
    "violet.700": "oklch(41.41% 0.1919 326.73)",
    "violet.800": "oklch(45.93% 0.2075 326.84)",
    "violet.900": "oklch(49.97% 0.2155 326.83)",
    "violet.1000": "oklch(53.46% 0.2257 326.87)",
    "violet.1100": "oklch(57% 0.2345 326.9)",
    "violet.1200": "oklch(59.45% 0.2336 326.81)",
    "violet.1300": "oklch(64.01% 0.236 326.73)",
    "violet.1400": "oklch(66.99% 0.2317 326.62)",
    "violet.1500": "oklch(70.07% 0.2234 327.05)",
    "violet.1600": "oklch(73.02% 0.2139 326.59)",
    "violet.1700": "oklch(76.04% 0.1994 327)",
    "violet.1800": "oklch(79.08% 0.1845 326.81)",
    "violet.1900": "oklch(82.03% 0.1634 326.94)",
    "violet.2000": "oklch(84.95% 0.1444 326.76)",
    "violet.2100": "oklch(88.05% 0.1107 326.97)",
    "violet.2200": "oklch(91.01% 0.0812 326.88)",
    "violet.2300": "oklch(93.91% 0.0535 326.96)",
    "violet.2400": "oklch(97.1% 0.0244 327.79)",
    "violet.2500": "oklch(100% 0 118.64)",
    "violet.base": "1200",
    "violet.light": "1500",
    "violet.midnight": "1100",
    "warning.100": "oklch(0% 0 0)",
    "warning.200": "oklch(16% 0.0448 46.21)",
    "warning.300": "oklch(22.1% 0.0599 48.33)",
    "warning.400": "oklch(26.97% 0.0741 47.45)",
    "warning.500": "oklch(31.97% 0.0879 47.43)",
    "warning.600": "oklch(36.97% 0.1022 47.02)",
    "warning.700": "oklch(41.46% 0.1137 47.14)",
    "warning.800": "oklch(46% 0.1263 47.19)",
    "warning.900": "oklch(49.95% 0.1373 47.2)",
    "warning.1000": "oklch(53.52% 0.1459 47.56)",
    "warning.1100": "oklch(57.03% 0.1564 47.39)",
    "warning.1200": "oklch(60.5% 0.1667 47.14)",
    "warning.1300": "oklch(64.05% 0.1761 47.4)",
    "warning.1400": "oklch(68.31% 0.1835 47.45)",
    "warning.1500": "oklch(69.95% 0.1814 47.35)",
    "warning.1600": "oklch(72.88% 0.171 47.42)",
    "warning.1700": "oklch(76.01% 0.1547 47.33)",
    "warning.1800": "oklch(79.02% 0.1315 47.25)",
    "warning.1900": "oklch(82% 0.1095 47.02)",
    "warning.2000": "oklch(84.93% 0.0891 46.58)",
    "warning.2100": "oklch(87.94% 0.0694 46.53)",
    "warning.2200": "oklch(91.02% 0.0507 47.5)",
    "warning.2300": "oklch(93.98% 0.0329 46.4)",
    "warning.2400": "oklch(96.97% 0.0162 46.57)",
    "warning.2500": "oklch(100% 0 118.64)",
    "warning.base": "1600",
    "warning.light": "1700",
    "warning.midnight": "900",
    "yellow.100": "oklch(0% 0 0)",
    "yellow.200": "oklch(16% 0.028 93.94)",
    "yellow.300": "oklch(22.02% 0.045 93.94)",
    "yellow.400": "oklch(26.97% 0.055 93.94)",
    "yellow.500": "oklch(31.97% 0.065 93.94)",
    "yellow.600": "oklch(37.01% 0.075 93.94)",
    "yellow.700": "oklch(41.46% 0.085 93.94)",
    "yellow.800": "oklch(46% 0.094 93.94)",
    "yellow.900": "oklch(49.97% 0.102 93.94)",
    "yellow.1000": "oklch(53.5% 0.109 93.94)",
    "yellow.1100": "oklch(57% 0.116 93.94)",
    "yellow.1200": "oklch(60.49% 0.123 93.94)",
    "yellow.1300": "oklch(64.02% 0.131 93.94)",
    "yellow.1400": "oklch(67.01% 0.137 93.94)",
    "yellow.1500": "oklch(70.02% 0.143 93.94)",
    "yellow.1600": "oklch(72.98% 0.149 93.94)",
    "yellow.1700": "oklch(75.99% 0.155 93.94)",
    "yellow.1800": "oklch(79.5% 0.158 93.94)",
    "yellow.1900": "oklch(82.5% 0.159 93.94)",
    "yellow.2000": "oklch(86% 0.16 93.94)",
    "yellow.2100": "oklch(89.32% 0.1612 93.94)",
    "yellow.2200": "oklch(91.3% 0.131 93.94)",
    "yellow.2300": "oklch(93.98% 0.091 93.94)",
    "yellow.2400": "oklch(97.01% 0.045 93.94)",
    "yellow.2500": "oklch(100% 0 137.33)",
    "yellow.base": "1300",
    "yellow.light": "1400",
    "yellow.midnight": "1200",
    "saffron.100": "oklch(0% 0 0)",
    "saffron.200": "oklch(16.04% 0.043 41.91)",
    "saffron.300": "oklch(21.97% 0.065 42.74)",
    "saffron.400": "oklch(26.89% 0.081 41.77)",
    "saffron.500": "oklch(31.93% 0.097 41.62)",
    "saffron.600": "oklch(37.10% 0.112 41.55)",
    "saffron.700": "oklch(41.46% 0.126 41.45)",
    "saffron.800": "oklch(46.03% 0.140 41.40)",
    "saffron.900": "oklch(49.98% 0.151 41.60)",
    "saffron.1000": "oklch(53.43% 0.162 41.42)",
    "saffron.1100": "oklch(57.11% 0.173 41.48)",
    "saffron.1200": "oklch(60.45% 0.184 41.41)",
    "saffron.1300": "oklch(64.03% 0.195 41.32)",
    "saffron.1400": "oklch(67.05% 0.198 41.63)",
    "saffron.1500": "oklch(69.80% 0.200 41.49)",
    "saffron.1600": "oklch(72.01% 0.181 41.55)",
    "saffron.1700": "oklch(75.00% 0.157 41.31)",
    "saffron.1800": "oklch(78.47% 0.130 40.94)",
    "saffron.1900": "oklch(82.00% 0.105 40.89)",
    "saffron.2000": "oklch(84.99% 0.080 41.78)",
    "saffron.2100": "oklch(87.93% 0.060 41.56)",
    "saffron.2200": "oklch(90.96% 0.040 41.03)",
    "saffron.2300": "oklch(93.97% 0.025 42.10)",
    "saffron.2400": "oklch(97.03% 0.011 39.44)",
    "saffron.2500": "oklch(100.00% 0.000 0)",
    "saffron.base": "1500",
    "saffron.light": "1600",
    "saffron.midnight": "1400"
};
const $f8fd43f1ee3f8cd8$var$config$1 = {
    brand: $f8fd43f1ee3f8cd8$var$brand,
    foundation: $f8fd43f1ee3f8cd8$var$foundation,
    colors: $f8fd43f1ee3f8cd8$var$colors
};
const $f8fd43f1ee3f8cd8$var$surfaceAliases = {
    "subtle-": "subtleDecreased",
    "moderate-": "moderateDecreased",
    "minimal-": "minimalDecreased"
};
function $f8fd43f1ee3f8cd8$export$1630fb55fe6ce943(appearance, scale = 25, surface, boldOption = "delta", mode = "light") {
    let color = appearance;
    const surfaceScale = $f8fd43f1ee3f8cd8$var$config$1.foundation.step.surface[$f8fd43f1ee3f8cd8$var$surfaceAliases[surface] || surface];
    const surfaceConrast = $f8fd43f1ee3f8cd8$var$config$1.foundation.contrast.surface[surface];
    const isMidnight = appearance?.includes("midnight");
    color = $f8fd43f1ee3f8cd8$var$replaceMidnight(color);
    const contrast1 = $f8fd43f1ee3f8cd8$var$getContrast(color, scale, 2);
    const contrast2 = $f8fd43f1ee3f8cd8$var$getContrast(color, scale, 25);
    const isForward = contrast2 > contrast1;
    switch(surface){
        case "default":
            scale = mode === "dark" ? 2 : 25;
            break;
        case "ghost":
            return scale;
        case "minimal":
            if (isForward) scale += surfaceScale;
            else scale -= surfaceScale;
            break;
        case "minimal-":
            if (scale <= 1) scale = scale - surfaceScale;
            else if (scale >= 25) scale = scale + surfaceScale;
            else if (isForward) scale += surfaceScale;
            else scale -= surfaceScale;
            break;
        case "subtle":
            scale = isForward ? scale + surfaceScale : scale - surfaceScale;
            break;
        case "subtle-":
            if (scale <= 2) scale = scale - surfaceScale;
            else if (scale >= 24) scale = scale + surfaceScale;
            else isForward ? scale += surfaceScale : scale -= surfaceScale;
            break;
        case "moderate":
            isForward ? scale += surfaceScale : scale -= surfaceScale;
            break;
        case "moderate-":
            if (scale <= 3) scale = scale - surfaceScale;
            else if (scale >= 23) scale = scale + surfaceScale;
            else isForward ? scale += surfaceScale : scale -= surfaceScale;
            break;
        case "bold":
            {
                const baseScale = $f8fd43f1ee3f8cd8$var$getAdjustedBaseScale(scale, color, isMidnight);
                let contrast = $f8fd43f1ee3f8cd8$var$getContrast(color, scale, baseScale);
                if (contrast >= surfaceConrast) scale = baseScale;
                else {
                    if (boldOption === "contrast") {
                        if (scale >= 3 && scale <= 24) while(contrast < surfaceConrast){
                            if (isForward && baseScale === 25 || !isForward && baseScale === 1) break;
                            scale += isForward ? 1 : -1;
                            contrast = $f8fd43f1ee3f8cd8$var$getContrast(color, scale, baseScale);
                        }
                        else scale = baseScale;
                    } else if (boldOption === "white") {
                        if (scale >= 3 && scale <= 6) scale += 7;
                        else if (scale >= 7 && scale <= 18) scale = 25;
                        else if (scale >= 19 && scale <= 24) scale -= 7;
                        else scale = baseScale;
                    } else {
                        if (scale >= 3 && scale <= 10) scale += 7;
                        else if (scale >= 11 && scale <= 24) scale -= 7;
                        else scale = baseScale;
                    }
                }
            }
            break;
        case "boldA11y":
            {
                let baseScale = $f8fd43f1ee3f8cd8$var$getAdjustedBaseScale(scale, color, isMidnight);
                let contrast = $f8fd43f1ee3f8cd8$var$getContrast(color, scale, baseScale);
                if (!(contrast >= surfaceConrast)) while(contrast < surfaceConrast){
                    if (isForward && baseScale === 25 || !isForward && baseScale === 1) break;
                    baseScale += isForward ? 1 : -1;
                    contrast = $f8fd43f1ee3f8cd8$var$getContrast(color, scale, baseScale);
                }
                scale = baseScale;
            }
            break;
        case "heavy":
            {
                const newScale = isForward ? 18 : 6;
                const contrast = $f8fd43f1ee3f8cd8$var$getContrast(color, scale, newScale);
                if (contrast >= surfaceConrast) scale = newScale;
                else scale = $f8fd43f1ee3f8cd8$var$getAdjustedContrastScale(color, scale, newScale, contrast, surfaceConrast, isForward);
            }
            break;
        case "contrasting":
            scale = isForward ? 25 : 2;
            break;
        case "black":
            scale = 1;
            break;
        case "elevatedHigh":
            {
                const baseScale = $f8fd43f1ee3f8cd8$var$getAdjustedBaseScale(scale, color, isMidnight);
                const contrast = $f8fd43f1ee3f8cd8$var$getContrast(color, scale, baseScale);
                if (contrast >= 45) scale = baseScale;
                else {
                    if (scale >= 3 && scale <= 24) scale += 7;
                    else if (scale >= 11 && scale <= 24) scale -= 7;
                    else if (scale >= 11 && scale <= 24) scale -= 7;
                    else scale = baseScale;
                }
            }
            break;
        case "elevatedMedium":
            if (scale >= 1 && scale <= 12) {
                const newScale = scale + 4;
                scale = newScale > 25 ? scale - 2 : newScale;
            } else if (scale >= 13 && scale <= 24) {
                const newScale = scale + 3;
                scale = newScale > 25 ? scale - 2 : newScale;
            } else {
                const newScale = scale + 1;
                scale = newScale > 25 ? scale - 2 : newScale;
            }
            break;
        case "elevatedLow":
            if (scale >= 1 && scale <= 12) {
                const newScale = scale + 2;
                scale = newScale > 25 ? scale - 2 : newScale;
            } else if (scale >= 13 && scale <= 24) {
                const newScale = scale + 1;
                scale = newScale > 25 ? scale - 2 : newScale;
            } else {
                const newScale = scale + 1;
                scale = newScale > 25 ? scale - 2 : newScale;
            }
            break;
        default:
            scale += 0;
    }
    return $f8fd43f1ee3f8cd8$var$clamp(scale, 1, 25);
}
function $f8fd43f1ee3f8cd8$var$getSurfaceColor(appearance, scale, parentScale = 25, surface = "ghost", mode = "light", state = "idle") {
    if (surface === "ghost") return {
        scales: {
            [scale || 0]: 0
        },
        surfaceType: "surface"
    };
    const stateStep = $f8fd43f1ee3f8cd8$var$config$1.foundation.step.event[state];
    const color = $f8fd43f1ee3f8cd8$var$replaceMidnight(appearance);
    const contrast1 = $f8fd43f1ee3f8cd8$var$getContrast(color, scale, 2);
    const contrast2 = $f8fd43f1ee3f8cd8$var$getContrast(color, scale, 25);
    const isForward = contrast2 > contrast1;
    if (state && state !== "idle" && surface !== "black") {
        const contrast = $f8fd43f1ee3f8cd8$var$getContrast(color, parentScale, scale);
        let ghostStep = 1;
        let boldStep = 1;
        if (contrast < 60) boldStep = 2;
        if (contrast > 60) boldStep = 3;
        ghostStep *= stateStep;
        boldStep *= stateStep;
        switch(surface){
            case "ghost":
            case "minimal":
            case "subtle":
            case "moderate":
                scale = isForward ? scale + ghostStep : scale - ghostStep;
                break;
            case "bold":
            case "boldA11y":
            case "heavy":
            case "contrasting":
                if (Math.abs(scale - boldStep) < 3) scale += boldStep;
                else scale -= boldStep;
                break;
        }
    }
    let newColor = $f8fd43f1ee3f8cd8$var$getColor(color, scale);
    if (surface.includes("elevated")) {
        const surfaceParts = surface.split("elevated");
        newColor = [
            newColor,
            $f8fd43f1ee3f8cd8$var$getElevatedShadow(surfaceParts[1] || "Medium", mode, appearance)
        ].join(";");
    }
    return {
        surfaceType: "surface",
        color: newColor,
        scales: {
            [scale || 0]: 100
        }
    };
}
const $f8fd43f1ee3f8cd8$var$getElevatedShadow = (type, mode, appearance)=>{
    let shadows = [];
    let color = $f8fd43f1ee3f8cd8$var$getColor(appearance, mode === "dark" ? 1 : 2);
    const borderColor = $f8fd43f1ee3f8cd8$var$applyAlpha($f8fd43f1ee3f8cd8$var$getColor(appearance, 25), 10);
    switch(type?.toLowerCase() || ""){
        case "high":
            color = $f8fd43f1ee3f8cd8$var$applyAlpha(color, 16);
            shadows = [
                color ?? "",
                "0",
                "16",
                "32",
                "0",
                "16",
                "48"
            ];
            break;
        case "medium":
            color = $f8fd43f1ee3f8cd8$var$applyAlpha(color, 12);
            shadows = [
                color ?? "",
                "0",
                "12",
                "24",
                "0",
                "16",
                "48"
            ];
            break;
        case "low":
            color = $f8fd43f1ee3f8cd8$var$applyAlpha(color, 8);
            shadows = [
                color ?? "",
                "0",
                "12",
                "24",
                "0",
                "16",
                "48"
            ];
    }
    shadows.push(...[
        borderColor ?? "",
        mode === "dark" ? "1" : "0"
    ]);
    return shadows.join(";");
};
function $f8fd43f1ee3f8cd8$var$getContentColor(type, appearance = "primary", scale = 25, surface, state = "idle", tinted = true) {
    if (surface === "none") return {
        scales: {}
    };
    if (surface === "ghost") return {
        scales: {
            [scale]: 0
        }
    };
    const surfaceContrast = $f8fd43f1ee3f8cd8$var$config$1.foundation.contrast[type]?.[surface];
    const isMidnight = appearance.includes("midnight");
    const color = appearance.replace("_midnight", "");
    let contrast1 = $f8fd43f1ee3f8cd8$var$getContrast(color, scale, 1);
    let contrast2 = $f8fd43f1ee3f8cd8$var$getContrast(color, scale, 25);
    let isForward = contrast2 > contrast1;
    contrast1 = $f8fd43f1ee3f8cd8$var$getContrast(color, scale, 1);
    contrast2 = $f8fd43f1ee3f8cd8$var$getContrast(color, scale, 25);
    isForward = contrast2 > contrast1;
    switch(surface){
        case "contrasting":
            switch(state){
                case "hover":
                    if (tinted) {
                        const idle = $f8fd43f1ee3f8cd8$var$getContentColor(type, appearance, scale, surface, "idle", tinted);
                        const active = $f8fd43f1ee3f8cd8$var$getContentColor(type, appearance, scale, surface, "active", tinted);
                        return {
                            scales: {
                                ...idle.scales,
                                ...active.scales
                            }
                        };
                    }
                    return $f8fd43f1ee3f8cd8$var$getContentColor(type, appearance, scale, "heavy", "idle", tinted);
                case "active":
                    return $f8fd43f1ee3f8cd8$var$getContentColor(type, appearance, scale, "moderate", "idle", tinted);
                default:
                    if (tinted) {
                        const highScale = isForward ? 25 : 2;
                        let mediumScale = scale;
                        const baseScale = $f8fd43f1ee3f8cd8$var$getScale(color, isMidnight);
                        const contrast = $f8fd43f1ee3f8cd8$var$getContrast(color, mediumScale, baseScale);
                        if (contrast >= 60) mediumScale = baseScale;
                        else {
                            const offset = $f8fd43f1ee3f8cd8$var$getAdjustedContrastScale(color, scale, baseScale, $f8fd43f1ee3f8cd8$var$getContrast(color, baseScale, baseScale), 60, isForward);
                            if (isForward && Math.abs(baseScale - offset) > 5) mediumScale = 25;
                            else mediumScale = offset;
                        }
                        scale = $f8fd43f1ee3f8cd8$var$clamp(Math.floor((1 + (highScale + mediumScale)) / 2), 1, 25);
                        return {
                            scales: {
                                [scale]: 100
                            }
                        };
                    }
                    scale = isForward ? 25 : 2;
                    return {
                        scales: {
                            [scale]: 100
                        }
                    };
            }
        case "heavy":
            switch(state){
                case "hover":
                    {
                        const idle = $f8fd43f1ee3f8cd8$var$getContentColor(type, appearance, scale, surface, "idle", tinted);
                        const active = $f8fd43f1ee3f8cd8$var$getContentColor(type, appearance, scale, surface, "active", tinted);
                        return {
                            scales: {
                                ...idle.scales,
                                ...active.scales
                            }
                        };
                    }
                case "active":
                    if (tinted) {
                        const low = $f8fd43f1ee3f8cd8$var$getContentColor(type, appearance, scale, "moderate", "idle", true);
                        const medium = $f8fd43f1ee3f8cd8$var$getContentColor(type, appearance, scale, "heavy", "idle", true);
                        const high = $f8fd43f1ee3f8cd8$var$getContentColor(type, appearance, scale, "contrasting", "idle", true);
                        if (Object.keys(medium.scales)[0] === Object.keys(high.scales)[0]) return low;
                        return high;
                    }
                    return $f8fd43f1ee3f8cd8$var$getContentColor(type, appearance, scale, "moderate", "idle", tinted);
                default:
                    {
                        if (tinted) {
                            const baseScale = $f8fd43f1ee3f8cd8$var$getScale(color, isMidnight);
                            const contrast = $f8fd43f1ee3f8cd8$var$getContrast(color, scale, baseScale);
                            if (contrast >= surfaceContrast) scale = baseScale;
                            else {
                                const offset = $f8fd43f1ee3f8cd8$var$getAdjustedContrastScale(color, scale, baseScale, contrast, surfaceContrast, isForward);
                                if (isForward && Math.abs(baseScale - offset) > 5) scale = 25;
                                else scale = offset;
                            }
                            return {
                                scales: {
                                    [scale]: 100
                                }
                            };
                        }
                        const opacity = $f8fd43f1ee3f8cd8$var$getOpacity(color, scale, isForward ? 24 : 2, surfaceContrast);
                        const newHexColor = isForward ? 24 : 2;
                        const high = isForward ? 24 : 2;
                        const low = $f8fd43f1ee3f8cd8$var$applyAlpha($f8fd43f1ee3f8cd8$var$getColor(color, newHexColor), opacity);
                        return {
                            scales: {},
                            color: $f8fd43f1ee3f8cd8$export$72a85c3a80ccc403($f8fd43f1ee3f8cd8$var$getColor(color, high), low)
                        };
                    }
            }
        case "moderate":
            switch(state){
                case "hover":
                    if (tinted) {
                        const idle = $f8fd43f1ee3f8cd8$var$getContentColor(type, appearance, scale, surface, "idle", tinted);
                        const active = $f8fd43f1ee3f8cd8$var$getContentColor(type, appearance, scale, surface, "active", tinted);
                        return {
                            scales: {
                                ...idle.scales,
                                ...active.scales
                            }
                        };
                    }
                    return $f8fd43f1ee3f8cd8$var$getContentColor(type, appearance, scale, "heavy", "idle", tinted);
                case "active":
                    return $f8fd43f1ee3f8cd8$var$getContentColor(type, appearance, scale, "contrasting", "idle", tinted);
                default:
                    {
                        if (tinted) {
                            const contrast = $f8fd43f1ee3f8cd8$var$getContrast(color, scale, scale);
                            const offset = $f8fd43f1ee3f8cd8$var$getAdjustedContrastScale(color, scale, scale, contrast, surfaceContrast, isForward);
                            scale = offset;
                            return {
                                scales: {
                                    [scale]: 100
                                }
                            };
                        }
                        const newScale = isForward ? 23 : 2;
                        const opacity = $f8fd43f1ee3f8cd8$var$getOpacity(color, scale, newScale, surfaceContrast);
                        scale = newScale;
                        return {
                            scales: {
                                [newScale]: opacity
                            }
                        };
                    }
            }
        default:
            return {
                scales: {
                    [scale]: 100
                }
            };
    }
}
function $f8fd43f1ee3f8cd8$var$getStrokeColor(appearance, scale, surface, mode = "light", state = "idle", tinted = true) {
    if (surface === "ghost") return {
        scales: {
            [scale || 0]: 0
        },
        color: "transparent"
    };
    const surfaceContrast = $f8fd43f1ee3f8cd8$var$config$1.foundation.contrast["stroke"][surface] || 60;
    const isMidnight = appearance.includes("midnight");
    const color = appearance.replace("_midnight", "");
    let contrast1 = $f8fd43f1ee3f8cd8$var$getContrast(color, scale, 1);
    let contrast2 = $f8fd43f1ee3f8cd8$var$getContrast(color, scale, 25);
    let isForward = contrast2 > contrast1;
    contrast1 = $f8fd43f1ee3f8cd8$var$getContrast(color, scale, 1);
    contrast2 = $f8fd43f1ee3f8cd8$var$getContrast(color, scale, 25);
    isForward = contrast2 > contrast1;
    switch(surface){
        case "contrasting":
            switch(state){
                case "hover":
                    return $f8fd43f1ee3f8cd8$var$getStrokeColor(appearance, scale, "heavy", mode, "idle", tinted);
                case "active":
                    return $f8fd43f1ee3f8cd8$var$getStrokeColor(appearance, scale, "bold", mode, "idle", tinted);
                default:
                    scale = isForward ? 25 : 2;
                    return {
                        scales: {
                            [scale]: 100
                        }
                    };
            }
        case "heavy":
            switch(state){
                case "hover":
                    return $f8fd43f1ee3f8cd8$var$getStrokeColor(appearance, scale, "bold", mode, "idle", tinted);
                case "active":
                    return $f8fd43f1ee3f8cd8$var$getStrokeColor(appearance, scale, "moderate", mode, "idle", tinted);
                default:
                    {
                        if (tinted) {
                            const highScale = isForward ? 25 : 2;
                            const baseScale = $f8fd43f1ee3f8cd8$var$getScale(color, isMidnight);
                            scale = Math.ceil((highScale + baseScale) / 2);
                            return {
                                scales: {
                                    [scale]: 100
                                }
                            };
                        }
                        const contrastingColor = isForward ? 25 : 2;
                        const moderateColor = isForward ? 22 : 3;
                        scale = isForward ? 22 : 3;
                        return {
                            scales: {
                                [contrastingColor]: 66,
                                [moderateColor]: 33
                            }
                        };
                    }
            }
        case "bold":
            switch(state){
                case "hover":
                    return $f8fd43f1ee3f8cd8$var$getStrokeColor(appearance, scale, "heavy", mode, "idle", tinted);
                case "active":
                    return $f8fd43f1ee3f8cd8$var$getStrokeColor(appearance, scale, "contrasting", mode, "idle", tinted);
                default:
                    {
                        if (tinted) {
                            const baseScale = $f8fd43f1ee3f8cd8$var$getScale(color, isMidnight);
                            const contrast = $f8fd43f1ee3f8cd8$var$getContrast(color, scale, baseScale);
                            if (contrast >= 60) scale = baseScale;
                            else scale = $f8fd43f1ee3f8cd8$var$getAdjustedContrastScale(color, scale, baseScale, contrast, 60, isForward);
                            return {
                                scales: {
                                    [scale]: 100
                                }
                            };
                        }
                        const contrastingColor = isForward ? 25 : 2;
                        const opacity = $f8fd43f1ee3f8cd8$var$getOpacity(color, scale, isForward ? 22 : 3, 30);
                        const moderateColor = isForward ? 22 : 3;
                        scale = isForward ? 22 : 3;
                        return {
                            scales: {
                                [contrastingColor]: 33,
                                [moderateColor]: opacity
                            }
                        };
                    }
            }
        case "moderate":
            switch(state){
                case "hover":
                    return $f8fd43f1ee3f8cd8$var$getStrokeColor(appearance, scale, "bold", mode, "idle", tinted);
                case "active":
                    return $f8fd43f1ee3f8cd8$var$getStrokeColor(appearance, scale, "heavy", mode, "idle", tinted);
                default:
                    {
                        if (tinted) {
                            let boldScale = $f8fd43f1ee3f8cd8$var$getScale(color, isMidnight);
                            const contrast = $f8fd43f1ee3f8cd8$var$getContrast(color, scale, boldScale);
                            boldScale = $f8fd43f1ee3f8cd8$var$getAdjustedContrastScale(color, scale, boldScale, contrast, 60, isForward);
                            const minimalScale = isForward ? scale + 2 : scale - 2;
                            scale = Math.floor((minimalScale + boldScale) / 2);
                            return {
                                scales: {
                                    [scale]: 100
                                }
                            };
                        }
                        const newScale = isForward ? 22 : 3;
                        const opacity = $f8fd43f1ee3f8cd8$var$getOpacity(color, scale, newScale, surfaceContrast);
                        scale = newScale;
                        return {
                            scales: {
                                [newScale]: opacity
                            }
                        };
                    }
            }
        case "minimal":
            switch(state){
                case "hover":
                    return $f8fd43f1ee3f8cd8$var$getStrokeColor(appearance, scale, "moderate", mode, "idle", tinted);
                case "active":
                    return $f8fd43f1ee3f8cd8$var$getStrokeColor(appearance, scale, "bold", mode, "idle", tinted);
                default:
                    {
                        if (tinted) {
                            scale = isForward ? scale + 2 : scale - 2;
                            return {
                                scales: {
                                    [scale]: 100
                                }
                            };
                        }
                        const newScale = isForward ? 21 : 4;
                        const opacity = $f8fd43f1ee3f8cd8$var$getOpacity(color, scale, newScale, surfaceContrast);
                        return {
                            scales: {
                                [newScale]: opacity
                            }
                        };
                    }
            }
    }
    return {
        scales: {}
    };
}
const $f8fd43f1ee3f8cd8$var$GlassSurfaceConfig = {
    minimal: {
        default: 18,
        hover: 14,
        pressed: 10
    },
    subtle: {
        default: 14,
        hover: 10,
        pressed: 6
    },
    moderate: {
        default: 10,
        hover: 6,
        pressed: 2
    },
    heavy: {
        default: 6,
        hover: 10,
        pressed: 14
    }
};
function $f8fd43f1ee3f8cd8$var$calculatePercentages(scale) {
    const minValue = 1;
    const maxValue = 25;
    const clampedValue = Math.min(Math.max(scale, minValue), maxValue);
    const normalizedValue = (maxValue - clampedValue) / (maxValue - minValue);
    const transparency = normalizedValue;
    const blur = Math.round(normalizedValue * 200);
    const saturation = Math.round(normalizedValue * 100 + 100);
    return {
        transparency: transparency,
        blur: blur,
        saturation: saturation / 100
    };
}
const $f8fd43f1ee3f8cd8$var$getGlassSurface = (surface, state = "default", mode = "light", appearance = "navi")=>{
    let scale = $f8fd43f1ee3f8cd8$var$GlassSurfaceConfig[surface][state];
    const tbs = $f8fd43f1ee3f8cd8$var$calculatePercentages(scale);
    if (mode === "dark") scale = -scale;
    return {
        color: `glass--scale=${scale}-appearance=${appearance}-blur=${tbs.blur}-saturation=${tbs.saturation}-transparency=${tbs.transparency}`
    };
};
function $f8fd43f1ee3f8cd8$var$resolveColorByType(color, tokens = {}) {
    const [_, surfaceType, surfaceFromToken, tinted] = color.split("_");
    let { scale: scale = 25, surface: surface, mode: mode, parentScale: parentScale = 25, strokeSurface: strokeSurface } = tokens;
    const state = tokens.state;
    surface = surfaceFromToken || surface;
    if (surfaceType === "stroke") strokeSurface = surfaceFromToken || strokeSurface;
    switch(surfaceType){
        case "surface":
            return $f8fd43f1ee3f8cd8$var$getSurfaceColor(tokens.appearance, parseInt(scale), parseInt(parentScale), surface, mode, state);
        case "stroke":
            return {
                surfaceType: surfaceType,
                ...$f8fd43f1ee3f8cd8$var$getStrokeColor(tokens.appearance, parseInt(scale), strokeSurface, mode, state, tinted === "tinted") || {}
            };
        case "glass":
            return $f8fd43f1ee3f8cd8$var$getGlassSurface(tokens.surface, tokens.state, tokens.mode, tokens.appearance);
        default:
            return {
                surfaceType: surfaceType,
                ...$f8fd43f1ee3f8cd8$var$getContentColor(surfaceType, tokens.appearance, parseInt(parentScale), surface, state, tinted === "tinted") || ""
            };
    }
}
const $f8fd43f1ee3f8cd8$var$updateAppearanceAccent = (values)=>{
    if (values.accent) {
        if (values.parentAppearance === "neutral" && values.currentAppearance === "auto") return values.accent;
    }
    return values.appearance;
};
const $f8fd43f1ee3f8cd8$var$updateFlatTokens = (tokens)=>{
    tokens.appearance = tokens.appearance || "primary";
    const appearance = $f8fd43f1ee3f8cd8$export$37b637165f0c11db(tokens);
    const parentScale = parseInt(tokens.scale);
    tokens.scale = String($f8fd43f1ee3f8cd8$export$1630fb55fe6ce943(appearance, parentScale, tokens.surface, void 0, tokens.mode));
    tokens.appearance = $f8fd43f1ee3f8cd8$var$updateAppearanceAccent(tokens);
    tokens["brandVersion"] = "jio-v2";
    return tokens;
};
const $f8fd43f1ee3f8cd8$var$contrastDict = $f8fd43f1ee3f8cd8$var$contrast;
const $f8fd43f1ee3f8cd8$var$convertStringOklchToObject = (color)=>{
    if (!color) return;
    const values = color.replace("oklch", "").replace(/^\(|\)$/gm, "");
    const [L, C, H, _, opacity = "1"] = values.split(" ");
    return {
        lightness: parseFloat(L.replace("%", "")),
        chroma: parseFloat(C),
        hue: parseFloat(H),
        alpha: parseFloat(opacity)
    };
};
function $f8fd43f1ee3f8cd8$export$72a85c3a80ccc403(color1Oklch, color2Oklch, amountToMix1 = 50, amountToMix2 = 50) {
    const color1 = $f8fd43f1ee3f8cd8$var$convertStringOklchToObject(color1Oklch);
    const color2 = $f8fd43f1ee3f8cd8$var$convertStringOklchToObject(color2Oklch);
    if (!color1 || !color2) return;
    const weight1 = amountToMix1 / (amountToMix1 + amountToMix2);
    const weight2 = amountToMix2 / (amountToMix1 + amountToMix2);
    const mixedLightness = color1.lightness * weight1 + color2.lightness * weight2;
    const mixedChroma = color1.chroma * weight1 + color2.chroma * weight2;
    const mixedAlpha = color1.alpha * weight1 + color2.alpha * weight2;
    const hueDifference = Math.abs(color1.hue - color2.hue);
    let mixedHue;
    if (hueDifference > Math.PI) {
        const adjustedHue1 = color1.hue > color2.hue ? color1.hue - 2 * Math.PI : color1.hue;
        const adjustedHue2 = color2.hue > color1.hue ? color2.hue - 2 * Math.PI : color2.hue;
        mixedHue = adjustedHue1 * weight1 + adjustedHue2 * weight2;
    } else mixedHue = color1.hue * weight1 + color2.hue * weight2;
    const finalHue = mixedHue >= 0 ? mixedHue : mixedHue + 2 * Math.PI;
    return `oklch(${mixedLightness}% ${mixedChroma} ${finalHue} / ${mixedAlpha})`;
}
function $f8fd43f1ee3f8cd8$var$converOpacityToHex(opacity) {
    return Math.round(opacity / 100 * 255).toString(16).padStart(2, "0");
}
function $f8fd43f1ee3f8cd8$var$applyAlpha(color, opacity) {
    if (!color) {
        console.warn("Color is nil");
        return;
    }
    const opacityValue = Math.max(0, Math.min(100, opacity));
    const alpha = opacityValue / 100;
    if (color.startsWith("#")) return color + $f8fd43f1ee3f8cd8$var$converOpacityToHex(alpha);
    const colorParts = color.replace("oklch", "").replace(/^\(|\)$/gm, "").split(" ");
    if (colorParts.length < 3) return;
    colorParts[2] = colorParts[2] + " / " + alpha;
    return `oklch(${colorParts.slice(0, 3).join(" ")})`;
}
function $f8fd43f1ee3f8cd8$var$getContrast(color, _bgScale, _fgScale) {
    if (!_bgScale || !_fgScale) return 45;
    const _background = [
        color,
        $f8fd43f1ee3f8cd8$var$clamp(_bgScale, 1, 25) * 100
    ].join(".");
    const _foreground = [
        color,
        $f8fd43f1ee3f8cd8$var$clamp(_fgScale, 1, 25) * 100
    ].join(".");
    try {
        return $f8fd43f1ee3f8cd8$var$contrastDict[color][_background][_foreground].contrast;
    } catch (error) {}
    return 45;
}
function $f8fd43f1ee3f8cd8$var$getColor(color, scale) {
    if (typeof scale === "number") scale = scale * 100;
    const oklch = $f8fd43f1ee3f8cd8$var$config$1.colors[`${color}.${scale}`];
    if ([
        "base",
        "midnight",
        "light"
    ].includes(scale)) return oklch;
    if (!oklch) return "";
    return oklch;
}
function $f8fd43f1ee3f8cd8$var$replaceMidnight(color) {
    return color?.replace(/(_|\.)midnight/gm, "");
}
function $f8fd43f1ee3f8cd8$var$getScale(color, midnight) {
    let scale = 0;
    color = $f8fd43f1ee3f8cd8$var$replaceMidnight(color);
    if (midnight) scale = parseInt($f8fd43f1ee3f8cd8$var$getColor(color, "midnight")) / 100 || 12;
    else scale = parseInt($f8fd43f1ee3f8cd8$var$getColor(color, "base")) / 100 || 13;
    return scale;
}
function $f8fd43f1ee3f8cd8$var$getOpacity(color, background, foreground, breakpoint) {
    const config2 = $f8fd43f1ee3f8cd8$var$contrast[color];
    const _background = `${color}.${background * 100}`;
    const _foreground = `${color}.${foreground * 100}`;
    if (!config2 || !_background || !_foreground) return 1;
    try {
        return config2[_background][_foreground]["lc" + breakpoint];
    } catch (error) {
        return 100;
    }
}
function $f8fd43f1ee3f8cd8$export$37b637165f0c11db(tokens = {}) {
    let { appearance: appearance = "primary" } = tokens;
    appearance = $f8fd43f1ee3f8cd8$var$updateAppearanceAccent(tokens);
    return [
        "primary",
        "secondary",
        "sparkle"
    ].includes(appearance) ? tokens[appearance] || tokens["primary"] || "navi" : appearance || tokens?.["appearance"];
}
const $f8fd43f1ee3f8cd8$var$clamp = (value, min, max)=>Math.max(min, Math.min(value, max));
function $f8fd43f1ee3f8cd8$var$getAdjustedBaseScale(scale, color, isMidnight) {
    let baseScale = $f8fd43f1ee3f8cd8$var$getScale(color, isMidnight);
    if (color === "grey") {
        if (scale <= 13) baseScale = 25;
        else baseScale = 2;
    } else if (scale <= 13) {
        if (baseScale >= 1 && baseScale <= 6) baseScale = baseScale + 3;
        else if (baseScale >= 7 && baseScale <= 12) baseScale = baseScale + 2;
        else if (baseScale >= 13 && baseScale <= 18) baseScale = baseScale + 1;
    }
    return baseScale;
}
function $f8fd43f1ee3f8cd8$var$getAdjustedContrastScale(color, scale, newScale, contrast2, surfaceContrast, isForward) {
    while(contrast2 < surfaceContrast){
        if (isForward && newScale === 25 || !isForward && newScale === 1) break;
        newScale += isForward ? 1 : -1;
        contrast2 = $f8fd43f1ee3f8cd8$var$getContrast(color, scale, newScale);
    }
    return newScale;
}
const $f8fd43f1ee3f8cd8$var$convertScalesToVars = ({ scales: scales }, tokens, key, originalAppearance, color, surfaceType, colorAppearance = "navi", forceValue)=>{
    if (surfaceType === "surface") {
        if (Object.keys(scales).find((item)=>scales[parseInt(item)] === 0 || parseInt(item) === 0)) return {
            value: "transparent"
        };
        return {
            key: Object.keys(scales).map((scale)=>[
                    originalAppearance.split("_")[0],
                    parseInt(scale) * 100
                ].join(".")).join("."),
            value: color
        };
    }
    if (!Object.keys(scales).length) return {
        key: key
    };
    if (Object.keys(scales).length === 1) {
        const key2 = Object.keys(scales)[0];
        if (!key2) return {
            value: "transparent"
        };
        const opacity = scales[parseInt(key2)] ?? 100;
        const color2 = $f8fd43f1ee3f8cd8$var$getColor(colorAppearance, parseInt(key2) || 0);
        if (opacity === 0) return {
            value: "transparent"
        };
        if (opacity === 100) return {
            value: color2,
            key: [
                originalAppearance.split("_")[0],
                parseInt(key2) * 100
            ].join(".")
        };
        if (forceValue) {
            const oklch = $f8fd43f1ee3f8cd8$var$getColor(colorAppearance, parseInt(key2) || 25)?.replace(")", `/ ${opacity / 100})`);
            return {
                value: oklch
            };
        }
        return {
            // value: `color-mix(in oklch,${
            //   color ?? 'transparent'
            // } ${opacity}%, transparent ${100 - opacity}%)`,
            value: `oklch(from ${color2} l c h / ${opacity}%)`
        };
    }
    return {
        value: `color-mix(in oklch,${Object.entries(scales).map(([scale, opacity])=>[
                $f8fd43f1ee3f8cd8$var$getColor(tokens["appearance"].split("_")[0], parseInt(scale)),
                opacity + "%"
            ].join(" ")).join(",")})`
    };
};
const $f8fd43f1ee3f8cd8$var$border_none = "0";
const $f8fd43f1ee3f8cd8$var$border_thinner = "0.5";
const $f8fd43f1ee3f8cd8$var$border_thin = "1";
const $f8fd43f1ee3f8cd8$var$border_normal = "2";
const $f8fd43f1ee3f8cd8$var$border_thick = "3";
const $f8fd43f1ee3f8cd8$var$border_focus = "4";
const $f8fd43f1ee3f8cd8$var$borderWidth = {
    border_none: $f8fd43f1ee3f8cd8$var$border_none,
    border_thinner: $f8fd43f1ee3f8cd8$var$border_thinner,
    border_thin: $f8fd43f1ee3f8cd8$var$border_thin,
    border_normal: $f8fd43f1ee3f8cd8$var$border_normal,
    border_thick: $f8fd43f1ee3f8cd8$var$border_thick,
    border_focus: $f8fd43f1ee3f8cd8$var$border_focus
};
const $f8fd43f1ee3f8cd8$var$config = $f8fd43f1ee3f8cd8$var$config$1;
const $f8fd43f1ee3f8cd8$var$densityPointDict = $f8fd43f1ee3f8cd8$var$config.brand.density;
const $f8fd43f1ee3f8cd8$var$scaleFactorJSON = $f8fd43f1ee3f8cd8$var$config$1.foundation.scaleFactor;
class $f8fd43f1ee3f8cd8$export$ce6a82d4287db7b3 {
    static getDimension(value, density = "default", maxWidth = 360, needsValue = false, indexLimit = "12", version = "3.0.5") {
        const [type, family, baseSize, apiSize, mult = "x1"] = value.split("_");
        let index = 0;
        let dimensionScale = false;
        dimensionScale = (type === "spacing" || type === "gap" || value.startsWith("f")) && version.startsWith("3.1.");
        if (value.startsWith("f")) {
            const index2 = parseInt(value.split("f").pop() || "0");
            const apiSize2 = value.split("_")[1];
            const mult2 = value.split("_")[2];
            if (apiSize2) {
                const scaleFactor = parseInt(mult2.slice(1)) || 1;
                const newSize = this.calculateSize(apiSize2, scaleFactor, dimensionScale);
                const newIndex = index2 + newSize;
                if (needsValue || indexLimit && newIndex > parseInt(indexLimit)) return this.getCalculatedValue(density, maxWidth, newIndex);
                return {
                    key: `f${newIndex}`,
                    value: 0
                };
            }
            if (needsValue || indexLimit && index2 > parseInt(indexLimit)) return this.getCalculatedValue(density, maxWidth, index2);
            return {
                key: `f${index2}`,
                value: 0
            };
        }
        if (type === "stroke") return $f8fd43f1ee3f8cd8$export$ce6a82d4287db7b3.getStroke(family, dimensionScale);
        const base = $f8fd43f1ee3f8cd8$var$config.brand?.[type]?.[family]?.["m"];
        const baseScaleFactor = this.getScaleFactor(type, family);
        const sizeMaping = this.calculateSize(baseSize, baseScaleFactor, dimensionScale) || 0;
        const sizeOffset = typeof base === "string" ? parseInt(base) : base;
        if (!apiSize) {
            index = dimensionScale ? sizeMaping : sizeMaping + sizeOffset;
            if (needsValue || indexLimit && index > parseInt(indexLimit)) return this.getCalculatedValue(density, maxWidth, index);
            return {
                key: `f${index}`,
                value: 0
            };
        }
        const multiplier = parseInt(mult.slice(1)) || 1;
        const newSizeMaping = this.addSize(baseSize, apiSize, baseScaleFactor, multiplier, dimensionScale);
        index = dimensionScale ? newSizeMaping : newSizeMaping + sizeOffset;
        if (needsValue || indexLimit && index > parseInt(indexLimit)) return this.getCalculatedValue(density, maxWidth, index);
        return {
            key: `f${index}`,
            value: 0
        };
    }
    static getScaleFactor(type = "spacing", family = "component") {
        return $f8fd43f1ee3f8cd8$var$scaleFactorJSON[type]?.[family] ?? 1;
    }
    static getFraction(index) {
        const newIndex = Math.abs(index);
        const clamped = Math.min(7, Math.max(0, newIndex));
        const fractionConstant = 1 / 7;
        return clamped * fractionConstant;
    }
    static getLerp(a, b, t) {
        return a + t * (b - a);
    }
    static getCalculatedValue(density = "default", maxWidth = 360, index) {
        const x = maxWidth || 360;
        const min = $f8fd43f1ee3f8cd8$var$densityPointDict[density]?.["min"];
        const max = $f8fd43f1ee3f8cd8$var$densityPointDict[density]?.["max"];
        const breakPointMin = 360;
        const breakPointMax = 1920;
        if (!min || !max) return {
            value: 0
        };
        const fluid = this.getFluid(min, max, breakPointMin, breakPointMax, x);
        if (index >= 0) {
            const min2 = $f8fd43f1ee3f8cd8$var$densityPointDict[density]?.advanced?.["c2"] ?? 0;
            const max2 = $f8fd43f1ee3f8cd8$var$densityPointDict[density]?.advanced?.["c3"] ?? 0;
            const base = this.getFluid(min2, max2, breakPointMin, breakPointMax, x);
            const power = Math.pow(base, index);
            return {
                value: Math.round(fluid * power)
            };
        }
        const b = $f8fd43f1ee3f8cd8$var$densityPointDict[density]?.advanced?.["c1"] ?? 0;
        const t = this.getFraction(index);
        const lerp = this.getLerp(fluid, b, t);
        return {
            value: Math.round(lerp)
        };
    }
    static getFluid(minSize, maxSize, minViewport, maxViewport, viewport) {
        const fontV = 100 * (maxSize - minSize) / (maxViewport - minViewport);
        const fontR = (minViewport * maxSize - maxViewport * minSize) / (minViewport - maxViewport);
        const fluid = viewport / 100 * fontV + fontR;
        const clamped = Math.min(maxSize, Math.max(minSize, fluid));
        return clamped;
    }
    static calculateSize(size, scaleFactor = 1, dimensionScale) {
        if (!size) return 0;
        const sizeRegex = /\d*(xs|s|m|l|xl)/;
        const nsString = size.toLowerCase();
        const results = nsString.match(sizeRegex);
        if (!results) return 0;
        const multiplierString = nsString.replace(results[1], "") || "1";
        const baseSizeString = results[1];
        const multiplier = parseFloat(multiplierString) ?? 1;
        const baseSize = baseSizeString || "m";
        const dynamicSize = dimensionScale ? this.getDynamicSize2(baseSize, multiplier, scaleFactor) : this.getDynamicSize(baseSize, multiplier, scaleFactor);
        return dynamicSize;
    }
    static addSize(baseSize, apiSize, baseFactor, scaleFactor, dimensionScale) {
        const newBaseSize = this.calculateSize(baseSize, baseFactor, dimensionScale);
        const newSize = this.calculateSize(apiSize, scaleFactor, dimensionScale);
        return newBaseSize + newSize;
    }
    static getDynamicSize2(baseSize, multiplier, scaleFactor) {
        switch(baseSize){
            case "m":
                return 0;
            case "s":
                return -1 * (scaleFactor + 1);
            case "xs":
                return -((1 + multiplier) * scaleFactor) - 2;
            case "l":
                return 1 * (scaleFactor + 1);
            case "xl":
                return (1 + multiplier) * (scaleFactor + 1);
        }
    }
    static getDynamicSize(baseSize, multiplier, scaleFactor) {
        switch(baseSize){
            case "m":
                return 0;
            case "s":
                return -1 * scaleFactor;
            case "xs":
                return -(1 + multiplier) * scaleFactor;
            case "l":
                return 1 * scaleFactor;
            case "xl":
                return (1 + multiplier) * scaleFactor;
        }
    }
    static getStroke(size, dimensionScale) {
        const calculatedSize = this.calculateSize(size, 1, dimensionScale);
        return {
            value: this.getStrokeValue(calculatedSize)
        };
    }
    static getStrokeValue(index) {
        const base = $f8fd43f1ee3f8cd8$var$config$1.foundation.baseValue.dimension.stroke;
        return $f8fd43f1ee3f8cd8$var$getGPseriesValue(base, 1.5, index);
    }
}
function $f8fd43f1ee3f8cd8$var$getGPseriesValue(base, ratio, index) {
    const offset = Math.pow(ratio, index);
    return base * offset;
}
const $f8fd43f1ee3f8cd8$var$fValueMap = {
    "--fluid-b": "calc(var(--dp-c1) * 1px)",
    // unit
    "--fontV-a": "calc(100 * ((var(--dp-max) - var(--dp-min)) / (1920 - 360)))",
    // unitless
    "--fontR-a": "calc(((360 * var(--dp-max)) - (1920 * var(--dp-min))) / (360 - 1920))",
    // unitless
    "--pre-fluid-a": "calc(var(--fontV-a) * 1vw + var(--fontR-a) * 1px)",
    // unit
    "--fluid-a": "min(max(calc(var(--dp-min) * 1px), var(--pre-fluid-a)), calc(var(--dp-max) * 1px))",
    // unit
    "--fontV-base": "calc(100 * ((var(--dp-c3) - var(--dp-c2)) / (1920 - 360)))",
    // unitless
    "--fontR-base": "calc(((360 * var(--dp-c3)) - (1920 * var(--dp-c2))) / (360 - 1920))",
    // unitless
    "--pre-fluid-base": "calc(var(--fontV-base) * 1vw + var(--fontR-base) * 1px)",
    // unit
    "--pre-base": "min(max(calc(var(--dp-c2) * 1px), var(--pre-fluid-base)), calc(var(--dp-c3) * 1px))",
    // unit
    "--base": "var(--dp-c2)",
    // unitless ; default value
    "--f-0": "var(--fluid-a)",
    // unit
    "--f-1": "calc(var(--f-0) * var(--base))",
    // unit
    "--f-2": "calc(var(--f-1) * var(--base))",
    // unit
    "--f-3": "calc(var(--f-2) * var(--base))",
    // unit
    "--f-4": "calc(var(--f-3) * var(--base))",
    // unit
    "--f-5": "calc(var(--f-4) * var(--base))",
    // unit
    "--f-6": "calc(var(--f-5) * var(--base))",
    // unit
    "--f-7": "calc(var(--f-6) * var(--base))",
    // unit
    "--f-8": "calc(var(--f-7) * var(--base))",
    // unit
    "--f-9": "calc(var(--f-8) * var(--base))",
    // unit
    "--f-10": "calc(var(--f-9) * var(--base))",
    // unit
    "--f-11": "calc(var(--f-10) * var(--base))",
    // unit
    "--f-12": "calc(var(--f-11) * var(--base))",
    // unit
    "--f-m-0": "var(--fluid-a)",
    // unit
    "--f-m-1": "calc((var(--fluid-a) + (1 * (var(--fluid-b) - var(--fluid-a)) / 7)))",
    // unit
    "--f-m-2": "calc((var(--fluid-a) + (2 * (var(--fluid-b) - var(--fluid-a)) / 7)))",
    // unit
    "--f-m-3": "calc((var(--fluid-a) + (3 * (var(--fluid-b) - var(--fluid-a)) / 7)))",
    // unit
    "--f-m-4": "calc((var(--fluid-a) + (4 * (var(--fluid-b) - var(--fluid-a)) / 7)))",
    // unit
    "--f-m-5": "calc((var(--fluid-a) + (5 * (var(--fluid-b) - var(--fluid-a)) / 7)))",
    // unit
    "--f-m-6": "calc((var(--fluid-a) + (6 * (var(--fluid-b) - var(--fluid-a)) / 7)))",
    // unit
    "--f-m-7": "var(--fluid-b)",
    // unit
    "--f-m-8": "0"
};
function $f8fd43f1ee3f8cd8$var$getDensityMap(density) {
    const densityData = $f8fd43f1ee3f8cd8$var$densityPointDict[density];
    const c1 = densityData.advanced?.c1 ?? 0;
    const c2 = densityData.advanced?.c2 ?? 0;
    const c3 = densityData.advanced?.c3 ?? 0;
    const min = densityData.min;
    const max = densityData.max;
    return {
        "--dp-c1": String(c1),
        "--dp-c2": String(c2),
        "--dp-c3": String(c3),
        "--dp-min": String(min),
        "--dp-max": String(max),
        ...$f8fd43f1ee3f8cd8$var$fValueMap
    };
}
function $f8fd43f1ee3f8cd8$var$getColorToken(token) {
    return $f8fd43f1ee3f8cd8$var$config$1.colors[token];
}
const $f8fd43f1ee3f8cd8$var$feedbackColors = [
    "positive",
    "negative",
    "warning",
    "informative"
];
const $f8fd43f1ee3f8cd8$var$scales = [
    "100",
    "200",
    "300",
    "400",
    "500",
    "600",
    "700",
    "800",
    "900",
    "1000",
    "1100",
    "1200",
    "1300",
    "1400",
    "1500",
    "1600",
    "1700",
    "1800",
    "1900",
    "2000",
    "2100",
    "2200",
    "2300",
    "2400",
    "2500"
];
function $f8fd43f1ee3f8cd8$var$getColorsMap(tokens, addFeedbackColors = false) {
    const result = {};
    const { primary: primary, secondary: secondary, sparkle: sparkle } = tokens;
    let themeColors = {
        primary: primary,
        secondary: secondary,
        sparkle: sparkle
    };
    if (addFeedbackColors) themeColors = {
        ...themeColors,
        neutral: "neutral",
        ...Object.fromEntries($f8fd43f1ee3f8cd8$var$feedbackColors.map((f)=>[
                f,
                f
            ]))
    };
    const colors = Object.keys(themeColors);
    for (const color of colors)for (const scale of $f8fd43f1ee3f8cd8$var$scales){
        const colorToken = `${themeColors[color].split("_")[0]}.${scale}`;
        const colorVar = `--${color}-${scale}`;
        if (scale === "100") {
            if (addFeedbackColors) result[colorVar] = "var(--black)";
            continue;
        } else if (scale === "2500") {
            if (addFeedbackColors) result[colorVar] = "var(--white)";
            continue;
        }
        result[colorVar] = $f8fd43f1ee3f8cd8$var$getColorToken?.(colorToken) || "transparent";
    }
    if (addFeedbackColors) result["--transparent"] = "transparent";
    return result;
}
function $f8fd43f1ee3f8cd8$var$brandResolverFn(type, key, tokens, forceValue = false) {
    key = (0, $bff35c0dd9851fab$export$5fe300a9008e2bfc)(key).replace("&", "");
    switch(type){
        case "fill":
        case "color":
        case "background-color":
        case "border-color":
            {
                const appearance = $f8fd43f1ee3f8cd8$export$37b637165f0c11db(tokens);
                const newTokens = {
                    ...tokens,
                    appearance: appearance
                };
                const { scales: scales2 = {}, surfaceType: surfaceType, color: color } = $f8fd43f1ee3f8cd8$var$resolveColorByType(key, newTokens);
                if (key.includes("elevated")) return {
                    value: color
                };
                if (!Object.keys(scales2).length) return {
                    value: color
                };
                if (color?.startsWith("glass")) return {
                    value: color
                };
                const resolvedScales = $f8fd43f1ee3f8cd8$var$convertScalesToVars({
                    scales: scales2
                }, newTokens, key, tokens?.["appearance"] ?? "primary", color, surfaceType, appearance, forceValue);
                if (forceValue) {
                    if (resolvedScales.key) {
                        const [_, scale] = resolvedScales.key.split(".");
                        const key2 = `${$f8fd43f1ee3f8cd8$var$replaceMidnight(appearance)}.${scale}`;
                        return {
                            value: $f8fd43f1ee3f8cd8$var$getColorToken(key2)
                        };
                    }
                }
                return resolvedScales;
            }
        case "transition-duration":
            return {
                value: "var(--transitions-duration-medium)"
            };
        case "transition-timing-function":
            return {
                value: "var(--transitions-ease-joyful)"
            };
        case "transition-delay":
            return {
                value: "0"
            };
        default:
            {
                const resolved = $f8fd43f1ee3f8cd8$export$ce6a82d4287db7b3.getDimension(key, tokens["density"], parseInt(tokens["maxWidth"]), forceValue, tokens.indexLimit, tokens.version);
                if (!resolved) return void 0;
                return {
                    key: forceValue ? void 0 : resolved.key,
                    value: resolved ? `${resolved.value}px` : key
                };
            }
    }
}
const $f8fd43f1ee3f8cd8$var$surface = "{&color_surface}";
const $f8fd43f1ee3f8cd8$var$content = "{&color_content}";
const $f8fd43f1ee3f8cd8$var$stroke = "{&color_stroke}";
const $f8fd43f1ee3f8cd8$var$color = {
    surface: $f8fd43f1ee3f8cd8$var$surface,
    content: $f8fd43f1ee3f8cd8$var$content,
    stroke: $f8fd43f1ee3f8cd8$var$stroke
};
function $f8fd43f1ee3f8cd8$var$getComponentTokens(componentName) {
    const GENERATED_JSON_MAP = {};
    return GENERATED_JSON_MAP[componentName];
}
const $f8fd43f1ee3f8cd8$var$layout = {
    "flexDirection.row": "row",
    "flexDirection.column": "column",
    "flexDirection.stack": "stack",
    "alignItems.start": "flex-start",
    "alignItems.center": "center",
    "alignItems.end": "flex-end",
    "alignItems.spaceBetween": "space-between",
    "alignItems.spaceAround": "space-around",
    "alignItems.spaceEvenly": "space-evenly",
    "alignItems.stretch": "stretch",
    "justifyContent.start": "flex-start",
    "justifyContent.center": "center",
    "justifyContent.end": "flex-end",
    "justifyContent.spaceBetween": "space-between",
    "justifyContent.spaceAround": "space-around",
    "justifyContent.spaceEvenly": "space-evenly",
    "textAlign.start": "start",
    "textAlign.center": "center",
    "textAlign.end": "end",
    "textAlign.justify": "justify",
    "aspect_ratio.1.1": "1",
    "aspect_ratio.3.4": "0.75",
    "aspect_ratio.4.3": "1.33",
    "aspect_ratio.4.5": "0.8",
    "aspect_ratio.5.4": "1.25",
    "aspect_ratio.9.16": "0.56",
    "aspect_ratio.16.9": "1.77",
    "aspect_ratio.2_75.1": "2.75",
    "size.max": "max",
    "size.min": "min",
    "size.negativeMax": "negativeMax",
    "intrinsicSize.min": "intrinsicSize.min",
    "intrinsicSize.max": "intrinsicSize.max",
    "zIndex-1": 1,
    "size.fit": "fit-content"
};
const $f8fd43f1ee3f8cd8$var$opacity = {
    "opacity.invisible": "0%",
    "opacity.disabled": "30%",
    "opacity.half": "50%",
    "opacity.enabled": "100%"
};
const $f8fd43f1ee3f8cd8$var$spacing = {
    "grid.margin": "{grid.margin.$platform}",
    "grid.gutter": "{grid.gutter.$platform}",
    "grid.margin.mobile": "{grid.margin.mobile.$density}",
    "grid.margin.tablet": "{grid.margin.tablet.$density}",
    "grid.gutter.mobile": "{grid.gutter.mobile.$density}",
    "grid.gutter.tablet": "{grid.gutter.tablet.$density}",
    "grid.columns.mobile": 4,
    "grid.columns.tablet": 8,
    "screensize.desktop": 1440,
    "grid.margin.desktop": "{grid.margin.desktop.$density}",
    "grid.gutter.desktop": "{grid.gutter.desktop.$density}",
    "grid.columns.desktop": 12,
    "grid.columns": "{grid.columns.$platform}",
    "grid.margin.mobile.open": "{&f2}",
    "grid.margin.mobile.default": "{&f0}",
    "grid.margin.mobile.compact": "{&f0}",
    "grid.gutter.mobile.open": "{&f-2}",
    "grid.gutter.mobile.default": "{&f-4}",
    "grid.gutter.mobile.compact": "{&f-5}",
    "grid.margin.desktop.open": "{&f7}",
    "grid.margin.desktop.default": "{&f6}",
    "grid.margin.desktop.compact": "{&f5}",
    "grid.gutter.desktop.open": "{&f1}",
    "grid.gutter.desktop.default": "{&f0}",
    "grid.gutter.desktop.compact": "{&f-1}",
    "grid.margin.tablet.open": "{&f7}",
    "grid.margin.tablet.default": "{&f6}",
    "grid.margin.tablet.compact": "{&f5}",
    "grid.gutter.tablet.open": "{&f1}",
    "grid.gutter.tablet.default": "{&f0}",
    "grid.gutter.tablet.compact": "{&f-1}"
};
const $f8fd43f1ee3f8cd8$var$easeRapid = "0.35, 0, 0.5, 1";
const $f8fd43f1ee3f8cd8$var$easeQuick = "0.35, 0, 0.25, 1";
const $f8fd43f1ee3f8cd8$var$easeJoyful = "0.35, 1.3, 0.3, 1";
const $f8fd43f1ee3f8cd8$var$easeEntrance = "0, 0, 0.1, 1";
const $f8fd43f1ee3f8cd8$var$easeExit = "0.35, 0, 0.8, 1";
const $f8fd43f1ee3f8cd8$var$easeJoyfulEntrance = "0.15, 1.3, 0.3, 1";
const $f8fd43f1ee3f8cd8$var$easeJoyfulExit = "0.7, -0.1, 0.6, 0.1";
const $f8fd43f1ee3f8cd8$var$transitions = {
    easeRapid: $f8fd43f1ee3f8cd8$var$easeRapid,
    easeQuick: $f8fd43f1ee3f8cd8$var$easeQuick,
    easeJoyful: $f8fd43f1ee3f8cd8$var$easeJoyful,
    easeEntrance: $f8fd43f1ee3f8cd8$var$easeEntrance,
    easeExit: $f8fd43f1ee3f8cd8$var$easeExit,
    easeJoyfulEntrance: $f8fd43f1ee3f8cd8$var$easeJoyfulEntrance,
    easeJoyfulExit: $f8fd43f1ee3f8cd8$var$easeJoyfulExit
};
const $f8fd43f1ee3f8cd8$var$rapid = "300";
const $f8fd43f1ee3f8cd8$var$medium = "500";
const $f8fd43f1ee3f8cd8$var$slow = "1000";
const $f8fd43f1ee3f8cd8$var$transitionsDuration = {
    rapid: $f8fd43f1ee3f8cd8$var$rapid,
    medium: $f8fd43f1ee3f8cd8$var$medium,
    slow: $f8fd43f1ee3f8cd8$var$slow
};
const $f8fd43f1ee3f8cd8$var$fontFamilies = {
    "typography.fontfamily": "JioType Var"
};
const $f8fd43f1ee3f8cd8$var$lineHeights = {
    "display.l.lineheight": 100,
    "display.m.lineheight": 100,
    "display.s.lineheight": 100,
    "display.xs.lineheight": 100,
    "display.2xs.lineheight": 100,
    "headline.l.lineheight": 100,
    "headline.m.lineheight": 100,
    "headline.s.lineheight": 100,
    "headline.xs.lineheight": 100,
    "headline.2xs.lineheight": 100,
    "headline.3xs.lineheight": 100,
    "title.l.lineheight": 110.00000238418579,
    "title.m.lineheight": 110.00000238418579,
    "title.s.lineheight": 110.00000238418579,
    "title.xs.lineheight": 110.00000238418579,
    "title.2xs.lineheight": 110.00000238418579,
    "title.3xs.lineheight": 110.00000238418579,
    "body.l.lineheight": 120,
    "body.m.lineheight": 120,
    "body.s.lineheight": 120,
    "body.xs.lineheight": 120,
    "body.2xs.lineheight": 120,
    "body.3xs.lineheight": 120,
    "label.l.lineheight": 100,
    "label.m.lineheight": 100,
    "label.s.lineheight": 100,
    "label.xs.lineheight": 100,
    "label.2xs.lineheight": 100,
    "label.3xs.lineheight": 100
};
const $f8fd43f1ee3f8cd8$var$fontWeights = {
    "typography.fontweight.display": 900,
    "typography.fontweight.headline": 900,
    "typography.fontweight.titlemediumsmall": 750,
    "typography.fontweight.headlinemediumsmall": 850,
    "typography.fontweight.title": 800,
    "typography.fontweight.bodylow": 400,
    "typography.fontweight.bodymedium": 500,
    "typography.fontweight.bodyhigh": 700,
    "typography.fontweight.labelhigh": 700,
    "typography.fontweight.labelmedium": 500
};
const $f8fd43f1ee3f8cd8$var$letterSpacing = {
    "display.l.letterspacing": 0,
    "display.m.letterspacing": 0,
    "display.s.letterspacing": 0,
    "display.xs.letterspacing": 0,
    "display.2xs.letterspacing": 0,
    "headline.l.letterspacing": 0,
    "headline.m.letterspacing": 0,
    "headline.s.letterspacing": 0,
    "headline.xs.letterspacing": 0,
    "headline.2xs.letterspacing": 0,
    "headline.3xs.letterspacing": 0,
    "title.m.letterspacing": 0,
    "title.l.letterspacing": 0,
    "title.s.letterspacing": 0,
    "title.xs.letterspacing": 0,
    "title.2xs.letterspacing": 0,
    "title.3xs.letterspacing": 0,
    "body.l.letterspacing": 0,
    "body.m.letterspacing": 0,
    "body.s.letterspacing": 0,
    "body.xs.letterspacing": 0,
    "body.2xs.letterspacing": 0,
    "body.3xs.letterspacing": 0,
    "label.l.letterspacing": 0,
    "label.m.letterspacing": 0,
    "label.s.letterspacing": 0,
    "label.xs.letterspacing": 0,
    "label.2xs.letterspacing": 0,
    "label.3xs.letterspacing": 0
};
const $f8fd43f1ee3f8cd8$var$defaults = {
    image: {
        width: "fit-content"
    }
};
const $f8fd43f1ee3f8cd8$export$6ad93df59e712c43 = {
    tokens: {
        color: {
            ...$f8fd43f1ee3f8cd8$var$color,
            ...$f8fd43f1ee3f8cd8$var$config$1.colors
        },
        spacing: $f8fd43f1ee3f8cd8$var$spacing,
        fontFamilies: $f8fd43f1ee3f8cd8$var$fontFamilies,
        borderWidth: $f8fd43f1ee3f8cd8$var$borderWidth,
        layout: $f8fd43f1ee3f8cd8$var$layout,
        opacity: $f8fd43f1ee3f8cd8$var$opacity,
        lineHeights: $f8fd43f1ee3f8cd8$var$lineHeights,
        transitions: $f8fd43f1ee3f8cd8$var$transitions,
        transitionsDuration: $f8fd43f1ee3f8cd8$var$transitionsDuration,
        fontWeights: $f8fd43f1ee3f8cd8$var$fontWeights,
        letterSpacing: $f8fd43f1ee3f8cd8$var$letterSpacing
    },
    defaults: $f8fd43f1ee3f8cd8$var$defaults,
    getComponentTokens: $f8fd43f1ee3f8cd8$var$getComponentTokens,
    brandResolverFn: $f8fd43f1ee3f8cd8$var$brandResolverFn,
    updateFlatTokens: $f8fd43f1ee3f8cd8$var$updateFlatTokens,
    getDensityMap: $f8fd43f1ee3f8cd8$var$getDensityMap,
    getColorsMap: $f8fd43f1ee3f8cd8$var$getColorsMap
};
const $f8fd43f1ee3f8cd8$export$616d0e83e98f2255 = [
    {
        name: "JioMeet",
        primaryColor: "orange",
        secondaryColor: "purple",
        sparkleColor: "sky"
    },
    {
        name: "JioMart Express",
        primaryColor: "navi_midnight",
        secondaryColor: "red",
        sparkleColor: "pink"
    },
    {
        name: "JioSnap",
        primaryColor: "violet",
        secondaryColor: "orange",
        sparkleColor: "pink"
    },
    {
        name: "JioMart Digital Partner",
        primaryColor: "purple_midnight",
        secondaryColor: "red",
        sparkleColor: "green"
    },
    {
        name: "JioTrue5G",
        primaryColor: "navi_midnight",
        secondaryColor: "orange",
        sparkleColor: "reliance"
    },
    {
        name: "JioNetVelocity",
        primaryColor: "reliance",
        secondaryColor: "marigold",
        sparkleColor: "green"
    },
    {
        name: "JioSociety",
        primaryColor: "violet_midnight",
        secondaryColor: "mint",
        sparkleColor: "orange"
    },
    {
        name: "JioVideoCall",
        primaryColor: "navi",
        secondaryColor: "orange",
        sparkleColor: "marigold"
    },
    {
        name: "JioSwitch",
        primaryColor: "reliance_midnight",
        secondaryColor: "orange",
        sparkleColor: "sky"
    },
    {
        name: "DSP",
        primaryColor: "reliance",
        secondaryColor: "navi",
        sparkleColor: "sky"
    },
    {
        name: "JioPhotos",
        primaryColor: "navi",
        secondaryColor: "red",
        sparkleColor: "green"
    },
    {
        name: "JioPay",
        primaryColor: "reliance",
        secondaryColor: "navi_midnight",
        sparkleColor: "marigold"
    },
    {
        name: "JioTranslate",
        primaryColor: "pink_midnight",
        secondaryColor: "marigold",
        sparkleColor: "purple"
    },
    {
        name: "JioTV",
        primaryColor: "crimson",
        secondaryColor: "red",
        sparkleColor: "sky"
    },
    {
        name: "JioGames",
        primaryColor: "green",
        secondaryColor: "mint_midnight",
        sparkleColor: "marigold"
    },
    {
        name: "JustDial",
        primaryColor: "sky",
        secondaryColor: "orange",
        sparkleColor: "mint"
    },
    {
        name: "JioTVplus",
        primaryColor: "crimson",
        secondaryColor: "marigold",
        sparkleColor: "red"
    },
    {
        name: "JioHealthHub",
        primaryColor: "mint",
        secondaryColor: "sky_midnight",
        sparkleColor: "red"
    },
    {
        name: "JioGlobal",
        primaryColor: "reliance",
        secondaryColor: "navi",
        sparkleColor: "sky"
    },
    {
        name: "JioSaavn",
        primaryColor: "mint",
        secondaryColor: "sky",
        sparkleColor: "navi"
    },
    {
        name: "JioEvents",
        primaryColor: "mint",
        secondaryColor: "purple",
        sparkleColor: "pink"
    },
    {
        name: "JioFit",
        primaryColor: "Orange",
        secondaryColor: "Purple",
        sparkleColor: "Mint"
    },
    {
        name: "JioMarket",
        primaryColor: "purple_midnight",
        secondaryColor: "red",
        sparkleColor: "orange"
    },
    {
        name: "JioAssist",
        primaryColor: "reliance",
        secondaryColor: "navi",
        sparkleColor: "mint"
    },
    {
        name: "JioChannels",
        primaryColor: "navi",
        secondaryColor: "orange",
        sparkleColor: "pink"
    },
    {
        name: "JioBase",
        primaryColor: "navi",
        secondaryColor: "marigold",
        sparkleColor: "mint"
    },
    {
        name: "JioCloud",
        primaryColor: "sky",
        secondaryColor: "mint",
        sparkleColor: "marigold"
    },
    {
        name: "JioAds",
        primaryColor: "navi",
        secondaryColor: "red",
        sparkleColor: "sky"
    },
    {
        name: "JioKrishi",
        primaryColor: "green_midnight",
        secondaryColor: "orange",
        sparkleColor: "marigold"
    },
    {
        name: "JioCinema",
        primaryColor: "pink",
        secondaryColor: "violet_midnight",
        sparkleColor: "marigold"
    },
    {
        name: "JioMart Digital Business",
        primaryColor: "purple_midnight",
        secondaryColor: "red",
        sparkleColor: "green"
    },
    {
        name: "MyJio",
        primaryColor: "reliance",
        secondaryColor: "navi_midnight",
        sparkleColor: "sky"
    },
    {
        name: "JioGlass",
        primaryColor: "crimson",
        secondaryColor: "purple_midnight",
        sparkleColor: "orange"
    },
    {
        name: "JioDive",
        primaryColor: "purple",
        secondaryColor: "mint",
        sparkleColor: "sky"
    },
    {
        name: "JioCall",
        primaryColor: "green",
        secondaryColor: "violet",
        sparkleColor: "navi"
    },
    {
        name: "JioEngage",
        primaryColor: "violet_midnight",
        secondaryColor: "red",
        sparkleColor: "marigold"
    },
    {
        name: "JioCX",
        primaryColor: "purple",
        secondaryColor: "navi_midnight",
        sparkleColor: "orange"
    },
    {
        name: "JioFinance",
        primaryColor: "gold",
        secondaryColor: "orange_midnight",
        sparkleColor: "sky_midnight"
    },
    {
        name: "JioPos",
        primaryColor: "mint",
        secondaryColor: "red_midnight",
        sparkleColor: "orange"
    },
    {
        name: "JioNews",
        primaryColor: "crimson",
        secondaryColor: "orange",
        sparkleColor: "sky"
    },
    {
        name: "JioMart Digital",
        primaryColor: "purple_midnight",
        secondaryColor: "red",
        sparkleColor: "green"
    },
    {
        name: "JioID",
        primaryColor: "reliance",
        secondaryColor: "navi_midnight",
        sparkleColor: "green"
    },
    {
        name: "JioHome",
        primaryColor: "sky",
        secondaryColor: "purple_midnight",
        sparkleColor: "orange"
    },
    {
        name: "JioMart",
        primaryColor: "sky",
        secondaryColor: "red",
        sparkleColor: "green"
    },
    {
        name: "JioMart Partner",
        primaryColor: "sky",
        secondaryColor: "red",
        sparkleColor: "green"
    },
    {
        name: "JioGauSamridhhi",
        primaryColor: "orange",
        secondaryColor: "green_midnight",
        sparkleColor: "pink_midnight"
    },
    {
        name: "JioWallet",
        primaryColor: "reliance",
        secondaryColor: "navi_midnight",
        sparkleColor: "orange"
    },
    {
        name: "JioJoin",
        primaryColor: "green",
        secondaryColor: "purple",
        sparkleColor: "marigold"
    },
    {
        name: "JioSecure",
        primaryColor: "mint",
        secondaryColor: "reliance_midnight",
        sparkleColor: "sky_light"
    },
    {
        name: "JioCare",
        primaryColor: "reliance",
        secondaryColor: "navi",
        sparkleColor: "pink"
    },
    {
        name: "JioSphere",
        primaryColor: "mint",
        secondaryColor: "sky_midnight",
        sparkleColor: "orange"
    },
    {
        name: "JioChat",
        primaryColor: "navi",
        secondaryColor: "orange",
        sparkleColor: "sky"
    },
    {
        name: "JioCloud PC",
        primaryColor: "sky",
        secondaryColor: "marigold",
        sparkleColor: "orange"
    },
    {
        name: "jio com",
        primaryColor: "reliance",
        secondaryColor: "navi_midnight",
        sparkleColor: "sky"
    },
    {
        name: "JioWave",
        primaryColor: "purple",
        secondaryColor: "sky",
        sparkleColor: "mint"
    },
    {
        name: "JioWorkspace",
        primaryColor: "purple",
        secondaryColor: "marigold",
        sparkleColor: "reliance"
    },
    {
        name: "JioFacility",
        primaryColor: "indigo",
        secondaryColor: "marigold",
        sparkleColor: "orange"
    },
    {
        name: "MyJio1",
        primaryColor: "indigo",
        secondaryColor: "saffron",
        sparkleColor: "green"
    },
    {
        name: "JioMessages",
        primaryColor: "purple",
        secondaryColor: "marigold",
        sparkleColor: "green"
    },
    {
        name: "JioBusiness",
        primaryColor: "purple",
        secondaryColor: "reliance",
        sparkleColor: "mint"
    }
];
const $f8fd43f1ee3f8cd8$var$camelCase = (s, separator = "-")=>s.split(separator).map((segment, index)=>index === 0 ? segment : segment.charAt(0).toUpperCase() + segment.slice(1)).join("");
const $f8fd43f1ee3f8cd8$var$clearModeFromColor = (color)=>{
    return color.replace(/_(light|dark|dim)+/i, "");
};
const $f8fd43f1ee3f8cd8$var$transformThemeName = (name)=>name.split("-").map((segment)=>segment.charAt(0).toUpperCase() + segment.slice(1)).join("");
const $f8fd43f1ee3f8cd8$var$normalizedThemeData = $f8fd43f1ee3f8cd8$export$616d0e83e98f2255.map((data)=>({
        ...data,
        name: $f8fd43f1ee3f8cd8$var$transformThemeName(data.name)
    }));
const $f8fd43f1ee3f8cd8$export$e330aa996edc4437 = (theme)=>{
    const normalizedTheme = $f8fd43f1ee3f8cd8$var$transformThemeName(theme);
    const currentTheme = $f8fd43f1ee3f8cd8$var$normalizedThemeData.find((data)=>$f8fd43f1ee3f8cd8$var$camelCase(normalizedTheme) === $f8fd43f1ee3f8cd8$var$camelCase(data.name));
    let colors = {
        primary: $f8fd43f1ee3f8cd8$export$616d0e83e98f2255[0].primaryColor,
        secondary: $f8fd43f1ee3f8cd8$export$616d0e83e98f2255[0].secondaryColor,
        sparkle: $f8fd43f1ee3f8cd8$export$616d0e83e98f2255[0].sparkleColor,
        neutral: "neutral"
    };
    if (currentTheme) {
        const { primaryColor: primaryColor, secondaryColor: secondaryColor, sparkleColor: sparkleColor } = currentTheme;
        colors = {
            primary: primaryColor?.toLowerCase(),
            secondary: secondaryColor?.toLowerCase(),
            sparkle: sparkleColor?.toLowerCase(),
            neutral: "neutral"
        };
    }
    colors.primary = $f8fd43f1ee3f8cd8$var$clearModeFromColor(colors.primary);
    colors.secondary = $f8fd43f1ee3f8cd8$var$clearModeFromColor(colors.secondary);
    colors.sparkle = $f8fd43f1ee3f8cd8$var$clearModeFromColor(colors.sparkle);
    return colors;
};




var $acw62 = parcelRequire("acw62");

const $e3613f6017c674c5$var$xSmall = "2";
const $e3613f6017c674c5$var$small = "4";
const $e3613f6017c674c5$var$medium$1 = "8";
const $e3613f6017c674c5$var$large = "16";
const $e3613f6017c674c5$var$xl$2 = "24";
const $e3613f6017c674c5$var$xxl$2 = "32";
const $e3613f6017c674c5$var$pill = "25000";
const $e3613f6017c674c5$var$none = "0";
const $e3613f6017c674c5$var$custom_1$3 = "12";
const $e3613f6017c674c5$var$custom_2$3 = "48";
const $e3613f6017c674c5$var$custom_3$2 = "250";
const $e3613f6017c674c5$var$borderRadius = {
    xSmall: $e3613f6017c674c5$var$xSmall,
    small: $e3613f6017c674c5$var$small,
    medium: $e3613f6017c674c5$var$medium$1,
    large: $e3613f6017c674c5$var$large,
    xl: $e3613f6017c674c5$var$xl$2,
    xxl: $e3613f6017c674c5$var$xxl$2,
    pill: $e3613f6017c674c5$var$pill,
    none: $e3613f6017c674c5$var$none,
    custom_1: $e3613f6017c674c5$var$custom_1$3,
    custom_2: $e3613f6017c674c5$var$custom_2$3,
    custom_3: $e3613f6017c674c5$var$custom_3$2
};
const $e3613f6017c674c5$var$border_none = "0";
const $e3613f6017c674c5$var$border_thin = "1";
const $e3613f6017c674c5$var$border_normal = "2";
const $e3613f6017c674c5$var$border_thick = "3";
const $e3613f6017c674c5$var$border_focus = "4";
const $e3613f6017c674c5$var$borderWidth = {
    border_none: $e3613f6017c674c5$var$border_none,
    border_thin: $e3613f6017c674c5$var$border_thin,
    border_normal: $e3613f6017c674c5$var$border_normal,
    border_thick: $e3613f6017c674c5$var$border_thick,
    border_focus: $e3613f6017c674c5$var$border_focus
};
const $e3613f6017c674c5$var$primary20 = "{color.$mode.$primary.20}";
const $e3613f6017c674c5$var$primary30 = "{color.$mode.$primary.30}";
const $e3613f6017c674c5$var$primary40 = "{color.$mode.$primary.40}";
const $e3613f6017c674c5$var$primary50 = "{color.$mode.$primary.50}";
const $e3613f6017c674c5$var$primary60 = "{color.$mode.$primary.60}";
const $e3613f6017c674c5$var$primary70 = "{color.$mode.$primary.70}";
const $e3613f6017c674c5$var$primary80 = "{color.$mode.$primary.80}";
const $e3613f6017c674c5$var$primaryInverse = "{color.$mode.$primary.inverse}";
const $e3613f6017c674c5$var$primaryBackground = "{color.$mode.$primary.background}";
const $e3613f6017c674c5$var$primaryGrey100 = "{color.$mode.$primary.grey.100}";
const $e3613f6017c674c5$var$primaryGrey80 = "{color.$mode.$primary.grey.80}";
const $e3613f6017c674c5$var$primaryGrey60 = "{color.$mode.$primary.grey.60}";
const $e3613f6017c674c5$var$primaryGrey40 = "{color.$mode.$primary.grey.40}";
const $e3613f6017c674c5$var$primaryGrey20 = "{color.$mode.$primary.grey.20}";
const $e3613f6017c674c5$var$secondary20 = "{color.$mode.$secondary.20}";
const $e3613f6017c674c5$var$secondary30 = "{color.$mode.$secondary.30}";
const $e3613f6017c674c5$var$secondary40 = "{color.$mode.$secondary.40}";
const $e3613f6017c674c5$var$secondary50 = "{color.$mode.$secondary.50}";
const $e3613f6017c674c5$var$secondary60 = "{color.$mode.$secondary.60}";
const $e3613f6017c674c5$var$secondary70 = "{color.$mode.$secondary.70}";
const $e3613f6017c674c5$var$secondary80 = "{color.$mode.$secondary.80}";
const $e3613f6017c674c5$var$secondaryInverse = "{color.$mode.$secondary.inverse}";
const $e3613f6017c674c5$var$secondaryBackground = "{color.$mode.$secondary.background}";
const $e3613f6017c674c5$var$secondaryGrey100 = "{color.$mode.$secondary.grey.100}";
const $e3613f6017c674c5$var$secondaryGrey80 = "{color.$mode.$secondary.grey.80}";
const $e3613f6017c674c5$var$secondaryGrey60 = "{color.$mode.$secondary.grey.60}";
const $e3613f6017c674c5$var$secondaryGrey40 = "{color.$mode.$secondary.grey.40}";
const $e3613f6017c674c5$var$secondaryGrey20 = "{color.$mode.$secondary.grey.20}";
const $e3613f6017c674c5$var$sparkle20 = "{color.$mode.$sparkle.20}";
const $e3613f6017c674c5$var$sparkle30 = "{color.$mode.$sparkle.30}";
const $e3613f6017c674c5$var$sparkle40 = "{color.$mode.$sparkle.40}";
const $e3613f6017c674c5$var$sparkle50 = "{color.$mode.$sparkle.50}";
const $e3613f6017c674c5$var$sparkle60 = "{color.$mode.$sparkle.60}";
const $e3613f6017c674c5$var$sparkle70 = "{color.$mode.$sparkle.70}";
const $e3613f6017c674c5$var$sparkle80 = "{color.$mode.$sparkle.80}";
const $e3613f6017c674c5$var$sparkleInverse = "{color.$mode.$sparkle.inverse}";
const $e3613f6017c674c5$var$sparkleBackground = "{color.$mode.$sparkle.background}";
const $e3613f6017c674c5$var$sparkleGrey100 = "{color.$mode.$sparkle.grey.100}";
const $e3613f6017c674c5$var$sparkleGrey80 = "{color.$mode.$sparkle.grey.80}";
const $e3613f6017c674c5$var$sparkleGrey60 = "{color.$mode.$sparkle.grey.60}";
const $e3613f6017c674c5$var$sparkleGrey40 = "{color.$mode.$sparkle.grey.40}";
const $e3613f6017c674c5$var$sparkleGrey20 = "{color.$mode.$sparkle.grey.20}";
const $e3613f6017c674c5$var$feedbackError80 = "{color.$mode.feedback.error.80}";
const $e3613f6017c674c5$var$feedbackError70 = "{color.$mode.feedback.error.70}";
const $e3613f6017c674c5$var$feedbackError60 = "{color.$mode.feedback.error.60}";
const $e3613f6017c674c5$var$feedbackError50 = "{color.$mode.feedback.error.50}";
const $e3613f6017c674c5$var$feedbackError40 = "{color.$mode.feedback.error.40}";
const $e3613f6017c674c5$var$feedbackError30 = "{color.$mode.feedback.error.30}";
const $e3613f6017c674c5$var$feedbackError20 = "{color.$mode.feedback.error.20}";
const $e3613f6017c674c5$var$feedbackWarning80 = "{color.$mode.feedback.warning.80}";
const $e3613f6017c674c5$var$feedbackWarning70 = "{color.$mode.feedback.warning.70}";
const $e3613f6017c674c5$var$feedbackWarning60 = "{color.$mode.feedback.warning.60}";
const $e3613f6017c674c5$var$feedbackWarning50 = "{color.$mode.feedback.warning.50}";
const $e3613f6017c674c5$var$feedbackWarning40 = "{color.$mode.feedback.warning.40}";
const $e3613f6017c674c5$var$feedbackWarning30 = "{color.$mode.feedback.warning.30}";
const $e3613f6017c674c5$var$feedbackWarning20 = "{color.$mode.feedback.warning.20}";
const $e3613f6017c674c5$var$feedbackSuccess80 = "{color.$mode.feedback.success.80}";
const $e3613f6017c674c5$var$feedbackSuccess70 = "{color.$mode.feedback.success.70}";
const $e3613f6017c674c5$var$feedbackSuccess60 = "{color.$mode.feedback.success.60}";
const $e3613f6017c674c5$var$feedbackSuccess50 = "{color.$mode.feedback.success.50}";
const $e3613f6017c674c5$var$feedbackSuccess40 = "{color.$mode.feedback.success.40}";
const $e3613f6017c674c5$var$feedbackSuccess30 = "{color.$mode.feedback.success.30}";
const $e3613f6017c674c5$var$feedbackSuccess20 = "{color.$mode.feedback.success.20}";
const $e3613f6017c674c5$var$elevation1 = "{elevation1.$mode}";
const $e3613f6017c674c5$var$custom_color_1 = "";
const $e3613f6017c674c5$var$custom_color_2 = "#75757580";
const $e3613f6017c674c5$var$custom_color_3 = "#000000D9";
const $e3613f6017c674c5$var$custom_color_4 = "#75757580";
const $e3613f6017c674c5$var$custom_color_5 = "#00000029";
const $e3613f6017c674c5$var$custom_color_6 = "#14151775";
const $e3613f6017c674c5$var$custom_dark_primary_40 = "{color.dark.$primary.40}";
const $e3613f6017c674c5$var$custom_dark_primary_60 = "{color.dark.$primary.60}";
const $e3613f6017c674c5$var$custom_dark_primary_grey_80 = "{color.dark.$primary.grey.80}";
const $e3613f6017c674c5$var$custom_dark_primary_grey_100 = "{color.dark.$primary.grey.100}";
const $e3613f6017c674c5$var$color = {
    primary20: $e3613f6017c674c5$var$primary20,
    primary30: $e3613f6017c674c5$var$primary30,
    primary40: $e3613f6017c674c5$var$primary40,
    primary50: $e3613f6017c674c5$var$primary50,
    primary60: $e3613f6017c674c5$var$primary60,
    primary70: $e3613f6017c674c5$var$primary70,
    primary80: $e3613f6017c674c5$var$primary80,
    primaryInverse: $e3613f6017c674c5$var$primaryInverse,
    primaryBackground: $e3613f6017c674c5$var$primaryBackground,
    primaryGrey100: $e3613f6017c674c5$var$primaryGrey100,
    primaryGrey80: $e3613f6017c674c5$var$primaryGrey80,
    primaryGrey60: $e3613f6017c674c5$var$primaryGrey60,
    primaryGrey40: $e3613f6017c674c5$var$primaryGrey40,
    primaryGrey20: $e3613f6017c674c5$var$primaryGrey20,
    secondary20: $e3613f6017c674c5$var$secondary20,
    secondary30: $e3613f6017c674c5$var$secondary30,
    secondary40: $e3613f6017c674c5$var$secondary40,
    secondary50: $e3613f6017c674c5$var$secondary50,
    secondary60: $e3613f6017c674c5$var$secondary60,
    secondary70: $e3613f6017c674c5$var$secondary70,
    secondary80: $e3613f6017c674c5$var$secondary80,
    secondaryInverse: $e3613f6017c674c5$var$secondaryInverse,
    secondaryBackground: $e3613f6017c674c5$var$secondaryBackground,
    secondaryGrey100: $e3613f6017c674c5$var$secondaryGrey100,
    secondaryGrey80: $e3613f6017c674c5$var$secondaryGrey80,
    secondaryGrey60: $e3613f6017c674c5$var$secondaryGrey60,
    secondaryGrey40: $e3613f6017c674c5$var$secondaryGrey40,
    secondaryGrey20: $e3613f6017c674c5$var$secondaryGrey20,
    sparkle20: $e3613f6017c674c5$var$sparkle20,
    sparkle30: $e3613f6017c674c5$var$sparkle30,
    sparkle40: $e3613f6017c674c5$var$sparkle40,
    sparkle50: $e3613f6017c674c5$var$sparkle50,
    sparkle60: $e3613f6017c674c5$var$sparkle60,
    sparkle70: $e3613f6017c674c5$var$sparkle70,
    sparkle80: $e3613f6017c674c5$var$sparkle80,
    sparkleInverse: $e3613f6017c674c5$var$sparkleInverse,
    sparkleBackground: $e3613f6017c674c5$var$sparkleBackground,
    sparkleGrey100: $e3613f6017c674c5$var$sparkleGrey100,
    sparkleGrey80: $e3613f6017c674c5$var$sparkleGrey80,
    sparkleGrey60: $e3613f6017c674c5$var$sparkleGrey60,
    sparkleGrey40: $e3613f6017c674c5$var$sparkleGrey40,
    sparkleGrey20: $e3613f6017c674c5$var$sparkleGrey20,
    "global.white": "{color.$mode.white}",
    "global.black": "{color.$mode.black}",
    "global.transparent": "transparent",
    feedbackError80: $e3613f6017c674c5$var$feedbackError80,
    feedbackError70: $e3613f6017c674c5$var$feedbackError70,
    feedbackError60: $e3613f6017c674c5$var$feedbackError60,
    feedbackError50: $e3613f6017c674c5$var$feedbackError50,
    feedbackError40: $e3613f6017c674c5$var$feedbackError40,
    feedbackError30: $e3613f6017c674c5$var$feedbackError30,
    feedbackError20: $e3613f6017c674c5$var$feedbackError20,
    feedbackWarning80: $e3613f6017c674c5$var$feedbackWarning80,
    feedbackWarning70: $e3613f6017c674c5$var$feedbackWarning70,
    feedbackWarning60: $e3613f6017c674c5$var$feedbackWarning60,
    feedbackWarning50: $e3613f6017c674c5$var$feedbackWarning50,
    feedbackWarning40: $e3613f6017c674c5$var$feedbackWarning40,
    feedbackWarning30: $e3613f6017c674c5$var$feedbackWarning30,
    feedbackWarning20: $e3613f6017c674c5$var$feedbackWarning20,
    feedbackSuccess80: $e3613f6017c674c5$var$feedbackSuccess80,
    feedbackSuccess70: $e3613f6017c674c5$var$feedbackSuccess70,
    feedbackSuccess60: $e3613f6017c674c5$var$feedbackSuccess60,
    feedbackSuccess50: $e3613f6017c674c5$var$feedbackSuccess50,
    feedbackSuccess40: $e3613f6017c674c5$var$feedbackSuccess40,
    feedbackSuccess30: $e3613f6017c674c5$var$feedbackSuccess30,
    feedbackSuccess20: $e3613f6017c674c5$var$feedbackSuccess20,
    "color.bold.crimson_midnight.20": "#f98ba133",
    "color.bold.crimson_midnight.30": "#f98ba166",
    "color.bold.crimson_midnight.40": "#f98ba199",
    "color.bold.crimson_midnight.50": "#f98ba1ff",
    "color.bold.crimson_midnight.60": "#fbb7c0ff",
    "color.bold.crimson_midnight.70": "#fdd2d8ff",
    "color.bold.crimson_midnight.80": "#feecefff",
    "color.bold.crimson_midnight.inverse": "#38000cff",
    "color.bold.crimson_midnight.background": "#700017ff",
    "color.bold.crimson_midnight.grey.100": "#ffffffff",
    "color.bold.crimson_midnight.grey.80": "#ffffffc7",
    "color.bold.crimson_midnight.grey.60": "#ffffff87",
    "color.bold.crimson_midnight.grey.40": "#ffffff4f",
    "color.bold.crimson_midnight.grey.20": "#ffffff1f",
    "color.dark.crimson_midnight.20": "#3a0611ff",
    "color.dark.crimson_midnight.30": "#600a1cff",
    "color.dark.crimson_midnight.40": "#870f28ff",
    "color.dark.crimson_midnight.50": "#c11539ff",
    "color.dark.crimson_midnight.60": "#d45b74ff",
    "color.dark.crimson_midnight.70": "#e396a6ff",
    "color.dark.crimson_midnight.80": "#f3d0d7ff",
    "color.dark.crimson_midnight.inverse": "#ffffffff",
    "color.dark.crimson_midnight.background": "#141414ff",
    "color.dark.crimson_midnight.grey.100": "#ffffffff",
    "color.dark.crimson_midnight.grey.80": "#ffffffc7",
    "color.dark.crimson_midnight.grey.60": "#a1a1a1ff",
    "color.dark.crimson_midnight.grey.40": "#5a5a5aff",
    "color.dark.crimson_midnight.grey.20": "#2b2b2bff",
    "color.light.crimson_midnight.20": "#f7e5e9ff",
    "color.light.crimson_midnight.30": "#f98ba1ff",
    "color.light.crimson_midnight.40": "#aa0023ff",
    "color.light.crimson_midnight.50": "#700017ff",
    "color.light.crimson_midnight.60": "#4e0010ff",
    "color.light.crimson_midnight.70": "#38000cff",
    "color.light.crimson_midnight.80": "#220007ff",
    "color.light.crimson_midnight.inverse": "#ffffffff",
    "color.light.crimson_midnight.background": "#ffffffff",
    "color.light.crimson_midnight.grey.100": "#141414ff",
    "color.light.crimson_midnight.grey.80": "#000000a6",
    "color.light.crimson_midnight.grey.60": "#b5b5b5ff",
    "color.light.crimson_midnight.grey.40": "#e0e0e0ff",
    "color.light.crimson_midnight.grey.20": "#f5f5f5ff",
    "color.bold.crimson.20": "#f98ba133",
    "color.bold.crimson.30": "#f98ba166",
    "color.bold.crimson.40": "#f98ba199",
    "color.bold.crimson.50": "#f98ba1ff",
    "color.bold.crimson.60": "#fbc0cbff",
    "color.bold.crimson.70": "#fddae1ff",
    "color.bold.crimson.80": "#feedf0ff",
    "color.bold.crimson.inverse": "#4d0010ff",
    "color.bold.crimson.background": "#aa0023ff",
    "color.bold.crimson.grey.100": "#ffffffff",
    "color.bold.crimson.grey.80": "#ffffffc7",
    "color.bold.crimson.grey.60": "#ffffff87",
    "color.bold.crimson.grey.40": "#ffffff4f",
    "color.bold.crimson.grey.20": "#ffffff1f",
    "color.dark.crimson.20": "#3a0611ff",
    "color.dark.crimson.30": "#600a1cff",
    "color.dark.crimson.40": "#870f28ff",
    "color.dark.crimson.50": "#c11539ff",
    "color.dark.crimson.60": "#d45b74ff",
    "color.dark.crimson.70": "#e396a6ff",
    "color.dark.crimson.80": "#f3d0d7ff",
    "color.dark.crimson.inverse": "#ffffffff",
    "color.dark.crimson.background": "#141414ff",
    "color.dark.crimson.grey.100": "#ffffffff",
    "color.dark.crimson.grey.80": "#ffffffc7",
    "color.dark.crimson.grey.60": "#a1a1a1ff",
    "color.dark.crimson.grey.40": "#5a5a5aff",
    "color.dark.crimson.grey.20": "#2b2b2bff",
    "color.light.crimson.20": "#f7e5e9ff",
    "color.light.crimson.30": "#f98ba1ff",
    "color.light.crimson.40": "#ed617fff",
    "color.light.crimson.50": "#aa0023ff",
    "color.light.crimson.60": "#700017ff",
    "color.light.crimson.70": "#4d0010ff",
    "color.light.crimson.80": "#2a0009ff",
    "color.light.crimson.inverse": "#ffffffff",
    "color.light.crimson.background": "#ffffffff",
    "color.light.crimson.grey.100": "#141414ff",
    "color.light.crimson.grey.80": "#000000a6",
    "color.light.crimson.grey.60": "#b5b5b5ff",
    "color.light.crimson.grey.40": "#e0e0e0ff",
    "color.light.crimson.grey.20": "#f5f5f5ff",
    "color.bold.green_midnight.20": "#94f6c533",
    "color.bold.green_midnight.30": "#94f6c566",
    "color.bold.green_midnight.40": "#94f6c599",
    "color.bold.green_midnight.50": "#94f6c5ff",
    "color.bold.green_midnight.60": "#c5fadfff",
    "color.bold.green_midnight.70": "#dcfcebff",
    "color.bold.green_midnight.80": "#f3fef8ff",
    "color.bold.green_midnight.inverse": "#013a1eff",
    "color.bold.green_midnight.background": "#03753cff",
    "color.bold.green_midnight.grey.100": "#ffffffff",
    "color.bold.green_midnight.grey.80": "#ffffffd4",
    "color.bold.green_midnight.grey.60": "#ffffff87",
    "color.bold.green_midnight.grey.40": "#ffffff4f",
    "color.bold.green_midnight.grey.20": "#ffffff1f",
    "color.dark.green_midnight.20": "#06371fff",
    "color.dark.green_midnight.30": "#0a5c33ff",
    "color.dark.green_midnight.40": "#0e8147ff",
    "color.dark.green_midnight.50": "#14b866ff",
    "color.dark.green_midnight.60": "#5acd94ff",
    "color.dark.green_midnight.70": "#95dfbaff",
    "color.dark.green_midnight.80": "#d0f1e0ff",
    "color.dark.green_midnight.inverse": "#06371fff",
    "color.dark.green_midnight.background": "#141414ff",
    "color.dark.green_midnight.grey.100": "#ffffffff",
    "color.dark.green_midnight.grey.80": "#ffffffc7",
    "color.dark.green_midnight.grey.60": "#a1a1a1ff",
    "color.dark.green_midnight.grey.40": "#5a5a5aff",
    "color.dark.green_midnight.grey.20": "#2b2b2bff",
    "color.light.green_midnight.20": "#e5f7eeff",
    "color.light.green_midnight.30": "#94f6c5ff",
    "color.light.green_midnight.40": "#00b259ff",
    "color.light.green_midnight.50": "#03753cff",
    "color.light.green_midnight.60": "#02522aff",
    "color.light.green_midnight.70": "#013a1eff",
    "color.light.green_midnight.80": "#012312ff",
    "color.light.green_midnight.inverse": "#ffffffff",
    "color.light.green_midnight.background": "#ffffffff",
    "color.light.green_midnight.grey.100": "#141414ff",
    "color.light.green_midnight.grey.80": "#000000a6",
    "color.light.green_midnight.grey.60": "#b5b5b5ff",
    "color.light.green_midnight.grey.40": "#e0e0e0ff",
    "color.light.green_midnight.grey.20": "#f5f5f5ff",
    "color.bold.green.20": "#00502833",
    "color.bold.green.30": "#00502866",
    "color.bold.green.40": "#00502899",
    "color.bold.green.50": "#005028ff",
    "color.bold.green.60": "#003b1dff",
    "color.bold.green.70": "#002613ff",
    "color.bold.green.80": "#00170cff",
    "color.bold.green.inverse": "#e5f7eeff",
    "color.bold.green.background": "#00b259ff",
    "color.bold.green.grey.100": "#002d16ff",
    "color.bold.green.grey.80": "#002d16e3",
    "color.bold.green.grey.60": "#002d1687",
    "color.bold.green.grey.40": "#002d164d",
    "color.bold.green.grey.20": "#002d161f",
    "color.dark.green.20": "#06371fff",
    "color.dark.green.30": "#0a5c33ff",
    "color.dark.green.40": "#0e8147ff",
    "color.dark.green.50": "#14b866ff",
    "color.dark.green.60": "#5acd94ff",
    "color.dark.green.70": "#95dfbaff",
    "color.dark.green.80": "#d0f1e0ff",
    "color.dark.green.inverse": "#06371fff",
    "color.dark.green.background": "#141414ff",
    "color.dark.green.grey.100": "#ffffffff",
    "color.dark.green.grey.80": "#ffffffc7",
    "color.dark.green.grey.60": "#a1a1a1ff",
    "color.dark.green.grey.40": "#5a5a5aff",
    "color.dark.green.grey.20": "#2b2b2bff",
    "color.light.green.20": "#e5f7eeff",
    "color.light.green.30": "#94f6c5ff",
    "color.light.green.40": "#10d974ff",
    "color.light.green.50": "#00b259ff",
    "color.light.green.60": "#03753cff",
    "color.light.green.70": "#005028ff",
    "color.light.green.80": "#002d16ff",
    "color.light.green.inverse": "#002d16ff",
    "color.light.green.background": "#ffffffff",
    "color.light.green.grey.100": "#141414ff",
    "color.light.green.grey.80": "#000000a6",
    "color.light.green.grey.60": "#b5b5b5ff",
    "color.light.green.grey.40": "#e0e0e0ff",
    "color.light.green.grey.20": "#f5f5f5ff",
    "color.bold.marigold_midnight.20": "#ffe3ae33",
    "color.bold.marigold_midnight.30": "#ffe3ae66",
    "color.bold.marigold_midnight.40": "#ffe3ae99",
    "color.bold.marigold_midnight.50": "#ffe3aeff",
    "color.bold.marigold_midnight.60": "#ffffffff",
    "color.bold.marigold_midnight.70": "#ffffffff",
    "color.bold.marigold_midnight.80": "#ffffffff",
    "color.bold.marigold_midnight.inverse": "#401d0cff",
    "color.bold.marigold_midnight.background": "#ac660cff",
    "color.bold.marigold_midnight.grey.100": "#ffffffff",
    "color.bold.marigold_midnight.grey.80": "#ffffffff",
    "color.bold.marigold_midnight.grey.60": "#ffffff87",
    "color.bold.marigold_midnight.grey.40": "#ffffff4f",
    "color.bold.marigold_midnight.grey.20": "#ffffff1f",
    "color.dark.marigold_midnight.20": "#3c2e16ff",
    "color.dark.marigold_midnight.30": "#675228ff",
    "color.dark.marigold_midnight.40": "#8d713aff",
    "color.dark.marigold_midnight.50": "#f9be53ff",
    "color.dark.marigold_midnight.60": "#fbd187ff",
    "color.dark.marigold_midnight.70": "#fce2b2ff",
    "color.dark.marigold_midnight.80": "#fef2ddff",
    "color.dark.marigold_midnight.inverse": "#3c2e16ff",
    "color.dark.marigold_midnight.background": "#141414ff",
    "color.dark.marigold_midnight.grey.100": "#ffffffff",
    "color.dark.marigold_midnight.grey.80": "#ffffffc7",
    "color.dark.marigold_midnight.grey.60": "#a1a1a1ff",
    "color.dark.marigold_midnight.grey.40": "#5a5a5aff",
    "color.dark.marigold_midnight.grey.20": "#2b2b2bff",
    "color.light.marigold_midnight.20": "#fef7e9ff",
    "color.light.marigold_midnight.30": "#ffe3aeff",
    "color.light.marigold_midnight.40": "#ffd947ff",
    "color.light.marigold_midnight.50": "#ac660cff",
    "color.light.marigold_midnight.60": "#7f4b10ff",
    "color.light.marigold_midnight.70": "#401d0cff",
    "color.light.marigold_midnight.80": "#341709ff",
    "color.light.marigold_midnight.inverse": "#ffffffff",
    "color.light.marigold_midnight.background": "#ffffffff",
    "color.light.marigold_midnight.grey.100": "#141414ff",
    "color.light.marigold_midnight.grey.80": "#000000a6",
    "color.light.marigold_midnight.grey.60": "#b5b5b5ff",
    "color.light.marigold_midnight.grey.40": "#e0e0e0ff",
    "color.light.marigold_midnight.grey.20": "#f5f5f5ff",
    "color.bold.marigold.20": "#92551b33",
    "color.bold.marigold.30": "#92551b66",
    "color.bold.marigold.40": "#92551b99",
    "color.bold.marigold.50": "#8a3200ff",
    "color.bold.marigold.60": "#5e2200ff",
    "color.bold.marigold.70": "#3d1600ff",
    "color.bold.marigold.80": "#2e1100ff",
    "color.bold.marigold.inverse": "#fef7e9ff",
    "color.bold.marigold.background": "#f7ab20ff",
    "color.bold.marigold.grey.100": "#401d0cff",
    "color.bold.marigold.grey.80": "#401d0cc7",
    "color.bold.marigold.grey.60": "#401d0c87",
    "color.bold.marigold.grey.40": "#401d0c4d",
    "color.bold.marigold.grey.20": "#401d0c1f",
    "color.dark.marigold.20": "#3c2e16ff",
    "color.dark.marigold.30": "#675228ff",
    "color.dark.marigold.40": "#8d713aff",
    "color.dark.marigold.50": "#f9be53ff",
    "color.dark.marigold.60": "#fbd187ff",
    "color.dark.marigold.70": "#fce2b2ff",
    "color.dark.marigold.80": "#fef2ddff",
    "color.dark.marigold.inverse": "#3c2e16ff",
    "color.dark.marigold.background": "#141414ff",
    "color.dark.marigold.grey.100": "#ffffffff",
    "color.dark.marigold.grey.80": "#ffffffc7",
    "color.dark.marigold.grey.60": "#a1a1a1ff",
    "color.dark.marigold.grey.40": "#5a5a5aff",
    "color.dark.marigold.grey.20": "#2b2b2bff",
    "color.light.marigold.20": "#fef7e9ff",
    "color.light.marigold.30": "#ffe3aeff",
    "color.light.marigold.40": "#ffd947ff",
    "color.light.marigold.50": "#f7ab20ff",
    "color.light.marigold.60": "#ac660cff",
    "color.light.marigold.70": "#7f4b10ff",
    "color.light.marigold.80": "#401d0cff",
    "color.light.marigold.inverse": "#401d0cff",
    "color.light.marigold.background": "#ffffffff",
    "color.light.marigold.grey.100": "#141414ff",
    "color.light.marigold.grey.80": "#000000a6",
    "color.light.marigold.grey.60": "#b5b5b5ff",
    "color.light.marigold.grey.40": "#e0e0e0ff",
    "color.light.marigold.grey.20": "#f5f5f5ff",
    "color.bold.mint_midnight.20": "#a7f6e933",
    "color.bold.mint_midnight.30": "#a7f6e966",
    "color.bold.mint_midnight.40": "#a7f6e999",
    "color.bold.mint_midnight.50": "#a7f6e9ff",
    "color.bold.mint_midnight.60": "#c9f9f1ff",
    "color.bold.mint_midnight.70": "#e0fcf7ff",
    "color.bold.mint_midnight.80": "#f3fefcff",
    "color.bold.mint_midnight.inverse": "#0f3e3aff",
    "color.bold.mint_midnight.background": "#1e7b74ff",
    "color.bold.mint_midnight.grey.100": "#ffffffff",
    "color.bold.mint_midnight.grey.80": "#ffffffe8",
    "color.bold.mint_midnight.grey.60": "#ffffff87",
    "color.bold.mint_midnight.grey.40": "#ffffff4f",
    "color.bold.mint_midnight.grey.20": "#ffffff1f",
    "color.dark.mint_midnight.20": "#1a413bff",
    "color.dark.mint_midnight.30": "#245a51ff",
    "color.dark.mint_midnight.40": "#348376ff",
    "color.dark.mint_midnight.50": "#58dac5ff",
    "color.dark.mint_midnight.60": "#8ae5d6ff",
    "color.dark.mint_midnight.70": "#b4eee5ff",
    "color.dark.mint_midnight.80": "#def8f3ff",
    "color.dark.mint_midnight.inverse": "#1a413bff",
    "color.dark.mint_midnight.background": "#141414ff",
    "color.dark.mint_midnight.grey.100": "#ffffffff",
    "color.dark.mint_midnight.grey.80": "#ffffffc7",
    "color.dark.mint_midnight.grey.60": "#a1a1a1ff",
    "color.dark.mint_midnight.grey.40": "#5a5a5aff",
    "color.dark.mint_midnight.grey.20": "#2b2b2bff",
    "color.light.mint_midnight.20": "#e8faf7ff",
    "color.light.mint_midnight.30": "#a7f6e9ff",
    "color.light.mint_midnight.40": "#1eccb0ff",
    "color.light.mint_midnight.50": "#1e7b74ff",
    "color.light.mint_midnight.60": "#155651ff",
    "color.light.mint_midnight.70": "#0f3e3aff",
    "color.light.mint_midnight.80": "#092523ff",
    "color.light.mint_midnight.inverse": "#ffffffff",
    "color.light.mint_midnight.background": "#ffffffff",
    "color.light.mint_midnight.grey.100": "#141414ff",
    "color.light.mint_midnight.grey.80": "#000000a6",
    "color.light.mint_midnight.grey.60": "#b5b5b5ff",
    "color.light.mint_midnight.grey.40": "#e0e0e0ff",
    "color.light.mint_midnight.grey.20": "#f5f5f5ff",
    "color.bold.mint.20": "#0e5c4f33",
    "color.bold.mint.30": "#0e5c4f66",
    "color.bold.mint.40": "#0e5c4f99",
    "color.bold.mint.50": "#0e5c4fff",
    "color.bold.mint.60": "#0a493fff",
    "color.bold.mint.70": "#07362eff",
    "color.bold.mint.80": "#052923ff",
    "color.bold.mint.inverse": "#e8faf7ff",
    "color.bold.mint.background": "#1eccb0ff",
    "color.bold.mint.grey.100": "#08332cff",
    "color.bold.mint.grey.80": "#08332ccf",
    "color.bold.mint.grey.60": "#08332c87",
    "color.bold.mint.grey.40": "#08332c4d",
    "color.bold.mint.grey.20": "#08332c1f",
    "color.dark.mint.20": "#1a413bff",
    "color.dark.mint.30": "#245a51ff",
    "color.dark.mint.40": "#348376ff",
    "color.dark.mint.50": "#58dac5ff",
    "color.dark.mint.60": "#8ae5d6ff",
    "color.dark.mint.70": "#b4eee5ff",
    "color.dark.mint.80": "#def8f3ff",
    "color.dark.mint.inverse": "#1a413bff",
    "color.dark.mint.background": "#141414ff",
    "color.dark.mint.grey.100": "#ffffffff",
    "color.dark.mint.grey.80": "#ffffffc7",
    "color.dark.mint.grey.60": "#a1a1a1ff",
    "color.dark.mint.grey.40": "#5a5a5aff",
    "color.dark.mint.grey.20": "#2b2b2bff",
    "color.light.mint.20": "#e8faf7ff",
    "color.light.mint.30": "#a7f6e9ff",
    "color.light.mint.40": "#7aebd9ff",
    "color.light.mint.50": "#1eccb0ff",
    "color.light.mint.60": "#1e7b74ff",
    "color.light.mint.70": "#0e5c4fff",
    "color.light.mint.80": "#08332cff",
    "color.light.mint.inverse": "#08332cff",
    "color.light.mint.background": "#ffffffff",
    "color.light.mint.grey.100": "#141414ff",
    "color.light.mint.grey.80": "#000000a6",
    "color.light.mint.grey.60": "#b5b5b5ff",
    "color.light.mint.grey.40": "#e0e0e0ff",
    "color.light.mint.grey.20": "#f5f5f5ff",
    "color.bold.navi_midnight.20": "#9999ff33",
    "color.bold.navi_midnight.30": "#9999ff66",
    "color.bold.navi_midnight.40": "#9999ff99",
    "color.bold.navi_midnight.50": "#9999ffff",
    "color.bold.navi_midnight.60": "#b9b9ffff",
    "color.bold.navi_midnight.70": "#ddddffff",
    "color.bold.navi_midnight.80": "#ffffffff",
    "color.bold.navi_midnight.inverse": "#00004aff",
    "color.bold.navi_midnight.background": "#000093ff",
    "color.bold.navi_midnight.grey.100": "#ffffffff",
    "color.bold.navi_midnight.grey.80": "#ffffffc7",
    "color.bold.navi_midnight.grey.60": "#ffffff87",
    "color.bold.navi_midnight.grey.40": "#ffffff4f",
    "color.bold.navi_midnight.grey.20": "#ffffff1f",
    "color.dark.navi_midnight.20": "#16164bff",
    "color.dark.navi_midnight.30": "#24247dff",
    "color.dark.navi_midnight.40": "#3232aeff",
    "color.dark.navi_midnight.50": "#4848f9ff",
    "color.dark.navi_midnight.60": "#7f7ffbff",
    "color.dark.navi_midnight.70": "#adadfcff",
    "color.dark.navi_midnight.80": "#dadafeff",
    "color.dark.navi_midnight.inverse": "#ffffffff",
    "color.dark.navi_midnight.background": "#141414ff",
    "color.dark.navi_midnight.grey.100": "#ffffffff",
    "color.dark.navi_midnight.grey.80": "#ffffffc7",
    "color.dark.navi_midnight.grey.60": "#a1a1a1ff",
    "color.dark.navi_midnight.grey.40": "#5a5a5aff",
    "color.dark.navi_midnight.grey.20": "#2b2b2bff",
    "color.light.navi_midnight.20": "#e8e8fcff",
    "color.light.navi_midnight.30": "#9999ffff",
    "color.light.navi_midnight.40": "#3535f3ff",
    "color.light.navi_midnight.50": "#000093ff",
    "color.light.navi_midnight.60": "#000067ff",
    "color.light.navi_midnight.70": "#00004aff",
    "color.light.navi_midnight.80": "#00002cff",
    "color.light.navi_midnight.inverse": "#ffffffff",
    "color.light.navi_midnight.background": "#ffffffff",
    "color.light.navi_midnight.grey.100": "#141414ff",
    "color.light.navi_midnight.grey.80": "#000000a6",
    "color.light.navi_midnight.grey.60": "#b5b5b5ff",
    "color.light.navi_midnight.grey.40": "#e0e0e0ff",
    "color.light.navi_midnight.grey.20": "#f5f5f5ff",
    "color.bold.navi.20": "#9999ff33",
    "color.bold.navi.30": "#9999ff66",
    "color.bold.navi.40": "#9999ff99",
    "color.bold.navi.50": "#9999ffff",
    "color.bold.navi.60": "#ceceffff",
    "color.bold.navi.70": "#ddddffff",
    "color.bold.navi.80": "#fafaffff",
    "color.bold.navi.inverse": "#00004cff",
    "color.bold.navi.background": "#3535f3ff",
    "color.bold.navi.grey.100": "#ffffffff",
    "color.bold.navi.grey.80": "#ffffffc7",
    "color.bold.navi.grey.60": "#ffffff87",
    "color.bold.navi.grey.40": "#ffffff4f",
    "color.bold.navi.grey.20": "#ffffff1f",
    "color.dark.navi.20": "#16164bff",
    "color.dark.navi.30": "#24247dff",
    "color.dark.navi.40": "#3232aeff",
    "color.dark.navi.50": "#4848f9ff",
    "color.dark.navi.60": "#7f7ffbff",
    "color.dark.navi.70": "#adadfcff",
    "color.dark.navi.80": "#dadafeff",
    "color.dark.navi.inverse": "#ffffffff",
    "color.dark.navi.background": "#141414ff",
    "color.dark.navi.grey.100": "#ffffffff",
    "color.dark.navi.grey.80": "#ffffffc7",
    "color.dark.navi.grey.60": "#a1a1a1ff",
    "color.dark.navi.grey.40": "#5a5a5aff",
    "color.dark.navi.grey.20": "#2b2b2bff",
    "color.light.navi.20": "#e8e8fcff",
    "color.light.navi.30": "#9999ffff",
    "color.light.navi.40": "#6464ffff",
    "color.light.navi.50": "#3535f3ff",
    "color.light.navi.60": "#000093ff",
    "color.light.navi.70": "#00004cff",
    "color.light.navi.80": "#010029ff",
    "color.light.navi.inverse": "#ffffffff",
    "color.light.navi.background": "#ffffffff",
    "color.light.navi.grey.100": "#141414ff",
    "color.light.navi.grey.80": "#000000a6",
    "color.light.navi.grey.60": "#b5b5b5ff",
    "color.light.navi.grey.40": "#e0e0e0ff",
    "color.light.navi.grey.20": "#f5f5f5ff",
    "color.bold.orange_midnight.20": "#ffd2ad33",
    "color.bold.orange_midnight.30": "#ffd2ad66",
    "color.bold.orange_midnight.40": "#ffd2ad99",
    "color.bold.orange_midnight.50": "#ffd2adff",
    "color.bold.orange_midnight.60": "#ffead9ff",
    "color.bold.orange_midnight.70": "#fff5eeff",
    "color.bold.orange_midnight.80": "#ffffffff",
    "color.bold.orange_midnight.inverse": "#661f00ff",
    "color.bold.orange_midnight.background": "#cd3d00ff",
    "color.bold.orange_midnight.grey.100": "#ffffffff",
    "color.bold.orange_midnight.grey.80": "#fffffffc",
    "color.bold.orange_midnight.grey.60": "#ffffff87",
    "color.bold.orange_midnight.grey.40": "#ffffff4f",
    "color.bold.orange_midnight.grey.20": "#ffffff1f",
    "color.dark.orange_midnight.20": "#492b13ff",
    "color.dark.orange_midnight.30": "#7a471fff",
    "color.dark.orange_midnight.40": "#ab642bff",
    "color.dark.orange_midnight.50": "#f48f3eff",
    "color.dark.orange_midnight.60": "#f7b178ff",
    "color.dark.orange_midnight.70": "#facda8ff",
    "color.dark.orange_midnight.80": "#fde9d8ff",
    "color.dark.orange_midnight.inverse": "#492b13ff",
    "color.dark.orange_midnight.background": "#141414ff",
    "color.dark.orange_midnight.grey.100": "#ffffffff",
    "color.dark.orange_midnight.grey.80": "#ffffffc7",
    "color.dark.orange_midnight.grey.60": "#a1a1a1ff",
    "color.dark.orange_midnight.grey.40": "#5a5a5aff",
    "color.dark.orange_midnight.grey.20": "#2b2b2bff",
    "color.light.orange_midnight.20": "#fef2e9ff",
    "color.light.orange_midnight.30": "#ffd2adff",
    "color.light.orange_midnight.40": "#fa7d19ff",
    "color.light.orange_midnight.50": "#cd3d00ff",
    "color.light.orange_midnight.60": "#902b00ff",
    "color.light.orange_midnight.70": "#661f00ff",
    "color.light.orange_midnight.80": "#3d1200ff",
    "color.light.orange_midnight.inverse": "#ffffffff",
    "color.light.orange_midnight.background": "#ffffffff",
    "color.light.orange_midnight.grey.100": "#141414ff",
    "color.light.orange_midnight.grey.80": "#000000a6",
    "color.light.orange_midnight.grey.60": "#b5b5b5ff",
    "color.light.orange_midnight.grey.40": "#e0e0e0ff",
    "color.light.orange_midnight.grey.20": "#f5f5f5ff",
    "color.bold.orange.20": "#7b160433",
    "color.bold.orange.30": "#7b160466",
    "color.bold.orange.40": "#7b160499",
    "color.bold.orange.50": "#7b1604ff",
    "color.bold.orange.60": "#5c1700ff",
    "color.bold.orange.70": "#3d0f00ff",
    "color.bold.orange.80": "#2e0b00ff",
    "color.bold.orange.inverse": "#fef2e9ff",
    "color.bold.orange.background": "#fa7d19ff",
    "color.bold.orange.grey.100": "#46070bff",
    "color.bold.orange.grey.80": "#46070bcf",
    "color.bold.orange.grey.60": "#46070b87",
    "color.bold.orange.grey.40": "#46070b4f",
    "color.bold.orange.grey.20": "#46070b33",
    "color.dark.orange.20": "#492b13ff",
    "color.dark.orange.30": "#7a471fff",
    "color.dark.orange.40": "#ab642bff",
    "color.dark.orange.50": "#f48f3eff",
    "color.dark.orange.60": "#f7b178ff",
    "color.dark.orange.70": "#facda8ff",
    "color.dark.orange.80": "#fde9d8ff",
    "color.dark.orange.inverse": "#492b13ff",
    "color.dark.orange.background": "#141414ff",
    "color.dark.orange.grey.100": "#ffffffff",
    "color.dark.orange.grey.80": "#ffffffc7",
    "color.dark.orange.grey.60": "#a1a1a1ff",
    "color.dark.orange.grey.40": "#5a5a5aff",
    "color.dark.orange.grey.20": "#2b2b2bff",
    "color.light.orange.20": "#fef2e9ff",
    "color.light.orange.30": "#ffd2adff",
    "color.light.orange.40": "#ffaa66ff",
    "color.light.orange.50": "#fa7d19ff",
    "color.light.orange.60": "#cd3d00ff",
    "color.light.orange.70": "#7b1604ff",
    "color.light.orange.80": "#46070bff",
    "color.light.orange.inverse": "#46070bff",
    "color.light.orange.background": "#ffffffff",
    "color.light.orange.grey.100": "#141414ff",
    "color.light.orange.grey.80": "#000000a6",
    "color.light.orange.grey.60": "#b5b5b5ff",
    "color.light.orange.grey.40": "#e0e0e0ff",
    "color.light.orange.grey.20": "#f5f5f5ff",
    "color.bold.pink_midnight.20": "#ff99db33",
    "color.bold.pink_midnight.30": "#ff99db66",
    "color.bold.pink_midnight.40": "#ff99db99",
    "color.bold.pink_midnight.50": "#ff99dbff",
    "color.bold.pink_midnight.60": "#ffbfe9ff",
    "color.bold.pink_midnight.70": "#ffeaf8ff",
    "color.bold.pink_midnight.80": "#fff6fcff",
    "color.bold.pink_midnight.inverse": "#47002fff",
    "color.bold.pink_midnight.background": "#8f005dff",
    "color.bold.pink_midnight.grey.100": "#ffffffff",
    "color.bold.pink_midnight.grey.80": "#ffffffc7",
    "color.bold.pink_midnight.grey.60": "#ffffff87",
    "color.bold.pink_midnight.grey.40": "#ffffff4f",
    "color.bold.pink_midnight.grey.20": "#ffffff1f",
    "color.dark.pink_midnight.20": "#360023ff",
    "color.dark.pink_midnight.30": "#62003fff",
    "color.dark.pink_midnight.40": "#8f005dff",
    "color.dark.pink_midnight.50": "#d9008dff",
    "color.dark.pink_midnight.60": "#ff6dccff",
    "color.dark.pink_midnight.70": "#ff99dbff",
    "color.dark.pink_midnight.80": "#fbe5f4ff",
    "color.dark.pink_midnight.inverse": "#ffffffff",
    "color.dark.pink_midnight.background": "#141414ff",
    "color.dark.pink_midnight.grey.100": "#ffffffff",
    "color.dark.pink_midnight.grey.80": "#ffffffc7",
    "color.dark.pink_midnight.grey.60": "#a1a1a1ff",
    "color.dark.pink_midnight.grey.40": "#5a5a5aff",
    "color.dark.pink_midnight.grey.20": "#2b2b2bff",
    "color.light.pink_midnight.20": "#fbe5f4ff",
    "color.light.pink_midnight.30": "#ff99dbff",
    "color.light.pink_midnight.40": "#d9008dff",
    "color.light.pink_midnight.50": "#8f005dff",
    "color.light.pink_midnight.60": "#640041ff",
    "color.light.pink_midnight.70": "#47002fff",
    "color.light.pink_midnight.80": "#2b001cff",
    "color.light.pink_midnight.inverse": "#ffffffff",
    "color.light.pink_midnight.background": "#ffffffff",
    "color.light.pink_midnight.grey.100": "#141414ff",
    "color.light.pink_midnight.grey.80": "#000000a6",
    "color.light.pink_midnight.grey.60": "#b5b5b5ff",
    "color.light.pink_midnight.grey.40": "#e0e0e0ff",
    "color.light.pink_midnight.grey.20": "#f5f5f5ff",
    "color.bold.pink.20": "#ff99db33",
    "color.bold.pink.30": "#ff99db66",
    "color.bold.pink.40": "#ff99db99",
    "color.bold.pink.50": "#ff99dbff",
    "color.bold.pink.60": "#fff7fcff",
    "color.bold.pink.70": "#ffffffff",
    "color.bold.pink.80": "#ffffffff",
    "color.bold.pink.inverse": "#62003fff",
    "color.bold.pink.background": "#d9008dff",
    "color.bold.pink.grey.100": "#ffffffff",
    "color.bold.pink.grey.80": "#fffffff5",
    "color.bold.pink.grey.60": "#ffffff87",
    "color.bold.pink.grey.40": "#ffffff4f",
    "color.bold.pink.grey.20": "#ffffff1f",
    "color.dark.pink.20": "#360023ff",
    "color.dark.pink.30": "#62003fff",
    "color.dark.pink.40": "#8f005dff",
    "color.dark.pink.50": "#d9008dff",
    "color.dark.pink.60": "#ff6dccff",
    "color.dark.pink.70": "#ff99dbff",
    "color.dark.pink.80": "#fbe5f4ff",
    "color.dark.pink.inverse": "#ffffffff",
    "color.dark.pink.background": "#141414ff",
    "color.dark.pink.grey.100": "#ffffffff",
    "color.dark.pink.grey.80": "#ffffffc7",
    "color.dark.pink.grey.60": "#a1a1a1ff",
    "color.dark.pink.grey.40": "#5a5a5aff",
    "color.dark.pink.grey.20": "#2b2b2bff",
    "color.light.pink.20": "#fbe5f4ff",
    "color.light.pink.30": "#ff99dbff",
    "color.light.pink.40": "#ff6dccff",
    "color.light.pink.50": "#d9008dff",
    "color.light.pink.60": "#8f005dff",
    "color.light.pink.70": "#62003fff",
    "color.light.pink.80": "#360023ff",
    "color.light.pink.inverse": "#ffffffff",
    "color.light.pink.background": "#ffffffff",
    "color.light.pink.grey.100": "#141414ff",
    "color.light.pink.grey.80": "#000000a6",
    "color.light.pink.grey.60": "#b5b5b5ff",
    "color.light.pink.grey.40": "#e0e0e0ff",
    "color.light.pink.grey.20": "#f5f5f5ff",
    "color.bold.purple_midnight.20": "#cba2fa33",
    "color.bold.purple_midnight.30": "#cba2fa66",
    "color.bold.purple_midnight.40": "#cba2fa99",
    "color.bold.purple_midnight.50": "#cba2faff",
    "color.bold.purple_midnight.60": "#e4cffcff",
    "color.bold.purple_midnight.70": "#eee1fdff",
    "color.bold.purple_midnight.80": "#fbf9ffff",
    "color.bold.purple_midnight.inverse": "#1f0042ff",
    "color.bold.purple_midnight.background": "#3e0084ff",
    "color.bold.purple_midnight.grey.100": "#ffffffff",
    "color.bold.purple_midnight.grey.80": "#ffffffc7",
    "color.bold.purple_midnight.grey.60": "#ffffff87",
    "color.bold.purple_midnight.grey.40": "#ffffff4f",
    "color.bold.purple_midnight.grey.20": "#ffffff1f",
    "color.dark.purple_midnight.20": "#281240ff",
    "color.dark.purple_midnight.30": "#421f6bff",
    "color.dark.purple_midnight.40": "#5d2b96ff",
    "color.dark.purple_midnight.50": "#853dd6ff",
    "color.dark.purple_midnight.60": "#aa77e2ff",
    "color.dark.purple_midnight.70": "#c8a8edff",
    "color.dark.purple_midnight.80": "#e7d8f7ff",
    "color.dark.purple_midnight.inverse": "#ffffffff",
    "color.dark.purple_midnight.background": "#141414ff",
    "color.dark.purple_midnight.grey.100": "#ffffffff",
    "color.dark.purple_midnight.grey.80": "#ffffffc7",
    "color.dark.purple_midnight.grey.60": "#a1a1a1ff",
    "color.dark.purple_midnight.grey.40": "#5a5a5aff",
    "color.dark.purple_midnight.grey.20": "#2b2b2bff",
    "color.light.purple_midnight.20": "#f0e8faff",
    "color.light.purple_midnight.30": "#cba2faff",
    "color.light.purple_midnight.40": "#6d17ceff",
    "color.light.purple_midnight.50": "#3e0084ff",
    "color.light.purple_midnight.60": "#2b005cff",
    "color.light.purple_midnight.70": "#1f0042ff",
    "color.light.purple_midnight.80": "#130028ff",
    "color.light.purple_midnight.inverse": "#ffffffff",
    "color.light.purple_midnight.background": "#ffffffff",
    "color.light.purple_midnight.grey.100": "#141414ff",
    "color.light.purple_midnight.grey.80": "#000000a6",
    "color.light.purple_midnight.grey.60": "#b5b5b5ff",
    "color.light.purple_midnight.grey.40": "#e0e0e0ff",
    "color.light.purple_midnight.grey.20": "#f5f5f5ff",
    "color.bold.purple.20": "#cba2fa33",
    "color.bold.purple.30": "#cba2fa66",
    "color.bold.purple.40": "#cba2fa99",
    "color.bold.purple.50": "#cba2faff",
    "color.bold.purple.60": "#dbbefbff",
    "color.bold.purple.70": "#e4cffcff",
    "color.bold.purple.80": "#ecddfdff",
    "color.bold.purple.inverse": "#310a5dff",
    "color.bold.purple.background": "#6d17ceff",
    "color.bold.purple.grey.100": "#ffffffff",
    "color.bold.purple.grey.80": "#ffffffc7",
    "color.bold.purple.grey.60": "#ffffff87",
    "color.bold.purple.grey.40": "#ffffff4f",
    "color.bold.purple.grey.20": "#ffffff1f",
    "color.dark.purple.20": "#281240ff",
    "color.dark.purple.30": "#421f6bff",
    "color.dark.purple.40": "#5d2b96ff",
    "color.dark.purple.50": "#853dd6ff",
    "color.dark.purple.60": "#aa77e2ff",
    "color.dark.purple.70": "#c8a8edff",
    "color.dark.purple.80": "#e7d8f7ff",
    "color.dark.purple.inverse": "#ffffffff",
    "color.dark.purple.background": "#141414ff",
    "color.dark.purple.grey.100": "#ffffffff",
    "color.dark.purple.grey.80": "#ffffffc7",
    "color.dark.purple.grey.60": "#a1a1a1ff",
    "color.dark.purple.grey.40": "#5a5a5aff",
    "color.dark.purple.grey.20": "#2b2b2bff",
    "color.light.purple.20": "#f0e8faff",
    "color.light.purple.30": "#cba2faff",
    "color.light.purple.40": "#a680ffff",
    "color.light.purple.50": "#6d17ceff",
    "color.light.purple.60": "#3e0084ff",
    "color.light.purple.70": "#310a5dff",
    "color.light.purple.80": "#1b0633ff",
    "color.light.purple.inverse": "#ffffffff",
    "color.light.purple.background": "#ffffffff",
    "color.light.purple.grey.100": "#141414ff",
    "color.light.purple.grey.80": "#000000a6",
    "color.light.purple.grey.60": "#b5b5b5ff",
    "color.light.purple.grey.40": "#e0e0e0ff",
    "color.light.purple.grey.20": "#f5f5f5ff",
    "color.bold.red_midnight.20": "#ff9da333",
    "color.bold.red_midnight.30": "#ff9da366",
    "color.bold.red_midnight.40": "#ff9da399",
    "color.bold.red_midnight.50": "#ff9da3ff",
    "color.bold.red_midnight.60": "#ffccd1ff",
    "color.bold.red_midnight.70": "#ffe5e8ff",
    "color.bold.red_midnight.80": "#fff4f5ff",
    "color.bold.red_midnight.inverse": "#540000ff",
    "color.bold.red_midnight.background": "#a80000ff",
    "color.bold.red_midnight.grey.100": "#ffffffff",
    "color.bold.red_midnight.grey.80": "#ffffffc7",
    "color.bold.red_midnight.grey.60": "#ffffff87",
    "color.bold.red_midnight.grey.40": "#ffffff4f",
    "color.bold.red_midnight.grey.20": "#ffffff1f",
    "color.dark.red_midnight.20": "#430c10ff",
    "color.dark.red_midnight.30": "#70141aff",
    "color.dark.red_midnight.40": "#9d1d24ff",
    "color.dark.red_midnight.50": "#e02934ff",
    "color.dark.red_midnight.60": "#e96971ff",
    "color.dark.red_midnight.70": "#f19fa4ff",
    "color.dark.red_midnight.80": "#f9d4d6ff",
    "color.dark.red_midnight.inverse": "#ffffffff",
    "color.dark.red_midnight.background": "#141414ff",
    "color.dark.red_midnight.grey.100": "#ffffffff",
    "color.dark.red_midnight.grey.80": "#ffffffc7",
    "color.dark.red_midnight.grey.60": "#a1a1a1ff",
    "color.dark.red_midnight.grey.40": "#5a5a5aff",
    "color.dark.red_midnight.grey.20": "#2b2b2bff",
    "color.light.red_midnight.20": "#fce6e7ff",
    "color.light.red_midnight.30": "#ff9da3ff",
    "color.light.red_midnight.40": "#e30513ff",
    "color.light.red_midnight.50": "#a80000ff",
    "color.light.red_midnight.60": "#760000ff",
    "color.light.red_midnight.70": "#540000ff",
    "color.light.red_midnight.80": "#320000ff",
    "color.light.red_midnight.inverse": "#ffffffff",
    "color.light.red_midnight.background": "#ffffffff",
    "color.light.red_midnight.grey.100": "#141414ff",
    "color.light.red_midnight.grey.80": "#000000a6",
    "color.light.red_midnight.grey.60": "#b5b5b5ff",
    "color.light.red_midnight.grey.40": "#e0e0e0ff",
    "color.light.red_midnight.grey.20": "#f5f5f5ff",
    "color.bold.red.20": "#ff9da333",
    "color.bold.red.30": "#ff9da366",
    "color.bold.red.40": "#ff9da399",
    "color.bold.red.50": "#ff9da3ff",
    "color.bold.red.60": "#fff6f7ff",
    "color.bold.red.70": "#ffffffff",
    "color.bold.red.80": "#ffffffff",
    "color.bold.red.inverse": "#660209ff",
    "color.bold.red.background": "#e30513ff",
    "color.bold.red.grey.100": "#ffffffff",
    "color.bold.red.grey.80": "#fffffff5",
    "color.bold.red.grey.60": "#ffffff87",
    "color.bold.red.grey.40": "#ffffff4f",
    "color.bold.red.grey.20": "#ffffff1f",
    "color.dark.red.20": "#430c10ff",
    "color.dark.red.30": "#70141aff",
    "color.dark.red.40": "#9d1d24ff",
    "color.dark.red.50": "#e02934ff",
    "color.dark.red.60": "#e96971ff",
    "color.dark.red.70": "#f19fa4ff",
    "color.dark.red.80": "#f9d4d6ff",
    "color.dark.red.inverse": "#ffffffff",
    "color.dark.red.background": "#141414ff",
    "color.dark.red.grey.100": "#ffffffff",
    "color.dark.red.grey.80": "#ffffffc7",
    "color.dark.red.grey.60": "#a1a1a1ff",
    "color.dark.red.grey.40": "#5a5a5aff",
    "color.dark.red.grey.20": "#2b2b2bff",
    "color.light.red.20": "#fce6e7ff",
    "color.light.red.30": "#ff9da3ff",
    "color.light.red.40": "#fc6770ff",
    "color.light.red.50": "#e30513ff",
    "color.light.red.60": "#a80000ff",
    "color.light.red.70": "#660209ff",
    "color.light.red.80": "#390105ff",
    "color.light.red.inverse": "#ffffffff",
    "color.light.red.background": "#ffffffff",
    "color.light.red.grey.100": "#141414ff",
    "color.light.red.grey.80": "#000000a6",
    "color.light.red.grey.60": "#b5b5b5ff",
    "color.light.red.grey.40": "#e0e0e0ff",
    "color.light.red.grey.20": "#f5f5f5ff",
    "color.bold.reliance_midnight.20": "#9eb5fa33",
    "color.bold.reliance_midnight.30": "#9eb5fa66",
    "color.bold.reliance_midnight.40": "#9eb5fa99",
    "color.bold.reliance_midnight.50": "#9eb5faff",
    "color.bold.reliance_midnight.60": "#c7d4fcff",
    "color.bold.reliance_midnight.70": "#dce4fdff",
    "color.bold.reliance_midnight.80": "#f3f5feff",
    "color.bold.reliance_midnight.inverse": "#051442ff",
    "color.bold.reliance_midnight.background": "#0a2885ff",
    "color.bold.reliance_midnight.grey.100": "#ffffffff",
    "color.bold.reliance_midnight.grey.80": "#ffffffc7",
    "color.bold.reliance_midnight.grey.60": "#ffffff87",
    "color.bold.reliance_midnight.grey.40": "#ffffff4f",
    "color.bold.reliance_midnight.grey.20": "#ffffff1f",
    "color.dark.reliance_midnight.20": "#051444ff",
    "color.dark.reliance_midnight.30": "#092272ff",
    "color.dark.reliance_midnight.40": "#0c30a0ff",
    "color.dark.reliance_midnight.50": "#1144e4ff",
    "color.dark.reliance_midnight.60": "#587cecff",
    "color.dark.reliance_midnight.70": "#94abf3ff",
    "color.dark.reliance_midnight.80": "#cfdafaff",
    "color.dark.reliance_midnight.inverse": "#ffffffff",
    "color.dark.reliance_midnight.background": "#141414ff",
    "color.dark.reliance_midnight.grey.100": "#ffffffff",
    "color.dark.reliance_midnight.grey.80": "#ffffffc7",
    "color.dark.reliance_midnight.grey.60": "#a1a1a1ff",
    "color.dark.reliance_midnight.grey.40": "#5a5a5aff",
    "color.dark.reliance_midnight.grey.20": "#2b2b2bff",
    "color.light.reliance_midnight.20": "#e7ebf8ff",
    "color.light.reliance_midnight.30": "#9eb5faff",
    "color.light.reliance_midnight.40": "#0f3cc9ff",
    "color.light.reliance_midnight.50": "#0a2885ff",
    "color.light.reliance_midnight.60": "#071c5dff",
    "color.light.reliance_midnight.70": "#051442ff",
    "color.light.reliance_midnight.80": "#030c28ff",
    "color.light.reliance_midnight.inverse": "#ffffffff",
    "color.light.reliance_midnight.background": "#ffffffff",
    "color.light.reliance_midnight.grey.100": "#141414ff",
    "color.light.reliance_midnight.grey.80": "#000000a6",
    "color.light.reliance_midnight.grey.60": "#b5b5b5ff",
    "color.light.reliance_midnight.grey.40": "#e0e0e0ff",
    "color.light.reliance_midnight.grey.20": "#f5f5f5ff",
    "color.bold.reliance.20": "#9eb5fa33",
    "color.bold.reliance.30": "#9eb5fa66",
    "color.bold.reliance.40": "#9eb5fa99",
    "color.bold.reliance.50": "#9eb5faff",
    "color.bold.reliance.60": "#becefbff",
    "color.bold.reliance.70": "#d0dcfdff",
    "color.bold.reliance.80": "#e8eefeff",
    "color.bold.reliance.inverse": "#061951ff",
    "color.bold.reliance.background": "#0f3cc9ff",
    "color.bold.reliance.grey.100": "#ffffffff",
    "color.bold.reliance.grey.80": "#ffffffc7",
    "color.bold.reliance.grey.60": "#ffffff87",
    "color.bold.reliance.grey.40": "#ffffff4f",
    "color.bold.reliance.grey.20": "#ffffff1f",
    "color.dark.reliance.20": "#051444ff",
    "color.dark.reliance.30": "#092272ff",
    "color.dark.reliance.40": "#0c30a0ff",
    "color.dark.reliance.50": "#1144e4ff",
    "color.dark.reliance.60": "#587cecff",
    "color.dark.reliance.70": "#94abf3ff",
    "color.dark.reliance.80": "#cfdafaff",
    "color.dark.reliance.inverse": "#ffffffff",
    "color.dark.reliance.background": "#141414ff",
    "color.dark.reliance.grey.100": "#ffffffff",
    "color.dark.reliance.grey.80": "#ffffffc7",
    "color.dark.reliance.grey.60": "#a1a1a1ff",
    "color.dark.reliance.grey.40": "#5a5a5aff",
    "color.dark.reliance.grey.20": "#2b2b2bff",
    "color.light.reliance.20": "#e7ebf8ff",
    "color.light.reliance.30": "#9eb5faff",
    "color.light.reliance.40": "#6789f4ff",
    "color.light.reliance.50": "#0f3cc9ff",
    "color.light.reliance.60": "#0a2885ff",
    "color.light.reliance.70": "#061951ff",
    "color.light.reliance.80": "#070e21ff",
    "color.light.reliance.inverse": "#ffffffff",
    "color.light.reliance.background": "#ffffffff",
    "color.light.reliance.grey.100": "#141414ff",
    "color.light.reliance.grey.80": "#000000a6",
    "color.light.reliance.grey.60": "#b5b5b5ff",
    "color.light.reliance.grey.40": "#e0e0e0ff",
    "color.light.reliance.grey.20": "#f5f5f5ff",
    "color.bold.sky_midnight.20": "#89dcff33",
    "color.bold.sky_midnight.30": "#89dcff66",
    "color.bold.sky_midnight.40": "#89dcff99",
    "color.bold.sky_midnight.50": "#89dcffff",
    "color.bold.sky_midnight.60": "#bceaffff",
    "color.bold.sky_midnight.70": "#d4f2ffff",
    "color.bold.sky_midnight.80": "#f2fbffff",
    "color.bold.sky_midnight.inverse": "#062939ff",
    "color.bold.sky_midnight.background": "#0c5273ff",
    "color.bold.sky_midnight.grey.100": "#ffffffff",
    "color.bold.sky_midnight.grey.80": "#ffffffc7",
    "color.bold.sky_midnight.grey.60": "#ffffff87",
    "color.bold.sky_midnight.grey.40": "#ffffff4f",
    "color.bold.sky_midnight.grey.20": "#ffffff1f",
    "color.dark.sky_midnight.20": "#002b3dff",
    "color.dark.sky_midnight.30": "#004766ff",
    "color.dark.sky_midnight.40": "#00638fff",
    "color.dark.sky_midnight.50": "#007fadff",
    "color.dark.sky_midnight.60": "#4ca5c6ff",
    "color.dark.sky_midnight.70": "#8cc5daff",
    "color.dark.sky_midnight.80": "#cce5efff",
    "color.dark.sky_midnight.inverse": "#ffffffff",
    "color.dark.sky_midnight.background": "#141414ff",
    "color.dark.sky_midnight.grey.100": "#ffffffff",
    "color.dark.sky_midnight.grey.80": "#ffffffc7",
    "color.dark.sky_midnight.grey.60": "#a1a1a1ff",
    "color.dark.sky_midnight.grey.40": "#5a5a5aff",
    "color.dark.sky_midnight.grey.20": "#2b2b2bff",
    "color.light.sky_midnight.20": "#e5f1f7ff",
    "color.light.sky_midnight.30": "#89dcffff",
    "color.light.sky_midnight.40": "#0078adff",
    "color.light.sky_midnight.50": "#0c5273ff",
    "color.light.sky_midnight.60": "#083950ff",
    "color.light.sky_midnight.70": "#062939ff",
    "color.light.sky_midnight.80": "#041922ff",
    "color.light.sky_midnight.inverse": "#ffffffff",
    "color.light.sky_midnight.background": "#ffffffff",
    "color.light.sky_midnight.grey.100": "#141414ff",
    "color.light.sky_midnight.grey.80": "#000000a6",
    "color.light.sky_midnight.grey.60": "#b5b5b5ff",
    "color.light.sky_midnight.grey.40": "#e0e0e0ff",
    "color.light.sky_midnight.grey.20": "#f5f5f5ff",
    "color.bold.sky.20": "#89dcff33",
    "color.bold.sky.30": "#89dcff66",
    "color.bold.sky.40": "#89dcff99",
    "color.bold.sky.50": "#89dcffff",
    "color.bold.sky.60": "#eefaffff",
    "color.bold.sky.70": "#ffffffff",
    "color.bold.sky.80": "#ffffffff",
    "color.bold.sky.inverse": "#00364eff",
    "color.bold.sky.background": "#0078adff",
    "color.bold.sky.grey.100": "#ffffffff",
    "color.bold.sky.grey.80": "#fffffff0",
    "color.bold.sky.grey.60": "#ffffff87",
    "color.bold.sky.grey.40": "#ffffff4f",
    "color.bold.sky.grey.20": "#ffffff1f",
    "color.dark.sky.20": "#002b3dff",
    "color.dark.sky.30": "#004766ff",
    "color.dark.sky.40": "#00638fff",
    "color.dark.sky.50": "#007fadff",
    "color.dark.sky.60": "#4ca5c6ff",
    "color.dark.sky.70": "#8cc5daff",
    "color.dark.sky.80": "#cce5efff",
    "color.dark.sky.inverse": "#ffffffff",
    "color.dark.sky.background": "#141414ff",
    "color.dark.sky.grey.100": "#ffffffff",
    "color.dark.sky.grey.80": "#ffffffc7",
    "color.dark.sky.grey.60": "#a1a1a1ff",
    "color.dark.sky.grey.40": "#5a5a5aff",
    "color.dark.sky.grey.20": "#2b2b2bff",
    "color.light.sky.20": "#e5f1f7ff",
    "color.light.sky.30": "#89dcffff",
    "color.light.sky.40": "#67c3efff",
    "color.light.sky.50": "#0078adff",
    "color.light.sky.60": "#0c5273ff",
    "color.light.sky.70": "#00364eff",
    "color.light.sky.80": "#001e2bff",
    "color.light.sky.inverse": "#ffffffff",
    "color.light.sky.background": "#ffffffff",
    "color.light.sky.grey.100": "#141414ff",
    "color.light.sky.grey.80": "#000000a6",
    "color.light.sky.grey.60": "#b5b5b5ff",
    "color.light.sky.grey.40": "#e0e0e0ff",
    "color.light.sky.grey.20": "#f5f5f5ff",
    "color.bold.violet_midnight.20": "#f7a8fa33",
    "color.bold.violet_midnight.30": "#f7a8fa66",
    "color.bold.violet_midnight.40": "#f7a8fa99",
    "color.bold.violet_midnight.50": "#f7a8faff",
    "color.bold.violet_midnight.60": "#fbd1fcff",
    "color.bold.violet_midnight.70": "#fbd3fcff",
    "color.bold.violet_midnight.80": "#fef3feff",
    "color.bold.violet_midnight.inverse": "#3d0040ff",
    "color.bold.violet_midnight.background": "#79007fff",
    "color.bold.violet_midnight.grey.100": "#ffffffff",
    "color.bold.violet_midnight.grey.80": "#ffffffc7",
    "color.bold.violet_midnight.grey.60": "#ffffff87",
    "color.bold.violet_midnight.grey.40": "#ffffff4f",
    "color.bold.violet_midnight.grey.20": "#ffffff1f",
    "color.dark.violet_midnight.20": "#300d31ff",
    "color.dark.violet_midnight.30": "#571859ff",
    "color.dark.violet_midnight.40": "#79007fff",
    "color.dark.violet_midnight.50": "#c135c5ff",
    "color.dark.violet_midnight.60": "#f680f9ff",
    "color.dark.violet_midnight.70": "#f7a8faff",
    "color.dark.violet_midnight.80": "#f9ebf9ff",
    "color.dark.violet_midnight.inverse": "#ffffffff",
    "color.dark.violet_midnight.background": "#141414ff",
    "color.dark.violet_midnight.grey.100": "#ffffffff",
    "color.dark.violet_midnight.grey.80": "#ffffffc7",
    "color.dark.violet_midnight.grey.60": "#a1a1a1ff",
    "color.dark.violet_midnight.grey.40": "#5a5a5aff",
    "color.dark.violet_midnight.grey.20": "#2b2b2bff",
    "color.light.violet_midnight.20": "#f9ebf9ff",
    "color.light.violet_midnight.30": "#f7a8faff",
    "color.light.violet_midnight.40": "#c135c5ff",
    "color.light.violet_midnight.50": "#79007fff",
    "color.light.violet_midnight.60": "#550059ff",
    "color.light.violet_midnight.70": "#3d0040ff",
    "color.light.violet_midnight.80": "#240026ff",
    "color.light.violet_midnight.inverse": "#ffffffff",
    "color.light.violet_midnight.background": "#ffffffff",
    "color.light.violet_midnight.grey.100": "#141414ff",
    "color.light.violet_midnight.grey.80": "#000000a6",
    "color.light.violet_midnight.grey.60": "#b5b5b5ff",
    "color.light.violet_midnight.grey.40": "#e0e0e0ff",
    "color.light.violet_midnight.grey.20": "#f5f5f5ff",
    "color.bold.violet.20": "#f7a8fa33",
    "color.bold.violet.30": "#f7a8fa66",
    "color.bold.violet.40": "#f7a8fa99",
    "color.bold.violet.50": "#f7a8faff",
    "color.bold.violet.60": "#fefdffff",
    "color.bold.violet.70": "#ffffffff",
    "color.bold.violet.80": "#ffffffff",
    "color.bold.violet.inverse": "#571859ff",
    "color.bold.violet.background": "#c135c5ff",
    "color.bold.violet.grey.100": "#ffffffff",
    "color.bold.violet.grey.80": "#fffffffc",
    "color.bold.violet.grey.60": "#ffffff87",
    "color.bold.violet.grey.40": "#ffffff4f",
    "color.bold.violet.grey.20": "#ffffff1f",
    "color.dark.violet.20": "#300d31ff",
    "color.dark.violet.30": "#571859ff",
    "color.dark.violet.40": "#79007fff",
    "color.dark.violet.50": "#c135c5ff",
    "color.dark.violet.60": "#f680f9ff",
    "color.dark.violet.70": "#f7a8faff",
    "color.dark.violet.80": "#f9ebf9ff",
    "color.dark.violet.inverse": "#ffffffff",
    "color.dark.violet.background": "#141414ff",
    "color.dark.violet.grey.100": "#ffffffff",
    "color.dark.violet.grey.80": "#ffffffc7",
    "color.dark.violet.grey.60": "#a1a1a1ff",
    "color.dark.violet.grey.40": "#5a5a5aff",
    "color.dark.violet.grey.20": "#2b2b2bff",
    "color.light.violet.20": "#f9ebf9ff",
    "color.light.violet.30": "#f7a8faff",
    "color.light.violet.40": "#f680f9ff",
    "color.light.violet.50": "#c135c5ff",
    "color.light.violet.60": "#79007fff",
    "color.light.violet.70": "#571859ff",
    "color.light.violet.80": "#300d31ff",
    "color.light.violet.inverse": "#ffffffff",
    "color.light.violet.background": "#ffffffff",
    "color.light.violet.grey.100": "#141414ff",
    "color.light.violet.grey.80": "#000000a6",
    "color.light.violet.grey.60": "#b5b5b5ff",
    "color.light.violet.grey.40": "#e0e0e0ff",
    "color.light.violet.grey.20": "#f5f5f5ff",
    "color.light.feedback.error.80": "#3e0006ff",
    "color.light.feedback.error.70": "#6a000fff",
    "color.light.feedback.error.60": "#cd0027ff",
    "color.light.feedback.error.50": "#fa2F40ff",
    "color.light.feedback.error.40": "#fe9993ff",
    "color.light.feedback.error.30": "#ffCFCBff",
    "color.light.feedback.error.20": "#fff1F0ff",
    "color.light.feedback.warning.80": "#321304ff",
    "color.light.feedback.warning.70": "#582309ff",
    "color.light.feedback.warning.60": "#b04914ff",
    "color.light.feedback.warning.50": "#f06d0fff",
    "color.light.feedback.warning.40": "#fC9E6dff",
    "color.light.feedback.warning.30": "#FCD3BFff",
    "color.light.feedback.warning.20": "#fff2ecff",
    "color.light.feedback.success.80": "#0e540cff",
    "color.light.feedback.success.70": "#136c11ff",
    "color.light.feedback.success.60": "#1a8417ff",
    "color.light.feedback.success.50": "#25ab21ff",
    "color.light.feedback.success.40": "#85ce7fff",
    "color.light.feedback.success.30": "#c8e7c5ff",
    "color.light.feedback.success.20": "#eff8eeff",
    "color.light.white": "#ffffff",
    "color.light.black": "#141414",
    "color.dark.white": "#ffffff",
    "color.dark.black": "#141414",
    "color.bold.white": "#ffffff",
    "color.bold.black": "#141414",
    "color.bold.feedback.error.80": "#FFE1DEff",
    "color.bold.feedback.error.70": "#FFCFCBff",
    "color.bold.feedback.error.60": "#FFBEB9ff",
    "color.bold.feedback.error.50": "#FEABA6ff",
    "color.bold.feedback.error.40": "#FE9993ff",
    "color.bold.feedback.error.30": "#FF847Fff",
    "color.bold.feedback.error.20": "#FF6E6Cff",
    "color.bold.feedback.warning.80": "#FFF2ECff",
    "color.bold.feedback.warning.70": "#FEE3D6ff",
    "color.bold.feedback.warning.60": "#FCD3BFff",
    "color.bold.feedback.warning.50": "#FBC2A6ff",
    "color.bold.feedback.warning.40": "#FBB08Aff",
    "color.bold.feedback.warning.30": "#FC9E6Dff",
    "color.bold.feedback.warning.20": "#FB8C50ff",
    "color.bold.feedback.success.80": "#DCF0DAff",
    "color.bold.feedback.success.70": "#C8E7C5ff",
    "color.bold.feedback.success.60": "#B4DEAFff",
    "color.bold.feedback.success.50": "#9CD696ff",
    "color.bold.feedback.success.40": "#85CE7Fff",
    "color.bold.feedback.success.30": "#6CC765ff",
    "color.bold.feedback.success.20": "#54BE4Eff",
    "color.dark.feedback.error.80": "#fff1f0ff",
    "color.dark.feedback.error.70": "#ffe1deff",
    "color.dark.feedback.error.60": "#feaba6ff",
    "color.dark.feedback.error.50": "#ff5256ff",
    "color.dark.feedback.error.40": "#df042cff",
    "color.dark.feedback.error.30": "#770113ff",
    "color.dark.feedback.error.20": "#4F0109ff",
    "color.dark.feedback.warning.80": "#fff2ecff",
    "color.dark.feedback.warning.70": "#ffd6c2ff",
    "color.dark.feedback.warning.60": "#fbb08Aff",
    "color.dark.feedback.warning.50": "#f87a2eff",
    "color.dark.feedback.warning.40": "#c05016ff",
    "color.dark.feedback.warning.30": "#66270aff",
    "color.dark.feedback.warning.20": "#401a07ff",
    "color.dark.feedback.success.80": "#EFF8EEff",
    "color.dark.feedback.success.70": "#DCF0DAff",
    "color.dark.feedback.success.60": "#9CD696ff",
    "color.dark.feedback.success.50": "#3EB438ff",
    "color.dark.feedback.success.40": "#1D901Aff",
    "color.dark.feedback.success.30": "#167814ff",
    "color.dark.feedback.success.20": "#105F0Eff",
    "color.light.gold.20": "#f9f6efFF",
    "color.dark.gold.20": "#3f3721FF",
    "color.bold.gold.20": "#211d14FF",
    "color.light.gold.30": "#f4ead4FF",
    "color.dark.gold.30": "#746640FF",
    "color.bold.gold.30": "#3f3721FF",
    "color.light.gold.40": "#f0deb2FF",
    "color.dark.gold.40": "#a18e5bFF",
    "color.bold.gold.40": "#746640FF",
    "color.light.gold.50": "#c9b273FF",
    "color.dark.gold.50": "#d2ba78FF",
    "color.bold.gold.50": "#a18e5bFF",
    "color.light.gold.60": "#968454FF",
    "color.dark.gold.60": "#f0deb2FF",
    "color.bold.gold.60": "#f0deb2FF",
    "color.light.gold.70": "#6a5d3aFF",
    "color.dark.gold.70": "#f4ead4FF",
    "color.bold.gold.70": "#f4ead4FF",
    "color.light.gold.80": "#352e1dFF",
    "color.dark.gold.80": "#f9f6efFF",
    "color.bold.gold.80": "#f9f6efFF",
    "color.light.gold.grey.20": "#f5f5f5FF",
    "color.dark.gold.grey.20": "#2b2b2bFF",
    "color.bold.gold.grey.20": "#ffffff1F",
    "color.light.gold.grey.40": "#e0e0e0FF",
    "color.dark.gold.grey.40": "#5a5a5aFF",
    "color.bold.gold.grey.40": "#ffffff52",
    "color.light.gold.grey.60": "#b5b5b5FF",
    "color.dark.gold.grey.60": "#a1a1a1FF",
    "color.bold.gold.grey.60": "#ffffff87",
    "color.light.gold.grey.80": "#000000A6",
    "color.dark.gold.grey.80": "#ffffffC7",
    "color.bold.gold.grey.80": "#ffffffC7",
    "color.light.gold.grey.100": "#141414FF",
    "color.dark.gold.grey.100": "#ffffffFF",
    "color.bold.gold.grey.100": "#ffffffFF",
    "color.light.gold.background": "#ffffffFF",
    "color.dark.gold.background": "#141414FF",
    "color.bold.gold.background": "#c9b273FF",
    "color.light.gold.inverse": "#352e1dFF",
    "color.dark.gold.inverse": "#3f3721FF",
    "color.bold.gold.inverse": "#211d14FF",
    "color.light.rose.20": "#fcf5f5FF",
    "color.dark.rose.20": "#2e070aFF",
    "color.bold.rose.20": "#4e0b19FF",
    "color.light.rose.30": "#fad8d8FF",
    "color.dark.rose.30": "#700b25FF",
    "color.bold.rose.30": "#d8214fFF",
    "color.light.rose.40": "#f9c9caFF",
    "color.dark.rose.40": "#c61d48FF",
    "color.bold.rose.40": "#f8536eFF",
    "color.light.rose.50": "#fa969dFF",
    "color.dark.rose.50": "#f8536eFF",
    "color.bold.rose.50": "#f96e7eFF",
    "color.light.rose.60": "#f96e7eFF",
    "color.dark.rose.60": "#fba5aaFF",
    "color.bold.rose.60": "#fab6b9FF",
    "color.light.rose.70": "#720c26FF",
    "color.dark.rose.70": "#fad7d8FF",
    "color.bold.rose.70": "#fad7d8FF",
    "color.light.rose.80": "#3d0912FF",
    "color.dark.rose.80": "#fae6e7FF",
    "color.bold.rose.80": "#fcf5f5FF",
    "color.light.rose.grey.20": "#f5f5f5FF",
    "color.dark.rose.grey.20": "#2b2b2bFF",
    "color.bold.rose.grey.20": "#ffffff1F",
    "color.light.rose.grey.40": "#e0e0e0FF",
    "color.dark.rose.grey.40": "#5a5a5aFF",
    "color.bold.rose.grey.40": "#ffffff52",
    "color.light.rose.grey.60": "#b5b5b5FF",
    "color.dark.rose.grey.60": "#a1a1a1FF",
    "color.bold.rose.grey.60": "#ffffff87",
    "color.light.rose.grey.80": "#000000A6",
    "color.dark.rose.grey.80": "#ffffffC7",
    "color.bold.rose.grey.80": "#ffffffC7",
    "color.light.rose.grey.100": "#141414FF",
    "color.dark.rose.grey.100": "#ffffffFF",
    "color.bold.rose.grey.100": "#ffffffFF",
    "color.light.rose.background": "#3d0912FF",
    "color.dark.rose.background": "#141414FF",
    "color.bold.rose.background": "#141414FF",
    "color.light.rose.inverse": "#3d0912FF",
    "color.dark.rose.inverse": "#ffffffFF",
    "color.bold.rose.inverse": "#2e070aFF",
    "color.light.warm_gold.20": "#FEF7EF",
    "color.light.warm_gold.30": "#F9D4A9",
    "color.light.warm_gold.40": "#F3B561",
    "color.light.warm_gold.50": "#E39B2B",
    "color.light.warm_gold.60": "#9B6817",
    "color.light.warm_gold.70": "#67440C",
    "color.light.warm_gold.80": "#312109",
    "color.light.warm_gold.grey.20": "#F5F5F5",
    "color.light.warm_gold.grey.40": "#E0E0E0",
    "color.light.warm_gold.grey.60": "#B5B5B5",
    "color.light.warm_gold.grey.80": "#000000A5",
    "color.light.warm_gold.grey.100": "#141414",
    "color.light.warm_gold.background": "#FFFFFF",
    "color.light.warm_gold.inverse": "#312109",
    "color.dark.warm_gold.20": "#312109",
    "color.dark.warm_gold.30": "#67440C",
    "color.dark.warm_gold.40": "#A8711A",
    "color.dark.warm_gold.50": "#EFA73D",
    "color.dark.warm_gold.60": "#F6C586",
    "color.dark.warm_gold.70": "#FCE7D0",
    "color.dark.warm_gold.80": "#FDFDFD",
    "color.dark.warm_gold.grey.20": "#2B2B2B",
    "color.dark.warm_gold.grey.40": "#5A5A5A",
    "color.dark.warm_gold.grey.60": "#A1A1A1",
    "color.dark.warm_gold.grey.80": "#FFFFFFC7",
    "color.dark.warm_gold.grey.100": "#FFFFFF",
    "color.dark.warm_gold.background": "#120C04",
    "color.dark.warm_gold.inverse": "#312109",
    "color.bold.warm_gold.20": "#EFA73D",
    "color.bold.warm_gold.30": "#C78724",
    "color.bold.warm_gold.40": "#8E5F15",
    "color.bold.warm_gold.50": "#67440C",
    "color.bold.warm_gold.60": "#452D09",
    "color.bold.warm_gold.70": "#312109",
    "color.bold.warm_gold.80": "#241908",
    "color.bold.warm_gold.grey.20": "#401D0C1E",
    "color.bold.warm_gold.grey.40": "#401D0C4D",
    "color.bold.warm_gold.grey.60": "#401D0C87",
    "color.bold.warm_gold.grey.80": "#401D0CBF",
    "color.bold.warm_gold.grey.100": "#401D0C",
    "color.bold.warm_gold.background": "#E39B2B",
    "color.bold.warm_gold.inverse": "#FEF7EF",
    elevation1: $e3613f6017c674c5$var$elevation1,
    "elevation1.light": "{color.light.$primary.background}",
    "elevation1.dark": "{color.dark.$primary.grey.20}",
    "elevation1.bold": "{color.bold.$primary.background}",
    custom_color_1: $e3613f6017c674c5$var$custom_color_1,
    custom_color_2: $e3613f6017c674c5$var$custom_color_2,
    custom_color_3: $e3613f6017c674c5$var$custom_color_3,
    custom_color_4: $e3613f6017c674c5$var$custom_color_4,
    custom_color_5: $e3613f6017c674c5$var$custom_color_5,
    custom_color_6: $e3613f6017c674c5$var$custom_color_6,
    custom_dark_primary_40: $e3613f6017c674c5$var$custom_dark_primary_40,
    custom_dark_primary_60: $e3613f6017c674c5$var$custom_dark_primary_60,
    custom_dark_primary_grey_80: $e3613f6017c674c5$var$custom_dark_primary_grey_80,
    custom_dark_primary_grey_100: $e3613f6017c674c5$var$custom_dark_primary_grey_100
};
const $e3613f6017c674c5$var$headingXl$4 = "{$lang.$platform.headingXl}";
const $e3613f6017c674c5$var$headingL$4 = "{$lang.$platform.headingL}";
const $e3613f6017c674c5$var$headingM$4 = "{$lang.$platform.headingM}";
const $e3613f6017c674c5$var$headingS$4 = "{$lang.$platform.headingS}";
const $e3613f6017c674c5$var$headingXs$4 = "{$lang.$platform.headingXs}";
const $e3613f6017c674c5$var$headingXxs$4 = "{$lang.$platform.headingXxs}";
const $e3613f6017c674c5$var$overline$5 = "{$lang.$platform.overline}";
const $e3613f6017c674c5$var$bodyL$4 = "{$lang.$platform.bodyL}";
const $e3613f6017c674c5$var$bodyLBold$4 = "{$lang.$platform.bodyLBold}";
const $e3613f6017c674c5$var$bodyLLink$4 = "{$lang.$platform.bodyLLink}";
const $e3613f6017c674c5$var$bodyM$4 = "{$lang.$platform.bodyM}";
const $e3613f6017c674c5$var$bodyMBold$4 = "{$lang.$platform.bodyMBold}";
const $e3613f6017c674c5$var$bodyMLink$4 = "{$lang.$platform.bodyMLink}";
const $e3613f6017c674c5$var$bodyS$4 = "{$lang.$platform.bodyS}";
const $e3613f6017c674c5$var$bodySBold$4 = "{$lang.$platform.bodySBold}";
const $e3613f6017c674c5$var$bodySLink$4 = "{$lang.$platform.bodySLink}";
const $e3613f6017c674c5$var$bodyXs$4 = "{$lang.$platform.bodyXs}";
const $e3613f6017c674c5$var$bodyXsBold$4 = "{$lang.$platform.bodyXsBold}";
const $e3613f6017c674c5$var$bodyXsLink$4 = "{$lang.$platform.bodyXsLink}";
const $e3613f6017c674c5$var$bodyXxs$4 = "{$lang.$platform.bodyXxs}";
const $e3613f6017c674c5$var$bodyXxsBold$4 = "{$lang.$platform.bodyXxsBold}";
const $e3613f6017c674c5$var$bodyXxsLink$4 = "{$lang.$platform.bodyXxsLink}";
const $e3613f6017c674c5$var$body3xs$4 = "{$lang.$platform.body3xs}";
const $e3613f6017c674c5$var$body3xsBold$4 = "{$lang.$platform.body3xsBold}";
const $e3613f6017c674c5$var$body3xsLink$4 = "{$lang.$platform.body3xsLink}";
const $e3613f6017c674c5$var$listTitle$4 = "{$lang.$platform.listTitle}";
const $e3613f6017c674c5$var$button$4 = "{$lang.$platform.button}";
const $e3613f6017c674c5$var$code$4 = "{$lang.$platform.code}";
const $e3613f6017c674c5$var$fontFamilies = {
    "as.desktop.headingXl": "Noto Sans",
    "as.desktop.headingL": "Noto Sans",
    "as.desktop.headingM": "Noto Sans",
    "as.desktop.headingS": "Noto Sans",
    "as.desktop.headingXs": "Noto Sans",
    "as.desktop.headingXxs": "Noto Sans",
    "as.desktop.overline": "Noto Sans",
    "as.desktop.bodyL": "Noto Sans",
    "as.desktop.bodyLBold": "Noto Sans",
    "as.desktop.bodyLLink": "Noto Sans",
    "as.desktop.bodyM": "Noto Sans",
    "as.desktop.bodyMBold": "Noto Sans",
    "as.desktop.bodyMLink": "Noto Sans",
    "as.desktop.bodyS": "Noto Sans",
    "as.desktop.bodySBold": "Noto Sans",
    "as.desktop.bodySLink": "Noto Sans",
    "as.desktop.bodyXs": "Noto Sans",
    "as.desktop.bodyXsBold": "Noto Sans",
    "as.desktop.bodyXsLink": "Noto Sans",
    "as.desktop.bodyXxs": "Noto Sans",
    "as.desktop.bodyXxsBold": "Noto Sans",
    "as.desktop.bodyXxsLink": "Noto Sans",
    "as.desktop.body3xs": "Noto Sans",
    "as.desktop.body3xsBold": "Noto Sans",
    "as.desktop.body3xsLink": "Noto Sans",
    "as.desktop.listTitle": "Noto Sans",
    "as.desktop.button": "Noto Sans",
    "as.desktop.code": "JetBrains Mono",
    "as.mobile.headingXl": "Noto Sans",
    "as.mobile.headingL": "Noto Sans",
    "as.mobile.headingM": "Noto Sans",
    "as.mobile.headingS": "Noto Sans",
    "as.mobile.headingXs": "Noto Sans",
    "as.mobile.headingXxs": "Noto Sans",
    "as.mobile.overline": "Noto Sans",
    "as.mobile.bodyL": "Noto Sans",
    "as.mobile.bodyLBold": "Noto Sans",
    "as.mobile.bodyLLink": "Noto Sans",
    "as.mobile.bodyM": "Noto Sans",
    "as.mobile.bodyMBold": "Noto Sans",
    "as.mobile.bodyMLink": "Noto Sans",
    "as.mobile.bodyS": "Noto Sans",
    "as.mobile.bodySBold": "Noto Sans",
    "as.mobile.bodySLink": "Noto Sans",
    "as.mobile.bodyXs": "Noto Sans",
    "as.mobile.bodyXsBold": "Noto Sans",
    "as.mobile.bodyXsLink": "Noto Sans",
    "as.mobile.bodyXxs": "Noto Sans",
    "as.mobile.bodyXxsBold": "Noto Sans",
    "as.mobile.bodyXxsLink": "Noto Sans",
    "as.mobile.body3xs": "Noto Sans",
    "as.mobile.body3xsBold": "Noto Sans",
    "as.mobile.body3xsLink": "Noto Sans",
    "as.mobile.listTitle": "Noto Sans",
    "as.mobile.button": "Noto Sans",
    "as.mobile.code": "JetBrains Mono",
    "bn.desktop.headingXl": "Noto Sans Bengali",
    "bn.desktop.headingL": "Noto Sans Bengali",
    "bn.desktop.headingM": "Noto Sans Bengali",
    "bn.desktop.headingS": "Noto Sans Bengali",
    "bn.desktop.headingXs": "Noto Sans Bengali",
    "bn.desktop.headingXxs": "Noto Sans Bengali",
    "bn.desktop.overline": "Noto Sans Bengali",
    "bn.desktop.bodyL": "Noto Sans Bengali",
    "bn.desktop.bodyLBold": "Noto Sans Bengali",
    "bn.desktop.bodyLLink": "Noto Sans Bengali",
    "bn.desktop.bodyM": "Noto Sans Bengali",
    "bn.desktop.bodyMBold": "Noto Sans Bengali",
    "bn.desktop.bodyMLink": "Noto Sans Bengali",
    "bn.desktop.bodyS": "Noto Sans Bengali",
    "bn.desktop.bodySBold": "Noto Sans Bengali",
    "bn.desktop.bodySLink": "Noto Sans Bengali",
    "bn.desktop.bodyXs": "Noto Sans Bengali",
    "bn.desktop.bodyXsBold": "Noto Sans Bengali",
    "bn.desktop.bodyXsLink": "Noto Sans Bengali",
    "bn.desktop.bodyXxs": "Noto Sans Bengali",
    "bn.desktop.bodyXxsBold": "Noto Sans Bengali",
    "bn.desktop.bodyXxsLink": "Noto Sans Bengali",
    "bn.desktop.body3xs": "Noto Sans Bengali",
    "bn.desktop.body3xsBold": "Noto Sans Bengali",
    "bn.desktop.body3xsLink": "Noto Sans Bengali",
    "bn.desktop.listTitle": "Noto Sans Bengali",
    "bn.desktop.button": "Noto Sans Bengali",
    "bn.desktop.code": "JetBrains Mono",
    "bn.mobile.headingXl": "Noto Sans Bengali",
    "bn.mobile.headingL": "Noto Sans Bengali",
    "bn.mobile.headingM": "Noto Sans Bengali",
    "bn.mobile.headingS": "Noto Sans Bengali",
    "bn.mobile.headingXs": "Noto Sans Bengali",
    "bn.mobile.headingXxs": "Noto Sans Bengali",
    "bn.mobile.overline": "Noto Sans Bengali",
    "bn.mobile.bodyL": "Noto Sans Bengali",
    "bn.mobile.bodyLBold": "Noto Sans Bengali",
    "bn.mobile.bodyLLink": "Noto Sans Bengali",
    "bn.mobile.bodyM": "Noto Sans Bengali",
    "bn.mobile.bodyMBold": "Noto Sans Bengali",
    "bn.mobile.bodyMLink": "Noto Sans Bengali",
    "bn.mobile.bodyS": "Noto Sans Bengali",
    "bn.mobile.bodySBold": "Noto Sans Bengali",
    "bn.mobile.bodySLink": "Noto Sans Bengali",
    "bn.mobile.bodyXs": "Noto Sans Bengali",
    "bn.mobile.bodyXsBold": "Noto Sans Bengali",
    "bn.mobile.bodyXsLink": "Noto Sans Bengali",
    "bn.mobile.bodyXxs": "Noto Sans Bengali",
    "bn.mobile.bodyXxsBold": "Noto Sans Bengali",
    "bn.mobile.bodyXxsLink": "Noto Sans Bengali",
    "bn.mobile.body3xs": "Noto Sans Bengali",
    "bn.mobile.body3xsBold": "Noto Sans Bengali",
    "bn.mobile.body3xsLink": "Noto Sans Bengali",
    "bn.mobile.listTitle": "Noto Sans Bengali",
    "bn.mobile.button": "Noto Sans Bengali",
    "bn.mobile.code": "JetBrains Mono",
    "en.desktop.headingXl": "JioType Black",
    "en.desktop.headingL": "JioType Black",
    "en.desktop.headingM": "JioType Black",
    "en.desktop.headingS": "JioType Black",
    "en.desktop.headingXs": "JioType Black",
    "en.desktop.headingXxs": "JioType Black",
    "en.desktop.overline": "JioType Bold",
    "en.desktop.bodyL": "JioType Medium",
    "en.desktop.bodyLBold": "JioType Bold",
    "en.desktop.bodyLLink": "JioType Bold",
    "en.desktop.bodyM": "JioType Medium",
    "en.desktop.bodyMBold": "JioType Bold",
    "en.desktop.bodyMLink": "JioType Bold",
    "en.desktop.bodyS": "JioType Medium",
    "en.desktop.bodySBold": "JioType Bold",
    "en.desktop.bodySLink": "JioType Bold",
    "en.desktop.bodyXs": "JioType Medium",
    "en.desktop.bodyXsBold": "JioType Bold",
    "en.desktop.bodyXsLink": "JioType Bold",
    "en.desktop.bodyXxs": "JioType Medium",
    "en.desktop.bodyXxsBold": "JioType Bold",
    "en.desktop.bodyXxsLink": "JioType Bold",
    "en.desktop.body3xs": "JioType Medium",
    "en.desktop.body3xsBold": "JioType Bold",
    "en.desktop.body3xsLink": "JioType Bold",
    "en.desktop.listTitle": "JioType Medium",
    "en.desktop.button": "JioType Bold",
    "en.desktop.code": "JetBrains Mono",
    "en.mobile.headingXl": "JioType Black",
    "en.mobile.headingL": "JioType Black",
    "en.mobile.headingM": "JioType Black",
    "en.mobile.headingS": "JioType Black",
    "en.mobile.headingXs": "JioType Black",
    "en.mobile.headingXxs": "JioType Black",
    "en.mobile.overline": "JioType Bold",
    "en.mobile.bodyL": "JioType Medium",
    "en.mobile.bodyLBold": "JioType Bold",
    "en.mobile.bodyLLink": "JioType Bold",
    "en.mobile.bodyM": "JioType Medium",
    "en.mobile.bodyMBold": "JioType Bold",
    "en.mobile.bodyMLink": "JioType Bold",
    "en.mobile.bodyS": "JioType Medium",
    "en.mobile.bodySBold": "JioType Bold",
    "en.mobile.bodySLink": "JioType Bold",
    "en.mobile.bodyXs": "JioType Medium",
    "en.mobile.bodyXsBold": "JioType Bold",
    "en.mobile.bodyXsLink": "JioType Bold",
    "en.mobile.bodyXxs": "JioType Medium",
    "en.mobile.bodyXxsBold": "JioType Bold",
    "en.mobile.bodyXxsLink": "JioType Bold",
    "en.mobile.body3xs": "JioType Medium",
    "en.mobile.body3xsBold": "JioType Bold",
    "en.mobile.body3xsLink": "JioType Bold",
    "en.mobile.listTitle": "JioType Medium",
    "en.mobile.button": "JioType Bold",
    "en.mobile.code": "JetBrains Mono",
    "gu.desktop.headingXl": "Noto Sans Gujarati",
    "gu.desktop.headingL": "Noto Sans Gujarati",
    "gu.desktop.headingM": "Noto Sans Gujarati",
    "gu.desktop.headingS": "Noto Sans Gujarati",
    "gu.desktop.headingXs": "Noto Sans Gujarati",
    "gu.desktop.headingXxs": "Noto Sans Gujarati",
    "gu.desktop.overline": "Noto Sans Gujarati",
    "gu.desktop.bodyL": "Noto Sans Gujarati",
    "gu.desktop.bodyLBold": "Noto Sans Gujarati",
    "gu.desktop.bodyLLink": "Noto Sans Gujarati",
    "gu.desktop.bodyM": "Noto Sans Gujarati",
    "gu.desktop.bodyMBold": "Noto Sans Gujarati",
    "gu.desktop.bodyMLink": "Noto Sans Gujarati",
    "gu.desktop.bodyS": "Noto Sans Gujarati",
    "gu.desktop.bodySBold": "Noto Sans Gujarati",
    "gu.desktop.bodySLink": "Noto Sans Gujarati",
    "gu.desktop.bodyXs": "Noto Sans Gujarati",
    "gu.desktop.bodyXsBold": "Noto Sans Gujarati",
    "gu.desktop.bodyXsLink": "Noto Sans Gujarati",
    "gu.desktop.bodyXxs": "Noto Sans Gujarati",
    "gu.desktop.bodyXxsBold": "Noto Sans Gujarati",
    "gu.desktop.bodyXxsLink": "Noto Sans Gujarati",
    "gu.desktop.body3xs": "Noto Sans Gujarati",
    "gu.desktop.body3xsBold": "Noto Sans Gujarati",
    "gu.desktop.body3xsLink": "Noto Sans Gujarati",
    "gu.desktop.listTitle": "Noto Sans Gujarati",
    "gu.desktop.button": "Noto Sans Gujarati",
    "gu.desktop.code": "JetBrains Mono",
    "gu.mobile.headingXl": "Noto Sans Gujarati",
    "gu.mobile.headingL": "Noto Sans Gujarati",
    "gu.mobile.headingM": "Noto Sans Gujarati",
    "gu.mobile.headingS": "Noto Sans Gujarati",
    "gu.mobile.headingXs": "Noto Sans Gujarati",
    "gu.mobile.headingXxs": "Noto Sans Gujarati",
    "gu.mobile.overline": "Noto Sans Gujarati",
    "gu.mobile.bodyL": "Noto Sans Gujarati",
    "gu.mobile.bodyLBold": "Noto Sans Gujarati",
    "gu.mobile.bodyLLink": "Noto Sans Gujarati",
    "gu.mobile.bodyM": "Noto Sans Gujarati",
    "gu.mobile.bodyMBold": "Noto Sans Gujarati",
    "gu.mobile.bodyMLink": "Noto Sans Gujarati",
    "gu.mobile.bodyS": "Noto Sans Gujarati",
    "gu.mobile.bodySBold": "Noto Sans Gujarati",
    "gu.mobile.bodySLink": "Noto Sans Gujarati",
    "gu.mobile.bodyXs": "Noto Sans Gujarati",
    "gu.mobile.bodyXsBold": "Noto Sans Gujarati",
    "gu.mobile.bodyXsLink": "Noto Sans Gujarati",
    "gu.mobile.bodyXxs": "Noto Sans Gujarati",
    "gu.mobile.bodyXxsBold": "Noto Sans Gujarati",
    "gu.mobile.bodyXxsLink": "Noto Sans Gujarati",
    "gu.mobile.body3xs": "Noto Sans Gujarati",
    "gu.mobile.body3xsBold": "Noto Sans Gujarati",
    "gu.mobile.body3xsLink": "Noto Sans Gujarati",
    "gu.mobile.listTitle": "Noto Sans Gujarati",
    "gu.mobile.button": "Noto Sans Gujarati",
    "gu.mobile.code": "JetBrains Mono",
    "hi.desktop.headingXl": "Noto Sans",
    "hi.desktop.headingL": "Noto Sans",
    "hi.desktop.headingM": "Noto Sans",
    "hi.desktop.headingS": "Noto Sans",
    "hi.desktop.headingXs": "Noto Sans",
    "hi.desktop.headingXxs": "Noto Sans",
    "hi.desktop.overline": "Noto Sans Bengali",
    "hi.desktop.bodyL": "Noto Sans",
    "hi.desktop.bodyLBold": "Noto Sans",
    "hi.desktop.bodyLLink": "Noto Sans",
    "hi.desktop.bodyM": "Noto Sans",
    "hi.desktop.bodyMBold": "Noto Sans",
    "hi.desktop.bodyMLink": "Noto Sans",
    "hi.desktop.bodyS": "Noto Sans",
    "hi.desktop.bodySBold": "Noto Sans",
    "hi.desktop.bodySLink": "Noto Sans",
    "hi.desktop.bodyXs": "Noto Sans",
    "hi.desktop.bodyXsBold": "Noto Sans",
    "hi.desktop.bodyXsLink": "Noto Sans",
    "hi.desktop.bodyXxs": "Noto Sans",
    "hi.desktop.bodyXxsBold": "Noto Sans",
    "hi.desktop.bodyXxsLink": "Noto Sans",
    "hi.desktop.body3xs": "Noto Sans",
    "hi.desktop.body3xsBold": "Noto Sans",
    "hi.desktop.body3xsLink": "Noto Sans",
    "hi.desktop.listTitle": "Noto Sans",
    "hi.desktop.button": "Noto Sans",
    "hi.desktop.code": "JetBrains Mono",
    "hi.mobile.headingXl": "Noto Sans",
    "hi.mobile.headingL": "Noto Sans",
    "hi.mobile.headingM": "Noto Sans",
    "hi.mobile.headingS": "Noto Sans",
    "hi.mobile.headingXs": "Noto Sans",
    "hi.mobile.headingXxs": "Noto Sans",
    "hi.mobile.overline": "Noto Sans",
    "hi.mobile.bodyL": "Noto Sans",
    "hi.mobile.bodyLBold": "Noto Sans",
    "hi.mobile.bodyLLink": "Noto Sans",
    "hi.mobile.bodyM": "Noto Sans",
    "hi.mobile.bodyMBold": "Noto Sans",
    "hi.mobile.bodyMLink": "Noto Sans",
    "hi.mobile.bodyS": "Noto Sans",
    "hi.mobile.bodySBold": "Noto Sans",
    "hi.mobile.bodySLink": "Noto Sans",
    "hi.mobile.bodyXs": "Noto Sans",
    "hi.mobile.bodyXsBold": "Noto Sans",
    "hi.mobile.bodyXsLink": "Noto Sans",
    "hi.mobile.bodyXxs": "Noto Sans",
    "hi.mobile.bodyXxsBold": "Noto Sans",
    "hi.mobile.bodyXxsLink": "Noto Sans",
    "hi.mobile.body3xs": "Noto Sans",
    "hi.mobile.body3xsBold": "Noto Sans",
    "hi.mobile.body3xsLink": "Noto Sans",
    "hi.mobile.listTitle": "Noto Sans",
    "hi.mobile.button": "Noto Sans",
    "hi.mobile.code": "JetBrains Mono",
    "kn.desktop.headingXl": "Noto Sans Kannada",
    "kn.desktop.headingL": "Noto Sans Kannada",
    "kn.desktop.headingM": "Noto Sans Kannada",
    "kn.desktop.headingS": "Noto Sans Kannada",
    "kn.desktop.headingXs": "Noto Sans Kannada",
    "kn.desktop.headingXxs": "Noto Sans Kannada",
    "kn.desktop.overline": "Noto Sans Kannada",
    "kn.desktop.bodyL": "Noto Sans Kannada",
    "kn.desktop.bodyLBold": "Noto Sans Kannada",
    "kn.desktop.bodyLLink": "Noto Sans Kannada",
    "kn.desktop.bodyM": "Noto Sans Kannada",
    "kn.desktop.bodyMBold": "Noto Sans Kannada",
    "kn.desktop.bodyMLink": "Noto Sans Kannada",
    "kn.desktop.bodyS": "Noto Sans Kannada",
    "kn.desktop.bodySBold": "Noto Sans Kannada",
    "kn.desktop.bodySLink": "Noto Sans Kannada",
    "kn.desktop.bodyXs": "Noto Sans Kannada",
    "kn.desktop.bodyXsBold": "Noto Sans Kannada",
    "kn.desktop.bodyXsLink": "Noto Sans Kannada",
    "kn.desktop.bodyXxs": "Noto Sans Kannada",
    "kn.desktop.bodyXxsBold": "Noto Sans Kannada",
    "kn.desktop.bodyXxsLink": "Noto Sans Kannada",
    "kn.desktop.body3xs": "Noto Sans Kannada",
    "kn.desktop.body3xsBold": "Noto Sans Kannada",
    "kn.desktop.body3xsLink": "Noto Sans Kannada",
    "kn.desktop.listTitle": "Noto Sans Kannada",
    "kn.desktop.button": "Noto Sans Kannada",
    "kn.desktop.code": "JetBrains Mono",
    "kn.mobile.headingXl": "Noto Sans Kannada",
    "kn.mobile.headingL": "Noto Sans Kannada",
    "kn.mobile.headingM": "Noto Sans Kannada",
    "kn.mobile.headingS": "Noto Sans Kannada",
    "kn.mobile.headingXs": "Noto Sans Kannada",
    "kn.mobile.headingXxs": "Noto Sans Kannada",
    "kn.mobile.overline": "Noto Sans Kannada",
    "kn.mobile.bodyL": "Noto Sans Kannada",
    "kn.mobile.bodyLBold": "Noto Sans Kannada",
    "kn.mobile.bodyLLink": "Noto Sans Kannada",
    "kn.mobile.bodyM": "Noto Sans Kannada",
    "kn.mobile.bodyMBold": "Noto Sans Kannada",
    "kn.mobile.bodyMLink": "Noto Sans Kannada",
    "kn.mobile.bodyS": "Noto Sans Kannada",
    "kn.mobile.bodySBold": "Noto Sans Kannada",
    "kn.mobile.bodySLink": "Noto Sans Kannada",
    "kn.mobile.bodyXs": "Noto Sans Kannada",
    "kn.mobile.bodyXsBold": "Noto Sans Kannada",
    "kn.mobile.bodyXsLink": "Noto Sans Kannada",
    "kn.mobile.bodyXxs": "Noto Sans Kannada",
    "kn.mobile.bodyXxsBold": "Noto Sans Kannada",
    "kn.mobile.bodyXxsLink": "Noto Sans Kannada",
    "kn.mobile.body3xs": "Noto Sans Kannada",
    "kn.mobile.body3xsBold": "Noto Sans Kannada",
    "kn.mobile.body3xsLink": "Noto Sans Kannada",
    "kn.mobile.listTitle": "Noto Sans Kannada",
    "kn.mobile.button": "Noto Sans Kannada",
    "kn.mobile.code": "JetBrains Mono",
    "ml.desktop.headingXl": "Noto Sans Malayalam",
    "ml.desktop.headingL": "Noto Sans Malayalam",
    "ml.desktop.headingM": "Noto Sans Malayalam",
    "ml.desktop.headingS": "Noto Sans Malayalam",
    "ml.desktop.headingXs": "Noto Sans Malayalam",
    "ml.desktop.headingXxs": "Noto Sans Malayalam",
    "ml.desktop.overline": "Noto Sans Malayalam",
    "ml.desktop.bodyL": "Noto Sans Malayalam",
    "ml.desktop.bodyLBold": "Noto Sans Malayalam",
    "ml.desktop.bodyLLink": "Noto Sans Malayalam",
    "ml.desktop.bodyM": "Noto Sans Malayalam",
    "ml.desktop.bodyMBold": "Noto Sans Malayalam",
    "ml.desktop.bodyMLink": "Noto Sans Malayalam",
    "ml.desktop.bodyS": "Noto Sans Malayalam",
    "ml.desktop.bodySBold": "Noto Sans Malayalam",
    "ml.desktop.bodySLink": "Noto Sans Malayalam",
    "ml.desktop.bodyXs": "Noto Sans Malayalam",
    "ml.desktop.bodyXsBold": "Noto Sans Malayalam",
    "ml.desktop.bodyXsLink": "Noto Sans Malayalam",
    "ml.desktop.bodyXxs": "Noto Sans Malayalam",
    "ml.desktop.bodyXxsBold": "Noto Sans Malayalam",
    "ml.desktop.bodyXxsLink": "Noto Sans Malayalam",
    "ml.desktop.body3xs": "Noto Sans Malayalam",
    "ml.desktop.body3xsBold": "Noto Sans Malayalam",
    "ml.desktop.body3xsLink": "Noto Sans Malayalam",
    "ml.desktop.listTitle": "Noto Sans Malayalam",
    "ml.desktop.button": "Noto Sans Malayalam",
    "ml.desktop.code": "JetBrains Mono",
    "ml.mobile.headingXl": "Noto Sans Malayalam",
    "ml.mobile.headingL": "Noto Sans Malayalam",
    "ml.mobile.headingM": "Noto Sans Malayalam",
    "ml.mobile.headingS": "Noto Sans Malayalam",
    "ml.mobile.headingXs": "Noto Sans Malayalam",
    "ml.mobile.headingXxs": "Noto Sans Malayalam",
    "ml.mobile.overline": "Noto Sans Malayalam",
    "ml.mobile.bodyL": "Noto Sans Malayalam",
    "ml.mobile.bodyLBold": "Noto Sans Malayalam",
    "ml.mobile.bodyLLink": "Noto Sans Malayalam",
    "ml.mobile.bodyM": "Noto Sans Malayalam",
    "ml.mobile.bodyMBold": "Noto Sans Malayalam",
    "ml.mobile.bodyMLink": "Noto Sans Malayalam",
    "ml.mobile.bodyS": "Noto Sans Malayalam",
    "ml.mobile.bodySBold": "Noto Sans Malayalam",
    "ml.mobile.bodySLink": "Noto Sans Malayalam",
    "ml.mobile.bodyXs": "Noto Sans Malayalam",
    "ml.mobile.bodyXsBold": "Noto Sans Malayalam",
    "ml.mobile.bodyXsLink": "Noto Sans Malayalam",
    "ml.mobile.bodyXxs": "Noto Sans Malayalam",
    "ml.mobile.bodyXxsBold": "Noto Sans Malayalam",
    "ml.mobile.bodyXxsLink": "Noto Sans Malayalam",
    "ml.mobile.body3xs": "Noto Sans Malayalam",
    "ml.mobile.body3xsBold": "Noto Sans Malayalam",
    "ml.mobile.body3xsLink": "Noto Sans Malayalam",
    "ml.mobile.listTitle": "Noto Sans Malayalam",
    "ml.mobile.button": "Noto Sans Malayalam",
    "ml.mobile.code": "JetBrains Mono",
    "mr.desktop.headingXl": "Noto Sans",
    "mr.desktop.headingL": "Noto Sans",
    "mr.desktop.headingM": "Noto Sans",
    "mr.desktop.headingS": "Noto Sans",
    "mr.desktop.headingXs": "Noto Sans",
    "mr.desktop.headingXxs": "Noto Sans",
    "mr.desktop.overline": "Noto Sans",
    "mr.desktop.bodyL": "Noto Sans",
    "mr.desktop.bodyLBold": "Noto Sans",
    "mr.desktop.bodyLLink": "Noto Sans",
    "mr.desktop.bodyM": "Noto Sans",
    "mr.desktop.bodyMBold": "Noto Sans",
    "mr.desktop.bodyMLink": "Noto Sans",
    "mr.desktop.bodyS": "Noto Sans",
    "mr.desktop.bodySBold": "Noto Sans",
    "mr.desktop.bodySLink": "Noto Sans",
    "mr.desktop.bodyXs": "Noto Sans",
    "mr.desktop.bodyXsBold": "Noto Sans",
    "mr.desktop.bodyXsLink": "Noto Sans",
    "mr.desktop.bodyXxs": "Noto Sans",
    "mr.desktop.bodyXxsBold": "Noto Sans",
    "mr.desktop.bodyXxsLink": "Noto Sans",
    "mr.desktop.body3xs": "Noto Sans",
    "mr.desktop.body3xsBold": "Noto Sans",
    "mr.desktop.body3xsLink": "Noto Sans",
    "mr.desktop.listTitle": "Noto Sans",
    "mr.desktop.button": "Noto Sans",
    "mr.desktop.code": "JetBrains Mono",
    "mr.mobile.headingXl": "Noto Sans",
    "mr.mobile.headingL": "Noto Sans",
    "mr.mobile.headingM": "Noto Sans",
    "mr.mobile.headingS": "Noto Sans",
    "mr.mobile.headingXs": "Noto Sans",
    "mr.mobile.headingXxs": "Noto Sans",
    "mr.mobile.overline": "Noto Sans Oriya",
    "mr.mobile.bodyL": "Noto Sans",
    "mr.mobile.bodyLBold": "Noto Sans",
    "mr.mobile.bodyLLink": "Noto Sans",
    "mr.mobile.bodyM": "Noto Sans",
    "mr.mobile.bodyMBold": "Noto Sans",
    "mr.mobile.bodyMLink": "Noto Sans",
    "mr.mobile.bodyS": "Noto Sans",
    "mr.mobile.bodySBold": "Noto Sans",
    "mr.mobile.bodySLink": "Noto Sans",
    "mr.mobile.bodyXs": "Noto Sans",
    "mr.mobile.bodyXsBold": "Noto Sans",
    "mr.mobile.bodyXsLink": "Noto Sans",
    "mr.mobile.bodyXxs": "Noto Sans",
    "mr.mobile.bodyXxsBold": "Noto Sans",
    "mr.mobile.bodyXxsLink": "Noto Sans",
    "mr.mobile.body3xs": "Noto Sans",
    "mr.mobile.body3xsBold": "Noto Sans",
    "mr.mobile.body3xsLink": "Noto Sans",
    "mr.mobile.listTitle": "Noto Sans",
    "mr.mobile.button": "Noto Sans",
    "mr.mobile.code": "JetBrains Mono",
    "or.desktop.headingXl": "Noto Sans Oriya",
    "or.desktop.headingL": "Noto Sans Oriya",
    "or.desktop.headingM": "Noto Sans Oriya",
    "or.desktop.headingS": "Noto Sans Oriya",
    "or.desktop.headingXs": "Noto Sans Oriya",
    "or.desktop.headingXxs": "Noto Sans Oriya",
    "or.desktop.overline": "Noto Sans Oriya",
    "or.desktop.bodyL": "Noto Sans Oriya",
    "or.desktop.bodyLBold": "Noto Sans Oriya",
    "or.desktop.bodyLLink": "Noto Sans Oriya",
    "or.desktop.bodyM": "Noto Sans Oriya",
    "or.desktop.bodyMBold": "Noto Sans Oriya",
    "or.desktop.bodyMLink": "Noto Sans Oriya",
    "or.desktop.bodyS": "Noto Sans Oriya",
    "or.desktop.bodySBold": "Noto Sans Oriya",
    "or.desktop.bodySLink": "Noto Sans Oriya",
    "or.desktop.bodyXs": "Noto Sans Oriya",
    "or.desktop.bodyXsBold": "Noto Sans Oriya",
    "or.desktop.bodyXsLink": "Noto Sans Oriya",
    "or.desktop.bodyXxs": "Noto Sans Oriya",
    "or.desktop.bodyXxsBold": "Noto Sans Oriya",
    "or.desktop.bodyXxsLink": "Noto Sans Oriya",
    "or.desktop.body3xs": "Noto Sans Oriya",
    "or.desktop.body3xsBold": "Noto Sans Oriya",
    "or.desktop.body3xsLink": "Noto Sans Oriya",
    "or.desktop.listTitle": "Noto Sans Oriya",
    "or.desktop.button": "Noto Sans Oriya",
    "or.desktop.code": "JetBrains Mono",
    "or.mobile.headingXl": "Noto Sans Oriya",
    "or.mobile.headingL": "Noto Sans Oriya",
    "or.mobile.headingM": "Noto Sans Oriya",
    "or.mobile.headingS": "Noto Sans Oriya",
    "or.mobile.headingXs": "Noto Sans Oriya",
    "or.mobile.headingXxs": "Noto Sans Oriya",
    "or.mobile.overline": "Noto Sans Oriya",
    "or.mobile.bodyL": "Noto Sans Oriya",
    "or.mobile.bodyLBold": "Noto Sans Oriya",
    "or.mobile.bodyLLink": "Noto Sans Oriya",
    "or.mobile.bodyM": "Noto Sans Oriya",
    "or.mobile.bodyMBold": "Noto Sans Oriya",
    "or.mobile.bodyMLink": "Noto Sans Oriya",
    "or.mobile.bodyS": "Noto Sans Oriya",
    "or.mobile.bodySBold": "Noto Sans Oriya",
    "or.mobile.bodySLink": "Noto Sans Oriya",
    "or.mobile.bodyXs": "Noto Sans Oriya",
    "or.mobile.bodyXsBold": "Noto Sans Oriya",
    "or.mobile.bodyXsLink": "Noto Sans Oriya",
    "or.mobile.bodyXxs": "Noto Sans Oriya",
    "or.mobile.bodyXxsBold": "Noto Sans Oriya",
    "or.mobile.bodyXxsLink": "Noto Sans Oriya",
    "or.mobile.body3xs": "Noto Sans Oriya",
    "or.mobile.body3xsBold": "Noto Sans Oriya",
    "or.mobile.body3xsLink": "Noto Sans Oriya",
    "or.mobile.listTitle": "Noto Sans Oriya",
    "or.mobile.button": "Noto Sans Oriya",
    "or.mobile.code": "JetBrains Mono",
    "pa.desktop.headingXl": "Noto Sans Gurmukhi",
    "pa.desktop.headingL": "Noto Sans Gurmukhi",
    "pa.desktop.headingM": "Noto Sans Gurmukhi",
    "pa.desktop.headingS": "Noto Sans Gurmukhi",
    "pa.desktop.headingXs": "Noto Sans Gurmukhi",
    "pa.desktop.headingXxs": "Noto Sans Gurmukhi",
    "pa.desktop.overline": "Noto Sans Gurmukhi",
    "pa.desktop.bodyL": "Noto Sans Gurmukhi",
    "pa.desktop.bodyLBold": "Noto Sans Gurmukhi",
    "pa.desktop.bodyLLink": "Noto Sans Gurmukhi",
    "pa.desktop.bodyM": "Noto Sans Gurmukhi",
    "pa.desktop.bodyMBold": "Noto Sans Gurmukhi",
    "pa.desktop.bodyMLink": "Noto Sans Gurmukhi",
    "pa.desktop.bodyS": "Noto Sans Gurmukhi",
    "pa.desktop.bodySBold": "Noto Sans Gurmukhi",
    "pa.desktop.bodySLink": "Noto Sans Gurmukhi",
    "pa.desktop.bodyXs": "Noto Sans Gurmukhi",
    "pa.desktop.bodyXsBold": "Noto Sans Gurmukhi",
    "pa.desktop.bodyXsLink": "Noto Sans Gurmukhi",
    "pa.desktop.bodyXxs": "Noto Sans Gurmukhi",
    "pa.desktop.bodyXxsBold": "Noto Sans Gurmukhi",
    "pa.desktop.bodyXxsLink": "Noto Sans Gurmukhi",
    "pa.desktop.body3xs": "Noto Sans Gurmukhi",
    "pa.desktop.body3xsBold": "Noto Sans Gurmukhi",
    "pa.desktop.body3xsLink": "Noto Sans Gurmukhi",
    "pa.desktop.listTitle": "Noto Sans Gurmukhi",
    "pa.desktop.button": "Noto Sans Gurmukhi",
    "pa.desktop.code": "JetBrains Mono",
    "pa.mobile.headingXl": "Noto Sans Gurmukhi",
    "pa.mobile.headingL": "Noto Sans Gurmukhi",
    "pa.mobile.headingM": "Noto Sans Gurmukhi",
    "pa.mobile.headingS": "Noto Sans Gurmukhi",
    "pa.mobile.headingXs": "Noto Sans Gurmukhi",
    "pa.mobile.headingXxs": "Noto Sans Gurmukhi",
    "pa.mobile.overline": "Noto Sans Gurmukhi",
    "pa.mobile.bodyL": "Noto Sans Gurmukhi",
    "pa.mobile.bodyLBold": "Noto Sans Gurmukhi",
    "pa.mobile.bodyLLink": "Noto Sans Gurmukhi",
    "pa.mobile.bodyM": "Noto Sans Gurmukhi",
    "pa.mobile.bodyMBold": "Noto Sans Gurmukhi",
    "pa.mobile.bodyMLink": "Noto Sans Gurmukhi",
    "pa.mobile.bodyS": "Noto Sans Gurmukhi",
    "pa.mobile.bodySBold": "Noto Sans Gurmukhi",
    "pa.mobile.bodySLink": "Noto Sans Gurmukhi",
    "pa.mobile.bodyXs": "Noto Sans Gurmukhi",
    "pa.mobile.bodyXsBold": "Noto Sans Gurmukhi",
    "pa.mobile.bodyXsLink": "Noto Sans Gurmukhi",
    "pa.mobile.bodyXxs": "Noto Sans Gurmukhi",
    "pa.mobile.bodyXxsBold": "Noto Sans Gurmukhi",
    "pa.mobile.bodyXxsLink": "Noto Sans Gurmukhi",
    "pa.mobile.body3xs": "Noto Sans Gurmukhi",
    "pa.mobile.body3xsBold": "Noto Sans Gurmukhi",
    "pa.mobile.body3xsLink": "Noto Sans Gurmukhi",
    "pa.mobile.listTitle": "Noto Sans Gurmukhi",
    "pa.mobile.button": "Noto Sans Gurmukhi",
    "pa.mobile.code": "JetBrains Mono",
    "ta.desktop.headingXl": "Noto Sans Tamil",
    "ta.desktop.headingL": "Noto Sans Tamil",
    "ta.desktop.headingM": "Noto Sans Tamil",
    "ta.desktop.headingS": "Noto Sans Tamil",
    "ta.desktop.headingXs": "Noto Sans Tamil",
    "ta.desktop.headingXxs": "Noto Sans Tamil",
    "ta.desktop.overline": "Noto Sans Tamil",
    "ta.desktop.bodyL": "Noto Sans Tamil",
    "ta.desktop.bodyLBold": "Noto Sans Tamil",
    "ta.desktop.bodyLLink": "Noto Sans Tamil",
    "ta.desktop.bodyM": "Noto Sans Tamil",
    "ta.desktop.bodyMBold": "Noto Sans Tamil",
    "ta.desktop.bodyMLink": "Noto Sans Tamil",
    "ta.desktop.bodyS": "Noto Sans Tamil",
    "ta.desktop.bodySBold": "Noto Sans Tamil",
    "ta.desktop.bodySLink": "Noto Sans Tamil",
    "ta.desktop.bodyXs": "Noto Sans Tamil",
    "ta.desktop.bodyXsBold": "Noto Sans Tamil",
    "ta.desktop.bodyXsLink": "Noto Sans Tamil",
    "ta.desktop.bodyXxs": "Noto Sans Tamil",
    "ta.desktop.bodyXxsBold": "Noto Sans Tamil",
    "ta.desktop.bodyXxsLink": "Noto Sans Tamil",
    "ta.desktop.body3xs": "Noto Sans Tamil",
    "ta.desktop.body3xsBold": "Noto Sans Tamil",
    "ta.desktop.body3xsLink": "Noto Sans Tamil",
    "ta.desktop.listTitle": "Noto Sans Tamil",
    "ta.desktop.button": "Noto Sans Tamil",
    "ta.desktop.code": "JetBrains Mono",
    "ta.mobile.headingXl": "Noto Sans Tamil",
    "ta.mobile.headingL": "Noto Sans Tamil",
    "ta.mobile.headingM": "Noto Sans Tamil",
    "ta.mobile.headingS": "Noto Sans Tamil",
    "ta.mobile.headingXs": "Noto Sans Tamil",
    "ta.mobile.headingXxs": "Noto Sans Tamil",
    "ta.mobile.overline": "Noto Sans Tamil",
    "ta.mobile.bodyL": "Noto Sans Tamil",
    "ta.mobile.bodyLBold": "Noto Sans Tamil",
    "ta.mobile.bodyLLink": "Noto Sans Tamil",
    "ta.mobile.bodyM": "Noto Sans Tamil",
    "ta.mobile.bodyMBold": "Noto Sans Tamil",
    "ta.mobile.bodyMLink": "Noto Sans Tamil",
    "ta.mobile.bodyS": "Noto Sans Tamil",
    "ta.mobile.bodySBold": "Noto Sans Tamil",
    "ta.mobile.bodySLink": "Noto Sans Tamil",
    "ta.mobile.bodyXs": "Noto Sans Tamil",
    "ta.mobile.bodyXsBold": "Noto Sans Tamil",
    "ta.mobile.bodyXsLink": "Noto Sans Tamil",
    "ta.mobile.bodyXxs": "Noto Sans Tamil",
    "ta.mobile.bodyXxsBold": "Noto Sans Tamil",
    "ta.mobile.bodyXxsLink": "Noto Sans Tamil",
    "ta.mobile.body3xs": "Noto Sans Tamil",
    "ta.mobile.body3xsBold": "Noto Sans Tamil",
    "ta.mobile.body3xsLink": "Noto Sans Tamil",
    "ta.mobile.listTitle": "Noto Sans Tamil",
    "ta.mobile.button": "Noto Sans Tamil",
    "ta.mobile.code": "JetBrains Mono",
    "te.desktop.headingXl": "Noto Sans Telugu",
    "te.desktop.headingL": "Noto Sans Telugu",
    "te.desktop.headingM": "Noto Sans Telugu",
    "te.desktop.headingS": "Noto Sans Telugu",
    "te.desktop.headingXs": "Noto Sans Telugu",
    "te.desktop.headingXxs": "Noto Sans Telugu",
    "te.desktop.overline": "Noto Sans Telugu",
    "te.desktop.bodyL": "Noto Sans Telugu",
    "te.desktop.bodyLBold": "Noto Sans Telugu",
    "te.desktop.bodyLLink": "Noto Sans Telugu",
    "te.desktop.bodyM": "Noto Sans Telugu",
    "te.desktop.bodyMBold": "Noto Sans Telugu",
    "te.desktop.bodyMLink": "Noto Sans Telugu",
    "te.desktop.bodyS": "Noto Sans Telugu",
    "te.desktop.bodySBold": "Noto Sans Telugu",
    "te.desktop.bodySLink": "Noto Sans Telugu",
    "te.desktop.bodyXs": "Noto Sans Telugu",
    "te.desktop.bodyXsBold": "Noto Sans Telugu",
    "te.desktop.bodyXsLink": "Noto Sans Telugu",
    "te.desktop.bodyXxs": "Noto Sans Telugu",
    "te.desktop.bodyXxsBold": "Noto Sans Telugu",
    "te.desktop.bodyXxsLink": "Noto Sans Telugu",
    "te.desktop.body3xs": "Noto Sans Telugu",
    "te.desktop.body3xsBold": "Noto Sans Telugu",
    "te.desktop.body3xsLink": "Noto Sans Telugu",
    "te.desktop.listTitle": "Noto Sans Telugu",
    "te.desktop.button": "Noto Sans Telugu",
    "te.desktop.code": "JetBrains Mono",
    "te.mobile.headingXl": "Noto Sans Telugu",
    "te.mobile.headingL": "Noto Sans Telugu",
    "te.mobile.headingM": "Noto Sans Telugu",
    "te.mobile.headingS": "Noto Sans Telugu",
    "te.mobile.headingXs": "Noto Sans Telugu",
    "te.mobile.headingXxs": "Noto Sans Telugu",
    "te.mobile.overline": "Noto Sans Telugu",
    "te.mobile.bodyL": "Noto Sans Telugu",
    "te.mobile.bodyLBold": "Noto Sans Telugu",
    "te.mobile.bodyLLink": "Noto Sans Telugu",
    "te.mobile.bodyM": "Noto Sans Telugu",
    "te.mobile.bodyMBold": "Noto Sans Telugu",
    "te.mobile.bodyMLink": "Noto Sans Telugu",
    "te.mobile.bodyS": "Noto Sans Telugu",
    "te.mobile.bodySBold": "Noto Sans Telugu",
    "te.mobile.bodySLink": "Noto Sans Telugu",
    "te.mobile.bodyXs": "Noto Sans Telugu",
    "te.mobile.bodyXsBold": "Noto Sans Telugu",
    "te.mobile.bodyXsLink": "Noto Sans Telugu",
    "te.mobile.bodyXxs": "Noto Sans Telugu",
    "te.mobile.bodyXxsBold": "Noto Sans Telugu",
    "te.mobile.bodyXxsLink": "Noto Sans Telugu",
    "te.mobile.body3xs": "Noto Sans Telugu",
    "te.mobile.body3xsBold": "Noto Sans Telugu",
    "te.mobile.body3xsLink": "Noto Sans Telugu",
    "te.mobile.listTitle": "Noto Sans Telugu",
    "te.mobile.button": "Noto Sans Telugu",
    "te.mobile.code": "JetBrains Mono",
    headingXl: $e3613f6017c674c5$var$headingXl$4,
    headingL: $e3613f6017c674c5$var$headingL$4,
    headingM: $e3613f6017c674c5$var$headingM$4,
    headingS: $e3613f6017c674c5$var$headingS$4,
    headingXs: $e3613f6017c674c5$var$headingXs$4,
    headingXxs: $e3613f6017c674c5$var$headingXxs$4,
    overline: $e3613f6017c674c5$var$overline$5,
    bodyL: $e3613f6017c674c5$var$bodyL$4,
    bodyLBold: $e3613f6017c674c5$var$bodyLBold$4,
    bodyLLink: $e3613f6017c674c5$var$bodyLLink$4,
    bodyM: $e3613f6017c674c5$var$bodyM$4,
    bodyMBold: $e3613f6017c674c5$var$bodyMBold$4,
    bodyMLink: $e3613f6017c674c5$var$bodyMLink$4,
    bodyS: $e3613f6017c674c5$var$bodyS$4,
    bodySBold: $e3613f6017c674c5$var$bodySBold$4,
    bodySLink: $e3613f6017c674c5$var$bodySLink$4,
    bodyXs: $e3613f6017c674c5$var$bodyXs$4,
    bodyXsBold: $e3613f6017c674c5$var$bodyXsBold$4,
    bodyXsLink: $e3613f6017c674c5$var$bodyXsLink$4,
    bodyXxs: $e3613f6017c674c5$var$bodyXxs$4,
    bodyXxsBold: $e3613f6017c674c5$var$bodyXxsBold$4,
    bodyXxsLink: $e3613f6017c674c5$var$bodyXxsLink$4,
    body3xs: $e3613f6017c674c5$var$body3xs$4,
    body3xsBold: $e3613f6017c674c5$var$body3xsBold$4,
    body3xsLink: $e3613f6017c674c5$var$body3xsLink$4,
    listTitle: $e3613f6017c674c5$var$listTitle$4,
    button: $e3613f6017c674c5$var$button$4,
    code: $e3613f6017c674c5$var$code$4
};
const $e3613f6017c674c5$var$headingXl$3 = "{$lang.$platform.headingXl}";
const $e3613f6017c674c5$var$headingL$3 = "{$lang.$platform.headingL}";
const $e3613f6017c674c5$var$headingM$3 = "{$lang.$platform.headingM}";
const $e3613f6017c674c5$var$headingS$3 = "{$lang.$platform.headingS}";
const $e3613f6017c674c5$var$headingXs$3 = "{$lang.$platform.headingXs}";
const $e3613f6017c674c5$var$headingXxs$3 = "{$lang.$platform.headingXxs}";
const $e3613f6017c674c5$var$overline$4 = "{$lang.$platform.overline}";
const $e3613f6017c674c5$var$bodyL$3 = "{$lang.$platform.bodyL}";
const $e3613f6017c674c5$var$bodyLBold$3 = "{$lang.$platform.bodyLBold}";
const $e3613f6017c674c5$var$bodyLLink$3 = "{$lang.$platform.bodyLLink}";
const $e3613f6017c674c5$var$bodyM$3 = "{$lang.$platform.bodyM}";
const $e3613f6017c674c5$var$bodyMBold$3 = "{$lang.$platform.bodyMBold}";
const $e3613f6017c674c5$var$bodyMLink$3 = "{$lang.$platform.bodyMLink}";
const $e3613f6017c674c5$var$bodyS$3 = "{$lang.$platform.bodyS}";
const $e3613f6017c674c5$var$bodySBold$3 = "{$lang.$platform.bodySBold}";
const $e3613f6017c674c5$var$bodySLink$3 = "{$lang.$platform.bodySLink}";
const $e3613f6017c674c5$var$bodyXs$3 = "{$lang.$platform.bodyXs}";
const $e3613f6017c674c5$var$bodyXsBold$3 = "{$lang.$platform.bodyXsBold}";
const $e3613f6017c674c5$var$bodyXsLink$3 = "{$lang.$platform.bodyXsLink}";
const $e3613f6017c674c5$var$bodyXxs$3 = "{$lang.$platform.bodyXxs}";
const $e3613f6017c674c5$var$bodyXxsBold$3 = "{$lang.$platform.bodyXxsBold}";
const $e3613f6017c674c5$var$bodyXxsLink$3 = "{$lang.$platform.bodyXxsLink}";
const $e3613f6017c674c5$var$body3xs$3 = "{$lang.$platform.body3xs}";
const $e3613f6017c674c5$var$body3xsBold$3 = "{$lang.$platform.body3xsBold}";
const $e3613f6017c674c5$var$body3xsLink$3 = "{$lang.$platform.body3xsLink}";
const $e3613f6017c674c5$var$listTitle$3 = "{$lang.$platform.listTitle}";
const $e3613f6017c674c5$var$button$3 = "{$lang.$platform.button}";
const $e3613f6017c674c5$var$code$3 = "{$lang.$platform.code}";
const $e3613f6017c674c5$var$fontSizes = {
    "as.desktop.headingXl": 88,
    "as.desktop.headingL": 64,
    "as.desktop.headingM": 40,
    "as.desktop.headingS": 32,
    "as.desktop.headingXs": 24,
    "as.desktop.headingXxs": 16,
    "as.desktop.overline": 12,
    "as.desktop.bodyL": 24,
    "as.desktop.bodyLBold": 24,
    "as.desktop.bodyLLink": 24,
    "as.desktop.bodyM": 18,
    "as.desktop.bodyMBold": 18,
    "as.desktop.bodyMLink": 18,
    "as.desktop.bodyS": 16,
    "as.desktop.bodySBold": 16,
    "as.desktop.bodySLink": 16,
    "as.desktop.bodyXs": 14,
    "as.desktop.bodyXsBold": 14,
    "as.desktop.bodyXsLink": 14,
    "as.desktop.bodyXxs": 12,
    "as.desktop.bodyXxsBold": 12,
    "as.desktop.bodyXxsLink": 12,
    "as.desktop.body3xs": 11,
    "as.desktop.body3xsBold": 11,
    "as.desktop.body3xsLink": 11,
    "as.desktop.listTitle": 16,
    "as.desktop.button": 16,
    "as.desktop.code": 12,
    "as.mobile.headingXl": 64,
    "as.mobile.headingL": 48,
    "as.mobile.headingM": 40,
    "as.mobile.headingS": 32,
    "as.mobile.headingXs": 24,
    "as.mobile.headingXxs": 16,
    "as.mobile.overline": 12,
    "as.mobile.bodyL": 24,
    "as.mobile.bodyLBold": 24,
    "as.mobile.bodyLLink": 24,
    "as.mobile.bodyM": 18,
    "as.mobile.bodyMBold": 18,
    "as.mobile.bodyMLink": 18,
    "as.mobile.bodyS": 16,
    "as.mobile.bodySBold": 16,
    "as.mobile.bodySLink": 16,
    "as.mobile.bodyXs": 14,
    "as.mobile.bodyXsBold": 14,
    "as.mobile.bodyXsLink": 14,
    "as.mobile.bodyXxs": 12,
    "as.mobile.bodyXxsBold": 12,
    "as.mobile.bodyXxsLink": 12,
    "as.mobile.body3xs": 11,
    "as.mobile.body3xsBold": 11,
    "as.mobile.body3xsLink": 11,
    "as.mobile.listTitle": 16,
    "as.mobile.button": 16,
    "as.mobile.code": 12,
    "bn.desktop.headingXl": 88,
    "bn.desktop.headingL": 64,
    "bn.desktop.headingM": 40,
    "bn.desktop.headingS": 32,
    "bn.desktop.headingXs": 24,
    "bn.desktop.headingXxs": 16,
    "bn.desktop.overline": 12,
    "bn.desktop.bodyL": 24,
    "bn.desktop.bodyLBold": 24,
    "bn.desktop.bodyLLink": 24,
    "bn.desktop.bodyM": 18,
    "bn.desktop.bodyMBold": 18,
    "bn.desktop.bodyMLink": 18,
    "bn.desktop.bodyS": 16,
    "bn.desktop.bodySBold": 16,
    "bn.desktop.bodySLink": 16,
    "bn.desktop.bodyXs": 14,
    "bn.desktop.bodyXsBold": 14,
    "bn.desktop.bodyXsLink": 14,
    "bn.desktop.bodyXxs": 12,
    "bn.desktop.bodyXxsBold": 12,
    "bn.desktop.bodyXxsLink": 12,
    "bn.desktop.body3xs": 11,
    "bn.desktop.body3xsBold": 11,
    "bn.desktop.body3xsLink": 11,
    "bn.desktop.listTitle": 16,
    "bn.desktop.button": 16,
    "bn.desktop.code": 12,
    "bn.mobile.headingXl": 64,
    "bn.mobile.headingL": 48,
    "bn.mobile.headingM": 40,
    "bn.mobile.headingS": 32,
    "bn.mobile.headingXs": 24,
    "bn.mobile.headingXxs": 16,
    "bn.mobile.overline": 12,
    "bn.mobile.bodyL": 24,
    "bn.mobile.bodyLBold": 24,
    "bn.mobile.bodyLLink": 24,
    "bn.mobile.bodyM": 18,
    "bn.mobile.bodyMBold": 18,
    "bn.mobile.bodyMLink": 18,
    "bn.mobile.bodyS": 16,
    "bn.mobile.bodySBold": 16,
    "bn.mobile.bodySLink": 16,
    "bn.mobile.bodyXs": 14,
    "bn.mobile.bodyXsBold": 14,
    "bn.mobile.bodyXsLink": 14,
    "bn.mobile.bodyXxs": 12,
    "bn.mobile.bodyXxsBold": 12,
    "bn.mobile.bodyXxsLink": 12,
    "bn.mobile.body3xs": 11,
    "bn.mobile.body3xsBold": 11,
    "bn.mobile.body3xsLink": 11,
    "bn.mobile.listTitle": 16,
    "bn.mobile.button": 16,
    "bn.mobile.code": 12,
    "en.desktop.headingXl": 88,
    "en.desktop.headingL": 64,
    "en.desktop.headingM": 40,
    "en.desktop.headingS": 32,
    "en.desktop.headingXs": 24,
    "en.desktop.headingXxs": 16,
    "en.desktop.overline": 12,
    "en.desktop.bodyL": 24,
    "en.desktop.bodyLBold": 24,
    "en.desktop.bodyLLink": 24,
    "en.desktop.bodyM": 18,
    "en.desktop.bodyMBold": 18,
    "en.desktop.bodyMLink": 18,
    "en.desktop.bodyS": 16,
    "en.desktop.bodySBold": 16,
    "en.desktop.bodySLink": 16,
    "en.desktop.bodyXs": 14,
    "en.desktop.bodyXsBold": 14,
    "en.desktop.bodyXsLink": 14,
    "en.desktop.bodyXxs": 12,
    "en.desktop.bodyXxsBold": 12,
    "en.desktop.bodyXxsLink": 12,
    "en.desktop.body3xs": 11,
    "en.desktop.body3xsBold": 11,
    "en.desktop.body3xsLink": 11,
    "en.desktop.listTitle": 16,
    "en.desktop.button": 16,
    "en.desktop.code": 12,
    "en.mobile.headingXl": 64,
    "en.mobile.headingL": 48,
    "en.mobile.headingM": 40,
    "en.mobile.headingS": 32,
    "en.mobile.headingXs": 24,
    "en.mobile.headingXxs": 16,
    "en.mobile.overline": 12,
    "en.mobile.bodyL": 24,
    "en.mobile.bodyLBold": 24,
    "en.mobile.bodyLLink": 24,
    "en.mobile.bodyM": 18,
    "en.mobile.bodyMBold": 18,
    "en.mobile.bodyMLink": 18,
    "en.mobile.bodyS": 16,
    "en.mobile.bodySBold": 16,
    "en.mobile.bodySLink": 16,
    "en.mobile.bodyXs": 14,
    "en.mobile.bodyXsBold": 14,
    "en.mobile.bodyXsLink": 14,
    "en.mobile.bodyXxs": 12,
    "en.mobile.bodyXxsBold": 12,
    "en.mobile.bodyXxsLink": 12,
    "en.mobile.body3xs": 11,
    "en.mobile.body3xsBold": 11,
    "en.mobile.body3xsLink": 11,
    "en.mobile.listTitle": 16,
    "en.mobile.button": 16,
    "en.mobile.code": 12,
    "gu.desktop.headingXl": 88,
    "gu.desktop.headingL": 64,
    "gu.desktop.headingM": 40,
    "gu.desktop.headingS": 32,
    "gu.desktop.headingXs": 24,
    "gu.desktop.headingXxs": 16,
    "gu.desktop.overline": 12,
    "gu.desktop.bodyL": 24,
    "gu.desktop.bodyLBold": 24,
    "gu.desktop.bodyLLink": 24,
    "gu.desktop.bodyM": 18,
    "gu.desktop.bodyMBold": 18,
    "gu.desktop.bodyMLink": 18,
    "gu.desktop.bodyS": 16,
    "gu.desktop.bodySBold": 16,
    "gu.desktop.bodySLink": 16,
    "gu.desktop.bodyXs": 14,
    "gu.desktop.bodyXsBold": 14,
    "gu.desktop.bodyXsLink": 14,
    "gu.desktop.bodyXxs": 12,
    "gu.desktop.bodyXxsBold": 12,
    "gu.desktop.bodyXxsLink": 12,
    "gu.desktop.body3xs": 11,
    "gu.desktop.body3xsBold": 11,
    "gu.desktop.body3xsLink": 11,
    "gu.desktop.listTitle": 16,
    "gu.desktop.button": 16,
    "gu.desktop.code": 12,
    "gu.mobile.headingXl": 64,
    "gu.mobile.headingL": 48,
    "gu.mobile.headingM": 40,
    "gu.mobile.headingS": 32,
    "gu.mobile.headingXs": 24,
    "gu.mobile.headingXxs": 16,
    "gu.mobile.overline": 12,
    "gu.mobile.bodyL": 24,
    "gu.mobile.bodyLBold": 24,
    "gu.mobile.bodyLLink": 24,
    "gu.mobile.bodyM": 18,
    "gu.mobile.bodyMBold": 18,
    "gu.mobile.bodyMLink": 18,
    "gu.mobile.bodyS": 16,
    "gu.mobile.bodySBold": 16,
    "gu.mobile.bodySLink": 16,
    "gu.mobile.bodyXs": 14,
    "gu.mobile.bodyXsBold": 14,
    "gu.mobile.bodyXsLink": 14,
    "gu.mobile.bodyXxs": 12,
    "gu.mobile.bodyXxsBold": 12,
    "gu.mobile.bodyXxsLink": 12,
    "gu.mobile.body3xs": 11,
    "gu.mobile.body3xsBold": 11,
    "gu.mobile.body3xsLink": 11,
    "gu.mobile.listTitle": 16,
    "gu.mobile.button": 16,
    "gu.mobile.code": 12,
    "hi.desktop.headingXl": 88,
    "hi.desktop.headingL": 64,
    "hi.desktop.headingM": 40,
    "hi.desktop.headingS": 32,
    "hi.desktop.headingXs": 24,
    "hi.desktop.headingXxs": 16,
    "hi.desktop.overline": 12,
    "hi.desktop.bodyL": 24,
    "hi.desktop.bodyLBold": 24,
    "hi.desktop.bodyLLink": 24,
    "hi.desktop.bodyM": 18,
    "hi.desktop.bodyMBold": 18,
    "hi.desktop.bodyMLink": 18,
    "hi.desktop.bodyS": 16,
    "hi.desktop.bodySBold": 16,
    "hi.desktop.bodySLink": 16,
    "hi.desktop.bodyXs": 14,
    "hi.desktop.bodyXsBold": 14,
    "hi.desktop.bodyXsLink": 14,
    "hi.desktop.bodyXxs": 12,
    "hi.desktop.bodyXxsBold": 12,
    "hi.desktop.bodyXxsLink": 12,
    "hi.desktop.body3xs": 11,
    "hi.desktop.body3xsBold": 11,
    "hi.desktop.body3xsLink": 11,
    "hi.desktop.listTitle": 16,
    "hi.desktop.button": 16,
    "hi.desktop.code": 12,
    "hi.mobile.headingXl": 64,
    "hi.mobile.headingL": 48,
    "hi.mobile.headingM": 40,
    "hi.mobile.headingS": 32,
    "hi.mobile.headingXs": 24,
    "hi.mobile.headingXxs": 16,
    "hi.mobile.overline": 12,
    "hi.mobile.bodyL": 24,
    "hi.mobile.bodyLBold": 24,
    "hi.mobile.bodyLLink": 24,
    "hi.mobile.bodyM": 18,
    "hi.mobile.bodyMBold": 18,
    "hi.mobile.bodyMLink": 18,
    "hi.mobile.bodyS": 16,
    "hi.mobile.bodySBold": 16,
    "hi.mobile.bodySLink": 16,
    "hi.mobile.bodyXs": 14,
    "hi.mobile.bodyXsBold": 14,
    "hi.mobile.bodyXsLink": 14,
    "hi.mobile.bodyXxs": 12,
    "hi.mobile.bodyXxsBold": 12,
    "hi.mobile.bodyXxsLink": 12,
    "hi.mobile.body3xs": 11,
    "hi.mobile.body3xsBold": 11,
    "hi.mobile.body3xsLink": 11,
    "hi.mobile.listTitle": 16,
    "hi.mobile.button": 16,
    "hi.mobile.code": 12,
    "kn.desktop.headingXl": 88,
    "kn.desktop.headingL": 64,
    "kn.desktop.headingM": 40,
    "kn.desktop.headingS": 32,
    "kn.desktop.headingXs": 24,
    "kn.desktop.headingXxs": 16,
    "kn.desktop.overline": 12,
    "kn.desktop.bodyL": 24,
    "kn.desktop.bodyLBold": 24,
    "kn.desktop.bodyLLink": 24,
    "kn.desktop.bodyM": 18,
    "kn.desktop.bodyMBold": 18,
    "kn.desktop.bodyMLink": 18,
    "kn.desktop.bodyS": 16,
    "kn.desktop.bodySBold": 16,
    "kn.desktop.bodySLink": 16,
    "kn.desktop.bodyXs": 14,
    "kn.desktop.bodyXsBold": 14,
    "kn.desktop.bodyXsLink": 14,
    "kn.desktop.bodyXxs": 12,
    "kn.desktop.bodyXxsBold": 12,
    "kn.desktop.bodyXxsLink": 12,
    "kn.desktop.body3xs": 11,
    "kn.desktop.body3xsBold": 11,
    "kn.desktop.body3xsLink": 11,
    "kn.desktop.listTitle": 16,
    "kn.desktop.button": 16,
    "kn.desktop.code": 12,
    "kn.mobile.headingXl": 64,
    "kn.mobile.headingL": 48,
    "kn.mobile.headingM": 40,
    "kn.mobile.headingS": 32,
    "kn.mobile.headingXs": 24,
    "kn.mobile.headingXxs": 16,
    "kn.mobile.overline": 12,
    "kn.mobile.bodyL": 24,
    "kn.mobile.bodyLBold": 24,
    "kn.mobile.bodyLLink": 24,
    "kn.mobile.bodyM": 18,
    "kn.mobile.bodyMBold": 18,
    "kn.mobile.bodyMLink": 18,
    "kn.mobile.bodyS": 16,
    "kn.mobile.bodySBold": 16,
    "kn.mobile.bodySLink": 16,
    "kn.mobile.bodyXs": 14,
    "kn.mobile.bodyXsBold": 14,
    "kn.mobile.bodyXsLink": 14,
    "kn.mobile.bodyXxs": 12,
    "kn.mobile.bodyXxsBold": 12,
    "kn.mobile.bodyXxsLink": 12,
    "kn.mobile.body3xs": 11,
    "kn.mobile.body3xsBold": 11,
    "kn.mobile.body3xsLink": 11,
    "kn.mobile.listTitle": 16,
    "kn.mobile.button": 16,
    "kn.mobile.code": 12,
    "ml.desktop.headingXl": 88,
    "ml.desktop.headingL": 64,
    "ml.desktop.headingM": 40,
    "ml.desktop.headingS": 32,
    "ml.desktop.headingXs": 24,
    "ml.desktop.headingXxs": 16,
    "ml.desktop.overline": 12,
    "ml.desktop.bodyL": 24,
    "ml.desktop.bodyLBold": 24,
    "ml.desktop.bodyLLink": 24,
    "ml.desktop.bodyM": 18,
    "ml.desktop.bodyMBold": 18,
    "ml.desktop.bodyMLink": 18,
    "ml.desktop.bodyS": 16,
    "ml.desktop.bodySBold": 16,
    "ml.desktop.bodySLink": 16,
    "ml.desktop.bodyXs": 14,
    "ml.desktop.bodyXsBold": 14,
    "ml.desktop.bodyXsLink": 14,
    "ml.desktop.bodyXxs": 12,
    "ml.desktop.bodyXxsBold": 12,
    "ml.desktop.bodyXxsLink": 12,
    "ml.desktop.body3xs": 11,
    "ml.desktop.body3xsBold": 11,
    "ml.desktop.body3xsLink": 11,
    "ml.desktop.listTitle": 16,
    "ml.desktop.button": 16,
    "ml.desktop.code": 12,
    "ml.mobile.headingXl": 64,
    "ml.mobile.headingL": 48,
    "ml.mobile.headingM": 40,
    "ml.mobile.headingS": 32,
    "ml.mobile.headingXs": 24,
    "ml.mobile.headingXxs": 16,
    "ml.mobile.overline": 12,
    "ml.mobile.bodyL": 24,
    "ml.mobile.bodyLBold": 24,
    "ml.mobile.bodyLLink": 24,
    "ml.mobile.bodyM": 18,
    "ml.mobile.bodyMBold": 18,
    "ml.mobile.bodyMLink": 18,
    "ml.mobile.bodyS": 16,
    "ml.mobile.bodySBold": 16,
    "ml.mobile.bodySLink": 16,
    "ml.mobile.bodyXs": 14,
    "ml.mobile.bodyXsBold": 14,
    "ml.mobile.bodyXsLink": 14,
    "ml.mobile.bodyXxs": 12,
    "ml.mobile.bodyXxsBold": 12,
    "ml.mobile.bodyXxsLink": 12,
    "ml.mobile.body3xs": 11,
    "ml.mobile.body3xsBold": 11,
    "ml.mobile.body3xsLink": 11,
    "ml.mobile.listTitle": 16,
    "ml.mobile.button": 16,
    "ml.mobile.code": 12,
    "mr.desktop.headingXl": 88,
    "mr.desktop.headingL": 64,
    "mr.desktop.headingM": 40,
    "mr.desktop.headingS": 32,
    "mr.desktop.headingXs": 24,
    "mr.desktop.headingXxs": 16,
    "mr.desktop.overline": 12,
    "mr.desktop.bodyL": 24,
    "mr.desktop.bodyLBold": 24,
    "mr.desktop.bodyLLink": 24,
    "mr.desktop.bodyM": 18,
    "mr.desktop.bodyMBold": 18,
    "mr.desktop.bodyMLink": 18,
    "mr.desktop.bodyS": 16,
    "mr.desktop.bodySBold": 16,
    "mr.desktop.bodySLink": 16,
    "mr.desktop.bodyXs": 14,
    "mr.desktop.bodyXsBold": 14,
    "mr.desktop.bodyXsLink": 14,
    "mr.desktop.bodyXxs": 12,
    "mr.desktop.bodyXxsBold": 12,
    "mr.desktop.bodyXxsLink": 12,
    "mr.desktop.body3xs": 11,
    "mr.desktop.body3xsBold": 11,
    "mr.desktop.body3xsLink": 11,
    "mr.desktop.listTitle": 16,
    "mr.desktop.button": 16,
    "mr.desktop.code": 12,
    "mr.mobile.headingXl": 64,
    "mr.mobile.headingL": 48,
    "mr.mobile.headingM": 40,
    "mr.mobile.headingS": 32,
    "mr.mobile.headingXs": 24,
    "mr.mobile.headingXxs": 16,
    "mr.mobile.overline": 12,
    "mr.mobile.bodyL": 24,
    "mr.mobile.bodyLBold": 24,
    "mr.mobile.bodyLLink": 24,
    "mr.mobile.bodyM": 18,
    "mr.mobile.bodyMBold": 18,
    "mr.mobile.bodyMLink": 18,
    "mr.mobile.bodyS": 16,
    "mr.mobile.bodySBold": 16,
    "mr.mobile.bodySLink": 16,
    "mr.mobile.bodyXs": 14,
    "mr.mobile.bodyXsBold": 14,
    "mr.mobile.bodyXsLink": 14,
    "mr.mobile.bodyXxs": 12,
    "mr.mobile.bodyXxsBold": 12,
    "mr.mobile.bodyXxsLink": 12,
    "mr.mobile.body3xs": 11,
    "mr.mobile.body3xsBold": 11,
    "mr.mobile.body3xsLink": 11,
    "mr.mobile.listTitle": 16,
    "mr.mobile.button": 16,
    "mr.mobile.code": 12,
    "or.desktop.headingXl": 88,
    "or.desktop.headingL": 64,
    "or.desktop.headingM": 40,
    "or.desktop.headingS": 32,
    "or.desktop.headingXs": 24,
    "or.desktop.headingXxs": 16,
    "or.desktop.overline": 12,
    "or.desktop.bodyL": 24,
    "or.desktop.bodyLBold": 24,
    "or.desktop.bodyLLink": 24,
    "or.desktop.bodyM": 18,
    "or.desktop.bodyMBold": 18,
    "or.desktop.bodyMLink": 18,
    "or.desktop.bodyS": 16,
    "or.desktop.bodySBold": 16,
    "or.desktop.bodySLink": 16,
    "or.desktop.bodyXs": 14,
    "or.desktop.bodyXsBold": 14,
    "or.desktop.bodyXsLink": 14,
    "or.desktop.bodyXxs": 12,
    "or.desktop.bodyXxsBold": 12,
    "or.desktop.bodyXxsLink": 12,
    "or.desktop.body3xs": 11,
    "or.desktop.body3xsBold": 11,
    "or.desktop.body3xsLink": 11,
    "or.desktop.listTitle": 16,
    "or.desktop.button": 16,
    "or.desktop.code": 12,
    "or.mobile.headingXl": 64,
    "or.mobile.headingL": 48,
    "or.mobile.headingM": 40,
    "or.mobile.headingS": 32,
    "or.mobile.headingXs": 24,
    "or.mobile.headingXxs": 16,
    "or.mobile.overline": 12,
    "or.mobile.bodyL": 24,
    "or.mobile.bodyLBold": 24,
    "or.mobile.bodyLLink": 24,
    "or.mobile.bodyM": 18,
    "or.mobile.bodyMBold": 18,
    "or.mobile.bodyMLink": 18,
    "or.mobile.bodyS": 16,
    "or.mobile.bodySBold": 16,
    "or.mobile.bodySLink": 16,
    "or.mobile.bodyXs": 14,
    "or.mobile.bodyXsBold": 14,
    "or.mobile.bodyXsLink": 14,
    "or.mobile.bodyXxs": 12,
    "or.mobile.bodyXxsBold": 12,
    "or.mobile.bodyXxsLink": 12,
    "or.mobile.body3xs": 11,
    "or.mobile.body3xsBold": 11,
    "or.mobile.body3xsLink": 11,
    "or.mobile.listTitle": 16,
    "or.mobile.button": 16,
    "or.mobile.code": 12,
    "pa.desktop.headingXl": 88,
    "pa.desktop.headingL": 64,
    "pa.desktop.headingM": 40,
    "pa.desktop.headingS": 32,
    "pa.desktop.headingXs": 24,
    "pa.desktop.headingXxs": 16,
    "pa.desktop.overline": 12,
    "pa.desktop.bodyL": 24,
    "pa.desktop.bodyLBold": 24,
    "pa.desktop.bodyLLink": 24,
    "pa.desktop.bodyM": 18,
    "pa.desktop.bodyMBold": 18,
    "pa.desktop.bodyMLink": 18,
    "pa.desktop.bodyS": 16,
    "pa.desktop.bodySBold": 16,
    "pa.desktop.bodySLink": 16,
    "pa.desktop.bodyXs": 14,
    "pa.desktop.bodyXsBold": 14,
    "pa.desktop.bodyXsLink": 14,
    "pa.desktop.bodyXxs": 12,
    "pa.desktop.bodyXxsBold": 12,
    "pa.desktop.bodyXxsLink": 12,
    "pa.desktop.body3xs": 11,
    "pa.desktop.body3xsBold": 11,
    "pa.desktop.body3xsLink": 11,
    "pa.desktop.listTitle": 16,
    "pa.desktop.button": 16,
    "pa.desktop.code": 12,
    "pa.mobile.headingXl": 64,
    "pa.mobile.headingL": 48,
    "pa.mobile.headingM": 40,
    "pa.mobile.headingS": 32,
    "pa.mobile.headingXs": 24,
    "pa.mobile.headingXxs": 16,
    "pa.mobile.overline": 12,
    "pa.mobile.bodyL": 24,
    "pa.mobile.bodyLBold": 24,
    "pa.mobile.bodyLLink": 24,
    "pa.mobile.bodyM": 18,
    "pa.mobile.bodyMBold": 18,
    "pa.mobile.bodyMLink": 18,
    "pa.mobile.bodyS": 16,
    "pa.mobile.bodySBold": 16,
    "pa.mobile.bodySLink": 16,
    "pa.mobile.bodyXs": 14,
    "pa.mobile.bodyXsBold": 14,
    "pa.mobile.bodyXsLink": 14,
    "pa.mobile.bodyXxs": 12,
    "pa.mobile.bodyXxsBold": 12,
    "pa.mobile.bodyXxsLink": 12,
    "pa.mobile.body3xs": 11,
    "pa.mobile.body3xsBold": 11,
    "pa.mobile.body3xsLink": 11,
    "pa.mobile.listTitle": 16,
    "pa.mobile.button": 16,
    "pa.mobile.code": 12,
    "ta.desktop.headingXl": 88,
    "ta.desktop.headingL": 64,
    "ta.desktop.headingM": 40,
    "ta.desktop.headingS": 32,
    "ta.desktop.headingXs": 24,
    "ta.desktop.headingXxs": 16,
    "ta.desktop.overline": 12,
    "ta.desktop.bodyL": 24,
    "ta.desktop.bodyLBold": 24,
    "ta.desktop.bodyLLink": 24,
    "ta.desktop.bodyM": 18,
    "ta.desktop.bodyMBold": 18,
    "ta.desktop.bodyMLink": 18,
    "ta.desktop.bodyS": 16,
    "ta.desktop.bodySBold": 16,
    "ta.desktop.bodySLink": 16,
    "ta.desktop.bodyXs": 14,
    "ta.desktop.bodyXsBold": 14,
    "ta.desktop.bodyXsLink": 14,
    "ta.desktop.bodyXxs": 12,
    "ta.desktop.bodyXxsBold": 12,
    "ta.desktop.bodyXxsLink": 12,
    "ta.desktop.body3xs": 11,
    "ta.desktop.body3xsBold": 11,
    "ta.desktop.body3xsLink": 11,
    "ta.desktop.listTitle": 16,
    "ta.desktop.button": 16,
    "ta.desktop.code": 12,
    "ta.mobile.headingXl": 64,
    "ta.mobile.headingL": 48,
    "ta.mobile.headingM": 40,
    "ta.mobile.headingS": 32,
    "ta.mobile.headingXs": 24,
    "ta.mobile.headingXxs": 16,
    "ta.mobile.overline": 12,
    "ta.mobile.bodyL": 24,
    "ta.mobile.bodyLBold": 24,
    "ta.mobile.bodyLLink": 24,
    "ta.mobile.bodyM": 18,
    "ta.mobile.bodyMBold": 18,
    "ta.mobile.bodyMLink": 18,
    "ta.mobile.bodyS": 16,
    "ta.mobile.bodySBold": 16,
    "ta.mobile.bodySLink": 16,
    "ta.mobile.bodyXs": 14,
    "ta.mobile.bodyXsBold": 14,
    "ta.mobile.bodyXsLink": 14,
    "ta.mobile.bodyXxs": 12,
    "ta.mobile.bodyXxsBold": 12,
    "ta.mobile.bodyXxsLink": 12,
    "ta.mobile.body3xs": 11,
    "ta.mobile.body3xsBold": 11,
    "ta.mobile.body3xsLink": 11,
    "ta.mobile.listTitle": 16,
    "ta.mobile.button": 16,
    "ta.mobile.code": 12,
    "te.desktop.headingXl": 88,
    "te.desktop.headingL": 64,
    "te.desktop.headingM": 40,
    "te.desktop.headingS": 32,
    "te.desktop.headingXs": 24,
    "te.desktop.headingXxs": 16,
    "te.desktop.overline": 12,
    "te.desktop.bodyL": 24,
    "te.desktop.bodyLBold": 24,
    "te.desktop.bodyLLink": 24,
    "te.desktop.bodyM": 18,
    "te.desktop.bodyMBold": 18,
    "te.desktop.bodyMLink": 18,
    "te.desktop.bodyS": 16,
    "te.desktop.bodySBold": 16,
    "te.desktop.bodySLink": 16,
    "te.desktop.bodyXs": 14,
    "te.desktop.bodyXsBold": 14,
    "te.desktop.bodyXsLink": 14,
    "te.desktop.bodyXxs": 12,
    "te.desktop.bodyXxsBold": 12,
    "te.desktop.bodyXxsLink": 12,
    "te.desktop.body3xs": 11,
    "te.desktop.body3xsBold": 11,
    "te.desktop.body3xsLink": 11,
    "te.desktop.listTitle": 16,
    "te.desktop.button": 16,
    "te.desktop.code": 12,
    "te.mobile.headingXl": 64,
    "te.mobile.headingL": 48,
    "te.mobile.headingM": 40,
    "te.mobile.headingS": 32,
    "te.mobile.headingXs": 24,
    "te.mobile.headingXxs": 16,
    "te.mobile.overline": 12,
    "te.mobile.bodyL": 24,
    "te.mobile.bodyLBold": 24,
    "te.mobile.bodyLLink": 24,
    "te.mobile.bodyM": 18,
    "te.mobile.bodyMBold": 18,
    "te.mobile.bodyMLink": 18,
    "te.mobile.bodyS": 16,
    "te.mobile.bodySBold": 16,
    "te.mobile.bodySLink": 16,
    "te.mobile.bodyXs": 14,
    "te.mobile.bodyXsBold": 14,
    "te.mobile.bodyXsLink": 14,
    "te.mobile.bodyXxs": 12,
    "te.mobile.bodyXxsBold": 12,
    "te.mobile.bodyXxsLink": 12,
    "te.mobile.body3xs": 11,
    "te.mobile.body3xsBold": 11,
    "te.mobile.body3xsLink": 11,
    "te.mobile.listTitle": 16,
    "te.mobile.button": 16,
    "te.mobile.code": 12,
    headingXl: $e3613f6017c674c5$var$headingXl$3,
    headingL: $e3613f6017c674c5$var$headingL$3,
    headingM: $e3613f6017c674c5$var$headingM$3,
    headingS: $e3613f6017c674c5$var$headingS$3,
    headingXs: $e3613f6017c674c5$var$headingXs$3,
    headingXxs: $e3613f6017c674c5$var$headingXxs$3,
    overline: $e3613f6017c674c5$var$overline$4,
    bodyL: $e3613f6017c674c5$var$bodyL$3,
    bodyLBold: $e3613f6017c674c5$var$bodyLBold$3,
    bodyLLink: $e3613f6017c674c5$var$bodyLLink$3,
    bodyM: $e3613f6017c674c5$var$bodyM$3,
    bodyMBold: $e3613f6017c674c5$var$bodyMBold$3,
    bodyMLink: $e3613f6017c674c5$var$bodyMLink$3,
    bodyS: $e3613f6017c674c5$var$bodyS$3,
    bodySBold: $e3613f6017c674c5$var$bodySBold$3,
    bodySLink: $e3613f6017c674c5$var$bodySLink$3,
    bodyXs: $e3613f6017c674c5$var$bodyXs$3,
    bodyXsBold: $e3613f6017c674c5$var$bodyXsBold$3,
    bodyXsLink: $e3613f6017c674c5$var$bodyXsLink$3,
    bodyXxs: $e3613f6017c674c5$var$bodyXxs$3,
    bodyXxsBold: $e3613f6017c674c5$var$bodyXxsBold$3,
    bodyXxsLink: $e3613f6017c674c5$var$bodyXxsLink$3,
    body3xs: $e3613f6017c674c5$var$body3xs$3,
    body3xsBold: $e3613f6017c674c5$var$body3xsBold$3,
    body3xsLink: $e3613f6017c674c5$var$body3xsLink$3,
    listTitle: $e3613f6017c674c5$var$listTitle$3,
    button: $e3613f6017c674c5$var$button$3,
    code: $e3613f6017c674c5$var$code$3
};
const $e3613f6017c674c5$var$headingXl$2 = "{$lang.$platform.headingXl}";
const $e3613f6017c674c5$var$headingL$2 = "{$lang.$platform.headingL}";
const $e3613f6017c674c5$var$headingM$2 = "{$lang.$platform.headingM}";
const $e3613f6017c674c5$var$headingS$2 = "{$lang.$platform.headingS}";
const $e3613f6017c674c5$var$headingXs$2 = "{$lang.$platform.headingXs}";
const $e3613f6017c674c5$var$headingXxs$2 = "{$lang.$platform.headingXxs}";
const $e3613f6017c674c5$var$overline$3 = "{$lang.$platform.overline}";
const $e3613f6017c674c5$var$bodyL$2 = "{$lang.$platform.bodyL}";
const $e3613f6017c674c5$var$bodyLBold$2 = "{$lang.$platform.bodyLBold}";
const $e3613f6017c674c5$var$bodyLLink$2 = "{$lang.$platform.bodyLLink}";
const $e3613f6017c674c5$var$bodyM$2 = "{$lang.$platform.bodyM}";
const $e3613f6017c674c5$var$bodyMBold$2 = "{$lang.$platform.bodyMBold}";
const $e3613f6017c674c5$var$bodyMLink$2 = "{$lang.$platform.bodyMLink}";
const $e3613f6017c674c5$var$bodyS$2 = "{$lang.$platform.bodyS}";
const $e3613f6017c674c5$var$bodySBold$2 = "{$lang.$platform.bodySBold}";
const $e3613f6017c674c5$var$bodySLink$2 = "{$lang.$platform.bodySLink}";
const $e3613f6017c674c5$var$bodyXs$2 = "{$lang.$platform.bodyXs}";
const $e3613f6017c674c5$var$bodyXsBold$2 = "{$lang.$platform.bodyXsBold}";
const $e3613f6017c674c5$var$bodyXsLink$2 = "{$lang.$platform.bodyXsLink}";
const $e3613f6017c674c5$var$bodyXxs$2 = "{$lang.$platform.bodyXxs}";
const $e3613f6017c674c5$var$bodyXxsBold$2 = "{$lang.$platform.bodyXxsBold}";
const $e3613f6017c674c5$var$bodyXxsLink$2 = "{$lang.$platform.bodyXxsLink}";
const $e3613f6017c674c5$var$body3xs$2 = "{$lang.$platform.body3xs}";
const $e3613f6017c674c5$var$body3xsBold$2 = "{$lang.$platform.body3xsBold}";
const $e3613f6017c674c5$var$body3xsLink$2 = "{$lang.$platform.body3xsLink}";
const $e3613f6017c674c5$var$listTitle$2 = "{$lang.$platform.listTitle}";
const $e3613f6017c674c5$var$button$2 = "{$lang.$platform.button}";
const $e3613f6017c674c5$var$code$2 = "{$lang.$platform.code}";
const $e3613f6017c674c5$var$fontWeights = {
    "400": "400",
    "500": "500",
    "700": "700",
    "800": "800",
    "900": "900",
    "avatar.font.weight": "700",
    "badge.font.weight": "700",
    "button.font.weight": "700",
    "as.desktop.headingXl": 700,
    "as.desktop.headingL": 700,
    "as.desktop.headingM": 700,
    "as.desktop.headingS": 700,
    "as.desktop.headingXs": 700,
    "as.desktop.headingXxs": 700,
    "as.desktop.overline": 700,
    "as.desktop.bodyL": 400,
    "as.desktop.bodyLBold": 700,
    "as.desktop.bodyLLink": 700,
    "as.desktop.bodyM": 400,
    "as.desktop.bodyMBold": 700,
    "as.desktop.bodyMLink": 700,
    "as.desktop.bodyS": 400,
    "as.desktop.bodySBold": 700,
    "as.desktop.bodySLink": 700,
    "as.desktop.bodyXs": 400,
    "as.desktop.bodyXsBold": 700,
    "as.desktop.bodyXsLink": 700,
    "as.desktop.bodyXxs": 400,
    "as.desktop.bodyXxsBold": 700,
    "as.desktop.bodyXxsLink": 700,
    "as.desktop.body3xs": 400,
    "as.desktop.body3xsBold": 700,
    "as.desktop.body3xsLink": 700,
    "as.desktop.listTitle": 400,
    "as.desktop.button": 700,
    "as.desktop.code": 500,
    "as.mobile.headingXl": 700,
    "as.mobile.headingL": 700,
    "as.mobile.headingM": 700,
    "as.mobile.headingS": 700,
    "as.mobile.headingXs": 700,
    "as.mobile.headingXxs": 700,
    "as.mobile.overline": 700,
    "as.mobile.bodyL": 400,
    "as.mobile.bodyLBold": 700,
    "as.mobile.bodyLLink": 700,
    "as.mobile.bodyM": 400,
    "as.mobile.bodyMBold": 700,
    "as.mobile.bodyMLink": 700,
    "as.mobile.bodyS": 400,
    "as.mobile.bodySBold": 700,
    "as.mobile.bodySLink": 700,
    "as.mobile.bodyXs": 400,
    "as.mobile.bodyXsBold": 700,
    "as.mobile.bodyXsLink": 700,
    "as.mobile.bodyXxs": 400,
    "as.mobile.bodyXxsBold": 700,
    "as.mobile.bodyXxsLink": 700,
    "as.mobile.body3xs": 400,
    "as.mobile.body3xsBold": 700,
    "as.mobile.body3xsLink": 700,
    "as.mobile.listTitle": 400,
    "as.mobile.button": 700,
    "as.mobile.code": 500,
    "bn.desktop.headingXl": 700,
    "bn.desktop.headingL": 700,
    "bn.desktop.headingM": 700,
    "bn.desktop.headingS": 700,
    "bn.desktop.headingXs": 700,
    "bn.desktop.headingXxs": 700,
    "bn.desktop.overline": 700,
    "bn.desktop.bodyL": 400,
    "bn.desktop.bodyLBold": 700,
    "bn.desktop.bodyLLink": 700,
    "bn.desktop.bodyM": 400,
    "bn.desktop.bodyMBold": 700,
    "bn.desktop.bodyMLink": 700,
    "bn.desktop.bodyS": 400,
    "bn.desktop.bodySBold": 700,
    "bn.desktop.bodySLink": 700,
    "bn.desktop.bodyXs": 400,
    "bn.desktop.bodyXsBold": 700,
    "bn.desktop.bodyXsLink": 700,
    "bn.desktop.bodyXxs": 400,
    "bn.desktop.bodyXxsBold": 700,
    "bn.desktop.bodyXxsLink": 700,
    "bn.desktop.body3xs": 400,
    "bn.desktop.body3xsBold": 700,
    "bn.desktop.body3xsLink": 700,
    "bn.desktop.listTitle": 400,
    "bn.desktop.button": 700,
    "bn.desktop.code": 500,
    "bn.mobile.headingXl": 700,
    "bn.mobile.headingL": 700,
    "bn.mobile.headingM": 700,
    "bn.mobile.headingS": 700,
    "bn.mobile.headingXs": 700,
    "bn.mobile.headingXxs": 700,
    "bn.mobile.overline": 700,
    "bn.mobile.bodyL": 400,
    "bn.mobile.bodyLBold": 700,
    "bn.mobile.bodyLLink": 700,
    "bn.mobile.bodyM": 400,
    "bn.mobile.bodyMBold": 700,
    "bn.mobile.bodyMLink": 700,
    "bn.mobile.bodyS": 400,
    "bn.mobile.bodySBold": 700,
    "bn.mobile.bodySLink": 700,
    "bn.mobile.bodyXs": 400,
    "bn.mobile.bodyXsBold": 700,
    "bn.mobile.bodyXsLink": 700,
    "bn.mobile.bodyXxs": 400,
    "bn.mobile.bodyXxsBold": 700,
    "bn.mobile.bodyXxsLink": 700,
    "bn.mobile.body3xs": 400,
    "bn.mobile.body3xsBold": 700,
    "bn.mobile.body3xsLink": 700,
    "bn.mobile.listTitle": 400,
    "bn.mobile.button": 700,
    "bn.mobile.code": 500,
    "en.desktop.headingXl": 900,
    "en.desktop.headingL": 900,
    "en.desktop.headingM": 900,
    "en.desktop.headingS": 900,
    "en.desktop.headingXs": 900,
    "en.desktop.headingXxs": 900,
    "en.desktop.overline": 700,
    "en.desktop.bodyL": 500,
    "en.desktop.bodyLBold": 700,
    "en.desktop.bodyLLink": 700,
    "en.desktop.bodyM": 500,
    "en.desktop.bodyMBold": 700,
    "en.desktop.bodyMLink": 700,
    "en.desktop.bodyS": 500,
    "en.desktop.bodySBold": 700,
    "en.desktop.bodySLink": 700,
    "en.desktop.bodyXs": 500,
    "en.desktop.bodyXsBold": 700,
    "en.desktop.bodyXsLink": 700,
    "en.desktop.bodyXxs": 500,
    "en.desktop.bodyXxsBold": 700,
    "en.desktop.bodyXxsLink": 700,
    "en.desktop.body3xs": 500,
    "en.desktop.body3xsBold": 700,
    "en.desktop.body3xsLink": 700,
    "en.desktop.listTitle": 500,
    "en.desktop.button": 700,
    "en.desktop.code": 500,
    "en.mobile.headingXl": 900,
    "en.mobile.headingL": 900,
    "en.mobile.headingM": 900,
    "en.mobile.headingS": 900,
    "en.mobile.headingXs": 900,
    "en.mobile.headingXxs": 900,
    "en.mobile.overline": 700,
    "en.mobile.bodyL": 500,
    "en.mobile.bodyLBold": 700,
    "en.mobile.bodyLLink": 700,
    "en.mobile.bodyM": 500,
    "en.mobile.bodyMBold": 700,
    "en.mobile.bodyMLink": 700,
    "en.mobile.bodyS": 500,
    "en.mobile.bodySBold": 700,
    "en.mobile.bodySLink": 700,
    "en.mobile.bodyXs": 500,
    "en.mobile.bodyXsBold": 700,
    "en.mobile.bodyXsLink": 700,
    "en.mobile.bodyXxs": 500,
    "en.mobile.bodyXxsBold": 700,
    "en.mobile.bodyXxsLink": 700,
    "en.mobile.body3xs": 500,
    "en.mobile.body3xsBold": 700,
    "en.mobile.body3xsLink": 700,
    "en.mobile.listTitle": 500,
    "en.mobile.button": 700,
    "en.mobile.code": 500,
    "gu.desktop.headingXl": 700,
    "gu.desktop.headingL": 700,
    "gu.desktop.headingM": 700,
    "gu.desktop.headingS": 700,
    "gu.desktop.headingXs": 700,
    "gu.desktop.headingXxs": 700,
    "gu.desktop.overline": 700,
    "gu.desktop.bodyL": 400,
    "gu.desktop.bodyLBold": 700,
    "gu.desktop.bodyLLink": 700,
    "gu.desktop.bodyM": 400,
    "gu.desktop.bodyMBold": 700,
    "gu.desktop.bodyMLink": 700,
    "gu.desktop.bodyS": 400,
    "gu.desktop.bodySBold": 700,
    "gu.desktop.bodySLink": 700,
    "gu.desktop.bodyXs": 400,
    "gu.desktop.bodyXsBold": 700,
    "gu.desktop.bodyXsLink": 700,
    "gu.desktop.bodyXxs": 400,
    "gu.desktop.bodyXxsBold": 700,
    "gu.desktop.bodyXxsLink": 700,
    "gu.desktop.body3xs": 400,
    "gu.desktop.body3xsBold": 700,
    "gu.desktop.body3xsLink": 700,
    "gu.desktop.listTitle": 400,
    "gu.desktop.button": 700,
    "gu.desktop.code": 500,
    "gu.mobile.headingXl": 700,
    "gu.mobile.headingL": 700,
    "gu.mobile.headingM": 700,
    "gu.mobile.headingS": 700,
    "gu.mobile.headingXs": 700,
    "gu.mobile.headingXxs": 700,
    "gu.mobile.overline": 700,
    "gu.mobile.bodyL": 400,
    "gu.mobile.bodyLBold": 700,
    "gu.mobile.bodyLLink": 700,
    "gu.mobile.bodyM": 400,
    "gu.mobile.bodyMBold": 700,
    "gu.mobile.bodyMLink": 700,
    "gu.mobile.bodyS": 400,
    "gu.mobile.bodySBold": 700,
    "gu.mobile.bodySLink": 700,
    "gu.mobile.bodyXs": 400,
    "gu.mobile.bodyXsBold": 700,
    "gu.mobile.bodyXsLink": 700,
    "gu.mobile.bodyXxs": 400,
    "gu.mobile.bodyXxsBold": 700,
    "gu.mobile.bodyXxsLink": 700,
    "gu.mobile.body3xs": 400,
    "gu.mobile.body3xsBold": 700,
    "gu.mobile.body3xsLink": 700,
    "gu.mobile.listTitle": 400,
    "gu.mobile.button": 700,
    "gu.mobile.code": 500,
    "hi.desktop.headingXl": 700,
    "hi.desktop.headingL": 700,
    "hi.desktop.headingM": 700,
    "hi.desktop.headingS": 700,
    "hi.desktop.headingXs": 700,
    "hi.desktop.headingXxs": 700,
    "hi.desktop.overline": 700,
    "hi.desktop.bodyL": 400,
    "hi.desktop.bodyLBold": 700,
    "hi.desktop.bodyLLink": 700,
    "hi.desktop.bodyM": 400,
    "hi.desktop.bodyMBold": 700,
    "hi.desktop.bodyMLink": 700,
    "hi.desktop.bodyS": 400,
    "hi.desktop.bodySBold": 700,
    "hi.desktop.bodySLink": 700,
    "hi.desktop.bodyXs": 400,
    "hi.desktop.bodyXsBold": 700,
    "hi.desktop.bodyXsLink": 700,
    "hi.desktop.bodyXxs": 400,
    "hi.desktop.bodyXxsBold": 700,
    "hi.desktop.bodyXxsLink": 700,
    "hi.desktop.body3xs": 400,
    "hi.desktop.body3xsBold": 700,
    "hi.desktop.body3xsLink": 700,
    "hi.desktop.listTitle": 400,
    "hi.desktop.button": 700,
    "hi.desktop.code": 500,
    "hi.mobile.headingXl": 700,
    "hi.mobile.headingL": 700,
    "hi.mobile.headingM": 700,
    "hi.mobile.headingS": 700,
    "hi.mobile.headingXs": 700,
    "hi.mobile.headingXxs": 700,
    "hi.mobile.overline": 700,
    "hi.mobile.bodyL": 400,
    "hi.mobile.bodyLBold": 700,
    "hi.mobile.bodyLLink": 700,
    "hi.mobile.bodyM": 400,
    "hi.mobile.bodyMBold": 700,
    "hi.mobile.bodyMLink": 700,
    "hi.mobile.bodyS": 400,
    "hi.mobile.bodySBold": 700,
    "hi.mobile.bodySLink": 700,
    "hi.mobile.bodyXs": 400,
    "hi.mobile.bodyXsBold": 700,
    "hi.mobile.bodyXsLink": 700,
    "hi.mobile.bodyXxs": 400,
    "hi.mobile.bodyXxsBold": 700,
    "hi.mobile.bodyXxsLink": 700,
    "hi.mobile.body3xs": 400,
    "hi.mobile.body3xsBold": 700,
    "hi.mobile.body3xsLink": 700,
    "hi.mobile.listTitle": 400,
    "hi.mobile.button": 700,
    "hi.mobile.code": 500,
    "kn.desktop.headingXl": 700,
    "kn.desktop.headingL": 700,
    "kn.desktop.headingM": 700,
    "kn.desktop.headingS": 700,
    "kn.desktop.headingXs": 700,
    "kn.desktop.headingXxs": 700,
    "kn.desktop.overline": 700,
    "kn.desktop.bodyL": 400,
    "kn.desktop.bodyLBold": 700,
    "kn.desktop.bodyLLink": 700,
    "kn.desktop.bodyM": 400,
    "kn.desktop.bodyMBold": 700,
    "kn.desktop.bodyMLink": 700,
    "kn.desktop.bodyS": 400,
    "kn.desktop.bodySBold": 700,
    "kn.desktop.bodySLink": 700,
    "kn.desktop.bodyXs": 400,
    "kn.desktop.bodyXsBold": 700,
    "kn.desktop.bodyXsLink": 700,
    "kn.desktop.bodyXxs": 400,
    "kn.desktop.bodyXxsBold": 700,
    "kn.desktop.bodyXxsLink": 700,
    "kn.desktop.body3xs": 400,
    "kn.desktop.body3xsBold": 700,
    "kn.desktop.body3xsLink": 700,
    "kn.desktop.listTitle": 400,
    "kn.desktop.button": 700,
    "kn.desktop.code": 500,
    "kn.mobile.headingXl": 700,
    "kn.mobile.headingL": 700,
    "kn.mobile.headingM": 700,
    "kn.mobile.headingS": 700,
    "kn.mobile.headingXs": 700,
    "kn.mobile.headingXxs": 700,
    "kn.mobile.overline": 700,
    "kn.mobile.bodyL": 400,
    "kn.mobile.bodyLBold": 700,
    "kn.mobile.bodyLLink": 700,
    "kn.mobile.bodyM": 400,
    "kn.mobile.bodyMBold": 700,
    "kn.mobile.bodyMLink": 700,
    "kn.mobile.bodyS": 400,
    "kn.mobile.bodySBold": 700,
    "kn.mobile.bodySLink": 700,
    "kn.mobile.bodyXs": 400,
    "kn.mobile.bodyXsBold": 700,
    "kn.mobile.bodyXsLink": 700,
    "kn.mobile.bodyXxs": 400,
    "kn.mobile.bodyXxsBold": 700,
    "kn.mobile.bodyXxsLink": 700,
    "kn.mobile.body3xs": 400,
    "kn.mobile.body3xsBold": 700,
    "kn.mobile.body3xsLink": 700,
    "kn.mobile.listTitle": 400,
    "kn.mobile.button": 700,
    "kn.mobile.code": 500,
    "ml.desktop.headingXl": 700,
    "ml.desktop.headingL": 700,
    "ml.desktop.headingM": 700,
    "ml.desktop.headingS": 700,
    "ml.desktop.headingXs": 700,
    "ml.desktop.headingXxs": 700,
    "ml.desktop.overline": 700,
    "ml.desktop.bodyL": 400,
    "ml.desktop.bodyLBold": 700,
    "ml.desktop.bodyLLink": 700,
    "ml.desktop.bodyM": 400,
    "ml.desktop.bodyMBold": 700,
    "ml.desktop.bodyMLink": 700,
    "ml.desktop.bodyS": 400,
    "ml.desktop.bodySBold": 700,
    "ml.desktop.bodySLink": 700,
    "ml.desktop.bodyXs": 400,
    "ml.desktop.bodyXsBold": 700,
    "ml.desktop.bodyXsLink": 700,
    "ml.desktop.bodyXxs": 400,
    "ml.desktop.bodyXxsBold": 700,
    "ml.desktop.bodyXxsLink": 700,
    "ml.desktop.body3xs": 400,
    "ml.desktop.body3xsBold": 700,
    "ml.desktop.body3xsLink": 700,
    "ml.desktop.listTitle": 400,
    "ml.desktop.button": 700,
    "ml.desktop.code": 500,
    "ml.mobile.headingXl": 700,
    "ml.mobile.headingL": 700,
    "ml.mobile.headingM": 700,
    "ml.mobile.headingS": 700,
    "ml.mobile.headingXs": 700,
    "ml.mobile.headingXxs": 700,
    "ml.mobile.overline": 700,
    "ml.mobile.bodyL": 400,
    "ml.mobile.bodyLBold": 700,
    "ml.mobile.bodyLLink": 700,
    "ml.mobile.bodyM": 400,
    "ml.mobile.bodyMBold": 700,
    "ml.mobile.bodyMLink": 700,
    "ml.mobile.bodyS": 400,
    "ml.mobile.bodySBold": 700,
    "ml.mobile.bodySLink": 700,
    "ml.mobile.bodyXs": 400,
    "ml.mobile.bodyXsBold": 700,
    "ml.mobile.bodyXsLink": 700,
    "ml.mobile.bodyXxs": 400,
    "ml.mobile.bodyXxsBold": 700,
    "ml.mobile.bodyXxsLink": 700,
    "ml.mobile.body3xs": 400,
    "ml.mobile.body3xsBold": 700,
    "ml.mobile.body3xsLink": 700,
    "ml.mobile.listTitle": 400,
    "ml.mobile.button": 700,
    "ml.mobile.code": 500,
    "mr.desktop.headingXl": 700,
    "mr.desktop.headingL": 700,
    "mr.desktop.headingM": 700,
    "mr.desktop.headingS": 700,
    "mr.desktop.headingXs": 700,
    "mr.desktop.headingXxs": 700,
    "mr.desktop.overline": 700,
    "mr.desktop.bodyL": 400,
    "mr.desktop.bodyLBold": 700,
    "mr.desktop.bodyLLink": 700,
    "mr.desktop.bodyM": 400,
    "mr.desktop.bodyMBold": 700,
    "mr.desktop.bodyMLink": 700,
    "mr.desktop.bodyS": 400,
    "mr.desktop.bodySBold": 700,
    "mr.desktop.bodySLink": 700,
    "mr.desktop.bodyXs": 400,
    "mr.desktop.bodyXsBold": 700,
    "mr.desktop.bodyXsLink": 700,
    "mr.desktop.bodyXxs": 400,
    "mr.desktop.bodyXxsBold": 700,
    "mr.desktop.bodyXxsLink": 700,
    "mr.desktop.body3xs": 400,
    "mr.desktop.body3xsBold": 700,
    "mr.desktop.body3xsLink": 700,
    "mr.desktop.listTitle": 400,
    "mr.desktop.button": 700,
    "mr.desktop.code": 500,
    "mr.mobile.headingXl": 700,
    "mr.mobile.headingL": 700,
    "mr.mobile.headingM": 700,
    "mr.mobile.headingS": 700,
    "mr.mobile.headingXs": 700,
    "mr.mobile.headingXxs": 700,
    "mr.mobile.overline": 700,
    "mr.mobile.bodyL": 400,
    "mr.mobile.bodyLBold": 700,
    "mr.mobile.bodyLLink": 700,
    "mr.mobile.bodyM": 400,
    "mr.mobile.bodyMBold": 700,
    "mr.mobile.bodyMLink": 700,
    "mr.mobile.bodyS": 400,
    "mr.mobile.bodySBold": 700,
    "mr.mobile.bodySLink": 700,
    "mr.mobile.bodyXs": 400,
    "mr.mobile.bodyXsBold": 700,
    "mr.mobile.bodyXsLink": 700,
    "mr.mobile.bodyXxs": 400,
    "mr.mobile.bodyXxsBold": 700,
    "mr.mobile.bodyXxsLink": 700,
    "mr.mobile.body3xs": 400,
    "mr.mobile.body3xsBold": 700,
    "mr.mobile.body3xsLink": 700,
    "mr.mobile.listTitle": 400,
    "mr.mobile.button": 700,
    "mr.mobile.code": 500,
    "or.desktop.headingXl": 700,
    "or.desktop.headingL": 700,
    "or.desktop.headingM": 700,
    "or.desktop.headingS": 700,
    "or.desktop.headingXs": 700,
    "or.desktop.headingXxs": 700,
    "or.desktop.overline": 700,
    "or.desktop.bodyL": 400,
    "or.desktop.bodyLBold": 700,
    "or.desktop.bodyLLink": 700,
    "or.desktop.bodyM": 400,
    "or.desktop.bodyMBold": 700,
    "or.desktop.bodyMLink": 700,
    "or.desktop.bodyS": 400,
    "or.desktop.bodySBold": 700,
    "or.desktop.bodySLink": 700,
    "or.desktop.bodyXs": 400,
    "or.desktop.bodyXsBold": 700,
    "or.desktop.bodyXsLink": 700,
    "or.desktop.bodyXxs": 400,
    "or.desktop.bodyXxsBold": 700,
    "or.desktop.bodyXxsLink": 700,
    "or.desktop.body3xs": 400,
    "or.desktop.body3xsBold": 700,
    "or.desktop.body3xsLink": 700,
    "or.desktop.listTitle": 400,
    "or.desktop.button": 700,
    "or.desktop.code": 500,
    "or.mobile.headingXl": 700,
    "or.mobile.headingL": 700,
    "or.mobile.headingM": 700,
    "or.mobile.headingS": 700,
    "or.mobile.headingXs": 700,
    "or.mobile.headingXxs": 700,
    "or.mobile.overline": 700,
    "or.mobile.bodyL": 400,
    "or.mobile.bodyLBold": 700,
    "or.mobile.bodyLLink": 700,
    "or.mobile.bodyM": 400,
    "or.mobile.bodyMBold": 700,
    "or.mobile.bodyMLink": 700,
    "or.mobile.bodyS": 400,
    "or.mobile.bodySBold": 700,
    "or.mobile.bodySLink": 700,
    "or.mobile.bodyXs": 400,
    "or.mobile.bodyXsBold": 700,
    "or.mobile.bodyXsLink": 700,
    "or.mobile.bodyXxs": 400,
    "or.mobile.bodyXxsBold": 700,
    "or.mobile.bodyXxsLink": 700,
    "or.mobile.body3xs": 400,
    "or.mobile.body3xsBold": 700,
    "or.mobile.body3xsLink": 700,
    "or.mobile.listTitle": 400,
    "or.mobile.button": 700,
    "or.mobile.code": 500,
    "pa.desktop.headingXl": 700,
    "pa.desktop.headingL": 700,
    "pa.desktop.headingM": 700,
    "pa.desktop.headingS": 700,
    "pa.desktop.headingXs": 700,
    "pa.desktop.headingXxs": 700,
    "pa.desktop.overline": 700,
    "pa.desktop.bodyL": 400,
    "pa.desktop.bodyLBold": 700,
    "pa.desktop.bodyLLink": 700,
    "pa.desktop.bodyM": 400,
    "pa.desktop.bodyMBold": 700,
    "pa.desktop.bodyMLink": 700,
    "pa.desktop.bodyS": 400,
    "pa.desktop.bodySBold": 700,
    "pa.desktop.bodySLink": 700,
    "pa.desktop.bodyXs": 400,
    "pa.desktop.bodyXsBold": 700,
    "pa.desktop.bodyXsLink": 700,
    "pa.desktop.bodyXxs": 400,
    "pa.desktop.bodyXxsBold": 700,
    "pa.desktop.bodyXxsLink": 700,
    "pa.desktop.body3xs": 400,
    "pa.desktop.body3xsBold": 700,
    "pa.desktop.body3xsLink": 700,
    "pa.desktop.listTitle": 400,
    "pa.desktop.button": 700,
    "pa.desktop.code": 500,
    "pa.mobile.headingXl": 700,
    "pa.mobile.headingL": 700,
    "pa.mobile.headingM": 700,
    "pa.mobile.headingS": 700,
    "pa.mobile.headingXs": 700,
    "pa.mobile.headingXxs": 700,
    "pa.mobile.overline": 700,
    "pa.mobile.bodyL": 400,
    "pa.mobile.bodyLBold": 700,
    "pa.mobile.bodyLLink": 700,
    "pa.mobile.bodyM": 400,
    "pa.mobile.bodyMBold": 700,
    "pa.mobile.bodyMLink": 700,
    "pa.mobile.bodyS": 400,
    "pa.mobile.bodySBold": 700,
    "pa.mobile.bodySLink": 700,
    "pa.mobile.bodyXs": 400,
    "pa.mobile.bodyXsBold": 700,
    "pa.mobile.bodyXsLink": 700,
    "pa.mobile.bodyXxs": 400,
    "pa.mobile.bodyXxsBold": 700,
    "pa.mobile.bodyXxsLink": 700,
    "pa.mobile.body3xs": 400,
    "pa.mobile.body3xsBold": 700,
    "pa.mobile.body3xsLink": 700,
    "pa.mobile.listTitle": 400,
    "pa.mobile.button": 700,
    "pa.mobile.code": 500,
    "ta.desktop.headingXl": 700,
    "ta.desktop.headingL": 700,
    "ta.desktop.headingM": 700,
    "ta.desktop.headingS": 700,
    "ta.desktop.headingXs": 700,
    "ta.desktop.headingXxs": 700,
    "ta.desktop.overline": 700,
    "ta.desktop.bodyL": 400,
    "ta.desktop.bodyLBold": 700,
    "ta.desktop.bodyLLink": 700,
    "ta.desktop.bodyM": 400,
    "ta.desktop.bodyMBold": 700,
    "ta.desktop.bodyMLink": 700,
    "ta.desktop.bodyS": 400,
    "ta.desktop.bodySBold": 700,
    "ta.desktop.bodySLink": 700,
    "ta.desktop.bodyXs": 400,
    "ta.desktop.bodyXsBold": 700,
    "ta.desktop.bodyXsLink": 700,
    "ta.desktop.bodyXxs": 400,
    "ta.desktop.bodyXxsBold": 700,
    "ta.desktop.bodyXxsLink": 700,
    "ta.desktop.body3xs": 400,
    "ta.desktop.body3xsBold": 700,
    "ta.desktop.body3xsLink": 700,
    "ta.desktop.listTitle": 400,
    "ta.desktop.button": 700,
    "ta.desktop.code": 500,
    "ta.mobile.headingXl": 700,
    "ta.mobile.headingL": 700,
    "ta.mobile.headingM": 700,
    "ta.mobile.headingS": 700,
    "ta.mobile.headingXs": 700,
    "ta.mobile.headingXxs": 700,
    "ta.mobile.overline": 700,
    "ta.mobile.bodyL": 400,
    "ta.mobile.bodyLBold": 700,
    "ta.mobile.bodyLLink": 700,
    "ta.mobile.bodyM": 400,
    "ta.mobile.bodyMBold": 700,
    "ta.mobile.bodyMLink": 700,
    "ta.mobile.bodyS": 400,
    "ta.mobile.bodySBold": 700,
    "ta.mobile.bodySLink": 700,
    "ta.mobile.bodyXs": 400,
    "ta.mobile.bodyXsBold": 700,
    "ta.mobile.bodyXsLink": 700,
    "ta.mobile.bodyXxs": 400,
    "ta.mobile.bodyXxsBold": 700,
    "ta.mobile.bodyXxsLink": 700,
    "ta.mobile.body3xs": 400,
    "ta.mobile.body3xsBold": 700,
    "ta.mobile.body3xsLink": 700,
    "ta.mobile.listTitle": 400,
    "ta.mobile.button": 700,
    "ta.mobile.code": 500,
    "te.desktop.headingXl": 700,
    "te.desktop.headingL": 700,
    "te.desktop.headingM": 700,
    "te.desktop.headingS": 700,
    "te.desktop.headingXs": 700,
    "te.desktop.headingXxs": 700,
    "te.desktop.overline": 700,
    "te.desktop.bodyL": 400,
    "te.desktop.bodyLBold": 700,
    "te.desktop.bodyLLink": 700,
    "te.desktop.bodyM": 400,
    "te.desktop.bodyMBold": 700,
    "te.desktop.bodyMLink": 700,
    "te.desktop.bodyS": 400,
    "te.desktop.bodySBold": 700,
    "te.desktop.bodySLink": 700,
    "te.desktop.bodyXs": 400,
    "te.desktop.bodyXsBold": 700,
    "te.desktop.bodyXsLink": 700,
    "te.desktop.bodyXxs": 400,
    "te.desktop.bodyXxsBold": 700,
    "te.desktop.bodyXxsLink": 700,
    "te.desktop.body3xs": 400,
    "te.desktop.body3xsBold": 700,
    "te.desktop.body3xsLink": 700,
    "te.desktop.listTitle": 400,
    "te.desktop.button": 700,
    "te.desktop.code": 500,
    "te.mobile.headingXl": 700,
    "te.mobile.headingL": 700,
    "te.mobile.headingM": 700,
    "te.mobile.headingS": 700,
    "te.mobile.headingXs": 700,
    "te.mobile.headingXxs": 700,
    "te.mobile.overline": 700,
    "te.mobile.bodyL": 400,
    "te.mobile.bodyLBold": 700,
    "te.mobile.bodyLLink": 700,
    "te.mobile.bodyM": 400,
    "te.mobile.bodyMBold": 700,
    "te.mobile.bodyMLink": 700,
    "te.mobile.bodyS": 400,
    "te.mobile.bodySBold": 700,
    "te.mobile.bodySLink": 700,
    "te.mobile.bodyXs": 400,
    "te.mobile.bodyXsBold": 700,
    "te.mobile.bodyXsLink": 700,
    "te.mobile.bodyXxs": 400,
    "te.mobile.bodyXxsBold": 700,
    "te.mobile.bodyXxsLink": 700,
    "te.mobile.body3xs": 400,
    "te.mobile.body3xsBold": 700,
    "te.mobile.body3xsLink": 700,
    "te.mobile.listTitle": 400,
    "te.mobile.button": 700,
    "te.mobile.code": 500,
    headingXl: $e3613f6017c674c5$var$headingXl$2,
    headingL: $e3613f6017c674c5$var$headingL$2,
    headingM: $e3613f6017c674c5$var$headingM$2,
    headingS: $e3613f6017c674c5$var$headingS$2,
    headingXs: $e3613f6017c674c5$var$headingXs$2,
    headingXxs: $e3613f6017c674c5$var$headingXxs$2,
    overline: $e3613f6017c674c5$var$overline$3,
    bodyL: $e3613f6017c674c5$var$bodyL$2,
    bodyLBold: $e3613f6017c674c5$var$bodyLBold$2,
    bodyLLink: $e3613f6017c674c5$var$bodyLLink$2,
    bodyM: $e3613f6017c674c5$var$bodyM$2,
    bodyMBold: $e3613f6017c674c5$var$bodyMBold$2,
    bodyMLink: $e3613f6017c674c5$var$bodyMLink$2,
    bodyS: $e3613f6017c674c5$var$bodyS$2,
    bodySBold: $e3613f6017c674c5$var$bodySBold$2,
    bodySLink: $e3613f6017c674c5$var$bodySLink$2,
    bodyXs: $e3613f6017c674c5$var$bodyXs$2,
    bodyXsBold: $e3613f6017c674c5$var$bodyXsBold$2,
    bodyXsLink: $e3613f6017c674c5$var$bodyXsLink$2,
    bodyXxs: $e3613f6017c674c5$var$bodyXxs$2,
    bodyXxsBold: $e3613f6017c674c5$var$bodyXxsBold$2,
    bodyXxsLink: $e3613f6017c674c5$var$bodyXxsLink$2,
    body3xs: $e3613f6017c674c5$var$body3xs$2,
    body3xsBold: $e3613f6017c674c5$var$body3xsBold$2,
    body3xsLink: $e3613f6017c674c5$var$body3xsLink$2,
    listTitle: $e3613f6017c674c5$var$listTitle$2,
    button: $e3613f6017c674c5$var$button$2,
    code: $e3613f6017c674c5$var$code$2
};
const $e3613f6017c674c5$var$JSON_MAP$1 = {
    "JDSActionButton": {
        "a_0": "{global.transparent}",
        "a_1": "{opacity.enabled}",
        "a_2": "{flexDirection.stack}",
        "a_3": "{alignItems.center}",
        "a_4": "{justifyContent.center}",
        "a_5": "{pill}",
        "a_6": "{primary50}",
        "a_7": "{flexDirection.row}",
        "a_8": "{alignItems.center}",
        "a_9": "{justifyContent.center}",
        "a_10": "{pill}",
        "a_11": "{xs}",
        "a_12": "{base}",
        "a_13": "{xs}",
        "a_14": "{base}",
        "a_15": "{xs}",
        "a_16": "{primary30}",
        "a_17": "{primary60}",
        "a_18": "{border_focus}",
        "a_19": "{primary60}",
        "a_20": "{primary50}",
        "a_21": "{global.transparent}",
        "a_22": "{primaryGrey40}",
        "a_23": "{border_focus}",
        "a_24": "{border_none}",
        "a_25": "{opacity.enabled}",
        "a_26": "{m}",
        "a_27": "{m}",
        "a_28": "{primaryInverse}",
        "a_29": "{primary70}",
        "a_30": "{primaryInverse}",
        "a_31": "{m}",
        "a_32": "{primaryInverse}",
        "a_33": "{primary70}",
        "a_34": "{primaryInverse}",
        "a_35": "{xxs}",
        "a_36": "{s}",
        "a_37": "{xxs}",
        "a_38": "{s}",
        "a_39": "{xxs}",
        "a_40": "{base}",
        "a_41": "{base}",
        "a_42": "{m}",
        "a_43": "{s}",
        "a_44": "{m}",
        "a_45": "{s}",
        "a_46": "{m}",
        "a_47": "{xs}",
        "a_48": "{m}",
        "a_49": "{m}",
        "a_50": "{m}",
        "a_51": "{base}",
        "a_52": "{l}",
        "a_53": "{base}",
        "a_54": "{l}",
        "a_55": "{xs}",
        "a_56": "{l}",
        "a_57": "{l}",
        "a_58": "{xxl}",
        "a_59": "{opacity.disabled}",
        "a_60": "{opacity.invisible}",
        "a_61": "{opacity.invisible}",
        "a_62": "{opacity.invisible}",
        "a_63": "{opacity.disabled}",
        "a_64": "{opacity.enabled}",
        "a_65": "{global.transparent}",
        "a_66": "{border_thin}",
        "a_67": "{primaryGrey60}",
        "a_68": "{primary20}",
        "a_69": "{primary30}",
        "a_70": "{border_focus}",
        "a_71": "{primary60}",
        "a_72": "{primary60}",
        "a_73": "{primary60}",
        "a_74": "{primary70}",
        "a_75": "{primary60}",
        "a_76": "{primary60}",
        "a_77": "{primary70}",
        "a_78": "{custom_5}",
        "a_79": "{custom_5}",
        "a_80": "{custom_5}",
        "a_81": "{custom_5}",
        "a_82": "{global.transparent}",
        "a_83": "{primary20}",
        "a_84": "{primary30}",
        "a_85": "{border_focus}",
        "a_86": "{custom_1}",
        "a_87": "{primary60}",
        "a_88": "{primary60}",
        "a_89": "{primary50}",
        "a_90": "{primary70}",
        "a_91": "{primary60}",
        "a_92": "{primary50}",
        "a_93": "{primary70}",
        "a_94": "{feedbackSuccess50}",
        "a_95": "{feedbackSuccess20}",
        "a_96": "{feedbackSuccess80}",
        "a_97": "{primary60}",
        "a_98": "{global.white}",
        "a_99": "{feedbackSuccess80}",
        "a_100": "{primaryBackground}",
        "a_101": "{global.white}",
        "a_102": "{feedbackSuccess80}",
        "a_103": "{primaryBackground}",
        "a_104": "{global.transparent}",
        "a_105": "{border_thin}",
        "a_106": "{primaryGrey60}",
        "a_107": "{feedbackSuccess20}",
        "a_108": "{feedbackSuccess80}",
        "a_109": "{primary60}",
        "a_110": "{feedbackSuccess80}",
        "a_111": "{feedbackSuccess80}",
        "a_112": "{primaryBackground}",
        "a_113": "{feedbackSuccess80}",
        "a_114": "{feedbackSuccess80}",
        "a_115": "{primaryBackground}",
        "a_116": "{global.transparent}",
        "a_117": "{custom_1}",
        "a_118": "{feedbackSuccess20}",
        "a_119": "{feedbackSuccess80}",
        "a_120": "{primary60}",
        "a_121": "{feedbackSuccess80}",
        "a_122": "{feedbackSuccess50}",
        "a_123": "{primaryGrey100}",
        "a_124": "{feedbackSuccess80}",
        "a_125": "{feedbackSuccess50}",
        "a_126": "{primaryGrey100}",
        "a_127": "{custom_5}",
        "a_128": "{custom_5}",
        "a_129": "{feedbackError50}",
        "a_130": "{feedbackError20}",
        "a_131": "{feedbackError80}",
        "a_132": "{primary60}",
        "a_133": "{global.white}",
        "a_134": "{feedbackError80}",
        "a_135": "{primaryBackground}",
        "a_136": "{global.white}",
        "a_137": "{feedbackError80}",
        "a_138": "{primaryBackground}",
        "a_139": "{global.transparent}",
        "a_140": "{border_thin}",
        "a_141": "{primaryGrey60}",
        "a_142": "{feedbackError20}",
        "a_143": "{feedbackError80}",
        "a_144": "{primary60}",
        "a_145": "{feedbackError80}",
        "a_146": "{feedbackError80}",
        "a_147": "{primaryBackground}",
        "a_148": "{feedbackError80}",
        "a_149": "{feedbackError80}",
        "a_150": "{primaryBackground}",
        "a_151": "{global.transparent}",
        "a_152": "{pill}",
        "a_153": "{feedbackError20}",
        "a_154": "{feedbackError80}",
        "a_155": "{primary60}",
        "a_156": "{feedbackError80}",
        "a_157": "{feedbackError50}",
        "a_158": "{primaryGrey100}",
        "a_159": "{feedbackError80}",
        "a_160": "{feedbackError50}",
        "a_161": "{primaryGrey100}",
        "a_162": "{custom_5}",
        "a_163": "{custom_5}",
        "a_164": "{primaryBackground}",
        "a_165": "{primary20}",
        "a_166": "{primary30}",
        "a_167": "{primary50}",
        "a_168": "{primaryGrey100}",
        "a_169": "{primaryGrey100}",
        "a_170": "{primaryGrey100}",
        "a_171": "{primaryGrey100}",
        "a_172": "{primaryGrey100}",
        "a_173": "{primaryGrey100}",
        "a_174": "{global.transparent}",
        "a_175": "{border_thin}",
        "a_176": "{primaryGrey60}",
        "a_177": "{primary20}",
        "a_178": "{primary30}",
        "a_179": "{border_focus}",
        "a_180": "{primary50}",
        "a_181": "{primaryBackground}",
        "a_182": "{primaryGrey100}",
        "a_183": "{primaryGrey100}",
        "a_184": "{primaryBackground}",
        "a_185": "{primaryGrey100}",
        "a_186": "{primaryGrey100}",
        "a_187": "{global.transparent}",
        "a_188": "{pill}",
        "a_189": "{primary20}",
        "a_190": "{primary30}",
        "a_191": "{border_focus}",
        "a_192": "{primary50}",
        "a_193": "{primaryBackground}",
        "a_194": "{primaryGrey100}",
        "a_195": "{primaryGrey100}",
        "a_196": "{primaryBackground}",
        "a_197": "{primaryGrey100}",
        "a_198": "{primaryGrey100}",
        "a_199": "{base}",
        "a_200": "{base}",
        "a_201": "{m}",
        "a_202": "{m}",
        "a_203": "{l}",
        "a_204": "{l}",
        "a_205": "{size.max}",
        "a_206": "{size.max}"
    },
    "JDSAvatar": {
        "a_0": "{xl}",
        "a_1": "{xl}",
        "a_2": "{flexDirection.row}",
        "a_3": "{justifyContent.center}",
        "a_4": "{alignItems.center}",
        "a_5": "{primary20}",
        "a_6": "{pill}",
        "a_7": "{border_none}",
        "a_8": "{primary80}",
        "a_9": "{m}",
        "a_10": "{m}",
        "a_11": "{l}",
        "a_12": "{l}",
        "a_13": "{xxl}",
        "a_14": "{xxl}",
        "a_15": "{custom_1}",
        "a_16": "{custom_1}",
        "a_17": "{opacity.enabled}",
        "a_18": "{opacity.disabled}",
        "a_19": "{sparkle20}",
        "a_20": "{border_focus}",
        "a_21": "{sparkle40}",
        "a_22": "{border_focus}",
        "a_23": "{sparkle40}",
        "a_24": "{opacity.disabled}",
        "a_25": "{border_focus}",
        "a_26": "{opacity.disabled}"
    },
    "JDSAvatarV2Default": {
        "a_0": "{xl}",
        "a_1": "{xl}",
        "a_2": "{flexDirection.row}",
        "a_3": "{justifyContent.center}",
        "a_4": "{alignItems.center}",
        "a_5": "{primary20}",
        "a_6": "{pill}",
        "a_7": "{border_none}",
        "a_8": "{primary60}",
        "a_9": "{opacity.enabled}",
        "a_10": "{primary30}",
        "a_11": "{border_focus}",
        "a_12": "{custom_3}",
        "a_13": "{primary60}",
        "a_14": "{primary50}",
        "a_15": "{primary70}",
        "a_16": "{m}",
        "a_17": "{m}",
        "a_18": "{l}",
        "a_19": "{l}",
        "a_20": "{xxl}",
        "a_21": "{xxl}",
        "a_22": "{custom_11}",
        "a_23": "{custom_11}",
        "a_24": "{custom_1}",
        "a_25": "{custom_1}",
        "a_26": "{base}",
        "a_27": "{m}",
        "a_28": "{l}",
        "a_29": "{xl}",
        "a_30": "{xxl}",
        "a_31": "{opacity.disabled}",
        "a_32": "{sparkle20}",
        "a_33": "{opacity.disabled}",
        "a_34": "{primaryBackground}",
        "a_35": "{opacity.disabled}",
        "a_36": "{primaryGrey80}"
    },
    "JDSAccordionList": {
        "a_0": "{flexDirection.column}",
        "a_1": "{size.max}",
        "a_2": "{flexDirection.column}",
        "a_3": "{size.max}"
    },
    "JDSMobileBottomSheet": {
        "m_0": "{flexDirection.stack}",
        "m_1": "{justifyContent.center}",
        "m_2": "{alignItems.end}",
        "m_3": "{size.max}",
        "m_4": "{custom_color_3}",
        "m_5": "{opacity.invisible}",
        "m_6": "{medium}",
        "m_7": "{easeEntrance}",
        "m_8": "{global.transparent}",
        "m_9": "{global.transparent}",
        "m_10": "{opacity.enabled}",
        "m_11": "{easeExit}"
    },
    "JDSMobileBottomSheetInternal": {
        "m_0": "{flexDirection.stack}",
        "m_1": "{justifyContent.end}",
        "m_2": "{alignItems.end}",
        "m_3": "{size.max}",
        "m_4": "{flexDirection.column}",
        "m_5": "{justifyContent.start}",
        "m_6": "{primaryBackground}",
        "m_7": "{alignItems.start}",
        "m_8": "{xl}",
        "m_9": "{xl}",
        "m_10": "{size.max}",
        "m_11": "{size.max}",
        "m_12": "{medium}",
        "m_13": "{easeEntrance}",
        "m_14": "{flexDirection.row}",
        "m_15": "{justifyContent.end}",
        "m_16": "{alignItems.center}",
        "m_17": "{size.max}",
        "m_18": "{xxs}",
        "m_19": "{xxs}",
        "m_20": "{xs}",
        "m_21": "{s}",
        "m_22": "{s}",
        "m_23": 1,
        "m_24": 1,
        "m_25": "{base}",
        "m_26": "{flexDirection.column}",
        "m_27": "{justifyContent.start}",
        "m_28": "{alignItems.start}",
        "m_29": "{m}",
        "m_30": "{m}",
        "m_31": "{size.max}",
        "m_32": "{xs}",
        "m_33": "{m}",
        "m_34": "{flexDirection.column}",
        "m_35": "{base}",
        "m_36": "{size.max}",
        "m_37": "{m}",
        "m_38": "{m}",
        "m_39": "{flexDirection.column}",
        "m_40": "{justifyContent.start}",
        "m_41": "{alignItems.start}",
        "m_42": "{primaryBackground}",
        "m_43": "{xl}",
        "m_44": "{xl}",
        "m_45": "{m}",
        "m_46": "{m}",
        "m_47": "{m}",
        "m_48": "{m}",
        "m_49": "{size.max}",
        "m_50": "{size.max}",
        "m_51": "{medium}",
        "m_52": "{easeEntrance}",
        "m_53": 0,
        "m_54": 4,
        "m_55": 24,
        "m_56": 0,
        "m_57": "{custom_color_5}",
        "m_58": 0,
        "m_59": "{m}",
        "m_60": 0,
        "m_61": "{size.max}"
    },
    "JDSBadge": {
        "b_0": "{flexDirection.row}",
        "b_1": "{justifyContent.center}",
        "b_2": "{alignItems.center}",
        "b_3": "{xxs}",
        "b_4": "{xs}",
        "b_5": "{xs}",
        "b_6": "{xxs}",
        "b_7": "{xxs}",
        "b_8": "{sparkle60}",
        "b_9": "{medium}",
        "b_10": "{base}",
        "b_11": "{sparkleGrey20}",
        "b_12": "{justifyContent.start}",
        "b_13": "{alignItems.start}",
        "b_14": "{bodySBold}",
        "b_15": "{bodySBold}",
        "b_16": "{bodySBold}",
        "b_17": "{bodySBold}",
        "b_18": "{bodySBold}",
        "b_19": "{sparkleGrey20}",
        "b_20": "{text-case.uppercase}",
        "b_21": "{pill}",
        "b_22": "{custom_color_2}",
        "b_23": "{xxs}",
        "b_24": "{xxs}",
        "b_25": "{s}",
        "b_26": "{xxs}",
        "b_27": "{xs}",
        "b_28": "{bodyMBold}",
        "b_29": "{bodyMBold}",
        "b_30": "{bodyMBold}",
        "b_31": "{bodyMBold}",
        "b_32": "{bodyMBold}",
        "b_33": "{global.white}",
        "b_34": "{m}",
        "b_35": "{custom_color_1}",
        "b_36": "{small}",
        "b_37": "{s}",
        "b_38": "{bodyXxsBold}",
        "b_39": "{bodyXxsBold}",
        "b_40": "{bodyXxsBold}",
        "b_41": "{bodyXxsBold}",
        "b_42": "{bodyXxsBold}",
        "b_43": "{s}",
        "b_44": "{s}",
        "b_45": "{xs}",
        "b_46": "{m}",
        "b_47": "{bodyLBold}",
        "b_48": "{bodyLBold}",
        "b_49": "{bodyLBold}",
        "b_50": "{bodyLBold}",
        "b_51": "{bodyLBold}"
    },
    "JDSBadgeV2Brand": {
        "b_0": "{flexDirection.row}",
        "b_1": "{justifyContent.center}",
        "b_2": "{alignItems.center}",
        "b_3": "{primary50}",
        "b_4": "{xxs}",
        "b_5": "{pill}",
        "b_6": "{xs}",
        "b_7": "{s}",
        "b_8": "{xxs}",
        "b_9": "{xxs}",
        "b_10": "{pill}",
        "b_11": "{custom_18}",
        "b_12": "{medium}",
        "b_13": "{medium}",
        "b_14": "{medium}",
        "b_15": "{medium}",
        "b_16": "{small}",
        "b_17": "{xxs}",
        "b_18": "{xxs}",
        "b_19": "{custom_5}",
        "b_20": "{custom_5}",
        "b_21": "{s}",
        "b_22": "{xxs}",
        "b_23": "{xs}",
        "b_24": "{custom_4}",
        "b_25": "{custom_4}",
        "b_26": "{s}",
        "b_27": "{xxs}",
        "b_28": "{xs}",
        "b_29": "{custom_4}",
        "b_30": "{custom_4}",
        "b_31": "{base}",
        "b_32": "{xxs}",
        "b_33": "{xs}",
        "b_34": "{xxs}",
        "b_35": "{xxs}",
        "b_36": "{custom_18}",
        "b_37": "{xs}",
        "b_38": "{custom_3}",
        "b_39": "{primary60}",
        "b_40": "{custom_5}",
        "b_41": "{custom_5}",
        "b_42": "{custom_5}",
        "b_43": "{base}",
        "b_44": "{custom_5}",
        "b_45": "{custom_18}",
        "b_46": "{custom_5}",
        "b_47": "{m}",
        "b_48": "{custom_5}",
        "b_49": "{custom_3}",
        "b_50": "{custom_5}",
        "b_51": "{l}",
        "b_52": "{custom_5}",
        "b_53": "{xl}",
        "b_54": "{small}",
        "b_55": "{custom_5}",
        "b_56": "{base}",
        "b_57": "{small}",
        "b_58": "{small}",
        "b_59": "{custom_5}",
        "b_60": "{custom_18}",
        "b_61": "{small}",
        "b_62": "{small}",
        "b_63": "{custom_5}",
        "b_64": "{m}",
        "b_65": "{small}",
        "b_66": "{small}",
        "b_67": "{custom_5}",
        "b_68": "{custom_3}",
        "b_69": "{small}",
        "b_70": "{l}",
        "b_71": "{xl}",
        "b_72": "{medium}",
        "b_73": "{small}",
        "b_74": "{small}",
        "b_75": "{xxs}",
        "b_76": "{small}",
        "b_77": "{xxs}",
        "b_78": "{xs}",
        "b_79": "{base}",
        "b_80": "{xs}",
        "b_81": "{small}",
        "b_82": "{xs}"
    },
    "JDSBadgeV2Information": {
        "b_0": "{small}",
        "b_1": "{alignItems.center}",
        "b_2": "{flexDirection.row}",
        "b_3": "{justifyContent.center}",
        "b_4": "{alignItems.center}",
        "b_5": "{sparkle60}",
        "b_6": "{xxs}",
        "b_7": "{small}",
        "b_8": "{xxs}",
        "b_9": "{xs}",
        "b_10": "{custom_4}",
        "b_11": "{custom_4}",
        "b_12": "{flexDirection.row}",
        "b_13": "{justifyContent.center}",
        "b_14": "{alignItems.center}",
        "b_15": "{base}",
        "b_16": "{primaryBackground}",
        "b_17": "{base}",
        "b_18": "{flexDirection.row}",
        "b_19": "{justifyContent.center}",
        "b_20": "{alignItems.center}",
        "b_21": "{base}",
        "b_22": "{secondary60}",
        "b_23": "{secondary60}",
        "b_24": "{primaryBackground}",
        "b_25": "{xxs}",
        "b_26": "{custom_5}",
        "b_27": "{custom_5}",
        "b_28": "{s}",
        "b_29": "{s}",
        "b_30": "{s}",
        "b_31": "{xxs}",
        "b_32": "{custom_5}",
        "b_33": "{custom_5}",
        "b_34": "{s}",
        "b_35": "{s}",
        "b_36": "{s}",
        "b_37": "{xxs}",
        "b_38": "{custom_5}",
        "b_39": "{custom_5}",
        "b_40": "{s}",
        "b_41": "{s}",
        "b_42": "{s}",
        "b_43": "{xs}",
        "b_44": "{xxs}",
        "b_45": "{xxs}",
        "b_46": "{medium}",
        "b_47": "{medium}",
        "b_48": "{xs}",
        "b_49": "{xxs}",
        "b_50": "{xxs}",
        "b_51": "{custom_18}",
        "b_52": "{custom_18}",
        "b_53": "{custom_18}",
        "b_54": "{medium}",
        "b_55": "{medium}",
        "b_56": "{xs}",
        "b_57": "{s}",
        "b_58": "{xxs}",
        "b_59": "{xxs}",
        "b_60": "{custom_3}",
        "b_61": "{custom_3}",
        "b_62": "{custom_3}",
        "b_63": "{feedbackSuccess50}",
        "b_64": "{feedbackSuccess50}",
        "b_65": "{feedbackWarning50}",
        "b_66": "{feedbackWarning50}",
        "b_67": "{feedbackError50}",
        "b_68": "{feedbackError50}",
        "b_69": "{primaryGrey80}",
        "b_70": "{global.transparent}",
        "b_71": "{custom_16}",
        "b_72": "{primaryBackground}",
        "b_73": "{custom_5}",
        "b_74": "{xs}",
        "b_75": "{xs}",
        "b_76": "{custom_5}",
        "b_77": "{s}",
        "b_78": "{s}",
        "b_79": "{custom_5}",
        "b_80": "{base}",
        "b_81": "{base}",
        "b_82": "{custom_5}",
        "b_83": "{custom_5}",
        "b_84": "{custom_5}",
        "b_85": "{custom_5}",
        "b_86": "{custom_5}",
        "b_87": "{custom_18}",
        "b_88": "{custom_18}",
        "b_89": "{m}",
        "b_90": "{m}",
        "b_91": "{custom_3}",
        "b_92": "{custom_3}",
        "b_93": "{l}",
        "b_94": "{l}",
        "b_95": "{xl}",
        "b_96": "{xl}",
        "b_97": "{pill}",
        "b_98": "{pill}",
        "b_99": "{custom_5}",
        "b_100": "{s}",
        "b_101": "{pill}",
        "b_102": "{xs}",
        "b_103": "{pill}",
        "b_104": "{pill}",
        "b_105": "{custom_5}",
        "b_106": "{s}",
        "b_107": "{pill}",
        "b_108": "{xs}",
        "b_109": "{pill}",
        "b_110": "{custom_5}",
        "b_111": "{base}",
        "b_112": "{pill}",
        "b_113": "{custom_19}",
        "b_114": "{pill}",
        "b_115": "{custom_5}",
        "b_116": "{custom_18}",
        "b_117": "{pill}",
        "b_118": "{s}",
        "b_119": "{pill}",
        "b_120": "{custom_5}",
        "b_121": "{m}",
        "b_122": "{pill}",
        "b_123": "{base}",
        "b_124": "{pill}",
        "b_125": "{custom_5}",
        "b_126": "{custom_3}",
        "b_127": "{pill}",
        "b_128": "{base}",
        "b_129": "{pill}",
        "b_130": "{custom_5}",
        "b_131": "{l}",
        "b_132": "{pill}",
        "b_133": "{custom_18}",
        "b_134": "{pill}",
        "b_135": "{custom_5}",
        "b_136": "{xl}",
        "b_137": "{pill}",
        "b_138": "{m}",
        "b_139": "{small}",
        "b_140": "{small}",
        "b_141": "{custom_5}",
        "b_142": "{s}",
        "b_143": "{small}",
        "b_144": "{xs}",
        "b_145": "{small}",
        "b_146": "{custom_5}",
        "b_147": "{s}",
        "b_148": "{small}",
        "b_149": "{xs}",
        "b_150": "{small}",
        "b_151": "{custom_5}",
        "b_152": "{base}",
        "b_153": "{small}",
        "b_154": "{custom_19}",
        "b_155": "{small}",
        "b_156": "{custom_5}",
        "b_157": "{custom_18}",
        "b_158": "{small}",
        "b_159": "{s}",
        "b_160": "{small}",
        "b_161": "{custom_5}",
        "b_162": "{m}",
        "b_163": "{small}",
        "b_164": "{base}",
        "b_165": "{small}",
        "b_166": "{custom_5}",
        "b_167": "{custom_3}",
        "b_168": "{small}",
        "b_169": "{base}",
        "b_170": "{medium}",
        "b_171": "{custom_5}",
        "b_172": "{l}",
        "b_173": "{medium}",
        "b_174": "{custom_18}",
        "b_175": "{custom_1}",
        "b_176": "{custom_5}",
        "b_177": "{xl}",
        "b_178": "{custom_1}",
        "b_179": "{m}",
        "b_180": "{base}",
        "b_181": "{base}",
        "b_182": "{base}",
        "b_183": "{custom_18}",
        "b_184": "{xs}",
        "b_185": "{m}",
        "b_186": "{xs}",
        "b_187": "{custom_3}",
        "b_188": "{l}",
        "b_189": "{xl}",
        "b_190": "{s}",
        "b_191": "{base}",
        "b_192": "{base}",
        "b_193": "{base}",
        "b_194": "{custom_18}",
        "b_195": "{m}",
        "b_196": "{custom_3}",
        "b_197": "{l}",
        "b_198": "{xl}",
        "b_199": "{base}",
        "b_200": "{base}",
        "b_201": "{base}",
        "b_202": "{custom_18}",
        "b_203": "{m}",
        "b_204": "{custom_3}",
        "b_205": "{l}",
        "b_206": "{xl}",
        "b_207": "{sparkle20}",
        "b_208": "{sparkle20}",
        "b_209": "{sparkle60}",
        "b_210": "{feedbackSuccess20}",
        "b_211": "{feedbackSuccess20}",
        "b_212": "{feedbackSuccess50}",
        "b_213": "{feedbackWarning20}",
        "b_214": "{feedbackWarning20}",
        "b_215": "{feedbackWarning50}",
        "b_216": "{feedbackError20}",
        "b_217": "{feedbackError20}",
        "b_218": "{feedbackError50}",
        "b_219": "{primaryGrey20}",
        "b_220": "{primaryGrey20}",
        "b_221": "{primaryGrey80}",
        "b_222": "{global.transparent}",
        "b_223": "{global.transparent}",
        "b_224": "{sparkle60}",
        "b_225": "{global.transparent}",
        "b_226": "{global.transparent}",
        "b_227": "{feedbackSuccess50}",
        "b_228": "{global.transparent}",
        "b_229": "{global.transparent}",
        "b_230": "{feedbackWarning50}",
        "b_231": "{global.transparent}",
        "b_232": "{global.transparent}",
        "b_233": "{feedbackError50}",
        "b_234": "{global.transparent}",
        "b_235": "{global.transparent}",
        "b_236": "{primaryGrey80}",
        "b_237": "{global.transparent}",
        "b_238": "{global.transparent}",
        "b_239": "{sparkle60}",
        "b_240": "{global.transparent}",
        "b_241": "{global.transparent}",
        "b_242": "{feedbackSuccess50}",
        "b_243": "{global.transparent}",
        "b_244": "{global.transparent}",
        "b_245": "{feedbackWarning50}",
        "b_246": "{global.transparent}",
        "b_247": "{global.transparent}",
        "b_248": "{feedbackError50}",
        "b_249": "{global.transparent}",
        "b_250": "{global.transparent}",
        "b_251": "{primaryGrey80}",
        "b_252": "{custom_4}",
        "b_253": "{custom_4}",
        "b_254": "{custom_4}",
        "b_255": "{custom_16}",
        "b_256": "{custom_16}",
        "b_257": "{custom_16}",
        "b_258": "{xxs}",
        "b_259": "{custom_4}",
        "b_260": "{custom_4}",
        "b_261": "{global.transparent}",
        "b_262": "{global.transparent}",
        "b_263": "{secondary60}",
        "b_264": "{global.transparent}",
        "b_265": "{global.tansparent}",
        "b_266": "{secondary60}",
        "b_267": "{secondary20}",
        "b_268": "{secondary20}",
        "b_269": "{secondary60}",
        "b_270": "{global.transparent}",
        "b_271": "{custom_5}"
    },
    "JDSBadgeV2Notification": {
        "b_0": "{flexDirection.row}",
        "b_1": "{justifyContent.center}",
        "b_2": "{alignItems.center}",
        "b_3": "{xs}",
        "b_4": "{xs}",
        "b_5": "{feedbackError50}",
        "b_6": "{pill}",
        "b_7": "{custom_5}",
        "b_8": "{global.transparent}",
        "b_9": "{primaryBackground}",
        "b_10": "{custom_4}",
        "b_11": "{s}",
        "b_12": "{s}",
        "b_13": "{base}",
        "b_14": "{base}",
        "b_15": "{custom_4}",
        "b_16": "{custom_18}",
        "b_17": "{custom_18}",
        "b_18": "{custom_4}",
        "b_19": "{m}",
        "b_20": "{m}",
        "b_21": "{custom_16}",
        "b_22": "{custom_3}",
        "b_23": "{custom_3}",
        "b_24": "{custom_16}",
        "b_25": "{l}",
        "b_26": "{l}",
        "b_27": "{custom_16}",
        "b_28": "{xl}",
        "b_29": "{xl}",
        "b_30": "{xxs}",
        "b_31": "{custom_1}",
        "b_32": "{base}",
        "b_33": "{base}",
        "b_34": "{base}",
        "b_35": "{base}",
        "b_36": "{base}",
        "b_37": "{base}",
        "b_38": "{custom_18}",
        "b_39": "{custom_18}",
        "b_40": "{m}",
        "b_41": "{m}",
        "b_42": "{custom_3}",
        "b_43": "{custom_3}",
        "b_44": "{l}",
        "b_45": "{l}",
        "b_46": "{xl}",
        "b_47": "{xl}",
        "b_48": "{base}",
        "b_49": "{small}",
        "b_50": "{xxs}",
        "b_51": "{xxs}",
        "b_52": "{base}",
        "b_53": "{small}",
        "b_54": "{xxs}",
        "b_55": "{xxs}",
        "b_56": "{base}",
        "b_57": "{small}",
        "b_58": "{xxs}",
        "b_59": "{xxs}",
        "b_60": "{custom_18}",
        "b_61": "{small}",
        "b_62": "{custom_18}",
        "b_63": "{custom_18}",
        "b_64": "{m}",
        "b_65": "{small}",
        "b_66": "{custom_18}",
        "b_67": "{custom_18}",
        "b_68": "{custom_3}",
        "b_69": "{small}",
        "b_70": "{custom_18}",
        "b_71": "{custom_18}",
        "b_72": "{l}",
        "b_73": "{medium}",
        "b_74": "{xs}",
        "b_75": "{xs}",
        "b_76": "{xl}",
        "b_77": "{medium}",
        "b_78": "{xs}",
        "b_79": "{xs}",
        "b_80": "{custom_4}"
    },
    "JDSBadgeV2Status": {
        "b_0": "{flexDirection.row}",
        "b_1": "{justifyContent.center}",
        "b_2": "{alignItems.center}",
        "b_3": "{xs}",
        "b_4": "{flexDirection.row}",
        "b_5": "{justifyContent.center}",
        "b_6": "{alignItems.center}",
        "b_7": "{m}",
        "b_8": "{pill}",
        "b_9": "{feedbackSuccess50}",
        "b_10": "{global.white}",
        "b_11": "{base}",
        "b_12": "{s}",
        "b_13": "{s}",
        "b_14": "{small}",
        "b_15": "{xs}",
        "b_16": "{xs}",
        "b_17": "{small}",
        "b_18": "{xs}",
        "b_19": "{xs}",
        "b_20": "{s}",
        "b_21": "{small}",
        "b_22": "{xs}",
        "b_23": "{xs}",
        "b_24": "{base}",
        "b_25": "{s}",
        "b_26": "{l}",
        "b_27": "{m}",
        "b_28": "{xl}",
        "b_29": "{custom_3}",
        "b_30": "{feedbackError50}",
        "b_31": "{feedbackWarning50}",
        "b_32": "{primaryGrey60}",
        "b_33": "{primaryBackground}",
        "b_34": "{primaryBackground}",
        "b_35": "{xs}",
        "b_36": "{base}",
        "b_37": "{m}",
        "b_38": "{l}",
        "b_39": "{xs}",
        "b_40": "{base}",
        "b_41": "{m}",
        "b_42": "{l}",
        "b_43": "{m}",
        "b_44": "{base}",
        "b_45": "{m}",
        "b_46": "{base}",
        "b_47": "{medium}",
        "b_48": "{medium}",
        "b_49": "{xs}",
        "b_50": "{medium}",
        "b_51": "{base}",
        "b_52": "{medium}",
        "b_53": "{m}",
        "b_54": "{l}",
        "b_55": "{medium}",
        "b_56": "{base}",
        "b_57": "{s}",
        "b_58": "{medium}",
        "b_59": "{m}",
        "b_60": "{base}",
        "b_61": "{feedbackSuccess50}",
        "b_62": "{feedbackError50}",
        "b_63": "{feedbackWarning50}",
        "b_64": "{primaryGrey60}",
        "b_65": "{feedbackSuccess50}",
        "b_66": "{global.white}",
        "b_67": "{feedbackError50}",
        "b_68": "{global.white}",
        "b_69": "{feedbackWarning50}",
        "b_70": "{global.white}",
        "b_71": "{primaryGrey60}",
        "b_72": "{global.white}",
        "b_73": "{feedbackSuccess50}",
        "b_74": "{global.white}",
        "b_75": "{feedbackSuccess50}",
        "b_76": "{feedbackError50}",
        "b_77": "{global.white}",
        "b_78": "{feedbackError50}",
        "b_79": "{feedbackWarning50}",
        "b_80": "{global.white}",
        "b_81": "{feedbackWarning50}",
        "b_82": "{primaryGrey60}",
        "b_83": "{global.white}",
        "b_84": "{primaryGrey60}",
        "b_85": "{border_normal}",
        "b_86": "{border_normal}",
        "b_87": "{border_thick}",
        "b_88": "{border_thick}",
        "b_89": "{border_thick}",
        "b_90": "{border_normal}",
        "b_91": "{border_normal}",
        "b_92": "{border_thick}",
        "b_93": "{border_thick}",
        "b_94": "{border_thick}",
        "b_95": "{border_normal}",
        "b_96": "{border_normal}",
        "b_97": "{border_thick}",
        "b_98": "{border_thick}",
        "b_99": "{border_thick}"
    },
    "JDSBaseIcon": {
        "b_0": "{base}",
        "b_1": "{primary50}",
        "b_2": "{primary30}",
        "b_3": "{primary60}",
        "b_4": "{primary70}",
        "b_5": "{primaryBackground}",
        "b_6": "{secondary50}",
        "b_7": "{sparkle50}",
        "b_8": "{primaryGrey60}",
        "b_9": "{primaryGrey80}",
        "b_10": "{primaryGrey100}",
        "b_11": "{feedbackSuccess50}",
        "b_12": "{feedbackError50}",
        "b_13": "{feedbackWarning50}",
        "b_14": "{global.white}",
        "b_15": "{custom_color_1}"
    },
    "JDSDesktopBottomSheet": {
        "d_0": "{flexDirection.row}",
        "d_1": "{justifyContent.end}",
        "d_2": "{alignItems.end}",
        "d_3": "{custom_color_3}",
        "d_4": "{size.max}",
        "d_5": "{flexDirection.column}",
        "d_6": "{justifyContent.start}",
        "d_7": "{primaryBackground}",
        "d_8": "{alignItems.start}",
        "d_9": "{xl}",
        "d_10": "{xl}",
        "d_11": "{flexDirection.row}",
        "d_12": "{justifyContent.end}",
        "d_13": "{alignItems.center}",
        "d_14": "{size.max}",
        "d_15": "{xxs}",
        "d_16": "{xxs}",
        "d_17": "{xs}",
        "d_18": "{s}",
        "d_19": "{s}",
        "d_20": "{flexDirection.column}",
        "d_21": "{justifyContent.start}",
        "d_22": "{alignItems.start}",
        "d_23": "{m}",
        "d_24": "{m}",
        "d_25": "{size.max}",
        "d_26": "{xs}",
        "d_27": "{m}",
        "d_28": "{flexDirection.column}",
        "d_29": "{base}",
        "d_30": "{size.max}",
        "d_31": "{m}",
        "d_32": "{m}",
        "d_33": "{base}",
        "d_34": "{custom_color_5}"
    },
    "JDSDesktopBottomSheetInternal": {
        "d_0": "{flexDirection.stack}",
        "d_1": "{flexDirection.column}",
        "d_2": "{justifyContent.start}",
        "d_3": "{alignItems.start}",
        "d_4": "{primaryBackground}",
        "d_5": "{xl}",
        "d_6": "{xl}",
        "d_7": "{m}",
        "d_8": "{m}",
        "d_9": "{m}",
        "d_10": "{m}",
        "d_11": "{custom_28}",
        "d_12": "{size.max}",
        "d_13": "{justifyContent.end}",
        "d_14": "{alignItems.end}",
        "d_15": "{custom_28}",
        "d_16": "{size.max}",
        "d_17": "{medium}",
        "d_18": "{easeEntrance}",
        "d_19": "{flexDirection.row}",
        "d_20": "{justifyContent.end}",
        "d_21": "{alignItems.end}",
        "d_22": "{custom_color_3}",
        "d_23": "{size.max}",
        "d_24": "{flexDirection.column}",
        "d_25": "{justifyContent.start}",
        "d_26": "{primaryBackground}",
        "d_27": "{alignItems.start}",
        "d_28": "{xl}",
        "d_29": "{xl}",
        "d_30": "{flexDirection.row}",
        "d_31": "{justifyContent.end}",
        "d_32": "{alignItems.center}",
        "d_33": "{size.max}",
        "d_34": "{xxs}",
        "d_35": "{xxs}",
        "d_36": "{xs}",
        "d_37": "{s}",
        "d_38": "{s}",
        "d_39": "{flexDirection.column}",
        "d_40": "{justifyContent.start}",
        "d_41": "{alignItems.start}",
        "d_42": "{m}",
        "d_43": "{m}",
        "d_44": "{size.max}",
        "d_45": "{xs}",
        "d_46": "{m}",
        "d_47": "{flexDirection.column}",
        "d_48": "{base}",
        "d_49": "{size.max}",
        "d_50": "{m}",
        "d_51": "{m}",
        "d_52": "{base}",
        "d_53": "{custom_color_5}",
        "d_54": "{bottomsheet_padding_right}",
        "d_55": "{opacity.invisible}",
        "d_56": "{medium}",
        "d_57": "{easeEntrance}",
        "d_58": "{global.transparent}",
        "d_59": "{global.transparent}",
        "d_60": "{opacity.enabled}",
        "d_61": "{easeExit}"
    },
    "JDSBreadcrumbs": {
        "b_0": "{flexDirection.row}",
        "b_1": "{justifyContent.start}",
        "b_2": "{alignItems.start}",
        "b_3": "{m}",
        "b_4": "{flexDirection.row}",
        "b_5": "{justifyContent.start}",
        "b_6": "{alignItems.start}"
    },
    "JDSCarousel": {
        "c_0": "{flexDirection.column}",
        "c_1": "{justifyContent.center}",
        "c_2": "{alignItems.center}",
        "c_3": "{base}",
        "c_4": "{size.max}",
        "c_5": "{size.max}",
        "c_6": "{flexDirection.row}",
        "c_7": "{justifyContent.spaceBetween}",
        "c_8": "{alignItems.center}",
        "c_9": "{base}",
        "c_10": "{size.max}",
        "c_11": "{size.max}",
        "c_12": "{flexDirection.row}",
        "c_13": "{justifyContent.start}",
        "c_14": "{alignItems.center}",
        "c_15": "{base}",
        "c_16": "{xs}",
        "c_17": "{xs}",
        "c_18": "{flexDirection.column}",
        "c_19": "{justifyContent.center}",
        "c_20": "{alignItems.start}",
        "c_21": "{flexDirection.stack}",
        "c_22": "{justifyContent.center}",
        "c_23": "{alignItems.center}",
        "c_24": "{flexDirection.row}",
        "c_25": "{justifyContent.start}",
        "c_26": "{alignItems.start}",
        "c_27": "{size.max}",
        "c_28": "{flexDirection.row}",
        "c_29": "{justifyContent.end}",
        "c_30": "{alignItems.start}",
        "c_31": "{s}",
        "c_32": "{xs}",
        "c_33": "{xs}",
        "c_34": "{xs}"
    },
    "JDSCarouselPagination": {
        "c_0": "{flexDirection.row}",
        "c_1": "{justifyContent.center}",
        "c_2": "{alignItems.center}",
        "c_3": "{s}",
        "c_4": "{xs}",
        "c_5": "{size.max}",
        "c_6": "{xs}",
        "c_7": "{xs}"
    },
    "JDSButton": {
        "b_0": "{opacity.enabled}",
        "b_1": "{primary50}",
        "b_2": "{flexDirection.row}",
        "b_3": "{alignItems.center}",
        "b_4": "{justifyContent.center}",
        "b_5": "{pill}",
        "b_6": "0",
        "b_7": "",
        "b_8": "{xs}",
        "b_9": 0,
        "b_10": "{primary60}",
        "b_11": "{primary60}",
        "b_12": "{border_focus}",
        "b_13": "{primary80}",
        "b_14": "{flexDirection.row}",
        "b_15": "{alignItems.center}",
        "b_16": "{justifyContent.start}",
        "b_17": "{xs}",
        "b_18": "{primaryInverse}",
        "b_19": "{global.transparent}",
        "b_20": "{border_focus}",
        "b_21": "{opacity.enabled}",
        "b_22": "{base}",
        "b_23": "{m}",
        "b_24": "{primaryInverse}",
        "b_25": "{m}",
        "b_26": "{primaryInverse}",
        "b_27": "{size.max}",
        "b_28": "{justifyContent.spaceBetween}",
        "b_29": "{opacity.disabled}",
        "b_30": "{primary30}",
        "b_31": "{primary30}",
        "b_32": "{feedbackError20}",
        "b_33": "{feedbackError50}",
        "b_34": "{feedbackError80}",
        "b_35": "{feedbackError50}",
        "b_36": "{feedbackError80}",
        "b_37": "{feedbackError80}",
        "b_38": "{global.white}",
        "b_39": "{feedbackError20}",
        "b_40": "{global.white}",
        "b_41": "{feedbackError80}",
        "b_42": "{feedbackError20}",
        "b_43": "{feedbackSuccess20}",
        "b_44": "{feedbackSuccess50}",
        "b_45": "{feedbackSuccess80}",
        "b_46": "{feedbackSuccess50}",
        "b_47": "{feedbackSuccess80}",
        "b_48": "{feedbackSuccess80}",
        "b_49": "{global.white}",
        "b_50": "{feedbackSuccess20}",
        "b_51": "{feedbackSuccess80}",
        "b_52": "{global.white}",
        "b_53": "{feedbackSuccess20}",
        "b_54": "{global.transparent}",
        "b_55": "{border_thin}",
        "b_56": "{primaryGrey40}",
        "b_57": "{primary60}",
        "b_58": "{global.transparent}",
        "b_59": "{primary20}",
        "b_60": "{primary60}",
        "b_61": "{primary80}",
        "b_62": "{primary60}",
        "b_63": "{primary60}",
        "b_64": "{primary60}",
        "b_65": "{global.transparent}",
        "b_66": "{border_thin}",
        "b_67": "{primaryGrey40}",
        "b_68": "{feedbackError20}",
        "b_69": "{feedbackError80}",
        "b_70": "{feedbackError50}",
        "b_71": "{border_focus}",
        "b_72": "{feedbackError80}",
        "b_73": "{feedbackError80}",
        "b_74": "{feedbackError80}",
        "b_75": "{global.transparent}",
        "b_76": "{border_thin}",
        "b_77": "{primaryGrey40}",
        "b_78": "{feedbackSuccess20}",
        "b_79": "{feedbackSuccess80}",
        "b_80": "{feedbackSuccess50}",
        "b_81": "{border_focus}",
        "b_82": "{feedbackSuccess80}",
        "b_83": "{feedbackSuccess80}",
        "b_84": "{feedbackSuccess80}",
        "b_85": "{global.transparent}",
        "b_86": "{primary20}",
        "b_87": "{primary30}",
        "b_88": "{primary80}",
        "b_89": "{primary20}",
        "b_90": "{primary60}",
        "b_91": "{primary60}",
        "b_92": "{primary60}",
        "b_93": "{global.transparent}",
        "b_94": "{feedbackError20}",
        "b_95": "{feedbackError80}",
        "b_96": "{feedbackError50}",
        "b_97": "{border_focus}",
        "b_98": "{feedbackError20}",
        "b_99": "{feedbackError80}",
        "b_100": "{feedbackError80}",
        "b_101": "{feedbackError80}",
        "b_102": "{global.transparent}",
        "b_103": "{feedbackSuccess20}",
        "b_104": "{feedbackSuccess50}",
        "b_105": "{border_focus}",
        "b_106": "{feedbackSuccess80}",
        "b_107": "{feedbackSuccess80}",
        "b_108": "{feedbackSuccess80}",
        "b_109": "{xxs}",
        "b_110": "{base}",
        "b_111": "{xxs}",
        "b_112": "{base}",
        "b_113": "{base}",
        "b_114": "{base}",
        "b_115": "{base}",
        "b_116": "{s}",
        "b_117": "{base}",
        "b_118": "{s}",
        "b_119": "{base}",
        "b_120": "{m}",
        "b_121": "{m}",
        "b_122": "{m}",
        "b_123": "{base}",
        "b_124": "{m}",
        "b_125": "{base}",
        "b_126": "{m}",
        "b_127": "{m}",
        "b_128": "{m}",
        "b_129": "{m}",
        "b_130": "{l}",
        "b_131": "{l}",
        "b_132": "{base}",
        "b_133": "{base}",
        "b_134": "{base}",
        "b_135": "{xxl}",
        "b_136": "{xxl}",
        "b_137": "{m}",
        "b_138": "{m}",
        "b_139": "{m}",
        "b_140": "{m}",
        "b_141": "{m}",
        "b_142": "{m}",
        "b_143": "{justifyContent.center}",
        "b_144": "{justifyContent.center}",
        "b_145": "{justifyContent.center}",
        "b_146": "{justifyContent.center}",
        "b_147": "{justifyContent.center}"
    },
    "JDSCarouselPaginationItem": {
        "c_0": "{s}",
        "c_1": "{s}",
        "c_2": "{primary60}",
        "c_3": "{opacity.disabled}",
        "c_4": "{pill}",
        "c_5": "{primary40}",
        "c_6": "{opacity.enabled}",
        "c_7": "{primary60}",
        "c_8": "{opacity.enabled}",
        "c_9": "{xs}",
        "c_10": "{opacity.enabled}",
        "c_11": "{primary70}",
        "c_12": "{primary70}",
        "c_13": "{s}",
        "c_14": "{xs}",
        "c_15": "{xs}",
        "c_16": "{custom_15}",
        "c_17": "{custom_15}",
        "c_18": "{xs}",
        "c_19": "{custom_15}",
        "c_20": "{custom_15}",
        "c_21": "{xxs}",
        "c_22": "{xxs}",
        "c_23": "{m}",
        "c_24": "{m}",
        "c_25": "{m}",
        "c_26": "{l}",
        "c_27": "{l}",
        "c_28": "{l}"
    },
    "JDSCarouselSlide": {
        "c_0": "{size.max}",
        "c_1": "{small}",
        "c_2": "{size.max}"
    },
    "JDSCheckbox": {
        "c_0": "{flexDirection.column}",
        "c_1": "{justifyContent.start}",
        "c_2": "{alignItems.start}",
        "c_3": "{xs}",
        "c_4": "{flexDirection.row}",
        "c_5": "{justifyContent.start}",
        "c_6": "{alignItems.center}",
        "c_7": "{xs}",
        "c_8": "{m}",
        "c_9": "{m}",
        "c_10": "{flexDirection.row}",
        "c_11": "{justifyContent.center}",
        "c_12": "{alignItems.center}",
        "c_13": "{global.transparent}",
        "c_14": "{small}",
        "c_15": "{border_thin}",
        "c_16": "{primaryGrey80}",
        "c_17": "{primary40}",
        "c_18": "{primary60}",
        "c_19": "{border_focus}",
        "c_20": "{primary60}",
        "c_21": "{base}",
        "c_22": "{textAlign.start}",
        "c_23": "{base}",
        "c_24": "{base}",
        "c_25": "{xxs}",
        "c_26": "{s}",
        "c_27": "ic_confirm",
        "c_28": "{primary50}",
        "c_29": "{primary40}",
        "c_30": "{primary60}",
        "c_31": "{primaryInverse}",
        "c_32": "ic_minus",
        "c_33": "{primary50}",
        "c_34": "{primary40}",
        "c_35": "{primary50}",
        "c_36": "{primaryInverse}",
        "c_37": "{opacity.disabled}",
        "c_38": "{opacity.enabled}"
    },
    "JDSContentBlock": {
        "c_0": "{flexDirection.column}",
        "c_1": "{alignItems.start}",
        "c_2": "{justifyContent.start}",
        "c_3": "{size.max}",
        "c_4": "{flexDirection.column}",
        "c_5": "{alignItems.start}",
        "c_6": "{justifyContent.start}",
        "c_7": "{size.max}",
        "c_8": "{xs}",
        "c_9": "{xxs}",
        "c_10": "{m}",
        "c_11": "{m}",
        "c_12": "{flexDirection.row}",
        "c_13": "{size.max}",
        "c_14": "{xs}",
        "c_15": "{s}",
        "c_16": "{s}",
        "c_17": "{s}",
        "c_18": "{s}",
        "c_19": "{base}",
        "c_20": "{base}",
        "c_21": "{l}",
        "c_22": "{s}",
        "c_23": "{base}",
        "c_24": "{base}",
        "c_25": "{l}",
        "c_26": "{s}",
        "c_27": "{flexDirection.column}",
        "c_28": "{size.max}",
        "c_29": "{size.max}",
        "c_30": "{base}",
        "c_31": "{m}",
        "c_32": "{m}",
        "c_33": "{flexDirection.row}",
        "c_34": "{justifyContent.spaceBetween}",
        "c_35": "{alignItems.center}",
        "c_36": "{flexDirection.row}",
        "c_37": "{justifyContent.end}",
        "c_38": "{alignItems.center}"
    },
    "JDSDatepickerButton": {
        "d_0": "{xxl}",
        "d_1": "{custom_9}",
        "d_2": "{pill}",
        "d_3": "{global.transparent}",
        "d_4": "{border_thin}",
        "d_5": "{primaryGrey40}",
        "d_6": "{flexDirection.row}",
        "d_7": "{justifyContent.center}",
        "d_8": "{alignItems.center}",
        "d_9": "{xs}",
        "d_10": "{base}",
        "d_11": "{base}",
        "d_12": "{primary60}",
        "d_13": "{primaryGrey100}",
        "d_14": "{border_focus}",
        "d_15": "{primary60}",
        "d_16": "{primary20}",
        "d_17": "{primary20}",
        "d_18": "{primary60}",
        "d_19": "{border_none}",
        "d_20": "{opacity.disabled}",
        "d_21": "{border_none}"
    },
    "JDSContentCard": {
        "c_0": "{size.max}",
        "c_1": "{xl}",
        "c_2": "{flexDirection.column}",
        "c_3": "{justifyContent.start}",
        "c_4": "{alignItems.start}",
        "c_5": "{primaryBackground}",
        "c_6": "{justifyContent.start}",
        "c_7": "{alignItems.start}",
        "c_8": "{size.max}",
        "c_9": "{base}",
        "c_10": "{base}",
        "c_11": "{base}",
        "c_12": "{justifyContent.start}",
        "c_13": "{alignItems.start}",
        "c_14": "{size.max}",
        "c_15": "{base}",
        "c_16": "{base}",
        "c_17": "{base}",
        "c_18": "{flexDirection.column}",
        "c_19": "{size.max}",
        "c_20": "{justifyContent.start}",
        "c_21": "{alignItems.start}",
        "c_22": "{base}",
        "c_23": "{base}",
        "c_24": "{base}",
        "c_25": "{base}",
        "c_26": "{base}",
        "c_27": "{base}",
        "c_28": "{base}",
        "c_29": "{base}",
        "c_30": "{base}",
        "c_31": "{base}",
        "c_32": "{flexDirection.row}",
        "c_33": "{custom_10}",
        "c_34": "{size.max}",
        "c_35": "{base}",
        "c_36": "{base}",
        "c_37": "{flexDirection.row}",
        "c_38": "{size.max}"
    },
    "JDSDatepickerCalendarButton": {
        "d_0": "{flexDirection.row}",
        "d_1": "{justifyContent.center}",
        "d_2": "{alignItems.center}",
        "d_3": "{custom_7}",
        "d_4": "{m}",
        "d_5": "{size.max}",
        "d_6": "{xxl}",
        "d_7": "{m}",
        "d_8": "{flexDirection.row}",
        "d_9": "{justifyContent.center}",
        "d_10": "{alignItems.center}",
        "d_11": "{xxl}",
        "d_12": "{intrinsicSize.min}",
        "d_13": "{xxl}",
        "d_14": "{pill}",
        "d_15": "{primaryGrey100}",
        "d_16": "{global.transparent}",
        "d_17": "{primary20}",
        "d_18": "{primary40}",
        "d_19": "{primary20}",
        "d_20": "{border_focus}",
        "d_21": "{primary50}",
        "d_22": "{primary20}",
        "d_23": "{opacity.disabled}",
        "d_24": "{base}",
        "d_25": "{base}"
    },
    "JDSDatepickerCalendar": {
        "d_0": "{flexDirection.column}",
        "d_1": "{justifyContent.start}",
        "d_2": "{alignItems.center}",
        "d_3": "{s}",
        "d_4": "{flexDirection.column}"
    },
    "JDSDatepickerCalendarRow": {
        "d_0": "{flexDirection.row}",
        "d_1": "{justifyContent.start}",
        "d_2": "{alignItems.center}",
        "d_3": "{size.max}"
    },
    "JDSAccordion": {
        "a_0": "{flexDirection.column}",
        "a_1": "{size.max}",
        "a_2": "{flexDirection.row}",
        "a_3": "{alignItems.center}",
        "a_4": "{justifyContent.start}",
        "a_5": "{size.max}",
        "a_6": "{xxs}",
        "a_7": "{s}",
        "a_8": "{flexDirection.column}",
        "a_9": "{justifyContent.start}",
        "a_10": "{alignItems.start}",
        "a_11": "{xxs}",
        "a_12": "0",
        "a_13": "{size.max}",
        "a_14": "{size.max}",
        "a_15": "{opacity.enabled}",
        "a_16": "{base}",
        "a_17": "{opacity.disabled}",
        "a_18": "ic_minus",
        "a_19": "ic_add",
        "a_20": "ic_chevron_up",
        "a_21": "ic_chevron_down"
    },
    "JDSDatepickerCalendarHeader": {
        "d_0": "{flexDirection.row}",
        "d_1": "{justifyContent.center}",
        "d_2": "{alignItems.center}",
        "d_3": "{size.max}"
    },
    "JDSDatepickerDesktop": {
        "d_0": "{flexDirection.column}",
        "d_1": "{justifyContent.start}",
        "d_2": "{alignItems.center}",
        "d_3": "{opacity.invisible}",
        "d_4": "{primaryBackground}",
        "d_5": "{flexDirection.column}",
        "d_6": "{justifyContent.start}",
        "d_7": "{alignItems.center}",
        "d_8": "{xl}",
        "d_9": "{flexDirection.row}",
        "d_10": "{justifyContent.end}",
        "d_11": "{alignItems.center}",
        "d_12": "{xs}",
        "d_13": "{s}",
        "d_14": "{xs}",
        "d_15": "{s}",
        "d_16": "{custom_6}",
        "d_17": "{m}",
        "d_18": "{m}",
        "d_19": "{flexDirection.column}",
        "d_20": "{justifyContent.start}",
        "d_21": "{alignItems.center}",
        "d_22": "{m}",
        "d_23": "{flexDirection.column}",
        "d_24": "{justifyContent.start}",
        "d_25": "{alignItems.center}",
        "d_26": "{size.max}",
        "d_27": "{size.max}",
        "d_28": "{m}",
        "d_29": "{m}",
        "d_30": "{m}",
        "d_31": "{opacity.enabled}",
        "d_32": "{justifyContent.spaceBetween}",
        "d_33": "{justifyContent.spaceBetween}"
    },
    "JDSDatepickerDesktopInternal": {
        "d_0": "{flexDirection.column}",
        "d_1": "{justifyContent.start}",
        "d_2": "{alignItems.center}",
        "d_3": "{opacity.invisible}",
        "d_4": "{primaryBackground}",
        "d_5": "{flexDirection.column}",
        "d_6": "{justifyContent.start}",
        "d_7": "{alignItems.center}",
        "d_8": "{xl}",
        "d_9": "{flexDirection.row}",
        "d_10": "{justifyContent.end}",
        "d_11": "{alignItems.center}",
        "d_12": "{xs}",
        "d_13": "{s}",
        "d_14": "{xs}",
        "d_15": "{s}",
        "d_16": "{custom_6}",
        "d_17": "{m}",
        "d_18": "{m}",
        "d_19": "{flexDirection.column}",
        "d_20": "{justifyContent.start}",
        "d_21": "{alignItems.center}",
        "d_22": "{m}",
        "d_23": "{flexDirection.column}",
        "d_24": "{justifyContent.start}",
        "d_25": "{alignItems.center}",
        "d_26": "{size.max}",
        "d_27": "{size.max}",
        "d_28": "{m}",
        "d_29": "{m}",
        "d_30": "{m}",
        "d_31": "{opacity.enabled}",
        "d_32": "{justifyContent.spaceBetween}",
        "d_33": "{justifyContent.spaceBetween}"
    },
    "JDSDatepickerHeader": {
        "d_0": "{size.max}",
        "d_1": "{xxl}",
        "d_2": "{flexDirection.row}",
        "d_3": "{justifyContent.spaceBetween}",
        "d_4": "{alignItems.center}",
        "d_5": "{xxl}",
        "d_6": "{flexDirection.row}",
        "d_7": "{justifyContent.center}",
        "d_8": "{alignItems.center}",
        "d_9": "{s}"
    },
    "JDSDatepickerYearView": {
        "d_0": "{flexDirection.column}",
        "d_1": "{size.max}",
        "d_2": "{alignItems.center}"
    },
    "JDSDatepickerMonthView": {
        "d_0": "{flexDirection.column}",
        "d_1": "{custom_8}",
        "d_2": "{size.max}",
        "d_3": "{alignItems.center}"
    },
    "JDSDatepickerMobile": {
        "d_0": "{primaryBackground}",
        "d_1": "{flexDirection.column}",
        "d_2": "{justifyContent.start}",
        "d_3": "{alignItems.center}",
        "d_4": "{size.max}",
        "d_5": "{flexDirection.row}",
        "d_6": "{justifyContent.end}",
        "d_7": "{alignItems.center}",
        "d_8": "{xs}",
        "d_9": "{xs}",
        "d_10": "{s}",
        "d_11": "{s}",
        "d_12": "{size.max}",
        "d_13": "{flexDirection.column}",
        "d_14": "{justifyContent.start}",
        "d_15": "{alignItems.center}",
        "d_16": "{m}",
        "d_17": "{s}",
        "d_18": "{s}",
        "d_19": "{s}",
        "d_20": "{s}",
        "d_21": "{m}",
        "d_22": "{s}",
        "d_23": "{s}",
        "d_24": "{s}",
        "d_25": "{s}",
        "d_26": "{m}",
        "d_27": "{flexDirection.column}",
        "d_28": "{s}",
        "d_29": "{justifyContent.start}",
        "d_30": "{alignItems.center}",
        "d_31": "{size.max}",
        "d_32": "{m}",
        "d_33": "{m}",
        "d_34": "{flexDirection.column}",
        "d_35": "{justifyContent.start}",
        "d_36": "{alignItems.center}",
        "d_37": "{s}",
        "d_38": "{size.max}",
        "d_39": "{justifyContent.spaceBetween}",
        "d_40": "{justifyContent.spaceBetween}"
    },
    "JDSDatepickerMobileInteral": {
        "d_0": "{primaryBackground}",
        "d_1": "{flexDirection.column}",
        "d_2": "{justifyContent.start}",
        "d_3": "{alignItems.center}",
        "d_4": "{size.max}",
        "d_5": "{flexDirection.row}",
        "d_6": "{justifyContent.end}",
        "d_7": "{alignItems.center}",
        "d_8": "{xs}",
        "d_9": "{xs}",
        "d_10": "{s}",
        "d_11": "{s}",
        "d_12": "{size.max}",
        "d_13": "{flexDirection.column}",
        "d_14": "{justifyContent.start}",
        "d_15": "{alignItems.center}",
        "d_16": "{m}",
        "d_17": "{s}",
        "d_18": "{s}",
        "d_19": "{s}",
        "d_20": "{s}",
        "d_21": "{m}",
        "d_22": "{s}",
        "d_23": "{s}",
        "d_24": "{s}",
        "d_25": "{s}",
        "d_26": "{m}",
        "d_27": "{flexDirection.column}",
        "d_28": "{s}",
        "d_29": "{justifyContent.start}",
        "d_30": "{alignItems.center}",
        "d_31": "{size.max}",
        "d_32": "{m}",
        "d_33": "{m}",
        "d_34": "{flexDirection.column}",
        "d_35": "{justifyContent.start}",
        "d_36": "{alignItems.center}",
        "d_37": "{s}",
        "d_38": "{size.max}",
        "d_39": "{justifyContent.spaceBetween}",
        "d_40": "{justifyContent.spaceBetween}"
    },
    "JDSDivider": {
        "d_0": "{global.transparent}",
        "d_1": "{flexDirection.row}",
        "d_2": "{justifyContent.center}",
        "d_3": "{alignItems.center}",
        "d_4": "{xs}",
        "d_5": "{s}",
        "d_6": "{s}",
        "d_7": "{s}",
        "d_8": "{s}",
        "d_9": "{custom_5}",
        "d_10": "{custom_5}",
        "d_11": "{flexDirection.row}",
        "d_12": "{primaryGrey40}",
        "d_13": "{pill}",
        "d_14": "{custom_5}",
        "d_15": "{custom_5}",
        "d_16": "{flexDirection.row}",
        "d_17": "{primaryGrey40}",
        "d_18": "{pill}",
        "d_19": "{sparkle50}",
        "d_20": "{sparkle50}",
        "d_21": "{size.max}",
        "d_22": "{size.max}",
        "d_23": "{flexDirection.column}",
        "d_24": "{flexDirection.column}",
        "d_25": "{flexDirection.column}",
        "d_26": "{base}",
        "d_27": "{base}",
        "d_28": "{base}",
        "d_29": "{base}",
        "d_30": "{base}",
        "d_31": "{base}",
        "d_32": "{base}",
        "d_33": "{base}",
        "d_34": "{base}",
        "d_35": "{base}",
        "d_36": "{base}",
        "d_37": "{base}",
        "d_38": "{m}",
        "d_39": "{m}",
        "d_40": "{m}",
        "d_41": "{m}",
        "d_42": "{m}",
        "d_43": "{m}",
        "d_44": "{m}",
        "d_45": "{m}",
        "d_46": "{m}",
        "d_47": "{m}",
        "d_48": "{m}",
        "d_49": "{m}",
        "d_50": "{xs}",
        "d_51": "{xs}",
        "d_52": "{xs}",
        "d_53": "{xs}",
        "d_54": "{xs}",
        "d_55": "{xs}",
        "d_56": "{xs}",
        "d_57": "{xs}",
        "d_58": "{xs}",
        "d_59": "{xs}",
        "d_60": "{xs}",
        "d_61": "{xs}",
        "d_62": "{xxs}",
        "d_63": "{xxs}",
        "d_64": "{xxs}",
        "d_65": "{xxs}",
        "d_66": "{xxs}",
        "d_67": "{xxs}",
        "d_68": "{xxs}",
        "d_69": "{xxs}",
        "d_70": "{xxs}",
        "d_71": "{xxs}",
        "d_72": "{xxs}",
        "d_73": "{xxs}",
        "d_74": "{xxl}",
        "d_75": "{xxl}",
        "d_76": "{xxl}",
        "d_77": "{xxl}",
        "d_78": "{xxl}",
        "d_79": "{xxl}",
        "d_80": "{xxl}",
        "d_81": "{xxl}",
        "d_82": "{xxl}",
        "d_83": "{xxl}",
        "d_84": "{xxl}",
        "d_85": "{xxl}",
        "d_86": "{xl}",
        "d_87": "{xl}",
        "d_88": "{xl}",
        "d_89": "{xl}",
        "d_90": "{xl}",
        "d_91": "{xl}",
        "d_92": "{xl}",
        "d_93": "{xl}",
        "d_94": "{xl}",
        "d_95": "{xl}",
        "d_96": "{xl}",
        "d_97": "{xl}",
        "d_98": "{l}",
        "d_99": "{l}",
        "d_100": "{l}",
        "d_101": "{l}",
        "d_102": "{l}",
        "d_103": "{l}",
        "d_104": "{l}",
        "d_105": "{l}",
        "d_106": "{l}",
        "d_107": "{l}",
        "d_108": "{l}",
        "d_109": "{l}",
        "d_110": "{huge}",
        "d_111": "{huge}",
        "d_112": "{huge}",
        "d_113": "{huge}",
        "d_114": "{huge}",
        "d_115": "{huge}",
        "d_116": "{huge}",
        "d_117": "{huge}",
        "d_118": "{huge}",
        "d_119": "{huge}",
        "d_120": "{huge}",
        "d_121": "{huge}",
        "d_122": "{massive}",
        "d_123": "{massive}",
        "d_124": "{massive}",
        "d_125": "{massive}",
        "d_126": "{massive}",
        "d_127": "{massive}",
        "d_128": "{massive}",
        "d_129": "{massive}",
        "d_130": "{massive}",
        "d_131": "{massive}",
        "d_132": "{massive}",
        "d_133": "{massive}"
    },
    "JDSDatepickerViewButton": {
        "d_0": "{size.max}",
        "d_1": "{flexDirection.row}",
        "d_2": "{justifyContent.center}",
        "d_3": "{alignItems.center}",
        "d_4": "{xxl}",
        "d_5": "{custom_7}",
        "d_6": "{flexDirection.row}",
        "d_7": "{justifyContent.center}",
        "d_8": "{alignItems.center}"
    },
    "JDSFAB": {
        "f_0": "{flexDirection.stack}",
        "f_1": "{justifyContent.end}",
        "f_2": "{alignItems.end}",
        "f_3": "{size.max}",
        "f_4": "{base}",
        "f_5": "{base}",
        "f_6": "{secondary50}",
        "f_7": "{flexDirection.row}",
        "f_8": "{justifyContent.center}",
        "f_9": "{alignItems.center}",
        "f_10": "{xs}",
        "f_11": "{pill}",
        "f_12": "{base}",
        "f_13": "{m}",
        "f_14": "{m}",
        "f_15": "{base}",
        "f_16": "{primary80}",
        "f_17": "{border_none}",
        "f_18": "{secondary60}",
        "f_19": "{secondary60}",
        "f_20": "{secondary60}",
        "f_21": "{border_focus}",
        "f_22": "{m}",
        "f_23": "{secondaryInverse}",
        "f_24": "{pill}",
        "f_25": "{secondary30}",
        "f_26": "{base}",
        "f_27": "{base}"
    },
    "JDSFABInternal": {
        "f_0": "{flexDirection.stack}",
        "f_1": "{justifyContent.end}",
        "f_2": "{alignItems.end}",
        "f_3": "{size.max}",
        "f_4": "{base}",
        "f_5": "{base}",
        "f_6": "{secondary50}",
        "f_7": "{flexDirection.row}",
        "f_8": "{justifyContent.center}",
        "f_9": "{alignItems.center}",
        "f_10": "{xs}",
        "f_11": "{pill}",
        "f_12": "{base}",
        "f_13": "{m}",
        "f_14": "{m}",
        "f_15": "{base}",
        "f_16": "{primary80}",
        "f_17": "{border_none}",
        "f_18": "{secondary60}",
        "f_19": "{secondary60}",
        "f_20": "{secondary60}",
        "f_21": "{border_focus}",
        "f_22": "{m}",
        "f_23": "{secondaryInverse}",
        "f_24": "{pill}",
        "f_25": "{secondary30}",
        "f_26": "{base}",
        "f_27": "{base}"
    },
    "JDSDropdown": {
        "d_0": "{flexDirection.column}",
        "d_1": "{xxs}",
        "d_2": "{size.max}",
        "d_3": "{justifyContent.start}",
        "d_4": "{alignItems.start}",
        "d_5": "{flexDirection.stack}",
        "d_6": "{size.max}",
        "d_7": "{alignItems.end}",
        "d_8": "{justifyContent.start}",
        "d_9": "{xxs}",
        "d_10": "{flexDirection.row}",
        "d_11": "{xs}",
        "d_12": "{flexDirection.row}",
        "d_13": "{justifyContent.end}",
        "d_14": "{size.max}",
        "d_15": "{alignItems.center}",
        "d_16": "{flexDirection.column}",
        "d_17": "{size.max}",
        "d_18": "{alignItems.center}",
        "d_19": "{size.max}",
        "d_20": "{primaryGrey100}",
        "d_21": "{primary50}",
        "d_22": "{primary50}",
        "d_23": "{primary50}",
        "d_24": "{border_thin}",
        "d_25": "{primaryGrey60}",
        "d_26": "{medium}",
        "d_27": "{custom_17}",
        "d_28": "{custom_17}",
        "d_29": "{s}",
        "d_30": "{xs}",
        "d_31": "{primartGrey60}",
        "d_32": "{white}",
        "d_33": "{white}",
        "d_34": "{m}",
        "d_35": "{primaryGrey80}",
        "d_36": "{opacity.disabled}",
        "d_37": "{opacity.enabled}",
        "d_38": "{feedbackSuccess50}",
        "d_39": "{feedbackSuccess50}",
        "d_40": "{feedbackSuccess50}",
        "d_41": "{feedbackSuccess50}",
        "d_42": "{feedbackError50}",
        "d_43": "{feedbackError50}",
        "d_44": "{feedbackError50}",
        "d_45": "{feedbackError50}",
        "d_46": "{feedbackWarning50}",
        "d_47": "{feedbackWarning50}",
        "d_48": "{feedbackWarning50}",
        "d_49": "{feedbackWarning50}",
        "d_50": "{primaryGrey20}",
        "d_51": "{xl}",
        "d_52": "{alignItems.start}",
        "d_53": "{alignItems.start}",
        "d_54": "{alignItems.end}",
        "d_55": "{l}",
        "d_56": "{alignItems.end}",
        "d_57": "{s}",
        "d_58": "{primary60}"
    },
    "JDSDropdownMenu": {
        "d_0": "{global.transparent}",
        "d_1": "{primaryGrey20}",
        "d_2": "{flexDirection.column}",
        "d_3": "{flexDirection.column}",
        "d_4": "{large}",
        "d_5": "{xs}",
        "d_6": "{xs}",
        "d_7": "{base}",
        "d_8": "{base}",
        "d_9": "{base}",
        "d_10": "{custom_color_5}",
        "d_11": "{size.max}",
        "d_12": "{size.max}",
        "d_13": "{size.max}",
        "d_14": "{size.max}",
        "d_15": "{size.max}",
        "d_16": "{opacity.invisible}",
        "d_17": "{opacity.enabled}"
    },
    "JDSDropdownMenuInternal": {
        "d_0": "{global.transparent}",
        "d_1": "{primaryGrey20}",
        "d_2": "{flexDirection.column}",
        "d_3": "{flexDirection.column}",
        "d_4": "{large}",
        "d_5": "{xs}",
        "d_6": "{xs}",
        "d_7": "{base}",
        "d_8": "{base}",
        "d_9": "{base}",
        "d_10": "{custom_color_5}",
        "d_11": "{size.max}",
        "d_12": "{size.max}",
        "d_13": "{size.max}",
        "d_14": "{size.max}",
        "d_15": "{size.max}",
        "d_16": "{opacity.invisible}",
        "d_17": "{opacity.enabled}"
    },
    "JDSDropdownMenuItem": {
        "d_0": "{size.max}",
        "d_1": "{flexDirection.row}",
        "d_2": "{flexDirection.column}",
        "d_3": "{s}",
        "d_4": "{primaryGrey20}",
        "d_5": "{primaryBackground}",
        "d_6": "{primary50}",
        "d_7": "{primaryGrey100}",
        "d_8": "{xs}",
        "d_9": "{base}",
        "d_10": "{xs}",
        "d_11": "{base}",
        "d_12": "{primary50}",
        "d_13": "{primary50}",
        "d_14": "{justifyContent.start}",
        "d_15": "{alignItems.start}",
        "d_16": "{alignItems.center}",
        "d_17": "{alignItems.start}",
        "d_18": "{primary60}",
        "d_19": "{m}",
        "d_20": "{primaryInverse}",
        "d_21": "{primaryInverse}",
        "d_22": "{opacity.disabled}",
        "d_23": "{small}",
        "d_24": "{size.max}"
    },
    "JDSDropdownMenuItemMobile": {
        "d_0": "{size.max}",
        "d_1": "{flexDirection.row}",
        "d_2": "{flexDirection.column}",
        "d_3": "{s}",
        "d_4": "{primaryGrey20}",
        "d_5": "{primaryBackground}",
        "d_6": "{primary50}",
        "d_7": "{primaryGrey100}",
        "d_8": "{xs}",
        "d_9": "{base}",
        "d_10": "{xs}",
        "d_11": "{base}",
        "d_12": "{primary50}",
        "d_13": "{primary50}",
        "d_14": "{justifyContent.start}",
        "d_15": "{alignItems.start}",
        "d_16": "{alignItems.center}",
        "d_17": "{alignItems.start}",
        "d_18": "{primary60}",
        "d_19": "{m}",
        "d_20": "{primaryInverse}",
        "d_21": "{primaryInverse}",
        "d_22": "{opacity.disabled}",
        "d_23": "{small}",
        "d_24": "{size.max}"
    },
    "JDSDropdownMenuGroup": {
        "d_0": "{size.max}",
        "d_1": "{flexDirection.column}",
        "d_2": "{flexDirection.column}",
        "d_3": "{xs}",
        "d_4": "{base}",
        "d_5": "{base}",
        "d_6": "{size.max}",
        "d_7": "{primaryGrey20}",
        "d_8": "{size.max}"
    },
    "JDSDropdownMenuSubMenu": {
        "d_0": "{global.transparent}",
        "d_1": "{primaryGrey20}",
        "d_2": "{flexDirection.column}",
        "d_3": "{large}",
        "d_4": "{xs}",
        "d_5": "{xs}",
        "d_6": "{custom_color_5}",
        "d_7": "{size.max}",
        "d_8": "{size.max}",
        "d_9": "{opacity.invisible}",
        "d_10": "{opacity.enabled}"
    },
    "JDSFeedbackBlock": {
        "f_0": "{flexDirection.row}",
        "f_1": "{justifyContent.center}",
        "f_2": "{alignItems.center}",
        "f_3": "{xs}",
        "f_4": "{alignItems.start}",
        "f_5": "{flexDirection.row}",
        "f_6": "{justifyContent.center}",
        "f_7": "{alignItems.center}",
        "f_8": "{m}",
        "f_9": "{m}",
        "f_10": "{custom_18}",
        "f_11": "{base}"
    },
    "JDSBottomFooterLinkItem": {
        "b_0": "{base}"
    },
    "JDSFooterIconLinks": {
        "f_0": "{base}",
        "f_1": "{flexDirection.column}",
        "f_2": "{alignItems.start}",
        "f_3": "{flexDirection.row}",
        "f_4": "{base}"
    },
    "JDSFooter": {
        "f_0": "{flexDirection.column}",
        "f_1": "{alignItems.center}",
        "f_2": "{size.max}",
        "f_3": "{primaryGrey20}",
        "f_4": "{flexDirection.row}",
        "f_5": "{justifyContent.spaceBetween}",
        "f_6": "{alignItems.start}",
        "f_7": "{base}",
        "f_8": "{size.max}",
        "f_9": "{xl}",
        "f_10": "{xl}",
        "f_11": "{huge}",
        "f_12": "{huge}",
        "f_13": "{xs}",
        "f_14": "{flexDirection.column}",
        "f_15": "{l}",
        "f_16": "{flexDirection.column}",
        "f_17": "{alignItems.start}",
        "f_18": "{size.max}",
        "f_19": "{size.max}",
        "f_20": "{size.max}",
        "f_21": "{m}",
        "f_22": "{flexDirection.column}",
        "f_23": "{justifyContent.start}",
        "f_24": "{m}",
        "f_25": "{xl}",
        "f_26": "{m}",
        "f_27": "{m}",
        "f_28": "{custom_17}"
    },
    "JDSBottomFooter": {
        "b_0": "{flexDirection.row}",
        "b_1": "{justifyContent.spaceBetween}",
        "b_2": "{alignItems.center}",
        "b_3": "{base}",
        "b_4": "{huge}",
        "b_5": "{base}",
        "b_6": "{huge}",
        "b_7": "{global.transparent}",
        "b_8": "{base}",
        "b_9": "{flexDirection.row}",
        "b_10": "{alignItems.center}",
        "b_11": "{alignItems.center}",
        "b_12": "{size.max}",
        "b_13": "{flexDirection.column}",
        "b_14": "{justifyContent.start}",
        "b_15": "{alignItems.start}",
        "b_16": "{m}",
        "b_17": "{m}",
        "b_18": "{m}",
        "b_19": "{base}",
        "b_20": "{flexDirection.column}",
        "b_21": "{alignItems.start}",
        "b_22": "{base}"
    },
    "JDSFooterLinksGrid": {
        "f_0": "{flexDirection.row}",
        "f_1": "{size.max}",
        "f_2": "{base}"
    },
    "JDSFooterLinks": {
        "f_0": "{flexDirection.column}",
        "f_1": "{alignItems.start}",
        "f_2": "{size.max}",
        "f_3": "{size.max}",
        "f_4": "{xs}",
        "f_5": "{xs}",
        "f_6": "{flexDirection.column}",
        "f_7": "{justifyContent.start}",
        "f_8": "{alignItems.start}",
        "f_9": "{global.transparent}",
        "f_10": "{primaryGrey40}",
        "f_11": "{xs}",
        "f_12": "{xs}",
        "f_13": "{s}",
        "f_14": "{size.max}",
        "f_15": "{flexDirection.column}"
    },
    "JDSIcon": {
        "icon_0": "{global.transparent}",
        "icon_1": "{pill}",
        "icon_2": "{m}",
        "icon_3": "{justifyContent.center}",
        "icon_4": "{alignItems.center}",
        "icon_5": "{m}",
        "icon_6": "{custom_color_1}",
        "icon_7": "{primary50}",
        "icon_8": "{primary30}",
        "icon_9": "{primary60}",
        "icon_10": "{primary70}",
        "icon_11": "{primaryBackground}",
        "icon_12": "{secondary50}",
        "icon_13": "{sparkle50}",
        "icon_14": "{primaryGrey60}",
        "icon_15": "{primaryGrey80}",
        "icon_16": "{primaryGrey100}",
        "icon_17": "{feedbackSuccess50}",
        "icon_18": "{feedbackError50}",
        "icon_19": "{feedbackWarning50}",
        "icon_20": "{global.white}",
        "icon_21": "{base}",
        "icon_22": "{base}",
        "icon_23": "{l}",
        "icon_24": "{l}",
        "icon_25": "{xl}",
        "icon_26": "{xl}",
        "icon_27": "{xxl}",
        "icon_28": "{xxl}",
        "icon_29": "{size.max}",
        "icon_30": "{size.max}",
        "icon_31": "{primary20}",
        "icon_32": "{primary20}",
        "icon_33": "{primary20}",
        "icon_34": "{primary20}",
        "icon_35": "{primary20}",
        "icon_36": "{secondary20}",
        "icon_37": "{sparkle20}",
        "icon_38": "{primaryGrey20}",
        "icon_39": "{primaryGrey20}",
        "icon_40": "{primaryGrey20}",
        "icon_41": "{primary20}",
        "icon_42": "{feedbackSuccess20}",
        "icon_43": "{feedbackError20}",
        "icon_44": "{feedbackWarning20}",
        "icon_45": "{primary50}",
        "icon_46": "{primaryInverse}",
        "icon_47": "{primary30}",
        "icon_48": "{primary30}",
        "icon_49": "{primary60}",
        "icon_50": "{primaryInverse}",
        "icon_51": "{primary70}",
        "icon_52": "{primaryInverse}",
        "icon_53": "{primaryBackground}",
        "icon_54": "{primaryInverse}",
        "icon_55": "{secondary50}",
        "icon_56": "{secondaryInverse}",
        "icon_57": "{sparkle50}",
        "icon_58": "{sparkleInverse}",
        "icon_59": "{primaryGrey60}",
        "icon_60": "{primaryInverse}",
        "icon_61": "{primaryGrey80}",
        "icon_62": "{primaryInverse}",
        "icon_63": "{primaryGrey100}",
        "icon_64": "{primaryInverse}",
        "icon_65": "{global.white}",
        "icon_66": "{global.white}",
        "icon_67": "{feedbackSuccess50}",
        "icon_68": "{primaryInverse}",
        "icon_69": "{feedbackError50}",
        "icon_70": "{primaryInverse}",
        "icon_71": "{feedbackWarning50}",
        "icon_72": "{primaryInverse}",
        "icon_73": "{m}",
        "icon_74": "{base}",
        "icon_75": "{base}",
        "icon_76": "{global.transparent}",
        "icon_77": "{base}",
        "icon_78": "{l}",
        "icon_79": "{m}",
        "icon_80": "{xl}",
        "icon_81": "{custom_3}",
        "icon_82": "{xxl}",
        "icon_83": "{l}",
        "icon_84": "{global.transparent}",
        "icon_85": "{primary50}",
        "icon_86": "{global.transparent}",
        "icon_87": "{primary30}",
        "icon_88": "{global.transparent}",
        "icon_89": "{primary60}",
        "icon_90": "{global.transparent}",
        "icon_91": "{primary70}",
        "icon_92": "{global.transparent}",
        "icon_93": "{primaryBackground}",
        "icon_94": "{global.transparent}",
        "icon_95": "{secondary50}",
        "icon_96": "{global.transparent}",
        "icon_97": "{sparkle50}",
        "icon_98": "{global.transparent}",
        "icon_99": "{primaryGrey60}",
        "icon_100": "{global.transparent}",
        "icon_101": "{primaryGrey80}",
        "icon_102": "{global.transparent}",
        "icon_103": "{primaryGrey100}",
        "icon_104": "{global.transparent}",
        "icon_105": "{global.white}",
        "icon_106": "{global.transparent}",
        "icon_107": "{feedbackSuccess50}",
        "icon_108": "{global.transparent}",
        "icon_109": "{feedbackError50}",
        "icon_110": "{global.transparent}",
        "icon_111": "{feedbackWarning50}",
        "icon_112": "{m}",
        "icon_113": "{base}",
        "icon_114": "{base}",
        "icon_115": "{base}",
        "icon_116": "{l}",
        "icon_117": "{m}",
        "icon_118": "{xl}",
        "icon_119": "{custom_3}",
        "icon_120": "{xxl}",
        "icon_121": "{l}",
        "icon_122": "{m}",
        "icon_123": "{m}",
        "icon_124": "{m}",
        "icon_125": "{m}",
        "icon_126": "{m}",
        "icon_127": "{m}",
        "icon_128": "{m}",
        "icon_129": "{m}",
        "icon_130": "{m}",
        "icon_131": "{m}",
        "icon_132": "{m}",
        "icon_133": "{m}",
        "icon_134": "{l}",
        "icon_135": "{l}",
        "icon_136": "{l}",
        "icon_137": "{l}",
        "icon_138": "{l}",
        "icon_139": "{l}",
        "icon_140": "{l}",
        "icon_141": "{l}",
        "icon_142": "{l}",
        "icon_143": "{l}",
        "icon_144": "{l}",
        "icon_145": "{l}",
        "icon_146": "{xl}",
        "icon_147": "{xl}",
        "icon_148": "{xl}",
        "icon_149": "{xl}",
        "icon_150": "{xl}",
        "icon_151": "{xl}",
        "icon_152": "{xl}",
        "icon_153": "{xl}",
        "icon_154": "{xl}",
        "icon_155": "{xl}",
        "icon_156": "{xl}",
        "icon_157": "{xl}",
        "icon_158": "{xxl}",
        "icon_159": "{xxl}",
        "icon_160": "{xxl}",
        "icon_161": "{xxl}",
        "icon_162": "{xxl}",
        "icon_163": "{xxl}",
        "icon_164": "{xxl}",
        "icon_165": "{xxl}",
        "icon_166": "{xxl}",
        "icon_167": "{xxl}",
        "icon_168": "{xxl}",
        "icon_169": "{xxl}",
        "icon_170": "{primaryInverse}",
        "icon_171": "{secondaryInverse}",
        "icon_172": "{sparkleInverse}",
        "icon_173": "{global.white}"
    },
    "JDSFooterMarketLinks": {
        "f_0": "{base}",
        "f_1": "{flexDirection.column}",
        "f_2": "{alignItems.start}",
        "f_3": "{flexDirection.row}",
        "f_4": "{alignItems.center}",
        "f_5": "{base}"
    },
    "JDSImage": {
        "i_0": "{global.transparent}",
        "i_1": "{flexDirection.stack}",
        "i_2": "{justifyContent.center}",
        "i_3": "{alignItems.center}",
        "i_4": "{size.min}",
        "i_5": "{size.min}",
        "i_6": "{xl}",
        "i_7": "{aspect_ratio.1.1}",
        "i_8": "{xl}",
        "i_9": "{size.max}",
        "i_10": "{size.max}",
        "i_11": "{l}",
        "i_12": "{primaryGrey80}",
        "i_13": "{size.max}",
        "i_14": "{aspect_ratio.1.1}",
        "i_15": "{size.max}",
        "i_16": "{size.max}",
        "i_17": "{primaryGrey20}",
        "i_18": "{opacity.invisible}",
        "i_19": "{primaryGrey20}",
        "i_20": "{opacity.invisible}",
        "i_21": "{primaryGrey20}",
        "i_22": "{opacity.invisible}",
        "i_23": "{aspect_ratio.4.3}",
        "i_24": "{aspect_ratio.4.3}",
        "i_25": "{aspect_ratio.4.3}",
        "i_26": "{aspect_ratio.4.3}",
        "i_27": "{aspect_ratio.5.4}",
        "i_28": "{aspect_ratio.5.4}",
        "i_29": "{aspect_ratio.5.4}",
        "i_30": "{aspect_ratio.5.4}",
        "i_31": "{aspect_ratio.16.9}",
        "i_32": "{aspect_ratio.16.9}",
        "i_33": "{aspect_ratio.16.9}",
        "i_34": "{aspect_ratio.16.9}",
        "i_35": "{aspect_ratio.4.5}",
        "i_36": "{aspect_ratio.4.5}",
        "i_37": "{aspect_ratio.4.5}",
        "i_38": "{aspect_ratio.4.5}",
        "i_39": "{aspect_ratio.3.4}",
        "i_40": "{aspect_ratio.3.4}",
        "i_41": "{aspect_ratio.3.4}",
        "i_42": "{aspect_ratio.3.4}",
        "i_43": "{aspect_ratio.9.16}",
        "i_44": "{aspect_ratio.9.16}",
        "i_45": "{aspect_ratio.9.16}",
        "i_46": "{aspect_ratio.9.16}",
        "i_47": "{aspect_ratio.2_75.1}",
        "i_48": "{aspect_ratio.2_75.1}",
        "i_49": "{aspect_ratio.2_75.1}",
        "i_50": "{aspect_ratio.2_75.1}"
    },
    "JDSInput": {
        "i_0": "{textAlign.start}",
        "i_1": "{primaryGrey60}",
        "i_2": "{bodyS}",
        "i_3": "{bodyS}",
        "i_4": "{bodyS}",
        "i_5": "{bodyS}",
        "i_6": "{bodyS}",
        "i_7": "{primaryGrey100}",
        "i_8": "{bodyS}",
        "i_9": "{bodyS}",
        "i_10": "{bodyS}",
        "i_11": "{bodyS}",
        "i_12": "{bodyS}",
        "i_13": "{primaryGrey100}",
        "i_14": "{size.max}",
        "i_15": "{opacity.disabled}",
        "i_16": "{textAlign.center}",
        "i_17": "{textAlign.end}",
        "i_18": "{textAlign.justify}",
        "i_19": "{bodyL}",
        "i_20": "{bodyL}",
        "i_21": "{bodyL}",
        "i_22": "{bodyL}",
        "i_23": "{bodyL}",
        "i_24": "{bodyL}",
        "i_25": "{bodyL}",
        "i_26": "{bodyL}",
        "i_27": "{primary80}",
        "i_28": "{primary70}",
        "i_29": "{primary60}",
        "i_30": "{primary50}",
        "i_31": "{primary40}",
        "i_32": "{primary30}",
        "i_33": "{primary20}",
        "i_34": "{primaryInverse}",
        "i_35": "{primaryBackground}",
        "i_36": "{primaryGrey100}",
        "i_37": "{primaryGrey80}",
        "i_38": "{primaryGrey60}",
        "i_39": "{primaryGrey40}",
        "i_40": "{primaryGrey20}",
        "i_41": "{secondary80}",
        "i_42": "{secondary70}",
        "i_43": "{secondary60}",
        "i_44": "{secondary50}",
        "i_45": "{secondary40}",
        "i_46": "{secondary30}",
        "i_47": "{secondary20}",
        "i_48": "{secondaryInverse}",
        "i_49": "{secondaryBackground}",
        "i_50": "{secondaryGrey100}",
        "i_51": "{secondaryGrey80}",
        "i_52": "{secondaryGrey60}",
        "i_53": "{secondaryGrey40}",
        "i_54": "{secondaryGrey20}",
        "i_55": "{sparkle80}",
        "i_56": "{sparkle70}",
        "i_57": "{sparkle60}",
        "i_58": "{sparkle50}",
        "i_59": "{sparkle40}",
        "i_60": "{sparkle30}",
        "i_61": "{sparkle20}",
        "i_62": "{sparkleInverse}",
        "i_63": "{sparkleBackground}",
        "i_64": "{sparkleGrey100}",
        "i_65": "{sparkleGrey80}",
        "i_66": "{sparkleGrey60}",
        "i_67": "{sparkleGrey40}",
        "i_68": "{sparkleGrey20}",
        "i_69": "{feedbackError80}",
        "i_70": "{feedbackError50}",
        "i_71": "{feedbackError20}",
        "i_72": "{feedbackWarning80}",
        "i_73": "{feedbackWarning50}",
        "i_74": "{feedbackWarning20}",
        "i_75": "{feedbackSuccess80}",
        "i_76": "{feedbackSuccess50}",
        "i_77": "{feedbackSuccess20}",
        "i_78": "{global.white}",
        "i_79": "{global.black}",
        "i_80": "{global.transparent}"
    },
    "JDSInputCodeItem": {
        "i_0": "{flexDirection.column}",
        "i_1": "{justifyContent.center}",
        "i_2": "{alignItems.center}",
        "i_3": "{xs}",
        "i_4": "{size.max}",
        "i_5": "{size.max}",
        "i_6": "{flexDirection.column}",
        "i_7": "{justifyContent.center}",
        "i_8": "{alignItems.center}",
        "i_9": "{size.max}",
        "i_10": "{custom_1}",
        "i_11": "{custom_1}",
        "i_12": "{size.max}",
        "i_13": "{custom_4}",
        "i_14": "{primaryGrey100}",
        "i_15": "{custom_2}",
        "i_16": "{primary50}",
        "i_17": "{primary50}",
        "i_18": "{primary50}",
        "i_19": "{feedbackSuccess50}",
        "i_20": "{feedbackError50}",
        "i_21": "{feedbackWarning50}",
        "i_22": "{primary60}"
    },
    "JDSInputDate": {
        "i_0": "{flexDirection.column}",
        "i_1": "{alignItems.start}",
        "i_2": "{xs}",
        "i_3": "{size.max}",
        "i_4": "{flexDirection.row}",
        "i_5": "{size.max}",
        "i_6": "{alignItems.center}",
        "i_7": "{flexDirection.column}",
        "i_8": "{size.max}",
        "i_9": "{alignItems.start}",
        "i_10": "{size.max}",
        "i_11": "{s}",
        "i_12": "{alignItems.stretch}",
        "i_13": "{flexDirection.column}",
        "i_14": "{xs}",
        "i_15": "{alignItems.start}",
        "i_16": "{textAlign.start}",
        "i_17": "{size.max}",
        "i_18": "{size.max}",
        "i_19": "{primaryGrey80}",
        "i_20": "{primaryGrey60}",
        "i_21": "{flexDirection.column}",
        "i_22": "{xs}",
        "i_23": "{alignItems.start}",
        "i_24": "{textAlign.start}",
        "i_25": "{size.max}",
        "i_26": "{size.max}",
        "i_27": "{primaryGrey80}",
        "i_28": "{primaryGrey60}",
        "i_29": "{flexDirection.column}",
        "i_30": "{xs}",
        "i_31": "{alignItems.start}",
        "i_32": "{textAlign.start}",
        "i_33": "{size.max}",
        "i_34": "{size.max}",
        "i_35": "{primaryGrey80}",
        "i_36": "{justifyContent.center}",
        "i_37": "{alignItems.center}",
        "i_38": "{flexDirection.column}",
        "i_39": "{alignItems.start}",
        "i_40": "{xs}",
        "i_41": "{size.max}",
        "i_42": "{opacity.disabled}",
        "i_43": "{opacity.disabled}",
        "i_44": "{feedbackError50}",
        "i_45": "{feedbackError50}",
        "i_46": "{feedbackError50}",
        "i_47": "{feedbackError50}",
        "i_48": "{feedbackError50}",
        "i_49": "{feedbackError50}"
    },
    "JDSLink": {
        "l_0": "{global.transparent}",
        "l_1": "{flexDirection.row}",
        "l_2": "{justifyContent.center}",
        "l_3": "{alignItems.center}",
        "l_4": "{small}",
        "l_5": "{border_normal}",
        "l_6": "{primary60}",
        "l_7": "{primary30}",
        "l_8": "{text-decoration.underline}",
        "l_9": "{text-decoration.underline}",
        "l_10": "{text-decoration.underline}",
        "l_11": "{text-decoration.none}",
        "l_12": "{text-decoration.underline}"
    },
    "JDSFileUploader": {
        "f_0": "{flexDirection.column}",
        "f_1": "{justifyContent.start}",
        "f_2": "{alignItems.start}",
        "f_3": "{size.max}",
        "f_4": "{xs}",
        "f_5": "{opacity.enabled}"
    },
    "JDSFileUploaderControl": {
        "f_0": "{flexDirection.column}",
        "f_1": "{justifyContent.start}",
        "f_2": "{alignItems.start}",
        "f_3": "{xxs}",
        "f_4": "{size.max}",
        "f_5": "{opacity.enabled}",
        "f_6": "{flexDirection.row}",
        "f_7": "{justifyContent.start}",
        "f_8": "{alignItems.center}",
        "f_9": "{xxs}"
    },
    "JDSFileUploaderItem": {
        "f_0": "{flexDirection.column}",
        "f_1": "{justifyContent.start}",
        "f_2": "{alignItems.start}",
        "f_3": "{size.max}",
        "f_4": "{opacity.enabled}",
        "f_5": "{primaryGrey20}",
        "f_6": "{flexDirection.row}",
        "f_7": "{justifyContent.spaceBetween}",
        "f_8": "{alignItems.center}",
        "f_9": "{xs}",
        "f_10": "{s}",
        "f_11": "{size.max}",
        "f_12": "{flexDirection.row}",
        "f_13": "{justifyContent.start}",
        "f_14": "{alignItems.center}",
        "f_15": "{xs}",
        "f_16": "{alignItems.center}"
    },
    "JDSFileUploaderList": {
        "f_0": "{flexDirection.column}",
        "f_1": "{justifyContent.start}",
        "f_2": "{alignItems.start}",
        "f_3": "{size.max}",
        "f_4": "{opacity.enabled}",
        "f_5": "{primaryGrey20}",
        "f_6": "{large}"
    },
    "JDSFileUploaderPanel": {
        "f_0": "{flexDirection.column}",
        "f_1": "{justifyContent.start}",
        "f_2": "{alignItems.start}",
        "f_3": "{size.max}",
        "f_4": "{opacity.enabled}",
        "f_5": "{primaryGrey20}",
        "f_6": "{large}",
        "f_7": "{xs}",
        "f_8": "{xs}",
        "f_9": "{xs}",
        "f_10": "{xs}",
        "f_11": "{s}",
        "f_12": "{s}",
        "f_13": "{size.max}"
    },
    "JDSMenuBlock": {
        "m_0": "{global.transparent}",
        "m_1": "{flexDirection.stack}",
        "m_2": "{base}",
        "m_3": "{base}",
        "m_4": "{size.max}",
        "m_5": "{intrinsicSize.max}",
        "m_6": "{primaryBackground}",
        "m_7": "{flexDirection.column}",
        "m_8": "{medium}",
        "m_9": "{size.max}"
    },
    "JDSMenuBlockInternal": {
        "m_0": "{global.transparent}",
        "m_1": "{flexDirection.stack}",
        "m_2": "{base}",
        "m_3": "{base}",
        "m_4": "{size.max}",
        "m_5": "{intrinsicSize.max}",
        "m_6": "{primaryBackground}",
        "m_7": "{flexDirection.column}",
        "m_8": "{medium}",
        "m_9": "{size.max}"
    },
    "JDSListBlock": {
        "l_0": "{flexDirection.column}",
        "l_1": "{size.max}",
        "l_2": "{justifyContent.start}",
        "l_3": "{alignItems.start}",
        "l_4": "{xs}",
        "l_5": "{xs}",
        "l_6": "{xs}",
        "l_7": "{flexDirection.row}",
        "l_8": "{size.max}",
        "l_9": "{base}",
        "l_10": "{justifyContent.start}",
        "l_11": "{alignItems.center}",
        "l_12": "{flexDirection.column}",
        "l_13": "{xxs}",
        "l_14": "{justifyContent.start}",
        "l_15": "{alignItems.start}",
        "l_16": "{flexDirection.row}",
        "l_17": "{size.max}",
        "l_18": "{justifyContent.spaceBetween}",
        "l_19": "{alignItems.center}",
        "l_20": "{s}",
        "l_21": "{flexDirection.row}",
        "l_22": "{justifyContent.start}",
        "l_23": "{alignItems.center}",
        "l_24": "{s}",
        "l_25": "{flexDirection.row}",
        "l_26": "{size.max}",
        "l_27": "{justifyContent.spaceBetween}",
        "l_28": "{alignItems.center}",
        "l_29": "{s}",
        "l_30": "{flexDirection.row}",
        "l_31": "{justifyContent.start}",
        "l_32": "{alignItems.center}",
        "l_33": "{s}",
        "l_34": "{flexDirection.row}",
        "l_35": "{size.max}",
        "l_36": "{justifyContent.spaceBetween}",
        "l_37": "{alignItems.center}",
        "l_38": "{s}",
        "l_39": "{flexDirection.row}",
        "l_40": "{justifyContent.start}",
        "l_41": "{alignItems.center}",
        "l_42": "{s}",
        "l_43": "{s}",
        "l_44": "{xxs}",
        "l_45": "{alignItems.start}"
    },
    "JDSInputField": {
        "i_0": "{flexDirection.column}",
        "i_1": "{xxs}",
        "i_2": "{size.max}",
        "i_3": "{justifyContent.start}",
        "i_4": "{alignItems.start}",
        "i_5": "{flexDirection.stack}",
        "i_6": "{size.max}",
        "i_7": "{alignItems.end}",
        "i_8": "{justifyContent.start}",
        "i_9": "{xxs}",
        "i_10": "{flexDirection.row}",
        "i_11": "{justifyContent.start}",
        "i_12": "{size.max}",
        "i_13": "{xs}",
        "i_14": "{alignItems.center}",
        "i_15": "{m}",
        "i_16": "{primaryGrey80}",
        "i_17": "{textAlign.start}",
        "i_18": "{m}",
        "i_19": "{primaryGrey80}",
        "i_20": "{primary60}",
        "i_21": "{flexDirection.column}",
        "i_22": "{size.max}",
        "i_23": "{alignItems.center}",
        "i_24": "{size.max}",
        "i_25": "{primaryGrey80}",
        "i_26": "{primary50}",
        "i_27": "{primary60}",
        "i_28": "{primary60}",
        "i_29": "{opacity.disabled}",
        "i_30": "{opacity.enabled}",
        "i_31": "{feedbackSuccess50}",
        "i_32": "{feedbackSuccess50}",
        "i_33": "{feedbackSuccess50}",
        "i_34": "{feedbackSuccess50}",
        "i_35": "{feedbackError50}",
        "i_36": "{feedbackError50}",
        "i_37": "{feedbackError50}",
        "i_38": "{feedbackError50}",
        "i_39": "{feedbackWarning50}",
        "i_40": "{feedbackWarning50}",
        "i_41": "{feedbackWarning50}",
        "i_42": "{feedbackWarning50}",
        "i_43": "{alignItems.start}",
        "i_44": "{alignItems.start}",
        "i_45": "{alignItems.end}",
        "i_46": "{l}",
        "i_47": "{alignItems.end}",
        "i_48": "{primary60}"
    },
    "JDSInputFieldV2": {
        "i_0": "{s}",
        "i_1": "{flexDirection.column}",
        "i_2": "{size.max}",
        "i_3": "{justifyContent.start}",
        "i_4": "{alignItems.start}",
        "i_5": "{opacity.enabled}",
        "i_6": "{flexDirection.row}",
        "i_7": "{justifyContent.start}",
        "i_8": "{alignItems.center}",
        "i_9": "{xxs}",
        "i_10": "{xs}",
        "i_11": "{xs}",
        "i_12": "{xxs}",
        "i_13": "{flexDirection.row}",
        "i_14": "{justifyContent.start}",
        "i_15": "{alignItems.center}",
        "i_16": "{size.max}",
        "i_17": "{xl}",
        "i_18": "{xs}",
        "i_19": "{xs}",
        "i_20": "{xs}",
        "i_21": "{xs}",
        "i_22": "{xs}",
        "i_23": "{border_thin}",
        "i_24": "{primaryGrey60}",
        "i_25": "{primaryGrey40}",
        "i_26": "{medium}",
        "i_27": "{primary50}",
        "i_28": "{primary60}",
        "i_29": "{primary60}",
        "i_30": "{textAlign.start}",
        "i_31": 1,
        "i_32": "{flexDirection.column}",
        "i_33": "{justifyContent.start}",
        "i_34": "{alignItems.start}",
        "i_35": "{xxs}",
        "i_36": "{xxs}",
        "i_37": "{xs}",
        "i_38": "{xs}",
        "i_39": "{xxs}",
        "i_40": "{flexDirection.row}",
        "i_41": "{justifyContent.start}",
        "i_42": "{alignItems.center}",
        "i_43": "{xs}",
        "i_44": "{xs}",
        "i_45": "{opacity.disabled}",
        "i_46": "{feedbackSuccess50}",
        "i_47": "{feedbackSuccess50}",
        "i_48": "{feedbackSuccess50}",
        "i_49": "{feedbackSuccess50}",
        "i_50": "{feedbackError50}",
        "i_51": "{feedbackError50}",
        "i_52": "{feedbackError50}",
        "i_53": "{feedbackError50}",
        "i_54": "{feedbackWarning50}",
        "i_55": "{feedbackWarning50}",
        "i_56": "{feedbackWarning50}",
        "i_57": "{feedbackWarning50}",
        "i_58": "{l}",
        "i_59": "{xxs}",
        "i_60": "{xxs}",
        "i_61": "{xxl}",
        "i_62": "{s}",
        "i_63": "{s}",
        "i_64": "{s}",
        "i_65": "{xs}",
        "i_66": "{xs}"
    },
    "JDSModalDesktop": {
        "m_0": "{flexDirection.stack}",
        "m_1": "{opacity.invisible}",
        "m_2": "{opacity.enabled}",
        "m_3": "{justifyContent.center}",
        "m_4": "{alignItems.center}",
        "m_5": "{size.max}",
        "m_6": "{size.max}",
        "m_7": "{global.black}",
        "m_8": "{custom_2}",
        "m_9": "{flexDirection.column}",
        "m_10": "{justifyContent.start}",
        "m_11": "{alignItems.start}",
        "m_12": "{xxl}",
        "m_13": "{primaryBackground}",
        "m_14": "{size.max}",
        "m_15": "{flexDirection.row}",
        "m_16": "{justifyContent.end}",
        "m_17": "{alignItems.center}",
        "m_18": "{size.max}",
        "m_19": "{s}",
        "m_20": "{s}",
        "m_21": "{s}",
        "m_22": "{s}",
        "m_23": "{flexDirection.column}",
        "m_24": "{justifyContent.start}",
        "m_25": "{alignItems.start}",
        "m_26": "{l}",
        "m_27": "{l}",
        "m_28": "{l}",
        "m_29": "{size.max}",
        "m_30": "auto",
        "m_31": "auto",
        "m_32": "{flexDirection.row}",
        "m_33": "{justifyContent.start}",
        "m_34": "{alignItems.center}",
        "m_35": "{size.max}",
        "m_36": "{base}",
        "m_37": "{size.max}",
        "m_38": "auto",
        "m_39": "{size.max}",
        "m_40": "{justifyContent.end}",
        "m_41": "{alignItems.start}",
        "m_42": "{flexDirection.row}",
        "m_43": "{s}",
        "m_44": "{base}",
        "m_45": "{flexDirection.column}",
        "m_46": "{justifyContent.start}",
        "m_47": "{alignItems.start}",
        "m_48": "{xxl}",
        "m_49": "{primaryBackground}",
        "m_50": "{l}",
        "m_51": "{l}",
        "m_52": "{l}",
        "m_53": "{l}",
        "m_54": "{size.max}",
        "m_55": "{size.max}",
        "m_56": "{justifyContent.end}",
        "m_57": "{justifyContent.center}",
        "m_58": "{m}",
        "m_59": "{m}",
        "m_60": "{m}",
        "m_61": "{l}",
        "m_62": "{l}"
    },
    "JDSModalDesktopInternal": {
        "m_0": "{flexDirection.stack}",
        "m_1": "{justifyContent.center}",
        "m_2": "{alignItems.center}",
        "m_3": "{size.max}",
        "m_4": "{opacity.invisible}",
        "m_5": "{medium}",
        "m_6": "{easeEntrance}",
        "m_7": "{size.max}",
        "m_8": "{global.black}",
        "m_9": "{custom_2}",
        "m_10": "{flexDirection.column}",
        "m_11": "{justifyContent.start}",
        "m_12": "{alignItems.start}",
        "m_13": "{xxl}",
        "m_14": "{elevation1}",
        "m_15": "{custom_27}",
        "m_16": "{size.max}",
        "m_17": "{flexDirection.row}",
        "m_18": "{justifyContent.end}",
        "m_19": "{alignItems.center}",
        "m_20": "{size.max}",
        "m_21": "{s}",
        "m_22": "{s}",
        "m_23": "{s}",
        "m_24": "{s}",
        "m_25": "{flexDirection.column}",
        "m_26": "{justifyContent.start}",
        "m_27": "{alignItems.start}",
        "m_28": "{l}",
        "m_29": "{l}",
        "m_30": "{l}",
        "m_31": "{size.max}",
        "m_32": "auto",
        "m_33": "auto",
        "m_34": "{flexDirection.row}",
        "m_35": "{justifyContent.start}",
        "m_36": "{alignItems.center}",
        "m_37": "{size.max}",
        "m_38": "{base}",
        "m_39": "{size.max}",
        "m_40": "auto",
        "m_41": "{size.max}",
        "m_42": "{justifyContent.end}",
        "m_43": "{alignItems.start}",
        "m_44": "{flexDirection.row}",
        "m_45": "{s}",
        "m_46": "{base}",
        "m_47": "{flexDirection.column}",
        "m_48": "{justifyContent.start}",
        "m_49": "{alignItems.start}",
        "m_50": "{xxl}",
        "m_51": "{primaryBackground}",
        "m_52": "{l}",
        "m_53": "{l}",
        "m_54": "{l}",
        "m_55": "{l}",
        "m_56": "80%",
        "m_57": "80%",
        "m_58": "{justifyContent.end}",
        "m_59": "{justifyContent.center}",
        "m_60": "{m}",
        "m_61": "{m}",
        "m_62": "{m}",
        "m_63": "{l}",
        "m_64": "{l}",
        "m_65": "{opacity.enabled}",
        "m_66": "{easeExit}",
        "m_67": "{custom_27}",
        "m_68": "{modal_desktop_comibation_medium_width}",
        "m_69": "{modal_desktop_combination_small_width}",
        "m_70": "{modal_desktop_combination_small_width}"
    },
    "JDSMenuBlockItem": {
        "m_0": "{opacity.enabled}",
        "m_1": "{global.transparent}",
        "m_2": "{size.max}",
        "m_3": "{global.transparent}",
        "m_4": "{size.max}",
        "m_5": "{xs}",
        "m_6": "{base}",
        "m_7": "{xs}",
        "m_8": "{base}",
        "m_9": "{flexDirection.row}",
        "m_10": "{alignItems.center}",
        "m_11": "{justifyContent.spaceBetween}",
        "m_12": "{global.transparent}",
        "m_13": "{primaryGrey20}",
        "m_14": "{primary60}",
        "m_15": "{small}",
        "m_16": "{size.max}",
        "m_17": "{xs}",
        "m_18": "{base}",
        "m_19": "{xs}",
        "m_20": "{base}",
        "m_21": "{size.max}",
        "m_22": "{alignItems.center}",
        "m_23": "{justifyContent.start}",
        "m_24": "{xs}",
        "m_25": "{flexDirection.row}",
        "m_26": "{alignItems.center}",
        "m_27": "{primaryGrey20}",
        "m_28": "{opacity.disabled}",
        "m_29": "{xxl}"
    },
    "JDSModalMobile": {
        "m_0": "{flexDirection.stack}",
        "m_1": "{justifyContent.center}",
        "m_2": "{alignItems.center}",
        "m_3": "{size.max}",
        "m_4": "{opacity.invisible}",
        "m_5": "{medium}",
        "m_6": "{easeEntrance}",
        "m_7": "{opacity.enabled}",
        "m_8": "{easeExit}"
    },
    "JDSModalMobileInternal": {
        "m_0": "{flexDirection.stack}",
        "m_1": "{justifyContent.center}",
        "m_2": "{alignItems.center}",
        "m_3": "{size.max}",
        "m_4": "{size.max}",
        "m_5": "{global.black}",
        "m_6": "{custom_2}",
        "m_7": "{flexDirection.column}",
        "m_8": "{justifyContent.start}",
        "m_9": "{alignItems.start}",
        "m_10": "{xl}",
        "m_11": "{size.max}",
        "m_12": "{custom_31}",
        "m_13": "{elevation1}",
        "m_14": "{flexDirection.row}",
        "m_15": "{justifyContent.center}",
        "m_16": "{alignItems.center}",
        "m_17": "{xl}",
        "m_18": "{size.max}",
        "m_19": "{size.max}",
        "m_20": "{m}",
        "m_21": "{m}",
        "m_22": "{m}",
        "m_23": "{m}",
        "m_24": "{flexDirection.row}",
        "m_25": "{justifyContent.end}",
        "m_26": "{alignItems.center}",
        "m_27": "{size.max}",
        "m_28": "{s}",
        "m_29": "{s}",
        "m_30": "{s}",
        "m_31": "{s}",
        "m_32": "{flexDirection.column}",
        "m_33": "{justifyContent.start}",
        "m_34": "{alignItems.start}",
        "m_35": "{size.max}",
        "m_36": "{l}",
        "m_37": "{l}",
        "m_38": "{l}",
        "m_39": "auto",
        "m_40": "{flexDirection.row}",
        "m_41": "{justifyContent.start}",
        "m_42": "{alignItems.center}",
        "m_43": "{size.max}",
        "m_44": "{base}",
        "m_45": "{alignItems.start}",
        "m_46": "{size.max}",
        "m_47": "auto",
        "m_48": "{flexDirection.column}",
        "m_49": "{size.max}",
        "m_50": "{justifyContent.start}",
        "m_51": "{alignItems.start}",
        "m_52": "{flexDirection.column}",
        "m_53": "{s}",
        "m_54": "{base}",
        "m_55": "{flexDirection.column}",
        "m_56": "{justifyContent.start}",
        "m_57": "{alignItems.start}",
        "m_58": "{xl}",
        "m_59": "{elevation1}",
        "m_60": "{l}",
        "m_61": "{l}",
        "m_62": "{l}",
        "m_63": "{l}",
        "m_64": "{size.max}",
        "m_65": "{justifyContent.end}",
        "m_66": "{justifyContent.center}",
        "m_67": "{m}",
        "m_68": "{m}",
        "m_69": "{m}",
        "m_70": "{l}",
        "m_71": "{l}",
        "m_72": "{opacity.enabled}",
        "m_73": "{easeExit}"
    },
    "JDSHeaderDesktop": {
        "h_0": "{size.max}",
        "h_1": "{flexDirection.column}",
        "h_2": "{flexDirection.row}",
        "h_3": "{justifyContent.start}",
        "h_4": "{alignItems.center}",
        "h_5": "{xs}",
        "h_6": "{size.max}",
        "h_7": "{primary50}",
        "h_8": "{flexDirection.row}",
        "h_9": "{justifyContent.spaceBetween}",
        "h_10": "{alignItems.center}",
        "h_11": "{xxl}",
        "h_12": "{s}",
        "h_13": "{xxl}",
        "h_14": "{s}",
        "h_15": "{base}",
        "h_16": "{custom_16}",
        "h_17": "{flexDirection.row}",
        "h_18": "{justifyContent.start}",
        "h_19": "{alignItems.center}",
        "h_20": "{base}",
        "h_21": "{flexDirection.row}",
        "h_22": "{justifyContent.center}",
        "h_23": "{alignItems.center}",
        "h_24": "{xs}",
        "h_25": "{flexDirection.row}",
        "h_26": "{justifyContent.center}",
        "h_27": "{alignItems.center}",
        "h_28": "{xs}",
        "h_29": "{flexDirection.row}",
        "h_30": "{justifyContent.start}",
        "h_31": "{alignItems.center}",
        "h_32": "{l}",
        "h_33": "{huge}",
        "h_34": "{flexDirection.row}",
        "h_35": "{justifyContent.end}",
        "h_36": "{alignItems.center}",
        "h_37": "{s}",
        "h_38": "{flexDirection.row}",
        "h_39": "{justifyContent.end}",
        "h_40": "{alignItems.center}",
        "h_41": "{s}",
        "h_42": "{size.max}",
        "h_43": "{flexDirection.row}",
        "h_44": "{justifyContent.center}",
        "h_45": "{alignItems.center}",
        "h_46": "{s}",
        "h_47": "{size.max}",
        "h_48": "{huge}",
        "h_49": "{s}",
        "h_50": "{s}",
        "h_51": "{s}",
        "h_52": "{xs}",
        "h_53": "{xs}",
        "h_54": "{xs}",
        "h_55": "{size.max}",
        "h_56": "{justifyContent.spaceBetween}",
        "h_57": "{size.max}",
        "h_58": "{intrinsicSize.max}",
        "h_59": "{justifyContent.spaceBetween}"
    },
    "JDSBottomNavigation": {
        "b_0": "{size.max}",
        "b_1": "{flexDirection.row}",
        "b_2": "{justifyContent.center}",
        "b_3": "{alignItems.center}",
        "b_4": "{primaryBackground}",
        "b_5": "{m}",
        "b_6": "{base}",
        "b_7": "{m}",
        "b_8": "{base}",
        "b_9": "{m}",
        "b_10": 0,
        "b_11": -1,
        "b_12": 0,
        "b_13": 0,
        "b_14": 1,
        "b_15": "{primaryGrey40}"
    },
    "JDSBottomNavigationItem": {
        "b_0": "{size.max}",
        "b_1": "{flexDirection.column}",
        "b_2": "{justifyContent.center}",
        "b_3": "{alignItems.center}",
        "b_4": "{xxs}",
        "b_5": "{opacity.disabled}",
        "b_6": "{opacity.enabled}"
    },
    "JDSMegaMenu": {
        "m_0": "{flexDirection.row}",
        "m_1": "{size.max}",
        "m_2": "{flexDirection.row}",
        "m_3": "{justifyContent.start}",
        "m_4": "{alignItems.start}",
        "m_5": "{primaryBackground}",
        "m_6": "{m}",
        "m_7": "{m}",
        "m_8": "{xxl}",
        "m_9": "{xxl}",
        "m_10": "{base}"
    },
    "JDSMegaMenuInternal": {
        "m_0": "{flexDirection.row}",
        "m_1": "{size.max}",
        "m_2": "{flexDirection.row}",
        "m_3": "{justifyContent.start}",
        "m_4": "{alignItems.start}",
        "m_5": "{primaryBackground}",
        "m_6": "{m}",
        "m_7": "{m}",
        "m_8": "{xxl}",
        "m_9": "{xxl}",
        "m_10": "{base}"
    },
    "JDSHeaderMobile": {
        "h_0": "{size.max}",
        "h_1": "{flexDirection.column}",
        "h_2": "{size.max}",
        "h_3": "{size.max}",
        "h_4": "{primary50}",
        "h_5": "{flexDirection.row}",
        "h_6": "{justifyContent.spaceBetween}",
        "h_7": "{alignItems.center}",
        "h_8": "{s}",
        "h_9": "{xs}",
        "h_10": "{s}",
        "h_11": "{xs}",
        "h_12": "{base}",
        "h_13": "{huge}",
        "h_14": "{flexDirection.row}",
        "h_15": "{justifyContent.start}",
        "h_16": "{alignItems.center}",
        "h_17": "{base}",
        "h_18": "{flexDirection.row}",
        "h_19": "{justifyContent.start}",
        "h_20": "{alignItems.center}",
        "h_21": "{xs}",
        "h_22": "{flexDirection.row}",
        "h_23": "{justifyContent.center}",
        "h_24": "{alignItems.center}",
        "h_25": "{xs}",
        "h_26": "{flexDirection.row}",
        "h_27": "{justifyContent.start}",
        "h_28": "{alignItems.center}",
        "h_29": "{l}",
        "h_30": "{huge}",
        "h_31": "{flexDirection.row}",
        "h_32": "{justifyContent.end}",
        "h_33": "{alignItems.center}",
        "h_34": "{s}",
        "h_35": "{flexDirection.row}",
        "h_36": "{justifyContent.end}",
        "h_37": "{alignItems.center}",
        "h_38": "{s}",
        "h_39": "{flexDirection.row}",
        "h_40": "{justifyContent.center}",
        "h_41": "{alignItems.center}",
        "h_42": "{s}",
        "h_43": "{s}",
        "h_44": "{s}",
        "h_45": "{xxs}",
        "h_46": "{xs}",
        "h_47": "{xs}",
        "h_48": "{xs}",
        "h_49": "{intrinsicSize.max}",
        "h_50": "{m}"
    },
    "JDSMegaMenuItem": {
        "m_0": "{flexDirection.row}",
        "m_1": "{justifyContent.start}",
        "m_2": "{alignItems.start}",
        "m_3": "{xs}",
        "m_4": "{xs}"
    },
    "JDSTextarea": {
        "t_0": "{flexDirection.column}",
        "t_1": "{justifyContent.start}",
        "t_2": "{alignItems.start}",
        "t_3": "{xxs}",
        "t_4": "{size.max}",
        "t_5": "{flexDirection.stack}",
        "t_6": "{size.max}",
        "t_7": "{xxs}",
        "t_8": "{justifyContent.start}",
        "t_9": "{alignItems.end}",
        "t_10": "{flexDirection.row}",
        "t_11": "{justifyContent.start}",
        "t_12": "{size.max}",
        "t_13": "{alignItems.center}",
        "t_14": "{textAlign.start}",
        "t_15": "{primaryGrey60}",
        "t_16": "{bodyS}",
        "t_17": "{bodyS}",
        "t_18": "{bodyS}",
        "t_19": "{bodyS}",
        "t_20": "{bodyS}",
        "t_21": "{primaryGrey100}",
        "t_22": "{bodyS}",
        "t_23": "{bodyS}",
        "t_24": "{bodyS}",
        "t_25": "{bodyS}",
        "t_26": "{bodyS}",
        "t_27": "{primaryGrey100}",
        "t_28": "{primaryGrey100}",
        "t_29": "{size.max}",
        "t_30": "{primary50}",
        "t_31": "{primary60}",
        "t_32": "{primary60}",
        "t_33": "{flexDirection.column}",
        "t_34": "{size.max}",
        "t_35": "{alignItems.center}",
        "t_36": "{size.max}",
        "t_37": "{primaryGrey100}",
        "t_38": "{primary50}",
        "t_39": "{primary60}",
        "t_40": "{primary60}",
        "t_41": "{opacity.disabled}",
        "t_42": "{opacity.enabled}",
        "t_43": "{border_thin}",
        "t_44": "{primaryGrey60}",
        "t_45": "{custom_17}",
        "t_46": "{medium}",
        "t_47": "{custom_17}",
        "t_48": "{base}",
        "t_49": "{s}",
        "t_50": "{feedbackSuccess50}",
        "t_51": "{feedbackSuccess50}",
        "t_52": "{feedbackSuccess50}",
        "t_53": "{feedbackSuccess50}",
        "t_54": "{feedbackSuccess50}",
        "t_55": "{feedbackSuccess50}",
        "t_56": "{feedbackSuccess50}",
        "t_57": "{feedbackSuccess50}",
        "t_58": "{feedbackError50}",
        "t_59": "{feedbackError50}",
        "t_60": "{feedbackError50}",
        "t_61": "{feedbackError50}",
        "t_62": "{feedbackError50}",
        "t_63": "{feedbackError50}",
        "t_64": "{feedbackError50}",
        "t_65": "{feedbackError50}",
        "t_66": "{feedbackWarning50}",
        "t_67": "{feedbackWarning50}",
        "t_68": "{feedbackWarning50}",
        "t_69": "{feedbackWarning50}",
        "t_70": "{feedbackWarning50}",
        "t_71": "{feedbackWarning50}",
        "t_72": "{feedbackWarning50}",
        "t_73": "{feedbackWarning50}",
        "t_74": "{alignItems.start}",
        "t_75": "{primary60}",
        "t_76": "{primary60}",
        "t_77": "{primaryGrey40}",
        "t_78": "{primaryGrey60}",
        "t_79": "{primaryGrey80}"
    },
    "JDSSidePanelItem": {
        "s_0": "{xl}",
        "s_1": "{xs}",
        "s_2": "{flexDirection.row}",
        "s_3": "{justifyContent.spaceBetween}",
        "s_4": "{alignItems.center}",
        "s_5": "{size.max}",
        "s_6": "{flexDirection.row}",
        "s_7": "{justifyContent.start}",
        "s_8": "{alignItems.center}",
        "s_9": "{base}",
        "s_10": "{s}",
        "s_11": "{s}"
    },
    "JDSMegaMenuBlock": {
        "m_0": "{flexDirection.column}",
        "m_1": "{justifyContent.start}",
        "m_2": "{alignItems.start}",
        "m_3": "{base}",
        "m_4": "{flexDirection.column}",
        "m_5": "{justifyContent.start}",
        "m_6": "{alignItems.start}",
        "m_7": "{xs}"
    },
    "JDSNotificationButton": {
        "n_0": "{xxs}",
        "n_1": "{base}",
        "n_2": "{xxs}",
        "n_3": "{base}",
        "n_4": "{global.transparent}",
        "n_5": "{primaryGrey60}",
        "n_6": "{primary20}",
        "n_7": "{primary30}",
        "n_8": "{primary50}",
        "n_9": "{opacity.disabled}",
        "n_10": "{primary30}",
        "n_11": "{primary40}",
        "n_12": "{primary30}",
        "n_13": "{primary20}",
        "n_14": "{base}",
        "n_15": "{xs}",
        "n_16": "{xs}",
        "n_17": "{xs}",
        "n_18": "{xs}"
    },
    "JDSNotificationBanner": {
        "n_0": "{custom_11}",
        "n_1": "{size.max}",
        "n_2": "{flexDirection.column}",
        "n_3": "{justifyContent.center}",
        "n_4": "{alignItems.center}",
        "n_5": "{base}",
        "n_6": "{base}",
        "n_7": "{base}",
        "n_8": "{base}",
        "n_9": "{base}",
        "n_10": "{large}",
        "n_11": "{primaryGrey20}",
        "n_12": "{flexDirection.row}",
        "n_13": "{justifyContent.start}",
        "n_14": "{alignItems.start}",
        "n_15": "{size.max}",
        "n_16": "{s}",
        "n_17": "{justifyContent.start}",
        "n_18": "{alignItems.start}",
        "n_19": "{flexDirection.column}",
        "n_20": "{xxs}",
        "n_21": "{flexDirection.row}",
        "n_22": "{xs}",
        "n_23": "{size.max}",
        "n_24": "{flexDirection.row}",
        "n_25": "{justifyContent.end}",
        "n_26": "{alignItems.center}",
        "n_27": "{alignItems.center}",
        "n_28": "{custom_3}",
        "n_29": "{custom_3}",
        "n_30": "{m}",
        "n_31": "{m}",
        "n_32": "{l}",
        "n_33": "{l}"
    },
    "JDSNudgeContainer": {
        "n_0": "{flexDirection.stack}",
        "n_1": "{size.max}",
        "n_2": "{base}",
        "n_3": "{base}",
        "n_4": "{base}",
        "n_5": "{base}",
        "n_6": "{flexDirection.column}",
        "n_7": "{justifyContent.start}",
        "n_8": "{alignItems.end}",
        "n_9": "{size.max}",
        "n_10": "{xs}"
    },
    "JDSToastContainer": {
        "t_0": "{flexDirection.stack}",
        "t_1": "{size.max}",
        "t_2": "{base}",
        "t_3": "{base}",
        "t_4": "{base}",
        "t_5": "{base}",
        "t_6": "{flexDirection.column}",
        "t_7": "{justifyContent.end}",
        "t_8": "{alignItems.start}",
        "t_9": "{size.max}",
        "t_10": "{xs}"
    },
    "JDSToast": {
        "t_0": "{size.max}",
        "t_1": "{size.max}",
        "t_2": "{xl}",
        "t_3": "{primaryGrey80}",
        "t_4": "{flexDirection.column}",
        "t_5": "{base}",
        "t_6": "{base}",
        "t_7": "{base}",
        "t_8": "{base}",
        "t_9": "{base}",
        "t_10": "{s}",
        "t_11": "{size.max}",
        "t_12": "{flexDirection.row}",
        "t_13": "{justifyContent.start}",
        "t_14": "{alignItems.center}",
        "t_15": "{flexDirection.column}",
        "t_16": "{justifyContent.start}",
        "t_17": "{alignItems.start}",
        "t_18": "{xxs}",
        "t_19": "{size.max}",
        "t_20": "{s}",
        "t_21": "{flexDirection.row}",
        "t_22": "{justifyContent.end}",
        "t_23": "{custom_13}",
        "t_24": "{custom_14}"
    },
    "JDSNudge": {
        "n_0": "{size.max}",
        "n_1": "{size.max}",
        "n_2": "{xl}",
        "n_3": "{primaryGrey80}",
        "n_4": "{flexDirection.column}",
        "n_5": "{base}",
        "n_6": "{base}",
        "n_7": "{base}",
        "n_8": "{base}",
        "n_9": "{base}",
        "n_10": "{s}",
        "n_11": "{size.max}",
        "n_12": "{flexDirection.row}",
        "n_13": "{justifyContent.start}",
        "n_14": "{alignItems.center}",
        "n_15": "{flexDirection.column}",
        "n_16": "{justifyContent.start}",
        "n_17": "{alignItems.start}",
        "n_18": "{s}",
        "n_19": "{size.max}",
        "n_20": "{s}",
        "n_21": "{flexDirection.row}",
        "n_22": "{justifyContent.end}",
        "n_23": "{custom_13}",
        "n_24": "{custom_14}"
    },
    "JDSPagination": {
        "p_0": "{global.transparent}",
        "p_1": "{flexDirection.row}",
        "p_2": "{alignItems.center}",
        "p_3": "{alignItems.center}",
        "p_4": "{custom_25}",
        "p_5": "{custom_25}",
        "p_6": "{size.max}",
        "p_7": "{xxl}",
        "p_8": "{flexDirection.row}",
        "p_9": "{flexDirection.row}",
        "p_10": "{xxs}",
        "p_11": "{base}",
        "p_12": "{base}"
    },
    "JDSPromoCard": {
        "p_0": "{global.white}",
        "p_1": "{flexDirection.column}",
        "p_2": "{size.max}",
        "p_3": "{justifyContent.start}",
        "p_4": "{alignItems.start}",
        "p_5": "{xl}",
        "p_6": "{flexDirection.column}",
        "p_7": "{alignItems.start}",
        "p_8": "{justifyContent.start}",
        "p_9": "{size.max}",
        "p_10": "{xl}",
        "p_11": "{primaryBackground}",
        "p_12": "{flexDirection.row}",
        "p_13": "{alignItems.stretch}",
        "p_14": "{justifyContent.start}",
        "p_15": "{size.max}",
        "p_16": "{xl}",
        "p_17": "{intrinsicSize.max}",
        "p_18": "{primaryBackground}",
        "p_19": "{flexDirection.row}",
        "p_20": "{alignItems.start}",
        "p_21": "{justifyContent.start}",
        "p_22": "{size.max}",
        "p_23": "{primaryBackground}",
        "p_24": "{xl}",
        "p_25": "{xl}",
        "p_26": "{m}",
        "p_27": "{m}",
        "p_28": "{m}",
        "p_29": "{flexDirection.row}",
        "p_30": "{alignItems.start}",
        "p_31": "{justifyContent.start}",
        "p_32": "{size.max}",
        "p_33": "{primaryBackground}",
        "p_34": "{m}",
        "p_35": "{m}",
        "p_36": "{m}",
        "p_37": "{m}",
        "p_38": "{size.max}",
        "p_39": "{flexDirection.stack}",
        "p_40": "{alignItems.end}",
        "p_41": "{size.max}",
        "p_42": "{flexDirection.stack}",
        "p_43": "{alignItems.center}",
        "p_44": "{justifyContent.start}",
        "p_45": "{size.max}",
        "p_46": "{primaryBackground}",
        "p_47": "{size.max}",
        "p_48": "{xl}",
        "p_49": "{primaryBackground}",
        "p_50": "{size.max}",
        "p_51": "{xl}",
        "p_52": "{primaryBackground}",
        "p_53": "{size.max}",
        "p_54": "{justifyContent.spaceBetween}",
        "p_55": "{alignItems.center}",
        "p_56": "{flexDirection.row}",
        "p_57": "{base}",
        "p_58": "{m}",
        "p_59": "{m}",
        "p_60": "{base}",
        "p_61": "{base}",
        "p_62": "{l}",
        "p_63": "{l}",
        "p_64": "{l}",
        "p_65": "{l}",
        "p_66": "{l}",
        "p_67": "{l}",
        "p_68": "{l}",
        "p_69": "{l}"
    },
    "JDSSidePanel": {
        "s_0": "{size.max}",
        "s_1": "{size.max}",
        "s_2": "{flexDirection.row}",
        "s_3": "{justifyContent.start}",
        "s_4": "{alignItems.center}",
        "s_5": "{size.max}",
        "s_6": "{flexDirection.column}",
        "s_7": "{primaryBackground}",
        "s_8": "{size.max}",
        "s_9": "{size.max}",
        "s_10": "{flexDirection.column}",
        "s_11": "{justifyContent.start}",
        "s_12": "{alignItems.center}",
        "s_13": "{m}",
        "s_14": "{m}",
        "s_15": "{m}",
        "s_16": "{primary50}",
        "s_17": "{s}",
        "s_18": "{s}",
        "s_19": "{m}",
        "s_20": "{m}",
        "s_21": "{size.max}",
        "s_22": "{justifyContent.spaceBetween}",
        "s_23": "{alignItems.center}",
        "s_24": "{flexDirection.row}",
        "s_25": "{s}",
        "s_26": "{alignItems.center}",
        "s_27": "{justifyContent.end}",
        "s_28": "{size.max}",
        "s_29": "{size.max}",
        "s_30": 376
    },
    "JDSSidePanelInternal": {
        "s_0": "{size.max}",
        "s_1": "{size.max}",
        "s_2": "{flexDirection.row}",
        "s_3": "{justifyContent.start}",
        "s_4": "{alignItems.center}",
        "s_5": "{size.max}",
        "s_6": "{flexDirection.column}",
        "s_7": "{primaryBackground}",
        "s_8": "{size.max}",
        "s_9": "{size.max}",
        "s_10": "{flexDirection.column}",
        "s_11": "{justifyContent.start}",
        "s_12": "{alignItems.center}",
        "s_13": "{m}",
        "s_14": "{m}",
        "s_15": "{m}",
        "s_16": "{primary50}",
        "s_17": "{s}",
        "s_18": "{s}",
        "s_19": "{m}",
        "s_20": "{m}",
        "s_21": "{size.max}",
        "s_22": "{justifyContent.spaceBetween}",
        "s_23": "{alignItems.center}",
        "s_24": "{flexDirection.row}",
        "s_25": "{s}",
        "s_26": "{alignItems.center}",
        "s_27": "{justifyContent.end}",
        "s_28": "{size.max}",
        "s_29": "{size.max}",
        "s_30": 376
    },
    "JDSProgressBar": {
        "p_0": "{flexDirection.column}",
        "p_1": "{justifyContent.center}",
        "p_2": "{alignItems.start}",
        "p_3": "{base}",
        "p_4": "{size.max}",
        "p_5": "{global.transparent}",
        "p_6": "{global.transparent}",
        "p_7": "{flexDirection.row}",
        "p_8": "{justifyContent.spaceBetween}",
        "p_9": "{alignItems.center}",
        "p_10": "{size.max}",
        "p_11": "{m}",
        "p_12": "{primaryGrey40}",
        "p_13": "{xs}",
        "p_14": "{size.max}",
        "p_15": "{flexDirection.row}",
        "p_16": "{justifyContent.start}",
        "p_17": "{alignItems.start}",
        "p_18": "{pill}",
        "p_19": "{primary50}",
        "p_20": "{xs}",
        "p_21": "{pill}",
        "p_22": "{xs}",
        "p_23": "{flexDirection.stack}",
        "p_24": "{primaryGrey40}",
        "p_25": "{xs}",
        "p_26": "{size.max}",
        "p_27": "{pill}",
        "p_28": "{size.max}",
        "p_29": "{size.max}",
        "p_30": "{massive}",
        "p_31": "{primary50}",
        "p_32": "{pill}",
        "p_33": "{feedbackSuccess50}",
        "p_34": "{feedbackSuccess50}",
        "p_35": "{feedbackError50}",
        "p_36": "{feedbackError50}",
        "p_37": "{feedbackWarning50}",
        "p_38": "{feedbackWarning50}",
        "p_39": "{justifyContent.center}"
    },
    "JDSSearchBox": {
        "s_0": "{primaryGrey20}",
        "s_1": "{flexDirection.row}",
        "s_2": "{justifyContent.start}",
        "s_3": "{alignItems.center}",
        "s_4": "{s}",
        "s_5": "{s}",
        "s_6": "{size.max}",
        "s_7": "{xl}",
        "s_8": "{pill}",
        "s_9": "{s}",
        "s_10": "{opacity.enabled}",
        "s_11": "{primary60}",
        "s_12": "{border_focus}",
        "s_13": "{primaryGrey40}",
        "s_14": "{textAlign.start}",
        "s_15": "{primaryGrey100}",
        "s_16": "{bodyS}",
        "s_17": "{bodyS}",
        "s_18": "{bodyS}",
        "s_19": "{bodyS}",
        "s_20": "{bodyS}",
        "s_21": "{primaryGrey100}",
        "s_22": "{bodyS}",
        "s_23": "{bodyS}",
        "s_24": "{bodyS}",
        "s_25": "{bodyS}",
        "s_26": "{bodyS}",
        "s_27": "{primary60}",
        "s_28": "{primary60}",
        "s_29": "{primary60}",
        "s_30": "{primary60}",
        "s_31": "{flexDirection.row}",
        "s_32": "{justifyContent.center}",
        "s_33": "{alignItems.center}",
        "s_34": "{m}",
        "s_35": "{primaryGrey100}",
        "s_36": "{primary60}",
        "s_37": "{primary60}",
        "s_38": "{primaryGrey80}",
        "s_39": "{flexDirection.row}",
        "s_40": "{justifyContent.center}",
        "s_41": "{alignItems.center}",
        "s_42": "{m}",
        "s_43": "{primary60}",
        "s_44": "{primary60}",
        "s_45": "{primary60}",
        "s_46": "{primaryGrey100}",
        "s_47": "{primary60}",
        "s_48": "{primary80}",
        "s_49": "{primary70}",
        "s_50": "{primaryBackground}",
        "s_51": "{primary30}",
        "s_52": "{primary30}",
        "s_53": "{primaryBackground}",
        "s_54": "{primary30}",
        "s_55": "{primary30}",
        "s_56": "{primaryBackground}",
        "s_57": "{primary40}",
        "s_58": "{primary30}",
        "s_59": "{primary30}",
        "s_60": "{primaryBackground}",
        "s_61": "{primaryGrey60}",
        "s_62": "{primary50}",
        "s_63": "{primary80}",
        "s_64": "{primary60}",
        "s_65": "{border_thin}",
        "s_66": "{border_focus}",
        "s_67": "{primaryGrey100}",
        "s_68": "{primary60}",
        "s_69": "{primaryGrey100}",
        "s_70": "{primaryGrey100}",
        "s_71": "{primary60}",
        "s_72": "{primary60}",
        "s_73": "{primaryGrey100}",
        "s_74": "{primary60}",
        "s_75": "{primary60}",
        "s_76": "{opacity.disabled}",
        "s_77": "{primaryGrey80}",
        "s_78": "{primary30}",
        "s_79": "{primaryGrey60}",
        "s_80": "{primaryGrey80}",
        "s_81": "{primary60}"
    },
    "JDSPaginationButton": {
        "p_0": "{xxl}",
        "p_1": "{justifyContent.center}",
        "p_2": "{alignItems.center}",
        "p_3": "{global.transparent}",
        "p_4": "{flexDirection.row}",
        "p_5": "{justifyContent.center}",
        "p_6": "{alignItems.center}",
        "p_7": "{pill}",
        "p_8": "{l}",
        "p_9": "{l}",
        "p_10": "{opacity.enabled}",
        "p_11": "{xs}",
        "p_12": "{primary80}",
        "p_13": "{primary20}",
        "p_14": "{primary30}",
        "p_15": "{border_focus}",
        "p_16": "{primary70}",
        "p_17": "{global.transparent}"
    },
    "JDSSearchResultItem": {
        "s_0": "{flexDirection.row}",
        "s_1": "{base}",
        "s_2": "{xs}",
        "s_3": "{xs}",
        "s_4": "{alignItems.center}",
        "s_5": "{size.max}",
        "s_6": "{primaryGrey20}",
        "s_7": "{primaryGrey20}",
        "s_8": "{primaryGrey20}",
        "s_9": "{l}",
        "s_10": "{primaryGrey80}",
        "s_11": "{flexDirection.row}",
        "s_12": "{justifyContent.start}",
        "s_13": "{alignItems.center}"
    },
    "JDSSearchResultText": {},
    "JDSRadioButton": {
        "r_0": "{flexDirection.column}",
        "r_1": "{justifyContent.start}",
        "r_2": "{alignItems.start}",
        "r_3": "{xs}",
        "r_4": "{flexDirection.row}",
        "r_5": "{justifyContent.start}",
        "r_6": "{alignItems.center}",
        "r_7": "{xs}",
        "r_8": "{m}",
        "r_9": "{m}",
        "r_10": "{flexDirection.row}",
        "r_11": "{justifyContent.center}",
        "r_12": "{alignItems.center}",
        "r_13": "{global.transparent}",
        "r_14": "{pill}",
        "r_15": "{primaryGrey80}",
        "r_16": "{border_thin}",
        "r_17": "{border_none}",
        "r_18": "{primary40}",
        "r_19": "{primary60}",
        "r_20": "{primary60}",
        "r_21": "{s}",
        "r_22": "{s}",
        "r_23": "{pill}",
        "r_24": "{textAlign.start}",
        "r_25": "{base}",
        "r_26": "{base}",
        "r_27": "{xxs}",
        "r_28": "{xs}",
        "r_29": "{xs}",
        "r_30": "{primary50}",
        "r_31": "{primary40}",
        "r_32": "{primary60}",
        "r_33": "{primary50}",
        "r_34": "{primaryInverse}",
        "r_35": "{opacity.disabled}",
        "r_36": "{opacity.enabled}",
        "r_37": "{global.white}",
        "r_38": "{global.white}",
        "r_39": "{global.white}"
    },
    "JDSSelector": {
        "s_0": "{flexDirection.stack}",
        "s_1": "{opacity.enabled}",
        "s_2": "{alignItems.center}",
        "s_3": "{justifyContent.center}",
        "s_4": "{pill}",
        "s_5": "{xxs}",
        "s_6": "{xxs}",
        "s_7": "{xxs}",
        "s_8": "{xxs}",
        "s_9": "{xxs}",
        "s_10": "{xxs}",
        "s_11": "{xxs}",
        "s_12": "{xxs}",
        "s_13": "{primaryGrey20}",
        "s_14": "{pill}",
        "s_15": "{xxs}",
        "s_16": "{flexDirection.row}",
        "s_17": "{size.max}",
        "s_18": "{intrinsicSize.max}",
        "s_19": "{justifyContent.start}",
        "s_20": "{alignItems.center}",
        "s_21": "{primary50}",
        "s_22": "{pill}",
        "s_23": "{size.max}",
        "s_24": "{size.max}",
        "s_25": "{primary50}"
    },
    "JDSSelectorItem": {
        "s_0": "{opacity.enabled}",
        "s_1": "{global.transparent}",
        "s_2": "{flexDirection.row}",
        "s_3": "{alignItems.center}",
        "s_4": "{justifyContent.center}",
        "s_5": "{pill}",
        "s_6": "{xs}",
        "s_7": "{xs}",
        "s_8": "{base}",
        "s_9": "{xs}",
        "s_10": "{base}",
        "s_11": "{primary20}",
        "s_12": "{xxs}",
        "s_13": "{primary60}",
        "s_14": "{primary20}",
        "s_15": "{primary30}",
        "s_16": "{m}",
        "s_17": "{primary60}",
        "s_18": "{primary50}",
        "s_19": "{primary60}",
        "s_20": "{primary60}",
        "s_21": "{primary50}",
        "s_22": "{primaryInverse}",
        "s_23": "{primary30}",
        "s_24": "{flexDirection.column}",
        "s_25": "{size.max}",
        "s_26": "{opacity.disabled}",
        "s_27": "{xxs}"
    },
    "JDSSearchResults": {
        "s_0": "{global.transparent}",
        "s_1": "{flexDirection.stack}",
        "s_2": "{justifyContent.center}",
        "s_3": "{size.max}",
        "s_4": "{global.transparent}",
        "s_5": "{primaryBackground}",
        "s_6": "{flexDirection.column}",
        "s_7": "{alignItems.center}",
        "s_8": "{base}",
        "s_9": "{base}",
        "s_10": "{base}",
        "s_11": "{base}",
        "s_12": "{base}",
        "s_13": "{size.max}",
        "s_14": "{size.max}",
        "s_15": "{flexDirection.column}",
        "s_16": "{alignItems.center}",
        "s_17": "{flexDirection.row}",
        "s_18": "{justifyContent.spaceBetween}",
        "s_19": "{alignItems.start}",
        "s_20": "{size.max}",
        "s_21": "{flexDirection.column}",
        "s_22": "{alignItems.start}",
        "s_23": "{base}",
        "s_24": "{size.max}",
        "s_25": "{xl}"
    },
    "JDSSearchResultsInternal": {
        "s_0": "{global.transparent}",
        "s_1": "{flexDirection.stack}",
        "s_2": "{justifyContent.center}",
        "s_3": "{size.max}",
        "s_4": "{global.transparent}",
        "s_5": "{primaryBackground}",
        "s_6": "{flexDirection.column}",
        "s_7": "{alignItems.center}",
        "s_8": "{base}",
        "s_9": "{base}",
        "s_10": "{base}",
        "s_11": "{base}",
        "s_12": "{base}",
        "s_13": "{size.max}",
        "s_14": "{size.max}",
        "s_15": "{flexDirection.column}",
        "s_16": "{alignItems.center}",
        "s_17": "{flexDirection.row}",
        "s_18": "{justifyContent.spaceBetween}",
        "s_19": "{alignItems.start}",
        "s_20": "{size.max}",
        "s_21": "{flexDirection.column}",
        "s_22": "{alignItems.start}",
        "s_23": "{base}",
        "s_24": "{size.max}",
        "s_25": "{xl}"
    },
    "JDSSkeleton": {
        "s_0": "{primaryGrey20}",
        "s_1": "{primaryGrey20}",
        "s_2": "{primaryGrey40}",
        "s_3": "{pill}",
        "s_4": "{xxl}",
        "s_5": "{pill}",
        "s_6": "{pill}",
        "s_7": "{base}",
        "s_8": "{xl}",
        "s_9": "{xxl}",
        "s_10": "{size.max}",
        "s_11": "{size.max}"
    },
    "JDSServiceCard": {
        "s_0": "{flexDirection.stack}",
        "s_1": "{flexDirection.stack}",
        "s_2": "{size.max}",
        "s_3": "{size.max}",
        "s_4": "{justifyContent.start}",
        "s_5": "{justifyContent.start}",
        "s_6": "{alignItems.start}",
        "s_7": "{xl}",
        "s_8": "{size.max}",
        "s_9": "{size.max}",
        "s_10": "{xl}",
        "s_11": "{aspect_ratio.16.9}",
        "s_12": "{flexDirection.column}",
        "s_13": "{size.max}",
        "s_14": "{justifyContent.start}",
        "s_15": "{alignItems.start}",
        "s_16": "{flexDirection.row}",
        "s_17": "{justifyContent.start}",
        "s_18": "{alignItems.start}",
        "s_19": "{size.max}",
        "s_20": "{size.max}",
        "s_21": "{base}",
        "s_22": "{base}",
        "s_23": "{custom_color_4}",
        "s_24": "{size.max}",
        "s_25": "{base}",
        "s_26": "{base}",
        "s_27": "{base}",
        "s_28": "{base}",
        "s_29": "{size.max}",
        "s_30": "{aspect_ratio.1.1}",
        "s_31": "{aspect_ratio.4.3}",
        "s_32": "{aspect_ratio.4.5}"
    },
    "JDSNotificationIconButton": {
        "n_0": "{l}",
        "n_1": "{l}",
        "n_2": "{justifyContent.center}",
        "n_3": "{alignItems.center}",
        "n_4": "{global.transparent}",
        "n_5": "{global.transparent}",
        "n_6": "{primary30}",
        "n_7": "{primary40}",
        "n_8": "{primary30}",
        "n_9": "{primary50}",
        "n_10": "{base}",
        "n_11": "{primary20}",
        "n_12": "{opacity.disabled}"
    },
    "JDSSpinner": {
        "s_0": "{global.transparent}",
        "s_1": "{base}",
        "s_2": "{justifyContent.center}",
        "s_3": "{alignItems.center}",
        "s_4": "{flexDirection.row}",
        "s_5": "{xxl}",
        "s_6": "{flexDirection.stack}",
        "s_7": "{justifyContent.center}",
        "s_8": "{alignItems.center}",
        "s_9": "{size.max}",
        "s_10": "{primaryGrey40}",
        "s_11": "{m}",
        "s_12": "{xs}",
        "s_13": 0,
        "s_14": 360,
        "s_15": "{primary50}",
        "s_16": "{m}",
        "s_17": "{xs}",
        "s_18": 0,
        "s_19": 120,
        "s_20": "1000",
        "s_21": "{primary50}",
        "s_22": "{m}",
        "s_23": "{xs}",
        "s_24": 0,
        "s_25": 360,
        "s_26": "300",
        "s_27": "1300",
        "s_28": "{secondary50}",
        "s_29": "{m}",
        "s_30": "{xs}",
        "s_31": 0,
        "s_32": 360,
        "s_33": "150",
        "s_34": "1300",
        "s_35": "{sparkle50}",
        "s_36": "{m}",
        "s_37": "{xs}",
        "s_38": 0,
        "s_39": 360,
        "s_40": "1300",
        "s_41": "{flexDirection.column}",
        "s_42": "{s}",
        "s_43": "{m}",
        "s_44": "{xxs}",
        "s_45": "{s}",
        "s_46": "{xxs}",
        "s_47": "{s}",
        "s_48": "{xxs}",
        "s_49": "{s}",
        "s_50": "{xxs}",
        "s_51": "{s}",
        "s_52": "{xxs}",
        "s_53": "{s}",
        "s_54": "{primaryGrey80}",
        "s_55": "{flexDirection.row}"
    },
    "JDSSelectorButton": {
        "s_0": "{primary50}",
        "s_1": "{flexDirection.row}",
        "s_2": "{justifyContent.center}",
        "s_3": "{alignItems.center}",
        "s_4": "{pill}",
        "s_5": "{xs}",
        "s_6": "{xs}",
        "s_7": "{base}",
        "s_8": "{base}",
        "s_9": "{border_none}",
        "s_10": "{xs}",
        "s_11": "{opacity.enabled}",
        "s_12": "{primary30}",
        "s_13": "{primary60}",
        "s_14": "{border_focus}",
        "s_15": "{primary60}",
        "s_16": "{m}",
        "s_17": "{primaryInverse}",
        "s_18": "{primary70}",
        "s_19": "{m}",
        "s_20": "{primaryInverse}",
        "s_21": "{primary70}",
        "s_22": "{opacity.disabled}",
        "s_23": "{primary60}",
        "s_24": "{primary50}",
        "s_25": "{primary70}",
        "s_26": "{primary70}",
        "s_27": "{global.transparent}",
        "s_28": "{border_thin}",
        "s_29": "{primaryGrey60}",
        "s_30": "{primary20}",
        "s_31": "{primary60}",
        "s_32": "{primary20}",
        "s_33": "{border_focus}",
        "s_34": "{primary60}",
        "s_35": "{primary60}",
        "s_36": "{primary60}",
        "s_37": "{primary20}",
        "s_38": "{border_thin}",
        "s_39": "{primaryGrey60}",
        "s_40": "{primary60}",
        "s_41": "{primary30}",
        "s_42": "{border_focus}",
        "s_43": "{primary60}",
        "s_44": "{primary60}",
        "s_45": "{primary70}",
        "s_46": "{primary60}",
        "s_47": "{primary70}",
        "s_48": "{primary20}",
        "s_49": "{primary20}",
        "s_50": "{primary60}",
        "s_51": "{border_thin}",
        "s_52": "{primary30}",
        "s_53": "{border_focus}",
        "s_54": "{primary60}",
        "s_55": "{primary60}",
        "s_56": "{primary70}",
        "s_57": "{primary60}",
        "s_58": "{primary60}",
        "s_59": "{primary70}",
        "s_60": "{primary60}",
        "s_61": "{global.transparent}",
        "s_62": "{border_thin}",
        "s_63": "{primary60}",
        "s_64": "{primary20}",
        "s_65": "{primary20}",
        "s_66": "{primary60}",
        "s_67": "{primary60}",
        "s_68": "{primary60}",
        "s_69": "{primary60}",
        "s_70": "{primary60}",
        "s_71": "{primary60}",
        "s_72": "{global.transparent}",
        "s_73": "{border_focus}",
        "s_74": "{primary60}",
        "s_75": "{global.transparent}",
        "s_76": "{global.transparent}",
        "s_77": "{primary70}",
        "s_78": "{primary60}",
        "s_79": "{primary80}",
        "s_80": "{primary70}",
        "s_81": "{primary60}",
        "s_82": "{primary80}",
        "s_83": "{global.transparent}",
        "s_84": "{global.transparent}",
        "s_85": "{global.transparent}",
        "s_86": "{primary60}",
        "s_87": "{primary50}",
        "s_88": "{primary70}",
        "s_89": "{primary60}",
        "s_90": "{primary50}",
        "s_91": "{primary70}",
        "s_92": "{primaryGrey80}",
        "s_93": "{primary30}",
        "s_94": "{primary50}",
        "s_95": "{border_focus}",
        "s_96": "{primary60}",
        "s_97": "{primaryBackground}",
        "s_98": "{primary70}",
        "s_99": "{primaryInverse}",
        "s_100": "{primaryBackground}",
        "s_101": "{primary70}",
        "s_102": "{primaryInverse}",
        "s_103": "{global.transparent}",
        "s_104": "{border_thin}",
        "s_105": "{primaryGrey60}",
        "s_106": "{primary20}",
        "s_107": "{primary60}",
        "s_108": "{primary20}",
        "s_109": "{border_focus}",
        "s_110": "{primary60}",
        "s_111": "{primaryGrey80}",
        "s_112": "{primaryGrey80}",
        "s_113": "{primary20}",
        "s_114": "{primaryGrey60}",
        "s_115": "{primary60}",
        "s_116": "{primary30}",
        "s_117": "{border_focus}",
        "s_118": "{primary60}",
        "s_119": "{primary60}",
        "s_120": "{primary70}",
        "s_121": "{primary60}",
        "s_122": "{primary70}",
        "s_123": "{primary20}",
        "s_124": "{primary60}",
        "s_125": "{border_thin}",
        "s_126": "{primary30}",
        "s_127": "{border_focus}",
        "s_128": "{primary60}",
        "s_129": "{primary60}",
        "s_130": "{primary70}",
        "s_131": "{primary60}",
        "s_132": "{primary70}",
        "s_133": "{global.transparent}",
        "s_134": "{primary60}",
        "s_135": "{border_thin}",
        "s_136": "{primary20}",
        "s_137": "{primary20}",
        "s_138": "{border_focus}",
        "s_139": "{primary60}",
        "s_140": "{primaryGrey80}",
        "s_141": "{primary60}",
        "s_142": "{primary60}",
        "s_143": "{primaryGrey80}",
        "s_144": "{primary60}",
        "s_145": "{primary60}",
        "s_146": "{global.transparent}",
        "s_147": "{global.transparent}",
        "s_148": "{border_focus}",
        "s_149": "{primary60}",
        "s_150": "{primary60}",
        "s_151": "{primary50}",
        "s_152": "{primary80}",
        "s_153": "{primary60}",
        "s_154": "{primary50}",
        "s_155": "{primary80}",
        "s_156": "{global.transparent}",
        "s_157": "{global.transparent}",
        "s_158": "{border_focus}",
        "s_159": "{primary60}",
        "s_160": "{primaryGrey80}",
        "s_161": "{primary50}",
        "s_162": "{primary60}",
        "s_163": "{primaryGrey80}",
        "s_164": "{primary50}",
        "s_165": "{primary60}",
        "s_166": "{primaryBackground}",
        "s_167": "{primary30}",
        "s_168": "{primary50}",
        "s_169": "{border_focus}",
        "s_170": "{primary50}",
        "s_171": "{primaryGrey100}",
        "s_172": "{primaryGrey100}",
        "s_173": "{primaryGrey100}",
        "s_174": "{primaryInverse}",
        "s_175": "{primaryGrey100}",
        "s_176": "{primaryGrey100}",
        "s_177": "{primaryGrey100}",
        "s_178": "{primaryInverse}",
        "s_179": "{primary50}",
        "s_180": "{primary30}",
        "s_181": "{primary60}",
        "s_182": "{primary50}",
        "s_183": "{border_focus}",
        "s_184": "{primary40}",
        "s_185": "{primaryInverse}",
        "s_186": "{primaryGrey100}",
        "s_187": "{primaryInverse}",
        "s_188": "{primaryGrey100}",
        "s_189": "{global.transparent}",
        "s_190": "{border_thin}",
        "s_191": "{primaryGrey60}",
        "s_192": "{primary30}",
        "s_193": "{primary50}",
        "s_194": "{primary30}",
        "s_195": "{border_focus}",
        "s_196": "{primary50}",
        "s_197": "{primaryBackground}",
        "s_198": "{primaryGrey100}",
        "s_199": "{primaryGrey100}",
        "s_200": "{primaryBackground}",
        "s_201": "{primaryGrey100}",
        "s_202": "{primaryGrey100}",
        "s_203": "{primary30}",
        "s_204": "{primaryGrey60}",
        "s_205": "{primary50}",
        "s_206": "{primary50}",
        "s_207": "{border_focus}",
        "s_208": "{primary50}",
        "s_209": "{primaryGrey100}",
        "s_210": "{primaryInverse}",
        "s_211": "{primaryGrey100}",
        "s_212": "{primaryInverse}",
        "s_213": "{global.transparent}",
        "s_214": "{primary30}",
        "s_215": "{primary50}",
        "s_216": "{primary30}",
        "s_217": "{border_focus}",
        "s_218": "{primary50}",
        "s_219": "{primaryBackground}",
        "s_220": "{primaryGrey100}",
        "s_221": "{primaryGrey100}",
        "s_222": "{primaryBackground}",
        "s_223": "{primaryGrey100}",
        "s_224": "{primaryGrey100}",
        "s_225": "{primary30}",
        "s_226": "{primary50}",
        "s_227": "{border_focus}",
        "s_228": "{primary50}",
        "s_229": "{primary50}",
        "s_230": "{primaryGrey100}",
        "s_231": "{primaryInverse}",
        "s_232": "{primaryGrey100}",
        "s_233": "{primaryInverse}",
        "s_234": "{global.transparent}",
        "s_235": "{border_focus}",
        "s_236": "{primary50}",
        "s_237": "{global.transparent}",
        "s_238": "{global.transparent}",
        "s_239": "{primaryBackground}",
        "s_240": "{primary20}",
        "s_241": "{primary30}",
        "s_242": "{primaryBackground}",
        "s_243": "{primary20}",
        "s_244": "{primary30}",
        "s_245": "{global.transparent}",
        "s_246": "{border_focus}",
        "s_247": "{primary50}",
        "s_248": "{global.transparent}",
        "s_249": "{global.transparent}",
        "s_250": "{primary30}",
        "s_251": "{primary20}",
        "s_252": "{primary30}",
        "s_253": "{primary30}",
        "s_254": "{primary30}",
        "s_255": "{primary20}",
        "s_256": "{primary30}",
        "s_257": "{primary30}",
        "s_258": "{xxs}",
        "s_259": "{xxs}",
        "s_260": "{xs}",
        "s_261": "{xs}",
        "s_262": "{s}",
        "s_263": "{s}",
        "s_264": "{base}",
        "s_265": "{base}",
        "s_266": "{xxs}",
        "s_267": "{xxs}",
        "s_268": "{base}",
        "s_269": "{base}",
        "s_270": "{s}",
        "s_271": "{m}",
        "s_272": "{s}",
        "s_273": "{m}",
        "s_274": "{m}",
        "s_275": "{m}",
        "s_276": "{base}",
        "s_277": "{l}",
        "s_278": "{base}",
        "s_279": "{l}",
        "s_280": "{l}",
        "s_281": "{l}",
        "s_282": "{l}",
        "s_283": "{l}",
        "s_284": "{base}",
        "s_285": "{xl}",
        "s_286": "{xl}",
        "s_287": "{xxl}",
        "s_288": "{xxl}",
        "s_289": "{m}",
        "s_290": "{huge}",
        "s_291": "{huge}",
        "s_292": "{l}",
        "s_293": "{size.max}",
        "s_294": "{justifyContent.spaceBetween}",
        "s_295": "{primary60}",
        "s_296": "{primary60}"
    },
    "JDSSlider": {
        "s_0": "{flexDirection.column}",
        "s_1": "{justifyContent.start}",
        "s_2": "{alignItems.start}",
        "s_3": "{size.max}",
        "s_4": "{xs}",
        "s_5": "{flexDirection.row}",
        "s_6": "{justifyContent.start}",
        "s_7": "{alignItems.center}",
        "s_8": "{size.max}",
        "s_9": "{xs}",
        "s_10": "{justifyContent.start}",
        "s_11": "{alignItems.center}",
        "s_12": "{alignItems.center}",
        "s_13": "{xs}",
        "s_14": "{xs}",
        "s_15": "{border_thin}",
        "s_16": "{primaryGrey80}",
        "s_17": "{medium}",
        "s_18": "{size.max}",
        "s_19": "{xxs}",
        "s_20": "{primaryGrey40}",
        "s_21": "{primary50}",
        "s_22": "{primary50}",
        "s_23": "{primary80}",
        "s_24": "{small}",
        "s_25": "{primary60}",
        "s_26": "{primary60}",
        "s_27": "{primary60}",
        "s_28": "{border_focus}",
        "s_29": "{flexDirection.row}",
        "s_30": "{justifyContent.spaceBetween}",
        "s_31": "{alignItems.center}",
        "s_32": "{size.max}",
        "s_33": "{feedbackSuccess50}",
        "s_34": "{feedbackError50}",
        "s_35": "{feedbackWarning50}",
        "s_36": "{opacity.disabled}",
        "s_37": "{primary50}",
        "s_38": "{primary50}",
        "s_39": "{primary50}"
    },
    "JDSStepperDot": {
        "s_0": "{global.transparent}",
        "s_1": "{border_thin}",
        "s_2": "{sparkleGrey60}",
        "s_3": "{l}",
        "s_4": "{l}",
        "s_5": "{justifyContent.center}",
        "s_6": "{alignItems.center}",
        "s_7": "{pill}",
        "s_8": "{sparkleGrey60}",
        "s_9": "{base}",
        "s_10": "{sparkle60}",
        "s_11": "{base}",
        "s_12": "{sparkleGrey60}",
        "s_13": "{xs}",
        "s_14": "{xs}",
        "s_15": "{pill}",
        "s_16": "{sparkle50}",
        "s_17": "{sparkle50}",
        "s_18": "{sparkleInverse}",
        "s_19": "{sparkleInverse}",
        "s_20": "{sparkle20}",
        "s_21": "{sparkle50}",
        "s_22": "{l}",
        "s_23": "{l}",
        "s_24": "{sparkle60}",
        "s_25": "{sparkle60}",
        "s_26": "{opacity.disabled}"
    },
    "JDSHorizontalStepItem": {
        "h_0": "{flexDirection.column}",
        "h_1": "{alignItems.center}",
        "h_2": "{justifyContent.start}",
        "h_3": "{size.max}",
        "h_4": "{xs}",
        "h_5": "{flexDirection.row}",
        "h_6": "{size.max}",
        "h_7": "{alignItems.center}",
        "h_8": "{xs}",
        "h_9": "{xs}",
        "h_10": "{xs}",
        "h_11": "{opacity.enabled}",
        "h_12": "{opacity.enabled}",
        "h_13": "{opacity.invisible}",
        "h_14": "{opacity.invisible}"
    },
    "JDSVerticalStepItem": {
        "v_0": "{flexDirection.column}",
        "v_1": "{justifyContent.start}",
        "v_2": "{alignItems.start}",
        "v_3": "{xs}",
        "v_4": "{size.max}",
        "v_5": "{opacity.enabled}",
        "v_6": "{flexDirection.row}",
        "v_7": "{justifyContent.start}",
        "v_8": "{alignItems.center}",
        "v_9": "{intrinsicSize.max}",
        "v_10": "{flexDirection.row}",
        "v_11": "{justifyContent.start}",
        "v_12": "{alignItems.stretch}",
        "v_13": "{l}",
        "v_14": "{custom_23}",
        "v_15": "{flexDirection.row}",
        "v_16": "{justifyContent.start}",
        "v_17": "{alignItems.center}",
        "v_18": "{base}",
        "v_19": "0",
        "v_20": "0",
        "v_21": "{custom_24}",
        "v_22": "{xs}",
        "v_23": "{m}",
        "v_24": "{opacity.invisible}"
    },
    "JDSTableCell": {
        "t_0": "{flexDirection.row}",
        "t_1": "{justifyContent.start}",
        "t_2": "{alignItems.center}",
        "t_3": "{global.transparent}",
        "t_4": "{base}",
        "t_5": "{base}",
        "t_6": "{base}",
        "t_7": "{base}",
        "t_8": "{primaryGrey40}",
        "t_9": "{size.max}",
        "t_10": "{xs}",
        "t_11": "{xs}",
        "t_12": "{xs}",
        "t_13": "{xs}",
        "t_14": "{primaryGrey40}",
        "t_15": 1,
        "t_16": "{primary50}",
        "t_17": "{primary60}",
        "t_18": "{primaryGrey20}",
        "t_19": 1,
        "t_20": 4,
        "t_21": 0
    },
    "JDSTableBody": {
        "t_0": "{size.max}",
        "t_1": "{flexDirection.row}",
        "t_2": "{size.max}"
    },
    "JDSTableRow": {
        "t_0": "{flexDirection.column}",
        "t_1": "{size.max}",
        "t_2": "{size.max}"
    },
    "JDSTabBar": {
        "t_0": "{flexDirection.stack}",
        "t_1": "{size.max}",
        "t_2": "{size.max}",
        "t_3": "{justifyContent.start}",
        "t_4": "{alignItems.end}",
        "t_5": "{size.max}",
        "t_6": "{opacity.enabled}",
        "t_7": "{global.transparent}",
        "t_8": "{alignItems.center}",
        "t_9": "{justifyContent.start}",
        "t_10": "{xxs}",
        "t_11": "{flexDirection.row}",
        "t_12": "{flexDirection.row}",
        "t_13": "{justifyContent.start}",
        "t_14": "{alignItems.center}",
        "t_15": "{size.max}",
        "t_16": "{pill}",
        "t_17": "{primary50}",
        "t_18": "{xxs}",
        "t_19": "{size.max}",
        "t_20": "{justifyContent.center}",
        "t_21": "{primary60}",
        "t_22": "{xxl}",
        "t_23": "{xxl}",
        "t_24": "{custom_dark_primary_60}",
        "t_25": "{m}",
        "t_26": "{m}"
    },
    "JDSVerticalStepper": {
        "v_0": "{flexDirection.column}",
        "v_1": "{justifyContent.start}",
        "v_2": "{alignItems.start}",
        "v_3": "{size.max}",
        "v_4": "{xs}"
    },
    "JDSTabItem": {
        "t_0": "{global.transparent}",
        "t_1": "{flexDirection.column}",
        "t_2": "{alignItems.center}",
        "t_3": "{justifyContent.center}",
        "t_4": "{xxl}",
        "t_5": "{intrinsicSize.max}",
        "t_6": "{intrinsicSize.max}",
        "t_7": "{flexDirection.row}",
        "t_8": "{alignItems.center}",
        "t_9": "{justifyContent.center}",
        "t_10": "{xs}",
        "t_11": "{s}",
        "t_12": "{s}",
        "t_13": "{xs}",
        "t_14": "{xs}",
        "t_15": "{border_normal}",
        "t_16": "{primary80}",
        "t_17": "{large}",
        "t_18": "{m}",
        "t_19": "{primaryGrey80}",
        "t_20": "{primaryGrey100}",
        "t_21": "{primary60}",
        "t_22": "{primaryGrey80}",
        "t_23": "{bodyS}",
        "t_24": "{bodyS}",
        "t_25": "{bodyS}",
        "t_26": "{bodyS}",
        "t_27": "{bodyS}",
        "t_28": "{primary60}",
        "t_29": "{global.transparent}",
        "t_30": "{xxs}",
        "t_31": "{size.max}",
        "t_32": "{pill}",
        "t_33": "{opacity.enabled}",
        "t_34": "{opacity.disabled}",
        "t_35": "{primaryGrey100}",
        "t_36": "{primary60}",
        "t_37": "{custom_dark_primary_40}",
        "t_38": "{custom_dark_primary_60}",
        "t_39": "{custom_dark_primary_grey_100}",
        "t_40": "{custom_dark_primary_grey_80}",
        "t_41": "{custom_dark_primary_grey_100}",
        "t_42": "{custom_dark_primary_grey_100}",
        "t_43": "{custom_dark_primary_grey_80}",
        "t_44": "{custom_dark_primary_grey_100}",
        "t_45": "{primaryGrey100}",
        "t_46": "{primaryGrey100}"
    },
    "JDSTabsDesktop": {
        "t_0": "{flexDirection.column}",
        "t_1": "{size.max}",
        "t_2": "{size.max}",
        "t_3": "{flexDirection.row}",
        "t_4": "{size.max}",
        "t_5": "{alignItems.center}",
        "t_6": "{size.max}",
        "t_7": "{base}",
        "t_8": "{primary60}"
    },
    "JDSTag": {
        "t_0": "{flexDirection.row}",
        "t_1": "{justifyContent.start}",
        "t_2": "{alignItems.center}",
        "t_3": "{xxs}",
        "t_4": "{s}",
        "t_5": "{s}",
        "t_6": "{xxs}",
        "t_7": "{xxs}",
        "t_8": "{global.transparent}",
        "t_9": "{pill}",
        "t_10": "{border_thin}",
        "t_11": "{primaryGrey80}",
        "t_12": "{primaryGrey80}",
        "t_13": "{sparkle20}",
        "t_14": "{sparkle80}",
        "t_15": "{border_focus}",
        "t_16": "{base}",
        "t_17": "{primaryGrey100}",
        "t_18": "{sparkle80}",
        "t_19": "{sparkle80}",
        "t_20": "{sparkle80}",
        "t_21": "{border_none}",
        "t_22": "{primaryGrey80}",
        "t_23": "{sparkle20}",
        "t_24": "{sparkle30}",
        "t_25": "{global.transparent}",
        "t_26": "{primaryGrey40}",
        "t_27": "{sparkle30}",
        "t_28": "{sparkle80}",
        "t_29": "{opacity.disabled}",
        "t_30": "{opacity.enabled}",
        "t_31": "{custom_4}",
        "t_32": "{xs}",
        "t_33": "{xs}",
        "t_34": "{custom_4}"
    },
    "JDSHorizontalStepper": {
        "h_0": "{stepper_horizontal}",
        "h_1": "{flexDirection.column}",
        "h_2": "{size.max}",
        "h_3": "{flexDirection.row}",
        "h_4": "{justifyContent.center}",
        "h_5": "{alignItems.center}",
        "h_6": "{size.max}",
        "h_7": "{l}",
        "h_8": "{l}",
        "h_9": "{size.max}",
        "h_10": "{flexDirection.row}",
        "h_11": "{justifyContent.start}",
        "h_12": "{alignItems.center}"
    },
    "JDSTable": {
        "t_0": "{flexDirection.column}",
        "t_1": "{size.max}",
        "t_2": "{medium}",
        "t_3": "{border_thin}",
        "t_4": "{primaryGrey40}",
        "t_5": "{size.max}",
        "t_6": "{alignItems.start}",
        "t_7": "{base}",
        "t_8": "{base}",
        "t_9": "{base}",
        "t_10": "{base}",
        "t_11": "{xs}",
        "t_12": "{xs}",
        "t_13": "{xs}",
        "t_14": "{xs}"
    },
    "JDSToggle": {
        "t_0": "{flexDirection.column}",
        "t_1": "{flexDirection.column}",
        "t_2": "{justifyContent.start}",
        "t_3": "{alignItems.start}",
        "t_4": "{xs}",
        "t_5": "{flexDirection.row}",
        "t_6": "{justifyContent.start}",
        "t_7": "{alignItems.center}",
        "t_8": "{xs}",
        "t_9": "{custom_2}",
        "t_10": "{m}",
        "t_11": "{flexDirection.row}",
        "t_12": "{justifyContent.start}",
        "t_13": "{alignItems.center}",
        "t_14": "{xxs}",
        "t_15": "{xxs}",
        "t_16": "{global.transparent}",
        "t_17": "{pill}",
        "t_18": "{border_thin}",
        "t_19": "{primaryGrey80}",
        "t_20": "{primary40}",
        "t_21": "{primary60}",
        "t_22": "{xxs}",
        "t_23": "{primary60}",
        "t_24": "{border_none}",
        "t_25": "{base}",
        "t_26": "{base}",
        "t_27": "{primaryGrey80}",
        "t_28": "{pill}",
        "t_29": "{textAlign.start}",
        "t_30": "{custom_3}",
        "t_31": "{base}",
        "t_32": "{xxs}",
        "t_33": "{xs}",
        "t_34": "{xs}",
        "t_35": "{justifyContent.end}",
        "t_36": "{primary50}",
        "t_37": "{border_none}",
        "t_38": "{primary40}",
        "t_39": "{primary60}",
        "t_40": "{primaryInverse}",
        "t_41": "{opacity.disabled}",
        "t_42": "{opacity.enabled}"
    },
    "JDSText": {
        "text_0": "{primary60}",
        "text_1": "{bodyS}",
        "text_2": "{primaryGrey100}",
        "text_3": "{bodyS}",
        "text_4": "{bodyS}",
        "text_5": "{bodyS}",
        "text_6": "{bodyS}",
        "text_7": "{text-decoration.none}",
        "text_8": "{text-case.none}",
        "text_9": "{text-decoration.underline}",
        "text_10": "{text-decoration.line-through}",
        "text_11": "{text-decoration.overline}",
        "text_12": "{primary80}",
        "text_13": "{primary70}",
        "text_14": "{primary60}",
        "text_15": "{primary50}",
        "text_16": "{primary40}",
        "text_17": "{primary30}",
        "text_18": "{primary20}",
        "text_19": "{primaryInverse}",
        "text_20": "{primaryBackground}",
        "text_21": "{primaryGrey100}",
        "text_22": "{primaryGrey80}",
        "text_23": "{primaryGrey60}",
        "text_24": "{primaryGrey40}",
        "text_25": "{primaryGrey20}",
        "text_26": "{secondary80}",
        "text_27": "{secondary70}",
        "text_28": "{secondary60}",
        "text_29": "{secondary50}",
        "text_30": "{secondary40}",
        "text_31": "{secondary30}",
        "text_32": "{secondary20}",
        "text_33": "{secondaryInverse}",
        "text_34": "{secondaryBackground}",
        "text_35": "{secondaryGrey100}",
        "text_36": "{secondaryGrey80}",
        "text_37": "{secondaryGrey60}",
        "text_38": "{secondaryGrey40}",
        "text_39": "{secondaryGrey20}",
        "text_40": "{sparkle80}",
        "text_41": "{sparkle70}",
        "text_42": "{sparkle60}",
        "text_43": "{sparkle50}",
        "text_44": "{sparkle40}",
        "text_45": "{sparkle30}",
        "text_46": "{sparkle20}",
        "text_47": "{sparkleInverse}",
        "text_48": "{sparkleBackground}",
        "text_49": "{sparkleGrey100}",
        "text_50": "{sparkleGrey80}",
        "text_51": "{sparkleGrey60}",
        "text_52": "{sparkleGrey40}",
        "text_53": "{sparkleGrey20}",
        "text_54": "{feedbackError80}",
        "text_55": "{feedbackError50}",
        "text_56": "{feedbackError20}",
        "text_57": "{feedbackWarning80}",
        "text_58": "{feedbackWarning50}",
        "text_59": "{feedbackWarning20}",
        "text_60": "{feedbackSuccess80}",
        "text_61": "{feedbackSuccess50}",
        "text_62": "{feedbackSuccess20}",
        "text_63": "{global.white}",
        "text_64": "{global.black}",
        "text_65": "{global.transparent}",
        "text_66": "{headingXl}",
        "text_67": "{headingXl}",
        "text_68": "{headingXl}",
        "text_69": "{headingXl}",
        "text_70": "{headingXl}",
        "text_71": "{headingL}",
        "text_72": "{headingL}",
        "text_73": "{headingL}",
        "text_74": "{headingL}",
        "text_75": "{headingL}",
        "text_76": "{headingM}",
        "text_77": "{headingM}",
        "text_78": "{headingM}",
        "text_79": "{headingM}",
        "text_80": "{headingM}",
        "text_81": "{headingS}",
        "text_82": "{headingS}",
        "text_83": "{headingS}",
        "text_84": "{headingS}",
        "text_85": "{headingS}",
        "text_86": "{headingXs}",
        "text_87": "{headingXs}",
        "text_88": "{headingXs}",
        "text_89": "{headingXs}",
        "text_90": "{headingXs}",
        "text_91": "{headingXxs}",
        "text_92": "{headingXxs}",
        "text_93": "{headingXxs}",
        "text_94": "{headingXxs}",
        "text_95": "{headingXxs}",
        "text_96": "{overline}",
        "text_97": "{overline}",
        "text_98": "{overline}",
        "text_99": "{overline}",
        "text_100": "{overline}",
        "text_101": "{overline}",
        "text_102": "{bodyL}",
        "text_103": "{bodyL}",
        "text_104": "{bodyL}",
        "text_105": "{bodyL}",
        "text_106": "{bodyL}",
        "text_107": "{bodyLBold}",
        "text_108": "{bodyLBold}",
        "text_109": "{bodyLBold}",
        "text_110": "{bodyLBold}",
        "text_111": "{bodyLBold}",
        "text_112": "{bodyLLink}",
        "text_113": "{bodyLLink}",
        "text_114": "{bodyLLink}",
        "text_115": "{bodyLLink}",
        "text_116": "{bodyLLink}",
        "text_117": "{bodyM}",
        "text_118": "{bodyM}",
        "text_119": "{bodyM}",
        "text_120": "{bodyM}",
        "text_121": "{bodyM}",
        "text_122": "{bodyMBold}",
        "text_123": "{bodyMBold}",
        "text_124": "{bodyMBold}",
        "text_125": "{bodyMBold}",
        "text_126": "{bodyMBold}",
        "text_127": "{bodyMLink}",
        "text_128": "{bodyMLink}",
        "text_129": "{bodyMLink}",
        "text_130": "{bodyMLink}",
        "text_131": "{bodyMLink}",
        "text_132": "{bodyS}",
        "text_133": "{bodyS}",
        "text_134": "{bodyS}",
        "text_135": "{bodyS}",
        "text_136": "{bodyS}",
        "text_137": "{bodySBold}",
        "text_138": "{bodySBold}",
        "text_139": "{bodySBold}",
        "text_140": "{bodySBold}",
        "text_141": "{bodySBold}",
        "text_142": "{bodySLink}",
        "text_143": "{bodySLink}",
        "text_144": "{bodySLink}",
        "text_145": "{bodySLink}",
        "text_146": "{bodySLink}",
        "text_147": "{bodyXs}",
        "text_148": "{bodyXs}",
        "text_149": "{bodyXs}",
        "text_150": "{bodyXs}",
        "text_151": "{bodyXs}",
        "text_152": "{bodyXsBold}",
        "text_153": "{bodyXsBold}",
        "text_154": "{bodyXsBold}",
        "text_155": "{bodyXsBold}",
        "text_156": "{bodyXsBold}",
        "text_157": "{bodyXsLink}",
        "text_158": "{bodyXsLink}",
        "text_159": "{bodyXsLink}",
        "text_160": "{bodyXsLink}",
        "text_161": "{bodyXsLink}",
        "text_162": "{bodyXs}",
        "text_163": "{bodyXs}",
        "text_164": "{bodyS}",
        "text_165": "{bodyXs}",
        "text_166": "{bodyXs}",
        "text_167": "{bodyXxs}",
        "text_168": "{bodyXxs}",
        "text_169": "{bodyXxs}",
        "text_170": "{bodyXxs}",
        "text_171": "{bodyXxs}",
        "text_172": "{bodyXxsBold}",
        "text_173": "{bodyXxsBold}",
        "text_174": "{bodyXxsBold}",
        "text_175": "{bodyXxsBold}",
        "text_176": "{bodyXxsBold}",
        "text_177": "{bodyXxsLink}",
        "text_178": "{bodyXxsLink}",
        "text_179": "{bodyXxsLink}",
        "text_180": "{bodyXxsLink}",
        "text_181": "{bodyXxsLink}",
        "text_182": "{body3xs}",
        "text_183": "{body3xs}",
        "text_184": "{body3xs}",
        "text_185": "{body3xs}",
        "text_186": "{body3xs}",
        "text_187": "{body3xsBold}",
        "text_188": "{body3xsBold}",
        "text_189": "{body3xsBold}",
        "text_190": "{body3xsBold}",
        "text_191": "{body3xsBold}",
        "text_192": "{body3xsLink}",
        "text_193": "{body3xsLink}",
        "text_194": "{body3xsLink}",
        "text_195": "{body3xsLink}",
        "text_196": "{body3xsLink}",
        "text_197": "{listTitle}",
        "text_198": "{listTitle}",
        "text_199": "{listTitle}",
        "text_200": "{listTitle}",
        "text_201": "{listTitle}",
        "text_202": "{button}",
        "text_203": "{button}",
        "text_204": "{button}",
        "text_205": "{button}",
        "text_206": "{button}",
        "text_207": "{code}",
        "text_208": "{code}",
        "text_209": "{code}",
        "text_210": "{code}",
        "text_211": "{code}",
        "text_212": "{bodyS}",
        "text_213": "{bodyS}",
        "text_214": "{bodyS}",
        "text_215": "{bodyS}",
        "text_216": "{bodyS}"
    },
    "JDSTooltip": {
        "t_0": "{flexDirection.row}",
        "t_1": "{justifyContent.start}",
        "t_2": "{alignItems.start}",
        "t_3": "{flexDirection.row}",
        "t_4": "{justifyContent.start}",
        "t_5": "{alignItems.center}",
        "t_6": "hidden",
        "t_7": "{medium}",
        "t_8": "{border_thin}",
        "t_9": "{primaryGrey100}",
        "t_10": "{primaryGrey100}",
        "t_11": "{primaryGrey100}",
        "t_12": "{base}",
        "t_13": "{base}",
        "t_14": "{xs}",
        "t_15": "{xs}",
        "t_16": "{alignItems.start}",
        "t_17": "{xs}",
        "t_18": "{alignItems.end}",
        "t_19": "{xs}",
        "t_20": "{alignItems.start}",
        "t_21": "{xs}",
        "t_22": "{alignItems.end}",
        "t_23": "{xs}",
        "t_24": "{flexDirection.column}",
        "t_25": "{alignItems.center}",
        "t_26": "{flexDirection.column}",
        "t_27": "{alignItems.start}",
        "t_28": "{xs}",
        "t_29": "{flexDirection.column}",
        "t_30": "{alignItems.end}",
        "t_31": "{xs}",
        "t_32": "{flexDirection.column}",
        "t_33": "{alignItems.center}",
        "t_34": "{flexDirection.column}",
        "t_35": "{alignItems.start}",
        "t_36": "{xs}",
        "t_37": "{flexDirection.column}",
        "t_38": "{alignItems.end}",
        "t_39": "{xs}",
        "t_40": "{xl}",
        "t_41": "{alignItems.center}"
    },
    "JDSTooltipInternal": {
        "t_0": "{flexDirection.row}",
        "t_1": "{justifyContent.start}",
        "t_2": "{alignItems.start}",
        "t_3": "{flexDirection.row}",
        "t_4": "{justifyContent.start}",
        "t_5": "{alignItems.center}",
        "t_6": "hidden",
        "t_7": "{medium}",
        "t_8": "{border_thin}",
        "t_9": "{primaryGrey100}",
        "t_10": "{primaryGrey100}",
        "t_11": "{primaryGrey100}",
        "t_12": "{base}",
        "t_13": "{base}",
        "t_14": "{xs}",
        "t_15": "{xs}",
        "t_16": "{alignItems.start}",
        "t_17": "{xs}",
        "t_18": "{alignItems.end}",
        "t_19": "{xs}",
        "t_20": "{alignItems.start}",
        "t_21": "{xs}",
        "t_22": "{alignItems.end}",
        "t_23": "{xs}",
        "t_24": "{flexDirection.column}",
        "t_25": "{alignItems.center}",
        "t_26": "{flexDirection.column}",
        "t_27": "{alignItems.start}",
        "t_28": "{xs}",
        "t_29": "{flexDirection.column}",
        "t_30": "{alignItems.end}",
        "t_31": "{xs}",
        "t_32": "{flexDirection.column}",
        "t_33": "{alignItems.center}",
        "t_34": "{flexDirection.column}",
        "t_35": "{alignItems.start}",
        "t_36": "{xs}",
        "t_37": "{flexDirection.column}",
        "t_38": "{alignItems.end}",
        "t_39": "{xs}",
        "t_40": "{xl}",
        "t_41": "{alignItems.center}"
    },
    "JDSInputCode": {
        "i_0": "{flexDirection.column}",
        "i_1": "{justifyContent.start}",
        "i_2": "{alignItems.start}",
        "i_3": "{size.max}",
        "i_4": "{xs}",
        "i_5": "{flexDirection.row}",
        "i_6": "{justifyContent.center}",
        "i_7": "{alignItems.center}",
        "i_8": "{size.max}",
        "i_9": "{xs}",
        "i_10": "{opacity.disabled}",
        "i_11": "{opacity.enabled}"
    },
    "JDSRatingBar": {
        "r_0": "{flexDirection.column}",
        "r_1": "{alignItems.start}",
        "r_2": "{justifyContent.start}",
        "r_3": "{xxs}",
        "r_4": "{flexDirection.row}",
        "a_5": "{alignItems.center}",
        "r_6": "{justifyContent.start}",
        "r_7": "{xs}",
        "r_8": "{flexDirection.row}",
        "r_9": "{xxs}",
        "r_10": "{xs}",
        "r_11": "{alignItems.center}",
        "r_12": "{alignItems.center}",
        "r_13": "{opacity.disabled}",
        "r_14": "{xxs}",
        "r_15": "{xxs}",
        "r_16": "{xs}",
        "r_17": "{xs}",
        "r_18": "{xs}",
        "r_19": "{xs}",
        "r_20": "{xxs}",
        "r_21": "{xxs}",
        "r_22": "{xs}",
        "r_23": "{xs}",
        "r_24": "{xs}",
        "r_25": "{xs}",
        "r_26": "{alignItems.center}"
    },
    "JDSRatingBarItem": {
        "r_0": "{flexDirection.stack}",
        "r_1": "{border_focus}",
        "r_2": "{primary60}",
        "r_3": "{m}",
        "r_4": "{m}",
        "r_5": "{xl}",
        "r_6": "{xl}",
        "r_7": "{opacity.disabled}",
        "r_8": "{primaryGrey60}",
        "r_9": "{primaryGrey60}",
        "r_10": "{primaryGrey60}",
        "r_11": "{primaryGrey60}",
        "r_12": "{primaryGrey80}",
        "r_13": "{primaryGrey80}",
        "r_14": "{primaryGrey80}",
        "r_15": "{primaryGrey80}",
        "r_16": "{border_focus}",
        "r_17": "{border_focus}",
        "r_18": "{primary60}",
        "r_19": "{primary60}",
        "r_20": "{primaryGrey60}",
        "r_21": "{primaryGrey60}",
        "r_22": "{primary50}",
        "r_23": "{primary50}",
        "r_24": "{primary70}",
        "r_25": "{primary70}",
        "r_26": "{primary60}",
        "r_27": "{primary60}",
        "r_28": "{border_focus}",
        "r_29": "{border_focus}",
        "r_30": "{primary60}",
        "r_31": "{primary60}",
        "r_32": "{primary50}",
        "r_33": "{primary50}",
        "r_34": "{primary70}",
        "r_35": "{primary70}",
        "r_36": "{primary70}",
        "r_37": "{primary70}",
        "r_38": "{primaryGrey80}",
        "r_39": "{primaryGrey60}"
    }
};
function $e3613f6017c674c5$var$getComponentTokens(componentName) {
    return $e3613f6017c674c5$var$JSON_MAP$1[componentName];
}
const $e3613f6017c674c5$var$layout = {
    "flexDirection.row": "row",
    "flexDirection.column": "column",
    "flexDirection.stack": "stack",
    "alignItems.start": "flex-start",
    "alignItems.center": "center",
    "alignItems.end": "flex-end",
    "alignItems.spaceBetween": "space-between",
    "alignItems.spaceAround": "space-around",
    "alignItems.spaceEvenly": "space-evenly",
    "alignItems.stretch": "stretch",
    "justifyContent.start": "flex-start",
    "justifyContent.center": "center",
    "justifyContent.end": "flex-end",
    "justifyContent.spaceBetween": "space-between",
    "justifyContent.spaceAround": "space-around",
    "justifyContent.spaceEvenly": "space-evenly",
    "textAlign.start": "start",
    "textAlign.center": "center",
    "textAlign.end": "end",
    "textAlign.justify": "justify",
    "aspect_ratio.1.1": "1",
    "aspect_ratio.3.4": "0.75",
    "aspect_ratio.4.3": "1.33",
    "aspect_ratio.4.5": "0.8",
    "aspect_ratio.5.4": "1.25",
    "aspect_ratio.9.16": "0.56",
    "aspect_ratio.16.9": "1.77",
    "aspect_ratio.2_75.1": "2.75",
    "size.max": "max",
    "size.min": "min",
    "size.negativeMax": "negativeMax",
    "intrinsicSize.min": "intrinsicSize.min",
    "intrinsicSize.max": "intrinsicSize.max",
    "zIndex-1": 1,
    "size.fit": "fit-content"
};
const $e3613f6017c674c5$var$headingXl$1 = "{$lang.$platform.headingXl}";
const $e3613f6017c674c5$var$headingL$1 = "{$lang.$platform.headingL}";
const $e3613f6017c674c5$var$headingM$1 = "{$lang.$platform.headingM}";
const $e3613f6017c674c5$var$headingS$1 = "{$lang.$platform.headingS}";
const $e3613f6017c674c5$var$headingXs$1 = "{$lang.$platform.headingXs}";
const $e3613f6017c674c5$var$headingXxs$1 = "{$lang.$platform.headingXxs}";
const $e3613f6017c674c5$var$overline$2 = "{$lang.$platform.overline}";
const $e3613f6017c674c5$var$bodyL$1 = "{$lang.$platform.bodyL}";
const $e3613f6017c674c5$var$bodyLBold$1 = "{$lang.$platform.bodyLBold}";
const $e3613f6017c674c5$var$bodyLLink$1 = "{$lang.$platform.bodyLLink}";
const $e3613f6017c674c5$var$bodyM$1 = "{$lang.$platform.bodyM}";
const $e3613f6017c674c5$var$bodyMBold$1 = "{$lang.$platform.bodyMBold}";
const $e3613f6017c674c5$var$bodyMLink$1 = "{$lang.$platform.bodyMLink}";
const $e3613f6017c674c5$var$bodyS$1 = "{$lang.$platform.bodyS}";
const $e3613f6017c674c5$var$bodySBold$1 = "{$lang.$platform.bodySBold}";
const $e3613f6017c674c5$var$bodySLink$1 = "{$lang.$platform.bodySLink}";
const $e3613f6017c674c5$var$bodyXs$1 = "{$lang.$platform.bodyXs}";
const $e3613f6017c674c5$var$bodyXsBold$1 = "{$lang.$platform.bodyXsBold}";
const $e3613f6017c674c5$var$bodyXsLink$1 = "{$lang.$platform.bodyXsLink}";
const $e3613f6017c674c5$var$bodyXxs$1 = "{$lang.$platform.bodyXxs}";
const $e3613f6017c674c5$var$bodyXxsBold$1 = "{$lang.$platform.bodyXxsBold}";
const $e3613f6017c674c5$var$bodyXxsLink$1 = "{$lang.$platform.bodyXxsLink}";
const $e3613f6017c674c5$var$body3xs$1 = "{$lang.$platform.body3xs}";
const $e3613f6017c674c5$var$body3xsBold$1 = "{$lang.$platform.body3xsBold}";
const $e3613f6017c674c5$var$body3xsLink$1 = "{$lang.$platform.body3xsLink}";
const $e3613f6017c674c5$var$listTitle$1 = "{$lang.$platform.listTitle}";
const $e3613f6017c674c5$var$button$1 = "{$lang.$platform.button}";
const $e3613f6017c674c5$var$code$1 = "{$lang.$platform.code}";
const $e3613f6017c674c5$var$letterSpacing = {
    "letter-spacing.0": "0",
    "as.desktop.headingXl": -2.6399999999999997,
    "as.desktop.headingL": -1.92,
    "as.desktop.headingM": -1.2,
    "as.desktop.headingS": -0.96,
    "as.desktop.headingXs": -0.72,
    "as.desktop.headingXxs": -0.48,
    "as.desktop.overline": -0.06,
    "as.desktop.bodyL": -0.12,
    "as.desktop.bodyLBold": -0.12,
    "as.desktop.bodyLLink": -0.12,
    "as.desktop.bodyM": -0.09,
    "as.desktop.bodyMBold": -0.09,
    "as.desktop.bodyMLink": -0.09,
    "as.desktop.bodyS": -0.08,
    "as.desktop.bodySBold": -0.08,
    "as.desktop.bodySLink": -0.08,
    "as.desktop.bodyXs": -0.07,
    "as.desktop.bodyXsBold": -0.07,
    "as.desktop.bodyXsLink": -0.07,
    "as.desktop.bodyXxs": -0.06,
    "as.desktop.bodyXxsBold": -0.06,
    "as.desktop.bodyXxsLink": -0.06,
    "as.desktop.body3xs": -0.055,
    "as.desktop.body3xsBold": -0.055,
    "as.desktop.body3xsLink": -0.055,
    "as.desktop.listTitle": -0.08,
    "as.desktop.button": -0.08,
    "as.desktop.code": 0,
    "as.mobile.headingXl": -1.92,
    "as.mobile.headingL": -1.44,
    "as.mobile.headingM": -1.2,
    "as.mobile.headingS": -0.96,
    "as.mobile.headingXs": -0.72,
    "as.mobile.headingXxs": -0.48,
    "as.mobile.overline": -0.06,
    "as.mobile.bodyL": -0.12,
    "as.mobile.bodyLBold": -0.12,
    "as.mobile.bodyLLink": -0.12,
    "as.mobile.bodyM": -0.09,
    "as.mobile.bodyMBold": -0.09,
    "as.mobile.bodyMLink": -0.09,
    "as.mobile.bodyS": 0.08,
    "as.mobile.bodySBold": -0.08,
    "as.mobile.bodySLink": -0.08,
    "as.mobile.bodyXs": -0.07,
    "as.mobile.bodyXsBold": -0.07,
    "as.mobile.bodyXsLink": -0.07,
    "as.mobile.bodyXxs": -0.06,
    "as.mobile.bodyXxsBold": -0.06,
    "as.mobile.bodyXxsLink": -0.06,
    "as.mobile.body3xs": -0.055,
    "as.mobile.body3xsBold": -0.055,
    "as.mobile.body3xsLink": -0.055,
    "as.mobile.listTitle": -0.08,
    "as.mobile.button": -0.08,
    "as.mobile.code": 0,
    "bn.desktop.headingXl": -2.6399999999999997,
    "bn.desktop.headingL": -1.92,
    "bn.desktop.headingM": -1.2,
    "bn.desktop.headingS": -0.96,
    "bn.desktop.headingXs": -0.72,
    "bn.desktop.headingXxs": -0.48,
    "bn.desktop.overline": -0.06,
    "bn.desktop.bodyL": -0.12,
    "bn.desktop.bodyLBold": -0.12,
    "bn.desktop.bodyLLink": -0.12,
    "bn.desktop.bodyM": -0.09,
    "bn.desktop.bodyMBold": -0.09,
    "bn.desktop.bodyMLink": -0.09,
    "bn.desktop.bodyS": -0.08,
    "bn.desktop.bodySBold": -0.08,
    "bn.desktop.bodySLink": -0.08,
    "bn.desktop.bodyXs": -0.07,
    "bn.desktop.bodyXsBold": -0.07,
    "bn.desktop.bodyXsLink": -0.07,
    "bn.desktop.bodyXxs": -0.06,
    "bn.desktop.bodyXxsBold": -0.06,
    "bn.desktop.bodyXxsLink": -0.06,
    "bn.desktop.body3xs": -0.055,
    "bn.desktop.body3xsBold": -0.055,
    "bn.desktop.body3xsLink": -0.055,
    "bn.desktop.listTitle": -0.08,
    "bn.desktop.button": -0.08,
    "bn.desktop.code": 0,
    "bn.mobile.headingXl": -1.92,
    "bn.mobile.headingL": -1.44,
    "bn.mobile.headingM": -1.2,
    "bn.mobile.headingS": -0.96,
    "bn.mobile.headingXs": -0.72,
    "bn.mobile.headingXxs": -0.48,
    "bn.mobile.overline": -0.06,
    "bn.mobile.bodyL": -0.12,
    "bn.mobile.bodyLBold": -0.12,
    "bn.mobile.bodyLLink": -0.12,
    "bn.mobile.bodyM": -0.09,
    "bn.mobile.bodyMBold": -0.09,
    "bn.mobile.bodyMLink": -0.09,
    "bn.mobile.bodyS": 0.08,
    "bn.mobile.bodySBold": -0.08,
    "bn.mobile.bodySLink": -0.08,
    "bn.mobile.bodyXs": -0.07,
    "bn.mobile.bodyXsBold": -0.07,
    "bn.mobile.bodyXsLink": -0.07,
    "bn.mobile.bodyXxs": -0.06,
    "bn.mobile.bodyXxsBold": -0.06,
    "bn.mobile.bodyXxsLink": -0.06,
    "bn.mobile.body3xs": -0.055,
    "bn.mobile.body3xsBold": -0.055,
    "bn.mobile.body3xsLink": -0.055,
    "bn.mobile.listTitle": -0.08,
    "bn.mobile.button": -0.08,
    "bn.mobile.code": 0,
    "en.desktop.headingXl": -2.6399999999999997,
    "en.desktop.headingL": -1.92,
    "en.desktop.headingM": -1.2,
    "en.desktop.headingS": -0.96,
    "en.desktop.headingXs": -0.72,
    "en.desktop.headingXxs": -0.48,
    "en.desktop.overline": 0.06,
    "en.desktop.bodyL": -0.12,
    "en.desktop.bodyLBold": -0.12,
    "en.desktop.bodyLLink": -0.12,
    "en.desktop.bodyM": -0.09,
    "en.desktop.bodyMBold": -0.09,
    "en.desktop.bodyMLink": -0.09,
    "en.desktop.bodyS": -0.08,
    "en.desktop.bodySBold": -0.08,
    "en.desktop.bodySLink": -0.08,
    "en.desktop.bodyXs": -0.07,
    "en.desktop.bodyXsBold": -0.07,
    "en.desktop.bodyXsLink": -0.07,
    "en.desktop.bodyXxs": -0.06,
    "en.desktop.bodyXxsBold": -0.06,
    "en.desktop.bodyXxsLink": -0.06,
    "en.desktop.body3xs": -0.055,
    "en.desktop.body3xsBold": -0.055,
    "en.desktop.body3xsLink": -0.055,
    "en.desktop.listTitle": -0.08,
    "en.desktop.button": -0.08,
    "en.desktop.code": 0,
    "en.mobile.headingXl": -1.92,
    "en.mobile.headingL": -1.44,
    "en.mobile.headingM": -1.2,
    "en.mobile.headingS": -0.96,
    "en.mobile.headingXs": -0.72,
    "en.mobile.headingXxs": -0.48,
    "en.mobile.overline": 0.06,
    "en.mobile.bodyL": -0.12,
    "en.mobile.bodyLBold": -0.12,
    "en.mobile.bodyLLink": -0.12,
    "en.mobile.bodyM": -0.09,
    "en.mobile.bodyMBold": -0.09,
    "en.mobile.bodyMLink": -0.09,
    "en.mobile.bodyS": -0.08,
    "en.mobile.bodySBold": -0.08,
    "en.mobile.bodySLink": -0.08,
    "en.mobile.bodyXs": -0.07,
    "en.mobile.bodyXsBold": -0.07,
    "en.mobile.bodyXsLink": -0.07,
    "en.mobile.bodyXxs": -0.06,
    "en.mobile.bodyXxsBold": -0.06,
    "en.mobile.bodyXxsLink": -0.06,
    "en.mobile.body3xs": -0.055,
    "en.mobile.body3xsBold": -0.055,
    "en.mobile.body3xsLink": -0.055,
    "en.mobile.listTitle": -0.08,
    "en.mobile.button": -0.08,
    "en.mobile.code": 0,
    "gu.desktop.headingXl": -2.6399999999999997,
    "gu.desktop.headingL": -1.92,
    "gu.desktop.headingM": -1.2,
    "gu.desktop.headingS": -0.96,
    "gu.desktop.headingXs": -0.72,
    "gu.desktop.headingXxs": -0.48,
    "gu.desktop.overline": -0.06,
    "gu.desktop.bodyL": -0.12,
    "gu.desktop.bodyLBold": -0.12,
    "gu.desktop.bodyLLink": -0.12,
    "gu.desktop.bodyM": -0.09,
    "gu.desktop.bodyMBold": -0.09,
    "gu.desktop.bodyMLink": -0.09,
    "gu.desktop.bodyS": -0.08,
    "gu.desktop.bodySBold": -0.08,
    "gu.desktop.bodySLink": -0.08,
    "gu.desktop.bodyXs": -0.07,
    "gu.desktop.bodyXsBold": -0.07,
    "gu.desktop.bodyXsLink": -0.07,
    "gu.desktop.bodyXxs": -0.06,
    "gu.desktop.bodyXxsBold": -0.06,
    "gu.desktop.bodyXxsLink": -0.06,
    "gu.desktop.body3xs": -0.055,
    "gu.desktop.body3xsBold": -0.055,
    "gu.desktop.body3xsLink": -0.055,
    "gu.desktop.listTitle": -0.08,
    "gu.desktop.button": -0.08,
    "gu.desktop.code": 0,
    "gu.mobile.headingXl": -1.92,
    "gu.mobile.headingL": -1.44,
    "gu.mobile.headingM": -1.2,
    "gu.mobile.headingS": -0.96,
    "gu.mobile.headingXs": -0.72,
    "gu.mobile.headingXxs": -0.48,
    "gu.mobile.overline": -0.06,
    "gu.mobile.bodyL": -0.12,
    "gu.mobile.bodyLBold": -0.12,
    "gu.mobile.bodyLLink": -0.12,
    "gu.mobile.bodyM": -0.09,
    "gu.mobile.bodyMBold": -0.09,
    "gu.mobile.bodyMLink": -0.09,
    "gu.mobile.bodyS": 0.08,
    "gu.mobile.bodySBold": -0.08,
    "gu.mobile.bodySLink": -0.08,
    "gu.mobile.bodyXs": -0.07,
    "gu.mobile.bodyXsBold": -0.07,
    "gu.mobile.bodyXsLink": -0.07,
    "gu.mobile.bodyXxs": -0.06,
    "gu.mobile.bodyXxsBold": -0.06,
    "gu.mobile.bodyXxsLink": -0.06,
    "gu.mobile.body3xs": -0.055,
    "gu.mobile.body3xsBold": -0.055,
    "gu.mobile.body3xsLink": -0.055,
    "gu.mobile.listTitle": -0.08,
    "gu.mobile.button": -0.08,
    "gu.mobile.code": 0,
    "hi.desktop.headingXl": -2.6399999999999997,
    "hi.desktop.headingL": -1.92,
    "hi.desktop.headingM": -1.2,
    "hi.desktop.headingS": -0.96,
    "hi.desktop.headingXs": -0.72,
    "hi.desktop.headingXxs": -0.48,
    "hi.desktop.overline": -0.06,
    "hi.desktop.bodyL": -0.12,
    "hi.desktop.bodyLBold": -0.12,
    "hi.desktop.bodyLLink": -0.12,
    "hi.desktop.bodyM": -0.09,
    "hi.desktop.bodyMBold": -0.09,
    "hi.desktop.bodyMLink": -0.09,
    "hi.desktop.bodyS": -0.08,
    "hi.desktop.bodySBold": -0.08,
    "hi.desktop.bodySLink": -0.08,
    "hi.desktop.bodyXs": -0.07,
    "hi.desktop.bodyXsBold": -0.07,
    "hi.desktop.bodyXsLink": -0.07,
    "hi.desktop.bodyXxs": -0.06,
    "hi.desktop.bodyXxsBold": -0.06,
    "hi.desktop.bodyXxsLink": -0.06,
    "hi.desktop.body3xs": -0.055,
    "hi.desktop.body3xsBold": -0.055,
    "hi.desktop.body3xsLink": -0.055,
    "hi.desktop.listTitle": -0.08,
    "hi.desktop.button": -0.08,
    "hi.desktop.code": 0,
    "hi.mobile.headingXl": -1.92,
    "hi.mobile.headingL": -1.44,
    "hi.mobile.headingM": -1.2,
    "hi.mobile.headingS": -0.96,
    "hi.mobile.headingXs": -0.72,
    "hi.mobile.headingXxs": -0.48,
    "hi.mobile.overline": -0.06,
    "hi.mobile.bodyL": -0.12,
    "hi.mobile.bodyLBold": -0.12,
    "hi.mobile.bodyLLink": -0.12,
    "hi.mobile.bodyM": -0.09,
    "hi.mobile.bodyMBold": -0.09,
    "hi.mobile.bodyMLink": -0.09,
    "hi.mobile.bodyS": 0.08,
    "hi.mobile.bodySBold": -0.08,
    "hi.mobile.bodySLink": -0.08,
    "hi.mobile.bodyXs": -0.07,
    "hi.mobile.bodyXsBold": -0.07,
    "hi.mobile.bodyXsLink": -0.07,
    "hi.mobile.bodyXxs": -0.06,
    "hi.mobile.bodyXxsBold": -0.06,
    "hi.mobile.bodyXxsLink": -0.06,
    "hi.mobile.body3xs": -0.055,
    "hi.mobile.body3xsBold": -0.055,
    "hi.mobile.body3xsLink": -0.055,
    "hi.mobile.listTitle": -0.08,
    "hi.mobile.button": -0.08,
    "hi.mobile.code": 0,
    "kn.desktop.headingXl": -2.6399999999999997,
    "kn.desktop.headingL": -1.92,
    "kn.desktop.headingM": -1.2,
    "kn.desktop.headingS": -0.96,
    "kn.desktop.headingXs": -0.72,
    "kn.desktop.headingXxs": -0.48,
    "kn.desktop.overline": -0.06,
    "kn.desktop.bodyL": -0.12,
    "kn.desktop.bodyLBold": -0.12,
    "kn.desktop.bodyLLink": -0.12,
    "kn.desktop.bodyM": -0.09,
    "kn.desktop.bodyMBold": -0.09,
    "kn.desktop.bodyMLink": -0.09,
    "kn.desktop.bodyS": -0.08,
    "kn.desktop.bodySBold": -0.08,
    "kn.desktop.bodySLink": -0.08,
    "kn.desktop.bodyXs": -0.07,
    "kn.desktop.bodyXsBold": -0.07,
    "kn.desktop.bodyXsLink": -0.07,
    "kn.desktop.bodyXxs": -0.06,
    "kn.desktop.bodyXxsBold": -0.06,
    "kn.desktop.bodyXxsLink": -0.06,
    "kn.desktop.body3xs": -0.055,
    "kn.desktop.body3xsBold": -0.055,
    "kn.desktop.body3xsLink": -0.055,
    "kn.desktop.listTitle": -0.08,
    "kn.desktop.button": -0.08,
    "kn.desktop.code": 0,
    "kn.mobile.headingXl": -1.92,
    "kn.mobile.headingL": -1.44,
    "kn.mobile.headingM": -1.2,
    "kn.mobile.headingS": -0.96,
    "kn.mobile.headingXs": -0.72,
    "kn.mobile.headingXxs": -0.48,
    "kn.mobile.overline": -0.06,
    "kn.mobile.bodyL": -0.12,
    "kn.mobile.bodyLBold": -0.12,
    "kn.mobile.bodyLLink": -0.12,
    "kn.mobile.bodyM": -0.09,
    "kn.mobile.bodyMBold": -0.09,
    "kn.mobile.bodyMLink": -0.09,
    "kn.mobile.bodyS": 0.08,
    "kn.mobile.bodySBold": -0.08,
    "kn.mobile.bodySLink": -0.08,
    "kn.mobile.bodyXs": -0.07,
    "kn.mobile.bodyXsBold": -0.07,
    "kn.mobile.bodyXsLink": -0.07,
    "kn.mobile.bodyXxs": -0.06,
    "kn.mobile.bodyXxsBold": -0.06,
    "kn.mobile.bodyXxsLink": -0.06,
    "kn.mobile.body3xs": -0.055,
    "kn.mobile.body3xsBold": -0.055,
    "kn.mobile.body3xsLink": -0.055,
    "kn.mobile.listTitle": -0.08,
    "kn.mobile.button": -0.08,
    "kn.mobile.code": 0,
    "ml.desktop.headingXl": -2.6399999999999997,
    "ml.desktop.headingL": -1.92,
    "ml.desktop.headingM": -1.2,
    "ml.desktop.headingS": -0.96,
    "ml.desktop.headingXs": -0.72,
    "ml.desktop.headingXxs": -0.48,
    "ml.desktop.overline": -0.06,
    "ml.desktop.bodyL": -0.12,
    "ml.desktop.bodyLBold": -0.12,
    "ml.desktop.bodyLLink": -0.12,
    "ml.desktop.bodyM": -0.09,
    "ml.desktop.bodyMBold": -0.09,
    "ml.desktop.bodyMLink": -0.09,
    "ml.desktop.bodyS": -0.08,
    "ml.desktop.bodySBold": -0.08,
    "ml.desktop.bodySLink": -0.08,
    "ml.desktop.bodyXs": -0.07,
    "ml.desktop.bodyXsBold": -0.07,
    "ml.desktop.bodyXsLink": -0.07,
    "ml.desktop.bodyXxs": -0.06,
    "ml.desktop.bodyXxsBold": -0.06,
    "ml.desktop.bodyXxsLink": -0.06,
    "ml.desktop.body3xs": -0.055,
    "ml.desktop.body3xsBold": -0.055,
    "ml.desktop.body3xsLink": -0.055,
    "ml.desktop.listTitle": -0.08,
    "ml.desktop.button": -0.08,
    "ml.desktop.code": 0,
    "ml.mobile.headingXl": -1.92,
    "ml.mobile.headingL": -1.44,
    "ml.mobile.headingM": -1.2,
    "ml.mobile.headingS": -0.96,
    "ml.mobile.headingXs": -0.72,
    "ml.mobile.headingXxs": -0.48,
    "ml.mobile.overline": -0.06,
    "ml.mobile.bodyL": -0.12,
    "ml.mobile.bodyLBold": -0.12,
    "ml.mobile.bodyLLink": -0.12,
    "ml.mobile.bodyM": -0.09,
    "ml.mobile.bodyMBold": -0.09,
    "ml.mobile.bodyMLink": -0.09,
    "ml.mobile.bodyS": 0.08,
    "ml.mobile.bodySBold": -0.08,
    "ml.mobile.bodySLink": -0.08,
    "ml.mobile.bodyXs": -0.07,
    "ml.mobile.bodyXsBold": -0.07,
    "ml.mobile.bodyXsLink": -0.07,
    "ml.mobile.bodyXxs": -0.06,
    "ml.mobile.bodyXxsBold": -0.06,
    "ml.mobile.bodyXxsLink": -0.06,
    "ml.mobile.body3xs": -0.055,
    "ml.mobile.body3xsBold": -0.055,
    "ml.mobile.body3xsLink": -0.055,
    "ml.mobile.listTitle": -0.08,
    "ml.mobile.button": -0.08,
    "ml.mobile.code": 0,
    "mr.desktop.headingXl": -2.6399999999999997,
    "mr.desktop.headingL": -1.92,
    "mr.desktop.headingM": -1.2,
    "mr.desktop.headingS": -0.96,
    "mr.desktop.headingXs": -0.72,
    "mr.desktop.headingXxs": -0.48,
    "mr.desktop.overline": -0.06,
    "mr.desktop.bodyL": -0.12,
    "mr.desktop.bodyLBold": -0.12,
    "mr.desktop.bodyLLink": -0.12,
    "mr.desktop.bodyM": -0.09,
    "mr.desktop.bodyMBold": -0.09,
    "mr.desktop.bodyMLink": -0.09,
    "mr.desktop.bodyS": -0.08,
    "mr.desktop.bodySBold": -0.08,
    "mr.desktop.bodySLink": -0.08,
    "mr.desktop.bodyXs": -0.07,
    "mr.desktop.bodyXsBold": -0.07,
    "mr.desktop.bodyXsLink": -0.07,
    "mr.desktop.bodyXxs": -0.06,
    "mr.desktop.bodyXxsBold": -0.06,
    "mr.desktop.bodyXxsLink": -0.06,
    "mr.desktop.body3xs": -0.055,
    "mr.desktop.body3xsBold": -0.055,
    "mr.desktop.body3xsLink": -0.055,
    "mr.desktop.listTitle": -0.08,
    "mr.desktop.button": -0.08,
    "mr.desktop.code": 0,
    "mr.mobile.headingXl": -1.92,
    "mr.mobile.headingL": -1.44,
    "mr.mobile.headingM": -1.2,
    "mr.mobile.headingS": -0.96,
    "mr.mobile.headingXs": -0.72,
    "mr.mobile.headingXxs": -0.48,
    "mr.mobile.overline": -0.06,
    "mr.mobile.bodyL": -0.12,
    "mr.mobile.bodyLBold": -0.12,
    "mr.mobile.bodyLLink": -0.12,
    "mr.mobile.bodyM": -0.09,
    "mr.mobile.bodyMBold": -0.09,
    "mr.mobile.bodyMLink": -0.09,
    "mr.mobile.bodyS": 0.08,
    "mr.mobile.bodySBold": -0.08,
    "mr.mobile.bodySLink": -0.08,
    "mr.mobile.bodyXs": -0.07,
    "mr.mobile.bodyXsBold": -0.07,
    "mr.mobile.bodyXsLink": -0.07,
    "mr.mobile.bodyXxs": -0.06,
    "mr.mobile.bodyXxsBold": -0.06,
    "mr.mobile.bodyXxsLink": -0.06,
    "mr.mobile.body3xs": -0.055,
    "mr.mobile.body3xsBold": -0.055,
    "mr.mobile.body3xsLink": -0.055,
    "mr.mobile.listTitle": -0.08,
    "mr.mobile.button": -0.08,
    "mr.mobile.code": 0,
    "or.desktop.headingXl": -2.6399999999999997,
    "or.desktop.headingL": -1.92,
    "or.desktop.headingM": -1.2,
    "or.desktop.headingS": -0.96,
    "or.desktop.headingXs": -0.72,
    "or.desktop.headingXxs": -0.48,
    "or.desktop.overline": -0.06,
    "or.desktop.bodyL": -0.12,
    "or.desktop.bodyLBold": -0.12,
    "or.desktop.bodyLLink": -0.12,
    "or.desktop.bodyM": -0.09,
    "or.desktop.bodyMBold": -0.09,
    "or.desktop.bodyMLink": -0.09,
    "or.desktop.bodyS": -0.08,
    "or.desktop.bodySBold": -0.08,
    "or.desktop.bodySLink": -0.08,
    "or.desktop.bodyXs": -0.07,
    "or.desktop.bodyXsBold": -0.07,
    "or.desktop.bodyXsLink": -0.07,
    "or.desktop.bodyXxs": -0.06,
    "or.desktop.bodyXxsBold": -0.06,
    "or.desktop.bodyXxsLink": -0.06,
    "or.desktop.body3xs": -0.055,
    "or.desktop.body3xsBold": -0.055,
    "or.desktop.body3xsLink": -0.055,
    "or.desktop.listTitle": -0.08,
    "or.desktop.button": -0.08,
    "or.desktop.code": 0,
    "or.mobile.headingXl": -1.92,
    "or.mobile.headingL": -1.44,
    "or.mobile.headingM": -1.2,
    "or.mobile.headingS": -0.96,
    "or.mobile.headingXs": -0.72,
    "or.mobile.headingXxs": -0.48,
    "or.mobile.overline": -0.06,
    "or.mobile.bodyL": -0.12,
    "or.mobile.bodyLBold": -0.12,
    "or.mobile.bodyLLink": -0.12,
    "or.mobile.bodyM": -0.09,
    "or.mobile.bodyMBold": -0.09,
    "or.mobile.bodyMLink": -0.09,
    "or.mobile.bodyS": 0.08,
    "or.mobile.bodySBold": -0.08,
    "or.mobile.bodySLink": -0.08,
    "or.mobile.bodyXs": -0.07,
    "or.mobile.bodyXsBold": -0.07,
    "or.mobile.bodyXsLink": -0.07,
    "or.mobile.bodyXxs": -0.06,
    "or.mobile.bodyXxsBold": -0.06,
    "or.mobile.bodyXxsLink": -0.06,
    "or.mobile.body3xs": -0.055,
    "or.mobile.body3xsBold": -0.055,
    "or.mobile.body3xsLink": -0.055,
    "or.mobile.listTitle": -0.08,
    "or.mobile.button": -0.08,
    "or.mobile.code": 0,
    "pa.desktop.headingXl": -2.6399999999999997,
    "pa.desktop.headingL": -1.92,
    "pa.desktop.headingM": -1.2,
    "pa.desktop.headingS": -0.96,
    "pa.desktop.headingXs": -0.72,
    "pa.desktop.headingXxs": -0.48,
    "pa.desktop.overline": -0.06,
    "pa.desktop.bodyL": -0.12,
    "pa.desktop.bodyLBold": -0.12,
    "pa.desktop.bodyLLink": -0.12,
    "pa.desktop.bodyM": -0.09,
    "pa.desktop.bodyMBold": -0.09,
    "pa.desktop.bodyMLink": -0.09,
    "pa.desktop.bodyS": -0.08,
    "pa.desktop.bodySBold": -0.08,
    "pa.desktop.bodySLink": -0.08,
    "pa.desktop.bodyXs": -0.07,
    "pa.desktop.bodyXsBold": -0.07,
    "pa.desktop.bodyXsLink": -0.07,
    "pa.desktop.bodyXxs": -0.06,
    "pa.desktop.bodyXxsBold": -0.06,
    "pa.desktop.bodyXxsLink": -0.06,
    "pa.desktop.body3xs": -0.055,
    "pa.desktop.body3xsBold": -0.055,
    "pa.desktop.body3xsLink": -0.055,
    "pa.desktop.listTitle": -0.08,
    "pa.desktop.button": -0.08,
    "pa.desktop.code": 0,
    "pa.mobile.headingXl": -1.92,
    "pa.mobile.headingL": -1.44,
    "pa.mobile.headingM": -1.2,
    "pa.mobile.headingS": -0.96,
    "pa.mobile.headingXs": -0.72,
    "pa.mobile.headingXxs": -0.48,
    "pa.mobile.overline": -0.06,
    "pa.mobile.bodyL": -0.12,
    "pa.mobile.bodyLBold": -0.12,
    "pa.mobile.bodyLLink": -0.12,
    "pa.mobile.bodyM": -0.09,
    "pa.mobile.bodyMBold": -0.09,
    "pa.mobile.bodyMLink": -0.09,
    "pa.mobile.bodyS": 0.08,
    "pa.mobile.bodySBold": -0.08,
    "pa.mobile.bodySLink": -0.08,
    "pa.mobile.bodyXs": -0.07,
    "pa.mobile.bodyXsBold": -0.07,
    "pa.mobile.bodyXsLink": -0.07,
    "pa.mobile.bodyXxs": -0.06,
    "pa.mobile.bodyXxsBold": -0.06,
    "pa.mobile.bodyXxsLink": -0.06,
    "pa.mobile.body3xs": -0.055,
    "pa.mobile.body3xsBold": -0.055,
    "pa.mobile.body3xsLink": -0.055,
    "pa.mobile.listTitle": -0.08,
    "pa.mobile.button": -0.08,
    "pa.mobile.code": 0,
    "ta.desktop.headingXl": -2.6399999999999997,
    "ta.desktop.headingL": -1.92,
    "ta.desktop.headingM": -1.2,
    "ta.desktop.headingS": -0.96,
    "ta.desktop.headingXs": -0.72,
    "ta.desktop.headingXxs": -0.48,
    "ta.desktop.overline": -0.06,
    "ta.desktop.bodyL": -0.12,
    "ta.desktop.bodyLBold": -0.12,
    "ta.desktop.bodyLLink": -0.12,
    "ta.desktop.bodyM": -0.09,
    "ta.desktop.bodyMBold": -0.09,
    "ta.desktop.bodyMLink": -0.09,
    "ta.desktop.bodyS": -0.08,
    "ta.desktop.bodySBold": -0.08,
    "ta.desktop.bodySLink": -0.08,
    "ta.desktop.bodyXs": -0.07,
    "ta.desktop.bodyXsBold": -0.07,
    "ta.desktop.bodyXsLink": -0.07,
    "ta.desktop.bodyXxs": -0.06,
    "ta.desktop.bodyXxsBold": -0.06,
    "ta.desktop.bodyXxsLink": -0.06,
    "ta.desktop.body3xs": -0.055,
    "ta.desktop.body3xsBold": -0.055,
    "ta.desktop.body3xsLink": -0.055,
    "ta.desktop.listTitle": -0.08,
    "ta.desktop.button": -0.08,
    "ta.desktop.code": 0,
    "ta.mobile.headingXl": -1.92,
    "ta.mobile.headingL": -1.44,
    "ta.mobile.headingM": -1.2,
    "ta.mobile.headingS": -0.96,
    "ta.mobile.headingXs": -0.72,
    "ta.mobile.headingXxs": -0.48,
    "ta.mobile.overline": -0.06,
    "ta.mobile.bodyL": -0.12,
    "ta.mobile.bodyLBold": -0.12,
    "ta.mobile.bodyLLink": -0.12,
    "ta.mobile.bodyM": -0.09,
    "ta.mobile.bodyMBold": -0.09,
    "ta.mobile.bodyMLink": -0.09,
    "ta.mobile.bodyS": 0.08,
    "ta.mobile.bodySBold": -0.08,
    "ta.mobile.bodySLink": -0.08,
    "ta.mobile.bodyXs": -0.07,
    "ta.mobile.bodyXsBold": -0.07,
    "ta.mobile.bodyXsLink": -0.07,
    "ta.mobile.bodyXxs": -0.06,
    "ta.mobile.bodyXxsBold": -0.06,
    "ta.mobile.bodyXxsLink": -0.06,
    "ta.mobile.body3xs": -0.055,
    "ta.mobile.body3xsBold": -0.055,
    "ta.mobile.body3xsLink": -0.055,
    "ta.mobile.listTitle": -0.08,
    "ta.mobile.button": -0.08,
    "ta.mobile.code": 0,
    "te.desktop.headingXl": -2.6399999999999997,
    "te.desktop.headingL": -1.92,
    "te.desktop.headingM": -1.2,
    "te.desktop.headingS": -0.96,
    "te.desktop.headingXs": -0.72,
    "te.desktop.headingXxs": -0.48,
    "te.desktop.overline": -0.06,
    "te.desktop.bodyL": -0.12,
    "te.desktop.bodyLBold": -0.12,
    "te.desktop.bodyLLink": -0.12,
    "te.desktop.bodyM": -0.09,
    "te.desktop.bodyMBold": -0.09,
    "te.desktop.bodyMLink": -0.09,
    "te.desktop.bodyS": -0.08,
    "te.desktop.bodySBold": -0.08,
    "te.desktop.bodySLink": -0.08,
    "te.desktop.bodyXs": -0.07,
    "te.desktop.bodyXsBold": -0.07,
    "te.desktop.bodyXsLink": -0.07,
    "te.desktop.bodyXxs": -0.06,
    "te.desktop.bodyXxsBold": -0.06,
    "te.desktop.bodyXxsLink": -0.06,
    "te.desktop.body3xs": -0.055,
    "te.desktop.body3xsBold": -0.055,
    "te.desktop.body3xsLink": -0.055,
    "te.desktop.listTitle": -0.08,
    "te.desktop.button": -0.08,
    "te.desktop.code": 0,
    "te.mobile.headingXl": -1.92,
    "te.mobile.headingL": -1.44,
    "te.mobile.headingM": -1.2,
    "te.mobile.headingS": -0.96,
    "te.mobile.headingXs": -0.72,
    "te.mobile.headingXxs": -0.48,
    "te.mobile.overline": -0.06,
    "te.mobile.bodyL": -0.12,
    "te.mobile.bodyLBold": -0.12,
    "te.mobile.bodyLLink": -0.12,
    "te.mobile.bodyM": -0.09,
    "te.mobile.bodyMBold": -0.09,
    "te.mobile.bodyMLink": -0.09,
    "te.mobile.bodyS": 0.08,
    "te.mobile.bodySBold": -0.08,
    "te.mobile.bodySLink": -0.08,
    "te.mobile.bodyXs": -0.07,
    "te.mobile.bodyXsBold": -0.07,
    "te.mobile.bodyXsLink": -0.07,
    "te.mobile.bodyXxs": -0.06,
    "te.mobile.bodyXxsBold": -0.06,
    "te.mobile.bodyXxsLink": -0.06,
    "te.mobile.body3xs": -0.055,
    "te.mobile.body3xsBold": -0.055,
    "te.mobile.body3xsLink": -0.055,
    "te.mobile.listTitle": -0.08,
    "te.mobile.button": -0.08,
    "te.mobile.code": 0,
    headingXl: $e3613f6017c674c5$var$headingXl$1,
    headingL: $e3613f6017c674c5$var$headingL$1,
    headingM: $e3613f6017c674c5$var$headingM$1,
    headingS: $e3613f6017c674c5$var$headingS$1,
    headingXs: $e3613f6017c674c5$var$headingXs$1,
    headingXxs: $e3613f6017c674c5$var$headingXxs$1,
    overline: $e3613f6017c674c5$var$overline$2,
    bodyL: $e3613f6017c674c5$var$bodyL$1,
    bodyLBold: $e3613f6017c674c5$var$bodyLBold$1,
    bodyLLink: $e3613f6017c674c5$var$bodyLLink$1,
    bodyM: $e3613f6017c674c5$var$bodyM$1,
    bodyMBold: $e3613f6017c674c5$var$bodyMBold$1,
    bodyMLink: $e3613f6017c674c5$var$bodyMLink$1,
    bodyS: $e3613f6017c674c5$var$bodyS$1,
    bodySBold: $e3613f6017c674c5$var$bodySBold$1,
    bodySLink: $e3613f6017c674c5$var$bodySLink$1,
    bodyXs: $e3613f6017c674c5$var$bodyXs$1,
    bodyXsBold: $e3613f6017c674c5$var$bodyXsBold$1,
    bodyXsLink: $e3613f6017c674c5$var$bodyXsLink$1,
    bodyXxs: $e3613f6017c674c5$var$bodyXxs$1,
    bodyXxsBold: $e3613f6017c674c5$var$bodyXxsBold$1,
    bodyXxsLink: $e3613f6017c674c5$var$bodyXxsLink$1,
    body3xs: $e3613f6017c674c5$var$body3xs$1,
    body3xsBold: $e3613f6017c674c5$var$body3xsBold$1,
    body3xsLink: $e3613f6017c674c5$var$body3xsLink$1,
    listTitle: $e3613f6017c674c5$var$listTitle$1,
    button: $e3613f6017c674c5$var$button$1,
    code: $e3613f6017c674c5$var$code$1
};
const $e3613f6017c674c5$var$headingXl = "{$lang.$platform.headingXl}";
const $e3613f6017c674c5$var$headingL = "{$lang.$platform.headingL}";
const $e3613f6017c674c5$var$headingM = "{$lang.$platform.headingM}";
const $e3613f6017c674c5$var$headingS = "{$lang.$platform.headingS}";
const $e3613f6017c674c5$var$headingXs = "{$lang.$platform.headingXs}";
const $e3613f6017c674c5$var$headingXxs = "{$lang.$platform.headingXxs}";
const $e3613f6017c674c5$var$overline$1 = "{$lang.$platform.overline}";
const $e3613f6017c674c5$var$bodyL = "{$lang.$platform.bodyL}";
const $e3613f6017c674c5$var$bodyLBold = "{$lang.$platform.bodyLBold}";
const $e3613f6017c674c5$var$bodyLLink = "{$lang.$platform.bodyLLink}";
const $e3613f6017c674c5$var$bodyM = "{$lang.$platform.bodyM}";
const $e3613f6017c674c5$var$bodyMBold = "{$lang.$platform.bodyMBold}";
const $e3613f6017c674c5$var$bodyMLink = "{$lang.$platform.bodyMLink}";
const $e3613f6017c674c5$var$bodyS = "{$lang.$platform.bodyS}";
const $e3613f6017c674c5$var$bodySBold = "{$lang.$platform.bodySBold}";
const $e3613f6017c674c5$var$bodySLink = "{$lang.$platform.bodySLink}";
const $e3613f6017c674c5$var$bodyXs = "{$lang.$platform.bodyXs}";
const $e3613f6017c674c5$var$bodyXsBold = "{$lang.$platform.bodyXsBold}";
const $e3613f6017c674c5$var$bodyXsLink = "{$lang.$platform.bodyXsLink}";
const $e3613f6017c674c5$var$bodyXxs = "{$lang.$platform.bodyXxs}";
const $e3613f6017c674c5$var$bodyXxsBold = "{$lang.$platform.bodyXxsBold}";
const $e3613f6017c674c5$var$bodyXxsLink = "{$lang.$platform.bodyXxsLink}";
const $e3613f6017c674c5$var$body3xs = "{$lang.$platform.body3xs}";
const $e3613f6017c674c5$var$body3xsBold = "{$lang.$platform.body3xsBold}";
const $e3613f6017c674c5$var$body3xsLink = "{$lang.$platform.body3xsLink}";
const $e3613f6017c674c5$var$listTitle = "{$lang.$platform.listTitle}";
const $e3613f6017c674c5$var$button = "{$lang.$platform.button}";
const $e3613f6017c674c5$var$code = "{$lang.$platform.code}";
const $e3613f6017c674c5$var$lineHeights = {
    "as.desktop.headingXl": 92,
    "as.desktop.headingL": 68,
    "as.desktop.headingM": 44,
    "as.desktop.headingS": 36,
    "as.desktop.headingXs": 32,
    "as.desktop.headingXxs": 24,
    "as.desktop.overline": 16,
    "as.desktop.bodyL": 28,
    "as.desktop.bodyLBold": 28,
    "as.desktop.bodyLLink": 28,
    "as.desktop.bodyM": 24,
    "as.desktop.bodyMBold": 24,
    "as.desktop.bodyMLink": 24,
    "as.desktop.bodyS": 24,
    "as.desktop.bodySBold": 24,
    "as.desktop.bodySLink": 24,
    "as.desktop.bodyXs": 16,
    "as.desktop.bodyXsBold": 16,
    "as.desktop.bodyXsLink": 16,
    "as.desktop.bodyXxs": 16,
    "as.desktop.bodyXxsBold": 20,
    "as.desktop.bodyXxsLink": 16,
    "as.desktop.body3xs": 14,
    "as.desktop.body3xsBold": 14,
    "as.desktop.body3xsLink": 14,
    "as.desktop.listTitle": 20,
    "as.desktop.button": 24,
    "as.desktop.code": 16,
    "as.mobile.headingXl": 68,
    "as.mobile.headingL": 52,
    "as.mobile.headingM": 44,
    "as.mobile.headingS": 36,
    "as.mobile.headingXs": 32,
    "as.mobile.headingXxs": 24,
    "as.mobile.overline": 16,
    "as.mobile.bodyL": 32,
    "as.mobile.bodyLBold": 32,
    "as.mobile.bodyLLink": 32,
    "as.mobile.bodyM": 24,
    "as.mobile.bodyMBold": 24,
    "as.mobile.bodyMLink": 24,
    "as.mobile.bodyS": 24,
    "as.mobile.bodySBold": 24,
    "as.mobile.bodySLink": 24,
    "as.mobile.bodyXs": 16,
    "as.mobile.bodyXsBold": 16,
    "as.mobile.bodyXsLink": 16,
    "as.mobile.bodyXxs": 16,
    "as.mobile.bodyXxsBold": 16,
    "as.mobile.bodyXxsLink": 16,
    "as.mobile.body3xs": 14,
    "as.mobile.body3xsBold": 14,
    "as.mobile.body3xsLink": 14,
    "as.mobile.listTitle": 20,
    "as.mobile.button": 24,
    "as.mobile.code": 16,
    "bn.desktop.headingXl": 92,
    "bn.desktop.headingL": 68,
    "bn.desktop.headingM": 44,
    "bn.desktop.headingS": 36,
    "bn.desktop.headingXs": 32,
    "bn.desktop.headingXxs": 24,
    "bn.desktop.overline": 16,
    "bn.desktop.bodyL": 28,
    "bn.desktop.bodyLBold": 28,
    "bn.desktop.bodyLLink": 28,
    "bn.desktop.bodyM": 24,
    "bn.desktop.bodyMBold": 24,
    "bn.desktop.bodyMLink": 24,
    "bn.desktop.bodyS": 24,
    "bn.desktop.bodySBold": 24,
    "bn.desktop.bodySLink": 24,
    "bn.desktop.bodyXs": 16,
    "bn.desktop.bodyXsBold": 16,
    "bn.desktop.bodyXsLink": 16,
    "bn.desktop.bodyXxs": 16,
    "bn.desktop.bodyXxsBold": 16,
    "bn.desktop.bodyXxsLink": 16,
    "bn.desktop.body3xs": 14,
    "bn.desktop.body3xsBold": 14,
    "bn.desktop.body3xsLink": 14,
    "bn.desktop.listTitle": 20,
    "bn.desktop.button": 24,
    "bn.desktop.code": 16,
    "bn.mobile.headingXl": 68,
    "bn.mobile.headingL": 52,
    "bn.mobile.headingM": 44,
    "bn.mobile.headingS": 36,
    "bn.mobile.headingXs": 32,
    "bn.mobile.headingXxs": 24,
    "bn.mobile.overline": 16,
    "bn.mobile.bodyL": 32,
    "bn.mobile.bodyLBold": 32,
    "bn.mobile.bodyLLink": 32,
    "bn.mobile.bodyM": 24,
    "bn.mobile.bodyMBold": 24,
    "bn.mobile.bodyMLink": 24,
    "bn.mobile.bodyS": 24,
    "bn.mobile.bodySBold": 24,
    "bn.mobile.bodySLink": 24,
    "bn.mobile.bodyXs": 16,
    "bn.mobile.bodyXsBold": 16,
    "bn.mobile.bodyXsLink": 16,
    "bn.mobile.bodyXxs": 16,
    "bn.mobile.bodyXxsBold": 16,
    "bn.mobile.bodyXxsLink": 16,
    "bn.mobile.body3xs": 14,
    "bn.mobile.body3xsBold": 14,
    "bn.mobile.body3xsLink": 14,
    "bn.mobile.listTitle": 20,
    "bn.mobile.button": 24,
    "bn.mobile.code": 16,
    "en.desktop.headingXl": 88,
    "en.desktop.headingL": 64,
    "en.desktop.headingM": 40,
    "en.desktop.headingS": 32,
    "en.desktop.headingXs": 28,
    "en.desktop.headingXxs": 20,
    "en.desktop.overline": 16,
    "en.desktop.bodyL": 32,
    "en.desktop.bodyLBold": 32,
    "en.desktop.bodyLLink": 32,
    "en.desktop.bodyM": 24,
    "en.desktop.bodyMBold": 24,
    "en.desktop.bodyMLink": 24,
    "en.desktop.bodyS": 24,
    "en.desktop.bodySBold": 24,
    "en.desktop.bodySLink": 24,
    "en.desktop.bodyXs": 20,
    "en.desktop.bodyXsBold": 20,
    "en.desktop.bodyXsLink": 20,
    "en.desktop.bodyXxs": 16,
    "en.desktop.bodyXxsBold": 16,
    "en.desktop.bodyXxsLink": 16,
    "en.desktop.body3xs": 14,
    "en.desktop.body3xsBold": 14,
    "en.desktop.body3xsLink": 14,
    "en.desktop.listTitle": 20,
    "en.desktop.button": 24,
    "en.desktop.code": 16,
    "en.mobile.headingXl": 64,
    "en.mobile.headingL": 48,
    "en.mobile.headingM": 40,
    "en.mobile.headingS": 32,
    "en.mobile.headingXs": 28,
    "en.mobile.headingXxs": 20,
    "en.mobile.overline": 16,
    "en.mobile.bodyL": 32,
    "en.mobile.bodyLBold": 32,
    "en.mobile.bodyLLink": 32,
    "en.mobile.bodyM": 24,
    "en.mobile.bodyMBold": 24,
    "en.mobile.bodyMLink": 24,
    "en.mobile.bodyS": 24,
    "en.mobile.bodySBold": 24,
    "en.mobile.bodySLink": 24,
    "en.mobile.bodyXs": 20,
    "en.mobile.bodyXsBold": 20,
    "en.mobile.bodyXsLink": 20,
    "en.mobile.bodyXxs": 16,
    "en.mobile.bodyXxsBold": 16,
    "en.mobile.bodyXxsLink": 16,
    "en.mobile.body3xs": 14,
    "en.mobile.body3xsBold": 14,
    "en.mobile.body3xsLink": 14,
    "en.mobile.listTitle": 20,
    "en.mobile.button": 24,
    "en.mobile.code": 16,
    "gu.desktop.headingXl": 112,
    "gu.desktop.headingL": 88,
    "gu.desktop.headingM": 64,
    "gu.desktop.headingS": 44,
    "gu.desktop.headingXs": 32,
    "gu.desktop.headingXxs": 24,
    "gu.desktop.overline": 16,
    "gu.desktop.bodyL": 28,
    "gu.desktop.bodyLBold": 28,
    "gu.desktop.bodyLLink": 28,
    "gu.desktop.bodyM": 24,
    "gu.desktop.bodyMBold": 24,
    "gu.desktop.bodyMLink": 24,
    "gu.desktop.bodyS": 24,
    "gu.desktop.bodySBold": 24,
    "gu.desktop.bodySLink": 24,
    "gu.desktop.bodyXs": 20,
    "gu.desktop.bodyXsBold": 16,
    "gu.desktop.bodyXsLink": 16,
    "gu.desktop.bodyXxs": 16,
    "gu.desktop.bodyXxsBold": 16,
    "gu.desktop.bodyXxsLink": 16,
    "gu.desktop.body3xs": 14,
    "gu.desktop.body3xsBold": 14,
    "gu.desktop.body3xsLink": 14,
    "gu.desktop.listTitle": 20,
    "gu.desktop.button": 24,
    "gu.desktop.code": 16,
    "gu.mobile.headingXl": 68,
    "gu.mobile.headingL": 52,
    "gu.mobile.headingM": 44,
    "gu.mobile.headingS": 36,
    "gu.mobile.headingXs": 32,
    "gu.mobile.headingXxs": 24,
    "gu.mobile.overline": 16,
    "gu.mobile.bodyL": 32,
    "gu.mobile.bodyLBold": 32,
    "gu.mobile.bodyLLink": 32,
    "gu.mobile.bodyM": 24,
    "gu.mobile.bodyMBold": 24,
    "gu.mobile.bodyMLink": 24,
    "gu.mobile.bodyS": 24,
    "gu.mobile.bodySBold": 24,
    "gu.mobile.bodySLink": 24,
    "gu.mobile.bodyXs": 16,
    "gu.mobile.bodyXsBold": 16,
    "gu.mobile.bodyXsLink": 16,
    "gu.mobile.bodyXxs": 16,
    "gu.mobile.bodyXxsBold": 16,
    "gu.mobile.bodyXxsLink": 16,
    "gu.mobile.body3xs": 14,
    "gu.mobile.body3xsBold": 14,
    "gu.mobile.body3xsLink": 14,
    "gu.mobile.listTitle": 20,
    "gu.mobile.button": 24,
    "gu.mobile.code": 16,
    "hi.desktop.headingXl": 92,
    "hi.desktop.headingL": 68,
    "hi.desktop.headingM": 44,
    "hi.desktop.headingS": 36,
    "hi.desktop.headingXs": 32,
    "hi.desktop.headingXxs": 24,
    "hi.desktop.overline": 16,
    "hi.desktop.bodyL": 28,
    "hi.desktop.bodyLBold": 28,
    "hi.desktop.bodyLLink": 28,
    "hi.desktop.bodyM": 24,
    "hi.desktop.bodyMBold": 24,
    "hi.desktop.bodyMLink": 24,
    "hi.desktop.bodyS": 24,
    "hi.desktop.bodySBold": 24,
    "hi.desktop.bodySLink": 24,
    "hi.desktop.bodyXs": 16,
    "hi.desktop.bodyXsBold": 16,
    "hi.desktop.bodyXsLink": 16,
    "hi.desktop.bodyXxs": 16,
    "hi.desktop.bodyXxsBold": 20,
    "hi.desktop.bodyXxsLink": 16,
    "hi.desktop.body3xs": 14,
    "hi.desktop.body3xsBold": 14,
    "hi.desktop.body3xsLink": 14,
    "hi.desktop.listTitle": 20,
    "hi.desktop.button": 24,
    "hi.desktop.code": 16,
    "hi.mobile.headingXl": 68,
    "hi.mobile.headingL": 52,
    "hi.mobile.headingM": 44,
    "hi.mobile.headingS": 36,
    "hi.mobile.headingXs": 32,
    "hi.mobile.headingXxs": 24,
    "hi.mobile.overline": 16,
    "hi.mobile.bodyL": 32,
    "hi.mobile.bodyLBold": 32,
    "hi.mobile.bodyLLink": 32,
    "hi.mobile.bodyM": 24,
    "hi.mobile.bodyMBold": 24,
    "hi.mobile.bodyMLink": 24,
    "hi.mobile.bodyS": 24,
    "hi.mobile.bodySBold": 24,
    "hi.mobile.bodySLink": 24,
    "hi.mobile.bodyXs": 16,
    "hi.mobile.bodyXsBold": 16,
    "hi.mobile.bodyXsLink": 16,
    "hi.mobile.bodyXxs": 16,
    "hi.mobile.bodyXxsBold": 16,
    "hi.mobile.bodyXxsLink": 16,
    "hi.mobile.body3xs": 14,
    "hi.mobile.body3xsBold": 14,
    "hi.mobile.body3xsLink": 14,
    "hi.mobile.listTitle": 20,
    "hi.mobile.button": 24,
    "hi.mobile.code": 16,
    "kn.desktop.headingXl": 112,
    "kn.desktop.headingL": 88,
    "kn.desktop.headingM": 64,
    "kn.desktop.headingS": 44,
    "kn.desktop.headingXs": 32,
    "kn.desktop.headingXxs": 24,
    "kn.desktop.overline": 16,
    "kn.desktop.bodyL": 28,
    "kn.desktop.bodyLBold": 28,
    "kn.desktop.bodyLLink": 28,
    "kn.desktop.bodyM": 24,
    "kn.desktop.bodyMBold": 24,
    "kn.desktop.bodyMLink": 24,
    "kn.desktop.bodyS": 24,
    "kn.desktop.bodySBold": 24,
    "kn.desktop.bodySLink": 24,
    "kn.desktop.bodyXs": 20,
    "kn.desktop.bodyXsBold": 16,
    "kn.desktop.bodyXsLink": 16,
    "kn.desktop.bodyXxs": 16,
    "kn.desktop.bodyXxsBold": 16,
    "kn.desktop.bodyXxsLink": 16,
    "kn.desktop.body3xs": 14,
    "kn.desktop.body3xsBold": 14,
    "kn.desktop.body3xsLink": 14,
    "kn.desktop.listTitle": 20,
    "kn.desktop.button": 24,
    "kn.desktop.code": 16,
    "kn.mobile.headingXl": 68,
    "kn.mobile.headingL": 52,
    "kn.mobile.headingM": 44,
    "kn.mobile.headingS": 36,
    "kn.mobile.headingXs": 32,
    "kn.mobile.headingXxs": 24,
    "kn.mobile.overline": 16,
    "kn.mobile.bodyL": 32,
    "kn.mobile.bodyLBold": 32,
    "kn.mobile.bodyLLink": 32,
    "kn.mobile.bodyM": 24,
    "kn.mobile.bodyMBold": 24,
    "kn.mobile.bodyMLink": 24,
    "kn.mobile.bodyS": 24,
    "kn.mobile.bodySBold": 24,
    "kn.mobile.bodySLink": 24,
    "kn.mobile.bodyXs": 16,
    "kn.mobile.bodyXsBold": 16,
    "kn.mobile.bodyXsLink": 16,
    "kn.mobile.bodyXxs": 16,
    "kn.mobile.bodyXxsBold": 16,
    "kn.mobile.bodyXxsLink": 16,
    "kn.mobile.body3xs": 14,
    "kn.mobile.body3xsBold": 14,
    "kn.mobile.body3xsLink": 14,
    "kn.mobile.listTitle": 20,
    "kn.mobile.button": 24,
    "kn.mobile.code": 16,
    "ml.desktop.headingXl": 92,
    "ml.desktop.headingL": 68,
    "ml.desktop.headingM": 44,
    "ml.desktop.headingS": 36,
    "ml.desktop.headingXs": 32,
    "ml.desktop.headingXxs": 24,
    "ml.desktop.overline": 16,
    "ml.desktop.bodyL": 28,
    "ml.desktop.bodyLBold": 28,
    "ml.desktop.bodyLLink": 28,
    "ml.desktop.bodyM": 24,
    "ml.desktop.bodyMBold": 24,
    "ml.desktop.bodyMLink": 24,
    "ml.desktop.bodyS": 24,
    "ml.desktop.bodySBold": 24,
    "ml.desktop.bodySLink": 24,
    "ml.desktop.bodyXs": 20,
    "ml.desktop.bodyXsBold": 16,
    "ml.desktop.bodyXsLink": 16,
    "ml.desktop.bodyXxs": 16,
    "ml.desktop.bodyXxsBold": 16,
    "ml.desktop.bodyXxsLink": 16,
    "ml.desktop.body3xs": 14,
    "ml.desktop.body3xsBold": 14,
    "ml.desktop.body3xsLink": 14,
    "ml.desktop.listTitle": 20,
    "ml.desktop.button": 24,
    "ml.desktop.code": 16,
    "ml.mobile.headingXl": 68,
    "ml.mobile.headingL": 52,
    "ml.mobile.headingM": 44,
    "ml.mobile.headingS": 36,
    "ml.mobile.headingXs": 32,
    "ml.mobile.headingXxs": 24,
    "ml.mobile.overline": 16,
    "ml.mobile.bodyL": 32,
    "ml.mobile.bodyLBold": 32,
    "ml.mobile.bodyLLink": 32,
    "ml.mobile.bodyM": 24,
    "ml.mobile.bodyMBold": 24,
    "ml.mobile.bodyMLink": 24,
    "ml.mobile.bodyS": 24,
    "ml.mobile.bodySBold": 24,
    "ml.mobile.bodySLink": 24,
    "ml.mobile.bodyXs": 16,
    "ml.mobile.bodyXsBold": 16,
    "ml.mobile.bodyXsLink": 16,
    "ml.mobile.bodyXxs": 16,
    "ml.mobile.bodyXxsBold": 16,
    "ml.mobile.bodyXxsLink": 16,
    "ml.mobile.body3xs": 14,
    "ml.mobile.body3xsBold": 14,
    "ml.mobile.body3xsLink": 14,
    "ml.mobile.listTitle": 20,
    "ml.mobile.button": 24,
    "ml.mobile.code": 16,
    "mr.desktop.headingXl": 92,
    "mr.desktop.headingL": 68,
    "mr.desktop.headingM": 44,
    "mr.desktop.headingS": 36,
    "mr.desktop.headingXs": 32,
    "mr.desktop.headingXxs": 24,
    "mr.desktop.overline": 16,
    "mr.desktop.bodyL": 28,
    "mr.desktop.bodyLBold": 28,
    "mr.desktop.bodyLLink": 28,
    "mr.desktop.bodyM": 24,
    "mr.desktop.bodyMBold": 24,
    "mr.desktop.bodyMLink": 24,
    "mr.desktop.bodyS": 24,
    "mr.desktop.bodySBold": 24,
    "mr.desktop.bodySLink": 24,
    "mr.desktop.bodyXs": 16,
    "mr.desktop.bodyXsBold": 16,
    "mr.desktop.bodyXsLink": 16,
    "mr.desktop.bodyXxs": 16,
    "mr.desktop.bodyXxsBold": 16,
    "mr.desktop.bodyXxsLink": 16,
    "mr.desktop.body3xs": 14,
    "mr.desktop.body3xsBold": 14,
    "mr.desktop.body3xsLink": 14,
    "mr.desktop.listTitle": 20,
    "mr.desktop.button": 24,
    "mr.desktop.code": 16,
    "mr.mobile.headingXl": 68,
    "mr.mobile.headingL": 52,
    "mr.mobile.headingM": 44,
    "mr.mobile.headingS": 36,
    "mr.mobile.headingXs": 32,
    "mr.mobile.headingXxs": 24,
    "mr.mobile.overline": 16,
    "mr.mobile.bodyL": 32,
    "mr.mobile.bodyLBold": 32,
    "mr.mobile.bodyLLink": 32,
    "mr.mobile.bodyM": 24,
    "mr.mobile.bodyMBold": 24,
    "mr.mobile.bodyMLink": 24,
    "mr.mobile.bodyS": 24,
    "mr.mobile.bodySBold": 24,
    "mr.mobile.bodySLink": 24,
    "mr.mobile.bodyXs": 16,
    "mr.mobile.bodyXsBold": 16,
    "mr.mobile.bodyXsLink": 16,
    "mr.mobile.bodyXxs": 16,
    "mr.mobile.bodyXxsBold": 16,
    "mr.mobile.bodyXxsLink": 16,
    "mr.mobile.body3xs": 14,
    "mr.mobile.body3xsBold": 14,
    "mr.mobile.body3xsLink": 14,
    "mr.mobile.listTitle": 20,
    "mr.mobile.button": 24,
    "mr.mobile.code": 16,
    "or.desktop.headingXl": 92,
    "or.desktop.headingL": 68,
    "or.desktop.headingM": 44,
    "or.desktop.headingS": 36,
    "or.desktop.headingXs": 32,
    "or.desktop.headingXxs": 24,
    "or.desktop.overline": 16,
    "or.desktop.bodyL": 28,
    "or.desktop.bodyLBold": 28,
    "or.desktop.bodyLLink": 28,
    "or.desktop.bodyM": 24,
    "or.desktop.bodyMBold": 24,
    "or.desktop.bodyMLink": 24,
    "or.desktop.bodyS": 24,
    "or.desktop.bodySBold": 24,
    "or.desktop.bodySLink": 24,
    "or.desktop.bodyXs": 16,
    "or.desktop.bodyXsBold": 16,
    "or.desktop.bodyXsLink": 16,
    "or.desktop.bodyXxs": 16,
    "or.desktop.bodyXxsBold": 16,
    "or.desktop.bodyXxsLink": 16,
    "or.desktop.body3xs": 14,
    "or.desktop.body3xsBold": 14,
    "or.desktop.body3xsLink": 14,
    "or.desktop.listTitle": 20,
    "or.desktop.button": 24,
    "or.desktop.code": 16,
    "or.mobile.headingXl": 68,
    "or.mobile.headingL": 52,
    "or.mobile.headingM": 44,
    "or.mobile.headingS": 36,
    "or.mobile.headingXs": 32,
    "or.mobile.headingXxs": 24,
    "or.mobile.overline": 16,
    "or.mobile.bodyL": 32,
    "or.mobile.bodyLBold": 32,
    "or.mobile.bodyLLink": 32,
    "or.mobile.bodyM": 24,
    "or.mobile.bodyMBold": 24,
    "or.mobile.bodyMLink": 24,
    "or.mobile.bodyS": 24,
    "or.mobile.bodySBold": 24,
    "or.mobile.bodySLink": 24,
    "or.mobile.bodyXs": 16,
    "or.mobile.bodyXsBold": 16,
    "or.mobile.bodyXsLink": 16,
    "or.mobile.bodyXxs": 16,
    "or.mobile.bodyXxsBold": 16,
    "or.mobile.bodyXxsLink": 16,
    "or.mobile.body3xs": 14,
    "or.mobile.body3xsBold": 14,
    "or.mobile.body3xsLink": 14,
    "or.mobile.listTitle": 20,
    "or.mobile.button": 24,
    "or.mobile.code": 16,
    "pa.desktop.headingXl": 92,
    "pa.desktop.headingL": 68,
    "pa.desktop.headingM": 44,
    "pa.desktop.headingS": 36,
    "pa.desktop.headingXs": 32,
    "pa.desktop.headingXxs": 24,
    "pa.desktop.overline": 16,
    "pa.desktop.bodyL": 28,
    "pa.desktop.bodyLBold": 28,
    "pa.desktop.bodyLLink": 28,
    "pa.desktop.bodyM": 24,
    "pa.desktop.bodyMBold": 24,
    "pa.desktop.bodyMLink": 24,
    "pa.desktop.bodyS": 24,
    "pa.desktop.bodySBold": 24,
    "pa.desktop.bodySLink": 24,
    "pa.desktop.bodyXs": 20,
    "pa.desktop.bodyXsBold": 16,
    "pa.desktop.bodyXsLink": 16,
    "pa.desktop.bodyXxs": 16,
    "pa.desktop.bodyXxsBold": 16,
    "pa.desktop.bodyXxsLink": 16,
    "pa.desktop.body3xs": 14,
    "pa.desktop.body3xsBold": 14,
    "pa.desktop.body3xsLink": 14,
    "pa.desktop.listTitle": 20,
    "pa.desktop.button": 24,
    "pa.desktop.code": 16,
    "pa.mobile.headingXl": 68,
    "pa.mobile.headingL": 52,
    "pa.mobile.headingM": 44,
    "pa.mobile.headingS": 36,
    "pa.mobile.headingXs": 32,
    "pa.mobile.headingXxs": 24,
    "pa.mobile.overline": 16,
    "pa.mobile.bodyL": 32,
    "pa.mobile.bodyLBold": 32,
    "pa.mobile.bodyLLink": 32,
    "pa.mobile.bodyM": 24,
    "pa.mobile.bodyMBold": 24,
    "pa.mobile.bodyMLink": 24,
    "pa.mobile.bodyS": 24,
    "pa.mobile.bodySBold": 24,
    "pa.mobile.bodySLink": 24,
    "pa.mobile.bodyXs": 16,
    "pa.mobile.bodyXsBold": 16,
    "pa.mobile.bodyXsLink": 16,
    "pa.mobile.bodyXxs": 16,
    "pa.mobile.bodyXxsBold": 16,
    "pa.mobile.bodyXxsLink": 16,
    "pa.mobile.body3xs": 14,
    "pa.mobile.body3xsBold": 14,
    "pa.mobile.body3xsLink": 14,
    "pa.mobile.listTitle": 20,
    "pa.mobile.button": 24,
    "pa.mobile.code": 16,
    "ta.desktop.headingXl": 112,
    "ta.desktop.headingL": 88,
    "ta.desktop.headingM": 64,
    "ta.desktop.headingS": 44,
    "ta.desktop.headingXs": 32,
    "ta.desktop.headingXxs": 24,
    "ta.desktop.overline": 16,
    "ta.desktop.bodyL": 28,
    "ta.desktop.bodyLBold": 28,
    "ta.desktop.bodyLLink": 28,
    "ta.desktop.bodyM": 24,
    "ta.desktop.bodyMBold": 24,
    "ta.desktop.bodyMLink": 24,
    "ta.desktop.bodyS": 24,
    "ta.desktop.bodySBold": 24,
    "ta.desktop.bodySLink": 24,
    "ta.desktop.bodyXs": 16,
    "ta.desktop.bodyXsBold": 16,
    "ta.desktop.bodyXsLink": 16,
    "ta.desktop.bodyXxs": 16,
    "ta.desktop.bodyXxsBold": 16,
    "ta.desktop.bodyXxsLink": 16,
    "ta.desktop.body3xs": 14,
    "ta.desktop.body3xsBold": 14,
    "ta.desktop.body3xsLink": 14,
    "ta.desktop.listTitle": 20,
    "ta.desktop.button": 24,
    "ta.desktop.code": 16,
    "ta.mobile.headingXl": 68,
    "ta.mobile.headingL": 52,
    "ta.mobile.headingM": 44,
    "ta.mobile.headingS": 36,
    "ta.mobile.headingXs": 32,
    "ta.mobile.headingXxs": 24,
    "ta.mobile.overline": 16,
    "ta.mobile.bodyL": 32,
    "ta.mobile.bodyLBold": 32,
    "ta.mobile.bodyLLink": 32,
    "ta.mobile.bodyM": 24,
    "ta.mobile.bodyMBold": 24,
    "ta.mobile.bodyMLink": 24,
    "ta.mobile.bodyS": 24,
    "ta.mobile.bodySBold": 24,
    "ta.mobile.bodySLink": 24,
    "ta.mobile.bodyXs": 20,
    "ta.mobile.bodyXsBold": 16,
    "ta.mobile.bodyXsLink": 16,
    "ta.mobile.bodyXxs": 16,
    "ta.mobile.bodyXxsBold": 16,
    "ta.mobile.bodyXxsLink": 16,
    "ta.mobile.body3xs": 14,
    "ta.mobile.body3xsBold": 14,
    "ta.mobile.body3xsLink": 14,
    "ta.mobile.listTitle": 20,
    "ta.mobile.button": 24,
    "ta.mobile.code": 16,
    "te.desktop.headingXl": 92,
    "te.desktop.headingL": 68,
    "te.desktop.headingM": 44,
    "te.desktop.headingS": 36,
    "te.desktop.headingXs": 32,
    "te.desktop.headingXxs": 24,
    "te.desktop.overline": 16,
    "te.desktop.bodyL": 28,
    "te.desktop.bodyLBold": 28,
    "te.desktop.bodyLLink": 28,
    "te.desktop.bodyM": 24,
    "te.desktop.bodyMBold": 24,
    "te.desktop.bodyMLink": 24,
    "te.desktop.bodyS": 24,
    "te.desktop.bodySBold": 24,
    "te.desktop.bodySLink": 24,
    "te.desktop.bodyXs": 16,
    "te.desktop.bodyXsBold": 16,
    "te.desktop.bodyXsLink": 16,
    "te.desktop.bodyXxs": 16,
    "te.desktop.bodyXxsBold": 16,
    "te.desktop.bodyXxsLink": 16,
    "te.desktop.body3xs": 14,
    "te.desktop.body3xsBold": 14,
    "te.desktop.body3xsLink": 14,
    "te.desktop.listTitle": 20,
    "te.desktop.button": 24,
    "te.desktop.code": 16,
    "te.mobile.headingXl": 68,
    "te.mobile.headingL": 52,
    "te.mobile.headingM": 44,
    "te.mobile.headingS": 36,
    "te.mobile.headingXs": 32,
    "te.mobile.headingXxs": 24,
    "te.mobile.overline": 16,
    "te.mobile.bodyL": 32,
    "te.mobile.bodyLBold": 32,
    "te.mobile.bodyLLink": 32,
    "te.mobile.bodyM": 24,
    "te.mobile.bodyMBold": 24,
    "te.mobile.bodyMLink": 24,
    "te.mobile.bodyS": 24,
    "te.mobile.bodySBold": 24,
    "te.mobile.bodySLink": 24,
    "te.mobile.bodyXs": 16,
    "te.mobile.bodyXsBold": 16,
    "te.mobile.bodyXsLink": 16,
    "te.mobile.bodyXxs": 16,
    "te.mobile.bodyXxsBold": 16,
    "te.mobile.bodyXxsLink": 16,
    "te.mobile.body3xs": 14,
    "te.mobile.body3xsBold": 14,
    "te.mobile.body3xsLink": 14,
    "te.mobile.listTitle": 20,
    "te.mobile.button": 24,
    "te.mobile.code": 16,
    headingXl: $e3613f6017c674c5$var$headingXl,
    headingL: $e3613f6017c674c5$var$headingL,
    headingM: $e3613f6017c674c5$var$headingM,
    headingS: $e3613f6017c674c5$var$headingS,
    headingXs: $e3613f6017c674c5$var$headingXs,
    headingXxs: $e3613f6017c674c5$var$headingXxs,
    overline: $e3613f6017c674c5$var$overline$1,
    bodyL: $e3613f6017c674c5$var$bodyL,
    bodyLBold: $e3613f6017c674c5$var$bodyLBold,
    bodyLLink: $e3613f6017c674c5$var$bodyLLink,
    bodyM: $e3613f6017c674c5$var$bodyM,
    bodyMBold: $e3613f6017c674c5$var$bodyMBold,
    bodyMLink: $e3613f6017c674c5$var$bodyMLink,
    bodyS: $e3613f6017c674c5$var$bodyS,
    bodySBold: $e3613f6017c674c5$var$bodySBold,
    bodySLink: $e3613f6017c674c5$var$bodySLink,
    bodyXs: $e3613f6017c674c5$var$bodyXs,
    bodyXsBold: $e3613f6017c674c5$var$bodyXsBold,
    bodyXsLink: $e3613f6017c674c5$var$bodyXsLink,
    bodyXxs: $e3613f6017c674c5$var$bodyXxs,
    bodyXxsBold: $e3613f6017c674c5$var$bodyXxsBold,
    bodyXxsLink: $e3613f6017c674c5$var$bodyXxsLink,
    body3xs: $e3613f6017c674c5$var$body3xs,
    body3xsBold: $e3613f6017c674c5$var$body3xsBold,
    body3xsLink: $e3613f6017c674c5$var$body3xsLink,
    listTitle: $e3613f6017c674c5$var$listTitle,
    button: $e3613f6017c674c5$var$button,
    code: $e3613f6017c674c5$var$code
};
const $e3613f6017c674c5$var$custom_1$2 = "85%";
const $e3613f6017c674c5$var$custom_2$2 = "80%";
const $e3613f6017c674c5$var$opacity = {
    "opacity.invisible": "0%",
    "opacity.disabled": "30%",
    "opacity.enabled": "100%",
    custom_1: $e3613f6017c674c5$var$custom_1$2,
    custom_2: $e3613f6017c674c5$var$custom_2$2
};
const $e3613f6017c674c5$var$paragraphSpacing = {
    "paragraph-spacing.0": "0"
};
const $e3613f6017c674c5$var$semantic = {
    "color.bold.default.description": "Used for default focus and disable backgrounds",
    "color.bold.emphasised.description": "Used for hover bg",
    "color.bold.muted.description": "Used as fg on dissabled",
    "color.bold.subtle.description": "Used for the fg on pressed",
    "color.bold.discreet.description": "Used as fg on hover",
    "color.bold.on-bold.description": "Used on the default fg",
    "color.bold.disabled.description": "Used on the default fg"
};
const $e3613f6017c674c5$var$shadows = {
    "box-shadow.1.true": "0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)",
    "box-shadow.false": "none"
};
const $e3613f6017c674c5$var$xxs$1 = "4";
const $e3613f6017c674c5$var$xs$1 = "8";
const $e3613f6017c674c5$var$s$1 = "12";
const $e3613f6017c674c5$var$base$1 = "16";
const $e3613f6017c674c5$var$m$1 = "24";
const $e3613f6017c674c5$var$l$1 = "32";
const $e3613f6017c674c5$var$xl$1 = "40";
const $e3613f6017c674c5$var$xxl$1 = "48";
const $e3613f6017c674c5$var$huge$1 = "64";
const $e3613f6017c674c5$var$massive$1 = "80";
const $e3613f6017c674c5$var$custom_1$1 = "120";
const $e3613f6017c674c5$var$custom_2$1 = "44";
const $e3613f6017c674c5$var$custom_3$1 = "28";
const $e3613f6017c674c5$var$custom_4$1 = "2";
const $e3613f6017c674c5$var$custom_5$1 = "1";
const $e3613f6017c674c5$var$custom_6$1 = "384";
const $e3613f6017c674c5$var$custom_7$1 = "156";
const $e3613f6017c674c5$var$custom_8$1 = "300";
const $e3613f6017c674c5$var$custom_9$1 = "102";
const $e3613f6017c674c5$var$custom_10$1 = "184";
const $e3613f6017c674c5$var$custom_11$1 = "56";
const $e3613f6017c674c5$var$custom_12$1 = "280";
const $e3613f6017c674c5$var$custom_13$1 = "312";
const $e3613f6017c674c5$var$custom_14$1 = "384";
const $e3613f6017c674c5$var$custom_15$1 = "6";
const $e3613f6017c674c5$var$custom_16$1 = "72";
const $e3613f6017c674c5$var$custom_17$1 = "560";
const $e3613f6017c674c5$var$custom_18$1 = "20";
const $e3613f6017c674c5$var$custom_19$1 = "10";
const $e3613f6017c674c5$var$custom_20$1 = "9";
const $e3613f6017c674c5$var$custom_21$1 = "15";
const $e3613f6017c674c5$var$custom_22$1 = "17";
const $e3613f6017c674c5$var$custom_23$1 = "7";
const $e3613f6017c674c5$var$custom_24$1 = "13";
const $e3613f6017c674c5$var$custom_25$1 = "18";
const $e3613f6017c674c5$var$custom_26 = "27";
const $e3613f6017c674c5$var$custom_27 = "584";
const $e3613f6017c674c5$var$custom_28 = "331";
const $e3613f6017c674c5$var$custom_29 = "33";
const $e3613f6017c674c5$var$custom_30 = "23";
const $e3613f6017c674c5$var$custom_31 = "592";
const $e3613f6017c674c5$var$sizing = {
    xxs: $e3613f6017c674c5$var$xxs$1,
    xs: $e3613f6017c674c5$var$xs$1,
    s: $e3613f6017c674c5$var$s$1,
    base: $e3613f6017c674c5$var$base$1,
    m: $e3613f6017c674c5$var$m$1,
    l: $e3613f6017c674c5$var$l$1,
    xl: $e3613f6017c674c5$var$xl$1,
    xxl: $e3613f6017c674c5$var$xxl$1,
    huge: $e3613f6017c674c5$var$huge$1,
    massive: $e3613f6017c674c5$var$massive$1,
    custom_1: $e3613f6017c674c5$var$custom_1$1,
    custom_2: $e3613f6017c674c5$var$custom_2$1,
    custom_3: $e3613f6017c674c5$var$custom_3$1,
    custom_4: $e3613f6017c674c5$var$custom_4$1,
    custom_5: $e3613f6017c674c5$var$custom_5$1,
    custom_6: $e3613f6017c674c5$var$custom_6$1,
    custom_7: $e3613f6017c674c5$var$custom_7$1,
    custom_8: $e3613f6017c674c5$var$custom_8$1,
    custom_9: $e3613f6017c674c5$var$custom_9$1,
    custom_10: $e3613f6017c674c5$var$custom_10$1,
    custom_11: $e3613f6017c674c5$var$custom_11$1,
    custom_12: $e3613f6017c674c5$var$custom_12$1,
    custom_13: $e3613f6017c674c5$var$custom_13$1,
    custom_14: $e3613f6017c674c5$var$custom_14$1,
    custom_15: $e3613f6017c674c5$var$custom_15$1,
    custom_16: $e3613f6017c674c5$var$custom_16$1,
    custom_17: $e3613f6017c674c5$var$custom_17$1,
    custom_18: $e3613f6017c674c5$var$custom_18$1,
    custom_19: $e3613f6017c674c5$var$custom_19$1,
    custom_20: $e3613f6017c674c5$var$custom_20$1,
    custom_21: $e3613f6017c674c5$var$custom_21$1,
    custom_22: $e3613f6017c674c5$var$custom_22$1,
    custom_23: $e3613f6017c674c5$var$custom_23$1,
    custom_24: $e3613f6017c674c5$var$custom_24$1,
    custom_25: $e3613f6017c674c5$var$custom_25$1,
    custom_26: $e3613f6017c674c5$var$custom_26,
    custom_27: $e3613f6017c674c5$var$custom_27,
    custom_28: $e3613f6017c674c5$var$custom_28,
    custom_29: $e3613f6017c674c5$var$custom_29,
    custom_30: $e3613f6017c674c5$var$custom_30,
    custom_31: $e3613f6017c674c5$var$custom_31
};
const $e3613f6017c674c5$var$xxs = "4";
const $e3613f6017c674c5$var$xs = "8";
const $e3613f6017c674c5$var$s = "12";
const $e3613f6017c674c5$var$base = "16";
const $e3613f6017c674c5$var$m = "24";
const $e3613f6017c674c5$var$l = "32";
const $e3613f6017c674c5$var$xl = "40";
const $e3613f6017c674c5$var$xxl = "48";
const $e3613f6017c674c5$var$huge = "64";
const $e3613f6017c674c5$var$massive = "80";
const $e3613f6017c674c5$var$custom_1 = "1";
const $e3613f6017c674c5$var$stepper_horizontal = "{$platform.stepper_horizontal}";
const $e3613f6017c674c5$var$custom_2 = "11";
const $e3613f6017c674c5$var$custom_3 = "128";
const $e3613f6017c674c5$var$custom_4 = "2";
const $e3613f6017c674c5$var$custom_5 = "0";
const $e3613f6017c674c5$var$custom_6 = "84";
const $e3613f6017c674c5$var$custom_7 = "88";
const $e3613f6017c674c5$var$custom_8 = "42";
const $e3613f6017c674c5$var$custom_9 = "10";
const $e3613f6017c674c5$var$custom_10 = "38";
const $e3613f6017c674c5$var$custom_11 = "26";
const $e3613f6017c674c5$var$custom_12 = "30";
const $e3613f6017c674c5$var$custom_13 = "22";
const $e3613f6017c674c5$var$custom_14 = "28";
const $e3613f6017c674c5$var$custom_15 = "20";
const $e3613f6017c674c5$var$custom_16 = "3";
const $e3613f6017c674c5$var$custom_17 = "5";
const $e3613f6017c674c5$var$custom_18 = "6";
const $e3613f6017c674c5$var$custom_19 = "56";
const $e3613f6017c674c5$var$custom_20 = "46";
const $e3613f6017c674c5$var$custom_21 = "110";
const $e3613f6017c674c5$var$custom_22 = "114";
const $e3613f6017c674c5$var$custom_23 = "15";
const $e3613f6017c674c5$var$custom_24 = "31";
const $e3613f6017c674c5$var$custom_25 = "17";
const $e3613f6017c674c5$var$bottomsheet_padding_right = "90";
const $e3613f6017c674c5$var$spacing = {
    xxs: $e3613f6017c674c5$var$xxs,
    xs: $e3613f6017c674c5$var$xs,
    s: $e3613f6017c674c5$var$s,
    base: $e3613f6017c674c5$var$base,
    m: $e3613f6017c674c5$var$m,
    l: $e3613f6017c674c5$var$l,
    xl: $e3613f6017c674c5$var$xl,
    xxl: $e3613f6017c674c5$var$xxl,
    huge: $e3613f6017c674c5$var$huge,
    massive: $e3613f6017c674c5$var$massive,
    custom_1: $e3613f6017c674c5$var$custom_1,
    "desktop.stepper_horizontal": "{massive}",
    "tablet.stepper_horizontal": "{m}",
    "mobile.stepper_horizontal": "{m}",
    stepper_horizontal: $e3613f6017c674c5$var$stepper_horizontal,
    custom_2: $e3613f6017c674c5$var$custom_2,
    custom_3: $e3613f6017c674c5$var$custom_3,
    custom_4: $e3613f6017c674c5$var$custom_4,
    custom_5: $e3613f6017c674c5$var$custom_5,
    custom_6: $e3613f6017c674c5$var$custom_6,
    custom_7: $e3613f6017c674c5$var$custom_7,
    custom_8: $e3613f6017c674c5$var$custom_8,
    custom_9: $e3613f6017c674c5$var$custom_9,
    custom_10: $e3613f6017c674c5$var$custom_10,
    custom_11: $e3613f6017c674c5$var$custom_11,
    custom_12: $e3613f6017c674c5$var$custom_12,
    custom_13: $e3613f6017c674c5$var$custom_13,
    custom_14: $e3613f6017c674c5$var$custom_14,
    custom_15: $e3613f6017c674c5$var$custom_15,
    custom_16: $e3613f6017c674c5$var$custom_16,
    custom_17: $e3613f6017c674c5$var$custom_17,
    custom_18: $e3613f6017c674c5$var$custom_18,
    custom_19: $e3613f6017c674c5$var$custom_19,
    custom_20: $e3613f6017c674c5$var$custom_20,
    custom_21: $e3613f6017c674c5$var$custom_21,
    custom_22: $e3613f6017c674c5$var$custom_22,
    custom_23: $e3613f6017c674c5$var$custom_23,
    custom_24: $e3613f6017c674c5$var$custom_24,
    custom_25: $e3613f6017c674c5$var$custom_25,
    bottomsheet_padding_right: $e3613f6017c674c5$var$bottomsheet_padding_right
};
const $e3613f6017c674c5$var$overline = "{$lang.$platform.overline}";
const $e3613f6017c674c5$var$textCase = {
    "text-case.none": "none",
    "text-case.uppercase": "uppercase",
    "text-case.lowercase": "lowercase",
    "text-case.capitalize": "capitalize",
    "as.desktop.overline": "uppercase",
    "as.mobile.overline": "uppercase",
    "bn.desktop.overline": "uppercase",
    "bn.mobile.overline": "uppercase",
    "en.desktop.overline": "uppercase",
    "en.mobile.overline": "uppercase",
    "gu.desktop.overline": "uppercase",
    "gu.mobile.overline": "uppercase",
    "hi.desktop.overline": "uppercase",
    "hi.mobile.overline": "uppercase",
    "kn.desktop.overline": "uppercase",
    "kn.mobile.overline": "uppercase",
    "ml.desktop.overline": "uppercase",
    "mr.desktop.overline": "uppercase",
    "mr.mobile.overline": "uppercase",
    "or.desktop.overline": "uppercase",
    "pa.desktop.overline": "uppercase",
    "pa.mobile.overline": "uppercase",
    "ta.desktop.overline": "uppercase",
    "ta.mobile.overline": "uppercase",
    "te.desktop.overline": "uppercase",
    "te.mobile.overline": "uppercase",
    overline: $e3613f6017c674c5$var$overline
};
const $e3613f6017c674c5$var$textDecoration = {
    "text-decoration.none": "none",
    "text-decoration.underline": "underline",
    "text-decoration.line-through": "line-through",
    "text-decoration.overline": "overline",
    "max.lines.1": "1",
    "text-overflow.ellipsis": "ellipsis"
};
const $e3613f6017c674c5$var$easeRapid = "0.35, 0, 0.5, 1";
const $e3613f6017c674c5$var$easeQuick = "0.35, 0, 0.25, 1";
const $e3613f6017c674c5$var$easeJoyful = "0.35, 1.3, 0.3, 1";
const $e3613f6017c674c5$var$easeEntrance = "0, 0, 0.1, 1";
const $e3613f6017c674c5$var$easeExit = "0.35, 0, 0.8, 1";
const $e3613f6017c674c5$var$easeJoyfulEntrance = "0.15, 1.3, 0.3, 1";
const $e3613f6017c674c5$var$easeJoyfulExit = "0.7, -0.1, 0.6, 0.1";
const $e3613f6017c674c5$var$easeJoyfulentrance = "0.15, 1.3, 0.3, 1";
const $e3613f6017c674c5$var$easeJoyfulexit = "0.7, -0.1, 0.6, 0.1";
const $e3613f6017c674c5$var$transitions = {
    easeRapid: $e3613f6017c674c5$var$easeRapid,
    easeQuick: $e3613f6017c674c5$var$easeQuick,
    easeJoyful: $e3613f6017c674c5$var$easeJoyful,
    easeEntrance: $e3613f6017c674c5$var$easeEntrance,
    easeExit: $e3613f6017c674c5$var$easeExit,
    easeJoyfulEntrance: $e3613f6017c674c5$var$easeJoyfulEntrance,
    easeJoyfulExit: $e3613f6017c674c5$var$easeJoyfulExit,
    easeJoyfulentrance: $e3613f6017c674c5$var$easeJoyfulentrance,
    easeJoyfulexit: $e3613f6017c674c5$var$easeJoyfulexit
};
const $e3613f6017c674c5$var$rapid = "300";
const $e3613f6017c674c5$var$medium = "500";
const $e3613f6017c674c5$var$slow = "1000";
const $e3613f6017c674c5$var$transitionsDuration = {
    rapid: $e3613f6017c674c5$var$rapid,
    medium: $e3613f6017c674c5$var$medium,
    slow: $e3613f6017c674c5$var$slow
};
const $e3613f6017c674c5$var$typography = {};
const $e3613f6017c674c5$export$6ad93df59e712c43 = {
    tokens: {
        borderRadius: $e3613f6017c674c5$var$borderRadius,
        borderWidth: $e3613f6017c674c5$var$borderWidth,
        color: $e3613f6017c674c5$var$color,
        fontFamilies: $e3613f6017c674c5$var$fontFamilies,
        fontSizes: $e3613f6017c674c5$var$fontSizes,
        fontWeights: $e3613f6017c674c5$var$fontWeights,
        letterSpacing: $e3613f6017c674c5$var$letterSpacing,
        lineHeights: $e3613f6017c674c5$var$lineHeights,
        opacity: $e3613f6017c674c5$var$opacity,
        paragraphSpacing: $e3613f6017c674c5$var$paragraphSpacing,
        semantic: $e3613f6017c674c5$var$semantic,
        sizing: $e3613f6017c674c5$var$sizing,
        spacing: $e3613f6017c674c5$var$spacing,
        textCase: $e3613f6017c674c5$var$textCase,
        textDecoration: $e3613f6017c674c5$var$textDecoration,
        typography: $e3613f6017c674c5$var$typography,
        layout: $e3613f6017c674c5$var$layout,
        shadows: $e3613f6017c674c5$var$shadows,
        transitions: $e3613f6017c674c5$var$transitions,
        transitionsDuration: $e3613f6017c674c5$var$transitionsDuration
    },
    getComponentTokens: $e3613f6017c674c5$var$getComponentTokens
};
const $e3613f6017c674c5$var$accordionlist_base_container_width = "{size.max}";
const $e3613f6017c674c5$var$AccordionListTokens = {
    "accordionlist_base_root-container_flex-direction": "{flexDirection.column}",
    "accordionlist_base_root-container_width": "{size.max}",
    "accordionlist_base_container_flex-direction": "{flexDirection.column}",
    accordionlist_base_container_width: $e3613f6017c674c5$var$accordionlist_base_container_width
};
const $e3613f6017c674c5$var$avatar_base_container_width$1 = "{xl}";
const $e3613f6017c674c5$var$avatar_base_container_height$1 = "{xl}";
const $e3613f6017c674c5$var$avatar_variant_size_small_container_width$1 = "{l}";
const $e3613f6017c674c5$var$avatar_variant_size_small_container_height$1 = "{l}";
const $e3613f6017c674c5$var$avatar_variant_size_large_container_width$1 = "{xxl}";
const $e3613f6017c674c5$var$avatar_variant_size_large_container_height$1 = "{xxl}";
const $e3613f6017c674c5$var$avatar_base_container_opacity$1 = "{opacity.enabled}";
const $e3613f6017c674c5$var$avatar_variant_disabled_true_container_opacity$1 = "{opacity.disabled}";
const $e3613f6017c674c5$var$avatar_combination_true_image_container_behavior_hover_opacity = "{opacity.disabled}";
const $e3613f6017c674c5$var$avatar_combination_true_image_container_behavior_focus_opacity = "{opacity.disabled}";
const $e3613f6017c674c5$var$AvatarTokens = {
    avatar_base_container_width: $e3613f6017c674c5$var$avatar_base_container_width$1,
    avatar_base_container_height: $e3613f6017c674c5$var$avatar_base_container_height$1,
    "avatar_base_container_flex-direction": "{flexDirection.row}",
    "avatar_base_container_justify-content": "{justifyContent.center}",
    "avatar_base_container_align-items": "{alignItems.center}",
    "avatar_base_container_background-color": "{primary20}",
    "avatar_base_container_border-radius": "{pill}",
    "avatar_base_container_border-width": "{border_none}",
    "avatar_base_container_border-color": "{primary80}",
    "avatar_variant_size_xtra-small_container_width": "{m}",
    "avatar_variant_size_xtra-small_container_height": "{m}",
    avatar_variant_size_small_container_width: $e3613f6017c674c5$var$avatar_variant_size_small_container_width$1,
    avatar_variant_size_small_container_height: $e3613f6017c674c5$var$avatar_variant_size_small_container_height$1,
    avatar_variant_size_large_container_width: $e3613f6017c674c5$var$avatar_variant_size_large_container_width$1,
    avatar_variant_size_large_container_height: $e3613f6017c674c5$var$avatar_variant_size_large_container_height$1,
    "avatar_variant_size_xtra-xtra-large_container_width": "{custom_1}",
    "avatar_variant_size_xtra-xtra-large_container_height": "{custom_1}",
    avatar_base_container_opacity: $e3613f6017c674c5$var$avatar_base_container_opacity$1,
    avatar_variant_disabled_true_container_opacity: $e3613f6017c674c5$var$avatar_variant_disabled_true_container_opacity$1,
    "avatar_variant_kind_initials_container_background-color": "{sparkle20}",
    "avatar_combination_true_icon_container_behavior_focus_border-width": "{border_focus}",
    "avatar_combination_true_initials_container_behavior_hover_background-color": "{sparkle40}",
    "avatar_combination_true_initials_container_behavior_focus_border-width": "{border_focus}",
    "avatar_combination_true_initials_container_behavior_focus_background-color": "{sparkle40}",
    avatar_combination_true_image_container_behavior_hover_opacity: $e3613f6017c674c5$var$avatar_combination_true_image_container_behavior_hover_opacity,
    "avatar_combination_true_image_container_behavior_focus_border-width": "{border_focus}",
    avatar_combination_true_image_container_behavior_focus_opacity: $e3613f6017c674c5$var$avatar_combination_true_image_container_behavior_focus_opacity
};
const $e3613f6017c674c5$var$avatar_base_container_width = "{xl}";
const $e3613f6017c674c5$var$avatar_base_container_height = "{xl}";
const $e3613f6017c674c5$var$avatar_base_container_opacity = "{opacity.enabled}";
const $e3613f6017c674c5$var$avatar_base_icon_size = "{custom_3}";
const $e3613f6017c674c5$var$avatar_base_icon_color = "{primary60}";
const $e3613f6017c674c5$var$avatar_base_icon_behavior_hover_color = "{primary50}";
const $e3613f6017c674c5$var$avatar_base_icon_behavior_active_color = "{primary70}";
const $e3613f6017c674c5$var$avatar_variant_size_small_container_width = "{l}";
const $e3613f6017c674c5$var$avatar_variant_size_small_container_height = "{l}";
const $e3613f6017c674c5$var$avatar_variant_size_large_container_width = "{xxl}";
const $e3613f6017c674c5$var$avatar_variant_size_large_container_height = "{xxl}";
const $e3613f6017c674c5$var$avatar_variant_size_small_icon_size = "{m}";
const $e3613f6017c674c5$var$avatar_variant_size_large_icon_size = "{l}";
const $e3613f6017c674c5$var$avatar_variant_disabled_true_container_opacity = "{opacity.disabled}";
const $e3613f6017c674c5$var$avatar_variant_kind_image_jds_image_behavior_hover_opacity = "{opacity.disabled}";
const $e3613f6017c674c5$var$avatar_variant_kind_image_jds_image_behavior_active_opacity = "{opacity.disabled}";
const $e3613f6017c674c5$var$AvatarV2DefaultTokens = {
    avatar_base_container_width: $e3613f6017c674c5$var$avatar_base_container_width,
    avatar_base_container_height: $e3613f6017c674c5$var$avatar_base_container_height,
    "avatar_base_container_flex-direction": "{flexDirection.row}",
    "avatar_base_container_justify-content": "{justifyContent.center}",
    "avatar_base_container_align-items": "{alignItems.center}",
    "avatar_base_container_background-color": "{primary20}",
    "avatar_base_container_border-radius": "{pill}",
    "avatar_base_container_border-width": "{border_none}",
    "avatar_base_container_border-color": "{primary60}",
    avatar_base_container_opacity: $e3613f6017c674c5$var$avatar_base_container_opacity,
    "avatar_base_container_behavior_active_background-color": "{primary30}",
    "avatar_base_container_behavior_focus_border-width": "{border_focus}",
    avatar_base_icon_size: $e3613f6017c674c5$var$avatar_base_icon_size,
    avatar_base_icon_color: $e3613f6017c674c5$var$avatar_base_icon_color,
    avatar_base_icon_behavior_hover_color: $e3613f6017c674c5$var$avatar_base_icon_behavior_hover_color,
    avatar_base_icon_behavior_active_color: $e3613f6017c674c5$var$avatar_base_icon_behavior_active_color,
    "avatar_variant_size_xtra-small_container_width": "{m}",
    "avatar_variant_size_xtra-small_container_height": "{m}",
    avatar_variant_size_small_container_width: $e3613f6017c674c5$var$avatar_variant_size_small_container_width,
    avatar_variant_size_small_container_height: $e3613f6017c674c5$var$avatar_variant_size_small_container_height,
    avatar_variant_size_large_container_width: $e3613f6017c674c5$var$avatar_variant_size_large_container_width,
    avatar_variant_size_large_container_height: $e3613f6017c674c5$var$avatar_variant_size_large_container_height,
    "avatar_variant_size_xtra-large_container_width": "{custom_11}",
    "avatar_variant_size_xtra-large_container_height": "{custom_11}",
    "avatar_variant_size_xtra-xtra-large_container_width": "{custom_1}",
    "avatar_variant_size_xtra-xtra-large_container_height": "{custom_1}",
    "avatar_variant_size_xtra-small_icon_size": "{base}",
    avatar_variant_size_small_icon_size: $e3613f6017c674c5$var$avatar_variant_size_small_icon_size,
    avatar_variant_size_large_icon_size: $e3613f6017c674c5$var$avatar_variant_size_large_icon_size,
    "avatar_variant_size_xtra-large_icon_size": "{xl}",
    "avatar_variant_size_xtra-xtra-large_icon_size": "{xxl}",
    avatar_variant_disabled_true_container_opacity: $e3613f6017c674c5$var$avatar_variant_disabled_true_container_opacity,
    "avatar_variant_kind_initials_container_background-color": "{sparkle20}",
    avatar_variant_kind_image_jds_image_behavior_hover_opacity: $e3613f6017c674c5$var$avatar_variant_kind_image_jds_image_behavior_hover_opacity,
    "avatar_variant_kind_image_container_behavior_hover_background-color": "{primaryBackground}",
    avatar_variant_kind_image_jds_image_behavior_active_opacity: $e3613f6017c674c5$var$avatar_variant_kind_image_jds_image_behavior_active_opacity,
    "avatar_variant_kind_image_container_behavior_active_background-color": "{primaryGrey80}"
};
const $e3613f6017c674c5$var$actionbutton_base_container_opacity = "{opacity.enabled}";
const $e3613f6017c674c5$var$actionbutton_base_loader_color = "{primary50}";
const $e3613f6017c674c5$var$actionbutton_base_loader_opacity = "{opacity.enabled}";
const $e3613f6017c674c5$var$actionbutton_base_loader_size = "{m}";
const $e3613f6017c674c5$var$actionbutton_variant_size_small_loader_size = "{m}";
const $e3613f6017c674c5$var$actionbutton_variant_size_large_loader_size = "{m}";
const $e3613f6017c674c5$var$actionbutton_variant_state_loading_jds_text_opacity = "{opacity.invisible}";
const $e3613f6017c674c5$var$actionbutton_combination_false_small_loader_size = "{base}";
const $e3613f6017c674c5$var$actionbutton_combination_false_large_loader_size = "{m}";
const $e3613f6017c674c5$var$actionbutton_combination_true_true_container_width = "{size.max}";
const $e3613f6017c674c5$var$ActionButtonTokens = {
    "actionbutton_base_container_background-color": "{global.transparent}",
    actionbutton_base_container_opacity: $e3613f6017c674c5$var$actionbutton_base_container_opacity,
    "actionbutton_base_container_flex-direction": "{flexDirection.stack}",
    "actionbutton_base_container_align-items": "{alignItems.center}",
    "actionbutton_base_container_justify-content": "{justifyContent.center}",
    "actionbutton_base_container_border-radius": "{pill}",
    "actionbutton_base_inner-container_background-color": "{primary50}",
    "actionbutton_base_inner-container_flex-direction": "{flexDirection.row}",
    "actionbutton_base_inner-container_align-items": "{alignItems.center}",
    "actionbutton_base_inner-container_justify-content": "{justifyContent.center}",
    "actionbutton_base_inner-container_border-radius": "{pill}",
    "actionbutton_base_inner-container_padding-top": "{xs}",
    "actionbutton_base_inner-container_padding-right": "{base}",
    "actionbutton_base_inner-container_padding-bottom": "{xs}",
    "actionbutton_base_inner-container_padding-left": "{base}",
    "actionbutton_base_inner-container_gap": "{xs}",
    "actionbutton_base_inner-container_behavior_hover_background-color": "{primary30}",
    "actionbutton_base_inner-container_behavior_active_background-color": "{primary60}",
    "actionbutton_base_inner-container_behavior_focus_border-width": "{border_focus}",
    "actionbutton_base_inner-container_behavior_focus_border-color": "{primary60}",
    actionbutton_base_loader_color: $e3613f6017c674c5$var$actionbutton_base_loader_color,
    "actionbutton_base_loader_background-color": "{global.transparent}",
    "actionbutton_base_loader_track-color": "{primaryGrey40}",
    "actionbutton_base_loader_border-width": "{border_focus}",
    "actionbutton_base_inner-container_border-width": "{border_none}",
    actionbutton_base_loader_opacity: $e3613f6017c674c5$var$actionbutton_base_loader_opacity,
    actionbutton_base_loader_size: $e3613f6017c674c5$var$actionbutton_base_loader_size,
    "actionbutton_base_left-icon_size": "{m}",
    "actionbutton_base_left-icon_color": "{primaryInverse}",
    "actionbutton_base_left-icon_behavior_hover_color": "{primary70}",
    "actionbutton_base_left-icon_behavior_active_color": "{primaryInverse}",
    "actionbutton_base_right-icon_size": "{m}",
    "actionbutton_base_right-icon_color": "{primaryInverse}",
    "actionbutton_base_right-icon_behavior_hover_color": "{primary70}",
    "actionbutton_base_right-icon_behavior_active_color": "{primaryInverse}",
    "actionbutton_variant_size_small_inner-container_padding-top": "{xxs}",
    "actionbutton_variant_size_small_inner-container_padding-right": "{s}",
    "actionbutton_variant_size_small_inner-container_padding-bottom": "{xxs}",
    "actionbutton_variant_size_small_inner-container_padding-left": "{s}",
    "actionbutton_variant_size_small_inner-container_gap": "{xxs}",
    "actionbutton_variant_size_small_left-icon_size": "{base}",
    "actionbutton_variant_size_small_right-icon_size": "{base}",
    actionbutton_variant_size_small_loader_size: $e3613f6017c674c5$var$actionbutton_variant_size_small_loader_size,
    "actionbutton_variant_size_large_inner-container_padding-top": "{s}",
    "actionbutton_variant_size_large_inner-container_padding-left": "{m}",
    "actionbutton_variant_size_large_inner-container_padding-bottom": "{s}",
    "actionbutton_variant_size_large_inner-container_padding-right": "{m}",
    "actionbutton_variant_size_large_inner-container_gap": "{xs}",
    "actionbutton_variant_size_large_left-icon_size": "{m}",
    "actionbutton_variant_size_large_right-icon_size": "{m}",
    actionbutton_variant_size_large_loader_size: $e3613f6017c674c5$var$actionbutton_variant_size_large_loader_size,
    "actionbutton_variant_size_extra-large_inner-container_padding-top": "{base}",
    "actionbutton_variant_size_extra-large_inner-container_padding-right": "{l}",
    "actionbutton_variant_size_extra-large_inner-container_padding-bottom": "{base}",
    "actionbutton_variant_size_extra-large_inner-container_padding-left": "{l}",
    "actionbutton_variant_size_extra-large_inner-container_gap": "{xs}",
    "actionbutton_variant_size_extra-large_left-icon_size": "{l}",
    "actionbutton_variant_size_extra-large_right-icon_size": "{l}",
    "actionbutton_variant_size_extra-large_loader_size": "{xxl}",
    "actionbutton_variant_state_loading_inner-container_opacity": "{opacity.disabled}",
    "actionbutton_variant_state_loading_left-icon_opacity": "{opacity.invisible}",
    "actionbutton_variant_state_loading_right-icon_opacity": "{opacity.invisible}",
    actionbutton_variant_state_loading_jds_text_opacity: $e3613f6017c674c5$var$actionbutton_variant_state_loading_jds_text_opacity,
    "actionbutton_variant_state_disabled_inner-container_opacity": "{opacity.disabled}",
    "actionbutton_base_inner-container_opacity": "{opacity.enabled}",
    "actionbutton_combination_normal_secondary_inner-container_background-color": "{global.transparent}",
    "actionbutton_combination_normal_secondary_inner-container_border-width": "{border_thin}",
    "actionbutton_combination_normal_secondary_inner-container_border-color": "{primaryGrey60}",
    "actionbutton_combination_normal_secondary_inner-container_behavior_hover_background-color": "{primary20}",
    "actionbutton_combination_normal_secondary_inner-container_behavior_active_background-color": "{primary30}",
    "actionbutton_combination_normal_secondary_inner-container_behavior_focus_border-width": "{border_focus}",
    "actionbutton_combination_normal_secondary_inner-container_behavior_focus_border-color": "{primary60}",
    "actionbutton_combination_normal_secondary_left-icon_color": "{primary60}",
    "actionbutton_combination_normal_secondary_left-icon_behavior_hover_color": "{primary60}",
    "actionbutton_combination_normal_secondary_left-icon_behavior_active_color": "{primary70}",
    "actionbutton_combination_normal_secondary_right-icon_color": "{primary60}",
    "actionbutton_combination_normal_secondary_right-icon_behavior_hover_color": "{primary60}",
    "actionbutton_combination_normal_secondary_right-icon_behavior_active_color": "{primary70}",
    "actionbutton_combination_normal_tertiary_inner-container_padding-left": "{custom_5}",
    "actionbutton_combination_normal_tertiary_inner-container_padding-right": "{custom_5}",
    "actionbutton_combination_positive_tertiary_inner-container_padding-left": "{custom_5}",
    "actionbutton_combination_positive_tertiary_inner-container_padding-right": "{custom_5}",
    "actionbutton_combination_normal_tertiary_inner-container_background-color": "{global.transparent}",
    "actionbutton_combination_normal_tertiary_inner-container_behavior_hover_background-color": "{primary20}",
    "actionbutton_combination_normal_tertiary_inner-container_behavior_active_background-color": "{primary30}",
    "actionbutton_combination_normal_tertiary_inner-container_behavior_focus_border-width": "{border_focus}",
    "actionbutton_combination_normal_tertiary_inner-container_behavior_focus_border-radius": "{custom_1}",
    "actionbutton_combination_normal_tertiary_inner-container_behavior_focus_border-color": "{primary60}",
    "actionbutton_combination_normal_tertiary_left-icon_color": "{primary60}",
    "actionbutton_combination_normal_tertiary_left-icon_behavior_hover_color": "{primary50}",
    "actionbutton_combination_normal_tertiary_left-icon_behavior_active_color": "{primary70}",
    "actionbutton_combination_normal_tertiary_right-icon_color": "{primary60}",
    "actionbutton_combination_normal_tertiary_right-icon_behavior_hover_color": "{primary50}",
    "actionbutton_combination_normal_tertiary_right-icon_behavior_active_color": "{primary70}",
    "actionbutton_combination_positive_primary_inner-container_background-color": "{feedbackSuccess50}",
    "actionbutton_combination_positive_primary_inner-container_behavior_hover_background-color": "{feedbackSuccess20}",
    "actionbutton_combination_positive_primary_inner-container_behavior_active_background-color": "{feedbackSuccess80}",
    "actionbutton_combination_positive_primary_inner-container_behavior_focus_border-color": "{primary60}",
    "actionbutton_combination_positive_primary_left-icon_color": "{global.white}",
    "actionbutton_combination_positive_primary_left-icon_behavior_hover_color": "{feedbackSuccess80}",
    "actionbutton_combination_positive_primary_left-icon_behavior_active_color": "{primaryBackground}",
    "actionbutton_combination_positive_primary_right-icon_color": "{global.white}",
    "actionbutton_combination_positive_primary_right-icon_behavior_hover_color": "{feedbackSuccess80}",
    "actionbutton_combination_positive_primary_right-icon_behavior_active_color": "{primaryBackground}",
    "actionbutton_combination_positive_secondary_inner-container_background-color": "{global.transparent}",
    "actionbutton_combination_positive_secondary_inner-container_border-width": "{border_thin}",
    "actionbutton_combination_positive_secondary_inner-container_border-color": "{primaryGrey60}",
    "actionbutton_combination_positive_secondary_inner-container_behavior_hover_background-color": "{feedbackSuccess20}",
    "actionbutton_combination_positive_secondary_inner-container_behavior_active_background-color": "{feedbackSuccess80}",
    "actionbutton_combination_positive_secondary_inner-container_behavior_focus_border-color": "{primary60}",
    "actionbutton_combination_positive_secondary_left-icon_color": "{feedbackSuccess80}",
    "actionbutton_combination_positive_secondary_left-icon_behavior_hover_color": "{feedbackSuccess80}",
    "actionbutton_combination_positive_secondary_left-icon_behavior_active_color": "{primaryBackground}",
    "actionbutton_combination_positive_secondary_right-icon_color": "{feedbackSuccess80}",
    "actionbutton_combination_positive_secondary_right-icon_behavior_hover_color": "{feedbackSuccess80}",
    "actionbutton_combination_positive_secondary_right-icon_behavior_active_color": "{primaryBackground}",
    "actionbutton_combination_positive_tertiary_inner-container_background-color": "{global.transparent}",
    "actionbutton_combination_positive_tertiary_inner-container_border-radius": "{custom_1}",
    "actionbutton_combination_positive_tertiary_inner-container_behavior_hover_background-color": "{feedbackSuccess20}",
    "actionbutton_combination_positive_tertiary_inner-container_behavior_active_background-color": "{feedbackSuccess80}",
    "actionbutton_combination_positive_tertiary_inner-container_behavior_focus_border-color": "{primary60}",
    "actionbutton_combination_positive_tertiary_left-icon_color": "{feedbackSuccess80}",
    "actionbutton_combination_positive_tertiary_left-icon_behavior_hover_color": "{feedbackSuccess50}",
    "actionbutton_combination_positive_tertiary_left-icon_behavior_active_color": "{primaryGrey100}",
    "actionbutton_combination_positive_tertiary_right-icon_color": "{feedbackSuccess80}",
    "actionbutton_combination_positive_tertiary_right-icon_behavior_hover_color": "{feedbackSuccess50}",
    "actionbutton_combination_positive_tertiary_right-icon_behavior_active_color": "{primaryGrey100}",
    "actionbutton_combination_negative_tertiary_inner-container_padding-left": "{custom_5}",
    "actionbutton_combination_negative_tertiary_inner-container_padding-right": "{custom_5}",
    "actionbutton_combination_negative_primary_inner-container_background-color": "{feedbackError50}",
    "actionbutton_combination_negative_primary_inner-container_behavior_hover_background-color": "{feedbackError20}",
    "actionbutton_combination_negative_primary_inner-container_behavior_active_background-color": "{feedbackError80}",
    "actionbutton_combination_negative_primary_inner-container_behavior_focus_border-color": "{primary60}",
    "actionbutton_combination_negative_primary_left-icon_color": "{global.white}",
    "actionbutton_combination_negative_primary_left-icon_behavior_hover_color": "{feedbackError80}",
    "actionbutton_combination_negative_primary_left-icon_behavior_active_color": "{primaryBackground}",
    "actionbutton_combination_negative_primary_right-icon_color": "{global.white}",
    "actionbutton_combination_negative_primary_right-icon_behavior_hover_color": "{feedbackError80}",
    "actionbutton_combination_negative_primary_right-icon_behavior_active_color": "{primaryBackground}",
    "actionbutton_combination_negative_secondary_inner-container_background-color": "{global.transparent}",
    "actionbutton_combination_negative_secondary_inner-container_border-width": "{border_thin}",
    "actionbutton_combination_negative_secondary_inner-container_border-color": "{primaryGrey60}",
    "actionbutton_combination_negative_secondary_inner-container_behavior_hover_background-color": "{feedbackError20}",
    "actionbutton_combination_negative_secondary_inner-container_behavior_active_background-color": "{feedbackError80}",
    "actionbutton_combination_negative_secondary_inner-container_behavior_focus_border-color": "{primary60}",
    "actionbutton_combination_negative_secondary_left-icon_color": "{feedbackError80}",
    "actionbutton_combination_negative_secondary_left-icon_behavior_hover_color": "{feedbackError80}",
    "actionbutton_combination_negative_secondary_left-icon_behavior_active_color": "{primaryBackground}",
    "actionbutton_combination_negative_secondary_right-icon_color": "{feedbackError80}",
    "actionbutton_combination_negative_secondary_right-icon_behavior_hover_color": "{feedbackError80}",
    "actionbutton_combination_negative_secondary_right-icon_behavior_active_color": "{primaryBackground}",
    "actionbutton_combination_negative_tertiary_inner-container_background-color": "{global.transparent}",
    "actionbutton_combination_negative_tertiary_inner-container_border-radius": "{pill}",
    "actionbutton_combination_negative_tertiary_inner-container_behavior_hover_background-color": "{feedbackError20}",
    "actionbutton_combination_negative_tertiary_inner-container_behavior_active_background-color": "{feedbackError80}",
    "actionbutton_combination_negative_tertiary_inner-container_behavior_focus_border-color": "{primary60}",
    "actionbutton_combination_negative_tertiary_left-icon_color": "{feedbackError80}",
    "actionbutton_combination_negative_tertiary_left-icon_behavior_hover_color": "{feedbackError50}",
    "actionbutton_combination_negative_tertiary_left-icon_behavior_active_color": "{primaryGrey100}",
    "actionbutton_combination_negative_tertiary_right-icon_color": "{feedbackError80}",
    "actionbutton_combination_negative_tertiary_right-icon_behavior_hover_color": "{feedbackError50}",
    "actionbutton_combination_negative_tertiary_right-icon_behavior_active_color": "{primaryGrey100}",
    "actionbutton_combination_contrast_tertiary_inner-container_padding-left": "{custom_5}",
    "actionbutton_combination_contrast_tertiary_inner-container_padding-right": "{custom_5}",
    "actionbutton_combination_contrast_primary_inner-container_background-color": "{primaryBackground}",
    "actionbutton_combination_contrast_primary_inner-container_behavior_hover_background-color": "{primary20}",
    "actionbutton_combination_contrast_primary_inner-container_behavior_active_background-color": "{primary30}",
    "actionbutton_combination_contrast_primary_inner-container_behavior_focus_border-color": "{primary50}",
    "actionbutton_combination_contrast_primary_left-icon_color": "{primaryGrey100}",
    "actionbutton_combination_contrast_primary_left-icon_behavior_hover_color": "{primaryGrey100}",
    "actionbutton_combination_contrast_primary_left-icon_behavior_active_color": "{primaryGrey100}",
    "actionbutton_combination_contrast_primary_right-icon_color": "{primaryGrey100}",
    "actionbutton_combination_contrast_primary_right-icon_behavior_hover_color": "{primaryGrey100}",
    "actionbutton_combination_contrast_primary_right-icon_behavior_active_color": "{primaryGrey100}",
    "actionbutton_combination_contrast_secondary_inner-container_background-color": "{global.transparent}",
    "actionbutton_combination_contrast_secondary_inner-container_border-width": "{border_thin}",
    "actionbutton_combination_contrast_secondary_inner-container_border-color": "{primaryGrey60}",
    "actionbutton_combination_contrast_secondary_inner-container_behavior_hover_background-color": "{primary20}",
    "actionbutton_combination_contrast_secondary_inner-container_behavior_active_background-color": "{primary30}",
    "actionbutton_combination_contrast_secondary_inner-container_behavior_focus_border-width": "{border_focus}",
    "actionbutton_combination_contrast_secondary_inner-container_behavior_focus_border-color": "{primary50}",
    "actionbutton_combination_contrast_secondary_left-icon_color": "{primaryBackground}",
    "actionbutton_combination_contrast_secondary_left-icon_behavior_hover_color": "{primaryGrey100}",
    "actionbutton_combination_contrast_secondary_left-icon_behavior_active_color": "{primaryGrey100}",
    "actionbutton_combination_contrast_secondary_right-icon_color": "{primaryBackground}",
    "actionbutton_combination_contrast_secondary_right-icon_behavior_hover_color": "{primaryGrey100}",
    "actionbutton_combination_contrast_secondary_right-icon_behavior_active_color": "{primaryGrey100}",
    "actionbutton_combination_contrast_tertiary_inner-container_background-color": "{global.transparent}",
    "actionbutton_combination_contrast_tertiary_inner-container_border-radius": "{pill}",
    "actionbutton_combination_contrast_tertiary_inner-container_behavior_hover_background-color": "{primary20}",
    "actionbutton_combination_contrast_tertiary_inner-container_behavior_active_background-color": "{primary30}",
    "actionbutton_combination_contrast_tertiary_inner-container_behavior_focus_border-width": "{border_focus}",
    "actionbutton_combination_contrast_tertiary_inner-container_behavior_focus_border-color": "{primary50}",
    "actionbutton_combination_contrast_tertiary_left-icon_color": "{primaryBackground}",
    "actionbutton_combination_contrast_tertiary_left-icon_behavior_hover_color": "{primaryGrey100}",
    "actionbutton_combination_contrast_tertiary_left-icon_behavior_active_color": "{primaryGrey100}",
    "actionbutton_combination_contrast_tertiary_right-icon_color": "{primaryBackground}",
    "actionbutton_combination_contrast_tertiary_right-icon_behavior_hover_color": "{primaryGrey100}",
    "actionbutton_combination_contrast_tertiary_right-icon_behavior_active_color": "{primaryGrey100}",
    "actionbutton_combination_false_small_left-icon_size": "{base}",
    actionbutton_combination_false_small_loader_size: $e3613f6017c674c5$var$actionbutton_combination_false_small_loader_size,
    "actionbutton_combination_false_large_left-icon_size": "{m}",
    actionbutton_combination_false_large_loader_size: $e3613f6017c674c5$var$actionbutton_combination_false_large_loader_size,
    "actionbutton_combination_false_extra-large_left-icon_size": "{l}",
    "actionbutton_combination_false_extra-large_loader_size": "{l}",
    actionbutton_combination_true_true_container_width: $e3613f6017c674c5$var$actionbutton_combination_true_true_container_width,
    "actionbutton_combination_true_true_inner-container_width": "{size.max}"
};
const $e3613f6017c674c5$var$accordion_base_container_width = "{size.max}";
const $e3613f6017c674c5$var$accordion_base_container_opacity = "{opacity.enabled}";
const $e3613f6017c674c5$var$accordion_variant_disabled_true_container_opacity = "{opacity.disabled}";
const $e3613f6017c674c5$var$accordion_combination_plus_true_jds_button_icon = "ic_minus";
const $e3613f6017c674c5$var$accordion_combination_plus_false_jds_button_icon = "ic_add";
const $e3613f6017c674c5$var$accordion_combination_chevron_true_jds_button_icon = "ic_chevron_up";
const $e3613f6017c674c5$var$accordion_combination_chevron_false_jds_button_icon = "ic_chevron_down";
const $e3613f6017c674c5$var$AccordionTokens = {
    "accordion_base_container_flex-direction": "{flexDirection.column}",
    accordion_base_container_width: $e3613f6017c674c5$var$accordion_base_container_width,
    "accordion_base_accordion-header-container_flex-direction": "{flexDirection.row}",
    "accordion_base_accordion-header-container_align-items": "{alignItems.center}",
    "accordion_base_accordion-header-container_justify-content": "{justifyContent.start}",
    "accordion_base_accordion-header-container_width": "{size.max}",
    "accordion_base_accordion-header-container_padding-top": "{xxs}",
    "accordion_base_accordion-header-container_gap": "{s}",
    "accordion_base_text-container_flex-direction": "{flexDirection.column}",
    "accordion_base_text-container_justify-content": "{justifyContent.start}",
    "accordion_base_text-container_align-items": "{alignItems.start}",
    "accordion_base_text-container_gap": "{xxs}",
    "accordion_base_children-container_padding-top": "0",
    "accordion_base_children-container_width": "{size.max}",
    "accordion_base_child-content-container_width": "{size.max}",
    accordion_base_container_opacity: $e3613f6017c674c5$var$accordion_base_container_opacity,
    "accordion_variant_expandedPanel_true_children-container_padding-top": "{base}",
    accordion_variant_disabled_true_container_opacity: $e3613f6017c674c5$var$accordion_variant_disabled_true_container_opacity,
    accordion_combination_plus_true_jds_button_icon: $e3613f6017c674c5$var$accordion_combination_plus_true_jds_button_icon,
    accordion_combination_plus_false_jds_button_icon: $e3613f6017c674c5$var$accordion_combination_plus_false_jds_button_icon,
    accordion_combination_chevron_true_jds_button_icon: $e3613f6017c674c5$var$accordion_combination_chevron_true_jds_button_icon,
    accordion_combination_chevron_false_jds_button_icon: $e3613f6017c674c5$var$accordion_combination_chevron_false_jds_button_icon
};
const $e3613f6017c674c5$var$badge_base_container_gap = "{xxs}";
const $e3613f6017c674c5$var$badge_base_icon_size = "{base}";
const $e3613f6017c674c5$var$badge_base_icon_color = "{sparkleGrey20}";
const $e3613f6017c674c5$var$badge_base_text_color = "{sparkleGrey20}";
const $e3613f6017c674c5$var$badge_variant_kind_service_container_gap = "{xs}";
const $e3613f6017c674c5$var$badge_variant_kind_service_text_color = "{global.white}";
const $e3613f6017c674c5$var$badge_variant_kind_service_icon_size = "{m}";
const $e3613f6017c674c5$var$badge_variant_kind_service_icon_color = "{custom_color_1}";
const $e3613f6017c674c5$var$badge_combination_normal_small_icon_size = "{s}";
const $e3613f6017c674c5$var$badge_combination_normal_large_container_gap = "{xs}";
const $e3613f6017c674c5$var$badge_combination_normal_large_icon_size = "{m}";
const $e3613f6017c674c5$var$BadgeTokens = {
    "badge_base_container_flex-direction": "{flexDirection.row}",
    "badge_base_container_justify-content": "{justifyContent.center}",
    "badge_base_container_align-items": "{alignItems.center}",
    "badge_base_container_padding-top": "{xxs}",
    "badge_base_container_padding-left": "{xs}",
    "badge_base_container_padding-right": "{xs}",
    "badge_base_container_padding-bottom": "{xxs}",
    badge_base_container_gap: $e3613f6017c674c5$var$badge_base_container_gap,
    "badge_base_container_background-color": "{sparkle60}",
    "badge_base_container_border-radius": "{medium}",
    badge_base_icon_size: $e3613f6017c674c5$var$badge_base_icon_size,
    badge_base_icon_color: $e3613f6017c674c5$var$badge_base_icon_color,
    "badge_base_icon_justify-content": "{justifyContent.start}",
    "badge_base_icon_align-items": "{alignItems.start}",
    "badge_base_text_font-family": "{bodySBold}",
    "badge_base_text_font-size": "{bodySBold}",
    "badge_base_text_line-height": "{bodySBold}",
    "badge_base_text_letter-spacing": "{bodySBold}",
    "badge_base_text_font-weight": "{bodySBold}",
    badge_base_text_color: $e3613f6017c674c5$var$badge_base_text_color,
    "badge_base_text_text-transform": "{text-case.uppercase}",
    "badge_variant_kind_service_container_border-radius": "{pill}",
    "badge_variant_kind_service_container_background-color": "{custom_color_2}",
    "badge_variant_kind_service_container_padding-top": "{xxs}",
    "badge_variant_kind_service_container_padding-left": "{xxs}",
    "badge_variant_kind_service_container_padding-right": "{s}",
    "badge_variant_kind_service_container_padding-bottom": "{xxs}",
    badge_variant_kind_service_container_gap: $e3613f6017c674c5$var$badge_variant_kind_service_container_gap,
    "badge_variant_kind_service_text_font-family": "{bodyMBold}",
    "badge_variant_kind_service_text_font-size": "{bodyMBold}",
    "badge_variant_kind_service_text_line-height": "{bodyMBold}",
    "badge_variant_kind_service_text_letter-spacing": "{bodyMBold}",
    "badge_variant_kind_service_text_font-weight": "{bodyMBold}",
    badge_variant_kind_service_text_color: $e3613f6017c674c5$var$badge_variant_kind_service_text_color,
    badge_variant_kind_service_icon_size: $e3613f6017c674c5$var$badge_variant_kind_service_icon_size,
    badge_variant_kind_service_icon_color: $e3613f6017c674c5$var$badge_variant_kind_service_icon_color,
    "badge_combination_normal_small_container_border-radius": "{small}",
    badge_combination_normal_small_icon_size: $e3613f6017c674c5$var$badge_combination_normal_small_icon_size,
    "badge_combination_normal_small_text_font-family": "{bodyXxsBold}",
    "badge_combination_normal_small_text_font-size": "{bodyXxsBold}",
    "badge_combination_normal_small_text_line-height": "{bodyXxsBold}",
    "badge_combination_normal_small_text_letter-spacing": "{bodyXxsBold}",
    "badge_combination_normal_small_text_font-weight": "{bodyXxsBold}",
    "badge_combination_normal_large_container_padding-left": "{s}",
    "badge_combination_normal_large_container_padding-right": "{s}",
    badge_combination_normal_large_container_gap: $e3613f6017c674c5$var$badge_combination_normal_large_container_gap,
    badge_combination_normal_large_icon_size: $e3613f6017c674c5$var$badge_combination_normal_large_icon_size,
    "badge_combination_normal_large_text_font-family": "{bodyLBold}",
    "badge_combination_normal_large_text_font-size": "{bodyLBold}",
    "badge_combination_normal_large_text_line-height": "{bodyLBold}",
    "badge_combination_normal_large_text_letter-spacing": "{bodyLBold}",
    "badge_combination_normal_large_text_font-weight": "{bodyLBold}"
};
const $e3613f6017c674c5$var$badgev2brand_base_container_gap = "{xxs}";
const $e3613f6017c674c5$var$badgev2brand_variant_kind_circle_container_padding = "{custom_5}";
const $e3613f6017c674c5$var$badgev2brand_variant_kind_square_container_padding = "{custom_5}";
const $e3613f6017c674c5$var$badgev2brand_combination_circle_medium_container_padding = "{custom_5}";
const $e3613f6017c674c5$var$badgev2brand_combination_circle_large_container_padding = "{custom_5}";
const $e3613f6017c674c5$var$badgev2brand_combination_square_medium_container_padding = "{custom_5}";
const $e3613f6017c674c5$var$badgev2brand_combination_square_large_container_padding = "{custom_5}";
const $e3613f6017c674c5$var$BadgeV2BrandTokens = {
    "badgev2brand_base_container_flex-direction": "{flexDirection.row}",
    "badgev2brand_base_container_justify-content": "{justifyContent.center}",
    "badgev2brand_base_container_align-items": "{alignItems.center}",
    "badgev2brand_base_container_background-color": "{primary50}",
    badgev2brand_base_container_gap: $e3613f6017c674c5$var$badgev2brand_base_container_gap,
    "badgev2brand_base_container_border-radius": "{pill}",
    "badgev2brand_base_container_padding-left": "{xs}",
    "badgev2brand_base_container_padding-right": "{s}",
    "badgev2brand_base_container_padding-top": "{xxs}",
    "badgev2brand_base_container_padding-bottom": "{xxs}",
    "badgev2brand_base_image-container_border-radius": "{pill}",
    "badgev2brand_base_image-container_size": "{custom_18}",
    "badgev2brand_variant_kind_square_image-container_border-radius": "{medium}",
    "badgev2brand_variant_kind_square-container_border-radius": "{medium}",
    "badgev2brand_variant_kind_square_brand-jds_image_border-radius": "{medium}",
    "badgev2brand_variant_kind_square-label_container_border-radius": "{medium}",
    "badgev2brand_variant_kind_square-label_image-container_border-radius": "{small}",
    "badgev2brand_variant_size_medium_container_padding-left": "{xxs}",
    "badgev2brand_variant_size_medium_container_padding-right": "{xxs}",
    "badgev2brand_variant_size_medium_container_padding-top": "{custom_5}",
    "badgev2brand_variant_size_medium_container_padding-bottom": "{custom_5}",
    "badgev2brand_variant_size_medium_image-container_size": "{s}",
    "badgev2brand_variant_size_large_container_padding-left": "{xxs}",
    "badgev2brand_variant_size_large_container_padding-right": "{xs}",
    "badgev2brand_variant_size_large_container_padding-top": "{custom_4}",
    "badgev2brand_variant_size_large_container_padding-bottom": "{custom_4}",
    "badgev2brand_variant_size_large_image-container_size": "{s}",
    "badgev2brand_variant_size_xtra-large_container_padding-left": "{xxs}",
    "badgev2brand_variant_size_xtra-large_container_padding-right": "{xs}",
    "badgev2brand_variant_size_xtra-large_container_padding-top": "{custom_4}",
    "badgev2brand_variant_size_xtra-large_container_padding-bottom": "{custom_4}",
    "badgev2brand_variant_size_xtra-large_image-container_size": "{base}",
    "badgev2brand_variant_size_xtra-xtra-large_container_padding-left": "{xxs}",
    "badgev2brand_variant_size_xtra-xtra-large_container_padding-right": "{xs}",
    "badgev2brand_variant_size_xtra-xtra-large_container_padding-top": "{xxs}",
    "badgev2brand_variant_size_xtra-xtra-large_container_padding-bottom": "{xxs}",
    "badgev2brand_variant_size_xtra-xtra-large_image-container_size": "{custom_18}",
    "badgev2brand_variant_size_xtra-xtra-xtra-xtra-large_container_padding": "{xs}",
    "badgev2brand_variant_size_xtra-xtra-xtra-xtra-large_image-container_size": "{custom_3}",
    "badgev2brand_variant_emphasis_bold_container_background-color": "{primary60}",
    badgev2brand_variant_kind_circle_container_padding: $e3613f6017c674c5$var$badgev2brand_variant_kind_circle_container_padding,
    badgev2brand_variant_kind_square_container_padding: $e3613f6017c674c5$var$badgev2brand_variant_kind_square_container_padding,
    badgev2brand_combination_circle_medium_container_padding: $e3613f6017c674c5$var$badgev2brand_combination_circle_medium_container_padding,
    "badgev2brand_combination_circle_medium_image-container_size": "{base}",
    badgev2brand_combination_circle_large_container_padding: $e3613f6017c674c5$var$badgev2brand_combination_circle_large_container_padding,
    "badgev2brand_combination_circle_large_image-container_size": "{custom_18}",
    "badgev2brand_combination_circle_xtra-large_container_padding": "{custom_5}",
    "badgev2brand_combination_circle_xtra-large_image-container_size": "{m}",
    "badgev2brand_combination_circle_xtra-xtra-large_container_padding": "{custom_5}",
    "badgev2brand_combination_circle_xtra-xtra-large_image-container_size": "{custom_3}",
    "badgev2brand_combination_circle_xtra-xtra-xtra-large_container_padding": "{custom_5}",
    "badgev2brand_combination_circle_xtra-xtra-xtra-large_image-container_size": "{l}",
    "badgev2brand_combination_circle_xtra-xtra-xtra-xtra-large_container_padding": "{custom_5}",
    "badgev2brand_combination_circle_xtra-xtra-xtra-xtra-large_image-container_size": "{xl}",
    "badgev2brand_combination_square_medium_container_border-radius": "{small}",
    badgev2brand_combination_square_medium_container_padding: $e3613f6017c674c5$var$badgev2brand_combination_square_medium_container_padding,
    "badgev2brand_combination_square_medium_image-container_size": "{base}",
    "badgev2brand_combination_square_medium_image-container_border-radius": "{small}",
    "badgev2brand_combination_square_large_container_border-radius": "{small}",
    badgev2brand_combination_square_large_container_padding: $e3613f6017c674c5$var$badgev2brand_combination_square_large_container_padding,
    "badgev2brand_combination_square_large_image-container_size": "{custom_18}",
    "badgev2brand_combination_square_large_image-container_border-radius": "{small}",
    "badgev2brand_combination_square_xtra-large_container_border-radius": "{small}",
    "badgev2brand_combination_square_xtra-large_container_padding": "{custom_5}",
    "badgev2brand_combination_square_xtra-large_image-container_size": "{m}",
    "badgev2brand_combination_square_xtra-large_image-container_border-radius": "{small}",
    "badgev2brand_combination_square_xtra-xtra-large_container_border-radius": "{small}",
    "badgev2brand_combination_square_xtra-xtra-large_container_padding": "{custom_5}",
    "badgev2brand_combination_square_xtra-xtra-large_image-container_size": "{custom_3}",
    "badgev2brand_combination_square_xtra-xtra-large_image-container_border-radius": "{small}",
    "badgev2brand_combination_square_xtra-xtra-xtra-large_image-container_size": "{l}",
    "badgev2brand_combination_square_xtra-xtra-xtra-xtra-large_image-container_size": "{xl}",
    "badgev2brand_combination_square-label_xtra-xtra-xtra-xtra-large_image-container_border-radius": "{medium}",
    "badgev2brand_combination_square-label_medium_container_border-radius": "{small}",
    "badgev2brand_combination_square-label_large_container_border-radius": "{small}",
    "badgev2brand_combination_square-label_large_container_padding-right": "{xxs}",
    "badgev2brand_combination_square-label_xtra-large_container_border-radius": "{small}",
    "badgev2brand_combination_square-label_xtra-large_container_padding-right": "{xxs}",
    "badgev2brand_combination_square-label_xtra-xtra-large_container_padding-left": "{xs}",
    "badgev2brand_combination_square-label_xtra-xtra-large_image-container_size": "{base}",
    "badgev2brand_combination_square-label_xtra-xtra-xtra-large_container_padding-right": "{xs}",
    "badgev2brand_combination_square-label_xtra-xtra-large_container_border-radius": "{small}",
    "badgev2brand_combination_square-label_xtra-xtra-xtra-xtra-large_container_padding-right": "{xs}"
};
const $e3613f6017c674c5$var$badgev2information_base_container_gap = "{xxs}";
const $e3613f6017c674c5$var$badgev2information_base_icon_color = "{primaryBackground}";
const $e3613f6017c674c5$var$badgev2information_base_icon_size = "{base}";
const $e3613f6017c674c5$var$badgev2information_variant_color_secondary_icon_color = "{primaryBackground}";
const $e3613f6017c674c5$var$badgev2information_variant_size_small_icon_size = "{s}";
const $e3613f6017c674c5$var$badgev2information_variant_size_medium_icon_size = "{s}";
const $e3613f6017c674c5$var$badgev2information_variant_border_true_container_padding = "{custom_16}";
const $e3613f6017c674c5$var$badgev2information_combination_icon_small_container_padding = "{custom_5}";
const $e3613f6017c674c5$var$badgev2information_combination_icon_small_icon_size = "{s}";
const $e3613f6017c674c5$var$badgev2information_combination_icon_medium_container_padding = "{custom_5}";
const $e3613f6017c674c5$var$badgev2information_combination_icon_medium_icon_size = "{base}";
const $e3613f6017c674c5$var$badgev2information_combination_icon_large_container_padding = "{custom_5}";
const $e3613f6017c674c5$var$badgev2information_combination_icon_large_icon_size = "{custom_18}";
const $e3613f6017c674c5$var$badgev2information_combination_label_small_container_size = "{base}";
const $e3613f6017c674c5$var$badgev2information_combination_label_medium_container_size = "{base}";
const $e3613f6017c674c5$var$badgev2information_combination_label_large_container_size = "{custom_18}";
const $e3613f6017c674c5$var$badgev2information_combination_subtle_default_icon_color = "{sparkle60}";
const $e3613f6017c674c5$var$badgev2information_combination_subtle_positive_icon_color = "{feedbackSuccess50}";
const $e3613f6017c674c5$var$badgev2information_combination_subtle_warning_icon_color = "{feedbackWarning50}";
const $e3613f6017c674c5$var$badgev2information_combination_subtle_negative_icon_color = "{feedbackError50}";
const $e3613f6017c674c5$var$badgev2information_combination_subtle_neutral_icon_color = "{primaryGrey80}";
const $e3613f6017c674c5$var$badgev2information_combination_icon_bold_default_icon_color = "{sparkle60}";
const $e3613f6017c674c5$var$badgev2information_combination_icon_bold_positive_icon_color = "{feedbackSuccess50}";
const $e3613f6017c674c5$var$badgev2information_combination_icon_bold_warning_icon_color = "{feedbackWarning50}";
const $e3613f6017c674c5$var$badgev2information_combination_icon_bold_negative_icon_color = "{feedbackError50}";
const $e3613f6017c674c5$var$badgev2information_combination_icon_bold_neutral_icon_color = "{primaryGrey80}";
const $e3613f6017c674c5$var$badgev2information_combination_icon_subtle_default_icon_color = "{sparkle60}";
const $e3613f6017c674c5$var$badgev2information_combination_icon_subtle_positive_icon_color = "{feedbackSuccess50}";
const $e3613f6017c674c5$var$badgev2information_combination_icon_subtle_warning_icon_color = "{feedbackWarning50}";
const $e3613f6017c674c5$var$badgev2information_combination_icon_subtle_negative_icon_color = "{feedbackError50}";
const $e3613f6017c674c5$var$badgev2information_combination_icon_subtle_neutral_icon_color = "{primaryGrey80}";
const $e3613f6017c674c5$var$badgev2information_combination_true_small_container_padding = "{custom_4}";
const $e3613f6017c674c5$var$badgev2information_combination_true_medium_container_padding = "{custom_4}";
const $e3613f6017c674c5$var$badgev2information_combination_true_large_container_padding = "{custom_16}";
const $e3613f6017c674c5$var$badgev2information_combination_icon_subtle_secondary_icon_color = "{secondary60}";
const $e3613f6017c674c5$var$badgev2information_combination_icon_bold_secondary_icon_color = "{secondary60}";
const $e3613f6017c674c5$var$badgev2information_combination_subtle_secondary_icon_color = "{secondary60}";
const $e3613f6017c674c5$var$badgev2information_combination_true_icon_container_padding = "{custom_5}";
const $e3613f6017c674c5$var$BadgeV2InformationTokens = {
    "badgev2information_base_outer-container_border-radius": "{small}",
    "badgev2information_base_outer-container_align-items": "{alignItems.center}",
    "badgev2information_base_container_flex-direction": "{flexDirection.row}",
    "badgev2information_base_container_justify-content": "{justifyContent.center}",
    "badgev2information_base_container_align-items": "{alignItems.center}",
    "badgev2information_base_container_background-color": "{sparkle60}",
    badgev2information_base_container_gap: $e3613f6017c674c5$var$badgev2information_base_container_gap,
    "badgev2information_base_container_border-radius": "{small}",
    "badgev2information_base_container_padding-left": "{xxs}",
    "badgev2information_base_container_padding-right": "{xs}",
    "badgev2information_base_container_padding-top": "{custom_4}",
    "badgev2information_base_container_padding-bottom": "{custom_4}",
    "badgev2information_base_icon-container_flex-direction": "{flexDirection.row}",
    "badgev2information_base_icon-container_justify-content": "{justifyContent.center}",
    "badgev2information_base_icon-container_align-items": "{alignItems.center}",
    "badgev2information_base_icon-container_size": "{base}",
    badgev2information_base_icon_color: $e3613f6017c674c5$var$badgev2information_base_icon_color,
    badgev2information_base_icon_size: $e3613f6017c674c5$var$badgev2information_base_icon_size,
    "badgev2information_base_image-container_flex-direction": "{flexDirection.row}",
    "badgev2information_base_image-container_justify-content": "{justifyContent.center}",
    "badgev2information_base_image-container_align-items": "{alignItems.center}",
    "badgev2information_base_image-container_size": "{base}",
    "badgev2information_variant_color_secondary_container_background-color": "{secondary60}",
    "badgev2information_variant_color_secondary_icon-container_background-color": "{secondary60}",
    badgev2information_variant_color_secondary_icon_color: $e3613f6017c674c5$var$badgev2information_variant_color_secondary_icon_color,
    "badgev2information_variant_size_xtra-small_inner-container_padding-right": "{xxs}",
    "badgev2information_variant_size_xtra-small_inner-container_padding-top": "{custom_5}",
    "badgev2information_variant_size_xtra-small_inner-container_padding-bottom": "{custom_5}",
    "badgev2information_variant_size_xtra-small_icon-container_size": "{s}",
    "badgev2information_variant_size_xtra-small_icon_size": "{s}",
    "badgev2information_variant_size_xtra-small_image-container_size": "{s}",
    "badgev2information_variant_size_small_inner-container_padding-right": "{xxs}",
    "badgev2information_variant_size_small_inner-container_padding-top": "{custom_5}",
    "badgev2information_variant_size_small_inner-container_padding-bottom": "{custom_5}",
    "badgev2information_variant_size_small_icon-container_size": "{s}",
    badgev2information_variant_size_small_icon_size: $e3613f6017c674c5$var$badgev2information_variant_size_small_icon_size,
    "badgev2information_variant_size_small_image-container_size": "{s}",
    "badgev2information_variant_size_medium_inner-container_padding-right": "{xxs}",
    "badgev2information_variant_size_medium_inner-container_padding-top": "{custom_5}",
    "badgev2information_variant_size_medium_inner-container_padding-bottom": "{custom_5}",
    "badgev2information_variant_size_medium_icon-container_size": "{s}",
    badgev2information_variant_size_medium_icon_size: $e3613f6017c674c5$var$badgev2information_variant_size_medium_icon_size,
    "badgev2information_variant_size_medium_image-container_size": "{s}",
    "badgev2information_variant_size_xtra-xtra-large_inner-container_padding-left": "{xs}",
    "badgev2information_variant_size_xtra-xtra-large_inner-container_padding-top": "{xxs}",
    "badgev2information_variant_size_xtra-xtra-large_inner-container_padding-bottom": "{xxs}",
    "badgev2information_variant_size_xtra-xtra-xtra-large_container_border-radius": "{medium}",
    "badgev2information_variant_size_xtra-xtra-xtra-large_inner-container_border-radius": "{medium}",
    "badgev2information_variant_size_xtra-xtra-xtra-large_inner-container_padding-left": "{xs}",
    "badgev2information_variant_size_xtra-xtra-xtra-large_inner-container_padding-top": "{xxs}",
    "badgev2information_variant_size_xtra-xtra-xtra-large_inner-container_padding-bottom": "{xxs}",
    "badgev2information_variant_size_xtra-xtra-xtra-large_icon-container_size": "{custom_18}",
    "badgev2information_variant_size_xtra-xtra-xtra-large_icon_size": "{custom_18}",
    "badgev2information_variant_size_xtra-xtra-xtra-large_image-container_size": "{custom_18}",
    "badgev2information_variant_size_xtra-xtra-xtra-xtra-large_container_border-radius": "{medium}",
    "badgev2information_variant_size_xtra-xtra-xtra-xtra-large_inner-container_border-radius": "{medium}",
    "badgev2information_variant_size_xtra-xtra-xtra-xtra-large_inner-container_padding-left": "{xs}",
    "badgev2information_variant_size_xtra-xtra-xtra-xtra-large_inner-container_padding-right": "{s}",
    "badgev2information_variant_size_xtra-xtra-xtra-xtra-large_inner-container_padding-top": "{xxs}",
    "badgev2information_variant_size_xtra-xtra-xtra-xtra-large_inner-container_padding-bottom": "{xxs}",
    "badgev2information_variant_size_xtra-xtra-xtra-xtra-large_icon-container_size": "{custom_3}",
    "badgev2information_variant_size_xtra-xtra-xtra-xtra-large_icon_size": "{custom_3}",
    "badgev2information_variant_size_xtra-xtra-xtra-xtra-large_image-container_size": "{custom_3}",
    "badgev2information_variant_color_positive_container_background-color": "{feedbackSuccess50}",
    "badgev2information_variant_color_positive_icon-container_background-color": "{feedbackSuccess50}",
    "badgev2information_variant_color_warning_container_background-color": "{feedbackWarning50}",
    "badgev2information_variant_color_warning_icon-container_background-color": "{feedbackWarning50}",
    "badgev2information_variant_color_negative_container_background-color": "{feedbackError50}",
    "badgev2information_variant_color_negative_icon-container_background-color": "{feedbackError50}",
    "badgev2information_variant_color_neutral_container_background-color": "{primaryGrey80}",
    "badgev2information_variant_color_neutral_icon-container_background-color": "{global.transparent}",
    badgev2information_variant_border_true_container_padding: $e3613f6017c674c5$var$badgev2information_variant_border_true_container_padding,
    "badgev2information_variant_border_true_container_border-color": "{primaryBackground}",
    "badgev2information_combination_icon_xtra-small_container_padding": "{custom_5}",
    "badgev2information_combination_icon_xtra-small_icon-container_size": "{xs}",
    "badgev2information_combination_icon_xtra-small_icon_size": "{xs}",
    badgev2information_combination_icon_small_container_padding: $e3613f6017c674c5$var$badgev2information_combination_icon_small_container_padding,
    "badgev2information_combination_icon_small_icon-container_size": "{s}",
    badgev2information_combination_icon_small_icon_size: $e3613f6017c674c5$var$badgev2information_combination_icon_small_icon_size,
    badgev2information_combination_icon_medium_container_padding: $e3613f6017c674c5$var$badgev2information_combination_icon_medium_container_padding,
    "badgev2information_combination_icon_medium_icon-container_size": "{base}",
    badgev2information_combination_icon_medium_icon_size: $e3613f6017c674c5$var$badgev2information_combination_icon_medium_icon_size,
    badgev2information_combination_icon_large_container_padding: $e3613f6017c674c5$var$badgev2information_combination_icon_large_container_padding,
    "badgev2information_combination_icon_xtra-large_container_padding": "{custom_5}",
    "badgev2information_combination_icon_xtra-xtra-large_container_padding": "{custom_5}",
    "badgev2information_combination_icon_xtra-xtra-xtra-large_container_padding": "{custom_5}",
    "badgev2information_combination_icon_xtra-xtra-xtra-xtra-large_container_padding": "{custom_5}",
    "badgev2information_combination_icon_large_icon-container_size": "{custom_18}",
    badgev2information_combination_icon_large_icon_size: $e3613f6017c674c5$var$badgev2information_combination_icon_large_icon_size,
    "badgev2information_combination_icon_xtra-large_icon-container_size": "{m}",
    "badgev2information_combination_icon_xtra-large_icon_size": "{m}",
    "badgev2information_combination_icon_xtra-xtra-large_icon-container_size": "{custom_3}",
    "badgev2information_combination_icon_xtra-xtra-large_icon_size": "{custom_3}",
    "badgev2information_combination_icon_xtra-xtra-xtra-large_icon-container_size": "{l}",
    "badgev2information_combination_icon_xtra-xtra-xtra-large_icon_size": "{l}",
    "badgev2information_combination_icon_xtra-xtra-xtra-xtra-large_icon-container_size": "{xl}",
    "badgev2information_combination_icon_xtra-xtra-xtra-xtra-large_icon_size": "{xl}",
    "badgev2information_combination_icon-circle_xtra-small_outer-container_border-radius": "{pill}",
    "badgev2information_combination_icon-circle_xtra-small_container_border-radius": "{pill}",
    "badgev2information_combination_icon-circle_xtra-small_container_padding": "{custom_5}",
    "badgev2information_combination_icon-circle_xtra-small_icon-container_size": "{s}",
    "badgev2information_combination_icon-circle_xtra-small_icon-container_border-radius": "{pill}",
    "badgev2information_combination_icon-circle_xtra-small_icon_size": "{xs}",
    "badgev2information_combination_icon-circle_small_outer-container_border-radius": "{pill}",
    "badgev2information_combination_icon-circle_small_container_border-radius": "{pill}",
    "badgev2information_combination_icon-circle_small_container_padding": "{custom_5}",
    "badgev2information_combination_icon-circle_small_icon-container_size": "{s}",
    "badgev2information_combination_icon-circle_small_icon-container_border-radius": "{pill}",
    "badgev2information_combination_icon-circle_small_icon_size": "{xs}",
    "badgev2information_combination_icon-circle_medium_container_border-radius": "{pill}",
    "badgev2information_combination_icon-circle_medium_container_padding": "{custom_5}",
    "badgev2information_combination_icon-circle_medium_icon-container_size": "{base}",
    "badgev2information_combination_icon-circle_medium_icon-container_border-radius": "{pill}",
    "badgev2information_combination_icon-circle_medium_icon_size": "{custom_19}",
    "badgev2information_combination_icon-circle_large_container_border-radius": "{pill}",
    "badgev2information_combination_icon-circle_large_container_padding": "{custom_5}",
    "badgev2information_combination_icon-circle_large_icon-container_size": "{custom_18}",
    "badgev2information_combination_icon-circle_large_icon-container_border-radius": "{pill}",
    "badgev2information_combination_icon-circle_large_icon_size": "{s}",
    "badgev2information_combination_icon-circle_xtra-large_container_border-radius": "{pill}",
    "badgev2information_combination_icon-circle_xtra-large_container_padding": "{custom_5}",
    "badgev2information_combination_icon-circle_xtra-large_icon-container_size": "{m}",
    "badgev2information_combination_icon-circle_xtra-large_icon-container_border-radius": "{pill}",
    "badgev2information_combination_icon-circle_xtra-large_icon_size": "{base}",
    "badgev2information_combination_icon-circle_xtra-xtra-large_container_border-radius": "{pill}",
    "badgev2information_combination_icon-circle_xtra-xtra-large_container_padding": "{custom_5}",
    "badgev2information_combination_icon-circle_xtra-xtra-large_icon-container_size": "{custom_3}",
    "badgev2information_combination_icon-circle_xtra-xtra-large_icon-container_border-radius": "{pill}",
    "badgev2information_combination_icon-circle_xtra-xtra-large_icon_size": "{base}",
    "badgev2information_combination_icon-circle_xtra-xtra-xtra-large_container_border-radius": "{pill}",
    "badgev2information_combination_icon-circle_xtra-xtra-xtra-large_container_padding": "{custom_5}",
    "badgev2information_combination_icon-circle_xtra-xtra-xtra-large_icon-container_size": "{l}",
    "badgev2information_combination_icon-circle_xtra-xtra-xtra-large_icon-container_border-radius": "{pill}",
    "badgev2information_combination_icon-circle_xtra-xtra-xtra-large_icon_size": "{custom_18}",
    "badgev2information_combination_icon-circle_xtra-xtra-xtra-xtra-large_container_border-radius": "{pill}",
    "badgev2information_combination_icon-circle_xtra-xtra-xtra-xtra-large_container_padding": "{custom_5}",
    "badgev2information_combination_icon-circle_xtra-xtra-xtra-xtra-large_icon-container_size": "{xl}",
    "badgev2information_combination_icon-circle_xtra-xtra-xtra-xtra-large_icon-container_border-radius": "{pill}",
    "badgev2information_combination_icon-circle_xtra-xtra-xtra-xtra-large_icon_size": "{m}",
    "badgev2information_combination_icon-square_xtra-small_outer-container_border-radius": "{small}",
    "badgev2information_combination_icon-square_xtra-small_container_border-radius": "{small}",
    "badgev2information_combination_icon-square_xtra-small_container_padding": "{custom_5}",
    "badgev2information_combination_icon-square_xtra-small_icon-container_size": "{s}",
    "badgev2information_combination_icon-square_xtra-small_icon-container_border-radius": "{small}",
    "badgev2information_combination_icon-square_xtra-small_icon_size": "{xs}",
    "badgev2information_combination_icon-square_small_container_border-radius": "{small}",
    "badgev2information_combination_icon-square_small_container_padding": "{custom_5}",
    "badgev2information_combination_icon-square_small_icon-container_size": "{s}",
    "badgev2information_combination_icon-square_small_icon-container_border-radius": "{small}",
    "badgev2information_combination_icon-square_small_icon_size": "{xs}",
    "badgev2information_combination_icon-square_medium_container_border-radius": "{small}",
    "badgev2information_combination_icon-square_medium_container_padding": "{custom_5}",
    "badgev2information_combination_icon-square_medium_icon-container_size": "{base}",
    "badgev2information_combination_icon-square_medium_icon-container_border-radius": "{small}",
    "badgev2information_combination_icon-square_medium_icon_size": "{custom_19}",
    "badgev2information_combination_icon-square_large_container_border-radius": "{small}",
    "badgev2information_combination_icon-square_large_container_padding": "{custom_5}",
    "badgev2information_combination_icon-square_large_icon-container_size": "{custom_18}",
    "badgev2information_combination_icon-square_large_icon-container_border-radius": "{small}",
    "badgev2information_combination_icon-square_large_icon_size": "{s}",
    "badgev2information_combination_icon-square_xtra-large_container_border-radius": "{small}",
    "badgev2information_combination_icon-square_xtra-large_container_padding": "{custom_5}",
    "badgev2information_combination_icon-square_xtra-large_icon-container_size": "{m}",
    "badgev2information_combination_icon-square_xtra-large_icon-container_border-radius": "{small}",
    "badgev2information_combination_icon-square_xtra-large_icon_size": "{base}",
    "badgev2information_combination_icon-square_xtra-xtra-large_container_border-radius": "{small}",
    "badgev2information_combination_icon-square_xtra-xtra-large_container_padding": "{custom_5}",
    "badgev2information_combination_icon-square_xtra-xtra-large_icon-container_size": "{custom_3}",
    "badgev2information_combination_icon-square_xtra-xtra-large_icon-container_border-radius": "{small}",
    "badgev2information_combination_icon-square_xtra-xtra-large_icon_size": "{base}",
    "badgev2information_combination_icon-square_xtra-xtra-xtra-large_container_border-radius": "{medium}",
    "badgev2information_combination_icon-square_xtra-xtra-xtra-large_container_padding": "{custom_5}",
    "badgev2information_combination_icon-square_xtra-xtra-xtra-large_icon-container_size": "{l}",
    "badgev2information_combination_icon-square_xtra-xtra-xtra-large_icon-container_border-radius": "{medium}",
    "badgev2information_combination_icon-square_xtra-xtra-xtra-large_icon_size": "{custom_18}",
    "badgev2information_combination_icon-square_xtra-xtra-xtra-xtra-large_container_border-radius": "{custom_1}",
    "badgev2information_combination_icon-square_xtra-xtra-xtra-xtra-large_container_padding": "{custom_5}",
    "badgev2information_combination_icon-square_xtra-xtra-xtra-xtra-large_icon-container_size": "{xl}",
    "badgev2information_combination_icon-square_xtra-xtra-xtra-xtra-large_icon-container_border-radius": "{custom_1}",
    "badgev2information_combination_icon-square_xtra-xtra-xtra-xtra-large_icon_size": "{m}",
    "badgev2information_combination_label_xtra-small_container_size": "{base}",
    badgev2information_combination_label_small_container_size: $e3613f6017c674c5$var$badgev2information_combination_label_small_container_size,
    badgev2information_combination_label_medium_container_size: $e3613f6017c674c5$var$badgev2information_combination_label_medium_container_size,
    badgev2information_combination_label_large_container_size: $e3613f6017c674c5$var$badgev2information_combination_label_large_container_size,
    "badgev2information_combination_label_large_inner-container_padding-left": "{xs}",
    "badgev2information_combination_label_xtra-large_container_size": "{m}",
    "badgev2information_combination_label_xtra-large_inner-container_padding-left": "{xs}",
    "badgev2information_combination_label_xtra-xtra-large_container_size": "{custom_3}",
    "badgev2information_combination_label_xtra-xtra-xtra-large_container_size": "{l}",
    "badgev2information_combination_label_xtra-xtra-xtra-xtra-large_container_size": "{xl}",
    "badgev2information_combination_label_xtra-xtra-xtra-xtra-large_inner-container_padding-left": "{s}",
    "badgev2information_combination_label-icon_xtra-small_container_size": "{base}",
    "badgev2information_combination_label-icon_small_container_size": "{base}",
    "badgev2information_combination_label-icon_medium_container_size": "{base}",
    "badgev2information_combination_label-icon_large_container_size": "{custom_18}",
    "badgev2information_combination_label-icon_xtra-large_container_size": "{m}",
    "badgev2information_combination_label-icon_xtra-xtra-large_container_size": "{custom_3}",
    "badgev2information_combination_label-icon_xtra-xtra-xtra-large_container_size": "{l}",
    "badgev2information_combination_label-icon_xtra-xtra-xtra-xtra-large_container_size": "{xl}",
    "badgev2information_combination_label-image_xtra-small_container_size": "{base}",
    "badgev2information_combination_label-image_small_container_size": "{base}",
    "badgev2information_combination_label-image_medium_container_size": "{base}",
    "badgev2information_combination_label-image_large_container_size": "{custom_18}",
    "badgev2information_combination_label-image_xtra-large_container_size": "{m}",
    "badgev2information_combination_label-image_xtra-xtra-large_container_size": "{custom_3}",
    "badgev2information_combination_label-image_xtra-xtra-xtra-large_container_size": "{l}",
    "badgev2information_combination_label-image_xtra-xtra-xtra-xtra-large_container_size": "{xl}",
    "badgev2information_combination_subtle_default_container_background-color": "{sparkle20}",
    "badgev2information_combination_subtle_default_icon-container_background-color": "{sparkle20}",
    badgev2information_combination_subtle_default_icon_color: $e3613f6017c674c5$var$badgev2information_combination_subtle_default_icon_color,
    "badgev2information_combination_subtle_positive_container_background-color": "{feedbackSuccess20}",
    "badgev2information_combination_subtle_positive_icon-container_background-color": "{feedbackSuccess20}",
    badgev2information_combination_subtle_positive_icon_color: $e3613f6017c674c5$var$badgev2information_combination_subtle_positive_icon_color,
    "badgev2information_combination_subtle_warning_container_background-color": "{feedbackWarning20}",
    "badgev2information_combination_subtle_warning_icon-container_background-color": "{feedbackWarning20}",
    badgev2information_combination_subtle_warning_icon_color: $e3613f6017c674c5$var$badgev2information_combination_subtle_warning_icon_color,
    "badgev2information_combination_subtle_negative_container_background-color": "{feedbackError20}",
    "badgev2information_combination_subtle_negative_icon-container_background-color": "{feedbackError20}",
    badgev2information_combination_subtle_negative_icon_color: $e3613f6017c674c5$var$badgev2information_combination_subtle_negative_icon_color,
    "badgev2information_combination_subtle_neutral_container_background-color": "{primaryGrey20}",
    "badgev2information_combination_subtle_neutral_icon-container_background-color": "{primaryGrey20}",
    badgev2information_combination_subtle_neutral_icon_color: $e3613f6017c674c5$var$badgev2information_combination_subtle_neutral_icon_color,
    "badgev2information_combination_icon_bold_default_container_background-color": "{global.transparent}",
    "badgev2information_combination_icon_bold_default_icon-container_background-color": "{global.transparent}",
    badgev2information_combination_icon_bold_default_icon_color: $e3613f6017c674c5$var$badgev2information_combination_icon_bold_default_icon_color,
    "badgev2information_combination_icon_bold_positive_container_background-color": "{global.transparent}",
    "badgev2information_combination_icon_bold_positive_icon-container_background-color": "{global.transparent}",
    badgev2information_combination_icon_bold_positive_icon_color: $e3613f6017c674c5$var$badgev2information_combination_icon_bold_positive_icon_color,
    "badgev2information_combination_icon_bold_warning_container_background-color": "{global.transparent}",
    "badgev2information_combination_icon_bold_warning_icon-container_background-color": "{global.transparent}",
    badgev2information_combination_icon_bold_warning_icon_color: $e3613f6017c674c5$var$badgev2information_combination_icon_bold_warning_icon_color,
    "badgev2information_combination_icon_bold_negative_container_background-color": "{global.transparent}",
    "badgev2information_combination_icon_bold_negative_icon-container_background-color": "{global.transparent}",
    badgev2information_combination_icon_bold_negative_icon_color: $e3613f6017c674c5$var$badgev2information_combination_icon_bold_negative_icon_color,
    "badgev2information_combination_icon_bold_neutral_container_background-color": "{global.transparent}",
    "badgev2information_combination_icon_bold_neutral_icon-container_background-color": "{global.transparent}",
    badgev2information_combination_icon_bold_neutral_icon_color: $e3613f6017c674c5$var$badgev2information_combination_icon_bold_neutral_icon_color,
    "badgev2information_combination_icon_subtle_default_container_background-color": "{global.transparent}",
    "badgev2information_combination_icon_subtle_default_icon-container_background-color": "{global.transparent}",
    badgev2information_combination_icon_subtle_default_icon_color: $e3613f6017c674c5$var$badgev2information_combination_icon_subtle_default_icon_color,
    "badgev2information_combination_icon_subtle_positive_container_background-color": "{global.transparent}",
    "badgev2information_combination_icon_subtle_positive_icon-container_background-color": "{global.transparent}",
    badgev2information_combination_icon_subtle_positive_icon_color: $e3613f6017c674c5$var$badgev2information_combination_icon_subtle_positive_icon_color,
    "badgev2information_combination_icon_subtle_warning_container_background-color": "{global.transparent}",
    "badgev2information_combination_icon_subtle_warning_icon-container_background-color": "{global.transparent}",
    badgev2information_combination_icon_subtle_warning_icon_color: $e3613f6017c674c5$var$badgev2information_combination_icon_subtle_warning_icon_color,
    "badgev2information_combination_icon_subtle_negative_container_background-color": "{global.transparent}",
    "badgev2information_combination_icon_subtle_negative_icon-container_background-color": "{global.transparent}",
    badgev2information_combination_icon_subtle_negative_icon_color: $e3613f6017c674c5$var$badgev2information_combination_icon_subtle_negative_icon_color,
    "badgev2information_combination_icon_subtle_neutral_container_background-color": "{global.transparent}",
    "badgev2information_combination_icon_subtle_neutral_icon-container_background-color": "{global.transparent}",
    badgev2information_combination_icon_subtle_neutral_icon_color: $e3613f6017c674c5$var$badgev2information_combination_icon_subtle_neutral_icon_color,
    "badgev2information_combination_true_xtra-small_container_padding": "{custom_4}",
    badgev2information_combination_true_small_container_padding: $e3613f6017c674c5$var$badgev2information_combination_true_small_container_padding,
    badgev2information_combination_true_medium_container_padding: $e3613f6017c674c5$var$badgev2information_combination_true_medium_container_padding,
    badgev2information_combination_true_large_container_padding: $e3613f6017c674c5$var$badgev2information_combination_true_large_container_padding,
    "badgev2information_combination_true_xtra-xtra-large_container_padding": "{custom_16}",
    "badgev2information_combination_true_xtra-xtra-xtra-large_container_padding": "{custom_16}",
    "badgev2information_combination_true_xtra-xtra-xtra-xtra-large_container_padding": "{xxs}",
    "badgev2information_combination_true_icon-circle_large_container_padding": "{custom_4}",
    "badgev2information_combination_true_icon-square_large_container_padding": "{custom_4}",
    "badgev2information_combination_icon_subtle_secondary_container_background-color": "{global.transparent}",
    "badgev2information_combination_icon_subtle_secondary_icon-container_background-color": "{global.transparent}",
    badgev2information_combination_icon_subtle_secondary_icon_color: $e3613f6017c674c5$var$badgev2information_combination_icon_subtle_secondary_icon_color,
    "badgev2information_combination_icon_bold_secondary_container_background-color": "{global.transparent}",
    "badgev2information_combination_icon_bold_secondary_icon-container_background-color": "{global.tansparent}",
    badgev2information_combination_icon_bold_secondary_icon_color: $e3613f6017c674c5$var$badgev2information_combination_icon_bold_secondary_icon_color,
    "badgev2information_combination_subtle_secondary_container_background-color": "{secondary20}",
    "badgev2information_combination_subtle_secondary_icon-container_background-color": "{secondary20}",
    badgev2information_combination_subtle_secondary_icon_color: $e3613f6017c674c5$var$badgev2information_combination_subtle_secondary_icon_color,
    "badgev2information_combination_true_icon_container_border-color": "{global.transparent}",
    badgev2information_combination_true_icon_container_padding: $e3613f6017c674c5$var$badgev2information_combination_true_icon_container_padding
};
const $e3613f6017c674c5$var$badgev2notification_base_container_width = "{xs}";
const $e3613f6017c674c5$var$badgev2notification_base_container_height = "{xs}";
const $e3613f6017c674c5$var$badgev2notification_base_container_padding = "{custom_5}";
const $e3613f6017c674c5$var$badgev2notification_variant_size_small_container_padding = "{custom_4}";
const $e3613f6017c674c5$var$badgev2notification_variant_size_small_container_width = "{s}";
const $e3613f6017c674c5$var$badgev2notification_variant_size_small_container_height = "{s}";
const $e3613f6017c674c5$var$badgev2notification_variant_size_medium_container_width = "{base}";
const $e3613f6017c674c5$var$badgev2notification_variant_size_medium_container_height = "{base}";
const $e3613f6017c674c5$var$badgev2notification_variant_size_medium_container_padding = "{custom_4}";
const $e3613f6017c674c5$var$badgev2notification_variant_size_large_container_width = "{custom_18}";
const $e3613f6017c674c5$var$badgev2notification_variant_size_large_container_height = "{custom_18}";
const $e3613f6017c674c5$var$badgev2notification_variant_size_large_container_padding = "{custom_4}";
const $e3613f6017c674c5$var$badgev2notification_variant_border_true_container_padding = "{custom_1}";
const $e3613f6017c674c5$var$badgev2notification_combination_number_small_container_width = "{base}";
const $e3613f6017c674c5$var$badgev2notification_combination_number_small_container_height = "{base}";
const $e3613f6017c674c5$var$badgev2notification_combination_number_medium_container_width = "{base}";
const $e3613f6017c674c5$var$badgev2notification_combination_number_medium_container_height = "{base}";
const $e3613f6017c674c5$var$badgev2notification_combination_number_large_container_width = "{custom_18}";
const $e3613f6017c674c5$var$badgev2notification_combination_number_large_container_height = "{custom_18}";
const $e3613f6017c674c5$var$BadgeV2NotificationTokens = {
    "badgev2notification_base_container_flex-direction": "{flexDirection.row}",
    "badgev2notification_base_container_justify-content": "{justifyContent.center}",
    "badgev2notification_base_container_align-items": "{alignItems.center}",
    badgev2notification_base_container_width: $e3613f6017c674c5$var$badgev2notification_base_container_width,
    badgev2notification_base_container_height: $e3613f6017c674c5$var$badgev2notification_base_container_height,
    "badgev2notification_base_container_background-color": "{feedbackError50}",
    "badgev2notification_base_container_border-radius": "{pill}",
    badgev2notification_base_container_padding: $e3613f6017c674c5$var$badgev2notification_base_container_padding,
    "badgev2notification_base_container_border-color": "{global.transparent}",
    "badgev2notification_variant_border_true_container_border-color": "{primaryBackground}",
    badgev2notification_variant_size_small_container_padding: $e3613f6017c674c5$var$badgev2notification_variant_size_small_container_padding,
    badgev2notification_variant_size_small_container_width: $e3613f6017c674c5$var$badgev2notification_variant_size_small_container_width,
    badgev2notification_variant_size_small_container_height: $e3613f6017c674c5$var$badgev2notification_variant_size_small_container_height,
    badgev2notification_variant_size_medium_container_width: $e3613f6017c674c5$var$badgev2notification_variant_size_medium_container_width,
    badgev2notification_variant_size_medium_container_height: $e3613f6017c674c5$var$badgev2notification_variant_size_medium_container_height,
    badgev2notification_variant_size_medium_container_padding: $e3613f6017c674c5$var$badgev2notification_variant_size_medium_container_padding,
    badgev2notification_variant_size_large_container_width: $e3613f6017c674c5$var$badgev2notification_variant_size_large_container_width,
    badgev2notification_variant_size_large_container_height: $e3613f6017c674c5$var$badgev2notification_variant_size_large_container_height,
    badgev2notification_variant_size_large_container_padding: $e3613f6017c674c5$var$badgev2notification_variant_size_large_container_padding,
    "badgev2notification_variant_size_xtra-large_container_width": "{m}",
    "badgev2notification_variant_size_xtra-large_container_height": "{m}",
    "badgev2notification_variant_size_xtra-large_container_padding": "{custom_16}",
    "badgev2notification_variant_size_xtra-xtra-large_container_width": "{custom_3}",
    "badgev2notification_variant_size_xtra-xtra-large_container_height": "{custom_3}",
    "badgev2notification_variant_size_xtra-xtra-large_container_padding": "{custom_16}",
    "badgev2notification_variant_size_xtra-xtra-xtra-large_container_width": "{l}",
    "badgev2notification_variant_size_xtra-xtra-xtra-large_container_height": "{l}",
    "badgev2notification_variant_size_xtra-xtra-xtra-large_container_padding": "{custom_16}",
    "badgev2notification_variant_size_xtra-xtra-xtra-xtra-large_container_width": "{xl}",
    "badgev2notification_variant_size_xtra-xtra-xtra-xtra-large_container_height": "{xl}",
    "badgev2notification_variant_size_xtra-xtra-xtra-xtra-large_container_padding": "{xxs}",
    badgev2notification_variant_border_true_container_padding: $e3613f6017c674c5$var$badgev2notification_variant_border_true_container_padding,
    "badgev2notification_combination_number_xtra-small_container_width": "{base}",
    "badgev2notification_combination_number_xtra-small_container_height": "{base}",
    badgev2notification_combination_number_small_container_width: $e3613f6017c674c5$var$badgev2notification_combination_number_small_container_width,
    badgev2notification_combination_number_small_container_height: $e3613f6017c674c5$var$badgev2notification_combination_number_small_container_height,
    badgev2notification_combination_number_medium_container_width: $e3613f6017c674c5$var$badgev2notification_combination_number_medium_container_width,
    badgev2notification_combination_number_medium_container_height: $e3613f6017c674c5$var$badgev2notification_combination_number_medium_container_height,
    badgev2notification_combination_number_large_container_width: $e3613f6017c674c5$var$badgev2notification_combination_number_large_container_width,
    badgev2notification_combination_number_large_container_height: $e3613f6017c674c5$var$badgev2notification_combination_number_large_container_height,
    "badgev2notification_combination_number_xtra-large_container_width": "{m}",
    "badgev2notification_combination_number_xtra-large_container_height": "{m}",
    "badgev2notification_combination_number_xtra-xtra-large_container_width": "{custom_3}",
    "badgev2notification_combination_number_xtra-xtra-large_container_height": "{custom_3}",
    "badgev2notification_combination_number_xtra-xtra-xtra-large_container_width": "{l}",
    "badgev2notification_combination_number_xtra-xtra-xtra-large_container_height": "{l}",
    "badgev2notification_combination_number_xtra-xtra-xtra-xtra-large_container_width": "{xl}",
    "badgev2notification_combination_number_xtra-xtra-xtra-xtra-large_container_height": "{xl}",
    "badgev2notification_combination_number-symbol_xtra-small_container_height": "{base}",
    "badgev2notification_combination_number-symbol_xtra-small_container_border-radius": "{small}",
    "badgev2notification_combination_number-symbol_xtra-small_container_padding-left": "{xxs}",
    "badgev2notification_combination_number-symbol_xtra-small_container_padding-right": "{xxs}",
    "badgev2notification_combination_number-symbol_small_container_height": "{base}",
    "badgev2notification_combination_number-symbol_small_container_border-radius": "{small}",
    "badgev2notification_combination_number-symbol_small_container_padding-left": "{xxs}",
    "badgev2notification_combination_number-symbol_small_container_padding-right": "{xxs}",
    "badgev2notification_combination_number-symbol_medium_container_height": "{base}",
    "badgev2notification_combination_number-symbol_medium_container_border-radius": "{small}",
    "badgev2notification_combination_number-symbol_medium_container_padding-left": "{xxs}",
    "badgev2notification_combination_number-symbol_medium_container_padding-right": "{xxs}",
    "badgev2notification_combination_number-symbol_large_container_height": "{custom_18}",
    "badgev2notification_combination_number-symbol_large_container_border-radius": "{small}",
    "badgev2notification_combination_number-symbol_large_container_padding-left": "{custom_18}",
    "badgev2notification_combination_number-symbol_large_container_padding-right": "{custom_18}",
    "badgev2notification_combination_number-symbol_xtra-large_container_height": "{m}",
    "badgev2notification_combination_number-symbol_xtra-large_container_border-radius": "{small}",
    "badgev2notification_combination_number-symbol_xtra-large_container_padding-left": "{custom_18}",
    "badgev2notification_combination_number-symbol_xtra-large_container_padding-right": "{custom_18}",
    "badgev2notification_combination_number-symbol_xtra-xtra-large_container_height": "{custom_3}",
    "badgev2notification_combination_number-symbol_xtra-xtra-large_container_border-radius": "{small}",
    "badgev2notification_combination_number-symbol_xtra-xtra-large_container_padding-left": "{custom_18}",
    "badgev2notification_combination_number-symbol_xtra-xtra-large_container_padding-right": "{custom_18}",
    "badgev2notification_combination_number-symbol_xtra-xtra-xtra-large_container_height": "{l}",
    "badgev2notification_combination_number-symbol_xtra-xtra-xtra-large_container_border-radius": "{medium}",
    "badgev2notification_combination_number-symbol_xtra-xtra-xtra-large_container_padding-left": "{xs}",
    "badgev2notification_combination_number-symbol_xtra-xtra-xtra-large_container_padding-right": "{xs}",
    "badgev2notification_combination_number-symbol_xtra-xtra-xtra-xtra-large_container_height": "{xl}",
    "badgev2notification_combination_number-symbol_xtra-xtra-xtra-xtra-large_container_border-radius": "{medium}",
    "badgev2notification_combination_number-symbol_xtra-xtra-xtra-xtra-large_container_padding-left": "{xs}",
    "badgev2notification_combination_number-symbol_xtra-xtra-xtra-xtra-large_container_padding-right": "{xs}",
    "badgev2notification_combination_true_number_xtra-small_container_padding": "{custom_4}"
};
const $e3613f6017c674c5$var$badgev2status_base_container_gap = "{xs}";
const $e3613f6017c674c5$var$BadgeV2StatusTokens = {
    "badgev2status_base_container_flex-direction": "{flexDirection.row}",
    "badgev2status_base_container_justify-content": "{justifyContent.center}",
    "badgev2status_base_container_align-items": "{alignItems.center}",
    badgev2status_base_container_gap: $e3613f6017c674c5$var$badgev2status_base_container_gap,
    "badgev2status_base_status-container_flex-direction": "{flexDirection.row}",
    "badgev2status_base_status-container_justify-content": "{justifyContent.center}",
    "badgev2status_base_status-container_align-items": "{alignItems.center}",
    "badgev2status_base_status-container_size": "{m}",
    "badgev2status_base_status-container_border-radius": "{pill}",
    "badgev2status_base_status-container_background-color": "{feedbackSuccess50}",
    "badgev2status_base_status-icon_color": "{global.white}",
    "badgev2status_base_status-icon_size": "{base}",
    "badgev2status_variant_kind_dot_status-container_size": "{s}",
    "badgev2status_variant_kind_dot-label_status-container_size": "{s}",
    "badgev2status_variant_kind_label-container_container_border-radius": "{small}",
    "badgev2status_variant_kind_label-container_container_padding-left": "{xs}",
    "badgev2status_variant_kind_label-container_container_padding-right": "{xs}",
    "badgev2status_variant_kind_dot-label-container_container_border-radius": "{small}",
    "badgev2status_variant_kind_dot-label-container_container_padding-left": "{xs}",
    "badgev2status_variant_kind_dot-label-container_container_padding-right": "{xs}",
    "badgev2status_variant_kind_dot-label-container_status-container_size": "{s}",
    "badgev2status_variant_kind_icon-label-container_container_border-radius": "{small}",
    "badgev2status_variant_kind_icon-label-container_container_padding-left": "{xs}",
    "badgev2status_variant_kind_icon-label-container_container_padding-right": "{xs}",
    "badgev2status_variant_size_xtra-small_status-container_size": "{base}",
    "badgev2status_variant_size_xtra-small_status-icon_size": "{s}",
    "badgev2status_variant_size_medium_status-container_size": "{l}",
    "badgev2status_variant_size_medium_status-icon_size": "{m}",
    "badgev2status_variant_size_large_status-container_size": "{xl}",
    "badgev2status_variant_size_large_status-icon_size": "{custom_3}",
    "badgev2status_variant_status_error_status-container_background-color": "{feedbackError50}",
    "badgev2status_variant_status_warning_status-container_background-color": "{feedbackWarning50}",
    "badgev2status_variant_status_disabled_status-container_background-color": "{primaryGrey60}",
    "badgev2status_variant_border_true_container_border-color": "{primaryBackground}",
    "badgev2status_variant_border_true_status-container_border-color": "{primaryBackground}",
    "badgev2status_combination_dot_xtra-small_status-container_size": "{xs}",
    "badgev2status_combination_dot_medium_status-container_size": "{base}",
    "badgev2status_combination_dot_large_status-container_size": "{m}",
    "badgev2status_combination_dot_xtra-large_status-container_size": "{l}",
    "badgev2status_combination_dot-label_xtra-small_status-container_size": "{xs}",
    "badgev2status_combination_dot-label_medium_status-container_size": "{base}",
    "badgev2status_combination_dot-label_large_status-container_size": "{m}",
    "badgev2status_combination_dot-label_xtra-large_status-container_size": "{l}",
    "badgev2status_combination_icon-label_medium_status-container_size": "{m}",
    "badgev2status_combination_icon-label_medium_status-icon_size": "{base}",
    "badgev2status_combination_icon-label_large_status-container_size": "{m}",
    "badgev2status_combination_icon-label_large_status-icon_size": "{base}",
    "badgev2status_combination_label-container_medium_container_border-radius": "{medium}",
    "badgev2status_combination_label-container_large_container_border-radius": "{medium}",
    "badgev2status_combination_dot-label-container_xtra-small_status-container_size": "{xs}",
    "badgev2status_combination_dot-label-container_medium_container_border-radius": "{medium}",
    "badgev2status_combination_dot-label-container_medium_status-container_size": "{base}",
    "badgev2status_combination_dot-label-container_large_container_border-radius": "{medium}",
    "badgev2status_combination_dot-label-container_large_status-container_size": "{m}",
    "badgev2status_combination_dot-label-container_xtra-large_status-container_size": "{l}",
    "badgev2status_combination_icon-label-container_medium_container_border-radius": "{medium}",
    "badgev2status_combination_icon-label-container_medium_status-container_size": "{base}",
    "badgev2status_combination_icon-label-container_medium_status-icon_size": "{s}",
    "badgev2status_combination_icon-label-container_large_container_border-radius": "{medium}",
    "badgev2status_combination_icon-label-container_large_status-container_size": "{m}",
    "badgev2status_combination_icon-label-container_large_status-icon_size": "{base}",
    "badgev2status_combination_label-container_success_container_background-color": "{feedbackSuccess50}",
    "badgev2status_combination_label-container_error_container_background-color": "{feedbackError50}",
    "badgev2status_combination_label-container_warning_container_background-color": "{feedbackWarning50}",
    "badgev2status_combination_label-container_disabled_container_background-color": "{primaryGrey60}",
    "badgev2status_combination_dot-label-container_success_container_background-color": "{feedbackSuccess50}",
    "badgev2status_combination_dot-label-container_success_status-container_background-color": "{global.white}",
    "badgev2status_combination_dot-label-container_error_container_background-color": "{feedbackError50}",
    "badgev2status_combination_dot-label-container_error_status-container_background-color": "{global.white}",
    "badgev2status_combination_dot-label-container_warning_container_background-color": "{feedbackWarning50}",
    "badgev2status_combination_dot-label-container_warning_status-container_background-color": "{global.white}",
    "badgev2status_combination_dot-label-container_disabled_container_background-color": "{primaryGrey60}",
    "badgev2status_combination_dot-label-container_disabled_status-container_background-color": "{global.white}",
    "badgev2status_combination_icon-label-container_success_container_background-color": "{feedbackSuccess50}",
    "badgev2status_combination_icon-label-container_success_status-container_background-color": "{global.white}",
    "badgev2status_combination_icon-label-container_success_status-icon_color": "{feedbackSuccess50}",
    "badgev2status_combination_icon-label-container_error_container_background-color": "{feedbackError50}",
    "badgev2status_combination_icon-label-container_error_status-container_background-color": "{global.white}",
    "badgev2status_combination_icon-label-container_error_status-icon_color": "{feedbackError50}",
    "badgev2status_combination_icon-label-container_warning_container_background-color": "{feedbackWarning50}",
    "badgev2status_combination_icon-label-container_warning_status-container_background-color": "{global.white}",
    "badgev2status_combination_icon-label-container_warning_status-icon_color": "{feedbackWarning50}",
    "badgev2status_combination_icon-label-container_disabled_container_background-color": "{primaryGrey60}",
    "badgev2status_combination_icon-label-container_disabled_status-container_background-color": "{global.white}",
    "badgev2status_combination_icon-label-container_disabled_status-icon_color": "{primaryGrey60}",
    "badgev2status_combination_true_dot_xtra-small_status-container_border-width": "{border_normal}",
    "badgev2status_combination_true_dot_small_status-container_border-width": "{border_normal}",
    "badgev2status_combination_true_dot_medium_status-container_border-width": "{border_thick}",
    "badgev2status_combination_true_dot_large_status-container_border-width": "{border_thick}",
    "badgev2status_combination_true_dot_xtra-large_status-container_border-width": "{border_thick}",
    "badgev2status_combination_true_icon_xtra-small_status-container_border-width": "{border_normal}",
    "badgev2status_combination_true_icon_small_status-container_border-width": "{border_normal}",
    "badgev2status_combination_true_icon_medium_status-container_border-width": "{border_thick}",
    "badgev2status_combination_true_icon_large_status-container_border-width": "{border_thick}",
    "badgev2status_combination_true_icon_xtra-large_status-container_border-width": "{border_thick}",
    "badgev2status_combination_true_label-container_xtra-small_container_border-width": "{border_normal}",
    "badgev2status_combination_true_label-container_small_container_border-width": "{border_normal}",
    "badgev2status_combination_true_label-container_medium_container_border-width": "{border_thick}",
    "badgev2status_combination_true_label-container_large_container_border-width": "{border_thick}",
    "badgev2status_combination_true_label-container_xtra-large_container_border-width": "{border_thick}"
};
const $e3613f6017c674c5$var$breadcrumbs_base_container_height = "{m}";
const $e3613f6017c674c5$var$BreadcrumbsTokens = {
    "breadcrumbs_base_container_flex-direction": "{flexDirection.row}",
    "breadcrumbs_base_container_justify-content": "{justifyContent.start}",
    "breadcrumbs_base_container_align-items": "{alignItems.start}",
    breadcrumbs_base_container_height: $e3613f6017c674c5$var$breadcrumbs_base_container_height,
    "breadcrumbs_base_link-container_flex-direction": "{flexDirection.row}",
    "breadcrumbs_base_link-container_justify-content": "{justifyContent.start}",
    "breadcrumbs_base_link-container_align-items": "{alignItems.start}"
};
const $e3613f6017c674c5$var$MobileBottomSheetTokens = {
    "mobilebottomsheet_base_popup-container_flex-direction": "{flexDirection.stack}",
    "mobilebottomsheet_base_popup-container_justify-content": "{justifyContent.center}",
    "mobilebottomsheet_base_popup-container_align-items": "{alignItems.end}",
    "mobilebottomsheet_base_popup-container_size": "{size.max}",
    "mobilebottomsheet_base_popup-container_background-color": "{custom_color_3}",
    "mobilebottomsheet_base_popup-container_opacity": "{opacity.invisible}",
    "mobilebottomsheet_base_popup-container_transition_duration": "{medium}",
    "mobilebottomsheet_base_popup-container_transition_timing-function": "{easeEntrance}",
    "mobilebottomsheet_variant_kind_passive_popup_background-color": "{global.transparent}",
    "mobilebottomsheet_variant_kind_passive_popup-container_background-color": "{global.transparent}",
    "mobilebottomsheet_variant_close_false_popup-container_opacity": "{opacity.enabled}",
    "mobilebottomsheet_variant_close_false_popup-container_transition_timing-function": "{easeExit}"
};
const $e3613f6017c674c5$var$mobilebottomsheetinternal_base_container_width = "{size.max}";
const $e3613f6017c674c5$var$MobileBottomSheetInternalTokens = {
    "mobilebottomsheetinternal_base_container_flex-direction": "{flexDirection.stack}",
    "mobilebottomsheetinternal_base_container_justify-content": "{justifyContent.end}",
    "mobilebottomsheetinternal_base_container_align-items": "{alignItems.end}",
    mobilebottomsheetinternal_base_container_width: $e3613f6017c674c5$var$mobilebottomsheetinternal_base_container_width,
    "mobilebottomsheetinternal_base_root-container_flex-direction": "{flexDirection.column}",
    "mobilebottomsheetinternal_base_root-container_justify-content": "{justifyContent.start}",
    "mobilebottomsheetinternal_base_root-container_background-color": "{primaryBackground}",
    "mobilebottomsheetinternal_base_root-container_align-items": "{alignItems.start}",
    "mobilebottomsheetinternal_base_root-container_border-top-left-radius": "{xl}",
    "mobilebottomsheetinternal_base_root-container_border-top-right-radius": "{xl}",
    "mobilebottomsheetinternal_base_root-container_width": "{size.max}",
    "mobilebottomsheetinternal_base_root-container_translate-y": "{size.max}",
    "mobilebottomsheetinternal_base_root-container_transition_duration": "{medium}",
    "mobilebottomsheetinternal_base_root-container_transition_timing-function": "{easeEntrance}",
    "mobilebottomsheetinternal_base_cancel-container_flex-direction": "{flexDirection.row}",
    "mobilebottomsheetinternal_base_cancel-container_justify-content": "{justifyContent.end}",
    "mobilebottomsheetinternal_base_cancel-container_align-items": "{alignItems.center}",
    "mobilebottomsheetinternal_base_cancel-container_width": "{size.max}",
    "mobilebottomsheetinternal_base_cancel-container_padding-top": "{xxs}",
    "mobilebottomsheetinternal_base_cancel-container_padding-bottom": "{xxs}",
    "mobilebottomsheetinternal_base_cancel-container_padding-left": "{xs}",
    "mobilebottomsheetinternal_base_cancel-container_padding-right": "{s}",
    "mobilebottomsheetinternal_base_cancel-container_gap": "{s}",
    "mobilebottomsheetinternal_base_back-container_flex": 1,
    "mobilebottomsheetinternal_base_empty-container_flex": 1,
    "mobilebottomsheetinternal_base_step-jds_text_padding-right": "{base}",
    "mobilebottomsheetinternal_base_vertical-container_flex-direction": "{flexDirection.column}",
    "mobilebottomsheetinternal_base_vertical-container_justify-content": "{justifyContent.start}",
    "mobilebottomsheetinternal_base_vertical-container_align-items": "{alignItems.start}",
    "mobilebottomsheetinternal_base_vertical-container_padding-left": "{m}",
    "mobilebottomsheetinternal_base_vertical-container_padding-right": "{m}",
    "mobilebottomsheetinternal_base_vertical-container_width": "{size.max}",
    "mobilebottomsheetinternal_base_title-jds_text_padding-bottom": "{xs}",
    "mobilebottomsheetinternal_base_description-jds_text_padding-bottom": "{m}",
    "mobilebottomsheetinternal_base_cta-container_flex-direction": "{flexDirection.column}",
    "mobilebottomsheetinternal_base_cta-container_gap": "{base}",
    "mobilebottomsheetinternal_base_cta-container_width": "{size.max}",
    "mobilebottomsheetinternal_base_cta-container_padding-bottom": "{m}",
    "mobilebottomsheetinternal_base_cta-container_padding-top": "{m}",
    "mobilebottomsheetinternal_base_custom-container_flex-direction": "{flexDirection.column}",
    "mobilebottomsheetinternal_base_custom-container_justify-content": "{justifyContent.start}",
    "mobilebottomsheetinternal_base_custom-container_align-items": "{alignItems.start}",
    "mobilebottomsheetinternal_base_custom-container_background-color": "{primaryBackground}",
    "mobilebottomsheetinternal_base_custom-container_border-top-left-radius": "{xl}",
    "mobilebottomsheetinternal_base_custom-container_border-top-right-radius": "{xl}",
    "mobilebottomsheetinternal_base_custom-container_padding-left": "{m}",
    "mobilebottomsheetinternal_base_custom-container_padding-right": "{m}",
    "mobilebottomsheetinternal_base_custom-container_padding-top": "{m}",
    "mobilebottomsheetinternal_base_custom-container_padding-bottom": "{m}",
    "mobilebottomsheetinternal_base_custom-container_width": "{size.max}",
    "mobilebottomsheetinternal_base_custom-container_translate-y": "{size.max}",
    "mobilebottomsheetinternal_base_custom-container_transition_duration": "{medium}",
    "mobilebottomsheetinternal_base_custom-container_transition_timing-function": "{easeEntrance}",
    "mobilebottomsheetinternal_variant_kind_passive_root-container_box-shadow_x": 0,
    "mobilebottomsheetinternal_variant_kind_passive_root-container_box-shadow_y": 4,
    "mobilebottomsheetinternal_variant_kind_passive_root-container_box-shadow_blur": 24,
    "mobilebottomsheetinternal_variant_kind_passive_root-container_box-shadow_spread": 0,
    "mobilebottomsheetinternal_variant_kind_passive_root-container_box-shadow_color": "{custom_color_5}",
    "mobilebottomsheetinternal_variant_close_false_root-container_translate-y": 0,
    "mobilebottomsheetinternal_variant__noButton_true_root-container_padding-bottom": "{m}",
    "mobilebottomsheetinternal_combination_false_true_custom-container_translate-y": 0,
    "mobilebottomsheetinternal_combination_false_true_root-container_translate-y": "{size.max}"
};
const $e3613f6017c674c5$var$DesktopBottomSheetInternalTokens = {
    "desktopbottomsheetinternal_base_container_flex-direction": "{flexDirection.stack}",
    "desktopbottomsheetinternal_base_custom-container_flex-direction": "{flexDirection.column}",
    "desktopbottomsheetinternal_base_custom-container_justify-content": "{justifyContent.start}",
    "desktopbottomsheetinternal_base_custom-container_align-items": "{alignItems.start}",
    "desktopbottomsheetinternal_base_custom-container_background-color": "{primaryBackground}",
    "desktopbottomsheetinternal_base_custom-container_border-top-left-radius": "{xl}",
    "desktopbottomsheetinternal_base_custom-container_border-top-right-radius": "{xl}",
    "desktopbottomsheetinternal_base_custom-container_padding-left": "{m}",
    "desktopbottomsheetinternal_base_custom-container_padding-right": "{m}",
    "desktopbottomsheetinternal_base_custom-container_padding-top": "{m}",
    "desktopbottomsheetinternal_base_custom-container_padding-bottom": "{m}",
    "desktopbottomsheetinternal_base_custom-container_width": "{custom_28}",
    "desktopbottomsheetinternal_base_custom-container_translate-y": "{size.max}",
    "desktopbottomsheetinternal_base_container_justify-content": "{justifyContent.end}",
    "desktopbottomsheetinternal_base_container_align-items": "{alignItems.end}",
    "desktopbottomsheetinternal_base_root-container_width": "{custom_28}",
    "desktopbottomsheetinternal_base_root-container_translate-y": "{size.max}",
    "desktopbottomsheetinternal_base_root-container_transition_duration": "{medium}",
    "desktopbottomsheetinternal_base_root-container_transition_timing-function": "{easeEntrance}",
    "desktopbottomsheetinternal_base_popup-container_flex-direction": "{flexDirection.row}",
    "desktopbottomsheetinternal_base_popup-container_justify-content": "{justifyContent.end}",
    "desktopbottomsheetinternal_base_popup-container_align-items": "{alignItems.end}",
    "desktopbottomsheetinternal_base_popup-container_background-color": "{custom_color_3}",
    "desktopbottomsheetinternal_base_popup-container_size": "{size.max}",
    "desktopbottomsheetinternal_base_root-container_flex-direction": "{flexDirection.column}",
    "desktopbottomsheetinternal_base_root-container_justify-content": "{justifyContent.start}",
    "desktopbottomsheetinternal_base_root-container_background-color": "{primaryBackground}",
    "desktopbottomsheetinternal_base_root-container_align-items": "{alignItems.start}",
    "desktopbottomsheetinternal_base_root-container_border-top-left-radius": "{xl}",
    "desktopbottomsheetinternal_base_root-container_border-top-right-radius": "{xl}",
    "desktopbottomsheetinternal_base_cancel-container_flex-direction": "{flexDirection.row}",
    "desktopbottomsheetinternal_base_cancel-container_justify-content": "{justifyContent.end}",
    "desktopbottomsheetinternal_base_cancel-container_align-items": "{alignItems.center}",
    "desktopbottomsheetinternal_base_cancel-container_width": "{size.max}",
    "desktopbottomsheetinternal_base_cancel-container_padding-top": "{xxs}",
    "desktopbottomsheetinternal_base_cancel-container_padding-bottom": "{xxs}",
    "desktopbottomsheetinternal_base_cancel-container_padding-left": "{xs}",
    "desktopbottomsheetinternal_base_cancel-container_padding-right": "{s}",
    "desktopbottomsheetinternal_base_cancel-container_gap": "{s}",
    "desktopbottomsheetinternal_base_vertical-container_flex-direction": "{flexDirection.column}",
    "desktopbottomsheetinternal_base_vertical-container_justify-content": "{justifyContent.start}",
    "desktopbottomsheetinternal_base_vertical-container_align-items": "{alignItems.start}",
    "desktopbottomsheetinternal_base_vertical-container_padding-left": "{m}",
    "desktopbottomsheetinternal_base_vertical-container_padding-right": "{m}",
    "desktopbottomsheetinternal_base_vertical-container_width": "{size.max}",
    "desktopbottomsheetinternal_base_title-jds_text_padding-bottom": "{xs}",
    "desktopbottomsheetinternal_base_description-jds_text_padding-bottom": "{m}",
    "desktopbottomsheetinternal_base_cta-container_flex-direction": "{flexDirection.column}",
    "desktopbottomsheetinternal_base_cta-container_gap": "{base}",
    "desktopbottomsheetinternal_base_cta-container_width": "{size.max}",
    "desktopbottomsheetinternal_base_cta-container_padding-bottom": "{m}",
    "desktopbottomsheetinternal_base_cta-container_padding-top": "{m}",
    "desktopbottomsheetinternal_base_step-jds_text_padding-right": "{base}",
    "desktopbottomsheetinternal_variant_kind_passive_root-container_box-shadow_color": "{custom_color_5}",
    "desktopbottomsheetinternal_base_popup-container_padding-right": "{bottomsheet_padding_right}",
    "desktopbottomsheetinternal_base_popup-container_opacity": "{opacity.invisible}",
    "desktopbottomsheetinternal_base_popup-container_transition_duration": "{medium}",
    "desktopbottomsheetinternal_base_popup-container_transition_timing-function": "{easeEntrance}",
    "desktopbottomsheetinternal_variant_kind_passive_popup_background-color": "{global.transparent}",
    "desktopbottomsheetinternal_variant_kind_passive_popup-container_background-color": "{global.transparent}",
    "desktopbottomsheetinternal_variant_close_false_popup-container_opacity": "{opacity.enabled}",
    "desktopbottomsheetinternal_variant_close_false_popup-container_transition_timing-function": "{easeExit}"
};
const $e3613f6017c674c5$var$DesktopBottomSheetTokens = {
    "desktopbottomsheet_base_popup-container_flex-direction": "{flexDirection.row}",
    "desktopbottomsheet_base_popup-container_justify-content": "{justifyContent.end}",
    "desktopbottomsheet_base_popup-container_align-items": "{alignItems.end}",
    "desktopbottomsheet_base_popup-container_background-color": "{custom_color_3}",
    "desktopbottomsheet_base_popup-container_size": "{size.max}",
    "desktopbottomsheet_base_root-container_flex-direction": "{flexDirection.column}",
    "desktopbottomsheet_base_root-container_justify-content": "{justifyContent.start}",
    "desktopbottomsheet_base_root-container_background-color": "{primaryBackground}",
    "desktopbottomsheet_base_root-container_align-items": "{alignItems.start}",
    "desktopbottomsheet_base_root-container_border-top-left-radius": "{xl}",
    "desktopbottomsheet_base_root-container_border-top-right-radius": "{xl}",
    "desktopbottomsheet_base_cancel-container_flex-direction": "{flexDirection.row}",
    "desktopbottomsheet_base_cancel-container_justify-content": "{justifyContent.end}",
    "desktopbottomsheet_base_cancel-container_align-items": "{alignItems.center}",
    "desktopbottomsheet_base_cancel-container_width": "{size.max}",
    "desktopbottomsheet_base_cancel-container_padding-top": "{xxs}",
    "desktopbottomsheet_base_cancel-container_padding-bottom": "{xxs}",
    "desktopbottomsheet_base_cancel-container_padding-left": "{xs}",
    "desktopbottomsheet_base_cancel-container_padding-right": "{s}",
    "desktopbottomsheet_base_cancel-container_gap": "{s}",
    "desktopbottomsheet_base_vertical-container_flex-direction": "{flexDirection.column}",
    "desktopbottomsheet_base_vertical-container_justify-content": "{justifyContent.start}",
    "desktopbottomsheet_base_vertical-container_align-items": "{alignItems.start}",
    "desktopbottomsheet_base_vertical-container_padding-left": "{m}",
    "desktopbottomsheet_base_vertical-container_padding-right": "{m}",
    "desktopbottomsheet_base_vertical-container_width": "{size.max}",
    "desktopbottomsheet_base_title-jds_text_padding-bottom": "{xs}",
    "desktopbottomsheet_base_description-jds_text_padding-bottom": "{m}",
    "desktopbottomsheet_base_cta-container_flex-direction": "{flexDirection.column}",
    "desktopbottomsheet_base_cta-container_gap": "{base}",
    "desktopbottomsheet_base_cta-container_width": "{size.max}",
    "desktopbottomsheet_base_cta-container_padding-bottom": "{m}",
    "desktopbottomsheet_base_cta-container_padding-top": "{m}",
    "desktopbottomsheet_base_step-jds_text_padding-right": "{base}",
    "desktopbottomsheet_variant_kind_passive_root-container_box-shadow_color": "{custom_color_5}"
};
const $e3613f6017c674c5$var$carousel_base_container_gap = "{base}";
const $e3613f6017c674c5$var$carousel_base_container_width = "{size.max}";
const $e3613f6017c674c5$var$carousel_variant_density_condensed_container_gap = "{xs}";
const $e3613f6017c674c5$var$CarouselTokens = {
    "carousel_base_container_flex-direction": "{flexDirection.column}",
    "carousel_base_container_justify-content": "{justifyContent.center}",
    "carousel_base_container_align-items": "{alignItems.center}",
    carousel_base_container_gap: $e3613f6017c674c5$var$carousel_base_container_gap,
    carousel_base_container_width: $e3613f6017c674c5$var$carousel_base_container_width,
    "carousel_base_slider-container_width": "{size.max}",
    "carousel_base_control-container_flex-direction": "{flexDirection.row}",
    "carousel_base_control-container_justify-content": "{justifyContent.spaceBetween}",
    "carousel_base_control-container_align-items": "{alignItems.center}",
    "carousel_base_control-container_gap": "{base}",
    "carousel_base_control-container_width": "{size.max}",
    "carousel_base_left-container_max-width": "{size.max}",
    "carousel_base_left-container_flex-direction": "{flexDirection.row}",
    "carousel_base_left-container_justify-content": "{justifyContent.start}",
    "carousel_base_left-container_align-items": "{alignItems.center}",
    "carousel_base_left-container_gap": "{base}",
    "carousel_base_left-container_padding-top": "{xs}",
    "carousel_base_left-container_padding-bottom": "{xs}",
    "carousel_base_prefix-container_flex-direction": "{flexDirection.column}",
    "carousel_base_prefix-container_justify-content": "{justifyContent.center}",
    "carousel_base_prefix-container_align-items": "{alignItems.start}",
    "carousel_base_progress-container_flex-direction": "{flexDirection.stack}",
    "carousel_base_progress-container_justify-content": "{justifyContent.center}",
    "carousel_base_progress-container_align-items": "{alignItems.center}",
    "carousel_base_inner-container_flex-direction": "{flexDirection.row}",
    "carousel_base_inner-container_justify-content": "{justifyContent.start}",
    "carousel_base_inner-container_align-items": "{alignItems.start}",
    "carousel_base_right-container_max-width": "{size.max}",
    "carousel_base_right-container_flex-direction": "{flexDirection.row}",
    "carousel_base_right-container_justify-content": "{justifyContent.end}",
    "carousel_base_right-container_align-items": "{alignItems.start}",
    "carousel_base_right-container_gap": "{s}",
    "carousel_base_right-container_padding-top": "{xs}",
    "carousel_base_right-container_padding-bottom": "{xs}",
    carousel_variant_density_condensed_container_gap: $e3613f6017c674c5$var$carousel_variant_density_condensed_container_gap
};
const $e3613f6017c674c5$var$carouselpaginationitem_base_container_width = "{s}";
const $e3613f6017c674c5$var$carouselpaginationitem_base_container_height = "{s}";
const $e3613f6017c674c5$var$carouselpaginationitem_base_container_opacity = "{opacity.disabled}";
const $e3613f6017c674c5$var$carouselpaginationitem_base_container_behavior_hover_opacity = "{opacity.enabled}";
const $e3613f6017c674c5$var$carouselpaginationitem_base_container_behavior_active_opacity = "{opacity.enabled}";
const $e3613f6017c674c5$var$carouselpaginationitem_variant_density_condensed_container_height = "{xs}";
const $e3613f6017c674c5$var$carouselpaginationitem_variant_active_true_container_opacity = "{opacity.enabled}";
const $e3613f6017c674c5$var$carouselpaginationitem_combination_relaxed_false_normal_container_width = "{s}";
const $e3613f6017c674c5$var$carouselpaginationitem_combination_relaxed_false_tail_dot_large_container_width = "{xs}";
const $e3613f6017c674c5$var$carouselpaginationitem_combination_relaxed_false_tail_dot_large_container_height = "{xs}";
const $e3613f6017c674c5$var$carouselpaginationitem_combination_relaxed_false_tail_dot_small_container_width = "{custom_15}";
const $e3613f6017c674c5$var$carouselpaginationitem_combination_relaxed_false_tail_dot_small_container_height = "{custom_15}";
const $e3613f6017c674c5$var$carouselpaginationitem_combination_condensed_false_normal_container_width = "{xs}";
const $e3613f6017c674c5$var$carouselpaginationitem_combination_condensed_false_tail_dot_large_container_width = "{custom_15}";
const $e3613f6017c674c5$var$carouselpaginationitem_combination_condensed_false_tail_dot_large_container_height = "{custom_15}";
const $e3613f6017c674c5$var$carouselpaginationitem_combination_condensed_false_tail_dot_small_container_width = "{xxs}";
const $e3613f6017c674c5$var$carouselpaginationitem_combination_condensed_false_tail_dot_small_container_height = "{xxs}";
const $e3613f6017c674c5$var$carouselpaginationitem_combination_condensed_true_normal_container_width = "{m}";
const $e3613f6017c674c5$var$carouselpaginationitem_combination_condensed_true_tail_dot_large_container_width = "{m}";
const $e3613f6017c674c5$var$carouselpaginationitem_combination_condensed_true_tail_dot_small_container_width = "{m}";
const $e3613f6017c674c5$var$carouselpaginationitem_combination_relaxed_true_normal_container_width = "{l}";
const $e3613f6017c674c5$var$carouselpaginationitem_combination_relaxed_true_tail_dot_large_container_width = "{l}";
const $e3613f6017c674c5$var$carouselpaginationitem_combination_relaxed_true_tail_dot_small_container_width = "{l}";
const $e3613f6017c674c5$var$CarouselPaginationItemTokens = {
    carouselpaginationitem_base_container_width: $e3613f6017c674c5$var$carouselpaginationitem_base_container_width,
    carouselpaginationitem_base_container_height: $e3613f6017c674c5$var$carouselpaginationitem_base_container_height,
    "carouselpaginationitem_base_container_background-color": "{primary60}",
    carouselpaginationitem_base_container_opacity: $e3613f6017c674c5$var$carouselpaginationitem_base_container_opacity,
    "carouselpaginationitem_base_container_border-radius": "{pill}",
    "carouselpaginationitem_base_container_behavior_hover_background-color": "{primary40}",
    carouselpaginationitem_base_container_behavior_hover_opacity: $e3613f6017c674c5$var$carouselpaginationitem_base_container_behavior_hover_opacity,
    "carouselpaginationitem_base_container_behavior_active_background-color": "{primary60}",
    carouselpaginationitem_base_container_behavior_active_opacity: $e3613f6017c674c5$var$carouselpaginationitem_base_container_behavior_active_opacity,
    carouselpaginationitem_variant_density_condensed_container_height: $e3613f6017c674c5$var$carouselpaginationitem_variant_density_condensed_container_height,
    carouselpaginationitem_variant_active_true_container_opacity: $e3613f6017c674c5$var$carouselpaginationitem_variant_active_true_container_opacity,
    "carouselpaginationitem_variant_active_true_container_behavior_hover_background-color": "{primary70}",
    "carouselpaginationitem_variant_active_true_container_behavior_active_background-color": "{primary70}",
    carouselpaginationitem_combination_relaxed_false_normal_container_width: $e3613f6017c674c5$var$carouselpaginationitem_combination_relaxed_false_normal_container_width,
    carouselpaginationitem_combination_relaxed_false_tail_dot_large_container_width: $e3613f6017c674c5$var$carouselpaginationitem_combination_relaxed_false_tail_dot_large_container_width,
    carouselpaginationitem_combination_relaxed_false_tail_dot_large_container_height: $e3613f6017c674c5$var$carouselpaginationitem_combination_relaxed_false_tail_dot_large_container_height,
    carouselpaginationitem_combination_relaxed_false_tail_dot_small_container_width: $e3613f6017c674c5$var$carouselpaginationitem_combination_relaxed_false_tail_dot_small_container_width,
    carouselpaginationitem_combination_relaxed_false_tail_dot_small_container_height: $e3613f6017c674c5$var$carouselpaginationitem_combination_relaxed_false_tail_dot_small_container_height,
    carouselpaginationitem_combination_condensed_false_normal_container_width: $e3613f6017c674c5$var$carouselpaginationitem_combination_condensed_false_normal_container_width,
    carouselpaginationitem_combination_condensed_false_tail_dot_large_container_width: $e3613f6017c674c5$var$carouselpaginationitem_combination_condensed_false_tail_dot_large_container_width,
    carouselpaginationitem_combination_condensed_false_tail_dot_large_container_height: $e3613f6017c674c5$var$carouselpaginationitem_combination_condensed_false_tail_dot_large_container_height,
    carouselpaginationitem_combination_condensed_false_tail_dot_small_container_width: $e3613f6017c674c5$var$carouselpaginationitem_combination_condensed_false_tail_dot_small_container_width,
    carouselpaginationitem_combination_condensed_false_tail_dot_small_container_height: $e3613f6017c674c5$var$carouselpaginationitem_combination_condensed_false_tail_dot_small_container_height,
    carouselpaginationitem_combination_condensed_true_normal_container_width: $e3613f6017c674c5$var$carouselpaginationitem_combination_condensed_true_normal_container_width,
    carouselpaginationitem_combination_condensed_true_tail_dot_large_container_width: $e3613f6017c674c5$var$carouselpaginationitem_combination_condensed_true_tail_dot_large_container_width,
    carouselpaginationitem_combination_condensed_true_tail_dot_small_container_width: $e3613f6017c674c5$var$carouselpaginationitem_combination_condensed_true_tail_dot_small_container_width,
    carouselpaginationitem_combination_relaxed_true_normal_container_width: $e3613f6017c674c5$var$carouselpaginationitem_combination_relaxed_true_normal_container_width,
    carouselpaginationitem_combination_relaxed_true_tail_dot_large_container_width: $e3613f6017c674c5$var$carouselpaginationitem_combination_relaxed_true_tail_dot_large_container_width,
    carouselpaginationitem_combination_relaxed_true_tail_dot_small_container_width: $e3613f6017c674c5$var$carouselpaginationitem_combination_relaxed_true_tail_dot_small_container_width
};
const $e3613f6017c674c5$var$carouselpagination_base_container_gap = "{s}";
const $e3613f6017c674c5$var$carouselpagination_base_container_width = "{size.max}";
const $e3613f6017c674c5$var$carouselpagination_variant_density_condensed_container_gap = "{xs}";
const $e3613f6017c674c5$var$CarouselPaginationTokens = {
    "carouselpagination_base_container_flex-direction": "{flexDirection.row}",
    "carouselpagination_base_container_justify-content": "{justifyContent.center}",
    "carouselpagination_base_container_align-items": "{alignItems.center}",
    carouselpagination_base_container_gap: $e3613f6017c674c5$var$carouselpagination_base_container_gap,
    "carouselpagination_base_container_padding-top": "{xs}",
    carouselpagination_base_container_width: $e3613f6017c674c5$var$carouselpagination_base_container_width,
    "carouselpagination_base_container_padding-bottom": "{xs}",
    carouselpagination_variant_density_condensed_container_gap: $e3613f6017c674c5$var$carouselpagination_variant_density_condensed_container_gap
};
const $e3613f6017c674c5$var$button_base_container_opacity = "{opacity.enabled}";
const $e3613f6017c674c5$var$button_base_container_gap = "{xs}";
const $e3613f6017c674c5$var$button_base_loader_color = "{primaryInverse}";
const $e3613f6017c674c5$var$button_base_loader_opacity = "{opacity.enabled}";
const $e3613f6017c674c5$var$button_base_loader_size = "{base}";
const $e3613f6017c674c5$var$button_variant_fullWidth_true_container_width = "{size.max}";
const $e3613f6017c674c5$var$button_variant_disabled_true_container_opacity = "{opacity.disabled}";
const $e3613f6017c674c5$var$button_combination_primary_destructive_loader_color = "{feedbackError80}";
const $e3613f6017c674c5$var$button_combination_primary_positive_loader_color = "{feedbackSuccess80}";
const $e3613f6017c674c5$var$button_combination_secondary_normal_loader_color = "{primary60}";
const $e3613f6017c674c5$var$button_combination_secondary_destructive_loader_color = "{feedbackError80}";
const $e3613f6017c674c5$var$button_combination_secondary_positive_loader_color = "{feedbackSuccess80}";
const $e3613f6017c674c5$var$button_combination_tertiary_normal_loader_color = "{primary60}";
const $e3613f6017c674c5$var$button_combination_tertiary_destructive_loader_color = "{feedbackError80}";
const $e3613f6017c674c5$var$button_combination_tertiary_positive_loader_color = "{feedbackSuccess80}";
const $e3613f6017c674c5$var$button_combination_true_small_loader_size = "{base}";
const $e3613f6017c674c5$var$button_combination_true_medium_loader_size = "{m}";
const $e3613f6017c674c5$var$button_combination_true_large_loader_size = "{m}";
const $e3613f6017c674c5$var$button_combination_false_small_loader_size = "{base}";
const $e3613f6017c674c5$var$button_combination_false_medium_loader_size = "{m}";
const $e3613f6017c674c5$var$button_combination_false_large_loader_size = "{m}";
const $e3613f6017c674c5$var$ButtonTokens = {
    button_base_container_opacity: $e3613f6017c674c5$var$button_base_container_opacity,
    "button_base_container_background-color": "{primary50}",
    "button_base_container_flex-direction": "{flexDirection.row}",
    "button_base_container_align-items": "{alignItems.center}",
    "button_base_container_justify-content": "{justifyContent.center}",
    "button_base_container_border-radius": "{pill}",
    "button_base_container_border-width": "0",
    "button_base_container_border-color": "",
    button_base_container_gap: $e3613f6017c674c5$var$button_base_container_gap,
    "button_combination_tertiary_normal_container_border-width": 0,
    "button_base_container_behavior_hover_background-color": "{primary60}",
    "button_base_container_behavior_active_background-color": "{primary60}",
    "button_base_container_behavior_focus_border-width": "{border_focus}",
    "button_base_container_behavior_focus_border-color": "{primary80}",
    "button_base_left-container_flex-direction": "{flexDirection.row}",
    "button_base_left-container_align-items": "{alignItems.center}",
    "button_base_left-container_justify-content": "{justifyContent.start}",
    "button_base_left-container_gap": "{xs}",
    button_base_loader_color: $e3613f6017c674c5$var$button_base_loader_color,
    "button_base_loader_background-color": "{global.transparent}",
    "button_base_loader_border-width": "{border_focus}",
    button_base_loader_opacity: $e3613f6017c674c5$var$button_base_loader_opacity,
    button_base_loader_size: $e3613f6017c674c5$var$button_base_loader_size,
    "button_base_left-icon_size": "{m}",
    "button_base_left-icon_color": "{primaryInverse}",
    "button_base_right-icon_size": "{m}",
    "button_base_right-icon_color": "{primaryInverse}",
    button_variant_fullWidth_true_container_width: $e3613f6017c674c5$var$button_variant_fullWidth_true_container_width,
    "button_variant_fullWidth_true_container_justify-content": "{justifyContent.spaceBetween}",
    button_variant_disabled_true_container_opacity: $e3613f6017c674c5$var$button_variant_disabled_true_container_opacity,
    "button_combination_primary_normal_left-icon_behavior_active_color": "{primary30}",
    "button_combination_primary_normal_right-icon_behavior_active_color": "{primary30}",
    "button_combination_primary_destructive_container_background-color": "{feedbackError20}",
    "button_combination_primary_destructive_container_behavior_hover_background-color": "{feedbackError50}",
    "button_combination_primary_destructive_container_behavior_active_background-color": "{feedbackError80}",
    "button_combination_primary_destructive_container_behavior_focus_border-color": "{feedbackError50}",
    button_combination_primary_destructive_loader_color: $e3613f6017c674c5$var$button_combination_primary_destructive_loader_color,
    "button_combination_primary_destructive_left-icon_color": "{feedbackError80}",
    "button_combination_primary_destructive_left-icon_behavior_hover_color": "{global.white}",
    "button_combination_primary_destructive_left-icon_behavior_active_color": "{feedbackError20}",
    "button_combination_primary_destructive_right-icon_behavior_hover_color": "{global.white}",
    "button_combination_primary_destructive_right-icon_color": "{feedbackError80}",
    "button_combination_primary_destructive_right-icon_behavior_active_color": "{feedbackError20}",
    "button_combination_primary_positive_container_background-color": "{feedbackSuccess20}",
    "button_combination_primary_positive_container_behavior_hover_background-color": "{feedbackSuccess50}",
    "button_combination_primary_positive_container_behavior_active_background-color": "{feedbackSuccess80}",
    "button_combination_primary_positive_container_behavior_focus_border-color": "{feedbackSuccess50}",
    button_combination_primary_positive_loader_color: $e3613f6017c674c5$var$button_combination_primary_positive_loader_color,
    "button_combination_primary_positive_left-icon_color": "{feedbackSuccess80}",
    "button_combination_primary_positive_left-icon_behavior_hover_color": "{global.white}",
    "button_combination_primary_positive_left-icon_behavior_active_color": "{feedbackSuccess20}",
    "button_combination_primary_positive_right-icon_color": "{feedbackSuccess80}",
    "button_combination_primary_positive_right-icon_behavior_hover_color": "{global.white}",
    "button_combination_primary_positive_right-icon_behavior_active_color": "{feedbackSuccess20}",
    "button_combination_secondary_normal_container_background-color": "{global.transparent}",
    "button_combination_secondary_normal_container_border-width": "{border_thin}",
    "button_combination_secondary_normal_container_border-color": "{primaryGrey40}",
    "button_combination_secondary_normal_container_behavior_hover_border-color": "{primary60}",
    "button_combination_secondary_normal_container_behavior_hover_background-color": "{global.transparent}",
    "button_combination_secondary_normal_container_behavior_active_background-color": "{primary20}",
    "button_combination_secondary_normal_container_behavior_active_border-color": "{primary60}",
    "button_combination_secondary_normal_container_behavior_focus_border-color": "{primary80}",
    button_combination_secondary_normal_loader_color: $e3613f6017c674c5$var$button_combination_secondary_normal_loader_color,
    "button_combination_secondary_normal_left-icon_color": "{primary60}",
    "button_combination_secondary_normal_right-icon_color": "{primary60}",
    "button_combination_secondary_destructive_container_background-color": "{global.transparent}",
    "button_combination_secondary_destructive_container_border-width": "{border_thin}",
    "button_combination_secondary_destructive_container_border-color": "{primaryGrey40}",
    "button_combination_secondary_destructive_container_behavior_active_background-color": "{feedbackError20}",
    "button_combination_secondary_destructive_container_behavior_active_border-color": "{feedbackError80}",
    "button_combination_secondary_destructive_container_behavior_focus_border-color": "{feedbackError50}",
    "button_combination_secondary_destructive_container_behavior_focus_border-width": "{border_focus}",
    button_combination_secondary_destructive_loader_color: $e3613f6017c674c5$var$button_combination_secondary_destructive_loader_color,
    "button_combination_secondary_destructive_left-icon_color": "{feedbackError80}",
    "button_combination_secondary_destructive_right-icon_color": "{feedbackError80}",
    "button_combination_secondary_positive_container_background-color": "{global.transparent}",
    "button_combination_secondary_positive_container_border-width": "{border_thin}",
    "button_combination_secondary_positive_container_border-color": "{primaryGrey40}",
    "button_combination_secondary_positive_container_behavior_active_background-color": "{feedbackSuccess20}",
    "button_combination_secondary_positive_container_behavior_active_border-color": "{feedbackSuccess80}",
    "button_combination_secondary_positive_container_behavior_focus_border-color": "{feedbackSuccess50}",
    "button_combination_secondary_positive_container_behavior_focus_border-width": "{border_focus}",
    button_combination_secondary_positive_loader_color: $e3613f6017c674c5$var$button_combination_secondary_positive_loader_color,
    "button_combination_secondary_positive_left-icon_color": "{feedbackSuccess80}",
    "button_combination_secondary_positive_right-icon_color": "{feedbackSuccess80}",
    "button_combination_tertiary_normal_container_background-color": "{global.transparent}",
    "button_combination_tertiary_normal_container_behavior_hover_background-color": "{primary20}",
    "button_combination_tertiary_normal_container_behavior_active_background-color": "{primary30}",
    "button_combination_tertiary_normal_container_behavior_focus_border-color": "{primary80}",
    "button_combination_tertiary_normal_container_behavior_focus_background-color": "{primary20}",
    button_combination_tertiary_normal_loader_color: $e3613f6017c674c5$var$button_combination_tertiary_normal_loader_color,
    "button_combination_tertiary_normal_left-icon_color": "{primary60}",
    "button_combination_tertiary_normal_right-icon_color": "{primary60}",
    "button_combination_tertiary_destructive_container_background-color": "{global.transparent}",
    "button_combination_tertiary_destructive_container_behavior_hover_background-color": "{feedbackError20}",
    "button_combination_tertiary_destructive_container_behavior_active_background-color": "{feedbackError80}",
    "button_combination_tertiary_destructive_container_behavior_focus_border-color": "{feedbackError50}",
    "button_combination_tertiary_destructive_container_behavior_focus_border-width": "{border_focus}",
    "button_combination_tertiary_destructive_container_behavior_focus_background-color": "{feedbackError20}",
    button_combination_tertiary_destructive_loader_color: $e3613f6017c674c5$var$button_combination_tertiary_destructive_loader_color,
    "button_combination_tertiary_destructive_left-icon_color": "{feedbackError80}",
    "button_combination_tertiary_destructive_right-icon_color": "{feedbackError80}",
    "button_combination_tertiary_positive_container_background-color": "{global.transparent}",
    "button_combination_tertiary_positive_container_behavior_active_background-color": "{feedbackSuccess20}",
    "button_combination_tertiary_positive_container_behavior_focus_border-color": "{feedbackSuccess50}",
    "button_combination_tertiary_positive_container_behavior_focus_border-width": "{border_focus}",
    button_combination_tertiary_positive_loader_color: $e3613f6017c674c5$var$button_combination_tertiary_positive_loader_color,
    "button_combination_tertiary_positive_left-icon_color": "{feedbackSuccess80}",
    "button_combination_tertiary_positive_right-icon_color": "{feedbackSuccess80}",
    "button_combination_true_small_container_padding-top": "{xxs}",
    "button_combination_true_small_container_padding-right": "{base}",
    "button_combination_true_small_container_padding-bottom": "{xxs}",
    "button_combination_true_small_container_padding-left": "{base}",
    "button_combination_true_small_left-icon_size": "{base}",
    "button_combination_true_small_right-icon_size": "{base}",
    button_combination_true_small_loader_size: $e3613f6017c674c5$var$button_combination_true_small_loader_size,
    "button_combination_true_medium_container_padding-top": "{s}",
    "button_combination_true_medium_container_padding-right": "{base}",
    "button_combination_true_medium_container_padding-bottom": "{s}",
    "button_combination_true_medium_container_padding-left": "{base}",
    "button_combination_true_medium_left-icon_size": "{m}",
    "button_combination_true_medium_right-icon_size": "{m}",
    button_combination_true_medium_loader_size: $e3613f6017c674c5$var$button_combination_true_medium_loader_size,
    "button_combination_true_large_container_padding-top": "{base}",
    "button_combination_true_large_container_padding-left": "{m}",
    "button_combination_true_large_container_padding-bottom": "{base}",
    "button_combination_true_large_container_padding-right": "{m}",
    "button_combination_true_large_left-icon_size": "{m}",
    "button_combination_true_large_right-icon_size": "{m}",
    button_combination_true_large_loader_size: $e3613f6017c674c5$var$button_combination_true_large_loader_size,
    "button_combination_false_small_container_min-height": "{l}",
    "button_combination_false_small_container_min-width": "{l}",
    "button_combination_false_small_left-icon_size": "{base}",
    "button_combination_false_small_right-icon_size": "{base}",
    button_combination_false_small_loader_size: $e3613f6017c674c5$var$button_combination_false_small_loader_size,
    "button_combination_false_medium_container_min-height": "{xxl}",
    "button_combination_false_medium_container_min-width": "{xxl}",
    "button_combination_false_medium_left-icon_size": "{m}",
    "button_combination_false_medium_right-icon_size": "{m}",
    button_combination_false_medium_loader_size: $e3613f6017c674c5$var$button_combination_false_medium_loader_size,
    "button_combination_false_large_left-icon_size": "{m}",
    "button_combination_false_large_right-icon_size": "{m}",
    button_combination_false_large_loader_size: $e3613f6017c674c5$var$button_combination_false_large_loader_size,
    "button_combination_true_true_true_false_false_container_justify-content": "{justifyContent.center}",
    "button_combination_true_true_true_false_true_container_justify-content": "{justifyContent.center}",
    "button_combination_true_false_false_true_false_container_justify-content": "{justifyContent.center}",
    "button_combination_true_false_false_false_true_container_justify-content": "{justifyContent.center}",
    "button_combination_true_false_true_true_false_container_justify-content": "{justifyContent.center}"
};
const $e3613f6017c674c5$var$ContentCardTokens = {
    "contentcard_base_root-container_width": "{size.max}",
    "contentcard_base_root-container_border-radius": "{xl}",
    "contentcard_base_root-container_flex-direction": "{flexDirection.column}",
    "contentcard_base_root-container_justify-content": "{justifyContent.start}",
    "contentcard_base_root-container_align-items": "{alignItems.start}",
    "contentcard_base_root-container_background-color": "{primaryBackground}",
    "contentcard_base_header-container_justify-content": "{justifyContent.start}",
    "contentcard_base_header-container_align-items": "{alignItems.start}",
    "contentcard_base_header-container_width": "{size.max}",
    "contentcard_base_header-container_padding-left": "{base}",
    "contentcard_base_header-container_padding-right": "{base}",
    "contentcard_base_header-container_padding-top": "{base}",
    "contentcard_base_children-container_justify-content": "{justifyContent.start}",
    "contentcard_base_children-container_align-items": "{alignItems.start}",
    "contentcard_base_children-container_width": "{size.max}",
    "contentcard_base_children-container_padding-left": "{base}",
    "contentcard_base_children-container_padding-right": "{base}",
    "contentcard_base_children-container_padding-bottom": "{base}",
    "contentcard_base_image-content-container_flex-direction": "{flexDirection.column}",
    "contentcard_base_image-content-container_width": "{size.max}",
    "contentcard_base_image-content-container_justify-content": "{justifyContent.start}",
    "contentcard_base_image-content-container_align-items": "{alignItems.start}",
    "contentcard_base_image-content-container_padding-top": "{base}",
    "contentcard_base_image-content-container_padding-bottom": "{base}",
    "contentcard_base_jds_content_block_padding-left": "{base}",
    "contentcard_base_jds_content_block_padding-right": "{base}",
    "contentcard_base_jds_content_block_padding-top": "{base}",
    "contentcard_base_footer-jds_text_padding-left": "{base}",
    "contentcard_base_footer-jds_text_padding-right": "{base}",
    "contentcard_base_footer-jds_text_padding-bottom": "{base}",
    "contentcard_combination_true_horizontal_image-content-container_padding-left": "{base}",
    "contentcard_combination_true_horizontal_image-content-container_padding-top": "{base}",
    "contentcard_combination_true_horizontal_image-content-container_flex-direction": "{flexDirection.row}",
    "contentcard_combination_true_vertical_root-container_width": "{custom_10}",
    "contentcard_combination_false_horizontal_root-container_width": "{size.max}",
    "contentcard_combination_false_horizontal_image-content-container_padding-left": "{base}",
    "contentcard_combination_false_horizontal_image-content-container_padding-top": "{base}",
    "contentcard_combination_false_horizontal_image-content-container_flex-direction": "{flexDirection.row}",
    "contentcard_combination_true_vertical_mobile_root-container_width": "{size.max}"
};
const $e3613f6017c674c5$var$carouselslide_base_container_width = "{size.max}";
const $e3613f6017c674c5$var$carouselslide_base_jds_image_width = "{size.max}";
const $e3613f6017c674c5$var$CarouselSlideTokens = {
    carouselslide_base_container_width: $e3613f6017c674c5$var$carouselslide_base_container_width,
    "carouselslide_base_container_border-radius": "{small}",
    carouselslide_base_jds_image_width: $e3613f6017c674c5$var$carouselslide_base_jds_image_width
};
const $e3613f6017c674c5$var$ContentBlockTokens = {
    "contentblock_base_root-container_flex-direction": "{flexDirection.column}",
    "contentblock_base_root-container_align-items": "{alignItems.start}",
    "contentblock_base_root-container_justify-content": "{justifyContent.start}",
    "contentblock_base_root-container_width": "{size.max}",
    "contentblock_base_inner-container_flex-direction": "{flexDirection.column}",
    "contentblock_base_inner-container_align-items": "{alignItems.start}",
    "contentblock_base_inner-container_justify-content": "{justifyContent.start}",
    "contentblock_base_inner-container_width": "{size.max}",
    "contentblock_base_caption-container_padding-bottom": "{xs}",
    "contentblock_base_title-jds_text_padding-bottom": "{xxs}",
    "contentblock_base_description-jds_text_padding-bottom": "{m}",
    "contentblock_base_children-container_padding-bottom": "{m}",
    "contentblock_base_button-container_flex-direction": "{flexDirection.row}",
    "contentblock_base_button-container_width": "{size.max}",
    "contentblock_base_button-container_gap": "{xs}",
    "contentblock_variant_size_small_title-jds_text_padding-bottom": "{s}",
    "contentblock_variant_size_medium_caption-container_padding-bottom": "{s}",
    "contentblock_variant_size_medium_title-jds_text_padding-bottom": "{s}",
    "contentblock_variant_size_medium_button-container_gap": "{s}",
    "contentblock_variant_size_large_caption-container_padding-bottom": "{base}",
    "contentblock_variant_size_large_title-jds_text_padding-bottom": "{base}",
    "contentblock_variant_size_large_children-container_padding-bottom": "{l}",
    "contentblock_variant_size_large_button-container_gap": "{s}",
    "contentblock_variant_size_xtra-large_caption-container_padding-bottom": "{base}",
    "contentblock_variant_size_xtra-large_title-jds_text_padding-bottom": "{base}",
    "contentblock_variant_size_xtra-large_children-container_padding-bottom": "{l}",
    "contentblock_variant_size_xtra-large_button-container_gap": "{s}",
    "contentblock_variant_ctaWrap_vertical_button-container_flex-direction": "{flexDirection.column}",
    "contentblock_variant_singleButton_false_inner-container_width": "{size.max}",
    "contentblock_variant_singleButton_false_button-container_width": "{size.max}",
    "contentblock_combination_desktop_medium_title-jds_text_padding-bottom": "{base}",
    "contentblock_combination_desktop_large_title-jds_text_padding-bottom": "{m}",
    "contentblock_combination_desktop_xtra-large_title-jds_text_padding-bottom": "{m}",
    "contentblock_combination_true_xtra-xtra-small_root-container_flex-direction": "{flexDirection.row}",
    "contentblock_combination_true_xtra-xtra-small_root-container_justify-content": "{justifyContent.spaceBetween}",
    "contentblock_combination_true_xtra-xtra-small_root-container_align-items": "{alignItems.center}",
    "contentblock_combination_true_xtra-xtra-small_button-container_flex-direction": "{flexDirection.row}",
    "contentblock_combination_true_xtra-xtra-small_button-container_justify-content": "{justifyContent.end}",
    "contentblock_combination_true_xtra-xtra-small_button-container_align-items": "{alignItems.center}"
};
const $e3613f6017c674c5$var$CheckboxTokens = {
    "checkbox_base_vertical-container_flex-direction": "{flexDirection.column}",
    "checkbox_base_vertical-container_justify-content": "{justifyContent.start}",
    "checkbox_base_vertical-container_align-items": "{alignItems.start}",
    "checkbox_base_vertical-container_gap": "{xs}",
    "checkbox_base_horizontal-container_flex-direction": "{flexDirection.row}",
    "checkbox_base_horizontal-container_justify-content": "{justifyContent.start}",
    "checkbox_base_horizontal-container_align-items": "{alignItems.center}",
    "checkbox_base_horizontal-container_gap": "{xs}",
    "checkbox_base_control-container_min-width": "{m}",
    "checkbox_base_control-container_min-height": "{m}",
    "checkbox_base_control-container_flex-direction": "{flexDirection.row}",
    "checkbox_base_control-container_justify-content": "{justifyContent.center}",
    "checkbox_base_control-container_align-items": "{alignItems.center}",
    "checkbox_base_control-container_background-color": "{global.transparent}",
    "checkbox_base_control-container_border-radius": "{small}",
    "checkbox_base_control-container_border-width": "{border_thin}",
    "checkbox_base_control-container_border-color": "{primaryGrey80}",
    "checkbox_base_control-container_behavior_hover_border-color": "{primary40}",
    "checkbox_base_control-container_behavior_active_border-color": "{primary60}",
    "checkbox_base_control-container_behavior_focus_border-width": "{border_focus}",
    "checkbox_base_control-container_behavior_focus_border-color": "{primary60}",
    "checkbox_base_control-icon_size": "{base}",
    "checkbox_base_label-jds_text_text-align": "{textAlign.start}",
    "checkbox_variant_size_small_control-container_min-width": "{base}",
    "checkbox_variant_size_small_control-container_min-height": "{base}",
    "checkbox_variant_size_small_vertical-container_gap": "{xxs}",
    "checkbox_variant_size_small_control-icon_size": "{s}",
    "checkbox_variant_checked_true_control-icon_value": "ic_confirm",
    "checkbox_variant_checked_true_control-container_background-color": "{primary50}",
    "checkbox_variant_checked_true_control-container_behavior_hover_background-color": "{primary40}",
    "checkbox_variant_checked_true_control-container_behavior_active_background-color": "{primary60}",
    "checkbox_variant_checked_true_control-icon_color": "{primaryInverse}",
    "checkbox_variant_indeterminate_true_control-icon_value": "ic_minus",
    "checkbox_variant_indeterminate_true_control-container_background-color": "{primary50}",
    "checkbox_variant_indeterminate_true_control-container_behavior_hover_background-color": "{primary40}",
    "checkbox_variant_indeterminate_true_control-container_behavior_focus_background-color": "{primary50}",
    "checkbox_variant_indeterminate_true_control-icon_color": "{primaryInverse}",
    "checkbox_variant_disabled_true_vertical-container_opacity": "{opacity.disabled}",
    "checkbox_base_vertical-container_opacity": "{opacity.enabled}"
};
const $e3613f6017c674c5$var$datepickercalendarbutton_base_container_width = "{custom_7}";
const $e3613f6017c674c5$var$datepickercalendarbutton_button_container_width = "{m}";
const $e3613f6017c674c5$var$datepickercalendarbutton_base_container_height = "{xxl}";
const $e3613f6017c674c5$var$datepickercalendarbutton_button_container_height = "{m}";
const $e3613f6017c674c5$var$datepickercalendarbutton_variant_disabled_true_container_opacity = "{opacity.disabled}";
const $e3613f6017c674c5$var$DatepickerCalendarButtonTokens = {
    "datepickercalendarbutton_base_container_flex-direction": "{flexDirection.row}",
    "datepickercalendarbutton_base_container_justify-content": "{justifyContent.center}",
    "datepickercalendarbutton_base_container_align-items": "{alignItems.center}",
    datepickercalendarbutton_base_container_width: $e3613f6017c674c5$var$datepickercalendarbutton_base_container_width,
    datepickercalendarbutton_button_container_width: $e3613f6017c674c5$var$datepickercalendarbutton_button_container_width,
    "datepickercalendarbutton_base_root-container_max_width": "{size.max}",
    datepickercalendarbutton_base_container_height: $e3613f6017c674c5$var$datepickercalendarbutton_base_container_height,
    datepickercalendarbutton_button_container_height: $e3613f6017c674c5$var$datepickercalendarbutton_button_container_height,
    "datepickercalendarbutton_base_button-container_flex-direction": "{flexDirection.row}",
    "datepickercalendarbutton_base_button-container_justify-content": "{justifyContent.center}",
    "datepickercalendarbutton_base_button-container_align-items": "{alignItems.center}",
    "datepickercalendarbutton_base_button-container_width": "{xxl}",
    "datepickercalendarbutton_base_button-container_instrinsic_width": "{intrinsicSize.min}",
    "datepickercalendarbutton_base_button-container_height": "{xxl}",
    "datepickercalendarbutton_base_button-container_border-radius": "{pill}",
    "datepickercalendarbutton_base_button-container_border-color": "{primaryGrey100}",
    "datepickercalendarbutton_base_button-container_background-color": "{global.transparent}",
    "datepickercalendarbutton_base_button-container_behavior_hover_background-color": "{primary20}",
    "datepickercalendarbutton_base_button-container_behavior_active_background-color": "{primary40}",
    "datepickercalendarbutton_base_button-container_behavior_focus_background-color": "{primary20}",
    "datepickercalendarbutton_base_button-container_behavior_focus_border-width": "{border_focus}",
    "datepickercalendarbutton_variant_state_selected_button-container_background-color": "{primary50}",
    "datepickercalendarbutton_variant_state_current_button-container_background-color": "{primary20}",
    datepickercalendarbutton_variant_disabled_true_container_opacity: $e3613f6017c674c5$var$datepickercalendarbutton_variant_disabled_true_container_opacity,
    "datepickerbutton_base_container_padding-right": "{base}",
    "datepickerbutton_base_container_padding-left": "{base}"
};
const $e3613f6017c674c5$var$datepickerbutton_base_container_height = "{xxl}";
const $e3613f6017c674c5$var$datepickerbutton_base_container_gap = "{xs}";
const $e3613f6017c674c5$var$datepickerbutton_variant_state_disabled_container_opacity = "{opacity.disabled}";
const $e3613f6017c674c5$var$DatepickerButtonTokens = {
    datepickerbutton_base_container_height: $e3613f6017c674c5$var$datepickerbutton_base_container_height,
    "datepickerbutton_base_container_max-width": "{custom_9}",
    "datepickerbutton_base_container_border-radius": "{pill}",
    "datepickerbutton_base_container_background-color": "{global.transparent}",
    "datepickerbutton_base_container_border-width": "{border_thin}",
    "datepickerbutton_base_container_border-color": "{primaryGrey40}",
    "datepickerbutton_base_container_flex-direction": "{flexDirection.row}",
    "datepickerbutton_base_container_justify-content": "{justifyContent.center}",
    "datepickerbutton_base_container_align-items": "{alignItems.center}",
    datepickerbutton_base_container_gap: $e3613f6017c674c5$var$datepickerbutton_base_container_gap,
    "datepickerbutton_base_container_padding-right": "{base}",
    "datepickerbutton_base_container_padding-left": "{base}",
    "datepickerbutton_base_container_behavior_hover_border-color": "{primary60}",
    "datepickerbutton_base_container_behavior_focus_border-color": "{primaryGrey100}",
    "datepickerbutton_base_container_behavior_focus_border-width": "{border_focus}",
    "datepickerbutton_base_container_behavior_active_border-color": "{primary60}",
    "datepickerbutton_base_container_behavior_active_background-color": "{primary20}",
    "datepickerbutton_variant_state_selected_container_background-color": "{primary20}",
    "datepickerbutton_variant_state_selected_container_border-color": "{primary60}",
    "datepickerbutton_variant_state_disabled_container_border-width": "{border_none}",
    datepickerbutton_variant_state_disabled_container_opacity: $e3613f6017c674c5$var$datepickerbutton_variant_state_disabled_container_opacity,
    "datepickerbutton_variant_state_text_only_container_border-width": "{border_none}"
};
const $e3613f6017c674c5$var$datepickercalendar_base_container_gap = "{s}";
const $e3613f6017c674c5$var$DatepickerCalendarTokens = {
    "datepickercalendar_base_container_flex-direction": "{flexDirection.column}",
    "datepickercalendar_base_container_justify-content": "{justifyContent.start}",
    "datepickercalendar_base_container_align-items": "{alignItems.center}",
    datepickercalendar_base_container_gap: $e3613f6017c674c5$var$datepickercalendar_base_container_gap,
    "datepickercalendar_base_rows-container_flex-direction": "{flexDirection.column}"
};
const $e3613f6017c674c5$var$datepickerheader_base_container_width = "{size.max}";
const $e3613f6017c674c5$var$datepickerheader_base_container_height = "{xxl}";
const $e3613f6017c674c5$var$DatepickerHeaderTokens = {
    datepickerheader_base_container_width: $e3613f6017c674c5$var$datepickerheader_base_container_width,
    datepickerheader_base_container_height: $e3613f6017c674c5$var$datepickerheader_base_container_height,
    "datepickerheader_base_container_flex-direction": "{flexDirection.row}",
    "datepickerheader_base_container_justify-content": "{justifyContent.spaceBetween}",
    "datepickerheader_base_container_align-items": "{alignItems.center}",
    "datepickerheader_base_inner-container_height": "{xxl}",
    "datepickerheader_base_inner-container_flex-direction": "{flexDirection.row}",
    "datepickerheader_base_inner-container_justify-content": "{justifyContent.center}",
    "datepickerheader_base_inner-container_align-items": "{alignItems.center}",
    "datepickerheader_base_inner-container_gap": "{s}"
};
const $e3613f6017c674c5$var$datepickerdesktop_base_container_opacity = "{opacity.invisible}";
const $e3613f6017c674c5$var$datapickerdesktop_variant_open_true_container_opacity = "{opacity.enabled}";
const $e3613f6017c674c5$var$DatepickerDesktopTokens = {
    "datepickerdesktop_base_popup-container_flex-direction": "{flexDirection.column}",
    "datepickerdesktop_base_popup-container_justify-content": "{justifyContent.start}",
    "datepickerdesktop_base_popup-container_align-items": "{alignItems.center}",
    datepickerdesktop_base_container_opacity: $e3613f6017c674c5$var$datepickerdesktop_base_container_opacity,
    "datepickerdesktop_base_container_background-color": "{primaryBackground}",
    "datepickerdesktop_base_container_flex-direction": "{flexDirection.column}",
    "datepickerdesktop_base_container_justify-content": "{justifyContent.start}",
    "datepickerdesktop_base_container_align-items": "{alignItems.center}",
    "datepickerdesktop_base_container_border-radius": "{xl}",
    "datepickerdesktop_base_top-container_flex-direction": "{flexDirection.row}",
    "datepickerdesktop_base_top-container_justify-content": "{justifyContent.end}",
    "datepickerdesktop_base_top-container_align-items": "{alignItems.center}",
    "datepickerdesktop_base_top-container_padding-top": "{xs}",
    "datepickerdesktop_base_top-container_padding-right": "{s}",
    "datepickerdesktop_base_top-container_padding-bottom": "{xs}",
    "datepickerdesktop_base_top-container_padding-left": "{s}",
    "datepickerdesktop_base_top-container_width": "{custom_6}",
    "datepickerdesktop_base_jds_datepicker_header_padding-right": "{m}",
    "datepickerdesktop_base_jds_datepicker_header_padding-left": "{m}",
    "datepickerdesktop_base_controls-container_flex-direction": "{flexDirection.column}",
    "datepickerdesktop_base_controls-container_justify-content": "{justifyContent.start}",
    "datepickerdesktop_base_controls-container_align-items": "{alignItems.center}",
    "datepickerdesktop_base_controls-container_gap": "{m}",
    "datepickerdesktop_base_calender-view-container_flex-direction": "{flexDirection.column}",
    "datepickerdesktop_base_calender-view-container_justify-content": "{justifyContent.start}",
    "datepickerdesktop_base_calender-view-container_align-items": "{alignItems.center}",
    "datepickerdesktop_base_calender-view-container_height": "{size.max}",
    "datepickerdesktop_base_calender-view-container_width": "{size.max}",
    "datepickerdesktop_base_jds_datepicker_calendar_padding-right": "{m}",
    "datepickerdesktop_base_jds_datepicker_calendar_padding-left": "{m}",
    "datepickerdesktop_base_jds_datepicker_calendar_padding-bottom": "{m}",
    datapickerdesktop_variant_open_true_container_opacity: $e3613f6017c674c5$var$datapickerdesktop_variant_open_true_container_opacity,
    "datepickerdesktop_variant_state_month_view_top-container_justify-content": "{justifyContent.spaceBetween}",
    "datepickerdesktop_variant_state_year_view_top-container_justify-content": "{justifyContent.spaceBetween}"
};
const $e3613f6017c674c5$var$datepickercalendarrow_base_container_width = "{size.max}";
const $e3613f6017c674c5$var$DatepickerCalendarRowTokens = {
    "datepickercalendarrow_base_container_flex-direction": "{flexDirection.row}",
    "datepickercalendarrow_base_container_justify-content": "{justifyContent.start}",
    "datepickercalendarrow_base_container_align-items": "{alignItems.center}",
    datepickercalendarrow_base_container_width: $e3613f6017c674c5$var$datepickercalendarrow_base_container_width
};
const $e3613f6017c674c5$var$datepickerviewbutton_base_container_height = "{xxl}";
const $e3613f6017c674c5$var$datepickerviewbutton_base_container_width = "{custom_7}";
const $e3613f6017c674c5$var$DatepickerViewButtonTokens = {
    "datepickerviewbutton_base_root-container_width": "{size.max}",
    "datepickerviewbutton_base_root-container_flex-direction": "{flexDirection.row}",
    "datepickerviewbutton_base_root-container_justify-content": "{justifyContent.center}",
    "datepickerviewbutton_base_root-container_align-items": "{alignItems.center}",
    datepickerviewbutton_base_container_height: $e3613f6017c674c5$var$datepickerviewbutton_base_container_height,
    datepickerviewbutton_base_container_width: $e3613f6017c674c5$var$datepickerviewbutton_base_container_width,
    "datepickerviewbutton_base_container_flex-direction": "{flexDirection.row}",
    "datepickerviewbutton_base_container_justify-content": "{justifyContent.center}",
    "datepickerviewbutton_base_container_align-items": "{alignItems.center}"
};
const $e3613f6017c674c5$var$datepickercalendarheader_base_container_width = "{size.max}";
const $e3613f6017c674c5$var$DatepickerCalendarHeaderTokens = {
    "datepickercalendarheader_base_container_flex-direction": "{flexDirection.row}",
    "datepickercalendarheader_base_container_justify-content": "{justifyContent.center}",
    "datepickercalendarheader_base_container_align-items": "{alignItems.center}",
    datepickercalendarheader_base_container_width: $e3613f6017c674c5$var$datepickercalendarheader_base_container_width
};
const $e3613f6017c674c5$var$datepickeryearview_base_container_width = "{size.max}";
const $e3613f6017c674c5$var$DatepickerYearViewTokens = {
    "datepickeryearview_base_container_flex-direction": "{flexDirection.column}",
    datepickeryearview_base_container_width: $e3613f6017c674c5$var$datepickeryearview_base_container_width,
    "datepickeryearview_base_container_align-items": "{alignItems.center}"
};
const $e3613f6017c674c5$var$datepickermobile_base_container_size = "{size.max}";
const $e3613f6017c674c5$var$DatepickerMobileTokens = {
    "datepickermobile_base_container_background-color": "{primaryBackground}",
    "datepickermobile_base_container_flex-direction": "{flexDirection.column}",
    "datepickermobile_base_container_justify-content": "{justifyContent.start}",
    "datepickermobile_base_container_align-items": "{alignItems.center}",
    datepickermobile_base_container_size: $e3613f6017c674c5$var$datepickermobile_base_container_size,
    "datepickermobile_base_top-container_flex-direction": "{flexDirection.row}",
    "datepickermobile_base_top-container_justify-content": "{justifyContent.end}",
    "datepickermobile_base_top-container_align-items": "{alignItems.center}",
    "datepickermobile_base_top-container_padding-top": "{xs}",
    "datepickermobile_base_top-container_padding-bottom": "{xs}",
    "datepickermobile_base_top-container_padding-left": "{s}",
    "datepickermobile_base_top-container_padding-right": "{s}",
    "datepickermobile_base_top-container_width": "{size.max}",
    "datepickermobile_base_controls-container_flex-direction": "{flexDirection.column}",
    "datepickermobile_base_controls-container_justify-content": "{justifyContent.start}",
    "datepickermobile_base_controls-container_align-items": "{alignItems.center}",
    "datepickermobile_base_controls-container_gap": "{m}",
    "datepickermobile_base_jds_datepicker_header_padding-left": "{s}",
    "datepickermobile_base_jds_datepicker_header_padding-right": "{s}",
    "datepickermobile_base_jds_datepicker_calendar_padding-left": "{s}",
    "datepickermobile_base_jds_datepicker_calendar_padding-right": "{s}",
    "datepickermobile_base_jds_datepicker_calendar_padding-bottom": "{m}",
    "datepickermobile_base_jds_datepicker_month_view_padding-left": "{s}",
    "datepickermobile_base_jds_datepicker_month_view_padding-right": "{s}",
    "datepickermobile_base_jds_datepicker_year_view_padding-left": "{s}",
    "datepickermobile_base_jds_datepicker_year_view_padding-right": "{s}",
    "datepickermobile_base_confirmation-container_padding-bottom": "{m}",
    "datepickermobile_base_confirmation-container_flex-direction": "{flexDirection.column}",
    "datepickermobile_base_confirmation-container_gap": "{s}",
    "datepickermobile_base_confirmation-container_justify-content": "{justifyContent.start}",
    "datepickermobile_base_confirmation-container_align-items": "{alignItems.center}",
    "datepickermobile_base_confirmation-container_width": "{size.max}",
    "datepickermobile_base_confirmation-group-container_padding-right": "{m}",
    "datepickermobile_base_confirmation-group-container_padding-left": "{m}",
    "datepickermobile_base_confirmation-group-container_flex-direction": "{flexDirection.column}",
    "datepickermobile_base_confirmation-group-container_justify-content": "{justifyContent.start}",
    "datepickermobile_base_confirmation-group-container_align-items": "{alignItems.center}",
    "datepickermobile_base_confirmation-group-container_gap": "{s}",
    "datepickermobile_base_confirmation-group-container_width": "{size.max}",
    "datepickermobile_variant_state_month_view_top-container_justify-content": "{justifyContent.spaceBetween}",
    "datepickermobile_variant_state_year_view_top-container_justify-content": "{justifyContent.spaceBetween}"
};
const $e3613f6017c674c5$var$datepickermonthview_base_container_height = "{custom_8}";
const $e3613f6017c674c5$var$datepickermonthview_base_container_width = "{size.max}";
const $e3613f6017c674c5$var$DatepickerMonthViewTokens = {
    "datepickermonthview_base_container_flex-direction": "{flexDirection.column}",
    datepickermonthview_base_container_height: $e3613f6017c674c5$var$datepickermonthview_base_container_height,
    datepickermonthview_base_container_width: $e3613f6017c674c5$var$datepickermonthview_base_container_width,
    "datepickermonthview_base_container_align-items": "{alignItems.center}"
};
const $e3613f6017c674c5$var$dropdownmenu_base_jds_search_box_width = "{size.max}";
const $e3613f6017c674c5$var$DropdownMenuTokens = {
    "dropdownmenu_base_popup_background-color": "{global.transparent}",
    "dropdownmenu_base_menu-container_background_color": "{primaryGrey20}",
    "dropdownmenu_base_menu-container_flex-direction": "{flexDirection.column}",
    "dropdownmenu_base_menu-group-container_flex-direction": "{flexDirection.column}",
    "dropdownmenu_base_menu-container_border-radius": "{large}",
    "dropdownmenu_base_menu-group-container_padding-top": "{xs}",
    "dropdownmenu_base_menu-group-container_padding-bottom": "{xs}",
    "dropdownmenu_base_search-container_padding-top": "{base}",
    "dropdownmenu_base_search-container_padding-left": "{base}",
    "dropdownmenu_base_search-container_padding-right": "{base}",
    "dropdownmenu_base_menu-container_box-shadow_color": "{custom_color_5}",
    "dropdownmenu_base_search-container_width": "{size.max}",
    dropdownmenu_base_jds_search_box_width: $e3613f6017c674c5$var$dropdownmenu_base_jds_search_box_width,
    "dropdownmenu_base_menu-group-container_width": "{size.max}",
    "dropdownmenu_variant__menuFullScreen_true_popup-container_size": "{size.max}",
    "dropdownmenu_variant__menuFullScreen_true_menu-container_size": "{size.max}",
    "dropdownmenu_base_menu-container_opacity": "{opacity.invisible}",
    "dropdownmenu_variant__menuContainerVisible_true_menu-container_opacity": "{opacity.enabled}"
};
const $e3613f6017c674c5$var$dropdownmenuitem_base_container_width = "{size.max}";
const $e3613f6017c674c5$var$dropdownmenuitem_base_container_gap = "{s}";
const $e3613f6017c674c5$var$dropdownmenuitem_base_icon_color = "{primary60}";
const $e3613f6017c674c5$var$dropdownmenuitem_base_icon_size = "{m}";
const $e3613f6017c674c5$var$dropdownmenuitem_base_icon_behaviour_active_color = "{primaryInverse}";
const $e3613f6017c674c5$var$dropdownmenuitem_variant_disabled_true_container_opacity = "{opacity.disabled}";
const $e3613f6017c674c5$var$DropdownMenuItemTokens = {
    dropdownmenuitem_base_container_width: $e3613f6017c674c5$var$dropdownmenuitem_base_container_width,
    "dropdownmenuitem_base_container_flex-direction": "{flexDirection.row}",
    "dropdownmenuitem_base_content-container_flex-direction": "{flexDirection.column}",
    dropdownmenuitem_base_container_gap: $e3613f6017c674c5$var$dropdownmenuitem_base_container_gap,
    "dropdownmenuitem_base_container_background-color": "{primaryGrey20}",
    "dropdownmenuitem_base_container_behavior_hover_background-color": "{primaryBackground}",
    "dropdownmenuitem_base_container_behavior_active_background-color": "{primary50}",
    "dropdownmenuitem_base_label-jds_text_behavior_color": "{primaryGrey100}",
    "dropdownmenuitem_base_container_padding-top": "{xs}",
    "dropdownmenuitem_base_container_padding-right": "{base}",
    "dropdownmenuitem_base_container_padding-bottom": "{xs}",
    "dropdownmenuitem_base_container_padding-left": "{base}",
    "dropdownmenuitem_variant_selected_true_container_background-color": "{primary50}",
    "dropdownmenuitem_variant_selected_true_container_behavior_active_background-color": "{primary50}",
    "dropdownmenuitem_base_content-container_justify-content": "{justifyContent.start}",
    "dropdownmenuitem_base_content-container_align-items": "{alignItems.start}",
    "dropdownmenuitem_base_container_align-items": "{alignItems.center}",
    "dropdownmenuitem_base_prefix-container_align-self": "{alignItems.start}",
    dropdownmenuitem_base_icon_color: $e3613f6017c674c5$var$dropdownmenuitem_base_icon_color,
    dropdownmenuitem_base_icon_size: $e3613f6017c674c5$var$dropdownmenuitem_base_icon_size,
    dropdownmenuitem_base_icon_behaviour_active_color: $e3613f6017c674c5$var$dropdownmenuitem_base_icon_behaviour_active_color,
    "dropdownmenuitem_variant_selected_true_icon-color": "{primaryInverse}",
    dropdownmenuitem_variant_disabled_true_container_opacity: $e3613f6017c674c5$var$dropdownmenuitem_variant_disabled_true_container_opacity,
    "dropdownmenuitem_base_container_behavior_focus_border-radius": "{small}",
    "dropdownmenuitem_base_root-container_width": "{size.max}"
};
const $e3613f6017c674c5$var$dropdownmenugroup_base_container_width = "{size.max}";
const $e3613f6017c674c5$var$DropdownMenuGroupTokens = {
    dropdownmenugroup_base_container_width: $e3613f6017c674c5$var$dropdownmenugroup_base_container_width,
    "dropdownmenugroup_base_container_flex-direction": "{flexDirection.column}",
    "dropdownmenugroup_base_menu-item-container_flex-direction": "{flexDirection.column}",
    "dropdownmenugroup_base_label-container_padding-top": "{xs}",
    "dropdownmenugroup_base_label-container_padding-left": "{base}",
    "dropdownmenugroup_base_label-container_padding-right": "{base}",
    "dropdownmenugroup_base_label-container_width": "{size.max}",
    "dropdownmenugroup_base_container_background-color": "{primaryGrey20}",
    "dropdownmenugroup_base_menu-item-container_width": "{size.max}"
};
const $e3613f6017c674c5$var$DropdownMenuSubMenuTokens = {
    "dropdownmenusubmenu_base_popup_background-color": "{global.transparent}",
    "dropdownmenusubmenu_base_menu-container_background_color": "{primaryGrey20}",
    "dropdownmenusubmenu_base_menu-container_flex-direction": "{flexDirection.column}",
    "dropdownmenusubmenu_base_menu-container_border-radius": "{large}",
    "dropdownmenusubmenu_base_menu-container_padding-top": "{xs}",
    "dropdownmenusubmenu_base_menu-container_padding-bottom": "{xs}",
    "dropdownmenusubmenu_base_menu-container_box-shadow_color": "{custom_color_5}",
    "dropdownmenu_variant__platform_mobile_popup-container_size": "{size.max}",
    "dropdownmenu_variant__platform_mobile_menu-container_size": "{size.max}",
    "dropdownmenusubmenu_base_menu-container_opacity": "{opacity.invisible}",
    "dropdownmenusubmenu_variant__menuContainerVisible_true_menu-container_opacity": "{opacity.enabled}"
};
const $e3613f6017c674c5$var$bottomfooter_base_container_background = "{global.transparent}";
const $e3613f6017c674c5$var$bottomfooter_variant__platform_desktop_container_width = "{size.max}";
const $e3613f6017c674c5$var$bottomfooter_variant__platform_mobile_container_gap = "{base}";
const $e3613f6017c674c5$var$BottomFooterTokens = {
    "bottomfooter_base_container_flex-direction": "{flexDirection.row}",
    "bottomfooter_base_container_justify-content": "{justifyContent.spaceBetween}",
    "bottomfooter_base_container_align-items": "{alignItems.center}",
    "bottomfooter_base_container_padding-top": "{base}",
    "bottomfooter_base_container_padding-right": "{huge}",
    "bottomfooter_base_container_padding-bottom": "{base}",
    "bottomfooter_base_container_padding-left": "{huge}",
    bottomfooter_base_container_background: $e3613f6017c674c5$var$bottomfooter_base_container_background,
    "bottomfooter_base_copyright-container_gap": "{base}",
    "bottomfooter_base_copyright-container_flex-direction": "{flexDirection.row}",
    "bottomfooter_base_copyright-container_align-items": "{alignItems.center}",
    "bottomfooter_base_informational-links-container_align-items": "{alignItems.center}",
    bottomfooter_variant__platform_desktop_container_width: $e3613f6017c674c5$var$bottomfooter_variant__platform_desktop_container_width,
    "bottomfooter_variant__platform_mobile_container_flex-direction": "{flexDirection.column}",
    "bottomfooter_variant__platform_mobile_container_justify-content": "{justifyContent.start}",
    "bottomfooter_variant__platform_mobile_container_align-items": "{alignItems.start}",
    "bottomfooter_variant__platform_mobile_container_padding-right": "{m}",
    "bottomfooter_variant__platform_mobile_container_padding-bottom": "{m}",
    "bottomfooter_variant__platform_mobile_container_padding-left": "{m}",
    bottomfooter_variant__platform_mobile_container_gap: $e3613f6017c674c5$var$bottomfooter_variant__platform_mobile_container_gap,
    "bottomfooter_variant__platform_mobile_copyright-container_flex-direction": "{flexDirection.column}",
    "bottomfooter_variant__platform_mobile_copyright-container_align-items": "{alignItems.start}",
    "bottomfooter_variant__platform_mobile_copyright-container_gap": "{base}"
};
const $e3613f6017c674c5$var$divider_base_container_gap = "{xs}";
const $e3613f6017c674c5$var$divider_variant_orientation_horizontal_container_width = "{size.max}";
const $e3613f6017c674c5$var$divider_variant_orientation_vertical_container_height = "{size.max}";
const $e3613f6017c674c5$var$DividerTokens = {
    "divider_base_container_background-color": "{global.transparent}",
    "divider_base_container_flex-direction": "{flexDirection.row}",
    "divider_base_container_justify-content": "{justifyContent.center}",
    "divider_base_container_align-items": "{alignItems.center}",
    divider_base_container_gap: $e3613f6017c674c5$var$divider_base_container_gap,
    "divider_base_container_padding-left": "{s}",
    "divider_base_container_padding-right": "{s}",
    "divider_base_container_padding-top": "{s}",
    "divider_base_container_padding-bottom": "{s}",
    "divider_base_start-container_min-height": "{custom_5}",
    "divider_base_start-container_min-width": "{custom_5}",
    "divider_base_start-container_flex-direction": "{flexDirection.row}",
    "divider_base_start-container_background-color": "{primaryGrey40}",
    "divider_base_start-container_border-radius": "{pill}",
    "divider_base_end-container_min-height": "{custom_5}",
    "divider_base_end-container_min-width": "{custom_5}",
    "divider_base_end-container_flex-direction": "{flexDirection.row}",
    "divider_base_end-container_background-color": "{primaryGrey40}",
    "divider_base_end-container_border-radius": "{pill}",
    "divider_variant_variant_stepper_start-container_background-color": "{sparkle50}",
    "divider_variant_variant_stepper_end-container_background-color": "{sparkle50}",
    divider_variant_orientation_horizontal_container_width: $e3613f6017c674c5$var$divider_variant_orientation_horizontal_container_width,
    divider_variant_orientation_vertical_container_height: $e3613f6017c674c5$var$divider_variant_orientation_vertical_container_height,
    "divider_variant_orientation_vertical_container_flex-direction": "{flexDirection.column}",
    "divider_variant_orientation_vertical_start-container_flex-direction": "{flexDirection.column}",
    "divider_variant_orientation_vertical_end-container_flex-direction": "{flexDirection.column}",
    "divider_combination_base_all_container_padding-left": "{base}",
    "divider_combination_base_all_container_padding-right": "{base}",
    "divider_combination_base_all_container_padding-top": "{base}",
    "divider_combination_base_all_container_padding-bottom": "{base}",
    "divider_combination_base_left_container_padding-left": "{base}",
    "divider_combination_base_right_container_padding-right": "{base}",
    "divider_combination_base_top_container_padding-top": "{base}",
    "divider_combination_base_bottom_container_padding-bottom": "{base}",
    "divider_combination_base_vertical_container_padding-top": "{base}",
    "divider_combination_base_vertical_container_padding-bottom": "{base}",
    "divider_combination_base_horizontal_container_padding-left": "{base}",
    "divider_combination_base_horizontal_container_padding-right": "{base}",
    "divider_combination_medium_all_container_padding-left": "{m}",
    "divider_combination_medium_all_container_padding-right": "{m}",
    "divider_combination_medium_all_container_padding-top": "{m}",
    "divider_combination_medium_all_container_padding-bottom": "{m}",
    "divider_combination_medium_left_container_padding-left": "{m}",
    "divider_combination_medium_right_container_padding-right": "{m}",
    "divider_combination_medium_top_container_padding-top": "{m}",
    "divider_combination_medium_bottom_container_padding-bottom": "{m}",
    "divider_combination_medium_vertical_container_padding-top": "{m}",
    "divider_combination_medium_vertical_container_padding-bottom": "{m}",
    "divider_combination_medium_horizontal_container_padding-left": "{m}",
    "divider_combination_medium_horizontal_container_padding-right": "{m}",
    "divider_combination_xtra-small_all_container_padding-left": "{xs}",
    "divider_combination_xtra-small_all_container_padding-right": "{xs}",
    "divider_combination_xtra-small_all_container_padding-top": "{xs}",
    "divider_combination_xtra-small_all_container_padding-bottom": "{xs}",
    "divider_combination_xtra-small_left_container_padding-left": "{xs}",
    "divider_combination_xtra-small_right_container_padding-right": "{xs}",
    "divider_combination_xtra-small_top_container_padding-top": "{xs}",
    "divider_combination_xtra-small_bottom_container_padding-bottom": "{xs}",
    "divider_combination_xtra-small_vertical_container_padding-top": "{xs}",
    "divider_combination_xtra-small_vertical_container_padding-bottom": "{xs}",
    "divider_combination_xtra-small_horizontal_container_padding-left": "{xs}",
    "divider_combination_xtra-small_horizontal_container_padding-right": "{xs}",
    "divider_combination_xtra-xtra-small_all_container_padding-left": "{xxs}",
    "divider_combination_xtra-xtra-small_all_container_padding-right": "{xxs}",
    "divider_combination_xtra-xtra-small_all_container_padding-top": "{xxs}",
    "divider_combination_xtra-xtra-small_all_container_padding-bottom": "{xxs}",
    "divider_combination_xtra-xtra-small_left_container_padding-left": "{xxs}",
    "divider_combination_xtra-xtra-small_right_container_padding-right": "{xxs}",
    "divider_combination_xtra-xtra-small_top_container_padding-top": "{xxs}",
    "divider_combination_xtra-xtra-small_bottom_container_padding-bottom": "{xxs}",
    "divider_combination_xtra-xtra-small_vertical_container_padding-top": "{xxs}",
    "divider_combination_xtra-xtra-small_vertical_container_padding-bottom": "{xxs}",
    "divider_combination_xtra-xtra-small_horizontal_container_padding-left": "{xxs}",
    "divider_combination_xtra-xtra-small_horizontal_container_padding-bottom": "{xxs}",
    "divider_combination_xtra-xtra-large_all_container_padding-left": "{xxl}",
    "divider_combination_xtra-xtra-large_all_container_padding-right": "{xxl}",
    "divider_combination_xtra-xtra-large_all_container_padding-top": "{xxl}",
    "divider_combination_xtra-xtra-large_all_container_padding-bottom": "{xxl}",
    "divider_combination_xtra-xtra-large_left_container_padding-left": "{xxl}",
    "divider_combination_xtra-xtra-large_right_container_padding-right": "{xxl}",
    "divider_combination_xtra-xtra-large_top_container_padding-top": "{xxl}",
    "divider_combination_xtra-xtra-large_bottom_container_padding-bottom": "{xxl}",
    "divider_combination_xtra-xtra-large_vertical_container_padding-top": "{xxl}",
    "divider_combination_xtra-xtra-large_vertical_container_padding-bottom": "{xxl}",
    "divider_combination_xtra-xtra-large_horizontal_container_padding-left": "{xxl}",
    "divider_combination_xtra-xtra-large_horizontal_container_padding-right": "{xxl}",
    "divider_combination_xtra-large_all_container_padding-left": "{xl}",
    "divider_combination_xtra-large_all_container_padding-right": "{xl}",
    "divider_combination_xtra-large_all_container_padding-top": "{xl}",
    "divider_combination_xtra-large_all_container_padding-bottom": "{xl}",
    "divider_combination_xtra-large_left_container_padding-left": "{xl}",
    "divider_combination_xtra-large_right_container_padding-right": "{xl}",
    "divider_combination_xtra-large_top_container_padding-top": "{xl}",
    "divider_combination_xtra-large_bottom_container_padding-bottom": "{xl}",
    "divider_combination_xtra-large_vertical_container_padding-top": "{xl}",
    "divider_combination_xtra-large_vertical_container_padding-bottom": "{xl}",
    "divider_combination_xtra-large_horizontal_container_padding-left": "{xl}",
    "divider_combination_xtra-large_horizontal_container_padding-right": "{xl}",
    "divider_combination_large_all_container_padding-left": "{l}",
    "divider_combination_large_all_container_padding-right": "{l}",
    "divider_combination_large_all_container_padding-top": "{l}",
    "divider_combination_large_all_container_padding-bottom": "{l}",
    "divider_combination_large_left_container_padding-left": "{l}",
    "divider_combination_large_right_container_padding-right": "{l}",
    "divider_combination_large_top_container_padding-top": "{l}",
    "divider_combination_large_bottom_container_padding-bottom": "{l}",
    "divider_combination_large_vertical_container_padding-top": "{l}",
    "divider_combination_large_vertical_container_padding-bottom": "{l}",
    "divider_combination_large_horizontal_container_padding-left": "{l}",
    "divider_combination_large_horizontal_container_padding-right": "{l}",
    "divider_combination_huge_all_container_padding-left": "{huge}",
    "divider_combination_huge_all_container_padding-right": "{huge}",
    "divider_combination_huge_all_container_padding-top": "{huge}",
    "divider_combination_huge_all_container_padding-bottom": "{huge}",
    "divider_combination_huge_left_container_padding-left": "{huge}",
    "divider_combination_huge_right_container_padding-right": "{huge}",
    "divider_combination_huge_top_container_padding-top": "{huge}",
    "divider_combination_huge_bottom_container_padding-bottom": "{huge}",
    "divider_combination_huge_vertical_container_padding-top": "{huge}",
    "divider_combination_huge_vertical_container_padding-bottom": "{huge}",
    "divider_combination_huge_horizontal_container_padding-left": "{huge}",
    "divider_combination_huge_horizontal_container_padding-right": "{huge}",
    "divider_combination_massive_all_container_padding-left": "{massive}",
    "divider_combination_massive_all_container_padding-right": "{massive}",
    "divider_combination_massive_all_container_padding-top": "{massive}",
    "divider_combination_massive_all_container_padding-bottom": "{massive}",
    "divider_combination_massive_left_container_padding-left": "{massive}",
    "divider_combination_massive_right_container_padding-right": "{massive}",
    "divider_combination_massive_top_container_padding-top": "{massive}",
    "divider_combination_massive_bottom_container_padding-bottom": "{massive}",
    "divider_combination_massive_vertical_container_padding-top": "{massive}",
    "divider_combination_massive_vertical_container_padding-bottom": "{massive}",
    "divider_combination_massive_horizontal_container_padding-left": "{massive}",
    "divider_combination_massive_horizontal_container_padding-right": "{massive}"
};
const $e3613f6017c674c5$var$fab_base_container_gap = "{xs}";
const $e3613f6017c674c5$var$fab_base_icon_size = "{m}";
const $e3613f6017c674c5$var$fab_base_icon_color = "{secondaryInverse}";
const $e3613f6017c674c5$var$fab_base_icon_behavior_active_color = "{secondary30}";
const $e3613f6017c674c5$var$FABTokens = {
    "fab_base_popup-container_flex-direction": "{flexDirection.stack}",
    "fab_base_popup-container_justify-content": "{justifyContent.end}",
    "fab_base_popup-container_align-items": "{alignItems.end}",
    "fab_base_popup-container_size": "{size.max}",
    "fab_base_popup-container_padding-right": "{base}",
    "fab_base_popup-container_padding-bottom": "{base}",
    "fab_base_container_background-color": "{secondary50}",
    "fab_base_container_flex-direction": "{flexDirection.row}",
    "fab_base_container_justify-content": "{justifyContent.center}",
    "fab_base_container_align-items": "{alignItems.center}",
    fab_base_container_gap: $e3613f6017c674c5$var$fab_base_container_gap,
    "fab_base_container_border-radius": "{pill}",
    "fab_base_container_padding-top": "{base}",
    "fab_base_container_padding-left": "{m}",
    "fab_base_container_padding-right": "{m}",
    "fab_base_container_padding-bottom": "{base}",
    "fab_base_container_border-color": "{primary80}",
    "fab_base_container_border-width": "{border_none}",
    "fab_base_container_behavior_hover_background-color": "{secondary60}",
    "fab_base_container_behavior_active_background-color": "{secondary60}",
    "fab_base_container_behavior_focus_background-color": "{secondary60}",
    "fab_base_container_behavior_focus_border-width": "{border_focus}",
    fab_base_icon_size: $e3613f6017c674c5$var$fab_base_icon_size,
    fab_base_icon_color: $e3613f6017c674c5$var$fab_base_icon_color,
    "fab_base_icon_border-radius": "{pill}",
    fab_base_icon_behavior_active_color: $e3613f6017c674c5$var$fab_base_icon_behavior_active_color,
    "fab_variant_extend_false_container_padding-left": "{base}",
    "fab_variant_extend_false_container_padding-right": "{base}"
};
const $e3613f6017c674c5$var$feedbackblock_base_container_gap = "{xs}";
const $e3613f6017c674c5$var$feedbackblock_base_icon_size = "{m}";
const $e3613f6017c674c5$var$feedbackblock_variant_size_s_icon_size = "{base}";
const $e3613f6017c674c5$var$FeedbackBlockTokens = {
    "feedbackblock_base_container_flex-direction": "{flexDirection.row}",
    "feedbackblock_base_container_justify-content": "{justifyContent.center}",
    "feedbackblock_base_container_align-items": "{alignItems.center}",
    feedbackblock_base_container_gap: $e3613f6017c674c5$var$feedbackblock_base_container_gap,
    "feedbackblock_variant_alignment_top_container_align-items": "{alignItems.start}",
    "feedbackblock_base_icon-flex-direction": "{flexDirection.row}",
    "feedbackblock_base_icon-container_justify-content": "{justifyContent.center}",
    "feedbackblock_base_icon-container_align-items": "{alignItems.center}",
    "feedbackblock_base_icon-container_height": "{m}",
    feedbackblock_base_icon_size: $e3613f6017c674c5$var$feedbackblock_base_icon_size,
    "feedbackblock_variant_size_s_icon-container_height": "{custom_18}",
    feedbackblock_variant_size_s_icon_size: $e3613f6017c674c5$var$feedbackblock_variant_size_s_icon_size
};
const $e3613f6017c674c5$var$dropdown_base_container_gap = "{xxs}";
const $e3613f6017c674c5$var$dropdown_base_container_width = "{size.max}";
const $e3613f6017c674c5$var$dropdown_variant_disabled_true_container_opacity = "{opacity.disabled}";
const $e3613f6017c674c5$var$dropdown_base_conatiner_opacity = "{opacity.enabled}";
const $e3613f6017c674c5$var$DropdownTokens = {
    "dropdown_base_container_flex-direction": "{flexDirection.column}",
    dropdown_base_container_gap: $e3613f6017c674c5$var$dropdown_base_container_gap,
    dropdown_base_container_width: $e3613f6017c674c5$var$dropdown_base_container_width,
    "dropdown_base_container_justify-content": "{justifyContent.start}",
    "dropdown_base_container_align-items": "{alignItems.start}",
    "dropdown_base_field-container_flex-direction": "{flexDirection.stack}",
    "dropdown_base_field-container_width": "{size.max}",
    "dropdown_base_field-container_align-items": "{alignItems.end}",
    "dropdown_base_field-container_justify-content": "{justifyContent.start}",
    "dropdown_base_field-container_padding-bottom": "{xxs}",
    "dropdown_base_text-container_flex-direction": "{flexDirection.row}",
    "dropdown_base_text-container_gap": "{xs}",
    "dropdown_base_select-container_flex-direction": "{flexDirection.row}",
    "dropdown_base_select-container_justify-content": "{justifyContent.end}",
    "dropdown_base_select-container_width": "{size.max}",
    "dropdown_base_select-container_align-items": "{alignItems.center}",
    "dropdown_base_active-line-container_flex-direction": "{flexDirection.column}",
    "dropdown_base_active-line-container_width": "{size.max}",
    "dropdown_base_active-line-container_align-items": "{alignItems.center}",
    "dropdown_base_feedback-container_width": "{size.max}",
    "dropdown_base_feedback-container_background-color": "{primaryGrey100}",
    "dropdown_base_feedback-container_behavior_hover_background-color": "{primary50}",
    "dropdown_base_feedback-container_behavior_focus_background-color": "{primary50}",
    "dropdown_base_feedback-container_behavior_active_background-color": "{primary50}",
    "dropdown_variant_border_true-select-container_border-width": "{border_thin}",
    "dropdown_variant_border_true-select-container_border-color": "{primaryGrey60}",
    "dropdown_variant_border_true-select-container_border-radius": "{medium}",
    "dropdown_variant_border_true-select-container_padding-top": "{custom_17}",
    "dropdown_variant_border_true-select-container_padding-bottom": "{custom_17}",
    "dropdown_variant_border_true-select-container_padding-left": "{s}",
    "dropdown_variant_border_true-select-container_padding-right": "{xs}",
    "dropdown_variant_border_true-select-container_behavior_hover_background-color": "{primartGrey60}",
    "dropdown_variant_border_true-select-container_behavior_focus_background-color": "{white}",
    "dropdown_variant_border_true-select-container_behavior_active_background-color": "{white}",
    "dropdown_base_prefix-icon_size": "{m}",
    "dropdown_base_prefix-icon_color": "{primaryGrey80}",
    dropdown_variant_disabled_true_container_opacity: $e3613f6017c674c5$var$dropdown_variant_disabled_true_container_opacity,
    dropdown_base_conatiner_opacity: $e3613f6017c674c5$var$dropdown_base_conatiner_opacity,
    "dropdown_variant_state_success_feedback-container_background-color": "{feedbackSuccess50}",
    "dropdown_variant_state_success_feedback-container_behavior_hover_background-color": "{feedbackSuccess50}",
    "dropdown_variant_state_success_feedback-container_behavior_focus_background-color": "{feedbackSuccess50}",
    "dropdown_variant_state_success_feedback-container_behavior_active_background-color": "{feedbackSuccess50}",
    "dropdown_variant_state_error_feedback-container_background-color": "{feedbackError50}",
    "dropdown_variant_state_error_feedback-container_behavior_hover_background-color": "{feedbackError50}",
    "dropdown_variant_state_error_feedback-container_behavior_focus_background-color": "{feedbackError50}",
    "dropdown_variant_state_error_feedback-container_behavior_active_background-color": "{feedbackError50}",
    "dropdown_variant_state_warning_feedback-container_background-color": "{feedbackWarning50}",
    "dropdown_variant_state_warning_feedback-container_behavior_hover_background-color": "{feedbackWarning50}",
    "dropdown_variant_state_warning_feedback-container_behavior_focus_background-color": "{feedbackWarning50}",
    "dropdown_variant_state_warning_feedback-container_behavior_active_background-color": "{feedbackWarning50}",
    "dropdown_variant_border_true-select-container_background-color": "{primaryGrey20}",
    "dropdown_variant_border_true-select-container_height": "{xl}",
    "dropdown_combination_true_true_field-container_align-items": "{alignItems.start}",
    "dropdown_combination_true_false_field-container_align-items": "{alignItems.start}",
    "dropdown_combination_false_true_field-container_align-items": "{alignItems.end}",
    "dropdown_combination_false_true_label-jds_text_padding-left": "{l}",
    "dropdown_combination_false_false_field-container_align-items": "{alignItems.end}",
    "dropdown_combination_false_true_select-container_padding-left": "{s}",
    "dropdown_combination_none_true_feedback-container_background-color": "{primary60}"
};
const $e3613f6017c674c5$var$bottomfooterlinkitem_base_container_gap = "{base}";
const $e3613f6017c674c5$var$BottomFooterLinkItemTokens = {
    bottomfooterlinkitem_base_container_gap: $e3613f6017c674c5$var$bottomfooterlinkitem_base_container_gap
};
const $e3613f6017c674c5$var$footer_base_container_size = "{size.max}";
const $e3613f6017c674c5$var$FooterTokens = {
    "footer_base_container_flex-direction": "{flexDirection.column}",
    "footer_base_container_align-items": "{alignItems.center}",
    footer_base_container_size: $e3613f6017c674c5$var$footer_base_container_size,
    "footer_base_container_background-color": "{primaryGrey20}",
    "footer_base_main-container_flex-direction": "{flexDirection.row}",
    "footer_base_main-container_justify-content": "{justifyContent.spaceBetween}",
    "footer_base_main-container_align-items": "{alignItems.start}",
    "footer_base_main-container_gap": "{base}",
    "footer_base_main-container_size": "{size.max}",
    "footer_base_main-container_padding-top": "{xl}",
    "footer_base_main-container_padding-bottom": "{xl}",
    "footer_base_main-container_padding-left": "{huge}",
    "footer_base_main-container_padding-right": "{huge}",
    "footer_base_social-links-container_padding-top": "{xs}",
    "footer_base_social-links-container_flex-direction": "{flexDirection.column}",
    "footer_base_social-links-container_gap": "{l}",
    "footer_base_bottom-container_flex-direction": "{flexDirection.column}",
    "footer_base_bottom-container_align-items": "{alignItems.start}",
    "footer_base_bottom-container_width": "{size.max}",
    "footer_base_content-container_width": "{size.max}",
    "footer_base_content-slot_width": "{size.max}",
    "footer_variant__platform_mobile_bottom-container_gap": "{m}",
    "footer_variant__platform_mobile_main-container_flex-direction": "{flexDirection.column}",
    "footer_variant__platform_mobile_main-container_justify-content": "{justifyContent.start}",
    "footer_variant__platform_mobile_main-container_padding-top": "{m}",
    "footer_variant__platform_mobile_main-container_padding-bottom": "{xl}",
    "footer_variant__platform_mobile_main-container_padding-left": "{m}",
    "footer_variant__platform_mobile_main-container_padding-right": "{m}",
    "footer_base_social-links-container_width": "{custom_17}"
};
const $e3613f6017c674c5$var$footerlinksgrid_base_container_size = "{size.max}";
const $e3613f6017c674c5$var$footerlinksgrid_base_container_gap = "{base}";
const $e3613f6017c674c5$var$FooterLinksGridTokens = {
    "footerlinksgrid_base_container_flex-direction": "{flexDirection.row}",
    footerlinksgrid_base_container_size: $e3613f6017c674c5$var$footerlinksgrid_base_container_size,
    footerlinksgrid_base_container_gap: $e3613f6017c674c5$var$footerlinksgrid_base_container_gap
};
const $e3613f6017c674c5$var$footericonlinks_base_container_gap = "{base}";
const $e3613f6017c674c5$var$FooterIconLinksTokens = {
    footericonlinks_base_container_gap: $e3613f6017c674c5$var$footericonlinks_base_container_gap,
    "footericonlinks_base_container_flex-direction": "{flexDirection.column}",
    "footericonlinks_base_container_align-items": "{alignItems.start}",
    "footericonlinks_base_icons-container_flex-direction": "{flexDirection.row}",
    "footericonlinks_base_icons-container_gap": "{base}"
};
const $e3613f6017c674c5$var$footermarketlinks_base_container_gap = "{base}";
const $e3613f6017c674c5$var$FooterMarketLinksTokens = {
    footermarketlinks_base_container_gap: $e3613f6017c674c5$var$footermarketlinks_base_container_gap,
    "footermarketlinks_base_container_flex-direction": "{flexDirection.column}",
    "footermarketlinks_base_container_align-items": "{alignItems.start}",
    "footermarketlinks_base_assets-container_flex-direction": "{flexDirection.row}",
    "footermarketlinks_base_assets-container_align-items": "{alignItems.center}",
    "footermarketlinks_base_assets-container_gap": "{base}"
};
const $e3613f6017c674c5$var$footerlinks_base_container_size = "{size.max}";
const $e3613f6017c674c5$var$FooterLinksTokens = {
    "footerlinks_base_container_flex-direction": "{flexDirection.column}",
    "footerlinks_base_container_align-items": "{alignItems.start}",
    footerlinks_base_container_size: $e3613f6017c674c5$var$footerlinks_base_container_size,
    "footerlinks_base_link-item-container_size": "{size.max}",
    "footerlinks_base_link-item-container_padding-top": "{xs}",
    "footerlinks_base_link-item-container_padding-bottom": "{xs}",
    "footerlinks_base_link-item-container_flex-direction": "{flexDirection.column}",
    "footerlinks_base_link-item-container_justify-content": "{justifyContent.start}",
    "footerlinks_base_link-item-container_align-items": "{alignItems.start}",
    "footerlinks_base_link-item-container_background-color": "{global.transparent}",
    "footerlinks_base_link-item-container_behavior_hover_background-color": "{primaryGrey40}",
    "footerlinks_base_title-jds_text_padding-top": "{xs}",
    "footerlinks_base_title-jds_text_padding-bottom": "{xs}",
    "footerlinks_base_links-container_padding-top": "{s}",
    "footerlinks_base_links-container_size": "{size.max}",
    "footerlinks_base_links-container_flex-direction": "{flexDirection.column}"
};
const $e3613f6017c674c5$var$BaseIconTokens = {
    "base-icon_base_icon_size": "{base}",
    "base-icon_base_icon_color": "{primary50}",
    "base-icon_variant_color_primary_30_icon_color": "{primary30}",
    "base-icon_variant_color_primary_60_icon_color": "{primary60}",
    "base-icon_variant_color_primary_70_icon_color": "{primary70}",
    "base-icon_variant_color_primary_background_icon_color": "{primaryBackground}",
    "base-icon_variant_color_secondary_50_icon_color": "{secondary50}",
    "base-icon_variant_color_sparkle_50_icon_color": "{sparkle50}",
    "base-icon_variant_color_primary_grey_60_icon_color": "{primaryGrey60}",
    "base-icon_variant_color_primary_grey_80_icon_color": "{primaryGrey80}",
    "base-icon_variant_color_primary_grey_100_icon_color": "{primaryGrey100}",
    "base-icon_variant_color_feedback_success_icon_color": "{feedbackSuccess50}",
    "base-icon_variant_color_feedback_error_icon_color": "{feedbackError50}",
    "base-icon_variant_color_feedback_warning_icon_color": "{feedbackWarning50}",
    "base-icon_variant_color_white_icon_color": "{global.white}",
    "base-icon_variant_color_none_icon_color": "{custom_color_1}"
};
const $e3613f6017c674c5$var$icon_base_container_size = "{m}";
const $e3613f6017c674c5$var$icon_base_icon_size = "{m}";
const $e3613f6017c674c5$var$icon_base_icon_color = "{custom_color_1}";
const $e3613f6017c674c5$var$icon_variant_color_primary_50_icon_color = "{primary50}";
const $e3613f6017c674c5$var$icon_variant_color_primary_30_icon_color = "{primary30}";
const $e3613f6017c674c5$var$icon_variant_color_primary_60_icon_color = "{primary60}";
const $e3613f6017c674c5$var$icon_variant_color_primary_70_icon_color = "{primary70}";
const $e3613f6017c674c5$var$icon_variant_color_primary_background_icon_color = "{primaryBackground}";
const $e3613f6017c674c5$var$icon_variant_color_secondary_50_icon_color = "{secondary50}";
const $e3613f6017c674c5$var$icon_variant_color_sparkle_50_icon_color = "{sparkle50}";
const $e3613f6017c674c5$var$icon_variant_color_primary_grey_60_icon_color = "{primaryGrey60}";
const $e3613f6017c674c5$var$icon_variant_color_primary_grey_80_icon_color = "{primaryGrey80}";
const $e3613f6017c674c5$var$icon_variant_color_primary_grey_100_icon_color = "{primaryGrey100}";
const $e3613f6017c674c5$var$icon_variant_color_feedback_success_icon_color = "{feedbackSuccess50}";
const $e3613f6017c674c5$var$icon_variant_color_feedback_error_icon_color = "{feedbackError50}";
const $e3613f6017c674c5$var$icon_variant_color_feedback_warning_icon_color = "{feedbackWarning50}";
const $e3613f6017c674c5$var$icon_variant_color_white_icon_color = "{global.white}";
const $e3613f6017c674c5$var$icon_variant_size_small_container_size = "{base}";
const $e3613f6017c674c5$var$icon_variant_size_small_icon_size = "{base}";
const $e3613f6017c674c5$var$icon_variant_size_large_container_size = "{l}";
const $e3613f6017c674c5$var$icon_variant_size_large_icon_size = "{l}";
const $e3613f6017c674c5$var$icon_variant_size_fill_container_size = "{size.max}";
const $e3613f6017c674c5$var$icon_variant_size_fill_icon_size = "{size.max}";
const $e3613f6017c674c5$var$icon_combination_background_bold_primary_50_icon_color = "{primaryInverse}";
const $e3613f6017c674c5$var$icon_combination_background_bold_primary_30_icon_color = "{primary30}";
const $e3613f6017c674c5$var$icon_combination_background_bold_primary_60_icon_color = "{primaryInverse}";
const $e3613f6017c674c5$var$icon_combination_background_bold_primary_70_icon_color = "{primaryInverse}";
const $e3613f6017c674c5$var$icon_combination_background_bold_primary_background_icon_color = "{primaryInverse}";
const $e3613f6017c674c5$var$icon_combination_background_bold_secondary_50_icon_color = "{secondaryInverse}";
const $e3613f6017c674c5$var$icon_combination_background_bold_sparkle_50_icon_color = "{sparkleInverse}";
const $e3613f6017c674c5$var$icon_combination_background_bold_primary_grey_60_icon_color = "{primaryInverse}";
const $e3613f6017c674c5$var$icon_combination_background_bold_primary_grey_80_icon_color = "{primaryInverse}";
const $e3613f6017c674c5$var$icon_combination_background_bold_primary_grey_100_icon_color = "{primaryInverse}";
const $e3613f6017c674c5$var$icon_combination_background_bold_white_icon_color = "{global.white}";
const $e3613f6017c674c5$var$icon_combination_background_bold_feedback_success_50_icon_color = "{primaryInverse}";
const $e3613f6017c674c5$var$icon_combination_background_bold_feedback_error_50_icon_color = "{primaryInverse}";
const $e3613f6017c674c5$var$icon_combination_background_bold_feedback_warning_50_icon_color = "{primaryInverse}";
const $e3613f6017c674c5$var$icon_combination_medium_background_container_size = "{m}";
const $e3613f6017c674c5$var$icon_combination_medium_background_icon_size = "{base}";
const $e3613f6017c674c5$var$icon_combination_small_background_container_size = "{base}";
const $e3613f6017c674c5$var$icon_combination_small_background_icon_size = "{base}";
const $e3613f6017c674c5$var$icon_combination_large_background_container_size = "{l}";
const $e3613f6017c674c5$var$icon_combination_large_background_icon_size = "{m}";
const $e3613f6017c674c5$var$icon_combination_small_background_bold_primary_50_icon_color = "{primary50}";
const $e3613f6017c674c5$var$icon_combination_small_background_bold_primary_30_icon_color = "{primary30}";
const $e3613f6017c674c5$var$icon_combination_small_background_bold_primary_60_icon_color = "{primary60}";
const $e3613f6017c674c5$var$icon_combination_small_background_bold_primary_70_icon_color = "{primary70}";
const $e3613f6017c674c5$var$icon_combination_small_background_bold_primary_background_icon_color = "{primaryBackground}";
const $e3613f6017c674c5$var$icon_combination_small_background_bold_secondary_50_icon_color = "{secondary50}";
const $e3613f6017c674c5$var$icon_combination_small_background_bold_sparkle_50_icon_color = "{sparkle50}";
const $e3613f6017c674c5$var$icon_combination_small_background_bold_primary_grey_60_icon_color = "{primaryGrey60}";
const $e3613f6017c674c5$var$icon_combination_small_background_bold_primary_grey_80_icon_color = "{primaryGrey80}";
const $e3613f6017c674c5$var$icon_combination_small_background_bold_primary_grey_100_icon_color = "{primaryGrey100}";
const $e3613f6017c674c5$var$icon_combination_small_background_bold_white_icon_color = "{global.white}";
const $e3613f6017c674c5$var$icon_combination_small_background_bold_feedback_success_50_icon_color = "{feedbackSuccess50}";
const $e3613f6017c674c5$var$icon_combination_small_background_bold_feedback_error_50_icon_color = "{feedbackError50}";
const $e3613f6017c674c5$var$icon_combination_small_background_bold_feedback_warning_50_icon_color = "{feedbackWarning50}";
const $e3613f6017c674c5$var$icon_combination_medium_background_bold_container_size = "{m}";
const $e3613f6017c674c5$var$icon_combination_medium_background_bold_icon_size = "{base}";
const $e3613f6017c674c5$var$icon_combination_small_background_bold_container_size = "{base}";
const $e3613f6017c674c5$var$icon_combination_small_background_bold_icon_size = "{base}";
const $e3613f6017c674c5$var$icon_combination_large_background_bold_container_size = "{l}";
const $e3613f6017c674c5$var$icon_combination_large_background_bold_icon_size = "{m}";
const $e3613f6017c674c5$var$icon_combination_medium_background_feedback_success_container_size = "{m}";
const $e3613f6017c674c5$var$icon_combination_medium_background_feedback_error_container_size = "{m}";
const $e3613f6017c674c5$var$icon_combination_medium_background_feedback_warning_container_size = "{m}";
const $e3613f6017c674c5$var$icon_combination_medium_background_feedback_success_icon_size = "{m}";
const $e3613f6017c674c5$var$icon_combination_medium_background_feedback_error_icon_size = "{m}";
const $e3613f6017c674c5$var$icon_combination_medium_background_feedback_warning_icon_size = "{m}";
const $e3613f6017c674c5$var$icon_combination_medium_background_bold_feedback_success_container_size = "{m}";
const $e3613f6017c674c5$var$icon_combination_medium_background_bold_feedback_error_container_size = "{m}";
const $e3613f6017c674c5$var$icon_combination_medium_background_bold_feedback_warning_container_size = "{m}";
const $e3613f6017c674c5$var$icon_combination_medium_background_bold_feedback_success_icon_size = "{m}";
const $e3613f6017c674c5$var$icon_combination_medium_background_bold_feedback_error_icon_size = "{m}";
const $e3613f6017c674c5$var$icon_combination_medium_background_bold_feedback_warning_icon_size = "{m}";
const $e3613f6017c674c5$var$icon_combination_large_background_feedback_success_container_size = "{l}";
const $e3613f6017c674c5$var$icon_combination_large_background_feedback_error_container_size = "{l}";
const $e3613f6017c674c5$var$icon_combination_large_background_feedback_warning_container_size = "{l}";
const $e3613f6017c674c5$var$icon_combination_large_background_feedback_success_icon_size = "{l}";
const $e3613f6017c674c5$var$icon_combination_large_background_feedback_error_icon_size = "{l}";
const $e3613f6017c674c5$var$icon_combination_large_background_feedback_warning_icon_size = "{l}";
const $e3613f6017c674c5$var$icon_combination_large_background_bold_feedback_success_container_size = "{l}";
const $e3613f6017c674c5$var$icon_combination_large_background_bold_feedback_error_container_size = "{l}";
const $e3613f6017c674c5$var$icon_combination_large_background_bold_feedback_warning_container_size = "{l}";
const $e3613f6017c674c5$var$icon_combination_large_background_bold_feedback_success_icon_size = "{l}";
const $e3613f6017c674c5$var$icon_combination_large_background_bold_feedback_error_icon_size = "{l}";
const $e3613f6017c674c5$var$icon_combination_large_background_bold_feedback_warning_icon_size = "{l}";
const $e3613f6017c674c5$var$icon_combination_inverse_primary_icon_color = "{primaryInverse}";
const $e3613f6017c674c5$var$icon_combination_inverse_secondary_icon_color = "{secondaryInverse}";
const $e3613f6017c674c5$var$icon_combination_inverse_sparkle_icon_color = "{sparkleInverse}";
const $e3613f6017c674c5$var$icon_combination_inverse_feedback_icon_color = "{global.white}";
const $e3613f6017c674c5$var$IconTokens = {
    "icon_base_container_background-color": "{global.transparent}",
    "icon_base_container_border-radius": "{pill}",
    icon_base_container_size: $e3613f6017c674c5$var$icon_base_container_size,
    "icon_base_container_justify-content": "{justifyContent.center}",
    "icon_base_container_align-items": "{alignItems.center}",
    icon_base_icon_size: $e3613f6017c674c5$var$icon_base_icon_size,
    icon_base_icon_color: $e3613f6017c674c5$var$icon_base_icon_color,
    icon_variant_color_primary_50_icon_color: $e3613f6017c674c5$var$icon_variant_color_primary_50_icon_color,
    icon_variant_color_primary_30_icon_color: $e3613f6017c674c5$var$icon_variant_color_primary_30_icon_color,
    icon_variant_color_primary_60_icon_color: $e3613f6017c674c5$var$icon_variant_color_primary_60_icon_color,
    icon_variant_color_primary_70_icon_color: $e3613f6017c674c5$var$icon_variant_color_primary_70_icon_color,
    icon_variant_color_primary_background_icon_color: $e3613f6017c674c5$var$icon_variant_color_primary_background_icon_color,
    icon_variant_color_secondary_50_icon_color: $e3613f6017c674c5$var$icon_variant_color_secondary_50_icon_color,
    icon_variant_color_sparkle_50_icon_color: $e3613f6017c674c5$var$icon_variant_color_sparkle_50_icon_color,
    icon_variant_color_primary_grey_60_icon_color: $e3613f6017c674c5$var$icon_variant_color_primary_grey_60_icon_color,
    icon_variant_color_primary_grey_80_icon_color: $e3613f6017c674c5$var$icon_variant_color_primary_grey_80_icon_color,
    icon_variant_color_primary_grey_100_icon_color: $e3613f6017c674c5$var$icon_variant_color_primary_grey_100_icon_color,
    icon_variant_color_feedback_success_icon_color: $e3613f6017c674c5$var$icon_variant_color_feedback_success_icon_color,
    icon_variant_color_feedback_error_icon_color: $e3613f6017c674c5$var$icon_variant_color_feedback_error_icon_color,
    icon_variant_color_feedback_warning_icon_color: $e3613f6017c674c5$var$icon_variant_color_feedback_warning_icon_color,
    icon_variant_color_white_icon_color: $e3613f6017c674c5$var$icon_variant_color_white_icon_color,
    icon_variant_size_small_container_size: $e3613f6017c674c5$var$icon_variant_size_small_container_size,
    icon_variant_size_small_icon_size: $e3613f6017c674c5$var$icon_variant_size_small_icon_size,
    icon_variant_size_large_container_size: $e3613f6017c674c5$var$icon_variant_size_large_container_size,
    icon_variant_size_large_icon_size: $e3613f6017c674c5$var$icon_variant_size_large_icon_size,
    "icon_variant_size_xtra-large_container_size": "{xl}",
    "icon_variant_size_xtra-large_icon_size": "{xl}",
    "icon_variant_size_xtra-xtra-large_container_size": "{xxl}",
    "icon_variant_size_xtra-xtra-large_icon_size": "{xxl}",
    icon_variant_size_fill_container_size: $e3613f6017c674c5$var$icon_variant_size_fill_container_size,
    icon_variant_size_fill_icon_size: $e3613f6017c674c5$var$icon_variant_size_fill_icon_size,
    "icon_combination_background_primary_50_container_background-color": "{primary20}",
    "icon_combination_background_primary_30_container_background-color": "{primary20}",
    "icon_combination_background_primary_60_container_background-color": "{primary20}",
    "icon_combination_background_primary_70_container_background-color": "{primary20}",
    "icon_combination_background_primary_background_container_background-color": "{primary20}",
    "icon_combination_background_secondary_50_container_background-color": "{secondary20}",
    "icon_combination_background_sparkle_50_container_background-color": "{sparkle20}",
    "icon_combination_background_primary_grey_60_container_background-color": "{primaryGrey20}",
    "icon_combination_background_primary_grey_80_container_background-color": "{primaryGrey20}",
    "icon_combination_background_primary_grey_100_container_background-color": "{primaryGrey20}",
    "icon_combination_background_white_container_background-color": "{primary20}",
    "icon_combination_background_feedback_success_50_container_background-color": "{feedbackSuccess20}",
    "icon_combination_background_feedback_error_50_container_background-color": "{feedbackError20}",
    "icon_combination_background_feedback_warning_50_container_background-color": "{feedbackWarning20}",
    "icon_combination_background_bold_primary_50_container_background-color": "{primary50}",
    icon_combination_background_bold_primary_50_icon_color: $e3613f6017c674c5$var$icon_combination_background_bold_primary_50_icon_color,
    "icon_combination_background_bold_primary_30_container_background-color": "{primary30}",
    icon_combination_background_bold_primary_30_icon_color: $e3613f6017c674c5$var$icon_combination_background_bold_primary_30_icon_color,
    "icon_combination_background_bold_primary_60_container_background-color": "{primary60}",
    icon_combination_background_bold_primary_60_icon_color: $e3613f6017c674c5$var$icon_combination_background_bold_primary_60_icon_color,
    "icon_combination_background_bold_primary_70_container_background-color": "{primary70}",
    icon_combination_background_bold_primary_70_icon_color: $e3613f6017c674c5$var$icon_combination_background_bold_primary_70_icon_color,
    "icon_combination_background_bold_primary_background_container_background-color": "{primaryBackground}",
    icon_combination_background_bold_primary_background_icon_color: $e3613f6017c674c5$var$icon_combination_background_bold_primary_background_icon_color,
    "icon_combination_background_bold_secondary_50_container_background-color": "{secondary50}",
    icon_combination_background_bold_secondary_50_icon_color: $e3613f6017c674c5$var$icon_combination_background_bold_secondary_50_icon_color,
    "icon_combination_background_bold_sparkle_50_container_background-color": "{sparkle50}",
    icon_combination_background_bold_sparkle_50_icon_color: $e3613f6017c674c5$var$icon_combination_background_bold_sparkle_50_icon_color,
    "icon_combination_background_bold_primary_grey_60_container_background-color": "{primaryGrey60}",
    icon_combination_background_bold_primary_grey_60_icon_color: $e3613f6017c674c5$var$icon_combination_background_bold_primary_grey_60_icon_color,
    "icon_combination_background_bold_primary_grey_80_container_background-color": "{primaryGrey80}",
    icon_combination_background_bold_primary_grey_80_icon_color: $e3613f6017c674c5$var$icon_combination_background_bold_primary_grey_80_icon_color,
    "icon_combination_background_bold_primary_grey_100_container_background-color": "{primaryGrey100}",
    icon_combination_background_bold_primary_grey_100_icon_color: $e3613f6017c674c5$var$icon_combination_background_bold_primary_grey_100_icon_color,
    "icon_combination_background_bold_white_container_background-color": "{global.white}",
    icon_combination_background_bold_white_icon_color: $e3613f6017c674c5$var$icon_combination_background_bold_white_icon_color,
    "icon_combination_background_bold_feedback_success_50_container_background-color": "{feedbackSuccess50}",
    icon_combination_background_bold_feedback_success_50_icon_color: $e3613f6017c674c5$var$icon_combination_background_bold_feedback_success_50_icon_color,
    "icon_combination_background_bold_feedback_error_50_container_background-color": "{feedbackError50}",
    icon_combination_background_bold_feedback_error_50_icon_color: $e3613f6017c674c5$var$icon_combination_background_bold_feedback_error_50_icon_color,
    "icon_combination_background_bold_feedback_warning_50_container_background-color": "{feedbackWarning50}",
    icon_combination_background_bold_feedback_warning_50_icon_color: $e3613f6017c674c5$var$icon_combination_background_bold_feedback_warning_50_icon_color,
    icon_combination_medium_background_container_size: $e3613f6017c674c5$var$icon_combination_medium_background_container_size,
    icon_combination_medium_background_icon_size: $e3613f6017c674c5$var$icon_combination_medium_background_icon_size,
    icon_combination_small_background_container_size: $e3613f6017c674c5$var$icon_combination_small_background_container_size,
    "icon_combination_small_background_container_background-color": "{global.transparent}",
    icon_combination_small_background_icon_size: $e3613f6017c674c5$var$icon_combination_small_background_icon_size,
    icon_combination_large_background_container_size: $e3613f6017c674c5$var$icon_combination_large_background_container_size,
    icon_combination_large_background_icon_size: $e3613f6017c674c5$var$icon_combination_large_background_icon_size,
    "icon_combination_xtra-large_background_container_size": "{xl}",
    "icon_combination_xtra-large_background_icon_size": "{custom_3}",
    "icon_combination_xtra-xtra-large_background_container_size": "{xxl}",
    "icon_combination_xtra-xtra-large_background_icon_size": "{l}",
    "icon_combination_small_background_bold_primary_50_container_background-color": "{global.transparent}",
    icon_combination_small_background_bold_primary_50_icon_color: $e3613f6017c674c5$var$icon_combination_small_background_bold_primary_50_icon_color,
    "icon_combination_small_background_bold_primary_30_container_background-color": "{global.transparent}",
    icon_combination_small_background_bold_primary_30_icon_color: $e3613f6017c674c5$var$icon_combination_small_background_bold_primary_30_icon_color,
    "icon_combination_small_background_bold_primary_60_container_background-color": "{global.transparent}",
    icon_combination_small_background_bold_primary_60_icon_color: $e3613f6017c674c5$var$icon_combination_small_background_bold_primary_60_icon_color,
    "icon_combination_small_background_bold_primary_70_container_background-color": "{global.transparent}",
    icon_combination_small_background_bold_primary_70_icon_color: $e3613f6017c674c5$var$icon_combination_small_background_bold_primary_70_icon_color,
    "icon_combination_small_background_bold_primary_background_container_background-color": "{global.transparent}",
    icon_combination_small_background_bold_primary_background_icon_color: $e3613f6017c674c5$var$icon_combination_small_background_bold_primary_background_icon_color,
    "icon_combination_small_background_bold_secondary_50_container_background-color": "{global.transparent}",
    icon_combination_small_background_bold_secondary_50_icon_color: $e3613f6017c674c5$var$icon_combination_small_background_bold_secondary_50_icon_color,
    "icon_combination_small_background_bold_sparkle_50_container_background-color": "{global.transparent}",
    icon_combination_small_background_bold_sparkle_50_icon_color: $e3613f6017c674c5$var$icon_combination_small_background_bold_sparkle_50_icon_color,
    "icon_combination_small_background_bold_primary_grey_60_container_background-color": "{global.transparent}",
    icon_combination_small_background_bold_primary_grey_60_icon_color: $e3613f6017c674c5$var$icon_combination_small_background_bold_primary_grey_60_icon_color,
    "icon_combination_small_background_bold_primary_grey_80_container_background-color": "{global.transparent}",
    icon_combination_small_background_bold_primary_grey_80_icon_color: $e3613f6017c674c5$var$icon_combination_small_background_bold_primary_grey_80_icon_color,
    "icon_combination_small_background_bold_primary_grey_100_container_background-color": "{global.transparent}",
    icon_combination_small_background_bold_primary_grey_100_icon_color: $e3613f6017c674c5$var$icon_combination_small_background_bold_primary_grey_100_icon_color,
    "icon_combination_small_background_bold_white_container_background-color": "{global.transparent}",
    icon_combination_small_background_bold_white_icon_color: $e3613f6017c674c5$var$icon_combination_small_background_bold_white_icon_color,
    "icon_combination_small_background_bold_feedback_success_50_container_background-color": "{global.transparent}",
    icon_combination_small_background_bold_feedback_success_50_icon_color: $e3613f6017c674c5$var$icon_combination_small_background_bold_feedback_success_50_icon_color,
    "icon_combination_small_background_bold_feedback_error_50_container_background-color": "{global.transparent}",
    icon_combination_small_background_bold_feedback_error_50_icon_color: $e3613f6017c674c5$var$icon_combination_small_background_bold_feedback_error_50_icon_color,
    "icon_combination_small_background_bold_feedback_warning_50_container_background-color": "{global.transparent}",
    icon_combination_small_background_bold_feedback_warning_50_icon_color: $e3613f6017c674c5$var$icon_combination_small_background_bold_feedback_warning_50_icon_color,
    icon_combination_medium_background_bold_container_size: $e3613f6017c674c5$var$icon_combination_medium_background_bold_container_size,
    icon_combination_medium_background_bold_icon_size: $e3613f6017c674c5$var$icon_combination_medium_background_bold_icon_size,
    icon_combination_small_background_bold_container_size: $e3613f6017c674c5$var$icon_combination_small_background_bold_container_size,
    icon_combination_small_background_bold_icon_size: $e3613f6017c674c5$var$icon_combination_small_background_bold_icon_size,
    icon_combination_large_background_bold_container_size: $e3613f6017c674c5$var$icon_combination_large_background_bold_container_size,
    icon_combination_large_background_bold_icon_size: $e3613f6017c674c5$var$icon_combination_large_background_bold_icon_size,
    "icon_combination_xtra-large_background_bold_container_size": "{xl}",
    "icon_combination_xtra-large_background_bold_icon_size": "{custom_3}",
    "icon_combination_xtra-xtra-large_background_bold_container_size": "{xxl}",
    "icon_combination_xtra-xtra-large_background_bold_icon_size": "{l}",
    icon_combination_medium_background_feedback_success_container_size: $e3613f6017c674c5$var$icon_combination_medium_background_feedback_success_container_size,
    icon_combination_medium_background_feedback_error_container_size: $e3613f6017c674c5$var$icon_combination_medium_background_feedback_error_container_size,
    icon_combination_medium_background_feedback_warning_container_size: $e3613f6017c674c5$var$icon_combination_medium_background_feedback_warning_container_size,
    icon_combination_medium_background_feedback_success_icon_size: $e3613f6017c674c5$var$icon_combination_medium_background_feedback_success_icon_size,
    icon_combination_medium_background_feedback_error_icon_size: $e3613f6017c674c5$var$icon_combination_medium_background_feedback_error_icon_size,
    icon_combination_medium_background_feedback_warning_icon_size: $e3613f6017c674c5$var$icon_combination_medium_background_feedback_warning_icon_size,
    icon_combination_medium_background_bold_feedback_success_container_size: $e3613f6017c674c5$var$icon_combination_medium_background_bold_feedback_success_container_size,
    icon_combination_medium_background_bold_feedback_error_container_size: $e3613f6017c674c5$var$icon_combination_medium_background_bold_feedback_error_container_size,
    icon_combination_medium_background_bold_feedback_warning_container_size: $e3613f6017c674c5$var$icon_combination_medium_background_bold_feedback_warning_container_size,
    icon_combination_medium_background_bold_feedback_success_icon_size: $e3613f6017c674c5$var$icon_combination_medium_background_bold_feedback_success_icon_size,
    icon_combination_medium_background_bold_feedback_error_icon_size: $e3613f6017c674c5$var$icon_combination_medium_background_bold_feedback_error_icon_size,
    icon_combination_medium_background_bold_feedback_warning_icon_size: $e3613f6017c674c5$var$icon_combination_medium_background_bold_feedback_warning_icon_size,
    icon_combination_large_background_feedback_success_container_size: $e3613f6017c674c5$var$icon_combination_large_background_feedback_success_container_size,
    icon_combination_large_background_feedback_error_container_size: $e3613f6017c674c5$var$icon_combination_large_background_feedback_error_container_size,
    icon_combination_large_background_feedback_warning_container_size: $e3613f6017c674c5$var$icon_combination_large_background_feedback_warning_container_size,
    icon_combination_large_background_feedback_success_icon_size: $e3613f6017c674c5$var$icon_combination_large_background_feedback_success_icon_size,
    icon_combination_large_background_feedback_error_icon_size: $e3613f6017c674c5$var$icon_combination_large_background_feedback_error_icon_size,
    icon_combination_large_background_feedback_warning_icon_size: $e3613f6017c674c5$var$icon_combination_large_background_feedback_warning_icon_size,
    icon_combination_large_background_bold_feedback_success_container_size: $e3613f6017c674c5$var$icon_combination_large_background_bold_feedback_success_container_size,
    icon_combination_large_background_bold_feedback_error_container_size: $e3613f6017c674c5$var$icon_combination_large_background_bold_feedback_error_container_size,
    icon_combination_large_background_bold_feedback_warning_container_size: $e3613f6017c674c5$var$icon_combination_large_background_bold_feedback_warning_container_size,
    icon_combination_large_background_bold_feedback_success_icon_size: $e3613f6017c674c5$var$icon_combination_large_background_bold_feedback_success_icon_size,
    icon_combination_large_background_bold_feedback_error_icon_size: $e3613f6017c674c5$var$icon_combination_large_background_bold_feedback_error_icon_size,
    icon_combination_large_background_bold_feedback_warning_icon_size: $e3613f6017c674c5$var$icon_combination_large_background_bold_feedback_warning_icon_size,
    "icon_combination_xtra-large_background_feedback_success_container_size": "{xl}",
    "icon_combination_xtra-large_background_feedback_error_container_size": "{xl}",
    "icon_combination_xtra-large_background_feedback_warning_container_size": "{xl}",
    "icon_combination_xtra-large_background_feedback_success_icon_size": "{xl}",
    "icon_combination_xtra-large_background_feedback_error_icon_size": "{xl}",
    "icon_combination_xtra-large_background_feedback_warning_icon_size": "{xl}",
    "icon_combination_xtra-large_background_bold_feedback_success_container_size": "{xl}",
    "icon_combination_xtra-large_background_bold_feedback_error_container_size": "{xl}",
    "icon_combination_xtra-large_background_bold_feedback_warning_container_size": "{xl}",
    "icon_combination_xtra-large_background_bold_feedback_success_icon_size": "{xl}",
    "icon_combination_xtra-large_background_bold_feedback_error_icon_size": "{xl}",
    "icon_combination_xtra-large_background_bold_feedback_warning_icon_size": "{xl}",
    "icon_combination_xtra-xtra-large_background_feedback_success_container_size": "{xxl}",
    "icon_combination_xtra-xtra-large_background_feedback_error_container_size": "{xxl}",
    "icon_combination_xtra-xtra-large_background_feedback_warning_container_size": "{xxl}",
    "icon_combination_xtra-xtra-large_background_feedback_success_icon_size": "{xxl}",
    "icon_combination_xtra-xtra-large_background_feedback_error_icon_size": "{xxl}",
    "icon_combination_xtra-xtra-large_background_feedback_warning_icon_size": "{xxl}",
    "icon_combination_xtra-xtra-large_background_bold_feedback_success_container_size": "{xxl}",
    "icon_combination_xtra-xtra-large_background_bold_feedback_error_container_size": "{xxl}",
    "icon_combination_xtra-xtra-large_background_bold_feedback_warning_container_size": "{xxl}",
    "icon_combination_xtra-xtra-large_background_bold_feedback_success_icon_size": "{xxl}",
    "icon_combination_xtra-xtra-large_background_bold_feedback_error_icon_size": "{xxl}",
    "icon_combination_xtra-xtra-large_background_bold_feedback_warning_icon_size": "{xxl}",
    icon_combination_inverse_primary_icon_color: $e3613f6017c674c5$var$icon_combination_inverse_primary_icon_color,
    icon_combination_inverse_secondary_icon_color: $e3613f6017c674c5$var$icon_combination_inverse_secondary_icon_color,
    icon_combination_inverse_sparkle_icon_color: $e3613f6017c674c5$var$icon_combination_inverse_sparkle_icon_color,
    icon_combination_inverse_feedback_icon_color: $e3613f6017c674c5$var$icon_combination_inverse_feedback_icon_color
};
const $e3613f6017c674c5$var$image_base_container_width = "{size.min}";
const $e3613f6017c674c5$var$image_base_container_height = "{size.min}";
const $e3613f6017c674c5$var$image_base_image_width = "{size.max}";
const $e3613f6017c674c5$var$image_base_lottie_size = "{size.max}";
const $e3613f6017c674c5$var$image_base_icon_size = "{l}";
const $e3613f6017c674c5$var$image_base_icon_color = "{primaryGrey80}";
const $e3613f6017c674c5$var$image_variant_state_loading_image_opacity = "{opacity.invisible}";
const $e3613f6017c674c5$var$image_variant_state_empty_image_opacity = "{opacity.invisible}";
const $e3613f6017c674c5$var$image_variant_state_error_image_opacity = "{opacity.invisible}";
const $e3613f6017c674c5$var$ImageTokens = {
    "image_base_container_background-color": "{global.transparent}",
    "image_base_container_flex-direction": "{flexDirection.stack}",
    "image_base_container_justify-content": "{justifyContent.center}",
    "image_base_container_align-items": "{alignItems.center}",
    image_base_container_width: $e3613f6017c674c5$var$image_base_container_width,
    image_base_container_height: $e3613f6017c674c5$var$image_base_container_height,
    "image_base_container_border-radius": "{xl}",
    "image_base_image_aspect-ratio": "{aspect_ratio.1.1}",
    "image_base_image_border-radius": "{xl}",
    image_base_image_width: $e3613f6017c674c5$var$image_base_image_width,
    image_base_lottie_size: $e3613f6017c674c5$var$image_base_lottie_size,
    image_base_icon_size: $e3613f6017c674c5$var$image_base_icon_size,
    image_base_icon_color: $e3613f6017c674c5$var$image_base_icon_color,
    "image_base_provider-slot_width": "{size.max}",
    "image_base_skeleton-container_aspect-ratio": "{aspect_ratio.1.1}",
    "image_base_skeleton-container_width": "{size.max}",
    "image_base_skeleton-slot_size": "{size.max}",
    "image_variant_state_loading_container_background-color": "{primaryGrey20}",
    image_variant_state_loading_image_opacity: $e3613f6017c674c5$var$image_variant_state_loading_image_opacity,
    "image_variant_state_empty_container_background-color": "{primaryGrey20}",
    image_variant_state_empty_image_opacity: $e3613f6017c674c5$var$image_variant_state_empty_image_opacity,
    "image_variant_state_error_container_background-color": "{primaryGrey20}",
    image_variant_state_error_image_opacity: $e3613f6017c674c5$var$image_variant_state_error_image_opacity,
    "image_combination_horizontal_4_3_true_image_aspect-ratio": "{aspect_ratio.4.3}",
    "image_combination_horizontal_4_3_true_skeleton-container_aspect-ratio": "{aspect_ratio.4.3}",
    "image_combination_horizontal_4_3_false_image_aspect-ratio": "{aspect_ratio.4.3}",
    "image_combination_horizontal_4_3_false_skeleton-container_aspect-ratio": "{aspect_ratio.4.3}",
    "image_combination_horizontal_5_4_true_image_aspect-ratio": "{aspect_ratio.5.4}",
    "image_combination_horizontal_5_4_true_skeleton-container_aspect-ratio": "{aspect_ratio.5.4}",
    "image_combination_horizontal_5_4_false_image_aspect-ratio": "{aspect_ratio.5.4}",
    "image_combination_horizontal_5_4_false_skeleton-container_aspect-ratio": "{aspect_ratio.5.4}",
    "image_combination_horizontal_16_9_true_image_aspect-ratio": "{aspect_ratio.16.9}",
    "image_combination_horizontal_16_9_true_skeleton-container_aspect-ratio": "{aspect_ratio.16.9}",
    "image_combination_horizontal_16_9_false_image_aspect-ratio": "{aspect_ratio.16.9}",
    "image_combination_horizontal_16_9_false_skeleton-container_aspect-ratio": "{aspect_ratio.16.9}",
    "image_combination_vertical_4_5_true_image_aspect-ratio": "{aspect_ratio.4.5}",
    "image_combination_vertical_4_5_true_skeleton-container_aspect-ratio": "{aspect_ratio.4.5}",
    "image_combination_vertical_4_5_false_image_aspect-ratio": "{aspect_ratio.4.5}",
    "image_combination_vertical_4_5_false_skeleton-container_aspect-ratio": "{aspect_ratio.4.5}",
    "image_combination_vertical_3_4_true_image_aspect-ratio": "{aspect_ratio.3.4}",
    "image_combination_vertical_3_4_true_skeleton-container_aspect-ratio": "{aspect_ratio.3.4}",
    "image_combination_vertical_3_4_false_image_aspect-ratio": "{aspect_ratio.3.4}",
    "image_combination_vertical_3_4_false_skeleton-container_aspect-ratio": "{aspect_ratio.3.4}",
    "image_combination_vertical_9_16_true_image_aspect-ratio": "{aspect_ratio.9.16}",
    "image_combination_vertical_9_16_true_skeleton-container_aspect-ratio": "{aspect_ratio.9.16}",
    "image_combination_vertical_9_16_false_image_aspect-ratio": "{aspect_ratio.9.16}",
    "image_combination_vertical_9_16_false_skeleton-container_aspect-ratio": "{aspect_ratio.9.16}",
    "image_combination_horizontal_2_75__1_true_image_aspect-ratio": "{aspect_ratio.2_75.1}",
    "image_combination_horizontal_2_75__1_true_skeleton-container_aspect-ratio": "{aspect_ratio.2_75.1}",
    "image_combination_horizontal_2_75__1_false_image_aspect-ratio": "{aspect_ratio.2_75.1}",
    "image_combination_horizontal_2_75__1_false_skeleton-container_aspect-ratio": "{aspect_ratio.2_75.1}"
};
const $e3613f6017c674c5$var$inputcode_base_container_width = "{size.max}";
const $e3613f6017c674c5$var$inputcode_base_container_gap = "{xs}";
const $e3613f6017c674c5$var$inputcode_variant_disabled_true_container_opacity = "{opacity.disabled}";
const $e3613f6017c674c5$var$inputcode_base_container_opacity = "{opacity.enabled}";
const $e3613f6017c674c5$var$InputCodeTokens = {
    "inputcode_base_container_flex-direction": "{flexDirection.column}",
    "inputcode_base_container_justify-content": "{justifyContent.start}",
    "inputcode_base_container_align-items": "{alignItems.start}",
    inputcode_base_container_width: $e3613f6017c674c5$var$inputcode_base_container_width,
    inputcode_base_container_gap: $e3613f6017c674c5$var$inputcode_base_container_gap,
    "inputcode_base_field-container_flex-direction": "{flexDirection.row}",
    "inputcode_base_field-container_justify-content": "{justifyContent.center}",
    "inputcode_base_field-container_align-items": "{alignItems.center}",
    "inputcode_base_field-container_width": "{size.max}",
    "inputcode_base_field-container_gap": "{xs}",
    inputcode_variant_disabled_true_container_opacity: $e3613f6017c674c5$var$inputcode_variant_disabled_true_container_opacity,
    inputcode_base_container_opacity: $e3613f6017c674c5$var$inputcode_base_container_opacity
};
const $e3613f6017c674c5$var$input_base_input_width = "{size.max}";
const $e3613f6017c674c5$var$input_variant_disabled_true_input_opacity = "{opacity.disabled}";
const $e3613f6017c674c5$var$input_variant_color_primary_80_input_text_color = "{primary80}";
const $e3613f6017c674c5$var$input_variant_color_primary_70_input_text_color = "{primary70}";
const $e3613f6017c674c5$var$input_variant_color_primary_60_input_text_color = "{primary60}";
const $e3613f6017c674c5$var$input_variant_color_primary_50_input_text_color = "{primary50}";
const $e3613f6017c674c5$var$input_variant_color_primary_40_input_text_color = "{primary40}";
const $e3613f6017c674c5$var$input_variant_color_primary_30_input_text_color = "{primary30}";
const $e3613f6017c674c5$var$input_variant_color_primary_20_input_text_color = "{primary20}";
const $e3613f6017c674c5$var$input_variant_color_primary_inverse_input_text_color = "{primaryInverse}";
const $e3613f6017c674c5$var$input_variant_color_primary_background_input_text_color = "{primaryBackground}";
const $e3613f6017c674c5$var$input_variant_color_primary_grey_100_input_text_color = "{primaryGrey100}";
const $e3613f6017c674c5$var$input_variant_color_primary_grey_80_input_text_color = "{primaryGrey80}";
const $e3613f6017c674c5$var$input_variant_color_primary_grey_60_input_text_color = "{primaryGrey60}";
const $e3613f6017c674c5$var$input_variant_color_primary_grey_40_input_text_color = "{primaryGrey40}";
const $e3613f6017c674c5$var$input_variant_color_primary_grey_20_input_text_color = "{primaryGrey20}";
const $e3613f6017c674c5$var$input_variant_color_secondary_80_input_text_color = "{secondary80}";
const $e3613f6017c674c5$var$input_variant_color_secondary_70_input_text_color = "{secondary70}";
const $e3613f6017c674c5$var$input_variant_color_secondary_60_input_text_color = "{secondary60}";
const $e3613f6017c674c5$var$input_variant_color_secondary_50_input_text_color = "{secondary50}";
const $e3613f6017c674c5$var$input_variant_color_secondary_40_input_text_color = "{secondary40}";
const $e3613f6017c674c5$var$input_variant_color_secondary_30_input_text_color = "{secondary30}";
const $e3613f6017c674c5$var$input_variant_color_secondary_20_input_text_color = "{secondary20}";
const $e3613f6017c674c5$var$input_variant_color_secondary_inverse_input_text_color = "{secondaryInverse}";
const $e3613f6017c674c5$var$input_variant_color_secondary_background_input_text_color = "{secondaryBackground}";
const $e3613f6017c674c5$var$input_variant_color_secondary_grey_100_input_text_color = "{secondaryGrey100}";
const $e3613f6017c674c5$var$input_variant_color_secondary_grey_80_input_text_color = "{secondaryGrey80}";
const $e3613f6017c674c5$var$input_variant_color_secondary_grey_60_input_text_color = "{secondaryGrey60}";
const $e3613f6017c674c5$var$input_variant_color_secondary_grey_40_input_text_color = "{secondaryGrey40}";
const $e3613f6017c674c5$var$input_variant_color_secondary_grey_20_input_text_color = "{secondaryGrey20}";
const $e3613f6017c674c5$var$input_variant_color_sparkle_80_input_text_color = "{sparkle80}";
const $e3613f6017c674c5$var$input_variant_color_sparkle_70_input_text_color = "{sparkle70}";
const $e3613f6017c674c5$var$input_variant_color_sparkle_60_input_text_color = "{sparkle60}";
const $e3613f6017c674c5$var$input_variant_color_sparkle_50_input_text_color = "{sparkle50}";
const $e3613f6017c674c5$var$input_variant_color_sparkle_40_input_text_color = "{sparkle40}";
const $e3613f6017c674c5$var$input_variant_color_sparkle_30_input_text_color = "{sparkle30}";
const $e3613f6017c674c5$var$input_variant_color_sparkle_20_input_text_color = "{sparkle20}";
const $e3613f6017c674c5$var$input_variant_color_sparkle_inverse_input_text_color = "{sparkleInverse}";
const $e3613f6017c674c5$var$input_variant_color_sparkle_background_input_text_color = "{sparkleBackground}";
const $e3613f6017c674c5$var$input_variant_color_sparkle_grey_100_input_text_color = "{sparkleGrey100}";
const $e3613f6017c674c5$var$input_variant_color_sparkle_grey_80_input_text_color = "{sparkleGrey80}";
const $e3613f6017c674c5$var$input_variant_color_sparkle_grey_60_input_text_color = "{sparkleGrey60}";
const $e3613f6017c674c5$var$input_variant_color_sparkle_grey_40_input_text_color = "{sparkleGrey40}";
const $e3613f6017c674c5$var$input_variant_color_sparkle_grey_20_input_text_color = "{sparkleGrey20}";
const $e3613f6017c674c5$var$input_variant_color_feedback_error_80_input_text_color = "{feedbackError80}";
const $e3613f6017c674c5$var$input_variant_color_feedback_error_50_input_text_color = "{feedbackError50}";
const $e3613f6017c674c5$var$input_variant_color_feedback_error_20_input_text_color = "{feedbackError20}";
const $e3613f6017c674c5$var$input_variant_color_feedback_warning_80_input_text_color = "{feedbackWarning80}";
const $e3613f6017c674c5$var$input_variant_color_feedback_warning_50_input_text_color = "{feedbackWarning50}";
const $e3613f6017c674c5$var$input_variant_color_feedback_warning_20_input_text_color = "{feedbackWarning20}";
const $e3613f6017c674c5$var$input_variant_color_feedback_success_80_input_text_color = "{feedbackSuccess80}";
const $e3613f6017c674c5$var$input_variant_color_feedback_success_50_input_text_color = "{feedbackSuccess50}";
const $e3613f6017c674c5$var$input_variant_color_feedback_success_20_input_text_color = "{feedbackSuccess20}";
const $e3613f6017c674c5$var$input_variant_color_white_input_text_color = "{global.white}";
const $e3613f6017c674c5$var$input_variant_color_black_input_text_color = "{global.black}";
const $e3613f6017c674c5$var$input_variant_color_transparent_input_text_color = "{global.transparent}";
const $e3613f6017c674c5$var$InputTokens = {
    "input_base_input_text-align": "{textAlign.start}",
    "input_base_input_placeholder-color": "{primaryGrey60}",
    "input_base_input_placeholder-font-family": "{bodyS}",
    "input_base_input_placeholder-font-size": "{bodyS}",
    "input_base_input_placeholder-font-weight": "{bodyS}",
    "input_base_input_placeholder-line-height": "{bodyS}",
    "input_base_input_placeholder-letter-spacing": "{bodyS}",
    "input_base_input_input-color": "{primaryGrey100}",
    "input_base_input_input-font-family": "{bodyS}",
    "input_base_input_input-font-size": "{bodyS}",
    "input_base_input_input-font-weight": "{bodyS}",
    "input_base_input_input-line-height": "{bodyS}",
    "input_base_input_input-letter-spacing": "{bodyS}",
    "input_base_input_cursor-color": "{primaryGrey100}",
    input_base_input_width: $e3613f6017c674c5$var$input_base_input_width,
    input_variant_disabled_true_input_opacity: $e3613f6017c674c5$var$input_variant_disabled_true_input_opacity,
    "input_variant_textAlign_center_input_text-align": "{textAlign.center}",
    "input_variant_textAlign_end_input_text-align": "{textAlign.end}",
    "input_variant_textAlign_justify_input_text-align": "{textAlign.justify}",
    "input_variant_textSize_large_input_placeholder-font-family": "{bodyL}",
    "input_variant_textSize_large_input_placeholder-font-size": "{bodyL}",
    "input_variant_textSize_large_input_placeholder-line-height": "{bodyL}",
    "input_variant_textSize_large_input_placeholder-font-weight": "{bodyL}",
    "input_variant_textSize_large_input_input-font-family": "{bodyL}",
    "input_variant_textSize_large_input_input-font-size": "{bodyL}",
    "input_variant_textSize_large_input_input-line-height": "{bodyL}",
    "input_variant_textSize_large_input_input-font-weight": "{bodyL}",
    input_variant_color_primary_80_input_text_color: $e3613f6017c674c5$var$input_variant_color_primary_80_input_text_color,
    input_variant_color_primary_70_input_text_color: $e3613f6017c674c5$var$input_variant_color_primary_70_input_text_color,
    input_variant_color_primary_60_input_text_color: $e3613f6017c674c5$var$input_variant_color_primary_60_input_text_color,
    input_variant_color_primary_50_input_text_color: $e3613f6017c674c5$var$input_variant_color_primary_50_input_text_color,
    input_variant_color_primary_40_input_text_color: $e3613f6017c674c5$var$input_variant_color_primary_40_input_text_color,
    input_variant_color_primary_30_input_text_color: $e3613f6017c674c5$var$input_variant_color_primary_30_input_text_color,
    input_variant_color_primary_20_input_text_color: $e3613f6017c674c5$var$input_variant_color_primary_20_input_text_color,
    input_variant_color_primary_inverse_input_text_color: $e3613f6017c674c5$var$input_variant_color_primary_inverse_input_text_color,
    input_variant_color_primary_background_input_text_color: $e3613f6017c674c5$var$input_variant_color_primary_background_input_text_color,
    input_variant_color_primary_grey_100_input_text_color: $e3613f6017c674c5$var$input_variant_color_primary_grey_100_input_text_color,
    input_variant_color_primary_grey_80_input_text_color: $e3613f6017c674c5$var$input_variant_color_primary_grey_80_input_text_color,
    input_variant_color_primary_grey_60_input_text_color: $e3613f6017c674c5$var$input_variant_color_primary_grey_60_input_text_color,
    input_variant_color_primary_grey_40_input_text_color: $e3613f6017c674c5$var$input_variant_color_primary_grey_40_input_text_color,
    input_variant_color_primary_grey_20_input_text_color: $e3613f6017c674c5$var$input_variant_color_primary_grey_20_input_text_color,
    input_variant_color_secondary_80_input_text_color: $e3613f6017c674c5$var$input_variant_color_secondary_80_input_text_color,
    input_variant_color_secondary_70_input_text_color: $e3613f6017c674c5$var$input_variant_color_secondary_70_input_text_color,
    input_variant_color_secondary_60_input_text_color: $e3613f6017c674c5$var$input_variant_color_secondary_60_input_text_color,
    input_variant_color_secondary_50_input_text_color: $e3613f6017c674c5$var$input_variant_color_secondary_50_input_text_color,
    input_variant_color_secondary_40_input_text_color: $e3613f6017c674c5$var$input_variant_color_secondary_40_input_text_color,
    input_variant_color_secondary_30_input_text_color: $e3613f6017c674c5$var$input_variant_color_secondary_30_input_text_color,
    input_variant_color_secondary_20_input_text_color: $e3613f6017c674c5$var$input_variant_color_secondary_20_input_text_color,
    input_variant_color_secondary_inverse_input_text_color: $e3613f6017c674c5$var$input_variant_color_secondary_inverse_input_text_color,
    input_variant_color_secondary_background_input_text_color: $e3613f6017c674c5$var$input_variant_color_secondary_background_input_text_color,
    input_variant_color_secondary_grey_100_input_text_color: $e3613f6017c674c5$var$input_variant_color_secondary_grey_100_input_text_color,
    input_variant_color_secondary_grey_80_input_text_color: $e3613f6017c674c5$var$input_variant_color_secondary_grey_80_input_text_color,
    input_variant_color_secondary_grey_60_input_text_color: $e3613f6017c674c5$var$input_variant_color_secondary_grey_60_input_text_color,
    input_variant_color_secondary_grey_40_input_text_color: $e3613f6017c674c5$var$input_variant_color_secondary_grey_40_input_text_color,
    input_variant_color_secondary_grey_20_input_text_color: $e3613f6017c674c5$var$input_variant_color_secondary_grey_20_input_text_color,
    input_variant_color_sparkle_80_input_text_color: $e3613f6017c674c5$var$input_variant_color_sparkle_80_input_text_color,
    input_variant_color_sparkle_70_input_text_color: $e3613f6017c674c5$var$input_variant_color_sparkle_70_input_text_color,
    input_variant_color_sparkle_60_input_text_color: $e3613f6017c674c5$var$input_variant_color_sparkle_60_input_text_color,
    input_variant_color_sparkle_50_input_text_color: $e3613f6017c674c5$var$input_variant_color_sparkle_50_input_text_color,
    input_variant_color_sparkle_40_input_text_color: $e3613f6017c674c5$var$input_variant_color_sparkle_40_input_text_color,
    input_variant_color_sparkle_30_input_text_color: $e3613f6017c674c5$var$input_variant_color_sparkle_30_input_text_color,
    input_variant_color_sparkle_20_input_text_color: $e3613f6017c674c5$var$input_variant_color_sparkle_20_input_text_color,
    input_variant_color_sparkle_inverse_input_text_color: $e3613f6017c674c5$var$input_variant_color_sparkle_inverse_input_text_color,
    input_variant_color_sparkle_background_input_text_color: $e3613f6017c674c5$var$input_variant_color_sparkle_background_input_text_color,
    input_variant_color_sparkle_grey_100_input_text_color: $e3613f6017c674c5$var$input_variant_color_sparkle_grey_100_input_text_color,
    input_variant_color_sparkle_grey_80_input_text_color: $e3613f6017c674c5$var$input_variant_color_sparkle_grey_80_input_text_color,
    input_variant_color_sparkle_grey_60_input_text_color: $e3613f6017c674c5$var$input_variant_color_sparkle_grey_60_input_text_color,
    input_variant_color_sparkle_grey_40_input_text_color: $e3613f6017c674c5$var$input_variant_color_sparkle_grey_40_input_text_color,
    input_variant_color_sparkle_grey_20_input_text_color: $e3613f6017c674c5$var$input_variant_color_sparkle_grey_20_input_text_color,
    input_variant_color_feedback_error_80_input_text_color: $e3613f6017c674c5$var$input_variant_color_feedback_error_80_input_text_color,
    input_variant_color_feedback_error_50_input_text_color: $e3613f6017c674c5$var$input_variant_color_feedback_error_50_input_text_color,
    input_variant_color_feedback_error_20_input_text_color: $e3613f6017c674c5$var$input_variant_color_feedback_error_20_input_text_color,
    input_variant_color_feedback_warning_80_input_text_color: $e3613f6017c674c5$var$input_variant_color_feedback_warning_80_input_text_color,
    input_variant_color_feedback_warning_50_input_text_color: $e3613f6017c674c5$var$input_variant_color_feedback_warning_50_input_text_color,
    input_variant_color_feedback_warning_20_input_text_color: $e3613f6017c674c5$var$input_variant_color_feedback_warning_20_input_text_color,
    input_variant_color_feedback_success_80_input_text_color: $e3613f6017c674c5$var$input_variant_color_feedback_success_80_input_text_color,
    input_variant_color_feedback_success_50_input_text_color: $e3613f6017c674c5$var$input_variant_color_feedback_success_50_input_text_color,
    input_variant_color_feedback_success_20_input_text_color: $e3613f6017c674c5$var$input_variant_color_feedback_success_20_input_text_color,
    input_variant_color_white_input_text_color: $e3613f6017c674c5$var$input_variant_color_white_input_text_color,
    input_variant_color_black_input_text_color: $e3613f6017c674c5$var$input_variant_color_black_input_text_color,
    input_variant_color_transparent_input_text_color: $e3613f6017c674c5$var$input_variant_color_transparent_input_text_color
};
const $e3613f6017c674c5$var$inputdate_base_container_gap = "{xs}";
const $e3613f6017c674c5$var$inputdate_base_container_width = "{size.max}";
const $e3613f6017c674c5$var$inputdate_variant_disabled_true_container_opacity = "{opacity.disabled}";
const $e3613f6017c674c5$var$InputDateTokens = {
    "inputdate_base_container_flex-direction": "{flexDirection.column}",
    "inputdate_base_container_align-items": "{alignItems.start}",
    inputdate_base_container_gap: $e3613f6017c674c5$var$inputdate_base_container_gap,
    inputdate_base_container_width: $e3613f6017c674c5$var$inputdate_base_container_width,
    "inputdate_base_outer-container_flex-direction": "{flexDirection.row}",
    "inputdate_base_outer-container_width": "{size.max}",
    "inputdate_base_outer-container_align-items": "{alignItems.center}",
    "inputdate_base_field-container_flex-direction": "{flexDirection.column}",
    "inputdate_base_field-container_width": "{size.max}",
    "inputdate_base_field-container_align-items": "{alignItems.start}",
    "inputdate_base_input-container_width": "{size.max}",
    "inputdate_base_input-container_gap": "{s}",
    "inputdate_base_input-container_align-items": "{alignItems.stretch}",
    "inputdate_base_dd-container_flex-direction": "{flexDirection.column}",
    "inputdate_base_dd-container_gap": "{xs}",
    "inputdate_base_dd-container_align-items": "{alignItems.start}",
    "inputdate_base_dd-jds_input_textAlign": "{textAlign.start}",
    "inputdate_base_dd-active-line-container_width": "{size.max}",
    "inputdate_base_dd-feedback-container_width": "{size.max}",
    "inputdate_base_dd-feedback-container_background-color": "{primaryGrey80}",
    "inputdate_base_left-slash-container_background-color": "{primaryGrey60}",
    "inputdate_base_mm-container_flex-direction": "{flexDirection.column}",
    "inputdate_base_mm-container_gap": "{xs}",
    "inputdate_base_mm-container_align-items": "{alignItems.start}",
    "inputdate_base_mm-jds_input_textAlign": "{textAlign.start}",
    "inputdate_base_mm-active-line-container_width": "{size.max}",
    "inputdate_base_mm-feedback-container_width": "{size.max}",
    "inputdate_base_mm-feedback-container_background-color": "{primaryGrey80}",
    "inputdate_base_right-slash-container_background-color": "{primaryGrey60}",
    "inputdate_base_yy-container_flex-direction": "{flexDirection.column}",
    "inputdate_base_yy-container_gap": "{xs}",
    "inputdate_base_yy-container_align-items": "{alignItems.start}",
    "inputdate_base_yy-jds_input_textAlign": "{textAlign.start}",
    "inputdate_base_yy-active-line-container_width": "{size.max}",
    "inputdate_base_yy-feedback-container_width": "{size.max}",
    "inputdate_base_yy-feedback-container_background-color": "{primaryGrey80}",
    "inputdate_base_calendar-container_justify-content": "{justifyContent.center}",
    "inputdate_base_calendar-container_align-items": "{alignItems.center}",
    "inputdate_base_bottom-container_flex-direction": "{flexDirection.column}",
    "inputdate_base_bottom-container_align-items": "{alignItems.start}",
    "inputdate_base_bottom-container_gap": "{xs}",
    "inputdate_base_bottom-container_width": "{size.max}",
    inputdate_variant_disabled_true_container_opacity: $e3613f6017c674c5$var$inputdate_variant_disabled_true_container_opacity,
    "inputdate_variant_disabled_true_bottom-container_opacity": "{opacity.disabled}",
    "inputdate_variant_error_true_dd-feedback-container_background-color": "{feedbackError50}",
    "inputdate_variant_error_true_mm-feedback-container_background-color": "{feedbackError50}",
    "inputdate_variant_error_true_yy-feedback-container_background-color": "{feedbackError50}",
    "inputdate_variant_ddError_true_dd-feedback-container_background-color": "{feedbackError50}",
    "inputdate_variant_mmError_true_mm-feedback-container_background-color": "{feedbackError50}",
    "inputdate_variant_yyError_true_yy-feedback-container_background-color": "{feedbackError50}"
};
const $e3613f6017c674c5$var$inputcodeitem_base_jds_input_width = "{size.max}";
const $e3613f6017c674c5$var$InputCodeItemTokens = {
    "inputcodeitem_base_input-container_flex-direction": "{flexDirection.column}",
    "inputcodeitem_base_input-container_justify-content": "{justifyContent.center}",
    "inputcodeitem_base_input-container_align-items": "{alignItems.center}",
    "inputcodeitem_base_input-container_gap": "{xs}",
    "inputcodeitem_base_input-container_input_width": "{size.max}",
    inputcodeitem_base_jds_input_width: $e3613f6017c674c5$var$inputcodeitem_base_jds_input_width,
    "inputcodeitem_base_active-line-container_flex-direction": "{flexDirection.column}",
    "inputcodeitem_base_active-line-container_justify-content": "{justifyContent.center}",
    "inputcodeitem_base_active-line-container_align-items": "{alignItems.center}",
    "inputcodeitem_base_active-line-container_width": "{size.max}",
    "inputcodeitem_base_active-line-container_padding-top": "{custom_1}",
    "inputcodeitem_base_active-line-container_padding-bottom": "{custom_1}",
    "inputcodeitem_base_feedback-container_width": "{size.max}",
    "inputcodeitem_base_feedback-container_height": "{custom_4}",
    "inputcodeitem_base_feedback-container_background-color": "{primaryGrey100}",
    "inputcodeitem_base_feedback-container_border-radius": "{custom_2}",
    "inputcodeitem_base_feedback-container_behavior_hover_background-color": "{primary50}",
    "inputcodeitem_base_feedback-container_behavior_focus_background-color": "{primary50}",
    "inputcodeitem_base_feedback-container_behavior_active_background-color": "{primary50}",
    "inputcodeitem_variant_state_success_feedback-container_background-color": "{feedbackSuccess50}",
    "inputcodeitem_variant_state_error_feedback-container_background-color": "{feedbackError50}",
    "inputcodeitem_variant_state_warning_feedback-container_background-color": "{feedbackWarning50}",
    "inputcodeitem_combination_none_true_feedback-container_background-color": "{primary60}"
};
const $e3613f6017c674c5$var$fileuploader_base_container_width = "{size.max}";
const $e3613f6017c674c5$var$fileuploader_base_container_gap = "{xs}";
const $e3613f6017c674c5$var$fileuploader_base_container_opacity = "{opacity.enabled}";
const $e3613f6017c674c5$var$FileUploaderTokens = {
    "fileuploader_base_container_flex-direction": "{flexDirection.column}",
    "fileuploader_base_container_justify-content": "{justifyContent.start}",
    "fileuploader_base_container_align-items": "{alignItems.start}",
    fileuploader_base_container_width: $e3613f6017c674c5$var$fileuploader_base_container_width,
    fileuploader_base_container_gap: $e3613f6017c674c5$var$fileuploader_base_container_gap,
    fileuploader_base_container_opacity: $e3613f6017c674c5$var$fileuploader_base_container_opacity
};
const $e3613f6017c674c5$var$fileuploadercontrol_base_container_gap = "{xxs}";
const $e3613f6017c674c5$var$fileuploadercontrol_base_container_width = "{size.max}";
const $e3613f6017c674c5$var$fileuploadercontrol_base_container_opacity = "{opacity.enabled}";
const $e3613f6017c674c5$var$FileUploaderControlTokens = {
    "fileuploadercontrol_base_container_flex-direction": "{flexDirection.column}",
    "fileuploadercontrol_base_container_justify-content": "{justifyContent.start}",
    "fileuploadercontrol_base_container_align-items": "{alignItems.start}",
    fileuploadercontrol_base_container_gap: $e3613f6017c674c5$var$fileuploadercontrol_base_container_gap,
    fileuploadercontrol_base_container_width: $e3613f6017c674c5$var$fileuploadercontrol_base_container_width,
    fileuploadercontrol_base_container_opacity: $e3613f6017c674c5$var$fileuploadercontrol_base_container_opacity,
    "fileuploadercontrol_base_label-container_flex-direction": "{flexDirection.row}",
    "fileuploadercontrol_base_label-container_justify-content": "{justifyContent.start}",
    "fileuploadercontrol_base_label-container_align-items": "{alignItems.center}",
    "fileuploadercontrol_base_label-container_gap": "{xxs}"
};
const $e3613f6017c674c5$var$fileuploaderitem_base_container_width = "{size.max}";
const $e3613f6017c674c5$var$fileuploaderitem_base_container_opacity = "{opacity.enabled}";
const $e3613f6017c674c5$var$FileUploaderItemTokens = {
    "fileuploaderitem_base_container_flex-direction": "{flexDirection.column}",
    "fileuploaderitem_base_container_justify-content": "{justifyContent.start}",
    "fileuploaderitem_base_container_align-items": "{alignItems.start}",
    fileuploaderitem_base_container_width: $e3613f6017c674c5$var$fileuploaderitem_base_container_width,
    fileuploaderitem_base_container_opacity: $e3613f6017c674c5$var$fileuploaderitem_base_container_opacity,
    "fileuploaderitem_base_container_background-color": "{primaryGrey20}",
    "fileuploaderitem_base_file-container_flex-direction": "{flexDirection.row}",
    "fileuploaderitem_base_file-container_justify-content": "{justifyContent.spaceBetween}",
    "fileuploaderitem_base_file-container_align-items": "{alignItems.center}",
    "fileuploaderitem_base_file-container_gap": "{xs}",
    "fileuploaderitem_base_file-container_padding-left": "{s}",
    "fileuploaderitem_base_file-container_width": "{size.max}",
    "fileuploaderitem_base_state-container_flex-direction": "{flexDirection.row}",
    "fileuploaderitem_base_state-container_justify-content": "{justifyContent.start}",
    "fileuploaderitem_base_state-container_align-items": "{alignItems.center}",
    "fileuploaderitem_base_state-container_gap": "{xs}",
    "fileuploaderitem_base_button-container_align-items": "{alignItems.center}"
};
const $e3613f6017c674c5$var$fileuploaderlist_base_container_width = "{size.max}";
const $e3613f6017c674c5$var$fileuploaderlist_base_container_opacity = "{opacity.enabled}";
const $e3613f6017c674c5$var$FileUploaderListTokens = {
    "fileuploaderlist_base_container_flex-direction": "{flexDirection.column}",
    "fileuploaderlist_base_container_justify-content": "{justifyContent.start}",
    "fileuploaderlist_base_container_align-items": "{alignItems.start}",
    fileuploaderlist_base_container_width: $e3613f6017c674c5$var$fileuploaderlist_base_container_width,
    fileuploaderlist_base_container_opacity: $e3613f6017c674c5$var$fileuploaderlist_base_container_opacity,
    "fileuploaderlist_base_container_background-color": "{primaryGrey20}",
    "fileuploaderlist_base_container_border-radius": "{large}"
};
const $e3613f6017c674c5$var$fileuploaderpanel_base_container_width = "{size.max}";
const $e3613f6017c674c5$var$fileuploaderpanel_base_container_opacity = "{opacity.enabled}";
const $e3613f6017c674c5$var$FileUploaderPanelTokens = {
    "fileuploaderpanel_base_container_flex-direction": "{flexDirection.column}",
    "fileuploaderpanel_base_container_justify-content": "{justifyContent.start}",
    "fileuploaderpanel_base_container_align-items": "{alignItems.start}",
    fileuploaderpanel_base_container_width: $e3613f6017c674c5$var$fileuploaderpanel_base_container_width,
    fileuploaderpanel_base_container_opacity: $e3613f6017c674c5$var$fileuploaderpanel_base_container_opacity,
    "fileuploaderpanel_base_container_background-color": "{primaryGrey20}",
    "fileuploaderpanel_base_container_border-radius": "{large}",
    "fileuploaderpanel_base_container_padding-top": "{xs}",
    "fileuploaderpanel_base_container_padding-bottom": "{xs}",
    "fileuploaderpanel_base_inner-container_padding-top": "{xs}",
    "fileuploaderpanel_base_inner-container_padding-bottom": "{xs}",
    "fileuploaderpanel_base_inner-container_padding-left": "{s}",
    "fileuploaderpanel_base_inner-container_padding-right": "{s}",
    "fileuploaderpanel_base_inner-container_width": "{size.max}"
};
const $e3613f6017c674c5$var$textarea_base_container_gap = "{xxs}";
const $e3613f6017c674c5$var$textarea_base_container_width = "{size.max}";
const $e3613f6017c674c5$var$textarea_base_input_width = "{size.max}";
const $e3613f6017c674c5$var$textarea_variant_disabled_true_container_opacity = "{opacity.disabled}";
const $e3613f6017c674c5$var$textarea_base_container_opacity = "{opacity.enabled}";
const $e3613f6017c674c5$var$TextareaTokens = {
    "textarea_base_container_flex-direction": "{flexDirection.column}",
    "textarea_base_container_justify-content": "{justifyContent.start}",
    "textarea_base_container_align-items": "{alignItems.start}",
    textarea_base_container_gap: $e3613f6017c674c5$var$textarea_base_container_gap,
    textarea_base_container_width: $e3613f6017c674c5$var$textarea_base_container_width,
    "textarea_base_field-container_flex-direction": "{flexDirection.stack}",
    "textarea_base_field-container_width": "{size.max}",
    "textarea_base_field-container_padding-bottom": "{xxs}",
    "textarea_base_field-container_justify-content": "{justifyContent.start}",
    "textarea_base_field-container_align-items": "{alignItems.end}",
    "textarea_base_input-container_flex-direction": "{flexDirection.row}",
    "textarea_base_input-container_justify-content": "{justifyContent.start}",
    "textarea_base_input-container_width": "{size.max}",
    "textarea_base_input-container_align-items": "{alignItems.center}",
    "textarea_base_input_text-align": "{textAlign.start}",
    "textarea_base_input_placeholder-color": "{primaryGrey60}",
    "textarea_base_input_placeholder-font-family": "{bodyS}",
    "textarea_base_input_placeholder-font-size": "{bodyS}",
    "textarea_base_input_placeholder-line-height": "{bodyS}",
    "textarea_base_input_placeholder-letter-spacing": "{bodyS}",
    "textarea_base_input_placeholder-font-weight": "{bodyS}",
    "textarea_base_input_input-color": "{primaryGrey100}",
    "textarea_base_input_input-font-family": "{bodyS}",
    "textarea_base_input_input-font-size": "{bodyS}",
    "textarea_base_input_input-line-height": "{bodyS}",
    "textarea_base_input_input-letter-spacing": "{bodyS}",
    "textarea_base_input_input-font-weight": "{bodyS}",
    "textarea_base_input_resize-color": "{primaryGrey100}",
    "textarea_base_input_cursor-color": "{primaryGrey100}",
    textarea_base_input_width: $e3613f6017c674c5$var$textarea_base_input_width,
    "textarea_base_input_behavior_hover_resize-color": "{primary50}",
    "textarea_base_input_behavior_focus_resize-color": "{primary60}",
    "textarea_base_input_behavior_active_resize-color": "{primary60}",
    "textarea_base_active-line-container_flex-direction": "{flexDirection.column}",
    "textarea_base_active-line-container_width": "{size.max}",
    "textarea_base_active-line-container_align-items": "{alignItems.center}",
    "textarea_base_feedback-container_width": "{size.max}",
    "textarea_base_feedback-container_background-color": "{primaryGrey100}",
    "textarea_base_feedback-container_behavior_hover_background-color": "{primary50}",
    "textarea_base_feedback-container_behavior_focus_background-color": "{primary60}",
    "textarea_base_feedback-container_behavior_active_background-color": "{primary60}",
    textarea_variant_disabled_true_container_opacity: $e3613f6017c674c5$var$textarea_variant_disabled_true_container_opacity,
    textarea_base_container_opacity: $e3613f6017c674c5$var$textarea_base_container_opacity,
    "textarea_variant_border_true-input-container_border-width": "{border_thin}",
    "textarea_variant_border_true-input-container_background-color": "{primaryGrey60}",
    "textarea_variant_border_true-input-container_padding-top": "{custom_17}",
    "textarea_variant_border_true-input-container_border-radius": "{medium}",
    "textarea_variant_border_true-input-container_padding-bottom": "{custom_17}",
    "textarea_variant_border_true-input-container_padding-left": "{base}",
    "textarea_variant_border_true-input-container_padding-right": "{s}",
    "textarea_variant_state_success_feedback-container_background-color": "{feedbackSuccess50}",
    "textarea_variant_state_success_feedback-container_behavior_hover_background-color": "{feedbackSuccess50}",
    "textarea_variant_state_success_feedback-container_behavior_focus_background-color": "{feedbackSuccess50}",
    "textarea_variant_state_success_feedback-container_behavior_active_background-color": "{feedbackSuccess50}",
    "textarea_variant_state_success_input_resize-color": "{feedbackSuccess50}",
    "textarea_variant_state_success_input_behavior_hover_resize-color": "{feedbackSuccess50}",
    "textarea_variant_state_success_input_behavior_focus_resize-color": "{feedbackSuccess50}",
    "textarea_variant_state_success_input_behavior_active_resize-color": "{feedbackSuccess50}",
    "textarea_variant_state_error_feedback-container_background-color": "{feedbackError50}",
    "textarea_variant_state_error_feedback-container_behavior_hover_background-color": "{feedbackError50}",
    "textarea_variant_state_error_feedback-container_behavior_focus_background-color": "{feedbackError50}",
    "textarea_variant_state_error_feedback-container_behavior_active_background-color": "{feedbackError50}",
    "textarea_variant_state_error_input_resize-color": "{feedbackError50}",
    "textarea_variant_state_error_input_behavior_hover_resize-color": "{feedbackError50}",
    "textarea_variant_state_error_input_behavior_focus_resize-color": "{feedbackError50}",
    "textarea_variant_state_error_input_behavior_active_resize-color": "{feedbackError50}",
    "textarea_variant_state_warning_feedback-container_background-color": "{feedbackWarning50}",
    "textarea_variant_state_warning_feedback-container_behavior_hover_background-color": "{feedbackWarning50}",
    "textarea_variant_state_warning_feedback-container_behavior_focus_background-color": "{feedbackWarning50}",
    "textarea_variant_state_warning_feedback-container_behavior_active_background-color": "{feedbackWarning50}",
    "textarea_variant_state_warning_input_resize-color": "{feedbackWarning50}",
    "textarea_variant_state_warning_input_behavior_hover_resize-color": "{feedbackWarning50}",
    "textarea_variant_state_warning_input_behavior_focus_resize-color": "{feedbackWarning50}",
    "textarea_variant_state_warning_input_behavior_active_resize-color": "{feedbackWarning50}",
    "textarea_variant__labelFocus_true_field-container_align-items": "{alignItems.start}",
    "textarea_combination_none_true_feedback-container_background-color": "{primary60}",
    "textarea_combination_none_true_input_resize-color": "{primary60}",
    "textarea_combination_true_true_field-container_border-color": "{primaryGrey40}",
    "textarea_combination_true_true_input_resize-color": "{primaryGrey60}",
    "textarea_combination_true_true_input_input-color": "{primaryGrey80}"
};
const $e3613f6017c674c5$var$LinkTokens = {
    "link_base_container_background-color": "{global.transparent}",
    "link_base_container_flex-direction": "{flexDirection.row}",
    "link_base_container_justify-content": "{justifyContent.center}",
    "link_base_container_align-items": "{alignItems.center}",
    "link_base_container_behavior_focus_border-radius": "{small}",
    "link_base_container_behavior_focus_border-width": "{border_normal}",
    "link_base_container_behavior_focus_border-color": "{primary60}",
    "link_variant_kind_header_container_behavior_focus_border-color": "{primary30}",
    "link_variant_kind_submenu_jds_text_behavior_hover_text-decoration": "{text-decoration.underline}",
    "link_variant_kind_header_jds_text_behavior_hover_text-decoration": "{text-decoration.underline}",
    "link_variant_kind_rich_text_jds_text_text-decoration": "{text-decoration.underline}",
    "link_variant_kind_rich_text_jds_text_behavior_hover_text-decoration": "{text-decoration.none}",
    "link_combination_default_none_jds_text_behavior_hover_text-decoration": "{text-decoration.underline}"
};
const $e3613f6017c674c5$var$menublock_base_container_width = "{intrinsicSize.max}";
const $e3613f6017c674c5$var$MenuBlockTokens = {
    "menublock_base_popup_background-color": "{global.transparent}",
    "menublock_base_popup-container_flex-direction": "{flexDirection.stack}",
    "menublock_base_popup-container_padding-right": "{base}",
    "menublock_base_popup-container_padding-bottom": "{base}",
    "menublock_base_popup-container_width": "{size.max}",
    menublock_base_container_width: $e3613f6017c674c5$var$menublock_base_container_width,
    "menublock_base_container_background-color": "{primaryBackground}",
    "menublock_base_container_flex-direction": "{flexDirection.column}",
    "menublock_base_container_border-radius": "{medium}",
    "menublock_base_popup-container_max-height": "{size.max}"
};
const $e3613f6017c674c5$var$inputfield_base_container_gap = "{xxs}";
const $e3613f6017c674c5$var$inputfield_base_container_width = "{size.max}";
const $e3613f6017c674c5$var$inputfield_base_jds_input_textAlign = "{textAlign.start}";
const $e3613f6017c674c5$var$inputfield_variant_disabled_true_container_opacity = "{opacity.disabled}";
const $e3613f6017c674c5$var$inputfield_base_container_opacity = "{opacity.enabled}";
const $e3613f6017c674c5$var$InputFieldTokens = {
    "inputfield_base_container_flex-direction": "{flexDirection.column}",
    inputfield_base_container_gap: $e3613f6017c674c5$var$inputfield_base_container_gap,
    inputfield_base_container_width: $e3613f6017c674c5$var$inputfield_base_container_width,
    "inputfield_base_container_justify-content": "{justifyContent.start}",
    "inputfield_base_container_align-items": "{alignItems.start}",
    "inputfield_base_field-container_flex-direction": "{flexDirection.stack}",
    "inputfield_base_field-container_width": "{size.max}",
    "inputfield_base_field-container_align-items": "{alignItems.end}",
    "inputfield_base_field-container_justify-content": "{justifyContent.start}",
    "inputfield_base_field-container_padding-bottom": "{xxs}",
    "inputfield_base_input-container_flex-direction": "{flexDirection.row}",
    "inputfield_base_input-container_justify-content": "{justifyContent.start}",
    "inputfield_base_input-container_width": "{size.max}",
    "inputfield_base_input-container_gap": "{xs}",
    "inputfield_base_input-container_align-items": "{alignItems.center}",
    "inputfield_base_prefix-icon_size": "{m}",
    "inputfield_base_prefix-icon_color": "{primaryGrey80}",
    inputfield_base_jds_input_textAlign: $e3613f6017c674c5$var$inputfield_base_jds_input_textAlign,
    "inputfield_base_suffix-icon_size": "{m}",
    "inputfield_base_suffix-icon_color": "{primaryGrey80}",
    "inputfield_base_suffix-icon_behavior_hover_color": "{primary60}",
    "inputfield_base_active-line-container_flex-direction": "{flexDirection.column}",
    "inputfield_base_active-line-container_width": "{size.max}",
    "inputfield_base_active-line-container_align-items": "{alignItems.center}",
    "inputfield_base_feedback-container_width": "{size.max}",
    "inputfield_base_feedback-container_background-color": "{primaryGrey80}",
    "inputfield_base_feedback-container_behavior_hover_background-color": "{primary50}",
    "inputfield_base_feedback-container_behavior_focus_background-color": "{primary60}",
    "inputfield_base_feedback-container_behavior_active_background-color": "{primary60}",
    inputfield_variant_disabled_true_container_opacity: $e3613f6017c674c5$var$inputfield_variant_disabled_true_container_opacity,
    inputfield_base_container_opacity: $e3613f6017c674c5$var$inputfield_base_container_opacity,
    "inputfield_variant_state_success_feedback-container_background-color": "{feedbackSuccess50}",
    "inputfield_variant_state_success_feedback-container_behavior_hover_background-color": "{feedbackSuccess50}",
    "inputfield_variant_state_success_feedback-container_behavior_focus_background-color": "{feedbackSuccess50}",
    "inputfield_variant_state_success_feedback-container_behavior_active_background-color": "{feedbackSuccess50}",
    "inputfield_variant_state_error_feedback-container_background-color": "{feedbackError50}",
    "inputfield_variant_state_error_feedback-container_behavior_hover_background-color": "{feedbackError50}",
    "inputfield_variant_state_error_feedback-container_behavior_focus_background-color": "{feedbackError50}",
    "inputfield_variant_state_error_feedback-container_behavior_active_background-color": "{feedbackError50}",
    "inputfield_variant_state_warning_feedback-container_background-color": "{feedbackWarning50}",
    "inputfield_variant_state_warning_feedback-container_behavior_hover_background-color": "{feedbackWarning50}",
    "inputfield_variant_state_warning_feedback-container_behavior_focus_background-color": "{feedbackWarning50}",
    "inputfield_variant_state_warning_feedback-container_behavior_active_background-color": "{feedbackWarning50}",
    "inputfield_combination_true_true_field-container_align-items": "{alignItems.start}",
    "inputfield_combination_true_false_field-container_align-items": "{alignItems.start}",
    "inputfield_combination_false_true_field-container_align-items": "{alignItems.end}",
    "inputfield_combination_false_true_input_label-jds_text_padding-left": "{l}",
    "inputfield_combination_false_false_field-container_align-items": "{alignItems.end}",
    "inputfield_combination_none_true_feedback-container_background-color": "{primary60}"
};
const $e3613f6017c674c5$var$inputfieldv2_base_container_width = "{size.max}";
const $e3613f6017c674c5$var$inputfieldv2_base_container_opacity = "{opacity.enabled}";
const $e3613f6017c674c5$var$inputfieldv2_base_jds_input_textAlign = "{textAlign.start}";
const $e3613f6017c674c5$var$inputfieldv2_base_jds_input_flex = 1;
const $e3613f6017c674c5$var$inputfieldv2_variant_disabled_true_container_opacity = "{opacity.disabled}";
const $e3613f6017c674c5$var$InputFieldV2Tokens = {
    "inputfieldv2_variant_noPrefix_input-container_padding-left": "{s}",
    "inputfieldv2_base_container_flex-direction": "{flexDirection.column}",
    inputfieldv2_base_container_width: $e3613f6017c674c5$var$inputfieldv2_base_container_width,
    "inputfieldv2_base_container_justify-content": "{justifyContent.start}",
    "inputfieldv2_base_container_align-items": "{alignItems.start}",
    inputfieldv2_base_container_opacity: $e3613f6017c674c5$var$inputfieldv2_base_container_opacity,
    "inputfieldv2_base_label-container_flex-direction": "{flexDirection.row}",
    "inputfieldv2_base_label-container_justify-content": "{justifyContent.start}",
    "inputfieldv2_base_label-container_align-items": "{alignItems.center}",
    "inputfieldv2_base_label-container_gap": "{xxs}",
    "inputfieldv2_base_label-container_padding-left": "{xs}",
    "inputfieldv2_base_label-container_padding-right": "{xs}",
    "inputfieldv2_base_label-container_padding-bottom": "{xxs}",
    "inputfieldv2_base_input-container_flex-direction": "{flexDirection.row}",
    "inputfieldv2_base_input-container_justify-content": "{justifyContent.start}",
    "inputfieldv2_base_input-container_align-items": "{alignItems.center}",
    "inputfieldv2_base_input-container_width": "{size.max}",
    "inputfieldv2_base_input-container_height": "{xl}",
    "inputfieldv2_base_input-container_gap": "{xs}",
    "inputfieldv2_base_input-container_padding-left": "{xs}",
    "inputfieldv2_base_input-container_padding-right": "{xs}",
    "inputfieldv2_base_input-container_padding-top": "{xs}",
    "inputfieldv2_base_input-container_padding-bottom": "{xs}",
    "inputfieldv2_base_input-container_border-width": "{border_thin}",
    "inputfieldv2_base_input-container_border-color": "{primaryGrey60}",
    "inputfieldv2_variant_readOnly_true_input-container_border-color": "{primaryGrey40}",
    "inputfieldv2_base_input-container_border-radius": "{medium}",
    "inputfieldv2_base_input-container_behavior_hover_border-color": "{primary50}",
    "inputfieldv2_base_input-container_behavior_active_border-color": "{primary60}",
    "inputfieldv2_base_input-container_behavior_focus_border-color": "{primary60}",
    inputfieldv2_base_jds_input_textAlign: $e3613f6017c674c5$var$inputfieldv2_base_jds_input_textAlign,
    inputfieldv2_base_jds_input_flex: $e3613f6017c674c5$var$inputfieldv2_base_jds_input_flex,
    "inputfieldv2_base_helper-container_flex-direction": "{flexDirection.column}",
    "inputfieldv2_base_helper-container_justify-content": "{justifyContent.start}",
    "inputfieldv2_base_helper-container_align-items": "{alignItems.start}",
    "inputfieldv2_base_helper-container_gap": "{xxs}",
    "inputfieldv2_base_dynamic-container_gap": "{xxs}",
    "inputfieldv2_base_helper-container_padding-left": "{xs}",
    "inputfieldv2_base_helper-container_padding-right": "{xs}",
    "inputfieldv2_base_helper-container_padding-top": "{xxs}",
    "inputfieldv2_base_dynamic-container_flex-direction": "{flexDirection.row}",
    "inputfieldv2_base_dynamic-container_justify-content": "{justifyContent.start}",
    "inputfieldv2_base_dynamic-container_align-items": "{alignItems.center}",
    "inputfieldv2_base_dynamic-container_padding-left": "{xs}",
    "inputfieldv2_base_dynamic-container_padding-right": "{xs}",
    inputfieldv2_variant_disabled_true_container_opacity: $e3613f6017c674c5$var$inputfieldv2_variant_disabled_true_container_opacity,
    "inputfieldv2_variant_state_success_input-container_border-color": "{feedbackSuccess50}",
    "inputfieldv2_variant_state_success_input-container_behavior_hover_border-color": "{feedbackSuccess50}",
    "inputfieldv2_variant_state_success_input-container_behavior_focus_border-color": "{feedbackSuccess50}",
    "inputfieldv2_variant_state_success_input-container_behavior_active_border-color": "{feedbackSuccess50}",
    "inputfieldv2_variant_state_error_input-container_border-color": "{feedbackError50}",
    "inputfieldv2_variant_state_error_input-container_behavior_hover_border-color": "{feedbackError50}",
    "inputfieldv2_variant_state_error_input-container_behavior_focus_border-color": "{feedbackError50}",
    "inputfieldv2_variant_state_error_input-container_behavior_active_border-color": "{feedbackError50}",
    "inputfieldv2_variant_state_warning_input-container_border-color": "{feedbackWarning50}",
    "inputfieldv2_variant_state_warning_input-container_behavior_hover_border-color": "{feedbackWarning50}",
    "inputfieldv2_variant_state_warning_input-container_behavior_focus_border-color": "{feedbackWarning50}",
    "inputfieldv2_variant_state_warning_input-container_behavior_active_border-color": "{feedbackWarning50}",
    "inputfieldv2_variant_size_small_input-container_height": "{l}",
    "inputfieldv2_variant_size_small_input-container_padding-top": "{xxs}",
    "inputfieldv2_variant_size_small_input-container_padding-bottom": "{xxs}",
    "inputfieldv2_variant_size_large_input-container_height": "{xxl}",
    "inputfieldv2_variant_size_large_input-container_gap": "{s}",
    "inputfieldv2_variant_size_large_input-container_padding-top": "{s}",
    "inputfieldv2_variant_size_large_input-container_padding-bottom": "{s}",
    "inputfieldv2_variant_size_large_helper-container_gap": "{xs}",
    "inputfieldv2_variant_size_large_helper-container_padding-top": "{xs}"
};
const $e3613f6017c674c5$var$menublockitem_base_container_opacity = "{opacity.enabled}";
const $e3613f6017c674c5$var$menublockitem_base_container_width = "{size.max}";
const $e3613f6017c674c5$var$menublockitem_variant_disabled_true_container_opacity = "{opacity.disabled}";
const $e3613f6017c674c5$var$MenuBlockItemTokens = {
    menublockitem_base_container_opacity: $e3613f6017c674c5$var$menublockitem_base_container_opacity,
    "menublockitem_base_container_background-color": "{global.transparent}",
    menublockitem_base_container_width: $e3613f6017c674c5$var$menublockitem_base_container_width,
    "menublockitem_base_entry-container_background-color": "{global.transparent}",
    "menublockitem_base_entry-container_width": "{size.max}",
    "menublockitem_base_entry-container_padding-top": "{xs}",
    "menublockitem_base_entry-container_padding-right": "{base}",
    "menublockitem_base_entry-container_padding-bottom": "{xs}",
    "menublockitem_base_entry-container_padding-left": "{base}",
    "menublockitem_base_entry-container_flex-direction": "{flexDirection.row}",
    "menublockitem_base_entry-container_align-items": "{alignItems.center}",
    "menublockitem_base_entry-container_justify-content": "{justifyContent.spaceBetween}",
    "menublockitem_base_entry-container_border-color": "{global.transparent}",
    "menublockitem_base_entry-container_behavior_hover_background-color": "{primaryGrey20}",
    "menublockitem_base_entry-container_behavior_focus_border-color": "{primary60}",
    "menublockitem_base_entry-container_behavior_focus_border-radius": "{small}",
    "menublockitem_base_divider-container_width": "{size.max}",
    "menublockitem_base_heading-container_padding-top": "{xs}",
    "menublockitem_base_heading-container_padding-right": "{base}",
    "menublockitem_base_heading-container_padding-bottom": "{xs}",
    "menublockitem_base_heading-container_padding-left": "{base}",
    "menublockitem_base_heading-container_width": "{size.max}",
    "menublockitem_base_heading-container_align-items": "{alignItems.center}",
    "menublockitem_base_heading-container_justify-content": "{justifyContent.start}",
    "menublockitem_base_left-container_gap": "{xs}",
    "menublockitem_base_left-container_flex-direction": "{flexDirection.row}",
    "menublockitem_base_left-container_align-items": "{alignItems.center}",
    "menublockitem_variant_selected_true_container_background-color": "{primaryGrey20}",
    menublockitem_variant_disabled_true_container_opacity: $e3613f6017c674c5$var$menublockitem_variant_disabled_true_container_opacity,
    "menublockitem_variant_hasIcon_true_heading-container_padding-left": "{xxl}"
};
const $e3613f6017c674c5$var$ListBlockTokens = {
    "listblock_base_root-container_flex-direction": "{flexDirection.column}",
    "listblock_base_root-container_width": "{size.max}",
    "listblock_base_root-container_justify-content": "{justifyContent.start}",
    "listblock_base_root-container_align-items": "{alignItems.start}",
    "listblock_base_root-container_gap": "{xs}",
    "listblock_base_root-container_padding-top": "{xs}",
    "listblock_base_root-container_padding-bottom": "{xs}",
    "listblock_base_main-container_flex-direction": "{flexDirection.row}",
    "listblock_base_main-container_width": "{size.max}",
    "listblock_base_main-container_gap": "{base}",
    "listblock_base_main-container_justify-content": "{justifyContent.start}",
    "listblock_base_main-container_align-items": "{alignItems.center}",
    "listblock_base_block-container_flex-direction": "{flexDirection.column}",
    "listblock_base_block-container_gap": "{xxs}",
    "listblock_base_block-container_justify-content": "{justifyContent.start}",
    "listblock_base_block-container_align-items": "{alignItems.start}",
    "listblock_base_caption-container_flex-direction": "{flexDirection.row}",
    "listblock_base_caption-container_width": "{size.max}",
    "listblock_base_caption-container_justify-content": "{justifyContent.spaceBetween}",
    "listblock_base_caption-container_align-items": "{alignItems.center}",
    "listblock_base_caption-container_gap": "{s}",
    "listblock_base_inner-caption-container_flex-direction": "{flexDirection.row}",
    "listblock_base_inner-caption-container_justify-content": "{justifyContent.start}",
    "listblock_base_inner-caption-container_align-items": "{alignItems.center}",
    "listblock_base_inner-caption-container_gap": "{s}",
    "listblock_base_title-container_flex-direction": "{flexDirection.row}",
    "listblock_base_title-container_width": "{size.max}",
    "listblock_base_title-container_justify-content": "{justifyContent.spaceBetween}",
    "listblock_base_title-container_align-items": "{alignItems.center}",
    "listblock_base_title-container_gap": "{s}",
    "listblock_base_inner-title-container_flex-direction": "{flexDirection.row}",
    "listblock_base_inner-title-container_justify-content": "{justifyContent.start}",
    "listblock_base_inner-title-container_align-items": "{alignItems.center}",
    "listblock_base_inner-title-container_gap": "{s}",
    "listblock_base_helper-container_flex-direction": "{flexDirection.row}",
    "listblock_base_helper-container_width": "{size.max}",
    "listblock_base_helper-container_justify-content": "{justifyContent.spaceBetween}",
    "listblock_base_helper-container_align-items": "{alignItems.center}",
    "listblock_base_helper-container_gap": "{s}",
    "listblock_base_inner-helper-container_flex-direction": "{flexDirection.row}",
    "listblock_base_inner-helper-container_justify-content": "{justifyContent.start}",
    "listblock_base_inner-helper-container_align-items": "{alignItems.center}",
    "listblock_base_inner-helper-container_gap": "{s}",
    "listblock_variant_spacing_small_main-container_gap": "{s}",
    "listblock_variant_spacing_small_root-container_gap": "{xxs}",
    "listblock_variant_verticalAlignment_top_main-container_align-items": "{alignItems.start}"
};
const $e3613f6017c674c5$var$bottomnavigation_base_container_width = "{size.max}";
const $e3613f6017c674c5$var$bottomnavigation_base_container_gap = "{m}";
const $e3613f6017c674c5$var$bottomnavigation_base_jds_bottom_navigation_item_flex = 1;
const $e3613f6017c674c5$var$BottomNavigationTokens = {
    bottomnavigation_base_container_width: $e3613f6017c674c5$var$bottomnavigation_base_container_width,
    "bottomnavigation_base_container_flex-direction": "{flexDirection.row}",
    "bottomnavigation_base_container_justify-content": "{justifyContent.center}",
    "bottomnavigation_base_container_align-items": "{alignItems.center}",
    "bottomnavigation_base_container_background-color": "{primaryBackground}",
    "bottomnavigation_base_container_padding-left": "{m}",
    "bottomnavigation_base_container_padding-top": "{base}",
    "bottomnavigation_base_container_padding-right": "{m}",
    "bottomnavigation_base_container_padding-bottom": "{base}",
    bottomnavigation_base_container_gap: $e3613f6017c674c5$var$bottomnavigation_base_container_gap,
    "bottomnavigation_base_container_box-shadow_x": 0,
    "bottomnavigation_base_container_box-shadow_y": -1,
    "bottomnavigation_base_container_box-shadow_blur": 0,
    "bottomnavigation_base_container_box-shadow_spread": 0,
    bottomnavigation_base_jds_bottom_navigation_item_flex: $e3613f6017c674c5$var$bottomnavigation_base_jds_bottom_navigation_item_flex,
    "bottomnavigation_base_container_box-shadow_color": "{primaryGrey40}"
};
const $e3613f6017c674c5$var$ModalDesktopTokens = {
    "modaldesktop_base_popup-container_flex-direction": "{flexDirection.stack}",
    "modaldesktop_base_popup-container_opacity": "{opacity.invisible}",
    "modaldesktop_variant_close_false_popup-container_opacity": "{opacity.enabled}",
    "modaldesktop_base_popup-container_justify-content": "{justifyContent.center}",
    "modaldesktop_base_popup-container_align-items": "{alignItems.center}",
    "modaldesktop_base_popup-container_size": "{size.max}",
    "modaldesktop_base_overlay-container_size": "{size.max}",
    "modaldesktop_base_overlay-container_background-color": "{global.black}",
    "modaldesktop_base_overlay-container_opacity": "{custom_2}",
    "modaldesktop_base_root-container_flex-direction": "{flexDirection.column}",
    "modaldesktop_base_root-container_justify-content": "{justifyContent.start}",
    "modaldesktop_base_root-container_align-items": "{alignItems.start}",
    "modaldesktop_base_root-container_border-radius": "{xxl}",
    "modaldesktop_base_root-container_background-color": "{primaryBackground}",
    "modaldesktop_base_root-container_max-height": "{size.max}",
    "modaldesktop_base_cancel-container_flex-direction": "{flexDirection.row}",
    "modaldesktop_base_cancel-container_justify-content": "{justifyContent.end}",
    "modaldesktop_base_cancel-container_align-items": "{alignItems.center}",
    "modaldesktop_base_cancel-container_width": "{size.max}",
    "modaldesktop_base_cancel-container_padding-top": "{s}",
    "modaldesktop_base_cancel-container_padding-bottom": "{s}",
    "modaldesktop_base_cancel-container_padding-left": "{s}",
    "modaldesktop_base_cancel-container_padding-right": "{s}",
    "modaldesktop_base_vertical-container_flex-direction": "{flexDirection.column}",
    "modaldesktop_base_vertical-container_justify-content": "{justifyContent.start}",
    "modaldesktop_base_vertical-container_align-items": "{alignItems.start}",
    "modaldesktop_base_vertical-container_padding-left": "{l}",
    "modaldesktop_base_vertical-container_padding-right": "{l}",
    "modaldesktop_base_vertical-container_padding-bottom": "{l}",
    "modaldesktop_base_vertical-container_width": "{size.max}",
    "modaldesktop_base_vertical-container_overflow": "auto",
    "modaldesktop_base_custom-container_overflow": "auto",
    "modaldesktop_base_header-container_flex-direction": "{flexDirection.row}",
    "modaldesktop_base_header-container_justify-content": "{justifyContent.start}",
    "modaldesktop_base_header-container_align-items": "{alignItems.center}",
    "modaldesktop_base_header-container_width": "{size.max}",
    "modaldesktop_base_header-container_padding-bottom": "{base}",
    "modaldesktop_base_children-container_width": "{size.max}",
    "modaldesktop_base_children-container_overflow": "auto",
    "modaldesktop_base_button-container_width": "{size.max}",
    "modaldesktop_base_button-container_justify-content": "{justifyContent.end}",
    "modaldesktop_base_button-container_align-items": "{alignItems.start}",
    "modaldesktop_base_button-container_flex-direction": "{flexDirection.row}",
    "modaldesktop_base_button-container_gap": "{s}",
    "modaldesktop_base_button-container_padding-top": "{base}",
    "modaldesktop_base_custom-container_flex-direction": "{flexDirection.column}",
    "modaldesktop_base_custom-container_justify-content": "{justifyContent.start}",
    "modaldesktop_base_custom-container_align-items": "{alignItems.start}",
    "modaldesktop_base_custom-container_border-radius": "{xxl}",
    "modaldesktop_base_custom-container_background-color": "{primaryBackground}",
    "modaldesktop_base_custom-container_padding-left": "{l}",
    "modaldesktop_base_custom-container_padding-right": "{l}",
    "modaldesktop_base_custom-container_padding-top": "{l}",
    "modaldesktop_base_custom-container_padding-bottom": "{l}",
    "modaldesktop_base_custom-container_width": "{size.max}",
    "modaldesktop_base_custom-container_max-height": "{size.max}",
    "modaldesktop_variant_headerAlignment_right_header-container_justify-content": "{justifyContent.end}",
    "modaldesktop_variant_headerAlignment_center_header-container_justify-content": "{justifyContent.center}",
    "modaldesktop_variant_size_small_vertical-container_padding-left": "{m}",
    "modaldesktop_variant_size_small_vertical-container_padding-right": "{m}",
    "modaldesktop_variant_size_small_vertical-container_padding-bottom": "{m}",
    "modaldesktop_combination_dialog_false_vertical-container_padding-top": "{l}",
    "modaldesktop_combination_acknowledgement_false_vertical-container_padding-top": "{l}"
};
const $e3613f6017c674c5$var$modaldesktopinternal_base_container_size = "{size.max}";
const $e3613f6017c674c5$var$ModalDesktopInternalTokens = {
    "modaldesktopinternal_base_container_flex-direction": "{flexDirection.stack}",
    "modaldesktopinternal_base_container_justify-content": "{justifyContent.center}",
    "modaldesktopinternal_base_container_align-items": "{alignItems.center}",
    modaldesktopinternal_base_container_size: $e3613f6017c674c5$var$modaldesktopinternal_base_container_size,
    "modaldesktopinternal_base_popup-container_opacity": "{opacity.invisible}",
    "modaldesktopinternal_base_popup-container_transition_duration": "{medium}",
    "modaldesktopinternal_base_popup-container_transition_timing-function": "{easeEntrance}",
    "modaldesktopinternal_base_overlay-container_size": "{size.max}",
    "modaldesktopinternal_base_overlay-container_background-color": "{global.black}",
    "modaldesktopinternal_base_overlay-container_opacity": "{custom_2}",
    "modaldesktopinternal_base_root-container_flex-direction": "{flexDirection.column}",
    "modaldesktopinternal_base_root-container_justify-content": "{justifyContent.start}",
    "modaldesktopinternal_base_root-container_align-items": "{alignItems.start}",
    "modaldesktopinternal_base_root-container_border-radius": "{xxl}",
    "modaldesktopinternal_base_root-container_background-color": "{elevation1}",
    "modaldesktopinternal_base_root-container_width": "{custom_27}",
    "modaldesktopinternal_base_root-container_max-height": "{size.max}",
    "modaldesktopinternal_base_cancel-container_flex-direction": "{flexDirection.row}",
    "modaldesktopinternal_base_cancel-container_justify-content": "{justifyContent.end}",
    "modaldesktopinternal_base_cancel-container_align-items": "{alignItems.center}",
    "modaldesktopinternal_base_cancel-container_width": "{size.max}",
    "modaldesktopinternal_base_cancel-container_padding-top": "{s}",
    "modaldesktopinternal_base_cancel-container_padding-bottom": "{s}",
    "modaldesktopinternal_base_cancel-container_padding-left": "{s}",
    "modaldesktopinternal_base_cancel-container_padding-right": "{s}",
    "modaldesktopinternal_base_vertical-container_flex-direction": "{flexDirection.column}",
    "modaldesktopinternal_base_vertical-container_justify-content": "{justifyContent.start}",
    "modaldesktopinternal_base_vertical-container_align-items": "{alignItems.start}",
    "modaldesktopinternal_base_vertical-container_padding-left": "{l}",
    "modaldesktopinternal_base_vertical-container_padding-right": "{l}",
    "modaldesktopinternal_base_vertical-container_padding-bottom": "{l}",
    "modaldesktopinternal_base_vertical-container_width": "{size.max}",
    "modaldesktopinternal_base_vertical-container_overflow": "auto",
    "modaldesktopinternal_base_custom-container_overflow": "auto",
    "modaldesktopinternal_base_header-container_flex-direction": "{flexDirection.row}",
    "modaldesktopinternal_base_header-container_justify-content": "{justifyContent.start}",
    "modaldesktopinternal_base_header-container_align-items": "{alignItems.center}",
    "modaldesktopinternal_base_header-container_width": "{size.max}",
    "modaldesktopinternal_base_header-container_padding-bottom": "{base}",
    "modaldesktopinternal_base_children-container_width": "{size.max}",
    "modaldesktopinternal_base_children-container_overflow": "auto",
    "modaldesktopinternal_base_button-container_width": "{size.max}",
    "modaldesktopinternal_base_button-container_justify-content": "{justifyContent.end}",
    "modaldesktopinternal_base_button-container_align-items": "{alignItems.start}",
    "modaldesktopinternal_base_button-container_flex-direction": "{flexDirection.row}",
    "modaldesktopinternal_base_button-container_gap": "{s}",
    "modaldesktopinternal_base_button-container_padding-top": "{base}",
    "modaldesktopinternal_base_custom-container_flex-direction": "{flexDirection.column}",
    "modaldesktopinternal_base_custom-container_justify-content": "{justifyContent.start}",
    "modaldesktopinternal_base_custom-container_align-items": "{alignItems.start}",
    "modaldesktopinternal_base_custom-container_border-radius": "{xxl}",
    "modaldesktopinternal_base_custom-container_background-color": "{primaryBackground}",
    "modaldesktopinternal_base_custom-container_padding-left": "{l}",
    "modaldesktopinternal_base_custom-container_padding-right": "{l}",
    "modaldesktopinternal_base_custom-container_padding-top": "{l}",
    "modaldesktopinternal_base_custom-container_padding-bottom": "{l}",
    "modaldesktopinternal_base_custom-container_max-width": "80%",
    "modaldesktopinternal_base_custom-container_max-height": "80%",
    "modaldesktopinternal_variant_headerAlignment_right_header-container_justify-content": "{justifyContent.end}",
    "modaldesktopinternal_variant_headerAlignment_center_header-container_justify-content": "{justifyContent.center}",
    "modaldesktopinternal_variant_size_small_vertical-container_padding-left": "{m}",
    "modaldesktopinternal_variant_size_small_vertical-container_padding-right": "{m}",
    "modaldesktopinternal_variant_size_small_vertical-container_padding-bottom": "{m}",
    "modaldesktopinternal_combination_dialog_false_vertical-container_padding-top": "{l}",
    "modaldesktopinternal_combination_acknowledgement_false_vertical-container_padding-top": "{l}",
    "modaldesktopinternal_variant_close_false_popup-container_opacity": "{opacity.enabled}",
    "modaldesktopinternal_variant_close_false_popup-container_transition_timing-function": "{easeExit}",
    "modaldesktopinternal_combination_medium_desktop_root-container_width": "{custom_27}",
    "modaldesktopinternal_combination_medium_tablet_root-container_width": "{modal_desktop_comibation_medium_width}",
    "modaldesktopinternal_combination_small_desktop_root-container_width": "{modal_desktop_combination_small_width}",
    "modaldesktopinternal_combination_small_tablet_root-container_width": "{modal_desktop_combination_small_width}"
};
const $e3613f6017c674c5$var$bottomnavigationitem_base_container_width = "{size.max}";
const $e3613f6017c674c5$var$bottomnavigationitem_base_container_gap = "{xxs}";
const $e3613f6017c674c5$var$bottomnavigationitem_variant_disabled_true_container_opacity = "{opacity.disabled}";
const $e3613f6017c674c5$var$bottomnavigationitem_variant_enabled_true_container_opacity = "{opacity.enabled}";
const $e3613f6017c674c5$var$BottomNavigationItemTokens = {
    bottomnavigationitem_base_container_width: $e3613f6017c674c5$var$bottomnavigationitem_base_container_width,
    "bottomnavigationitem_base_container_flex-direction": "{flexDirection.column}",
    "bottomnavigationitem_base_container_justify-content": "{justifyContent.center}",
    "bottomnavigationitem_base_container_align-items": "{alignItems.center}",
    bottomnavigationitem_base_container_gap: $e3613f6017c674c5$var$bottomnavigationitem_base_container_gap,
    bottomnavigationitem_variant_disabled_true_container_opacity: $e3613f6017c674c5$var$bottomnavigationitem_variant_disabled_true_container_opacity,
    bottomnavigationitem_variant_enabled_true_container_opacity: $e3613f6017c674c5$var$bottomnavigationitem_variant_enabled_true_container_opacity
};
const $e3613f6017c674c5$var$ModalMobileTokens = {
    "modalmobile_base_popup-container_flex-direction": "{flexDirection.stack}",
    "modalmobile_base_popup-container_justify-content": "{justifyContent.center}",
    "modalmobile_base_popup-container_align-items": "{alignItems.center}",
    "modalmobile_base_popup-container_size": "{size.max}",
    "modalmobile_base_popup-container_opacity": "{opacity.invisible}",
    "modalmobile_base_popup-container_transition_duration": "{medium}",
    "modalmobile_base_popup-container_transition_timing-function": "{easeEntrance}",
    "modalmobile_variant_close_false_popup-container_opacity": "{opacity.enabled}",
    "modalmobile_variant_close_false_popup-container_transition_timing-function": "{easeExit}"
};
const $e3613f6017c674c5$var$modalmobileinternal_base_container_size = "{size.max}";
const $e3613f6017c674c5$var$ModalMobileInternalTokens = {
    "modalmobileinternal_base_container_flex-direction": "{flexDirection.stack}",
    "modalmobileinternal_base_container_justify-content": "{justifyContent.center}",
    "modalmobileinternal_base_container_align-items": "{alignItems.center}",
    modalmobileinternal_base_container_size: $e3613f6017c674c5$var$modalmobileinternal_base_container_size,
    "modalmobileinternal_base_overlay-container_size": "{size.max}",
    "modalmobileinternal_base_overlay-container_background-color": "{global.black}",
    "modalmobileinternal_base_overlay-container_opacity": "{custom_2}",
    "modalmobileinternal_base_root-container_flex-direction": "{flexDirection.column}",
    "modalmobileinternal_base_root-container_justify-content": "{justifyContent.start}",
    "modalmobileinternal_base_root-container_align-items": "{alignItems.start}",
    "modalmobileinternal_base_root-container_border-radius": "{xl}",
    "modalmobileinternal_base_root-container_width": "{size.max}",
    "modalmobileinternal_base_root-container_max-height": "{custom_31}",
    "modalmobileinternal_base_root-container_background-color": "{elevation1}",
    "modalmobileinternal_base_outer-container_flex-direction": "{flexDirection.row}",
    "modalmobileinternal_base_outer-container_justify-content": "{justifyContent.center}",
    "modalmobileinternal_base_outer-container_align-items": "{alignItems.center}",
    "modalmobileinternal_base_outer-container_border-radius": "{xl}",
    "modalmobileinternal_base_outer-container_width": "{size.max}",
    "modalmobileinternal_base_outer-container_max-height": "{size.max}",
    "modalmobileinternal_base_outer-container_padding-top": "{m}",
    "modalmobileinternal_base_outer-container_padding-bottom": "{m}",
    "modalmobileinternal_base_outer-container_padding-left": "{m}",
    "modalmobileinternal_base_outer-container_padding-right": "{m}",
    "modalmobileinternal_base_cancel-container_flex-direction": "{flexDirection.row}",
    "modalmobileinternal_base_cancel-container_justify-content": "{justifyContent.end}",
    "modalmobileinternal_base_cancel-container_align-items": "{alignItems.center}",
    "modalmobileinternal_base_cancel-container_width": "{size.max}",
    "modalmobileinternal_base_cancel-container_padding-top": "{s}",
    "modalmobileinternal_base_cancel-container_padding-bottom": "{s}",
    "modalmobileinternal_base_cancel-container_padding-left": "{s}",
    "modalmobileinternal_base_cancel-container_padding-right": "{s}",
    "modalmobileinternal_base_vertical-container_flex-direction": "{flexDirection.column}",
    "modalmobileinternal_base_vertical-container_justify-content": "{justifyContent.start}",
    "modalmobileinternal_base_vertical-container_align-items": "{alignItems.start}",
    "modalmobileinternal_base_vertical-container_width": "{size.max}",
    "modalmobileinternal_base_vertical-container_padding-left": "{l}",
    "modalmobileinternal_base_vertical-container_padding-right": "{l}",
    "modalmobileinternal_base_vertical-container_padding-bottom": "{l}",
    "modalmobileinternal_base_vertical-container_overflow": "auto",
    "modalmobileinternal_base_header-container_flex-direction": "{flexDirection.row}",
    "modalmobileinternal_base_header-container_justify-content": "{justifyContent.start}",
    "modalmobileinternal_base_header-container_align-items": "{alignItems.center}",
    "modalmobileinternal_base_header-container_width": "{size.max}",
    "modalmobileinternal_base_header-container_padding-bottom": "{base}",
    "modalmobileinternal_base_children-container_align-items": "{alignItems.start}",
    "modalmobileinternal_base_children-container_width": "{size.max}",
    "modalmobileinternal_base_children-container_overflow": "auto",
    "modalmobileinternal_base_children-container_flex-direction": "{flexDirection.column}",
    "modalmobileinternal_base_button-container_width": "{size.max}",
    "modalmobileinternal_base_button-container_justify-content": "{justifyContent.start}",
    "modalmobileinternal_base_button-container_align-items": "{alignItems.start}",
    "modalmobileinternal_base_button-container_flex-direction": "{flexDirection.column}",
    "modalmobileinternal_base_button-container_gap": "{s}",
    "modalmobileinternal_base_button-container_padding-top": "{base}",
    "modalmobileinternal_base_custom-container_flex-direction": "{flexDirection.column}",
    "modalmobileinternal_base_custom-container_justify-content": "{justifyContent.start}",
    "modalmobileinternal_base_custom-container_align-items": "{alignItems.start}",
    "modalmobileinternal_base_custom-container_border-radius": "{xl}",
    "modalmobileinternal_base_custom-container_background-color": "{elevation1}",
    "modalmobileinternal_base_custom-container_padding-left": "{l}",
    "modalmobileinternal_base_custom-container_padding-right": "{l}",
    "modalmobileinternal_base_custom-container_padding-top": "{l}",
    "modalmobileinternal_base_custom-container_padding-bottom": "{l}",
    "modalmobileinternal_base_custom-container_width": "{size.max}",
    "modalmobileinternal_variant_headerAlignment_right_header-container_justify-content": "{justifyContent.end}",
    "modalmobileinternal_variant_headerAlignment_center_header-container_justify-content": "{justifyContent.center}",
    "modalmobileinternal_variant_size_small_vertical-container_padding-left": "{m}",
    "modalmobileinternal_variant_size_small_vertical-container_padding-right": "{m}",
    "modalmobileinternal_variant_size_small_vertical-container_padding-bottom": "{m}",
    "modalmobileinternal_combination_dialog_false_vertical-container_padding-top": "{l}",
    "modalmobileinternal_combination_acknowledgement_false_vertical-container_padding-top": "{l}",
    "modalmobileinternal_variant_close_false_popup-container_opacity": "{opacity.enabled}",
    "modalmobileinternal_variant_close_false_popup-container_transition_timing-function": "{easeExit}"
};
const $e3613f6017c674c5$var$headermobile_variant_fullWidth_false_container_width = "{intrinsicSize.max}";
const $e3613f6017c674c5$var$HeaderMobileTokens = {
    "headermobile_base_container_min-width": "{size.max}",
    "headermobile_base_container_flex-direction": "{flexDirection.column}",
    "headermobile_base_header-container_min-width": "{size.max}",
    "headermobile_base_header-container_width": "{size.max}",
    "headermobile_base_header-container_background-color": "{primary50}",
    "headermobile_base_header-container_flex-direction": "{flexDirection.row}",
    "headermobile_base_header-container_justify-content": "{justifyContent.spaceBetween}",
    "headermobile_base_header-container_align-items": "{alignItems.center}",
    "headermobile_base_header-container_padding-left": "{s}",
    "headermobile_base_header-container_padding-top": "{xs}",
    "headermobile_base_header-container_padding-right": "{s}",
    "headermobile_base_header-container_padding-bottom": "{xs}",
    "headermobile_base_header-container_gap": "{base}",
    "headermobile_base_header-container_height": "{huge}",
    "headermobile_base_left-container_flex-direction": "{flexDirection.row}",
    "headermobile_base_left-container_justify-content": "{justifyContent.start}",
    "headermobile_base_left-container_align-items": "{alignItems.center}",
    "headermobile_base_left-container_gap": "{base}",
    "headermobile_base_prefix-container_flex-direction": "{flexDirection.row}",
    "headermobile_base_prefix-container_justify-content": "{justifyContent.start}",
    "headermobile_base_prefix-container_align-items": "{alignItems.center}",
    "headermobile_base_prefix-container_gap": "{xs}",
    "headermobile_base_logo-container_flex-direction": "{flexDirection.row}",
    "headermobile_base_logo-container_justify-content": "{justifyContent.center}",
    "headermobile_base_logo-container_align-items": "{alignItems.center}",
    "headermobile_base_logo-container_gap": "{xs}",
    "headermobile_base_links-container_flex-direction": "{flexDirection.row}",
    "headermobile_base_links-container_justify-content": "{justifyContent.start}",
    "headermobile_base_links-container_align-items": "{alignItems.center}",
    "headermobile_base_links-container_gap": "{l}",
    "headermobile_base_links-container_padding-left": "{huge}",
    "headermobile_base_right-container_flex-direction": "{flexDirection.row}",
    "headermobile_base_right-container_justify-content": "{justifyContent.end}",
    "headermobile_base_right-container_align-items": "{alignItems.center}",
    "headermobile_base_right-container_gap": "{s}",
    "headermobile_base_suffix-container_flex-direction": "{flexDirection.row}",
    "headermobile_base_suffix-container_justify-content": "{justifyContent.end}",
    "headermobile_base_suffix-container_align-items": "{alignItems.center}",
    "headermobile_base_suffix-container_gap": "{s}",
    "headermobile_base_icon-links-container_flex-direction": "{flexDirection.row}",
    "headermobile_base_icon-links-container_justify-content": "{justifyContent.center}",
    "headermobile_base_icon-links-container_align-items": "{alignItems.center}",
    "headermobile_base_icon-links-container_gap": "{s}",
    "headermobile_variant__platform_mobile_header-container_padding-left": "{s}",
    "headermobile_variant__platform_mobile_header-container_padding-right": "{s}",
    "headermobile_variant__platform_mobile_header-container_gap": "{xxs}",
    "headermobile_variant__platform_mobile_left-container_gap": "{xs}",
    "headermobile_variant__platform_mobile_right-container_gap": "{xs}",
    "headermobile_variant__platform_mobile_suffix-container_gap": "{xs}",
    headermobile_variant_fullWidth_false_container_width: $e3613f6017c674c5$var$headermobile_variant_fullWidth_false_container_width,
    "headermobile_variant__platform_mobile__isPrefixButtonMissing_true_header-container_padding-left": "{m}"
};
const $e3613f6017c674c5$var$megamenu_base_container_width = "{size.max}";
const $e3613f6017c674c5$var$megamenu_base_container_gap = "{base}";
const $e3613f6017c674c5$var$MegaMenuTokens = {
    "megamenu_base_popup-container_flex-direction": "{flexDirection.row}",
    megamenu_base_container_width: $e3613f6017c674c5$var$megamenu_base_container_width,
    "megamenu_base_container_flex-direction": "{flexDirection.row}",
    "megamenu_base_container_justify-content": "{justifyContent.start}",
    "megamenu_base_container_align-items": "{alignItems.start}",
    "megamenu_base_container_background-color": "{primaryBackground}",
    "megamenu_base_container_padding-top": "{m}",
    "megamenu_base_container_padding-bottom": "{m}",
    "megamenu_base_container_padding-right": "{xxl}",
    "megamenu_base_container_padding-left": "{xxl}",
    megamenu_base_container_gap: $e3613f6017c674c5$var$megamenu_base_container_gap
};
const $e3613f6017c674c5$var$megamenublock_base_container_gap = "{base}";
const $e3613f6017c674c5$var$MegaMenuBlockTokens = {
    "megamenublock_base_container_flex-direction": "{flexDirection.column}",
    "megamenublock_base_container_justify-content": "{justifyContent.start}",
    "megamenublock_base_container_align-items": "{alignItems.start}",
    megamenublock_base_container_gap: $e3613f6017c674c5$var$megamenublock_base_container_gap,
    "megamenublock_base_links-container_flex-direction": "{flexDirection.column}",
    "megamenublock_base_links-container_justify-content": "{justifyContent.start}",
    "megamenublock_base_links-container_align-items": "{alignItems.start}",
    "megamenublock_base_heading-jds_text_padding-top": "{xs}"
};
const $e3613f6017c674c5$var$headerdesktop_base_header_container_height = "{custom_16}";
const $e3613f6017c674c5$var$headerdesktop_base_jds_search_box_width = "{size.max}";
const $e3613f6017c674c5$var$headerdesktop_variant__platform_mobile_header_container_height = "{huge}";
const $e3613f6017c674c5$var$headerdesktop_variant_variant_active_search_jds_search_box_width = "{size.max}";
const $e3613f6017c674c5$var$headerdesktop_variant_fullWidth_false_container_width = "{intrinsicSize.max}";
const $e3613f6017c674c5$var$HeaderDesktopTokens = {
    "headerdesktop_base_container_min-width": "{size.max}",
    "headerdesktop_base_container_flex-direction": "{flexDirection.column}",
    "headerdesktop_base_prefix-container_flex-direction": "{flexDirection.row}",
    "headerdesktop_base_prefix-container_justify-content": "{justifyContent.start}",
    "headerdesktop_base_prefix-container_align-items": "{alignItems.center}",
    "headerdesktop_base_prefix-container_gap": "{xs}",
    "headerdesktop_base_header-container_min-width": "{size.max}",
    "headerdesktop_base_header-container_background-color": "{primary50}",
    "headerdesktop_base_header-container_flex-direction": "{flexDirection.row}",
    "headerdesktop_base_header-container_justify-content": "{justifyContent.spaceBetween}",
    "headerdesktop_base_header-container_align-items": "{alignItems.center}",
    "headerdesktop_base_header-container_padding-left": "{xxl}",
    "headerdesktop_base_header-container_padding-top": "{s}",
    "headerdesktop_base_header-container_padding-right": "{xxl}",
    "headerdesktop_base_header-container_padding-bottom": "{s}",
    "headerdesktop_base_header-container_gap": "{base}",
    headerdesktop_base_header_container_height: $e3613f6017c674c5$var$headerdesktop_base_header_container_height,
    "headerdesktop_base_left-container_flex-direction": "{flexDirection.row}",
    "headerdesktop_base_left-container_justify-content": "{justifyContent.start}",
    "headerdesktop_base_left-container_align-items": "{alignItems.center}",
    "headerdesktop_base_left-container_gap": "{base}",
    "headerdesktop_base_logo-container_flex-direction": "{flexDirection.row}",
    "headerdesktop_base_logo-container_justify-content": "{justifyContent.center}",
    "headerdesktop_base_logo-container_align-items": "{alignItems.center}",
    "headerdesktop_base_logo-container_gap": "{xs}",
    "headerdesktop_base_profile-container_flex-direction": "{flexDirection.row}",
    "headerdesktop_base_profile-container_justify-content": "{justifyContent.center}",
    "headerdesktop_base_profile-container_align-items": "{alignItems.center}",
    "headerdesktop_base_profile-container_gap": "{xs}",
    "headerdesktop_base_links-container_flex-direction": "{flexDirection.row}",
    "headerdesktop_base_links-container_justify-content": "{justifyContent.start}",
    "headerdesktop_base_links-container_align-items": "{alignItems.center}",
    "headerdesktop_base_links-container_gap": "{l}",
    "headerdesktop_base_links-container_padding-left": "{huge}",
    "headerdesktop_base_right-container_flex-direction": "{flexDirection.row}",
    "headerdesktop_base_right-container_justify-content": "{justifyContent.end}",
    "headerdesktop_base_right-container_align-items": "{alignItems.center}",
    "headerdesktop_base_right-container_gap": "{s}",
    "headerdesktop_base_suffix-container_flex-direction": "{flexDirection.row}",
    "headerdesktop_base_suffix-container_justify-content": "{justifyContent.end}",
    "headerdesktop_base_suffix-container_align-items": "{alignItems.center}",
    "headerdesktop_base_suffix-container_gap": "{s}",
    "headerdesktop_base_suffix-container_width": "{size.max}",
    "headerdesktop_base_icon-links-container_flex-direction": "{flexDirection.row}",
    "headerdesktop_base_icon-links-container_justify-content": "{justifyContent.center}",
    "headerdesktop_base_icon-links-container_align-items": "{alignItems.center}",
    "headerdesktop_base_icon-links-container_gap": "{s}",
    headerdesktop_base_jds_search_box_width: $e3613f6017c674c5$var$headerdesktop_base_jds_search_box_width,
    headerdesktop_variant__platform_mobile_header_container_height: $e3613f6017c674c5$var$headerdesktop_variant__platform_mobile_header_container_height,
    "headerdesktop_variant__platform_mobile_header-container_padding-left": "{s}",
    "headerdesktop_variant__platform_mobile_header-container_padding-right": "{s}",
    "headerdesktop_variant__platform_mobile_header-container_gap": "{s}",
    "headerdesktop_variant__platform_mobile_left-container_gap": "{xs}",
    "headerdesktop_variant__platform_mobile_right-container_gap": "{xs}",
    "headerdesktop_variant__platform_mobile_suffix-container_gap": "{xs}",
    "headerdesktop_variant_variant_default_left-container_width": "{size.max}",
    "headerdesktop_variant_variant_active_search_header-container_justify-content": "{justifyContent.spaceBetween}",
    headerdesktop_variant_variant_active_search_jds_search_box_width: $e3613f6017c674c5$var$headerdesktop_variant_variant_active_search_jds_search_box_width,
    headerdesktop_variant_fullWidth_false_container_width: $e3613f6017c674c5$var$headerdesktop_variant_fullWidth_false_container_width,
    "headerdesktop_combinaton_mobile_false_header-container_justify-content": "{justifyContent.spaceBetween}"
};
const $e3613f6017c674c5$var$sidepanel_base_container_height = "{size.max}";
const $e3613f6017c674c5$var$sidepanel_combination_true_desktop_container_width = "{size.max}";
const $e3613f6017c674c5$var$sidepanel_combination_true_mobile_container_width = "{size.max}";
const $e3613f6017c674c5$var$sidepanel_combination_false_mobile_container_width = 376;
const $e3613f6017c674c5$var$SidePanelTokens = {
    "sidepanel_base_popup-container_height": "{size.max}",
    "sidepanel_base_popup-container_width": "{size.max}",
    "sidepanel_base_popup-container_flex-direction": "{flexDirection.row}",
    "sidepanel_base_popup-container_justify-content": "{justifyContent.start}",
    "sidepanel_base_popup-container_align-items": "{alignItems.center}",
    sidepanel_base_container_height: $e3613f6017c674c5$var$sidepanel_base_container_height,
    "sidepanel_base_container_flex-direction": "{flexDirection.column}",
    "sidepanel_base_container_background-color": "{primaryBackground}",
    "sidepanel_base_section-container_height": "{size.max}",
    "sidepanel_base_section-container_width": "{size.max}",
    "sidepanel_base_section-container_flex-direction": "{flexDirection.column}",
    "sidepanel_base_section-container_justify-content": "{justifyContent.start}",
    "sidepanel_base_section-container_align-items": "{alignItems.center}",
    "sidepanel_base_section-container_padding-left": "{m}",
    "sidepanel_base_section-container_padding-top": "{m}",
    "sidepanel_base_section-container_padding-right": "{m}",
    "sidepanel_base_header-container_background-color": "{primary50}",
    "sidepanel_base_header-container_padding-top": "{s}",
    "sidepanel_base_header-container_padding-bottom": "{s}",
    "sidepanel_base_header-container_padding-right": "{m}",
    "sidepanel_base_header-container_padding-left": "{m}",
    "sidepanel_base_header-container_width": "{size.max}",
    "sidepanel_base_header-container_justify-content": "{justifyContent.spaceBetween}",
    "sidepanel_base_header-container_align-items": "{alignItems.center}",
    "sidepanel_base_left-container_flex-direction": "{flexDirection.row}",
    "sidepanel_base_left-container_gap": "{s}",
    "sidepanel_base_left-container_align-items": "{alignItems.center}",
    "sidepanel_variant_direction_right_popup-container_justify-content": "{justifyContent.end}",
    sidepanel_combination_true_desktop_container_width: $e3613f6017c674c5$var$sidepanel_combination_true_desktop_container_width,
    sidepanel_combination_true_mobile_container_width: $e3613f6017c674c5$var$sidepanel_combination_true_mobile_container_width,
    sidepanel_combination_false_mobile_container_width: $e3613f6017c674c5$var$sidepanel_combination_false_mobile_container_width
};
const $e3613f6017c674c5$var$MegaMenuItemTokens = {
    "megamenuitem_base_container_flex-direction": "{flexDirection.row}",
    "megamenuitem_base_container_justify-content": "{justifyContent.start}",
    "megamenuitem_base_container_align-items": "{alignItems.start}",
    "megamenuitem_base_container_padding-top": "{xs}",
    "megamenuitem_base_container_padding-bottom": "{xs}"
};
const $e3613f6017c674c5$var$sidepanelitem_base_container_width = "{size.max}";
const $e3613f6017c674c5$var$SidePanelItemTokens = {
    "sidepanelitem_base_heading-jds_text_padding-top": "{xl}",
    "sidepanelitem_base_heading-jds_text_padding-bottom": "{xs}",
    "sidepanelitem_base_container_flex-direction": "{flexDirection.row}",
    "sidepanelitem_base_container_justify-content": "{justifyContent.spaceBetween}",
    "sidepanelitem_base_container_align-items": "{alignItems.center}",
    sidepanelitem_base_container_width: $e3613f6017c674c5$var$sidepanelitem_base_container_width,
    "sidepanelitem_base_inner-container_flex-direction": "{flexDirection.row}",
    "sidepanelitem_base_inner-container_justify-content": "{justifyContent.start}",
    "sidepanelitem_base_inner-container_align-items": "{alignItems.center}",
    "sidepanelitem_base_inner-container_gap": "{base}",
    "sidepanelitem_base_inner-container_padding-top": "{s}",
    "sidepanelitem_base_inner-container_padding-bottom": "{s}"
};
const $e3613f6017c674c5$var$NotificationBannerTokens = {
    "notificationbanner_base_root-container_min-height": "{custom_11}",
    "notificationbanner_base_root-container_width": "{size.max}",
    "notificationbanner_base_root-container_flex-direction": "{flexDirection.column}",
    "notificationbanner_base_root-container_justify-content": "{justifyContent.center}",
    "notificationbanner_base_root-container_align-items": "{alignItems.center}",
    "notificationbanner_base_root-container_padding-top": "{base}",
    "notificationbanner_base_root-container_padding-right": "{base}",
    "notificationbanner_base_root-container_padding-bottom": "{base}",
    "notificationbanner_base_root-container_padding-left": "{base}",
    "notificationbanner_base_root-container_gap": "{base}",
    "notificationbanner_base_root-container_border-radius": "{large}",
    "notificationbanner_base_root-container_background-color": "{primaryGrey20}",
    "notificationbanner_base_main-container_flex-direction": "{flexDirection.row}",
    "notificationbanner_base_main-container_justify-content": "{justifyContent.start}",
    "notificationbanner_base_main-container_align-items": "{alignItems.start}",
    "notificationbanner_base_main-container_width": "{size.max}",
    "notificationbanner_base_main-container_gap": "{s}",
    "notificationbanner_base_text-container_justify-content": "{justifyContent.start}",
    "notificationbanner_base_text-container_align-items": "{alignItems.start}",
    "notificationbanner_base_text-container_flex-direction": "{flexDirection.column}",
    "notificationbanner_base_text-container_gap": "{xxs}",
    "notificationbanner_base_button-container_flex-direction": "{flexDirection.row}",
    "notificationbanner_base_button-container_gap": "{xs}",
    "notificationbanner_base_bottom-container_width": "{size.max}",
    "notificationbanner_base_bottom-container_flex-direction": "{flexDirection.row}",
    "notificationbanner_base_bottom-container_justify-content": "{justifyContent.end}",
    "notificationbanner_base_bottom-container_align-items": "{alignItems.center}",
    "notificationbanner_variant__hasDescription_false_main-container_align-items": "{alignItems.center}",
    "notificationbanner_combination_true_desktop_root-container_padding-left": "{custom_3}",
    "notificationbanner_combination_true_desktop_root-container_padding-right": "{custom_3}",
    "notificationbanner_combination_true_mobile_root-container_padding-left": "{m}",
    "notificationbanner_combination_true_mobile_root-container_padding-right": "{m}",
    "notificationbanner_combination_true_tablet_root-container_padding-left": "{l}",
    "notificationbanner_combination_true_tablet_root-container_padding-right": "{l}"
};
const $e3613f6017c674c5$var$notificationbutton_variant_isDisabled_true_container_opacity = "{opacity.disabled}";
const $e3613f6017c674c5$var$notificationbutton_base_icon_color = "{primary20}";
const $e3613f6017c674c5$var$notificationbutton_base_icon_size = "{base}";
const $e3613f6017c674c5$var$NotificationButtonTokens = {
    "notificationbutton_base_container_padding-top": "{xxs}",
    "notificationbutton_base_container_padding-right": "{base}",
    "notificationbutton_base_container_padding-bottom": "{xxs}",
    "notificationbutton_base_container_padding-left": "{base}",
    "notificationbutton_base_container_background-color": "{global.transparent}",
    "notificationbutton_base_container_border-color": "{primaryGrey60}",
    "notificationbutton_base_container_behavior_hover_border-color": "{primary20}",
    "notificationbutton_base_container_behavior_active_background-color": "{primary30}",
    "notificationbutton_base_container_behavior_focus_border-color": "{primary50}",
    notificationbutton_variant_isDisabled_true_container_opacity: $e3613f6017c674c5$var$notificationbutton_variant_isDisabled_true_container_opacity,
    "notificationbutton_variant_kind_tertiary_container_behavior_hover_background-color": "{primary30}",
    "notificationbutton_variant_kind_tertiary_container_behavior_active_background-color": "{primary40}",
    "notificationbutton_variant_kind_tertiary_container_behavior_focus_background-color": "{primary30}",
    notificationbutton_base_icon_color: $e3613f6017c674c5$var$notificationbutton_base_icon_color,
    notificationbutton_base_icon_size: $e3613f6017c674c5$var$notificationbutton_base_icon_size,
    "notificationbutton_variant__hasLabel_false_container_padding-top": "{xs}",
    "notificationbutton_variant__hasLabel_false_container_padding-bottom": "{xs}",
    "notificationbutton_variant__hasLabel_false_container_padding-left": "{xs}",
    "notificationbutton_variant__hasLabel_false_container_padding-right": "{xs}"
};
const $e3613f6017c674c5$var$notificationiconbutton_base_container_height = "{l}";
const $e3613f6017c674c5$var$notificationiconbutton_base_container_width = "{l}";
const $e3613f6017c674c5$var$notificationiconbutton_base_icon_size = "{base}";
const $e3613f6017c674c5$var$notificationiconbutton_base_icon_color = "{primary20}";
const $e3613f6017c674c5$var$notificationiconbutton_variant_isDisabled_true_container_opacity = "{opacity.disabled}";
const $e3613f6017c674c5$var$NotificationIconButtonTokens = {
    notificationiconbutton_base_container_height: $e3613f6017c674c5$var$notificationiconbutton_base_container_height,
    notificationiconbutton_base_container_width: $e3613f6017c674c5$var$notificationiconbutton_base_container_width,
    "notificationiconbutton_base_container_justify-content": "{justifyContent.center}",
    "notificationiconbutton_base_container_align-items": "{alignItems.center}",
    "notificationiconbutton_base_container_background-color": "{global.transparent}",
    "notificationiconbutton_base_container_border-color": "{global.transparent}",
    "notificationiconbutton_base_container_behavior_hover_background-color": "{primary30}",
    "notificationiconbutton_base_container_behavior_active_background-color": "{primary40}",
    "notificationiconbutton_base_container_behavior_focus_background-color": "{primary30}",
    "notificationiconbutton_base_container_behavior_focus_border-color": "{primary50}",
    notificationiconbutton_base_icon_size: $e3613f6017c674c5$var$notificationiconbutton_base_icon_size,
    notificationiconbutton_base_icon_color: $e3613f6017c674c5$var$notificationiconbutton_base_icon_color,
    notificationiconbutton_variant_isDisabled_true_container_opacity: $e3613f6017c674c5$var$notificationiconbutton_variant_isDisabled_true_container_opacity
};
const $e3613f6017c674c5$var$NudgeTokens = {
    "nudge_base_root-container_width": "{size.max}",
    "nudge_base_root-container_max-width": "{size.max}",
    "nudge_base_root-container_border-radius": "{xl}",
    "nudge_base_root-container_background-color": "{primaryGrey80}",
    "nudge_base_root-container_flex-direction": "{flexDirection.column}",
    "nudge_base_root-container_gap": "{base}",
    "nudge_base_root-container_padding-top": "{base}",
    "nudge_base_root-container_padding-right": "{base}",
    "nudge_base_root-container_padding-bottom": "{base}",
    "nudge_base_root-container_padding-left": "{base}",
    "nudge_base_base-container_gap": "{s}",
    "nudge_base_base-container_width": "{size.max}",
    "nudge_base_base-container_flex-direction": "{flexDirection.row}",
    "nudge_base_base-container_justify-content": "{justifyContent.start}",
    "nudge_base_base-container_align-items": "{alignItems.center}",
    "nudge_base_center-container_flex-direction": "{flexDirection.column}",
    "nudge_base_center-container_justify-content": "{justifyContent.start}",
    "nudge_base_center-container_align-items": "{alignItems.start}",
    "nudge_base_center-container_gap": "{s}",
    "nudge_base_buttons-container_width": "{size.max}",
    "nudge_base_buttons-container_gap": "{s}",
    "nudge_base_buttons-container_flex-direction": "{flexDirection.row}",
    "nudge_base_buttons-container_justify-content": "{justifyContent.end}",
    "nudge_variant__platform_tablet_root-container_max-width": "{custom_13}",
    "nudge_variant__platform_desktop_root-container_max-width": "{custom_14}"
};
const $e3613f6017c674c5$var$ToastTokens = {
    "toast_base_root-container_width": "{size.max}",
    "toast_base_root-container_max-width": "{size.max}",
    "toast_base_root-container_border-radius": "{xl}",
    "toast_base_root-container_background-color": "{primaryGrey80}",
    "toast_base_root-container_flex-direction": "{flexDirection.column}",
    "toast_base_root-container_gap": "{base}",
    "toast_base_root-container_padding-top": "{base}",
    "toast_base_root-container_padding-right": "{base}",
    "toast_base_root-container_padding-bottom": "{base}",
    "toast_base_root-container_padding-left": "{base}",
    "toast_base_base-container_gap": "{s}",
    "toast_base_base-container_width": "{size.max}",
    "toast_base_base-container_flex-direction": "{flexDirection.row}",
    "toast_base_base-container_justify-content": "{justifyContent.start}",
    "toast_base_base-container_align-items": "{alignItems.center}",
    "toast_base_center-container_flex-direction": "{flexDirection.column}",
    "toast_base_center-container_justify-content": "{justifyContent.start}",
    "toast_base_center-container_align-items": "{alignItems.start}",
    "toast_base_center-container_gap": "{xxs}",
    "toast_base_buttons-container_width": "{size.max}",
    "toast_base_buttons-container_gap": "{s}",
    "toast_base_buttons-container_flex-direction": "{flexDirection.row}",
    "toast_base_buttons-container_justify-content": "{justifyContent.end}",
    "toast_variant__platform_tablet_root-container_max-width": "{custom_13}",
    "toast_variant__platform_desktop_root-container_max-width": "{custom_14}"
};
const $e3613f6017c674c5$var$NudgeContainerTokens = {
    "nudgecontainer_base_popup-container_flex-direction": "{flexDirection.stack}",
    "nudgecontainer_base_popup-container_size": "{size.max}",
    "nudgecontainer_base_popup-container_padding-top": "{base}",
    "nudgecontainer_base_popup-container_padding-right": "{base}",
    "nudgecontainer_base_popup-container_padding-bottom": "{base}",
    "nudgecontainer_base_popup-container_padding-left": "{base}",
    "nudgecontainer_base_root-container_flex-direction": "{flexDirection.column}",
    "nudgecontainer_base_root-container_justify-content": "{justifyContent.start}",
    "nudgecontainer_base_root-container_align-items": "{alignItems.end}",
    "nudgecontainer_base_root-container_size": "{size.max}",
    "nudgecontainer_base_root-container_gap": "{xs}"
};
const $e3613f6017c674c5$var$ToastContainerTokens = {
    "toastcontainer_base_popup-container_flex-direction": "{flexDirection.stack}",
    "toastcontainer_base_popup-container_size": "{size.max}",
    "toastcontainer_base_popup-container_padding-top": "{base}",
    "toastcontainer_base_popup-container_padding-right": "{base}",
    "toastcontainer_base_popup-container_padding-bottom": "{base}",
    "toastcontainer_base_popup-container_padding-left": "{base}",
    "toastcontainer_base_root-container_flex-direction": "{flexDirection.column}",
    "toastcontainer_base_root-container_justify-content": "{justifyContent.end}",
    "toastcontainer_base_root-container_align-items": "{alignItems.start}",
    "toastcontainer_base_root-container_size": "{size.max}",
    "toastcontainer_base_root-container_gap": "{xs}"
};
const $e3613f6017c674c5$var$progressbar_base_container_gap = "{base}";
const $e3613f6017c674c5$var$progressbar_base_container_width = "{size.max}";
const $e3613f6017c674c5$var$ProgressBarTokens = {
    "progressbar_base_container_flex-direction": "{flexDirection.column}",
    "progressbar_base_container_justify-content": "{justifyContent.center}",
    "progressbar_base_container_align-items": "{alignItems.start}",
    progressbar_base_container_gap: $e3613f6017c674c5$var$progressbar_base_container_gap,
    progressbar_base_container_width: $e3613f6017c674c5$var$progressbar_base_container_width,
    "progressbar_base_container_background-color": "{global.transparent}",
    "progressbar_base_top-container_background-color": "{global.transparent}",
    "progressbar_base_top-container_flex-direction": "{flexDirection.row}",
    "progressbar_base_top-container_justify-content": "{justifyContent.spaceBetween}",
    "progressbar_base_top-container_align-items": "{alignItems.center}",
    "progressbar_base_top-container_width": "{size.max}",
    "progressbar_base_top-container_gap": "{m}",
    "progressbar_base_determinate-container_background-color": "{primaryGrey40}",
    "progressbar_base_determinate-container_height": "{xs}",
    "progressbar_base_determinate-container_width": "{size.max}",
    "progressbar_base_determinate-container_flex-direction": "{flexDirection.row}",
    "progressbar_base_determinate-container_justify-content": "{justifyContent.start}",
    "progressbar_base_determinate-container_align-items": "{alignItems.start}",
    "progressbar_base_determinate-container_border-radius": "{pill}",
    "progressbar_base_active-container_background-color": "{primary50}",
    "progressbar_base_active-container_height": "{xs}",
    "progressbar_base_active-container_border-radius": "{pill}",
    "progressbar_base_invisible-container_height": "{xs}",
    "progressbar_base_indeterminate-container_flex-direction": "{flexDirection.stack}",
    "progressbar_base_indeterminate-container_background-color": "{primaryGrey40}",
    "progressbar_base_indeterminate-container_height": "{xs}",
    "progressbar_base_indeterminate-container_width": "{size.max}",
    "progressbar_base_indeterminate-container_border-radius": "{pill}",
    "progressbar_base_track-container_height": "{size.max}",
    "progressbar_base_active-animatedContainer_height": "{size.max}",
    "progressbar_base_active-animatedContainer_width": "{massive}",
    "progressbar_base_active-animatedContainer_background-color": "{primary50}",
    "progressbar_base_active-animatedContainer_border-radius": "{pill}",
    "progressbar_variant_state_success_active-container_background-color": "{feedbackSuccess50}",
    "progressbar_variant_state_success_active-animatedContainer_background-color": "{feedbackSuccess50}",
    "progressbar_variant_state_error_active-container_background-color": "{feedbackError50}",
    "progressbar_variant_state_error_active-animatedContainer_background-color": "{feedbackError50}",
    "progressbar_variant_state_warning_active-container_background-color": "{feedbackWarning50}",
    "progressbar_variant_state_warning_active-animatedContainer_background-color": "{feedbackWarning50}",
    "progressbar_variant_labelPosition_center_top-container_justify-content": "{justifyContent.center}"
};
const $e3613f6017c674c5$var$pagination_base_container_width = "{size.max}";
const $e3613f6017c674c5$var$PaginationTokens = {
    "pagination_base_container_background-color": "{global.transparent}",
    "pagination_base_container_flex-direction": "{flexDirection.row}",
    "pagination_base_container_justify-content": "{alignItems.center}",
    "pagination_base_container_align-items": "{alignItems.center}",
    "pagination_base_container_padding-left": "{custom_25}",
    "pagination_base_container_padding-right": "{custom_25}",
    pagination_base_container_width: $e3613f6017c674c5$var$pagination_base_container_width,
    "pagination_base_container_min-height": "{xxl}",
    "pagination_base_basic-container_flex-direction": "{flexDirection.row}",
    "pagination_base_compact-container_flex-direction": "{flexDirection.row}",
    "pagination_base_compact-container_gap": "{xxs}",
    "pagination_base_compact-container_padding-left": "{base}",
    "pagination_base_compact-container_padding-right": "{base}"
};
const $e3613f6017c674c5$var$PromoCardTokens = {
    "promocard_base_root-container_background-color": "{global.white}",
    "promocard_base_root-container_flex-direction": "{flexDirection.column}",
    "promocard_base_root-container_width": "{size.max}",
    "promocard_base_root-container_justify-content": "{justifyContent.start}",
    "promocard_base_root-container_align-items": "{alignItems.start}",
    "promocard_base_root-container_border-radius": "{xl}",
    "promocard_base_vertical-container_flex-direction": "{flexDirection.column}",
    "promocard_base_vertical-container_align-items": "{alignItems.start}",
    "promocard_base_vertical-container_justify-content": "{justifyContent.start}",
    "promocard_base_vertical-container_width": "{size.max}",
    "promocard_base_vertical-container_border-radius": "{xl}",
    "promocard_base_vertical-container_background-color": "{primaryBackground}",
    "promocard_base_horizontal-container_flex-direction": "{flexDirection.row}",
    "promocard_base_horizontal-container_align-items": "{alignItems.stretch}",
    "promocard_base_horizontal-container_justify-content": "{justifyContent.start}",
    "promocard_base_horizontal-container_width": "{size.max}",
    "promocard_base_horizontal-container_border-radius": "{xl}",
    "promocard_base_horizontal-container_height": "{intrinsicSize.max}",
    "promocard_base_horizontal-container_background-color": "{primaryBackground}",
    "promocard_base_vertical-content-container_flex-direction": "{flexDirection.row}",
    "promocard_base_vertical-content-container_align-items": "{alignItems.start}",
    "promocard_base_vertical-content-container_justify-content": "{justifyContent.start}",
    "promocard_base_vertical-content-container_width": "{size.max}",
    "promocard_base_vertical-content-container_background-color": "{primaryBackground}",
    "promocard_base_vertical-content-container_border-bottom-left-radius": "{xl}",
    "promocard_base_vertical-content-container_border-bottom-right-radius": "{xl}",
    "promocard_base_vertical-content-container_padding-right": "{m}",
    "promocard_base_vertical-content-container_padding-bottom": "{m}",
    "promocard_base_vertical-content-container_padding-left": "{m}",
    "promocard_base_horizontal-content-container_flex-direction": "{flexDirection.row}",
    "promocard_base_horizontal-content-container_align-items": "{alignItems.start}",
    "promocard_base_horizontal-content-container_justify-content": "{justifyContent.start}",
    "promocard_base_horizontal-content-container_height": "{size.max}",
    "promocard_base_horizontal-content-container_background-color": "{primaryBackground}",
    "promocard_base_horizontal-content-container_padding-top": "{m}",
    "promocard_base_horizontal-content-container_padding-right": "{m}",
    "promocard_base_horizontal-content-container_padding-bottom": "{m}",
    "promocard_base_horizontal-content-container_padding-left": "{m}",
    "promocard_base_vertical-image-container_width": "{size.max}",
    "promocard_base_vertical-image-container_flex-direction": "{flexDirection.stack}",
    "promocard_base_vertical-image-container_align-items": "{alignItems.end}",
    "promocard_base_horizontal-image-container_height": "{size.max}",
    "promocard_base_horizontal-image-container_flex-direction": "{flexDirection.stack}",
    "promocard_base_horizontal-image-container_align-items": "{alignItems.center}",
    "promocard_base_horizontal-image-container_justify-content": "{justifyContent.start}",
    "promocard_base_horizontal-image_height": "{size.max}",
    "promocard_base_vertical-promoCardArc_color": "{primaryBackground}",
    "promocard_base_vertical-promoCardArc_width": "{size.max}",
    "promocard_base_vertical-promoCardArc_height": "{xl}",
    "promocard_base_horizontal-promoCardArc_color": "{primaryBackground}",
    "promocard_base_horizontal-promoCardArc_height": "{size.max}",
    "promocard_base_horizontal-promoCardArc_width": "{xl}",
    "promocard_base_footer-container_color": "{primaryBackground}",
    "promocard_base_footer-container_width": "{size.max}",
    "promocard_base_footer-container_justify-content": "{justifyContent.spaceBetween}",
    "promocard_base_footer-container_align-items": "{alignItems.center}",
    "promocard_base_footer-container_flex-direction": "{flexDirection.row}",
    "promocard_base_footer-container_gap": "{base}",
    "promocard_base_footer-container_padding-left": "{m}",
    "promocard_base_footer-container_padding-right": "{m}",
    "promocard_base_footer-container_padding-top": "{base}",
    "promocard_base_footer-container_padding-bottom": "{base}",
    "promocard_variant_size_medium_horizontal-content-container_padding-top": "{l}",
    "promocard_variant_size_medium_horizontal-content-container_padding-right": "{l}",
    "promocard_variant_size_medium_horizontal-content-container_padding-bottom": "{l}",
    "promocard_variant_size_medium_horizontal-content-container_padding-left": "{l}",
    "promocard_variant_size_large_horizontal-content-container_padding-top": "{l}",
    "promocard_variant_size_large_horizontal-content-container_padding-right": "{l}",
    "promocard_variant_size_large_horizontal-content-container_padding-bottom": "{l}",
    "promocard_variant_size_large_horizontal-content-container_padding-left": "{l}"
};
const $e3613f6017c674c5$var$searchresultitem_base_container_gap = "{base}";
const $e3613f6017c674c5$var$searchresultitem_base_container_width = "{size.max}";
const $e3613f6017c674c5$var$searchresultitem_base_icon_size = "{l}";
const $e3613f6017c674c5$var$searchresultitem_base_icon_color = "{primaryGrey80}";
const $e3613f6017c674c5$var$SearchResultItemTokens = {
    "searchresultitem_base_container_flex-direction": "{flexDirection.row}",
    searchresultitem_base_container_gap: $e3613f6017c674c5$var$searchresultitem_base_container_gap,
    "searchresultitem_base_container_padding-top": "{xs}",
    "searchresultitem_base_container_padding-bottom": "{xs}",
    "searchresultitem_base_container_align-items": "{alignItems.center}",
    searchresultitem_base_container_width: $e3613f6017c674c5$var$searchresultitem_base_container_width,
    "searchresultitem_base_container_behavior_hover_background-color": "{primaryGrey20}",
    "searchresultitem_base_container_behavior_active_background-color": "{primaryGrey20}",
    "searchresultitem_base_container_behavior_focus_background-color": "{primaryGrey20}",
    searchresultitem_base_icon_size: $e3613f6017c674c5$var$searchresultitem_base_icon_size,
    searchresultitem_base_icon_color: $e3613f6017c674c5$var$searchresultitem_base_icon_color,
    "searchresultitem_base_text-container_flex-direction": "{flexDirection.row}",
    "searchresultitem_base_text-container_justify-content": "{justifyContent.start}",
    "searchresultitem_base_text-container_align-items": "{alignItems.center}"
};
const $e3613f6017c674c5$var$SearchResultTextTokens = {};
const $e3613f6017c674c5$var$searchresults_base_container_width = "{size.max}";
const $e3613f6017c674c5$var$SearchResultsTokens = {
    "searchresults_base_popup_background-color": "{global.transparent}",
    "searchresults_base_popup-container_flex-direction": "{flexDirection.stack}",
    "searchresults_base_popup-container_justify-content": "{justifyContent.center}",
    "searchresults_base_popup-container_width": "{size.max}",
    "searchresults_base_popup-container_background-color": "{global.transparent}",
    "searchresults_base_root-container_background-color": "{primaryBackground}",
    "searchresults_base_root-container_flex-direction": "{flexDirection.column}",
    "searchresults_base_root-container_align-items": "{alignItems.center}",
    "searchresults_base_root-container_padding-top": "{base}",
    "searchresults_base_root-container_padding-right": "{base}",
    "searchresults_base_root-container_padding-bottom": "{base}",
    "searchresults_base_root-container_padding-left": "{base}",
    "searchresults_base_root-container_gap": "{base}",
    "searchresults_base_root-container_width": "{size.max}",
    searchresults_base_container_width: $e3613f6017c674c5$var$searchresults_base_container_width,
    "searchresults_base_container_flex-direction": "{flexDirection.column}",
    "searchresults_base_container_align-items": "{alignItems.center}",
    "searchresults_base_heading-container_flex-direction": "{flexDirection.row}",
    "searchresults_base_heading-container_justify-content": "{justifyContent.spaceBetween}",
    "searchresults_base_heading-container_align-items": "{alignItems.start}",
    "searchresults_base_heading-container_width": "{size.max}",
    "searchresults_base_results-container_flex-direction": "{flexDirection.column}",
    "searchresults_base_results-container_align-items": "{alignItems.start}",
    "searchresults_base_results-container_gap": "{base}",
    "searchresults_base_results-container_width": "{size.max}",
    "searchresults_variant_appearance_box_root-container_border-radius": "{xl}"
};
const $e3613f6017c674c5$var$RadioButtonTokens = {
    "radiobutton_base_vertical-container_flex-direction": "{flexDirection.column}",
    "radiobutton_base_vertical-container_justify-content": "{justifyContent.start}",
    "radiobutton_base_vertical-container_align-items": "{alignItems.start}",
    "radiobutton_base_vertical-container_gap": "{xs}",
    "radiobutton_base_horizontal-container_flex-direction": "{flexDirection.row}",
    "radiobutton_base_horizontal-container_justify-content": "{justifyContent.start}",
    "radiobutton_base_horizontal-container_align-items": "{alignItems.center}",
    "radiobutton_base_horizontal-container_gap": "{xs}",
    "radiobutton_base_outer-container_min-width": "{m}",
    "radiobutton_base_outer-container_min-height": "{m}",
    "radiobutton_base_outer-container_flex-direction": "{flexDirection.row}",
    "radiobutton_base_outer-container_justify-content": "{justifyContent.center}",
    "radiobutton_base_outer-container_align-items": "{alignItems.center}",
    "radiobutton_base_outer-container_background-color": "{global.transparent}",
    "radiobutton_base_outer-container_border-radius": "{pill}",
    "radiobutton_base_outer-container_border-color": "{primaryGrey80}",
    "radiobutton_base_outer-container_border-width": "{border_thin}",
    "radiobutton_variant_checked_true_outer-container_border-width": "{border_none}",
    "radiobutton_base_outer-container_behavior_hover_border-color": "{primary40}",
    "radiobutton_base_outer-container_behavior_active_border-color": "{primary60}",
    "radiobutton_base_outer-container_behavior_focus_border-color": "{primary60}",
    "radiobutton_base_inner-container_min-width": "{s}",
    "radiobutton_base_inner-container_min-height": "{s}",
    "radiobutton_base_inner-container_border-radius": "{pill}",
    "radiobutton_base_label-jds_text_text-align": "{textAlign.start}",
    "radiobutton_variant_size_small_outer-container_min-width": "{base}",
    "radiobutton_variant_size_small_outer-container_min-height": "{base}",
    "radiobutton_variant_size_small_vertical-container_gap": "{xxs}",
    "radiobutton_variant_size_small_inner-container_min-width": "{xs}",
    "radiobutton_variant_size_small_inner-container_min-height": "{xs}",
    "radiobutton_variant_checked_true_outer-container_background-color": "{primary50}",
    "radiobutton_variant_checked_true_outer-container_behavior_hover_background-color": "{primary40}",
    "radiobutton_variant_checked_true_outer-container_behavior_active_background-color": "{primary60}",
    "radiobutton_variant_checked_true_outer-container_behavior_focus_background-color": "{primary50}",
    "radiobutton_variant_checked_true_inner-container_background-color": "{primaryInverse}",
    "radiobutton_variant_disabled_true_vertical-container_opacity": "{opacity.disabled}",
    "radiobutton_base_vertical-container_opacity": "{opacity.enabled}",
    "radiobutton_combination_true_success_inner-container_background-color": "{global.white}",
    "radiobutton_combination_true_error_inner-container_background-color": "{global.white}",
    "radiobutton_combination_true_warning_inner-container_background-color": "{global.white}"
};
const $e3613f6017c674c5$var$skeleton_variant_shape_heading_container_height = "{xxl}";
const $e3613f6017c674c5$var$skeleton_variant_shape_paragraph_container_height = "{base}";
const $e3613f6017c674c5$var$skeleton_variant_shape_custom_container_width = "{size.max}";
const $e3613f6017c674c5$var$skeleton_variant_shape_custom_container_height = "{size.max}";
const $e3613f6017c674c5$var$SkeletonTokens = {
    "skeleton_base_container_background-color": "{primaryGrey20}",
    "skeleton_base_skeletonLoader_primary-color": "{primaryGrey20}",
    "skeleton_base_skeletonLoader_secondary-color": "{primaryGrey40}",
    "skeleton_variant_shape_circle_container_border-radius": "{pill}",
    skeleton_variant_shape_heading_container_height: $e3613f6017c674c5$var$skeleton_variant_shape_heading_container_height,
    "skeleton_variant_shape_heading_container_border-radius": "{pill}",
    "skeleton_variant_shape_paragraph_container_border-radius": "{pill}",
    skeleton_variant_shape_paragraph_container_height: $e3613f6017c674c5$var$skeleton_variant_shape_paragraph_container_height,
    "skeleton_variant_shape_rectangle_container_border-radius": "{xl}",
    "skeleton_variant_shape_square_container_border-radius": "{xxl}",
    skeleton_variant_shape_custom_container_width: $e3613f6017c674c5$var$skeleton_variant_shape_custom_container_width,
    skeleton_variant_shape_custom_container_height: $e3613f6017c674c5$var$skeleton_variant_shape_custom_container_height
};
const $e3613f6017c674c5$var$selector_variant_stretch_true_container_width = "{size.max}";
const $e3613f6017c674c5$var$SelectorTokens = {
    "selector_base_container_flex-direction": "{flexDirection.stack}",
    "selector_base_selector-container_opacity": "{opacity.enabled}",
    "selector_base_selector-container_align-items": "{alignItems.center}",
    "selector_base_selector-container_justify-content": "{justifyContent.center}",
    "selector_base_selector-container_border-radius": "{pill}",
    "selector_base_selector-container_padding-top": "{xxs}",
    "selector_base_selector-container_padding-right": "{xxs}",
    "selector_base_selector-container_padding-bottom": "{xxs}",
    "selector_base_selector-container_padding-left": "{xxs}",
    "selector_base_outer-container_padding-top": "{xxs}",
    "selector_base_outer-container_padding-right": "{xxs}",
    "selector_base_outer-container_padding-bottom": "{xxs}",
    "selector_base_outer-container_padding-left": "{xxs}",
    "selector_base_outer-container_background-color": "{primaryGrey20}",
    "selector_base_outer-container_border-radius": "{pill}",
    "selector_base_selector-container_gap": "{xxs}",
    "selector_base_selector-container_flex-direction": "{flexDirection.row}",
    "selector_base_outer-container_width": "{size.max}",
    "selector_base_outer-container_height": "{intrinsicSize.max}",
    "selector_base_outer-container_justify-content": "{justifyContent.start}",
    "selector_base_outer-container_align-items": "{alignItems.center}",
    "selector_base_inner-container_background-color": "{primary50}",
    "selector_base_inner-container_border-radius": "{pill}",
    selector_variant_stretch_true_container_width: $e3613f6017c674c5$var$selector_variant_stretch_true_container_width,
    "selector_variant_stretch_true_selector-container_width": "{size.max}",
    "selector_variant__animating_true_inner-container_background-color": "{primary50}"
};
const $e3613f6017c674c5$var$selectoritem_base_container_opacity = "{opacity.enabled}";
const $e3613f6017c674c5$var$selectoritem_base_container_gap = "{xs}";
const $e3613f6017c674c5$var$selectoritem_base_icon_size = "{m}";
const $e3613f6017c674c5$var$selectoritem_base_icon_color = "{primary60}";
const $e3613f6017c674c5$var$selectoritem_variant_selected_true_icon_color = "{primaryInverse}";
const $e3613f6017c674c5$var$selectoritem_variant_selected_true_icon_behavior_active_color = "{primary30}";
const $e3613f6017c674c5$var$selectoritem_variant_stretch_true_container_width = "{size.max}";
const $e3613f6017c674c5$var$selectoritem_variant_disabled_true_container_opacity = "{opacity.disabled}";
const $e3613f6017c674c5$var$selectoritem_variant_wrap_vertical_container_gap = "{xxs}";
const $e3613f6017c674c5$var$SelectorItemTokens = {
    selectoritem_base_container_opacity: $e3613f6017c674c5$var$selectoritem_base_container_opacity,
    "selectoritem_base_container_background-color": "{global.transparent}",
    "selectoritem_base_container_flex-direction": "{flexDirection.row}",
    "selectoritem_base_container_align-items": "{alignItems.center}",
    "selectoritem_base_container_justify-content": "{justifyContent.center}",
    "selectoritem_base_container_border-radius": "{pill}",
    selectoritem_base_container_gap: $e3613f6017c674c5$var$selectoritem_base_container_gap,
    "selectoritem_base_container_padding-top": "{xs}",
    "selectoritem_base_container_padding-right": "{base}",
    "selectoritem_base_container_padding-bottom": "{xs}",
    "selectoritem_base_container_padding-left": "{base}",
    "selectoritem_base_container_behavior_focus_background-color": "{primary20}",
    "selectoritem_base_container_behavior_focus_box-shadow_spread": "{xxs}",
    "selectoritem_base_container_behavior_focus_box-shadow_color": "{primary60}",
    "selectoritem_base_container_behavior_hover_background-color": "{primary20}",
    "selectoritem_base_container_behavior_active_background-color": "{primary30}",
    selectoritem_base_icon_size: $e3613f6017c674c5$var$selectoritem_base_icon_size,
    selectoritem_base_icon_color: $e3613f6017c674c5$var$selectoritem_base_icon_color,
    "selectoritem_variant_selected_true_container_background-color": "{primary50}",
    "selectoritem_variant_selected_true_container_behavior_hover_background-color": "{primary60}",
    "selectoritem_variant_selected_true_container_behavior_active_background-color": "{primary60}",
    "selectoritem_variant_selected_true_container_behavior_focus_background-color": "{primary50}",
    selectoritem_variant_selected_true_icon_color: $e3613f6017c674c5$var$selectoritem_variant_selected_true_icon_color,
    selectoritem_variant_selected_true_icon_behavior_active_color: $e3613f6017c674c5$var$selectoritem_variant_selected_true_icon_behavior_active_color,
    "selectoritem_variant_wrap_vertical_container_flex-direction": "{flexDirection.column}",
    selectoritem_variant_stretch_true_container_width: $e3613f6017c674c5$var$selectoritem_variant_stretch_true_container_width,
    selectoritem_variant_disabled_true_container_opacity: $e3613f6017c674c5$var$selectoritem_variant_disabled_true_container_opacity,
    selectoritem_variant_wrap_vertical_container_gap: $e3613f6017c674c5$var$selectoritem_variant_wrap_vertical_container_gap
};
const $e3613f6017c674c5$var$servicecard_base_jds_content_block_width = "{size.max}";
const $e3613f6017c674c5$var$ServiceCardTokens = {
    "servicecard_base_root-container_flex-direction": "{flexDirection.stack}",
    "servicecard_base_inner-stack-container_flex-direction": "{flexDirection.stack}",
    "servicecard_base_root-container_size": "{size.max}",
    "servicecard_base_inner-stack-container_size": "{size.max}",
    "servicecard_base_root-container_justify-content": "{justifyContent.start}",
    "servicecard_base_inner-stack-container_justify-content": "{justifyContent.start}",
    "servicecard_base_root-container_align-items": "{alignItems.start}",
    "servicecard_base_root-container_border-radius": "{xl}",
    "servicecard_base_blur-image_height": "{size.max}",
    "servicecard_base_blur-image_width": "{size.max}",
    "servicecard_base_blur-image_blur-radius": "{xl}",
    "servicecard_base_blur-image_aspect-ratio": "{aspect_ratio.16.9}",
    "servicecard_base_internal-vertical-container_flex-direction": "{flexDirection.column}",
    "servicecard_base_internal-vertical-container_size": "{size.max}",
    "servicecard_base_internal-vertical-container_justify-content": "{justifyContent.start}",
    "servicecard_base_internal-vertical-container_align-items": "{alignItems.start}",
    "servicecard_base_image-container_flex-direction": "{flexDirection.row}",
    "servicecard_base_image-container_justify-content": "{justifyContent.start}",
    "servicecard_base_image-container_align-items": "{alignItems.start}",
    "servicecard_base_image-container_height": "{size.max}",
    "servicecard_base_image-container_width": "{size.max}",
    "servicecard_base_jds_badge_padding-top": "{base}",
    "servicecard_base_jds_badge_padding-left": "{base}",
    "servicecard_base_content-block-container_background-color": "{custom_color_4}",
    "servicecard_base_content-block-container_width": "{size.max}",
    "servicecard_base_content-block-container_padding-top": "{base}",
    "servicecard_base_content-block-container_padding-bottom": "{base}",
    "servicecard_base_content-block-container_padding-left": "{base}",
    "servicecard_base_content-block-container_padding-right": "{base}",
    servicecard_base_jds_content_block_width: $e3613f6017c674c5$var$servicecard_base_jds_content_block_width,
    "servicecard_variant_imageRatio_square_blur_image_aspect-ratio": "{aspect_ratio.1.1}",
    "servicecard_variant_imageRatio_landscape_blur_image_aspect-ratio": "{aspect_ratio.4.3}",
    "servicecard_variant_imageRatio_portrait_blur_image_aspect-ratio": "{aspect_ratio.4.5}"
};
const $e3613f6017c674c5$var$slider_base_container_width = "{size.max}";
const $e3613f6017c674c5$var$slider_base_container_gap = "{xs}";
const $e3613f6017c674c5$var$slider_base_slider_width = "{size.max}";
const $e3613f6017c674c5$var$slider_variant_disabled_true_container_opacity = "{opacity.disabled}";
const $e3613f6017c674c5$var$SliderTokens = {
    "slider_base_container_flex-direction": "{flexDirection.column}",
    "slider_base_container_justify-content": "{justifyContent.start}",
    "slider_base_container_align-items": "{alignItems.start}",
    slider_base_container_width: $e3613f6017c674c5$var$slider_base_container_width,
    slider_base_container_gap: $e3613f6017c674c5$var$slider_base_container_gap,
    "slider_base_top-container_flex-direction": "{flexDirection.row}",
    "slider_base_top-container_justify-content": "{justifyContent.start}",
    "slider_base_top-container_align-items": "{alignItems.center}",
    "slider_base_top-container_width": "{size.max}",
    "slider_base_top-container_gap": "{xs}",
    "slider_base_label-jds_text_justify-content": "{justifyContent.start}",
    "slider_base_label-jds_text_align-items": "{alignItems.center}",
    "slider_base_inner-container_align-items": "{alignItems.center}",
    "slider_base_inner-container_padding-left": "{xs}",
    "slider_base_inner-container_padding-right": "{xs}",
    "slider_base_inner-container_border-width": "{border_thin}",
    "slider_base_inner-container_border-color": "{primaryGrey80}",
    "slider_base_inner-container_border-radius": "{medium}",
    slider_base_slider_width: $e3613f6017c674c5$var$slider_base_slider_width,
    "slider_base_slider_track-height": "{xxs}",
    "slider_base_slider_inactive-color": "{primaryGrey40}",
    "slider_base_slider_active-color": "{primary50}",
    "slider_base_slider_ball-color": "{primary50}",
    "slider_base_slider_ball-border-color": "{primary80}",
    "slider_base_slider_border-radius": "{small}",
    "slider_base_slider_behavior_hover_ball-color": "{primary60}",
    "slider_base_slider_behavior_active_active-color": "{primary60}",
    "slider_base_slider_behavior_active_ball-color": "{primary60}",
    "slider_base_slider_behavior_focus_ball-border-width": "{border_focus}",
    "slider_base_bottom-container_flex-direction": "{flexDirection.row}",
    "slider_base_bottom-container_justify-content": "{justifyContent.spaceBetween}",
    "slider_base_bottom-container_align-items": "{alignItems.center}",
    "slider_base_bottom-container_width": "{size.max}",
    "slider_variant_state_success_inner-container_border-color": "{feedbackSuccess50}",
    "slider_variant_state_error_inner-container_border-color": "{feedbackError50}",
    "slider_variant_state_warning_inner-container_border-color": "{feedbackWarning50}",
    slider_variant_disabled_true_container_opacity: $e3613f6017c674c5$var$slider_variant_disabled_true_container_opacity,
    "slider_variant_disabled_true_slider_behavior_hover_ball-color": "{primary50}",
    "slider_variant_disabled_true_slider_behavior_active_active-color": "{primary50}",
    "slider_variant_disabled_true_slider_behavior_active_ball-color": "{primary50}"
};
const $e3613f6017c674c5$var$paginationbutton_base_container_size = "{xxl}";
const $e3613f6017c674c5$var$PaginationButtonTokens = {
    paginationbutton_base_container_size: $e3613f6017c674c5$var$paginationbutton_base_container_size,
    "paginationbutton_base_container_justify-content": "{justifyContent.center}",
    "paginationbutton_base_container_align-items": "{alignItems.center}",
    "paginationbutton_base_inner-container_background-color": "{global.transparent}",
    "paginationbutton_base_inner-container_flex-direction": "{flexDirection.row}",
    "paginationbutton_base_inner-container_justify-content": "{justifyContent.center}",
    "paginationbutton_base_inner-container_align-items": "{alignItems.center}",
    "paginationbutton_base_inner-container_border-radius": "{pill}",
    "paginationbutton_base_inner-container_width": "{l}",
    "paginationbutton_base_inner-container_height": "{l}",
    "paginationbutton_base_inner-container_opacity": "{opacity.enabled}",
    "paginationbutton_base_inner-container_gap": "{xs}",
    "paginationbutton_base_inner-container_border-color": "{primary80}",
    "paginationbutton_base_inner-container_behavior_hover_background-color": "{primary20}",
    "paginationbutton_base_inner-container_behavior_active_background-color": "{primary30}",
    "paginationbutton_base_inner-container_behavior_focus_border-width": "{border_focus}",
    "paginationbutton_variant_state_selected_inner-container_background-color": "{primary70}",
    "paginationbutton_variant_state_ellipsis_inner-container_background-color": "{global.transparent}"
};
const $e3613f6017c674c5$var$searchbox_base_container_width = "{size.max}";
const $e3613f6017c674c5$var$searchbox_base_container_height = "{xl}";
const $e3613f6017c674c5$var$searchbox_base_container_gap = "{s}";
const $e3613f6017c674c5$var$searchbox_base_container_opacity = "{opacity.enabled}";
const $e3613f6017c674c5$var$searchbox_variant_disabled_true_container_opacity = "{opacity.disabled}";
const $e3613f6017c674c5$var$SearchBoxTokens = {
    "searchbox_base_container_background-color": "{primaryGrey20}",
    "searchbox_base_container_flex-direction": "{flexDirection.row}",
    "searchbox_base_container_justify-content": "{justifyContent.start}",
    "searchbox_base_container_align-items": "{alignItems.center}",
    "searchbox_base_container_padding-right": "{s}",
    "searchbox_base_container_padding-left": "{s}",
    searchbox_base_container_width: $e3613f6017c674c5$var$searchbox_base_container_width,
    searchbox_base_container_height: $e3613f6017c674c5$var$searchbox_base_container_height,
    "searchbox_base_container_border-radius": "{pill}",
    searchbox_base_container_gap: $e3613f6017c674c5$var$searchbox_base_container_gap,
    searchbox_base_container_opacity: $e3613f6017c674c5$var$searchbox_base_container_opacity,
    "searchbox_base_container_behavior_focus_border-color": "{primary60}",
    "searchbox_base_container_behavior_focus_border-width": "{border_focus}",
    "searchbox_base_container_behavior_active_background-color": "{primaryGrey40}",
    "searchbox_base_input_text-align": "{textAlign.start}",
    "searchbox_base_input_placeholder-color": "{primaryGrey100}",
    "searchbox_base_input_placeholder-font-family": "{bodyS}",
    "searchbox_base_input_placeholder-font-size": "{bodyS}",
    "searchbox_base_input_placeholder-line-height": "{bodyS}",
    "searchbox_base_input_placeholder-letter-spacing": "{bodyS}",
    "searchbox_base_input_placeholder-font-weight": "{bodyS}",
    "searchbox_base_input_input-color": "{primaryGrey100}",
    "searchbox_base_input_input-font-family": "{bodyS}",
    "searchbox_base_input_input-font-size": "{bodyS}",
    "searchbox_base_input_input-line-height": "{bodyS}",
    "searchbox_base_input_input-letter-spacing": "{bodyS}",
    "searchbox_base_input_input-font-weight": "{bodyS}",
    "searchbox_base_input_cursor-color": "{primary60}",
    "searchbox_base_input_behavior_hover_placeholder-color": "{primary60}",
    "searchbox_base_input_behavior_focus_placeholder-color": "{primary60}",
    "searchbox_base_input_behavior_active_placeholder-color": "{primary60}",
    "searchbox_base_prefix-container_flex-direction": "{flexDirection.row}",
    "searchbox_base_prefix-container_justify-content": "{justifyContent.center}",
    "searchbox_base_prefix-container_align-items": "{alignItems.center}",
    "searchbox_base_prefix-icon_size": "{m}",
    "searchbox_base_prefix-icon_color": "{primaryGrey100}",
    "searchbox_base_prefix-icon_behavior_hover_color": "{primary60}",
    "searchbox_base_prefix-icon_behavior_focus_color": "{primary60}",
    "searchbox_base_prefix-icon_behavior_active_color": "{primaryGrey80}",
    "searchbox_base_suffix-container_flex-direction": "{flexDirection.row}",
    "searchbox_base_suffix-container_justify-content": "{justifyContent.center}",
    "searchbox_base_suffix-container_align-items": "{alignItems.center}",
    "searchbox_base_suffix-icon_size": "{m}",
    "searchbox_base_suffix-icon_color": "{primary60}",
    "searchbox_base_suffix-icon_behavior_hover_color": "{primary60}",
    "searchbox_base_suffix-icon_behavior_focus_color": "{primary60}",
    "searchbox_base_suffix-icon_behavior_active_color": "{primaryGrey100}",
    "searchbox_variant_kind_header_container_background-color": "{primary60}",
    "searchbox_variant_kind_header_container_behavior_focus_border-color": "{primary80}",
    "searchbox_variant_kind_header_container_behavior_active_background-color": "{primary70}",
    "searchbox_variant_kind_header_prefix-icon_color": "{primaryBackground}",
    "searchbox_variant_kind_header_prefix-icon_behavior_hover_color": "{primary30}",
    "searchbox_variant_kind_header_prefix-icon_behavior_active_color": "{primary30}",
    "searchbox_variant_kind_header_suffix-icon_color": "{primaryBackground}",
    "searchbox_variant_kind_header_suffix-icon_behavior_hover_color": "{primary30}",
    "searchbox_variant_kind_header_suffix-icon_behavior_active_color": "{primary30}",
    "searchbox_variant_kind_header_input_input-color": "{primaryBackground}",
    "searchbox_variant_kind_header_input_placeholder-color": "{primary40}",
    "searchbox_variant_kind_header_input_cursor-color": "{primary30}",
    "searchbox_variant_kind_header_input_behavior_hover_placeholder-color": "{primary30}",
    "searchbox_variant_kind_light_background_container_background-color": "{primaryBackground}",
    "searchbox_variant_kind_light_background_container_border-color": "{primaryGrey60}",
    "searchbox_variant_kind_light_background_container_behavior_hover_border-color": "{primary50}",
    "searchbox_variant_kind_light_background_container_behavior_focus_border-color": "{primary80}",
    "searchbox_variant_kind_light_background_container_behavior_active_border-color": "{primary60}",
    "searchbox_variant_kind_light_background_container_border-width": "{border_thin}",
    "searchbox_variant_kind_light_background_container_behavior_focus_border-width": "{border_focus}",
    "searchbox_variant_kind_light_background_input_input-color": "{primaryGrey100}",
    "searchbox_variant_kind_light_background_input_cursor-color": "{primary60}",
    "searchbox_variant_kind_light_background_input_behavior_active_placeholder-color": "{primaryGrey100}",
    "searchbox_variant_kind_light_background_prefix-icon_color": "{primaryGrey100}",
    "searchbox_variant_kind_light_background_prefix-icon_behavior_hover_color": "{primary60}",
    "searchbox_variant_kind_light_background_prefix-icon_behavior_focus_color": "{primary60}",
    "searchbox_variant_kind_light_background_prefix-icon_behavior_active_color": "{primaryGrey100}",
    "searchbox_variant_kind_light_background_suffix-icon_color": "{primary60}",
    "searchbox_variant_kind_light_background_suffix-icon_behavior_active_color": "{primary60}",
    searchbox_variant_disabled_true_container_opacity: $e3613f6017c674c5$var$searchbox_variant_disabled_true_container_opacity,
    "searchbox_variant__isValueEmpty_false_suffix-icon_color": "{primaryGrey80}",
    "searchbox_combination_header_false_suffix-icon_color": "{primary30}",
    "searchbox_variant__inputFocus_true_input_placeholder-color": "{primaryGrey60}",
    "searchbox_combination_light_background_false_suffix-icon_color": "{primaryGrey80}",
    "searchbox_combination_light_background_true_container_border-color": "{primary60}"
};
const $e3613f6017c674c5$var$spinner_base_container_gap = "{base}";
const $e3613f6017c674c5$var$spinner_variant_size_small_container_gap = "{s}";
const $e3613f6017c674c5$var$SpinnerTokens = {
    "spinner_base_container_background-color": "{global.transparent}",
    spinner_base_container_gap: $e3613f6017c674c5$var$spinner_base_container_gap,
    "spinner_base_container_justify-content": "{justifyContent.center}",
    "spinner_base_container_align-items": "{alignItems.center}",
    "spinner_base_container_flex-direction": "{flexDirection.row}",
    "spinner_base_spinner-container_size": "{xxl}",
    "spinner_base_arc-container_flex-direction": "{flexDirection.stack}",
    "spinner_base_arc-container_justify-content": "{justifyContent.center}",
    "spinner_base_arc-container_align-items": "{alignItems.center}",
    "spinner_base_arc-container_size": "{size.max}",
    "spinner_base_base-arc_fill": "{primaryGrey40}",
    "spinner_base_base-arc_radius": "{m}",
    "spinner_base_base-arc_arcWidth": "{xs}",
    "spinner_base_base-arc_start": 0,
    "spinner_base_base-arc_end": 360,
    "spinner_base_normal-arc_fill": "{primary50}",
    "spinner_base_normal-arc_radius": "{m}",
    "spinner_base_normal-arc_arcWidth": "{xs}",
    "spinner_base_normal-arc_start": 0,
    "spinner_base_normal-arc_end": 120,
    "spinner_base_normal-arc_animation-duration": "1000",
    "spinner_base_first-arc_fill": "{primary50}",
    "spinner_base_first-arc_radius": "{m}",
    "spinner_base_first-arc_arcWidth": "{xs}",
    "spinner_base_first-arc_start": 0,
    "spinner_base_first-arc_end": 360,
    "spinner_base_first-arc_animation-delay": "300",
    "spinner_base_first-arc_animation-duration": "1300",
    "spinner_base_second-arc_fill": "{secondary50}",
    "spinner_base_second-arc_radius": "{m}",
    "spinner_base_second-arc_arcWidth": "{xs}",
    "spinner_base_second-arc_start": 0,
    "spinner_base_second-arc_end": 360,
    "spinner_base_second-arc_animation-delay": "150",
    "spinner_base_second-arc_animation-duration": "1300",
    "spinner_base_third-arc_fill": "{sparkle50}",
    "spinner_base_third-arc_radius": "{m}",
    "spinner_base_third-arc_arcWidth": "{xs}",
    "spinner_base_third-arc_start": 0,
    "spinner_base_third-arc_end": 360,
    "spinner_base_third-arc_animation-duration": "1300",
    "spinner_variant_labelPosition_bottom_container_flex-direction": "{flexDirection.column}",
    spinner_variant_size_small_container_gap: $e3613f6017c674c5$var$spinner_variant_size_small_container_gap,
    "spinner_variant_size_small_spinner-container_size": "{m}",
    "spinner_variant_size_small_base-arc_arcWidth": "{xxs}",
    "spinner_variant_size_small_base-arc_radius": "{s}",
    "spinner_variant_size_small_normal-arc_arcWidth": "{xxs}",
    "spinner_variant_size_small_normal-arc_radius": "{s}",
    "spinner_variant_size_small_first-arc_arcWidth": "{xxs}",
    "spinner_variant_size_small_first-arc_radius": "{s}",
    "spinner_variant_size_small_second-arc_arcWidth": "{xxs}",
    "spinner_variant_size_small_second-arc_radius": "{s}",
    "spinner_variant_size_small_third-arc_arcWidth": "{xxs}",
    "spinner_variant_size_small_third-arc_radius": "{s}",
    "spinner_combination_false_inline_normal-arc_fill": "{primaryGrey80}",
    "spinner_combination_small_bottom_container_flex-direction": "{flexDirection.row}"
};
const $e3613f6017c674c5$var$selectorbutton_base_container_gap = "{xs}";
const $e3613f6017c674c5$var$selectorbutton_base_container_opacity = "{opacity.enabled}";
const $e3613f6017c674c5$var$selectorbutton_variant_disabled_true_container_opacity = "{opacity.disabled}";
const $e3613f6017c674c5$var$selectorbutton_combination_false_small_container_width = "{l}";
const $e3613f6017c674c5$var$selectorbutton_combination_false_small_container_height = "{l}";
const $e3613f6017c674c5$var$selectorbutton_combination_false_medium_container_width = "{xl}";
const $e3613f6017c674c5$var$selectorbutton_combination_false_medium_container_height = "{xl}";
const $e3613f6017c674c5$var$selectorbutton_combination_false_large_container_width = "{xxl}";
const $e3613f6017c674c5$var$selectorbutton_combination_false_large_container_height = "{xxl}";
const $e3613f6017c674c5$var$selectorbutton_combination_false_extra_large_container_width = "{huge}";
const $e3613f6017c674c5$var$selectorbutton_combination_false_extra_large_container_height = "{huge}";
const $e3613f6017c674c5$var$selectorbutton_combination_true_true_container_width = "{size.max}";
const $e3613f6017c674c5$var$SelectorButtonTokens = {
    "selectorbutton_base_container_background-color": "{primary50}",
    "selectorbutton_base_container_flex-direction": "{flexDirection.row}",
    "selectorbutton_base_container_justify-content": "{justifyContent.center}",
    "selectorbutton_base_container_align-items": "{alignItems.center}",
    "selectorbutton_base_container_border-radius": "{pill}",
    "selectorbutton_base_container_padding-bottom": "{xs}",
    "selectorbutton_base_container_padding-top": "{xs}",
    "selectorbutton_base_container_padding-left": "{base}",
    "selectorbutton_base_container_padding-right": "{base}",
    "selectorbutton_base_container_border-width": "{border_none}",
    selectorbutton_base_container_gap: $e3613f6017c674c5$var$selectorbutton_base_container_gap,
    selectorbutton_base_container_opacity: $e3613f6017c674c5$var$selectorbutton_base_container_opacity,
    "selectorbutton_base_container_behavior_hover_background-color": "{primary30}",
    "selectorbutton_base_container_behavior_active_background-color": "{primary60}",
    "selectorbutton_base_container_behavior_focus_border-width": "{border_focus}",
    "selectorbutton_base_container_behavior_focus_border-color": "{primary60}",
    "selectorbutton_base_left-icon_size": "{m}",
    "selectorbutton_base_left-icon_color": "{primaryInverse}",
    "selectorbutton_base_left-icon_behavior_hover_color": "{primary70}",
    "selectorbutton_base_right-icon_size": "{m}",
    "selectorbutton_base_right-icon_color": "{primaryInverse}",
    "selectorbutton_base_right-icon_behavior_hover_color": "{primary70}",
    selectorbutton_variant_disabled_true_container_opacity: $e3613f6017c674c5$var$selectorbutton_variant_disabled_true_container_opacity,
    "selectorbutton_combination_normal_primary_true_container_background-color": "{primary60}",
    "selectorbutton_combination_normal_primary_true_container_behavior_hover_background-color": "{primary50}",
    "selectorbutton_combination_normal_primary_true_container_behavior_active_background-color": "{primary70}",
    "selectorbutton_combination_normal_primary_true_container_behavior_focus_border-color": "{primary70}",
    "selectorbutton_combination_normal_secondary_false_container_background-color": "{global.transparent}",
    "selectorbutton_combination_normal_secondary_false_container_border-width": "{border_thin}",
    "selectorbutton_combination_normal_secondary_false_container_border-color": "{primaryGrey60}",
    "selectorbutton_combination_normal_secondary_false_container_behavior_hover_background-color": "{primary20}",
    "selectorbutton_combination_normal_secondary_false_container_behavior_hover_border-color": "{primary60}",
    "selectorbutton_combination_normal_secondary_false_container_behavior_active_background-color": "{primary20}",
    "selectorbutton_combination_normal_secondary_false_container_behavior_focus_border-width": "{border_focus}",
    "selectorbutton_combination_normal_secondary_false_container_behavior_focus_border-color": "{primary60}",
    "selectorbutton_combination_normal_secondary_false_left-icon_color": "{primary60}",
    "selectorbutton_combination_normal_secondary_false_right-icon_color": "{primary60}",
    "selectorbutton_combination_normal_secondary_true_container_background-color": "{primary20}",
    "selectorbutton_combination_normal_secondary_true_container_border-width": "{border_thin}",
    "selectorbutton_combination_normal_secondary_true_container_border-color": "{primaryGrey60}",
    "selectorbutton_combination_normal_secondary_true_container_behavior_hover_border-color": "{primary60}",
    "selectorbutton_combination_normal_secondary_true_container_behavior_active_background-color": "{primary30}",
    "selectorbutton_combination_normal_secondary_true_container_behavior_focus_border-width": "{border_focus}",
    "selectorbutton_combination_normal_secondary_true_container_behavior_focus_border-color": "{primary60}",
    "selectorbutton_combination_normal_secondary_true_left-icon_color": "{primary60}",
    "selectorbutton_combination_normal_secondary_true_left-icon_behavior_active_color": "{primary70}",
    "selectorbutton_combination_normal_secondary_true_right-icon_color": "{primary60}",
    "selectorbutton_combination_normal_secondary_true_right-icon_behavior_active_color": "{primary70}",
    "selectorbutton_combination_normal_tertiary_true_container_background-color": "{primary20}",
    "selectorbutton_combination_normal_tertiary_true_container_behavior_hover_background-color": "{primary20}",
    "selectorbutton_combination_normal_tertiary_true_container_behavior_hover_border-color": "{primary60}",
    "selectorbutton_combination_normal_tertiary_true_container_behavior_hover_border-width": "{border_thin}",
    "selectorbutton_combination_normal_tertiary_true_container_behavior_active_background-color": "{primary30}",
    "selectorbutton_combination_normal_tertiary_true_container_behavior_focus_border-width": "{border_focus}",
    "selectorbutton_combination_normal_tertiary_true_container_behavior_focus_border-color": "{primary60}",
    "selectorbutton_combination_normal_tertiary_true_left-icon_color": "{primary60}",
    "selectorbutton_combination_normal_tertiary_true_left-icon_behavior_active_color": "{primary70}",
    "selectorbutton_combination_normal_tertiary_true_left-icon_behavior_hover_color": "{primary60}",
    "selectorbutton_combination_normal_tertiary_true_right-icon_color": "{primary60}",
    "selectorbutton_combination_normal_tertiary_true_right-icon_behavior_active_color": "{primary70}",
    "selectorbutton_combination_normal_tertiary_true_right-icon_behavior_hover_color": "{primary60}",
    "selectorbutton_combination_normal_tertiary_false_container_background-color": "{global.transparent}",
    "selectorbutton_combination_normal_tertiary_false_container_behavior_hover_border-width": "{border_thin}",
    "selectorbutton_combination_normal_tertiary_false_container_behavior_hover_border-color": "{primary60}",
    "selectorbutton_combination_normal_tertiary_false_container_behavior_hover_background-color": "{primary20}",
    "selectorbutton_combination_normal_tertiary_false_container_behavior_active_background-color": "{primary20}",
    "selectorbutton_combination_normal_tertiary_false_left-icon_color": "{primary60}",
    "selectorbutton_combination_normal_tertiary_false_left-icon_behavior_active_color": "{primary60}",
    "selectorbutton_combination_normal_tertiary_false_left-icon_behavior_hover_color": "{primary60}",
    "selectorbutton_combination_normal_tertiary_false_right-icon_color": "{primary60}",
    "selectorbutton_combination_normal_tertiary_false_right-icon_behavior_active_color": "{primary60}",
    "selectorbutton_combination_normal_tertiary_false_right-icon_behavior_hover_color": "{primary60}",
    "selectorbutton_combination_normal_tertiary_narrow_true_container_background-color": "{global.transparent}",
    "selectorbutton_combination_normal_tertiary_narrow_true_container_behavior_focus_border-width": "{border_focus}",
    "selectorbutton_combination_normal_tertiary_narrow_true_container_behavior_focus_border-color": "{primary60}",
    "selectorbutton_combination_normal_tertiary_narrow_true_container_behavior_hover_background-color": "{global.transparent}",
    "selectorbutton_combination_normal_tertiary_narrow_true_container_behavior_active_background-color": "{global.transparent}",
    "selectorbutton_combination_normal_tertiary_narrow_true_left-icon_color": "{primary70}",
    "selectorbutton_combination_normal_tertiary_narrow_true_left-icon_behavior_hover_color": "{primary60}",
    "selectorbutton_combination_normal_tertiary_narrow_true_left-icon_behavior_active_color": "{primary80}",
    "selectorbutton_combination_normal_tertiary_narrow_true_right-icon_color": "{primary70}",
    "selectorbutton_combination_normal_tertiary_narrow_true_right-icon_behavior_hover_color": "{primary60}",
    "selectorbutton_combination_normal_tertiary_narrow_true_right-icon_behavior_active_color": "{primary80}",
    "selectorbutton_combination_normal_tertiary_narrow_false_container_background-color": "{global.transparent}",
    "selectorbutton_combination_normal_tertiary_narrow_false_container_behavior_hover_background-color": "{global.transparent}",
    "selectorbutton_combination_normal_tertiary_narrow_false_container_behavior_active_background-color": "{global.transparent}",
    "selectorbutton_combination_normal_tertiary_narrow_false_left-icon_color": "{primary60}",
    "selectorbutton_combination_normal_tertiary_narrow_false_left-icon_behavior_hover_color": "{primary50}",
    "selectorbutton_combination_normal_tertiary_narrow_false_left-icon_behavior_active_color": "{primary70}",
    "selectorbutton_combination_normal_tertiary_narrow_false_right-icon_color": "{primary60}",
    "selectorbutton_combination_normal_tertiary_narrow_false_right-icon_behavior_hover_color": "{primary50}",
    "selectorbutton_combination_normal_tertiary_narrow_false_right-icon_behavior_active_color": "{primary70}",
    "selectorbutton_combination_grey_scale_primary_false_container_background-color": "{primaryGrey80}",
    "selectorbutton_combination_grey_scale_primary_false_container_behavior_hover_background-color": "{primary30}",
    "selectorbutton_combination_grey_scale_primary_false_container_behavior_active_background-color": "{primary50}",
    "selectorbutton_combination_grey_scale_primary_false_container_behavior_focus_border-width": "{border_focus}",
    "selectorbutton_combination_grey_scale_primary_false_container_behavior_focus_border-color": "{primary60}",
    "selectorbutton_combination_grey_scale_primary_false_left-icon_color": "{primaryBackground}",
    "selectorbutton_combination_grey_scale_primary_false_left-icon_behavior_hover_color": "{primary70}",
    "selectorbutton_combination_grey_scale_primary_false_left-icon_behavior_active_color": "{primaryInverse}",
    "selectorbutton_combination_grey_scale_primary_false_right-icon_color": "{primaryBackground}",
    "selectorbutton_combination_grey_scale_primary_false_right-icon_behavior_hover_color": "{primary70}",
    "selectorbutton_combination_grey_scale_primary_false_right-icon_behavior_active_color": "{primaryInverse}",
    "selectorbutton_combination_grey_scale_secondary_false_container_background-color": "{global.transparent}",
    "selectorbutton_combination_grey_scale_secondary_false_container_border-width": "{border_thin}",
    "selectorbutton_combination_grey_scale_secondary_false_container_border-color": "{primaryGrey60}",
    "selectorbutton_combination_grey_scale_secondary_false_container_behavior_hover_background-color": "{primary20}",
    "selectorbutton_combination_grey_scale_secondary_false_container_behavior_hover_border-color": "{primary60}",
    "selectorbutton_combination_grey_scale_secondary_false_container_behavior_active_background-color": "{primary20}",
    "selectorbutton_combination_grey_scale_secondary_false_container_behavior_focus_border-width": "{border_focus}",
    "selectorbutton_combination_grey_scale_secondary_false_container_behavior_focus_border-color": "{primary60}",
    "selectorbutton_combination_grey_scale_secondary_false_left-icon_color": "{primaryGrey80}",
    "selectorbutton_combination_grey_scale_secondary_false_right-icon_color": "{primaryGrey80}",
    "selectorbutton_combination_grey_scale_secondary_true_container_background-color": "{primary20}",
    "selectorbutton_combination_grey_scale_secondary_true_container_border-color": "{primaryGrey60}",
    "selectorbutton_combination_grey_scale_secondary_true_container_behavior_hover_border-color": "{primary60}",
    "selectorbutton_combination_grey_scale_secondary_true_container_behavior_active_background-color": "{primary30}",
    "selectorbutton_combination_grey_scale_secondary_true_container_behavior_focus_border-width": "{border_focus}",
    "selectorbutton_combination_grey_scale_secondary_true_container_behavior_focus_border-color": "{primary60}",
    "selectorbutton_combination_grey_scale_secondary_true_left-icon_color": "{primary60}",
    "selectorbutton_combination_grey_scale_secondary_true_left-icon_behavior_active_color": "{primary70}",
    "selectorbutton_combination_grey_scale_secondary_true_right-icon_color": "{primary60}",
    "selectorbutton_combination_grey_scale_secondary_true_right-icon_behavior_active_color": "{primary70}",
    "selectorbutton_combination_grey_scale_tertiary_true_container_background-color": "{primary20}",
    "selectorbutton_combination_grey_scale_tertiary_true_container_behavior_hover_border-color": "{primary60}",
    "selectorbutton_combination_grey_scale_tertiary_true_container_behavior_hover_border-width": "{border_thin}",
    "selectorbutton_combination_grey_scale_tertiary_true_container_behavior_active_background-color": "{primary30}",
    "selectorbutton_combination_grey_scale_tertiary_true_container_behavior_focus_border-width": "{border_focus}",
    "selectorbutton_combination_grey_scale_tertiary_true_container_behavior_focus_border-color": "{primary60}",
    "selectorbutton_combination_grey_scale_tertiary_true_left-icon_color": "{primary60}",
    "selectorbutton_combination_grey_scale_tertiary_true_left-icon_behavior_active_color": "{primary70}",
    "selectorbutton_combination_grey_scale_tertiary_true_right-icon_color": "{primary60}",
    "selectorbutton_combination_grey_scale_tertiary_true_right-icon_behavior_active_color": "{primary70}",
    "selectorbutton_combination_grey_scale_tertiary_false_container_background-color": "{global.transparent}",
    "selectorbutton_combination_grey_scale_tertiary_false_container_behavior_hover_border-color": "{primary60}",
    "selectorbutton_combination_grey_scale_tertiary_false_container_behavior_hover_border-width": "{border_thin}",
    "selectorbutton_combination_grey_scale_tertiary_false_container_behavior_hover_background-color": "{primary20}",
    "selectorbutton_combination_grey_scale_tertiary_false_container_behavior_active_background-color": "{primary20}",
    "selectorbutton_combination_grey_scale_tertiary_false_container_behavior_focus_border-width": "{border_focus}",
    "selectorbutton_combination_grey_scale_tertiary_false_container_behavior_focus_border-color": "{primary60}",
    "selectorbutton_combination_grey_scale_tertiary_false_left-icon_color": "{primaryGrey80}",
    "selectorbutton_combination_grey_scale_tertiary_false_left-icon_hover_color": "{primary60}",
    "selectorbutton_combination_grey_scale_tertiary_false_left-icon_active_color": "{primary60}",
    "selectorbutton_combination_grey_scale_tertiary_false_right-icon_color": "{primaryGrey80}",
    "selectorbutton_combination_grey_scale_tertiary_false_right-icon_hover_color": "{primary60}",
    "selectorbutton_combination_grey_scale_tertiary_false_right-icon_active_color": "{primary60}",
    "selectorbutton_combination_grey_scale_tertiary_narrow_true_container_background-color": "{global.transparent}",
    "selectorbutton_combination_grey_scale_tertiary_narrow_true_container_behavior_hover_background-color": "{global.transparent}",
    "selectorbutton_combination_grey_scale_tertiary_narrow_true_container_behavior_focus_border-width": "{border_focus}",
    "selectorbutton_combination_grey_scale_tertiary_narrow_true_container_behavior_focus_border-color": "{primary60}",
    "selectorbutton_combination_grey_scale_tertiary_narrow_true_left-icon_color": "{primary60}",
    "selectorbutton_combination_grey_scale_tertiary_narrow_true_left-icon_behavior_hover_color": "{primary50}",
    "selectorbutton_combination_grey_scale_tertiary_narrow_true_left-icon_behavior_active_color": "{primary80}",
    "selectorbutton_combination_grey_scale_tertiary_narrow_true_right-icon_color": "{primary60}",
    "selectorbutton_combination_grey_scale_tertiary_narrow_true_right-icon_behavior_hover_color": "{primary50}",
    "selectorbutton_combination_grey_scale_tertiary_narrow_true_right-icon_behavior_active_color": "{primary80}",
    "selectorbutton_combination_grey_scale_tertiary_narrow_false_container_background-color": "{global.transparent}",
    "selectorbutton_combination_grey_scale_tertiary_narrow_false_container_behavior_hover_background-color": "{global.transparent}",
    "selectorbutton_combination_grey_scale_tertiary_narrow_false_container_behavior_focus_border-width": "{border_focus}",
    "selectorbutton_combination_grey_scale_tertiary_narrow_false_container_behavior_focus_border-color": "{primary60}",
    "selectorbutton_combination_grey_scale_tertiary_narrow_false_left-icon_color": "{primaryGrey80}",
    "selectorbutton_combination_grey_scale_tertiary_narrow_false_left-icon_behavior_hover_color": "{primary50}",
    "selectorbutton_combination_grey_scale_tertiary_narrow_false_left-icon_behavior_active_color": "{primary60}",
    "selectorbutton_combination_grey_scale_tertiary_narrow_false_right-icon_color": "{primaryGrey80}",
    "selectorbutton_combination_grey_scale_tertiary_narrow_false_right-icon_behavior_hover_color": "{primary50}",
    "selectorbutton_combination_grey_scale_tertiary_narrow_false_right-icon_behavior_active_color": "{primary60}",
    "selectorbutton_combination_contrast_primary_false_container_background-color": "{primaryBackground}",
    "selectorbutton_combination_contrast_primary_false_container_behavior_hover_background-color": "{primary30}",
    "selectorbutton_combination_contrast_primary_false_container_behavior_active_background-color": "{primary50}",
    "selectorbutton_combination_contrast_primary_false_container_behavior_focus_border-width": "{border_focus}",
    "selectorbutton_combination_contrast_primary_false_container_behavior_focus_border-color": "{primary50}",
    "selectorbutton_combination_contrast_primary_false_left-icon_color": "{primaryGrey100}",
    "selectorbutton_combination_contrast_primary_false_left-icon_behavior_hover_color": "{primaryGrey100}",
    "selectorbutton_combination_contrast_primary_false_left-icon_behavior_focus_color": "{primaryGrey100}",
    "selectorbutton_combination_contrast_primary_false_left-icon_behavior_active_color": "{primaryInverse}",
    "selectorbutton_combination_contrast_primary_false_right-icon_color": "{primaryGrey100}",
    "selectorbutton_combination_contrast_primary_false_right-icon_behavior_hover_color": "{primaryGrey100}",
    "selectorbutton_combination_contrast_primary_false_right-icon_behavior_focus_color": "{primaryGrey100}",
    "selectorbutton_combination_contrast_primary_false_right-icon_behavior_active_color": "{primaryInverse}",
    "selectorbutton_combination_contrast_primary_true_container_background-color": "{primary50}",
    "selectorbutton_combination_contrast_primary_true_container_behavior_hover_background-color": "{primary30}",
    "selectorbutton_combination_contrast_primary_true_container_behavior_active_background-color": "{primary60}",
    "selectorbutton_combination_contrast_primary_true_container_behavior_focus_background-color": "{primary50}",
    "selectorbutton_combination_contrast_primary_true_container_behavior_focus_border-width": "{border_focus}",
    "selectorbutton_combination_contrast_primary_true_container_behavior_focus_border-color": "{primary40}",
    "selectorbutton_combination_contrast_primary_true_left-icon_color": "{primaryInverse}",
    "selectorbutton_combination_contrast_primary_true_left-icon_behavior_hover_color": "{primaryGrey100}",
    "selectorbutton_combination_contrast_primary_true_right-icon_color": "{primaryInverse}",
    "selectorbutton_combination_contrast_primary_true_right-icon_behavior_hover_color": "{primaryGrey100}",
    "selectorbutton_combination_contrast_secondary_false_container_background-color": "{global.transparent}",
    "selectorbutton_combination_contrast_secondary_false_container_border-width": "{border_thin}",
    "selectorbutton_combination_contrast_secondary_false_container_border-color": "{primaryGrey60}",
    "selectorbutton_combination_contrast_secondary_false_container_behavior_hover_background-color": "{primary30}",
    "selectorbutton_combination_contrast_secondary_false_container_behavior_hover_border-color": "{primary50}",
    "selectorbutton_combination_contrast_secondary_false_container_behavior_active_background-color": "{primary30}",
    "selectorbutton_combination_contrast_secondary_false_container_behavior_focus_border-width": "{border_focus}",
    "selectorbutton_combination_contrast_secondary_false_container_behavior_focus_border-color": "{primary50}",
    "selectorbutton_combination_contrast_secondary_false_left-icon_color": "{primaryBackground}",
    "selectorbutton_combination_contrast_secondary_false_left-icon_behavior_hover_color": "{primaryGrey100}",
    "selectorbutton_combination_contrast_secondary_false_left-icon_behavior_active_color": "{primaryGrey100}",
    "selectorbutton_combination_contrast_secondary_false_right-icon_color": "{primaryBackground}",
    "selectorbutton_combination_contrast_secondary_false_right-icon_behavior_hover_color": "{primaryGrey100}",
    "selectorbutton_combination_contrast_secondary_false_right-icon_behavior_active_color": "{primaryGrey100}",
    "selectorbutton_combination_contrast_secondary_true_container_background-color": "{primary30}",
    "selectorbutton_combination_contrast_secondary_true_container_border-color": "{primaryGrey60}",
    "selectorbutton_combination_contrast_secondary_true_container_behavior_hover_border-color": "{primary50}",
    "selectorbutton_combination_contrast_secondary_true_container_behavior_active_background-color": "{primary50}",
    "selectorbutton_combination_contrast_secondary_true_container_behavior_focus_border-width": "{border_focus}",
    "selectorbutton_combination_contrast_secondary_true_container_behavior_focus_border-color": "{primary50}",
    "selectorbutton_combination_contrast_secondary_true_left-icon_color": "{primaryGrey100}",
    "selectorbutton_combination_contrast_secondary_true_left-icon_behavior_active_color": "{primaryInverse}",
    "selectorbutton_combination_contrast_secondary_true_right-icon_color": "{primaryGrey100}",
    "selectorbutton_combination_contrast_secondary_true_right-icon_behavior_active_color": "{primaryInverse}",
    "selectorbutton_combination_contrast_tertiary_false_container_background-color": "{global.transparent}",
    "selectorbutton_combination_contrast_tertiary_false_container_behavior_hover_background-color": "{primary30}",
    "selectorbutton_combination_contrast_tertiary_false_container_behavior_hover_border-color": "{primary50}",
    "selectorbutton_combination_contrast_tertiary_false_container_behavior_active_background-color": "{primary30}",
    "selectorbutton_combination_contrast_tertiary_false_container_behavior_focus_border-width": "{border_focus}",
    "selectorbutton_combination_contrast_tertiary_false_container_behavior_focus_border-color": "{primary50}",
    "selectorbutton_combination_contrast_tertiary_false_left-icon_color": "{primaryBackground}",
    "selectorbutton_combination_contrast_tertiary_false_left-icon_behavior_hover_color": "{primaryGrey100}",
    "selectorbutton_combination_contrast_tertiary_false_left-icon_behavior_active_color": "{primaryGrey100}",
    "selectorbutton_combination_contrast_tertiary_false_right-icon_color": "{primaryBackground}",
    "selectorbutton_combination_contrast_tertiary_false_right-icon_behavior_hover_color": "{primaryGrey100}",
    "selectorbutton_combination_contrast_tertiary_false_right-icon_behavior_active_color": "{primaryGrey100}",
    "selectorbutton_combination_contrast_tertiary_true_container_background-color": "{primary30}",
    "selectorbutton_combination_contrast_tertiary_true_container_behavior_hover_border-color": "{primary50}",
    "selectorbutton_combination_contrast_tertiary_true_container_behavior_focus_border-width": "{border_focus}",
    "selectorbutton_combination_contrast_tertiary_true_container_behavior_focus_border-color": "{primary50}",
    "selectorbutton_combination_contrast_tertiary_true_container_behavior_active_background-color": "{primary50}",
    "selectorbutton_combination_contrast_tertiary_true_left-icon_color": "{primaryGrey100}",
    "selectorbutton_combination_contrast_tertiary_true_left-icon_behavior_active_background-color": "{primaryInverse}",
    "selectorbutton_combination_contrast_tertiary_true_right-icon_color": "{primaryGrey100}",
    "selectorbutton_combination_contrast_tertiary_true_right-icon_behavior_active_background-color": "{primaryInverse}",
    "selectorbutton_combination_contrast_tertiary_narrow_false_container_background-color": "{global.transparent}",
    "selectorbutton_combination_contrast_tertiary_narrow_false_container_behavior_focus_border-width": "{border_focus}",
    "selectorbutton_combination_contrast_tertiary_narrow_false_container_behavior_focus_border-color": "{primary50}",
    "selectorbutton_combination_contrast_tertiary_narrow_false_container_behavior_hover_background-color": "{global.transparent}",
    "selectorbutton_combination_contrast_tertiary_narrow_false_container_behavior_active_background-color": "{global.transparent}",
    "selectorbutton_combination_contrast_tertiary_narrow_false_left-icon_color": "{primaryBackground}",
    "selectorbutton_combination_contrast_tertiary_narrow_false_left-icon_behavior_hover_color": "{primary20}",
    "selectorbutton_combination_contrast_tertiary_narrow_false_left-icon_behavior_active_color": "{primary30}",
    "selectorbutton_combination_contrast_tertiary_narrow_false_right-icon_color": "{primaryBackground}",
    "selectorbutton_combination_contrast_tertiary_narrow_false_right-icon_behavior_hover_color": "{primary20}",
    "selectorbutton_combination_contrast_tertiary_narrow_false_right-icon_behavior_active_color": "{primary30}",
    "selectorbutton_combination_contrast_tertiary_narrow_true_container_background-color": "{global.transparent}",
    "selectorbutton_combination_contrast_tertiary_narrow_true_container_behavior_focus_border-width": "{border_focus}",
    "selectorbutton_combination_contrast_tertiary_narrow_true_container_behavior_focus_border-color": "{primary50}",
    "selectorbutton_combination_contrast_tertiary_narrow_true_container_behavior_hover_background-color": "{global.transparent}",
    "selectorbutton_combination_contrast_tertiary_narrow_true_container_behavior_active_background-color": "{global.transparent}",
    "selectorbutton_combination_contrast_tertiary_narrow_true_left-icon_color": "{primary30}",
    "selectorbutton_combination_contrast_tertiary_narrow_true_left-icon_behavior_hover_color": "{primary20}",
    "selectorbutton_combination_contrast_tertiary_narrow_true_left-icon_behavior_active_color": "{primary30}",
    "selectorbutton_combination_contrast_tertiary_narrow_true_left-icon_behavior_focus_color": "{primary30}",
    "selectorbutton_combination_contrast_tertiary_narrow_true_right-icon_color": "{primary30}",
    "selectorbutton_combination_contrast_tertiary_narrow_true_right-icon_behavior_hover_color": "{primary20}",
    "selectorbutton_combination_contrast_tertiary_narrow_true_right-icon_behavior_active_color": "{primary30}",
    "selectorbutton_combination_contrast_tertiary_narrow_true_right-icon_behavior_focus_color": "{primary30}",
    "selectorbutton_combination_tertiary_narrow_small_container_padding-bottom": "{xxs}",
    "selectorbutton_combination_tertiary_narrow_small_container_padding-top": "{xxs}",
    "selectorbutton_combination_tertiary_narrow_medium_container_padding-bottom": "{xs}",
    "selectorbutton_combination_tertiary_narrow_medium_container_padding-top": "{xs}",
    "selectorbutton_combination_tertiary_narrow_large_container_padding-bottom": "{s}",
    "selectorbutton_combination_tertiary_narrow_large_container_padding-top": "{s}",
    "selectorbutton_combination_tertiary_narrow_extra_large_container_padding-bottom": "{base}",
    "selectorbutton_combination_tertiary_narrow_extra_large_container_padding-top": "{base}",
    "selectorbutton_combination_true_small_container_padding-top": "{xxs}",
    "selectorbutton_combination_true_small_container_padding-bottom": "{xxs}",
    "selectorbutton_combination_true_small_left-icon_size": "{base}",
    "selectorbutton_combination_true_small_right-icon_size": "{base}",
    "selectorbutton_combination_true_large_container_padding-top": "{s}",
    "selectorbutton_combination_true_large_container_padding-left": "{m}",
    "selectorbutton_combination_true_large_container_padding-bottom": "{s}",
    "selectorbutton_combination_true_large_container_padding-right": "{m}",
    "selectorbutton_combination_true_large_left-icon_size": "{m}",
    "selectorbutton_combination_true_large_right-icon_size": "{m}",
    "selectorbutton_combination_true_extra_large_container_padding-top": "{base}",
    "selectorbutton_combination_true_extra_large_container_padding-right": "{l}",
    "selectorbutton_combination_true_extra_large_container_padding-bottom": "{base}",
    "selectorbutton_combination_true_extra_large_container_padding-left": "{l}",
    "selectorbutton_combination_true_extra_large_left-icon_size": "{l}",
    "selectorbutton_combination_true_extra_large_right-icon_size": "{l}",
    selectorbutton_combination_false_small_container_width: $e3613f6017c674c5$var$selectorbutton_combination_false_small_container_width,
    selectorbutton_combination_false_small_container_height: $e3613f6017c674c5$var$selectorbutton_combination_false_small_container_height,
    "selectorbutton_combination_false_small_left-icon_size": "{base}",
    selectorbutton_combination_false_medium_container_width: $e3613f6017c674c5$var$selectorbutton_combination_false_medium_container_width,
    selectorbutton_combination_false_medium_container_height: $e3613f6017c674c5$var$selectorbutton_combination_false_medium_container_height,
    selectorbutton_combination_false_large_container_width: $e3613f6017c674c5$var$selectorbutton_combination_false_large_container_width,
    selectorbutton_combination_false_large_container_height: $e3613f6017c674c5$var$selectorbutton_combination_false_large_container_height,
    "selectorbutton_combination_false_large_left-icon_size": "{m}",
    selectorbutton_combination_false_extra_large_container_width: $e3613f6017c674c5$var$selectorbutton_combination_false_extra_large_container_width,
    selectorbutton_combination_false_extra_large_container_height: $e3613f6017c674c5$var$selectorbutton_combination_false_extra_large_container_height,
    "selectorbutton_combination_false_extra_large_left-icon_size": "{l}",
    selectorbutton_combination_true_true_container_width: $e3613f6017c674c5$var$selectorbutton_combination_true_true_container_width,
    "selectorbutton_combination_true_true_container_justify-content": "{justifyContent.spaceBetween}",
    "selectorbutton_combination_grey_scale_secondary_false_left-icon_behavior_hover_color": "{primary60}",
    "selectorbutton_combination_grey_scale_secondary_false_right-icon_behavior_hover_color": "{primary60}"
};
const $e3613f6017c674c5$var$HorizontalStepItemTokens = {
    "horizontalstepitem_base_stepper-outer-container_flex-direction": "{flexDirection.column}",
    "horizontalstepitem_base_stepper-outer-container_align-items": "{alignItems.center}",
    "horizontalstepitem_base_stepper-outer-container_justify-content": "{justifyContent.start}",
    "horizontalstepitem_base_stepper-outer-container_size": "{size.max}",
    "horizontalstepitem_base_stepper-outer-container_gap": "{xs}",
    "horizontalstepitem_base_stepper-inner-container_flex-direction": "{flexDirection.row}",
    "horizontalstepitem_base_stepper-inner-container_width": "{size.max}",
    "horizontalstepitem_base_stepper-inner-container_align-items": "{alignItems.center}",
    "horizontalstepitem_base_stepper-inner-container_gap": "{xs}",
    "horizontalstepitem_base_label-jds_text_padding-right": "{xs}",
    "horizontalstepitem_base_label-jds_text_padding-left": "{xs}",
    "horizontalstepitem_base_start-jds_divider_opacity": "{opacity.enabled}",
    "horizontalstepitem_base_end-jds_divider_opacity": "{opacity.enabled}",
    "horizontalstepitem_variant_direction_start_end-jds_divider_opacity": "{opacity.invisible}",
    "horizontalstepitem_variant_direction_end_start-jds_divider_opacity": "{opacity.invisible}"
};
const $e3613f6017c674c5$var$stepperdot_base_icon_color = "{sparkleGrey60}";
const $e3613f6017c674c5$var$stepperdot_base_icon_size = "{base}";
const $e3613f6017c674c5$var$stepperdot_combination_warning_active_icon_color = "{sparkle60}";
const $e3613f6017c674c5$var$stepperdot_combination_warning_complete_icon_color = "{sparkle60}";
const $e3613f6017c674c5$var$StepperDotTokens = {
    "stepperdot_base_step-icon-container_background-color": "{global.transparent}",
    "stepperdot_base_step-icon-container_border-width": "{border_thin}",
    "stepperdot_base_step-icon-container_border-color": "{sparkleGrey60}",
    "stepperdot_base_step-icon-container_min-height": "{l}",
    "stepperdot_base_step-icon-container_min-width": "{l}",
    "stepperdot_base_step-icon-container_justify-content": "{justifyContent.center}",
    "stepperdot_base_step-icon-container_align-items": "{alignItems.center}",
    "stepperdot_base_step-icon-container_border-radius": "{pill}",
    stepperdot_base_icon_color: $e3613f6017c674c5$var$stepperdot_base_icon_color,
    stepperdot_base_icon_size: $e3613f6017c674c5$var$stepperdot_base_icon_size,
    "stepperdot_base_complete-icon_color": "{sparkle60}",
    "stepperdot_base_complete-icon_size": "{base}",
    "stepperdot_base_dot-container_background-color": "{sparkleGrey60}",
    "stepperdot_base_dot-container_width": "{xs}",
    "stepperdot_base_dot-container_height": "{xs}",
    "stepperdot_base_dot-container_border-radius": "{pill}",
    "stepperdot_variant_state_active_step-icon-container_background-color": "{sparkle50}",
    "stepperdot_variant_state_active_step-icon-container_border-color": "{sparkle50}",
    "stepperdot_variant_state_active_icon-color": "{sparkleInverse}",
    "stepperdot_variant_state_active_dot-container_background-color": "{sparkleInverse}",
    "stepperdot_variant_state_complete_step-icon-container_background-color": "{sparkle20}",
    "stepperdot_variant_state_complete_step-icon-container_border-color": "{sparkle50}",
    "stepperdot_variant_itemsType_icon_step-icon-container_height": "{l}",
    "stepperdot_variant_itemsType_icon_step-icon-container_width": "{l}",
    stepperdot_combination_warning_active_icon_color: $e3613f6017c674c5$var$stepperdot_combination_warning_active_icon_color,
    stepperdot_combination_warning_complete_icon_color: $e3613f6017c674c5$var$stepperdot_combination_warning_complete_icon_color,
    "stepperdot_variant_state_disabled_step-icon-container_opacity": "{opacity.disabled}"
};
const $e3613f6017c674c5$var$VerticalStepItemTokens = {
    "verticalstepitem_base_stepper-outer-container_flex-direction": "{flexDirection.column}",
    "verticalstepitem_base_stepper-outer-container_justify-content": "{justifyContent.start}",
    "verticalstepitem_base_stepper-outer-container_align-items": "{alignItems.start}",
    "verticalstepitem_base_stepper-outer-container_gap": "{xs}",
    "verticalstepitem_base_stepper-outer-container_size": "{size.max}",
    "verticalstepitem_base_end-container_opacity": "{opacity.enabled}",
    "verticalstepitem_base_content-child-container_flex-direction": "{flexDirection.row}",
    "verticalstepitem_base_content-child-container_justify-content": "{justifyContent.start}",
    "verticalstepitem_base_content-child-container_align-items": "{alignItems.center}",
    "verticalstepitem_base_step-indicator-container_height": "{intrinsicSize.max}",
    "verticalstepitem_base_step-indicator-container_flex-direction": "{flexDirection.row}",
    "verticalstepitem_base_step-indicator-container_justify-content": "{justifyContent.start}",
    "verticalstepitem_base_step-indicator-container_align-items": "{alignItems.stretch}",
    "verticalstepitem_base_step-indicator-container_min-height": "{l}",
    "verticalstepitem_base_step-indicator-container_padding-left": "{custom_23}",
    "verticalstepitem_base_step-dot-container_flex-direction": "{flexDirection.row}",
    "verticalstepitem_base_step-dot-container_justify-content": "{justifyContent.start}",
    "verticalstepitem_base_step-dot-container_align-items": "{alignItems.center}",
    "verticalstepitem_base_step-dot-container_gap": "{base}",
    "verticalstepitem_base_content-container_padding-top": "0",
    "verticalstepitem_base_content-container_padding-bottom": "0",
    "verticalstepitem_base_content-container_padding-left": "{custom_24}",
    "verticalstepitem__hideChild_true_content-container_padding-top": "{xs}",
    "verticalstepitem__hideChild_true_content-container_padding-bottom": "{m}",
    "verticalstepitem_variant_direction_start_end-jds_divider_opacity": "{opacity.invisible}"
};
const $e3613f6017c674c5$var$verticalstepper_base_container_size = "{size.max}";
const $e3613f6017c674c5$var$verticalstepper_base_container_gap = "{xs}";
const $e3613f6017c674c5$var$VerticalStepperTokens = {
    "verticalstepper_base_container_flex-direction": "{flexDirection.column}",
    "verticalstepper_base_container_justify-content": "{justifyContent.start}",
    "verticalstepper_base_container_align-items": "{alignItems.start}",
    verticalstepper_base_container_size: $e3613f6017c674c5$var$verticalstepper_base_container_size,
    verticalstepper_base_container_gap: $e3613f6017c674c5$var$verticalstepper_base_container_gap
};
const $e3613f6017c674c5$var$horizontalstepper_base_container_gap = "{stepper_horizontal}";
const $e3613f6017c674c5$var$horizontalstepper_base_container_size = "{size.max}";
const $e3613f6017c674c5$var$HorizontalStepperTokens = {
    horizontalstepper_base_container_gap: $e3613f6017c674c5$var$horizontalstepper_base_container_gap,
    "horizontalstepper_base_container_flex-direction": "{flexDirection.column}",
    horizontalstepper_base_container_size: $e3613f6017c674c5$var$horizontalstepper_base_container_size,
    "horizontalstepper_base_step-indicator-container_flex-direction": "{flexDirection.row}",
    "horizontalstepper_base_step-indicator-container_justify-content": "{justifyContent.center}",
    "horizontalstepper_base_step-indicator-container_align-items": "{alignItems.center}",
    "horizontalstepper_base_step-indicator-container_size": "{size.max}",
    "horizontalstepper_base_step-indicator-container_padding-left": "{l}",
    "horizontalstepper_base_step-indicator-container_padding-right": "{l}",
    "horizontalstepper_base_stepper-children-container_size": "{size.max}",
    "horizontalstepper_base_stepper-children-container_flex-direction": "{flexDirection.row}",
    "horizontalstepper_base_stepper-children-container_justify-content": "{justifyContent.start}",
    "horizontalstepper_base_stepper-children-container_align-items": "{alignItems.center}"
};
const $e3613f6017c674c5$var$tablebody_base_container_width = "{size.max}";
const $e3613f6017c674c5$var$tablebody_variant_fullWidth_container_width = "{size.max}";
const $e3613f6017c674c5$var$TableBodyTokens = {
    tablebody_base_container_width: $e3613f6017c674c5$var$tablebody_base_container_width,
    "tablebody_base_container_flex-direction": "{flexDirection.row}",
    tablebody_variant_fullWidth_container_width: $e3613f6017c674c5$var$tablebody_variant_fullWidth_container_width
};
const $e3613f6017c674c5$var$table_base_container_width = "{size.max}";
const $e3613f6017c674c5$var$table_variant_fullWidth_container_width = "{size.max}";
const $e3613f6017c674c5$var$TableTokens = {
    "table_base_container_flex-direction": "{flexDirection.column}",
    table_base_container_width: $e3613f6017c674c5$var$table_base_container_width,
    "table_base_container_border-radius": "{medium}",
    "table_base_container_border-width": "{border_thin}",
    "table_base_container_border-color": "{primaryGrey40}",
    table_variant_fullWidth_container_width: $e3613f6017c674c5$var$table_variant_fullWidth_container_width,
    "table_base_container_align-items": "{alignItems.start}",
    "table_base_footer-jds_text_padding-left": "{base}",
    "table_base_footer-jds_text_padding-right": "{base}",
    "table_base_footer-jds_text_padding-top": "{base}",
    "table_base_footer-jds_text_padding-bottom": "{base}",
    "table_variant_density_condensed_footer-jds_text_padding-left": "{xs}",
    "table_variant_density_condensed_footer-jds_text_padding-right": "{xs}",
    "table_variant_density_condensed_footer-jds_text_padding-top": "{xs}",
    "table_variant_density_condensed_footer-jds_text_padding-bottom": "{xs}"
};
const $e3613f6017c674c5$var$tablerow_base_container_width = "{size.max}";
const $e3613f6017c674c5$var$tablerow_variant_fullWidth_container_width = "{size.max}";
const $e3613f6017c674c5$var$TableRowTokens = {
    "tablerow_base_container_flex-direction": "{flexDirection.column}",
    tablerow_base_container_width: $e3613f6017c674c5$var$tablerow_base_container_width,
    tablerow_variant_fullWidth_container_width: $e3613f6017c674c5$var$tablerow_variant_fullWidth_container_width
};
const $e3613f6017c674c5$var$tablecell_base_container_width = "{size.max}";
const $e3613f6017c674c5$var$TableCellTokens = {
    "tablecell_base_container_flex-direction": "{flexDirection.row}",
    "tablecell_base_container_justify-content": "{justifyContent.start}",
    "tablecell_base_container_align-items": "{alignItems.center}",
    "tablecell_base_container_background-color": "{global.transparent}",
    "tablecell_base_container_padding-left": "{base}",
    "tablecell_base_container_padding-right": "{base}",
    "tablecell_base_container_padding-top": "{base}",
    "tablecell_base_container_padding-bottom": "{base}",
    "tablecell_base_container_border-color": "{primaryGrey40}",
    tablecell_base_container_width: $e3613f6017c674c5$var$tablecell_base_container_width,
    "tablecell_variant_density_condensed_container_padding-left": "{xs}",
    "tablecell_variant_density_condensed_container_padding-right": "{xs}",
    "tablecell_variant_density_condensed_container_padding-top": "{xs}",
    "tablecell_variant_density_condensed_container_padding-bottom": "{xs}",
    "tablecell_variant_columnDivider_true_container_border-color": "{primaryGrey40}",
    "tablecell_variant_columnDivider_true_container_border-right-width": 1,
    "tablecell_combination_header_true_container_background-color": "{primary50}",
    "tablecell_combination_header_true_container_border-color": "{primary60}",
    "tablecell_combination_cell_true_container_background-color": "{primaryGrey20}",
    "tablecell_combination_header_true_container_border-bottom-width": 1,
    "tablecell_combination_header_false_container_border-bottom-width": 4,
    "tablecell_combination_cell_true_container_border-bottom-width": 0
};
const $e3613f6017c674c5$var$tabbar_base_container_width = "{size.max}";
const $e3613f6017c674c5$var$TabBarTokens = {
    "tabbar_base_container_flex-direction": "{flexDirection.stack}",
    tabbar_base_container_width: $e3613f6017c674c5$var$tabbar_base_container_width,
    "tabbar_base_indicator-container_width": "{size.max}",
    "tabbar_base_container_justify-content": "{justifyContent.start}",
    "tabbar_base_container_align-items": "{alignItems.end}",
    "tabbar_base_tab-container_width": "{size.max}",
    "tabbar_base_tab-container_opacity": "{opacity.enabled}",
    "tabbar_base_tab-container_background-color": "{global.transparent}",
    "tabbar_base_tab-container_align-items": "{alignItems.center}",
    "tabbar_base_tab-container_justify-content": "{justifyContent.start}",
    "tabbar_base_tab-container_gap": "{xxs}",
    "tabbar_base_tab-container_flex-direction": "{flexDirection.row}",
    "tabbar_base_outer-container_flex-direction": "{flexDirection.row}",
    "tabbar_base_outer-container_justify-content": "{justifyContent.start}",
    "tabbar_base_outer-container_align-items": "{alignItems.center}",
    "tabbar_base_outer-container_width": "{size.max}",
    "tabbar_base_inner-container_border-radius": "{pill}",
    "tabbar_base_inner-container_background-color": "{primary50}",
    "tabbar_base_inner-container_height": "{xxs}",
    "tabbar_variant_overflow_fit_tab-container_width": "{size.max}",
    "tabbar_variant_overflow_fit_tab-container_justify-content": "{justifyContent.center}",
    "tabbar_variant_appearance_tab_bar_tab-container_background-color": "{primary60}",
    "tabbar_variant_appearance_tab_bar_tab-container_padding-right": "{xxl}",
    "tabbar_variant_appearance_tab_bar_tab-container_padding-left": "{xxl}",
    "tabbar_variant_appearance_tab_bar_inner-container_background-color": "{custom_dark_primary_60}",
    "tabbar_combination_mobile_tab_bar_tab-container_padding-right": "{m}",
    "tabbar_combination_mobile_tab_bar_tab-container_padding-left": "{m}"
};
const $e3613f6017c674c5$var$tag_base_container_gap = "{xxs}";
const $e3613f6017c674c5$var$tag_base_icon_size = "{base}";
const $e3613f6017c674c5$var$tag_base_icon_color = "{primaryGrey100}";
const $e3613f6017c674c5$var$tag_base_icon_behavior_hover_color = "{sparkle80}";
const $e3613f6017c674c5$var$tag_base_icon_behavior_active_color = "{sparkle80}";
const $e3613f6017c674c5$var$tag_base_icon_behavior_focus_color = "{sparkle80}";
const $e3613f6017c674c5$var$tag_variant_active_true_icon_color = "{sparkle80}";
const $e3613f6017c674c5$var$tag_variant_disabled_true_container_opacity = "{opacity.disabled}";
const $e3613f6017c674c5$var$tag_base_container_opacity = "{opacity.enabled}";
const $e3613f6017c674c5$var$TagTokens = {
    "tag_base_container_flex-direction": "{flexDirection.row}",
    "tag_base_container_justify-content": "{justifyContent.start}",
    "tag_base_container_align-items": "{alignItems.center}",
    "tag_base_container_padding-top": "{xxs}",
    "tag_base_container_padding-left": "{s}",
    "tag_base_container_padding-right": "{s}",
    "tag_base_container_padding-bottom": "{xxs}",
    tag_base_container_gap: $e3613f6017c674c5$var$tag_base_container_gap,
    "tag_base_container_background-color": "{global.transparent}",
    "tag_base_container_border-radius": "{pill}",
    "tag_base_container_border-width": "{border_thin}",
    "tag_base_container_border-color": "{primaryGrey80}",
    "tag_base_container_behavior_hover_border-color": "{primaryGrey80}",
    "tag_base_container_behavior_active_border-color": "{sparkle20}",
    "tag_base_container_behavior_focus_border-color": "{sparkle80}",
    "tag_base_container_behavior_focus_border-width": "{border_focus}",
    tag_base_icon_size: $e3613f6017c674c5$var$tag_base_icon_size,
    tag_base_icon_color: $e3613f6017c674c5$var$tag_base_icon_color,
    tag_base_icon_behavior_hover_color: $e3613f6017c674c5$var$tag_base_icon_behavior_hover_color,
    tag_base_icon_behavior_active_color: $e3613f6017c674c5$var$tag_base_icon_behavior_active_color,
    tag_base_icon_behavior_focus_color: $e3613f6017c674c5$var$tag_base_icon_behavior_focus_color,
    "tag_variant_active_true_container_border-width": "{border_none}",
    "tag_variant_active_true_container_border-color": "{primaryGrey80}",
    "tag_variant_active_true_container_background-color": "{sparkle20}",
    "tag_variant_active_true_container_behavior_hover_background-color": "{sparkle30}",
    "tag_variant_active_true_container_behavior_active_background-color": "{global.transparent}",
    "tag_variant_active_true_container_behavior_active_border-color": "{primaryGrey40}",
    "tag_variant_active_true_container_behavior_focus_background-color": "{sparkle30}",
    tag_variant_active_true_icon_color: $e3613f6017c674c5$var$tag_variant_active_true_icon_color,
    tag_variant_disabled_true_container_opacity: $e3613f6017c674c5$var$tag_variant_disabled_true_container_opacity,
    tag_base_container_opacity: $e3613f6017c674c5$var$tag_base_container_opacity,
    "tag_variant_size_small_container_padding-top": "{custom_4}",
    "tag_variant_size_small_container_padding-left": "{xs}",
    "tag_variant_size_small_container_padding-right": "{xs}",
    "tag_variant_size_small_container_padding-bottom": "{custom_4}"
};
const $e3613f6017c674c5$var$tabsdesktop_base_container_width = "{size.max}";
const $e3613f6017c674c5$var$tabsdesktop_base_jds_tab_bar_width = "{size.max}";
const $e3613f6017c674c5$var$TabsDesktopTokens = {
    "tabsdesktop_base_container_flex-direction": "{flexDirection.column}",
    tabsdesktop_base_container_width: $e3613f6017c674c5$var$tabsdesktop_base_container_width,
    tabsdesktop_base_jds_tab_bar_width: $e3613f6017c674c5$var$tabsdesktop_base_jds_tab_bar_width,
    "tabsdesktop_base_header-container_flex-direction": "{flexDirection.row}",
    "tabsdesktop_base_header-container_width": "{size.max}",
    "tabsdesktop_base_header-container_align-items": "{alignItems.center}",
    "tabsdesktop_base_tablist-container_width": "{size.max}",
    "tabsdesktop_variant_overflow_arrows_header-container_gap": "{base}",
    "tabsdesktop_variant_appearance_tab_bar_header-container_background-color": "{primary60}"
};
const $e3613f6017c674c5$var$tabitem_base_container_gap = "{xs}";
const $e3613f6017c674c5$var$tabitem_base_icon_size = "{m}";
const $e3613f6017c674c5$var$tabitem_base_icon_color = "{primaryGrey80}";
const $e3613f6017c674c5$var$tabitem_base_icon_behavior_hover_color = "{primaryGrey100}";
const $e3613f6017c674c5$var$tabitem_base_icon_behavior_active_color = "{primary60}";
const $e3613f6017c674c5$var$tabitem_base_text_color = "{primaryGrey80}";
const $e3613f6017c674c5$var$tabitem_base_text_behavior_hover_color = "{primary60}";
const $e3613f6017c674c5$var$tabitem_variant_appearance_normal_text_behavior_hover_color = "{primaryGrey100}";
const $e3613f6017c674c5$var$tabitem_variant_appearance_normal_text_behavior_active_color = "{primary60}";
const $e3613f6017c674c5$var$tabitem_variant_appearance_tab_bar_icon_color = "{custom_dark_primary_grey_100}";
const $e3613f6017c674c5$var$tabitem_variant_appearance_tab_bar_icon_behavior_hover_color = "{custom_dark_primary_grey_80}";
const $e3613f6017c674c5$var$tabitem_variant_appearance_tab_bar_icon_behavior_active_color = "{custom_dark_primary_grey_100}";
const $e3613f6017c674c5$var$tabitem_variant_appearance_tab_bar_text_color = "{custom_dark_primary_grey_100}";
const $e3613f6017c674c5$var$tabitem_variant_appearance_tab_bar_text_behavior_hover_color = "{custom_dark_primary_grey_80}";
const $e3613f6017c674c5$var$tabitem_variant_appearance_tab_bar_text_behavior_active_color = "{custom_dark_primary_grey_100}";
const $e3613f6017c674c5$var$tabitem_combination_active_normal_icon_color = "{primaryGrey100}";
const $e3613f6017c674c5$var$tabitem_combination_active_normal_text_color = "{primaryGrey100}";
const $e3613f6017c674c5$var$TabItemTokens = {
    "tabitem_base_outer-container_background-color": "{global.transparent}",
    "tabitem_base_outer-container_flex-direction": "{flexDirection.column}",
    "tabitem_base_outer-container_align-items": "{alignItems.center}",
    "tabitem_base_outer-container_justify-content": "{justifyContent.center}",
    "tabitem_base_outer-container_min-height": "{xxl}",
    "tabitem_base_outer-container_width": "{intrinsicSize.max}",
    "tabitem_base_outer-container_height": "{intrinsicSize.max}",
    "tabitem_base_container_flex-direction": "{flexDirection.row}",
    "tabitem_base_container_align-items": "{alignItems.center}",
    "tabitem_base_container_justify-content": "{justifyContent.center}",
    tabitem_base_container_gap: $e3613f6017c674c5$var$tabitem_base_container_gap,
    "tabitem_base_container_padding-top": "{s}",
    "tabitem_base_container_padding-bottom": "{s}",
    "tabitem_base_container_padding-right": "{xs}",
    "tabitem_base_container_padding-left": "{xs}",
    "tabitem_base_container_behavior_focus_border-width": "{border_normal}",
    "tabitem_base_container_behavior_focus_border-color": "{primary80}",
    "tabitem_base_container_behavior_focus_border-radius": "{large}",
    tabitem_base_icon_size: $e3613f6017c674c5$var$tabitem_base_icon_size,
    tabitem_base_icon_color: $e3613f6017c674c5$var$tabitem_base_icon_color,
    tabitem_base_icon_behavior_hover_color: $e3613f6017c674c5$var$tabitem_base_icon_behavior_hover_color,
    tabitem_base_icon_behavior_active_color: $e3613f6017c674c5$var$tabitem_base_icon_behavior_active_color,
    tabitem_base_text_color: $e3613f6017c674c5$var$tabitem_base_text_color,
    "tabitem_base_text_font-size": "{bodyS}",
    "tabitem_base_text_font-family": "{bodyS}",
    "tabitem_base_text_font-weight": "{bodyS}",
    "tabitem_base_text_line-height": "{bodyS}",
    "tabitem_base_text_letter-spacing": "{bodyS}",
    tabitem_base_text_behavior_hover_color: $e3613f6017c674c5$var$tabitem_base_text_behavior_hover_color,
    "tabitem_base_indicator-container_background-color": "{global.transparent}",
    "tabitem_base_indicator-container_height": "{xxs}",
    "tabitem_base_indicator-container_width": "{size.max}",
    "tabitem_base_indicator-container_border-radius": "{pill}",
    "tabitem_base_outer-container_opacity": "{opacity.enabled}",
    "tabitem_variant_disabled_true_outer-container_opacity": "{opacity.disabled}",
    tabitem_variant_appearance_normal_text_behavior_hover_color: $e3613f6017c674c5$var$tabitem_variant_appearance_normal_text_behavior_hover_color,
    tabitem_variant_appearance_normal_text_behavior_active_color: $e3613f6017c674c5$var$tabitem_variant_appearance_normal_text_behavior_active_color,
    "tabitem_variant_appearance_tab_bar_container_behavior_active_background-color": "{custom_dark_primary_40}",
    "tabitem_variant_appearance_tab_bar_container_behavior_focus_border-color": "{custom_dark_primary_60}",
    tabitem_variant_appearance_tab_bar_icon_color: $e3613f6017c674c5$var$tabitem_variant_appearance_tab_bar_icon_color,
    tabitem_variant_appearance_tab_bar_icon_behavior_hover_color: $e3613f6017c674c5$var$tabitem_variant_appearance_tab_bar_icon_behavior_hover_color,
    tabitem_variant_appearance_tab_bar_icon_behavior_active_color: $e3613f6017c674c5$var$tabitem_variant_appearance_tab_bar_icon_behavior_active_color,
    tabitem_variant_appearance_tab_bar_text_color: $e3613f6017c674c5$var$tabitem_variant_appearance_tab_bar_text_color,
    tabitem_variant_appearance_tab_bar_text_behavior_hover_color: $e3613f6017c674c5$var$tabitem_variant_appearance_tab_bar_text_behavior_hover_color,
    tabitem_variant_appearance_tab_bar_text_behavior_active_color: $e3613f6017c674c5$var$tabitem_variant_appearance_tab_bar_text_behavior_active_color,
    tabitem_combination_active_normal_icon_color: $e3613f6017c674c5$var$tabitem_combination_active_normal_icon_color,
    tabitem_combination_active_normal_text_color: $e3613f6017c674c5$var$tabitem_combination_active_normal_text_color
};
const $e3613f6017c674c5$var$TooltipTokens = {
    "tooltip_base_popup-container_flex-direction": "{flexDirection.row}",
    "tooltip_base_popup-container_justify-content": "{justifyContent.start}",
    "tooltip_base_popup-container_align-items": "{alignItems.start}",
    "tooltip_base_root-container_flex-direction": "{flexDirection.row}",
    "tooltip_base_root-container_justify-content": "{justifyContent.start}",
    "tooltip_base_root-container_align-items": "{alignItems.center}",
    "tooltip_base_root-container_overflow": "hidden",
    "tooltip_base_text-container_border-radius": "{medium}",
    "tooltip_base_text-container_border-width": "{border_thin}",
    "tooltip_base_text-container_background-color": "{primaryGrey100}",
    "tooltip_base_start-tooltip_color": "{primaryGrey100}",
    "tooltip_base_end-tooltip_color": "{primaryGrey100}",
    "tooltip_base_text-container_padding-left": "{base}",
    "tooltip_base_text-container_padding-right": "{base}",
    "tooltip_base_text-container_padding-top": "{xs}",
    "tooltip_base_text-container_padding-bottom": "{xs}",
    "tooltip_variant_position_right_start_root-container_align-items": "{alignItems.start}",
    "tooltip_variant_position_right_start_start-tooltip_padding-top": "{xs}",
    "tooltip_variant_position_right_end_root-container_align-items": "{alignItems.end}",
    "tooltip_variant_position_right_end_start-tooltip_padding-bottom": "{xs}",
    "tooltip_variant_position_left_start_root-container_align-items": "{alignItems.start}",
    "tooltip_variant_position_left_start_end-tooltip_padding-top": "{xs}",
    "tooltip_variant_position_left_end_root-container_align-items": "{alignItems.end}",
    "tooltip_variant_position_left_end_end-tooltip_padding-bottom": "{xs}",
    "tooltip_variant_position_top_root-container_flex-direction": "{flexDirection.column}",
    "tooltip_variant_position_top_root-container_align-items": "{alignItems.center}",
    "tooltip_variant_position_top_start_root-container_flex-direction": "{flexDirection.column}",
    "tooltip_variant_position_top_start_root-container_align-items": "{alignItems.start}",
    "tooltip_variant_position_top_start_end-tooltip_padding-left": "{xs}",
    "tooltip_variant_position_top_end_root-container_flex-direction": "{flexDirection.column}",
    "tooltip_variant_position_top_end_root-container_align-items": "{alignItems.end}",
    "tooltip_variant_position_top_end_end-tooltip_padding-right": "{xs}",
    "tooltip_variant_position_bottom_root-container_flex-direction": "{flexDirection.column}",
    "tooltip_variant_position_bottom_root-container_align-items": "{alignItems.center}",
    "tooltip_variant_position_bottom_start_root-container_flex-direction": "{flexDirection.column}",
    "tooltip_variant_position_bottom_start_root-container_align-items": "{alignItems.start}",
    "tooltip_variant_position_bottom_start_start-tooltip_padding-left": "{xs}",
    "tooltip_variant_position_bottom_end_root-container_flex-direction": "{flexDirection.column}",
    "tooltip_variant_position_bottom_end_root-container_align-items": "{alignItems.end}",
    "tooltip_variant_position_bottom_end_start-tooltip_padding-right": "{xs}",
    "tooltip_base_text-container_min-height": "{xl}",
    "tooltip_base_text-container_align-items": "{alignItems.center}"
};
const $e3613f6017c674c5$var$ToggleTokens = {
    "toggle_base_prefix-icon-container_flex-direction": "{flexDirection.column}",
    "toggle_base_vertical-container_flex-direction": "{flexDirection.column}",
    "toggle_base_vertical-container_justify-content": "{justifyContent.start}",
    "toggle_base_vertical-container_align-items": "{alignItems.start}",
    "toggle_base_vertical-container_gap": "{xs}",
    "toggle_base_horizontal-container_flex-direction": "{flexDirection.row}",
    "toggle_base_horizontal-container_justify-content": "{justifyContent.start}",
    "toggle_base_horizontal-container_align-items": "{alignItems.center}",
    "toggle_base_horizontal-container_gap": "{xs}",
    "toggle_base_pill-container_min-width": "{custom_2}",
    "toggle_base_pill-container_min-height": "{m}",
    "toggle_base_pill-container_flex-direction": "{flexDirection.row}",
    "toggle_base_pill-container_justify-content": "{justifyContent.start}",
    "toggle_base_pill-container_align-items": "{alignItems.center}",
    "toggle_base_pill-container_padding-left": "{xxs}",
    "toggle_base_pill-container_padding-right": "{xxs}",
    "toggle_base_pill-container_background-color": "{global.transparent}",
    "toggle_base_pill-container_border-radius": "{pill}",
    "toggle_base_pill-container_border-width": "{border_thin}",
    "toggle_base_pill-container_border-color": "{primaryGrey80}",
    "toggle_base_pill-container_behavior_hover_border-color": "{primary40}",
    "toggle_base_pill-container_behavior_active_border-color": "{primary60}",
    "toggle_base_pill-container_behavior_focus_box-shadow_spread": "{xxs}",
    "toggle_base_pill-container_behavior_focus_box-shadow_color": "{primary60}",
    "toggle_base_pill-container_behavior_focus_border-width": "{border_none}",
    "toggle_base_ball-container_min-width": "{base}",
    "toggle_base_ball-container_min-height": "{base}",
    "toggle_base_ball-container_background-color": "{primaryGrey80}",
    "toggle_base_ball-container_border-radius": "{pill}",
    "toggle_base_left-jds_text_text-align": "{textAlign.start}",
    "toggle_variant_size_small_pill-container_min-width": "{custom_3}",
    "toggle_variant_size_small_pill-container_min-height": "{base}",
    "toggle_variant_size_small_vertical-container_gap": "{xxs}",
    "toggle_variant_size_small_ball-container_min-width": "{xs}",
    "toggle_variant_size_small_ball-container_min-height": "{xs}",
    "toggle_variant_checked_true_pill-container_justify-content": "{justifyContent.end}",
    "toggle_variant_checked_true_pill-container_background-color": "{primary50}",
    "toggle_variant_checked_true_pill-container_border-width": "{border_none}",
    "toggle_variant_checked_true_pill-container_behavior_hover_background-color": "{primary40}",
    "toggle_variant_checked_true_pill-container_behavior_active_background-color": "{primary60}",
    "toggle_variant_checked_true_ball-container_background-color": "{primaryInverse}",
    "toggle_variant_disabled_true_vertical-container_opacity": "{opacity.disabled}",
    "toggle_base_vertical-container_opacity": "{opacity.enabled}"
};
const $e3613f6017c674c5$var$text_link_color = "{primary60}";
const $e3613f6017c674c5$var$text_base_text_color = "{primaryGrey100}";
const $e3613f6017c674c5$var$text_variant_color_primary_80_text_color = "{primary80}";
const $e3613f6017c674c5$var$text_variant_color_primary_70_text_color = "{primary70}";
const $e3613f6017c674c5$var$text_variant_color_primary_60_text_color = "{primary60}";
const $e3613f6017c674c5$var$text_variant_color_primary_50_text_color = "{primary50}";
const $e3613f6017c674c5$var$text_variant_color_primary_40_text_color = "{primary40}";
const $e3613f6017c674c5$var$text_variant_color_primary_30_text_color = "{primary30}";
const $e3613f6017c674c5$var$text_variant_color_primary_20_text_color = "{primary20}";
const $e3613f6017c674c5$var$text_variant_color_primary_inverse_text_color = "{primaryInverse}";
const $e3613f6017c674c5$var$text_variant_color_primary_background_text_color = "{primaryBackground}";
const $e3613f6017c674c5$var$text_variant_color_primary_grey_100_text_color = "{primaryGrey100}";
const $e3613f6017c674c5$var$text_variant_color_primary_grey_80_text_color = "{primaryGrey80}";
const $e3613f6017c674c5$var$text_variant_color_primary_grey_60_text_color = "{primaryGrey60}";
const $e3613f6017c674c5$var$text_variant_color_primary_grey_40_text_color = "{primaryGrey40}";
const $e3613f6017c674c5$var$text_variant_color_primary_grey_20_text_color = "{primaryGrey20}";
const $e3613f6017c674c5$var$text_variant_color_secondary_80_text_color = "{secondary80}";
const $e3613f6017c674c5$var$text_variant_color_secondary_70_text_color = "{secondary70}";
const $e3613f6017c674c5$var$text_variant_color_secondary_60_text_color = "{secondary60}";
const $e3613f6017c674c5$var$text_variant_color_secondary_50_text_color = "{secondary50}";
const $e3613f6017c674c5$var$text_variant_color_secondary_40_text_color = "{secondary40}";
const $e3613f6017c674c5$var$text_variant_color_secondary_30_text_color = "{secondary30}";
const $e3613f6017c674c5$var$text_variant_color_secondary_20_text_color = "{secondary20}";
const $e3613f6017c674c5$var$text_variant_color_secondary_inverse_text_color = "{secondaryInverse}";
const $e3613f6017c674c5$var$text_variant_color_secondary_background_text_color = "{secondaryBackground}";
const $e3613f6017c674c5$var$text_variant_color_secondary_grey_100_text_color = "{secondaryGrey100}";
const $e3613f6017c674c5$var$text_variant_color_secondary_grey_80_text_color = "{secondaryGrey80}";
const $e3613f6017c674c5$var$text_variant_color_secondary_grey_60_text_color = "{secondaryGrey60}";
const $e3613f6017c674c5$var$text_variant_color_secondary_grey_40_text_color = "{secondaryGrey40}";
const $e3613f6017c674c5$var$text_variant_color_secondary_grey_20_text_color = "{secondaryGrey20}";
const $e3613f6017c674c5$var$text_variant_color_sparkle_80_text_color = "{sparkle80}";
const $e3613f6017c674c5$var$text_variant_color_sparkle_70_text_color = "{sparkle70}";
const $e3613f6017c674c5$var$text_variant_color_sparkle_60_text_color = "{sparkle60}";
const $e3613f6017c674c5$var$text_variant_color_sparkle_50_text_color = "{sparkle50}";
const $e3613f6017c674c5$var$text_variant_color_sparkle_40_text_color = "{sparkle40}";
const $e3613f6017c674c5$var$text_variant_color_sparkle_30_text_color = "{sparkle30}";
const $e3613f6017c674c5$var$text_variant_color_sparkle_20_text_color = "{sparkle20}";
const $e3613f6017c674c5$var$text_variant_color_sparkle_inverse_text_color = "{sparkleInverse}";
const $e3613f6017c674c5$var$text_variant_color_sparkle_background_text_color = "{sparkleBackground}";
const $e3613f6017c674c5$var$text_variant_color_sparkle_grey_100_text_color = "{sparkleGrey100}";
const $e3613f6017c674c5$var$text_variant_color_sparkle_grey_80_text_color = "{sparkleGrey80}";
const $e3613f6017c674c5$var$text_variant_color_sparkle_grey_60_text_color = "{sparkleGrey60}";
const $e3613f6017c674c5$var$text_variant_color_sparkle_grey_40_text_color = "{sparkleGrey40}";
const $e3613f6017c674c5$var$text_variant_color_sparkle_grey_20_text_color = "{sparkleGrey20}";
const $e3613f6017c674c5$var$text_variant_color_feedback_error_80_text_color = "{feedbackError80}";
const $e3613f6017c674c5$var$text_variant_color_feedback_error_50_text_color = "{feedbackError50}";
const $e3613f6017c674c5$var$text_variant_color_feedback_error_20_text_color = "{feedbackError20}";
const $e3613f6017c674c5$var$text_variant_color_feedback_warning_80_text_color = "{feedbackWarning80}";
const $e3613f6017c674c5$var$text_variant_color_feedback_warning_50_text_color = "{feedbackWarning50}";
const $e3613f6017c674c5$var$text_variant_color_feedback_warning_20_text_color = "{feedbackWarning20}";
const $e3613f6017c674c5$var$text_variant_color_feedback_success_80_text_color = "{feedbackSuccess80}";
const $e3613f6017c674c5$var$text_variant_color_feedback_success_50_text_color = "{feedbackSuccess50}";
const $e3613f6017c674c5$var$text_variant_color_feedback_success_20_text_color = "{feedbackSuccess20}";
const $e3613f6017c674c5$var$text_variant_color_white_text_color = "{global.white}";
const $e3613f6017c674c5$var$text_variant_color_black_text_color = "{global.black}";
const $e3613f6017c674c5$var$text_variant_color_transparent_text_color = "{global.transparent}";
const $e3613f6017c674c5$var$TextTokens = {
    text_link_color: $e3613f6017c674c5$var$text_link_color,
    "text_base_text_font-family": "{bodyS}",
    text_base_text_color: $e3613f6017c674c5$var$text_base_text_color,
    "text_base_text_font-size": "{bodyS}",
    "text_base_text_line-height": "{bodyS}",
    "text_base_text_letter-spacing": "{bodyS}",
    "text_base_text_font-weight": "{bodyS}",
    "text_base_text_text-decoration": "{text-decoration.none}",
    "text_base_text_text-transform": "{text-case.none}",
    "text_variant_textDecoration_underline_text_text-decoration": "{text-decoration.underline}",
    "text_variant_textDecoration_line-through_text_text-decoration": "{text-decoration.line-through}",
    "text_variant_textDecoration_overline_text_text-decoration": "{text-decoration.overline}",
    text_variant_color_primary_80_text_color: $e3613f6017c674c5$var$text_variant_color_primary_80_text_color,
    text_variant_color_primary_70_text_color: $e3613f6017c674c5$var$text_variant_color_primary_70_text_color,
    text_variant_color_primary_60_text_color: $e3613f6017c674c5$var$text_variant_color_primary_60_text_color,
    text_variant_color_primary_50_text_color: $e3613f6017c674c5$var$text_variant_color_primary_50_text_color,
    text_variant_color_primary_40_text_color: $e3613f6017c674c5$var$text_variant_color_primary_40_text_color,
    text_variant_color_primary_30_text_color: $e3613f6017c674c5$var$text_variant_color_primary_30_text_color,
    text_variant_color_primary_20_text_color: $e3613f6017c674c5$var$text_variant_color_primary_20_text_color,
    text_variant_color_primary_inverse_text_color: $e3613f6017c674c5$var$text_variant_color_primary_inverse_text_color,
    text_variant_color_primary_background_text_color: $e3613f6017c674c5$var$text_variant_color_primary_background_text_color,
    text_variant_color_primary_grey_100_text_color: $e3613f6017c674c5$var$text_variant_color_primary_grey_100_text_color,
    text_variant_color_primary_grey_80_text_color: $e3613f6017c674c5$var$text_variant_color_primary_grey_80_text_color,
    text_variant_color_primary_grey_60_text_color: $e3613f6017c674c5$var$text_variant_color_primary_grey_60_text_color,
    text_variant_color_primary_grey_40_text_color: $e3613f6017c674c5$var$text_variant_color_primary_grey_40_text_color,
    text_variant_color_primary_grey_20_text_color: $e3613f6017c674c5$var$text_variant_color_primary_grey_20_text_color,
    text_variant_color_secondary_80_text_color: $e3613f6017c674c5$var$text_variant_color_secondary_80_text_color,
    text_variant_color_secondary_70_text_color: $e3613f6017c674c5$var$text_variant_color_secondary_70_text_color,
    text_variant_color_secondary_60_text_color: $e3613f6017c674c5$var$text_variant_color_secondary_60_text_color,
    text_variant_color_secondary_50_text_color: $e3613f6017c674c5$var$text_variant_color_secondary_50_text_color,
    text_variant_color_secondary_40_text_color: $e3613f6017c674c5$var$text_variant_color_secondary_40_text_color,
    text_variant_color_secondary_30_text_color: $e3613f6017c674c5$var$text_variant_color_secondary_30_text_color,
    text_variant_color_secondary_20_text_color: $e3613f6017c674c5$var$text_variant_color_secondary_20_text_color,
    text_variant_color_secondary_inverse_text_color: $e3613f6017c674c5$var$text_variant_color_secondary_inverse_text_color,
    text_variant_color_secondary_background_text_color: $e3613f6017c674c5$var$text_variant_color_secondary_background_text_color,
    text_variant_color_secondary_grey_100_text_color: $e3613f6017c674c5$var$text_variant_color_secondary_grey_100_text_color,
    text_variant_color_secondary_grey_80_text_color: $e3613f6017c674c5$var$text_variant_color_secondary_grey_80_text_color,
    text_variant_color_secondary_grey_60_text_color: $e3613f6017c674c5$var$text_variant_color_secondary_grey_60_text_color,
    text_variant_color_secondary_grey_40_text_color: $e3613f6017c674c5$var$text_variant_color_secondary_grey_40_text_color,
    text_variant_color_secondary_grey_20_text_color: $e3613f6017c674c5$var$text_variant_color_secondary_grey_20_text_color,
    text_variant_color_sparkle_80_text_color: $e3613f6017c674c5$var$text_variant_color_sparkle_80_text_color,
    text_variant_color_sparkle_70_text_color: $e3613f6017c674c5$var$text_variant_color_sparkle_70_text_color,
    text_variant_color_sparkle_60_text_color: $e3613f6017c674c5$var$text_variant_color_sparkle_60_text_color,
    text_variant_color_sparkle_50_text_color: $e3613f6017c674c5$var$text_variant_color_sparkle_50_text_color,
    text_variant_color_sparkle_40_text_color: $e3613f6017c674c5$var$text_variant_color_sparkle_40_text_color,
    text_variant_color_sparkle_30_text_color: $e3613f6017c674c5$var$text_variant_color_sparkle_30_text_color,
    text_variant_color_sparkle_20_text_color: $e3613f6017c674c5$var$text_variant_color_sparkle_20_text_color,
    text_variant_color_sparkle_inverse_text_color: $e3613f6017c674c5$var$text_variant_color_sparkle_inverse_text_color,
    text_variant_color_sparkle_background_text_color: $e3613f6017c674c5$var$text_variant_color_sparkle_background_text_color,
    text_variant_color_sparkle_grey_100_text_color: $e3613f6017c674c5$var$text_variant_color_sparkle_grey_100_text_color,
    text_variant_color_sparkle_grey_80_text_color: $e3613f6017c674c5$var$text_variant_color_sparkle_grey_80_text_color,
    text_variant_color_sparkle_grey_60_text_color: $e3613f6017c674c5$var$text_variant_color_sparkle_grey_60_text_color,
    text_variant_color_sparkle_grey_40_text_color: $e3613f6017c674c5$var$text_variant_color_sparkle_grey_40_text_color,
    text_variant_color_sparkle_grey_20_text_color: $e3613f6017c674c5$var$text_variant_color_sparkle_grey_20_text_color,
    text_variant_color_feedback_error_80_text_color: $e3613f6017c674c5$var$text_variant_color_feedback_error_80_text_color,
    text_variant_color_feedback_error_50_text_color: $e3613f6017c674c5$var$text_variant_color_feedback_error_50_text_color,
    text_variant_color_feedback_error_20_text_color: $e3613f6017c674c5$var$text_variant_color_feedback_error_20_text_color,
    text_variant_color_feedback_warning_80_text_color: $e3613f6017c674c5$var$text_variant_color_feedback_warning_80_text_color,
    text_variant_color_feedback_warning_50_text_color: $e3613f6017c674c5$var$text_variant_color_feedback_warning_50_text_color,
    text_variant_color_feedback_warning_20_text_color: $e3613f6017c674c5$var$text_variant_color_feedback_warning_20_text_color,
    text_variant_color_feedback_success_80_text_color: $e3613f6017c674c5$var$text_variant_color_feedback_success_80_text_color,
    text_variant_color_feedback_success_50_text_color: $e3613f6017c674c5$var$text_variant_color_feedback_success_50_text_color,
    text_variant_color_feedback_success_20_text_color: $e3613f6017c674c5$var$text_variant_color_feedback_success_20_text_color,
    text_variant_color_white_text_color: $e3613f6017c674c5$var$text_variant_color_white_text_color,
    text_variant_color_black_text_color: $e3613f6017c674c5$var$text_variant_color_black_text_color,
    text_variant_color_transparent_text_color: $e3613f6017c674c5$var$text_variant_color_transparent_text_color,
    "text_variant_appearance_heading_xl_text_font-size": "{headingXl}",
    "text_variant_appearance_heading_xl_text_font-family": "{headingXl}",
    "text_variant_appearance_heading_xl_text_line-height": "{headingXl}",
    "text_variant_appearance_heading_xl_text_letter-spacing": "{headingXl}",
    "text_variant_appearance_heading_xl_text_font-weight": "{headingXl}",
    "text_variant_appearance_heading_l_text_font-size": "{headingL}",
    "text_variant_appearance_heading_l_text_font-family": "{headingL}",
    "text_variant_appearance_heading_l_text_line-height": "{headingL}",
    "text_variant_appearance_heading_l_text_letter-spacing": "{headingL}",
    "text_variant_appearance_heading_l_text_font-weight": "{headingL}",
    "text_variant_appearance_heading_m_text_font-size": "{headingM}",
    "text_variant_appearance_heading_m_text_font-family": "{headingM}",
    "text_variant_appearance_heading_m_text_line-height": "{headingM}",
    "text_variant_appearance_heading_m_text_letter-spacing": "{headingM}",
    "text_variant_appearance_heading_m_text_font-weight": "{headingM}",
    "text_variant_appearance_heading_s_text_font-size": "{headingS}",
    "text_variant_appearance_heading_s_text_font-family": "{headingS}",
    "text_variant_appearance_heading_s_text_line-height": "{headingS}",
    "text_variant_appearance_heading_s_text_letter-spacing": "{headingS}",
    "text_variant_appearance_heading_s_text_font-weight": "{headingS}",
    "text_variant_appearance_heading_xs_text_font-size": "{headingXs}",
    "text_variant_appearance_heading_xs_text_font-family": "{headingXs}",
    "text_variant_appearance_heading_xs_text_line-height": "{headingXs}",
    "text_variant_appearance_heading_xs_text_letter-spacing": "{headingXs}",
    "text_variant_appearance_heading_xs_text_font-weight": "{headingXs}",
    "text_variant_appearance_heading_xxs_text_font-size": "{headingXxs}",
    "text_variant_appearance_heading_xxs_text_font-family": "{headingXxs}",
    "text_variant_appearance_heading_xxs_text_line-height": "{headingXxs}",
    "text_variant_appearance_heading_xxs_text_letter-spacing": "{headingXxs}",
    "text_variant_appearance_heading_xxs_text_font-weight": "{headingXxs}",
    "text_variant_appearance_overline_text_font-size": "{overline}",
    "text_variant_appearance_overline_text_font-family": "{overline}",
    "text_variant_appearance_overline_text_line-height": "{overline}",
    "text_variant_appearance_overline_text_letter-spacing": "{overline}",
    "text_variant_appearance_overline_text_font-weight": "{overline}",
    "text_variant_appearance_overline_text_text-transform": "{overline}",
    "text_variant_appearance_body_l_text_font-size": "{bodyL}",
    "text_variant_appearance_body_l_text_font-family": "{bodyL}",
    "text_variant_appearance_body_l_text_line-height": "{bodyL}",
    "text_variant_appearance_body_l_text_letter-spacing": "{bodyL}",
    "text_variant_appearance_body_l_text_font-weight": "{bodyL}",
    "text_variant_appearance_body_l_bold_text_font-size": "{bodyLBold}",
    "text_variant_appearance_body_l_bold_text_font-family": "{bodyLBold}",
    "text_variant_appearance_body_l_bold_text_line-height": "{bodyLBold}",
    "text_variant_appearance_body_l_bold_text_letter-spacing": "{bodyLBold}",
    "text_variant_appearance_body_l_bold_text_font-weight": "{bodyLBold}",
    "text_variant_appearance_body_l_link_text_font-size": "{bodyLLink}",
    "text_variant_appearance_body_l_link_text_font-family": "{bodyLLink}",
    "text_variant_appearance_body_l_link_text_line-height": "{bodyLLink}",
    "text_variant_appearance_body_l_link_text_letter-spacing": "{bodyLLink}",
    "text_variant_appearance_body_l_link_text_font-weight": "{bodyLLink}",
    "text_variant_appearance_body_m_text_font-size": "{bodyM}",
    "text_variant_appearance_body_m_text_font-family": "{bodyM}",
    "text_variant_appearance_body_m_text_line-height": "{bodyM}",
    "text_variant_appearance_body_m_text_letter-spacing": "{bodyM}",
    "text_variant_appearance_body_m_text_font-weight": "{bodyM}",
    "text_variant_appearance_body_m_bold_text_font-size": "{bodyMBold}",
    "text_variant_appearance_body_m_bold_text_font-family": "{bodyMBold}",
    "text_variant_appearance_body_m_bold_text_line-height": "{bodyMBold}",
    "text_variant_appearance_body_m_bold_text_letter-spacing": "{bodyMBold}",
    "text_variant_appearance_body_m_bold_text_font-weight": "{bodyMBold}",
    "text_variant_appearance_body_m_link_text_font-size": "{bodyMLink}",
    "text_variant_appearance_body_m_link_text_font-family": "{bodyMLink}",
    "text_variant_appearance_body_m_link_text_line-height": "{bodyMLink}",
    "text_variant_appearance_body_m_link_text_letter-spacing": "{bodyMLink}",
    "text_variant_appearance_body_m_link_text_font-weight": "{bodyMLink}",
    "text_variant_appearance_body_s_text_font-size": "{bodyS}",
    "text_variant_appearance_body_s_text_font-family": "{bodyS}",
    "text_variant_appearance_body_s_text_line-height": "{bodyS}",
    "text_variant_appearance_body_s_text_letter-spacing": "{bodyS}",
    "text_variant_appearance_body_s_text_font-weight": "{bodyS}",
    "text_variant_appearance_body_s_bold_text_font-size": "{bodySBold}",
    "text_variant_appearance_body_s_bold_text_font-family": "{bodySBold}",
    "text_variant_appearance_body_s_bold_text_line-height": "{bodySBold}",
    "text_variant_appearance_body_s_bold_text_letter-spacing": "{bodySBold}",
    "text_variant_appearance_body_s_bold_text_font-weight": "{bodySBold}",
    "text_variant_appearance_body_s_link_text_font-size": "{bodySLink}",
    "text_variant_appearance_body_s_link_text_font-family": "{bodySLink}",
    "text_variant_appearance_body_s_link_text_line-height": "{bodySLink}",
    "text_variant_appearance_body_s_link_text_letter-spacing": "{bodySLink}",
    "text_variant_appearance_body_s_link_text_font-weight": "{bodySLink}",
    "text_variant_appearance_body_xs_text_font-size": "{bodyXs}",
    "text_variant_appearance_body_xs_text_font-family": "{bodyXs}",
    "text_variant_appearance_body_xs_text_line-height": "{bodyXs}",
    "text_variant_appearance_body_xs_text_letter-spacing": "{bodyXs}",
    "text_variant_appearance_body_xs_text_font-weight": "{bodyXs}",
    "text_variant_appearance_body_xs_bold_text_font-size": "{bodyXsBold}",
    "text_variant_appearance_body_xs_bold_text_font-family": "{bodyXsBold}",
    "text_variant_appearance_body_xs_bold_text_line-height": "{bodyXsBold}",
    "text_variant_appearance_body_xs_bold_text_letter-spacing": "{bodyXsBold}",
    "text_variant_appearance_body_xs_bold_text_font-weight": "{bodyXsBold}",
    "text_variant_appearance_body_xs_link_text_font-size": "{bodyXsLink}",
    "text_variant_appearance_body_xs_link_text_font-family": "{bodyXsLink}",
    "text_variant_appearance_body_xs_link_text_line-height": "{bodyXsLink}",
    "text_variant_appearance_body_xs_link_text_letter-spacing": "{bodyXsLink}",
    "text_variant_appearance_body_xs_link_text_font-weight": "{bodyXsLink}",
    "text_variant_appearance_body_xs_caps_text_font-family": "{bodyXs}",
    "text_variant_appearance_body_xs_caps_text_line-height": "{bodyXs}",
    "text_variant_appearance_body_xs_caps_text_text-transform": "{bodyS}",
    "text_variant_appearance_body_xs_caps_text_letter-spacing": "{bodyXs}",
    "text_variant_appearance_body_xs_caps_text_font-weight": "{bodyXs}",
    "text_variant_appearance_body_xxs_text_font-size": "{bodyXxs}",
    "text_variant_appearance_body_xxs_text_font-family": "{bodyXxs}",
    "text_variant_appearance_body_xxs_text_line-height": "{bodyXxs}",
    "text_variant_appearance_body_xxs_text_letter-spacing": "{bodyXxs}",
    "text_variant_appearance_body_xxs_text_font-weight": "{bodyXxs}",
    "text_variant_appearance_body_xxs_bold_text_font-size": "{bodyXxsBold}",
    "text_variant_appearance_body_xxs_bold_text_font-family": "{bodyXxsBold}",
    "text_variant_appearance_body_xxs_bold_text_line-height": "{bodyXxsBold}",
    "text_variant_appearance_body_xxs_bold_text_letter-spacing": "{bodyXxsBold}",
    "text_variant_appearance_body_xxs_bold_text_font-weight": "{bodyXxsBold}",
    "text_variant_appearance_body_xxs_link_text_font-size": "{bodyXxsLink}",
    "text_variant_appearance_body_xxs_link_text_font-family": "{bodyXxsLink}",
    "text_variant_appearance_body_xxs_link_text_line-height": "{bodyXxsLink}",
    "text_variant_appearance_body_xxs_link_text_letter-spacing": "{bodyXxsLink}",
    "text_variant_appearance_body_xxs_link_text_font-weight": "{bodyXxsLink}",
    "text_variant_appearance_body_3xs_text_font-size": "{body3xs}",
    "text_variant_appearance_body_3xs_text_font-family": "{body3xs}",
    "text_variant_appearance_body_3xs_text_line-height": "{body3xs}",
    "text_variant_appearance_body_3xs_text_letter-spacing": "{body3xs}",
    "text_variant_appearance_body_3xs_text_font-weight": "{body3xs}",
    "text_variant_appearance_body_3xs_bold_text_font-size": "{body3xsBold}",
    "text_variant_appearance_body_3xs_bold_text_font-family": "{body3xsBold}",
    "text_variant_appearance_body_3xs_bold_text_line-height": "{body3xsBold}",
    "text_variant_appearance_body_3xs_bold_text_letter-spacing": "{body3xsBold}",
    "text_variant_appearance_body_3xs_bold_text_font-weight": "{body3xsBold}",
    "text_variant_appearance_body_3xs_link_text_font-size": "{body3xsLink}",
    "text_variant_appearance_body_3xs_link_text_font-family": "{body3xsLink}",
    "text_variant_appearance_body_3xs_link_text_line-height": "{body3xsLink}",
    "text_variant_appearance_body_3xs_link_text_letter-spacing": "{body3xsLink}",
    "text_variant_appearance_body_3xs_link_text_font-weight": "{body3xsLink}",
    "text_variant_appearance_list_title_text_font-size": "{listTitle}",
    "text_variant_appearance_list_title_text_font-family": "{listTitle}",
    "text_variant_appearance_list_title_text_line-height": "{listTitle}",
    "text_variant_appearance_list_title_text_letter-spacing": "{listTitle}",
    "text_variant_appearance_list_title_text_font-weight": "{listTitle}",
    "text_variant_appearance_button_text_font-size": "{button}",
    "text_variant_appearance_button_text_font-family": "{button}",
    "text_variant_appearance_button_text_line-height": "{button}",
    "text_variant_appearance_button_text_letter-spacing": "{button}",
    "text_variant_appearance_button_text_font-weight": "{button}",
    "text_variant_appearance_code_text_font-size": "{code}",
    "text_variant_appearance_code_text_font-family": "{code}",
    "text_variant_appearance_code_text_line-height": "{code}",
    "text_variant_appearance_code_text_letter-spacing": "{code}",
    "text_variant_appearance_code_text_font-weight": "{code}",
    "text_variant_appearance_body_s_regular_para_text_font-size": "{bodyS}",
    "text_variant_appearance_body_s_regular_para_text_line-height": "{bodyS}",
    "text_variant_appearance_body_s_regular_para_text_letter-spacing": "{bodyS}",
    "text_variant_appearance_body_s_regular_para_text_font-weight": "{bodyS}",
    "text_variant_appearance_body_s_regular_para_text_font-family": "{bodyS}"
};
const $e3613f6017c674c5$var$RatingBarTokens = {
    "ratingbar_base_vertical-container_flex-direction": "{flexDirection.column}",
    "ratingbar_base_vertical-container_align-items": "{alignItems.start}",
    "ratingbar_base_vertical-container_justify-content": "{justifyContent.start}",
    "ratingbar_base_vertical-container_gap": "{xxs}",
    "ratingbar_base_horizontal-container_flex-direction": "{flexDirection.row}",
    "align-items": "{alignItems.center}",
    "ratingbar_base_horizontal-container_justify-content": "{justifyContent.start}",
    "ratingbar_base_horizontal-container_gap": "{xs}",
    "ratingbar_base_rating-bar-container_flex-direction": "{flexDirection.row}",
    "ratingbar_variant_size_small_vertical-container_gap": "{xxs}",
    "ratingbar_variant_size_small_horizontal-container_gap": "{xs}",
    "ratingbar_variant_labelPosition_bottom_center_vertical-container_align-items": "{alignItems.center}",
    "ratingbar_variant_labelPosition_top_center_vertical-container_align-items": "{alignItems.center}",
    "ratingbar_variant_disabled_true_vertical-container_opacity": "{opacity.disabled}",
    "ratingbar_combination_read_only_expanded_small_horizontal-container_gap": "{xxs}",
    "ratingbar_combination_read_only_expanded_small_vertical-container_gap": "{xxs}",
    "ratingbar_combination_read_only_expanded_medium_vertical-container_gap": "{xs}",
    "ratingbar_combination_read_only_expanded_medium_horizontal-container_gap": "{xs}",
    "ratingbar_combination_read_only_expanded_large_vertical-container_gap": "{xs}",
    "ratingbar_combination_read_only_expanded_large_horizontal-container_gap": "{xs}",
    "ratingbar_combination_read_only_compact_small_horizontal-container_gap": "{xxs}",
    "ratingbar_combination_read_only_compact_small_vertical-container_gap": "{xxs}",
    "ratingbar_combination_read_only_compact_medium_vertical-container_gap": "{xs}",
    "ratingbar_combination_read_only_compact_medium_horizontal-container_gap": "{xs}",
    "ratingbar_combination_read_only_compact_large_vertical-container_gap": "{xs}",
    "ratingbar_combination_read_only_compact_large_horizontal-container_gap": "{xs}",
    "ratingbar_base_horizontal-container_align-items": "{alignItems.center}"
};
const $e3613f6017c674c5$var$ratingBarItem_variant_size_small_start_icon_size = "{m}";
const $e3613f6017c674c5$var$ratingBarItem_variant_size_small_end_icon_size = "{m}";
const $e3613f6017c674c5$var$ratingBarItem_variant_size_large_start_icon_size = "{xl}";
const $e3613f6017c674c5$var$ratingBarItem_variant_size_large_end_icon_size = "{xl}";
const $e3613f6017c674c5$var$ratingBarItem_variant_disabled_true_container_opacity = "{opacity.disabled}";
const $e3613f6017c674c5$var$ratingBarItem_combination_isInteractive_isActive_isHovered_false_false_false_start_icon_color = "{primaryGrey60}";
const $e3613f6017c674c5$var$ratingBarItem_combination_isInteractive_isActive_isHovered_false_false_false_end_icon_color = "{primaryGrey60}";
const $e3613f6017c674c5$var$ratingBarItem_combination_isInteractive_isActive_isHovered_false_false_true_start_icon_color = "{primaryGrey60}";
const $e3613f6017c674c5$var$ratingBarItem_combination_isInteractive_isActive_isHovered_false_false_true_end_icon_color = "{primaryGrey60}";
const $e3613f6017c674c5$var$ratingBarItem_combination_isInteractive_isActive_isHovered_false_true_false_start_icon_color = "{primaryGrey80}";
const $e3613f6017c674c5$var$ratingBarItem_combination_isInteractive_isActive_isHovered_false_true_false_end_icon_color = "{primaryGrey80}";
const $e3613f6017c674c5$var$ratingBarItem_combination_isInteractive_isActive_isHovered_false_true_true_start_icon_color = "{primaryGrey80}";
const $e3613f6017c674c5$var$ratingBarItem_combination_isInteractive_isActive_isHovered_false_true_true_end_icon_color = "{primaryGrey80}";
const $e3613f6017c674c5$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_false_start_icon_color = "{primaryGrey60}";
const $e3613f6017c674c5$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_false_end_icon_color = "{primaryGrey60}";
const $e3613f6017c674c5$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_true_start_icon_color = "{primary50}";
const $e3613f6017c674c5$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_true_end_icon_color = "{primary50}";
const $e3613f6017c674c5$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_false_start_icon_behavior_active_color = "{primary70}";
const $e3613f6017c674c5$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_false_end_icon_behavior_active_color = "{primary70}";
const $e3613f6017c674c5$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_false_start_icon_color = "{primary60}";
const $e3613f6017c674c5$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_false_end_icon_color = "{primary60}";
const $e3613f6017c674c5$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_true_start_icon_color = "{primary50}";
const $e3613f6017c674c5$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_true_end_icon_color = "{primary50}";
const $e3613f6017c674c5$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_false_start_icon_behavior_active_color = "{primary70}";
const $e3613f6017c674c5$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_false_end_icon_behavior_active_color = "{primary70}";
const $e3613f6017c674c5$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_true_start_icon_behavior_active_color = "{primary70}";
const $e3613f6017c674c5$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_true_end_icon_behavior_active_color = "{primary70}";
const $e3613f6017c674c5$var$ratingBarItem_combination_isInteractive_isHalfRated_false_true_start_icon_color = "{primaryGrey80}";
const $e3613f6017c674c5$var$ratingBarItem_combination_isInteractive_isHalfRated_false_true_end_icon_color = "{primaryGrey60}";
const $e3613f6017c674c5$var$RatingBarItemTokens = {
    "ratingBarItem_base_container_flex-direction": "{flexDirection.stack}",
    "ratingBarItem_base_container_behavior_focus_border-width": "{border_focus}",
    "ratingBarItem_base_container_behavior_focus_border-color": "{primary60}",
    ratingBarItem_variant_size_small_start_icon_size: $e3613f6017c674c5$var$ratingBarItem_variant_size_small_start_icon_size,
    ratingBarItem_variant_size_small_end_icon_size: $e3613f6017c674c5$var$ratingBarItem_variant_size_small_end_icon_size,
    ratingBarItem_variant_size_large_start_icon_size: $e3613f6017c674c5$var$ratingBarItem_variant_size_large_start_icon_size,
    ratingBarItem_variant_size_large_end_icon_size: $e3613f6017c674c5$var$ratingBarItem_variant_size_large_end_icon_size,
    ratingBarItem_variant_disabled_true_container_opacity: $e3613f6017c674c5$var$ratingBarItem_variant_disabled_true_container_opacity,
    ratingBarItem_combination_isInteractive_isActive_isHovered_false_false_false_start_icon_color: $e3613f6017c674c5$var$ratingBarItem_combination_isInteractive_isActive_isHovered_false_false_false_start_icon_color,
    ratingBarItem_combination_isInteractive_isActive_isHovered_false_false_false_end_icon_color: $e3613f6017c674c5$var$ratingBarItem_combination_isInteractive_isActive_isHovered_false_false_false_end_icon_color,
    ratingBarItem_combination_isInteractive_isActive_isHovered_false_false_true_start_icon_color: $e3613f6017c674c5$var$ratingBarItem_combination_isInteractive_isActive_isHovered_false_false_true_start_icon_color,
    ratingBarItem_combination_isInteractive_isActive_isHovered_false_false_true_end_icon_color: $e3613f6017c674c5$var$ratingBarItem_combination_isInteractive_isActive_isHovered_false_false_true_end_icon_color,
    ratingBarItem_combination_isInteractive_isActive_isHovered_false_true_false_start_icon_color: $e3613f6017c674c5$var$ratingBarItem_combination_isInteractive_isActive_isHovered_false_true_false_start_icon_color,
    ratingBarItem_combination_isInteractive_isActive_isHovered_false_true_false_end_icon_color: $e3613f6017c674c5$var$ratingBarItem_combination_isInteractive_isActive_isHovered_false_true_false_end_icon_color,
    ratingBarItem_combination_isInteractive_isActive_isHovered_false_true_true_start_icon_color: $e3613f6017c674c5$var$ratingBarItem_combination_isInteractive_isActive_isHovered_false_true_true_start_icon_color,
    ratingBarItem_combination_isInteractive_isActive_isHovered_false_true_true_end_icon_color: $e3613f6017c674c5$var$ratingBarItem_combination_isInteractive_isActive_isHovered_false_true_true_end_icon_color,
    "ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_false_container_behavior_focus_border-width": "{border_focus}",
    "ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_true_container_behavior_focus_border-width": "{border_focus}",
    "ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_false_container_behavior_focus_border-color": "{primary60}",
    "ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_true_container_behavior_focus_border-color": "{primary60}",
    ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_false_start_icon_color: $e3613f6017c674c5$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_false_start_icon_color,
    ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_false_end_icon_color: $e3613f6017c674c5$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_false_end_icon_color,
    ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_true_start_icon_color: $e3613f6017c674c5$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_true_start_icon_color,
    ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_true_end_icon_color: $e3613f6017c674c5$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_true_end_icon_color,
    ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_false_start_icon_behavior_active_color: $e3613f6017c674c5$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_false_start_icon_behavior_active_color,
    ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_false_end_icon_behavior_active_color: $e3613f6017c674c5$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_false_end_icon_behavior_active_color,
    "ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_false_container_behavior_focus_border-color": "{primary60}",
    "ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_true_container_behavior_focus_border-color": "{primary60}",
    "ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_false_container_behavior_focus_border-width": "{border_focus}",
    "ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_true_container_behavior_focus_border-width": "{border_focus}",
    ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_false_start_icon_color: $e3613f6017c674c5$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_false_start_icon_color,
    ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_false_end_icon_color: $e3613f6017c674c5$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_false_end_icon_color,
    ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_true_start_icon_color: $e3613f6017c674c5$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_true_start_icon_color,
    ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_true_end_icon_color: $e3613f6017c674c5$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_true_end_icon_color,
    ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_false_start_icon_behavior_active_color: $e3613f6017c674c5$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_false_start_icon_behavior_active_color,
    ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_false_end_icon_behavior_active_color: $e3613f6017c674c5$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_false_end_icon_behavior_active_color,
    ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_true_start_icon_behavior_active_color: $e3613f6017c674c5$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_true_start_icon_behavior_active_color,
    ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_true_end_icon_behavior_active_color: $e3613f6017c674c5$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_true_end_icon_behavior_active_color,
    ratingBarItem_combination_isInteractive_isHalfRated_false_true_start_icon_color: $e3613f6017c674c5$var$ratingBarItem_combination_isInteractive_isHalfRated_false_true_start_icon_color,
    ratingBarItem_combination_isInteractive_isHalfRated_false_true_end_icon_color: $e3613f6017c674c5$var$ratingBarItem_combination_isInteractive_isHalfRated_false_true_end_icon_color
};
const $e3613f6017c674c5$export$a744e0ee3d364193 = {
    JDSActionButton: $e3613f6017c674c5$var$ActionButtonTokens,
    JDSAvatar: $e3613f6017c674c5$var$AvatarTokens,
    JDSAvatarV2Default: $e3613f6017c674c5$var$AvatarV2DefaultTokens,
    JDSAccordionList: $e3613f6017c674c5$var$AccordionListTokens,
    JDSMobileBottomSheet: $e3613f6017c674c5$var$MobileBottomSheetTokens,
    JDSMobileBottomSheetInternal: $e3613f6017c674c5$var$MobileBottomSheetInternalTokens,
    JDSBadge: $e3613f6017c674c5$var$BadgeTokens,
    JDSBadgeV2Brand: $e3613f6017c674c5$var$BadgeV2BrandTokens,
    JDSBadgeV2Information: $e3613f6017c674c5$var$BadgeV2InformationTokens,
    JDSBadgeV2Notification: $e3613f6017c674c5$var$BadgeV2NotificationTokens,
    JDSBadgeV2Status: $e3613f6017c674c5$var$BadgeV2StatusTokens,
    JDSBaseIcon: $e3613f6017c674c5$var$BaseIconTokens,
    JDSDesktopBottomSheet: $e3613f6017c674c5$var$DesktopBottomSheetTokens,
    JDSDesktopBottomSheetInternal: $e3613f6017c674c5$var$DesktopBottomSheetInternalTokens,
    JDSBreadcrumbs: $e3613f6017c674c5$var$BreadcrumbsTokens,
    JDSCarousel: $e3613f6017c674c5$var$CarouselTokens,
    JDSCarouselPagination: $e3613f6017c674c5$var$CarouselPaginationTokens,
    JDSButton: $e3613f6017c674c5$var$ButtonTokens,
    JDSCarouselPaginationItem: $e3613f6017c674c5$var$CarouselPaginationItemTokens,
    JDSCarouselSlide: $e3613f6017c674c5$var$CarouselSlideTokens,
    JDSCheckbox: $e3613f6017c674c5$var$CheckboxTokens,
    JDSContentBlock: $e3613f6017c674c5$var$ContentBlockTokens,
    JDSDatepickerButton: $e3613f6017c674c5$var$DatepickerButtonTokens,
    JDSContentCard: $e3613f6017c674c5$var$ContentCardTokens,
    JDSDatepickerCalendarButton: $e3613f6017c674c5$var$DatepickerCalendarButtonTokens,
    JDSDatepickerCalendar: $e3613f6017c674c5$var$DatepickerCalendarTokens,
    JDSDatepickerCalendarRow: $e3613f6017c674c5$var$DatepickerCalendarRowTokens,
    JDSAccordion: $e3613f6017c674c5$var$AccordionTokens,
    JDSDatepickerCalendarHeader: $e3613f6017c674c5$var$DatepickerCalendarHeaderTokens,
    JDSDatepickerDesktop: $e3613f6017c674c5$var$DatepickerDesktopTokens,
    JDSDatepickerDesktopInternal: $e3613f6017c674c5$var$DatepickerDesktopTokens,
    JDSDatepickerHeader: $e3613f6017c674c5$var$DatepickerHeaderTokens,
    JDSDatepickerYearView: $e3613f6017c674c5$var$DatepickerYearViewTokens,
    JDSDatepickerMonthView: $e3613f6017c674c5$var$DatepickerMonthViewTokens,
    JDSDatepickerMobile: $e3613f6017c674c5$var$DatepickerMobileTokens,
    JDSDatepickerMobileInteral: $e3613f6017c674c5$var$DatepickerMobileTokens,
    JDSDivider: $e3613f6017c674c5$var$DividerTokens,
    JDSDatepickerViewButton: $e3613f6017c674c5$var$DatepickerViewButtonTokens,
    JDSFAB: $e3613f6017c674c5$var$FABTokens,
    JDSFABInternal: $e3613f6017c674c5$var$FABTokens,
    JDSDropdown: $e3613f6017c674c5$var$DropdownTokens,
    JDSDropdownMenu: $e3613f6017c674c5$var$DropdownMenuTokens,
    JDSDropdownMenuInternal: $e3613f6017c674c5$var$DropdownMenuTokens,
    JDSDropdownMenuItem: $e3613f6017c674c5$var$DropdownMenuItemTokens,
    JDSDropdownMenuItemMobile: $e3613f6017c674c5$var$DropdownMenuItemTokens,
    JDSDropdownMenuGroup: $e3613f6017c674c5$var$DropdownMenuGroupTokens,
    JDSDropdownMenuSubMenu: $e3613f6017c674c5$var$DropdownMenuSubMenuTokens,
    JDSFeedbackBlock: $e3613f6017c674c5$var$FeedbackBlockTokens,
    JDSBottomFooterLinkItem: $e3613f6017c674c5$var$BottomFooterLinkItemTokens,
    JDSFooterIconLinks: $e3613f6017c674c5$var$FooterIconLinksTokens,
    JDSFooter: $e3613f6017c674c5$var$FooterTokens,
    JDSBottomFooter: $e3613f6017c674c5$var$BottomFooterTokens,
    JDSFooterLinksGrid: $e3613f6017c674c5$var$FooterLinksGridTokens,
    JDSFooterLinks: $e3613f6017c674c5$var$FooterLinksTokens,
    JDSIcon: $e3613f6017c674c5$var$IconTokens,
    JDSFooterMarketLinks: $e3613f6017c674c5$var$FooterMarketLinksTokens,
    JDSImage: $e3613f6017c674c5$var$ImageTokens,
    JDSInput: $e3613f6017c674c5$var$InputTokens,
    JDSInputCodeItem: $e3613f6017c674c5$var$InputCodeItemTokens,
    JDSInputDate: $e3613f6017c674c5$var$InputDateTokens,
    JDSLink: $e3613f6017c674c5$var$LinkTokens,
    JDSFileUploader: $e3613f6017c674c5$var$FileUploaderTokens,
    JDSFileUploaderControl: $e3613f6017c674c5$var$FileUploaderControlTokens,
    JDSFileUploaderItem: $e3613f6017c674c5$var$FileUploaderItemTokens,
    JDSFileUploaderList: $e3613f6017c674c5$var$FileUploaderListTokens,
    JDSFileUploaderPanel: $e3613f6017c674c5$var$FileUploaderPanelTokens,
    JDSMenuBlock: $e3613f6017c674c5$var$MenuBlockTokens,
    JDSMenuBlockInternal: $e3613f6017c674c5$var$MenuBlockTokens,
    JDSListBlock: $e3613f6017c674c5$var$ListBlockTokens,
    JDSInputField: $e3613f6017c674c5$var$InputFieldTokens,
    JDSInputFieldV2: $e3613f6017c674c5$var$InputFieldV2Tokens,
    JDSModalDesktop: $e3613f6017c674c5$var$ModalDesktopTokens,
    JDSModalDesktopInternal: $e3613f6017c674c5$var$ModalDesktopInternalTokens,
    JDSMenuBlockItem: $e3613f6017c674c5$var$MenuBlockItemTokens,
    JDSModalMobile: $e3613f6017c674c5$var$ModalMobileTokens,
    JDSModalMobileInternal: $e3613f6017c674c5$var$ModalMobileInternalTokens,
    JDSHeaderDesktop: $e3613f6017c674c5$var$HeaderDesktopTokens,
    JDSBottomNavigation: $e3613f6017c674c5$var$BottomNavigationTokens,
    JDSBottomNavigationItem: $e3613f6017c674c5$var$BottomNavigationItemTokens,
    JDSMegaMenu: $e3613f6017c674c5$var$MegaMenuTokens,
    JDSMegaMenuInternal: $e3613f6017c674c5$var$MegaMenuTokens,
    JDSHeaderMobile: $e3613f6017c674c5$var$HeaderMobileTokens,
    JDSMegaMenuItem: $e3613f6017c674c5$var$MegaMenuItemTokens,
    JDSTextarea: $e3613f6017c674c5$var$TextareaTokens,
    JDSSidePanelItem: $e3613f6017c674c5$var$SidePanelItemTokens,
    JDSMegaMenuBlock: $e3613f6017c674c5$var$MegaMenuBlockTokens,
    JDSNotificationButton: $e3613f6017c674c5$var$NotificationButtonTokens,
    JDSNotificationBanner: $e3613f6017c674c5$var$NotificationBannerTokens,
    JDSNudgeContainer: $e3613f6017c674c5$var$NudgeContainerTokens,
    JDSToastContainer: $e3613f6017c674c5$var$ToastContainerTokens,
    JDSToast: $e3613f6017c674c5$var$ToastTokens,
    JDSNudge: $e3613f6017c674c5$var$NudgeTokens,
    JDSPagination: $e3613f6017c674c5$var$PaginationTokens,
    JDSPromoCard: $e3613f6017c674c5$var$PromoCardTokens,
    JDSSidePanel: $e3613f6017c674c5$var$SidePanelTokens,
    JDSSidePanelInternal: $e3613f6017c674c5$var$SidePanelTokens,
    JDSProgressBar: $e3613f6017c674c5$var$ProgressBarTokens,
    JDSSearchBox: $e3613f6017c674c5$var$SearchBoxTokens,
    JDSPaginationButton: $e3613f6017c674c5$var$PaginationButtonTokens,
    JDSSearchResultItem: $e3613f6017c674c5$var$SearchResultItemTokens,
    JDSSearchResultText: $e3613f6017c674c5$var$SearchResultTextTokens,
    JDSRadioButton: $e3613f6017c674c5$var$RadioButtonTokens,
    JDSSelector: $e3613f6017c674c5$var$SelectorTokens,
    JDSSelectorItem: $e3613f6017c674c5$var$SelectorItemTokens,
    JDSSearchResults: $e3613f6017c674c5$var$SearchResultsTokens,
    JDSSearchResultsInternal: $e3613f6017c674c5$var$SearchResultsTokens,
    JDSSkeleton: $e3613f6017c674c5$var$SkeletonTokens,
    JDSServiceCard: $e3613f6017c674c5$var$ServiceCardTokens,
    JDSNotificationIconButton: $e3613f6017c674c5$var$NotificationIconButtonTokens,
    JDSSpinner: $e3613f6017c674c5$var$SpinnerTokens,
    JDSSelectorButton: $e3613f6017c674c5$var$SelectorButtonTokens,
    JDSSlider: $e3613f6017c674c5$var$SliderTokens,
    JDSStepperDot: $e3613f6017c674c5$var$StepperDotTokens,
    JDSHorizontalStepItem: $e3613f6017c674c5$var$HorizontalStepItemTokens,
    JDSVerticalStepItem: $e3613f6017c674c5$var$VerticalStepItemTokens,
    JDSTableCell: $e3613f6017c674c5$var$TableCellTokens,
    JDSTableBody: $e3613f6017c674c5$var$TableBodyTokens,
    JDSTableRow: $e3613f6017c674c5$var$TableRowTokens,
    JDSTabBar: $e3613f6017c674c5$var$TabBarTokens,
    JDSVerticalStepper: $e3613f6017c674c5$var$VerticalStepperTokens,
    JDSTabItem: $e3613f6017c674c5$var$TabItemTokens,
    JDSTabsDesktop: $e3613f6017c674c5$var$TabsDesktopTokens,
    JDSTag: $e3613f6017c674c5$var$TagTokens,
    JDSHorizontalStepper: $e3613f6017c674c5$var$HorizontalStepperTokens,
    JDSTable: $e3613f6017c674c5$var$TableTokens,
    JDSToggle: $e3613f6017c674c5$var$ToggleTokens,
    JDSText: $e3613f6017c674c5$var$TextTokens,
    JDSTooltip: $e3613f6017c674c5$var$TooltipTokens,
    JDSTooltipInternal: $e3613f6017c674c5$var$TooltipTokens,
    JDSInputCode: $e3613f6017c674c5$var$InputCodeTokens,
    JDSRatingBar: $e3613f6017c674c5$var$RatingBarTokens,
    JDSRatingBarItem: $e3613f6017c674c5$var$RatingBarItemTokens
};
const $e3613f6017c674c5$export$616d0e83e98f2255 = [
    {
        name: "JioMeet",
        primaryColor: "orange",
        secondaryColor: "purple",
        sparkleColor: "sky"
    },
    {
        name: "JioMart Express",
        primaryColor: "navi_midnight",
        secondaryColor: "red",
        sparkleColor: "pink"
    },
    {
        name: "JioSnap",
        primaryColor: "violet",
        secondaryColor: "orange",
        sparkleColor: "pink"
    },
    {
        name: "JioMart Digital Partner",
        primaryColor: "purple_midnight",
        secondaryColor: "red",
        sparkleColor: "green"
    },
    {
        name: "JioTrue5G",
        primaryColor: "navi_midnight",
        secondaryColor: "orange",
        sparkleColor: "reliance"
    },
    {
        name: "JioNetVelocity",
        primaryColor: "reliance",
        secondaryColor: "marigold",
        sparkleColor: "green"
    },
    {
        name: "JioSociety",
        primaryColor: "violet_midnight",
        secondaryColor: "mint",
        sparkleColor: "orange"
    },
    {
        name: "JioVideoCall",
        primaryColor: "navi",
        secondaryColor: "orange",
        sparkleColor: "marigold"
    },
    {
        name: "JioSwitch",
        primaryColor: "reliance_midnight",
        secondaryColor: "orange",
        sparkleColor: "sky"
    },
    {
        name: "DSP",
        primaryColor: "reliance",
        secondaryColor: "navi",
        sparkleColor: "sky"
    },
    {
        name: "JioPhotos",
        primaryColor: "navi",
        secondaryColor: "red",
        sparkleColor: "green"
    },
    {
        name: "JioPay",
        primaryColor: "reliance",
        secondaryColor: "navi_midnight",
        sparkleColor: "marigold"
    },
    {
        name: "JioTranslate",
        primaryColor: "pink_midnight",
        secondaryColor: "marigold",
        sparkleColor: "purple"
    },
    {
        name: "JioTV",
        primaryColor: "crimson",
        secondaryColor: "red",
        sparkleColor: "sky"
    },
    {
        name: "JioGames",
        primaryColor: "green",
        secondaryColor: "mint_midnight",
        sparkleColor: "marigold"
    },
    {
        name: "JustDial",
        primaryColor: "sky",
        secondaryColor: "orange",
        sparkleColor: "mint"
    },
    {
        name: "JioTVplus",
        primaryColor: "crimson",
        secondaryColor: "marigold",
        sparkleColor: "red"
    },
    {
        name: "JioHealthHub",
        primaryColor: "mint",
        secondaryColor: "sky_midnight",
        sparkleColor: "red"
    },
    {
        name: "JioGlobal",
        primaryColor: "reliance",
        secondaryColor: "navi",
        sparkleColor: "sky"
    },
    {
        name: "JioSaavn",
        primaryColor: "mint",
        secondaryColor: "sky",
        sparkleColor: "navi"
    },
    {
        name: "JioEvents",
        primaryColor: "mint",
        secondaryColor: "purple",
        sparkleColor: "pink"
    },
    {
        name: "JioFit",
        primaryColor: "Orange",
        secondaryColor: "Purple",
        sparkleColor: "Mint"
    },
    {
        name: "JioMarket",
        primaryColor: "purple_midnight",
        secondaryColor: "red",
        sparkleColor: "orange"
    },
    {
        name: "JioAssist",
        primaryColor: "reliance",
        secondaryColor: "navi",
        sparkleColor: "mint"
    },
    {
        name: "JioChannels",
        primaryColor: "navi",
        secondaryColor: "orange",
        sparkleColor: "pink"
    },
    {
        name: "JioBase",
        primaryColor: "navi",
        secondaryColor: "marigold",
        sparkleColor: "mint"
    },
    {
        name: "JioCloud",
        primaryColor: "sky",
        secondaryColor: "mint",
        sparkleColor: "marigold"
    },
    {
        name: "JioAds",
        primaryColor: "navi",
        secondaryColor: "red",
        sparkleColor: "sky"
    },
    {
        name: "JioKrishi",
        primaryColor: "green_midnight",
        secondaryColor: "orange",
        sparkleColor: "marigold"
    },
    {
        name: "JioCinema",
        primaryColor: "pink",
        secondaryColor: "violet_midnight",
        sparkleColor: "marigold"
    },
    {
        name: "JioMart Digital Business",
        primaryColor: "purple_midnight",
        secondaryColor: "red",
        sparkleColor: "green"
    },
    {
        name: "MyJio",
        primaryColor: "reliance",
        secondaryColor: "navi_midnight",
        sparkleColor: "sky"
    },
    {
        name: "JioGlass",
        primaryColor: "crimson",
        secondaryColor: "purple_midnight",
        sparkleColor: "orange"
    },
    {
        name: "JioDive",
        primaryColor: "purple",
        secondaryColor: "mint",
        sparkleColor: "sky"
    },
    {
        name: "JioCall",
        primaryColor: "green",
        secondaryColor: "violet",
        sparkleColor: "navi"
    },
    {
        name: "JioEngage",
        primaryColor: "violet_midnight",
        secondaryColor: "red",
        sparkleColor: "marigold"
    },
    {
        name: "JioCX",
        primaryColor: "purple",
        secondaryColor: "navi_midnight",
        sparkleColor: "orange"
    },
    {
        name: "JioFinance",
        primaryColor: "gold",
        secondaryColor: "orange_midnight",
        sparkleColor: "sky_midnight"
    },
    {
        name: "JioPos",
        primaryColor: "mint",
        secondaryColor: "red_midnight",
        sparkleColor: "orange"
    },
    {
        name: "JioNews",
        primaryColor: "crimson",
        secondaryColor: "orange",
        sparkleColor: "sky"
    },
    {
        name: "JioMart Digital",
        primaryColor: "purple_midnight",
        secondaryColor: "red",
        sparkleColor: "green"
    },
    {
        name: "JioID",
        primaryColor: "reliance",
        secondaryColor: "navi_midnight",
        sparkleColor: "green"
    },
    {
        name: "JioHome",
        primaryColor: "sky",
        secondaryColor: "purple_midnight",
        sparkleColor: "orange"
    },
    {
        name: "JioMart",
        primaryColor: "sky",
        secondaryColor: "red",
        sparkleColor: "green"
    },
    {
        name: "JioMart Partner",
        primaryColor: "sky",
        secondaryColor: "red",
        sparkleColor: "green"
    },
    {
        name: "JioGauSamridhhi",
        primaryColor: "orange",
        secondaryColor: "green_midnight",
        sparkleColor: "pink_midnight"
    },
    {
        name: "JioWallet",
        primaryColor: "reliance",
        secondaryColor: "navi_midnight",
        sparkleColor: "orange"
    },
    {
        name: "JioJoin",
        primaryColor: "green",
        secondaryColor: "purple",
        sparkleColor: "marigold"
    },
    {
        name: "JioSecure",
        primaryColor: "mint",
        secondaryColor: "reliance_midnight",
        sparkleColor: "sky_light"
    },
    {
        name: "JioCare",
        primaryColor: "reliance",
        secondaryColor: "navi",
        sparkleColor: "pink"
    },
    {
        name: "JioSphere",
        primaryColor: "mint",
        secondaryColor: "sky_midnight",
        sparkleColor: "orange"
    },
    {
        name: "JioChat",
        primaryColor: "navi",
        secondaryColor: "orange",
        sparkleColor: "sky"
    },
    {
        name: "JioCloud PC",
        primaryColor: "sky",
        secondaryColor: "marigold",
        sparkleColor: "orange"
    },
    {
        name: "jio com",
        primaryColor: "reliance",
        secondaryColor: "navi_midnight",
        sparkleColor: "sky"
    },
    {
        name: "JioWave",
        primaryColor: "purple",
        secondaryColor: "sky",
        sparkleColor: "mint"
    },
    {
        name: "JioWorkspace",
        primaryColor: "purple",
        secondaryColor: "marigold",
        sparkleColor: "reliance"
    },
    {
        name: "JioFacility",
        primaryColor: "indigo",
        secondaryColor: "marigold",
        sparkleColor: "orange"
    },
    {
        name: "MyJio1",
        primaryColor: "indigo",
        secondaryColor: "saffron",
        sparkleColor: "green"
    }
];
const $e3613f6017c674c5$var$camelCase = (s, separator = "-")=>s.split(separator).map((segment, index)=>index === 0 ? segment : segment.charAt(0).toUpperCase() + segment.slice(1)).join("");
const $e3613f6017c674c5$var$clearModeFromColor = (color)=>{
    return color.replace(/_(light|dark|dim)+/i, "");
};
const $e3613f6017c674c5$var$transformThemeName = (name)=>name.split("-").map((segment)=>segment.charAt(0).toUpperCase() + segment.slice(1)).join("");
const $e3613f6017c674c5$var$normalizedThemeData = $e3613f6017c674c5$export$616d0e83e98f2255.map((data)=>({
        ...data,
        name: $e3613f6017c674c5$var$transformThemeName(data.name)
    }));
const $e3613f6017c674c5$export$e330aa996edc4437 = (theme)=>{
    const normalizedTheme = $e3613f6017c674c5$var$transformThemeName(theme);
    const currentTheme = $e3613f6017c674c5$var$normalizedThemeData.find((data)=>$e3613f6017c674c5$var$camelCase(normalizedTheme) === $e3613f6017c674c5$var$camelCase(data.name));
    let colors = {
        primary: $e3613f6017c674c5$export$616d0e83e98f2255[0].primaryColor,
        secondary: $e3613f6017c674c5$export$616d0e83e98f2255[0].secondaryColor,
        sparkle: $e3613f6017c674c5$export$616d0e83e98f2255[0].sparkleColor,
        neutral: "neutral"
    };
    if (currentTheme) {
        const { primaryColor: primaryColor, secondaryColor: secondaryColor, sparkleColor: sparkleColor } = currentTheme;
        colors = {
            primary: primaryColor?.toLowerCase(),
            secondary: secondaryColor?.toLowerCase(),
            sparkle: sparkleColor?.toLowerCase(),
            neutral: "neutral"
        };
    }
    colors.primary = $e3613f6017c674c5$var$clearModeFromColor(colors.primary);
    colors.secondary = $e3613f6017c674c5$var$clearModeFromColor(colors.secondary);
    colors.sparkle = $e3613f6017c674c5$var$clearModeFromColor(colors.sparkle);
    return colors;
};



/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $eeb0961446aae8e3$export$6100ba28696e12de(buf);
    else return $eeb0961446aae8e3$export$6100ba28696e12de(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$51861dfc7ca9d588$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $eeb0961446aae8e3$export$d622b2ad8d90c771($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $8bd3c5c9ee0d1eb4$require$Buffer = $51861dfc7ca9d588$export$a143d493d941bafc;
const $8bd3c5c9ee0d1eb4$var$index = '';
const $8bd3c5c9ee0d1eb4$export$1ec1d45228a8d241 = [
    "primary",
    "secondary",
    "sparkle",
    "theme",
    "mode",
    "surface",
    "scale",
    "emphasis",
    "appearance",
    "strokeSurface",
    "accent"
];
let $8bd3c5c9ee0d1eb4$var$defaultTokenValues = {
    theme: "MyJio",
    mode: "light",
    scale: 25,
    density: "default",
    lang: "en",
    platform: "mobile",
    appearance: "neutral",
    surface: "default"
};
function $8bd3c5c9ee0d1eb4$export$d239735146a56826(value) {
    $8bd3c5c9ee0d1eb4$var$defaultTokenValues = {
        ...$8bd3c5c9ee0d1eb4$var$defaultTokenValues,
        ...value,
        ...(0, $f8fd43f1ee3f8cd8$export$e330aa996edc4437)(value.theme || $8bd3c5c9ee0d1eb4$var$defaultTokenValues.theme)
    };
}
function $8bd3c5c9ee0d1eb4$export$dfce236e857ed8b0() {
    return {
        ...$8bd3c5c9ee0d1eb4$var$defaultTokenValues,
        ...(0, $f8fd43f1ee3f8cd8$export$e330aa996edc4437)($8bd3c5c9ee0d1eb4$var$defaultTokenValues.theme)
    };
}
const $8bd3c5c9ee0d1eb4$var$EVENTS_MAP = {
    onClick: "onClick",
    onFocus: "onFocus",
    onBlur: "onBlur",
    onHover: "onMouseEnter",
    onChange: "onChange",
    onHoverEnd: "onMouseLeave",
    onKeydown: "onKeyDown",
    onKeyup: "onKeyUp",
    onInvalid: "onInvalid",
    onLoad: "onLoad",
    onError: "onError",
    onPaste: "onPaste",
    onScroll: "onScroll",
    onSwipeLeft: [
        "onPointerDown",
        "onPointerMove",
        "onPointerUp",
        "onPointerOut",
        "onDragStart",
        "onDragEnd"
    ]
};
const $8bd3c5c9ee0d1eb4$var$filterInvalidValue = (v)=>{
    if (typeof v === "undefined") return false;
    if (v === "") return false;
    if (v === null) return false;
    return true;
};
function $8bd3c5c9ee0d1eb4$var$getEventName(key) {
    const match = Object.keys($8bd3c5c9ee0d1eb4$var$EVENTS_MAP).find((evt)=>key === evt);
    const matchedEvent = $8bd3c5c9ee0d1eb4$var$EVENTS_MAP[match];
    return matchedEvent;
}
const $8bd3c5c9ee0d1eb4$var$internalLayerPrefixes = [
    "jds",
    "tooltip"
];
const $8bd3c5c9ee0d1eb4$var$processConfigAPI = (config, values, layerProps)=>{
    if (!values) return {};
    const finalData = {};
    Object.entries(config || {}).forEach(([name, item])=>{
        const resolvedConfigValues = item.values || [];
        if (!layerProps?.[name]) {
            if (!resolvedConfigValues.includes(values[name])) {
                if ($8bd3c5c9ee0d1eb4$var$filterInvalidValue(resolvedConfigValues[0])) finalData[name] = resolvedConfigValues[0];
            } else if ($8bd3c5c9ee0d1eb4$var$filterInvalidValue(values[name])) finalData[name] = values[name];
        }
    });
    return finalData;
};
const $8bd3c5c9ee0d1eb4$var$acceptedInternalProps = [
    "internalIndex",
    "layerRefs",
    "className",
    "internalClasses",
    "tabIndex",
    "slideIndex"
];
const $8bd3c5c9ee0d1eb4$var$processDataAPI = (api, currentLayer, values)=>{
    if (!currentLayer) return {};
    const processData = {};
    const processChildren = {};
    const processedEvents = {};
    let processedA11y = {};
    const { data: data = {}, events: events, children: children = {} } = api;
    if (children[currentLayer]) processChildren[currentLayer] = values[children[currentLayer].name];
    const currentDataItem = data[currentLayer];
    Object.entries(currentDataItem || {}).forEach(([name, { name: propName = "" }])=>{
        const currentName = propName.slice(propName.lastIndexOf(".") + 1, propName.length);
        const value = (0, $bff35c0dd9851fab$export$3988ae62b71be9a3)(values, propName, void 0) || (0, $bff35c0dd9851fab$export$3988ae62b71be9a3)(values, currentName, void 0);
        if (typeof value !== "undefined") processData[name] = value;
    });
    if (events) {
        const currentEventItem = events[currentLayer];
        if (currentEventItem) Object.entries(currentEventItem).forEach(([internalName, valueName])=>{
            const eventMapItem = $8bd3c5c9ee0d1eb4$var$getEventName(internalName);
            const resolvedName = typeof valueName === "string" ? valueName : valueName.name;
            if (!Array.isArray(eventMapItem)) {
                const baseLayer = $8bd3c5c9ee0d1eb4$var$getBaseLayerName(currentLayer);
                const key = baseLayer.startsWith("jds_") ? internalName : eventMapItem;
                if (!key) return;
                processedEvents[key] = values[resolvedName] || values[eventMapItem];
            } else {
                eventMapItem.forEach((item)=>{
                    if (item) processedEvents[item] = values[item];
                });
                if (internalName) processedEvents[internalName] = values[resolvedName];
            }
        });
    }
    if (api.a11y) processedA11y = $8bd3c5c9ee0d1eb4$var$processA11yData(api.a11y, currentLayer, values);
    $8bd3c5c9ee0d1eb4$var$acceptedInternalProps.map((item)=>{
        if (item in values) processData[item] = values[item];
    });
    return {
        processData: processData,
        processedEvents: processedEvents,
        processedA11y: processedA11y,
        processedChildren: processChildren
    };
};
const $8bd3c5c9ee0d1eb4$var$processA11yData = (data, layer, api)=>{
    if (!data[layer]) return {};
    const { properties: properties } = data[layer];
    if (!properties) return {};
    const processed = {};
    Object.entries(properties).forEach(([internalProperty, property])=>{
        if (typeof property === "string") {
            const normalisedProperty = property.slice(property.lastIndexOf(".") + 1, property.length);
            processed[internalProperty] = api[normalisedProperty];
        } else {
            const { name: name, value: value, prop: prop } = property;
            const normalisedName = name?.slice(name.lastIndexOf(".") + 1, name.length);
            const defaultValue = api[prop || ""] || value;
            processed[internalProperty] = api[normalisedName] || defaultValue;
        }
    });
    return processed;
};
const $8bd3c5c9ee0d1eb4$var$validateProp = (prop)=>{
    if (typeof prop === "undefined") return false;
    if (prop === null) return false;
    if (prop === "") return false;
    return true;
};
const $8bd3c5c9ee0d1eb4$var$mergeStyleProperties = (props, uiTokens, data, layerProps)=>{
    const modifiedStyles = (0, $bff35c0dd9851fab$export$629a2bd3f5a49ecc)(uiTokens);
    Object.entries(data || {}).forEach(([layer, properties])=>{
        Object.entries(properties).forEach(([internalName, { name: name }])=>{
            modifiedStyles[layer] = modifiedStyles[layer] || {};
            if ($8bd3c5c9ee0d1eb4$var$validateProp(props[name])) {
                if (name in (0, $6eea7234d56610fe$export$95994f4e1548c018)) {
                    if (!layerProps[layer] || !(name in layerProps[layer]) || $8bd3c5c9ee0d1eb4$export$1ec1d45228a8d241.includes(name)) modifiedStyles[layer][name] = props[name];
                    else delete modifiedStyles[layer][name];
                } else delete modifiedStyles[layer][name];
                if (internalName in (0, $6eea7234d56610fe$export$95994f4e1548c018)) {
                    if (!layerProps[layer] || !(internalName in layerProps[layer])) modifiedStyles[layer][internalName] = props[name];
                    else delete modifiedStyles[layer][internalName];
                } else delete modifiedStyles[layer][internalName];
            }
        });
    });
    return modifiedStyles;
};
const $8bd3c5c9ee0d1eb4$var$allowedLayerProps = [
    "disabled",
    "transition"
];
const $8bd3c5c9ee0d1eb4$var$seperateComponentLayerProps = (styles = {}, props)=>{
    const layerProps = {};
    Object.entries(styles).forEach(([currentlayer, currentStyles])=>{
        const layerElements = currentlayer.split("-");
        const layerName = layerElements[layerElements.length - 1];
        if (!layerProps[currentlayer]) layerProps[currentlayer] = {};
        const isInternalLayer = $8bd3c5c9ee0d1eb4$var$internalLayerPrefixes.find((i)=>layerName.startsWith(i));
        if (isInternalLayer) Object.entries(currentStyles || {}).forEach(([property, value])=>{
            layerProps[currentlayer][property] = value;
        });
        if (styles.value) layerProps[currentlayer].value = currentStyles.value;
        Object.entries(currentStyles).forEach(([property, value])=>{
            if (!(property in (0, $6eea7234d56610fe$export$95994f4e1548c018))) {
                if (!(currentlayer in layerProps)) layerProps[currentlayer] = {};
                layerProps[currentlayer][property] = value;
            } else if ($8bd3c5c9ee0d1eb4$var$allowedLayerProps.includes(property)) layerProps[currentlayer][property] = value;
        });
    });
    return {
        layerProps: layerProps,
        styles: styles
    };
};
const $8bd3c5c9ee0d1eb4$var$BufferConverter = (value)=>{
    return $8bd3c5c9ee0d1eb4$require$Buffer.from(value, "base64").toString("utf-8");
};
const $8bd3c5c9ee0d1eb4$var$convertBase64ToObject = (value)=>{
    if (!value) return {};
    const converter = typeof window === "undefined" ? $8bd3c5c9ee0d1eb4$var$BufferConverter : window.atob;
    const objectString = converter(value);
    return JSON.parse(objectString || "{}");
};
const $8bd3c5c9ee0d1eb4$var$classNames = (...classes)=>classes.filter(Boolean).join(" ");
const $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9 = (custom)=>{
    const base64 = custom.includes("--") ? (custom?.split("--") || [])[1] : custom;
    const convertedCustom = $8bd3c5c9ee0d1eb4$var$convertBase64ToObject(base64);
    return convertedCustom;
};
const $8bd3c5c9ee0d1eb4$var$getBaseLayerName = (layer = "")=>{
    const parts = layer.split("-");
    return parts[parts.length - 1];
};
const $8bd3c5c9ee0d1eb4$export$7d15b64cf5a3a4c4 = (value, min, max)=>Math.max(min, Math.min(value, max));
const $8bd3c5c9ee0d1eb4$export$9382739d0e79620f = (props)=>{
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: props.style,
        className: $8bd3c5c9ee0d1eb4$var$classNames(props.className, "progress-animateContainer")
    });
};
function $8bd3c5c9ee0d1eb4$var$polarToCartesian(centerX, centerY, radius, angleInDegrees) {
    const angleInRadians = (angleInDegrees - 90) * Math.PI / 180;
    return {
        x: centerX + radius * Math.cos(angleInRadians),
        y: centerY + radius * Math.sin(angleInRadians)
    };
}
function $8bd3c5c9ee0d1eb4$var$describeArc(x, y, radius, startAngle, endAngle) {
    const start = $8bd3c5c9ee0d1eb4$var$polarToCartesian(x, y, radius, endAngle);
    const end = $8bd3c5c9ee0d1eb4$var$polarToCartesian(x, y, radius, startAngle);
    const largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";
    const d = [
        "M",
        start.x,
        start.y,
        "A",
        radius,
        radius,
        0,
        largeArcFlag,
        0,
        end.x,
        end.y
    ].join(" ");
    return d;
}
function $8bd3c5c9ee0d1eb4$var$getColorVariable(val, tokens = {}) {
    if (typeof val === "string") {
        if (val.match(/[{}]/)) {
            if (val.includes("&")) tokens = (0, $6eea7234d56610fe$export$859883d4ec9c7db4).updateFlatTokens({
                ...tokens,
                surface: val.split("_")[2].replace("}", "")
            });
            return (0, $6eea7234d56610fe$export$6a176e754d54672)("color", val, tokens);
        }
    }
    return val.toString();
}
function $8bd3c5c9ee0d1eb4$var$getValue(val, rule, tokens = {}) {
    if (typeof val === "string") {
        if (val.match(/[{}]/)) return (0, $6eea7234d56610fe$export$6a176e754d54672)(rule, val, tokens);
    }
    return (0, $6eea7234d56610fe$export$95c38a73fd251991)(rule, val);
}
const $8bd3c5c9ee0d1eb4$export$6ef80ffb606dd232 = ({ radius: radius = 0, start: start = 0, end: end = 0, fill: fill, className: className, arcWidth: arcWidth = 10, "animation-delay": animationDelay = "0ms", layer: layer, animate: animate, ...rest })=>{
    start = parseInt($8bd3c5c9ee0d1eb4$var$getValue(start, "rotate"), 10);
    end = parseInt($8bd3c5c9ee0d1eb4$var$getValue(end, "rotate"), 10);
    radius = parseInt($8bd3c5c9ee0d1eb4$var$getValue(radius, "width"), 10);
    arcWidth = parseInt($8bd3c5c9ee0d1eb4$var$getValue(arcWidth, "width"), 10);
    animationDelay = $8bd3c5c9ee0d1eb4$var$getValue(animationDelay, "transition-delay");
    animationDelay = animationDelay.includes("ms") ? animationDelay : animationDelay + "ms";
    const strokeWidth = end - start === 0 ? 0 : arcWidth / 2;
    const diameter = radius * 2;
    const halfRadius = radius / 2;
    const circumference = 2 * Math.PI * halfRadius;
    const percent = end / 360 * 100;
    const dash = percent * circumference / 100;
    const midRadius = radius + strokeWidth;
    const durationKey = Object.keys(rest.style || {}).find((key)=>key.endsWith("transition-duration"));
    const variables = {
        "--diameter": diameter,
        "--rotate": `-${end}deg`,
        "--fill-color": $8bd3c5c9ee0d1eb4$var$getColorVariable(fill || "currentcolor", $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e()),
        "--animation-delay": animationDelay,
        "--animation-duration": rest.style?.[durationKey] || (rest["animation-duration"] || 2.5) + "s",
        "--offset": animate ? "100px" : `${dash}px ${circumference - dash}px`,
        "--end": end * Math.PI / 180,
        "--start": start * Math.PI / 180,
        "--start-anim-offset": `${circumference}px`,
        "--end-anim-offset": `-${circumference}px`
    };
    const animateClass = animate ? "jds-spinner-circle-animate" : "";
    const arc = (0, $acw62.useMemo)(()=>{
        return $8bd3c5c9ee0d1eb4$var$describeArc(midRadius / 2, midRadius / 2, radius / 2, start, end);
    }, [
        start,
        end,
        midRadius
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: $8bd3c5c9ee0d1eb4$var$classNames(className, animateClass),
        style: {
            width: diameter,
            height: diameter,
            ...variables
        },
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
            className: $8bd3c5c9ee0d1eb4$var$classNames("jds-spinner-circle", `circle-${layer}`, animate ? "animate" : ""),
            viewBox: `0 0 ${radius + arcWidth / 2} ${radius + arcWidth / 2}`,
            children: Math.abs(end - start) === 360 || animate ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("circle", {
                fill: "none",
                stroke: variables["--fill-color"],
                r: halfRadius,
                cx: midRadius / 2,
                cy: midRadius / 2,
                strokeWidth: strokeWidth,
                strokeLinecap: "round"
            }) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: arc,
                strokeLinecap: "round",
                className: $8bd3c5c9ee0d1eb4$var$classNames(animate ? "animated" : ""),
                strokeWidth: strokeWidth,
                stroke: variables["--fill-color"],
                fill: "none",
                "data-dimension": `${end}-${start}-${end - start}`
            })
        })
    });
};
const $8bd3c5c9ee0d1eb4$var$unsafeProps = [
    "height",
    "padding",
    "opacity",
    "translate-y",
    "translate-x",
    "max-height"
];
const $8bd3c5c9ee0d1eb4$export$31627395a3b18e54 = (props)=>{
    const [internalHidden, setInternalHidden] = (0, $acw62.useState)(!props.animatedProperties?.length);
    (0, $acw62.useEffect)(()=>{
        if (!props.hidden) setInternalHidden(false);
    }, [
        props.hidden
    ]);
    const hasProperties = $8bd3c5c9ee0d1eb4$var$unsafeProps.some((property)=>props.animatedProperties?.includes(property));
    if (props.hidden) {
        if (!props.animatedProperties?.length) return null;
        if (!internalHidden) {
            if (!hasProperties) return null;
            return props.children || null;
        }
        if (hasProperties) return props.children;
        return null;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(props.children || /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}), {
        onTransitionEnd: (ev)=>{
            if (props.hidden) setInternalHidden(true);
        }
    });
};
const $8bd3c5c9ee0d1eb4$var$registeredIcons = {
    ...$7484f88fafffadc1$exports
};
const $8bd3c5c9ee0d1eb4$export$99b432e1290ef823 = (icons)=>{
    Object.assign($8bd3c5c9ee0d1eb4$var$registeredIcons, icons);
};
const $8bd3c5c9ee0d1eb4$export$d824b604106683ab = (icons)=>Object.keys(icons).filter((icon)=>typeof icons[icon] === "function");
const $8bd3c5c9ee0d1eb4$export$75b0b37acc90e887 = (ic)=>{
    if (typeof ic === "string") {
        const NewIcon = $8bd3c5c9ee0d1eb4$var$registeredIcons[ic];
        if (!NewIcon) return null;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(NewIcon, {});
    }
    return ic;
};
const $8bd3c5c9ee0d1eb4$export$f04a61298a47a40f = ({ value: value, events: events, style: style, layer: layer, className: className, role: role, _isLottieVisible: _isLottieVisible, "aria-label": ariaLabel, "aria-describedby": ariaDescribedby, ...rest })=>{
    const stringIcon = typeof value === "string";
    const camelCaseIcon = !stringIcon ? value : (0, $bff35c0dd9851fab$export$26c6f48841fe1a8a)(value || "", "_");
    const icon = $8bd3c5c9ee0d1eb4$export$75b0b37acc90e887(camelCaseIcon);
    if (!value) return null;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($8bd3c5c9ee0d1eb4$export$31627395a3b18e54, {
        hidden: [
            true,
            "true"
        ].includes(rest.hidden),
        animatedProperties: rest.transition?.property,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(icon) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(icon, {
            "data-testid": rest?.["data-testid"] || "icon-root",
            className: $8bd3c5c9ee0d1eb4$var$classNames("icon-atom", className),
            ...events,
            style: style,
            "data-iconname": stringIcon ? value?.toLowerCase() : void 0,
            "data-hidden": rest.hidden,
            "data-transition": Boolean(rest.transition),
            role: role,
            "aria-label": ariaLabel,
            "aria-describedby": ariaDescribedby
        })
    });
};
const $8bd3c5c9ee0d1eb4$export$f5b8910cec6cf069 = (props)=>{
    const { disabled: disabled, className: className, children: children, type: type = "text", internalIndex: internalIndex, root: root, rootRef: rootRef, textAlign: textAlign, events: events = {}, "aria-label": ariaLabel, "aria-describedby": ariaDescribedby, "aria-invalid": ariaInvalid, "aria-required": _ariaRequired, "aria-placeholder": _ariaPlaceholder, _childrenProps: _childrenProps, processedA11y: processedA11y, textSize: textSize, layerRefs: layerRefs, isContainerFocusable: isContainerFocusable, componentTag: componentTag, ...rest } = props;
    const combinedStyles = {
        ...rest?.style,
        textAlign: textAlign
    };
    const commonProps = {
        ...events,
        ...rest,
        style: combinedStyles,
        disabled: disabled,
        maxLength: rest["max-length"],
        value: rest.value
    };
    switch(type.toLowerCase()){
        case "textarea":
            return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-area-wrapper",
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                    ref: layerRefs?.[rest.layer],
                    ...commonProps,
                    className: $8bd3c5c9ee0d1eb4$var$classNames("jds-input-atom", className, "jds-textarea-atom"),
                    "aria-label": ariaLabel,
                    "aria-describedby": ariaDescribedby,
                    "aria-invalid": ariaInvalid,
                    "aria-required": _ariaRequired,
                    "aria-placeholder": _ariaPlaceholder
                })
            });
        case "phone":
            return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("input", {
                ...commonProps,
                value: commonProps.value ? String(commonProps.value).slice(0, commonProps["max-length"]) : props.value,
                maxLength: void 0,
                ref: layerRefs?.[rest.layer],
                type: "tel",
                className: $8bd3c5c9ee0d1eb4$var$classNames("jds-input-atom", className)
            });
        default:
            return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("input", {
                ...commonProps,
                value: commonProps.value ? String(commonProps.value).slice(0, commonProps["max-length"]) : props.value,
                maxLength: void 0,
                type: type,
                ref: layerRefs?.[rest.layer],
                className: $8bd3c5c9ee0d1eb4$var$classNames("jds-input-atom", className),
                "aria-label": ariaLabel,
                "aria-describedby": ariaDescribedby,
                "aria-invalid": ariaInvalid,
                "aria-required": _ariaRequired,
                "aria-placeholder": _ariaPlaceholder
            });
    }
};
const $8bd3c5c9ee0d1eb4$export$3b0d6d7590275603 = (props)=>{
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
        "data-testid": "loader-root",
        ...props,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($8bd3c5c9ee0d1eb4$var$Spinner, {})
    });
};
const $8bd3c5c9ee0d1eb4$var$Spinner = ()=>{
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "j-spinner",
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
                className: "circle circle-0",
                viewBox: "0 0 28 28",
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("circle", {
                    "data-testid": "spinner-circle-icon",
                    fill: "none",
                    strokeWidth: "4",
                    strokeLinecap: "round",
                    cx: "14",
                    cy: "14",
                    r: "12"
                })
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
                className: "circle circle-1",
                viewBox: "0 0 28 28",
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("circle", {
                    "data-testid": "spinner-circle-icon",
                    fill: "none",
                    strokeWidth: "4",
                    strokeLinecap: "round",
                    cx: "14",
                    cy: "14",
                    r: "12"
                })
            })
        ]
    });
};
const $8bd3c5c9ee0d1eb4$var$WINDOW = typeof window === "object" && window || void 0;
const $8bd3c5c9ee0d1eb4$var$defaultBreakpoints = {
    xmobile: 323,
    mobile: 619,
    tablet: 991,
    desktop: 992,
    widescreen: 1280,
    hd: 1920
};
class $8bd3c5c9ee0d1eb4$var$Devices {
    static withSizes(breakpoints) {
        this.breakpoints = Object.assign(this.breakpoints, breakpoints);
        return this;
    }
    /**
   * is width xmobile and below
   */ static isXMobile() {
        const width = $8bd3c5c9ee0d1eb4$var$WINDOW?.innerWidth || 1e3;
        return width <= this.breakpoints.xmobile;
    }
    /**
   * is width mobile and below. returns true even on xmobile
   */ static isMobile() {
        const width = $8bd3c5c9ee0d1eb4$var$WINDOW?.innerWidth || 1e3;
        return width <= this.breakpoints.mobile;
    }
    /**
   * is width above mobile and below desktop
   */ static isTabletOnly() {
        const width = $8bd3c5c9ee0d1eb4$var$WINDOW?.innerWidth || 1e3;
        return width <= this.breakpoints.tablet && width > this.breakpoints.mobile;
    }
    /**
   * is width less than tablet? returns true even on mobile and xmobile
   */ static isTablet() {
        const width = $8bd3c5c9ee0d1eb4$var$WINDOW?.innerWidth || 1e3;
        return width <= this.breakpoints.tablet;
    }
    /**
   * is width greater than tablet?
   */ static isDesktop() {
        const width = $8bd3c5c9ee0d1eb4$var$WINDOW?.innerWidth || 1e3;
        return width >= this.breakpoints.tablet;
    }
    /**
   * is width greater than max-flex of desktop (1280px). i.e the breakpoint after which
   * max-width does not keep growing.
   */ static isWidescreen() {
        const width = $8bd3c5c9ee0d1eb4$var$WINDOW?.innerWidth || 0;
        return width >= this.breakpoints.widescreen;
    }
    /**
   * is width greater than or equal to HD.
   */ static isHD() {
        const width = $8bd3c5c9ee0d1eb4$var$WINDOW?.innerWidth || 0;
        return width >= this.breakpoints.hd;
    }
    /**
   * Re-renders functional component at Breakpoints from defaultBreakpoints.
   * @returns ```
   {
        xmobile: boolean,
        mobile: boolean,
        tablet: boolean,
        desktop: boolean,
        widescreen: boolean,
        hd: boolean
    }
   ```
   * [xmobile < mobile < tablet] [desktop > widescreen > HD]
   * tablet will be true even when xmobile and mobile are true.
   * desktop will be true even when widescreen and hd are true.
   *
   *
   * Breakpoints can be overridden by calling withSizes() first.
   * e.g. Devices.withSizes(mySize).useMedia()
   */ static useMedia() {
        const queries = [
            `(max-width: ${this.breakpoints.xmobile}px)`,
            `(max-width: ${this.breakpoints.mobile}px)`,
            `(max-width: ${this.breakpoints.tablet}px)`,
            `(min-width: ${this.breakpoints.desktop}px)`,
            `(min-width: ${this.breakpoints.widescreen}px)`,
            `(min-width: ${this.breakpoints.hd}px)`
        ];
        const mediaQueryLists = queries.map((q)=>$8bd3c5c9ee0d1eb4$var$WINDOW?.matchMedia && $8bd3c5c9ee0d1eb4$var$WINDOW.matchMedia(q));
        const getValue = ()=>{
            const matchedResults = mediaQueryLists.map((mql)=>mql?.matches);
            const valObj = {
                xmobile: false,
                mobile: false,
                tablet: false,
                desktop: false,
                widescreen: false,
                hd: false
            };
            Object.keys(this.breakpoints).forEach((key, i)=>{
                valObj[key] = matchedResults[i];
            });
            return valObj;
        };
        const [value, setValue] = (0, $acw62.useState)(getValue);
        (0, $acw62.useEffect)(()=>{
            const handler = ()=>setValue(getValue);
            mediaQueryLists.forEach((mql)=>mql?.addListener(handler));
            return ()=>mediaQueryLists.forEach((mql)=>mql?.removeListener(handler));
        }, []);
        return value;
    }
}
$8bd3c5c9ee0d1eb4$var$Devices.breakpoints = $8bd3c5c9ee0d1eb4$var$defaultBreakpoints;
const $8bd3c5c9ee0d1eb4$var$layersWithStyleAttr = [
    "button",
    "div"
];
const $8bd3c5c9ee0d1eb4$var$filterUniqueTokens = (newTokens, existingTokens)=>{
    if (newTokens._source === "popup") return newTokens;
    return (0, $bff35c0dd9851fab$export$b460b275d6c6aa0)(newTokens, (value, key)=>!(key in existingTokens) || existingTokens[key] !== value);
};
const $8bd3c5c9ee0d1eb4$var$resolvePlatform = (exisintPlatform)=>{
    const platform = $8bd3c5c9ee0d1eb4$var$Devices.useMedia();
    if (platform.desktop || platform.widescreen || platform.hd) return "desktop";
    if (platform.tablet) return "tablet";
    return "mobile";
};
const $8bd3c5c9ee0d1eb4$export$3e90a26ba68b9c65 = (0, $acw62.createContext)({});
const $8bd3c5c9ee0d1eb4$var$registerBrandAndFetchTokenVars = (value, existingTokens, brandTokens)=>{
    const defaultTokenValues = $8bd3c5c9ee0d1eb4$export$dfce236e857ed8b0();
    const mode = value.mode || existingTokens.mode || defaultTokenValues.mode;
    let tokens$1 = {
        scale: existingTokens.scale || (mode === "dark" ? 2 : 25),
        ...defaultTokenValues,
        ...existingTokens,
        parentAppearance: existingTokens.appearance,
        currentAppearance: value.appearance || "auto",
        surface: value.surface || "ghost",
        ...(0, $f8fd43f1ee3f8cd8$export$e330aa996edc4437)(value.theme || existingTokens.theme || defaultTokenValues.theme),
        ...Object.fromEntries(Object.entries(value).filter(([_, v])=>v !== "auto"))
    };
    if (!tokens$1._registered || brandTokens) {
        (0, $6eea7234d56610fe$export$859883d4ec9c7db4).registerBrand(brandTokens || (0, $e3613f6017c674c5$export$6ad93df59e712c43));
        tokens$1._registered = true;
    }
    if ((0, $6eea7234d56610fe$export$859883d4ec9c7db4).updateFlatTokens) {
        tokens$1 = (0, $6eea7234d56610fe$export$859883d4ec9c7db4).updateFlatTokens(tokens$1);
        tokens$1.parentScale = existingTokens.scale;
    }
    const equalThemeTokens = $8bd3c5c9ee0d1eb4$export$1ec1d45228a8d241.every((key)=>existingTokens[key] === value[key]);
    const entries = [];
    if (!(equalThemeTokens && !(value._source === "popup"))) {
        const mergedTokens = {
            ...defaultTokenValues,
            ...(0, $f8fd43f1ee3f8cd8$export$e330aa996edc4437)(existingTokens.theme || defaultTokenValues.theme),
            ...existingTokens
        };
        const uniqueTokens = $8bd3c5c9ee0d1eb4$var$filterUniqueTokens(tokens$1, mergedTokens);
        if ((0, $6eea7234d56610fe$export$859883d4ec9c7db4).brandResolverFn) {
            if ([
                "density"
            ].some((item)=>uniqueTokens[item])) {
                const densityMap = (0, $6eea7234d56610fe$export$859883d4ec9c7db4).getDensityMap?.(tokens$1.density ?? "default") ?? {};
                entries.push(...Object.entries(densityMap));
            }
            if ([
                "theme"
            ].some((item)=>uniqueTokens[item])) {
                const colorMap = (0, $6eea7234d56610fe$export$859883d4ec9c7db4).getColorsMap({
                    primary: tokens$1.primary,
                    secondary: tokens$1.secondary,
                    sparkle: tokens$1.sparkle
                });
                entries.push(...Object.entries(colorMap));
            }
        } else {
            const applicableTokens = (0, $6eea7234d56610fe$export$859883d4ec9c7db4).getApplicableTokens(uniqueTokens);
            Object.entries(applicableTokens).forEach(([folderKey, folder])=>Object.entries(folder).forEach(([key, value2])=>{
                    entries.push([
                        (0, $6eea7234d56610fe$export$585f0f7ef40c9f0)(`${folderKey}-${key}`),
                        (0, $6eea7234d56610fe$export$bdcbab1cb38db489)(value2) ? (0, $6eea7234d56610fe$export$c59eaf4f26921ab2)(folderKey, value2, tokens$1) : (0, $6eea7234d56610fe$export$95c38a73fd251991)(folderKey, value2)
                    ]);
                }));
        }
    }
    const styles = Object.fromEntries(entries);
    return {
        styles: styles,
        tokens: tokens$1
    };
};
const $8bd3c5c9ee0d1eb4$export$e5cf4eff53e7947d = ({ value: value, children: children, tokens: brandTokens })=>{
    const defaultTokenValues = $8bd3c5c9ee0d1eb4$export$dfce236e857ed8b0();
    const rootRef = (0, $acw62.useRef)();
    const timeoutRef = (0, $acw62.useRef)();
    value ??= defaultTokenValues;
    const existingTokens = (0, $acw62.useContext)($8bd3c5c9ee0d1eb4$export$3e90a26ba68b9c65);
    value.platform = $8bd3c5c9ee0d1eb4$var$resolvePlatform(value.platform || existingTokens.platform);
    const { styles: styles, tokens: tokens } = (0, $acw62.useMemo)(()=>$8bd3c5c9ee0d1eb4$var$registerBrandAndFetchTokenVars(value, existingTokens, brandTokens), [
        value,
        brandTokens
    ]);
    const isRootProvider = !Object.keys(existingTokens).length;
    (0, $acw62.useEffect)(()=>{
        function listener() {
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
            timeoutRef.current = setTimeout(()=>{
                const root = rootRef.current;
                if (root) {
                    const { padding: padding } = getComputedStyle(root);
                    const base = parseFloat(padding);
                    root.style.setProperty("--base", base.toString());
                }
            }, 100);
        }
        if (isRootProvider && tokens?.["brandVersion"] === "jio-v2") {
            window.addEventListener("resize", listener);
            listener();
        }
        return ()=>{
            if (isRootProvider && tokens?.["brandVersion"] === "jio-v2") window.removeEventListener("resize", listener);
        };
    }, [
        tokens?.["brandVersion"],
        isRootProvider
    ]);
    if (!("brandVersion" in tokens) || tokens?.["brandVersion"] !== "jio-v2") return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            ...styles,
            display: "contents"
        },
        className: "tokens",
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($8bd3c5c9ee0d1eb4$export$3e90a26ba68b9c65.Provider, {
            value: {
                ...tokens
            },
            children: children
        })
    });
    if (isRootProvider) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "tokens-provider v3",
        style: {
            display: "contents",
            padding: "var(--pre-base)",
            ...tokens.maxWidth ? {
                "--viewport": tokens.maxWidth / 100 + "px"
            } : {},
            ...styles
        },
        ref: rootRef,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($8bd3c5c9ee0d1eb4$export$3e90a26ba68b9c65.Provider, {
            value: {
                ...tokens
            },
            children: children
        })
    });
    const newChildren = !Object.keys(styles).length ? children : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.map(children, (child)=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(child)) {
            if ($8bd3c5c9ee0d1eb4$var$layersWithStyleAttr.includes(typeof child.type === "string" ? child.type : child.type.name) && !isRootProvider) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(child, {
                ...child.props,
                style: {
                    ...child.props.style,
                    ...styles
                }
            });
            return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tokens-provider",
                style: {
                    ...styles,
                    display: "contents"
                },
                children: child
            });
        }
        return child;
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($8bd3c5c9ee0d1eb4$export$3e90a26ba68b9c65.Provider, {
        value: {
            ...tokens
        },
        children: newChildren
    });
};
function $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e() {
    const tokenValues = (0, $acw62.useContext)($8bd3c5c9ee0d1eb4$export$3e90a26ba68b9c65);
    if (tokenValues === void 0) throw new Error("useTokenValues must be used within a TokenProvider");
    return tokenValues;
}
const $8bd3c5c9ee0d1eb4$export$31dcd79391e423fe = (value, type)=>{
    const tokens = (0, $acw62.useContext)($8bd3c5c9ee0d1eb4$export$3e90a26ba68b9c65);
    if (tokens === void 0) throw new Error("Please wrap your app in a TokenProvider");
    return (0, $6eea7234d56610fe$export$6a176e754d54672)(type, value, tokens);
};
function $8bd3c5c9ee0d1eb4$var$CustomPortal({ children: children }) {
    const [mounted, setMounted] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        setMounted(true);
    }, []);
    return mounted && typeof window !== "undefined" ? (0, $11492dca620dcaa5$exports.createPortal)(children, document.body) : null;
}
const $8bd3c5c9ee0d1eb4$export$129a32eedafa97c5 = ({ children: children, className: className, style: style, events: events, rootRef: rootRef, layer: layer, ...rest })=>{
    const { alignment: alignment = "top-start", priority: priority } = rest;
    const x = rest.offsetX;
    const y = rest.offsetY;
    const left = alignment.includes("start") && x ? `${x}px` : void 0;
    const right = alignment.includes("end") && x ? `${x}px` : void 0;
    const top = alignment.includes("top") && y ? `${y}px` : void 0;
    const bottom = alignment.includes("bottom") && y ? `${y}px` : void 0;
    const styles = {
        backgroundColor: rest["background-color"],
        pointerEvents: rest.passive ? "none" : "auto",
        "--popup-priority": priority,
        "--popup-left": left,
        "--popup-right": right,
        "--popup-top": top,
        "--popup-bottom": bottom
    };
    const tokens = $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e();
    if (tokens.fromPlugin) return children;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($8bd3c5c9ee0d1eb4$var$CustomPortal, {
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($8bd3c5c9ee0d1eb4$export$e5cf4eff53e7947d, {
            value: {
                ...tokens,
                _source: "popup"
            },
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($8bd3c5c9ee0d1eb4$export$31627395a3b18e54, {
                hidden: rest.hidden,
                animatedProperties: rest.transition?.property,
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                    "data-testid": rest?.["data-testid"],
                    ref: rootRef,
                    style: {
                        ...styles,
                        ...style,
                        pointerEvents: !rest.passive ? "auto" : "none",
                        touchAction: events?.onClick || !rest.passive ? "auto" : "none"
                    },
                    className: $8bd3c5c9ee0d1eb4$var$classNames("jds-popup-layer", className),
                    ...events,
                    onClick: (ev)=>{
                        if (events?.onClick) ev.stopPropagation();
                        events?.onClick?.(ev);
                    },
                    children: children
                })
            })
        })
    });
};
const $8bd3c5c9ee0d1eb4$export$d50980d2cec56085 = ({ layer: layer, style: style, className: className, ...rest })=>{
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: $8bd3c5c9ee0d1eb4$var$classNames("skeleton-animate-loader-container", className),
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
            "data-testid": rest["data-testid"],
            style: style
        })
    });
};
const $8bd3c5c9ee0d1eb4$var$getTokenValue = (type, tokens, value)=>{
    if (!value) return "";
    return (0, $6eea7234d56610fe$export$6404fd1becf96b61)(type, value.toString() || "");
};
function $8bd3c5c9ee0d1eb4$export$1947d5eba3dbedea(value = 0, min = 0, max = 100) {
    const offset = value - min;
    const range = max - min;
    const ratio = offset / range;
    const percentage = (1 - ratio) * 100;
    return Math.round(percentage);
}
function $8bd3c5c9ee0d1eb4$export$762ec5ce8fb56ed0(value, step = 1, min = 0, max = 100) {
    if (typeof value !== "number") return min;
    step = step > 0 ? step : 1;
    const clamped = $8bd3c5c9ee0d1eb4$export$7d15b64cf5a3a4c4(value, min, max);
    return Math.round((clamped - min) / step) * step + min;
}
const $8bd3c5c9ee0d1eb4$export$472062a354075cee = ({ min: min = 0, max: max = 100, "aria-label": ariaLabel, "aria-describedby": ariaDescribedby, "aria-valuenow": _ariaValuenow, "aria-valuemin": _ariaValuemin, "aria-valuemax": _ariaValuemax, ...props })=>{
    const tokens = $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e();
    const ballProperties = {
        "--ball-color": $8bd3c5c9ee0d1eb4$var$getTokenValue("color", tokens, props["ball-color"]),
        "--ball-color--active": $8bd3c5c9ee0d1eb4$var$getTokenValue("color", tokens, props?.behavior.active["ball-color-active"]),
        "--ball-color--hover": $8bd3c5c9ee0d1eb4$var$getTokenValue("color", tokens, props?.behavior.hover["ball-color-active"]),
        "--ball-size": $8bd3c5c9ee0d1eb4$var$getTokenValue("width", tokens, props["ball-size"]),
        "--ball-border-width": $8bd3c5c9ee0d1eb4$var$getTokenValue("width", tokens, props["ball-border-width"]),
        "--ball-border-color": $8bd3c5c9ee0d1eb4$var$getTokenValue("color", tokens, props["ball-border-color"]),
        "--active-color": $8bd3c5c9ee0d1eb4$var$getTokenValue("color", tokens, props["active-color"]),
        "--active-color--active": $8bd3c5c9ee0d1eb4$var$getTokenValue("color", tokens, props?.behavior.active["active-color-active"]),
        "--inactive-color": $8bd3c5c9ee0d1eb4$var$getTokenValue("color", tokens, props["inactive-color"])
    };
    const requiredValue = $8bd3c5c9ee0d1eb4$export$762ec5ce8fb56ed0(props.value, props.step, min, max) || 0;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("input", {
        type: "range",
        step: props.step,
        value: requiredValue,
        min: min,
        max: max,
        size: 2,
        onChange: props.onChange,
        className: [
            props.className,
            "jds-slider-atom"
        ].join(" "),
        "aria-label": ariaLabel,
        "aria-describedby": ariaDescribedby,
        "aria-valuenow": _ariaValuenow,
        "aria-valuemin": _ariaValuemin,
        "aria-valuemax": _ariaValuemax,
        style: {
            ...props.style,
            ...ballProperties,
            height: $8bd3c5c9ee0d1eb4$var$getTokenValue("height", tokens, props["track-height"]),
            "--progress": `${$8bd3c5c9ee0d1eb4$export$1947d5eba3dbedea(requiredValue, min, max)}%`
        }
    });
};
const $8bd3c5c9ee0d1eb4$var$alignClasses = {
    left: "text-left",
    center: "text-center",
    right: "text-right",
    justify: "text-justify"
};
const $8bd3c5c9ee0d1eb4$var$textAlignmentVariable = "--text-tx-al";
const $8bd3c5c9ee0d1eb4$export$5f1af8db9871e1d6 = ({ value: value, events: { onTextLayout: onTextLayout, ...restEvents } = {}, className: className, style: style, layer: layer, textType: textType = "div", role: role, "aria-describedby": ariaDescribedby, ...rest })=>{
    if (typeof value === "undefined" || value === "") return null;
    const currentStyle = typeof style === "object" ? {
        ...style
    } : {};
    const Type = textType?.trim() === "" ? "div" : textType;
    const maxLines = Number(rest["max-lines"]) || 0;
    const maxLineClass = maxLines > 0 && "multi-line";
    const align = currentStyle[$8bd3c5c9ee0d1eb4$var$textAlignmentVariable];
    const alignClass = align ? $8bd3c5c9ee0d1eb4$var$alignClasses[align] ?? "" : "";
    currentStyle["--max-lines"] = maxLines || void 0;
    if (alignClass) delete currentStyle[$8bd3c5c9ee0d1eb4$var$textAlignmentVariable];
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($8bd3c5c9ee0d1eb4$export$31627395a3b18e54, {
        hidden: [
            "true",
            true
        ].includes(rest.hidden),
        animatedProperties: rest.transition?.property,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Type, {
            className: $8bd3c5c9ee0d1eb4$var$classNames("text-atom", className, maxLineClass, alignClass),
            style: currentStyle,
            ...restEvents,
            "data-testid": rest["data-testid"],
            "aria-describedby": ariaDescribedby,
            role: role,
            children: value
        })
    });
};
const $8bd3c5c9ee0d1eb4$export$379139ebc1c2b235 = (props)=>{
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("textarea", {
        ...props,
        className: "jds-input-textarea-atom"
    });
};
const $8bd3c5c9ee0d1eb4$var$VerticalTip = (props)=>{
    const { processedA11y: processedA11y, isContainerFocusable: isContainerFocusable, internalIndex: internalIndex, _childrenProps: _childrenProps, svgClassName: svgClassName, ...svgProps } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: props.className,
        style: {
            boxSizing: "content-box",
            background: "transparent"
        },
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
            ...svgProps,
            className: svgClassName,
            width: "8",
            height: "24",
            viewBox: "0 0 8 24",
            fill: props["background-color"],
            xmlns: "http://www.w3.org/2000/svg",
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                id: "Vector 5",
                d: "M6.87661 14.4244L2.7121 18.1471C0.97557 19.6994 -9.59586e-08 21.8047 0 24L-1.04907e-06 -2.38419e-07C-9.53115e-07 2.19528 0.975566 4.30064 2.71209 5.85293L6.87661 9.57563C8.37446 10.9146 8.37446 13.0854 6.87661 14.4244Z"
            })
        })
    });
};
const $8bd3c5c9ee0d1eb4$var$HorizontalTip = (props)=>{
    const { processedA11y: processedA11y, isContainerFocusable: isContainerFocusable, internalIndex: internalIndex, _childrenProps: _childrenProps, svgClassName: svgClassName, ...svgProps } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: props.className,
        style: {
            display: "flex",
            flexDirection: "column",
            background: "transparent"
        },
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
            ...svgProps,
            className: svgClassName,
            width: "24",
            height: "8",
            viewBox: "0 0 24 8",
            fill: props["background-color"],
            xmlns: "http://www.w3.org/2000/svg",
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                id: "Vector 5",
                d: "M14.4244 1.12338L18.1471 5.2879C19.6994 7.02443 21.8047 8 24 8L-2.38419e-07 8C2.19528 8 4.30064 7.02443 5.85294 5.28791L9.57564 1.12339C10.9146 -0.374462 13.0854 -0.374465 14.4244 1.12338Z"
            })
        })
    });
};
const $8bd3c5c9ee0d1eb4$var$svgDirectionConfig = {
    vertical: $8bd3c5c9ee0d1eb4$var$VerticalTip,
    horizontal: $8bd3c5c9ee0d1eb4$var$HorizontalTip
};
const $8bd3c5c9ee0d1eb4$export$c92c6401b52a9298 = (props)=>{
    const { position: position = "right", className: className } = props;
    const positionPrefix = position.split("_")?.[0].toLowerCase();
    const tipClass = `j_tooltip-tip-${positionPrefix}`;
    const direction = [
        "top",
        "bottom"
    ].includes(positionPrefix) ? "horizontal" : "vertical";
    const Component = $8bd3c5c9ee0d1eb4$var$svgDirectionConfig[direction];
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ...props,
        className: className,
        svgClassName: tipClass
    });
};
const $8bd3c5c9ee0d1eb4$var$focusableSelectors = [
    'a[href]:not([tabindex^="-"])',
    'area[href]:not([tabindex^="-"])',
    'input:not([type="hidden"]):not([type="radio"]):not([disabled]):not([tabindex^="-"])',
    'input[type="radio"]:not([disabled]):not([tabindex^="-"])',
    'select:not([disabled]):not([tabindex^="-"])',
    'textarea:not([disabled]):not([tabindex^="-"])',
    'button:not([disabled]):not([tabindex^="-"])',
    'iframe:not([tabindex^="-"])',
    'audio[controls]:not([tabindex^="-"])',
    'video[controls]:not([tabindex^="-"])',
    '[contenteditable]:not([tabindex^="-"])',
    '[tabindex]:not([tabindex^="-"])'
];
const $8bd3c5c9ee0d1eb4$var$isVisible = (element)=>{
    return element.offsetWidth || element.offsetHeight || element.getClientRects().length;
};
const $8bd3c5c9ee0d1eb4$var$getFocusableChildren = (root)=>{
    if (!root) return null;
    const elements = [];
    root.querySelectorAll($8bd3c5c9ee0d1eb4$var$focusableSelectors.join(",")).forEach((ele)=>elements.push(ele));
    return elements.filter($8bd3c5c9ee0d1eb4$var$isVisible);
};
const $8bd3c5c9ee0d1eb4$export$31e8f018cc5f8f35 = (props)=>{
    const ref = (0, $acw62.useRef)(null);
    const { trap: trap, children: children, ...rest } = props;
    const [lastFocus, setLastFocus] = (0, $acw62.useState)(()=>trap ? document.activeElement : null);
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            lastFocus && lastFocus.focus?.();
        };
    }, []);
    const trapTabKey = (element, event)=>{
        const focusableChildren = $8bd3c5c9ee0d1eb4$var$getFocusableChildren(element);
        if (!focusableChildren) return;
        const focusedItemIndex = document.activeElement ? focusableChildren.indexOf(document.activeElement) : -1;
        const lastIndex = focusableChildren.length - 1;
        const withShift = event.shiftKey;
        if (withShift && focusedItemIndex === 0) {
            focusableChildren?.[lastIndex]?.focus?.();
            event.preventDefault();
        } else if (!withShift && focusedItemIndex === lastIndex) {
            focusableChildren?.[0]?.focus?.();
            event.preventDefault();
        }
    };
    const moveFocusIn = ()=>{
        if (!$8bd3c5c9ee0d1eb4$var$getFocusableChildren(ref.current)?.includes(document?.activeElement)) {
            const target = ref?.current?.querySelector("[autofocus]") || $8bd3c5c9ee0d1eb4$var$getFocusableChildren(ref.current)?.[0];
            requestAnimationFrame(()=>{
                target && target?.focus?.();
            });
        }
    };
    (0, $acw62.useEffect)(()=>{
        if (trap) {
            setLastFocus(document.activeElement);
            moveFocusIn();
        } else lastFocus && lastFocus.focus?.();
    }, [
        trap
    ]);
    (0, $acw62.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            if (trap) {
                if (event.key === "Tab") trapTabKey(ref?.current, event);
            }
        };
        document.addEventListener("keydown", handleKeyDown, false);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown, false);
        };
    }, [
        ref,
        lastFocus,
        trap
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            display: "contents"
        },
        ref: ref,
        ...rest,
        children: children
    });
};
$8bd3c5c9ee0d1eb4$export$31e8f018cc5f8f35.displayName = "TrapFocus";
$8bd3c5c9ee0d1eb4$export$31e8f018cc5f8f35.defaultProps = {
    trap: false
};
const $8bd3c5c9ee0d1eb4$var$filterInternalEvents = (events)=>{
    const internalEvents = [
        "onSwipeLeft",
        "onSwipeRight",
        "onSwipeUp",
        "onSwipeDown",
        "onPinch",
        "onRotate",
        "onLongPress",
        "onDoubleTap"
    ];
    const filteredEvents = {};
    Object.entries(events).forEach(([key, handler])=>{
        if (!internalEvents.includes(key)) filteredEvents[key] = handler;
    });
    return filteredEvents;
};
const $8bd3c5c9ee0d1eb4$var$resolveDisabled = (disabled)=>{
    if (typeof disabled === "object") return false;
    return disabled;
};
const $8bd3c5c9ee0d1eb4$var$disabledStyles = {
    cursor: "not-allowed",
    pointerEvents: "none",
    userSelect: "none"
};
const $8bd3c5c9ee0d1eb4$export$42a852a2b6b56249 = (props)=>{
    const { children: children, elementRef: elementRef, events: events = {}, className: className, style: style, disabled: disabled, passive: passive, target: target, href: href, title: title, internalIndex: internalIndex, isContainerFocusable: isContainerFocusable, root: root, rootRef: rootRef, show: show, componentTag: componentTag, ...rest } = props;
    const hasFocus = Boolean(isContainerFocusable && events?.onClick);
    const tokens = $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e();
    const isJioV2 = tokens?.["brandVersion"] === "jio-v2";
    const isButton = className.includes("j-JDSButton-container") || className.includes("j-JDSButton2-container");
    const POINTER_CURSOR_CLASSES = [
        "j-JDSButton-container",
        "j-JDSLink-container",
        "j-JDSActionButton-inner-container",
        "j-JDSTabItem-container"
    ];
    const Element = String(componentTag) === "undefined" && String(props["web-tag"]) === "undefined" ? isButton ? "button" : "div" : props["web-tag"] || componentTag;
    if (!show && (!children || Array.isArray(children) && children.every((c)=>c === null))) return null;
    const resolvedDisabled = $8bd3c5c9ee0d1eb4$var$resolveDisabled(disabled);
    const shouldHavePointerCursor = POINTER_CURSOR_CLASSES.some((cls)=>className?.includes(cls));
    const filteredEvents = $8bd3c5c9ee0d1eb4$var$filterInternalEvents(events);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($8bd3c5c9ee0d1eb4$export$31627395a3b18e54, {
        hidden: [
            true,
            "true"
        ].includes(props.hidden),
        animatedProperties: rest.transition?.property,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Element, {
            ...filteredEvents,
            type: rest.type,
            "data-testid": rest?.["data-testid"],
            "data-index": internalIndex,
            className: $8bd3c5c9ee0d1eb4$var$classNames(className, hasFocus ? "hasFocus" : "", hasFocus && isJioV2 ? "engine-container" : ""),
            ref: elementRef || rootRef,
            disabled: resolvedDisabled,
            onKeyDown: (ev)=>{
                if (document.activeElement === ev.target && ev.target.tagName !== "BUTTON") {
                    if (ev.key === "Enter" || ev.key === " ") {
                        const event = new MouseEvent("click", {
                            bubbles: true,
                            cancelable: true
                        });
                        ev.target.dispatchEvent(event);
                    }
                }
                props.onKeyDown?.(ev);
            },
            title: title,
            style: {
                ...style,
                overflow: props["overflow"],
                touchAction: passive ? "none" : void 0,
                cursor: shouldHavePointerCursor ? "pointer" : events.onClick ? "default" : void 0,
                ...resolvedDisabled ? $8bd3c5c9ee0d1eb4$var$disabledStyles : void 0
            },
            tabIndex: props.tabIndex ?? (disabled ? -1 : hasFocus ? 0 : void 0),
            "aria-label": props["aria-label"],
            "aria-labelledby": props["aria-labelledby"],
            "aria-describedby": props["aria-describedby"],
            "aria-disabled": props["aria-disabled"],
            role: props.role,
            "aria-checked": props["aria-checked"],
            "aria-orientation": props["aria-orientation"],
            "aria-current": props["aria-current"],
            "aria-expanded": props["aria-expanded"],
            "aria-controls": props["aria-controls"],
            "aria-valuemin": props["aria-valuemin"],
            "aria-valuemax": props["aria-valuemax"],
            "aria-valuenow": props["aria-valuenow"],
            "aria-busy": props["aria-busy"],
            "aria-valuetext": props["aria-valuetext"],
            "aria-selected": props["aria-selected"],
            "aria-pressed": props["aria-pressed"],
            "aria-hidden": props["aria-hidden"],
            "aria-modal": props["aria-modal"],
            "aria-haspopup": props["aria-haspopup"],
            "aria-live": props["aria-live"]
        }, children)
    });
};
const $8bd3c5c9ee0d1eb4$export$3e431a229df88919 = (props)=>{
    const { value: value, semantics: semantics, events: events, internalIndex: internalIndex, processedA11y: processedA11y, imageFocus: imageFocus, aspectRatio: aspectRatio, _childrenProps: _childrenProps, _isLottieVisible: _isLottieVisible, isContainerFocusable: isContainerFocusable, roundedCorner: roundedCorner, contentScale: contentScale, ...props_ } = props;
    const tokens = $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e();
    const [src, setSrc] = (0, $acw62.useState)(value);
    const handleError = ()=>{
        if (tokens?.["brandVersion"] === "jio-v2") setSrc("https://picsum.photos/seed/picsum/200/300");
    };
    const formatImageName = (imagePath = value || "")=>{
        const parts = imagePath.split("/");
        const imageName = parts.length > 0 ? parts[parts.length - 1] : "";
        if (imageName) {
            const formattedName = imageName.replace(/\..*$/, "").replace(/([A-Z])/g, " $1").toLowerCase() + " image";
            return formattedName;
        }
        return "Image name not found";
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("img", {
        "data-testid": "image-root",
        alt: semantics || formatImageName(src),
        src: src,
        onError: handleError,
        ...props_,
        ...events,
        style: {
            ...props_.style,
            width: tokens?.["brandVersion"] === "jio-v2" ? props_.width : "100%",
            opacity: !value ? 0 : void 0
        }
    });
};
const $8bd3c5c9ee0d1eb4$export$a6c7ac8248d6e38a = (props)=>{
    const { children: children, events: events, className: className, style: style, layer: layer, ...rest } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("a", {
        ...events,
        className: className,
        style: style,
        "data-testid": rest?.["data-testid"],
        children: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.map(props.children, (item)=>item && (0, $acw62.cloneElement)(item))
    });
};
const $8bd3c5c9ee0d1eb4$var$PromoCardArc = (props)=>{
    const { orientation: orientation, style: style, className: className } = props;
    if (orientation === "horizontal") return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        className: className,
        viewBox: "0 0 1 1",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            display: "block",
            ...style
        },
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M0,0 L0,5 C1,3 1,-3 0,-5 L0,0",
            fill: "currentcolor"
        })
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        className: className,
        viewBox: "0 0 1 1",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            display: "block",
            ...style
        },
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M0,0 L0,10 C1,3 1,-3 0,-10 L0,0",
            fill: "currentcolor",
            style: {
                transform: "rotate(270deg) translateX(-100%) translateY(50%"
            }
        })
    });
};
const $8bd3c5c9ee0d1eb4$var$addV2TagToCompLayer = (tokens, layer)=>{
    if (!layer) return layer;
    if (tokens?.["brandVersion"] === "jio-v2") {
        if (!layer.endsWith("2")) return layer + "2";
    }
    return layer;
};
const $8bd3c5c9ee0d1eb4$var$RenderComponent = (Comp, props, componentsMap)=>{
    const tokens = $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e();
    const comp = $8bd3c5c9ee0d1eb4$var$addV2TagToCompLayer(tokens, Comp?.component);
    if (comp && componentsMap?.[comp]) Comp = (0, $acw62.createElement)(componentsMap?.[comp](), Comp.props);
    if (Array.isArray(Comp)) return Comp.map((C)=>{
        if (!C.component) return $8bd3c5c9ee0d1eb4$var$RenderComponent(C, {
            ...C.props,
            ...props
        }, componentsMap);
        const comp2 = $8bd3c5c9ee0d1eb4$var$addV2TagToCompLayer(tokens, C?.component);
        return $8bd3c5c9ee0d1eb4$var$RenderComponent(comp2, {
            ...C.props,
            ...props
        }, componentsMap);
    });
    if (!(0, $acw62.isValidElement)(Comp)) return null;
    const compName = $8bd3c5c9ee0d1eb4$var$getComponentName(Comp);
    const { slot_layers: slot_layers, ...newProps } = props ?? {};
    const { lock_all: lock_all, ...slotProps } = slot_layers?.[compName] ?? slot_layers?.[compName + "2"] ?? {};
    for(const prop in slotProps){
        const arr = [].concat(slotProps[prop]);
        const value = Comp.props[prop];
        if (arr.includes(value)) newProps[prop] = value;
        else {
            newProps[prop] = arr[0];
            value !== void 0 && console.warn(`Invalid property on ${compName} for ${prop} - currently ${value}. Value must be one of [${arr.join()}]`);
        }
    }
    if (lock_all) return (0, $acw62.createElement)(Comp.type, {
        ...Comp.props,
        ...newProps
    });
    return (0, $acw62.cloneElement)(Comp, {
        ...Comp.props,
        ...newProps
    });
};
const $8bd3c5c9ee0d1eb4$var$removeBrandPrefixes = (name)=>{
    const PREFIXES = [
        "jds_"
    ];
    let currentName = name;
    PREFIXES.forEach((prefix)=>{
        currentName = currentName.replace(prefix, "");
    });
    return currentName;
};
const $8bd3c5c9ee0d1eb4$var$getComponentName = (Comp)=>{
    if (!Comp) return "";
    if (Comp?.type?.slotName) return Comp?.type?.slotName?.replace(/\d+$/, "");
    if (Comp?.slotName) return Comp?.slotName?.replace(/\d+$/, "");
    return Comp?.type?.displayName ?? Comp?.displayName ?? "";
};
const $8bd3c5c9ee0d1eb4$export$8c6ed5c666ac1360 = ({ _childrenProps: _childrenProps, layer: layer, events: events, className: className, style: style = {}, disabled: disabled, slot_layers: slot_layers, ...rest })=>{
    const { api: children, props: props } = _childrenProps;
    if (!children?.[layer]?.name) return null;
    const Comp = props?.[children?.[layer]?.name];
    if (!Comp) return null;
    const hasStyle = Boolean(Object.keys(style || {}).length);
    const _accepts = children?.[layer]?.accepts.map((item)=>item.replace(/\d+$/, ""));
    const acceptedArrayItems = [];
    _accepts?.forEach((item)=>{
        if (typeof item === "string") acceptedArrayItems.push($8bd3c5c9ee0d1eb4$var$removeBrandPrefixes(item.toLowerCase()).replace(/\d+$/, ""));
        if (Array.isArray(item)) item.map((item2)=>acceptedArrayItems.push($8bd3c5c9ee0d1eb4$var$removeBrandPrefixes(item2?.toLowerCase()).replace(/\d+$/, "")));
        return acceptedArrayItems;
    });
    const shouldComponentRender = (Comp2)=>{
        if (Comp2.component) Comp2 = $8bd3c5c9ee0d1eb4$var$RenderComponent(Comp2, Comp2.props, _childrenProps?.componentsMap || {});
        const CompName = $8bd3c5c9ee0d1eb4$var$getComponentName(Comp2);
        const should = acceptedArrayItems.includes(CompName?.toLowerCase()) || _accepts.includes(CompName?.toLowerCase().replace(/\d+$/, "")) || [
            "any",
            "template",
            "Any"
        ].includes(_accepts[0]);
        if (!should) console.warn("Did not render", {
            Comp: Comp2,
            CompName: CompName,
            acceptedArrayItems: acceptedArrayItems,
            _accepts: _accepts
        });
        return should;
    };
    const isReactElement = (obj)=>obj?.$$typeof === Symbol.for("react.element");
    const isArrayOfReactElements = (obj)=>Array.isArray(obj) && obj.every(isReactElement);
    if (!isReactElement(Comp) && !isArrayOfReactElements(Comp)) console.warn("not a react element", Comp);
    if (Comp.type !== Symbol.for("react.fragment") && (0, $acw62.isValidElement)(Comp)) {
        if (shouldComponentRender(Comp)) {
            if (!hasStyle) return $8bd3c5c9ee0d1eb4$var$RenderComponent(Comp, {
                ...events,
                ...Comp.props,
                style: {
                    ...rest["style"],
                    ...Comp?.props?.style
                },
                slot_layers: slot_layers
            }, _childrenProps?.componentsMap || {});
            return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: className,
                style: {
                    ...style,
                    display: "contents",
                    pointerEvents: disabled ? "none" : void 0
                },
                children: $8bd3c5c9ee0d1eb4$var$RenderComponent(Comp, {
                    ...events,
                    ...Comp.props,
                    style: {
                        ...rest["style"],
                        ...Comp?.props?.style
                    },
                    slot_layers: slot_layers
                }, _childrenProps?.componentsMap || {})
            });
        }
    }
    if (Array.isArray(Comp)) {
        if (children?.[layer]?.max) {
            if (!hasStyle) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: Comp.slice(0, children?.[layer]?.max).filter(shouldComponentRender).map((Item, i)=>$8bd3c5c9ee0d1eb4$var$RenderComponent(Item, {
                        key: $8bd3c5c9ee0d1eb4$var$getComponentName(Item) + i,
                        ...events,
                        slot_layers: slot_layers
                    }, _childrenProps?.componentsMap || {}))
            });
            return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: className,
                style: {
                    ...style,
                    display: "contents",
                    pointerEvents: disabled ? "none" : void 0
                },
                children: Comp.slice(0, children?.[layer]?.max).filter(shouldComponentRender).map((Item, i)=>$8bd3c5c9ee0d1eb4$var$RenderComponent(Item, {
                        key: $8bd3c5c9ee0d1eb4$var$getComponentName(Item) + i,
                        ...events,
                        slot_layers: slot_layers
                    }, _childrenProps?.componentsMap || {}))
            });
        }
        if (!hasStyle) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
            children: Comp.filter(shouldComponentRender).map((Item, i)=>$8bd3c5c9ee0d1eb4$var$RenderComponent(Item, {
                    key: $8bd3c5c9ee0d1eb4$var$getComponentName(Item) + i,
                    ...events,
                    slot_layers: slot_layers
                }, _childrenProps?.componentsMap || {}))
        });
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: className,
            style: {
                ...style,
                display: "contents",
                pointerEvents: disabled ? "none" : void 0
            },
            children: Comp.filter(shouldComponentRender).map((Item, i)=>$8bd3c5c9ee0d1eb4$var$RenderComponent(Item, {
                    key: $8bd3c5c9ee0d1eb4$var$getComponentName(Item) + i,
                    ...events,
                    slot_layers: slot_layers
                }, _childrenProps?.componentsMap || {}))
        });
    }
    const renderFragment = (Comp2)=>{
        let ComponentChildren;
        if (children?.[layer]?.max || Array.isArray(Comp2.props.children)) {
            ComponentChildren = Comp2.props.children.slice?.(0, children?.[layer]?.max).map((item)=>{
                if (item?.type === Symbol.for("react.fragment")) return renderFragment(item);
                else if (item) return shouldComponentRender(item) && $8bd3c5c9ee0d1eb4$var$RenderComponent(item, {
                    ...item.props,
                    slot_layers: slot_layers
                }, _childrenProps?.componentsMap || {});
                return null;
            });
            if (!hasStyle) return ComponentChildren;
            return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: className,
                style: {
                    ...style,
                    display: "contents",
                    pointerEvents: disabled ? "none" : void 0
                },
                children: ComponentChildren.map((child)=>shouldComponentRender(child) && $8bd3c5c9ee0d1eb4$var$RenderComponent(child, {
                        ...child.props,
                        slot_layers: slot_layers
                    }, _childrenProps?.componentsMap || {}))
            });
        }
        ComponentChildren = Comp2.props.children;
        return ComponentChildren.map((child)=>shouldComponentRender(child) && $8bd3c5c9ee0d1eb4$var$RenderComponent(child, {
                ...child.props,
                slot_layers: slot_layers
            }, _childrenProps?.componentsMap || {}));
    };
    if (typeof Comp === "object" && Comp.type === Symbol.for("react.fragment")) return renderFragment(Comp);
    return null;
};
const $8bd3c5c9ee0d1eb4$var$ButtonVector = (props)=>{
    const transformAngle = props.direction !== "reversed" ? 180 : 0;
    const borderClass = props["border-type"] === "solid" ? "solid-border" : "none";
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        className: $8bd3c5c9ee0d1eb4$var$classNames(props.className, borderClass, "sw-btn-vector"),
        style: {
            ...props.style,
            transform: `rotate(${transformAngle}deg)`
        },
        preserveAspectRatio: "none",
        viewBox: "0 0 40 56",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("mask", {
                id: "path-1-inside-1_23_23",
                fill: "red",
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M0 56H12.53C12.53 56 24.19 55.81 28.54 41.98C32.44 30.4 37.86 28.35 40 28C37.86 27.64 32.45 25.6 28.54 14.02C24.19 0.190001 12.53 0 12.53 0H0"
                })
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                className: "inside",
                d: "M0 56H12.53C12.53 56 24.19 55.81 28.54 41.98C32.44 30.4 37.86 28.35 40 28C37.86 27.64 32.45 25.6 28.54 14.02C24.19 0.190001 12.53 0 12.53 0H0",
                fill: "currentcolor"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12.53 56V57H12.5381L12.5463 56.9999L12.53 56ZM28.54 41.98L27.5923 41.6608L27.5891 41.6704L27.5861 41.68L28.54 41.98ZM40 28L40.1614 28.9869L40.1659 27.0139L40 28ZM28.54 14.02L27.5861 14.32L27.5892 14.33L27.5926 14.3399L28.54 14.02ZM12.53 0L12.5463 -0.999867L12.5381 -1H12.53V0ZM0 57H12.53V55H0V57ZM12.53 56C12.5463 56.9999 12.5469 56.9999 12.5476 56.9998C12.5479 56.9998 12.5486 56.9998 12.5491 56.9998C12.5503 56.9998 12.5516 56.9998 12.5531 56.9997C12.556 56.9997 12.5597 56.9996 12.5641 56.9995C12.5729 56.9993 12.5844 56.9989 12.5988 56.9984C12.6274 56.9974 12.6671 56.9957 12.7171 56.993C12.8171 56.9875 12.9588 56.9776 13.1374 56.96C13.4946 56.9249 14.0005 56.8588 14.6173 56.7345C15.8497 56.4863 17.5338 56.004 19.3606 55.0658C23.038 53.1773 27.2325 49.47 29.4939 42.28L27.5861 41.68C25.4975 48.32 21.687 51.6227 18.4469 53.2867C16.815 54.1248 15.3121 54.5544 14.2224 54.7739C13.6781 54.8836 13.2391 54.9404 12.9416 54.9696C12.7929 54.9843 12.6799 54.992 12.6069 54.996C12.5705 54.998 12.5441 54.9991 12.5284 54.9997C12.5205 54.9999 12.5153 55.0001 12.5128 55.0001C12.5116 55.0002 12.5111 55.0002 12.5112 55.0002C12.5113 55.0002 12.5115 55.0002 12.5119 55.0002C12.5121 55.0002 12.5126 55.0002 12.5127 55.0001C12.5132 55.0001 12.5137 55.0001 12.53 56ZM29.4877 42.2992C33.2983 30.9845 38.4683 29.2638 40.1614 28.9869L39.8386 27.0131C37.2517 27.4362 31.5817 29.8155 27.5923 41.6608L29.4877 42.2992ZM40.1659 27.0139C38.4677 26.7282 33.3074 25.0135 29.4874 13.7001L27.5926 14.3399C31.5926 26.1865 37.2523 28.5518 39.8341 28.9861L40.1659 27.0139ZM29.4939 13.72C27.2325 6.53004 23.038 2.82274 19.3606 0.934197C17.5338 -0.00395302 15.8497 -0.486254 14.6173 -0.734524C14.0005 -0.858788 13.4946 -0.924878 13.1374 -0.960018C12.9588 -0.977597 12.8171 -0.987457 12.7171 -0.992973C12.6671 -0.995731 12.6274 -0.997405 12.5988 -0.998413C12.5844 -0.998918 12.5729 -0.999256 12.5641 -0.999481C12.5597 -0.999594 12.556 -0.999678 12.5531 -0.99974C12.5516 -0.999771 12.5503 -0.999796 12.5491 -0.999817C12.5486 -0.999828 12.5479 -0.999841 12.5476 -0.999846C12.5469 -0.999857 12.5463 -0.999867 12.53 0C12.5137 0.999867 12.5132 0.999858 12.5127 0.99985C12.5126 0.999848 12.5121 0.99984 12.5119 0.999836C12.5115 0.999829 12.5113 0.999824 12.5112 0.999822C12.5111 0.999819 12.5116 0.99983 12.5128 0.999862C12.5153 0.999925 12.5205 1.00007 12.5284 1.00035C12.5441 1.0009 12.5705 1.00198 12.6069 1.00399C12.6799 1.00801 12.7929 1.01574 12.9416 1.03037C13.2391 1.05964 13.6781 1.11644 14.2224 1.22609C15.3121 1.44563 16.815 1.8752 18.4469 2.7133C21.687 4.37726 25.4975 7.67996 27.5861 14.32L29.4939 13.72ZM12.53 -1H0V1H12.53V-1Z",
                fill: "url(#paint0_angular_23_23)",
                mask: "url(#path-1-inside-1_23_23)"
            }),
            props["border-type"] === "gradient" && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("defs", {
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("radialGradient", {
                    id: "paint0_angular_23_23",
                    cx: "0",
                    cy: "0",
                    r: "1",
                    gradientUnits: "userSpaceOnUse",
                    gradientTransform: "translate(38.5 51.5) rotate(154.464) scale(70.402 85.8467)",
                    children: [
                        /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("stop", {
                            offset: "0.0165174",
                            stopColor: "#EAB872"
                        }),
                        /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("stop", {
                            offset: "0.280935",
                            stopColor: "#63371D"
                        }),
                        /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("stop", {
                            offset: "0.563131",
                            stopColor: "#FFEAC2"
                        }),
                        /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("stop", {
                            offset: "0.796371",
                            stopColor: "#AE824E"
                        })
                    ]
                })
            })
        ]
    });
};
const $8bd3c5c9ee0d1eb4$var$atomsMap = {
    container: $8bd3c5c9ee0d1eb4$export$42a852a2b6b56249,
    text: $8bd3c5c9ee0d1eb4$export$5f1af8db9871e1d6,
    icon: $8bd3c5c9ee0d1eb4$export$f04a61298a47a40f,
    image: $8bd3c5c9ee0d1eb4$export$3e431a229df88919,
    slider: $8bd3c5c9ee0d1eb4$export$472062a354075cee,
    animatedContainer: $8bd3c5c9ee0d1eb4$export$9382739d0e79620f,
    loader: $8bd3c5c9ee0d1eb4$export$3b0d6d7590275603,
    link: $8bd3c5c9ee0d1eb4$export$a6c7ac8248d6e38a,
    popup: $8bd3c5c9ee0d1eb4$export$129a32eedafa97c5,
    textarea: $8bd3c5c9ee0d1eb4$export$379139ebc1c2b235,
    tooltip: $8bd3c5c9ee0d1eb4$export$c92c6401b52a9298,
    input: $8bd3c5c9ee0d1eb4$export$f5b8910cec6cf069,
    promoCardArc: $8bd3c5c9ee0d1eb4$var$PromoCardArc,
    arc: $8bd3c5c9ee0d1eb4$export$6ef80ffb606dd232,
    slot: $8bd3c5c9ee0d1eb4$export$8c6ed5c666ac1360,
    skeletonLoader: $8bd3c5c9ee0d1eb4$export$d50980d2cec56085,
    button_vector: $8bd3c5c9ee0d1eb4$var$ButtonVector
};
const $8bd3c5c9ee0d1eb4$export$595884dc072315a0 = (layer)=>{
    const baseLayerName = $8bd3c5c9ee0d1eb4$var$getBaseLayerName(layer);
    return Object.keys($8bd3c5c9ee0d1eb4$var$atomsMap).includes(baseLayerName);
};
const $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38 = (componentProperties, props, componentName = "component", componentsMap, _custom = {}, parentRuntime)=>{
    const runtime = parentRuntime || props.runtime;
    const { hierarchy: hierarchy, api: api, ...rest } = componentProperties;
    const { componentTag: componentTag, ...restProps } = props;
    const customMergedJSON = (0, $bff35c0dd9851fab$export$4950aa0f605343fb)({
        api: api,
        ...rest
    }, _custom);
    const defaultProps = (0, $6eea7234d56610fe$export$61b94149aeb1f59)(customMergedJSON.api);
    const invariants = (0, $6eea7234d56610fe$export$ce4be320c9b7d5be)(customMergedJSON);
    const normalisedProperties = $8bd3c5c9ee0d1eb4$var$processConfigAPI(api?.config, props);
    const mergedProps = {
        ...restProps,
        ...normalisedProperties
    };
    const flatTokens = $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e();
    const propTokens = (0, $bff35c0dd9851fab$export$b460b275d6c6aa0)(mergedProps, (v, k)=>$8bd3c5c9ee0d1eb4$export$1ec1d45228a8d241.includes(k) && v !== "auto");
    const getPercentageTokens = Object.keys(defaultProps).filter((key)=>props[key] !== defaultProps[key]);
    const defaultSwitchables = $8bd3c5c9ee0d1eb4$export$dfce236e857ed8b0();
    const hasDifferentTokens = Object.keys((0, $bff35c0dd9851fab$export$b460b275d6c6aa0)(propTokens, (v, k)=>v !== defaultSwitchables[k])).length > 0;
    const shouldIncludeAmpersand = getPercentageTokens.length > 0 && hasDifferentTokens || Object.values(customMergedJSON.base).some((item)=>Object.keys(item).some((key)=>key.endsWith("color") || key === "fill"));
    const config = (0, $6eea7234d56610fe$export$859883d4ec9c7db4).brandResolverFn && !runtime ? {
        getAmpersandTokens: shouldIncludeAmpersand,
        getPercentageTokens: getPercentageTokens,
        getAllBaseLayers: false,
        transformer: false
    } : void 0;
    const uiTokens = (0, $6eea7234d56610fe$export$e025e4ac3d283105)(mergedProps, (0, $bff35c0dd9851fab$export$629a2bd3f5a49ecc)(customMergedJSON), config);
    const { layerProps: layerProps, styles: styles_ } = $8bd3c5c9ee0d1eb4$var$seperateComponentLayerProps(uiTokens);
    const { hierarchy: hierarchy_, styles: styles } = $8bd3c5c9ee0d1eb4$var$hiddenFilter({
        hierarchy_: hierarchy,
        styles_: styles_,
        api: api,
        props: mergedProps
    });
    const propMergedStyles = $8bd3c5c9ee0d1eb4$var$mergeStyleProperties(mergedProps, styles, api.data, layerProps);
    const drawnComponent = (0, $6eea7234d56610fe$export$a1a0a7262a295961)(componentName, propMergedStyles, hierarchy, invariants, {
        ...flatTokens,
        ...propTokens
    });
    return $8bd3c5c9ee0d1eb4$var$renderComponent({
        currentLayer: hierarchy_,
        api: api,
        props: mergedProps,
        componentName: customMergedJSON?.metadata?.name || componentName,
        children: api.children,
        componentsMap: componentsMap,
        base: propMergedStyles,
        layerProps: layerProps,
        internalIndex: props.internalIndex,
        root: true,
        componentTag: componentTag,
        drawnComponent: drawnComponent,
        runtime: runtime,
        tokens: flatTokens
    });
};
const $8bd3c5c9ee0d1eb4$var$ComponentWithTokens = ({ children: children, base: base, layer: layer, propTokens: propTokens, runtime: runtime })=>{
    const tokens = $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e();
    if (runtime && // !['text', 'icon'].some((key) => layer.endsWith(key)) &&
    !layer.includes("jds_")) return (0, $acw62.cloneElement)(children, {
        style: Object.fromEntries(Object.entries(base[layer] || {}).map(([key, value])=>[
                key,
                (0, $6eea7234d56610fe$export$6a176e754d54672)(key, value, tokens)
            ]))
    });
    if (tokens.brandVersion !== "jio-v2") {
        if (Object.keys(tokens).some((key)=>key in base[layer])) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($8bd3c5c9ee0d1eb4$export$e5cf4eff53e7947d, {
            value: (0, $bff35c0dd9851fab$export$b460b275d6c6aa0)(base[layer], (v, k)=>$8bd3c5c9ee0d1eb4$export$1ec1d45228a8d241.includes(k)),
            children: children
        });
        return children;
    }
    const colorKeys = [
        "appearance",
        "surface",
        "strokeSurface",
        "color",
        "background-color",
        "border-color",
        "fill"
    ];
    if (tokens?.["brandVersion"] !== "jio-v2" || (!base[layer] || !colorKeys.some((k)=>base[layer]?.[k])) && !Object.keys(propTokens || {}).length || layer.endsWith("slot")) return children;
    const colorProperty = Object.keys(base[layer] || {}).find((key)=>key.endsWith("color") && !key.includes("border"));
    const borderColorProperty = Object.keys(base[layer] || {}).find((key)=>key.includes("border"));
    const colorToken = (0, $bff35c0dd9851fab$export$5fe300a9008e2bfc)(String(base[layer]?.[colorProperty]) || "");
    const borderColorToken = (0, $bff35c0dd9851fab$export$5fe300a9008e2bfc)(String(base[layer]?.[borderColorProperty]) || "");
    const surface = colorToken?.split("_")?.[2];
    const strokeSurface = borderColorToken?.split("_")?.[2];
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($8bd3c5c9ee0d1eb4$export$e5cf4eff53e7947d, {
        value: {
            ...(0, $bff35c0dd9851fab$export$b460b275d6c6aa0)(base[layer], (v, k)=>$8bd3c5c9ee0d1eb4$export$1ec1d45228a8d241.includes(k)),
            ...propTokens,
            surface: base[layer]?.surface?.toString() || surface || "ghost",
            strokeSurface: base[layer]?.strokeSurface?.toString() || strokeSurface || void 0
        },
        children: children
    });
};
const $8bd3c5c9ee0d1eb4$var$renderComponent = ({ currentLayer: currentLayer, api: api, props: props, componentName: componentName, children: children, componentsMap: componentsMap, base: base, layerProps: layerProps, internalIndex: internalIndex, root: root, componentTag: componentTag, drawnComponent: drawnComponent, runtime: runtime, tokens: tokens })=>{
    const isV2 = tokens?.["brandVersion"] === "jio-v2";
    if (typeof currentLayer === "string") {
        const CurrentComp = $8bd3c5c9ee0d1eb4$var$getCompFromKey(currentLayer, componentsMap);
        const { processData: processData, processedEvents: processedEvents, processedA11y: processedA11y } = $8bd3c5c9ee0d1eb4$var$processDataAPI(api, currentLayer, props);
        const drawnClasses = drawnComponent.classes[currentLayer] ?? [];
        const drawnStyles = drawnComponent.styles;
        if (CurrentComp) {
            const processedConfigAPI = $8bd3c5c9ee0d1eb4$var$processConfigAPI(api?.config, props);
            const newProps = (0, $bff35c0dd9851fab$export$4950aa0f605343fb)(processedConfigAPI, layerProps?.[currentLayer], processData, {
                events: processedEvents
            }, processedA11y);
            const className = (0, $6eea7234d56610fe$export$c1260eec73bdf31d)(componentName, currentLayer);
            const isAtomicLayer = $8bd3c5c9ee0d1eb4$export$595884dc072315a0(currentLayer);
            const Component = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(CurrentComp, {
                layer: currentLayer,
                "data-testid": (0, $6eea7234d56610fe$export$82c717ab02da3bac)(componentName, currentLayer),
                _childrenProps: {
                    api: children,
                    props: props,
                    componentsMap: componentsMap
                },
                disabled: props.disabled || layerProps?.[currentLayer]?.["disabled"],
                ...newProps,
                runtime: runtime && !currentLayer.includes("jds_"),
                ...newProps.events,
                isContainerFocusable: $8bd3c5c9ee0d1eb4$var$getIsContainerFocusable(api, currentLayer),
                className: $8bd3c5c9ee0d1eb4$export$595884dc072315a0 && isV2 ? $8bd3c5c9ee0d1eb4$var$classNames(className, ...drawnClasses, newProps.className) : !Object.keys(base).length ? "" : className,
                style: root ? drawnStyles : void 0,
                internalIndex: internalIndex || 0,
                processedA11y: processedA11y
            }, currentLayer);
            if (!(0, $acw62.isValidElement)(Component)) return null;
            if (!isAtomicLayer) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    display: "contents",
                    ...root ? drawnStyles : {}
                },
                className: className,
                children: Component
            }, currentLayer);
            if (currentLayer.endsWith("slot")) {
                if (props?.[children?.[currentLayer]?.name]) return Component;
                return null;
            }
            return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($8bd3c5c9ee0d1eb4$var$ComponentWithTokens, {
                base: base,
                layer: currentLayer,
                runtime: runtime,
                propTokens: (0, $bff35c0dd9851fab$export$b460b275d6c6aa0)(newProps, (v, k)=>$8bd3c5c9ee0d1eb4$export$1ec1d45228a8d241.includes(k) && v !== "auto"),
                children: Component
            }, currentLayer);
        }
    } else if (typeof currentLayer === "object" && !Array.isArray(currentLayer)) return Object.keys(currentLayer).map((layer)=>{
        const drawnClasses = drawnComponent.classes[layer] ?? [];
        const drawnStyles = drawnComponent.styles;
        const CurrentComp = $8bd3c5c9ee0d1eb4$var$getCompFromKey(layer, componentsMap);
        const { processData: processData, processedEvents: processedEvents, processedA11y: processedA11y } = $8bd3c5c9ee0d1eb4$var$processDataAPI(api, layer, props) || {};
        if (CurrentComp) {
            const processedConfigAPI = $8bd3c5c9ee0d1eb4$var$processConfigAPI(api?.config, props);
            const newProps = {
                ...processedConfigAPI,
                ...layerProps?.[layer],
                ...processData,
                ...processedEvents,
                ...processedA11y,
                style: root ? props.style : void 0,
                componentTag: root ? componentTag : void 0,
                rootRef: root ? props.rootRef : void 0
            };
            const listName = api.data?.[layer]?.["value"]?.name;
            const arrayData = api.data?.[layer]?.["value"]?.type === "list" ? props[listName] : void 0;
            const className = (0, $6eea7234d56610fe$export$c1260eec73bdf31d)(componentName, layer);
            return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($8bd3c5c9ee0d1eb4$var$ComponentWithTokens, {
                base: base,
                layer: layer,
                runtime: runtime,
                propTokens: (0, $bff35c0dd9851fab$export$b460b275d6c6aa0)(newProps, (v, k)=>$8bd3c5c9ee0d1eb4$export$1ec1d45228a8d241.includes(k) && v !== "auto"),
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(CurrentComp, {
                    "data-testid": (0, $6eea7234d56610fe$export$82c717ab02da3bac)(componentName, layer),
                    ...newProps,
                    layer: layer,
                    runtime: runtime && !layer.includes("jds_"),
                    className: $8bd3c5c9ee0d1eb4$var$classNames(className, !root ? "" : newProps.className, ...isV2 ? drawnClasses : []),
                    isContainerFocusable: $8bd3c5c9ee0d1eb4$var$getIsContainerFocusable(api, layer),
                    style: root ? {
                        ...props.style ?? {},
                        ...drawnStyles
                    } : void 0,
                    events: processedEvents,
                    disabled: props.disabled || layerProps?.[layer]?.["disabled"],
                    internalIndex: internalIndex,
                    processedA11y: processedA11y,
                    children: arrayData ? arrayData?.map((valueItem, i)=>{
                        return $8bd3c5c9ee0d1eb4$var$renderComponent({
                            currentLayer: currentLayer[layer],
                            api: api,
                            props: {
                                ...props,
                                ...valueItem,
                                internalIndex: i
                            },
                            componentName: componentName,
                            children: children,
                            componentsMap: componentsMap,
                            base: base,
                            layerProps: layerProps,
                            internalIndex: valueItem.internalIndex || i,
                            drawnComponent: drawnComponent,
                            runtime: runtime,
                            tokens: tokens
                        });
                    }) : $8bd3c5c9ee0d1eb4$var$renderComponent({
                        currentLayer: currentLayer[layer],
                        api: api,
                        props: {
                            ...props
                        },
                        componentName: componentName,
                        children: children,
                        componentsMap: componentsMap,
                        base: base,
                        layerProps: layerProps,
                        internalIndex: internalIndex,
                        drawnComponent: drawnComponent,
                        runtime: runtime,
                        tokens: tokens
                    })
                }, layer)
            }, layer);
        }
        return null;
    });
    else if (typeof currentLayer === "object" && Array.isArray(currentLayer)) return currentLayer.map((child)=>{
        return $8bd3c5c9ee0d1eb4$var$renderComponent({
            currentLayer: child,
            api: api,
            props: props,
            componentName: componentName,
            children: children,
            componentsMap: componentsMap,
            base: base,
            layerProps: layerProps,
            internalIndex: internalIndex,
            drawnComponent: drawnComponent,
            runtime: runtime,
            tokens: tokens
        });
    });
    return null;
};
const $8bd3c5c9ee0d1eb4$var$getCompFromKey = (obj, componentsMap)=>{
    const layerName = $8bd3c5c9ee0d1eb4$var$getBaseLayerName(obj);
    if (componentsMap && componentsMap[layerName]) try {
        return componentsMap[layerName]?.() || null;
    } catch (error) {
        return null;
    }
    if ($8bd3c5c9ee0d1eb4$export$595884dc072315a0(layerName)) return $8bd3c5c9ee0d1eb4$var$atomsMap[layerName] || null;
    return null;
};
const $8bd3c5c9ee0d1eb4$var$excludedLayers = [
    "input",
    "container",
    "arc",
    "slider",
    "loader",
    "button_vector",
    "skeletonLoader"
];
const $8bd3c5c9ee0d1eb4$var$hasProps = (layerName = "", api, props, styles)=>{
    if ($8bd3c5c9ee0d1eb4$var$excludedLayers.some((layer)=>layerName.endsWith(layer))) return true;
    const apiLayers = api.data?.[layerName];
    const childlayers = api.children?.[layerName];
    if (!apiLayers && !childlayers && Object.values(apiLayers || {}).every(({ type: type })=>type === "boolean")) return true;
    const hasChildren = Boolean(props?.[childlayers?.name]);
    const hasData = Object.values(apiLayers || {}).some(({ name: name })=>![
            void 0,
            null,
            ""
        ].includes(props[name]) || ![
            void 0,
            null,
            ""
        ].includes(styles?.[layerName]?.[name]) || name.includes("."));
    const hasBaseProps = Object.keys((styles || {})[layerName] || {}).filter((key)=>Object.values(apiLayers || {}).find(({ name: name })=>name === key))?.length;
    if (!hasData && hasBaseProps) return true;
    if (!hasData && !(hasChildren && childlayers)) return false;
    return true;
};
const $8bd3c5c9ee0d1eb4$var$hiddenFilter = ({ hierarchy_: hierarchy_, styles_: styles_, api: api, props: props })=>{
    const hiddenLayers = [];
    const styles = Object.entries(styles_).reduce((acc, [layerName, styleProps])=>{
        if ($8bd3c5c9ee0d1eb4$var$isHidden(styleProps.hidden) && !styleProps?.["transition"]) hiddenLayers.push(layerName);
        else acc[layerName] = styleProps;
        return acc;
    }, {});
    const hierarchy = $8bd3c5c9ee0d1eb4$var$filterHierarchy(hierarchy_, hiddenLayers, api, props, styles);
    return {
        hierarchy: hierarchy,
        styles: styles
    };
};
const $8bd3c5c9ee0d1eb4$var$isHidden = (hidden)=>{
    if (typeof hidden === "string") return hidden.includes("true");
    return Boolean(hidden);
};
const $8bd3c5c9ee0d1eb4$var$isLayerHidden = (layer, hiddenLayers)=>{
    return hiddenLayers.includes(layer);
};
const $8bd3c5c9ee0d1eb4$var$filterHierarchy = (hierarchy, hiddenLayers, api, props, styles)=>{
    if (typeof hierarchy === "string" && !$8bd3c5c9ee0d1eb4$var$isLayerHidden(hierarchy, hiddenLayers) && $8bd3c5c9ee0d1eb4$var$hasProps(hierarchy, api, props, styles)) return hierarchy;
    else if (typeof hierarchy === "object" && !Array.isArray(hierarchy)) {
        const end = Object.keys(hierarchy).filter((key)=>{
            return !$8bd3c5c9ee0d1eb4$var$isLayerHidden(key, hiddenLayers) && $8bd3c5c9ee0d1eb4$var$hasProps(key, api, props);
        }).reduce((res, key)=>{
            res[key] = $8bd3c5c9ee0d1eb4$var$filterHierarchy(hierarchy[key], hiddenLayers, api, props, styles);
            return res;
        }, {});
        return end;
    } else if (typeof hierarchy === "object" && Array.isArray(hierarchy)) {
        const res = [];
        hierarchy.forEach((key)=>{
            res.push($8bd3c5c9ee0d1eb4$var$filterHierarchy(key, hiddenLayers, api, props, styles));
        });
        return res.filter((r)=>Object.keys(r).length).flat();
    }
    return {};
};
function $8bd3c5c9ee0d1eb4$var$getIsContainerFocusable(api, layer) {
    const clickEvent = api.events?.[layer]?.onClick;
    if (layer.includes("popup")) return false;
    if (layer.includes("button")) return true;
    if (!layer.includes("container")) return false;
    if (clickEvent) {
        const name = typeof clickEvent === "string" ? clickEvent : clickEvent.name;
        return !name.startsWith("_");
    }
}
const $8bd3c5c9ee0d1eb4$var$English$6 = {
    of: "of"
};
const $8bd3c5c9ee0d1eb4$var$Hindi$6 = {
    of: "\u0915\u093E"
};
const $8bd3c5c9ee0d1eb4$var$Marathi$6 = {
    of: "\u091A\u094D\u092F\u093E"
};
const $8bd3c5c9ee0d1eb4$var$Gujarati$6 = {
    of: "\u0AA8\u0ABE"
};
const $8bd3c5c9ee0d1eb4$var$Punjabi$6 = {
    of: "\u0A26\u0A47"
};
const $8bd3c5c9ee0d1eb4$var$Bengali$6 = {
    of: "\u098F\u09B0"
};
const $8bd3c5c9ee0d1eb4$var$Tamil$6 = {
    of: "\u0B87\u0BA9\u0BCD"
};
const $8bd3c5c9ee0d1eb4$var$Telugu$6 = {
    of: "\u0C2F\u0C4A\u0C15\u0C4D\u0C15"
};
const $8bd3c5c9ee0d1eb4$var$Kannada$6 = {
    of: "\u0CA8"
};
const $8bd3c5c9ee0d1eb4$var$Assamese$6 = {
    of: "\u09F0"
};
const $8bd3c5c9ee0d1eb4$var$Malayalam$6 = {
    of: "\u0D2F\u0D41\u0D1F\u0D46"
};
const $8bd3c5c9ee0d1eb4$var$Oriya$6 = {
    of: "\u0B30"
};
const $8bd3c5c9ee0d1eb4$var$of = {
    English: $8bd3c5c9ee0d1eb4$var$English$6,
    Hindi: $8bd3c5c9ee0d1eb4$var$Hindi$6,
    Marathi: $8bd3c5c9ee0d1eb4$var$Marathi$6,
    Gujarati: $8bd3c5c9ee0d1eb4$var$Gujarati$6,
    Punjabi: $8bd3c5c9ee0d1eb4$var$Punjabi$6,
    Bengali: $8bd3c5c9ee0d1eb4$var$Bengali$6,
    Tamil: $8bd3c5c9ee0d1eb4$var$Tamil$6,
    Telugu: $8bd3c5c9ee0d1eb4$var$Telugu$6,
    Kannada: $8bd3c5c9ee0d1eb4$var$Kannada$6,
    Assamese: $8bd3c5c9ee0d1eb4$var$Assamese$6,
    Malayalam: $8bd3c5c9ee0d1eb4$var$Malayalam$6,
    Oriya: $8bd3c5c9ee0d1eb4$var$Oriya$6
};
const $8bd3c5c9ee0d1eb4$var$ofData = /*#__PURE__*/ Object.freeze(/*#__PURE__*/ Object.defineProperty({
    __proto__: null,
    Assamese: $8bd3c5c9ee0d1eb4$var$Assamese$6,
    Bengali: $8bd3c5c9ee0d1eb4$var$Bengali$6,
    English: $8bd3c5c9ee0d1eb4$var$English$6,
    Gujarati: $8bd3c5c9ee0d1eb4$var$Gujarati$6,
    Hindi: $8bd3c5c9ee0d1eb4$var$Hindi$6,
    Kannada: $8bd3c5c9ee0d1eb4$var$Kannada$6,
    Malayalam: $8bd3c5c9ee0d1eb4$var$Malayalam$6,
    Marathi: $8bd3c5c9ee0d1eb4$var$Marathi$6,
    Oriya: $8bd3c5c9ee0d1eb4$var$Oriya$6,
    Punjabi: $8bd3c5c9ee0d1eb4$var$Punjabi$6,
    Tamil: $8bd3c5c9ee0d1eb4$var$Tamil$6,
    Telugu: $8bd3c5c9ee0d1eb4$var$Telugu$6,
    default: $8bd3c5c9ee0d1eb4$var$of
}, Symbol.toStringTag, {
    value: 'Module'
}));
const $8bd3c5c9ee0d1eb4$var$English$5 = {
    ConfirmButton: "Confirm"
};
const $8bd3c5c9ee0d1eb4$var$Hindi$5 = {
    ConfirmButton: "\u092A\u0941\u0937\u094D\u091F\u093F \u0915\u0930\u0947\u0902"
};
const $8bd3c5c9ee0d1eb4$var$Marathi$5 = {
    ConfirmButton: "\u092A\u0941\u0937\u094D\u091F\u0940"
};
const $8bd3c5c9ee0d1eb4$var$Gujarati$5 = {
    ConfirmButton: "\u0AAA\u0AC1\u0AB7\u0ACD\u0A9F\u0ABF \u0A95\u0AB0\u0ACB"
};
const $8bd3c5c9ee0d1eb4$var$Punjabi$5 = {
    ConfirmButton: "\u0A2A\u0A41\u0A38\u0A3C\u0A1F\u0A40 \u0A15\u0A30\u0A4B"
};
const $8bd3c5c9ee0d1eb4$var$Bengali$5 = {
    ConfirmButton: "\u09A8\u09BF\u09B6\u09CD\u099A\u09BF\u09A4 \u0995\u09B0\u09C1\u09A8"
};
const $8bd3c5c9ee0d1eb4$var$Tamil$5 = {
    ConfirmButton: "\u0B89\u0BB1\u0BC1\u0BA4\u0BBF\u0BAA\u0BCD\u0BAA\u0B9F\u0BC1\u0BA4\u0BCD\u0BA4\u0BB5\u0BC1\u0BAE\u0BCD"
};
const $8bd3c5c9ee0d1eb4$var$Telugu$5 = {
    ConfirmButton: "\u0C28\u0C3F\u0C30\u0C4D\u0C27\u0C3E\u0C30\u0C3F\u0C02\u0C1A\u0C02\u0C21\u0C3F"
};
const $8bd3c5c9ee0d1eb4$var$Kannada$5 = {
    ConfirmButton: "\u0CA6\u0CC3\u0CA2\u0CC0\u0C95\u0CB0\u0CBF\u0CB8\u0CBF"
};
const $8bd3c5c9ee0d1eb4$var$Assamese$5 = {
    ConfirmButton: "\u09A8\u09BF\u09B6\u09CD\u099A\u09BF\u09A4"
};
const $8bd3c5c9ee0d1eb4$var$Malayalam$5 = {
    ConfirmButton: "\u0D38\u0D4D\u0D25\u0D3F\u0D30\u0D40\u0D15\u0D30\u0D3F\u0D15\u0D4D\u0D15\u0D41\u0D15"
};
const $8bd3c5c9ee0d1eb4$var$Oriya$5 = {
    ConfirmButton: "\u0B28\u0B3F\u0B36\u0B4D\u0B1A\u0B3F\u0B24 \u0B15\u0B30\u0B28\u0B4D\u0B24\u0B41 |"
};
const $8bd3c5c9ee0d1eb4$var$confirmButtonData = {
    English: $8bd3c5c9ee0d1eb4$var$English$5,
    Hindi: $8bd3c5c9ee0d1eb4$var$Hindi$5,
    Marathi: $8bd3c5c9ee0d1eb4$var$Marathi$5,
    Gujarati: $8bd3c5c9ee0d1eb4$var$Gujarati$5,
    Punjabi: $8bd3c5c9ee0d1eb4$var$Punjabi$5,
    Bengali: $8bd3c5c9ee0d1eb4$var$Bengali$5,
    Tamil: $8bd3c5c9ee0d1eb4$var$Tamil$5,
    Telugu: $8bd3c5c9ee0d1eb4$var$Telugu$5,
    Kannada: $8bd3c5c9ee0d1eb4$var$Kannada$5,
    Assamese: $8bd3c5c9ee0d1eb4$var$Assamese$5,
    Malayalam: $8bd3c5c9ee0d1eb4$var$Malayalam$5,
    Oriya: $8bd3c5c9ee0d1eb4$var$Oriya$5
};
const $8bd3c5c9ee0d1eb4$var$as = "Assamese";
const $8bd3c5c9ee0d1eb4$var$bn = "Bengali";
const $8bd3c5c9ee0d1eb4$var$en = "English";
const $8bd3c5c9ee0d1eb4$var$gu = "Gujarati";
const $8bd3c5c9ee0d1eb4$var$hi = "Hindi";
const $8bd3c5c9ee0d1eb4$var$kn = "Kannada";
const $8bd3c5c9ee0d1eb4$var$ml = "Malayalam";
const $8bd3c5c9ee0d1eb4$var$mr = "Marathi";
const $8bd3c5c9ee0d1eb4$var$or = "Oriya";
const $8bd3c5c9ee0d1eb4$var$pa = "Punjabi";
const $8bd3c5c9ee0d1eb4$var$ta = "Tamil";
const $8bd3c5c9ee0d1eb4$var$te = "Telugu";
const $8bd3c5c9ee0d1eb4$var$localeLanguageData = {
    as: $8bd3c5c9ee0d1eb4$var$as,
    bn: $8bd3c5c9ee0d1eb4$var$bn,
    en: $8bd3c5c9ee0d1eb4$var$en,
    gu: $8bd3c5c9ee0d1eb4$var$gu,
    hi: $8bd3c5c9ee0d1eb4$var$hi,
    kn: $8bd3c5c9ee0d1eb4$var$kn,
    ml: $8bd3c5c9ee0d1eb4$var$ml,
    mr: $8bd3c5c9ee0d1eb4$var$mr,
    or: $8bd3c5c9ee0d1eb4$var$or,
    pa: $8bd3c5c9ee0d1eb4$var$pa,
    ta: $8bd3c5c9ee0d1eb4$var$ta,
    te: $8bd3c5c9ee0d1eb4$var$te
};
const $8bd3c5c9ee0d1eb4$var$English$4 = {
    zero: "0",
    one: "1",
    two: "2",
    three: "3",
    four: "4",
    five: "5",
    six: "6",
    seven: "7",
    eight: "8",
    nine: "9",
    ten: "10",
    eleven: "11",
    twelve: "12",
    thirteen: "13",
    fourteen: "14",
    fifteen: "15",
    sixteen: "16",
    seventeen: "17",
    eighteen: "18",
    nineteen: "19",
    twenty: "20",
    twenty_one: "21",
    twenty_two: "22",
    twenty_three: "23",
    twenty_four: "24",
    twenty_five: "25",
    twenty_six: "26",
    twenty_seven: "27",
    twenty_eight: "28",
    twenty_nine: "29",
    thirty: "30",
    thirty_one: "31"
};
const $8bd3c5c9ee0d1eb4$var$Hindi$4 = {
    zero: "\u0966",
    one: "\u0967",
    two: "\u0968",
    three: "\u0969",
    four: "\u096A",
    five: "\u096B",
    six: "\u096C",
    seven: "\u096D",
    eight: "\u096E",
    nine: "\u096F",
    ten: "\u0967\u0966",
    eleven: "\u0967\u0967",
    twelve: "\u0967\u0968",
    thirteen: "\u0967\u0969",
    fourteen: "\u0967\u096A",
    fifteen: "\u0967\u096B",
    sixteen: "\u0967\u096C",
    seventeen: "\u0967\u096D",
    eighteen: "\u0967\u096E",
    nineteen: "\u0967\u096F",
    twenty: "\u0968\u0966",
    twenty_one: "\u0968\u0967",
    twenty_two: "\u0968\u0968",
    twenty_three: "\u0968\u0969",
    twenty_four: "\u0968\u096A",
    twenty_five: "\u0968\u096B",
    twenty_six: "\u0968\u096C",
    twenty_seven: "\u0968\u096D",
    twenty_eight: "\u0968\u096E",
    twenty_nine: "\u0968\u096F",
    thirty: "\u0969\u0966",
    thirty_one: "\u0969\u0967"
};
const $8bd3c5c9ee0d1eb4$var$Marathi$4 = {
    zero: "\u0966",
    one: "\u0967",
    two: "\u0968",
    three: "\u0969",
    four: "\u096A",
    five: "\u096B",
    six: "\u096C",
    seven: "\u096D",
    eight: "\u096E",
    nine: "\u096F",
    ten: "\u0967\u0966",
    eleven: "\u0967\u0967",
    twelve: "\u0967\u0968",
    thirteen: "\u0967\u0969",
    fourteen: "\u0967\u096A",
    fifteen: "\u0967\u096B",
    sixteen: "\u0967\u096C",
    seventeen: "\u0967\u096D",
    eighteen: "\u0967\u096E",
    nineteen: "\u0967\u096F",
    twenty: "\u0968\u0966",
    twenty_one: "\u0968\u0967",
    twenty_two: "\u0968\u0968",
    twenty_three: "\u0968\u0969",
    twenty_four: "\u0968\u096A",
    twenty_five: "\u0968\u096B",
    twenty_six: "\u0968\u096C",
    twenty_seven: "\u0968\u096D",
    twenty_eight: "\u0968\u096E",
    twenty_nine: "\u0968\u096F",
    thirty: "\u0969\u0966",
    thirty_one: "\u0969\u0967"
};
const $8bd3c5c9ee0d1eb4$var$Gujarati$4 = {
    zero: "\u0AE6",
    one: "\u0AE7",
    two: "\u0AE8",
    three: "\u0AE9",
    four: "\u0AEA",
    five: "\u0AEB",
    six: "\u0AEC",
    seven: "\u0AED",
    eight: "\u0AEE",
    nine: "\u0AEF",
    ten: "\u0AE7\u0AE6",
    eleven: "\u0AE7\u0AE7",
    twelve: "\u0AE7\u0AE8",
    thirteen: "\u0AE7\u0AE9",
    fourteen: "\u0AE7\u0AEA",
    fifteen: "\u0AE7\u0AEB",
    sixteen: "\u0AE7\u0AEC",
    seventeen: "\u0AE7\u0AED",
    eighteen: "\u0AE7\u0AEE",
    nineteen: "\u0AE7\u0AEF",
    twenty: "\u0AE8\u0AE6",
    twenty_one: "\u0AE8\u0AE7",
    twenty_two: "\u0AE8\u0AE8",
    twenty_three: "\u0AE8\u0AE9",
    twenty_four: "\u0AE8\u0AEA",
    twenty_five: "\u0AE8\u0AEB",
    twenty_six: "\u0AE8\u0AEC",
    twenty_seven: "\u0AE8\u0AED",
    twenty_eight: "\u0AE8\u0AEE",
    twenty_nine: "\u0AE8\u0AEF",
    thirty: "\u0AE9\u0AE6",
    thirty_one: "\u0AE9\u0AE7"
};
const $8bd3c5c9ee0d1eb4$var$Punjabi$4 = {
    zero: "\u0A66",
    one: "\u0A67",
    two: "\u0A68",
    three: "\u0A69",
    four: "\u0A6A",
    five: "\u0A6B",
    six: "\u0A6C",
    seven: "\u0A6D",
    eight: "\u0A6E",
    nine: "\u0A6F",
    ten: "\u0A67\u0A66",
    eleven: "\u0A67\u0A67",
    twelve: "\u0A67\u0A68",
    thirteen: "\u0A67\u0A69",
    fourteen: "\u0A67\u0A6A",
    fifteen: "\u0A67\u0A6B",
    sixteen: "\u0A67\u0A6C",
    seventeen: "\u0A67\u0A6D",
    eighteen: "\u0A67\u0A6E",
    nineteen: "\u0A67\u0A6F",
    twenty: "\u0A68\u0A66",
    twenty_one: "\u0A68\u0A67",
    twenty_two: "\u0A68\u0A68",
    twenty_three: "\u0A68\u0A69",
    twenty_four: "\u0A68\u0A6A",
    twenty_five: "\u0A68\u0A6B",
    twenty_six: "\u0A68\u0A6C",
    twenty_seven: "\u0A68\u0A6D",
    twenty_eight: "\u0A68\u0A6E",
    twenty_nine: "\u0A68\u0A6F",
    thirty: "\u0A69\u0A66",
    thirty_one: "\u0A69\u0A67"
};
const $8bd3c5c9ee0d1eb4$var$Bengali$4 = {
    zero: "\u09E6",
    one: "\u09E7",
    two: "\u09E8",
    three: "\u09E9",
    four: "\u09EA",
    five: "\u09EB",
    six: "\u09EC",
    seven: "\u09ED",
    eight: "\u09EE",
    nine: "\u09EF",
    ten: "\u09E7\u09E6",
    eleven: "\u09E7\u09E7",
    twelve: "\u09E7\u09E8",
    thirteen: "\u09E7\u09E9",
    fourteen: "\u09E7\u09EA",
    fifteen: "\u09E7\u09EB",
    sixteen: "\u09E7\u09EC",
    seventeen: "\u09E7\u09ED",
    eighteen: "\u09E7\u09EE",
    nineteen: "\u09E7\u09EF",
    twenty: "\u09E8\u09E6",
    twenty_one: "\u09E8\u09E7",
    twenty_two: "\u09E8\u09E8",
    twenty_three: "\u09E8\u09E9",
    twenty_four: "\u09E8\u09EA",
    twenty_five: "\u09E8\u09EB",
    twenty_six: "\u09E8\u09EC",
    twenty_seven: "\u09E8\u09ED",
    twenty_eight: "\u09E8\u09EE",
    twenty_nine: "\u09E8\u09EF",
    thirty: "\u09E9\u09E6",
    thirty_one: "\u09E9\u09E7"
};
const $8bd3c5c9ee0d1eb4$var$Tamil$4 = {
    zero: "\u0BE6",
    one: "\u0BE7",
    two: "\u0BE8",
    three: "\u0BE9",
    four: "\u0BEA",
    five: "\u0BEB",
    six: "\u0BEC",
    seven: "\u0BED",
    eight: "\u0BEE",
    nine: "\u0BEF",
    ten: "\u0BE7\u0BE6",
    eleven: "\u0BE7\u0BE7",
    twelve: "\u0BE7\u0BE8",
    thirteen: "\u0BE7\u0BE9",
    fourteen: "\u0BE7\u0BEA",
    fifteen: "\u0BE7\u0BEB",
    sixteen: "\u0BE7\u0BEC",
    seventeen: "\u0BE7\u0BED",
    eighteen: "\u0BE7\u0BEE",
    nineteen: "\u0BE7\u0BEF",
    twenty: "\u0BE8\u0BE6",
    twenty_one: "\u0BE8\u0BE7",
    twenty_two: "\u0BE8\u0BE8",
    twenty_three: "\u0BE8\u0BE9",
    twenty_four: "\u0BE8\u0BEA",
    twenty_five: "\u0BE8\u0BEB",
    twenty_six: "\u0BE8\u0BEC",
    twenty_seven: "\u0BE8\u0BED",
    twenty_eight: "\u0BE8\u0BEE",
    twenty_nine: "\u0BE8\u0BEF",
    thirty: "\u0BE9\u0BE6",
    thirty_one: "\u0BE9\u0BE7"
};
const $8bd3c5c9ee0d1eb4$var$Telugu$4 = {
    zero: "\u0C66",
    one: "\u0C67",
    two: "\u0C68",
    three: "\u0C69",
    four: "\u0C6A",
    five: "\u0C6B",
    six: "\u0C6C",
    seven: "\u0C6D",
    eight: "\u0C6E",
    nine: "\u0C6F",
    ten: "\u0C67\u0C66",
    eleven: "\u0C67\u0C67",
    twelve: "\u0C67\u0C68",
    thirteen: "\u0C67\u0C69",
    fourteen: "\u0C67\u0C6A",
    fifteen: "\u0C67\u0C6B",
    sixteen: "\u0C67\u0C6C",
    seventeen: "\u0C67\u0C6D",
    eighteen: "\u0C67\u0C6E",
    nineteen: "\u0C67\u0C6F",
    twenty: "\u0C68\u0C66",
    twenty_one: "\u0C68\u0C67",
    twenty_two: "\u0C68\u0C68",
    twenty_three: "\u0C68\u0C69",
    twenty_four: "\u0C68\u0C6A",
    twenty_five: "\u0C68\u0C6B",
    twenty_six: "\u0C68\u0C6C",
    twenty_seven: "\u0C68\u0C6D",
    twenty_eight: "\u0C68\u0C6E",
    twenty_nine: "\u0C68\u0C6F",
    thirty: "\u0C69\u0C66",
    thirty_one: "\u0C69\u0C67"
};
const $8bd3c5c9ee0d1eb4$var$Kannada$4 = {
    zero: "\u0CE6",
    one: "\u0CE7",
    two: "\u0CE8",
    three: "\u0CE9",
    four: "\u0CEA",
    five: "\u0CEB",
    six: "\u0CEC",
    seven: "\u0CED",
    eight: "\u0CEE",
    nine: "\u0CEF",
    ten: "\u0CE7\u0CE6",
    eleven: "\u0CE7\u0CE7",
    twelve: "\u0CE7\u0CE8",
    thirteen: "\u0CE7\u0CE9",
    fourteen: "\u0CE7\u0CEA",
    fifteen: "\u0CE7\u0CEB",
    sixteen: "\u0CE7\u0CEC",
    seventeen: "\u0CE7\u0CED",
    eighteen: "\u0CE7\u0CEE",
    nineteen: "\u0CE7\u0CEF",
    twenty: "\u0CE8\u0CE6",
    twenty_one: "\u0CE8\u0CE7",
    twenty_two: "\u0CE8\u0CE8",
    twenty_three: "\u0CE8\u0CE9",
    twenty_four: "\u0CE8\u0CEA",
    twenty_five: "\u0CE8\u0CEB",
    twenty_six: "\u0CE8\u0CEC",
    twenty_seven: "\u0CE8\u0CED",
    twenty_eight: "\u0CE8\u0CEE",
    twenty_nine: "\u0CE8\u0CEF",
    thirty: "\u0CE9\u0CE6",
    thirty_one: "\u0CE9\u0CE7"
};
const $8bd3c5c9ee0d1eb4$var$Assamese$4 = {
    zero: "\u09E6",
    one: "\u09E7",
    two: "\u09E8",
    three: "\u09E9",
    four: "\u09EA",
    five: "\u09EB",
    six: "\u09EC",
    seven: "\u09ED",
    eight: "\u09EE",
    nine: "\u09EF",
    ten: "\u09E7\u09E6",
    eleven: "\u09E7\u09E7",
    twelve: "\u09E7\u09E8",
    thirteen: "\u09E7\u09E9",
    fourteen: "\u09E7\u09EA",
    fifteen: "\u09E7\u09EB",
    sixteen: "\u09E7\u09EC",
    seventeen: "\u09E7\u09ED",
    eighteen: "\u09E7\u09EE",
    nineteen: "\u09E7\u09EF",
    twenty: "\u09E8\u09E6",
    twenty_one: "\u09E8\u09E7",
    twenty_two: "\u09E8\u09E8",
    twenty_three: "\u09E8\u09E9",
    twenty_four: "\u09E8\u09EA",
    twenty_five: "\u09E8\u09EB",
    twenty_six: "\u09E8\u09EC",
    twenty_seven: "\u09E8\u09ED",
    twenty_eight: "\u09E8\u09EE",
    twenty_nine: "\u09E8\u09EF",
    thirty: "\u09E9\u09E6",
    thirty_one: "\u09E9\u09E7"
};
const $8bd3c5c9ee0d1eb4$var$Malayalam$4 = {
    zero: "\u0D66",
    one: "\u0D67",
    two: "\u0D68",
    three: "\u0D69",
    four: "\u0D6A",
    five: "\u0D6B",
    six: "\u0D6C",
    seven: "\u0D6D",
    eight: "\u0D6E",
    nine: "\u0D6F",
    ten: "\u0D67\u0D66",
    eleven: "\u0D67\u0D67",
    twelve: "\u0D67\u0D68",
    thirteen: "\u0D67\u0D69",
    fourteen: "\u0D67\u0D6A",
    fifteen: "\u0D67\u0D6B",
    sixteen: "\u0D67\u0D6C",
    seventeen: "\u0D67\u0D6D",
    eighteen: "\u0D67\u0D6E",
    nineteen: "\u0D67\u0D6F",
    twenty: "\u0D68\u0D66",
    twenty_one: "\u0D68\u0D67",
    twenty_two: "\u0D68\u0D68",
    twenty_three: "\u0D68\u0D69",
    twenty_four: "\u0D68\u0D6A",
    twenty_five: "\u0D68\u0D6B",
    twenty_six: "\u0D68\u0D6C",
    twenty_seven: "\u0D68\u0D6D",
    twenty_eight: "\u0D68\u0D6E",
    twenty_nine: "\u0D68\u0D6F",
    thirty: "\u0D69\u0D66",
    thirty_one: "\u0D69\u0D67"
};
const $8bd3c5c9ee0d1eb4$var$Oriya$4 = {
    zero: "\u0B66",
    one: "\u0B67",
    two: "\u0B68",
    three: "\u0B69",
    four: "\u0B6A",
    five: "\u0B6B",
    six: "\u0B6C",
    seven: "\u0B6D",
    eight: "\u0B6E",
    nine: "\u0B6F",
    ten: "\u0B67\u0B66",
    eleven: "\u0B67\u0B67",
    twelve: "\u0B67\u0B68",
    thirteen: "\u0B67\u0B69",
    fourteen: "\u0B67\u0B6A",
    fifteen: "\u0B67\u0B6B",
    sixteen: "\u0B67\u0B6C",
    seventeen: "\u0B67\u0B6D",
    eighteen: "\u0B67\u0B6E",
    nineteen: "\u0B67\u0B6F",
    twenty: "\u0B68\u0B66",
    twenty_one: "\u0B68\u0B67",
    twenty_two: "\u0B68\u0B68",
    twenty_three: "\u0B68\u0B69",
    twenty_four: "\u0B68\u0B6A",
    twenty_five: "\u0B68\u0B6B",
    twenty_six: "\u0B68\u0B6C",
    twenty_seven: "\u0B68\u0B6D",
    twenty_eight: "\u0B68\u0B6E",
    twenty_nine: "\u0B68\u0B6F",
    thirty: "\u0B69\u0B66",
    thirty_one: "\u0B69\u0B67"
};
const $8bd3c5c9ee0d1eb4$var$monthDatesData = {
    English: $8bd3c5c9ee0d1eb4$var$English$4,
    Hindi: $8bd3c5c9ee0d1eb4$var$Hindi$4,
    Marathi: $8bd3c5c9ee0d1eb4$var$Marathi$4,
    Gujarati: $8bd3c5c9ee0d1eb4$var$Gujarati$4,
    Punjabi: $8bd3c5c9ee0d1eb4$var$Punjabi$4,
    Bengali: $8bd3c5c9ee0d1eb4$var$Bengali$4,
    Tamil: $8bd3c5c9ee0d1eb4$var$Tamil$4,
    Telugu: $8bd3c5c9ee0d1eb4$var$Telugu$4,
    Kannada: $8bd3c5c9ee0d1eb4$var$Kannada$4,
    Assamese: $8bd3c5c9ee0d1eb4$var$Assamese$4,
    Malayalam: $8bd3c5c9ee0d1eb4$var$Malayalam$4,
    Oriya: $8bd3c5c9ee0d1eb4$var$Oriya$4
};
const $8bd3c5c9ee0d1eb4$var$English$3 = {
    January: "January",
    February: "February",
    March: "March",
    April: "April",
    May: "May",
    June: "June",
    July: "July",
    August: "August",
    September: "September",
    October: "October",
    November: "November",
    December: "December"
};
const $8bd3c5c9ee0d1eb4$var$Hindi$3 = {
    January: "\u091C\u0928\u0935\u0930\u0940",
    February: "\u092B\u0930\u0935\u0930\u0940",
    March: "\u092E\u093E\u0930\u094D\u091A",
    April: "\u0905\u092A\u094D\u0930\u0948\u0932",
    May: "\u092E\u0908",
    June: "\u091C\u0942\u0928",
    July: "\u091C\u0941\u0932\u093E\u0908",
    August: "\u0905\u0917\u0938\u094D\u0924",
    September: "\u0938\u093F\u0924\u0902\u092C\u0930",
    October: "\u0905\u0915\u094D\u091F\u0942\u092C\u0930",
    November: "\u0928\u0935\u0902\u092C\u0930",
    December: "\u0926\u093F\u0938\u0902\u092C\u0930"
};
const $8bd3c5c9ee0d1eb4$var$Marathi$3 = {
    January: "\u091C\u093E\u0928\u0947\u0935\u093E\u0930\u0940",
    February: "\u092B\u0947\u092C\u094D\u0930\u0941\u0935\u093E\u0930\u0940",
    March: "\u092E\u093E\u0930\u094D\u091A",
    April: "\u090F\u092A\u094D\u0930\u093F\u0932",
    May: "\u092E\u0947",
    June: "\u091C\u0942\u0928",
    July: "\u091C\u0941\u0932\u0948",
    August: "\u0911\u0917\u0938\u094D\u091F",
    September: "\u0938\u092A\u094D\u091F\u0947\u0902\u092C\u0930",
    October: "\u0911\u0915\u094D\u091F\u094B\u092C\u0930",
    November: "\u0928\u094B\u0935\u094D\u0939\u0947\u0902\u092C\u0930",
    December: "\u0921\u093F\u0938\u0947\u0902\u092C\u0930"
};
const $8bd3c5c9ee0d1eb4$var$Gujarati$3 = {
    January: "\u0A9C\u0ABE\u0AA8\u0ACD\u0AAF\u0AC1\u0A86\u0AB0\u0AC0",
    February: "\u0AAB\u0AC7\u0AAC\u0ACD\u0AB0\u0AC1\u0A86\u0AB0\u0AC0",
    March: "\u0AAE\u0ABE\u0AB0\u0ACD\u0A9A",
    April: "\u0A8F\u0AAA\u0ACD\u0AB0\u0ABF\u0AB2",
    May: "\u0AAE\u0AC7",
    June: "\u0A9C\u0AC2\u0AA8",
    July: "\u0A9C\u0AC1\u0AB2\u0ABE\u0A88",
    August: "\u0A91\u0A97\u0AB8\u0ACD\u0A9F",
    September: "\u0AB8\u0AAA\u0ACD\u0A9F\u0AC7\u0AAE\u0ACD\u0AAC\u0AB0",
    October: "\u0A93\u0A95\u0ACD\u0A9F\u0ACB\u0AAC\u0AB0",
    November: "\u0AA8\u0AB5\u0AC7\u0AAE\u0ACD\u0AAC\u0AB0",
    December: "\u0AA1\u0ABF\u0AB8\u0AC7\u0AAE\u0ACD\u0AAC\u0AB0"
};
const $8bd3c5c9ee0d1eb4$var$Punjabi$3 = {
    January: "\u0A1C\u0A28\u0A35\u0A30\u0A40",
    February: "\u0A2B\u0A30\u0A35\u0A30\u0A40",
    March: "\u0A2E\u0A3E\u0A30\u0A1A",
    April: "\u0A05\u0A2A\u0A4D\u0A30\u0A48\u0A32",
    May: "\u0A2E\u0A08",
    June: "\u0A1C\u0A42\u0A28",
    July: "\u0A1C\u0A41\u0A32\u0A3E\u0A08",
    August: "\u0A05\u0A17\u0A38\u0A24",
    September: "\u0A38\u0A24\u0A70\u0A2C\u0A30",
    October: "\u0A05\u0A15\u0A24\u0A42\u0A2C\u0A30",
    November: "\u0A28\u0A35\u0A70\u0A2C\u0A30",
    December: "\u0A26\u0A38\u0A70\u0A2C\u0A30"
};
const $8bd3c5c9ee0d1eb4$var$Bengali$3 = {
    January: "\u099C\u09BE\u09A8\u09C1\u09AF\u09BC\u09BE\u09B0\u09BF",
    February: "\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1\u09AF\u09BC\u09BE\u09B0\u09BF",
    March: "\u09AE\u09BE\u09B0\u09CD\u099A",
    April: "\u098F\u09AA\u09CD\u09B0\u09BF\u09B2",
    May: "\u09AE\u09C7",
    June: "\u099C\u09C1\u09A8",
    July: "\u099C\u09C1\u09B2\u09BE\u0987",
    August: "\u0985\u0997\u09BE\u09B8\u09CD\u099F",
    September: "\u09B8\u09C7\u09AA\u09CD\u099F\u09C7\u09AE\u09CD\u09AC\u09B0",
    October: "\u0985\u0995\u09CD\u099F\u09CB\u09AC\u09B0",
    November: "\u09A8\u09AD\u09C7\u09AE\u09CD\u09AC\u09B0",
    December: "\u09A1\u09BF\u09B8\u09C7\u09AE\u09CD\u09AC\u09B0"
};
const $8bd3c5c9ee0d1eb4$var$Tamil$3 = {
    January: "\u0B9C\u0BA9\u0BB5\u0BB0\u0BBF",
    February: "\u0BAA\u0BBF\u0BAA\u0BCD\u0BB0\u0BB5\u0BB0\u0BBF",
    March: "\u0BAE\u0BBE\u0BB0\u0BCD\u0B9A\u0BCD",
    April: "\u0B8F\u0BAA\u0BCD\u0BB0\u0BB2\u0BCD",
    May: "\u0BAE\u0BC7",
    June: "\u0B9C\u0BC2\u0BA9\u0BCD",
    July: "\u0B9C\u0BC2\u0BB2\u0BC8",
    August: "\u0B86\u0B95\u0BB8\u0BCD\u0B9F\u0BC1",
    September: "\u0B9A\u0BC6\u0BAA\u0BCD\u0B9F\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD",
    October: "\u0B85\u0B95\u0BCD\u0B9F\u0BCB\u0BAA\u0BB0\u0BCD",
    November: "\u0BA8\u0BB5\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD",
    December: "\u0B9F\u0BBF\u0B9A\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD"
};
const $8bd3c5c9ee0d1eb4$var$Telugu$3 = {
    January: "\u0C1C\u0C28\u0C35\u0C30\u0C3F",
    February: "\u0C2B\u0C3F\u0C2C\u0C4D\u0C30\u0C35\u0C30\u0C3F",
    March: "\u0C2E\u0C3E\u0C30\u0C4D\u0C1A\u0C3F",
    April: "\u0C0F\u0C2A\u0C4D\u0C30\u0C3F\u0C32\u0C4D",
    May: "\u0C2E\u0C47",
    June: "\u0C1C\u0C42\u0C28\u0C4D",
    July: "\u0C1C\u0C41\u0C32\u0C48",
    August: "\u0C06\u0C17\u0C37\u0C4D\u0C1F\u0C41",
    September: "\u0C38\u0C46\u0C2A\u0C4D\u0C1F\u0C46\u0C02\u0C2C\u0C30\u0C4D",
    October: "\u0C05\u0C15\u0C4D\u0C1F\u0C4B\u0C2C\u0C30\u0C4D",
    November: "\u0C28\u0C35\u0C02\u0C2C\u0C30\u0C4D",
    December: "\u0C21\u0C3F\u0C38\u0C46\u0C02\u0C2C\u0C30\u0C4D"
};
const $8bd3c5c9ee0d1eb4$var$Kannada$3 = {
    January: "\u0C9C\u0CA8\u0CB5\u0CB0\u0CBF",
    February: "\u0CAB\u0CC6\u0CAC\u0CCD\u0CB0\u0CB5\u0CB0\u0CBF",
    March: "\u0CAE\u0CBE\u0CB0\u0CCD\u0C9A\u0CCD",
    April: "\u0C8F\u0CAA\u0CCD\u0CB0\u0CBF\u0CB2\u0CCD",
    May: "\u0CAE\u0CC7",
    June: "\u0C9C\u0CC2\u0CA8\u0CCD",
    July: "\u0C9C\u0CC1\u0CB2\u0CC8",
    August: "\u0C86\u0C97\u0CB8\u0CCD\u0C9F\u0CCD",
    September: "\u0CB8\u0CC6\u0CAA\u0CCD\u0C9F\u0CC6\u0C82\u0CAC\u0CB0\u0CCD",
    October: "\u0C85\u0C95\u0CCD\u0C9F\u0CCB\u0CAC\u0CB0\u0CCD",
    November: "\u0CA8\u0CB5\u0CC6\u0C82\u0CAC\u0CB0\u0CCD",
    December: "\u0CA1\u0CBF\u0CB8\u0CC6\u0C82\u0CAC\u0CB0\u0CCD"
};
const $8bd3c5c9ee0d1eb4$var$Assamese$3 = {
    January: "\u099C\u09BE\u09A8\u09C1\u09F1\u09BE\u09F0\u09C0",
    February: "\u09AB\u09C7\u09AC\u09CD\u09F0\u09C1\u09F1\u09BE\u09F0\u09C0",
    March: "\u09AE\u09BE\u09F0\u09CD\u099A",
    April: "\u098F\u09AA\u09CD\u09F0\u09BF\u09B2",
    May: "\u09AE\u09C7",
    June: "\u099C\u09C1\u09A8",
    July: "\u099C\u09C1\u09B2\u09BE\u0987",
    August: "\u0986\u0997\u09B7\u09CD\u099F",
    September: "\u099B\u09C7\u09AA\u09CD\u099F\u09C7\u09AE\u09CD\u09AC\u09F0",
    October: "\u0985\u0995\u09CD\u099F\u09CB\u09AC\u09F0",
    November: "\u09A8\u09F1\u09C7\u09AE\u09CD\u09AC\u09F0",
    December: "\u09A1\u09BF\u099A\u09C7\u09AE\u09CD\u09AC\u09F0"
};
const $8bd3c5c9ee0d1eb4$var$Malayalam$3 = {
    January: "\u0D1C\u0D28\u0D41\u0D35\u0D30\u0D3F",
    February: "\u0D2B\u0D46\u0D2C\u0D4D\u0D30\u0D41\u0D35\u0D30\u0D3F",
    March: "\u0D2E\u0D3E\u0D7C\u0D1A\u0D4D\u0D1A\u0D4D",
    April: "\u0D0F\u0D2A\u0D4D\u0D30\u0D3F\u0D7D",
    May: "\u0D2E\u0D47\u0D2F\u0D4D",
    June: "\u0D1C\u0D42\u0D7A",
    July: "\u0D1C\u0D42\u0D32\u0D48",
    August: "\u0D13\u0D17\u0D38\u0D4D\u0D31\u0D4D\u0D31\u0D4D",
    September: "\u0D38\u0D46\u0D2A\u0D4D\u0D31\u0D4D\u0D31\u0D02\u0D2C\u0D7C",
    October: "\u0D12\u0D15\u0D4D\u0D1F\u0D4B\u0D2C\u0D7C",
    November: "\u0D28\u0D35\u0D02\u0D2C\u0D7C",
    December: "\u0D21\u0D3F\u0D38\u0D02\u0D2C\u0D7C"
};
const $8bd3c5c9ee0d1eb4$var$Oriya$3 = {
    January: "\u0B1C\u0B3E\u0B28\u0B41\u0B06\u0B30\u0B40",
    February: "\u0B2B\u0B47\u0B2C\u0B43\u0B5F\u0B3E\u0B30\u0B40",
    March: "\u0B2E\u0B3E\u0B30\u0B4D\u0B1A\u0B4D",
    April: "\u0B0F\u0B2A\u0B4D\u0B30\u0B3F\u0B32",
    May: "\u0B2E\u0B47",
    June: "\u0B1C\u0B41\u0B28",
    July: "\u0B1C\u0B41\u0B32\u0B3E\u0B07",
    August: "\u0B05\u0B17\u0B37\u0B4D\u0B1F",
    September: "\u0B38\u0B47\u0B2A\u0B4D\u0B1F\u0B47\u0B2E\u0B4D\u0B2C\u0B30",
    October: "\u0B05\u0B15\u0B4D\u0B1F\u0B4B\u0B2C\u0B30",
    November: "\u0B28\u0B2D\u0B47\u0B2E\u0B4D\u0B2C\u0B30",
    December: "\u0B21\u0B3F\u0B38\u0B47\u0B2E\u0B4D\u0B2C\u0B30"
};
const $8bd3c5c9ee0d1eb4$var$monthNamesData = {
    English: $8bd3c5c9ee0d1eb4$var$English$3,
    Hindi: $8bd3c5c9ee0d1eb4$var$Hindi$3,
    Marathi: $8bd3c5c9ee0d1eb4$var$Marathi$3,
    Gujarati: $8bd3c5c9ee0d1eb4$var$Gujarati$3,
    Punjabi: $8bd3c5c9ee0d1eb4$var$Punjabi$3,
    Bengali: $8bd3c5c9ee0d1eb4$var$Bengali$3,
    Tamil: $8bd3c5c9ee0d1eb4$var$Tamil$3,
    Telugu: $8bd3c5c9ee0d1eb4$var$Telugu$3,
    Kannada: $8bd3c5c9ee0d1eb4$var$Kannada$3,
    Assamese: $8bd3c5c9ee0d1eb4$var$Assamese$3,
    Malayalam: $8bd3c5c9ee0d1eb4$var$Malayalam$3,
    Oriya: $8bd3c5c9ee0d1eb4$var$Oriya$3
};
const $8bd3c5c9ee0d1eb4$var$English$2 = {
    zero: "0",
    one: "1",
    two: "2",
    three: "3",
    four: "4",
    five: "5",
    six: "6",
    seven: "7",
    eight: "8",
    nine: "9"
};
const $8bd3c5c9ee0d1eb4$var$Hindi$2 = {
    zero: "\u0966",
    one: "\u0967",
    two: "\u0968",
    three: "\u0969",
    four: "\u096A",
    five: "\u096B",
    six: "\u096C",
    seven: "\u096D",
    eight: "\u096E",
    nine: "\u096F"
};
const $8bd3c5c9ee0d1eb4$var$Marathi$2 = {
    zero: "\u0966",
    one: "\u0967",
    two: "\u0968",
    three: "\u0969",
    four: "\u096A",
    five: "\u096B",
    six: "\u096C",
    seven: "\u096D",
    eight: "\u096E",
    nine: "\u096F"
};
const $8bd3c5c9ee0d1eb4$var$Gujarati$2 = {
    zero: "\u0AE6",
    one: "\u0AE7",
    two: "\u0AE8",
    three: "\u0AE9",
    four: "\u0AEA",
    five: "\u0AEB",
    six: "\u0AEC",
    seven: "\u0AED",
    eight: "\u0AEE",
    nine: "\u0AEF"
};
const $8bd3c5c9ee0d1eb4$var$Punjabi$2 = {
    zero: "\u0A66",
    one: "\u0A67",
    two: "\u0A68",
    three: "\u0A69",
    four: "\u0A6A",
    five: "\u0A6B",
    six: "\u0A6C",
    seven: "\u0A6D",
    eight: "\u0A6E",
    nine: "\u0A6F"
};
const $8bd3c5c9ee0d1eb4$var$Bengali$2 = {
    zero: "\u09E6",
    one: "\u09E7",
    two: "\u09E8",
    three: "\u09E9",
    four: "\u09EA",
    five: "\u09EB",
    six: "\u09EC",
    seven: "\u09ED",
    eight: "\u09EE",
    nine: "\u09EF"
};
const $8bd3c5c9ee0d1eb4$var$Tamil$2 = {
    zero: "\u0BE6",
    one: "\u0BE7",
    two: "\u0BE8",
    three: "\u0BE9",
    four: "\u0BEA",
    five: "\u0BEB",
    six: "\u0BEC",
    seven: "\u0BED",
    eight: "\u0BEE",
    nine: "\u0BEF"
};
const $8bd3c5c9ee0d1eb4$var$Telugu$2 = {
    zero: "\u0C66",
    one: "\u0C67",
    two: "\u0C68",
    three: "\u0C69",
    four: "\u0C6A",
    five: "\u0C6B",
    six: "\u0C6C",
    seven: "\u0C6D",
    eight: "\u0C6E",
    nine: "\u0C6F"
};
const $8bd3c5c9ee0d1eb4$var$Kannada$2 = {
    zero: "\u0CE6",
    one: "\u0CE7",
    two: "\u0CE8",
    three: "\u0CE9",
    four: "\u0CEA",
    five: "\u0CEB",
    six: "\u0CEC",
    seven: "\u0CED",
    eight: "\u0CEE",
    nine: "\u0CEF"
};
const $8bd3c5c9ee0d1eb4$var$Assamese$2 = {
    zero: "\u09E6",
    one: "\u09E7",
    two: "\u09E8",
    three: "\u09E9",
    four: "\u09EA",
    five: "\u09EB",
    six: "\u09EC",
    seven: "\u09ED",
    eight: "\u09EE",
    nine: "\u09EF"
};
const $8bd3c5c9ee0d1eb4$var$Malayalam$2 = {
    zero: "\u0D66",
    one: "\u0D67",
    two: "\u0D68",
    three: "\u0D69",
    four: "\u0D6A",
    five: "\u0D6B",
    six: "\u0D6C",
    seven: "\u0D6D",
    eight: "\u0D6E",
    nine: "\u0D6F"
};
const $8bd3c5c9ee0d1eb4$var$Oriya$2 = {
    zero: "\u0B66",
    one: "\u0B67",
    two: "\u0B68",
    three: "\u0B69",
    four: "\u0B6A",
    five: "\u0B6B",
    six: "\u0B6C",
    seven: "\u0B6D",
    eight: "\u0B6E",
    nine: "\u0B6F"
};
const $8bd3c5c9ee0d1eb4$var$numberData = {
    English: $8bd3c5c9ee0d1eb4$var$English$2,
    Hindi: $8bd3c5c9ee0d1eb4$var$Hindi$2,
    Marathi: $8bd3c5c9ee0d1eb4$var$Marathi$2,
    Gujarati: $8bd3c5c9ee0d1eb4$var$Gujarati$2,
    Punjabi: $8bd3c5c9ee0d1eb4$var$Punjabi$2,
    Bengali: $8bd3c5c9ee0d1eb4$var$Bengali$2,
    Tamil: $8bd3c5c9ee0d1eb4$var$Tamil$2,
    Telugu: $8bd3c5c9ee0d1eb4$var$Telugu$2,
    Kannada: $8bd3c5c9ee0d1eb4$var$Kannada$2,
    Assamese: $8bd3c5c9ee0d1eb4$var$Assamese$2,
    Malayalam: $8bd3c5c9ee0d1eb4$var$Malayalam$2,
    Oriya: $8bd3c5c9ee0d1eb4$var$Oriya$2
};
const $8bd3c5c9ee0d1eb4$var$English$1 = {
    Sunday: "S",
    Monday: "M",
    Tuesday: "T",
    Wednesday: "W",
    Thursday: "T",
    Friday: "F",
    Saturday: "S"
};
const $8bd3c5c9ee0d1eb4$var$Hindi$1 = {
    Sunday: "\u0930",
    Monday: "\u0938\u094B",
    Tuesday: "\u092E\u0902",
    Wednesday: "\u092C\u0941",
    Thursday: "\u0917\u0941",
    Friday: "\u0936\u0941",
    Saturday: "\u0936"
};
const $8bd3c5c9ee0d1eb4$var$Marathi$1 = {
    Sunday: "\u0930",
    Monday: "\u0938\u094B",
    Tuesday: "\u092E\u0902",
    Wednesday: "\u092C\u0941",
    Thursday: "\u0917\u0941",
    Friday: "\u0936\u0941",
    Saturday: "\u0936"
};
const $8bd3c5c9ee0d1eb4$var$Gujarati$1 = {
    Sunday: "\u0AB0",
    Monday: "\u0AB8\u0ACB",
    Tuesday: "\u0AAE\u0A82",
    Wednesday: "\u0AAC\u0AC1",
    Thursday: "\u0A97\u0AC1",
    Friday: "\u0AB6\u0AC1",
    Saturday: "\u0AB6"
};
const $8bd3c5c9ee0d1eb4$var$Punjabi$1 = {
    Sunday: "\u0A10",
    Monday: "\u0A38\u0A4B",
    Tuesday: "\u0A2E\u0A70",
    Wednesday: "\u0A2C\u0A41",
    Thursday: "\u0A35\u0A40",
    Friday: "\u0A36\u0A41",
    Saturday: "\u0A38\u0A3C"
};
const $8bd3c5c9ee0d1eb4$var$Bengali$1 = {
    Sunday: "\u09B0",
    Monday: "\u09B8\u09CB",
    Tuesday: "\u09AE\u0982",
    Wednesday: "\u09AC\u09C1",
    Thursday: "\u09AC\u09C3",
    Friday: "\u09B6\u09C1",
    Saturday: "\u09B6"
};
const $8bd3c5c9ee0d1eb4$var$Tamil$1 = {
    Sunday: "\u0B9E\u0BBE",
    Monday: "\u0BA4\u0BBF",
    Tuesday: "\u0B9A\u0BC6",
    Wednesday: "\u0BAA\u0BC1",
    Thursday: "\u0BB5\u0BBF",
    Friday: "\u0BB5\u0BC6",
    Saturday: "\u0B9A"
};
const $8bd3c5c9ee0d1eb4$var$Telugu$1 = {
    Sunday: "\u0C06",
    Monday: "\u0C38\u0C4B",
    Tuesday: "\u0C2E\u0C02",
    Wednesday: "\u0C2C\u0C41",
    Thursday: "\u0C17\u0C41",
    Friday: "\u0C36\u0C41",
    Saturday: "\u0C36"
};
const $8bd3c5c9ee0d1eb4$var$Kannada$1 = {
    Sunday: "\u0CAD\u0CBE",
    Monday: "\u0CB8\u0CCB",
    Tuesday: "\u0CAE\u0C82",
    Wednesday: "\u0CAC\u0CC1",
    Thursday: "\u0C97\u0CC1",
    Friday: "\u0CB6\u0CC1",
    Saturday: "\u0CB6"
};
const $8bd3c5c9ee0d1eb4$var$Assamese$1 = {
    Sunday: "\u09F0",
    Monday: "\u09B8\u09CB",
    Tuesday: "\u09AE\u0982",
    Wednesday: "\u09AC\u09C1",
    Thursday: "\u09AC\u09C3",
    Friday: "\u09B6\u09C1",
    Saturday: "\u09B6"
};
const $8bd3c5c9ee0d1eb4$var$Malayalam$1 = {
    Sunday: "\u0D1E\u0D3E",
    Monday: "\u0D24\u0D3F",
    Tuesday: "\u0D1A\u0D4A",
    Wednesday: "\u0D2C\u0D41",
    Thursday: "\u0D35\u0D4D\u0D2F",
    Friday: "\u0D35\u0D46",
    Saturday: "\u0D36"
};
const $8bd3c5c9ee0d1eb4$var$Oriya$1 = {
    Sunday: "\u0B30",
    Monday: "\u0B38\u0B4B",
    Tuesday: "\u0B2E\u0B02",
    Wednesday: "\u0B2C\u0B41",
    Thursday: "\u0B2C\u0B3F",
    Friday: "\u0B36\u0B41",
    Saturday: "\u0B36"
};
const $8bd3c5c9ee0d1eb4$var$weekdayInitialsData = {
    English: $8bd3c5c9ee0d1eb4$var$English$1,
    Hindi: $8bd3c5c9ee0d1eb4$var$Hindi$1,
    Marathi: $8bd3c5c9ee0d1eb4$var$Marathi$1,
    Gujarati: $8bd3c5c9ee0d1eb4$var$Gujarati$1,
    Punjabi: $8bd3c5c9ee0d1eb4$var$Punjabi$1,
    Bengali: $8bd3c5c9ee0d1eb4$var$Bengali$1,
    Tamil: $8bd3c5c9ee0d1eb4$var$Tamil$1,
    Telugu: $8bd3c5c9ee0d1eb4$var$Telugu$1,
    Kannada: $8bd3c5c9ee0d1eb4$var$Kannada$1,
    Assamese: $8bd3c5c9ee0d1eb4$var$Assamese$1,
    Malayalam: $8bd3c5c9ee0d1eb4$var$Malayalam$1,
    Oriya: $8bd3c5c9ee0d1eb4$var$Oriya$1
};
const $8bd3c5c9ee0d1eb4$var$English = {
    Sunday: "Sunday",
    Monday: "Monday",
    Tuesday: "Tuesday",
    Wednesday: "Wednesday",
    Thursday: "Thursday",
    Friday: "Friday",
    Saturday: "Saturday"
};
const $8bd3c5c9ee0d1eb4$var$Hindi = {
    Sunday: "\u0930\u0935\u093F\u0935\u093E\u0930",
    Monday: "\u0938\u094B\u092E\u0935\u093E\u0930",
    Tuesday: "\u092E\u0902\u0917\u0932\u0935\u093E\u0930",
    Wednesday: "\u092C\u0941\u0927\u0935\u093E\u0930",
    Thursday: "\u0917\u0941\u0930\u0941\u0935\u093E\u0930",
    Friday: "\u0936\u0941\u0915\u094D\u0930\u0935\u093E\u0930",
    Saturday: "\u0936\u0928\u093F\u0935\u093E\u0930"
};
const $8bd3c5c9ee0d1eb4$var$Marathi = {
    Sunday: "\u0930\u0935\u093F\u0935\u093E\u0930",
    Monday: "\u0938\u094B\u092E\u0935\u093E\u0930",
    Tuesday: "\u092E\u0902\u0917\u0933\u0935\u093E\u0930",
    Wednesday: "\u092C\u0941\u0927\u0935\u093E\u0930",
    Thursday: "\u0917\u0941\u0930\u0941\u0935\u093E\u0930",
    Friday: "\u0936\u0941\u0915\u094D\u0930\u0935\u093E\u0930",
    Saturday: "\u0936\u0928\u093F\u0935\u093E\u0930"
};
const $8bd3c5c9ee0d1eb4$var$Gujarati = {
    Sunday: "\u0AB0\u0AB5\u0ABF\u0AB5\u0ABE\u0AB0",
    Monday: "\u0AB8\u0ACB\u0AAE\u0AB5\u0ABE\u0AB0",
    Tuesday: "\u0AAE\u0A82\u0A97\u0AB3\u0AB5\u0ABE\u0AB0",
    Wednesday: "\u0AAC\u0AC1\u0AA7\u0AB5\u0ABE\u0AB0",
    Thursday: "\u0A97\u0AC1\u0AB0\u0AC1\u0AB5\u0ABE\u0AB0",
    Friday: "\u0AB6\u0AC1\u0A95\u0ACD\u0AB0\u0AB5\u0ABE\u0AB0",
    Saturday: "\u0AB6\u0AA8\u0ABF\u0AB5\u0ABE\u0AB0"
};
const $8bd3c5c9ee0d1eb4$var$Punjabi = {
    Sunday: "\u0A10\u0A24\u0A35\u0A3E\u0A30",
    Monday: "\u0A38\u0A4B\u0A2E\u0A35\u0A3E\u0A30",
    Tuesday: "\u0A2E\u0A70\u0A17\u0A32\u0A35\u0A3E\u0A30",
    Wednesday: "\u0A2C\u0A41\u0A71\u0A27\u0A35\u0A3E\u0A30",
    Thursday: "\u0A35\u0A40\u0A30\u0A35\u0A3E\u0A30",
    Friday: "\u0A36\u0A41\u0A71\u0A15\u0A30\u0A35\u0A3E\u0A30",
    Saturday: "\u0A38\u0A3C\u0A28\u0A3F\u0A35\u0A3E\u0A30"
};
const $8bd3c5c9ee0d1eb4$var$Bengali = {
    Sunday: "\u09B0\u09AC\u09BF\u09AC\u09BE\u09B0",
    Monday: "\u09B8\u09CB\u09AE\u09AC\u09BE\u09B0",
    Tuesday: "\u09AE\u0999\u09CD\u0997\u09B2\u09AC\u09BE\u09B0",
    Wednesday: "\u09AC\u09C1\u09A7\u09AC\u09BE\u09B0",
    Thursday: "\u09AC\u09C3\u09B9\u09B8\u09CD\u09AA\u09A4\u09BF\u09AC\u09BE\u09B0",
    Friday: "\u09B6\u09C1\u0995\u09CD\u09B0\u09AC\u09BE\u09B0",
    Saturday: "\u09B6\u09A8\u09BF\u09AC\u09BE\u09B0"
};
const $8bd3c5c9ee0d1eb4$var$Tamil = {
    Sunday: "\u0B9E\u0BBE\u0BAF\u0BBF\u0BB1\u0BC1",
    Monday: "\u0BA4\u0BBF\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
    Tuesday: "\u0B9A\u0BC6\u0BB5\u0BCD\u0BB5\u0BBE\u0BAF\u0BCD",
    Wednesday: "\u0BAA\u0BC1\u0BA4\u0BA9\u0BCD",
    Thursday: "\u0BB5\u0BBF\u0BAF\u0BBE\u0BB4\u0BA9\u0BCD",
    Friday: "\u0BB5\u0BC6\u0BB3\u0BCD\u0BB3\u0BBF",
    Saturday: "\u0B9A\u0BA9\u0BBF\u0B95\u0BCD\u0B95\u0BBF\u0BB4\u0BAE\u0BC8"
};
const $8bd3c5c9ee0d1eb4$var$Telugu = {
    Sunday: "\u0C06\u0C26\u0C3F\u0C35\u0C3E\u0C30\u0C02",
    Monday: "\u0C38\u0C4B\u0C2E\u0C35\u0C3E\u0C30\u0C02",
    Tuesday: "\u0C2E\u0C02\u0C17\u0C33\u0C35\u0C3E\u0C30\u0C02",
    Wednesday: "\u0C2C\u0C41\u0C27\u0C35\u0C3E\u0C30\u0C02",
    Thursday: "\u0C17\u0C41\u0C30\u0C41\u0C35\u0C3E\u0C30\u0C02",
    Friday: "\u0C36\u0C41\u0C15\u0C4D\u0C30\u0C35\u0C3E\u0C30\u0C02",
    Saturday: "\u0C36\u0C28\u0C3F\u0C35\u0C3E\u0C30\u0C02"
};
const $8bd3c5c9ee0d1eb4$var$Kannada = {
    Sunday: "\u0CAD\u0CBE\u0CA8\u0CC1\u0CB5\u0CBE\u0CB0",
    Monday: "\u0CB8\u0CCB\u0CAE\u0CB5\u0CBE\u0CB0",
    Tuesday: "\u0CAE\u0C82\u0C97\u0CB3\u0CB5\u0CBE\u0CB0",
    Wednesday: "\u0CAC\u0CC1\u0CA7\u0CB5\u0CBE\u0CB0",
    Thursday: "\u0C97\u0CC1\u0CB0\u0CC1\u0CB5\u0CBE\u0CB0",
    Friday: "\u0CB6\u0CC1\u0C95\u0CCD\u0CB0\u0CB5\u0CBE\u0CB0",
    Saturday: "\u0CB6\u0CA8\u0CBF\u0CB5\u0CBE\u0CB0"
};
const $8bd3c5c9ee0d1eb4$var$Assamese = {
    Sunday: "\u09AD\u09BE\u09A8\u09C1\u09F1\u09BE\u09B0",
    Monday: "\u09B8\u09CB\u09AE\u09AC\u09BE\u09F0",
    Tuesday: "\u09AE\u0999\u09CD\u0997\u09B2\u09AC\u09BE\u09F0",
    Wednesday: "\u09AC\u09C1\u09A7\u09AC\u09BE\u09F0",
    Thursday: "\u09AC\u09C3\u09B9\u09B8\u09CD\u09AA\u09A4\u09BF\u09AC\u09BE\u09F0",
    Friday: "\u09B6\u09C1\u0995\u09CD\u09F0\u09AC\u09BE\u09F0",
    Saturday: "\u09B6\u09A8\u09BF\u09AC\u09BE\u09F0"
};
const $8bd3c5c9ee0d1eb4$var$Malayalam = {
    Sunday: "\u0D1E\u0D3E\u0D2F\u0D31\u0D3E\u0D34\u0D4D\u0D1A",
    Monday: "\u0D24\u0D3F\u0D19\u0D4D\u0D15\u0D33\u0D3E\u0D34\u0D4D\u0D1A",
    Tuesday: "\u0D1A\u0D4A\u0D35\u0D4D\u0D35\u0D3E\u0D34\u0D4D\u0D1A",
    Wednesday: "\u0D2C\u0D41\u0D27\u0D28\u0D3E\u0D34\u0D4D\u0D1A",
    Thursday: "\u0D35\u0D4D\u0D2F\u0D3E\u0D34\u0D3E\u0D34\u0D4D\u0D1A",
    Friday: "\u0D35\u0D46\u0D33\u0D4D\u0D33\u0D3F\u0D2F\u0D3E\u0D34\u0D4D\u0D1A",
    Saturday: "\u0D36\u0D28\u0D3F\u0D2F\u0D3E\u0D34\u0D4D\u0D1A"
};
const $8bd3c5c9ee0d1eb4$var$Oriya = {
    Sunday: "\u0B30\u0B2C\u0B3F\u0B2C\u0B3E\u0B30",
    Monday: "\u0B38\u0B4B\u0B2E\u0B2C\u0B3E\u0B30",
    Tuesday: "\u0B2E\u0B19\u0B4D\u0B17\u0B33\u0B2C\u0B3E\u0B30",
    Wednesday: "\u0B2C\u0B41\u0B27\u0B2C\u0B3E\u0B30",
    Thursday: "\u0B2C\u0B43\u0B39\u0B38\u0B4D\u0B2A\u0B24\u0B3F\u0B2C\u0B3E\u0B30",
    Friday: "\u0B36\u0B41\u0B15\u0B4D\u0B30\u0B2C\u0B3E\u0B30",
    Saturday: "\u0B36\u0B28\u0B3F\u0B2C\u0B3E\u0B30"
};
const $8bd3c5c9ee0d1eb4$var$weekdayNamesData = {
    English: $8bd3c5c9ee0d1eb4$var$English,
    Hindi: $8bd3c5c9ee0d1eb4$var$Hindi,
    Marathi: $8bd3c5c9ee0d1eb4$var$Marathi,
    Gujarati: $8bd3c5c9ee0d1eb4$var$Gujarati,
    Punjabi: $8bd3c5c9ee0d1eb4$var$Punjabi,
    Bengali: $8bd3c5c9ee0d1eb4$var$Bengali,
    Tamil: $8bd3c5c9ee0d1eb4$var$Tamil,
    Telugu: $8bd3c5c9ee0d1eb4$var$Telugu,
    Kannada: $8bd3c5c9ee0d1eb4$var$Kannada,
    Assamese: $8bd3c5c9ee0d1eb4$var$Assamese,
    Malayalam: $8bd3c5c9ee0d1eb4$var$Malayalam,
    Oriya: $8bd3c5c9ee0d1eb4$var$Oriya
};
const $8bd3c5c9ee0d1eb4$var$LOCALE_LANGUAGE_MAP = $8bd3c5c9ee0d1eb4$var$localeLanguageData;
const $8bd3c5c9ee0d1eb4$var$MONTH_DATES = $8bd3c5c9ee0d1eb4$var$monthDatesData;
const $8bd3c5c9ee0d1eb4$var$NUMBERS = $8bd3c5c9ee0d1eb4$var$numberData;
const $8bd3c5c9ee0d1eb4$var$WEEKDAY_INITIALS = $8bd3c5c9ee0d1eb4$var$weekdayInitialsData;
const $8bd3c5c9ee0d1eb4$var$WEEKDAY_NAMES = $8bd3c5c9ee0d1eb4$var$weekdayNamesData;
const $8bd3c5c9ee0d1eb4$var$MONTH_NAMES = $8bd3c5c9ee0d1eb4$var$monthNamesData;
const $8bd3c5c9ee0d1eb4$var$CONFIRM_BUTTON = $8bd3c5c9ee0d1eb4$var$confirmButtonData;
const $8bd3c5c9ee0d1eb4$var$OF = $8bd3c5c9ee0d1eb4$var$ofData;
const $8bd3c5c9ee0d1eb4$var$weekdayKeys = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
];
const $8bd3c5c9ee0d1eb4$var$monthKeys = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
const $8bd3c5c9ee0d1eb4$var$monthDateKeys = [
    "one",
    "two",
    "three",
    "four",
    "five",
    "six",
    "seven",
    "eight",
    "nine",
    "ten",
    "eleven",
    "twelve",
    "thirteen",
    "fourteen",
    "fifteen",
    "sixteen",
    "seventeen",
    "eighteen",
    "nineteen",
    "twenty",
    "twenty_one",
    "twenty_two",
    "twenty_three",
    "twenty_four",
    "twenty_five",
    "twenty_six",
    "twenty_seven",
    "twenty_eight",
    "twenty_nine",
    "thirty",
    "thirty_one"
];
const $8bd3c5c9ee0d1eb4$var$numberKeys = [
    "zero",
    "one",
    "two",
    "three",
    "four",
    "five",
    "six",
    "seven",
    "eight",
    "nine"
];
function $8bd3c5c9ee0d1eb4$export$e085862dfb8d71(locale) {
    return $8bd3c5c9ee0d1eb4$var$LOCALE_LANGUAGE_MAP[locale];
}
function $8bd3c5c9ee0d1eb4$export$4ee93fd31f185549(locale = "en") {
    const language = $8bd3c5c9ee0d1eb4$export$e085862dfb8d71(locale);
    const dates = $8bd3c5c9ee0d1eb4$var$MONTH_DATES[language];
    return $8bd3c5c9ee0d1eb4$var$monthDateKeys.map((key)=>dates[key]);
}
function $8bd3c5c9ee0d1eb4$export$cae41416faa27367(locale = "en") {
    const language = $8bd3c5c9ee0d1eb4$export$e085862dfb8d71(locale);
    const names = $8bd3c5c9ee0d1eb4$var$MONTH_NAMES[language];
    return $8bd3c5c9ee0d1eb4$var$monthKeys.map((key)=>names[key]);
}
function $8bd3c5c9ee0d1eb4$export$3f81e69b9bc596cd(locale = "en") {
    const language = $8bd3c5c9ee0d1eb4$export$e085862dfb8d71(locale);
    const numbers = $8bd3c5c9ee0d1eb4$var$NUMBERS[language];
    return $8bd3c5c9ee0d1eb4$var$numberKeys.map((key)=>numbers[key]);
}
function $8bd3c5c9ee0d1eb4$export$3d12634d88530fee(locale = "en") {
    const language = $8bd3c5c9ee0d1eb4$export$e085862dfb8d71(locale);
    const initials = $8bd3c5c9ee0d1eb4$var$WEEKDAY_INITIALS[language];
    return $8bd3c5c9ee0d1eb4$var$weekdayKeys.map((key)=>initials[key]);
}
function $8bd3c5c9ee0d1eb4$export$bd4a8430f86abf7b(locale = "en") {
    const language = $8bd3c5c9ee0d1eb4$export$e085862dfb8d71(locale);
    const names = $8bd3c5c9ee0d1eb4$var$WEEKDAY_NAMES[language];
    return $8bd3c5c9ee0d1eb4$var$weekdayKeys.map((key)=>names[key]);
}
function $8bd3c5c9ee0d1eb4$export$6d8d0ec03e692fdc(locale = "en") {
    const language = $8bd3c5c9ee0d1eb4$export$e085862dfb8d71(locale);
    const labelObj = $8bd3c5c9ee0d1eb4$var$CONFIRM_BUTTON[language];
    return Object.values(labelObj)[0];
}
function $8bd3c5c9ee0d1eb4$export$fb5267b92d6c6cd3(locale = "en") {
    const language = $8bd3c5c9ee0d1eb4$export$e085862dfb8d71(locale);
    const ofObj = $8bd3c5c9ee0d1eb4$var$OF[language];
    return Object.values(ofObj)[0];
}
const $8bd3c5c9ee0d1eb4$export$8793edee2d425525 = ()=>{};
const $8bd3c5c9ee0d1eb4$export$b806f3e5b648e4a8 = (cb, deps = [])=>{
    const [element, setElement] = (0, $acw62.useState)(null);
    const rootRef = (0, $acw62.useCallback)((element2)=>{
        setElement(element2);
        cb?.(element2);
    }, [
        ...deps
    ]);
    return {
        element: element,
        rootRef: rootRef
    };
};



var $acw62 = parcelRequire("acw62");
const $fe5170bdd3625759$var$sdl$2c = {
    "metadata": {
        "version": "1.0.0",
        "id": "icon-1.0.0",
        "name": "JDSIcon",
        "layerName": "jds_icon"
    },
    "hierarchy": {
        "container": [
            "icon",
            "lottie"
        ]
    },
    "base": {
        "container": {
            "background-color": "{icon_0}",
            "border-radius": "{icon_1}",
            "size": "{icon_2}",
            "justify-content": "{icon_3}",
            "align-items": "{icon_4}"
        },
        "icon": {
            "size": "{icon_5}",
            "color": "{icon_6}"
        },
        "lottie": {
            "hidden": true,
            "size": "{icon_5}",
            "repeat": true
        }
    },
    "variant": {
        "kind": {
            "background": {},
            "background_bold": {},
            "inverse": {}
        },
        "color": {
            "primary_50": {
                "icon": {
                    "color": "{icon_7}"
                }
            },
            "primary_30": {
                "icon": {
                    "color": "{icon_8}"
                }
            },
            "primary_60": {
                "icon": {
                    "color": "{icon_9}"
                }
            },
            "primary_70": {
                "icon": {
                    "color": "{icon_10}"
                }
            },
            "primary_background": {
                "icon": {
                    "color": "{icon_11}"
                }
            },
            "secondary_50": {
                "icon": {
                    "color": "{icon_12}"
                }
            },
            "sparkle_50": {
                "icon": {
                    "color": "{icon_13}"
                }
            },
            "primary_grey_60": {
                "icon": {
                    "color": "{icon_14}"
                }
            },
            "primary_grey_80": {
                "icon": {
                    "color": "{icon_15}"
                }
            },
            "primary_grey_100": {
                "icon": {
                    "color": "{icon_16}"
                }
            },
            "feedback_success": {
                "icon": {
                    "color": "{icon_17}",
                    "value": "ic_success_colored"
                }
            },
            "feedback_error": {
                "icon": {
                    "color": "{icon_18}",
                    "value": "ic_error_colored"
                }
            },
            "feedback_warning": {
                "icon": {
                    "color": "{icon_19}",
                    "value": "ic_warning_colored"
                }
            },
            "feedback_success_50": {
                "icon": {
                    "color": "{icon_17}"
                }
            },
            "feedback_error_50": {
                "icon": {
                    "color": "{icon_18}"
                }
            },
            "feedback_warning_50": {
                "icon": {
                    "color": "{icon_19}"
                }
            },
            "white": {
                "icon": {
                    "color": "{icon_20}"
                }
            },
            "none": {
                "icon": {
                    "color": ""
                }
            }
        },
        "size": {
            "small": {
                "container": {
                    "size": "{icon_21}"
                },
                "icon": {
                    "size": "{icon_22}"
                },
                "lottie": {
                    "size": "{icon_22}"
                }
            },
            "large": {
                "container": {
                    "size": "{icon_23}"
                },
                "icon": {
                    "size": "{icon_24}"
                },
                "lottie": {
                    "size": "{icon_24}"
                }
            },
            "xtra-large": {
                "container": {
                    "size": "{icon_25}"
                },
                "icon": {
                    "size": "{icon_26}"
                },
                "lottie": {
                    "size": "{icon_26}"
                }
            },
            "xtra-xtra-large": {
                "container": {
                    "size": "{icon_27}"
                },
                "icon": {
                    "size": "{icon_28}"
                },
                "lottie": {
                    "size": "{icon_28}"
                }
            }
        },
        "_isLottieVisible": {
            "true": {
                "lottie": {
                    "hidden": false
                },
                "icon": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {
            "background": {
                "primary_50": {
                    "container": {
                        "background-color": "{icon_31}"
                    }
                },
                "primary_30": {
                    "container": {
                        "background-color": "{icon_32}"
                    }
                },
                "primary_60": {
                    "container": {
                        "background-color": "{icon_33}"
                    }
                },
                "primary_70": {
                    "container": {
                        "background-color": "{icon_34}"
                    }
                },
                "primary_background": {
                    "container": {
                        "background-color": "{icon_35}"
                    }
                },
                "secondary_50": {
                    "container": {
                        "background-color": "{icon_36}"
                    }
                },
                "sparkle_50": {
                    "container": {
                        "background-color": "{icon_37}"
                    }
                },
                "primary_grey_60": {
                    "container": {
                        "background-color": "{icon_38}"
                    }
                },
                "primary_grey_80": {
                    "container": {
                        "background-color": "{icon_39}"
                    }
                },
                "primary_grey_100": {
                    "container": {
                        "background-color": "{icon_40}"
                    }
                },
                "white": {
                    "container": {
                        "background-color": "{icon_41}"
                    }
                },
                "feedback_success_50": {
                    "container": {
                        "background-color": "{icon_42}"
                    }
                },
                "feedback_error_50": {
                    "container": {
                        "background-color": "{icon_43}"
                    }
                },
                "feedback_warning_50": {
                    "container": {
                        "background-color": "{icon_44}"
                    }
                }
            },
            "background_bold": {
                "primary_50": {
                    "container": {
                        "background-color": "{icon_45}"
                    },
                    "icon": {
                        "color": "{icon_46}"
                    }
                },
                "primary_30": {
                    "container": {
                        "background-color": "{icon_47}"
                    },
                    "icon": {
                        "color": "{icon_48}"
                    }
                },
                "primary_60": {
                    "container": {
                        "background-color": "{icon_49}"
                    },
                    "icon": {
                        "color": "{icon_50}"
                    }
                },
                "primary_70": {
                    "container": {
                        "background-color": "{icon_51}"
                    },
                    "icon": {
                        "color": "{icon_52}"
                    }
                },
                "primary_background": {
                    "container": {
                        "background-color": "{icon_53}"
                    },
                    "icon": {
                        "color": "{icon_54}"
                    }
                },
                "secondary_50": {
                    "container": {
                        "background-color": "{icon_55}"
                    },
                    "icon": {
                        "color": "{icon_56}"
                    }
                },
                "sparkle_50": {
                    "container": {
                        "background-color": "{icon_57}"
                    },
                    "icon": {
                        "color": "{icon_58}"
                    }
                },
                "primary_grey_60": {
                    "container": {
                        "background-color": "{icon_59}"
                    },
                    "icon": {
                        "color": "{icon_60}"
                    }
                },
                "primary_grey_80": {
                    "container": {
                        "background-color": "{icon_61}"
                    },
                    "icon": {
                        "color": "{icon_62}"
                    }
                },
                "primary_grey_100": {
                    "container": {
                        "background-color": "{icon_63}"
                    },
                    "icon": {
                        "color": "{icon_64}"
                    }
                },
                "white": {
                    "container": {
                        "background-color": "{icon_65}"
                    },
                    "icon": {
                        "color": "{icon_66}"
                    }
                },
                "feedback_success_50": {
                    "container": {
                        "background-color": "{icon_67}"
                    },
                    "icon": {
                        "color": "{icon_68}"
                    }
                },
                "feedback_error_50": {
                    "container": {
                        "background-color": "{icon_69}"
                    },
                    "icon": {
                        "color": "{icon_70}"
                    }
                },
                "feedback_warning_50": {
                    "container": {
                        "background-color": "{icon_71}"
                    },
                    "icon": {
                        "color": "{icon_72}"
                    }
                }
            },
            "inverse": {
                "primary_50": {
                    "icon": {
                        "color": "{icon_170}"
                    }
                },
                "primary_30": {
                    "icon": {
                        "color": "{icon_170}"
                    }
                },
                "primary_60": {
                    "icon": {
                        "color": "{icon_170}"
                    }
                },
                "primary_70": {
                    "icon": {
                        "color": "{icon_170}"
                    }
                },
                "primary_background": {
                    "icon": {
                        "color": "{icon_170}"
                    }
                },
                "secondary_50": {
                    "icon": {
                        "color": "{icon_171}"
                    }
                },
                "sparkle_50": {
                    "icon": {
                        "color": "{icon_172}"
                    }
                },
                "primary_grey_60": {
                    "icon": {
                        "color": "{icon_170}"
                    }
                },
                "primary_grey_80": {
                    "icon": {
                        "color": "{icon_170}"
                    }
                },
                "primary_grey_100": {
                    "icon": {
                        "color": "{icon_170}"
                    }
                },
                "feedback_success_50": {
                    "icon": {
                        "color": "{icon_173}"
                    }
                },
                "feedback_error_50": {
                    "icon": {
                        "color": "{icon_173}"
                    }
                },
                "feedback_warning_50": {
                    "icon": {
                        "color": "{icon_173}"
                    }
                }
            }
        },
        {
            "medium": {
                "background": {
                    "container": {
                        "size": "{icon_73}"
                    },
                    "icon": {
                        "size": "{icon_74}"
                    },
                    "lottie": {
                        "size": "{icon_74}"
                    }
                },
                "background_bold": {
                    "container": {
                        "size": "{icon_112}"
                    },
                    "icon": {
                        "size": "{icon_113}"
                    },
                    "lottie": {
                        "size": "{icon_113}"
                    }
                }
            },
            "small": {
                "background": {
                    "container": {
                        "size": "{icon_75}",
                        "background-color": "{icon_76}"
                    },
                    "icon": {
                        "size": "{icon_77}"
                    },
                    "lottie": {
                        "size": "{icon_77}"
                    }
                },
                "background_bold": {
                    "container": {
                        "size": "{icon_114}"
                    },
                    "icon": {
                        "size": "{icon_115}"
                    },
                    "lottie": {
                        "size": "{icon_115}"
                    }
                }
            },
            "large": {
                "background": {
                    "container": {
                        "size": "{icon_78}"
                    },
                    "icon": {
                        "size": "{icon_79}"
                    },
                    "lottie": {
                        "size": "{icon_79}"
                    }
                },
                "background_bold": {
                    "container": {
                        "size": "{icon_116}"
                    },
                    "icon": {
                        "size": "{icon_117}"
                    },
                    "lottie": {
                        "size": "{icon_117}"
                    }
                }
            },
            "xtra-large": {
                "background": {
                    "container": {
                        "size": "{icon_80}"
                    },
                    "icon": {
                        "size": "{icon_81}"
                    },
                    "lottie": {
                        "size": "{icon_81}"
                    }
                },
                "background_bold": {
                    "container": {
                        "size": "{icon_118}"
                    },
                    "icon": {
                        "size": "{icon_119}"
                    },
                    "lottie": {
                        "size": "{icon_119}"
                    }
                }
            },
            "xtra-xtra-large": {
                "background": {
                    "container": {
                        "size": "{icon_82}"
                    },
                    "icon": {
                        "size": "{icon_83}"
                    },
                    "lottie": {
                        "size": "{icon_83}"
                    }
                },
                "background_bold": {
                    "container": {
                        "size": "{icon_120}"
                    },
                    "icon": {
                        "size": "{icon_121}"
                    },
                    "lottie": {
                        "size": "{icon_121}"
                    }
                }
            }
        },
        {
            "small": {
                "background_bold": {
                    "primary_50": {
                        "container": {
                            "background-color": "{icon_84}"
                        },
                        "icon": {
                            "color": "{icon_85}"
                        }
                    },
                    "primary_30": {
                        "container": {
                            "background-color": "{icon_86}"
                        },
                        "icon": {
                            "color": "{icon_87}"
                        }
                    },
                    "primary_60": {
                        "container": {
                            "background-color": "{icon_88}"
                        },
                        "icon": {
                            "color": "{icon_89}"
                        }
                    },
                    "primary_70": {
                        "container": {
                            "background-color": "{icon_90}"
                        },
                        "icon": {
                            "color": "{icon_91}"
                        }
                    },
                    "primary_background": {
                        "container": {
                            "background-color": "{icon_92}"
                        },
                        "icon": {
                            "color": "{icon_93}"
                        }
                    },
                    "secondary_50": {
                        "container": {
                            "background-color": "{icon_94}"
                        },
                        "icon": {
                            "color": "{icon_95}"
                        }
                    },
                    "sparkle_50": {
                        "container": {
                            "background-color": "{icon_96}"
                        },
                        "icon": {
                            "color": "{icon_97}"
                        }
                    },
                    "primary_grey_60": {
                        "container": {
                            "background-color": "{icon_98}"
                        },
                        "icon": {
                            "color": "{icon_99}"
                        }
                    },
                    "primary_grey_80": {
                        "container": {
                            "background-color": "{icon_100}"
                        },
                        "icon": {
                            "color": "{icon_101}"
                        }
                    },
                    "primary_grey_100": {
                        "container": {
                            "background-color": "{icon_102}"
                        },
                        "icon": {
                            "color": "{icon_103}"
                        }
                    },
                    "white": {
                        "container": {
                            "background-color": "{icon_104}"
                        },
                        "icon": {
                            "color": "{icon_105}"
                        }
                    },
                    "feedback_success_50": {
                        "container": {
                            "background-color": "{icon_106}"
                        },
                        "icon": {
                            "color": "{icon_107}"
                        }
                    },
                    "feedback_error_50": {
                        "container": {
                            "background-color": "{icon_108}"
                        },
                        "icon": {
                            "color": "{icon_109}"
                        }
                    },
                    "feedback_warning_50": {
                        "container": {
                            "background-color": "{icon_110}"
                        },
                        "icon": {
                            "color": "{icon_111}"
                        }
                    }
                }
            },
            "medium": {
                "background": {
                    "feedback_success": {
                        "container": {
                            "size": "{icon_122}"
                        },
                        "icon": {
                            "size": "{icon_125}"
                        },
                        "lottie": {
                            "size": "{icon_125}"
                        }
                    },
                    "feedback_error": {
                        "container": {
                            "size": "{icon_123}"
                        },
                        "icon": {
                            "size": "{icon_126}"
                        },
                        "lottie": {
                            "size": "{icon_126}"
                        }
                    },
                    "feedback_warning": {
                        "container": {
                            "size": "{icon_124}"
                        },
                        "icon": {
                            "size": "{icon_127}"
                        },
                        "lottie": {
                            "size": "{icon_127}"
                        }
                    }
                },
                "background_bold": {
                    "feedback_success": {
                        "container": {
                            "size": "{icon_128}"
                        },
                        "icon": {
                            "size": "{icon_131}"
                        },
                        "lottie": {
                            "size": "{icon_131}"
                        }
                    },
                    "feedback_error": {
                        "container": {
                            "size": "{icon_129}"
                        },
                        "icon": {
                            "size": "{icon_132}"
                        },
                        "lottie": {
                            "size": "{icon_132}"
                        }
                    },
                    "feedback_warning": {
                        "container": {
                            "size": "{icon_130}"
                        },
                        "icon": {
                            "size": "{icon_133}"
                        },
                        "lottie": {
                            "size": "{icon_133}"
                        }
                    }
                }
            },
            "large": {
                "background": {
                    "feedback_success": {
                        "container": {
                            "size": "{icon_135}"
                        },
                        "icon": {
                            "size": "{icon_137}"
                        },
                        "lottie": {
                            "size": "{icon_137}"
                        }
                    },
                    "feedback_error": {
                        "container": {
                            "size": "{icon_136}"
                        },
                        "icon": {
                            "size": "{icon_138}"
                        },
                        "lottie": {
                            "size": "{icon_138}"
                        }
                    },
                    "feedback_warning": {
                        "container": {
                            "size": "{icon_136}"
                        },
                        "icon": {
                            "size": "{icon_139}"
                        },
                        "lottie": {
                            "size": "{icon_139}"
                        }
                    }
                },
                "background_bold": {
                    "feedback_success": {
                        "container": {
                            "size": "{icon_140}"
                        },
                        "icon": {
                            "size": "{icon_143}"
                        },
                        "lottie": {
                            "size": "{icon_143}"
                        }
                    },
                    "feedback_error": {
                        "container": {
                            "size": "{icon_141}"
                        },
                        "icon": {
                            "size": "{icon_144}"
                        },
                        "lottie": {
                            "size": "{icon_144}"
                        }
                    },
                    "feedback_warning": {
                        "container": {
                            "size": "{icon_142}"
                        },
                        "icon": {
                            "size": "{icon_145}"
                        },
                        "lottie": {
                            "size": "{icon_145}"
                        }
                    }
                }
            },
            "xtra-large": {
                "background": {
                    "feedback_success": {
                        "container": {
                            "size": "{icon_146}"
                        },
                        "icon": {
                            "size": "{icon_149}"
                        },
                        "lottie": {
                            "size": "{icon_149}"
                        }
                    },
                    "feedback_error": {
                        "container": {
                            "size": "{icon_147}"
                        },
                        "icon": {
                            "size": "{icon_150}"
                        },
                        "lottie": {
                            "size": "{icon_150}"
                        }
                    },
                    "feedback_warning": {
                        "container": {
                            "size": "{icon_148}"
                        },
                        "icon": {
                            "size": "{icon_151}"
                        },
                        "lottie": {
                            "size": "{icon_151}"
                        }
                    }
                },
                "background_bold": {
                    "feedback_success": {
                        "container": {
                            "size": "{icon_152}"
                        },
                        "icon": {
                            "size": "{icon_155}"
                        },
                        "lottie": {
                            "size": "{icon_155}"
                        }
                    },
                    "feedback_error": {
                        "container": {
                            "size": "{icon_153}"
                        },
                        "icon": {
                            "size": "{icon_156}"
                        },
                        "lottie": {
                            "size": "{icon_156}"
                        }
                    },
                    "feedback_warning": {
                        "container": {
                            "size": "{icon_154}"
                        },
                        "icon": {
                            "size": "{icon_157}"
                        },
                        "lottie": {
                            "size": "{icon_157}"
                        }
                    }
                }
            },
            "xtra-xtra-large": {
                "background": {
                    "feedback_success": {
                        "container": {
                            "size": "{icon_158}"
                        },
                        "icon": {
                            "size": "{icon_161}"
                        },
                        "lottie": {
                            "size": "{icon_161}"
                        }
                    },
                    "feedback_error": {
                        "container": {
                            "size": "{icon_159}"
                        },
                        "icon": {
                            "size": "{icon_162}"
                        },
                        "lottie": {
                            "size": "{icon_162}"
                        }
                    },
                    "feedback_warning": {
                        "container": {
                            "size": "{icon_160}"
                        },
                        "icon": {
                            "size": "{icon_163}"
                        },
                        "lottie": {
                            "size": "{icon_163}"
                        }
                    }
                },
                "background_bold": {
                    "feedback_success": {
                        "container": {
                            "size": "{icon_164}"
                        },
                        "icon": {
                            "size": "{icon_167}"
                        },
                        "lottie": {
                            "size": "{icon_167}"
                        }
                    },
                    "feedback_error": {
                        "container": {
                            "size": "{icon_165}"
                        },
                        "icon": {
                            "size": "{icon_168}"
                        },
                        "lottie": {
                            "size": "{icon_168}"
                        }
                    },
                    "feedback_warning": {
                        "container": {
                            "size": "{icon_166}"
                        },
                        "icon": {
                            "size": "{icon_169}"
                        },
                        "lottie": {
                            "size": "{icon_169}"
                        }
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "kind",
            "color"
        ],
        [
            "size",
            "kind"
        ],
        [
            "size",
            "kind",
            "color"
        ]
    ],
    "api": {
        "config": {
            "size": {
                "values": [
                    "medium",
                    "small",
                    "large",
                    "xtra-large",
                    "xtra-xtra-large"
                ],
                "doc_description": "It can be used to control size of icon. Please note that the actual size of the icon inside will vary based on the `kind` selected."
            },
            "color": {
                "values": [
                    "primary_50",
                    "primary_30",
                    "primary_60",
                    "primary_70",
                    "primary_background",
                    "secondary_50",
                    "sparkle_50",
                    "primary_grey_60",
                    "primary_grey_80",
                    "primary_grey_100",
                    "feedback_success",
                    "feedback_error",
                    "feedback_warning",
                    "feedback_success_50",
                    "feedback_error_50",
                    "feedback_warning_50",
                    "white",
                    "none"
                ]
            },
            "kind": {
                "values": [
                    "default",
                    "background",
                    "background_bold",
                    "inverse"
                ],
                "doc_description": "It can be used to switch between 3 variants of Icon. 'background-bold' sets color prop as bg, Icon color is inverse of that."
            },
            "_isLottieVisible": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "container": {
                "size": {
                    "type": "size",
                    "name": "customSize",
                    "function": true
                }
            },
            "icon": {
                "value": {
                    "type": "icon",
                    "name": "ic",
                    "function": true,
                    "doc_description": "It can take the icon user want to pass or the name of icon. e.g. `ic={<IcFavorite/>}` or `ic='IcFavorite'`. User can also pass a any custom icon he may have stored locally."
                },
                "semantics": {
                    "type": "string",
                    "name": "semantics",
                    "required": false
                },
                "size": {
                    "type": "size",
                    "name": "_size",
                    "function": true
                }
            },
            "lottie": {
                "value": {
                    "type": "icon",
                    "name": "ic",
                    "function": true,
                    "doc_description": "It can take the icon user want to pass or the name of icon. e.g. `ic={<IcFavorite/>}` or `ic='IcFavorite'`. User can also pass a any custom icon he may have stored locally."
                },
                "attributes": {
                    "type": "object",
                    "name": "lottieAttributes",
                    "platform": "android, ios",
                    "required": false,
                    "object": {
                        "repeatCount": "number",
                        "maxRetryCount": "number",
                        "speed": "float",
                        "isPlaying": "boolean",
                        "reverseOnRepeat": "boolean",
                        "clipSpec": "LottieClipSpec"
                    }
                }
            }
        },
        "events": {
            "container": {
                "onClick": "onClick"
            }
        },
        "a11y": {
            "icon": {
                "properties": {
                    "role": {
                        "value": "img"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "function": true
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$sdl$2b = {
    "metadata": {
        "version": "1.0.0",
        "id": "accordion-1.0.0",
        "name": "JDSAccordion",
        "layerName": "jds_accordion",
        "description": "An accordion is a list of headers that hide or reveal additional content when expanded.",
        "usage": "Accordion is used when users only need a few specific pieces of content within a page."
    },
    "hierarchy": {
        "container": [
            {
                "accordion-header-container": [
                    "prefix-slot",
                    {
                        "text-container": [
                            "title-jds-text",
                            "subtitle-jds-text"
                        ]
                    },
                    "jds_button"
                ]
            },
            {
                "children-container": [
                    {
                        "child-content-container": [
                            "content-slot"
                        ]
                    }
                ]
            },
            "jds_divider"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{a_0}",
            "opacity": "{a_15}",
            "width": "{a_1}"
        },
        "accordion-header-container": {
            "flex-direction": "{a_2}",
            "align-items": "{a_3}",
            "justify-content": "{a_4}",
            "width": "{a_5}",
            "padding-top": "{a_6}",
            "gap": "{a_7}"
        },
        "text-container": {
            "flex-direction": "{a_8}",
            "justify-content": "{a_9}",
            "align-items": "{a_10}",
            "gap": "{a_11}",
            "flex": 1
        },
        "jds_button": {
            "icon": "ic_add",
            "kind": "tertiary",
            "size": "medium",
            "state": "normal"
        },
        "children-container": {
            "hidden": true,
            "padding-top": "{a_12}",
            "width": "{a_13}",
            "enter-animation-name": "slideVerticallyDown",
            "exit-animation-name": "slideVerticallyUp",
            "enter-animation-curve": "entrance_ease",
            "exit-animation-curve": "exit_ease",
            "enter-animation-duration": 500,
            "exit-animation-duration": 500,
            "overflow": "hidden",
            "transition": {
                "property": [
                    "max-height",
                    "padding-top"
                ],
                "duration": "{medium}",
                "timing-function": "{easeExit}"
            }
        },
        "child-content-container": {
            "width": "{a_14}"
        },
        "jds_divider": {
            "orientation": "horizontal",
            "pad": "xtra-xtra-small",
            "padPosition": "top"
        },
        "title-jds-text": {
            "font-family": "{listTitle}",
            "color": "{primaryGrey100}",
            "font-size": "{listTitle}",
            "line-height": "{listTitle}",
            "letter-spacing": "{listTitle}",
            "font-weight": "{listTitle}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        },
        "subtitle-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{a_17}"
                },
                "accordion-header-container": {
                    "disabled": true
                },
                "jds_button": {
                    "disabled": true
                }
            }
        },
        "expandedPanel": {
            "true": {
                "children-container": {
                    "hidden": false,
                    "padding-top": "{a_16}",
                    "transition": {
                        "timing-function": "{easeEntrance}"
                    }
                }
            }
        },
        "showDivider": {
            "false": {
                "jds_divider": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {
            "plus": {
                "true": {
                    "jds_button": {
                        "icon": "{a_18}"
                    }
                },
                "false": {
                    "jds_button": {
                        "icon": "{a_19}"
                    }
                }
            },
            "chevron": {
                "true": {
                    "jds_button": {
                        "icon": "{a_20}"
                    }
                },
                "false": {
                    "jds_button": {
                        "icon": "{a_21}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "iconType",
            "expandedPanel"
        ]
    ],
    "api": {
        "children": {
            "content-slot": {
                "name": "children",
                "accepts": [
                    "any"
                ],
                "max": 1,
                "doc_description": "It can be used to display content as children of Accordion."
            },
            "prefix-slot": {
                "name": "prefix",
                "accepts": [
                    "jds_avatar",
                    "jds_icon"
                ],
                "max": 1,
                "doc_description": "It can be used to display `avatar` or `icon` to the left of text."
            }
        },
        "config": {
            "expandedPanel": {
                "values": [
                    false,
                    true
                ],
                "doc-description": "If false/undefined, only allows one accordionPanel to be expanded by collapsing others on each click."
            },
            "disabled": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to enable or disable Accordion."
            },
            "showDivider": {
                "values": [
                    true,
                    false
                ]
            },
            "iconType": {
                "values": [
                    "chevron",
                    "plus"
                ],
                "doc_description": "The icon to be displayed. The plus icon changes to a minus icon when the corresponding panel is expanded."
            }
        },
        "data": {
            "children-container": {
                "max-height": {
                    "name": "_childrenHeight",
                    "type": "size"
                }
            },
            "title-jds-text": {
                "value": {
                    "name": "title",
                    "type": "string",
                    "doc_description": "This displays the title of Accordion."
                }
            },
            "subtitle-jds-text": {
                "value": {
                    "name": "subtitle",
                    "type": "string",
                    "doc_description": "This displays the subtitle of Accordion."
                }
            }
        },
        "events": {
            "accordion-header-container": {
                "onClick": "onClick"
            },
            "jds_button": {
                "onClick": "onClick"
            }
        },
        "a11y": {
            "accordion-header-container": {
                "properties": {
                    "role": {
                        "value": "button"
                    },
                    "aria-expanded": {
                        "name": "_ariaExpanded",
                        "prop": "expandedPanel"
                    },
                    "aria-controls": {
                        "name": "_ariaControls"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "title"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
function $fe5170bdd3625759$var$getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || "Component";
}
const $fe5170bdd3625759$var$modifyProps = (props, map)=>{
    if (!props) return {};
    if (!map) return props;
    let finalProps = {
        ...props
    };
    const modifedProps = map(props);
    Object.entries(modifedProps).forEach(([key, obj])=>{
        const { properties: properties, variations: variations, defaultValue: defaultValue } = obj;
        const currentValue = props[key];
        if (typeof currentValue !== "undefined") {
            if (Object.keys(properties || {}).length) finalProps = {
                ...finalProps,
                ...properties
            };
            if (variations?.[currentValue]) finalProps = {
                ...finalProps,
                ...variations?.[currentValue]
            };
        } else if (defaultValue) finalProps = {
            ...finalProps,
            ...variations?.[defaultValue]
        };
    });
    return finalProps;
};
const $fe5170bdd3625759$var$withModifiedProps = (Component, map)=>(props)=>{
        if (!map) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
        Component.displayName = $fe5170bdd3625759$var$getDisplayName(Component);
        const finalProps = $fe5170bdd3625759$var$modifyProps(props, map);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props,
            ...finalProps
        });
    };
const $fe5170bdd3625759$var$get = (obj, path, defValue)=>{
    if (!path) return void 0;
    const pathArray = Array.isArray(path) ? path : path.match(/([^[.\]])+/g);
    const result = pathArray?.reduce((prevObj, key)=>prevObj && prevObj[key], obj);
    return result === void 0 ? defValue : result;
};
const $fe5170bdd3625759$var$debounce = (fn, wait, immediate = false)=>{
    let timeoutId;
    return function(...args) {
        const later = ()=>{
            timeoutId = null;
            if (!immediate) fn.apply(this, args);
        };
        const callNow = immediate && !timeoutId;
        timeoutId !== null && clearTimeout(timeoutId);
        timeoutId = setTimeout(later, wait);
        if (callNow) fn.apply(this, args);
    };
};
const $fe5170bdd3625759$var$convertTextToComponent = (children)=>{
    if (typeof children === "string" && children.length) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$5f1af8db9871e1d6, {
        text: children
    });
    return children || null;
};
const $fe5170bdd3625759$var$resolvePropObjectKeys = (prop, objPath, defValue)=>{
    if (!prop) return void 0;
    if (typeof prop === "string") return prop;
    return $fe5170bdd3625759$var$get(prop, objPath, defValue);
};
const $fe5170bdd3625759$var$useRootRef = (cb, deps = [])=>{
    const [element, setElement] = (0, $acw62.useState)(null);
    const rootRef = (0, $acw62.useCallback)((element2)=>{
        setElement(element2);
        cb?.(element2);
    }, [
        ...deps
    ]);
    return {
        element: element,
        rootRef: rootRef
    };
};
const $fe5170bdd3625759$var$PROP_MAP$v = (props)=>{
    return {
        header: {
            properties: {
                title: props.title || props.header?.title || props.header?.titleBlock?.text || props.header,
                subtitle: props.subtitle || props.header?.titleBlock?.helper,
                prefix: props.prefix || props.header?.prefix
            }
        },
        children: {
            properties: {
                children: $fe5170bdd3625759$var$convertTextToComponent(props.children)
            }
        }
    };
};
const $fe5170bdd3625759$var$withLogic$2f = (Component)=>(userProps)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$v);
        const { element: element, rootRef: rootRef } = $fe5170bdd3625759$var$useRootRef();
        const childContainer = element?.querySelector('div[data-testid="JDSAccordion-child-content-container"]');
        const [childrenHeight, setChildrenHeight] = (0, $acw62.useState)(0);
        (0, $acw62.useEffect)(()=>{
            if (!childContainer || !props.expandedPanel) return;
            const updateHeight = ()=>{
                requestAnimationFrame(()=>{
                    setChildrenHeight(childContainer.offsetHeight + 16);
                });
            };
            updateHeight();
            const resizeObserver = new ResizeObserver(updateHeight);
            resizeObserver.observe(childContainer);
            return ()=>{
                resizeObserver.disconnect();
            };
        }, [
            childContainer,
            props.expandedPanel,
            props.children
        ]);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                rootRef: rootRef,
                _ariaControls: "children-container",
                _childrenHeight: props.expandedPanel ? childrenHeight : 0
            }
        });
    };
const $fe5170bdd3625759$var$Component$2g = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$2b;
    const { expandedPanel: expandedPanel = false, disabled: disabled = false, showDivider: showDivider = true, iconType: iconType = "chevron", onClick: onClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), ariaLabel: ariaLabel = props.title?.toString(), _ariaExpanded: _ariaExpanded = props.expandedPanel?.toString(), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            expandedPanel: expandedPanel,
            disabled: disabled,
            showDivider: showDivider,
            iconType: iconType,
            onClick: onClick,
            ariaLabel: ariaLabel,
            _ariaExpanded: _ariaExpanded,
            ...rest
        },
        componentTag: componentTag
    }, "JDSAccordion", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$7cad6f17fd6e117b = $fe5170bdd3625759$var$withLogic$2f($fe5170bdd3625759$var$Component$2g);
$fe5170bdd3625759$export$7cad6f17fd6e117b.displayName = "AccordionPanel";
$fe5170bdd3625759$export$7cad6f17fd6e117b.slotName = "jds_accordion";
const $fe5170bdd3625759$var$sdl$2a = {
    "metadata": {
        "version": "1.0.0",
        "id": "action-button-1.0.0",
        "name": "JDSActionButton",
        "layerName": "jds_action_button"
    },
    "hierarchy": {
        "container": [
            {
                "inner-container": [
                    "left-icon",
                    "jds-text",
                    "right-icon"
                ]
            },
            "loader"
        ]
    },
    "base": {
        "container": {
            "background-color": "{a_0}",
            "opacity": "{a_1}",
            "flex-direction": "{a_2}",
            "align-items": "{a_3}",
            "justify-content": "{a_4}",
            "border-radius": "{a_5}"
        },
        "inner-container": {
            "opacity": "{a_64}",
            "border-width": "{a_24}",
            "background-color": "{a_6}",
            "flex-direction": "{a_7}",
            "align-items": "{a_8}",
            "justify-content": "{a_9}",
            "border-radius": "{a_10}",
            "padding-top": "{a_11}",
            "padding-right": "{a_12}",
            "padding-bottom": "{a_13}",
            "padding-left": "{a_14}",
            "gap": "{a_15}",
            "transition": {
                "property": [
                    "background-color",
                    "border-width",
                    "border-color"
                ],
                "duration": "{rapid}",
                "timing-function": "{easeQuick}"
            },
            "behavior": {
                "hover": {
                    "background-color": "{a_16}"
                },
                "active": {
                    "background-color": "{a_17}"
                },
                "focus": {
                    "border-width": "{a_18}",
                    "border-color": "{a_19}"
                }
            }
        },
        "loader": {
            "hidden": true,
            "color": "{a_20}",
            "background-color": "{a_21}",
            "track-color": "{a_22}",
            "border-width": "{a_23}",
            "opacity": "{a_25}",
            "size": "{a_26}",
            "z-index": 1
        },
        "left-icon": {
            "size": "{a_27}",
            "color": "{a_28}",
            "hidden": false,
            "transition": {
                "property": [
                    "color"
                ],
                "duration": "{rapid}",
                "timing-function": "{easeQuick}"
            },
            "behavior": {
                "hover": {
                    "color": "{a_29}"
                },
                "active": {
                    "color": "{a_30}"
                }
            }
        },
        "right-icon": {
            "size": "{a_31}",
            "color": "{a_32}",
            "hidden": true,
            "transition": {
                "property": [
                    "color"
                ],
                "duration": "{rapid}",
                "timing-function": "{easeQuick}"
            },
            "behavior": {
                "hover": {
                    "color": "{a_33}"
                },
                "active": {
                    "color": "{a_34}"
                }
            }
        },
        "jds-text": {
            "font-family": "{bodySBold}",
            "color": "{primaryInverse}",
            "font-size": "{bodySBold}",
            "line-height": "{bodySBold}",
            "letter-spacing": "{bodySBold}",
            "font-weight": "{bodySBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 2,
            "maxLines": 2,
            "hidden": false,
            "transition": {
                "property": [
                    "color"
                ],
                "duration": "{rapid}",
                "timing-function": "{easeQuick}"
            },
            "behavior": {
                "hover": {
                    "color": "{primary70}",
                    "transition": {
                        "property": [
                            "color"
                        ],
                        "duration": "{rapid}",
                        "timing-function": "{easeQuick}"
                    }
                },
                "active": {
                    "transition": {
                        "property": [
                            "color"
                        ],
                        "duration": "{rapid}",
                        "timing-function": "{easeQuick}"
                    }
                }
            }
        }
    },
    "variant": {
        "size": {
            "small": {
                "inner-container": {
                    "padding-top": "{a_35}",
                    "padding-right": "{a_36}",
                    "padding-bottom": "{a_37}",
                    "padding-left": "{a_38}",
                    "gap": "{a_39}"
                },
                "left-icon": {
                    "size": "{a_40}"
                },
                "right-icon": {
                    "size": "{a_41}"
                },
                "loader": {
                    "size": "{a_42}"
                }
            },
            "large": {
                "inner-container": {
                    "padding-top": "{a_43}",
                    "padding-left": "{a_44}",
                    "padding-bottom": "{a_45}",
                    "padding-right": "{a_46}",
                    "gap": "{a_47}"
                },
                "left-icon": {
                    "size": "{a_48}"
                },
                "right-icon": {
                    "size": "{a_49}"
                },
                "loader": {
                    "size": "{a_50}"
                },
                "jds-text": {
                    "font-family": "{bodyMBold}",
                    "font-size": "{bodyMBold}",
                    "line-height": "{bodyMBold}",
                    "letter-spacing": "{bodyMBold}",
                    "font-weight": "{bodyMBold}"
                }
            },
            "extra-large": {
                "inner-container": {
                    "padding-top": "{a_51}",
                    "padding-right": "{a_52}",
                    "padding-bottom": "{a_53}",
                    "padding-left": "{a_54}",
                    "gap": "{a_55}"
                },
                "left-icon": {
                    "size": "{a_56}"
                },
                "right-icon": {
                    "size": "{a_57}"
                },
                "loader": {
                    "size": "{a_58}"
                },
                "jds-text": {
                    "font-family": "{bodyLBold}",
                    "font-size": "{bodyLBold}",
                    "line-height": "{bodyLBold}",
                    "letter-spacing": "{bodyLBold}",
                    "font-weight": "{bodyLBold}"
                }
            }
        },
        "iconPosition": {
            "right": {
                "left-icon": {
                    "hidden": true
                },
                "right-icon": {
                    "hidden": false
                }
            }
        },
        "state": {
            "loading": {
                "inner-container": {
                    "disabled": true,
                    "opacity": "{a_59}"
                },
                "left-icon": {
                    "opacity": "{a_60}"
                },
                "right-icon": {
                    "opacity": "{a_61}"
                },
                "loader": {
                    "hidden": false
                },
                "jds-text": {
                    "opacity": "{a_62}"
                }
            },
            "disabled": {
                "inner-container": {
                    "opacity": "{a_63}",
                    "disabled": true
                }
            }
        },
        "_hasIcon": {
            "false": {
                "left-icon": {
                    "hidden": true
                },
                "right-icon": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {
            "normal": {
                "secondary": {
                    "inner-container": {
                        "background-color": "{a_65}",
                        "border-width": "{a_66}",
                        "border-color": "{a_67}",
                        "behavior": {
                            "hover": {
                                "background-color": "{a_68}"
                            },
                            "active": {
                                "background-color": "{a_69}"
                            },
                            "focus": {
                                "border-width": "{a_70}",
                                "border-color": "{a_71}"
                            }
                        }
                    },
                    "left-icon": {
                        "color": "{a_72}",
                        "behavior": {
                            "hover": {
                                "color": "{a_73}"
                            },
                            "active": {
                                "color": "{a_74}"
                            }
                        }
                    },
                    "right-icon": {
                        "color": "{a_75}",
                        "behavior": {
                            "hover": {
                                "color": "{a_76}"
                            },
                            "active": {
                                "color": "{a_77}"
                            }
                        }
                    },
                    "jds-text": {
                        "color": "{primary60}",
                        "behavior": {
                            "hover": {},
                            "active": {
                                "color": "{primary70}"
                            }
                        }
                    }
                },
                "tertiary": {
                    "inner-container": {
                        "padding-left": "{a_78}",
                        "padding-right": "{a_79}",
                        "background-color": "{a_82}",
                        "behavior": {
                            "hover": {
                                "background-color": "{a_83}"
                            },
                            "active": {
                                "background-color": "{a_84}"
                            },
                            "focus": {
                                "border-width": "{a_85}",
                                "border-radius": "{a_86}",
                                "border-color": "{a_87}"
                            }
                        }
                    },
                    "left-icon": {
                        "color": "{a_88}",
                        "behavior": {
                            "hover": {
                                "color": "{a_89}"
                            },
                            "active": {
                                "color": "{a_90}"
                            }
                        }
                    },
                    "right-icon": {
                        "color": "{a_91}",
                        "behavior": {
                            "hover": {
                                "color": "{a_92}"
                            },
                            "active": {
                                "color": "{a_93}"
                            }
                        }
                    },
                    "jds-text": {
                        "color": "{primary60}",
                        "behavior": {
                            "hover": {
                                "color": "{primary50}"
                            },
                            "active": {
                                "color": "{primary70}"
                            }
                        }
                    }
                }
            },
            "positive": {
                "primary": {
                    "inner-container": {
                        "background-color": "{a_94}",
                        "behavior": {
                            "hover": {
                                "background-color": "{a_95}"
                            },
                            "active": {
                                "background-color": "{a_96}"
                            },
                            "focus": {
                                "border-color": "{a_97}"
                            }
                        }
                    },
                    "left-icon": {
                        "color": "{a_98}",
                        "behavior": {
                            "hover": {
                                "color": "{a_99}"
                            },
                            "active": {
                                "color": "{a_100}"
                            }
                        }
                    },
                    "right-icon": {
                        "color": "{a_101}",
                        "behavior": {
                            "hover": {
                                "color": "{a_102}"
                            },
                            "active": {
                                "color": "{a_103}"
                            }
                        }
                    },
                    "jds-text": {
                        "color": "{global.white}",
                        "behavior": {
                            "hover": {
                                "color": "{feedbackSuccess80}"
                            },
                            "active": {
                                "color": "{primaryBackground}"
                            }
                        }
                    }
                },
                "secondary": {
                    "inner-container": {
                        "background-color": "{a_104}",
                        "border-width": "{a_105}",
                        "border-color": "{a_106}",
                        "behavior": {
                            "hover": {
                                "background-color": "{a_107}"
                            },
                            "active": {
                                "background-color": "{a_108}"
                            },
                            "focus": {
                                "border-color": "{a_109}"
                            }
                        }
                    },
                    "left-icon": {
                        "color": "{a_110}",
                        "behavior": {
                            "hover": {
                                "color": "{a_111}"
                            },
                            "active": {
                                "color": "{a_112}"
                            }
                        }
                    },
                    "right-icon": {
                        "color": "{a_113}",
                        "behavior": {
                            "hover": {
                                "color": "{a_114}"
                            },
                            "active": {
                                "color": "{a_115}"
                            }
                        }
                    },
                    "jds-text": {
                        "color": "{feedbackSuccess80}",
                        "behavior": {
                            "hover": {},
                            "active": {
                                "color": "{primaryBackground}"
                            }
                        }
                    }
                },
                "tertiary": {
                    "inner-container": {
                        "padding-left": "{a_80}",
                        "padding-right": "{a_81}",
                        "background-color": "{a_116}",
                        "border-radius": "{a_117}",
                        "behavior": {
                            "hover": {
                                "background-color": "{a_118}"
                            },
                            "active": {
                                "background-color": "{a_119}"
                            },
                            "focus": {
                                "border-color": "{a_120}"
                            }
                        }
                    },
                    "left-icon": {
                        "color": "{a_121}",
                        "behavior": {
                            "hover": {
                                "color": "{a_122}"
                            },
                            "active": {
                                "color": "{a_123}"
                            }
                        }
                    },
                    "right-icon": {
                        "color": "{a_124}",
                        "behavior": {
                            "hover": {
                                "color": "{a_125}"
                            },
                            "active": {
                                "color": "{a_126}"
                            }
                        }
                    },
                    "jds-text": {
                        "color": "{feedbackSuccess80}",
                        "behavior": {
                            "hover": {
                                "color": "{feedbackSuccess50}"
                            },
                            "active": {
                                "color": "{primaryGrey100}"
                            }
                        }
                    }
                }
            },
            "negative": {
                "primary": {
                    "inner-container": {
                        "background-color": "{a_129}",
                        "behavior": {
                            "hover": {
                                "background-color": "{a_130}"
                            },
                            "active": {
                                "background-color": "{a_131}"
                            },
                            "focus": {
                                "border-color": "{a_132}"
                            }
                        }
                    },
                    "left-icon": {
                        "color": "{a_133}",
                        "behavior": {
                            "hover": {
                                "color": "{a_134}"
                            },
                            "active": {
                                "color": "{a_135}"
                            }
                        }
                    },
                    "right-icon": {
                        "color": "{a_136}",
                        "behavior": {
                            "hover": {
                                "color": "{a_137}"
                            },
                            "active": {
                                "color": "{a_138}"
                            }
                        }
                    },
                    "jds-text": {
                        "color": "{global.white}",
                        "behavior": {
                            "hover": {
                                "color": "{feedbackError80}"
                            },
                            "active": {
                                "color": "{primaryBackground}"
                            }
                        }
                    }
                },
                "secondary": {
                    "inner-container": {
                        "background-color": "{a_139}",
                        "border-width": "{a_140}",
                        "border-color": "{a_141}",
                        "behavior": {
                            "hover": {
                                "background-color": "{a_142}"
                            },
                            "active": {
                                "background-color": "{a_143}"
                            },
                            "focus": {
                                "border-color": "{a_144}"
                            }
                        }
                    },
                    "left-icon": {
                        "color": "{a_145}",
                        "behavior": {
                            "hover": {
                                "color": "{a_146}"
                            },
                            "active": {
                                "color": "{a_147}"
                            }
                        }
                    },
                    "right-icon": {
                        "color": "{a_148}",
                        "behavior": {
                            "hover": {
                                "color": "{a_149}"
                            },
                            "active": {
                                "color": "{a_150}"
                            }
                        }
                    },
                    "jds-text": {
                        "color": "{feedbackError80}",
                        "behavior": {
                            "hover": {},
                            "active": {
                                "color": "{primaryBackground}"
                            }
                        }
                    }
                },
                "tertiary": {
                    "inner-container": {
                        "padding-left": "{a_127}",
                        "padding-right": "{a_128}",
                        "background-color": "{a_151}",
                        "border-radius": "{a_152}",
                        "behavior": {
                            "hover": {
                                "background-color": "{a_153}"
                            },
                            "active": {
                                "background-color": "{a_154}"
                            },
                            "focus": {
                                "border-color": "{a_155}"
                            }
                        }
                    },
                    "left-icon": {
                        "color": "{a_156}",
                        "behavior": {
                            "hover": {
                                "color": "{a_157}"
                            },
                            "active": {
                                "color": "{a_158}"
                            }
                        }
                    },
                    "right-icon": {
                        "color": "{a_159}",
                        "behavior": {
                            "hover": {
                                "color": "{a_160}"
                            },
                            "active": {
                                "color": "{a_161}"
                            }
                        }
                    },
                    "jds-text": {
                        "color": "{feedbackError80}",
                        "behavior": {
                            "hover": {
                                "color": "{feedbackError50}"
                            },
                            "active": {
                                "color": "{primaryGrey100}"
                            }
                        }
                    }
                }
            },
            "contrast": {
                "primary": {
                    "inner-container": {
                        "background-color": "{a_164}",
                        "behavior": {
                            "hover": {
                                "background-color": "{a_165}"
                            },
                            "active": {
                                "background-color": "{a_166}"
                            },
                            "focus": {
                                "border-color": "{a_167}"
                            }
                        }
                    },
                    "left-icon": {
                        "color": "{a_168}",
                        "behavior": {
                            "hover": {
                                "color": "{a_169}"
                            },
                            "active": {
                                "color": "{a_170}"
                            }
                        }
                    },
                    "right-icon": {
                        "color": "{a_171}",
                        "behavior": {
                            "hover": {
                                "color": "{a_172}"
                            },
                            "active": {
                                "color": "{a_173}"
                            }
                        }
                    },
                    "jds-text": {
                        "color": "{primaryGrey100}",
                        "behavior": {
                            "hover": {},
                            "active": {}
                        }
                    }
                },
                "secondary": {
                    "inner-container": {
                        "background-color": "{a_174}",
                        "border-width": "{a_175}",
                        "border-color": "{a_176}",
                        "behavior": {
                            "hover": {
                                "background-color": "{a_177}"
                            },
                            "active": {
                                "background-color": "{a_178}"
                            },
                            "focus": {
                                "border-width": "{a_179}",
                                "border-color": "{a_180}"
                            }
                        }
                    },
                    "left-icon": {
                        "color": "{a_181}",
                        "behavior": {
                            "hover": {
                                "color": "{a_182}"
                            },
                            "active": {
                                "color": "{a_183}"
                            }
                        }
                    },
                    "right-icon": {
                        "color": "{a_184}",
                        "behavior": {
                            "hover": {
                                "color": "{a_185}"
                            },
                            "active": {
                                "color": "{a_186}"
                            }
                        }
                    },
                    "jds-text": {
                        "color": "{primaryBackground}",
                        "behavior": {
                            "hover": {
                                "color": "{primaryGrey100}"
                            },
                            "active": {
                                "color": "{primaryGrey100}"
                            }
                        }
                    }
                },
                "tertiary": {
                    "inner-container": {
                        "padding-left": "{a_162}",
                        "padding-right": "{a_163}",
                        "background-color": "{a_187}",
                        "border-radius": "{a_188}",
                        "behavior": {
                            "hover": {
                                "background-color": "{a_189}"
                            },
                            "active": {
                                "background-color": "{a_190}"
                            },
                            "focus": {
                                "border-width": "{a_191}",
                                "border-color": "{a_192}"
                            }
                        }
                    },
                    "left-icon": {
                        "color": "{a_193}",
                        "behavior": {
                            "hover": {
                                "color": "{a_194}"
                            },
                            "active": {
                                "color": "{a_195}"
                            }
                        }
                    },
                    "right-icon": {
                        "color": "{a_196}",
                        "behavior": {
                            "hover": {
                                "color": "{a_197}"
                            },
                            "active": {
                                "color": "{a_198}"
                            }
                        }
                    },
                    "jds-text": {
                        "color": "{primaryBackground}",
                        "behavior": {
                            "hover": {
                                "color": "{primaryGrey100}"
                            },
                            "active": {
                                "color": "{primaryGrey100}"
                            }
                        }
                    }
                }
            }
        },
        {
            "false": {
                "small": {
                    "inner-container": {
                        "padding-top": 0,
                        "padding-right": 0,
                        "padding-bottom": 0,
                        "padding-left": 0,
                        "width": 32,
                        "height": 32
                    },
                    "left-icon": {
                        "size": "{a_199}"
                    },
                    "loader": {
                        "size": "{a_200}"
                    },
                    "jds-text": {
                        "hidden": true
                    }
                },
                "medium": {
                    "inner-container": {
                        "padding-top": 0,
                        "padding-right": 0,
                        "padding-bottom": 0,
                        "padding-left": 0,
                        "width": 40,
                        "height": 40
                    },
                    "jds-text": {
                        "hidden": true
                    }
                },
                "large": {
                    "inner-container": {
                        "padding-top": 0,
                        "padding-right": 0,
                        "padding-bottom": 0,
                        "padding-left": 0,
                        "width": 48,
                        "height": 48
                    },
                    "left-icon": {
                        "size": "{a_201}"
                    },
                    "loader": {
                        "size": "{a_202}"
                    },
                    "jds-text": {
                        "hidden": true
                    }
                },
                "extra-large": {
                    "inner-container": {
                        "padding-top": 0,
                        "padding-right": 0,
                        "padding-bottom": 0,
                        "padding-left": 0,
                        "width": 64,
                        "height": 64
                    },
                    "left-icon": {
                        "size": "{a_203}"
                    },
                    "loader": {
                        "size": "{a_204}"
                    },
                    "jds-text": {
                        "hidden": true
                    }
                }
            }
        },
        {
            "true": {
                "true": {
                    "container": {
                        "width": "{a_205}"
                    },
                    "inner-container": {
                        "width": "{a_206}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "appearance",
            "kind"
        ],
        [
            "_hasLabel",
            "size"
        ],
        [
            "_hasLabel",
            "stretch"
        ]
    ],
    "api": {
        "config": {
            "kind": {
                "values": [
                    "primary",
                    "secondary",
                    "tertiary"
                ],
                "doc_description": "It can be used to switch between 3 variants of ActionButton which is by default 'primary'."
            },
            "size": {
                "values": [
                    "medium",
                    "small",
                    "large",
                    "extra-large"
                ],
                "doc_description": "it can be used to control the size of ActionButton."
            },
            "appearance": {
                "values": [
                    "normal",
                    "positive",
                    "negative",
                    "contrast"
                ],
                "doc_description": "It can be used to set the appearance of ActionButton."
            },
            "state": {
                "values": [
                    "normal",
                    "disabled",
                    "loading"
                ],
                "doc_description": "It can be used to change the state of ActionButton."
            },
            "iconPosition": {
                "values": [
                    "left",
                    "right"
                ],
                "doc_description": "It can be used to psoition icon."
            },
            "stretch": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "This can be used to fill the container with ActionButton."
            },
            "_hasLabel": {
                "values": [
                    true,
                    false
                ]
            },
            "_hasIcon": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "container": {
                "type": {
                    "name": "type",
                    "type": "string",
                    "platform": "web"
                }
            },
            "left-icon": {
                "value": {
                    "type": "icon",
                    "name": "icon",
                    "doc_description": "It displays icon of ActionButton."
                }
            },
            "right-icon": {
                "value": {
                    "type": "icon",
                    "name": "icon",
                    "doc_description": "It displays icon of ActionButton."
                }
            },
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "label",
                    "doc_description": "It displays label of ActionButton."
                }
            }
        },
        "events": {
            "inner-container": {
                "onClick": "onClick",
                "onFocus": {
                    "name": "onFocus",
                    "platform": "web"
                }
            }
        },
        "a11y": {
            "inner-container": {
                "properties": {
                    "role": {
                        "value": "button"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "aria-hidden": "ariaHidden"
                }
            },
            "left-icon": {
                "properties": {
                    "role": {
                        "value": "img"
                    },
                    "aria-label": {
                        "name": "iconAriaLabel",
                        "function": true
                    }
                }
            },
            "right-icon": {
                "properties": {
                    "role": {
                        "value": "img"
                    },
                    "aria-label": {
                        "name": "iconAriaLabel",
                        "function": true
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$legacyKinds = [
    "icon-only",
    "background-bold"
];
const $fe5170bdd3625759$var$legacySizes$4 = [
    "m",
    "s",
    "l",
    "xl",
    "xxl"
];
const $fe5170bdd3625759$var$PROP_MAP$u = (props)=>{
    if ($fe5170bdd3625759$var$legacyKinds.includes(props.kind)) console.warn("these values for the kind prop are deprecated", $fe5170bdd3625759$var$legacyKinds);
    if ($fe5170bdd3625759$var$legacySizes$4.includes(props.size)) console.warn("these values for the size prop are deprecated", $fe5170bdd3625759$var$legacySizes$4);
    return {
        ic: {
            properties: {
                ic: props.ic
            }
        },
        size: {
            defaultValue: "medium",
            variations: {
                m: {
                    size: "medium"
                },
                l: {
                    size: "large"
                },
                xl: {
                    size: "xtra-large"
                },
                xxl: {
                    size: "xtra-xtra-large"
                },
                s: {
                    size: "small"
                }
            }
        },
        color: {
            variations: {
                primary: {
                    color: "primary_50"
                },
                secondary: {
                    color: "secondary_50"
                },
                sparkle: {
                    color: "sparkle_50"
                },
                "grey-100": {
                    color: "primary_grey_100"
                },
                "grey-80": {
                    color: "primary_grey_80"
                },
                "grey-60": {
                    color: "primary_grey_60"
                },
                success: {
                    color: "feedback_success"
                },
                error: {
                    color: "feedback_error"
                },
                warning: {
                    color: "feedback_warning"
                }
            }
        },
        kind: {
            defaultValue: "icon-only",
            variations: {
                "icon-only": {
                    kind: "default"
                },
                background: {
                    kind: "background"
                },
                "background-bold": {
                    kind: "background_bold"
                }
            }
        }
    };
};
const $fe5170bdd3625759$var$feedbackIcons = {
    feedback_success: "IcSuccessColored",
    feedback_error: "IcErrorColored",
    feedback_warning: "IcWarningColored"
};
const $fe5170bdd3625759$var$formatIconName = (iconName)=>{
    if (typeof iconName === "string" && iconName.startsWith("Ic")) {
        const words = iconName.slice(2).match(/[A-Z][a-z]+/g);
        return words ? words.join(" ").toLowerCase() + " icon" : iconName;
    } else if (typeof iconName === "string" && iconName.startsWith("ic_")) {
        const words = iconName.slice(3).split("_");
        return words ? words.join(" ").toLowerCase() + " icon" : iconName;
    }
    return iconName;
};
const $fe5170bdd3625759$var$withLogic$2e = (Component)=>(0, $acw62.forwardRef)((userProps, ref)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$u);
        let iconComponent = props.ic;
        if (typeof props.ic === "string") {
            if (props.color && Object.keys($fe5170bdd3625759$var$feedbackIcons).includes(props.color)) iconComponent = $fe5170bdd3625759$var$feedbackIcons[props.color] || props.ic;
        }
        let getCustomSize = props.customSize || void 0;
        if (getCustomSize) {
            const sizeInPx = /^(\d+)(px)?$/.exec(getCustomSize);
            if (sizeInPx) getCustomSize = sizeInPx[1];
            else {
                console.warn("customSize should only be provided in pixels (px) or as a number.");
                getCustomSize = void 0;
            }
            if (Number.parseInt(getCustomSize) > 1080) getCustomSize = "1080";
            else if (Number.parseInt(getCustomSize) < 8) getCustomSize = "8";
        }
        const iconSize = props.kind === "default" ? getCustomSize : getCustomSize !== void 0 ? 2 / 3 * Number.parseInt(getCustomSize) : getCustomSize;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                rootRef: ref,
                ariaLabel: props.ariaLabel || $fe5170bdd3625759$var$formatIconName(props.ic),
                _size: iconSize,
                customSize: getCustomSize
            },
            ic: iconComponent
        });
    });
const $fe5170bdd3625759$var$withLogic$2d = (Component)=>(0, $acw62.forwardRef)((props, ref)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                _hasLabel: Boolean(props.label?.length),
                rootRef: ref,
                iconAriaLabel: props.iconAriaLabel || $fe5170bdd3625759$var$formatIconName(props.icon)
            }
        });
    });
const $fe5170bdd3625759$var$Component$2f = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$2a;
    const { kind: kind = "primary", size: size = "medium", appearance: appearance = "normal", state: state = "normal", iconPosition: iconPosition = "left", stretch: stretch = false, onClick: onClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onFocus: onFocus = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), ariaLabel: ariaLabel = props.label?.toString(), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            size: size,
            appearance: appearance,
            state: state,
            iconPosition: iconPosition,
            stretch: stretch,
            onClick: onClick,
            onFocus: onFocus,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSActionButton", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$cfc7921d29ef7b80 = $fe5170bdd3625759$var$withLogic$2d($fe5170bdd3625759$var$Component$2f);
$fe5170bdd3625759$export$cfc7921d29ef7b80.displayName = "ActionButton";
$fe5170bdd3625759$export$cfc7921d29ef7b80.slotName = "jds_action_button";
const $fe5170bdd3625759$var$sdl$29 = {
    "metadata": {
        "version": "1.0.0",
        "id": "avatar-1.0.0",
        "name": "JDSAvatar",
        "layerName": "jds_avatar",
        "description": "Avatars are used to show a thumbnail representation of an individual or business in the interface.",
        "usage": "Avatars can either be custom images uploaded by users, or default themed images, or automatically populated user initials."
    },
    "hierarchy": {
        "container": [
            "jds_image",
            "jds-text",
            {
                "jds-icon-container": [
                    "jds-icon"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "hidden": false,
            "opacity": "{a_17}",
            "width": "{a_0}",
            "height": "{a_1}",
            "display": "flex",
            "flex-direction": "{a_2}",
            "justify-content": "{a_3}",
            "align-items": "{a_4}",
            "background-color": "{a_5}",
            "border-radius": "{a_6}",
            "border-width": "{a_7}",
            "border-color": "{a_8}"
        },
        "jds_image": {
            "hidden": true,
            "aspectRatio": "round"
        },
        "jds-text": {
            "font-family": "{bodyS}",
            "color": "{sparkle60}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": true
        },
        "jds-icon": {
            "size": "{l}",
            "color": "{primary50}",
            "value": "ic_profile",
            "hidden": false,
            "ic": "ic_profile"
        },
        "jds-icon-container": {
            "background-color": "{global.transparent}",
            "border-radius": "{pill}",
            "size": "{l}",
            "justify-content": "{justifyContent.center}",
            "align-items": "{alignItems.center}",
            "hidden": false,
            "ic": "ic_profile"
        }
    },
    "variant": {
        "size": {
            "xtra-small": {
                "container": {
                    "width": "{a_9}",
                    "height": "{a_10}"
                },
                "jds-text": {
                    "font-family": "{bodyXxs}",
                    "font-size": "{bodyXxs}",
                    "line-height": "{bodyXxs}",
                    "letter-spacing": "{bodyXxs}",
                    "font-weight": "{bodyXxs}"
                },
                "jds-icon": {
                    "size": "{base}"
                },
                "jds-icon-container": {
                    "background-color": "{global.transparent}",
                    "border-radius": "{pill}",
                    "size": "{base}",
                    "justify-content": "{justifyContent.center}",
                    "align-items": "{alignItems.center}"
                }
            },
            "small": {
                "container": {
                    "width": "{a_11}",
                    "height": "{a_12}"
                },
                "jds-text": {
                    "font-family": "{bodyXxs}",
                    "font-size": "{bodyXxs}",
                    "line-height": "{bodyXxs}",
                    "letter-spacing": "{bodyXxs}",
                    "font-weight": "{bodyXxs}"
                },
                "jds-icon": {
                    "size": "{m}"
                },
                "jds-icon-container": {
                    "background-color": "{global.transparent}",
                    "border-radius": "{pill}",
                    "size": "{m}",
                    "justify-content": "{justifyContent.center}",
                    "align-items": "{alignItems.center}"
                }
            },
            "large": {
                "container": {
                    "width": "{a_13}",
                    "height": "{a_14}"
                },
                "jds-text": {
                    "font-family": "{bodyM}",
                    "font-size": "{bodyM}",
                    "line-height": "{bodyM}",
                    "letter-spacing": "{bodyM}",
                    "font-weight": "{bodyM}"
                },
                "jds-icon": {
                    "size": "{xl}"
                },
                "jds-icon-container": {
                    "background-color": "{global.transparent}",
                    "border-radius": "{pill}",
                    "size": "{xl}",
                    "justify-content": "{justifyContent.center}",
                    "align-items": "{alignItems.center}"
                }
            },
            "xtra-large": {
                "container": {
                    "width": 56,
                    "height": 56
                },
                "jds-text": {
                    "font-family": "{bodyM}",
                    "font-size": "{bodyM}",
                    "line-height": "{bodyM}",
                    "letter-spacing": "{bodyM}",
                    "font-weight": "{bodyM}"
                },
                "jds-icon": {
                    "size": "{xxl}"
                },
                "jds-icon-container": {
                    "background-color": "{global.transparent}",
                    "border-radius": "{pill}",
                    "size": "{xxl}",
                    "justify-content": "{justifyContent.center}",
                    "align-items": "{alignItems.center}"
                }
            },
            "xtra-xtra-large": {
                "container": {
                    "width": "{a_15}",
                    "height": "{a_16}"
                },
                "jds-text": {
                    "font-family": "{bodyL}",
                    "font-size": "{bodyL}",
                    "line-height": "{bodyL}",
                    "letter-spacing": "{bodyL}",
                    "font-weight": "{bodyL}"
                },
                "jds-icon": {
                    "size": "{xxl}"
                },
                "jds-icon-container": {
                    "background-color": "{global.transparent}",
                    "border-radius": "{pill}",
                    "size": "{xxl}",
                    "justify-content": "{justifyContent.center}",
                    "align-items": "{alignItems.center}"
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{a_18}"
                }
            }
        },
        "isClickable": {
            "false": {
                "container": {
                    "disabled": true
                }
            }
        },
        "kind": {
            "image": {
                "jds_image": {
                    "hidden": false
                },
                "jds-icon": {
                    "hidden": true
                },
                "jds-icon-container": {
                    "background-color": "{global.transparent}",
                    "border-radius": "{pill}",
                    "size": "{l}",
                    "justify-content": "{justifyContent.center}",
                    "align-items": "{alignItems.center}",
                    "hidden": true
                },
                "jds-text": {}
            },
            "initials": {
                "container": {
                    "background-color": "{a_19}"
                },
                "jds_image": {
                    "hidden": true
                },
                "jds-icon": {
                    "hidden": true
                },
                "jds-icon-container": {
                    "background-color": "{global.transparent}",
                    "border-radius": "{pill}",
                    "size": "{l}",
                    "justify-content": "{justifyContent.center}",
                    "align-items": "{alignItems.center}",
                    "hidden": true
                },
                "jds-text": {
                    "hidden": false
                }
            }
        }
    },
    "combination": [
        {
            "true": {
                "icon": {
                    "container": {
                        "behavior": {
                            "focus": {
                                "border-width": "{a_20}"
                            }
                        }
                    },
                    "jds-icon": {
                        "behavior": {
                            "hover": {
                                "color": "{primary60}"
                            },
                            "focus": {
                                "color": "{primary60}"
                            }
                        }
                    },
                    "jds-icon-container": {
                        "background-color": "{global.transparent}",
                        "border-radius": "{pill}",
                        "size": "{l}",
                        "justify-content": "{justifyContent.center}",
                        "align-items": "{alignItems.center}",
                        "behavior": {
                            "hover": {
                                "background-color": "{global.transparent}",
                                "border-radius": "{pill}",
                                "size": "{l}",
                                "justify-content": "{justifyContent.center}",
                                "align-items": "{alignItems.center}"
                            },
                            "focus": {
                                "background-color": "{global.transparent}",
                                "border-radius": "{pill}",
                                "size": "{l}",
                                "justify-content": "{justifyContent.center}",
                                "align-items": "{alignItems.center}"
                            }
                        }
                    }
                },
                "initials": {
                    "container": {
                        "behavior": {
                            "hover": {
                                "background-color": "{a_21}"
                            },
                            "focus": {
                                "border-width": "{a_22}",
                                "background-color": "{a_23}"
                            }
                        }
                    },
                    "jds-text": {
                        "behavior": {
                            "hover": {
                                "color": "{sparkle70}"
                            },
                            "focus": {
                                "color": "{sparkle70}"
                            }
                        }
                    }
                },
                "image": {
                    "container": {
                        "behavior": {
                            "hover": {
                                "opacity": "{a_24}"
                            },
                            "focus": {
                                "border-width": "{a_25}",
                                "opacity": "{a_26}"
                            }
                        }
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "isClickable",
            "kind"
        ]
    ],
    "api": {
        "data": {
            "jds_image": {
                "src": {
                    "type": "image",
                    "name": "image",
                    "doc_description": "This is a user uploaded image. It will be used, when [kind] is set to image."
                }
            },
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "initials",
                    "function": true,
                    "doc_description": "This is the two initials of user name. It will be used, when [kind] is set to initials."
                }
            }
        },
        "config": {
            "size": {
                "values": [
                    "medium",
                    "xtra-small",
                    "small",
                    "large",
                    "xtra-large",
                    "xtra-xtra-large"
                ],
                "doc_description": "This can be used to control the size of Avatar."
            },
            "kind": {
                "values": [
                    "icon",
                    "initials",
                    "image"
                ],
                "doc_description": "It can be used to switch between 3 variants of Avatar."
            },
            "disabled": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to enable or disable Avatar."
            },
            "isClickable": {
                "values": [
                    false,
                    true
                ],
                "platform": "web",
                "doc_description": "It can be used to make Avatar Clickable"
            }
        },
        "events": {
            "container": {
                "onClick": "onClick"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "aria-label": {
                        "name": "ariaLabel",
                        "value": "avatar"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "role": {
                        "name": "role",
                        "platform": "web"
                    },
                    "aria-haspopup": {
                        "name": "ariaHaspopup",
                        "platform": "web"
                    },
                    "aria-expanded": {
                        "name": "ariaExpanded",
                        "platform": "web"
                    },
                    "aria-controls": {
                        "name": "ariaControls",
                        "platform": "web"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$legacySizes$3 = [
    "x-small",
    "x-large",
    "xx-large"
];
const $fe5170bdd3625759$var$PROP_MAP$t = (props)=>{
    if ($fe5170bdd3625759$var$legacySizes$3.includes(props.size)) console.warn("these sizes are not deprecated. use sizes starting with `xtra`");
    if (typeof props.image === "object") console.warn("Image as an element is deprecated. Pass a string instead");
    return {
        size: {
            properties: {
                size: props.size
            },
            defaultValue: "medium",
            variations: {
                "x-small": {
                    size: "xtra-small"
                },
                small: {
                    size: "small"
                },
                medium: {
                    size: "medium"
                },
                large: {
                    size: "large"
                },
                "x-large": {
                    size: "xtra-large"
                },
                "xx-large": {
                    size: "xtra-xtra-large"
                }
            }
        },
        kind: {
            properties: {
                kind: props.kind
            },
            defaultValue: "default",
            variations: {
                default: {
                    icon: "ic_profile"
                }
            }
        },
        onClick: {
            properties: {
                onClick: props.onClick
            }
        }
    };
};
const $fe5170bdd3625759$var$extractInitials = (value = "A", size)=>{
    const trimmedValue = value?.trim();
    if (size === "xtra-small") return (trimmedValue[0] || "A").toUpperCase();
    if (trimmedValue.indexOf(" ") >= 0) {
        const strMatch = trimmedValue?.trim().match(/\b(\w)/g) || [
            ""
        ];
        const strJoin = strMatch.join("") || trimmedValue;
        return strJoin.toUpperCase().trim().substring(0, 2);
    }
    return trimmedValue.toUpperCase().trim().substring(0, 2);
};
const $fe5170bdd3625759$var$withLogic$2c = (Component)=>(userProps)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$t);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props,
            image: typeof props.image === "string" ? props.image : props.image?.props?.src,
            initials: $fe5170bdd3625759$var$extractInitials(props.initials, props.size || "")
        });
    };
const $fe5170bdd3625759$var$Component$2e = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$29;
    const { size: size = "medium", kind: kind = "icon", disabled: disabled = false, isClickable: isClickable = false, onClick: onClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), ariaLabel: ariaLabel = "avatar", custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            size: size,
            kind: kind,
            disabled: disabled,
            isClickable: isClickable,
            onClick: onClick,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSAvatar", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$e2255cf6045e8d47 = $fe5170bdd3625759$var$withLogic$2c($fe5170bdd3625759$var$Component$2e);
$fe5170bdd3625759$export$e2255cf6045e8d47.displayName = "Avatar";
$fe5170bdd3625759$export$e2255cf6045e8d47.slotName = "jds_avatar";
const $fe5170bdd3625759$var$sdl$28 = {
    "metadata": {
        "version": "2.0.0",
        "id": "avatar-2.0.0",
        "name": "JDSAvatarV2",
        "layerName": "jds_avatar_v2"
    },
    "hierarchy": {
        "container": [
            "jds_avatar_v2_default",
            "jds_avatar_v2_status",
            "jds_avatar_v2_notification",
            "jds_avatar_v2_information",
            "jds_avatar_v2_complete_ring",
            "jds_avatar_v2_segmented_ring",
            "jds_avatar_v2_progress_ring"
        ]
    },
    "base": {
        "container": {
            "hidden": false,
            "behavior": {
                "focus": {
                    "background-color": "{primary60}",
                    "border-radius": "{pill}",
                    "padding-left": "{xxs}",
                    "padding-right": "{xxs}",
                    "padding-top": "{xxs}",
                    "padding-bottom": "{xxs}"
                }
            }
        },
        "jds_avatar_v2_default": {
            "hidden": false,
            "size": "medium"
        },
        "jds_avatar_v2_status": {
            "hidden": true,
            "size": "medium"
        },
        "jds_avatar_v2_notification": {
            "hidden": true,
            "size": "medium"
        },
        "jds_avatar_v2_information": {
            "hidden": true,
            "size": "medium"
        },
        "jds_avatar_v2_complete_ring": {
            "hidden": true,
            "size": "medium"
        },
        "jds_avatar_v2_segmented_ring": {
            "hidden": true,
            "size": "medium"
        },
        "jds_avatar_v2_progress_ring": {
            "hidden": true,
            "size": "medium"
        }
    },
    "variant": {
        "kind": {
            "status": {
                "jds_avatar_v2_default": {
                    "hidden": true
                },
                "jds_avatar_v2_status": {
                    "hidden": false
                }
            },
            "notification": {
                "jds_avatar_v2_default": {
                    "hidden": true
                },
                "jds_avatar_v2_notification": {
                    "hidden": false
                }
            },
            "information": {
                "jds_avatar_v2_default": {
                    "hidden": true
                },
                "jds_avatar_v2_information": {
                    "hidden": false
                }
            },
            "complete-ring": {
                "jds_avatar_v2_default": {
                    "hidden": true
                },
                "jds_avatar_v2_complete_ring": {
                    "hidden": false
                }
            },
            "segmented-ring": {
                "jds_avatar_v2_default": {
                    "hidden": true
                },
                "jds_avatar_v2_segmented_ring": {
                    "hidden": false
                }
            },
            "progress-ring": {
                "jds_avatar_v2_default": {
                    "hidden": true
                },
                "jds_avatar_v2_progress_ring": {
                    "hidden": false
                }
            }
        },
        "size": {
            "xtra-small": {
                "jds_avatar_v2_default": {
                    "size": "xtra-small"
                },
                "jds_avatar_v2_status": {
                    "size": "xtra-small"
                },
                "jds_avatar_v2_notification": {
                    "size": "xtra-small"
                },
                "jds_avatar_v2_information": {
                    "size": "xtra-small"
                },
                "jds_avatar_v2_complete_ring": {
                    "size": "xtra-small"
                },
                "jds_avatar_v2_segmented_ring": {
                    "size": "xtra-small"
                },
                "jds_avatar_v2_progress_ring": {
                    "size": "xtra-small"
                }
            },
            "small": {
                "jds_avatar_v2_default": {
                    "size": "small"
                },
                "jds_avatar_v2_status": {
                    "size": "small"
                },
                "jds_avatar_v2_notification": {
                    "size": "small"
                },
                "jds_avatar_v2_information": {
                    "size": "small"
                },
                "jds_avatar_v2_complete_ring": {
                    "size": "small"
                },
                "jds_avatar_v2_segmented_ring": {
                    "size": "small"
                },
                "jds_avatar_v2_progress_ring": {
                    "size": "small"
                }
            },
            "large": {
                "jds_avatar_v2_default": {
                    "size": "large"
                },
                "jds_avatar_v2_status": {
                    "size": "large"
                },
                "jds_avatar_v2_notification": {
                    "size": "large"
                },
                "jds_avatar_v2_information": {
                    "size": "large"
                },
                "jds_avatar_v2_complete_ring": {
                    "size": "large"
                },
                "jds_avatar_v2_segmented_ring": {
                    "size": "large"
                },
                "jds_avatar_v2_progress_ring": {
                    "size": "large"
                }
            },
            "xtra-large": {
                "jds_avatar_v2_default": {
                    "size": "xtra-large"
                },
                "jds_avatar_v2_status": {
                    "size": "xtra-large"
                },
                "jds_avatar_v2_notification": {
                    "size": "xtra-large"
                },
                "jds_avatar_v2_information": {
                    "size": "xtra-large"
                },
                "jds_avatar_v2_complete_ring": {
                    "size": "xtra-large"
                },
                "jds_avatar_v2_segmented_ring": {
                    "size": "xtra-large"
                },
                "jds_avatar_v2_progress_ring": {
                    "size": "xtra-large"
                }
            },
            "xtra-xtra-large": {
                "jds_avatar_v2_default": {
                    "size": "xtra-xtra-large"
                },
                "jds_avatar_v2_status": {
                    "size": "xtra-xtra-large"
                },
                "jds_avatar_v2_notification": {
                    "size": "xtra-xtra-large"
                },
                "jds_avatar_v2_information": {
                    "size": "xtra-xtra-large"
                },
                "jds_avatar_v2_complete_ring": {
                    "size": "xtra-xtra-large"
                },
                "jds_avatar_v2_segmented_ring": {
                    "size": "xtra-xtra-large"
                },
                "jds_avatar_v2_progress_ring": {
                    "size": "xtra-xtra-large"
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "kind": {
                "values": [
                    "default",
                    "status",
                    "notification",
                    "information",
                    "complete-ring",
                    "segmented-ring",
                    "progress-ring"
                ]
            },
            "size": {
                "values": [
                    "medium",
                    "xtra-small",
                    "small",
                    "large",
                    "xtra-large",
                    "xtra-xtra-large"
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds_avatar_v2_default": {
                "image": {
                    "type": "image",
                    "name": "image"
                },
                "initials": {
                    "type": "string",
                    "name": "initials"
                },
                "kind": {
                    "type": "JDSAvatarV2Default.kind",
                    "name": "avatarKind"
                },
                "disabled": {
                    "type": "boolean",
                    "name": "disabled"
                }
            },
            "jds_avatar_v2_status": {
                "label": {
                    "type": "string",
                    "name": "badgeLabel"
                },
                "avatarImage": {
                    "type": "image",
                    "name": "image"
                },
                "avatarInitials": {
                    "type": "string",
                    "name": "initials"
                },
                "avatarKind": {
                    "type": "JDSAvatarV2Default.kind",
                    "name": "avatarKind"
                },
                "badgeBorder": {
                    "type": "boolean",
                    "name": "badgeBorder"
                },
                "badgeStatus": {
                    "type": "JDSBadgeV2Status.status",
                    "name": "statusBadgeStatus"
                },
                "kind": {
                    "type": "JDSAvatarV2Status.kind",
                    "name": "statusBadgeKind"
                },
                "placement": {
                    "type": "JDSAvatarV2Status.placement",
                    "name": "statusBadgePlacement"
                },
                "disabled": {
                    "type": "boolean",
                    "name": "disabled"
                }
            },
            "jds_avatar_v2_notification": {
                "label": {
                    "type": "string",
                    "name": "badgeLabel"
                },
                "avatarImage": {
                    "type": "image",
                    "name": "image"
                },
                "avatarInitials": {
                    "type": "string",
                    "name": "initials"
                },
                "avatarKind": {
                    "type": "JDSAvatarV2Default.kind",
                    "name": "avatarKind"
                },
                "badgeBorder": {
                    "type": "boolean",
                    "name": "badgeBorder"
                },
                "kind": {
                    "type": "JDSAvatarV2Notification.kind",
                    "name": "notificationBadgeKind"
                },
                "disabled": {
                    "type": "boolean",
                    "name": "disabled"
                }
            },
            "jds_avatar_v2_information": {
                "label": {
                    "type": "string",
                    "name": "badgeLabel"
                },
                "avatarImage": {
                    "type": "image",
                    "name": "image"
                },
                "avatarInitials": {
                    "type": "string",
                    "name": "initials"
                },
                "avatarKind": {
                    "type": "JDSAvatarV2Default.kind",
                    "name": "avatarKind"
                },
                "badgeBorder": {
                    "type": "boolean",
                    "name": "badgeBorder"
                },
                "badgeIcon": {
                    "type": "icon",
                    "name": "informationBadgeIcon"
                },
                "badgeColor": {
                    "type": "JDSBadgeV2Information.color",
                    "name": "informationBadgeColor"
                },
                "badgeAppearance": {
                    "type": "JDSBadgeV2Information.appearance",
                    "name": "informationBadgeAppearance"
                },
                "kind": {
                    "type": "JDSAvatarV2Information.kind",
                    "name": "informationBadgeKind"
                },
                "placement": {
                    "type": "JDSAvatarV2Information.placement",
                    "name": "informationBadgePlacement"
                },
                "disabled": {
                    "type": "boolean",
                    "name": "disabled"
                }
            },
            "jds_avatar_v2_complete_ring": {
                "avatarImage": {
                    "type": "image",
                    "name": "image"
                },
                "avatarInitials": {
                    "type": "string",
                    "name": "initials"
                },
                "avatarKind": {
                    "type": "JDSAvatarV2Default.kind",
                    "name": "avatarKind"
                },
                "disabled": {
                    "type": "boolean",
                    "name": "disabled"
                }
            },
            "jds_avatar_v2_segmented_ring": {
                "avatarImage": {
                    "type": "image",
                    "name": "image"
                },
                "avatarInitials": {
                    "type": "string",
                    "name": "initials"
                },
                "avatarKind": {
                    "type": "JDSAvatarV2Default.kind",
                    "name": "avatarKind"
                },
                "disabled": {
                    "type": "boolean",
                    "name": "disabled"
                },
                "count": {
                    "type": "number",
                    "name": "segmentCount",
                    "doc_description": "It can be used to control count of segments."
                }
            },
            "jds_avatar_v2_progress_ring": {
                "avatarImage": {
                    "type": "image",
                    "name": "image"
                },
                "avatarInitials": {
                    "type": "string",
                    "name": "initials"
                },
                "avatarKind": {
                    "type": "JDSAvatarV2Default.kind",
                    "name": "avatarKind"
                },
                "disabled": {
                    "type": "boolean",
                    "name": "disabled"
                },
                "progress": {
                    "type": "number",
                    "name": "progress"
                }
            }
        },
        "events": {
            "container": {
                "onClick": "onClick"
            }
        },
        "a11y": {
            "jds_avatar_v2_default": {
                "properties": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_avatar_v2_status": {
                "properties": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_avatar_v2_notification": {
                "properties": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_avatar_v2_information": {
                "properties": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_avatar_v2_complete_ring": {
                "properties": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_avatar_v2_segmented_ring": {
                "properties": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_avatar_v2_progress_ring": {
                "properties": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$2b = (Component)=>(props)=>{
        const trimChars = (initials2, size)=>{
            if (!initials2 || typeof initials2 !== "string" || initials2.trim() === "") return "";
            let initialsText = "";
            const array = initials2.trim().split(" ");
            if (array.length <= 1) initialsText = array[0].substring(0, 2);
            else initialsText = array[0][0] + array[1][0];
            initialsText = initialsText.substring(0, size);
            return initialsText.toUpperCase();
        };
        const initials = (item)=>{
            return trimChars(item.initials, item.size === "xtra-small" ? 1 : 2);
        };
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props,
            initials: initials(props)
        });
    };
const $fe5170bdd3625759$var$Component$2d = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$28;
    const { kind: kind = "default", size: size = "medium", disabled: disabled = false, onClick: onClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            size: size,
            disabled: disabled,
            onClick: onClick,
            ...rest
        },
        componentTag: componentTag
    }, "JDSAvatarV2", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$ac4313c0728f5b84 = $fe5170bdd3625759$var$withLogic$2b($fe5170bdd3625759$var$Component$2d);
$fe5170bdd3625759$export$ac4313c0728f5b84.displayName = "AvatarV2";
$fe5170bdd3625759$export$ac4313c0728f5b84.slotName = "jds_avatar_v2";
const $fe5170bdd3625759$var$sdl$27 = {
    "metadata": {
        "version": "2.0.0",
        "id": "avatar-complete-ring-2.0.0",
        "name": "JDSAvatarV2CompleteRing",
        "layerName": "jds_avatar_v2_complete_ring",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "ring-arc",
            "jds_avatar_v2_default"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{flexDirection.stack}",
            "justify-content": "{justifyContent.center}",
            "align-items": "{alignItems.center}",
            "opacity": "{opacity.enabled}",
            "hidden": false
        },
        "ring-arc": {
            "radius": 24,
            "arcWidth": 2,
            "fill": "{primary50}",
            "start": 0,
            "end": 360,
            "z-index": 1,
            "disabled": true
        },
        "jds_avatar_v2_default": {
            "size": "medium"
        }
    },
    "variant": {
        "size": {
            "xtra-xtra-large": {
                "jds_avatar_v2_default": {
                    "size": "xtra-xtra-large"
                },
                "ring-arc": {
                    "radius": 68,
                    "arcWidth": 4
                }
            },
            "xtra-large": {
                "jds_avatar_v2_default": {
                    "size": "xtra-large"
                },
                "ring-arc": {
                    "radius": 34,
                    "arcWidth": 3
                }
            },
            "large": {
                "jds_avatar_v2_default": {
                    "size": "large"
                },
                "ring-arc": {
                    "radius": 30,
                    "arcWidth": 3
                }
            },
            "small": {
                "jds_avatar_v2_default": {
                    "size": "small"
                },
                "ring-arc": {
                    "radius": 20,
                    "arcWidth": 2
                }
            },
            "xtra-small": {
                "jds_avatar_v2_default": {
                    "size": "xtra-small"
                },
                "ring-arc": {
                    "radius": 16,
                    "arcWidth": 2
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{opacity.disabled}"
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "size": {
                "values": [
                    "medium",
                    "xtra-xtra-large",
                    "xtra-large",
                    "large",
                    "small",
                    "xtra-small"
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds_avatar_v2_default": {
                "image": {
                    "type": "image",
                    "name": "avatarImage"
                },
                "initials": {
                    "type": "string",
                    "name": "avatarInitials"
                },
                "kind": {
                    "type": "JDSAvatarV2Default.kind",
                    "name": "avatarKind"
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "aria-label": {
                        "name": "ariaLabel",
                        "value": "Avatar with Activity Ring"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$2a = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$2c = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$27;
    const { size: size = "medium", disabled: disabled = false, ariaLabel: ariaLabel = "Avatar with Activity Ring", custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            size: size,
            disabled: disabled,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSAvatarV2CompleteRing", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$70f728d68d57ace9 = $fe5170bdd3625759$var$withLogic$2a($fe5170bdd3625759$var$Component$2c);
$fe5170bdd3625759$export$70f728d68d57ace9.displayName = "AvatarV2CompleteRing";
$fe5170bdd3625759$export$70f728d68d57ace9.slotName = "jds_avatar_v2_complete_ring";
const $fe5170bdd3625759$var$sdl$26 = {
    "metadata": {
        "version": "2.0.0",
        "id": "avatar-default-2.0.0",
        "name": "JDSAvatarV2Default",
        "layerName": "jds_avatar_v2_default",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "jds_image",
            "jds-text",
            "icon"
        ]
    },
    "base": {
        "container": {
            "hidden": false,
            "opacity": "{a_9}",
            "width": "{a_0}",
            "height": "{a_1}",
            "flex-direction": "{a_2}",
            "justify-content": "{a_3}",
            "align-items": "{a_4}",
            "background-color": "{a_5}",
            "border-radius": "{a_6}",
            "behavior": {
                "active": {
                    "background-color": "{a_10}"
                }
            }
        },
        "jds_image": {
            "hidden": true,
            "aspectRatio": "round"
        },
        "icon": {
            "hidden": false,
            "size": "{a_12}",
            "color": "{a_13}",
            "value": "ic_profile",
            "behavior": {
                "hover": {
                    "color": "{a_14}"
                },
                "active": {
                    "color": "{a_15}"
                }
            }
        },
        "jds-text": {
            "font-family": "{bodySBold}",
            "color": "{primary70}",
            "font-size": "{bodySBold}",
            "line-height": "{bodySBold}",
            "letter-spacing": "{bodySBold}",
            "font-weight": "{bodySBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": true,
            "behavior": {
                "hover": {
                    "color": "{primary50}"
                }
            }
        }
    },
    "variant": {
        "size": {
            "xtra-small": {
                "container": {
                    "width": "{a_16}",
                    "height": "{a_17}"
                },
                "icon": {
                    "size": "{a_26}"
                },
                "jds-text": {
                    "font-family": "{bodyXxsBold}",
                    "font-size": "{bodyXxsBold}",
                    "line-height": "{bodyXxsBold}",
                    "letter-spacing": "{bodyXxsBold}",
                    "font-weight": "{bodyXxsBold}"
                }
            },
            "small": {
                "container": {
                    "width": "{a_18}",
                    "height": "{a_19}"
                },
                "icon": {
                    "size": "{a_27}"
                },
                "jds-text": {
                    "font-family": "{bodyXxsBold}",
                    "font-size": "{bodyXxsBold}",
                    "line-height": "{bodyXxsBold}",
                    "letter-spacing": "{bodyXxsBold}",
                    "font-weight": "{bodyXxsBold}"
                }
            },
            "large": {
                "container": {
                    "width": "{a_20}",
                    "height": "{a_21}"
                },
                "icon": {
                    "size": "{a_28}"
                },
                "jds-text": {}
            },
            "xtra-large": {
                "container": {
                    "width": "{a_22}",
                    "height": "{a_23}"
                },
                "icon": {
                    "size": "{a_29}"
                },
                "jds-text": {
                    "font-family": "{bodyMBold}",
                    "font-size": "{bodyMBold}",
                    "line-height": "{bodyMBold}",
                    "letter-spacing": "{bodyMBold}",
                    "font-weight": "{bodyMBold}"
                }
            },
            "xtra-xtra-large": {
                "container": {
                    "width": "{a_24}",
                    "height": "{a_25}"
                },
                "icon": {
                    "size": "{a_30}"
                },
                "jds-text": {
                    "font-family": "{bodyLBold}",
                    "font-size": "{bodyLBold}",
                    "line-height": "{bodyLBold}",
                    "letter-spacing": "{bodyLBold}",
                    "font-weight": "{bodyLBold}"
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{a_31}"
                }
            }
        },
        "kind": {
            "initials": {
                "jds_image": {
                    "hidden": true
                },
                "icon": {
                    "hidden": true
                },
                "jds-text": {
                    "hidden": false
                }
            },
            "image": {
                "container": {
                    "behavior": {
                        "hover": {
                            "background-color": "{a_34}"
                        },
                        "active": {
                            "background-color": "{a_36}"
                        }
                    }
                },
                "jds_image": {
                    "hidden": false,
                    "behavior": {
                        "hover": {
                            "opacity": "{a_33}"
                        },
                        "active": {
                            "opacity": "{a_35}"
                        }
                    }
                },
                "icon": {
                    "hidden": true
                },
                "jds-text": {}
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "data": {
            "jds_image": {
                "src": {
                    "type": "image",
                    "name": "image"
                }
            },
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "initials",
                    "function": true
                }
            }
        },
        "config": {
            "size": {
                "values": [
                    "medium",
                    "xtra-small",
                    "small",
                    "large",
                    "xtra-large",
                    "xtra-xtra-large"
                ]
            },
            "kind": {
                "values": [
                    "icon",
                    "initials",
                    "image"
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "events": {
            "container": {
                "onClick": "onClick"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "aria-label": {
                        "name": "ariaLabel",
                        "value": "Avatar"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$29 = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$2b = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$26;
    const { size: size = "medium", kind: kind = "icon", disabled: disabled = false, onClick: onClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), ariaLabel: ariaLabel = "Avatar", custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            size: size,
            kind: kind,
            disabled: disabled,
            onClick: onClick,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSAvatarV2Default", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$4860988e9a471058 = $fe5170bdd3625759$var$withLogic$29($fe5170bdd3625759$var$Component$2b);
$fe5170bdd3625759$export$4860988e9a471058.displayName = "AvatarV2Default";
$fe5170bdd3625759$export$4860988e9a471058.slotName = "jds_avatar_v2_default";
const $fe5170bdd3625759$var$sdl$25 = {
    "metadata": {
        "version": "2.0.0",
        "id": "avatar-information-2.0.0",
        "name": "JDSAvatarV2Information",
        "layerName": "jds_avatar_v2_information",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "jds_avatar_v2_default",
            {
                "badge-container": [
                    "jds_badge_v2"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{flexDirection.stack}",
            "justify-content": "{justifyContent.start}",
            "align-items": "{alignItems.start}",
            "opacity": "{opacity.enabled}",
            "hidden": false
        },
        "badge-container": {
            "padding-left": "{custom_11}",
            "padding-top": "{custom_11}",
            "z-index": 1,
            "disabled": true
        },
        "jds_avatar_v2_default": {
            "size": "medium"
        },
        "jds_badge_v2": {
            "size": "small",
            "kind": "information",
            "informationKind": "icon-circle",
            "border": true
        }
    },
    "variant": {
        "kind": {
            "label": {
                "jds_badge_v2": {
                    "informationKind": "label"
                }
            }
        },
        "size": {
            "xtra-small": {
                "container": {
                    "hidden": true
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{opacity.disabled}"
                }
            }
        }
    },
    "combination": [
        {
            "small": {
                "icon": {
                    "bottom-right": {
                        "badge-container": {
                            "padding-left": "{custom_15}",
                            "padding-top": "{custom_15}"
                        },
                        "jds_avatar_v2_default": {
                            "size": "small"
                        },
                        "jds_badge_v2": {
                            "size": "small"
                        }
                    },
                    "bottom-center": {
                        "container": {
                            "justify-content": "{justifyContent.center}",
                            "align-items": "{alignItems.center}"
                        },
                        "badge-container": {
                            "align-self": "flex-end",
                            "padding-left": "{custom_5}",
                            "padding-top": "{l}"
                        },
                        "jds_avatar_v2_default": {
                            "size": "small"
                        },
                        "jds_badge_v2": {
                            "size": "small"
                        }
                    }
                },
                "label": {
                    "bottom-right": {
                        "container": {
                            "hidden": true
                        }
                    },
                    "bottom-center": {
                        "container": {
                            "hidden": true
                        }
                    }
                }
            },
            "medium": {
                "icon": {
                    "bottom-center": {
                        "container": {
                            "justify-content": "{justifyContent.center}",
                            "align-items": "{alignItems.center}"
                        },
                        "badge-container": {
                            "align-self": "flex-end",
                            "padding-left": "{custom_5}",
                            "padding-top": "{custom_10}"
                        },
                        "jds_avatar_v2_default": {
                            "size": "medium"
                        },
                        "jds_badge_v2": {
                            "size": "small"
                        }
                    }
                },
                "label": {
                    "bottom-right": {
                        "badge-container": {
                            "padding-left": "{custom_11}",
                            "padding-top": "{l}"
                        },
                        "jds_avatar_v2_default": {
                            "size": "medium"
                        },
                        "jds_badge_v2": {
                            "size": "xtra-small"
                        }
                    },
                    "bottom-center": {
                        "container": {
                            "justify-content": "{justifyContent.center}",
                            "align-items": "{alignItems.center}"
                        },
                        "badge-container": {
                            "align-self": "flex-end",
                            "padding-left": "{custom_5}",
                            "padding-top": "{custom_10}"
                        },
                        "jds_avatar_v2_default": {
                            "size": "medium"
                        },
                        "jds_badge_v2": {
                            "size": "xtra-small"
                        }
                    }
                }
            },
            "large": {
                "icon": {
                    "bottom-right": {
                        "badge-container": {
                            "padding-left": "{l}",
                            "padding-top": "{l}"
                        },
                        "jds_avatar_v2_default": {
                            "size": "large"
                        },
                        "jds_badge_v2": {
                            "size": "medium"
                        }
                    },
                    "bottom-center": {
                        "container": {
                            "justify-content": "{justifyContent.center}",
                            "align-items": "{alignItems.center}"
                        },
                        "badge-container": {
                            "align-self": "flex-end",
                            "padding-left": "{custom_5}",
                            "padding-top": "{xxl}"
                        },
                        "jds_avatar_v2_default": {
                            "size": "large"
                        },
                        "jds_badge_v2": {
                            "size": "medium"
                        }
                    }
                },
                "label": {
                    "bottom-right": {
                        "badge-container": {
                            "padding-left": "{l}",
                            "padding-top": "{custom_10}"
                        },
                        "jds_avatar_v2_default": {
                            "size": "large"
                        },
                        "jds_badge_v2": {
                            "size": "xtra-small"
                        }
                    },
                    "bottom-center": {
                        "container": {
                            "justify-content": "{justifyContent.center}",
                            "align-items": "{alignItems.center}"
                        },
                        "badge-container": {
                            "align-self": "flex-end",
                            "padding-left": "{custom_5}",
                            "padding-top": "{xxl}"
                        },
                        "jds_avatar_v2_default": {
                            "size": "large"
                        },
                        "jds_badge_v2": {
                            "size": "xtra-small"
                        }
                    }
                }
            },
            "xtra-large": {
                "icon": {
                    "bottom-right": {
                        "badge-container": {
                            "padding-left": "{xl}",
                            "padding-top": "{xl}"
                        },
                        "jds_avatar_v2_default": {
                            "size": "xtra-large"
                        },
                        "jds_badge_v2": {
                            "size": "large"
                        }
                    },
                    "bottom-center": {
                        "container": {
                            "justify-content": "{justifyContent.center}",
                            "align-items": "{alignItems.center}"
                        },
                        "badge-container": {
                            "align-self": "flex-end",
                            "padding-left": "{custom_5}",
                            "padding-top": "{custom_19}"
                        },
                        "jds_avatar_v2_default": {
                            "size": "xtra-large"
                        },
                        "jds_badge_v2": {
                            "size": "large"
                        }
                    }
                },
                "label": {
                    "bottom-right": {
                        "badge-container": {
                            "padding-left": "{custom_8}",
                            "padding-top": "{xl}"
                        },
                        "jds_avatar_v2_default": {
                            "size": "xtra-large"
                        },
                        "jds_badge_v2": {
                            "size": "xtra-small"
                        }
                    },
                    "bottom-center": {
                        "container": {
                            "justify-content": "{justifyContent.center}",
                            "align-items": "{alignItems.center}"
                        },
                        "badge-container": {
                            "align-self": "flex-end",
                            "padding-left": "{custom_5}",
                            "padding-top": "{custom_19}"
                        },
                        "jds_avatar_v2_default": {
                            "size": "xtra-large"
                        },
                        "jds_badge_v2": {
                            "size": "xtra-small"
                        }
                    }
                }
            },
            "xtra-xtra-large": {
                "icon": {
                    "bottom-right": {
                        "badge-container": {
                            "padding-left": "{custom_7}",
                            "padding-top": "{custom_7}"
                        },
                        "jds_avatar_v2_default": {
                            "size": "xtra-xtra-large"
                        },
                        "jds_badge_v2": {
                            "size": "xtra-xtra-large"
                        }
                    },
                    "bottom-center": {
                        "container": {
                            "justify-content": "{justifyContent.center}",
                            "align-items": "{alignItems.center}"
                        },
                        "badge-container": {
                            "align-self": "flex-end",
                            "padding-left": "{custom_5}",
                            "padding-top": "{custom_21}"
                        },
                        "jds_avatar_v2_default": {
                            "size": "xtra-xtra-large"
                        },
                        "jds_badge_v2": {
                            "size": "xtra-xtra-large"
                        }
                    }
                },
                "label": {
                    "bottom-right": {
                        "badge-container": {
                            "padding-left": "{custom_6}",
                            "padding-top": "{custom_7}"
                        },
                        "jds_avatar_v2_default": {
                            "size": "xtra-xtra-large"
                        },
                        "jds_badge_v2": {
                            "size": "medium"
                        }
                    },
                    "bottom-center": {
                        "container": {
                            "justify-content": "{justifyContent.center}",
                            "align-items": "{alignItems.center}"
                        },
                        "badge-container": {
                            "align-self": "flex-end",
                            "padding-left": "{custom_5}",
                            "padding-top": "{custom_22}"
                        },
                        "jds_avatar_v2_default": {
                            "size": "xtra-xtra-large"
                        },
                        "jds_badge_v2": {
                            "size": "medium"
                        }
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "size",
            "kind",
            "placement"
        ]
    ],
    "api": {
        "data": {
            "jds_avatar_v2_default": {
                "image": {
                    "type": "image",
                    "name": "avatarImage"
                },
                "kind": {
                    "type": "JDSAvatarV2Default.kind",
                    "name": "avatarKind"
                },
                "initials": {
                    "type": "string",
                    "name": "avatarInitials"
                }
            },
            "jds_badge_v2": {
                "icon": {
                    "type": "icon",
                    "name": "badgeIcon"
                },
                "label": {
                    "type": "string",
                    "name": "label"
                },
                "border": {
                    "type": "boolean",
                    "name": "badgeBorder"
                },
                "color": {
                    "type": "JDSBadgeV2Information.color",
                    "name": "badgeColor"
                },
                "appearance": {
                    "type": "JDSBadgeV2Information.appearance",
                    "name": "badgeAppearance"
                }
            }
        },
        "config": {
            "kind": {
                "values": [
                    "icon",
                    "label"
                ]
            },
            "placement": {
                "values": [
                    "bottom-right",
                    "bottom-center"
                ]
            },
            "size": {
                "values": [
                    "medium",
                    "xtra-xtra-large",
                    "xtra-large",
                    "large",
                    "small",
                    "xtra-small"
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "aria-label": {
                        "name": "ariaLabel",
                        "value": "Avatar with Information Badge"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$28 = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$2a = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$25;
    const { kind: kind = "icon", placement: placement = "bottom-right", size: size = "medium", disabled: disabled = false, ariaLabel: ariaLabel = "Avatar with Information Badge", custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            placement: placement,
            size: size,
            disabled: disabled,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSAvatarV2Information", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$dbc79143cb6c67cb = $fe5170bdd3625759$var$withLogic$28($fe5170bdd3625759$var$Component$2a);
$fe5170bdd3625759$export$dbc79143cb6c67cb.displayName = "AvatarV2Information";
$fe5170bdd3625759$export$dbc79143cb6c67cb.slotName = "jds_avatar_v2_information";
const $fe5170bdd3625759$var$sdl$24 = {
    "metadata": {
        "version": "2.0.0",
        "id": "avatar-notification-2.0.0",
        "name": "JDSAvatarV2Notification",
        "layerName": "jds_avatar_v2_notification",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "jds_avatar_v2_default",
            {
                "badge-container": [
                    "jds_badge_v2"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{flexDirection.stack}",
            "justify-content": "{justifyContent.start}",
            "align-items": "{alignItems.end}",
            "opacity": "{opacity.enabled}"
        },
        "badge-container": {
            "padding-left": 28,
            "padding-bottom": 28,
            "z-index": 1,
            "disabled": true
        },
        "jds_avatar_v2_default": {
            "size": "medium"
        },
        "jds_badge_v2": {
            "kind": "notification",
            "notificationKind": "dot",
            "size": "small"
        }
    },
    "variant": {
        "kind": {
            "number": {
                "jds_badge_v2": {
                    "notificationKind": "number"
                }
            },
            "number-symbol": {
                "jds_badge_v2": {
                    "notificationKind": "number-symbol"
                }
            }
        },
        "size": {
            "xtra-small": {
                "badge-container": {
                    "padding-left": 16,
                    "padding-bottom": 16
                },
                "jds_avatar_v2_default": {
                    "size": "xtra-small"
                },
                "jds_badge_v2": {
                    "size": "xtra-small"
                }
            },
            "small": {
                "badge-container": {
                    "padding-left": 20,
                    "padding-bottom": 20
                },
                "jds_avatar_v2_default": {
                    "size": "small"
                },
                "jds_badge_v2": {
                    "size": "small"
                }
            },
            "large": {
                "badge-container": {
                    "padding-left": 32,
                    "padding-bottom": 32
                },
                "jds_avatar_v2_default": {
                    "size": "large"
                },
                "jds_badge_v2": {
                    "size": "medium"
                }
            },
            "xtra-large": {
                "badge-container": {
                    "padding-left": 37,
                    "padding-bottom": 37
                },
                "jds_avatar_v2_default": {
                    "size": "xtra-large"
                },
                "jds_badge_v2": {
                    "size": "large"
                }
            },
            "xtra-xtra-large": {
                "badge-container": {
                    "padding-left": 87,
                    "padding-bottom": 87
                },
                "jds_avatar_v2_default": {
                    "size": "xtra-xtra-large"
                },
                "jds_badge_v2": {
                    "size": "xtra-xtra-xtra-large"
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{opacity.disabled}"
                }
            }
        }
    },
    "combination": [
        {
            "number": {
                "xtra-small": {
                    "badge-container": {
                        "padding-left": 15,
                        "padding-bottom": 15
                    },
                    "jds_badge_v2": {
                        "size": "medium"
                    }
                },
                "small": {
                    "badge-container": {
                        "padding-left": 19,
                        "padding-bottom": 19
                    },
                    "jds_badge_v2": {
                        "size": "large"
                    }
                },
                "medium": {
                    "badge-container": {
                        "padding-left": 23,
                        "padding-bottom": 27
                    },
                    "jds_badge_v2": {
                        "size": "large"
                    }
                },
                "large": {
                    "badge-container": {
                        "padding-left": 27,
                        "padding-bottom": 35
                    },
                    "jds_badge_v2": {
                        "size": "large"
                    }
                },
                "xtra-large": {
                    "badge-container": {
                        "padding-left": 35,
                        "padding-bottom": 39
                    },
                    "jds_badge_v2": {
                        "size": "xtra-large"
                    }
                }
            },
            "number-symbol": {
                "xtra-small": {
                    "badge-container": {
                        "padding-left": 10,
                        "padding-bottom": 23
                    },
                    "jds_avatar_v2_default": {
                        "size": "small"
                    },
                    "jds_badge_v2": {
                        "size": "medium"
                    }
                },
                "small": {
                    "badge-container": {
                        "padding-left": 10,
                        "padding-bottom": 23
                    },
                    "jds_badge_v2": {
                        "size": "medium"
                    }
                },
                "medium": {
                    "badge-container": {
                        "padding-left": 18,
                        "padding-bottom": 31
                    },
                    "jds_badge_v2": {
                        "size": "medium"
                    }
                },
                "large": {
                    "badge-container": {
                        "padding-left": 22,
                        "padding-bottom": 39
                    },
                    "jds_badge_v2": {
                        "size": "medium"
                    }
                },
                "xtra-large": {
                    "badge-container": {
                        "padding-left": 28,
                        "padding-bottom": 43
                    },
                    "jds_badge_v2": {
                        "size": "large"
                    }
                },
                "xtra-xtra-large": {
                    "badge-container": {
                        "padding-left": 75,
                        "padding-bottom": 87
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "kind",
            "size"
        ]
    ],
    "api": {
        "config": {
            "kind": {
                "values": [
                    "dot",
                    "number",
                    "number-symbol"
                ]
            },
            "size": {
                "values": [
                    "medium",
                    "xtra-small",
                    "small",
                    "large",
                    "xtra-large",
                    "xtra-xtra-large"
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds_avatar_v2_default": {
                "image": {
                    "type": "image",
                    "name": "avatarImage"
                },
                "initials": {
                    "type": "string",
                    "name": "avatarInitials"
                },
                "kind": {
                    "type": "JDSAvatarV2Default.kind",
                    "name": "avatarKind"
                }
            },
            "jds_badge_v2": {
                "label": {
                    "type": "string",
                    "name": "label"
                },
                "border": {
                    "type": "boolean",
                    "name": "badgeBorder"
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "aria-label": {
                        "name": "ariaLabel",
                        "value": "Avatar with Active Notifications"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$27 = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$29 = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$24;
    const { kind: kind = "dot", size: size = "medium", disabled: disabled = false, ariaLabel: ariaLabel = "Avatar with Active Notifications", custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            size: size,
            disabled: disabled,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSAvatarV2Notification", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$c906bb7932dd69e9 = $fe5170bdd3625759$var$withLogic$27($fe5170bdd3625759$var$Component$29);
$fe5170bdd3625759$export$c906bb7932dd69e9.displayName = "AvatarV2Notification";
$fe5170bdd3625759$export$c906bb7932dd69e9.slotName = "jds_avatar_v2_notification";
const $fe5170bdd3625759$var$sdl$23 = {
    "metadata": {
        "version": "1.0.0",
        "id": "avatar_progress_ring-1.0.0",
        "name": "JDSAvatarV2ProgressRing",
        "layerName": "jds_avatar_v2_progress_ring",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "base-arc",
            "ring-arc",
            "jds_avatar_v2_default"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{flexDirection.stack}",
            "justify-content": "{justifyContent.center}",
            "align-items": "{alignItems.center}",
            "opacity": "{opacity.enabled}",
            "hidden": false
        },
        "base-arc": {
            "radius": 24,
            "arcWidth": 2,
            "fill": "{primaryGrey40}",
            "start": 0,
            "end": 360,
            "z-index": 1,
            "disabled": true
        },
        "ring-arc": {
            "radius": 24,
            "arcWidth": 2,
            "fill": "{primary50}",
            "start": 0,
            "end": 270,
            "z-index": 2,
            "disabled": true
        },
        "jds_avatar_v2_default": {
            "size": "medium"
        }
    },
    "variant": {
        "size": {
            "xtra-xtra-large": {
                "jds_avatar_v2_default": {
                    "size": "xtra-xtra-large"
                },
                "base-arc": {
                    "radius": 68,
                    "arcWidth": 4
                },
                "ring-arc": {
                    "radius": 68,
                    "arcWidth": 4
                }
            },
            "xtra-large": {
                "jds_avatar_v2_default": {
                    "size": "xtra-large"
                },
                "base-arc": {
                    "radius": 34,
                    "arcWidth": 3
                },
                "ring-arc": {
                    "radius": 34,
                    "arcWidth": 3
                }
            },
            "large": {
                "jds_avatar_v2_default": {
                    "size": "large"
                },
                "base-arc": {
                    "radius": 30,
                    "arcWidth": 3
                },
                "ring-arc": {
                    "radius": 30,
                    "arcWidth": 3
                }
            },
            "small": {
                "jds_avatar_v2_default": {
                    "size": "small"
                },
                "base-arc": {
                    "radius": 20,
                    "arcWidth": 2
                },
                "ring-arc": {
                    "radius": 20,
                    "arcWidth": 2
                }
            },
            "xtra-small": {
                "jds_avatar_v2_default": {
                    "size": "xtra-small"
                },
                "base-arc": {
                    "radius": 16,
                    "arcWidth": 2
                },
                "ring-arc": {
                    "radius": 16,
                    "arcWidth": 2
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{opacity.disabled}"
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "size": {
                "values": [
                    "medium",
                    "xtra-xtra-large",
                    "xtra-large",
                    "large",
                    "small",
                    "xtra-small"
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds_avatar_v2_default": {
                "image": {
                    "type": "image",
                    "name": "avatarImage"
                },
                "initials": {
                    "type": "string",
                    "name": "avatarInitials"
                },
                "kind": {
                    "type": "JDSAvatarV2Default.kind",
                    "name": "avatarKind"
                }
            },
            "ring-arc": {
                "end": {
                    "type": "number",
                    "name": "progress",
                    "function": true
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "aria-label": {
                        "name": "ariaLabel",
                        "value": "Avatar with Progress Activity Ring"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$26 = (Component)=>(props)=>{
        const progress = (items)=>{
            let percent = items.progress ?? 0;
            if (percent < 0) percent = Math.abs(percent);
            if (percent > 100) percent = percent % 100;
            return percent * 3.6;
        };
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props,
            progress: progress(props)
        });
    };
const $fe5170bdd3625759$var$Component$28 = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$23;
    const { size: size = "medium", disabled: disabled = false, ariaLabel: ariaLabel = "Avatar with Progress Activity Ring", custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            size: size,
            disabled: disabled,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSAvatarV2ProgressRing", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$add0715ef3cff303 = $fe5170bdd3625759$var$withLogic$26($fe5170bdd3625759$var$Component$28);
$fe5170bdd3625759$export$add0715ef3cff303.displayName = "AvatarV2ProgressRing";
$fe5170bdd3625759$export$add0715ef3cff303.slotName = "jds_avatar_v2_progress_ring";
const $fe5170bdd3625759$var$sdl$22 = {
    "metadata": {
        "version": "1.0.0",
        "id": "avatar_segmented_ring-1.0.0",
        "name": "JDSAvatarV2SegmentedRing",
        "layerName": "jds_avatar_v2_segmented_ring",
        "internal": true
    },
    "hierarchy": {
        "container": [
            {
                "ring-container": [
                    "jds_segmented_ring_item"
                ]
            },
            "jds_avatar_v2_default"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{flexDirection.stack}",
            "justify-content": "{justifyContent.center}",
            "align-items": "{alignItems.center}",
            "opacity": "{opacity.enabled}",
            "hidden": false
        },
        "ring-container": {
            "hidden": false,
            "flex-direction": "{flexDirection.stack}",
            "justify-content": "{justifyContent.center}",
            "align-items": "{alignItems.center}",
            "z-index": 1,
            "disabled": true
        },
        "jds_segmented_ring_item": {
            "size": "medium",
            "z-index": 1
        },
        "jds_avatar_v2_default": {
            "size": "medium"
        }
    },
    "variant": {
        "size": {
            "xtra-xtra-large": {
                "jds_avatar_v2_default": {
                    "size": "xtra-xtra-large"
                },
                "jds_segmented_ring_item": {
                    "size": "xtra-xtra-large"
                }
            },
            "xtra-large": {
                "jds_avatar_v2_default": {
                    "size": "xtra-large"
                },
                "jds_segmented_ring_item": {
                    "size": "xtra-large"
                }
            },
            "large": {
                "jds_avatar_v2_default": {
                    "size": "large"
                },
                "jds_segmented_ring_item": {
                    "size": "large"
                }
            },
            "small": {
                "jds_avatar_v2_default": {
                    "size": "small"
                },
                "jds_segmented_ring_item": {
                    "size": "small"
                }
            },
            "xtra-small": {
                "jds_avatar_v2_default": {
                    "size": "xtra-small"
                },
                "jds_segmented_ring_item": {
                    "size": "xtra-small"
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{opacity.disabled}"
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "size": {
                "values": [
                    "medium",
                    "xtra-xtra-large",
                    "xtra-large",
                    "large",
                    "small",
                    "xtra-small"
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "container": {
                "_ring.startAngle": {
                    "type": "string",
                    "name": "startAngle"
                },
                "_ring.endAngle": {
                    "type": "string",
                    "name": "endAngle"
                }
            },
            "jds_avatar_v2_default": {
                "image": {
                    "type": "image",
                    "name": "avatarImage"
                },
                "initials": {
                    "type": "string",
                    "name": "avatarInitials"
                },
                "kind": {
                    "type": "JDSAvatarV2Default.kind",
                    "name": "avatarKind"
                }
            },
            "ring-container": {
                "value": {
                    "type": "list",
                    "name": "_ring",
                    "object": {
                        "startAngle": "number",
                        "endAngle": "number"
                    }
                },
                "length": {
                    "type": "number",
                    "name": "count",
                    "doc_description": "It can be used to control count of segments."
                }
            },
            "jds_segmented_ring_item": {
                "startAngle": {
                    "type": "string",
                    "name": "ring.startAngle"
                },
                "endAngle": {
                    "type": "string",
                    "name": "ring.endAngle"
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "aria-label": {
                        "name": "ariaLabel",
                        "value": "Avatar with Activity Ring"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$25 = (Component)=>(props)=>{
        const defaultRingCount = 4;
        const startAngle = (index, len)=>{
            if (len === 1) return 0;
            const gap = 5;
            const portion = 360 / len;
            return portion * index + gap;
        };
        const endAngle = (index, len)=>{
            if (len === 1) return 360;
            const gap = 5;
            const portion = 360 / len;
            return portion * (index + 1) - gap;
        };
        const ring = (item)=>{
            const rings = [];
            const len = item.count || defaultRingCount;
            for(let index = 0; index < len; index++)rings.push({
                startAngle: startAngle(index, len),
                endAngle: endAngle(index, len)
            });
            return rings;
        };
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                _ring: ring(props)
            }
        });
    };
const $fe5170bdd3625759$var$Component$27 = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$22;
    const { size: size = "medium", disabled: disabled = false, ariaLabel: ariaLabel = "Avatar with Activity Ring", custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            size: size,
            disabled: disabled,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSAvatarV2SegmentedRing", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$9b02a99b26bc2fb = $fe5170bdd3625759$var$withLogic$25($fe5170bdd3625759$var$Component$27);
$fe5170bdd3625759$export$9b02a99b26bc2fb.displayName = "AvatarV2SegmentedRing";
$fe5170bdd3625759$export$9b02a99b26bc2fb.slotName = "jds_avatar_v2_segmented_ring";
const $fe5170bdd3625759$var$sdl$21 = {
    "metadata": {
        "version": "1.0.0",
        "name": "JDSAvatarV2Status",
        "layerName": "jds_avatar_v2_status",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "jds_avatar_v2_default",
            {
                "badge-container": [
                    "jds_badge_v2"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{flexDirection.stack}",
            "justify-content": "{justifyContent.start}",
            "align-items": "{alignItems.start}",
            "opacity": "{opacity.enabled}",
            "hidden": false
        },
        "jds_avatar_v2_default": {
            "size": "medium"
        },
        "badge-container": {
            "padding-top": "{custom_11}",
            "padding-left": "{custom_11}",
            "padding-bottom": "{custom_5}",
            "z-index": 1,
            "disabled": true
        },
        "jds_badge_v2": {
            "kind": "status",
            "statusKind": "dot",
            "size": "medium"
        }
    },
    "variant": {
        "kind": {
            "icon": {
                "jds_badge_v2": {
                    "statusKind": "icon",
                    "size": "medium"
                },
                "badge-container": {
                    "padding-top": "{custom_11}",
                    "padding-left": "{custom_11}",
                    "padding-bottom": "{custom_5}"
                }
            },
            "text": {
                "jds_badge_v2": {
                    "statusKind": "label-container",
                    "size": "xtra-small"
                },
                "badge-container": {
                    "padding-top": "{l}",
                    "padding-left": "{base}",
                    "padding-bottom": "{custom_5}"
                }
            }
        },
        "size": {
            "xtra-xtra-large": {
                "jds_avatar_v2_default": {
                    "size": "xtra-xtra-large"
                },
                "badge-container": {
                    "padding-top": "{custom_7}",
                    "padding-left": "{custom_7}",
                    "padding-bottom": "{custom_5}"
                },
                "jds_badge_v2": {
                    "size": "xtra-xtra-large"
                }
            },
            "xtra-large": {
                "jds_avatar_v2_default": {
                    "size": "xtra-large"
                },
                "jds_badge_v2": {
                    "size": "large"
                },
                "badge-container": {
                    "padding-top": "{custom_10}",
                    "padding-left": "{custom_10}",
                    "padding-bottom": "{custom_5}"
                }
            },
            "large": {
                "jds_avatar_v2_default": {
                    "size": "large"
                },
                "jds_badge_v2": {
                    "size": "medium"
                },
                "badge-container": {
                    "padding-top": "{l}",
                    "padding-left": "{l}",
                    "padding-bottom": "{custom_5}"
                }
            },
            "small": {
                "jds_avatar_v2_default": {
                    "size": "small"
                },
                "jds_badge_v2": {
                    "size": "small"
                },
                "badge-container": {
                    "padding-top": "{custom_13}",
                    "padding-left": "{custom_13}",
                    "padding-bottom": "{custom_5}"
                }
            },
            "xtra-small": {
                "jds_avatar_v2_default": {
                    "size": "xtra-small"
                },
                "badge-container": {
                    "padding-top": "{base}",
                    "padding-left": "{base}",
                    "padding-bottom": "{custom_5}"
                },
                "jds_badge_v2": {
                    "size": "xtra-small"
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{opacity.disabled}"
                }
            }
        }
    },
    "combination": [
        {
            "icon": {
                "xtra-xtra-large": {
                    "bottom": {
                        "jds_badge_v2": {
                            "size": "xtra-xtra-large"
                        },
                        "badge-container": {
                            "padding-top": "{custom_7}",
                            "padding-left": "{custom_7}"
                        }
                    },
                    "top": {
                        "jds_badge_v2": {
                            "size": "xtra-xtra-large"
                        },
                        "badge-container": {
                            "padding-bottom": "{custom_7}",
                            "padding-left": "{custom_7}",
                            "padding-top": "{custom_5}"
                        }
                    }
                },
                "xtra-large": {
                    "bottom": {
                        "jds_badge_v2": {
                            "size": "large"
                        },
                        "badge-container": {
                            "padding-top": "{custom_10}",
                            "padding-left": "{custom_10}"
                        }
                    },
                    "top": {
                        "jds_badge_v2": {
                            "size": "large"
                        },
                        "badge-container": {
                            "padding-bottom": "{custom_10}",
                            "padding-left": "{custom_10}",
                            "padding-top": "{custom_5}"
                        }
                    }
                },
                "large": {
                    "bottom": {
                        "jds_badge_v2": {
                            "size": "medium"
                        },
                        "badge-container": {
                            "padding-top": "{l}",
                            "padding-left": "{l}"
                        }
                    },
                    "top": {
                        "jds_badge_v2": {
                            "size": "medium"
                        },
                        "badge-container": {
                            "padding-bottom": "{l}",
                            "padding-left": "{l}",
                            "padding-top": "{custom_5}"
                        }
                    }
                },
                "medium": {
                    "top": {
                        "jds_badge_v2": {
                            "size": "medium"
                        },
                        "badge-container": {
                            "padding-bottom": "{custom_11}",
                            "padding-left": "{custom_11}",
                            "padding-top": "{custom_5}"
                        }
                    }
                },
                "small": {
                    "bottom": {
                        "jds_badge_v2": {
                            "size": "small"
                        },
                        "badge-container": {
                            "padding-top": "{custom_13}",
                            "padding-left": "{custom_13}"
                        }
                    },
                    "top": {
                        "jds_badge_v2": {
                            "size": "small"
                        },
                        "badge-container": {
                            "padding-bottom": "{custom_13}",
                            "padding-left": "{custom_13}",
                            "padding-top": "{custom_5}"
                        }
                    }
                },
                "xtra-small": {
                    "bottom": {
                        "jds_badge_v2": {
                            "size": "xtra-small"
                        },
                        "badge-container": {
                            "padding-top": "{base}",
                            "padding-left": "{base}"
                        }
                    },
                    "top": {
                        "jds_badge_v2": {
                            "size": "xtra-small"
                        },
                        "badge-container": {
                            "padding-bottom": "{base}",
                            "padding-left": "{base}",
                            "padding-top": "{custom_5}"
                        }
                    }
                }
            },
            "dot": {
                "xtra-xtra-large": {
                    "top": {
                        "badge-container": {
                            "padding-bottom": "{custom_7}",
                            "padding-left": "{custom_7}",
                            "padding-top": "{custom_5}"
                        },
                        "jds_badge_v2": {
                            "size": "xtra-xtra-large"
                        }
                    }
                },
                "xtra-large": {
                    "top": {
                        "jds_badge_v2": {
                            "size": "large"
                        },
                        "badge-container": {
                            "padding-bottom": "{custom_10}",
                            "padding-left": "{custom_10}",
                            "padding-top": "{custom_5}"
                        }
                    }
                },
                "large": {
                    "top": {
                        "jds_badge_v2": {
                            "size": "medium"
                        },
                        "badge-container": {
                            "padding-bottom": "{l}",
                            "padding-left": "{l}",
                            "padding-top": "{custom_5}"
                        }
                    }
                },
                "medium": {
                    "top": {
                        "jds_badge_v2": {
                            "size": "medium"
                        },
                        "badge-container": {
                            "padding-bottom": "{l}",
                            "padding-left": "{custom_11}",
                            "padding-top": "{custom_5}"
                        }
                    }
                },
                "small": {
                    "top": {
                        "jds_badge_v2": {
                            "size": "small"
                        },
                        "badge-container": {
                            "padding-bottom": "{custom_13}",
                            "padding-left": "{custom_13}",
                            "padding-top": "{custom_5}"
                        }
                    }
                },
                "xtra-small": {
                    "top": {
                        "badge-container": {
                            "padding-bottom": "{base}",
                            "padding-left": "{base}",
                            "padding-top": "{custom_5}"
                        },
                        "jds_badge_v2": {
                            "size": "xtra-small"
                        }
                    }
                }
            },
            "text": {
                "xtra-xtra-large": {
                    "bottom": {
                        "jds_badge_v2": {
                            "size": "medium"
                        },
                        "badge-container": {
                            "padding-top": "{custom_7}",
                            "padding-left": "{huge}"
                        }
                    },
                    "top": {
                        "jds_badge_v2": {
                            "size": "medium"
                        },
                        "badge-container": {
                            "padding-bottom": "{custom_7}",
                            "padding-left": "{huge}",
                            "padding-top": "{custom_5}"
                        }
                    }
                },
                "xtra-large": {
                    "bottom": {
                        "jds_badge_v2": {
                            "size": "xtra-small"
                        },
                        "badge-container": {
                            "padding-top": "{xl}",
                            "padding-left": "{custom_12}"
                        }
                    },
                    "top": {
                        "jds_badge_v2": {
                            "size": "xtra-small"
                        },
                        "badge-container": {
                            "padding-bottom": "{custom_8}",
                            "padding-left": "{custom_12}",
                            "padding-top": "{custom_5}"
                        }
                    }
                },
                "large": {
                    "bottom": {
                        "jds_badge_v2": {
                            "size": "xtra-small"
                        },
                        "badge-container": {
                            "padding-top": "{custom_10}",
                            "padding-left": "{m}"
                        }
                    },
                    "top": {
                        "jds_badge_v2": {
                            "size": "xtra-small"
                        },
                        "badge-container": {
                            "padding-bottom": "{custom_20}",
                            "padding-left": "{m}",
                            "padding-top": "{custom_5}"
                        }
                    }
                },
                "medium": {
                    "top": {
                        "jds_badge_v2": {
                            "size": "xtra-small"
                        },
                        "badge-container": {
                            "padding-bottom": "{custom_8}",
                            "padding-left": "{base}",
                            "padding-top": "{custom_5}"
                        }
                    }
                },
                "small": {
                    "bottom": {
                        "container": {
                            "hidden": true
                        }
                    },
                    "top": {
                        "container": {
                            "hidden": true
                        }
                    }
                },
                "xtra-small": {
                    "bottom": {
                        "container": {
                            "hidden": true
                        }
                    },
                    "top": {
                        "container": {
                            "hidden": true
                        }
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "kind",
            "size",
            "placement"
        ]
    ],
    "api": {
        "config": {
            "kind": {
                "values": [
                    "dot",
                    "icon",
                    "text"
                ]
            },
            "size": {
                "values": [
                    "medium",
                    "xtra-xtra-large",
                    "xtra-large",
                    "large",
                    "small",
                    "xtra-small"
                ]
            },
            "placement": {
                "values": [
                    "bottom",
                    "top"
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds_avatar_v2_default": {
                "image": {
                    "type": "image",
                    "name": "avatarImage"
                },
                "initials": {
                    "type": "string",
                    "name": "avatarInitials"
                },
                "kind": {
                    "type": "JDSAvatarV2Default.kind",
                    "name": "avatarKind"
                }
            },
            "jds_badge_v2": {
                "label": {
                    "type": "string",
                    "name": "label"
                },
                "border": {
                    "type": "boolean",
                    "name": "badgeBorder"
                },
                "status": {
                    "type": "JDSBadgeV2Status.status",
                    "name": "badgeStatus"
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "aria-label": {
                        "name": "ariaLabel",
                        "value": "Avatar with Status Badge"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$24 = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$26 = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$21;
    const { kind: kind = "dot", size: size = "medium", placement: placement = "bottom", disabled: disabled = false, ariaLabel: ariaLabel = "Avatar with Status Badge", custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            size: size,
            placement: placement,
            disabled: disabled,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSAvatarV2Status", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$6c44d71f4e8d3278 = $fe5170bdd3625759$var$withLogic$24($fe5170bdd3625759$var$Component$26);
$fe5170bdd3625759$export$6c44d71f4e8d3278.displayName = "AvatarV2Status";
$fe5170bdd3625759$export$6c44d71f4e8d3278.slotName = "jds_avatar_v2_status";
const $fe5170bdd3625759$var$sdl$20 = {
    "metadata": {
        "version": "1.0.0",
        "id": "badge-1.0.0",
        "name": "JDSBadge",
        "layerName": "jds_badge",
        "description": "A Badge is used to draw attention to new or categorized content elements.",
        "usage": "Badges are not interactive. They are only used to describe a category or feature of the content they associate with."
    },
    "hierarchy": {
        "container": [
            "icon",
            "text"
        ]
    },
    "base": {
        "container": {
            "hidden": false,
            "flex-direction": "{b_0}",
            "justify-content": "{b_1}",
            "align-items": "{b_2}",
            "padding-top": "{b_3}",
            "padding-left": "{b_4}",
            "padding-right": "{b_5}",
            "padding-bottom": "{b_6}",
            "gap": "{b_7}",
            "background-color": "{b_8}",
            "border-radius": "{b_9}"
        },
        "icon": {
            "hidden": false,
            "size": "{b_10}",
            "color": "{b_11}",
            "justify-content": "{b_12}",
            "align-items": "{b_13}"
        },
        "text": {
            "hidden": false,
            "font-family": "{b_14}",
            "font-size": "{b_15}",
            "line-height": "{b_16}",
            "letter-spacing": "{b_17}",
            "font-weight": "{b_18}",
            "color": "{b_19}",
            "max-lines": 1,
            "text-transform": "{b_20}"
        }
    },
    "variant": {
        "kind": {
            "service": {
                "container": {
                    "border-radius": "{b_21}",
                    "background-color": "{b_22}",
                    "padding-top": "{b_23}",
                    "padding-left": "{b_24}",
                    "padding-right": "{b_25}",
                    "padding-bottom": "{b_26}",
                    "gap": "{b_27}"
                },
                "text": {
                    "font-family": "{b_28}",
                    "font-size": "{b_29}",
                    "line-height": "{b_30}",
                    "letter-spacing": "{b_31}",
                    "font-weight": "{b_32}",
                    "color": "{b_33}",
                    "text-transform": "{badge_variant_kind_service_text_text-transform}"
                },
                "icon": {
                    "size": "{b_34}",
                    "color": "{b_35}"
                }
            }
        },
        "_hasIcon": {
            "false": {
                "icon": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {
            "normal": {
                "small": {
                    "container": {
                        "border-radius": "{b_36}"
                    },
                    "icon": {
                        "size": "{b_37}"
                    },
                    "text": {
                        "font-family": "{b_38}",
                        "font-size": "{b_39}",
                        "line-height": "{b_40}",
                        "letter-spacing": "{b_41}",
                        "font-weight": "{b_42}"
                    }
                },
                "large": {
                    "container": {
                        "padding-left": "{b_43}",
                        "padding-right": "{b_44}",
                        "gap": "{b_45}"
                    },
                    "icon": {
                        "size": "{b_46}"
                    },
                    "text": {
                        "font-family": "{b_47}",
                        "font-size": "{b_48}",
                        "line-height": "{b_49}",
                        "letter-spacing": "{b_50}",
                        "font-weight": "{b_51}"
                    }
                }
            }
        },
        {
            "service": {
                "false": {
                    "container": {
                        "padding-left": "{b_25}",
                        "padding-right": "{b_25}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "kind",
            "size"
        ],
        [
            "kind",
            "_hasIcon"
        ]
    ],
    "api": {
        "data": {
            "text": {
                "value": {
                    "type": "string",
                    "name": "label",
                    "doc_description": "It is used to display label of badge."
                }
            },
            "icon": {
                "value": {
                    "type": "icon",
                    "name": "icon",
                    "doc_description": "It displays icon on the left with text."
                }
            }
        },
        "config": {
            "kind": {
                "values": [
                    "normal",
                    "service"
                ],
                "doc_description": "It can be used to switch between 2 variants of Badge."
            },
            "size": {
                "values": [
                    "medium",
                    "small",
                    "large"
                ],
                "doc_description": "It can be used to adjust the size of Badge."
            },
            "_hasIcon": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$modifyIcon = ({ kind: kind, icon: icon })=>{
    if (kind !== "service" || !icon) return icon;
    if (typeof icon === "string") {
        if (!icon.toString().toLowerCase().startsWith("ps")) return void 0;
        return icon;
    }
    return icon;
};
const $fe5170bdd3625759$var$withLogic$23 = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props,
            icon: $fe5170bdd3625759$var$modifyIcon(props)
        });
    };
const $fe5170bdd3625759$var$Component$25 = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$20;
    const { kind: kind = "normal", size: size = "medium", ariaLabel: ariaLabel = props.label?.toString(), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            size: size,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSBadge", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$37acb3580601e69a = $fe5170bdd3625759$var$withLogic$23($fe5170bdd3625759$var$Component$25);
$fe5170bdd3625759$export$37acb3580601e69a.displayName = "Badge";
$fe5170bdd3625759$export$37acb3580601e69a.slotName = "jds_badge";
const $fe5170bdd3625759$var$sdl$1$ = {
    "metadata": {
        "version": "2.0.0",
        "id": "badge-2.0.0",
        "name": "JDSBadgeV2",
        "layerName": "jds_badge_v2"
    },
    "hierarchy": {
        "container": [
            {
                "children-container": [
                    "children-slot"
                ]
            },
            {
                "badge-container": [
                    "jds_badge_v2_information",
                    "jds_badge_v2_brand",
                    "jds_badge_v2_notification",
                    "jds_badge_v2_status"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{flexDirection.stack}",
            "justify-content": "{justifyContent.start}",
            "align-items": "{alignItems.start}",
            "hidden": false
        },
        "badge-container": {
            "z-index": 1
        },
        "jds_badge_v2_information": {
            "hidden": true,
            "size": "medium"
        },
        "jds_badge_v2_brand": {
            "hidden": true,
            "size": "medium"
        },
        "jds_badge_v2_notification": {
            "hidden": true,
            "size": "medium"
        },
        "jds_badge_v2_status": {
            "hidden": true,
            "size": "medium"
        },
        "children-container": {
            "hidden": false,
            "z-index": 0
        }
    },
    "variant": {
        "kind": {
            "information": {
                "jds_badge_v2_information": {
                    "hidden": false
                }
            },
            "brand": {
                "jds_badge_v2_brand": {
                    "hidden": false
                }
            },
            "notification": {
                "jds_badge_v2_notification": {
                    "hidden": false
                }
            },
            "status": {
                "jds_badge_v2_status": {
                    "hidden": false
                }
            }
        },
        "placement": {
            "top": {
                "container": {
                    "justify-content": "{justifyContent.center}",
                    "align-items": "{alignItems.start}"
                }
            },
            "top_end": {
                "container": {
                    "justify-content": "{justifyContent.end}",
                    "align-items": "{alignItems.start}"
                }
            },
            "bottom_start": {
                "container": {
                    "justify-content": "{justifyContent.start}",
                    "align-items": "{alignItems.end}"
                }
            },
            "bottom": {
                "container": {
                    "justify-content": "{justifyContent.center}",
                    "align-items": "{alignItems.end}"
                }
            },
            "bottom_end": {
                "container": {
                    "justify-content": "{justifyContent.end}",
                    "align-items": "{alignItems.end}"
                }
            },
            "left": {
                "container": {
                    "justify-content": "{justifyContent.start}",
                    "align-items": "{alignItems.center}"
                }
            },
            "right": {
                "container": {
                    "justify-content": "{justifyContent.end}",
                    "align-items": "{alignItems.center}"
                }
            }
        },
        "size": {
            "xtra-small": {
                "jds_badge_v2_information": {
                    "size": "xtra-small"
                },
                "jds_badge_v2_brand": {
                    "size": "medium"
                },
                "jds_badge_v2_notification": {
                    "size": "xtra-small"
                },
                "jds_badge_v2_status": {
                    "size": "xtra-small"
                }
            },
            "small": {
                "jds_badge_v2_information": {
                    "size": "small"
                },
                "jds_badge_v2_brand": {
                    "size": "medium"
                },
                "jds_badge_v2_notification": {
                    "size": "small"
                },
                "jds_badge_v2_status": {
                    "size": "small"
                }
            },
            "large": {
                "jds_badge_v2_information": {
                    "size": "large"
                },
                "jds_badge_v2_brand": {
                    "size": "large"
                },
                "jds_badge_v2_notification": {
                    "size": "large"
                },
                "jds_badge_v2_status": {
                    "size": "large"
                }
            },
            "xtra-large": {
                "jds_badge_v2_information": {
                    "size": "xtra-large"
                },
                "jds_badge_v2_brand": {
                    "size": "xtra-large"
                },
                "jds_badge_v2_notification": {
                    "size": "xtra-large"
                },
                "jds_badge_v2_status": {
                    "size": "xtra-large"
                }
            },
            "xtra-xtra-large": {
                "jds_badge_v2_information": {
                    "size": "xtra-xtra-large"
                },
                "jds_badge_v2_brand": {
                    "size": "xtra-xtra-large"
                },
                "jds_badge_v2_notification": {
                    "size": "xtra-xtra-large"
                },
                "jds_badge_v2_status": {
                    "size": "xtra-xtra-large"
                }
            },
            "xtra-xtra-xtra-large": {
                "jds_badge_v2_information": {
                    "size": "xtra-xtra-xtra-large"
                },
                "jds_badge_v2_brand": {
                    "size": "xtra-xtra-xtra-large"
                },
                "jds_badge_v2_notification": {
                    "size": "xtra-xtra-xtra-large"
                },
                "jds_badge_v2_status": {
                    "size": "xtra-xtra-xtra-large"
                }
            },
            "xtra-xtra-xtra-xtra-large": {
                "jds_badge_v2_information": {
                    "size": "xtra-xtra-xtra-xtra-large"
                },
                "jds_badge_v2_brand": {
                    "size": "xtra-xtra-xtra-xtra-large"
                },
                "jds_badge_v2_notification": {
                    "size": "xtra-xtra-xtra-xtra-large"
                },
                "jds_badge_v2_status": {
                    "size": "xtra-xtra-xtra-xtra-large"
                }
            }
        },
        "_hasChildrenSlot": {
            "false": {
                "children-container": {
                    "hidden": true
                },
                "badge-container": {
                    "z-index": 0
                }
            }
        }
    },
    "api": {
        "config": {
            "kind": {
                "values": [
                    "information",
                    "brand",
                    "notification",
                    "status"
                ]
            },
            "placement": {
                "values": [
                    "top_start",
                    "top",
                    "top_end",
                    "bottom_start",
                    "bottom",
                    "bottom_end",
                    "left",
                    "right"
                ]
            },
            "size": {
                "values": [
                    "medium",
                    "xtra-small",
                    "small",
                    "large",
                    "xtra-large",
                    "xtra-xtra-large",
                    "xtra-xtra-xtra-large",
                    "xtra-xtra-xtra-xtra-large"
                ]
            },
            "_hasChildrenSlot": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "badge-container": {
                "translate-x": {
                    "type": "size",
                    "name": "offsetLeft"
                },
                "translate-y": {
                    "type": "size",
                    "name": "offsetTop"
                }
            },
            "jds_badge_v2_information": {
                "label": {
                    "type": "string",
                    "name": "label"
                },
                "icon": {
                    "type": "icon",
                    "name": "icon"
                },
                "background": {
                    "type": "color",
                    "name": "backgroundInfoColor"
                },
                "image": {
                    "type": "image",
                    "name": "image"
                },
                "kind": {
                    "type": "JDSBadgeV2Information.kind",
                    "name": "informationKind"
                },
                "color": {
                    "type": "JDSBadgeV2Information.color",
                    "name": "color"
                },
                "appearance": {
                    "type": "JDSBadgeV2Information.appearance",
                    "name": "appearance"
                },
                "border": {
                    "type": "boolean",
                    "name": "border"
                }
            },
            "jds_badge_v2_brand": {
                "label": {
                    "type": "string",
                    "name": "label"
                },
                "image": {
                    "type": "image",
                    "name": "image"
                },
                "kind": {
                    "type": "JDSBadgeV2Brand.kind",
                    "name": "brandKind"
                },
                "emphasis": {
                    "type": "JDSBadgeV2Brand.emphasis",
                    "name": "brandEmphasis"
                }
            },
            "jds_badge_v2_notification": {
                "label": {
                    "type": "string",
                    "name": "label"
                },
                "kind": {
                    "type": "JDSBadgeV2Notification.kind",
                    "name": "notificationKind"
                },
                "border": {
                    "type": "boolean",
                    "name": "border"
                }
            },
            "jds_badge_v2_status": {
                "label": {
                    "type": "string",
                    "name": "label"
                },
                "kind": {
                    "type": "JDSBadgeV2Status.kind",
                    "name": "statusKind"
                },
                "status": {
                    "type": "JDSBadgeV2Status.status",
                    "name": "status"
                },
                "border": {
                    "type": "boolean",
                    "name": "border"
                }
            }
        },
        "children": {
            "children-slot": {
                "name": "children",
                "accepts": [
                    "any"
                ],
                "max": 1
            }
        },
        "a11y": {
            "jds_badge_v2_information": {
                "properties": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_badge_v2_brand": {
                "properties": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_badge_v2_status": {
                "properties": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_badge_v2_notification": {
                "properties": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$22 = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                _hasChildrenSlot: Boolean(props.children)
            }
        });
    };
const $fe5170bdd3625759$var$Component$24 = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1$;
    const { kind: kind = "information", placement: placement = "top_start", size: size = "medium", custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            placement: placement,
            size: size,
            ...rest
        },
        componentTag: componentTag
    }, "JDSBadgeV2", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$561b3597d6384588 = $fe5170bdd3625759$var$withLogic$22($fe5170bdd3625759$var$Component$24);
$fe5170bdd3625759$export$561b3597d6384588.displayName = "BadgeV2";
$fe5170bdd3625759$export$561b3597d6384588.slotName = "jds_badge_v2";
const $fe5170bdd3625759$var$sdl$1_ = {
    "metadata": {
        "version": "2.0.0",
        "id": "badge-brand-2.0.0",
        "name": "JDSBadgeV2Brand",
        "layerName": "jds_badge_v2_brand",
        "internal": true
    },
    "hierarchy": {
        "container": [
            {
                "image-container": [
                    "brand-jds_image"
                ]
            },
            "label-jds-text"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{b_0}",
            "justify-content": "{b_1}",
            "align-items": "{b_2}",
            "background-color": "{b_3}",
            "gap": "{b_4}",
            "border-radius": "{b_5}",
            "padding-left": "{b_6}",
            "padding-right": "{b_7}",
            "padding-top": "{b_8}",
            "padding-bottom": "{b_9}"
        },
        "image-container": {
            "border-radius": "{b_10}",
            "size": "{b_11}",
            "overflow": "hidden"
        },
        "brand-jds_image": {
            "aspectRatio": "round",
            "roundedCorner": false
        },
        "label-jds-text": {
            "font-family": "{bodySBold}",
            "color": "{global.white}",
            "font-size": "{bodySBold}",
            "line-height": "{bodySBold}",
            "letter-spacing": "{bodySBold}",
            "font-weight": "{bodySBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false
        }
    },
    "variant": {
        "kind": {
            "circle": {
                "container": {
                    "padding-left": "{b_40}",
                    "padding-right": "{b_40}",
                    "padding-top": "{b_40}",
                    "padding-bottom": "{b_40}"
                },
                "label-jds-text": {
                    "hidden": true
                }
            },
            "square": {
                "container": {
                    "border-radius": "{b_13}",
                    "padding-left": "{b_41}",
                    "padding-right": "{b_41}",
                    "padding-top": "{b_41}",
                    "padding-bottom": "{b_41}"
                },
                "image-container": {
                    "border-radius": "{b_12}"
                },
                "brand-jds_image": {
                    "aspectRatio": "square"
                },
                "label-jds-text": {
                    "hidden": true
                }
            },
            "square-label": {
                "container": {
                    "border-radius": "{b_15}"
                },
                "image-container": {
                    "border-radius": "{b_16}"
                },
                "brand-jds_image": {
                    "aspectRatio": "square"
                }
            }
        },
        "size": {
            "medium": {
                "container": {
                    "padding-left": "{b_17}",
                    "padding-right": "{b_18}",
                    "padding-top": "{b_19}",
                    "padding-bottom": "{b_20}"
                },
                "image-container": {
                    "size": "{b_21}"
                },
                "label-jds-text": {
                    "font-family": "{bodyXxsBold}",
                    "font-size": "{bodyXxsBold}",
                    "line-height": "{bodyXxsBold}",
                    "letter-spacing": "{bodyXxsBold}",
                    "font-weight": "{bodyXxsBold}"
                }
            },
            "large": {
                "container": {
                    "padding-left": "{b_22}",
                    "padding-right": "{b_23}",
                    "padding-top": "{b_24}",
                    "padding-bottom": "{b_25}"
                },
                "image-container": {
                    "size": "{b_26}"
                },
                "label-jds-text": {
                    "font-family": "{bodyXxsBold}",
                    "font-size": "{bodyXxsBold}",
                    "line-height": "{bodyXxsBold}",
                    "letter-spacing": "{bodyXxsBold}",
                    "font-weight": "{bodyXxsBold}"
                }
            },
            "xtra-large": {
                "container": {
                    "padding-left": "{b_27}",
                    "padding-right": "{b_28}",
                    "padding-top": "{b_29}",
                    "padding-bottom": "{b_30}"
                },
                "image-container": {
                    "size": "{b_31}"
                },
                "label-jds-text": {
                    "font-family": "{bodyXsBold}",
                    "font-size": "{bodyXsBold}",
                    "line-height": "{bodyXsBold}",
                    "letter-spacing": "{bodyXsBold}",
                    "font-weight": "{bodyXsBold}"
                }
            },
            "xtra-xtra-large": {
                "container": {
                    "padding-left": "{b_32}",
                    "padding-right": "{b_33}",
                    "padding-top": "{b_34}",
                    "padding-bottom": "{b_35}"
                },
                "image-container": {
                    "size": "{b_36}"
                },
                "label-jds-text": {
                    "font-family": "{bodyXsBold}",
                    "font-size": "{bodyXsBold}",
                    "line-height": "{bodyXsBold}",
                    "letter-spacing": "{bodyXsBold}",
                    "font-weight": "{bodyXsBold}"
                }
            },
            "xtra-xtra-xtra-xtra-large": {
                "container": {
                    "gap": "{b_37}"
                },
                "image-container": {
                    "size": "{b_38}"
                },
                "label-jds-text": {
                    "font-family": "{bodyLBold}",
                    "font-size": "{bodyLBold}",
                    "line-height": "{bodyLBold}",
                    "letter-spacing": "{bodyLBold}",
                    "font-weight": "{bodyLBold}"
                }
            }
        },
        "emphasis": {
            "bold": {
                "container": {
                    "background-color": "{b_39}"
                }
            }
        }
    },
    "combination": [
        {
            "circle": {
                "medium": {
                    "container": {
                        "padding-left": "{b_42}",
                        "padding-right": "{b_42}",
                        "padding-top": "{b_42}",
                        "padding-bottom": "{b_42}"
                    },
                    "image-container": {
                        "size": "{b_43}"
                    }
                },
                "large": {
                    "container": {
                        "padding-left": "{b_44}",
                        "padding-right": "{b_44}",
                        "padding-top": "{b_44}",
                        "padding-bottom": "{b_44}"
                    },
                    "image-container": {
                        "size": "{b_45}"
                    }
                },
                "xtra-large": {
                    "container": {
                        "padding-left": "{b_46}",
                        "padding-right": "{b_46}",
                        "padding-top": "{b_46}",
                        "padding-bottom": "{b_46}"
                    },
                    "image-container": {
                        "size": "{b_47}"
                    }
                },
                "xtra-xtra-large": {
                    "container": {
                        "padding-left": "{b_48}",
                        "padding-right": "{b_48}",
                        "padding-top": "{b_48}",
                        "padding-bottom": "{b_48}"
                    },
                    "image-container": {
                        "size": "{b_49}"
                    }
                },
                "xtra-xtra-xtra-large": {
                    "image-container": {
                        "size": "{b_51}"
                    }
                },
                "xtra-xtra-xtra-xtra-large": {
                    "image-container": {
                        "size": "{b_53}"
                    }
                }
            },
            "square": {
                "medium": {
                    "container": {
                        "border-radius": "{b_54}",
                        "padding-left": "{b_55}",
                        "padding-right": "{b_55}",
                        "padding-top": "{b_55}",
                        "padding-bottom": "{b_55}"
                    },
                    "image-container": {
                        "size": "{b_56}",
                        "border-radius": "{b_57}"
                    }
                },
                "large": {
                    "container": {
                        "border-radius": "{b_58}",
                        "padding-left": "{b_59}",
                        "padding-right": "{b_59}",
                        "padding-top": "{b_59}",
                        "padding-bottom": "{b_59}"
                    },
                    "image-container": {
                        "size": "{b_60}",
                        "border-radius": "{b_61}"
                    }
                },
                "xtra-large": {
                    "container": {
                        "border-radius": "{b_62}",
                        "padding-left": "{b_63}",
                        "padding-right": "{b_63}",
                        "padding-top": "{b_63}",
                        "padding-bottom": "{b_63}"
                    },
                    "image-container": {
                        "size": "{b_64}",
                        "border-radius": "{b_65}"
                    }
                },
                "xtra-xtra-large": {
                    "container": {
                        "border-radius": "{b_66}",
                        "padding-left": "{b_67}",
                        "padding-right": "{b_67}",
                        "padding-top": "{b_67}",
                        "padding-bottom": "{b_67}"
                    },
                    "image-container": {
                        "size": "{b_68}",
                        "border-radius": "{b_69}"
                    }
                },
                "xtra-xtra-xtra-large": {
                    "image-container": {
                        "size": "{b_70}"
                    }
                },
                "xtra-xtra-xtra-xtra-large": {
                    "image-container": {
                        "size": "{b_71}"
                    }
                }
            },
            "square-label": {
                "medium": {
                    "container": {
                        "border-radius": "{b_73}"
                    }
                },
                "large": {
                    "container": {
                        "border-radius": "{b_74}",
                        "padding-right": "{b_75}"
                    }
                },
                "xtra-large": {
                    "container": {
                        "border-radius": "{b_76}",
                        "padding-right": "{b_77}"
                    }
                },
                "xtra-xtra-large": {
                    "container": {
                        "border-radius": "{b_81}",
                        "padding-left": "{b_78}"
                    },
                    "image-container": {
                        "size": "{b_79}"
                    }
                },
                "xtra-xtra-xtra-large": {
                    "container": {
                        "padding-right": "{b_80}"
                    }
                },
                "xtra-xtra-xtra-xtra-large": {
                    "container": {
                        "padding-right": "{b_82}"
                    },
                    "image-container": {
                        "border-radius": "{b_72}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "kind",
            "size"
        ]
    ],
    "api": {
        "config": {
            "kind": {
                "values": [
                    "circle-label",
                    "circle",
                    "square",
                    "square-label"
                ]
            },
            "size": {
                "values": [
                    "xtra-xtra-xtra-large",
                    "medium",
                    "large",
                    "xtra-large",
                    "xtra-xtra-large",
                    "xtra-xtra-xtra-xtra-large"
                ]
            },
            "emphasis": {
                "values": [
                    "light",
                    "bold"
                ]
            }
        },
        "data": {
            "brand-jds_image": {
                "src": {
                    "type": "image",
                    "name": "image"
                }
            },
            "label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$21 = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$23 = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1_;
    const { kind: kind = "circle-label", size: size = "xtra-xtra-xtra-large", emphasis: emphasis = "light", ariaLabel: ariaLabel = props.label?.toString(), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            size: size,
            emphasis: emphasis,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSBadgeV2Brand", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$3b623c6160d8d9d1 = $fe5170bdd3625759$var$withLogic$21($fe5170bdd3625759$var$Component$23);
$fe5170bdd3625759$export$3b623c6160d8d9d1.displayName = "BadgeV2Brand";
$fe5170bdd3625759$export$3b623c6160d8d9d1.slotName = "jds_badge_v2_brand";
const $fe5170bdd3625759$var$sdl$1Z = {
    "metadata": {
        "version": "2.0.0",
        "id": "badge-information-2.0.0",
        "name": "JDSBadgeV2Information",
        "layerName": "jds_badge_v2_information",
        "internal": true
    },
    "hierarchy": {
        "container": [
            {
                "inner-container": [
                    {
                        "image-container": [
                            "jds_image"
                        ]
                    },
                    {
                        "icon-container": [
                            "icon"
                        ]
                    },
                    "label-jds-text"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "border-radius": "{b_0}"
        },
        "inner-container": {
            "flex-direction": "{b_2}",
            "justify-content": "{b_3}",
            "align-items": "{b_4}",
            "background-color": "{b_5}",
            "gap": "{b_6}",
            "border-radius": "{b_7}",
            "padding-left": "{b_8}",
            "padding-right": "{b_9}",
            "padding-top": "{b_10}",
            "padding-bottom": "{b_11}"
        },
        "icon-container": {
            "hidden": false,
            "show": true,
            "flex-direction": "{b_12}",
            "justify-content": "{b_13}",
            "align-items": "{b_14}",
            "size": "{b_15}"
        },
        "icon": {
            "color": "{b_16}",
            "size": "{b_17}"
        },
        "image-container": {
            "hidden": true,
            "show": true,
            "flex-direction": "{b_18}",
            "justify-content": "{b_19}",
            "align-items": "{b_20}",
            "size": "{b_21}",
            "overflow": "hidden"
        },
        "jds_image": {
            "aspectRatio": "round"
        },
        "label-jds-text": {
            "font-family": "{bodyXsBold}",
            "color": "{primaryBackground}",
            "font-size": "{bodyXsBold}",
            "line-height": "{bodyXsBold}",
            "letter-spacing": "{bodyXsBold}",
            "font-weight": "{bodyXsBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false
        }
    },
    "variant": {
        "kind": {
            "label": {
                "icon-container": {
                    "hidden": true
                }
            },
            "label-image": {
                "icon-container": {
                    "hidden": true
                },
                "image-container": {
                    "hidden": false
                }
            },
            "icon": {
                "label-jds-text": {
                    "hidden": true
                }
            },
            "icon-circle": {
                "label-jds-text": {
                    "hidden": true
                }
            },
            "icon-square": {
                "label-jds-text": {
                    "hidden": true
                }
            }
        },
        "size": {
            "xtra-small": {
                "inner-container": {
                    "padding-right": "{b_25}",
                    "padding-top": "{b_26}",
                    "padding-bottom": "{b_27}"
                },
                "icon-container": {
                    "size": "{b_28}"
                },
                "icon": {
                    "size": "{b_29}"
                },
                "image-container": {
                    "size": "{b_30}"
                },
                "label-jds-text": {
                    "font-family": "{bodyXxsBold}",
                    "font-size": "{bodyXxsBold}",
                    "line-height": "{bodyXxsBold}",
                    "letter-spacing": "{bodyXxsBold}",
                    "font-weight": "{bodyXxsBold}"
                }
            },
            "small": {
                "inner-container": {
                    "padding-right": "{b_31}",
                    "padding-top": "{b_32}",
                    "padding-bottom": "{b_33}"
                },
                "icon-container": {
                    "size": "{b_34}"
                },
                "icon": {
                    "size": "{b_35}"
                },
                "image-container": {
                    "size": "{b_36}"
                },
                "label-jds-text": {
                    "font-family": "{bodyXxsBold}",
                    "font-size": "{bodyXxsBold}",
                    "line-height": "{bodyXxsBold}",
                    "letter-spacing": "{bodyXxsBold}",
                    "font-weight": "{bodyXxsBold}"
                }
            },
            "medium": {
                "inner-container": {
                    "padding-right": "{b_37}",
                    "padding-top": "{b_38}",
                    "padding-bottom": "{b_39}"
                },
                "icon-container": {
                    "size": "{b_40}"
                },
                "icon": {
                    "size": "{b_41}"
                },
                "image-container": {
                    "size": "{b_42}"
                },
                "label-jds-text": {
                    "font-family": "{bodyXxsBold}",
                    "font-size": "{bodyXxsBold}",
                    "line-height": "{bodyXxsBold}",
                    "letter-spacing": "{bodyXxsBold}",
                    "font-weight": "{bodyXxsBold}"
                }
            },
            "large": {
                "label-jds-text": {
                    "font-family": "{bodyXxsBold}",
                    "font-size": "{bodyXxsBold}",
                    "line-height": "{bodyXxsBold}",
                    "letter-spacing": "{bodyXxsBold}",
                    "font-weight": "{bodyXxsBold}"
                }
            },
            "xtra-xtra-large": {
                "inner-container": {
                    "padding-left": "{b_43}",
                    "padding-top": "{b_44}",
                    "padding-bottom": "{b_45}"
                }
            },
            "xtra-xtra-xtra-large": {
                "container": {
                    "border-radius": "{b_46}"
                },
                "inner-container": {
                    "border-radius": "{b_47}",
                    "padding-left": "{b_48}",
                    "padding-top": "{b_49}",
                    "padding-bottom": "{b_50}"
                },
                "icon-container": {
                    "size": "{b_51}"
                },
                "icon": {
                    "size": "{b_52}"
                },
                "image-container": {
                    "size": "{b_53}"
                },
                "label-jds-text": {
                    "font-family": "{bodySBold}",
                    "font-size": "{bodySBold}",
                    "line-height": "{bodySBold}",
                    "letter-spacing": "{bodySBold}",
                    "font-weight": "{bodySBold}"
                }
            },
            "xtra-xtra-xtra-xtra-large": {
                "container": {
                    "border-radius": "{b_54}"
                },
                "inner-container": {
                    "border-radius": "{b_55}",
                    "padding-left": "{b_56}",
                    "padding-right": "{b_57}",
                    "padding-top": "{b_58}",
                    "padding-bottom": "{b_59}"
                },
                "icon-container": {
                    "size": "{b_60}"
                },
                "icon": {
                    "size": "{b_61}"
                },
                "image-container": {
                    "size": "{b_62}"
                },
                "label-jds-text": {
                    "font-family": "{bodyLBold}",
                    "font-size": "{bodyLBold}",
                    "line-height": "{bodyLBold}",
                    "letter-spacing": "{bodyLBold}",
                    "font-weight": "{bodyLBold}"
                }
            }
        },
        "color": {
            "secondary": {
                "inner-container": {
                    "background-color": "{b_22}"
                },
                "icon-container": {
                    "background-color": "{b_23}"
                },
                "icon": {
                    "color": "{b_24}"
                }
            },
            "positive": {
                "inner-container": {
                    "background-color": "{b_63}"
                },
                "icon-container": {
                    "background-color": "{b_64}"
                }
            },
            "warning": {
                "inner-container": {
                    "background-color": "{b_65}"
                },
                "icon-container": {
                    "background-color": "{b_66}"
                }
            },
            "negative": {
                "inner-container": {
                    "background-color": "{b_67}"
                },
                "icon-container": {
                    "background-color": "{b_68}"
                }
            },
            "neutral": {
                "inner-container": {
                    "background-color": "{b_69}"
                },
                "icon-container": {
                    "background-color": "{b_70}"
                }
            }
        },
        "border": {
            "true": {
                "container": {
                    "background-color": "{b_72}",
                    "padding-top": "{b_71}",
                    "padding-bottom": "{b_71}",
                    "padding-left": "{b_71}",
                    "padding-right": "{b_71}"
                }
            }
        }
    },
    "combination": [
        {
            "icon": {
                "xtra-small": {
                    "inner-container": {
                        "padding-left": "{b_73}",
                        "padding-right": "{b_73}",
                        "padding-top": "{b_73}",
                        "padding-bottom": "{b_73}"
                    },
                    "icon-container": {
                        "size": "{b_74}"
                    },
                    "icon": {
                        "size": "{b_75}"
                    }
                },
                "small": {
                    "inner-container": {
                        "padding-left": "{b_76}",
                        "padding-right": "{b_76}",
                        "padding-top": "{b_76}",
                        "padding-bottom": "{b_76}"
                    },
                    "icon-container": {
                        "size": "{b_77}"
                    },
                    "icon": {
                        "size": "{b_78}"
                    }
                },
                "medium": {
                    "inner-container": {
                        "padding-left": "{b_79}",
                        "padding-right": "{b_79}",
                        "padding-top": "{b_79}",
                        "padding-bottom": "{b_79}"
                    },
                    "icon-container": {
                        "size": "{b_80}"
                    },
                    "icon": {
                        "size": "{b_81}"
                    }
                },
                "large": {
                    "inner-container": {
                        "padding-left": "{b_82}",
                        "padding-right": "{b_82}",
                        "padding-top": "{b_82}",
                        "padding-bottom": "{b_82}"
                    },
                    "icon-container": {
                        "size": "{b_87}"
                    },
                    "icon": {
                        "size": "{b_88}"
                    }
                },
                "xtra-large": {
                    "inner-container": {
                        "padding-left": "{b_83}",
                        "padding-right": "{b_83}",
                        "padding-top": "{b_83}",
                        "padding-bottom": "{b_83}"
                    },
                    "icon-container": {
                        "size": "{b_89}"
                    },
                    "icon": {
                        "size": "{b_90}"
                    }
                },
                "xtra-xtra-large": {
                    "inner-container": {
                        "padding-left": "{b_84}",
                        "padding-right": "{b_84}",
                        "padding-top": "{b_84}",
                        "padding-bottom": "{b_84}"
                    },
                    "icon-container": {
                        "size": "{b_91}"
                    },
                    "icon": {
                        "size": "{b_92}"
                    }
                },
                "xtra-xtra-xtra-large": {
                    "inner-container": {
                        "padding-left": "{b_85}",
                        "padding-right": "{b_85}",
                        "padding-top": "{b_85}",
                        "padding-bottom": "{b_85}"
                    },
                    "icon-container": {
                        "size": "{b_93}"
                    },
                    "icon": {
                        "size": "{b_94}"
                    }
                },
                "xtra-xtra-xtra-xtra-large": {
                    "inner-container": {
                        "padding-left": "{b_86}",
                        "padding-right": "{b_86}",
                        "padding-top": "{b_86}",
                        "padding-bottom": "{b_86}"
                    },
                    "icon-container": {
                        "size": "{b_95}"
                    },
                    "icon": {
                        "size": "{b_96}"
                    }
                }
            },
            "icon-circle": {
                "xtra-small": {
                    "container": {
                        "border-radius": "{b_97}"
                    },
                    "inner-container": {
                        "border-radius": "{b_98}",
                        "padding-left": "{b_99}",
                        "padding-right": "{b_99}",
                        "padding-top": "{b_99}",
                        "padding-bottom": "{b_99}"
                    },
                    "icon-container": {
                        "size": "{b_100}",
                        "border-radius": "{b_101}"
                    },
                    "icon": {
                        "size": "{b_102}"
                    }
                },
                "small": {
                    "container": {
                        "border-radius": "{b_103}"
                    },
                    "inner-container": {
                        "border-radius": "{b_104}",
                        "padding-left": "{b_105}",
                        "padding-right": "{b_105}",
                        "padding-top": "{b_105}",
                        "padding-bottom": "{b_105}"
                    },
                    "icon-container": {
                        "size": "{b_106}",
                        "border-radius": "{b_107}"
                    },
                    "icon": {
                        "size": "{b_108}"
                    }
                },
                "medium": {
                    "container": {
                        "border-radius": "{b_109}"
                    },
                    "inner-container": {
                        "border-radius": "{b_109}",
                        "padding-left": "{b_110}",
                        "padding-right": "{b_110}",
                        "padding-top": "{b_110}",
                        "padding-bottom": "{b_110}"
                    },
                    "icon-container": {
                        "size": "{b_111}",
                        "border-radius": "{b_112}"
                    },
                    "icon": {
                        "size": "{b_113}"
                    }
                },
                "large": {
                    "container": {
                        "border-radius": "{b_114}"
                    },
                    "inner-container": {
                        "border-radius": "{b_114}",
                        "padding-left": "{b_115}",
                        "padding-right": "{b_115}",
                        "padding-top": "{b_115}",
                        "padding-bottom": "{b_115}"
                    },
                    "icon-container": {
                        "size": "{b_116}",
                        "border-radius": "{b_117}"
                    },
                    "icon": {
                        "size": "{b_118}"
                    }
                },
                "xtra-large": {
                    "container": {
                        "border-radius": "{b_119}"
                    },
                    "inner-container": {
                        "border-radius": "{b_119}",
                        "padding-left": "{b_120}",
                        "padding-right": "{b_120}",
                        "padding-top": "{b_120}",
                        "padding-bottom": "{b_120}"
                    },
                    "icon-container": {
                        "size": "{b_121}",
                        "border-radius": "{b_122}"
                    },
                    "icon": {
                        "size": "{b_123}"
                    }
                },
                "xtra-xtra-large": {
                    "container": {
                        "border-radius": "{b_124}"
                    },
                    "inner-container": {
                        "border-radius": "{b_124}",
                        "padding-left": "{b_125}",
                        "padding-right": "{b_125}",
                        "padding-top": "{b_125}",
                        "padding-bottom": "{b_125}"
                    },
                    "icon-container": {
                        "size": "{b_126}",
                        "border-radius": "{b_127}"
                    },
                    "icon": {
                        "size": "{b_128}"
                    }
                },
                "xtra-xtra-xtra-large": {
                    "container": {
                        "border-radius": "{b_129}"
                    },
                    "inner-container": {
                        "border-radius": "{b_129}",
                        "padding-left": "{b_130}",
                        "padding-right": "{b_130}",
                        "padding-top": "{b_130}",
                        "padding-bottom": "{b_130}"
                    },
                    "icon-container": {
                        "size": "{b_131}",
                        "border-radius": "{b_132}"
                    },
                    "icon": {
                        "size": "{b_133}"
                    }
                },
                "xtra-xtra-xtra-xtra-large": {
                    "container": {
                        "border-radius": "{b_134}"
                    },
                    "inner-container": {
                        "border-radius": "{b_134}",
                        "padding-left": "{b_135}",
                        "padding-right": "{b_135}",
                        "padding-top": "{b_135}",
                        "padding-bottom": "{b_135}"
                    },
                    "icon-container": {
                        "size": "{b_136}",
                        "border-radius": "{b_137}"
                    },
                    "icon": {
                        "size": "{b_138}"
                    }
                }
            },
            "icon-square": {
                "xtra-small": {
                    "container": {
                        "border-radius": "{b_139}"
                    },
                    "inner-container": {
                        "border-radius": "{b_140}",
                        "padding-left": "{b_141}",
                        "padding-right": "{b_141}",
                        "padding-top": "{b_141}",
                        "padding-bottom": "{b_141}"
                    },
                    "icon-container": {
                        "size": "{b_142}",
                        "border-radius": "{b_143}"
                    },
                    "icon": {
                        "size": "{b_144}"
                    }
                },
                "small": {
                    "container": {
                        "border-radius": "{b_145}"
                    },
                    "inner-container": {
                        "border-radius": "{b_145}",
                        "padding-left": "{b_146}",
                        "padding-right": "{b_146}",
                        "padding-top": "{b_146}",
                        "padding-bottom": "{b_146}"
                    },
                    "icon-container": {
                        "size": "{b_147}",
                        "border-radius": "{b_148}"
                    },
                    "icon": {
                        "size": "{b_149}"
                    }
                },
                "medium": {
                    "container": {
                        "border-radius": "{b_150}"
                    },
                    "inner-container": {
                        "border-radius": "{b_150}",
                        "padding-left": "{b_151}",
                        "padding-right": "{b_151}",
                        "padding-top": "{b_151}",
                        "padding-bottom": "{b_151}"
                    },
                    "icon-container": {
                        "size": "{b_152}",
                        "border-radius": "{b_153}"
                    },
                    "icon": {
                        "size": "{b_154}"
                    }
                },
                "large": {
                    "container": {
                        "border-radius": "{b_155}"
                    },
                    "inner-container": {
                        "border-radius": "{b_155}",
                        "padding-left": "{b_156}",
                        "padding-right": "{b_156}",
                        "padding-top": "{b_156}",
                        "padding-bottom": "{b_156}"
                    },
                    "icon-container": {
                        "size": "{b_157}",
                        "border-radius": "{b_158}"
                    },
                    "icon": {
                        "size": "{b_159}"
                    }
                },
                "xtra-large": {
                    "container": {
                        "border-radius": "{b_160}"
                    },
                    "inner-container": {
                        "border-radius": "{b_160}",
                        "padding-left": "{b_161}",
                        "padding-right": "{b_161}",
                        "padding-top": "{b_161}",
                        "padding-bottom": "{b_161}"
                    },
                    "icon-container": {
                        "size": "{b_162}",
                        "border-radius": "{b_163}"
                    },
                    "icon": {
                        "size": "{b_164}"
                    }
                },
                "xtra-xtra-large": {
                    "container": {
                        "border-radius": "{b_165}"
                    },
                    "inner-container": {
                        "border-radius": "{b_165}",
                        "padding-left": "{b_166}",
                        "padding-right": "{b_166}",
                        "padding-top": "{b_166}",
                        "padding-bottom": "{b_166}"
                    },
                    "icon-container": {
                        "size": "{b_167}",
                        "border-radius": "{b_168}"
                    },
                    "icon": {
                        "size": "{b_169}"
                    }
                },
                "xtra-xtra-xtra-large": {
                    "container": {
                        "border-radius": "{b_170}"
                    },
                    "inner-container": {
                        "border-radius": "{b_170}",
                        "padding-left": "{b_171}",
                        "padding-right": "{b_171}",
                        "padding-top": "{b_171}",
                        "padding-bottom": "{b_171}"
                    },
                    "icon-container": {
                        "size": "{b_172}",
                        "border-radius": "{b_173}"
                    },
                    "icon": {
                        "size": "{b_174}"
                    }
                },
                "xtra-xtra-xtra-xtra-large": {
                    "container": {
                        "border-radius": "{b_175}"
                    },
                    "inner-container": {
                        "border-radius": "{b_175}",
                        "padding-left": "{b_176}",
                        "padding-right": "{b_176}",
                        "padding-top": "{b_176}",
                        "padding-bottom": "{b_176}"
                    },
                    "icon-container": {
                        "size": "{b_177}",
                        "border-radius": "{b_173}"
                    },
                    "icon": {
                        "size": "{b_179}"
                    }
                }
            },
            "label": {
                "xtra-small": {
                    "inner-container": {
                        "height": "{b_180}"
                    }
                },
                "small": {
                    "inner-container": {
                        "height": "{b_181}"
                    }
                },
                "medium": {
                    "inner-container": {
                        "height": "{b_182}"
                    }
                },
                "large": {
                    "inner-container": {
                        "height": "{b_183}",
                        "padding-left": "{b_184}"
                    }
                },
                "xtra-large": {
                    "inner-container": {
                        "height": "{b_185}",
                        "padding-left": "{b_186}"
                    }
                },
                "xtra-xtra-large": {
                    "inner-container": {
                        "height": "{b_187}"
                    }
                },
                "xtra-xtra-xtra-large": {
                    "inner-container": {
                        "height": "{b_188}"
                    }
                },
                "xtra-xtra-xtra-xtra-large": {
                    "inner-container": {
                        "height": "{b_189}",
                        "padding-left": "{b_190}"
                    }
                }
            },
            "label-icon": {
                "xtra-small": {
                    "inner-container": {
                        "height": "{b_201}"
                    }
                },
                "small": {
                    "inner-container": {
                        "height": "{b_201}"
                    }
                },
                "medium": {
                    "inner-container": {
                        "height": "{b_201}"
                    }
                },
                "large": {
                    "inner-container": {
                        "height": "{b_202}"
                    }
                },
                "xtra-large": {
                    "inner-container": {
                        "height": "{b_203}"
                    }
                },
                "xtra-xtra-large": {
                    "inner-container": {
                        "height": "{b_204}"
                    }
                },
                "xtra-xtra-xtra-large": {
                    "inner-container": {
                        "height": "{b_205}"
                    }
                },
                "xtra-xtra-xtra-xtra-large": {
                    "inner-container": {
                        "height": "{b_206}"
                    }
                }
            },
            "label-image": {
                "xtra-small": {
                    "inner-container": {
                        "height": "{b_201}"
                    }
                },
                "small": {
                    "inner-container": {
                        "height": "{b_201}"
                    }
                },
                "medium": {
                    "inner-container": {
                        "height": "{b_201}"
                    }
                },
                "large": {
                    "inner-container": {
                        "height": "{b_202}"
                    }
                },
                "xtra-large": {
                    "inner-container": {
                        "height": "{b_203}"
                    }
                },
                "xtra-xtra-large": {
                    "inner-container": {
                        "height": "{b_204}"
                    }
                },
                "xtra-xtra-xtra-large": {
                    "inner-container": {
                        "height": "{b_205}"
                    }
                },
                "xtra-xtra-xtra-xtra-large": {
                    "inner-container": {
                        "height": "{b_206}"
                    }
                }
            }
        },
        {
            "subtle": {
                "default": {
                    "inner-container": {
                        "background-color": "{b_207}"
                    },
                    "icon-container": {
                        "background-color": "{b_208}"
                    },
                    "icon": {
                        "color": "{b_209}"
                    },
                    "label-jds-text": {
                        "color": "{sparkle60}"
                    }
                },
                "secondary": {
                    "inner-container": {
                        "background-color": "{b_267}"
                    },
                    "icon-container": {
                        "background-color": "{b_268}"
                    },
                    "icon": {
                        "color": "{b_269}"
                    },
                    "label-jds-text": {
                        "color": "{secondary60}"
                    }
                },
                "positive": {
                    "inner-container": {
                        "background-color": "{b_210}"
                    },
                    "icon-container": {
                        "background-color": "{b_211}"
                    },
                    "icon": {
                        "color": "{b_212}"
                    },
                    "label-jds-text": {
                        "color": "{feedbackSuccess50}"
                    }
                },
                "warning": {
                    "inner-container": {
                        "background-color": "{b_213}"
                    },
                    "icon-container": {
                        "background-color": "{b_214}"
                    },
                    "icon": {
                        "color": "{b_215}"
                    },
                    "label-jds-text": {
                        "color": "{feedbackWarning50}"
                    }
                },
                "negative": {
                    "inner-container": {
                        "background-color": "{b_216}"
                    },
                    "icon-container": {
                        "background-color": "{b_217}"
                    },
                    "icon": {
                        "color": "{b_218}"
                    },
                    "label-jds-text": {
                        "color": "{feedbackError50}"
                    }
                },
                "neutral": {
                    "inner-container": {
                        "background-color": "{b_219}"
                    },
                    "icon-container": {
                        "background-color": "{b_220}"
                    },
                    "icon": {
                        "color": "{b_221}"
                    },
                    "label-jds-text": {
                        "color": "{primaryGrey80}"
                    }
                }
            }
        },
        {
            "icon": {
                "bold": {
                    "default": {
                        "inner-container": {
                            "background-color": "{b_222}"
                        },
                        "icon-container": {
                            "background-color": "{b_223}"
                        },
                        "icon": {
                            "color": "{b_224}"
                        }
                    },
                    "secondary": {
                        "inner-container": {
                            "background-color": "{b_264}"
                        },
                        "icon-container": {
                            "background-color": "{b_265}"
                        },
                        "icon": {
                            "color": "{b_266}"
                        }
                    },
                    "positive": {
                        "inner-container": {
                            "background-color": "{b_225}"
                        },
                        "icon-container": {
                            "background-color": "{b_226}"
                        },
                        "icon": {
                            "color": "{b_227}"
                        }
                    },
                    "warning": {
                        "inner-container": {
                            "background-color": "{b_228}"
                        },
                        "icon-container": {
                            "background-color": "{b_229}"
                        },
                        "icon": {
                            "color": "{b_230}"
                        }
                    },
                    "negative": {
                        "inner-container": {
                            "background-color": "{b_231}"
                        },
                        "icon-container": {
                            "background-color": "{b_232}"
                        },
                        "icon": {
                            "color": "{b_233}"
                        }
                    },
                    "neutral": {
                        "inner-container": {
                            "background-color": "{b_234}"
                        },
                        "icon-container": {
                            "background-color": "{b_235}"
                        },
                        "icon": {
                            "color": "{b_236}"
                        }
                    }
                },
                "subtle": {
                    "default": {
                        "inner-container": {
                            "background-color": "{b_237}"
                        },
                        "icon-container": {
                            "background-color": "{b_238}"
                        },
                        "icon": {
                            "color": "{b_239}"
                        }
                    },
                    "secondary": {
                        "inner-container": {
                            "background-color": "{b_261}"
                        },
                        "icon-container": {
                            "background-color": "{b_262}"
                        },
                        "icon": {
                            "color": "{b_263}"
                        }
                    },
                    "positive": {
                        "inner-container": {
                            "background-color": "{b_240}"
                        },
                        "icon-container": {
                            "background-color": "{b_241}"
                        },
                        "icon": {
                            "color": "{b_242}"
                        }
                    },
                    "warning": {
                        "inner-container": {
                            "background-color": "{b_243}"
                        },
                        "icon-container": {
                            "background-color": "{b_244}"
                        },
                        "icon": {
                            "color": "{b_245}"
                        }
                    },
                    "negative": {
                        "inner-container": {
                            "background-color": "{b_246}"
                        },
                        "icon-container": {
                            "background-color": "{b_247}"
                        },
                        "icon": {
                            "color": "{b_248}"
                        }
                    },
                    "neutral": {
                        "inner-container": {
                            "background-color": "{b_249}"
                        },
                        "icon-container": {
                            "background-color": "{b_250}"
                        },
                        "icon": {
                            "color": "{b_251}"
                        }
                    }
                }
            }
        },
        {
            "true": {
                "xtra-small": {
                    "container": {
                        "padding-left": "{b_252}",
                        "padding-right": "{b_252}",
                        "padding-top": "{b_252}",
                        "padding-bottom": "{b_252}"
                    }
                },
                "small": {
                    "container": {
                        "padding-left": "{b_253}",
                        "padding-right": "{b_253}",
                        "padding-top": "{b_253}",
                        "padding-bottom": "{b_253}"
                    }
                },
                "medium": {
                    "container": {
                        "padding-left": "{b_254}",
                        "padding-right": "{b_254}",
                        "padding-top": "{b_254}",
                        "padding-bottom": "{b_254}"
                    }
                },
                "large": {
                    "container": {
                        "padding-left": "{b_255}",
                        "padding-right": "{b_255}",
                        "padding-top": "{b_255}",
                        "padding-bottom": "{b_255}"
                    }
                },
                "xtra-xtra-large": {
                    "container": {
                        "padding-left": "{b_256}",
                        "padding-right": "{b_256}",
                        "padding-top": "{b_256}",
                        "padding-bottom": "{b_256}"
                    }
                },
                "xtra-xtra-xtra-large": {
                    "container": {
                        "padding-left": "{b_257}",
                        "padding-right": "{b_257}",
                        "padding-top": "{b_257}",
                        "padding-bottom": "{b_257}"
                    }
                },
                "xtra-xtra-xtra-xtra-large": {
                    "container": {
                        "padding-left": "{b_258}",
                        "padding-right": "{b_258}",
                        "padding-top": "{b_258}",
                        "padding-bottom": "{b_258}"
                    }
                }
            }
        },
        {
            "true": {
                "icon": {
                    "container": {
                        "background-color": "{b_270}",
                        "padding-top": "{b_271}",
                        "padding-bottom": "{b_271}",
                        "padding-left": "{b_271}",
                        "padding-right": "{b_271}"
                    }
                }
            }
        },
        {
            "true": {
                "icon-circle": {
                    "large": {
                        "container": {
                            "padding-left": "{b_259}",
                            "padding-right": "{b_259}",
                            "padding-top": "{b_259}",
                            "padding-bottom": "{b_259}"
                        }
                    }
                },
                "icon-square": {
                    "large": {
                        "container": {
                            "padding-left": "{b_260}",
                            "padding-right": "{b_260}",
                            "padding-top": "{b_260}",
                            "padding-bottom": "{b_260}"
                        }
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "kind",
            "size"
        ],
        [
            "appearance",
            "color"
        ],
        [
            "kind",
            "appearance",
            "color"
        ],
        [
            "border",
            "size"
        ],
        [
            "border",
            "kind"
        ],
        [
            "border",
            "kind",
            "size"
        ]
    ],
    "api": {
        "config": {
            "kind": {
                "values": [
                    "label-icon",
                    "label-image",
                    "label",
                    "icon",
                    "icon-circle",
                    "icon-square"
                ]
            },
            "size": {
                "values": [
                    "xtra-large",
                    "small",
                    "xtra-small",
                    "medium",
                    "large",
                    "xtra-xtra-large",
                    "xtra-xtra-xtra-large",
                    "xtra-xtra-xtra-xtra-large"
                ]
            },
            "color": {
                "values": [
                    "default",
                    "secondary",
                    "positive",
                    "warning",
                    "negative",
                    "neutral"
                ]
            },
            "appearance": {
                "values": [
                    "bold",
                    "subtle"
                ]
            },
            "border": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds_image": {
                "src": {
                    "type": "image",
                    "name": "image"
                }
            },
            "icon": {
                "value": {
                    "type": "icon",
                    "name": "icon"
                }
            },
            "inner-container": {
                "background-color": {
                    "type": "color",
                    "name": "background"
                }
            },
            "icon-container": {
                "background-color": {
                    "type": "color",
                    "name": "background"
                }
            },
            "label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$20 = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$22 = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1Z;
    const { kind: kind = "label-icon", size: size = "xtra-large", color: color = "default", appearance: appearance = "bold", border: border = false, ariaLabel: ariaLabel = props.label?.toString(), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            size: size,
            color: color,
            appearance: appearance,
            border: border,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSBadgeV2Information", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$50fcc0de7334f647 = $fe5170bdd3625759$var$withLogic$20($fe5170bdd3625759$var$Component$22);
$fe5170bdd3625759$export$50fcc0de7334f647.displayName = "BadgeV2Information";
$fe5170bdd3625759$export$50fcc0de7334f647.slotName = "jds_badge_v2_information";
const $fe5170bdd3625759$var$sdl$1Y = {
    "metadata": {
        "version": "2.0.0",
        "id": "badge-notification-2.0.0",
        "name": "JDSBadgeV2Notification",
        "layerName": "jds_badge_v2_notification",
        "internal": true
    },
    "hierarchy": {
        "outer-container": [
            {
                "container": [
                    {
                        "inner-container": [
                            "label-jds-text",
                            "symbol-jds-text"
                        ]
                    }
                ]
            }
        ]
    },
    "base": {
        "outer-container": {
            "width": 10,
            "height": 10,
            "justify-content": "{b_1}",
            "align-items": "{b_2}",
            "background-color": "{global.transparent}",
            "border-radius": "{b_6}"
        },
        "container": {
            "width": 8,
            "height": 8,
            "background-color": "{b_8}",
            "justify-content": "{b_1}",
            "align-items": "{b_2}",
            "border-radius": "{b_6}",
            "padding-left": "{b_7}",
            "padding-right": "{b_7}",
            "padding-top": "{b_7}",
            "padding-bottom": "{b_7}"
        },
        "inner-container": {
            "flex-direction": "{b_0}",
            "justify-content": "{b_1}",
            "align-items": "{b_2}",
            "width": 7,
            "height": 7,
            "background-color": "{b_5}",
            "border-radius": "{b_6}"
        },
        "label-jds-text": {
            "font-family": "{bodyXxsBold}",
            "color": "{global.white}",
            "font-size": "{bodyXxsBold}",
            "line-height": "{bodyXxsBold}",
            "letter-spacing": "{bodyXxsBold}",
            "font-weight": "{bodyXxsBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": true
        },
        "symbol-jds-text": {
            "font-family": "{bodyXxsBold}",
            "color": "{global.white}",
            "font-size": "{bodyXxsBold}",
            "line-height": "{bodyXxsBold}",
            "letter-spacing": "{bodyXxsBold}",
            "font-weight": "{bodyXxsBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "value": "+",
            "hidden": true,
            "text": "+"
        }
    },
    "variant": {
        "kind": {
            "dot": {
                "inner-container": {
                    "show": true
                }
            },
            "number": {
                "label-jds-text": {
                    "hidden": false
                }
            },
            "number-symbol": {
                "outer-container": {
                    "border-radius": 5,
                    "width": "",
                    "height": 18,
                    "padding-left": 1,
                    "padding-right": 1
                },
                "container": {
                    "border-radius": "{b_49}",
                    "width": "",
                    "height": 16,
                    "padding-left": 1,
                    "padding-right": 1
                },
                "inner-container": {
                    "width": "",
                    "height": 14,
                    "border-radius": "{b_49}",
                    "padding-left": 3,
                    "padding-right": 3
                },
                "label-jds-text": {
                    "hidden": false
                },
                "symbol-jds-text": {
                    "hidden": false
                }
            }
        },
        "size": {
            "small": {
                "outer-container": {
                    "width": 14,
                    "height": 14
                },
                "container": {
                    "width": 12,
                    "height": 12
                },
                "inner-container": {
                    "width": 10,
                    "height": 10
                },
                "label-jds-text": {
                    "trimLinePadding": "both"
                },
                "symbol-jds-text": {
                    "trimLinePadding": "both"
                }
            },
            "medium": {
                "outer-container": {
                    "width": 18,
                    "height": 18
                },
                "container": {
                    "width": 16,
                    "height": 16
                },
                "inner-container": {
                    "width": 13,
                    "height": 13
                },
                "label-jds-text": {
                    "trimLinePadding": "both"
                },
                "symbol-jds-text": {
                    "trimLinePadding": "both"
                }
            },
            "large": {
                "outer-container": {
                    "width": 22,
                    "height": 22
                },
                "container": {
                    "width": 20,
                    "height": 20
                },
                "inner-container": {
                    "width": 17,
                    "height": 17
                }
            },
            "xtra-large": {
                "outer-container": {
                    "width": 26,
                    "height": 26
                },
                "container": {
                    "width": 24,
                    "height": 24
                },
                "inner-container": {
                    "width": 20,
                    "height": 20
                },
                "label-jds-text": {
                    "font-family": "{bodyXsBold}",
                    "font-size": "{bodyXsBold}",
                    "line-height": "{bodyXsBold}",
                    "letter-spacing": "{bodyXsBold}",
                    "font-weight": "{bodyXsBold}"
                },
                "symbol-jds-text": {
                    "font-family": "{bodyXsBold}",
                    "font-size": "{bodyXsBold}",
                    "line-height": "{bodyXsBold}",
                    "letter-spacing": "{bodyXsBold}",
                    "font-weight": "{bodyXsBold}"
                }
            },
            "xtra-xtra-large": {
                "outer-container": {
                    "width": 30,
                    "height": 30
                },
                "container": {
                    "width": 28,
                    "height": 28
                },
                "inner-container": {
                    "width": 24,
                    "height": 24
                },
                "label-jds-text": {
                    "font-family": "{bodyXsBold}",
                    "font-size": "{bodyXsBold}",
                    "line-height": "{bodyXsBold}",
                    "letter-spacing": "{bodyXsBold}",
                    "font-weight": "{bodyXsBold}"
                },
                "symbol-jds-text": {
                    "font-family": "{bodyXsBold}",
                    "font-size": "{bodyXsBold}",
                    "line-height": "{bodyXsBold}",
                    "letter-spacing": "{bodyXsBold}",
                    "font-weight": "{bodyXsBold}"
                }
            },
            "xtra-xtra-xtra-large": {
                "outer-container": {
                    "width": 34,
                    "height": 34
                },
                "container": {
                    "width": 32,
                    "height": 32
                },
                "inner-container": {
                    "width": 27,
                    "height": 27
                },
                "label-jds-text": {
                    "font-family": "{bodySBold}",
                    "font-size": "{bodySBold}",
                    "line-height": "{bodySBold}",
                    "letter-spacing": "{bodySBold}",
                    "font-weight": "{bodySBold}"
                },
                "symbol-jds-text": {
                    "font-family": "{bodySBold}",
                    "font-size": "{bodySBold}",
                    "line-height": "{bodySBold}",
                    "letter-spacing": "{bodySBold}",
                    "font-weight": "{bodySBold}"
                }
            },
            "xtra-xtra-xtra-xtra-large": {
                "outer-container": {
                    "width": 42,
                    "height": 42
                },
                "container": {
                    "width": 40,
                    "height": 40
                },
                "inner-container": {
                    "width": 34,
                    "height": 34
                },
                "label-jds-text": {
                    "font-family": "{bodyMBold}",
                    "font-size": "{bodyMBold}",
                    "line-height": "{bodyMBold}",
                    "letter-spacing": "{bodyMBold}",
                    "font-weight": "{bodyMBold}"
                },
                "symbol-jds-text": {
                    "font-family": "{bodyMBold}",
                    "font-size": "{bodyMBold}",
                    "line-height": "{bodyMBold}",
                    "letter-spacing": "{bodyMBold}",
                    "font-weight": "{bodyMBold}"
                }
            }
        },
        "border": {
            "true": {
                "outer-container": {
                    "background-color": "{primaryBackground}"
                },
                "container": {
                    "background-color": "{b_9}"
                }
            }
        }
    },
    "combination": [
        {
            "number": {
                "xtra-small": {
                    "outer-container": {
                        "width": 18,
                        "height": 18
                    },
                    "container": {
                        "width": 16,
                        "height": 16
                    },
                    "inner-container": {
                        "width": 14,
                        "height": 14
                    }
                },
                "small": {
                    "outer-container": {
                        "width": 18,
                        "height": 18
                    },
                    "container": {
                        "width": 16,
                        "height": 16
                    },
                    "inner-container": {
                        "width": 14,
                        "height": 14
                    }
                },
                "medium": {
                    "inner-container": {
                        "width": 14,
                        "height": 14
                    }
                },
                "large": {
                    "inner-container": {
                        "width": 18,
                        "height": 18
                    }
                },
                "xtra-large": {
                    "inner-container": {
                        "width": 21,
                        "height": 21
                    }
                }
            },
            "number-symbol": {
                "small": {
                    "outer-container": {
                        "border-radius": 5,
                        "width": "",
                        "height": 18,
                        "padding-left": 1,
                        "padding-right": 1
                    },
                    "container": {
                        "border-radius": "{b_53}",
                        "width": "",
                        "height": 16,
                        "padding-left": 1,
                        "padding-right": 1
                    },
                    "inner-container": {
                        "width": "",
                        "height": 14,
                        "border-radius": "{b_53}",
                        "padding-left": 3,
                        "padding-right": 3
                    }
                },
                "medium": {
                    "outer-container": {
                        "border-radius": 5,
                        "width": "",
                        "padding-left": 1,
                        "padding-right": 1
                    },
                    "container": {
                        "border-radius": "{b_57}",
                        "width": "",
                        "padding-left": 1,
                        "padding-right": 1
                    },
                    "inner-container": {
                        "width": "",
                        "height": 14,
                        "border-radius": "{b_57}",
                        "padding-left": 3,
                        "padding-right": 3
                    }
                },
                "large": {
                    "outer-container": {
                        "border-radius": 5,
                        "width": "",
                        "height": 22,
                        "padding-left": 1,
                        "padding-right": 1
                    },
                    "container": {
                        "border-radius": "{b_61}",
                        "width": "",
                        "height": 20,
                        "padding-left": 1,
                        "padding-right": 1
                    },
                    "inner-container": {
                        "width": "",
                        "height": 18,
                        "border-radius": "{b_61}",
                        "padding-left": 5,
                        "padding-right": 3
                    }
                },
                "xtra-large": {
                    "outer-container": {
                        "border-radius": 5,
                        "width": "",
                        "height": 26,
                        "padding-left": 1,
                        "padding-right": 1
                    },
                    "container": {
                        "border-radius": "{b_65}",
                        "width": "",
                        "height": 24,
                        "padding-left": 2,
                        "padding-right": 2
                    },
                    "inner-container": {
                        "width": "",
                        "height": 20,
                        "border-radius": "{b_65}",
                        "padding-left": 4,
                        "padding-right": 4
                    }
                },
                "xtra-xtra-large": {
                    "outer-container": {
                        "border-radius": 5,
                        "width": "",
                        "height": 30,
                        "padding-left": 1,
                        "padding-right": 1
                    },
                    "container": {
                        "border-radius": "{b_69}",
                        "width": "",
                        "height": 28,
                        "padding-left": 2,
                        "padding-right": 2
                    },
                    "inner-container": {
                        "width": "",
                        "height": 24,
                        "border-radius": "{b_69}",
                        "padding-left": 5,
                        "padding-right": 3
                    }
                },
                "xtra-xtra-xtra-large": {
                    "outer-container": {
                        "border-radius": 9,
                        "width": "",
                        "height": 34,
                        "padding-left": 1,
                        "padding-right": 1
                    },
                    "container": {
                        "border-radius": "{b_73}",
                        "width": "",
                        "height": 32,
                        "padding-left": 2,
                        "padding-right": 2
                    },
                    "inner-container": {
                        "width": "",
                        "height": 28,
                        "border-radius": "{b_73}",
                        "padding-left": 5,
                        "padding-right": 5
                    }
                },
                "xtra-xtra-xtra-xtra-large": {
                    "outer-container": {
                        "border-radius": 9,
                        "width": "",
                        "height": 42,
                        "padding-left": 1,
                        "padding-right": 1
                    },
                    "container": {
                        "border-radius": "{b_77}",
                        "width": "",
                        "height": 40,
                        "padding-left": 3,
                        "padding-right": 3
                    },
                    "inner-container": {
                        "width": "",
                        "height": 34,
                        "border-radius": "{b_77}",
                        "padding-left": "{b_78}",
                        "padding-right": 6
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "kind",
            "size"
        ]
    ],
    "api": {
        "config": {
            "kind": {
                "values": [
                    "dot",
                    "number",
                    "number-symbol"
                ]
            },
            "size": {
                "values": [
                    "xtra-small",
                    "small",
                    "medium",
                    "large",
                    "xtra-large",
                    "xtra-xtra-large",
                    "xtra-xtra-xtra-large",
                    "xtra-xtra-xtra-xtra-large"
                ]
            },
            "border": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "aria-label": {
                        "name": "ariaLabel",
                        "value": "Active Notification"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1$ = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$21 = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1Y;
    const { kind: kind = "dot", size: size = "xtra-small", border: border = false, ariaLabel: ariaLabel = "Active Notification", custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            size: size,
            border: border,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSBadgeV2Notification", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$5217f316f51857f9 = $fe5170bdd3625759$var$withLogic$1$($fe5170bdd3625759$var$Component$21);
$fe5170bdd3625759$export$5217f316f51857f9.displayName = "BadgeV2Notification";
$fe5170bdd3625759$export$5217f316f51857f9.slotName = "jds_badge_v2_notification";
const $fe5170bdd3625759$var$sdl$1X = {
    "metadata": {
        "version": "2.0.0",
        "id": "badge-status-2.0.0",
        "name": "JDSBadgeV2Status",
        "layerName": "jds_badge_v2_status",
        "internal": true
    },
    "hierarchy": {
        "outer-container": [
            {
                "container": [
                    {
                        "inner-container": [
                            {
                                "status-container": [
                                    "status-icon"
                                ]
                            }
                        ]
                    },
                    "label-jds-text"
                ]
            }
        ]
    },
    "base": {
        "outer-container": {
            "width": 26,
            "height": 26,
            "justify-content": "{b_1}",
            "align-items": "{b_2}",
            "background-color": "{global.transparent}",
            "border-radius": "{b_8}"
        },
        "container": {
            "width": 24,
            "height": 24,
            "flex-direction": "{b_0}",
            "justify-content": "{b_1}",
            "align-items": "{b_2}",
            "gap": "{custom_5}"
        },
        "inner-container": {
            "width": 24,
            "height": 24,
            "justify-content": "{b_1}",
            "align-items": "{b_2}"
        },
        "status-container": {
            "width": 20,
            "height": 20,
            "hidden": false,
            "show": true,
            "flex-direction": "{b_4}",
            "justify-content": "{b_5}",
            "align-items": "{b_6}",
            "border-radius": "{b_8}",
            "background-color": "{b_9}"
        },
        "status-icon": {
            "value": "ic_message_send",
            "color": "{b_10}",
            "size": "{s}"
        },
        "label-jds-text": {
            "font-family": "{bodyXsBold}",
            "color": "{feedbackSuccess50}",
            "font-size": "{bodyXsBold}",
            "line-height": "{bodyXsBold}",
            "letter-spacing": "{bodyXsBold}",
            "font-weight": "{bodyXsBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": true
        }
    },
    "variant": {
        "kind": {
            "dot": {
                "status-icon": {
                    "hidden": true
                }
            },
            "label": {
                "outer-container": {
                    "background-color": "{global.transparent}",
                    "width": ""
                },
                "container": {
                    "width": ""
                },
                "inner-container": {
                    "hidden": true
                },
                "status-container": {
                    "hidden": true
                },
                "label-jds-text": {
                    "hidden": false
                }
            },
            "dot-label": {
                "outer-container": {
                    "border-radius": 0,
                    "width": "",
                    "height": ""
                },
                "container": {
                    "width": "",
                    "padding-top": "{custom_4}",
                    "padding-bottom": "{custom_4}",
                    "gap": 4
                },
                "inner-container": {
                    "width": 16,
                    "height": 16
                },
                "status-container": {
                    "size": "{custom_24}"
                },
                "status-icon": {
                    "hidden": true
                },
                "label-jds-text": {
                    "hidden": false
                }
            },
            "icon-label": {
                "outer-container": {
                    "border-radius": 0,
                    "width": "",
                    "height": ""
                },
                "container": {
                    "width": "",
                    "padding-top": "{custom_4}",
                    "padding-bottom": "{custom_4}",
                    "gap": 4
                },
                "inner-container": {
                    "width": 16,
                    "height": 16
                },
                "status-container": {
                    "size": "{custom_24}"
                },
                "status-icon": {
                    "size": "{xs}"
                },
                "label-jds-text": {
                    "hidden": false
                }
            },
            "label-container": {
                "outer-container": {
                    "border-radius": 6,
                    "width": "",
                    "height": 30,
                    "padding-left": 3,
                    "padding-right": 3
                },
                "container": {
                    "border-radius": "{small}",
                    "width": "",
                    "padding-left": "{xs}",
                    "padding-right": "{xs}",
                    "padding-top": "{custom_4}",
                    "padding-bottom": "{custom_4}"
                },
                "inner-container": {
                    "hidden": true
                },
                "status-container": {
                    "hidden": true
                },
                "label-jds-text": {
                    "hidden": false
                }
            },
            "dot-label-container": {
                "outer-container": {
                    "border-radius": "{small}",
                    "width": "",
                    "height": 24
                },
                "container": {
                    "border-radius": "{small}",
                    "width": "",
                    "padding-left": "{xxs}",
                    "padding-right": "{xs}",
                    "padding-top": "{custom_4}",
                    "padding-bottom": "{custom_4}",
                    "gap": 4
                },
                "status-container": {
                    "size": "{custom_24}"
                },
                "status-icon": {
                    "hidden": true
                },
                "label-jds-text": {
                    "hidden": false
                }
            },
            "icon-label-container": {
                "outer-container": {
                    "border-radius": "{small}",
                    "width": "",
                    "height": 24
                },
                "container": {
                    "border-radius": "{small}",
                    "width": "",
                    "padding-left": "{xxs}",
                    "padding-right": "{xs}",
                    "padding-top": "{custom_4}",
                    "padding-bottom": "{custom_4}",
                    "gap": 4
                },
                "status-container": {
                    "size": "{custom_24}"
                },
                "status-icon": {
                    "size": "{xs}"
                },
                "label-jds-text": {
                    "hidden": false
                }
            }
        },
        "size": {
            "xtra-small": {
                "outer-container": {
                    "width": 10,
                    "height": 10
                },
                "container": {
                    "width": 8,
                    "height": 8
                },
                "inner-container": {
                    "width": 8,
                    "height": 8
                },
                "status-container": {
                    "width": 7,
                    "height": 7
                },
                "status-icon": {
                    "size": "{xxs}"
                },
                "label-jds-text": {
                    "font-family": "{bodyXxsBold}",
                    "font-size": "{bodyXxsBold}",
                    "line-height": "{bodyXxsBold}",
                    "letter-spacing": "{bodyXxsBold}",
                    "font-weight": "{bodyXxsBold}"
                }
            },
            "small": {
                "outer-container": {
                    "width": 14,
                    "height": 14
                },
                "container": {
                    "width": 12,
                    "height": 12
                },
                "inner-container": {
                    "width": 12,
                    "height": 12
                },
                "status-container": {
                    "width": 10,
                    "height": 10
                },
                "status-icon": {
                    "size": "{custom_15}"
                },
                "label-jds-text": {
                    "font-family": "{bodyXxsBold}",
                    "font-size": "{bodyXxsBold}",
                    "line-height": "{bodyXxsBold}",
                    "letter-spacing": "{bodyXxsBold}",
                    "font-weight": "{bodyXxsBold}"
                }
            },
            "medium": {
                "outer-container": {
                    "width": 18,
                    "height": 18
                },
                "container": {
                    "width": 16,
                    "height": 16
                },
                "inner-container": {
                    "width": 16,
                    "height": 16
                },
                "status-container": {
                    "width": 13,
                    "height": 13
                },
                "status-icon": {
                    "size": "{xs}"
                },
                "label-jds-text": {
                    "font-family": "{bodyXxsBold}",
                    "font-size": "{bodyXxsBold}",
                    "line-height": "{bodyXxsBold}",
                    "letter-spacing": "{bodyXxsBold}",
                    "font-weight": "{bodyXxsBold}"
                }
            },
            "large": {
                "outer-container": {
                    "width": 22,
                    "height": 22
                },
                "container": {
                    "width": 20,
                    "height": 20
                },
                "inner-container": {
                    "width": 20,
                    "height": 20
                },
                "status-container": {
                    "width": 17,
                    "height": 17
                },
                "status-icon": {
                    "size": "{custom_19}"
                },
                "label-jds-text": {
                    "font-family": "{bodyXxsBold}",
                    "font-size": "{bodyXxsBold}",
                    "line-height": "{bodyXxsBold}",
                    "letter-spacing": "{bodyXxsBold}",
                    "font-weight": "{bodyXxsBold}"
                }
            },
            "xtra-xtra-large": {
                "outer-container": {
                    "width": 30,
                    "height": 30
                },
                "container": {
                    "width": 28,
                    "height": 28
                },
                "inner-container": {
                    "width": 28,
                    "height": 28
                },
                "status-container": {
                    "width": 23,
                    "height": 23
                },
                "status-icon": {
                    "size": "{custom_24}"
                }
            },
            "xtra-xtra-xtra-large": {
                "outer-container": {
                    "width": 34,
                    "height": 34
                },
                "container": {
                    "width": 32,
                    "height": 32
                },
                "inner-container": {
                    "width": 32,
                    "height": 32
                },
                "status-container": {
                    "width": 27,
                    "height": 27
                },
                "status-icon": {
                    "size": "{base}"
                },
                "label-jds-text": {
                    "font-family": "{bodySBold}",
                    "font-size": "{bodySBold}",
                    "line-height": "{bodySBold}",
                    "letter-spacing": "{bodySBold}",
                    "font-weight": "{bodySBold}"
                }
            },
            "xtra-xtra-xtra-xtra-large": {
                "outer-container": {
                    "width": 42,
                    "height": 42
                },
                "container": {
                    "width": 40,
                    "height": 40
                },
                "inner-container": {
                    "width": 40,
                    "height": 40
                },
                "status-container": {
                    "width": 33,
                    "height": 33
                },
                "status-icon": {
                    "size": "{custom_18}"
                },
                "label-jds-text": {
                    "font-family": "{bodyLBold}",
                    "font-size": "{bodyLBold}",
                    "line-height": "{bodyLBold}",
                    "letter-spacing": "{bodyLBold}",
                    "font-weight": "{bodyLBold}"
                }
            }
        },
        "status": {
            "error": {
                "status-container": {
                    "background-color": "{b_30}"
                },
                "status-icon": {
                    "value": "ic_close"
                },
                "label-jds-text": {
                    "color": "{feedbackError50}"
                }
            },
            "warning": {
                "status-container": {
                    "background-color": "{b_31}"
                },
                "status-icon": {
                    "value": "ic_exclamation"
                },
                "label-jds-text": {
                    "color": "{feedbackWarning50}"
                }
            },
            "disabled": {
                "container": {
                    "disabled": true
                },
                "status-container": {
                    "background-color": "{b_32}"
                },
                "status-icon": {
                    "value": "ic_close"
                },
                "label-jds-text": {
                    "color": "{primaryGrey60}"
                }
            }
        },
        "border": {
            "true": {
                "outer-container": {
                    "background-color": "{primaryBackground}"
                }
            }
        }
    },
    "combination": [
        {
            "label": {
                "xtra-small": {
                    "outer-container": {
                        "width": "",
                        "height": 18
                    },
                    "container": {
                        "width": "",
                        "height": 16
                    }
                },
                "small": {
                    "outer-container": {
                        "width": "",
                        "height": 18
                    },
                    "container": {
                        "width": "",
                        "height": 16
                    }
                },
                "medium": {
                    "outer-container": {
                        "width": ""
                    },
                    "container": {
                        "width": ""
                    }
                },
                "large": {
                    "outer-container": {
                        "width": ""
                    },
                    "container": {
                        "width": "",
                        "padding-top": 2,
                        "padding-bottom": 2
                    }
                },
                "xtra-xtra-large": {
                    "outer-container": {
                        "width": ""
                    },
                    "container": {
                        "width": ""
                    }
                },
                "xtra-xtra-xtra-large": {
                    "outer-container": {
                        "width": ""
                    },
                    "container": {
                        "width": ""
                    }
                },
                "xtra-xtra-xtra-xtra-large": {
                    "outer-container": {
                        "width": ""
                    },
                    "container": {
                        "width": ""
                    }
                }
            },
            "dot": {
                "xtra-xtra-large": {
                    "status-container": {
                        "width": 24,
                        "height": 24
                    }
                }
            },
            "dot-label": {
                "xtra-small": {
                    "outer-container": {
                        "width": "",
                        "height": ""
                    },
                    "container": {
                        "width": "",
                        "height": 16,
                        "padding-top": "{custom_5}",
                        "padding-bottom": "{custom_5}"
                    },
                    "inner-container": {
                        "width": 12,
                        "height": 12
                    },
                    "status-container": {
                        "size": "{custom_19}"
                    }
                },
                "small": {
                    "outer-container": {
                        "width": "",
                        "height": ""
                    },
                    "container": {
                        "width": "",
                        "height": 16,
                        "padding-top": "{custom_5}",
                        "padding-bottom": "{custom_5}"
                    },
                    "status-container": {
                        "size": "{custom_19}"
                    }
                },
                "medium": {
                    "outer-container": {
                        "width": "",
                        "height": ""
                    },
                    "container": {
                        "width": "",
                        "padding-top": "{custom_5}",
                        "padding-bottom": "{custom_5}"
                    },
                    "inner-container": {
                        "width": 12,
                        "height": 12
                    },
                    "status-container": {
                        "size": "{custom_19}"
                    }
                },
                "large": {
                    "outer-container": {
                        "width": "",
                        "height": ""
                    },
                    "container": {
                        "width": ""
                    },
                    "inner-container": {
                        "width": 16,
                        "height": 16
                    },
                    "status-container": {
                        "size": "{custom_24}"
                    }
                },
                "xtra-xtra-large": {
                    "outer-container": {
                        "width": "",
                        "height": ""
                    },
                    "container": {
                        "width": "",
                        "padding-top": "{xxs}",
                        "padding-bottom": "{xxs}"
                    },
                    "inner-container": {
                        "width": 16,
                        "height": 16
                    },
                    "status-container": {
                        "size": "{custom_24}"
                    }
                },
                "xtra-xtra-xtra-large": {
                    "outer-container": {
                        "width": "",
                        "height": ""
                    },
                    "container": {
                        "width": "",
                        "padding-top": "{xxs}",
                        "padding-bottom": "{xxs}"
                    },
                    "inner-container": {
                        "width": 20,
                        "height": 20
                    },
                    "status-container": {
                        "size": "{custom_22}"
                    }
                },
                "xtra-xtra-xtra-xtra-large": {
                    "outer-container": {
                        "width": "",
                        "height": ""
                    },
                    "container": {
                        "width": "",
                        "gap": "{custom_18}",
                        "padding-top": "{xxs}",
                        "padding-bottom": "{xxs}"
                    },
                    "inner-container": {
                        "width": 28,
                        "height": 28
                    },
                    "status-container": {
                        "size": "{custom_30}"
                    }
                }
            },
            "icon-label": {
                "xtra-small": {
                    "outer-container": {
                        "width": "",
                        "height": ""
                    },
                    "container": {
                        "width": "",
                        "height": 16,
                        "padding-top": "{custom_5}",
                        "padding-bottom": "{custom_5}"
                    },
                    "inner-container": {
                        "width": 12,
                        "height": 12
                    },
                    "status-container": {
                        "size": "{custom_19}"
                    },
                    "status-icon": {
                        "size": "{custom_15}"
                    }
                },
                "small": {
                    "outer-container": {
                        "width": "",
                        "height": ""
                    },
                    "container": {
                        "width": "",
                        "height": 16,
                        "padding-top": "{custom_5}",
                        "padding-bottom": "{custom_5}"
                    },
                    "status-container": {
                        "size": "{custom_19}"
                    },
                    "status-icon": {
                        "size": "{custom_15}"
                    }
                },
                "medium": {
                    "outer-container": {
                        "width": "",
                        "height": ""
                    },
                    "container": {
                        "width": "",
                        "padding-top": "{custom_5}",
                        "padding-bottom": "{custom_5}"
                    },
                    "inner-container": {
                        "width": 12,
                        "height": 12
                    },
                    "status-container": {
                        "size": "{custom_19}"
                    },
                    "status-icon": {
                        "size": "{custom_15}"
                    }
                },
                "large": {
                    "outer-container": {
                        "width": "",
                        "height": ""
                    },
                    "container": {
                        "width": ""
                    },
                    "inner-container": {
                        "width": 16,
                        "height": 16
                    },
                    "status-container": {
                        "size": "{custom_24}"
                    },
                    "status-icon": {
                        "size": "{xs}"
                    }
                },
                "xtra-xtra-large": {
                    "outer-container": {
                        "width": "",
                        "height": ""
                    },
                    "container": {
                        "width": "",
                        "padding-top": "{xxs}",
                        "padding-bottom": "{xxs}"
                    },
                    "inner-container": {
                        "width": 16,
                        "height": 16
                    },
                    "status-container": {
                        "size": "{custom_24}"
                    },
                    "status-icon": {
                        "size": "{xs}"
                    }
                },
                "xtra-xtra-xtra-large": {
                    "outer-container": {
                        "width": "",
                        "height": ""
                    },
                    "container": {
                        "width": "",
                        "padding-top": "{xxs}",
                        "padding-bottom": "{xxs}"
                    },
                    "inner-container": {
                        "width": 20,
                        "height": 20
                    },
                    "status-container": {
                        "size": "{custom_22}"
                    },
                    "status-icon": {
                        "size": "{custom_19}"
                    }
                },
                "xtra-xtra-xtra-xtra-large": {
                    "outer-container": {
                        "width": "",
                        "height": ""
                    },
                    "container": {
                        "width": "",
                        "gap": "{custom_18}",
                        "padding-top": "{xxs}",
                        "padding-bottom": "{xxs}"
                    },
                    "inner-container": {
                        "width": 28,
                        "height": 28
                    },
                    "status-container": {
                        "size": "{custom_30}"
                    },
                    "status-icon": {
                        "size": "{custom_24}"
                    }
                }
            },
            "label-container": {
                "xtra-small": {
                    "outer-container": {
                        "width": "",
                        "height": 20,
                        "padding-left": 2,
                        "padding-right": 2
                    },
                    "container": {
                        "width": "",
                        "height": 16,
                        "padding-left": "{xxs}",
                        "padding-right": "{xxs}",
                        "padding-top": "{custom_5}",
                        "padding-bottom": "{custom_5}"
                    }
                },
                "small": {
                    "outer-container": {
                        "width": "",
                        "height": 20,
                        "padding-left": 2,
                        "padding-right": 2
                    },
                    "container": {
                        "width": "",
                        "height": 16,
                        "padding-left": "{xxs}",
                        "padding-right": "{xxs}",
                        "padding-top": "{custom_5}",
                        "padding-bottom": "{custom_5}"
                    }
                },
                "medium": {
                    "outer-container": {
                        "width": "",
                        "height": 20,
                        "padding-left": 2,
                        "padding-right": 2
                    },
                    "container": {
                        "width": "",
                        "padding-left": "{xxs}",
                        "padding-right": "{xxs}",
                        "padding-top": "{custom_5}",
                        "padding-bottom": "{custom_5}"
                    }
                },
                "large": {
                    "outer-container": {
                        "width": "",
                        "height": 26
                    },
                    "container": {
                        "width": ""
                    }
                },
                "xtra-xtra-large": {
                    "outer-container": {
                        "width": "",
                        "height": 34
                    },
                    "container": {
                        "width": "",
                        "padding-top": "{xxs}",
                        "padding-bottom": "{xxs}"
                    }
                },
                "xtra-xtra-xtra-large": {
                    "outer-container": {
                        "border-radius": 10,
                        "width": "",
                        "height": 38
                    },
                    "container": {
                        "border-radius": "{medium}",
                        "width": "",
                        "padding-top": "{xxs}",
                        "padding-bottom": "{xxs}"
                    }
                },
                "xtra-xtra-xtra-xtra-large": {
                    "outer-container": {
                        "border-radius": 12,
                        "width": "",
                        "height": 48,
                        "padding-left": 4,
                        "padding-right": 4
                    },
                    "container": {
                        "border-radius": "{medium}",
                        "width": "",
                        "padding-left": "{s}",
                        "padding-right": "{s}",
                        "padding-top": "{xxs}",
                        "padding-bottom": "{xxs}"
                    }
                }
            },
            "dot-label-container": {
                "xtra-small": {
                    "outer-container": {
                        "width": "",
                        "height": 16
                    },
                    "container": {
                        "width": "",
                        "height": 16,
                        "padding-left": "{xxs}",
                        "padding-right": "{xxs}",
                        "padding-top": "{custom_5}",
                        "padding-bottom": "{custom_5}"
                    },
                    "inner-container": {
                        "width": 12,
                        "height": 12
                    },
                    "status-container": {
                        "size": "{custom_19}"
                    }
                },
                "small": {
                    "outer-container": {
                        "width": "",
                        "height": 16
                    },
                    "container": {
                        "width": "",
                        "height": 16,
                        "padding-left": "{xxs}",
                        "padding-right": "{xxs}",
                        "padding-top": "{custom_5}",
                        "padding-bottom": "{custom_5}"
                    },
                    "inner-container": {
                        "width": 12,
                        "height": 12
                    },
                    "status-container": {
                        "size": "{custom_19}"
                    }
                },
                "medium": {
                    "outer-container": {
                        "width": "",
                        "height": 16
                    },
                    "container": {
                        "width": "",
                        "padding-left": "{xxs}",
                        "padding-right": "{xxs}",
                        "padding-top": "{custom_5}",
                        "padding-bottom": "{custom_5}"
                    },
                    "inner-container": {
                        "width": 12,
                        "height": 12
                    },
                    "status-container": {
                        "size": "{custom_19}"
                    }
                },
                "large": {
                    "outer-container": {
                        "width": "",
                        "height": 20
                    },
                    "container": {
                        "width": ""
                    },
                    "status-container": {
                        "size": "{custom_24}"
                    }
                },
                "xtra-xtra-large": {
                    "outer-container": {
                        "width": "",
                        "height": 28
                    },
                    "container": {
                        "width": "",
                        "padding-left": "{xs}",
                        "padding-top": "{xxs}",
                        "padding-bottom": "{xxs}"
                    },
                    "status-container": {
                        "size": "{custom_24}"
                    }
                },
                "xtra-xtra-xtra-large": {
                    "outer-container": {
                        "border-radius": "{medium}",
                        "width": "",
                        "height": 32
                    },
                    "container": {
                        "border-radius": "{medium}",
                        "width": "",
                        "padding-left": "{xs}",
                        "padding-top": "{xxs}",
                        "padding-bottom": "{xxs}"
                    },
                    "inner-container": {
                        "width": 20,
                        "height": 20
                    },
                    "status-container": {
                        "size": "{custom_22}"
                    }
                },
                "xtra-xtra-xtra-xtra-large": {
                    "outer-container": {
                        "border-radius": "{medium}",
                        "width": "",
                        "height": 40
                    },
                    "container": {
                        "border-radius": "{medium}",
                        "width": "",
                        "padding-left": "{xs}",
                        "padding-right": "{s}",
                        "padding-top": "{xxs}",
                        "padding-bottom": "{xxs}"
                    },
                    "inner-container": {
                        "width": 28,
                        "height": 28
                    },
                    "status-container": {
                        "size": "{custom_30}"
                    }
                }
            },
            "icon-label-container": {
                "xtra-small": {
                    "outer-container": {
                        "width": "",
                        "height": 16
                    },
                    "container": {
                        "width": "",
                        "height": 16,
                        "padding-left": "{xxs}",
                        "padding-right": "{xxs}",
                        "padding-top": "{custom_5}",
                        "padding-bottom": "{custom_5}"
                    },
                    "inner-container": {
                        "width": 12,
                        "height": 12
                    },
                    "status-container": {
                        "size": "{custom_19}"
                    },
                    "status-icon": {
                        "size": "{custom_15}"
                    }
                },
                "small": {
                    "outer-container": {
                        "width": "",
                        "height": 16
                    },
                    "container": {
                        "width": "",
                        "height": 16,
                        "padding-left": "{xxs}",
                        "padding-right": "{xxs}",
                        "padding-top": "{custom_5}",
                        "padding-bottom": "{custom_5}"
                    },
                    "inner-container": {
                        "width": 12,
                        "height": 12
                    },
                    "status-container": {
                        "size": "{custom_19}"
                    },
                    "status-icon": {
                        "size": "{custom_15}"
                    }
                },
                "medium": {
                    "outer-container": {
                        "width": "",
                        "height": 16
                    },
                    "container": {
                        "width": "",
                        "padding-left": "{xxs}",
                        "padding-right": "{xxs}",
                        "padding-top": "{custom_5}",
                        "padding-bottom": "{custom_5}"
                    },
                    "inner-container": {
                        "width": 12,
                        "height": 12
                    },
                    "status-container": {
                        "size": "{custom_19}"
                    },
                    "status-icon": {
                        "size": "{custom_15}"
                    }
                },
                "large": {
                    "outer-container": {
                        "width": "",
                        "height": 20
                    },
                    "container": {
                        "width": ""
                    },
                    "status-container": {
                        "size": "{custom_24}"
                    },
                    "status-icon": {
                        "size": "{xs}"
                    }
                },
                "xtra-xtra-large": {
                    "outer-container": {
                        "width": "",
                        "height": 28
                    },
                    "container": {
                        "width": "",
                        "padding-left": "{xs}",
                        "padding-top": "{xxs}",
                        "padding-bottom": "{xxs}"
                    },
                    "status-container": {
                        "size": "{custom_24}"
                    },
                    "status-icon": {
                        "size": "{xs}"
                    }
                },
                "xtra-xtra-xtra-large": {
                    "outer-container": {
                        "border-radius": "{medium}",
                        "width": "",
                        "height": 32
                    },
                    "container": {
                        "border-radius": "{medium}",
                        "width": "",
                        "padding-left": "{xs}",
                        "padding-top": "{xxs}",
                        "padding-bottom": "{xxs}"
                    },
                    "inner-container": {
                        "width": 20,
                        "height": 20
                    },
                    "status-container": {
                        "size": "{custom_22}"
                    },
                    "status-icon": {
                        "size": "{custom_19}"
                    }
                },
                "xtra-xtra-xtra-xtra-large": {
                    "outer-container": {
                        "border-radius": "{medium}",
                        "width": "",
                        "height": 40
                    },
                    "container": {
                        "border-radius": "{medium}",
                        "width": "",
                        "padding-left": "{xs}",
                        "padding-right": "{s}",
                        "padding-top": "{xxs}",
                        "padding-bottom": "{xxs}"
                    },
                    "inner-container": {
                        "width": 28,
                        "height": 28
                    },
                    "status-container": {
                        "size": "{custom_30}"
                    },
                    "status-icon": {
                        "size": "{custom_24}"
                    }
                }
            }
        },
        {
            "label-container": {
                "success": {
                    "container": {
                        "background-color": "{b_61}"
                    },
                    "label-jds-text": {
                        "color": "{global.white}"
                    }
                },
                "error": {
                    "container": {
                        "background-color": "{b_62}"
                    },
                    "label-jds-text": {
                        "color": "{global.white}"
                    }
                },
                "warning": {
                    "container": {
                        "background-color": "{b_63}"
                    },
                    "label-jds-text": {
                        "color": "{global.white}"
                    }
                },
                "disabled": {
                    "container": {
                        "background-color": "{b_64}"
                    },
                    "label-jds-text": {
                        "color": "{global.white}"
                    }
                }
            },
            "dot-label-container": {
                "success": {
                    "container": {
                        "background-color": "{b_65}"
                    },
                    "status-container": {
                        "background-color": "{b_66}"
                    },
                    "label-jds-text": {
                        "color": "{global.white}"
                    }
                },
                "error": {
                    "container": {
                        "background-color": "{b_67}"
                    },
                    "status-container": {
                        "background-color": "{b_68}"
                    },
                    "label-jds-text": {
                        "color": "{global.white}"
                    }
                },
                "warning": {
                    "container": {
                        "background-color": "{b_69}"
                    },
                    "status-container": {
                        "background-color": "{b_70}"
                    },
                    "label-jds-text": {
                        "color": "{global.white}"
                    }
                },
                "disabled": {
                    "container": {
                        "background-color": "{b_71}"
                    },
                    "status-container": {
                        "background-color": "{b_72}"
                    },
                    "label-jds-text": {
                        "color": "{global.white}"
                    }
                }
            },
            "icon-label-container": {
                "success": {
                    "container": {
                        "background-color": "{b_73}"
                    },
                    "status-container": {
                        "background-color": "{b_74}"
                    },
                    "status-icon": {
                        "color": "{b_75}"
                    },
                    "label-jds-text": {
                        "color": "{global.white}"
                    }
                },
                "error": {
                    "container": {
                        "background-color": "{b_76}"
                    },
                    "status-container": {
                        "background-color": "{b_77}"
                    },
                    "status-icon": {
                        "color": "{b_78}"
                    },
                    "label-jds-text": {
                        "color": "{global.white}"
                    }
                },
                "warning": {
                    "container": {
                        "background-color": "{b_79}"
                    },
                    "status-container": {
                        "background-color": "{b_80}"
                    },
                    "status-icon": {
                        "color": "{b_81}"
                    },
                    "label-jds-text": {
                        "color": "{global.white}"
                    }
                },
                "disabled": {
                    "container": {
                        "background-color": "{b_82}"
                    },
                    "status-container": {
                        "background-color": "{b_83}"
                    },
                    "status-icon": {
                        "color": "{b_84}"
                    },
                    "label-jds-text": {
                        "color": "{global.white}"
                    }
                }
            }
        },
        {
            "true": {
                "label": {
                    "outer-container": {
                        "background-color": "{global.transparent}"
                    }
                },
                "dot-label": {
                    "outer-container": {
                        "background-color": "{global.transparent}"
                    }
                },
                "icon-label": {
                    "outer-container": {
                        "background-color": "{global.transparent}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "kind",
            "size"
        ],
        [
            "kind",
            "status"
        ],
        [
            "border",
            "kind"
        ]
    ],
    "api": {
        "config": {
            "kind": {
                "values": [
                    "icon",
                    "dot",
                    "label",
                    "dot-label",
                    "icon-label",
                    "label-container",
                    "dot-label-container",
                    "icon-label-container"
                ]
            },
            "size": {
                "values": [
                    "xtra-large",
                    "small",
                    "xtra-small",
                    "medium",
                    "large",
                    "xtra-xtra-large",
                    "xtra-xtra-xtra-large",
                    "xtra-xtra-xtra-xtra-large"
                ]
            },
            "status": {
                "values": [
                    "success",
                    "error",
                    "warning",
                    "disabled"
                ]
            },
            "border": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1_ = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$20 = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1X;
    const { kind: kind = "icon", size: size = "xtra-large", status: status = "success", border: border = false, ariaLabel: ariaLabel = props.label?.toString(), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            size: size,
            status: status,
            border: border,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSBadgeV2Status", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$87daca618cc26b9 = $fe5170bdd3625759$var$withLogic$1_($fe5170bdd3625759$var$Component$20);
$fe5170bdd3625759$export$87daca618cc26b9.displayName = "BadgeV2Status";
$fe5170bdd3625759$export$87daca618cc26b9.slotName = "jds_badge_v2_status";
const $fe5170bdd3625759$var$sdl$1W = {
    "metadata": {
        "version": "1.0.0",
        "id": "bottom-footer-1.0.0",
        "name": "JDSBottomFooter",
        "layerName": "jds_bottom_footer",
        "platform": "web"
    },
    "hierarchy": {
        "container": [
            {
                "copyright-container": [
                    {
                        "logo-container": [
                            {
                                "jds-icon-container": [
                                    "jds-icon"
                                ]
                            }
                        ]
                    },
                    {
                        "copyright-text-container": [
                            "jds_link",
                            "jds-text"
                        ]
                    }
                ]
            },
            {
                "informational-links-container": [
                    "jds_bottom_footer_link_item"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{b_0}",
            "justify-content": "{b_1}",
            "align-items": "{b_2}",
            "padding-top": "{b_3}",
            "padding-right": "{b_4}",
            "padding-bottom": "{b_5}",
            "padding-left": "{b_6}",
            "background": "{b_7}"
        },
        "jds_link": {
            "textAppearance": "body_xxs",
            "kind": "submenu",
            "hidden": true
        },
        "copyright-container": {
            "gap": "{b_8}",
            "flex-direction": "{b_9}",
            "align-items": "{b_10}",
            "flex": 1
        },
        "informational-links-container": {
            "flex-direction": "row",
            "align-items": "{b_11}",
            "gap": 10
        },
        "jds-text": {
            "font-family": "{bodyXxs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXxs}",
            "line-height": "{bodyXxs}",
            "letter-spacing": "{bodyXxs}",
            "font-weight": "{bodyXxs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false
        },
        "jds-icon": {
            "size": "{l}",
            "color": "{secondary50}"
        },
        "jds-icon-container": {
            "background-color": "{global.transparent}",
            "border-radius": "{pill}",
            "size": "{l}",
            "justify-content": "{justifyContent.center}",
            "align-items": "{alignItems.center}"
        }
    },
    "variant": {
        "_hasLink": {
            "true": {
                "jds_link": {
                    "hidden": false
                },
                "jds-text": {
                    "hidden": true
                }
            }
        },
        "_platform": {
            "desktop": {
                "container": {
                    "width": "{b_12}"
                }
            },
            "mobile": {
                "container": {
                    "flex-direction": "{b_13}",
                    "justify-content": "{b_14}",
                    "align-items": "{b_15}",
                    "padding-top": 0,
                    "padding-right": "{b_16}",
                    "padding-bottom": "{b_17}",
                    "padding-left": "{b_18}",
                    "gap": "{b_19}"
                },
                "copyright-container": {
                    "flex-direction": "{b_20}",
                    "align-items": "{b_21}",
                    "gap": "{b_22}"
                }
            }
        }
    },
    "api": {
        "config": {
            "_hasLink": {
                "values": [
                    true,
                    false
                ]
            },
            "_platform": {
                "values": [
                    "desktop",
                    "mobile"
                ]
            }
        },
        "data": {
            "informational-links-container": {
                "value": {
                    "name": "informationalLinks",
                    "type": "list",
                    "object": {
                        "title": "string",
                        "href": "string",
                        "separator": "boolean"
                    }
                }
            },
            "copyright-text-container": {
                "value": {
                    "name": "copyright",
                    "type": "object",
                    "object": {
                        "title": "string",
                        "href": "string",
                        "newTab": "boolean"
                    }
                }
            },
            "jds_link": {
                "title": {
                    "type": "string",
                    "name": "copyright.title"
                },
                "href": {
                    "type": "string",
                    "name": "copyright.href"
                },
                "newTab": {
                    "type": "boolean",
                    "name": "copyright.newTab"
                }
            },
            "jds_bottom_footer_link_item": {
                "title": {
                    "type": "string",
                    "name": "informationalLinks.title"
                },
                "href": {
                    "type": "string",
                    "name": "informationalLinks.href"
                },
                "newTab": {
                    "type": "boolean",
                    "name": "informationalLinks.newTab",
                    "platform": "web"
                },
                "routerLinkProps": {
                    "type": "string",
                    "name": "informationalLinks.routerLinkProps",
                    "platform": "angular"
                },
                "provider": {
                    "type": "string",
                    "name": "informationalLinks.provider",
                    "platform": "react"
                },
                "onClick": {
                    "type": "string",
                    "name": "informationalLinks.onClick"
                },
                "separator": {
                    "name": "informationalLinks.separator",
                    "type": "boolean"
                }
            },
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "copyrightText"
                }
            },
            "jds-icon": {
                "value": {
                    "type": "icon",
                    "name": "logo"
                },
                "ic": {
                    "type": "icon",
                    "name": "logo"
                }
            }
        },
        "a11y": {
            "jds_link": {
                "properties": {
                    "ariaLabel": "copyRightAriaLabel",
                    "ariaDescribedby": {
                        "name": "copyRightAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "informational-links-container": {
                "name": "informationalLinks",
                "repeating": {
                    "ariaLabel": "bottomlinkAriaLabel",
                    "ariaDescribedby": {
                        "name": "bottomlinkAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_bottom_footer_link_item": {
                "properties": {
                    "role": "informationalLinks.bottomlinkRole",
                    "ariaLabel": "informationalLinks.bottomlinkAriaLabel",
                    "ariaDescribedby": "informationalLinks.bottomlinkAriaDescribedby"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1Z = (Component)=>(props)=>{
        const length = props.informationalLinks?.length;
        const informationalLinks = props.informationalLinks?.map((item, i)=>({
                ...item,
                separator: i !== length - 1
            }));
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props,
            _hasLink: Boolean(props.copyright?.href),
            informationalLinks: informationalLinks
        });
    };
const $fe5170bdd3625759$var$Component$1$ = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1W;
    const { custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...rest,
        componentTag: componentTag
    }, "JDSBottomFooter", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$72ab4ebd04fea6e2 = $fe5170bdd3625759$var$withLogic$1Z($fe5170bdd3625759$var$Component$1$);
$fe5170bdd3625759$export$72ab4ebd04fea6e2.displayName = "BottomFooter";
$fe5170bdd3625759$export$72ab4ebd04fea6e2.slotName = "jds_bottom_footer";
const $fe5170bdd3625759$var$sdl$1V = {
    "metadata": {
        "version": "1.0.0",
        "id": "bottom-footer-link-item-1.0.0",
        "name": "JDSBottomFooterLinkItem",
        "layerName": "jds_bottom_footer_link_item",
        "platform": "web"
    },
    "hierarchy": {
        "container": [
            "jds_link",
            "jds_divider"
        ]
    },
    "base": {
        "container": {
            "gap": "{b_0}"
        },
        "jds_divider": {
            "pad": "none",
            "orientation": "vertical"
        },
        "jds_link": {
            "kind": "submenu",
            "textAppearance": "body_xxs"
        }
    },
    "variant": {
        "separator": {
            "false": {
                "jds_divider": {
                    "hidden": true
                }
            }
        }
    },
    "api": {
        "config": {
            "separator": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "jds_link": {
                "title": {
                    "type": "string",
                    "name": "title"
                },
                "href": {
                    "type": "string",
                    "name": "href"
                },
                "newTab": {
                    "type": "boolean",
                    "name": "newTab",
                    "platform": "web"
                },
                "routerLinkProps": {
                    "type": "RouterLinkProps",
                    "name": "routerLinkProps",
                    "platform": "angular"
                },
                "onClick": {
                    "type": "event",
                    "name": "onClick"
                },
                "provider": {
                    "type": "object",
                    "name": "provider",
                    "platform": "react"
                }
            }
        },
        "a11y": {
            "jds_link": {
                "properties": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1Y = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$1_ = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1V;
    const { separator: separator = true, custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            separator: separator,
            ...rest
        },
        componentTag: componentTag
    }, "JDSBottomFooterLinkItem", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$b592413d575db486 = $fe5170bdd3625759$var$withLogic$1Y($fe5170bdd3625759$var$Component$1_);
$fe5170bdd3625759$export$b592413d575db486.displayName = "BottomFooterLinkItem";
$fe5170bdd3625759$export$b592413d575db486.slotName = "jds_bottom_footer_link_item";
const $fe5170bdd3625759$var$sdl$1U = {
    "metadata": {
        "version": "1.0.0",
        "id": "bottom-navigation-item-1.0.0",
        "name": "JDSBottomNavigationItem",
        "layerName": "jds_bottom_navigation_item"
    },
    "hierarchy": {
        "container": [
            {
                "jds-icon-container": [
                    "jds-icon"
                ]
            },
            "jds-text"
        ]
    },
    "base": {
        "container": {
            "width": "{b_0}",
            "flex-direction": "{b_1}",
            "justify-content": "{b_2}",
            "align-items": "{b_3}",
            "gap": "{b_4}",
            "opacity": "{b_6}"
        },
        "jds-icon": {
            "size": "{m}",
            "color": "{primaryGrey80}"
        },
        "jds-icon-container": {
            "background-color": "{global.transparent}",
            "border-radius": "{pill}",
            "size": "{m}",
            "justify-content": "{justifyContent.center}",
            "align-items": "{alignItems.center}"
        },
        "jds-text": {
            "font-family": "{bodyXxs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXxs}",
            "line-height": "{bodyXxs}",
            "letter-spacing": "{bodyXxs}",
            "font-weight": "{bodyXxs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "text-align": "center",
            "max-lines": 1,
            "hidden": true,
            "maxLines": 1
        }
    },
    "variant": {
        "showLabel": {
            "true": {
                "jds-text": {
                    "hidden": false
                }
            }
        },
        "active": {
            "true": {
                "jds-icon": {
                    "color": "{secondary50}"
                },
                "jds-icon-container": {
                    "background-color": "{global.transparent}",
                    "border-radius": "{pill}",
                    "size": "{m}",
                    "justify-content": "{justifyContent.center}",
                    "align-items": "{alignItems.center}"
                },
                "jds-text": {
                    "color": "{primaryGrey100}"
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{b_5}"
                }
            }
        },
        "multiLine": {
            "true": {
                "jds-text": {
                    "max-lines": 2,
                    "maxLines": 2
                }
            }
        }
    },
    "api": {
        "config": {
            "showLabel": {
                "values": [
                    false,
                    true
                ]
            },
            "active": {
                "values": [
                    false,
                    true
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            },
            "multiLine": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds-icon": {
                "value": {
                    "type": "icon",
                    "name": "icon"
                },
                "ic": {
                    "type": "icon",
                    "name": "icon"
                }
            },
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            }
        },
        "events": {
            "container": {
                "onClick": "onItemClick"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "tab"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "aria-selected": {
                        "name": "_ariaSelected",
                        "prop": "active"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1X = (Component)=>({ selectedIndex: selectedIndex, internalIndex: internalIndex, ...rest })=>{
        const active = typeof selectedIndex === "number" && internalIndex === selectedIndex;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...rest,
                active: active,
                onChange: (ev)=>{
                    if (internalIndex) rest.onClick?.(ev, internalIndex);
                }
            }
        });
    };
const $fe5170bdd3625759$var$Component$1Z = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1U;
    const { showLabel: showLabel = false, active: active = false, disabled: disabled = false, multiLine: multiLine = false, onItemClick: onItemClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), ariaLabel: ariaLabel = props.label?.toString(), _ariaSelected: _ariaSelected = props.active?.toString(), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            showLabel: showLabel,
            active: active,
            disabled: disabled,
            multiLine: multiLine,
            onItemClick: onItemClick,
            ariaLabel: ariaLabel,
            _ariaSelected: _ariaSelected,
            ...rest
        },
        componentTag: componentTag
    }, "JDSBottomNavigationItem", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$f5e7567009f715b2 = $fe5170bdd3625759$var$withLogic$1X($fe5170bdd3625759$var$Component$1Z);
$fe5170bdd3625759$export$f5e7567009f715b2.displayName = "BottomNavigationItem";
$fe5170bdd3625759$export$f5e7567009f715b2.slotName = "jds_bottom_navigation_item";
const $fe5170bdd3625759$var$sdl$1T = {
    "metadata": {
        "version": "1.0.0",
        "id": "desktop-bottom-sheet-1.0.0",
        "name": "JDSDesktopBottomSheet",
        "layerName": "jds_desktop_bottom_sheet",
        "platform": "web"
    },
    "hierarchy": {
        "popup": [
            {
                "popup-container": [
                    "jds_desktop_bottom_sheet_internal"
                ]
            }
        ]
    },
    "base": {
        "popup": {
            "priority": 60,
            "passive": true
        },
        "popup-container": {
            "show": true,
            "flex-direction": "{d_0}",
            "justify-content": "{d_1}",
            "align-items": "{d_2}",
            "background-color": "{d_3}",
            "size": "{d_4}",
            "enter-animation-name": "fadeIn",
            "exit-animation-name": "fadeOut",
            "enter-animation-curve": "entrance_ease",
            "exit-animation-curve": "exit_ease",
            "enter-animation-duration": 500,
            "exit-animation-duration": 500,
            "padding-right": 90,
            "opacity": "{opacity.invisible}",
            "transition": {
                "property": [
                    "opacity"
                ],
                "duration": "{medium}",
                "timing-function": "{easeEntrance}"
            }
        },
        "jds_desktop_bottom_sheet_internal": {
            "close": true
        }
    },
    "variant": {
        "kind": {
            "passive": {
                "popup": {
                    "passive": true,
                    "background-color": "transparent"
                },
                "popup-container": {
                    "background-color": "transparent"
                }
            }
        },
        "isCustom": {
            "true": {
                "jds_desktop_bottom_sheet_internal": {
                    "isCustom": true
                }
            }
        },
        "buttonOrientation": {
            "horizontal": {
                "jds_mobile_bottom_sheet_internal": {
                    "buttonOrientation": "horizontal"
                }
            }
        },
        "close": {
            "false": {
                "popup-container": {
                    "opacity": "{opacity.enabled}",
                    "transition": {
                        "timing-function": "{easeExit}"
                    }
                },
                "jds_desktop_bottom_sheet_internal": {
                    "close": false
                }
            }
        }
    },
    "combination": [
        {
            "false": {
                "overlay": {
                    "popup": {
                        "passive": false
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "close",
            "kind"
        ]
    ],
    "api": {
        "config": {
            "kind": {
                "values": [
                    "overlay",
                    "passive"
                ]
            },
            "controlType": {
                "values": [
                    "normal",
                    "stepper"
                ]
            },
            "buttonOrientation": {
                "values": [
                    "vertical",
                    "horizontal"
                ]
            },
            "isCustom": {
                "values": [
                    false,
                    true
                ]
            },
            "close": {
                "values": [
                    true,
                    false
                ]
            },
            "primaryCtaDisabled": {
                "values": [
                    false,
                    true
                ]
            },
            "secondaryCtaDisabled": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds_desktop_bottom_sheet_internal": {
                "height": {
                    "type": "number",
                    "name": "height"
                },
                "title": {
                    "type": "string",
                    "name": "title"
                },
                "description": {
                    "type": "string",
                    "name": "description"
                },
                "primaryCTA": {
                    "type": "string",
                    "name": "primaryCTA"
                },
                "secondaryCTA": {
                    "type": "string",
                    "name": "secondaryCTA"
                },
                "step_label": {
                    "type": "string",
                    "name": "label"
                },
                "children": {
                    "name": "children",
                    "type": "slot"
                }
            }
        },
        "events": {
            "popup": {
                "onClick": "onClose"
            },
            "jds_desktop_bottom_sheet_internal": {
                "onBottomSheetClick": "_onBottomSheetClick",
                "onClose": "onClose",
                "onCancel": "onCancel",
                "onPrimaryClick": "onPrimaryClick",
                "onSecondaryClick": "onSecondaryClick",
                "onBack": "onBack"
            }
        },
        "a11y": {
            "jds_desktop_bottom_sheet_internal": {
                "properties": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "cancelButtonAriaLabel": "cancelButtonAriaLabel",
                    "backButtonAriaLabel": "backButtonAriaLabel",
                    "primaryCtaAriaLabel": "primaryCtaAriaLabel",
                    "primaryCtaAriaDescribedby": {
                        "name": "primaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    },
                    "secondaryCtaAriaLabel": "secondaryCtaAriaLabel",
                    "secondaryCtaAriaDescribedby": {
                        "name": "secondaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$WINDOW = typeof window === "object" && window || void 0;
const $fe5170bdd3625759$var$defaultBreakpoints = {
    xmobile: 323,
    mobile: 619,
    tablet: 991,
    desktop: 992,
    widescreen: 1280,
    hd: 1920
};
class $fe5170bdd3625759$var$Devices {
    static withSizes(breakpoints) {
        this.breakpoints = Object.assign(this.breakpoints, breakpoints);
        return this;
    }
    /**
   * is width xmobile and below
   */ static isXMobile() {
        const width = $fe5170bdd3625759$var$WINDOW?.innerWidth || 1e3;
        return width <= this.breakpoints.xmobile;
    }
    /**
   * is width mobile and below. returns true even on xmobile
   */ static isMobile() {
        const width = $fe5170bdd3625759$var$WINDOW?.innerWidth || 1e3;
        return width <= this.breakpoints.mobile;
    }
    /**
   * is width above mobile and below desktop
   */ static isTabletOnly() {
        const width = $fe5170bdd3625759$var$WINDOW?.innerWidth || 1e3;
        return width <= this.breakpoints.tablet && width > this.breakpoints.mobile;
    }
    /**
   * is width less than tablet? returns true even on mobile and xmobile
   */ static isTablet() {
        const width = $fe5170bdd3625759$var$WINDOW?.innerWidth || 1e3;
        return width <= this.breakpoints.tablet;
    }
    /**
   * is width greater than tablet?
   */ static isDesktop() {
        const width = $fe5170bdd3625759$var$WINDOW?.innerWidth || 1e3;
        return width >= this.breakpoints.tablet;
    }
    /**
   * is width greater than max-flex of desktop (1280px). i.e the breakpoint after which
   * max-width does not keep growing.
   */ static isWidescreen() {
        const width = $fe5170bdd3625759$var$WINDOW?.innerWidth || 0;
        return width >= this.breakpoints.widescreen;
    }
    /**
   * is width greater than or equal to HD.
   */ static isHD() {
        const width = $fe5170bdd3625759$var$WINDOW?.innerWidth || 0;
        return width >= this.breakpoints.hd;
    }
    /**
   * Re-renders functional component at Breakpoints from defaultBreakpoints.
   * @returns ```
   {
        xmobile: boolean,
        mobile: boolean,
        tablet: boolean,
        desktop: boolean,
        widescreen: boolean,
        hd: boolean
    }
   ```
   * [xmobile < mobile < tablet] [desktop > widescreen > HD]
   * tablet will be true even when xmobile and mobile are true.
   * desktop will be true even when widescreen and hd are true.
   *
   *
   * Breakpoints can be overridden by calling withSizes() first.
   * e.g. Devices.withSizes(mySize).useMedia()
   */ static useMedia() {
        const queries = [
            `(max-width: ${this.breakpoints.xmobile}px)`,
            `(max-width: ${this.breakpoints.mobile}px)`,
            `(max-width: ${this.breakpoints.tablet}px)`,
            `(min-width: ${this.breakpoints.desktop}px)`,
            `(min-width: ${this.breakpoints.widescreen}px)`,
            `(min-width: ${this.breakpoints.hd}px)`
        ];
        const mediaQueryLists = queries.map((q)=>$fe5170bdd3625759$var$WINDOW?.matchMedia && $fe5170bdd3625759$var$WINDOW.matchMedia(q));
        const getValue = ()=>{
            const matchedResults = mediaQueryLists.map((mql)=>mql?.matches);
            const valObj = {
                xmobile: false,
                mobile: false,
                tablet: false,
                desktop: false,
                widescreen: false,
                hd: false
            };
            Object.keys(this.breakpoints).forEach((key, i)=>{
                valObj[key] = matchedResults[i];
            });
            return valObj;
        };
        const [value, setValue] = (0, $acw62.useState)(getValue);
        (0, $acw62.useEffect)(()=>{
            const handler = ()=>setValue(getValue);
            mediaQueryLists.forEach((mql)=>mql?.addListener(handler));
            return ()=>mediaQueryLists.forEach((mql)=>mql?.removeListener(handler));
        }, []);
        return value;
    }
}
$fe5170bdd3625759$var$Devices.breakpoints = $fe5170bdd3625759$var$defaultBreakpoints;
const $fe5170bdd3625759$var$sdl$1S = {
    "metadata": {
        "version": "1.0.0",
        "id": "mobile-bottom-sheet-1.0.0",
        "name": "JDSMobileBottomSheet",
        "layerName": "jds_mobile_bottom_sheet"
    },
    "hierarchy": {
        "popup": [
            {
                "popup-container": [
                    "jds_mobile_bottom_sheet_internal"
                ]
            }
        ]
    },
    "base": {
        "popup": {
            "priority": 60,
            "passive": true
        },
        "popup-container": {
            "show": true,
            "flex-direction": "{m_0}",
            "justify-content": "{m_1}",
            "align-items": "{m_2}",
            "size": "{m_3}",
            "enter-animation-name": "fadeIn",
            "exit-animation-name": "fadeOut",
            "enter-animation-curve": "entrance_ease",
            "exit-animation-curve": "exit_ease",
            "enter-animation-duration": 500,
            "exit-animation-duration": 500,
            "background-color": "{m_4}",
            "opacity": "{m_5}",
            "transition": {
                "property": [
                    "opacity"
                ],
                "duration": "{m_6}",
                "timing-function": "{m_7}"
            }
        },
        "jds_mobile_bottom_sheet_internal": {
            "hidden": false
        }
    },
    "variant": {
        "kind": {
            "passive": {
                "popup": {
                    "passive": true,
                    "background-color": "{m_8}"
                },
                "popup-container": {
                    "background-color": "{m_9}"
                },
                "jds_mobile_bottom_sheet_internal": {
                    "kind": "passive"
                }
            }
        },
        "isCustom": {
            "true": {
                "jds_mobile_bottom_sheet_internal": {
                    "isCustom": true
                }
            }
        },
        "buttonOrientation": {
            "horizontal": {
                "jds_mobile_bottom_sheet_internal": {
                    "buttonOrientation": "horizontal"
                }
            }
        },
        "close": {
            "false": {
                "popup-container": {
                    "opacity": "{m_10}",
                    "transition": {
                        "timing-function": "{m_11}"
                    }
                },
                "jds_mobile_bottom_sheet_internal": {
                    "close": false
                }
            }
        },
        "controlType": {
            "stepper": {
                "jds_mobile_bottom_sheet_internal": {
                    "controlType": "stepper"
                }
            }
        },
        "primaryCtaDisabled": {
            "true": {
                "jds_mobile_bottom_sheet_internal": {
                    "primaryCtaDisabled": true
                }
            }
        },
        "secondaryCtaDisabled": {
            "true": {
                "jds_mobile_bottom_sheet_internal": {
                    "secondaryCtaDisabled": true
                }
            }
        }
    },
    "combination": [
        {
            "false": {
                "overlay": {
                    "popup": {
                        "passive": false
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "close",
            "kind"
        ]
    ],
    "api": {
        "config": {
            "kind": {
                "values": [
                    "overlay",
                    "passive"
                ]
            },
            "controlType": {
                "values": [
                    "normal",
                    "stepper"
                ]
            },
            "buttonOrientation": {
                "values": [
                    "vertical",
                    "horizontal"
                ]
            },
            "isCustom": {
                "values": [
                    false,
                    true
                ]
            },
            "close": {
                "values": [
                    true,
                    false
                ]
            },
            "primaryCtaDisabled": {
                "values": [
                    false,
                    true
                ]
            },
            "secondaryCtaDisabled": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds_mobile_bottom_sheet_internal": {
                "maxHeight": {
                    "type": "size",
                    "name": "height",
                    "function": true
                },
                "stepLabel": {
                    "type": "string",
                    "name": "label"
                },
                "title": {
                    "type": "string",
                    "name": "title"
                },
                "description": {
                    "type": "string",
                    "name": "description"
                },
                "primaryCTA": {
                    "type": "string",
                    "name": "primaryCTA"
                },
                "secondaryCTA": {
                    "type": "string",
                    "name": "secondaryCTA"
                },
                "children": {
                    "name": "children",
                    "type": "slot"
                }
            }
        },
        "events": {
            "popup": {
                "onClick": "onClose",
                "onAppear": {
                    "name": "_onAppear",
                    "platform": "ios"
                }
            },
            "jds_mobile_bottom_sheet_internal": {
                "onBottomSheetClick": "_onBottomSheetClick",
                "onClose": "onClose",
                "onBack": "onBack",
                "onCancel": "onCancel",
                "onPrimaryClick": "onPrimaryClick",
                "onSecondaryClick": "onSecondaryClick",
                "onAppear": {
                    "name": "_onContainerAppear",
                    "platform": "ios"
                }
            }
        },
        "a11y": {
            "jds_mobile_bottom_sheet_internal": {
                "properties": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "cancelButtonAriaLabel": "cancelButtonAriaLabel",
                    "backButtonAriaLabel": "backButtonAriaLabel",
                    "primaryCtaAriaLabel": "primaryCtaAriaLabel",
                    "primaryCtaAriaDescribedby": {
                        "name": "primaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    },
                    "secondaryCtaAriaLabel": "secondaryCtaAriaLabel",
                    "secondaryCtaAriaDescribedby": {
                        "name": "secondaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$useEscapeClose = (handler, condition)=>{
    const escapeListener = (0, $acw62.useCallback)(()=>handler(), [
        handler
    ]);
    (0, $acw62.useEffect)(()=>{
        document.addEventListener("keydown", (ev)=>{
            if ((condition || typeof condition === "undefined") && ev.key === "Escape") escapeListener();
        });
        return ()=>{
            document.removeEventListener("keydown", escapeListener);
        };
    }, [
        condition,
        escapeListener
    ]);
};
const $fe5170bdd3625759$var$useTransition = (externalOpen, cb, duration = 50)=>{
    const [open, setOpen] = (0, $acw62.useState)(externalOpen);
    const [internalOpen, setInternalOpen] = (0, $acw62.useState)(externalOpen);
    (0, $acw62.useEffect)(()=>{
        if (externalOpen) {
            setOpen(true);
            setTimeout(()=>{
                setInternalOpen(true);
            }, 10);
        } else {
            setOpen(false);
            setTimeout(()=>{
                setInternalOpen(false);
            }, 500);
        }
    }, [
        externalOpen
    ]);
    return {
        className: internalOpen && open ? "expanded" : "",
        open: internalOpen || open,
        close: ()=>{
            setOpen(false);
            setTimeout(()=>{
                setInternalOpen(false);
                cb?.();
            }, duration);
        }
    };
};
const $fe5170bdd3625759$var$PROP_MAP$s = (props)=>{
    return {
        primaryCTA: {
            properties: {
                primaryCTA: props.primaryCTA?.title,
                onPrimaryClick: props.primaryCTA?.onClick || props.onPrimaryClick
            }
        },
        secondaryCTA: {
            properties: {
                secondaryCTA: props.secondaryCTA?.title,
                onSecondaryClick: props.secondaryCTA?.onClick || props.onSecondaryClick
            }
        }
    };
};
const $fe5170bdd3625759$var$BOTTOMSHEET_SELECTOR$1 = "div.j-JDSMobileBottomSheetInternal-root-container";
const $fe5170bdd3625759$var$withLogic$1W = (Component)=>(userProps)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$s);
        const { close: close, onRequestClose: onRequestClose, onClose: onClose, ...rest } = props;
        const allowClose = !onRequestClose || onRequestClose();
        const { open: open, className: className, close: closeFn } = $fe5170bdd3625759$var$useTransition(Boolean(!close), ()=>{
            if (allowClose) onClose?.();
        });
        const { element: element, rootRef: rootRef } = $fe5170bdd3625759$var$useRootRef();
        const bottomsheetRef = element?.querySelector($fe5170bdd3625759$var$BOTTOMSHEET_SELECTOR$1);
        (0, $acw62.useEffect)(()=>{
            if (!close && bottomsheetRef) bottomsheetRef.focus();
        }, [
            close
        ]);
        $fe5170bdd3625759$var$useEscapeClose(closeFn, allowClose);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...rest,
                rootRef: rootRef,
                onBack: ()=>{
                    props.stepperConfig?.onBack?.(props.stepperConfig.activeStep);
                },
                label: props.stepperConfig?.indicatorText,
                _onBottomSheetClick: (ev)=>ev.stopPropagation(),
                close: !open,
                className: className,
                onCancel: ()=>{
                    if (allowClose) closeFn();
                },
                onClose: ()=>{
                    if (allowClose) closeFn();
                }
            }
        });
    };
const $fe5170bdd3625759$var$Component$1Y = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1S;
    const { kind: kind = "overlay", controlType: controlType = "normal", buttonOrientation: buttonOrientation = "vertical", isCustom: isCustom = false, close: close = true, primaryCtaDisabled: primaryCtaDisabled = false, secondaryCtaDisabled: secondaryCtaDisabled = false, onClose: onClose = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onBack: onBack = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onCancel: onCancel = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onPrimaryClick: onPrimaryClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSecondaryClick: onSecondaryClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            controlType: controlType,
            buttonOrientation: buttonOrientation,
            isCustom: isCustom,
            close: close,
            primaryCtaDisabled: primaryCtaDisabled,
            secondaryCtaDisabled: secondaryCtaDisabled,
            onClose: onClose,
            onBack: onBack,
            onCancel: onCancel,
            onPrimaryClick: onPrimaryClick,
            onSecondaryClick: onSecondaryClick,
            ...rest
        },
        componentTag: componentTag
    }, "JDSMobileBottomSheet", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$var$BottomSheet$1 = $fe5170bdd3625759$var$withLogic$1W($fe5170bdd3625759$var$Component$1Y);
$fe5170bdd3625759$var$BottomSheet$1.displayName = "BottomSheet";
$fe5170bdd3625759$var$BottomSheet$1.slotName = "jds_mobile_bottom_sheet";
const $fe5170bdd3625759$var$PROP_MAP$r = (props)=>{
    return {
        primaryCTA: {
            properties: {
                primaryCTA: $fe5170bdd3625759$var$resolvePropObjectKeys(props.primaryCTA, "title", ""),
                onPrimaryclick: props.primaryCTA?.onClick || props.onPrimaryClick
            }
        },
        secondaryCTA: {
            properties: {
                secondaryCTA: $fe5170bdd3625759$var$resolvePropObjectKeys(props.secondaryCTA, "title", ""),
                onSecondaryclick: props.secondaryCTA?.onClick || props.onSecondaryClick
            }
        }
    };
};
const $fe5170bdd3625759$var$BOTTOMSHEET_SELECTOR = "div.j-JDSDesktopBottomSheetInternal-root-container";
const $fe5170bdd3625759$var$withLogic$1V = (Component)=>(userProps)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$r);
        const { close: close, onRequestClose: onRequestClose, onClose: onClose, ...rest } = props;
        const allowClose = !onRequestClose || onRequestClose();
        const closeFn = ()=>{
            if (allowClose) onClose?.();
        };
        const { element: element, rootRef: rootRef } = $fe5170bdd3625759$var$useRootRef();
        const bottomsheetRef = element?.querySelector($fe5170bdd3625759$var$BOTTOMSHEET_SELECTOR);
        (0, $acw62.useEffect)(()=>{
            if (!close && bottomsheetRef) bottomsheetRef.focus();
        }, [
            close
        ]);
        const { mobile: mobile } = $fe5170bdd3625759$var$Devices.useMedia();
        $fe5170bdd3625759$var$useEscapeClose(closeFn, allowClose);
        if (mobile) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$var$BottomSheet$1, {
            ...userProps
        });
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...rest,
                rootRef: rootRef,
                onBack: ()=>{
                    props.stepperConfig?.onBack?.(props.stepperConfig.activeStep);
                },
                label: props.stepperConfig?.indicatorText,
                _onBottomSheetClick: (ev)=>ev.stopPropagation(),
                close: close,
                onCancel: ()=>{
                    if (allowClose) closeFn();
                },
                onClose: ()=>{
                    if (allowClose) closeFn();
                }
            }
        });
    };
const $fe5170bdd3625759$var$Component$1X = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1T;
    const { kind: kind = "overlay", controlType: controlType = "normal", buttonOrientation: buttonOrientation = "vertical", isCustom: isCustom = false, close: close = true, primaryCtaDisabled: primaryCtaDisabled = false, secondaryCtaDisabled: secondaryCtaDisabled = false, onClose: onClose = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onCancel: onCancel = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onPrimaryClick: onPrimaryClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSecondaryClick: onSecondaryClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onBack: onBack = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            controlType: controlType,
            buttonOrientation: buttonOrientation,
            isCustom: isCustom,
            close: close,
            primaryCtaDisabled: primaryCtaDisabled,
            secondaryCtaDisabled: secondaryCtaDisabled,
            onClose: onClose,
            onCancel: onCancel,
            onPrimaryClick: onPrimaryClick,
            onSecondaryClick: onSecondaryClick,
            onBack: onBack,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDesktopBottomSheet", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$2058ef1a26004a97 = $fe5170bdd3625759$var$withLogic$1V($fe5170bdd3625759$var$Component$1X);
$fe5170bdd3625759$export$2058ef1a26004a97.displayName = "BottomSheet";
$fe5170bdd3625759$export$2058ef1a26004a97.slotName = "jds_desktop_bottom_sheet";
const $fe5170bdd3625759$var$sdl$1R = {
    "metadata": {
        "version": "1.0.0",
        "id": "button-1.0.0",
        "name": "JDSButton",
        "layerName": "jds_button",
        "description": "A button is an interactive control that allows the user to perform a specific action.",
        "usage": "A button accepts a user choice, response or command."
    },
    "hierarchy": {
        "container": [
            {
                "left-container": [
                    "left-icon",
                    "jds-text"
                ]
            },
            "right-icon",
            "loader"
        ]
    },
    "base": {
        "container": {
            "opacity": "{b_0}",
            "background-color": "{b_1}",
            "flex-direction": "{b_2}",
            "align-items": "{b_3}",
            "justify-content": "{b_4}",
            "border-radius": "{b_5}",
            "border-width": "{b_6}",
            "border-color": "{b_7}",
            "gap": "{b_8}",
            "behavior": {
                "hover": {
                    "background-color": "{b_10}"
                },
                "active": {
                    "background-color": "{b_11}"
                },
                "focus": {
                    "border-width": "{b_12}",
                    "border-color": "{b_13}"
                }
            }
        },
        "left-container": {
            "hidden": false,
            "flex-direction": "{b_14}",
            "align-items": "{b_15}",
            "justify-content": "{b_16}",
            "gap": "{b_17}",
            "flex-fill-android": false
        },
        "loader": {
            "color": "{b_18}",
            "background-color": "{b_19}",
            "border-width": "{b_20}",
            "hidden": true,
            "opacity": "{b_21}",
            "size": "{b_22}"
        },
        "left-icon": {
            "size": "{b_23}",
            "color": "{b_24}",
            "hidden": false
        },
        "right-icon": {
            "size": "{b_25}",
            "color": "{b_26}",
            "hidden": false
        },
        "jds-text": {
            "font-family": "{button}",
            "color": "{primaryInverse}",
            "font-size": "{button}",
            "line-height": "{button}",
            "letter-spacing": "{button}",
            "font-weight": "{button}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "language": "en"
        }
    },
    "variant": {
        "_hasLabel": {
            "false": {
                "left-container": {
                    "hidden": true
                }
            }
        },
        "fullWidth": {
            "true": {
                "container": {
                    "justify-content": "{b_28}",
                    "width": "{b_27}",
                    "gap": 0
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{b_29}"
                }
            }
        },
        "loading": {
            "true": {
                "container": {
                    "disabled": true
                },
                "loader": {
                    "hidden": false
                },
                "right-icon": {
                    "hidden": true
                }
            }
        },
        "_hasRightIcon": {
            "false": {
                "right-icon": {
                    "hidden": true
                }
            }
        },
        "_hasLeftIcon": {
            "false": {
                "left-icon": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {
            "primary": {
                "normal": {
                    "left-icon": {
                        "behavior": {
                            "active": {
                                "color": "{b_30}"
                            }
                        }
                    },
                    "right-icon": {
                        "behavior": {
                            "active": {
                                "color": "{b_31}"
                            }
                        }
                    },
                    "jds-text": {
                        "behavior": {
                            "hover": {},
                            "active": {
                                "color": "{primary30}"
                            }
                        }
                    }
                },
                "destructive": {
                    "container": {
                        "background-color": "{b_32}",
                        "behavior": {
                            "hover": {
                                "background-color": "{b_33}"
                            },
                            "active": {
                                "background-color": "{b_34}"
                            },
                            "focus": {
                                "border-color": "{b_35}"
                            }
                        }
                    },
                    "loader": {
                        "color": "{b_36}"
                    },
                    "left-icon": {
                        "color": "{b_37}",
                        "behavior": {
                            "hover": {
                                "color": "{b_38}"
                            },
                            "active": {
                                "color": "{b_39}"
                            }
                        }
                    },
                    "right-icon": {
                        "color": "{b_41}",
                        "behavior": {
                            "hover": {
                                "color": "{b_40}"
                            },
                            "active": {
                                "color": "{b_42}"
                            }
                        }
                    },
                    "jds-text": {
                        "color": "{feedbackError80}",
                        "behavior": {
                            "hover": {
                                "color": "{global.white}"
                            },
                            "active": {
                                "color": "{feedbackError20}"
                            }
                        }
                    }
                },
                "positive": {
                    "container": {
                        "background-color": "{b_43}",
                        "behavior": {
                            "hover": {
                                "background-color": "{b_44}"
                            },
                            "active": {
                                "background-color": "{b_45}"
                            },
                            "focus": {
                                "border-color": "{b_46}"
                            }
                        }
                    },
                    "loader": {
                        "color": "{b_47}"
                    },
                    "left-icon": {
                        "color": "{b_48}",
                        "behavior": {
                            "hover": {
                                "color": "{b_49}"
                            },
                            "active": {
                                "color": "{b_50}"
                            }
                        }
                    },
                    "right-icon": {
                        "color": "{b_51}",
                        "behavior": {
                            "hover": {
                                "color": "{b_52}"
                            },
                            "active": {
                                "color": "{b_53}"
                            }
                        }
                    },
                    "jds-text": {
                        "color": "{feedbackSuccess80}",
                        "behavior": {
                            "hover": {
                                "color": "{global.white}"
                            },
                            "active": {
                                "color": "{feedbackSuccess20}"
                            }
                        }
                    }
                }
            },
            "secondary": {
                "normal": {
                    "container": {
                        "background-color": "{b_54}",
                        "border-width": "{b_55}",
                        "border-color": "{b_56}",
                        "behavior": {
                            "hover": {
                                "border-color": "{b_57}",
                                "background-color": "{b_58}"
                            },
                            "active": {
                                "background-color": "{b_59}",
                                "border-color": "{b_60}"
                            },
                            "focus": {
                                "border-color": "{b_61}"
                            }
                        }
                    },
                    "loader": {
                        "color": "{b_62}"
                    },
                    "left-icon": {
                        "color": "{b_63}"
                    },
                    "right-icon": {
                        "color": "{b_64}"
                    },
                    "jds-text": {
                        "color": "{primary60}"
                    }
                },
                "destructive": {
                    "container": {
                        "background-color": "{b_65}",
                        "border-width": "{b_66}",
                        "border-color": "{b_67}",
                        "behavior": {
                            "active": {
                                "background-color": "{b_68}",
                                "border-color": "{b_69}"
                            },
                            "focus": {
                                "border-color": "{b_70}",
                                "border-width": "{b_71}"
                            }
                        }
                    },
                    "loader": {
                        "color": "{b_72}"
                    },
                    "left-icon": {
                        "color": "{b_73}"
                    },
                    "right-icon": {
                        "color": "{b_74}"
                    },
                    "jds-text": {
                        "color": "{feedbackError80}"
                    }
                },
                "positive": {
                    "container": {
                        "background-color": "{b_75}",
                        "border-width": "{b_76}",
                        "border-color": "{b_77}",
                        "behavior": {
                            "active": {
                                "background-color": "{b_78}",
                                "border-color": "{b_79}"
                            },
                            "focus": {
                                "border-color": "{b_80}",
                                "border-width": "{b_81}"
                            }
                        }
                    },
                    "loader": {
                        "color": "{b_82}"
                    },
                    "left-icon": {
                        "color": "{b_83}"
                    },
                    "right-icon": {
                        "color": "{b_84}"
                    },
                    "jds-text": {
                        "color": "{feedbackSuccess80}"
                    }
                }
            },
            "tertiary": {
                "normal": {
                    "container": {
                        "border-width": "{b_9}",
                        "background-color": "{b_85}",
                        "behavior": {
                            "hover": {
                                "background-color": "{b_86}"
                            },
                            "active": {
                                "background-color": "{b_87}"
                            },
                            "focus": {
                                "border-color": "{b_88}",
                                "background-color": "{b_89}"
                            }
                        }
                    },
                    "loader": {
                        "color": "{b_90}"
                    },
                    "left-icon": {
                        "color": "{b_91}"
                    },
                    "right-icon": {
                        "color": "{b_92}"
                    },
                    "jds-text": {
                        "color": "{primary60}"
                    }
                },
                "destructive": {
                    "container": {
                        "background-color": "{b_93}",
                        "behavior": {
                            "hover": {
                                "background-color": "{b_94}"
                            },
                            "active": {
                                "background-color": "{b_95}"
                            },
                            "focus": {
                                "border-color": "{b_96}",
                                "border-width": "{b_97}",
                                "background-color": "{b_98}"
                            }
                        }
                    },
                    "loader": {
                        "color": "{b_99}"
                    },
                    "left-icon": {
                        "color": "{b_100}"
                    },
                    "right-icon": {
                        "color": "{b_101}"
                    },
                    "jds-text": {
                        "color": "{feedbackError80}"
                    }
                },
                "positive": {
                    "container": {
                        "background-color": "{b_102}",
                        "behavior": {
                            "active": {
                                "background-color": "{b_103}"
                            },
                            "focus": {
                                "border-color": "{b_104}",
                                "border-width": "{b_105}"
                            }
                        }
                    },
                    "loader": {
                        "color": "{b_106}"
                    },
                    "left-icon": {
                        "color": "{b_107}"
                    },
                    "right-icon": {
                        "color": "{b_108}"
                    },
                    "jds-text": {
                        "color": "{feedbackSuccess80}"
                    }
                }
            }
        },
        {
            "true": {
                "small": {
                    "container": {
                        "padding-top": "{b_109}",
                        "padding-right": "{b_110}",
                        "padding-bottom": "{b_111}",
                        "padding-left": "{b_112}"
                    },
                    "left-icon": {
                        "size": "{b_113}"
                    },
                    "right-icon": {
                        "size": "{b_114}"
                    },
                    "loader": {
                        "size": "{b_115}"
                    }
                },
                "medium": {
                    "container": {
                        "padding-top": "{b_116}",
                        "padding-right": "{b_117}",
                        "padding-bottom": "{b_118}",
                        "padding-left": "{b_119}"
                    },
                    "left-icon": {
                        "size": "{b_120}"
                    },
                    "right-icon": {
                        "size": "{b_121}"
                    },
                    "loader": {
                        "size": "{b_122}"
                    }
                },
                "large": {
                    "container": {
                        "padding-top": "{b_123}",
                        "padding-left": "{b_124}",
                        "padding-bottom": "{b_125}",
                        "padding-right": "{b_126}"
                    },
                    "left-icon": {
                        "size": "{b_127}"
                    },
                    "right-icon": {
                        "size": "{b_128}"
                    },
                    "loader": {
                        "size": "{b_129}"
                    }
                }
            },
            "false": {
                "small": {
                    "container": {
                        "min-height": "{b_130}",
                        "min-width": "{b_131}"
                    },
                    "left-icon": {
                        "size": "{b_132}"
                    },
                    "right-icon": {
                        "size": "{b_133}"
                    },
                    "loader": {
                        "size": "{b_134}"
                    },
                    "jds-text": {
                        "hidden": true
                    }
                },
                "medium": {
                    "container": {
                        "min-height": "{b_135}",
                        "min-width": "{b_136}"
                    },
                    "left-icon": {
                        "size": "{b_137}"
                    },
                    "right-icon": {
                        "size": "{b_138}"
                    },
                    "loader": {
                        "size": "{b_139}"
                    },
                    "jds-text": {
                        "hidden": true
                    }
                },
                "large": {
                    "container": {
                        "min-height": 56,
                        "min-width": 56
                    },
                    "left-icon": {
                        "size": "{b_140}"
                    },
                    "right-icon": {
                        "size": "{b_141}"
                    },
                    "loader": {
                        "size": "{b_142}"
                    },
                    "jds-text": {
                        "hidden": true
                    }
                }
            }
        },
        {
            "true": {
                "true": {
                    "true": {
                        "false": {
                            "false": {
                                "container": {
                                    "justify-content": "{b_143}"
                                }
                            },
                            "true": {
                                "container": {
                                    "justify-content": "{b_144}"
                                }
                            }
                        }
                    }
                },
                "false": {
                    "false": {
                        "true": {
                            "false": {
                                "container": {
                                    "justify-content": "{b_145}"
                                }
                            }
                        },
                        "false": {
                            "true": {
                                "container": {
                                    "justify-content": "{b_146}"
                                }
                            }
                        }
                    },
                    "true": {
                        "true": {
                            "false": {
                                "container": {
                                    "justify-content": "{b_147}"
                                }
                            }
                        }
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "kind",
            "state"
        ],
        [
            "_hasLabel",
            "size"
        ],
        [
            "fullWidth",
            "_hasRightIcon",
            "_hasLeftIcon",
            "_hasLabel",
            "loading"
        ]
    ],
    "api": {
        "config": {
            "kind": {
                "values": [
                    "primary",
                    "secondary",
                    "tertiary"
                ],
                "doc_description": "It can be used to switch between 3 variants of Button which is by default 'primary'."
            },
            "size": {
                "values": [
                    "medium",
                    "small",
                    "large"
                ],
                "doc_description": "it can be used to control the size of Button."
            },
            "state": {
                "values": [
                    "normal",
                    "destructive",
                    "positive"
                ],
                "doc_description": "It can be used to change the state of Button."
            },
            "fullWidth": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to make Button full-width."
            },
            "disabled": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to enable or disable Button."
            },
            "_hasRightIcon": {
                "values": [
                    true,
                    false
                ]
            },
            "_hasLeftIcon": {
                "values": [
                    true,
                    false
                ]
            },
            "loading": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "This can be used to add loading spinner to the right of label in Button."
            },
            "_hasLabel": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "container": {
                "type": {
                    "name": "type",
                    "type": "string",
                    "platform": "web"
                }
            },
            "left-icon": {
                "value": {
                    "type": "icon",
                    "name": "iconLeft",
                    "doc_description": "It can be used to add icon to the left of the text of Button."
                },
                "description": {
                    "type": "string",
                    "name": "description",
                    "required": false
                }
            },
            "right-icon": {
                "value": {
                    "type": "icon",
                    "name": "icon",
                    "doc_description": "It adds icon to the right of the text of Button."
                },
                "description": {
                    "type": "string",
                    "name": "description",
                    "required": false
                }
            },
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "label",
                    "doc_description": "It displays label of Button."
                }
            }
        },
        "events": {
            "container": {
                "onClick": "onClick",
                "onFocus": {
                    "name": "onFocus",
                    "platform": "web"
                },
                "onBlur": {
                    "name": "onBlur",
                    "platform": "web"
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "button"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "aria-expanded": "ariaExpanded",
                    "aria-controls": "ariaControls"
                }
            },
            "right-icon": {
                "properties": {
                    "role": {
                        "value": "img"
                    },
                    "aria-label": {
                        "name": "iconAriaLabel",
                        "function": true
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1U = (Component)=>(0, $acw62.forwardRef)((props, ref)=>{
        const hasLabel = Boolean(props.children || props.title || props.label);
        if (props.children) console.warn("children prop is deprecated. Use label instead");
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                rootRef: ref,
                label: props.children || props.label || props.title,
                _hasRightIcon: Boolean(props.icon),
                _hasLabel: hasLabel,
                iconAriaLabel: props.iconAriaLabel || $fe5170bdd3625759$var$formatIconName(props.icon)
            }
        });
    });
const $fe5170bdd3625759$var$Component$1W = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1R;
    const { kind: kind = "primary", size: size = "medium", state: state = "normal", fullWidth: fullWidth = false, disabled: disabled = false, loading: loading = false, onClick: onClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onFocus: onFocus = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onBlur: onBlur = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), ariaLabel: ariaLabel = props.label?.toString(), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            size: size,
            state: state,
            fullWidth: fullWidth,
            disabled: disabled,
            loading: loading,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSButton", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$353f5b6fc5456de1 = $fe5170bdd3625759$var$withLogic$1U($fe5170bdd3625759$var$Component$1W);
$fe5170bdd3625759$export$353f5b6fc5456de1.displayName = "Button";
$fe5170bdd3625759$export$353f5b6fc5456de1.slotName = "jds_button";
const $fe5170bdd3625759$var$sdl$1Q = {
    "metadata": {
        "version": "1.0.0",
        "id": "carousel-pagination-1.0.0",
        "name": "JDSCarouselPagination",
        "layerName": "jds_carousel_pagination"
    },
    "hierarchy": {
        "container": [
            "jds_carousel_pagination_item"
        ]
    },
    "base": {
        "container": {
            "hidden": false,
            "flex-direction": "{c_0}",
            "justify-content": "{c_1}",
            "align-items": "{c_2}",
            "gap": "{c_3}",
            "padding-top": "{c_4}",
            "padding-bottom": "{c_6}"
        },
        "jds_carousel_pagination_item": {
            "density": "relaxed"
        }
    },
    "variant": {
        "density": {
            "condensed": {
                "container": {
                    "gap": "{c_7}"
                },
                "jds_carousel_pagination_item": {
                    "density": "condensed"
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "density": {
                "type": "JDSCarouselPaginationItem.density",
                "values": [
                    "relaxed",
                    "condensed"
                ]
            }
        },
        "data": {
            "container": {
                "value": {
                    "type": "list",
                    "name": "items",
                    "object": {
                        "active": "boolean",
                        "kind": "JDSCarouselPaginationItem.kind"
                    }
                }
            },
            "jds_carousel_pagination_item": {
                "active": {
                    "type": "boolean",
                    "name": "items.active"
                },
                "kind": {
                    "type": "JDSCarouselPaginationItem.kind",
                    "name": "items.kind"
                }
            }
        },
        "events": {
            "jds_carousel_pagination_item": {
                "onDotClick": "onDotClick"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "presentation"
                    }
                }
            }
        }
    }
};
function $fe5170bdd3625759$var$getPaginationItemKind(currentIndex, kind, visibleArray, selectedIndex, total) {
    if (kind !== "diminishing") return "normal";
    if (visibleArray[0] === currentIndex && selectedIndex > 4 || visibleArray[visibleArray.length - 1] === currentIndex && selectedIndex < total - 3) return "tail_dot_small";
    if (visibleArray[1] === currentIndex && selectedIndex > 4 || visibleArray[visibleArray.length - 2] === currentIndex && selectedIndex < total - 3) return "tail_dot_large";
    return "normal";
}
const $fe5170bdd3625759$var$getVisibleItems = (selectedIndex, total)=>{
    let leftCount, rightCount;
    if (selectedIndex === total - 1) {
        leftCount = 6;
        rightCount = 0;
    } else if (selectedIndex === total - 2) {
        leftCount = 5;
        rightCount = 2;
    } else {
        leftCount = Math.min(selectedIndex, 4);
        leftCount = leftCount < 0 ? 0 : leftCount;
        rightCount = 7 - leftCount;
        rightCount = rightCount > total ? total : rightCount;
    }
    let left = Array.from({
        length: leftCount + 1
    }).map((_, i)=>selectedIndex - i);
    left.reverse();
    const right = Array.from({
        length: rightCount
    }).map((_, i)=>selectedIndex + i);
    return Array.from(/* @__PURE__ */ new Set([
        ...left,
        selectedIndex,
        ...right
    ]));
};
const $fe5170bdd3625759$var$withLogic$1T = (Component)=>(props)=>{
        const { selectedIndex: selectedIndex = 0, count: count, kind: kind } = props;
        const visibleItems = $fe5170bdd3625759$var$getVisibleItems(selectedIndex, count);
        const items = Array.from({
            length: count
        }).map((_, index)=>{
            const itemKind = $fe5170bdd3625759$var$getPaginationItemKind(index, count > 7 ? "diminishing" : "normal", visibleItems, selectedIndex, count);
            const isHidden = count > 7 && !visibleItems.includes(index);
            return {
                active: selectedIndex === index,
                kind: itemKind,
                internalClasses: [
                    isHidden ? "hide" : ""
                ].join(" ")
            };
        });
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
            style: {
                position: "relative"
            },
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
                ...{
                    ...props,
                    items: items
                }
            })
        });
    };
const $fe5170bdd3625759$var$Component$1V = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1Q;
    const { density: density = "undefined", onDotClick: onDotClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            density: density,
            onDotClick: onDotClick,
            ...rest
        },
        componentTag: componentTag
    }, "JDSCarouselPagination", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$var$CarouselPagination = $fe5170bdd3625759$var$withLogic$1T($fe5170bdd3625759$var$Component$1V);
$fe5170bdd3625759$var$CarouselPagination.displayName = "CarouselPagination";
$fe5170bdd3625759$var$CarouselPagination.slotName = "jds_carousel_pagination";
const $fe5170bdd3625759$var$sdl$1P = {
    "metadata": {
        "version": "1.0.0",
        "id": "carousel-pagination-item-1.0.0",
        "name": "JDSCarouselPaginationItem",
        "layerName": "jds_carousel_pagination_item",
        "internal": true
    },
    "hierarchy": {
        "container": []
    },
    "base": {
        "container": {
            "width": "{c_0}",
            "height": "{c_1}",
            "background-color": "{c_2}",
            "opacity": "{c_3}",
            "border-radius": "{c_4}",
            "show": true,
            "behavior": {
                "hover": {
                    "background-color": "{c_5}",
                    "opacity": "{c_6}"
                },
                "active": {
                    "background-color": "{c_7}",
                    "opacity": "{c_8}"
                }
            }
        }
    },
    "variant": {
        "density": {
            "condensed": {
                "container": {
                    "height": "{c_9}"
                }
            }
        },
        "active": {
            "true": {
                "container": {
                    "opacity": "{c_10}",
                    "behavior": {
                        "hover": {
                            "background-color": "{c_11}"
                        },
                        "active": {
                            "background-color": "{c_12}"
                        }
                    }
                }
            }
        },
        "kind": {
            "label": {
                "container": {
                    "hidden": true
                }
            },
            "none": {
                "container": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {
            "condensed": {
                "false": {
                    "normal": {
                        "container": {
                            "width": "{c_18}"
                        }
                    },
                    "tail_dot_large": {
                        "container": {
                            "width": "{c_19}",
                            "height": "{c_20}"
                        }
                    },
                    "tail_dot_small": {
                        "container": {
                            "width": "{c_21}",
                            "height": "{c_22}"
                        }
                    },
                    "invisible": {
                        "container": {
                            "show": false
                        }
                    }
                },
                "true": {
                    "normal": {
                        "container": {
                            "width": "{c_23}"
                        }
                    },
                    "tail_dot_large": {
                        "container": {
                            "width": "{c_24}"
                        }
                    },
                    "tail_dot_small": {
                        "container": {
                            "width": "{c_25}"
                        }
                    },
                    "invisible": {
                        "container": {
                            "show": false
                        }
                    }
                }
            },
            "relaxed": {
                "false": {
                    "normal": {
                        "container": {
                            "width": "{c_13}"
                        }
                    },
                    "tail_dot_large": {
                        "container": {
                            "width": "{c_14}",
                            "height": "{c_15}"
                        }
                    },
                    "tail_dot_small": {
                        "container": {
                            "width": "{c_16}",
                            "height": "{c_17}"
                        }
                    },
                    "invisible": {
                        "container": {
                            "show": false
                        }
                    }
                },
                "true": {
                    "normal": {
                        "container": {
                            "width": "{c_26}"
                        }
                    },
                    "tail_dot_large": {
                        "container": {
                            "width": "{c_27}"
                        }
                    },
                    "tail_dot_small": {
                        "container": {
                            "width": "{c_28}"
                        }
                    },
                    "invisible": {
                        "container": {
                            "show": false
                        }
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "density",
            "active",
            "kind"
        ]
    ],
    "api": {
        "config": {
            "kind": {
                "values": [
                    "normal",
                    "tail_dot_large",
                    "tail_dot_small",
                    "invisible"
                ]
            },
            "density": {
                "values": [
                    "relaxed",
                    "condensed"
                ]
            },
            "active": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "events": {
            "container": {
                "onClick": "onDotClick"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "presentation"
                    }
                }
            }
        },
        "data": {}
    }
};
const $fe5170bdd3625759$var$withLogic$1S = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                onDotClick: ()=>props.onDotClick?.(props.internalIndex),
                className: props.internalClasses
            }
        });
    };
const $fe5170bdd3625759$var$Component$1U = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1P;
    const { kind: kind = "normal", density: density = "relaxed", active: active = false, onDotClick: onDotClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            density: density,
            active: active,
            onDotClick: onDotClick,
            ...rest
        },
        componentTag: componentTag
    }, "JDSCarouselPaginationItem", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$var$CarouselPaginationItem = $fe5170bdd3625759$var$withLogic$1S($fe5170bdd3625759$var$Component$1U);
$fe5170bdd3625759$var$CarouselPaginationItem.displayName = "CarouselPaginationItem";
$fe5170bdd3625759$var$CarouselPaginationItem.slotName = "jds_carousel_pagination_item";
const $fe5170bdd3625759$var$sdl$1O = {
    "metadata": {
        "version": "1.0.0",
        "id": "carousel-slide-1.0.0",
        "name": "JDSCarouselSlide",
        "layerName": "jds_carousel_slide"
    },
    "hierarchy": {
        "container": [
            "slide-slot"
        ]
    },
    "base": {
        "container": {
            "hidden": true,
            "width": "{c_0}",
            "border-radius": "{c_1}",
            "enter-animation-name": "slideHorizontallyToLeft",
            "exit-animation-name": "slideHorizontallyToLeft",
            "padding-left": "{xxs}",
            "padding-right": "{xxs}",
            "web-cursor": "pointer"
        }
    },
    "variant": {
        "active": {
            "true": {
                "container": {
                    "hidden": false
                }
            }
        },
        "forward": {
            "false": {
                "container": {
                    "enter-animation-name": "slideHorizontallyToRight",
                    "exit-animation-name": "slideHorizontallyToRight"
                }
            }
        },
        "_platform": {
            "desktop": {
                "container": {
                    "padding-left": 0,
                    "padding-right": 0
                }
            }
        }
    },
    "api": {
        "config": {
            "active": {
                "values": [
                    false,
                    true
                ]
            },
            "forward": {
                "values": [
                    true,
                    false
                ]
            },
            "_platform": {
                "values": [
                    "tablet",
                    "desktop"
                ]
            }
        },
        "children": {
            "slide-slot": {
                "name": "children",
                "accepts": [
                    "any"
                ],
                "max": 1
            }
        },
        "events": {
            "container": {
                "onClick": "onClick",
                "onSwipeLeft": "onSwipeLeft",
                "onSwipeRight": "onSwipeRight"
            }
        },
        "data": {}
    }
};
const $fe5170bdd3625759$var$makeClass = (classes)=>classes.filter((e)=>e).join(" ").trim();
const $fe5170bdd3625759$var$setCSSVar = (obj)=>{
    Object.keys(obj).forEach((key)=>obj[key] === void 0 && delete obj[key]);
    return obj;
};
const $fe5170bdd3625759$var$getPlatform = ()=>{
    if ($fe5170bdd3625759$var$Devices.isMobile()) return "mobile";
    if ($fe5170bdd3625759$var$Devices.isTablet()) return "tablet";
    return "desktop";
};
const $fe5170bdd3625759$var$withLogic$1R = (Component)=>(props)=>{
        const internalProps = props;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                active: true,
                platform: $fe5170bdd3625759$var$getPlatform(),
                onPointerDown: (ev)=>{
                    internalProps?.onSwipeLeft?.(ev, {
                        type: "touchdown"
                    });
                },
                onPointerMove: (ev)=>{
                    internalProps?.onSwipeLeft?.(ev, {
                        type: "touchmove"
                    });
                },
                onPointerUp: (ev)=>{
                    internalProps?.onSwipeLeft?.(ev, {
                        type: "touchup"
                    });
                },
                onDragStart: (ev)=>{
                    ev.preventDefault();
                },
                onDragEnd: (ev)=>{
                    ev.preventDefault();
                }
            }
        });
    };
const $fe5170bdd3625759$var$Component$1T = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1O;
    const { active: active = false, forward: forward = true, onClick: onClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSwipeLeft: onSwipeLeft = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSwipeRight: onSwipeRight = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            active: active,
            forward: forward,
            onClick: onClick,
            onSwipeLeft: onSwipeLeft,
            onSwipeRight: onSwipeRight,
            ...rest
        },
        componentTag: componentTag
    }, "JDSCarouselSlide", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$cabb5ccfbd60cbd4 = $fe5170bdd3625759$var$withLogic$1R($fe5170bdd3625759$var$Component$1T);
$fe5170bdd3625759$export$cabb5ccfbd60cbd4.displayName = "CarouselSlide";
$fe5170bdd3625759$export$cabb5ccfbd60cbd4.slotName = "jds_carousel_slide";
const $fe5170bdd3625759$var$sdl$1N = {
    "metadata": {
        "version": "1.0.0",
        "id": "content-block-1.0.0",
        "name": "JDSContentBlock",
        "layerName": "jds_content_block"
    },
    "hierarchy": {
        "root-container": [
            {
                "inner-container": [
                    {
                        "caption-container": [
                            "caption-slot"
                        ]
                    },
                    "title-jds-text",
                    "description-jds-text",
                    {
                        "children-container": [
                            "children-slot"
                        ]
                    }
                ]
            },
            {
                "button-container": [
                    "primary-jds_button",
                    "secondary-jds_button",
                    "primary-inverted-jds_button"
                ]
            }
        ]
    },
    "base": {
        "root-container": {
            "flex-direction": "{c_0}",
            "align-items": "{c_1}",
            "justify-content": "{c_2}",
            "width": "{c_3}",
            "gap": "{m}"
        },
        "inner-container": {
            "flex-direction": "{c_4}",
            "align-items": "{c_5}",
            "justify-content": "{c_6}"
        },
        "caption-container": {
            "padding-bottom": "{c_8}",
            "hidden": false
        },
        "children-container": {
            "hidden": false
        },
        "button-container": {
            "flex-direction": "{c_12}",
            "gap": "{c_14}"
        },
        "primary-jds_button": {
            "kind": "primary",
            "size": "small",
            "hidden": false
        },
        "secondary-jds_button": {
            "kind": "secondary",
            "size": "small"
        },
        "primary-inverted-jds_button": {
            "kind": "primary",
            "size": "small",
            "hidden": true
        },
        "title-jds-text": {
            "font-family": "{headingXs}",
            "color": "{primaryGrey100}",
            "font-size": "{headingXs}",
            "line-height": "{headingXs}",
            "letter-spacing": "{headingXs}",
            "font-weight": "{headingXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "padding-bottom": "{c_9}"
        },
        "description-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "padding-bottom": "{c_10}"
        }
    },
    "variant": {
        "size": {
            "xtra-xtra-small": {
                "title-jds-text": {
                    "font-family": "{bodySBold}",
                    "font-size": "{bodySBold}",
                    "line-height": "{bodySBold}",
                    "letter-spacing": "{bodySBold}",
                    "font-weight": "{bodySBold}"
                }
            },
            "small": {
                "title-jds-text": {
                    "font-family": "{headingS}",
                    "font-size": "{headingS}",
                    "line-height": "{headingS}",
                    "letter-spacing": "{headingS}",
                    "font-weight": "{headingS}",
                    "padding-bottom": "{c_15}"
                },
                "description-jds-text": {
                    "font-family": "{bodyM}",
                    "font-size": "{bodyM}",
                    "line-height": "{bodyM}",
                    "letter-spacing": "{bodyM}",
                    "font-weight": "{bodyM}"
                }
            },
            "medium": {
                "caption-container": {
                    "padding-bottom": "{c_16}"
                },
                "button-container": {
                    "gap": "{c_18}"
                },
                "primary-jds_button": {
                    "size": "medium"
                },
                "secondary-jds_button": {
                    "size": "medium"
                },
                "primary-inverted-jds_button": {
                    "size": "medium"
                },
                "title-jds-text": {
                    "font-family": "{headingM}",
                    "font-size": "{headingM}",
                    "line-height": "{headingM}",
                    "letter-spacing": "{headingM}",
                    "font-weight": "{headingM}",
                    "padding-bottom": "{c_17}"
                },
                "description-jds-text": {
                    "font-family": "{bodyM}",
                    "font-size": "{bodyM}",
                    "line-height": "{bodyM}",
                    "letter-spacing": "{bodyM}",
                    "font-weight": "{bodyM}"
                }
            },
            "large": {
                "caption-container": {
                    "padding-bottom": "{c_19}"
                },
                "button-container": {
                    "gap": "{c_22}"
                },
                "primary-jds_button": {
                    "size": "large"
                },
                "secondary-jds_button": {
                    "size": "large"
                },
                "primary-inverted-jds_button": {
                    "size": "large"
                },
                "title-jds-text": {
                    "font-family": "{headingL}",
                    "font-size": "{headingL}",
                    "line-height": "{headingL}",
                    "letter-spacing": "{headingL}",
                    "font-weight": "{headingL}",
                    "padding-bottom": "{c_20}"
                },
                "description-jds-text": {
                    "font-family": "{bodyL}",
                    "font-size": "{bodyL}",
                    "line-height": "{bodyL}",
                    "letter-spacing": "{bodyL}",
                    "font-weight": "{bodyL}"
                }
            },
            "xtra-large": {
                "caption-container": {
                    "padding-bottom": "{c_23}"
                },
                "button-container": {
                    "gap": "{c_26}"
                },
                "primary-jds_button": {
                    "size": "large"
                },
                "secondary-jds_button": {
                    "size": "large"
                },
                "primary-inverted-jds_button": {
                    "size": "large"
                },
                "title-jds-text": {
                    "font-family": "{headingXl}",
                    "font-size": "{headingXl}",
                    "line-height": "{headingXl}",
                    "letter-spacing": "{headingXl}",
                    "font-weight": "{headingXl}",
                    "padding-bottom": "{c_24}"
                },
                "description-jds-text": {
                    "font-family": "{bodyL}",
                    "font-size": "{bodyL}",
                    "line-height": "{bodyL}",
                    "letter-spacing": "{bodyL}",
                    "font-weight": "{bodyL}"
                }
            }
        },
        "invertCTA": {
            "true": {
                "primary-jds_button": {
                    "hidden": true
                },
                "primary-inverted-jds_button": {
                    "hidden": false
                }
            }
        },
        "ctaWrap": {
            "vertical": {
                "button-container": {
                    "flex-direction": "{c_27}"
                },
                "primary-jds_button": {
                    "fullWidth": true
                },
                "secondary-jds_button": {
                    "fullWidth": true
                },
                "primary-inverted-jds_button": {
                    "fullWidth": true
                }
            }
        },
        "shouldOverrideColor": {
            "true": {
                "title-jds-text": {
                    "color": "{global.white}"
                },
                "description-jds-text": {
                    "color": "{global.white}"
                }
            }
        },
        "singleButton": {
            "false": {
                "inner-container": {
                    "width": "{c_28}"
                },
                "button-container": {
                    "width": "{c_29}"
                }
            }
        },
        "isTertiary": {
            "true": {
                "secondary-jds_button": {
                    "kind": "tertiary"
                }
            }
        },
        "_hasCaptionSlot": {
            "false": {
                "caption-container": {
                    "hidden": true
                }
            }
        },
        "_hasChildrenSlot": {
            "false": {
                "children-container": {
                    "hidden": true
                },
                "description-jds-text": {
                    "padding-bottom": "{custom_5}"
                }
            }
        },
        "_hasDescription": {
            "false": {
                "description-jds-text": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {
            "desktop": {
                "medium": {
                    "title-jds-text": {
                        "padding-bottom": "{c_30}"
                    }
                },
                "large": {
                    "title-jds-text": {
                        "padding-bottom": "{c_31}"
                    }
                },
                "xtra-large": {
                    "title-jds-text": {
                        "padding-bottom": "{c_32}"
                    }
                }
            }
        },
        {
            "true": {
                "xtra-xtra-small": {
                    "root-container": {
                        "flex-direction": "{c_33}",
                        "justify-content": "{c_34}",
                        "align-items": "{c_35}"
                    },
                    "button-container": {
                        "flex-direction": "{c_36}",
                        "justify-content": "{c_37}",
                        "align-items": "{c_38}"
                    },
                    "inner-container": {
                        "flex": 1
                    },
                    "primary-jds_button": {
                        "hidden": false
                    },
                    "secondary-jds_button": {
                        "hidden": true
                    },
                    "primary-inverted-jds_button": {
                        "hidden": true
                    }
                }
            }
        },
        {
            "false": {
                "false": {
                    "title-jds-text": {
                        "padding-bottom": "{custom_5}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "_platform",
            "size"
        ],
        [
            "singleButton",
            "size"
        ],
        [
            "_hasChildrenSlot",
            "_hasDescription"
        ]
    ],
    "api": {
        "config": {
            "_platform": {
                "values": [
                    "mobile",
                    "desktop"
                ]
            },
            "size": {
                "values": [
                    "xtra-small",
                    "xtra-xtra-small",
                    "small",
                    "medium",
                    "large",
                    "xtra-large"
                ],
                "doc_description": "It can be used to control the size of ContentBlock."
            },
            "ctaWrap": {
                "values": [
                    "horizontal",
                    "vertical"
                ],
                "doc_description": "It can be used to either wrap the primary button, secondary button horizontally or vertically."
            },
            "invertCTA": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It inverts the order of the CTAs if true."
            },
            "shouldOverrideColor": {
                "values": [
                    false,
                    true
                ]
            },
            "singleButton": {
                "values": [
                    false,
                    true
                ]
            },
            "isTertiary": {
                "values": [
                    false,
                    true
                ]
            },
            "_hasCaptionSlot": {
                "values": [
                    true,
                    false
                ]
            },
            "_hasChildrenSlot": {
                "values": [
                    true,
                    false
                ]
            },
            "_hasDescription": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "primary-jds_button": {
                "label": {
                    "type": "string",
                    "name": "primaryCTA",
                    "doc_description": "It displays label of secondary button of Toast."
                }
            },
            "secondary-jds_button": {
                "label": {
                    "type": "string",
                    "name": "secondaryCTA",
                    "doc_description": "It displays label of primary button of Toast."
                }
            },
            "primary-inverted-jds_button": {
                "label": {
                    "type": "string",
                    "name": "primaryCTA",
                    "doc_description": "It displays label of secondary button of Toast."
                }
            },
            "title-jds-text": {
                "value": {
                    "type": "string",
                    "name": "title",
                    "doc_description": "It displays the title of ContentBlock."
                }
            },
            "description-jds-text": {
                "value": {
                    "type": "string",
                    "name": "description",
                    "doc_description": "It can be used to add description to the ContentBlock."
                }
            }
        },
        "children": {
            "caption-slot": {
                "name": "caption",
                "accepts": [
                    "jds_text",
                    "jds_badge",
                    "jds_tag"
                ],
                "max": 1,
                "doc_description": "It displays the header of the ContentBlock. Can be 'badge', 'text', 'tag'."
            },
            "children-slot": {
                "name": "children",
                "accepts": [
                    "any"
                ],
                "max": 1
            }
        },
        "events": {
            "primary-jds_button": {
                "onClick": "onPrimaryClick"
            },
            "secondary-jds_button": {
                "onClick": "onSecondaryClick"
            },
            "primary-inverted-jds_button": {
                "onClick": "onPrimaryClick"
            }
        },
        "a11y": {
            "primary-jds_button": {
                "properties": {
                    "ariaLabel": "primaryCtaAriaLabel",
                    "ariaDescribedby": {
                        "name": "primaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "secondary-jds_button": {
                "properties": {
                    "ariaLabel": "secondaryCtaAriaLabel",
                    "ariaDescribedby": {
                        "name": "secondaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "primary-inverted-jds_button": {
                "properties": {
                    "ariaLabel": "primaryCtaAriaLabel",
                    "ariaDescribedby": {
                        "name": "primaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$legacySizes$2 = [
    "m",
    "l",
    "xl",
    "s",
    "xs",
    "xxs"
];
const $fe5170bdd3625759$var$PROP_MAP$q = (props)=>{
    if ($fe5170bdd3625759$var$legacySizes$2.includes(props.size)) console.warn($fe5170bdd3625759$var$legacySizes$2.join(","), "are deprecated. Use sizes staring with xtra, large, small");
    return {
        primaryCTA: {
            properties: {
                primaryCTA: $fe5170bdd3625759$var$resolvePropObjectKeys(props.primaryCTA, "title", ""),
                onPrimaryClick: props.onPrimaryClick || props.primaryCTA?.onClick
            }
        },
        secondaryCTA: {
            properties: {
                secondaryCTA: $fe5170bdd3625759$var$resolvePropObjectKeys(props.secondaryCTA, "title", ""),
                onSecondaryClick: props.onSecondaryClick || props.secondaryCTA?.onClick
            }
        },
        size: {
            defaultValue: "xtra-small",
            variations: {
                s: {
                    size: "small"
                },
                m: {
                    size: "medium"
                },
                xs: {
                    size: "xtra-small"
                },
                xxs: {
                    size: "xtra-xtra-small"
                },
                l: {
                    size: "large"
                },
                xl: {
                    size: "xtra-large"
                }
            }
        }
    };
};
const $fe5170bdd3625759$var$sizeMap = {
    xxs: "small",
    xs: "small",
    s: "small",
    m: "medium",
    l: "large",
    xl: "xtra-large",
    "xtra-small": "small",
    "xtra-xtra-small": "small",
    "xtra-large": "large"
};
const $fe5170bdd3625759$var$withLogic$1Q = (Component)=>(userProps)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$q);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                caption: props.caption ? (0, $acw62.cloneElement)(props.caption, {
                    size: $fe5170bdd3625759$var$sizeMap[props.size] || props.size
                }) : void 0,
                _hasCaptionSlot: Boolean(props.caption),
                _hasChildrenSlot: Boolean(props.children),
                _platform: $fe5170bdd3625759$var$Devices.isDesktop() ? "desktop" : "mobile"
            }
        });
    };
const $fe5170bdd3625759$var$Component$1S = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1N;
    const { size: size = "xtra-small", ctaWrap: ctaWrap = "horizontal", invertCTA: invertCTA = false, shouldOverrideColor: shouldOverrideColor = false, singleButton: singleButton = false, isTertiary: isTertiary = false, onPrimaryClick: onPrimaryClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSecondaryClick: onSecondaryClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            size: size,
            ctaWrap: ctaWrap,
            invertCTA: invertCTA,
            shouldOverrideColor: shouldOverrideColor,
            singleButton: singleButton,
            isTertiary: isTertiary,
            onPrimaryClick: onPrimaryClick,
            onSecondaryClick: onSecondaryClick,
            ...rest
        },
        componentTag: componentTag
    }, "JDSContentBlock", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$eb38b3b9c7f5f31b = $fe5170bdd3625759$var$withLogic$1Q($fe5170bdd3625759$var$Component$1S);
$fe5170bdd3625759$export$eb38b3b9c7f5f31b.displayName = "ContentBlock";
$fe5170bdd3625759$export$eb38b3b9c7f5f31b.slotName = "jds_content_block";
const $fe5170bdd3625759$var$JDSDatepickerDesktop = {
    "metadata": {
        "version": "1.0.0",
        "id": "date-picker-desktop-1.0.0",
        "name": "JDSDatepickerDesktop",
        "layerName": "jds_datepicker_desktop",
        "platform": "web"
    },
    "hierarchy": {
        "popup": [
            {
                "popup-container": [
                    "jds_datepicker_desktop_internal"
                ]
            }
        ]
    },
    "base": {
        "popup": {
            "priority": 70,
            "passive": true
        },
        "popup-container": {
            "hidden": true,
            "flex-direction": "{d_0}",
            "justify-content": "{d_1}",
            "align-items": "{d_2}",
            "opacity": "{opacity.invisible}",
            "transition": {
                "property": [
                    "opacity"
                ],
                "duration": "{medium}",
                "timing-function": "{easeExit}"
            }
        }
    },
    "variant": {
        "open": {
            "true": {
                "popup": {
                    "passive": false
                },
                "popup-container": {
                    "hidden": false,
                    "opacity": "{opacity.enabled}",
                    "transition": {
                        "timing-function": "{easeEntrance}"
                    }
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "state": {
                "values": [
                    "default",
                    "month_view",
                    "year_view"
                ]
            },
            "open": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "popup-container": {
                "padding-left": {
                    "type": "size",
                    "name": "offsetX"
                },
                "padding-top": {
                    "type": "size",
                    "name": "offsetY"
                }
            },
            "jds_datepicker_desktop_internal": {
                "triggerRef": {
                    "type": "ref",
                    "name": "triggerRef"
                },
                "monthName": {
                    "type": "string",
                    "name": "monthName"
                },
                "year": {
                    "type": "number",
                    "name": "year"
                },
                "yearSelectable": {
                    "type": "boolean",
                    "name": "yearSelectable"
                },
                "monthSelectable": {
                    "type": "boolean",
                    "name": "monthSelectable"
                },
                "months": {
                    "type": "list",
                    "name": "months",
                    "object": {
                        "name": "string",
                        "selected": "boolean",
                        "disabled": "boolean"
                    }
                },
                "current": {
                    "type": "number",
                    "name": "year"
                },
                "yearData": {
                    "type": "object",
                    "name": "yearData",
                    "object": {
                        "count": "number",
                        "disabled": "list",
                        "min": "number",
                        "max": "number"
                    }
                },
                "loadedYears": {
                    "type": "list",
                    "name": "loadedYears",
                    "object": {
                        "name": "string",
                        "selected": "boolean",
                        "disabled": "boolean"
                    }
                },
                "date": {
                    "type": "number",
                    "name": "date"
                },
                "month": {
                    "type": "number",
                    "name": "month"
                },
                "value": {
                    "type": "date",
                    "name": "value"
                },
                "calendarData": {
                    "type": "object",
                    "name": "calendarData",
                    "object": {
                        "disabledDays": "list",
                        "disabledDates": "list",
                        "max": "date",
                        "min": "date"
                    }
                },
                "yearLoadCount": {
                    "type": "number",
                    "platform": "web",
                    "name": "yearLoadCount"
                },
                "days": {
                    "type": "JDSDatepickerCalendarHeader.days",
                    "name": "days",
                    "object": {
                        "letter": "string"
                    }
                },
                "row": {
                    "type": "list",
                    "name": "rows.row",
                    "object": {
                        "value": "string",
                        "state": "JDSDatepickerCalendarButton.state"
                    }
                }
            }
        },
        "events": {
            "popup": {
                "onClick": "onClose"
            },
            "jds_datepicker_desktop_internal": {
                "onClose": "onClose",
                "onSelect": "onSelect"
            }
        },
        "a11y": {
            "jds_datepicker_desktop_internal": {
                "properties": {
                    "previousButtonAriaLabel": "previousButtonAriaLabel",
                    "closeAriaLabel": "closeAriaLabel",
                    "previousMonthAriaLabel": "previousMonthAriaLabel",
                    "nextMonthAriaLabel": "nextMonthAriaLabel"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$sdl$1M = {
    "metadata": {
        "version": "1.0.0",
        "id": "date-picker-mobile-1.0.0",
        "name": "JDSDatepickerMobile",
        "layerName": "jds_datepicker_mobile"
    },
    "hierarchy": {
        "popup": [
            "jds_datepicker_mobile_internal"
        ]
    },
    "base": {
        "popup": {
            "priority": 70,
            "passive": true
        },
        "jds_datepicker_mobile_internal": {
            "state": "default",
            "open": false
        }
    },
    "variant": {
        "state": {
            "month_view": {
                "jds_datepicker_mobile_internal": {
                    "state": "month_view"
                }
            },
            "year_view": {
                "jds_datepicker_mobile_internal": {
                    "state": "year_view"
                }
            }
        },
        "open": {
            "true": {
                "popup": {
                    "passive": false
                },
                "jds_datepicker_mobile_internal": {
                    "open": true
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "state": {
                "values": [
                    "default",
                    "month_view",
                    "year_view"
                ]
            },
            "open": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds_datepicker_mobile_internal": {
                "monthName": {
                    "type": "string",
                    "name": "monthName"
                },
                "year": {
                    "type": "string",
                    "name": "year"
                },
                "showArrows": {
                    "type": "boolean",
                    "name": "showArrows"
                },
                "yearSelectable": {
                    "type": "boolean",
                    "name": "yearSelectable"
                },
                "monthSelectable": {
                    "type": "boolean",
                    "name": "monthSelectable"
                },
                "months": {
                    "type": "list",
                    "name": "months",
                    "object": {
                        "name": "string",
                        "selected": "boolean",
                        "disabled": "boolean"
                    }
                },
                "current": {
                    "type": "number",
                    "name": "year"
                },
                "yearData": {
                    "type": "object",
                    "name": "yearData",
                    "object": {
                        "count": "number",
                        "disabled": "list",
                        "min": "number",
                        "max": "number"
                    }
                },
                "loadedYears": {
                    "type": "list",
                    "name": "loadedYears",
                    "object": {
                        "name": "string",
                        "selected": "boolean",
                        "disabled": "boolean"
                    }
                },
                "date": {
                    "type": "number",
                    "name": "date"
                },
                "month": {
                    "type": "number",
                    "name": "month"
                },
                "value": {
                    "type": "date",
                    "name": "value"
                },
                "calendarData": {
                    "type": "object",
                    "name": "calendarData",
                    "object": {
                        "disabledDays": "list",
                        "disabledDates": "list",
                        "max": "date",
                        "min": "date"
                    }
                },
                "calendarDays": {
                    "type": "JDSDatepickerCalendarHeader.days",
                    "name": "_calendarDays"
                },
                "calendarRows": {
                    "type": "JDSDatepickerCalendar.rows",
                    "name": "_calendarRows"
                },
                "confirmDate": {
                    "type": "string",
                    "name": "confirmDate"
                }
            }
        },
        "events": {
            "jds_datepicker_mobile_internal": {
                "onClose": "onClose",
                "onConfirm": "onConfirm"
            }
        },
        "a11y": {
            "jds_datepicker_mobile_internal": {
                "properties": {
                    "previousButtonAriaLabel": "previousButtonAriaLabel",
                    "closeAriaLabel": "closeAriaLabel",
                    "previousMonthAriaLabel": "previousMonthAriaLabel",
                    "nextMonthAriaLabel": "nextMonthAriaLabel",
                    "confirmAriaLabel": "confirmAriaLabel"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$DatePickerWidth = 384;
const $fe5170bdd3625759$var$setPositions$1 = (position = "left-end", container, trigger)=>{
    if (!trigger || !container) return {
        left: 0,
        top: 0
    };
    const triggerBounds = trigger.getBoundingClientRect();
    const triggerOffsetTop = trigger.getBoundingClientRect()?.top;
    const triggerOffsetLeft = trigger.getBoundingClientRect()?.left;
    const bodyHeight = document.body.clientHeight;
    const bodyWidth = document.body.clientWidth;
    const datePickerHeight = 484;
    let left = 0;
    let top;
    let height;
    let width;
    switch(position){
        case "right-start":
        case "left-start":
            top = triggerOffsetTop;
            if (top + datePickerHeight > bodyHeight) top = triggerOffsetTop + triggerBounds.height / 2 - datePickerHeight / 2;
            if (top + datePickerHeight > bodyHeight) top = triggerOffsetTop + triggerBounds.height - datePickerHeight;
            break;
        case "right-end":
        case "left-end":
            top = triggerOffsetTop + triggerBounds.height - datePickerHeight;
            if (top < 0) top = triggerOffsetTop + triggerBounds.height / 2 - datePickerHeight / 2;
            if (top < 0) top = triggerOffsetTop;
            if (left + $fe5170bdd3625759$var$DatePickerWidth > bodyWidth) left = triggerOffsetLeft - $fe5170bdd3625759$var$DatePickerWidth;
            break;
        case "right":
        case "left":
            top = triggerOffsetTop + triggerBounds.height / 2 - datePickerHeight / 2;
            if (triggerOffsetTop + triggerBounds.height / 2 - datePickerHeight / 2 < 0) top = triggerOffsetTop;
            if (triggerOffsetTop + triggerBounds.height / 2 + datePickerHeight / 2 > bodyHeight) top = triggerOffsetTop + triggerBounds.height - datePickerHeight;
            break;
        case "top-start":
        case "bottom-start":
            left = triggerOffsetLeft;
            if (left + $fe5170bdd3625759$var$DatePickerWidth > bodyWidth) left = triggerOffsetLeft + triggerBounds.width / 2 - $fe5170bdd3625759$var$DatePickerWidth / 2;
            if (left + $fe5170bdd3625759$var$DatePickerWidth > bodyWidth) left = triggerOffsetLeft + triggerBounds.width - $fe5170bdd3625759$var$DatePickerWidth;
            break;
        case "top-end":
        case "bottom-end":
            left = triggerOffsetLeft + triggerBounds.width - $fe5170bdd3625759$var$DatePickerWidth;
            if (left < 0) left = triggerOffsetLeft + triggerBounds.width / 2 - $fe5170bdd3625759$var$DatePickerWidth / 2;
            if (left < 0) left = triggerOffsetLeft;
            break;
        case "top":
        case "bottom":
            left = triggerOffsetLeft + triggerBounds.width / 2 - $fe5170bdd3625759$var$DatePickerWidth / 2;
            if (left < 0) left = triggerOffsetLeft;
            if (left + $fe5170bdd3625759$var$DatePickerWidth > bodyWidth) left = triggerOffsetLeft + triggerBounds.width - $fe5170bdd3625759$var$DatePickerWidth;
            break;
    }
    switch(position){
        case "right":
        case "right-start":
        case "right-end":
            left = triggerOffsetLeft + triggerBounds.width;
            if (left + $fe5170bdd3625759$var$DatePickerWidth > bodyWidth) left = triggerOffsetLeft - $fe5170bdd3625759$var$DatePickerWidth;
            break;
        case "left":
        case "left-start":
        case "left-end":
            left = triggerOffsetLeft - $fe5170bdd3625759$var$DatePickerWidth;
            if (left < 0) left = triggerOffsetLeft + triggerBounds.width;
            break;
        case "top-start":
        case "top":
        case "top-end":
            top = triggerOffsetTop - datePickerHeight;
            if (top < 0) top = triggerOffsetTop + triggerBounds.height;
            break;
        case "bottom-start":
        case "bottom":
        case "bottom-end":
            top = triggerOffsetTop + triggerBounds.height;
            if (top + datePickerHeight > bodyHeight) top = triggerOffsetTop - datePickerHeight;
            break;
        default:
            top = triggerOffsetTop + triggerBounds.height / 2 - datePickerHeight / 2;
            left = triggerOffsetLeft + triggerBounds.width;
    }
    return {
        left: left,
        top: top,
        maxHeight: height,
        maxWidth: width
    };
};
const $fe5170bdd3625759$var$useToggle = (value, condition, listener)=>{
    const [selected, setSelected] = (0, $acw62.useState)(value);
    (0, $acw62.useEffect)(()=>{
        setSelected(value);
    }, [
        value
    ]);
    const toggle = (e)=>{
        listener?.(e);
        if (condition || typeof condition === "undefined") setSelected(!selected);
    };
    const close = ()=>{
        if (selected) setSelected(false);
    };
    return {
        selected: selected,
        toggle: toggle,
        close: close
    };
};
const $fe5170bdd3625759$var$DEBOUNCE_TIME = 400;
const $fe5170bdd3625759$var$DATEPICKERINTERNAL_SELECTOR = "div.j-JDSDatepickerDesktopInternal-container";
const $fe5170bdd3625759$var$withLogic$1P = (Component)=>(props)=>{
        const { onClose: onClose, close: userClose = true, open: open, ...rest } = props;
        const closeProp = typeof open === "undefined" ? userClose : !open;
        const [containerElement, setContainerElement] = (0, $acw62.useState)();
        const anchorRef = (0, $acw62.useRef)(null);
        const trigger = props.triggerRef || anchorRef;
        const { selected: selected, toggle: toggle, close: close } = $fe5170bdd3625759$var$useToggle(!closeProp, true, props.onClose);
        const [coords, setCoords] = (0, $acw62.useState)({
            left: 0,
            top: 0
        });
        const calculateInitialPosition = (0, $acw62.useCallback)(()=>{
            if (trigger.current && containerElement) {
                const { left: left, top: top } = $fe5170bdd3625759$var$setPositions$1(props.position, containerElement, trigger.current);
                setCoords({
                    left: left,
                    top: top || 0
                });
            }
        }, [
            trigger,
            containerElement,
            props.position
        ]);
        const [shouldRender, setShouldRender] = (0, $acw62.useState)(selected);
        (0, $acw62.useEffect)(()=>{
            if (!shouldRender) return;
            calculateInitialPosition();
        }, [
            shouldRender,
            calculateInitialPosition
        ]);
        const containerRef = (0, $acw62.useCallback)((ref)=>{
            setContainerElement(ref);
        }, []);
        (0, $acw62.useEffect)(()=>{
            const resizeObserver = new ResizeObserver(()=>{
                calculateInitialPosition();
            });
            if (trigger.current) resizeObserver.observe(trigger.current);
            return ()=>{
                if (trigger.current) resizeObserver.unobserve(trigger.current);
            };
        }, [
            trigger,
            calculateInitialPosition
        ]);
        (0, $acw62.useEffect)(()=>{
            window?.addEventListener("resize", $fe5170bdd3625759$var$debounce(calculateInitialPosition, $fe5170bdd3625759$var$DEBOUNCE_TIME));
            return ()=>window?.removeEventListener("resize", $fe5170bdd3625759$var$debounce(calculateInitialPosition, $fe5170bdd3625759$var$DEBOUNCE_TIME));
        }, [
            calculateInitialPosition
        ]);
        const scrollCloseListener = (0, $acw62.useCallback)(()=>{
            close();
            onClose?.();
        }, [
            close,
            onClose
        ]);
        (0, $acw62.useEffect)(()=>{
            window.addEventListener("scroll", scrollCloseListener);
            return ()=>{
                window.removeEventListener("scroll", scrollCloseListener);
            };
        }, [
            scrollCloseListener
        ]);
        const [firstChild = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {}), ...restChildren] = (0, $acw62.Children).toArray(props.children);
        (0, $acw62.useEffect)(()=>{
            let timeout;
            if (selected) setShouldRender(true);
            else timeout = setTimeout(()=>{
                setShouldRender(false);
                setCoords(null);
            }, $fe5170bdd3625759$var$DEBOUNCE_TIME);
            return ()=>clearTimeout(timeout);
        }, [
            selected
        ]);
        (0, $acw62.useEffect)(()=>{
            if (!shouldRender || !selected) return;
            const timer = setTimeout(()=>{
                const datePickerInternalRef = document.querySelector($fe5170bdd3625759$var$DATEPICKERINTERNAL_SELECTOR);
                datePickerInternalRef?.setAttribute("tabindex", "0");
                datePickerInternalRef?.focus();
            }, $fe5170bdd3625759$var$DEBOUNCE_TIME);
            return ()=>clearTimeout(timer);
        }, [
            shouldRender,
            selected
        ]);
        (0, $acw62.useEffect)(()=>{
            const handleKeyDown = (event)=>{
                if (selected && event.key === "Escape") {
                    close();
                    onClose?.();
                }
            };
            window.addEventListener("keydown", handleKeyDown);
            return ()=>{
                window.removeEventListener("keydown", handleKeyDown);
            };
        }, [
            close,
            onClose,
            selected
        ]);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                shouldRender && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
                    ...{
                        ...rest,
                        open: selected,
                        triggerRef: containerRef,
                        onClose: ()=>{
                            if (selected) toggle();
                            onClose?.();
                        },
                        calendarData: {
                            disabledDates: props.disabledDates,
                            dateFilter: props.dateFilter,
                            min: props.min,
                            max: props.max
                        },
                        onClick: (ev)=>ev.stopPropagation(),
                        offsetX: coords?.left,
                        offsetY: coords?.top,
                        _onMonthSelect: (i)=>{
                            props.onMonthSelect?.();
                        },
                        _onYearSelect: (i)=>{
                            props.onYearSelect?.();
                        },
                        style: coords ? void 0 : {
                            visibility: "hidden"
                        }
                    }
                }),
                (0, $acw62.cloneElement)(firstChild, {
                    ref: anchorRef
                }),
                restChildren
            ]
        });
    };
const $fe5170bdd3625759$var$Component$1R = (props)=>{
    const { platform: platform, ...restSwitchables } = (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = platform === "desktop" ? $fe5170bdd3625759$var$JDSDatepickerDesktop : $fe5170bdd3625759$var$sdl$1M;
    const { state: state = "default", open: open = false, onClose: onClose = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSelect: onSelect = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            state: state,
            open: open,
            onClose: onClose,
            onSelect: onSelect,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDatepickerDesktop", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$5109c6dd95d8fb00 = $fe5170bdd3625759$var$withLogic$1P($fe5170bdd3625759$var$Component$1R);
$fe5170bdd3625759$export$5109c6dd95d8fb00.displayName = "DatePicker";
$fe5170bdd3625759$export$5109c6dd95d8fb00.slotName = "jds_datepicker_desktop";
const $fe5170bdd3625759$var$sdl$1L = {
    "metadata": {
        "version": "1.0.0",
        "id": "date-picker-button-1.0.0",
        "name": "JDSDatepickerButton",
        "layerName": "jds_datepicker_button",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "jds-text",
            {
                "jds-icon-container": [
                    "jds-icon"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "disabled": false,
            "height": "{d_0}",
            "border-radius": "{d_2}",
            "background-color": "{d_3}",
            "border-width": "{d_4}",
            "border-color": "{d_5}",
            "flex-direction": "{d_6}",
            "justify-content": "{d_7}",
            "align-items": "{d_8}",
            "gap": "{d_9}",
            "padding-right": "{d_10}",
            "padding-left": "{d_11}",
            "behavior": {
                "hover": {
                    "border-color": "{d_12}"
                },
                "focus": {
                    "border-color": "{d_13}",
                    "border-width": "{d_14}"
                },
                "active": {
                    "border-color": "{d_15}",
                    "background-color": "{d_16}"
                }
            }
        },
        "jds-text": {
            "font-family": "{button}",
            "color": "{primary60}",
            "font-size": "{button}",
            "line-height": "{button}",
            "letter-spacing": "{button}",
            "font-weight": "{button}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        },
        "jds-icon": {
            "size": "{m}",
            "color": "{primary60}",
            "value": "ic_chevron_down",
            "hidden": false,
            "ic": "ic_chevron_down"
        },
        "jds-icon-container": {
            "background-color": "{global.transparent}",
            "border-radius": "{pill}",
            "size": "{m}",
            "justify-content": "{justifyContent.center}",
            "align-items": "{alignItems.center}",
            "hidden": false,
            "ic": "ic_chevron_down"
        }
    },
    "variant": {
        "state": {
            "selected": {
                "container": {
                    "background-color": "{d_17}",
                    "border-color": "{d_18}"
                },
                "jds-icon": {
                    "value": "ic_chevron_up",
                    "ic": "ic_chevron_up"
                },
                "jds-icon-container": {
                    "background-color": "{global.transparent}",
                    "border-radius": "{pill}",
                    "size": "{m}",
                    "justify-content": "{justifyContent.center}",
                    "align-items": "{alignItems.center}",
                    "ic": "ic_chevron_up"
                }
            },
            "disabled": {
                "container": {
                    "disabled": true,
                    "border-width": "{d_19}",
                    "opacity": "{d_20}"
                }
            },
            "text_only": {
                "container": {
                    "disabled": true,
                    "border-width": "{d_21}"
                },
                "jds-text": {
                    "color": "{primaryGrey100}"
                },
                "jds-icon": {
                    "hidden": true
                },
                "jds-icon-container": {
                    "background-color": "{global.transparent}",
                    "border-radius": "{pill}",
                    "size": "{m}",
                    "justify-content": "{justifyContent.center}",
                    "align-items": "{alignItems.center}",
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "state": {
                "values": [
                    "default",
                    "selected",
                    "disabled",
                    "text_only"
                ]
            }
        },
        "data": {
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "text"
                }
            }
        },
        "events": {
            "container": {
                "onClick": "onClick"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "button"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "text"
                    },
                    "aria-expanded": {
                        "name": "_ariaExpanded"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1O = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                _ariaExpanded: props.state === "selected" ? "true" : "false"
            }
        });
    };
const $fe5170bdd3625759$var$Component$1Q = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1L;
    const { state: state = "default", onClick: onClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), ariaLabel: ariaLabel = props.text?.toString(), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            state: state,
            onClick: onClick,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDatepickerButton", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$395dd20d84297b30 = $fe5170bdd3625759$var$withLogic$1O($fe5170bdd3625759$var$Component$1Q);
$fe5170bdd3625759$export$395dd20d84297b30.displayName = "DatepickerButton";
$fe5170bdd3625759$export$395dd20d84297b30.slotName = "jds_datepicker_button";
const $fe5170bdd3625759$var$sdl$1K = {
    "metadata": {
        "version": "1.0.0",
        "id": "date-picker-calender-1.0.0",
        "name": "JDSDatepickerCalendar",
        "layerName": "jds_datepicker_calendar",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "jds_datepicker_calendar_header",
            {
                "rows-container": [
                    "jds_datepicker_calendar_row"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{d_0}",
            "justify-content": "{d_1}",
            "align-items": "{d_2}",
            "gap": "{d_3}"
        },
        "rows-container": {
            "flex-direction": "{d_4}",
            "flex": 1
        }
    },
    "variant": {},
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "data": {
            "jds_datepicker_calendar_header": {
                "days": {
                    "type": "JDSDatepickerCalendarHeader.days",
                    "name": "days",
                    "object": {
                        "letter": "string"
                    }
                }
            },
            "rows-container": {
                "rows.day": {
                    "type": "date",
                    "name": "day"
                },
                "rows.month": {
                    "type": "number",
                    "name": "month"
                },
                "rows.year": {
                    "type": "number",
                    "name": "year"
                },
                "rows.selected": {
                    "type": "date",
                    "name": "selected"
                },
                "rows.disabled": {
                    "type": "object",
                    "name": "disabled",
                    "object": {
                        "disabledDays": "list",
                        "disabledDates": "list",
                        "max": "date",
                        "min": "date"
                    }
                },
                "rows.loadedYears": {
                    "type": "list",
                    "name": "loadedYears",
                    "object": {
                        "name": "string",
                        "selected": "boolean",
                        "disabled": "boolean"
                    }
                },
                "value": {
                    "type": "list",
                    "name": "rows",
                    "object": {
                        "row": "JDSDatepickerCalendarRow.row"
                    }
                }
            },
            "jds_datepicker_calendar_row": {
                "row": {
                    "type": "list",
                    "name": "rows.row",
                    "object": {
                        "value": "string",
                        "state": "JDSDatepickerCalendarButton.state"
                    }
                }
            }
        },
        "events": {
            "container": {
                "onSwipeLeft": "onSwipeLeft",
                "onSwipeRight": "onSwipeRight"
            },
            "jds_datepicker_calendar_row": {
                "onClick": "onSelect"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "aria-label": {
                        "name": "_calendarAriaLabel",
                        "value": "Select date from calendar"
                    }
                }
            },
            "jds_datepicker_calendar_row": {
                "properties": {
                    "dateAriaLabel": {
                        "name": "dateAriaLabel",
                        "function": true
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$getNormalisedDate$1 = (value)=>{
    const date = new Date(value || /* @__PURE__ */ new Date());
    if (!date.getTime()) return {
        day: 0,
        month: 0,
        year: 0
    };
    return {
        day: date.getDate(),
        month: date.getMonth() + 1,
        year: date.getFullYear()
    };
};
function $fe5170bdd3625759$var$removeTime(d) {
    d.setHours(0, 0, 0, 0);
    return d;
}
const $fe5170bdd3625759$var$isToday = (date, month, year, day)=>{
    if (year !== date.getFullYear()) return false;
    if (month !== date.getMonth()) return false;
    if (day !== date.getDate()) return false;
    return true;
};
const $fe5170bdd3625759$var$isDateDisabled = (value, disabled, dateFilter, min, max)=>{
    if (dateFilter) return dateFilter(value);
    const { day: day, month: month, year: year } = $fe5170bdd3625759$var$getNormalisedDate$1(value);
    const disabledData = disabled.map((d)=>$fe5170bdd3625759$var$getNormalisedDate$1(d));
    const disabledIndex = disabledData.findIndex((d)=>{
        if (!(d.day === day)) return false;
        if (!(d.month === month)) return false;
        if (!(d.year === year)) return false;
        return true;
    });
    if (disabledIndex >= 0) return true;
    if (min && max) {
        const minDate = $fe5170bdd3625759$var$removeTime(new Date(min));
        const maxDate = $fe5170bdd3625759$var$removeTime(new Date(max));
        const currentValue = $fe5170bdd3625759$var$removeTime(new Date(value));
        return !(currentValue <= maxDate && currentValue >= minDate);
    }
    if (min) {
        const minDate = $fe5170bdd3625759$var$removeTime(new Date(min));
        const currentValue = $fe5170bdd3625759$var$removeTime(new Date(value));
        return !(currentValue >= minDate);
    }
    if (max) {
        const maxDate = $fe5170bdd3625759$var$removeTime(new Date(max));
        const currentValue = $fe5170bdd3625759$var$removeTime(new Date(value));
        return !(currentValue <= maxDate);
    }
};
const $fe5170bdd3625759$var$getDayState = (day, month, year, currentCount, selected)=>{
    const today = /* @__PURE__ */ new Date();
    const selectedDate = $fe5170bdd3625759$var$getNormalisedDate$1(selected);
    if (day - 1 === currentCount && selectedDate.month === month && selectedDate.year === year) return "selected";
    if ($fe5170bdd3625759$var$isToday(today, month - 1, year, currentCount + 1)) return "current";
    return "default";
};
const $fe5170bdd3625759$var$createRows = (month = 0, year = 0, day = 0, disabled = [], dateFilter, selected, min, max)=>{
    const tokens = (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const language = tokens.lang;
    const getMonthDatesFromLocale = (0, $acw62.useMemo)(()=>{
        return (0, $8bd3c5c9ee0d1eb4$export$4ee93fd31f185549)(language);
    }, [
        language
    ]);
    const visibleMonth = $fe5170bdd3625759$var$removeTime(new Date(year, month - 1, 1));
    const firstDayOfMonth = visibleMonth.getDay();
    const daysInMonth = new Date(year, month, 0).getDate();
    const blanks = [];
    for(let i = 0; i < firstDayOfMonth; i++)blanks.push({
        state: "empty"
    });
    const finalRows = [];
    const rows = Array.from({
        length: daysInMonth
    }).map((_, i)=>{
        return {
            value: i + 1,
            internalIndex: i + 1,
            state: $fe5170bdd3625759$var$getDayState(day, month, year, i, selected),
            disabled: $fe5170bdd3625759$var$isDateDisabled(new Date(year, month - 1, i + 1), disabled, dateFilter, min, max)
        };
    });
    const rowsWithBlanks = blanks.concat(rows);
    while(rowsWithBlanks.length % 7 !== 0)rowsWithBlanks.push({
        state: "empty"
    });
    let sum = 0;
    while(sum <= daysInMonth + 7){
        const localizedRows = rowsWithBlanks.slice(sum, sum + 7).map(({ value: value, state: state, disabled: disabled2, ...rest })=>({
                value: value ? getMonthDatesFromLocale[value - 1] : void 0,
                state: // Adjust index
                state,
                disabled: disabled2,
                ...rest
            }));
        finalRows.push({
            row: localizedRows
        });
        sum = sum + 7;
    }
    return finalRows;
};
const $fe5170bdd3625759$var$loadedYears = (max = 0, min = 0, selected, disabled)=>{
    const tokens = (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const language = tokens.lang;
    const numeralList = (0, $acw62.useMemo)(()=>{
        return (0, $8bd3c5c9ee0d1eb4$export$3f81e69b9bc596cd)(language);
    }, [
        language
    ]);
    const getLocaleYear = (year)=>{
        const yearString = year?.toString();
        return yearString?.replace(/\d/g, (num)=>numeralList[parseInt(num, 10)] ?? num);
    };
    return Array.from({
        length: max - min
    }).map((_, i)=>{
        return {
            name: getLocaleYear(min + i),
            value: min + i,
            selected: min + i === selected,
            disabled: disabled?.[i] === true
        };
    });
};
const $fe5170bdd3625759$var$loadedMonths = (selected, selectedYear, selectable, min, max)=>{
    const { month: minMonth, year: minYear } = $fe5170bdd3625759$var$getNormalisedDate$1(min);
    const { month: maxMonth, year: maxYear } = $fe5170bdd3625759$var$getNormalisedDate$1(max);
    const tokens = (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const language = tokens?.lang;
    const getMonthNamesFromLocale = (0, $acw62.useMemo)(()=>{
        return (0, $8bd3c5c9ee0d1eb4$export$cae41416faa27367)(language);
    }, [
        language
    ]);
    return getMonthNamesFromLocale.map((month, i)=>{
        let disabled = false;
        if (selectedYear === minYear && min) disabled = i + 1 < minMonth;
        if (selectedYear === maxYear && max) disabled = disabled || i + 1 > maxMonth;
        return {
            name: month,
            value: i + 1,
            selected: selected === i + 1,
            disabled: !selectable || disabled
        };
    });
};
const $fe5170bdd3625759$var$getDisabledYears = (minYear, maxYear, minDate, maxDate)=>{
    if (!minDate && !maxDate) return [];
    const { year: currentMinYear } = $fe5170bdd3625759$var$getNormalisedDate$1(minDate);
    const { year: currentMaxYear } = $fe5170bdd3625759$var$getNormalisedDate$1(maxDate);
    const years = Array.from({
        length: maxYear - minYear
    }).map((_, i)=>{
        const year = minYear + i;
        if (minDate && maxDate) return year < currentMinYear || year > currentMaxYear;
        if (minDate) return year < currentMinYear;
        if (maxDate) return year > currentMaxYear;
        return false;
    });
    return years;
};
const $fe5170bdd3625759$var$withLogic$1N = (Component)=>(props)=>{
        const { month: month, year: year, day: day } = props;
        const tokens = (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
        const language = tokens.lang;
        const getWeekdayInitialsFromLocale = (0, $acw62.useMemo)(()=>{
            return (0, $8bd3c5c9ee0d1eb4$export$3d12634d88530fee)(language);
        }, [
            language
        ]);
        const rows = $fe5170bdd3625759$var$createRows(month, year, day, props.disabled.disabledDates, props.disabled.dateFilter, props.selected, props.disabled?.min, props.disabled?.max);
        const selectedDate = props.selected;
        const options = {
            weekday: "long",
            month: "long",
            day: "numeric",
            year: "numeric"
        };
        const dateWithoutTime = selectedDate.toLocaleDateString("en-US", options);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                rows: rows,
                dateAriaLabel: `Selected date ${dateWithoutTime}`,
                days: getWeekdayInitialsFromLocale.map((d)=>({
                        letter: d[0]
                    }))
            }
        });
    };
const $fe5170bdd3625759$var$Component$1P = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1K;
    const { onSwipeLeft: onSwipeLeft = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSwipeRight: onSwipeRight = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSelect: onSelect = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            onSwipeLeft: onSwipeLeft,
            onSwipeRight: onSwipeRight,
            onSelect: onSelect,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDatepickerCalendar", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$cfdbf347b14a0a8d = $fe5170bdd3625759$var$withLogic$1N($fe5170bdd3625759$var$Component$1P);
$fe5170bdd3625759$export$cfdbf347b14a0a8d.displayName = "DatepickerCalendar";
$fe5170bdd3625759$export$cfdbf347b14a0a8d.slotName = "jds_datepicker_calendar";
const $fe5170bdd3625759$var$sdl$1J = {
    "metadata": {
        "version": "1.0.0",
        "id": "date-picker-calender-button-1.0.0",
        "name": "JDSDatepickerCalendarButton",
        "layerName": "jds_datepicker_calendar_button",
        "internal": true
    },
    "hierarchy": {
        "container": [
            {
                "button-container": [
                    "jds-text"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{d_0}",
            "justify-content": "{d_1}",
            "align-items": "{d_2}",
            "height": "{d_6}",
            "show": true
        },
        "button-container": {
            "hidden": false,
            "flex-direction": "{d_8}",
            "justify-content": "{d_9}",
            "align-items": "{d_10}",
            "height": "{d_13}",
            "border-radius": "{d_14}",
            "border-width": 0,
            "border-color": "{d_15}",
            "background-color": "{d_16}",
            "behavior": {
                "hover": {
                    "background-color": "{d_17}"
                },
                "active": {
                    "background-color": "{d_18}"
                },
                "focus": {
                    "background-color": "{d_19}",
                    "border-width": "{d_20}"
                }
            }
        },
        "jds-text": {
            "font-family": "{button}",
            "color": "{primary60}",
            "font-size": "{button}",
            "line-height": "{button}",
            "letter-spacing": "{button}",
            "font-weight": "{button}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "_type": {
            "rounded": {
                "container": {
                    "width": "{d_11}"
                },
                "button-container": {
                    "width": "{d_11}"
                }
            },
            "rectangular": {
                "container": {
                    "width": "{d_5}"
                },
                "button-container": {
                    "height": "{d_6}",
                    "width": "{d_3}",
                    "flex-direction": "{d_0}",
                    "justify-content": "{d_1}",
                    "align-items": "{d_2}"
                }
            }
        },
        "state": {
            "selected": {
                "button-container": {
                    "background-color": "{d_21}"
                },
                "jds-text": {
                    "color": "{primaryInverse}",
                    "behavior": {
                        "hover": {
                            "color": "{primary60}"
                        },
                        "focus": {
                            "color": "{primary60}"
                        }
                    }
                }
            },
            "current": {
                "button-container": {
                    "background-color": "{d_22}"
                }
            },
            "empty": {
                "button-container": {
                    "hidden": true
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{d_23}"
                },
                "button-container": {
                    "disabled": true
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "_type": {
                "values": [
                    "rounded",
                    "rectangular"
                ]
            },
            "state": {
                "values": [
                    "default",
                    "selected",
                    "current",
                    "empty"
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "value"
                }
            }
        },
        "events": {
            "button-container": {
                "onClick": "onClick"
            }
        },
        "a11y": {
            "button-container": {
                "properties": {
                    "role": {
                        "value": "radio"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "function": true
                    },
                    "aria-current": "_ariaCurrent",
                    "aria-checked": "_ariaChecked"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1M = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                ariaLabel: props.state === "selected" ? props.ariaLabel : `${props.value}`,
                _ariaCurrent: props.state === "current" ? "date" : void 0,
                _ariaChecked: props.state === "selected" ? "true" : "false",
                onClick: ()=>{
                    props.onClick?.(props.internalIndex, props.disabled);
                },
                _type: (props.value?.length ?? -1) > 2 ? "rectangular" : "rounded"
            }
        });
    };
const $fe5170bdd3625759$var$Component$1O = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1J;
    const { state: state = "default", disabled: disabled = false, onClick: onClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            state: state,
            disabled: disabled,
            onClick: onClick,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDatepickerCalendarButton", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$2d81f864fd880f98 = $fe5170bdd3625759$var$withLogic$1M($fe5170bdd3625759$var$Component$1O);
$fe5170bdd3625759$export$2d81f864fd880f98.displayName = "DatepickerCalendarButton";
$fe5170bdd3625759$export$2d81f864fd880f98.slotName = "jds_datepicker_calendar_button";
const $fe5170bdd3625759$var$sdl$1I = {
    "metadata": {
        "version": "1.0.0",
        "id": "date-picker-calender-header-1.0.0",
        "name": "JDSDatepickerCalendarHeader",
        "layerName": "jds_datepicker_calendar_header",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "jds-text"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{d_0}",
            "justify-content": "{d_1}",
            "align-items": "{d_2}",
            "width": "{d_3}",
            "show": true
        },
        "jds-text": {
            "font-family": "{bodySBold}",
            "color": "{primaryGrey80}",
            "font-size": "{bodySBold}",
            "line-height": "{bodySBold}",
            "letter-spacing": "{bodySBold}",
            "font-weight": "{bodySBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "text-align": "center",
            "flex": 1
        }
    },
    "variant": {},
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "data": {
            "container": {
                "value": {
                    "type": "list",
                    "name": "days",
                    "object": {
                        "letter": "string"
                    }
                }
            },
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "days.letter"
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "presentation"
                    },
                    "aria-label": "_weekDayAriaLabel"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1L = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$1N = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1I;
    const { custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...rest,
        componentTag: componentTag
    }, "JDSDatepickerCalendarHeader", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$2d5e85746b19c19b = $fe5170bdd3625759$var$withLogic$1L($fe5170bdd3625759$var$Component$1N);
$fe5170bdd3625759$export$2d5e85746b19c19b.displayName = "DatepickerCalendarHeader";
$fe5170bdd3625759$export$2d5e85746b19c19b.slotName = "jds_datepicker_calendar_header";
const $fe5170bdd3625759$var$sdl$1H = {
    "metadata": {
        "version": "1.0.0",
        "id": "date-picker-calender-row-1.0.0",
        "name": "JDSDatepickerCalendarRow",
        "layerName": "jds_datepicker_calendar_row",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "jds_datepicker_calendar_button"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{d_0}",
            "justify-content": "{d_1}",
            "align-items": "{d_2}",
            "width": "{d_3}"
        },
        "jds_datepicker_calendar_button": {
            "flex": 1
        }
    },
    "variant": {},
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "data": {
            "container": {
                "value": {
                    "type": "list",
                    "name": "row",
                    "object": {
                        "value": "string",
                        "state": "JDSDatepickerCalendarButton.state",
                        "disabled": "boolean"
                    }
                }
            },
            "jds_datepicker_calendar_button": {
                "value": {
                    "type": "string",
                    "name": "row.value"
                },
                "state": {
                    "type": "JDSDatepickerCalendarButton.state",
                    "name": "row.state"
                },
                "disabled": {
                    "type": "string",
                    "name": "row.disabled"
                }
            }
        },
        "events": {
            "jds_datepicker_calendar_button": {
                "onClick": "onClick"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "radiogroup"
                    }
                }
            },
            "jds_datepicker_calendar_button": {
                "properties": {
                    "ariaLabel": "dateAriaLabel"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1K = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$1M = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1H;
    const { onClick: onClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            onClick: onClick,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDatepickerCalendarRow", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$703dfd9521d4b08a = $fe5170bdd3625759$var$withLogic$1K($fe5170bdd3625759$var$Component$1M);
$fe5170bdd3625759$export$703dfd9521d4b08a.displayName = "DatepickerCalendarRow";
$fe5170bdd3625759$export$703dfd9521d4b08a.slotName = "jds_datepicker_calendar_row";
const $fe5170bdd3625759$var$JDSDatepickerDesktopInternal = {
    "metadata": {
        "version": "1.0.0",
        "id": "date-picker-desktop-1.0.0",
        "name": "JDSDatepickerDesktopInternal",
        "platform": "web",
        "layerName": "jds_datepicker_desktop_internal",
        "internal": true
    },
    "hierarchy": {
        "container": [
            {
                "top-container": [
                    "left-jds_button",
                    "close-jds_button"
                ]
            },
            {
                "controls-container": [
                    "jds_datepicker_header",
                    {
                        "calender-view-container": [
                            "top-jds_divider",
                            "jds_datepicker_calendar",
                            "jds_datepicker_month_view",
                            "jds_datepicker_year_view"
                        ]
                    }
                ]
            }
        ]
    },
    "base": {
        "container": {
            "background-color": "{d_4}",
            "flex-direction": "{d_5}",
            "justify-content": "{d_6}",
            "align-items": "{d_7}",
            "border-radius": "{d_8}",
            "box-shadow": {
                "x": 0,
                "y": 4,
                "blur": 16,
                "spread": 0,
                "color": "#00000029"
            }
        },
        "top-container": {
            "flex-direction": "{d_9}",
            "justify-content": "{d_10}",
            "align-items": "{d_11}",
            "padding-top": "{d_12}",
            "padding-right": "{d_13}",
            "padding-bottom": "{d_14}",
            "padding-left": "{d_15}",
            "width": "{d_16}"
        },
        "jds_datepicker_header": {
            "state": "default",
            "padding-right": "{d_17}",
            "padding-left": "{d_18}"
        },
        "left-jds_button": {
            "hidden": true,
            "kind": "tertiary",
            "icon": "ic_back",
            "size": "medium"
        },
        "close-jds_button": {
            "kind": "tertiary",
            "icon": "ic_close",
            "size": "medium"
        },
        "controls-container": {
            "flex-direction": "{d_19}",
            "justify-content": "{d_20}",
            "align-items": "{d_21}",
            "gap": "{d_22}"
        },
        "calender-view-container": {
            "flex-direction": "{d_23}",
            "justify-content": "{d_24}",
            "align-items": "{d_25}",
            "height": "{d_26}",
            "width": "{d_27}"
        },
        "top-jds_divider": {
            "pad": "none",
            "orientation": "horizontal",
            "hidden": true
        },
        "jds_datepicker_calendar": {
            "hidden": false,
            "padding-right": "{d_28}",
            "padding-left": "{d_29}",
            "padding-bottom": "{d_30}"
        },
        "jds_datepicker_month_view": {
            "hidden": true
        },
        "jds_datepicker_year_view": {
            "hidden": true
        }
    },
    "variant": {
        "state": {
            "month_view": {
                "top-jds_divider": {
                    "hidden": false
                },
                "top-container": {
                    "justify-content": "{d_32}"
                },
                "left-jds_button": {
                    "hidden": false
                },
                "jds_datepicker_calendar": {
                    "hidden": true
                },
                "jds_datepicker_month_view": {
                    "hidden": false
                },
                "jds_datepicker_header": {
                    "state": "month"
                }
            },
            "year_view": {
                "top-jds_divider": {
                    "hidden": false
                },
                "top-container": {
                    "justify-content": "{d_33}"
                },
                "left-jds_button": {
                    "hidden": false
                },
                "jds_datepicker_calendar": {
                    "hidden": true
                },
                "jds_datepicker_year_view": {
                    "hidden": false
                },
                "jds_datepicker_header": {
                    "state": "year"
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "state": {
                "values": [
                    "default",
                    "month_view",
                    "year_view"
                ]
            }
        },
        "data": {
            "container": {
                "elementRef": {
                    "type": "ref",
                    "name": "triggerRef"
                },
                "_years.yearLoadCount": {
                    "type": "number",
                    "name": "yearLoadCount"
                }
            },
            "jds_datepicker_header": {
                "month": {
                    "type": "string",
                    "name": "monthName"
                },
                "year": {
                    "type": "number",
                    "name": "year"
                },
                "yearSelectable": {
                    "type": "boolean",
                    "name": "yearSelectable"
                },
                "monthSelectable": {
                    "type": "boolean",
                    "name": "monthSelectable"
                }
            },
            "jds_datepicker_month_view": {
                "months": {
                    "type": "list",
                    "name": "months",
                    "object": {
                        "name": "string",
                        "state": "JDSDatepickerCalendarButton.state",
                        "disabled": "boolean"
                    }
                }
            },
            "jds_datepicker_year_view": {
                "current": {
                    "type": "number",
                    "name": "current"
                },
                "loadedYears": {
                    "type": "list",
                    "name": "loadedYears",
                    "object": {
                        "name": "string",
                        "state": "JDSDatepickerCalendarButton.state",
                        "disabled": "boolean"
                    }
                }
            },
            "jds_datepicker_calendar": {
                "day": {
                    "type": "number",
                    "name": "date"
                },
                "month": {
                    "type": "number",
                    "name": "month"
                },
                "year": {
                    "type": "number",
                    "name": "year"
                },
                "selected": {
                    "type": "date",
                    "name": "value"
                },
                "disabled": {
                    "type": "object",
                    "name": "calendarData",
                    "object": {
                        "disabledDays": "list",
                        "disabledDates": "list",
                        "max": "date",
                        "min": "date"
                    }
                }
            }
        },
        "events": {
            "container": {
                "onClick": "_onContainerClick"
            },
            "left-jds_button": {
                "onClick": "_onBack"
            },
            "close-jds_button": {
                "onClick": "onClose"
            },
            "jds_datepicker_header": {
                "onMonthClick": "_onMonthClick",
                "onYearClick": "_onYearClick",
                "onPrev": "_onPrev",
                "onNext": "_onNext"
            },
            "jds_datepicker_month_view": {
                "onSelect": "_onMonthSelect"
            },
            "jds_datepicker_year_view": {
                "onSelect": "_onYearSelect"
            },
            "jds_datepicker_calendar": {
                "onSelect": "onSelect",
                "onSwipeLeft": "_onNextCalendar",
                "onSwipeRight": "_onPrevCalendar"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "dialog"
                    },
                    "aria-label": {
                        "value": "Date Picker"
                    }
                }
            },
            "left-jds_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "previousButtonAriaLabel",
                        "value": "Click to Return"
                    }
                }
            },
            "close-jds_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "closeAriaLabel",
                        "value": "Click to Close"
                    }
                }
            },
            "jds_datepicker_header": {
                "properties": {
                    "previousAriaLabel": "previousMonthAriaLabel",
                    "nextAriaLabel": "nextMonthAriaLabel"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$sdl$1G = {
    "metadata": {
        "version": "1.0.0",
        "id": "date-picker-mobile-1.0.0",
        "name": "JDSDatepickerMobileInternal",
        "layerName": "jds_datepicker_mobile_internal",
        "internal": true
    },
    "hierarchy": {
        "container": [
            {
                "top-container": [
                    "left-jds_button",
                    "close-jds_button"
                ]
            },
            {
                "controls-container": [
                    "jds_datepicker_header",
                    "top-jds_divider",
                    "jds_datepicker_calendar",
                    "jds_datepicker_month_view",
                    "jds_datepicker_year_view"
                ]
            },
            {
                "confirmation-container": [
                    "bottom-jds_divider",
                    {
                        "confirmation-group-container": [
                            "confirm-jds-text",
                            "confirm-jds_button"
                        ]
                    }
                ]
            }
        ]
    },
    "base": {
        "container": {
            "background-color": "{primaryBackground}",
            "flex-direction": "{flexDirection.column}",
            "justify-content": "{justifyContent.start}",
            "align-items": "{alignItems.center}",
            "size": "{size.max}",
            "translate-y": "{size.max}",
            "transition": {
                "property": [
                    "translate-y"
                ],
                "duration": "{rapid}",
                "timing-function": "{easeQuick}"
            }
        },
        "top-container": {
            "flex-direction": "{flexDirection.row}",
            "justify-content": "{justifyContent.end}",
            "align-items": "{alignItems.center}",
            "padding-top": "{xs}",
            "padding-bottom": "{xs}",
            "padding-left": "{s}",
            "padding-right": "{s}",
            "width": "{size.max}"
        },
        "left-jds_button": {
            "hidden": true,
            "kind": "tertiary",
            "icon": "ic_back",
            "size": "medium"
        },
        "close-jds_button": {
            "kind": "tertiary",
            "icon": "ic_close",
            "size": "medium"
        },
        "controls-container": {
            "flex-direction": "{flexDirection.column}",
            "justify-content": "{justifyContent.start}",
            "align-items": "{alignItems.center}",
            "gap": "{m}",
            "flex": 1
        },
        "jds_datepicker_header": {
            "state": "default",
            "padding-left": "{s}",
            "padding-right": "{s}"
        },
        "top-jds_divider": {
            "pad": "none",
            "orientation": "horizontal",
            "hidden": true
        },
        "jds_datepicker_calendar": {
            "hidden": false,
            "padding-left": "{s}",
            "padding-right": "{s}",
            "padding-bottom": "{m}"
        },
        "jds_datepicker_month_view": {
            "hidden": true,
            "padding-left": "{s}",
            "padding-right": "{s}"
        },
        "jds_datepicker_year_view": {
            "hidden": true,
            "padding-left": "{s}",
            "padding-right": "{s}"
        },
        "confirmation-container": {
            "padding-top": 0,
            "padding-bottom": "{m}",
            "flex-direction": "{flexDirection.column}",
            "gap": "{s}",
            "justify-content": "{justifyContent.start}",
            "align-items": "{alignItems.center}",
            "width": "{size.max}"
        },
        "bottom-jds_divider": {
            "pad": "none",
            "orientation": "horizontal"
        },
        "confirmation-group-container": {
            "padding-top": 0,
            "padding-right": "{m}",
            "padding-bottom": 0,
            "padding-left": "{m}",
            "flex-direction": "{flexDirection.column}",
            "justify-content": "{justifyContent.start}",
            "align-items": "{alignItems.center}",
            "gap": "{s}",
            "width": "{size.max}"
        },
        "confirm-jds_button": {
            "fullWidth": true,
            "kind": "primary",
            "size": "medium"
        },
        "confirm-jds-text": {
            "font-family": "{bodySBold}",
            "color": "{primaryGrey80}",
            "font-size": "{bodySBold}",
            "line-height": "{bodySBold}",
            "letter-spacing": "{bodySBold}",
            "font-weight": "{bodySBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "state": {
            "month_view": {
                "top-jds_divider": {
                    "hidden": false
                },
                "top-container": {
                    "justify-content": "{justifyContent.spaceBetween}"
                },
                "left-jds_button": {
                    "hidden": false
                },
                "jds_datepicker_calendar": {
                    "hidden": true
                },
                "jds_datepicker_month_view": {
                    "hidden": false
                },
                "jds_datepicker_header": {
                    "state": "month",
                    "showArrows": false
                }
            },
            "year_view": {
                "top-jds_divider": {
                    "hidden": false
                },
                "top-container": {
                    "justify-content": "{justifyContent.spaceBetween}"
                },
                "left-jds_button": {
                    "hidden": false
                },
                "jds_datepicker_calendar": {
                    "hidden": true
                },
                "jds_datepicker_year_view": {
                    "hidden": false
                },
                "jds_datepicker_header": {
                    "state": "year",
                    "showArrows": false
                }
            }
        },
        "open": {
            "true": {
                "container": {
                    "translate-y": 0
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "state": {
                "values": [
                    "default",
                    "month_view",
                    "year_view"
                ]
            },
            "open": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds_datepicker_header": {
                "month": {
                    "type": "string",
                    "name": "monthName"
                },
                "year": {
                    "type": "string",
                    "name": "year"
                },
                "showArrows": {
                    "type": "boolean",
                    "name": "showArrows"
                },
                "yearSelectable": {
                    "type": "boolean",
                    "name": "yearSelectable"
                },
                "monthSelectable": {
                    "type": "boolean",
                    "name": "monthSelectable"
                }
            },
            "jds_datepicker_month_view": {
                "months": {
                    "type": "list",
                    "name": "months",
                    "object": {
                        "name": "string",
                        "state": "JDSDatepickerCalendarButton.state",
                        "disabled": "boolean"
                    }
                }
            },
            "jds_datepicker_year_view": {
                "current": {
                    "type": "number",
                    "name": "current"
                },
                "data": {
                    "type": "object",
                    "name": "yearData",
                    "object": {
                        "count": "number",
                        "disabled": "list",
                        "min": "number",
                        "max": "number"
                    }
                },
                "loadedYears": {
                    "type": "list",
                    "name": "loadedYears",
                    "object": {
                        "name": "string",
                        "state": "JDSDatepickerCalendarButton.state",
                        "disabled": "boolean"
                    }
                }
            },
            "jds_datepicker_calendar": {
                "day": {
                    "type": "number",
                    "name": "date"
                },
                "month": {
                    "type": "number",
                    "name": "month"
                },
                "year": {
                    "type": "number",
                    "name": "year"
                },
                "selected": {
                    "type": "date",
                    "name": "value"
                },
                "disabled": {
                    "type": "object",
                    "name": "calendarData",
                    "object": {
                        "disabledDays": "list",
                        "disabledDates": "list",
                        "max": "date",
                        "min": "date"
                    }
                },
                "days": {
                    "type": "JDSDatepickerCalendarHeader.days",
                    "name": "calendarDays"
                },
                "rows": {
                    "type": "JDSDatepickerCalendar.rows",
                    "name": "calendarRows"
                }
            },
            "confirm-jds_button": {
                "label": {
                    "type": "string",
                    "name": "_confirmLabel"
                }
            },
            "confirm-jds-text": {
                "value": {
                    "type": "string",
                    "name": "confirmDate"
                }
            }
        },
        "events": {
            "left-jds_button": {
                "onClick": "_onBack"
            },
            "close-jds_button": {
                "onClick": "onClose"
            },
            "jds_datepicker_header": {
                "onMonthClick": "_onMonthClick",
                "onYearClick": "_onYearClick",
                "onPrev": "_onPrev",
                "onNext": "_onNext"
            },
            "jds_datepicker_month_view": {
                "onSelect": "_onMonthSelect"
            },
            "jds_datepicker_year_view": {
                "onSelect": "_onYearSelect"
            },
            "jds_datepicker_calendar": {
                "onSelect": "_onSelect",
                "onSwipeLeft": "_onNextCalendar",
                "onSwipeRight": "_onPrevCalendar"
            },
            "confirm-jds_button": {
                "onClick": "onConfirm"
            }
        },
        "a11y": {
            "left-jds_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "previousButtonAriaLabel",
                        "value": "Tap to Return"
                    }
                }
            },
            "close-jds_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "closeAriaLabel",
                        "value": "Tap to Close"
                    }
                }
            },
            "jds_datepicker_header": {
                "properties": {
                    "previousAriaLabel": "previousMonthAriaLabel",
                    "nextAriaLabel": "nextMonthAriaLabel"
                }
            },
            "confirm-jds_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "confirmAriaLabel",
                        "value": "Tap to Confirm"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$YEAR_COUNT$1 = 50;
const $fe5170bdd3625759$var$withLogic$1J = (Component)=>(props)=>{
        const { yearSelectable: yearSelectable = true, monthSelectable: monthSelectable = true, ...rest } = props;
        const { lang: lang, platform: platform } = (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
        const confirmLabelLocal = (0, $acw62.useMemo)(()=>{
            return (0, $8bd3c5c9ee0d1eb4$export$6d8d0ec03e692fdc)(lang);
        }, [
            lang
        ]);
        const [state, setState] = (0, $acw62.useState)("default");
        const anchorRef = (0, $acw62.useRef)(null);
        const { day: day, month: month, year: year } = $fe5170bdd3625759$var$getNormalisedDate$1(props.value);
        const [selectedMonth, setSelectedMonth] = (0, $acw62.useState)(month);
        const [selectedDate, setSelectedDate] = (0, $acw62.useState)({
            date: day,
            month: month,
            year: year
        });
        const [selectedYear, setSelectedYear] = (0, $acw62.useState)(year);
        (0, $acw62.useEffect)(()=>{
            const { day: day2, month: month2, year: year2 } = $fe5170bdd3625759$var$getNormalisedDate$1(props.value);
            setSelectedDate({
                date: day2,
                month: month2,
                year: year2
            });
            setSelectedYear(year2);
            setSelectedMonth(month2);
        }, [
            props.value
        ]);
        const [firstChild = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {}), ...restChildren] = (0, $acw62.Children).toArray(props.children);
        const formattedConfirmDate = new Date(selectedDate.year, selectedDate.month - 1, selectedDate.date).toLocaleDateString(lang, {
            weekday: "short",
            day: "2-digit",
            month: "long",
            year: "numeric"
        });
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
                    ...{
                        ...rest,
                        onClose: ()=>{
                            props.onClose?.();
                            setState("default");
                        },
                        yearSelectable: yearSelectable,
                        monthSelectable: monthSelectable,
                        confirmDate: formattedConfirmDate,
                        _confirmLabel: confirmLabelLocal,
                        value: new Date(selectedDate.year, selectedDate.month - 1, selectedDate.date),
                        onClick: (ev)=>ev.stopPropagation(),
                        date: selectedDate.date,
                        month: selectedMonth,
                        year: selectedYear,
                        monthName: selectedMonth - 1,
                        months: $fe5170bdd3625759$var$loadedMonths(selectedMonth - 1, selectedYear, monthSelectable, props.calendarData?.min, props.calendarData?.max),
                        loadedYears: $fe5170bdd3625759$var$loadedYears(selectedYear + $fe5170bdd3625759$var$YEAR_COUNT$1 / 2, selectedYear - $fe5170bdd3625759$var$YEAR_COUNT$1 / 2, selectedYear, $fe5170bdd3625759$var$getDisabledYears(selectedYear - $fe5170bdd3625759$var$YEAR_COUNT$1 / 2, selectedYear + $fe5170bdd3625759$var$YEAR_COUNT$1 / 2, props.calendarData?.min, props.calendarData?.max)),
                        current: selectedYear,
                        state: state,
                        onConfirm: ()=>{
                            const date = new Date(selectedDate.year, selectedDate.month - 1, selectedDate.date);
                            props.onSelect?.(date);
                            props.onConfirm?.(date);
                            props?.onClose?.();
                        },
                        _onYearClick: ()=>setState("year_view"),
                        _onMonthClick: ()=>setState("month_view"),
                        _onBack: ()=>setState("default"),
                        _onSelect: (num)=>{
                            setSelectedDate({
                                date: num,
                                month: selectedMonth,
                                year: selectedYear
                            });
                            setState("default");
                        },
                        onSelect: (num, disabled)=>{
                            setSelectedDate({
                                date: num,
                                month: selectedMonth,
                                year: selectedYear
                            });
                            if (!disabled && platform === "desktop") {
                                props.onSelect?.(new Date(selectedYear, selectedMonth - 1, num));
                                props.onClose?.();
                            }
                            setState("default");
                        },
                        _onMonthSelect: (i)=>{
                            if (monthSelectable) {
                                setSelectedMonth(i);
                                setState("default");
                            }
                        },
                        _onYearSelect: (i)=>{
                            if (yearSelectable) {
                                setSelectedYear(i);
                                setState("default");
                            }
                        },
                        _onPrev: ()=>setSelectedMonth((m)=>{
                                if (m === 1) {
                                    setSelectedYear(selectedYear - 1);
                                    return 12;
                                }
                                return m - 1;
                            }),
                        _onNext: ()=>setSelectedMonth((m)=>{
                                if (m === 12) {
                                    setSelectedYear(selectedYear + 1);
                                    return 1;
                                }
                                return m + 1;
                            })
                    }
                }),
                (0, $acw62.cloneElement)(firstChild, {
                    ref: anchorRef
                }),
                restChildren
            ]
        });
    };
const $fe5170bdd3625759$var$Component$1L = (props)=>{
    const { platform: platform, ...restSwitchables } = (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = platform === "desktop" ? $fe5170bdd3625759$var$JDSDatepickerDesktopInternal : $fe5170bdd3625759$var$sdl$1G;
    const { state: state = "default", onClose: onClose = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSelect: onSelect = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), previousButtonAriaLabel: previousButtonAriaLabel = "Click to Return", closeAriaLabel: closeAriaLabel = "Click to Close", custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            state: state,
            onClose: onClose,
            onSelect: onSelect,
            previousButtonAriaLabel: previousButtonAriaLabel,
            closeAriaLabel: closeAriaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDatepickerDesktopInternal", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$1f2289af8fea154d = $fe5170bdd3625759$var$withLogic$1J($fe5170bdd3625759$var$Component$1L);
$fe5170bdd3625759$export$1f2289af8fea154d.displayName = "DatepickerDesktopInternal";
$fe5170bdd3625759$export$1f2289af8fea154d.slotName = "jds_datepicker_desktop_internal";
const $fe5170bdd3625759$var$sdl$1F = {
    "metadata": {
        "version": "1.0.0",
        "id": "date-picker-header-1.0.0",
        "name": "JDSDatepickerHeader",
        "layerName": "jds_datepicker_header",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "left-jds_button",
            {
                "inner-container": [
                    "month-jds_datepicker_button",
                    "year-jds_datepicker_button"
                ]
            },
            "right-jds_button"
        ]
    },
    "base": {
        "container": {
            "width": "{d_0}",
            "height": "{d_1}",
            "flex-direction": "{d_2}",
            "justify-content": "{d_3}",
            "align-items": "{d_4}"
        },
        "inner-container": {
            "height": "{d_5}",
            "flex-direction": "{d_6}",
            "justify-content": "{d_7}",
            "align-items": "{d_8}",
            "gap": "{d_9}",
            "flex": 1
        },
        "left-jds_button": {
            "hidden": false,
            "kind": "tertiary",
            "icon": "ic_chevron_left",
            "size": "medium"
        },
        "right-jds_button": {
            "hidden": false,
            "kind": "tertiary",
            "icon": "ic_chevron_right",
            "size": "medium"
        },
        "month-jds_datepicker_button": {
            "state": "default"
        },
        "year-jds_datepicker_button": {
            "state": "default"
        }
    },
    "variant": {
        "state": {
            "month": {
                "month-jds_datepicker_button": {
                    "state": "selected"
                }
            },
            "year": {
                "year-jds_datepicker_button": {
                    "state": "selected"
                }
            }
        },
        "showArrows": {
            "false": {
                "left-jds_button": {
                    "hidden": true
                },
                "right-jds_button": {
                    "hidden": true
                }
            }
        },
        "monthSelectable": {
            "false": {
                "month-jds_datepicker_button": {
                    "state": "disabled"
                }
            }
        },
        "yearSelectable": {
            "false": {
                "year-jds_datepicker_button": {
                    "state": "disabled"
                }
            }
        }
    },
    "combination": [
        {
            "false": {
                "false": {
                    "month-jds_datepicker_button": {
                        "state": "text_only"
                    },
                    "year-jds_datepicker_button": {
                        "state": "text_only"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "monthSelectable",
            "yearSelectable"
        ]
    ],
    "api": {
        "config": {
            "state": {
                "values": [
                    "default",
                    "month",
                    "year"
                ]
            },
            "showArrows": {
                "values": [
                    true,
                    false
                ]
            },
            "monthSelectable": {
                "values": [
                    true,
                    false
                ]
            },
            "yearSelectable": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "month-jds_datepicker_button": {
                "text": {
                    "type": "string",
                    "name": "month"
                }
            },
            "year-jds_datepicker_button": {
                "text": {
                    "type": "string",
                    "name": "year"
                }
            }
        },
        "events": {
            "left-jds_button": {
                "onClick": "onPrev"
            },
            "month-jds_datepicker_button": {
                "onClick": "onMonthClick"
            },
            "year-jds_datepicker_button": {
                "onClick": "onYearClick"
            },
            "right-jds_button": {
                "onClick": "onNext"
            }
        },
        "a11y": {
            "left-jds_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "previousAriaLabel",
                        "value": "Navigate to previous month"
                    }
                }
            },
            "right-jds_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "nextAriaLabel",
                        "value": "Navigate to next month"
                    }
                }
            },
            "month-jds_datepicker_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "_monthAriaLabel"
                    }
                }
            },
            "year-jds_datepicker_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "_yearAriaLabel"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1I = (Component)=>(props)=>{
        const tokens = (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
        const language = tokens.lang;
        const numeralList = (0, $acw62.useMemo)(()=>{
            return (0, $8bd3c5c9ee0d1eb4$export$3f81e69b9bc596cd)(language);
        }, [
            language
        ]);
        const getLocaleYear = (year)=>{
            const yearString = year?.toString();
            return yearString?.replace(/\d/g, (num)=>numeralList[parseInt(num, 10)] ?? num);
        };
        const getMonthNamesFromLocale = (0, $acw62.useMemo)(()=>{
            return (0, $8bd3c5c9ee0d1eb4$export$cae41416faa27367)(language);
        }, [
            language
        ]);
        const monthNames = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ];
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                _monthAriaLabel: props.state === "month" ? "Select month" : `${monthNames[Number(props.month)]}, Select month`,
                _yearAriaLabel: props.state === "year" ? "Select year" : `${props.year}, Select year`
            },
            year: getLocaleYear(Number(props.year)),
            month: getMonthNamesFromLocale[Number(props.month)]
        });
    };
const $fe5170bdd3625759$var$Component$1K = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1F;
    const { state: state = "default", showArrows: showArrows = true, monthSelectable: monthSelectable = true, yearSelectable: yearSelectable = true, onPrev: onPrev = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onMonthClick: onMonthClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onYearClick: onYearClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onNext: onNext = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), previousAriaLabel: previousAriaLabel = "Navigate to previous month", nextAriaLabel: nextAriaLabel = "Navigate to next month", custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            state: state,
            showArrows: showArrows,
            monthSelectable: monthSelectable,
            yearSelectable: yearSelectable,
            onPrev: onPrev,
            onMonthClick: onMonthClick,
            onYearClick: onYearClick,
            onNext: onNext,
            previousAriaLabel: previousAriaLabel,
            nextAriaLabel: nextAriaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDatepickerHeader", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$4677d90cce08ec53 = $fe5170bdd3625759$var$withLogic$1I($fe5170bdd3625759$var$Component$1K);
$fe5170bdd3625759$export$4677d90cce08ec53.displayName = "DatepickerHeader";
$fe5170bdd3625759$export$4677d90cce08ec53.slotName = "jds_datepicker_header";
const $fe5170bdd3625759$var$sdl$1E = {
    "metadata": {
        "version": "1.0.0",
        "id": "date-picker-month-view-1.0.0",
        "name": "JDSDatepickerMonthView",
        "layerName": "jds_datepicker_month_view",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "jds_datepicker_calendar_button"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{d_0}",
            "height": "{d_1}",
            "width": "{d_2}",
            "align-items": "{d_3}",
            "overflow": "scroll"
        }
    },
    "variant": {},
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "data": {
            "container": {
                "value": {
                    "type": "list",
                    "name": "months",
                    "object": {
                        "name": "string",
                        "state": "JDSDatepickerCalendarButton.state",
                        "disabled": "boolean"
                    }
                }
            },
            "jds_datepicker_calendar_button": {
                "value": {
                    "type": "string",
                    "name": "months.name"
                },
                "state": {
                    "type": "JDSDatepickerCalendarButton.state",
                    "name": "months.state"
                },
                "disabled": {
                    "type": "boolean",
                    "name": "months.disabled"
                }
            }
        },
        "events": {
            "jds_datepicker_calendar_button": {
                "onClick": "onSelect"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "list"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1H = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                onSelect: (i)=>{
                    props?.onSelect?.(props.months?.[i]?.value);
                }
            }
        });
    };
const $fe5170bdd3625759$var$Component$1J = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1E;
    const { onSelect: onSelect = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            onSelect: onSelect,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDatepickerMonthView", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$df8c284ffe0bf6ce = $fe5170bdd3625759$var$withLogic$1H($fe5170bdd3625759$var$Component$1J);
$fe5170bdd3625759$export$df8c284ffe0bf6ce.displayName = "DatepickerMonthView";
$fe5170bdd3625759$export$df8c284ffe0bf6ce.slotName = "jds_datepicker_month_view";
const $fe5170bdd3625759$var$sdl$1D = {
    "metadata": {
        "version": "1.0.0",
        "id": "date-picker-view-button-1.0.0",
        "name": "JDSDatepickerViewButton",
        "layerName": "jds_datepicker_view_button",
        "internal": true
    },
    "hierarchy": {
        "root-container": [
            {
                "container": [
                    "jds_button"
                ]
            }
        ]
    },
    "base": {
        "root-container": {
            "width": "{d_0}",
            "flex-direction": "{d_1}",
            "justify-content": "{d_2}",
            "align-items": "{d_3}"
        },
        "container": {
            "height": "{d_4}",
            "width": "{d_5}",
            "flex-direction": "{d_6}",
            "justify-content": "{d_7}",
            "align-items": "{d_8}"
        },
        "jds_button": {
            "kind": "tertiary",
            "size": "medium",
            "fullWidth": true,
            "state": "normal"
        }
    },
    "variant": {
        "selected": {
            "true": {
                "jds_button": {
                    "kind": "primary"
                }
            }
        },
        "disabled": {
            "true": {
                "jds_button": {
                    "disabled": true
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "disabled": {
                "values": [
                    false,
                    true
                ]
            },
            "selected": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds_button": {
                "label": {
                    "type": "string",
                    "name": "name"
                },
                "disabled": {
                    "type": "boolean",
                    "name": "disabled"
                }
            }
        },
        "events": {
            "jds_button": {
                "onClick": "onSelect"
            }
        },
        "a11y": {
            "jds_button": {
                "properties": {
                    "ariaLabel": "ariaLabel"
                }
            },
            "container": {
                "properties": {
                    "role": {
                        "value": "listitem"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1G = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                onSelect: ()=>{
                    props?.onSelect?.(props.internalIndex + 1);
                }
            }
        });
    };
const $fe5170bdd3625759$var$Component$1I = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1D;
    const { disabled: disabled = false, selected: selected = false, onSelect: onSelect = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            disabled: disabled,
            selected: selected,
            onSelect: onSelect,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDatepickerViewButton", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$99c3540c4320b145 = $fe5170bdd3625759$var$withLogic$1G($fe5170bdd3625759$var$Component$1I);
$fe5170bdd3625759$export$99c3540c4320b145.displayName = "DatepickerViewButton";
$fe5170bdd3625759$export$99c3540c4320b145.slotName = "jds_datepicker_view_button";
const $fe5170bdd3625759$var$sdl$1C = {
    "metadata": {
        "version": "1.0.0",
        "id": "date-picker-year-view-1.0.0",
        "name": "JDSDatepickerYearView",
        "layerName": "jds_datepicker_year_view",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "jds_datepicker_calendar_button"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{d_0}",
            "height": 300,
            "width": "{d_1}",
            "align-items": "{d_2}",
            "overflow": "scroll"
        }
    },
    "variant": {},
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "data": {
            "container": {
                "value": {
                    "type": "list",
                    "name": "loadedYears",
                    "object": {
                        "name": "string",
                        "state": "JDSDatepickerCalendarButton.state",
                        "disabled": "boolean"
                    }
                }
            },
            "jds_datepicker_calendar_button": {
                "value": {
                    "type": "string",
                    "name": "loadedYears.name"
                },
                "state": {
                    "type": "JDSDatepickerCalendarButton.state",
                    "name": "loadedYears.state"
                },
                "disabled": {
                    "type": "boolean",
                    "name": "loadedYears.disabled"
                }
            }
        },
        "events": {
            "container": {
                "onScroll": {
                    "name": "onScroll",
                    "platform": "web"
                }
            },
            "jds_datepicker_calendar_button": {
                "onClick": "onSelect"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "list"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1F = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                onSelect: (i)=>{
                    props?.onSelect?.(props.loadedYears?.[i]?.value);
                }
            }
        });
    };
const $fe5170bdd3625759$var$Component$1H = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1C;
    const { onScroll: onScroll = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSelect: onSelect = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            onScroll: onScroll,
            onSelect: onSelect,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDatepickerYearView", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$59892f17b1991230 = $fe5170bdd3625759$var$withLogic$1F($fe5170bdd3625759$var$Component$1H);
$fe5170bdd3625759$export$59892f17b1991230.displayName = "DatepickerYearView";
$fe5170bdd3625759$export$59892f17b1991230.slotName = "jds_datepicker_year_view";
const $fe5170bdd3625759$var$sdl$1B = {
    "metadata": {
        "version": "1.0.0",
        "id": "desktop-bottom-sheet-1.0.0",
        "name": "JDSDesktopBottomSheetInternal",
        "layerName": "jds_desktop_bottom_sheet_internal",
        "platform": "web",
        "internal": true
    },
    "hierarchy": {
        "container": [
            {
                "root-container": [
                    {
                        "cancel-container": [
                            {
                                "back-container": [
                                    "back-jds_button"
                                ]
                            },
                            "cancel-jds_button",
                            "step-jds-text"
                        ]
                    },
                    {
                        "vertical-container": [
                            "title-jds-text",
                            "description-jds-text",
                            "children-slot",
                            {
                                "cta-container": [
                                    "primary-jds_action_button",
                                    "secondary-jds_action_button"
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "custom-container": [
                    "children-slot"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{d_0}",
            "justify-content": "{d_13}",
            "align-items": "{d_14}"
        },
        "root-container": {
            "hidden": true,
            "z-index": 1,
            "flex-direction": "{d_24}",
            "justify-content": "{d_25}",
            "background-color": "{d_26}",
            "align-items": "{d_27}",
            "border-top-left-radius": "{d_28}",
            "border-top-right-radius": "{d_29}",
            "width": "{d_15}",
            "translate-y": "{d_16}",
            "enter-animation-name": "slideVerticallyUp",
            "exit-animation-name": "slideVerticallyDown",
            "enter-animation-curve": "entrance_ease",
            "exit-animation-curve": "exit_ease",
            "enter-animation-duration": 500,
            "exit-animation-duration": 500,
            "transition": {
                "property": [
                    "translate-y"
                ],
                "duration": "{d_17}",
                "timing-function": "{d_18}"
            }
        },
        "cancel-container": {
            "hidden": false,
            "flex-direction": "{d_30}",
            "justify-content": "{d_31}",
            "align-items": "{d_32}",
            "width": "{d_33}",
            "padding-top": "{d_34}",
            "padding-bottom": "{d_35}",
            "padding-left": "{d_36}",
            "padding-right": "{d_37}",
            "gap": "{d_38}"
        },
        "cancel-jds_button": {
            "hidden": false,
            "icon": "ic_close",
            "size": "medium",
            "kind": "tertiary"
        },
        "vertical-container": {
            "flex-direction": "{d_39}",
            "justify-content": "{d_40}",
            "align-items": "{d_41}",
            "padding-left": "{d_42}",
            "padding-right": "{d_43}",
            "width": "{d_44}"
        },
        "primary-jds_action_button": {
            "hidden": false,
            "kind": "primary",
            "size": "medium",
            "appearance": "normal",
            "state": "normal",
            "stretch": true
        },
        "secondary-jds_action_button": {
            "hidden": false,
            "kind": "secondary",
            "size": "medium",
            "appearance": "normal",
            "state": "normal",
            "stretch": true
        },
        "cta-container": {
            "flex-direction": "{d_47}",
            "gap": "{d_48}",
            "width": "{d_49}",
            "padding-bottom": "{d_50}",
            "padding-top": "{d_51}"
        },
        "back-container": {
            "flex": 1,
            "hidden": true
        },
        "back-jds_button": {
            "kind": "tertiary",
            "icon": "ic_back"
        },
        "custom-container": {
            "hidden": true,
            "z-index": 1,
            "flex-direction": "{d_1}",
            "justify-content": "{d_2}",
            "align-items": "{d_3}",
            "background-color": "{d_4}",
            "border-top-left-radius": "{d_5}",
            "border-top-right-radius": "{d_6}",
            "padding-left": "{d_7}",
            "padding-right": "{d_8}",
            "padding-top": "{d_9}",
            "padding-bottom": "{d_10}",
            "width": "{d_11}",
            "translate-y": "{d_12}",
            "transition": {
                "property": [
                    "translate-y"
                ],
                "duration": "{medium}",
                "timing-function": "{easeEntrance}"
            }
        },
        "title-jds-text": {
            "font-family": "{headingXs}",
            "color": "{primaryGrey100}",
            "font-size": "{headingXs}",
            "line-height": "{headingXs}",
            "letter-spacing": "{headingXs}",
            "font-weight": "{headingXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 2,
            "padding-bottom": "{d_45}",
            "maxLines": 2
        },
        "description-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "padding-bottom": "{d_46}"
        },
        "step-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey100}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": true,
            "padding-right": "{d_52}"
        }
    },
    "variant": {
        "controlType": {
            "stepper": {
                "back-container": {
                    "hidden": false
                },
                "cancel-jds_button": {
                    "hidden": true
                },
                "step-jds-text": {
                    "hidden": false
                }
            }
        },
        "buttonOrientation": {
            "horizontal": {
                "cta-container": {
                    "flex-direction": "{flexDirection.row}"
                }
            }
        },
        "kind": {
            "passive": {
                "root-container": {
                    "box-shadow": {
                        "x": 0,
                        "y": 4,
                        "blur": 16,
                        "spread": 0,
                        "color": "{d_53}"
                    }
                }
            }
        },
        "close": {
            "false": {
                "root-container": {
                    "translate-y": 0,
                    "hidden": false
                }
            }
        },
        "primaryCtaDisabled": {
            "true": {
                "primary-jds_action_button": {
                    "state": "disabled"
                }
            }
        },
        "secondaryCtaDisabled": {
            "true": {
                "secondary-jds_action_button": {
                    "state": "disabled"
                }
            }
        }
    },
    "combination": [
        {
            "false": {
                "true": {
                    "custom-container": {
                        "hidden": false,
                        "translate-y": 0
                    },
                    "root-container": {
                        "hidden": true,
                        "translate-y": "{size.max}"
                    },
                    "vertical-container": {
                        "hidden": true
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "close",
            "isCustom"
        ]
    ],
    "api": {
        "config": {
            "kind": {
                "values": [
                    "overlay",
                    "passive"
                ]
            },
            "controlType": {
                "values": [
                    "normal",
                    "stepper"
                ]
            },
            "buttonOrientation": {
                "values": [
                    "vertical",
                    "horizontal"
                ]
            },
            "isCustom": {
                "values": [
                    false,
                    true
                ]
            },
            "close": {
                "values": [
                    true,
                    false
                ]
            },
            "primaryCtaDisabled": {
                "values": [
                    false,
                    true
                ]
            },
            "secondaryCtaDisabled": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "root-container": {
                "max-height": {
                    "type": "number",
                    "name": "height"
                }
            },
            "primary-jds_action_button": {
                "label": {
                    "type": "string",
                    "name": "primaryCTA"
                }
            },
            "secondary-jds_action_button": {
                "label": {
                    "type": "string",
                    "name": "secondaryCTA"
                }
            },
            "title-jds-text": {
                "value": {
                    "type": "string",
                    "name": "title"
                }
            },
            "description-jds-text": {
                "value": {
                    "type": "string",
                    "name": "description"
                }
            },
            "step-jds-text": {
                "value": {
                    "type": "string",
                    "name": "step_label"
                }
            }
        },
        "children": {
            "children-slot": {
                "name": "children",
                "accepts": [
                    "any"
                ],
                "max": 1
            }
        },
        "events": {
            "root-container": {
                "onClick": "onBottomSheetClick",
                "onSwipeDown": "onClose"
            },
            "custom-container": {
                "onClick": "onBottomSheetClick",
                "onSwipeDown": "onClose"
            },
            "cancel-jds_button": {
                "onClick": "onCancel"
            },
            "primary-jds_action_button": {
                "onClick": "onPrimaryClick"
            },
            "secondary-jds_action_button": {
                "onClick": "onSecondaryClick"
            },
            "back-jds_button": {
                "onClick": "onBack"
            }
        },
        "a11y": {
            "root-container": {
                "properties": {
                    "role": {
                        "value": "dialog"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "value": "Bottom Sheet Content"
                    },
                    "aria-modal": {
                        "name": "_ariaModal"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "cancel-jds_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "cancelButtonAriaLabel",
                        "value": "Close Modal"
                    }
                }
            },
            "back-jds_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "backButtonAriaLabel",
                        "value": "Click to go Back"
                    }
                }
            },
            "primary-jds_action_button": {
                "properties": {
                    "ariaLabel": "primaryCtaAriaLabel",
                    "ariaDescribedby": {
                        "name": "primaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "secondary-jds_action_button": {
                "properties": {
                    "ariaLabel": "secondaryCtaAriaLabel",
                    "ariaDescribedby": {
                        "name": "secondaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$PROP_MAP$p = (props)=>{
    return {
        primaryCTA: {
            properties: {
                primaryCTA: $fe5170bdd3625759$var$resolvePropObjectKeys(props.primaryCTA, "title", ""),
                onPrimaryClick: props.primaryCTA?.onClick || props.onPrimaryClick
            }
        },
        secondaryCTA: {
            properties: {
                secondaryCTA: $fe5170bdd3625759$var$resolvePropObjectKeys(props.secondaryCTA, "title", ""),
                onSecondaryClick: props.secondaryCTA?.onClick || props.onSecondaryClick
            }
        }
    };
};
const $fe5170bdd3625759$var$withLogic$1E = (Component)=>(userProps)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$p);
        const { close: close, onRequestClose: onRequestClose, onClose: onClose, ...rest } = props;
        const allowClose = !onRequestClose || onRequestClose();
        const closeFn = ()=>{
            if (allowClose) onClose?.();
        };
        const { mobile: mobile } = $fe5170bdd3625759$var$Devices.useMedia();
        $fe5170bdd3625759$var$useEscapeClose(closeFn, allowClose);
        if (mobile) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$var$BottomSheet$1, {
            ...userProps
        });
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...rest,
                onBack: ()=>{
                    props.stepperConfig?.onBack?.(props.stepperConfig.activeStep);
                },
                label: props.stepperConfig?.indicatorText,
                _ariaModal: props.kind === "overlay" || !props.close ? "true" : "false",
                _onBottomSheetClick: (ev)=>ev.stopPropagation(),
                close: close,
                onCancel: ()=>{
                    if (allowClose) closeFn();
                },
                onClose: ()=>{
                    if (allowClose) closeFn();
                }
            }
        });
    };
const $fe5170bdd3625759$var$Component$1G = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1B;
    const { kind: kind = "overlay", controlType: controlType = "normal", buttonOrientation: buttonOrientation = "vertical", isCustom: isCustom = false, close: close = true, primaryCtaDisabled: primaryCtaDisabled = false, secondaryCtaDisabled: secondaryCtaDisabled = false, onBottomSheetClick: onBottomSheetClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onClose: onClose = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onCancel: onCancel = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onPrimaryClick: onPrimaryClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSecondaryClick: onSecondaryClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onBack: onBack = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), ariaLabel: ariaLabel = "Bottom Sheet Content", cancelButtonAriaLabel: cancelButtonAriaLabel = "Close Modal", backButtonAriaLabel: backButtonAriaLabel = "Click to go Back", custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            controlType: controlType,
            buttonOrientation: buttonOrientation,
            isCustom: isCustom,
            close: close,
            primaryCtaDisabled: primaryCtaDisabled,
            secondaryCtaDisabled: secondaryCtaDisabled,
            onBottomSheetClick: onBottomSheetClick,
            onClose: onClose,
            onCancel: onCancel,
            onPrimaryClick: onPrimaryClick,
            onSecondaryClick: onSecondaryClick,
            onBack: onBack,
            ariaLabel: ariaLabel,
            cancelButtonAriaLabel: cancelButtonAriaLabel,
            backButtonAriaLabel: backButtonAriaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDesktopBottomSheetInternal", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$a20173db319b8774 = $fe5170bdd3625759$var$withLogic$1E($fe5170bdd3625759$var$Component$1G);
$fe5170bdd3625759$export$a20173db319b8774.displayName = "DesktopBottomSheetInternal";
$fe5170bdd3625759$export$a20173db319b8774.slotName = "jds_desktop_bottom_sheet_internal";
const $fe5170bdd3625759$var$sdl$1A = {
    "metadata": {
        "version": "1.0.0",
        "id": "divider-1.0.0",
        "name": "JDSDivider",
        "layerName": "jds_divider",
        "description": "Dividers are used to group and divide contents within a page.",
        "usage": "Dividers are used inorder to establish clear grouping of content or emphasize the in-between boundaries of a list of content."
    },
    "hierarchy": {
        "container": [
            "start-container",
            "jds-text",
            "end-container"
        ]
    },
    "base": {
        "container": {
            "hidden": false,
            "background-color": "{d_0}",
            "flex-direction": "{d_1}",
            "justify-content": "{d_2}",
            "align-items": "{d_3}",
            "gap": "{d_4}",
            "flex": 1,
            "padding-left": "{d_5}",
            "padding-right": "{d_6}",
            "padding-top": "{d_7}",
            "padding-bottom": "{d_8}"
        },
        "start-container": {
            "hidden": false,
            "min-height": "{d_9}",
            "min-width": "{d_10}",
            "flex-direction": "{d_11}",
            "flex": 1,
            "background-color": "{d_12}",
            "border-radius": "{d_13}",
            "show": true
        },
        "end-container": {
            "hidden": true,
            "min-height": "{d_14}",
            "min-width": "{d_15}",
            "flex-direction": "{d_16}",
            "flex": 1,
            "background-color": "{d_17}",
            "border-radius": "{d_18}",
            "show": true
        },
        "jds-text": {
            "font-family": "{bodyXsBold}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXsBold}",
            "line-height": "{bodyXsBold}",
            "letter-spacing": "{bodyXsBold}",
            "font-weight": "{bodyXsBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": true
        }
    },
    "variant": {
        "variant": {
            "stepper": {
                "start-container": {
                    "background-color": "{d_19}"
                },
                "end-container": {
                    "background-color": "{d_20}"
                }
            }
        },
        "orientation": {
            "horizontal": {
                "container": {
                    "width": "{d_21}"
                },
                "start-container": {
                    "height": 1
                },
                "end-container": {
                    "height": 1
                }
            },
            "vertical": {
                "container": {
                    "height": "{d_22}",
                    "flex-direction": "{d_23}"
                },
                "start-container": {
                    "width": 1,
                    "flex-direction": "{d_24}",
                    "flex": 1
                },
                "end-container": {
                    "width": 1,
                    "flex-direction": "{d_25}",
                    "flex": 1
                }
            }
        },
        "pad": {
            "none": {
                "container": {
                    "padding-top": 0,
                    "padding-bottom": 0,
                    "padding-right": 0,
                    "padding-left": 0
                }
            }
        },
        "_withLabel": {
            "true": {
                "end-container": {
                    "hidden": false
                },
                "jds-text": {
                    "hidden": false
                }
            }
        }
    },
    "combination": [
        {
            "base": {
                "all": {
                    "container": {
                        "padding-left": "{d_26}",
                        "padding-right": "{d_27}",
                        "padding-top": "{d_28}",
                        "padding-bottom": "{d_29}"
                    }
                },
                "left": {
                    "container": {
                        "padding-left": "{d_30}",
                        "padding-right": 0,
                        "padding-top": 0,
                        "padding-bottom": 0
                    }
                },
                "right": {
                    "container": {
                        "padding-right": "{d_31}",
                        "padding-left": 0,
                        "padding-top": 0,
                        "padding-bottom": 0
                    }
                },
                "top": {
                    "container": {
                        "padding-bottom": 0,
                        "padding-right": 0,
                        "padding-left": 0,
                        "padding-top": "{d_32}"
                    }
                },
                "bottom": {
                    "container": {
                        "padding-top": 0,
                        "padding-right": 0,
                        "padding-left": 0,
                        "padding-bottom": "{d_33}"
                    }
                },
                "vertical": {
                    "container": {
                        "padding-top": "{d_34}",
                        "padding-right": 0,
                        "padding-left": 0,
                        "padding-bottom": "{d_35}"
                    }
                },
                "horizontal": {
                    "container": {
                        "padding-top": 0,
                        "padding-bottom": 0,
                        "padding-left": "{d_36}",
                        "padding-right": "{d_37}"
                    }
                }
            },
            "medium": {
                "all": {
                    "container": {
                        "padding-left": "{d_38}",
                        "padding-right": "{d_39}",
                        "padding-top": "{d_40}",
                        "padding-bottom": "{d_41}"
                    }
                },
                "left": {
                    "container": {
                        "padding-left": "{d_42}",
                        "padding-right": 0,
                        "padding-top": 0,
                        "padding-bottom": 0
                    }
                },
                "right": {
                    "container": {
                        "padding-right": "{d_43}",
                        "padding-left": 0,
                        "padding-top": 0,
                        "padding-bottom": 0
                    }
                },
                "top": {
                    "container": {
                        "padding-right": 0,
                        "padding-left": 0,
                        "padding-bottom": 0,
                        "padding-top": "{d_44}"
                    }
                },
                "bottom": {
                    "container": {
                        "padding-right": 0,
                        "padding-left": 0,
                        "padding-top": 0,
                        "padding-bottom": "{d_45}"
                    }
                },
                "vertical": {
                    "container": {
                        "padding-top": "{d_46}",
                        "padding-bottom": "{d_47}",
                        "padding-right": 0,
                        "padding-left": 0
                    }
                },
                "horizontal": {
                    "container": {
                        "padding-top": 0,
                        "padding-bottom": 0,
                        "padding-left": "{d_48}",
                        "padding-right": "{d_49}"
                    }
                }
            },
            "xtra-small": {
                "all": {
                    "container": {
                        "padding-left": "{d_50}",
                        "padding-right": "{d_51}",
                        "padding-top": "{d_52}",
                        "padding-bottom": "{d_53}"
                    }
                },
                "left": {
                    "container": {
                        "padding-left": "{d_54}",
                        "padding-top": 0,
                        "padding-bottom": 0,
                        "padding-right": 0
                    }
                },
                "right": {
                    "container": {
                        "padding-right": "{d_55}",
                        "padding-top": 0,
                        "padding-bottom": 0,
                        "padding-left": 0
                    }
                },
                "top": {
                    "container": {
                        "padding-bottom": 0,
                        "padding-top": "{d_56}",
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "bottom": {
                    "container": {
                        "padding-top": 0,
                        "padding-bottom": "{d_57}",
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "vertical": {
                    "container": {
                        "padding-top": "{d_58}",
                        "padding-bottom": "{d_59}",
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "horizontal": {
                    "container": {
                        "padding-top": 0,
                        "padding-bottom": 0,
                        "padding-left": "{d_60}",
                        "padding-right": "{d_61}"
                    }
                }
            },
            "xtra-xtra-small": {
                "all": {
                    "container": {
                        "padding-left": "{d_62}",
                        "padding-right": "{d_63}",
                        "padding-top": "{d_64}",
                        "padding-bottom": "{d_65}"
                    }
                },
                "left": {
                    "container": {
                        "padding-left": "{d_66}",
                        "padding-right": 0,
                        "padding-top": 0,
                        "padding-bottom": 0
                    }
                },
                "right": {
                    "container": {
                        "padding-right": "{d_67}",
                        "padding-left": 0,
                        "padding-top": 0,
                        "padding-bottom": 0
                    }
                },
                "top": {
                    "container": {
                        "padding-bottom": 0,
                        "padding-top": "{d_68}",
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "bottom": {
                    "container": {
                        "padding-top": 0,
                        "padding-bottom": "{d_69}",
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "vertical": {
                    "container": {
                        "padding-top": "{d_70}",
                        "padding-bottom": "{d_71}",
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "horizontal": {
                    "container": {
                        "padding-top": 0,
                        "padding-right": 0,
                        "padding-left": "{d_72}",
                        "padding-bottom": "{d_73}"
                    }
                }
            },
            "xtra-xtra-large": {
                "all": {
                    "container": {
                        "padding-left": "{d_74}",
                        "padding-right": "{d_75}",
                        "padding-top": "{d_76}",
                        "padding-bottom": "{d_77}"
                    }
                },
                "left": {
                    "container": {
                        "padding-left": "{d_78}",
                        "padding-right": 0,
                        "padding-top": 0,
                        "padding-bottom": 0
                    }
                },
                "right": {
                    "container": {
                        "padding-right": "{d_79}",
                        "padding-top": 0,
                        "padding-left": 0,
                        "padding-bottom": 0
                    }
                },
                "top": {
                    "container": {
                        "padding-bottom": 0,
                        "padding-top": "{d_80}",
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "bottom": {
                    "container": {
                        "padding-top": 0,
                        "padding-bottom": "{d_81}",
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "vertical": {
                    "container": {
                        "padding-top": "{d_82}",
                        "padding-bottom": "{d_83}",
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "horizontal": {
                    "container": {
                        "padding-top": 0,
                        "padding-bottom": 0,
                        "padding-left": "{d_84}",
                        "padding-right": "{d_85}"
                    }
                }
            },
            "xtra-large": {
                "all": {
                    "container": {
                        "padding-left": "{d_86}",
                        "padding-right": "{d_87}",
                        "padding-top": "{d_88}",
                        "padding-bottom": "{d_89}"
                    }
                },
                "left": {
                    "container": {
                        "padding-left": "{d_90}",
                        "padding-top": 0,
                        "padding-right": 0,
                        "padding-bottom": 0
                    }
                },
                "right": {
                    "container": {
                        "padding-right": "{d_91}",
                        "padding-top": 0,
                        "padding-left": 0,
                        "padding-bottom": 0
                    }
                },
                "top": {
                    "container": {
                        "padding-bottom": 0,
                        "padding-left": 0,
                        "padding-right": 0,
                        "padding-top": "{d_92}"
                    }
                },
                "bottom": {
                    "container": {
                        "padding-top": 0,
                        "padding-left": 0,
                        "padding-right": 0,
                        "padding-bottom": "{d_93}"
                    }
                },
                "vertical": {
                    "container": {
                        "padding-top": "{d_94}",
                        "padding-left": 0,
                        "padding-right": 0,
                        "padding-bottom": "{d_95}"
                    }
                },
                "horizontal": {
                    "container": {
                        "padding-top": 0,
                        "padding-bottom": 0,
                        "padding-left": "{d_96}",
                        "padding-right": "{d_97}"
                    }
                }
            },
            "large": {
                "all": {
                    "container": {
                        "padding-left": "{d_98}",
                        "padding-right": "{d_99}",
                        "padding-top": "{d_100}",
                        "padding-bottom": "{d_101}"
                    }
                },
                "left": {
                    "container": {
                        "padding-left": "{d_102}",
                        "padding-right": "0",
                        "padding-top": 0,
                        "padding-bottom": 0
                    }
                },
                "right": {
                    "container": {
                        "padding-right": "{d_103}",
                        "padding-left": "0",
                        "padding-top": 0,
                        "padding-bottom": 0
                    }
                },
                "top": {
                    "container": {
                        "padding-bottom": 0,
                        "padding-left": 0,
                        "padding-right": 0,
                        "padding-top": "{d_104}"
                    }
                },
                "bottom": {
                    "container": {
                        "padding-top": 0,
                        "padding-left": 0,
                        "padding-right": 0,
                        "padding-bottom": "{d_105}"
                    }
                },
                "vertical": {
                    "container": {
                        "padding-top": "{d_106}",
                        "padding-left": 0,
                        "padding-right": 0,
                        "padding-bottom": "{d_107}"
                    }
                },
                "horizontal": {
                    "container": {
                        "padding-top": 0,
                        "padding-bottom": 0,
                        "padding-left": "{d_108}",
                        "padding-right": "{d_109}"
                    }
                }
            },
            "huge": {
                "all": {
                    "container": {
                        "padding-left": "{d_110}",
                        "padding-right": "{d_111}",
                        "padding-top": "{d_112}",
                        "padding-bottom": "{d_113}"
                    }
                },
                "left": {
                    "container": {
                        "padding-left": "{d_114}",
                        "padding-right": 0,
                        "padding-top": 0,
                        "padding-bottom": 0
                    }
                },
                "right": {
                    "container": {
                        "padding-right": "{d_115}",
                        "padding-top": 0,
                        "padding-left": 0,
                        "padding-bottom": 0
                    }
                },
                "top": {
                    "container": {
                        "padding-bottom": 0,
                        "padding-top": "{d_116}",
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "bottom": {
                    "container": {
                        "padding-top": 0,
                        "padding-bottom": "{d_117}",
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "vertical": {
                    "container": {
                        "padding-top": "{d_118}",
                        "padding-bottom": "{d_119}",
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "horizontal": {
                    "container": {
                        "padding-top": 0,
                        "padding-bottom": 0,
                        "padding-left": "{d_120}",
                        "padding-right": "{d_121}"
                    }
                }
            },
            "massive": {
                "all": {
                    "container": {
                        "padding-left": "{d_122}",
                        "padding-right": "{d_123}",
                        "padding-top": "{d_124}",
                        "padding-bottom": "{d_125}"
                    }
                },
                "left": {
                    "container": {
                        "padding-left": "{d_126}",
                        "padding-right": 0,
                        "padding-top": 0,
                        "padding-bottom": 0
                    }
                },
                "right": {
                    "container": {
                        "padding-right": "{d_127}",
                        "padding-left": 0,
                        "padding-top": 0,
                        "padding-bottom": 0
                    }
                },
                "top": {
                    "container": {
                        "padding-bottom": 0,
                        "padding-top": "{d_128}",
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "bottom": {
                    "container": {
                        "padding-top": 0,
                        "padding-bottom": "{d_129}",
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "vertical": {
                    "container": {
                        "padding-top": "{d_130}",
                        "padding-bottom": "{d_131}",
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "horizontal": {
                    "container": {
                        "padding-top": 0,
                        "padding-bottom": 0,
                        "padding-left": "{d_132}",
                        "padding-right": "{d_133}"
                    }
                }
            },
            "small": {
                "left": {
                    "container": {
                        "padding-right": 0,
                        "padding-top": 0,
                        "padding-bottom": 0
                    }
                },
                "right": {
                    "container": {
                        "padding-left": 0,
                        "padding-top": 0,
                        "padding-bottom": 0
                    }
                },
                "top": {
                    "container": {
                        "padding-bottom": 0,
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "bottom": {
                    "container": {
                        "padding-top": 0,
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "vertical": {
                    "container": {
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "horizontal": {
                    "container": {
                        "padding-top": 0,
                        "padding-bottom": 0
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "pad",
            "padPosition"
        ]
    ],
    "api": {
        "data": {
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            }
        },
        "config": {
            "orientation": {
                "values": [
                    "horizontal",
                    "vertical"
                ],
                "doc_description": "Determines the view styles i.e. horizontal or vertical."
            },
            "variant": {
                "values": [
                    "default",
                    "stepper"
                ]
            },
            "_withLabel": {
                "values": [
                    false,
                    true
                ]
            },
            "padPosition": {
                "values": [
                    "all",
                    "vertical",
                    "horizontal",
                    "bottom",
                    "top",
                    "left",
                    "right"
                ],
                "doc_description": "Sets the position of padding defined as part of `padding` property. If `padding` property present, this default to `all`."
            },
            "pad": {
                "values": [
                    "small",
                    "base",
                    "medium",
                    "xtra-small",
                    "large",
                    "xtra-large",
                    "xtra-xtra-large",
                    "xtra-xtra-small",
                    "huge",
                    "massive",
                    "none"
                ]
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "separator"
                    },
                    "aria-label": {
                        "name": "_ariaLabel",
                        "prop": "label",
                        "function": true
                    },
                    "aria-orientation": {
                        "name": "_ariaOrientation",
                        "prop": "orientation"
                    },
                    "aria-hidden": {
                        "name": "ariaHidden"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$legacyPadding = [
    "xx-small",
    "x-small",
    "x-large",
    "xx-large"
];
const $fe5170bdd3625759$var$PROP_MAP$o = (props)=>{
    if ($fe5170bdd3625759$var$legacyPadding.includes(props.pad)) console.warn("sizes starting with xx- are deprecated. Use sizes starting with `xtra`. Ex: x-small => xtra-small");
    return {
        pad: {
            variations: {
                base: {
                    pad: "base"
                },
                huge: {
                    pad: "huge"
                },
                medium: {
                    pad: "medium"
                },
                small: {
                    pad: "small"
                },
                large: {
                    pad: "large"
                },
                "x-small": {
                    pad: "xtra-small"
                },
                "xx-small": {
                    pad: "xtra-xtra-small"
                },
                "x-large": {
                    pad: "xtra-large"
                },
                "xx-large": {
                    pad: "xtra-xtra-large"
                },
                massive: {
                    pad: "massive"
                }
            }
        },
        appearance: {
            properties: {
                orientation: props.appearance || props.orientation
            }
        }
    };
};
const $fe5170bdd3625759$var$withLogic$1D = (Component)=>(userProps)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$o);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                _withLabel: Boolean(props.label?.length),
                orientation: props.orientation || props.appearance
            }
        });
    };
const $fe5170bdd3625759$var$Component$1F = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1A;
    const { orientation: orientation = "horizontal", variant: variant = "default", padPosition: padPosition = "all", pad: pad = "small", _ariaLabel: _ariaLabel = props.label?.toString(), _ariaOrientation: _ariaOrientation = props.orientation?.toString(), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            orientation: orientation,
            variant: variant,
            padPosition: padPosition,
            pad: pad,
            _ariaLabel: _ariaLabel,
            _ariaOrientation: _ariaOrientation,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDivider", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$2e0a83ec2e27ecbb = $fe5170bdd3625759$var$withLogic$1D($fe5170bdd3625759$var$Component$1F);
$fe5170bdd3625759$export$2e0a83ec2e27ecbb.displayName = "Divider";
$fe5170bdd3625759$export$2e0a83ec2e27ecbb.slotName = "jds_divider";
const $fe5170bdd3625759$var$sdl$1z = {
    "metadata": {
        "version": "1.0.0",
        "id": "dropdown-menu-1.0.0",
        "name": "JDSDropdownMenu",
        "layerName": "jds_dropdown_menu"
    },
    "hierarchy": {
        "popup": [
            {
                "popup-container": [
                    "jds_dropdown_menu_internal"
                ]
            }
        ]
    },
    "base": {
        "popup": {
            "priority": 60,
            "background-color": "{global.transparent}",
            "hidden": true
        },
        "popup-container": {
            "hidden": false
        },
        "jds_dropdown_menu_internal": {
            "hidden": false,
            "kind": "single-select"
        }
    },
    "variant": {
        "kind": {
            "multi-select": {
                "jds_dropdown_menu_internal": {
                    "kind": "multi-select",
                    "showCTAButtons": true
                }
            }
        },
        "_menuFullScreen": {
            "true": {
                "popup-container": {
                    "size": "{size.max}"
                },
                "jds_dropdown_menu_internal": {
                    "menuFullScreen": true
                }
            }
        },
        "open": {
            "true": {
                "popup": {
                    "hidden": false
                },
                "jds_dropdown_menu_internal": {
                    "open": true
                }
            }
        },
        "searchTrigger": {
            "true": {
                "jds_dropdown_menu_internal": {
                    "searchTrigger": true
                }
            }
        },
        "showCTAButtons": {
            "false": {
                "jds_dropdown_menu_internal": {
                    "showCTAButtons": false
                }
            }
        },
        "labelTextWrap": {
            "true": {
                "jds_dropdown_menu_internal": {
                    "labelTextWrap": true
                }
            }
        },
        "width": {
            "trigger": {
                "jds_dropdown_menu_internal": {
                    "menuWidthConfig": "trigger"
                }
            }
        },
        "position": {
            "bottom_start": {
                "jds_dropdown_menu_internal": {
                    "position": "bottom_start"
                }
            },
            "bottom_end": {
                "jds_dropdown_menu_internal": {
                    "position": "bottom_end"
                }
            },
            "top_start": {
                "jds_dropdown_menu_internal": {
                    "position": "top_start"
                }
            },
            "top_end": {
                "jds_dropdown_menu_internal": {
                    "position": "top_end"
                }
            },
            "right_start": {
                "jds_dropdown_menu_internal": {
                    "position": "right_start"
                }
            },
            "right_end": {
                "jds_dropdown_menu_internal": {
                    "position": "right_end"
                }
            },
            "left_start": {
                "jds_dropdown_menu_internal": {
                    "position": "left_start"
                }
            },
            "left_end": {
                "jds_dropdown_menu_internal": {
                    "position": "left_end"
                }
            },
            "bottom_centre": {
                "jds_dropdown_menu_internal": {
                    "position": "bottom_centre"
                }
            },
            "top_centre": {
                "jds_dropdown_menu_internal": {
                    "position": "top_centre"
                }
            }
        }
    },
    "api": {
        "events": {
            "jds_dropdown_menu_internal": {
                "onSuffixClick": "onSuffixClick",
                "onSearchChange": "onSearchChange",
                "onAppear": {
                    "name": "_onAppear",
                    "platform": "ios"
                },
                "onContainerClick": "_onContainerClick",
                "onPrimaryClick": "onPrimaryClick",
                "onSecondaryClick": "onSecondaryClick"
            },
            "popup": {
                "onClick": "onClose"
            }
        },
        "data": {
            "jds_dropdown_menu_internal": {
                "searchLabel": {
                    "type": "string",
                    "name": "searchLabel"
                },
                "searchValue": {
                    "type": "string",
                    "name": "searchValue"
                },
                "searchSuffix": {
                    "type": "icon",
                    "name": "searchSuffix"
                },
                "menuWidth": {
                    "type": "size",
                    "name": "_menuWidth"
                },
                "triggerRef": {
                    "type": "ref",
                    "name": "triggerRef"
                },
                "menuMaxHeight": {
                    "type": "string",
                    "name": "_menuMaxHeight"
                },
                "primaryCTA": {
                    "type": "string",
                    "name": "primaryCTA"
                },
                "secondaryCTA": {
                    "type": "string",
                    "name": "secondaryCTA"
                },
                "children": {
                    "name": "children",
                    "type": "slot",
                    "accepts": [
                        "jds_dropdown_menu_group"
                    ]
                }
            },
            "popup-container": {
                "padding-left": {
                    "type": "size",
                    "name": "offsetX"
                },
                "padding-top": {
                    "type": "size",
                    "name": "offsetY"
                }
            }
        },
        "config": {
            "kind": {
                "values": [
                    "single-select",
                    "multi-select"
                ]
            },
            "searchTrigger": {
                "values": [
                    false,
                    true
                ]
            },
            "showCTAButtons": {
                "values": [
                    true,
                    false
                ]
            },
            "labelTextWrap": {
                "values": [
                    false,
                    true
                ]
            },
            "open": {
                "values": [
                    false,
                    true
                ]
            },
            "width": {
                "values": [
                    "max-content",
                    "trigger"
                ]
            },
            "position": {
                "values": [
                    "bottom_start",
                    "bottom_end",
                    "top_start",
                    "top_end",
                    "right_start",
                    "right_end",
                    "left_start",
                    "left_end",
                    "bottom_centre",
                    "top_centre"
                ]
            },
            "_menuFullScreen": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "a11y": {
            "jds_dropdown_menu_internal": {
                "properties": {
                    "searchAriaLabel": "searchAriaLabel"
                }
            }
        }
    }
};
function $fe5170bdd3625759$var$findFocusedIndex(menuItems) {
    const focusedElement = document.activeElement;
    const index = menuItems.findIndex((item)=>item === focusedElement);
    return index;
}
function $fe5170bdd3625759$var$handlePrevOrNextItemFocus(focusIndex, containerDomRef, itemSelector) {
    const menuItems = containerDomRef?.querySelectorAll?.(itemSelector);
    if (!menuItems?.length) return;
    const currentFocusIndex = $fe5170bdd3625759$var$findFocusedIndex(Array.from(menuItems));
    if (focusIndex === 1) {
        if (currentFocusIndex < menuItems.length - 1) menuItems[currentFocusIndex + 1].focus();
        else menuItems[0].focus();
    } else if (focusIndex === -1) {
        if (currentFocusIndex > 0) menuItems[currentFocusIndex - 1].focus();
        else menuItems[menuItems.length - 1].focus();
    }
}
const $fe5170bdd3625759$var$spaceAvailabilityOrder = {
    "bottom-start": [
        "bottom-end",
        "bottom-center",
        "top-start",
        "top-end",
        "top-center"
    ],
    "bottom-end": [
        "bottom-start",
        "bottom-center",
        "top-end",
        "top-start",
        "top-center"
    ],
    "top-start": [
        "top-end",
        "top-center",
        "bottom-start",
        "bottom-end",
        "bottom-center"
    ],
    "top-end": [
        "top-start",
        "top-center",
        "bottom-end",
        "bottom-start",
        "bottom-center"
    ],
    "right-end": [
        "right-start",
        "left-end",
        "left-start"
    ],
    "right-start": [
        "right-end",
        "left-start",
        "left-end",
        "bottom-end",
        "bottom-center"
    ],
    "left-end": [
        "left-start",
        "right-end",
        "right-start"
    ],
    "left-start": [
        "left-end",
        "right-start",
        "right-end"
    ],
    "top-center": [
        "top-start",
        "top-end",
        "bottom-center",
        "bottom-start",
        "bottom-end"
    ],
    "bottom-center": [
        "bottom-start",
        "bottom-end",
        "top-center",
        "top-start",
        "top-end"
    ]
};
function $fe5170bdd3625759$var$getCalculatedPosition(position, anchorRect, containerDomRect) {
    if (!(position && anchorRect && containerDomRect)) return position;
    if ($fe5170bdd3625759$var$checkSpaceAvailability(position, anchorRect, containerDomRect)) return position;
    let alternativePosition = $fe5170bdd3625759$var$spaceAvailabilityOrder[position].find((alternativePosition2)=>{
        return $fe5170bdd3625759$var$checkSpaceAvailability(alternativePosition2, anchorRect, containerDomRect);
    });
    if (!alternativePosition) alternativePosition = $fe5170bdd3625759$var$checkBestAvailablePosition(anchorRect);
    return alternativePosition || position;
}
function $fe5170bdd3625759$var$checkBestAvailablePosition(anchorRect) {
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;
    const { bottom: bottom, top: top, left: left, right: right } = anchorRect;
    const positionWidthHeightRatios = {
        "bottom-start": (windowWidth - left) * (windowHeight - bottom),
        "bottom-end": right * (windowHeight - bottom),
        "top-start": (windowWidth - left) * top,
        "top-end": right * top,
        "right-start": (windowWidth - right) * (windowHeight - top),
        "right-end": (windowWidth - right) * bottom,
        "left-start": left * (windowHeight - top),
        "left-end": left * bottom,
        "top-center": 0,
        "bottom-center": 0
    };
    let bestPosition = "bottom-start";
    let bestAvailableSpace = 0;
    for (const [position, availableSpace] of Object.entries(positionWidthHeightRatios))if (availableSpace > bestAvailableSpace) {
        bestPosition = position;
        bestAvailableSpace = availableSpace;
    }
    return bestPosition;
}
function $fe5170bdd3625759$var$checkSpaceAvailability(position, anchorRect, containerDomRect) {
    const { width: anchorWidth, top: anchorTop, bottom: anchorBottom, right: anchorRight, left: anchorLeft } = anchorRect;
    const { width: containerWidth, height: containerHeight } = containerDomRect;
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;
    const screenStart = 0;
    switch(position){
        case "bottom-start":
            return anchorBottom + containerHeight < screenHeight && anchorLeft + containerWidth < screenWidth;
        case "bottom-end":
            return anchorBottom + containerHeight < screenHeight && anchorRight - containerWidth > screenStart;
        case "top-start":
            return anchorLeft + containerWidth < screenWidth && anchorTop - containerHeight > 0;
        case "top-end":
            return anchorRight - containerWidth > screenStart && anchorTop - containerHeight > 0;
        case "right-end":
            return anchorRight + containerWidth < screenWidth && anchorBottom - containerHeight > 0;
        case "right-start":
            return anchorRight + containerWidth < screenWidth && anchorTop + containerHeight < screenHeight;
        case "left-end":
            return anchorLeft - containerWidth > screenStart && anchorBottom - containerHeight > 0;
        case "left-start":
            return anchorTop + containerHeight < screenHeight && anchorLeft - containerWidth > screenStart;
        case "top-center":
            return anchorTop - containerHeight > 0 && anchorLeft + anchorWidth / 2 - containerWidth / 2 > screenStart && anchorLeft + anchorWidth / 2 + containerWidth / 2 < screenWidth;
        case "bottom-center":
            return anchorBottom + containerHeight < screenHeight && anchorLeft + anchorWidth / 2 - containerWidth / 2 > screenStart && anchorLeft + anchorWidth / 2 + containerWidth / 2 < screenWidth;
        default:
            return true;
    }
}
const $fe5170bdd3625759$var$DropdownMenuContext = (0, $acw62.createContext)({
    activeMenuId: void 0,
    setActiveMenuId () {},
    labelTextWrap: true,
    selectedValue: void 0,
    setSelectedValue () {},
    selectedValues: [],
    setSelectedValues () {},
    isNested: false,
    setIsNested () {},
    resetSelections () {},
    applySelections () {}
});
const $fe5170bdd3625759$var$useScrollClose = (callback)=>{
    (0, $acw62.useEffect)(()=>{
        document.addEventListener("scroll", callback);
        return ()=>{
            document.removeEventListener("scroll", callback);
        };
    }, [
        callback
    ]);
};
const $fe5170bdd3625759$var$MENU_MARGIN = 4;
const $fe5170bdd3625759$var$getIcon$1 = (icon)=>{
    if (!icon) return void 0;
    if (typeof icon === "string") return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$f04a61298a47a40f, {
        ic: icon,
        color: "grey-80"
    });
    if (icon.props?.ic) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$f04a61298a47a40f, {
        ic: icon.props.ic,
        color: "grey-80"
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$f04a61298a47a40f, {
        ic: icon,
        color: "grey-80"
    });
};
function $fe5170bdd3625759$var$getPositionCoordinates(position, anchorRect, containerDomRect) {
    const { top: anchorTop, bottom: anchorBottom, right: anchorRight, left: anchorLeft, width: anchorWidth } = anchorRect;
    const { width: containerWidth, height: containerHeight } = containerDomRect;
    const screenHeight = window.innerHeight;
    const screenWidth = window.innerWidth;
    let left = 0;
    let top = 0;
    let maxHeight;
    let maxWidth;
    switch(position){
        case "bottom-start":
            left = anchorLeft;
            top = anchorBottom;
            maxHeight = screenHeight - anchorBottom;
            maxWidth = screenWidth - anchorLeft;
            break;
        case "bottom-end":
            left = anchorRight - containerWidth;
            top = anchorBottom;
            maxHeight = screenHeight - anchorBottom;
            maxWidth = anchorRight;
            break;
        case "top-start":
            left = anchorLeft;
            top = anchorTop - containerHeight;
            maxHeight = anchorTop;
            maxWidth = screenWidth - anchorLeft;
            break;
        case "top-end":
            left = anchorRight - containerWidth;
            top = anchorTop - containerHeight;
            maxHeight = anchorTop;
            maxWidth = anchorRight;
            break;
        case "right-end":
            left = anchorRight;
            top = anchorBottom - containerHeight;
            maxHeight = anchorBottom;
            maxWidth = screenWidth - anchorRight;
            break;
        case "right-start":
            left = anchorRight;
            top = anchorTop;
            maxHeight = screenHeight - anchorTop;
            maxWidth = screenWidth - anchorRight;
            break;
        case "left-end":
            left = anchorLeft - containerWidth;
            top = anchorBottom - containerHeight;
            maxHeight = anchorBottom;
            maxWidth = anchorLeft;
            break;
        case "left-start":
            left = anchorLeft - containerWidth;
            top = anchorTop;
            maxHeight = screenHeight - anchorTop;
            maxWidth = anchorLeft;
            break;
        case "top-center":
            left = anchorLeft + anchorWidth / 2 - containerWidth / 2;
            top = anchorTop - containerHeight;
            maxHeight = anchorTop;
            maxWidth = screenWidth;
            break;
        case "bottom-center":
            left = anchorLeft + anchorWidth / 2 - containerWidth / 2;
            top = anchorBottom;
            maxHeight = screenHeight - anchorBottom;
            maxWidth = screenWidth;
            break;
    }
    if (position.includes("top")) top -= $fe5170bdd3625759$var$MENU_MARGIN;
    else if (position.includes("bottom")) top += $fe5170bdd3625759$var$MENU_MARGIN;
    else if (position.includes("right")) left += $fe5170bdd3625759$var$MENU_MARGIN;
    else if (position.includes("left")) left -= $fe5170bdd3625759$var$MENU_MARGIN;
    return {
        left: Math.round(left < 0 ? 0 : left),
        top: Math.round(top < 0 ? 0 : top),
        maxHeight: maxHeight,
        maxWidth: maxWidth
    };
}
const $fe5170bdd3625759$var$DROPDOWNMENU_SELECTOR$1 = "div.j-JDSDropdownMenuInternal-menu-container";
const $fe5170bdd3625759$var$SEARCH_BAR_HEIGHT = 56;
const $fe5170bdd3625759$var$withLogic$1C = (Component)=>(props)=>{
        const [activeMenuId, setActiveMenuId] = (0, $acw62.useState)(void 0);
        const { element: element, rootRef: rootRef } = $fe5170bdd3625759$var$useRootRef();
        const [labelTextWrap, setLabelTextWrap] = (0, $acw62.useState)(true);
        const [selectedValue, setSelectedValue] = (0, $acw62.useState)(void 0);
        const [selectedValues, setSelectedValues] = (0, $acw62.useState)([]);
        const [menuVisible, setMenuVisible] = (0, $acw62.useState)(false);
        const [internalOpen, setInternalOpen] = (0, $acw62.useState)(false);
        const [isNested, setIsNested] = (0, $acw62.useState)(false);
        const [fullScreen, setFullScreen] = (0, $acw62.useState)(false);
        const [menuWidth, setMenuWidth] = (0, $acw62.useState)("max-content");
        const internalProps = props;
        const { anchorEl: anchorEl, position: position } = props;
        const dropdownMenuRef = element?.querySelector($fe5170bdd3625759$var$DROPDOWNMENU_SELECTOR$1);
        const [coords, setCoords] = (0, $acw62.useState)({
            left: 0,
            top: 0,
            maxHeight: 0,
            maxWidth: void 0
        });
        const defaultValue = {
            activeMenuId: void 0,
            setActiveMenuId: setActiveMenuId,
            labelTextWrap: labelTextWrap,
            selectedValue: selectedValue,
            setSelectedValue (value) {
                setSelectedValue(value);
                if (props.value !== value) {
                    props?.onSelect?.(value);
                    props?.onClose?.();
                    setActiveMenuId(void 0);
                }
            },
            selectedValues: selectedValues,
            setSelectedValues: (values)=>setSelectedValues([
                    ...values
                ]),
            isNested: isNested,
            setIsNested: setIsNested,
            resetSelections: ()=>{
                setSelectedValues([]);
            },
            applySelections: ()=>{
                props?.onSelect?.(selectedValues);
                props?.onClose?.();
            }
        };
        (0, $acw62.useEffect)(()=>{
            if (props.open) {
                setInternalOpen(true);
                if (dropdownMenuRef && anchorEl?.current) {
                    setFullScreen(false);
                    setMenuWidth("max-content");
                    setTimeout(()=>{
                        const anchorDomRect = anchorEl.current?.getBoundingClientRect();
                        const containerDomRect = dropdownMenuRef?.getBoundingClientRect();
                        if (anchorDomRect && containerDomRect) {
                            const calculatedPosition = $fe5170bdd3625759$var$getCalculatedPosition(position || "bottom-start", anchorDomRect, containerDomRect);
                            const { left: left, top: top, maxHeight: maxHeight, maxWidth: maxWidth } = $fe5170bdd3625759$var$getPositionCoordinates(calculatedPosition, anchorDomRect, containerDomRect);
                            const menuItems = dropdownMenuRef.querySelectorAll(".j-JDSDropdownMenuItem-container");
                            const isFullScreen = $fe5170bdd3625759$var$Devices.isMobile() ? isNested || (menuItems?.length || 0) > 7 : false;
                            setFullScreen(isFullScreen);
                            if (isFullScreen) setCoords({
                                left: 0,
                                top: 0,
                                maxHeight: maxHeight,
                                maxWidth: maxWidth
                            });
                            else setCoords({
                                left: left,
                                top: top,
                                maxHeight: maxHeight,
                                maxWidth: maxWidth
                            });
                            setMenuVisible(true);
                            if (props.width === "trigger") setMenuWidth(`${anchorDomRect.width}px`);
                            else setMenuWidth(maxWidth && containerDomRect.width > maxWidth ? `${maxWidth}px` : "max-content");
                        }
                    }, 10);
                }
            } else {
                setMenuVisible(false);
                setTimeout(()=>{
                    setInternalOpen(false);
                }, 300);
            }
        }, [
            props.open,
            anchorEl,
            position,
            dropdownMenuRef,
            isNested
        ]);
        (0, $acw62.useEffect)(()=>{
            if (props.kind === "multi-select") setSelectedValues(props.value ? [
                props.value
            ] : []);
            else setSelectedValue(props.value);
        }, [
            props.value
        ]);
        (0, $acw62.useEffect)(()=>{
            setLabelTextWrap(!!props.labelTextWrap);
        }, [
            props.labelTextWrap
        ]);
        (0, $acw62.useEffect)(()=>{
            if (props.open && dropdownMenuRef) dropdownMenuRef.focus();
        }, [
            props.open,
            dropdownMenuRef
        ]);
        (0, $acw62.useEffect)(()=>{
            const handleKeyDown = (event)=>{
                if (props.open && !activeMenuId) switch(event.key){
                    case "ArrowUp":
                        $fe5170bdd3625759$var$handlePrevOrNextItemFocus(-1, dropdownMenuRef, ".j-JDSDropdownMenuItem-container");
                        event.preventDefault();
                        event.stopPropagation();
                        break;
                    case "ArrowDown":
                        $fe5170bdd3625759$var$handlePrevOrNextItemFocus(1, dropdownMenuRef, ".j-JDSDropdownMenuItem-container");
                        event.preventDefault();
                        event.stopPropagation();
                        break;
                    case "Escape":
                        props?.onClose?.();
                        anchorEl?.current?.focus?.();
                        break;
                }
            };
            if (props.open) window.addEventListener("keydown", handleKeyDown);
            return ()=>{
                window.removeEventListener("keydown", handleKeyDown);
            };
        }, [
            props.open,
            dropdownMenuRef,
            activeMenuId
        ]);
        const shouldShowSuffix = props?.searchConfig?.suffix !== false;
        const close = ()=>{
            props?.onClose?.();
            setMenuVisible(false);
            setActiveMenuId(void 0);
        };
        $fe5170bdd3625759$var$useScrollClose(close);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$var$DropdownMenuContext.Provider, {
            value: {
                ...defaultValue,
                setActiveMenuId: setActiveMenuId,
                setIsNested: setIsNested,
                activeMenuId: activeMenuId,
                labelTextWrap: labelTextWrap,
                selectedValue: selectedValue,
                selectedValues: selectedValues,
                isNested: isNested
            },
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
                ...{
                    ...props,
                    open: internalOpen,
                    onClose: ()=>{
                        props?.onClose?.();
                        setMenuVisible(false);
                        setActiveMenuId(void 0);
                    },
                    rootRef: rootRef,
                    offsetX: internalProps.offsetX || `${coords.left}px`,
                    _menuWidth: fullScreen ? "100%" : menuWidth,
                    _menuFullScreen: fullScreen,
                    _menuMaxHeight: coords.maxHeight === 0 ? "unset" : props.searchTrigger ? `${coords.maxHeight - $fe5170bdd3625759$var$SEARCH_BAR_HEIGHT}px` : `${coords.maxHeight}px`,
                    offsetY: internalProps.offsetY || `${coords.top}px`,
                    searchSuffix: shouldShowSuffix ? "IcMic" : void 0,
                    searchLabel: props.searchLabel || "Search",
                    searchValue: props.searchValue,
                    onSuffixClick: props.onSuffixClick,
                    onSearchChange: props?.onSearchChange,
                    _onContainerClick: (event)=>{
                        event.stopPropagation();
                    },
                    onPrimaryClick: ()=>{
                        props.onPrimaryClick?.();
                        defaultValue.applySelections();
                    },
                    onSecondaryClick: ()=>{
                        props.onSecondaryClick?.();
                        defaultValue.resetSelections();
                    },
                    _menuContainerVisible: menuVisible
                }
            })
        });
    };
const $fe5170bdd3625759$var$Component$1E = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1z;
    const { kind: kind = "single-select", searchTrigger: searchTrigger = false, showCTAButtons: showCTAButtons = true, labelTextWrap: labelTextWrap = false, open: open = false, width: width = "max-content", position: position = "bottom_start", onSuffixClick: onSuffixClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSearchChange: onSearchChange = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onPrimaryClick: onPrimaryClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSecondaryClick: onSecondaryClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onClose: onClose = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            searchTrigger: searchTrigger,
            showCTAButtons: showCTAButtons,
            labelTextWrap: labelTextWrap,
            open: open,
            width: width,
            position: position,
            onSuffixClick: onSuffixClick,
            onSearchChange: onSearchChange,
            onPrimaryClick: onPrimaryClick,
            onSecondaryClick: onSecondaryClick,
            onClose: onClose,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDropdownMenu", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$e44a253a59704894 = $fe5170bdd3625759$var$withLogic$1C($fe5170bdd3625759$var$Component$1E);
$fe5170bdd3625759$export$e44a253a59704894.displayName = "DropdownMenu";
$fe5170bdd3625759$export$e44a253a59704894.slotName = "jds_dropdown_menu";
const $fe5170bdd3625759$var$sdl$1y = {
    "metadata": {
        "version": "1.0.0",
        "id": "dropdown-menu-group-1.0.0",
        "name": "JDSDropdownMenuGroup",
        "layerName": "jds_dropdown_menu_group",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "top-jds_divider",
            {
                "label-container": [
                    "label-jds-text"
                ]
            },
            {
                "menu-item-container": [
                    "menu-item-slot"
                ]
            },
            "bottom-jds_divider"
        ]
    },
    "base": {
        "top-jds_divider": {
            "hidden": false,
            "orientation": "horizontal",
            "pad": "xtra-small",
            "padPosition": "top"
        },
        "bottom-jds_divider": {
            "hidden": false,
            "orientation": "horizontal",
            "pad": "none",
            "padPosition": "all"
        },
        "label-container": {
            "width": "{d_6}",
            "padding-top": "{d_3}",
            "padding-right": "{d_5}",
            "padding-left": "{d_4}"
        },
        "container": {
            "hidden": false,
            "width": "{d_0}",
            "background-color": "{d_7}",
            "flex-direction": "{d_1}"
        },
        "menu-item-container": {
            "width": "{d_8}",
            "flex-direction": "{d_2}"
        },
        "menu-item-slot": {
            "hidden": false
        },
        "label-jds-text": {
            "font-family": "{bodyXxsBold}",
            "color": "{primaryGrey100}",
            "font-size": "{bodyXxsBold}",
            "line-height": "{bodyXxsBold}",
            "letter-spacing": "{bodyXxsBold}",
            "font-weight": "{bodyXxsBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false
        }
    },
    "variant": {
        "_hideTopDivider": {
            "true": {
                "top-jds_divider": {
                    "hidden": true
                },
                "label-container": {
                    "hidden": true
                }
            }
        },
        "hideBottomDivider": {
            "true": {
                "bottom-jds_divider": {
                    "hidden": true
                }
            }
        }
    },
    "api": {
        "children": {
            "menu-item-slot": {
                "name": "children",
                "accepts": [
                    "jds_dropdown_menu_item"
                ]
            }
        },
        "data": {
            "label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            }
        },
        "config": {
            "hideBottomDivider": {
                "values": [
                    false,
                    true
                ]
            },
            "_hideTopDivider": {
                "values": [
                    false,
                    true
                ]
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1B = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                _hideTopDivider: !props.label
            }
        });
    };
const $fe5170bdd3625759$var$Component$1D = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1y;
    const { hideBottomDivider: hideBottomDivider = false, custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            hideBottomDivider: hideBottomDivider,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDropdownMenuGroup", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$246bebaba3a2f70e = $fe5170bdd3625759$var$withLogic$1B($fe5170bdd3625759$var$Component$1D);
$fe5170bdd3625759$export$246bebaba3a2f70e.displayName = "DropdownMenuGroup";
$fe5170bdd3625759$export$246bebaba3a2f70e.slotName = "jds_dropdown_menu_group";
const $fe5170bdd3625759$var$sdl$1x = {
    "metadata": {
        "version": "1.0.0",
        "id": "dropdown-menu-1.0.0",
        "name": "JDSDropdownMenuInternal",
        "layerName": "jds_dropdown_menu_internal",
        "internal": true
    },
    "hierarchy": {
        "menu-container": [
            {
                "search-container": [
                    "jds_search_box"
                ]
            },
            {
                "menu-group-container": [
                    "menu-group-slot"
                ]
            },
            {
                "botton-container": [
                    "secondary-jds_action_button",
                    "primary-jds_action_button"
                ]
            }
        ]
    },
    "base": {
        "menu-container": {
            "hidden": false,
            "background-color": "{primaryGrey20}",
            "flex-direction": "{flexDirection.column}",
            "border-radius": "{large}",
            "pointer-events": "auto",
            "overflow": "hidden",
            "opacity": "{opacity.invisible}",
            "enter-animation-name": "fadeIn",
            "exit-animation-name": "fadeOut",
            "enter-animation-curve": "entrance_ease",
            "exit-animation-curve": "exit_ease",
            "enter-animation-duration": 500,
            "exit-animation-duration": 500,
            "box-shadow": {
                "x": 0,
                "y": 4,
                "blur": 16,
                "spread": 0,
                "color": "{custom_color_5}"
            }
        },
        "jds_search_box": {
            "prefix": "ic_search",
            "kind": "light_background",
            "width": "{size.max}"
        },
        "menu-group-container": {
            "hidden": false,
            "width": "{size.max}",
            "flex-direction": "{flexDirection.column}",
            "padding-top": "{xs}",
            "padding-bottom": "{xs}",
            "overflow-y": "auto"
        },
        "search-container": {
            "hidden": true,
            "width": "{size.max}",
            "padding-top": "{base}",
            "padding-left": "{base}",
            "padding-right": "{base}"
        },
        "menu-group-slot": {
            "hidden": false
        },
        "botton-container": {
            "hidden": true,
            "width": "{size.max}",
            "padding-top": "{base}",
            "padding-bottom": "{m}",
            "padding-left": "{base}",
            "padding-right": "{base}",
            "flex-direction": "{flexDirection.row}",
            "gap": "{s}"
        },
        "primary-jds_action_button": {
            "kind": "primary",
            "size": "medium",
            "stretch": true
        },
        "secondary-jds_action_button": {
            "kind": "secondary",
            "size": "medium",
            "stretch": true
        }
    },
    "variant": {
        "menuFullScreen": {
            "true": {
                "menu-container": {
                    "size": "{size.max}"
                }
            }
        },
        "_menuContainerVisible": {
            "true": {
                "menu-container": {
                    "opacity": "{opacity.enabled}"
                }
            }
        },
        "searchTrigger": {
            "true": {
                "search-container": {
                    "hidden": false
                }
            }
        },
        "kind": {
            "multi-select": {
                "botton-container": {
                    "hidden": false
                }
            }
        }
    },
    "combination": [
        {
            "multi-select": {
                "false": {
                    "botton-container": {
                        "hidden": true
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "kind",
            "showCTAButtons"
        ]
    ],
    "api": {
        "children": {
            "menu-group-slot": {
                "name": "children",
                "accepts": [
                    "jds_dropdown_menu_group"
                ]
            }
        },
        "events": {
            "jds_search_box": {
                "onSuffixClick": "onSuffixClick",
                "onChange": "onSearchChange"
            },
            "menu-container": {
                "onAppear": {
                    "name": "onAppear",
                    "platform": "ios"
                },
                "onClick": "onContainerClick"
            },
            "secondary-jds_action_button": {
                "onClick": "onSecondaryClick"
            },
            "primary-jds_action_button": {
                "onClick": "onPrimaryClick"
            }
        },
        "data": {
            "jds_search_box": {
                "label": {
                    "type": "string",
                    "name": "searchLabel"
                },
                "value": {
                    "type": "string",
                    "name": "searchValue"
                },
                "suffix": {
                    "type": "icon",
                    "name": "searchSuffix"
                }
            },
            "menu-container": {
                "width": {
                    "type": "size",
                    "name": "menuWidth"
                },
                "elementRef": {
                    "type": "ref",
                    "name": "triggerRef"
                }
            },
            "menu-group-container": {
                "max-height": {
                    "type": "string",
                    "name": "menuMaxHeight"
                }
            },
            "primary-jds_action_button": {
                "label": {
                    "type": "string",
                    "name": "primaryCTA"
                }
            },
            "secondary-jds_action_button": {
                "label": {
                    "type": "string",
                    "name": "secondaryCTA"
                }
            }
        },
        "config": {
            "kind": {
                "values": [
                    "single-select",
                    "multi-select"
                ]
            },
            "searchTrigger": {
                "values": [
                    false,
                    true
                ]
            },
            "showCTAButtons": {
                "values": [
                    true,
                    false
                ]
            },
            "labelTextWrap": {
                "values": [
                    false,
                    true
                ]
            },
            "open": {
                "values": [
                    false,
                    true
                ]
            },
            "menuWidthConfig": {
                "values": [
                    "max-content",
                    "trigger"
                ]
            },
            "position": {
                "values": [
                    "bottom_start",
                    "bottom_end",
                    "top_start",
                    "top_end",
                    "right_start",
                    "right_end",
                    "left_start",
                    "left_end",
                    "bottom_centre",
                    "top_centre"
                ]
            },
            "menuFullScreen": {
                "values": [
                    false,
                    true
                ]
            },
            "_menuContainerVisible": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "a11y": {
            "menu-container": {
                "properties": {
                    "role": {
                        "value": "menu"
                    }
                }
            },
            "jds_search_box": {
                "properties": {
                    "ariaLabel": "searchAriaLabel"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$DROPDOWNMENU_SELECTOR = "div.j-JDSDropdownMenuInternal-menu-container";
const $fe5170bdd3625759$var$withLogic$1A = (Component)=>(props)=>{
        const { activeMenuId: activeMenuId, setActiveMenuId: setActiveMenuId } = (0, $acw62.useContext)($fe5170bdd3625759$var$DropdownMenuContext);
        const { element: element, rootRef: rootRef } = $fe5170bdd3625759$var$useRootRef();
        const [menuVisible, setMenuVisible] = (0, $acw62.useState)(false);
        const [internalOpen, setInternalOpen] = (0, $acw62.useState)(false);
        const { anchorEl: anchorEl, position: position } = props;
        const dropdownMenuRef = element?.querySelector($fe5170bdd3625759$var$DROPDOWNMENU_SELECTOR);
        (0, $acw62.useEffect)(()=>{
            if (props.open) setTimeout(()=>{
                setInternalOpen(true);
                setMenuVisible(true);
            }, 10);
            else {
                setMenuVisible(false);
                setTimeout(()=>{
                    setInternalOpen(false);
                }, 300);
            }
        }, [
            props.open,
            anchorEl,
            position,
            dropdownMenuRef
        ]);
        (0, $acw62.useEffect)(()=>{
            const handleKeyDown = (event)=>{
                if (props.open && !activeMenuId) switch(event.key){
                    case "ArrowUp":
                        $fe5170bdd3625759$var$handlePrevOrNextItemFocus(-1, dropdownMenuRef, ".j-JDSDropdownMenuItem-container");
                        event.preventDefault();
                        event.stopPropagation();
                        break;
                    case "ArrowDown":
                        $fe5170bdd3625759$var$handlePrevOrNextItemFocus(1, dropdownMenuRef, ".j-JDSDropdownMenuItem-container");
                        event.preventDefault();
                        event.stopPropagation();
                        break;
                    case "Escape":
                        props?.onClose?.();
                        anchorEl?.current?.focus?.();
                        break;
                }
            };
            if (props.open) window.addEventListener("keydown", handleKeyDown);
            return ()=>{
                window.removeEventListener("keydown", handleKeyDown);
            };
        }, [
            props.open,
            dropdownMenuRef,
            activeMenuId
        ]);
        const shouldShowSuffix = props?.searchConfig?.suffix !== false;
        const close = ()=>{
            props?.onClose?.();
            setMenuVisible(false);
            setActiveMenuId(void 0);
        };
        $fe5170bdd3625759$var$useScrollClose(close);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                open: internalOpen,
                onClose: ()=>{
                    props?.onClose?.();
                    setMenuVisible(false);
                    setActiveMenuId(void 0);
                },
                rootRef: rootRef,
                searchSuffix: shouldShowSuffix ? "IcMic" : void 0,
                searchLabel: props.searchLabel || "Search",
                searchValue: props.searchValue,
                onSuffixClick: props.onSuffixClick,
                onSearchChange: props?.onSearchChange,
                _onContainerClick: (event)=>{
                    event.stopPropagation();
                },
                _menuContainerVisible: menuVisible
            }
        });
    };
const $fe5170bdd3625759$var$Component$1C = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1x;
    const { kind: kind = "single-select", searchTrigger: searchTrigger = false, showCTAButtons: showCTAButtons = true, labelTextWrap: labelTextWrap = false, open: open = false, menuWidthConfig: menuWidthConfig = "max-content", position: position = "bottom_start", menuFullScreen: menuFullScreen = false, onSuffixClick: onSuffixClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSearchChange: onSearchChange = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onAppear: onAppear = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onContainerClick: onContainerClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSecondaryClick: onSecondaryClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onPrimaryClick: onPrimaryClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            searchTrigger: searchTrigger,
            showCTAButtons: showCTAButtons,
            labelTextWrap: labelTextWrap,
            open: open,
            menuWidthConfig: menuWidthConfig,
            position: position,
            menuFullScreen: menuFullScreen,
            onSuffixClick: onSuffixClick,
            onSearchChange: onSearchChange,
            onAppear: onAppear,
            onContainerClick: onContainerClick,
            onSecondaryClick: onSecondaryClick,
            onPrimaryClick: onPrimaryClick,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDropdownMenuInternal", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$5a9d97cdadce1b72 = $fe5170bdd3625759$var$withLogic$1A($fe5170bdd3625759$var$Component$1C);
$fe5170bdd3625759$export$5a9d97cdadce1b72.displayName = "DropdownMenuInternal";
$fe5170bdd3625759$export$5a9d97cdadce1b72.slotName = "jds_dropdown_menu_internal";
const $fe5170bdd3625759$var$sdl$1w = {
    "metadata": {
        "version": "1.0.0",
        "id": "dropdown-menu-item-1.0.0",
        "name": "JDSDropdownMenuItem",
        "layerName": "jds_dropdown_menu_item",
        "internal": true
    },
    "hierarchy": {
        "root-container": [
            {
                "container": [
                    "jds_checkbox",
                    {
                        "prefix-container": [
                            "prefix-slot"
                        ]
                    },
                    {
                        "content-container": [
                            "label-jds-text",
                            "description-jds-text"
                        ]
                    },
                    {
                        "suffix-container": [
                            "suffix-jds-text",
                            "icon"
                        ]
                    }
                ]
            },
            {
                "jds_dropdown_menu_submenu": [
                    "menu-group-slot"
                ]
            }
        ]
    },
    "base": {
        "root-container": {
            "hidden": false,
            "width": "{d_24}"
        },
        "container": {
            "hidden": false,
            "flex-direction": "{d_1}",
            "align-items": "{d_16}",
            "gap": "{d_3}",
            "background-color": "{d_4}",
            "width": "{d_0}",
            "padding-top": "{d_8}",
            "padding-right": "{d_9}",
            "padding-bottom": "{d_10}",
            "padding-left": "{d_11}",
            "opacity": "",
            "behavior": {
                "hover": {
                    "background-color": "{d_5}"
                },
                "active": {
                    "background-color": "{d_6}"
                },
                "focus": {
                    "border-radius": "{d_23}"
                }
            }
        },
        "menu-group-slot": {
            "hidden": false
        },
        "suffix-container": {
            "hidden": false
        },
        "prefix-container": {
            "hidden": false,
            "align-self": "{d_17}"
        },
        "prefix-slot": {
            "hidden": false
        },
        "content-container": {
            "hidden": false,
            "flex": 1,
            "overflow": "hidden",
            "justify-content": "{d_14}",
            "align-items": "{d_15}",
            "flex-direction": "{d_2}"
        },
        "icon": {
            "size": "{d_19}",
            "color": "{d_18}",
            "value": "ic_chevron_right",
            "behavior": {
                "active": {
                    "color": "{d_20}"
                }
            },
            "hidden": true
        },
        "jds_dropdown_menu_submenu": {
            "hidden": true
        },
        "jds_checkbox": {
            "hidden": true
        },
        "label-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey100}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false,
            "behavior": {
                "active": {
                    "color": "{primaryInverse}"
                }
            }
        },
        "description-jds-text": {
            "font-family": "{bodyXxs}",
            "color": "{primaryGrey100}",
            "font-size": "{bodyXxs}",
            "line-height": "{bodyXxs}",
            "letter-spacing": "{bodyXxs}",
            "font-weight": "{bodyXxs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false,
            "behavior": {
                "active": {
                    "color": "{primaryInverse}"
                }
            }
        },
        "suffix-jds-text": {
            "font-family": "{bodyXxs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXxs}",
            "line-height": "{bodyXxs}",
            "letter-spacing": "{bodyXxs}",
            "font-weight": "{bodyXxs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false,
            "behavior": {
                "active": {
                    "color": "{primaryInverse}"
                }
            }
        }
    },
    "variant": {
        "kind": {
            "multi-select": {
                "jds_checkbox": {
                    "hidden": false,
                    "checked": false
                },
                "container": {
                    "behavior": {
                        "active": {
                            "background-color": "{primaryGrey40}"
                        }
                    }
                },
                "icon": {
                    "behavior": {
                        "active": {
                            "color": "{primaryGrey80}"
                        }
                    }
                },
                "label-jds-text": {
                    "behavior": {
                        "active": {}
                    }
                },
                "description-jds-text": {
                    "behavior": {
                        "active": {}
                    }
                },
                "suffix-jds-text": {
                    "behavior": {
                        "active": {
                            "color": "{primaryGrey100}"
                        }
                    }
                }
            }
        },
        "_labelTextWrap": {
            "false": {
                "label-jds-text": {
                    "max-lines": 1,
                    "maxLines": 1
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{d_22}"
                }
            }
        },
        "selected": {
            "true": {
                "jds_dropdown_menu_submenu": {
                    "hidden": false
                },
                "container": {
                    "background-color": "{d_12}",
                    "behavior": {
                        "hover": {
                            "background-color": "{d_13}"
                        }
                    }
                },
                "icon": {
                    "color": "{d_21}"
                },
                "label-jds-text": {
                    "color": "{primaryInverse}"
                },
                "description-jds-text": {
                    "color": "{primaryInverse}"
                },
                "suffix-jds-text": {
                    "color": "{primaryInverse}"
                }
            }
        },
        "_hasSubMenu": {
            "true": {
                "icon": {
                    "hidden": false
                },
                "suffix-jds-text": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {
            "multi-select": {
                "true": {
                    "container": {
                        "background-color": "{primaryGrey20}",
                        "behavior": {
                            "hover": {
                                "background-color": "{primaryGrey20}"
                            }
                        }
                    },
                    "icon": {
                        "color": "{primaryGrey80}"
                    },
                    "label-jds-text": {},
                    "description-jds-text": {},
                    "suffix-jds-text": {
                        "color": "{primaryGrey100}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "kind",
            "selected"
        ]
    ],
    "api": {
        "children": {
            "prefix-slot": {
                "name": "prefix",
                "accepts": [
                    "jds_image",
                    "jds_avatar",
                    "jds_icon"
                ],
                "max": 1
            },
            "menu-group-slot": {
                "name": "children",
                "accepts": [
                    "jds_dropdown_menu_group"
                ]
            }
        },
        "events": {
            "container": {
                "onAppear": {
                    "name": "_onAppear",
                    "platform": "ios"
                },
                "onClick": "onClick"
            },
            "jds_checkbox": {
                "onClick": "onItemSelect"
            }
        },
        "data": {
            "jds_dropdown_menu_submenu": {
                "offsetX": {
                    "type": "string",
                    "name": "_offsetX"
                },
                "offsetY": {
                    "type": "string",
                    "name": "_offsetY"
                },
                "children": {
                    "type": "slot",
                    "name": "children",
                    "accepts": [
                        "jds_dropdown_menu_group"
                    ]
                }
            },
            "jds_checkbox": {
                "indeterminate": {
                    "type": "boolean",
                    "name": "_indeterminate"
                },
                "checked": {
                    "type": "boolean",
                    "name": "_checked"
                }
            },
            "label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            },
            "description-jds-text": {
                "value": {
                    "type": "string",
                    "name": "description"
                }
            },
            "suffix-jds-text": {
                "value": {
                    "type": "string",
                    "name": "suffix"
                }
            }
        },
        "config": {
            "kind": {
                "values": [
                    "single-select",
                    "multi-select"
                ]
            },
            "selected": {
                "values": [
                    false,
                    true
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            },
            "_hasSubMenu": {
                "values": [
                    false,
                    true
                ]
            },
            "_labelTextWrap": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "menuitem"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-haspopup": {
                        "name": "_ariaHaspopup",
                        "prop": "_hasSubMenu"
                    },
                    "aria-expanded": {
                        "name": "_ariaExpanded"
                    }
                }
            }
        }
    }
};
function $fe5170bdd3625759$var$getUniqueId() {
    return $fe5170bdd3625759$var$generateId() + "-" + $fe5170bdd3625759$var$generateId() + "-" + $fe5170bdd3625759$var$generateId();
}
const $fe5170bdd3625759$var$generateId = function() {
    return ((1 + Math.random()) * 65536 | 0).toString(16).substring(1);
};
const $fe5170bdd3625759$var$DROPDOWNMENUITEM_SELECTOR = "div.j-JDSDropdownMenuItem-container";
const $fe5170bdd3625759$var$SUBMENU_OFFSET_TOP = 8;
const $fe5170bdd3625759$var$SUBMENU_MARGIN = 4;
const $fe5170bdd3625759$var$getPrefixComponent = (prefix)=>{
    if (typeof prefix === "string") return $fe5170bdd3625759$var$getIcon$1(prefix);
    if (prefix?.props?.src) return (0, $acw62.cloneElement)(prefix, {
        ...prefix.props,
        roundedCorner: true,
        aspectRatio: "square",
        style: {
            width: "24px",
            height: "24px"
        }
    });
    if (prefix?.props?.initials || prefix?.props?.kind) return (0, $acw62.cloneElement)(prefix, {
        ...prefix.props,
        size: "x-small"
    });
    return void 0;
};
const $fe5170bdd3625759$var$withLogic$1z = (Component)=>(props)=>{
        const { element: element, rootRef: rootRef } = $fe5170bdd3625759$var$useRootRef();
        const [selected, setSelected] = (0, $acw62.useState)(false);
        const [menuItemId, setMenuItemId] = (0, $acw62.useState)("");
        const context = (0, $acw62.useContext)($fe5170bdd3625759$var$DropdownMenuContext);
        const [offset, setOffset] = (0, $acw62.useState)({
            offsetX: 0,
            offsetY: 0
        });
        (0, $acw62.useEffect)(()=>{
            setMenuItemId($fe5170bdd3625759$var$getUniqueId());
        }, []);
        (0, $acw62.useEffect)(()=>{
            if (context.isNested && !props.children) {
                if (selected) setSelected(false);
                return;
            }
            if (props.children) {
                context.setIsNested(true);
                setSelected(context.activeMenuId === menuItemId);
            } else if (props.kind === "multi-select") setSelected(context.selectedValues.includes(props.value || ""));
            else setSelected(context.selectedValue !== void 0 && context.selectedValue === props.value);
        }, [
            selected,
            context.activeMenuId,
            menuItemId,
            context.selectedValue,
            context.selectedValues,
            context.isNested,
            props.value,
            props.children
        ]);
        const handleSubMenuPositioning = ()=>{
            const dropdownMenuItemRef2 = element?.querySelector($fe5170bdd3625759$var$DROPDOWNMENUITEM_SELECTOR);
            if (dropdownMenuItemRef2) {
                const { right: right, top: top, bottom: bottom, left: left } = dropdownMenuItemRef2.getBoundingClientRect();
                setOffset({
                    offsetX: `${right + $fe5170bdd3625759$var$SUBMENU_MARGIN}px`,
                    offsetY: `${top - $fe5170bdd3625759$var$SUBMENU_OFFSET_TOP}px`
                });
                setTimeout(()=>{
                    const subMenuRef = document.querySelector(".j-jds-JDSDropdownMenuSubMenu-menu-container");
                    if (!subMenuRef) return;
                    const subMenuDomRect = subMenuRef.getBoundingClientRect();
                    if (subMenuDomRect.right < window.innerWidth) return;
                    if (subMenuDomRect.width < left) setOffset(({ offsetY: offsetY })=>({
                            offsetX: `${left - (subMenuDomRect.width + $fe5170bdd3625759$var$SUBMENU_MARGIN)}px`,
                            offsetY: offsetY
                        }));
                    else setOffset({
                        offsetX: `${window.innerWidth - subMenuDomRect.width}px`,
                        offsetY: `${bottom + $fe5170bdd3625759$var$SUBMENU_MARGIN}px`
                    });
                }, 50);
            }
        };
        const dropdownMenuItemRef = element?.querySelector($fe5170bdd3625759$var$DROPDOWNMENUITEM_SELECTOR);
        (0, $acw62.useEffect)(()=>{
            const handleKeyDown = (event)=>{
                switch(event.key){
                    case "ArrowRight":
                        if (document.activeElement === dropdownMenuItemRef) {
                            if (Boolean(props.children) && !selected) {
                                context.setActiveMenuId(menuItemId);
                                handleSubMenuPositioning();
                                setTimeout(()=>{
                                    const subMenuRef = document.querySelector(".j-JDSDropdownMenuSubMenu-menu-container");
                                    if (subMenuRef) $fe5170bdd3625759$var$handlePrevOrNextItemFocus(1, subMenuRef, ".j-JDSDropdownMenuItem-container");
                                }, 10);
                            }
                            event.preventDefault();
                            event.stopPropagation();
                        }
                        break;
                    case "ArrowLeft":
                    case "Escape":
                        if (selected && context.activeMenuId) {
                            setSelected(false);
                            context.setActiveMenuId("");
                            dropdownMenuItemRef?.focus?.();
                        }
                        break;
                }
            };
            window.addEventListener("keydown", handleKeyDown);
            return ()=>{
                window.removeEventListener("keydown", handleKeyDown);
            };
        }, [
            context.activeMenuId,
            selected,
            dropdownMenuItemRef,
            menuItemId
        ]);
        const children = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.toArray(props.children?.props?.children);
        const selectedItems = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.toArray(props.children?.props?.children).filter((child)=>{
            if (!(typeof child === "object")) return false;
            if (!("props" in child)) return false;
            return child.props.selected;
        });
        const isSelected = children.length ? selectedItems.length === children.length : props.selected;
        const handleClick = (event)=>{
            const updatedSelectedValues = [
                ...context.selectedValues
            ];
            if (props.children) {
                context.setActiveMenuId(menuItemId);
                handleSubMenuPositioning();
            } else if (props.kind === "multi-select") {
                const isChecked = event.target.checked;
                if (isChecked) {
                    if (!updatedSelectedValues.includes(props.value ?? "")) updatedSelectedValues.push(props.value ?? "");
                } else {
                    const index = updatedSelectedValues.indexOf(props.value ?? "");
                    if (index > -1) updatedSelectedValues.splice(index, 1);
                }
            } else context.setSelectedValue(props.value ?? "");
            if (props.kind === "multi-select") {
                children.forEach((child)=>{
                    if (typeof child === "object" && "props" in child) {
                        if (child.props.selected) {
                            if (!updatedSelectedValues.includes(child.props.value)) updatedSelectedValues.push(child.props.value);
                        } else {
                            const index = updatedSelectedValues.indexOf(child.props.value);
                            if (index > -1) updatedSelectedValues.splice(index, 1);
                        }
                    }
                });
                context.setSelectedValues(updatedSelectedValues);
            }
            props?.onClick?.(props.value);
        };
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                rootRef: rootRef,
                prefix: $fe5170bdd3625759$var$getPrefixComponent(props.prefix),
                disabled: Boolean(props.disabled),
                _labelTextWrap: context.labelTextWrap,
                _offsetX: offset.offsetX,
                _offsetY: offset.offsetY,
                _hasSubMenu: Boolean(props.children),
                selected: selected,
                _checked: isSelected,
                _indeterminate: !isSelected && selectedItems.length > 0,
                className: selected ? "selected" : "",
                onClick: handleClick,
                tabIndex: 0,
                _ariaExpanded: !props.children ? void 0 : selected ? "true" : "false"
            }
        });
    };
const $fe5170bdd3625759$var$Component$1B = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1w;
    const { kind: kind = "single-select", selected: selected = false, disabled: disabled = false, onClick: onClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onItemSelect: onItemSelect = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), ariaLabel: ariaLabel = props.label?.toString(), _ariaHaspopup: _ariaHaspopup = props._hasSubMenu?.toString(), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            selected: selected,
            disabled: disabled,
            onClick: onClick,
            onItemSelect: onItemSelect,
            ariaLabel: ariaLabel,
            _ariaHaspopup: _ariaHaspopup,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDropdownMenuItem", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$ed97964d1871885d = $fe5170bdd3625759$var$withLogic$1z($fe5170bdd3625759$var$Component$1B);
$fe5170bdd3625759$export$ed97964d1871885d.displayName = "DropdownMenuItem";
$fe5170bdd3625759$export$ed97964d1871885d.slotName = "jds_dropdown_menu_item";
const $fe5170bdd3625759$var$sdl$1v = {
    "metadata": {
        "version": "1.0.0",
        "id": "dropdown-menu-submenu-1.0.0",
        "name": "JDSDropdownMenuSubMenu",
        "layerName": "jds_dropdown_menu_sub_menu",
        "internal": true
    },
    "hierarchy": {
        "popup": [
            {
                "popup-container": [
                    "jds_dropdown_menu_sub_menu_internal"
                ]
            }
        ]
    },
    "base": {
        "popup": {
            "priority": 65,
            "background-color": "{global.transparent}",
            "passive": true
        }
    },
    "variant": {
        "_platform": {
            "mobile": {
                "popup-container": {
                    "size": "{size.max}"
                }
            }
        }
    },
    "api": {
        "data": {
            "popup-container": {
                "padding-left": {
                    "type": "size",
                    "name": "offsetX"
                },
                "padding-top": {
                    "type": "size",
                    "name": "offsetY"
                }
            },
            "jds_dropdown_menu_sub_menu_internal": {
                "_menuWidth": {
                    "type": "size",
                    "name": "_menuWidth"
                },
                "_menuMaxHeight": {
                    "type": "size",
                    "name": "_menuMaxHeight"
                },
                "triggerRef": {
                    "type": "ref",
                    "name": "triggerRef"
                },
                "children": {
                    "name": "children",
                    "type": "slot",
                    "accepts": [
                        "jds_dropdown_menu_group"
                    ]
                }
            }
        },
        "events": {
            "jds_dropdown_menu_sub_menu_internal": {
                "onAppear": {
                    "name": "_onAppear",
                    "platform": "ios"
                },
                "onSelect": "onSelect"
            }
        },
        "config": {
            "_platform": {
                "values": [
                    "mobile",
                    "desktop"
                ]
            },
            "_menuContainerVisible": {
                "values": [
                    false,
                    true
                ]
            }
        }
    }
};
const $fe5170bdd3625759$var$DROPDOWNMENUSUBMENU_SELECTOR = "div.j-JDSDropdownMenuSubMenuInternal-menu-container";
const $fe5170bdd3625759$var$withLogic$1y = (Component)=>(props)=>{
        const { element: element, rootRef: rootRef } = $fe5170bdd3625759$var$useRootRef();
        const context = (0, $acw62.useContext)($fe5170bdd3625759$var$DropdownMenuContext);
        const [visible, setVisible] = (0, $acw62.useState)(false);
        const childArray = (0, $acw62.Children).toArray(props.children);
        const firstChild = childArray[0];
        const dropdownMenuSubMenuRef = element?.querySelector($fe5170bdd3625759$var$DROPDOWNMENUSUBMENU_SELECTOR);
        (0, $acw62.useEffect)(()=>{
            if (dropdownMenuSubMenuRef) setTimeout(()=>{
                dropdownMenuSubMenuRef.focus();
            });
        }, [
            dropdownMenuSubMenuRef,
            visible
        ]);
        (0, $acw62.useEffect)(()=>{
            const handleKeyDown = (event)=>{
                const isOpen = dropdownMenuSubMenuRef?.contains(document.activeElement);
                if (isOpen) switch(event.key){
                    case "ArrowUp":
                        $fe5170bdd3625759$var$handlePrevOrNextItemFocus(-1, dropdownMenuSubMenuRef, ".j-JDSDropdownMenuItem-container");
                        event.preventDefault();
                        event.stopPropagation();
                        break;
                    case "ArrowDown":
                        $fe5170bdd3625759$var$handlePrevOrNextItemFocus(1, dropdownMenuSubMenuRef, ".j-JDSDropdownMenuItem-container");
                        event.preventDefault();
                        event.stopPropagation();
                        break;
                }
            };
            if (context.activeMenuId) window.addEventListener("keydown", handleKeyDown);
            return ()=>{
                window.removeEventListener("keydown", handleKeyDown);
            };
        }, [
            context.activeMenuId,
            dropdownMenuSubMenuRef
        ]);
        (0, $acw62.useEffect)(()=>{
            setTimeout(()=>{
                setVisible(true);
            }, 50);
        }, []);
        const isMobile = $fe5170bdd3625759$var$Devices.isMobile();
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                rootRef: rootRef,
                _menuContainerVisible: visible,
                _menuWidth: "max-content",
                offsetX: isMobile ? 0 : props.offsetX,
                offsetY: isMobile ? 0 : props.offsetY,
                _platform: isMobile ? "mobile" : "desktop",
                children: (0, $acw62.isValidElement)(firstChild) ? firstChild.props._childrenProps.props.children : null
            }
        });
    };
const $fe5170bdd3625759$var$Component$1A = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1v;
    const { onSelect: onSelect = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            onSelect: onSelect,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDropdownMenuSubMenu", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$51cd9091d2dcc10a = $fe5170bdd3625759$var$withLogic$1y($fe5170bdd3625759$var$Component$1A);
$fe5170bdd3625759$export$51cd9091d2dcc10a.displayName = "DropdownMenuSubMenu";
$fe5170bdd3625759$export$51cd9091d2dcc10a.slotName = "jds_dropdown_menu_sub_menu";
const $fe5170bdd3625759$var$sdl$1u = {
    "metadata": {
        "version": "1.0.0",
        "id": "dropdown-menu-submenu-1.0.0",
        "name": "JDSDropdownMenuSubMenuInternal",
        "layerName": "jds_dropdown_menu_sub_menu_internal",
        "internal": true
    },
    "hierarchy": {
        "menu-container": [
            "menu-group-slot"
        ]
    },
    "base": {
        "menu-container": {
            "hidden": false,
            "background-color": "{primaryGrey20}",
            "flex-direction": "{flexDirection.column}",
            "border-radius": "{large}",
            "pointer-events": "auto",
            "overflow": "hidden",
            "padding-top": "{xs}",
            "padding-bottom": "{xs}",
            "overflow-y": "auto",
            "opacity": "{opacity.invisible}",
            "enter-animation-name": "fadeIn",
            "exit-animation-name": "fadeOut",
            "enter-animation-curve": "entrance_ease",
            "exit-animation-curve": "exit_ease",
            "enter-animation-duration": 500,
            "exit-animation-duration": 500,
            "box-shadow": {
                "x": 0,
                "y": 4,
                "blur": 16,
                "spread": 0,
                "color": "{custom_color_5}"
            }
        },
        "menu-group-slot": {
            "hidden": false
        }
    },
    "variant": {
        "_platform": {
            "mobile": {
                "menu-container": {
                    "size": "{size.max}"
                }
            }
        },
        "_menuContainerVisible": {
            "true": {
                "menu-container": {
                    "opacity": "{opacity.enabled}"
                }
            }
        }
    },
    "api": {
        "children": {
            "menu-group-slot": {
                "name": "children",
                "accepts": [
                    "jds_dropdown_menu_group"
                ]
            }
        },
        "data": {
            "menu-container": {
                "width": {
                    "type": "size",
                    "name": "_menuWidth"
                },
                "max-height": {
                    "type": "size",
                    "name": "_menuMaxHeight"
                },
                "elementRef": {
                    "type": "ref",
                    "name": "triggerRef"
                }
            }
        },
        "events": {
            "menu-container": {
                "onAppear": {
                    "name": "onAppear",
                    "platform": "ios"
                },
                "onClick": "onSelect"
            }
        },
        "config": {
            "_platform": {
                "values": [
                    "mobile",
                    "desktop"
                ]
            },
            "_menuContainerVisible": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "a11y": {
            "menu-container": {
                "properties": {
                    "role": {
                        "value": "menu"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1x = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$1z = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1u;
    const { onAppear: onAppear = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSelect: onSelect = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            onAppear: onAppear,
            onSelect: onSelect,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDropdownMenuSubMenuInternal", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$897b7938c608ac58 = $fe5170bdd3625759$var$withLogic$1x($fe5170bdd3625759$var$Component$1z);
$fe5170bdd3625759$export$897b7938c608ac58.displayName = "DropdownMenuSubMenuInternal";
$fe5170bdd3625759$export$897b7938c608ac58.slotName = "jds_dropdown_menu_sub_menu_internal";
const $fe5170bdd3625759$var$sdl$1t = {
    "metadata": {
        "version": "1.0.0",
        "id": "fab-1.0.0",
        "name": "JDSFAB",
        "layerName": "jds_fab",
        "description": "The Floating Action Button(FAB) performs the primary, or most common, action on a screen.",
        "usage": "It places the key user action within easy reach by being persistently visible at a fixed point on a screen."
    },
    "hierarchy": {
        "popup": [
            {
                "popup-container": [
                    "jds_fab_internal"
                ]
            }
        ]
    },
    "base": {
        "popup": {
            "priority": 50,
            "passive": true
        },
        "popup-container": {
            "show": true,
            "flex-direction": "{f_0}",
            "justify-content": "{f_1}",
            "align-items": "{f_2}",
            "size": "{f_3}",
            "padding-right": "{f_4}",
            "padding-bottom": "{f_5}"
        },
        "jds_fab_internal": {
            "hidden": false
        }
    },
    "variant": {
        "show": {
            "false": {
                "popup-container": {
                    "padding-bottom": "0"
                },
                "jds_fab_internal": {
                    "show": false
                }
            }
        },
        "extend": {
            "false": {
                "jds_fab_internal": {
                    "extend": false
                }
            }
        },
        "disableAnimation": {
            "false": {
                "popup-container": {
                    "transition": {
                        "property": [
                            "padding-bottom"
                        ],
                        "duration": "{rapid}",
                        "timing-function": "{easeJoyfulEntrance}"
                    }
                },
                "jds_fab_internal": {
                    "disableAnimation": false
                }
            },
            "true": {
                "jds_fab_internal": {
                    "disableAnimation": true
                }
            }
        }
    },
    "api": {
        "data": {
            "jds_fab_internal": {
                "title": {
                    "type": "string",
                    "name": "title",
                    "doc_description": "It displays the title of FAB."
                },
                "icon": {
                    "type": "icon",
                    "name": "icon",
                    "doc_description": "It displays icon of FAB."
                }
            }
        },
        "config": {
            "show": {
                "values": [
                    true,
                    false
                ],
                "doc_description": "It can be used to show or hide FAB."
            },
            "extend": {
                "values": [
                    true,
                    false
                ],
                "doc_description": "When false, shows only icon."
            },
            "disableAnimation": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to control the entry animation of FAB"
            }
        },
        "events": {
            "jds_fab_internal": {
                "onClick": "onClick",
                "onHover": {
                    "name": "onHover",
                    "platform": "web"
                },
                "onHoverEnd": {
                    "name": "onHoverEnd",
                    "platform": "web"
                }
            }
        },
        "a11y": {
            "jds_fab_internal": {
                "properties": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1w = (Component)=>(props)=>{
        const [scroll, setScroll] = (0, $acw62.useState)(false);
        const [hovered, setHovered] = (0, $acw62.useState)(false);
        const { extend: extend, extendOnHover: extendOnHover, shrinkOnScroll: shrinkOnScroll, onHide: onHide, onShow: onShow, onUnmount: onUnmount } = props;
        const scrollListener = (0, $acw62.useCallback)((ev)=>{
            if (shrinkOnScroll) setScroll(ev.currentTarget.scrollY !== 0);
        }, [
            shrinkOnScroll
        ]);
        (0, $acw62.useEffect)(()=>{
            return ()=>{
                onUnmount?.();
            };
        }, [
            onUnmount
        ]);
        (0, $acw62.useEffect)(()=>{
            window.addEventListener("scroll", scrollListener);
            return ()=>{
                window.removeEventListener("scroll", scrollListener);
            };
        }, [
            scrollListener
        ]);
        const internalExtend = (0, $acw62.useCallback)(()=>{
            if (!props.title) return false;
            if (scroll) {
                if (shrinkOnScroll) {
                    onHide?.();
                    return false;
                }
            }
            if (extend) {
                onShow?.();
                return true;
            }
            if (hovered) onShow?.();
            return hovered;
        }, [
            extend,
            scroll,
            hovered,
            onHide,
            onShow,
            shrinkOnScroll
        ]);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                className: "fab-pointer",
                extend: internalExtend(),
                _hasTitle: Boolean(props.title),
                onHover: (ev)=>{
                    ev.stopPropagation();
                    if (extendOnHover) setHovered(true);
                },
                onHoverEnd: (ev)=>{
                    ev.stopPropagation();
                    setHovered(false);
                }
            }
        });
    };
const $fe5170bdd3625759$var$Component$1y = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1t;
    const { show: show = true, extend: extend = true, disableAnimation: disableAnimation = false, onClick: onClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onHover: onHover = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onHoverEnd: onHoverEnd = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            show: show,
            extend: extend,
            disableAnimation: disableAnimation,
            onClick: onClick,
            onHover: onHover,
            onHoverEnd: onHoverEnd,
            ...rest
        },
        componentTag: componentTag
    }, "JDSFAB", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$72beae6a392d0fc6 = $fe5170bdd3625759$var$withLogic$1w($fe5170bdd3625759$var$Component$1y);
$fe5170bdd3625759$export$72beae6a392d0fc6.displayName = "FAB";
$fe5170bdd3625759$export$72beae6a392d0fc6.slotName = "jds_fab";
const $fe5170bdd3625759$var$sdl$1s = {
    "metadata": {
        "version": "1.0.0",
        "id": "fab-1.0.0",
        "name": "JDSFABInternal",
        "layerName": "jds_fab_internal",
        "description": "The Floating Action Button(FAB) performs the primary, or most common, action on a screen.",
        "usage": "It places the key user action within easy reach by being persistently visible at a fixed point on a screen.",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "icon",
            "jds-text"
        ]
    },
    "base": {
        "container": {
            "hidden": false,
            "background-color": "{f_6}",
            "display": "flex",
            "flex-direction": "{f_7}",
            "justify-content": "{f_8}",
            "align-items": "{f_9}",
            "gap": "{f_10}",
            "border-radius": "{f_11}",
            "padding-top": "{f_12}",
            "padding-left": "{f_13}",
            "padding-right": "{f_14}",
            "padding-bottom": "{f_15}",
            "border-color": "{f_16}",
            "border-width": "{f_17}",
            "box-shadow": {
                "x": 0,
                "y": 4,
                "blur": 16,
                "spread": 0,
                "color": "#00000014"
            },
            "behavior": {
                "hover": {
                    "background-color": "{f_18}",
                    "box-shadow": {
                        "x": 0,
                        "y": 4,
                        "blur": 16,
                        "spread": 0,
                        "color": "#00000029"
                    }
                },
                "active": {
                    "background-color": "{f_19}",
                    "box-shadow": {
                        "x": 0,
                        "y": 4,
                        "blur": 16,
                        "spread": 0,
                        "color": "#0000003D"
                    }
                },
                "focus": {
                    "background-color": "{f_20}",
                    "border-width": "{f_21}",
                    "box-shadow": {
                        "x": 0,
                        "y": 4,
                        "blur": 16,
                        "spread": 0,
                        "color": "#00000029"
                    }
                }
            }
        },
        "icon": {
            "hidden": false,
            "size": "{f_22}",
            "color": "{f_23}",
            "border-radius": "{f_24}",
            "behavior": {
                "active": {
                    "color": "{f_25}"
                }
            }
        },
        "jds-text": {
            "font-family": "{bodySBold}",
            "color": "{secondaryInverse}",
            "font-size": "{bodySBold}",
            "line-height": "{bodySBold}",
            "letter-spacing": "{bodySBold}",
            "font-weight": "{bodySBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false,
            "behavior": {
                "active": {
                    "color": "{secondary30}"
                }
            }
        }
    },
    "variant": {
        "show": {
            "false": {
                "container": {
                    "hidden": true,
                    "translate-y": "{size.max}"
                }
            }
        },
        "extend": {
            "false": {
                "container": {
                    "padding-left": "{f_26}",
                    "padding-right": "{f_27}"
                },
                "jds-text": {
                    "hidden": true
                }
            }
        },
        "disableAnimation": {
            "false": {
                "container": {
                    "enter-animation-name": "slideVerticallyUp",
                    "exit-animation-name": "slideVerticallyDown",
                    "enter-animation-curve": "entrance_ease",
                    "exit-animation-curve": "exit_ease",
                    "enter-animation-duration": 500,
                    "exit-animation-duration": 500,
                    "translate-y": "0",
                    "transition": {
                        "property": [
                            "background-color",
                            "box-shadow",
                            "padding-left",
                            "padding-right",
                            "translate-y"
                        ],
                        "duration": "{rapid}",
                        "timing-function": "{easeJoyfulEntrance}"
                    }
                }
            },
            "true": {
                "container": {
                    "transition": {
                        "property": [
                            "background-color",
                            "box-shadow",
                            "padding-left",
                            "padding-right"
                        ],
                        "duration": "{rapid}",
                        "timing-function": "{easeJoyfulEntrance}"
                    }
                }
            }
        },
        "_hasTitle": {
            "false": {
                "jds-text": {
                    "hidden": true
                }
            }
        }
    },
    "api": {
        "data": {
            "icon": {
                "value": {
                    "type": "icon",
                    "name": "icon",
                    "doc_description": "It displays icon of FAB."
                }
            },
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "title",
                    "doc_description": "It displays the title of FAB."
                }
            }
        },
        "config": {
            "show": {
                "values": [
                    true,
                    false
                ],
                "doc_description": "It can be used to show or hide FAB."
            },
            "extend": {
                "values": [
                    true,
                    false
                ],
                "doc_description": "When false, shows only icon."
            },
            "disableAnimation": {
                "values": [
                    false,
                    true
                ]
            },
            "_hasTitle": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "events": {
            "container": {
                "onClick": "onClick",
                "onHover": {
                    "name": "onHover",
                    "platform": "web"
                },
                "onHoverEnd": {
                    "name": "onHoverEnd",
                    "platform": "web"
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "button"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "title"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "icon": {
                "properties": {
                    "role": {
                        "value": "img"
                    },
                    "aria-label": {
                        "name": "iconAriaLabel",
                        "function": true
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1v = (Component)=>(props)=>{
        const [scroll, setScroll] = (0, $acw62.useState)(false);
        const [hovered, setHovered] = (0, $acw62.useState)(false);
        const { extend: extend, extendOnHover: extendOnHover, shrinkOnScroll: shrinkOnScroll, onHide: onHide, onShow: onShow, onUnmount: onUnmount } = props;
        const scrollListener = (0, $acw62.useCallback)((ev)=>{
            if (shrinkOnScroll) setScroll(ev.currentTarget.scrollY !== 0);
        }, [
            shrinkOnScroll
        ]);
        (0, $acw62.useEffect)(()=>{
            return ()=>{
                onUnmount?.();
            };
        }, [
            onUnmount
        ]);
        (0, $acw62.useEffect)(()=>{
            window.addEventListener("scroll", scrollListener);
            return ()=>{
                window.removeEventListener("scroll", scrollListener);
            };
        }, [
            scrollListener
        ]);
        const internalExtend = (0, $acw62.useCallback)(()=>{
            if (!props.title) return false;
            if (scroll) {
                if (shrinkOnScroll) {
                    onHide?.();
                    return false;
                }
            }
            if (extend) {
                onShow?.();
                return true;
            }
            if (hovered) onShow?.();
            return hovered;
        }, [
            extend,
            scroll,
            hovered,
            onHide,
            onShow,
            shrinkOnScroll
        ]);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                className: "fabinternal-pointer",
                extend: internalExtend(),
                _hasTitle: Boolean(props.title),
                iconAriaLabel: props.iconAriaLabel || $fe5170bdd3625759$var$formatIconName(props.icon),
                onHover: (ev)=>{
                    ev.stopPropagation();
                    if (extendOnHover) setHovered(true);
                },
                onHoverEnd: (ev)=>{
                    ev.stopPropagation();
                    setHovered(false);
                }
            }
        });
    };
const $fe5170bdd3625759$var$Component$1x = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1s;
    const { show: show = true, extend: extend = true, disableAnimation: disableAnimation = false, onClick: onClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onHover: onHover = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onHoverEnd: onHoverEnd = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), ariaLabel: ariaLabel = props.title?.toString(), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            show: show,
            extend: extend,
            disableAnimation: disableAnimation,
            onClick: onClick,
            onHover: onHover,
            onHoverEnd: onHoverEnd,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSFABInternal", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$f3670f01e3026458 = $fe5170bdd3625759$var$withLogic$1v($fe5170bdd3625759$var$Component$1x);
$fe5170bdd3625759$export$f3670f01e3026458.displayName = "FABInternal";
$fe5170bdd3625759$export$f3670f01e3026458.slotName = "jds_fab_internal";
const $fe5170bdd3625759$var$sdl$1r = {
    "metadata": {
        "version": "1.0.0",
        "id": "feedback-block-1.0.0",
        "name": "JDSFeedbackBlock",
        "layerName": "jds_feedback_block"
    },
    "hierarchy": {
        "container": [
            {
                "icon-container": [
                    "icon"
                ]
            },
            "jds-text"
        ]
    },
    "base": {
        "container": {
            "hidden": true,
            "flex-direction": "{f_0}",
            "justify-content": "{f_1}",
            "align-items": "{f_2}",
            "gap": "{f_3}"
        },
        "icon-container": {
            "flex-direction": "{f_5}",
            "justify-content": "{f_6}",
            "align-items": "{f_7}",
            "height": "{f_8}"
        },
        "icon": {
            "size": "{f_9}"
        },
        "jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey100}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "size": {
            "s": {
                "icon-container": {
                    "height": "{f_10}"
                },
                "icon": {
                    "size": "{f_11}"
                },
                "jds-text": {
                    "font-family": "{bodyXs}",
                    "font-size": "{bodyXs}",
                    "line-height": "{bodyXs}",
                    "letter-spacing": "{bodyXs}",
                    "font-weight": "{bodyXs}"
                }
            }
        },
        "state": {
            "success": {
                "container": {
                    "hidden": false
                },
                "icon": {
                    "value": "ic_success_colored",
                    "color": "{feedbackSuccess50}"
                },
                "jds-text": {
                    "color": "{feedbackSuccess80}"
                }
            },
            "error": {
                "container": {
                    "hidden": false
                },
                "icon": {
                    "value": "ic_error_colored",
                    "color": "{feedbackError50}"
                },
                "jds-text": {
                    "color": "{feedbackError80}"
                }
            },
            "warning": {
                "container": {
                    "hidden": false
                },
                "icon": {
                    "value": "ic_warning_colored",
                    "color": "{feedbackWarning50}"
                },
                "jds-text": {
                    "color": "{feedbackWarning80}"
                }
            }
        },
        "alignment": {
            "top": {
                "container": {
                    "align-items": "{f_4}"
                }
            }
        }
    },
    "api": {
        "config": {
            "size": {
                "values": [
                    "l",
                    "s"
                ]
            },
            "state": {
                "values": [
                    "none",
                    "success",
                    "error",
                    "warning"
                ]
            },
            "alignment": {
                "values": [
                    "center",
                    "top"
                ]
            }
        },
        "data": {
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "stateText"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1u = (Component)=>(props)=>{
        if (!props.stateText) return null;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$1w = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1r;
    const { size: size = "l", state: state = "none", alignment: alignment = "center", custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            size: size,
            state: state,
            alignment: alignment,
            ...rest
        },
        componentTag: componentTag
    }, "JDSFeedbackBlock", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$var$FeedbackBlock = $fe5170bdd3625759$var$withLogic$1u($fe5170bdd3625759$var$Component$1w);
$fe5170bdd3625759$var$FeedbackBlock.displayName = "FeedbackBlock";
$fe5170bdd3625759$var$FeedbackBlock.slotName = "jds_feedback_block";
const $fe5170bdd3625759$var$sdl$1q = {
    "metadata": {
        "version": "1.0.0",
        "id": "file-uploader-control-1.0.0",
        "name": "JDSFileUploaderControl",
        "layerName": "jds_file_uploader_control",
        "internal": true
    },
    "hierarchy": {
        "container": [
            {
                "label-container": [
                    "label-jds-text",
                    {
                        "info-jds-icon-container": [
                            "info-jds-icon"
                        ]
                    }
                ]
            },
            "upload-jds_button",
            "helper-jds-text"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{f_0}",
            "justify-content": "{f_1}",
            "align-items": "{f_2}",
            "gap": "{f_3}",
            "width": "{f_4}",
            "opacity": "{f_5}"
        },
        "label-container": {
            "flex-direction": "{f_6}",
            "justify-content": "{f_7}",
            "align-items": "{f_8}",
            "gap": "{f_9}"
        },
        "upload-jds_button": {
            "iconLeft": "ic_upload",
            "kind": "secondary",
            "size": "medium",
            "fullWidth": true
        },
        "label-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "textType": "label"
        },
        "info-jds-icon": {
            "size": "{base}",
            "color": "{primaryGrey80}",
            "value": "ic_info",
            "ic": "ic_info"
        },
        "info-jds-icon-container": {
            "background-color": "{global.transparent}",
            "border-radius": "{pill}",
            "size": "{base}",
            "justify-content": "{justifyContent.center}",
            "align-items": "{alignItems.center}",
            "ic": "ic_info"
        },
        "helper-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {},
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "data": {
            "upload-jds_button": {
                "label": {
                    "type": "string",
                    "name": "uploadButtonLabel"
                }
            },
            "label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            },
            "helper-jds-text": {
                "value": {
                    "type": "string",
                    "name": "helperText"
                }
            }
        },
        "events": {
            "upload-jds_button": {
                "onClick": "onClick"
            },
            "info-jds-icon": {
                "onClick": "onInfoClick"
            }
        },
        "a11y": {
            "upload-jds_button": {
                "properties": {
                    "ariaLabel": "uploadButtonAriaLabel"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1t = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$1v = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1q;
    const { onClick: onClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onInfoClick: onInfoClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            onClick: onClick,
            onInfoClick: onInfoClick,
            ...rest
        },
        componentTag: componentTag
    }, "JDSFileUploaderControl", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$2548bc68b9cf13da = $fe5170bdd3625759$var$withLogic$1t($fe5170bdd3625759$var$Component$1v);
$fe5170bdd3625759$export$2548bc68b9cf13da.displayName = "FileUploaderControl";
$fe5170bdd3625759$export$2548bc68b9cf13da.slotName = "jds_file_uploader_control";
const $fe5170bdd3625759$var$sdl$1p = {
    "metadata": {
        "version": "1.0.0",
        "id": "file-uploader-item-1.0.0",
        "name": "JDSFileUploaderItem",
        "layerName": "jds_file_uploader_item",
        "internal": true
    },
    "hierarchy": {
        "container": [
            {
                "file-container": [
                    {
                        "state-container": [
                            "jds_spinner",
                            {
                                "state-jds-icon-container": [
                                    "state-jds-icon"
                                ]
                            },
                            "message-jds-text"
                        ]
                    },
                    {
                        "button-container": [
                            "suffix-jds_button"
                        ]
                    }
                ]
            },
            "jds_divider"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{f_0}",
            "justify-content": "{f_1}",
            "align-items": "{f_2}",
            "width": "{f_3}",
            "opacity": "{f_4}",
            "background-color": "{f_5}"
        },
        "file-container": {
            "flex-direction": "{f_6}",
            "justify-content": "{f_7}",
            "align-items": "{f_8}",
            "gap": "{f_9}",
            "padding-left": "{f_10}",
            "width": "{f_11}"
        },
        "state-container": {
            "flex-direction": "{f_12}",
            "justify-content": "{f_13}",
            "align-items": "{f_14}",
            "gap": "{f_15}"
        },
        "jds_spinner": {
            "hidden": true,
            "kind": "normal",
            "size": "small"
        },
        "button-container": {
            "show": true,
            "size": "48",
            "align-items": "{f_16}"
        },
        "suffix-jds_button": {
            "icon": "ic_close",
            "kind": "tertiary",
            "size": "small"
        },
        "jds_divider": {
            "hidden": false,
            "orientation": "horizontal",
            "pad": "none"
        },
        "state-jds-icon": {
            "size": "{m}",
            "color": "{primary50}",
            "hidden": true
        },
        "state-jds-icon-container": {
            "background-color": "{global.transparent}",
            "border-radius": "{pill}",
            "size": "{m}",
            "justify-content": "{justifyContent.center}",
            "align-items": "{alignItems.center}",
            "hidden": true
        },
        "message-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "textType": "label"
        }
    },
    "variant": {
        "kind": {
            "collapsed": {
                "suffix-jds_button": {
                    "icon": "ic_chevron_down"
                },
                "jds_divider": {
                    "hidden": true
                }
            },
            "expanded": {
                "suffix-jds_button": {
                    "icon": "ic_chevron_up"
                },
                "jds_divider": {
                    "hidden": true
                }
            }
        },
        "showDivider": {
            "false": {
                "jds_divider": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {
            "normal": {
                "loading": {
                    "jds_spinner": {
                        "hidden": false
                    },
                    "state-jds-icon": {},
                    "state-jds-icon-container": {
                        "background-color": "{global.transparent}",
                        "border-radius": "{pill}",
                        "size": "{m}",
                        "justify-content": "{justifyContent.center}",
                        "align-items": "{alignItems.center}",
                        "hidden": true
                    }
                },
                "success": {
                    "jds_spinner": {
                        "hidden": true
                    },
                    "state-jds-icon": {
                        "color": "{feedbackSuccess50}",
                        "value": "ic_success_colored",
                        "hidden": false,
                        "ic": "ic_success_colored"
                    },
                    "state-jds-icon-container": {
                        "background-color": "{global.transparent}",
                        "border-radius": "{pill}",
                        "size": "{m}",
                        "justify-content": "{justifyContent.center}",
                        "align-items": "{alignItems.center}",
                        "hidden": false,
                        "ic": "ic_success_colored"
                    },
                    "message-jds-text": {
                        "color": "{feedbackSuccess50}"
                    }
                },
                "error": {
                    "jds_spinner": {
                        "hidden": true
                    },
                    "suffix-jds_button": {
                        "hidden": true
                    },
                    "state-jds-icon": {
                        "color": "{feedbackError50}",
                        "value": "ic_error_colored",
                        "hidden": false,
                        "ic": "ic_error_colored"
                    },
                    "state-jds-icon-container": {
                        "background-color": "{global.transparent}",
                        "border-radius": "{pill}",
                        "size": "{m}",
                        "justify-content": "{justifyContent.center}",
                        "align-items": "{alignItems.center}",
                        "hidden": false,
                        "ic": "ic_error_colored"
                    },
                    "message-jds-text": {
                        "color": "{feedbackError50}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "kind",
            "state"
        ]
    ],
    "api": {
        "config": {
            "state": {
                "values": [
                    "loading",
                    "success",
                    "error"
                ]
            },
            "kind": {
                "values": [
                    "normal",
                    "collapsed",
                    "expanded"
                ]
            },
            "showDivider": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "message-jds-text": {
                "value": {
                    "type": "string",
                    "name": "message"
                }
            }
        },
        "events": {
            "suffix-jds_button": {
                "onClick": "onClick"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "listitem"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "message"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "suffix-jds_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "suffixAriaLabel",
                        "value": "Remove File"
                    },
                    "ariaExpanded": "ariaExpanded"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1s = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props,
            onClick: ()=>{
                props.onClick?.(props.internalIndex);
            }
        });
    };
const $fe5170bdd3625759$var$Component$1u = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1p;
    const { state: state = "loading", kind: kind = "normal", showDivider: showDivider = true, onClick: onClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), ariaLabel: ariaLabel = props.message?.toString(), suffixAriaLabel: suffixAriaLabel = "Remove File", custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            state: state,
            kind: kind,
            showDivider: showDivider,
            onClick: onClick,
            ariaLabel: ariaLabel,
            suffixAriaLabel: suffixAriaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSFileUploaderItem", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$b41bb47bfc36c3b4 = $fe5170bdd3625759$var$withLogic$1s($fe5170bdd3625759$var$Component$1u);
$fe5170bdd3625759$export$b41bb47bfc36c3b4.displayName = "FileUploaderItem";
$fe5170bdd3625759$export$b41bb47bfc36c3b4.slotName = "jds_file_uploader_item";
const $fe5170bdd3625759$var$sdl$1o = {
    "metadata": {
        "version": "1.0.0",
        "id": "file-uploader-list-1.0.0",
        "name": "JDSFileUploaderList",
        "layerName": "jds_file_uploader_list",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "jds_file_uploader_item"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{f_0}",
            "justify-content": "{f_1}",
            "align-items": "{f_2}",
            "width": "{f_3}",
            "opacity": "{f_4}",
            "background-color": "{f_5}",
            "border-radius": "{f_6}"
        },
        "jds_file_uploader_item": {
            "kind": "normal",
            "showDivider": true
        }
    },
    "variant": {
        "showDivider": {
            "false": {
                "jds_file_uploader_item": {
                    "showDivider": false
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "showDivider": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "container": {
                "value": {
                    "type": "list",
                    "name": "items",
                    "object": {
                        "state": "JDSFileUploaderItem.state",
                        "message": "string"
                    }
                }
            },
            "jds_file_uploader_item": {
                "state": {
                    "type": "number",
                    "name": "items.state"
                },
                "message": {
                    "type": "string",
                    "name": "items.message"
                }
            }
        },
        "events": {
            "jds_file_uploader_item": {
                "onClick": "onClick"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "list"
                    }
                },
                "name": "items",
                "repeating": {
                    "ariaLabel": "itemAriaLabel",
                    "ariaDescribedby": {
                        "name": "itemAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_file_uploader_item": {
                "properties": {
                    "ariaLabel": "items.itemAriaLabel",
                    "ariaDescribedby": "items.itemAriaDescribedby"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1r = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$1t = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1o;
    const { showDivider: showDivider = true, onClick: onClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            showDivider: showDivider,
            onClick: onClick,
            ...rest
        },
        componentTag: componentTag
    }, "JDSFileUploaderList", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$3d00ed40fd09f854 = $fe5170bdd3625759$var$withLogic$1r($fe5170bdd3625759$var$Component$1t);
$fe5170bdd3625759$export$3d00ed40fd09f854.displayName = "FileUploaderList";
$fe5170bdd3625759$export$3d00ed40fd09f854.slotName = "jds_file_uploader_list";
const $fe5170bdd3625759$var$sdl$1n = {
    "metadata": {
        "version": "1.0.0",
        "id": "file-uploader-panel-1.0.0",
        "name": "JDSFileUploaderPanel",
        "layerName": "jds_file_uploader_panel",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "jds_file_uploader_item",
            {
                "inner-container": [
                    "jds_progress_bar"
                ]
            },
            "jds_file_uploader_list"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{f_0}",
            "justify-content": "{f_1}",
            "align-items": "{f_2}",
            "width": "{f_3}",
            "opacity": "{f_4}",
            "background-color": "{f_5}",
            "border-radius": "{f_6}",
            "padding-top": "{f_7}",
            "padding-bottom": "{f_8}"
        },
        "inner-container": {
            "hidden": true,
            "padding-top": "{f_9}",
            "padding-bottom": "{f_10}",
            "padding-left": "{f_11}",
            "padding-right": "{f_12}",
            "width": "{f_13}"
        },
        "jds_file_uploader_item": {
            "hidden": true
        },
        "jds_progress_bar": {
            "kind": "determinate",
            "flex": 1
        }
    },
    "variant": {
        "kind": {
            "collapsible": {
                "jds_file_uploader_item": {
                    "hidden": false
                },
                "inner-container": {
                    "hidden": false
                }
            }
        }
    },
    "combination": [
        {
            "collapsible": {
                "false": {
                    "jds_file_uploader_item": {
                        "kind": "collapsed"
                    },
                    "jds_file_uploader_list": {
                        "hidden": true
                    }
                },
                "true": {
                    "jds_file_uploader_item": {
                        "kind": "expanded"
                    },
                    "jds_file_uploader_list": {
                        "hidden": false
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "kind",
            "expanded"
        ]
    ],
    "api": {
        "config": {
            "kind": {
                "values": [
                    "classic",
                    "collapsible"
                ]
            },
            "expanded": {
                "values": [
                    false,
                    true
                ]
            },
            "showDivider": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "jds_file_uploader_item": {
                "message": {
                    "type": "string",
                    "name": "message"
                }
            },
            "jds_progress_bar": {
                "value": {
                    "type": "float",
                    "name": "value"
                }
            },
            "jds_file_uploader_list": {
                "showDivider": {
                    "type": "boolean",
                    "name": "showDivider"
                },
                "items": {
                    "type": "list",
                    "name": "items",
                    "object": {
                        "state": "JDSFileUploaderItem.state",
                        "message": "string"
                    }
                }
            }
        },
        "events": {
            "jds_file_uploader_item": {
                "onClick": "onClick"
            },
            "jds_file_uploader_list": {
                "onClick": "onClose"
            }
        },
        "a11y": {
            "jds_file_uploader_list": {
                "name": "items",
                "repeating": {
                    "itemAriaLabel": "itemAriaLabel",
                    "itemAriaDescribedby": {
                        "name": "itemAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_file_uploader_item": {
                "properties": {
                    "ariaLabel": "panelAriaLabel",
                    "ariaDescribedby": {
                        "name": "panelAriaDescribedBy",
                        "platform": "web,ios"
                    },
                    "suffixAriaLabel": {
                        "name": "panelSuffixAriaLabel",
                        "value": "Toggle Files List"
                    },
                    "ariaExpanded": {
                        "name": "_ariaExpanded",
                        "prop": "expanded"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1q = (Component)=>(props)=>{
        const { toggle: toggle, selected: selected } = $fe5170bdd3625759$var$useToggle(props.expanded, true);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                expanded: selected,
                onClick: (ev)=>{
                    if (selected) props.onClose?.();
                    else props.onClick?.(ev);
                    toggle();
                },
                onClose: (index)=>{
                    props.onClose?.(index);
                }
            }
        });
    };
const $fe5170bdd3625759$var$Component$1s = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1n;
    const { kind: kind = "classic", expanded: expanded = false, showDivider: showDivider = true, onClick: onClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onClose: onClose = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), panelSuffixAriaLabel: panelSuffixAriaLabel = "Toggle Files List", _ariaExpanded: _ariaExpanded = props.expanded?.toString(), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            expanded: expanded,
            showDivider: showDivider,
            onClick: onClick,
            onClose: onClose,
            panelSuffixAriaLabel: panelSuffixAriaLabel,
            _ariaExpanded: _ariaExpanded,
            ...rest
        },
        componentTag: componentTag
    }, "JDSFileUploaderPanel", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$4089cd2315da078 = $fe5170bdd3625759$var$withLogic$1q($fe5170bdd3625759$var$Component$1s);
$fe5170bdd3625759$export$4089cd2315da078.displayName = "FileUploaderPanel";
$fe5170bdd3625759$export$4089cd2315da078.slotName = "jds_file_uploader_panel";
const $fe5170bdd3625759$var$sdl$1m = {
    "metadata": {
        "version": "1.0.0",
        "id": "footer-icon-link-1.0.0",
        "name": "JDSFooterIconLinks",
        "layerName": "jds_footer_icon_links",
        "platform": "web"
    },
    "hierarchy": {
        "container": [
            "title-jds-text",
            {
                "icons-container": [
                    "jds_button"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "gap": "{f_0}",
            "flex-direction": "{f_1}",
            "align-items": "{f_2}"
        },
        "jds_button": {
            "size": "small"
        },
        "icons-container": {
            "flex-direction": "{f_3}",
            "gap": "{f_4}"
        },
        "title-jds-text": {
            "font-family": "{headingXxs}",
            "color": "{primaryGrey100}",
            "font-size": "{headingXxs}",
            "line-height": "{headingXxs}",
            "letter-spacing": "{headingXxs}",
            "font-weight": "{headingXxs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "language": "en"
        }
    },
    "api": {
        "data": {
            "icons-container": {
                "value": {
                    "name": "links",
                    "type": "list",
                    "object": {
                        "icon": "string",
                        "href": "string"
                    }
                }
            },
            "jds_button": {
                "icon": {
                    "name": "links.icon",
                    "type": "string"
                }
            },
            "title-jds-text": {
                "value": {
                    "type": "string",
                    "name": "title"
                }
            }
        },
        "a11y": {
            "icons-container": {
                "name": "links",
                "repeating": {
                    "ariaLabel": "iconAriaLabel",
                    "ariaDescribedby": {
                        "name": "iconAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_button": {
                "properties": {
                    "ariaLabel": "links.iconAriaLabel",
                    "ariaDescribedby": "links.iconAriaDescribedby"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1p = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$1r = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1m;
    const { custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...rest,
        componentTag: componentTag
    }, "JDSFooterIconLinks", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$ce48424ab2a5a45 = $fe5170bdd3625759$var$withLogic$1p($fe5170bdd3625759$var$Component$1r);
$fe5170bdd3625759$export$ce48424ab2a5a45.displayName = "FooterIconLinks";
$fe5170bdd3625759$export$ce48424ab2a5a45.slotName = "jds_footer_icon_links";
const $fe5170bdd3625759$var$sdl$1l = {
    "metadata": {
        "version": "1.0.0",
        "id": "footer-links-1.0.0",
        "name": "JDSFooterLinks",
        "layerName": "jds_footer_links",
        "platform": "web"
    },
    "hierarchy": {
        "container": [
            "title-jds-text",
            {
                "links-container": [
                    {
                        "link-item-container": [
                            "jds_link"
                        ]
                    }
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{f_0}",
            "align-items": "{f_1}",
            "size": "{f_2}"
        },
        "link-item-container": {
            "size": "{f_3}",
            "padding-top": "{f_4}",
            "padding-bottom": "{f_5}",
            "flex-direction": "{f_6}",
            "justify-content": "{f_7}",
            "align-items": "{f_8}",
            "background-color": "{f_9}",
            "behavior": {
                "hover": {
                    "background-color": "{f_10}"
                }
            }
        },
        "links-container": {
            "padding-top": "{f_13}",
            "size": "{f_14}",
            "flex-direction": "{f_15}"
        },
        "jds_link": {
            "kind": "submenu",
            "textAppearance": "body_s"
        },
        "title-jds-text": {
            "font-family": "{headingXxs}",
            "color": "{primaryGrey100}",
            "font-size": "{headingXxs}",
            "line-height": "{headingXxs}",
            "letter-spacing": "{headingXxs}",
            "font-weight": "{headingXxs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "padding-top": "{f_11}",
            "padding-bottom": "{f_12}"
        }
    },
    "api": {
        "config": {},
        "data": {
            "links-container": {
                "value": {
                    "name": "links",
                    "type": "list",
                    "object": {
                        "newTab": "boolean",
                        "href": "string",
                        "title": "string",
                        "routerLinkProps": "object",
                        "onClick": "event"
                    }
                }
            },
            "jds_link": {
                "title": {
                    "type": "string",
                    "name": "links.title"
                },
                "href": {
                    "type": "string",
                    "name": "links.href"
                },
                "newTab": {
                    "type": "string",
                    "name": "links.newTab",
                    "platform": "web"
                },
                "routerLinkProps": {
                    "type": "RouterLinkProps",
                    "name": "links.routerLinkProps",
                    "platform": "angular"
                },
                "provider": {
                    "type": "object",
                    "name": "links.provider",
                    "platform": "react"
                },
                "onClick": {
                    "type": "string",
                    "name": "links.onClick"
                }
            },
            "title-jds-text": {
                "value": {
                    "type": "string",
                    "name": "title"
                }
            }
        },
        "a11y": {
            "links-container": {
                "name": "links",
                "repeating": {
                    "ariaLabel": "linkAriaLabel",
                    "ariaDescribedby": {
                        "name": "linkAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_link": {
                "properties": {
                    "ariaLabel": "links.linkAriaLabel",
                    "ariaDescribedby": "links.linkAriaDescribedby"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1o = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$1q = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1l;
    const { custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...rest,
        componentTag: componentTag
    }, "JDSFooterLinks", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$553910ef0cc96026 = $fe5170bdd3625759$var$withLogic$1o($fe5170bdd3625759$var$Component$1q);
$fe5170bdd3625759$export$553910ef0cc96026.displayName = "FooterLinks";
$fe5170bdd3625759$export$553910ef0cc96026.slotName = "jds_footer_links";
const $fe5170bdd3625759$var$sdl$1k = {
    "metadata": {
        "version": "1.0.0",
        "id": "footer-links-grid-1.0.0",
        "name": "JDSFooterLinksGrid",
        "layerName": "jds_footer_links_grid",
        "platform": "web"
    },
    "hierarchy": {
        "container": [
            "jds_footer_links"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{f_0}",
            "size": "{f_1}",
            "gap": "{f_2}",
            "flex": 1
        }
    },
    "api": {
        "config": {},
        "data": {
            "container": {
                "value": {
                    "type": "list",
                    "name": "links",
                    "object": {
                        "title": "string",
                        "provider": "object",
                        "subLinks": "list"
                    }
                }
            },
            "jds_footer_links": {
                "links": {
                    "type": "list",
                    "name": "links.subLinks"
                },
                "title": {
                    "type": "string",
                    "name": "links.title"
                },
                "provider": {
                    "type": "object",
                    "name": "links.provider"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1n = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$1p = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1k;
    const { custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...rest,
        componentTag: componentTag
    }, "JDSFooterLinksGrid", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$e5275d44ac937bc0 = $fe5170bdd3625759$var$withLogic$1n($fe5170bdd3625759$var$Component$1p);
$fe5170bdd3625759$export$e5275d44ac937bc0.displayName = "FooterLinksGrid";
$fe5170bdd3625759$export$e5275d44ac937bc0.slotName = "jds_footer_links_grid";
const $fe5170bdd3625759$var$sdl$1j = {
    "metadata": {
        "version": "1.0.0",
        "id": "footer-market-links-1.0.0",
        "name": "JDSFooterMarketLinks",
        "layerName": "jds_footer_market_links",
        "platform": "web"
    },
    "hierarchy": {
        "container": [
            "title-jds-text",
            {
                "assets-container": [
                    "image"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "gap": "{f_0}",
            "flex-direction": "{f_1}",
            "align-items": "{f_2}"
        },
        "assets-container": {
            "flex-direction": "{f_3}",
            "align-items": "{f_4}",
            "gap": "{f_5}"
        },
        "image": {
            "height": 40,
            "object-fit": "contain"
        },
        "title-jds-text": {
            "font-family": "{headingXxs}",
            "color": "{primaryGrey100}",
            "font-size": "{headingXxs}",
            "line-height": "{headingXxs}",
            "letter-spacing": "{headingXxs}",
            "font-weight": "{headingXxs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "api": {
        "data": {
            "assets-container": {
                "value": {
                    "name": "assets",
                    "type": "list",
                    "object": {
                        "image": "image"
                    }
                }
            },
            "image": {
                "value": {
                    "type": "image",
                    "name": "assets.image"
                }
            },
            "title-jds-text": {
                "value": {
                    "type": "string",
                    "name": "title"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1m = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$1o = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1j;
    const { custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...rest,
        componentTag: componentTag
    }, "JDSFooterMarketLinks", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$4e70d4e1c9ec4c90 = $fe5170bdd3625759$var$withLogic$1m($fe5170bdd3625759$var$Component$1o);
$fe5170bdd3625759$export$4e70d4e1c9ec4c90.displayName = "FooterMarketLinks";
$fe5170bdd3625759$export$4e70d4e1c9ec4c90.slotName = "jds_footer_market_links";
const $fe5170bdd3625759$var$sdl$1i = {
    "metadata": {
        "version": "1.0.0",
        "id": "header-desktop-1.0.0",
        "name": "JDSHeaderDesktop",
        "layerName": "jds_header_desktop",
        "platform": "web"
    },
    "hierarchy": {
        "container": [
            {
                "header-container": [
                    {
                        "left-container": [
                            {
                                "prefix-container": [
                                    "prefix-jds_button",
                                    {
                                        "logo-container": [
                                            "logo-slot",
                                            "logo-jds-text"
                                        ]
                                    },
                                    "prefix-slot",
                                    "name-jds-text"
                                ]
                            },
                            {
                                "links-container": [
                                    "link-jds_link"
                                ]
                            }
                        ]
                    },
                    "jds_search_box",
                    {
                        "right-container": [
                            {
                                "suffix-container": [
                                    "search-jds_action_button",
                                    {
                                        "icon-links-container": [
                                            "icon-links-slot"
                                        ]
                                    },
                                    "avatar-slot"
                                ]
                            },
                            "suffix-jds_action_button",
                            "suffix-slot"
                        ]
                    }
                ]
            },
            "jds_mega_menu",
            "jds_search_results",
            "tabs-slot"
        ]
    },
    "base": {
        "container": {
            "min-width": "{h_0}",
            "flex-direction": "{h_1}"
        },
        "prefix-container": {
            "flex-direction": "{h_2}",
            "justify-content": "{h_3}",
            "align-items": "{h_4}",
            "gap": "{h_5}"
        },
        "header-container": {
            "min-width": "{h_6}",
            "background-color": "{h_7}",
            "flex-direction": "{h_8}",
            "justify-content": "{h_9}",
            "align-items": "{h_10}",
            "padding-left": "{h_11}",
            "padding-top": "{h_12}",
            "padding-right": "{h_13}",
            "padding-bottom": "{h_14}",
            "gap": "{h_15}",
            "height": "{h_16}"
        },
        "left-container": {
            "flex-direction": "{h_17}",
            "justify-content": "{h_18}",
            "align-items": "{h_19}",
            "gap": "{h_20}"
        },
        "logo-container": {
            "flex-direction": "{h_21}",
            "justify-content": "{h_22}",
            "align-items": "{h_23}",
            "gap": "{h_24}"
        },
        "profile-container": {
            "hidden": true,
            "flex-direction": "{h_25}",
            "justify-content": "{h_26}",
            "align-items": "{h_27}",
            "gap": "{h_28}"
        },
        "links-container": {
            "flex-direction": "{h_29}",
            "justify-content": "{h_30}",
            "align-items": "{h_31}",
            "gap": "{h_32}",
            "padding-left": "{h_33}",
            "flex": 1,
            "hidden": false
        },
        "right-container": {
            "flex-direction": "{h_34}",
            "justify-content": "{h_35}",
            "align-items": "{h_36}",
            "gap": "{h_37}"
        },
        "suffix-container": {
            "flex-direction": "{h_38}",
            "justify-content": "{h_39}",
            "align-items": "{h_40}",
            "gap": "{h_41}",
            "width": "{h_42}"
        },
        "icon-links-container": {
            "flex-direction": "{h_43}",
            "justify-content": "{h_44}",
            "align-items": "{h_45}",
            "gap": "{h_46}",
            "hidden": false
        },
        "prefix-jds_button": {
            "size": "medium",
            "fullWidth": false
        },
        "search-jds_action_button": {
            "hidden": true,
            "icon": "ic_search",
            "size": "medium"
        },
        "icon-links-jds_link": {
            "size": "medium"
        },
        "suffix-jds_action_button": {
            "hidden": true,
            "icon": "ic_close",
            "size": "medium"
        },
        "jds_search_box": {
            "prefix": "ic_search",
            "kind": "header",
            "max-width": "312",
            "width": "{h_47}"
        },
        "link-jds_link": {
            "kind": "header"
        },
        "jds_search_results": {
            "open": false,
            "hidden": false,
            "_maxWidth": 784
        },
        "logo-jds-text": {
            "font-family": "{headingXxs}",
            "color": "{primaryInverse}",
            "font-size": "{headingXxs}",
            "line-height": "{headingXxs}",
            "letter-spacing": "{headingXxs}",
            "font-weight": "{headingXxs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        },
        "name-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryInverse}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        },
        "link-jds-text": {
            "font-family": "{bodySBold}",
            "color": "{primaryInverse}",
            "font-size": "{bodySBold}",
            "line-height": "{bodySBold}",
            "letter-spacing": "{bodySBold}",
            "font-weight": "{bodySBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "_platform": {
            "mobile": {
                "links-container": {
                    "hidden": true
                },
                "profile-container": {
                    "hidden": false
                },
                "suffix-jds_action_button": {
                    "hidden": true
                },
                "jds_mega_menu": {
                    "hidden": true
                },
                "header-container": {
                    "padding-left": "{h_49}",
                    "padding-right": "{h_50}",
                    "gap": "{h_51}",
                    "height": "{h_48}"
                },
                "left-container": {
                    "gap": "{h_52}"
                },
                "right-container": {
                    "gap": "{h_53}"
                },
                "suffix-container": {
                    "gap": "{h_54}"
                }
            }
        },
        "_variant": {
            "active_search": {
                "header-container": {
                    "justify-content": "{h_56}"
                },
                "profile-container": {
                    "hidden": true
                },
                "links-container": {
                    "hidden": true
                },
                "avatar-slot": {
                    "hidden": true
                },
                "prefix-slot": {
                    "hidden": true
                },
                "suffix-jds_action_button": {
                    "hidden": false
                },
                "icon-links-container": {
                    "hidden": true
                },
                "jds_search_box": {
                    "max-width": "784",
                    "width": "{h_57}"
                },
                "suffix-slot": {
                    "hidden": true
                },
                "jds_search_results": {
                    "open": true
                },
                "prefix-jds_button": {
                    "hidden": true
                },
                "name-jds-text": {
                    "hidden": true
                },
                "logo-jds-text": {
                    "hidden": true
                }
            }
        },
        "search": {
            "false": {
                "jds_search_box": {
                    "hidden": true
                },
                "search-jds_action_button": {
                    "hidden": true
                }
            }
        },
        "fullWidth": {
            "false": {
                "container": {
                    "width": "{h_58}"
                }
            }
        },
        "_IsLinksEmpty": {
            "true": {
                "icon-links-container": {
                    "hidden": true
                }
            }
        },
        "_hasSearchResults": {
            "false": {
                "jds_search_results": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {
            "true": {
                "false": {
                    "jds_search_box": {
                        "hidden": true
                    },
                    "search-jds_action_button": {
                        "hidden": false
                    }
                }
            }
        },
        {
            "mobile": {
                "active_search": {
                    "suffix-jds_action_button": {
                        "hidden": false
                    }
                }
            },
            "desktop": {
                "default": {
                    "left-container": {
                        "width": "{h_55}"
                    }
                }
            }
        },
        {
            "mobile": {
                "false": {
                    "header-container": {
                        "justify-content": "{h_59}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "search",
            "expandedSearch"
        ],
        [
            "_platform",
            "_variant"
        ],
        [
            "_platform",
            "search"
        ]
    ],
    "api": {
        "config": {
            "_variant": {
                "values": [
                    "default",
                    "active_search"
                ]
            },
            "_platform": {
                "values": [
                    "desktop",
                    "mobile"
                ]
            },
            "search": {
                "values": [
                    true,
                    false
                ]
            },
            "expandedSearch": {
                "values": [
                    true,
                    false
                ]
            },
            "searchActive": {
                "values": [
                    false,
                    true
                ]
            },
            "fullWidth": {
                "values": [
                    true,
                    false
                ]
            },
            "_IsLinksEmpty": {
                "values": [
                    false,
                    true
                ]
            },
            "_hasSearchResults": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "prefix-jds_button": {
                "icon": {
                    "name": "prefix",
                    "type": "icon"
                }
            },
            "links-container": {
                "value": {
                    "type": "list",
                    "name": "links",
                    "object": {
                        "newTab": "boolean",
                        "href": "string",
                        "title": "string",
                        "routerLinkProps": "object",
                        "onClick": "event",
                        "subLinks": "list",
                        "active": "boolean"
                    }
                }
            },
            "link-jds_link": {
                "title": {
                    "type": "string",
                    "name": "links.title"
                },
                "href": {
                    "type": "string",
                    "name": "links.href"
                },
                "newTab": {
                    "type": "string",
                    "name": "links.newTab",
                    "platform": "web"
                },
                "routerLinkProps": {
                    "type": "string",
                    "name": "links.routerLinkProps",
                    "platform": "angular"
                },
                "onClick": {
                    "type": "string",
                    "name": "links.onClick"
                },
                "_active": {
                    "type": "string",
                    "name": "links.active"
                }
            },
            "jds_search_box": {
                "label": {
                    "type": "string",
                    "name": "searchLabel"
                },
                "suffix": {
                    "type": "icon",
                    "name": "searchSuffix"
                },
                "value": {
                    "type": "string",
                    "name": "query"
                },
                "showBack": {
                    "type": "boolean",
                    "name": "searchShowBack"
                }
            },
            "header-container": {
                "elementRef": {
                    "type": "ref",
                    "name": "elementRef"
                }
            },
            "container": {
                "value": {
                    "type": "object",
                    "name": "megaMenuProps",
                    "object": {
                        "subLinks": "list",
                        "offsetX": "size",
                        "offsetY": "size",
                        "width": "size",
                        "open": "boolean"
                    }
                }
            },
            "jds_search_results": {
                "offsetX": {
                    "type": "size",
                    "name": "megaMenuProps.offsetX"
                },
                "offsetY": {
                    "type": "size",
                    "name": "megaMenuProps.offsetY"
                },
                "_maxWidth": {
                    "type": "size",
                    "name": "megaMenuProps.width"
                },
                "results": {
                    "type": "list",
                    "name": "searchResults"
                },
                "header": {
                    "type": "string",
                    "name": "searchResultHeader"
                },
                "query": {
                    "type": "string",
                    "name": "query"
                },
                "headerAction": {
                    "type": "string",
                    "name": "searchResultHeaderAction"
                }
            },
            "jds_mega_menu": {
                "items": {
                    "type": "object",
                    "name": "megaMenuProps.subLinks"
                },
                "offsetX": {
                    "type": "size",
                    "name": "megaMenuProps.offsetX"
                },
                "offsetY": {
                    "type": "size",
                    "name": "megaMenuProps.offsetY"
                },
                "width": {
                    "type": "size",
                    "name": "megaMenuProps.width"
                },
                "open": {
                    "type": "boolean",
                    "name": "megaMenuProps.open"
                }
            },
            "search-jds_action_button": {
                "label": {
                    "type": "string",
                    "name": "dynamicButtonText"
                }
            },
            "logo-jds-text": {
                "value": {
                    "type": "string",
                    "name": "brandLabel"
                }
            },
            "name-jds-text": {
                "value": {
                    "type": "string",
                    "name": "pageTitle"
                }
            }
        },
        "children": {
            "avatar-slot": {
                "name": "avatar",
                "accepts": [
                    "jds_avatar",
                    "jds_link"
                ],
                "max": 1
            },
            "prefix-slot": {
                "name": "pageTitlePrefix",
                "accepts": [
                    "jds_avatar",
                    "jds_icon",
                    "jds_image"
                ],
                "max": 1
            },
            "tabs-slot": {
                "name": "tabs",
                "accepts": [
                    "jds_tabs_desktop"
                ],
                "max": 1
            },
            "suffix-slot": {
                "name": "suffix",
                "accepts": [
                    "jds_text",
                    "jds_button",
                    "jds_link"
                ],
                "max": 1
            },
            "logo-slot": {
                "name": "logo",
                "accepts": [
                    "jds_icon",
                    "jds_image",
                    "jds_link"
                ],
                "max": 1
            },
            "icon-links-slot": {
                "name": "iconLinks",
                "accepts": [
                    "jds_link"
                ]
            }
        },
        "events": {
            "container": {
                "_searchActive.onSearchActiveChange": "onSearchActiveChange"
            },
            "logo-container": {
                "onClick": "logoOnClick"
            },
            "avatar-slot": {
                "onClick": "avatarOnClick"
            },
            "prefix-jds_button": {
                "onClick": "prefixOnClick"
            },
            "suffix-jds_action_button": {
                "onClick": "suffixOnClick"
            },
            "link-jds_link": {
                "onHover": "onHover"
            },
            "jds_mega_menu": {
                "onHoverEnd": "onMenuHoverEnd"
            },
            "jds_search_box": {
                "onBlur": "onSearchBlur",
                "onFocus": "onSearchFocus",
                "onChange": "onSearchChange",
                "onSuffixClick": "onSearchBoxSuffixClick",
                "onKeydown": "onSearchKeydown"
            },
            "search-jds_action_button": {
                "onClick": "onSearchIconClick"
            },
            "jds_search_results": {
                "onHeaderActionClick": "onSearchResultHeaderActionClick",
                "onClick": "onSearchResultClick"
            }
        },
        "a11y": {
            "container": {
                "name": "megaMenuProps",
                "repeating": {
                    "ariaLabel": "menuItemAriaLabel",
                    "ariaDescribedby": {
                        "name": "menuItemAriaDescribedby",
                        "platform": "web,ios"
                    }
                },
                "properties": {
                    "role": {
                        "name": "role"
                    }
                }
            },
            "links-container": {
                "name": "links",
                "repeating": {
                    "ariaLabel": "linkAriaLabel",
                    "ariaDescribedby": {
                        "name": "linkAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "link-jds_link": {
                "properties": {
                    "ariaLabel": "links.linkAriaLabel",
                    "ariaDescribedby": "links.linkAriaDescribedby"
                }
            },
            "prefix-jds_button": {
                "properties": {
                    "ariaLabel": "prefixAriaLabel",
                    "ariaDescribedby": {
                        "name": "prefixAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "suffix-jds_action_button": {
                "properties": {
                    "ariaLabel": "suffixAriaLabel",
                    "ariaDescribedby": {
                        "name": "suffixAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_search_box": {
                "properties": {
                    "prefixAriaLabel": "searchBoxPrefixAriaLabel",
                    "suffixAriaLabel": "searchBoxSuffixAriaLabel",
                    "ariaLabel": "searchAriaLabel"
                }
            },
            "search-jds_action_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "searchButtonAriaLabel",
                        "prop": "dynamicButtonText"
                    },
                    "ariaDescribedby": {
                        "name": "searchButtonAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$Jdstext = {
    "metadata": {
        "version": "1.0.0",
        "id": "text-1.0.0",
        "name": "JDSText",
        "layerName": "jds_text"
    },
    "hierarchy": {
        "text": []
    },
    "base": {
        "text": {
            "font-family": "{text_1}",
            "color": "{text_2}",
            "font-size": "{text_3}",
            "line-height": "{text_4}",
            "letter-spacing": "{text_5}",
            "font-weight": "{text_6}",
            "text-decoration": "{text_7}",
            "text-transform": "{text_8}"
        }
    },
    "variant": {
        "textAlign": {
            "center": {
                "text": {
                    "text-align": "center"
                }
            },
            "right": {
                "text": {
                    "text-align": "right"
                }
            }
        },
        "textDecoration": {
            "underline": {
                "text": {
                    "text-decoration": "{text_9}"
                }
            },
            "line-through": {
                "text": {
                    "text-decoration": "{text_10}"
                }
            },
            "overline": {
                "text": {
                    "text-decoration": "{text_11}"
                }
            }
        },
        "color": {
            "primary_80": {
                "text": {
                    "color": "{text_12}"
                }
            },
            "primary_70": {
                "text": {
                    "color": "{text_13}"
                }
            },
            "primary_60": {
                "text": {
                    "color": "{text_14}"
                }
            },
            "primary_50": {
                "text": {
                    "color": "{text_15}"
                }
            },
            "primary_40": {
                "text": {
                    "color": "{text_16}"
                }
            },
            "primary_30": {
                "text": {
                    "color": "{text_17}"
                }
            },
            "primary_20": {
                "text": {
                    "color": "{text_18}"
                }
            },
            "primary_inverse": {
                "text": {
                    "color": "{text_19}"
                }
            },
            "primary_background": {
                "text": {
                    "color": "{text_20}"
                }
            },
            "primary_grey_100": {
                "text": {
                    "color": "{text_21}"
                }
            },
            "primary_grey_80": {
                "text": {
                    "color": "{text_22}"
                }
            },
            "primary_grey_60": {
                "text": {
                    "color": "{text_23}"
                }
            },
            "primary_grey_40": {
                "text": {
                    "color": "{text_24}"
                }
            },
            "primary_grey_20": {
                "text": {
                    "color": "{text_25}"
                }
            },
            "secondary_80": {
                "text": {
                    "color": "{text_26}"
                }
            },
            "secondary_70": {
                "text": {
                    "color": "{text_27}"
                }
            },
            "secondary_60": {
                "text": {
                    "color": "{text_28}"
                }
            },
            "secondary_50": {
                "text": {
                    "color": "{text_29}"
                }
            },
            "secondary_40": {
                "text": {
                    "color": "{text_30}"
                }
            },
            "secondary_30": {
                "text": {
                    "color": "{text_31}"
                }
            },
            "secondary_20": {
                "text": {
                    "color": "{text_32}"
                }
            },
            "secondary_inverse": {
                "text": {
                    "color": "{text_33}"
                }
            },
            "secondary_background": {
                "text": {
                    "color": "{text_34}"
                }
            },
            "secondary_grey_100": {
                "text": {
                    "color": "{text_35}"
                }
            },
            "secondary_grey_80": {
                "text": {
                    "color": "{text_36}"
                }
            },
            "secondary_grey_60": {
                "text": {
                    "color": "{text_37}"
                }
            },
            "secondary_grey_40": {
                "text": {
                    "color": "{text_38}"
                }
            },
            "secondary_grey_20": {
                "text": {
                    "color": "{text_39}"
                }
            },
            "sparkle_80": {
                "text": {
                    "color": "{text_40}"
                }
            },
            "sparkle_70": {
                "text": {
                    "color": "{text_41}"
                }
            },
            "sparkle_60": {
                "text": {
                    "color": "{text_42}"
                }
            },
            "sparkle_50": {
                "text": {
                    "color": "{text_43}"
                }
            },
            "sparkle_40": {
                "text": {
                    "color": "{text_44}"
                }
            },
            "sparkle_30": {
                "text": {
                    "color": "{text_45}"
                }
            },
            "sparkle_20": {
                "text": {
                    "color": "{text_46}"
                }
            },
            "sparkle_inverse": {
                "text": {
                    "color": "{text_47}"
                }
            },
            "sparkle_background": {
                "text": {
                    "color": "{text_48}"
                }
            },
            "sparkle_grey_100": {
                "text": {
                    "color": "{text_49}"
                }
            },
            "sparkle_grey_80": {
                "text": {
                    "color": "{text_50}"
                }
            },
            "sparkle_grey_60": {
                "text": {
                    "color": "{text_51}"
                }
            },
            "sparkle_grey_40": {
                "text": {
                    "color": "{text_52}"
                }
            },
            "sparkle_grey_20": {
                "text": {
                    "color": "{text_53}"
                }
            },
            "feedback_error_80": {
                "text": {
                    "color": "{text_54}"
                }
            },
            "feedback_error_50": {
                "text": {
                    "color": "{text_55}"
                }
            },
            "feedback_error_20": {
                "text": {
                    "color": "{text_56}"
                }
            },
            "feedback_warning_80": {
                "text": {
                    "color": "{text_57}"
                }
            },
            "feedback_warning_50": {
                "text": {
                    "color": "{text_58}"
                }
            },
            "feedback_warning_20": {
                "text": {
                    "color": "{text_59}"
                }
            },
            "feedback_success_80": {
                "text": {
                    "color": "{text_60}"
                }
            },
            "feedback_success_50": {
                "text": {
                    "color": "{text_61}"
                }
            },
            "feedback_success_20": {
                "text": {
                    "color": "{text_62}"
                }
            },
            "white": {
                "text": {
                    "color": "{text_63}"
                }
            },
            "black": {
                "text": {
                    "color": "{text_64}"
                }
            },
            "transparent": {
                "text": {
                    "color": "{text_65}"
                }
            }
        },
        "appearance": {
            "heading_xl": {
                "text": {
                    "font-size": "{text_66}",
                    "line-height": "{text_68}",
                    "letter-spacing": "{text_69}",
                    "font-weight": "{text_70}",
                    "font-family": "{text_67}"
                }
            },
            "heading_l": {
                "text": {
                    "font-size": "{text_71}",
                    "line-height": "{text_73}",
                    "letter-spacing": "{text_74}",
                    "font-weight": "{text_75}",
                    "font-family": "{text_72}"
                }
            },
            "heading_m": {
                "text": {
                    "font-size": "{text_76}",
                    "line-height": "{text_78}",
                    "letter-spacing": "{text_79}",
                    "font-weight": "{text_80}",
                    "font-family": "{text_77}"
                }
            },
            "heading_s": {
                "text": {
                    "font-size": "{text_81}",
                    "font-family": "{text_82}",
                    "line-height": "{text_83}",
                    "letter-spacing": "{text_84}",
                    "font-weight": "{text_85}"
                }
            },
            "heading_xs": {
                "text": {
                    "font-size": "{text_86}",
                    "font-family": "{text_87}",
                    "line-height": "{text_88}",
                    "letter-spacing": "{text_89}",
                    "font-weight": "{text_90}"
                }
            },
            "heading_xxs": {
                "text": {
                    "font-size": "{text_91}",
                    "line-height": "{text_93}",
                    "letter-spacing": "{text_94}",
                    "font-weight": "{text_95}",
                    "font-family": "{text_92}"
                }
            },
            "overline": {
                "text": {
                    "font-size": "{text_96}",
                    "font-family": "{text_97}",
                    "line-height": "{text_98}",
                    "letter-spacing": "{text_99}",
                    "font-weight": "{text_100}",
                    "text-transform": "{text_101}"
                }
            },
            "body_l": {
                "text": {
                    "font-size": "{text_102}",
                    "font-family": "{text_103}",
                    "line-height": "{text_104}",
                    "letter-spacing": "{text_105}",
                    "font-weight": "{text_106}"
                }
            },
            "body_l_bold": {
                "text": {
                    "font-size": "{text_107}",
                    "font-family": "{text_108}",
                    "line-height": "{text_109}",
                    "letter-spacing": "{text_110}",
                    "font-weight": "{text_111}"
                }
            },
            "body_l_link": {
                "text": {
                    "font-size": "{text_112}",
                    "font-family": "{text_113}",
                    "line-height": "{text_114}",
                    "letter-spacing": "{text_115}",
                    "font-weight": "{text_116}",
                    "color": "{text_0}"
                }
            },
            "body_m": {
                "text": {
                    "font-size": "{text_117}",
                    "font-family": "{text_118}",
                    "line-height": "{text_119}",
                    "letter-spacing": "{text_120}",
                    "font-weight": "{text_121}"
                }
            },
            "body_m_bold": {
                "text": {
                    "font-size": "{text_122}",
                    "font-family": "{text_123}",
                    "line-height": "{text_124}",
                    "letter-spacing": "{text_125}",
                    "font-weight": "{text_126}"
                }
            },
            "body_m_link": {
                "text": {
                    "font-size": "{text_127}",
                    "font-family": "{text_128}",
                    "line-height": "{text_129}",
                    "letter-spacing": "{text_130}",
                    "font-weight": "{text_131}",
                    "color": "{text_0}"
                }
            },
            "body_s": {
                "text": {
                    "font-size": "{text_132}",
                    "font-family": "{text_133}",
                    "line-height": "{text_134}",
                    "letter-spacing": "{text_135}",
                    "font-weight": "{text_136}"
                }
            },
            "body_s_bold": {
                "text": {
                    "font-size": "{text_137}",
                    "font-family": "{text_138}",
                    "line-height": "{text_139}",
                    "letter-spacing": "{text_140}",
                    "font-weight": "{text_141}"
                }
            },
            "body_s_link": {
                "text": {
                    "font-size": "{text_142}",
                    "font-family": "{text_143}",
                    "line-height": "{text_144}",
                    "letter-spacing": "{text_145}",
                    "font-weight": "{text_146}",
                    "color": "{text_0}"
                }
            },
            "body_xs": {
                "text": {
                    "font-size": "{text_147}",
                    "font-family": "{text_148}",
                    "line-height": "{text_149}",
                    "letter-spacing": "{text_150}",
                    "font-weight": "{text_151}"
                }
            },
            "body_xs_bold": {
                "text": {
                    "font-size": "{text_152}",
                    "font-family": "{text_153}",
                    "line-height": "{text_154}",
                    "letter-spacing": "{text_155}",
                    "font-weight": "{text_156}"
                }
            },
            "body_xs_link": {
                "text": {
                    "font-size": "{text_157}",
                    "font-family": "{text_158}",
                    "line-height": "{text_159}",
                    "letter-spacing": "{text_160}",
                    "font-weight": "{text_161}",
                    "color": "{text_0}"
                }
            },
            "body_xxs": {
                "text": {
                    "font-size": "{text_167}",
                    "font-family": "{text_168}",
                    "line-height": "{text_169}",
                    "letter-spacing": "{text_170}",
                    "font-weight": "{text_171}"
                }
            },
            "body_xxs_bold": {
                "text": {
                    "font-size": "{text_172}",
                    "font-family": "{text_173}",
                    "line-height": "{text_174}",
                    "letter-spacing": "{text_175}",
                    "font-weight": "{text_176}"
                }
            },
            "body_xxs_link": {
                "text": {
                    "font-size": "{text_177}",
                    "font-family": "{text_178}",
                    "line-height": "{text_179}",
                    "letter-spacing": "{text_180}",
                    "font-weight": "{text_181}",
                    "color": "{text_0}"
                }
            },
            "body_3xs": {
                "text": {
                    "font-size": "{text_182}",
                    "font-family": "{text_183}",
                    "line-height": "{text_184}",
                    "letter-spacing": "{text_185}",
                    "font-weight": "{text_186}"
                }
            },
            "body_3xs_bold": {
                "text": {
                    "font-size": "{text_187}",
                    "font-family": "{text_188}",
                    "line-height": "{text_189}",
                    "letter-spacing": "{text_190}",
                    "font-weight": "{text_191}"
                }
            },
            "body_3xs_link": {
                "text": {
                    "font-size": "{text_192}",
                    "font-family": "{text_193}",
                    "line-height": "{text_194}",
                    "letter-spacing": "{text_195}",
                    "font-weight": "{text_196}",
                    "color": "{text_0}"
                }
            },
            "list_title": {
                "text": {
                    "font-size": "{text_197}",
                    "font-family": "{text_198}",
                    "line-height": "{text_199}",
                    "letter-spacing": "{text_200}",
                    "font-weight": "{text_201}"
                }
            },
            "button": {
                "text": {
                    "font-size": "{text_202}",
                    "font-family": "{text_203}",
                    "line-height": "{text_204}",
                    "letter-spacing": "{text_205}",
                    "font-weight": "{text_206}"
                }
            },
            "code": {
                "text": {
                    "font-size": "{text_207}",
                    "font-family": "{text_208}",
                    "line-height": "{text_209}",
                    "letter-spacing": "{text_210}",
                    "font-weight": "{text_211}"
                }
            },
            "body_xs_caps": {
                "text": {
                    "font-size": "{text_variant_appearance_body_xs_caps_text_font-size}",
                    "line-height": "{text_163}",
                    "letter-spacing": "{text_165}",
                    "font-weight": "{text_166}",
                    "text-transform": "{text_164}",
                    "font-family": "{text_162}"
                }
            },
            "body_s_regular_para": {
                "text": {
                    "font-size": "{text_212}",
                    "line-height": "{text_213}",
                    "letter-spacing": "{text_214}",
                    "font-weight": "{text_215}",
                    "font-family": "{text_216}"
                }
            }
        }
    },
    "api": {
        "config": {
            "color": {
                "values": [
                    "primary_grey_100",
                    "primary_80",
                    "primary_70",
                    "primary_60",
                    "primary_50",
                    "primary_40",
                    "primary_30",
                    "primary_20",
                    "primary_inverse",
                    "primary_background",
                    "primary_grey_80",
                    "primary_grey_60",
                    "primary_grey_40",
                    "primary_grey_20",
                    "secondary_80",
                    "secondary_70",
                    "secondary_60",
                    "secondary_50",
                    "secondary_40",
                    "secondary_30",
                    "secondary_20",
                    "secondary_inverse",
                    "secondary_background",
                    "secondary_grey_100",
                    "secondary_grey_80",
                    "secondary_grey_60",
                    "secondary_grey_40",
                    "secondary_grey_20",
                    "sparkle_80",
                    "sparkle_70",
                    "sparkle_60",
                    "sparkle_50",
                    "sparkle_40",
                    "sparkle_30",
                    "sparkle_20",
                    "sparkle_inverse",
                    "sparkle_background",
                    "sparkle_grey_100",
                    "sparkle_grey_80",
                    "sparkle_grey_60",
                    "sparkle_grey_40",
                    "sparkle_grey_20",
                    "feedback_error_80",
                    "feedback_error_50",
                    "feedback_error_20",
                    "feedback_warning_80",
                    "feedback_warning_50",
                    "feedback_warning_20",
                    "feedback_success_80",
                    "feedback_success_50",
                    "feedback_success_20",
                    "white",
                    "black",
                    "transparent"
                ],
                "doc_description": "It can be used to add font-color to text.",
                "function": true
            },
            "textAlign": {
                "values": [
                    "left",
                    "right",
                    "center"
                ],
                "doc_description": "It aligns text to left, center, right."
            },
            "textDecoration": {
                "values": [
                    "none",
                    "underline",
                    "line-through",
                    "overline"
                ],
                "doc_description": "It can be used to decorate text eg. 'underline', 'line-through', 'overline'."
            },
            "appearance": {
                "values": [
                    "body_s",
                    "heading_xl",
                    "heading_l",
                    "heading_m",
                    "heading_s",
                    "heading_xs",
                    "heading_xxs",
                    "overline",
                    "body_l",
                    "body_l_bold",
                    "body_l_link",
                    "body_m",
                    "body_m_bold",
                    "body_m_link",
                    "body_s_bold",
                    "body_s_link",
                    "body_xs",
                    "body_xs_bold",
                    "body_xs_link",
                    "body_xxs",
                    "body_xxs_bold",
                    "body_xxs_link",
                    "body_3xs",
                    "body_3xs_bold",
                    "body_3xs_link",
                    "list_title",
                    "button",
                    "code",
                    "body_xs_caps",
                    "body_s_regular_para"
                ],
                "doc_description": "It can be used to set a font appearance based on our typography rules."
            }
        },
        "data": {
            "text": {
                "value": {
                    "type": "string",
                    "name": "text",
                    "doc_description": "It the user input text."
                },
                "max-lines": {
                    "type": "number",
                    "name": "maxLines",
                    "function": true,
                    "required": false,
                    "doc_description": "It determines the maximum lines of text the user can pass as input."
                },
                "min-lines": {
                    "type": "number",
                    "name": "minLines",
                    "platform": "android",
                    "required": false,
                    "doc_description": "It determines the minimum lines of text the user can pass as input."
                },
                "trim-line-padding": {
                    "type": "string",
                    "name": "trimLinePadding",
                    "required": false,
                    "platform": "android",
                    "doc_description": "Defines whether the space that would be added to the top of first line, and bottom of the last line should be trimmed or not."
                },
                "textType": {
                    "type": "string",
                    "name": "textType",
                    "platform": "web"
                },
                "custom-color": {
                    "type": "color",
                    "name": "customColor",
                    "required": false,
                    "platform": "android"
                }
            }
        },
        "events": {
            "text": {
                "onTextLayout": {
                    "name": "onTextLayout",
                    "platform": "android"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$legacyTextColors = [
    "primary-grey-100",
    "primary-80",
    "primary-70",
    "primary-60",
    "primary-50",
    "primary-40",
    "primary-30",
    "primary-20",
    "primary-inverse",
    "primary-background",
    "primary-grey-80",
    "primary-grey-60",
    "primary-grey-40",
    "primary-grey-20",
    "secondary-80",
    "secondary-70",
    "secondary-60",
    "secondary-50",
    "secondary-40",
    "secondary-30",
    "secondary-20",
    "secondary-inverse",
    "secondary-background",
    "secondary-grey-100",
    "secondary-grey-80",
    "secondary-grey-60",
    "secondary-grey-40",
    "secondary-grey-20",
    "sparkle-80",
    "sparkle-70",
    "sparkle-60",
    "sparkle-50",
    "sparkle-40",
    "sparkle-30",
    "sparkle-20",
    "sparkle-inverse",
    "sparkle-background",
    "sparkle-grey-100",
    "sparkle-grey-80",
    "sparkle-grey-60",
    "sparkle-grey-40",
    "sparkle-grey-20",
    "feedback-error-80",
    "feedback-error-50",
    "feedback-error-20",
    "feedback-warning-80",
    "feedback-warning-50",
    "feedback-warning-20",
    "feedback-success-80",
    "feedback-success-50",
    "feedback-success-20"
];
const $fe5170bdd3625759$var$legacyAppearance = [
    "body-s",
    "heading-xl",
    "heading-l",
    "heading-m",
    "heading-s",
    "heading-xs",
    "heading-xxs",
    "overline",
    "body-l",
    "body-l-bold",
    "body-l-link",
    "body-m",
    "body-m-bold",
    "body-m-link",
    "body-s-bold",
    "body-s-link",
    "body-xs",
    "body-xs-bold",
    "body-xs-link",
    "body-xxs",
    "body-xxs-bold",
    "body-xxs-link",
    "list-title",
    "body_xs_caps"
];
const $fe5170bdd3625759$var$PROP_MAP$n = (props)=>{
    if ($fe5170bdd3625759$var$legacyAppearance.includes(props.appearance)) console.warn("these values for appearance prop are deprecated", $fe5170bdd3625759$var$legacyAppearance);
    if ($fe5170bdd3625759$var$legacyTextColors.includes(props.color)) console.warn("these values for color are deprecated", $fe5170bdd3625759$var$legacyTextColors);
    return {
        color: {
            properties: {},
            variations: {
                "primary-grey-100": {
                    color: "primary_grey_100"
                },
                "primary-80": {
                    color: "primary_80"
                },
                "primary-70": {
                    color: "primary_70"
                },
                "primary-60": {
                    color: "primary_60"
                },
                "primary-50": {
                    color: "primary_50"
                },
                "primary-40": {
                    color: "primary_40"
                },
                "primary-30": {
                    color: "primary_30"
                },
                "primary-20": {
                    color: "primary_20"
                },
                "primary-inverse": {
                    color: "primary_inverse"
                },
                "primary-background": {
                    color: "primary_background"
                },
                "primary-grey-80": {
                    color: "primary_grey_80"
                },
                "primary-grey-60": {
                    color: "primary_grey_60"
                },
                "primary-grey-40": {
                    color: "primary_grey_40"
                },
                "primary-grey-20": {
                    color: "primary_grey_20"
                },
                "secondary-80": {
                    color: "secondary_80"
                },
                "secondary-70": {
                    color: "secondary_70"
                },
                "secondary-60": {
                    color: "secondary_60"
                },
                "secondary-50": {
                    color: "secondary_50"
                },
                "secondary-40": {
                    color: "secondary_40"
                },
                "secondary-30": {
                    color: "secondary_30"
                },
                "secondary-20": {
                    color: "secondary_20"
                },
                "secondary-inverse": {
                    color: "secondary_inverse"
                },
                "secondary-background": {
                    color: "secondary_background"
                },
                "secondary-grey-100": {
                    color: "secondary_grey_100"
                },
                "secondary-grey-80": {
                    color: "secondary_grey_80"
                },
                "secondary-grey-60": {
                    color: "secondary_grey_60"
                },
                "secondary-grey-40": {
                    color: "secondary_grey_40"
                },
                "secondary-grey-20": {
                    color: "secondary_grey_20"
                },
                "sparkle-80": {
                    color: "sparkle_80"
                },
                "sparkle-70": {
                    color: "sparkle_70"
                },
                "sparkle-60": {
                    color: "sparkle_60"
                },
                "sparkle-50": {
                    color: "sparkle_50"
                },
                "sparkle-40": {
                    color: "sparkle_40"
                },
                "sparkle-30": {
                    color: "sparkle_30"
                },
                "sparkle-20": {
                    color: "sparkle_20"
                },
                "sparkle-inverse": {
                    color: "sparkle_inverse"
                },
                "sparkle-background": {
                    color: "sparkle_background"
                },
                "sparkle-grey-100": {
                    color: "sparkle_grey_100"
                },
                "sparkle-grey-80": {
                    color: "sparkle_grey_80"
                },
                "SPARKLE-GREY-60": {
                    color: "sparkle_grey_60"
                },
                "sparkle-grey-40": {
                    color: "sparkle_grey_40"
                },
                "sparkle-grey-20": {
                    color: "sparkle_grey_20"
                },
                "feedback-error-80": {
                    color: "feedback_error_80"
                },
                "feedback-error-50": {
                    color: "feedback_error_50"
                },
                "feedback-error-20": {
                    color: "feedback_error_20"
                },
                "feedback-warning-80": {
                    color: "feedback_warning_80"
                },
                "feedback-warning-50": {
                    color: "feedback_warning_50"
                },
                "feedback-warning-20": {
                    color: "feedback_warning_20"
                },
                "feedback-success-80": {
                    color: "feedback_success_80"
                },
                "feedback-success-50": {
                    color: "feedback_success_50"
                },
                "feedback-success-20": {
                    color: "feedback_success_20"
                },
                white: {
                    color: "white"
                },
                black: {
                    color: "black"
                },
                transparent: {
                    color: "transparent"
                }
            }
        },
        children: {
            properties: {
                text: props.text || props.children
            }
        },
        text: {
            properties: {
                text: props.text || props.children
            }
        },
        as: {
            properties: {
                textType: props.as
            }
        },
        appearance: {
            properties: {},
            variations: {
                "body-s": {
                    appearance: "body-s"
                },
                "heading-xl": {
                    appearance: "heading_xl"
                },
                "heading-l": {
                    appearance: "heading_l"
                },
                "heading-m": {
                    appearance: "heading_m"
                },
                "heading-s": {
                    appearance: "heading_s"
                },
                "heading-xs": {
                    appearance: "heading_xs"
                },
                "heading-xxs": {
                    appearance: "heading_xxs"
                },
                overline: {
                    appearance: "overline"
                },
                "body-l": {
                    appearance: "body_l"
                },
                "body-l-bold": {
                    appearance: "body_l_bold"
                },
                "body-l-link": {
                    appearance: "body_l_link"
                },
                "body-m": {
                    appearance: "body_m"
                },
                "body-m-bold": {
                    appearance: "body_m_bold"
                },
                "body-m-link": {
                    appearance: "body_m_link"
                },
                "body-s-bold": {
                    appearance: "body_s_bold"
                },
                "body-s-link": {
                    appearance: "body_s_link"
                },
                "body-xs": {
                    appearance: "body_xs"
                },
                "body-xs-bold": {
                    appearance: "body_xs_bold"
                },
                "body-xs-link": {
                    appearance: "body_xs_link"
                },
                "body-xxs": {
                    appearance: "body_xxs"
                },
                "body-xxs-bold": {
                    appearance: "body_xxs-bold"
                },
                "body-xxs-link": {
                    appearance: "body_xxs_link"
                },
                "list-title": {
                    appearance: "list_title"
                },
                button: {
                    appearance: "button"
                },
                code: {
                    appearance: "code"
                }
            }
        }
    };
};
const $fe5170bdd3625759$var$withLogic$1l = (Component)=>(userProps)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$n);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props
            }
        });
    };
const $fe5170bdd3625759$var$Component$1n = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$Jdstext;
    const { color: color = "primary_grey_100", textAlign: textAlign = "left", textDecoration: textDecoration = "none", appearance: appearance = "body_s", onTextLayout: onTextLayout = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            color: color,
            textAlign: textAlign,
            textDecoration: textDecoration,
            appearance: appearance,
            onTextLayout: onTextLayout,
            ...rest
        },
        componentTag: componentTag
    }, "JDSText", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$5f1af8db9871e1d6 = $fe5170bdd3625759$var$withLogic$1l($fe5170bdd3625759$var$Component$1n);
$fe5170bdd3625759$export$5f1af8db9871e1d6.displayName = "Text";
$fe5170bdd3625759$export$5f1af8db9871e1d6.slotName = "jds_text";
const $fe5170bdd3625759$var$PROP_MAP$m = (props)=>({
        searchConfig: {
            properties: {
                searchResults: props.searchConfig?.searchResults?.sections?.[0].results?.map((c)=>({
                        ...c,
                        label: c.title
                    })),
                searchResultHeader: props.searchConfig?.searchResults?.sections?.[0].header,
                searchLabel: props.searchConfig?.searchInput?.label,
                searchSuffix: props.searchConfig?.searchInput?.suffix,
                searchShowBack: props.searchConfig?.searchInput?.showBack,
                query: props.searchConfig?.searchInput?.value,
                searchResultHeaderAction: props.searchConfig?.searchResults?.sections?.[0]?.headerAction?.title,
                onSearchResultClick: props.searchConfig?.searchResults?.onResultsItemClick,
                onSearchResultHeaderActionClick: props.searchConfig?.searchResults?.sections?.[0]?.headerAction?.onClick
            }
        },
        suffix: {
            properties: {
                suffix: typeof props.suffix === "string" ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$5f1af8db9871e1d6, {
                    children: props.suffix
                }) : props.suffix
            }
        }
    });
const $fe5170bdd3625759$var$sdl$1h = {
    "metadata": {
        "version": "1.0.0",
        "id": "link-1.0.0",
        "name": "JDSLink",
        "layerName": "jds_link"
    },
    "hierarchy": {
        "container": [
            "jds-text",
            "children-slot"
        ]
    },
    "base": {
        "container": {
            "hidden": false,
            "background-color": "{l_0}",
            "flex-direction": "{l_1}",
            "justify-content": "{l_2}",
            "align-items": "{l_3}",
            "behavior": {
                "hover": {},
                "visited": {},
                "active": {},
                "focus": {
                    "border-radius": "{l_4}",
                    "border-width": "{l_5}",
                    "border-color": "{l_6}"
                }
            }
        },
        "jds-text": {
            "font-family": "{bodySBold}",
            "color": "{primary60}",
            "font-size": "{bodySBold}",
            "line-height": "{bodySBold}",
            "letter-spacing": "{bodySBold}",
            "font-weight": "{bodySBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "text-color": "primary_grey_60"
        }
    },
    "variant": {
        "_hasText": {
            "false": {
                "jds-text": {
                    "hidden": true
                }
            }
        },
        "_hasChildren": {
            "false": {
                "children-slot": {
                    "hidden": true
                }
            },
            "true": {
                "jds-text": {
                    "hidden": true
                }
            }
        },
        "textAppearance": {
            "body_s": {
                "jds-text": {
                    "font-family": "{bodyS}",
                    "font-size": "{bodyS}",
                    "line-height": "{bodyS}",
                    "letter-spacing": "{bodyS}",
                    "font-weight": "{bodyS}"
                }
            },
            "body_s_bold": {
                "jds-text": {}
            },
            "body_m": {
                "jds-text": {
                    "font-family": "{bodyM}",
                    "font-size": "{bodyM}",
                    "line-height": "{bodyM}",
                    "letter-spacing": "{bodyM}",
                    "font-weight": "{bodyM}"
                }
            },
            "body_m_bold": {
                "jds-text": {
                    "font-family": "{bodyMBold}",
                    "font-size": "{bodyMBold}",
                    "line-height": "{bodyMBold}",
                    "letter-spacing": "{bodyMBold}",
                    "font-weight": "{bodyMBold}"
                }
            },
            "body_l": {
                "jds-text": {
                    "font-family": "{bodyL}",
                    "font-size": "{bodyL}",
                    "line-height": "{bodyL}",
                    "letter-spacing": "{bodyL}",
                    "font-weight": "{bodyL}"
                }
            },
            "body_l_bold": {
                "jds-text": {
                    "font-family": "{bodyLBold}",
                    "font-size": "{bodyLBold}",
                    "line-height": "{bodyLBold}",
                    "letter-spacing": "{bodyLBold}",
                    "font-weight": "{bodyLBold}"
                }
            },
            "body_l_link": {
                "jds-text": {
                    "font-family": "{bodyLLink}",
                    "font-size": "{bodyLLink}",
                    "line-height": "{bodyLLink}",
                    "letter-spacing": "{bodyLLink}",
                    "font-weight": "{bodyLLink}"
                }
            },
            "body_xs": {
                "jds-text": {
                    "font-family": "{bodyXs}",
                    "font-size": "{bodyXs}",
                    "line-height": "{bodyXs}",
                    "letter-spacing": "{bodyXs}",
                    "font-weight": "{bodyXs}"
                }
            },
            "body_xxs": {
                "jds-text": {
                    "font-family": "{bodyXxs}",
                    "font-size": "{bodyXxs}",
                    "line-height": "{bodyXxs}",
                    "letter-spacing": "{bodyXxs}",
                    "font-weight": "{bodyXxs}"
                }
            },
            "body_s_link": {
                "jds-text": {
                    "font-family": "{bodySLink}",
                    "font-size": "{bodySLink}",
                    "line-height": "{bodySLink}",
                    "letter-spacing": "{bodySLink}",
                    "font-weight": "{bodySLink}"
                }
            },
            "body_m_link": {
                "jds-text": {
                    "font-family": "{bodyMLink}",
                    "font-size": "{bodyMLink}",
                    "line-height": "{bodyMLink}",
                    "letter-spacing": "{bodyMLink}",
                    "font-weight": "{bodyMLink}"
                }
            },
            "body_xxs_link": {
                "jds-text": {
                    "font-family": "{bodyXxsLink}",
                    "font-size": "{bodyXxsLink}",
                    "line-height": "{bodyXxsLink}",
                    "letter-spacing": "{bodyXxsLink}",
                    "font-weight": "{bodyXxsLink}"
                }
            },
            "body_xs_link": {
                "jds-text": {
                    "font-family": "{bodyXsLink}",
                    "font-size": "{bodyXsLink}",
                    "line-height": "{bodyXsLink}",
                    "letter-spacing": "{bodyXsLink}",
                    "font-weight": "{bodyXsLink}"
                }
            },
            "body_xs_bold": {
                "jds-text": {
                    "font-family": "{bodyXsBold}",
                    "font-size": "{bodyXsBold}",
                    "line-height": "{bodyXsBold}",
                    "letter-spacing": "{bodyXsBold}",
                    "font-weight": "{bodyXsBold}"
                }
            },
            "body_xxs_bold": {
                "jds-text": {
                    "font-family": "{bodyXxsBold}",
                    "font-size": "{bodyXxsBold}",
                    "line-height": "{bodyXxsBold}",
                    "letter-spacing": "{bodyXxsBold}",
                    "font-weight": "{bodyXxsBold}"
                }
            },
            "heading_s": {
                "jds-text": {
                    "font-family": "{headingS}",
                    "font-size": "{headingS}",
                    "line-height": "{headingS}",
                    "letter-spacing": "{headingS}",
                    "font-weight": "{headingS}"
                }
            },
            "overline": {
                "jds-text": {
                    "font-family": "{overline}",
                    "font-size": "{overline}",
                    "line-height": "{overline}",
                    "letter-spacing": "{overline}",
                    "font-weight": "{overline}",
                    "text-transform": "{overline}"
                }
            },
            "heading_xs": {
                "jds-text": {
                    "font-family": "{headingXs}",
                    "font-size": "{headingXs}",
                    "line-height": "{headingXs}",
                    "letter-spacing": "{headingXs}",
                    "font-weight": "{headingXs}"
                }
            },
            "heading_xxs": {
                "jds-text": {
                    "font-family": "{headingXxs}",
                    "font-size": "{headingXxs}",
                    "line-height": "{headingXxs}",
                    "letter-spacing": "{headingXxs}",
                    "font-weight": "{headingXxs}"
                }
            },
            "heading_l": {
                "jds-text": {
                    "font-family": "{headingL}",
                    "font-size": "{headingL}",
                    "line-height": "{headingL}",
                    "letter-spacing": "{headingL}",
                    "font-weight": "{headingL}"
                }
            },
            "heading_m": {
                "jds-text": {
                    "font-family": "{headingM}",
                    "font-size": "{headingM}",
                    "line-height": "{headingM}",
                    "letter-spacing": "{headingM}",
                    "font-weight": "{headingM}"
                }
            },
            "heading_xl": {
                "jds-text": {
                    "font-family": "{headingXl}",
                    "font-size": "{headingXl}",
                    "line-height": "{headingXl}",
                    "letter-spacing": "{headingXl}",
                    "font-weight": "{headingXl}"
                }
            },
            "list_title": {
                "jds-text": {
                    "font-family": "{listTitle}",
                    "font-size": "{listTitle}",
                    "line-height": "{listTitle}",
                    "letter-spacing": "{listTitle}",
                    "font-weight": "{listTitle}"
                }
            },
            "button": {
                "jds-text": {
                    "font-family": "{button}",
                    "font-size": "{button}",
                    "line-height": "{button}",
                    "letter-spacing": "{button}",
                    "font-weight": "{button}"
                }
            },
            "code": {
                "jds-text": {
                    "font-family": "{code}",
                    "font-size": "{code}",
                    "line-height": "{code}",
                    "letter-spacing": "{code}",
                    "font-weight": "{code}"
                }
            }
        },
        "kind": {
            "default": {
                "jds-text": {
                    "behavior": {
                        "hover": {
                            "color": "{primary50}"
                        },
                        "visited": {
                            "color": "{primaryGrey80}"
                        }
                    }
                }
            },
            "header": {
                "container": {
                    "behavior": {
                        "focus": {
                            "border-color": "{l_7}"
                        }
                    }
                },
                "jds-text": {
                    "color": "{primaryInverse}",
                    "behavior": {
                        "hover": {
                            "text-decoration": "{text-decoration.underline}"
                        }
                    }
                }
            },
            "submenu": {
                "jds-text": {
                    "color": "{primaryGrey80}",
                    "behavior": {
                        "hover": {
                            "color": "{primaryGrey100}",
                            "text-decoration": "{text-decoration.underline}"
                        }
                    }
                }
            },
            "rich_text": {
                "jds-text": {
                    "color": "{primaryGrey100}",
                    "text-decoration": "{text-decoration.underline}",
                    "behavior": {
                        "hover": {
                            "text-decoration": "{text-decoration.none}"
                        }
                    }
                }
            }
        }
    },
    "combination": [
        {
            "true": {
                "header": {
                    "jds-text": {
                        "text-decoration": "{text-decoration.underline}"
                    }
                }
            }
        },
        {
            "header": {
                "none": {
                    "jds-text": {
                        "color": "{primaryInverse}",
                        "behavior": {
                            "hover": {
                                "font-family": "{bodySLink}",
                                "color": "{primary60}",
                                "font-size": "{bodySLink}",
                                "line-height": "{bodySLink}",
                                "letter-spacing": "{bodySLink}",
                                "font-weight": "{bodySLink}"
                            },
                            "active": {
                                "font-family": "{bodySLink}",
                                "color": "{primary60}",
                                "font-size": "{bodySLink}",
                                "line-height": "{bodySLink}",
                                "letter-spacing": "{bodySLink}",
                                "font-weight": "{bodySLink}"
                            }
                        }
                    }
                }
            },
            "submenu": {
                "none": {
                    "jds-text": {}
                }
            },
            "rich_text": {
                "none": {
                    "jds-text": {
                        "font-family": "{bodySLink}",
                        "font-size": "{bodySLink}",
                        "line-height": "{bodySLink}",
                        "letter-spacing": "{bodySLink}",
                        "font-weight": "{bodySLink}",
                        "behavior": {
                            "hover": {
                                "font-family": "{bodySBold}",
                                "color": "{primaryGrey100}",
                                "font-size": "{bodySBold}",
                                "line-height": "{bodySBold}",
                                "letter-spacing": "{bodySBold}",
                                "font-weight": "{bodySBold}",
                                "text-decoration": "{text-decoration.underline}"
                            }
                        }
                    }
                }
            },
            "default": {
                "none": {
                    "jds-text": {
                        "behavior": {
                            "hover": {
                                "font-family": "{bodySLink}",
                                "font-size": "{bodySLink}",
                                "line-height": "{bodySLink}",
                                "letter-spacing": "{bodySLink}",
                                "font-weight": "{bodySLink}"
                            }
                        }
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "_active",
            "kind"
        ],
        [
            "kind",
            "textAppearance"
        ]
    ],
    "api": {
        "data": {
            "container": {
                "href": {
                    "type": "string",
                    "name": "href",
                    "doc_description": "User provided href of the Link."
                },
                "target": {
                    "type": "boolean",
                    "name": "newTab",
                    "platform": "web"
                }
            },
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "title",
                    "doc_description": "It displayes the title of Link."
                }
            }
        },
        "config": {
            "_hasText": {
                "values": [
                    true,
                    false
                ]
            },
            "_active": {
                "values": [
                    false,
                    true
                ]
            },
            "_hasChildren": {
                "values": [
                    true,
                    false
                ]
            },
            "textAppearance": {
                "type": "JDSText.appearance",
                "doc_description": "It can be used to apply certain style to the title of the link.",
                "values": [
                    "body_s",
                    "heading_xl",
                    "heading_l",
                    "heading_m",
                    "heading_s",
                    "heading_xs",
                    "heading_xxs",
                    "overline",
                    "body_l",
                    "body_l_bold",
                    "body_l_link",
                    "body_m",
                    "body_m_bold",
                    "body_m_link",
                    "body_s_bold",
                    "body_s_link",
                    "body_xs",
                    "body_xs_bold",
                    "body_xs_link",
                    "body_xxs",
                    "body_xxs_bold",
                    "body_xxs_link",
                    "body_3xs",
                    "body_3xs_bold",
                    "body_3xs_link",
                    "list_title",
                    "button",
                    "code",
                    "body_xs_caps",
                    "body_s_regular_para"
                ]
            },
            "kind": {
                "values": [
                    "default",
                    "header",
                    "submenu",
                    "rich_text"
                ],
                "doc_description": "It can be used to switch between 4 variants of Link."
            }
        },
        "events": {
            "container": {
                "onClick": "onClick",
                "onHover": {
                    "name": "onHover",
                    "platform": "web"
                },
                "onHoverEnd": {
                    "name": "onHoverEnd",
                    "platform": "web"
                }
            }
        },
        "children": {
            "children-slot": {
                "name": "children",
                "accepts": [
                    "any"
                ]
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "link"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "title"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "aria-haspopup": {
                        "name": "ariaHaspopup",
                        "platform": "web"
                    },
                    "aria-expanded": {
                        "name": "ariaExpanded",
                        "platform": "web"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withProviderProps = (Component)=>({ provider: provider = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("a", {}), ...rest })=>{
        const currentProvider = provider || rest?.href ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("a", {
            href: rest?.href
        }) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {});
        if (!Component) return null;
        return (0, $acw62.cloneElement)(currentProvider, {
            ...{
                ...provider?.props,
                target: rest.newTab ? "_blank" : void 0,
                tabIndex: -1,
                style: {
                    ...provider?.props?.style || {},
                    display: "inline-flex"
                }
            },
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
                ...rest
            })
        });
    };
const $fe5170bdd3625759$var$PROP_MAP$l = (props)=>{
    if (props.kind === "rich-text") console.warn("rich-text is deprecated, use rich_text instead");
    return {
        newTab: {
            properties: {
                newTab: props.newTab ? "_blank" : void 0
            }
        },
        kind: {
            variations: {
                default: {
                    kind: "default"
                },
                "rich-text": {
                    kind: "rich_text"
                }
            }
        },
        textAppearance: {
            properties: {},
            variations: {
                "body-s": {
                    textAppearance: "body-s"
                },
                "heading-xl": {
                    textAppearance: "heading_xl"
                },
                "heading-l": {
                    textAppearance: "heading_l"
                },
                "heading-m": {
                    textAppearance: "heading_m"
                },
                "heading-s": {
                    textAppearance: "heading_s"
                },
                "heading-xs": {
                    textAppearance: "heading_xs"
                },
                "heading-xxs": {
                    textAppearance: "heading_xxs"
                },
                overline: {
                    textAppearance: "overline"
                },
                "body-l": {
                    textAppearance: "body_l"
                },
                "body-l-bold": {
                    textAppearance: "body_l_bold"
                },
                "body-l-link": {
                    textAppearance: "body_l_link"
                },
                "body-m": {
                    textAppearance: "body_m"
                },
                "body-m-bold": {
                    textAppearance: "body_m_bold"
                },
                "body-m-link": {
                    textAppearance: "body_m_link"
                },
                "body-s-bold": {
                    textAppearance: "body_s_bold"
                },
                "body-s-link": {
                    textAppearance: "body_s_link"
                },
                "body-xs": {
                    textAppearance: "body_xs"
                },
                "body-xs-bold": {
                    textAppearance: "body_xs_bold"
                },
                "body-xs-link": {
                    textAppearance: "body_xs_link"
                },
                "body-xxs": {
                    textAppearance: "body_xxs"
                },
                "body-xxs-bold": {
                    textAppearance: "body_xxs-bold"
                },
                "body-xxs-link": {
                    textAppearance: "body_xxs_link"
                },
                "list-title": {
                    textAppearance: "list_title"
                },
                button: {
                    textAppearance: "button"
                },
                code: {
                    textAppearance: "code"
                }
            }
        }
    };
};
const $fe5170bdd3625759$var$withLogic$1k = (Component)=>(0, $acw62.forwardRef)((userProps, ref)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$l);
        const ComponentWithProvider = (0, $acw62.useMemo)(()=>$fe5170bdd3625759$var$withProviderProps(Component), []);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(ComponentWithProvider, {
            ...{
                ...props,
                rootRef: ref,
                textAppearance: props.textAppearance || "body_s",
                _hasText: Boolean(props.title),
                _hasChildren: Boolean(props.children) && !props.title,
                children: $fe5170bdd3625759$var$convertTextToComponent(props.children)
            }
        });
    });
const $fe5170bdd3625759$var$Component$1m = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1h;
    const { textAppearance: textAppearance = "undefined", kind: kind = "default", onClick: onClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onHover: onHover = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onHoverEnd: onHoverEnd = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), ariaLabel: ariaLabel = props.title?.toString(), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            textAppearance: textAppearance,
            kind: kind,
            onClick: onClick,
            onHover: onHover,
            onHoverEnd: onHoverEnd,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSLink", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$a6c7ac8248d6e38a = $fe5170bdd3625759$var$withLogic$1k($fe5170bdd3625759$var$Component$1m);
$fe5170bdd3625759$export$a6c7ac8248d6e38a.displayName = "Link";
$fe5170bdd3625759$export$a6c7ac8248d6e38a.slotName = "jds_link";
const $fe5170bdd3625759$var$sdl$1g = {
    "metadata": {
        "version": "1.0.0",
        "id": "side-panel-1.0.0",
        "name": "JDSSidePanel",
        "description": "",
        "layerName": "jds_side_panel"
    },
    "hierarchy": {
        "popup": [
            {
                "popup-container": [
                    "jds_side_panel_internal"
                ]
            }
        ]
    },
    "base": {
        "popup": {
            "priority": 40,
            "passive": true,
            "show": true
        },
        "popup-container": {
            "background-color": "#141414D9",
            "height": "{s_0}",
            "width": "{s_1}",
            "flex-direction": "{s_2}",
            "justify-content": "{s_3}",
            "align-items": "{s_4}",
            "enter-animation-name": "fadeIn",
            "exit-animation-name": "fadeOut",
            "enter-animation-curve": "entrance_ease",
            "exit-animation-curve": "exit_ease",
            "enter-animation-duration": 500,
            "exit-animation-duration": 500,
            "opacity": "{opacity.invisible}",
            "transition": {
                "property": [
                    "opacity"
                ],
                "duration": "{medium}",
                "timing-function": "{easeRapid}"
            }
        },
        "jds_side_panel_internal": {
            "open": false,
            "maxWidth": false
        }
    },
    "variant": {
        "open": {
            "true": {
                "popup": {
                    "passive": false
                },
                "popup-container": {
                    "opacity": "{opacity.enabled}"
                },
                "jds_side_panel_internal": {
                    "open": true
                }
            }
        },
        "direction": {
            "right": {
                "popup-container": {
                    "justify-content": "{s_27}"
                },
                "jds_side_panel_internal": {
                    "direction": "right"
                }
            }
        },
        "maxWidth": {
            "true": {
                "jds_side_panel_internal": {
                    "maxWidth": true
                }
            }
        },
        "showClose": {
            "false": {
                "jds_side_panel_internal": {
                    "showClose": false
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [],
    "api": {
        "config": {
            "direction": {
                "values": [
                    "left",
                    "right"
                ],
                "doc_description": "Determines whether open/close should happen from left or right."
            },
            "showClose": {
                "values": [
                    true,
                    false
                ],
                "doc_description": "Whether a close on the right should be shown."
            },
            "open": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "Can be used to programatically open/close the drawer with animation and selected direction."
            },
            "maxWidth": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "If set it will limit max width of the panel to 412px.",
                "function": true
            },
            "disableTransition": {
                "values": [
                    false,
                    true
                ],
                "platform": "web"
            }
        },
        "data": {
            "jds_side_panel_internal": {
                "items": {
                    "type": "list",
                    "name": "items",
                    "object": {
                        "title": "string",
                        "prefix": "icon",
                        "showSuffix": "boolean",
                        "type": "JDSSidePanelItem.type"
                    }
                },
                "items.prefix": {
                    "type": "string",
                    "name": "items.prefix"
                },
                "items.title": {
                    "type": "string",
                    "name": "items.title"
                },
                "links.showSuffix": {
                    "type": "boolean",
                    "name": "links.showSuffix"
                },
                "items.type": {
                    "type": "string",
                    "name": "items.type"
                },
                "prefix": {
                    "name": "prefix",
                    "type": "slot",
                    "accepts": [
                        "jds_avatar",
                        "jds_icon",
                        "jds_button"
                    ],
                    "max": 1
                },
                "header": {
                    "name": "header",
                    "type": "slot",
                    "doc_description": "Has pre-defined suffix as close button.",
                    "accepts": [
                        "jds_text"
                    ],
                    "max": 1
                },
                "children": {
                    "name": "children",
                    "type": "slot",
                    "doc_description": "Any group of children can be added. When used for BurgerMenu, show a list of ListBlocks.",
                    "accepts": [
                        "any"
                    ]
                }
            }
        },
        "events": {
            "jds_side_panel_internal": {
                "onClose": "onClose",
                "onContainerClick": "_onContainerClick",
                "onSwipeLeft": "onClose",
                "onSidePanelSuffixClick": "onSidePanelSuffixClick"
            },
            "popup": {
                "onClick": "onClose"
            }
        },
        "a11y": {
            "jds_side_panel_internal": {
                "name": "items",
                "repeating": {
                    "itemAriaLabel": "itemAriaLabel",
                    "itemSuffixAriaLabel": "itemSuffixAriaLabel",
                    "itemAriaDescribedby": {
                        "name": "itemAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$PROP_MAP$k = (props)=>{
    if (props.header?.title) console.warn("passing listblock props to header is deprecated");
    return {
        header: {
            properties: {
                prefix: props.header?.prefix,
                header: props.header?.titleBlock?.text || (props.header?.title ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$5f1af8db9871e1d6, {
                    children: props.header?.title
                }) : props.header)
            }
        },
        maxWidth: {
            properties: {
                maxWidth: !props.maxWidth
            }
        }
    };
};
const $fe5170bdd3625759$var$SIDEPANEL_SELECTOR = "div.j-JDSSidePanelInternal-container";
const $fe5170bdd3625759$var$withLogic$1j = (Component)=>(userProps)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$k);
        const { className: className, open: open, close: close } = $fe5170bdd3625759$var$useTransition(Boolean(props.open), props.onClose, 500);
        const { element: element, rootRef: rootRef } = $fe5170bdd3625759$var$useRootRef();
        const sidepanelRef = element?.querySelector($fe5170bdd3625759$var$SIDEPANEL_SELECTOR);
        (0, $acw62.useEffect)(()=>{
            if (props.open && sidepanelRef) sidepanelRef.focus();
        }, [
            props.open
        ]);
        const directionClass = props.direction === "right" ? "right" : "";
        const classes = [
            directionClass,
            className,
            !props.disableTransition ? "enable-transition" : ""
        ];
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                open: open,
                rootRef: rootRef,
                maxWidth: props.maxWidth || props.maxWidth === void 0,
                platform: $fe5170bdd3625759$var$getPlatform(),
                children: $fe5170bdd3625759$var$convertTextToComponent(props.children),
                className: classes.join(" "),
                _onContainerClick: (ev)=>{
                    ev.stopPropagation();
                },
                onClose: close
            }
        });
    };
const $fe5170bdd3625759$var$Component$1l = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1g;
    const { direction: direction = "left", showClose: showClose = true, open: open = false, maxWidth: maxWidth = false, disableTransition: disableTransition = false, onClose: onClose = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSidePanelSuffixClick: onSidePanelSuffixClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            direction: direction,
            showClose: showClose,
            open: open,
            maxWidth: maxWidth,
            disableTransition: disableTransition,
            onClose: onClose,
            onSidePanelSuffixClick: onSidePanelSuffixClick,
            ...rest
        },
        componentTag: componentTag
    }, "JDSSidePanel", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$8689d3888980b1f3 = $fe5170bdd3625759$var$withLogic$1j($fe5170bdd3625759$var$Component$1l);
$fe5170bdd3625759$export$8689d3888980b1f3.displayName = "SidePanel";
$fe5170bdd3625759$export$8689d3888980b1f3.slotName = "jds_side_panel";
const $fe5170bdd3625759$var$sdl$1f = {
    "metadata": {
        "version": "1.0.0",
        "id": "side-panel-item-1.0.0",
        "name": "JDSSidePanelItem",
        "layerName": "jds_side_panel_item",
        "internal": true
    },
    "hierarchy": {
        "container": [
            {
                "inner-container": [
                    {
                        "prefix-jds-icon-container": [
                            "prefix-jds-icon"
                        ]
                    },
                    "title-jds_link"
                ]
            },
            "suffix-jds_action_button",
            "heading-jds-text",
            "jds_divider"
        ]
    },
    "base": {
        "jds_divider": {
            "hidden": true,
            "pad": "none",
            "orientation": "horizontal"
        },
        "container": {
            "flex-direction": "{s_2}",
            "justify-content": "{s_3}",
            "align-items": "{s_4}",
            "width": "{s_5}"
        },
        "inner-container": {
            "flex-direction": "{s_6}",
            "justify-content": "{s_7}",
            "align-items": "{s_8}",
            "gap": "{s_9}",
            "padding-top": "{s_10}",
            "padding-bottom": "{s_11}",
            "flex": 1
        },
        "title-jds_link": {
            "kind": "submenu",
            "textAppearance": "body_s"
        },
        "suffix-jds_action_button": {
            "hidden": false,
            "icon": "ic_next",
            "size": "medium",
            "kind": "tertiary"
        },
        "heading-jds-text": {
            "font-family": "{bodyXsBold}",
            "color": "{primaryGrey100}",
            "font-size": "{bodyXsBold}",
            "line-height": "{bodyXsBold}",
            "letter-spacing": "{bodyXsBold}",
            "font-weight": "{bodyXsBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": true,
            "padding-top": "{s_0}",
            "padding-bottom": "{s_1}"
        },
        "prefix-jds-icon": {
            "size": "{m}",
            "color": "{primary50}"
        },
        "prefix-jds-icon-container": {
            "background-color": "{primary20}",
            "border-radius": "{pill}",
            "size": "{l}",
            "justify-content": "{justifyContent.center}",
            "align-items": "{alignItems.center}"
        }
    },
    "variant": {
        "showSuffix": {
            "false": {
                "suffix-jds_action_button": {
                    "hidden": true
                }
            }
        },
        "type": {
            "divider": {
                "container": {
                    "padding-top": "0",
                    "padding-bottom": "0"
                },
                "inner-container": {
                    "hidden": true
                },
                "suffix-jds_action_button": {
                    "hidden": true
                },
                "jds_divider": {
                    "hidden": false
                }
            },
            "heading": {
                "container": {
                    "padding-top": "0",
                    "padding-bottom": "0"
                },
                "inner-container": {
                    "hidden": true
                },
                "suffix-jds_action_button": {
                    "hidden": true
                },
                "heading-jds-text": {
                    "hidden": false
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "type": {
                "values": [
                    "entry",
                    "divider",
                    "heading"
                ]
            },
            "showSuffix": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "title-jds_link": {
                "title": {
                    "type": "string",
                    "name": "title"
                },
                "href": {
                    "type": "string",
                    "name": "href"
                },
                "newTab": {
                    "type": "boolean",
                    "name": "newTab"
                }
            },
            "prefix-jds-icon": {
                "value": {
                    "type": "icon",
                    "name": "prefix"
                },
                "ic": {
                    "type": "icon",
                    "name": "prefix"
                }
            },
            "heading-jds-text": {
                "value": {
                    "type": "string",
                    "name": "title"
                }
            }
        },
        "events": {
            "suffix-jds_action_button": {
                "onClick": "onSuffixClick"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "listitem"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "title"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "suffix-jds_action_button": {
                "properties": {
                    "ariaLabel": "itemSuffixAriaLabel"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1i = (Component)=>(props)=>{
        const { prefix: prefix, ...rest } = props;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...rest,
                onSuffixClick: ()=>{
                    rest.onSuffixClick?.(rest.internalIndex);
                }
            }
        });
    };
const $fe5170bdd3625759$var$Component$1k = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1f;
    const { type: type = "entry", showSuffix: showSuffix = true, onSuffixClick: onSuffixClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), ariaLabel: ariaLabel = props.title?.toString(), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            type: type,
            showSuffix: showSuffix,
            onSuffixClick: onSuffixClick,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSSidePanelItem", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$500ae19c14a3c46 = $fe5170bdd3625759$var$withLogic$1i($fe5170bdd3625759$var$Component$1k);
$fe5170bdd3625759$export$500ae19c14a3c46.displayName = "SidePanelItem";
$fe5170bdd3625759$export$500ae19c14a3c46.slotName = "jds_side_panel_item";
const $fe5170bdd3625759$var$createIconLinks = (iconLinks)=>{
    return iconLinks?.map((iconLink, i)=>{
        const { icon: icon, ...rest } = iconLink;
        return /* @__PURE__ */ (0, $acw62.createElement)($fe5170bdd3625759$export$a6c7ac8248d6e38a, {
            ...rest,
            key: iconLink.href || i
        }, /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$353f5b6fc5456de1, {
            icon: icon
        }));
    });
};
const $fe5170bdd3625759$var$useResponsiveDevice = ()=>{
    const [isDesktop, setIsDesktop] = (0, $acw62.useState)(true);
    const handleResize = (0, $acw62.useCallback)(()=>{
        setIsDesktop($fe5170bdd3625759$var$Devices.isDesktop());
    }, []);
    (0, $acw62.useEffect)(()=>{
        setIsDesktop($fe5170bdd3625759$var$Devices.isDesktop());
        window.addEventListener("resize", handleResize);
        return ()=>{
            window.removeEventListener("resize", handleResize);
        };
    }, [
        handleResize
    ]);
    return isDesktop;
};
const $fe5170bdd3625759$var$withLogic$1h = (Component)=>(userProps)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$m);
        const isDesktop = $fe5170bdd3625759$var$useResponsiveDevice();
        const links = props.links?.map((link, i)=>({
                ...link,
                active: props.activeLink === i,
                showSuffix: link.subLinks?.length,
                onHover: ()=>{
                    if (isDesktop) {
                        setSelectedLink(i);
                        setOpen(true);
                    }
                }
            }));
        const [distance, setDistance] = (0, $acw62.useState)({
            x: 0,
            y: 0,
            width: 0
        });
        const [selectedLink, setSelectedLink] = (0, $acw62.useState)();
        const [open, setOpen] = (0, $acw62.useState)(false);
        const [internalSearchActive, setInternalSearchActive] = (0, $acw62.useState)(props.variant === "active_search");
        const [element, setElement] = (0, $acw62.useState)(null);
        const [searchValue, setSearchValue] = (0, $acw62.useState)(props.searchConfig?.searchInput?.value);
        const [currentLinks, setCurrentLinks] = (0, $acw62.useState)(links || []);
        const [sidePanelLinkIndex, setSidePanelLinkIndex] = (0, $acw62.useState)(0);
        const [lastSidePanelItems, setLastSidePanelItems] = (0, $acw62.useState)([
            links || []
        ]);
        const [sidePanelOpen, setSidePanelOpen] = (0, $acw62.useState)(false);
        const [sidePanelTitle, setSidePanelTitle] = (0, $acw62.useState)("");
        const updatePosition = (0, $acw62.useCallback)($fe5170bdd3625759$var$debounce((element2)=>{
            if (element2) {
                const { x: x, y: y, width: width, height: height } = element2.getBoundingClientRect();
                setDistance({
                    x: x,
                    y: y + height,
                    width: width
                });
            }
        }, 100), []);
        const ref = (0, $acw62.useCallback)((ref2)=>{
            if (ref2 && (open || internalSearchActive)) {
                setElement(ref2);
                updatePosition(ref2);
            }
        }, [
            updatePosition,
            open,
            internalSearchActive
        ]);
        const currentSelectedLinkIndex = typeof selectedLink === "number" ? selectedLink : -1;
        const megaMenuLinks = links?.[currentSelectedLinkIndex]?.subLinks?.map((t)=>({
                ...t,
                links: t.subLinks
            }));
        const handleSearchActiveChange = (val)=>{
            props?.onSearchStateChange?.(val ? "open" : "closed");
            setInternalSearchActive(val);
        };
        const listener = ()=>{
            setOpen(false);
            handleSearchActiveChange(false);
        };
        (0, $acw62.useEffect)(()=>{
            setInternalSearchActive(props.variant === "active_search");
        }, [
            props.variant
        ]);
        (0, $acw62.useEffect)(()=>{
            window.addEventListener("scroll", listener);
            return ()=>{
                window.removeEventListener("scroll", listener);
            };
        }, []);
        (0, $acw62.useEffect)(()=>{
            const targetLogo = document.querySelector('div[data-testid="JDSHeaderDesktop-logo-container"] > a > div[data-testid="JDSLink-container"] > div[data-testid="JDSIcon-container"]');
            const targetAvatar = document.querySelector('div[data-testid="JDSHeaderDesktop-suffix-container"] > a > div[data-testid="JDSLink-container"] > div[data-testid="JDSAvatar-container"]');
            const targetIconLinks = document.querySelectorAll(' a > div[data-testid="JDSLink-container"] > button[data-testid="JDSButton-container"]');
            if (targetLogo) targetLogo.setAttribute("tabindex", "-1");
            if (targetAvatar) targetAvatar.setAttribute("tabindex", "-1");
            if (targetIconLinks) targetIconLinks.forEach((el)=>el.setAttribute("tabindex", "-1"));
        }, []);
        const LogoItem = props.logo === null ? void 0 : props.logo?.props?.src || props.logo?.props?.ic ? props.logo : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$f04a61298a47a40f, {
            ic: "IcJioDot",
            size: "xtra-large",
            color: "secondary_50"
        });
        const logoSlot = props.logoLink === null || props.logoLink === void 0 ? LogoItem : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$a6c7ac8248d6e38a, {
            ...props.logoLink,
            children: LogoItem
        });
        const AvatarItem = props.avatar ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$e2255cf6045e8d47, {
            ...props.avatar
        }) : void 0;
        const avatarSlot = props.avatarLink === null || props.avatarLink === void 0 ? AvatarItem : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$a6c7ac8248d6e38a, {
            ...props.avatarLink,
            children: AvatarItem
        });
        const suffixSlot = props.suffixLink === null || props.suffixLink === void 0 ? props.suffix : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$a6c7ac8248d6e38a, {
            ...props.suffixLink,
            children: props.suffix
        });
        const { onFocus: onFocus, onSuffixClick: onSuffixClick, onChange: onChange, onKeyDown: onKeyDown, ...rest } = (props.searchConfig || {}).searchInput || {};
        (0, $acw62.useEffect)(()=>{
            if (open) updatePosition(element);
        }, [
            open,
            element
        ]);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
                    ...{
                        ...props,
                        ...rest,
                        onSearchBoxSuffixClick: onSuffixClick,
                        onSearchKeydown: onKeyDown || props.searchConfig?.onSearchKeyDown,
                        _hasSearchResults: Boolean(props.searchConfig?.searchResults),
                        suffix: suffixSlot,
                        prefixOnClick: ()=>{
                            if (!isDesktop && props.links?.length) setSidePanelOpen(true);
                        },
                        prefix: isDesktop || !props.links?.length ? props.prefix : "ic_burger_menu",
                        logo: logoSlot,
                        avatar: avatarSlot,
                        avatarOnClick: props.avatarOnClick || props.avatarLink,
                        onSearchIconClick: ()=>handleSearchActiveChange(true),
                        expandedSearch: internalSearchActive || props.expandedSearch,
                        onSearchResultContainerClick: (ev)=>ev.stopPropagation(),
                        tabs: props.tabs ? (0, $acw62.cloneElement)(props.tabs, {
                            appearance: "tab-bar"
                        }) : null,
                        onSearchResultClick: (ev)=>{
                            setSearchValue(ev.label);
                            handleSearchActiveChange(false);
                            props.searchConfig?.onSearchResultClick?.(ev);
                            props.searchConfig?.searchResults?.onResultsItemClick?.(ev);
                        },
                        _platform: isDesktop ? "desktop" : "mobile",
                        links: isDesktop ? links : void 0,
                        query: searchValue,
                        onSearchChange: (ev)=>{
                            setSearchValue(ev.target.value);
                            props.searchConfig?.onSearchChange?.(ev.target.value);
                            onChange?.(ev);
                        },
                        iconLinks: $fe5170bdd3625759$var$createIconLinks(props.iconLinks),
                        _variant: internalSearchActive ? "active_search" : "default",
                        onSearchFocus: (ev)=>{
                            handleSearchActiveChange(true);
                            props.searchConfig?.onSearchFocus?.();
                            onFocus?.(ev);
                        },
                        suffixOnClick: ()=>handleSearchActiveChange(false),
                        megaMenuProps: {
                            subLinks: megaMenuLinks,
                            offsetX: distance.x,
                            offsetY: distance.y,
                            width: distance.width + distance.x,
                            open: open
                        },
                        onMenuHoverEnd: ()=>setOpen(false),
                        onSearchClose: ()=>handleSearchActiveChange(false),
                        elementRef: ref
                    }
                }),
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$8689d3888980b1f3, {
                    open: sidePanelOpen,
                    onClose: ()=>setSidePanelOpen(false),
                    header: {
                        titleBlock: {
                            text: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$5f1af8db9871e1d6, {
                                color: "primary_inverse",
                                children: sidePanelTitle
                            })
                        },
                        prefix: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$353f5b6fc5456de1, {
                            icon: "ic_back",
                            onClick: ()=>{
                                const currentIndex = sidePanelLinkIndex;
                                const actualIndex = currentIndex < 0 ? 0 : currentIndex;
                                const currentItems = [
                                    ...lastSidePanelItems
                                ];
                                const lastItems = currentItems.splice(actualIndex, 1);
                                setSidePanelLinkIndex(actualIndex - 1);
                                if (lastItems?.[0]) setCurrentLinks(lastItems[0]);
                                setLastSidePanelItems(currentItems);
                            }
                        })
                    },
                    maxWidth: true,
                    children: currentLinks?.map((item, index)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$500ae19c14a3c46, {
                            type: item.type,
                            showSuffix: !!item.showSuffix,
                            prefix: item.prefix,
                            title: item.title,
                            ariaLabel: item.ariaLabel,
                            ariaDescribedby: item.ariaDescribedby,
                            itemSuffixAriaLabel: item.itemSuffixAriaLabel,
                            onSuffixClick: ()=>{
                                const subLinks = item.subLinks?.map((l)=>({
                                        ...l,
                                        showSuffix: Boolean(l.subLinks?.length)
                                    }));
                                if (subLinks) {
                                    setCurrentLinks(subLinks);
                                    setSidePanelLinkIndex(sidePanelLinkIndex + 1);
                                    setLastSidePanelItems((link)=>[
                                            ...link,
                                            currentLinks
                                        ]);
                                    setSidePanelTitle(item.title || "");
                                }
                                item.onSuffixClick?.();
                            },
                            custom: item.custom,
                            href: item.href,
                            newTab: true
                        }, index))
                })
            ]
        });
    };
const $fe5170bdd3625759$var$Component$1j = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1i;
    const { search: search = true, expandedSearch: expandedSearch = true, searchActive: searchActive = false, fullWidth: fullWidth = true, onSearchActiveChange: onSearchActiveChange = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), logoOnClick: logoOnClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), avatarOnClick: avatarOnClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), prefixOnClick: prefixOnClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), suffixOnClick: suffixOnClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onHover: onHover = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onMenuHoverEnd: onMenuHoverEnd = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSearchBlur: onSearchBlur = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSearchFocus: onSearchFocus = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSearchChange: onSearchChange = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSearchBoxSuffixClick: onSearchBoxSuffixClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSearchKeydown: onSearchKeydown = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSearchIconClick: onSearchIconClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSearchResultHeaderActionClick: onSearchResultHeaderActionClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSearchResultClick: onSearchResultClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), searchButtonAriaLabel: searchButtonAriaLabel = props.dynamicButtonText?.toString(), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            search: search,
            expandedSearch: expandedSearch,
            searchActive: searchActive,
            fullWidth: fullWidth,
            onSearchActiveChange: onSearchActiveChange,
            logoOnClick: logoOnClick,
            avatarOnClick: avatarOnClick,
            prefixOnClick: prefixOnClick,
            suffixOnClick: suffixOnClick,
            onHover: onHover,
            onMenuHoverEnd: onMenuHoverEnd,
            onSearchBlur: onSearchBlur,
            onSearchFocus: onSearchFocus,
            onSearchChange: onSearchChange,
            onSearchBoxSuffixClick: onSearchBoxSuffixClick,
            onSearchKeydown: onSearchKeydown,
            onSearchIconClick: onSearchIconClick,
            onSearchResultHeaderActionClick: onSearchResultHeaderActionClick,
            onSearchResultClick: onSearchResultClick,
            searchButtonAriaLabel: searchButtonAriaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSHeaderDesktop", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$8b251419efc915eb = $fe5170bdd3625759$var$withLogic$1h($fe5170bdd3625759$var$Component$1j);
$fe5170bdd3625759$export$8b251419efc915eb.displayName = "Header";
$fe5170bdd3625759$export$8b251419efc915eb.slotName = "jds_header_desktop";
const $fe5170bdd3625759$var$sdl$1e = {
    "metadata": {
        "version": "1.0.0",
        "id": "stepper-dot-1.0.0",
        "name": "JDSHorizontalStepItem",
        "layerName": "jds_horizontal_step_item",
        "internal": true
    },
    "hierarchy": {
        "stepper-outer-container": [
            {
                "stepper-inner-container": [
                    "start-jds_divider",
                    "jds_stepper_dot",
                    "end-jds_divider"
                ]
            },
            "label-jds-text"
        ]
    },
    "base": {
        "stepper-outer-container": {
            "flex-direction": "{h_0}",
            "align-items": "{h_1}",
            "justify-content": "{h_2}",
            "size": "{h_3}",
            "gap": "{h_4}"
        },
        "stepper-inner-container": {
            "flex-direction": "{h_5}",
            "width": "{h_6}",
            "align-items": "{h_7}",
            "gap": "{h_8}"
        },
        "start-jds_divider": {
            "pad": "none",
            "flex": 1,
            "withLabel": false,
            "hidden": false,
            "opacity": "{h_11}"
        },
        "end-jds_divider": {
            "pad": "none",
            "withLabel": false,
            "hidden": false,
            "flex": 1,
            "opacity": "{h_12}"
        },
        "label-jds-text": {
            "font-family": "{headingXxs}",
            "color": "{primaryGrey100}",
            "font-size": "{headingXxs}",
            "line-height": "{headingXxs}",
            "letter-spacing": "{headingXxs}",
            "font-weight": "{headingXxs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "padding-right": "{h_9}",
            "padding-left": "{h_10}"
        }
    },
    "variant": {
        "state": {
            "complete": {
                "end-jds_divider": {
                    "variant": "stepper"
                },
                "start-jds_divider": {
                    "variant": "stepper"
                }
            },
            "active": {
                "start-jds_divider": {
                    "variant": "stepper"
                }
            },
            "disabled": {
                "stepper-outer-container": {
                    "disabled": true
                },
                "jds_stepper_dot": {
                    "state": "disabled"
                }
            }
        },
        "direction": {
            "start": {
                "end-jds_divider": {
                    "opacity": "{h_13}"
                }
            },
            "end": {
                "start-jds_divider": {
                    "opacity": "{h_14}"
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "state": {
                "type": "JDSStepperDot.state",
                "values": [
                    "inactive",
                    "active",
                    "complete",
                    "disabled"
                ]
            },
            "itemsType": {
                "type": "JDSStepperDot.itemsType",
                "values": [
                    "numbered",
                    "icon",
                    "dot"
                ]
            },
            "direction": {
                "values": [
                    "both",
                    "start",
                    "end"
                ]
            }
        },
        "data": {
            "jds_stepper_dot": {
                "index": {
                    "type": "string",
                    "name": "index"
                },
                "icon": {
                    "type": "icon",
                    "name": "icon"
                },
                "state": {
                    "type": "JDSStepperDot.state",
                    "name": "state"
                },
                "itemsType": {
                    "type": "JDSStepperDot.itemsType",
                    "name": "itemsType"
                },
                "activeState": {
                    "type": "JDSStepperDot.activeState",
                    "name": "activeState"
                }
            },
            "label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            }
        },
        "a11y": {
            "stepper-outer-container": {
                "properties": {
                    "role": {
                        "value": "listitem"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-current": {
                        "name": "ariaCurrent"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1g = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$1i = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1e;
    const { state: state = "undefined", itemsType: itemsType = "undefined", direction: direction = "both", ariaLabel: ariaLabel = props.label?.toString(), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            state: state,
            itemsType: itemsType,
            direction: direction,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSHorizontalStepItem", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$210661c11db5ef0f = $fe5170bdd3625759$var$withLogic$1g($fe5170bdd3625759$var$Component$1i);
$fe5170bdd3625759$export$210661c11db5ef0f.displayName = "HorizontalStepItem";
$fe5170bdd3625759$export$210661c11db5ef0f.slotName = "jds_horizontal_step_item";
const $fe5170bdd3625759$var$sdl$1d = {
    "metadata": {
        "version": "1.0.0",
        "id": "image-1.0.0",
        "name": "JDSImage",
        "layerName": "jds_image"
    },
    "hierarchy": {
        "container": [
            "image",
            "lottie",
            "icon",
            "provider-slot",
            {
                "skeleton-container": [
                    "skeleton-slot"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "background-color": "{i_0}",
            "flex-direction": "{i_1}",
            "justify-content": "{i_2}",
            "align-items": "{i_3}",
            "width": "{i_4}",
            "height": "{i_5}",
            "border-radius": "{i_6}",
            "overflow": "hidden"
        },
        "image": {
            "hidden": false,
            "width": "{i_9}",
            "object-position": "center",
            "object-fit": "cover",
            "aspect-ratio": "{i_7}",
            "border-radius": "{i_8}",
            "z-index": 0
        },
        "lottie": {
            "hidden": true,
            "size": "{i_10}",
            "repeat": true
        },
        "icon": {
            "hidden": true,
            "value": "ic_broken_image",
            "size": "{i_11}",
            "color": "{i_12}",
            "z-index": 1
        },
        "provider-slot": {
            "hidden": true,
            "width": "{i_13}"
        },
        "skeleton-container": {
            "hidden": true,
            "z-index": 1,
            "aspect-ratio": "{i_14}",
            "width": "{i_15}"
        },
        "skeleton-slot": {
            "size": "{i_16}"
        }
    },
    "variant": {
        "contentScale": {
            "contain": {
                "image": {
                    "object-fit": "contain"
                }
            },
            "fill": {
                "image": {
                    "object-fit": "fill"
                }
            },
            "fit": {
                "image": {
                    "object-fit": "fit"
                }
            },
            "fill_height": {
                "image": {
                    "object-fit": "fill_height"
                }
            },
            "fill_width": {
                "image": {
                    "object-fit": "fill_width"
                }
            },
            "none": {
                "image": {
                    "object-fit": "none"
                }
            }
        },
        "imageFocus": {
            "left": {
                "image": {
                    "object-position": "left"
                }
            },
            "right": {
                "image": {
                    "object-position": "right"
                }
            },
            "top": {
                "image": {
                    "object-position": "top"
                }
            },
            "bottom": {
                "image": {
                    "object-position": "bottom"
                }
            }
        },
        "_state": {
            "loading": {
                "container": {
                    "background-color": "{i_17}"
                },
                "image": {
                    "opacity": "{i_18}"
                },
                "skeleton-container": {
                    "hidden": false
                }
            },
            "empty": {
                "container": {
                    "background-color": "{i_19}"
                },
                "image": {
                    "opacity": "{i_20}"
                },
                "icon": {
                    "hidden": false,
                    "value": "ic_image"
                }
            },
            "error": {
                "container": {
                    "background-color": "{i_21}"
                },
                "image": {
                    "opacity": "{i_22}"
                },
                "icon": {
                    "hidden": false
                }
            }
        },
        "_isLottieVisible": {
            "true": {
                "lottie": {
                    "hidden": false
                },
                "image": {
                    "hidden": true
                },
                "icon": {
                    "hidden": true
                },
                "skeleton-container": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {
            "round": {
                "true": {
                    "container": {
                        "border-radius": "1000"
                    },
                    "image": {
                        "border-radius": "1000"
                    }
                },
                "false": {
                    "container": {
                        "border-radius": "1000"
                    },
                    "image": {
                        "border-radius": "1000"
                    }
                }
            },
            "square": {
                "false": {
                    "container": {
                        "border-radius": "0"
                    },
                    "image": {
                        "border-radius": "0"
                    }
                }
            },
            "horizontal_4_3": {
                "true": {
                    "image": {
                        "aspect-ratio": "{i_23}"
                    },
                    "skeleton-container": {
                        "aspect-ratio": "{i_24}"
                    }
                },
                "false": {
                    "container": {
                        "border-radius": "0"
                    },
                    "image": {
                        "border-radius": "0",
                        "aspect-ratio": "{i_25}"
                    },
                    "skeleton-container": {
                        "aspect-ratio": "{i_26}"
                    }
                }
            },
            "horizontal_5_4": {
                "true": {
                    "image": {
                        "aspect-ratio": "{i_27}"
                    },
                    "skeleton-container": {
                        "aspect-ratio": "{i_28}"
                    }
                },
                "false": {
                    "container": {
                        "border-radius": "0"
                    },
                    "image": {
                        "border-radius": "0",
                        "aspect-ratio": "{i_29}"
                    },
                    "skeleton-container": {
                        "aspect-ratio": "{i_30}"
                    }
                }
            },
            "horizontal_16_9": {
                "true": {
                    "image": {
                        "aspect-ratio": "{i_31}"
                    },
                    "skeleton-container": {
                        "aspect-ratio": "{i_32}"
                    }
                },
                "false": {
                    "container": {
                        "border-radius": "0"
                    },
                    "image": {
                        "border-radius": "0",
                        "aspect-ratio": "{i_33}"
                    },
                    "skeleton-container": {
                        "aspect-ratio": "{i_34}"
                    }
                }
            },
            "vertical_4_5": {
                "true": {
                    "image": {
                        "aspect-ratio": "{i_35}"
                    },
                    "skeleton-container": {
                        "aspect-ratio": "{i_36}"
                    }
                },
                "false": {
                    "container": {
                        "border-radius": "0"
                    },
                    "image": {
                        "border-radius": "0",
                        "aspect-ratio": "{i_37}"
                    },
                    "skeleton-container": {
                        "aspect-ratio": "{i_38}"
                    }
                }
            },
            "vertical_3_4": {
                "true": {
                    "image": {
                        "aspect-ratio": "{i_39}"
                    },
                    "skeleton-container": {
                        "aspect-ratio": "{i_40}"
                    }
                },
                "false": {
                    "container": {
                        "border-radius": "0"
                    },
                    "image": {
                        "border-radius": "0",
                        "aspect-ratio": "{i_41}"
                    },
                    "skeleton-container": {
                        "aspect-ratio": "{i_42}"
                    }
                }
            },
            "vertical_9_16": {
                "true": {
                    "image": {
                        "aspect-ratio": "{i_43}"
                    },
                    "skeleton-container": {
                        "aspect-ratio": "{i_44}"
                    }
                },
                "false": {
                    "container": {
                        "border-radius": "0"
                    },
                    "image": {
                        "border-radius": "0",
                        "aspect-ratio": "{i_45}"
                    },
                    "skeleton-container": {
                        "aspect-ratio": "{i_46}"
                    }
                }
            },
            "horizontal_2_75__1": {
                "true": {
                    "container": {
                        "border-radius": "0"
                    },
                    "image": {
                        "border-radius": "0",
                        "aspect-ratio": "{i_47}"
                    },
                    "skeleton-container": {
                        "aspect-ratio": "{i_48}"
                    }
                },
                "false": {
                    "container": {
                        "border-radius": "0"
                    },
                    "image": {
                        "border-radius": "0",
                        "aspect-ratio": "{i_49}"
                    },
                    "skeleton-container": {
                        "aspect-ratio": "{i_50}"
                    }
                }
            },
            "none": {
                "true": {
                    "image": {
                        "aspect-ratio": ""
                    },
                    "skeleton-container": {
                        "aspect-ratio": ""
                    }
                },
                "false": {
                    "container": {
                        "border-radius": "0"
                    },
                    "image": {
                        "border-radius": "0",
                        "aspect-ratio": ""
                    },
                    "skeleton-container": {
                        "aspect-ratio": ""
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "aspectRatio",
            "roundedCorner"
        ]
    ],
    "api": {
        "config": {
            "aspectRatio": {
                "values": [
                    "square",
                    "round",
                    "horizontal_4_3",
                    "horizontal_5_4",
                    "horizontal_16_9",
                    "vertical_4_5",
                    "vertical_3_4",
                    "vertical_9_16",
                    "horizontal_2_75__1",
                    "none"
                ],
                "doc_description": "It can be used to change the aspect ratio of Image. 'round' takes the '1:1' aspect ratio as default."
            },
            "roundedCorner": {
                "values": [
                    true,
                    false
                ],
                "doc_description": "Border radius on image. This is `True` by default for all aspect ratios except `aspectRatio='horizontal_2_75__1'`. `horizontal_2_75__1` doesn't accept rounded corner."
            },
            "contentScale": {
                "values": [
                    "cover",
                    "contain",
                    "fit",
                    "fill",
                    "fill_height",
                    "fill_width",
                    "none"
                ]
            },
            "imageFocus": {
                "values": [
                    "center",
                    "left",
                    "right",
                    "top",
                    "bottom"
                ],
                "doc_description": "It can be used for reposition of the Image."
            },
            "_state": {
                "values": [
                    "loaded",
                    "loading",
                    "empty",
                    "error"
                ]
            },
            "_isLottieVisible": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "container": {
                "_image.alt": {
                    "type": "string",
                    "name": "alt",
                    "platform": "web",
                    "function": true
                },
                "width": {
                    "type": "size",
                    "name": "width",
                    "platform": "ios"
                },
                "height": {
                    "type": "size",
                    "name": "height",
                    "platform": "ios"
                },
                "border-radius": {
                    "type": "size",
                    "name": "borderRadius",
                    "function": true,
                    "required": false
                }
            },
            "image": {
                "value": {
                    "type": "image",
                    "name": "src",
                    "function": true
                },
                "border-radius": {
                    "type": "size",
                    "name": "borderRadius",
                    "function": true,
                    "required": false
                },
                "semantics": {
                    "type": "string",
                    "name": "semantics",
                    "platform": "android",
                    "required": false
                },
                "coil_image_loader": {
                    "type": "imageLoader",
                    "name": "imageLoader",
                    "required": false,
                    "platform": "android"
                },
                "title": {
                    "type": "string",
                    "name": "title",
                    "platform": "web"
                }
            },
            "lottie": {
                "value": {
                    "type": "image",
                    "name": "src",
                    "function": true
                },
                "attributes": {
                    "type": "object",
                    "name": "lottieAttributes",
                    "platform": "android, ios",
                    "required": false,
                    "object": {
                        "repeatCount": "number",
                        "maxRetryCount": "number",
                        "speed": "float",
                        "isPlaying": "boolean",
                        "reverseOnRepeat": "boolean",
                        "clipSpec": "LottieClipSpec"
                    }
                }
            }
        },
        "events": {
            "image": {
                "onClick": "onClick",
                "onHover": {
                    "name": "onHover",
                    "platform": "web"
                },
                "onError": "onError",
                "onLoad": "onLoad",
                "onEmpty": "onEmpty",
                "onLoading": "onLoading"
            }
        },
        "children": {
            "provider-slot": {
                "name": "provider",
                "accepts": [
                    "any"
                ],
                "max": 1
            },
            "skeleton-slot": {
                "name": "skeleton",
                "accepts": [
                    "jds_skeleton"
                ],
                "max": 1
            }
        },
        "a11y": {
            "image": {
                "properties": {
                    "role": {
                        "value": "img"
                    },
                    "aria-label": {
                        "name": "ariaLabel"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$sdl$1c = {
    "metadata": {
        "version": "1.0.0",
        "id": "skeleton-1.0.0",
        "name": "JDSSkeleton",
        "layerName": "jds_skeleton"
    },
    "hierarchy": {
        "container": [
            "skeletonLoader"
        ]
    },
    "base": {
        "container": {
            "hidden": false,
            "background-color": "{s_0}",
            "show": true,
            "overflow": "hidden"
        },
        "skeletonLoader": {
            "primary-color": "{s_1}",
            "secondary-color": "{s_2}",
            "hidden": true
        }
    },
    "variant": {
        "shape": {
            "circle": {
                "container": {
                    "aspect-ratio": "1",
                    "border-radius": "{s_3}"
                }
            },
            "heading": {
                "container": {
                    "height": "{s_4}",
                    "border-radius": "{s_5}"
                }
            },
            "paragraph": {
                "container": {
                    "border-radius": "{s_6}",
                    "height": "{s_7}"
                }
            },
            "rectangle": {
                "container": {
                    "border-radius": "{s_8}",
                    "aspect-ratio": "1.77"
                }
            },
            "square": {
                "container": {
                    "border-radius": "{s_9}",
                    "aspect-ratio": "1"
                }
            },
            "custom": {
                "container": {
                    "width": "{s_10}",
                    "height": "{s_11}"
                }
            }
        },
        "animated": {
            "true": {
                "skeletonLoader": {
                    "hidden": false
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "data": {
            "container": {
                "width": {
                    "type": "size",
                    "name": "width",
                    "function": true,
                    "doc_description": "It can be used to determine width of all shapes od Skeleton."
                }
            }
        },
        "config": {
            "shape": {
                "values": [
                    "circle",
                    "heading",
                    "paragraph",
                    "rectangle",
                    "square",
                    "custom"
                ],
                "doc_description": "It is used to determine the shape of Skeleton."
            },
            "animated": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to add animantionto Skeleton."
            }
        },
        "a11y": {
            "container": {
                "name": "skeleton",
                "properties": {
                    "aria-busy": {
                        "name": "_ariaBusy",
                        "prop": "animated"
                    },
                    "aria-label": {
                        "name": "_ariaLabel",
                        "platform": "android"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1f = (Component)=>(props)=>{
        if (props.shape === "custom" && !props.__noCustomWarn__) console.warn("shape=custom is an internal variant. Please do not use it");
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props
            },
            width: props.width
        });
    };
const $fe5170bdd3625759$var$Component$1h = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1c;
    const { shape: shape = "circle", animated: animated = false, _ariaBusy: _ariaBusy = props.animated?.toString(), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            shape: shape,
            animated: animated,
            _ariaBusy: _ariaBusy,
            ...rest
        },
        componentTag: componentTag
    }, "JDSSkeleton", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$8f31e4c4a37b8e9c = $fe5170bdd3625759$var$withLogic$1f($fe5170bdd3625759$var$Component$1h);
$fe5170bdd3625759$export$8f31e4c4a37b8e9c.displayName = "Skeleton";
$fe5170bdd3625759$export$8f31e4c4a37b8e9c.slotName = "jds_skeleton";
const $fe5170bdd3625759$var$legacyAspectRatios = [
    "1:1",
    "round",
    "4:3",
    "5:4",
    "16:9",
    "4:5",
    "3:4",
    "9:16",
    "2.75:1"
];
const $fe5170bdd3625759$var$PROP_MAP$j = (props)=>{
    if ($fe5170bdd3625759$var$legacyAspectRatios.includes(props.aspectRatio)) console.warn("these values for aspect ratios are deprectaed", $fe5170bdd3625759$var$legacyAspectRatios);
    return {
        aspectRatio: {
            variations: {
                "1:1": {
                    aspectRatio: "square"
                },
                "4:3": {
                    aspectRatio: "horizontal_4_3"
                },
                "5:4": {
                    aspectRatio: "horizontal_5_4"
                },
                "16:9": {
                    aspectRatio: "horizontal_16_9"
                },
                "4:5": {
                    aspectRatio: "vertical_4_5"
                },
                "3:4": {
                    aspectRatio: "vertical_3_4"
                },
                "9:16": {
                    aspectRatio: "vertical_9_16"
                },
                "2.75:1": {
                    aspectRatio: "horizontal_2_75__1"
                }
            }
        },
        src: {
            properties: {
                src: props.src
            }
        },
        alt: {
            properties: {
                semantics: props.alt
            }
        }
    };
};
const $fe5170bdd3625759$var$withLogic$1e = (Component)=>(userProps)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$j);
        const { src: src, onLoad: onLoad, onError: onError, ...rest } = props;
        const [imageStates, setImageStates] = (0, $acw62.useState)({
            error: false,
            loaded: false
        });
        const { error: error, loaded: loaded } = imageStates;
        const hasSrc = Boolean(src);
        const isBroken = hasSrc && loaded && error;
        const handleLoad = (e)=>{
            setImageStates({
                error: false,
                loaded: true
            });
            onLoad?.(e);
        };
        const handleError = (e)=>{
            if (!imageStates.error) {
                setImageStates({
                    error: true,
                    loaded: true
                });
                onError?.(e);
            }
        };
        const provider = ()=>{
            if (rest.provider) {
                const provider2 = rest.provider;
                return (0, $acw62.cloneElement)(rest?.provider, {
                    onLoad: (e)=>{
                        handleLoad(e);
                        provider2?.onLoad?.(e);
                    },
                    onError: (e)=>{
                        handleError(e);
                        provider2?.onError?.(e);
                    },
                    src: rest.provider?.props?.src || src
                });
            }
            return null;
        };
        const currentState = !hasSrc ? "empty" : isBroken ? "error" : loaded ? "loaded" : "loading";
        const formatImageName = (imagePath = props.src || "")=>{
            const parts = imagePath.split("/");
            const imageName = parts.length > 0 ? parts[parts.length - 1] : "";
            if (imageName) {
                const formattedName = imageName.replace(/\..*$/, "").replace(/([A-Z])/g, " $1").toLowerCase() + " image";
                return formattedName;
            }
            return "Image name not found";
        };
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...rest,
                skeleton: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$8f31e4c4a37b8e9c, {
                    shape: "custom",
                    animated: true,
                    width: "100%",
                    __noCustomWarn__: true
                }),
                _state: currentState,
                _loaderWidth: "100%",
                title: props.title || formatImageName(props.src),
                onLoad: handleLoad,
                onError: handleError,
                provider: provider() ?? void 0,
                _hasProvider: Boolean(rest.provider && currentState === "loaded"),
                src: rest?.provider?.props?.src || src || {},
                ariaLabel: props.ariaLabel || formatImageName(props.src)
            }
        });
    };
const $fe5170bdd3625759$var$Component$1g = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1d;
    const { aspectRatio: aspectRatio = "square", roundedCorner: roundedCorner = true, contentScale: contentScale = "cover", imageFocus: imageFocus = "center", onClick: onClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onHover: onHover = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onError: onError = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onLoad: onLoad = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onEmpty: onEmpty = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onLoading: onLoading = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            aspectRatio: aspectRatio,
            roundedCorner: roundedCorner,
            contentScale: contentScale,
            imageFocus: imageFocus,
            onClick: onClick,
            onHover: onHover,
            onError: onError,
            onLoad: onLoad,
            onEmpty: onEmpty,
            onLoading: onLoading,
            ...rest
        },
        componentTag: componentTag
    }, "JDSImage", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$3e431a229df88919 = $fe5170bdd3625759$var$withLogic$1e($fe5170bdd3625759$var$Component$1g);
$fe5170bdd3625759$export$3e431a229df88919.displayName = "Image";
$fe5170bdd3625759$export$3e431a229df88919.slotName = "jds_image";
const $fe5170bdd3625759$var$sdl$1b = {
    "metadata": {
        "version": "1.0.0",
        "id": "input-1.0.0",
        "name": "JDSInput",
        "layerName": "jds_input"
    },
    "hierarchy": {
        "input": []
    },
    "base": {
        "input": {
            "type": "text",
            "text-align": "{i_0}",
            "placeholder-color": "{i_1}",
            "placeholder-font-family": "{i_2}",
            "placeholder-font-size": "{i_3}",
            "placeholder-line-height": "{i_5}",
            "placeholder-font-weight": "{i_4}",
            "input-color": "{i_7}",
            "input-font-family": "{i_8}",
            "input-font-size": "{i_9}",
            "input-line-height": "{i_11}",
            "input-font-weight": "{i_10}",
            "cursor-color": "{i_13}",
            "disabled": false,
            "width": "{i_14}"
        }
    },
    "variant": {
        "disabled": {
            "true": {
                "input": {
                    "opacity": "{i_15}",
                    "disabled": true
                }
            }
        },
        "type": {
            "email": {
                "input": {
                    "type": "email"
                }
            },
            "number": {
                "input": {
                    "type": "number"
                }
            },
            "password": {
                "input": {
                    "type": "password"
                }
            },
            "textarea": {
                "input": {
                    "type": "textarea"
                }
            },
            "pin": {
                "input": {
                    "type": "pin"
                }
            },
            "phone": {
                "input": {
                    "type": "phone"
                }
            }
        },
        "color": {
            "primary_80": {
                "input": {
                    "input-color": "{i_27}"
                }
            },
            "primary_70": {
                "input": {
                    "input-color": "{i_28}"
                }
            },
            "primary_60": {
                "input": {
                    "input-color": "{i_29}"
                }
            },
            "primary_50": {
                "input": {
                    "input-color": "{i_30}"
                }
            },
            "primary_40": {
                "input": {
                    "input-color": "{i_31}"
                }
            },
            "primary_30": {
                "input": {
                    "input-color": "{i_32}"
                }
            },
            "primary_20": {
                "input": {
                    "input-color": "{i_33}"
                }
            },
            "primary_inverse": {
                "input": {
                    "input-color": "{i_34}"
                }
            },
            "primary_background": {
                "input": {
                    "input-color": "{i_35}"
                }
            },
            "primary_grey_100": {
                "input": {
                    "input-color": "{i_36}"
                }
            },
            "primary_grey_80": {
                "input": {
                    "input-color": "{i_37}"
                }
            },
            "primary_grey_60": {
                "input": {
                    "input-color": "{i_38}"
                }
            },
            "primary_grey_40": {
                "input": {
                    "input-color": "{i_39}"
                }
            },
            "primary_grey_20": {
                "input": {
                    "input-color": "{i_40}"
                }
            },
            "secondary_80": {
                "input": {
                    "input-color": "{i_41}"
                }
            },
            "secondary_70": {
                "input": {
                    "input-color": "{i_42}"
                }
            },
            "secondary_60": {
                "input": {
                    "input-color": "{i_43}"
                }
            },
            "secondary_50": {
                "input": {
                    "input-color": "{i_44}"
                }
            },
            "secondary_40": {
                "input": {
                    "input-color": "{i_45}"
                }
            },
            "secondary_30": {
                "input": {
                    "input-color": "{i_46}"
                }
            },
            "secondary_20": {
                "input": {
                    "input-color": "{i_47}"
                }
            },
            "secondary_inverse": {
                "input": {
                    "input-color": "{i_48}"
                }
            },
            "secondary_background": {
                "input": {
                    "input-color": "{i_49}"
                }
            },
            "secondary_grey_100": {
                "input": {
                    "input-color": "{i_50}"
                }
            },
            "secondary_grey_80": {
                "input": {
                    "input-color": "{i_51}"
                }
            },
            "secondary_grey_60": {
                "input": {
                    "input-color": "{i_52}"
                }
            },
            "secondary_grey_40": {
                "input": {
                    "input-color": "{i_53}"
                }
            },
            "secondary_grey_20": {
                "input": {
                    "input-color": "{i_54}"
                }
            },
            "sparkle_80": {
                "input": {
                    "input-color": "{i_55}"
                }
            },
            "sparkle_70": {
                "input": {
                    "input-color": "{i_56}"
                }
            },
            "sparkle_60": {
                "input": {
                    "input-color": "{i_57}"
                }
            },
            "sparkle_50": {
                "input": {
                    "input-color": "{i_58}"
                }
            },
            "sparkle_40": {
                "input": {
                    "input-color": "{i_59}"
                }
            },
            "sparkle_30": {
                "input": {
                    "input-color": "{i_60}"
                }
            },
            "sparkle_20": {
                "input": {
                    "input-color": "{i_61}"
                }
            },
            "sparkle_inverse": {
                "input": {
                    "input-color": "{i_62}"
                }
            },
            "sparkle_background": {
                "input": {
                    "input-color": "{i_63}"
                }
            },
            "sparkle_grey_100": {
                "input": {
                    "input-color": "{i_64}"
                }
            },
            "sparkle_grey_80": {
                "input": {
                    "input-color": "{i_65}"
                }
            },
            "sparkle_grey_60": {
                "input": {
                    "input-color": "{i_66}"
                }
            },
            "sparkle_grey_40": {
                "input": {
                    "input-color": "{i_67}"
                }
            },
            "sparkle_grey_20": {
                "input": {
                    "input-color": "{i_68}"
                }
            },
            "feedback_error_80": {
                "input": {
                    "input-color": "{i_69}"
                }
            },
            "feedback_error_50": {
                "input": {
                    "input-color": "{i_70}"
                }
            },
            "feedback_error_20": {
                "input": {
                    "input-color": "{i_71}"
                }
            },
            "feedback_warning_80": {
                "input": {
                    "input-color": "{i_72}"
                }
            },
            "feedback_warning_50": {
                "input": {
                    "input-color": "{i_73}"
                }
            },
            "feedback_warning_20": {
                "input": {
                    "input-color": "{i_74}"
                }
            },
            "feedback_success_80": {
                "input": {
                    "input-color": "{i_75}"
                }
            },
            "feedback_success_50": {
                "input": {
                    "input-color": "{i_76}"
                }
            },
            "feedback_success_20": {
                "input": {
                    "input-color": "{i_77}"
                }
            },
            "white": {
                "input": {
                    "input-color": "{i_78}"
                }
            },
            "black": {
                "input": {
                    "input-color": "{i_79}"
                }
            },
            "transparent": {
                "input": {
                    "input-color": "{i_80}"
                }
            }
        },
        "textAlign": {
            "center": {
                "input": {
                    "text-align": "{i_16}"
                }
            },
            "end": {
                "input": {
                    "text-align": "{i_17}"
                }
            },
            "justify": {
                "input": {
                    "text-align": "{i_18}"
                }
            }
        },
        "textSize": {
            "large": {
                "input": {
                    "placeholder-font-family": "{i_19}",
                    "placeholder-font-size": "{i_20}",
                    "placeholder-line-height": "{i_21}",
                    "placeholder-font-weight": "{i_22}",
                    "input-font-family": "{i_23}",
                    "input-font-size": "{i_24}",
                    "input-line-height": "{i_25}",
                    "input-font-weight": "{i_26}"
                }
            }
        },
        "readOnly": {
            "true": {
                "container": {
                    "disabled": true
                },
                "input": {
                    "disabled": true
                }
            }
        }
    },
    "api": {
        "config": {
            "disabled": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to enable or disable Input."
            },
            "color": {
                "values": [
                    "primary_grey_100",
                    "primary_80",
                    "primary_70",
                    "primary_60",
                    "primary_50",
                    "primary_40",
                    "primary_30",
                    "primary_20",
                    "primary_inverse",
                    "primary_background",
                    "primary_grey_80",
                    "primary_grey_60",
                    "primary_grey_40",
                    "primary_grey_20",
                    "secondary_80",
                    "secondary_70",
                    "secondary_60",
                    "secondary_50",
                    "secondary_40",
                    "secondary_30",
                    "secondary_20",
                    "secondary_inverse",
                    "secondary_background",
                    "secondary_grey_100",
                    "secondary_grey_80",
                    "secondary_grey_60",
                    "secondary_grey_40",
                    "secondary_grey_20",
                    "sparkle_80",
                    "sparkle_70",
                    "sparkle_60",
                    "sparkle_50",
                    "sparkle_40",
                    "sparkle_30",
                    "sparkle_20",
                    "sparkle_inverse",
                    "sparkle_background",
                    "sparkle_grey_100",
                    "sparkle_grey_80",
                    "sparkle_grey_60",
                    "sparkle_grey_40",
                    "sparkle_grey_20",
                    "feedback_error_80",
                    "feedback_error_50",
                    "feedback_error_20",
                    "feedback_warning_80",
                    "feedback_warning_50",
                    "feedback_warning_20",
                    "feedback_success_80",
                    "feedback_success_50",
                    "feedback_success_20",
                    "white",
                    "black",
                    "transparent"
                ],
                "doc_description": "It can be used to add font-color to Input text."
            },
            "type": {
                "values": [
                    "text",
                    "email",
                    "number",
                    "password",
                    "textarea",
                    "pin",
                    "phone"
                ],
                "doc_description": "This is used to specify the type of input."
            },
            "textAlign": {
                "values": [
                    "start",
                    "center",
                    "end",
                    "justify"
                ],
                "doc_description": "It can be used to align text of the Input."
            },
            "textSize": {
                "values": [
                    "small",
                    "large"
                ]
            },
            "readOnly": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "input": {
                "id": {
                    "type": "string",
                    "name": "id",
                    "platform": "web"
                },
                "autocomplete": {
                    "type": "string",
                    "name": "autocomplete",
                    "platform": "web"
                },
                "value": {
                    "type": "string",
                    "name": "value"
                },
                "placeholder": {
                    "type": "string",
                    "name": "placeholder"
                },
                "max-length": {
                    "type": "number",
                    "name": "maxLength"
                },
                "pattern": {
                    "type": "string",
                    "name": "pattern"
                },
                "rows": {
                    "type": "number",
                    "name": "rows"
                },
                "name": {
                    "type": "string",
                    "name": "name"
                },
                "min": {
                    "type": "number",
                    "name": "min"
                },
                "placeholder-letter-spacing": {
                    "type": "double",
                    "name": "letterSpacing",
                    "default": -0.5
                },
                "input-letter-spacing": {
                    "type": "double",
                    "name": "letterSpacing",
                    "default": -0.5
                },
                "autoFocus": {
                    "type": "boolean",
                    "name": "autoFocus",
                    "platform": "web,ios"
                },
                "max": {
                    "type": "number",
                    "name": "max"
                },
                "required": {
                    "type": "boolean",
                    "name": "required"
                },
                "focusRequester": {
                    "type": "focusRequester",
                    "name": "focusRequester",
                    "platform": "android"
                },
                "imeAction": {
                    "type": "imeAction",
                    "name": "imeAction",
                    "platform": "android"
                },
                "capitalization": {
                    "type": "keyboardCapitalization",
                    "name": "capitalization",
                    "platform": "android"
                },
                "semantics": {
                    "type": "string",
                    "name": "semantics",
                    "platform": "android"
                }
            }
        },
        "events": {
            "input": {
                "onFocus": "onFocus",
                "onBlur": "onBlur",
                "onChange": "onChange",
                "onSubmit": "onSubmit",
                "onKeyup": {
                    "name": "onKeyup",
                    "platform": "web"
                },
                "onKeydown": {
                    "name": "onKeydown",
                    "platform": "web"
                },
                "onPaste": "onPaste",
                "onInvalid": "onInvalid"
            }
        },
        "a11y": {
            "input": {
                "properties": {
                    "aria-label": {
                        "name": "ariaLabel"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "aria-invalid": {
                        "name": "ariaInvalid"
                    },
                    "aria-placeholder": {
                        "name": "ariaPlaceholder",
                        "prop": "placeholder"
                    },
                    "aria-required": {
                        "name": "ariaRequired",
                        "prop": "required"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1d = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props
            }
        });
    };
const $fe5170bdd3625759$var$Component$1f = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1b;
    const { disabled: disabled = false, color: color = "primary_grey_100", type: type = "text", textAlign: textAlign = "start", textSize: textSize = "small", readOnly: readOnly = false, onFocus: onFocus = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onBlur: onBlur = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onChange: onChange = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSubmit: onSubmit = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onKeyup: onKeyup = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onPaste: onPaste = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onInvalid: onInvalid = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), ariaPlaceholder: ariaPlaceholder = props.placeholder?.toString(), ariaRequired: ariaRequired = props.required?.toString(), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            disabled: disabled,
            color: color,
            type: type,
            textAlign: textAlign,
            textSize: textSize,
            readOnly: readOnly,
            onFocus: onFocus,
            onBlur: onBlur,
            onChange: onChange,
            onSubmit: onSubmit,
            onKeyup: onKeyup,
            onPaste: onPaste,
            onInvalid: onInvalid,
            ariaPlaceholder: ariaPlaceholder,
            ariaRequired: ariaRequired,
            ...rest
        },
        componentTag: componentTag
    }, "JDSInput", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$var$Input = $fe5170bdd3625759$var$withLogic$1d($fe5170bdd3625759$var$Component$1f);
$fe5170bdd3625759$var$Input.displayName = "Input";
$fe5170bdd3625759$var$Input.slotName = "jds_input";
const $fe5170bdd3625759$var$sdl$1a = {
    "metadata": {
        "version": "1.0.0",
        "id": "checkbox-1.0.0",
        "name": "JDSCheckbox",
        "layerName": "jds_checkbox",
        "description": "Checkboxes are used within an interface to allow the user to select between one or more options."
    },
    "hierarchy": {
        "vertical-container": [
            {
                "horizontal-container": [
                    {
                        "control-container": [
                            "control-icon"
                        ]
                    },
                    "label-jds-text"
                ]
            },
            "jds_feedback_block",
            "helper-jds-text"
        ]
    },
    "base": {
        "vertical-container": {
            "hidden": false,
            "flex-direction": "{c_0}",
            "justify-content": "{c_1}",
            "align-items": "{c_2}",
            "gap": "{c_3}",
            "opacity": "{c_38}"
        },
        "horizontal-container": {
            "hidden": false,
            "flex-direction": "{c_4}",
            "justify-content": "{c_5}",
            "align-items": "{c_6}",
            "gap": "{c_7}",
            "behavior": {
                "hover": {},
                "active": {},
                "focus": {}
            }
        },
        "control-container": {
            "hidden": false,
            "min-width": "{c_8}",
            "min-height": "{c_9}",
            "flex-direction": "{c_10}",
            "justify-content": "{c_11}",
            "align-items": "{c_12}",
            "background-color": "{c_13}",
            "border-radius": "{c_14}",
            "border-width": "{c_15}",
            "border-color": "{c_16}",
            "show": true,
            "behavior": {
                "hover": {
                    "border-color": "{c_17}"
                },
                "active": {
                    "border-color": "{c_18}"
                },
                "focus": {
                    "border-width": "{c_19}",
                    "box-sizing": "content-box",
                    "border-color": "{c_20}"
                }
            }
        },
        "control-icon": {
            "hidden": true,
            "size": "{c_21}"
        },
        "jds_feedback_block": {
            "hidden": true,
            "state": "none",
            "size": "l"
        },
        "label-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false,
            "text-align": "{c_22}",
            "behavior": {
                "hover": {
                    "color": "{primaryGrey100}"
                },
                "focus": {
                    "color": "{primaryGrey100}"
                }
            }
        },
        "helper-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false
        }
    },
    "variant": {
        "size": {
            "small": {
                "control-container": {
                    "min-width": "{c_23}",
                    "min-height": "{c_24}"
                },
                "vertical-container": {
                    "gap": "{c_25}"
                },
                "control-icon": {
                    "size": "{c_26}"
                },
                "jds_feedback_block": {
                    "size": "s"
                },
                "label-jds-text": {
                    "font-family": "{bodyXs}",
                    "font-size": "{bodyXs}",
                    "line-height": "{bodyXs}",
                    "letter-spacing": "{bodyXs}",
                    "font-weight": "{bodyXs}"
                },
                "helper-jds-text": {
                    "font-family": "{bodyXs}",
                    "font-size": "{bodyXs}",
                    "line-height": "{bodyXs}",
                    "letter-spacing": "{bodyXs}",
                    "font-weight": "{bodyXs}"
                }
            }
        },
        "checked": {
            "true": {
                "control-container": {
                    "background-color": "{c_28}",
                    "border-width": 0,
                    "behavior": {
                        "hover": {
                            "background-color": "{c_29}"
                        },
                        "active": {
                            "background-color": "{c_30}"
                        }
                    }
                },
                "control-icon": {
                    "hidden": false,
                    "value": "{c_27}",
                    "color": "{c_31}"
                },
                "label-jds-text": {
                    "color": "{primaryGrey100}"
                }
            }
        },
        "indeterminate": {
            "true": {
                "control-container": {
                    "background-color": "{c_33}",
                    "border-width": 0,
                    "behavior": {
                        "hover": {
                            "background-color": "{c_34}"
                        },
                        "focus": {
                            "background-color": "{c_35}"
                        }
                    }
                },
                "control-icon": {
                    "hidden": false,
                    "value": "{c_32}",
                    "color": "{c_36}"
                },
                "label-jds-text": {
                    "color": "{primaryGrey100}"
                }
            }
        },
        "disabled": {
            "true": {
                "vertical-container": {
                    "opacity": "{c_37}"
                },
                "horizontal-container": {
                    "disabled": true
                }
            }
        },
        "state": {
            "success": {
                "jds_feedback_block": {
                    "hidden": false
                }
            },
            "error": {
                "jds_feedback_block": {
                    "hidden": false
                }
            },
            "warning": {
                "jds_feedback_block": {
                    "hidden": false
                }
            }
        }
    },
    "api": {
        "config": {
            "checked": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to programmatically make input active/inactive."
            },
            "indeterminate": {
                "values": [
                    false,
                    true
                ]
            },
            "size": {
                "values": [
                    "medium",
                    "small"
                ],
                "doc_description": "It can be used control the size of Checkbox."
            },
            "disabled": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to enable or disable Checkbox."
            }
        },
        "data": {
            "jds_feedback_block": {
                "stateText": {
                    "type": "string",
                    "name": "stateText",
                    "doc_description": "It displays message with respect to its [state] selected."
                },
                "state": {
                    "type": "JDSFeedbackBlock.state",
                    "name": "state",
                    "doc_description": "It can be used to choose between states i.e. 'success','warning','error','none'."
                }
            },
            "label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label",
                    "doc_description": "It displays label of Checkbox."
                }
            },
            "helper-jds-text": {
                "value": {
                    "type": "string",
                    "name": "helperText",
                    "doc_description": "It displays helper text of Checkbox."
                }
            }
        },
        "events": {
            "horizontal-container": {
                "onClick": "onClick"
            }
        },
        "a11y": {
            "horizontal-container": {
                "properties": {
                    "role": {
                        "value": "checkbox"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-checked": {
                        "name": "_ariaChecked"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
function $fe5170bdd3625759$var$checkInputMask(event, value, textMask, readonly, pattern) {
    if (readonly || !textMask) return "noop";
    if (!textMask && !pattern) return "noop";
    if ([
        "Tab",
        "Enter",
        "ArrowLeft",
        "ArrowRight"
    ].indexOf(event.key) > -1) return "noop";
    const prevValue = value || "";
    if (textMask && typeof prevValue === "string" || pattern) {
        if (event.code === "Backspace") return "back";
        const regex = textMask ? new RegExp($fe5170bdd3625759$var$getTextMaskValue(textMask)) : pattern ? new RegExp(pattern) : void 0;
        if (!regex?.test(event.key) || textMask && (event.currentTarget.value?.length || 0) >= textMask.length) return "prevent";
    }
    return "noop";
}
const $fe5170bdd3625759$var$maskCharToRegexMap = {
    "#": "\\d",
    "&": "[A-Za-z]",
    "*": "[A-Za-z\\d]"
};
const $fe5170bdd3625759$var$getTextMask = (textMask)=>{
    if (!textMask) return void 0;
    if (typeof textMask === "string") return textMask;
    if (typeof textMask[0] === "object") return new RegExp(textMask[0]).source;
    return textMask[0];
};
const $fe5170bdd3625759$var$getTextMaskValue = (textMask)=>{
    return textMask.split("").map((t)=>`(${$fe5170bdd3625759$var$maskCharToRegexMap[t] || t})`).join("|");
};
const $fe5170bdd3625759$var$stateValues = {
    error: {
        state: "error",
        stateText: "errorText"
    },
    success: {
        state: "success",
        stateText: "successText"
    },
    warning: {
        state: "warning",
        stateText: "warningText"
    },
    required: {
        state: "error",
        stateText: "requiredText"
    }
};
const $fe5170bdd3625759$var$injectAutofillCSS = ()=>{
    const style = document.createElement("style");
    style.textContent = `
    input:-webkit-autofill {
      animation-name: autofill-start;
      animation-duration: 0.01s;
      animation-iteration-count: 1;
    }
    @keyframes autofill-start { from {} to {} }
  `;
    document.head.appendChild(style);
};
const $fe5170bdd3625759$var$useFocusedLabel = (props, ref)=>{
    const [focused, setFocused] = (0, $acw62.useState)(false);
    const [inputFocused, setInputFocused] = (0, $acw62.useState)(false);
    const labelRef = ref?.querySelector(".j-JDSInputField-input_label-jds-text") || ref?.querySelector(".j-JDSTextarea-input_label-jds-text");
    (0, $acw62.useEffect)(()=>{
        $fe5170bdd3625759$var$injectAutofillCSS();
        const input = ref?.querySelector("input");
        const onAutoFill = (e)=>{
            if (e.animationName === "autofill-start") {
                labelRef?.classList?.add("position-top");
                setFocused(true);
            }
        };
        input?.addEventListener("animationstart", onAutoFill);
        return ()=>input?.removeEventListener("animationstart", onAutoFill);
    }, [
        ref
    ]);
    (0, $acw62.useEffect)(()=>{
        if (props.placeholder || props.value) labelRef?.classList?.add("position-top");
    }, [
        props.placeholder,
        labelRef,
        props.value
    ]);
    return {
        onChange: (ev)=>{
            setFocused(true);
            labelRef?.classList.add("position-top");
            props.onChange?.(ev);
        },
        onBlur: (ev)=>{
            if (!(ev.target.value || props.placeholder)) {
                setFocused(false);
                labelRef?.classList.remove("position-top");
            }
            props.onBlur?.(ev);
            setInputFocused(false);
        },
        onFocus: (ev)=>{
            setFocused(true);
            setInputFocused(true);
            props.onFocus?.(ev);
            labelRef?.classList.add("position-top");
        },
        focused: Boolean(props.value) || Boolean(props.placeholder) || focused,
        _inputFocused: inputFocused
    };
};
const $fe5170bdd3625759$var$useInputState = (state, required, onInvalid, stateConfig = {}, stateText)=>{
    const [inputState, setInputState] = (0, $acw62.useState)("none");
    (0, $acw62.useEffect)(()=>{
        if (!required) setInputState(state || "none");
    }, [
        state,
        required
    ]);
    const stateKey = $fe5170bdd3625759$var$stateValues?.[inputState || "none"]?.state;
    const stateTextKey = $fe5170bdd3625759$var$stateValues[inputState]?.stateText;
    return {
        onInvalid: (ev)=>{
            onInvalid?.(ev);
            if (required) setInputState("required");
            else setInputState("error");
        },
        inputState: state || stateKey,
        stateText: stateText || stateConfig?.[stateTextKey]
    };
};
const $fe5170bdd3625759$var$getRequiredLabel = (label = "", required)=>{
    return label + (required ? " *" : "");
};
const $fe5170bdd3625759$var$getIcon = (icon, onClick)=>{
    if (!icon) return void 0;
    if (typeof icon === "string") return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$f04a61298a47a40f, {
        onClick: onClick,
        ic: icon,
        color: "grey-80"
    });
    if (typeof icon === "object" && icon.component === "Icon") return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$f04a61298a47a40f, {
        onClick: onClick,
        ...icon.props,
        color: "grey-80"
    });
    if (icon.type?.displayName) return (0, $acw62.cloneElement)(icon, {
        color: "grey-80"
    });
    if (icon.props?.ic) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$f04a61298a47a40f, {
        onClick: onClick,
        ic: icon.props.ic,
        color: "grey-80",
        ...icon.props
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$f04a61298a47a40f, {
        onClick: onClick,
        ic: icon,
        color: "grey-80"
    });
};
const $fe5170bdd3625759$var$getPrefixWidth = (element)=>{
    const prefixContainer = element?.querySelector('div[data-testid="JDSInputField-prefix-container"]');
    const { width: width } = prefixContainer?.getBoundingClientRect() || {};
    return width || 0;
};
const $fe5170bdd3625759$var$withLogic$1c = (Component)=>(0, $acw62.forwardRef)((props, ref)=>{
        const { rootRef: rootRef, element: element } = $fe5170bdd3625759$var$useRootRef();
        const { focused: focused, _inputFocused: _inputFocused, ...rest } = $fe5170bdd3625759$var$useFocusedLabel(props, element);
        const { inputState: inputState, onInvalid: onInvalid, stateText: stateText } = $fe5170bdd3625759$var$useInputState(props.state, props.required, props.onInvalid, props.stateConfig);
        const handlePrefixClick = (event)=>{
            props.onPrefixClick?.(event);
        };
        const handleSuffixClick = (event)=>{
            props.onSuffixClick?.(event);
        };
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                ...rest,
                rootRef: rootRef,
                prefix: $fe5170bdd3625759$var$getIcon(props.prefix, handlePrefixClick),
                suffix: $fe5170bdd3625759$var$getIcon(props.suffix, handleSuffixClick),
                onInvalid: onInvalid,
                _labelOffset: $fe5170bdd3625759$var$getPrefixWidth(element) + 8,
                onKeydown: (ev)=>{
                    const allowedCharsForNumber = [
                        "1",
                        "2",
                        "3",
                        "4",
                        "5",
                        "6",
                        "7",
                        "8",
                        "9",
                        "0",
                        "e",
                        "-",
                        "+",
                        "."
                    ];
                    const allowedCharsForPhone = [
                        "1",
                        "2",
                        "3",
                        "4",
                        "5",
                        "6",
                        "7",
                        "8",
                        "9",
                        "0",
                        "(",
                        ")",
                        "-",
                        " ",
                        "+"
                    ];
                    if ([
                        "number",
                        "phone"
                    ].includes(props.type)) {
                        if ([
                            "Backspace",
                            "Enter",
                            "ArrowLeft",
                            "ArrowRight"
                        ].includes(ev.key)) return;
                        const allowedChars = props.type === "number" ? allowedCharsForNumber : allowedCharsForPhone;
                        !allowedChars.includes(ev.key) && ev.preventDefault();
                    }
                    if (props.pattern && typeof props.value === "string" || props.textMask) {
                        const action = $fe5170bdd3625759$var$checkInputMask(ev, props.value, $fe5170bdd3625759$var$getTextMask(props.textMask), props.readonly, props.pattern);
                        if (action === "prevent" || action === "back") {
                            ev.preventDefault();
                            if (action === "back") {
                                const currentValue = (ev.currentTarget.value || "")?.slice(0, -1);
                                const tracker = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value")?.set;
                                tracker?.call(ev.target, currentValue);
                                const event = {
                                    ...ev,
                                    target: {
                                        ...ev.target,
                                        value: currentValue
                                    }
                                };
                                props.onChange?.(event);
                            }
                            return;
                        }
                    }
                    props.onKeyDown?.(ev);
                },
                label: $fe5170bdd3625759$var$getRequiredLabel(props.label, props.required),
                _inputFocus: _inputFocused,
                state: inputState,
                stateText: props.stateText || stateText,
                _hasPrefix: Boolean(props.prefix),
                _hasSuffix: Boolean(props.suffix),
                _labelFocus: focused,
                layerRefs: {
                    input: ref
                }
            }
        });
    });
const $fe5170bdd3625759$var$withLogic$1b = (Component)=>(props)=>{
        const { stateText: stateText, inputState: inputState } = $fe5170bdd3625759$var$useInputState(props.state, false, void 0, props.stateConfig, props.stateText);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                _ariaChecked: props.indeterminate ? "mixed" : props.checked === true ? "true" : "false",
                _hasHelper: Boolean(props.helperText),
                state: inputState,
                stateText: stateText
            }
        });
    };
const $fe5170bdd3625759$var$Component$1e = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1a;
    const { checked: checked = false, indeterminate: indeterminate = false, size: size = "medium", disabled: disabled = false, onClick: onClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), ariaLabel: ariaLabel = props.label?.toString(), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            checked: checked,
            indeterminate: indeterminate,
            size: size,
            disabled: disabled,
            onClick: onClick,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSCheckbox", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$fa1253a65a9e747d = $fe5170bdd3625759$var$withLogic$1b($fe5170bdd3625759$var$Component$1e);
$fe5170bdd3625759$export$fa1253a65a9e747d.displayName = "InputCheckbox";
$fe5170bdd3625759$export$fa1253a65a9e747d.slotName = "jds_checkbox";
const $fe5170bdd3625759$var$sdl$19 = {
    "metadata": {
        "version": "1.0.0",
        "id": "Input-code-item-1.0.0",
        "name": "JDSInputCodeItem",
        "layerName": "jds_input_code_item",
        "internal": true
    },
    "hierarchy": {
        "input-container": [
            "jds_input",
            {
                "active-line-container": [
                    "feedback-container"
                ]
            }
        ]
    },
    "base": {
        "input-container": {
            "flex-direction": "{i_0}",
            "justify-content": "{i_1}",
            "align-items": "{i_2}",
            "gap": "{i_3}",
            "width": "{i_4}",
            "behavior": {
                "hover": {}
            }
        },
        "jds_input": {
            "width": "{i_5}",
            "type": "phone",
            "textAlign": "center",
            "textSize": "large",
            "maxLength": 1
        },
        "active-line-container": {
            "flex-direction": "{i_6}",
            "justify-content": "{i_7}",
            "align-items": "{i_8}",
            "width": "{i_9}",
            "padding-top": "{i_10}",
            "padding-bottom": "{i_11}"
        },
        "feedback-container": {
            "width": "{i_12}",
            "height": "{i_13}",
            "background-color": "{i_14}",
            "border-radius": "{i_15}",
            "show": true,
            "behavior": {
                "focus": {
                    "background-color": "{i_17}"
                },
                "active": {
                    "background-color": "{i_18}"
                }
            }
        }
    },
    "variant": {
        "state": {
            "success": {
                "feedback-container": {
                    "background-color": "{i_19}"
                }
            },
            "error": {
                "feedback-container": {
                    "background-color": "{i_20}"
                }
            },
            "warning": {
                "feedback-container": {
                    "background-color": "{i_21}"
                }
            }
        },
        "disabled": {
            "true": {
                "jds_input": {
                    "disabled": true
                }
            }
        },
        "secureText": {
            "true": {
                "jds_input": {
                    "type": "pin"
                }
            }
        },
        "autoComplete": {
            "true": {
                "jds_input": {
                    "autoComplete": "true"
                }
            }
        }
    },
    "combination": [
        {
            "none": {
                "true": {
                    "feedback-container": {
                        "background-color": "{i_22}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "state",
            "_inputFocus"
        ]
    ],
    "api": {
        "config": {
            "autoComplete": {
                "values": [
                    false,
                    true
                ],
                "platform": "web"
            },
            "secureText": {
                "values": [
                    false,
                    true
                ]
            },
            "state": {
                "type": "JDSFeedbackBlock.state",
                "values": [
                    "none",
                    "success",
                    "error",
                    "warning"
                ]
            },
            "_inputFocus": {
                "values": [
                    false,
                    true
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds_input": {
                "value": {
                    "type": "string",
                    "name": "value"
                },
                "placeholder": {
                    "type": "string",
                    "name": "placeholder"
                },
                "autocomplete": {
                    "type": "string",
                    "name": "autocomplete",
                    "platform": "web"
                },
                "required": {
                    "type": "boolean",
                    "name": "required"
                },
                "focusRequester": {
                    "type": "focusRequester",
                    "name": "focusRequester",
                    "platform": "android"
                }
            }
        },
        "events": {
            "jds_input": {
                "onFocus": "onFocus",
                "onBlur": "onBlur",
                "onChange": "onChange",
                "onSubmit": "onSubmit",
                "onKeydown": {
                    "name": "onKeydown",
                    "platform": "web"
                },
                "onPaste": "onPaste",
                "onInvalid": "onInvalid"
            }
        },
        "a11y": {
            "jds_input": {
                "properties": {
                    "ariaLabel": {
                        "name": "ariaLabel",
                        "platform": "android"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$1a = (Component)=>(props)=>{
        const [inputFocus, setInputFocus] = (0, $acw62.useState)(false);
        const handleFocus = (0, $acw62.useCallback)((ev)=>{
            setInputFocus(true);
            if (props.onFocus) props.onFocus(ev);
        }, [
            props.onFocus
        ]);
        const handleBlur = (0, $acw62.useCallback)((ev)=>{
            setInputFocus(false);
            if (props.onBlur) props.onBlur(ev);
        }, [
            props.onBlur
        ]);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props,
            _inputFocus: inputFocus,
            onFocus: handleFocus,
            onBlur: handleBlur
        });
    };
const $fe5170bdd3625759$var$Component$1d = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$19;
    const { autoComplete: autoComplete = false, secureText: secureText = false, state: state = "undefined", disabled: disabled = false, onFocus: onFocus = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onBlur: onBlur = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onChange: onChange = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSubmit: onSubmit = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onPaste: onPaste = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onInvalid: onInvalid = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            autoComplete: autoComplete,
            secureText: secureText,
            state: state,
            disabled: disabled,
            onFocus: onFocus,
            onBlur: onBlur,
            onChange: onChange,
            onSubmit: onSubmit,
            onPaste: onPaste,
            onInvalid: onInvalid,
            ...rest
        },
        componentTag: componentTag
    }, "JDSInputCodeItem", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$963da1aad44be4c4 = $fe5170bdd3625759$var$withLogic$1a($fe5170bdd3625759$var$Component$1d);
$fe5170bdd3625759$export$963da1aad44be4c4.displayName = "InputCodeItem";
$fe5170bdd3625759$export$963da1aad44be4c4.slotName = "jds_input_code_item";
const $fe5170bdd3625759$var$sdl$18 = {
    "metadata": {
        "version": "1.0.0",
        "id": "input_phone_dropdown-1.0.0",
        "name": "JDSInputPhoneDropdown",
        "layerName": "jds_input_phone_dropdown"
    },
    "hierarchy": {
        "vertical-container": [
            {
                "container": [
                    {
                        "prefix-jds-icon-container": [
                            "prefix-jds-icon"
                        ]
                    },
                    "country_code-jds-text",
                    {
                        "chevron-jds-icon-container": [
                            "chevron-jds-icon"
                        ]
                    }
                ]
            },
            "jds_menu_block"
        ]
    },
    "base": {
        "vertical-container": {
            "flex-direction": "{flexDirection.column}"
        },
        "container": {
            "flex-direction": "{flexDirection.row}",
            "gap": "{xxs}"
        },
        "jds_menu_block": {
            "open": false
        },
        "prefix-jds-icon": {
            "size": "{m}",
            "color": "{primary50}"
        },
        "prefix-jds-icon-container": {
            "background-color": "{global.transparent}",
            "border-radius": "{pill}",
            "size": "{m}",
            "justify-content": "{justifyContent.center}",
            "align-items": "{alignItems.center}"
        },
        "country_code-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 1,
            "maxLines": 1
        },
        "chevron-jds-icon": {
            "size": "{m}",
            "color": "{primaryGrey80}",
            "value": "ic_chevron_down",
            "ic": "ic_chevron_down"
        },
        "chevron-jds-icon-container": {
            "background-color": "{global.transparent}",
            "border-radius": "{pill}",
            "size": "{m}",
            "justify-content": "{justifyContent.center}",
            "align-items": "{alignItems.center}",
            "ic": "ic_chevron_down"
        }
    },
    "variant": {
        "open": {
            "true": {
                "jds_menu_block": {
                    "open": true
                },
                "chevron-jds-icon": {
                    "value": "ic_chevron_up",
                    "ic": "ic_chevron_up"
                },
                "chevron-jds-icon-container": {
                    "background-color": "{global.transparent}",
                    "border-radius": "{pill}",
                    "size": "{m}",
                    "justify-content": "{justifyContent.center}",
                    "align-items": "{alignItems.center}",
                    "ic": "ic_chevron_up"
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true
                }
            }
        }
    },
    "combination": [],
    "combination_config": [],
    "api": {
        "config": {
            "open": {
                "values": [
                    false,
                    true
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds_menu_block": {
                "items": {
                    "type": "list",
                    "name": "items",
                    "object": {
                        "type": "JDSMenuBlockItem.type",
                        "label": "string",
                        "value": "string",
                        "prefix": "icon",
                        "suffix": "icon",
                        "disabled": "boolean",
                        "selected": "boolean"
                    }
                },
                "selectedIndex": {
                    "type": "number",
                    "name": "selectedIndex"
                },
                "offsetX": {
                    "type": "size",
                    "name": "_offsetX"
                },
                "offsetY": {
                    "type": "size",
                    "name": "_offsetY"
                },
                "minWidth": {
                    "type": "size",
                    "name": "_minWidth"
                },
                "maxWidth": {
                    "type": "size",
                    "name": "_maxWidth"
                },
                "maxHeight": {
                    "type": "size",
                    "name": "_maxHeight"
                }
            },
            "country_code-jds-text": {
                "value": {
                    "type": "string",
                    "name": "countryCode"
                },
                "color": {
                    "type": "JDSText.color",
                    "name": "countryCodeColor"
                }
            },
            "prefix-jds-icon": {
                "value": {
                    "type": "icon",
                    "name": "countryFlag"
                },
                "ic": {
                    "type": "icon",
                    "name": "countryFlag"
                }
            }
        },
        "events": {
            "container": {
                "onClick": "onOpen",
                "onAppear": {
                    "name": "_onAppear",
                    "platform": "ios"
                }
            },
            "jds_menu_block": {
                "onSelect": {
                    "name": "onSelect",
                    "object": {
                        "index": "number",
                        "value": "string"
                    }
                },
                "onClose": "onClose"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "combobox"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "value": "Select Country Code"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "aria-expanded": {
                        "name": "_ariaExpanded",
                        "prop": "open"
                    },
                    "aria-controls": {
                        "name": "ariaControls",
                        "value": "container"
                    }
                }
            },
            "jds_menu_block": {
                "name": "items",
                "repeating": {
                    "ariaLabel": "itemAriaLabel",
                    "ariaDescribedby": {
                        "name": "itemAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$setPositions = (anchorEl, menuBlockref, stringMaxHeight)=>{
    let menuItemPositionY = 0;
    let menuItemPositionX;
    let maxCalculatedHeight = 0;
    if (anchorEl && window) {
        const { y: anchorTop, height: anchorHeight, x: anchorLeft, width: anchorWidth } = anchorEl.getBoundingClientRect();
        const { innerWidth: overlayWidth, innerHeight: overlayHeight } = window;
        let maxHeight = parseInt(stringMaxHeight || "");
        maxHeight = isNaN(maxHeight) ? overlayHeight - anchorTop : maxHeight;
        const { scrollHeight: menuHeight, scrollWidth: menuWidth } = menuBlockref || {
            scrollWidth: 0,
            scrollHeight: maxHeight || 0
        };
        const sectionBelowAnchor = overlayHeight - (anchorTop + anchorHeight);
        const sectionAboveAnchor = anchorTop;
        if (menuBlockref && sectionBelowAnchor <= (maxHeight || menuHeight) && sectionAboveAnchor > sectionBelowAnchor) {
            menuItemPositionY = anchorTop - menuHeight;
            if (menuItemPositionY < 0) {
                maxCalculatedHeight = anchorTop;
                menuItemPositionY = maxHeight ? anchorTop - maxHeight : menuHeight < anchorTop ? anchorTop - menuHeight : 0;
            }
        } else {
            maxCalculatedHeight = sectionBelowAnchor;
            menuItemPositionY = anchorTop + anchorHeight;
        }
        const availableHeight = sectionBelowAnchor > 0 ? sectionBelowAnchor : overlayHeight - anchorTop;
        maxHeight = Math.min(maxHeight, availableHeight);
        const hasHitRight = overlayWidth <= anchorLeft + menuWidth;
        menuItemPositionX = hasHitRight ? Math.max(anchorLeft + anchorWidth - menuWidth, 0) : anchorLeft;
        return {
            left: menuItemPositionX || 0,
            top: menuItemPositionY || 0,
            width: anchorWidth,
            height: (maxHeight || maxCalculatedHeight) - 10 - 14,
            maxHeight: (maxHeight || maxCalculatedHeight) - 10,
            overflowY: "auto"
        };
    }
    return {
        left: 0,
        top: 0,
        maxWidth: "fit-content",
        height: (maxCalculatedHeight || menuBlockref?.getBoundingClientRect()?.height || 0) - 10
    };
};
const $fe5170bdd3625759$var$withLogic$19 = (Component)=>(props)=>{
        const { element: element, rootRef: rootRef } = $fe5170bdd3625759$var$useRootRef();
        const [position, setPosition] = (0, $acw62.useState)({
            left: 0,
            top: 0
        });
        const updatePosition = ()=>{
            const menuBlockEl = element?.querySelector("div.j-JDSMenuBlock-container");
            return $fe5170bdd3625759$var$setPositions(element, menuBlockEl);
        };
        const { close: close, selected: selected, toggle: toggle } = $fe5170bdd3625759$var$useToggle(props.open, true);
        (0, $acw62.useEffect)(()=>{
            if (element && selected) {
                const { left: left, top: top } = updatePosition();
                setPosition({
                    left: left,
                    top: top
                });
            }
        }, [
            element,
            selected
        ]);
        const [selectedItem, setSelectedItem] = (0, $acw62.useState)(props.items?.[props.selectedIndex || 0]);
        const handleOnSelect = (selectedIndex)=>{
            const selectedData = props.items?.[selectedIndex];
            toggle();
            setSelectedItem(selectedData);
            props.onSelect?.(selectedIndex, selectedData?.value);
        };
        $fe5170bdd3625759$var$useScrollClose(close);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                rootRef: rootRef,
                _offsetX: position.left,
                _offsetY: position.top,
                _maxWidth: "fit-content",
                open: selected,
                items: props.items,
                countryCode: selectedItem?.label,
                countryFlag: selectedItem?.prefix,
                onSelect: handleOnSelect,
                onOpen: ()=>{
                    toggle();
                    props.onOpen?.();
                },
                onClose: ()=>{
                    close();
                    props.onClose?.();
                }
            }
        });
    };
const $fe5170bdd3625759$var$Component$1c = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$18;
    const { open: open = false, disabled: disabled = false, onOpen: onOpen = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSelect: onSelect = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onClose: onClose = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), ariaLabel: ariaLabel = "Select Country Code", ariaControls: ariaControls = "container", _ariaExpanded: _ariaExpanded = props.open?.toString(), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            open: open,
            disabled: disabled,
            onOpen: onOpen,
            onSelect: onSelect,
            onClose: onClose,
            ariaLabel: ariaLabel,
            ariaControls: ariaControls,
            _ariaExpanded: _ariaExpanded,
            ...rest
        },
        componentTag: componentTag
    }, "JDSInputPhoneDropdown", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$770f20817cf88abc = $fe5170bdd3625759$var$withLogic$19($fe5170bdd3625759$var$Component$1c);
$fe5170bdd3625759$export$770f20817cf88abc.displayName = "InputPhoneDropdown";
$fe5170bdd3625759$export$770f20817cf88abc.slotName = "jds_input_phone_dropdown";
const $fe5170bdd3625759$var$sdl$17 = {
    "metadata": {
        "version": "1.0.0",
        "id": "list-block-1.0.0",
        "name": "JDSListBlock",
        "layerName": "jds_list_block",
        "description": "",
        "usage": ""
    },
    "hierarchy": {
        "root-container": [
            "top-slot",
            {
                "main-container": [
                    "prefix-slot",
                    {
                        "block-container": [
                            "title-jds-text",
                            {
                                "caption-container": [
                                    {
                                        "inner-caption-container": [
                                            "caption-block-text-slot",
                                            "caption-block-helper-slot"
                                        ]
                                    },
                                    "caption-block-value-slot"
                                ]
                            },
                            {
                                "title-container": [
                                    {
                                        "inner-title-container": [
                                            "title-block-text-slot",
                                            "title-block-helper-slot"
                                        ]
                                    },
                                    "title-block-value-slot"
                                ]
                            },
                            {
                                "helper-container": [
                                    {
                                        "inner-helper-container": [
                                            "helper-block-text-slot",
                                            "helper-block-helper-slot"
                                        ]
                                    },
                                    "helper-block-value-slot"
                                ]
                            }
                        ]
                    },
                    "suffix-slot"
                ]
            },
            "children-slot"
        ]
    },
    "base": {
        "root-container": {
            "flex-direction": "{l_0}",
            "width": "{l_1}",
            "justify-content": "{l_2}",
            "align-items": "{l_3}",
            "gap": "{l_4}",
            "padding-top": "{l_5}",
            "padding-bottom": "{l_6}"
        },
        "main-container": {
            "flex-direction": "{l_7}",
            "width": "{l_8}",
            "gap": "{l_9}",
            "justify-content": "{l_10}",
            "align-items": "{l_11}"
        },
        "block-container": {
            "flex-direction": "{l_12}",
            "flex": 1,
            "gap": "{l_13}",
            "justify-content": "{l_14}",
            "align-items": "{l_15}"
        },
        "caption-container": {
            "flex-direction": "{l_16}",
            "width": "{l_17}",
            "justify-content": "{l_18}",
            "align-items": "{l_19}",
            "gap": "{l_20}"
        },
        "inner-caption-container": {
            "flex-direction": "{l_21}",
            "justify-content": "{l_22}",
            "align-items": "{l_23}",
            "gap": "{l_24}"
        },
        "title-container": {
            "flex-direction": "{l_25}",
            "width": "{l_26}",
            "justify-content": "{l_27}",
            "align-items": "{l_28}",
            "gap": "{l_29}"
        },
        "inner-title-container": {
            "flex-direction": "{l_30}",
            "justify-content": "{l_31}",
            "align-items": "{l_32}",
            "gap": "{l_33}"
        },
        "helper-container": {
            "flex-direction": "{l_34}",
            "width": "{l_35}",
            "justify-content": "{l_36}",
            "align-items": "{l_37}",
            "gap": "{l_38}"
        },
        "inner-helper-container": {
            "flex-direction": "{l_39}",
            "justify-content": "{l_40}",
            "align-items": "{l_41}",
            "gap": "{l_42}"
        },
        "title-jds-text": {
            "font-family": "{bodySBold}",
            "color": "{primaryGrey100}",
            "font-size": "{bodySBold}",
            "line-height": "{bodySBold}",
            "letter-spacing": "{bodySBold}",
            "font-weight": "{bodySBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": true
        }
    },
    "variant": {
        "spacing": {
            "small": {
                "main-container": {
                    "gap": "{l_43}"
                },
                "root-container": {
                    "gap": "{l_44}"
                }
            }
        },
        "verticalAlignment": {
            "top": {
                "main-container": {
                    "align-items": "{l_45}"
                }
            }
        },
        "_isTitleVisible": {
            "true": {
                "caption-container": {
                    "hidden": true
                },
                "title-container": {
                    "hidden": true
                },
                "title-jds-text": {
                    "hidden": false
                }
            }
        }
    },
    "api": {
        "children": {
            "top-slot": {
                "name": "top",
                "accepts": [
                    "any"
                ],
                "max": 1
            },
            "prefix-slot": {
                "name": "prefix",
                "accepts": [
                    "jds_icon",
                    "jds_avatar",
                    "jds_image"
                ],
                "max": 1,
                "doc_description": "It can take 'icon', 'avtar', 'image' as prefix for Listblock."
            },
            "suffix-slot": {
                "name": "suffix",
                "accepts": [
                    "jds_text",
                    "jds_icon",
                    "jds_button",
                    "jds_link"
                ],
                "max": 1,
                "doc_description": "It can take 'icon', 'text', 'button', 'link' as suffix for Listblock."
            },
            "caption-block-text-slot": {
                "name": "captionBlockText",
                "accepts": [
                    "jds_text"
                ],
                "max": 1
            },
            "caption-block-helper-slot": {
                "name": "captionBlockHelper",
                "accepts": [
                    "jds_text",
                    "jds_badge",
                    "jds_tag"
                ],
                "max": 1
            },
            "caption-block-value-slot": {
                "name": "captionBlockValue",
                "accepts": [
                    "jds_text",
                    "jds_badge",
                    "jds_tag"
                ],
                "max": 1
            },
            "title-block-text-slot": {
                "name": "titleBlockText",
                "accepts": [
                    "jds_text"
                ],
                "max": 1
            },
            "title-block-helper-slot": {
                "name": "titleBlockHelper",
                "accepts": [
                    "jds_text",
                    "jds_badge",
                    "jds_tag"
                ],
                "max": 1
            },
            "title-block-value-slot": {
                "name": "titleBlockValue",
                "accepts": [
                    "jds_text",
                    "jds_badge",
                    "jds_tag"
                ],
                "max": 1
            },
            "helper-block-text-slot": {
                "name": "helperBlockText",
                "accepts": [
                    "jds_text"
                ],
                "max": 1
            },
            "helper-block-helper-slot": {
                "name": "helperBlockHelper",
                "accepts": [
                    "jds_text",
                    "jds_badge",
                    "jds_tag"
                ],
                "max": 1
            },
            "helper-block-value-slot": {
                "name": "helperBlockValue",
                "accepts": [
                    "jds_text",
                    "jds_badge",
                    "jds_tag"
                ],
                "max": 1
            },
            "children-slot": {
                "name": "children",
                "accepts": [
                    "any"
                ],
                "max": 1
            }
        },
        "config": {
            "spacing": {
                "values": [
                    "medium",
                    "small"
                ],
                "doc_description": "Adjusts the spacing between ListBlock contents"
            },
            "verticalAlignment": {
                "values": [
                    "middle",
                    "top"
                ],
                "doc_description": "Vertical alignment for Prefix and Suffix."
            },
            "_isTitleVisible": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "title-jds-text": {
                "value": {
                    "type": "string",
                    "name": "title"
                }
            }
        },
        "events": {
            "root-container": {
                "onClick": "onClick"
            },
            "prefix-slot": {
                "onClick": "onPrefixClick"
            },
            "suffix-slot": {
                "onClick": "onSuffixClick"
            }
        }
    }
};
const $fe5170bdd3625759$var$legacySpacing = [
    "m",
    "s"
];
const $fe5170bdd3625759$var$PROP_MAP$i = (props)=>{
    if ($fe5170bdd3625759$var$legacySpacing.includes(props.spacing)) console.warn("these values for the spacing prop are deprecated", $fe5170bdd3625759$var$legacySpacing);
    return {
        captionBlock: {
            properties: {
                captionBlockText: $fe5170bdd3625759$var$convertTextToComponent(props.captionBlock?.text),
                captionBlockHelper: $fe5170bdd3625759$var$convertTextToComponent(props.captionBlock?.helper),
                captionBlockValue: $fe5170bdd3625759$var$convertTextToComponent(props.captionBlock?.value)
            }
        },
        titleBlock: {
            properties: {
                titleBlockText: $fe5170bdd3625759$var$convertTextToComponent(props.titleBlock?.text),
                titleBlockHelper: $fe5170bdd3625759$var$convertTextToComponent(props.titleBlock?.helper),
                titleBlockValue: $fe5170bdd3625759$var$convertTextToComponent(props.titleBlock?.value)
            }
        },
        helperBlock: {
            properties: {
                helperBlockText: $fe5170bdd3625759$var$convertTextToComponent(props.helperBlock?.text),
                helperBlockHelper: $fe5170bdd3625759$var$convertTextToComponent(props.helperBlock?.helper),
                helperBlockValue: $fe5170bdd3625759$var$convertTextToComponent(props.helperBlock?.value)
            }
        },
        spacing: {
            properties: {
                spacing: props.spacing
            },
            defaultValue: "s",
            variations: {
                s: {
                    spacing: "small"
                },
                m: {
                    spacing: "medium"
                }
            }
        }
    };
};
const $fe5170bdd3625759$var$withLogic$18 = (Component)=>(userProps)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$i);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                _isTitleVisible: !(props.titleBlock?.text || props.titleBlockText)
            }
        });
    };
const $fe5170bdd3625759$var$Component$1b = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$17;
    const { spacing: spacing = "medium", verticalAlignment: verticalAlignment = "middle", onClick: onClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onPrefixClick: onPrefixClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSuffixClick: onSuffixClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            spacing: spacing,
            verticalAlignment: verticalAlignment,
            onClick: onClick,
            onPrefixClick: onPrefixClick,
            onSuffixClick: onSuffixClick,
            ...rest
        },
        componentTag: componentTag
    }, "JDSListBlock", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$7c8f337671b808e4 = $fe5170bdd3625759$var$withLogic$18($fe5170bdd3625759$var$Component$1b);
$fe5170bdd3625759$export$7c8f337671b808e4.displayName = "ListBlock";
$fe5170bdd3625759$export$7c8f337671b808e4.slotName = "jds_list_block";
const $fe5170bdd3625759$var$sdl$16 = {
    "metadata": {
        "version": "1.0.0",
        "id": "mega-menu-1.0.0",
        "name": "JDSMegaMenu",
        "layerName": "jds_mega_menu",
        "platform": "web"
    },
    "hierarchy": {
        "popup": [
            {
                "popup-container": [
                    "jds_megamenu_internal"
                ]
            }
        ]
    },
    "base": {
        "popup": {
            "priority": 40,
            "hidden": true,
            "passive": true
        },
        "popup-container": {
            "flex-direction": "{m_0}"
        }
    },
    "variant": {
        "open": {
            "true": {
                "popup": {
                    "hidden": false
                }
            }
        }
    },
    "api": {
        "config": {
            "open": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "popup-container": {
                "padding-top": {
                    "type": "size",
                    "name": "offsetY"
                },
                "padding-left": {
                    "type": "size",
                    "name": "offsetX"
                },
                "width": {
                    "type": "size",
                    "name": "width"
                }
            },
            "jds_megamenu_internal": {
                "items": {
                    "type": "list",
                    "name": "items",
                    "object": {
                        "heading": "string",
                        "subLinks": "list"
                    }
                },
                "items.heading": {
                    "type": "string",
                    "name": "items.heading"
                },
                "items.subLinks": {
                    "type": "list",
                    "name": "items.subLinks"
                }
            }
        },
        "events": {
            "jds_megamenu_internal": {
                "onHoverEnd": "onHoverEnd"
            }
        },
        "a11y": {
            "jds_megamenu_internal": {
                "name": "items",
                "repeating": {
                    "ariaLabel": "linkAriaLabel",
                    "ariaDescribedby": {
                        "name": "linkAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$17 = (Component)=>(props)=>{
        if (!props.open || !props.items?.length) return null;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$1a = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$16;
    const { open: open = false, onHoverEnd: onHoverEnd = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            open: open,
            onHoverEnd: onHoverEnd,
            ...rest
        },
        componentTag: componentTag
    }, "JDSMegaMenu", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$aee42d298194d478 = $fe5170bdd3625759$var$withLogic$17($fe5170bdd3625759$var$Component$1a);
$fe5170bdd3625759$export$aee42d298194d478.displayName = "MegaMenu";
$fe5170bdd3625759$export$aee42d298194d478.slotName = "jds_mega_menu";
const $fe5170bdd3625759$var$sdl$15 = {
    "metadata": {
        "version": "1.0.0",
        "id": "mega-menu-block-1.0.0",
        "name": "JDSMegaMenuBlock",
        "layerName": "jds_mega_menu_block",
        "platform": "web"
    },
    "hierarchy": {
        "container": [
            "heading-jds-text",
            {
                "links-container": [
                    "jds_mega_menu_item"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{m_0}",
            "justify-content": "{m_1}",
            "align-items": "{m_2}",
            "gap": "{m_3}"
        },
        "links-container": {
            "flex-direction": "{m_4}",
            "justify-content": "{m_5}",
            "align-items": "{m_6}"
        },
        "heading-jds-text": {
            "font-family": "{headingXxs}",
            "color": "{primaryGrey100}",
            "font-size": "{headingXxs}",
            "line-height": "{headingXxs}",
            "letter-spacing": "{headingXxs}",
            "font-weight": "{headingXxs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "padding-top": "{m_7}"
        }
    },
    "api": {
        "data": {
            "links-container": {
                "value": {
                    "name": "links",
                    "type": "list",
                    "object": {
                        "title": "string",
                        "href": "string"
                    }
                }
            },
            "jds_mega_menu_item": {
                "title": {
                    "type": "string",
                    "name": "links.title"
                },
                "href": {
                    "type": "string",
                    "name": "links.href"
                }
            },
            "heading-jds-text": {
                "value": {
                    "type": "string",
                    "name": "title"
                }
            }
        },
        "a11y": {
            "links-container": {
                "properties": {
                    "role": {
                        "value": "list"
                    }
                },
                "name": "links",
                "repeating": {
                    "ariaLabel": "linkAriaLabel",
                    "ariaDescribedby": {
                        "name": "linkAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_mega_menu_item": {
                "properties": {
                    "ariaLabel": "links.linkAriaLabel",
                    "ariaDescribedby": "links.linkAriaDescribedby"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$16 = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$19 = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$15;
    const { custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...rest,
        componentTag: componentTag
    }, "JDSMegaMenuBlock", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$5e96c1cbae381c93 = $fe5170bdd3625759$var$withLogic$16($fe5170bdd3625759$var$Component$19);
$fe5170bdd3625759$export$5e96c1cbae381c93.displayName = "MegaMenuBlock";
$fe5170bdd3625759$export$5e96c1cbae381c93.slotName = "jds_mega_menu_block";
const $fe5170bdd3625759$var$sdl$14 = {
    "metadata": {
        "version": "1.0.0",
        "id": "mega-menu-1.0.0",
        "name": "JDSMegaMenuInternal",
        "layerName": "jds_mega_menu_internal",
        "platform": "web"
    },
    "hierarchy": {
        "container": [
            "jds_mega_menu_block"
        ]
    },
    "base": {
        "container": {
            "width": "{m_1}",
            "flex-direction": "{m_2}",
            "justify-content": "{m_3}",
            "align-items": "{m_4}",
            "background-color": "{m_5}",
            "padding-top": "{m_6}",
            "padding-bottom": "{m_7}",
            "padding-right": "{m_8}",
            "padding-left": "{m_9}",
            "gap": "{m_10}"
        }
    },
    "variant": {},
    "api": {
        "config": {
            "open": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "container": {
                "value": {
                    "type": "list",
                    "name": "items",
                    "object": {
                        "heading": "string",
                        "subLinks": "list"
                    }
                }
            },
            "jds_mega_menu_block": {
                "title": {
                    "type": "string",
                    "name": "items.heading"
                },
                "links": {
                    "type": "list",
                    "name": "items.subLinks"
                }
            }
        },
        "events": {
            "container": {
                "onHoverEnd": "onHoverEnd"
            }
        },
        "a11y": {
            "container": {
                "name": "items",
                "repeating": {
                    "ariaLabel": "linkAriaLabel",
                    "ariaDescribedby": {
                        "name": "linkAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$15 = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$18 = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$14;
    const { open: open = false, onHoverEnd: onHoverEnd = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            open: open,
            onHoverEnd: onHoverEnd,
            ...rest
        },
        componentTag: componentTag
    }, "JDSMegaMenuInternal", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$d7717d03c9caf572 = $fe5170bdd3625759$var$withLogic$15($fe5170bdd3625759$var$Component$18);
$fe5170bdd3625759$export$d7717d03c9caf572.displayName = "MegaMenuInternal";
$fe5170bdd3625759$export$d7717d03c9caf572.slotName = "jds_mega_menu_internal";
const $fe5170bdd3625759$var$sdl$13 = {
    "metadata": {
        "version": "1.0.0",
        "id": "mega-menu-item-1.0.0",
        "name": "JDSMegaMenuItem",
        "layerName": "jds_mega_menu_item",
        "platform": "web"
    },
    "hierarchy": {
        "container": [
            "jds_link"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{m_0}",
            "justify-content": "{m_1}",
            "align-items": "{m_2}",
            "padding-top": "{m_3}",
            "padding-bottom": "{m_4}"
        },
        "jds_link": {
            "kind": "submenu"
        }
    },
    "variant": {},
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "data": {
            "jds_link": {
                "title": {
                    "type": "string",
                    "name": "title"
                },
                "href": {
                    "type": "string",
                    "name": "href"
                },
                "newTab": {
                    "type": "boolean",
                    "name": "newTab",
                    "platform": "web"
                },
                "routerLinkProps": {
                    "type": "RouterLinkProps",
                    "name": "routerLinkProps",
                    "platform": "angular"
                },
                "onClick": {
                    "type": "string",
                    "name": "onClick"
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "listitem"
                    }
                }
            },
            "jds_link": {
                "properties": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$14 = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$17 = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$13;
    const { custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...rest,
        componentTag: componentTag
    }, "JDSMegaMenuItem", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$cc2d7d7492914f14 = $fe5170bdd3625759$var$withLogic$14($fe5170bdd3625759$var$Component$17);
$fe5170bdd3625759$export$cc2d7d7492914f14.displayName = "MegaMenuItem";
$fe5170bdd3625759$export$cc2d7d7492914f14.slotName = "jds_mega_menu_item";
const $fe5170bdd3625759$var$sdl$12 = {
    "metadata": {
        "version": "1.0.0",
        "id": "menu-block-1.0.0",
        "name": "JDSMenuBlock",
        "layerName": "jds_menu_block"
    },
    "hierarchy": {
        "popup": [
            {
                "popup-container": [
                    "jds_menu_block_internal"
                ]
            }
        ]
    },
    "base": {
        "popup": {
            "background-color": "{global.transparent}",
            "priority": 70,
            "passive": true
        },
        "popup-container": {
            "flex-direction": "{flexDirection.stack}",
            "padding-bottom": "{m_3}",
            "max-height": "{m_9}"
        },
        "jds_menu_block_internal": {
            "hidden": false
        }
    },
    "variant": {
        "open": {
            "true": {
                "popup": {
                    "passive": false
                },
                "jds_menu_block_internal": {
                    "open": true
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "open": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "Used to open or close the modal programatically."
            }
        },
        "data": {
            "popup-container": {
                "padding-left": {
                    "type": "size",
                    "name": "offsetX",
                    "function": true
                },
                "padding-top": {
                    "type": "size",
                    "name": "offsetY",
                    "function": true
                }
            },
            "jds_menu_block_internal": {
                "maxHeight": {
                    "type": "size",
                    "name": "maxHeight",
                    "function": true
                },
                "maxWidth": {
                    "type": "size",
                    "name": "maxWidth"
                },
                "minWidth": {
                    "type": "size",
                    "name": "minWidth",
                    "function": true
                },
                "items": {
                    "type": "list",
                    "name": "items",
                    "doc_description": "Each entry eithin Menu is configured throught the MenuItem object. Some type may be unselectable.",
                    "object": {
                        "type": "JDSMenuBlockItem.type",
                        "label": "string",
                        "value": "string",
                        "prefix": "icon",
                        "suffix": "icon",
                        "disabled": "boolean",
                        "selected": "boolean"
                    }
                },
                "selectedIndex": {
                    "type": "number",
                    "name": "selectedIndex",
                    "doc_description": "Used to programatically change current selected Index"
                },
                "items.type": {
                    "type": "string",
                    "name": "items.type"
                },
                "items.label": {
                    "type": "string",
                    "name": "items.label"
                },
                "items.value": {
                    "type": "string",
                    "name": "items.value"
                },
                "items.prefix": {
                    "type": "icon",
                    "name": "items.prefix"
                },
                "items.suffix": {
                    "type": "icon",
                    "name": "items.suffix"
                },
                "items.disabled": {
                    "type": "boolean",
                    "name": "items.disabled"
                },
                "items.selected": {
                    "type": "boolean",
                    "name": "items.selected"
                }
            }
        },
        "events": {
            "jds_menu_block_internal": {
                "onSelect": {
                    "name": "onSelect",
                    "doc_description": "onClick event that triggers upon click or tap of the chosen entry."
                },
                "onAppear": {
                    "name": "_onAppear",
                    "platform": "ios"
                },
                "onClick": "onClick"
            },
            "popup": {
                "onClick": "onClose"
            }
        },
        "a11y": {
            "jds_menu_block_internal": {
                "name": "items",
                "repeating": {
                    "ariaLabel": "itemAriaLabel",
                    "ariaDescribedby": {
                        "name": "itemAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$useSelected = (selected)=>{
    const [selectedIndex, setSelectedIndex] = (0, $acw62.useState)(-1);
    (0, $acw62.useEffect)(()=>{
        if (typeof selected === "number") setSelectedIndex(selected);
    }, [
        selected
    ]);
    const updateIndex = (index)=>setSelectedIndex(index);
    return {
        index: selectedIndex,
        onClick: (index)=>{
            setSelectedIndex(index);
        },
        updateIndex: updateIndex
    };
};
const $fe5170bdd3625759$var$MENUBLOCK_SELECTOR$1 = "div#container.j-jds-menu-block-container";
const $fe5170bdd3625759$var$MENUBLOCKINTERNAL_SELECTOR$1 = "div.j-JDSMenuBlockInternal-container";
const $fe5170bdd3625759$var$ANIMATION_DURATION$1 = 250;
const $fe5170bdd3625759$var$withLogic$13 = (Component)=>(props)=>{
        const { element: element, rootRef: rootRef } = $fe5170bdd3625759$var$useRootRef();
        const { index: index, onClick: onClick } = $fe5170bdd3625759$var$useSelected(props.selectedIndex);
        const [shouldRender, setShouldRender] = (0, $acw62.useState)(props.open);
        const internalProps = props;
        const { items: items = props.items ?? [], anchorEl: anchorEl, open: open } = props;
        const menublockRef = element?.querySelector($fe5170bdd3625759$var$MENUBLOCK_SELECTOR$1);
        $fe5170bdd3625759$var$useEscapeClose(props.onClose, true);
        $fe5170bdd3625759$var$useScrollClose(props.onClose);
        (0, $acw62.useEffect)(()=>{
            if (open) props.onOpen?.();
        }, [
            open
        ]);
        const { left: left, top: top, height: height, width: width } = $fe5170bdd3625759$var$setPositions(anchorEl?.current, menublockRef, String(props.maxHeight));
        (0, $acw62.useEffect)(()=>{
            let timeout;
            if (props.open) {
                setShouldRender(true);
                props.onOpen?.();
            } else timeout = setTimeout(()=>{
                setShouldRender(false);
            }, $fe5170bdd3625759$var$ANIMATION_DURATION$1);
            return ()=>{
                if (timeout) clearTimeout(timeout);
            };
        }, [
            props.open
        ]);
        (0, $acw62.useEffect)(()=>{
            if (shouldRender && props.open) {
                const menublockInternalRef = element?.querySelector($fe5170bdd3625759$var$MENUBLOCKINTERNAL_SELECTOR$1);
                if (menublockInternalRef) menublockInternalRef.focus();
            } else anchorEl?.current?.focus();
        }, [
            shouldRender,
            props.open,
            element
        ]);
        if (!shouldRender) return null;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                open: open,
                rootRef: rootRef,
                selectedIndex: index,
                items: items,
                offsetX: internalProps.offsetX || left,
                maxHeight: !open ? 0 : props.maxHeight || height,
                offsetY: internalProps.offsetY || top,
                _hasIcon: items.some((i)=>Boolean(i.prefix)),
                onSelect: (index2)=>{
                    props.onSelect?.(index2, items?.[index2].value || "");
                    onClick?.(index2);
                    props.onClose?.();
                },
                onClick: (ev)=>{
                    ev.stopPropagation();
                    props.onClick?.(ev);
                },
                minWidth: internalProps.maxWidth || Math.max(width || 0, 250)
            }
        });
    };
const $fe5170bdd3625759$var$Component$16 = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$12;
    const { open: open = false, onSelect: onSelect = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onClick: onClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onClose: onClose = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            open: open,
            onSelect: onSelect,
            onClick: onClick,
            onClose: onClose,
            ...rest
        },
        componentTag: componentTag
    }, "JDSMenuBlock", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$3a7690908a5e9b5 = $fe5170bdd3625759$var$withLogic$13($fe5170bdd3625759$var$Component$16);
$fe5170bdd3625759$export$3a7690908a5e9b5.displayName = "MenuBlock";
$fe5170bdd3625759$export$3a7690908a5e9b5.slotName = "jds_menu_block";
const $fe5170bdd3625759$var$sdl$11 = {
    "metadata": {
        "version": "1.0.0",
        "id": "menu-block-1.0.0",
        "name": "JDSMenuBlockInternal",
        "layerName": "jds_menu_block_internal",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "jds_menu_block_item"
        ]
    },
    "base": {
        "container": {
            "hidden": true,
            "width": "{intrinsicSize.max}",
            "lazy-scroll-android": false,
            "background-color": "{primaryBackground}",
            "flex-direction": "{flexDirection.column}",
            "border-radius": "{medium}",
            "overflow": "auto",
            "box-shadow": {
                "x": 0,
                "y": 4,
                "blur": 16,
                "spread": 0,
                "color": "#00000014"
            },
            "transition": {
                "property": [
                    "max-height"
                ],
                "duration": "{slow}",
                "timing-function": "{easeExit}"
            }
        },
        "jds_menu_block_item": {
            "width": "{size.max}"
        }
    },
    "variant": {
        "open": {
            "true": {
                "container": {
                    "hidden": false,
                    "transition": {
                        "timing-function": "{easeEntrance}"
                    }
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "open": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "Used to open or close the modal programatically."
            }
        },
        "data": {
            "container": {
                "max-height": {
                    "type": "size",
                    "name": "maxHeight",
                    "function": true
                },
                "max-width": {
                    "type": "size",
                    "name": "maxWidth"
                },
                "min-width": {
                    "type": "size",
                    "name": "minWidth",
                    "function": true
                },
                "value": {
                    "type": "list",
                    "name": "items",
                    "doc_description": "Each entry eithin Menu is configured throught the MenuItem object. Some type may be unselectable.",
                    "object": {
                        "type": "JDSMenuBlockItem.type",
                        "label": "string",
                        "value": "string",
                        "prefix": "icon",
                        "suffix": "icon",
                        "disabled": "boolean",
                        "selected": "boolean"
                    }
                }
            },
            "jds_menu_block_item": {
                "selectedIndex": {
                    "type": "number",
                    "name": "selectedIndex",
                    "doc_description": "Used to programatically change current selected Index"
                },
                "type": {
                    "type": "string",
                    "name": "items.type"
                },
                "label": {
                    "type": "string",
                    "name": "items.label"
                },
                "value": {
                    "type": "string",
                    "name": "items.value"
                },
                "prefix": {
                    "type": "icon",
                    "name": "items.prefix"
                },
                "suffix": {
                    "type": "icon",
                    "name": "items.suffix"
                },
                "disabled": {
                    "type": "boolean",
                    "name": "items.disabled"
                },
                "hasIcon": {
                    "type": "boolean",
                    "name": "_hasIcon"
                },
                "selected": {
                    "type": "boolean",
                    "name": "items.selected"
                }
            }
        },
        "events": {
            "jds_menu_block_item": {
                "onSelect": {
                    "name": "onSelect",
                    "doc_description": "onClick event that triggers upon click or tap of the chosen entry."
                }
            },
            "container": {
                "onAppear": {
                    "name": "onAppear",
                    "platform": "ios"
                },
                "onClick": "onClick"
            }
        },
        "a11y": {
            "container": {
                "name": "items",
                "properties": {
                    "role": {
                        "value": "listbox"
                    },
                    "aria-label": {
                        "name": "_ariaLabel",
                        "value": "Choose an item"
                    }
                },
                "repeating": {
                    "ariaLabel": "itemAriaLabel",
                    "ariaDescribedby": {
                        "name": "itemAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_menu_block_item": {
                "properties": {
                    "ariaLabel": "items.itemAriaLabel",
                    "ariaDescribedby": "items.itemAriaDescribedby"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$MENUBLOCK_SELECTOR = "div#container.j-jds-menu-block-container";
const $fe5170bdd3625759$var$MENUBLOCKINTERNAL_SELECTOR = "div.j-JDSMenuBlockInternal-container";
const $fe5170bdd3625759$var$ANIMATION_DURATION = 250;
const $fe5170bdd3625759$var$withLogic$12 = (Component)=>(props)=>{
        const { element: element, rootRef: rootRef } = $fe5170bdd3625759$var$useRootRef();
        const { index: index, onClick: onClick } = $fe5170bdd3625759$var$useSelected(props.selectedIndex);
        const internalProps = props;
        const { items: items = [], anchorEl: anchorEl, open: open } = props;
        const [shouldRender, setShouldRender] = (0, $acw62.useState)(props.open);
        const menublockRef = element?.querySelector($fe5170bdd3625759$var$MENUBLOCK_SELECTOR);
        $fe5170bdd3625759$var$useEscapeClose(props.onClose, true);
        $fe5170bdd3625759$var$useScrollClose(props.onClose);
        (0, $acw62.useEffect)(()=>{
            if (open) props.onOpen?.();
        }, [
            open
        ]);
        const { left: left, top: top, height: height, width: width } = $fe5170bdd3625759$var$setPositions(anchorEl?.current, menublockRef, String(props.maxHeight));
        (0, $acw62.useEffect)(()=>{
            let timeout;
            if (open) {
                setShouldRender(true);
                props.onOpen?.();
            } else timeout = setTimeout(()=>{
                setShouldRender(false);
            }, $fe5170bdd3625759$var$ANIMATION_DURATION);
            return ()=>{
                if (timeout) clearTimeout(timeout);
            };
        }, [
            props.open
        ]);
        (0, $acw62.useEffect)(()=>{
            if (!shouldRender || !props.open) return;
            const timeout = setTimeout(()=>{
                const menublockInternalRef = document.querySelector($fe5170bdd3625759$var$MENUBLOCKINTERNAL_SELECTOR);
                menublockInternalRef?.focus();
            }, $fe5170bdd3625759$var$ANIMATION_DURATION);
            return ()=>clearTimeout(timeout);
        }, [
            shouldRender,
            props.open
        ]);
        if (!shouldRender) return null;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                open: open,
                rootRef: rootRef,
                selectedIndex: index,
                items: items,
                offsetX: internalProps.offsetX || left,
                maxHeight: !open ? 0 : props.maxHeight || height,
                offsetY: internalProps.offsetY || top,
                _hasIcon: items.some((i)=>Boolean(i.prefix)),
                onSelect: (index2)=>{
                    props.onSelect?.(index2, items?.[index2].value || "");
                    onClick?.(index2);
                    props.onClose?.();
                },
                onClick: (ev)=>{
                    ev.stopPropagation();
                    props.onClick?.(ev);
                }
            }
        });
    };
const $fe5170bdd3625759$var$Component$15 = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$11;
    const { open: open = false, onSelect: onSelect = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onAppear: onAppear = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onClick: onClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), _ariaLabel: _ariaLabel = "Choose an item", custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            open: open,
            onSelect: onSelect,
            onAppear: onAppear,
            onClick: onClick,
            _ariaLabel: _ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSMenuBlockInternal", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$f9b98c24bc73aa75 = $fe5170bdd3625759$var$withLogic$12($fe5170bdd3625759$var$Component$15);
$fe5170bdd3625759$export$f9b98c24bc73aa75.displayName = "MenuBlockInternal";
$fe5170bdd3625759$export$f9b98c24bc73aa75.slotName = "jds_menu_block_internal";
const $fe5170bdd3625759$var$sdl$10 = {
    "metadata": {
        "version": "1.0.0",
        "id": "menu-block-item-1.0.0",
        "name": "JDSMenuBlockItem",
        "layerName": "jds_menu_block_item"
    },
    "hierarchy": {
        "container": [
            {
                "entry-container": [
                    {
                        "left-container": [
                            {
                                "prefix-jds-icon-container": [
                                    "prefix-jds-icon"
                                ]
                            },
                            "entry-jds-text"
                        ]
                    },
                    {
                        "suffix-jds-icon-container": [
                            "suffix-jds-icon"
                        ]
                    }
                ]
            },
            {
                "divider-container": [
                    "jds_divider"
                ]
            },
            {
                "heading-container": [
                    "heading-jds-text"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "opacity": "{m_0}",
            "background-color": "{m_1}",
            "width": "{m_2}"
        },
        "entry-container": {
            "hidden": false,
            "background-color": "{m_3}",
            "width": "{m_4}",
            "padding-top": "{m_5}",
            "padding-right": "{m_6}",
            "padding-bottom": "{m_7}",
            "padding-left": "{m_8}",
            "flex-direction": "{m_9}",
            "align-items": "{m_10}",
            "justify-content": "{m_11}",
            "border-width": 0,
            "border-color": "{m_12}",
            "border-radius": 0,
            "behavior": {
                "hover": {
                    "background-color": "{m_13}"
                },
                "focus": {
                    "border-width": 2,
                    "border-color": "{m_14}",
                    "border-radius": "{m_15}"
                }
            }
        },
        "divider-container": {
            "hidden": true,
            "width": "{m_16}"
        },
        "jds_divider": {
            "pad": "none",
            "orientation": "horizontal"
        },
        "heading-container": {
            "hidden": true,
            "padding-top": "{m_17}",
            "padding-right": "{m_18}",
            "padding-bottom": "{m_19}",
            "padding-left": "{m_20}",
            "width": "{m_21}",
            "align-items": "{m_22}",
            "justify-content": "{m_23}"
        },
        "left-container": {
            "gap": "{m_24}",
            "flex-direction": "{m_25}",
            "align-items": "{m_26}"
        },
        "prefix-jds-icon": {
            "size": "{m}",
            "color": "{primaryGrey80}",
            "hidden": true
        },
        "prefix-jds-icon-container": {
            "background-color": "{global.transparent}",
            "border-radius": "{pill}",
            "size": "{m}",
            "justify-content": "{justifyContent.center}",
            "align-items": "{alignItems.center}",
            "hidden": true
        },
        "entry-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        },
        "suffix-jds-icon": {
            "size": "{m}",
            "color": "{primaryGrey80}"
        },
        "suffix-jds-icon-container": {
            "background-color": "{global.transparent}",
            "border-radius": "{pill}",
            "size": "{m}",
            "justify-content": "{justifyContent.center}",
            "align-items": "{alignItems.center}"
        },
        "heading-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey100}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "type": {
            "divider": {
                "entry-container": {
                    "hidden": true
                },
                "divider-container": {
                    "hidden": false
                }
            },
            "heading": {
                "entry-container": {
                    "hidden": true
                },
                "heading-container": {
                    "hidden": false
                }
            }
        },
        "selected": {
            "true": {
                "container": {
                    "background-color": "{m_27}"
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{m_28}"
                }
            }
        },
        "hasIcon": {
            "true": {
                "heading-container": {
                    "padding-left": "{m_29}"
                },
                "prefix-jds-icon": {
                    "hidden": false
                },
                "prefix-jds-icon-container": {
                    "background-color": "{global.transparent}",
                    "border-radius": "{pill}",
                    "size": "{m}",
                    "justify-content": "{justifyContent.center}",
                    "align-items": "{alignItems.center}",
                    "hidden": false
                }
            }
        }
    },
    "api": {
        "config": {
            "type": {
                "values": [
                    "entry",
                    "divider",
                    "heading"
                ]
            },
            "selected": {
                "values": [
                    false,
                    true
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            },
            "hasIcon": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "container": {
                "_item.value": {
                    "type": "string",
                    "name": "value"
                }
            },
            "entry-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            },
            "prefix-jds-icon": {
                "value": {
                    "type": "icon",
                    "name": "prefix"
                },
                "ic": {
                    "type": "icon",
                    "name": "prefix"
                }
            },
            "suffix-jds-icon": {
                "value": {
                    "type": "icon",
                    "name": "suffix"
                },
                "ic": {
                    "type": "icon",
                    "name": "suffix"
                }
            },
            "heading-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            }
        },
        "events": {
            "entry-container": {
                "onClick": "onSelect"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "option"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label",
                        "function": true
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "aria-selected": {
                        "name": "_ariaSelected",
                        "prop": "selected"
                    },
                    "aria-hidden": {
                        "name": "_ariaHidden",
                        "function": true
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$11 = (Component)=>(props)=>{
        const internalProps = props;
        const selected = internalProps.internalIndex === props.selectedIndex;
        const handleSelect = ()=>{
            props.onSelect?.(internalProps.internalIndex);
        };
        const handleKeyDown = (event)=>{
            if (event.key === "Enter" && internalProps.internalIndex === props.selectedIndex) handleSelect();
        };
        const handleClick = ()=>{
            handleSelect();
        };
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                onClick: handleClick,
                onKeyDown: handleKeyDown,
                selected: selected,
                ariaLabel: props.type === "heading" ? props.ariaLabel || `${props.label} heading` : props.ariaLabel,
                _ariaHidden: props.type === "divider" ? "true" : void 0,
                _ariaSelected: props.type === "entry" ? selected : void 0,
                _hasIcon: internalProps._hasIcon || Boolean(props.prefix),
                onSelect: !props.type || props.type === "entry" ? handleSelect : void 0,
                prefix: props.prefix || (internalProps._hasIcon ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {}) : void 0)
            }
        });
    };
const $fe5170bdd3625759$var$Component$14 = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$10;
    const { type: type = "entry", selected: selected = false, disabled: disabled = false, hasIcon: hasIcon = false, onSelect: onSelect = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), ariaLabel: ariaLabel = props.label?.toString(), _ariaSelected: _ariaSelected = props.selected?.toString(), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            type: type,
            selected: selected,
            disabled: disabled,
            hasIcon: hasIcon,
            onSelect: onSelect,
            ariaLabel: ariaLabel,
            _ariaSelected: _ariaSelected,
            ...rest
        },
        componentTag: componentTag
    }, "JDSMenuBlockItem", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$3789e0cd450be8da = $fe5170bdd3625759$var$withLogic$11($fe5170bdd3625759$var$Component$14);
$fe5170bdd3625759$export$3789e0cd450be8da.displayName = "MenuBlockItem";
$fe5170bdd3625759$export$3789e0cd450be8da.slotName = "jds_menu_block_item";
const $fe5170bdd3625759$var$sdl$$ = {
    "metadata": {
        "version": "1.0.0",
        "id": "mobile-bottom-sheet-1.0.0",
        "name": "JDSMobileBottomSheetInternal",
        "layerName": "jds_mobile_bottom_sheet_internal",
        "internal": true
    },
    "hierarchy": {
        "container": [
            {
                "root-container": [
                    {
                        "cancel-container": [
                            {
                                "back-container": [
                                    "back-jds_action_button"
                                ]
                            },
                            "empty-container",
                            "step-jds-text",
                            "cancel-jds_button"
                        ]
                    },
                    {
                        "vertical-container": [
                            "title-jds-text",
                            "description-jds-text",
                            "children-slot",
                            {
                                "cta-container": [
                                    "primary-jds_action_button",
                                    "secondary-jds_action_button"
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "custom-container": [
                    "children-slot"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{m_0}",
            "justify-content": "{m_1}",
            "align-items": "{m_2}",
            "width": "{m_3}"
        },
        "root-container": {
            "hidden": true,
            "z-index": 1,
            "flex-direction": "{m_4}",
            "justify-content": "{m_5}",
            "background-color": "{m_6}",
            "align-items": "{m_7}",
            "border-top-left-radius": "{m_8}",
            "border-top-right-radius": "{m_9}",
            "width": "{m_10}",
            "enter-animation-name": "slideVerticallyUp",
            "exit-animation-name": "slideVerticallyDown",
            "enter-animation-curve": "entrance_ease",
            "exit-animation-curve": "exit_ease",
            "enter-animation-duration": 500,
            "exit-animation-duration": 500,
            "translate-y": "{m_11}",
            "transition": {
                "property": [
                    "translate-y"
                ],
                "duration": "{m_12}",
                "timing-function": "{m_13}"
            }
        },
        "cancel-container": {
            "hidden": false,
            "flex-direction": "{m_14}",
            "justify-content": "{m_15}",
            "align-items": "{m_16}",
            "width": "{m_17}",
            "padding-top": "{m_18}",
            "padding-bottom": "{m_19}",
            "padding-left": "{m_20}",
            "padding-right": "{m_21}",
            "gap": "{m_22}"
        },
        "back-container": {
            "flex": "{m_23}",
            "hidden": true
        },
        "back-jds_action_button": {
            "padding-top": "{xs}",
            "icon": "ic_back",
            "size": "medium",
            "kind": "tertiary"
        },
        "empty-container": {
            "flex": "{m_24}"
        },
        "cancel-jds_button": {
            "padding-top": "{xs}",
            "hidden": false,
            "icon": "ic_close",
            "size": "large",
            "kind": "tertiary"
        },
        "vertical-container": {
            "flex-direction": "{m_26}",
            "justify-content": "{m_27}",
            "align-items": "{m_28}",
            "padding-left": "{m_29}",
            "padding-right": "{m_30}",
            "width": "{m_31}"
        },
        "primary-jds_action_button": {
            "hidden": false,
            "kind": "primary",
            "size": "large",
            "appearance": "normal",
            "state": "normal",
            "stretch": true
        },
        "secondary-jds_action_button": {
            "hidden": false,
            "kind": "secondary",
            "size": "large",
            "appearance": "normal",
            "state": "normal",
            "stretch": true
        },
        "cta-container": {
            "flex-direction": "{m_34}",
            "gap": "{m_35}",
            "width": "{m_36}",
            "padding-bottom": "{m_37}",
            "padding-top": "{m_38}"
        },
        "children-slot": {
            "flex-fill-android": false
        },
        "custom-container": {
            "hidden": true,
            "z-index": 1,
            "flex-direction": "{m_39}",
            "justify-content": "{m_40}",
            "align-items": "{m_41}",
            "background-color": "{m_42}",
            "border-top-left-radius": "{m_43}",
            "border-top-right-radius": "{m_44}",
            "padding-left": "{m_45}",
            "padding-right": "{m_46}",
            "padding-top": "{m_47}",
            "padding-bottom": "{m_48}",
            "width": "{m_49}",
            "translate-y": "{m_50}",
            "transition": {
                "property": [
                    "translate-y"
                ],
                "duration": "{m_51}",
                "timing-function": "{m_52}"
            }
        },
        "step-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": true,
            "padding-right": "{m_25}"
        },
        "title-jds-text": {
            "font-family": "{headingXs}",
            "color": "{primaryGrey100}",
            "font-size": "{headingXs}",
            "line-height": "{headingXs}",
            "letter-spacing": "{headingXs}",
            "font-weight": "{headingXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 2,
            "padding-bottom": "{xs}",
            "maxLines": 2
        },
        "description-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "padding-bottom": "{m_33}"
        }
    },
    "variant": {
        "kind": {
            "passive": {
                "root-container": {
                    "box-shadow": {
                        "x": "{m_53}",
                        "y": "{m_54}",
                        "blur": "{m_55}",
                        "spread": "{m_56}",
                        "color": "{m_57}"
                    }
                }
            }
        },
        "close": {
            "false": {
                "root-container": {
                    "translate-y": "{m_58}",
                    "hidden": false
                }
            }
        },
        "buttonOrientation": {
            "horizontal": {
                "cta-container": {
                    "flex-direction": "{flexDirection.row}"
                }
            }
        },
        "controlType": {
            "stepper": {
                "cancel-jds_button": {
                    "hidden": true
                },
                "back-container": {
                    "hidden": false
                },
                "step-jds-text": {
                    "hidden": false
                }
            }
        },
        "primaryCtaDisabled": {
            "true": {
                "primary-jds_action_button": {
                    "state": "disabled"
                }
            }
        },
        "secondaryCtaDisabled": {
            "true": {
                "secondary-jds_action_button": {
                    "state": "disabled"
                }
            }
        },
        "_noButton": {
            "true": {
                "root-container": {
                    "padding-bottom": "{m_59}"
                },
                "cta-container": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {
            "false": {
                "true": {
                    "custom-container": {
                        "hidden": false,
                        "translate-y": "{m_60}"
                    },
                    "root-container": {
                        "hidden": true,
                        "translate-y": "{m_61}"
                    },
                    "vertical-container": {
                        "hidden": true
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "close",
            "isCustom"
        ]
    ],
    "api": {
        "config": {
            "kind": {
                "values": [
                    "overlay",
                    "passive"
                ]
            },
            "controlType": {
                "values": [
                    "normal",
                    "stepper"
                ]
            },
            "buttonOrientation": {
                "values": [
                    "vertical",
                    "horizontal"
                ]
            },
            "isCustom": {
                "values": [
                    false,
                    true
                ]
            },
            "close": {
                "values": [
                    true,
                    false
                ]
            },
            "primaryCtaDisabled": {
                "values": [
                    false,
                    true
                ]
            },
            "secondaryCtaDisabled": {
                "values": [
                    false,
                    true
                ]
            },
            "_noButton": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "root-container": {
                "max-height": {
                    "type": "size",
                    "name": "maxHeight",
                    "function": true
                }
            },
            "primary-jds_action_button": {
                "label": {
                    "type": "string",
                    "name": "primaryCTA"
                }
            },
            "secondary-jds_action_button": {
                "label": {
                    "type": "string",
                    "name": "secondaryCTA"
                }
            },
            "step-jds-text": {
                "value": {
                    "type": "string",
                    "name": "stepLabel"
                }
            },
            "title-jds-text": {
                "value": {
                    "type": "string",
                    "name": "title"
                }
            },
            "description-jds-text": {
                "value": {
                    "type": "string",
                    "name": "description"
                }
            }
        },
        "children": {
            "children-slot": {
                "name": "children",
                "accepts": [
                    "any"
                ],
                "max": 1
            }
        },
        "events": {
            "container": {
                "onAppear": {
                    "name": "onAppear",
                    "platform": "ios"
                }
            },
            "root-container": {
                "onClick": "onBottomSheetClick",
                "onSwipeDown": "onClose"
            },
            "custom-container": {
                "onClick": "onBottomSheetClick",
                "onSwipeDown": "onClose"
            },
            "back-jds_action_button": {
                "onClick": "onBack"
            },
            "cancel-jds_button": {
                "onClick": "onCancel"
            },
            "primary-jds_action_button": {
                "onClick": "onPrimaryClick"
            },
            "secondary-jds_action_button": {
                "onClick": "onSecondaryClick"
            }
        },
        "a11y": {
            "root-container": {
                "properties": {
                    "role": {
                        "value": "dialog"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "value": "Bottom Sheet Content"
                    },
                    "aria-modal": {
                        "name": "_ariaModal"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "cancel-jds_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "cancelButtonAriaLabel",
                        "value": "Close Modal"
                    }
                }
            },
            "back-jds_action_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "backButtonAriaLabel",
                        "value": "Tap to go back"
                    }
                }
            },
            "primary-jds_action_button": {
                "properties": {
                    "ariaLabel": "primaryCtaAriaLabel",
                    "ariaDescribedby": {
                        "name": "primaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "secondary-jds_action_button": {
                "properties": {
                    "ariaLabel": "secondaryCtaAriaLabel",
                    "ariaDescribedby": {
                        "name": "secondaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$10 = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                _ariaModal: props.kind === "overlay" || !props.close ? "true" : "false"
            }
        });
    };
const $fe5170bdd3625759$var$Component$13 = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$$;
    const { kind: kind = "overlay", controlType: controlType = "normal", buttonOrientation: buttonOrientation = "vertical", isCustom: isCustom = false, close: close = true, primaryCtaDisabled: primaryCtaDisabled = false, secondaryCtaDisabled: secondaryCtaDisabled = false, onAppear: onAppear = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onBottomSheetClick: onBottomSheetClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onClose: onClose = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onBack: onBack = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onCancel: onCancel = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onPrimaryClick: onPrimaryClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSecondaryClick: onSecondaryClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), ariaLabel: ariaLabel = "Bottom Sheet Content", cancelButtonAriaLabel: cancelButtonAriaLabel = "Close Modal", backButtonAriaLabel: backButtonAriaLabel = "Tap to go back", custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            controlType: controlType,
            buttonOrientation: buttonOrientation,
            isCustom: isCustom,
            close: close,
            primaryCtaDisabled: primaryCtaDisabled,
            secondaryCtaDisabled: secondaryCtaDisabled,
            onAppear: onAppear,
            onBottomSheetClick: onBottomSheetClick,
            onClose: onClose,
            onBack: onBack,
            onCancel: onCancel,
            onPrimaryClick: onPrimaryClick,
            onSecondaryClick: onSecondaryClick,
            ariaLabel: ariaLabel,
            cancelButtonAriaLabel: cancelButtonAriaLabel,
            backButtonAriaLabel: backButtonAriaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSMobileBottomSheetInternal", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$9ac5eac5233c654 = $fe5170bdd3625759$var$withLogic$10($fe5170bdd3625759$var$Component$13);
$fe5170bdd3625759$export$9ac5eac5233c654.displayName = "MobileBottomSheetInternal";
$fe5170bdd3625759$export$9ac5eac5233c654.slotName = "jds_mobile_bottom_sheet_internal";
const $fe5170bdd3625759$var$sdl$_ = {
    "metadata": {
        "version": "1.0.0",
        "id": "modal-desktop-1.0.0",
        "name": "JDSModalDesktop",
        "layerName": "jds_modal_desktop",
        "platform": "web",
        "description": "Modals focus the user\u2019s attention exclusively on one task or piece of information via a window that sits on top of the page content. Dialog Modals are used to confirm with the user before continuing with destructive or complex actions. In this case the modal have two buttons at the bottom. Access to the rest of the UI is disabled until the modal is addressed.",
        "usage": "A dialog modal uses two buttons and requires immediate user response."
    },
    "hierarchy": {
        "popup": [
            {
                "popup-container": [
                    "jds_modal_desktop_internal"
                ]
            }
        ]
    },
    "base": {
        "popup": {
            "priority": 60,
            "full-width": true,
            "passive": true
        },
        "popup-container": {
            "flex-direction": "{m_0}",
            "justify-content": "{m_3}",
            "align-items": "{m_4}",
            "size": "{m_5}",
            "enter-animation-name": "fadeIn",
            "exit-animation-name": "fadeOut",
            "enter-animation-curve": "entrance_ease",
            "exit-animation-curve": "exit_ease",
            "enter-animation-duration": 500,
            "exit-animation-duration": 500,
            "opacity": "{opacity.invisible}",
            "transition": {
                "property": [
                    "opacity"
                ],
                "duration": "{medium}",
                "timing-function": "{easeEntrance}"
            }
        },
        "jds_modal_desktop_internal": {
            "kind": "dialog",
            "headerAlignment": "left",
            "isCloseable": true,
            "size": "medium"
        }
    },
    "variant": {
        "kind": {
            "acknowledgement": {
                "jds_modal_desktop_internal": {
                    "kind": "acknowledgement"
                }
            },
            "informational": {
                "jds_modal_desktop_internal": {
                    "kind": "informational"
                }
            },
            "custom": {
                "jds_modal_desktop_internal": {
                    "kind": "custom"
                }
            }
        },
        "headerAlignment": {
            "right": {
                "jds_modal_desktop_internal": {
                    "headerAlignment": "right"
                }
            },
            "center": {
                "jds_modal_desktop_internal": {
                    "headerAlignment": "center"
                }
            }
        },
        "size": {
            "small": {
                "jds_modal_desktop_internal": {
                    "size": "small"
                }
            }
        },
        "close": {
            "false": {
                "popup": {
                    "hidden": false,
                    "passive": false
                },
                "popup-container": {
                    "opacity": "{opacity.enabled}",
                    "transition": {
                        "timing-function": "{easeExit}"
                    }
                }
            }
        },
        "isCloseable": {
            "false": {
                "jds_modal_desktop_internal": {
                    "isCloseable": false
                }
            }
        }
    },
    "api": {
        "config": {
            "kind": {
                "values": [
                    "dialog",
                    "acknowledgement",
                    "informational",
                    "custom"
                ],
                "doc_description": "It can be used to switch between 3 variants of Modal. `informational` modal has no buttons,`dialog` modal has two buttons, `acknowledgement` modal has only a single button."
            },
            "size": {
                "values": [
                    "medium",
                    "small"
                ],
                "doc_description": "It can be used to control the size of popup container."
            },
            "headerAlignment": {
                "values": [
                    "left",
                    "right",
                    "center"
                ],
                "doc_description": "It is used to align header of Modal."
            },
            "isCloseable": {
                "values": [
                    true,
                    false
                ],
                "doc_description": "It can be used to makes Modal closeable, displays close icon button on popup."
            },
            "close": {
                "values": [
                    true,
                    false
                ],
                "doc_description": "It is used to close the Modal."
            },
            "_platform": {
                "values": [
                    "desktop",
                    "tablet"
                ]
            }
        },
        "data": {
            "jds_modal_desktop_internal": {
                "header": {
                    "type": "string",
                    "name": "header",
                    "doc_description": "It displays the title of modal."
                },
                "primaryCTA": {
                    "type": "string",
                    "name": "primaryCTA",
                    "doc_description": "It displays label of primary button of Modal."
                },
                "primaryCtaDisabled": {
                    "type": "boolean",
                    "name": "primaryCtaDisabled"
                },
                "secondaryCTA": {
                    "type": "string",
                    "name": "secondaryCTA",
                    "doc_description": "It displays label of secondary button of Modal."
                },
                "secondaryCtaDisabled": {
                    "type": "boolean",
                    "name": "secondaryCtaDisabled"
                },
                "children": {
                    "name": "children",
                    "type": "slot",
                    "doc_description": "This sets Modal content as a children elements eg. `<Modal> <Table /> <Modal/>`"
                }
            }
        },
        "events": {
            "popup": {
                "onClick": "onClose"
            },
            "jds_modal_desktop_internal": {
                "onModalClick": "_onModalClick",
                "onCancel": "_onCancel",
                "onPrimaryClick": "onPrimaryClick",
                "onSecondaryClick": "onSecondaryClick"
            }
        },
        "a11y": {
            "jds_modal_desktop_internal": {
                "properties": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "cancelButtonCtaAriaLabel": "cancelButtonCtaAriaLabel",
                    "primaryCtaAriaLabel": "primaryCtaAriaLabel",
                    "primaryCtaAriaDescribedby": {
                        "name": "primaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    },
                    "secondaryCtaAriaLabel": "secondaryCtaAriaLabel",
                    "secondaryCtaAriaDescribedby": {
                        "name": "secondaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$sdl$Z = {
    "metadata": {
        "version": "1.0.0",
        "id": "modal-mobile-1.0.0",
        "name": "JDSModalMobile",
        "layerName": "jds_modal_mobile"
    },
    "hierarchy": {
        "popup": [
            {
                "popup-container": [
                    "jds_modal_mobile_internal"
                ]
            }
        ]
    },
    "base": {
        "popup": {
            "priority": 60,
            "full-width": true,
            "passive": true
        },
        "popup-container": {
            "flex-direction": "{m_0}",
            "justify-content": "{m_1}",
            "align-items": "{m_2}",
            "size": "{m_3}",
            "enter-animation-name": "fadeIn",
            "exit-animation-name": "fadeOut",
            "enter-animation-curve": "entrance_ease",
            "exit-animation-curve": "exit_ease",
            "enter-animation-duration": 500,
            "exit-animation-duration": 500,
            "opacity": "{m_4}",
            "transition": {
                "property": [
                    "opacity"
                ],
                "duration": "{m_5}",
                "timing-function": "{m_6}"
            }
        },
        "jds_modal_mobile_internal": {
            "kind": "dialog",
            "headerAlignment": "left",
            "isCloseable": true,
            "size": "medium"
        }
    },
    "variant": {
        "kind": {
            "acknowledgement": {
                "jds_modal_mobile_internal": {
                    "kind": "acknowledgement"
                }
            },
            "informational": {
                "jds_modal_mobile_internal": {
                    "kind": "informational"
                }
            },
            "custom": {
                "jds_modal_mobile_internal": {
                    "kind": "custom"
                }
            }
        },
        "headerAlignment": {
            "right": {
                "jds_modal_mobile_internal": {
                    "headerAlignment": "right"
                }
            },
            "center": {
                "jds_modal_mobile_internal": {
                    "headerAlignment": "center"
                }
            }
        },
        "size": {
            "small": {
                "jds_modal_mobile_internal": {
                    "size": "small"
                }
            }
        },
        "close": {
            "false": {
                "popup": {
                    "hidden": false,
                    "passive": false
                },
                "popup-container": {
                    "opacity": "{m_7}",
                    "transition": {
                        "timing-function": "{m_8}"
                    }
                }
            }
        },
        "isCloseable": {
            "false": {
                "jds_modal_mobile_internal": {
                    "isCloseable": false
                }
            }
        }
    },
    "api": {
        "config": {
            "kind": {
                "values": [
                    "dialog",
                    "acknowledgement",
                    "informational",
                    "custom"
                ],
                "doc_description": "It can be used to switch between 3 variants of Modal. `informational` modal has no buttons,`dialog` modal has two buttons, `acknowledgement` modal has only a single button."
            },
            "size": {
                "values": [
                    "medium",
                    "small"
                ],
                "doc_description": "It can be used to control the size of popup container."
            },
            "headerAlignment": {
                "values": [
                    "left",
                    "right",
                    "center"
                ],
                "doc_description": "It is used to align header of Modal."
            },
            "isCloseable": {
                "values": [
                    true,
                    false
                ],
                "doc_description": "It can be used to makes Modal closeable, displays close icon button on popup."
            },
            "close": {
                "values": [
                    true,
                    false
                ],
                "doc_description": "It is used to close the Modal."
            },
            "disableOutsideClick": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It determines whether modal should close and the onClose event should be triggered when clicking outside modal.",
                "function": true
            }
        },
        "data": {
            "jds_modal_mobile_internal": {
                "header": {
                    "type": "string",
                    "name": "header",
                    "doc_description": "It displays the title of modal."
                },
                "primaryCTA": {
                    "type": "string",
                    "name": "primaryCTA",
                    "doc_description": "It displays label of primary button of Modal."
                },
                "primaryCtaDisabled": {
                    "type": "boolean",
                    "name": "primaryCtaDisabled"
                },
                "secondaryCTA": {
                    "type": "string",
                    "name": "secondaryCTA",
                    "doc_description": "It displays label of secondary button of Modal."
                },
                "secondaryCtaDisabled": {
                    "type": "boolean",
                    "name": "secondaryCtaDisabled"
                },
                "children": {
                    "type": "slot",
                    "name": "children"
                }
            }
        },
        "events": {
            "popup": {
                "onClick": "onClose"
            },
            "jds_modal_mobile_internal": {
                "onModalClick": "_onModalClick",
                "onCancel": "_onCancel",
                "onPrimaryClick": "onPrimaryClick",
                "onSecondaryClick": "onSecondaryClick"
            }
        },
        "a11y": {
            "jds_modal_mobile_internal": {
                "properties": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "cancelButtonCtaAriaLabel": "cancelButtonCtaAriaLabel",
                    "headerAriaLabel": "headerAriaLabel",
                    "primaryCtaAriaLabel": "primaryCtaAriaLabel",
                    "primaryCtaAriaDescribedby": {
                        "name": "primaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    },
                    "secondaryCtaAriaLabel": "secondaryCtaAriaLabel",
                    "secondaryCtaAriaDescribedby": {
                        "name": "secondaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$legacySizes$1 = [
    "s",
    "m"
];
const $fe5170bdd3625759$var$PROP_MAP$h = (props)=>{
    if ($fe5170bdd3625759$var$legacySizes$1.includes(props.size)) console.warn("these values for the size prop are deprecated");
    if (typeof props.header === "object") console.warn("passing listblock to the header is deprecated. Please pass a string");
    return {
        onCloseCallback: {
            properties: {
                onClose: props.onCloseCallback,
                onCloseCallback: props.onCloseCallback
            }
        },
        primaryCTA: {
            properties: {
                primaryCTA: props.primaryCTA?.title || props.primaryCTA,
                onPrimaryClick: props.primaryCTA?.onClick || props.onPrimaryClick
            }
        },
        secondaryCTA: {
            properties: {
                secondaryCTA: props.secondaryCTA?.title || props.secondaryCTA,
                onSecondaryClick: props.secondaryCTA?.onClick || props.onSecondaryClick
            }
        },
        isClosable: {
            properties: {
                isCloseable: typeof props.isCloseable === "undefined" ? props.isClosable : props.isCloseable
            }
        },
        size: {
            variations: {
                s: {
                    size: "small"
                },
                m: {
                    size: "medium"
                }
            }
        },
        children: {
            properties: {
                children: $fe5170bdd3625759$var$convertTextToComponent(props.children)
            }
        }
    };
};
const $fe5170bdd3625759$var$MODAL_SELECTOR$1 = "div.j-JDSModalMobileInternal-root-container";
const $fe5170bdd3625759$var$withLogic$$ = (Component)=>(userProps)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$h);
        const { onRequestClose: onRequestClose, onCloseCallback: onCloseCallback, kind: kind, isClosable: isClosable, close: userCloseProp, closed: closed, ...rest } = props;
        const { element: element, rootRef: rootRef } = $fe5170bdd3625759$var$useRootRef();
        const modalRef = element?.querySelector($fe5170bdd3625759$var$MODAL_SELECTOR$1);
        const closeProp = typeof userCloseProp === "undefined" ? closed : userCloseProp;
        const allowClose = !onRequestClose || onRequestClose();
        const close = ()=>{
            if (allowClose) {
                onCloseCallback?.();
                rest.onClose?.();
            }
        };
        $fe5170bdd3625759$var$useEscapeClose(close, kind === "informational");
        const handleClose = ()=>{
            if (kind === "informational") close();
        };
        (0, $acw62.useEffect)(()=>{
            if (!closeProp && modalRef) modalRef.focus();
        }, [
            closeProp
        ]);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...rest,
                kind: kind,
                rootRef: rootRef,
                _onModalClick: (ev)=>ev.stopPropagation(),
                close: closeProp,
                _onCancel: close,
                onClose: handleClose,
                isCloseable: isClosable || props.isCloseable
            }
        });
    };
const $fe5170bdd3625759$var$Component$12 = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$Z;
    const { kind: kind = "dialog", size: size = "medium", headerAlignment: headerAlignment = "left", isCloseable: isCloseable = true, close: close = true, disableOutsideClick: disableOutsideClick = false, onClose: onClose = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onPrimaryClick: onPrimaryClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSecondaryClick: onSecondaryClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            size: size,
            headerAlignment: headerAlignment,
            isCloseable: isCloseable,
            close: close,
            disableOutsideClick: disableOutsideClick,
            onClose: onClose,
            onPrimaryClick: onPrimaryClick,
            onSecondaryClick: onSecondaryClick,
            ...rest
        },
        componentTag: componentTag
    }, "JDSModalMobile", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$var$Modal$1 = $fe5170bdd3625759$var$withLogic$$($fe5170bdd3625759$var$Component$12);
$fe5170bdd3625759$var$Modal$1.displayName = "Modal";
$fe5170bdd3625759$var$Modal$1.slotName = "jds_modal_mobile";
const $fe5170bdd3625759$var$legacySizes = [
    "s",
    "m"
];
const $fe5170bdd3625759$var$PROP_MAP$g = (props)=>{
    if ($fe5170bdd3625759$var$legacySizes.includes(props.size)) console.warn("these values for the size prop are deprecated");
    if (typeof props.header === "object") console.warn("passing listblock to the header is deprecated. Please pass a string");
    return {
        onCloseCallback: {
            properties: {
                onClose: props.onCloseCallback,
                onCloseCallback: props.onCloseCallback
            }
        },
        onClose: {
            properties: {
                onCloseCallback: props.onClose
            }
        },
        primaryCTA: {
            properties: {
                primaryCTA: $fe5170bdd3625759$var$resolvePropObjectKeys(props.primaryCTA, "title", ""),
                onPrimaryClick: props.primaryCTA?.onClick || props.onPrimaryClick
            }
        },
        secondaryCTA: {
            properties: {
                secondaryCTA: $fe5170bdd3625759$var$resolvePropObjectKeys(props.secondaryCTA, "title", ""),
                onSecondaryClick: props.secondaryCTA?.onClick || props.onSecondaryClick
            }
        },
        isClosable: {
            properties: {
                isCloseable: typeof props.isCloseable === "undefined" ? props.isClosable : props.isCloseable
            }
        },
        size: {
            variations: {
                s: {
                    size: "small"
                },
                m: {
                    size: "medium"
                }
            }
        },
        children: {
            properties: {
                children: $fe5170bdd3625759$var$convertTextToComponent(props.children)
            }
        }
    };
};
const $fe5170bdd3625759$var$MODAL_SELECTOR = "div.j-JDSModalDesktopInternal-root-container";
const $fe5170bdd3625759$var$withLogic$_ = (Component)=>(userProps)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$g);
        const { onRequestClose: onRequestClose, onCloseCallback: onCloseCallback, kind: kind = "dialog", isClosable: isClosable, close: userCloseProp, closed: closed, ...rest } = props;
        const { element: element, rootRef: rootRef } = $fe5170bdd3625759$var$useRootRef();
        const modalRef = element?.querySelector($fe5170bdd3625759$var$MODAL_SELECTOR);
        const closeProp = typeof userCloseProp === "undefined" ? closed : userCloseProp;
        const { mobile: mobile } = $fe5170bdd3625759$var$Devices.useMedia();
        const allowClose = !onRequestClose || onRequestClose();
        const close = ()=>{
            if (allowClose) {
                onCloseCallback?.();
                rest?.onClose?.();
            }
        };
        $fe5170bdd3625759$var$useEscapeClose(close, kind === "informational");
        const handleClose = ()=>{
            if (kind === "informational") close();
        };
        (0, $acw62.useEffect)(()=>{
            if (!closeProp && modalRef) modalRef.focus();
            if (!closeProp) document.body.style.overflow = "hidden";
            else document.body.style.overflow = "";
            return ()=>{
                document.body.style.overflow = "";
            };
        }, [
            closeProp
        ]);
        if (mobile) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$var$Modal$1, {
            ...userProps
        });
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...rest,
                kind: kind,
                rootRef: rootRef,
                _onModalClick: (ev)=>ev.stopPropagation(),
                close: closeProp,
                _onCancel: close,
                onClose: handleClose
            }
        });
    };
const $fe5170bdd3625759$var$Component$11 = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$_;
    const { kind: kind = "dialog", size: size = "medium", headerAlignment: headerAlignment = "left", isCloseable: isCloseable = true, close: close = true, onClose: onClose = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onPrimaryClick: onPrimaryClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSecondaryClick: onSecondaryClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            size: size,
            headerAlignment: headerAlignment,
            isCloseable: isCloseable,
            close: close,
            onClose: onClose,
            onPrimaryClick: onPrimaryClick,
            onSecondaryClick: onSecondaryClick,
            ...rest
        },
        componentTag: componentTag
    }, "JDSModalDesktop", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$2b77a92f1a5ad772 = $fe5170bdd3625759$var$withLogic$_($fe5170bdd3625759$var$Component$11);
$fe5170bdd3625759$export$2b77a92f1a5ad772.displayName = "Modal";
$fe5170bdd3625759$export$2b77a92f1a5ad772.slotName = "jds_modal_desktop";
const $fe5170bdd3625759$var$sdl$Y = {
    "metadata": {
        "version": "1.0.0",
        "id": "modal-desktop-1.0.0",
        "name": "JDSModalDesktopInternal",
        "layerName": "jds_modal_desktop_internal",
        "platform": "web",
        "description": "Modals focus the user\u2019s attention exclusively on one task or piece of information via a window that sits on top of the page content. Dialog Modals are used to confirm with the user before continuing with destructive or complex actions. In this case the modal have two buttons at the bottom. Access to the rest of the UI is disabled until the modal is addressed.",
        "usage": "A dialog modal uses two buttons and requires immediate user response."
    },
    "hierarchy": {
        "container": [
            "overlay-container",
            {
                "root-container": [
                    {
                        "cancel-container": [
                            "cancel-jds_button"
                        ]
                    },
                    {
                        "vertical-container": [
                            {
                                "header-container": [
                                    "header-jds-text"
                                ]
                            },
                            {
                                "children-container": [
                                    "children-slot"
                                ]
                            },
                            {
                                "button-container": [
                                    "secondary-jds_action_button",
                                    "primary-jds_action_button"
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "custom-container": [
                    "children-slot"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{m_0}",
            "justify-content": "{m_1}",
            "align-items": "{m_2}",
            "size": "{m_3}"
        },
        "overlay-container": {
            "show": true,
            "size": "{m_7}",
            "background-color": "{m_8}",
            "opacity": "{m_9}"
        },
        "root-container": {
            "z-index": 1,
            "flex-direction": "{m_10}",
            "justify-content": "{m_11}",
            "align-items": "{m_12}",
            "border-radius": "{m_13}",
            "background-color": "{m_14}",
            "width": "{m_15}",
            "max-height": "{m_16}"
        },
        "cancel-container": {
            "flex-direction": "{m_17}",
            "justify-content": "{m_18}",
            "align-items": "{m_19}",
            "width": "{m_20}",
            "padding-top": "{m_21}",
            "padding-bottom": "{m_22}",
            "padding-left": "{m_23}",
            "padding-right": "{m_24}",
            "hidden": false
        },
        "cancel-jds_button": {
            "hidden": false,
            "icon": "ic_close",
            "kind": "tertiary",
            "size": "medium"
        },
        "vertical-container": {
            "flex-direction": "{m_25}",
            "justify-content": "{m_26}",
            "align-items": "{m_27}",
            "padding-left": "{m_28}",
            "padding-right": "{m_29}",
            "padding-bottom": "{m_30}",
            "width": "{m_31}",
            "overflow": "{m_32}"
        },
        "header-container": {
            "flex-direction": "{m_34}",
            "justify-content": "{m_35}",
            "align-items": "{m_36}",
            "width": "{m_37}",
            "padding-bottom": "{m_38}"
        },
        "children-container": {
            "width": "{m_39}",
            "overflow": "{m_40}"
        },
        "button-container": {
            "width": "{m_41}",
            "justify-content": "{m_42}",
            "align-items": "{m_43}",
            "flex-direction": "{m_44}",
            "gap": "{m_45}",
            "padding-top": "{m_46}"
        },
        "primary-jds_action_button": {
            "hidden": false,
            "kind": "primary",
            "size": "large",
            "stretch": false
        },
        "secondary-jds_action_button": {
            "hidden": false,
            "kind": "secondary",
            "size": "large",
            "stretch": false
        },
        "custom-container": {
            "hidden": true,
            "z-index": 1,
            "flex-direction": "{m_47}",
            "justify-content": "{m_48}",
            "align-items": "{m_49}",
            "border-radius": "{m_50}",
            "background-color": "{elevation1}",
            "padding-left": "{m_52}",
            "padding-right": "{m_53}",
            "padding-top": "{m_54}",
            "padding-bottom": "{m_55}",
            "max-width": "{m_56}",
            "max-height": "{m_57}",
            "overflow": "{m_33}"
        },
        "header-jds-text": {
            "font-family": "{headingXs}",
            "color": "{primaryGrey100}",
            "font-size": "{headingXs}",
            "line-height": "{headingXs}",
            "letter-spacing": "{headingXs}",
            "font-weight": "{headingXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "kind": {
            "acknowledgement": {
                "primary-jds_action_button": {
                    "stretch": true
                },
                "secondary-jds_action_button": {
                    "hidden": true
                }
            },
            "informational": {
                "button-container": {
                    "hidden": true
                }
            },
            "custom": {
                "custom-container": {
                    "hidden": false
                },
                "root-container": {
                    "hidden": true
                }
            }
        },
        "headerAlignment": {
            "right": {
                "header-container": {
                    "justify-content": "{m_58}"
                }
            },
            "center": {
                "header-container": {
                    "justify-content": "{m_59}"
                }
            }
        },
        "size": {
            "small": {
                "vertical-container": {
                    "padding-left": "{m_60}",
                    "padding-right": "{m_61}",
                    "padding-bottom": "{m_62}"
                }
            }
        },
        "primaryCtaDisabled": {
            "true": {
                "primary-jds_action_button": {
                    "state": "disabled"
                }
            }
        },
        "secondaryCtaDisabled": {
            "true": {
                "secondary-jds_action_button": {
                    "state": "disabled"
                }
            }
        },
        "_hasCta": {
            "false": {
                "button-container": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {
            "dialog": {
                "false": {
                    "cancel-container": {
                        "hidden": true
                    },
                    "vertical-container": {
                        "padding-top": "{m_63}"
                    }
                }
            },
            "acknowledgement": {
                "false": {
                    "cancel-container": {
                        "hidden": true
                    },
                    "vertical-container": {
                        "padding-top": "{m_64}"
                    }
                }
            }
        },
        {
            "medium": {
                "desktop": {
                    "root-container": {
                        "width": "584"
                    }
                },
                "tablet": {
                    "root-container": {
                        "width": "464"
                    }
                }
            },
            "small": {
                "desktop": {
                    "root-container": {
                        "width": "412"
                    }
                },
                "tablet": {
                    "root-container": {
                        "width": "412"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "kind",
            "isCloseable"
        ],
        [
            "size",
            "_platform"
        ]
    ],
    "api": {
        "config": {
            "kind": {
                "values": [
                    "dialog",
                    "acknowledgement",
                    "informational",
                    "custom"
                ],
                "doc_description": "It can be used to switch between 3 variants of Modal. `informational` modal has no buttons,`dialog` modal has two buttons, `acknowledgement` modal has only a single button."
            },
            "size": {
                "values": [
                    "medium",
                    "small"
                ],
                "doc_description": "It can be used to control the size of popup container."
            },
            "headerAlignment": {
                "values": [
                    "left",
                    "right",
                    "center"
                ],
                "doc_description": "It is used to align header of Modal."
            },
            "isCloseable": {
                "values": [
                    true,
                    false
                ],
                "doc_description": "It can be used to makes Modal closeable, displays close icon button on popup."
            },
            "primaryCtaDisabled": {
                "values": [
                    false,
                    true
                ]
            },
            "secondaryCtaDisabled": {
                "values": [
                    false,
                    true
                ]
            },
            "_platform": {
                "values": [
                    "desktop",
                    "tablet"
                ]
            },
            "_hasCta": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "primary-jds_action_button": {
                "label": {
                    "type": "string",
                    "name": "primaryCTA",
                    "doc_description": "It displays label of primary button of Modal."
                }
            },
            "secondary-jds_action_button": {
                "label": {
                    "type": "string",
                    "name": "secondaryCTA",
                    "doc_description": "It displays label of secondary button of Modal."
                }
            },
            "header-jds-text": {
                "value": {
                    "type": "string",
                    "name": "header",
                    "doc_description": "It displays the title of modal."
                }
            }
        },
        "children": {
            "children-slot": {
                "name": "children",
                "accepts": [
                    "any"
                ],
                "max": 1,
                "doc_description": "This sets Modal content as a children elements eg. `<Modal> <Table /> <Modal/>`"
            }
        },
        "events": {
            "root-container": {
                "onClick": "onModalClick"
            },
            "custom-container": {
                "onClick": "onModalClick"
            },
            "cancel-jds_button": {
                "onClick": "onCancel"
            },
            "primary-jds_action_button": {
                "onClick": "onPrimaryClick"
            },
            "secondary-jds_action_button": {
                "onClick": "onSecondaryClick"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "dialog"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "value": "Modal Content"
                    },
                    "aria-modal": {
                        "name": "_ariaModal",
                        "value": "true"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "cancel-jds_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "cancelButtonCtaAriaLabel",
                        "value": "Close Modal"
                    }
                }
            },
            "primary-jds_action_button": {
                "properties": {
                    "ariaLabel": "primaryCtaAriaLabel",
                    "ariaDescribedby": {
                        "name": "primaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "secondary-jds_action_button": {
                "properties": {
                    "ariaLabel": "secondaryCtaAriaLabel",
                    "ariaDescribedby": {
                        "name": "secondaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$Z = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                _hasCta: Boolean(props.primaryCTA || props.secondaryCTA)
            }
        });
    };
const $fe5170bdd3625759$var$Component$10 = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$Y;
    const { kind: kind = "dialog", size: size = "medium", headerAlignment: headerAlignment = "left", isCloseable: isCloseable = true, primaryCtaDisabled: primaryCtaDisabled = false, secondaryCtaDisabled: secondaryCtaDisabled = false, onModalClick: onModalClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onCancel: onCancel = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onPrimaryClick: onPrimaryClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSecondaryClick: onSecondaryClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), ariaLabel: ariaLabel = "Modal Content", cancelButtonCtaAriaLabel: cancelButtonCtaAriaLabel = "Close Modal", _ariaModal: _ariaModal = "true", custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            size: size,
            headerAlignment: headerAlignment,
            isCloseable: isCloseable,
            primaryCtaDisabled: primaryCtaDisabled,
            secondaryCtaDisabled: secondaryCtaDisabled,
            onModalClick: onModalClick,
            onCancel: onCancel,
            onPrimaryClick: onPrimaryClick,
            onSecondaryClick: onSecondaryClick,
            ariaLabel: ariaLabel,
            cancelButtonCtaAriaLabel: cancelButtonCtaAriaLabel,
            _ariaModal: _ariaModal,
            ...rest
        },
        componentTag: componentTag
    }, "JDSModalDesktopInternal", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$3e0ada2dd34546e6 = $fe5170bdd3625759$var$withLogic$Z($fe5170bdd3625759$var$Component$10);
$fe5170bdd3625759$export$3e0ada2dd34546e6.displayName = "ModalDesktopInternal";
$fe5170bdd3625759$export$3e0ada2dd34546e6.slotName = "jds_modal_desktop_internal";
const $fe5170bdd3625759$var$sdl$X = {
    "metadata": {
        "version": "1.0.0",
        "id": "modal-mobile-1.0.0",
        "name": "JDSModalMobileInternal",
        "layerName": "jds_modal_mobile_internal"
    },
    "hierarchy": {
        "container": [
            "overlay-container",
            {
                "outer-container": [
                    {
                        "root-container": [
                            {
                                "cancel-container": [
                                    "cancel-jds_button"
                                ]
                            },
                            {
                                "vertical-container": [
                                    {
                                        "header-container": [
                                            "header-jds-text"
                                        ]
                                    },
                                    {
                                        "children-container": [
                                            "children-slot"
                                        ]
                                    },
                                    {
                                        "button-container": [
                                            "primary-jds_action_button",
                                            "secondary-jds_action_button"
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "custom-container": [
                            "children-slot"
                        ]
                    }
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{m_0}",
            "justify-content": "{m_1}",
            "align-items": "{m_2}",
            "size": "{m_3}"
        },
        "overlay-container": {
            "show": true,
            "size": "{m_4}",
            "background-color": "{m_5}",
            "opacity": "{m_6}"
        },
        "outer-container": {
            "z-index": 1,
            "flex-direction": "{m_14}",
            "justify-content": "{m_15}",
            "align-items": "{m_16}",
            "max-height": "{m_19}",
            "width": "{m_18}",
            "padding-top": "{m_20}",
            "padding-bottom": "{m_21}",
            "padding-left": "{m_22}",
            "padding-right": "{m_23}"
        },
        "root-container": {
            "flex-direction": "{m_7}",
            "justify-content": "{m_8}",
            "align-items": "{m_9}",
            "border-radius": "{m_10}",
            "width": "{m_11}",
            "background-color": "{m_13}",
            "max-height": "{m_12}"
        },
        "cancel-container": {
            "flex-direction": "{m_24}",
            "justify-content": "{m_25}",
            "align-items": "{m_26}",
            "width": "{m_27}",
            "padding-top": "{m_28}",
            "padding-bottom": "{m_29}",
            "padding-left": "{m_30}",
            "padding-right": "{m_31}",
            "hidden": false
        },
        "cancel-jds_button": {
            "hidden": false,
            "icon": "ic_close",
            "kind": "tertiary",
            "size": "medium"
        },
        "vertical-container": {
            "flex-direction": "{m_32}",
            "justify-content": "{m_33}",
            "align-items": "{m_34}",
            "width": "{m_35}",
            "padding-left": "{m_36}",
            "padding-right": "{m_37}",
            "padding-bottom": "{m_38}",
            "overflow": "{m_39}"
        },
        "header-container": {
            "flex-direction": "{m_40}",
            "justify-content": "{m_41}",
            "align-items": "{m_42}",
            "width": "{m_43}",
            "padding-bottom": "{m_44}"
        },
        "children-container": {
            "width": "{m_46}",
            "overflow": "{m_47}",
            "flex-direction": "{m_48}",
            "align-items": "{m_45}",
            "flex-fill-android": false
        },
        "button-container": {
            "width": "{m_49}",
            "justify-content": "{m_50}",
            "align-items": "{m_51}",
            "flex-direction": "{m_52}",
            "gap": "{m_53}",
            "padding-top": "{m_54}"
        },
        "primary-jds_action_button": {
            "hidden": false,
            "kind": "primary",
            "size": "large",
            "stretch": true
        },
        "secondary-jds_action_button": {
            "hidden": false,
            "kind": "secondary",
            "size": "large",
            "stretch": true
        },
        "custom-container": {
            "hidden": true,
            "flex-direction": "{m_55}",
            "justify-content": "{m_56}",
            "align-items": "{m_57}",
            "border-radius": "{m_58}",
            "background-color": "{elevation1}",
            "padding-left": "{m_60}",
            "padding-right": "{m_61}",
            "padding-top": "{m_62}",
            "padding-bottom": "{m_63}",
            "width": "{m_64}"
        },
        "header-jds-text": {
            "font-family": "{headingXs}",
            "color": "{primaryGrey100}",
            "font-size": "{headingXs}",
            "line-height": "{headingXs}",
            "letter-spacing": "{headingXs}",
            "font-weight": "{headingXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "kind": {
            "acknowledgement": {
                "primary-jds_action_button": {
                    "stretch": true
                },
                "secondary-jds_action_button": {
                    "hidden": true
                }
            },
            "informational": {
                "button-container": {
                    "hidden": true
                }
            },
            "custom": {
                "custom-container": {
                    "hidden": false
                },
                "root-container": {
                    "hidden": true
                }
            }
        },
        "headerAlignment": {
            "right": {
                "header-container": {
                    "justify-content": "{m_65}"
                }
            },
            "center": {
                "header-container": {
                    "justify-content": "{m_66}"
                }
            }
        },
        "size": {
            "small": {
                "vertical-container": {
                    "padding-left": "{m_67}",
                    "padding-right": "{m_68}",
                    "padding-bottom": "{m_69}"
                }
            }
        },
        "primaryCtaDisabled": {
            "true": {
                "primary-jds_action_button": {
                    "state": "disabled"
                }
            }
        },
        "secondaryCtaDisabled": {
            "true": {
                "secondary-jds_action_button": {
                    "state": "disabled"
                }
            }
        },
        "_hasCta": {
            "false": {
                "button-container": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {
            "dialog": {
                "false": {
                    "cancel-container": {
                        "hidden": true
                    },
                    "vertical-container": {
                        "padding-top": "{m_70}"
                    }
                }
            },
            "acknowledgement": {
                "false": {
                    "cancel-container": {
                        "hidden": true
                    },
                    "vertical-container": {
                        "padding-top": "{m_71}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "kind",
            "isCloseable"
        ]
    ],
    "api": {
        "config": {
            "kind": {
                "values": [
                    "dialog",
                    "acknowledgement",
                    "informational",
                    "custom"
                ]
            },
            "size": {
                "values": [
                    "medium",
                    "small"
                ]
            },
            "headerAlignment": {
                "values": [
                    "left",
                    "right",
                    "center"
                ]
            },
            "isCloseable": {
                "values": [
                    true,
                    false
                ]
            },
            "primaryCtaDisabled": {
                "values": [
                    false,
                    true
                ]
            },
            "secondaryCtaDisabled": {
                "values": [
                    false,
                    true
                ]
            },
            "_hasCta": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "primary-jds_action_button": {
                "label": {
                    "type": "string",
                    "name": "primaryCTA"
                }
            },
            "secondary-jds_action_button": {
                "label": {
                    "type": "string",
                    "name": "secondaryCTA"
                }
            },
            "header-jds-text": {
                "value": {
                    "type": "string",
                    "name": "header"
                }
            }
        },
        "children": {
            "children-slot": {
                "name": "children",
                "accepts": [
                    "any"
                ],
                "max": 1,
                "doc_description": "This sets Modal content as a children elements."
            }
        },
        "events": {
            "root-container": {
                "onClick": "onModalClick"
            },
            "cancel-jds_button": {
                "onClick": "onCancel"
            },
            "primary-jds_action_button": {
                "onClick": "onPrimaryClick"
            },
            "secondary-jds_action_button": {
                "onClick": "onSecondaryClick"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "dialog"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "value": "Modal Content"
                    },
                    "aria-modal": {
                        "name": "_ariaModal",
                        "value": "true"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "cancel-jds_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "cancelButtonCtaAriaLabel",
                        "value": "Close Modal"
                    }
                }
            },
            "header-jds_text": {
                "properties": {
                    "aria-label": {
                        "name": "headerAriaLabel",
                        "prop": "header"
                    }
                }
            },
            "primary-jds_action_button": {
                "properties": {
                    "ariaLabel": "primaryCtaAriaLabel",
                    "ariaDescribedby": {
                        "name": "primaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "secondary-jds_action_button": {
                "properties": {
                    "ariaLabel": "secondaryCtaAriaLabel",
                    "ariaDescribedby": {
                        "name": "secondaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$Y = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                _hasCta: Boolean(props.primaryCTA || props.secondaryCTA)
            }
        });
    };
const $fe5170bdd3625759$var$Component$$ = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$X;
    const { kind: kind = "dialog", size: size = "medium", headerAlignment: headerAlignment = "left", isCloseable: isCloseable = true, primaryCtaDisabled: primaryCtaDisabled = false, secondaryCtaDisabled: secondaryCtaDisabled = false, onModalClick: onModalClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onCancel: onCancel = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onPrimaryClick: onPrimaryClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSecondaryClick: onSecondaryClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), ariaLabel: ariaLabel = "Modal Content", cancelButtonCtaAriaLabel: cancelButtonCtaAriaLabel = "Close Modal", headerAriaLabel: headerAriaLabel = props.header?.toString(), _ariaModal: _ariaModal = "true", custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            size: size,
            headerAlignment: headerAlignment,
            isCloseable: isCloseable,
            primaryCtaDisabled: primaryCtaDisabled,
            secondaryCtaDisabled: secondaryCtaDisabled,
            onModalClick: onModalClick,
            onCancel: onCancel,
            onPrimaryClick: onPrimaryClick,
            onSecondaryClick: onSecondaryClick,
            ariaLabel: ariaLabel,
            cancelButtonCtaAriaLabel: cancelButtonCtaAriaLabel,
            headerAriaLabel: headerAriaLabel,
            _ariaModal: _ariaModal,
            ...rest
        },
        componentTag: componentTag
    }, "JDSModalMobileInternal", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$e70e9b240ff3bbbf = $fe5170bdd3625759$var$withLogic$Y($fe5170bdd3625759$var$Component$$);
$fe5170bdd3625759$export$e70e9b240ff3bbbf.displayName = "ModalMobileInternal";
$fe5170bdd3625759$export$e70e9b240ff3bbbf.slotName = "jds_modal_mobile_internal";
const $fe5170bdd3625759$var$sdl$W = {
    "metadata": {
        "version": "1.0.0",
        "id": "notification-button-1.0.0",
        "name": "JDSNotificationButton",
        "layerName": "jds_notification_button"
    },
    "hierarchy": {
        "container": [
            "jds-text",
            "icon"
        ]
    },
    "base": {
        "container": {
            "padding-top": "{n_0}",
            "padding-right": "{n_1}",
            "padding-bottom": "{n_2}",
            "padding-left": "{n_3}",
            "background-color": "{n_4}",
            "border-radius": 1e3,
            "border-width": "1",
            "border-color": "{n_5}",
            "behavior": {
                "hover": {
                    "border-color": "{n_6}"
                },
                "active": {
                    "background-color": "{n_7}"
                },
                "focus": {
                    "border-width": "4",
                    "border-color": "{n_8}"
                }
            }
        },
        "icon": {
            "size": "{n_14}",
            "color": "{n_13}"
        },
        "jds-text": {
            "font-family": "{button}",
            "color": "{primary20}",
            "font-size": "{button}",
            "line-height": "{button}",
            "letter-spacing": "{button}",
            "font-weight": "{button}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "isDisabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{n_9}"
                }
            }
        },
        "kind": {
            "tertiary": {
                "container": {
                    "border-width": "0",
                    "behavior": {
                        "hover": {
                            "background-color": "{n_10}"
                        },
                        "active": {
                            "background-color": "{n_11}"
                        },
                        "focus": {
                            "background-color": "{n_12}"
                        }
                    }
                }
            }
        },
        "_hasLabel": {
            "false": {
                "container": {
                    "padding-top": "{n_15}",
                    "padding-bottom": "{n_16}",
                    "padding-left": "{n_17}",
                    "padding-right": "{n_18}"
                },
                "jds-text": {
                    "hidden": true
                }
            }
        },
        "_hasIcon": {
            "true": {
                "icon": {
                    "hidden": false
                }
            }
        }
    },
    "api": {
        "config": {
            "isDisabled": {
                "values": [
                    false,
                    true
                ]
            },
            "kind": {
                "values": [
                    "secondary",
                    "tertiary"
                ]
            },
            "_hasLabel": {
                "values": [
                    true,
                    false
                ]
            },
            "_hasIcon": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "icon": {
                "value": {
                    "type": "icon",
                    "name": "icon"
                }
            },
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            }
        },
        "events": {
            "container": {
                "onClick": "onClick"
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$X = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                _hasLabel: Boolean(props.label),
                tabIndex: 0
            }
        });
    };
const $fe5170bdd3625759$var$Component$_ = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$W;
    const { isDisabled: isDisabled = false, kind: kind = "secondary", onClick: onClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            isDisabled: isDisabled,
            kind: kind,
            onClick: onClick,
            ...rest
        },
        componentTag: componentTag
    }, "JDSNotificationButton", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$var$NotificationButton = $fe5170bdd3625759$var$withLogic$X($fe5170bdd3625759$var$Component$_);
$fe5170bdd3625759$var$NotificationButton.displayName = "NotificationButton";
$fe5170bdd3625759$var$NotificationButton.slotName = "jds_notification_button";
const $fe5170bdd3625759$var$sdl$V = {
    "metadata": {
        "version": "1.0.0",
        "id": "nudge-1.0.0",
        "name": "JDSNudge",
        "layerName": "jds_nudge"
    },
    "hierarchy": {
        "root-container": [
            {
                "base-container": [
                    "left-slot",
                    {
                        "center-container": [
                            "heading-jds-text",
                            "support-jds-text"
                        ]
                    },
                    "close-jds_notification_button",
                    "right-slot"
                ]
            },
            {
                "buttons-container": [
                    "secondary-jds_notification_button",
                    "primary-jds_notification_button"
                ]
            }
        ]
    },
    "base": {
        "root-container": {
            "width": "{n_0}",
            "max-width": "{n_1}",
            "border-radius": "{n_2}",
            "background-color": "{n_3}",
            "flex-direction": "{n_4}",
            "gap": "{n_5}",
            "padding-top": "{n_6}",
            "padding-right": "{n_7}",
            "padding-bottom": "{n_8}",
            "padding-left": "{n_9}",
            "enter-animation-name": "slideVerticallyDown",
            "exit-animation-name": "slideVerticallyUp",
            "enter-animation-curve": "entrance_ease",
            "exit-animation-curve": "exit_ease",
            "enter-animation-duration": 500,
            "exit-animation-duration": 500,
            "transition": {
                "property": [
                    "translate-x",
                    "translate-y"
                ],
                "duration": "{medium}",
                "timing-function": "{easeJoyfulExit}"
            },
            "hidden": true
        },
        "base-container": {
            "gap": "{n_10}",
            "flex-direction": "{n_12}",
            "justify-content": "{n_13}",
            "align-items": "{n_14}",
            "width": "{n_11}"
        },
        "center-container": {
            "flex-direction": "{n_15}",
            "justify-content": "{n_16}",
            "align-items": "{n_17}",
            "gap": "{n_18}",
            "flex": 1
        },
        "close-jds_notification_button": {
            "hidden": false,
            "icon": "ic_close",
            "kind": "tertiary"
        },
        "buttons-container": {
            "show": false,
            "gap": "{n_20}",
            "flex-direction": "{n_21}",
            "justify-content": "{n_22}",
            "width": "{n_19}"
        },
        "secondary-jds_notification_button": {
            "kind": "tertiary"
        },
        "right-slot": {
            "hidden": true
        },
        "heading-jds-text": {
            "font-family": "{bodySBold}",
            "color": "{primaryBackground}",
            "font-size": "{bodySBold}",
            "line-height": "{bodySBold}",
            "letter-spacing": "{bodySBold}",
            "font-weight": "{bodySBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 1,
            "maxLines": 1
        },
        "support-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey20}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 1,
            "maxLines": 1
        }
    },
    "variant": {
        "open": {
            "true": {
                "root-container": {
                    "hidden": false,
                    "transition": {
                        "timing-function": "{easeJoyfulEntrance}"
                    }
                }
            }
        },
        "showClose": {
            "false": {
                "close-jds_notification_button": {
                    "hidden": true
                },
                "right-slot": {
                    "hidden": false
                }
            }
        },
        "_platform": {
            "tablet": {
                "root-container": {
                    "max-width": "{n_23}",
                    "enter-animation-name": "slideHorizontallyToLeft",
                    "exit-animation-name": "slideHorizontallyToRight"
                }
            },
            "desktop": {
                "root-container": {
                    "max-width": "{n_24}",
                    "enter-animation-name": "slideHorizontallyToLeft",
                    "exit-animation-name": "slideHorizontallyToRight"
                }
            }
        },
        "_hasCTA": {
            "false": {
                "buttons-container": {
                    "hidden": true
                }
            }
        },
        "_hasDescription": {
            "false": {
                "support-jds-text": {
                    "hidden": true
                },
                "heading-jds-text": {
                    "max-lines": 2,
                    "maxLines": 2
                }
            }
        }
    },
    "combination": [
        {
            "false": {
                "mobile": {
                    "root-container": {
                        "translate-y": "{size.negativeMax}"
                    }
                },
                "tablet": {
                    "root-container": {
                        "translate-x": "{size.max}"
                    }
                },
                "desktop": {
                    "root-container": {
                        "translate-x": "{size.max}"
                    }
                }
            },
            "true": {
                "mobile": {
                    "root-container": {
                        "translate-y": 0
                    }
                },
                "tablet": {
                    "root-container": {
                        "translate-x": 0
                    }
                },
                "desktop": {
                    "root-container": {
                        "translate-x": 0
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "open",
            "_platform"
        ]
    ],
    "api": {
        "config": {
            "open": {
                "values": [
                    false,
                    true
                ]
            },
            "showClose": {
                "values": [
                    true,
                    false
                ],
                "doc_description": "This shows close button on Nudge when true."
            },
            "_platform": {
                "values": [
                    "mobile",
                    "tablet",
                    "desktop"
                ]
            },
            "_hasCTA": {
                "values": [
                    true,
                    false
                ]
            },
            "_hasDescription": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "root-container": {
                "_nudge.id": {
                    "type": "NotificationId",
                    "name": "id",
                    "required": true,
                    "doc_description": "It will hold the reference of Nudge"
                }
            },
            "secondary-jds_notification_button": {
                "label": {
                    "type": "string",
                    "name": "secondaryCTA",
                    "doc_description": "It displays label of secondary button of Nudge."
                }
            },
            "primary-jds_notification_button": {
                "label": {
                    "type": "string",
                    "name": "primaryCTA",
                    "doc_description": "It displays label of primary button of Nudge."
                }
            },
            "heading-jds-text": {
                "value": {
                    "type": "string",
                    "name": "title",
                    "doc_description": "It displays the title of Nudge."
                }
            },
            "support-jds-text": {
                "value": {
                    "type": "string",
                    "name": "description",
                    "doc_description": "It can be used to add description to the Nudge."
                },
                "maxLines": {
                    "type": "number",
                    "name": "maxLines",
                    "doc_description": "Allows customization of max lines for the description text."
                }
            }
        },
        "events": {
            "root-container": {
                "onShow": "onShow",
                "onHover": {
                    "name": "onHover",
                    "platform": "web"
                },
                "onUpdate": {
                    "name": "onUpdate",
                    "platform": "android"
                },
                "onHoverEnd": {
                    "name": "onHoverEnd",
                    "platform": "web"
                },
                "onSwipeUp": "onClose"
            },
            "close-jds_notification_button": {
                "onClick": "onClose"
            },
            "secondary-jds_notification_button": {
                "onClick": "onSecondaryClick"
            },
            "primary-jds_notification_button": {
                "onClick": "onPrimaryClick"
            }
        },
        "children": {
            "left-slot": {
                "accepts": [
                    "jds_icon",
                    "jds_avatar"
                ],
                "max": 1,
                "name": "prefix",
                "doc_description": "It takes 'icon', 'avatar' as prefix."
            },
            "right-slot": {
                "accepts": [
                    "jds_notification_button"
                ],
                "max": 1,
                "name": "suffix",
                "doc_description": "It takes 'jds_notification_button' as suffix."
            }
        },
        "a11y": {
            "root-container": {
                "properties": {
                    "role": {
                        "value": "alertdialog"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "title"
                    }
                }
            },
            "base-container": {
                "properties": {
                    "aria-hidden": {
                        "value": "true"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$PROP_MAP$f = (props)=>{
    return {
        primaryCTA: {
            properties: {
                primaryCTA: $fe5170bdd3625759$var$resolvePropObjectKeys(props.primaryCTA, "title", ""),
                onPrimaryClick: props.primaryCTA?.onClick
            }
        },
        secondaryCTA: {
            properties: {
                secondaryCTA: $fe5170bdd3625759$var$resolvePropObjectKeys(props.secondaryCTA, "title", ""),
                onPrimaryClick: props.secondaryCTA?.onClick
            }
        }
    };
};
function $fe5170bdd3625759$var$subscribe(eventClass, func) {
    const handler = function() {
        func(eventClass.args);
    };
    document.addEventListener(eventClass.eventName, handler, {
        passive: true
    });
    return {
        unsubscribe: function unsubscribe() {
            document.removeEventListener(eventClass.eventName, handler);
        }
    };
}
function $fe5170bdd3625759$var$publish(event) {
    const nativeEvent = new CustomEvent(event.constructor.eventName, {
        detail: event.constructor.args
    });
    document.dispatchEvent(nativeEvent);
}
const $fe5170bdd3625759$var$DEFAULT_DISMISS_WITH_CTA = 10;
const $fe5170bdd3625759$var$DEFAULT_DISMISS_WITHOUT_CTA = 5;
const $fe5170bdd3625759$var$TOAST_SELECTOR = "div.j-JDSToast-root-container";
const $fe5170bdd3625759$var$resolvePrefixIcon = (props)=>{
    if (typeof props.prefix === "string") return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$f04a61298a47a40f, {
        ic: props.prefix
    });
    return props.prefix;
};
function $fe5170bdd3625759$var$getDismissTime(isCTAPresent, dismissAfter) {
    let timer = $fe5170bdd3625759$var$DEFAULT_DISMISS_WITHOUT_CTA;
    if (isCTAPresent) timer = $fe5170bdd3625759$var$DEFAULT_DISMISS_WITH_CTA;
    if (dismissAfter !== void 0) {
        const defaultMinTimer = 2;
        const defaultMaxTimer = isCTAPresent ? $fe5170bdd3625759$var$DEFAULT_DISMISS_WITH_CTA : $fe5170bdd3625759$var$DEFAULT_DISMISS_WITHOUT_CTA;
        if (dismissAfter < defaultMinTimer) timer = defaultMinTimer;
        else if (dismissAfter < defaultMaxTimer) timer = dismissAfter;
    }
    return timer;
}
const $fe5170bdd3625759$var$withLogic$W = (Component)=>(userProps)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$f);
        const { onClose: onClose, onShow: onShow, primaryCTA: primaryCTA, secondaryCTA: secondaryCTA, showClose: showClose, id: userId, suffix: suffix, dismissAfter: dismissAfter, ...rest } = props;
        const uniqueId = userId || `toast-${Math.random().toString(36).substr(2, 9)}`;
        const [closeToast, setCloseToast] = (0, $acw62.useState)();
        const [timeToClose, setTimeToClose] = (0, $acw62.useState)(0);
        const [intervalID, setIntervalID] = (0, $acw62.useState)();
        const { rootRef: rootRef, element: element } = $fe5170bdd3625759$var$useRootRef();
        const isCTAPresent = !!(primaryCTA || secondaryCTA);
        const TOAST_CLOSING_TIME = $fe5170bdd3625759$var$getDismissTime(isCTAPresent, dismissAfter);
        const platformClass = $fe5170bdd3625759$var$getPlatform() === "mobile" ? "mobile-toast" : "desktop-toast";
        const [toastQueue, setToastQueue] = (0, $acw62.useState)([]);
        const [timeouts, setTimeouts] = (0, $acw62.useState)({});
        (0, $acw62.useEffect)(()=>{
            if (!toastQueue.includes(uniqueId)) setToastQueue((prevQueue)=>[
                    ...prevQueue,
                    uniqueId
                ]);
            const dismissTimer = setTimeout(()=>{
                setToastQueue((prevQueue)=>prevQueue.filter((id)=>id !== uniqueId));
                handleToastUnmount();
            }, TOAST_CLOSING_TIME * 1e3);
            setTimeouts((prevTimeouts)=>({
                    ...prevTimeouts,
                    [uniqueId]: dismissTimer
                }));
            return ()=>{
                clearTimeout(dismissTimer);
                setTimeouts((prevTimeouts)=>{
                    const newTimeouts = {
                        ...prevTimeouts
                    };
                    delete newTimeouts[uniqueId];
                    return newTimeouts;
                });
            };
        }, [
            uniqueId,
            TOAST_CLOSING_TIME
        ]);
        const handleToastUnmount = (0, $acw62.useCallback)(()=>{
            console.log("unmount");
            setToastQueue((prevQueue)=>prevQueue.filter((id)=>id !== uniqueId));
            if ($fe5170bdd3625759$var$toast && typeof $fe5170bdd3625759$var$toast.dismiss === "function") $fe5170bdd3625759$var$toast.dismiss(uniqueId);
            onClose?.(uniqueId);
            if (timeouts[uniqueId]) {
                clearTimeout(timeouts[uniqueId]);
                setTimeouts((prevTimeouts)=>{
                    const newTimeouts = {
                        ...prevTimeouts
                    };
                    delete newTimeouts[uniqueId];
                    return newTimeouts;
                });
            }
            if (element?.classList.contains("visible") && timeouts[uniqueId]) element.classList.remove("visible");
            setCloseToast(true);
        }, [
            uniqueId,
            onClose,
            timeouts
        ]);
        const handleToastStart = (0, $acw62.useCallback)(()=>{
            console.log("mount");
            if (timeToClose <= TOAST_CLOSING_TIME) {
                const intervalID2 = setInterval(()=>{
                    setTimeToClose((time)=>{
                        if (time === 10) clearInterval(intervalID2);
                        return time + 0.5;
                    });
                }, 500);
                setIntervalID(intervalID2);
            }
        }, [
            TOAST_CLOSING_TIME,
            timeToClose
        ]);
        const handleToastPause = (0, $acw62.useCallback)(()=>{
            if (timeToClose !== TOAST_CLOSING_TIME) clearInterval(intervalID);
        }, [
            timeToClose,
            TOAST_CLOSING_TIME,
            intervalID
        ]);
        (0, $acw62.useEffect)(()=>{
            uniqueId && onShow && onShow(uniqueId);
            setTimeout(()=>setCloseToast(false), 10);
            const toastElement = document.querySelector($fe5170bdd3625759$var$TOAST_SELECTOR);
            if (toastElement) {
                toastElement.setAttribute("tabindex", "0");
                toastElement.focus();
            }
            const { unsubscribe: toastCloseUnsubscribe } = $fe5170bdd3625759$var$subscribe($fe5170bdd3625759$var$NotificationCloseService, (data)=>{
                if (uniqueId && data[uniqueId] === "toast") handleToastClose();
            });
            if (window) {
                handleToastStart();
                window.addEventListener("blur", handleToastPause);
                window.addEventListener("focus", handleToastStart);
            }
            return ()=>{
                if (window) {
                    window.removeEventListener("blur", handleToastPause);
                    window.removeEventListener("focus", handleToastStart);
                }
                uniqueId && onClose && onClose(uniqueId);
                toastCloseUnsubscribe();
            };
        }, [
            uniqueId
        ]);
        (0, $acw62.useEffect)(()=>{
            if (timeToClose === TOAST_CLOSING_TIME) handleToastClose();
        }, [
            timeToClose,
            TOAST_CLOSING_TIME
        ]);
        const handleToastClose = ()=>{
            setCloseToast(true);
        };
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                onClose: handleToastUnmount,
                onMouseEnter: ()=>{
                    handleToastPause();
                },
                onMouseLeave: ()=>{
                    handleToastStart();
                },
                ...rest,
                prefix: $fe5170bdd3625759$var$resolvePrefixIcon(props),
                open: true,
                suffix: suffix?.props ? suffix : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$var$NotificationButton, {
                    ...suffix
                }),
                className: `v1 ${closeToast === false ? "visible" : ""} ${platformClass}`,
                rootRef: rootRef,
                _hasCTA: Boolean(primaryCTA || secondaryCTA),
                _hasDescription: Boolean(rest.description),
                _platform: $fe5170bdd3625759$var$getPlatform(),
                showClose: showClose,
                primaryCTA: primaryCTA,
                secondaryCTA: secondaryCTA
            }
        });
    };
const $fe5170bdd3625759$var$PROP_MAP$e = (props)=>{
    return {
        primaryCTA: {
            properties: {
                primaryCTA: $fe5170bdd3625759$var$resolvePropObjectKeys(props.primaryCTA, "title", ""),
                onPrimaryClick: props.primaryCTA?.onClick
            }
        },
        secondaryCTA: {
            properties: {
                secondaryCTA: $fe5170bdd3625759$var$resolvePropObjectKeys(props.secondaryCTA, "title", ""),
                onPrimaryClick: props.secondaryCTA?.onClick
            }
        }
    };
};
const $fe5170bdd3625759$var$NUDGE_CLOSING_TIME = 5;
const $fe5170bdd3625759$var$withLogic$V = (Component)=>(userProps)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$e);
        const { primaryCTA: primaryCTA, secondaryCTA: secondaryCTA, showClose: showClose, id: id, onShow: onShow, onClose: onClose, suffix: suffix, maxLines: maxLines, ...rest } = props;
        const { element: element, rootRef: rootRef } = $fe5170bdd3625759$var$useRootRef();
        const [closeNudge, setCloseNudge] = (0, $acw62.useState)(true);
        const [timeToClose, setTimeToClose] = (0, $acw62.useState)(0);
        const [intervalID, setIntervalID] = (0, $acw62.useState)();
        const defaultMaxLine = 1;
        const isCTAGroupAbsent = !(primaryCTA && secondaryCTA || (primaryCTA || secondaryCTA) && showClose);
        const handleNudgeUnmount = (0, $acw62.useCallback)(()=>{
            if (id) {
                $fe5170bdd3625759$var$nudge.dismiss(id);
                if (element?.classList.contains("visible")) element.classList.remove("visible");
                onClose?.(id);
                setCloseNudge(true);
            }
        }, [
            id,
            onClose
        ]);
        (0, $acw62.useEffect)(()=>{
            id && onShow && onShow(id);
            setTimeout(()=>setCloseNudge(false), 10);
            const { unsubscribe: nudgeCloseUnsubscribe } = $fe5170bdd3625759$var$subscribe($fe5170bdd3625759$var$NotificationCloseService, (data)=>{
                if (id && data[id] === "nudge") handleNudgeClose();
            });
            if (window) {
                handleNudgeStart();
                window.addEventListener("blur", handleNudgePause);
                window.addEventListener("focus", handleNudgeStart);
            }
            return ()=>{
                if (window) {
                    window.removeEventListener("blur", handleNudgePause);
                    window.removeEventListener("focus", handleNudgeStart);
                }
                id && onClose && onClose(id);
                nudgeCloseUnsubscribe();
            };
        }, [
            id
        ]);
        (0, $acw62.useEffect)(()=>{
            if (isCTAGroupAbsent && timeToClose >= $fe5170bdd3625759$var$NUDGE_CLOSING_TIME) handleNudgeUnmount();
        }, [
            timeToClose,
            handleNudgeUnmount,
            isCTAGroupAbsent
        ]);
        const handleNudgeStart = ()=>{
            if (isCTAGroupAbsent && timeToClose !== $fe5170bdd3625759$var$NUDGE_CLOSING_TIME) {
                const intervalID2 = setInterval(()=>{
                    setTimeToClose((time)=>{
                        if (time === 10) {
                            clearInterval(intervalID2);
                            return time;
                        }
                        return time + 0.5;
                    });
                }, 500);
                setIntervalID(intervalID2);
            }
        };
        const handleNudgePause = ()=>{
            if (isCTAGroupAbsent && timeToClose !== $fe5170bdd3625759$var$NUDGE_CLOSING_TIME) clearInterval(intervalID);
        };
        const handleNudgeClose = ()=>{
            setCloseNudge(true);
        };
        (0, $acw62.useEffect)(()=>{
            if (element) {
                const el = element.querySelector('[data-testid="JDSNudge-support-jds-text"]');
                if (el) el.style.setProperty("--max-lines", `${maxLines || defaultMaxLine}`);
            }
        }, [
            element,
            maxLines
        ]);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                onClose: handleNudgeUnmount,
                onMouseEnter: ()=>{
                    handleNudgePause();
                },
                onMouseLeave: ()=>{
                    handleNudgeStart();
                },
                ...rest,
                prefix: $fe5170bdd3625759$var$resolvePrefixIcon(props),
                suffix: suffix?.props ? suffix : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$var$NotificationButton, {
                    ...suffix
                }),
                rootRef: rootRef,
                open: true,
                className: closeNudge === false ? "visible" : "",
                showClose: showClose,
                primaryCTA: primaryCTA,
                secondaryCTA: secondaryCTA,
                maxLines: maxLines ?? defaultMaxLine,
                _platform: $fe5170bdd3625759$var$getPlatform(),
                _hasCTA: Boolean(primaryCTA || secondaryCTA),
                _hasDescription: Boolean(rest.description)
            }
        });
    };
const $fe5170bdd3625759$var$Component$Z = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$V;
    const { open: open = false, showClose: showClose = true, onShow: onShow = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onHover: onHover = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onUpdate: onUpdate = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onHoverEnd: onHoverEnd = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onClose: onClose = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSecondaryClick: onSecondaryClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onPrimaryClick: onPrimaryClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), ariaLabel: ariaLabel = props.title?.toString(), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            open: open,
            showClose: showClose,
            onShow: onShow,
            onHover: onHover,
            onUpdate: onUpdate,
            onHoverEnd: onHoverEnd,
            onClose: onClose,
            onSecondaryClick: onSecondaryClick,
            onPrimaryClick: onPrimaryClick,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSNudge", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$var$Nudge = $fe5170bdd3625759$var$withLogic$V($fe5170bdd3625759$var$Component$Z);
$fe5170bdd3625759$var$Nudge.displayName = "Nudge";
$fe5170bdd3625759$var$Nudge.slotName = "jds_nudge";
const $fe5170bdd3625759$var$sdl$U = {
    "metadata": {
        "version": "1.0.0",
        "id": "pagination-button-1.0.0",
        "name": "JDSPaginationButton",
        "layerName": "jds_pagination_button"
    },
    "hierarchy": {
        "container": [
            {
                "inner-container": [
                    "jds-text"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "size": "{p_0}",
            "justify-content": "{p_1}",
            "align-items": "{p_2}",
            "behavior": {
                "hover": {},
                "focus": {},
                "active": {}
            }
        },
        "inner-container": {
            "background-color": "{p_3}",
            "flex-direction": "{p_4}",
            "justify-content": "{p_5}",
            "align-items": "{p_6}",
            "border-radius": "{p_7}",
            "width": "{p_8}",
            "height": "{p_9}",
            "opacity": "{p_10}",
            "gap": "{p_11}",
            "border-color": "{p_12}",
            "behavior": {
                "hover": {
                    "background-color": "{p_13}"
                },
                "active": {
                    "background-color": "{p_14}"
                },
                "focus": {
                    "border-width": "{p_15}"
                }
            }
        },
        "jds-text": {
            "font-family": "{button}",
            "color": "{primary40}",
            "font-size": "{button}",
            "line-height": "{button}",
            "letter-spacing": "{button}",
            "font-weight": "{button}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false,
            "behavior": {
                "hover": {
                    "color": "{primary60}"
                },
                "active": {
                    "color": "{primary60}"
                },
                "focus": {
                    "color": "{primary60}"
                }
            }
        }
    },
    "variant": {
        "state": {
            "selected": {
                "inner-container": {
                    "background-color": "{p_16}"
                },
                "jds-text": {
                    "color": "{primary30}"
                }
            },
            "ellipsis": {
                "container": {
                    "disabled": true
                },
                "inner-container": {
                    "background-color": "{p_17}"
                },
                "jds-text": {
                    "color": "{primaryGrey80}"
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "state": {
                "values": [
                    "default",
                    "selected",
                    "ellipsis"
                ]
            }
        },
        "data": {
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "text"
                }
            }
        },
        "events": {
            "container": {
                "onClick": "onClick",
                "onFocus": {
                    "name": "onFocus",
                    "platform": "web"
                },
                "onBlur": {
                    "name": "onBlur",
                    "platform": "web"
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "button"
                    },
                    "aria-current": "_ariaCurrent"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$U = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                _ariaCurrent: props.state === "selected" ? "page" : void 0
            }
        });
    };
const $fe5170bdd3625759$var$Component$Y = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$U;
    const { state: state = "default", onClick: onClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onFocus: onFocus = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onBlur: onBlur = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            state: state,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            ...rest
        },
        componentTag: componentTag
    }, "JDSPaginationButton", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$c3639e97caabff2c = $fe5170bdd3625759$var$withLogic$U($fe5170bdd3625759$var$Component$Y);
$fe5170bdd3625759$export$c3639e97caabff2c.displayName = "PaginationButton";
$fe5170bdd3625759$export$c3639e97caabff2c.slotName = "jds_pagination_button";
const $fe5170bdd3625759$var$sdl$T = {
    "metadata": {
        "version": "1.0.0",
        "id": "progress-bar-1.0.0",
        "name": "JDSProgressBar",
        "layerName": "jds_progress_bar"
    },
    "hierarchy": {
        "container": [
            {
                "top-container": [
                    "jds-text",
                    "value-jds-text"
                ]
            },
            {
                "determinate-container": [
                    "active-container",
                    "invisible-container"
                ]
            },
            {
                "indeterminate-container": [
                    "track-container",
                    "active-animatedContainer"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "hidden": false,
            "flex-direction": "{p_0}",
            "justify-content": "{p_1}",
            "align-items": "{p_2}",
            "gap": "{p_3}",
            "width": "{p_4}",
            "background-color": "{p_5}"
        },
        "top-container": {
            "hidden": false,
            "show": false,
            "background-color": "{p_6}",
            "flex-direction": "{p_7}",
            "justify-content": "{p_8}",
            "align-items": "{p_9}",
            "width": "{p_10}",
            "gap": "{p_11}"
        },
        "determinate-container": {
            "hidden": false,
            "background-color": "{p_12}",
            "height": "{p_13}",
            "width": "{p_14}",
            "flex-direction": "{p_15}",
            "justify-content": "{p_16}",
            "align-items": "{p_17}",
            "border-radius": "{p_18}"
        },
        "active-container": {
            "background-color": "{p_19}",
            "height": "{p_20}",
            "border-radius": "{p_21}",
            "show": true
        },
        "invisible-container": {
            "height": "{p_22}",
            "show": true
        },
        "indeterminate-container": {
            "hidden": true,
            "flex-direction": "{p_23}",
            "background-color": "{p_24}",
            "height": "{p_25}",
            "width": "{p_26}",
            "border-radius": "{p_27}",
            "overflow": "hidden"
        },
        "track-container": {
            "height": "{p_28}",
            "show": true
        },
        "active-animatedContainer": {
            "height": "{p_29}",
            "width": "{p_30}",
            "background-color": "{p_31}",
            "z-index": 1,
            "border-radius": "{p_32}",
            "animation-curve": "entrance_ease",
            "animation-duration": 1e3
        },
        "jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey100}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        },
        "value-jds-text": {
            "font-family": "{bodySBold}",
            "color": "{primary60}",
            "font-size": "{bodySBold}",
            "line-height": "{bodySBold}",
            "letter-spacing": "{bodySBold}",
            "font-weight": "{bodySBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "kind": {
            "indeterminate": {
                "determinate-container": {
                    "hidden": true
                },
                "indeterminate-container": {
                    "hidden": false
                }
            }
        },
        "state": {
            "success": {
                "active-container": {
                    "background-color": "{p_33}"
                },
                "active-animatedContainer": {
                    "background-color": "{p_34}"
                }
            },
            "error": {
                "active-container": {
                    "background-color": "{p_35}"
                },
                "active-animatedContainer": {
                    "background-color": "{p_36}"
                }
            },
            "warning": {
                "active-container": {
                    "background-color": "{p_37}"
                },
                "active-animatedContainer": {
                    "background-color": "{p_38}"
                }
            }
        },
        "labelPosition": {
            "center": {
                "top-container": {
                    "justify-content": "{p_39}"
                }
            }
        },
        "_hasValueLabel": {
            "false": {
                "value-jds-text": {
                    "hidden": true
                }
            }
        },
        "_hasLabel": {
            "false": {
                "jds-text": {
                    "hidden": true
                }
            }
        },
        "_hasLabelOrValueLabel": {
            "false": {
                "top-container": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {
            "stretch": {
                "false": {
                    "top-container": {
                        "justify-content": "{justifyContent.start}"
                    },
                    "value-jds-text": {
                        "hidden": true
                    }
                }
            }
        },
        {
            "stretch": {
                "false": {
                    "top-container": {
                        "justify-content": "{justifyContent.end}"
                    },
                    "jds-text": {
                        "hidden": true
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "labelPosition",
            "_hasValueLabel"
        ],
        [
            "labelPosition",
            "_hasLabel"
        ]
    ],
    "api": {
        "data": {
            "active-container": {
                "flex": {
                    "type": "float",
                    "name": "value",
                    "function": true,
                    "doc_description": "It takes user input for value of progress bar."
                }
            },
            "invisible-container": {
                "flex": {
                    "type": "float",
                    "name": "_invisible"
                }
            },
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "label",
                    "doc_description": "It displays the main label of Progess Bar."
                }
            },
            "value-jds-text": {
                "value": {
                    "type": "string",
                    "name": "valueLabel",
                    "doc_description": "It displays the support label of Progess Bar."
                }
            }
        },
        "config": {
            "kind": {
                "values": [
                    "determinate",
                    "indeterminate"
                ],
                "doc_description": "It can be used to switch between 2 variants of progess bar."
            },
            "labelPosition": {
                "values": [
                    "stretch",
                    "center"
                ],
                "doc_description": "It can be used align label of progress bar to center or at the ends of progress bar."
            },
            "state": {
                "type": "JDSFeedbackBlock.state",
                "doc_description": "It can be used to choose between states i.e. 'success','warning','error','none'.By default it is 'none'.This can be dynamically changed as per user's form handling.",
                "values": [
                    "none",
                    "success",
                    "error",
                    "warning"
                ]
            },
            "_hasLabelOrValueLabel": {
                "values": [
                    true,
                    false
                ]
            },
            "_hasLabel": {
                "values": [
                    true,
                    false
                ]
            },
            "_hasValueLabel": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "progressbar"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label",
                        "function": true
                    },
                    "aria-valuenow": {
                        "name": "_ariaValuenow",
                        "platform": "web,ios"
                    },
                    "aria-valuemin": {
                        "name": "_ariaValuemin",
                        "platform": "web,ios"
                    },
                    "aria-valuemax": {
                        "name": "_ariaValuemax",
                        "platform": "web,ios"
                    },
                    "aria-busy": {
                        "name": "ariaBusy",
                        "function": true
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$PROP_MAP$d = (props)=>({
        type: {
            properties: {
                kind: props.type
            }
        }
    });
const $fe5170bdd3625759$var$withLogic$T = (Component)=>(userProps)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$d);
        const { value: value = 0, ...rest } = props;
        const min = 0;
        const max = value < 1 ? 1 : 100;
        const calculatedValue = value / (max - min);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...rest,
                value: calculatedValue,
                _invisible: 1 - calculatedValue,
                _ariaValuenow: props.kind === "indeterminate" ? void 0 : props.value,
                _ariaValuemin: props.kind === "indeterminate" ? void 0 : "0",
                _ariaValuemax: props.kind === "indeterminate" ? void 0 : "100",
                ariaBusy: props.kind === "indeterminate" ? "true" : props.ariaBusy
            }
        });
    };
const $fe5170bdd3625759$var$Component$X = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$T;
    const { kind: kind = "determinate", labelPosition: labelPosition = "stretch", state: state = "undefined", ariaLabel: ariaLabel = props.label?.toString(), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            labelPosition: labelPosition,
            state: state,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSProgressBar", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$c17561cb55d4db30 = $fe5170bdd3625759$var$withLogic$T($fe5170bdd3625759$var$Component$X);
$fe5170bdd3625759$export$c17561cb55d4db30.displayName = "ProgressBar";
$fe5170bdd3625759$export$c17561cb55d4db30.slotName = "jds_progress_bar";
const $fe5170bdd3625759$var$sdl$S = {
    "metadata": {
        "version": "1.0.0",
        "id": "Rating-bar-item-1.0.0",
        "name": "JDSRatingBarItem",
        "layerName": "jds_rating_bar_item"
    },
    "hierarchy": {
        "container": [
            {
                "start-container": [
                    "start-icon"
                ]
            },
            {
                "end-container": [
                    "end-icon"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{r_0}",
            "behavior": {
                "focus": {
                    "border-width": "{r_1}",
                    "border-color": "{r_2}"
                }
            }
        },
        "start-container": {
            "clip-first-half": true
        },
        "start-icon": {
            "size": "{l}",
            "color": "{primaryGrey80}",
            "value": "ic_star"
        },
        "end-container": {
            "hidden": true,
            "clip-first-half": false,
            "z-index": 1
        },
        "end-icon": {
            "size": "{l}",
            "color": "{primaryGrey80}",
            "value": "ic_star"
        }
    },
    "variant": {
        "size": {
            "small": {
                "start-icon": {
                    "size": "{r_3}"
                },
                "end-icon": {
                    "size": "{r_4}"
                }
            },
            "large": {
                "start-icon": {
                    "size": "{r_5}"
                },
                "end-icon": {
                    "size": "{r_6}"
                }
            }
        },
        "isInteractive": {
            "false": {
                "container": {
                    "disabled": true
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{r_7}"
                }
            }
        },
        "isHalfRated": {
            "true": {
                "end-container": {
                    "hidden": false
                }
            }
        }
    },
    "combination": [
        {
            "false": {
                "false": {
                    "false": {
                        "start-icon": {
                            "color": "{r_8}"
                        },
                        "end-icon": {
                            "color": "{r_9}"
                        }
                    },
                    "true": {
                        "start-icon": {
                            "color": "{r_10}"
                        },
                        "end-icon": {
                            "color": "{r_11}"
                        }
                    }
                },
                "true": {
                    "false": {
                        "start-icon": {
                            "color": "{r_12}"
                        },
                        "end-icon": {
                            "color": "{r_13}"
                        }
                    },
                    "true": {
                        "start-icon": {
                            "color": "{r_14}"
                        },
                        "end-icon": {
                            "color": "{r_15}"
                        }
                    }
                }
            },
            "true": {
                "false": {
                    "false": {
                        "container": {
                            "behavior": {
                                "focus": {
                                    "border-width": "{r_16}",
                                    "border-color": "{r_18}"
                                }
                            }
                        },
                        "start-icon": {
                            "color": "{r_20}",
                            "behavior": {
                                "active": {
                                    "color": "{r_24}"
                                }
                            }
                        },
                        "end-icon": {
                            "color": "{r_21}",
                            "behavior": {
                                "active": {
                                    "color": "{r_25}"
                                }
                            }
                        }
                    },
                    "true": {
                        "container": {
                            "behavior": {
                                "focus": {
                                    "border-width": "{r_17}",
                                    "border-color": "{r_19}"
                                }
                            }
                        },
                        "start-icon": {
                            "color": "{primary50}",
                            "behavior": {
                                "active": {
                                    "color": "{primary70}"
                                }
                            }
                        },
                        "end-icon": {
                            "color": "{primary50}",
                            "behavior": {
                                "active": {
                                    "color": "{primary70}"
                                }
                            }
                        }
                    }
                },
                "true": {
                    "false": {
                        "container": {
                            "behavior": {
                                "focus": {
                                    "border-width": "{r_28}",
                                    "border-color": "{r_26}"
                                }
                            }
                        },
                        "start-icon": {
                            "color": "{r_30}",
                            "behavior": {
                                "active": {
                                    "color": "{r_34}"
                                }
                            }
                        },
                        "end-icon": {
                            "color": "{r_31}",
                            "behavior": {
                                "active": {
                                    "color": "{r_35}"
                                }
                            }
                        }
                    },
                    "true": {
                        "container": {
                            "behavior": {
                                "focus": {
                                    "border-width": "{r_29}",
                                    "border-color": "{r_27}"
                                }
                            }
                        },
                        "start-icon": {
                            "color": "{r_32}",
                            "behavior": {
                                "active": {
                                    "color": "{r_34}"
                                }
                            }
                        },
                        "end-icon": {
                            "color": "{r_33}",
                            "behavior": {
                                "active": {
                                    "color": "{r_35}"
                                }
                            }
                        }
                    }
                }
            }
        },
        {
            "false": {
                "true": {
                    "start-icon": {
                        "color": "{r_38}"
                    },
                    "end-icon": {
                        "color": "{r_39}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "isInteractive",
            "isActive",
            "isHovered"
        ],
        [
            "isInteractive",
            "isHalfRated"
        ]
    ],
    "api": {
        "config": {
            "size": {
                "values": [
                    "medium",
                    "small",
                    "large"
                ]
            },
            "isInteractive": {
                "values": [
                    false,
                    true
                ]
            },
            "isActive": {
                "values": [
                    false,
                    true
                ]
            },
            "isHovered": {
                "values": [
                    false,
                    true
                ]
            },
            "isHalfRated": {
                "values": [
                    false,
                    true
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "start-container": {
                "clip-value": {
                    "type": "clipValueSize",
                    "name": "clipValue",
                    "function": true
                }
            },
            "end-container": {
                "clip-value": {
                    "type": "clipValueSize",
                    "name": "_updatedClipValue"
                }
            }
        },
        "events": {
            "container": {
                "onClick": "onClick",
                "onFocus": {
                    "name": "onFocus",
                    "platform": "web"
                },
                "onBlur": {
                    "name": "onBlur",
                    "platform": "web"
                },
                "onHover": {
                    "name": "onHover",
                    "platform": "web"
                },
                "onHoverEnd": {
                    "name": "onHoverEnd",
                    "platform": "web"
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "name": "_role"
                    },
                    "aria-label": {
                        "name": "ariaLabel"
                    },
                    "aria-checked": {
                        "name": "ariaChecked"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$S = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                _role: props.type === "interactive" ? "radio" : void 0
            },
            onHover: ()=>{
                props.onMouseEnter?.(props.internalIndex);
            },
            onHoverEnd: ()=>{
                props.onMouseLeave?.(-1);
            },
            onClick: ()=>{
                props.onClick?.(props.internalIndex);
            },
            _updatedClipValue: props.clipValue !== void 0 ? `${((1 - Number(props.clipValue?.slice(0, -1)) / 100) * 100).toString()}%` : void 0
        });
    };
const $fe5170bdd3625759$var$Component$W = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$S;
    const { size: size = "medium", isInteractive: isInteractive = false, isActive: isActive = false, isHovered: isHovered = false, isHalfRated: isHalfRated = false, disabled: disabled = false, onClick: onClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onFocus: onFocus = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onBlur: onBlur = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onHover: onHover = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onHoverEnd: onHoverEnd = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            size: size,
            isInteractive: isInteractive,
            isActive: isActive,
            isHovered: isHovered,
            isHalfRated: isHalfRated,
            disabled: disabled,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            onHover: onHover,
            onHoverEnd: onHoverEnd,
            ...rest
        },
        componentTag: componentTag
    }, "JDSRatingBarItem", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$b473c78e8d3557fd = $fe5170bdd3625759$var$withLogic$S($fe5170bdd3625759$var$Component$W);
$fe5170bdd3625759$export$b473c78e8d3557fd.displayName = "RatingBarItem";
$fe5170bdd3625759$export$b473c78e8d3557fd.slotName = "jds_rating_bar_item";
const $fe5170bdd3625759$var$sdl$R = {
    "metadata": {
        "version": "1.0.0",
        "id": "search-box-1.0.0",
        "name": "JDSSearchBox",
        "layerName": "jds_search_box",
        "description": "The search pattern allows users to quickly find relevant content by typing a querry",
        "usage": "The Search function is triggered as soon as the user focuses in the search field or hits on the search icon. Initially he can see a list of recent searches and quick links but as soon as he starts typing he would see suggestions relevant with his querry."
    },
    "hierarchy": {
        "container": [
            {
                "prefix-container": [
                    "prefix-icon"
                ]
            },
            "input",
            {
                "suffix-container": [
                    "suffix-icon"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "opacity": "{s_10}",
            "background-color": "{s_0}",
            "flex-direction": "{s_1}",
            "justify-content": "{s_2}",
            "align-items": "{s_3}",
            "padding-right": "{s_4}",
            "padding-left": "{s_5}",
            "width": "{s_6}",
            "height": "{s_7}",
            "border-radius": "{s_8}",
            "gap": "{s_9}",
            "behavior": {
                "focus": {
                    "border-color": "{s_11}",
                    "border-width": "{s_12}"
                },
                "active": {
                    "background-color": "{s_13}"
                }
            }
        },
        "input": {
            "type": "search",
            "text-align": "{s_14}",
            "placeholder-color": "{s_15}",
            "placeholder-font-family": "{s_16}",
            "placeholder-font-size": "{s_17}",
            "placeholder-line-height": "{s_18}",
            "placeholder-letter-spacing": "{s_19}",
            "placeholder-font-weight": "{s_20}",
            "input-color": "{s_21}",
            "input-font-family": "{s_22}",
            "input-font-size": "{s_23}",
            "input-line-height": "{s_24}",
            "input-letter-spacing": "{s_25}",
            "input-font-weight": "{s_26}",
            "cursor-color": "{s_27}",
            "width": "{size.max}",
            "disabled": false,
            "flex": 1,
            "behavior": {
                "hover": {
                    "placeholder-color": "{s_28}"
                },
                "focus": {
                    "placeholder-color": "{s_29}"
                },
                "active": {
                    "placeholder-color": "{s_30}"
                }
            }
        },
        "prefix-container": {
            "flex-direction": "{s_31}",
            "justify-content": "{s_32}",
            "align-items": "{s_33}"
        },
        "prefix-icon": {
            "size": "{s_34}",
            "color": "{s_35}",
            "behavior": {
                "hover": {
                    "color": "{s_36}"
                },
                "focus": {
                    "color": "{s_37}"
                },
                "active": {
                    "color": "{s_38}"
                }
            }
        },
        "suffix-container": {
            "flex-direction": "{s_39}",
            "justify-content": "{s_40}",
            "align-items": "{s_41}"
        },
        "suffix-icon": {
            "size": "{s_42}",
            "color": "{s_43}",
            "behavior": {
                "hover": {
                    "color": "{s_44}"
                },
                "focus": {
                    "color": "{s_45}"
                },
                "active": {
                    "color": "{s_46}"
                }
            }
        }
    },
    "variant": {
        "kind": {
            "header": {
                "container": {
                    "background-color": "{s_47}",
                    "behavior": {
                        "focus": {
                            "border-color": "{s_48}",
                            "border-width": 4
                        },
                        "active": {
                            "background-color": "{s_49}"
                        }
                    }
                },
                "prefix-icon": {
                    "color": "{s_50}",
                    "behavior": {
                        "hover": {
                            "color": "{s_51}"
                        },
                        "active": {
                            "color": "{s_52}"
                        }
                    }
                },
                "suffix-icon": {
                    "color": "{s_53}",
                    "behavior": {
                        "hover": {
                            "color": "{s_54}"
                        },
                        "active": {
                            "color": "{s_55}"
                        }
                    }
                },
                "input": {
                    "input-color": "{s_56}",
                    "placeholder-color": "{s_57}",
                    "cursor-color": "{s_58}",
                    "behavior": {
                        "hover": {
                            "placeholder-color": "{s_59}"
                        }
                    }
                }
            },
            "light_background": {
                "container": {
                    "background-color": "{s_60}",
                    "border-color": "{s_61}",
                    "border-width": "{s_65}",
                    "behavior": {
                        "hover": {
                            "background-color": "{s_60}",
                            "border-color": "{s_62}"
                        },
                        "focus": {
                            "background-color": "{s_60}",
                            "border-color": "{s_63}",
                            "border-width": "{s_66}"
                        },
                        "active": {
                            "background-color": "{s_60}",
                            "border-color": "{s_64}"
                        }
                    }
                },
                "input": {
                    "input-color": "{s_67}",
                    "cursor-color": "{s_68}",
                    "behavior": {
                        "active": {
                            "placeholder-color": "{s_69}"
                        }
                    }
                },
                "prefix-icon": {
                    "color": "{s_70}",
                    "behavior": {
                        "hover": {
                            "color": "{s_71}"
                        },
                        "focus": {
                            "color": "{s_72}"
                        },
                        "active": {
                            "color": "{s_73}"
                        }
                    }
                },
                "suffix-icon": {
                    "color": "{s_74}",
                    "behavior": {
                        "active": {
                            "color": "{s_75}"
                        }
                    }
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{s_76}"
                },
                "prefix-container": {
                    "disabled": true
                },
                "suffix-container": {
                    "disabled": true
                },
                "input": {
                    "disabled": true
                }
            }
        },
        "_isValueEmpty": {
            "false": {
                "suffix-icon": {
                    "color": "{s_77}"
                }
            }
        },
        "_inputFocus": {
            "true": {
                "input": {
                    "placeholder-color": "{s_79}"
                }
            }
        }
    },
    "combination": [
        {
            "header": {
                "false": {
                    "suffix-icon": {
                        "color": "{s_78}"
                    }
                }
            },
            "light_background": {
                "false": {
                    "suffix-icon": {
                        "color": "{s_80}"
                    }
                }
            }
        },
        {
            "light_background": {
                "true": {
                    "container": {
                        "border-color": "{s_81}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "kind",
            "_isValueEmpty"
        ],
        [
            "kind",
            "_inputFocus"
        ]
    ],
    "api": {
        "config": {
            "kind": {
                "values": [
                    "normal",
                    "header",
                    "light_background"
                ],
                "doc_description": "It determines if SearchBox is to be used on header or normal background."
            },
            "disabled": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to enable or disable SearchBox."
            },
            "_isValueEmpty": {
                "values": [
                    true,
                    false
                ]
            },
            "_inputFocus": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "input": {
                "value": {
                    "type": "string",
                    "name": "value",
                    "doc_description": "It takes user input for text to be searched."
                },
                "name": {
                    "type": "string",
                    "name": "name",
                    "doc_description": "It displays name of search box."
                },
                "placeholder": {
                    "type": "string",
                    "name": "label",
                    "doc_description": "It displays placeholder text of search box."
                },
                "focusRequester": {
                    "type": "focusRequester",
                    "name": "focusRequester",
                    "platform": "android"
                },
                "imeAction": {
                    "type": "imeAction",
                    "name": "imeAction",
                    "platform": "android"
                },
                "max-length": {
                    "type": "number",
                    "name": "maxLength"
                }
            },
            "prefix-icon": {
                "value": {
                    "type": "icon",
                    "name": "prefix",
                    "function": true,
                    "doc_description": "It can be used to pass icon as prefix."
                }
            },
            "suffix-icon": {
                "value": {
                    "type": "icon",
                    "name": "suffix",
                    "doc_description": "It can be used to display icon on the right of search box."
                }
            },
            "container": {
                "_prefix.showBack": {
                    "type": "boolean",
                    "name": "showBack"
                }
            }
        },
        "events": {
            "input": {
                "onFocus": "onFocus",
                "onBlur": "onBlur",
                "onChange": "onChange",
                "onSubmit": "onSubmit",
                "onKeyup": {
                    "name": "onKeyup",
                    "platform": "web"
                },
                "onKeydown": {
                    "name": "onKeydown",
                    "platform": "web"
                }
            },
            "prefix-container": {
                "onClick": "onBack"
            },
            "suffix-container": {
                "onClick": "onSuffixClick"
            }
        },
        "a11y": {
            "prefix-icon": {
                "properties": {
                    "role": {
                        "value": "button"
                    },
                    "aria-label": {
                        "name": "prefixAriaLabel"
                    }
                }
            },
            "suffix-icon": {
                "properties": {
                    "role": {
                        "value": "button"
                    },
                    "aria-label": {
                        "name": "suffixAriaLabel"
                    }
                }
            },
            "container": {
                "properties": {
                    "role": {
                        "value": "search"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    }
                }
            },
            "input": {
                "name": "input",
                "properties": {
                    "role": {
                        "value": "searchbox"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$R = (Component)=>(props)=>{
        const { onBack: onBack, ...rest } = props;
        const [typing, setTyping] = (0, $acw62.useState)(false);
        const [value, setValue] = (0, $acw62.useState)(props.value);
        const element = (0, $acw62.useRef)(null);
        const [focused, setFocused] = (0, $acw62.useState)(false);
        (0, $acw62.useEffect)(()=>{
            setValue(props.value);
        }, [
            props.value
        ]);
        const triggerChange = (value2 = "")=>{
            if (element) {
                const input = element?.current;
                const tracker = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value")?.set;
                tracker?.call(input, value2);
                const event = new Event("input", {
                    bubbles: true
                });
                input?.dispatchEvent(event);
            }
        };
        const formatIconName = (iconName)=>{
            if (typeof iconName === "string" && iconName.startsWith("Ic")) {
                const words = iconName.slice(2).match(/[A-Z][a-z]+/g);
                return words ? words.join(" ").toLowerCase() + " icon" : iconName;
            } else if (typeof iconName === "string" && iconName.startsWith("ic_")) {
                const words = iconName.slice(3).split("_");
                return words ? words.join(" ").toLowerCase() + " icon" : iconName;
            }
            return iconName;
        };
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...rest,
                value: value,
                prefixAriaLabel: props.prefixAriaLabel || formatIconName(props.prefix),
                suffixAriaLabel: props.suffixAriaLabel || formatIconName(props.suffix),
                onBack: ()=>{
                    if (focused && props.showBack) onBack?.(value || "");
                    else props.onPrefixClick?.(value);
                },
                prefix: props.showBack && focused ? "IcBack" : props.prefix,
                suffix: typing ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                    id: "suffix-container",
                    onMouseDown: (e)=>e.preventDefault(),
                    onClick: (e)=>{
                        e.stopPropagation();
                        props.onSuffixClick?.();
                    },
                    children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $41afd5d0591e38b4$export$464f071bbd2cc5e5), {})
                }) : props.suffix,
                onFocus: (ev)=>{
                    props.onFocus?.(ev);
                    setFocused(true);
                    setTyping(Boolean(ev.target.value));
                },
                _isValueEmpty: !typing,
                onBlur: (ev)=>{
                    props.onBlur?.(ev);
                    if (!ev.target.value) setFocused(false);
                    if (!(ev.relatedTarget?.id === "suffix-container")) setTyping(false);
                },
                onChange: (ev)=>{
                    setTyping(Boolean(ev.target.value));
                    props.onChange?.(ev);
                    setValue(ev.target.value);
                },
                layerRefs: {
                    input: element
                },
                _inputFocus: focused,
                onSuffixClick: ()=>{
                    props?.onSuffixClick?.();
                    if (typing) {
                        setValue("");
                        triggerChange("");
                        setTyping(false);
                    }
                }
            }
        });
    };
const $fe5170bdd3625759$var$Component$V = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$R;
    const { kind: kind = "normal", disabled: disabled = false, onFocus: onFocus = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onBlur: onBlur = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onChange: onChange = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSubmit: onSubmit = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onKeyup: onKeyup = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onBack: onBack = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSuffixClick: onSuffixClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), ariaLabel: ariaLabel = props.label?.toString(), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            disabled: disabled,
            onFocus: onFocus,
            onBlur: onBlur,
            onChange: onChange,
            onSubmit: onSubmit,
            onKeyup: onKeyup,
            onBack: onBack,
            onSuffixClick: onSuffixClick,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSSearchBox", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$5a58787633b0b5d8 = $fe5170bdd3625759$var$withLogic$R($fe5170bdd3625759$var$Component$V);
$fe5170bdd3625759$export$5a58787633b0b5d8.displayName = "SearchBox";
$fe5170bdd3625759$export$5a58787633b0b5d8.slotName = "jds_search_box";
const $fe5170bdd3625759$var$sdl$Q = {
    "metadata": {
        "version": "1.0.0",
        "id": "search-results-1.0.0",
        "name": "JDSSearchResults",
        "layerName": "jds_search_results"
    },
    "hierarchy": {
        "popup": [
            {
                "popup-container": [
                    "jds_search_results_internal"
                ]
            }
        ]
    },
    "base": {
        "popup": {
            "background-color": "{global.transparent}",
            "priority": 40,
            "hidden": true,
            "passive": true
        },
        "popup-container": {
            "flex-direction": "{flexDirection.stack}",
            "justify-content": "{justifyContent.center}",
            "width": "{size.max}",
            "background-color": "{global.transparent}",
            "border-radius": 0
        }
    },
    "variant": {
        "open": {
            "true": {
                "popup": {
                    "hidden": false
                }
            }
        },
        "appearance": {
            "box": {
                "jds_search_results_internal": {
                    "appearance": "box"
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "appearance": {
                "values": [
                    "normal",
                    "box"
                ],
                "doc_description": "This determines the appearance of search results, it can be 'normal or 'box'."
            },
            "open": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to open or close search result items."
            }
        },
        "data": {
            "jds_search_results_internal": {
                "maxWidth": {
                    "type": "size",
                    "name": "_maxWidth"
                },
                "header": {
                    "type": "string",
                    "name": "header",
                    "doc_description": "It is a heading that will display in the Header of the SearchResults."
                },
                "headerAction": {
                    "type": "string",
                    "name": "headerAction",
                    "doc_description": "If this is passed a button will appear on the right side of the Heading in the Header."
                },
                "results": {
                    "type": "list",
                    "name": "results",
                    "function": true,
                    "object": {
                        "icon": "icon",
                        "label": "string"
                    }
                },
                "results.label": {
                    "type": "string",
                    "name": "results.label"
                },
                "results.icon": {
                    "type": "icon",
                    "name": "results.icon"
                },
                "query": {
                    "type": "string",
                    "name": "query"
                }
            },
            "popup-container": {
                "padding-left": {
                    "type": "size",
                    "name": "offsetX"
                },
                "padding-top": {
                    "type": "size",
                    "name": "offsetY"
                }
            }
        },
        "events": {
            "jds_search_results_internal": {
                "onAppear": {
                    "name": "_onAppear",
                    "platform": "ios"
                },
                "onClick": "onClick",
                "onHeaderActionClick": "onHeaderActionClick",
                "onContainerClick": "_onContainerClick"
            },
            "popup": {
                "onClick": "onClose"
            }
        },
        "a11y": {
            "jds_search_results_internal": {
                "name": "results",
                "repeating": {
                    "ariaLabel": "resultAriaLabel",
                    "ariaDescribedby": {
                        "name": "resultAriaDescribedby",
                        "platform": "web,ios"
                    }
                },
                "properties": {
                    "headerActionAriaLabel": "headerActionAriaLabel",
                    "headerActionAriaDescribedby": {
                        "name": "headerActionAriaDescribedby",
                        "platform": "web,ios"
                    },
                    "ariaHidden": "headerActionAriaHidden"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$PROP_MAP$c = (props)=>({
        properties: {
            results: props.results?.map((r)=>({
                    ...r,
                    title: r.label,
                    icon: r.icon
                })),
            header: props.header,
            headerAction: props.headerAction?.title,
            onHeaderActionClick: props.headerAction?.onClick
        }
    });
const $fe5170bdd3625759$var$withLogic$Q = (Component)=>(userProps)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$c);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
                ...{
                    ...props,
                    _onContainerClick: (ev)=>ev.stopPropagation()
                }
            })
        });
    };
const $fe5170bdd3625759$var$Component$U = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$Q;
    const { appearance: appearance = "normal", open: open = false, onClick: onClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onHeaderActionClick: onHeaderActionClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onClose: onClose = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            appearance: appearance,
            open: open,
            onClick: onClick,
            onHeaderActionClick: onHeaderActionClick,
            onClose: onClose,
            ...rest
        },
        componentTag: componentTag
    }, "JDSSearchResults", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$aee53da69e9839be = $fe5170bdd3625759$var$withLogic$Q($fe5170bdd3625759$var$Component$U);
$fe5170bdd3625759$export$aee53da69e9839be.displayName = "SearchResults";
$fe5170bdd3625759$export$aee53da69e9839be.slotName = "jds_search_results";
const $fe5170bdd3625759$var$sdl$P = {
    "metadata": {
        "version": "1.0.0",
        "id": "search-results-1.0.0",
        "name": "JDSSearchResultsInternal",
        "layerName": "jds_search_results_internal"
    },
    "hierarchy": {
        "root-container": [
            {
                "container": [
                    {
                        "heading-container": [
                            "jds-text",
                            "jds_action_button"
                        ]
                    },
                    {
                        "results-container": [
                            "jds_search_result_item"
                        ]
                    }
                ]
            }
        ]
    },
    "base": {
        "root-container": {
            "background-color": "{primaryBackground}",
            "flex-direction": "{flexDirection.column}",
            "align-items": "{alignItems.center}",
            "padding-top": "{base}",
            "padding-right": "{base}",
            "padding-bottom": "{base}",
            "padding-left": "{base}",
            "gap": "{base}",
            "width": "{size.max}"
        },
        "container": {
            "width": "{size.max}",
            "flex-direction": "{flexDirection.column}",
            "align-items": "{alignItems.center}"
        },
        "heading-container": {
            "flex-direction": "{flexDirection.row}",
            "justify-content": "{justifyContent.spaceBetween}",
            "align-items": "{alignItems.start}",
            "width": "{size.max}"
        },
        "jds_action_button": {
            "kind": "tertiary",
            "size": "small",
            "appearance": "normal",
            "state": "normal",
            "iconPosition": "left",
            "stretch": false
        },
        "results-container": {
            "flex-direction": "{flexDirection.column}",
            "align-items": "{alignItems.start}",
            "gap": "{base}",
            "width": "{size.max}"
        },
        "jds-text": {
            "font-family": "{headingXs}",
            "color": "{primaryGrey100}",
            "font-size": "{headingXs}",
            "line-height": "{headingXs}",
            "letter-spacing": "{headingXs}",
            "font-weight": "{headingXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "appearance": {
            "box": {
                "root-container": {
                    "border-radius": "{xl}",
                    "box-shadow": {
                        "x": 0,
                        "y": 4,
                        "blur": 16,
                        "spread": 0,
                        "color": "#00000014"
                    }
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "appearance": {
                "values": [
                    "normal",
                    "box"
                ],
                "doc_description": "This determines the appearance of search results, it can be 'normal or 'box'."
            }
        },
        "data": {
            "container": {
                "max-width": {
                    "type": "size",
                    "name": "maxWidth"
                }
            },
            "jds_action_button": {
                "label": {
                    "type": "string",
                    "name": "headerAction",
                    "doc_description": "If this is passed a button will appear on the right side of the Heading in the Header."
                }
            },
            "results-container": {
                "value": {
                    "type": "list",
                    "name": "results",
                    "function": true,
                    "object": {
                        "icon": "icon",
                        "label": "string"
                    }
                }
            },
            "jds_search_result_item": {
                "label": {
                    "type": "string",
                    "name": "results.label"
                },
                "icon": {
                    "type": "icon",
                    "name": "results.icon"
                },
                "query": {
                    "type": "string",
                    "name": "query"
                }
            },
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "header",
                    "doc_description": "It is a heading that will display in the Header of the SearchResults."
                }
            }
        },
        "events": {
            "root-container": {
                "onAppear": {
                    "name": "onAppear",
                    "platform": "ios"
                }
            },
            "jds_search_result_item": {
                "onClick": "onClick"
            },
            "jds_action_button": {
                "onClick": "onHeaderActionClick"
            },
            "container": {
                "onClick": "onContainerClick"
            }
        },
        "a11y": {
            "jds_action_button": {
                "properties": {
                    "ariaLabel": "headerActionAriaLabel",
                    "ariaDescribedby": {
                        "name": "headerActionAriaDescribedby",
                        "platform": "web,ios"
                    },
                    "ariaHidden": {
                        "name": "ariaHidden",
                        "value": "true"
                    }
                }
            },
            "results-container": {
                "name": "results",
                "properties": {
                    "role": {
                        "value": "list"
                    }
                },
                "repeating": {
                    "ariaLabel": "resultAriaLabel",
                    "ariaDescribedby": {
                        "name": "resultAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_search_result_item": {
                "properties": {
                    "ariaLabel": "results.resultAriaLabel",
                    "ariaDescribedby": "results.resultAriaDescribedby"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$P = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$T = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$P;
    const { appearance: appearance = "normal", onAppear: onAppear = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onClick: onClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onHeaderActionClick: onHeaderActionClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onContainerClick: onContainerClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), ariaHidden: ariaHidden = "true", custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            appearance: appearance,
            onAppear: onAppear,
            onClick: onClick,
            onHeaderActionClick: onHeaderActionClick,
            onContainerClick: onContainerClick,
            ariaHidden: ariaHidden,
            ...rest
        },
        componentTag: componentTag
    }, "JDSSearchResultsInternal", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$49b46bbe543bdb4b = $fe5170bdd3625759$var$withLogic$P($fe5170bdd3625759$var$Component$T);
$fe5170bdd3625759$export$49b46bbe543bdb4b.displayName = "SearchResultsInternal";
$fe5170bdd3625759$export$49b46bbe543bdb4b.slotName = "jds_search_results_internal";
const $fe5170bdd3625759$var$sdl$O = {
    "metadata": {
        "version": "1.0.0",
        "id": "search-result-item-1.0.0",
        "name": "JDSSearchResultItem",
        "layerName": "jds_search_result_item"
    },
    "hierarchy": {
        "container": [
            "icon",
            {
                "text-container": [
                    "jds_search_result_text"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{s_0}",
            "gap": "{s_1}",
            "padding-top": "{s_2}",
            "padding-bottom": "{s_3}",
            "align-items": "{s_4}",
            "width": "{s_5}",
            "behavior": {
                "hover": {
                    "background-color": "{s_6}"
                },
                "active": {
                    "background-color": "{s_7}"
                },
                "focus": {
                    "background-color": "{s_8}"
                }
            }
        },
        "icon": {
            "size": "{s_9}",
            "color": "{s_10}"
        },
        "text-container": {
            "flex-direction": "{s_11}",
            "justify-content": "{s_12}",
            "align-items": "{s_13}"
        }
    },
    "variant": {},
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "data": {
            "container": {
                "_splitLabel.label": {
                    "type": "string",
                    "name": "label"
                },
                "_splitLabel.query": {
                    "type": "string",
                    "name": "query"
                }
            },
            "text-container": {
                "value": {
                    "type": "list",
                    "name": "_splitLabel",
                    "object": {
                        "bold": "boolean",
                        "text": "string"
                    }
                }
            },
            "jds_search_result_text": {
                "text": {
                    "type": "string",
                    "name": "_splitLabel.text"
                },
                "bold": {
                    "type": "boolean",
                    "name": "_splitLabel.bold"
                }
            },
            "icon": {
                "value": {
                    "type": "icon",
                    "name": "icon"
                }
            }
        },
        "events": {
            "container": {
                "onClick": "onClick"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "listitem"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$O = (Component)=>(props)=>{
        const { query: query = "", label: label = "", ...rest } = props;
        const index = label.indexOf(query);
        const leftPart = label.slice(0, index);
        const rightPart = label.slice(index + query.length, label.length);
        const labels = index >= 0 ? [
            leftPart,
            query,
            rightPart
        ] : [
            label
        ];
        const _splitLabel = labels.map((l)=>({
                text: l.replace(" ", "\xa0"),
                bold: query === l
            }));
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...rest,
                _splitLabel: _splitLabel,
                ariaLabel: props.ariaLabel || label,
                onClick: ()=>{
                    rest?.onClick?.({
                        label: label,
                        icon: rest.icon,
                        index: rest.internalIndex
                    });
                }
            }
        });
    };
const $fe5170bdd3625759$var$Component$S = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$O;
    const { onClick: onClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), ariaLabel: ariaLabel = props.label?.toString(), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            onClick: onClick,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSSearchResultItem", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$56e008c8bd1ccf7c = $fe5170bdd3625759$var$withLogic$O($fe5170bdd3625759$var$Component$S);
$fe5170bdd3625759$export$56e008c8bd1ccf7c.displayName = "SearchResultItem";
$fe5170bdd3625759$export$56e008c8bd1ccf7c.slotName = "jds_search_result_item";
const $fe5170bdd3625759$var$sdl$N = {
    "metadata": {
        "version": "1.0.0",
        "id": "search-result-text-1.0.0",
        "name": "JDSSearchResultText",
        "layerName": "jds_search_result_text"
    },
    "hierarchy": {
        "jds-text": []
    },
    "base": {
        "jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey100}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 1,
            "maxLines": 1,
            "behavior": {
                "hover": {
                    "color": "{primaryGrey80}"
                }
            }
        }
    },
    "variant": {
        "bold": {
            "true": {
                "jds-text": {
                    "font-family": "{bodySBold}",
                    "font-size": "{bodySBold}",
                    "line-height": "{bodySBold}",
                    "letter-spacing": "{bodySBold}",
                    "font-weight": "{bodySBold}"
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "bold": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "text"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$N = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$R = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$N;
    const { bold: bold = false, custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            bold: bold,
            ...rest
        },
        componentTag: componentTag
    }, "JDSSearchResultText", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$2a7e910d17016306 = $fe5170bdd3625759$var$withLogic$N($fe5170bdd3625759$var$Component$R);
$fe5170bdd3625759$export$2a7e910d17016306.displayName = "SearchResultText";
$fe5170bdd3625759$export$2a7e910d17016306.slotName = "jds_search_result_text";
const $fe5170bdd3625759$var$sdl$M = {
    "metadata": {
        "version": "1.0.0",
        "id": "Segmented-ring-item-1.0.0",
        "name": "JDSSegmentedRingItem",
        "layerName": "jds_segmented_ring_item",
        "internal": true
    },
    "hierarchy": {
        "arc": []
    },
    "base": {
        "arc": {
            "radius": 24,
            "arcWidth": 2,
            "fill": "{primary50}",
            "start": 0,
            "end": 360
        }
    },
    "variant": {
        "size": {
            "xtra-xtra-large": {
                "arc": {
                    "radius": 68,
                    "arcWidth": 4
                }
            },
            "xtra-large": {
                "arc": {
                    "radius": 34,
                    "arcWidth": 3
                }
            },
            "large": {
                "arc": {
                    "radius": 30,
                    "arcWidth": 3
                }
            },
            "small": {
                "arc": {
                    "radius": 20,
                    "arcWidth": 2
                }
            },
            "xtra-small": {
                "arc": {
                    "radius": 16,
                    "arcWidth": 2
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "size": {
                "values": [
                    "medium",
                    "xtra-xtra-large",
                    "xtra-large",
                    "large",
                    "small",
                    "xtra-small"
                ]
            }
        },
        "data": {
            "arc": {
                "start": {
                    "type": "number",
                    "name": "startAngle"
                },
                "end": {
                    "type": "number",
                    "name": "endAngle"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$M = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$Q = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$M;
    const { size: size = "medium", custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            size: size,
            ...rest
        },
        componentTag: componentTag
    }, "JDSSegmentedRingItem", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$28d80c087760154d = $fe5170bdd3625759$var$withLogic$M($fe5170bdd3625759$var$Component$Q);
$fe5170bdd3625759$export$28d80c087760154d.displayName = "SegmentedRingItem";
$fe5170bdd3625759$export$28d80c087760154d.slotName = "jds_segmented_ring_item";
const $fe5170bdd3625759$var$sdl$L = {
    "metadata": {
        "version": "1.0.0",
        "id": "selector-button-1.0.0",
        "name": "JDSSelectorButton",
        "layerName": "jds_selector_button",
        "description": "A selector button is an interactive control that allows the user to perform a selection action."
    },
    "hierarchy": {
        "container": [
            "left-icon",
            "jds-text",
            "right-icon"
        ]
    },
    "base": {
        "container": {
            "background-color": "{s_0}",
            "flex-direction": "{s_1}",
            "justify-content": "{s_2}",
            "align-items": "{s_3}",
            "border-radius": "{s_4}",
            "padding-bottom": "{s_5}",
            "padding-top": "{s_6}",
            "padding-left": "{s_7}",
            "padding-right": "{s_8}",
            "border-width": "{s_9}",
            "gap": "{s_10}",
            "opacity": "{s_11}",
            "behavior": {
                "hover": {
                    "background-color": "{s_12}"
                },
                "active": {
                    "background-color": "{s_13}"
                },
                "focus": {
                    "border-width": "{s_14}",
                    "border-color": "{s_15}"
                }
            }
        },
        "left-icon": {
            "hidden": false,
            "size": "{s_16}",
            "color": "{s_17}",
            "behavior": {
                "hover": {
                    "color": "{s_18}"
                }
            }
        },
        "right-icon": {
            "hidden": true,
            "size": "{s_19}",
            "color": "{s_20}",
            "behavior": {
                "hover": {
                    "color": "{s_21}"
                }
            }
        },
        "jds-text": {
            "font-family": "{bodySBold}",
            "color": "{primaryInverse}",
            "font-size": "{bodySBold}",
            "line-height": "{bodySBold}",
            "letter-spacing": "{bodySBold}",
            "font-weight": "{bodySBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false
        }
    },
    "variant": {
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{s_22}"
                }
            }
        }
    },
    "combination": [
        {
            "normal": {
                "primary": {
                    "true": {
                        "container": {
                            "background-color": "{s_23}",
                            "behavior": {
                                "hover": {
                                    "background-color": "{s_24}"
                                },
                                "active": {
                                    "background-color": "{s_25}"
                                },
                                "focus": {
                                    "border-color": "{s_26}"
                                }
                            }
                        }
                    },
                    "false": {
                        "jds-text": {
                            "behavior": {
                                "hover": {
                                    "color": "{primary70}"
                                }
                            }
                        }
                    }
                },
                "secondary": {
                    "false": {
                        "container": {
                            "background-color": "{s_27}",
                            "border-width": "{s_28}",
                            "border-color": "{s_29}",
                            "behavior": {
                                "hover": {
                                    "background-color": "{s_30}",
                                    "border-color": "{s_31}"
                                },
                                "active": {
                                    "background-color": "{s_32}"
                                },
                                "focus": {
                                    "border-width": "{s_33}",
                                    "border-color": "{s_34}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_35}"
                        },
                        "right-icon": {
                            "color": "{s_36}"
                        },
                        "jds-text": {
                            "color": "{primary60}"
                        }
                    },
                    "true": {
                        "container": {
                            "background-color": "{s_37}",
                            "border-width": "{s_38}",
                            "border-color": "{s_39}",
                            "behavior": {
                                "hover": {
                                    "border-color": "{s_40}"
                                },
                                "active": {
                                    "background-color": "{s_41}"
                                },
                                "focus": {
                                    "border-width": "{s_42}",
                                    "border-color": "{s_43}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_44}",
                            "behavior": {
                                "active": {
                                    "color": "{s_45}"
                                }
                            }
                        },
                        "right-icon": {
                            "color": "{s_46}",
                            "behavior": {
                                "active": {
                                    "color": "{s_47}"
                                }
                            }
                        },
                        "jds-text": {
                            "color": "{primary60}",
                            "behavior": {
                                "active": {
                                    "color": "{primary70}"
                                }
                            }
                        }
                    }
                },
                "tertiary": {
                    "true": {
                        "container": {
                            "background-color": "{s_48}",
                            "behavior": {
                                "hover": {
                                    "background-color": "{s_49}",
                                    "border-color": "{s_50}",
                                    "border-width": "{s_51}"
                                },
                                "active": {
                                    "background-color": "{s_52}"
                                },
                                "focus": {
                                    "border-width": "{s_53}",
                                    "border-color": "{s_54}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_55}",
                            "behavior": {
                                "active": {
                                    "color": "{s_56}"
                                },
                                "hover": {
                                    "color": "{s_57}"
                                }
                            }
                        },
                        "right-icon": {
                            "color": "{s_58}",
                            "behavior": {
                                "active": {
                                    "color": "{s_59}"
                                },
                                "hover": {
                                    "color": "{s_60}"
                                }
                            }
                        },
                        "jds-text": {
                            "color": "{primary60}",
                            "behavior": {
                                "active": {
                                    "color": "{primary70}"
                                },
                                "hover": {}
                            }
                        }
                    },
                    "false": {
                        "container": {
                            "background-color": "{s_61}",
                            "behavior": {
                                "hover": {
                                    "border-width": "{s_62}",
                                    "border-color": "{s_63}",
                                    "background-color": "{s_64}"
                                },
                                "active": {
                                    "background-color": "{s_65}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_66}",
                            "behavior": {
                                "active": {
                                    "color": "{s_67}"
                                },
                                "hover": {
                                    "color": "{s_68}"
                                }
                            }
                        },
                        "right-icon": {
                            "color": "{s_69}",
                            "behavior": {
                                "active": {
                                    "color": "{s_70}"
                                },
                                "hover": {
                                    "color": "{s_71}"
                                }
                            }
                        },
                        "jds-text": {
                            "color": "{primary60}"
                        }
                    }
                },
                "tertiary_narrow": {
                    "true": {
                        "container": {
                            "background-color": "{s_72}",
                            "behavior": {
                                "focus": {
                                    "border-width": "{s_73}",
                                    "border-color": "{s_74}"
                                },
                                "hover": {
                                    "background-color": "{s_75}"
                                },
                                "active": {
                                    "background-color": "{s_76}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_77}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_78}"
                                },
                                "active": {
                                    "color": "{s_79}"
                                }
                            }
                        },
                        "right-icon": {
                            "color": "{s_80}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_81}"
                                },
                                "active": {
                                    "color": "{s_82}"
                                }
                            }
                        },
                        "jds-text": {
                            "color": "{primary70}",
                            "behavior": {
                                "hover": {
                                    "color": "{primary60}"
                                },
                                "active": {
                                    "color": "{primary80}"
                                }
                            }
                        }
                    },
                    "false": {
                        "container": {
                            "background-color": "{s_83}",
                            "behavior": {
                                "hover": {
                                    "background-color": "{s_84}"
                                },
                                "active": {
                                    "background-color": "{s_85}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_86}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_87}"
                                },
                                "active": {
                                    "color": "{s_88}"
                                }
                            }
                        },
                        "right-icon": {
                            "color": "{s_89}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_90}"
                                },
                                "active": {
                                    "color": "{s_91}"
                                }
                            }
                        },
                        "jds-text": {
                            "color": "{primary60}",
                            "behavior": {
                                "hover": {
                                    "color": "{primary50}"
                                },
                                "active": {
                                    "color": "{primary70}"
                                }
                            }
                        }
                    }
                }
            },
            "grey_scale": {
                "primary": {
                    "false": {
                        "container": {
                            "background-color": "{s_92}",
                            "behavior": {
                                "hover": {
                                    "background-color": "{s_93}"
                                },
                                "active": {
                                    "background-color": "{s_94}"
                                },
                                "focus": {
                                    "border-width": "{s_95}",
                                    "border-color": "{s_96}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_97}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_98}"
                                },
                                "active": {
                                    "color": "{s_99}"
                                }
                            }
                        },
                        "right-icon": {
                            "color": "{s_100}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_101}"
                                },
                                "active": {
                                    "color": "{s_102}"
                                }
                            }
                        },
                        "jds-text": {
                            "color": "{primaryBackground}",
                            "behavior": {
                                "hover": {
                                    "color": "{primary70}"
                                },
                                "active": {
                                    "color": "{primaryInverse}"
                                }
                            }
                        }
                    }
                },
                "secondary": {
                    "false": {
                        "container": {
                            "background-color": "{s_103}",
                            "border-width": "{s_104}",
                            "border-color": "{s_105}",
                            "behavior": {
                                "hover": {
                                    "background-color": "{s_106}",
                                    "border-color": "{s_107}"
                                },
                                "active": {
                                    "background-color": "{s_108}"
                                },
                                "focus": {
                                    "border-width": "{s_109}",
                                    "border-color": "{s_110}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_111}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_295}"
                                }
                            }
                        },
                        "right-icon": {
                            "color": "{s_112}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_296}"
                                }
                            }
                        },
                        "jds-text": {
                            "color": "{primaryGrey80}",
                            "behavior": {
                                "hover": {
                                    "color": "{primary60}"
                                }
                            }
                        }
                    },
                    "true": {
                        "container": {
                            "background-color": "{s_113}",
                            "border-width": 1,
                            "border-color": "{s_114}",
                            "behavior": {
                                "hover": {
                                    "border-color": "{s_115}"
                                },
                                "active": {
                                    "background-color": "{s_116}"
                                },
                                "focus": {
                                    "border-width": "{s_117}",
                                    "border-color": "{s_118}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_119}",
                            "behavior": {
                                "active": {
                                    "color": "{s_120}"
                                }
                            }
                        },
                        "right-icon": {
                            "color": "{s_121}",
                            "behavior": {
                                "active": {
                                    "color": "{s_122}"
                                }
                            }
                        },
                        "jds-text": {
                            "color": "{primary60}",
                            "behavior": {
                                "active": {
                                    "color": "{primary70}"
                                }
                            }
                        }
                    }
                },
                "tertiary": {
                    "true": {
                        "container": {
                            "background-color": "{s_123}",
                            "behavior": {
                                "hover": {
                                    "border-color": "{s_124}",
                                    "border-width": "{s_125}"
                                },
                                "active": {
                                    "background-color": "{s_126}"
                                },
                                "focus": {
                                    "border-width": "{s_127}",
                                    "border-color": "{s_128}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_129}",
                            "behavior": {
                                "active": {
                                    "color": "{s_130}"
                                }
                            }
                        },
                        "right-icon": {
                            "color": "{s_131}",
                            "behavior": {
                                "active": {
                                    "color": "{s_132}"
                                }
                            }
                        },
                        "jds-text": {
                            "color": "{primary60}",
                            "behavior": {
                                "active": {
                                    "color": "{primary70}"
                                }
                            }
                        }
                    },
                    "false": {
                        "container": {
                            "background-color": "{s_133}",
                            "behavior": {
                                "hover": {
                                    "border-color": "{s_134}",
                                    "border-width": "{s_135}",
                                    "background-color": "{s_136}"
                                },
                                "active": {
                                    "background-color": "{s_137}"
                                },
                                "focus": {
                                    "border-width": "{s_138}",
                                    "border-color": "{s_139}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_140}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_141}"
                                },
                                "active": {
                                    "color": "{s_142}"
                                }
                            }
                        },
                        "right-icon": {
                            "color": "{s_143}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_144}"
                                },
                                "active": {
                                    "color": "{s_145}"
                                }
                            }
                        },
                        "jds-text": {
                            "color": "{primaryGrey80}",
                            "behavior": {
                                "hover": {
                                    "color": "{primary60}"
                                },
                                "active": {
                                    "color": "{primary60}"
                                }
                            }
                        }
                    }
                },
                "tertiary_narrow": {
                    "true": {
                        "container": {
                            "background-color": "{s_146}",
                            "behavior": {
                                "hover": {
                                    "background-color": "{s_147}"
                                },
                                "focus": {
                                    "border-width": "{s_148}",
                                    "border-color": "{s_149}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_150}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_151}"
                                },
                                "active": {
                                    "color": "{s_152}"
                                }
                            }
                        },
                        "right-icon": {
                            "color": "{s_153}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_154}"
                                },
                                "active": {
                                    "color": "{s_155}"
                                }
                            }
                        },
                        "jds-text": {
                            "color": "{primary60}",
                            "behavior": {
                                "hover": {
                                    "color": "{primary50}"
                                },
                                "active": {
                                    "color": "{primary80}"
                                }
                            }
                        }
                    },
                    "false": {
                        "container": {
                            "background-color": "{s_156}",
                            "behavior": {
                                "hover": {
                                    "background-color": "{s_157}"
                                },
                                "focus": {
                                    "border-width": "{s_158}",
                                    "border-color": "{s_159}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_160}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_161}"
                                },
                                "active": {
                                    "color": "{s_162}"
                                }
                            }
                        },
                        "right-icon": {
                            "color": "{s_163}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_164}"
                                },
                                "active": {
                                    "color": "{s_165}"
                                }
                            }
                        },
                        "jds-text": {
                            "color": "{primaryGrey80}",
                            "behavior": {
                                "hover": {
                                    "color": "{primary50}"
                                },
                                "active": {
                                    "color": "{primary60}"
                                }
                            }
                        }
                    }
                }
            },
            "contrast": {
                "primary": {
                    "false": {
                        "container": {
                            "background-color": "{s_166}",
                            "behavior": {
                                "hover": {
                                    "background-color": "{s_167}"
                                },
                                "active": {
                                    "background-color": "{s_168}"
                                },
                                "focus": {
                                    "border-width": "{s_169}",
                                    "border-color": "{s_170}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_171}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_172}"
                                },
                                "focus": {
                                    "color": "{s_173}"
                                },
                                "active": {
                                    "color": "{s_174}"
                                }
                            }
                        },
                        "right-icon": {
                            "color": "{s_175}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_176}"
                                },
                                "focus": {
                                    "color": "{s_177}"
                                },
                                "active": {
                                    "color": "{s_178}"
                                }
                            }
                        },
                        "jds-text": {
                            "color": "{primaryGrey100}",
                            "behavior": {
                                "hover": {},
                                "active": {
                                    "color": "{primaryInverse}"
                                }
                            }
                        }
                    },
                    "true": {
                        "container": {
                            "background-color": "{s_179}",
                            "behavior": {
                                "hover": {
                                    "background-color": "{s_180}"
                                },
                                "active": {
                                    "background-color": "{s_181}"
                                },
                                "focus": {
                                    "background-color": "{s_182}",
                                    "border-width": "{s_183}",
                                    "border-color": "{s_184}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_185}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_186}"
                                }
                            }
                        },
                        "right-icon": {
                            "color": "{s_187}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_188}"
                                }
                            }
                        },
                        "jds-text": {
                            "behavior": {
                                "hover": {
                                    "color": "{primaryGrey100}"
                                }
                            }
                        }
                    }
                },
                "secondary": {
                    "false": {
                        "container": {
                            "background-color": "{s_189}",
                            "border-width": "{s_190}",
                            "border-color": "{s_191}",
                            "behavior": {
                                "hover": {
                                    "background-color": "{s_192}",
                                    "border-color": "{s_193}"
                                },
                                "active": {
                                    "background-color": "{s_194}"
                                },
                                "focus": {
                                    "border-width": "{s_195}",
                                    "border-color": "{s_196}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_197}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_198}"
                                },
                                "active": {
                                    "color": "{s_199}"
                                }
                            }
                        },
                        "right-icon": {
                            "color": "{s_200}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_201}"
                                },
                                "active": {
                                    "color": "{s_202}"
                                }
                            }
                        },
                        "jds-text": {
                            "color": "{primaryBackground}",
                            "behavior": {
                                "hover": {
                                    "color": "{primaryGrey100}"
                                },
                                "active": {
                                    "color": "{primaryGrey100}"
                                }
                            }
                        }
                    },
                    "true": {
                        "container": {
                            "background-color": "{s_203}",
                            "border-width": 1,
                            "border-color": "{s_204}",
                            "behavior": {
                                "hover": {
                                    "border-color": "{s_205}"
                                },
                                "active": {
                                    "background-color": "{s_206}"
                                },
                                "focus": {
                                    "border-width": "{s_207}",
                                    "border-color": "{s_208}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_209}",
                            "behavior": {
                                "active": {
                                    "color": "{s_210}"
                                }
                            }
                        },
                        "right-icon": {
                            "color": "{s_211}",
                            "behavior": {
                                "active": {
                                    "color": "{s_212}"
                                }
                            }
                        },
                        "jds-text": {
                            "color": "{primaryGrey100}",
                            "behavior": {
                                "active": {
                                    "color": "{primaryInverse}"
                                }
                            }
                        }
                    }
                },
                "tertiary": {
                    "false": {
                        "container": {
                            "background-color": "{s_213}",
                            "behavior": {
                                "hover": {
                                    "background-color": "{s_214}",
                                    "border-width": 1,
                                    "border-color": "{s_215}"
                                },
                                "active": {
                                    "background-color": "{s_216}"
                                },
                                "focus": {
                                    "border-width": "{s_217}",
                                    "border-color": "{s_218}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_219}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_220}"
                                },
                                "active": {
                                    "color": "{s_221}"
                                }
                            }
                        },
                        "right-icon": {
                            "color": "{s_222}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_223}"
                                },
                                "active": {
                                    "color": "{s_224}"
                                }
                            }
                        },
                        "jds-text": {
                            "color": "{primaryBackground}",
                            "behavior": {
                                "hover": {
                                    "color": "{primaryGrey100}"
                                },
                                "active": {
                                    "color": "{primaryGrey100}"
                                }
                            }
                        }
                    },
                    "true": {
                        "container": {
                            "background-color": "{s_225}",
                            "behavior": {
                                "hover": {
                                    "border-width": 1,
                                    "border-color": "{s_226}"
                                },
                                "focus": {
                                    "border-width": "{s_227}",
                                    "border-color": "{s_228}"
                                },
                                "active": {
                                    "background-color": "{s_229}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_230}",
                            "behavior": {
                                "active": {
                                    "background-color": "{s_231}"
                                }
                            }
                        },
                        "right-icon": {
                            "color": "{s_232}",
                            "behavior": {
                                "active": {
                                    "background-color": "{s_233}"
                                }
                            }
                        },
                        "jds-text": {
                            "color": "{primaryGrey100}",
                            "behavior": {
                                "active": {
                                    "background-color": "primary_inverse"
                                }
                            }
                        }
                    }
                },
                "tertiary_narrow": {
                    "false": {
                        "container": {
                            "background-color": "{s_234}",
                            "behavior": {
                                "focus": {
                                    "border-width": "{s_235}",
                                    "border-color": "{s_236}"
                                },
                                "hover": {
                                    "background-color": "{s_237}"
                                },
                                "active": {
                                    "background-color": "{s_238}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_239}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_240}"
                                },
                                "active": {
                                    "color": "{s_241}"
                                }
                            }
                        },
                        "right-icon": {
                            "color": "{s_242}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_243}"
                                },
                                "active": {
                                    "color": "{s_244}"
                                }
                            }
                        },
                        "jds-text": {
                            "color": "{primaryBackground}",
                            "behavior": {
                                "hover": {
                                    "color": "{primary20}"
                                },
                                "active": {
                                    "color": "{primary30}"
                                }
                            }
                        }
                    },
                    "true": {
                        "container": {
                            "background-color": "{s_245}",
                            "behavior": {
                                "focus": {
                                    "border-width": "{s_246}",
                                    "border-color": "{s_247}"
                                },
                                "hover": {
                                    "background-color": "{s_248}"
                                },
                                "active": {
                                    "background-color": "{s_249}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_250}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_251}"
                                },
                                "active": {
                                    "color": "{s_252}"
                                },
                                "focus": {
                                    "color": "{s_253}"
                                }
                            }
                        },
                        "right-icon": {
                            "color": "{s_254}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_255}"
                                },
                                "active": {
                                    "color": "{s_256}"
                                },
                                "focus": {
                                    "color": "{s_257}"
                                }
                            }
                        },
                        "jds-text": {
                            "color": "{primary30}",
                            "behavior": {
                                "hover": {
                                    "color": "{primary20}"
                                },
                                "active": {},
                                "focus": {}
                            }
                        }
                    }
                }
            }
        },
        {
            "tertiary_narrow": {
                "small": {
                    "container": {
                        "padding-bottom": "{s_258}",
                        "padding-top": "{s_259}",
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "medium": {
                    "container": {
                        "padding-bottom": "{s_260}",
                        "padding-top": "{s_261}",
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "large": {
                    "container": {
                        "padding-bottom": "{s_262}",
                        "padding-top": "{s_263}",
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "extra_large": {
                    "container": {
                        "padding-bottom": "{s_264}",
                        "padding-top": "{s_265}",
                        "padding-left": 0,
                        "padding-right": 0
                    }
                }
            }
        },
        {
            "true": {
                "small": {
                    "container": {
                        "padding-top": "{s_266}",
                        "padding-bottom": "{s_267}"
                    },
                    "left-icon": {
                        "size": "{s_268}"
                    },
                    "right-icon": {
                        "size": "{s_269}"
                    },
                    "jds-text": {}
                },
                "large": {
                    "container": {
                        "padding-top": "{s_270}",
                        "padding-left": "{s_271}",
                        "padding-bottom": "{s_272}",
                        "padding-right": "{s_273}"
                    },
                    "left-icon": {
                        "size": "{s_274}"
                    },
                    "right-icon": {
                        "size": "{s_275}"
                    },
                    "jds-text": {
                        "font-family": "{bodyMBold}",
                        "font-size": "{bodyMBold}",
                        "line-height": "{bodyMBold}",
                        "letter-spacing": "{bodyMBold}",
                        "font-weight": "{bodyMBold}"
                    }
                },
                "extra_large": {
                    "container": {
                        "padding-top": "{s_276}",
                        "padding-right": "{s_277}",
                        "padding-bottom": "{s_278}",
                        "padding-left": "{s_279}"
                    },
                    "left-icon": {
                        "size": "{s_280}"
                    },
                    "right-icon": {
                        "size": "{s_281}"
                    },
                    "jds-text": {
                        "font-family": "{bodyLBold}",
                        "font-size": "{bodyLBold}",
                        "line-height": "{bodyLBold}",
                        "letter-spacing": "{bodyLBold}",
                        "font-weight": "{bodyLBold}"
                    }
                }
            },
            "false": {
                "small": {
                    "container": {
                        "width": "{s_282}",
                        "height": "{s_283}",
                        "padding-left": 0,
                        "padding-top": 0,
                        "padding-right": 0,
                        "padding-bottom": 0
                    },
                    "left-icon": {
                        "size": "{s_284}"
                    },
                    "jds-text": {
                        "hidden": true
                    }
                },
                "medium": {
                    "container": {
                        "width": "{s_285}",
                        "height": "{s_286}",
                        "padding-left": 0,
                        "padding-top": 0,
                        "padding-right": 0,
                        "padding-bottom": 0
                    },
                    "jds-text": {
                        "hidden": true
                    }
                },
                "large": {
                    "container": {
                        "width": "{s_287}",
                        "height": "{s_288}",
                        "padding-left": 0,
                        "padding-top": 0,
                        "padding-right": 0,
                        "padding-bottom": 0
                    },
                    "left-icon": {
                        "size": "{s_289}"
                    },
                    "jds-text": {
                        "hidden": true
                    }
                },
                "extra_large": {
                    "container": {
                        "width": "{s_290}",
                        "height": "{s_291}",
                        "padding-left": 0,
                        "padding-top": 0,
                        "padding-right": 0,
                        "padding-bottom": 0
                    },
                    "left-icon": {
                        "size": "{s_292}"
                    },
                    "jds-text": {
                        "hidden": true
                    }
                }
            }
        },
        {
            "true": {
                "right": {
                    "left-icon": {
                        "hidden": true
                    },
                    "right-icon": {
                        "hidden": false
                    }
                }
            }
        },
        {
            "true": {
                "true": {
                    "container": {
                        "width": "{s_293}",
                        "justify-content": "{s_294}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "appearance",
            "kind",
            "selected"
        ],
        [
            "kind",
            "size"
        ],
        [
            "_hasText",
            "size"
        ],
        [
            "_hasText",
            "iconPosition"
        ],
        [
            "_hasText",
            "stretch"
        ]
    ],
    "api": {
        "config": {
            "kind": {
                "values": [
                    "primary",
                    "secondary",
                    "tertiary",
                    "tertiary_narrow"
                ]
            },
            "iconPosition": {
                "values": [
                    "left",
                    "right"
                ]
            },
            "appearance": {
                "values": [
                    "normal",
                    "grey_scale",
                    "contrast"
                ]
            },
            "size": {
                "values": [
                    "medium",
                    "small",
                    "large",
                    "extra_large"
                ],
                "doc_description": "Sizes of the button"
            },
            "disabled": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to enable or disable SelectorButton."
            },
            "selected": {
                "values": [
                    false,
                    true
                ]
            },
            "stretch": {
                "values": [
                    false,
                    true
                ]
            },
            "_hasText": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "container": {
                "type": {
                    "name": "type",
                    "type": "string",
                    "platform": "web"
                }
            },
            "left-icon": {
                "value": {
                    "type": "icon",
                    "name": "icon"
                }
            },
            "right-icon": {
                "value": {
                    "type": "icon",
                    "name": "icon"
                }
            },
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "text"
                }
            }
        },
        "events": {
            "container": {
                "onClick": "onClick",
                "onFocus": {
                    "name": "onFocus",
                    "platform": "web"
                },
                "onBlur": {
                    "name": "onBlur",
                    "platform": "web"
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "button"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "text"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "aria-pressed": {
                        "name": "_ariaPressed",
                        "prop": "selected"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$PROP_MAP$b = (props)=>{
    if (props.size === "extra-large") console.warn("extra-large size is deprecated. use `extra_large`");
    if (props.appearance === "grey-scale") console.warn("grey-scale appearance is deprecated. use `grey_scale`");
    if (props.kind === "tertiary-narrow") console.warn("tertiary-narrow prop of kind is deprecated. Use `tertirary_narrow`");
    return {
        appearance: {
            properties: {
                appearance: props.appearance
            },
            variations: {
                "grey-scale": {
                    appearance: "grey_scale"
                },
                contrast: {
                    appearance: "contrast"
                },
                normal: {
                    appearance: "normal"
                }
            }
        },
        size: {
            properties: {
                size: props.size
            },
            variations: {
                medium: {
                    size: "medium"
                },
                small: {
                    size: "small"
                },
                large: {
                    size: "large"
                },
                "extra-large": {
                    size: "extra_large"
                }
            }
        },
        label: {
            properties: {
                text: props.label
            }
        },
        children: {
            properties: {
                text: props.children
            }
        },
        icon: {
            properties: {
                icon: props.icon
            }
        },
        kind: {
            properties: {
                kind: props.kind
            },
            variations: {
                primary: {
                    kind: "primary"
                },
                secondary: {
                    kind: "secondary"
                },
                tertiary: {
                    kind: "tertiary"
                },
                "tertiary-narrow": {
                    kind: "tertiary_narrow"
                }
            }
        }
    };
};
const $fe5170bdd3625759$var$withLogic$L = (Component)=>(0, $acw62.forwardRef)((userProps, ref)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$b);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                _hasText: Boolean(props.text?.length || props?.children),
                rootRef: ref
            }
        });
    });
const $fe5170bdd3625759$var$Component$P = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$L;
    const { kind: kind = "primary", iconPosition: iconPosition = "left", appearance: appearance = "normal", size: size = "medium", disabled: disabled = false, selected: selected = false, stretch: stretch = false, onClick: onClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onFocus: onFocus = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onBlur: onBlur = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), ariaLabel: ariaLabel = props.text?.toString(), _ariaPressed: _ariaPressed = props.selected?.toString(), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            iconPosition: iconPosition,
            appearance: appearance,
            size: size,
            disabled: disabled,
            selected: selected,
            stretch: stretch,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            ariaLabel: ariaLabel,
            _ariaPressed: _ariaPressed,
            ...rest
        },
        componentTag: componentTag
    }, "JDSSelectorButton", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$880a7f9ee0ea89e0 = $fe5170bdd3625759$var$withLogic$L($fe5170bdd3625759$var$Component$P);
$fe5170bdd3625759$export$880a7f9ee0ea89e0.displayName = "SelectorButton";
$fe5170bdd3625759$export$880a7f9ee0ea89e0.slotName = "jds_selector_button";
const $fe5170bdd3625759$var$sdl$K = {
    "metadata": {
        "version": "1.0.0",
        "id": "selector-item-1.0.0",
        "name": "JDSSelectorItem",
        "layerName": "jds_selector_item",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "icon",
            "jds-text"
        ]
    },
    "base": {
        "container": {
            "opacity": "{s_0}",
            "background-color": "{s_1}",
            "flex-direction": "{s_2}",
            "align-items": "{s_3}",
            "justify-content": "{s_4}",
            "border-radius": "{s_5}",
            "gap": "{s_6}",
            "padding-top": "{s_7}",
            "padding-right": "{s_8}",
            "padding-bottom": "{s_9}",
            "padding-left": "{s_10}",
            "behavior": {
                "focus": {
                    "background-color": "{s_11}",
                    "box-shadow": {
                        "x": 0,
                        "y": 0,
                        "blur": 0,
                        "spread": "{s_12}",
                        "color": "{s_13}"
                    }
                },
                "hover": {
                    "background-color": "{s_14}"
                },
                "active": {
                    "background-color": "{s_15}"
                }
            }
        },
        "icon": {
            "size": "{s_16}",
            "color": "{s_17}",
            "hidden": false
        },
        "jds-text": {
            "font-family": "{bodyS}",
            "color": "{primary60}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "selected": {
            "true": {
                "container": {
                    "behavior": {
                        "hover": {
                            "background-color": "{s_19}"
                        },
                        "active": {
                            "background-color": "{s_20}"
                        },
                        "focus": {
                            "background-color": "{s_21}"
                        }
                    }
                },
                "icon": {
                    "color": "{s_22}",
                    "behavior": {
                        "active": {
                            "color": "{s_23}"
                        }
                    }
                },
                "jds-text": {
                    "color": "{primaryInverse}",
                    "behavior": {
                        "hover": {},
                        "active": {
                            "color": "{primary30}"
                        }
                    }
                }
            }
        },
        "kind": {
            "label": {
                "icon": {
                    "hidden": true
                }
            },
            "icon": {
                "jds-text": {
                    "hidden": true
                }
            }
        },
        "wrap": {
            "vertical": {
                "container": {
                    "flex-direction": "{s_24}",
                    "gap": "{s_27}"
                }
            }
        },
        "stretch": {
            "true": {
                "container": {
                    "width": "{s_25}"
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{s_26}"
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "selected": {
                "values": [
                    false,
                    true
                ]
            },
            "stretch": {
                "values": [
                    false,
                    true
                ]
            },
            "kind": {
                "values": [
                    "label_icon",
                    "label",
                    "icon"
                ]
            },
            "wrap": {
                "values": [
                    "horizontal",
                    "vertical"
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "icon": {
                "value": {
                    "type": "icon",
                    "name": "icon"
                }
            },
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            }
        },
        "events": {
            "container": {
                "onAppear": {
                    "name": "onAppear",
                    "platform": "ios, android"
                },
                "onClick": "onClick",
                "onFocus": {
                    "name": "onFocus",
                    "platform": "web"
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "radio"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "aria-checked": {
                        "name": "_ariaChecked",
                        "prop": "selected"
                    }
                }
            },
            "icon": {
                "properties": {
                    "role": {
                        "value": "img"
                    },
                    "aria-label": {
                        "name": "iconAriaLabel",
                        "function": true
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$K = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                selected: props.check || props.selectedIndex === props.internalIndex,
                iconAriaLabel: props.iconAriaLabel || $fe5170bdd3625759$var$formatIconName(props.icon)
            }
        });
    };
const $fe5170bdd3625759$var$Component$O = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$K;
    const { selected: selected = false, stretch: stretch = false, kind: kind = "label_icon", wrap: wrap = "horizontal", disabled: disabled = false, onAppear: onAppear = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onClick: onClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onFocus: onFocus = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), ariaLabel: ariaLabel = props.label?.toString(), _ariaChecked: _ariaChecked = props.selected?.toString(), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            selected: selected,
            stretch: stretch,
            kind: kind,
            wrap: wrap,
            disabled: disabled,
            onAppear: onAppear,
            onClick: onClick,
            onFocus: onFocus,
            ariaLabel: ariaLabel,
            _ariaChecked: _ariaChecked,
            ...rest
        },
        componentTag: componentTag
    }, "JDSSelectorItem", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$ec8540225d9cc6a2 = $fe5170bdd3625759$var$withLogic$K($fe5170bdd3625759$var$Component$O);
$fe5170bdd3625759$export$ec8540225d9cc6a2.displayName = "SelectorItem";
$fe5170bdd3625759$export$ec8540225d9cc6a2.slotName = "jds_selector_item";
const $fe5170bdd3625759$var$sdl$J = {
    "metadata": {
        "version": "1.0.0",
        "id": "side-panel-1.0.0",
        "layerName": "jds_side_panel_internal",
        "name": "JDSSidePanelInternal",
        "description": "",
        "internal": true
    },
    "hierarchy": {
        "container": [
            {
                "header-container": [
                    {
                        "left-container": [
                            "avatar-slot",
                            "header-text-slot"
                        ]
                    },
                    "suffix-jds_action_button"
                ]
            },
            "children-slot",
            {
                "section-container": [
                    "jds_side_panel_item"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "width": 412,
            "height": "{s_5}",
            "flex-direction": "{s_6}",
            "background-color": "{s_7}",
            "enter-animation-name": "slideHorizontallyToRight",
            "exit-animation-name": "slideHorizontallyToLeft",
            "enter-animation-curve": "entrance_ease",
            "exit-animation-curve": "exit_ease",
            "enter-animation-duration": 500,
            "exit-animation-duration": 500,
            "hidden": true,
            "translate-x": "{size.negativeMax}",
            "transition": {
                "property": [
                    "translate-x"
                ],
                "duration": "{medium}",
                "timing-function": "{easeRapid}"
            }
        },
        "section-container": {
            "hidden": true,
            "height": "{s_8}",
            "width": "{s_9}",
            "flex-direction": "{s_10}",
            "justify-content": "{s_11}",
            "align-items": "{s_12}",
            "padding-left": "{s_13}",
            "padding-top": "{s_14}",
            "padding-right": "{s_15}"
        },
        "header-container": {
            "background-color": "{s_16}",
            "padding-top": "{s_17}",
            "padding-bottom": "{s_18}",
            "padding-right": "{s_19}",
            "padding-left": "{s_20}",
            "width": "{s_21}",
            "justify-content": "{s_22}",
            "align-items": "{s_23}"
        },
        "left-container": {
            "flex-direction": "{s_24}",
            "gap": "{s_25}",
            "align-items": "{s_26}"
        },
        "suffix-jds_action_button": {
            "hidden": false,
            "icon": "ic_close",
            "size": "large"
        }
    },
    "variant": {
        "open": {
            "true": {
                "container": {
                    "hidden": false,
                    "translate-x": 0,
                    "transition": {
                        "timing-function": "{easeEntrance}"
                    }
                }
            }
        },
        "direction": {
            "right": {
                "container": {
                    "enter-animation-name": "slideHorizontallyToLeft",
                    "exit-animation-name": "slideHorizontallyToRight"
                }
            }
        },
        "showClose": {
            "false": {
                "suffix-jds_action_button": {
                    "hidden": true
                }
            }
        },
        "_hasChildren": {
            "true": {
                "section-container": {
                    "hidden": false
                },
                "children-slot": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {
            "true": {
                "desktop": {
                    "container": {
                        "width": "{s_28}"
                    }
                },
                "mobile": {
                    "container": {
                        "width": "{s_29}"
                    }
                }
            },
            "false": {
                "desktop": {
                    "container": {
                        "width": 412
                    }
                },
                "mobile": {
                    "container": {
                        "width": "{s_30}"
                    }
                }
            }
        },
        {
            "false": {
                "right": {
                    "container": {
                        "translate-x": "{size.max}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "maxWidth",
            "_platform"
        ],
        [
            "open",
            "direction"
        ]
    ],
    "api": {
        "children": {
            "avatar-slot": {
                "name": "prefix",
                "accepts": [
                    "jds_avatar",
                    "jds_icon",
                    "jds_button"
                ],
                "max": 1
            },
            "header-text-slot": {
                "name": "header",
                "accepts": [
                    "jds_text"
                ],
                "max": 1,
                "doc_description": "Has pre-defined suffix as close button."
            },
            "children-slot": {
                "name": "children",
                "accepts": [
                    "any"
                ],
                "doc_description": "Any group of children can be added. When used for BurgerMenu, show a list of ListBlocks."
            }
        },
        "config": {
            "_platform": {
                "values": [
                    "desktop",
                    "mobile"
                ]
            },
            "direction": {
                "values": [
                    "left",
                    "right"
                ],
                "doc_description": "Determines whether open/close should happen from left or right."
            },
            "showClose": {
                "values": [
                    true,
                    false
                ],
                "doc_description": "Whether a close on the right should be shown."
            },
            "open": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "Can be used to programatically open/close the drawer with animation and selected direction."
            },
            "maxWidth": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "If set it will limit max width of the panel to 412px.",
                "function": true
            },
            "_hasChildren": {
                "values": [
                    false,
                    true
                ]
            },
            "disableTransition": {
                "values": [
                    false,
                    true
                ],
                "platform": "web"
            }
        },
        "data": {
            "section-container": {
                "value": {
                    "type": "list",
                    "name": "items",
                    "object": {
                        "title": "string",
                        "prefix": "icon",
                        "showSuffix": "boolean",
                        "type": "JDSSidePanelItem.type"
                    }
                }
            },
            "jds_side_panel_item": {
                "prefix": {
                    "type": "string",
                    "name": "items.prefix"
                },
                "title": {
                    "type": "string",
                    "name": "items.title"
                },
                "showSuffix": {
                    "type": "boolean",
                    "name": "links.showSuffix"
                },
                "type": {
                    "type": "string",
                    "name": "items.type"
                }
            }
        },
        "events": {
            "suffix-jds_action_button": {
                "onClick": "onClose"
            },
            "container": {
                "onClick": "onContainerClick",
                "onSwipeLeft": "onSwipeLeft"
            },
            "jds_side_panel_item": {
                "onSuffixClick": "onSidePanelSuffixClick"
            }
        },
        "a11y": {
            "suffix-jds_action_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "suffixAriaLabel",
                        "value": "Close Side Panel"
                    }
                }
            },
            "section-container": {
                "name": "items",
                "properties": {
                    "role": {
                        "value": "list"
                    }
                },
                "repeating": {
                    "ariaLabel": "itemAriaLabel",
                    "itemSuffixAriaLabel": "itemSuffixAriaLabel",
                    "ariaDescribedby": {
                        "name": "itemAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_side_panel_item": {
                "properties": {
                    "ariaLabel": "items.itemAriaLabel",
                    "itemSuffixAriaLabel": "items.itemSuffixAriaLabel",
                    "ariaDescribedby": "items.itemAriaDescribedby"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$J = (Component)=>(props)=>{
        const { onSwipeLeft: onSwipeLeft, ...rest } = props;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...rest
        });
    };
const $fe5170bdd3625759$var$Component$N = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$J;
    const { direction: direction = "left", showClose: showClose = true, open: open = false, maxWidth: maxWidth = false, disableTransition: disableTransition = false, onClose: onClose = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onContainerClick: onContainerClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSwipeLeft: onSwipeLeft = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSidePanelSuffixClick: onSidePanelSuffixClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), suffixAriaLabel: suffixAriaLabel = "Close Side Panel", custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            direction: direction,
            showClose: showClose,
            open: open,
            maxWidth: maxWidth,
            disableTransition: disableTransition,
            onClose: onClose,
            onContainerClick: onContainerClick,
            onSwipeLeft: onSwipeLeft,
            onSidePanelSuffixClick: onSidePanelSuffixClick,
            suffixAriaLabel: suffixAriaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSSidePanelInternal", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$8b5d5577a4deadf6 = $fe5170bdd3625759$var$withLogic$J($fe5170bdd3625759$var$Component$N);
$fe5170bdd3625759$export$8b5d5577a4deadf6.displayName = "SidePanelInternal";
$fe5170bdd3625759$export$8b5d5577a4deadf6.slotName = "jds_side_panel_internal";
const $fe5170bdd3625759$var$sdl$I = {
    "metadata": {
        "version": "1.0.0",
        "id": "spinner-1.0.0",
        "name": "JDSSpinner",
        "layerName": "jds_spinner"
    },
    "hierarchy": {
        "container": [
            {
                "spinner-container": [
                    {
                        "arc-container": [
                            "base-arc",
                            "normal-arc",
                            "third-arc",
                            "second-arc",
                            "first-arc"
                        ]
                    }
                ]
            },
            "jds-text"
        ]
    },
    "base": {
        "container": {
            "background-color": "{s_0}",
            "gap": "{s_1}",
            "justify-content": "{s_2}",
            "align-items": "{s_3}",
            "flex-direction": "{s_4}"
        },
        "spinner-container": {
            "size": "{s_5}"
        },
        "arc-container": {
            "flex-direction": "{s_6}",
            "justify-content": "{s_7}",
            "align-items": "{s_8}",
            "size": "{s_9}"
        },
        "base-arc": {
            "fill": "{s_10}",
            "radius": "{s_11}",
            "arcWidth": "{s_12}",
            "start": "{s_13}",
            "end": "{s_14}",
            "z-index": 0
        },
        "normal-arc": {
            "fill": "{s_15}",
            "radius": "{s_16}",
            "arcWidth": "{s_17}",
            "start": "{s_18}",
            "end": "{s_19}",
            "z-index": 1,
            "animation-duration": "{s_20}",
            "animate": true
        },
        "first-arc": {
            "hidden": true,
            "fill": "{s_21}",
            "radius": "{s_22}",
            "arcWidth": "{s_23}",
            "start": "{s_24}",
            "end": "{s_25}",
            "z-index": 3,
            "animation-delay": "{s_26}",
            "animation-duration": "{s_27}",
            "animate": true
        },
        "second-arc": {
            "hidden": true,
            "fill": "{s_28}",
            "radius": "{s_29}",
            "arcWidth": "{s_30}",
            "start": "{s_31}",
            "end": "{s_32}",
            "z-index": 2,
            "animation-delay": "{s_33}",
            "animation-duration": "{s_34}",
            "animate": true
        },
        "third-arc": {
            "hidden": true,
            "fill": "{s_35}",
            "radius": "{s_36}",
            "arcWidth": "{s_37}",
            "start": "{s_38}",
            "end": "{s_39}",
            "z-index": 1,
            "animation-duration": "{s_40}",
            "animate": true
        },
        "jds-text": {
            "font-family": "{bodyM}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyM}",
            "line-height": "{bodyM}",
            "letter-spacing": "{bodyM}",
            "font-weight": "{bodyM}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "labelPosition": {
            "bottom": {
                "container": {
                    "flex-direction": "{s_41}"
                }
            }
        },
        "size": {
            "small": {
                "container": {
                    "gap": "{s_42}"
                },
                "spinner-container": {
                    "size": "{s_43}"
                },
                "base-arc": {
                    "arcWidth": "{s_44}",
                    "radius": "{s_45}"
                },
                "normal-arc": {
                    "arcWidth": "{s_46}",
                    "radius": "{s_47}"
                },
                "first-arc": {
                    "arcWidth": "{s_48}",
                    "radius": "{s_49}"
                },
                "second-arc": {
                    "arcWidth": "{s_50}",
                    "radius": "{s_51}"
                },
                "third-arc": {
                    "arcWidth": "{s_52}",
                    "radius": "{s_53}"
                },
                "jds-text": {
                    "font-family": "{bodyS}",
                    "font-size": "{bodyS}",
                    "line-height": "{bodyS}",
                    "letter-spacing": "{bodyS}",
                    "font-weight": "{bodyS}"
                }
            }
        },
        "isOverlay": {
            "true": {
                "jds-text": {
                    "color": "{primaryInverse}"
                }
            }
        },
        "_determinate": {
            "true": {
                "normal-arc": {
                    "animate": false
                }
            }
        }
    },
    "combination": [
        {
            "small": {
                "bottom": {
                    "container": {
                        "flex-direction": "{s_55}"
                    }
                }
            }
        },
        {
            "false": {
                "inline": {
                    "normal-arc": {
                        "fill": "{s_54}"
                    }
                },
                "vibrant": {
                    "normal-arc": {
                        "hidden": true
                    },
                    "first-arc": {
                        "hidden": false
                    },
                    "second-arc": {
                        "hidden": false
                    },
                    "third-arc": {
                        "hidden": false
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "size",
            "labelPosition"
        ],
        [
            "_determinate",
            "kind"
        ]
    ],
    "api": {
        "config": {
            "labelPosition": {
                "values": [
                    "right",
                    "bottom"
                ],
                "doc_description": "It determines the position of the label. Note: if using a small spinner, the label can only be positioned on the right."
            },
            "size": {
                "values": [
                    "medium",
                    "small"
                ],
                "doc_description": "It can be used to control size od Spinner."
            },
            "kind": {
                "values": [
                    "normal",
                    "inline",
                    "vibrant"
                ],
                "doc_description": "It determines the appearance of the spinner .`inline` inherits from text color,`normal`: single color, `vibrant`: three color."
            },
            "isOverlay": {
                "values": [
                    false,
                    true
                ]
            },
            "_determinate": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "normal-arc": {
                "end": {
                    "type": "float",
                    "name": "value",
                    "function": true,
                    "doc_description": "It can be used to take value of spinner from user."
                }
            },
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "label",
                    "doc_description": "It displays the label of Spinner."
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "aria-label": {
                        "name": "ariaLabel",
                        "value": "Loading"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "aria-live": {
                        "name": "ariaLive",
                        "value": "polite"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$PROP_MAP$a = (props)=>({
        appearance: {
            properties: {
                kind: props.appearance
            }
        }
    });
const $fe5170bdd3625759$var$withLogic$I = (Component)=>(userProps)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$a);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            appearance: props.appearance || "normal",
            ...{
                ...props,
                _determinate: props.value !== void 0
            }
        });
    };
const $fe5170bdd3625759$var$Component$M = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$I;
    const { labelPosition: labelPosition = "right", size: size = "medium", kind: kind = "normal", isOverlay: isOverlay = false, ariaLabel: ariaLabel = "Loading", ariaLive: ariaLive = "polite", custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            labelPosition: labelPosition,
            size: size,
            kind: kind,
            isOverlay: isOverlay,
            ariaLabel: ariaLabel,
            ariaLive: ariaLive,
            ...rest
        },
        componentTag: componentTag
    }, "JDSSpinner", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$7f7cbe89f1eacd2 = $fe5170bdd3625759$var$withLogic$I($fe5170bdd3625759$var$Component$M);
$fe5170bdd3625759$export$7f7cbe89f1eacd2.displayName = "Spinner";
$fe5170bdd3625759$export$7f7cbe89f1eacd2.slotName = "jds_spinner";
const $fe5170bdd3625759$var$sdl$H = {
    "metadata": {
        "name": "JDSStepperDot",
        "version": "1.0.0",
        "layerName": "jds_stepper_dot",
        "description": "Steppers help break a complex task into a series of manageable steps and guides useres through each step of their progress.",
        "usage": "Steppers are used to support new and improve existing processes such as checkout and account application journeys.",
        "internal": true
    },
    "hierarchy": {
        "step-icon-container": [
            "count-jds-text",
            "icon",
            "complete-icon",
            "dot-container"
        ]
    },
    "base": {
        "step-icon-container": {
            "background-color": "{s_0}",
            "border-width": "{s_1}",
            "border-color": "{s_2}",
            "min-height": "{s_3}",
            "min-width": "{s_4}",
            "justify-content": "{s_5}",
            "align-items": "{s_6}",
            "border-radius": "{s_7}",
            "show": true
        },
        "icon": {
            "hidden": true,
            "color": "{s_8}",
            "size": "{s_9}"
        },
        "complete-icon": {
            "hidden": true,
            "value": "ic_confirm",
            "color": "{s_10}",
            "size": "{s_11}"
        },
        "dot-container": {
            "hidden": true,
            "background-color": "{s_12}",
            "width": "{s_13}",
            "height": "{s_14}",
            "border-radius": "{s_15}",
            "show": true
        },
        "count-jds-text": {
            "font-family": "{bodyXxs}",
            "color": "{sparkleGrey60}",
            "font-size": "{bodyXxs}",
            "line-height": "{bodyXxs}",
            "letter-spacing": "{bodyXxs}",
            "font-weight": "{bodyXxs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "state": {
            "active": {
                "step-icon-container": {
                    "background-color": "{s_16}",
                    "border-color": "{s_17}"
                },
                "icon": {
                    "color": "{s_18}"
                },
                "dot-container": {
                    "background-color": "{s_19}"
                },
                "count-jds-text": {
                    "color": "{sparkleInverse}"
                }
            },
            "complete": {
                "step-icon-container": {
                    "background-color": "{s_20}",
                    "border-color": "{s_21}"
                },
                "complete-icon": {
                    "hidden": false
                },
                "count-jds-text": {
                    "hidden": true
                }
            },
            "disabled": {
                "step-icon-container": {
                    "disabled": true,
                    "opacity": "{s_26}"
                }
            }
        },
        "itemsType": {
            "icon": {
                "dot-container": {
                    "hidden": true
                },
                "step-icon-container": {
                    "height": "{s_22}",
                    "width": "{s_23}"
                },
                "count-jds-text": {
                    "hidden": true
                }
            },
            "dot": {
                "icon": {
                    "hidden": true
                },
                "dot-container": {
                    "hidden": false
                },
                "count-jds-text": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {
            "complete": {
                "icon": {
                    "icon": {
                        "hidden": true
                    }
                },
                "dot": {
                    "dot-container": {
                        "hidden": true
                    }
                }
            },
            "active": {
                "icon": {
                    "icon": {
                        "hidden": false
                    }
                }
            },
            "inactive": {
                "icon": {
                    "icon": {
                        "hidden": false
                    }
                }
            }
        },
        {
            "warning": {
                "active": {
                    "icon": {
                        "hidden": false,
                        "value": "ic_exclamation",
                        "color": "{s_24}"
                    },
                    "dot-container": {
                        "hidden": true
                    },
                    "count-jds-text": {
                        "hidden": true
                    }
                },
                "complete": {
                    "icon": {
                        "hidden": false,
                        "value": "ic_exclamation",
                        "color": "{s_25}"
                    },
                    "complete-icon": {
                        "hidden": true
                    },
                    "dot-container": {
                        "hidden": true
                    },
                    "count-jds-text": {
                        "hidden": true
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "state",
            "itemsType"
        ],
        [
            "activeState",
            "state"
        ]
    ],
    "api": {
        "config": {
            "state": {
                "values": [
                    "inactive",
                    "active",
                    "complete",
                    "disabled"
                ]
            },
            "itemsType": {
                "values": [
                    "numbered",
                    "icon",
                    "dot"
                ],
                "doc_description": "Represents the type of Stepper indication."
            },
            "activeState": {
                "values": [
                    "normal",
                    "warning"
                ],
                "doc_description": "Devs will set this to show the warning states for active index only."
            }
        },
        "data": {
            "icon": {
                "value": {
                    "type": "icon",
                    "name": "icon",
                    "function": true,
                    "doc_description": "Optional icon. Only shows if parent stepper type is icon."
                }
            },
            "count-jds-text": {
                "value": {
                    "type": "string",
                    "name": "index"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$H = (Component)=>(props)=>{
        const tokens = (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
        const language = tokens.lang;
        const numeralList = (0, $acw62.useMemo)(()=>{
            return (0, $8bd3c5c9ee0d1eb4$export$3f81e69b9bc596cd)(language);
        }, [
            language
        ]);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props,
            index: numeralList[Number(props.index ?? 0)]
        });
    };
const $fe5170bdd3625759$var$Component$L = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$H;
    const { state: state = "inactive", itemsType: itemsType = "numbered", activeState: activeState = "normal", custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            state: state,
            itemsType: itemsType,
            activeState: activeState,
            ...rest
        },
        componentTag: componentTag
    }, "JDSStepperDot", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$435f28d5690c41ca = $fe5170bdd3625759$var$withLogic$H($fe5170bdd3625759$var$Component$L);
$fe5170bdd3625759$export$435f28d5690c41ca.displayName = "StepperDot";
$fe5170bdd3625759$export$435f28d5690c41ca.slotName = "jds_stepper_dot";
const $fe5170bdd3625759$var$sdl$G = {
    "metadata": {
        "version": "1.0.0",
        "id": "tab-1.0.0",
        "name": "JDSTabBar",
        "layerName": "jds_tab_bar"
    },
    "hierarchy": {
        "container": [
            {
                "tab-container": [
                    "jds_tab_item"
                ]
            },
            {
                "indicator-container": [
                    {
                        "outer-container": [
                            "inner-container"
                        ]
                    }
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{t_0}",
            "justify-content": "{t_3}",
            "align-items": "{t_4}",
            "width": "{t_1}"
        },
        "indicator-container": {
            "z-index": 1,
            "show": true,
            "width": "{t_2}"
        },
        "tab-container": {
            "width": "{t_5}",
            "opacity": "{t_6}",
            "background-color": "{t_7}",
            "align-items": "{t_8}",
            "justify-content": "{t_9}",
            "gap": "{t_10}",
            "flex-direction": "{t_11}"
        },
        "jds_tab_item": {
            "kind": "label_icon",
            "appearance": "normal"
        },
        "outer-container": {
            "flex-direction": "{t_12}",
            "justify-content": "{t_13}",
            "align-items": "{t_14}",
            "width": "{t_15}",
            "transition": {
                "property": [
                    "padding-left"
                ],
                "duration": "{rapid}",
                "timing-function": "{easeRapid}"
            }
        },
        "inner-container": {
            "background-color": "{t_17}",
            "border-radius": "{t_16}",
            "height": "{t_18}",
            "show": true,
            "transition": {
                "property": [
                    "width"
                ],
                "duration": "{rapid}",
                "timing-function": "{easeRapid}"
            }
        }
    },
    "variant": {
        "overflow": {
            "fit": {
                "tab-container": {
                    "width": "{t_19}",
                    "justify-content": "{t_20}"
                },
                "jds_tab_item": {
                    "flex": 1
                }
            }
        },
        "kind": {
            "label": {
                "jds_tab_item": {
                    "kind": "label"
                }
            },
            "icon": {
                "jds_tab_item": {
                    "kind": "icon"
                }
            }
        },
        "appearance": {
            "tab_bar": {
                "tab-container": {
                    "background-color": "{t_21}",
                    "padding-right": "{t_22}",
                    "padding-left": "{t_23}"
                },
                "jds_tab_item": {
                    "appearance": "tab_bar"
                },
                "inner-container": {
                    "mode": "dark",
                    "background-color": "{t_24}"
                }
            }
        }
    },
    "combination": [
        {
            "mobile": {
                "tab_bar": {
                    "indicator-container": {
                        "padding-right": "{t_25}",
                        "padding-left": "{t_26}"
                    },
                    "tab-container": {
                        "padding-right": "{t_25}",
                        "padding-left": "{t_26}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "_platform",
            "appearance"
        ]
    ],
    "api": {
        "config": {
            "overflow": {
                "values": [
                    "scroll",
                    "fit"
                ]
            },
            "kind": {
                "type": "JDSTabItem.kind",
                "values": [
                    "label_icon",
                    "label",
                    "icon"
                ]
            },
            "appearance": {
                "type": "JDSTabItem.appearance",
                "values": [
                    "normal",
                    "tab_bar"
                ]
            },
            "_platform": {
                "values": [
                    "desktop",
                    "mobile"
                ]
            }
        },
        "data": {
            "tab-container": {
                "value": {
                    "type": "list",
                    "name": "items",
                    "object": {
                        "label": "string",
                        "icon": "icon",
                        "disabled": "boolean"
                    }
                }
            },
            "outer-container": {
                "padding-left": {
                    "type": "size",
                    "name": "_left"
                }
            },
            "inner-container": {
                "width": {
                    "type": "size",
                    "name": "_width"
                }
            },
            "jds_tab_item": {
                "activeTab": {
                    "type": "number",
                    "name": "activeTab"
                },
                "label": {
                    "type": "string",
                    "name": "items.label"
                },
                "icon": {
                    "type": "icon",
                    "name": "items.icon"
                },
                "disabled": {
                    "type": "boolean",
                    "name": "items.disabled"
                }
            }
        },
        "events": {
            "jds_tab_item": {
                "onAppear": {
                    "name": "_onAppear",
                    "platform": "ios, android"
                },
                "onClick": "onChange"
            },
            "container": {
                "onScroll": {
                    "name": "onScroll",
                    "platform": "web"
                },
                "onAppear": {
                    "name": "_onTabAppear",
                    "platform": "ios"
                }
            }
        },
        "a11y": {
            "tab-container": {
                "properties": {
                    "role": {
                        "value": "tablist"
                    }
                },
                "name": "items",
                "repeating": {
                    "ariaLabel": "tabAriaLabel",
                    "ariaDescribedby": {
                        "name": "tabAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_tab_item": {
                "properties": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": "ariaDescribedby"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$G = (Component)=>(props)=>{
        const { rootRef: rootRef, element: element } = $fe5170bdd3625759$var$useRootRef();
        const [activeTabStyles, setActiveTabStyles] = (0, $acw62.useState)({
            _left: void 0,
            _width: void 0
        });
        const calculateStyles = (0, $acw62.useCallback)(()=>{
            const tabContainers = Array.from(element?.querySelectorAll("div.j-JDSTabItem-outer-container") || []);
            const active = tabContainers[props.activeTab || 0];
            setActiveTabStyles({
                _left: active?.offsetLeft,
                _width: active?.offsetWidth
            });
        }, [
            element,
            props.activeTab
        ]);
        (0, $acw62.useEffect)(()=>{
            if (element) {
                calculateStyles();
                const resizeObserver = new ResizeObserver(()=>{
                    calculateStyles();
                });
                element.querySelectorAll("div.j-JDSTabItem-outer-container").forEach((tabContainer)=>{
                    resizeObserver.observe(tabContainer);
                });
                return ()=>{
                    resizeObserver.disconnect();
                };
            }
        }, [
            element,
            calculateStyles
        ]);
        (0, $acw62.useEffect)(()=>{
            window.addEventListener("resize", calculateStyles);
            return ()=>{
                window.removeEventListener("resize", calculateStyles);
            };
        }, [
            calculateStyles
        ]);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                rootRef: rootRef,
                _left: activeTabStyles._left,
                _width: activeTabStyles._width
            }
        });
    };
const $fe5170bdd3625759$var$Component$K = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$G;
    const { overflow: overflow = "scroll", kind: kind = "undefined", appearance: appearance = "undefined", onChange: onChange = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onScroll: onScroll = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            overflow: overflow,
            kind: kind,
            appearance: appearance,
            onChange: onChange,
            onScroll: onScroll,
            ...rest
        },
        componentTag: componentTag
    }, "JDSTabBar", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$f97dc4a5a0177256 = $fe5170bdd3625759$var$withLogic$G($fe5170bdd3625759$var$Component$K);
$fe5170bdd3625759$export$f97dc4a5a0177256.displayName = "TabBar";
$fe5170bdd3625759$export$f97dc4a5a0177256.slotName = "jds_tab_bar";
const $fe5170bdd3625759$var$sdl$F = {
    "metadata": {
        "version": "1.0.0",
        "id": "tab-item-1.0.0",
        "name": "JDSTabItem",
        "layerName": "jds_tab_item"
    },
    "hierarchy": {
        "outer-container": [
            {
                "container": [
                    "icon",
                    "text"
                ]
            }
        ]
    },
    "base": {
        "outer-container": {
            "background-color": "{t_0}",
            "flex-direction": "{t_1}",
            "align-items": "{t_2}",
            "justify-content": "{t_3}",
            "min-height": "{t_4}",
            "height": "{t_6}",
            "width": "{t_5}",
            "opacity": "{t_33}",
            "behavior": {
                "hover": {},
                "active": {}
            }
        },
        "container": {
            "flex-direction": "{t_7}",
            "align-items": "{t_8}",
            "justify-content": "{t_9}",
            "gap": "{t_10}",
            "flex": 1,
            "padding-top": "{t_11}",
            "padding-bottom": "{t_12}",
            "padding-right": "{t_13}",
            "padding-left": "{t_14}",
            "behavior": {
                "focus": {
                    "border-width": "{t_15}",
                    "border-color": "{t_16}",
                    "border-radius": "{t_17}"
                }
            }
        },
        "text": {
            "color": "{t_22}",
            "font-family": "{t_24}",
            "font-size": "{t_23}",
            "line-height": "{t_26}",
            "letter-spacing": "{t_27}",
            "font-weight": "{t_25}",
            "max-lines": 2,
            "behavior": {
                "hover": {
                    "color": "{t_28}"
                },
                "active": {
                    "color": "{tabitem_base_text_behavior_active_color}"
                }
            }
        },
        "icon": {
            "size": "{t_18}",
            "color": "{t_19}",
            "hidden": false,
            "behavior": {
                "hover": {
                    "color": "{t_20}"
                },
                "active": {
                    "color": "{t_21}"
                }
            }
        }
    },
    "variant": {
        "kind": {
            "label": {
                "icon": {
                    "hidden": true
                }
            },
            "icon": {
                "text": {
                    "hidden": true
                }
            }
        },
        "disabled": {
            "true": {
                "outer-container": {
                    "disabled": true,
                    "opacity": "{t_34}"
                },
                "container": {
                    "disabled": true
                }
            }
        },
        "appearance": {
            "normal": {
                "text": {
                    "behavior": {
                        "hover": {
                            "color": "{t_35}"
                        },
                        "active": {
                            "color": "{t_36}"
                        }
                    }
                }
            },
            "tab_bar": {
                "container": {
                    "mode": "dark",
                    "behavior": {
                        "active": {
                            "background-color": "{t_37}"
                        },
                        "focus": {
                            "border-color": "{t_38}"
                        }
                    }
                },
                "text": {
                    "color": "{t_42}",
                    "behavior": {
                        "hover": {
                            "color": "{t_43}"
                        },
                        "active": {
                            "color": "{t_44}"
                        }
                    }
                },
                "icon": {
                    "color": "{t_39}",
                    "behavior": {
                        "hover": {
                            "color": "{t_40}"
                        },
                        "active": {
                            "color": "{t_41}"
                        }
                    }
                }
            }
        }
    },
    "combination": [
        {
            "active": {
                "normal": {
                    "text": {
                        "color": "{t_46}"
                    },
                    "icon": {
                        "color": "{t_45}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "state",
            "appearance"
        ]
    ],
    "api": {
        "config": {
            "state": {
                "values": [
                    "inactive",
                    "active"
                ]
            },
            "kind": {
                "values": [
                    "label_icon",
                    "label",
                    "icon"
                ]
            },
            "appearance": {
                "values": [
                    "normal",
                    "tab_bar"
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            },
            "icon": {
                "value": {
                    "type": "icon",
                    "name": "icon"
                }
            }
        },
        "events": {
            "outer-container": {
                "onAppear": {
                    "name": "onAppear",
                    "platform": "ios, android"
                }
            },
            "container": {
                "onClick": "onClick"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "tab"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "aria-selected": {
                        "name": "_ariaSelected"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$F = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8bd3c5c9ee0d1eb4$export$e5cf4eff53e7947d), {
            value: {
                mode: props.appearance === "tab_bar" ? "dark" : void 0
            },
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
                ...{
                    ...props,
                    onClick: ()=>{
                        if (!props.disabled) props.onClick?.(props.internalIndex);
                    },
                    state: props.activeTab === props.internalIndex ? "active" : "default",
                    _ariaSelected: props.activeTab === props.internalIndex
                }
            })
        });
    };
const $fe5170bdd3625759$var$Component$J = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$F;
    const { state: state = "inactive", kind: kind = "label_icon", appearance: appearance = "normal", disabled: disabled = false, onAppear: onAppear = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onClick: onClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), ariaLabel: ariaLabel = props.label?.toString(), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            state: state,
            kind: kind,
            appearance: appearance,
            disabled: disabled,
            onAppear: onAppear,
            onClick: onClick,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSTabItem", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$17043b9d35150718 = $fe5170bdd3625759$var$withLogic$F($fe5170bdd3625759$var$Component$J);
$fe5170bdd3625759$export$17043b9d35150718.displayName = "TabItem";
$fe5170bdd3625759$export$17043b9d35150718.slotName = "jds_tab_item";
const $fe5170bdd3625759$var$sdl$E = {
    "metadata": {
        "version": "1.0.0",
        "id": "table-body-1.0.0",
        "name": "JDSTableBody",
        "layerName": "jds_table_body",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "jds_table_row"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{t_1}"
        },
        "jds_table_row": {}
    },
    "variant": {
        "density": {
            "condensed": {
                "jds_table_row": {
                    "density": "condensed"
                }
            }
        },
        "fullWidth": {
            "true": {
                "container": {
                    "width": "{t_2}"
                },
                "jds_table_row": {
                    "flex": 1
                }
            }
        },
        "columnDivider": {
            "true": {
                "jds_table_row": {
                    "columnDivider": true
                }
            }
        }
    },
    "api": {
        "config": {
            "density": {
                "type": "JDSTableCell.density",
                "values": [
                    "relaxed",
                    "condensed"
                ]
            },
            "columnDivider": {
                "values": [
                    false,
                    true
                ],
                "function": true
            },
            "fullWidth": {
                "values": [
                    false,
                    true
                ]
            },
            "zebra": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "container": {
                "value": {
                    "type": "list",
                    "name": "rows",
                    "function": true,
                    "object": {
                        "cells": "JDSTableRow.cells"
                    }
                }
            },
            "jds_table_row": {
                "cells": {
                    "name": "rows.cells",
                    "type": "list"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$E = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$I = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$E;
    const { density: density = "undefined", columnDivider: columnDivider = false, fullWidth: fullWidth = false, zebra: zebra = false, custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            density: density,
            columnDivider: columnDivider,
            fullWidth: fullWidth,
            zebra: zebra,
            ...rest
        },
        componentTag: componentTag
    }, "JDSTableBody", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$76ccd210b9029917 = $fe5170bdd3625759$var$withLogic$E($fe5170bdd3625759$var$Component$I);
$fe5170bdd3625759$export$76ccd210b9029917.displayName = "TableBody";
$fe5170bdd3625759$export$76ccd210b9029917.slotName = "jds_table_body";
const $fe5170bdd3625759$var$sdl$D = {
    "metadata": {
        "version": "1.0.0",
        "id": "table-cell-1.0.0",
        "name": "JDSTableCell",
        "layerName": "jds_table_cell",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "jds-text"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{t_0}",
            "justify-content": "{t_1}",
            "align-items": "{t_2}",
            "background-color": "{t_3}",
            "padding-left": "{t_4}",
            "padding-right": "{t_5}",
            "padding-top": "{t_6}",
            "padding-bottom": "{t_7}",
            "border-color": "{t_8}",
            "border-bottom-width": 1,
            "width": "{t_9}"
        },
        "jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey100}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 1,
            "maxLines": 1
        }
    },
    "variant": {
        "density": {
            "condensed": {
                "container": {
                    "padding-left": "{t_10}",
                    "padding-right": "{t_11}",
                    "padding-top": "{t_12}",
                    "padding-bottom": "{t_13}"
                }
            }
        },
        "columnDivider": {
            "true": {
                "container": {
                    "border-color": "{t_14}",
                    "border-right-width": "{t_15}"
                }
            }
        }
    },
    "combination": [
        {
            "header": {
                "true": {
                    "container": {
                        "background-color": "{t_16}",
                        "border-color": "{t_17}",
                        "border-bottom-width": "{t_19}"
                    },
                    "jds-text": {
                        "font-family": "{headingXxs}",
                        "color": "{primaryInverse}",
                        "font-size": "{headingXxs}",
                        "line-height": "{headingXxs}",
                        "letter-spacing": "{headingXxs}",
                        "font-weight": "{headingXxs}"
                    }
                },
                "false": {
                    "container": {
                        "border-bottom-width": "{t_20}"
                    },
                    "jds-text": {
                        "font-family": "{headingXxs}",
                        "font-size": "{headingXxs}",
                        "line-height": "{headingXxs}",
                        "letter-spacing": "{headingXxs}",
                        "font-weight": "{headingXxs}"
                    }
                }
            },
            "cell": {
                "true": {
                    "container": {
                        "background-color": "{t_18}",
                        "border-bottom-width": "{t_21}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "type",
            "background"
        ]
    ],
    "api": {
        "data": {
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            }
        },
        "config": {
            "type": {
                "values": [
                    "cell",
                    "header"
                ]
            },
            "density": {
                "values": [
                    "relaxed",
                    "condensed"
                ]
            },
            "background": {
                "values": [
                    false,
                    true
                ]
            },
            "columnDivider": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "name": "_role"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$D = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                _role: props.type === "header" ? "columnheader" : "cell"
            }
        });
    };
const $fe5170bdd3625759$var$Component$H = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$D;
    const { type: type = "cell", density: density = "relaxed", background: background = false, columnDivider: columnDivider = false, custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            type: type,
            density: density,
            background: background,
            columnDivider: columnDivider,
            ...rest
        },
        componentTag: componentTag
    }, "JDSTableCell", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$1e4baea7053fc0e3 = $fe5170bdd3625759$var$withLogic$D($fe5170bdd3625759$var$Component$H);
$fe5170bdd3625759$export$1e4baea7053fc0e3.displayName = "TableCell";
$fe5170bdd3625759$export$1e4baea7053fc0e3.slotName = "jds_table_cell";
const $fe5170bdd3625759$var$sdl$C = {
    "metadata": {
        "version": "1.0.0",
        "id": "table-row-1.0.0",
        "name": "JDSTableRow",
        "layerName": "jds_table_row",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "jds_table_cell"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{t_0}",
            "lazy-scroll-android": false,
            "width": "{intrinsicSize.max}"
        },
        "jds_table_cell": {
            "width": "{size.max}"
        }
    },
    "variant": {
        "density": {
            "condensed": {
                "jds_table_cell": {
                    "density": "condensed"
                }
            }
        },
        "columnDivider": {
            "true": {
                "jds_table_cell": {
                    "columnDivider": true
                }
            }
        }
    },
    "api": {
        "config": {
            "density": {
                "type": "JDSTableCell.density",
                "values": [
                    "relaxed",
                    "condensed"
                ]
            },
            "columnDivider": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "container": {
                "value": {
                    "type": "list",
                    "name": "cells",
                    "object": {
                        "text": "string",
                        "type": "JDSTableCell.type",
                        "background": "boolean"
                    }
                }
            },
            "jds_table_cell": {
                "label": {
                    "name": "cells.text",
                    "type": "string"
                },
                "type": {
                    "name": "cells.type",
                    "type": "JDSTableCell.type"
                },
                "background": {
                    "name": "cells.background",
                    "type": "boolean"
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "row"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$C = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$G = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$C;
    const { density: density = "undefined", columnDivider: columnDivider = false, custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            density: density,
            columnDivider: columnDivider,
            ...rest
        },
        componentTag: componentTag
    }, "JDSTableRow", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$b05581f4e764e162 = $fe5170bdd3625759$var$withLogic$C($fe5170bdd3625759$var$Component$G);
$fe5170bdd3625759$export$b05581f4e764e162.displayName = "TableRow";
$fe5170bdd3625759$export$b05581f4e764e162.slotName = "jds_table_row";
const $fe5170bdd3625759$var$sdl$B = {
    "metadata": {
        "version": "1.0.0",
        "id": "tab-desktop-1.0.0",
        "name": "JDSTabsDesktop",
        "platform": "web",
        "layerName": "jds_tabs_desktop",
        "description": "Horizontal scrollable tabs is a navigation  device placed at the top of a page or content area that they relate to and can be separated into smaller groups of related information",
        "usage": "Use this type of tabs to organize related product information on a model landing page."
    },
    "hierarchy": {
        "container": [
            {
                "header-container": [
                    "prev-jds_button",
                    {
                        "tablist-container": [
                            "jds_tab_bar"
                        ]
                    },
                    "next-jds_button"
                ]
            },
            "content-slot"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{t_0}",
            "width": "{t_1}"
        },
        "jds_tab_bar": {
            "width": "{t_2}",
            "overflow": "scroll",
            "appearance": "normal",
            "kind": "label_icon"
        },
        "header-container": {
            "flex-direction": "{t_3}",
            "width": "{t_4}",
            "align-items": "{t_5}"
        },
        "prev-jds_button": {
            "icon": "ic_back",
            "kind": "tertiary",
            "hidden": true
        },
        "next-jds_button": {
            "icon": "ic_next",
            "kind": "tertiary",
            "hidden": true
        },
        "tablist-container": {
            "width": "{t_6}",
            "overflow": "auto"
        }
    },
    "variant": {
        "overflow": {
            "fit": {
                "jds_tab_bar": {
                    "overflow": "fit"
                },
                "tablist-container": {
                    "overflow": "hidden"
                }
            },
            "arrows": {
                "prev-jds_button": {
                    "hidden": false
                },
                "next-jds_button": {
                    "hidden": false
                },
                "header-container": {
                    "gap": "{t_7}"
                }
            }
        },
        "appearance": {
            "tab_bar": {
                "jds_tab_bar": {
                    "appearance": "tab_bar"
                },
                "header-container": {
                    "background-color": "{t_8}"
                }
            }
        },
        "_kind": {
            "label": {
                "jds_tab_bar": {
                    "kind": "label"
                }
            },
            "icon": {
                "jds_tab_bar": {
                    "kind": "icon"
                }
            }
        },
        "_hideNextBtn": {
            "true": {
                "next-jds_button": {
                    "hidden": true
                }
            }
        },
        "_hidePrevBtn": {
            "true": {
                "prev-jds_button": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "overflow": {
                "values": [
                    "scroll",
                    "fit",
                    "arrows"
                ],
                "doc_dscription": "Setting this to true makes the Tab fit the available width."
            },
            "appearance": {
                "type": "JDSTabItem.appearance",
                "values": [
                    "normal",
                    "tab_bar"
                ]
            },
            "_kind": {
                "type": "JDSTabItem.kind",
                "values": [
                    "label_icon",
                    "label",
                    "icon"
                ]
            },
            "_hideNextBtn": {
                "values": [
                    false,
                    true
                ]
            },
            "_hidePrevBtn": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds_tab_bar": {
                "items": {
                    "type": "list",
                    "name": "items",
                    "object": {
                        "label": "string",
                        "icon": "icon",
                        "disabled": "boolean"
                    }
                },
                "activeTab": {
                    "type": "number",
                    "name": "activeTab",
                    "doc_description": "Changes programatically the active tab with animation."
                }
            }
        },
        "events": {
            "jds_tab_bar": {
                "onChange": "onChange",
                "onScroll": "onScroll"
            },
            "prev-jds_button": {
                "onClick": "onPrevClick"
            },
            "next-jds_button": {
                "onClick": "onNextClick"
            }
        },
        "children": {
            "content-slot": {
                "name": "content",
                "accepts": [
                    "template"
                ]
            }
        },
        "a11y": {
            "jds_tab_bar": {
                "name": "items",
                "repeating": {
                    "ariaLabel": "tabAriaLabel",
                    "ariaDescribedby": {
                        "name": "tabAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "prev-jds_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "previousButtonAriaLabel",
                        "value": "Previous Tab"
                    }
                }
            },
            "next-jds_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "nextButtonAriaLabel",
                        "value": "Next Tab"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$getOverflow = (props)=>{
    if ([
        "tab-bar",
        "tab_bar"
    ].includes(props.appearance)) {
        if ([
            "arrow",
            "arrows"
        ].includes(props.overflow)) return "scroll";
    }
    return props.overflow;
};
const $fe5170bdd3625759$var$PROP_MAP$9 = (props)=>{
    if (props.appearance === "tab-bar") console.warn("appearance tab-bar is deprecated. Use tab_bar instead");
    if (props.overflow === "arrow") console.warn("overflow arrrow is deprecated. Use arrow instead");
    return {
        appearance: {
            variations: {
                normal: {
                    appearance: "normal"
                },
                "tab-bar": {
                    appearance: "tab_bar"
                }
            }
        },
        overflow: {
            variations: {
                arrow: {
                    overflow: "arrows"
                }
            },
            normal: {
                overflow: "normal"
            }
        }
    };
};
const $fe5170bdd3625759$var$TAB_LIST_CLASS = 'div[data-testid="JDSTabsDesktop-tablist-container"]';
const $fe5170bdd3625759$var$SCROLLABLE_CLASS = ".j-JDSTabBar-tab-container";
const $fe5170bdd3625759$var$withLogic$B = (Component)=>(userProps)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$9);
        const { element: element, rootRef: rootRef } = $fe5170bdd3625759$var$useRootRef();
        const { index: index, onClick: onClick } = $fe5170bdd3625759$var$useSelected(props.activeTab || 0);
        const items = props.items || props.children?.map((c)=>c.props);
        const tabListElement = element?.querySelector($fe5170bdd3625759$var$TAB_LIST_CLASS);
        const scrollableELement = element?.querySelector($fe5170bdd3625759$var$SCROLLABLE_CLASS);
        const hasIcon = items?.every((i)=>i?.icon);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                items: items,
                rootRef: rootRef,
                _kind: hasIcon ? "label_icon" : "label",
                activeTab: index,
                overflow: $fe5170bdd3625759$var$getOverflow(props),
                onNextClick: ()=>{
                    if (tabListElement && scrollableELement) {
                        const scrollValue = Math.min(tabListElement.scrollWidth, tabListElement.scrollLeft + tabListElement.clientWidth);
                        tabListElement.scrollTo({
                            left: scrollValue,
                            behavior: "smooth"
                        });
                    }
                },
                onPrevClick: ()=>{
                    if (tabListElement) {
                        const scrollValue = Math.max(0, tabListElement.scrollLeft - tabListElement.clientWidth);
                        tabListElement.scrollTo({
                            left: scrollValue,
                            behavior: "smooth"
                        });
                    }
                },
                content: items?.[index]?.children,
                onChange: (i)=>{
                    onClick(i);
                    props.onChange?.(i);
                }
            }
        });
    };
const $fe5170bdd3625759$var$Component$F = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$B;
    const { overflow: overflow = "scroll", appearance: appearance = "undefined", onChange: onChange = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onScroll: onScroll = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onPrevClick: onPrevClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onNextClick: onNextClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), previousButtonAriaLabel: previousButtonAriaLabel = "Previous Tab", nextButtonAriaLabel: nextButtonAriaLabel = "Next Tab", custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            overflow: overflow,
            appearance: appearance,
            onChange: onChange,
            onScroll: onScroll,
            onPrevClick: onPrevClick,
            onNextClick: onNextClick,
            previousButtonAriaLabel: previousButtonAriaLabel,
            nextButtonAriaLabel: nextButtonAriaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSTabsDesktop", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$b2539bed5023c21c = $fe5170bdd3625759$var$withLogic$B($fe5170bdd3625759$var$Component$F);
$fe5170bdd3625759$export$b2539bed5023c21c.displayName = "Tabs";
$fe5170bdd3625759$export$b2539bed5023c21c.slotName = "jds_tabs_desktop";
const $fe5170bdd3625759$var$sdl$A = {
    "metadata": {
        "version": "1.0.0",
        "id": "tag-1.0.0",
        "name": "JDSTag",
        "layerName": "jds_tag",
        "description": "Tags are keywords used to describe, categorize, or filter content.",
        "usage": "Use tags when content is mapped to multiple categories, and the user needs a way to differentiate between them."
    },
    "hierarchy": {
        "container": [
            "jds-text",
            "icon"
        ]
    },
    "base": {
        "container": {
            "hidden": false,
            "display": "flex",
            "flex-direction": "{t_0}",
            "justify-content": "{t_1}",
            "align-items": "{t_2}",
            "padding-top": "{t_3}",
            "padding-left": "{t_4}",
            "padding-right": "{t_5}",
            "padding-bottom": "{t_6}",
            "gap": "{t_7}",
            "background-color": "{t_8}",
            "border-radius": "{t_9}",
            "border-width": "{t_10}",
            "border-color": "{t_11}",
            "opacity": "{t_30}",
            "behavior": {
                "active": {
                    "border-color": "{t_13}"
                },
                "focus": {
                    "border-color": "{t_14}",
                    "border-width": "{t_15}"
                },
                "hover": {
                    "border-color": "{t_12}"
                }
            }
        },
        "icon": {
            "hidden": true,
            "size": "{t_16}",
            "color": "{t_17}",
            "behavior": {
                "hover": {
                    "color": "{t_18}"
                },
                "active": {
                    "color": "{t_19}"
                },
                "focus": {
                    "color": "{t_20}"
                }
            }
        },
        "jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey100}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 1,
            "hidden": false,
            "maxLines": 1,
            "behavior": {
                "hover": {
                    "color": "{sparkle80}"
                },
                "active": {
                    "color": "{sparkle80}"
                },
                "focus": {
                    "color": "{sparkle80}"
                }
            }
        }
    },
    "variant": {
        "size": {
            "small": {
                "container": {
                    "padding-top": "{t_31}",
                    "padding-left": "{t_32}",
                    "padding-right": "{t_33}",
                    "padding-bottom": "{t_34}"
                },
                "jds-text": {
                    "font-family": "{bodyXs}",
                    "font-size": "{bodyXs}",
                    "line-height": "{bodyXs}",
                    "letter-spacing": "{bodyXs}",
                    "font-weight": "{bodyXs}"
                }
            }
        },
        "kind": {
            "filter": {
                "icon": {
                    "hidden": false
                }
            }
        },
        "active": {
            "true": {
                "container": {
                    "background-color": "{t_23}",
                    "border-width": "{t_21}",
                    "border-color": "{t_22}",
                    "behavior": {
                        "hover": {
                            "background-color": "{t_24}"
                        },
                        "active": {
                            "background-color": "{t_25}",
                            "border-color": "{t_26}",
                            "border-width": 1
                        },
                        "focus": {
                            "background-color": "{t_27}"
                        }
                    }
                },
                "icon": {
                    "color": "{t_28}",
                    "value": "ic_close"
                },
                "jds-text": {
                    "color": "{sparkle80}"
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{t_29}"
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "data": {
            "icon": {
                "value": {
                    "type": "icon",
                    "name": "icon",
                    "function": true
                }
            },
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "label",
                    "doc_description": "It displays label of Tag."
                }
            }
        },
        "config": {
            "size": {
                "values": [
                    "medium",
                    "small"
                ],
                "doc_description": "It can be used to control size of Tag."
            },
            "kind": {
                "values": [
                    "toggle",
                    "filter"
                ],
                "doc_description": "It can be used to switch between 2 variants of Tag."
            },
            "disabled": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to enable or disable Tag."
            },
            "active": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "This can be used to activate Tag."
            }
        },
        "events": {
            "container": {
                "onClick": "onClick"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "button"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "aria-pressed": {
                        "name": "_ariaPressed",
                        "prop": "active"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$A = (Component)=>(props)=>{
        const { selected: selected, toggle: toggle } = $fe5170bdd3625759$var$useToggle(props.active, props.kind !== "normal", props.onClick);
        const icon = selected ? "IcClose" : typeof props.icon === "string" ? props.icon : "IcAdd";
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                onClick: toggle,
                active: selected,
                icon: icon
            }
        });
    };
const $fe5170bdd3625759$var$Component$E = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$A;
    const { size: size = "medium", kind: kind = "toggle", disabled: disabled = false, active: active = false, onClick: onClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), ariaLabel: ariaLabel = props.label?.toString(), _ariaPressed: _ariaPressed = props.active?.toString(), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            size: size,
            kind: kind,
            disabled: disabled,
            active: active,
            onClick: onClick,
            ariaLabel: ariaLabel,
            _ariaPressed: _ariaPressed,
            ...rest
        },
        componentTag: componentTag
    }, "JDSTag", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$3288d34c523a1192 = $fe5170bdd3625759$var$withLogic$A($fe5170bdd3625759$var$Component$E);
$fe5170bdd3625759$export$3288d34c523a1192.displayName = "Tag";
$fe5170bdd3625759$export$3288d34c523a1192.slotName = "jds_tag";
const $fe5170bdd3625759$var$sdl$z = {
    "metadata": {
        "version": "1.0.0",
        "id": "toast-1.0.0",
        "name": "JDSToast",
        "layerName": "jds_toast"
    },
    "hierarchy": {
        "root-container": [
            {
                "base-container": [
                    "left-slot",
                    {
                        "center-container": [
                            "heading-jds-text",
                            "support-jds-text"
                        ]
                    },
                    "close-jds_notification_button",
                    "right-slot"
                ]
            },
            {
                "buttons-container": [
                    "secondary-jds_notification_button",
                    "primary-jds_notification_button"
                ]
            }
        ]
    },
    "base": {
        "root-container": {
            "width": "{t_0}",
            "max-width": "{t_1}",
            "border-radius": "{t_2}",
            "background-color": "{t_3}",
            "flex-direction": "{t_4}",
            "gap": "{t_5}",
            "padding-top": "{t_6}",
            "padding-right": "{t_7}",
            "padding-bottom": "{t_8}",
            "padding-left": "{t_9}",
            "enter-animation-name": "slideVerticallyUp",
            "exit-animation-name": "slideVerticallyDown",
            "enter-animation-curve": "entrance_ease",
            "exit-animation-curve": "exit_ease",
            "enter-animation-duration": 500,
            "exit-animation-duration": 500,
            "transition": {
                "property": [
                    "translate-x",
                    "translate-y"
                ],
                "duration": "{medium}",
                "timing-function": "{easeJoyfulExit}"
            },
            "hidden": true
        },
        "base-container": {
            "gap": "{t_10}",
            "flex-direction": "{t_12}",
            "justify-content": "{t_13}",
            "align-items": "{t_14}",
            "width": "{t_11}"
        },
        "center-container": {
            "flex-direction": "{t_15}",
            "justify-content": "{t_16}",
            "align-items": "{t_17}",
            "gap": "{t_18}",
            "flex": 1
        },
        "close-jds_notification_button": {
            "hidden": false,
            "icon": "ic_close",
            "kind": "tertiary"
        },
        "buttons-container": {
            "gap": "{t_20}",
            "flex-direction": "{t_21}",
            "justify-content": "{t_22}",
            "width": "{t_19}"
        },
        "secondary-jds_notification_button": {
            "kind": "tertiary"
        },
        "right-slot": {
            "hidden": true
        },
        "heading-jds-text": {
            "font-family": "{bodySBold}",
            "color": "{primaryBackground}",
            "font-size": "{bodySBold}",
            "line-height": "{bodySBold}",
            "letter-spacing": "{bodySBold}",
            "font-weight": "{bodySBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 2,
            "maxLines": 2
        },
        "support-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey20}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 2,
            "maxLines": 2
        }
    },
    "variant": {
        "open": {
            "true": {
                "root-container": {
                    "hidden": false,
                    "transition": {
                        "timing-function": "{easeJoyfulEntrance}"
                    }
                }
            }
        },
        "showClose": {
            "false": {
                "close-jds_notification_button": {
                    "hidden": true
                },
                "right-slot": {
                    "hidden": false
                }
            }
        },
        "_platform": {
            "tablet": {
                "root-container": {
                    "max-width": "{t_23}"
                }
            },
            "desktop": {
                "root-container": {
                    "max-width": "{t_24}"
                }
            }
        },
        "_hasCTA": {
            "false": {
                "buttons-container": {
                    "hidden": true
                }
            }
        },
        "_hasDescription": {
            "false": {
                "support-jds-text": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {
            "false": {
                "mobile": {
                    "root-container": {
                        "translate-y": "{size.max}"
                    }
                },
                "tablet": {
                    "root-container": {
                        "translate-x": "{size.negativeMax}"
                    }
                },
                "desktop": {
                    "root-container": {
                        "translate-x": "{size.negativeMax}"
                    }
                }
            },
            "true": {
                "mobile": {
                    "root-container": {
                        "translate-y": 0
                    }
                },
                "tablet": {
                    "root-container": {
                        "translate-x": 0
                    }
                },
                "desktop": {
                    "root-container": {
                        "translate-x": 0
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "open",
            "_platform"
        ]
    ],
    "api": {
        "config": {
            "open": {
                "values": [
                    false,
                    true
                ]
            },
            "showClose": {
                "values": [
                    true,
                    false
                ],
                "doc_description": "This shows close button on Toast when true."
            },
            "_platform": {
                "values": [
                    "mobile",
                    "tablet",
                    "desktop"
                ]
            },
            "_hasCTA": {
                "values": [
                    true,
                    false
                ]
            },
            "_hasDescription": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "root-container": {
                "_nudge.id": {
                    "type": "NotificationId",
                    "name": "id",
                    "required": true,
                    "doc_description": "It will hold the reference of Toast"
                },
                "dismissAfter": {
                    "type": "number",
                    "name": "dismissAfter"
                }
            },
            "secondary-jds_notification_button": {
                "label": {
                    "type": "string",
                    "name": "secondaryCTA",
                    "doc_description": "It displays label of secondary button of Toast."
                }
            },
            "primary-jds_notification_button": {
                "label": {
                    "type": "string",
                    "name": "primaryCTA",
                    "doc_description": "It displays label of primary button of Toast."
                }
            },
            "heading-jds-text": {
                "value": {
                    "type": "string",
                    "name": "title",
                    "doc_description": "It displays the title of Toast."
                }
            },
            "support-jds-text": {
                "value": {
                    "type": "string",
                    "name": "description",
                    "doc_description": "It can be used to add description to the Toast."
                }
            }
        },
        "events": {
            "root-container": {
                "onShow": "onShow",
                "onUpdate": {
                    "name": "onUpdate",
                    "platform": "android"
                },
                "onHover": {
                    "name": "onHover",
                    "platform": "web"
                },
                "onHoverEnd": {
                    "name": "onHoverEnd",
                    "platform": "web"
                },
                "onSwipeDown": "onClose"
            },
            "close-jds_notification_button": {
                "onClick": "onClose"
            },
            "secondary-jds_notification_button": {
                "onClick": "onSecondaryClick"
            },
            "primary-jds_notification_button": {
                "onClick": "onPrimaryClick"
            }
        },
        "children": {
            "left-slot": {
                "accepts": [
                    "jds_icon",
                    "jds_avatar"
                ],
                "max": 1,
                "name": "prefix",
                "doc_description": "It takes 'icon', 'avatar' as prefix."
            },
            "right-slot": {
                "accepts": [
                    "jds_notification_button"
                ],
                "max": 1,
                "name": "suffix",
                "doc_description": "It takes 'jds_notification_button' as suffix."
            }
        },
        "a11y": {
            "root-container": {
                "properties": {
                    "role": {
                        "value": "alertdialog"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "title"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$Component$D = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$z;
    const { open: open = false, showClose: showClose = true, onShow: onShow = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onUpdate: onUpdate = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onHover: onHover = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onHoverEnd: onHoverEnd = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onClose: onClose = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSecondaryClick: onSecondaryClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onPrimaryClick: onPrimaryClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), ariaLabel: ariaLabel = props.title?.toString(), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            open: open,
            showClose: showClose,
            onShow: onShow,
            onUpdate: onUpdate,
            onHover: onHover,
            onHoverEnd: onHoverEnd,
            onClose: onClose,
            onSecondaryClick: onSecondaryClick,
            onPrimaryClick: onPrimaryClick,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSToast", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$var$Toast = $fe5170bdd3625759$var$withLogic$W($fe5170bdd3625759$var$Component$D);
$fe5170bdd3625759$var$Toast.displayName = "Toast";
$fe5170bdd3625759$var$Toast.slotName = "jds_toast";
const $fe5170bdd3625759$var$sdl$y = {
    "metadata": {
        "version": "1.0.0",
        "id": "tooltip-1.0.0",
        "name": "JDSTooltip",
        "layerName": "jds_tooltip",
        "description": "Tooltips are floating elements primarily used for accessibility as its function. It is used to display additional information about a user interface element or feature.",
        "usage": "The information included should be contextual, helpful, and nonessential while providing that extra ability to communicate and give clarity to a user."
    },
    "hierarchy": {
        "popup": [
            {
                "popup-container": [
                    "jds_tooltip_internal"
                ]
            }
        ]
    },
    "base": {
        "popup": {
            "passive": true,
            "hidden": true,
            "priority": 30
        },
        "popup-container": {
            "flex-direction": "{t_0}",
            "justify-content": "{t_1}",
            "align-items": "{t_2}"
        },
        "jds_tooltip_internal": {}
    },
    "variant": {
        "position": {
            "right_start": {
                "jds_tooltip_internal": {
                    "position": "right_start"
                }
            },
            "right_end": {
                "jds_tooltip_internal": {
                    "position": "right_end"
                }
            },
            "left": {
                "jds_tooltip_internal": {
                    "position": "left"
                }
            },
            "left_start": {
                "jds_tooltip_internal": {
                    "position": "left_start"
                }
            },
            "left_end": {
                "jds_tooltip_internal": {
                    "position": "left_end"
                }
            },
            "top": {
                "jds_tooltip_internal": {
                    "position": "top"
                }
            },
            "top_start": {
                "jds_tooltip_internal": {
                    "position": "top_start"
                }
            },
            "top_end": {
                "jds_tooltip_internal": {
                    "position": "top_end"
                }
            },
            "bottom": {
                "jds_tooltip_internal": {
                    "position": "bottom"
                }
            },
            "bottom_start": {
                "jds_tooltip_internal": {
                    "position": "bottom_start"
                }
            },
            "bottom_end": {
                "jds_tooltip_internal": {
                    "position": "bottom_end"
                }
            }
        },
        "open": {
            "true": {
                "popup": {
                    "hidden": false
                }
            }
        },
        "_platform": {
            "desktop": {
                "jds_tooltip_internal": {
                    "_platform": "desktop"
                }
            }
        }
    },
    "api": {
        "config": {
            "position": {
                "values": [
                    "right",
                    "right_start",
                    "right_end",
                    "bottom",
                    "bottom_start",
                    "bottom_end",
                    "left",
                    "left_start",
                    "left_end",
                    "top",
                    "top_start",
                    "top_end"
                ],
                "doc-description": "It can be used to give certain position to the Tooltip."
            },
            "open": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to progamtically open and close Tooltip."
            },
            "_platform": {
                "values": [
                    "mobile",
                    "desktop"
                ]
            }
        },
        "data": {
            "jds_tooltip_internal": {
                "label": {
                    "type": "string",
                    "name": "label",
                    "doc_description": "It displays label of Tooltip."
                },
                "triggerRef": {
                    "type": "ref",
                    "name": "triggerRef"
                },
                "width": {
                    "type": "size",
                    "name": "width"
                },
                "triggerSpacing": {
                    "type": "size",
                    "name": "triggerSpacing",
                    "function": true
                }
            },
            "popup-container": {
                "padding-left": {
                    "type": "size",
                    "name": "offsetX"
                },
                "padding-top": {
                    "type": "size",
                    "name": "offsetY"
                }
            }
        },
        "events": {
            "jds_tooltip_internal": {
                "onAppear": {
                    "name": "_onAppear",
                    "platform": "ios"
                },
                "onTextLayout": {
                    "name": "onTextLayout",
                    "platform": "android"
                }
            },
            "popup": {
                "onHover": {
                    "name": "onHover",
                    "platform": "web"
                }
            }
        },
        "a11y": {
            "jds_tooltip_internal": {
                "properties": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
function $fe5170bdd3625759$var$calculateOffsets(position, anchorRect, tooltipRect, gap) {
    let offsetX = "";
    let offsetY = "";
    const halfAnchorWidth = anchorRect.width / 2;
    const halfAnchorHeight = anchorRect.height / 2;
    const halfTooltipWidth = tooltipRect.width / 2;
    const halfTooltipHeight = tooltipRect.height / 2;
    const tipSize = 24;
    const tipSpace = 4;
    const verticalCenterX = anchorRect.left + halfAnchorWidth - halfTooltipWidth;
    const verticalEndX = anchorRect.right - tooltipRect.width - tipSpace;
    const verticalStartX = anchorRect.left + halfAnchorWidth - tipSize + tipSpace;
    const horizontalCenterY = anchorRect.top + halfAnchorHeight - halfTooltipHeight;
    const horizontalEndY = anchorRect.bottom - tooltipRect.height - tipSpace;
    const horizontalStartY = anchorRect.top + halfAnchorHeight - tipSize + tipSpace;
    const bottomY = anchorRect.bottom + gap;
    const topY = anchorRect.top - tooltipRect.height - gap;
    const leftX = anchorRect.left - tooltipRect.width - gap;
    const rightX = anchorRect.right + gap;
    switch(position){
        case "bottom":
            offsetX = `${verticalCenterX}px`;
            offsetY = `${bottomY}px`;
            break;
        case "bottom_end":
            offsetX = `${verticalEndX}px`;
            offsetY = `${bottomY}px`;
            break;
        case "bottom_start":
            offsetX = `${verticalStartX}px`;
            offsetY = `${bottomY}px`;
            break;
        case "top":
            offsetX = `${verticalCenterX}px`;
            offsetY = `${topY}px`;
            break;
        case "top_end":
            offsetX = `${verticalEndX}px`;
            offsetY = `${topY}px`;
            break;
        case "top_start":
            offsetX = `${verticalStartX}px`;
            offsetY = `${topY}px`;
            break;
        case "left":
            offsetX = `${leftX}px`;
            offsetY = `${horizontalCenterY}px`;
            break;
        case "left_end":
            offsetX = `${leftX}px`;
            offsetY = `${horizontalEndY}px`;
            break;
        case "left_start":
            offsetX = `${leftX}px`;
            offsetY = `${horizontalStartY}px`;
            break;
        case "right":
            offsetX = `${rightX}px`;
            offsetY = `${horizontalCenterY}px`;
            break;
        case "right_end":
            offsetX = `${rightX}px`;
            offsetY = `${horizontalEndY}px`;
            break;
        case "right_start":
            offsetX = `${rightX}px`;
            offsetY = `${horizontalStartY}px`;
            break;
    }
    return {
        offsetX: offsetX,
        offsetY: offsetY
    };
}
const $fe5170bdd3625759$var$SPACE_AVAILABILITY_ORDER = {
    bottom_start: [
        "top_start",
        "bottom",
        "bottom_end",
        "top",
        "top_end"
    ],
    bottom_end: [
        "top_end",
        "bottom",
        "bottom_start",
        "top",
        "top_start"
    ],
    top_start: [
        "bottom_start",
        "top",
        "top_end",
        "bottom",
        "bottom_end"
    ],
    top_end: [
        "bottom_end",
        "top",
        "top_start",
        "bottom",
        "bottom_start"
    ],
    right_end: [
        "left_end",
        "right",
        "right_start",
        "left",
        "left_start"
    ],
    right_start: [
        "left_start",
        "right",
        "right_end",
        "left",
        "left_end"
    ],
    left_end: [
        "right_end",
        "left",
        "left_start",
        "right",
        "right_start"
    ],
    left_start: [
        "right_start",
        "left",
        "left_end",
        "right",
        "right_end"
    ],
    top: [
        "bottom",
        "top_start",
        "top_end",
        "bottom_start",
        "bottom_end"
    ],
    bottom: [
        "top",
        "bottom_start",
        "bottom_end",
        "top_start",
        "top_end"
    ],
    left: [
        "right",
        "left_start",
        "left_end",
        "right_start",
        "right_end"
    ],
    right: [
        "left",
        "right_start",
        "right_end",
        "left_start",
        "left_end"
    ]
};
function $fe5170bdd3625759$var$isTooltipPositionFit(position, anchorRect, tooltipRect, gap) {
    const { offsetX: offsetX, offsetY: offsetY } = $fe5170bdd3625759$var$calculateOffsets(position, anchorRect, tooltipRect, gap);
    const positionX = parseInt(offsetX);
    const positionY = parseInt(offsetY);
    const { right: right, bottom: bottom } = tooltipRect;
    const { innerWidth: screenWidth, innerHeight: screenHeight } = window;
    switch(position){
        case "top":
            return positionY > 0 && positionX > 0 && right < screenWidth;
        case "top_start":
            return positionY > 0 && right < screenWidth;
        case "top_end":
            return positionY > 0 && positionX > 0;
        case "right_start":
            return bottom < screenHeight && right < screenWidth;
        case "right_end":
            return positionY > 0 && right < screenWidth;
        case "right":
            return positionY > 0 && bottom < screenHeight && right < screenWidth;
        case "bottom_start":
            return bottom < screenHeight && right < screenWidth;
        case "bottom_end":
            return bottom < screenHeight && positionX > 0;
        case "bottom":
            return bottom < screenHeight && positionX > 0 && right < screenWidth;
        case "left_start":
            return bottom < screenHeight && positionX > 0;
        case "left_end":
            return positionY > 0 && positionX > 0;
        case "left":
            return bottom < screenHeight && positionY > 0 && positionX > 0;
        default:
            return true;
    }
}
function $fe5170bdd3625759$var$getFlippedPosition(position, anchorRect, tooltipRect, gap) {
    if ($fe5170bdd3625759$var$isTooltipPositionFit(position, anchorRect, tooltipRect, gap)) return position;
    const alternativePosition = $fe5170bdd3625759$var$SPACE_AVAILABILITY_ORDER[position].find((alternativePosition2)=>{
        return $fe5170bdd3625759$var$isTooltipPositionFit(alternativePosition2, anchorRect, tooltipRect, gap);
    });
    return alternativePosition || position;
}
const $fe5170bdd3625759$var$LONG_PRESS_DELAY = 1e3;
const $fe5170bdd3625759$var$SUSTAIN_TIME = 3e3;
const $fe5170bdd3625759$var$getPosition = (anchor, tooltip, position = "right", TIP_OFFSET = $fe5170bdd3625759$var$Devices.isTablet() ? 20 : 8, isDesktop)=>{
    if (anchor && tooltip) {
        const anchorRect = anchor.getBoundingClientRect();
        const tooltipRect = tooltip.getBoundingClientRect();
        const resolvedOffset = typeof TIP_OFFSET === "string" ? parseInt(TIP_OFFSET.replace("px", "")) : TIP_OFFSET;
        const maxOffset = isDesktop ? 8 : 20;
        const clampedffset = (0, $8bd3c5c9ee0d1eb4$export$7d15b64cf5a3a4c4)(resolvedOffset, 0, maxOffset);
        const currentPosition = $fe5170bdd3625759$var$getFlippedPosition(position, anchorRect, tooltipRect, clampedffset);
        const { offsetX: offsetX, offsetY: offsetY } = $fe5170bdd3625759$var$calculateOffsets(currentPosition, anchorRect, tooltipRect, clampedffset);
        return {
            offsetX: offsetX.replace("px", ""),
            offsetY: offsetY.replace("px", ""),
            newPosition: currentPosition
        };
    }
    return {
        offsetX: 0,
        offsetY: 0
    };
};
const $fe5170bdd3625759$var$legacyTooltipPositions = [
    "right-start",
    "right-end",
    "bottom-start",
    "bottom-end",
    "left-start",
    "left-end",
    "top-start",
    "top-end"
];
const $fe5170bdd3625759$var$PROP_MAP$8 = (props)=>{
    if ($fe5170bdd3625759$var$legacyTooltipPositions.includes(props.position)) console.warn("these values for the position prop are deprecated", $fe5170bdd3625759$var$legacyTooltipPositions);
    return {
        position: {
            variations: {
                "right-start": {
                    position: "right_start"
                },
                "left-start": {
                    position: "left_start"
                },
                "bottom-start": {
                    position: "bottom_start"
                },
                "top-start": {
                    position: "top_start"
                },
                "left-end": {
                    position: "left_end"
                },
                "right-end": {
                    position: "right_end"
                },
                "top-end": {
                    position: "top_end"
                },
                "bottom-end": {
                    position: "bottom_end"
                },
                left: {
                    position: "left"
                },
                right: {
                    position: "right"
                },
                top: {
                    position: "top"
                },
                bottom: {
                    position: "bottom"
                }
            }
        }
    };
};
const $fe5170bdd3625759$var$withLogic$z = (Component)=>(userProps)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$8);
        const { children: children, ...rest } = props;
        const ref = (0, $acw62.useRef)(null);
        const { toggle: toggle, selected: selected, close: close } = $fe5170bdd3625759$var$useToggle(props.open);
        const [element, setElement] = (0, $acw62.useState)(null);
        const triggerRef = (0, $acw62.useCallback)((element2)=>{
            if (element2) setElement(element2);
        }, []);
        const { desktop: desktop } = $fe5170bdd3625759$var$Devices.useMedia();
        const { offsetX: offsetX, offsetY: offsetY, newPosition: newPosition } = $fe5170bdd3625759$var$getPosition(ref.current, element, rest.position, props.triggerSpacing, desktop);
        const timerRef = (0, $acw62.useRef)();
        const isTouchActive = (0, $acw62.useRef)(false);
        $fe5170bdd3625759$var$useScrollClose(close);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
                    ...{
                        ...rest,
                        offsetX: offsetX,
                        offsetY: offsetY,
                        _platform: $fe5170bdd3625759$var$getPlatform(),
                        width: "300px",
                        position: newPosition || props.position,
                        open: Boolean(selected),
                        triggerRef: triggerRef
                    }
                }),
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                    onMouseEnter: ()=>{
                        if (!(window && "ontouchstart" in window)) toggle();
                    },
                    onMouseLeave: close,
                    onTouchStart: ()=>{
                        if (window && "ontouchstart" in window && $fe5170bdd3625759$var$Devices.isMobile()) {
                            isTouchActive.current = true;
                            timerRef.current = setTimeout(toggle, $fe5170bdd3625759$var$LONG_PRESS_DELAY);
                        }
                    },
                    onTouchEnd: ()=>{
                        if ($fe5170bdd3625759$var$Devices.isMobile()) {
                            isTouchActive.current = false;
                            if (selected) setTimeout(close, $fe5170bdd3625759$var$SUSTAIN_TIME);
                            else if (timerRef.current) clearTimeout(timerRef.current);
                        }
                    },
                    ref: ref,
                    style: {
                        width: "fit-content"
                    },
                    children: children
                })
            ]
        });
    };
const $fe5170bdd3625759$var$Component$C = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$y;
    const { position: position = "right", open: open = false, onTextLayout: onTextLayout = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onHover: onHover = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            position: position,
            open: open,
            onTextLayout: onTextLayout,
            onHover: onHover,
            ...rest
        },
        componentTag: componentTag
    }, "JDSTooltip", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$28c660c63b792dea = $fe5170bdd3625759$var$withLogic$z($fe5170bdd3625759$var$Component$C);
$fe5170bdd3625759$export$28c660c63b792dea.displayName = "Tooltip";
$fe5170bdd3625759$export$28c660c63b792dea.slotName = "jds_tooltip";
const $fe5170bdd3625759$var$sdl$x = {
    "metadata": {
        "version": "1.0.0",
        "id": "tooltip-1.0.0",
        "name": "JDSTooltipInternal",
        "layerName": "jds_tooltip_internal",
        "description": "Tooltips are floating elements primarily used for accessibility as its function. It is used to display additional information about a user interface element or feature.",
        "usage": "The information included should be contextual, helpful, and nonessential while providing that extra ability to communicate and give clarity to a user.",
        "internal": true
    },
    "hierarchy": {
        "root-container": [
            "start-tooltip",
            {
                "text-container": [
                    "jds-text"
                ]
            },
            "end-tooltip"
        ]
    },
    "base": {
        "root-container": {
            "flex-direction": "{t_3}",
            "justify-content": "{t_4}",
            "align-items": "{t_5}",
            "overflow": "{tooltip_base_root-container-overflow}"
        },
        "text-container": {
            "border-radius": "{t_7}",
            "border-width": "{t_8}",
            "background-color": "{t_9}",
            "padding-left": "{t_12}",
            "padding-right": "{t_13}",
            "padding-top": "{t_14}",
            "padding-bottom": "{t_15}",
            "min-height": "{t_40}",
            "align-items": "{t_41}"
        },
        "start-tooltip": {
            "color": "{t_10}",
            "position": "right",
            "hidden": false
        },
        "end-tooltip": {
            "color": "{t_11}",
            "position": "right",
            "hidden": true
        },
        "jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryBackground}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "position": {
            "right_start": {
                "root-container": {
                    "align-items": "{t_16}"
                },
                "start-tooltip": {
                    "position": "right_start",
                    "padding-top": "{t_17}",
                    "hidden": false
                },
                "end-tooltip": {
                    "hidden": true
                }
            },
            "right_end": {
                "root-container": {
                    "align-items": "{t_18}"
                },
                "start-tooltip": {
                    "position": "right_end",
                    "padding-bottom": "{t_19}",
                    "hidden": false
                },
                "end-tooltip": {
                    "hidden": true
                }
            },
            "left": {
                "start-tooltip": {
                    "hidden": true
                },
                "end-tooltip": {
                    "position": "left",
                    "hidden": false
                }
            },
            "left_start": {
                "root-container": {
                    "align-items": "{t_20}"
                },
                "start-tooltip": {
                    "hidden": true
                },
                "end-tooltip": {
                    "position": "left_start",
                    "padding-top": "{t_21}",
                    "hidden": false
                }
            },
            "left_end": {
                "root-container": {
                    "align-items": "{t_22}"
                },
                "start-tooltip": {
                    "hidden": true
                },
                "end-tooltip": {
                    "position": "left_end",
                    "padding-bottom": "{t_23}",
                    "hidden": false
                }
            },
            "top": {
                "root-container": {
                    "flex-direction": "{t_24}",
                    "align-items": "{t_25}"
                },
                "start-tooltip": {
                    "hidden": true
                },
                "end-tooltip": {
                    "position": "top",
                    "hidden": false
                }
            },
            "top_start": {
                "root-container": {
                    "flex-direction": "{t_26}",
                    "align-items": "{t_27}"
                },
                "start-tooltip": {
                    "hidden": true
                },
                "end-tooltip": {
                    "position": "top_start",
                    "padding-left": "{t_28}",
                    "hidden": false
                }
            },
            "top_end": {
                "root-container": {
                    "flex-direction": "{t_29}",
                    "align-items": "{t_30}"
                },
                "start-tooltip": {
                    "hidden": true
                },
                "end-tooltip": {
                    "position": "top_end",
                    "padding-right": "{t_31}",
                    "hidden": false
                }
            },
            "bottom": {
                "root-container": {
                    "flex-direction": "{t_32}",
                    "align-items": "{t_33}"
                },
                "start-tooltip": {
                    "position": "bottom",
                    "hidden": false
                },
                "end-tooltip": {
                    "hidden": true
                }
            },
            "bottom_start": {
                "root-container": {
                    "flex-direction": "{t_34}",
                    "align-items": "{t_35}"
                },
                "start-tooltip": {
                    "padding-left": "{t_36}",
                    "position": "bottom_start",
                    "hidden": false
                },
                "end-tooltip": {
                    "hidden": true
                }
            },
            "bottom_end": {
                "root-container": {
                    "flex-direction": "{t_37}",
                    "align-items": "{t_38}"
                },
                "start-tooltip": {
                    "position": "bottom_end",
                    "padding-right": "{t_39}",
                    "hidden": false
                },
                "end-tooltip": {
                    "hidden": true
                }
            }
        },
        "_platform": {
            "desktop": {
                "jds-text": {
                    "font-family": "{bodyXxs}",
                    "font-size": "{bodyXxs}",
                    "line-height": "{bodyXxs}",
                    "letter-spacing": "{bodyXxs}",
                    "font-weight": "{bodyXxs}"
                }
            }
        }
    },
    "api": {
        "config": {
            "position": {
                "values": [
                    "right",
                    "right_start",
                    "right_end",
                    "bottom",
                    "bottom_start",
                    "bottom_end",
                    "left",
                    "left_start",
                    "left_end",
                    "top",
                    "top_start",
                    "top_end"
                ],
                "doc-description": "It can be used to give certain position to the Tooltip."
            },
            "_platform": {
                "values": [
                    "mobile",
                    "desktop"
                ]
            }
        },
        "data": {
            "root-container": {
                "elementRef": {
                    "type": "ref",
                    "name": "triggerRef"
                },
                "max-width": {
                    "type": "size",
                    "name": "width"
                },
                "spacing": {
                    "type": "size",
                    "name": "triggerSpacing",
                    "function": true
                }
            },
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "label",
                    "doc_description": "It displays label of Tooltip."
                }
            }
        },
        "events": {
            "root-container": {
                "onAppear": {
                    "name": "onAppear",
                    "platform": "ios"
                }
            },
            "jds-text": {
                "onTextLayout": {
                    "name": "onTextLayout",
                    "platform": "android"
                }
            }
        },
        "a11y": {
            "root-container": {
                "properties": {
                    "role": {
                        "value": "tooltip"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$y = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$B = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$x;
    const { position: position = "right", onAppear: onAppear = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onTextLayout: onTextLayout = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), ariaLabel: ariaLabel = props.label?.toString(), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            position: position,
            onAppear: onAppear,
            onTextLayout: onTextLayout,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSTooltipInternal", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$d8d56a9a74e44761 = $fe5170bdd3625759$var$withLogic$y($fe5170bdd3625759$var$Component$B);
$fe5170bdd3625759$export$d8d56a9a74e44761.displayName = "TooltipInternal";
$fe5170bdd3625759$export$d8d56a9a74e44761.slotName = "jds_tooltip_internal";
const $fe5170bdd3625759$var$sdl$w = {
    "metadata": {
        "version": "1.0.0",
        "id": "stepper-vertical-step-item-1.0.0",
        "name": "JDSVerticalStepItem",
        "layerName": "jds_vertical_step_item",
        "internal": true
    },
    "hierarchy": {
        "stepper-outer-container": [
            {
                "step-dot-container": [
                    "jds_stepper_dot",
                    "label-jds-text"
                ]
            },
            {
                "step-indicator-container": [
                    "end-jds_divider",
                    {
                        "content-container": [
                            {
                                "content-child-container": [
                                    "content-slot"
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    "base": {
        "stepper-outer-container": {
            "flex-direction": "{v_0}",
            "justify-content": "{v_1}",
            "align-items": "{v_2}",
            "gap": "{v_3}",
            "size": "{v_4}"
        },
        "end-container": {
            "hidden": false,
            "flex": 1,
            "opacity": "{v_5}"
        },
        "content-child-container": {
            "flex-direction": "{v_6}",
            "justify-content": "{v_7}",
            "align-items": "{v_8}",
            "hidden": false
        },
        "end-jds_divider": {
            "pad": "none",
            "withLabel": false,
            "orientation": "vertical"
        },
        "step-indicator-container": {
            "height": "{v_9}",
            "flex-direction": "{v_10}",
            "justify-content": "{v_11}",
            "align-items": "{v_12}",
            "padding-left": 15,
            "min-height": "{v_13}"
        },
        "step-dot-container": {
            "flex-direction": "{v_15}",
            "justify-content": "{v_16}",
            "align-items": "{v_17}",
            "gap": "{v_18}"
        },
        "content-container": {
            "padding-top": "{v_19}",
            "padding-left": 31,
            "padding-bottom": "{v_20}",
            "enter-animation-name": "slideVerticallyDown",
            "exit-animation-name": "slideVerticallyUp",
            "enter-animation-curve": "entrance_ease",
            "exit-animation-curve": "exit_ease",
            "enter-animation-duration": 500,
            "exit-animation-duration": 500,
            "hidden": true,
            "overflow": "hidden",
            "transition": {
                "property": [
                    "max-height",
                    "padding-top",
                    "padding-bottom"
                ],
                "duration": "{medium}",
                "timing-function": "{easeExit}"
            }
        },
        "label-jds-text": {
            "font-family": "{headingXxs}",
            "color": "{primaryGrey100}",
            "font-size": "{headingXxs}",
            "line-height": "{headingXxs}",
            "letter-spacing": "{headingXxs}",
            "font-weight": "{headingXxs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "language": "en",
            "padding-top": 0
        }
    },
    "variant": {
        "_hideChild": {
            "true": {
                "content-container": {
                    "hidden": false,
                    "padding-top": "{verticalstepitem_variant__hideChild_true_content-container_padding-top}",
                    "padding-bottom": "{verticalstepitem_variant__hideChild_true_content-container_padding-bottom}",
                    "transition": {
                        "timing-function": "{easeEntrance}"
                    }
                }
            }
        },
        "state": {
            "complete": {
                "end-jds_divider": {
                    "variant": "stepper"
                }
            },
            "disabled": {
                "stepper-outer-container": {
                    "disabled": true
                },
                "jds_stepper_dot": {
                    "state": "disabled"
                }
            }
        },
        "direction": {
            "start": {
                "end-jds_divider": {
                    "opacity": "{v_24}"
                }
            }
        }
    },
    "api": {
        "children": {
            "content-slot": {
                "name": "content",
                "accepts": [
                    "template"
                ],
                "max": 1
            }
        },
        "config": {
            "state": {
                "type": "JDSStepperDot.state",
                "values": [
                    "inactive",
                    "active",
                    "complete",
                    "disabled"
                ]
            },
            "direction": {
                "values": [
                    "both",
                    "start",
                    "end"
                ]
            },
            "_hideChild": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "jds_stepper_dot": {
                "index": {
                    "type": "string",
                    "name": "index"
                },
                "icon": {
                    "type": "icon",
                    "name": "icon"
                },
                "state": {
                    "type": "JDSStepperDot.state",
                    "name": "state"
                },
                "itemsType": {
                    "type": "JDSStepperDot.itemsType",
                    "name": "itemsType"
                },
                "activeState": {
                    "type": "JDSStepperDot.activeState",
                    "name": "activeState"
                }
            },
            "content-container": {
                "max-height": {
                    "name": "_contentHeight",
                    "type": "size"
                }
            },
            "label-jds-text": {
                "value": {
                    "name": "label",
                    "type": "string"
                }
            }
        },
        "a11y": {
            "stepper-outer-container": {
                "properties": {
                    "role": {
                        "value": "listitem"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-current": {
                        "name": "ariaCurrent"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$x = (Component)=>(props)=>{
        const active = props.state === "active";
        const { element: element, rootRef: rootRef } = $fe5170bdd3625759$var$useRootRef();
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                rootRef: rootRef,
                _hideChild: active,
                _contentHeight: active ? element?.querySelector('div[data-testid="JDSVerticalStepItem-content-container"]')?.scrollHeight : 0
            }
        });
    };
const $fe5170bdd3625759$var$Component$A = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$w;
    const { state: state = "undefined", direction: direction = "both", ariaLabel: ariaLabel = props.label?.toString(), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            state: state,
            direction: direction,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSVerticalStepItem", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$c4bee818be0dfd5a = $fe5170bdd3625759$var$withLogic$x($fe5170bdd3625759$var$Component$A);
$fe5170bdd3625759$export$c4bee818be0dfd5a.displayName = "VerticalStepItem";
$fe5170bdd3625759$export$c4bee818be0dfd5a.slotName = "jds_vertical_step_item";
const $fe5170bdd3625759$var$v1Map = {
    jds_text: ()=>$fe5170bdd3625759$export$5f1af8db9871e1d6,
    jds_tag: ()=>$fe5170bdd3625759$export$3288d34c523a1192,
    jds_icon: ()=>$fe5170bdd3625759$export$f04a61298a47a40f,
    jds_skeleton: ()=>$fe5170bdd3625759$export$8f31e4c4a37b8e9c,
    jds_badge: ()=>$fe5170bdd3625759$export$37acb3580601e69a,
    jds_toast: ()=>$fe5170bdd3625759$var$Toast,
    jds_nudge: ()=>$fe5170bdd3625759$var$Nudge,
    jds_fab: ()=>$fe5170bdd3625759$export$72beae6a392d0fc6,
    jds_fab_internal: ()=>$fe5170bdd3625759$export$f3670f01e3026458,
    jds_selector_item: ()=>$fe5170bdd3625759$export$ec8540225d9cc6a2,
    jds_table_cell: ()=>$fe5170bdd3625759$export$1e4baea7053fc0e3,
    jds_table_row: ()=>$fe5170bdd3625759$export$b05581f4e764e162,
    jds_table_body: ()=>$fe5170bdd3625759$export$76ccd210b9029917,
    jds_selector_button: ()=>$fe5170bdd3625759$export$880a7f9ee0ea89e0,
    jds_menu_block_item: ()=>$fe5170bdd3625759$export$3789e0cd450be8da,
    jds_notification_button: ()=>$fe5170bdd3625759$var$NotificationButton,
    jds_action_button: ()=>$fe5170bdd3625759$export$cfc7921d29ef7b80,
    jds_tab_item: ()=>$fe5170bdd3625759$export$17043b9d35150718,
    jds_feedback_block: ()=>$fe5170bdd3625759$var$FeedbackBlock,
    jds_link: ()=>$fe5170bdd3625759$export$a6c7ac8248d6e38a,
    jds_bottom_footer_link_item: ()=>$fe5170bdd3625759$export$b592413d575db486,
    jds_bottom_sheet: ()=>$fe5170bdd3625759$export$2058ef1a26004a97,
    jds_desktop_bottom_sheet_internal: ()=>$fe5170bdd3625759$export$a20173db319b8774,
    jds_mobile_bottom_sheet_internal: ()=>$fe5170bdd3625759$export$9ac5eac5233c654,
    jds_divider: ()=>$fe5170bdd3625759$export$2e0a83ec2e27ecbb,
    jds_image: ()=>$fe5170bdd3625759$export$3e431a229df88919,
    jds_footer_links: ()=>$fe5170bdd3625759$export$553910ef0cc96026,
    jds_footer_icon_links: ()=>$fe5170bdd3625759$export$ce48424ab2a5a45,
    jds_footer_market_links: ()=>$fe5170bdd3625759$export$4e70d4e1c9ec4c90,
    jds_footer_links_grid: ()=>$fe5170bdd3625759$export$e5275d44ac937bc0,
    jds_bottom_footer: ()=>$fe5170bdd3625759$export$72ab4ebd04fea6e2,
    jds_content_block: ()=>$fe5170bdd3625759$export$eb38b3b9c7f5f31b,
    jds_search_result_item: ()=>$fe5170bdd3625759$export$56e008c8bd1ccf7c,
    jds_search_results_internal: ()=>$fe5170bdd3625759$export$49b46bbe543bdb4b,
    jds_avatar: ()=>$fe5170bdd3625759$export$e2255cf6045e8d47,
    jds_segmented_ring_item: ()=>$fe5170bdd3625759$export$28d80c087760154d,
    jds_avatar_v2: ()=>$fe5170bdd3625759$export$ac4313c0728f5b84,
    jds_avatar_v2_segmented_ring: ()=>$fe5170bdd3625759$export$9b02a99b26bc2fb,
    jds_avatar_v2_progress_ring: ()=>$fe5170bdd3625759$export$add0715ef3cff303,
    jds_avatar_v2_complete_ring: ()=>$fe5170bdd3625759$export$70f728d68d57ace9,
    jds_avatar_v2_default: ()=>$fe5170bdd3625759$export$4860988e9a471058,
    jds_avatar_v2_information: ()=>$fe5170bdd3625759$export$dbc79143cb6c67cb,
    jds_avatar_v2_status: ()=>$fe5170bdd3625759$export$6c44d71f4e8d3278,
    jds_avatar_v2_notification: ()=>$fe5170bdd3625759$export$c906bb7932dd69e9,
    jds_button: ()=>$fe5170bdd3625759$export$353f5b6fc5456de1,
    jds_accordion: ()=>$fe5170bdd3625759$export$7cad6f17fd6e117b,
    jds_mega_menu_item: ()=>$fe5170bdd3625759$export$cc2d7d7492914f14,
    jds_mega_menu_block: ()=>$fe5170bdd3625759$export$5e96c1cbae381c93,
    jds_search_box: ()=>$fe5170bdd3625759$export$5a58787633b0b5d8,
    jds_modal_desktop_internal: ()=>$fe5170bdd3625759$export$3e0ada2dd34546e6,
    jds_modal_mobile_internal: ()=>$fe5170bdd3625759$export$e70e9b240ff3bbbf,
    jds_modal_desktop: ()=>$fe5170bdd3625759$export$2b77a92f1a5ad772,
    jds_side_panel_item: ()=>$fe5170bdd3625759$export$500ae19c14a3c46,
    jds_side_panel_internal: ()=>$fe5170bdd3625759$export$8b5d5577a4deadf6,
    jds_header: ()=>$fe5170bdd3625759$export$8b251419efc915eb,
    jds_mega_menu: ()=>$fe5170bdd3625759$export$aee42d298194d478,
    jds_bottom_navigation_item: ()=>$fe5170bdd3625759$export$f5e7567009f715b2,
    jds_bottom_navigation2: ()=>BottomNavigation2,
    jds_carousel_pagination_item: ()=>$fe5170bdd3625759$var$CarouselPaginationItem,
    jds_carousel_pagination: ()=>$fe5170bdd3625759$var$CarouselPagination,
    jds_carousel_slide: ()=>$fe5170bdd3625759$export$cabb5ccfbd60cbd4,
    jds_datepicker_button: ()=>$fe5170bdd3625759$export$395dd20d84297b30,
    jds_datepicker_calendar_button: ()=>$fe5170bdd3625759$export$2d81f864fd880f98,
    jds_datepicker_view_button: ()=>$fe5170bdd3625759$export$99c3540c4320b145,
    jds_datepicker_calendar_row: ()=>$fe5170bdd3625759$export$703dfd9521d4b08a,
    jds_datepicker_calendar: ()=>$fe5170bdd3625759$export$cfdbf347b14a0a8d,
    jds_datepicker_year_view: ()=>$fe5170bdd3625759$export$59892f17b1991230,
    jds_datepicker_calendar_header: ()=>$fe5170bdd3625759$export$2d5e85746b19c19b,
    jds_datepicker_header: ()=>$fe5170bdd3625759$export$4677d90cce08ec53,
    jds_datepicker_month_view: ()=>$fe5170bdd3625759$export$df8c284ffe0bf6ce,
    jds_dropdown_menu_item: ()=>$fe5170bdd3625759$export$ed97964d1871885d,
    jds_dropdown_menu_group: ()=>$fe5170bdd3625759$export$246bebaba3a2f70e,
    jds_dropdown_menu: ()=>$fe5170bdd3625759$export$e44a253a59704894,
    jds_dropdown_menu_submenu: ()=>$fe5170bdd3625759$export$51cd9091d2dcc10a,
    jds_dropdown_menu_sub_menu_internal: ()=>$fe5170bdd3625759$export$897b7938c608ac58,
    jds_dropdown_menu_internal: ()=>$fe5170bdd3625759$export$5a9d97cdadce1b72,
    jds_pagination_button: ()=>$fe5170bdd3625759$export$c3639e97caabff2c,
    jds_datepicker: ()=>$fe5170bdd3625759$export$5109c6dd95d8fb00,
    jds_datepicker_desktop_internal: ()=>$fe5170bdd3625759$export$1f2289af8fea154d,
    jds_datepicker_mobile_internal: ()=>$fe5170bdd3625759$export$1f2289af8fea154d,
    jds_menu_block: ()=>$fe5170bdd3625759$export$3a7690908a5e9b5,
    jds_menu_block_internal: ()=>$fe5170bdd3625759$export$f9b98c24bc73aa75,
    jds_list_block: ()=>$fe5170bdd3625759$export$7c8f337671b808e4,
    jds_input: ()=>$fe5170bdd3625759$var$Input,
    jds_input_code_item: ()=>$fe5170bdd3625759$export$963da1aad44be4c4,
    jds_tab_bar: ()=>$fe5170bdd3625759$export$f97dc4a5a0177256,
    jds_search_results: ()=>$fe5170bdd3625759$export$aee53da69e9839be,
    jds_search_result_text: ()=>$fe5170bdd3625759$export$2a7e910d17016306,
    jds_stepper_dot: ()=>$fe5170bdd3625759$export$435f28d5690c41ca,
    jds_step_item_vertical: ()=>$fe5170bdd3625759$export$c4bee818be0dfd5a,
    jds_step_item_horizontal: ()=>$fe5170bdd3625759$export$210661c11db5ef0f,
    jds_spinner: ()=>$fe5170bdd3625759$export$7f7cbe89f1eacd2,
    jds_tooltip: ()=>$fe5170bdd3625759$export$28c660c63b792dea,
    jds_tooltip_internal: ()=>$fe5170bdd3625759$export$d8d56a9a74e44761,
    jds_checkbox: ()=>$fe5170bdd3625759$export$fa1253a65a9e747d,
    swadesh_checkbox: ()=>$fe5170bdd3625759$export$fa1253a65a9e747d,
    swadesh_text: ()=>$fe5170bdd3625759$export$5f1af8db9871e1d6,
    jds_rating_bar_item: ()=>$fe5170bdd3625759$export$b473c78e8d3557fd,
    jds_file_uploader_control: ()=>$fe5170bdd3625759$export$2548bc68b9cf13da,
    jds_file_uploader_panel: ()=>$fe5170bdd3625759$export$4089cd2315da078,
    jds_file_uploader_item: ()=>$fe5170bdd3625759$export$b41bb47bfc36c3b4,
    jds_file_uploader_list: ()=>$fe5170bdd3625759$export$3d00ed40fd09f854,
    jds_progress_bar: ()=>$fe5170bdd3625759$export$c17561cb55d4db30,
    jds_input_phone_dropdown: ()=>$fe5170bdd3625759$export$770f20817cf88abc,
    jds_badge_v2: ()=>$fe5170bdd3625759$export$561b3597d6384588,
    jds_badge_v2_status: ()=>$fe5170bdd3625759$export$87daca618cc26b9,
    jds_badge_v2_information: ()=>$fe5170bdd3625759$export$50fcc0de7334f647,
    jds_badge_v2_notification: ()=>$fe5170bdd3625759$export$5217f316f51857f9,
    jds_badge_v2_brand: ()=>$fe5170bdd3625759$export$3b623c6160d8d9d1,
    jds_tabs_desktop: ()=>$fe5170bdd3625759$export$b2539bed5023c21c,
    jds_megamenu_internal: ()=>$fe5170bdd3625759$export$d7717d03c9caf572
};
const $fe5170bdd3625759$var$componentsMap = {
    ...$fe5170bdd3625759$var$v1Map
};
const $fe5170bdd3625759$var$Component$z = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$2c;
    const { size: size = "medium", color: color = "primary_50", kind: kind = "default", onClick: onClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            size: size,
            color: color,
            kind: kind,
            onClick: onClick,
            ...rest
        },
        componentTag: componentTag
    }, "JDSIcon", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$f04a61298a47a40f = $fe5170bdd3625759$var$withLogic$2e($fe5170bdd3625759$var$Component$z);
$fe5170bdd3625759$export$f04a61298a47a40f.displayName = "Icon";
$fe5170bdd3625759$export$f04a61298a47a40f.slotName = "jds_icon";
const $fe5170bdd3625759$var$_NotificationService = class {
    constructor(args){
        $fe5170bdd3625759$var$_NotificationService.args = args;
    }
};
let $fe5170bdd3625759$var$NotificationService = $fe5170bdd3625759$var$_NotificationService;
$fe5170bdd3625759$var$NotificationService.eventName = "notification";
const $fe5170bdd3625759$var$_NotificationCloseService = class {
    constructor(args){
        $fe5170bdd3625759$var$_NotificationCloseService.args = args;
    }
};
let $fe5170bdd3625759$var$NotificationCloseService = $fe5170bdd3625759$var$_NotificationCloseService;
$fe5170bdd3625759$var$NotificationCloseService.eventName = "close-notifications";
const $fe5170bdd3625759$var$_NotificationController = class {
    static updateNotifications(type) {
        if (type === "nudge") {
            $fe5170bdd3625759$var$publish(new $fe5170bdd3625759$var$NotificationService({
                type: type,
                notifications: [
                    ...$fe5170bdd3625759$var$_NotificationController.nudges
                ]
            }));
            return;
        }
        $fe5170bdd3625759$var$publish(new $fe5170bdd3625759$var$NotificationService({
            type: type,
            notifications: [
                ...$fe5170bdd3625759$var$_NotificationController.toasts
            ]
        }));
    }
    static createID(type) {
        const id = /* @__PURE__ */ new Date().getTime() + Math.random().toString();
        return this.getNotificationIndex(type, id) < 0 ? id : this.createID(type);
    }
    static getNotificationIndex(type, id) {
        if (type === "nudge") return $fe5170bdd3625759$var$_NotificationController.nudges.findIndex((item)=>item.id === id);
        return $fe5170bdd3625759$var$_NotificationController.toasts.findIndex((item)=>item.id === id);
    }
    static getNotification(id, type) {
        const index = $fe5170bdd3625759$var$_NotificationController.getNotificationIndex(type, id);
        if (this.isActive(id, type) && index >= 0) {
            if (type === "nudge") return $fe5170bdd3625759$var$_NotificationController.nudges[index];
            return $fe5170bdd3625759$var$_NotificationController.toasts[index];
        }
    }
    static nudge(props) {
        if (!props.title) {
            console.warn("Notification: [Nudge] cannot be created as title was not provided");
            return "";
        }
        const index = this.getNotificationIndex("nudge", props.id);
        let ID = props.id;
        if (index < 0) {
            ID = props.id || this.createID("nudge");
            if (!$fe5170bdd3625759$var$_NotificationController.isActive(ID, "nudge")) {
                const nudgeItem = {
                    showClose: true,
                    ...props,
                    id: ID
                };
                $fe5170bdd3625759$var$_NotificationController.nudges.push(nudgeItem);
                this.updateNotifications("nudge");
            }
            return ID;
        }
        return ID;
    }
    static toast(props) {
        if (!props.title) {
            console.warn("Notification: [Toast] cannot be created as title was not provided");
            return "";
        }
        const index = this.getNotificationIndex("toast", props.id);
        let ID = props.id;
        if (index < 0) {
            ID = props.id || this.createID("toast");
            if (!$fe5170bdd3625759$var$_NotificationController.isActive(ID, "toast")) {
                const toastItem = {
                    showClose: true,
                    ...props,
                    id: ID
                };
                $fe5170bdd3625759$var$_NotificationController.toasts.push(toastItem);
                this.updateNotifications("toast");
            }
            return ID;
        }
        return ID;
    }
    static dismiss(id, type) {
        if (this.isActive(id, type)) {
            $fe5170bdd3625759$var$publish(new $fe5170bdd3625759$var$NotificationCloseService({
                [id]: type
            }));
            setTimeout(()=>{
                if (type === "nudge") {
                    const newNudgeList = $fe5170bdd3625759$var$_NotificationController.nudges.filter((item)=>item.id !== id);
                    $fe5170bdd3625759$var$_NotificationController.nudges = newNudgeList;
                } else {
                    const newToastList = $fe5170bdd3625759$var$_NotificationController.toasts.filter((item)=>item.id !== id);
                    $fe5170bdd3625759$var$_NotificationController.toasts = newToastList;
                }
                this.updateNotifications(type);
            }, 500);
        }
        return id;
    }
    static update(id, type, props) {
        const notificationIndex = this.getNotificationIndex(type, id);
        if (notificationIndex >= 0) {
            if (this.isActive(id, type)) {
                if (type === "nudge") {
                    const currentNudge = $fe5170bdd3625759$var$_NotificationController.nudges.findIndex((nudge2)=>nudge2.id === id);
                    const updatedNudgeItem = {
                        ...$fe5170bdd3625759$var$_NotificationController.nudges[currentNudge],
                        ...props
                    };
                    $fe5170bdd3625759$var$_NotificationController.nudges[currentNudge] = updatedNudgeItem;
                } else {
                    const currentToast = $fe5170bdd3625759$var$_NotificationController.toasts.findIndex((toast2)=>toast2.id === id);
                    const updatedToastItem = {
                        ...$fe5170bdd3625759$var$_NotificationController.toasts[currentToast],
                        ...props
                    };
                    $fe5170bdd3625759$var$_NotificationController.toasts[currentToast] = updatedToastItem;
                }
                this.updateNotifications(type);
            }
        }
    }
    static isActive(id, type) {
        const exists = type === "nudge" ? $fe5170bdd3625759$var$_NotificationController.nudges.findIndex((nudgeItem)=>nudgeItem.id === id) >= 0 : $fe5170bdd3625759$var$_NotificationController.toasts.findIndex((toastItem)=>toastItem.id === id) >= 0;
        return exists;
    }
    static dismissAll(type) {
        const activeIds = {};
        $fe5170bdd3625759$var$_NotificationController.nudges.forEach((noti)=>{
            if (noti.id) activeIds[noti.id] = "nudge";
        });
        $fe5170bdd3625759$var$_NotificationController.toasts.forEach((noti)=>{
            if (noti.id) activeIds[noti.id] = "toast";
        });
        $fe5170bdd3625759$var$publish(new $fe5170bdd3625759$var$NotificationCloseService(activeIds));
        setTimeout(()=>{
            if (type === "nudge") $fe5170bdd3625759$var$_NotificationController.nudges = [];
            else $fe5170bdd3625759$var$_NotificationController.toasts = [];
            this.updateNotifications(type);
        }, 500);
    }
};
let $fe5170bdd3625759$var$NotificationController = $fe5170bdd3625759$var$_NotificationController;
$fe5170bdd3625759$var$NotificationController.nudges = [];
$fe5170bdd3625759$var$NotificationController.toasts = [];
const $fe5170bdd3625759$var$createProps = (props)=>typeof props === "string" ? {
        title: props
    } : props;
const $fe5170bdd3625759$var$nudge = (props)=>$fe5170bdd3625759$var$NotificationController.nudge($fe5170bdd3625759$var$createProps(props));
$fe5170bdd3625759$var$nudge.update = (id, props)=>$fe5170bdd3625759$var$NotificationController.update(id, "nudge", $fe5170bdd3625759$var$createProps(props));
$fe5170bdd3625759$var$nudge.dismiss = (id)=>$fe5170bdd3625759$var$NotificationController.dismiss(id, "nudge");
$fe5170bdd3625759$var$nudge.dismissAll = ()=>$fe5170bdd3625759$var$NotificationController.dismissAll("nudge");
$fe5170bdd3625759$var$nudge.isActive = (id)=>$fe5170bdd3625759$var$NotificationController.isActive(id, "nudge");
$fe5170bdd3625759$var$nudge.get = (id)=>$fe5170bdd3625759$var$NotificationController.getNotification(id, "nudge");
const $fe5170bdd3625759$var$toast = (props)=>$fe5170bdd3625759$var$NotificationController.toast($fe5170bdd3625759$var$createProps(props));
$fe5170bdd3625759$var$toast.update = (id, props)=>$fe5170bdd3625759$var$NotificationController.update(id, "toast", $fe5170bdd3625759$var$createProps(props));
$fe5170bdd3625759$var$toast.dismissAll = ()=>$fe5170bdd3625759$var$NotificationController.dismissAll("toast");
$fe5170bdd3625759$var$toast.dismiss = (id)=>$fe5170bdd3625759$var$NotificationController.dismiss(id, "toast");
$fe5170bdd3625759$var$toast.info = (props)=>$fe5170bdd3625759$var$NotificationController.toast({
        ...$fe5170bdd3625759$var$createProps(props),
        icon: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$f04a61298a47a40f, {
            ic: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f2a56b92690f077c$export$556fe0871d9b7899), {}),
            size: "l"
        })
    });
$fe5170bdd3625759$var$toast.error = (props)=>$fe5170bdd3625759$var$NotificationController.toast({
        ...$fe5170bdd3625759$var$createProps(props),
        icon: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$f04a61298a47a40f, {
            ic: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $87c0f97f25197d00$export$ed1619aa732c6643), {}),
            size: "l"
        })
    });
$fe5170bdd3625759$var$toast.success = (props)=>$fe5170bdd3625759$var$NotificationController.toast({
        ...$fe5170bdd3625759$var$createProps(props),
        icon: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$f04a61298a47a40f, {
            ic: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $dd949b1a0491130c$export$50c1b72d39add9), {}),
            size: "l"
        })
    });
$fe5170bdd3625759$var$toast.warning = (props)=>$fe5170bdd3625759$var$NotificationController.toast({
        ...$fe5170bdd3625759$var$createProps(props),
        icon: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$f04a61298a47a40f, {
            ic: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7dab575aad091c08$export$47407925ae9f1f0e), {}),
            size: "l"
        })
    });
$fe5170bdd3625759$var$toast.isActive = (id)=>$fe5170bdd3625759$var$NotificationController.isActive(id, "toast");
$fe5170bdd3625759$var$toast.get = (id)=>$fe5170bdd3625759$var$NotificationController.getNotification(id, "toast");
const $fe5170bdd3625759$var$sdl$v = {
    "metadata": {
        "version": "1.0.0",
        "id": "notification-banner-1.0.0",
        "name": "JDSNotificationBanner",
        "layerName": "jds_notification_banner"
    },
    "hierarchy": {
        "root-container": [
            {
                "main-container": [
                    {
                        "jds-icon-container": [
                            "jds-icon"
                        ]
                    },
                    {
                        "text-container": [
                            "heading-jds-text",
                            "support-jds-text"
                        ]
                    },
                    {
                        "button-container": [
                            "cta-jds_button",
                            "close-jds_button"
                        ]
                    }
                ]
            },
            {
                "bottom-container": [
                    "bottom-cta-jds_button"
                ]
            }
        ]
    },
    "base": {
        "root-container": {
            "hidden": false,
            "min-height": "{n_0}",
            "width": "{n_1}",
            "flex-direction": "{n_2}",
            "justify-content": "{n_3}",
            "align-items": "{n_4}",
            "padding-top": "{n_5}",
            "padding-right": "{n_6}",
            "padding-bottom": "{n_7}",
            "padding-left": "{n_8}",
            "gap": "{n_9}",
            "border-radius": "{n_10}",
            "background-color": "{n_11}",
            "enter-animation-name": "slideVerticallyDown",
            "exit-animation-name": "slideVerticallyUp",
            "enter-animation-curve": "entrance_ease",
            "exit-animation-curve": "exit_ease",
            "enter-animation-duration": 500,
            "exit-animation-duration": 500,
            "translate-y": 0,
            "transition": {
                "property": [
                    "translate-y"
                ],
                "duration": "{medium}",
                "timing-function": "{easeJoyfulEntrance}"
            }
        },
        "main-container": {
            "flex-direction": "{n_12}",
            "justify-content": "{n_13}",
            "align-items": "{n_14}",
            "width": "{n_15}",
            "gap": "{n_16}"
        },
        "text-container": {
            "flex": 1,
            "justify-content": "{n_17}",
            "align-items": "{n_18}",
            "flex-direction": "{n_19}",
            "gap": "{n_20}"
        },
        "button-container": {
            "flex-direction": "{n_21}",
            "gap": "{n_22}"
        },
        "cta-jds_button": {
            "hidden": false,
            "size": "small",
            "kind": "secondary"
        },
        "close-jds_button": {
            "size": "small",
            "kind": "tertiary",
            "icon": "ic_close"
        },
        "bottom-container": {
            "hidden": true,
            "flex-direction": "{n_24}",
            "justify-content": "{n_25}",
            "align-items": "{n_26}",
            "width": "{n_23}"
        },
        "bottom-cta-jds_button": {
            "size": "small",
            "kind": "secondary"
        },
        "jds-icon": {
            "size": "{l}",
            "color": "{primary50}"
        },
        "jds-icon-container": {
            "background-color": "{global.transparent}",
            "border-radius": "{pill}",
            "size": "{l}",
            "justify-content": "{justifyContent.center}",
            "align-items": "{alignItems.center}"
        },
        "heading-jds-text": {
            "font-family": "{bodySBold}",
            "color": "{primaryGrey100}",
            "font-size": "{bodySBold}",
            "line-height": "{bodySBold}",
            "letter-spacing": "{bodySBold}",
            "font-weight": "{bodySBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 1,
            "maxLines": 1
        },
        "support-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 4,
            "maxLines": 4
        }
    },
    "variant": {
        "ctaPosition": {
            "bottom": {
                "cta-jds_button": {
                    "hidden": true
                },
                "bottom-container": {
                    "hidden": false
                }
            }
        },
        "open": {
            "false": {
                "root-container": {
                    "hidden": true,
                    "translate-y": "{size.negativeMax}",
                    "transition": {
                        "timing-function": "{easeJoyfulExit}"
                    }
                }
            }
        },
        "_showClose": {
            "false": {
                "close-jds_button": {
                    "hidden": true
                }
            }
        },
        "_hasDescription": {
            "false": {
                "main-container": {
                    "align-items": "{n_27}"
                },
                "support-jds-text": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {
            "true": {
                "desktop": {
                    "root-container": {
                        "padding-left": "{n_28}",
                        "padding-right": "{n_29}",
                        "border-radius": 0
                    }
                },
                "mobile": {
                    "root-container": {
                        "padding-left": "{n_30}",
                        "padding-right": "{n_31}",
                        "border-radius": 0
                    }
                },
                "tablet": {
                    "root-container": {
                        "padding-left": "{n_32}",
                        "padding-right": "{n_33}",
                        "border-radius": 0
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "global",
            "_platform"
        ]
    ],
    "api": {
        "config": {
            "global": {
                "values": [
                    false,
                    true
                ]
            },
            "open": {
                "values": [
                    true,
                    false
                ]
            },
            "closeOnSuffixClick": {
                "values": [
                    true,
                    false
                ]
            },
            "ctaPosition": {
                "values": [
                    "inline",
                    "bottom"
                ]
            },
            "_showClose": {
                "values": [
                    true,
                    false
                ]
            },
            "_platform": {
                "values": [
                    "desktop",
                    "tablet",
                    "mobile"
                ]
            },
            "_hasDescription": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "cta-jds_button": {
                "label": {
                    "type": "string",
                    "name": "cta"
                }
            },
            "close-jds_button": {
                "icon": {
                    "type": "icon",
                    "name": "suffix"
                }
            },
            "bottom-cta-jds_button": {
                "label": {
                    "type": "string",
                    "name": "cta"
                }
            },
            "jds-icon": {
                "value": {
                    "type": "icon",
                    "name": "prefix"
                },
                "ic": {
                    "type": "icon",
                    "name": "prefix"
                }
            },
            "heading-jds-text": {
                "value": {
                    "type": "string",
                    "name": "title"
                }
            },
            "support-jds-text": {
                "value": {
                    "type": "string",
                    "name": "description"
                }
            }
        },
        "events": {
            "cta-jds_button": {
                "onClick": "onCTAClick"
            },
            "bottom-cta-jds_button": {
                "onClick": "onCTAClick"
            },
            "close-jds_button": {
                "onClick": "onSuffixClick"
            }
        },
        "a11y": {
            "root-container": {
                "properties": {
                    "role": {
                        "value": "banner"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "title"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "cta-jds_button": {
                "properties": {
                    "ariaLabel": "ctaAriaLabel",
                    "ariaDescribedby": {
                        "name": "ctaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "close-jds_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "closeButtonAriaLabel",
                        "value": "Close Button"
                    },
                    "ariaDescribedby": {
                        "name": "closeButtonAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "bottom-cta-jds_button": {
                "properties": {
                    "ariaLabel": "ctaAriaLabel",
                    "ariaDescribedby": {
                        "name": "ctaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$PROP_MAP$7 = (props)=>{
    if (typeof props.description === "object") console.warn("Passing Listblock props is deprecated. Please pass a string");
    return {
        cta: {
            properties: {
                cta: $fe5170bdd3625759$var$resolvePropObjectKeys(props.cta, "title", ""),
                onCTAClick: props.cta?.onClick ?? props.onCTAClick
            }
        }
    };
};
const $fe5170bdd3625759$var$withLogic$w = (Component)=>(userProps)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$7);
        const [open, setOpen] = (0, $acw62.useState)(props.open);
        const [internalOpen, setInternalOpen] = (0, $acw62.useState)(props.open);
        (0, $acw62.useEffect)(()=>{
            if (props.open) {
                setOpen(true);
                setTimeout(()=>{
                    setInternalOpen(true);
                }, 10);
            } else {
                setOpen(false);
                setTimeout(()=>setInternalOpen(false), 500);
            }
        }, [
            props.open
        ]);
        const getPlatform = ()=>{
            if ($fe5170bdd3625759$var$Devices.isMobile()) return "mobile";
            if ($fe5170bdd3625759$var$Devices.isTablet()) return "tablet";
            return "desktop";
        };
        const expandedClass = internalOpen && open ? "expanded" : "";
        const classes = [
            expandedClass
        ];
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                open: open || internalOpen,
                _showClose: !(props.suffix === null),
                _platform: getPlatform(),
                className: classes.join(" "),
                suffix: [
                    "",
                    void 0
                ].includes(props.suffix) ? "IcClose" : props.suffix,
                onSuffixClick: (ev)=>{
                    if (props.closeOnSuffixClick) {
                        setOpen(false);
                        setTimeout(()=>{
                            setInternalOpen(false);
                        }, 500);
                    }
                    props.onSuffixClick?.(ev);
                }
            }
        });
    };
const $fe5170bdd3625759$var$Component$y = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$v;
    const { global: global = false, open: open = true, closeOnSuffixClick: closeOnSuffixClick = true, ctaPosition: ctaPosition = "inline", onCTAClick: onCTAClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSuffixClick: onSuffixClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), ariaLabel: ariaLabel = props.title?.toString(), closeButtonAriaLabel: closeButtonAriaLabel = "Close Button", custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            global: global,
            open: open,
            closeOnSuffixClick: closeOnSuffixClick,
            ctaPosition: ctaPosition,
            onCTAClick: onCTAClick,
            onSuffixClick: onSuffixClick,
            ariaLabel: ariaLabel,
            closeButtonAriaLabel: closeButtonAriaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSNotificationBanner", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$var$NotificationBanner = $fe5170bdd3625759$var$withLogic$w($fe5170bdd3625759$var$Component$y);
$fe5170bdd3625759$var$NotificationBanner.displayName = "NotificationBanner";
$fe5170bdd3625759$var$NotificationBanner.slotName = "jds_notification_banner";
const $fe5170bdd3625759$var$sdl$u = {
    "metadata": {
        "version": "1.0.0",
        "id": "nudge-1.0.0",
        "name": "JDSNudgeContainer",
        "layerName": "jds_nudge_container"
    },
    "hierarchy": {
        "popup": [
            {
                "popup-container": [
                    {
                        "root-container": [
                            "jds_nudge"
                        ]
                    }
                ]
            }
        ]
    },
    "base": {
        "popup": {
            "priority": 70,
            "passive": true
        },
        "popup-container": {
            "flex-direction": "{n_0}",
            "size": "{n_1}",
            "padding-top": "{n_2}",
            "padding-right": "{n_3}",
            "padding-bottom": "{n_4}",
            "padding-left": "{n_5}"
        },
        "root-container": {
            "flex-direction": "{n_6}",
            "justify-content": "{n_7}",
            "align-items": "{n_8}",
            "size": "{n_9}",
            "gap": "{n_10}"
        }
    },
    "variant": {},
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "data": {
            "root-container": {
                "value": {
                    "type": "list",
                    "name": "activeNudges",
                    "object": {
                        "title": "string",
                        "description": "string",
                        "primaryCTA": "string",
                        "secondaryCTA": "string",
                        "showClose": "boolean",
                        "id": "string",
                        "prefix": "string"
                    }
                }
            },
            "jds_nudge": {
                "prefix": {
                    "type": "string",
                    "name": "activeNudges.prefix"
                },
                "title": {
                    "type": "string",
                    "name": "activeNudges.title"
                },
                "description": {
                    "type": "string",
                    "name": "activeNudges.description"
                },
                "primaryCTA": {
                    "type": "string",
                    "name": "activeNudges.primaryCTA"
                },
                "secondaryCTA": {
                    "type": "string",
                    "name": "activeNudges.secondaryCTA"
                },
                "showClose": {
                    "type": "string",
                    "name": "activeNudges.showClose"
                },
                "id": {
                    "type": "string",
                    "name": "activeNudges.id"
                },
                "suffix": {
                    "type": "slot",
                    "name": "activeNudges.suffix"
                },
                "maxLines": {
                    "type": "number",
                    "name": "activeNudges.maxLines"
                }
            }
        },
        "events": {
            "jds_nudge": {
                "onClose": "onClose",
                "onPrimaryClick": "onPrimaryClick",
                "onSecondaryClick": "onSecondaryClick",
                "onShow": "onShow"
            }
        },
        "a11y": {
            "jds_nudge": {
                "properties": {
                    "ariaLabel": "ariaLabel"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$v = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                activeNudges: props.nudges.map((n)=>({
                        ...n,
                        prefix: n.prefix || n.icon
                    }))
            }
        });
    };
const $fe5170bdd3625759$var$Component$x = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$u;
    const { onClose: onClose = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onPrimaryClick: onPrimaryClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSecondaryClick: onSecondaryClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onShow: onShow = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            onClose: onClose,
            onPrimaryClick: onPrimaryClick,
            onSecondaryClick: onSecondaryClick,
            onShow: onShow,
            ...rest
        },
        componentTag: componentTag
    }, "JDSNudgeContainer", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$var$NudgeContainer = $fe5170bdd3625759$var$withLogic$v($fe5170bdd3625759$var$Component$x);
$fe5170bdd3625759$var$NudgeContainer.displayName = "NudgeContainer";
$fe5170bdd3625759$var$NudgeContainer.slotName = "jds_nudge_container";
const $fe5170bdd3625759$var$sdl$t = {
    "metadata": {
        "version": "1.0.0",
        "id": "toast-1.0.0",
        "name": "JDSToastContainer",
        "layerName": "jds_toast_container"
    },
    "hierarchy": {
        "popup": [
            {
                "popup-container": [
                    {
                        "root-container": [
                            "jds_toast"
                        ]
                    }
                ]
            }
        ]
    },
    "base": {
        "popup": {
            "priority": 70,
            "passive": true
        },
        "popup-container": {
            "flex-direction": "{t_0}",
            "size": "{t_1}",
            "padding-top": "{t_2}",
            "padding-right": "{t_3}",
            "padding-bottom": "{t_4}",
            "padding-left": "{t_5}"
        },
        "root-container": {
            "flex-direction": "{t_6}",
            "justify-content": "{t_7}",
            "align-items": "{t_8}",
            "size": "{t_9}",
            "gap": "{t_10}"
        }
    },
    "variant": {},
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "data": {
            "root-container": {
                "value": {
                    "type": "list",
                    "name": "activeToasts",
                    "object": {
                        "title": "string",
                        "description": "string",
                        "primaryCTA": "string",
                        "secondaryCTA": "string",
                        "showClose": "boolean",
                        "dismissAfter": "number",
                        "id": "string",
                        "prefix": "string"
                    }
                }
            },
            "jds_toast": {
                "prefix": {
                    "type": "string",
                    "name": "activeToasts.prefix"
                },
                "title": {
                    "type": "string",
                    "name": "activeToasts.title"
                },
                "description": {
                    "type": "string",
                    "name": "activeToasts.description"
                },
                "primaryCTA": {
                    "type": "string",
                    "name": "activeToasts.primaryCTA"
                },
                "secondaryCTA": {
                    "type": "string",
                    "name": "activeToasts.secondaryCTA"
                },
                "showClose": {
                    "type": "string",
                    "name": "activeToasts.showClose"
                },
                "id": {
                    "type": "string",
                    "name": "activeToasts.id"
                },
                "dismissAfter": {
                    "type": "number",
                    "name": "activeToasts.dismissAfter"
                },
                "suffix": {
                    "type": "slot",
                    "name": "activeToasts.suffix"
                }
            }
        },
        "events": {
            "jds_toast": {
                "onClose": "onClose",
                "onPrimaryClick": "onPrimaryClick",
                "onSecondaryClick": "onSecondaryClick",
                "onShow": "onShow"
            }
        },
        "a11y": {
            "jds_toast": {
                "properties": {
                    "ariaLabel": "ariaLabel"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$u = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                activeToasts: props.toasts.map((t)=>({
                        ...t,
                        prefix: t.prefix || t.icon
                    }))
            }
        });
    };
const $fe5170bdd3625759$var$Component$w = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$t;
    const { onClose: onClose = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onPrimaryClick: onPrimaryClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSecondaryClick: onSecondaryClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onShow: onShow = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            onClose: onClose,
            onPrimaryClick: onPrimaryClick,
            onSecondaryClick: onSecondaryClick,
            onShow: onShow,
            ...rest
        },
        componentTag: componentTag
    }, "JDSToastContainer", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$var$ToastContainer = $fe5170bdd3625759$var$withLogic$u($fe5170bdd3625759$var$Component$w);
$fe5170bdd3625759$var$ToastContainer.displayName = "ToastContainer";
$fe5170bdd3625759$var$ToastContainer.slotName = "jds_toast_container";
const $fe5170bdd3625759$var$NotificationContainer = (props)=>{
    const { className: className, onShow: onShow, onClose: onClose, ...rest } = props;
    const classes = [
        className,
        "j-notificationContainer"
    ].join(" ");
    const notificationContRef = (0, $acw62.useRef)(null);
    const [nudges, setNudges] = (0, $acw62.useState)([]);
    const [toasts, setToasts] = (0, $acw62.useState)([]);
    const maxOnScreen = $fe5170bdd3625759$var$Devices.isMobile() ? 1 : 5;
    (0, $acw62.useEffect)(()=>{
        const { unsubscribe: nudgeUnsubscribe } = $fe5170bdd3625759$var$subscribe($fe5170bdd3625759$var$NotificationService, (data)=>{
            if (data.type === "nudge") setNudges(data.notifications);
        });
        const { unsubscribe: toastUnsubscribe } = $fe5170bdd3625759$var$subscribe($fe5170bdd3625759$var$NotificationService, (data)=>{
            if (data.type === "toast") setToasts(data.notifications);
        });
        return ()=>{
            $fe5170bdd3625759$var$nudge.dismissAll();
            nudgeUnsubscribe();
            $fe5170bdd3625759$var$toast.dismissAll();
            toastUnsubscribe();
        };
    }, []);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: classes,
        ...rest,
        ref: notificationContRef,
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$var$NudgeContainer, {
                onShow: onShow,
                onClose: onClose,
                nudges: nudges.slice(0, maxOnScreen).reverse()
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$var$ToastContainer, {
                onShow: onShow,
                onClose: onClose,
                toasts: toasts.slice(0, maxOnScreen).reverse()
            })
        ]
    });
};
$fe5170bdd3625759$var$NotificationContainer.displayName = "NotificationContainer";
$fe5170bdd3625759$var$NotificationContainer.defaultProps = {};
const $fe5170bdd3625759$var$sdl$s = {
    "metadata": {
        "version": "1.0.0",
        "id": "accordion-list-1.0.0",
        "name": "JDSAccordionList",
        "layerName": "jds_accordion_list"
    },
    "hierarchy": {
        "root-container": [
            {
                "container": [
                    "jds_accordion"
                ]
            },
            "content-slot"
        ]
    },
    "base": {
        "root-container": {
            "flex-direction": "{a_0}",
            "width": "{a_1}"
        },
        "container": {
            "hidden": true,
            "flex-direction": "{a_2}",
            "width": "{a_3}"
        },
        "content-slot": {
            "hidden": false
        }
    },
    "variant": {
        "_hasItems": {
            "true": {
                "content-slot": {
                    "hidden": true
                },
                "container": {
                    "hidden": false
                }
            }
        }
    },
    "api": {
        "data": {
            "container": {
                "value": {
                    "type": "list",
                    "name": "items",
                    "function": true,
                    "object": {
                        "children": "slot",
                        "prefix": "slot",
                        "expandedPanel": "boolean",
                        "showDivider": "boolean",
                        "disabled": "boolean",
                        "title": "string",
                        "subtitle": "string",
                        "onClick": "event"
                    }
                }
            },
            "jds_accordion": {
                "iconType": {
                    "type": "JDSAccordion.iconType",
                    "name": "iconType"
                },
                "children": {
                    "type": "slot",
                    "name": "items.children"
                },
                "prefix": {
                    "type": "slot",
                    "name": "items.prefix"
                },
                "expandedPanel": {
                    "type": "boolean",
                    "name": "items.expandedPanel"
                },
                "disabled": {
                    "type": "boolean",
                    "name": "items.disabled"
                },
                "title": {
                    "type": "string",
                    "name": "items.title"
                },
                "showDivider": {
                    "type": "boolean",
                    "name": "items.showDivider"
                },
                "subtitle": {
                    "type": "string",
                    "name": "items.subtitle"
                },
                "onClick": {
                    "type": "event",
                    "name": "items.onClick"
                }
            }
        },
        "config": {
            "iconType": {
                "type": "JDSAccordion.iconType",
                "values": [
                    "chevron",
                    "plus"
                ]
            },
            "allowMultiple": {
                "values": [
                    false,
                    true
                ]
            },
            "_hasItems": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "children": {
            "content-slot": {
                "name": "children",
                "accepts": [
                    "jds_accordion"
                ]
            }
        },
        "a11y": {
            "container": {
                "name": "items",
                "repeating": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": "ariaDescribedby"
                }
            },
            "jds_accordion": {
                "properties": {
                    "ariaLabel": "items.ariaLabel",
                    "ariaDescribedby": "items.ariaDescribedby"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$getAllowedPanels = (panels, allowMultiple)=>{
    if (!panels) return [];
    if (allowMultiple) return panels;
    return [
        panels[0]
    ];
};
const $fe5170bdd3625759$var$withLogic$t = (Component)=>(props)=>{
        const { allowMultiple: allowMultiple, children: children, onChange: onChange, iconType: iconType } = props;
        const [selected, setSelected] = (0, $acw62.useState)($fe5170bdd3625759$var$getAllowedPanels(props.expanded, allowMultiple));
        (0, $acw62.useEffect)(()=>{
            setSelected($fe5170bdd3625759$var$getAllowedPanels(props.expanded, allowMultiple));
        }, [
            props.expanded,
            allowMultiple
        ]);
        const childrenArray = (0, $acw62.useMemo)(()=>{
            if (!children) return [];
            if (Array.isArray(children)) return children;
            if (children.type === Symbol.for("react.fragment")) {
                const validChild = children.props.children;
                return Array.isArray(validChild) ? validChild : [
                    validChild
                ];
            }
            return [
                children
            ];
        }, [
            children
        ]);
        const handleSelected = (0, $acw62.useCallback)((i)=>{
            let newSelected = [
                ...selected
            ];
            if (selected.includes(i)) {
                const idx = newSelected.findIndex((s)=>s === i);
                if (allowMultiple) {
                    if (idx >= 0) newSelected.splice(idx, 1);
                } else newSelected = [];
            } else if (!allowMultiple) newSelected = [
                i
            ];
            else newSelected.push(i);
            setSelected(newSelected);
            onChange?.(newSelected);
        }, [
            selected,
            allowMultiple,
            onChange
        ]);
        const expandedChildren = (0, $acw62.useMemo)(()=>childrenArray?.map((c, i)=>{
                return (0, $acw62.cloneElement)(c, {
                    ...c.props,
                    iconType: iconType || c.props.iconType,
                    onClick: (e)=>{
                        handleSelected(i);
                        c.props.onClick?.(e);
                    },
                    expandedPanel: c?.props?.expandedPanel || selected.includes(i),
                    disabled: Boolean(c.props?.disabled)
                });
            }), [
            childrenArray,
            handleSelected,
            iconType,
            selected
        ]);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                _hasItems: Boolean(props.items?.length),
                items: props?.items?.map((item, i)=>{
                    return {
                        ...item,
                        key: item?.title ?? "" + i,
                        iconType: iconType,
                        onClick: (e)=>{
                            handleSelected(i);
                            item.onClick?.(e);
                        },
                        expandedPanel: item?.expandedPanel || selected.includes(i),
                        disabled: Boolean(item?.disabled)
                    };
                })
            },
            children: expandedChildren
        });
    };
const $fe5170bdd3625759$var$Component$v = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$s;
    const { iconType: iconType = "undefined", allowMultiple: allowMultiple = false, custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            iconType: iconType,
            allowMultiple: allowMultiple,
            ...rest
        },
        componentTag: componentTag
    }, "JDSAccordionList", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$a766cd26d0d69044 = $fe5170bdd3625759$var$withLogic$t($fe5170bdd3625759$var$Component$v);
$fe5170bdd3625759$export$a766cd26d0d69044.displayName = "Accordion";
$fe5170bdd3625759$export$a766cd26d0d69044.slotName = "jds_accordion_list";
const $fe5170bdd3625759$var$sdl$r = {
    "metadata": {
        "version": "1.0.0",
        "id": "base-icon-1.0.0",
        "name": "JDSBaseIcon",
        "layerName": "jds_base_icon"
    },
    "hierarchy": {
        "icon": []
    },
    "base": {
        "icon": {
            "size": "{b_0}",
            "color": "{b_1}"
        }
    },
    "variant": {
        "color": {
            "primary_30": {
                "icon": {
                    "color": "{b_2}"
                }
            },
            "primary_60": {
                "icon": {
                    "color": "{b_3}"
                }
            },
            "primary_70": {
                "icon": {
                    "color": "{b_4}"
                }
            },
            "primary_background": {
                "icon": {
                    "color": "{b_5}"
                }
            },
            "secondary_50": {
                "icon": {
                    "color": "{b_6}"
                }
            },
            "sparkle_50": {
                "icon": {
                    "color": "{b_7}"
                }
            },
            "primary_grey_60": {
                "icon": {
                    "color": "{b_8}"
                }
            },
            "primary_grey_80": {
                "icon": {
                    "color": "{b_9}"
                }
            },
            "primary_grey_100": {
                "icon": {
                    "color": "{b_10}"
                }
            },
            "feedback_success": {
                "icon": {
                    "color": "{b_11}",
                    "value": "ic_success_colored"
                }
            },
            "feedback_error": {
                "icon": {
                    "color": "{b_12}",
                    "value": "ic_error_colored"
                }
            },
            "feedback_warning": {
                "icon": {
                    "color": "{b_13}",
                    "value": "ic_warning_colored"
                }
            },
            "feedback_success_50": {
                "icon": {
                    "color": "{b_11}"
                }
            },
            "feedback_error_50": {
                "icon": {
                    "color": "{b_12}"
                }
            },
            "feedback_warning_50": {
                "icon": {
                    "color": "{b_13}"
                }
            },
            "white": {
                "icon": {
                    "color": "{b_14}"
                }
            },
            "none": {
                "icon": {
                    "color": "{b_15}"
                }
            }
        }
    },
    "api": {
        "config": {
            "color": {
                "values": [
                    "primary_50",
                    "primary_30",
                    "primary_60",
                    "primary_70",
                    "primary_background",
                    "secondary_50",
                    "sparkle_50",
                    "primary_grey_60",
                    "primary_grey_80",
                    "primary_grey_100",
                    "feedback_success",
                    "feedback_error",
                    "feedback_warning",
                    "feedback_success_50",
                    "feedback_error_50",
                    "feedback_warning_50",
                    "white",
                    "none"
                ]
            }
        },
        "data": {
            "icon": {
                "size": {
                    "type": "size",
                    "default": 16,
                    "name": "size",
                    "function": true,
                    "doc_description": "It can take the integer size user wants to pass."
                },
                "value": {
                    "type": "icon",
                    "name": "ic",
                    "function": true,
                    "doc_description": "It can take the icon user wants to pass or the name of icon. e.g. `ic='IcFavorite'`. User can also pass any custom icon he may have stored locally."
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$s = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$u = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$r;
    const { color: color = "primary_50", custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            color: color,
            ...rest
        },
        componentTag: componentTag
    }, "JDSBaseIcon", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$20931e2295160b07 = $fe5170bdd3625759$var$withLogic$s($fe5170bdd3625759$var$Component$u);
$fe5170bdd3625759$export$20931e2295160b07.displayName = "BaseIcon";
$fe5170bdd3625759$export$20931e2295160b07.slotName = "jds_base_icon";
const $fe5170bdd3625759$var$sdl$q = {
    "metadata": {
        "version": "1.0.0",
        "id": "bottom-navigation-1.0.0",
        "name": "JDSBottomNavigation",
        "layerName": "jds_bottom_navigation"
    },
    "hierarchy": {
        "container": [
            "jds_bottom_navigation_item"
        ]
    },
    "base": {
        "container": {
            "width": "{b_0}",
            "flex-direction": "{b_1}",
            "justify-content": "{b_2}",
            "align-items": "{b_3}",
            "background-color": "{b_4}",
            "padding-left": "{b_5}",
            "padding-top": "{b_6}",
            "padding-right": "{b_7}",
            "padding-bottom": "{b_8}",
            "gap": "{b_9}",
            "box-shadow": {
                "x": "{b_10}",
                "y": "{b_11}",
                "blur": "{b_12}",
                "spread": "{b_13}",
                "color": "{b_15}"
            }
        },
        "jds_bottom_navigation_item": {
            "flex": "{b_14}"
        }
    },
    "variant": {
        "multiLine": {
            "true": {
                "jds_bottom_navigation_item": {
                    "multiLine": true
                }
            },
            "false": {
                "jds_bottom_navigation_item": {
                    "multiLine": false
                }
            }
        }
    },
    "api": {
        "config": {
            "multiLine": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "container": {
                "value": {
                    "type": "list",
                    "name": "items",
                    "object": {
                        "icon": "icon",
                        "label": "string",
                        "disabled": "boolean"
                    },
                    "doc_description": "It shows list of items."
                }
            },
            "jds_bottom_navigation_item": {
                "selectedIndex": {
                    "type": "number",
                    "name": "activeIndex",
                    "doc_description": "It can be used to change the current active index."
                },
                "icon": {
                    "type": "icon",
                    "name": "items.icon"
                },
                "label": {
                    "type": "string",
                    "name": "items.label"
                },
                "disabled": {
                    "type": "boolean",
                    "name": "items.disabled"
                },
                "linkProps": {
                    "type": "object",
                    "name": "items.linkProps"
                },
                "showLabel": {
                    "type": "boolean",
                    "name": "showLabel",
                    "doc_description": "Shows label below icon if true,by default it is false."
                }
            }
        },
        "events": {
            "jds_bottom_navigation_item": {
                "onItemClick": "onChange"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "tablist"
                    }
                },
                "name": "items",
                "repeating": {
                    "ariaLabel": "navAriaLabel",
                    "ariaDescribedby": {
                        "name": "navAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_bottom_navigation_item": {
                "properties": {
                    "ariaLabel": "items.navAriaLabel",
                    "ariaDescribedby": "items.navAriaDescribedby"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$PROP_MAP$6 = (props = {})=>{
    return {
        items: {
            properties: {
                items: props?.items?.map((i)=>({
                        ...i,
                        label: i.label || i.title
                    }))
            }
        }
    };
};
const $fe5170bdd3625759$var$withLogic$r = (Component)=>(userProps)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$6);
        const { activeIndex: activeIndex, items: items = [], onChange: onChange, ...rest } = props;
        const { index: index, onClick: onClick } = $fe5170bdd3625759$var$useSelected(activeIndex);
        const navItems = items.map((item, i)=>({
                ...item,
                linkProps: {
                    href: item["href"],
                    provider: item["provider"],
                    target: item["target"],
                    newTab: item["newTab"]
                },
                showLabel: props.showLabel,
                onClick: (ev)=>{
                    if (!item.disabled) {
                        item["onClick"]?.(ev);
                        onClick(i);
                        onChange?.(i);
                    }
                }
            }));
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...rest,
                items: navItems,
                activeIndex: index,
                selectedIndex: index
            }
        });
    };
const $fe5170bdd3625759$var$Component$t = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$q;
    const { multiLine: multiLine = false, onChange: onChange = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            multiLine: multiLine,
            onChange: onChange,
            ...rest
        },
        componentTag: componentTag
    }, "JDSBottomNavigation", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$b77dc13a7753f3ee = $fe5170bdd3625759$var$withLogic$r($fe5170bdd3625759$var$Component$t);
$fe5170bdd3625759$export$b77dc13a7753f3ee.displayName = "BottomNav";
$fe5170bdd3625759$export$b77dc13a7753f3ee.slotName = "jds_bottom_navigation";
const $fe5170bdd3625759$var$sdl$p = {
    "metadata": {
        "version": "1.0.0",
        "id": "breadcrumbs-1.0.0",
        "name": "JDSBreadcrumbs",
        "layerName": "jds_breadcrumbs",
        "platform": "web",
        "description": "Breadcrumbs are a navigation system used to show hierarchy and navigational context for a user's location on a website. It helps users to understand where they are within a website's structure and move between levels.",
        "usage": "Breadcrumbs are used to categorize information in the search results and thus help the SEO of the site."
    },
    "hierarchy": {
        "container": [
            {
                "link-container": [
                    "jds_link",
                    {
                        "jds-icon-container": [
                            "jds-icon"
                        ]
                    }
                ]
            },
            "jds-text",
            "jds_menu_block"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{b_0}",
            "justify-content": "{b_1}",
            "align-items": "{b_2}",
            "height": "{b_3}"
        },
        "link-container": {
            "flex-direction": "{b_4}",
            "justify-content": "{b_5}",
            "align-items": "{b_6}"
        },
        "jds-icon": {
            "size": "{m}",
            "color": "{primaryGrey80}",
            "value": "ic_chevron_right",
            "ic": "ic_chevron_right"
        },
        "jds-icon-container": {
            "background-color": "{global.transparent}",
            "border-radius": "{pill}",
            "size": "{m}",
            "justify-content": "{justifyContent.center}",
            "align-items": "{alignItems.center}",
            "ic": "ic_chevron_right"
        },
        "jds-text": {
            "font-family": "{bodySBold}",
            "color": "{primaryGrey80}",
            "font-size": "{bodySBold}",
            "line-height": "{bodySBold}",
            "letter-spacing": "{bodySBold}",
            "font-weight": "{bodySBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "api": {
        "data": {
            "link-container": {
                "value": {
                    "type": "list",
                    "name": "shownLinks",
                    "object": {
                        "newTab": "boolean",
                        "href": "string",
                        "title": "string",
                        "routerLinkProps": "object",
                        "provider": "object",
                        "onClick": "event"
                    }
                }
            },
            "jds_link": {
                "title": {
                    "type": "string",
                    "name": "shownLinks.title"
                },
                "newTab": {
                    "type": "string",
                    "name": "shownLinks.newTab",
                    "platform": "web"
                },
                "href": {
                    "type": "string",
                    "name": "shownLinks.href"
                },
                "routerLinkProps": {
                    "type": "RouterLinkProps",
                    "name": "shownLinks.routerLinkProps",
                    "platform": "angular"
                },
                "onClick": {
                    "type": "event",
                    "name": "shownLinks.onClick"
                },
                "provider": {
                    "type": "event",
                    "name": "shownLinks.provider",
                    "platform": "react"
                }
            },
            "jds_menu_block": {
                "items": {
                    "type": "list",
                    "name": "hiddenLinks"
                },
                "open": {
                    "type": "boolean",
                    "name": "open"
                },
                "maxWidth": {
                    "type": "size",
                    "name": "maxWidth"
                },
                "offsetX": {
                    "type": "size",
                    "name": "_offsetX"
                },
                "offsetY": {
                    "type": "size",
                    "name": "_offsetY"
                },
                "maxHeight": {
                    "type": "size",
                    "name": "_maxHeight"
                }
            },
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "currentPage"
                }
            }
        },
        "events": {
            "jds_link": {
                "onClick": "onClick"
            },
            "jds_menu_block": {
                "onSelect": "onSelect",
                "onClose": "onClose"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "navigation"
                    }
                }
            },
            "link-container": {
                "name": "shownLinks",
                "repeating": {
                    "ariaLabel": "linkAriaLabel",
                    "ariaDescribedby": {
                        "name": "linkAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_link": {
                "properties": {
                    "ariaLabel": "shownLinks.linkAriaLabel",
                    "ariaDescribedby": "shownLinks.linkAriaDescribedby"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$q = (Component)=>(props)=>{
        const { children: children = [], links: linksArray = [] } = props;
        const { element: element, rootRef: rootRef } = $fe5170bdd3625759$var$useRootRef();
        const [open, setOpen] = (0, $acw62.useState)(false);
        const truncatedRef = (0, $acw62.useRef)(false);
        const [position, setPosition] = (0, $acw62.useState)({
            x: 0,
            y: 0,
            height: 0
        });
        const normalizedChildren = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.toArray(children);
        const allowedLinkIndices = (0, $acw62.useMemo)(()=>{
            const lastIndex = normalizedChildren.length - 1 || linksArray.length - 1 || 0;
            return [
                0,
                lastIndex
            ];
        }, [
            normalizedChildren,
            linksArray
        ]);
        const hiddenLinks = normalizedChildren.map((l, i)=>{
            if (!allowedLinkIndices.includes(i)) return {
                label: l.props?.title || linksArray?.[i]?.title
            };
            return null;
        }).filter((i)=>!!i);
        const getShownLinks = (0, $acw62.useMemo)(()=>{
            if (normalizedChildren.length > 1 && (element?.offsetWidth && element.offsetWidth > window.innerWidth / 2 || truncatedRef.current)) {
                truncatedRef.current = true;
                return allowedLinkIndices.map((index, i)=>{
                    if (i === 1) return {
                        title: "...",
                        onClick: (ev)=>{
                            setOpen(true);
                            const { target: target } = ev;
                            const { left: left, top: top, height: height } = $fe5170bdd3625759$var$setPositions(target, void 0);
                            setPosition({
                                x: left,
                                y: top,
                                height: height
                            });
                        }
                    };
                    return normalizedChildren[index]?.props || linksArray?.[index];
                });
            } else if (!truncatedRef.current) {
                truncatedRef.current = false;
                return linksArray.length ? linksArray : normalizedChildren.map((l)=>l.props);
            }
        }, [
            element,
            normalizedChildren,
            allowedLinkIndices,
            linksArray
        ]);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                hiddenLinks: hiddenLinks,
                shownLinks: getShownLinks,
                rootRef: rootRef,
                open: open,
                _offsetX: position.x,
                _offsetY: position.y,
                _maxHeight: position.height,
                maxWidth: "fit-content",
                onClose: ()=>setOpen(false),
                children: null
            }
        });
    };
const $fe5170bdd3625759$var$Component$s = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$p;
    const { onClick: onClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSelect: onSelect = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onClose: onClose = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            onClick: onClick,
            onSelect: onSelect,
            onClose: onClose,
            ...rest
        },
        componentTag: componentTag
    }, "JDSBreadcrumbs", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$2dc68d50d56fbbd = $fe5170bdd3625759$var$withLogic$q($fe5170bdd3625759$var$Component$s);
$fe5170bdd3625759$export$2dc68d50d56fbbd.displayName = "Breadcrumbs";
$fe5170bdd3625759$export$2dc68d50d56fbbd.slotName = "jds_breadcrumbs";
const $fe5170bdd3625759$var$sdl$o = {
    "metadata": {
        "version": "1.0.0",
        "id": "carousel-1.0.0",
        "name": "JDSCarousel",
        "layerName": "jds_carousel",
        "description": "Carousel is a component for cycling through a series of content slides that can be composed of a combination of images, text and cards.",
        "usage": "Carousels are used to promote multiple items of conent within a single area on a screen."
    },
    "hierarchy": {
        "container": [
            {
                "slider-container": [
                    "carousel-slot"
                ]
            },
            {
                "control-container": [
                    {
                        "left-container": [
                            {
                                "progress-container": [
                                    "jds_spinner",
                                    "prefix-jds_action_button"
                                ]
                            },
                            {
                                "prefix-container": [
                                    "title-jds-text",
                                    "subtitle-jds-text"
                                ]
                            }
                        ]
                    },
                    "jds_carousel_pagination",
                    {
                        "right-container": [
                            "back-jds_action_button",
                            "next-jds_action_button"
                        ]
                    }
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{c_0}",
            "justify-content": "{c_1}",
            "align-items": "{c_2}",
            "gap": "{c_3}",
            "width": "{c_4}"
        },
        "slider-container": {
            "width": "{c_5}"
        },
        "control-container": {
            "flex-direction": "{c_6}",
            "justify-content": "{c_7}",
            "align-items": "{c_8}",
            "gap": "{c_9}",
            "width": "{c_10}"
        },
        "left-container": {
            "flex": 1,
            "max-width": "{c_11}",
            "flex-direction": "{c_12}",
            "justify-content": "{c_13}",
            "align-items": "{c_14}",
            "gap": "{c_15}",
            "padding-top": "{c_16}",
            "padding-bottom": "{c_17}",
            "show": true
        },
        "progress-container": {
            "hidden": true,
            "flex-direction": "{c_21}",
            "justify-content": "{c_22}",
            "align-items": "{c_23}"
        },
        "prefix-jds_action_button": {
            "icon": "ic_play",
            "size": "medium",
            "kind": "secondary",
            "z-index": 0
        },
        "jds_spinner": {
            "hidden": true,
            "kind": "normal",
            "z-index": 0
        },
        "prefix-container": {
            "hidden": true,
            "flex-direction": "{c_18}",
            "justify-content": "{c_19}",
            "align-items": "{c_20}"
        },
        "right-container": {
            "flex": 1,
            "max-width": "{c_27}",
            "flex-direction": "{c_28}",
            "justify-content": "{c_29}",
            "align-items": "{c_30}",
            "gap": "{c_31}",
            "padding-top": "{c_32}",
            "padding-bottom": "{c_33}",
            "show": true
        },
        "back-jds_action_button": {
            "hidden": true,
            "icon": "ic_back",
            "size": "medium",
            "kind": "secondary"
        },
        "next-jds_action_button": {
            "hidden": true,
            "icon": "ic_next",
            "size": "medium",
            "kind": "secondary"
        },
        "jds_carousel_pagination": {
            "hidden": false
        },
        "title-jds-text": {
            "font-family": "{bodyXsBold}",
            "color": "{primaryGrey100}",
            "font-size": "{bodyXsBold}",
            "line-height": "{bodyXsBold}",
            "letter-spacing": "{bodyXsBold}",
            "font-weight": "{bodyXsBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "value": "Label",
            "text": "Label"
        },
        "subtitle-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "density": {
            "condensed": {
                "container": {
                    "gap": "{c_34}"
                },
                "prefix-jds_action_button": {
                    "size": "small"
                },
                "back-jds_action_button": {
                    "size": "small"
                },
                "next-jds_action_button": {
                    "size": "small"
                },
                "jds_carousel_pagination": {
                    "density": "condensed"
                }
            }
        },
        "indicatorType": {
            "label": {
                "left-container": {
                    "hidden": false
                },
                "prefix-container": {
                    "hidden": false
                },
                "jds_carousel_pagination": {
                    "hidden": true
                }
            },
            "dot_label": {
                "left-container": {
                    "hidden": false
                },
                "prefix-container": {
                    "hidden": false
                },
                "jds_carousel_pagination": {
                    "hidden": false
                }
            },
            "none": {
                "prefix-container": {
                    "hidden": true
                },
                "jds_carousel_pagination": {
                    "hidden": true
                }
            }
        },
        "autoPlay": {
            "false": {
                "left-container": {
                    "hidden": false
                }
            },
            "true": {
                "progress-container": {
                    "hidden": false
                }
            }
        },
        "showArrows": {
            "true": {
                "back-jds_action_button": {
                    "hidden": false
                },
                "next-jds_action_button": {
                    "hidden": false
                }
            }
        },
        "playing": {
            "true": {
                "prefix-jds_action_button": {
                    "icon": "ic_pause"
                }
            }
        }
    },
    "combination": [
        {
            "true": {
                "true": {
                    "prefix-jds_action_button": {
                        "z-index": 1,
                        "kind": "tertiary"
                    },
                    "jds_spinner": {
                        "hidden": false
                    }
                }
            }
        },
        {
            "true": {
                "true": {
                    "back-jds_action_button": {
                        "hidden": true
                    }
                }
            }
        },
        {
            "true": {
                "false": {
                    "progress-container": {
                        "hidden": true
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "autoPlay",
            "showDurationProgress"
        ],
        [
            "showArrows",
            "hideLeftArrow"
        ],
        [
            "playing",
            "showPlayPause"
        ]
    ],
    "api": {
        "config": {
            "density": {
                "type": "JDSCarouselPaginationItem.density",
                "values": [
                    "relaxed",
                    "condensed"
                ]
            },
            "indicatorType": {
                "values": [
                    "dot",
                    "label",
                    "dot_label",
                    "none"
                ]
            },
            "showArrows": {
                "values": [
                    false,
                    true
                ]
            },
            "hideLeftArrow": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "only used to hide the left arrow, no op when showArrows = false"
            },
            "hideNextSlide": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "only used to hide the left arrow, no op when showArrows = false"
            },
            "autoPlay": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "hide autoplay button when autoPlay=false"
            },
            "showPlayPause": {
                "values": [
                    true,
                    false
                ],
                "doc_description": "hide autoplay button when showPlayPause=false"
            },
            "playing": {
                "values": [
                    false,
                    true
                ]
            },
            "showDurationProgress": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds_carousel_pagination": {
                "selectedIndex": {
                    "type": "number",
                    "name": "selectedIndex"
                },
                "count": {
                    "type": "number",
                    "name": "totalSlides",
                    "doc_description": "to be used when number of children != total slides (e.g. when lazyloading or server pagination)"
                },
                "items": {
                    "type": "list",
                    "name": "_paginationItems"
                }
            },
            "jds_spinner": {
                "value": {
                    "type": "number",
                    "name": "_value"
                }
            },
            "slider-container": {
                "customHeight": {
                    "type": "number",
                    "name": "customHeight",
                    "platform": "ios",
                    "doc_description": "This can be used to set a custom user provided height for carousel container, instead of default height(200) rendered from engine"
                }
            },
            "title-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label",
                    "function": true
                }
            },
            "subtitle-jds-text": {
                "value": {
                    "type": "string",
                    "name": "_subtitle"
                }
            }
        },
        "children": {
            "carousel-slot": {
                "name": "children",
                "accepts": [
                    "jds_carousel_slide"
                ]
            }
        },
        "events": {
            "prefix-jds_action_button": {
                "onClick": {
                    "name": "onPlayPause",
                    "doc_description": "Triggered on resume/play/pause of auto playing slides."
                }
            },
            "back-jds_action_button": {
                "onClick": "onBackBtn"
            },
            "next-jds_action_button": {
                "onClick": "onNextBtn"
            },
            "jds_carousel_pagination": {
                "onDotClick": {
                    "name": "onDotClick",
                    "doc_description": "Triggerred on click of pagination dot"
                }
            },
            "slider-container": {
                "onClick": "onClick",
                "onSwipeLeft": "onNext",
                "onSwipeRight": "onBack"
            },
            "carousel-slot": {
                "onClick": "onClick",
                "onSwipeLeft": "onNext",
                "onSwipeRight": "onBack"
            }
        },
        "a11y": {
            "prefix-jds_action_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "PlayPauseAriaLabel",
                        "value": "Pause or Play Auto slide rotation"
                    }
                }
            },
            "back-jds_action_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "backButtonAriaLabel",
                        "value": "Previous Slide"
                    }
                }
            },
            "next-jds_action_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "nextButtonAriaLabel",
                        "value": "Next Slide"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$clampValue = (index, total)=>{
    if (index < 0) return total - 1;
    if (index >= total) return 0;
    return index;
};
const $fe5170bdd3625759$var$sortedOrder = (children)=>{
    children.sort((a, b)=>{
        const elementA = a;
        const elementB = b;
        return (elementA.props.order || -1) - (elementB.props.order || -1);
    });
    return children;
};
const $fe5170bdd3625759$var$AUTOPLAY_DURATION = 3e3;
const $fe5170bdd3625759$var$TRANSITION_DURATION = 300;
const $fe5170bdd3625759$var$TOTALSPINNER_VALUE = 360;
const $fe5170bdd3625759$var$withLogic$p = (Component)=>(0, $acw62.forwardRef)((userProps, ref)=>{
        const { activeIndex: activeIndex = -1, initialIndex: initialIndex = 0, slideDuration: slideDuration = $fe5170bdd3625759$var$AUTOPLAY_DURATION, hideNextSlide: hideNextSlide, totalSlides: slideCount = 0, ...props } = userProps;
        const SLIDE_PERCENT = $fe5170bdd3625759$var$Devices.isMobile() && !hideNextSlide ? 92 : 100;
        const totalSlides = slideCount || (0, $acw62.Children).count(props.children);
        const [spinnerValue, setSpinnerValue] = (0, $acw62.useState)($fe5170bdd3625759$var$TOTALSPINNER_VALUE);
        const { element: element, rootRef: rootRef } = $fe5170bdd3625759$var$useRootRef();
        const transitionProgressRef = (0, $acw62.useRef)(false);
        const intervalRef = (0, $acw62.useRef)();
        const spinnerIntervalRef = (0, $acw62.useRef)();
        const [selected, setSelected] = (0, $acw62.useState)(props.playing);
        (0, $acw62.useEffect)(()=>{
            handleAutoPlay(Boolean(props.playing));
            return ()=>{
                clearInterval(intervalRef.current);
                clearInterval(spinnerIntervalRef.current);
            };
        }, [
            props.playing
        ]);
        const [index, setIndex] = (0, $acw62.useState)(0);
        const touchRef = (0, $acw62.useRef)({
            start: 0,
            end: 0,
            started: false,
            id: 0
        });
        const totalDistance = (0, $acw62.useRef)(0);
        const [totalTouchDistance, setTotalDistance] = (0, $acw62.useState)(0);
        (0, $acw62.useEffect)(()=>{
            if (typeof initialIndex !== "undefined") jumpToSlide(initialIndex);
        }, [
            initialIndex
        ]);
        (0, $acw62.useEffect)(()=>{
            if (element) jumpToSlide(activeIndex);
        }, [
            activeIndex
        ]);
        const handleEndSlidePositions = (idx)=>{
            const currentIndex = idx === void 0 ? index : idx;
            const slides = Array.from(element?.querySelectorAll("div.j-jds-carousel-slide-container") || []);
            const firstSlide = slides[0];
            const lastSlide = slides[slides.length - 1];
            if (firstSlide) {
                if (currentIndex === totalSlides - 1) firstSlide.style.transform = `translateX(${(totalSlides || 1) * 100}%)`;
                else firstSlide.style.transform = "unset";
            }
            if (lastSlide) {
                if (currentIndex === 0) lastSlide.style.transform = `translateX(-${(totalSlides || 1) * 100}%)`;
                else lastSlide.style.transform = "unset";
            }
        };
        const enableTransition = ()=>{
            const containerRef = element?.querySelector('div[data-testid="JDSCarousel-slider-container"]');
            if (!containerRef) return;
            containerRef.style.transitionDuration = $fe5170bdd3625759$var$TRANSITION_DURATION + "ms";
        };
        const next = ()=>{
            if (transitionProgressRef.current) return;
            const nextIndex = $fe5170bdd3625759$var$clampValue(index + 1, totalSlides);
            moveToPanel(nextIndex, 1);
            setTimeout(()=>{
                handleEndSlidePositions(touchRef.current.id);
            }, $fe5170bdd3625759$var$TRANSITION_DURATION);
        };
        const prev = ()=>{
            if (transitionProgressRef.current) return;
            const nextIndex = $fe5170bdd3625759$var$clampValue(index - 1, totalSlides);
            moveToPanel(nextIndex, -1);
            setTimeout(()=>{
                handleEndSlidePositions(touchRef.current.id);
            }, $fe5170bdd3625759$var$TRANSITION_DURATION);
        };
        function handleImmediateTransitionToSlide(slideIndex) {
            const containerRef = element?.querySelector('div[data-testid="JDSCarousel-slider-container"]');
            if (!containerRef) return;
            containerRef.style.transitionDuration = "0ms";
            handleEndSlidePositions(totalSlides - 1);
            setTotalDistance(slideIndex * -1 * SLIDE_PERCENT);
            setTimeout(enableTransition, $fe5170bdd3625759$var$TRANSITION_DURATION);
        }
        const jumpToSlide = (idx)=>{
            if (transitionProgressRef.current) return;
            const clampedIndex = $fe5170bdd3625759$var$clampValue(idx, totalSlides);
            if (clampedIndex === index) return;
            moveToPanel(clampedIndex, 1);
            setTimeout(()=>{
                handleEndSlidePositions(touchRef.current.id);
            }, $fe5170bdd3625759$var$TRANSITION_DURATION);
        };
        (0, $acw62.useImperativeHandle)(ref, ()=>({
                getCurrentIndex: ()=>touchRef.current.id,
                goToSlide: jumpToSlide,
                next: next,
                prev: prev,
                getCaption: (currentIndex, _)=>{
                    return (0, $acw62.Children).toArray(props.children)[currentIndex].props.label || "";
                }
            }));
        const moveToPanel = (index2, dir = 1)=>{
            let distance = 0;
            if (dir > 0) {
                if (index2 === 0) {
                    distance = 0;
                    transitionProgressRef.current = true;
                    setTimeout(()=>{
                        handleImmediateTransitionToSlide(0);
                        transitionProgressRef.current = false;
                    }, $fe5170bdd3625759$var$TRANSITION_DURATION);
                } else distance = index2 * -1 * SLIDE_PERCENT;
            } else if (totalSlides - 1 === index2) {
                distance = SLIDE_PERCENT;
                transitionProgressRef.current = true;
                setTimeout(()=>{
                    handleImmediateTransitionToSlide(totalSlides - 1);
                    transitionProgressRef.current = false;
                }, $fe5170bdd3625759$var$TRANSITION_DURATION);
            } else distance = index2 * -1 * SLIDE_PERCENT;
            setTotalDistance(distance);
            setIndex(index2);
            touchRef.current.id = index2;
        };
        const handlePointerStart = (e)=>{
            handleEndSlidePositions();
            touchRef.current.started = true;
            touchRef.current.start = e.clientX;
            totalDistance.current = totalTouchDistance;
        };
        const handlePointerMove = (ev)=>{
            const containerWidth = element?.offsetWidth || 1;
            if (touchRef.current.started) {
                touchRef.current.end = ev.clientX;
                const difference = 100 / containerWidth * (touchRef.current.end - touchRef.current.start);
                const aactiveSlideDistance = index * -1 * SLIDE_PERCENT;
                setTotalDistance(aactiveSlideDistance + difference);
            }
        };
        const handlePointerEnd = (ev)=>{
            const difference = touchRef.current.end - touchRef.current.start;
            const diff = Math.abs(difference) / ev.currentTarget.offsetWidth * 100;
            touchRef.current = {
                start: 0,
                started: false,
                end: 0,
                id: touchRef.current.id
            };
            if (Math.abs(diff) > 30) {
                if (difference < 0) next();
                else prev();
            } else setTotalDistance(totalDistance.current);
        };
        (0, $acw62.useEffect)(()=>{
            if (!props.autoPlay) {
                if (intervalRef.current) clearInterval(intervalRef.current);
                if (spinnerIntervalRef.current) clearInterval(spinnerIntervalRef.current);
            }
        }, [
            props.autoPlay
        ]);
        const handleAutoPlay = (selected2)=>{
            console.log("handleAutoPlay called", selected2);
            setSelected(selected2);
            if (!selected2) {
                clearInterval(intervalRef.current);
                clearInterval(spinnerIntervalRef.current);
                props?.onPause?.(index);
                setSpinnerValue(0);
            } else {
                props?.onPlay?.(index);
                const animationDuration = slideDuration;
                let startTimestamp;
                const animate = (timestamp)=>{
                    if (!startTimestamp) startTimestamp = timestamp;
                    const progress = timestamp - startTimestamp;
                    const percentage = Math.min(progress / animationDuration, 1);
                    const newValue = percentage * 360;
                    setSpinnerValue(newValue);
                    if (progress < animationDuration) requestAnimationFrame(animate);
                    else {
                        startTimestamp = 0;
                        setTimeout(animate, slideDuration);
                    }
                };
                intervalRef.current = setInterval(()=>{
                    if (transitionProgressRef.current) return;
                    const nextIndex = $fe5170bdd3625759$var$clampValue(touchRef.current.id + 1, totalSlides);
                    moveToPanel(nextIndex, 1);
                    setTimeout(()=>{
                        handleEndSlidePositions(touchRef.current.id);
                    }, $fe5170bdd3625759$var$TRANSITION_DURATION);
                }, slideDuration);
                animate(performance.now());
                spinnerIntervalRef.current = setInterval(()=>{
                    animate(performance.now());
                }, slideDuration);
            }
        };
        const handleDotClick = (idx)=>{
            let dir = -1;
            if (idx < index) dir = -1;
            else dir = 1;
            moveToPanel(idx, dir);
            props.onPaginationClick?.();
            handleEndSlidePositions(idx);
        };
        const tokens = (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
        const language = tokens.lang;
        const numeralList = (0, $acw62.useMemo)(()=>{
            return (0, $8bd3c5c9ee0d1eb4$export$3f81e69b9bc596cd)(language);
        }, [
            language
        ]);
        const localOf = (0, $8bd3c5c9ee0d1eb4$export$fb5267b92d6c6cd3)(language);
        const getLocalNumber = (number)=>{
            const numString = number.toString();
            return numString.replace(/\d/g, (num)=>numeralList[parseInt(num, 10)] ?? num);
        };
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
            style: {
                "--move": totalTouchDistance + "%",
                "--slide-width": SLIDE_PERCENT + "%"
            },
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
                ...{
                    ...props,
                    totalSlides: totalSlides,
                    rootRef: rootRef,
                    children: $fe5170bdd3625759$var$sortedOrder((0, $acw62.Children).toArray(props.children)),
                    selectedIndex: index,
                    count: totalSlides,
                    _subtitle: `${getLocalNumber(index + 1)} ${localOf ?? "of"} ${getLocalNumber(totalSlides)}`,
                    onNextBtn: ()=>{
                        next();
                    },
                    onBackBtn: prev,
                    onNext: (ev, { type: type })=>{
                        if (type === "touchdown") handlePointerStart(ev);
                        else if (type === "touchmove") handlePointerMove(ev);
                        else handlePointerEnd(ev);
                    },
                    playing: selected,
                    _value: spinnerValue,
                    onPlayPause: ()=>handleAutoPlay(!selected),
                    onDotClick: handleDotClick
                }
            })
        });
    });
const $fe5170bdd3625759$var$Component$r = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$o;
    const { density: density = "undefined", indicatorType: indicatorType = "dot", showArrows: showArrows = false, hideLeftArrow: hideLeftArrow = false, hideNextSlide: hideNextSlide = false, autoPlay: autoPlay = false, showPlayPause: showPlayPause = true, playing: playing = false, showDurationProgress: showDurationProgress = false, onPlayPause: onPlayPause = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onBackBtn: onBackBtn = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onNextBtn: onNextBtn = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onDotClick: onDotClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onClick: onClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onNext: onNext = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onBack: onBack = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), PlayPauseAriaLabel: PlayPauseAriaLabel = "Pause or Play Auto slide rotation", backButtonAriaLabel: backButtonAriaLabel = "Previous Slide", nextButtonAriaLabel: nextButtonAriaLabel = "Next Slide", custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            density: density,
            indicatorType: indicatorType,
            showArrows: showArrows,
            hideLeftArrow: hideLeftArrow,
            hideNextSlide: hideNextSlide,
            autoPlay: autoPlay,
            showPlayPause: showPlayPause,
            playing: playing,
            showDurationProgress: showDurationProgress,
            onPlayPause: onPlayPause,
            onBackBtn: onBackBtn,
            onNextBtn: onNextBtn,
            onDotClick: onDotClick,
            onClick: onClick,
            onNext: onNext,
            onBack: onBack,
            PlayPauseAriaLabel: PlayPauseAriaLabel,
            backButtonAriaLabel: backButtonAriaLabel,
            nextButtonAriaLabel: nextButtonAriaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSCarousel", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$144901db2ea8e967 = $fe5170bdd3625759$var$withLogic$p($fe5170bdd3625759$var$Component$r);
$fe5170bdd3625759$export$144901db2ea8e967.displayName = "Carousel";
$fe5170bdd3625759$export$144901db2ea8e967.slotName = "jds_carousel";
const $fe5170bdd3625759$var$sdl$n = {
    "metadata": {
        "version": "1.0.0",
        "id": "container-1.0.0",
        "name": "JDSContainer",
        "layerName": "jds_container"
    },
    "hierarchy": {
        "container": [
            "content-slot"
        ]
    },
    "base": {
        "container": {
            "show": true,
            "background-color": "{global.transparent}",
            "flex-direction": "{flexDirection.row}",
            "justify-content": "{justifyContent.start}",
            "align-items": "{alignItems.start}",
            "padding-left": 0,
            "padding-top": 0,
            "padding-bottom": 0,
            "padding-right": 0,
            "border-bottom-width": 0,
            "border-top-width": 0,
            "border-right-width": 0,
            "border-left-width": 0,
            "border-top-left-radius": 0,
            "border-top-right-radius": 0,
            "border-bottom-left-radius": 0,
            "border-bottom-right-radius": 0
        }
    },
    "variant": {
        "direction": {
            "column": {
                "container": {
                    "flex-direction": "{flexDirection.column}"
                }
            },
            "stack": {
                "container": {
                    "flex-direction": "{flexDirection.stack}"
                }
            }
        }
    },
    "combination": [
        {
            "row": {
                "center": {
                    "container": {
                        "align-items": "{alignItems.center}"
                    }
                },
                "end": {
                    "container": {
                        "align-items": "{alignItems.end}"
                    }
                },
                "space-between": {
                    "container": {
                        "align-items": "{alignItems.spaceBetween}"
                    }
                },
                "space-around": {
                    "container": {
                        "align-items": "{alignItems.spaceAround}"
                    }
                },
                "space-evenly": {
                    "container": {
                        "align-items": "{alignItems.spaceEvenly}"
                    }
                }
            },
            "column": {
                "center": {
                    "container": {
                        "justify-content": "{justifyContent.center}"
                    }
                },
                "end": {
                    "container": {
                        "justify-content": "{justifyContent.end}"
                    }
                },
                "space-between": {
                    "container": {
                        "justify-content": "{justifyContent.spaceBetween}"
                    }
                },
                "space-around": {
                    "container": {
                        "justify-content": "{justifyContent.spaceAround}"
                    }
                },
                "space-evenly": {
                    "container": {
                        "justify-content": "{justifyContent.spaceEvenly}"
                    }
                }
            },
            "stack": {
                "center": {
                    "container": {
                        "align-items": "{alignItems.center}"
                    }
                },
                "end": {
                    "container": {
                        "align-items": "{alignItems.end}"
                    }
                }
            }
        },
        {
            "row": {
                "center": {
                    "container": {
                        "justify-content": "{justifyContent.center}"
                    }
                },
                "end": {
                    "container": {
                        "justify-content": "{justifyContent.end}"
                    }
                },
                "space-between": {
                    "container": {
                        "justify-content": "{justifyContent.spaceBetween}"
                    }
                },
                "space-around": {
                    "container": {
                        "justify-content": "{justifyContent.spaceAround}"
                    }
                },
                "space-evenly": {
                    "container": {
                        "justify-content": "{justifyContent.spaceEvenly}"
                    }
                }
            },
            "column": {
                "center": {
                    "container": {
                        "align-items": "{alignItems.center}"
                    }
                },
                "end": {
                    "container": {
                        "align-items": "{alignItems.end}"
                    }
                },
                "space-between": {
                    "container": {
                        "align-items": "{alignItems.spaceBetween}"
                    }
                },
                "space-around": {
                    "container": {
                        "align-items": "{alignItems.spaceAround}"
                    }
                },
                "space-evenly": {
                    "container": {
                        "align-items": "{alignItems.spaceEvenly}"
                    }
                }
            },
            "stack": {
                "center": {
                    "container": {
                        "justify-content": "{justifyContent.center}"
                    }
                },
                "end": {
                    "container": {
                        "justify-content": "{justifyContent.end}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "direction",
            "verticalAlign"
        ],
        [
            "direction",
            "horizontalAlign"
        ]
    ],
    "api": {
        "children": {
            "content-slot": {
                "name": "children",
                "accepts": [
                    "any"
                ]
            }
        },
        "config": {
            "verticalAlign": {
                "values": [
                    "start",
                    "center",
                    "end",
                    "space-between",
                    "space-around",
                    "space-evenly"
                ]
            },
            "horizontalAlign": {
                "values": [
                    "start",
                    "center",
                    "end",
                    "space-between",
                    "space-around",
                    "space-evenly"
                ]
            },
            "direction": {
                "values": [
                    "row",
                    "column",
                    "stack"
                ]
            }
        },
        "data": {
            "container": {
                "width": {
                    "type": "token",
                    "name": "width"
                },
                "height": {
                    "type": "token",
                    "name": "height"
                },
                "background-color": {
                    "type": "string",
                    "name": "backgroundColor"
                },
                "border-radius": {
                    "type": "token",
                    "name": "radius"
                },
                "padding-left": {
                    "type": "token",
                    "name": "paddingLeft"
                },
                "padding-right": {
                    "type": "token",
                    "name": "paddingRight"
                },
                "padding-top": {
                    "type": "token",
                    "name": "paddingTop"
                },
                "padding-bottom": {
                    "type": "token",
                    "name": "paddingBottom"
                },
                "flex": {
                    "type": "number",
                    "name": "flex"
                },
                "border-left-width": {
                    "type": "token",
                    "name": "borderLeftWidth"
                },
                "border-right-width": {
                    "type": "token",
                    "name": "borderRightWidth"
                },
                "border-top-width": {
                    "type": "token",
                    "name": "borderTopWidth"
                },
                "border-bottom-width": {
                    "type": "token",
                    "name": "borderBottomWidth"
                },
                "border-top-left-radius": {
                    "type": "token",
                    "name": "borderTopLeftRadius"
                },
                "border-top-right-radius": {
                    "type": "token",
                    "name": "borderTopRightRadius"
                },
                "border-bottom-left-radius": {
                    "type": "token",
                    "name": "borderBottomLeftRadius"
                },
                "border-bottom-right-radius": {
                    "type": "token",
                    "name": "borderBottomRightRadius"
                },
                "border-color": {
                    "type": "string",
                    "name": "borderColor"
                },
                "gap": {
                    "type": "token",
                    "name": "gap"
                },
                "overflow": {
                    "type": "string",
                    "name": "overflow",
                    "platform": "web"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$o = (Component)=>(0, $acw62.forwardRef)((props, ref)=>{
        const [borderTop, borderRight, borderBottom, borderLeft] = props.borderWidth || [];
        const allSides = props.padding?.length === 1 ? Array.from({
            length: 4
        }).map(()=>props.padding?.[0]) : props.padding;
        const [paddingTop, paddingRight, paddingBottom, paddingLeft] = allSides || [];
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                rootRef: ref,
                children: $fe5170bdd3625759$var$convertTextToComponent(props.children),
                width: props.fullWidth ? "{size.max}" : props.width,
                borderTopWidth: borderTop || props.borderTopWidth,
                borderLeftWidth: borderLeft || props.borderLeftWidth,
                borderRightWidth: borderRight || props.borderLeftWidth,
                borderBottomWidth: borderBottom || props.borderLeftWidth,
                paddingTop: paddingTop || props.paddingTop,
                paddingBottom: paddingBottom || props.paddingBottom,
                paddingRight: paddingRight || props.paddingRight,
                paddingLeft: paddingLeft || props.paddingLeft,
                gap: props.gap ?? 0,
                borderBottomLeftRadius: props.borderBottomLeftRadius || props.radius,
                borderBottomRightRadius: props.borderBottomRightRadius || props.radius,
                borderTopLeftRadius: props.borderTopLeftRadius || props.radius,
                borderTopRightRadius: props.borderTopRightRadius || props.radius
            }
        });
    });
const $fe5170bdd3625759$var$Component$q = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$n;
    const { verticalAlign: verticalAlign = "start", horizontalAlign: horizontalAlign = "start", direction: direction = "row", custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            verticalAlign: verticalAlign,
            horizontalAlign: horizontalAlign,
            direction: direction,
            ...rest
        },
        componentTag: componentTag
    }, "JDSContainer", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$42a852a2b6b56249 = $fe5170bdd3625759$var$withLogic$o($fe5170bdd3625759$var$Component$q);
$fe5170bdd3625759$export$42a852a2b6b56249.displayName = "Container";
$fe5170bdd3625759$export$42a852a2b6b56249.slotName = "jds_container";
const $fe5170bdd3625759$var$sdl$m = {
    "metadata": {
        "version": "1.0.0",
        "id": "content-card-1.0.0",
        "name": "JDSContentCard",
        "layerName": "jds_content_card",
        "description": "Content cards are blocks of content that contain various combinations of components in different structures.",
        "usage": "Content cards are used to organise content in meaningful blocks within a page."
    },
    "hierarchy": {
        "root-container": [
            {
                "header-container": [
                    "header-slot"
                ]
            },
            {
                "image-content-container": [
                    "jds_image",
                    "jds_content_block"
                ]
            },
            {
                "children-container": [
                    "children-slot"
                ]
            },
            "footer-jds-text"
        ]
    },
    "base": {
        "root-container": {
            "overflow": "hidden",
            "width": "{c_0}",
            "border-radius": "{c_1}",
            "flex-direction": "{c_2}",
            "justify-content": "{c_3}",
            "align-items": "{c_4}",
            "background-color": "{c_5}",
            "padding-bottom": "{c_29}",
            "gap": "{base}",
            "box-shadow": {
                "x": 0,
                "y": 4,
                "blur": 16,
                "spread": 0,
                "color": "#00000014"
            },
            "behavior": {
                "hover": {
                    "box-shadow": {
                        "x": 0,
                        "y": 4,
                        "blur": 16,
                        "spread": 0,
                        "color": "#0000000E"
                    }
                }
            }
        },
        "header-container": {
            "hidden": false,
            "justify-content": "{c_6}",
            "align-items": "{c_7}",
            "width": "{c_8}",
            "padding-left": "{c_9}",
            "padding-right": "{c_10}"
        },
        "children-container": {
            "hidden": false,
            "justify-content": "{c_12}",
            "align-items": "{c_13}",
            "width": "{c_14}",
            "padding-left": "{c_15}"
        },
        "image-content-container": {
            "flex-direction": "{c_18}",
            "width": "{c_19}",
            "justify-content": "{c_20}",
            "align-items": "{c_21}",
            "gap": "{base}"
        },
        "jds_image": {
            "aspectRatio": "horizontal_16_9",
            "roundedCorner": true,
            "imageFocus": "center"
        },
        "jds_content_block": {
            "size": "xtra-small",
            "padding-left": "{c_24}",
            "padding-right": "{c_25}"
        },
        "footer-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "padding-left": "{c_27}",
            "padding-right": "{c_28}"
        }
    },
    "variant": {
        "imageRatio": {
            "square": {
                "jds_image": {
                    "aspectRatio": "square"
                }
            },
            "landscape": {
                "jds_image": {
                    "aspectRatio": "horizontal_4_3"
                }
            },
            "portrait": {
                "jds_image": {
                    "aspectRatio": "vertical_4_5"
                }
            }
        },
        "shadow": {
            "false": {
                "root-container": {
                    "box-shadow": {
                        "x": 0,
                        "y": 0,
                        "blur": 0,
                        "spread": 0,
                        "color": "#00000000"
                    }
                }
            }
        },
        "_hasHeaderSlot": {
            "false": {
                "header-container": {
                    "hidden": true
                },
                "image-content-container": {
                    "padding-top": 0
                }
            }
        },
        "_hasChildrenSlot": {
            "false": {
                "children-container": {
                    "hidden": true
                }
            }
        },
        "_hasContentBlockAndImageProps": {
            "false": {
                "image-content-container": {
                    "hidden": true
                }
            }
        },
        "_hasContentBlockProps": {
            "false": {
                "jds_content_block": {
                    "hidden": true
                }
            }
        },
        "_hasImageProps": {
            "false": {
                "image-content-container": {
                    "padding-top": 0
                },
                "jds_image": {
                    "hidden": true
                },
                "jds_content_block": {
                    "padding-top": 0
                }
            }
        },
        "condensed": {
            "true": {
                "jds_content_block": {
                    "ctaWrap": "vertical"
                }
            }
        },
        "orientation": {
            "horizontal": {
                "jds_content_block": {
                    "padding-left": 0
                }
            }
        }
    },
    "combination": [
        {
            "false": {
                "xtra-xtra-small": {
                    "jds_content_block": {
                        "size": "xtra-xtra-small"
                    }
                },
                "small": {
                    "jds_content_block": {
                        "size": "small"
                    }
                },
                "medium": {
                    "jds_content_block": {
                        "size": "medium"
                    }
                },
                "large": {
                    "jds_content_block": {
                        "size": "large"
                    }
                },
                "xtra-large": {
                    "jds_content_block": {
                        "size": "xtra-large"
                    }
                }
            }
        },
        {
            "true": {
                "horizontal": {
                    "image-content-container": {
                        "padding-left": "{c_30}",
                        "padding-top": "{c_31}",
                        "flex-direction": "{c_32}"
                    },
                    "jds_image": {
                        "flex": "0.2",
                        "aspectRatio": "square"
                    },
                    "jds_content_block": {
                        "flex": "0.8",
                        "size": "xtra-xtra-small"
                    }
                },
                "vertical": {
                    "root-container": {
                        "width": "{c_33}"
                    },
                    "jds_image": {
                        "aspectRatio": "square"
                    },
                    "jds_content_block": {
                        "size": "xtra-xtra-small"
                    }
                }
            },
            "false": {
                "horizontal": {
                    "root-container": {
                        "width": "{c_34}"
                    },
                    "image-content-container": {
                        "padding-left": "{c_35}",
                        "padding-top": "{c_36}",
                        "flex-direction": "{c_37}"
                    },
                    "jds_image": {
                        "flex": "0.3"
                    },
                    "jds_content_block": {
                        "flex": "0.7"
                    }
                }
            }
        },
        {
            "true": {
                "vertical": {
                    "mobile": {
                        "root-container": {
                            "width": "{c_38}"
                        }
                    }
                }
            }
        },
        {
            "horizontal": {
                "false": {
                    "jds_content_block": {
                        "flex": 1,
                        "padding-left": 0
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "condensed",
            "size"
        ],
        [
            "condensed",
            "orientation"
        ],
        [
            "condensed",
            "orientation",
            "_platform"
        ],
        [
            "orientation",
            "_hasImageProps"
        ]
    ],
    "api": {
        "children": {
            "header-slot": {
                "name": "header",
                "accepts": [
                    "jds_list_block"
                ],
                "max": 1
            },
            "children-slot": {
                "name": "children",
                "accepts": [
                    "any"
                ],
                "max": 1
            }
        },
        "config": {
            "size": {
                "values": [
                    "xtra-small",
                    "xtra-xtra-small",
                    "small",
                    "medium",
                    "large",
                    "xtra-large"
                ]
            },
            "orientation": {
                "values": [
                    "vertical",
                    "horizontal"
                ],
                "doc_description": "Horizontal orientation puts image and content side by side."
            },
            "imageRatio": {
                "values": [
                    "wide",
                    "square",
                    "landscape",
                    "portrait"
                ]
            },
            "shadow": {
                "values": [
                    true,
                    false
                ],
                "doc_description": "Toggle drop shadow"
            },
            "condensed": {
                "values": [
                    false,
                    true
                ]
            },
            "_hasHeaderSlot": {
                "values": [
                    true,
                    false
                ]
            },
            "_hasChildrenSlot": {
                "values": [
                    true,
                    false
                ]
            },
            "_hasContentBlockAndImageProps": {
                "values": [
                    true,
                    false
                ]
            },
            "_hasContentBlockProps": {
                "values": [
                    true,
                    false
                ]
            },
            "_hasImageProps": {
                "values": [
                    true,
                    false
                ]
            },
            "_platform": {
                "values": [
                    "desktop",
                    "mobile"
                ]
            }
        },
        "data": {
            "root-container": {
                "fullCardCTA": {
                    "type": "string",
                    "name": "fullCardCTA",
                    "doc_description": "When present, the entire card is clickable. If any other CTAs are sent, they will not be clickable."
                }
            },
            "jds_content_block": {
                "title": {
                    "type": "string",
                    "name": "title"
                },
                "description": {
                    "type": "string",
                    "name": "description"
                },
                "primaryCTA": {
                    "type": "string",
                    "name": "primaryCTA"
                },
                "secondaryCTA": {
                    "type": "string",
                    "name": "secondaryCTA"
                },
                "caption": {
                    "type": "slot",
                    "name": "caption",
                    "accepts": [
                        "jds_badge",
                        "jds_text",
                        "jds_tag"
                    ],
                    "function": true
                },
                "ctaWrap": {
                    "type": "JDSContentBlock.ctaWrap",
                    "name": "ctaWrap"
                },
                "isTertiary": {
                    "type": "boolean",
                    "name": "isTertiary"
                }
            },
            "jds_image": {
                "src": {
                    "type": "image",
                    "name": "image"
                },
                "alt": {
                    "type": "string",
                    "name": "imgAlt"
                },
                "title": {
                    "type": "string",
                    "name": "imgTitle"
                },
                "borderRadius": {
                    "type": "size",
                    "default": 24,
                    "name": "borderRadius"
                },
                "imageFocus": {
                    "type": "JDSImage.imageFocus",
                    "name": "imageFocus"
                }
            },
            "footer-jds-text": {
                "value": {
                    "type": "string",
                    "name": "footer"
                }
            }
        },
        "events": {
            "root-container": {
                "onClick": "onClick"
            },
            "jds_content_block": {
                "onPrimaryClick": "onPrimaryClick",
                "onSecondaryClick": "onSecondaryClick"
            }
        },
        "a11y": {
            "jds_image": {
                "properties": {
                    "ariaLabel": "imageAriaLabel",
                    "ariaDescribedby": {
                        "name": "imageAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_content_block": {
                "properties": {
                    "primaryCtaAriaLabel": "primaryCtaAriaLabel",
                    "primaryCtaAriaDescribedby": {
                        "name": "primaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    },
                    "secondaryCtaAriaLabel": "secondaryCtaAriaLabel",
                    "secondaryCtaAriaDescribedby": {
                        "name": "secondaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$PROP_MAP$5 = (props)=>{
    if (typeof props.image === "object") console.warn("passing a JSX element is deprecated. pass the image source as as string");
    if (typeof props.footer === "object") console.warn("Passing JSX.Element is deprecated. Please pass a string");
    return {
        image: {
            properties: {
                image: $fe5170bdd3625759$var$resolvePropObjectKeys(props.image, "props.src", "")
            }
        },
        size: {
            defaultValue: "xtra-small",
            variations: {
                s: {
                    size: "small"
                },
                m: {
                    size: "medium"
                },
                xs: {
                    size: "xtra-small"
                },
                xxs: {
                    size: "xtra-xtra-small"
                },
                l: {
                    size: "large"
                },
                xl: {
                    size: "xtra-large"
                }
            }
        }
    };
};
const $fe5170bdd3625759$var$withLogic$n = (Component)=>(userProps)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$5);
        const hasContentBlockProps = Boolean(props.title || props.description || props.primaryCTA || props.secondaryCTA || props.caption);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                _hasHeaderSlot: Boolean(props.header),
                _hasChildrenSlot: Boolean(props.children),
                _hasContentBlockProps: hasContentBlockProps,
                _hasImageProps: Boolean(props.image),
                _hasContentBlockAndImageProps: Boolean(hasContentBlockProps || props.image),
                _platform: $fe5170bdd3625759$var$Devices.isDesktop() ? "desktop" : "mobile",
                children: props.children ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                    style: {
                        width: "100%"
                    },
                    children: props.children
                }) : void 0
            }
        });
    };
const $fe5170bdd3625759$var$Component$p = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$m;
    const { size: size = "xtra-small", orientation: orientation = "vertical", imageRatio: imageRatio = "wide", shadow: shadow = true, condensed: condensed = false, onClick: onClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onPrimaryClick: onPrimaryClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSecondaryClick: onSecondaryClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            size: size,
            orientation: orientation,
            imageRatio: imageRatio,
            shadow: shadow,
            condensed: condensed,
            onClick: onClick,
            onPrimaryClick: onPrimaryClick,
            onSecondaryClick: onSecondaryClick,
            ...rest
        },
        componentTag: componentTag
    }, "JDSContentCard", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$60332b2344f7fe41 = $fe5170bdd3625759$var$withLogic$n($fe5170bdd3625759$var$Component$p);
$fe5170bdd3625759$export$60332b2344f7fe41.displayName = "Card";
$fe5170bdd3625759$export$60332b2344f7fe41.slotName = "jds_content_card";
const $fe5170bdd3625759$var$YEAR_COUNT = 50;
const $fe5170bdd3625759$var$withLogic$m = (Component)=>(props)=>{
        const { onClose: onClose, monthSelectable: monthSelectable = true, yearSelectable: yearSelectable = true, close: userClose = true, open: open, ...rest } = props;
        const closeProp = typeof open === "undefined" ? userClose : !open;
        const [state, setState] = (0, $acw62.useState)("default");
        const { day: day, month: month, year: year } = $fe5170bdd3625759$var$getNormalisedDate$1(props.value);
        const [selectedMonth, setSelectedMonth] = (0, $acw62.useState)(month);
        const [selectedDate, setSelectedDate] = (0, $acw62.useState)({
            date: day,
            month: month,
            year: year
        });
        const [selectedYear, setSelectedYear] = (0, $acw62.useState)(year);
        const { selected: selected, toggle: toggle, close: close } = $fe5170bdd3625759$var$useToggle(props.open, !closeProp);
        const scrollCloseListener = (0, $acw62.useCallback)(()=>{
            close();
            onClose?.();
        }, [
            close,
            onClose
        ]);
        (0, $acw62.useEffect)(()=>{
            window.addEventListener("scroll", scrollCloseListener);
            return ()=>{
                window.removeEventListener("scroll", scrollCloseListener);
            };
        }, [
            scrollCloseListener
        ]);
        (0, $acw62.useEffect)(()=>{
            const { day: day2, month: month2, year: year2 } = $fe5170bdd3625759$var$getNormalisedDate$1(props.value);
            setSelectedDate({
                date: day2,
                month: month2,
                year: year2
            });
            setSelectedYear(year2);
            setSelectedMonth(month2);
        }, [
            props.value
        ]);
        const months = $fe5170bdd3625759$var$loadedMonths(selectedMonth - 1, selectedYear, monthSelectable, props.min, props.max);
        const tokens = (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
        const language = tokens.lang;
        const confirmLabelLocal = (0, $acw62.useMemo)(()=>{
            return (0, $8bd3c5c9ee0d1eb4$export$6d8d0ec03e692fdc)(language);
        }, [
            language
        ]);
        if (!selected) return props.children;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...rest,
                confirmDate: new Date(selectedDate.year, selectedDate.month - 1, selectedDate.date).toLocaleDateString("en-GB", {
                    weekday: "short",
                    day: "2-digit",
                    month: "long",
                    year: "numeric"
                }),
                _confirmLabel: confirmLabelLocal,
                calendarData: {
                    disabledDates: props.disabledDates,
                    dateFilter: props.dateFilter,
                    min: props.min,
                    max: props.max
                },
                open: selected,
                value: new Date(selectedDate.year, selectedDate.month - 1, selectedDate.date),
                onClose: ()=>{
                    if (selected) toggle();
                    onClose?.();
                },
                onClick: (ev)=>ev.stopPropagation(),
                date: selectedDate.date,
                month: selectedMonth,
                year: selectedYear,
                monthName: [
                    selectedMonth - 1
                ]?.slice(0, 3),
                months: months,
                state: state,
                offsetX: 0,
                offsetY: 0,
                yearData: {
                    count: $fe5170bdd3625759$var$YEAR_COUNT,
                    min: selectedYear - $fe5170bdd3625759$var$YEAR_COUNT / 2,
                    max: selectedYear + $fe5170bdd3625759$var$YEAR_COUNT / 2,
                    disabled: $fe5170bdd3625759$var$getDisabledYears(selectedYear - $fe5170bdd3625759$var$YEAR_COUNT / 2, selectedYear + $fe5170bdd3625759$var$YEAR_COUNT / 2, props.min, props.max)
                },
                _onYearClick: ()=>setState("year_view"),
                _onMonthClick: ()=>setState("month_view"),
                _onBack: ()=>setState("default"),
                onSelect: (num, disabled)=>{
                    if (!disabled) setSelectedDate({
                        date: num,
                        month: selectedMonth,
                        year: selectedYear
                    });
                    setState("default");
                },
                _onConfirm: ()=>{
                    props.onSelect?.(new Date(selectedDate.year, selectedDate.month, selectedDate.date));
                    props.onChange?.(new Date(selectedDate.year, selectedDate.month, selectedDate.date));
                    props.onConfirm?.(new Date(selectedDate.year, selectedDate.month, selectedDate.date));
                    close();
                    onClose?.();
                },
                _onMonthSelect: (i)=>{
                    if (monthSelectable) {
                        setSelectedMonth(i);
                        setState("default");
                        props.onMonthSelect?.();
                    }
                },
                _onYearSelect: (i)=>{
                    if (yearSelectable) {
                        setSelectedYear(i);
                        setState("default");
                        props.onYearSelect?.();
                    }
                },
                _onPrev: ()=>setSelectedMonth((m)=>{
                        if (m === 1) {
                            setSelectedYear(selectedYear - 1);
                            return 12;
                        }
                        return m - 1;
                    }),
                _onNext: ()=>setSelectedMonth((m)=>{
                        if (m === 12) {
                            setSelectedYear(selectedYear + 1);
                            return 1;
                        }
                        return m + 1;
                    })
            },
            children: props.children
        });
    };
const $fe5170bdd3625759$var$Component$o = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1M;
    const { state: state = "default", open: open = false, onClose: onClose = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onConfirm: onConfirm = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            state: state,
            open: open,
            onClose: onClose,
            onConfirm: onConfirm,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDatepickerMobile", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$92b06b9488028257 = $fe5170bdd3625759$var$withLogic$m($fe5170bdd3625759$var$Component$o);
$fe5170bdd3625759$export$92b06b9488028257.displayName = "DatepickerMobile";
$fe5170bdd3625759$export$92b06b9488028257.slotName = "jds_datepicker_mobile";
const $fe5170bdd3625759$var$withLogic$l = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$n = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1G;
    const { state: state = "default", open: open = false, onClose: onClose = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onConfirm: onConfirm = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), previousButtonAriaLabel: previousButtonAriaLabel = "Tap to Return", closeAriaLabel: closeAriaLabel = "Tap to Close", confirmAriaLabel: confirmAriaLabel = "Tap to Confirm", custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            state: state,
            open: open,
            onClose: onClose,
            onConfirm: onConfirm,
            previousButtonAriaLabel: previousButtonAriaLabel,
            closeAriaLabel: closeAriaLabel,
            confirmAriaLabel: confirmAriaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDatepickerMobileInternal", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$8d28dfe32d652778 = $fe5170bdd3625759$var$withLogic$l($fe5170bdd3625759$var$Component$n);
$fe5170bdd3625759$export$8d28dfe32d652778.displayName = "DatepickerMobileInternal";
$fe5170bdd3625759$export$8d28dfe32d652778.slotName = "jds_datepicker_mobile_internal";
const $fe5170bdd3625759$var$sdl$l = {
    "metadata": {
        "version": "1.0.0",
        "id": "dropdown-1.0.0",
        "name": "JDSDropdown",
        "layerName": "jds_dropdown",
        "description": "Dropdowns allow users to choose from a list of options presented contextually as a list. A dropdown in this document is a combination of a trigger and an options popup.",
        "usage": "Dropdowns are used when you want users to take an action or provide input."
    },
    "hierarchy": {
        "container": [
            "label-border-jds-text",
            {
                "field-container": [
                    "label-jds-text",
                    {
                        "select-container": [
                            {
                                "text-container": [
                                    {
                                        "prefix-icon-container": [
                                            "prefix-icon"
                                        ]
                                    },
                                    "current-jds-text",
                                    "placeholder-jds-text"
                                ]
                            },
                            {
                                "chevron-jds-icon-container": [
                                    "chevron-jds-icon"
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "active-line-container": [
                    "feedback-container"
                ]
            },
            "jds_feedback_block",
            "helper-jds-text",
            "jds_menu_block"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{d_0}",
            "gap": "{d_1}",
            "width": "{d_2}",
            "justify-content": "{d_3}",
            "align-items": "{d_4}",
            "behavior": {
                "hover": {}
            },
            "opacity": "{d_37}"
        },
        "field-container": {
            "flex-direction": "{d_5}",
            "width": "{d_6}",
            "align-items": "{d_7}",
            "justify-content": "{d_8}",
            "padding-bottom": "{d_9}"
        },
        "text-container": {
            "flex-direction": "{d_10}",
            "overflow": "hidden",
            "flex": 1,
            "hidden": false,
            "gap": "{d_11}"
        },
        "select-container": {
            "flex-direction": "{d_12}",
            "justify-content": "{d_13}",
            "width": "{d_14}",
            "padding-top": 20,
            "align-items": "{d_15}",
            "z-index": 0
        },
        "active-line-container": {
            "flex-direction": "{d_16}",
            "width": "{d_17}",
            "align-items": "{d_18}",
            "padding-top": 1,
            "padding-bottom": 1
        },
        "feedback-container": {
            "width": "{d_19}",
            "height": 2,
            "background-color": "{d_20}",
            "border-radius": 48,
            "show": true,
            "hidden": false,
            "behavior": {
                "hover": {
                    "background-color": "{d_21}"
                },
                "focus": {
                    "background-color": "{d_22}"
                },
                "active": {
                    "background-color": "{d_23}"
                }
            }
        },
        "jds_feedback_block": {
            "size": "s",
            "state": "none"
        },
        "jds_menu_block": {
            "open": false
        },
        "prefix-icon-container": {
            "hidden": true
        },
        "prefix-icon": {
            "size": "{d_34}",
            "color": "{d_35}"
        },
        "label-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 1,
            "maxLines": 1,
            "z-index": 1
        },
        "label-border-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 1,
            "hidden": true,
            "maxLines": 1
        },
        "current-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey100}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 1,
            "hidden": true,
            "maxLines": 1
        },
        "placeholder-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        },
        "chevron-jds-icon": {
            "size": "{m}",
            "color": "{primaryGrey80}",
            "value": "ic_chevron_down",
            "ic": "ic_chevron_down"
        },
        "chevron-jds-icon-container": {
            "background-color": "{global.transparent}",
            "border-radius": "{pill}",
            "size": "{m}",
            "justify-content": "{justifyContent.center}",
            "align-items": "{alignItems.center}",
            "ic": "ic_chevron_down"
        },
        "helper-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "border": {
            "true": {
                "feedback-container": {
                    "hidden": true
                },
                "field-container": {
                    "label-jds_text": {
                        "hidden": true
                    }
                },
                "select-container": {
                    "height": "{d_51}",
                    "border-width": "{d_24}",
                    "border-color": "{d_25}",
                    "border-radius": "{d_26}",
                    "background-color": "{d_50}",
                    "padding-top": "{d_27}",
                    "padding-bottom": "{d_28}",
                    "padding-left": "{d_29}",
                    "padding-right": "{d_30}",
                    "behavior": {
                        "hover": {
                            "background-color": "{d_31}"
                        },
                        "focus": {
                            "background-color": "{d_32}"
                        },
                        "active": {
                            "background-color": "{d_33}"
                        }
                    }
                },
                "label-jds-text": {
                    "hidden": true
                },
                "label-border-jds-text": {
                    "hidden": false
                }
            }
        },
        "open": {
            "true": {
                "jds_menu_block": {
                    "open": true
                },
                "chevron-jds-icon": {
                    "value": "ic_chevron_up",
                    "ic": "ic_chevron_up"
                },
                "chevron-jds-icon-container": {
                    "background-color": "{global.transparent}",
                    "border-radius": "{pill}",
                    "size": "{m}",
                    "justify-content": "{justifyContent.center}",
                    "align-items": "{alignItems.center}",
                    "ic": "ic_chevron_up"
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{d_36}"
                },
                "select-container": {
                    "disabled": true
                }
            }
        },
        "state": {
            "success": {
                "feedback-container": {
                    "background-color": "{d_38}",
                    "behavior": {
                        "hover": {
                            "background-color": "{d_39}"
                        },
                        "focus": {
                            "background-color": "{d_40}"
                        },
                        "active": {
                            "background-color": "{d_41}"
                        }
                    }
                },
                "select-container": {
                    "border-color": "{d_38}"
                },
                "jds_feedback_block": {
                    "state": "success"
                }
            },
            "error": {
                "feedback-container": {
                    "background-color": "{d_42}",
                    "behavior": {
                        "hover": {
                            "background-color": "{d_43}"
                        },
                        "focus": {
                            "background-color": "{d_44}"
                        },
                        "active": {
                            "background-color": "{d_45}"
                        }
                    }
                },
                "select-container": {
                    "border-color": "{d_42}"
                },
                "jds_feedback_block": {
                    "state": "error"
                }
            },
            "warning": {
                "feedback-container": {
                    "background-color": "{d_46}",
                    "behavior": {
                        "hover": {
                            "background-color": "{d_47}"
                        },
                        "focus": {
                            "background-color": "{d_48}"
                        },
                        "active": {
                            "background-color": "{d_49}"
                        }
                    }
                },
                "select-container": {
                    "border-color": "{d_46}"
                },
                "jds_feedback_block": {
                    "state": "warning"
                }
            }
        },
        "_isLabelEmpty": {
            "true": {
                "label-jds-text": {
                    "hidden": true
                }
            }
        },
        "_isPlaceHolderEmpty": {
            "true": {
                "placeholder-jds-text": {
                    "hidden": true
                }
            }
        },
        "_isValueEmpty": {
            "false": {
                "current-jds-text": {
                    "hidden": false
                },
                "placeholder-jds-text": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {
            "true": {
                "true": {
                    "field-container": {
                        "align-items": "{d_52}"
                    },
                    "prefix-icon-container": {
                        "hidden": false
                    },
                    "label-jds-text": {
                        "font-family": "{bodyXs}",
                        "font-size": "{bodyXs}",
                        "line-height": "{bodyXs}",
                        "letter-spacing": "{bodyXs}",
                        "font-weight": "{bodyXs}",
                        "padding-left": 0
                    }
                },
                "false": {
                    "field-container": {
                        "align-items": "{d_53}"
                    },
                    "label-jds-text": {
                        "font-family": "{bodyXs}",
                        "font-size": "{bodyXs}",
                        "line-height": "{bodyXs}",
                        "letter-spacing": "{bodyXs}",
                        "font-weight": "{bodyXs}",
                        "padding-left": 0
                    }
                }
            },
            "false": {
                "true": {
                    "field-container": {
                        "align-items": "{d_54}"
                    },
                    "prefix-icon-container": {
                        "hidden": false
                    },
                    "label-jds-text": {
                        "padding-left": "{d_55}"
                    }
                },
                "false": {
                    "field-container": {
                        "align-items": "{d_56}"
                    },
                    "label-jds-text": {
                        "padding-left": 0
                    }
                }
            }
        },
        {
            "none": {
                "true": {
                    "feedback-container": {
                        "background-color": "{d_58}"
                    }
                }
            }
        },
        {
            "false": {
                "true": {
                    "select-container": {
                        "padding-left": "{d_57}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "_labelFocus",
            "_hasPrefix"
        ],
        [
            "state",
            "_inputFocus"
        ],
        [
            "_hasPrefix",
            "border"
        ]
    ],
    "api": {
        "config": {
            "open": {
                "values": [
                    false,
                    true
                ]
            },
            "border": {
                "values": [
                    false,
                    true
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            },
            "state": {
                "type": "JDSFeedbackBlock.state",
                "values": [
                    "none",
                    "success",
                    "error",
                    "warning"
                ]
            },
            "_labelFocus": {
                "values": [
                    false,
                    true
                ]
            },
            "_inputFocus": {
                "values": [
                    false,
                    true
                ]
            },
            "_hasPrefix": {
                "values": [
                    false,
                    true
                ]
            },
            "_isLabelEmpty": {
                "values": [
                    false,
                    true
                ]
            },
            "_isPlaceHolderEmpty": {
                "values": [
                    false,
                    true
                ]
            },
            "_isValueEmpty": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds_feedback_block": {
                "stateText": {
                    "type": "string",
                    "name": "stateText"
                }
            },
            "prefix-icon": {
                "value": {
                    "type": "icon",
                    "name": "prefix"
                }
            },
            "jds_menu_block": {
                "items": {
                    "type": "list",
                    "name": "items",
                    "doc_description": "This should pass down values to MenuBlock\u2019s items prop. selected determines the default selected value currently.",
                    "object": {
                        "type": "JDSMenuBlockItem.type",
                        "label": "string",
                        "value": "string",
                        "prefix": "icon",
                        "suffix": "icon",
                        "disabled": "boolean"
                    }
                },
                "selectedIndex": {
                    "type": "number",
                    "name": "selectedIndex"
                },
                "offsetX": {
                    "type": "size",
                    "name": "_offsetX"
                },
                "offsetY": {
                    "type": "size",
                    "name": "_offsetY"
                },
                "minWidth": {
                    "type": "size",
                    "name": "_minWidth"
                },
                "maxWidth": {
                    "type": "size",
                    "name": "_maxWidth"
                },
                "maxHeight": {
                    "type": "size",
                    "name": "_maxHeight"
                }
            },
            "label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            },
            "label-border-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            },
            "current-jds-text": {
                "value": {
                    "type": "string",
                    "name": "current"
                }
            },
            "placeholder-jds-text": {
                "value": {
                    "type": "string",
                    "name": "placeholder"
                }
            },
            "helper-jds-text": {
                "value": {
                    "type": "string",
                    "name": "helperText"
                }
            }
        },
        "events": {
            "active-line-container": {
                "onAppear": {
                    "name": "_onAppear",
                    "platform": "ios"
                }
            },
            "select-container": {
                "onClick": "onOpen"
            },
            "jds_menu_block": {
                "onSelect": "onSelect",
                "onClose": "onClose"
            }
        },
        "a11y": {
            "select-container": {
                "properties": {
                    "role": {
                        "value": "combobox"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "aria-expanded": {
                        "name": "_ariaExpanded",
                        "prop": "open"
                    },
                    "aria-controls": {
                        "name": "ariaControls",
                        "value": "container"
                    }
                }
            },
            "jds_menu_block": {
                "name": "items",
                "repeating": {
                    "ariaLabel": "itemAriaLabel",
                    "ariaDescribedby": {
                        "name": "itemAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$PROP_MAP$4 = (props)=>{
    return {
        state: {
            properties: {
                state: props.state
            },
            variations: {
                error: {
                    stateText: props.stateConfig?.errorText || props.stateText
                },
                success: {
                    stateText: props.stateConfig?.successText || props.stateText
                },
                warning: {
                    stateText: props.stateConfig?.warningText || props.stateText
                },
                required: {
                    stateText: props.stateConfig?.requiredText
                }
            }
        },
        items: {
            properties: {
                items: props.items || []
            }
        }
    };
};
const $fe5170bdd3625759$var$SELECT_CONTAINER_SELECTOR = 'div[data-testid="JDSDropdown-select-container"]';
const $fe5170bdd3625759$var$OFFSET = 12;
const $fe5170bdd3625759$var$withLogic$k = (Component)=>(userProps)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$4);
        const [distance, setDistance] = (0, $acw62.useState)({
            x: 0,
            y: 0,
            width: 0,
            height: 0
        });
        const [isPositionReady, setIsPositionReady] = (0, $acw62.useState)(false);
        const { selectedIndex: selectedIndex, items: items = [], onSelect: onSelect } = props;
        const { index: index, onClick: onClick } = $fe5170bdd3625759$var$useSelected(selectedIndex);
        const { selected: selected, toggle: toggle, close: close } = $fe5170bdd3625759$var$useToggle(false);
        const { element: element, rootRef: rootRef } = $fe5170bdd3625759$var$useRootRef();
        const selectContainer = element?.querySelector($fe5170bdd3625759$var$SELECT_CONTAINER_SELECTOR);
        const calculatePositions = ()=>{
            if (selectContainer) {
                const { height: height, left: x, top: y, width: width = 0 } = $fe5170bdd3625759$var$setPositions(selectContainer, void 0);
                setDistance({
                    x: x,
                    y: y,
                    width: width,
                    height: height
                });
                setIsPositionReady(true);
            }
        };
        const handleOpen = ()=>{
            calculatePositions();
            toggle(true);
        };
        (0, $acw62.useEffect)(()=>{
            if (!selected) {
                setIsPositionReady(false);
                selectContainer?.focus?.();
            }
        }, [
            selected
        ]);
        const hasPrefix = Boolean(props.prefix);
        const currentIdx = props.value ? items.findIndex((item)=>item.value === props.value) : index;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                label: $fe5170bdd3625759$var$getRequiredLabel(props.label, props.required),
                current: items[currentIdx]?.label,
                open: selected && isPositionReady,
                onSelect: (index2)=>{
                    onClick(index2);
                    onSelect?.(index2, items[index2]?.value || items[index2]?.label);
                },
                rootRef: rootRef,
                _hasPrefix: hasPrefix,
                _inputFocus: currentIdx >= 0,
                selectedIndex: currentIdx,
                onClose: ()=>{
                    close();
                    props.onClose?.();
                },
                onOpen: ()=>{
                    handleOpen();
                    props.onOpen?.();
                },
                _labelFocus: Boolean(currentIdx >= 0 || props.placeholder),
                _offsetX: distance.x,
                _offsetY: distance.y + $fe5170bdd3625759$var$OFFSET,
                _maxWidth: distance.width,
                _maxHeight: distance.height,
                _isValueEmpty: !items[currentIdx]?.label,
                _isPlaceHolderEmpty: !props.placeholder
            }
        });
    };
const $fe5170bdd3625759$var$Component$m = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$l;
    const { open: open = false, border: border = false, disabled: disabled = false, state: state = "undefined", onOpen: onOpen = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSelect: onSelect = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onClose: onClose = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), ariaLabel: ariaLabel = props.label?.toString(), ariaControls: ariaControls = "container", _ariaExpanded: _ariaExpanded = props.open?.toString(), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            open: open,
            border: border,
            disabled: disabled,
            state: state,
            onOpen: onOpen,
            onSelect: onSelect,
            onClose: onClose,
            ariaLabel: ariaLabel,
            ariaControls: ariaControls,
            _ariaExpanded: _ariaExpanded,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDropdown", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$4ca664383a1d455a = $fe5170bdd3625759$var$withLogic$k($fe5170bdd3625759$var$Component$m);
$fe5170bdd3625759$export$4ca664383a1d455a.displayName = "InputDropdown";
$fe5170bdd3625759$export$4ca664383a1d455a.slotName = "jds_dropdown";
const $fe5170bdd3625759$var$sdl$k = {
    "metadata": {
        "version": "1.0.0",
        "id": "dropdown-menu-item-1.0.0",
        "name": "JDSDropdownMenuItemMobile",
        "platform": "android",
        "layerName": "jds_dropdown_menu_item_mobile",
        "internal": true
    },
    "hierarchy": {
        "root-container": [
            {
                "container": [
                    {
                        "prefix-container": [
                            "prefix-slot"
                        ]
                    },
                    {
                        "content-container": [
                            "label-jds-text",
                            "description-jds-text"
                        ]
                    },
                    {
                        "suffix-container": [
                            "suffix-jds-text",
                            "icon"
                        ]
                    }
                ]
            },
            {
                "jds_dropdown_menu_submenu": [
                    "menu-group-slot"
                ]
            }
        ]
    },
    "base": {
        "root-container": {
            "hidden": false,
            "width": "{d_24}"
        },
        "container": {
            "hidden": false,
            "flex-direction": "{d_1}",
            "align-items": "{d_16}",
            "gap": "{d_3}",
            "background-color": "{d_4}",
            "width": "{d_0}",
            "padding-top": "{d_8}",
            "padding-right": "{d_9}",
            "padding-bottom": "{d_10}",
            "padding-left": "{d_11}",
            "opacity": "",
            "behavior": {
                "hover": {
                    "background-color": "{d_5}"
                },
                "active": {
                    "background-color": "{d_6}"
                },
                "focus": {
                    "border-radius": "{d_23}"
                }
            }
        },
        "menu-group-slot": {
            "hidden": false
        },
        "suffix-container": {
            "hidden": false
        },
        "prefix-container": {
            "hidden": false,
            "align-self": "{d_17}"
        },
        "prefix-slot": {
            "hidden": false
        },
        "content-container": {
            "hidden": false,
            "flex": 1,
            "overflow": "hidden",
            "justify-content": "{d_14}",
            "align-items": "{d_15}",
            "flex-direction": "{d_2}"
        },
        "icon": {
            "size": "{d_19}",
            "color": "{d_18}",
            "value": "ic_chevron_right",
            "behavior": {
                "active": {
                    "color": "{d_20}"
                }
            },
            "hidden": true
        },
        "jds_dropdown_menu_submenu": {
            "hidden": true
        },
        "label-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey100}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false,
            "behavior": {
                "active": {
                    "color": "{primaryInverse}"
                }
            }
        },
        "description-jds-text": {
            "font-family": "{bodyXxs}",
            "color": "{primaryGrey100}",
            "font-size": "{bodyXxs}",
            "line-height": "{bodyXxs}",
            "letter-spacing": "{bodyXxs}",
            "font-weight": "{bodyXxs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false,
            "behavior": {
                "active": {
                    "color": "{primaryInverse}"
                }
            }
        },
        "suffix-jds-text": {
            "font-family": "{bodyXxs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXxs}",
            "line-height": "{bodyXxs}",
            "letter-spacing": "{bodyXxs}",
            "font-weight": "{bodyXxs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false,
            "behavior": {
                "active": {
                    "color": "{primaryInverse}"
                }
            }
        }
    },
    "variant": {
        "_labelTextWrap": {
            "false": {
                "label-jds-text": {
                    "max-lines": 1,
                    "maxLines": 1
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{d_22}"
                }
            }
        },
        "selected": {
            "true": {
                "container": {
                    "background-color": "{d_12}",
                    "behavior": {
                        "hover": {
                            "background-color": "{d_13}"
                        }
                    }
                },
                "icon": {
                    "color": "{d_21}"
                },
                "label-jds-text": {
                    "color": "{primaryInverse}"
                },
                "description-jds-text": {
                    "color": "{primaryInverse}"
                },
                "suffix-jds-text": {
                    "color": "{primaryInverse}"
                }
            }
        },
        "_hasSubMenu": {
            "true": {
                "icon": {
                    "hidden": false
                },
                "suffix-jds-text": {
                    "hidden": true
                }
            }
        }
    },
    "api": {
        "children": {
            "prefix-slot": {
                "name": "prefix",
                "accepts": [
                    "jds_image",
                    "jds_avatar",
                    "jds_icon"
                ],
                "max": 1
            },
            "menu-group-slot": {
                "name": "children",
                "accepts": [
                    "jds_dropdown_menu_group"
                ]
            }
        },
        "events": {
            "container": {
                "onClick": "onClick"
            }
        },
        "data": {
            "jds_dropdown_menu_submenu": {
                "offsetX": {
                    "type": "string",
                    "name": "_offsetX"
                },
                "offsetY": {
                    "type": "string",
                    "name": "_offsetY"
                },
                "children": {
                    "type": "slot",
                    "name": "children"
                }
            },
            "label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            },
            "description-jds-text": {
                "value": {
                    "type": "string",
                    "name": "description"
                }
            },
            "suffix-jds-text": {
                "value": {
                    "type": "string",
                    "name": "suffix"
                }
            }
        },
        "config": {
            "selected": {
                "values": [
                    false,
                    true
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            },
            "_hasSubMenu": {
                "values": [
                    false,
                    true
                ]
            },
            "_labelTextWrap": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "menuitem"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-haspopup": {
                        "name": "_ariaHaspopup",
                        "prop": "_hasSubMenu"
                    },
                    "aria-expanded": {
                        "name": "_ariaExpanded",
                        "prop": "selected"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$j = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$l = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$k;
    const { selected: selected = false, disabled: disabled = false, onClick: onClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), ariaLabel: ariaLabel = props.label?.toString(), _ariaHaspopup: _ariaHaspopup = props._hasSubMenu?.toString(), _ariaExpanded: _ariaExpanded = props.selected?.toString(), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            selected: selected,
            disabled: disabled,
            onClick: onClick,
            ariaLabel: ariaLabel,
            _ariaHaspopup: _ariaHaspopup,
            _ariaExpanded: _ariaExpanded,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDropdownMenuItemMobile", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$7d15013c6b8c3bad = $fe5170bdd3625759$var$withLogic$j($fe5170bdd3625759$var$Component$l);
$fe5170bdd3625759$export$7d15013c6b8c3bad.displayName = "DropdownMenuItemMobile";
$fe5170bdd3625759$export$7d15013c6b8c3bad.slotName = "jds_dropdown_menu_item_mobile";
const $fe5170bdd3625759$var$sdl$j = {
    "metadata": {
        "version": "1.0.0",
        "id": "file-uploader-1.0.0",
        "name": "JDSFileUploader",
        "layerName": "jds_file_uploader"
    },
    "hierarchy": {
        "container": [
            "jds_file_uploader_control",
            "jds_file_uploader_panel"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{f_0}",
            "justify-content": "{f_1}",
            "align-items": "{f_2}",
            "width": "{f_3}",
            "gap": "{f_4}",
            "opacity": "{f_5}"
        }
    },
    "variant": {
        "kind": {
            "collapsible": {
                "jds_file_uploader_panel": {
                    "kind": "collapsible"
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "kind": {
                "type": "JDSFileUploaderPanel.kind",
                "values": [
                    "classic",
                    "collapsible"
                ]
            },
            "expanded": {
                "values": [
                    false,
                    true
                ]
            },
            "showDivider": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "jds_file_uploader_control": {
                "label": {
                    "type": "string",
                    "name": "label"
                },
                "helperText": {
                    "type": "string",
                    "name": "helperText"
                },
                "uploadButtonLabel": {
                    "type": "string",
                    "name": "uploadButtonLabel"
                }
            },
            "jds_file_uploader_panel": {
                "message": {
                    "type": "string",
                    "name": "message"
                },
                "value": {
                    "type": "float",
                    "name": "value"
                },
                "showDivider": {
                    "type": "boolean",
                    "name": "showDivider"
                },
                "expanded": {
                    "type": "boolean",
                    "name": "expanded"
                },
                "items": {
                    "type": "list",
                    "name": "items",
                    "object": {
                        "state": "JDSFileUploaderItem.state",
                        "message": "string"
                    }
                }
            }
        },
        "events": {
            "jds_file_uploader_control": {
                "onInfoClick": "onInfoClick",
                "onClick": "onClick"
            },
            "jds_file_uploader_panel": {
                "onClick": "onExpand",
                "onClose": "onClose"
            }
        },
        "a11y": {
            "jds_file_uploader_control": {
                "properties": {
                    "uploadButtonAriaLabel": "uploadButtonAriaLabel"
                }
            },
            "jds_file_uploader_panel": {
                "properties": {
                    "panelAriaLabel": "panelAriaLabel",
                    "panelAriaDescribedBy": {
                        "name": "panelAriaDescribedBy",
                        "platform": "web,ios"
                    },
                    "panelSuffixAriaLabel": "panelSuffixAriaLabel"
                },
                "name": "items",
                "repeating": {
                    "ariaLabel": "itemAriaLabel",
                    "ariaDescribedby": {
                        "name": "itemAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$i = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$k = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$j;
    const { kind: kind = "undefined", expanded: expanded = false, showDivider: showDivider = true, onInfoClick: onInfoClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onClick: onClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onExpand: onExpand = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onClose: onClose = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            expanded: expanded,
            showDivider: showDivider,
            onInfoClick: onInfoClick,
            onClick: onClick,
            onExpand: onExpand,
            onClose: onClose,
            ...rest
        },
        componentTag: componentTag
    }, "JDSFileUploader", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$1a5cb5295a7d2749 = $fe5170bdd3625759$var$withLogic$i($fe5170bdd3625759$var$Component$k);
$fe5170bdd3625759$export$1a5cb5295a7d2749.displayName = "FileUploader";
$fe5170bdd3625759$export$1a5cb5295a7d2749.slotName = "jds_file_uploader";
const $fe5170bdd3625759$var$sdl$i = {
    "metadata": {
        "version": "1.0.0",
        "id": "footer-1.0.0",
        "name": "JDSFooter",
        "layerName": "jds_footer",
        "platform": "web"
    },
    "hierarchy": {
        "container": [
            {
                "main-container": [
                    {
                        "content-container": [
                            "content-slot"
                        ]
                    },
                    {
                        "social-links-container": [
                            "jds_footer_icon_links",
                            "jds_footer_market_links"
                        ]
                    }
                ]
            },
            {
                "bottom-container": [
                    "jds_divider",
                    "jds_bottom_footer"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{f_0}",
            "align-items": "{f_1}",
            "size": "{f_2}",
            "background-color": "{f_3}"
        },
        "main-container": {
            "flex-direction": "{f_4}",
            "justify-content": "{f_5}",
            "align-items": "{f_6}",
            "gap": "{f_7}",
            "size": "{f_8}",
            "padding-top": "{f_9}",
            "padding-bottom": "{f_10}",
            "padding-left": "{f_11}",
            "padding-right": "{f_12}"
        },
        "social-links-container": {
            "padding-top": "{f_13}",
            "flex-direction": "{f_14}",
            "gap": "{f_15}",
            "width": "{f_28}"
        },
        "bottom-container": {
            "flex-direction": "{f_16}",
            "align-items": "{f_17}",
            "width": "{f_18}",
            "gap": 0
        },
        "jds_divider": {
            "pad": "none"
        },
        "jds_bottom_footer": {
            "_platform": "desktop"
        },
        "content-container": {
            "width": "{f_19}"
        },
        "content-slot": {
            "width": "{f_20}"
        }
    },
    "variant": {
        "_platform": {
            "mobile": {
                "bottom-container": {
                    "gap": "{f_21}"
                },
                "jds_bottom_footer": {
                    "_platform": "mobile"
                },
                "main-container": {
                    "flex-direction": "{f_22}",
                    "justify-content": "{f_23}",
                    "padding-top": "{f_24}",
                    "padding-bottom": "{f_25}",
                    "padding-left": "{f_26}",
                    "padding-right": "{f_27}"
                }
            }
        },
        "_hasMainContainerProps": {
            "false": {
                "main-container": {
                    "hidden": true
                }
            }
        },
        "_hasContentSlot": {
            "false": {
                "content-container": {
                    "hidden": true
                }
            }
        },
        "_hasSocialLinksContainer": {
            "false": {
                "social-links-container": {
                    "hidden": true
                }
            }
        },
        "_hasFooterIconLinks": {
            "false": {
                "jds_footer_icon_links": {
                    "hidden": true
                }
            }
        }
    },
    "api": {
        "config": {
            "_platform": {
                "values": [
                    "desktop",
                    "mobile"
                ]
            },
            "_hasMainContainerProps": {
                "values": [
                    true,
                    false
                ]
            },
            "_hasContentSlot": {
                "values": [
                    true,
                    false
                ]
            },
            "_hasSocialLinksContainer": {
                "values": [
                    true,
                    false
                ]
            },
            "_hasFooterIconLinks": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "children": {
            "content-slot": {
                "name": "children",
                "accepts": [
                    "any"
                ]
            }
        },
        "data": {
            "main_container": {
                "value": {
                    "name": "links",
                    "type": "object",
                    "object": {
                        "links": "list"
                    }
                }
            },
            "social-links-container": {
                "marketplace": {
                    "type": "object",
                    "name": "marketplace",
                    "object": {
                        "assets": "JDSFooterMarketLinks.assets",
                        "title": "string"
                    }
                },
                "social": {
                    "type": "object",
                    "name": "social",
                    "object": {
                        "links": "JDSFooterIconLinks.links",
                        "title": "string"
                    }
                }
            },
            "jds_footer_icon_links": {
                "links": {
                    "name": "social.links",
                    "type": "list"
                },
                "title": {
                    "name": "social.title",
                    "type": "string"
                }
            },
            "jds_footer_market_links": {
                "assets": {
                    "name": "marketplace.assets",
                    "type": "list"
                },
                "title": {
                    "name": "marketplace.title",
                    "type": "string"
                }
            },
            "jds_bottom_footer": {
                "copyright": {
                    "type": "JDSBottomFooter.copyright",
                    "name": "copyright"
                },
                "copyrightText": {
                    "type": "string",
                    "name": "copyrightText"
                },
                "informationalLinks": {
                    "type": "JDSBottomFooter.informationalLinks",
                    "name": "bottomLinks"
                },
                "logo": {
                    "type": "icon",
                    "name": "logo"
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "name": "role"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "value": "Footer"
                    }
                }
            },
            "jds_bottom_footer": {
                "properties": {
                    "copyRightAriaLabel": "copyRightAriaLabel",
                    "copyRightAriaDescribedby": {
                        "name": "copyRightAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$PROP_MAP$3 = (props)=>({
        marketplace: {
            properties: {
                title: props.marketplace?.title,
                assets: props.marketplace?.stores?.map((store)=>({
                        image: store.badgeAsset,
                        href: store.href
                    }))
            }
        },
        mainLinks: {
            properties: {
                links: props.mainLinks?.map((l)=>({
                        title: l.heading,
                        subLinks: l.links
                    }))
            }
        }
    });
const $fe5170bdd3625759$var$FooterAccordion = (props)=>{
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$a766cd26d0d69044, {
        allowMultiple: true,
        children: props.links?.map((link)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$7cad6f17fd6e117b, {
                header: link.title,
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$553910ef0cc96026, {
                    links: link.subLinks
                })
            }, link.title))
    });
};
const $fe5170bdd3625759$var$withLogic$h = (Component)=>(userProps)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$3);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                _platform: $fe5170bdd3625759$var$Devices.isDesktop() ? "desktop" : "mobile",
                _hasMainContainerProps: Boolean(props.marketplace || props.links || props.social),
                copyright: props.copyright,
                _hasContentSlot: Boolean(props.links),
                _hasFooterIconLinks: Boolean(props.social),
                _hasSocialLinksContainer: Boolean(props.social || props.marketplace),
                children: $fe5170bdd3625759$var$Devices.isDesktop() ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$e5275d44ac937bc0, {
                    links: props.links
                }) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$var$FooterAccordion, {
                    links: props.links
                })
            }
        });
    };
const $fe5170bdd3625759$var$Component$j = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$i;
    const { ariaLabel: ariaLabel = "Footer", custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSFooter", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$a06f1c675e846f6f = $fe5170bdd3625759$var$withLogic$h($fe5170bdd3625759$var$Component$j);
$fe5170bdd3625759$export$a06f1c675e846f6f.displayName = "Footer";
$fe5170bdd3625759$export$a06f1c675e846f6f.slotName = "jds_footer";
const $fe5170bdd3625759$var$sdl$h = {
    "metadata": {
        "version": "1.0.0",
        "id": "header-mobile-1.0.0",
        "name": "JDSHeaderMobile",
        "layerName": "jds_header_mobile"
    },
    "hierarchy": {
        "container": [
            {
                "header-container": [
                    {
                        "left-container": [
                            "prefix-jds_button",
                            {
                                "prefix-container": [
                                    {
                                        "logo-container": [
                                            "logo-slot",
                                            "logo-jds-text"
                                        ]
                                    },
                                    "prefix-slot",
                                    "name-jds-text"
                                ]
                            }
                        ]
                    },
                    {
                        "right-container": [
                            "jds_search_box",
                            {
                                "suffix-container": [
                                    "search-jds_action_button",
                                    {
                                        "icon-links-container": [
                                            "icon-links-jds_button"
                                        ]
                                    },
                                    "avatar-slot"
                                ]
                            },
                            "suffix-jds_action_button",
                            "suffix-slot"
                        ]
                    }
                ]
            },
            "jds_search_results",
            "tabs-slot"
        ]
    },
    "base": {
        "container": {
            "min-width": "{h_0}",
            "flex-direction": "{h_1}"
        },
        "header-container": {
            "min-width": "{h_2}",
            "width": "{h_3}",
            "background-color": "{h_4}",
            "flex-direction": "{h_5}",
            "justify-content": "{h_6}",
            "align-items": "{h_7}",
            "padding-left": "{h_43}",
            "padding-top": "{h_9}",
            "padding-right": "{h_44}",
            "padding-bottom": "{h_11}",
            "height": "{h_13}",
            "gap": "{h_45}"
        },
        "left-container": {
            "flex-direction": "{h_14}",
            "justify-content": "{h_15}",
            "align-items": "{h_16}"
        },
        "prefix-container": {
            "flex-direction": "{h_18}",
            "justify-content": "{h_19}",
            "align-items": "{h_20}",
            "gap": "{h_21}"
        },
        "prefix-jds_button": {
            "size": "medium"
        },
        "logo-container": {
            "hidden": false,
            "flex-direction": "{h_22}",
            "justify-content": "{h_23}",
            "align-items": "{h_24}",
            "gap": "{h_25}"
        },
        "jds_search_box": {
            "prefix": "ic_search",
            "kind": "header",
            "flex": 1
        },
        "right-container": {
            "flex-direction": "{h_31}",
            "justify-content": "{h_32}",
            "align-items": "{h_33}",
            "gap": "{h_47}"
        },
        "suffix-container": {
            "flex-direction": "{h_35}",
            "justify-content": "{h_36}",
            "align-items": "{h_37}",
            "gap": "{h_48}"
        },
        "suffix-jds_action_button": {
            "hidden": true,
            "icon": "ic_close",
            "size": "medium"
        },
        "icon-links-container": {
            "flex-direction": "{h_39}",
            "justify-content": "{h_40}",
            "align-items": "{h_41}",
            "gap": "{h_42}",
            "hidden": false
        },
        "icon-links-jds_button": {
            "size": "medium"
        },
        "search-jds_action_button": {
            "hidden": true,
            "icon": "ic_search",
            "size": "medium"
        },
        "jds_search_results": {
            "open": false,
            "_maxWidth": 784
        },
        "logo-jds-text": {
            "font-family": "{headingXxs}",
            "color": "{primaryInverse}",
            "font-size": "{headingXxs}",
            "line-height": "{headingXxs}",
            "letter-spacing": "{headingXxs}",
            "font-weight": "{headingXxs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        },
        "name-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryInverse}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 1,
            "maxLines": 1
        }
    },
    "variant": {
        "_variant": {
            "active_search": {
                "prefix-slot": {
                    "hidden": true
                },
                "avatar-slot": {
                    "hidden": true
                },
                "suffix-jds_action_button": {
                    "hidden": false
                },
                "jds_search_box": {
                    "prefix": "ic_search",
                    "flex": 1
                },
                "left-container": {
                    "hidden": true
                },
                "icon-links-container": {
                    "hidden": true
                },
                "suffix-slot": {
                    "hidden": true
                },
                "jds_search_results": {
                    "open": true
                },
                "prefix-jds_button": {
                    "hidden": true
                },
                "name-jds-text": {
                    "hidden": true
                },
                "logo-jds-text": {
                    "hidden": true
                }
            }
        },
        "search": {
            "false": {
                "left-container": {
                    "flex": 1
                },
                "jds_search_box": {
                    "hidden": true
                },
                "search-jds_action_button": {
                    "hidden": true
                }
            }
        },
        "_IsLinksEmpty": {
            "true": {
                "icon-links-container": {
                    "hidden": true
                }
            }
        },
        "_isBrandMissing": {
            "true": {
                "logo-container": {
                    "hidden": true
                }
            }
        },
        "_isPrefixButtonMissing": {
            "true": {
                "header-container": {
                    "padding-left": "{h_50}"
                }
            }
        }
    },
    "combination": [
        {
            "true": {
                "false": {
                    "left-container": {
                        "flex": 1
                    },
                    "jds_search_box": {
                        "hidden": true
                    },
                    "search-jds_action_button": {
                        "hidden": false
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "search",
            "expandedSearch"
        ]
    ],
    "api": {
        "config": {
            "_variant": {
                "values": [
                    "default",
                    "active_search"
                ]
            },
            "search": {
                "values": [
                    true,
                    false
                ]
            },
            "expandedSearch": {
                "values": [
                    true,
                    false
                ]
            },
            "searchActive": {
                "values": [
                    false,
                    true
                ]
            },
            "_IsLinksEmpty": {
                "values": [
                    false,
                    true
                ]
            },
            "_isBrandMissing": {
                "values": [
                    false,
                    true
                ]
            },
            "_isPrefixButtonMissing": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "prefix-jds_button": {
                "icon": {
                    "name": "prefix",
                    "type": "icon"
                }
            },
            "icon-links-container": {
                "value": {
                    "type": "list",
                    "name": "icons",
                    "object": {
                        "icon": "icon",
                        "onClick": "event"
                    }
                }
            },
            "icon-links-jds_button": {
                "icon": {
                    "name": "icons.icon",
                    "type": "icon"
                }
            },
            "jds_search_box": {
                "label": {
                    "type": "string",
                    "name": "searchLabel"
                },
                "suffix": {
                    "type": "icon",
                    "name": "searchSuffix",
                    "function": true
                },
                "value": {
                    "type": "string",
                    "name": "query"
                },
                "showBack": {
                    "type": "boolean",
                    "name": "searchShowBack"
                },
                "focusRequester": {
                    "type": "focusRequester",
                    "name": "focusRequester",
                    "platform": "android"
                },
                "imeAction": {
                    "type": "imeAction",
                    "name": "imeAction",
                    "platform": "android"
                }
            },
            "jds_search_results": {
                "offsetX": {
                    "type": "number",
                    "name": "_offsetX"
                },
                "offsetY": {
                    "type": "number",
                    "name": "_offsetY"
                },
                "results": {
                    "type": "list",
                    "name": "searchResults",
                    "object": {
                        "icon": "icon",
                        "label": "string"
                    }
                },
                "header": {
                    "type": "string",
                    "name": "searchResultHeader"
                },
                "query": {
                    "type": "string",
                    "name": "query"
                },
                "headerAction": {
                    "type": "string",
                    "name": "searchResultHeaderAction"
                }
            },
            "logo-jds-text": {
                "value": {
                    "type": "string",
                    "name": "brandLabel"
                }
            },
            "name-jds-text": {
                "value": {
                    "type": "string",
                    "name": "pageTitle"
                }
            }
        },
        "children": {
            "avatar-slot": {
                "name": "avatar",
                "accepts": [
                    "jds_avatar",
                    "jds_link"
                ],
                "max": 1
            },
            "prefix-slot": {
                "name": "pageTitlePrefix",
                "accepts": [
                    "jds_avatar",
                    "jds_icon",
                    "jds_image"
                ],
                "max": 1
            },
            "tabs-slot": {
                "name": "tabs",
                "accepts": [
                    "jds_tab"
                ],
                "max": 1
            },
            "suffix-slot": {
                "name": "suffix",
                "accepts": [
                    "jds_text",
                    "jds_button",
                    "jds_link"
                ],
                "max": 1
            },
            "logo-slot": {
                "name": "logo",
                "accepts": [
                    "jds_icon",
                    "jds_image",
                    "jds_link"
                ],
                "max": 1
            }
        },
        "events": {
            "container": {
                "_searchActive.onSearchActiveChange": "onSearchActiveChange"
            },
            "header-container": {
                "onAppear": {
                    "name": "_onAppear",
                    "platform": "ios"
                }
            },
            "logo-container": {
                "onClick": "logoOnClick"
            },
            "avatar-slot": {
                "onClick": "avatarOnClick"
            },
            "prefix-jds_button": {
                "onClick": "prefixOnClick"
            },
            "suffix-jds_action_button": {
                "onClick": "suffixOnClick"
            },
            "jds_search_box": {
                "onBlur": "onSearchBlur",
                "onFocus": "onSearchFocus",
                "onChange": "onSearchChange",
                "onSuffixClick": "onSearchBoxSuffixClick",
                "onBack": "onSearchBoxPrefixClick"
            },
            "search-jds_action_button": {
                "onClick": "onSearchIconClick"
            },
            "jds_search_results": {
                "onHeaderActionClick": "onSearchResultHeaderActionClick",
                "onClick": "onSearchResultClick"
            }
        },
        "a11y": {
            "icon-links-container": {
                "name": "icons",
                "repeating": {
                    "ariaLabel": "iconLinkAriaLabel",
                    "ariaDescribedby": {
                        "name": "iconLinkAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_search_results": {
                "name": "searchResults",
                "repeating": {
                    "ariaLabel": "searchResultAriaLabel",
                    "ariaDescribedby": {
                        "name": "searchResultAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "icon-links-jds_button": {
                "properties": {
                    "ariaLabel": "icons.iconLinkAriaLabel",
                    "ariaDescribedby": "icons.iconLinkAriaDescribedby"
                }
            },
            "prefix-jds_button": {
                "properties": {
                    "ariaLabel": "prefixAriaLabel",
                    "ariaDescribedby": {
                        "name": "prefixAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "suffix-jds_action_button": {
                "properties": {
                    "ariaLabel": "suffixAriaLabel",
                    "ariaDescribedby": {
                        "name": "suffixAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_search_box": {
                "properties": {
                    "prefixAriaLabel": "searchBoxPrefixAriaLabel",
                    "suffixAriaLabel": "searchBoxSuffixAriaLabel",
                    "ariaLabel": "searchAriaLabel"
                }
            },
            "search-jds_action_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "searchButtonAriaLabel",
                        "prop": "dynamicButtonText"
                    },
                    "ariaDescribedby": {
                        "name": "searchButtonAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$g = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$i = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$h;
    const { search: search = true, expandedSearch: expandedSearch = true, searchActive: searchActive = false, onSearchActiveChange: onSearchActiveChange = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), logoOnClick: logoOnClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), avatarOnClick: avatarOnClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), prefixOnClick: prefixOnClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), suffixOnClick: suffixOnClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSearchBlur: onSearchBlur = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSearchFocus: onSearchFocus = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSearchChange: onSearchChange = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSearchBoxSuffixClick: onSearchBoxSuffixClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSearchBoxPrefixClick: onSearchBoxPrefixClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSearchIconClick: onSearchIconClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSearchResultHeaderActionClick: onSearchResultHeaderActionClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSearchResultClick: onSearchResultClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), searchButtonAriaLabel: searchButtonAriaLabel = props.dynamicButtonText?.toString(), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            search: search,
            expandedSearch: expandedSearch,
            searchActive: searchActive,
            onSearchActiveChange: onSearchActiveChange,
            logoOnClick: logoOnClick,
            avatarOnClick: avatarOnClick,
            prefixOnClick: prefixOnClick,
            suffixOnClick: suffixOnClick,
            onSearchBlur: onSearchBlur,
            onSearchFocus: onSearchFocus,
            onSearchChange: onSearchChange,
            onSearchBoxSuffixClick: onSearchBoxSuffixClick,
            onSearchBoxPrefixClick: onSearchBoxPrefixClick,
            onSearchIconClick: onSearchIconClick,
            onSearchResultHeaderActionClick: onSearchResultHeaderActionClick,
            onSearchResultClick: onSearchResultClick,
            searchButtonAriaLabel: searchButtonAriaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSHeaderMobile", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$9f3d994e721c19d3 = $fe5170bdd3625759$var$withLogic$g($fe5170bdd3625759$var$Component$i);
$fe5170bdd3625759$export$9f3d994e721c19d3.displayName = "HeaderMobile";
$fe5170bdd3625759$export$9f3d994e721c19d3.slotName = "jds_header_mobile";
const $fe5170bdd3625759$var$sdl$g = {
    "metadata": {
        "version": "1.0.0",
        "id": "input-code-1.0.0",
        "name": "JDSInputCode",
        "layerName": "jds_input_code"
    },
    "hierarchy": {
        "container": [
            {
                "field-container": [
                    "jds_input_code_item"
                ]
            },
            "jds_feedback_block",
            "helper-jds-text"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{i_0}",
            "justify-content": "{i_1}",
            "align-items": "{i_2}",
            "width": "{i_3}",
            "gap": "{i_4}",
            "opacity": "{i_11}"
        },
        "field-container": {
            "flex-direction": "{i_5}",
            "justify-content": "{i_6}",
            "align-items": "{i_7}",
            "width": "{i_8}",
            "gap": "{i_9}"
        },
        "jds_input_code_item": {
            "flex": 1
        },
        "jds_feedback_block": {
            "size": "s",
            "state": "none"
        },
        "helper-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{i_10}"
                }
            }
        },
        "state": {
            "success": {
                "jds_feedback_block": {
                    "state": "success"
                }
            },
            "error": {
                "jds_feedback_block": {
                    "state": "error"
                }
            },
            "warning": {
                "jds_feedback_block": {
                    "state": "warning"
                }
            }
        },
        "autoComplete": {
            "true": {
                "jds_input_code_item": {
                    "autoComplete": "true"
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "disabled": {
                "values": [
                    false,
                    true
                ]
            },
            "autoComplete": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to enable or disable the autocomplete feature in the inputcode.",
                "platform": "web"
            },
            "autofocus": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to Focus on the Inputcode.",
                "platform": "web"
            },
            "state": {
                "type": "JDSFeedbackBlock.state",
                "values": [
                    "none",
                    "success",
                    "error",
                    "warning"
                ]
            }
        },
        "data": {
            "container": {
                "_codes.value": {
                    "type": "string",
                    "name": "value"
                },
                "_codes.placeholder": {
                    "type": "string",
                    "name": "placeholder"
                }
            },
            "field-container": {
                "value": {
                    "type": "list",
                    "name": "_codes",
                    "object": {
                        "value": "string",
                        "placeholder": "string"
                    }
                },
                "length": {
                    "type": "number",
                    "name": "codeLength",
                    "doc_description": "It can be used to control length of Code."
                }
            },
            "jds_input_code_item": {
                "state": {
                    "type": "JDSFeedbackBlock.state",
                    "name": "state",
                    "doc_description": "It can be used to choose between states i.e. 'success','warning','error','none'.By default it is 'none'."
                },
                "disabled": {
                    "type": "boolean",
                    "name": "disabled",
                    "doc_description": "It can be used to enable or disable Code."
                },
                "autofocus": {
                    "type": "boolean",
                    "name": "autofocus",
                    "doc_description": "It can be used to enable the autoFocus on InputCode.",
                    "platform": "web,ios"
                },
                "value": {
                    "type": "string",
                    "name": "codes.value"
                },
                "placeholder": {
                    "type": "string",
                    "name": "codes.placeholder"
                },
                "required": {
                    "type": "boolean",
                    "name": "required",
                    "doc_description": "It can be used to make input required."
                },
                "secureText": {
                    "type": "boolean",
                    "name": "secureText"
                },
                "focusRequester": {
                    "type": "focusRequester",
                    "name": "focusRequester",
                    "platform": "android"
                }
            },
            "jds_feedback_block": {
                "stateText": {
                    "type": "string",
                    "name": "stateText",
                    "doc_description": "It displays message with respect to its [state] selected."
                }
            },
            "helper-jds-text": {
                "value": {
                    "type": "string",
                    "name": "helperText",
                    "doc_description": "It displays helper text of Code."
                }
            }
        },
        "events": {
            "jds_input_code_item": {
                "onFocus": "onFocus",
                "onBlur": "onBlur",
                "onChange": "onChange",
                "onBackPress": {
                    "name": "onBackPress",
                    "platform": "android"
                },
                "onSubmit": "onSubmit",
                "onKeydown": {
                    "name": "onKeydown",
                    "platform": "web"
                },
                "onPaste": "onPaste",
                "onInvalid": "onInvalid"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "input"
                    },
                    "aria-label": {
                        "name": "ariaLabel"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_input_code_item": {
                "properties": {
                    "ariaLabel": {
                        "name": "codeAriaLabel",
                        "platform": "android"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$f = (Component)=>(props)=>{
        const { value: propValue, onChange: onChange, autofocus: autofocus, ...rest } = props;
        const [element, setElement] = (0, $acw62.useState)(null);
        const rootRef = (0, $acw62.useCallback)((element2)=>{
            if (element2) setElement(element2);
        }, []);
        const { inputState: inputState, stateText: stateText, onInvalid: onInvalid } = $fe5170bdd3625759$var$useInputState(props.state, props.required, props.onInvalid, props.stateConfig, props.stateText);
        const [value, setValue] = (0, $acw62.useState)(propValue?.split("") || []);
        (0, $acw62.useState)(propValue || "");
        const [updatedValue, setUpdatedValue] = (0, $acw62.useState)("");
        const inputs = Array.from(element?.getElementsByTagName("input") || []);
        const autofocusExecuted = (0, $acw62.useRef)(false);
        (0, $acw62.useEffect)(()=>{
            if (autofocus && !autofocusExecuted.current && inputs.length > 0) {
                autofocusExecuted.current = true;
                inputs[0]?.focus();
                inputs[0]?.select();
            }
        }, [
            autofocus,
            inputs
        ]);
        (0, $acw62.useEffect)(()=>{
            setValue(propValue?.split("") || []);
            setUpdatedValue(propValue || "");
        }, [
            propValue
        ]);
        const focusNext = (i)=>{
            if (i + 1 < inputs.length) {
                inputs[i + 1]?.focus();
                inputs[i + 1]?.select();
            }
        };
        const focusPrev = (i)=>{
            if (i > 0) {
                inputs[i - 1]?.focus();
                inputs[i - 1]?.select();
            } else {
                inputs[0]?.focus();
                inputs[0]?.select();
            }
        };
        const handleChange = (ev, i)=>{
            const inputValue = ev.target.value;
            const newValue = [
                ...value
            ];
            if (inputValue.length > 1) {
                Array.from({
                    length: inputValue.length
                }).forEach((_, idx)=>{
                    newValue[idx] = inputValue[idx];
                });
                const lastUpdatedIndex = i + inputValue.length - 1;
                inputs[lastUpdatedIndex]?.focus();
                inputs[lastUpdatedIndex]?.select();
            } else {
                newValue[i] = inputValue.slice(-1) || "";
                focusNext(i);
            }
            setValue(newValue);
            setUpdatedValue(newValue.join(""));
            if (props.onChange) {
                const event = {
                    ...ev,
                    target: {
                        ...ev.target,
                        value: newValue.join("")
                    }
                };
                props.onChange(event);
            }
        };
        const handleFocus = (ev, i)=>{
            const target = ev.target;
            const selectValue = ()=>{
                if (document.activeElement === target) {
                    target.select();
                    setTimeout(selectValue, 0);
                }
            };
            selectValue();
        };
        const handleKeyDown = (ev, i)=>{
            const allowedKeys = [
                "Backspace",
                "Delete",
                "ArrowLeft",
                "ArrowRight",
                "Tab"
            ];
            const isPasteShortcut = (ev.ctrlKey || ev.metaKey) && ev.key.toLowerCase() === "v";
            if (!/^\d$/.test(ev.key) && !allowedKeys.includes(ev.key) && !isPasteShortcut) {
                ev.preventDefault();
                return;
            }
            switch(ev.key){
                case "Backspace":
                case "Delete":
                    {
                        const newValue = [
                            ...value
                        ];
                        if (!ev.currentTarget.value && i > 0) {
                            newValue[i - 1] = "";
                            focusPrev(i);
                        } else newValue[i] = "";
                        setValue(newValue);
                        setUpdatedValue(newValue.join(""));
                        if (props.onChange) props.onChange({
                            ...ev,
                            target: {
                                ...ev.target,
                                value: newValue.join("")
                            }
                        });
                        ev.preventDefault();
                        break;
                    }
                case "ArrowLeft":
                    focusPrev(i);
                    ev.preventDefault();
                    break;
                case "ArrowRight":
                    focusNext(i);
                    ev.preventDefault();
                    break;
                case "Tab":
                    if (ev.shiftKey) focusPrev(i);
                    else focusNext(i);
                    ev.preventDefault();
                    break;
            }
        };
        const handlePaste = (ev, i)=>{
            ev.preventDefault();
            const clipboardValue = ev.clipboardData.getData("text").replace(/\D/g, "").split("").slice(0, props.codeLength);
            const newValue = [
                ...Array(props.codeLength).fill(""),
                ...value
            ].slice(0, props.codeLength);
            let lastIndex = i;
            clipboardValue.forEach((char, idx)=>{
                if (i + idx < newValue.length) {
                    newValue[i + idx] = char;
                    lastIndex = i + idx;
                }
            });
            setValue(newValue);
            setUpdatedValue(newValue.join(""));
            if (props.onChange) props.onChange({
                ...ev,
                target: {
                    ...ev.target,
                    value: newValue.join("")
                }
            });
            setTimeout(()=>{
                inputs[lastIndex]?.focus();
                inputs[lastIndex]?.select();
            }, 0);
        };
        const handleInput = (ev, i)=>{
            const inputValue = ev.target.value;
            if (inputValue.length > 1) {
                const autofillValues = inputValue.split("").slice(0, props.codeLength);
                const newValue = autofillValues.concat(value.slice(autofillValues.length));
                setValue(newValue);
                setUpdatedValue(newValue.join(""));
                const lastIndex = autofillValues.length - 1;
                inputs[lastIndex]?.focus();
                inputs[lastIndex]?.select();
                if (props.onChange) {
                    const event = {
                        ...ev,
                        target: {
                            ...ev.target,
                            value: newValue.join("")
                        }
                    };
                    props.onChange(event);
                }
            } else if (inputValue) {
                const newValue = [
                    ...value
                ];
                newValue[i] = inputValue.slice(-1);
                setValue(newValue);
                setUpdatedValue(newValue.join(""));
                const nextFocusIndex = Math.min(newValue.join("").length, props.codeLength - 1);
                inputs[nextFocusIndex]?.focus();
                inputs[nextFocusIndex]?.select();
                if (props.onChange) {
                    const event = {
                        ...ev,
                        target: {
                            ...ev.target,
                            value: newValue.join("")
                        }
                    };
                    props.onChange(event);
                }
            } else handleChange(ev, i);
        };
        const codes = Array.from({
            length: props.codeLength || 6
        }).map((_, i)=>({
                placeholder: props.placeholder?.[i] || (i + 1).toString(),
                value: value[i] || "",
                onChange: (ev)=>handleChange(ev, i),
                onFocus: (ev)=>handleFocus(ev),
                onKeyDown: (ev)=>handleKeyDown(ev, i),
                onPaste: (ev)=>handlePaste(ev, i),
                onInput: (ev)=>handleInput(ev, i)
            }));
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...rest,
                rootRef: rootRef,
                state: inputState,
                stateText: stateText,
                onInvalid: onInvalid,
                _codes: codes,
                ariaLabel: props.ariaLabel || `Input code of length ${props.codeLength}`
            }
        });
    };
const $fe5170bdd3625759$var$Component$h = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$g;
    const { disabled: disabled = false, autoComplete: autoComplete = false, autofocus: autofocus = false, state: state = "undefined", onFocus: onFocus = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onBlur: onBlur = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onChange: onChange = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onBackPress: onBackPress = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSubmit: onSubmit = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onPaste: onPaste = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onInvalid: onInvalid = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            disabled: disabled,
            autoComplete: autoComplete,
            autofocus: autofocus,
            state: state,
            onFocus: onFocus,
            onBlur: onBlur,
            onChange: onChange,
            onBackPress: onBackPress,
            onSubmit: onSubmit,
            onPaste: onPaste,
            onInvalid: onInvalid,
            ...rest
        },
        componentTag: componentTag
    }, "JDSInputCode", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$6d59a84bf808ad3a = $fe5170bdd3625759$var$withLogic$f($fe5170bdd3625759$var$Component$h);
$fe5170bdd3625759$export$6d59a84bf808ad3a.displayName = "InputCode";
$fe5170bdd3625759$export$6d59a84bf808ad3a.slotName = "jds_input_code";
const $fe5170bdd3625759$var$sdl$f = {
    "metadata": {
        "version": "1.0.0",
        "id": "input-date-1.0.0",
        "name": "JDSInputDate",
        "layerName": "jds_input_date",
        "description": "",
        "usage": "Input date component is used to help users enter a memorable date or one they can easily look up for example a date of birth or an expiration date of the credit card."
    },
    "hierarchy": {
        "container": [
            {
                "outer-container": [
                    {
                        "field-container": [
                            "label-jds-text",
                            {
                                "input-container": [
                                    {
                                        "dd-container": [
                                            "dd-jds_input",
                                            {
                                                "dd-active-line-container": [
                                                    "dd-feedback-container"
                                                ]
                                            }
                                        ]
                                    },
                                    "left-slash-container",
                                    {
                                        "mm-container": [
                                            "mm-jds_input",
                                            {
                                                "mm-active-line-container": [
                                                    "mm-feedback-container"
                                                ]
                                            }
                                        ]
                                    },
                                    "right-slash-container",
                                    {
                                        "yy-container": [
                                            "yy-jds_input",
                                            {
                                                "yy-active-line-container": [
                                                    "yy-feedback-container"
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "calendar-container": [
                            "calendar-jds_action_button"
                        ]
                    }
                ]
            },
            {
                "bottom-container": [
                    "jds_feedback_block",
                    "helper-jds-text",
                    "jds_datepicker"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{i_0}",
            "align-items": "{i_1}",
            "gap": "{i_2}",
            "width": "{i_3}"
        },
        "outer-container": {
            "flex-direction": "{i_4}",
            "width": "{i_5}",
            "align-items": "{i_6}"
        },
        "field-container": {
            "flex": 1,
            "flex-direction": "{i_7}",
            "width": "{i_8}",
            "align-items": "{i_9}"
        },
        "input-container": {
            "width": "{i_10}",
            "gap": "{i_11}",
            "height": 36,
            "align-items": "{i_12}"
        },
        "dd-container": {
            "flex-direction": "{i_13}",
            "flex": 1,
            "gap": "{i_14}",
            "align-items": "{i_15}"
        },
        "dd-jds_input": {
            "disabled": false,
            "type": "number",
            "textAlign": "{i_16}",
            "maxLength": 2,
            "placeholder": "dd"
        },
        "dd-active-line-container": {
            "width": "{i_17}",
            "padding-top": 1,
            "padding-bottom": 1
        },
        "dd-feedback-container": {
            "height": 2,
            "width": "{i_18}",
            "background-color": "{i_19}",
            "show": true
        },
        "left-slash-container": {
            "width": 1,
            "height": 35,
            "rotate": 10,
            "background-color": "{i_20}",
            "show": true
        },
        "mm-container": {
            "flex-direction": "{i_21}",
            "flex": 1,
            "gap": "{i_22}",
            "align-items": "{i_23}"
        },
        "mm-jds_input": {
            "disabled": false,
            "type": "number",
            "textAlign": "{i_24}",
            "maxLength": 2,
            "placeholder": "mm"
        },
        "mm-active-line-container": {
            "width": "{i_25}",
            "padding-top": 1,
            "padding-bottom": 1
        },
        "mm-feedback-container": {
            "height": 2,
            "width": "{i_26}",
            "background-color": "{i_27}",
            "show": true
        },
        "right-slash-container": {
            "width": 1,
            "height": 35,
            "rotate": 10,
            "background-color": "{i_28}",
            "show": true
        },
        "yy-container": {
            "flex-direction": "{i_29}",
            "flex": 1,
            "gap": "{i_30}",
            "align-items": "{i_31}"
        },
        "yy-jds_input": {
            "disabled": false,
            "type": "number",
            "textAlign": "{i_32}",
            "maxLength": 4,
            "placeholder": "yyyy"
        },
        "yy-active-line-container": {
            "width": "{i_33}",
            "padding-top": 1,
            "padding-bottom": 1
        },
        "yy-feedback-container": {
            "height": 2,
            "width": "{i_34}",
            "background-color": "{i_35}",
            "show": true
        },
        "calendar-container": {
            "hidden": false,
            "justify-content": "{i_36}",
            "align-items": "{i_37}"
        },
        "calendar-jds_action_button": {
            "kind": "tertiary",
            "size": "medium",
            "icon": "ic_calendar"
        },
        "bottom-container": {
            "flex-direction": "{i_38}",
            "align-items": "{i_39}",
            "gap": "{i_40}",
            "width": "{i_41}"
        },
        "jds_feedback_block": {
            "size": "s",
            "state": "none"
        },
        "label-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 1,
            "maxLines": 1
        },
        "helper-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "disabled": {
            "true": {
                "field-container": {
                    "opacity": "{i_42}",
                    "disabled": true
                },
                "bottom-container": {
                    "opacity": "{i_43}",
                    "disabled": true
                },
                "dd-jds_input": {
                    "disabled": true
                },
                "mm-jds_input": {
                    "disabled": true
                },
                "yy-jds_input": {
                    "disabled": true
                },
                "calendar-jds_action_button": {
                    "state": "disabled"
                }
            }
        },
        "error": {
            "true": {
                "jds_feedback_block": {
                    "state": "error"
                },
                "dd-feedback-container": {
                    "background-color": "{i_44}"
                },
                "mm-feedback-container": {
                    "background-color": "{i_45}"
                },
                "yy-feedback-container": {
                    "background-color": "{i_46}"
                }
            }
        },
        "ddError": {
            "true": {
                "jds_feedback_block": {
                    "state": "error"
                },
                "dd-feedback-container": {
                    "background-color": "{i_47}"
                }
            }
        },
        "mmError": {
            "true": {
                "jds_feedback_block": {
                    "state": "error"
                },
                "mm-feedback-container": {
                    "background-color": "{i_48}"
                }
            }
        },
        "yyError": {
            "true": {
                "jds_feedback_block": {
                    "state": "error"
                },
                "yy-feedback-container": {
                    "background-color": "{i_49}"
                }
            }
        },
        "showCalendar": {
            "false": {
                "calendar-container": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "disabled": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "Determines the disabled input field"
            },
            "error": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "The error state of the input"
            },
            "ddError": {
                "values": [
                    false,
                    true
                ]
            },
            "mmError": {
                "values": [
                    false,
                    true
                ]
            },
            "yyError": {
                "values": [
                    false,
                    true
                ]
            },
            "showCalendar": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "dd-jds_input": {
                "value": {
                    "type": "number",
                    "name": "ddValue"
                }
            },
            "mm-jds_input": {
                "value": {
                    "type": "number",
                    "name": "mmValue"
                }
            },
            "yy-jds_input": {
                "value": {
                    "type": "number",
                    "name": "yyValue"
                }
            },
            "jds_feedback_block": {
                "stateText": {
                    "type": "string",
                    "name": "errorText",
                    "doc_description": "The error text to display"
                }
            },
            "jds_datepicker": {
                "open": {
                    "type": "boolean",
                    "name": "_datepickerOpen"
                },
                "offsetX": {
                    "type": "string",
                    "name": "_offsetX"
                },
                "offsetY": {
                    "type": "string",
                    "name": "_offsetY"
                },
                "triggerRef": {
                    "type": "ref",
                    "name": "triggerRef"
                },
                "min": {
                    "type": "date",
                    "name": "min",
                    "doc_description": "Defines the min date possible"
                },
                "max": {
                    "type": "date",
                    "name": "max",
                    "doc_description": "Defines the max date possible"
                },
                "value": {
                    "type": "date",
                    "name": "_calendarValue"
                }
            },
            "label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label",
                    "doc_description": "Determines the label"
                }
            },
            "helper-jds-text": {
                "value": {
                    "type": "string",
                    "name": "helperText",
                    "doc_description": "The helper text to display"
                }
            }
        },
        "events": {
            "calendar-jds_action_button": {
                "onClick": "onCalendarClick"
            },
            "dd-jds_input": {
                "onChange": "onDateChange",
                "onSubmit": "onDateSubmit",
                "onKeydown": {
                    "name": "onDateKeydown",
                    "platform": "web"
                },
                "onBlur": "onDateBlur"
            },
            "mm-jds_input": {
                "onChange": "onMonthChange",
                "onSubmit": "onMonthSubmit",
                "onKeydown": {
                    "name": "onMonthKeydown",
                    "platform": "web"
                },
                "onBlur": "onMonthBlur"
            },
            "yy-jds_input": {
                "onChange": "onYearChange",
                "onSubmit": "onYearSubmit",
                "onKeydown": {
                    "name": "onYearKeydown",
                    "platform": "web"
                },
                "onBlur": "onYearBlur"
            },
            "jds_datepicker": {
                "onClose": "onDatepickerClose",
                "onSelect": "onDatepickerSelect",
                "onConfirm": "onDatepickerSelect"
            }
        },
        "a11y": {
            "dd-jds_input": {
                "properties": {
                    "ariaLabel": {
                        "name": "dateAriaLabel",
                        "value": "Insert day"
                    }
                }
            },
            "mm-jds_input": {
                "properties": {
                    "ariaLabel": {
                        "name": "monthAriaLabel",
                        "value": "Insert month"
                    }
                }
            },
            "yy-jds_input": {
                "properties": {
                    "ariaLabel": {
                        "name": "yearAriaLabel",
                        "value": "Insert year"
                    }
                }
            },
            "calendar-jds_action_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "datepickerAriaLabel",
                        "value": "Launch datepicker"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$DATEPICKER_LAYER_ID = ".j-JDSInputDate-calendar-container";
const $fe5170bdd3625759$var$getNormalisedDate = (value)=>{
    if (!value) return {
        day: void 0,
        month: void 0,
        year: void 0
    };
    const date = new Date(value);
    if (!date.getTime()) return {
        day: void 0,
        month: void 0,
        year: void 0
    };
    return {
        day: date.getDate(),
        month: date.getMonth() + 1,
        year: date.getFullYear()
    };
};
const $fe5170bdd3625759$var$validateYear = (value, min, max)=>{
    const { year: year = 0 } = value;
    const { year: minYear = 0 } = $fe5170bdd3625759$var$getNormalisedDate(min);
    const { year: maxYear = 0 } = $fe5170bdd3625759$var$getNormalisedDate(max);
    if (min && year) {
        if (year < minYear) return false;
    }
    if (max && year) {
        if (year > maxYear) return false;
    }
    return true;
};
const $fe5170bdd3625759$var$validateMonth = (value, min, max)=>{
    if (!$fe5170bdd3625759$var$validateYear(value, min, max)) return false;
    const { year: year, month: month } = value;
    if (!month || month < 1 || month > 12) return false;
    const { year: minYear, month: minMonth = 0 } = $fe5170bdd3625759$var$getNormalisedDate(min);
    const { year: maxYear, month: maxMonth = 0 } = $fe5170bdd3625759$var$getNormalisedDate(max);
    if (year === minYear && month < minMonth) return false;
    if (year === maxYear && month > maxMonth) return false;
    return true;
};
const $fe5170bdd3625759$var$validateDate = (value, min, max)=>{
    const { day: day, month: month, year: year } = value;
    if (!day || !month || !year) return true;
    const currentDate = new Date(year, month - 1, day);
    const minDate = min ? new Date(min) : null;
    const maxDate = max ? new Date(max) : null;
    const isLeapYear = (year2)=>{
        return year2 % 4 === 0;
    };
    const monthsWith30Days = [
        4,
        6,
        9,
        11
    ];
    if (month < 1 || month > 12 || day < 1) return false;
    if (monthsWith30Days.includes(month) && day > 30) return false;
    if (month === 2) {
        if (isLeapYear(year) && day > 29) return false;
        if (!isLeapYear(year) && day > 28) return false;
    } else if (day > 31) return false;
    if (minDate && currentDate < minDate) return false;
    if (maxDate && currentDate > maxDate) return false;
    if (minDate && year === minDate.getFullYear()) {
        if (month < minDate.getMonth() + 1) return false;
        if (month === minDate.getMonth() + 1 && day < minDate.getDate()) return false;
    }
    if (maxDate && year === maxDate.getFullYear()) {
        if (month > maxDate.getMonth() + 1) return false;
        if (month === maxDate.getMonth() + 1 && day > maxDate.getDate()) return false;
    }
    return true;
};
const $fe5170bdd3625759$var$nodeJump = (key, sourceNode, nextNode, prevNode, sourceNodeError)=>{
    switch(key){
        case "Backspace":
            if (!sourceNode?.value && !sourceNodeError) setTimeout(()=>prevNode?.select());
            break;
        case "ArrowLeft":
            if (document.getSelection()?.toString() === sourceNode?.value && !sourceNodeError) setTimeout(()=>prevNode?.select?.());
            break;
        case "ArrowRight":
            if (document.getSelection()?.toString() === sourceNode?.value && !sourceNodeError) setTimeout(()=>nextNode?.select?.());
            break;
    }
};
const $fe5170bdd3625759$var$getDateFromObject = (obj)=>new Date(obj.year || 0, obj.month || 0, obj.day);
const $fe5170bdd3625759$var$getDateStringFromObject = (obj)=>`${obj.year || ""}/${(obj.month || "").toString().padStart(2, "0")}/${(obj.day || "").toString().padStart(2, "0")}`;
const $fe5170bdd3625759$var$getDisabledsDays = (date, step)=>{
    if (!step) return [];
    const { month: month = 0, year: year = 0 } = date;
    const daysInMonth = new Date(year, month, 0).getDate();
    const numbers = Array.from({
        length: daysInMonth
    }).map((_, i)=>i + 1);
    const filteredNumbers = numbers.filter((i)=>{
        return i % step === 0;
    });
    return filteredNumbers.map((i)=>new Date(year, month - 1, i));
};
const $fe5170bdd3625759$var$withLogic$e = (Component)=>(props)=>{
        const { value: value, datePicker: datePicker, min: min, max: max, error: error, errorText: errorText, errorFieldsObject: errorFieldsObject, setValidity: setValidity, setCustomValidity: setCustomValidity, onChange: onChange, step: step, ...rest } = props;
        const { selected: selected, toggle: toggle, close: close } = $fe5170bdd3625759$var$useToggle(false);
        const [date, setDate] = (0, $acw62.useState)($fe5170bdd3625759$var$getNormalisedDate(value));
        const [element, setElement] = (0, $acw62.useState)(null);
        (0, $acw62.useEffect)(()=>{
            if (value === "") setDate({
                day: void 0,
                month: void 0,
                year: void 0
            });
            else setDate($fe5170bdd3625759$var$getNormalisedDate(value));
        }, [
            value
        ]);
        const [focus, setFocus] = (0, $acw62.useState)({
            dd: false,
            mm: false,
            yy: false
        });
        const { day: day, month: month, year: year } = date;
        const rootRef = (0, $acw62.useCallback)((element2)=>{
            if (element2) setElement(element2);
        }, []);
        const datePickerLayer = element?.querySelector($fe5170bdd3625759$var$DATEPICKER_LAYER_ID);
        const inputs = Array.from(element?.querySelectorAll("input") || []);
        const ddInput = inputs.find((input)=>input.placeholder === "dd");
        const mmInput = inputs.find((input)=>input.placeholder === "mm");
        const yyyInput = inputs.find((input)=>input.placeholder === "yyyy");
        const { dd: dd, mm: mm, yyyy: yyyy, errorLocalText: errorLocalText } = setCustomValidity?.(new Date(date.year || 0, date.month || 0, date.day)) || {};
        const userValidated = setValidity?.($fe5170bdd3625759$var$getDateFromObject(date));
        const dayError = !focus.dd && (userValidated || dd || errorFieldsObject?.dd || error || date.day && !$fe5170bdd3625759$var$validateDate(date, min, max) || rest.required && !date.day);
        const monthError = !focus.mm && (userValidated || mm || errorFieldsObject?.mm || error || date.month && !$fe5170bdd3625759$var$validateMonth(date, min, max) || rest.required && !date.month);
        const yearError = !focus.yy && (userValidated || yyyy || errorFieldsObject?.yyyy || error || date.year && !$fe5170bdd3625759$var$validateYear(date, min, max) || rest.required && !date.year);
        const getCurrentDate = ()=>{
            const now = /* @__PURE__ */ new Date();
            return {
                day: now.getDate(),
                month: now.getMonth() + 1,
                year: now.getFullYear()
            };
        };
        const isInvalidDate = (date2)=>{
            return !date2 || isNaN(date2.day ?? NaN) || date2.day === 0 || !$fe5170bdd3625759$var$validateDate(date2) || !$fe5170bdd3625759$var$validateMonth(date2) || isNaN(date2.month ?? NaN) || date2.month === 0 || isNaN(date2.year ?? NaN) || date2.year === 0;
        };
        const formatDate = (date2)=>{
            const mm2 = String(date2.month).padStart(2, "0");
            const dd2 = String(date2.day).padStart(2, "0");
            const yyyy2 = date2.year;
            return `${mm2}-${dd2}-${yyyy2}`;
        };
        const [calendarValue, setCalendarValue] = (0, $acw62.useState)(formatDate(getCurrentDate()));
        (0, $acw62.useEffect)(()=>{
            setCalendarValue(formatDate(isInvalidDate(date) ? getCurrentDate() : date));
        }, [
            date
        ]);
        console.log(date, "test 1");
        console.log(calendarValue, "test 2");
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...rest,
                min: min,
                max: max,
                errorText: errorLocalText || errorText,
                _datepickerOpen: selected,
                dateAriaLabel: props.dateAriaLabel || "Input date",
                monthAriaLabel: props.monthAriaLabel || "Input month",
                yearAriaLabel: props.yearAriaLabel || "Input year",
                datepickerAriaLabel: props.datepickerAriaLabel || "Launch datepicker",
                onMonthKeydown: (ev)=>{
                    $fe5170bdd3625759$var$nodeJump(ev.key, mmInput, yyyInput, ddInput, monthError);
                },
                onDateKeydown: (ev)=>{
                    $fe5170bdd3625759$var$nodeJump(ev.key, ddInput, mmInput, void 0, dayError);
                },
                onYearKeydown: (ev)=>{
                    $fe5170bdd3625759$var$nodeJump(ev.key, yyyInput, void 0, mmInput, yearError);
                },
                showCalendar: datePicker,
                onCalendarClick: toggle,
                onDatepickerClose: close,
                rootRef: rootRef,
                disabledDates: $fe5170bdd3625759$var$getDisabledsDays(date, parseInt(step)),
                ddValue: focus.dd ? day : day?.toString().padStart(2, "0") || "",
                mmValue: focus.mm ? month : month?.toString().padStart(2, "0") || "",
                yyValue: focus.yy ? year : year?.toString().padStart(4, "0") || "",
                _calendarValue: calendarValue,
                onDatepickerSelect: (value2)=>{
                    const date2 = $fe5170bdd3625759$var$getNormalisedDate(value2);
                    setDate(date2);
                    onChange?.($fe5170bdd3625759$var$getDateStringFromObject(date2));
                },
                triggerRef: {
                    current: datePickerLayer
                },
                ddError: dayError,
                mmError: monthError,
                yyError: yearError,
                onDateChange: (ev)=>{
                    setFocus({
                        ...focus,
                        dd: true
                    });
                    const currentValue = {
                        ...date,
                        day: parseInt(ev.target.value)
                    };
                    setDate(currentValue);
                    onChange?.($fe5170bdd3625759$var$getDateStringFromObject(currentValue));
                    if (ev.target.value.length === 2 && !dayError) setTimeout(()=>mmInput?.select?.());
                },
                onMonthChange: (ev)=>{
                    setFocus({
                        ...focus,
                        mm: true
                    });
                    const currentValue = {
                        ...date,
                        month: parseInt(ev.target.value)
                    };
                    setDate(currentValue);
                    onChange?.($fe5170bdd3625759$var$getDateStringFromObject(currentValue));
                    if (ev.target.value.length === 2 && !monthError) setTimeout(()=>yyyInput?.select?.());
                },
                onYearChange: (ev)=>{
                    setFocus({
                        ...focus,
                        yy: true
                    });
                    const currentValue = {
                        ...date,
                        year: parseInt(ev.target.value)
                    };
                    setDate(currentValue);
                    onChange?.($fe5170bdd3625759$var$getDateStringFromObject(currentValue));
                },
                onDateBlur: ()=>{
                    setFocus({
                        ...focus,
                        dd: false
                    });
                },
                onMonthBlur: ()=>{
                    setFocus({
                        ...focus,
                        mm: false
                    });
                },
                onYearBlur: ()=>{
                    setFocus({
                        ...focus,
                        yy: false
                    });
                }
            }
        });
    };
const $fe5170bdd3625759$var$Component$g = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$f;
    const { disabled: disabled = false, error: error = false, ddError: ddError = false, mmError: mmError = false, yyError: yyError = false, showCalendar: showCalendar = true, onCalendarClick: onCalendarClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onDateChange: onDateChange = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onDateSubmit: onDateSubmit = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onDateKeydown: onDateKeydown = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onDateBlur: onDateBlur = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onMonthChange: onMonthChange = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onMonthSubmit: onMonthSubmit = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onMonthKeydown: onMonthKeydown = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onMonthBlur: onMonthBlur = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onYearChange: onYearChange = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onYearSubmit: onYearSubmit = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onYearKeydown: onYearKeydown = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onYearBlur: onYearBlur = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onDatepickerClose: onDatepickerClose = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onDatepickerSelect: onDatepickerSelect = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), dateAriaLabel: dateAriaLabel = "Insert day", monthAriaLabel: monthAriaLabel = "Insert month", yearAriaLabel: yearAriaLabel = "Insert year", datepickerAriaLabel: datepickerAriaLabel = "Launch datepicker", custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            disabled: disabled,
            error: error,
            ddError: ddError,
            mmError: mmError,
            yyError: yyError,
            showCalendar: showCalendar,
            onCalendarClick: onCalendarClick,
            onDateChange: onDateChange,
            onDateSubmit: onDateSubmit,
            onDateKeydown: onDateKeydown,
            onDateBlur: onDateBlur,
            onMonthChange: onMonthChange,
            onMonthSubmit: onMonthSubmit,
            onMonthKeydown: onMonthKeydown,
            onMonthBlur: onMonthBlur,
            onYearChange: onYearChange,
            onYearSubmit: onYearSubmit,
            onYearKeydown: onYearKeydown,
            onYearBlur: onYearBlur,
            onDatepickerClose: onDatepickerClose,
            onDatepickerSelect: onDatepickerSelect,
            dateAriaLabel: dateAriaLabel,
            monthAriaLabel: monthAriaLabel,
            yearAriaLabel: yearAriaLabel,
            datepickerAriaLabel: datepickerAriaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSInputDate", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$7ac9d04ce3f22c96 = $fe5170bdd3625759$var$withLogic$e($fe5170bdd3625759$var$Component$g);
$fe5170bdd3625759$export$7ac9d04ce3f22c96.displayName = "InputDate";
$fe5170bdd3625759$export$7ac9d04ce3f22c96.slotName = "jds_input_date";
const $fe5170bdd3625759$var$sdl$e = {
    "metadata": {
        "version": "1.0.0",
        "id": "input-field-1.0.0",
        "name": "JDSInputField",
        "layerName": "jds_input_field",
        "description": "A input field give context to the information that a user needs to input. They're commonly used in forms."
    },
    "hierarchy": {
        "container": [
            {
                "field-container": [
                    "input_label-jds-text",
                    {
                        "input-container": [
                            {
                                "prefix-container": [
                                    "prefix-slot"
                                ]
                            },
                            "jds_input",
                            "suffix-slot"
                        ]
                    }
                ]
            },
            {
                "active-line-container": [
                    "feedback-container"
                ]
            },
            "jds_feedback_block",
            "helper-jds-text"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{i_0}",
            "gap": "{i_1}",
            "width": "{i_2}",
            "justify-content": "{i_3}",
            "align-items": "{i_4}",
            "opacity": "{i_30}",
            "behavior": {
                "hover": {}
            }
        },
        "field-container": {
            "flex-direction": "{i_5}",
            "width": "{i_6}",
            "align-items": "{i_7}",
            "justify-content": "{i_8}",
            "padding-bottom": "{i_9}",
            "animate-stack-alignment": true
        },
        "input-container": {
            "flex-direction": "{i_10}",
            "justify-content": "{i_11}",
            "width": "{i_12}",
            "gap": "{i_13}",
            "padding-top": 20,
            "align-items": "{i_14}",
            "z-index": 0
        },
        "prefix-container": {
            "hidden": false
        },
        "jds_input": {
            "disabled": false,
            "type": "text",
            "textAlign": "{i_17}",
            "rows": 1,
            "flex": 1
        },
        "active-line-container": {
            "flex-direction": "{i_21}",
            "width": "{i_22}",
            "align-items": "{i_23}",
            "padding-bottom": 1,
            "padding-top": 1
        },
        "feedback-container": {
            "width": "{i_24}",
            "height": 2,
            "background-color": "{i_25}",
            "border-radius": 48,
            "show": true,
            "behavior": {
                "hover": {
                    "background-color": "{i_26}"
                },
                "focus": {
                    "background-color": "{i_27}"
                },
                "active": {
                    "background-color": "{i_28}"
                }
            }
        },
        "jds_feedback_block": {
            "size": "s",
            "state": "none"
        },
        "prefix-slot": {
            "disabled": false
        },
        "suffix-slot": {
            "disabled": false
        },
        "input_label-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 1,
            "textType": "label",
            "maxLines": 1,
            "z-index": 1,
            "animate-padding-left": true
        },
        "helper-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "disabled": {
            "true": {
                "container": {
                    "opacity": "{i_29}",
                    "disabled": true
                },
                "jds_input": {
                    "disabled": true
                },
                "prefix-slot": {
                    "disabled": true
                },
                "suffix-slot": {
                    "disabled": true
                }
            }
        },
        "state": {
            "success": {
                "feedback-container": {
                    "background-color": "{i_31}",
                    "behavior": {
                        "hover": {
                            "background-color": "{i_32}"
                        },
                        "focus": {
                            "background-color": "{i_33}"
                        },
                        "active": {
                            "background-color": "{i_34}"
                        }
                    }
                },
                "jds_feedback_block": {
                    "state": "success"
                }
            },
            "error": {
                "feedback-container": {
                    "background-color": "{i_35}",
                    "behavior": {
                        "hover": {
                            "background-color": "{i_36}"
                        },
                        "focus": {
                            "background-color": "{i_37}"
                        },
                        "active": {
                            "background-color": "{i_38}"
                        }
                    }
                },
                "jds_feedback_block": {
                    "state": "error"
                }
            },
            "warning": {
                "feedback-container": {
                    "background-color": "{i_39}",
                    "behavior": {
                        "hover": {
                            "background-color": "{i_40}"
                        },
                        "focus": {
                            "background-color": "{i_41}"
                        },
                        "active": {
                            "background-color": "{i_42}"
                        }
                    }
                },
                "jds_feedback_block": {
                    "state": "warning"
                }
            }
        },
        "type": {
            "email": {
                "jds_input": {
                    "type": "email"
                }
            },
            "number": {
                "jds_input": {
                    "type": "number"
                }
            },
            "password": {
                "jds_input": {
                    "type": "password"
                }
            },
            "phone": {
                "jds_input": {
                    "type": "phone"
                }
            }
        },
        "_hasSuffix": {
            "true": {
                "suffix-icon-container": {
                    "hidden": false
                }
            }
        }
    },
    "combination": [
        {
            "true": {
                "true": {
                    "field-container": {
                        "align-items": "{i_43}"
                    },
                    "prefix-icon-container": {
                        "hidden": false
                    },
                    "input_label-jds-text": {
                        "font-family": "{bodyXs}",
                        "font-size": "{bodyXs}",
                        "line-height": "{bodyXs}",
                        "letter-spacing": "{bodyXs}",
                        "font-weight": "{bodyXs}",
                        "padding-left": 0
                    }
                },
                "false": {
                    "field-container": {
                        "align-items": "{i_44}"
                    },
                    "input_label-jds-text": {
                        "font-family": "{bodyXs}",
                        "font-size": "{bodyXs}",
                        "line-height": "{bodyXs}",
                        "letter-spacing": "{bodyXs}",
                        "font-weight": "{bodyXs}",
                        "padding-left": 0
                    }
                }
            },
            "false": {
                "true": {
                    "field-container": {
                        "align-items": "{i_45}"
                    },
                    "prefix-icon-container": {
                        "hidden": false
                    }
                },
                "false": {
                    "field-container": {
                        "align-items": "{i_47}"
                    },
                    "input_label-jds-text": {
                        "padding-left": 0
                    }
                }
            }
        },
        {
            "none": {
                "true": {
                    "feedback-container": {
                        "background-color": "{i_48}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "_labelFocus",
            "_hasPrefix"
        ],
        [
            "state",
            "_inputFocus"
        ]
    ],
    "api": {
        "children": {
            "prefix-slot": {
                "name": "prefix",
                "accepts": [
                    "jds_dropdown",
                    "jds_icon",
                    "jds_input_phone_dropdown",
                    "jds_text"
                ],
                "max": 1,
                "doc_description": "It takes 'icon' or 'dropdown' as prefix."
            },
            "suffix-slot": {
                "name": "suffix",
                "accepts": [
                    "jds_dropdown",
                    "jds_icon",
                    "jds_spinner"
                ],
                "max": 1,
                "doc_description": "It takes 'icon' or 'dropdown' as suffix."
            }
        },
        "config": {
            "disabled": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to enable or disable InputField."
            },
            "state": {
                "type": "JDSFeedbackBlock.state",
                "doc_description": "It can be used to choose between states i.e. 'success','warning','error','none'.By default it is 'none'.",
                "values": [
                    "none",
                    "success",
                    "error",
                    "warning"
                ]
            },
            "type": {
                "type": "JDSInput.type",
                "function": true,
                "values": [
                    "text",
                    "email",
                    "number",
                    "password",
                    "textarea",
                    "pin",
                    "phone"
                ]
            },
            "_labelFocus": {
                "values": [
                    false,
                    true
                ]
            },
            "_inputFocus": {
                "values": [
                    false,
                    true
                ]
            },
            "_hasPrefix": {
                "values": [
                    false,
                    true
                ]
            },
            "_hasSuffix": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds_input": {
                "id": {
                    "type": "string",
                    "name": "id",
                    "platform": "web"
                },
                "value": {
                    "type": "string",
                    "name": "value",
                    "doc_description": "It takes value from user for the Input field."
                },
                "name": {
                    "type": "string",
                    "name": "name"
                },
                "autocomplete": {
                    "type": "string",
                    "name": "autocomplete",
                    "platform": "web"
                },
                "autoFocus": {
                    "type": "boolean",
                    "name": "autoFocus",
                    "platform": "web,ios"
                },
                "placeholder": {
                    "type": "string",
                    "name": "placeholder",
                    "doc_description": "It displays the placeholder of Input field."
                },
                "maxLength": {
                    "type": "number",
                    "name": "maxLength",
                    "doc_description": "It can be used to bound user's input within a maximum character limit."
                },
                "pattern": {
                    "type": "string",
                    "name": "pattern"
                },
                "required": {
                    "type": "boolean",
                    "name": "required",
                    "doc_description": "It can be used to make input field required."
                },
                "focusRequester": {
                    "type": "focusRequester",
                    "name": "focusRequester",
                    "platform": "android"
                },
                "imeAction": {
                    "type": "imeAction",
                    "name": "imeAction",
                    "platform": "android"
                },
                "capitalization": {
                    "type": "keyboardCapitalization",
                    "name": "capitalization",
                    "platform": "android"
                },
                "semantics": {
                    "type": "string",
                    "name": "semantics",
                    "platform": "android"
                }
            },
            "jds_feedback_block": {
                "stateText": {
                    "type": "string",
                    "name": "stateText",
                    "doc_description": "It displays message with respect to its [state] selected."
                }
            },
            "input_label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label",
                    "function": true
                },
                "id": {
                    "type": "string",
                    "name": "id",
                    "platform": "web"
                },
                "padding-left": {
                    "type": "size",
                    "name": "_labelOffset"
                }
            },
            "helper-jds-text": {
                "value": {
                    "type": "string",
                    "name": "helperText",
                    "doc_description": "It dispalys helper text of the input field."
                }
            }
        },
        "events": {
            "prefix-container": {
                "onAppear": {
                    "name": "_onAppear",
                    "platform": "ios"
                }
            },
            "jds_input": {
                "onFocus": "onFocus",
                "onBlur": "onBlur",
                "onChange": "onChange",
                "onKeydown": {
                    "name": "onKeydown",
                    "platform": "web"
                },
                "onInvalid": "onInvalid",
                "onSubmit": "onSubmit"
            },
            "prefix-slot": {
                "onClick": "onPrefixClick",
                "onSlotMeasure": {
                    "name": "onPrefixSlotWidth",
                    "platform": "android"
                }
            },
            "suffix-slot": {
                "onClick": "onSuffixClick"
            }
        },
        "a11y": {
            "jds_input": {
                "properties": {
                    "ariaLabel": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "ariaInvalid": "ariaInvalid",
                    "ariaPlaceholder": {
                        "name": "_ariaPlaceholder"
                    },
                    "ariaRequired": {
                        "name": "_ariaRequired",
                        "prop": "required"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$Component$f = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$e;
    const { disabled: disabled = false, state: state = "undefined", type: type = "undefined", onFocus: onFocus = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onBlur: onBlur = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onChange: onChange = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onInvalid: onInvalid = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSubmit: onSubmit = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onPrefixClick: onPrefixClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onPrefixSlotWidth: onPrefixSlotWidth = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSuffixClick: onSuffixClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), ariaLabel: ariaLabel = props.label?.toString(), _ariaRequired: _ariaRequired = props.required?.toString(), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            disabled: disabled,
            state: state,
            type: type,
            onFocus: onFocus,
            onBlur: onBlur,
            onChange: onChange,
            onInvalid: onInvalid,
            onSubmit: onSubmit,
            onPrefixClick: onPrefixClick,
            onPrefixSlotWidth: onPrefixSlotWidth,
            onSuffixClick: onSuffixClick,
            ariaLabel: ariaLabel,
            _ariaRequired: _ariaRequired,
            ...rest
        },
        componentTag: componentTag
    }, "JDSInputField", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$dd2171e2b7d3bc5b = $fe5170bdd3625759$var$withLogic$1c($fe5170bdd3625759$var$Component$f);
$fe5170bdd3625759$export$dd2171e2b7d3bc5b.displayName = "InputField";
$fe5170bdd3625759$export$dd2171e2b7d3bc5b.slotName = "jds_input_field";
const $fe5170bdd3625759$var$sdl$d = {
    "metadata": {
        "version": "1.0.0",
        "id": "pagination-1.0.0",
        "name": "JDSPagination",
        "layerName": "jds_pagination"
    },
    "hierarchy": {
        "container": [
            "first-jds_button",
            "previous-jds_button",
            {
                "basic-container": [
                    "data-jds_pagination_button"
                ]
            },
            {
                "compact-container": [
                    "helper-jds-text"
                ]
            },
            "next-jds_button",
            "last-jds_button"
        ]
    },
    "base": {
        "container": {
            "hidden": false,
            "background-color": "{p_0}",
            "flex-direction": "{p_1}",
            "justify-content": "{p_2}",
            "align-items": "{p_3}",
            "padding-left": "{p_4}",
            "padding-right": "{p_5}",
            "width": "{p_6}",
            "min-height": "{p_7}"
        },
        "basic-container": {
            "flex-direction": "{p_8}"
        },
        "previous-jds_button": {
            "icon": "ic_back",
            "kind": "tertiary",
            "size": "small",
            "_hasLabel": false
        },
        "next-jds_button": {
            "icon": "ic_next",
            "kind": "tertiary",
            "size": "small",
            "_hasLabel": false
        },
        "last-jds_button": {
            "hidden": true,
            "icon": "ic_lastpage",
            "kind": "tertiary",
            "size": "small",
            "_hasLabel": false
        },
        "first-jds_button": {
            "hidden": true,
            "icon": "ic_firstpage",
            "kind": "tertiary",
            "size": "small",
            "_hasLabel": false
        },
        "compact-container": {
            "flex-direction": "{p_9}",
            "hidden": true,
            "gap": "{p_10}",
            "padding-left": "{p_11}",
            "padding-right": "{p_12}"
        },
        "helper-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "kind": {
            "compact": {
                "compact-container": {
                    "hidden": false
                },
                "basic-container": {
                    "hidden": true
                },
                "last-jds_button": {
                    "hidden": false
                },
                "first-jds_button": {
                    "hidden": false
                }
            }
        }
    },
    "api": {
        "config": {
            "kind": {
                "values": [
                    "basic",
                    "compact"
                ]
            }
        },
        "data": {
            "container": {
                "_items.page": {
                    "type": "number",
                    "name": "page"
                },
                "_items.totalPages": {
                    "type": "number",
                    "name": "totalPages"
                }
            },
            "basic-container": {
                "value": {
                    "type": "list",
                    "name": "_items",
                    "object": {
                        "text": "string",
                        "state": "JDSPaginationButton.state"
                    }
                }
            },
            "data-jds_pagination_button": {
                "text": {
                    "type": "string",
                    "name": "_items.text"
                },
                "state": {
                    "type": "JDSPaginationButton.state",
                    "name": "_items.state"
                }
            },
            "first-jds_button": {
                "disabled": {
                    "type": "boolean",
                    "name": "_firstDisabled"
                }
            },
            "previous-jds_button": {
                "disabled": {
                    "type": "boolean",
                    "name": "_previousDisabled"
                }
            },
            "next-jds_button": {
                "disabled": {
                    "type": "boolean",
                    "name": "_nextDisabled"
                }
            },
            "last-jds_button": {
                "disabled": {
                    "type": "boolean",
                    "name": "_lastDisabled"
                }
            },
            "helper-jds-text": {
                "value": {
                    "type": "string",
                    "name": "_helperText"
                }
            }
        },
        "events": {
            "first-jds_button": {
                "onClick": "onFirst"
            },
            "previous-jds_button": {
                "onClick": "onPrevious"
            },
            "next-jds_button": {
                "onClick": "onNext"
            },
            "last-jds_button": {
                "onClick": "onLast"
            },
            "data-jds_pagination_button": {
                "onClick": "onSelect"
            }
        },
        "a11y": {
            "previous-jds_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "previousButtonAriaLabel",
                        "value": "Previous Page"
                    }
                }
            },
            "next-jds_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "nextButtonAriaLabel",
                        "value": "Next Page"
                    }
                }
            },
            "last-jds_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "lastButtonAriaLabel",
                        "value": "Last Page"
                    }
                }
            },
            "first-jds_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "firstButtonAriaLabel",
                        "value": "First Page"
                    }
                }
            },
            "container": {
                "properties": {
                    "role": {
                        "value": "navigation"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "value": "Pagination navigation"
                    },
                    "aria-describedby": "ariaDescribedby"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$ellipsis = {
    state: "ellipsis",
    text: "..."
};
function $fe5170bdd3625759$var$getTruncatedFiniteItems(length, page) {
    if (page <= 4) {
        const start2 = Array.from({
            length: 5
        }).map((_, index)=>({
                state: index + 1 === page ? "selected" : "default",
                text: `${index + 1}`
            }));
        const end2 = {
            state: page === length ? "selected" : "default",
            text: length.toString()
        };
        return [
            ...start2,
            $fe5170bdd3625759$var$ellipsis,
            end2
        ];
    } else if (page >= length - 3) {
        const start2 = {
            state: page === 1 ? "selected" : "default",
            text: "1"
        };
        const end2 = Array.from({
            length: 5
        }).map((_, index)=>({
                state: page === index + length - 4 ? "selected" : "default",
                text: `${index + length - 4}`
            }));
        return [
            start2,
            $fe5170bdd3625759$var$ellipsis,
            ...end2
        ];
    }
    const start = {
        state: page === 1 ? "selected" : "default",
        text: "1"
    };
    const end = {
        state: page === length ? "selected" : "default",
        text: length.toString()
    };
    const mid = Array.from({
        length: 3
    }).map((_, index)=>({
            state: index + page - 1 === page ? "selected" : "default",
            text: `${index + page - 1}`
        }));
    return [
        start,
        $fe5170bdd3625759$var$ellipsis,
        ...mid,
        $fe5170bdd3625759$var$ellipsis,
        end
    ];
}
function $fe5170bdd3625759$var$getInfiniteItems(page) {
    if (page <= 5) {
        const start2 = Array.from({
            length: 6
        }).map((_, index)=>({
                state: index + 1 === page ? "selected" : "default",
                text: `${index + 1}`
            }));
        return [
            ...start2,
            $fe5170bdd3625759$var$ellipsis
        ];
    }
    const start = {
        state: page === 1 ? "selected" : "default",
        text: "1"
    };
    const mid = Array.from({
        length: 4
    }).map((_, index)=>({
            state: index + page - 2 === page ? "selected" : "default",
            text: `${index + page - 2}`
        }));
    return [
        start,
        $fe5170bdd3625759$var$ellipsis,
        ...mid,
        $fe5170bdd3625759$var$ellipsis
    ];
}
function $fe5170bdd3625759$var$getBasicItems(length, page) {
    return Array.from({
        length: length
    }).map((_, index)=>({
            text: `${index + 1}`,
            state: index + 1 === page ? "selected" : "default"
        }));
}
const $fe5170bdd3625759$var$withLogic$d = (Component)=>(props)=>{
        const { page: page, totalPages: totalPages = 0, onPageChange: onPageChange, kind: kind, ...rest } = props;
        const { index: index, onClick: onClick, updateIndex: updateIndex } = $fe5170bdd3625759$var$useSelected(page);
        const handlePrev = ()=>{
            if (index !== 0) {
                updateIndex(index - 1);
                onPageChange?.(index - 1);
            }
        };
        const handleNext = ()=>{
            if (index !== totalPages) {
                updateIndex(index + 1);
                onPageChange?.(index + 1);
            }
        };
        const handleOnLast = ()=>{
            updateIndex(totalPages);
            onPageChange?.(totalPages);
        };
        const handleOnFirst = ()=>{
            updateIndex(1);
            onPageChange?.(1);
        };
        const items = ()=>{
            const length = totalPages ?? 0;
            const page2 = index ?? 0;
            if (length > 0 && length <= 7) return $fe5170bdd3625759$var$getBasicItems(length, page2);
            else if (length > 7) return $fe5170bdd3625759$var$getTruncatedFiniteItems(length, page2);
            else if (length < 1) return $fe5170bdd3625759$var$getInfiniteItems(page2);
            return [];
        };
        const tokens = (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
        const language = tokens.lang;
        const numeralList = (0, $acw62.useMemo)(()=>{
            return (0, $8bd3c5c9ee0d1eb4$export$3f81e69b9bc596cd)(language);
        }, [
            language
        ]);
        const getLocalNumber = (number)=>{
            const numString = number.toString();
            return numString.replace(/\d/g, (num)=>numeralList[parseInt(num, 10)] ?? num);
        };
        const currentItems = items().map((item, i)=>({
                ...item,
                text: item.text !== "..." ? getLocalNumber(Number(item.text)) : item.text,
                onSelect: ()=>{
                    const { text: text } = item;
                    if (text !== "...") {
                        const currentPage = parseInt(text);
                        onClick(currentPage);
                        onPageChange?.(currentPage);
                    }
                }
            }));
        const firstButtonState = index === 1;
        const lastButtonState = index === totalPages;
        console.log(lastButtonState, 205);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...rest,
                _items: currentItems,
                kind: kind,
                onPrevious: handlePrev,
                onNext: handleNext,
                _helperText: `${getLocalNumber(index)} / ${getLocalNumber(totalPages)}`,
                onFirst: handleOnFirst,
                onLast: handleOnLast,
                _previousDisabled: firstButtonState,
                _firstDisabled: firstButtonState,
                _lastDisabled: lastButtonState,
                _nextDisabled: lastButtonState
            }
        });
    };
const $fe5170bdd3625759$var$Component$e = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$d;
    const { kind: kind = "basic", onFirst: onFirst = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onPrevious: onPrevious = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onNext: onNext = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onLast: onLast = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSelect: onSelect = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), previousButtonAriaLabel: previousButtonAriaLabel = "Previous Page", nextButtonAriaLabel: nextButtonAriaLabel = "Next Page", lastButtonAriaLabel: lastButtonAriaLabel = "Last Page", firstButtonAriaLabel: firstButtonAriaLabel = "First Page", ariaLabel: ariaLabel = "Pagination navigation", custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            onFirst: onFirst,
            onPrevious: onPrevious,
            onNext: onNext,
            onLast: onLast,
            onSelect: onSelect,
            previousButtonAriaLabel: previousButtonAriaLabel,
            nextButtonAriaLabel: nextButtonAriaLabel,
            lastButtonAriaLabel: lastButtonAriaLabel,
            firstButtonAriaLabel: firstButtonAriaLabel,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSPagination", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$68f5e1453c188a82 = $fe5170bdd3625759$var$withLogic$d($fe5170bdd3625759$var$Component$e);
$fe5170bdd3625759$export$68f5e1453c188a82.displayName = "Pagination";
$fe5170bdd3625759$export$68f5e1453c188a82.slotName = "jds_pagination";
const $fe5170bdd3625759$var$sdl$c = {
    "metadata": {
        "version": "1.0.0",
        "id": "promo-card-1.0.0",
        "name": "JDSPromoCard",
        "layerName": "jds_promo_card",
        "description": "Promotional cards are compositions of text and images intended to promote a specific service or feature.",
        "usage": "Promotional cards are used to announce a new feature or motivate users to take an action."
    },
    "hierarchy": {
        "root-container": [
            {
                "vertical-container": [
                    {
                        "vertical-image-container": [
                            "vertical-jds_image",
                            "vertical-promoCardArc"
                        ]
                    },
                    {
                        "vertical-content-container": [
                            "vertical-jds_content_block"
                        ]
                    }
                ]
            },
            {
                "horizontal-container": [
                    {
                        "horizontal-content-container": [
                            "horizontal-jds_content_block"
                        ]
                    },
                    {
                        "horizontal-image-container": [
                            "horizontal-image",
                            "horizontal-promoCardArc"
                        ]
                    }
                ]
            },
            {
                "footer-container": [
                    "prefix-slot",
                    "suffix-slot"
                ]
            }
        ]
    },
    "base": {
        "root-container": {
            "background-color": "{p_0}",
            "flex-direction": "{p_1}",
            "width": "{p_2}",
            "justify-content": "{p_3}",
            "align-items": "{p_4}",
            "border-radius": "{p_5}",
            "box-shadow": {
                "x": 0,
                "y": 4,
                "blur": 16,
                "spread": 0,
                "color": "#00000014"
            }
        },
        "vertical-container": {
            "mode": "bold",
            "flex-direction": "{p_6}",
            "align-items": "{p_7}",
            "justify-content": "{p_8}",
            "width": "{p_9}",
            "border-radius": "{p_10}",
            "background-color": "{p_11}",
            "overflow": "hidden"
        },
        "horizontal-container": {
            "hidden": true,
            "mode": "bold",
            "flex-direction": "{p_12}",
            "align-items": "{p_13}",
            "justify-content": "{p_14}",
            "width": "{p_15}",
            "border-radius": "{p_16}",
            "height": "{p_17}",
            "background-color": "{p_18}",
            "overflow": "hidden"
        },
        "vertical-content-container": {
            "flex-direction": "{p_19}",
            "align-items": "{p_20}",
            "justify-content": "{p_21}",
            "width": "{p_22}",
            "mode": "bold",
            "background-color": "{p_23}",
            "border-bottom-left-radius": "{p_24}",
            "border-bottom-right-radius": "{p_25}",
            "padding-right": "{p_26}",
            "padding-bottom": "{p_27}",
            "padding-left": "{p_28}"
        },
        "horizontal-content-container": {
            "flex-direction": "{p_29}",
            "align-items": "{p_30}",
            "justify-content": "{p_31}",
            "height": "{p_32}",
            "mode": "bold",
            "background-color": "{p_33}",
            "flex": 1,
            "padding-top": "{p_34}",
            "padding-right": "{p_35}",
            "padding-bottom": "{p_36}",
            "padding-left": "{p_37}"
        },
        "vertical-jds_content_block": {
            "mode": "bold",
            "size": "small"
        },
        "horizontal-jds_content_block": {
            "mode": "bold",
            "size": "small"
        },
        "vertical-image-container": {
            "width": "{p_38}",
            "flex-direction": "{p_39}",
            "align-items": "{p_40}"
        },
        "horizontal-image-container": {
            "flex": 1,
            "height": "{p_41}",
            "flex-direction": "{p_42}",
            "align-items": "{p_43}",
            "justify-content": "{p_44}"
        },
        "vertical-jds_image": {
            "aspectRatio": "horizontal_16_9",
            "roundedCorner": false
        },
        "horizontal-image": {
            "overflow": "hidden",
            "height": "{p_45}",
            "object-position": "center",
            "object-fit": "cover",
            "aspect-ratio": "{aspect_ratio.16.9}"
        },
        "vertical-promoCardArc": {
            "mode": "bold",
            "color": "{p_46}",
            "orientation": "vertical",
            "width": "{p_47}",
            "height": "{p_48}",
            "z-index": 1
        },
        "horizontal-promoCardArc": {
            "mode": "bold",
            "color": "{p_49}",
            "orientation": "horizontal",
            "height": "{p_50}",
            "width": "{p_51}",
            "z-index": 1
        },
        "footer-container": {
            "color": "{p_52}",
            "width": "{p_53}",
            "justify-content": "{p_54}",
            "align-items": "{p_55}",
            "flex-direction": "{p_56}",
            "gap": "{p_57}",
            "padding-left": "{p_58}",
            "padding-right": "{p_59}",
            "padding-top": "{p_60}",
            "padding-bottom": "{p_61}",
            "mode": "light",
            "show": false
        }
    },
    "variant": {
        "imageRatio": {
            "square": {
                "vertical-jds_image": {
                    "aspectRatio": "square"
                },
                "horizontal-image": {
                    "aspect-ratio": "{aspect_ratio.1.1}"
                }
            },
            "landscape": {
                "vertical-jds_image": {
                    "aspectRatio": "horizontal_4_3"
                },
                "horizontal-image": {
                    "aspect-ratio": "{aspect_ratio.4.3}"
                }
            },
            "portrait": {
                "vertical-jds_image": {
                    "aspectRatio": "vertical_4_5"
                },
                "horizontal-image": {
                    "aspect-ratio": "{aspect_ratio.4.5}"
                }
            }
        },
        "imageFocus": {
            "left": {
                "vertical-jds_image": {
                    "imageFocus": "left"
                },
                "horizontal-image": {
                    "object-position": "left"
                }
            },
            "right": {
                "vertical-jds_image": {
                    "imageFocus": "right"
                },
                "horizontal-image": {
                    "object-position": "right"
                }
            },
            "top": {
                "vertical-jds_image": {
                    "imageFocus": "top"
                },
                "horizontal-image": {
                    "object-position": "top"
                }
            },
            "bottom": {
                "vertical-jds_image": {
                    "imageFocus": "bottom"
                },
                "horizontal-image": {
                    "object-position": "bottom"
                }
            }
        },
        "shadow": {
            "false": {
                "root-container": {
                    "box-shadow": {
                        "x": 0,
                        "y": 0,
                        "blur": 0,
                        "spread": 0,
                        "color": "#00000000"
                    }
                }
            }
        },
        "size": {
            "xtra-small": {
                "vertical-jds_content_block": {
                    "size": "xtra-small"
                },
                "horizontal-jds_content_block": {
                    "size": "xtra-small"
                }
            },
            "medium": {
                "vertical-jds_content_block": {
                    "size": "medium"
                },
                "horizontal-jds_content_block": {
                    "size": "medium"
                },
                "horizontal-content-container": {
                    "padding-top": "{p_62}",
                    "padding-right": "{p_63}",
                    "padding-bottom": "{p_64}",
                    "padding-left": "{p_65}"
                }
            },
            "large": {
                "vertical-jds_content_block": {
                    "size": "large"
                },
                "horizontal-jds_content_block": {
                    "size": "large"
                },
                "horizontal-content-container": {
                    "padding-top": "{p_66}",
                    "padding-right": "{p_67}",
                    "padding-bottom": "{p_68}",
                    "padding-left": "{p_69}"
                }
            }
        },
        "orientation": {
            "horizontal": {
                "vertical-container": {
                    "hidden": true
                },
                "horizontal-container": {
                    "hidden": false
                }
            }
        },
        "_hasFooter": {
            "false": {
                "footer-container": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "children": {
            "prefix-slot": {
                "name": "footerPrefix",
                "accepts": [
                    "jds_text"
                ],
                "max": 1,
                "doc_description": "footerPrefix corresponds to the left part of the footer. Incase of a String, a text with style body-xxs with grey-100 color is shown"
            },
            "suffix-slot": {
                "name": "footerSuffix",
                "accepts": [
                    "jds_text"
                ],
                "max": 1,
                "doc_description": "footerSuffix corresponds to the right part of the footer. Incase of a String, a text with style body-xxs with grey-100 color is shown"
            }
        },
        "config": {
            "size": {
                "values": [
                    "small",
                    "xtra-small",
                    "medium",
                    "large"
                ],
                "doc_description": "Determines the size of the PromoCard. Size dictates the text and spacing."
            },
            "orientation": {
                "values": [
                    "vertical",
                    "horizontal"
                ],
                "doc_description": "Horizontal orientation puts image and content side by side."
            },
            "imageRatio": {
                "values": [
                    "wide",
                    "square",
                    "landscape",
                    "portrait"
                ]
            },
            "imageFocus": {
                "type": "JDSImage.imageFocus",
                "values": [
                    "center",
                    "left",
                    "right",
                    "top",
                    "bottom"
                ]
            },
            "shadow": {
                "values": [
                    true,
                    false
                ],
                "doc_description": "Toggle drop shadow"
            },
            "_hasFooter": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "horizontal-jds_content_block": {
                "title": {
                    "type": "string",
                    "name": "title",
                    "doc_description": "The main title copy."
                },
                "description": {
                    "type": "string",
                    "name": "description",
                    "doc_description": "Accepts description as string. JSX.Element is also allowed in case you have anchor tags inside your richtext."
                },
                "primaryCTA": {
                    "type": "string",
                    "name": "primaryCTA"
                },
                "children": {
                    "type": "slot",
                    "name": "children"
                }
            },
            "vertical-jds_content_block": {
                "title": {
                    "type": "string",
                    "name": "title",
                    "doc_description": "The main title copy."
                },
                "description": {
                    "type": "string",
                    "name": "description",
                    "doc_description": "Accepts description as string. JSX.Element is also allowed in case you have anchor tags inside your richtext."
                },
                "primaryCTA": {
                    "type": "string",
                    "name": "primaryCTA"
                },
                "children": {
                    "type": "slot",
                    "name": "children"
                }
            },
            "horizontal-image": {
                "value": {
                    "type": "image",
                    "name": "image"
                }
            },
            "vertical-jds_image": {
                "src": {
                    "type": "image",
                    "name": "image"
                }
            }
        },
        "events": {
            "root-container": {
                "onClick": "onClick"
            },
            "horizontal-jds_content_block": {
                "onPrimaryClick": "onPrimaryClick"
            },
            "vertical-jds_content_block": {
                "onPrimaryClick": "onPrimaryClick"
            }
        },
        "a11y": {
            "horizontal-jds_content_block": {
                "properties": {
                    "primaryCtaAriaLabel": "primaryCtaAriaLabel",
                    "primaryCtaAriaDescribedby": {
                        "name": "primaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    },
                    "secondaryCtaAriaLabel": "secondaryCtaAriaLabel",
                    "secondaryCtaAriaDescribedby": {
                        "name": "secondaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "vertical-jds_content_block": {
                "properties": {
                    "primaryCtaAriaLabel": "primaryCtaAriaLabel",
                    "primaryCtaAriaDescribedby": {
                        "name": "primaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    },
                    "secondaryCtaAriaLabel": "secondaryCtaAriaLabel",
                    "secondaryCtaAriaDescribedby": {
                        "name": "secondaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "vertical-jds_image": {
                "properties": {
                    "ariaLabel": "imageAriaLabel",
                    "ariaDescribedby": {
                        "name": "imageAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "horizontal-image": {
                "properties": {
                    "ariaLabel": "imageAriaLabel",
                    "ariaDescribedby": {
                        "name": "imageAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$c = (Component)=>(props)=>{
        const { footerPrefix: footerPrefix, footerSuffix: footerSuffix, ...rest } = props;
        const tokens = (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
        const formatImageName = (imagePath = props.src || "")=>{
            const parts = imagePath.split("/");
            const imageName = parts.length > 0 ? parts[parts.length - 1] : "";
            if (imageName) {
                const formattedName = imageName.replace(/\.\w+$/, "").replace(/([A-Z])/g, " $1").toLowerCase() + " image";
                return formattedName;
            }
            return "Image name not found";
        };
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $8bd3c5c9ee0d1eb4$export$e5cf4eff53e7947d), {
            value: {
                ...tokens,
                mode: "bold"
            },
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
                ...{
                    ...rest,
                    _hasChildren: Boolean(rest.children),
                    _hasFooter: Boolean(footerPrefix || footerSuffix),
                    children: $fe5170bdd3625759$var$convertTextToComponent(rest.children),
                    footerPrefix: $fe5170bdd3625759$var$convertTextToComponent(footerPrefix),
                    footerSuffix: $fe5170bdd3625759$var$convertTextToComponent(footerSuffix),
                    _imageAriaLabel: formatImageName(props.image)
                }
            })
        });
    };
const $fe5170bdd3625759$var$Component$d = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$c;
    const { size: size = "small", orientation: orientation = "vertical", imageRatio: imageRatio = "wide", imageFocus: imageFocus = "undefined", shadow: shadow = true, onClick: onClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onPrimaryClick: onPrimaryClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            size: size,
            orientation: orientation,
            imageRatio: imageRatio,
            imageFocus: imageFocus,
            shadow: shadow,
            onClick: onClick,
            onPrimaryClick: onPrimaryClick,
            ...rest
        },
        componentTag: componentTag
    }, "JDSPromoCard", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$ad00a5af021e778b = $fe5170bdd3625759$var$withLogic$c($fe5170bdd3625759$var$Component$d);
$fe5170bdd3625759$export$ad00a5af021e778b.displayName = "PromoCard";
$fe5170bdd3625759$export$ad00a5af021e778b.slotName = "jds_promo_card";
const $fe5170bdd3625759$var$sdl$b = {
    "metadata": {
        "version": "1.0.0",
        "id": "radio-button-1.0.0",
        "name": "JDSRadioButton",
        "layerName": "jds_radio_button",
        "description": "Radio buttons are used when there is alist of two or more options that are mutually exclusive and the user must select exactly one choice.",
        "usage": ""
    },
    "hierarchy": {
        "vertical-container": [
            {
                "horizontal-container": [
                    {
                        "outer-container": [
                            "inner-container"
                        ]
                    },
                    "label-jds-text"
                ]
            },
            "jds_feedback_block",
            "helper-jds-text"
        ]
    },
    "base": {
        "vertical-container": {
            "hidden": false,
            "flex-direction": "{r_0}",
            "justify-content": "{r_1}",
            "align-items": "{r_2}",
            "gap": "{r_3}",
            "opacity": "{r_36}"
        },
        "horizontal-container": {
            "hidden": false,
            "flex-direction": "{r_4}",
            "justify-content": "{r_5}",
            "align-items": "{r_6}",
            "gap": "{r_7}",
            "behavior": {
                "hover": {},
                "active": {},
                "focus": {}
            }
        },
        "outer-container": {
            "hidden": false,
            "min-width": "{r_8}",
            "min-height": "{r_9}",
            "flex-direction": "{r_10}",
            "justify-content": "{r_11}",
            "align-items": "{r_12}",
            "background-color": "{r_13}",
            "border-radius": "{r_14}",
            "border-width": "{r_16}",
            "border-color": "{r_15}",
            "show": true,
            "behavior": {
                "hover": {
                    "border-color": "{r_18}"
                },
                "active": {
                    "border-color": "{r_19}"
                },
                "focus": {
                    "border-width": 4,
                    "box-sizing": "content-box",
                    "border-color": "{r_20}"
                }
            }
        },
        "inner-container": {
            "hidden": true,
            "min-width": "{r_21}",
            "min-height": "{r_22}",
            "border-radius": "{r_23}",
            "show": true
        },
        "jds_feedback_block": {
            "size": "l"
        },
        "label-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "text-align": "{r_24}",
            "behavior": {
                "hover": {
                    "color": "{primaryGrey100}"
                },
                "focus": {
                    "color": "{primaryGrey100}"
                }
            }
        },
        "helper-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "size": {
            "small": {
                "outer-container": {
                    "min-width": "{r_25}",
                    "min-height": "{r_26}"
                },
                "vertical-container": {
                    "gap": "{r_27}"
                },
                "inner-container": {
                    "min-width": "{r_28}",
                    "min-height": "{r_29}"
                },
                "jds_feedback_block": {
                    "size": "s"
                },
                "label-jds-text": {
                    "font-family": "{bodyXs}",
                    "font-size": "{bodyXs}",
                    "line-height": "{bodyXs}",
                    "letter-spacing": "{bodyXs}",
                    "font-weight": "{bodyXs}"
                },
                "helper-jds-text": {
                    "font-family": "{bodyXs}",
                    "font-size": "{bodyXs}",
                    "line-height": "{bodyXs}",
                    "letter-spacing": "{bodyXs}",
                    "font-weight": "{bodyXs}"
                }
            }
        },
        "checked": {
            "true": {
                "outer-container": {
                    "background-color": "{r_30}",
                    "border-width": "{r_17}",
                    "behavior": {
                        "hover": {
                            "background-color": "{r_31}"
                        },
                        "active": {
                            "background-color": "{r_32}"
                        },
                        "focus": {
                            "background-color": "{r_33}"
                        }
                    }
                },
                "inner-container": {
                    "hidden": false,
                    "background-color": "{r_34}"
                },
                "label-jds-text": {
                    "color": "{primaryGrey100}"
                }
            }
        },
        "disabled": {
            "true": {
                "vertical-container": {
                    "opacity": "{r_35}"
                },
                "horizontal-container": {
                    "disabled": true
                }
            }
        }
    },
    "api": {
        "config": {
            "checked": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "Used to programatically make input active/inactive."
            },
            "size": {
                "values": [
                    "medium",
                    "small"
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds_feedback_block": {
                "stateText": {
                    "type": "string",
                    "name": "stateText"
                },
                "state": {
                    "type": "JDSFeedbackBlock.state",
                    "name": "state"
                }
            },
            "label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            },
            "helper-jds-text": {
                "value": {
                    "type": "string",
                    "name": "helperText"
                }
            }
        },
        "events": {
            "horizontal-container": {
                "onClick": "onClick"
            }
        },
        "a11y": {
            "vertical-container": {
                "properties": {
                    "role": {
                        "value": "radio"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "aria-checked": {
                        "name": "_ariaChecked",
                        "prop": "checked"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$b = (Component)=>(props)=>{
        const handleClick = (ev)=>{
            if (props.onClick) props.onClick({
                ...ev,
                currentTarget: {
                    value: props.value
                },
                target: {
                    value: props.value
                }
            });
        };
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                checked: props.checked,
                onClick: handleClick
            }
        });
    };
const $fe5170bdd3625759$var$Component$c = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$b;
    const { checked: checked = false, size: size = "medium", disabled: disabled = false, onClick: onClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), ariaLabel: ariaLabel = props.label?.toString(), _ariaChecked: _ariaChecked = props.checked?.toString(), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            checked: checked,
            size: size,
            disabled: disabled,
            onClick: onClick,
            ariaLabel: ariaLabel,
            _ariaChecked: _ariaChecked,
            ...rest
        },
        componentTag: componentTag
    }, "JDSRadioButton", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$324f219e224c2ba4 = $fe5170bdd3625759$var$withLogic$b($fe5170bdd3625759$var$Component$c);
$fe5170bdd3625759$export$324f219e224c2ba4.displayName = "InputRadio";
$fe5170bdd3625759$export$324f219e224c2ba4.slotName = "jds_radio_button";
const $fe5170bdd3625759$var$sdl$a = {
    "metadata": {
        "version": "1.0.0",
        "id": "Rating-bar-1.0.0",
        "name": "JDSRatingBar",
        "layerName": "jds_rating_bar"
    },
    "hierarchy": {
        "vertical-container": [
            "top_label-jds-text",
            {
                "horizontal-container": [
                    "left_label-jds-text",
                    "compact-jds_rating_bar_item",
                    {
                        "rating-bar-container": [
                            "jds_rating_bar_item"
                        ]
                    },
                    "right_label-jds-text",
                    "right_support-jds-text"
                ]
            },
            "bottom_label-jds-text",
            "bottom_support-jds-text",
            "jds_feedback_block"
        ]
    },
    "base": {
        "vertical-container": {
            "flex-direction": "{r_0}",
            "align-items": "{r_1}",
            "justify-content": "{r_2}",
            "gap": "{r_3}"
        },
        "horizontal-container": {
            "flex-direction": "{r_4}",
            "align-items": "{r_26}",
            "justify-content": "{r_6}",
            "gap": "{r_7}"
        },
        "compact-jds_rating_bar_item": {
            "hidden": true,
            "isInteractive": false,
            "isActive": true,
            "isHalfRated": false,
            "size": "medium"
        },
        "rating-bar-container": {
            "flex-direction": "{r_8}"
        },
        "jds_feedback_block": {
            "size": "l",
            "hidden": true
        },
        "top_label-jds-text": {
            "font-family": "{bodySBold}",
            "color": "{primaryGrey100}",
            "font-size": "{bodySBold}",
            "line-height": "{bodySBold}",
            "letter-spacing": "{bodySBold}",
            "font-weight": "{bodySBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false
        },
        "left_label-jds-text": {
            "font-family": "{bodySBold}",
            "color": "{primaryGrey100}",
            "font-size": "{bodySBold}",
            "line-height": "{bodySBold}",
            "letter-spacing": "{bodySBold}",
            "font-weight": "{bodySBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": true
        },
        "right_label-jds-text": {
            "font-family": "{bodySBold}",
            "color": "{primaryGrey100}",
            "font-size": "{bodySBold}",
            "line-height": "{bodySBold}",
            "letter-spacing": "{bodySBold}",
            "font-weight": "{bodySBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": true
        },
        "bottom_label-jds-text": {
            "font-family": "{bodySBold}",
            "color": "{primaryGrey100}",
            "font-size": "{bodySBold}",
            "line-height": "{bodySBold}",
            "letter-spacing": "{bodySBold}",
            "font-weight": "{bodySBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": true
        },
        "right_support-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": true
        },
        "bottom_support-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false
        }
    },
    "variant": {
        "size": {
            "small": {
                "vertical-container": {
                    "gap": "{r_9}"
                },
                "horizontal-container": {
                    "gap": "{r_10}"
                },
                "compact-jds_rating_bar_item": {
                    "size": "small"
                },
                "top_label-jds-text": {
                    "font-family": "{bodyXxsBold}",
                    "font-size": "{bodyXxsBold}",
                    "line-height": "{bodyXxsBold}",
                    "letter-spacing": "{bodyXxsBold}",
                    "font-weight": "{bodyXxsBold}"
                },
                "left_label-jds-text": {
                    "font-family": "{bodyXxsBold}",
                    "font-size": "{bodyXxsBold}",
                    "line-height": "{bodyXxsBold}",
                    "letter-spacing": "{bodyXxsBold}",
                    "font-weight": "{bodyXxsBold}"
                },
                "right_label-jds-text": {
                    "font-family": "{bodyXxsBold}",
                    "font-size": "{bodyXxsBold}",
                    "line-height": "{bodyXxsBold}",
                    "letter-spacing": "{bodyXxsBold}",
                    "font-weight": "{bodyXxsBold}"
                },
                "bottom_label-jds-text": {
                    "font-family": "{bodyXxsBold}",
                    "font-size": "{bodyXxsBold}",
                    "line-height": "{bodyXxsBold}",
                    "letter-spacing": "{bodyXxsBold}",
                    "font-weight": "{bodyXxsBold}"
                },
                "right_support-jds-text": {
                    "font-family": "{bodyXxs}",
                    "font-size": "{bodyXxs}",
                    "line-height": "{bodyXxs}",
                    "letter-spacing": "{bodyXxs}",
                    "font-weight": "{bodyXxs}"
                },
                "bottom_support-jds-text": {
                    "font-family": "{bodyXxs}",
                    "font-size": "{bodyXxs}",
                    "line-height": "{bodyXxs}",
                    "letter-spacing": "{bodyXxs}",
                    "font-weight": "{bodyXxs}"
                }
            },
            "large": {
                "compact-jds_rating_bar_item": {
                    "size": "large"
                }
            }
        },
        "labelPosition": {
            "bottom_center": {
                "vertical-container": {
                    "align-items": "{r_11}"
                },
                "top_label-jds-text": {
                    "hidden": true
                },
                "bottom_label-jds-text": {
                    "hidden": false
                }
            },
            "bottom_left": {
                "top_label-jds-text": {
                    "hidden": true
                },
                "bottom_label-jds-text": {
                    "hidden": false
                }
            },
            "top_center": {
                "vertical-container": {
                    "align-items": "{r_12}"
                }
            },
            "right": {
                "top_label-jds-text": {
                    "hidden": true
                },
                "right_label-jds-text": {
                    "hidden": false
                },
                "bottom_support-jds-text": {
                    "hidden": true
                },
                "right_support-jds-text": {
                    "hidden": false
                }
            },
            "left": {
                "top_label-jds-text": {
                    "hidden": true
                },
                "left_label-jds-text": {
                    "hidden": false
                },
                "bottom_support-jds-text": {
                    "hidden": true
                },
                "right_support-jds-text": {
                    "hidden": false
                }
            }
        },
        "type": {
            "read_only_expanded": {
                "rating-bar-container": {
                    "disabled": true
                },
                "jds_rating_bar_item": {
                    "isInteractive": false
                }
            },
            "read_only_compact": {
                "rating-bar-container": {
                    "hidden": true
                },
                "compact-jds_rating_bar_item": {
                    "hidden": false
                }
            }
        },
        "disabled": {
            "true": {
                "vertical-container": {
                    "disabled": true,
                    "opacity": "{r_13}"
                }
            }
        },
        "state": {
            "success": {
                "jds_feedback_block": {
                    "hidden": false
                }
            },
            "error": {
                "jds_feedback_block": {
                    "hidden": false
                }
            },
            "warning": {
                "jds_feedback_block": {
                    "hidden": false
                }
            }
        }
    },
    "combination": [
        {
            "read_only_compact": {
                "top_left": {
                    "top_label-jds-text": {
                        "hidden": true
                    },
                    "right_label-jds-text": {
                        "hidden": false
                    }
                },
                "top_center": {
                    "top_label-jds-text": {
                        "hidden": true
                    },
                    "right_label-jds-text": {
                        "hidden": false
                    }
                },
                "bottom_left": {
                    "bottom_label-jds-text": {},
                    "right_label-jds-text": {
                        "hidden": false
                    }
                },
                "bottom_center": {
                    "bottom_label-jds-text": {},
                    "right_label-jds-text": {
                        "hidden": false
                    }
                }
            }
        },
        {
            "read_only_expanded": {
                "small": {
                    "vertical-container": {
                        "gap": "{r_15}"
                    },
                    "horizontal-container": {
                        "gap": "{r_14}"
                    }
                },
                "medium": {
                    "vertical-container": {
                        "gap": "{r_16}"
                    },
                    "horizontal-container": {
                        "gap": "{r_17}"
                    }
                },
                "large": {
                    "vertical-container": {
                        "gap": "{r_18}"
                    },
                    "horizontal-container": {
                        "gap": "{r_19}"
                    }
                }
            },
            "read_only_compact": {
                "small": {
                    "vertical-container": {
                        "gap": "{r_21}"
                    },
                    "horizontal-container": {
                        "gap": "{r_20}"
                    }
                },
                "medium": {
                    "vertical-container": {
                        "gap": "{r_22}"
                    },
                    "horizontal-container": {
                        "gap": "{r_23}"
                    }
                },
                "large": {
                    "vertical-container": {
                        "gap": "{r_24}"
                    },
                    "horizontal-container": {
                        "gap": "{r_25}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "type",
            "labelPosition"
        ],
        [
            "type",
            "size"
        ]
    ],
    "api": {
        "config": {
            "size": {
                "type": "JDSRatingBarItem.size",
                "values": [
                    "medium",
                    "small",
                    "large"
                ]
            },
            "labelPosition": {
                "values": [
                    "top_left",
                    "bottom_left",
                    "top_center",
                    "bottom_center",
                    "right",
                    "left"
                ]
            },
            "type": {
                "values": [
                    "interactive",
                    "read_only_expanded",
                    "read_only_compact"
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            },
            "state": {
                "type": "JDSFeedbackBlock.state",
                "values": [
                    "none",
                    "success",
                    "error",
                    "warning"
                ]
            }
        },
        "data": {
            "rating-bar-container": {
                "value": {
                    "type": "list",
                    "name": "_items",
                    "object": {
                        "isInteractive": "boolean",
                        "isActive": "boolean",
                        "isHalfRated": "boolean",
                        "isHovered": "boolean",
                        "rating": "clipValueSize"
                    }
                },
                "_items.rating": {
                    "type": "float",
                    "name": "rating"
                },
                "_items.count": {
                    "type": "number",
                    "name": "count"
                }
            },
            "jds_rating_bar_item": {
                "size": {
                    "type": "JDSRatingBarItem.size",
                    "name": "size"
                },
                "isInteractive": {
                    "type": "boolean",
                    "name": "_items.isInteractive"
                },
                "isActive": {
                    "type": "boolean",
                    "name": "_items.isActive"
                },
                "isHovered": {
                    "type": "boolean",
                    "name": "_items.isHovered"
                },
                "isHalfRated": {
                    "type": "boolean",
                    "name": "_items.isHalfRated"
                },
                "disabled": {
                    "type": "boolean",
                    "name": "disabled"
                },
                "clipValue": {
                    "type": "clipValueSize",
                    "name": "_items.rating"
                }
            },
            "jds_feedback_block": {
                "stateText": {
                    "type": "string",
                    "name": "stateText"
                },
                "state": {
                    "type": "JDSFeedbackBlock.state",
                    "name": "state"
                }
            },
            "top_label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            },
            "left_label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "_label"
                }
            },
            "right_label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "_label"
                }
            },
            "bottom_label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            },
            "right_support-jds-text": {
                "value": {
                    "type": "string",
                    "name": "supportText"
                }
            },
            "bottom_support-jds-text": {
                "value": {
                    "type": "string",
                    "name": "supportText"
                }
            }
        },
        "events": {
            "jds_rating_bar_item": {
                "onClick": "onChange",
                "onHover": {
                    "name": "_onHover",
                    "platform": "web"
                },
                "onHoverEnd": {
                    "name": "_onHoverEnd",
                    "platform": "web"
                }
            }
        },
        "a11y": {
            "vertical-container": {
                "properties": {
                    "role": {
                        "name": "_role"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "function": true
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "rating-bar-container": {
                "name": "_items",
                "repeating": {
                    "ariaLabel": "itemAriaLabel",
                    "ariaChecked": "itemAriaChecked"
                }
            },
            "jds_rating_bar_item": {
                "properties": {
                    "ariaLabel": "_items.itemAriaLabel",
                    "ariaChecked": "_items.itemAriaChecked"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$EPSILON = 5e-3;
const $fe5170bdd3625759$var$withLogic$a = (Component)=>({ rating: rating = -1, ...props })=>{
        const { index: userRating, updateIndex: updateIndex } = $fe5170bdd3625759$var$useSelected(rating);
        const ratingIsInt = Math.abs(Math.floor(userRating) - userRating) < $fe5170bdd3625759$var$EPSILON;
        const [hoverIndex, setHoverIndex] = (0, $acw62.useState)(-1);
        const decimalPart = Math.abs(Math.floor(userRating) - userRating);
        const tokens = (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
        const language = tokens.lang;
        const numeralList = (0, $acw62.useMemo)(()=>{
            return (0, $8bd3c5c9ee0d1eb4$export$3f81e69b9bc596cd)(language);
        }, [
            language
        ]);
        const getLocalNumber = (number)=>{
            const numString = number.toString();
            return numString.replace(/\d/g, (num)=>numeralList[parseInt(num, 10)] ?? num);
        };
        const roundedUserRating = Math.round(userRating);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                rating: userRating,
                _role: props.type === "interactive" ? "radiogroup" : "img",
                ariaLabel: props.type === "interactive" ? `${roundedUserRating} star` : `Rated ${roundedUserRating} out of ${props.count} star`,
                _label: props.type === "read_only_compact" ? getLocalNumber(rating) : props.label,
                _onHover: (idx)=>{
                    setHoverIndex(idx);
                },
                _onHoverEnd: (idx)=>{
                    setHoverIndex(idx);
                },
                _items: Array.from({
                    length: props.count || 0
                }).map((_, i)=>{
                    const isHalfRated = !ratingIsInt && i + 1 === Math.ceil(userRating);
                    return {
                        isInteractive: props.type === "interactive",
                        itemAriaLabel: props.type === "interactive" ? `${i + 1} star` : void 0,
                        itemAriaChecked: props.type === "interactive" ? userRating === i + 1 ? "true" : "false" : void 0,
                        isActive: hoverIndex === -1 ? i + 1 <= userRating : i <= hoverIndex,
                        isHalfRated: isHalfRated,
                        rating: isHalfRated ? 100 * (1 - decimalPart) + "%" : void 0,
                        onChange: (index)=>{
                            if (props.type === "interactive") {
                                updateIndex(index + 1);
                                props.onChange?.(index + 1);
                            }
                        }
                    };
                })
            }
        });
    };
const $fe5170bdd3625759$var$Component$b = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$a;
    const { size: size = "undefined", labelPosition: labelPosition = "top_left", type: type = "interactive", disabled: disabled = false, state: state = "undefined", onChange: onChange = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            size: size,
            labelPosition: labelPosition,
            type: type,
            disabled: disabled,
            state: state,
            onChange: onChange,
            ...rest
        },
        componentTag: componentTag
    }, "JDSRatingBar", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$43a203ef9d36f4e4 = $fe5170bdd3625759$var$withLogic$a($fe5170bdd3625759$var$Component$b);
$fe5170bdd3625759$export$43a203ef9d36f4e4.displayName = "RatingBar";
$fe5170bdd3625759$export$43a203ef9d36f4e4.slotName = "jds_rating_bar";
const $fe5170bdd3625759$var$sdl$9 = {
    "metadata": {
        "version": "1.0.0",
        "id": "selector-1.0.0",
        "layerName": "jds_selector",
        "name": "JDSSelector",
        "description": "A selector is a control that allows the user choose a value from a range of options."
    },
    "hierarchy": {
        "container": [
            {
                "selector-container": [
                    "jds_selector_item"
                ]
            },
            {
                "outer-container": [
                    "inner-container"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{s_0}"
        },
        "selector-container": {
            "opacity": "{s_1}",
            "align-items": "{s_2}",
            "justify-content": "{s_3}",
            "border-radius": "{s_4}",
            "padding-top": "{s_5}",
            "padding-right": "{s_6}",
            "padding-bottom": "{s_7}",
            "padding-left": "{s_8}",
            "gap": "{s_15}",
            "flex-direction": "{s_16}"
        },
        "jds_selector_item": {
            "wrap": "horizontal",
            "kind": "label_icon"
        },
        "outer-container": {
            "z-index": -1,
            "justify-content": "{s_19}",
            "background-color": "{s_13}",
            "border-radius": "{s_4}",
            "align-items": "{s_20}",
            "padding-top": "{s_9}",
            "padding-right": "{s_10}",
            "padding-bottom": "{s_11}",
            "padding-left": "{s_12}",
            "width": "{s_17}",
            "height": "{s_18}",
            "disabled": true,
            "transition": {
                "property": [
                    "padding-left"
                ],
                "duration": "{rapid}",
                "timing-function": "{easeJoyful}"
            }
        },
        "inner-container": {
            "background-color": "{s_21}",
            "border-radius": "{s_22}",
            "show": true,
            "transition": {
                "property": [
                    "width"
                ],
                "duration": "{rapid}",
                "timing-function": "{easeJoyful}"
            }
        }
    },
    "variant": {
        "stretch": {
            "true": {
                "container": {
                    "width": "{s_23}"
                },
                "selector-container": {
                    "width": "{s_24}"
                },
                "jds_selector_item": {
                    "flex": 1,
                    "stretch": true
                }
            }
        },
        "wrap": {
            "vertical": {
                "jds_selector_item": {
                    "wrap": "vertical"
                }
            }
        },
        "kind": {
            "label": {
                "jds_selector_item": {
                    "kind": "label"
                }
            },
            "icon": {
                "jds_selector_item": {
                    "kind": "icon"
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "stretch": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to fill the container in which Selector is present."
            },
            "kind": {
                "type": "JDSSelectorItem.kind",
                "values": [
                    "label_icon",
                    "label",
                    "icon"
                ]
            },
            "wrap": {
                "type": "JDSSelectorItem.wrap",
                "values": [
                    "horizontal",
                    "vertical"
                ]
            }
        },
        "data": {
            "selector-container": {
                "value": {
                    "type": "list",
                    "name": "items",
                    "object": {
                        "value": "string",
                        "label": "string",
                        "id": "string",
                        "icon": "icon",
                        "disabled": "boolean"
                    }
                }
            },
            "jds_selector_item": {
                "selectedIndex": {
                    "type": "number",
                    "name": "selectedIndex",
                    "doc_description": "It gives the current index of selected button of Selector. User can overwrite it by passing a new value."
                },
                "value": {
                    "type": "string",
                    "name": "items.value"
                },
                "label": {
                    "type": "string",
                    "name": "items.label"
                },
                "id": {
                    "type": "string",
                    "name": "items.id"
                },
                "icon": {
                    "type": "icon",
                    "name": "items.icon"
                },
                "disabled": {
                    "type": "boolean",
                    "name": "items.disabled"
                }
            },
            "outer-container": {
                "padding-left": {
                    "type": "size",
                    "name": "_left"
                }
            },
            "inner-container": {
                "width": {
                    "type": "size",
                    "name": "_width"
                },
                "height": {
                    "type": "size",
                    "name": "_height"
                }
            }
        },
        "events": {
            "jds_selector_item": {
                "onAppear": {
                    "name": "_onAppear",
                    "platform": "ios, android"
                },
                "onClick": "onClick"
            },
            "container": {
                "onAppear": {
                    "name": "_onSelectorAppear",
                    "platform": "ios"
                }
            }
        },
        "a11y": {
            "selector-container": {
                "name": "items",
                "properties": {
                    "role": {
                        "value": "radiogroup"
                    }
                },
                "repeating": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "iconAriaLabel": "iconAriaLabel"
                }
            },
            "jds_selector_item": {
                "properties": {
                    "ariaLabel": "items.ariaLabel",
                    "ariaDescribedby": "items.ariaDescribedby",
                    "iconAriaLabel": "items.iconAriaLabel"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$9 = (Component)=>({ items: userItems = [], ...props })=>{
        const [selectedIndex, setSelectedIndex] = (0, $acw62.useState)(props.selectedIndex || 0);
        const [dimensions, setDimensions] = (0, $acw62.useState)({
            left: 0,
            width: 0,
            height: 0
        });
        const { rootRef: rootRef } = $fe5170bdd3625759$var$useRootRef((element)=>{
            const updateDimensions = ()=>{
                const selectorContainers2 = Array.from(element?.querySelectorAll("div.j-JDSSelectorItem-container") || []);
                const selectedContainer = selectorContainers2[selectedIndex];
                if (selectedContainer) setDimensions({
                    left: selectedContainer?.offsetLeft,
                    width: selectedContainer?.offsetWidth,
                    height: selectedContainer?.offsetHeight
                });
            };
            updateDimensions();
            const resizeObserver = new ResizeObserver(()=>{
                updateDimensions();
            });
            const selectorContainers = element?.querySelectorAll("div.j-JDSSelectorItem-container") || [];
            selectorContainers.forEach((container)=>{
                resizeObserver.observe(container);
            });
            return ()=>{
                resizeObserver.disconnect();
            };
        }, [
            selectedIndex,
            props.stretch,
            props.wrap
        ]);
        (0, $acw62.useEffect)(()=>{
            if (typeof props.selectedIndex === "number") setSelectedIndex(props.selectedIndex);
            else setSelectedIndex(0);
        }, [
            props.selectedIndex
        ]);
        const items = userItems.map((item, i)=>({
                ...item,
                selected: selectedIndex === i,
                selectedIndex: selectedIndex,
                onClick: (ev)=>{
                    setSelectedIndex(i);
                    props.onChange?.(item.value, i, ev);
                }
            }));
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                selectedIndex: selectedIndex,
                items: items,
                rootRef: rootRef,
                _left: dimensions.left,
                _width: dimensions.width,
                _height: dimensions.height
            }
        });
    };
const $fe5170bdd3625759$var$Component$a = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$9;
    const { stretch: stretch = false, kind: kind = "undefined", wrap: wrap = "undefined", onClick: onClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            stretch: stretch,
            kind: kind,
            wrap: wrap,
            onClick: onClick,
            ...rest
        },
        componentTag: componentTag
    }, "JDSSelector", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$87e9c2ff338a8575 = $fe5170bdd3625759$var$withLogic$9($fe5170bdd3625759$var$Component$a);
$fe5170bdd3625759$export$87e9c2ff338a8575.displayName = "Selectors";
$fe5170bdd3625759$export$87e9c2ff338a8575.slotName = "jds_selector";
const $fe5170bdd3625759$var$sdl$8 = {
    "metadata": {
        "version": "1.0.0",
        "id": "service-card-1.0.0",
        "name": "JDSServiceCard",
        "layerName": "jds_service_card",
        "description": "Service cards are blocks of images and text aiming to promote and connect services.",
        "usage": "Service cards are used to drive users from one Jio service to another."
    },
    "hierarchy": {
        "root-container": [
            {
                "inner-stack-container": [
                    "blur-image",
                    {
                        "internal-vertical-container": [
                            {
                                "image-container": [
                                    "jds_image"
                                ]
                            },
                            {
                                "content-block-container": [
                                    "jds_content_block"
                                ]
                            }
                        ]
                    }
                ]
            },
            "jds_badge"
        ]
    },
    "base": {
        "root-container": {
            "flex-direction": "{s_0}",
            "size": "{s_2}",
            "justify-content": "{s_4}",
            "align-items": "{s_6}",
            "border-radius": "{s_7}",
            "overflow": "hidden"
        },
        "inner-stack-container": {
            "flex-direction": "{s_1}",
            "size": "{s_3}",
            "justify-content": "{s_5}",
            "align-items": "{alignItems.end}",
            "overflow": "hidden"
        },
        "blur-image": {
            "height": "{s_8}",
            "width": "{s_9}",
            "object-fit": "cover",
            "blur-radius": "{s_10}",
            "z-index": 0
        },
        "internal-vertical-container": {
            "flex-direction": "{s_12}",
            "size": "{s_13}",
            "justify-content": "{s_14}",
            "align-items": "{s_15}",
            "z-index": 1
        },
        "image-container": {
            "flex-direction": "{s_16}",
            "justify-content": "{s_17}",
            "align-items": "{s_18}",
            "height": "{s_19}",
            "width": "{s_20}",
            "overflow": "hidden"
        },
        "jds_image": {
            "aspectRatio": "horizontal_16_9",
            "roundedCorner": false,
            "imageFocus": "center"
        },
        "jds_badge": {
            "kind": "service",
            "padding-top": "{s_21}",
            "padding-left": "{s_22}",
            "z-index": 1
        },
        "content-block-container": {
            "background-color": "{s_23}",
            "width": "{s_24}",
            "padding-top": "{s_25}",
            "padding-bottom": "{s_26}",
            "padding-left": "{s_27}",
            "padding-right": "{s_28}"
        },
        "jds_content_block": {
            "size": "xtra-xtra-small",
            "invertCTA": false,
            "ctaWrap": "horizontal",
            "shouldOverrideColor": true,
            "singleButton": true,
            "width": "{s_29}"
        }
    },
    "variant": {
        "imageRatio": {
            "square": {
                "jds_image": {
                    "aspectRatio": "square"
                }
            },
            "landscape": {
                "jds_image": {
                    "aspectRatio": "horizontal_4_3"
                }
            },
            "portrait": {
                "jds_image": {
                    "aspectRatio": "vertical_4_5"
                }
            }
        },
        "shadow": {
            "true": {
                "root-container": {
                    "box-shadow": {
                        "x": 0,
                        "y": 4,
                        "blur": 16,
                        "spread": 0,
                        "color": "#00000014"
                    }
                }
            }
        },
        "size": {
            "xtra-small": {
                "jds_content_block": {
                    "size": "xtra-small"
                }
            },
            "small": {
                "jds_content_block": {
                    "size": "small"
                }
            }
        },
        "_hasFullCardCTA": {
            "true": {
                "root-container": {
                    "behavior": {
                        "hover": {
                            "box-shadow": {
                                "x": 0,
                                "y": 4,
                                "blur": 16,
                                "spread": 0,
                                "color": "#00000014"
                            }
                        }
                    }
                }
            }
        }
    },
    "api": {
        "config": {
            "size": {
                "values": [
                    "xtra-xtra-small",
                    "xtra-small",
                    "small"
                ],
                "doc_description": "Determines the size of the ContentBlock. Size dictates the text and spacing. For size=`xxs`, the layout also changes if only a single CTA is sent."
            },
            "imageRatio": {
                "values": [
                    "wide",
                    "square",
                    "landscape",
                    "portrait"
                ]
            },
            "shadow": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "Toggle drop shadow"
            },
            "_hasFullCardCTA": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "root-container": {
                "fullCardCTA": {
                    "type": "string",
                    "name": "fullCardCTA",
                    "doc_description": "When present, the entire card is clickable."
                }
            },
            "jds_content_block": {
                "title": {
                    "type": "string",
                    "name": "title",
                    "doc_description": "The main title copy."
                },
                "description": {
                    "type": "string",
                    "name": "description",
                    "doc_description": "Accepts description as string. JSX.Element is also allowed in case you have anchor tags inside your richtext."
                },
                "primaryCTA": {
                    "type": "string",
                    "name": "primaryCTA"
                },
                "children": {
                    "type": "slot",
                    "name": "children"
                }
            },
            "jds_image": {
                "src": {
                    "type": "image",
                    "name": "image"
                },
                "imageFocus": {
                    "type": "JDSImage.imageFocus",
                    "name": "imageFocus"
                }
            },
            "blur-image": {
                "value": {
                    "type": "image",
                    "name": "image"
                }
            },
            "jds_badge": {
                "label": {
                    "type": "string",
                    "name": "badgeLabel"
                },
                "icon": {
                    "type": "icon",
                    "name": "badgeIcon"
                }
            }
        },
        "events": {
            "root-container": {
                "onClick": "onClick"
            },
            "jds_content_block": {
                "onPrimaryClick": "onPrimaryClick"
            }
        },
        "a11y": {
            "root-container": {
                "name": "serviceCard"
            },
            "jds_content_block": {
                "properties": {
                    "primaryCtaAriaLabel": "primaryCtaAriaLabel",
                    "primaryCtaAriaDescribedby": {
                        "name": "primaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_image": {
                "properties": {
                    "ariaLabel": "imageAriaLabel",
                    "ariaDescribedby": {
                        "name": "imageAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_badge": {
                "properties": {
                    "ariaLabel": "badgeAriaLabel",
                    "ariaDescribedby": {
                        "name": "badgeAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$PROP_MAP$2 = (props)=>{
    if (typeof props.description === "object") console.warn("passing description as an element is deprecated");
    if (typeof props.image === "object") console.warn("passing image as an element is deprecated");
    return {
        image: {
            properties: {
                image: $fe5170bdd3625759$var$resolvePropObjectKeys(props.image, "props.src", "")
            }
        },
        caption: {
            properties: {
                badgeLabel: props.caption?.label,
                badgeIcon: props.caption?.icon
            }
        },
        size: {
            defaultValue: "xxs",
            variations: {
                s: {
                    size: "small"
                },
                xs: {
                    size: "xtra-small"
                },
                xxs: {
                    size: "xtra-xtra-small"
                }
            }
        }
    };
};
const $fe5170bdd3625759$var$withLogic$8 = (Component)=>(userProps)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$2);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$9 = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$8;
    const { size: size = "xtra-xtra-small", imageRatio: imageRatio = "wide", shadow: shadow = false, onClick: onClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onPrimaryClick: onPrimaryClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            size: size,
            imageRatio: imageRatio,
            shadow: shadow,
            onClick: onClick,
            onPrimaryClick: onPrimaryClick,
            ...rest
        },
        componentTag: componentTag
    }, "JDSServiceCard", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$47e19cb482b7c646 = $fe5170bdd3625759$var$withLogic$8($fe5170bdd3625759$var$Component$9);
$fe5170bdd3625759$export$47e19cb482b7c646.displayName = "ServiceCard";
$fe5170bdd3625759$export$47e19cb482b7c646.slotName = "jds_service_card";
const $fe5170bdd3625759$var$sdl$7 = {
    "metadata": {
        "version": "1.0.0",
        "id": "slider-1.0.0",
        "name": "JDSSlider",
        "layerName": "jds_slider",
        "description": "Continuous Sliders allow the selection of a value within a given range.",
        "usage": "Use Continuous Sliders whenever it makes easy for the user to select a value within a minimum and maximum range. Sliders work best when the specific value does not matter to the user, but an approximate value is good enough."
    },
    "hierarchy": {
        "container": [
            {
                "top-container": [
                    "label-jds-text",
                    {
                        "inner-container": [
                            "value-jds-text",
                            "jds_input"
                        ]
                    }
                ]
            },
            "slider",
            {
                "bottom-container": [
                    "min-jds-text",
                    "max-jds-text"
                ]
            },
            "jds_feedback_block",
            "helper-jds-text"
        ]
    },
    "base": {
        "container": {
            "hidden": false,
            "flex-direction": "{s_0}",
            "justify-content": "{s_1}",
            "align-items": "{s_2}",
            "width": "{s_3}",
            "gap": "{s_4}"
        },
        "top-container": {
            "hidden": false,
            "flex-direction": "{s_5}",
            "justify-content": "{s_6}",
            "align-items": "{s_7}",
            "width": "{s_8}",
            "gap": "{s_9}"
        },
        "inner-container": {
            "hidden": false,
            "height": 32,
            "align-items": "{s_12}",
            "padding-left": "{s_13}",
            "padding-right": "{s_14}",
            "border-width": "{s_15}",
            "border-color": "{s_16}",
            "border-radius": "{s_17}"
        },
        "jds_input": {
            "disabled": false,
            "hidden": true,
            "type": "number",
            "textAlign": "end",
            "rows": 1,
            "width": 93
        },
        "slider": {
            "width": "{s_18}",
            "track-height": "{s_19}",
            "inactive-color": "{s_20}",
            "active-color": "{s_21}",
            "ball-size": 20,
            "ball-color": "{s_22}",
            "ball-border-color": "{s_23}",
            "ball-border-width": 0,
            "border-radius": "{s_24}",
            "behavior": {
                "hover": {
                    "ball-color": "{s_25}"
                },
                "active": {
                    "active-color": "{s_26}",
                    "ball-color": "{s_27}"
                },
                "focus": {
                    "ball-border-width": "{s_28}"
                }
            }
        },
        "bottom-container": {
            "hidden": false,
            "show": false,
            "flex-direction": "{s_29}",
            "justify-content": "{s_30}",
            "align-items": "{s_31}",
            "width": "{s_32}"
        },
        "jds_feedback_block": {
            "size": "s",
            "hidden": true
        },
        "label-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false,
            "flex": 1,
            "justify-content": "{s_10}",
            "align-items": "{s_11}",
            "behavior": {
                "hover": {
                    "color": "{primaryGrey100}"
                },
                "focus": {
                    "color": "{primaryGrey100}"
                }
            }
        },
        "value-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey100}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false
        },
        "min-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        },
        "max-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        },
        "helper-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false
        }
    },
    "variant": {
        "_hideMinMaxLabel": {
            "true": {
                "bottom-container": {
                    "hidden": true
                }
            }
        },
        "editableTextBox": {
            "true": {
                "jds_input": {
                    "hidden": false
                },
                "value-jds-text": {
                    "hidden": true
                }
            }
        },
        "state": {
            "success": {
                "inner-container": {
                    "border-color": "{s_33}"
                },
                "jds_feedback_block": {
                    "hidden": false
                }
            },
            "error": {
                "inner-container": {
                    "border-color": "{s_34}"
                },
                "jds_feedback_block": {
                    "hidden": false
                }
            },
            "warning": {
                "inner-container": {
                    "border-color": "{s_35}"
                },
                "jds_feedback_block": {
                    "hidden": false
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{s_36}"
                },
                "jds_input": {
                    "disabled": true
                },
                "slider": {
                    "disabled": true,
                    "behavior": {
                        "hover": {
                            "ball-color": "{s_37}"
                        },
                        "active": {
                            "active-color": "{s_38}",
                            "ball-color": "{s_39}"
                        },
                        "focus": {
                            "ball-border-width": 0
                        }
                    }
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "_hideMinMaxLabel": {
                "values": [
                    false,
                    true
                ]
            },
            "editableTextBox": {
                "values": [
                    false,
                    true
                ],
                "doc_description": " It allows user to input their own number in the text box that moves the slider value. By default this textbox is in readonly mode."
            },
            "state": {
                "type": "JDSFeedbackBlock.state",
                "doc_description": "It can be used to choose between states i.e. 'success','warning','error','none'.",
                "values": [
                    "none",
                    "success",
                    "error",
                    "warning"
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to enable or disable SearchBox."
            }
        },
        "data": {
            "jds_input": {
                "id": {
                    "type": "string",
                    "name": "id"
                },
                "name": {
                    "type": "string",
                    "name": "name"
                },
                "value": {
                    "type": "string",
                    "name": "valueSuffix",
                    "function": true
                },
                "placeholder": {
                    "type": "string",
                    "name": "placeholder"
                },
                "min": {
                    "type": "float",
                    "name": "min",
                    "function": true,
                    "doc_description": "It is minimum value for Slider."
                },
                "max": {
                    "type": "float",
                    "name": "max",
                    "function": true,
                    "doc_description": "It is maximum value for Slider."
                },
                "required": {
                    "type": "boolean",
                    "name": "required"
                }
            },
            "slider": {
                "step": {
                    "type": "number",
                    "name": "step",
                    "doc_description": "It determines number of divisions slider should slide by."
                },
                "min": {
                    "type": "float",
                    "name": "min",
                    "function": true,
                    "doc_description": "It is minimum value for Slider."
                },
                "max": {
                    "type": "float",
                    "name": "max",
                    "function": true,
                    "doc_description": "It is maximum value for Slider."
                },
                "value": {
                    "type": "float",
                    "name": "value",
                    "function": true,
                    "doc_description": "It takes user input for value of Slider."
                },
                "required": {
                    "type": "boolean",
                    "name": "required"
                }
            },
            "jds_feedback_block": {
                "stateText": {
                    "type": "string",
                    "name": "stateText",
                    "doc_description": "It displays message with respect to its [state] selected."
                },
                "state": {
                    "type": "JDSFeedbackBlock.state",
                    "name": "state"
                }
            },
            "label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label",
                    "doc_description": "It displays label of Slider."
                }
            },
            "value-jds-text": {
                "value": {
                    "type": "string",
                    "name": "valueSuffix",
                    "function": true
                }
            },
            "min-jds-text": {
                "value": {
                    "type": "string",
                    "name": "labelMin"
                }
            },
            "max-jds-text": {
                "value": {
                    "type": "string",
                    "name": "labelMax"
                }
            },
            "helper-jds-text": {
                "value": {
                    "type": "string",
                    "name": "helperText",
                    "doc_description": "It displays helper text of Slider."
                }
            }
        },
        "events": {
            "slider": {
                "onChange": "onValueChange",
                "onEditChange": {
                    "name": "onEditChange",
                    "platform": "ios"
                }
            },
            "jds_input": {
                "onFocus": "onFocus",
                "onBlur": "onBlur",
                "onChange": "onChange",
                "onSubmit": "onSubmit",
                "onKeydown": {
                    "name": "onKeydown",
                    "platform": "web"
                }
            }
        },
        "a11y": {
            "slider": {
                "name": "container",
                "properties": {
                    "role": {
                        "value": "slider"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label",
                        "function": true
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "aria-valuenow": {
                        "name": "_ariaValuenow",
                        "prop": "value",
                        "platform": "web,ios"
                    },
                    "aria-valuemin": {
                        "name": "_ariaValuemin",
                        "prop": "min",
                        "platform": "web,ios"
                    },
                    "aria-valuemax": {
                        "name": "_ariaValuemax",
                        "prop": "max",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$PROP_MAP$1 = (props)=>({
        onChange: {
            properties: {
                onChange: props.onChange,
                onValueChange: props.onChange
            }
        }
    });
function $fe5170bdd3625759$var$getSteppedValue(value, step = 1, min = 0, max = 100) {
    if (typeof value !== "number") return min;
    step = step > 0 ? step : 1;
    const clamped = $fe5170bdd3625759$var$clamp(value, min, max);
    return Math.round((clamped - min) / step) * step + min;
}
const $fe5170bdd3625759$var$clamp = (value, min, max)=>Math.max(min, Math.min(value, max));
const $fe5170bdd3625759$var$withLogic$7 = (Component)=>(userProps)=>{
        const props = $fe5170bdd3625759$var$modifyProps(userProps, $fe5170bdd3625759$var$PROP_MAP$1);
        const { value: userValue = 0 } = props;
        const { inputState: inputState, onInvalid: onInvalid, stateText: stateText } = $fe5170bdd3625759$var$useInputState(props.state, props.required, props.onInvalid, props.stateConfig);
        const [value, setValue] = (0, $acw62.useState)(userValue);
        const [inputValue, setInputValue] = (0, $acw62.useState)(userValue);
        (0, $acw62.useEffect)(()=>{
            setValue(userValue);
            setInputValue(userValue);
        }, [
            userValue
        ]);
        const getSuffixValue = (value2, editable)=>{
            if (editable) return value2;
            return Intl.NumberFormat().format(value2);
        };
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                value: value,
                valueSuffix: getSuffixValue(inputValue, props.editableTextBox),
                state: inputState,
                stateText: stateText || props.stateText,
                onInvalid: onInvalid,
                label: $fe5170bdd3625759$var$getRequiredLabel(props.label, props.required),
                max: props.max || 100,
                min: props.min || 0,
                onBlur: (ev)=>{
                    const currentValue = ev.target.value ? parseInt(ev.target.value) : value;
                    const steppedValue = $fe5170bdd3625759$var$getSteppedValue(currentValue, props.step, props.min, props.max);
                    setValue(steppedValue);
                    const tracker = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value")?.set;
                    tracker?.call(ev.target, currentValue);
                    setInputValue(steppedValue);
                    props?.onChange?.({
                        ...ev,
                        target: {
                            ...ev.target,
                            value: steppedValue
                        }
                    });
                },
                onChange: (ev)=>{
                    setInputValue(parseInt(ev.target.value));
                },
                onValueChange: (ev)=>{
                    setValue(parseInt(ev.target.value));
                    setInputValue(ev.target.value);
                    props?.onChange?.(ev);
                },
                labelMin: Intl.NumberFormat().format(props.min || 0),
                labelMax: Intl.NumberFormat().format(props.max || 100)
            }
        });
    };
const $fe5170bdd3625759$var$Component$8 = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$7;
    const { editableTextBox: editableTextBox = false, state: state = "undefined", disabled: disabled = false, onValueChange: onValueChange = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onEditChange: onEditChange = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onFocus: onFocus = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onBlur: onBlur = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onChange: onChange = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSubmit: onSubmit = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), ariaLabel: ariaLabel = props.label?.toString(), _ariaValuenow: _ariaValuenow = props.value?.toString(), _ariaValuemin: _ariaValuemin = props.min?.toString(), _ariaValuemax: _ariaValuemax = props.max?.toString(), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            editableTextBox: editableTextBox,
            state: state,
            disabled: disabled,
            onValueChange: onValueChange,
            onEditChange: onEditChange,
            onFocus: onFocus,
            onBlur: onBlur,
            onChange: onChange,
            onSubmit: onSubmit,
            ariaLabel: ariaLabel,
            _ariaValuenow: _ariaValuenow,
            _ariaValuemin: _ariaValuemin,
            _ariaValuemax: _ariaValuemax,
            ...rest
        },
        componentTag: componentTag
    }, "JDSSlider", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$97be854b3aad3c92 = $fe5170bdd3625759$var$withLogic$7($fe5170bdd3625759$var$Component$8);
$fe5170bdd3625759$export$97be854b3aad3c92.displayName = "InputSlider";
$fe5170bdd3625759$export$97be854b3aad3c92.slotName = "jds_slider";
const $fe5170bdd3625759$var$sdl$6 = {
    "metadata": {
        "version": "1.0.0",
        "id": "table-1.0.0",
        "name": "JDSTable",
        "layerName": "jds_table",
        "description": "Simple tables display information in a tabular data format with rows and columns. The organize information in a way that's easy to scan so that users can look for patterns and develop insights from data.",
        "usage": "Simple tables are used on wide viewports only or whenever their layout can easily fit in the screen - not too many columns."
    },
    "hierarchy": {
        "container": [
            "jds_table_body",
            "footer-jds-text"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{t_0}",
            "border-radius": "{t_2}",
            "border-width": "{t_3}",
            "border-color": "{t_4}",
            "overflow": "hidden",
            "align-items": "{t_6}"
        },
        "footer-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey100}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "padding-left": "{t_7}",
            "padding-right": "{t_8}",
            "padding-top": "{t_9}",
            "padding-bottom": "{t_10}",
            "hidden": true
        }
    },
    "variant": {
        "density": {
            "condensed": {
                "jds_table_body": {
                    "density": "condensed"
                },
                "footer-jds-text": {
                    "padding-left": "{t_11}",
                    "padding-right": "{t_12}",
                    "padding-top": "{t_13}",
                    "padding-bottom": "{t_14}"
                }
            }
        },
        "columnDivider": {
            "true": {
                "jds_table_body": {
                    "columnDivider": true
                }
            }
        },
        "fullWidth": {
            "true": {
                "container": {
                    "width": "{t_5}"
                },
                "jds_table_body": {
                    "fullWidth": true
                }
            }
        },
        "_hasFooter": {
            "true": {
                "footer-jds-text": {
                    "hidden": false
                }
            }
        }
    },
    "api": {
        "config": {
            "density": {
                "type": "JDSTableCell.density",
                "values": [
                    "relaxed",
                    "condensed"
                ]
            },
            "background": {
                "values": [
                    false,
                    true
                ]
            },
            "columnDivider": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "Show/hide border between columns."
            },
            "fullWidth": {
                "values": [
                    false,
                    true
                ]
            },
            "_hasFooter": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds_table_body": {
                "rows": {
                    "name": "rows",
                    "type": "list",
                    "object": {
                        "cells": "list"
                    },
                    "doc_description": "Pass rows as an array of objects {[HEADER_NAME_1]?: , [HEADER_NAME_2]?:...}, where each row is an object where:\n- the properties are equal to header names\n- values are displayed in columns\n- properties for non-existent header.name are ignored, warning is displayed\n- missing header property results in empty column"
                },
                "zebra": {
                    "type": "boolean",
                    "name": "zebra"
                },
                "background": {
                    "type": "boolean",
                    "name": "background"
                }
            },
            "footer-jds-text": {
                "value": {
                    "type": "string",
                    "name": "footer",
                    "doc_description": "Optional text at the bottom."
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "table"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "value": "table"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$6 = (Component)=>(props)=>{
        const isZebra = props.rowStyle === "zebra" || props.zebra;
        const rows = props.headers.map((header)=>({
                cells: [
                    {
                        text: header.value,
                        type: "header",
                        background: props.headerBackground || props.background
                    },
                    ...props.rows.map((row, i)=>({
                            text: row[header.name] || `\xa0`,
                            background: isZebra && i % 2 === 0
                        }))
                ]
            }));
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                rows: rows,
                background: Boolean(props.headerBackground),
                _hasFooter: Boolean(props.footer)
            }
        });
    };
const $fe5170bdd3625759$var$Component$7 = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$6;
    const { density: density = "undefined", background: background = false, columnDivider: columnDivider = false, fullWidth: fullWidth = false, ariaLabel: ariaLabel = "table", custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            density: density,
            background: background,
            columnDivider: columnDivider,
            fullWidth: fullWidth,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSTable", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$54ec01a60f47d33d = $fe5170bdd3625759$var$withLogic$6($fe5170bdd3625759$var$Component$7);
$fe5170bdd3625759$export$54ec01a60f47d33d.displayName = "Table";
$fe5170bdd3625759$export$54ec01a60f47d33d.slotName = "jds_table";
const $fe5170bdd3625759$var$sdl$5 = {
    "metadata": {
        "version": "1.0.1",
        "id": "test-1.0.1",
        "name": "TestComponent",
        "layerName": "test_component",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "heading-text",
            "icon",
            "image"
        ]
    },
    "base": {
        "container": {
            "padding-top": "50",
            "padding-right": "50",
            "padding-bottom": "50",
            "padding-left": "50",
            "background-color": "blue",
            "border-color": "",
            "border-radius": "",
            "border-width": "",
            "border-style": "",
            "height": "",
            "width": "",
            "max-height": "",
            "min-height": "",
            "max-width": "",
            "min-width": "",
            "box-shadow": {
                "x": 0,
                "y": 4,
                "blur": 16,
                "spread": 0,
                "color": "#00000014"
            },
            "opacity": "",
            "align-items": "",
            "justify-content": "",
            "flex-direction": "",
            "gap": "",
            "display": "",
            "outline": "",
            "pointer-events": "",
            "cursor": "",
            "z-index": ""
        },
        "heading-text": {
            "color": "#f4f4f4",
            "align-items": "",
            "flex-direction": "",
            "font-family": "",
            "font-size": "",
            "font-weight": "",
            "gap": "",
            "justify-content": "",
            "letter-spacing": "",
            "line-height": "",
            "opacity": "",
            "outline": "",
            "padding-top": 50,
            "padding-right": 50,
            "padding-bottom": 50,
            "padding-left": 50,
            "pointer-events": "",
            "width": "",
            "z-index": "",
            "text-decoration": "",
            "text-overflow": "",
            "text-transform": ""
        },
        "icon": {
            "background-color": "",
            "color": "",
            "padding-top": 50,
            "padding-right": 50,
            "padding-bottom": 50,
            "padding-left": 50,
            "height": "24",
            "width": "24",
            "size": "{m}",
            "opacity": "",
            "outline": "",
            "justify-content": "",
            "box-shadow": {
                "x": 0,
                "y": 4,
                "blur": 16,
                "spread": 0,
                "color": "#00000014"
            },
            "align-items": "",
            "box-sizing": ""
        },
        "image": {
            "align-items": "",
            "aspect-ratio": "{aspect_ratio.1.1}",
            "border-radius": "",
            "opacity": "",
            "hidden": true,
            "padding-top": "50",
            "padding-right": "50",
            "padding-bottom": "50",
            "padding-left": "50",
            "pointer-events": "",
            "box-shadow": {
                "x": 0,
                "y": 4,
                "blur": 16,
                "spread": 0,
                "color": "#00000014"
            },
            "object-fit": "",
            "object-position": ""
        }
    },
    "variant": {
        "kind": {
            "SERVICE": {
                "container": {
                    "border-radius": "{pill}",
                    "background-color": "#75757580",
                    "padding-top": "{xxs}",
                    "padding-left": "{xxs}",
                    "padding-right": "{s}",
                    "padding-bottom": "{xxs}",
                    "gap": "{xs}"
                },
                "heading-text": {
                    "appearance": "BODY_M_BOLD",
                    "color": "WHITE"
                },
                "icon": {
                    "size": "{m}",
                    "color": "{global.transparent}"
                }
            }
        }
    },
    "api": {
        "data": {
            "heading-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            },
            "icon": {
                "value": {
                    "type": "icon",
                    "name": "icon"
                }
            },
            "image": {
                "value": {
                    "type": "image",
                    "name": "image"
                }
            }
        },
        "config": {
            "kind": {
                "values": [
                    "NORMAL",
                    "SERVICE"
                ]
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$5 = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    };
const $fe5170bdd3625759$var$Component$6 = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$5;
    const { kind: kind = "NORMAL", custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            ...rest
        },
        componentTag: componentTag
    }, "TestComponent", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$d8fd24743e1b801f = $fe5170bdd3625759$var$withLogic$5($fe5170bdd3625759$var$Component$6);
$fe5170bdd3625759$export$d8fd24743e1b801f.displayName = "TestComponent";
$fe5170bdd3625759$export$d8fd24743e1b801f.slotName = "test_component";
const $fe5170bdd3625759$var$sdl$4 = {
    "metadata": {
        "version": "1.0.0",
        "id": "textarea-1.0.0",
        "name": "JDSTextarea",
        "layerName": "jds_textarea",
        "description": "A Textarea lets a user input a longer amount of text than an input field, typically spanning across multiple lines.",
        "usage": "Use a textarea when the input being expected is likely to extend beyond one line."
    },
    "hierarchy": {
        "container": [
            "label-border-jds-text",
            {
                "field-container": [
                    "input_label-jds-text",
                    {
                        "input-container": [
                            "input"
                        ]
                    }
                ]
            },
            {
                "active-line-container": [
                    "feedback-container"
                ]
            },
            "jds_feedback_block",
            "helper-jds-text"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{t_0}",
            "justify-content": "{t_1}",
            "align-items": "{t_2}",
            "gap": "{t_3}",
            "width": "{t_4}",
            "opacity": "{t_42}",
            "behavior": {
                "hover": {}
            }
        },
        "field-container": {
            "flex-direction": "{t_5}",
            "width": "{t_6}",
            "padding-bottom": "{t_7}",
            "justify-content": "{t_8}",
            "align-items": "{t_9}"
        },
        "input-container": {
            "flex-direction": "{t_10}",
            "justify-content": "{t_11}",
            "width": "{t_12}",
            "padding-top": 20,
            "align-items": "{t_13}",
            "z-index": 0
        },
        "input": {
            "disabled": false,
            "type": "textarea",
            "flex": 1,
            "text-align": "{t_14}",
            "placeholder-color": "{t_15}",
            "placeholder-font-family": "{t_16}",
            "placeholder-font-size": "{t_17}",
            "placeholder-line-height": "{t_18}",
            "placeholder-letter-spacing": "{t_19}",
            "placeholder-font-weight": "{t_20}",
            "input-color": "{t_21}",
            "input-font-family": "{t_22}",
            "input-font-size": "{t_23}",
            "input-line-height": "{t_24}",
            "input-letter-spacing": "{t_25}",
            "input-font-weight": "{t_26}",
            "resize-color": "{t_27}",
            "cursor-color": "{t_28}",
            "width": "{t_29}",
            "behavior": {
                "hover": {
                    "resize-color": "{t_30}"
                },
                "focus": {
                    "resize-color": "{t_31}"
                },
                "active": {
                    "resize-color": "{t_32}"
                }
            }
        },
        "active-line-container": {
            "flex-direction": "{t_33}",
            "width": "{t_34}",
            "align-items": "{t_35}",
            "padding-top": 1,
            "padding-bottom": 1
        },
        "feedback-container": {
            "width": "{t_36}",
            "height": 2,
            "background-color": "{t_37}",
            "border-radius": 48,
            "show": true,
            "hidden": false,
            "behavior": {
                "hover": {
                    "background-color": "{t_38}"
                },
                "focus": {
                    "background-color": "{t_39}"
                },
                "active": {
                    "background-color": "{t_40}"
                }
            }
        },
        "jds_feedback_block": {
            "size": "s",
            "state": "none"
        },
        "label-border-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 1,
            "textType": "label",
            "hidden": true,
            "maxLines": 1
        },
        "input_label-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 1,
            "textType": "label",
            "maxLines": 1,
            "z-index": 1
        },
        "helper-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "disabled": {
            "true": {
                "container": {
                    "opacity": "{t_41}"
                },
                "input": {
                    "disabled": true
                }
            }
        },
        "border": {
            "true": {
                "feedback-container": {
                    "hidden": true
                },
                "input-container": {
                    "padding-top": "{t_45}"
                },
                "field-container": {
                    "border-width": "{t_43}",
                    "border-color": "{t_44}",
                    "border-radius": "{t_46}",
                    "padding-top": "{t_45}",
                    "padding-bottom": "{t_47}",
                    "padding-left": "{t_48}",
                    "padding-right": "{t_49}"
                },
                "input_label-jds-text": {
                    "hidden": true
                },
                "label-border-jds-text": {
                    "hidden": false
                }
            }
        },
        "state": {
            "success": {
                "feedback-container": {
                    "background-color": "{t_50}",
                    "behavior": {
                        "hover": {
                            "background-color": "{t_51}"
                        },
                        "focus": {
                            "background-color": "{t_52}"
                        },
                        "active": {
                            "background-color": "{t_53}"
                        }
                    }
                },
                "field-container": {
                    "border-color": "{t_50}"
                },
                "input": {
                    "resize-color": "{t_54}",
                    "behavior": {
                        "hover": {
                            "resize-color": "{t_55}"
                        },
                        "focus": {
                            "resize-color": "{t_56}"
                        },
                        "active": {
                            "resize-color": "{t_57}"
                        }
                    }
                },
                "jds_feedback_block": {
                    "state": "success"
                }
            },
            "error": {
                "feedback-container": {
                    "background-color": "{t_58}",
                    "behavior": {
                        "hover": {
                            "background-color": "{t_59}"
                        },
                        "focus": {
                            "background-color": "{t_60}"
                        },
                        "active": {
                            "background-color": "{t_61}"
                        }
                    }
                },
                "field-container": {
                    "border-color": "{t_58}"
                },
                "input": {
                    "resize-color": "{t_62}",
                    "behavior": {
                        "hover": {
                            "resize-color": "{t_63}"
                        },
                        "focus": {
                            "resize-color": "{t_64}"
                        },
                        "active": {
                            "resize-color": "{t_65}"
                        }
                    }
                },
                "jds_feedback_block": {
                    "state": "error"
                }
            },
            "warning": {
                "feedback-container": {
                    "background-color": "{t_66}",
                    "behavior": {
                        "hover": {
                            "background-color": "{t_67}"
                        },
                        "focus": {
                            "background-color": "{t_68}"
                        },
                        "active": {
                            "background-color": "{t_69}"
                        }
                    }
                },
                "field-container": {
                    "border-color": "{t_66}"
                },
                "input": {
                    "resize-color": "{t_70}",
                    "behavior": {
                        "hover": {
                            "resize-color": "{t_71}"
                        },
                        "focus": {
                            "resize-color": "{t_72}"
                        },
                        "active": {
                            "resize-color": "{t_73}"
                        }
                    }
                },
                "jds_feedback_block": {
                    "state": "warning"
                }
            }
        },
        "_labelFocus": {
            "true": {
                "field-container": {
                    "align-items": "{t_74}"
                },
                "input_label-jds-text": {
                    "font-family": "{bodyXs}",
                    "font-size": "{bodyXs}",
                    "line-height": "{bodyXs}",
                    "letter-spacing": "{bodyXs}",
                    "font-weight": "{bodyXs}",
                    "padding-top": 0
                }
            }
        }
    },
    "combination": [
        {
            "none": {
                "true": {
                    "feedback-container": {
                        "background-color": "{t_75}"
                    },
                    "input": {
                        "resize-color": "{t_76}"
                    }
                }
            }
        },
        {
            "true": {
                "true": {
                    "field-container": {
                        "border-color": "{t_77}"
                    },
                    "input": {
                        "input-color": "{t_79}",
                        "disabled": true,
                        "resize-color": "{t_78}",
                        "behavior": {
                            "hover": {
                                "resize-color": "{t_78}"
                            },
                            "focus": {
                                "resize-color": "{t_78}"
                            },
                            "active": {
                                "resize-color": "{t_78}"
                            }
                        }
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "state",
            "_inputFocus"
        ],
        [
            "border",
            "readOnly"
        ]
    ],
    "api": {
        "config": {
            "disabled": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to enable or disable SearchBox."
            },
            "border": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can change the border of textArea"
            },
            "state": {
                "type": "JDSFeedbackBlock.state",
                "doc_description": "It can be used to choose between states i.e. 'success','warning','error','none'.",
                "values": [
                    "none",
                    "success",
                    "error",
                    "warning"
                ]
            },
            "_labelFocus": {
                "values": [
                    false,
                    true
                ]
            },
            "_inputFocus": {
                "values": [
                    false,
                    true
                ]
            },
            "readOnly": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It is used when border is set to true"
            }
        },
        "data": {
            "input": {
                "id": {
                    "type": "string",
                    "name": "id",
                    "platform": "web"
                },
                "name": {
                    "type": "string",
                    "name": "name"
                },
                "value": {
                    "type": "string",
                    "name": "value"
                },
                "rows": {
                    "type": "number",
                    "name": "rows"
                },
                "minLines": {
                    "type": "number",
                    "name": "minLines"
                },
                "placeholder": {
                    "type": "string",
                    "name": "placeholder"
                },
                "max-length": {
                    "type": "number",
                    "name": "maxLength"
                },
                "required": {
                    "type": "boolean",
                    "name": "required"
                },
                "focusRequester": {
                    "type": "focusRequester",
                    "name": "focusRequester",
                    "platform": "android"
                },
                "imeAction": {
                    "type": "imeAction",
                    "name": "imeAction",
                    "platform": "android"
                },
                "capitalization": {
                    "type": "keyboardCapitalization",
                    "name": "capitalization",
                    "platform": "android"
                },
                "semantics": {
                    "type": "string",
                    "name": "semantics",
                    "platform": "android"
                }
            },
            "jds_feedback_block": {
                "stateText": {
                    "type": "string",
                    "name": "stateText",
                    "doc_description": "It displays message with respect to its [state] selected."
                }
            },
            "label-border-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label",
                    "doc_description": "It displays label of Textarea."
                },
                "id": {
                    "type": "string",
                    "name": "id",
                    "platform": "web"
                }
            },
            "input_label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label",
                    "doc_description": "It displays label of Textarea."
                },
                "id": {
                    "type": "string",
                    "name": "id",
                    "platform": "web"
                }
            },
            "helper-jds-text": {
                "value": {
                    "type": "string",
                    "name": "helperText",
                    "doc_description": "It displays helper text of Textarea."
                }
            }
        },
        "events": {
            "input": {
                "onFocus": "onFocus",
                "onBlur": "onBlur",
                "onChange": "onChange",
                "onKeydown": {
                    "name": "onKeydown",
                    "platform": "web"
                },
                "onInvalid": "onInvalid",
                "onSubmit": "onSubmit"
            }
        },
        "a11y": {
            "input": {
                "properties": {
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "aria-invalid": "ariaInvalid",
                    "aria-placeholder": {
                        "name": "_ariaPlaceholder",
                        "prop": "placeholder"
                    },
                    "aria-required": {
                        "name": "_ariaRequired",
                        "prop": "required"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$4 = (Component)=>(0, $acw62.forwardRef)((props, ref)=>{
        const { rootRef: rootRef, element: element } = $fe5170bdd3625759$var$useRootRef();
        const { focused: focused, _inputFocused: _inputFocused, ...rest } = $fe5170bdd3625759$var$useFocusedLabel(props, element);
        const { inputState: inputState, onInvalid: onInvalid, stateText: stateText } = $fe5170bdd3625759$var$useInputState(props.state, props.required, props.onInvalid, props.stateConfig, props.stateText);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                ...rest,
                rootRef: rootRef,
                label: $fe5170bdd3625759$var$getRequiredLabel(props.label, props.required),
                _labelFocus: focused,
                _inputFocus: _inputFocused,
                state: inputState,
                stateText: stateText,
                onInvalid: onInvalid,
                layerRefs: {
                    input: ref
                }
            }
        });
    });
const $fe5170bdd3625759$var$Component$5 = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$4;
    const { disabled: disabled = false, border: border = false, state: state = "undefined", readOnly: readOnly = false, onFocus: onFocus = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onBlur: onBlur = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onChange: onChange = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onInvalid: onInvalid = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSubmit: onSubmit = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), ariaLabel: ariaLabel = props.label?.toString(), _ariaPlaceholder: _ariaPlaceholder = props.placeholder?.toString(), _ariaRequired: _ariaRequired = props.required?.toString(), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            disabled: disabled,
            border: border,
            state: state,
            readOnly: readOnly,
            onFocus: onFocus,
            onBlur: onBlur,
            onChange: onChange,
            onInvalid: onInvalid,
            onSubmit: onSubmit,
            ariaLabel: ariaLabel,
            _ariaPlaceholder: _ariaPlaceholder,
            _ariaRequired: _ariaRequired,
            ...rest
        },
        componentTag: componentTag
    }, "JDSTextarea", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$3d88bd58d836b21e = $fe5170bdd3625759$var$withLogic$4($fe5170bdd3625759$var$Component$5);
$fe5170bdd3625759$export$3d88bd58d836b21e.displayName = "InputTextarea";
$fe5170bdd3625759$export$3d88bd58d836b21e.slotName = "jds_textarea";
const $fe5170bdd3625759$var$sdl$3 = {
    "metadata": {
        "version": "1.0.0",
        "id": "toggle-1.0.0",
        "name": "JDSToggle",
        "description": "Interaction element for decision making that may or may not be accompanied by a label, depending on the context of use.",
        "layerName": "jds_toggle"
    },
    "hierarchy": {
        "vertical-container": [
            {
                "horizontal-container": [
                    {
                        "prefix-icon-container": [
                            {
                                "toggle-jds-icon-container": [
                                    "toggle-jds-icon"
                                ]
                            }
                        ]
                    },
                    "left-jds-text",
                    {
                        "pill-container": [
                            "ball-container"
                        ]
                    },
                    "right-jds-text"
                ]
            },
            "jds_feedback_block",
            "helper-jds-text"
        ]
    },
    "base": {
        "vertical-container": {
            "hidden": false,
            "flex-direction": "{t_1}",
            "justify-content": "{t_2}",
            "align-items": "{t_3}",
            "gap": "{t_4}",
            "opacity": "{t_42}"
        },
        "horizontal-container": {
            "hidden": false,
            "flex-direction": "{t_5}",
            "justify-content": "{t_6}",
            "align-items": "{t_7}",
            "gap": "{t_8}",
            "behavior": {
                "hover": {},
                "active": {},
                "focus": {}
            }
        },
        "pill-container": {
            "hidden": false,
            "min-width": "{t_9}",
            "min-height": "{t_10}",
            "flex-direction": "{t_11}",
            "justify-content": "{t_12}",
            "align-items": "{t_13}",
            "padding-left": "{t_14}",
            "padding-right": "{t_15}",
            "background-color": "{t_16}",
            "border-radius": "{t_17}",
            "border-width": "{t_18}",
            "border-color": "{t_19}",
            "behavior": {
                "hover": {
                    "border-color": "{t_20}"
                },
                "active": {
                    "border-color": "{t_21}"
                },
                "focus": {
                    "border-width": "{t_24}",
                    "box-shadow": {
                        "x": 0,
                        "y": 0,
                        "blur": 0,
                        "spread": "{t_22}",
                        "color": "{t_23}"
                    }
                }
            }
        },
        "ball-container": {
            "hidden": false,
            "min-width": "{t_25}",
            "min-height": "{t_26}",
            "background-color": "{t_27}",
            "border-radius": "{t_28}",
            "show": true
        },
        "prefix-icon-container": {
            "flex-direction": "{t_0}"
        },
        "jds_feedback_block": {
            "size": "l"
        },
        "left-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false,
            "text-align": "{t_29}",
            "flex-fill-android": false,
            "behavior": {
                "hover": {
                    "color": "{primaryGrey100}"
                },
                "focus": {
                    "color": "{primaryGrey100}"
                }
            }
        },
        "right-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": true,
            "behavior": {
                "hover": {
                    "color": "{primaryGrey100}"
                },
                "focus": {
                    "color": "{primaryGrey100}"
                }
            }
        },
        "toggle-jds-icon": {
            "size": "{m}",
            "color": "{primaryGrey80}"
        },
        "toggle-jds-icon-container": {
            "background-color": "{global.transparent}",
            "border-radius": "{pill}",
            "size": "{m}",
            "justify-content": "{justifyContent.center}",
            "align-items": "{alignItems.center}"
        },
        "helper-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false
        }
    },
    "variant": {
        "size": {
            "small": {
                "pill-container": {
                    "min-width": "{t_30}",
                    "min-height": "{t_31}"
                },
                "vertical-container": {
                    "gap": "{t_32}"
                },
                "ball-container": {
                    "min-width": "{t_33}",
                    "min-height": "{t_34}"
                },
                "jds_feedback_block": {
                    "size": "s"
                },
                "left-jds-text": {
                    "font-family": "{bodyXs}",
                    "font-size": "{bodyXs}",
                    "line-height": "{bodyXs}",
                    "letter-spacing": "{bodyXs}",
                    "font-weight": "{bodyXs}"
                },
                "right-jds-text": {
                    "font-family": "{bodyXs}",
                    "font-size": "{bodyXs}",
                    "line-height": "{bodyXs}",
                    "letter-spacing": "{bodyXs}",
                    "font-weight": "{bodyXs}"
                },
                "toggle-jds-icon": {
                    "size": "{base}"
                },
                "toggle-jds-icon-container": {
                    "background-color": "{global.transparent}",
                    "border-radius": "{pill}",
                    "size": "{base}",
                    "justify-content": "{justifyContent.center}",
                    "align-items": "{alignItems.center}"
                },
                "helper-jds-text": {
                    "font-family": "{bodyXs}",
                    "font-size": "{bodyXs}",
                    "line-height": "{bodyXs}",
                    "letter-spacing": "{bodyXs}",
                    "font-weight": "{bodyXs}"
                }
            }
        },
        "labelPosition": {
            "right": {
                "left-jds-text": {
                    "hidden": true
                },
                "right-jds-text": {
                    "hidden": false
                }
            }
        },
        "_hasIcon": {
            "false": {
                "prefix-icon-container": {
                    "hidden": true
                }
            }
        },
        "checked": {
            "true": {
                "pill-container": {
                    "justify-content": "{t_35}",
                    "background-color": "{t_36}",
                    "border-width": "{t_37}",
                    "behavior": {
                        "hover": {
                            "background-color": "{t_38}"
                        },
                        "active": {
                            "background-color": "{t_39}"
                        }
                    }
                },
                "ball-container": {
                    "background-color": "{t_40}"
                },
                "left-jds-text": {
                    "color": "{primaryGrey100}"
                },
                "right-jds-text": {
                    "color": "{primaryGrey100}"
                },
                "toggle-jds-icon": {},
                "toggle-jds-icon-container": {
                    "background-color": "{global.transparent}",
                    "border-radius": "{pill}",
                    "size": "{m}",
                    "justify-content": "{justifyContent.center}",
                    "align-items": "{alignItems.center}"
                }
            }
        },
        "disabled": {
            "true": {
                "horizontal-container": {
                    "disabled": true
                },
                "prefix-icon-container": {
                    "disabled": true
                },
                "vertical-container": {
                    "opacity": "{t_41}"
                }
            }
        }
    },
    "api": {
        "config": {
            "checked": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to programatically make input active/inactive."
            },
            "labelPosition": {
                "values": [
                    "left",
                    "right"
                ],
                "doc_description": "It can be used to position lable to either left or right of Toggle."
            },
            "size": {
                "values": [
                    "medium",
                    "small"
                ],
                "doc_description": "It can be used control the size of Toggle."
            },
            "disabled": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to enable or disable Toggle."
            },
            "_hasIcon": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to show or hide the prefix icon container."
            }
        },
        "data": {
            "jds_feedback_block": {
                "stateText": {
                    "type": "string",
                    "name": "stateText",
                    "doc_description": "It displays message with respect to its [state] selected."
                },
                "state": {
                    "type": "JDSFeedbackBlock.state",
                    "name": "state",
                    "doc_description": "It can be used to choose between states i.e. 'success','warning','error','none'."
                }
            },
            "left-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label",
                    "doc_description": "It displays label of Toggle."
                }
            },
            "right-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label",
                    "doc_description": "It displays label of Toggle."
                }
            },
            "toggle-jds-icon": {
                "value": {
                    "type": "icon",
                    "name": "icon",
                    "doc_description": "Take icon input for Toggle."
                },
                "ic": {
                    "type": "icon",
                    "name": "icon",
                    "doc_description": "Take icon input for Toggle."
                }
            },
            "helper-jds-text": {
                "value": {
                    "type": "string",
                    "name": "helperText",
                    "doc_description": "It displays helper text of Toggle."
                }
            }
        },
        "events": {
            "horizontal-container": {
                "onClick": "onClick"
            },
            "prefix-icon-container": {
                "onClick": "onPrefixClick"
            }
        },
        "a11y": {
            "vertical-container": {
                "properties": {
                    "role": {
                        "value": "switch"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "aria-checked": {
                        "name": "_ariaChecked",
                        "prop": "checked"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$useSwitch = (value)=>{
    const [switchState, setSwitchState] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        setSwitchState(Boolean(value));
    }, [
        value
    ]);
    return {
        switchState: switchState,
        onChange: (value2)=>setSwitchState(value2)
    };
};
const $fe5170bdd3625759$var$withLogic$3 = (Component)=>(props)=>{
        const { switchState: switchState, onChange: onChange } = $fe5170bdd3625759$var$useSwitch(props.checked);
        const { stateText: stateText, inputState: inputState } = $fe5170bdd3625759$var$useInputState(props.state, false, void 0, props.stateConfig, props.stateText);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                _hasIcon: Boolean(props.icon || props.prefix),
                state: inputState,
                stateText: stateText,
                icon: props.icon,
                checked: switchState,
                onClick: (ev)=>{
                    onChange?.(!switchState);
                    props.onChange?.({
                        ...ev,
                        target: {
                            ...ev.target,
                            value: props.value || "",
                            checked: !switchState
                        }
                    });
                }
            }
        });
    };
const $fe5170bdd3625759$var$Component$4 = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$3;
    const { checked: checked = false, labelPosition: labelPosition = "left", size: size = "medium", disabled: disabled = false, onClick: onClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onPrefixClick: onPrefixClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), ariaLabel: ariaLabel = props.label?.toString(), _ariaChecked: _ariaChecked = props.checked?.toString(), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            checked: checked,
            labelPosition: labelPosition,
            size: size,
            disabled: disabled,
            onClick: onClick,
            onPrefixClick: onPrefixClick,
            ariaLabel: ariaLabel,
            _ariaChecked: _ariaChecked,
            ...rest
        },
        componentTag: componentTag
    }, "JDSToggle", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$ed3c6fc36a947b6a = $fe5170bdd3625759$var$withLogic$3($fe5170bdd3625759$var$Component$4);
$fe5170bdd3625759$export$ed3c6fc36a947b6a.displayName = "InputToggle";
$fe5170bdd3625759$export$ed3c6fc36a947b6a.slotName = "jds_toggle";
const $fe5170bdd3625759$var$sdl$2 = {
    "metadata": {
        "version": "2.0.0",
        "id": "input-field-2.0.0",
        "name": "JDSInputFieldV2",
        "layerName": "jds_input_field_v2"
    },
    "hierarchy": {
        "container": [
            {
                "label-container": [
                    "input_label-jds-text",
                    "info-slot"
                ]
            },
            {
                "input-container": [
                    "prefix-slot",
                    "jds_input",
                    "suffix-slot"
                ]
            },
            {
                "helper-container": [
                    "jds_feedback_block",
                    "helper-jds-text"
                ]
            },
            {
                "dynamic-container": [
                    "dynamic-jds-text",
                    "dynamic-jds_action_button"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{i_1}",
            "width": "{i_2}",
            "justify-content": "{i_3}",
            "align-items": "{i_4}",
            "opacity": "{i_5}",
            "gap": "{i_9}"
        },
        "label-container": {
            "flex-direction": "{i_6}",
            "justify-content": "{i_7}",
            "align-items": "{i_8}",
            "gap": "{i_9}"
        },
        "input-container": {
            "flex-direction": "{i_13}",
            "justify-content": "{i_14}",
            "align-items": "{i_15}",
            "width": "{i_16}",
            "height": "{i_17}",
            "gap": "{i_18}",
            "padding-left": "{i_19}",
            "padding-right": "{i_20}",
            "border-width": "{i_23}",
            "border-color": "{i_24}",
            "border-radius": "{i_26}",
            "behavior": {
                "hover": {
                    "border-color": "{i_27}"
                },
                "active": {
                    "border-color": "{i_28}"
                },
                "focus": {
                    "border-color": "{i_29}"
                }
            }
        },
        "jds_input": {
            "type": "text",
            "textAlign": "{i_30}",
            "rows": 1,
            "flex": "{i_31}"
        },
        "helper-container": {
            "flex-direction": "{i_32}",
            "justify-content": "{i_33}",
            "align-items": "{i_34}",
            "gap": "{i_35}"
        },
        "jds_feedback_block": {
            "size": "s",
            "state": "none",
            "alignment": "top"
        },
        "dynamic-container": {
            "flex-direction": "{i_40}",
            "justify-content": "{i_41}",
            "align-items": "{i_42}",
            "gap": "{i_36}",
            "hidden": false
        },
        "dynamic-jds_action_button": {
            "kind": "tertiary",
            "size": "small"
        },
        "input_label-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 1,
            "textType": "label",
            "maxLines": 1
        },
        "helper-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        },
        "dynamic-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey60}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "_hasDynamic": {
            "false": {
                "dynamic-container": {
                    "hidden": true
                }
            }
        },
        "_noPrefix": {
            "true": {
                "input-container": {
                    "padding-left": "{i_0}"
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "opacity": "{i_45}",
                    "disabled": true
                },
                "jds_input": {
                    "disabled": true
                },
                "prefix-slot": {
                    "disabled": true
                },
                "suffix-slot": {
                    "disabled": true
                }
            }
        },
        "state": {
            "success": {
                "input-container": {
                    "border-color": "{i_46}",
                    "behavior": {
                        "hover": {
                            "border-color": "{i_47}"
                        },
                        "focus": {
                            "border-color": "{i_48}"
                        },
                        "active": {
                            "border-color": "{i_49}"
                        }
                    }
                },
                "jds_feedback_block": {
                    "state": "success"
                }
            },
            "error": {
                "input-container": {
                    "border-color": "{i_50}",
                    "behavior": {
                        "hover": {
                            "border-color": "{i_51}"
                        },
                        "focus": {
                            "border-color": "{i_52}"
                        },
                        "active": {
                            "border-color": "{i_53}"
                        }
                    }
                },
                "jds_feedback_block": {
                    "state": "error"
                }
            },
            "warning": {
                "input-container": {
                    "border-color": "{i_54}",
                    "behavior": {
                        "hover": {
                            "border-color": "{i_55}"
                        },
                        "focus": {
                            "border-color": "{i_56}"
                        },
                        "active": {
                            "border-color": "{i_57}"
                        }
                    }
                },
                "jds_feedback_block": {
                    "state": "warning"
                }
            }
        },
        "size": {
            "small": {
                "input-container": {
                    "height": "{i_58}"
                }
            },
            "large": {
                "input-container": {
                    "height": "{i_61}",
                    "gap": "{i_62}",
                    "padding-left": "{i_63}",
                    "padding-right": "{i_64}"
                },
                "jds_feedback_block": {
                    "size": "l"
                },
                "input_label-jds-text": {
                    "font-family": "{bodyS}",
                    "font-size": "{bodyS}",
                    "line-height": "{bodyS}",
                    "letter-spacing": "{bodyS}",
                    "font-weight": "{bodyS}"
                },
                "helper-jds-text": {
                    "font-family": "{bodyS}",
                    "font-size": "{bodyS}",
                    "line-height": "{bodyS}",
                    "letter-spacing": "{bodyS}",
                    "font-weight": "{bodyS}"
                },
                "dynamic-jds-text": {
                    "font-family": "{bodyS}",
                    "font-size": "{bodyS}",
                    "line-height": "{bodyS}",
                    "letter-spacing": "{bodyS}",
                    "font-weight": "{bodyS}"
                }
            }
        },
        "type": {
            "email": {
                "jds_input": {
                    "type": "email"
                }
            },
            "number": {
                "jds_input": {
                    "type": "number"
                }
            },
            "password": {
                "jds_input": {
                    "type": "password"
                }
            },
            "pin": {
                "jds_input": {
                    "type": "number",
                    "letterSpacing": 12,
                    "textAlign": "center"
                }
            },
            "phone": {
                "jds_input": {
                    "type": "phone"
                }
            }
        },
        "readOnly": {
            "true": {
                "jds_input": {
                    "readOnly": true,
                    "color": "primary_grey_80"
                },
                "input-container": {
                    "border-color": "{i_25}"
                }
            }
        }
    },
    "api": {
        "children": {
            "prefix-slot": {
                "name": "prefix",
                "accepts": [
                    "jds_text",
                    "jds_icon",
                    "jds_input_phone_dropdown"
                ],
                "function": true
            },
            "suffix-slot": {
                "name": "suffix",
                "accepts": [
                    "jds_button",
                    "jds_icon",
                    "jds_spinner"
                ],
                "function": true
            },
            "info-slot": {
                "name": "info",
                "accepts": [
                    "any"
                ],
                "max": 1
            }
        },
        "config": {
            "_hasDynamic": {
                "values": [
                    true,
                    false
                ]
            },
            "_noPrefix": {
                "values": [
                    true,
                    false
                ]
            },
            "state": {
                "type": "JDSFeedbackBlock.state",
                "values": [
                    "none",
                    "success",
                    "error",
                    "warning"
                ]
            },
            "size": {
                "values": [
                    "medium",
                    "small",
                    "large"
                ]
            },
            "type": {
                "values": [
                    "text",
                    "email",
                    "number",
                    "password",
                    "pin",
                    "phone"
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            },
            "readOnly": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds_input": {
                "id": {
                    "type": "string",
                    "name": "id",
                    "platform": "web"
                },
                "value": {
                    "type": "string",
                    "name": "value"
                },
                "autocomplete": {
                    "type": "string",
                    "name": "autocomplete",
                    "platform": "web"
                },
                "name": {
                    "type": "string",
                    "name": "name"
                },
                "autoFocus": {
                    "type": "boolean",
                    "name": "autoFocus",
                    "platform": "web,ios"
                },
                "placeholder": {
                    "type": "string",
                    "name": "placeholder"
                },
                "maxLength": {
                    "type": "number",
                    "name": "maxLength"
                },
                "pattern": {
                    "type": "string",
                    "name": "pattern"
                },
                "required": {
                    "type": "boolean",
                    "name": "required"
                },
                "focusRequester": {
                    "type": "focusRequester",
                    "name": "focusRequester",
                    "platform": "android"
                },
                "imeAction": {
                    "type": "imeAction",
                    "name": "imeAction",
                    "platform": "android"
                },
                "capitalization": {
                    "type": "keyboardCapitalization",
                    "name": "capitalization",
                    "platform": "android"
                }
            },
            "jds_feedback_block": {
                "stateText": {
                    "type": "string",
                    "name": "stateText"
                }
            },
            "dynamic-jds_action_button": {
                "label": {
                    "type": "string",
                    "name": "dynamicButtonText"
                }
            },
            "input_label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label",
                    "function": true
                },
                "id": {
                    "type": "string",
                    "name": "id",
                    "platform": "web"
                }
            },
            "helper-jds-text": {
                "value": {
                    "type": "string",
                    "name": "helperText"
                }
            },
            "dynamic-jds-text": {
                "value": {
                    "type": "string",
                    "name": "dynamicText"
                }
            }
        },
        "events": {
            "jds_input": {
                "onFocus": "onFocus",
                "onBlur": "onBlur",
                "onChange": "onChange",
                "onKeydown": {
                    "name": "onKeydown",
                    "platform": "web"
                },
                "onInvalid": "onInvalid",
                "onSubmit": "onSubmit"
            },
            "prefix-slot": {
                "onClick": "onPrefixClick"
            },
            "suffix-slot": {
                "onClick": "onSuffixClick"
            },
            "dynamic-jds_action_button": {
                "onClick": "onButtonClick"
            }
        },
        "a11y": {
            "jds_input": {
                "properties": {
                    "ariaLabel": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "ariaInvalid": "ariaInvalid",
                    "ariaPlaceholder": {
                        "name": "_ariaPlaceholder"
                    },
                    "ariaRequired": {
                        "name": "_ariaRequired",
                        "prop": "required"
                    }
                }
            },
            "dynamic-jds_action_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "dynamicButtonAriaLabel",
                        "prop": "dynamicButtonText"
                    },
                    "ariaDescribedby": {
                        "name": "dynamicButtonAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic$2 = (Component)=>(0, $acw62.forwardRef)((props, ref)=>{
        const handlePrefixClick = (event)=>{
            props.onPrefixClick?.(event);
        };
        const handleSuffixClick = (event)=>{
            props.onSuffixClick?.(event);
        };
        const handlephonetype = (event)=>{
            const { value: value } = event.target;
            if (props.type === "phone") {
                const filteredValue = value.replace(/[^\d+]/g, "");
                event.target.value = filteredValue;
            }
            props.onChange?.(event);
        };
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                layerRefs: {
                    input: ref
                }
            },
            prefix: $fe5170bdd3625759$var$getIcon(props.prefix, handlePrefixClick),
            suffix: $fe5170bdd3625759$var$getIcon(props.suffix, handleSuffixClick),
            label: $fe5170bdd3625759$var$getRequiredLabel(props.label, props.required),
            _hasDynamic: Boolean(props.dynamicText || props.dynamicButtonText),
            _noPrefix: !props.prefix,
            onChange: handlephonetype
        });
    });
const $fe5170bdd3625759$var$Component$3 = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$2;
    const { state: state = "undefined", size: size = "medium", type: type = "text", disabled: disabled = false, readOnly: readOnly = false, onFocus: onFocus = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onBlur: onBlur = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onChange: onChange = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onInvalid: onInvalid = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSubmit: onSubmit = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onPrefixClick: onPrefixClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onSuffixClick: onSuffixClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), onButtonClick: onButtonClick = (0, $8bd3c5c9ee0d1eb4$export$8793edee2d425525), ariaLabel: ariaLabel = props.label?.toString(), dynamicButtonAriaLabel: dynamicButtonAriaLabel = props.dynamicButtonText?.toString(), _ariaRequired: _ariaRequired = props.required?.toString(), custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...{
            state: state,
            size: size,
            type: type,
            disabled: disabled,
            readOnly: readOnly,
            onFocus: onFocus,
            onBlur: onBlur,
            onChange: onChange,
            onInvalid: onInvalid,
            onSubmit: onSubmit,
            onPrefixClick: onPrefixClick,
            onSuffixClick: onSuffixClick,
            onButtonClick: onButtonClick,
            ariaLabel: ariaLabel,
            dynamicButtonAriaLabel: dynamicButtonAriaLabel,
            _ariaRequired: _ariaRequired,
            ...rest
        },
        componentTag: componentTag
    }, "JDSInputFieldV2", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$export$ac0438506784559a = $fe5170bdd3625759$var$withLogic$2($fe5170bdd3625759$var$Component$3);
$fe5170bdd3625759$export$ac0438506784559a.displayName = "InputFieldV2";
$fe5170bdd3625759$export$ac0438506784559a.slotName = "jds_input_field_v2";
const $fe5170bdd3625759$var$PROP_MAP = (props)=>({
        color: {
            properties: {},
            variations: {
                "primary-grey-100": {
                    color: "primary_grey_100"
                },
                "primary-80": {
                    color: "primary_80"
                },
                "primary-70": {
                    color: "primary_70"
                },
                "primary-60": {
                    color: "primary_60"
                },
                "primary-50": {
                    color: "primary_50"
                },
                "primary-40": {
                    color: "primary_40"
                },
                "primary-30": {
                    color: "primary_30"
                },
                "primary-20": {
                    color: "primary_20"
                },
                "primary-inverse": {
                    color: "primary_inverse"
                },
                "primary-background": {
                    color: "primary_background"
                },
                "primary-grey-80": {
                    color: "primary_grey_80"
                },
                "primary-grey-60": {
                    color: "primary_grey_60"
                },
                "primary-grey-40": {
                    color: "primary_grey_40"
                },
                "primary-grey-20": {
                    color: "primary_grey_20"
                },
                "secondary-80": {
                    color: "secondary_80"
                },
                "secondary-70": {
                    color: "secondary_70"
                },
                "secondary-60": {
                    color: "secondary_60"
                },
                "secondary-50": {
                    color: "secondary_50"
                },
                "secondary-40": {
                    color: "secondary_40"
                },
                "secondary-30": {
                    color: "secondary_30"
                },
                "secondary-20": {
                    color: "secondary_20"
                },
                "secondary-inverse": {
                    color: "secondary_inverse"
                },
                "secondary-background": {
                    color: "secondary_background"
                },
                "secondary-grey-100": {
                    color: "secondary_grey_100"
                },
                "secondary-grey-80": {
                    color: "secondary_grey_80"
                },
                "secondary-grey-60": {
                    color: "secondary_grey_60"
                },
                "secondary-grey-40": {
                    color: "secondary_grey_40"
                },
                "secondary-grey-20": {
                    color: "secondary_grey_20"
                },
                "sparkle-80": {
                    color: "sparkle_80"
                },
                "sparkle-70": {
                    color: "sparkle_70"
                },
                "sparkle-60": {
                    color: "sparkle_60"
                },
                "sparkle-50": {
                    color: "sparkle_50"
                },
                "sparkle-40": {
                    color: "sparkle_40"
                },
                "sparkle-30": {
                    color: "sparkle_30"
                },
                "sparkle-20": {
                    color: "sparkle_20"
                },
                "sparkle-inverse": {
                    color: "sparkle_inverse"
                },
                "sparkle-background": {
                    color: "sparkle_background"
                },
                "sparkle-grey-100": {
                    color: "sparkle_grey_100"
                },
                "sparkle-grey-80": {
                    color: "sparkle_grey_80"
                },
                "SPARKLE-GREY-60": {
                    color: "sparkle_grey_60"
                },
                "sparkle-grey-40": {
                    color: "sparkle_grey_40"
                },
                "sparkle-grey-20": {
                    color: "sparkle_grey_20"
                },
                feedback_error_80: {
                    color: "feedback_error_80"
                },
                "feedback-error_50": {
                    color: "feedback_error_50"
                },
                "feedback-error-20": {
                    color: "feedback_error_20"
                },
                "feedback-warning-80": {
                    color: "feedback_warning_80"
                },
                "feedback-warning-50": {
                    color: "feedback_warning_50"
                },
                "feedback-warning-20": {
                    color: "feedback_warning_20"
                },
                "feedback-success-80": {
                    color: "feedback_success_80"
                },
                "feedback-success-50": {
                    color: "feedback_success_50"
                },
                "feedback-success-20": {
                    color: "feedback_success_20"
                },
                white: {
                    color: "white"
                },
                black: {
                    color: "black"
                },
                transparent: {
                    color: "transparent"
                }
            }
        },
        children: {
            properties: {
                text: props.children
            }
        },
        text: {
            properties: {
                text: props.text
            }
        },
        as: {
            properties: {
                textType: props.as
            }
        },
        appearance: {
            properties: {},
            variations: {
                "body-s": {
                    appearance: "body-s"
                },
                "heading-xl": {
                    appearance: "heading_xl"
                },
                "heading-l": {
                    appearance: "heading_l"
                },
                "heading-m": {
                    appearance: "heading_m"
                },
                "heading-s": {
                    appearance: "heading_s"
                },
                "heading-xs": {
                    appearance: "heading_xs"
                },
                "heading-xxs": {
                    appearance: "heading_xxs"
                },
                overline: {
                    appearance: "overline"
                },
                "body-l": {
                    appearance: "body_l"
                },
                "body-l-bold": {
                    appearance: "body_l_bold"
                },
                "body-l-link": {
                    appearance: "body_l_link"
                },
                "body-m": {
                    appearance: "body_m"
                },
                "body-m-bold": {
                    appearance: "body_m_bold"
                },
                "body-m-link": {
                    appearance: "body_m_link"
                },
                "body-s-bold": {
                    appearance: "body_s_bold"
                },
                "body-s-link": {
                    appearance: "body_s_link"
                },
                "body-xs": {
                    appearance: "body_xs"
                },
                "body-xs-bold": {
                    appearance: "body_xs_bold"
                },
                "body-xs-link": {
                    appearance: "body_xs_link"
                },
                "body-xxs": {
                    appearance: "body_xxs"
                },
                "body-xxs-bold": {
                    appearance: "body_xxs-bold"
                },
                "body-xxs-link": {
                    appearance: "body_xxs_link"
                },
                "list-title": {
                    appearance: "list_title"
                },
                button: {
                    appearance: "button"
                },
                code: {
                    appearance: "code"
                }
            }
        }
    });
const $fe5170bdd3625759$var$Component$2 = ({ children: children, ...props })=>{
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)($fe5170bdd3625759$var$Jdstext, {
        ...props,
        text: props.text || children
    }, "JDSText", $fe5170bdd3625759$var$componentsMap);
};
const $fe5170bdd3625759$export$a8a3e93435678ff9 = $fe5170bdd3625759$var$withModifiedProps($fe5170bdd3625759$var$Component$2, $fe5170bdd3625759$var$PROP_MAP);
$fe5170bdd3625759$export$a8a3e93435678ff9.defaultProps = {
    as: "h1"
};
const $fe5170bdd3625759$var$CSSTransition = (props)=>{
    const { in: _in, appear: appear, children: children, className: className, timeout: timeout = 150, onEntered: onEntered, onExited: onExited, unmountOnExit: unmountOnExit, enter: enter, exit: exit, ...rest } = props;
    const rootPrefixedClassNames = (root, ...classList)=>$fe5170bdd3625759$var$makeClass([
            root,
            ...classList.map((classN)=>`${root}-${classN}`)
        ]);
    const [classes, setClasses] = (0, $acw62.useState)(rootPrefixedClassNames(className, "initial"));
    const [status, setStatus] = (0, $acw62.useState)(_in ? 1 /* ENTERING */  : 3 /* EXITED */ );
    const [_appear, setAppear] = (0, $acw62.useState)(appear);
    (0, $acw62.useEffect)(()=>{
        if (_in && (appear || enter)) {
            setStatus(1 /* ENTERING */ );
            setTimeout(()=>setStatus(0 /* ENTERED */ ), timeout);
            setAppear(false);
        } else if (!_appear || exit) {
            setAppear(appear);
            setStatus(2 /* EXITING */ );
            setTimeout(()=>setStatus(3 /* EXITED */ ), timeout);
        }
        return ()=>{
            setStatus(3 /* EXITED */ );
        };
    }, [
        _in
    ]);
    (0, $acw62.useEffect)(()=>{
        switch(status){
            case 1 /* ENTERING */ :
                setClasses($fe5170bdd3625759$var$makeClass([
                    className,
                    `${className}-enter`,
                    "enter-active"
                ]));
                break;
            case 0 /* ENTERED */ :
                onEntered?.(true);
                setClasses(rootPrefixedClassNames(className, "initial", "enter", "enter-done"));
                break;
            case 2 /* EXITING */ :
                setClasses(rootPrefixedClassNames(className, `exit`, "exit-active"));
                break;
            case 3 /* EXITED */ :
                onExited?.(true);
                setClasses(rootPrefixedClassNames(className, "initial", "exit", "exit-done"));
                break;
        }
    }, [
        status
    ]);
    const shouldUnMount = unmountOnExit && status === 3 /* EXITED */ ;
    return shouldUnMount ? null : (0, $acw62.cloneElement)(children, {
        className: $fe5170bdd3625759$var$makeClass([
            classes,
            children.props.className
        ]),
        ...rest
    });
};
const $fe5170bdd3625759$var$OnVisible = (props)=>{
    const { onChange: onChange, children: children, percent: percent = 50, visibleClassName: visibleClassName, wrappingElement: wrappingElement = "div", ...rest } = props;
    const [visible, setVisible] = (0, $acw62.useState)(false);
    const intersectionObserverRef = (0, $acw62.useRef)(null);
    const handleInteraction = (entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                onChange?.(true);
                setVisible(true);
                intersectionObserverRef?.current?.disconnect();
            }
        });
    };
    const domRef = (0, $acw62.useCallback)((ref)=>{
        const intersectionObserver = new IntersectionObserver(handleInteraction, {
            threshold: percent / 100
        });
        intersectionObserverRef.current = intersectionObserver;
        if (ref) intersectionObserver.observe(ref);
        return ()=>intersectionObserver.disconnect();
    }, []);
    return (0, $acw62.createElement)(wrappingElement, {
        ref: domRef,
        ...rest,
        className: visible ? visibleClassName : void 0
    }, children);
};
const $fe5170bdd3625759$var$FadeOnScroll = (props)=>{
    const [isVisible, setVisible] = (0, $acw62.useState)(false);
    const uniqKey = props.uniqueKey || "-no-key";
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$var$OnVisible, {
        onChange: (val)=>{
            setVisible(val);
            props.onVisible && props.onVisible(false);
        },
        visibleClassName: "fadeup-visible",
        percent: 5,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$var$CSSTransition, {
            in: props.enter === void 0 ? isVisible : isVisible && props.enter,
            appear: true,
            className: props.animationClass || "fadeup",
            onEntered: ()=>{
                props.onVisible && props.onVisible(true);
            },
            timeout: 150,
            ...props.transitionProps,
            children: props.children
        }, uniqKey)
    });
};
$fe5170bdd3625759$var$FadeOnScroll.defaultProps = {
    animateClass: "fadeup"
};
const $fe5170bdd3625759$var$Container = (0, $acw62.forwardRef)((props, ref)=>{
    const { padPosition: padPosition, displayOn: displayOn, animateIn: animateIn, animateNow: animateNow, layout: layout, pad: pad, as: as = "section", rounded: rounded, onVisible: onVisible, background: background, mode: mode, ...rest } = props;
    const classNames = $fe5170bdd3625759$var$makeClass([
        props.className,
        "j-container",
        pad && `sp--${pad}`,
        (pad || padPosition) && `pd--${padPosition || "all"}`,
        layout && `l-layout--${layout}`,
        displayOn && `l-breakpoint--${displayOn}`,
        background && `bg--${background}`,
        rounded && `l-radius--${rounded}`,
        animateIn && "fadeup-initial"
    ]);
    const modeProp = {};
    if (mode) modeProp["data-mode"] = mode || "light";
    const ContainerTag = as;
    const containerDom = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(ContainerTag, {
        ref: ref,
        ...modeProp,
        ...rest,
        className: classNames,
        children: props.children
    });
    if (!(animateIn === true || animateNow === true)) return containerDom;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$var$FadeOnScroll, {
        animate: animateIn,
        uniqueKey: classNames + "-" + props.id,
        onVisible: onVisible,
        enter: animateNow,
        children: containerDom
    });
});
$fe5170bdd3625759$var$Container.defaultProps = {
    as: "section"
};
const $fe5170bdd3625759$var$FULL_LAYOUTS = [
    "full-width"
];
const $fe5170bdd3625759$var$VerticalAlignmentCSSCustomMapping = {
    top: "start",
    bottom: "end"
};
const $fe5170bdd3625759$export$ce6636bfa4e9f0e8 = (props)=>{
    const { className: className, children: children, layout: layout = "1-col-even", verticalAlignment: verticalAlignment = "stretch", horizontalAlignment: horizontalAlignment = "stretch", margin: margin, marginPosition: marginPosition, ...rest } = props;
    const SLIDER_ENABLED_PANELS = [
        "2-col-overflow",
        "3-col-overflow",
        "4-col-overflow"
    ];
    const { tablet: tablet } = $fe5170bdd3625759$var$Devices.useMedia();
    const hasSlider = SLIDER_ENABLED_PANELS.includes(layout) && tablet;
    const classes = $fe5170bdd3625759$var$makeClass([
        className,
        $fe5170bdd3625759$var$FULL_LAYOUTS.includes(layout) ? "l-layout--full" : "l-layout--max-width",
        "j-content-layout",
        `j-content-layout__layout-${layout}`,
        margin && `sp--${margin}`,
        margin && marginPosition && `mg--${marginPosition}`,
        hasSlider && "j-content-layout__slider"
    ]);
    const [activeIndex, setActiveIndex] = (0, $acw62.useState)(0);
    const styleVars = $fe5170bdd3625759$var$setCSSVar({
        "--content-layout-horizontal-alignment": horizontalAlignment,
        "--content-layout-vertical-alignment": Object.keys($fe5170bdd3625759$var$VerticalAlignmentCSSCustomMapping).includes(verticalAlignment) ? $fe5170bdd3625759$var$VerticalAlignmentCSSCustomMapping[verticalAlignment] : verticalAlignment
    });
    const modifiedStyles = {
        ...props.style || {},
        ...styleVars
    };
    const contentPanelClasses = $fe5170bdd3625759$var$makeClass([
        "j-content-layout-panel"
    ]);
    const GAP_SIZE = 16;
    const TOUCH_THRESHOLD = 20;
    const touchRef = (0, $acw62.useRef)({
        start: 0,
        end: 0,
        id: 0
    });
    const contentLayoutRef = (0, $acw62.useRef)(null);
    const moveToPanel = (scrollValue)=>{
        const currentActiveIndex = touchRef.current.id >= 0 ? touchRef.current.id : 0;
        Array.from(contentLayoutRef.current?.children || []).forEach((item)=>{
            item.style.transform = "translateX(-" + scrollValue + "px)";
        });
        setActiveIndex(currentActiveIndex);
    };
    const handlePointerStart = (e)=>{
        if (hasSlider) touchRef.current.start = e.clientX;
    };
    const getScrolledValue = (panelItemIndex)=>{
        let totalScrolled = 0;
        const items = Array.from(contentLayoutRef.current?.children || []);
        const panelIndexDifference = Math.abs(touchRef.current.id - panelItemIndex);
        items.length = panelItemIndex > 0 ? panelIndexDifference === 0 ? panelItemIndex : panelItemIndex - panelIndexDifference : 0;
        items.forEach((_, elIndex)=>{
            totalScrolled = totalScrolled + items[elIndex].offsetWidth + GAP_SIZE;
        });
        return totalScrolled;
    };
    const handlePointerMove = (ev)=>{
        if (hasSlider && touchRef.current.start) {
            touchRef.current.end = ev.clientX;
            if (ev.cancelable) ev.preventDefault();
            const touchDistance = touchRef.current.end - touchRef.current.start;
            const panelItemIndex = parseInt(ev.currentTarget.getAttribute("data-index") || "0");
            const totalScrolled = getScrolledValue(panelItemIndex);
            const scrollValue = totalScrolled + -1 * touchDistance;
            moveToPanel(scrollValue);
        }
    };
    const handlePointerEnd = (ev)=>{
        if (hasSlider && touchRef.current.end) {
            const touchDistance = touchRef.current.end - touchRef.current.start;
            const childItemsLength = contentLayoutRef.current?.children.length || 0;
            const touchDistancePercent = 100 / ev.currentTarget.offsetWidth * Math.abs(touchDistance);
            let nextPanelID = touchRef.current.id < 0 ? 1 : touchRef.current.id;
            if (touchDistancePercent > TOUCH_THRESHOLD) nextPanelID += touchDistance < 0 ? 1 : -1;
            nextPanelID = nextPanelID >= childItemsLength ? nextPanelID - 1 : nextPanelID;
            touchRef.current.start = 0;
            slideToPanel(nextPanelID);
        }
    };
    const handlePointerOut = ()=>{
        touchRef.current.start = 0;
        slideToPanel(touchRef.current.id);
        touchRef.current.end = 0;
    };
    const slideToPanel = (index)=>{
        touchRef.current.id = index;
        const scrollValue = getScrolledValue(index);
        moveToPanel(scrollValue);
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                ...rest,
                ref: contentLayoutRef,
                className: classes,
                style: modifiedStyles,
                children: (0, $acw62.Children).map(children, (child, index)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                        onPointerDown: handlePointerStart,
                        onPointerUp: handlePointerEnd,
                        onPointerMove: handlePointerMove,
                        onPointerOut: handlePointerOut,
                        "data-index": index,
                        className: contentPanelClasses,
                        children: child
                    }))
            }),
            hasSlider && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$var$Container, {
                className: "pagination__wrapper",
                layout: "centered",
                pad: "xs",
                padPosition: "vertical",
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$var$CarouselPagination, {
                    clickable: true,
                    onDotClick: slideToPanel,
                    count: (0, $acw62.Children).count(children),
                    selectedIndex: activeIndex
                })
            })
        ]
    });
};
$fe5170bdd3625759$export$ce6636bfa4e9f0e8.defaultProps = {
    layout: "1-col-even",
    horizontalAlignment: "stretch",
    verticalAlignment: "stretch",
    margin: "layout"
};
const $fe5170bdd3625759$export$ef2184bd89960b14 = (props)=>{
    const { template: template, templateTablet: templateTablet, templateMobile: templateMobile, gap: gap, align: align, justify: justify, ...rest } = props;
    const classNames = $fe5170bdd3625759$var$makeClass([
        props.className,
        "j-grid"
    ]);
    const styleVars = $fe5170bdd3625759$var$setCSSVar({
        "--grid-template": template,
        "--grid-template-tablet": templateTablet,
        "--grid-template-mobile": templateMobile || templateTablet,
        "--grid-gap": gap,
        "--grid-align": align,
        "--grid-justify": justify
    });
    const modifiedStyles = Object.assign(props.style || {}, styleVars);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
        ...rest,
        className: classNames,
        style: modifiedStyles,
        children: props.children
    });
};
$fe5170bdd3625759$export$ef2184bd89960b14.defaultProps = {
    template: "repeat(auto-fill, minmax(200px, 1fr))",
    gap: "var(--spacing-base)",
    align: "center"
};
const $fe5170bdd3625759$var$Horizontal = (props)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$eef1e68107c58ef2, {
        ...props,
        direction: "horizontal"
    });
const $fe5170bdd3625759$var$Vertical = (props)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$export$eef1e68107c58ef2, {
        ...props,
        direction: "vertical"
    });
const $fe5170bdd3625759$export$eef1e68107c58ef2 = (props)=>{
    const { className: className, value: value, direction: direction, ...rest } = props;
    const classes = $fe5170bdd3625759$var$makeClass([
        className,
        value && `sp--${value}`,
        direction === "horizontal" ? "pd--right" : "pd--bottom",
        `j-Space__${direction}`,
        "j-Space"
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: classes,
        ...rest
    });
};
$fe5170bdd3625759$export$eef1e68107c58ef2.H = $fe5170bdd3625759$var$Horizontal;
$fe5170bdd3625759$export$eef1e68107c58ef2.V = $fe5170bdd3625759$var$Vertical;
$fe5170bdd3625759$export$eef1e68107c58ef2.displayName = "Space";
$fe5170bdd3625759$export$eef1e68107c58ef2.defaultProps = {
    direction: "vertical",
    value: "s"
};
const $fe5170bdd3625759$var$sdl$1 = {
    "metadata": {
        "version": "1.0.0",
        "id": "horizontal-stepper-1.0.0",
        "name": "JDSHorizontalStepper",
        "layerName": "jds_horizontal_stepper"
    },
    "hierarchy": {
        "container": [
            {
                "step-indicator-container": [
                    "jds_step_item_horizontal"
                ]
            },
            {
                "stepper-children-container": [
                    "stepper-content-slot"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "gap": "{h_0}",
            "flex-direction": "{h_1}",
            "size": "{h_2}"
        },
        "step-indicator-container": {
            "flex-direction": "{h_3}",
            "justify-content": "{h_4}",
            "align-items": "{h_5}",
            "size": "{h_6}",
            "padding-left": "{h_7}",
            "padding-right": "{h_8}"
        },
        "jds_step_item_horizontal": {
            "flex": 1
        },
        "stepper-children-container": {
            "size": "{h_9}",
            "flex-direction": "{h_10}",
            "justify-content": "{h_11}",
            "align-items": "{h_12}",
            "enter-animation-name": "slideHorizontallyToRight",
            "exit-animation-name": "slideHorizontallyToLeft",
            "enter-animation-curve": "entrance_ease",
            "exit-animation-curve": "exit_ease",
            "enter-animation-duration": 500,
            "exit-animation-duration": 500
        }
    },
    "api": {
        "data": {
            "container": {
                "max-width": {
                    "name": "maxWidth",
                    "type": "size"
                }
            },
            "step-indicator-container": {
                "value": {
                    "name": "stepItems",
                    "type": "list",
                    "object": {
                        "state": "JDSStepperDot.state",
                        "label": "string",
                        "index": "string",
                        "icon": "icon",
                        "activeState": "JDSStepperDot.activeState",
                        "direction": "JDSHorizontalStepItem.direction"
                    }
                }
            },
            "jds_step_item_horizontal": {
                "state": {
                    "type": "JDSStepperDot.state",
                    "name": "stepItems.state"
                },
                "label": {
                    "type": "string",
                    "name": "stepItems.label"
                },
                "index": {
                    "type": "string",
                    "name": "stepItems.index"
                },
                "icon": {
                    "type": "icon",
                    "name": "stepItems.icon"
                },
                "direction": {
                    "type": "JDSHorizontalStepItem.direction",
                    "name": "stepItems.direction"
                },
                "activeState": {
                    "type": "JDSStepperDot.activeState",
                    "name": "stepItems.activeState"
                },
                "itemsType": {
                    "type": "JDSStepperDot.itemsType",
                    "name": "itemsType"
                }
            }
        },
        "children": {
            "stepper-content-slot": {
                "name": "content",
                "accepts": [
                    "template"
                ],
                "max": 1
            }
        },
        "a11y": {
            "step-indicator-container": {
                "name": "stepItems",
                "repeating": {
                    "ariaLabel": "stepItemAriaLabel",
                    "ariaCurrent": "_ariaCurrent"
                },
                "properties": {
                    "role": {
                        "value": "list"
                    }
                }
            },
            "jds_step_item_horizontal": {
                "properties": {
                    "ariaLabel": "stepItems.stepItemAriaLabel",
                    "ariaCurrent": "stepItems._ariaCurrent"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$AnimatedStepItem = ({ children: children, show: show, animateState: animateState })=>{
    const { className: className } = $fe5170bdd3625759$var$useTransition(Boolean(show));
    if (!show) return null;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: [
            className,
            "animate-step-item",
            animateState
        ].join(" "),
        children: children
    });
};
const $fe5170bdd3625759$var$getCompletedStepItems = (stepItems)=>{
    const filteredList = stepItems.filter((item)=>item.complete);
    if (!filteredList.length) return [
        -1
    ];
    return filteredList.map((_, i)=>i);
};
const $fe5170bdd3625759$var$getState = (idx, stepItems, completedList)=>{
    if (stepItems[idx]?.disabled) return "disabled";
    if (completedList.includes(idx)) return "complete";
    const activeItems = stepItems.findIndex((t, i)=>!completedList.includes(i) && !t.disabled);
    return activeItems === idx ? "active" : "inactive";
};
const $fe5170bdd3625759$var$useStepper = (props, stepperRef)=>{
    const { children: children, onActiveChange: onActiveChange, onComplete: onComplete, orientation: orientation } = props;
    const stepItems = children.map((c)=>c.props);
    const [animateState, setAnimateState] = (0, $acw62.useState)("next");
    const [completedList, setCompletedList] = (0, $acw62.useState)($fe5170bdd3625759$var$getCompletedStepItems(stepItems));
    const completeIndex = completedList.sort()[completedList.length - 1];
    (0, $acw62.useImperativeHandle)(stepperRef, ()=>({
            next: ()=>{
                const nextIndex = completeIndex === stepItems.length ? stepItems.length - 1 : completeIndex + 1;
                const actualIndex = stepItems[nextIndex].disabled ? nextIndex + 1 : nextIndex;
                setCompletedList([
                    ...completedList,
                    actualIndex
                ]);
                stepItems?.[completeIndex]?.onComplete?.();
                onActiveChange?.(actualIndex);
                setAnimateState("next");
                if (nextIndex === stepItems.length - 1) onComplete?.();
            },
            prev: ()=>{
                const prevIndex = completeIndex === stepItems.length - 1 ? [
                    completeIndex,
                    completeIndex - 1
                ] : [
                    completeIndex
                ];
                const currentList = completedList.filter((t)=>!prevIndex.includes(t));
                setCompletedList(currentList);
                setAnimateState("prev");
            }
        }), [
        completeIndex,
        completedList,
        stepItems,
        onActiveChange,
        onComplete
    ]);
    const updatedStepItems = stepItems.map((item, i)=>{
        const direction = i === 0 || orientation === "vertical" && i !== stepItems.length - 1 ? "end" : i === stepItems.length - 1 ? "start" : "both";
        const state = $fe5170bdd3625759$var$getState(i, stepItems, completedList);
        return {
            ...item,
            content: item.children,
            itemsType: props.itemsType,
            icon: item.activeState === "warning" ? void 0 : item.icon,
            _compeleteDivider: i >= completeIndex && orientation === "horizontal",
            direction: direction,
            index: i + 1,
            state: state,
            _ariaCurrent: state === "active" ? "step" : void 0
        };
    });
    return {
        stepItems: updatedStepItems,
        completeIndex: completeIndex,
        animateState: animateState
    };
};
const $fe5170bdd3625759$var$withLogic$1 = (Component)=>(0, $acw62.forwardRef)((props, stepperRef)=>{
        const { stepItems: stepItems, animateState: animateState } = $fe5170bdd3625759$var$useStepper(props, stepperRef);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                stepItems: stepItems,
                content: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                    children: stepItems.map((item, i)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$var$AnimatedStepItem, {
                            animateState: animateState,
                            show: item.state === "active",
                            children: item.children
                        }, i))
                })
            }
        });
    });
const $fe5170bdd3625759$var$Component$1 = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl$1;
    const { custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...rest,
        componentTag: componentTag
    }, "JDSHorizontalStepper", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$var$HorizontalStepper = $fe5170bdd3625759$var$withLogic$1($fe5170bdd3625759$var$Component$1);
$fe5170bdd3625759$var$HorizontalStepper.displayName = "HorizontalStepper";
$fe5170bdd3625759$var$HorizontalStepper.slotName = "jds_horizontal_stepper";
const $fe5170bdd3625759$export$3ced97e5087256a2 = (props)=>null;
const $fe5170bdd3625759$var$sdl = {
    "metadata": {
        "version": "1.0.0",
        "id": "vertical-stepper-1.0.0",
        "name": "JDSVerticalStepper",
        "layerName": "jds_vertical_stepper"
    },
    "hierarchy": {
        "container": [
            "jds_step_item_vertical"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{v_0}",
            "justify-content": "{v_1}",
            "align-items": "{v_2}",
            "size": "{v_3}",
            "gap": "{v_4}"
        },
        "label-jds-text": {
            "font-family": "{headingXxs}",
            "color": "{primaryGrey100}",
            "font-size": "{headingXxs}",
            "line-height": "{headingXxs}",
            "letter-spacing": "{headingXxs}",
            "font-weight": "{headingXxs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "language": "en",
            "padding-top": 0
        }
    },
    "api": {
        "data": {
            "container": {
                "value": {
                    "type": "list",
                    "name": "stepItems",
                    "object": {
                        "state": "JDSStepperDot.state",
                        "label": "string",
                        "index": "string",
                        "icon": "icon",
                        "direction": "JDSVerticalStepItem.direction",
                        "content": "template",
                        "activeState": "JDSStepperDot.activeState"
                    }
                },
                "max-width": {
                    "name": "maxWidth",
                    "type": "size"
                }
            },
            "jds_step_item_vertical": {
                "state": {
                    "type": "JDSStepperDot.state",
                    "name": "stepItems.state"
                },
                "label": {
                    "type": "string",
                    "name": "stepItems.label"
                },
                "index": {
                    "type": "string",
                    "name": "stepItems.index"
                },
                "icon": {
                    "type": "icon",
                    "name": "stepItems.icon"
                },
                "direction": {
                    "type": "JDSVerticalStepItem.direction",
                    "name": "stepItems.direction"
                },
                "content": {
                    "type": "template",
                    "name": "stepItems.content"
                },
                "activeState": {
                    "type": "JDSStepperDot.activeState",
                    "name": "stepItems.activeState"
                },
                "itemsType": {
                    "type": "JDSStepperDot.itemsType",
                    "name": "itemsType"
                }
            }
        },
        "a11y": {
            "container": {
                "name": "stepItems",
                "repeating": {
                    "ariaLabel": "stepItemAriaLabel",
                    "ariaCurrent": "_ariaCurrent"
                },
                "properties": {
                    "role": {
                        "value": "list"
                    }
                }
            },
            "jds_step_item_vertical": {
                "properties": {
                    "ariaLabel": "stepItems.stepItemAriaLabel",
                    "ariaCurrent": "stepItems._ariaCurrent"
                }
            }
        }
    }
};
const $fe5170bdd3625759$var$withLogic = (Component)=>(0, $acw62.forwardRef)((props, stepperRef)=>{
        const { stepItems: stepItems } = $fe5170bdd3625759$var$useStepper(props, stepperRef);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...{
                ...props,
                stepItems: stepItems
            }
        });
    });
const $fe5170bdd3625759$var$Component = (props)=>{
    (0, $8bd3c5c9ee0d1eb4$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $fe5170bdd3625759$var$sdl;
    const { custom: custom = "", ...rest } = props;
    return (0, $8bd3c5c9ee0d1eb4$export$60e54eaca7e7fb38)(json, {
        ...rest,
        componentTag: componentTag
    }, "JDSVerticalStepper", $fe5170bdd3625759$var$componentsMap, (0, $8bd3c5c9ee0d1eb4$export$d72eddc0980b68c9)(custom || "") || {});
};
const $fe5170bdd3625759$var$VerticalStepper = $fe5170bdd3625759$var$withLogic($fe5170bdd3625759$var$Component);
$fe5170bdd3625759$var$VerticalStepper.displayName = "VerticalStepper";
$fe5170bdd3625759$var$VerticalStepper.slotName = "jds_vertical_stepper";
const $fe5170bdd3625759$export$ed8ca599049e8881 = (0, $acw62.forwardRef)(({ orientation: orientation, ...rest }, ref)=>{
    if (orientation === "vertical") return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$var$VerticalStepper, {
        ...rest,
        ref: ref,
        orientation: "vertical"
    });
    if (orientation === "auto") {
        const isVertical = $fe5170bdd3625759$var$Devices.isMobile() && rest.children?.length > 6;
        if (isVertical) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$var$VerticalStepper, {
            ref: ref,
            ...rest,
            orientation: "vertical"
        });
    }
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($fe5170bdd3625759$var$HorizontalStepper, {
        ...rest,
        ref: ref,
        orientation: "horizontal"
    });
});
const $fe5170bdd3625759$export$c13f210c706eb549 = (props)=>null;
const $fe5170bdd3625759$export$36ba2f559d49a8f6 = {
    nudge: $fe5170bdd3625759$var$nudge,
    toast: $fe5170bdd3625759$var$toast,
    Container: $fe5170bdd3625759$var$NotificationContainer,
    Banner: $fe5170bdd3625759$var$NotificationBanner
};




var $acw62 = parcelRequire("acw62");





const $32937e877ad5e53a$export$4bdaead51b5919b2 = (l)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                fill: "currentColor",
                d: "M0 0h24v24H0z"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M3.293 11.293A1 1 0 014 11h16a1 1 0 010 2H4a1 1 0 01-.707-1.707z",
                fill: "#fff"
            })
        ]
    });



const $f0bae4c2368766e6$export$95ab99e064402c41 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            stroke: "currentColor",
            d: "M.5.5h23v23H.5z"
        })
    });



const $1632be84cd6eedb9$export$d3d0e5567c53d0cf = (t)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                fill: "currentColor",
                d: "M0 0h24v24H0z"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M9 19a1.002 1.002 0 01-.71-.29l-5-5a1.004 1.004 0 111.42-1.42L9 16.59l10.29-10.3a1.004 1.004 0 111.42 1.42l-11 11A1 1 0 019 19z",
                fill: "#fff"
            })
        ]
    });



const $16458bf7dd024619$export$b343909e775b1c7b = (r)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("g", {
                clipPath: "url(#ic_radio_off_svg__clip0_33414_144135)",
                children: (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M12 0C5.38 0 0 5.38 0 12s5.38 12 12 12 12-5.38 12-12S18.62 0 12 0zm0 21.6c-5.3 0-9.6-4.3-9.6-9.6S6.7 2.4 12 2.4s9.6 4.3 9.6 9.6-4.3 9.6-9.6 9.6z",
                    fill: "currentColor"
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)("defs", {
                children: (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                    id: "ic_radio_off_svg__clip0_33414_144135",
                    children: (0, $7b02d682eb115277$exports.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h24v24H0z"
                    })
                })
            })
        ]
    });



const $c9374c0b0125dcd6$export$52e67d5bcbf742e4 = (r)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: [
            (0, $7b02d682eb115277$exports.jsxs)("g", {
                clipPath: "url(#ic_radio_on_svg__clip0_33414_144136)",
                fill: "currentColor",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M12 0C5.38 0 0 5.38 0 12s5.38 12 12 12 12-5.38 12-12S18.62 0 12 0zm0 21.6c-5.3 0-9.6-4.3-9.6-9.6S6.7 2.4 12 2.4s9.6 4.3 9.6 9.6-4.3 9.6-9.6 9.6z"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M12 18c3.31 0 6-2.69 6-6s-2.69-6-6-6-6 2.69-6 6 2.69 6 6 6z"
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsx)("defs", {
                children: (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                    id: "ic_radio_on_svg__clip0_33414_144136",
                    children: (0, $7b02d682eb115277$exports.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h24v24H0z"
                    })
                })
            })
        ]
    });



const $05a0dad6e8daa70a$export$500fc573b0753093 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M11 9a1 1 0 001 1 8.72 8.72 0 004.45-1.11A6.77 6.77 0 0120 8a1 1 0 100-2 8.72 8.72 0 00-4.45 1.11A6.77 6.77 0 0112 8a1 1 0 00-1 1zm-2 8V9a3 3 0 012.93-3l-1.64-2.6a1 1 0 00-1.58 0L4.2 10.54A7.85 7.85 0 003 14.69 6.42 6.42 0 009.5 21a6.6 6.6 0 003.5-1h-1a3 3 0 01-3-3zm11-7a8.72 8.72 0 00-4.45 1.11A6.77 6.77 0 0112 12a1 1 0 100 2 8.72 8.72 0 004.45-1.11A6.77 6.77 0 0120 12a1 1 0 000-2zm0 4a8.72 8.72 0 00-4.45 1.11A6.77 6.77 0 0112 16a1 1 0 100 2 8.72 8.72 0 004.45-1.11A6.77 6.77 0 0120 16a1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $1562c8b17c1fa42b$export$ffdc046da2186e59 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4 7a1 1 0 100-2 1 1 0 000 2zm0 10a1 1 0 100 2 1 1 0 000-2zm0-4a1 1 0 100-2 1 1 0 000 2zm2 1a1 1 0 100 2 1 1 0 000-2zm0-6a1 1 0 100 2 1 1 0 000-2zm12.71 5.29a1.004 1.004 0 10-1.42 1.42l.3.29H13V9h4.59l-.3.29a1 1 0 00.325 1.639 1 1 0 001.095-.219l2-2a1 1 0 000-1.42l-2-2a1.003 1.003 0 10-1.42 1.42l.3.29H13V4a1 1 0 00-1-1h-2a1 1 0 00-1 1v16a1 1 0 001 1h2a1 1 0 001-1v-3h4.59l-.3.29a1.002 1.002 0 00.325 1.639 1 1 0 001.095-.219l2-2a1.002 1.002 0 000-1.42l-2-2z",
            fill: "currentColor"
        })
    });



const $1295482b9f382794$export$b796fc20b8f88c19 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M3.88 6.71l2.83-2.83a1.004 1.004 0 00-1.42-1.42L2.46 5.29a1.004 1.004 0 101.42 1.42zm17.66-1.42l-2.83-2.83a1.004 1.004 0 10-1.42 1.42l2.83 2.83a1.004 1.004 0 001.42-1.42zM12 4a9 9 0 00-7.46 14l-1.25 1.29a1.004 1.004 0 101.42 1.42l1.14-1.15a9 9 0 0012.3 0l1.14 1.15a1.004 1.004 0 101.42-1.42L19.46 18A9 9 0 0012 4zm2.12 11.12a1 1 0 01-1.41 0l-1.42-1.41a1.15 1.15 0 01-.21-.33A1.001 1.001 0 0111 13V8a1 1 0 012 0v4.59l1.12 1.12a1 1 0 010 1.41z",
            fill: "currentColor"
        })
    });



const $f6332c21b46465fd$export$e592fa5de01562e0 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M11 8.76V8a1 1 0 011-1 .93.93 0 01.56.2l2.61-2.61A8.79 8.79 0 0012 4a9 9 0 00-9 9 8.75 8.75 0 00.6 3.16l7.4-7.4zm-7.12-2l2.83-2.88a1.004 1.004 0 00-1.42-1.42L2.46 5.29a1.004 1.004 0 101.42 1.42v.05zM19.46 18a9 9 0 00-.89-11.17L20.49 5a1.055 1.055 0 00-.745-1.798A1.053 1.053 0 0019 3.51L3.51 19A1.053 1.053 0 105 20.49l.91-.92a9 9 0 0012.28 0l1.14 1.15a1.004 1.004 0 101.42-1.42L19.46 18zm-5.34-2.92a1 1 0 01-1.41 0l-1.2-1.19L13 12.44v.15l1.12 1.12a1 1 0 010 1.41v-.04z",
            fill: "currentColor"
        })
    });



const $9367a230d12be757$export$20898a3f86a237f4 = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 19H4c-.55 0-1 .45-1 1s.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1zm-10-2h4c1.66 0 3-1.34 3-3V6c0-1.66-1.34-3-3-3h-4C8.34 3 7 4.34 7 6v8c0 1.66 1.34 3 3 3z",
            fill: "currentColor"
        })
    });



const $bd9074b5ec452af7$export$a99ebacd7d84b374 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 7h-4V3c0-.55-.45-1-1-1s-1 .45-1 1v4H7c-1.66 0-3 1.34-3 3v4c0 1.66 1.34 3 3 3h4v4c0 .55.45 1 1 1s1-.45 1-1v-4h4c1.66 0 3-1.34 3-3v-4c0-1.66-1.34-3-3-3z",
            fill: "currentColor"
        })
    });



const $0f3fb0995975837c$export$143960deea632ebd = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4 3c-.55 0-1 .45-1 1v16c0 .55.45 1 1 1s1-.45 1-1V4c0-.55-.45-1-1-1zm14 4h-8c-1.66 0-3 1.34-3 3v4c0 1.66 1.34 3 3 3h8c1.66 0 3-1.34 3-3v-4c0-1.66-1.34-3-3-3z",
            fill: "currentColor"
        })
    });



const $5b2240371d4efa07$export$4f79d73ab0b298a7 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 3c-.55 0-1 .45-1 1v16c0 .55.45 1 1 1s1-.45 1-1V4c0-.55-.45-1-1-1zm-6 4H6c-1.66 0-3 1.34-3 3v4c0 1.66 1.34 3 3 3h8c1.66 0 3-1.34 3-3v-4c0-1.66-1.34-3-3-3z",
            fill: "currentColor"
        })
    });



const $b7cebbc65b815997$export$d4a12372498d6b45 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 3H4c-.55 0-1 .45-1 1s.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1zm-6 4h-4c-1.66 0-3 1.34-3 3v8c0 1.66 1.34 3 3 3h4c1.66 0 3-1.34 3-3v-8c0-1.66-1.34-3-3-3z",
            fill: "currentColor"
        })
    });



const $92dc2138d9fa880b$export$3bb21c2366b6d32c = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21 11h-4V7c0-1.66-1.34-3-3-3h-4C8.34 4 7 5.34 7 7v4H3c-.55 0-1 .45-1 1s.45 1 1 1h4v4c0 1.66 1.34 3 3 3h4c1.66 0 3-1.34 3-3v-4h4c.55 0 1-.45 1-1s-.45-1-1-1z",
            fill: "currentColor"
        })
    });



const $a645a9e240c4c0d7$export$f7404d6e3326d530 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.29 8.71c.19.19.45.29.71.29.13 0 .26-.02.38-.08.37-.15.62-.52.62-.92V4c0-.55-.45-1-1-1h-4a1.002 1.002 0 00-.7 1.71L16.59 6 12 10.59 7.41 6 8.7 4.71c.29-.29.37-.72.22-1.09C8.77 3.25 8.4 3 8 3H4c-.55 0-1 .45-1 1v4c0 .4.24.77.62.92a.995.995 0 001.09-.21L6 7.42l4.59 4.59L6 16.6l-1.29-1.29c-.29-.29-.72-.37-1.09-.22-.37.15-.62.52-.62.92v4c0 .55.45 1 1 1h4a1.002 1.002 0 00.7-1.71l-1.29-1.29L12 13.42l4.59 4.59-1.29 1.29c-.29.29-.37.72-.22 1.09.15.37.52.62.92.62h4c.55 0 1-.45 1-1v-4c0-.4-.24-.77-.62-.92a.984.984 0 00-1.09.22L18 16.6l-4.59-4.59L18 7.42l1.29 1.29z",
            fill: "currentColor"
        })
    });



const $76802c6f1a0174da$export$21a96402a77d9d4d = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.71 11.29l-3-3a.988.988 0 00-1.09-.22c-.37.15-.62.52-.62.92v2H7v-2c0-.4-.24-.77-.62-.92a.984.984 0 00-1.09.22l-3 3a.996.996 0 000 1.41l3 3c.19.19.45.29.71.29.13 0 .26-.02.38-.08.37-.15.62-.52.62-.92v-2h10v2c0 .4.24.77.62.92a.995.995 0 001.09-.21l3-3a.996.996 0 000-1.41z",
            fill: "currentColor"
        })
    });



const $b619183cc28d5579$export$f1e3d056624f8d9d = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15 17h-2V7h2a1.002 1.002 0 00.7-1.71l-3-3a.996.996 0 00-1.41 0l-3 3c-.29.29-.37.72-.22 1.09.15.37.52.62.92.62h2v10h-2a1.002 1.002 0 00-.7 1.71l3 3c.2.2.45.29.71.29.26 0 .51-.1.71-.29l3-3c.29-.29.37-.72.22-1.09-.15-.37-.52-.62-.92-.62H15z",
            fill: "currentColor"
        })
    });



const $e3e6b603de67ca09$export$e48846fd074d3b95 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 3H4a2 2 0 00-2 2v1a1 1 0 001 1h18a1 1 0 001-1V5a2 2 0 00-2-2zM4 18a3 3 0 003 3h10a3 3 0 003-3V9H4v9zm6-6h4a1 1 0 010 2h-4a1 1 0 010-2z",
            fill: "currentColor"
        })
    });



const $143feaed87102930$export$1f00984dadc6a12 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 3H6a3 3 0 00-1.29.3l16 16c.193-.406.292-.85.29-1.3V6a3 3 0 00-3-3zM3 6v12a3 3 0 003 3h12a2.999 2.999 0 001.29-.3l-16-16A3 3 0 003 6z",
            fill: "currentColor"
        })
    });



const $e1388f49db25c9ff$export$9550ee559b7e6415 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 19H4a1 1 0 000 2h16a1 1 0 000-2zM4 11h16a1 1 0 000-2H4a1 1 0 000 2zm16 3H4a1 1 0 000 2h16a1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $e4c8e300df1edf89$export$29e3618e9249687b = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4 8h16a1 1 0 100-2H4a1 1 0 000 2zm16 3H4a1 1 0 000 2h16a1 1 0 000-2zm0 5H4a1 1 0 000 2h16a1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $3d88311a73709c99$export$761ada6b67aa4bb2 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4 5h16a1 1 0 100-2H4a1 1 0 000 2zm16 14H4a1 1 0 000 2h16a1 1 0 000-2zm0-8H4a1 1 0 000 2h16a1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $a4a408185e3f74d0$export$a7ce9ccfff3b13e7 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4 5h16a1 1 0 100-2H4a1 1 0 000 2zm16 8H4a1 1 0 000 2h16a1 1 0 000-2zm0-5H4a1 1 0 000 2h16a1 1 0 100-2z",
            fill: "currentColor"
        })
    });



const $40109318919d4806$export$889a2aad61280dd8 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 3a5 5 0 100 10 5 5 0 000-10zM9.25 9.81l-4.68 6.43a3 3 0 004.44 4l5.91-5.32a7 7 0 01-5.67-5.11zM9 16.5a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $4b03d52ce1145c93$export$efc6f891dde4d2f5 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 15c-.55 0-1 .45-1 1v1.59L4.71 3.29A.996.996 0 103.3 4.7l14.29 14.29H16c-.55 0-1 .45-1 1s.45 1 1 1h4c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1V15z",
            fill: "currentColor"
        })
    });



const $24375d1b084dcfe4$export$5ee5012dbf17ed77 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 15c-.55 0-1 .45-1 1v1.59L6.41 5H8c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1s1-.45 1-1V6.41L17.59 19H16c-.55 0-1 .45-1 1s.45 1 1 1h4c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1z",
            fill: "currentColor"
        })
    });



const $5c7586f57cf796c5$export$483c1e7da08958dd = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 15c-.55 0-1 .45-1 1v1.59L7.82 6.41c.11-.28.18-.59.18-.91a2.5 2.5 0 00-5 0A2.5 2.5 0 005.5 8c.32 0 .63-.07.91-.18L17.59 19H16c-.55 0-1 .45-1 1s.45 1 1 1h4c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1z",
            fill: "currentColor"
        })
    });



const $dfa6bf7e703fcf98$export$90739fe78688b72c = (v)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...v,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M3 14.33h4.67V9.67H3v4.66zM9.67 21h4.66v-4.67H9.67V21zM19 3h-2.67v4.67H21V5a2 2 0 00-2-2zM3 19a2 2 0 002 2h2.67v-4.67H3V19zM3 5v2.67h4.67V3H5a2 2 0 00-2 2zm13.33 16H19a2 2 0 002-2v-2.67h-4.67V21zm0-6.67H21V9.67h-4.67v4.66zM9.67 7.67h4.66V3H9.67v4.67zm0 6.66h4.66V9.67H9.67v4.66z",
            fill: "currentColor"
        })
    });



const $5fd43ae2470d1dc8$export$1c88108fd439c684 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M22 9.17a6.09 6.09 0 00-10.39-4.31.413.413 0 00-.07.11 1.06 1.06 0 00-.11.07l-8.09 8.09a4.56 4.56 0 106.45 6.45l5.39-5.39a3.034 3.034 0 00-4.29-4.29L8 12.78a1 1 0 000 1.41.998.998 0 00.71.29 1 1 0 00.71-.29l2.87-2.88a1.04 1.04 0 111.47 1.47l-5.39 5.39a2.62 2.62 0 01-3.62 0 2.56 2.56 0 010-3.62l8.09-8.09.07-.11c.031-.022.062-.045.09-.07a4.09 4.09 0 115.78 5.78 1.06 1.06 0 00-.07.11s-.08 0-.11.07l-6.83 6.83a1 1 0 000 1.41 1 1 0 001.41 0L20 13.65c.026-.035.05-.072.07-.11 0 0 .08 0 .11-.07A6 6 0 0022 9.17z",
            fill: "currentColor"
        })
    });



const $1d01470b5cdfb82e$export$664472575265e3d4 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7.71 11.29a1 1 0 00-1.42 0l-.22.22a6 6 0 0110.22-3.75 1.004 1.004 0 101.42-1.42 8 8 0 00-13.64 5.31l-.36-.36a1.004 1.004 0 10-1.42 1.42l2 2a1.001 1.001 0 001.42 0l2-2a1 1 0 000-1.42zm14 0l-2-2a.999.999 0 00-1.42 0l-2 2a1.003 1.003 0 101.42 1.42l.27-.27A6 6 0 0112 18a5.93 5.93 0 01-4.24-1.76 1.004 1.004 0 10-1.42 1.42A8 8 0 0020 12.39l.31.32a1.001 1.001 0 001.42 0 1 1 0 00-.02-1.42zM11.53 9.82l-1.5 4a.52.52 0 00.29.65.51.51 0 00.65-.29l.25-.68h1.56l.25.68a.51.51 0 00.47.32h.18a.51.51 0 00.29-.65l-1.5-4a.52.52 0 00-.94-.03zm.07 2.68l.4-1.08.4 1.08h-.8z",
            fill: "currentColor"
        })
    });



const $679a35a09432035d$export$77250bd632398719 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 10a8 8 0 10-12.53 6.59L7 19.72a2 2 0 003.09 1.94L12 20.4l1.89 1.26A2 2 0 0015 22a2.002 2.002 0 001.98-2.31l-.45-3.13A8 8 0 0020 10zm-8 6a6 6 0 110-12 6 6 0 010 12zm2.49-7.16l-1.34-.2-.61-1.29a.59.59 0 00-1.08 0l-.61 1.29-1.34.2a.6.6 0 00-.34 1l1 1-.25 1.46a.61.61 0 00.89.63l1.19-.66 1.19.66a.631.631 0 00.64-.04.61.61 0 00.25-.59l-.24-1.43 1-1a.6.6 0 00-.34-1l-.01-.03z",
            fill: "currentColor"
        })
    });



const $fc4ba75fbe92a56c$export$ea1aa56f5d29112f = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.77 9.36l-.82-1 .32-1.24A1 1 0 0018.71 6l-1.13-.51-.23-1.25a1 1 0 00-1-.82h-1.23l-.73-1a1 1 0 00-1.29-.3l-1.1.59-1.08-.59a1 1 0 00-1.29.3l-.73 1H7.67a1 1 0 00-1 .82l-.25 1.22L5.29 6a1 1 0 00-.56 1.17l.32 1.24-.82 1a1 1 0 000 1.28l.82 1-.32 1.24A1 1 0 005.29 14l1.13.51.23 1.25a1 1 0 00.82.8L7 19.72a2 2 0 003.09 1.94L12 20.4l1.89 1.26A2 2 0 0015 22a2.002 2.002 0 001.98-2.31l-.45-3.13a1 1 0 00.82-.8l.23-1.25 1.13-.51a1 1 0 00.56-1.17L19 11.62l.82-1a1 1 0 00-.05-1.26zm-2.69 1.37a.998.998 0 00-.2.89l.24.93-.84.37a1 1 0 00-.57.74l-.17.92h-.9a1 1 0 00-.85.41l-.53.74-.78-.42a1 1 0 00-1 0l-.78.42-.49-.73a.91.91 0 00-.85-.41h-.9l-.17-.92a1 1 0 00-.57-.74l-.84-.37.24-.93a1 1 0 00-.2-.89L6.31 10l.61-.73a1 1 0 00.2-.89l-.24-.93.84-.37a1 1 0 00.57-.74l.17-.92h.9a.94.94 0 00.85-.42l.53-.74.78.42a1 1 0 001 0l.78-.42.53.74a1 1 0 00.85.41h.9l.17.92a1 1 0 00.57.74l.84.37-.24.93a.999.999 0 00.2.89l.61.73-.65.74zM12 7a3 3 0 100 6 3 3 0 000-6z",
            fill: "currentColor"
        })
    });



const $b21a6599fc219df4$export$39b8cc716a4f9fa4 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M9 13c-3.31 0-6 2.69-6 6 0 1.11.89 2 2 2h8c1.1 0 2-.9 2-2 0-3.31-2.69-6-6-6zm0-1c1.93 0 3.5-1.57 3.5-3.5S10.93 5 9 5 5.5 6.57 5.5 8.5 7.07 12 9 12zm11.56-.09c-1.04-.3-1.17-.42-1.47-1.46a.612.612 0 00-1.18-.01c-.3 1.04-.42 1.17-1.46 1.47a.612.612 0 00-.01 1.18c1.04.3 1.17.42 1.47 1.46a.612.612 0 001.18.01c.3-1.04.42-1.17 1.46-1.47.26-.07.45-.32.45-.59 0-.27-.18-.51-.44-.59zM17 9c.29 0 .55-.19.63-.48.38-1.33.56-1.5 1.88-1.89.28-.08.48-.34.48-.63s-.19-.55-.48-.63c-1.33-.38-1.5-.56-1.89-1.89a.654.654 0 00-1.26.01c-.38 1.33-.56 1.5-1.88 1.89-.28.08-.48.34-.48.64s.2.55.48.63c1.33.38 1.51.56 1.89 1.89.08.28.34.47.63.47V9z",
            fill: "currentColor"
        })
    });



const $bf47c8ace3b2b6d5$export$3262dbf20dd8d255 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21 10a1 1 0 00-1 1v1H4v-1a1 1 0 10-2 0v2a1 1 0 001 1h18a1 1 0 001-1v-2a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $e3b843b7f4783448$export$326d689e37502847 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 00-7.74 16.33L18.33 4.26A10 10 0 0012 2zm7.74 3.67L5.67 19.74A10 10 0 0019.74 5.67z",
            fill: "currentColor"
        })
    });



const $cac1223b33c533e8$export$9180669364c738c9 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M9 10H5a2 2 0 00-2 2v8a2 2 0 002 2h4a2 2 0 002-2v-8a2 2 0 00-2-2zm0-8H5a2 2 0 00-2 2v2a2 2 0 002 2h4a2 2 0 002-2V4a2 2 0 00-2-2zm10 14h-4a2 2 0 00-2 2v2a2 2 0 002 2h4a2 2 0 002-2v-2a2 2 0 00-2-2zm0-14h-4a2 2 0 00-2 2v8a2 2 0 002 2h4a2 2 0 002-2V4a2 2 0 00-2-2z",
            fill: "currentColor"
        })
    });



const $585548cca2a27772$export$d66f951aecfd954a = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17.85 11.15c.91-1.11 1.38-2.6 1.03-4.22C18.37 4.6 16.21 3 13.82 3H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h7.28c2.86 0 5.41-2.1 5.69-4.95.2-1.99-.68-3.79-2.12-4.9zM8 6h6c1.1 0 2 .9 2 2s-.9 2-2 2H8V6zm6.5 12H8v-5h6.5a2.5 2.5 0 010 5z",
            fill: "currentColor"
        })
    });



const $e880ce50a4f2a827$export$cf4bcd810d78c8a3 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 2H7a3 3 0 00-3 3v15a2 2 0 003 1.73l5-2.88 5 2.88a2 2 0 001 .27 2 2 0 001.732-1.001A2 2 0 0020 20V5a3 3 0 00-3-3z",
            fill: "currentColor"
        })
    });



const $50c6593860fe472b$export$b82f3afbb4cca9e9 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 2H6a2 2 0 00-2 2v16a2 2 0 003 1.73l5-2.88 5 2.88a2 2 0 001 .27 2 2 0 001.732-1.001A2 2 0 0020 20V4a2 2 0 00-2-2zm-4 9h-1v1a1 1 0 01-2 0v-1h-1a1 1 0 010-2h1V8a1 1 0 012 0v1h1a1 1 0 110 2z",
            fill: "currentColor"
        })
    });



const $dd26ac59f3dc07ba$export$b2a7c5a9732ef77e = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17.66 2.08A2.84 2.84 0 0017 2H7c-.8 0-1.56.32-2.12.88S4 4.21 4 5v10.73L17.66 2.08zM20.29 2.28L4.01 18.56v.02L2.3 20.29a.996.996 0 00.71 1.7c.26 0 .51-.1.71-.29l.62-.62c.17.27.4.49.67.65.3.18.65.27 1 .27s.7-.09 1-.27l5-2.88 5 2.88c.3.18.65.27 1 .27s.7-.09 1-.27c.3-.18.56-.43.73-.73.18-.3.27-.65.27-1V5.41l1.71-1.71a.996.996 0 10-1.41-1.41l-.02-.01z",
            fill: "currentColor"
        })
    });



const $1b065c64decae37c$export$3ee2cf3f438ed851 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M8.5 11A4.75 4.75 0 004 15.5c0 2.81-.68 3.76-.74 3.82a1 1 0 00-.18 1.06A1 1 0 004 21c4.19 0 9-.62 9-5.5A4.75 4.75 0 008.5 11zm11.62-7.12a3 3 0 00-4.24 0l-5.45 5.44a7.001 7.001 0 014.22 4.27l5.47-5.47a3 3 0 000-4.24z",
            fill: "currentColor"
        })
    });



const $474012083be16551$export$981f77c367aeaa60 = (m)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...m,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 2H7a3 3 0 00-3 3v14a3 3 0 003 3h10a3 3 0 003-3V5a3 3 0 00-3-3zM8 19a1 1 0 110-2 1 1 0 010 2zm0-3.5a1 1 0 110-2 1 1 0 010 2zM8 12a1 1 0 110-2 1 1 0 010 2zm4 7a1 1 0 110-2 1 1 0 010 2zm0-3.5a1 1 0 110-2 1 1 0 010 2zm0-3.5a1 1 0 110-2 1 1 0 010 2zm4 7a1 1 0 110-2 1 1 0 010 2zm0-3.5a1 1 0 110-2 1 1 0 010 2zm0-3.5a1 1 0 110-2 1 1 0 010 2zm1-5a1 1 0 01-1 1H8a1 1 0 01-1-1V6a1 1 0 011-1h8a1 1 0 011 1v1z",
            fill: "currentColor"
        })
    });



const $ff32d7485e77eb14$export$f8d7b9876d656085 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 3h-1a1 1 0 00-2 0H9a1 1 0 00-2 0H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-3-3zm-1.79 8.71l-5 5a1.002 1.002 0 01-1.42 0l-2-2a1.003 1.003 0 111.42-1.42l1.29 1.3 4.29-4.3a1.004 1.004 0 011.42 1.42zM19 7H5V6a1 1 0 011-1h1a1 1 0 002 0h6a1 1 0 002 0h1a1 1 0 011 1v1z",
            fill: "currentColor"
        })
    });



const $b4d50dec9884ee9e$export$16c11adbace9ede8 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M13.5 14h-1v-2a1 1 0 00-2 0v3a1 1 0 001 1h2a1 1 0 000-2zM18 3h-1a1 1 0 00-2 0H9a1 1 0 00-2 0H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-3-3zm-6 16a5 5 0 110-9.999A5 5 0 0112 19zm7-12H5V6a1 1 0 011-1h1a1 1 0 002 0h6a1 1 0 002 0h1a1 1 0 011 1v1z",
            fill: "currentColor"
        })
    });



const $a314e2e80001b0b9$export$cdd7d64c250a9601 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.12 3.88A3 3 0 0018 3h-1a1 1 0 00-2 0H9a1 1 0 00-2 0H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-.88-2.12zM8 17a1 1 0 110-2 1 1 0 010 2zm0-4a1 1 0 110-2 1 1 0 010 2zm4 4a1 1 0 110-2 1 1 0 010 2zm0-4a1 1 0 110-2 1 1 0 010 2zm4 0a1 1 0 110-2 1 1 0 010 2zm3-6H5V6a1 1 0 011-1h1a1 1 0 002 0h6a1 1 0 002 0h1a1 1 0 011 1v1z",
            fill: "currentColor"
        })
    });



const $8b2dc65ddbe2ab05$export$343b514a5adb8483 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.12 3.88A3 3 0 0018 3h-1a1 1 0 00-2 0H9a1 1 0 00-2 0H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-.88-2.12zM13 16a1 1 0 01-2 0v-4a1 1 0 012 0v4zm6-9H5V6a1 1 0 011-1h1a1 1 0 002 0h6a1 1 0 002 0h1a1 1 0 011 1v1z",
            fill: "currentColor"
        })
    });



const $89cf857ac88a2429$export$6f8324fc8dc65147 = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18.65 6.77l1.06-1.06A.996.996 0 1018.3 4.3l-1.06 1.06-1.06-1.06a.996.996 0 10-1.41 1.41l1.06 1.06-1.06 1.06a.996.996 0 101.41 1.41l1.06-1.06 1.06 1.06a.996.996 0 101.41-1.41l-1.06-1.06zm-.48 7.55c-.78-.78-2.05-.78-2.83 0l-.71.71c-.71.71-1.41 0-1.41 0l-4.24-4.24c-.71-.71 0-1.41 0-1.41l.71-.71c.78-.78.78-2.05 0-2.83l-.71-.71c-.78-.78-2.05-.78-2.83 0l-.99.99c-.31.31-.51.7-.57 1.14-.17 1.41-.06 4.74 3.68 8.48s7.08 3.85 8.48 3.68c.43-.05.83-.26 1.14-.57l.99-.99c.78-.78.78-2.05 0-2.83l-.71-.71z",
            fill: "currentColor"
        })
    });



const $d884b659859406e2$export$297b5e34ea6a85b = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M11.12 14h1.76L12 12.24 11.12 14zM19 7h-.9a1 1 0 01-.84-.47l-1-1.6a2 2 0 00-1.7-.93H9.44a2 2 0 00-1.69.93l-1 1.6A1 1 0 015.9 7H5a3 3 0 00-3 3v7a3 3 0 003 3h14a3 3 0 003-3v-7a3 3 0 00-3-3zm-3.55 9.89A.929.929 0 0115 17a1 1 0 01-.89-.55l-.23-.45h-3.76l-.23.45a1 1 0 01-1.78-.9l3-6a1 1 0 011.78 0l3 6a1 1 0 01-.44 1.34z",
            fill: "currentColor"
        })
    });



const $e2ba1b5a744eb5fd$export$e85a7564e5d79b3a = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7.56 13.41c-1.04-.3-1.17-.42-1.47-1.46a.612.612 0 00-1.18-.01c-.3 1.04-.42 1.17-1.46 1.47a.612.612 0 00-.01 1.18c1.04.3 1.17.42 1.47 1.46a.612.612 0 001.18.01c.3-1.04.42-1.17 1.46-1.47.26-.07.45-.32.45-.59 0-.27-.18-.51-.44-.59zm4.38-7.32c1.04.3 1.17.42 1.47 1.46a.612.612 0 001.18.01c.3-1.04.42-1.17 1.46-1.47.26-.07.45-.32.45-.59 0-.27-.18-.51-.44-.59-1.04-.3-1.17-.42-1.47-1.46a.612.612 0 00-1.18-.01c-.3 1.04-.42 1.17-1.46 1.47a.612.612 0 00-.01 1.18zm-2.95-.1c0-.29-.19-.55-.48-.63-1.33-.38-1.5-.56-1.89-1.89a.654.654 0 00-1.26.01c-.38 1.33-.56 1.5-1.88 1.89-.28.08-.48.34-.48.64s.2.55.48.63c1.33.38 1.51.56 1.89 1.89.08.28.34.47.63.47.29-.01.55-.2.63-.49.38-1.33.56-1.5 1.88-1.89.28-.08.48-.34.48-.63zm10.72 12.3L10.42 9a.996.996 0 10-1.41 1.41l9.29 9.29a.996.996 0 101.41-1.41z",
            fill: "currentColor"
        })
    });



const $eaeaaecb2bac92d0$export$443c1a440311bf43 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 7h-.9a1 1 0 01-.84-.47l-1-1.6a2 2 0 00-1.7-.93H9.44a2 2 0 00-1.69.93l-1 1.6A1 1 0 015.9 7H5a3 3 0 00-3 3v7a3 3 0 003 3h14a3 3 0 003-3v-7a3 3 0 00-3-3zm-7 9a3 3 0 110-5.999A3 3 0 0112 16zm6-4a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $c4c296f57c4911cc$export$d08f96f833fb73cc = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 7h-.9a1 1 0 01-.84-.47l-1-1.6a2 2 0 00-1.7-.93H9.44a2 2 0 00-1.69.93l-1 1.6A1 1 0 015.9 7H5a3 3 0 00-3 3v7a3 3 0 003 3h14a3 3 0 003-3v-7a3 3 0 00-3-3zm-2 9a1 1 0 01-2 0v-3.76l-2.11 4.21a1 1 0 01-1.78 0L9 12.24V16a1 1 0 11-2 0v-6a1 1 0 011-1h1a1 1 0 01.89.55L12 13.76l2.11-4.21A1 1 0 0115 9h1a1 1 0 011 1v6z",
            fill: "currentColor"
        })
    });



const $d6e8a9fead7f2c59$export$fcaf0efac50a5eda = (r)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12.16 13.2c-.06-.16-.08-.36-.16-.36s-.1.2-.16.36l-.83 2.51c-.03.09-.03.14-.03.16 0 .05.03.07.1.07h1.83c.07 0 .1-.02.1-.07 0-.02 0-.07-.03-.16l-.82-2.51z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M18.75 9.29c-.32-.55-.77-1-1.32-1.32v-.51c0-1.45-.57-2.83-1.59-3.86A5.436 5.436 0 0012 2c-1.44 0-2.82.57-3.84 1.6a5.456 5.456 0 00-1.59 3.86v.51a3.632 3.632 0 00-1.81 3.13v7.27c0 .96.38 1.89 1.06 2.57.68.68 1.6 1.07 2.56 1.07h7.25c.96 0 1.88-.38 2.56-1.07.68-.68 1.06-1.61 1.06-2.57V11.1c0-.63-.17-1.26-.49-1.81h-.01zm-8.04-3.12a1.809 1.809 0 013.09 1.29h-3.62c0-.48.19-.94.53-1.29zM14.59 19c-.25 0-.52-.11-.64-.48l-.35-.99c-.03-.1-.08-.16-.17-.16h-2.87c-.09 0-.14.06-.17.16l-.35.99c-.13.36-.39.48-.64.48-.36 0-.79-.23-.79-.65 0-.09.02-.2.07-.32l2.19-6c.29-.8.54-1.03 1.14-1.03.6 0 .85.24 1.13 1.03l2.19 6c.05.11.07.23.07.32 0 .39-.4.65-.79.65h-.02z",
                fill: "currentColor"
            })
        ]
    });



const $142ddc52ce5fe2d2$export$e6d13a2ff40968cd = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4 5a1 1 0 00-1 1v12a1 1 0 102 0V6a1 1 0 00-1-1zm11-2H9a2 2 0 00-2 2v14a2 2 0 002 2h6a2 2 0 002-2V5a2 2 0 00-2-2zm5 2a1 1 0 00-1 1v12a1 1 0 002 0V6a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $63049894c238231f$export$14ed79ad664bab8 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 7a5 5 0 00-5 5 4.94 4.94 0 00.9 2.85 1 1 0 001.64-1.14 3 3 0 114.92 0 1 1 0 001.64 1.14c.587-.834.901-1.83.9-2.85a5 5 0 00-5-5zm.71 8.29a1.002 1.002 0 00-1.42 0l-4 4a1 1 0 00-.21 1.09A1 1 0 008 21h8a1 1 0 00.92-.62 1 1 0 00-.21-1.09l-4-4zM12 3a9 9 0 00-6.9 14.78 1 1 0 001.53-1.29 7 7 0 1110.74 0 .999.999 0 00.12 1.41 1 1 0 00.64.23.999.999 0 00.77-.35A9 9 0 0012 3z",
            fill: "currentColor"
        })
    });



const $9e30fd0dcf58e894$export$4a184c817d8bfdaa = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M3.5 16a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm0-3H3a1 1 0 000 2h.5A2.5 2.5 0 016 17.5v.5a1 1 0 102 0v-.5A4.51 4.51 0 003.5 13zM19 5H5a3 3 0 00-3 3 1 1 0 002 0 1 1 0 011-1h14a1 1 0 011 1v8a1 1 0 01-1 1h-6a1 1 0 000 2h6a3 3 0 003-3V8a3 3 0 00-3-3zM3.5 10H3a1 1 0 000 2h.5A5.51 5.51 0 019 17.5v.5a1 1 0 102 0v-.5A7.5 7.5 0 003.5 10z",
            fill: "currentColor"
        })
    });



const $aae511c90bec00ac$export$d5c8615d2745f595 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12.71 14.29a1.002 1.002 0 00-1.42 0l-4 4a1 1 0 00-.21 1.09A1 1 0 008 20h8a1 1 0 00.92-.62 1 1 0 00-.21-1.09l-4-4zM19 5H5a3 3 0 00-3 3v7a3 3 0 003 3 1 1 0 000-2 1 1 0 01-1-1V8a1 1 0 011-1h14a1 1 0 011 1v7a1 1 0 01-1 1 1 1 0 000 2 3 3 0 003-3V8a3 3 0 00-3-3z",
            fill: "currentColor"
        })
    });



const $00f3071785e6330d$export$2c0df9aa8fe882c8 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M11 6h9a1 1 0 100-2h-9a1 1 0 100 2zM6 4H4a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V6a2 2 0 00-2-2zm0 10H4a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2zm14-6h-9a1 1 0 100 2h9a1 1 0 100-2zm0 6h-9a1 1 0 000 2h9a1 1 0 000-2zm0 4h-9a1 1 0 000 2h9a1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $b65bff141ce6786f$export$482559b84b5373af = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 14h-2a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2zm-1-8h9a1 1 0 100-2h-9a1 1 0 100 2zM8 6a2 2 0 00-2-2H4a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V6zm12 2h-9a1 1 0 100 2h9a1 1 0 100-2zm0 6h-3a1 1 0 000 2h3a1 1 0 000-2zm0 4h-3a1 1 0 000 2h3a1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $77787b3a24dcbec0$export$e5831773af1f445c = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 17H4a1 1 0 000 2h12a1 1 0 000-2zm4-12H8a1 1 0 000 2h12a1 1 0 100-2zm-2 6H6a1 1 0 000 2h12a1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $966e8e1153f08df5$export$a6a286c0a8fda0a0 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M5 17a2 2 0 100 4 2 2 0 000-4zm1-2V9a1 1 0 00-2 0v6a1 1 0 102 0zm13-8a2 2 0 100-4 2 2 0 000 4zm-1 2v6a1 1 0 002 0V9a1 1 0 00-2 0zm1 8a2 2 0 100 4 2 2 0 000-4zM15 4H9a1 1 0 000 2h6a1 1 0 100-2zM5 3a2 2 0 100 4 2 2 0 000-4zm10 15H9a1 1 0 000 2h6a1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $331640b897585fd8$export$c85883d76e5d3c1c = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 11.54c.01-.18.01-.36 0-.54A6 6 0 008.8 8a4 4 0 00-3.31 2.1A4.48 4.48 0 006 19h12a4 4 0 002-7.46z",
            fill: "currentColor"
        })
    });



const $8d75ad605bb16742$export$7b97e105d3117fa3 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.7 13.46c-.33-.8-.92-1.47-1.67-1.91.01-.18.01-.36 0-.53 0-1.3-.43-2.57-1.22-3.61a5.963 5.963 0 00-3.17-2.12c-1.26-.34-2.6-.25-3.8.25-1.2.5-2.21 1.38-2.86 2.51-.68.04-1.33.25-1.9.61-.57.36-1.04.87-1.36 1.46-1.08.17-2.06.74-2.75 1.59a4.407 4.407 0 00.34 5.91c.78.77 1.82 1.22 2.91 1.27h11.83c.87 0 1.71-.29 2.4-.82s1.18-1.27 1.41-2.11c.22-.84.17-1.73-.16-2.53v.03zM13 17c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm1-4c0 .55-.45 1-1 1s-1-.45-1-1V9c0-.55.45-1 1-1s1 .45 1 1v4z",
            fill: "currentColor"
        })
    });



const $4034e07dd7a094d2$export$aeda07bd1014a1bc = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M14 5a6 6 0 00-5.2 3 4 4 0 00-3.31 2.1A4.5 4.5 0 002 14.5a4.42 4.42 0 00.77 2.5L14.71 5.05A5.517 5.517 0 0014 5zm6 6.54c.01-.18.01-.36 0-.54a6 6 0 00-1.55-4l2-2a1.038 1.038 0 00-.314-1.7A1.04 1.04 0 0019 3.51L3.51 19A1.054 1.054 0 105 20.49L6.44 19H18a4 4 0 002-7.46z",
            fill: "currentColor"
        })
    });



const $39abc195cec4e023$export$8afc35ef71c7e645 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.7 13.46c-.33-.8-.92-1.47-1.67-1.91.01-.18.01-.36 0-.53 0-1.3-.43-2.57-1.22-3.61a5.908 5.908 0 00-3.17-2.12c-1.26-.34-2.6-.25-3.8.25-1.2.5-2.21 1.38-2.86 2.51-.68.04-1.33.25-1.9.61-.57.36-1.04.87-1.36 1.46-1.08.17-2.06.74-2.75 1.59a4.407 4.407 0 00.34 5.91c.78.77 1.82 1.22 2.91 1.27h11.84c.87 0 1.71-.29 2.4-.82s1.18-1.27 1.41-2.11c.22-.84.17-1.73-.16-2.53l-.01.03zM12 14.95c0 .55-.44.99-.99.99s-.99-.44-.99-.99V11c0-.55.44-.99.99-.99s.99.44.99.99v3.95zm3.95 0c0 .55-.44.99-.99.99s-.99-.44-.99-.99V11c0-.55.44-.99.99-.99s.99.44.99.99v3.95z",
            fill: "currentColor"
        })
    });



const $5e90aa818ddd9b51$export$f3f4a2dc40db8ea9 = (e)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...e,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M20.03 11.02v.53l.01-.03c.75.44 1.34 1.11 1.67 1.91.33.8.38 1.69.16 2.53-.23.84-.72 1.58-1.41 2.11-.69.53-1.53.82-2.4.82H6.22c-1.09-.05-2.13-.5-2.91-1.27a4.407 4.407 0 01-.34-5.91c.69-.85 1.67-1.42 2.75-1.59.32-.59.79-1.1 1.36-1.46.57-.36 1.22-.57 1.9-.61a5.928 5.928 0 012.86-2.51c1.2-.5 2.54-.59 3.8-.25 1.26.34 2.38 1.09 3.17 2.12a5.976 5.976 0 011.22 3.61zM13 10a1 1 0 10-2 0v4a1 1 0 00.553.894l2 1a1 1 0 00.894-1.789L13 13.382V10z",
            fill: "currentColor"
        })
    });



const $bf542848e61dc332$export$c4a944480fd34c53 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17.75 9.07c-.6-1.78-2.26-3.08-4.25-3.08-1.99 0-3.6 1.26-4.22 3H8c-2.76 0-5 2.24-5 5s2.24 5 5 5h9c2.76 0 5-2.24 5-5 0-2.51-1.85-4.56-4.25-4.92zm-7.73 6.72c-.21 0-.41-.08-.56-.23l-1.6-1.6a.803.803 0 010-1.13c.31-.31.82-.31 1.13 0l.26.26c.16-2.07 1.87-3.7 3.97-3.7.31 0 .64.05 1 .14.42.11.68.54.58.98-.11.43-.55.68-.98.58a2.36 2.36 0 00-.6-.09c-1.2 0-2.19.88-2.36 2.03l.2-.2c.31-.31.82-.31 1.13 0 .31.31.31.82 0 1.13l-1.6 1.6c-.16.16-.36.23-.56.23h-.01zm8.58-1.83c-.16.16-.36.23-.57.23-.21 0-.41-.08-.57-.23l-.26-.26c-.16 2.07-1.87 3.7-3.97 3.7-.31 0-.64-.05-1-.14a.818.818 0 01-.58-.98.81.81 0 01.98-.58c.23.06.42.09.6.09 1.2 0 2.19-.88 2.36-2.03l-.2.2c-.31.31-.82.31-1.13 0a.803.803 0 010-1.13l1.6-1.6c.31-.31.82-.31 1.13 0l1.6 1.6c.31.31.31.82 0 1.13h.01z",
            fill: "currentColor"
        })
    });



const $15563ff1ea573b11$export$6ca3fafb53485135 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15.71 11.71l-4 4a.998.998 0 01-1.42 0l-2-2a1.004 1.004 0 011.42-1.42l1.29 1.3 3.29-3.3a1.004 1.004 0 011.42 1.42zm4.29-.17c.01-.18.01-.36 0-.54A6 6 0 008.8 8a4 4 0 00-3.31 2.1A4.48 4.48 0 006 19h12a4 4 0 002-7.46z",
            fill: "currentColor"
        })
    });



const $b216dccff2fe9d9c$export$3f6a59fe7584ab3d = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15.71 13.21a.998.998 0 01-1.42 0l-.29-.3v2.59a1 1 0 01-2 0v-2.59l-.29.3a1.004 1.004 0 11-1.42-1.42l2-2a.999.999 0 011.42 0l2 2a1.001 1.001 0 010 1.42zM20 11.54c.01-.18.01-.36 0-.54A6 6 0 008.8 8a4 4 0 00-3.31 2.1A4.48 4.48 0 006 19h12a4 4 0 002-7.46z",
            fill: "currentColor"
        })
    });



const $243e0d63d215675c$export$11367a391bef9404 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.059 9.647h-4.706V4.941c0-.565-.377-.941-.941-.941-.565 0-.941.376-.941.941v5.647c0 .565.376.941.94.941h5.648c.564 0 .941-.376.941-.94 0-.566-.377-.942-.941-.942zM10.588 12.47H4.941c-.565 0-.941.377-.941.942 0 .564.376.94.941.94h4.706v4.707c0 .564.377.941.941.941.565 0 .941-.377.941-.941v-5.647c0-.565-.376-.941-.94-.941z",
            fill: "currentColor"
        })
    });



const $aac86af397d1e39c$export$16b13b7f869f01de = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.8 10A10 10 0 1012 22a3 3 0 003-3v-1.72A2.08 2.08 0 0117 15h2a3 3 0 003-3c0-.672-.067-1.342-.2-2zM6.44 7.44a1.5 1.5 0 110 2.12 1.49 1.49 0 010-2.12zM6.5 15a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm4.06 3.56a1.5 1.5 0 110-2.12 1.49 1.49 0 010 2.12zM12 8a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm5.56 1.56a1.5 1.5 0 110-2.12 1.49 1.49 0 010 2.12z",
            fill: "currentColor"
        })
    });



const $cdfc54b3738ee992$export$4f2830264a771dbe = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10.23 20A8 8 0 017 18.48a1 1 0 00-1.24 1.57 10 10 0 004 1.93L10 22a1 1 0 001-.78 1 1 0 00-.77-1.22zM4 12.24a1 1 0 10-2 0 9.86 9.86 0 001 4.34 1 1 0 001.8-.87 7.88 7.88 0 01-.8-3.47zm-.55-3c.136.059.282.09.43.09a1 1 0 00.9-.56A8 8 0 017 6a1 1 0 00-1.25-1.56A10 10 0 003 7.9a1 1 0 00.45 1.34zm15.76 6.45a1 1 0 00.47 1.31c.135.062.282.096.43.1a1 1 0 00.9-.57 9.76 9.76 0 00.78-2.34h-2.05a7.833 7.833 0 01-.53 1.5zM17 18.47A8 8 0 0113.79 20a1.005 1.005 0 00.21 2c.073.01.147.01.22 0a10 10 0 004-1.93 1.006 1.006 0 10-1.22-1.6zm-7-14h.23A7.71 7.71 0 0112 4.22v-2a10 10 0 00-2.25.26 1.006 1.006 0 00.22 2l.03-.01zm8.34 6.67a1.82 1.82 0 002.59 0l.24-.24a1.84 1.84 0 000-2.59l-.8-.79 1-1a2.09 2.09 0 00.29-2.65 2 2 0 00-3-.25l-1.14 1.05-.8-.79a1.81 1.81 0 00-2.58 0l-.24.24a1.82 1.82 0 000 2.59l-4.59 4.58A1 1 0 009 12v3a1 1 0 001 1h3a1 1 0 00.7-.29l4.64-4.57zM12.43 11l2.88-2.88 1.59 1.59L15.6 11h-3.17z",
            fill: "currentColor"
        })
    });



const $17b7c115ec2f5d68$export$5a18cb429d2c5c5e = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M8 5H5a1 1 0 00-1 1v12a1 1 0 001 1h3a1 1 0 001-1V6a1 1 0 00-1-1zm4-3a1 1 0 00-1 1v18a1 1 0 002 0V3a1 1 0 00-1-1zm7 3h-3a1 1 0 00-1 1v12a1 1 0 001 1h3a1 1 0 001-1V6a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $2bb9b24e740a8d14$export$3365e7340a5946a7 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10.5 12.5h-6c-.55 0-1 .45-1 1s.45 1 1 1h3.59L2.8 19.79a.996.996 0 00.71 1.7c.26 0 .51-.1.71-.29l5.29-5.29v3.59c0 .55.45 1 1 1s1-.45 1-1v-6c0-.55-.45-1-1-1h-.01zm10.71-9.71a.996.996 0 00-1.41 0l-5.29 5.29V4.49c0-.55-.45-1-1-1s-1 .45-1 1v6c0 .55.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1h-3.59l5.29-5.29a.996.996 0 000-1.41z",
            fill: "currentColor"
        })
    });



const $4cc8351403c5ca22$export$f10d91edfa54dd19 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M6.38 9.08a1 1 0 00-1.09.21l-2 2a1 1 0 000 1.41l2 2A1 1 0 006 15a.84.84 0 00.38-.08A1 1 0 007 14v-4a1 1 0 00-.62-.92zM10 7h4a1 1 0 00.93-.62 1 1 0 00-.23-1.08l-2-2A1.08 1.08 0 0012 3a1 1 0 00-.7.29l-2 2A1 1 0 0010 7zm4 10h-4a1 1 0 00-.71 1.7l2 2c.191.185.444.292.71.3a1 1 0 00.71-.29l2-2A1 1 0 0014 17zm6.71-5.68l-2-2A1 1 0 0017 10v4a1 1 0 001 1 1 1 0 00.71-.29l2-2A1 1 0 0021 12a1 1 0 00-.3-.68h.01zM12 9a3 3 0 100 6 3 3 0 000-6z",
            fill: "currentColor"
        })
    });



const $965e16cc135a5806$export$38057519d7a019f9 = (l)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M11 14c-.26 0-.51-.1-.71-.29a.996.996 0 010-1.41l8-8.01A.996.996 0 1119.7 5.7l-7.99 8.01c-.2.2-.45.29-.71.29z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M18 20H6c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h6c.55 0 1 .45 1 1s-.45 1-1 1H6v12h12v-6c0-.55.45-1 1-1s1 .45 1 1v6c0 1.1-.9 2-2 2z",
                fill: "currentColor"
            })
        ]
    });



const $8befc3b9ebc28bcc$export$ca438254b071f4bf = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17.5 6a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM22 11.95c-.16.02-.33.05-.5.05-1.3 0-2.44-.63-3.17-1.59-.27.06-.54.09-.83.09-2.21 0-4-1.79-4-4 0-.43.09-.84.21-1.23A3.993 3.993 0 0112 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10v-.05zM7.5 16c-.83 0-1.5-.67-1.5-1.5S6.67 13 7.5 13s1.5.67 1.5 1.5S8.33 16 7.5 16zm1-5.5c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM17 17c-.83 0-1.5-.67-1.5-1.5S16.17 14 17 14s1.5.67 1.5 1.5S17.83 17 17 17z",
            fill: "currentColor"
        })
    });



const $92c43119469f0d93$export$60fdeb36f9384891 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12.33 8.82V6H4.87A1.88 1.88 0 003 7.88v12.24A1.88 1.88 0 004.87 22h10.26A1.88 1.88 0 0017 20.12v-9.41h-2.8a1.88 1.88 0 01-1.87-1.89zm8.08-3.23l-3-3A2 2 0 0016 2H8a2 2 0 00-2 2h7a3 3 0 012.12.88l3 3A3 3 0 0119 10v9a2 2 0 002-2V7a2 2 0 00-.59-1.41z",
            fill: "currentColor"
        })
    });



const $0bf03935be6b6b96$export$6bdb2a81916b4ae2 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10 17H4a1 1 0 000 2h6a1 1 0 000-2zM4 7h16a1 1 0 100-2H4a1 1 0 000 2zm16 7h-2.5v-2.5a1 1 0 00-2 0V14H13a1 1 0 000 2h2.5v2.5a1 1 0 002 0V16H20a1 1 0 000-2zm-10-3H4a1 1 0 000 2h6a1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $074f50ed9a64cd34$export$dfcc302e5232b900 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 14a1 1 0 002 0V6a1 1 0 00-1-1H7V3a1 1 0 00-2 0v2H3a1 1 0 000 2h14v7zm4 3H7v-7a1 1 0 00-2 0v8a1 1 0 001 1h11v2a1 1 0 002 0v-2h2a1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $52bb7fd4ad3e97b4$export$115b61b4529f2606 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4 6v9.76l2-2V6h7.76l2-2H6V3a1 1 0 00-2 0v1H3a1 1 0 000 2h1zm17 12h-1V6a2.087 2.087 0 00-.07-.51l.78-.78a1.004 1.004 0 10-1.42-1.42l-16 16a1 1 0 00.325 1.639 1 1 0 001.095-.219l.78-.78c.166.044.338.068.51.07h12v1a1 1 0 002 0v-1h1a1 1 0 000-2zm-3 0H7.41L18 7.41V18z",
            fill: "currentColor"
        })
    });



const $553d5d8fffa05683$export$96aed8822fb46b8e = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21 18h-1V6a2 2 0 00-2-2H6V3a1 1 0 00-2 0v1H3a1 1 0 000 2h1v12a2 2 0 002 2h12v1a1 1 0 002 0v-1h1a1 1 0 000-2zm-3-6.91l-1.79-1.8a1 1 0 00-1.42 0l-4.29 4.3-1.29-1.3a1 1 0 00-1.42 0L6 14.09V6h12v5.09zM8.5 10a1 1 0 100-2 1 1 0 000 2z",
            fill: "currentColor"
        })
    });



const $c57d0b456b45a185$export$a4785f470471cdda = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21 3a1 1 0 00-1.44 0L3 19.56A1.018 1.018 0 104.44 21L21 4.44A.998.998 0 0021 3zM6 3a3 3 0 00-3 3v10.76L16.76 3H6zm12 18a3 3 0 003-3V7.24L7.24 21H18z",
            fill: "currentColor"
        })
    });



const $f6ca536946a0faf4$export$50d96ce282c66e7d = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M11 5h2a1 1 0 100-2h-2a1 1 0 100 2zm-7 9a1 1 0 001-1v-2a1 1 0 10-2 0v2a1 1 0 001 1zm9 5h-2a1 1 0 000 2h2a1 1 0 000-2zm3.6-3.8L12.34 12l4.26-3.2a1 1 0 00-1.2-1.6l-4.72 3.55-3-2.26a3 3 0 10-3.26.05L9 12l-4.59 3.46a3 3 0 00-.53 4.66 3 3 0 004.24 0 3 3 0 00-.45-4.61l3-2.26 4.73 3.55a1 1 0 001.2-1.6zM6.71 6.71a1.004 1.004 0 11-1.42-1.42 1.004 1.004 0 011.42 1.42zm0 12a1.004 1.004 0 11-1.42-1.42 1.004 1.004 0 011.42 1.42zM18 3h-1a1 1 0 100 2h1a1 1 0 011 1v1a1 1 0 002 0V6a3 3 0 00-3-3zm2 13a1 1 0 00-1 1v1a1 1 0 01-1 1h-1a1 1 0 000 2h1a3 3 0 003-3v-1a1 1 0 00-1-1zm0-6a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $3c9b9f8f499b6f27$export$2bf52036aeb20ba3 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.69 5.72a1 1 0 00-1.38-1.44l-3.49 3.33L16 3.25a1.031 1.031 0 00-2-.5l-2 7.51-2.19 2.15A3.43 3.43 0 009 11a3.58 3.58 0 00-5 0 3.5 3.5 0 002.5 6A3.51 3.51 0 009 16l2.13-2-1 3.68a3.5 3.5 0 003.39 4.39 3.5 3.5 0 003.37-2.59 3.51 3.51 0 00-2.47-4.29 3.442 3.442 0 00-1.56 0l1-3.81 5.83-5.66zM5.44 14.56a1.5 1.5 0 010-2.12 1.498 1.498 0 012.488.46 1.5 1.5 0 01-.368 1.66 1.53 1.53 0 01-2.12 0zm8.45 2.53a1.51 1.51 0 11-1.063 2.827 1.51 1.51 0 011.063-2.827z",
            fill: "currentColor"
        })
    });



const $b12908bb8fca9ee9$export$e94172007eefc192 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zm0 18A8 8 0 019.69 4.35a10 10 0 007.74 13.53A8 8 0 0112 20z",
            fill: "currentColor"
        })
    });



const $8e36abda9a562c36$export$de832566deb4fe47 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 19H4a1 1 0 000 2h16a1 1 0 000-2zM4 5h16a1 1 0 100-2H4a1 1 0 000 2zm15 2H5a2 2 0 00-2 2v6a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2z",
            fill: "currentColor"
        })
    });



const $ef9fee5bdb8ee62d$export$cfa4c65d3910da5e = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M6.34 7.76c.192.183.445.286.71.29a1 1 0 001-1 1.05 1.05 0 00-.29-.71l-.71-.7a1 1 0 00-.71-.3 1 1 0 00-.921 1.385 1 1 0 00.221.325l.7.71zM12 6a1 1 0 001-1V4a1 1 0 00-2 0v1a1 1 0 001 1zm-6 6a1 1 0 00-1-1H4a1 1 0 000 2h1a1 1 0 001-1zm11-3.95a1.05 1.05 0 00.71-.29l.7-.71a1 1 0 00.3-.71 1 1 0 00-1.385-.921A1 1 0 0017 5.64l-.71.7a1.05 1.05 0 00-.29.71 1 1 0 001 1zm3.76 3.24A1.001 1.001 0 0020 11h-1a1 1 0 000 2h1a1 1 0 00.71-1.71h.05zm-3.05 4.95A1.05 1.05 0 0017 16a1 1 0 00-1 1c.004.265.107.518.29.71l.71.7a1 1 0 00.71.3 1 1 0 00.921-1.385A1 1 0 0018.41 17l-.7-.76zM12 7a5 5 0 100 10 5 5 0 000-10zm0 8a3 3 0 01-.47-5.95A3.93 3.93 0 0011 11a4 4 0 002.38 3.65A2.94 2.94 0 0112 15zm-4.95 1a1.05 1.05 0 00-.71.29l-.7.71a1 1 0 00-.3.71 1 1 0 001.385.921 1 1 0 00.325-.221l.71-.7a1.05 1.05 0 00.29-.71 1 1 0 00-1-1zM12 18a1 1 0 00-1 1v1a1 1 0 002 0v-1a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $bbf01eb8bc53c995$export$42afd8056af34a50 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-4.41 3.59-8 8-8 1.85 0 3.54.63 4.9 1.69L5.69 16.9A7.985 7.985 0 014 12zm8 8c-1.85 0-3.54-.63-4.9-1.69L18.31 7.1A7.985 7.985 0 0120 12c0 4.41-3.59 8-8 8z",
            fill: "currentColor"
        })
    });



const $4e693d377072f475$export$fa351830b1431371 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 5H8a3 3 0 00-2.34 1.18l-3.05 4a3 3 0 000 3.64l3.05 4A3 3 0 008 19h11a3 3 0 003-3V8a3 3 0 00-3-3zm-1.29 8.29a1.002 1.002 0 01-.326 1.639.999.999 0 01-1.094-.219L15 13.41l-1.29 1.3a1.001 1.001 0 01-1.64-.325 1 1 0 01.22-1.095l1.3-1.29-1.3-1.29a1.004 1.004 0 111.42-1.42l1.29 1.3 1.29-1.3a1.004 1.004 0 011.42 1.42L16.41 12l1.3 1.29z",
            fill: "currentColor"
        })
    });



const $3279253ac8bee064$export$ae2fdbd5450824d9 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M3.568 6.67l-.55 5A3 3 0 005.998 15h4v3.92a2 2 0 003.94.56l1-4c.04-.157.06-.318.06-.48V4h-8.45a3 3 0 00-2.98 2.67zM18.998 4h-2v11h2a2 2 0 002-2V6a2 2 0 00-2-2z",
            fill: "currentColor"
        })
    });



const $64409b42c3805821$export$747ec39607da8127 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 3c-.55 0-1 .45-1 1v16c0 .55.45 1 1 1s1-.45 1-1V4c0-.55-.45-1-1-1zM4 3.5c-.55 0-1 .45-1 1v15c0 .55.45 1 1 1s1-.45 1-1v-15c0-.55-.45-1-1-1zM14 5h-4C8.34 5 7 6.34 7 8v8c0 1.66 1.34 3 3 3h4c1.66 0 3-1.34 3-3V8c0-1.66-1.34-3-3-3z",
            fill: "currentColor"
        })
    });



const $c9b6d5c83e301329$export$cf3a06ae5f86323a = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 3H4c-.55 0-1 .45-1 1s.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1zm-.5 16h-15c-.55 0-1 .45-1 1s.45 1 1 1h15c.55 0 1-.45 1-1s-.45-1-1-1zM16 17c1.66 0 3-1.34 3-3v-4c0-1.66-1.34-3-3-3H8c-1.66 0-3 1.34-3 3v4c0 1.66 1.34 3 3 3h8z",
            fill: "currentColor"
        })
    });



const $a680860e19d5715c$export$c2d7e4a7e0ec103d = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.14 4H8.86C7.83 4 7 4.83 7 5.86v7.28C7 14.17 7.83 15 8.86 15h10.28c1.03 0 1.86-.83 1.86-1.86V5.86C21 4.83 20.17 4 19.14 4zM19 13H9V6h10v7zm-4 4H6c-.55 0-1-.45-1-1V9c0-.55-.45-1-1-1s-1 .45-1 1v7c0 1.65 1.35 3 3 3h9c.55 0 1-.45 1-1s-.45-1-1-1z",
            fill: "currentColor"
        })
    });



const $aa06e3a016bd4467$export$de8a9c1730087af5 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M9.5 10a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM16 7h4a2 2 0 00-.59-1.41l-3-3A2 2 0 0015 2v4a1 1 0 001 1zm-3-1V2H6.5A2.5 2.5 0 004 4.5v15A2.5 2.5 0 006.5 22h11a2.5 2.5 0 002.5-2.5V9h-4a3 3 0 01-3-3zm.62 10.78A1 1 0 0113 17a1 1 0 01-.78-.38l-1.49-1.86A3.37 3.37 0 019.5 15a3.53 3.53 0 112.82-1.45l1.46 1.83a1 1 0 01-.16 1.4z",
            fill: "currentColor"
        })
    });



const $d7a714c99fbff66f$export$c44ec8c273d81030 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12.26 22a1.28 1.28 0 01-.95-.4c-1.1-1.09.31-2.7 3.71-6.57 1.22-1.38 3.16-3.58 4.23-5.12A125.39 125.39 0 0014.83 14C9.11 19.49 6 22.28 4.37 20.62c-1.63-1.66.69-4.36 6.63-10.87 1.46-1.6 3.29-3.6 4.33-5a73.585 73.585 0 00-5.9 4.87c-4.61 4-6 5.16-7 4.1-1-1.06.37-2.86 3.43-6.27C6.74 6.42 8 5 8.67 4.09a17.22 17.22 0 00-4.88 2.74 1 1 0 01-1.4 0 1 1 0 010-1.39A17.35 17.35 0 016.12 3c2.35-1.17 3.82-1.35 4.61-.56 1.16 1.15-.37 2.87-3.43 6.28l-.4.44 1.22-1.02c5.41-4.74 7.76-6.6 9.3-5.84a1.28 1.28 0 01.69.92c.24 1.25-1.27 3-5.65 7.85C10.27 13.48 6.76 17.33 6 19c1.57-.76 5.17-4.22 7.42-6.38C18 8.25 19.65 6.76 20.89 7a1.29 1.29 0 01.94.69c.76 1.52-1 3.8-5.31 8.67-.65.73-1.4 1.59-2 2.37l1.41-1c2.91-2.16 4.66-3.47 5.76-2.37a1 1 0 01-1.06 1.61 22.932 22.932 0 00-3.51 2.33c-2.23 1.56-3.76 2.7-4.86 2.7z",
            fill: "currentColor"
        })
    });



const $a340b762f8551a7a$export$ac3a5105136e8616 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7.714 7.71a1.004 1.004 0 10-1.42-1.42l-.29.3V3a1 1 0 00-2 0v3.59l-.29-.3a1.004 1.004 0 00-1.42 1.42l2 2a1 1 0 001.42 0l2-2zm8.83 1.76h-2.67l2-5.48a1.48 1.48 0 00-2.54-1.43l-7.7 9.62a2 2 0 001.54 3.2h2.8L8.164 20a1.48 1.48 0 002.52 1.48l7.37-8.75a2 2 0 00-1.51-3.26z",
            fill: "currentColor"
        })
    });



const $ff25663a33fa22b5$export$cdeded076cd13dd8 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.24 8.17A10 10 0 009.099 2.427a10 10 0 1012.14 5.743zM14 19h-4a1 1 0 010-2h4a1 1 0 110 2zm1.71-7.29l-3 3a1 1 0 01-.33.21.94.94 0 01-.76 0 1.001 1.001 0 01-.33-.21l-3-3a1.004 1.004 0 011.42-1.42l1.29 1.3V6a1 1 0 012 0v5.59l1.29-1.3a1.004 1.004 0 111.42 1.42z",
            fill: "currentColor"
        })
    });



const $7a330602f0751bf4$export$990b955facd81352 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4 7h6a1 1 0 100-2H4a1 1 0 000 2zm0 6h6a1 1 0 000-2H4a1 1 0 000 2zm16.21-2.71a1.002 1.002 0 00-1.42 0l-1.29 1.3V6a1 1 0 00-2 0v5.59l-1.29-1.3a1.004 1.004 0 00-1.42 1.42l3 3a1.002 1.002 0 001.42 0l3-3a1.002 1.002 0 000-1.42zM19 17H4a1 1 0 000 2h15a1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $b1684a8c900bb264$export$43b886abf1ded66d = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10 17H4a1 1 0 000 2h6a1 1 0 000-2zm0-6H4a1 1 0 000 2h6a1 1 0 000-2zm8.79 3.29l-1.29 1.3V11.5a1 1 0 00-2 0v4.09l-1.29-1.3a1.004 1.004 0 10-1.42 1.42l3 3a1.002 1.002 0 001.42 0l3-3a1.004 1.004 0 00-1.42-1.42zM20 5H4a1 1 0 000 2h16a1 1 0 100-2z",
            fill: "currentColor"
        })
    });



const $31751230af4bedaa$export$ac8598120916667d = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 19H8c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1zM13.41 10l3.29-3.29a.996.996 0 10-1.41-1.41L12 8.59 8.71 5.3A.996.996 0 107.3 6.71L10.59 10 7.3 13.29a.996.996 0 00.71 1.7c.26 0 .51-.1.71-.29l3.29-3.29 3.29 3.29c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 000-1.41L13.43 10h-.02z",
            fill: "currentColor"
        })
    });



const $a5c16463083b51f9$export$1fc2820de190a272 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zm2.8 10.6l-3 4a.999.999 0 11-1.6-1.2L12 13h-2a1 1 0 01-.8-1.6l3-4a1 1 0 111.6 1.2L12 11h2a1 1 0 01.8 1.6z",
            fill: "currentColor"
        })
    });



const $e3f2ed97cffa54ca$export$8f7145c2d365ec6 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4.93 18.48c-.37 0-.73-.14-1.01-.42-.56-.56-.56-1.46 0-2.02L16.04 3.92c.56-.56 1.46-.56 2.02 0s.56 1.46 0 2.02L5.94 18.06c-.28.28-.64.42-1.01.42zM10.99 20.5c-.37 0-.73-.14-1.01-.42-.56-.56-.56-1.46 0-2.02l8.08-8.08c.56-.56 1.46-.56 2.02 0s.56 1.46 0 2.02L12 20.08c-.28.28-.64.42-1.01.42z",
            fill: "currentColor"
        })
    });



const $fbde742ea42d26c4$export$7a6a3d4b5c8b33e4 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M8 6a1 1 0 00-1 1v10a1 1 0 102 0V7a1 1 0 00-1-1zm4 2a1 1 0 00-1 1v6a1 1 0 002 0V9a1 1 0 00-1-1zm4 2a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $267237bab8dfdc7a$export$932e595845264bb0 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 20c5.523 0 10-3.582 10-8s-4.477-8-10-8S2 7.582 2 12s4.477 8 10 8z",
            fill: "currentColor"
        })
    });



const $971d1239166f6d85$export$1778f56e136ea11c = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15.5 5H12a1 1 0 000 2h3.5a3.5 3.5 0 110 7H6.41l2.3-2.29a1.004 1.004 0 00-1.42-1.42l-4 4a1 1 0 000 1.42l4 4a1 1 0 001.639-.325 1 1 0 00-.22-1.095L6.41 16h9.09a5.5 5.5 0 000-11z",
            fill: "currentColor"
        })
    });



const $fc2315c63cf2c06f$export$33132ea7e0b96231 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7 4h10a1 1 0 100-2H7a1 1 0 000 2zM5 8h14a1 1 0 100-2H5a1 1 0 000 2zm14 2H5a3 3 0 00-3 3v6a3 3 0 003 3h14a3 3 0 003-3v-6a3 3 0 00-3-3z",
            fill: "currentColor"
        })
    });



const $6f18212a132ef404$export$43b08451cf465258 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15.41 16l5.3-5.29a.997.997 0 00.219-1.095.998.998 0 00-.22-.325l-6-6a.999.999 0 00-1.42 0L7.38 9.21 14.17 16h1.24zM20 18h-6.67L6 10.62l-2.71 2.67a1 1 0 000 1.42l5 5A1 1 0 009 20h11a1 1 0 100-2z",
            fill: "currentColor"
        })
    });



const $3b986dfd749f41fd$export$e49f0b9552cd8acb = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18.71 15.29a1.004 1.004 0 10-1.42 1.42l.3.29H7a2 2 0 01-2-2 1 1 0 10-2 0 4 4 0 004 4h10.59l-.3.29a1 1 0 000 1.42 1.001 1.001 0 001.42 0l2-2a.999.999 0 000-1.42l-2-2zM5.29 8.71a1 1 0 001.42 0 1 1 0 000-1.42L6.41 7H17a2 2 0 012 2 1 1 0 002 0 4 4 0 00-4-4H6.41l.3-.29a1.004 1.004 0 00-1.42-1.42l-2 2a1 1 0 000 1.42l2 2z",
            fill: "currentColor"
        })
    });



const $4176ad9423193adf$export$3cafa4f65eab9862 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.111 4h-5.333c-.534 0-.89.356-.89.889s.356.889.89.889h4.444v4.444c0 .534.356.89.89.89.532 0 .888-.356.888-.89V4.89c0-.533-.356-.889-.889-.889zM10.222 18.222H5.778v-4.444c0-.534-.356-.89-.89-.89-.532 0-.888.356-.888.89v5.333c0 .533.356.889.889.889h5.333c.534 0 .89-.356.89-.889s-.356-.889-.89-.889z",
            fill: "currentColor"
        })
    });



const $0713149d9d10ea66$export$c931d0885b512601 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 11a1 1 0 100 2 1 1 0 000-2zm0-9a10 10 0 100 20 10 10 0 000-20zm3.89 7.45L14 13.15a2 2 0 01-.89.89l-3.7 1.85A.93.93 0 019 16a1 1 0 01-.71-.29 1 1 0 01-.18-1.16l1.89-3.7a2 2 0 01.89-.89l3.7-1.85a1 1 0 011.34 1.34h-.04z",
            fill: "currentColor"
        })
    });



const $1c9300fdd519dffe$export$df7cd0eadaea4b97 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 3H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-3-3zm-1 15h-3a1 1 0 010-2h3a1 1 0 010 2zm1.53-12.57L5.42 17.61a.25.25 0 01-.42-.18V6a1 1 0 011-1h12.36a.25.25 0 01.17.43zM11 8h-1V7a1 1 0 00-2 0v1H7a1 1 0 000 2h1v1a1 1 0 102 0v-1h1a1 1 0 100-2z",
            fill: "currentColor"
        })
    });



const $cb435da8fee5613b$export$d8f33cb400e25080 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 3h-6c-.55 0-1 .45-1 1s.45 1 1 1h3.59L12.8 9.79a.996.996 0 00.71 1.7c.26 0 .51-.1.71-.29l4.79-4.79V10c0 .55.45 1 1 1s1-.45 1-1V4c0-.55-.45-1-1-1H20zM9.79 12.79L5 17.58v-3.59c0-.55-.45-1-1-1s-1 .45-1 1v6c0 .55.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1H6.41l4.79-4.79a.996.996 0 10-1.41-1.41z",
            fill: "currentColor"
        })
    });



const $f9d8e2d4b0f1fae8$export$7be70a3e89478b87 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M22 4.24a.6.6 0 00-.48-.4l-1.34-.2-.61-1.29a.59.59 0 00-1.08 0l-.61 1.29-1.34.2a.6.6 0 00-.34 1l1 1-.28 1.46a.61.61 0 00.89.63L19 7.27l1.19.66a.63.63 0 00.64-.04.61.61 0 00.25-.59l-.24-1.43 1-1a.59.59 0 00.16-.63zM10 6a8 8 0 100 16 8 8 0 000-16zm-4 6a1 1 0 112 0 1 1 0 01-2 0zm7.25 5.75a4.85 4.85 0 01-6.5 0 1.001 1.001 0 01.97-1.734.999.999 0 01.34.234 2.88 2.88 0 003.88 0 .998.998 0 011.478.032 1 1 0 01-.168 1.468zM13 13a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $bfca1a3820aa9a77$export$8cd1ef6658092bac = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M11 13c-1 0-3 .84-3 4s2 4 3 4a1 1 0 001-1v-6a1 1 0 00-1-1zm0-2c0-1-.84-3-4-3s-4 2-4 3a1 1 0 001 1h6a1 1 0 001-1zm5-4c0-3.16-2-4-3-4a1 1 0 00-1 1v6a1 1 0 001 1c1 0 3-.84 3-4zm4 5h-6a1 1 0 00-1 1c0 1 .84 3 4 3s4-2 4-3a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $2e759fc7d1b7259b$export$db55b4b9602b2fe9 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 7c0-3.16-2-4-3-4a1 1 0 00-1 1v6a1 1 0 001 1c1 0 3-.84 3-4zm4 5h-6a1 1 0 00-1 1c0 1 .84 3 4 3s4-2 4-3a1 1 0 00-1-1zm-2.68-2a.51.51 0 00.68-.32l.22-.68h1.56l.25.68a.51.51 0 00.47.32h.18a.51.51 0 00.32-.68l-1.5-4a.52.52 0 00-.94 0l-1.5 4a.51.51 0 00.26.68zM19 6.92L19.4 8h-.8l.4-1.08zM11 13c-1 0-3 .84-3 4s2 4 3 4a1 1 0 001-1v-6a1 1 0 00-1-1zm0-2c0-1-.84-3-4-3s-4 2-4 3a1 1 0 001 1h6a1 1 0 001-1z",
            fill: "currentColor"
        })
    });



const $2570f6c98529f450$export$37b8844f7f15f21d = (m)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...m,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4 12h6a1 1 0 001-1c0-1-.84-3-4-3s-4 2-4 3a1 1 0 001 1zm1-5a1 1 0 100-2 1 1 0 000 2zm3-2a.92.92 0 011 1 1 1 0 002 0 2.91 2.91 0 00-3-3 1 1 0 000 2zM6 18a1 1 0 100 2 1 1 0 000-2zm12-7a2.91 2.91 0 003-3 1 1 0 00-2 0 .92.92 0 01-1 1 1 1 0 100 2zm0-5a1 1 0 100-2 1 1 0 000 2zm-2 13a.92.92 0 01-1-1 1 1 0 00-2 0 2.909 2.909 0 003 3 1 1 0 000-2zm3-2a1 1 0 100 2 1 1 0 000-2zM6 13a2.909 2.909 0 00-3 3 1 1 0 002 0 .92.92 0 011-1 1 1 0 000-2zm14-1h-6a1 1 0 00-1 1c0 1 .84 3 4 3s4-2 4-3a1 1 0 00-1-1zm-4-5c0-3.16-2-4-3-4a1 1 0 00-1 1v6a1 1 0 001 1c1 0 3-.84 3-4zm-5 6c-1 0-3 .84-3 4s2 4 3 4a1 1 0 001-1v-6a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $96d18e0913a7c627$export$f5c78efd66fc0145 = (m)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...m,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10 8a1 1 0 100-2 1 1 0 000 2zm-3 5a1 1 0 100 2 1 1 0 000-2zm4-2c0-1-.84-3-4-3s-4 2-4 3a1 1 0 001 1h6a1 1 0 001-1zm6 0a1 1 0 100-2 1 1 0 000 2zm-3 5a1 1 0 100 2 1 1 0 000-2zm6-4h-6a1 1 0 00-1 1c0 1 .84 3 4 3s4-2 4-3a1 1 0 00-1-1zm-4-5c0-3.16-2-4-3-4a1 1 0 00-1 1v6a1 1 0 001 1c1 0 3-.84 3-4zm-5 6c-1 0-3 .84-3 4s2 4 3 4a1 1 0 001-1v-6a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $75ab90d818e41e2b$export$9802a4e8438e3f3f = (m)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...m,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4 12h6a1 1 0 001-1c0-1-.84-3-4-3s-4 2-4 3a1 1 0 001 1zm4-7a.92.92 0 011 1 1 1 0 002 0 2.91 2.91 0 00-3-3 1 1 0 000 2zm-2 8a2.909 2.909 0 00-3 3 1 1 0 002 0 .92.92 0 011-1 1 1 0 000-2zm12-3a2.909 2.909 0 003-3 1 1 0 00-2 0 .92.92 0 01-1 1 1 1 0 100 2zm-2 9a.92.92 0 01-1-1 1 1 0 00-2 0 2.909 2.909 0 003 3 1 1 0 000-2zm-5-6c-1 0-3 .84-3 4s2 4 3 4a1 1 0 001-1v-6a1 1 0 00-1-1zm9-1h-6a1 1 0 00-1 1c0 1 .84 3 4 3s4-2 4-3a1 1 0 00-1-1zm-4-5c0-3.16-2-4-3-4a1 1 0 00-1 1v6a1 1 0 001 1c1 0 3-.84 3-4z",
            fill: "currentColor"
        })
    });



const $9cf33a4e5e777c1c$export$ab8114e8e722f98c = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M5.07 8l5.2 3a1 1 0 001.36-.37A2.75 2.75 0 0011.94 9a4 4 0 00-2.27-3c-2.74-1.58-4.45-.31-5 .59a1 1 0 00-.1.76 1 1 0 00.5.65zm5.66 4.39a.998.998 0 00-.1-.76c-.51-.89-2.22-2.17-5-.59A4 4 0 003.4 14a2.75 2.75 0 00.31 1.67 1 1 0 001.36.37l5.2-3a1 1 0 00.46-.65zM11 13c-1 0-3 .84-3 4s2 4 3 4a1 1 0 001-1v-6a1 1 0 00-1-1zm9.29-4.63A1 1 0 0018.93 8l-5.2 3a1 1 0 00-.46.61 1 1 0 00.1.76 2.869 2.869 0 002.51 1.34 4.85 4.85 0 002.45-.71 4 4 0 002.27-3 2.75 2.75 0 00-.31-1.63zM18.93 16l-5.2-3a1 1 0 00-1.36.37 2.75 2.75 0 00-.31 1.63 4 4 0 002.27 3 4.85 4.85 0 002.45.75 2.87 2.87 0 002.51-1.34.998.998 0 00.1-.76 1 1 0 00-.46-.65zM13 11c1 0 3-.84 3-4s-2-4-3-4a1 1 0 00-1 1v6a1 1 0 001 1z",
            fill: "currentColor"
        })
    });



const $caba23206c9de786$export$34a92663ec545531 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12.5 2a9.49 9.49 0 00-8.59 13.54l-.56 3.39a1.49 1.49 0 001.72 1.72l3.39-.56A9.5 9.5 0 1012.5 2zm0 15.5a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5zm1.77-5.36c-.66.42-.77.54-.77.86a1 1 0 11-2 0 2.93 2.93 0 011.69-2.55c.65-.41.81-.56.81-.95a1.5 1.5 0 10-3 0 1 1 0 11-2 0 3.5 3.5 0 117 0 2.999 2.999 0 01-1.73 2.64z",
            fill: "currentColor"
        })
    });



const $6fcc176c6087260b$export$3365e792a6a8a61f = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7.71 11.29a1 1 0 00-1.42 0l-.22.22a6 6 0 0110.22-3.75 1.004 1.004 0 101.42-1.42 8 8 0 00-13.64 5.31l-.36-.36a1.004 1.004 0 10-1.42 1.42l2 2a1.001 1.001 0 001.42 0l2-2a1 1 0 000-1.42zm14 0l-2-2a.999.999 0 00-1.42 0l-2 2a1.003 1.003 0 101.42 1.42l.27-.27A6 6 0 0112 18a5.93 5.93 0 01-4.24-1.76 1.004 1.004 0 10-1.42 1.42A8 8 0 0020 12.39l.31.32a1.001 1.001 0 001.42 0 1 1 0 00-.02-1.42zM12 9.51A2 2 0 0010.73 9a1.89 1.89 0 00-1.91 1.92c0 1.19.93 2.27 2.53 3.74l.17.15a.7.7 0 001 0l.17-.15c1.6-1.47 2.53-2.55 2.53-3.74A1.89 1.89 0 0013.27 9a2 2 0 00-1.27.51z",
            fill: "currentColor"
        })
    });



const $3f1ae98b52bcedb2$export$19ef8cc540c407ac = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4 7h9.18a3 3 0 005.64 0H20a1 1 0 100-2h-1.18a3 3 0 00-5.64 0H4a1 1 0 000 2zm12-2a1 1 0 110 2 1 1 0 010-2zm4 12h-1.18a3 3 0 00-5.64 0H4a1 1 0 000 2h9.18a3 3 0 005.64 0H20a1 1 0 100-2zm-4 2a1 1 0 110-2 1 1 0 010 2zm4-8h-9.18a3 3 0 00-5.64 0H4a1 1 0 000 2h1.18a3 3 0 005.64 0H20a1 1 0 100-2zM8 13a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $f5847e1a840c0a46$export$b711d682fdca97f7 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M11 9c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm5.5-7h-9c-1.66 0-3 1.34-3 3v14c0 1.66 1.34 3 3 3h9c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3zm.21 14.71c-.2.2-.45.29-.71.29-.26 0-.51-.1-.71-.29l-2.27-2.27c-.59.35-1.28.57-2.02.57-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4c0 .74-.22 1.42-.57 2.02l2.27 2.27c.39.39.39 1.02 0 1.41h.01z",
            fill: "currentColor"
        })
    });



const $673a1678bc3d83ba$export$69764c52cacf3343 = (v)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...v,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M8 16a1 1 0 00-1 1v3a1 1 0 102 0v-3a1 1 0 00-1-1zM5.66 6a1 1 0 00-1.37.34A9 9 0 003 11v7a1 1 0 102 0v-7a7.05 7.05 0 011-3.6A1 1 0 005.66 6zM12 17a1 1 0 00-1 1v3a1 1 0 002 0v-3a1 1 0 00-1-1zm0-11a5 5 0 00-5 5v2a1 1 0 102 0v-2a3 3 0 016 0v9a1 1 0 002 0v-9a5 5 0 00-5-5zm0 4a1 1 0 00-1 1v3a1 1 0 002 0v-3a1 1 0 00-1-1zm8 5a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1zM12 2a9 9 0 00-4.5 1.21 1 1 0 101 1.73A7.09 7.09 0 0112 4a7 7 0 017 7v1a1 1 0 002 0v-1a9 9 0 00-9-9z",
            fill: "currentColor"
        })
    });



const $c10626ba368e41b0$export$4824bf1948af82d6 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18.48 10l2.11-2.79A2 2 0 0019 4H5V3a1 1 0 00-2 0v18a1 1 0 102 0v-5h14a2 2 0 001.59-3.21L18.48 10z",
            fill: "currentColor"
        })
    });



const $bf17c7f1cf853386$export$b09235ac0da04192 = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M3.64 6.23A1 1 0 002 7v10a1 1 0 001.64.77l6-5c.23-.19.36-.47.36-.77 0-.3-.13-.58-.36-.77l-6-5zM4 14.86V9.13L7.44 12 4 14.87v-.01zM12 3c-.55 0-1 .45-1 1v16c0 .55.45 1 1 1s1-.45 1-1V4c0-.55-.45-1-1-1zm9.42 3.09a.978.978 0 00-1.06.14l-6 5c-.23.19-.36.47-.36.77 0 .3.13.58.36.77l6 5a1.005 1.005 0 001.06.14c.35-.16.58-.52.58-.91V7a1 1 0 00-.58-.91z",
            fill: "currentColor"
        })
    });



const $e6a78f70ab9734ef$export$22c17efe10d64fc = (r)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M9.75 16.99h4.5c.6 0 1.17-.24 1.59-.66.42-.42.66-.99.66-1.59V4.25c0-.6-.24-1.17-.66-1.59-.42-.42-.99-.66-1.59-.66h-4.5c-.6 0-1.17.24-1.59.66-.42.42-.66.99-.66 1.59v10.49c0 .6.24 1.17.66 1.59.42.42.99.66 1.59.66zm1.27-3.2c.04-.19.13-.37.27-.51s.32-.24.51-.27A1.014 1.014 0 0113 14c0 .27-.11.52-.29.71-.18.19-.44.29-.71.29-.2 0-.39-.06-.56-.17-.16-.11-.29-.27-.37-.45a.956.956 0 01-.06-.58l.01-.01z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M18.04 14.26l-.21-.02a.941.941 0 00-.81 1.43c.13.21.34.36.59.42 1.74.42 2.38.91 2.51 1.09-.18.29-1.78 1.2-5.61 1.52-.52.04-.9.5-.86 1.01.04.49.45.86.94.86h.09c2.2-.19 7.33-.9 7.33-3.42 0-.89-.68-2.12-3.96-2.9l-.01.01zM12.86 19.39h.01l-.02-.05a1.74 1.74 0 00-.11-.18l-.15-.16-1.22-1.22a.914.914 0 00-.66-.27c-.25 0-.49.1-.66.27-.18.18-.27.41-.27.66 0 .1 0 .19.04.28-3.71-.27-5.7-1.19-5.92-1.56.14-.19.78-.67 2.51-1.08.24-.06.45-.2.58-.42.13-.21.18-.47.11-.71a.943.943 0 00-.92-.72c-.08 0-.15 0-.22.03-3.27.79-3.96 2.01-3.96 2.9 0 2.16 3.98 3.2 7.87 3.46a.938.938 0 00.17 1.08c.18.18.41.27.66.27.25 0 .49-.1.66-.27l1.3-1.3c.09-.09.16-.19.21-.3.05-.12.07-.24.07-.36 0-.11-.02-.21-.06-.31l-.02-.05v.01z",
                fill: "currentColor"
            })
        ]
    });



const $d4f6cbf0a4eb0d74$export$8f17510b89c20aa8 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M11.23 9.64c.19.23.47.36.77.36.3 0 .58-.13.77-.36l5-6A1 1 0 0017 2H7a1 1 0 00-.77 1.64l5 6zM14.86 4L12 7.44 9.14 4h5.73-.01zM20 11H4c-.55 0-1 .45-1 1s.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1zm-7.23 3.36c-.38-.46-1.16-.46-1.54 0l-5 6A1 1 0 007 22h10a1 1 0 00.77-1.64l-5-6z",
            fill: "currentColor"
        })
    });



const $bfd2ac108a5a0f08$export$759d8401e4c49516 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.12 6.88A3 3 0 0019 6h-6.59l-1.12-1.12A3 3 0 009.17 4H5a3 3 0 00-3 3v10a3 3 0 003 3h14a3 3 0 003-3V9a3 3 0 00-.88-2.12zM14 14h-4a1 1 0 010-2h4a1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $2b765280fb1538de$export$f6c9de28bcfc2777 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10 16h4a2 2 0 002-2v-4a2 2 0 00-2-2h-4a2 2 0 00-2 2v4a2 2 0 002 2zm11 2h-1V6h1a1 1 0 100-2h-1V3a1 1 0 00-2 0v1H6V3a1 1 0 00-2 0v1H3a1 1 0 000 2h1v12H3a1 1 0 000 2h1v1a1 1 0 102 0v-1h12v1a1 1 0 002 0v-1h1a1 1 0 000-2zm-3 0H6V6h12v12z",
            fill: "currentColor"
        })
    });



const $61b8992a672d136b$export$59d3f71ce90c5c10 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M5 18a3 3 0 003 3h3v-8H5v5zM20 7h-1.18A3 3 0 0016 3h-2a3 3 0 00-2 .78A3 3 0 0010 3H8a3 3 0 00-2.82 4H4a1 1 0 00-1 1v2a1 1 0 001 1h16a1 1 0 001-1V8a1 1 0 00-1-1zm-9 0H8a1 1 0 010-2h2a1 1 0 011 1v1zm5 0h-3V6a1 1 0 011-1h2a1 1 0 110 2zm-3 14h3a3 3 0 003-3v-5h-6v8z",
            fill: "currentColor"
        })
    });



const $2cc54608d447953b$export$e0aa58e81c147560 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18.5 16a2.5 2.5 0 100 5 2.5 2.5 0 000-5zM18 3H6a3 3 0 00-3 3v12a3 3 0 003 3h7a1 1 0 000-2H6a1 1 0 01-1-1V6a1 1 0 011-1h12a1 1 0 011 1v7a1 1 0 002 0V6a3 3 0 00-3-3zm-6 5a4 4 0 100 8 4 4 0 000-8z",
            fill: "currentColor"
        })
    });



const $1125f882c0146953$export$cd202841eb49e57d = (s)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...s,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.43 10.09c-.45-.21-.98-.06-1.26.35L16.46 13a.25.25 0 01-.46-.14V5c0-.55-.45-1-1-1s-1 .45-1 1v5.5c0 .28-.22.5-.5.5s-.5-.22-.5-.5V3c0-.55-.45-1-1-1s-1 .45-1 1v7.5c0 .28-.22.5-.5.5s-.5-.22-.5-.5V4c0-.55-.45-1-1-1s-1 .45-1 1v7.5c0 .28-.22.5-.5.5s-.5-.22-.5-.5V7c0-.55-.45-1-1-1s-1 .45-1 1v7.99c0 3.71 2.88 6.93 6.59 7.01 3.06.06 5.72-1.88 6.6-4.8l1.77-5.91a.998.998 0 00-.53-1.19v-.01z",
            fill: "currentColor"
        })
    });



const $4e649004202e151d$export$2189d885bb90f002 = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15 4c-.55 0-1 .45-1 1v.76l1.56-1.56c-.16-.11-.35-.2-.56-.2zm-5 0c0-.55-.45-1-1-1s-1 .45-1 1v7.76l2-2V4zm3-1c0-.55-.45-1-1-1s-1 .45-1 1v5.76l2-2V3zm-6 9.5V7c0-.55-.45-1-1-1s-1 .45-1 1v7.76l2.05-2.05A.465.465 0 017 12.5zm13.71-7.79A.996.996 0 1019.3 3.3L3.29 19.29a.996.996 0 00.71 1.7c.26 0 .51-.1.71-.29l1.6-1.6c1.19 1.7 3.09 2.85 5.28 2.89 3.06.06 5.72-1.88 6.6-4.8l1.77-5.91a.998.998 0 00-.53-1.19.992.992 0 00-1.26.34l-1.71 2.56a.25.25 0 01-.46-.14V9.41l4.71-4.71v.01z",
            fill: "currentColor"
        })
    });



const $cf90b2d19341db15$export$5df289911fe08c4c = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7 8a1 1 0 00-1 1v2H4V9a1 1 0 00-2 0v6a1 1 0 102 0v-2h2v2a1 1 0 102 0V9a1 1 0 00-1-1zm14.16 5.08A3 3 0 0019 8h-2a1 1 0 00-1 1v6a1 1 0 002 0v-1h1c.12.01.24.01.36 0l.75 1.49A1 1 0 0021 16a.93.93 0 00.45-.11 1 1 0 00.44-1.34l-.73-1.47zM19 12h-1v-2h1a1 1 0 010 2zm-7-4h-2a1 1 0 00-1 1v6a1 1 0 001 1h2c1 0 3-.84 3-4s-2-4-3-4zm0 6h-1v-4h1c.17 0 1 .16 1 2s-.83 2-1 2z",
            fill: "currentColor"
        })
    });



const $e48b4b26cbcb7623$export$4cdf5f8fb031511 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 13h-2a1 1 0 00-1 1v6a1 1 0 001 1h2c1 0 3-.84 3-4s-2-4-3-4zm0 6h-1v-4h1c.17 0 1 .16 1 2s-.83 2-1 2zm-5-6a1 1 0 00-1 1v2H4v-2a1 1 0 10-2 0v6a1 1 0 102 0v-2h2v2a1 1 0 102 0v-6a1 1 0 00-1-1zm12 0h-2a1 1 0 00-1 1v6a1 1 0 002 0v-1h1c.12.01.24.01.36 0l.75 1.49A1 1 0 0021 21a.93.93 0 00.45-.11 1 1 0 00.44-1.34l-.73-1.47A3 3 0 0019 13zm0 4h-1v-2h1a1 1 0 010 2zm1-14h-4a2 2 0 00-2 2v4a2 2 0 002 2h4a2 2 0 002-2V5a2 2 0 00-2-2zm-.32 6.47h-.18a.51.51 0 01-.5-.29l-.25-.68h-1.53l-.22.68a.51.51 0 01-.65.29.52.52 0 01-.35-.65l1.5-4a.52.52 0 01.94 0l1.5 4a.51.51 0 01-.26.65zm-2.08-2h.8L18 6.42l-.4 1.05z",
            fill: "currentColor"
        })
    });



const $62d8c4f92a8a3c00$export$ed7933a7636060f8 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12.27 8l2.55 2.55A3.08 3.08 0 0012.27 8zM4.71 3.29a1.004 1.004 0 10-1.42 1.42l3.37 3.36A1 1 0 006 9v2H4V9a1 1 0 00-2 0v6a1 1 0 102 0v-2h2v2a1 1 0 102 0V9.41l1 1V15a1 1 0 001 1h2a2.76 2.76 0 001.81-.77l5.48 5.48a1.002 1.002 0 001.639-.325 1 1 0 00-.219-1.095l-16-16zM12 14h-1v-1.59l1.4 1.41a.87.87 0 01-.4.18zm9.18-.92A3 3 0 0019 8h-2a1 1 0 00-1 1v2.76L18.24 14H19c.12.01.24.01.36 0l.75 1.49A1 1 0 0021 16a.93.93 0 00.45-.11 1 1 0 00.44-1.34l-.71-1.47zM19 12h-1v-2h1a1 1 0 110 2z",
            fill: "currentColor"
        })
    });



const $834281b73576bba9$export$69bc39f17dadde14 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 11h-1v-1a7 7 0 10-14 0v1H4a2 2 0 00-2 2v4a2 2 0 002 2h1a2 2 0 002-2v-7a5 5 0 1110 0v7a2 2 0 002 2h1a2 2 0 002-2v-4a2 2 0 00-2-2zm-4.45 6.17l-2.5-1.67 2.5-1.67a1 1 0 000-1.63l-4-3a1 1 0 00-1-.09A1 1 0 0010 10v3.46l-.45-.29a1 1 0 00-1.1 1.66l1 .67-1 .67a1 1 0 001.11 1.66l.45-.3V21a1 1 0 00.55.89.91.91 0 00.44.11 1 1 0 00.6-.2l4-3a1 1 0 000-1.63h-.05zM12 12l1.27.95-1.27.85V12zm0 7v-1.8l1.27.85L12 19z",
            fill: "currentColor"
        })
    });



const $f69b59f202ed43a1$export$a920c14827773107 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M9 1.99h5.99a2 2 0 012 2v7H7v-7a2 2 0 012-2zM15 21.99H9.01a2 2 0 01-2-2v-7H17v7a2 2 0 01-2 2z",
            fill: "currentColor"
        })
    });



const $7c6c647afdddd839$export$20f34fa971a4dda4 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 10a6 6 0 006-6 1 1 0 00-1-1H7a1 1 0 00-1 1 6 6 0 006 6zm-3.29 2.29a1 1 0 00-1.42 0L5 14.59V14a1 1 0 10-2 0v3a1 1 0 001 1h3a1 1 0 000-2h-.59l2.3-2.29a1 1 0 000-1.42zM20 13a1 1 0 00-1 1v.59l-2.29-2.3a1.004 1.004 0 10-1.42 1.42l2.3 2.29H17a1 1 0 000 2h3a1 1 0 001-1v-3a1 1 0 00-1-1zm-6.71 4.29l-.29.3V13a1 1 0 00-2 0v4.59l-.29-.3a1.004 1.004 0 00-1.42 1.42l2 2a1.002 1.002 0 001.42 0l2-2a1.004 1.004 0 10-1.42-1.42z",
            fill: "currentColor"
        })
    });



const $05aba797b919ead7$export$eff1a97fdd1fff59 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 4a1 1 0 100-2H5a1 1 0 000 2c.38 4.49 3.35 8 7 8s6.57-3.51 7-8zM8.51 8a8.2 8.2 0 01-1.45-4h9.88a8.2 8.2 0 01-1.45 4H8.51zM19 20c-.38-4.49-3.35-8-6.95-8s-6.57 3.51-6.95 8H5a1 1 0 000 2h14a1 1 0 000-2zM8.51 16A4.37 4.37 0 0112 14a4.37 4.37 0 013.49 2H8.51z",
            fill: "currentColor"
        })
    });



const $9cdc50eb328c7058$export$105134528b84b926 = (r)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M5 13h4.59l-.29.29a.996.996 0 00.71 1.7c.26 0 .51-.1.71-.29l2-2a.996.996 0 000-1.41l-2-2a.996.996 0 10-1.41 1.41l.29.29H3c-.55 0-1 .45-1 1s.45 1 1 1h2V13z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M19 4H6C4.35 4 3 5.35 3 7v2h2V7c0-.55.45-1 1-1h13c.55 0 1 .45 1 1v10c0 .55-.45 1-1 1H6c-.55 0-1-.45-1-1v-2H3v2c0 1.65 1.35 3 3 3h13c1.65 0 3-1.35 3-3V7c0-1.65-1.35-3-3-3z",
                fill: "currentColor"
            })
        ]
    });



const $a83ffbc4efbfd954$export$71c2580fd0e0bab3 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zm0 18c-.84 0-1.95-1.48-2.55-4h5.1c-.55 2.52-1.71 4-2.55 4zm-2.89-6a18.24 18.24 0 010-4h5.78c.074.664.11 1.332.11 2 0 .668-.036 1.336-.11 2H9.11zM4 12a8.24 8.24 0 01.26-2h2.83C7 10.64 7 11.31 7 12s0 1.36.09 2H4.26A8.24 8.24 0 014 12zm8-8c.84 0 1.95 1.48 2.55 4h-5.1c.6-2.52 1.71-4 2.55-4zm4.91 6h2.83a7.82 7.82 0 010 4h-2.83c.06-.64.09-1.31.09-2s0-1.36-.09-2zm2-2h-2.3a12.788 12.788 0 00-1-3.15A8.1 8.1 0 0118.92 8h-.01zM8.44 4.85A12.79 12.79 0 007.39 8H5.08a8.1 8.1 0 013.36-3.15zM5.08 16h2.31a12.79 12.79 0 001 3.15A8.1 8.1 0 015.08 16zm10.48 3.15a12.788 12.788 0 001-3.15h2.31a8.1 8.1 0 01-3.31 3.15z",
            fill: "currentColor"
        })
    });



const $1fc6a559f6d65efb$export$9a2d5f5603250b20 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15 5a6.88 6.88 0 00-3 .69A6.88 6.88 0 009 5a7 7 0 000 14 6.88 6.88 0 003-.69 6.88 6.88 0 003 .69 7 7 0 100-14zm-5 11.9a5 5 0 110-9.8 7 7 0 000 9.8zm5 .1a5.584 5.584 0 01-1-.1 7 7 0 000-9.8 5 5 0 111 9.9z",
            fill: "currentColor"
        })
    });



const $1b9473e13929750a$export$dca9ddf5780d3131 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 3h-9c-.55 0-1 .45-1 1s.45 1 1 1h3.38l-7 14H4c-.55 0-1 .45-1 1s.45 1 1 1h9c.55 0 1-.45 1-1s-.45-1-1-1H9.62l7-14H20c.55 0 1-.45 1-1s-.45-1-1-1z",
            fill: "currentColor"
        })
    });



const $6e51a8b482ad5d26$export$666a333ca876f84c = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.71 16.71l-7.88-7.88c.112-.434.17-.881.17-1.33A5.5 5.5 0 107.5 13c.449 0 .896-.058 1.33-.17L10 14h2v2h2v2h2v2l.71.71a1 1 0 00.7.29H20a1 1 0 001-1v-2.59a1 1 0 00-.29-.7zM6.5 8a1.5 1.5 0 110-3 1.5 1.5 0 010 3z",
            fill: "currentColor"
        })
    });



const $65df72eaca0381cd$export$44cfcbb17cec67d7 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.71 16.71l-6-6L20.49 5a1.055 1.055 0 00-.745-1.799A1.053 1.053 0 0019 3.51L3.51 19A1.053 1.053 0 105 20.49L11.44 14H12v2h2v2h2v2l.71.71a1 1 0 00.7.29H20a1 1 0 001-1v-2.59a1 1 0 00-.29-.7zM6.81 13L13 6.81A5.5 5.5 0 106.81 13zM6.5 5a1.5 1.5 0 110 3 1.5 1.5 0 010-3z",
            fill: "currentColor"
        })
    });



const $38d05dea931a875e$export$692ece75168a068c = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 5H5C3.34 5 2 6.34 2 8v8c0 1.66 1.34 3 3 3h14c1.66 0 3-1.34 3-3V8c0-1.66-1.34-3-3-3zm-7 3c.83 0 1.5.67 1.5 1.5S12.83 11 12 11s-1.5-.67-1.5-1.5S11.17 8 12 8zm2 8h-4c-.55 0-1-.45-1-1 0-1.66 1.34-3 3-3s3 1.34 3 3c0 .55-.45 1-1 1z",
            fill: "currentColor"
        })
    });



const $ab6d9bfa47542205$export$28390bfec38e5c4f = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.71 4.29A1 1 0 0021 4h-2.23a1 1 0 00-.71.29 1 1 0 00-.29.71 1 1 0 001 1H19v1.48a2 2 0 01-.85.09 2.3 2.3 0 01-.81-.24A2.29 2.29 0 0016 4.1a2.3 2.3 0 00-2.62.9 1 1 0 00-.15.75 1 1 0 00.43.63 1 1 0 001.39-.28.36.36 0 01.14-.1.54.54 0 01.18 0 .4.4 0 01.15.1.28.28 0 01.07.17.32.32 0 01-.08.21.309.309 0 01-.22.09 1 1 0 00-.92.615 1 1 0 00-.08.385 1 1 0 00.3.7 1 1 0 00.7.3.76.76 0 01.42.12.7.7 0 01.27.34.779.779 0 01.05.43.72.72 0 01-.21.38.78.78 0 01-.38.2A.71.71 0 0115 10a.82.82 0 01-.34-.27.791.791 0 01-.12-.42 1 1 0 00-2 0 2.73 2.73 0 004.56 2.05 2.72 2.72 0 00.9-1.81c.133.01.267.01.4 0 .2.014.402.008.6-.02v1.56c.004.265.108.518.29.71a1.001 1.001 0 001.42 0 1.05 1.05 0 00.29-.71V6a1 1 0 00.71-.29A1.05 1.05 0 0022 5a.999.999 0 00-.29-.71zm-12.28.34a1 1 0 00-1.86 0l-5.5 14a1 1 0 000 .77c.11.24.307.428.55.53a1 1 0 00.77 0c.24-.11.429-.307.53-.55L5.65 15h5.7l1.72 4.37c.049.119.12.228.21.32.09.097.2.175.32.23a1.07 1.07 0 00.79.01c.12-.049.228-.12.32-.21.097-.09.176-.2.23-.32A.998.998 0 0015 19a1.067 1.067 0 00-.07-.39L9.43 4.63zm-3 8.37L8.5 7.73 10.57 13H6.43z",
            fill: "currentColor"
        })
    });



const $a36e444fcdcd0cd2$export$37eb6be167ced64 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M3 18c0 1.66 1.34 3 3 3h8V10H3v8zM18 3H6C4.34 3 3 4.34 3 6v2h18V6c0-1.66-1.34-3-3-3zm-2 18h2c1.66 0 3-1.34 3-3v-8h-5v11z",
            fill: "currentColor"
        })
    });



const $4ae1c1adc0c24266$export$6ca314f2963187d3 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4 3a2 2 0 00-2 2v14a2 2 0 004 0V5a2 2 0 00-2-2zm6 0a2 2 0 00-2 2v14a2 2 0 004 0V5a2 2 0 00-2-2zm11.88 15.32L17.09 5.16a2.001 2.001 0 00-3.76 1.37l4.79 13.15a2 2 0 103.76-1.36z",
            fill: "currentColor"
        })
    });



const $cbc0f7723c2a9df5$export$a733607c708b10c = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.71 19.29l-16-16A.996.996 0 103.3 4.7l15.99 16.01c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 000-1.41v-.01z",
            fill: "currentColor"
        })
    });



const $d996a786e0252fcd$export$4a5f65aa5aa35e63 = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12.29 10.29a.996.996 0 000 1.41c.87.87 1 2.16.3 2.87l-3.07 3.07c-.32.33-.78.48-1.3.45-.57-.04-1.12-.3-1.56-.75-.44-.44-.71-1-.74-1.56-.04-.52.12-.98.45-1.3l1.28-1.28a.996.996 0 10-1.41-1.41l-1.28 1.28c-.74.74-1.1 1.75-1.03 2.85.07 1.05.54 2.06 1.33 2.84a4.52 4.52 0 002.84 1.33h.29c.99 0 1.89-.36 2.57-1.04l3.07-3.07c1.49-1.49 1.35-4.04-.3-5.7a.996.996 0 00-1.41 0l-.03.01zm6.47-5.05a4.52 4.52 0 00-2.84-1.33c-1.1-.08-2.12.29-2.85 1.03L10 8.01c-.74.74-1.1 1.75-1.03 2.85.07 1.05.54 2.06 1.33 2.84.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 000-1.41c-.44-.44-.71-1-.74-1.56-.04-.52.12-.98.45-1.3l3.07-3.07c.33-.33.79-.48 1.3-.45.57.04 1.12.3 1.56.75.44.44.71 1 .74 1.56.04.52-.12.98-.45 1.3l-1.28 1.28a.996.996 0 101.41 1.41l1.28-1.28c.74-.74 1.1-1.75 1.03-2.85-.07-1.05-.54-2.06-1.33-2.84z",
            fill: "currentColor"
        })
    });



const $10b0e380126162df$export$a295fc1e9af415d9 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 17H9a1 1 0 000 2h11a1 1 0 000-2zm0-6H9a1 1 0 000 2h11a1 1 0 000-2zM9 7h11a1 1 0 100-2H9a1 1 0 000 2zM4.5 4.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm0 6a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm0 6a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
            fill: "currentColor"
        })
    });



const $877b66ae310f37ad$export$86a64d40d9f97b5d = (l)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12.01 14.004a2 2 0 100-4 2 2 0 000 4zM18.72 19.004c-.24 0-.48-.08-.67-.25-.41-.37-.45-1-.08-1.41a8.006 8.006 0 002.04-5.33c0-1.97-.72-3.87-2.04-5.33a.998.998 0 111.49-1.33 9.985 9.985 0 012.55 6.67c0 2.47-.9 4.83-2.55 6.67-.2.22-.47.33-.75.33l.01-.02z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M16.01 16.004c-.21 0-.42-.07-.6-.2-.44-.33-.53-.96-.2-1.4a4.002 4.002 0 000-4.8c-.33-.44-.24-1.07.2-1.4.44-.33 1.07-.24 1.4.2.79 1.05 1.2 2.29 1.2 3.6s-.42 2.56-1.2 3.6c-.2.26-.5.4-.8.4zM5.3 19.004c-.27 0-.55-.11-.75-.33A9.985 9.985 0 012 12.004c0-2.47.9-4.83 2.55-6.67a.998.998 0 111.49 1.33A8.006 8.006 0 004 11.994c0 1.97.72 3.87 2.04 5.33.37.41.33 1.04-.08 1.41-.19.17-.43.25-.67.25l.01.02z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8.01 16.004c-.3 0-.6-.14-.8-.4a5.927 5.927 0 01-1.2-3.6c0-1.31.42-2.56 1.2-3.6.33-.44.96-.53 1.4-.2.44.33.53.96.2 1.4a4.002 4.002 0 000 4.8c.33.44.24 1.07-.2 1.4-.18.13-.39.2-.6.2z",
                fill: "currentColor"
            })
        ]
    });



const $30789908573cec47$export$f9184086c5d32054 = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4.64 15.12A7.91 7.91 0 014 12c0-2.05.77-3.92 2.04-5.33a.998.998 0 10-1.49-1.33 9.968 9.968 0 00-2.54 6.67c0 1.66.41 3.23 1.14 4.62l1.49-1.51zM19.74 5.67l.96-.96a.996.996 0 10-1.41-1.41l-16 16A.996.996 0 004 21c.26 0 .51-.1.71-.29l6.78-6.78c.16.04.33.07.51.07 1.1 0 2-.9 2-2 0-.18-.03-.35-.07-.51l1.52-1.52c.35.6.56 1.28.56 2.03 0 .91-.29 1.73-.8 2.4-.33.44-.24 1.07.2 1.4.44.33 1.07.24 1.4-.2a5.99 5.99 0 001.2-3.6c0-1.27-.39-2.44-1.06-3.41l-.05-.07 1.43-1.43a7.977 7.977 0 011.68 4.9c0 2.04-.77 3.92-2.04 5.33a.998.998 0 101.49 1.33A9.987 9.987 0 0022 11.98c0-2.39-.84-4.59-2.26-6.31zM6.21 13.54l1.81-1.81c.05-.8.32-1.53.78-2.13l.06-.08c.26-.43.16-1-.26-1.31a.998.998 0 00-1.33.12l-.07.08a5.99 5.99 0 00-1.2 3.6c0 .54.08 1.04.21 1.53z",
            fill: "currentColor"
        })
    });



const $362b5897d76ce45e$export$6e845194b4edd537 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18.7 15.5l-5-3a3.5 3.5 0 010-6L16.2 5H4a2 2 0 00-2 2v9a2 2 0 002 2h16a2 2 0 002-2h-1.5a3.47 3.47 0 01-1.8-.5zM15 19H9a1 1 0 000 2h6a1 1 0 000-2zm5.5-8a1.62 1.62 0 00-.44.07L17.44 9.5l2.62-1.57c.143.043.29.067.44.07A1.5 1.5 0 1019 6.22l-3.06 1.85A1.62 1.62 0 0015.5 8a1.5 1.5 0 000 3 1.62 1.62 0 00.44-.07L19 12.78A1.5 1.5 0 1020.5 11z",
            fill: "currentColor"
        })
    });



const $e2cb3a545a615003$export$2e8350b143a85b07 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.5 12a1.62 1.62 0 00-.44.07l-2.62-1.57 2.62-1.57c.143.043.29.067.44.07A1.5 1.5 0 1018 7.22l-1.16.69-1.9 1.16A1.62 1.62 0 0014.5 9a1.5 1.5 0 000 3 1.62 1.62 0 00.44-.07l1.93 1.16 1.16.69A1.501 1.501 0 1019.5 12zm-6.8 1.5a3.5 3.5 0 010-6l5-3c.078-.04.158-.077.24-.11A3 3 0 0015 2H9a3 3 0 00-3 3v14a3 3 0 003 3h6a3 3 0 003-3v-2.35a2.1 2.1 0 01-.3-.15l-5-3zM12 20a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $50c2b25462dad974$export$5866e5883f7d2c52 = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 20h-1c-2.76 0-5-2.24-5-5V5.41l2.29 2.29c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 000-1.41l-4-4a.996.996 0 00-1.41 0l-4.01 4A.996.996 0 108.7 7.7l2.29-2.29V15c0 2.76-2.24 5-5 5h-1c-.55 0-1 .45-1 1s.45 1 1 1h1c2.55 0 4.78-1.37 6-3.41a6.986 6.986 0 006 3.41h1c.55 0 1-.45 1-1s-.45-1-1-1H19z",
            fill: "currentColor"
        })
    });



const $4932b9076f5a925d$export$f4336d9f8d626571 = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M8.71 7.7L11 5.41v3.35l2.01-2.01V5.41l.67.67 1.42-1.42-2.37-2.37a.996.996 0 00-1.41 0l-4.01 4A.996.996 0 108.72 7.7h-.01zM21.71 3.7a.996.996 0 000-1.41.99.99 0 00-1.39-.02L2.53 20.06s-.02.01-.03.02l-.21.21a.996.996 0 00.71 1.7c.26 0 .51-.1.71-.29l.36-.36c.14.38.5.66.93.66h1c2.55 0 4.78-1.37 6-3.41A6.986 6.986 0 0018 22h1c.55 0 1-.45 1-1s-.45-1-1-1h-.99c-2.76 0-5-2.24-5-5v-2.61l8.7-8.69zM11 15c0 2.76-2.24 5-5 5h-.6l5.6-5.6v.6z",
            fill: "currentColor"
        })
    });



const $e8c79e36108cbc05$export$147cbfc12040ee2a = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M6 19a2 2 0 01-2-2V7a2 2 0 012-2h14a3.9 3.9 0 011.64.36A4 4 0 0018 3H6a4 4 0 00-4 4v10a4 4 0 004 4h6.56a3.91 3.91 0 01-.56-2H6zM20 7h-4a2 2 0 00-2 2v10a2 2 0 002 2h4a2 2 0 002-2V9a2 2 0 00-2-2zm-2 12a1 1 0 110-2 1 1 0 010 2zM6.37 8v8a1 1 0 001 1H12V9a3.91 3.91 0 01.56-2H7.37a1 1 0 00-1 1z",
            fill: "currentColor"
        })
    });



const $5fb4d1abda89abd7$export$bdf9baf5495f0651 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M3 5v6h4.67V3H5a2 2 0 00-2 2zm0 14a2 2 0 002 2h2.67v-8H3v6zm6.67 2h4.66v-8H9.67v8zm6.66 0H19a2 2 0 002-2v-6h-4.67v8zM19 3h-2.67v8H21V5a2 2 0 00-2-2zm-9.33 8h4.66V3H9.67v8z",
            fill: "currentColor"
        })
    });



const $e9194342d7befcfe$export$3b92df52218dee41 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 3H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-3-3zm-1 12a2 2 0 11-2-2V8.34l-5 1.48V16a2 2 0 11-2-2V9.08a1 1 0 01.71-1l7-2.08a1 1 0 011.194.53A1 1 0 0117 7v8z",
            fill: "currentColor"
        })
    });



const $0210ca2477fa59c3$export$69ba7ae8bc5bb9f0 = (v)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...v,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.12 2.88C20.56 2.32 19.79 2 19 2h-8c-.8 0-1.56.32-2.12.88S8 4.21 8 5v1h5c1.33 0 2.6.53 3.54 1.46C17.48 8.4 18 9.67 18 11v5h1c.8 0 1.56-.32 2.12-.88S22 13.79 22 13V5c0-.8-.32-1.56-.88-2.12zM13 8H5c-.8 0-1.56.32-2.12.88S2 10.21 2 11v8c0 .8.32 1.56.88 2.12S4.21 22 5 22h8c.8 0 1.56-.32 2.12-.88S16 19.79 16 19v-8c0-.8-.32-1.56-.88-2.12S13.79 8 13 8zm-1 8h-2v2c0 .55-.45 1-1 1s-1-.45-1-1v-2H6c-.55 0-1-.45-1-1s.45-1 1-1h2v-2c0-.55.45-1 1-1s1 .45 1 1v2h2c.55 0 1 .45 1 1s-.45 1-1 1z",
            fill: "currentColor"
        })
    });



const $6abc5d67c680131e$export$810bd2b8026f0d72 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 2h-9a3 3 0 00-3 3v13a1 1 0 11-2 0V8H4a2 2 0 00-2 2v9a3 3 0 003 3h14a3 3 0 003-3V5a3 3 0 00-3-3zm-3 15h-5a1 1 0 010-2h5a1 1 0 010 2zm2-5h-7a1 1 0 010-2h7a1 1 0 010 2zm0-5h-7a1 1 0 110-2h7a1 1 0 110 2z",
            fill: "currentColor"
        })
    });



const $35f90b1ab60460ce$export$aaaee639caf0fc9 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zm4.71 10.71l-3 3a1.002 1.002 0 01-1.639-.325 1 1 0 01.219-1.095l1.3-1.29H8a1 1 0 010-2h5.59l-1.3-1.29a1.004 1.004 0 111.42-1.42l3 3a1 1 0 01.21.33 1 1 0 010 .76 1 1 0 01-.21.33z",
            fill: "currentColor"
        })
    });



const $0457ac9ab36f8389$export$7088e49c6061a9c3 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.24 8.17c-.37-.9-.87-1.73-1.48-2.48l1.25-1.25c.4-.4.4-1.04 0-1.44-.4-.4-1.04-.4-1.44 0L3 19.56c-.4.4-.4 1.04 0 1.44.4.4 1.04.4 1.44 0l1.26-1.26a9.922 9.922 0 0010.13 1.5 10.04 10.04 0 004.49-3.68A9.993 9.993 0 0022.01 12c0-1.31-.26-2.61-.76-3.83h-.01zm-2.92-1.05c.22.28.42.57.6.88h-1.48l.88-.88zm-11.2 11.2l.68-.68c.16.51.36 1.02.59 1.51-.45-.23-.87-.52-1.27-.83zM12 20c-.84 0-1.95-1.48-2.55-4h5.1c-.55 2.52-1.71 4-2.55 4zm2.89-6h-3.45l3.48-3.48c.04.49.08.98.08 1.48 0 .67-.04 1.34-.11 2zm.67 5.15c.47-1 .8-2.06 1-3.15h2.31a8.098 8.098 0 01-3.31 3.15zM19.74 14h-2.83c.06-.64.09-1.31.09-2s0-1.36-.09-2h2.83a7.75 7.75 0 010 4zM5.67 14H4.26c-.17-.65-.26-1.33-.26-2 0-.67.09-1.35.26-2h2.83C7 10.64 7 11.31 7 12v.67l2.07-2.07c.02-.2.01-.4.03-.6h.56l2-2H9.44c.6-2.52 1.71-4 2.55-4 .56 0 1.24.67 1.81 1.86l2.75-2.75c-.24-.12-.48-.24-.74-.35a10.017 10.017 0 00-9.39.93 9.975 9.975 0 00-3.68 4.49c-.76 1.83-.95 3.84-.57 5.78.18.91.5 1.79.92 2.61l2.56-2.56.02-.01zm2.77-9.15c-.49 1-.84 2.06-1.05 3.15H5.08a8.1 8.1 0 013.36-3.15z",
            fill: "currentColor"
        })
    });



const $0fd0cdbe14717baa$export$f807047dc2fe0b83 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 8V6a3 3 0 00-3-3h-1.28A2 2 0 0014 2h-4a2 2 0 00-1.72 1H7a3 3 0 00-3 3v13a3 3 0 003 3h10a3 3 0 003-3v-1a2 2 0 002-2v-6a2 2 0 00-2-2zm-2 0h-6a2 2 0 00-2 2v6a2 2 0 002 2h6v1a1 1 0 01-1 1H7a1 1 0 01-1-1V6a1 1 0 011-1h1.28A2 2 0 0010 6h4a2 2 0 001.72-1H17a1 1 0 011 1v2z",
            fill: "currentColor"
        })
    });



const $c445313bffc441a7$export$687d754bcaed713c = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15 19H9a1 1 0 000 2h6a1 1 0 000-2zm5-14H4a2 2 0 00-2 2v9a2 2 0 002 2h16a2 2 0 002-2V7a2 2 0 00-2-2zm-5.45 7.33l-3 2A1 1 0 0110 13.5v-4a1 1 0 01.53-.88 1 1 0 011 .05l3 2a1 1 0 010 1.66h.02z",
            fill: "currentColor"
        })
    });



const $44704dbf4baf2c18$export$ecf39483af6dd5fc = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zm1 14a1 1 0 01-2 0V8a1 1 0 012 0v8z",
            fill: "currentColor"
        })
    });



const $da44209b57570ac4$export$73a628190c65df58 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a8 8 0 00-8 8 7.8 7.8 0 00.09 1.14 1.01 1.01 0 002-.28A5.511 5.511 0 016 10a6 6 0 1112 0c0 .288-.024.576-.07.86a.998.998 0 00.85 1.14h.14a1 1 0 001-.86A8 8 0 0012 2zm0 4a4 4 0 00-4 4v11a1 1 0 001 1h6a1 1 0 001-1V10a4 4 0 00-4-4zm2 5.5a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5V10a2 2 0 114 0v1.5z",
            fill: "currentColor"
        })
    });



const $744c59edd05ffc6c$export$fbf0a50e428d2da9 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 3H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-3-3zm0 8a1 1 0 01-2 0V9.41l-4.29 4.3a1.002 1.002 0 01-1.639-.325 1 1 0 01.219-1.095L14.59 8H13a1 1 0 110-2h4a1 1 0 011 1v4z",
            fill: "currentColor"
        })
    });



const $a6998eea8099b647$export$bde1530697441e51 = (t)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8 9.99c0-2.21 1.79-4 4-4h2v-1c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v9c0 1.1.9 2 2 2h2v-6z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M18 7.99h-6a2 2 0 00-2 2v9a2 2 0 002 2h6a2 2 0 002-2v-9a2 2 0 00-2-2z",
                fill: "currentColor"
            })
        ]
    });



const $9a9089b970df8718$export$f1818b9948a7748b = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15 5a6.88 6.88 0 00-3 .69A6.88 6.88 0 009 5a7 7 0 000 14 6.88 6.88 0 003-.69 6.88 6.88 0 003 .69 7 7 0 100-14zM9 17a5 5 0 111-9.9 7 7 0 000 9.8c-.33.063-.664.097-1 .1zm3-1a4.94 4.94 0 010-8 4.94 4.94 0 010 8z",
            fill: "currentColor"
        })
    });



const $dea81c5aef43679e$export$69c2b3ccb50624 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15.66 6.61l-10-3.5A2 2 0 003 5v10.5a2 2 0 001.34 1.89l10 3.5A2 2 0 0017 19V8.5a2 2 0 00-1.34-1.89zM20 10a1 1 0 00-1 1v8a1 1 0 002 0v-8a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $f66f400950e9a708$export$1a76285b9c9b2edf = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7.5 8a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM21 5a3 3 0 00-2.33-.75c-4.433.5-8.907.5-13.34 0A3 3 0 002 7.23v9.54a3 3 0 003 3h.33c4.433-.5 8.907-.5 13.34 0a2.999 2.999 0 003.33-3V7.23A3 3 0 0021 5zm-1 8.7l-3.83-3.44a1 1 0 00-1.34 0l-4.89 4.45-1.8-1.48a1 1 0 00-1.3 0L4 15.77V7.23a1 1 0 011.11-.99c4.58.51 9.2.51 13.78 0a1 1 0 011.11.99v6.47z",
            fill: "currentColor"
        })
    });



const $7e62ce540104cabe$export$85f07d96a860f87 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 8V6a3 3 0 00-3-3h-1.28A2 2 0 0014 2h-4a2 2 0 00-1.72 1H7a3 3 0 00-3 3v13a3 3 0 003 3h10a3 3 0 003-3v-1a2 2 0 002-2v-6a2 2 0 00-2-2zm-2 0h-6a2 2 0 00-2 2v6a2 2 0 002 2h6v1a1 1 0 01-1 1H7a1 1 0 01-1-1V6a1 1 0 011-1h1.28A2 2 0 0010 6h4a2 2 0 001.72-1H17a1 1 0 011 1v2z",
            fill: "currentColor"
        })
    });



const $76e4c56897bc459e$export$db6c6054ad855134 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 10a1 1 0 00-1 1v1.09l-2.79-2.8a1 1 0 00-1.42 0l-4.29 4.3-1.29-1.3a1 1 0 00-1.42 0L5 15.09V6a1 1 0 011-1h7a1 1 0 100-2H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3v-7a1 1 0 00-1-1zM7 8.5a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0zm14-4.38h-1.12V3a1 1 0 00-2 0v1.12h-1.12a1 1 0 100 2h1.12v1.12a1 1 0 001 1 1 1 0 00.71-.24 1 1 0 00.29-.71V6.12H21a1 1 0 100-2z",
            fill: "currentColor"
        })
    });



const $b2dbb9bfea08b306$export$6ff971bf6309bf6c = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7 8.5a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0zM20 8a1 1 0 00-1 1v3.09l-2.79-2.8a1 1 0 00-1.42 0l-4.29 4.3-1.29-1.3a1 1 0 00-1.42 0L5 15.09V6a1 1 0 011-1h9a1 1 0 100-2H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V9a1 1 0 00-1-1zm.91-3.5l.8-.79a1.004 1.004 0 00-1.42-1.42l-.79.8-.79-.8a1.003 1.003 0 10-1.42 1.42l.8.79-.8.79a1 1 0 00.325 1.64 1 1 0 001.095-.22l.79-.8.79.8a1.001 1.001 0 001.639-.325 1 1 0 00-.219-1.095l-.8-.79z",
            fill: "currentColor"
        })
    });



const $9bfbf84be9e8e518$export$ee9b0797e12936af = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M9 13H5a2 2 0 00-2 2v4a2 2 0 002 2h4a2 2 0 002-2v-4a2 2 0 00-2-2zm9-10H6a3 3 0 00-3 3v5.56A3.91 3.91 0 015 11h4a4 4 0 014 4v4a3.91 3.91 0 01-.56 2H18a3 3 0 003-3V6a3 3 0 00-3-3zm1 6a1 1 0 01-2 0v-.59l-2.29 2.3a1.002 1.002 0 01-1.639-.325 1 1 0 01.219-1.095L15.59 7H15a1 1 0 110-2h3a1 1 0 01.38.08 1 1 0 01.54.54c.051.12.078.25.08.38v3z",
            fill: "currentColor"
        })
    });



const $c32cda30e1a86336$export$43e65afa9af7a994 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10 11a1 1 0 100-2 1 1 0 000 2zm-3 9H5a1 1 0 01-1-1v-2a1 1 0 10-2 0v2a3 3 0 003 3h2a1 1 0 000-2zM19 2h-2a1 1 0 100 2h2a1 1 0 011 1v2a1 1 0 002 0V5a3 3 0 00-3-3zm-2.25 4h-9.5A1.25 1.25 0 006 7.25v9.5A1.25 1.25 0 007.25 18h9.5A1.25 1.25 0 0018 16.75v-9.5A1.25 1.25 0 0016.75 6zM16 12.09l-.79-.8a1 1 0 00-1.48.07l-1.8 2.16-1.22-1.23A1 1 0 0010 12a1 1 0 00-.73.36L8 13.84V8h8v4.09z",
            fill: "currentColor"
        })
    });



const $ec039ebb0953ce08$export$163b57c4f5745343 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.49 19l-5.16-5.15 3.79-3.79a1.5 1.5 0 00-1.06-2.56h-4.87L8.24 2.59a2 2 0 00-2.83 0L2.59 5.41a2 2 0 000 2.83l5 4.95v4.87a1.5 1.5 0 002.56 1.06l3.79-3.79L19 20.49A1.054 1.054 0 1020.49 19z",
            fill: "currentColor"
        })
    });



const $18792ee3b044ce0a$export$94df67a47422efa9 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12.71 7.05L8.24 2.59a2 2 0 00-2.83 0L2.59 5.41a2 2 0 000 2.83l4.46 4.47 5.66-5.66zm2.62 6.84l3.79-3.79a1.5 1.5 0 00-1.06-2.56h-.15L20.49 5a1.055 1.055 0 00-1.148-1.718c-.128.053-.244.13-.342.228L3.51 19A1.054 1.054 0 105 20.49l2.58-2.58v.15a1.5 1.5 0 002.56 1.06l3.79-3.79L19 20.49A1.054 1.054 0 1020.49 19l-5.16-5.11z",
            fill: "currentColor"
        })
    });



const $9b9b332dd79fc3a9$export$2590041940f63e4a = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4 7h9a1 1 0 100-2H4a1 1 0 000 2zm0 6h9a1 1 0 100-2H4a1 1 0 000 2zm16.58-7.81a1 1 0 00-.9-.14l-3 1A1 1 0 0016 7v8.05a2.5 2.5 0 102 2.45V8.72L20.32 8A1 1 0 0021 7V6a1 1 0 00-.42-.81zM10 17H4a1 1 0 000 2h6a1 1 0 100-2z",
            fill: "currentColor"
        })
    });



const $3a07bb1ea0accb1e$export$c3d91d6bcba631c1 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4 7h6a1 1 0 100-2H4a1 1 0 000 2zm9 3h2.5v2.5a1 1 0 002 0V10H20a1 1 0 100-2h-2.5V5.5a1 1 0 00-2 0V8H13a1 1 0 100 2zm-9 3h6a1 1 0 000-2H4a1 1 0 000 2zm16 4H4a1 1 0 000 2h16a1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $00160e4f600edffe$export$840d27e8506f60a8 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M3.61 6.92c.124.05.256.077.39.08h16a1 1 0 00.92-1.39 1.058 1.058 0 00-.21-.31A1.059 1.059 0 0020 5H4a1.09 1.09 0 00-.39.08 1.06 1.06 0 00-.31.21 1.06 1.06 0 00-.21.31 1 1 0 000 .78 1 1 0 00.52.54zm6.78 10.16A1.089 1.089 0 0010 17H4a1 1 0 00-.39 1.92c.124.05.256.078.39.08h6a1 1 0 00.39-1.92zm.32-5.79A1 1 0 0010 11H4a1 1 0 00-1 1 1.19 1.19 0 000 .26.53.53 0 000 .12A1 1 0 004 13h6a1 1 0 00.92-.62.523.523 0 000-.12c.037-.083.063-.17.08-.26a.998.998 0 00-.29-.71zm8.58 1.5l-3.79 3.8-1.79-1.8a1.005 1.005 0 00-1.42 1.42l2.5 2.5a1.001 1.001 0 001.42 0l4.5-4.5a1.003 1.003 0 00-1.094-1.638c-.122.05-.233.125-.326.218z",
            fill: "currentColor"
        })
    });



const $2c9ee72b39f31a8e$export$aceb06e123e5485c = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 2H8C6.34 2 5 3.34 5 5v14c0 1.66 1.34 3 3 3h8c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3zm-4 6c.83 0 1.5.67 1.5 1.5S12.83 11 12 11s-1.5-.67-1.5-1.5S11.17 8 12 8zm2 8h-4c-.55 0-1-.45-1-1 0-1.66 1.34-3 3-3s3 1.34 3 3c0 .55-.45 1-1 1z",
            fill: "currentColor"
        })
    });



const $2b5f3edcd88ac770$export$5404248572d71cf4 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 6h-1V4a2 2 0 00-2-2H7a2 2 0 00-2 2v2H4a2 2 0 00-2 2v8a2 2 0 002 2h1v2a2 2 0 002 2h10a2 2 0 002-2v-2h1a2 2 0 002-2V8a2 2 0 00-2-2zm-3 14H7v-7h10v7zm0-14H7V4h10v2zM9 16h6a1 1 0 000-2H9a1 1 0 000 2zm0 3h6a1 1 0 000-2H9a1 1 0 000 2z",
            fill: "currentColor"
        })
    });



const $05e9cf2305008e88$export$a4090ba59108a6f3 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10.88 16.12l-2-2a3 3 0 010-4.24l2-2A3 3 0 0113 7h1V4a2 2 0 00-2.26-2l-6 .77A2 2 0 004 4.78v14.44a2 2 0 001.74 2l6 .77.26.01a2 2 0 002-2v-3h-1a3 3 0 01-2.12-.88zM17 7a1 1 0 000 2 1 1 0 110 2h-3.59l.3-.29a1.004 1.004 0 00-1.42-1.42l-2 2a1 1 0 00-.21.33 1 1 0 000 .76c.047.123.119.235.21.33l2 2a1.001 1.001 0 001.639-.326 1 1 0 00-.22-1.094l-.3-.29H17a3 3 0 100-6z",
            fill: "currentColor"
        })
    });



const $abc4cf28e786f6a9$export$1960915c2ff5f4f0 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.12 2.88C20.56 2.32 19.79 2 19 2h-2c-.27 0-.52.11-.71.29A.99.99 0 0016 3c0 .27.11.52.29.71.18.19.44.29.71.29h2c.27 0 .52.11.71.29.19.19.29.44.29.71v2c0 .27.11.52.29.71.18.19.44.29.71.29.27 0 .52-.11.71-.29.19-.18.29-.44.29-.71V5c0-.8-.32-1.56-.88-2.12zM7 20H5c-.27 0-.52-.11-.71-.29A.973.973 0 014 19v-2c0-.27-.11-.52-.29-.71A.99.99 0 003 16c-.27 0-.52.11-.71.29-.19.18-.29.44-.29.71v2c0 .8.32 1.56.88 2.12S4.21 22 5 22h2c.27 0 .52-.11.71-.29A.99.99 0 008 21c0-.27-.11-.52-.29-.71A.99.99 0 007 20zm5.1-6.03c-.6 0-1.01.42-1.01 1.02 0 .6.41 1.01 1.01 1.01.6 0 1.03-.41 1.03-1.01 0-.6-.42-1.02-1.03-1.02zM9.21 8c-.14 0-.42.05-.67.3L6.86 9.96c-.23.23-.32.45-.32.66 0 .49.52.94.98.94.19 0 .4-.08.6-.28.03-.03.07-.06.1-.06.06 0 .06.07.06.1v3.86c0 .62.47.82.92.82.45 0 .92-.19.92-.82V8.96c0-.73-.45-.97-.91-.97V8zm7.34 0c-.14 0-.42.05-.67.3L14.2 9.96c-.23.23-.32.45-.32.66 0 .49.52.94.98.94.19 0 .4-.08.6-.28.03-.03.07-.06.1-.06.06 0 .06.07.06.1v3.86c0 .62.47.82.92.82.45 0 .92-.19.92-.82V8.96c0-.73-.45-.97-.91-.97V8zm-4.46 2.27c-.6 0-1.01.42-1.01 1.02 0 .6.41 1.01 1.01 1.01.6 0 1.03-.41 1.03-1.01 0-.6-.42-1.02-1.03-1.02z",
            fill: "currentColor"
        })
    });



const $d85d52b82416b15a$export$6b472fb68343cb96 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7 20H5c-.27 0-.52-.11-.71-.29A.973.973 0 014 19v-2c0-.27-.11-.52-.29-.71A.99.99 0 003 16c-.27 0-.52.11-.71.29-.19.18-.29.44-.29.71v2c0 .8.32 1.56.88 2.12S4.21 22 5 22h2c.27 0 .52-.11.71-.29A.99.99 0 008 21c0-.27-.11-.52-.29-.71A.99.99 0 007 20zM21.12 2.88C20.56 2.32 19.79 2 19 2h-2c-.27 0-.52.11-.71.29A.99.99 0 0016 3c0 .27.11.52.29.71.18.19.44.29.71.29h2c.27 0 .52.11.71.29.19.19.29.44.29.71v2c0 .27.11.52.29.71.18.19.44.29.71.29.27 0 .52-.11.71-.29.19-.18.29-.44.29-.71V5c0-.8-.32-1.56-.88-2.12zM9.84 13.1h-.05c-.08 0-.1-.03-.1-.11v-.32c0-.63-.43-.82-.9-.82-.47 0-.9.19-.9.82v.32c0 .08-.02.11-.1.11h-.56s-.1-.02-.1-.08c0-.03.02-.08.03-.11l1.52-3.65c.07-.16.09-.28.09-.41 0-.53-.57-.85-1.02-.85-.27 0-.55.14-.7.55l-1.77 4.6c-.08.22-.25.68-.25.95 0 .49.32.77 1.03.77h1.68c.08 0 .1.03.1.1v.2c0 .62.47.82.92.82.45 0 .92-.19.92-.82v-.2c0-.07.02-.1.1-.1h.05c.62 0 .87-.34.87-.89s-.25-.89-.87-.89l.01.01zm8.35-1.12s-.06-.06-.06-.09.02-.07.06-.09c.36-.32.65-.82.65-1.51 0-1.35-.93-2.28-2.48-2.28-.95 0-1.52.31-1.95.74-.18.19-.41.48-.41.78 0 .49.51.87.93.87.3 0 .45-.11.6-.25.28-.2.48-.4.83-.4.38 0 .63.25.63.66 0 .39-.27.67-.65.67h-.11c-.51 0-.77.33-.77.81 0 .48.24.83.76.83h.11c.45 0 .78.32.78.77s-.3.76-.75.76c-.41 0-.7-.24-.86-.4-.3-.28-.44-.32-.62-.32-.49 0-.94.53-.94.9 0 .24.14.48.25.6.26.28.86.97 2.18.97 1.67 0 2.61-1.07 2.61-2.4 0-.82-.41-1.32-.78-1.62h-.01zm-5.94-1.71c-.6 0-1.01.42-1.01 1.02 0 .6.41 1.01 1.01 1.01.6 0 1.03-.41 1.03-1.01 0-.6-.42-1.02-1.03-1.02zm0 3.69c-.6 0-1.01.42-1.01 1.02 0 .6.41 1.01 1.01 1.01.6 0 1.03-.41 1.03-1.01 0-.6-.42-1.02-1.03-1.02z",
            fill: "currentColor"
        })
    });



const $45ff6084847cb35a$export$b6a0c200ca06e464 = (s)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...s,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7 20H5c-.27 0-.52-.11-.71-.29A.973.973 0 014 19v-1.01c0-.26-.11-.52-.29-.71a.99.99 0 00-.71-.29c-.27 0-.52.11-.71.29-.19.18-.29.44-.29.71V19c0 .79.32 1.56.88 2.12S4.21 22 5 22h2c.27 0 .52-.11.71-.29A.99.99 0 008 21c0-.27-.11-.52-.29-.71A.99.99 0 007 20zM21.12 2.88C20.56 2.32 19.79 2 19 2h-2c-.27 0-.52.11-.71.29-.19.18-.29.44-.29.71 0 .27.11.52.29.71.19.19.44.29.71.29h2c.27 0 .52.11.71.29.19.18.29.44.29.71v1c0 .27.11.52.29.71.18.19.44.29.71.29.27 0 .52-.11.71-.29.19-.18.29-.44.29-.71V5c0-.8-.32-1.56-.88-2.12zM3.64 11.56c.19 0 .4-.08.6-.28.03-.03.07-.06.1-.06.06 0 .06.07.06.1v3.86c0 .62.47.82.92.82.45 0 .92-.19.92-.82V8.96c0-.73-.45-.97-.91-.97-.14 0-.42.05-.67.3L2.98 9.95c-.23.23-.32.45-.32.66 0 .49.52.94.98.94v.01zM18.67 8c-1.7 0-2.56 1.07-2.56 2.76 0 1.58.89 2.5 2.44 2.5.23 0 .42-.02.66-.1 0 0 .09-.03.11-.03.07 0 .07.03.07.08-.01.25-.05.48-.13.66-.1.25-.4.39-.78.39-.13 0-.33-.03-.58-.18-.23-.14-.35-.18-.55-.18-.45 0-.87.5-.87.9s.31.65.53.78c.53.33 1.06.43 1.49.43 2.49 0 2.82-1.7 2.82-4s-.36-4-2.66-4l.01-.01zm.69 2.66c0 .36-.09.9-.69.9-.57 0-.7-.53-.7-.9s.14-.9.7-.9c.56 0 .69.52.69.85v.05zm-5-.39c-.6 0-1.01.42-1.01 1.02 0 .6.41 1.01 1.01 1.01.6 0 1.03-.41 1.03-1.01 0-.6-.42-1.02-1.03-1.02zm-4.17.47c-.23 0-.42.02-.66.1 0 0-.09.03-.11.03-.07 0-.07-.03-.07-.08.01-.25.05-.48.12-.66.1-.25.4-.39.78-.39.12 0 .33.03.58.18.23.14.35.18.55.18.45 0 .87-.5.87-.9s-.31-.65-.53-.78c-.53-.33-1.06-.43-1.49-.43-2.49 0-2.82 1.7-2.82 4s.36 4 2.66 4c1.7 0 2.56-1.07 2.56-2.76 0-1.58-.89-2.5-2.44-2.5v.01zm-.11 3.5c-.55 0-.69-.52-.69-.85v-.05c0-.36.09-.9.69-.9.57 0 .7.53.7.9s-.14.9-.7.9zm4.29-.27c-.6 0-1.01.42-1.01 1.02 0 .6.41 1.01 1.01 1.01.6 0 1.03-.41 1.03-1.01 0-.6-.42-1.02-1.03-1.02z",
            fill: "currentColor"
        })
    });



const $22a893fb56d6cc67$export$49d461412e10b217 = (v)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...v,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17.24 14.38c-.27 0-.4-.18-.4-.47V8.62c0-.66-.48-.87-.98-.87s-.98.21-.98.87v5.57c0 1.27.53 2.06 1.83 2.06.89 0 1.16-.36 1.16-.94s-.22-.93-.64-.93h.01zM12.7 9.82c-.49 0-.98.21-.98.87v2.82c0 .22-.02.42-.12.58-.11.17-.27.28-.54.28-.24 0-.37-.12-.47-.28-.1-.16-.12-.4-.12-.58v-2.82c0-.66-.49-.87-.98-.87s-.98.21-.98.87v3.49c0 .94.47 2.07 1.82 2.07.66 0 1.11-.34 1.33-.51 0 0 .05-.04.08-.04.05 0 .06.02.08.08.13.34.53.46.89.46.47 0 .95-.21.95-.87v-4.69c0-.66-.49-.87-.98-.87l.02.01zM7.13 7.81H3.27c-.51 0-.96.24-.96.93v6.66c0 .69.55.86 1.01.86.48 0 1.04-.17 1.04-.86v-2.44c0-.08.02-.11.11-.11h1.91c.68 0 .88-.47.88-.97s-.2-.99-.88-.99H4.47c-.08 0-.11-.02-.11-.11v-.92c0-.08.02-.11.11-.11h2.66c.67 0 .88-.47.88-.97s-.21-.99-.88-.99v.02zm13.92 6.57c-.27 0-.4-.18-.4-.47V8.62c0-.66-.48-.87-.98-.87s-.98.21-.98.87v5.57c0 1.27.53 2.06 1.83 2.06.89 0 1.16-.36 1.16-.94s-.22-.93-.64-.93h.01zm.07-11.5C20.56 2.32 19.79 2 19 2h-2c-.27 0-.52.11-.71.29-.19.18-.29.44-.29.71 0 .27.11.52.29.71.19.19.44.29.71.29h2c.27 0 .52.11.71.29.19.18.29.44.29.71v1c0 .27.11.52.29.71.18.19.44.29.71.29.27 0 .52-.11.71-.29.19-.18.29-.44.29-.71V5c0-.8-.32-1.56-.88-2.12zM7 20H5c-.27 0-.52-.11-.71-.29A.973.973 0 014 19v-1.01c0-.26-.11-.52-.29-.71a.99.99 0 00-.71-.29c-.27 0-.52.11-.71.29-.19.18-.29.44-.29.71V19c0 .79.32 1.56.88 2.12S4.21 22 5 22h2c.27 0 .52-.11.71-.29A.99.99 0 008 21c0-.27-.11-.52-.29-.71A.99.99 0 007 20z",
            fill: "currentColor"
        })
    });



const $237ff60d7cab2fc7$export$154da16714e78b3e = (s)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...s,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.12 2.88C20.56 2.32 19.79 2 19 2h-2c-.27 0-.52.11-.71.29-.19.18-.29.44-.29.71 0 .27.11.52.29.71.19.19.44.29.71.29h2c.27 0 .52.11.71.29.19.18.29.44.29.71v1c0 .27.11.52.29.71.18.19.44.29.71.29.27 0 .52-.11.71-.29.19-.18.29-.44.29-.71V5c0-.8-.32-1.56-.88-2.12zM7 20H5c-.27 0-.52-.11-.71-.29A.973.973 0 014 19v-1.01c0-.26-.11-.52-.29-.71a.99.99 0 00-.71-.29c-.27 0-.52.11-.71.29-.19.18-.29.44-.29.71V19c0 .79.32 1.56.88 2.12S4.21 22 5 22h2c.27 0 .52-.11.71-.29A.99.99 0 008 21c0-.27-.11-.52-.29-.71A.99.99 0 007 20zm3.59-12c-2.34 0-2.66 1.81-2.66 4s.32 4 2.66 4c2.34 0 2.66-1.81 2.66-4s-.32-4-2.66-4zm.77 4.06c0 1.47-.06 2.17-.77 2.17s-.77-.7-.77-2.17v-.11c0-1.47.06-2.17.77-2.17s.77.7.77 2.18v.1zm-8.04.73c-.89.92-1.22 1.58-1.22 2.29 0 .47.27.88 1.01.88h3.06c.64 0 .86-.41.86-.88 0-.47-.23-.87-.86-.87H4.64s-.09 0-.09-.06c0-.02.02-.06.02-.06.08-.11.14-.19.33-.4l1.2-1.27c.67-.72.95-1.4.95-1.99C7.05 9 6.22 8 4.56 8c-.89 0-1.6.36-2.06.83-.18.19-.35.39-.35.7 0 .49.51.9.93.9.28 0 .45-.11.59-.24.3-.26.53-.42.89-.42.42 0 .64.27.64.67 0 .27-.16.53-.5.89l-1.39 1.45.01.01zm15.91-4.78c-1.7 0-2.56 1.07-2.56 2.76 0 1.58.89 2.5 2.44 2.5.23 0 .42-.02.66-.1 0 0 .09-.03.11-.03.07 0 .07.03.07.08-.01.25-.05.48-.13.66-.1.25-.4.39-.78.39-.13 0-.33-.03-.58-.18-.23-.14-.35-.18-.55-.18-.45 0-.87.5-.87.9s.31.65.53.78c.53.33 1.06.43 1.49.43 2.49 0 2.82-1.7 2.82-4s-.36-4-2.66-4l.01-.01zm.69 2.66c0 .36-.09.9-.69.9-.57 0-.7-.53-.7-.9s.14-.9.7-.9c.56 0 .69.52.69.85v.05zm-5 3.31c-.6 0-1.01.42-1.01 1.02 0 .6.41 1.01 1.01 1.01.6 0 1.03-.41 1.03-1.01 0-.6-.42-1.02-1.03-1.02zm0-3.69c-.6 0-1.01.42-1.01 1.02 0 .6.41 1.01 1.01 1.01.6 0 1.03-.41 1.03-1.01 0-.6-.42-1.02-1.03-1.02z",
            fill: "currentColor"
        })
    });



const $66425a80da646b2d$export$690459f01774312 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 8a3 3 0 100-6 3 3 0 000 6zm7.5 5H21v-3a2 2 0 00-2.79-1.84l-3.49 1.5a5.93 5.93 0 00-5.44 0l-3.49-1.5A2 2 0 003 10v3h1.5a1.5 1.5 0 110 3H3v1a2 2 0 001.21 1.84l7 3h.15l.14.05a1.82 1.82 0 001 0l.14-.05h.15l7-3A2 2 0 0021 17v-1h-1.5a1.5 1.5 0 110-3z",
            fill: "currentColor"
        })
    });



const $40f75d2429b74478$export$752b181797401277 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.92 11.62a1 1 0 00-.21-.33l-2-2a1.004 1.004 0 10-1.42 1.42l.3.29H13V6.41l.29.3a1.001 1.001 0 001.639-.326 1 1 0 00-.22-1.094l-2-2a1 1 0 00-.33-.21 1 1 0 00-.76 0 1 1 0 00-.33.21l-2 2a1.004 1.004 0 101.42 1.42l.29-.3V11H6.41l.3-.29a1.004 1.004 0 00-1.42-1.42l-2 2a1 1 0 00-.21.33 1 1 0 000 .76 1 1 0 00.21.33l2 2a1 1 0 001.64-.326 1 1 0 00-.22-1.094l-.3-.29H11v4.59l-.29-.3a1.004 1.004 0 00-1.42 1.42l2 2a1 1 0 00.33.21.94.94 0 00.76 0c.124-.048.236-.12.33-.21l2-2a1.004 1.004 0 10-1.42-1.42l-.29.3V13h4.59l-.3.29a1.002 1.002 0 00.326 1.639 1 1 0 001.095-.22l2-2c.09-.094.162-.206.21-.33a1 1 0 000-.76z",
            fill: "currentColor"
        })
    });



const $9d077356c1170720$export$dcd7bbec392d79ec = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zm0 18a8 8 0 110-16.001A8 8 0 0112 20zm0-13a5 5 0 100 10 5 5 0 000-10z",
            fill: "currentColor"
        })
    });



const $8cddcaecceb7e554$export$27b8c2d00ec21954 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 4H5a3 3 0 00-3 3v10a3 3 0 003 3h14a3 3 0 003-3V7a3 3 0 00-3-3zm-3 11H8a3 3 0 112.82-2h2.33A3 3 0 1116 15zm-8-4a1 1 0 100 2 1 1 0 000-2zm8 0a1 1 0 100 2 1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $35fac96b89e84a70$export$5f23da3aa6e38392 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 5H5a3 3 0 00-3 3v8a3 3 0 003 3h14a3 3 0 003-3V8a3 3 0 00-3-3z",
            fill: "currentColor"
        })
    });



const $0a1ef61ca52cb93c$export$725cad8df439d9ee = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.71 8.29l-4-4a1.003 1.003 0 10-1.42 1.42L17.59 8H10a7 7 0 00-7 7v3a1 1 0 102 0v-3a5 5 0 015-5h7.59l-2.3 2.29a1 1 0 000 1.42 1.002 1.002 0 001.42 0l4-4a1.001 1.001 0 000-1.42z",
            fill: "currentColor"
        })
    });



const $326b350b793f0511$export$83e7fe94ec1ab25e = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 4a8 8 0 013.85 1H15a1 1 0 100 2h3a1 1 0 001-1V3a1 1 0 00-2 0v.36A10 10 0 0012 2a10 10 0 00-8.65 5A9.94 9.94 0 002 12a1 1 0 102 0 8 8 0 018-8zm9.71 7.29A1 1 0 0020 12a8 8 0 01-11.84 7H9a1 1 0 000-2H6a1 1 0 00-1 1v3a1 1 0 102 0v-.36A10 10 0 0012 22a10 10 0 0010-10 1 1 0 00-.29-.71z",
            fill: "currentColor"
        })
    });



const $b7542692ef02a735$export$b771562322da256 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M13 9.5h-3v2h3a1 1 0 000-2zM12 2a10 10 0 100 20 10 10 0 000-20zm3.83 13a1 1 0 01-.28 1.38.94.94 0 01-.55.17 1 1 0 01-.83-.45l-1.71-2.6H10v2a1 1 0 11-2 0v-7a1 1 0 011-1h4a3 3 0 011.57 5.55L15.83 15z",
            fill: "currentColor"
        })
    });



const $01721f4f2f69d966$export$7175b5921244e265 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10.43 4.63a1 1 0 00-1.86 0l-5.5 14a1 1 0 000 .77c.11.24.307.429.55.53a1 1 0 00.77 0c.24-.11.429-.307.53-.55L6.65 15h5.7l1.72 4.37a1 1 0 00.21.32 1 1 0 00.32.23 1.07 1.07 0 00.79.01 1 1 0 00.32-.21 1 1 0 00.23-.32A1 1 0 0016 19a1.07 1.07 0 00-.07-.39l-5.5-13.98zm-3 8.37L9.5 7.73 11.57 13H7.43zM19 3a1 1 0 00-1 1v16a1 1 0 002 0V4a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $d0b9a9ab7137e30c$export$236a0ccd7568e743 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M11 15c.196-.002.387-.06.55-.17l3-2a1 1 0 000-1.66l-3-2a1 1 0 00-1-.05A1 1 0 0010 10v4a1 1 0 00.53.88c.145.078.306.12.47.12zm1-13A10 10 0 002 12a8.32 8.32 0 00.07 1.12 1.007 1.007 0 102-.24A8.49 8.49 0 014 12a8 8 0 112.73 6h.77a1 1 0 000-2h-3a1 1 0 00-1 1v3a1 1 0 002 0v-.43A10 10 0 1012 2z",
            fill: "currentColor"
        })
    });



const $99c7740ff8bad48e$export$dc69950d8f8fa827 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 110 20 10 10 0 010-20zm-4.71 8.71l2 2a1 1 0 001.639-.325 1 1 0 00-.219-1.095l-.3-.29H13a1.88 1.88 0 012 2v2a1 1 0 002 0v-2a3.89 3.89 0 00-4-4h-2.59l.3-.29A1.005 1.005 0 0010 6.996a1.004 1.004 0 00-.71.294l-2 2a1 1 0 000 1.42z",
            fill: "currentColor"
        })
    });



const $1eb5f59a495729e7$export$f5c72112f059cb6f = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 4a8 8 0 00-8 7.61l-.31-.32a1.004 1.004 0 10-1.42 1.42l2 2a1.001 1.001 0 001.42 0l2-2a1.004 1.004 0 10-1.42-1.42l-.27.27a6 6 0 111.8 4.73 1.001 1.001 0 10-1.39 1.42A7.92 7.92 0 0012 20a8 8 0 100-16z",
            fill: "currentColor"
        })
    });



const $3d699ee66f269191$export$c9aacfdae2c4af96 = (l)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M13.75 3.64c.34-.4.32-.99-.06-1.36-.4-.38-1.03-.37-1.41.02l-1.41 1.46a.99.99 0 000 1.39l1.41 1.46a1.015 1.015 0 001.42.02.95.95 0 00.27-.88c2.9.89 5.03 3.67 5.03 6.97 0 4.01-3.14 7.27-7 7.27s-7-3.26-7-7.27c0-.55-.45-1-1-1s-1 .45-1 1c0 5.11 4.04 9.27 9 9.27s9-4.16 9-9.27c0-4.49-3.12-8.25-7.25-9.09v.01z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M10.19 18h3.61a1.809 1.809 0 001.81-1.82v-3.64c0-.32-.09-.63-.24-.9-.16-.27-.39-.5-.66-.66v-.25c0-.72-.29-1.42-.79-1.93-.51-.51-1.2-.8-1.92-.8s-1.41.29-1.92.8-.79 1.21-.79 1.93v.25c-.27.16-.5.39-.66.66-.16.27-.24.59-.24.9v3.64c0 .48.19.94.53 1.29.34.34.8.53 1.28.53h-.01zm1.17-7.92c.17-.17.4-.27.64-.27s.47.1.64.27c.17.17.26.4.26.64h-1.81c0-.24.1-.47.26-.64h.01z",
                fill: "currentColor"
            })
        ]
    });



const $b36fa5b8b53b2295$export$ec3c41764d2179bd = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 3H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-3-3zM8 17a1 1 0 11-2 0V7a1 1 0 012 0v10zm10-5a1 1 0 01-.62.92.84.84 0 01-.38.08 1 1 0 01-.71-.29L15 11.41l-1.29 1.3a.999.999 0 01-1.09.21A1 1 0 0112 12V7a1 1 0 011-1h4a1 1 0 011 1v5z",
            fill: "currentColor"
        })
    });



const $ceddafd122d89c4d$export$2a5e9b521f12455f = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 3H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-3-3zm-8 5a1 1 0 01.53-.88 1 1 0 011 0l3 2a1 1 0 010 1.66l-3 2A1 1 0 0110 12V8zm7 10H7a1 1 0 010-2h10a1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $9321ab629be0520c$export$3c93e30627a6194 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zm1.5 14H9.41l.3.29a1.004 1.004 0 11-1.42 1.42l-2-2a1.001 1.001 0 010-1.42l2-2a1.001 1.001 0 011.639.325 1 1 0 01-.219 1.095l-.3.29h4.09a2.5 2.5 0 000-5H10a1 1 0 010-2h3.5a4.5 4.5 0 110 9z",
            fill: "currentColor"
        })
    });



const $5ad3938d43ce05a8$export$2c72c2314e4d6a9b = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.71 2.29a.996.996 0 00-1.41 0l-18.01 18a.996.996 0 00.71 1.7c.26 0 .51-.1.71-.29l2.15-2.15A8.955 8.955 0 0012 21.99c4.96 0 9-4.04 9-9 0-2.38-.94-4.53-2.45-6.14l3.16-3.16a.996.996 0 000-1.41v.01zM19 13c0 3.86-3.14 7-7 7-1.82 0-3.48-.71-4.72-1.86l9.86-9.86A6.953 6.953 0 0119 13.01V13zM11.29 7.7c.15.15.34.22.53.26l1.14-1.14a1.02 1.02 0 00-.26-.53l-.27-.27c.4.02.78.09 1.15.18l1.6-1.6c-.88-.33-1.81-.54-2.79-.58l.31-.31a.996.996 0 10-1.41-1.41l-2 2a.996.996 0 000 1.41l2 2V7.7zM5.19 14.59c-.12-.51-.19-1.05-.19-1.6s-.45-1-1-1-1 .45-1 1c0 1.12.22 2.2.6 3.19l1.6-1.6-.01.01z",
            fill: "currentColor"
        })
    });



const $b01a2c64f36c3014$export$e7cab3c8b5a63ccb = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M5.64 16.24a1.5 1.5 0 102.194 2.045A1.5 1.5 0 005.64 16.24zm0-10.6a1.49 1.49 0 000 2.12 1.5 1.5 0 002.12-2.12 1.49 1.49 0 00-2.12 0zM6 12a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0zm12.36-4.24a1.5 1.5 0 10-2.195-2.045A1.5 1.5 0 0018.36 7.76zM12 18a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm4.24-1.76a1.51 1.51 0 000 2.12 1.5 1.5 0 002.12-2.12 1.51 1.51 0 00-2.12 0zm3.26-5.74a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM12 3a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
            fill: "currentColor"
        })
    });



const $6968e5184464870e$export$619eb836965b9bc9 = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M9.5 8C8.67 8 8 8.67 8 9.5S8.67 11 9.5 11s1.5-.67 1.5-1.5S10.33 8 9.5 8zm0 10c-.83 0-1.5.67-1.5 1.5S8.67 21 9.5 21s1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-5c-.83 0-1.5.67-1.5 1.5S8.67 16 9.5 16s1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm-5-5C3.67 8 3 8.67 3 9.5S3.67 11 4.5 11 6 10.33 6 9.5 5.33 8 4.5 8zm0 5c-.83 0-1.5.67-1.5 1.5S3.67 16 4.5 16 6 15.33 6 14.5 5.33 13 4.5 13zm15-7c.83 0 1.5-.67 1.5-1.5S20.33 3 19.5 3 18 3.67 18 4.5 18.67 6 19.5 6zm-15 12c-.83 0-1.5.67-1.5 1.5S3.67 21 4.5 21 6 20.33 6 19.5 5.33 18 4.5 18zm0-15C3.67 3 3 3.67 3 4.5S3.67 6 4.5 6 6 5.33 6 4.5 5.33 3 4.5 3zm15 15c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm-5-10c-.83 0-1.5.67-1.5 1.5S13.67 6 14.5 6 16 5.33 16 4.5 15.33 3 14.5 3zm5 5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5S20.33 8 19.5 8zm-10-5C8.67 3 8 3.67 8 4.5S8.67 6 9.5 6 11 5.33 11 4.5 10.33 3 9.5 3zm5 15c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5S15.33 8 14.5 8z",
            fill: "currentColor"
        })
    });



const $0f90a49407861121$export$2c32e9e390995f43 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.71 8.79c-.33-.33-.84-.36-1.22-.13v-.68c0-2.73-2.24-4.96-5-4.96-.55 0-1 .45-1 1s.45 1 1 1c1.65 0 3 1.33 3 2.96v.69a.989.989 0 00-1.17.17.996.996 0 000 1.41l1.44 1.44c.18.19.44.32.72.32.27 0 .52-.11.71-.29l1.51-1.51a.996.996 0 000-1.41l.01-.01zM12.39 8H5.65a2.63 2.63 0 00-2.63 2.63v6.74A2.63 2.63 0 005.65 20h6.74a2.63 2.63 0 002.63-2.63v-6.74A2.63 2.63 0 0012.39 8z",
            fill: "currentColor"
        })
    });



const $5cfc2505742f6d97$export$c516803b8f9d842c = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 12H8c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-6c0-1.1-.9-2-2-2zm-1 6c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-7-8V4c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2v-4c0-2.21 1.79-4 4-4h4zm4-6h.98c.27 0 .52.1.71.3.19.19.29.44.29.73v1.55l-.27-.28a.996.996 0 10-1.41 1.41l2 2c.2.2.45.29.71.29.26 0 .51-.1.71-.29l2-2a.996.996 0 10-1.41-1.41l-.3.3V5.03c0-.81-.31-1.57-.88-2.14C18.56 2.32 17.81 2 17 2h-.98c-.55 0-1 .45-1 1s.45 1 1 1H16z",
            fill: "currentColor"
        })
    });



const $28f3d8b0f5115dc2$export$9cd2721c30617df4 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.41 6.59l-3-3a2 2 0 00-2.82 0l-.3.29 1.42 1.41a1 1 0 01-.326 1.639 1 1 0 01-1.094-.22l-1.41-1.42-1.59 1.59 3.42 3.41a1 1 0 01-.326 1.64 1.002 1.002 0 01-1.094-.22L9.88 8.29 8.29 9.88l1.42 1.41a1 1 0 010 1.42 1.001 1.001 0 01-1.42 0l-1.41-1.42-1.59 1.59 3.42 3.41a1 1 0 01-.326 1.64 1.001 1.001 0 01-1.094-.22l-3.41-3.42-.29.3a2 2 0 000 2.82l3 3a2 2 0 002.82 0l11-11a2 2 0 000-2.82z",
            fill: "currentColor"
        })
    });



const $e1d4c3ddbadbebc5$export$8c486b78de544dca = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zm4 6.69l-1.24 3.1A1.91 1.91 0 0113.32 13c-.13.015-.26.015-.39 0a1.89 1.89 0 01-1.36-.57 1.92 1.92 0 01.64-3.15L15.31 8a.5.5 0 01.65.65l.04.04z",
            fill: "currentColor"
        })
    });



const $9bab36c5190a2e7b$export$3ea149f4ae5ed603 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M14 11a1 1 0 001-1V8a1 1 0 00-2 0v2a1 1 0 001 1zm6.12-3.88l-3.24-3.24A3 3 0 0014.76 3H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V9.24a3 3 0 00-.88-2.12zM16 10a2 2 0 01-2 2h-4a2 2 0 01-2-2V6h8v4z",
            fill: "currentColor"
        })
    });



const $28f92ce4cb832dcf$export$6b4ebac990974271 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 7h-1v5a1 1 0 01-2 0V7h-2v3a1 1 0 01-2 0V7h-2v5a1 1 0 01-2 0V7H7v3a1 1 0 11-2 0V7H4a2 2 0 00-2 2v6a2 2 0 002 2h16a2 2 0 002-2V9a2 2 0 00-2-2z",
            fill: "currentColor"
        })
    });



const $0ed6294e75ffc3f6$export$fe1c9b81d4877df5 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7 20H5a1 1 0 01-1-1v-2a1 1 0 10-2 0v2a3 3 0 003 3h2a1 1 0 000-2zM3 8a1 1 0 001-1V5a1 1 0 011-1h2a1 1 0 000-2H5a3 3 0 00-3 3v2a1 1 0 001 1zm18 3H3a1 1 0 000 2h18a1 1 0 000-2zm0 5a1 1 0 00-1 1v2a1 1 0 01-1 1h-2a1 1 0 000 2h2a3 3 0 003-3v-2a1 1 0 00-1-1zM19 2h-2a1 1 0 100 2h2a1 1 0 011 1v2a1 1 0 002 0V5a3 3 0 00-3-3z",
            fill: "currentColor"
        })
    });



const $de22d18a0bbbadf3$export$8154b628bc424b08 = (A)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...A,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M3 8c.27 0 .52-.11.71-.29A.99.99 0 004 7V5c0-.27.11-.52.29-.71A.99.99 0 015 4h2c.27 0 .52-.11.71-.29A.99.99 0 008 3c0-.27-.11-.52-.29-.71A.99.99 0 007 2H5c-.8 0-1.56.32-2.12.88S2 4.21 2 5v2c0 .27.11.52.29.71.19.19.44.29.71.29zM19 2h-2c-.27 0-.52.11-.71.29A.99.99 0 0016 3c0 .27.11.52.29.71.19.19.44.29.71.29h2c.27 0 .52.11.71.29.19.19.29.44.29.71v2c0 .27.11.52.29.71.19.19.44.29.71.29.27 0 .52-.11.71-.29A.99.99 0 0022 7V5c0-.8-.32-1.56-.88-2.12S19.79 2 19 2zM7 20H5c-.27 0-.52-.11-.71-.29A.99.99 0 014 19v-2c0-.27-.11-.52-.29-.71A.99.99 0 003 16c-.27 0-.52.11-.71.29A.99.99 0 002 17v2c0 .8.32 1.56.88 2.12S4.21 22 5 22h2c.27 0 .52-.11.71-.29A.99.99 0 008 21c0-.27-.11-.52-.29-.71A.99.99 0 007 20zM21 16c-.27 0-.52.11-.71.29-.19.18-.29.44-.29.71v2c0 .27-.11.52-.29.71-.18.19-.44.29-.71.29h-2c-.27 0-.52.11-.71.29-.19.18-.29.44-.29.71 0 .27.11.52.29.71.18.19.44.29.71.29h2c.8 0 1.56-.32 2.12-.88S22 19.79 22 19v-2c0-.27-.11-.52-.29-.71A.973.973 0 0021 16zM12 7.8c.28 0 .55-.08.78-.24a1.399 1.399 0 00.6-1.44c-.05-.27-.19-.52-.38-.72-.2-.2-.45-.33-.72-.38-.27-.05-.55-.03-.81.08s-.47.29-.63.52c-.15.23-.24.5-.24.78 0 .37.15.73.41.99s.62.41.99.41zM16.1 17.64a25.77 25.77 0 00-3.16-5.07v-1.58c.59.27 1.37.52 2.31.53.51 0 .94-.41.94-.93a.93.93 0 00-.93-.94c-.77 0-1.41-.27-1.82-.49-.63-.34-1.35-.43-2.02-.26-2.12.56-3.33 1.95-3.38 2.01-.33.39-.29.97.1 1.31a.922.922 0 001.31-.09s.6-.66 1.63-1.13v1.85a9.412 9.412 0 01-2.06 4.55c-.09.09-.16.19-.2.3-.05.11-.07.24-.07.36s.02.25.07.36c.05.11.12.22.2.3.09.09.19.16.3.2.11.05.24.07.36.07s.25-.02.36-.07c.11-.05.22-.12.3-.2.98-1.07 1.7-2.34 2.11-3.73.74 1.11 1.41 2.26 2 3.45.07.16.19.3.34.4.15.1.32.15.49.16.15 0 .29-.03.42-.1a.91.91 0 00.46-.54c.08-.23.06-.49-.05-.71l-.01-.01z",
            fill: "currentColor"
        })
    });



const $61f8f980cc6a68c5$export$30a8e0baeec5fc48 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10.77 14H13a1 1 0 000-2h-2.23l2.09-3.49a1 1 0 00-1.72-1L9.05 11a2 2 0 001.72 3zM7 7a1 1 0 100 2 1 1 0 000-2zm9 2a1 1 0 100-2 1 1 0 000 2zM7 20H5a1 1 0 01-1-1v-2a1 1 0 10-2 0v2a3 3 0 003 3h2a1 1 0 000-2zM7 2H5a3 3 0 00-3 3v2a1 1 0 002 0V5a1 1 0 011-1h2a1 1 0 000-2zm14 14a1 1 0 00-1 1v2a1 1 0 01-1 1h-2a1 1 0 000 2h2a3 3 0 003-3v-2a1 1 0 00-1-1zM19 2h-2a1 1 0 100 2h2a1 1 0 011 1v2a1 1 0 002 0V5a3 3 0 00-3-3zm-4.6 14.2a4.11 4.11 0 01-4.8 0 1 1 0 00-1.2 1.6 6.45 6.45 0 003.7 1.2 5.72 5.72 0 003.5-1.19 1 1 0 10-1.2-1.6v-.01z",
            fill: "currentColor"
        })
    });



const $4cf20eb5649c50eb$export$3e583a05629e2450 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10 11a1 1 0 100-2 1 1 0 000 2zM3 8a1 1 0 001-1V5a1 1 0 011-1h2a1 1 0 000-2H5a3 3 0 00-3 3v2a1 1 0 001 1zm4 12H5a1 1 0 01-1-1v-2a1 1 0 10-2 0v2a3 3 0 003 3h2a1 1 0 000-2zM6 7.25v9.5A1.25 1.25 0 007.25 18h9.5A1.25 1.25 0 0018 16.75v-9.5A1.25 1.25 0 0016.75 6h-9.5A1.25 1.25 0 006 7.25zM8 8h8v4.09l-.79-.8a1 1 0 00-1.48.07l-1.8 2.16-1.22-1.23A1 1 0 0010 12a1 1 0 00-.73.36L8 13.84V8zm11-6h-2a1 1 0 100 2h2a1 1 0 011 1v2a1 1 0 002 0V5a3 3 0 00-3-3zm2 14a1 1 0 00-1 1v2a1 1 0 01-1 1h-2a1 1 0 000 2h2a3 3 0 003-3v-2a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $1e045c68dc62c614$export$1bac93f6fb9b5e47 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 7H7a1 1 0 000 2h10a1 1 0 100-2zm0 4H7a1 1 0 000 2h10a1 1 0 000-2zM3 8a1 1 0 001-1V5a1 1 0 011-1h2a1 1 0 000-2H5a3 3 0 00-3 3v2a1 1 0 001 1zm4 12H5a1 1 0 01-1-1v-2a1 1 0 10-2 0v2a3 3 0 003 3h2a1 1 0 000-2zm6-5H7a1 1 0 000 2h6a1 1 0 000-2zm6-13h-2a1 1 0 100 2h2a1 1 0 011 1v2a1 1 0 002 0V5a3 3 0 00-3-3zm2 14a1 1 0 00-1 1v2a1 1 0 01-1 1h-2a1 1 0 000 2h2a3 3 0 003-3v-2a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $99b1b76518e349df$export$dc3c7389b2c7a3fc = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 13H5a2 2 0 00-2 2v4a2 2 0 002 2h14a2 2 0 002-2v-4a2 2 0 00-2-2zm0-10H5a2 2 0 00-2 2v4a2 2 0 002 2h14a2 2 0 002-2V5a2 2 0 00-2-2z",
            fill: "currentColor"
        })
    });



const $5e123b8f60d8c777$export$501c5177a31b1f12 = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21 13h-1.5a8.298 8.298 0 000-3.33 3.35 3.35 0 00-2.2-2.62c-2.25-.75-5.67-.42-9.18 5.44-.73 1.22-1.59 1.83-2.32 1.63A1.17 1.17 0 015 13c0-1 1.17-2.28 2.2-3.45a17.23 17.23 0 001.63-2 3.56 3.56 0 00.71-2.17 2.2 2.2 0 00-1-1.75c-1.38-.93-3.88-.42-5.37 1.82a1 1 0 001.66 1.1C5.73 5.21 7 5 7.44 5.3a.19.19 0 01.1.19 1.62 1.62 0 01-.37 1 21.09 21.09 0 01-1.46 1.74C4.38 9.72 3 11.27 3 13a3.17 3.17 0 002.29 3.05c.61.17 2.75.49 4.57-2.54 1.56-2.6 4-5.5 6.82-4.56.17.05.66.22.89 1.18a6.75 6.75 0 01-.13 2.93 17.12 17.12 0 00-3.36.47C10.71 14.41 10 16.45 10 18a2.77 2.77 0 001.61 2.7c.319.125.658.189 1 .19 1 0 2.33-.45 4.07-2.18A10.4 10.4 0 0018.94 15H21a1 1 0 100-2zm-5.71 4.29c-1.54 1.54-2.56 1.7-2.92 1.56-.36-.14-.37-.69-.37-.85 0-.87.29-1.94 2.59-2.54.702-.175 1.418-.289 2.14-.34a7.81 7.81 0 01-1.44 2.17z",
            fill: "currentColor"
        })
    });



const $c647374f748e4023$export$99131cc76a63ecf8 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 18a6 6 0 100-12 6 6 0 000 12z",
            fill: "currentColor"
        })
    });



const $959c80acc9069acb$export$e2519f9643651437 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.52 9.04l-15-6.82C4.14 1.59 2.4 2.31 2 4.07c-.1.46-.03.94.17 1.36L9.1 20.67c.19.42.5.79.91 1 1.71.88 3.44-.13 3.75-1.68l.51-2.57a4.01 4.01 0 013.14-3.14l2.72-.54c.45-.09.89-.31 1.18-.66 1.24-1.46.66-3.38-.79-4.04z",
            fill: "currentColor"
        })
    });



const $0816975166b6f490$export$70cbb8869b5e41ee = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 4H5C3.34 4 2 5.34 2 7v10c0 1.66 1.34 3 3 3h14c1.66 0 3-1.34 3-3V7c0-1.66-1.34-3-3-3zm-3.29 7.71c-.2.2-.45.29-.71.29-.26 0-.51-.1-.71-.29L13 10.42v5.59c0 .55-.45 1-1 1s-1-.45-1-1v-5.59l-1.29 1.29c-.2.2-.45.29-.71.29-.26 0-.51-.1-.71-.29a.996.996 0 010-1.41l3-3a.996.996 0 011.41 0l3 3c.39.39.39 1.02 0 1.41h.01z",
            fill: "currentColor"
        })
    });



const $897d037fd7b811d0$export$91fc322e74e5c6d4 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.3 3.7a12.88 12.88 0 00-8.45 0 13.1 13.1 0 00-8.16 16.62 1 1 0 00.95.68c.12.017.24.017.36 0a1 1 0 00.62-1.27 11.74 11.74 0 01-.48-2.13c.791.15 1.594.228 2.4.23a13.47 13.47 0 007.28-2.12 1 1 0 00.39-1.15L14 11l4.06.68a1 1 0 001-.46A13.53 13.53 0 0021 4.67a1 1 0 00-.7-.97z",
            fill: "currentColor"
        })
    });



const $e60cb4f514084d60$export$7275effcf079f7ee = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M9 16.5a2.5 2.5 0 10-5 0 2.5 2.5 0 005 0zM17.5 4a3.71 3.71 0 00-.48 0A5 5 0 008.4 5H8a4 4 0 000 8 4.18 4.18 0 001.33-.24 5 5 0 009.31.08A4.49 4.49 0 0017.5 4zM15 11.5h-3a1.001 1.001 0 01-.89-.55 1 1 0 01.09-1L13 7.5h-1a1 1 0 110-2h3a1 1 0 01.89.55 1 1 0 01-.09 1L14 9.5h1a1 1 0 110 2zM9.5 19a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
            fill: "currentColor"
        })
    });



const $c6c54ce4478c0f63$export$7e4861ec0c557e6d = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M2 8v8a2 2 0 002 2h1V6H4a2 2 0 00-2 2zm18-2h-1v12h1a2 2 0 002-2V8a2 2 0 00-2-2zm-5-2H9a2 2 0 00-2 2v12a2 2 0 002 2h6a2 2 0 002-2V6a2 2 0 00-2-2z",
            fill: "currentColor"
        })
    });



const $a39162c6ffd6a03e$export$a1de62ff27a4f6e1 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7.22 18.38a8.32 8.32 0 01-1.79-1.86.89.89 0 00-.27-.31 1.001 1.001 0 00-.37-.21 1 1 0 00-.41 0 1 1 0 00-.38.16 1 1 0 00-.43.68 1.39 1.39 0 000 .41 1 1 0 00.2.37A9.51 9.51 0 006 20a1 1 0 00.6.2 1 1 0 00.59-.2 1 1 0 00.36-.49 1.06 1.06 0 000-.61.94.94 0 00-.33-.52zM4 14a1 1 0 00.16-.37 1 1 0 000-.39 7 7 0 010-2.48 1 1 0 000-.39 1 1 0 00-.22-.37.8.8 0 00-.29-.26 1 1 0 00-.37-.14 1 1 0 00-.39 0 1 1 0 00-.63.45 1.26 1.26 0 00-.13.37 9.49 9.49 0 000 3.1c.042.236.162.45.34.61a1 1 0 00.66.24h.15c.132-.022.257-.07.37-.14A.94.94 0 004 14zM7.22 3.86a1 1 0 00-.42-.12 1.07 1.07 0 00-.43.06 1.11 1.11 0 00-.37.25 9.88 9.88 0 00-2.2 2.26A1 1 0 004 7.7a1 1 0 001.4-.26 8.21 8.21 0 011.77-1.81.89.89 0 00.34-.27A.91.91 0 007.7 5a.94.94 0 000-.44.81.81 0 00-.17-.39 1 1 0 00-.31-.31zm2.62 12.73a1.47 1.47 0 001.58-.16l4.24-3.26a1.509 1.509 0 000-2.38l-4.24-3.26a1.5 1.5 0 00-.76-.31 1.52 1.52 0 00-1.43.7 1.51 1.51 0 00-.22.8v6.52a1.47 1.47 0 00.83 1.35zm9.23-11.66A10 10 0 0010 2.2a1 1 0 00-.65.43 1 1 0 00-.15.77 1 1 0 00.44.6 1 1 0 00.77.16A7.06 7.06 0 0112 4a8 8 0 110 16 7.117 7.117 0 01-1.6-.16 1.34 1.34 0 00-.4 0 1 1 0 00-.37.16.83.83 0 00-.28.28 1 1 0 00-.15.36.9.9 0 000 .4.85.85 0 00.15.37c.075.11.17.205.28.28.113.072.239.123.37.15.659.133 1.329.2 2 .2a10 10 0 007.07-17.11z",
            fill: "currentColor"
        })
    });



const $0887c8339383c1ce$export$16820eb7c0cd3938 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4 9h16a1 1 0 100-2H4a1 1 0 000 2zm16 2H4a1 1 0 000 2h16a1 1 0 000-2zm0 4H4a1 1 0 000 2h16a1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $fdc1af3d54e8adb7$export$79aa0125a3651e97 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10 17H4a1 1 0 000 2h6a1 1 0 000-2zm0-6H4a1 1 0 000 2h6a1 1 0 000-2zm8.79 3.29l-1.29 1.3V11.5a1 1 0 00-2 0v4.09l-1.29-1.3a1.004 1.004 0 10-1.42 1.42l3 3a1.002 1.002 0 001.42 0l3-3a1.004 1.004 0 00-1.42-1.42zM20 5H4a1 1 0 000 2h16a1 1 0 100-2z",
            fill: "currentColor"
        })
    });



const $0aea7c821469b55e$export$7d7747a274f9a995 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10 17H4c-.27 0-.52.11-.71.29A.99.99 0 003 18c0 .27.11.52.29.71.19.19.44.29.71.29h6c.27 0 .52-.11.71-.29.19-.18.29-.44.29-.71 0-.27-.11-.52-.29-.71A.973.973 0 0010 17zm0-6H4c-.27 0-.52.11-.71.29A.99.99 0 003 12c0 .27.11.52.29.71.19.19.44.29.71.29h6c.27 0 .52-.11.71-.29.19-.18.29-.44.29-.71 0-.27-.11-.52-.29-.71A.973.973 0 0010 11zm4.21 4.22l1.29-1.3v4.09c0 .27.11.52.29.71.18.19.44.29.71.29.27 0 .52-.11.71-.29.19-.18.29-.44.29-.71v-4.09l1.29 1.3c.19.19.44.29.71.29.27 0 .52-.11.71-.29.19-.18.29-.44.29-.71 0-.27-.11-.52-.29-.71l-3-3a.955.955 0 00-.33-.22.995.995 0 00-.38-.08c-.13 0-.26.03-.38.08s-.23.13-.33.22l-3 3c-.09.09-.17.2-.22.33-.05.12-.08.25-.08.38s.03.26.08.38a1.004 1.004 0 00.55.55c.12.05.25.08.38.08s.26-.03.38-.08.23-.12.33-.22zM20 5H4c-.27 0-.52.11-.71.29A.99.99 0 003 6c0 .27.11.52.29.71.19.19.44.29.71.29h16c.27 0 .52-.11.71-.29A.99.99 0 0021 6c0-.27-.11-.52-.29-.71A.99.99 0 0020 5z",
            fill: "currentColor"
        })
    });



const $185793cf3286568e$export$fc9054f330e4a247 = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.7 6.83c-.19.18-.44.27-.68.27-.27 0-.53-.11-.73-.32l-1.4-1.49v3.35a7.96 7.96 0 01-2.96 6.21l-1.9 1.54V21c0 .55-.45 1-1 1s-1-.45-1-1v-4.59l-1.92-1.55a7.972 7.972 0 01-2.98-6.23V5.27l-1.4 1.49c-.2.21-.46.32-.73.32a.996.996 0 01-.72-1.68l2.77-2.95c.28-.3.68-.47 1.09-.47.41 0 .81.17 1.09.48l2.76 2.95c.38.4.36 1.04-.05 1.41-.4.38-1.04.36-1.41-.05l-1.4-1.5v3.37c0 1.82.81 3.53 2.23 4.67l1.65 1.33 1.66-1.35a5.967 5.967 0 002.22-4.66V5.27l-1.4 1.5c-.38.4-1.01.42-1.41.05-.4-.38-.42-1.01-.05-1.41l2.76-2.95a1.498 1.498 0 012.18 0l2.77 2.95c.38.4.36 1.04-.04 1.41v.01z",
            fill: "currentColor"
        })
    });



const $93fb739de7d08ee5$export$300d309e647e403b = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M5.5 6a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM12 19a1 1 0 100 2 1 1 0 000-2zm5-11a1 1 0 100-2 1 1 0 000 2zm1 1a3 3 0 00-2.5 1.34L14 10a4 4 0 10-6.79 2.89l-.68 1.19A3.07 3.07 0 006 14a3 3 0 103 3 3 3 0 00-.74-1.95L9 13.84c.324.099.66.153 1 .16a4 4 0 003.5-2.09l1.53.38A3 3 0 1018 9z",
            fill: "currentColor"
        })
    });



const $4235aa0f8e43da6f$export$ca972266fa36d6 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16.67 4.29a5 5 0 013 3 1 1 0 00.94.67 1 1 0 00.39-.02 1 1 0 00.6-1.27 6.93 6.93 0 00-4.26-4.26 1 1 0 10-.66 1.88h-.01zM3 7.94a1 1 0 001.29-.61 5 5 0 013-3 1 1 0 10-.66-1.88 6.93 6.93 0 00-4.22 4.22A1 1 0 003 7.94zm4.33 11.77a5 5 0 01-3-3A1 1 0 003 16.06a1 1 0 00-.6 1.27 6.93 6.93 0 004.26 4.26c.106.038.217.059.33.06a1 1 0 00.33-1.94h.01zM18 15V9a3 3 0 00-3-3H9a3 3 0 00-3 3v6a3 3 0 003 3h6a3 3 0 003-3zm-6-1a2 2 0 110-4 2 2 0 010 4zm9 2.06a.999.999 0 00-1.28.61 5 5 0 01-3 3 1 1 0 00.28 1.98c.113-.001.224-.022.33-.06a6.93 6.93 0 004.26-4.26 1 1 0 00-.59-1.27z",
            fill: "currentColor"
        })
    });



const $280182771da9caf3$export$326f33ad46fe272 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.9 9.48a2 2 0 00-1.6-1.35l-4.47-.68-2-4.3a2 2 0 00-3.62 0l-2 4.3-4.51.68a2 2 0 00-1.6 1.35 2 2 0 00.47 2l3.29 3.38-.78 4.79a2 2 0 00.82 1.95 2 2 0 001.16.4c.35.009.695-.078 1-.25l4-2.2 4 2.2c.305.172.65.259 1 .25a2 2 0 001.16-.37 2 2 0 00.82-1.95l-.78-4.79 3.29-3.38a2 2 0 00.35-2.03zM14 14h-1v1a1 1 0 11-2 0v-1h-1a1 1 0 010-2h1v-1a1 1 0 012 0v1h1a1 1 0 110 2z",
            fill: "currentColor"
        })
    });



const $b6dd8893f9bd0902$export$da1bbd17bc59c98e = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16.84 4H7.16A3.16 3.16 0 004 7.16v9.68A3.16 3.16 0 007.16 20h9.68A3.16 3.16 0 0020 16.84V7.16A3.16 3.16 0 0016.84 4z",
            fill: "currentColor"
        })
    });



const $3297cbb07d23a170$export$ce92fad5f8bd687 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10 4h4a1 1 0 100-2h-4a1 1 0 000 2zm8.71 2.71a1 1 0 101.41-1.42l-1.41-1.41a1 1 0 10-1.42 1.41l1.42 1.42zM12 5a8.5 8.5 0 108.5 8.5A8.51 8.51 0 0012 5zm1 8a1 1 0 01-2 0V9a1 1 0 012 0v4z",
            fill: "currentColor"
        })
    });



const $8c541319ede222fc$export$6d7656d5217e896d = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 14c.65 0 1.23-.32 1.59-.8.26-.34.41-.75.41-1.2 0-1.1-.9-2-2-2s-2 .9-2 2c0 .45.15.86.41 1.2.36.48.94.8 1.59.8zm3.59 2.8a4.48 4.48 0 00-1.6-1.33c-.6-.3-1.27-.47-1.99-.47s-1.39.17-1.99.47c-.63.31-1.18.77-1.6 1.33-.41.54-.7 1.17-.83 1.86-.05.27-.08.55-.08.84 0 .82.68 1.5 1.5 1.5h6c.82 0 1.5-.68 1.5-1.5 0-.29-.03-.57-.08-.84-.13-.69-.42-1.32-.83-1.86zM12 6c-3.31 0-6 2.69-6 6 0 1.24.37 2.38 1.02 3.34.43-.52.94-.97 1.52-1.33A3.999 3.999 0 0112 8a3.999 3.999 0 013.46 6.01c.58.36 1.09.81 1.52 1.33A5.91 5.91 0 0018 12c0-3.31-2.69-6-6-6zm0-4C6.49 2 2 6.49 2 12c0 3.04 1.36 5.76 3.51 7.6-.01-.03-.01-.07-.01-.1 0-.81.15-1.59.43-2.31A7.95 7.95 0 014 12c0-4.41 3.59-8 8-8s8 3.59 8 8c0 1.98-.73 3.79-1.93 5.19.28.72.43 1.5.43 2.31 0 .03 0 .07-.01.1A9.973 9.973 0 0022 12c0-5.51-4.49-10-10-10z",
            fill: "currentColor"
        })
    });



const $45f6dc7f41132b38$export$3d4d4de3df0f26a2 = (o)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M19.48 13.01H4.9c-.56 0-1.01-.45-1.01-1.01s.45-1.01 1.01-1.01h14.58c.56 0 1.01.45 1.01 1.01s-.45 1.01-1.01 1.01z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M11.92 4.87c-2.24 0-3.54.99-3.54 2.49 0 1.24 1.1 1.81 2.72 2.43l2.72 1.08c2.94 1.16 4.75 2.46 4.75 5.49 0 3.48-2.72 5.6-6.65 5.6-2.92 0-5.04-.96-6.43-2.32-.23-.23-.45-.59-.45-.93 0-.65.71-1.59 1.56-1.59.34 0 .59.17.96.48.99.85 2.38 1.53 4.36 1.53 2.12 0 3.6-1.05 3.6-2.77 0-1.27-1.08-2.06-2.72-2.69l-2.72-1.08c-2.92-1.16-4.76-2.29-4.76-5.24 0-3.2 2.66-5.32 6.6-5.32 2.26 0 4.02.68 5.12 1.53.37.31.54.65.54 1.1 0 .65-.74 1.47-1.44 1.47-.37 0-.57-.11-.88-.31-.91-.54-1.81-.96-3.34-.96v.01z",
                fill: "currentColor"
            })
        ]
    });



const $5d9356f1e88078dc$export$383cc8f9793bd903 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 3h-1.28A2 2 0 0014 2h-4a2 2 0 00-1.72 1H7a3 3 0 00-3 3v13a3 3 0 003 3h10a3 3 0 003-3V6a3 3 0 00-3-3zM8.29 13.29a1 1 0 011.42 0l1.29 1.3 3.29-3.3a1.004 1.004 0 111.42 1.42l-4 4a1.002 1.002 0 01-1.42 0l-2-2a1 1 0 010-1.42zM18 8H6V6a1 1 0 011-1h1.28A2 2 0 0010 6h4a2 2 0 001.72-1H17a1 1 0 011 1v2z",
            fill: "currentColor"
        })
    });



const $7a6e4468633e19e6$export$408b61a04e7b941f = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.12 2.88C20.56 2.32 19.79 2 19 2h-8c-.8 0-1.56.32-2.12.88S8 4.21 8 5v1h5c1.33 0 2.6.53 3.54 1.46C17.48 8.4 18 9.67 18 11v5h1c.8 0 1.56-.32 2.12-.88S22 13.79 22 13V5c0-.8-.32-1.56-.88-2.12zM13 8H5c-.8 0-1.56.32-2.12.88S2 10.21 2 11v8c0 .8.32 1.56.88 2.12S4.21 22 5 22h8c.8 0 1.56-.32 2.12-.88S16 19.79 16 19v-8c0-.8-.32-1.56-.88-2.12S13.79 8 13 8zm-1.17 8.41a.996.996 0 11-1.41 1.41l-1.41-1.41-1.41 1.41a.996.996 0 11-1.41-1.41L7.6 15l-1.41-1.41a.996.996 0 111.41-1.41l1.41 1.41 1.41-1.41a.996.996 0 111.41 1.41L10.42 15l1.41 1.41z",
            fill: "currentColor"
        })
    });



const $489c353fcdfa4e69$export$2af0abbb7bb6bab = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 8V6a3 3 0 00-3-3h-1.28A2 2 0 0014 2h-4a2 2 0 00-1.72 1H7a3 3 0 00-3 3v13a3 3 0 003 3h10a3 3 0 003-3v-1a2 2 0 002-2v-6a2 2 0 00-2-2zm-2 11a1 1 0 01-1 1H7a1 1 0 01-1-1V6a1 1 0 011-1h1.28A2 2 0 0010 6h4a2 2 0 001.72-1H17a1 1 0 011 1v2h-6a2 2 0 00-2 2v6a2 2 0 002 2h6v1zm.71-6.79l-3 3a1.002 1.002 0 01-1.42 0l-1-1a1.004 1.004 0 111.42-1.42l.29.3 2.29-2.3a1.004 1.004 0 111.42 1.42z",
            fill: "currentColor"
        })
    });



const $28c523f3d2cfb1d9$export$2357490b75636f8a = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 3H4c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1s1-.45 1-1V5h6v14H9c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1h-2V5h6v2c0 .55.45 1 1 1s1-.45 1-1V4c0-.55-.45-1-1-1z",
            fill: "currentColor"
        })
    });



const $3d976abb18e464e5$export$2a5ab1758d0c1fda = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4 7h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zm16 10H4c-.55 0-1 .45-1 1s.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1zM8 11c-.55 0-1 .45-1 1s.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1H8z",
            fill: "currentColor"
        })
    });



const $8dafd2c5e9995eb1$export$d66a7e063ec59c87 = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4 7h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zm16 10H4c-.55 0-1 .45-1 1s.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1zm0-6H4c-.55 0-1 .45-1 1s.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1z",
            fill: "currentColor"
        })
    });



const $2e214eeb59598f7b$export$3ebb08846f7f004b = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4 7h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zm16 10H4c-.55 0-1 .45-1 1s.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1zM4 13h8c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1z",
            fill: "currentColor"
        })
    });



const $7606c724f92f6cb8$export$abca49d354f25a55 = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 17H4c-.55 0-1 .45-1 1s.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1zM4 7h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zm16 4h-8c-.55 0-1 .45-1 1s.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1z",
            fill: "currentColor"
        })
    });



const $544de00620925318$export$e67e32c3473ed37b = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M3.5 5v14a3 3 0 003 3V2a3 3 0 00-3 3zm14-3h-9v20h9a3 3 0 003-3V5a3 3 0 00-3-3zM16 10h-3a2 2 0 010-4h3a2 2 0 010 4z",
            fill: "currentColor"
        })
    });



const $bf8625a4e3ea545c$export$e425130f835347c8 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 2h-8a3 3 0 00-3 3v3H5a3 3 0 00-3 3v8a3 3 0 003 3h8a3 3 0 003-3v-3h3a3 3 0 003-3V5a3 3 0 00-3-3zm-5 17a1 1 0 01-1 1H5a1 1 0 01-1-1v-8a1 1 0 011-1h8a1 1 0 011 1v8z",
            fill: "currentColor"
        })
    });



const $648749baa6f27fdc$export$cb300663aff5ee4c = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M3 5v14a2 2 0 002 2h2.67V3H5a2 2 0 00-2 2zm6.67 16h4.66V3H9.67v18zM19 3h-2.67v18H19a2 2 0 002-2V5a2 2 0 00-2-2z",
            fill: "currentColor"
        })
    });



const $caa792f87978a8fd$export$71d4b26e508bf4d = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M9 3H5a2 2 0 00-2 2v4a2 2 0 002 2h4a2 2 0 002-2V5a2 2 0 00-2-2zm0 10H5a2 2 0 00-2 2v4a2 2 0 002 2h4a2 2 0 002-2v-4a2 2 0 00-2-2zM19 3h-4a2 2 0 00-2 2v4a2 2 0 002 2h4a2 2 0 002-2V5a2 2 0 00-2-2zm0 10h-4a2 2 0 00-2 2v4a2 2 0 002 2h4a2 2 0 002-2v-4a2 2 0 00-2-2z",
            fill: "currentColor"
        })
    });



const $52eabbd64289cb3a$export$559c4f3e9df11f56 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 6v6l-5 3.33A6 6 0 1012 6zm0-4a10 10 0 100 20 10 10 0 000-20zm0 18a8 8 0 110-16.001A8 8 0 0112 20z",
            fill: "currentColor"
        })
    });



const $48f60c0c9ba5bad2$export$eb6c8047c37c8455 = (v)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...v,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4 15v2a1 1 0 001 1h4v-4H5a1 1 0 00-1 1zm14-4V9a1 1 0 00-1-1h-2v4h2a1 1 0 001-1zm-5-9h-2a1 1 0 00-1 1v2a1.001 1.001 0 00.29.71l.71.7v13a1.5 1.5 0 102 0v-13l.71-.7A1 1 0 0014 5V3a1 1 0 00-1-1zm6 12h-4v4h4a1 1 0 001-1v-2a1 1 0 00-1-1zM4 9v2a1 1 0 001 1h4V8H5a1 1 0 00-1 1z",
            fill: "currentColor"
        })
    });



const $889bf62b7207be2c$export$e0403001d1ab4406 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4.5 10.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm0 6a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM9 7h10a1 1 0 001.71.71l1-1a1 1 0 000-1.42l-1-1A1 1 0 0019 5H9a1 1 0 000 2zM4.5 4.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm16.21 11.79a1.002 1.002 0 00-1.636.326A1 1 0 0019 17H9a1 1 0 000 2h10a1 1 0 001.71.71l1-1a1 1 0 000-1.42l-1-1zm0-6a1.002 1.002 0 00-1.636.326A1 1 0 0019 11H9a1 1 0 000 2h10a1 1 0 001.71.71l1-1a1 1 0 000-1.42l-1-1z",
            fill: "currentColor"
        })
    });



const $5f215393ba54b160$export$ca7f98875870ea41 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17.65 17a.509.509 0 00-.56.2l-1 1.44a.5.5 0 000 .56l1 1.55a.481.481 0 00.42.23h.14a.5.5 0 00.35-.48v-3a.5.5 0 00-.35-.5zM22 12a10.1 10.1 0 00-.76-3.83A10 10 0 009.099 2.427a10 10 0 00-4.17 16.643 9.93 9.93 0 009.82 2.53A4.93 4.93 0 0114 19a5 5 0 015-5 4.91 4.91 0 012.6.75A9.777 9.777 0 0022 12zm-9 1a1 1 0 01-1 1H9a1 1 0 010-2h2V9a1 1 0 012 0v4zm7.92 4.23a.5.5 0 00-.92.27v3a.5.5 0 00.35.48h.15a.491.491 0 00.41-.22l1-1.44a.5.5 0 000-.56l-.99-1.53z",
            fill: "currentColor"
        })
    });



const $7f0fa03212331f79$export$b066479acc928c9c = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 11a4 4 0 100-8 4 4 0 000 8zm-1.5-5a1 1 0 012 0v.78l.82.27A1 1 0 0119 8.32 1 1 0 0118 9a1.25 1.25 0 01-.32 0l-1.5-.5a1 1 0 01-.68-.95V6zM7 3a4 4 0 100 8 4 4 0 000-8zm1 5.5H6.5a1 1 0 01-1-1V6a1 1 0 012 0v.5H8a1 1 0 010 2zm9 4.5a4 4 0 100 8 4 4 0 000-8zm1 4.5h-.5v.5a1 1 0 01-2 0v-1.5a1 1 0 011-1H18a1 1 0 010 2zM7 13a4 4 0 100 8 4 4 0 000-8zm1.5 4.5a1 1 0 01-.68.95l-1.5.5c-.104.03-.212.047-.32.05a1 1 0 01-.949-1.446 1 1 0 01.579-.504l.82-.27V16a1 1 0 112 0l.05 1.5z",
            fill: "currentColor"
        })
    });



const $c2c2c67ba1863e13$export$590b9d8a1cd8c29f = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 3H6a3 3 0 00-3 3v9a3 3 0 003 3h4v1a2 2 0 002 2h2a2 2 0 002-2v-1h2a3 3 0 003-3V6a3 3 0 00-3-3zm1 12a1 1 0 01-1 1h-2l.81-2.8v-.15a2 2 0 00-1.6-2.21L12 10.18V8a1 1 0 00-2 0v4.13l-1.45-1A1 1 0 007.2 12.6L9.75 16H6a1 1 0 01-1-1V6a1 1 0 011-1h12a1 1 0 011 1v9z",
            fill: "currentColor"
        })
    });



const $f39468b83be661fe$export$a04849034721082d = (h)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M5.01 15V6a1 1 0 01.3-.71c.19-.19.44-.29.7-.29h9.64l2-2H6.01c-.79 0-1.55.31-2.12.88-.56.56-.88 1.32-.88 2.12v9c0 .7.25 1.39.71 1.93l1.43-1.43a.993.993 0 01-.14-.5z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M10.31 7.29a1 1 0 00-.3.71v2.64l2-2V8a.99.99 0 00-1-1c-.27 0-.51.1-.7.29zM7.2 11.23c-.17.19-.27.43-.26.69 0 .25.1.49.27.68l.36.48 1.56-1.56-.57-.39a.967.967 0 00-.7-.22.99.99 0 00-.66.32zM21.67 3.25a.996.996 0 00-1.41 0l-.39.39-1.44 1.43s0 .01.01.01l-5.32 5.32h-.02l-4.3 4.3h.01v.01L7.52 16H7.5l-1.96 1.96h.02l-1.29 1.29a.996.996 0 00.71 1.7c.26 0 .51-.1.71-.29L8.35 18h1.68v1c0 .53.22 1.04.59 1.41.38.38.88.59 1.41.59h2a1.998 1.998 0 002-2v-1h2c.8 0 1.56-.32 2.13-.88.56-.56.87-1.33.87-2.12V6c0-.21-.02-.41-.07-.61l.73-.73a.996.996 0 000-1.41h-.02zM19.01 15c0 .26-.1.52-.29.71-.19.18-.44.29-.71.29h-2l.81-2.8v-.15c.07-.5-.06-1.01-.36-1.42-.26-.35-.61-.61-1.03-.73l3.58-3.58V15z",
                fill: "currentColor"
            })
        ]
    });



const $920014f5b9f1a896$export$eb3b4e07c2fe27aa = (s)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...s,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 4H5C3.34 4 2 5.34 2 7v9.99c0 1.66 1.34 3 3 3h13.99c1.66 0 3-1.34 3-3V7c0-1.66-1.34-3-3-3H19zM5 11h2c.55 0 1 .45 1 1s-.45 1-1 1H5c-.55 0-1-.45-1-1s.45-1 1-1zm8 6H5c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1zm6 0h-2c-.55 0-1-.45-1-1s.45-1 1-1h2c.55 0 1 .45 1 1s-.45 1-1 1zm0-4h-8c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1z",
            fill: "currentColor"
        })
    });



const $45ee665e462b402c$export$7086692d697dac8a = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 6h-2V5a3 3 0 00-3-3H9a3 3 0 00-3 3v1H4a1 1 0 000 2h1v11a3 3 0 003 3h8a3 3 0 003-3V8h1a1 1 0 100-2zm-4.29 9.71l-3 3a1 1 0 01-.33.21.94.94 0 01-.76 0 1 1 0 01-.33-.21l-3-3a1.004 1.004 0 011.42-1.42l1.29 1.3V10a1 1 0 012 0v5.59l1.29-1.3a1.004 1.004 0 111.42 1.42zM16 6H8V5a1 1 0 011-1h6a1 1 0 011 1v1z",
            fill: "currentColor"
        })
    });



const $20eb493072419a1d$export$1c5bb962986bf72e = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15.62 6.54C14 5.17 13 4.27 13 3a1 1 0 00-.62-.92 1 1 0 00-1.09.21c-.1.11-2.48 2.57-.18 7.16a1.53 1.53 0 01-.1 1.83 1.09 1.09 0 01-1.25.25c-.56-.28-1.07-1.32-.76-3.39a1 1 0 00-1.54-1A8.44 8.44 0 004 14a7.83 7.83 0 008 8 7.83 7.83 0 008-8c0-3.77-2.43-5.82-4.38-7.46z",
            fill: "currentColor"
        })
    });



const $9baea98c54796104$export$64c7a41559227748 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.73 16.99l-7-12C13.37 4.38 12.71 4 12 4s-1.37.38-1.73.99l-7 12c-.36.62-.36 1.38 0 2 .36.62 1.02 1 1.73 1h14c.72 0 1.38-.38 1.73-1 .35-.62.35-1.39 0-2z",
            fill: "currentColor"
        })
    });



const $a59c417823c023fb$export$4d56dfe848ec7e1b = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M3.27 7.01l7 12c.36.61 1.02.99 1.73.99s1.37-.38 1.73-.99l7-12c.36-.62.36-1.38 0-2-.36-.62-1.02-1-1.73-1H5c-.72 0-1.38.38-1.73 1-.35.62-.35 1.39 0 2z",
            fill: "currentColor"
        })
    });



const $0fd8625f7bb8f9a9$export$e746177acb22994f = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15 19H9a1 1 0 000 2h6a1 1 0 000-2zm5-14H4a2 2 0 00-2 2v9a2 2 0 002 2h16a2 2 0 002-2V7a2 2 0 00-2-2zm-4.92 10.3a1.001 1.001 0 01-.52.15 1 1 0 01-.86-.45 2 2 0 00-3.4 0 1.003 1.003 0 11-1.71-1.05 4 4 0 016.82 0 1 1 0 01-.33 1.35zm3-3a1 1 0 01-1.066.131 1.001 1.001 0 01-.344-.271 6 6 0 00-9.3 0 1 1 0 01-1.57-1.22 8 8 0 0112.4 0 1 1 0 01-.14 1.41l.02-.05z",
            fill: "currentColor"
        })
    });



const $47dd94de6dfda796$export$bf13fc7cb83a81f = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 18c3.84 0 6.96-3.12 6.96-6.96V4c0-.55-.45-1-1-1s-1 .45-1 1v7.04a4.96 4.96 0 11-9.92 0V4c0-.55-.45-1-1-1s-1 .45-1 1v7.04C5.04 14.88 8.16 18 12 18zm7 2H5c-.55 0-1 .45-1 1s.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1z",
            fill: "currentColor"
        })
    });



const $a341092ad95f246b$export$f16aa9805435e325 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M14 8H6.41l2.3-2.29a1.004 1.004 0 00-1.42-1.42l-4 4a1 1 0 000 1.42l4 4a1 1 0 001.639-.325 1 1 0 00-.22-1.095L6.41 10H14a5 5 0 015 5v3a1 1 0 002 0v-3a7 7 0 00-7-7z",
            fill: "currentColor"
        })
    });



const $1a1982678b7f2925$export$6e33871d77085bef = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12.55 8.3l1.94-1.94c.33-.33.79-.48 1.3-.45.57.04 1.12.3 1.56.75.44.44.71 1 .74 1.56.04.52-.12.98-.45 1.3l-1.28 1.28c-.3.3-.36.73-.21 1.1l.52.52c.36.16.8.09 1.1-.21l1.28-1.28c.74-.74 1.1-1.75 1.03-2.85-.07-1.05-.54-2.06-1.33-2.84a4.52 4.52 0 00-2.84-1.33c-1.1-.08-2.12.29-2.85 1.03l-1.93 1.93 1.43 1.43h-.01zM5.26 3.84s-.03-.05-.05-.08l-.48-.48a.996.996 0 10-1.41 1.41l5.66 5.66c-.01.17-.03.33-.02.51.07 1.05.54 2.06 1.33 2.84.2.2.45.29.71.29.26 0 .51-.1.71-.29.11-.11.18-.25.23-.39l.89.89c-.07.13-.15.25-.25.36l-3.07 3.07c-.32.33-.78.48-1.3.45-.57-.04-1.12-.3-1.56-.75-.44-.44-.71-1-.74-1.56-.04-.52.12-.98.45-1.3l1.28-1.28a.996.996 0 10-1.41-1.41l-1.28 1.28c-.74.74-1.1 1.75-1.03 2.85.07 1.05.54 2.06 1.33 2.84a4.52 4.52 0 002.84 1.33h.29c.99 0 1.89-.36 2.57-1.04l3.07-3.07c.1-.1.17-.22.26-.33l5.03 5.03c.2.2.45.29.71.29.26 0 .51-.1.71-.29.37-.37.38-.94.05-1.34L5.26 3.84z",
            fill: "currentColor"
        })
    });



const $2956159ac41fa16b$export$611d5f8c1b45c238 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16.24 16.24A5.93 5.93 0 0112 18a6 6 0 01-6-5.56l.27.27a1 1 0 001.64-.325 1 1 0 00-.22-1.095l-2-2a1 1 0 00-1.42 0l-2 2a1.004 1.004 0 101.42 1.42l.31-.32a8 8 0 0013.64 5.27 1.004 1.004 0 10-1.42-1.42h.02zm5.47-4.95a1.001 1.001 0 00-1.42 0l-.36.36A8 8 0 006.29 6.34a1.004 1.004 0 101.42 1.42 6 6 0 0110.22 3.75l-.22-.22a1.004 1.004 0 10-1.42 1.42l2 2a1 1 0 001.42 0l2-2a1.002 1.002 0 000-1.42zM12 14a1 1 0 001-1v-3a1 1 0 00-2 0v2h-1a1 1 0 100 2h2z",
            fill: "currentColor"
        })
    });



const $6b2ee614637bc724$export$2c21ffb4035a8a86 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M6 1.99h5v20H6c-1.1 0-2-.9-2-2v-16c0-1.1.9-2 2-2zM18 21.99h-5v-20h5c1.1 0 2 .9 2 2v16c0 1.1-.9 2-2 2z",
            fill: "currentColor"
        })
    });



const $7dcf7b8b8891b576$export$1ec59ff38f9eb8d9 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10.29 15.29L8 17.59V17a1 1 0 10-2 0v3a1 1 0 001 1h3a1 1 0 000-2h-.59l2.3-2.29a1.004 1.004 0 10-1.42-1.42zM8 19v-.07.07zM20 6a6 6 0 100 12 1 1 0 001-1V7a1 1 0 00-1-1zm-9 5H6.41l.3-.29a1.004 1.004 0 00-1.42-1.42l-2 2a1 1 0 000 1.42l2 2a1 1 0 001.639-.325 1 1 0 00-.22-1.095l-.3-.29H11a1 1 0 100-2zM9.41 5H10a1 1 0 100-2H7a1 1 0 00-1 1v3a1 1 0 002 0v-.59l2.29 2.3a1 1 0 001.42 0 .998.998 0 000-1.42L9.41 5z",
            fill: "currentColor"
        })
    });



const $0789fec50f955aa3$export$2f87d75dfbb9c961 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10 14H4a2 2 0 00-2 2v2a2 2 0 002 2h6a2 2 0 002-2v-2a2 2 0 00-2-2zm9-10H5a3 3 0 00-3 3v5.56A3.91 3.91 0 014 12h6a4 4 0 014 4v2a3.91 3.91 0 01-.56 2H19a3 3 0 003-3V7a3 3 0 00-3-3zm1 6a1 1 0 01-2 0v-.59l-2.29 2.3a1.002 1.002 0 01-1.639-.325 1 1 0 01.219-1.095L16.59 8H16a1 1 0 110-2h3a1 1 0 01.38.08 1 1 0 01.54.54c.051.12.078.25.08.38v3z",
            fill: "currentColor"
        })
    });



const $5a82ca2dcdee9945$export$bba130b76c67e5d8 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7 20H5a1 1 0 01-1-1v-2a1 1 0 10-2 0v2a3 3 0 003 3h2a1 1 0 000-2zm5-15a7 7 0 100 14 7 7 0 000-14zm2.13 7.69l-2.5 1.67a.86.86 0 01-.46.14.82.82 0 01-.4-.1.83.83 0 01-.44-.73v-3.34a.84.84 0 011.3-.69l2.5 1.67a.83.83 0 010 1.38zM19 2h-2a1 1 0 100 2h2a1 1 0 011 1v2a1 1 0 002 0V5a3 3 0 00-3-3z",
            fill: "currentColor"
        })
    });



const $e49cf87768220270$export$4386c467731795f3 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 19H4a1 1 0 000 2h16a1 1 0 000-2zm0-4H4a1 1 0 000 2h16a1 1 0 000-2zM18 3H6a3 3 0 00-3 3v4a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-3-3z",
            fill: "currentColor"
        })
    });



const $b9714ca3b2e6224a$export$425b6dcdc0d7b582 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 11a1 1 0 100 2 1 1 0 000-2zm0-9a10 10 0 100 20 10 10 0 000-20zm0 14a4 4 0 110-8 4 4 0 010 8z",
            fill: "currentColor"
        })
    });



const $0b5abd6c5b7902be$export$560b1486b0218c7a = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a1 1 0 00-1 1v18a1 1 0 002 0V3a1 1 0 00-1-1zM4 9a1 1 0 00-1 1v4a1 1 0 102 0v-4a1 1 0 00-1-1zm4-3a1 1 0 00-1 1v10a1 1 0 102 0V7a1 1 0 00-1-1zm12 3a1 1 0 00-1 1v4a1 1 0 002 0v-4a1 1 0 00-1-1zm-4-3a1 1 0 00-1 1v10a1 1 0 002 0V7a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $eb62f59765e6e878$export$a8b307e25bd67c8b = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M6.28 9.19c.4-.11.7-.47.72-.9.03-.6.35-1.16.83-1.51.45-.32.55-.95.23-1.39a.985.985 0 00-1.39-.23c-.99.71-1.6 1.81-1.67 3.02-.03.55.39 1.02.94 1.06.12 0 .23 0 .34-.04v-.01zM14 20h-4c-.55 0-1 .45-1 1s.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1zM6.83 3.9c.5-.24.71-.84.47-1.33a.996.996 0 00-1.33-.47 6.972 6.972 0 00-3.92 7.1c.06.55.56.94 1.11.88.06 0 .11-.02.16-.03.46-.13.77-.58.71-1.08-.24-2.11.88-4.15 2.8-5.07zM12 15a2.5 2.5 0 002.5-2.5v-6a2.5 2.5 0 00-5 0v6A2.5 2.5 0 0012 15zm5.5-3.5c-.55 0-1 .45-1 1 0 2.48-2.02 4.5-4.5 4.5s-4.5-2.02-4.5-4.5c0-.55-.45-1-1-1s-1 .45-1 1c0 3.58 2.92 6.5 6.5 6.5s6.5-2.92 6.5-6.5c0-.55-.45-1-1-1zm.53-9.4a.99.99 0 00-1.33.47.99.99 0 00.47 1.33c1.92.92 3.04 2.96 2.8 5.07-.06.49.25.94.71 1.08.05.02.11.03.16.03.55.06 1.04-.33 1.11-.88a7 7 0 00-3.92-7.11v.01zm-.71 3.05a.994.994 0 00-1.39.23.994.994 0 00.23 1.39c.49.35.8.91.83 1.51.03.44.32.79.72.9.11.03.22.04.34.04.55-.03.97-.5.94-1.06a3.988 3.988 0 00-1.67-3.02v.01z",
            fill: "currentColor"
        })
    });



const $4a7bd5a8107c94ff$export$33db1cf356ef2a79 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M3 16.38a2 2 0 001.3 1.87l6.7 2.51v-9.08l-8-3.2v7.9zm10-4.73v9.11l6.7-2.51a2 2 0 001.3-1.87V8.09l-8 3.56zm6.7-5.9l-7-2.62a2 2 0 00-1.4 0l-7 2.62a2 2 0 00-.93.72L12 9.92l8.38-3.73a2 2 0 00-.68-.44z",
            fill: "currentColor"
        })
    });



const $0bcf41f80f9baedc$export$6d0be57e00590597 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M8.5 7a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM4 10a1 1 0 001-1V6a1 1 0 011-1h3a1 1 0 000-2H6a3 3 0 00-3 3v3a1 1 0 001 1zm14-7h-3a1 1 0 100 2h3a1 1 0 011 1v3a1 1 0 002 0V6a3 3 0 00-3-3zm-1.79 6.29a1 1 0 00-1.41 0l-4.29 4.3-1.29-1.3a1 1 0 00-1.41 0L5 15.09V15a1 1 0 10-2 0v3a3 3 0 003 3h12a3 3 0 003-3v-3.5a1 1 0 00-.29-.71l-4.5-4.5z",
            fill: "currentColor"
        })
    });



const $32b7bb262719920f$export$50f698e223a2b318 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7 4h10a1 1 0 100-2H7a1 1 0 000 2zM5 8h14a1 1 0 100-2H5a1 1 0 000 2zm14 2H5a3 3 0 00-3 3v6a3 3 0 003 3h14a3 3 0 003-3v-6a3 3 0 00-3-3zm-4.45 6.83l-3 2A1 1 0 0110 18v-4a1 1 0 01.53-.88 1 1 0 011 .05l3 2a1 1 0 010 1.66h.02z",
            fill: "currentColor"
        })
    });



const $c675671766b2cc2e$export$53f5aab3f4b2ba22 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M8 21h3V3H8v18zM3 5v14a2 2 0 002 2h1V3H5a2 2 0 00-2 2zm10 16h3V3h-3v18zm6-18h-1v18h1a2 2 0 002-2V5a2 2 0 00-2-2z",
            fill: "currentColor"
        })
    });



const $7963ab46a1383998$export$faf2d09b0fa664b8 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4.89 11a1 1 0 00.71-.3A8.91 8.91 0 0112 8a8.73 8.73 0 014.05 1H16a1 1 0 100 2h3a1 1 0 001-1V7.41a1 1 0 10-2 0v.4A10.89 10.89 0 004.17 9.3a1 1 0 000 1.41 1 1 0 00.72.29zm17 1.51a1 1 0 00-1.36-.38L12 16.86l-8.51-4.73a1.004 1.004 0 00-1 1.74l9 5a1 1 0 001 0l9-5a1 1 0 00.38-1.36h.02z",
            fill: "currentColor"
        })
    });



const $b315a2a70603a95c$export$94c4607572978ecf = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M9 3H5a2 2 0 00-2 2v4a2 2 0 002 2h4a2 2 0 002-2V5a2 2 0 00-2-2zm0 10H5a2 2 0 00-2 2v4a2 2 0 002 2h4a2 2 0 002-2v-4a2 2 0 00-2-2zm12.16-7.41l-2.75-2.75a2 2 0 00-2.82 0l-2.75 2.75a2 2 0 000 2.82l2.75 2.75a2 2 0 002.82 0l2.75-2.75a2 2 0 000-2.82zM19 13h-4a2 2 0 00-2 2v4a2 2 0 002 2h4a2 2 0 002-2v-4a2 2 0 00-2-2z",
            fill: "currentColor"
        })
    });



const $f1f6def2f11c3851$export$88f04eef16409e4b = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M8.17 16.93A5 5 0 1114 12a1 1 0 002 0 7 7 0 10-8.17 6.9H8a1 1 0 001-.84 1 1 0 00-.83-1.13zm8-11.83a1 1 0 10-.35 1.97A5 5 0 1110 12a1 1 0 10-2 0 7 7 0 003.5 6.06A6.931 6.931 0 0015 19a7 7 0 001.17-13.9z",
            fill: "currentColor"
        })
    });



const $376ef59c2ee22ad2$export$c856eb2eb66cf6c2 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.94 20.62a1.19 1.19 0 00-.22-.33l-6.11-6.1a6.937 6.937 0 001.36-3.57c.12-1.29-.13-2.59-.71-3.75a6.944 6.944 0 00-2.58-2.82A7.012 7.012 0 0010.01 3c-1.11 0-2.2.26-3.19.77-.99.5-1.84 1.24-2.49 2.14-.65.9-1.08 1.94-1.24 3.04-.17 1.1-.07 2.22.28 3.27.35 1.05.95 2.01 1.74 2.79.79.78 1.76 1.36 2.82 1.69 1.06.33 2.18.41 3.28.22 1.09-.19 2.13-.63 3.01-1.3l6.1 6.11c.09.09.2.17.33.22.12.05.25.08.38.08s.26-.03.38-.08.23-.13.33-.22c.09-.09.17-.2.22-.33.05-.12.08-.25.08-.38s-.03-.26-.08-.38l-.02-.02zm-7.31-8.7A4.992 4.992 0 0110.01 15c-.66 0-1.31-.13-1.91-.38-.61-.25-1.16-.62-1.62-1.08-.46-.46-.83-1.02-1.08-1.62-.25-.61-.38-1.26-.38-1.91A4.992 4.992 0 018.1 5.39c.91-.38 1.92-.48 2.89-.28.97.19 1.86.67 2.56 1.37.7.7 1.18 1.59 1.37 2.56.19.97.09 1.98-.28 2.89l-.01-.01zM12 9.01h-1v-1c0-.55-.45-1-1-1s-1 .45-1 1v1H8c-.55 0-1 .45-1 1s.45 1 1 1h1v1c0 .55.45 1 1 1s1-.45 1-1v-1h1c.55 0 1-.45 1-1s-.45-1-1-1z",
            fill: "currentColor"
        })
    });



const $0a2c38a347b8637b$export$b6b883b2a780dc7a = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.94 20.62a1.19 1.19 0 00-.22-.33l-6.11-6.1a6.937 6.937 0 001.36-3.57c.12-1.29-.13-2.59-.71-3.75a6.944 6.944 0 00-2.58-2.82A7.012 7.012 0 0010.01 3c-1.11 0-2.2.26-3.19.77-.99.5-1.84 1.24-2.49 2.14-.65.9-1.08 1.94-1.24 3.04-.17 1.1-.07 2.22.28 3.27.35 1.05.95 2.01 1.74 2.79.79.78 1.76 1.36 2.82 1.69 1.06.33 2.18.41 3.28.22 1.09-.19 2.13-.63 3.01-1.3l6.1 6.11c.09.09.2.17.33.22.12.05.25.08.38.08s.26-.03.38-.08.23-.13.33-.22c.09-.09.17-.2.22-.33.05-.12.08-.25.08-.38s-.03-.26-.08-.38l-.02-.02zm-7.31-8.7A4.992 4.992 0 0110.01 15c-.66 0-1.31-.13-1.91-.38-.61-.25-1.16-.62-1.62-1.08-.46-.46-.83-1.02-1.08-1.62-.25-.61-.38-1.26-.38-1.91A4.992 4.992 0 018.1 5.39c.91-.38 1.92-.48 2.89-.28.97.19 1.86.67 2.56 1.37.7.7 1.18 1.59 1.37 2.56.19.97.09 1.98-.28 2.89l-.01-.01zM12 9.01H8c-.55 0-1 .45-1 1s.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1z",
            fill: "currentColor"
        })
    });



const $124382f9889a91e5$export$6466d4125a6ffc99 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4.82 11.04c.37.16.79.2 1.2.11.41-.09.77-.28 1.06-.57.29-.29.49-.65.57-1.06.08-.41.04-.82-.11-1.2s-.42-.7-.76-.93c-.34-.23-.75-.35-1.15-.35h-.01c-.55.01-1.08.23-1.47.61-.38.38-.6.91-.6 1.47 0 .42.12.81.35 1.15.22.33.55.6.93.76l-.01.01zM5.63 12.21c-.97 0-1.89.41-2.57 1.14-.68.74-1.06 1.73-1.06 2.76 0 .35.12.68.35.93.23.25.53.38.85.38h4.84c.32 0 .62-.14.85-.38.23-.25.35-.58.35-.93 0-1.04-.38-2.03-1.06-2.76-.69-.73-1.6-1.14-2.57-1.14h.02zM12.36 11.18c-.28 0-.54.1-.74.3-.19.2-.3.46-.3.74v4.16c0 .28.1.54.3.74.2.19.46.3.74.3.28 0 .54-.1.74-.3.19-.2.3-.46.3-.74v-4.16c0-.28-.1-.54-.3-.74-.2-.19-.46-.3-.74-.3zM16.54 11.18c-.28 0-.54.1-.74.3-.19.2-.3.46-.3.74v4.16c0 .28.1.54.3.74.2.19.46.3.74.3.28 0 .54-.1.74-.3.19-.2.3-.46.3-.74v-4.16c0-.28-.1-.54-.3-.74-.2-.19-.46-.3-.74-.3zM20.7 11.18c-.28 0-.54.1-.74.3-.19.2-.3.46-.3.74v4.16c0 .28.1.54.3.74.2.19.46.3.74.3.28 0 .54-.1.74-.3.19-.2.3-.46.3-.74v-4.16c0-.28-.1-.54-.3-.74-.2-.19-.46-.3-.74-.3zM12.15 10.15h8.81c1.24 0 1.43-1.78.24-2.05l-3.94-.91c-.46-.1-.95-.1-1.4 0h-.01l-3.94.91c-1.21.28-1 2.05.24 2.05z",
            fill: "currentColor"
        })
    });



const $6301646df2797f65$export$cadcc48a976067cd = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 19h-2v-9h1a2 2 0 00.79-3.84l-7-3a2.06 2.06 0 00-1.58 0l-7 3A2 2 0 005 10h1v9H4a1 1 0 000 2h16a1 1 0 100-2zm-4 0h-3v-9h3v9zm-8-9h3v9H8v-9z",
            fill: "currentColor"
        })
    });



const $54cc7c9d65d36108$export$66c7e2df2a0eeea2 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.63 6.1l-9-3a2.08 2.08 0 00-1.26 0l-9 3A2 2 0 003 10v9a1 1 0 000 2h18a1 1 0 100-2v-9a2 2 0 00.63-3.9zM11 10v9H9v-9h2zm2 0h2v9h-2v-9zm-8 0h2v9H5v-9zm14 9h-2v-9h2v9z",
            fill: "currentColor"
        })
    });



const $577470741c8213b1$export$a4711fa638990f82 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 7h4a2 2 0 00-.59-1.41l-3-3A2 2 0 0015 2v4a1 1 0 001 1zm-2.12 1.12A3 3 0 0113 6V2H6.5A2.49 2.49 0 004 4.5v15A2.49 2.49 0 006.5 22h11a2.49 2.49 0 002.5-2.5V9h-4a3 3 0 01-2.12-.88zM14 14a3 3 0 01-1.11 2.33l1.56.78A1 1 0 0114 19a.929.929 0 01-.45-.11l-4-2A1 1 0 0110 15h1a1 1 0 100-2H9a1 1 0 110-2h5a1 1 0 010 2h-.18a3 3 0 01.18 1z",
            fill: "currentColor"
        })
    });



const $73e98e5eaa9d3409$export$22de42671c97ad79 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M5 8h1v1a1 1 0 002 0V8h1a1 1 0 000-2H8V5a1 1 0 00-2 0v1H5a1 1 0 000 2zm4.21 6.79a1 1 0 00-1.42 0l-.79.8-.79-.8a1.005 1.005 0 00-1.714.71c0 .266.106.522.294.71l.8.79-.8.79a1 1 0 00.325 1.639 1 1 0 001.095-.219l.79-.8.79.8a1 1 0 001.639-.325 1 1 0 00-.219-1.095l-.8-.79.8-.79a1 1 0 000-1.42zM15 8h4a1 1 0 100-2h-4a1 1 0 100 2zm5 3h-7V4a1 1 0 00-2 0v7H4a1 1 0 000 2h7v7a1 1 0 002 0v-7h7a1 1 0 000-2zm-1 6.5h-4a1 1 0 000 2h4a1 1 0 000-2zm0-3h-4a1 1 0 000 2h4a1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $a2a8d6e6455bc124$export$68415c15ac5d6fbc = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.12 2.88A3 3 0 0017 2H7a3 3 0 00-3 3v14a3 3 0 003 3h10a3 3 0 003-3V5a3 3 0 00-.88-2.12zm-3.49 15.75a1.218 1.218 0 01-.88.37 1.25 1.25 0 01-1.15-.77 1.27 1.27 0 01-.08-.72 1.3 1.3 0 011-1A1.25 1.25 0 0116 17.75a1.22 1.22 0 01-.37.88zm.08-5.92l-6 6a1 1 0 01-1.639-.325 1 1 0 01.219-1.095l6-6a1.004 1.004 0 111.42 1.42zM8 12.25A1.26 1.26 0 019.25 11a1.25 1.25 0 011.15.77c.096.227.124.477.08.72a1.3 1.3 0 01-1 1A1.25 1.25 0 018 12.25zM17 7a1 1 0 01-1 1H8a1 1 0 01-1-1V6a1 1 0 011-1h8a1 1 0 011 1v1z",
            fill: "currentColor"
        })
    });



const $56788a4a71963f46$export$88e6870732189f12 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M14.76 5H4a2 2 0 00-2 2v2h8.76l4-4zM22 9V7a2 2 0 00-1.62-2l.33-.33A1.005 1.005 0 0020 2.956a1.004 1.004 0 00-.71.294l-16 16a1 1 0 000 1.42.998.998 0 001.42 0L6.41 19H20a2 2 0 002-2v-6h-7.59l2-2H22zm-3 4a1 1 0 110 2 1 1 0 010-2zm-3 0a1 1 0 110 2 1 1 0 010-2zm-3 2a1 1 0 110-2 1 1 0 010 2zM2 11v6a2.2 2.2 0 00.11.64L8.76 11H2z",
            fill: "currentColor"
        })
    });



const $805421f391e54bf6$export$7a6dc42646a30141 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M2.07 7.93L4 15.14V6a3.82 3.82 0 01.07-.68l-.59.16a2 2 0 00-1.41 2.45zM8.71 4H8a2 2 0 00-2 2v7.59L8.29 5a3.87 3.87 0 01.42-1zm11.81 2.19l-7.84-2.12a2 2 0 00-2.46 1.42L7.07 17.37a2 2 0 001.41 2.44l7.84 2.12a2 2 0 002.46-1.42l3.15-11.88a2 2 0 00-1.41-2.44zM10 18a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $9e481594b426f35f$export$92901747d5923154 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 5H5a3 3 0 00-3 3v8a3 3 0 003 3h14a3 3 0 003-3V8a3 3 0 00-3-3zM9.25 8a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zm5.5 8a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5zm1-6.29l-6 6a1 1 0 01-1.639-.325 1 1 0 01.219-1.095l6-6a1.004 1.004 0 011.42 1.42z",
            fill: "currentColor"
        })
    });



const $2c6ca4ea0991b8b4$export$d9f0e3cfc4cfc7f4 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 4C6.48 4 2 7.58 2 12s4.48 8 10 8 10-3.58 10-8-4.48-8-10-8zm-6.12 8.82a1 1 0 01-1 .73 1.26 1.26 0 01-.28 0 1 1 0 01-.6-1.28.75.75 0 000-.54 1.003 1.003 0 011.93-.55 2.86 2.86 0 010 1.64h-.05zm3.85 1.1a1 1 0 01-1 .73.9.9 0 01-.28 0 1 1 0 01-.69-1.24 4.79 4.79 0 000-2.74 1.003 1.003 0 011.93-.55 7 7 0 010 3.84l.04-.04zM13.57 15a1 1 0 01-1 .73c-.09.01-.18.01-.27 0a.999.999 0 01-.69-1.24 8.89 8.89 0 000-4.94A1.018 1.018 0 0113.57 9a10.82 10.82 0 010 6zm3.84 1.1a1 1 0 01-1 .72c-.09.01-.18.01-.27 0a.999.999 0 01-.69-1.24 12.75 12.75 0 000-7.14 1 1 0 011.447-1.149 1 1 0 01.473.599 14.68 14.68 0 010 8.24l.04-.03z",
            fill: "currentColor"
        })
    });



const $8cf1c08370070b7a$export$3f4ad7b8a45f5fa3 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 9a2 2 0 100 4 2 2 0 000-4zm7-5H5a3 3 0 00-3 3v8a3 3 0 002 2.82V19a1 1 0 001 1h1a1 1 0 001-1v-1h10v1a1 1 0 001 1h1a1 1 0 001-1v-1.18A3 3 0 0022 15V7a3 3 0 00-3-3zm-1 8h-2.14a4 4 0 110-2H18a1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $052a3cfdc44c5428$export$9afe0ea97432fd0 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M6 16a1 1 0 01-.71-1.71L6.59 13H2v3a3 3 0 003 3h3v-4.59l-1.29 1.3A1 1 0 016 16zm6.71-1.71a1.002 1.002 0 01-.325 1.639 1 1 0 01-1.095-.219L10 14.41V19h9a3 3 0 003-3v-3H11.41l1.3 1.29zM19 5h-9v2.18A3 3 0 0113.82 11H22V8a3 3 0 00-3-3zm-7 5a1 1 0 00-2 0v1h1a1 1 0 001-1zM2 8v3h2.18A3 3 0 018 7.18V5H5a3 3 0 00-3 3zm5 1a1 1 0 000 2h1v-1a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $5326b4d66c3435af$export$90783931dd936f2d = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.02 6.29c-.28-.33-.66-.53-1.07-.57-1.83-.19-3.61-.72-5.26-1.55-.21-.11-.45-.16-.68-.16-.23 0-.47.05-.68.16C9.69 5 7.92 5.53 6.1 5.72c-.41.04-.81.23-1.09.54-.29.31-.46.72-.47 1.16v4.25c0 5.72 5.6 9.34 7.46 9.34 1.86 0 7.46-3.61 7.46-9.34V7.42c0-.41-.17-.82-.45-1.12h.01v-.01z",
            fill: "currentColor"
        })
    });



const $6bff985e4a1580a4$export$3912e35c750d2ed0 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 2H5a1 1 0 000 2v17a1 1 0 00.53.88 1 1 0 001-.05L9 20.2l2.45 1.63a1 1 0 001.11 0L15 20.2l2.44 1.63A1 1 0 0019 21V4a1 1 0 100-2zm-4.5 9a3.001 3.001 0 01-1.11 2.33l1.56.78A1 1 0 0114.5 16a.93.93 0 01-.45-.11l-4-2A1 1 0 0110.5 12h1a1 1 0 000-2h-2a1 1 0 010-2h5a1 1 0 110 2h-.18a3 3 0 01.18 1z",
            fill: "currentColor"
        })
    });



const $7a9c9a36036b96d0$export$8f5a853e37b3fc9a = (m)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...m,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 7h4a2 2 0 00-.59-1.41l-3-3A2 2 0 0015 2v4a1 1 0 001 1zm-2.12 1.12A3 3 0 0113 6V2H6.5A2.49 2.49 0 004 4.5v15A2.49 2.49 0 006.5 22h11a2.49 2.49 0 002.5-2.5V9h-4a3 3 0 01-2.12-.88zM8 18a1 1 0 110-2 1 1 0 010 2zm0-4a1 1 0 110-2 1 1 0 010 2zm4 4a1 1 0 110-2 1 1 0 010 2zm0-4a1 1 0 110-2 1 1 0 010 2zm4 4a1 1 0 110-2 1 1 0 010 2zm1-5a1 1 0 11-2 0 1 1 0 012 0z",
            fill: "currentColor"
        })
    });



const $87b2b0c44c8135f1$export$2af1e2079090d85a = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M8.53 6.55h6.95l.68-1.3c.07-.13.1-.27.1-.42 0-.15-.04-.29-.12-.42a.92.92 0 00-.31-.31.777.777 0 00-.42-.11h-1.7c-.21 0-.42.08-.58.23l-.7.62-.7-.65a.823.823 0 00-.58-.2H8.6c-.14 0-.29.04-.42.11s-.23.18-.31.31c-.08.13-.12.27-.12.42 0 .15.03.29.1.42l.68 1.3zM17.98 11.27h.01a8.38 8.38 0 00-2.43-3.02H8.45c-1.03.8-1.86 1.84-2.43 3.02a8.502 8.502 0 00-.82 3.78c0 .06.08 5.95 6.8 5.95s6.8-5.89 6.8-5.95c.03-1.31-.26-2.6-.82-3.78z",
            fill: "currentColor"
        })
    });



const $7acf1dececcef075$export$9dfa65e1676f4b8 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 7h1v1a1 1 0 002 0V7h1a1 1 0 100-2h-1V4a1 1 0 00-2 0v1h-1a1 1 0 100 2zm-3-1c.003-.336.036-.67.1-1H5a3 3 0 00-3 3v8a3 3 0 003 3h14a3 3 0 003-3v-6a5 5 0 01-8-4zm-3 5a3.001 3.001 0 01-1.11 2.33l1.56.78A1 1 0 0111 16a.93.93 0 01-.45-.11l-4-2A1 1 0 017 12h1a1 1 0 000-2H6a1 1 0 010-2h5a1 1 0 110 2h-.18a3 3 0 01.18 1z",
            fill: "currentColor"
        })
    });



const $ab718390f09bd0e0$export$bdda707c980472c0 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16.49 12a3.5 3.5 0 100-7 3.5 3.5 0 000 7zM19.71 14.89a.978.978 0 00-1.41 0l-2.53 2.53c-.38.38-.88.59-1.41.59h-3.35c-.55 0-1-.45-1-1s.45-1 1-1h2c.55 0 1-.45 1-1s-.45-1-1-1h-4c-1.1 0-2 .9-2 2h-2c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h9.35c1.07 0 2.07-.42 2.83-1.17l2.53-2.53a.996.996 0 000-1.41l-.01-.01z",
            fill: "currentColor"
        })
    });



const $a592412f01bd1c1d$export$296403f38eee36b3 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 11a5 5 0 01-4.9-6H5a3 3 0 00-3 3v8a3 3 0 003 3h14a3 3 0 003-3v-6a5 5 0 01-3 1zm-8 0a3.001 3.001 0 01-1.11 2.33l1.56.78A1 1 0 0111 16a.929.929 0 01-.45-.11l-4-2A1 1 0 017 12h1a1 1 0 100-2H6a1 1 0 110-2h5a1 1 0 110 2h-.18a3 3 0 01.18 1zm5.29-4.29l2 2a1.004 1.004 0 001.42-1.42l-.3-.29H21a1 1 0 100-2h-1.59l.3-.29a1.001 1.001 0 00-1.094-1.636 1 1 0 00-.326.216l-2 2a1 1 0 00-.21.33.92.92 0 000 .76 1 1 0 00.21.33z",
            fill: "currentColor"
        })
    });



const $b12aa16f67f40b38$export$42329295ab1d936b = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 7h1.59l-.3.29a1 1 0 00.325 1.64 1 1 0 001.095-.22l2-2a1 1 0 00.21-.33 1 1 0 000-.76 1 1 0 00-.21-.33l-2-2a1.003 1.003 0 10-1.42 1.42l.3.29H17a1 1 0 100 2zm2 4a5 5 0 01-4.9-6H5a3 3 0 00-3 3v8a3 3 0 003 3h14a3 3 0 003-3v-6a5 5 0 01-3 1zm-8 0a3.001 3.001 0 01-1.11 2.33l1.56.78A1 1 0 0111 16a.93.93 0 01-.45-.11l-4-2A1 1 0 017 12h1a1 1 0 000-2H6a1 1 0 010-2h5a1 1 0 110 2h-.18a3 3 0 01.18 1z",
            fill: "currentColor"
        })
    });



const $edfeeda1864e85e5$export$f10f4942674b32ef = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18.29 8.71a.93.93 0 00.33.21 1 1 0 00.76 0 1.15 1.15 0 00.33-.21l2-2A1.005 1.005 0 0021 4.996a1.004 1.004 0 00-.71.294l-.29.3V4a1 1 0 00-2 0v1.59l-.29-.3a1 1 0 00-1.639.325 1 1 0 00.219 1.095l2 2zM19 11a5 5 0 01-4.9-6H5a3 3 0 00-3 3v8a3 3 0 003 3h14a3 3 0 003-3v-6a5 5 0 01-3 1zm-8 0a3.001 3.001 0 01-1.11 2.33l1.56.78A1 1 0 0111 16a.93.93 0 01-.45-.11l-4-2A1 1 0 017 12h1a1 1 0 000-2H6a1 1 0 010-2h5a1 1 0 110 2h-.18a3 3 0 01.18 1z",
            fill: "currentColor"
        })
    });



const $3fab72599a269e08$export$6968d65f3058d1bc = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M11 5h2a2 2 0 002-2 1 1 0 00-1-1h-4a1 1 0 00-1 1 2 2 0 002 2zm8 13.28V14a7 7 0 00-5-6.71V7a1 1 0 00-1-1h-2a1 1 0 00-1 1v.29A7 7 0 005 14v4.28A2 2 0 004 20a2 2 0 002 2h12a2 2 0 002-2 2 2 0 00-1-1.72zM14.5 14a3.001 3.001 0 01-1.11 2.33l1.56.78A1 1 0 0114.5 19a.93.93 0 01-.45-.11l-4-2A1 1 0 0110.5 15h1a1 1 0 000-2h-2a1 1 0 010-2h5a1 1 0 010 2h-.18a3 3 0 01.18 1z",
            fill: "currentColor"
        })
    });



const $27e4ae5cc663a095$export$6f3401e3bcdc014b = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M22 10.07a1.53 1.53 0 00-.48-.76L13.85 2.7a2.79 2.79 0 00-3.7 0L2.53 9.31A1.53 1.53 0 002.08 11c.098.29.283.54.53.72.242.187.535.295.84.31H4v7a3 3 0 003 3h10a3 3 0 003-3V12h.55a1.49 1.49 0 00.84-.31c.247-.18.432-.43.53-.72a1.54 1.54 0 00.08-.9zM14.5 14a3.001 3.001 0 01-1.11 2.33l1.56.78A1 1 0 0114.5 19a.93.93 0 01-.45-.11l-4-2A1 1 0 0110.5 15h1a1 1 0 000-2h-2a1 1 0 010-2h5a1 1 0 110 2h-.18a3 3 0 01.18 1z",
            fill: "currentColor"
        })
    });



const $7bdb77dac1d8b992$export$cb69cd506dde2c09 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zM9.25 8a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zm5.5 8a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5zm1-6.29l-6 6a1 1 0 01-1.639-.325 1 1 0 01.219-1.095l6-6a1.004 1.004 0 011.42 1.42z",
            fill: "currentColor"
        })
    });



const $f65f9da3ac1cbe52$export$18ea7426c9e309c = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M13.57 21a1.7 1.7 0 012.43-.82 1.71 1.71 0 002.54-1.84 1.71 1.71 0 011.51-2.08 1.7 1.7 0 001-3 1.71 1.71 0 010-2.56 1.7 1.7 0 00-1-3 1.71 1.71 0 01-1.51-2.08A1.71 1.71 0 0016 3.82 1.7 1.7 0 0113.57 3a1.71 1.71 0 00-3.14 0A1.7 1.7 0 018 3.82a1.71 1.71 0 00-2.54 1.84A1.71 1.71 0 014 7.74a1.7 1.7 0 00-1 3 1.71 1.71 0 010 2.56 1.7 1.7 0 001 3 1.71 1.71 0 011.51 2.08A1.71 1.71 0 008 20.18a1.701 1.701 0 012.43.79 1.71 1.71 0 003.14.03zM9.25 8a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zm5.5 8a1.25 1.25 0 110-2.501 1.25 1.25 0 010 2.501zm1-6.29l-6 6a.998.998 0 01-1.42 0 .999.999 0 010-1.42l6-6a1.004 1.004 0 011.42 1.42z",
            fill: "currentColor"
        })
    });



const $f08d2fe60f36d25b$export$75254632714e6af = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.7 5.75l-7-2.62a2 2 0 00-1.4 0l-7 2.62a1.71 1.71 0 00-.23.13L12 8.93l7.93-3a1.708 1.708 0 00-.23-.18zM3 7.62v8.76a2 2 0 001.3 1.87l6.7 2.51V10.69L3 7.61v.01zm18 0l-8 3.08v10.06l6.7-2.51a2 2 0 001.3-1.87V7.62z",
            fill: "currentColor"
        })
    });



const $b92d64e8ea5669a2$export$f3324ee39619d326 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M14.54 3.88l-2.19-.82a1.05 1.05 0 00-.7 0L4 5.93l2.66 1 7.88-3.05zm-6.91 9.34a1 1 0 01-2 0V8.68L3 7.69V17a1 1 0 00.65.94L11 20.69v-10L7.63 9.43v3.79zm9.73-8.28L9.48 8l2.52.93 8-3-2.64-.99zM13 10.69v10l7.35-2.75A1 1 0 0021 17V7.69l-8 3z",
            fill: "currentColor"
        })
    });



const $1b1ddce7cb4c5255$export$9dd2dbe7f9908a2 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 2H7a3 3 0 00-3 3v14a3 3 0 003 3h10a3 3 0 003-3V5a3 3 0 00-3-3zm-5 4a3 3 0 110 6 3 3 0 010-6zm3 12H9a1 1 0 010-2h6a1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $2570c2371d56b233$export$9f28609a41dcf718 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 2H7a3 3 0 00-3 3v14a3 3 0 003 3h10a3 3 0 003-3V5a3 3 0 00-3-3zM9.5 6h5a1 1 0 110 2h-.18a3 3 0 01-.93 3.33l1.56.78A1 1 0 0114.5 14a.93.93 0 01-.45-.11l-4-2A1 1 0 0110.5 10h1a1 1 0 100-2h-2a1 1 0 010-2zM15 19H9a1 1 0 010-2h6a1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $a0a1dec51b2eb323$export$80990643fd07f265 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M11.68 12.46l-3.13-1.57A1 1 0 019 9h1a1 1 0 100-2H8a1 1 0 010-2h5a1 1 0 110 2h-.18a3 3 0 01-.93 3.33l1.44.72a6.949 6.949 0 016.67-.37V5a3 3 0 00-3-3H7a3 3 0 00-3 3v14a3 3 0 003 3h5.11a7 7 0 01-.43-9.54zM17 12a5 5 0 100 10 5 5 0 000-10zm1.5 6a1 1 0 01-1 1h-2a1 1 0 010-2h1v-1.5a1 1 0 012 0V18z",
            fill: "currentColor"
        })
    });



const $8d3c1b646c7fdc1b$export$69cb30f368eaaafe = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 5H5a3 3 0 00-3 3v8a3 3 0 003 3h14a3 3 0 003-3V8a3 3 0 00-3-3zM8 8a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm2 8H6a1 1 0 01-1-1 3 3 0 016 0 1 1 0 01-1 1zm8-6h-.18a3 3 0 01-.93 3.33l1.56.78A1 1 0 0118 16a.93.93 0 01-.45-.11l-4-2A1 1 0 0114 12h1a1 1 0 000-2h-2a1 1 0 110-2h5a1 1 0 110 2z",
            fill: "currentColor"
        })
    });



const $b6d48599a2e14025$export$47cda29aed194ead = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15.5 9a1 1 0 00-1-1h-5a1 1 0 000 2h2a1 1 0 110 2h-1a1 1 0 00-.45 1.89l4 2a.931.931 0 00.45.11 1 1 0 00.89-.55 1 1 0 00-.39-1.34l-1.56-.78a3 3 0 00.88-3.33h.18a1 1 0 001-1zM12 2A10 10 0 002 12c-.002.374.021.749.07 1.12a1.007 1.007 0 002-.24A8.493 8.493 0 014 12a8 8 0 112.73 6h.77a1 1 0 000-2h-3a1 1 0 00-1 1v3a1 1 0 002 0v-.43A10 10 0 1012 2z",
            fill: "currentColor"
        })
    });



const $b26d8ce75abb0691$export$5250b0ba24d5b00f = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.12 3.88A3 3 0 0018 3h-1a1 1 0 00-2 0H9a1 1 0 00-2 0H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-.88-2.12zM14.5 13a3.001 3.001 0 01-1.11 2.33l1.56.78A1 1 0 0114.5 18a.93.93 0 01-.45-.11l-4-2A1 1 0 0110.5 14h1a1 1 0 000-2h-2a1 1 0 010-2h5a1 1 0 010 2h-.18a3 3 0 01.18 1zM19 7H5V6a1 1 0 011-1h1a1 1 0 002 0h6a1 1 0 002 0h1a1 1 0 011 1v1z",
            fill: "currentColor"
        })
    });



const $69bd99f1e5710067$export$30677eb3476d3e6 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 3H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-3-3zm-3.14 7H16a1 1 0 010 2h-1.14a4 4 0 01-2.61 2.78l2.26 1.36a1 1 0 01-1.02 1.72l-5-3s-.06-.06-.09-.08a.67.67 0 01-.15-.14l-.11-.15a.999.999 0 01-.08-.18 1.18 1.18 0 010-.2L8 14v-.07a1.29 1.29 0 010-.19 1.07 1.07 0 01.07-.19v-.06c0-.06.06-.06.08-.09a.91.91 0 01.3-.26l.16-.08h.21L9 13h2a2 2 0 001.72-1H8a1 1 0 010-2h4.72A2 2 0 0011 9H8a1 1 0 010-2h8a1 1 0 110 2h-1.56c.187.312.328.649.42 1z",
            fill: "currentColor"
        })
    });



const $05203919c874ab28$export$436d474bc97dc429 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.12 3.88A3 3 0 0017 3h-1.28a2 2 0 00-.72-.73A2 2 0 0014 2h-4a2 2 0 00-1 .27 2 2 0 00-.72.73H7a3 3 0 00-3 3v13a3 3 0 003 3h10a3 3 0 003-3V6a3 3 0 00-.88-2.12zM14.5 14a3.001 3.001 0 01-1.11 2.33l1.56.78A1 1 0 0114.5 19a.93.93 0 01-.45-.11l-4-2A1 1 0 0110.5 15h1a1 1 0 000-2h-2a1 1 0 010-2h5a1 1 0 010 2h-.18a3 3 0 01.18 1zM18 8H6V6a1 1 0 011-1h1.28a2 2 0 00.72.73A2 2 0 0010 6h4a2 2 0 001-.27 2 2 0 00.72-.73H17a1 1 0 011 1v2z",
            fill: "currentColor"
        })
    });



const $1b70149b2cc5a2ee$export$56dd336bb2b5cb52 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17.07 8.06h-1.82c-.12-.44-.29-.86-.5-1.25h2.32c.77 0 1.4-.63 1.4-1.4 0-.77-.63-1.4-1.4-1.4H6.93c-.77 0-1.4.63-1.4 1.4 0 .77.63 1.4 1.4 1.4h3.04c.92 0 1.77.48 2.25 1.25H6.93c-.77 0-1.4.63-1.4 1.4 0 .77.63 1.4 1.4 1.4h5.29c-.47.75-1.28 1.22-2.15 1.25H6.93c-.49 0-.93.25-1.19.66-.39.61-.23 1.43.35 1.87l8.11 6.08c.25.18.54.28.84.28.07 0 .13 0 .2-.01.37-.05.7-.25.92-.55.22-.3.32-.67.27-1.04-.05-.37-.25-.7-.55-.92l-4.87-3.65a5.51 5.51 0 004.24-3.96h1.82c.77 0 1.4-.63 1.4-1.4 0-.77-.63-1.4-1.4-1.4v-.01z",
            fill: "currentColor"
        })
    });



const $9f79c586d715b209$export$d1447d983b832cf3 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M6.996 9.001a2.994 2.994 0 002.769-1.852 3.004 3.004 0 00-2.184-4.09 2.993 2.993 0 00-3.076 1.275 3.003 3.003 0 002.491 4.667zm10.987 6a2.994 2.994 0 00-2.768 1.852 3.004 3.004 0 00.65 3.27A2.994 2.994 0 0020.978 18a3.002 3.002 0 00-2.996-3zm-12.984 6h3.995a.998.998 0 00.706-1.707.998.998 0 00-.706-.293H7.306L20.71 4.681a1 1 0 000-1.41.999.999 0 00-.73-.27.998.998 0 00-.729.32L5.998 17.471v-1.47a1 1 0 00-1-1 .998.998 0 00-.998 1v4a1 1 0 00.999 1z",
            fill: "currentColor"
        })
    });



const $8098729f856ac62b$export$8efed9b992e6e673 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16.983 15a2.994 2.994 0 00-2.768 1.852 3.002 3.002 0 002.183 4.09 2.993 2.993 0 003.076-1.275 3.003 3.003 0 00-.372-3.788 2.994 2.994 0 00-2.12-.879zM5.996 9a2.994 2.994 0 002.769-1.852 3.003 3.003 0 00-2.184-4.09 2.993 2.993 0 00-3.076 1.275A3.003 3.003 0 005.996 9zM18.98 3h-3.995a.998.998 0 00-.706 1.707.998.998 0 00.706.293h1.688L3.27 19.32a1 1 0 000 1.41.997.997 0 00.729.27.998.998 0 00.729-.32L17.982 6.53V8a1 1 0 00.998 1 .998.998 0 001-1V4a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $ec6abc49fabd1e58$export$53337a0d65ca52a8 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 2H7a3 3 0 00-3 3v14a3 3 0 003 3h10a3 3 0 003-3V5a3 3 0 00-3-3zM8.37 6.37A1.22 1.22 0 019.25 6a1.25 1.25 0 011.15.77c.096.227.124.477.08.72a1.3 1.3 0 01-1 1A1.25 1.25 0 018 7.25a1.22 1.22 0 01.37-.88zm-.08 5.92l6-6a1.003 1.003 0 111.42 1.42l-6 6a1 1 0 01-1.639-.325 1 1 0 01.219-1.095zm7.71.46A1.26 1.26 0 0114.75 14a1.25 1.25 0 01-1.15-.77 1.27 1.27 0 01-.08-.72 1.3 1.3 0 011-1A1.25 1.25 0 0116 12.75zM16 19H8a1 1 0 010-2h8a1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $ef494185ca26e0c9$export$37823efd3361ff2c = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 2H7a3 3 0 00-3 3v14a3 3 0 003 3h10a3 3 0 003-3V5a3 3 0 00-3-3zm-5 4h4a1 1 0 110 2h-4a1 1 0 110-2zm4 12h-4a1 1 0 010-2h4a1 1 0 010 2zm0-5h-4a1 1 0 010-2h4a1 1 0 010 2zM9.5 7a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm0 5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm0 5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z",
            fill: "currentColor"
        })
    });



const $a16e798fcb7f8e05$export$cfcc821af8b708ca = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16.17 8A1 1 0 0116 8h-4a1 1 0 110-2h2.17a3 3 0 012-3.87.498.498 0 01.01-.13H7a3 3 0 00-3 3v14a3 3 0 003 3h10a3 3 0 003-3V9.83A3 3 0 0116.17 8zM8 18.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm0-5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm0-5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm8 9.5h-4a1 1 0 010-2h4a1 1 0 010 2zm0-5h-4a1 1 0 010-2h4a1 1 0 010 2zm5-9h-1V3a1 1 0 00-1-1 1 1 0 00-.92.62A.92.92 0 0018 3v1h-1a1 1 0 100 2h1v1a1 1 0 002 0V6h1a1 1 0 100-2z",
            fill: "currentColor"
        })
    });



const $a7cf27f91e2453e5$export$7c64c4e96609684e = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M13.77 3H6.23A3.12 3.12 0 003 6v12a3.12 3.12 0 003.23 3h7.54A3.12 3.12 0 0017 18V6a3.12 3.12 0 00-3.23-3zM7 6h2.5a1 1 0 110 2H7a1 1 0 010-2zm6 12H7a1 1 0 010-2h6a1 1 0 110 2zm0-5H7a1 1 0 010-2h6a1 1 0 110 2zm5.66-9c.284.628.427 1.31.42 2v12a4.749 4.749 0 01-.42 2A2.71 2.71 0 0021 17.28V6.72A2.71 2.71 0 0018.66 4z",
            fill: "currentColor"
        })
    });



const $f9e52a5554bbafce$export$c6454d0b03c576ba = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10 13a1 1 0 001 1h8a1 1 0 001-1v-2H10v2zm9-6h-8a1 1 0 00-1 1v1h10V8a1 1 0 00-1-1zM8 13V8a3 3 0 013-3h4.82A3 3 0 0013 3H7a3 3 0 00-3 3v13a3 3 0 003 3h6a3 3 0 003-3v-3h-5a3 3 0 01-3-3zm2 7a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $97d7a75bd13e67a2$export$401621e6261f8045 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 7h1v1a1 1 0 002 0V7h1a1 1 0 100-2h-1V4a1 1 0 00-2 0v1h-1a1 1 0 100 2zm-.24 3.47a4.89 4.89 0 01-2-1.84A5 5 0 0114 6c.003-.336.037-.67.1-1H5a3 3 0 00-3 3v8a3 3 0 003 3h14a3 3 0 003-3v-6a5 5 0 01-5.24.47zm-9.82-2a1.5 1.5 0 012.45.49c.111.272.139.572.08.86A1.49 1.49 0 018.29 11a1.49 1.49 0 01-.86-.08 1.5 1.5 0 01-.49-2.45zm3.77 7.27A1 1 0 0110 16H6a1 1 0 01-1-1 3 3 0 016 0 1 1 0 01-.29.71v.03z",
            fill: "currentColor"
        })
    });



const $f169b18fe84ab707$export$3e7afaed2f91d59c = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 12a5 5 0 100 10 5 5 0 000-10zm1.5 6a1 1 0 01-1 1h-2a1 1 0 010-2h1v-1.5a1 1 0 012 0V18zM19 5H5a3 3 0 00-3 3v8a3 3 0 003 3h5.29a6.909 6.909 0 01-.29-2 7.241 7.241 0 01.18-1.56.35.35 0 01-.13 0l-4-2a1 1 0 01.45-1.94h1a1 1 0 000-2h-2a1 1 0 010-2h5a1 1 0 110 2h-.18a3 3 0 01-.93 3.33l1.51.75A6.998 6.998 0 0122 12.11V8a3 3 0 00-3-3z",
            fill: "currentColor"
        })
    });



const $63659a9635b84e8a$export$c005cd689b2dd649 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7.71 11.29a1 1 0 00-1.42 0l-.22.22a6 6 0 0110.22-3.75 1.004 1.004 0 101.42-1.42 8 8 0 00-13.64 5.31l-.36-.36a1.004 1.004 0 10-1.42 1.42l2 2a1.001 1.001 0 001.42 0l2-2a1 1 0 000-1.42zm14 0l-2-2a1 1 0 00-1.42 0l-2 2a1.005 1.005 0 001.42 1.42l.27-.27A6 6 0 0112 18a5.931 5.931 0 01-4.24-1.76 1.004 1.004 0 10-1.42 1.42A8 8 0 0020 12.39l.31.32a1.002 1.002 0 001.42 0 1 1 0 00-.02-1.42z",
            fill: "currentColor"
        })
    });



const $234fba4fa6a8fa0a$export$c5528b722e184d2a = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.74 5.68l1-1a1.005 1.005 0 00-.71-1.714 1.004 1.004 0 00-.71.294l-16 16a.999.999 0 000 1.42 1.001 1.001 0 001.42 0l1-1c.1.08.19.18.3.26H6a9.9 9.9 0 006 2 10.001 10.001 0 007.74-16.26zM16 12h-1.14a4 4 0 01-2.61 2.78l2.26 1.36a1 1 0 01-1.02 1.72l-3.71-2.23L15.41 10H16a1 1 0 110 2zm-8.2 0a1.006 1.006 0 01.2-2h1.76l1-1H8a1 1 0 010-2h4.76l3.86-3.86A10 10 0 003.14 16.62L7.8 12z",
            fill: "currentColor"
        })
    });



const $a2e84076d7315a39$export$e07e25cc8874dfdf = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7.92 5h8.16l.8-1.53A1 1 0 0016 2h-2a1 1 0 00-.68.27L12.5 3l-.82-.76A1 1 0 0011 2H8a1 1 0 00-.88 1.47L7.92 5zm8.26 2H7.82A9.9 9.9 0 004 15c0 .07.09 7 8 7s8-6.93 8-7a9.9 9.9 0 00-3.82-8zm-1.68 6a3 3 0 01-1.11 2.33l1.56.78A1 1 0 0114.5 18a.93.93 0 01-.45-.11l-4-2A1 1 0 0110.5 14h1a1 1 0 100-2h-2a1 1 0 110-2h5a1 1 0 110 2h-.18c.117.32.177.659.18 1z",
            fill: "currentColor"
        })
    });



const $9d23a76e76262d27$export$c493c09cdef2d22 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 6h-2a4 4 0 10-8 0H6a2 2 0 00-2 2v11a3 3 0 003 3h10a3 3 0 003-3V8a2 2 0 00-2-2zm-8 0a2 2 0 114 0h-4z",
            fill: "currentColor"
        })
    });



const $f51f24f6bceff017$export$7e96b0e025595de2 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 6h-2a4 4 0 10-8 0H6a2 2 0 00-2 2v11a3 3 0 003 3h10a3 3 0 003-3V8a2 2 0 00-2-2zm-6-2a2 2 0 012 2h-4a2 2 0 012-2zm.76 13.1l-.2.18a.82.82 0 01-1.12 0l-.2-.18c-1.86-1.71-3-3-3-4.36a2.21 2.21 0 012.23-2.24 2.31 2.31 0 011.48.6 2.31 2.31 0 011.48-.6 2.21 2.21 0 012.23 2.24c.05 1.38-1.04 2.65-2.9 4.36z",
            fill: "currentColor"
        })
    });



const $5eecf5d6a0506f73$export$fe5ac61676d09a0a = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.57 9.76A2 2 0 0020 9h-1.4l-2.74-4.51a1 1 0 00-1.72 1L16.23 9H7.77l2.09-3.49a1 1 0 00-1.72-1L5.43 9H4a2 2 0 00-1.98 2.44l1.42 6.22a3 3 0 003 2.34h11.1a3 3 0 003-2.34L22 11.44a2.001 2.001 0 00-.43-1.68z",
            fill: "currentColor"
        })
    });



const $a0f8755a55c1595c$export$e8605d5b4960c93c = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 20H5a1 1 0 000 2h14a1 1 0 000-2zm-1-7h-2a3 3 0 01-3-3v-.14a4 4 0 10-2 0V10a3 3 0 01-3 3H6a2 2 0 00-2 2v1a2 2 0 002 2h12a2 2 0 002-2v-1a2 2 0 00-2-2z",
            fill: "currentColor"
        })
    });



const $a779af3bcc5a6af8$export$51a4821d7a77d279 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.12 5.88l-2.55-2.35A2 2 0 0017.22 3H6.78a2 2 0 00-1.35.53L2.88 5.88a3 3 0 004.24 4.24c.076-.082.146-.169.21-.26a3 3 0 004.67 0 3 3 0 004.67 0c.065.091.135.178.21.26a3 3 0 104.24-4.24zM7.34 12.42a5 5 0 01-4.34.16V18a3 3 0 003 3h5v-8.19a4.91 4.91 0 01-3.66-.39zm9.32 0a4.91 4.91 0 01-3.66.39V15h2a1 1 0 010 2h-2v4h5a3 3 0 003-3v-5.42a5 5 0 01-4.34-.16z",
            fill: "currentColor"
        })
    });



const $9d4021dbc2123a83$export$b748b587f66e1a5b = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 2H7a3 3 0 00-3 3v14a3 3 0 003 3h10a3 3 0 003-3V5a3 3 0 00-3-3zM8.79 7.29a1 1 0 011.42 0l.79.8 2.79-2.8a1.003 1.003 0 111.42 1.42l-3.5 3.5a1.002 1.002 0 01-1.42 0l-1.5-1.5a1 1 0 010-1.42zM15.5 19h-7a1 1 0 010-2h7a1 1 0 010 2zm0-4h-7a1 1 0 010-2h7a1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $114e1debbd891287$export$a53a6d565c29f6ec = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18.66 4c.284.628.427 1.31.42 2v12a4.749 4.749 0 01-.42 2A2.71 2.71 0 0021 17.28V6.72A2.71 2.71 0 0018.66 4zM15 2H6a3 3 0 00-3 3v14a3 3 0 003 3h9a3 3 0 003-3V5a3 3 0 00-3-3zM7.29 7.29a1 1 0 011.42 0l.79.8 2.79-2.8a1.003 1.003 0 111.42 1.42l-3.5 3.5a1.002 1.002 0 01-1.42 0l-1.5-1.5a1 1 0 010-1.42zM14 19H7a1 1 0 010-2h7a1 1 0 010 2zm0-4H7a1 1 0 010-2h7a1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $ea12cea82e101df2$export$89d584422e9f53c0 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 2a1 1 0 00-1 1v1a1 1 0 002 0V3a1 1 0 00-1-1zm-5 3a5 5 0 011-3H7a3 3 0 00-3 3v14a3 3 0 003 3h10a3 3 0 003-3V9.9A5 5 0 0114 5zm.5 9a3.001 3.001 0 01-1.11 2.33l1.56.78A1 1 0 0114.5 19a.93.93 0 01-.45-.11l-4-2A1 1 0 0110.5 15h1a1 1 0 000-2h-2a1 1 0 010-2h5a1 1 0 010 2h-.18a3 3 0 01.18 1zm3.79-7.71A1 1 0 0018 7c.002.13.029.26.08.38.05.121.122.233.21.33.097.088.209.16.33.21a.94.94 0 00.76 0 1.15 1.15 0 00.33-.21A1 1 0 0020 7a1 1 0 00-1.71-.71z",
            fill: "currentColor"
        })
    });



const $11b7c1a3322ff6b1$export$6b428d4c0f5527e5 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M14 5a5 5 0 011-3H7a3 3 0 00-3 3v14a3 3 0 003 3h10a3 3 0 003-3V9.9A5 5 0 0114 5zm.5 9a3.001 3.001 0 01-1.11 2.33l1.56.78A1 1 0 0114.5 19a.93.93 0 01-.45-.11l-4-2A1 1 0 0110.5 15h1a1 1 0 000-2h-2a1 1 0 010-2h5a1 1 0 010 2h-.18a3 3 0 01.18 1zm5-12a1 1 0 00-1 1v2h-1a1 1 0 100 2h2a1 1 0 001-1V3a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $31c91ac6ede51752$export$d12eedeb76804f3a = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.41 5l.71-.71a1 1 0 00-1.41-1.41l-.71.71-.71-.71a1 1 0 00-1.41 1.41l.71.71-.71.71a1 1 0 000 1.41 1 1 0 001.41 0l.71-.71.71.71a1 1 0 001.41 0 1 1 0 000-1.41L20.41 5zM14 5a5 5 0 011-3H7a3 3 0 00-3 3v14a3 3 0 003 3h10a3 3 0 003-3V9.9A5 5 0 0114 5zm.5 9a3.001 3.001 0 01-1.11 2.33l1.56.78A1 1 0 0114.5 19a.93.93 0 01-.45-.11l-4-2A1 1 0 0110.5 15h1a1 1 0 000-2h-2a1 1 0 010-2h5a1 1 0 010 2h-.18a3 3 0 01.18 1z",
            fill: "currentColor"
        })
    });



const $034fb9d845020e13$export$e6efd41ef4148c99 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 7a2 2 0 100-4 2 2 0 000 4zm2.69 8.06a1 1 0 00-1.41 0l-2.17 2.28a1.999 1.999 0 01-1.45.62H12a1 1 0 010-2h2.66a1 1 0 000-2H8a2 2 0 00-2 2H4a1 1 0 00-1 1v2a1 1 0 001 1h11.66a4 4 0 002.89-1.24l2.17-2.28a1 1 0 00-.03-1.38zM14 12a2 2 0 100-4 2 2 0 000 4z",
            fill: "currentColor"
        })
    });



const $1c0780fb834358fe$export$f7aa4db7c8068f00 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 12a5 5 0 100 10 5 5 0 000-10zm1.5 6a1 1 0 01-1 1h-2a1 1 0 010-2h1v-1.5a1 1 0 012 0V18zM8 18a1 1 0 010-2h2.08a7 7 0 011.18-3H8a1 1 0 010-2h5.41A7 7 0 0117 10a6.88 6.88 0 013 .69V5a3 3 0 00-3-3H7a3 3 0 00-3 3v14a3 3 0 003 3h5.11a7 7 0 01-2-4H8zM8 6h3a1 1 0 110 2H8a1 1 0 010-2z",
            fill: "currentColor"
        })
    });



const $3b19355bacdb7fd9$export$354ae60bd9a5cced = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 5H5a3 3 0 00-3 3v8a3 3 0 003 3h14a3 3 0 003-3V8a3 3 0 00-3-3zM6 16a1 1 0 110-2 1 1 0 010 2zm5-1a1 1 0 01-2 0v-2a1 1 0 112 0v2zm4 0a1 1 0 01-2 0v-4a1 1 0 012 0v4zm4 0a1 1 0 01-2 0V9a1 1 0 012 0v6z",
            fill: "currentColor"
        })
    });



const $b2cc52df1fa9ad06$export$1891302a2a5cf17d = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 5H5a3 3 0 00-3 3v8a3 3 0 003 3h14a3 3 0 003-3V8a3 3 0 00-3-3zm-8 6a3.001 3.001 0 01-1.11 2.33l1.56.78A1 1 0 0111 16a.93.93 0 01-.45-.11l-4-2A1 1 0 017 12h1a1 1 0 000-2H6a1 1 0 010-2h5a1 1 0 110 2h-.18a3 3 0 01.18 1zm6 6a1 1 0 110-2 1 1 0 010 2zm0-4a1 1 0 110-2 1 1 0 010 2zm0-4a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $dd43bed12e0db215$export$7f35373838b28a0d = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 5H5a3 3 0 00-3 3v8a3 3 0 003 3h14a3 3 0 003-3V8a3 3 0 00-3-3zM5.37 8.37A1.22 1.22 0 016.25 8a1.25 1.25 0 011.15.77c.096.227.124.477.08.72a1.3 1.3 0 01-1 1A1.25 1.25 0 015 9.25a1.22 1.22 0 01.37-.88zm7.26 7.26a1.218 1.218 0 01-.88.37 1.25 1.25 0 01-1.15-.77 1.27 1.27 0 01-.08-.72 1.3 1.3 0 011-1A1.25 1.25 0 0113 14.75a1.22 1.22 0 01-.37.88zm.08-5.92l-6 6a1 1 0 01-1.639-.325 1 1 0 01.219-1.095l6-6a1.004 1.004 0 011.42 1.42zM17 17a1 1 0 110-2 1 1 0 010 2zm0-4a1 1 0 110-2 1 1 0 010 2zm0-4a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $f506deba3861dc26$export$dd0665241bcd5000 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 12a2 2 0 002 2h3v-4h-3a2 2 0 00-2 2zm2-8H5a3 3 0 00-3 3v10a3 3 0 003 3h14a3 3 0 003-3v-1h-3a4 4 0 110-8h3V7a3 3 0 00-3-3z",
            fill: "currentColor"
        })
    });



const $9a04dbecb918105f$export$826613f4ee58a24c = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17.28 5H6.72C5.22 5 4 6.22 4 7.72v8.56C4 17.78 5.22 19 6.72 19h10.56c1.5 0 2.72-1.22 2.72-2.72V7.72C20 6.22 18.78 5 17.28 5zm.72 8h-3.15c-.42 0-.82.24-.95.63a2.001 2.001 0 01-3.8 0c-.13-.39-.54-.63-.95-.63H6v-1c0-.55.45-1 1-1h10c.55 0 1 .45 1 1v1zm0-4H6V8c0-.55.45-1 1-1h10c.55 0 1 .45 1 1v1z",
            fill: "currentColor"
        })
    });



const $eb81b7715b49d6bf$export$7beb1f3b8ec9cf06 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M8.71 11.29a1.004 1.004 0 10-1.42 1.42l3 3a.999.999 0 001.42 0l10-10a1.004 1.004 0 00-1.42-1.42L11 13.59l-2.29-2.3zM20.83 10a1 1 0 00-.83 1.12c.015.293.015.587 0 .88a8 8 0 11-8-8 7.82 7.82 0 013.55.84 1.002 1.002 0 00.9-1.79A9.84 9.84 0 0012 2a10 10 0 1010 10 8.323 8.323 0 00-.07-1.12 1 1 0 00-1.1-.88z",
            fill: "currentColor"
        })
    });



const $68b784db152def2c$export$8dd0e13f59c26d7 = (c)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M18.91 6.03a7.92 7.92 0 00-2.8-2.889 7.959 7.959 0 00-3.858-1.138 7.827 7.827 0 00-3.918.91 7.978 7.978 0 00-2.968 2.711 7.889 7.889 0 00-1.257 3.83 7.913 7.913 0 003.423 6.995l-.465 3.095c-.05.376 0 .762.169 1.108.158.347.415.633.742.841.326.198.702.307 1.078.307.386 0 .752-.119 1.068-.336l1.89-1.247 1.87 1.247a1.967 1.967 0 002.157.03c.326-.209.583-.505.742-.852.158-.356.217-.741.158-1.127l-.445-3.097a7.822 7.822 0 002.513-2.82 8.007 8.007 0 00.92-3.67 7.87 7.87 0 00-1.02-3.888v-.01zm-2.701 8.093a5.923 5.923 0 01-4.195 1.741 5.895 5.895 0 01-3.294-1 5.92 5.92 0 01-2.187-2.66 5.991 5.991 0 01-.336-3.434 5.928 5.928 0 014.66-4.66 6 6 0 013.433.337 5.942 5.942 0 013.66 5.48 5.906 5.906 0 01-1.741 4.196z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12.044 5.96c-.178 0-.366.06-.614.298L9.808 7.83c-.159.158-.218.316-.218.465 0 .376.386.732.732.732.149 0 .317-.07.475-.228l.336-.336s.08-.08.11-.08c.059 0 .059.08.059.149v4.71c0 .484.356.642.712.642s.702-.158.702-.643v-6.5c0-.554-.336-.781-.672-.781z",
                fill: "currentColor"
            })
        ]
    });



const $df1d3fe7db3c039c$export$a019ebbf50b3c65d = (o)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M16.76 13.84c-.58.61-1.3 1.09-2.76 1.54v5.12c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5v-8.04c-.59-.04-1.3-.14-1.7-.32-.58-.23-1.1-.59-1.54-1.04-2.15-2.16-2.15-6.21-2.15-6.38 0-.19.07-.36.2-.49s.29-.21.48-.21c1.63-.15 3.26.32 4.59 1.29 1.33.98 2.54 3.02 2.58 4.78.82-1.42 2.53-1.87 3.86-1.83.18 0 .35.08.48.21s.2.3.2.49c.02 1.89-.07 3.4-1.24 4.88z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M16.76 13.84c-.58.61-1.3 1.09-2.76 1.54v5.12c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5v-8.04c-.59-.04-1.3-.14-1.7-.32-.58-.23-1.1-.59-1.54-1.04-2.15-2.16-2.15-6.21-2.15-6.38 0-.19.07-.36.2-.49s.29-.21.48-.21c1.63-.15 3.26.32 4.59 1.29 1.33.98 2.54 3.02 2.58 4.78.82-1.42 2.53-1.87 3.86-1.83.18 0 .35.08.48.21s.2.3.2.49c.02 1.89-.07 3.4-1.24 4.88z",
                fill: "currentColor"
            })
        ]
    });



const $3139261b9832edc0$export$3d0bdadec1498300 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M8.27 15.73c3.74 3.75 7.07 3.85 8.48 3.68a1.89 1.89 0 001.13-.57l1-1a2 2 0 000-2.83l-.71-.71a2 2 0 00-2.82 0l-.71.71a.997.997 0 01-1.095.219.998.998 0 01-.325-.219L9 10.79a.999.999 0 010-1.42l.71-.71a2 2 0 000-2.82L9 5.13a2 2 0 00-2.83 0l-1 1a1.89 1.89 0 00-.57 1.13c-.18 1.4-.08 4.74 3.67 8.47z",
            fill: "currentColor"
        })
    });



const $4f49a4e89f486209$export$f4cdb875f32f3afc = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16.34 15.57l-.72-.75a1.992 1.992 0 00-1.42-.58c-.27 0-.52.05-.77.15-.24.1-.46.25-.65.43l-.7.71c-.09.09-.2.17-.33.22-.12.05-.25.08-.38.08s-.26-.03-.38-.08a1.19 1.19 0 01-.33-.22l-4.24-4.24a1.036 1.036 0 01-.3-.71c0-.13.03-.26.08-.38s.12-.23.22-.33l.71-.7a1.992 1.992 0 00.58-1.42c0-.27-.05-.52-.15-.77-.1-.25-.25-.46-.43-.65l-.71-.71A1.992 1.992 0 005 5.04c-.27 0-.52.05-.77.15-.24.1-.46.25-.65.43l-1 1c-.3.31-.5.7-.56 1.13-.16 1.4-.04 4.74 3.68 8.48s7.08 3.84 8.49 3.72c.43-.06.82-.26 1.13-.56l1-1a1.992 1.992 0 00.58-1.42c0-.27-.05-.52-.15-.77-.1-.24-.25-.46-.43-.65l.02.02zM19 6.99h-2v-2c0-.55-.45-1-1-1s-1 .45-1 1v2h-2c-.55 0-1 .45-1 1s.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1v-2h2c.55 0 1-.45 1-1s-.45-1-1-1z",
            fill: "currentColor"
        })
    });



const $e0ba7a20c74fe690$export$7fd12e4044220555 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16.62 15.86a1.998 1.998 0 00-2.83 0l-.7.71a1 1 0 01-1.42 0S8.14 13 7.43 12.33a1.001 1.001 0 010-1.42l.71-.7a2 2 0 000-2.83l-.71-.71a2 2 0 00-2.83 0l-1 1a2 2 0 00-.56 1.13c-.16 1.4-.04 4.74 3.68 8.48s7.08 3.84 8.49 3.72a2 2 0 001.13-.56l1-1a2 2 0 000-2.83l-.72-.75zM17.5 3h-3a3.49 3.49 0 00-1.19 6.78L13 11.09a.74.74 0 00.31.78.72.72 0 00.42.13.7.7 0 00.42-.13L16.9 10h.6a3.5 3.5 0 100-7z",
            fill: "currentColor"
        })
    });



const $8831758439b34470$export$e9a13e12acf7b9ab = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18.16 14.32a2 2 0 00-2.82 0l-.71.71a1 1 0 01-1.42 0L9 10.79a1 1 0 010-1.42l.71-.71a2 2 0 000-2.82L9 5.13a2 2 0 00-2.83 0l-1 1a1.89 1.89 0 00-.57 1.13c-.18 1.4-.08 4.74 3.67 8.47 3.75 3.73 7.07 3.85 8.48 3.68a1.89 1.89 0 001.13-.57l1-1a2 2 0 000-2.83l-.72-.69zM13.5 10.5a1 1 0 011 1 .5.5 0 001 0 1 1 0 011-1 .5.5 0 000-1 1 1 0 01-1-1 .5.5 0 10-1 0 1 1 0 01-1 1 .5.5 0 000 1zm7-6a2 2 0 01-2-2 .5.5 0 10-1 0 2 2 0 01-2 2 .5.5 0 000 1 2 2 0 012 2 .5.5 0 001 0 2 2 0 012-2 .5.5 0 000-1z",
            fill: "currentColor"
        })
    });



const $a396b3963124ec0a$export$8152fe582308c14d = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10 6h10a1 1 0 100-2H10a1 1 0 000 2zm5.62 9.86a1.998 1.998 0 00-2.83 0l-.7.71a1 1 0 01-1.42 0l-4.24-4.24a1.001 1.001 0 010-1.42l.71-.7a2 2 0 000-2.83l-.71-.71a2 2 0 00-2.83 0l-1 1a2 2 0 00-.56 1.13c-.16 1.4-.04 4.74 3.68 8.48s7.08 3.84 8.49 3.72a2 2 0 001.13-.56l1-1a2 2 0 000-2.83l-.72-.75zM20 12h-2a1 1 0 000 2h2a1 1 0 000-2zm0-4h-6a1 1 0 000 2h6a1 1 0 100-2z",
            fill: "currentColor"
        })
    });



const $5c4f64ca436795db$export$52bff09788e9cb7f = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18.16 14.32a2 2 0 00-2.82 0l-.71.71a1.001 1.001 0 01-1.42 0L9 10.79a1 1 0 010-1.42l.71-.71a2 2 0 000-2.82L9 5.13a2 2 0 00-2.83 0l-1 1a1.89 1.89 0 00-.57 1.13c-.18 1.4-.08 4.74 3.67 8.47 3.75 3.73 7.07 3.85 8.48 3.68a1.89 1.89 0 001.13-.57l1-1a2.001 2.001 0 000-2.83l-.72-.69zm3.55-6a1 1 0 00-1.42 0l-.29.3V5a1 1 0 00-2 0v6a1 1 0 00.62.92 1 1 0 001.09-.21l2-2a1 1 0 000-1.42v.03zm-8-.58l.29-.3V11a1 1 0 102 0V5a1 1 0 00-.62-.92 1 1 0 00-1.09.21l-2 2a1.004 1.004 0 101.42 1.42v.03z",
            fill: "currentColor"
        })
    });



const $505281ba48efd0e8$export$541e8cb2126d12ff = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M14 7a1 1 0 100 2 1 1 0 000-2zm0 8a1 1 0 100 2 1 1 0 000-2zM9 3H7.6a1.93 1.93 0 00-1.2.4C5.28 4.28 3 6.71 3 12c0 5.29 2.28 7.72 3.4 8.6a1.93 1.93 0 001.2.4H9a2 2 0 002-2v-1a2 2 0 00-2-2H8a1 1 0 01-1-1V9a1 1 0 011-1h1a2 2 0 002-2V5a2 2 0 00-2-2zm5 8a1 1 0 100 2 1 1 0 000-2zm3 4a1 1 0 100 2 1 1 0 000-2zm3 0a1 1 0 100 2 1 1 0 000-2zm-3-4a1 1 0 100 2 1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $2e10d0ea857286a6$export$175477875a1071ec = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15.62 15.86c-.78-.78-2.05-.78-2.83 0l-.71.71c-.71.71-1.41 0-1.41 0l-4.24-4.24c-.71-.71 0-1.41 0-1.41l.71-.71c.78-.78.78-2.05 0-2.83l-.71-.71c-.78-.78-2.05-.78-2.83 0l-.99.99c-.31.31-.51.7-.57 1.14-.17 1.41-.06 4.74 3.68 8.48s7.08 3.85 8.48 3.68c.43-.05.83-.26 1.14-.57l.99-.99c.78-.78.78-2.05 0-2.83l-.71-.71zM16.5 2C13.46 2 11 4.46 11 7.5V13h5.5c3.04 0 5.5-2.46 5.5-5.5S19.54 2 16.5 2zm3 6c0 .28-.22.5-.5.5h-1.5V10c0 .28-.22.5-.5.5h-1c-.28 0-.5-.22-.5-.5V8.5H14c-.28 0-.5-.22-.5-.5V7c0-.28.22-.5.5-.5h1.5V5c0-.28.22-.5.5-.5h1c.28 0 .5.22.5.5v1.5H19c.28 0 .5.22.5.5v1z",
            fill: "currentColor"
        })
    });



const $5f22e360284a0d78$export$24fbec4fe8a9482 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 8c-5.29 0-7.72 2.28-8.6 3.4a1.93 1.93 0 00-.4 1.2V14a2 2 0 002 2h1a2 2 0 002-2v-1a1 1 0 011-1h6a1 1 0 011 1v1a2 2 0 002 2h1a2 2 0 002-2v-1.4a1.93 1.93 0 00-.4-1.2C19.72 10.28 17.29 8 12 8z",
            fill: "currentColor"
        })
    });



const $795a110aee49dbd0$export$4e213e5760bf102a = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18.16 14.32a2 2 0 00-2.82 0l-.71.71a1.001 1.001 0 01-1.42 0L9 10.79a1 1 0 010-1.42l.71-.71a2 2 0 000-2.82L9 5.13a2 2 0 00-2.83 0l-1 1a1.89 1.89 0 00-.57 1.13c-.18 1.4-.08 4.74 3.67 8.47 3.75 3.73 7.07 3.85 8.48 3.68a1.89 1.89 0 001.13-.57l1-1a2.002 2.002 0 000-2.83l-.72-.69zm2.55-8l-2-2a1.005 1.005 0 00-1.42 1.42L18.59 7l-1.3 1.29a.998.998 0 000 1.42.999.999 0 001.42 0l2-2a1.001 1.001 0 000-1.42v.03zm-7.42 3.39a.999.999 0 001.42 0l2-2a1.001 1.001 0 000-1.42l-2-2a1.005 1.005 0 00-1.42 1.42L14.59 7l-1.3 1.29a.998.998 0 000 1.42z",
            fill: "currentColor"
        })
    });



const $f3716b606c0ee79e$export$c95fee370d5c4573 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M14 7a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm4-1a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm0 1a3 3 0 00-2.53 1.4A3 3 0 0011 11a1 1 0 001 1h4a1 1 0 001-1h3a1 1 0 001-1 3 3 0 00-3-3zm-2.39 8.86a1.998 1.998 0 00-2.83 0l-.7.71a1 1 0 01-1.42 0l-4.23-4.24a1.001 1.001 0 010-1.42l.71-.7a2 2 0 000-2.83l-.71-.71a2 2 0 00-2.83 0l-1 1a2 2 0 00-.56 1.13c-.16 1.4-.04 4.74 3.68 8.48s7.08 3.84 8.49 3.72a2 2 0 001.13-.56l1-1a2 2 0 000-2.83l-.73-.75z",
            fill: "currentColor"
        })
    });



const $730a29369ec6ebc8$export$7bf79d6a8337bb11 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15.56 15.86a1.998 1.998 0 00-2.83 0l-.7.71a1 1 0 01-1.42 0l-4.24-4.24a1 1 0 010-1.42l.71-.7a2 2 0 000-2.83l-.71-.71a2 2 0 00-2.83 0l-1 1A2 2 0 002 8.79c-.17 1.41-.07 4.75 3.67 8.49 3.74 3.74 7.08 3.84 8.49 3.67a2 2 0 001.13-.56l1-1a2 2 0 000-2.83l-.73-.7zm2.69-8.36h-.5v3h.5a1.5 1.5 0 100-3zM20 5h-8a2 2 0 00-2 2v4a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2zm-4.25 6a.5.5 0 11-1 0V9.5h-2V11a.5.5 0 11-1 0V7a.5.5 0 011 0v1.5h2V7a.5.5 0 011 0v4zm2.5.5h-1a.5.5 0 01-.5-.5V7a.5.5 0 01.5-.5h1a2.5 2.5 0 110 5z",
            fill: "currentColor"
        })
    });



const $70bf5e0e114c1e96$export$6f59f05266d9b20d = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 10a1 1 0 001-1V5a1 1 0 00-2 0v4a1 1 0 001 1zm2.16 4.32a2 2 0 00-2.82 0l-.71.71a1.001 1.001 0 01-1.42 0L9 10.79a1 1 0 010-1.42l.71-.71a2 2 0 000-2.82L9 5.13a2 2 0 00-2.83 0l-1 1a1.89 1.89 0 00-.57 1.13c-.18 1.4-.08 4.74 3.67 8.47 3.75 3.73 7.07 3.85 8.48 3.68a1.89 1.89 0 001.13-.57l1-1a2.001 2.001 0 000-2.83l-.72-.69zM19 4a1 1 0 00-1 1v4a1 1 0 102 0V5a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $5cceec9b15f00870$export$e9f4c5ba77c9979a = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M9 16H8a1 1 0 01-1-1V9a1 1 0 011-1h1a2 2 0 002-2V5a2 2 0 00-2-2H7.6a1.93 1.93 0 00-1.2.4C5.28 4.28 3 6.71 3 12c0 5.29 2.28 7.72 3.4 8.6a1.93 1.93 0 001.2.4H9a2 2 0 002-2v-1a2 2 0 00-2-2zm11 0a1 1 0 00-1 1v.6a6 6 0 00-4.07-1.6H14a1 1 0 000 2h.93a3.94 3.94 0 012.62 1H17a1 1 0 000 2h3a1 1 0 001-1v-3a1 1 0 00-1-1zm0-13h-3a1 1 0 100 2h.55a3.94 3.94 0 01-2.62 1H14a1 1 0 100 2h.93A6 6 0 0019 6.4V7a1 1 0 002 0V4a1 1 0 00-1-1zm-1.29 6.29a1.004 1.004 0 00-1.42 1.42l.3.29H11a1 1 0 000 2h6.59l-.3.29a1.001 1.001 0 00.325 1.639 1 1 0 001.095-.219l2-2a1 1 0 000-1.42l-2-2z",
            fill: "currentColor"
        })
    });



const $2377372fd75a458f$export$b3bd1714d1bd310e = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M11 9a1 1 0 00.71-.29L14 6.41V7a1 1 0 002 0V4a.997.997 0 00-.08-.38 1 1 0 00-.54-.54A1 1 0 0015 3h-3a1 1 0 000 2h.59l-2.3 2.29A1 1 0 0011 9zm10.71-.71a.999.999 0 00-1.42 0L18 10.59V10a1 1 0 10-2 0v3c.002.13.029.26.08.38a1 1 0 00.54.54c.12.051.25.078.38.08h3a1 1 0 000-2h-.59l2.3-2.29a.998.998 0 000-1.42zm-6.09 7.57a1.998 1.998 0 00-2.83 0l-.7.71a1 1 0 01-1.42 0l-4.24-4.24a1.001 1.001 0 010-1.42l.71-.7a2 2 0 000-2.83l-.71-.71a2 2 0 00-2.83 0l-1 1a2 2 0 00-.56 1.13c-.16 1.4-.04 4.74 3.68 8.48s7.08 3.84 8.49 3.72a2 2 0 001.13-.56l1-1a2 2 0 000-2.83l-.72-.75z",
            fill: "currentColor"
        })
    });



const $ed8fb68ec0612a7c$export$143d598504f27ae8 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18.16 14.32a2 2 0 00-2.82 0l-.71.71a1 1 0 01-1.42 0L9 10.79a1 1 0 010-1.42l.71-.71a2 2 0 000-2.82L9 5.13a2 2 0 00-2.83 0l-1 1a1.89 1.89 0 00-.57 1.13c-.18 1.4-.08 4.74 3.67 8.47 3.75 3.73 7.07 3.85 8.48 3.68a1.89 1.89 0 001.13-.57l1-1a2 2 0 000-2.83l-.72-.69zm1.55-10a.999.999 0 00-1.42 0L16 6.59V6a1 1 0 10-2 0v3c.002.13.029.26.08.38a1 1 0 00.54.54A1 1 0 0015 10h3a1 1 0 100-2h-.59l2.3-2.29a.998.998 0 000-1.42v.03z",
            fill: "currentColor"
        })
    });



const $b40c0de61374bd31$export$c22acf14efabda72 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.6 16.4c-.87-1.12-3.31-3.4-8.6-3.4-5.29 0-7.72 2.28-8.6 3.4-.27.34-.4.77-.4 1.2V19c0 1.1.9 2 2 2h1c1.1 0 2-.9 2-2v-1s0-1 1-1h6s1 0 1 1v1c0 1.1.9 2 2 2h1c1.1 0 2-.9 2-2v-1.4c0-.44-.13-.86-.4-1.2zM7 8c.55 0 1-.45 1-1v-.59l4.29 4.29c.2.2.45.29.71.29.26 0 .51-.1.71-.29l4-4a.996.996 0 10-1.41-1.41l-3.29 3.29-3.59-3.59h.59c.55 0 1-.45 1-1s-.45-1-1-1h-3c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1L7 8z",
            fill: "currentColor"
        })
    });



const $6be6d4bf8a99e081$export$62609e7e2e4de999 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17.79 16.76l-.72-.69c-.38-.37-.88-.58-1.41-.58-.53 0-1.04.21-1.41.58l-.71.71c-.09.09-.2.17-.33.22-.12.05-.25.08-.38.08s-.26-.03-.38-.08-.23-.12-.33-.22l-4.21-4.24a.955.955 0 01-.22-.33.995.995 0 01-.08-.38c0-.13.03-.26.08-.38s.12-.23.22-.33l.71-.71c.37-.37.58-.88.58-1.41 0-.53-.21-1.04-.58-1.41l-.71-.71a1.992 1.992 0 00-1.42-.58c-.27 0-.52.05-.77.15-.24.1-.46.25-.65.43l-1 1c-.31.3-.52.7-.57 1.13-.18 1.4-.08 4.74 3.67 8.47 3.75 3.73 7.07 3.85 8.48 3.68.43-.05.83-.26 1.13-.57l1-1a1.992 1.992 0 00.58-1.42c0-.27-.05-.52-.15-.77-.1-.24-.25-.46-.43-.65l.01.01zM20.57 8.12h-.44V5.49c0-.93-.37-1.82-1.03-2.47a3.505 3.505 0 00-4.96 0c-.66.66-1.03 1.55-1.03 2.47v2.63h-.44c-.12 0-.23.05-.31.13-.08.08-.13.19-.13.31s.05.23.13.31c.08.08.19.13.31.13h7.9c.12 0 .23-.05.31-.13.08-.08.13-.19.13-.31s-.05-.23-.13-.31a.439.439 0 00-.31-.13zm-3.95 3.19c.35 0 .68-.14.93-.39s.39-.58.39-.93h-2.63c0 .35.14.68.39.93s.58.39.93.39h-.01z",
            fill: "currentColor"
        })
    });



const $97df4cdf8a751b82$export$7cd4995355504eef = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15.62 15.86a2 2 0 00-2.83 0l-.7.71a1 1 0 01-1.42 0l-4.24-4.24a.999.999 0 010-1.42l.71-.7a2 2 0 000-2.83l-.71-.71a2 2 0 00-2.83 0l-1 1a2 2 0 00-.56 1.13c-.16 1.4-.04 4.74 3.68 8.48s7.08 3.84 8.49 3.72a2 2 0 001.13-.56l1-1a2 2 0 000-2.83l-.72-.75zM21 6h-.31l.25-.65a1.002 1.002 0 10-1.88-.7L18.56 6h-1.87l.25-.65a1.002 1.002 0 10-1.88-.7L14.56 6H13a1 1 0 000 2h.81l-.75 2H12a1 1 0 000 2h.31l-.25.65a1.001 1.001 0 00.59 1.29A1 1 0 0013 14a1 1 0 00.94-.65l.5-1.35h1.87l-.25.65a1.001 1.001 0 00.59 1.29A1 1 0 0017 14a1 1 0 00.94-.65l.5-1.35H20a1 1 0 100-2h-.81l.75-2H21a1 1 0 100-2zm-3.94 4h-1.87l.75-2h1.87l-.75 2z",
            fill: "currentColor"
        })
    });



const $f21bbfb1dd2704eb$export$8ef9b8b99d54a31b = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.71 3.29a.999.999 0 00-1.42 0l-16 16a1 1 0 000 1.42.998.998 0 001.42 0L9 16.42c3.44 3.07 6.44 3.15 7.76 3a1.89 1.89 0 001.13-.57l1-1a2 2 0 000-2.83l-.71-.71a2 2 0 00-2.82 0l-.71.71a.997.997 0 01-1.095.219.998.998 0 01-.325-.22l-1.43-1.41 8.91-8.9a.998.998 0 000-1.42zM9 10.79a.999.999 0 010-1.42l.71-.71a2 2 0 000-2.82L9 5.13a2 2 0 00-2.83 0l-1 1a1.89 1.89 0 00-.57 1.13 9.12 9.12 0 001.75 6.16L9 10.79z",
            fill: "currentColor"
        })
    });



const $2dc8b9f262582907$export$cbba21544350570b = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.92 4.62a1 1 0 00-.54-.54A1 1 0 0019 4h-3a1 1 0 000 2h.59l-2.3 2.29a1 1 0 00.325 1.639 1 1 0 001.095-.219L18 7.41V8a1 1 0 002 0V5a.997.997 0 00-.08-.38zm-1.76 9.7a2 2 0 00-2.82 0l-.71.71a1 1 0 01-1.42 0L9 10.79a1 1 0 010-1.42l.71-.71a2 2 0 000-2.82L9 5.13a2 2 0 00-2.83 0l-1 1a1.89 1.89 0 00-.57 1.13c-.18 1.4-.08 4.74 3.67 8.47 3.75 3.73 7.07 3.85 8.48 3.68a1.89 1.89 0 001.13-.57l1-1a2 2 0 000-2.83l-.72-.69z",
            fill: "currentColor"
        })
    });



const $fa243719e42c8ac0$export$343082e2b2058227 = (r)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M17.22 16.91l-.72-.69c-.38-.37-.88-.58-1.41-.58-.53 0-1.04.21-1.41.58l-.71.71c-.09.09-.2.17-.33.22-.12.05-.25.08-.38.08s-.26-.03-.38-.08-.23-.12-.33-.22l-4.21-4.24a.955.955 0 01-.22-.33.995.995 0 01-.08-.38c0-.13.03-.26.08-.38s.12-.23.22-.33l.71-.71c.37-.37.58-.88.58-1.41 0-.53-.21-1.04-.58-1.41l-.71-.71a1.992 1.992 0 00-1.42-.58c-.27 0-.52.05-.77.15-.24.1-.46.25-.65.43l-1 1c-.31.3-.52.7-.57 1.13-.18 1.4-.08 4.74 3.67 8.47 3.75 3.73 7.07 3.85 8.48 3.68.43-.05.83-.26 1.13-.57l1-1a1.992 1.992 0 00.58-1.42c0-.27-.05-.52-.15-.77-.1-.24-.25-.46-.43-.65l.01.01z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M20.57 8.89l-.78-.45V7.8l.78-.45c.25-.15.43-.38.51-.67.07-.28.04-.58-.11-.83l-.55-.95c-.15-.25-.38-.43-.67-.51-.29-.08-.58-.04-.83.11l-.65.37-.14.08-.55-.32v-.9c0-.29-.12-.57-.32-.77-.21-.21-.48-.32-.77-.32h-1.1c-.29 0-.57.12-.77.32-.21.21-.32.48-.32.77v.9l-.14.08-.41.24-.14-.08-.65-.37c-.25-.15-.55-.18-.83-.11-.28.07-.52.26-.67.51l-.55.95c-.15.25-.18.55-.11.83.08.28.26.52.51.67l.78.45v.64l-.78.45c-.25.15-.43.38-.51.67-.07.28-.04.58.11.83l.55.95c.15.25.38.43.67.51.28.07.58.04.83-.11l.78-.45.55.32v.9c0 .29.12.57.32.77.2.2.48.32.77.32h1.1c.29 0 .57-.12.77-.32.2-.2.32-.48.32-.77v-.9l.55-.32.78.45c.25.15.55.18.83.11.28-.07.52-.26.67-.51l.55-.95c.15-.25.18-.55.11-.83-.08-.28-.26-.52-.51-.67h.02zm-3.46.39c-.31.31-.73.48-1.16.48-.32 0-.64-.1-.91-.28-.27-.18-.48-.44-.6-.74s-.16-.63-.09-.95c.06-.32.22-.61.45-.84.23-.23.52-.39.84-.45.32-.06.65-.03.95.09.3.12.56.34.74.61a1.626 1.626 0 01-.2 2.07l-.02.01z",
                fill: "currentColor"
            })
        ]
    });



const $3e32aaa7e10ac00b$export$5d16e4c1975c9e61 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18.16 14.32a2 2 0 00-2.82 0l-.71.71a1.001 1.001 0 01-1.42 0L9 10.79a1 1 0 010-1.42l.71-.71a2 2 0 000-2.82L9 5.13a2 2 0 00-2.83 0l-1 1a1.89 1.89 0 00-.57 1.13c-.18 1.4-.08 4.74 3.67 8.47 3.75 3.73 7.07 3.85 8.48 3.68a1.89 1.89 0 001.13-.57l1-1a2.001 2.001 0 000-2.83l-.72-.69zm-4.49-5.21a2 2 0 011.22 1.22 1 1 0 00.94.67 1 1 0 00.94-1.33 3.941 3.941 0 00-2.44-2.44 1 1 0 00-.66 1.88zm.5-5a1.014 1.014 0 10-.33 2 5 5 0 014.09 4.1 1 1 0 001 .83h.16a1.001 1.001 0 00.82-1.16 7 7 0 00-5.74-5.78v.01z",
            fill: "currentColor"
        })
    });



const $5f2f94e5ad23ebe0$export$444296294f93ddd6 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16.84 16.6l-.73-.75a1.992 1.992 0 00-1.42-.58c-.27 0-.52.05-.77.15-.25.1-.46.25-.65.43l-.7.71c-.09.09-.2.17-.33.22-.12.05-.25.08-.38.08s-.26-.03-.38-.08a1.19 1.19 0 01-.33-.22l-4.23-4.24a.955.955 0 01-.22-.33.995.995 0 01-.08-.38c0-.13.03-.26.08-.38s.13-.23.22-.33l.71-.7a1.992 1.992 0 00.58-1.42c0-.27-.05-.52-.15-.77-.1-.25-.25-.46-.43-.65l-.71-.71a1.991 1.991 0 00-1.42-.58c-.27 0-.52.05-.77.15-.24.1-.46.25-.65.43l-1 1c-.3.31-.5.7-.56 1.13-.16 1.4-.04 4.74 3.68 8.48s7.08 3.84 8.49 3.72c.43-.06.82-.26 1.13-.56l1-1A1.992 1.992 0 0017.4 18c0-.27-.05-.52-.15-.77-.1-.24-.25-.46-.43-.65l.02.02zM21.87 4.26a.954.954 0 00-.36-.33.964.964 0 00-.47-.09c-.16.01-.32.07-.45.17l-1.53 1.18v-.47a1.772 1.772 0 00-1.77-1.77h-5.3a1.772 1.772 0 00-1.77 1.77v3.53a1.772 1.772 0 001.77 1.77h5.3a1.772 1.772 0 001.77-1.77v-.44l1.53 1.15c.13.1.29.16.45.17a.88.88 0 00.96-.88V4.72a.94.94 0 00-.13-.46z",
            fill: "currentColor"
        })
    });



const $cc7f976532290cab$export$6c3e45e35614fad1 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 12a1 1 0 100 2 1 1 0 000-2zm-.38 3.86a1.998 1.998 0 00-2.83 0l-.7.71a1 1 0 01-1.42 0l-4.24-4.24a1.001 1.001 0 010-1.42l.71-.7a2 2 0 000-2.83l-.71-.71a2 2 0 00-2.83 0l-1 1a2 2 0 00-.56 1.13c-.16 1.4-.04 4.74 3.68 8.48s7.08 3.84 8.49 3.72a2 2 0 001.13-.56l1-1a2 2 0 000-2.83l-.72-.75zm5.94-10.17a10.14 10.14 0 00-11.11 0A1 1 0 0011 7.52a.94.94 0 00.55-.17 8.11 8.11 0 018.89 0 1 1 0 001.12-1.66zM19 8.86a5.81 5.81 0 00-6.07 0 1 1 0 001 1.72 3.8 3.8 0 014 0 1 1 0 001.37-.35 1 1 0 00-.3-1.37z",
            fill: "currentColor"
        })
    });



const $20dcfb79553055b7$export$8f0df8acc324b7fa = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15 4H9a7 7 0 00-1 13.92V20a1.5 1.5 0 002.4 1.2l4.27-3.2H15a7 7 0 000-14zm-7 8a1 1 0 110-2 1 1 0 010 2zm4 0a1 1 0 110-2 1 1 0 010 2zm4 0a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $f18f1fa2680b5d29$export$f2fd440fabd00a2 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15.7 2h-5.4a6.28 6.28 0 00-5.09 2.6A8.34 8.34 0 018.3 4h5.4a8.3 8.3 0 018 6.18A6.155 6.155 0 0022 8.3 6.3 6.3 0 0015.7 2zm-2 4H8.3a6.3 6.3 0 00-.9 12.53v1.87a1.35 1.35 0 002.16 1.08l3.84-2.88h.3a6.3 6.3 0 100-12.6zM7 13a1 1 0 110-2 1 1 0 010 2zm4 0a1 1 0 110-2 1 1 0 010 2zm4 0a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $06a14a0cf0d17eb3$export$8b4dbe8d377ce234 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M3 6v12a3 3 0 003 3h1V3H6a3 3 0 00-3 3zm15-3H9v18h9a3 3 0 003-3V6a3 3 0 00-3-3zm-3 5a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm2 8h-4a1 1 0 01-1-1 3 3 0 016 0 1 1 0 01-1 1z",
            fill: "currentColor"
        })
    });



const $aef25b9733b263cf$export$6f30fc53505c6570 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12.59 11.34l8-5.85A3 3 0 0019 5H5a3 3 0 00-1.63.49l8 5.85a1 1 0 001.22 0zm9.25-4.26L13.76 13a3 3 0 01-3.52 0L2.16 7.08A2.82 2.82 0 002 8v8a3 3 0 003 3h14a3 3 0 003-3V8a2.819 2.819 0 00-.16-.92z",
            fill: "currentColor"
        })
    });



const $616d71a80524dff7$export$e0bf046d7f70588b = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16.88 7.12c.39.39 1.02.39 1.41 0l.71-.71.71.71a.996.996 0 101.41-1.41L20.41 5l.71-.71a.996.996 0 10-1.41-1.41l-.71.71-.71-.71a.996.996 0 10-1.41 1.41l.71.71-.71.71a.996.996 0 000 1.41zm4.87 2.05c-.79.52-1.73.83-2.75.83a5.002 5.002 0 01-4.9-6H9c-3.87 0-7 3.13-7 7 0 3.53 2.61 6.43 6 6.92V20c0 1.24 1.41 1.94 2.4 1.2l4.27-3.2H15c3.87 0 7-3.13 7-7 0-.63-.09-1.25-.25-1.83z",
            fill: "currentColor"
        })
    });



const $35cc8456466684d8$export$acb0088d99c5dfc5 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18.29 4.29L6 16.59V9a1 1 0 00-2 0v10a1 1 0 00.08.38 1 1 0 00.54.54c.12.051.25.079.38.08h10a1 1 0 000-2H7.41l12.3-12.29a1.004 1.004 0 00-1.42-1.42z",
            fill: "currentColor"
        })
    });



const $8b6c73d2eefde0dd$export$a7b8f7779b550219 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M8 5a2 2 0 00-2-2H4a2 2 0 00-2 2v.56A3.91 3.91 0 014 5h4zm0 2H4a2 2 0 00-2 2v10a2 2 0 002 2h4a2 2 0 002-2V9a2 2 0 00-2-2zM6 19a1 1 0 110-2 1 1 0 010 2zM21.12 4.88A3 3 0 0019 4H9v1.14a4 4 0 012.52 2A1 1 0 0112 7h6a1 1 0 011 1v2a1 1 0 01-1 1h-6v2a1 1 0 010 2v1a1 1 0 010 2v1a4.09 4.09 0 01-.14 1H19a3 3 0 003-3V7a3 3 0 00-.88-2.12zM15 18a1 1 0 110-2 1 1 0 010 2zm0-3a1 1 0 110-2 1 1 0 010 2zm3 3a1 1 0 110-2 1 1 0 010 2zm0-3a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $49d03a5273ba6aca$export$280d4365d332b314 = (v)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...v,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M6 3H4a2 2 0 00-2 2v14a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2zm15.12 1.88A3 3 0 0019 4H9v16h10a3 3 0 003-3V7a3 3 0 00-.88-2.12zm-7.91 12.83a1 1 0 01-1.27.12.94.94 0 01-.36-.45 1 1 0 01-.06-.58 1 1 0 01.78-.8 1 1 0 01.58.06.94.94 0 01.45.36 1 1 0 01-.12 1.27v.02zm0-3a1 1 0 01-1.27.12.94.94 0 01-.36-.45 1 1 0 01-.06-.58 1 1 0 01.78-.8 1 1 0 01.58.06.94.94 0 01.45.36 1 1 0 01-.12 1.27v.02zm3 3a1 1 0 01-1.27.12.94.94 0 01-.36-.45 1 1 0 01-.06-.58 1 1 0 01.78-.8 1 1 0 01.58.06.94.94 0 01.45.36 1 1 0 01-.12 1.27v.02zm0-3a1 1 0 01-1.27.12.94.94 0 01-.36-.45 1 1 0 01-.06-.58 1 1 0 01.78-.8 1 1 0 01.58.06.94.94 0 01.45.36 1 1 0 01-.12 1.27v.02zm3 3a1 1 0 01-1.27.12.94.94 0 01-.36-.45 1 1 0 01-.06-.58 1 1 0 01.78-.8 1 1 0 01.58.06.94.94 0 01.45.36 1 1 0 01-.12 1.27v.02zm0-3a1 1 0 01-1.27.12.94.94 0 01-.36-.45 1 1 0 01-.06-.58 1 1 0 01.78-.8 1 1 0 01.58.06.94.94 0 01.45.36 1 1 0 01-.12 1.27v.02zM19.5 9a1 1 0 01-1 1h-6a1 1 0 01-1-1V7a1 1 0 011-1h6a1 1 0 011 1v2z",
            fill: "currentColor"
        })
    });



const $65aa4a1cf376cf45$export$2c6c17b3c91859a8 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 4H5a3 3 0 00-3 3v10a3 3 0 003 3h14a3 3 0 003-3V7a3 3 0 00-3-3zm-2 4a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm-5 0a1.5 1.5 0 110 3 1.5 1.5 0 010-3zM7 8a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm12 8H5a1 1 0 01-1-1 3 3 0 015.5-1.65 3 3 0 015 0A3 3 0 0120 15a1 1 0 01-1 1z",
            fill: "currentColor"
        })
    });



const $e64d61f864cb2816$export$9552eb1a35e93757 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M6 12c.55 0 1-.45 1-1V8.91l5.29 5.29c.2.2.45.29.71.29.26 0 .51-.1.71-.29l5-5a.996.996 0 10-1.41-1.41l-4.29 4.29-4.59-4.59h2.09c.55 0 1-.45 1-1s-.45-1-1-1h-4.5c-.55 0-1 .45-1 1v4.5c0 .55.45 1 1 1L6 12zM18 16.54H6a.96.96 0 000 1.92h12a.96.96 0 000-1.92z",
            fill: "currentColor"
        })
    });



const $5b003c7eb3182889$export$c0f568f89d838d39 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15 4H9a7 7 0 00-1 13.92V20a1.5 1.5 0 002.4 1.2l4.27-3.2H15a7 7 0 000-14zm-1 8h-1v1a1 1 0 01-2 0v-1h-1a1 1 0 010-2h1V9a1 1 0 112 0v1h1a1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $9cc0b93afb5d44cd$export$6443673732de868 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M6.5 3a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM12 18a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM6.5 8a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm0 5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm11-7a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM12 13a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm5.5 0a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm0-5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM12 3a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm0 5a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
            fill: "currentColor"
        })
    });



const $faa829c4d1c57c47$export$6f25785fbb4a77ad = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.92 4.62a1 1 0 00-.54-.54A1 1 0 0019 4H9a1 1 0 000 2h7.59L4.29 18.29a1 1 0 00.325 1.639 1 1 0 001.095-.219L18 7.41V15a1 1 0 002 0V5a.997.997 0 00-.08-.38z",
            fill: "currentColor"
        })
    });



const $c021c072c78b0e33$export$66031ff53e635bd0 = (m)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...m,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.6 6.4C19.72 5.28 17.29 3 12 3 6.71 3 4.28 5.28 3.4 6.4A1.93 1.93 0 003 7.6V9a2 2 0 002 2h1a2 2 0 002-2V8a1 1 0 011-1h6a1 1 0 011 1v1a2 2 0 002 2h1a2 2 0 002-2V7.6a1.93 1.93 0 00-.4-1.2zM18 13a4 4 0 01-4-4h-4a4 4 0 01-4 4 2 2 0 00-2 2v3a3 3 0 003 3h10a3 3 0 003-3v-3a2 2 0 00-2-2zm-9 6a1 1 0 110-2 1 1 0 010 2zm0-3a1 1 0 110-2 1 1 0 010 2zm3 3a1 1 0 110-2 1 1 0 010 2zm0-3a1 1 0 110-2 1 1 0 010 2zm3 3a1 1 0 110-2 1 1 0 010 2zm0-3a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $db43bba48d22945b$export$7a138309621df376 = (v)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...v,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 2h-5a3 3 0 00-2.38 1.13l-3 3.7A3 3 0 005 8.7V19a3 3 0 003 3h8a3 3 0 003-3V5a3 3 0 00-3-3zM7 12h3v3H7v-3zm5 8H8a1 1 0 01-1-1v-2h5v3zm5-1a1 1 0 01-1 1h-2v-3h3v2zm0-4h-5v-3h5v3z",
            fill: "currentColor"
        })
    });



const $e3e7349a485b8140$export$b6331fbbde215e42 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M6 11a2 2 0 002-2V8a1 1 0 011-1h6a1 1 0 011 1h4a4.23 4.23 0 011 .14V7.6a1.93 1.93 0 00-.4-1.2C19.72 5.28 17.29 3 12 3 6.71 3 4.28 5.28 3.4 6.4A1.93 1.93 0 003 7.6V9a2 2 0 002 2h1zm15.41-.41A2 2 0 0020 10h-4a2 2 0 00-2 2v8a2 2 0 002 2h4a2 2 0 002-2v-8a2 2 0 00-.59-1.41zm-2.7 9.12a1 1 0 01-1.27.12.94.94 0 01-.36-.45 1 1 0 01-.08-.58 1 1 0 01.8-.8 1 1 0 01.58.06.94.94 0 01.45.36 1 1 0 01-.12 1.27v.02zm-9.88-7.88A4 4 0 016 13a2 2 0 00-2 2v3a3 3 0 003 3h5.14a4.233 4.233 0 01-.14-1v-6a1.5 1.5 0 110-3h.14a4 4 0 011.24-2H10a4 4 0 01-1.17 2.83z",
            fill: "currentColor"
        })
    });



const $f0c7b305dfa8d7e2$export$766cf5efdb887320 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15 4H9a7 7 0 00-1 13.92V20a1.5 1.5 0 002.4 1.2l4.27-3.2H15a7 7 0 000-14z",
            fill: "currentColor"
        })
    });



const $81c20b8d86574cdc$export$302b9e2129c6c57c = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15 4H9a7 7 0 00-1 13.92V20a1.5 1.5 0 002.4 1.2l4.27-3.2H15a7 7 0 000-14zm-1.67 3a1.34 1.34 0 11.02 2.68A1.34 1.34 0 0113.33 7zm-3.55.89a1.34 1.34 0 110 2.68 1.34 1.34 0 010-2.68zm5.33 6.22h-2.67a.88.88 0 01-.88.89H8a.89.89 0 01-.89-.89 2.68 2.68 0 012.67-2.67 2.58 2.58 0 011.3.36A2.67 2.67 0 0116 13.22a.89.89 0 01-.89.89z",
            fill: "currentColor"
        })
    });



const $4a9799b2bbd5b809$export$24e60f703b1e751e = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15 4H9a7 7 0 00-1 13.92V20a1.5 1.5 0 002.4 1.2l4.27-3.2H15a7 7 0 000-14zm2.71 5.71L15.41 12H16a1 1 0 010 2h-3a1.001 1.001 0 01-.38-.08 1 1 0 01-.54-.54A.997.997 0 0112 13v-3a1 1 0 112 0v.59l2.29-2.3a1.004 1.004 0 011.42 1.42z",
            fill: "currentColor"
        })
    });



const $8d60d2f8d875a855$export$f2b0c1860b0343fe = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15 4H9a7 7 0 00-1 13.92V20a1.5 1.5 0 002.4 1.2l4.27-3.2H15a7 7 0 000-14zm3 8a1 1 0 01-2 0v-.59l-2.29 2.3a1.004 1.004 0 11-1.42-1.42l2.3-2.29H14a1 1 0 110-2h3a1 1 0 01.38.08 1 1 0 01.54.54c.051.12.078.25.08.38v3z",
            fill: "currentColor"
        })
    });



const $91cc7c64f4325047$export$d0f4d49391e9e7bc = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15.7 2h-5.4a6.28 6.28 0 00-5.09 2.6A8.34 8.34 0 018.3 4h5.4a8.3 8.3 0 018 6.18A6.155 6.155 0 0022 8.3 6.3 6.3 0 0015.7 2zm-2 4H8.3a6.3 6.3 0 00-.9 12.53v1.87a1.35 1.35 0 002.16 1.08l3.84-2.88h.3a6.3 6.3 0 100-12.6z",
            fill: "currentColor"
        })
    });



const $0344033913470c3c$export$cbea49f44710a7e2 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 4H5a3 3 0 00-3 3v8a3 3 0 003 3h3v1a2 2 0 003.2 1.6l3.47-2.6H19a3 3 0 003-3V7a3 3 0 00-3-3zm-7 12.5a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5zm1.32-4.62l-.33.24A1 1 0 0111 12a2.18 2.18 0 011.17-1.76c.56-.4.83-.61.83-1.24a1.17 1.17 0 00-1-1 1.17 1.17 0 00-1 1 1 1 0 01-2 0 3.16 3.16 0 013-3 3.16 3.16 0 013 3 3.31 3.31 0 01-1.68 2.88z",
            fill: "currentColor"
        })
    });



const $b8e4f7803b42b486$export$aa0ae546683e56bc = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 10h-1V9A7 7 0 105 9v1H4a2 2 0 00-2 2v4a2 2 0 002 2h1a2 2 0 002-2V9a5 5 0 1110 0v10a1 1 0 01-1 1h-3a1 1 0 000 2h3a3 3 0 003-3v-1h1a2 2 0 002-2v-4a2 2 0 00-2-2z",
            fill: "currentColor"
        })
    });



const $f36fb9d3e0a1e6aa$export$49b9fed3311349db = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.6 7.8l-2.6 2V9a3 3 0 00-3-3H5a3 3 0 00-3 3v6a3 3 0 003 3h9a3 3 0 003-3v-.75l2.6 1.95A1.5 1.5 0 0022 15V9a1.5 1.5 0 00-2.4-1.2z",
            fill: "currentColor"
        })
    });



const $b0ddf8fab1b75813$export$f285ee3249f0f9e7 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.6 7.8l-2.6 2V8a3 3 0 00-3-3H5a3 3 0 00-3 3v8a3 3 0 003 3h9a3 3 0 003-3v-1.75l2.6 1.95A1.5 1.5 0 0022 15V9a1.5 1.5 0 00-2.4-1.2zm-8.38.2a1.34 1.34 0 11.02 2.68A1.34 1.34 0 0111.22 8zm-3.55.89a1.34 1.34 0 110 2.68 1.34 1.34 0 010-2.68zM13 15.11h-2.67a.89.89 0 01-.89.89H5.89a.89.89 0 01-.89-.89 2.67 2.67 0 012.67-2.67A2.61 2.61 0 019 12.8a2.67 2.67 0 014.92 1.42.89.89 0 01-.92.89z",
            fill: "currentColor"
        })
    });



const $a5a59b753180de89$export$b56b1a51efb79c12 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.91 10.51a1.11 1.11 0 00-.12-.27.249.249 0 010-.07c-.07-.099-.15-.19-.24-.27l-.06-.05a1.885 1.885 0 00-.23-.16h-.09a1.859 1.859 0 00-.31-.1h-.3l-.29.05h-.14a1.41 1.41 0 00-.42.22L17 11.75V11a3 3 0 00-3-3H5a3 3 0 00-3 3v6a3 3 0 003 3h9a3 3 0 003-3v-.75l2.6 1.95c.127.097.269.17.42.22h.14l.29.05c.1.01.2.01.3 0 .106-.024.21-.058.31-.1l.09-.05c.08-.047.157-.101.23-.16h.06c.09-.08.17-.171.24-.27a.249.249 0 010-.07 1.11 1.11 0 00.12-.27v-.1c.096-.135.164-.288.2-.45v-6a1.23 1.23 0 00-.06-.39l-.03-.1zm-1.83-6L18 6.12V5.5A2.451 2.451 0 0015.6 3H8.4A2.45 2.45 0 006 5.5V6h8a5 5 0 014.23 2.33l.17-.13a3.45 3.45 0 013.6-.35V5.5a1.2 1.2 0 00-1.92-1v.01z",
            fill: "currentColor"
        })
    });



const $567f689d04592990$export$3403f14c224a2199 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.6 7.8l-2.6 2V9c.015-.17.015-.34 0-.51L20.49 5a1.055 1.055 0 00-1.148-1.719c-.128.053-.244.13-.342.229L3.51 19A1.053 1.053 0 105 20.49L7.44 18H14a3 3 0 003-3v-.75l2.6 1.95A1.5 1.5 0 0022 15V9a1.5 1.5 0 00-2.4-1.2zM5 6a3 3 0 00-3 3v6a3 3 0 00.77 2l11-11H5z",
            fill: "currentColor"
        })
    });



const $69526323a63d5243$export$d5a1a7fd732e0cd9 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.6 7.8l-2.6 2V9a3 3 0 00-3-3H5a3 3 0 00-3 3v6a3 3 0 003 3h9a3 3 0 003-3v-.75l2.6 1.95A1.5 1.5 0 0022 15V9a1.5 1.5 0 00-2.4-1.2zM5 14a1 1 0 01-.71-1.71L6.59 10H6a1 1 0 010-2h3a1 1 0 01.92.62 1 1 0 01-.21 1.09l-4 4A1 1 0 015 14zm7 2H9a1 1 0 01-.92-.62 1 1 0 01.21-1.09l4-4a1.004 1.004 0 011.42 1.42L11.41 14H12a1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $747bc7aa58ff7aef$export$e5faa45ff5bbf05a = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.6 7.8l-2.6 2V9a3 3 0 00-3-3H5a3 3 0 00-3 3v6a3 3 0 003 3h9a3 3 0 003-3v-.75l2.6 1.95A1.5 1.5 0 0022 15V9a1.5 1.5 0 00-2.4-1.2zm-9.89 3.91L7.41 14H8a1 1 0 010 2H5a1.001 1.001 0 01-.38-.08 1 1 0 01-.54-.54A1 1 0 014 15v-3a1 1 0 112 0v.59l2.29-2.3a1.004 1.004 0 011.42 1.42z",
            fill: "currentColor"
        })
    });



const $4d056fd3ede1a7db$export$49ed6e10a0e30260 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.6 7.8l-2.6 2V9a3 3 0 00-3-3H5a3 3 0 00-3 3v6a3 3 0 003 3h9a3 3 0 003-3v-.75l2.6 1.95A1.5 1.5 0 0022 15V9a1.5 1.5 0 00-2.4-1.2zM15 12a1 1 0 01-2 0v-.59l-2.29 2.3a1.002 1.002 0 01-1.639-.325 1 1 0 01.219-1.095l2.3-2.29H11a1 1 0 110-2h3a1 1 0 01.38.08 1 1 0 01.54.54c.051.12.078.25.08.38v3z",
            fill: "currentColor"
        })
    });



const $86cd28fa7aa50dfa$export$dbc6a1d3b73f557f = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.78 8.21a1.508 1.508 0 00-1.42-.7c-.28.03-.54.13-.77.29l-2.6 2V9c0-.8-.32-1.56-.88-2.12S14.78 6 13.99 6H5c-.8 0-1.56.32-2.12.88S2 8.21 2 9v6c0 .8.32 1.56.88 2.12S4.21 18 5 18h9c.8 0 1.56-.32 2.12-.88S17 15.79 17 15v-.75l2.6 1.95c.22.17.49.27.77.29a1.508 1.508 0 001.42-.7c.15-.24.22-.51.22-.79V9c0-.28-.08-.55-.22-.79h-.01zM9.5 16c-.88 0-1.7-.29-2.39-.81v.04c0 .1-.07.19-.14.26-.2.2-.55.19-.74 0-.1-.1-.15-.23-.15-.37v-1.16c0-.14.06-.27.15-.37.1-.1.23-.15.37-.15h1.16c.14 0 .27.06.37.15.1.1.15.23.15.37 0 .14-.06.27-.15.37-.08.07-.17.13-.27.14h-.04c.49.34 1.07.52 1.69.52 1.65 0 3-1.35 3-3s-1.35-3-3-3c-1.32 0-2.5.88-2.88 2.14a.51.51 0 01-.62.34.505.505 0 01-.34-.62A4.03 4.03 0 019.5 7.99c2.21 0 4 1.79 4 4s-1.79 4-4 4V16z",
            fill: "currentColor"
        })
    });



const $cc1e8efe3ac86a56$export$1384193ae0285b02 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10 13.96h-.31c-.12 0-.15-.05-.15-.16v-1.1c0-.67-.51-.91-1.04-.91s-1.02.24-1.02.91v1.1c0 .11-.03.16-.15.16h-1.4c-.07 0-.15-.03-.15-.11 0-.05.1-.29.1-.29l2.46-5.95c.07-.16.1-.3.1-.43 0-.58-.66-.93-1.17-.93-.31 0-.62.16-.82.62l-2.84 6.95c-.21.5-.35.91-.35 1.18 0 .56.43.85 1.08.85h2.97c.12 0 .15.05.15.14v.62c0 .66.51.9 1.02.9s1.04-.24 1.04-.9v-.62c0-.1.03-.14.15-.14h.31c.62 0 .85-.46.85-.94 0-.48-.23-.94-.85-.94l.02-.01zm9.67-3.11h-2.43c-.67 0-.92.5-.92.99s.25 1.01.92 1.01h1.05c.1 0 .15.03.15.14v.61c0 .51-.05.78-.26 1.09-.51.75-1.26.8-1.71.8-.45 0-1.28 0-1.71-.8-.33-.61-.33-1.55-.33-2.82 0-1.27.02-2.21.33-2.82.43-.83 1.31-.83 1.84-.83.72 0 1.13.11 1.81.51.15.1.31.16.54.16.51 0 1.05-.56 1.05-1.04 0-.43-.25-.66-.56-.88-.72-.53-1.68-.74-2.88-.74-1.38 0-2.5.21-3.38 1.2-.66.74-.97 2.27-.97 4.43 0 2.16.31 3.7.97 4.43.89.99 1.92 1.2 3.29 1.2s2.43-.19 3.29-1.2c.64-.77.79-1.57.79-2.69v-1.92c0-.53-.35-.85-.87-.85l-.01.02z",
            fill: "currentColor"
        })
    });



const $6e025e7b20beb496$export$557f1e1834b7d579 = (s)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...s,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M5 10h3v1c0 .55.45 1 1 1s1-.45 1-1v-1c.55 0 1-.45 1-1s-.45-1-1-1V7c0-.55-.45-1-1-1s-1 .45-1 1v1H6.48l1.45-3.63a.994.994 0 00-.56-1.3.99.99 0 00-1.3.56l-2 5c-.12.31-.09.66.1.93s.5.44.83.44zm10.75 2c2.07 0 3.75-1.68 3.75-3.75V7.5c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1s.45 1 1 1h.98c-.12.85-.85 1.5-1.73 1.5-.96 0-1.75-.79-1.75-1.75v-1.5c0-.96.79-1.75 1.75-1.75.41 0 .8.14 1.11.4.43.35 1.06.29 1.41-.13.35-.43.29-1.06-.13-1.41-.67-.55-1.52-.86-2.39-.86C13.68 3 12 4.68 12 6.75v1.5c0 2.07 1.68 3.75 3.75 3.75zM8 19H6v-5c0-.55-.45-1-1-1s-1 .45-1 1v6c0 .55.45 1 1 1h3c.55 0 1-.45 1-1s-.45-1-1-1zm5.5-6h-5c-.55 0-1 .45-1 1s.45 1 1 1H10v5c0 .55.45 1 1 1s1-.45 1-1v-5h1.5c.55 0 1-.45 1-1s-.45-1-1-1zm5.5 6h-2v-1h1.25c.55 0 1-.45 1-1s-.45-1-1-1H17v-1h2c.55 0 1-.45 1-1s-.45-1-1-1h-3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h3c.55 0 1-.45 1-1s-.45-1-1-1z",
            fill: "currentColor"
        })
    });



const $c6e6019f3317e922$export$ee02956505b6b51b = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7.07 9.86c-.39 0-.79.06-1.15.26-.06.03-.14.1-.21.1-.08 0-.11-.05-.11-.11v-1.7c0-.13.03-.14.14-.14H8.6c.68 0 .93-.42.93-.94 0-.5-.25-.98-.93-.98H4.49c-.52 0-.9.35-.9.93v4.56c0 .7.51.99 1.14.99.43 0 .63-.29.92-.56.27-.26.62-.51 1.07-.51 1.17 0 1.41.9 1.41 1.95 0 1.47-.6 1.94-1.41 1.94-.76 0-1.3-.48-1.53-.77-.25-.3-.46-.35-.66-.35-.55 0-1.06.64-1.06 1.04 0 .26.16.51.28.66.35.38 1.22 1.33 3.02 1.33 2.02 0 3.4-1.25 3.4-3.84 0-2.16-.85-3.84-3.1-3.84v-.02zm11.77 1.02H16.5c-.65 0-.88.5-.88.99s.24 1.01.88 1.01h1.01c.09 0 .14.03.14.14v.61c0 .51-.05.78-.25 1.09-.49.75-1.22.8-1.64.8-.42 0-1.23 0-1.64-.8-.32-.61-.32-1.55-.32-2.82 0-1.27.02-2.21.32-2.82.41-.83 1.26-.83 1.77-.83.7 0 1.09.11 1.74.51.14.1.3.16.52.16.49 0 1.01-.56 1.01-1.04 0-.43-.24-.66-.54-.88-.7-.53-1.61-.74-2.76-.74-1.33 0-2.4.21-3.25 1.2-.63.74-.93 2.27-.93 4.43 0 2.16.3 3.7.93 4.43.85.99 1.85 1.2 3.16 1.2s2.34-.19 3.16-1.2c.62-.77.76-1.57.76-2.69v-1.92c0-.53-.33-.85-.84-.85l-.01.02z",
            fill: "currentColor"
        })
    });



const $a3d7fa6f67d28ddb$export$daef89f00dda4431 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M6.08 9.88c-.35 0-.69.06-1.01.22-.06.03-.12.08-.18.08-.07 0-.1-.04-.1-.1V8.59c0-.11.03-.13.12-.13h2.5c.59 0 .82-.36.82-.83 0-.43-.22-.85-.82-.85H3.82c-.46 0-.79.31-.79.81v3.99c0 .62.44.87 1 .87.37 0 .55-.25.8-.49.24-.22.54-.45.94-.45 1.02 0 1.23.78 1.23 1.71 0 1.29-.53 1.69-1.23 1.69-.66 0-1.13-.42-1.34-.67-.22-.27-.4-.31-.58-.31-.48 0-.93.56-.93.91 0 .22.14.45.25.57.3.34 1.06 1.16 2.64 1.16 1.77 0 2.97-1.09 2.97-3.36 0-1.89-.75-3.36-2.71-3.36l.01.03zm9.83.9h-2.05c-.57 0-.77.43-.77.87s.21.88.77.88h.88c.08 0 .12.03.12.13v.53c0 .45-.04.69-.22.95-.43.66-1.06.7-1.44.7-.38 0-1.08 0-1.44-.7-.28-.53-.28-1.36-.28-2.47s.01-1.93.28-2.46c.36-.73 1.11-.73 1.55-.73.61 0 .95.1 1.52.45.12.08.26.14.46.14.43 0 .88-.49.88-.91 0-.38-.21-.57-.47-.77-.61-.46-1.41-.64-2.42-.64-1.16 0-2.1.18-2.85 1.05-.55.64-.82 1.99-.82 3.88s.26 3.24.82 3.88c.75.87 1.62 1.05 2.76 1.05 1.14 0 2.05-.17 2.76-1.05.54-.67.66-1.37.66-2.35v-1.68c0-.46-.29-.74-.73-.74l.03-.01zm5.72-2.94H20.2c-.07 0-.11-.04-.11-.11v-1.4c0-.4-.28-.54-.59-.54-.31 0-.59.14-.59.54v1.4c0 .07-.02.11-.11.11h-1.44c-.38 0-.52.25-.52.56 0 .31.14.58.52.58h1.44c.08 0 .11.02.11.11v1.46c0 .38.3.53.59.53s.59-.14.59-.53V9.09c0-.08.04-.11.11-.11h1.43c.39 0 .53-.28.53-.58 0-.3-.14-.56-.53-.56zm-.12 6.08h-1.4c-.07 0-.1-.04-.1-.11v-1.4c0-.4-.28-.54-.58-.54-.3 0-.58.14-.58.54v1.4c0 .07-.02.11-.1.11h-1.41c-.37 0-.51.25-.51.56 0 .31.14.58.51.58h1.41c.08 0 .1.02.1.11v1.46c0 .38.29.53.58.53s.58-.14.58-.53v-1.46c0-.08.04-.11.1-.11h1.4c.38 0 .52-.28.52-.58 0-.3-.14-.56-.52-.56z",
            fill: "currentColor"
        })
    });



const $c80492716f0abe7a$export$783703101dce8daf = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M5.08 9.88c-.35 0-.69.06-1.01.22-.05.03-.12.08-.18.08-.07 0-.1-.04-.1-.1V8.59c0-.11.03-.13.12-.13h2.5c.59 0 .82-.36.82-.83 0-.43-.22-.85-.82-.85H2.82c-.46 0-.79.31-.79.81v3.99c0 .62.44.87 1 .87.37 0 .55-.25.8-.49.23-.22.54-.45.94-.45 1.02 0 1.23.78 1.23 1.71 0 1.29-.53 1.69-1.23 1.69-.66 0-1.13-.42-1.34-.67-.22-.27-.4-.31-.58-.31-.48 0-.93.56-.93.91 0 .22.14.45.25.57.3.34 1.06 1.16 2.64 1.16 1.77 0 2.97-1.09 2.97-3.36 0-1.89-.75-3.36-2.71-3.36l.01.03zm9.83.9h-2.05c-.57 0-.77.43-.77.87s.21.88.77.88h.88c.08 0 .12.03.12.13v.53c0 .45-.04.69-.22.95-.43.66-1.06.7-1.44.7-.38 0-1.08 0-1.44-.7-.28-.53-.28-1.36-.28-2.47s.01-1.93.28-2.46c.36-.73 1.11-.73 1.55-.73.61 0 .95.1 1.52.45.12.08.26.14.46.14.43 0 .88-.49.88-.91 0-.38-.21-.57-.47-.77-.61-.46-1.41-.64-2.42-.64-1.16 0-2.1.18-2.85 1.05-.55.64-.82 1.99-.82 3.88s.26 3.24.82 3.88c.75.87 1.62 1.05 2.76 1.05 1.14 0 2.05-.17 2.76-1.05.54-.67.66-1.37.66-2.35v-1.68c0-.46-.29-.74-.73-.74l.03-.01zm6.35.84h-1.43c-.07 0-.11-.04-.11-.11v-1.4c0-.4-.28-.54-.59-.54-.31 0-.59.14-.59.54v1.4c0 .07-.02.11-.11.11h-1.44c-.38 0-.52.25-.52.56 0 .31.14.58.52.58h1.44c.08 0 .11.02.11.11v1.46c0 .38.3.53.59.53s.59-.14.59-.53v-1.46c0-.08.04-.11.11-.11h1.43c.39 0 .53-.28.53-.58 0-.3-.14-.56-.53-.56z",
            fill: "currentColor"
        })
    });



const $898449b426655eac$export$ad8b1aaf67880d29 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.46 4.68c-.34-.37-.8-.6-1.3-.66-2.2-.23-4.35-.85-6.34-1.83-.26-.13-.54-.19-.82-.19-.28 0-.56.07-.82.19-1.97.98-4.11 1.6-6.3 1.83-.5.04-.97.27-1.32.64-.35.37-.55.85-.56 1.36v4.99C3 17.75 9.75 22 12 22s9-4.25 9-10.99V6.02c-.01-.5-.2-.97-.54-1.34zm-4.92 9.44a.996.996 0 11-1.41 1.41l-2.12-2.12-2.12 2.12a.996.996 0 11-1.41-1.41L10.6 12 8.48 9.88a.996.996 0 111.41-1.41l2.12 2.12 2.12-2.12a.996.996 0 111.41 1.41L13.42 12l2.12 2.12z",
            fill: "currentColor"
        })
    });



const $0950f00a2ea761f9$export$40eb74ef6c7abe0a = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M8.45 12h1.6l-.8-1.78-.8 1.78zm5.93-2.5H14v4h.38c.7 0 1.23-.17 1.59-.53.44-.44.54-1.04.54-1.47 0-1.25-.79-2-2.12-2h-.01zm6.09-4.82c-.34-.37-.8-.6-1.3-.66-2.2-.23-4.35-.85-6.34-1.83-.26-.13-.54-.19-.82-.19-.28 0-.56.07-.82.19-1.97.98-4.11 1.6-6.3 1.83-.5.04-.97.27-1.32.64-.35.37-.55.85-.56 1.36v4.99c0 6.74 6.75 10.99 9 10.99s9-4.25 9-10.99V6.02c-.01-.5-.2-.97-.54-1.34zm-8.75 9.78a.522.522 0 01-.67-.25L10.51 13h-2.5l-.54 1.21c-.11.25-.41.36-.66.25a.502.502 0 01-.25-.66l2.25-5c.16-.36.75-.36.91 0l2.25 5c.11.25 0 .55-.25.66zm4.96-.77c-.54.53-1.31.81-2.24.81h-.93c-.28 0-.5-.22-.5-.5V9c0-.28.22-.5.5-.5h.88c1.87 0 3.12 1.21 3.12 3 0 .89-.29 1.65-.83 2.19z",
            fill: "currentColor"
        })
    });



const $7aa7ec7365e4e9df$export$ddf52a795412a476 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M14 11h8a10 10 0 00-9-8.95v8a1 1 0 001 .95zm-3-1V2.05A10 10 0 1022 13h-8a3 3 0 01-3-3z",
            fill: "currentColor"
        })
    });



const $7dc3ad2a2f60db63$export$6370056ad1510856 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 11.5a1 1 0 000-2 2.5 2.5 0 000 5 1 1 0 000-2 .5.5 0 010-1zm-4.24 3.33a1 1 0 000 1.41A5.93 5.93 0 0012 18a6 6 0 100-12 5.93 5.93 0 00-4.24 1.76 1 1 0 001.41 1.41 4 4 0 110 5.66 1 1 0 00-1.41 0zM12 2a1 1 0 100 2 8 8 0 11-8 8 1 1 0 10-2 0A10 10 0 1012 2z",
            fill: "currentColor"
        })
    });



const $abca275dfc054a60$export$da31e52c4c48452a = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 17a5 5 0 01-2-9.57V2.2A10 10 0 1021.8 14h-5.23A5 5 0 0112 17zm2-5h8A9.999 9.999 0 0012 2v8a2 2 0 002 2z",
            fill: "currentColor"
        })
    });



const $2a6fd3877f58affa$export$882c6e7a935d78b1 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16.9 11H22a10 10 0 00-9-8.95V7.1a5 5 0 013.9 3.9zM13 16.89V22a10 10 0 009-9h-5.1a5 5 0 01-3.9 3.89zM2 12a10 10 0 009 10v-5.1a5 5 0 010-9.8v-5A10 10 0 002 12z",
            fill: "currentColor"
        })
    });



const $981d2b2088488291$export$a88411281a66bd44 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.72 5.66l-3.57 3.57a5 5 0 11-8.35 0L4.23 5.66a10 10 0 1015.49 0zm-5 2.16l3.58-3.57a10 10 0 00-12.65 0l3.57 3.57a5 5 0 015.51 0h-.01z",
            fill: "currentColor"
        })
    });



const $77fb9cce5ac847da$export$2d7e0408cbf539fa = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 19H5v-1.91h1.18c7 0 10.16-4.08 12.68-9.39l.19.58A1 1 0 0020 9c.106.014.214.014.32 0A1 1 0 0021 7.68l-1-3a1 1 0 00-1.27-.63l-3 1A1.019 1.019 0 1016.32 7l.84-.28C14.68 12 11.86 15.53 5 15.07V4a1 1 0 00-2 0v16a1 1 0 001 1h16a1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $5090970aaa70234c$export$22d908d9b2914199 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M13 11h-2a1 1 0 00-1 1v9a1 1 0 001 1h2a1 1 0 001-1v-9a1 1 0 00-1-1zm-6 4H5a1 1 0 00-1 1v5a1 1 0 001 1h2a1 1 0 001-1v-5a1 1 0 00-1-1zm3.71-8.71a1 1 0 00-1.42 0l-1 1a1 1 0 000 1.42 1 1 0 001.42 0l1-1a1 1 0 000-1.42zM19 7h-2a1 1 0 00-1 1v13a1 1 0 001 1h2a1 1 0 001-1V8a1 1 0 00-1-1zM9 2a5 5 0 00-5 5 1 1 0 002 0 3 3 0 116 0 1 1 0 002 0 5 5 0 00-5-5z",
            fill: "currentColor"
        })
    });



const $c7827672a2ef5d35$export$c4b02b6ef51e22cc = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M5 8h11.59l-.3.29a1.001 1.001 0 00.325 1.639 1 1 0 001.095-.22l2-2a1 1 0 000-1.42l-2-2a1.003 1.003 0 10-1.42 1.42l.3.29H5a1 1 0 000 2zm2 6H5a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1zm6 0h-2a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1zm6 0h-2a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $ff7b7005f1145983$export$f4a3680c2f141f35 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M13 14h-2a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1zm-6 3H5a1 1 0 00-1 1v3a1 1 0 001 1h2a1 1 0 001-1v-3a1 1 0 00-1-1zm12-7h-2a1 1 0 00-1 1v10a1 1 0 001 1h2a1 1 0 001-1V11a1 1 0 00-1-1zm0-8h-3a1 1 0 100 2h.63C14.22 6.43 10.12 10 5 10a1 1 0 000 2c5.87 0 10.37-3.9 13-6.54V6a1 1 0 002 0V3a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $4855dc4ed57d6cd6$export$4d93a77e244427a0 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16.7 11.88l-.41.41a1 1 0 000 1.42 1.002 1.002 0 001.42 0l2-2a1.001 1.001 0 000-1.42l-2-2a1.003 1.003 0 10-1.42 1.42l.13.13C11.79 9.25 8.54 7 5.86 2.49a1 1 0 00-1.72 1c3.11 5.2 7.05 7.84 12.56 8.39zM7 10H5a1 1 0 00-1 1v10a1 1 0 001 1h2a1 1 0 001-1V11a1 1 0 00-1-1zm12 7h-2a1 1 0 00-1 1v3a1 1 0 001 1h2a1 1 0 001-1v-3a1 1 0 00-1-1zm-6-3h-2a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $c38a72ea5803f1dd$export$79e2acaaab7df541 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7 15H5a1 1 0 00-1 1v5a1 1 0 001 1h2a1 1 0 001-1v-5a1 1 0 00-1-1zm2-9H7l1.8-2.4a1 1 0 10-1.6-1.2l-3 4a1 1 0 00-.09 1A1 1 0 005 8h2l-1.8 2.4a1 1 0 001.6 1.2l3-4a1 1 0 00.09-1A1 1 0 009 6zm4 5h-2a1 1 0 00-1 1v9a1 1 0 001 1h2a1 1 0 001-1v-9a1 1 0 00-1-1zm6-4h-2a1 1 0 00-1 1v13a1 1 0 001 1h2a1 1 0 001-1V8a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $fd1542df9a3cffeb$export$cb8f4cef95f78418 = (r)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M15.5 7h4c0-.53-.21-1.04-.59-1.41l-3-3c-.37-.38-.88-.59-1.41-.59v4c0 .27.11.52.29.71.19.19.44.29.71.29z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M13.38 8.12c-.56-.56-.88-1.33-.88-2.12V2H7c-.66 0-1.3.26-1.77.73S4.5 3.83 4.5 4.5v15c0 .66.26 1.3.73 1.77S6.33 22 7 22h10c.66 0 1.3-.26 1.77-.73s.73-1.1.73-1.77V9h-4c-.8 0-1.56-.32-2.12-.88zM9.61 18.4c-.17.21-.64.58-1.4.58-.45 0-1.06-.13-1.4-.59-.28-.37-.34-.98-.34-1.75s.05-1.39.34-1.75c.37-.46.9-.59 1.4-.59.46 0 .87.13 1.19.39.15.13.26.23.26.46 0 .25-.27.56-.54.56-.13 0-.21-.02-.29-.09-.23-.21-.36-.25-.59-.25-.18 0-.39.09-.49.27-.11.2-.11.53-.11.99 0 .46 0 .79.11.99.11.2.29.27.49.27.17 0 .41-.08.62-.29.09-.09.19-.16.34-.16.27 0 .56.33.56.56 0 .19-.07.28-.16.39l.01.01zm2.28.58c-.67 0-1.27-.22-1.6-.58-.07-.09-.17-.2-.17-.37 0-.27.27-.54.55-.54.13 0 .25.08.36.17.29.2.56.26.86.26.32 0 .54-.13.54-.34 0-.15-.15-.23-.42-.32l-.59-.2c-.76-.25-1.23-.62-1.23-1.39 0-.77.67-1.35 1.7-1.35.61 0 1.01.19 1.31.41.15.11.23.25.23.41 0 .27-.29.56-.52.56-.14 0-.21-.05-.3-.1-.23-.13-.5-.21-.72-.21-.32 0-.53.11-.53.28 0 .13.15.23.4.32l.59.2c.81.27 1.25.69 1.25 1.39 0 .88-.7 1.41-1.71 1.41v-.01zm3.83-2.03c.06 0 .07-.1.13-.27l.62-2.01c.09-.28.27-.36.46-.36.28 0 .6.18.6.51 0 .07 0 .13-.03.21l-1.11 3.41c-.12.37-.34.54-.66.54s-.55-.17-.66-.54l-1.11-3.41c-.03-.08-.03-.15-.03-.21 0-.31.3-.51.6-.51.19 0 .37.09.46.36l.62 2.01c.05.17.07.27.13.27h-.02z",
                fill: "currentColor"
            })
        ]
    });



const $ba102e2abb13e1d6$export$1073f10bd2313b73 = (o)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M11.97 17.82c-1.65 0-3.16-.2-4.43-.55-1.17-.31-2.11-.76-2.76-1.28v1.28c0 1.48 3.3 2.72 7.21 2.72s7.21-1.24 7.21-2.72v-1.28c-.64.52-1.61.96-2.8 1.28-1.25.35-2.78.55-4.43.55zM11.99 13.94c-1.65 0-3.18-.19-4.43-.52-1.17-.3-2.12-.71-2.76-1.2v1.2c0 1.4 3.3 2.57 7.21 2.57s7.21-1.17 7.21-2.57v-1.2c-.66.49-1.63.91-2.8 1.2-1.27.33-2.78.52-4.43.52zM16.42 9.27c-1.27.35-2.78.55-4.43.55s-3.18-.2-4.43-.55c-1.17-.31-2.12-.76-2.76-1.28v1.28c0 1.48 3.3 2.72 7.21 2.72s7.21-1.24 7.21-2.72V7.99c-.66.52-1.63.96-2.8 1.28z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M11.99 8c3.982 0 7.21-1.343 7.21-3s-3.228-3-7.21-3C8.008 2 4.78 3.343 4.78 5s3.228 3 7.21 3z",
                fill: "currentColor"
            })
        ]
    });



const $62a12a4b1e81601b$export$23584e69445bd2dc = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M14.5 19a1.51 1.51 0 00-1.38.91c-.37.06-.745.09-1.12.09A8 8 0 015.8 7H6a1.5 1.5 0 10-1.49-1.6 10 10 0 009.3 16.43 1.6 1.6 0 00.69.17 1.51 1.51 0 001.5-1.45v-.05a1.5 1.5 0 00-1.5-1.5zm-5-14a1.51 1.51 0 001.38-.9 7.82 7.82 0 015.63 1.31v.09A1.5 1.5 0 1018 4a9.9 9.9 0 00-7.76-1.82A1.53 1.53 0 009.5 2a1.5 1.5 0 100 3zm12.33 5.19c.108-.214.166-.45.17-.69A1.51 1.51 0 0020.55 8h-.05a1.5 1.5 0 00-.59 2.88c.06.37.09.745.09 1.12a8 8 0 01-1.8 5 1.5 1.5 0 101.8 1.5 1.55 1.55 0 00-.07-.43 9.888 9.888 0 001.9-7.88zM12 10a2 2 0 100 4 2 2 0 000-4zm6.5 1.5a1.5 1.5 0 10-2.56 1.06 4 4 0 11-4.5-4.5 1.51 1.51 0 10-.08-2 6 6 0 106.6 6.6 1.48 1.48 0 00.54-1.16z",
            fill: "currentColor"
        })
    });



const $b65694f2762dd797$export$780340da92a1b4db = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.5 10.5a1.502 1.502 0 00-1.11.5h-4l3-3h.08A1.5 1.5 0 1016 6.5v.08l-3 3v-4a1.5 1.5 0 10-2 0v4l-3-3V6.5A1.5 1.5 0 106.5 8h.08l3 3h-4a1.5 1.5 0 100 2h4l-3 3H6.5A1.5 1.5 0 108 17.5v-.08l3-3v4a1.5 1.5 0 102 0v-4l3 3v.08a1.5 1.5 0 101.5-1.5h-.08l-3-3h4a1.5 1.5 0 101.11-2.5h-.03zm-6.79 2.21a.999.999 0 11-1.407-1.418.999.999 0 011.407 1.418z",
            fill: "currentColor"
        })
    });



const $19116fa24372f400$export$723a25bb50401fe2 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 10a2 2 0 10-2-2 1.37 1.37 0 000 .19l-3.3 2.35a2.999 2.999 0 00-.72-.36V5.72A2 2 0 0014 4a2 2 0 10-4 0 2 2 0 001 1.72v4.46A3 3 0 009.18 12H6.72A2 2 0 005 11a2 2 0 100 4 2 2 0 001.72-1h2.46a3.1 3.1 0 001.08 1.44l-.75 2.63A2 2 0 1012 20a2 2 0 00-.56-1.39l.75-2.61a2.88 2.88 0 001.33-.41L16 17.66V18a2 2 0 102-2 1.909 1.909 0 00-.68.13L14.81 14c.115-.321.18-.659.19-1a2.76 2.76 0 00-.13-.82l3.31-2.36A2 2 0 0019 10z",
            fill: "currentColor"
        })
    });



const $ab278964fcea4645$export$d8ed26f6b56d7cb = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M13 6V2H7.5A2.5 2.5 0 005 4.5v15A2.5 2.5 0 007.5 22h10a2.5 2.5 0 002.5-2.5V9h-4a3 3 0 01-3-3zm3 1h4a2 2 0 00-.59-1.41l-3-3A2 2 0 0015 2v4a1 1 0 001 1z",
            fill: "currentColor"
        })
    });



const $4fcd28204b117471$export$239e388a824fc446 = (l)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8.86 15.53h-.54s-.06.01-.06.06v2.3s.01.06.06.06h.54c.19 0 .38-.07.49-.24.1-.17.11-.56.11-.97 0-.41 0-.79-.11-.97-.1-.17-.29-.24-.49-.24zM12.76 15.5c-.2 0-.38.08-.49.27-.1.18-.11.56-.11.97 0 .41.01.79.11.97.1.19.29.27.49.27s.38-.08.49-.27c.1-.17.11-.56.11-.97 0-.41-.01-.79-.11-.97-.1-.19-.29-.27-.49-.27z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M19.27 2.73C18.8 2.26 18.17 2 17.5 2H10c-.53 0-1.04.21-1.41.59l-3 3C5.21 5.96 5 6.47 5 7v12.5c0 .66.26 1.3.73 1.77s1.1.73 1.77.73h10c.66 0 1.3-.26 1.77-.73s.73-1.1.73-1.77v-15c0-.66-.26-1.3-.73-1.77zm-9 15.72c-.36.44-.85.55-1.37.55H7.67c-.27 0-.52-.12-.52-.49v-3.54c0-.37.25-.5.52-.5H8.9c.52 0 1.01.11 1.37.55.27.33.33.92.33 1.71 0 .79-.06 1.39-.33 1.72zm3.9 0c-.36.46-.89.58-1.41.58-.52 0-1.05-.12-1.41-.58-.27-.34-.33-.92-.33-1.71 0-.79.06-1.37.33-1.71.36-.46.89-.58 1.41-.58.52 0 1.05.12 1.41.58.27.34.33.92.33 1.71 0 .79-.06 1.37-.33 1.71zm3.82 0c-.16.2-.62.57-1.37.57-.44 0-1.03-.13-1.37-.58-.27-.36-.33-.96-.33-1.71s.05-1.37.33-1.71c.36-.46.88-.58 1.37-.58.45 0 .85.12 1.16.38.14.12.25.23.25.45 0 .25-.27.55-.53.55-.12 0-.21-.02-.28-.08-.22-.2-.35-.24-.58-.24-.18 0-.38.08-.48.27-.1.2-.11.52-.11.97 0 .45 0 .77.11.97.1.2.28.27.48.27.17 0 .4-.08.61-.29.09-.09.19-.16.33-.16.26 0 .55.32.55.55 0 .18-.05.26-.14.37z",
                fill: "currentColor"
            })
        ]
    });



const $bcbd0c3359b8a691$export$4c77dda49cc3c71b = (l)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12.4 15.54h-.66s-.06.01-.06.06v.78s.01.06.06.06h.66c.25 0 .42-.16.42-.44s-.17-.46-.42-.46z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M19.27 2.73C18.8 2.26 18.17 2 17.5 2H10c-.53 0-1.04.21-1.41.59l-3 3C5.21 5.96 5 6.47 5 7v12.5c0 .66.26 1.3.73 1.77s1.1.73 1.77.73h10c.66 0 1.3-.26 1.77-.73s.73-1.1.73-1.77v-15c0-.66-.26-1.3-.73-1.77zM9.78 17.69c0 .85-.54 1.34-1.42 1.34-.48 0-.88-.21-1.12-.62a.515.515 0 01-.08-.27c0-.26.28-.49.54-.49.13 0 .26.06.36.21.05.08.14.12.25.12.19 0 .36-.12.36-.38v-2.68c0-.37.3-.46.55-.46.26 0 .56.09.56.46v2.77zm2.77-.21l-.81.01s-.06.01-.06.06v1.01c0 .37-.3.46-.56.46-.26 0-.55-.09-.55-.46v-3.59c0-.37.25-.5.52-.5h1.46c.78 0 1.4.49 1.4 1.51s-.62 1.5-1.4 1.5zm5.15-.08c0 .47-.15.85-.31 1.06-.36.45-.85.57-1.36.57-.51 0-1.05-.12-1.41-.58-.27-.34-.33-.92-.33-1.71 0-.79.06-1.37.33-1.71.36-.46.88-.58 1.42-.58.47 0 .87.1 1.18.32.14.1.23.2.23.43 0 .26-.27.55-.53.55-.12 0-.2-.04-.27-.08-.23-.13-.36-.18-.6-.18-.22 0-.41.08-.51.27-.1.18-.11.56-.11.97 0 .41.01.79.11.97.1.19.29.27.49.27s.32-.07.44-.19c.05-.04.12-.19.12-.31v-.04s-.02-.06-.06-.06h-.08c-.36 0-.47-.25-.47-.52s.11-.53.47-.53h.84c.26 0 .4.17.4.4l.01.68z",
                fill: "currentColor"
            })
        ]
    });



const $6a1f92269a9adff4$export$a62c059138cbc0d6 = (h)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M18.27 2.73C17.8 2.26 17.17 2 16.5 2H9c-.53 0-1.04.21-1.41.59l-3 3C4.21 5.96 4 6.47 4 7v12.5c0 .66.26 1.3.73 1.77s1.1.73 1.77.73h10c.66 0 1.3-.26 1.77-.73s.73-1.1.73-1.77v-15c0-.66-.26-1.3-.73-1.77zM8.98 18.41c-.37.46-.91.59-1.43.59-.52 0-1.06-.12-1.43-.59-.27-.34-.34-.94-.34-1.74s.07-1.39.34-1.74c.37-.46.9-.59 1.43-.59.53 0 1.06.13 1.43.59.27.34.34.94.34 1.74s-.07 1.39-.34 1.74zm4.15 0c-.36.45-.86.56-1.39.56h-1.25c-.28 0-.53-.12-.53-.5v-3.59c0-.38.25-.51.53-.51h1.25c.53 0 1.02.11 1.39.56.28.34.34.94.34 1.74s-.06 1.4-.34 1.74zm3.61-2.97h-.67s-.06.01-.06.06v3.03c0 .38-.3.47-.56.47-.26 0-.57-.09-.57-.47V15.5s-.01-.06-.06-.06h-.65c-.37 0-.48-.26-.48-.53 0-.28.11-.54.48-.54h2.56c.37 0 .48.26.48.54s-.11.53-.48.53h.01z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M11.7 15.44h-.55s-.06.01-.06.06v2.34s.01.06.06.06h.55c.2 0 .39-.07.5-.24.1-.17.11-.57.11-.98 0-.41 0-.81-.11-.99-.1-.17-.3-.24-.5-.24v-.01zM7.54 15.42c-.2 0-.39.08-.5.27-.1.18-.11.57-.11.99 0 .42.01.81.11.98.11.19.3.27.5.27s.39-.08.5-.27c.1-.18.11-.57.11-.98 0-.41-.01-.81-.11-.99a.552.552 0 00-.5-.27z",
                fill: "currentColor"
            })
        ]
    });



const $1b8ea6622f27aafc$export$deb5cb0c442ff413 = (h)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M19.27 2.73C18.8 2.26 18.17 2 17.5 2H10c-.53 0-1.04.21-1.41.59l-3 3C5.21 5.96 5 6.47 5 7v12.5c0 .66.26 1.3.73 1.77s1.1.73 1.77.73h10c.66 0 1.3-.26 1.77-.73s.73-1.1.73-1.77v-15c0-.66-.26-1.3-.73-1.77zM9.08 17.47h-.82s-.06.01-.06.06v1.01c0 .37-.3.46-.56.46-.26 0-.55-.09-.55-.46v-3.59c0-.37.25-.5.52-.5h1.46c.78 0 1.4.49 1.4 1.51s-.61 1.51-1.39 1.51zm5.07.96c-.36.44-.84.55-1.36.55h-1.23c-.27 0-.52-.12-.52-.49v-3.54c0-.37.25-.5.52-.5h1.23c.52 0 1.01.11 1.36.55.27.33.33.92.33 1.71 0 .79-.06 1.39-.33 1.72zm3.57-2.92h-1.44s-.06.01-.06.06v.49s.01.06.06.06h1.03c.36 0 .47.25.47.53s-.11.52-.47.52h-1.03s-.06.01-.06.06v1.31c0 .37-.3.46-.56.46-.26 0-.55-.09-.55-.46v-3.59c0-.37.25-.5.52-.5h2.08c.36 0 .47.25.47.53s-.1.53-.46.53z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8.92 15.51h-.66s-.06.01-.06.06v.78s.01.06.06.06h.66c.25 0 .42-.16.42-.44s-.17-.46-.42-.46zM12.74 15.51h-.54s-.06.01-.06.06v2.3s.01.06.06.06h.54c.2 0 .38-.07.49-.24.1-.17.11-.56.11-.97 0-.41 0-.79-.11-.97-.1-.17-.29-.24-.49-.24z",
                fill: "currentColor"
            })
        ]
    });



const $39dc808d0c958fd1$export$f6b4a1ef510e4247 = (l)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8.75 15.54h-.66s-.06.01-.06.06v.78s.01.06.06.06h.66c.25 0 .42-.16.42-.44s-.17-.46-.42-.46z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M19.27 2.73C18.8 2.26 18.17 2 17.5 2H10c-.53 0-1.04.21-1.41.59l-3 3C5.21 5.96 5 6.47 5 7v12.5c0 .66.26 1.3.73 1.77s1.1.73 1.77.73h10c.66 0 1.3-.26 1.77-.73s.73-1.1.73-1.77v-15c0-.66-.26-1.3-.73-1.77zM8.91 17.49h-.82s-.06.01-.06.06v1.01c0 .37-.3.46-.56.46-.26 0-.55-.09-.55-.46v-3.59c0-.37.25-.5.52-.5H8.9c.78 0 1.4.49 1.4 1.51s-.61 1.51-1.39 1.51zm5.34.96c0 .44-.22.57-.58.57-.25 0-.42-.08-.59-.4l-1.02-1.88s-.02-.04-.05-.04c-.03 0-.03.05-.03.05v1.81c0 .37-.3.46-.56.46-.26 0-.55-.09-.55-.46v-3.54c0-.44.22-.57.58-.57.25 0 .42.08.59.4l1.02 1.85s.02.04.05.04c.03 0 .03-.05.03-.05v-1.77c0-.37.3-.46.56-.46.26 0 .55.09.55.46v3.54-.01zm4.06-1.05c0 .47-.15.85-.31 1.06-.36.45-.85.57-1.36.57-.51 0-1.05-.12-1.41-.58-.27-.34-.33-.92-.33-1.71 0-.79.06-1.37.33-1.71.36-.46.88-.58 1.42-.58.47 0 .87.1 1.18.32.14.1.23.2.23.43 0 .26-.27.55-.53.55-.12 0-.19-.04-.27-.08-.23-.13-.36-.18-.6-.18-.22 0-.41.08-.51.27-.1.18-.11.56-.11.97 0 .41.01.79.11.97.1.19.29.27.49.27s.32-.07.44-.19c.05-.04.12-.19.12-.31v-.04s-.02-.06-.06-.06h-.08c-.36 0-.47-.25-.47-.52s.11-.53.47-.53h.84c.26 0 .4.17.4.4l.01.68z",
                fill: "currentColor"
            })
        ]
    });



const $f3d534cd23043117$export$38ca6805e1805aff = (s)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...s,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M19.27 2.73C18.8 2.26 18.17 2 17.5 2H10c-.53 0-1.04.21-1.41.59l-3 3C5.21 5.96 5 6.47 5 7v12.5c0 .66.26 1.3.73 1.77s1.1.73 1.77.73h10c.66 0 1.3-.26 1.77-.73s.73-1.1.73-1.77v-15c0-.66-.26-1.3-.73-1.77zM9.01 19.05c-.14 0-.29-.07-.41-.27l-.76-1.33c-.03-.06-.05-.06-.1-.06h-.35s-.06 0-.06.06v1.14c0 .37-.3.46-.56.46-.26 0-.54-.09-.54-.46v-3.58c0-.37.25-.5.52-.5H8.2c.78 0 1.39.47 1.39 1.45 0 .62-.21 1.02-.62 1.23-.03.01-.03.03-.03.04 0 0 0 .02.01.04l.56.97c.07.11.09.21.09.29 0 .28-.32.52-.6.52h.01zm4.21 0c-.19 0-.4-.09-.48-.36l-.12-.4c-.02-.05-.05-.08-.09-.08h-1.27s-.07.03-.09.08l-.12.4c-.08.27-.29.36-.48.36-.27 0-.57-.16-.57-.48 0-.06.01-.14.04-.22l1.12-3.27c.18-.51.5-.59.75-.59s.57.08.75.59l1.12 3.27c.03.08.04.16.04.22 0 .3-.28.48-.57.48h-.03zm5.97-3.9l-.89 3.44c-.05.19-.19.45-.5.45-.29 0-.47-.16-.56-.42l-.7-2.12s-.04-.18-.08-.18-.07.14-.08.18l-.7 2.12c-.09.27-.28.42-.56.42-.31 0-.45-.26-.5-.45l-.89-3.44a.615.615 0 01-.03-.18c0-.32.29-.49.59-.49.19 0 .39.09.46.39l.46 1.85c.03.13.03.23.07.23.04 0 .06-.11.1-.24l.51-1.72c.08-.27.19-.51.57-.51.38 0 .49.24.57.51l.51 1.72c.04.13.05.24.1.24s.04-.1.07-.23l.46-1.85c.07-.3.27-.39.46-.39.25 0 .59.15.59.49 0 .05 0 .11-.03.18z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8.05 15.56H7.4s-.06.01-.06.06v.65c0 .06.01.06.06.06h.65c.25 0 .42-.14.42-.38s-.17-.39-.42-.39zM11.97 15.86c-.03-.1-.03-.18-.08-.18s-.05.08-.08.18l-.36 1.28v.03c0 .03.02.05.05.05h.82s.05-.02.05-.05v-.03l-.4-1.28z",
                fill: "currentColor"
            })
        ]
    });



const $87c653365e411174$export$96fb173c8b38034b = (h)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M7.79 15.45h-.67s-.06.01-.06.06v.66c0 .06.01.06.06.06h.67c.25 0 .42-.14.42-.38s-.17-.4-.42-.4z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M18.27 2.73C17.8 2.26 17.17 2 16.5 2H9c-.53 0-1.04.21-1.41.59l-3 3C4.21 5.96 4 6.47 4 7v12.5c0 .66.26 1.3.73 1.77s1.1.73 1.77.73h10c.66 0 1.3-.26 1.77-.73s.73-1.1.73-1.77v-15c0-.66-.26-1.3-.73-1.77zM8.75 18.99c-.15 0-.28-.06-.4-.27l-.77-1.35c-.03-.06-.05-.06-.11-.06h-.36s-.06 0-.06.06v1.16c0 .38-.3.47-.57.47-.27 0-.56-.09-.56-.47v-3.65c0-.38.25-.51.53-.51h1.48c.79 0 1.42.48 1.42 1.47 0 .63-.21 1.04-.63 1.25-.03.01-.03.03-.03.05 0 0 0 .02.01.04l.57.98c.07.11.09.21.09.3 0 .28-.33.53-.61.53zm4.12-3.54h-.67s-.06.01-.06.06v3.03c0 .38-.3.47-.56.47-.26 0-.57-.09-.57-.47v-3.03s-.01-.06-.06-.06h-.65c-.37 0-.48-.26-.48-.53 0-.28.11-.54.48-.54h2.56c.37 0 .48.26.48.54s-.1.53-.47.53zm3.71 0h-1.46s-.06.01-.06.06v.5s.01.06.06.06h1.04c.37 0 .48.26.48.54s-.11.53-.48.53h-1.04s-.06.01-.06.06v1.33c0 .38-.3.47-.57.47-.27 0-.56-.09-.56-.47v-3.65c0-.38.25-.51.53-.51h2.11c.37 0 .48.26.48.54s-.1.54-.47.54z",
                fill: "currentColor"
            })
        ]
    });



const $ec1a118585a3117c$export$fcb327c733b2830c = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 7h4c0-.53-.21-1.04-.59-1.41l-3-3C16.03 2.21 15.53 2 15 2v4c0 .55.45 1 1 1zm-4 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm1-7V2H7.5A2.5 2.5 0 005 4.5v15A2.5 2.5 0 007.5 22h10a2.5 2.5 0 002.5-2.5V9h-4c-1.65 0-3-1.35-3-3zm3.58 6.93c.28.48.11 1.09-.37 1.37l-.27.16c.02.18.06.36.06.55 0 .19-.03.37-.06.55l.27.16c.48.28.64.89.37 1.37l-.5.87c-.28.48-.89.64-1.37.37l-.27-.16c-.29.23-.6.42-.94.56v.3c0 .55-.45 1-1 1h-1c-.55 0-1-.45-1-1v-.3c-.34-.14-.66-.33-.94-.56l-.27.16c-.48.28-1.09.11-1.37-.37l-.5-.87c-.28-.48-.11-1.09.37-1.37l.27-.16c-.02-.18-.06-.36-.06-.55 0-.19.03-.37.06-.55l-.27-.16a1.01 1.01 0 01-.37-1.37l.5-.87c.28-.48.89-.64 1.37-.37l.27.16c.29-.23.6-.42.94-.56v-.3c0-.55.45-1 1-1h1c.55 0 1 .45 1 1v.3c.34.14.66.33.94.56l.27-.16c.48-.28 1.09-.11 1.37.37l.5.87z",
            fill: "currentColor"
        })
    });



const $5da0f4a6141f9f95$export$8f1dec1a07ca97cb = (s)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...s,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.27 2.73C18.8 2.26 18.17 2 17.5 2H10c-.53 0-1.04.21-1.41.59l-3 3C5.21 5.96 5 6.47 5 7v12.5c0 .66.26 1.3.73 1.77s1.1.73 1.77.73h10c.66 0 1.3-.26 1.77-.73s.73-1.1.73-1.77v-15c0-.66-.26-1.3-.73-1.77zm-8.32 12.8h-.66s-.06.01-.06.06v2.98c0 .38-.3.46-.55.46-.26 0-.56-.08-.56-.46v-2.98s-.01-.06-.06-.06h-.64c-.36 0-.47-.25-.47-.52s.11-.53.47-.53h2.52c.36 0 .47.25.47.53s-.11.52-.47.52h.01zm2.16 3.04c0 .37-.3.46-.56.46-.26 0-.55-.09-.55-.46v-3.65c0-.37.3-.46.55-.46.26 0 .56.09.56.46v3.65zm3.47-3.04h-1.44s-.06.01-.06.06v.49s.01.06.06.06h1.03c.36 0 .47.25.47.53s-.11.52-.47.52h-1.03s-.06.01-.06.06v1.31c0 .37-.3.46-.56.46-.26 0-.55-.09-.55-.46v-3.59c0-.37.25-.5.52-.5h2.08c.36 0 .47.25.47.53s-.11.52-.47.52l.01.01z",
            fill: "currentColor"
        })
    });



const $c04c59e194e8aa1b$export$90707a6584dd0c95 = (s)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...s,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.27 2.73C18.8 2.26 18.17 2 17.5 2H10c-.53 0-1.04.21-1.41.59l-3 3C5.21 5.96 5 6.47 5 7v12.5c0 .66.26 1.3.73 1.77s1.1.73 1.77.73h10c.66 0 1.3-.26 1.77-.73s.73-1.1.73-1.77v-15c0-.66-.26-1.3-.73-1.77zm-9.19 12.8h-.66s-.06.01-.06.06v2.98c0 .38-.3.46-.55.46-.26 0-.56-.08-.56-.46v-2.98s-.01-.06-.06-.06h-.64c-.36 0-.47-.25-.47-.52s.11-.53.47-.53h2.52c.36 0 .47.25.47.53s-.11.52-.47.52h.01zm3.54 3.5c-.14 0-.28-.07-.4-.24l-.69-1.05s-.01-.03-.04-.03-.04.03-.04.03l-.69 1.05c-.12.18-.26.24-.4.24-.26 0-.59-.24-.59-.53 0-.09.03-.2.11-.31l.96-1.39s.02-.03.02-.05c0-.02-.02-.06-.02-.06l-.94-1.39a.556.556 0 01-.11-.31c0-.28.31-.53.59-.53.14 0 .28.07.4.25l.68 1.05s.01.03.04.03.04-.03.04-.03l.68-1.05c.12-.18.26-.25.4-.25.26 0 .59.24.59.53 0 .09-.03.19-.11.31l-.94 1.39s-.02.03-.02.06.02.05.02.05l.96 1.39c.08.12.11.22.11.31 0 .28-.31.53-.59.53h-.02zm3.82-3.5h-.66s-.06.01-.06.06v2.98c0 .38-.3.46-.55.46-.26 0-.56-.08-.56-.46v-2.98s-.01-.06-.06-.06h-.64c-.36 0-.47-.25-.47-.52s.11-.53.47-.53h2.52c.36 0 .47.25.47.53s-.11.52-.47.52h.01z",
            fill: "currentColor"
        })
    });



const $6a20796cdaecc378$export$74c54a309f3e59cf = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M13 6V2H7.5A2.5 2.5 0 005 4.5v15A2.5 2.5 0 007.5 22h10a2.5 2.5 0 002.5-2.5V9h-4a3 3 0 01-3-3zm-2 13a1.07 1.07 0 110-2.142A1.07 1.07 0 0111 19zm1.13-4l-.28.21a.86.86 0 01-1.71-.11 1.871 1.871 0 011-1.5c.49-.34.72-.53.72-1.07a1 1 0 00-.86-.86 1 1 0 00-.86.86.859.859 0 11-1.71 0A2.71 2.71 0 0111 10a2.71 2.71 0 012.57 2.57A2.83 2.83 0 0112.13 15zM16 7h4a2 2 0 00-.59-1.41l-3-3A2 2 0 0015 2v4a1 1 0 001 1z",
            fill: "currentColor"
        })
    });



const $4cea26f4edf15017$export$a5f1ab5a9c574ada = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.27 2.73C18.8 2.26 18.17 2 17.5 2H10c-.53 0-1.04.21-1.41.59l-3 3C5.21 5.96 5 6.47 5 7v12.5c0 .66.26 1.3.73 1.77s1.1.73 1.77.73h10c.66 0 1.3-.26 1.77-.73s.73-1.1.73-1.77v-15c0-.66-.26-1.3-.73-1.77zm-9.22 16.29c-.14 0-.28-.07-.4-.24l-.69-1.05s-.01-.03-.04-.03-.04.03-.04.03l-.69 1.05c-.12.18-.26.24-.4.24-.26 0-.59-.24-.59-.53 0-.09.03-.2.11-.31l.96-1.39s.02-.03.02-.05c0-.02-.02-.06-.02-.06l-.94-1.39a.556.556 0 01-.11-.31c0-.28.31-.53.59-.53.14 0 .28.07.4.25l.68 1.05s.01.03.04.03.04-.03.04-.03l.68-1.05c.12-.18.26-.25.4-.25.26 0 .59.24.59.53 0 .09-.03.19-.11.31l-.94 1.39s-.02.03-.02.06.02.05.02.05l.96 1.39c.08.12.11.22.11.31 0 .28-.31.53-.59.53h-.02zm3.43-.03h-1.79c-.29 0-.53-.1-.53-.49v-3.6c0-.37.3-.46.55-.46.26 0 .56.09.56.46v2.98s0 .06.05.06h1.16c.36 0 .47.25.47.53 0 .27-.11.52-.47.52zm2.56.03c-.66 0-1.25-.21-1.57-.57-.07-.08-.17-.2-.17-.36 0-.26.27-.53.54-.53.12 0 .24.08.36.16.29.19.55.25.84.25.31 0 .53-.12.53-.33 0-.15-.15-.22-.41-.31l-.58-.19c-.74-.25-1.2-.61-1.2-1.36 0-.75.66-1.33 1.66-1.33.6 0 .99.19 1.28.4.15.11.23.24.23.4 0 .27-.28.55-.51.55-.14 0-.21-.05-.29-.1-.22-.12-.49-.21-.7-.21-.31 0-.52.11-.52.27 0 .12.14.23.39.31l.58.2c.79.27 1.22.68 1.22 1.36 0 .86-.68 1.38-1.67 1.38l-.01.01z",
            fill: "currentColor"
        })
    });



const $8dd26cd76ebdae9b$export$415d11b3c88540cc = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18.77 2.73C18.3 2.26 17.67 2 17 2H9.5c-.53 0-1.04.21-1.41.59l-3 3c-.38.37-.59.88-.59 1.41v12.5c0 .66.26 1.3.73 1.77S6.33 22 7 22h10c.66 0 1.3-.26 1.77-.73s.73-1.1.73-1.77v-15c0-.66-.26-1.3-.73-1.77zM8.4 19c-.12 0-.24-.06-.34-.2l-.61-.92-.61.92c-.1.15-.22.2-.33.2-.22 0-.5-.2-.5-.45 0-.08.03-.16.09-.26l.81-1.18s.02-.02.02-.04-.02-.05-.02-.05l-.8-1.18a.45.45 0 01-.09-.26c0-.24.26-.45.5-.45.12 0 .24.06.34.21l.6.92.6-.92c.1-.15.22-.21.34-.21.22 0 .5.2.5.45 0 .08-.03.16-.09.26l-.8 1.18s-.02.03-.02.05c0 .02.02.04.02.04l.81 1.18c.07.1.09.19.09.26 0 .24-.27.45-.51.45zm2.9-.02H9.79c-.24 0-.45-.09-.45-.41v-3.05c0-.31.25-.39.46-.39.22 0 .47.08.47.39v2.52s0 .05.04.05h.98c.31 0 .4.21.4.45 0 .24-.08.44-.39.44zm2.16.02c-.56 0-1.06-.18-1.33-.48-.06-.07-.14-.16-.14-.31 0-.22.23-.45.46-.45.1 0 .2.07.3.14.24.17.47.21.71.21.26 0 .45-.1.45-.28 0-.13-.13-.19-.35-.26l-.49-.16c-.63-.21-1.02-.52-1.02-1.15 0-.63.55-1.12 1.41-1.12.51 0 .84.16 1.08.34.13.09.19.2.19.34 0 .23-.24.47-.43.47-.12 0-.18-.04-.25-.08-.19-.1-.42-.18-.59-.18-.26 0-.44.09-.44.23 0 .1.12.19.33.26l.49.16c.67.23 1.03.57 1.03 1.15 0 .73-.58 1.17-1.41 1.17zm4.04 0c-.12 0-.24-.06-.34-.2l-.61-.92-.61.92c-.1.15-.22.2-.33.2-.22 0-.5-.2-.5-.45 0-.08.03-.16.09-.26l.81-1.18s.02-.02.02-.04-.02-.05-.02-.05l-.8-1.18a.45.45 0 01-.09-.26c0-.24.26-.45.5-.45.12 0 .24.06.34.21l.6.92.6-.92c.1-.15.22-.21.34-.21.22 0 .5.2.5.45 0 .08-.03.16-.09.26l-.8 1.18s-.02.03-.02.05c0 .02.02.04.02.04l.81 1.18c.07.1.09.19.09.26 0 .24-.27.45-.51.45z",
            fill: "currentColor"
        })
    });



const $1899b52780d455ec$export$def84b0988449d3 = (r)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M15.5 7h4c0-.53-.21-1.04-.59-1.41l-3-3c-.37-.38-.88-.59-1.41-.59v4c0 .27.11.52.29.71.18.19.44.29.71.29z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M13.38 8.12c-.56-.56-.88-1.33-.88-2.12V2H7c-.66 0-1.3.26-1.77.73S4.5 3.83 4.5 4.5v15c0 .66.26 1.3.73 1.77S6.33 22 7 22h10c.66 0 1.3-.26 1.77-.73s.73-1.1.73-1.77V9h-4c-.8 0-1.56-.32-2.12-.88zm2.33 8.58l-3 3c-.09.09-.2.17-.33.22-.12.05-.25.08-.38.08s-.26-.03-.38-.08-.23-.12-.33-.22l-3-3a.996.996 0 111.41-1.41l1.29 1.29v-5.59c0-.55.45-1 1-1s1 .45 1 1v5.59l1.29-1.29a.996.996 0 111.41 1.41h.02z",
                fill: "currentColor"
            })
        ]
    });



const $c1221161cc95bfd2$export$f16b52ec039d447c = (r)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M16 7h4c0-.53-.21-1.04-.59-1.41l-3-3C16.04 2.21 15.53 2 15 2v4c0 .27.11.52.29.71.18.19.44.29.71.29z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M13.88 8.12C13.32 7.56 13 6.79 13 6V2H7.5c-.66 0-1.3.26-1.77.73S5 3.83 5 4.5v15c0 .66.26 1.3.73 1.77s1.1.73 1.77.73h10c.66 0 1.3-.26 1.77-.73s.73-1.1.73-1.77V9h-4c-.8 0-1.56-.32-2.12-.88zm3.04 7.5a1 1 0 01-.22 1.09l-3 3c-.2.2-.45.29-.71.29-.26 0-.51-.1-.71-.29a.996.996 0 010-1.41l1.29-1.29H8.98c-.55 0-1-.45-1-1s.45-1 1-1h4.59l-1.29-1.29a.996.996 0 111.41-1.41l3 3c.09.09.18.18.23.31z",
                fill: "currentColor"
            })
        ]
    });



const $878bb707c1fa8fe8$export$35fe2eb2c60c523d = (l)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M15 7h4c0-.53-.21-1.04-.59-1.41l-3-3C15.04 2.21 14.53 2 14 2v4c0 .27.11.52.29.71.18.19.44.29.71.29z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12.88 8.12C12.32 7.56 12 6.79 12 6V2H6.5c-.66 0-1.3.26-1.77.73S4 3.83 4 4.5v15c0 .66.26 1.3.73 1.77s1.1.73 1.77.73h10c.66 0 1.3-.26 1.77-.73s.73-1.1.73-1.77V9h-4c-.8 0-1.56-.32-2.12-.88zM15 17.99c0 .55-.45 1-1 1s-1-.45-1-1v-1.58L9.71 19.7c-.2.2-.45.29-.71.29-.26 0-.51-.1-.71-.29a.996.996 0 010-1.41L11.58 15H10c-.55 0-1-.45-1-1s.45-1 1-1h4c.13 0 .26.03.38.08.25.1.44.3.54.54.05.12.08.25.08.38v3.99z",
                fill: "currentColor"
            })
        ]
    });



const $45b3eb16ac0c5e8a$export$cc3efeae6c22f71d = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12.01 11c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm9.11-7.12C20.56 3.32 19.79 3 19 3H5c-.8 0-1.56.32-2.12.88S2 5.21 2 6v12c0 .8.32 1.56.88 2.12S4.21 21 5 21h14c.8 0 1.56-.32 2.12-.88S22 18.79 22 18V6c0-.8-.32-1.56-.88-2.12zM10.29 5.29A.99.99 0 0111 5a1.014 1.014 0 01.99 1.2c-.04.2-.13.37-.27.51s-.32.24-.51.27a1.014 1.014 0 01-1.2-.99c0-.27.11-.52.29-.71l-.01.01zm-4.31.9c-.04.19-.13.37-.27.51s-.32.24-.51.27A1.014 1.014 0 014 5.98c0-.27.11-.52.29-.71A.99.99 0 015 4.98c.2 0 .39.06.56.17.16.11.29.27.37.45.08.18.1.38.06.58l-.01.01zm1.64.73A1.014 1.014 0 017 5.99c0-.27.11-.52.29-.71A.99.99 0 018 4.99a1.014 1.014 0 01.99 1.2c-.04.2-.13.37-.27.51s-.32.24-.51.27c-.19.04-.4.02-.58-.06l-.01.01zm10.1 11.79c-.2.2-.45.29-.71.29-.26 0-.51-.1-.71-.29l-2.27-2.27c-.59.35-1.28.57-2.02.57-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4c0 .74-.22 1.42-.57 2.02l2.27 2.27c.39.39.39 1.02 0 1.41h.01z",
            fill: "currentColor"
        })
    });



const $6bb60871f5560581$export$9038500471c1ae24 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 20H5a3 3 0 01-3-3V7a3 3 0 013-3h4.17a3 3 0 012.12.88L12.41 6H19a3 3 0 013 3v8a3 3 0 01-3 3z",
            fill: "currentColor"
        })
    });



const $e389b56bb488615e$export$701e1c2401e85716 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 6h-6.59l-1.12-1.12C10.73 4.32 9.96 4 9.17 4H5C3.34 4 2 5.34 2 7v10c0 1.66 1.34 3 3 3h14c1.66 0 3-1.34 3-3V9c0-1.66-1.34-3-3-3zm-4.78 10.48L12 15l-2.22 1.48a.504.504 0 01-.78-.42V9.99c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v6.07c0 .4-.45.64-.78.42z",
            fill: "currentColor"
        })
    });



const $24d0ead605ef1526$export$debc252eda2cede2 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 6h-6.59l-1.12-1.12A3 3 0 009.17 4H5a3 3 0 00-3 3v10a3 3 0 003 3h14a3 3 0 003-3V9a3 3 0 00-3-3zm-6.24 10.1l-.2.18a.82.82 0 01-1.12 0l-.2-.18c-1.86-1.71-3-3-3-4.36a2.21 2.21 0 012.28-2.24 2.31 2.31 0 011.48.6 2.31 2.31 0 011.48-.6 2.21 2.21 0 012.23 2.24c0 1.38-1.09 2.65-2.95 4.36z",
            fill: "currentColor"
        })
    });



const $20ce81836ba61db6$export$f2f9f807a8567098 = (l)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12.31 13.47a.84.84 0 00-.47-.05c-.16.03-.3.11-.42.22-.11.11-.19.26-.22.42a.76.76 0 00.05.47c.06.15.17.28.3.37.13.09.29.14.45.14.22 0 .42-.09.58-.24.15-.15.24-.36.24-.58 0-.16-.05-.32-.14-.45a.838.838 0 00-.37-.3zM12 10.14c-.22 0-.43.09-.58.24-.15.15-.24.36-.24.58h1.64c0-.22-.09-.43-.24-.58a.825.825 0 00-.58-.24z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M21.12 6.88C20.56 6.32 19.79 6 19 6h-6.59l-1.12-1.12C10.73 4.32 9.97 4 9.17 4H5c-.8 0-1.56.32-2.12.88S2 6.21 2 7v10c0 .8.32 1.56.88 2.12S4.21 20 5 20h14c.8 0 1.56-.32 2.12-.88S22 17.79 22 17V9c0-.8-.32-1.56-.88-2.12zm-5.85 8.98a1.643 1.643 0 01-1.64 1.64h-3.27a1.643 1.643 0 01-1.64-1.64v-3.27a1.612 1.612 0 01.82-1.4v-.23c0-.65.26-1.28.72-1.74A2.45 2.45 0 0112 8.5c.66 0 1.28.26 1.74.72.46.46.72 1.08.72 1.74v.23c.25.14.45.35.6.59.14.25.22.53.22.81v3.27h-.01z",
                fill: "currentColor"
            })
        ]
    });



const $baf020b44dcd2573$export$6e5d2998ee72508c = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 6h-6.59l-1.12-1.12A3 3 0 009.17 4H5a3 3 0 00-3 3v10a3 3 0 003 3h14a3 3 0 003-3V9a3 3 0 00-3-3zm-2.29 7.71l-3 3a1.004 1.004 0 11-1.42-1.42l1.3-1.29H8a1 1 0 010-2h5.59l-1.3-1.29a1.002 1.002 0 01.325-1.639 1 1 0 011.095.219l3 3a1.002 1.002 0 010 1.42z",
            fill: "currentColor"
        })
    });



const $d8ef6cef4f805b15$export$b20c0783ea5ef7d9 = (r)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 16.99c.42 0 1-.74 1.27-2h-2.55c.3 1.26.85 2 1.27 2H12zM9.69 10.99c.11-.55.28-1.08.52-1.57-.7.35-1.28.9-1.68 1.57h1.16zM8.54 14.99c.39.67.96 1.22 1.65 1.57-.23-.5-.4-1.03-.5-1.57H8.54zM12 8.99c-.42 0-.98.74-1.27 2h2.55c-.3-1.26-.85-2-1.27-2H12zM9.5 12.99c0-.34 0-.68.04-1H8.12c-.08.33-.13.66-.13 1 0 .34.05.67.13 1h1.42c-.04-.32-.04-.66-.04-1zM15.46 10.99c-.39-.67-.96-1.22-1.65-1.57.23.5.4 1.03.5 1.57h1.15zM10.56 11.99a9.55 9.55 0 000 2h2.89a8.386 8.386 0 000-2h-2.89z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M21.12 6.88C20.56 6.32 19.79 6 19 6h-6.59l-1.12-1.12C10.73 4.32 9.97 4 9.17 4H5c-.8 0-1.56.32-2.12.88S2 6.21 2 7v10c0 .8.32 1.56.88 2.12S4.21 20 5 20h14c.8 0 1.56-.32 2.12-.88S22 17.79 22 17V9c0-.8-.32-1.56-.88-2.12zm-4.96 8.89c-.55.82-1.33 1.46-2.24 1.84-.91.38-1.92.48-2.89.28-.97-.19-1.86-.67-2.56-1.37-.7-.7-1.18-1.59-1.37-2.56-.19-.97-.09-1.98.28-2.89A4.992 4.992 0 0112 7.99c.66 0 1.31.13 1.91.38.61.25 1.16.62 1.62 1.08.46.46.83 1.02 1.08 1.62.25.61.38 1.26.38 1.91 0 .99-.29 1.96-.84 2.78l.01.01z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M14.46 11.99c.04.32.04.66.04 1 0 .34-.02.68-.04 1h1.42c.17-.66.17-1.34 0-2h-1.42zM13.78 16.57c.69-.36 1.27-.9 1.65-1.57h-1.15c-.1.54-.27 1.07-.5 1.57z",
                fill: "currentColor"
            })
        ]
    });



const $25259a12b0faf3cd$export$4eff2cc6c7acd72d = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 6h-6.59l-1.12-1.12A3 3 0 009.17 4H5a3 3 0 00-3 3v10a3 3 0 003 3h14a3 3 0 003-3V9a3 3 0 00-3-3zm-3.62 6.49l-1.07 1 .25 1.51a.85.85 0 01-1.24.9L12 15.21l-1.32.69a.85.85 0 01-1.24-.9l.25-1.47-1.07-1A.86.86 0 019.1 11l1.47-.22.66-1.33a.86.86 0 011.54 0l.66 1.33 1.47.22a.86.86 0 01.48 1.49z",
            fill: "currentColor"
        })
    });



const $56fa47886fdb35f1$export$cb02b95583fea3fc = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.12 6.88C20.56 6.32 19.79 6 19 6h-6.59l-1.12-1.12C10.73 4.32 9.97 4 9.17 4H5c-.8 0-1.56.32-2.12.88S2 6.21 2 7v10c0 .8.32 1.56.88 2.12S4.21 20 5 20h14c.8 0 1.56-.32 2.12-.88S22 17.79 22 17V9c0-.8-.32-1.56-.88-2.12zM10.71 11.7l-2 2c-.2.2-.45.29-.71.29-.26 0-.51-.1-.71-.29l-2-2a.996.996 0 111.41-1.41l.29.29V7.99c0-.55.45-1 1-1s1 .45 1 1v2.59l.29-.29a.996.996 0 111.41 1.41h.02z",
            fill: "currentColor"
        })
    });



const $24f75b41065028ed$export$c53d5311b561d710 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 2H7a3 3 0 00-3 3v14a3 3 0 003 3h10a3 3 0 003-3V5a3 3 0 00-3-3zM8 6h3a1 1 0 110 2H8a1 1 0 010-2zm8 12H8a1 1 0 010-2h8a1 1 0 010 2zm0-5H8a1 1 0 010-2h8a1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $1b377aba2e31b04c$export$c759325b39dc1773 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16.13 7.87a3 3 0 010-5.74.501.501 0 01.05-.13H7a3 3 0 00-3 3v14a3 3 0 003 3h10a3 3 0 003-3V9.83a3 3 0 01-3.87-2v.04zM8 6h3a1 1 0 110 2H8a1 1 0 010-2zm8 12H8a1 1 0 010-2h8a1 1 0 010 2zm0-5H8a1 1 0 010-2h8a1 1 0 010 2zm5-9h-1V3a1 1 0 00-2 0v1h-1a1 1 0 100 2h1v1a1 1 0 002 0V6h1a1 1 0 100-2z",
            fill: "currentColor"
        })
    });



const $bdb0d41215fd7505$export$955404ccda80d7e9 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M13.77 3H6.23A3.12 3.12 0 003 6v12a3.12 3.12 0 003.23 3h7.54A3.12 3.12 0 0017 18V6a3.12 3.12 0 00-3.23-3zM7 6h2.5a1 1 0 110 2H7a1 1 0 010-2zm6 12H7a1 1 0 010-2h6a1 1 0 110 2zm0-5H7a1 1 0 010-2h6a1 1 0 110 2zm5.66-9c.284.628.427 1.31.42 2v12a4.749 4.749 0 01-.42 2A2.71 2.71 0 0021 17.28V6.72A2.71 2.71 0 0018.66 4z",
            fill: "currentColor"
        })
    });



const $886a0789a9ecbfb5$export$ce8a55c18f2bd6e7 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M13 14h-2a1 1 0 00-1 1v5a1 1 0 001 1h2a1 1 0 001-1v-5a1 1 0 00-1-1zm6-2h-2a1 1 0 00-1 1v7a1 1 0 001 1h2a1 1 0 001-1v-7a1 1 0 00-1-1zM7 16H5a1 1 0 00-1 1v3a1 1 0 001 1h2a1 1 0 001-1v-3a1 1 0 00-1-1zM19 3h-3a1 1 0 100 2h.59l-3.86 3.86-2.41-.81a1 1 0 00-.94.17l-5 4A1 1 0 005 14a1 1 0 00.62-.22l4.58-3.66 2.48.83a1 1 0 001-.24L18 6.41V7a1 1 0 002 0V4a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $a5ed7a7c51cecd0c$export$81ae11a45b672aab = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7 15H5a1 1 0 00-1 1v5a1 1 0 001 1h2a1 1 0 001-1v-5a1 1 0 00-1-1zm6-4h-2a1 1 0 00-1 1v9a1 1 0 001 1h2a1 1 0 001-1v-9a1 1 0 00-1-1zm6-4h-2a1 1 0 00-1 1v13a1 1 0 001 1h2a1 1 0 001-1V8a1 1 0 00-1-1zM6 9a2 2 0 100 4 2 2 0 000-4z",
            fill: "currentColor"
        })
    });



const $43e390e13d5ca9e2$export$9b105abaa4dff92f = (v)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...v,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 17a1 1 0 001-1V6a1 1 0 00-2 0v10a1 1 0 001 1zm-4 0a1 1 0 001-1v-6a1 1 0 00-2 0v6a1 1 0 001 1zm-4 0a1 1 0 001-1v-4a1 1 0 10-2 0v4a1 1 0 001 1zm12-6a1 1 0 00-1 1v4a1 1 0 002 0v-4a1 1 0 00-1-1zm0 8H5V4a1 1 0 00-2 0v16a1 1 0 001 1h16a1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $104caced7555607c$export$add9576bba04feab = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 2H7a3 3 0 00-3 3v14a3 3 0 003 3h10a3 3 0 003-3V5a3 3 0 00-3-3zM7 7h1V6a1 1 0 012 0v1h1a1 1 0 110 2h-1v1a1 1 0 11-2 0V9H7a1 1 0 010-2zm10 12H7a1 1 0 010-2h10a1 1 0 010 2zm0-4H7a1 1 0 010-2h10a1 1 0 010 2zm0-4h-3a1 1 0 010-2h3a1 1 0 110 2zm0-4h-3a1 1 0 110-2h3a1 1 0 110 2z",
            fill: "currentColor"
        })
    });



const $72d03d55670cea7f$export$7c28aa9b1c1263b7 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.5 12a1.45 1.45 0 00-.89.3L16 11.78a4 4 0 00-1.19-2.64L16 7a2 2 0 10-1.73-1l-1.22 2.16A3.71 3.71 0 0012 8a3.9 3.9 0 00-1.73.41L8 5.7a1.36 1.36 0 000-.2A1.5 1.5 0 106.46 7l2.28 2.69A4 4 0 008 12c.005.201.025.402.06.6l-1.87.8A2 2 0 005 13a2 2 0 102 2.24l1.87-.8A4 4 0 0012 16h.1l.46 1.62A2 2 0 0012 19a2 2 0 004 0 2 2 0 00-1.51-1.93L14 15.43a4 4 0 001.57-1.69l2.62.52A1.5 1.5 0 1019.5 12z",
            fill: "currentColor"
        })
    });



const $a13d4ed3f71288d9$export$8b637e4916b164c2 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 13a1 1 0 100-2h-2.78v-.1l1.9-3.9A2 2 0 1019 3a2 2 0 00-1.72 1h-3.56a2 2 0 00-3.44 0H6.72A2 2 0 005 3a2 2 0 10-.12 4l2 3.91v.1H4a1 1 0 000 2h2.78v.1L4.88 17A2 2 0 105 21a2 2 0 001.72-1h3.56a2 2 0 003.44 0h3.56A2 2 0 0019 21a2.001 2.001 0 00.12-4l-1.95-3.9V13H20zm-8-5.76l1.83 3.66s0 .07-.05.1h-3.56s0-.07-.05-.1L12 7.24zM6.67 6.1V6h3.56s0 .07.05.1L8.5 9.76 6.67 6.1zM10.28 18H6.72v-.1l1.78-3.66 1.83 3.66s-.03.1-.05.1zM12 16.76l-1.83-3.66s0-.07.05-.1h3.56s0 .07.05.1L12 16.76zm5.33 1.14v.1h-3.61s0-.07-.05-.1l1.83-3.66 1.83 3.66zM15.5 9.76L13.67 6.1s0-.07.05-.1h3.56v.1L15.5 9.76z",
            fill: "currentColor"
        })
    });



const $1964e8d68c6b7d36$export$199384c9d6f96a47 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 16.008a1 1 0 001 1h3a1 1 0 001-1v-3a1 1 0 00-2 0v.59l-3.29-3.3a1.002 1.002 0 00-1.42 0L12 12.588l-7.21-9.2a.7.7 0 00-.16-.13.49.49 0 00-.15-.1.85.85 0 00-.17-.06H4l-.12-.09a.65.65 0 00-.2 0 .66.66 0 00-.19.09h-.11a.7.7 0 00-.13.16.49.49 0 00-.1.15.85.85 0 00-.06.17 1.42 1.42 0 000 .2l-.09.23v16a1 1 0 001 1h16a1 1 0 100-2H5V6.898l6.13 7.81a1 1 0 00.73.38 1 1 0 00.77-.29l2.37-2.38 2.59 2.59H17a1 1 0 00-1 1z",
            fill: "currentColor"
        })
    });



const $0c045c4c590c0956$export$d4e8ac77bb062c75 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7.59 14.48H5.03c-.08 0-.11-.02-.11-.1V8.62c0-.5-.4-.62-.77-.62s-.77.12-.77.62v6.62c0 .43.26.67.67.67h3.53c.49 0 .66-.35.66-.7s-.18-.72-.66-.72l.01-.01zm11.9 0h-3.13c-.08 0-.11-.02-.11-.1v-1.72c0-.08.02-.1.11-.1h2.56c.49 0 .66-.36.66-.71s-.18-.71-.66-.71h-2.56c-.08 0-.11-.02-.11-.1V9.57c0-.08.02-.1.11-.1h3.01c.49 0 .66-.36.66-.71s-.18-.71-.66-.71h-3.98c-.41 0-.67.24-.67.67v6.53c0 .43.26.67.67.67h4.1c.49 0 .66-.35.66-.7s-.18-.72-.66-.72v-.02zm-6.62-6.44H8.16c-.49 0-.66.36-.66.71s.18.71.66.71h1.48c.08 0 .11.02.11.1v5.76c0 .5.41.62.77.62.36 0 .77-.12.77-.62V9.56c0-.08.04-.1.11-.1h1.48c.49 0 .66-.35.66-.71s-.18-.71-.66-.71h-.01z",
            fill: "currentColor"
        })
    });



const $f5967a1354364371$export$6695ac489958f2e2 = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zm-2 2.25A7.92 7.92 0 0112 4c.48.001.959.048 1.43.14a10 10 0 00-3.22 2.67A7.73 7.73 0 0110 5v-.75zm.27 6.75a2 2 0 00.68-.22 8.061 8.061 0 011.74 1.9 2 2 0 00-.19.85v.07c-.54.37-1.125.672-1.74.9a2 2 0 00-.67-.37A6.719 6.719 0 0110 13a7.704 7.704 0 01.27-2zM8 5.09a9.57 9.57 0 00.26 2.19A9.61 9.61 0 005.76 7 8 8 0 018 5.09zm-3.66 9h-.07a7.84 7.84 0 01.25-4.91 7.77 7.77 0 013.48.1 2 2 0 00.38.92A9.73 9.73 0 008 13c.002.52.049 1.038.14 1.55a1.61 1.61 0 00-.35.43 7.63 7.63 0 01-3.44-.87l-.01-.02zm1.18 2.57c.732.19 1.484.29 2.24.3a2 2 0 001.58 1c.397.69.874 1.331 1.42 1.91a8 8 0 01-5.23-3.19l-.01-.02zm8 3a8 8 0 01-2.39-2.53 1.93 1.93 0 00.3-.74c.755-.28 1.473-.65 2.14-1.1a.881.881 0 00.22.1c.124.528.194 1.068.21 1.61.001.9-.151 1.792-.45 2.64l-.03.02zm.95-8.14h-.15A10.339 10.339 0 0012 9a1.94 1.94 0 00-.26-1 8 8 0 014.08-2.73c.123.568.183 1.149.18 1.73a7.9 7.9 0 01-1.41 4.51l-.12.01zm1.28 7.55c.16-.679.244-1.373.25-2.07a10.083 10.083 0 00-.21-2c.078-.07.148-.146.21-.23.658.142 1.327.219 2 .23a9.762 9.762 0 001.44-.11 8 8 0 01-3.66 4.16l-.03.02zm.58-6.24a1.441 1.441 0 00-.09-.22A9.85 9.85 0 0018 7v-.29A8 8 0 0120 12c0 .25 0 .49-.05.73a8.06 8.06 0 01-3.59.08l-.03.02z",
            fill: "currentColor"
        })
    });



const $bf07f2cc527784f9$export$5317cdb78d5e1f8c = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.12 3.88C20.56 3.32 19.79 3 19 3H5c-.8 0-1.56.32-2.12.88S2 5.21 2 6v12c0 .8.32 1.56.88 2.12S4.21 21 5 21h14c.8 0 1.56-.32 2.12-.88S22 18.79 22 18V6c0-.8-.32-1.56-.88-2.12zM10.29 5.29A.99.99 0 0111 5a1.014 1.014 0 01.99 1.2c-.04.2-.13.37-.27.51s-.32.24-.51.27a1.014 1.014 0 01-1.2-.99c0-.27.11-.52.29-.71l-.01.01zm-4.31.9c-.04.19-.13.37-.27.51s-.32.24-.51.27A1.014 1.014 0 014 5.98c0-.27.11-.52.29-.71A.99.99 0 015 4.98c.2 0 .39.06.56.17.16.11.29.27.37.45.08.18.1.38.06.58l-.01.01zM7 5.99c0-.27.11-.52.29-.71A.99.99 0 018 4.99a1.014 1.014 0 01.99 1.2c-.04.2-.13.37-.27.51s-.32.24-.51.27a1.014 1.014 0 01-1.2-.99L7 5.99zm9 8c0 .19-.03.37-.06.55l.27.16c.48.28.64.89.37 1.37l-.5.87c-.28.48-.89.64-1.37.37l-.27-.16c-.29.23-.6.42-.94.56v.3c0 .55-.45 1-1 1h-1c-.55 0-1-.45-1-1v-.3c-.34-.14-.66-.33-.94-.56l-.27.16c-.48.28-1.09.11-1.37-.37l-.5-.87c-.28-.48-.11-1.09.37-1.37l.27-.16c-.02-.18-.06-.36-.06-.55 0-.19.03-.37.06-.55l-.27-.16a1.01 1.01 0 01-.37-1.37l.5-.87c.28-.48.89-.64 1.37-.37l.27.16c.29-.23.6-.42.94-.56v-.3c0-.55.45-1 1-1h1c.55 0 1 .45 1 1v.3c.34.14.66.33.94.56l.27-.16c.48-.28 1.09-.11 1.37.37l.5.87c.28.48.11 1.09-.37 1.37l-.27.16c.02.18.06.36.06.55zm-4-2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z",
            fill: "currentColor"
        })
    });



const $a930f517e25148b3$export$47643e0df7debb5c = (l)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M15.5 7h4c0-.53-.21-1.04-.59-1.41l-3-3c-.37-.38-.88-.59-1.41-.59v4c0 .27.11.52.29.71.19.19.44.29.71.29zM10.69 16.14h-.54s-.05.01-.05.05v.64s.01.05.05.05h.54c.2 0 .34-.13.34-.36 0-.23-.14-.37-.34-.37v-.01zM7.47 16.14h-.54s-.05.01-.05.05v.64s.01.05.05.05h.54c.2 0 .34-.13.34-.36 0-.23-.14-.37-.34-.37v-.01z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M13.38 8.12c-.56-.56-.88-1.33-.88-2.12V2H7c-.66 0-1.3.26-1.77.73S4.5 3.83 4.5 4.5v15c0 .66.26 1.3.73 1.77S6.33 22 7 22h10c.66 0 1.3-.26 1.77-.73s.73-1.1.73-1.77V9h-4c-.8 0-1.56-.32-2.12-.88zm-5.77 9.62h-.67s-.05.01-.05.05v.83c0 .3-.24.38-.46.38-.2 0-.45-.07-.45-.38v-2.93c0-.3.2-.41.43-.41H7.6c.64 0 1.14.4 1.14 1.24s-.5 1.23-1.14 1.23l.01-.01zm3.22 0h-.67s-.05.01-.05.05v.83c0 .3-.24.38-.46.38-.2 0-.45-.07-.45-.38v-2.93c0-.3.2-.41.43-.41h1.19c.64 0 1.14.4 1.14 1.24s-.5 1.23-1.14 1.23l.01-.01zm3.8-1.61h-.54s-.05.01-.05.05v2.43c0 .31-.24.38-.45.38-.21 0-.46-.07-.46-.38v-2.43s-.01-.05-.05-.05h-.53c-.3 0-.39-.21-.39-.43s.09-.43.39-.43h2.06c.3 0 .39.21.39.43s-.09.43-.39.43h.02zm1.4-.68l.55.85s.01.03.03.03c.02 0 .03-.03.03-.03l.55-.85c.1-.15.21-.2.32-.2.21 0 .48.2.48.44 0 .07-.03.16-.09.25l-.77 1.14s-.02.03-.02.05c0 .02.02.04.02.04l.78 1.14c.06.1.09.18.09.26 0 .23-.26.43-.48.43-.11 0-.23-.05-.32-.2l-.56-.85s-.01-.03-.03-.03c-.02 0-.03.03-.03.03l-.56.85c-.09.14-.21.2-.32.2-.21 0-.48-.2-.48-.43 0-.08.03-.16.09-.26l.78-1.14s.02-.02.02-.04-.02-.05-.02-.05l-.77-1.14a.477.477 0 01-.09-.25c0-.23.26-.44.48-.44.11 0 .23.05.32.2z",
                fill: "currentColor"
            })
        ]
    });



const $27e748c382ba7cb4$export$fe870b56b83724a3 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18.12 2.88C17.56 2.32 16.8 2 16 2h-5a2.993 2.993 0 00-2.38 1.13l-3 3.7c-.41.54-.63 1.19-.62 1.87V19c0 .8.32 1.56.88 2.12S7.21 22 8 22h8c.8 0 1.56-.32 2.12-.88S19 19.79 19 19V5c0-.8-.32-1.56-.88-2.12zM8.73 14.51c0 .37-.26.49-.53.49s-.54-.12-.54-.49v-3.57c0-.05 0-.11-.04-.11-.03 0-.06.03-.09.06l-.26.26a.52.52 0 01-.36.17c-.26 0-.55-.27-.55-.55 0-.11.04-.23.16-.35l1.23-1.19c.19-.18.33-.22.47-.22.26 0 .5.17.5.59v4.93l.01-.02zm4.04.45h-2.5c-.47 0-.6-.24-.6-.51 0-.51.26-1.1.95-1.78l1.07-1.05c.33-.33.44-.66.44-.89 0-.43-.23-.71-.69-.71-.37 0-.54.14-.83.38-.08.07-.18.14-.34.14-.25 0-.55-.22-.55-.51 0-.18.11-.31.23-.43.32-.33.83-.6 1.49-.6 1.13 0 1.8.66 1.8 1.73 0 .46-.16.99-.71 1.53l-.97.96c-.19.18-.37.43-.47.55 0 0-.04.09-.04.12 0 .04.05.04.08.04h1.63c.37 0 .49.24.49.51s-.13.51-.49.51l.01.01zm2.91.03c-.97 0-1.41-.5-1.6-.71a.564.564 0 01-.15-.35c0-.21.27-.55.57-.55.1 0 .25.07.36.19.14.15.43.4.83.4.53 0 .84-.31.84-.8 0-.49-.31-.78-.84-.78h-.09c-.36 0-.49-.21-.49-.49s.13-.49.49-.49h.09c.41 0 .68-.26.68-.68 0-.42-.27-.71-.68-.71-.35 0-.52.11-.78.35-.09.08-.18.14-.35.14-.25 0-.55-.22-.55-.51 0-.18.11-.31.23-.44.32-.33.81-.57 1.46-.57 1.07 0 1.79.64 1.79 1.69 0 .48-.16.87-.47 1.16-.03.03-.03.04-.03.07 0 .03 0 .05.03.07.4.29.63.69.63 1.2 0 1.09-.76 1.82-1.95 1.82l-.02-.01z",
            fill: "currentColor"
        })
    });



const $6c0114017b73d7c5$export$fd9199a2e71c7b86 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.86 16.3a.897.897 0 00-.94-.44c-.18.03-.35.12-.48.25l-.39.37s-.09.07-.14.1c-.05.02-.11.03-.17.03-.06 0-.12-.01-.17-.03a.653.653 0 01-.15-.1l-1.25-1.23a.91.91 0 00-.63-.25.91.91 0 00-.63.25l-1.35 1.28s-.1.07-.15.09c-.05.02-.12.03-.18.02-.12 0-.23-.05-.31-.13l-.4-.39a.953.953 0 00-.47-.26c-.19-.03-.38 0-.55.07a.897.897 0 00-.51.9l.27 2.54h8.45l.27-2.54a.833.833 0 00-.12-.53zm-7.43-2.41h.03l.03.01c.25.05.48.14.71.25l.37-.35a2.908 2.908 0 014.03.02l.3.29s.08-.02.11-.04V2.84c0-.22-.09-.44-.24-.59A.789.789 0 0017.2 2h-6.91c-.75 0-1.46.31-1.96.86L4.73 6.8c-.46.5-.71 1.16-.71 1.84v12.52c0 .22.09.44.24.59.15.16.36.25.57.25h4.89c-.09-.2-.16-.41-.21-.63H9.5l-.02-.16-.03-.19-.06-.57-.09-.9-.27-2.53c-.06-.6.07-1.19.36-1.71a2.904 2.904 0 012.52-1.47c.17 0 .34.02.51.05h.01zm1.58-8.62c0-.15.15-.27.33-.27h1.33c.09 0 .17.03.24.08.06.05.1.12.1.19v4.45c0 .07-.04.14-.1.19-.06.05-.15.08-.24.08h-1.33c-.18 0-.33-.12-.33-.27V5.27zm-4 4.45c0 .07-.04.14-.1.19-.06.05-.15.08-.24.08H8.34c-.18 0-.33-.12-.33-.27V5.27c0-.15.15-.27.33-.27h1.33c.09 0 .17.03.24.08.07.05.1.12.1.19v4.45zm1.02 0V5.27c0-.15.15-.27.33-.27h1.32c.09 0 .17.03.23.08s.1.12.1.19v4.45c0 .07-.03.14-.1.19-.06.05-.15.08-.23.08h-1.32c-.18 0-.33-.12-.33-.27zm.36 11.09c.03.33.19.63.44.85.25.22.57.34.91.34h5.46c.34 0 .66-.12.91-.34.25-.22.41-.52.44-.85l.06-.57h-8.28l.06.57z",
            fill: "currentColor"
        })
    });



const $4e7dd12284ba8d75$export$29f6ecfe4b65fb4 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 14h-1V5h1a1 1 0 100-2H4a1 1 0 000 2h1v9H4a1 1 0 000 2h5.92l-2.7 3.38A1 1 0 008 21a1 1 0 00.78-.38L11 17.85V20a1 1 0 002 0v-2.15l2.22 2.77A1 1 0 0016 21a1 1 0 00.78-1.62L14.08 16H20a1 1 0 000-2zm-3.29-4.79a1 1 0 01-1.42 0l-.68-.69-2.31 3.08a1 1 0 01-.73.4 1.07 1.07 0 01-.78-.29l-1.18-1.19-.81 1.08a1 1 0 11-1.6-1.2l1.5-2a1 1 0 011.51-.11l1.18 1.19L13.7 6.4a1 1 0 011.51-.11l1.5 1.5a1 1 0 010 1.42z",
            fill: "currentColor"
        })
    });



const $daea4c3a426f2d2f$export$9872d4bdee4b5ed7 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 7h4a2 2 0 00-.59-1.41l-3-3A2 2 0 0015 2v4a1 1 0 001 1zm-2.12 1.12A3 3 0 0113 6V2H6.5A2.49 2.49 0 004 4.5v15A2.49 2.49 0 006.5 22h11a2.49 2.49 0 002.5-2.5V9h-4a3 3 0 01-2.12-.88zM8 18.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm0-5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm0-5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm8 9.5h-4a1 1 0 110-2h4a1 1 0 010 2zm1-6a1 1 0 01-1 1h-4a1 1 0 110-2h4a1 1 0 011 1z",
            fill: "currentColor"
        })
    });



const $71b96a1d0b8569f9$export$d74a8375358b5827 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.71 7.29l-2-2a1.004 1.004 0 00-1.42 1.42l.3.29H17a8 8 0 00-6 2.73V5.41l.29.3a.999.999 0 001.42 0 1.001 1.001 0 000-1.42l-2-2a.85.85 0 00-.3-.19A.85.85 0 0010 2h-.07a1 1 0 00-.24.05h-.1a1 1 0 00-.3.19l-2 2a1.022 1.022 0 101.42 1.47l.29-.3v8.94A3.448 3.448 0 007.5 14 1.5 1.5 0 016 12.5v-2.09l.29.3a1 1 0 001.42 0 1 1 0 000-1.42l-2-2a1 1 0 00-1.42 0l-2 2a1.004 1.004 0 001.42 1.42l.29-.3v2.09A3.5 3.5 0 007.5 16 1.5 1.5 0 019 17.5V21a1 1 0 002 0v-6a6 6 0 016-6h1.59l-.3.29a1 1 0 00.326 1.639 1 1 0 001.094-.219l2-2a1.001 1.001 0 000-1.42zM17 12a3.93 3.93 0 00-4 3.8c0 2.54 3 5.57 3.29 5.91a.998.998 0 001.42 0C18 21.37 21 18.34 21 15.8a3.93 3.93 0 00-4-3.8zm0 5a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $20eb625d40ed7dc4$export$3101ecf42f69aa37 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.57 19L15 13.83c.203-.324.352-.678.44-1.05l3-.21a1.469 1.469 0 001.06.43 1.5 1.5 0 100-3 1.47 1.47 0 00-1.17.58l-3.06.2a3.362 3.362 0 00-.47-.85l3-3.95.2.02a2 2 0 10-2-2 1.92 1.92 0 00.16.79l-3 3.94a3.22 3.22 0 00-2-.13L9 4.7a1.362 1.362 0 000-.2A1.5 1.5 0 107.41 6l2.06 3.6a3.56 3.56 0 00-.75 1.22l-4.05-.24a1.5 1.5 0 10-.11 2l4 .24c.11.458.31.89.59 1.27L6.23 18H6a2 2 0 102 2 2.1 2.1 0 00-.16-.79l2.95-3.94c.154.059.31.11.47.15l.16 2a1.48 1.48 0 00-.42 1 1.5 1.5 0 102.845-.66 1.469 1.469 0 00-.435-.52l-.16-2.06.24-.1 4.51 5.2A1.5 1.5 0 1019.57 19z",
            fill: "currentColor"
        })
    });



const $d8f2e8532485fc6b$export$9924a8a882da0ffa = (s)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...s,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10.5 9c0 1.65 1.35 3 3 3s3-1.35 3-3v-.5c0-1.65-1.35-3-3-3s-3 1.35-3 3V9zm2-.5c0-.55.45-1 1-1s1 .45 1 1V9c0 .55-.45 1-1 1s-1-.45-1-1v-.5zM7 12c.4 0 .76-.24.92-.61l3-7a.999.999 0 00-.52-1.31.991.991 0 00-1.31.53L7.01 8.46 4.93 3.61a.994.994 0 10-1.83.78l3 7c.16.37.52.61.92.61H7zm12 7h-2v-1h1.25c.55 0 1-.45 1-1s-.45-1-1-1H17v-1h2c.55 0 1-.45 1-1s-.45-1-1-1h-3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h3c.55 0 1-.45 1-1s-.45-1-1-1zm-5.5-6h-5c-.55 0-1 .45-1 1s.45 1 1 1H10v5c0 .55.45 1 1 1s1-.45 1-1v-5h1.5c.55 0 1-.45 1-1s-.45-1-1-1zM8 19H6v-5c0-.55-.45-1-1-1s-1 .45-1 1v6c0 .55.45 1 1 1h3c.55 0 1-.45 1-1s-.45-1-1-1z",
            fill: "currentColor"
        })
    });



const $6cb49be913e7f45d$export$c34b1fc5fb714e9d = (s)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...s,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12.5 15.5c-.55 0-1 .45-1 1V20c0 .55.45 1 1 1s1-.45 1-1v-3.5c0-.55-.45-1-1-1zm-2.26-2.47a1 1 0 00-1.21.73l-.67 2.67-.91-2.74a1 1 0 00-.95-.68c-.43 0-.81.28-.95.68l-.91 2.72-.67-2.65a.99.99 0 00-1.21-.72.99.99 0 00-.72 1.21l1.51 5.96c.11.43.49.74.93.75.43.05.84-.26.99-.68l1.04-3.12 1.05 3.16a1 1 0 00.95.68h.04c.44-.02.82-.33.93-.76l1.5-6a.995.995 0 00-.73-1.21h-.01zm-4.16-1.64c.16.37.52.61.92.61s.76-.24.92-.61l3-7a.999.999 0 00-.52-1.31.991.991 0 00-1.31.53L7.01 8.46 4.93 3.61a.994.994 0 10-1.83.78l3 7h-.02zM21 15c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 .5c-.55 0-1 .45-1 1V20c0 .55.45 1 1 1s1-.45 1-1v-3.5c0-.55-.45-1-1-1zM12.5 13c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm6 0h-3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1s1-.45 1-1v-2h1c.55 0 1-.45 1-1s-.45-1-1-1h-1v-1h2c.55 0 1-.45 1-1s-.45-1-1-1zm-2-4v-.5c0-1.65-1.35-3-3-3s-3 1.35-3 3V9c0 1.65 1.35 3 3 3s3-1.35 3-3zm-2 0c0 .55-.45 1-1 1s-1-.45-1-1v-.5c0-.55.45-1 1-1s1 .45 1 1V9z",
            fill: "currentColor"
        })
    });



const $f6b55ae1bf10c6fa$export$8eb1b3d90b20ed7e = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M6.43 11.45c.5 0 .77-.2.98-.88l2.11-6.55c.04-.12.06-.22.06-.31 0-.46-.47-.71-.85-.71-.25 0-.51.12-.63.52L6.61 8.37c-.06.18-.11.4-.18.4-.07 0-.12-.22-.18-.4L4.76 3.52c-.12-.4-.38-.52-.63-.52-.41 0-.85.29-.85.71 0 .1.02.19.06.31l2.11 6.55c.21.67.49.88.98.88zm2.77.75c-.37 0-.77.14-.77.69v4.58s0 .12-.06.12-.09-.06-.13-.12l-2.45-4.34c-.4-.71-.6-.92-1.11-.92-.46 0-.79.24-.79.97v7.12c0 .55.42.69.77.69.35 0 .77-.14.77-.69v-4.58s0-.14.06-.14.09.06.13.14l2.45 4.34c.4.71.6.92 1.11.92.46 0 .79-.24.79-.97v-7.12c0-.55-.42-.69-.77-.69zm5.71-3.86c0-1.77-.46-3.11-2.52-3.11S9.87 6.56 9.87 8.34c0 1.78.46 3.11 2.52 3.11s2.52-1.33 2.52-3.11zm-3.53 0c0-1.04.06-1.68 1.01-1.68s1.01.64 1.01 1.68-.06 1.68-1.01 1.68-1.01-.64-1.01-1.68zm6.28 11.44l-1.26-2.21s-.01-.02-.01-.05c0-.04.01-.06.06-.09.76-.47 1.31-1.11 1.31-2.52 0-1.81-1.09-2.67-2.44-2.67h-2.9c-.41 0-.67.26-.67.74v7.31c0 .55.42.69.77.69.35 0 .77-.14.77-.69V17.7c0-.09.02-.11.11-.11h1.2c.09 0 .13 0 .19.11l1.58 2.87c.17.31.39.41.59.41.39 0 .84-.36.84-.77a.96.96 0 00-.13-.42l-.01-.01zm-2.33-3.75H13.4c-.08 0-.11-.02-.11-.11v-1.99c0-.09.02-.11.11-.11h1.87c.54 0 .9.37.9 1.11 0 .74-.37 1.11-.84 1.11v-.01z",
            fill: "currentColor"
        })
    });



const $fac3a83a05e5892a$export$c5d71a77fdff738a = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.46 4.68c-.34-.37-.8-.6-1.3-.66-2.2-.23-4.35-.85-6.34-1.83-.26-.13-.54-.19-.82-.19-.28 0-.56.07-.82.19-1.97.98-4.11 1.6-6.3 1.83-.5.04-.97.27-1.32.64-.35.37-.55.85-.56 1.36v4.99C3 17.75 9.75 22 12 22s9-4.25 9-10.99V6.02c-.01-.5-.2-.97-.54-1.34zM8.97 9.17l-1.75 5c-.07.2-.26.33-.47.33-.21 0-.4-.13-.47-.33l-1.75-5c-.09-.26.05-.55.31-.64.26-.09.55.05.64.31l1.28 3.65 1.28-3.65c.09-.26.38-.4.64-.31.26.09.4.38.31.64h-.02zM12.25 12H11v2c0 .28-.22.5-.5.5s-.5-.22-.5-.5V9c0-.28.22-.5.5-.5h1.75c.96 0 1.75.79 1.75 1.75S13.21 12 12.25 12zM19 14c0 .22-.15.42-.37.48-.04.01-.09.02-.13.02-.17 0-.34-.09-.43-.24L16 10.81v3.2c0 .28-.22.5-.5.5s-.5-.22-.5-.5v-5c0-.22.15-.42.37-.48.21-.06.45.03.56.22L18 12.2V9c0-.28.22-.5.5-.5s.5.22.5.5v5zm-6.75-4.5H11V11h1.25c.41 0 .75-.34.75-.75s-.34-.75-.75-.75z",
            fill: "currentColor"
        })
    });



const $0ae7a57f4c21cd9f$export$bbbcec05db93bae4 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10 11a1 1 0 00-1 1v8a1 1 0 102 0v-8a1 1 0 00-1-1zm8-8a1 1 0 00-1 1v16a1 1 0 002 0V4a1 1 0 00-1-1zM6 15a1 1 0 00-1 1v4a1 1 0 102 0v-4a1 1 0 00-1-1zm8-8a1 1 0 00-1 1v12a1 1 0 002 0V8a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $ae227b2f49d00c79$export$cb51d6df3298dbba = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M6 15a1 1 0 00-1 1v4a1 1 0 102 0v-4a1 1 0 00-1-1zm4-4a1 1 0 00-1 1v8a1 1 0 102 0v-8a1 1 0 00-1-1zM7.71 5.29a1 1 0 00-1.42 0l-.29.3-.29-.3a1.004 1.004 0 00-1.42 1.42l.3.29-.3.29a1 1 0 000 1.42 1 1 0 001.42 0l.29-.3.29.3a1 1 0 001.42 0 1 1 0 000-1.42L7.41 7l.3-.29a1 1 0 000-1.42zM18 3a1 1 0 00-1 1v16a1 1 0 002 0V4a1 1 0 00-1-1zm-4 4a1 1 0 00-1 1v12a1 1 0 002 0V8a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $3194ef69612c6524$export$29097d78334fcbad = (v)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...v,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10 17a1 1 0 00-1 1v2a1 1 0 102 0v-2a1 1 0 00-1-1zm-4 0a1 1 0 00-1 1v2a1 1 0 102 0v-2a1 1 0 00-1-1zm8 0a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1zm4 0a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $d1314e485e42529f$export$d6108359c4cd1fb5 = (v)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...v,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M6 15a1 1 0 00-1 1v4a1 1 0 102 0v-4a1 1 0 00-1-1zm4 2a1 1 0 00-1 1v2a1 1 0 102 0v-2a1 1 0 00-1-1zm8 0a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1zm-4 0a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $8a0265bc7df07a01$export$bc7fc0e123b014b6 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M6 15a1 1 0 00-1 1v4a1 1 0 102 0v-4a1 1 0 00-1-1zm4-4a1 1 0 00-1 1v8a1 1 0 102 0v-8a1 1 0 00-1-1zm4-4a1 1 0 00-1 1v12a1 1 0 002 0V8a1 1 0 00-1-1zm4 10a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $eee38b3f8958e14c$export$df787c1b79720032 = (v)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...v,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10 11a1 1 0 00-1 1v8a1 1 0 102 0v-8a1 1 0 00-1-1zm-4 4a1 1 0 00-1 1v4a1 1 0 102 0v-4a1 1 0 00-1-1zm12 2a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1zm-4 0a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $22d44516821c85cf$export$a152d6423c823365 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 3H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-3-3zm-7 5a2 2 0 013.34-1.47.502.502 0 01-.68.74A1 1 0 0013 7a1 1 0 00-1 1v1a1 1 0 002 0h-.5a.5.5 0 010-1h1a.5.5 0 01.5.5V9a2 2 0 11-4 0V8zM6 9.34l1-3a.525.525 0 111 .32L7.19 9H8v-.5a.5.5 0 111 0V9h.5a.5.5 0 110 1H9v.5a.5.5 0 01-1 0V10H6.5a.52.52 0 01-.41-.21.48.48 0 01-.09-.45zm2.5 8.16h-2A.5.5 0 016 17v-4a.5.5 0 011 0v3.5h1.5a.5.5 0 010 1zm3.5-4h-1V17a.5.5 0 01-1 0v-3.5H9a.5.5 0 010-1h3a.5.5 0 010 1zm3 1a.5.5 0 010 1h-1v1h1.5a.5.5 0 010 1h-2a.5.5 0 01-.5-.5v-4a.5.5 0 01.5-.5h2a.5.5 0 010 1H14v1h1z",
            fill: "currentColor"
        })
    });



const $1a0c7434c2733ef6$export$73102c100a9242ae = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M9.5 17v-.29l-.29.29h.29zm8.62-14.12A3 3 0 0016 2h-5a2.86 2.86 0 00-1.32.29 3 3 0 00-1.06.84l-3 3.7A3 3 0 005 8.7V19a3 3 0 003 3h8a3 3 0 003-3V5a3 3 0 00-.88-2.12zM11 18h-.5v.5a.5.5 0 01-1 0V18H8a.5.5 0 01-.46-.31.47.47 0 01.11-.54l2-2a.36.36 0 01.16-.15.5.5 0 01.65.27.429.429 0 010 .19V17H11a.5.5 0 010 1zm3.5 1a2 2 0 010-4h.5a.5.5 0 010 1h-.5a1 1 0 10.85 1.5H15a.5.5 0 010-1h1a.5.5 0 01.5.5 2 2 0 01-2 2z",
            fill: "currentColor"
        })
    });



const $cb2e972f41265773$export$3b6a82cb9a962a78 = (o)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M13.56 9H6.45c-.8 0-1.44.58-1.44 1.3v9.4c0 .72.65 1.3 1.44 1.3h7.11c.8 0 1.44-.58 1.44-1.3v-9.4c0-.72-.65-1.3-1.44-1.3zM10 16.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM14.9 1.98c-.55 0-1 .45-1 1s.45 1 1 1c2.79 0 5.06 2.27 5.06 5.06 0 .55.45 1 1 1s1-.45 1-1c0-3.9-3.17-7.06-7.06-7.06z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M14.5 5.04c-.55 0-1 .45-1 1s.45 1 1 1a2.5 2.5 0 012.5 2.5c0 .55.45 1 1 1s1-.45 1-1c0-2.48-2.02-4.5-4.5-4.5z",
                fill: "currentColor"
            })
        ]
    });



const $70ae5539ff52aefd$export$c0c184a56328ebd5 = (v)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...v,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M3 10a1 1 0 00-1 1v5a1 1 0 102 0v-5a1 1 0 00-1-1zm2 6a4 4 0 003 3.86V21a1 1 0 102 0v-1h4v1a1 1 0 102 0v-1.14A4 4 0 0019 16v-4H5v4zM18.71 2.29a1 1 0 00-1.42 0l-1.1 1.11a7 7 0 00-8.38 0l-1.1-1.11a1.004 1.004 0 10-1.42 1.42l1.11 1.1A6.94 6.94 0 005 9v2h14V9a6.94 6.94 0 00-1.4-4.19l1.11-1.1a1.001 1.001 0 000-1.42zM10 8a1 1 0 110-2 1 1 0 010 2zm4 0a1 1 0 110-2 1 1 0 010 2zm7 2a1 1 0 00-1 1v5a1 1 0 102 0v-5a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $96ecf79dfc607445$export$37ce2e1b3a6603bb = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M6 3a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3A15 15 0 006 3z",
            fill: "currentColor"
        })
    });



const $fef05dfefe02b5f7$export$ff371fe20d76e6bb = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18.61 6.15c-.26-.31-.62-.5-1.01-.54-1.72-.18-3.4-.68-4.95-1.46a1.432 1.432 0 00-1.28 0c-1.54.78-3.21 1.28-4.92 1.46-.39.04-.76.22-1.03.51-.27.29-.43.68-.44 1.09v4C4.98 16.6 10.25 20 12 20s7.02-3.4 7.02-8.79v-4c0-.39-.16-.77-.42-1.05l.01-.01z",
            fill: "currentColor"
        })
    });



const $06aac26bdbb57b76$export$1139286608b59365 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16.3 3.46a18.64 18.64 0 01-3.48-1.29 1.86 1.86 0 00-1.64 0A18.5 18.5 0 014.88 4 2.06 2.06 0 003 6v5a10.18 10.18 0 001.13 4.63L16.3 3.46zm4.41 1.25a1.004 1.004 0 10-1.42-1.42l-16 16a1 1 0 00.325 1.639 1 1 0 001.095-.219l1.82-1.82c2 2 4.32 3.11 5.47 3.11 2.25 0 9-4.25 9-11V6a2 2 0 00-.42-1.17l.13-.12z",
            fill: "currentColor"
        })
    });



const $c1954f094c3601f3$export$70a4e90de60e2f7f = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.46 4.68a2 2 0 00-1.3-.68 18.78 18.78 0 01-6.34-1.83 1.86 1.86 0 00-1.64 0A18.5 18.5 0 014.88 4 2.06 2.06 0 003 6v5c0 6.74 6.75 11 9 11s9-4.25 9-11V6a2 2 0 00-.54-1.32zM12 20c-1.15-.05-7-3.29-7-9V6a21 21 0 007-2v16z",
            fill: "currentColor"
        })
    });



const $a4abc2e2dd03b756$export$b60cd65f1204c691 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 4a2 2 0 00-2-2h-4a2 2 0 00-2 2 3 3 0 00-3 3v12a3 3 0 003 3h8a3 3 0 003-3V7a3 3 0 00-3-3zm1 15a1 1 0 01-1 1H8a1 1 0 01-1-1V7a1 1 0 011-1h1a1 1 0 001-1V4h4v1a1 1 0 001 1h1a1 1 0 011 1v12zm-1.5-3h-7a.5.5 0 00-.5.5v2a.5.5 0 00.5.5h7a.5.5 0 00.5-.5v-2a.5.5 0 00-.5-.5z",
            fill: "currentColor"
        })
    });



const $c61d033d8161db53$export$1735a9487cccfead = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 4a2 2 0 00-2-2h-4a2 2 0 00-2 2 3 3 0 00-3 3v12a3 3 0 003 3h8a3 3 0 003-3V7a3 3 0 00-3-3zm1 15a1 1 0 01-1 1H8a1 1 0 01-1-1V7a1 1 0 011-1h1a1 1 0 001-1V4h4v1a1 1 0 001 1h1a1 1 0 011 1v12zM15.5 7h-7a.5.5 0 00-.5.5v11a.5.5 0 00.5.5h7a.5.5 0 00.5-.5v-11a.5.5 0 00-.5-.5z",
            fill: "currentColor"
        })
    });



const $009dfdf175e55921$export$308a077307a6382a = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 4a2 2 0 00-2-2h-4a2 2 0 00-2 2 3 3 0 00-3 3v12a3 3 0 003 3h8a3 3 0 003-3V7a3 3 0 00-3-3zm1 15a1 1 0 01-1 1H8a1 1 0 01-1-1V7a1 1 0 011-1h1a1 1 0 001-1V4h4v1a1 1 0 001 1h1a1 1 0 011 1v12zm-1.5-4h-7a.5.5 0 00-.5.5v3a.5.5 0 00.5.5h7a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5z",
            fill: "currentColor"
        })
    });



const $03e7cdb1f1a575db$export$7db82f520734e9ee = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 4a2 2 0 00-2-2h-4a2 2 0 00-2 2 3 3 0 00-3 3v12a3 3 0 003 3h8a3 3 0 003-3V7a3 3 0 00-3-3zm1 15a1 1 0 01-1 1H8a1 1 0 01-1-1V7a1 1 0 011-1h1a1 1 0 001-1V4h4v1a1 1 0 001 1h1a1 1 0 011 1v12zm-1.5-5h-7a.5.5 0 00-.5.5v4a.5.5 0 00.5.5h7a.5.5 0 00.5-.5v-4a.5.5 0 00-.5-.5z",
            fill: "currentColor"
        })
    });



const $306cd6f090aa0c35$export$e4406511413798c4 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 4a2 2 0 00-2-2h-4a2 2 0 00-2 2 3 3 0 00-3 3v12a3 3 0 003 3h8a3 3 0 003-3V7a3 3 0 00-3-3zm1 15a1 1 0 01-1 1H8a1 1 0 01-1-1V7a1 1 0 011-1h1a1 1 0 001-1V4h4v1a1 1 0 001 1h1a1 1 0 011 1v12zm-1.5-6h-7a.5.5 0 00-.5.5v5a.5.5 0 00.5.5h7a.5.5 0 00.5-.5v-5a.5.5 0 00-.5-.5z",
            fill: "currentColor"
        })
    });



const $edb6f9643cef43e2$export$eefcea3bceb3c5c8 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 4a2 2 0 00-2-2h-4a2 2 0 00-2 2 3 3 0 00-3 3v12a3 3 0 003 3h8a3 3 0 003-3V7a3 3 0 00-3-3zm1 15a1 1 0 01-1 1H8a1 1 0 01-1-1V7a1 1 0 011-1h1a1 1 0 001-1V4h4v1a1 1 0 001 1h1a1 1 0 011 1v12zm-1.5-2h-7a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h7a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5z",
            fill: "currentColor"
        })
    });



const $6729e5f5f37e5292$export$6ad49b3833012a5e = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 4a2 2 0 00-2-2h-4a2 2 0 00-2 2 3 3 0 00-3 3v12a3 3 0 003 3h8a3 3 0 003-3V7a3 3 0 00-3-3zm1 15a1 1 0 01-1 1H8a1 1 0 01-1-1V7a1 1 0 011-1h1a1 1 0 001-1V4h4v1a1 1 0 001 1h1a1 1 0 011 1v12zm-1.5-7h-7a.5.5 0 00-.5.5v6a.5.5 0 00.5.5h7a.5.5 0 00.5-.5v-6a.5.5 0 00-.5-.5z",
            fill: "currentColor"
        })
    });



const $2d0b36b022bc4ebd$export$fcf3dfe70281d308 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 4a2 2 0 00-2-2h-4a2 2 0 00-2 2 3 3 0 00-3 3v12a3 3 0 003 3h8a3 3 0 003-3V7a3 3 0 00-3-3zm1 15a1 1 0 01-1 1H8a1 1 0 01-1-1V7a1 1 0 011-1h1a1 1 0 001-1V4h4v1a1 1 0 001 1h1a1 1 0 011 1v12zm-1.5-8h-7a.5.5 0 00-.5.5v7a.5.5 0 00.5.5h7a.5.5 0 00.5-.5v-7a.5.5 0 00-.5-.5z",
            fill: "currentColor"
        })
    });



const $acebee286a92bd73$export$342656b5f7fd6098 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 4a2 2 0 00-2-2h-4a2 2 0 00-2 2 3 3 0 00-3 3v12a3 3 0 003 3h8a3 3 0 003-3V7a3 3 0 00-3-3zm1 15a1 1 0 01-1 1H8a1 1 0 01-1-1V7a1 1 0 011-1h1a1 1 0 001-1V4h4v1a1 1 0 001 1h1a1 1 0 011 1v12zm-1.5-9h-7a.5.5 0 00-.5.5v8a.5.5 0 00.5.5h7a.5.5 0 00.5-.5v-8a.5.5 0 00-.5-.5z",
            fill: "currentColor"
        })
    });



const $a987bf6c407305fd$export$c057f53962ffbe7 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 4a2 2 0 00-2-2h-4a2 2 0 00-2 2 3 3 0 00-3 3v12a3 3 0 003 3h8a3 3 0 003-3V7a3 3 0 00-3-3zm1 15a1 1 0 01-1 1H8a1 1 0 01-1-1V7a1 1 0 011-1h1a1 1 0 001-1V4h4v1a1 1 0 001 1h1a1 1 0 011 1v12zM15.5 9h-7a.5.5 0 00-.5.5v9a.5.5 0 00.5.5h7a.5.5 0 00.5-.5v-9a.5.5 0 00-.5-.5z",
            fill: "currentColor"
        })
    });



const $d31ed02c3b849d83$export$fcbdc36760308266 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 4a2 2 0 00-2-2h-4a2 2 0 00-2 2 3 3 0 00-3 3v12a3 3 0 003 3h8a3 3 0 003-3V7a3 3 0 00-3-3zm1 15a1 1 0 01-1 1H8a1 1 0 01-1-1V7a1 1 0 011-1h1a1 1 0 001-1V4h4v1a1 1 0 001 1h1a1 1 0 011 1v12zM15.5 8h-7a.5.5 0 00-.5.5v10a.5.5 0 00.5.5h7a.5.5 0 00.5-.5v-10a.5.5 0 00-.5-.5z",
            fill: "currentColor"
        })
    });



const $1140c8e544d7ea1b$export$5398c1d319c66d3a = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 22H8a3 3 0 01-3-3V7a3 3 0 013-3 2 2 0 012-2h4a2 2 0 012 2 3 3 0 013 3v12a3 3 0 01-3 3zM8 6a1 1 0 00-1 1v12a1 1 0 001 1h8a1 1 0 001-1V7a1 1 0 00-1-1h-1a1 1 0 01-1-1V4h-4v1a1 1 0 01-1 1H8z",
            fill: "currentColor"
        })
    });



const $c55bbcf22feeaafc$export$14049bfbe4016896 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 4a2 2 0 00-2-2h-4a2 2 0 00-2 2 3 3 0 00-3 3v12a3 3 0 003 3h8a3 3 0 003-3V7a3 3 0 00-3-3zm1 15a1 1 0 01-1 1H8a1 1 0 01-1-1V7a1 1 0 011-1h1a1 1 0 001-1V4h4v1a1 1 0 001 1h1a1 1 0 011 1v12zm-3-7h-2l1.8-2.4a1 1 0 00-1.6-1.2l-3 4a1 1 0 00-.09 1 1 1 0 00.89.6h2l-1.8 2.4a1 1 0 001.6 1.2l3-4A1 1 0 0014 12z",
            fill: "currentColor"
        })
    });



const $c58b5bd2f63bee97$export$c8f4b878a40e18dd = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15.5 7h-7a.5.5 0 00-.5.5v11a.5.5 0 00.5.5h7a.5.5 0 00.5-.5v-11a.5.5 0 00-.5-.5zm.5-3a2 2 0 00-2-2h-4a2 2 0 00-2 2 3 3 0 00-3 3v12a3 3 0 003 3h8a3 3 0 003-3V7a3 3 0 00-3-3zm1 15a1 1 0 01-1 1H8a1 1 0 01-1-1V7a1 1 0 011-1h1a1 1 0 001-1V4h4v1a1 1 0 001 1h1a1 1 0 011 1v12z",
            fill: "currentColor"
        })
    });



const $a5aeed993cd9e087$export$f066529347c0624a = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 4a2 2 0 00-2-2h-4a2 2 0 00-2 2 3 3 0 00-3 3v12a3 3 0 003 3h8a3 3 0 003-3V7a3 3 0 00-3-3zm-1.2 9.6l-3 4a.999.999 0 11-1.6-1.2L12 14h-2a1 1 0 01-.89-.55 1 1 0 01.09-1l3-4a1 1 0 111.6 1.2L12 12h2a1 1 0 01.8 1.6z",
            fill: "currentColor"
        })
    });



const $9bed904f66b2e60a$export$e5c696f324e938a5 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 8a3 3 0 00-3-3H5a3 3 0 00-3 3v8a3 3 0 003 3h12a3 3 0 003-3 2 2 0 002-2v-4a2 2 0 00-2-2zm0 6h-1a1 1 0 00-1 1v1a1 1 0 01-1 1H5a1 1 0 01-1-1V8a1 1 0 011-1h12a1 1 0 011 1v1a1 1 0 001 1h1v4zM7.5 9h-1a.5.5 0 00-.5.5v5a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-5a.5.5 0 00-.5-.5z",
            fill: "currentColor"
        })
    });



const $6956d2ab4e4818cb$export$3bc5b24507be3647 = (v)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...v,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 8a3 3 0 00-3-3H5a3 3 0 00-3 3v8a3 3 0 003 3h12a3 3 0 003-3 2 2 0 002-2v-4a2 2 0 00-2-2zm0 6h-1a1 1 0 00-1 1v1a1 1 0 01-1 1H5a1 1 0 01-1-1V8a1 1 0 011-1h12a1 1 0 011 1v1a1 1 0 001 1h1v4zM7.5 9h-1a.5.5 0 00-.5.5v5a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-5a.5.5 0 00-.5-.5zm4 0h-1a.5.5 0 00-.5.5v5a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-5a.5.5 0 00-.5-.5z",
            fill: "currentColor"
        })
    });



const $e305b1c9a592ca23$export$8f6eb1ed4f92e374 = (v)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...v,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 8a3 3 0 00-3-3H5a3 3 0 00-3 3v8a3 3 0 003 3h12a3 3 0 003-3 2 2 0 002-2v-4a2 2 0 00-2-2zm0 6h-1a1 1 0 00-1 1v1a1 1 0 01-1 1H5a1 1 0 01-1-1V8a1 1 0 011-1h12a1 1 0 011 1v1a1 1 0 001 1h1v4zM7.5 9h-1a.5.5 0 00-.5.5v5a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-5a.5.5 0 00-.5-.5zm4 0h-1a.5.5 0 00-.5.5v5a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-5a.5.5 0 00-.5-.5zm4 0h-1a.5.5 0 00-.5.5v5a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-5a.5.5 0 00-.5-.5z",
            fill: "currentColor"
        })
    });



const $19822843798530f9$export$99ce065d3316f17e = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 8a3 3 0 00-3-3H5a3 3 0 00-3 3v8a3 3 0 003 3h12a3 3 0 003-3 2 2 0 002-2v-4a2 2 0 00-2-2zm0 6h-1a1 1 0 00-1 1v1a1 1 0 01-1 1H5a1 1 0 01-1-1V8a1 1 0 011-1h12a1 1 0 011 1v1a1 1 0 001 1h1v4z",
            fill: "currentColor"
        })
    });



const $a2ab302a43309d85$export$b4021e825a5851ae = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15.5 15h-7a.5.5 0 00-.5.5v3a.5.5 0 00.5.5h7a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5zM16 4a2 2 0 00-2-2h-4a2 2 0 00-2 2 3 3 0 00-3 3v12a3 3 0 003 3h8a3 3 0 003-3V7a3 3 0 00-3-3zm1 15a1 1 0 01-1 1H8a1 1 0 01-1-1V7a1 1 0 011-1h1a1 1 0 001-1V4h4v1a1 1 0 001 1h1a1 1 0 011 1v12z",
            fill: "currentColor"
        })
    });



const $69d5bd10a5c97d7d$export$1adc8bebe7d941f6 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15.5 10h-7a.5.5 0 00-.5.5v8a.5.5 0 00.5.5h7a.5.5 0 00.5-.5v-8a.5.5 0 00-.5-.5zm.5-6a2 2 0 00-2-2h-4a2 2 0 00-2 2 3 3 0 00-3 3v12a3 3 0 003 3h8a3 3 0 003-3V7a3 3 0 00-3-3zm1 15a1 1 0 01-1 1H8a1 1 0 01-1-1V7a1 1 0 011-1h1a1 1 0 001-1V4h4v1a1 1 0 001 1h1a1 1 0 011 1v12z",
            fill: "currentColor"
        })
    });



const $795bc54d2270d46a$export$ab7f4ebb56747fd5 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.49 3.51c-.4-.4-1.04-.4-1.44 0L3.51 19.04c-.4.4-.4 1.04 0 1.44.4.4 1.04.4 1.44 0l.29-.29A3.005 3.005 0 007.99 22h8c1.65 0 3-1.35 3-3V7c0-.17-.02-.34-.05-.51l1.54-1.54c.4-.4.4-1.04 0-1.44h.01zM17 19c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1v-.56l1-1v1.06c0 .28.22.5.5.5h7c.28 0 .5-.22.5-.5V9.44l1-1V19zM7 7c0-.55.45-1 1-1h1c.55 0 1-.45 1-1V4h4v1c0 .21.08.4.2.56l1.78-1.78C15.87 2.78 15.03 2 14 2h-4c-1.1 0-2 .9-2 2-1.65 0-3 1.35-3 3v7.76l2-2V7zm1 1.5v3.26L11.76 8H8.5c-.28 0-.5.22-.5.5z",
            fill: "currentColor"
        })
    });



const $bd9ca32781e18b39$export$d648d85c57127b65 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M8.95 4h4v1a1 1 0 00.3.71c.18.19.44.29.7.29h1c.27 0 .52.11.71.29.19.19.29.45.29.71v2h2V7c0-.79-.31-1.56-.88-2.12-.56-.56-1.32-.88-2.12-.88 0-.53-.21-1.04-.58-1.41C14 2.22 13.48 2 12.95 2h-4c-.53 0-1.04.21-1.41.59-.12.12-.23.26-.31.41l1.72 1.72V4zm5.31 6.03l5.06 5.06c.03-2.89.64-4.1.65-4.13.06-.1.08-.21.08-.33a.765.765 0 00-.11-.32.868.868 0 00-.27-.23.784.784 0 00-.35-.08h-4.33c-.25 0-.49.01-.73.03zm.69-2.53a.491.491 0 00-.5-.5h-3.22l2.11 2.11c.5-.07 1.02-.11 1.56-.11h.05V7.5zM9.64 21.45s.01-.02.02-.03l-.08.07s.04-.02.06-.04zm11.2-2.01s-.08-.1-.13-.15l-1.83-1.83-3.31-3.31-1.03-1.03-3.43-3.43-2.08-2.08L7.42 6 5.7 4.28l-.99-.99c-.05-.05-.1-.09-.15-.13-.4-.25-.93-.21-1.27.13-.39.39-.39 1.03 0 1.42l.97.97c-.2.41-.31.86-.31 1.32v12c0 .8.32 1.56.88 2.12.56.57 1.33.88 2.12.88h.37c-.64-.61-1.37-2-1.37-3V7.37l1 1v5.08a7.677 7.677 0 012.32-2.76l.76.76c-1.9 1.34-2.98 3.62-2.98 6.55 0 1.87.52 2.89 1.17 3.42.03.01.05.02.08.02.03.01.05 0 .08 0 .03-.01.05-.03.07-.04.02-.02.03-.04.04-.07.18-3.08 1.6-5.48 4.22-7.2l.99.99c-2.48 1.56-3.71 3.78-3.76 6.7 0 .03.02.06.04.09.01.01 0 .03.01.04.01 0 .03 0 .04.01.03.02.06.04.1.04.29 0 .57-.02.85-.04 2.86-.18 4.94-1.07 6.31-2.31.17-.15.32-.31.47-.47l1.53 1.53c.2.19.45.29.71.29.26 0 .51-.1.71-.29.34-.34.38-.87.13-1.27z",
            fill: "currentColor"
        })
    });



const $c9f8e7a0e77385a9$export$580bcb30770deed9 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M9.69 21.45s.01-.02.02-.03l-.08.07s.04-.02.06-.04zM7.5 7a.47.47 0 00-.35.15c-.09.1-.15.22-.15.35v5.95C8.41 10.65 11.22 9 14.94 9H15V7.5a.47.47 0 00-.15-.35.529.529 0 00-.35-.15h-7zM6 7c0-.27.11-.52.29-.71C6.47 6.1 6.73 6 7 6h1c.27 0 .52-.11.71-.29A.99.99 0 009 5V4h4v1c0 .27.11.52.29.71.18.19.44.29.71.29h1c.27 0 .52.11.71.29.19.19.29.44.29.71v2h2V7c0-.8-.32-1.56-.88-2.12S15.79 4 15 4c0-.53-.21-1.04-.59-1.41C14.03 2.22 13.53 2 13 2H9c-.53 0-1.04.21-1.41.59C7.22 2.97 7 3.47 7 4c-.8 0-1.56.32-2.12.88S4 6.21 4 7v12c0 .8.32 1.56.88 2.12S6.21 22 7 22h.37C6.73 21.39 6 20 6 19V7zm13.98 3.31a.711.711 0 00-.26-.23.853.853 0 00-.35-.08h-4.33c-4.9 0-7.94 3.07-7.94 8 0 1.87.53 2.89 1.18 3.42.02.01.05.02.08.02h.08c.03 0 .05-.02.07-.04.02-.02.03-.04.04-.06.24-4 2.56-6.86 6.91-8.58.09-.04.18-.06.28-.06a.722.722 0 01.52.18c.07.06.13.14.16.22a.583.583 0 010 .52c-.04.08-.09.16-.16.22s-.15.11-.24.14c-3.99 1.55-5.96 4.13-6.03 7.84 0 .03.02.06.04.09 0 .01 0 .03.02.04 0 0 .03 0 .04.01.03.02.06.04.1.04.29 0 .57-.02.85-.04 5.71-.35 8.35-3.6 8.35-6.63s.64-4.34.65-4.37c.05-.1.08-.21.07-.33 0-.11-.04-.22-.11-.32h-.02zM9.94 21.94s.03 0 .04.01c-.01 0-.03 0-.04-.01zm-.06-.13s.02.06.04.09c-.02-.03-.04-.06-.04-.09z",
            fill: "currentColor"
        })
    });



const $c098f6042b8ea6ba$export$2faf204402d29b06 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 9c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1s1-.45 1-1v-3c0-.55-.45-1-1-1zm-.71 6.29c-.18.19-.29.44-.29.71 0 .13.03.26.08.38s.12.23.21.33c.1.09.21.16.33.21.12.06.25.08.38.08s.26-.02.38-.08c.12-.05.23-.12.33-.21A.99.99 0 0013 16c0-.27-.11-.52-.29-.71-.37-.37-1.05-.37-1.42 0zM16 4c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2-1.65 0-3 1.35-3 3v12c0 1.65 1.35 3 3 3h8c1.65 0 3-1.35 3-3V7c0-1.65-1.35-3-3-3zm1 15c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1V7c0-.55.45-1 1-1h1c.55 0 1-.45 1-1V4h4v1c0 .55.45 1 1 1h1c.55 0 1 .45 1 1v12z",
            fill: "currentColor"
        })
    });



const $4fd5c24d3681195d$export$c8ca6aa7247d22af = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 16.59v-.09-.06a1.37 1.37 0 00-.07-.29v-.12a1.099 1.099 0 00-.28-.33L13.67 12l4.93-3.7a1.1 1.1 0 00.28-.3v-.12a1.37 1.37 0 00.12-.32V7.5v-.09a1.307 1.307 0 00-.06-.27 1.088 1.088 0 00-.1-.14.357.357 0 000-.09 1.273 1.273 0 00-.13-.11s0-.07-.07-.09l-6-4.5A1 1 0 0011 3v7L6.6 6.7a1 1 0 10-1.2 1.6l4.93 3.7-4.93 3.7a1 1 0 101.2 1.6L11 14v7a1 1 0 00.55.89 1.001 1.001 0 001-.09l6-4.5s.06-.08.09-.11.08-.05.11-.09a.357.357 0 000-.09c.03-.048.057-.098.08-.15a1.31 1.31 0 00.17-.27zM13 5l3.33 2.5L13 10V5zm0 14v-5l3.33 2.5L13 19z",
            fill: "currentColor"
        })
    });



const $3084cab0cad8c25d$export$fb8e03e19f644f30 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18.92 16.15v-.12a1.099 1.099 0 00-.28-.33L13.67 12l4.93-3.7a1.1 1.1 0 00.28-.3v-.12a1.37 1.37 0 00.12-.32V7.5v-.09a1.307 1.307 0 00-.06-.27 1.088 1.088 0 00-.1-.14.357.357 0 000-.09 1.273 1.273 0 00-.13-.11s0-.07-.07-.09l-6-4.5A1 1 0 0011 3v7L6.6 6.7a1 1 0 00-1.2 1.6l4.93 3.7-4.93 3.7a1 1 0 101.2 1.6L11 14v7a1 1 0 00.55.89 1.001 1.001 0 001-.09l6-4.5s.06-.08.09-.11.08-.05.11-.09a.357.357 0 000-.09c.03-.048.057-.098.08-.15.03-.088.05-.178.06-.27v-.09-.06c.02-.096.03-.193.03-.29zM13 5l3.33 2.5L13 10V5zm0 14v-5l3.33 2.5L13 19zm6.5-8.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM6 12a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0z",
            fill: "currentColor"
        })
    });



const $b89c78c433ce965c$export$f1209b822ca0d56e = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7.05 15.54l-.71.7a1.004 1.004 0 001.42 1.42l.7-.71a1 1 0 10-1.41-1.41zM7 12a1 1 0 00-1-1H5a1 1 0 000 2h1a1 1 0 001-1zm10-3.54l.71-.7a1.004 1.004 0 10-1.42-1.42l-.7.71A1 1 0 1017 8.46zM12 7a1 1 0 001-1V5a1 1 0 00-2 0v1a1 1 0 001 1zM7.05 8.46a1 1 0 101.41-1.41l-.7-.71a1.004 1.004 0 10-1.42 1.42l.71.7zM12 17a1 1 0 00-1 1v1a1 1 0 002 0v-1a1 1 0 00-1-1zm7-6h-1a1 1 0 000 2h1a1 1 0 000-2zm-2 4.54A1.033 1.033 0 0015.54 17l.7.71a1.004 1.004 0 101.42-1.42l-.66-.75zM12 8a4 4 0 100 8 4 4 0 000-8z",
            fill: "currentColor"
        })
    });



const $c15268d51515ea3f$export$b0801c9e1012c220 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16.24 8.76a1 1 0 00.71-.3l2.12-2.12a1 1 0 10-1.41-1.41l-2.12 2.12a1 1 0 000 1.41 1 1 0 00.7.3zm-9.19 6.78l-2.12 2.12a1 1 0 000 1.41 1 1 0 001.41 0L8.46 17a1 1 0 000-1.41 1 1 0 00-1.41-.05zM7 12a1 1 0 00-1-1H3a1 1 0 000 2h3a1 1 0 001-1zm0-3.54a1 1 0 00.71.3 1 1 0 00.7-.3 1 1 0 000-1.41L6.34 4.93a1 1 0 00-1.41 1.41L7 8.46zM12 7a1 1 0 001-1V3a1 1 0 00-2 0v3a1 1 0 001 1zm5 8.54a1 1 0 00-1.41 0 1 1 0 000 1.41l2.12 2.12a1 1 0 001.41 0 1 1 0 000-1.41L17 15.54zM21 11h-3a1 1 0 000 2h3a1 1 0 000-2zm-9-3a4 4 0 100 8 4 4 0 000-8zm0 6v-4a2 2 0 010 4zm0 3a1 1 0 00-1 1v3a1 1 0 002 0v-3a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $e175c85fa4518962$export$55e87ba4758f7bce = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 7a1 1 0 001-1V3a1 1 0 00-2 0v3a1 1 0 001 1zM7.05 8.46a1 1 0 00.71.3 1 1 0 00.7-.3 1 1 0 000-1.41L6.34 4.93a1 1 0 00-1.41 1.41l2.12 2.12zm9.19.3a1 1 0 00.71-.3l2.12-2.12a1 1 0 10-1.41-1.41l-2.12 2.12a1 1 0 000 1.41 1 1 0 00.7.3zM7 12a1 1 0 00-1-1H3a1 1 0 000 2h3a1 1 0 001-1zm10 3.54a1 1 0 00-1.41 0 1 1 0 000 1.41l2.12 2.12a1 1 0 001.41 0 1 1 0 000-1.41L17 15.54zM12 8a4 4 0 100 8 4 4 0 000-8zm9 3h-3a1 1 0 000 2h3a1 1 0 000-2zm-9 6a1 1 0 00-1 1v3a1 1 0 002 0v-3a1 1 0 00-1-1zm-4.95-1.46l-2.12 2.12a1 1 0 000 1.41 1 1 0 001.41 0L8.46 17a1 1 0 000-1.41 1 1 0 00-1.41-.05z",
            fill: "currentColor"
        })
    });



const $468b9865b5c26934$export$4d765c7c1cfddfa7 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 11h-2a1 1 0 000 2h2a1 1 0 000-2zM7.05 8.46a1 1 0 101.41-1.41L7.05 5.64a1 1 0 00-1.41 1.41l1.41 1.41zM12 7a1 1 0 001-1V4a1 1 0 00-2 0v2a1 1 0 001 1zm5 1.46l1.41-1.41A1 1 0 1017 5.64l-1.46 1.41A1.015 1.015 0 1017 8.46zM7 12a1 1 0 00-1-1H4a1 1 0 000 2h2a1 1 0 001-1zm10 3.54A1.033 1.033 0 0015.54 17L17 18.36A1 1 0 1018.36 17L17 15.54zM12 8a4 4 0 100 8 4 4 0 000-8zm0 9a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1zm-4.95-1.46L5.64 17a1 1 0 101.41 1.41L8.46 17a1 1 0 10-1.41-1.41v-.05z",
            fill: "currentColor"
        })
    });



const $e5b4a711261802c6$export$e96ca8840706dba4 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 11.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM12 3a10 10 0 00-7.07 17.07 1 1 0 101.41-1.41 8 8 0 1111.32 0 1 1 0 000 1.41 1 1 0 001.41 0A10 10 0 0012 3zm0 4a6 6 0 00-6 6 5.93 5.93 0 001.76 4.24 1 1 0 101.41-1.41 4 4 0 115.66 0 1 1 0 000 1.41 1 1 0 001.41 0A5.931 5.931 0 0018 13a6 6 0 00-6-6z",
            fill: "currentColor"
        })
    });



const $5ab532ce162c2edb$export$c8eb348f91f7fa1f = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 5H5a3 3 0 00-3 3v8a3 3 0 003 3h14a3 3 0 003-3V8a3 3 0 00-3-3zm-5 10a1 1 0 01-2 0v-3.59l-.29.3a1.004 1.004 0 11-1.42-1.42l2-2a1 1 0 011.09-.21A1 1 0 0114 9v6zm5.71-1.29l-2 2A1 1 0 0117 16a.84.84 0 01-.38-.08A1 1 0 0116 15V9a1 1 0 012 0v3.59l.29-.3a1.004 1.004 0 111.42 1.42z",
            fill: "currentColor"
        })
    });



const $f68d8e21383d28aa$export$c5c370ca015691e7 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zm-1 13.75a1 1 0 01-2 0V11.1l-1.22 1.52a1 1 0 11-1.56-1.24l3-3.76a1 1 0 011.78.63v7.5zm6.78-3.13l-3 3.76a1 1 0 01-1.594-.054A1 1 0 0113 15.75v-7.5a1 1 0 012 0v4.65l1.22-1.52a1 1 0 011.56 1.24z",
            fill: "currentColor"
        })
    });



const $acc842af34d6437b$export$dbcb75afc871b5f3 = (r)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                opacity: .2,
                d: "M10.29 14.29L8 16.59V6a1 1 0 00-2 0v10.59l-2.29-2.3a1.004 1.004 0 10-1.42 1.42l4 4a.998.998 0 001.42 0l4-4a.997.997 0 00.219-1.095.998.998 0 00-.22-.325 1 1 0 00-1.42 0zm11.42-6l-4-4a.999.999 0 00-1.42 0l-4 4a1 1 0 00.325 1.639 1 1 0 001.095-.22L16 7.41V18a1 1 0 102 0V7.41l2.29 2.3a1.004 1.004 0 001.42-1.42z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M11.71 14.29a1 1 0 00-1.42 0L8 16.59V6a1 1 0 00-2 0v10.59l-2.29-2.3a1.004 1.004 0 10-1.42 1.42l4 4a1.001 1.001 0 001.42 0l4-4a.999.999 0 000-1.42z",
                fill: "currentColor"
            })
        ]
    });



const $ca0bb1465950f462$export$ddd342073eb012f3 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10.29 14.29L8 16.59V6a1 1 0 00-2 0v10.59l-2.29-2.3a1.004 1.004 0 10-1.42 1.42l4 4a.998.998 0 001.42 0l4-4a.997.997 0 00.219-1.095.998.998 0 00-.22-.325 1 1 0 00-1.42 0zm11.42-6l-4-4a.999.999 0 00-1.42 0l-4 4a1 1 0 00.325 1.639 1 1 0 001.095-.22L16 7.41V18a1 1 0 102 0V7.41l2.29 2.3a1.004 1.004 0 001.42-1.42z",
            fill: "currentColor"
        })
    });



const $ae72199ca43e0b93$export$d608cabdebe455c3 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            opacity: .2,
            d: "M10.29 14.29L8 16.59V6a1 1 0 00-2 0v10.59l-2.29-2.3a1.004 1.004 0 10-1.42 1.42l4 4a.998.998 0 001.42 0l4-4a.997.997 0 00.219-1.095.998.998 0 00-.22-.325 1 1 0 00-1.42 0zm11.42-6l-4-4a.999.999 0 00-1.42 0l-4 4a1 1 0 00.325 1.639 1 1 0 001.095-.22L16 7.41V18a1 1 0 102 0V7.41l2.29 2.3a1.004 1.004 0 001.42-1.42z",
            fill: "currentColor"
        })
    });



const $2c552fe7d77f3382$export$4ca275033a367467 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7.71 7.71L9 6.41V12a1 1 0 102 0V4a1 1 0 00-.62-.92 1 1 0 00-1.09.21l-3 3a1.004 1.004 0 001.42 1.42zm5.91 5.21A.84.84 0 0014 13a1 1 0 00.71-.29l3-3A1.005 1.005 0 0017 7.996a1.004 1.004 0 00-.71.294L15 9.59V4a1 1 0 00-2 0v8a1 1 0 00.62.92zm7.07 3.14a1 1 0 00-1.41 0l-2.17 2.28a1.999 1.999 0 01-1.45.62H12a1 1 0 010-2h1.66a1 1 0 000-2H8a2 2 0 00-2 2H4a1 1 0 00-1 1v2a1 1 0 001 1h11.66a4 4 0 002.89-1.24l2.17-2.28a1 1 0 00-.03-1.38z",
            fill: "currentColor"
        })
    });



const $669cfa7a60e3d3fa$export$189cc4536c1510fc = (r)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M21.71 8.29l-4-4a.999.999 0 00-1.42 0l-4 4a1 1 0 00.325 1.639 1 1 0 001.095-.22L16 7.41V18a1 1 0 102 0V7.41l2.29 2.3a1.004 1.004 0 001.42-1.42z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                opacity: .2,
                d: "M10.29 14.29L8 16.59V6a1 1 0 00-2 0v10.59l-2.29-2.3a1.004 1.004 0 10-1.42 1.42l4 4a.998.998 0 001.42 0l4-4a.997.997 0 00.219-1.095.998.998 0 00-.22-.325 1 1 0 00-1.42 0zm11.42-6l-4-4a.999.999 0 00-1.42 0l-4 4a1 1 0 00.325 1.639 1 1 0 001.095-.22L16 7.41V18a1 1 0 102 0V7.41l2.29 2.3a1.004 1.004 0 001.42-1.42z",
                fill: "currentColor"
            })
        ]
    });



const $5850b1f226ac7cf8$export$35ef738dee90a42f = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 3H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-3-3zm-7 12.75a1 1 0 01-2 0V11.1l-1.22 1.52a1 1 0 11-1.56-1.24l3-3.76a1 1 0 011.78.63v7.5zm6.78-3.13l-3 3.76a1 1 0 01-1.594-.054A1 1 0 0113 15.75v-7.5a1 1 0 012 0v4.65l1.22-1.52a1 1 0 011.56 1.24z",
            fill: "currentColor"
        })
    });



const $46a5ef6f8b5d8ada$export$3fea6b7ba88fca38 = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.74 18.01l-8-14A2.016 2.016 0 0012 3c-.72 0-1.38.38-1.74 1.01l-8 14c-.35.62-.35 1.38 0 2 .36.62 1.02 1 1.73 1H20c.71 0 1.37-.38 1.73-1 .36-.62.36-1.38 0-2h.01zM11 16c0 .55-.45 1-1 1s-1-.45-1-1v-2.59l-.29.29a.996.996 0 11-1.41-1.41l2-2c.29-.29.72-.37 1.09-.22.37.15.62.52.62.92v5L11 16zm5.71-1.29l-2 2c-.19.19-.45.29-.71.29-.13 0-.26-.02-.38-.08-.37-.15-.62-.52-.62-.92v-5c0-.55.45-1 1-1s1 .45 1 1v2.59l.29-.29a.996.996 0 111.41 1.41h.01z",
            fill: "currentColor"
        })
    });



const $1c06c6159879359a$export$c8687c349690d7a5 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 3H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-3-3zm-6 14a1 1 0 010-2 3 3 0 10-3-3.34l.29-.27a1 1 0 011.41 0 1 1 0 01-.05 1.41l-2 1.88a.86.86 0 01-.2.13l-.11.07A.94.94 0 018 15a1.001 1.001 0 01-.38-.08.408.408 0 01-.11-.07 1 1 0 01-.22-.14l-2-2a1.003 1.003 0 111.42-1.42l.33.33A5 5 0 1112 17z",
            fill: "currentColor"
        })
    });



const $aab03c39395734a0$export$796a563d960a4189 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M8.29 18.29A1 1 0 008 19a1 1 0 00.29.71A1 1 0 009 20h3v-2H9a1 1 0 00-.71.29zM20 7a3.91 3.91 0 012 .58V6a2 2 0 00-2-2H4a2 2 0 00-2 2v9a2 2 0 002 2h8v-5.84A4.1 4.1 0 0116 7h4zm1.45 2.67A2.16 2.16 0 0020 9h-4a2.16 2.16 0 00-1.45.67 2.13 2.13 0 00-.55 1.5v8.66a2.11 2.11 0 00.55 1.5A2.08 2.08 0 0016 22h4a2.08 2.08 0 001.45-.67 2.11 2.11 0 00.55-1.5v-8.67a2.13 2.13 0 00-.55-1.5v.01zm-2.74 10A1.001 1.001 0 0118 20a1 1 0 01-.858-.487 1 1 0 01.148-1.213 1 1 0 01.51-.3 1 1 0 01.58.06c.187.07.345.2.45.37A1 1 0 0119 19a1 1 0 01-.29.7v-.03z",
            fill: "currentColor"
        })
    });



const $48caf12f27dc64fb$export$8974fe194791cb57 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 3a2 2 0 00-2 2c.002.172.026.344.07.51l-3.66 3.66 1.42 1.42 3.66-3.66c.167.044.338.068.51.07a2 2 0 100-4zM7.05 5.64a1 1 0 00-1.41 0 9 9 0 1012.72 12.72 1 1 0 00.3-.7 1 1 0 00-.3-.71L7.05 5.64z",
            fill: "currentColor"
        })
    });



const $1ad29dc8dc9369d9$export$5672b1ca9f5ca3ac = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7.05 5.64a1 1 0 00-1.41 0 9 9 0 1012.72 12.72 1 1 0 00.3-.7.998.998 0 00-.3-.71L7.05 5.64zm6.07-2.56a1.007 1.007 0 10-.24 2 7 7 0 016.06 6.06 1 1 0 001 .88h.12a1 1 0 00.87-1.11 9 9 0 00-7.81-7.83zm1.77 8.17a1 1 0 001 .75h.25a1 1 0 00.72-1.22 5 5 0 00-3.58-3.58 1.002 1.002 0 10-.5 1.94 3 3 0 012.11 2.11z",
            fill: "currentColor"
        })
    });



const $a6ebae30c71c10b5$export$b627e71315d1a0ce = (v)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...v,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 6v10a4 4 0 01-4 4H8a2 2 0 002 2h5a5 5 0 005-5V8a2 2 0 00-2-2zm-2 10V4a2 2 0 00-2-2H9.79a3 3 0 00-2.15.91L4.85 5.78A3 3 0 004 7.87V16a2 2 0 002 2h8a2 2 0 002-2zM6 10h2v2H6v-2zm4 6H6.5a.5.5 0 01-.5-.5V14h4v2zm0-6h4v2h-4v-2zm3.5 6H12v-2h2v1.5a.5.5 0 01-.5.5z",
            fill: "currentColor"
        })
    });



const $4a275a1c8edbc6e4$export$b9b23667186823ad = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18.12 2.88C17.56 2.32 16.79 2 16 2h-5a2.993 2.993 0 00-2.38 1.13l-3 3.7C5.21 7.37 5 8.02 5 8.7V19c0 .8.32 1.56.88 2.12S7.21 22 8 22h8c.8 0 1.56-.32 2.12-.88S19 19.79 19 19V5c0-.8-.32-1.56-.88-2.12zM8.27 5.44a5.574 5.574 0 017.48 0c.08.07.13.17.13.28 0 .11-.03.21-.1.29-.04.04-.08.07-.13.1-.05.02-.11.03-.16.03-.1 0-.19-.03-.27-.1a4.794 4.794 0 00-3.2-1.23c-1.18 0-2.32.44-3.2 1.23-.08.07-.18.11-.29.1a.41.41 0 01-.28-.13.383.383 0 01-.1-.29.41.41 0 01.13-.28h-.01zM12 8.01c-.34 0-.68.11-.96.32a.44.44 0 01-.3.08.378.378 0 01-.26-.16.44.44 0 01-.08-.3c.02-.11.07-.2.16-.26a2.397 2.397 0 012.88 0c.08.06.1.12.1.12s.05.065.05.15c0 0 .015.087 0 .16a.37.37 0 01-.07.14c-.04.05-.09.09-.14.12-.05.03-.12.04-.18.04-.09 0-.17-.03-.24-.08-.28-.21-.61-.33-.96-.33zm.6 1.39c0 .12-.04.23-.1.33-.06.1-.16.18-.27.22-.11.05-.23.06-.35.03a.617.617 0 01-.31-.16.58.58 0 01-.16-.31.69.69 0 01.03-.35c.05-.11.12-.2.22-.27s.21-.1.33-.1c.16 0 .31.06.42.18.11.11.18.27.18.42l.01.01zm-.6-3c-.76 0-1.5.27-2.08.76-.08.07-.19.1-.29.09-.11 0-.2-.06-.27-.14a.389.389 0 01-.09-.29c0-.11.06-.2.14-.27.72-.62 1.64-.96 2.6-.96.95 0 1.87.34 2.6.96.08.07.13.17.14.27 0 .11-.03.21-.09.29a.42.42 0 01-.27.14c-.11 0-.21-.03-.29-.09-.58-.49-1.33-.76-2.1-.76zM7 12h3v3H7v-3zm5 8H8c-.27 0-.52-.11-.71-.29A.99.99 0 017 19v-2h5v3zm5-1c0 .27-.11.52-.29.71A.99.99 0 0116 20h-2v-3h3v2zm0-4h-5v-3h5v3z",
            fill: "currentColor"
        })
    });



const $aea712d978c57b3d$export$489cec4575421161 = (a)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M19.46 9.25a1.002 1.002 0 00.97.75c.17 0 .34-.05.49-.13.15-.08.28-.21.36-.36.46-.75.7-1.62.7-2.5 0-.88-.24-1.75-.7-2.5-.15-.2-.36-.34-.6-.39-.24-.05-.49-.01-.71.11a1.008 1.008 0 00-.41 1.28c.27.45.42.96.43 1.49a2.9 2.9 0 01-.43 1.49c-.14.23-.17.5-.11.76h.01zM13.08 9.87a1.002 1.002 0 001.46-.62c.07-.25.03-.53-.11-.76-.27-.45-.42-.96-.43-1.49 0-.53.16-1.04.43-1.49a1.008 1.008 0 00-.41-1.28.977.977 0 00-.71-.11.98.98 0 00-.6.39c-.46.75-.7 1.62-.7 2.5 0 .88.24 1.75.7 2.5.09.15.21.27.36.36h.01z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M22 17v-2c0-.8-.32-1.56-.88-2.12S19.79 12 19 12h-1V5c0-.27-.11-.52-.29-.71A.973.973 0 0017 4c-.27 0-.52.11-.71.29-.19.18-.29.44-.29.71v7h-2.58L4.7 3.28a.996.996 0 10-1.41 1.41l17 17c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 000-1.41l-.9-.9c.11-.08.22-.16.32-.26.56-.56.88-1.33.88-2.12H22zM5 12c-.8 0-1.56.32-2.12.88S2 14.21 2 15v2c0 .8.32 1.56.88 2.12S4.21 20 5 20h10.76l-8-8H5zm1.71 4.71A.99.99 0 016 17a1.014 1.014 0 01-.99-1.2c.04-.19.13-.37.27-.51s.32-.24.51-.27a1.014 1.014 0 011.2.99c0 .27-.11.52-.29.71l.01-.01zm2.31-.9c.04-.19.13-.37.27-.51s.32-.24.51-.27a1.014 1.014 0 011.2.99c0 .27-.11.52-.29.71-.18.19-.44.29-.71.29a1.014 1.014 0 01-.99-1.2l.01-.01z",
                fill: "currentColor"
            })
        ]
    });



const $bce5ec1fde31aef1$export$f282da7d50c61c30 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M5.59 12.18l7.7-9.62A1.48 1.48 0 0115.83 4l-2 5.48h2.67a2 2 0 011.51 3.24l-7.37 8.75A1.48 1.48 0 018.16 20l1.77-4.6h-2.8a2 2 0 01-1.54-3.22z",
            fill: "currentColor"
        })
    });



const $3d8752ccb595a75b$export$16505b2ddbff0a49 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18.05 12.71a2 2 0 00-1.51-3.24h-2.67l2-5.48a1.48 1.48 0 00-2.54-1.43l-2.88 3.6 7.14 7.14.46-.59zM20.49 19L5 3.51A1.054 1.054 0 003.51 5l4.37 4.32-2.29 2.86a2 2 0 001.54 3.2h2.8L8.16 20a1.48 1.48 0 002.52 1.48L15 16.39l4 4.1A1.054 1.054 0 1020.49 19z",
            fill: "currentColor"
        })
    });



const $0bbe97b3b1d7c28c$export$5cec8b7b80b4c165 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.5 3.5a2 2 0 00-2.83 0L14.13 7 4.7 5.81a1.5 1.5 0 00-1 2.76L9.18 12l-1.41 1.4-3 .27a1.5 1.5 0 00-.6 2.8l2.14 1.21 1.21 2.14a1.5 1.5 0 002.8-.6l.27-3 1.41-1.4 3.42 5.47a1.5 1.5 0 002.76-1L17 9.87l3.5-3.54a1.999 1.999 0 000-2.83z",
            fill: "currentColor"
        })
    });



const $919f45f0dd8f3842$export$64bfe7d70d4969d7 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M3.71 8.57l4.56 2.92 4.61-4.61L4.7 5.81a1.5 1.5 0 00-.99 2.76zm0 7.47l2.5-2.5-1.43.13A1.5 1.5 0 003.71 16v.04zM20.5 3.5l-.13-.1.12.11a1 1 0 00-1.45 0L3.51 19A1.053 1.053 0 105 20.49l1.84-1.89.69 1.22a1.5 1.5 0 002.8-.6l.27-3 1.4-1.4 3.42 5.47a1.5 1.5 0 002.76-1L17 9.87l3.5-3.54a2 2 0 000-2.83z",
            fill: "currentColor"
        })
    });



const $9837f830af53d1be$export$352666b9a4904a55 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M5 11v2c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-2c0-.55-.45-1-1-1H6c-.55 0-1 .45-1 1zm-2-1c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1s1-.45 1-1v-2c0-.55-.45-1-1-1zm18 0c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1s1-.45 1-1v-2c0-.55-.45-1-1-1zm-3.34 6.24a.996.996 0 10-1.41 1.41l1.41 1.41a.996.996 0 101.41-1.41l-1.41-1.41zm-11.31 0l-1.41 1.41a.996.996 0 101.41 1.41l1.41-1.41a.996.996 0 10-1.41-1.41zM12.01 18c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1s1-.45 1-1v-2c0-.55-.45-1-1-1zM6.34 7.76a.996.996 0 101.41-1.41L6.34 4.94a.996.996 0 10-1.41 1.41l1.41 1.41zm11.31-2.83l-1.41 1.41a.996.996 0 101.41 1.41l1.41-1.41a.996.996 0 10-1.41-1.41zM11.99 6c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1s-1 .45-1 1v2c0 .55.45 1 1 1z",
            fill: "currentColor"
        })
    });



const $60b583b4df8f3ae5$export$d8a6625d809f5391 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4 11a8 8 0 012.05-5.33A1 1 0 006.3 5a1 1 0 00-.3-.74 1 1 0 00-1.41.07 10 10 0 000 13.34 1.002 1.002 0 001.49-1.34A8 8 0 014 11zm8 2a2 2 0 100-4 2 2 0 000 4zm-3.18.39a4 4 0 010-4.78 1.002 1.002 0 10-1.59-1.22 6 6 0 000 7.22 1.002 1.002 0 101.59-1.22zm8-6a1.002 1.002 0 00-1.59 1.22 4 4 0 010 4.78 1.002 1.002 0 101.59 1.22 6 6 0 00-.05-7.22h.05zm2.67-3.06A1.002 1.002 0 0018 5.67a8 8 0 010 10.66 1 1 0 00-.25.67 1 1 0 001.74.67 10 10 0 000-13.34zm-6.34 10.21a1.54 1.54 0 00-2.3 0l-2.5 3A1.5 1.5 0 009.5 20h5a1.519 1.519 0 001.36-.86 1.49 1.49 0 00-.21-1.6l-2.5-3z",
            fill: "currentColor"
        })
    });



const $9003388cd037e255$export$2a04953a3c18223e = (A)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...A,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 14a1 1 0 00-.71.29A1 1 0 0015 15v3.59l-.29-.3A1 1 0 0014 18a1 1 0 00-.71 1.71l2 2a1 1 0 00.32.22c.125.047.257.071.39.07a.84.84 0 00.38-.08 1 1 0 00.45-.37A1 1 0 0017 21v-6a1 1 0 00-.29-.71A1.05 1.05 0 0016 14zm5.71 2.29l-2-2a1 1 0 00-.52-.27.93.93 0 00-.57.06 1 1 0 00-.45.37A1 1 0 0018 15v6a1 1 0 00.29.71A1 1 0 0019 22a1.05 1.05 0 00.71-.29A1 1 0 0020 21v-3.59l.29.3A1 1 0 0021 18a1 1 0 00.71-1.71zM11 19.46A7.93 7.93 0 019.45 16H13v-1c0-.341.06-.68.18-1H9.11a17.83 17.83 0 010-4h5.78c.072.664.108 1.332.11 2v.19a2.8 2.8 0 012 0V12a14.51 14.51 0 00-.09-2h2.83c.166.654.254 1.325.26 2v.18c.427.14.814.38 1.13.7l.74.73A10 10 0 1012 22h.72l-.84-.88a2.91 2.91 0 01-.88-1.66zM18.92 8h-2.31a12.85 12.85 0 00-1-3.15A8.1 8.1 0 0118.92 8zM12 4c.84 0 1.95 1.48 2.55 4h-5.1c.6-2.52 1.71-4 2.55-4zm-7.74 6h2.83A14.51 14.51 0 007 12a14.51 14.51 0 00.09 2H4.26a7.75 7.75 0 010-4zm.82 6h2.31a12.43 12.43 0 001 3.15A8.1 8.1 0 015.08 16zm2.31-8H5.08a8.1 8.1 0 013.36-3.15A12.55 12.55 0 007.39 8z",
            fill: "currentColor"
        })
    });



const $45d61ccde4e8c6b3$export$84d6c69d0f2ae428 = (s)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...s,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4.2 9.42c-.4 0-.82.18-.82.74v5.25c0 .55.42.74.82.74.4 0 .81-.19.81-.74v-5.25c0-.56-.4-.74-.81-.74zM4.2 7c-.56 0-.94.39-.94.94 0 .55.38.94.94.94.56 0 .94-.4.94-.94 0-.54-.4-.94-.94-.94zm14.29 3.95l-1.21-.46c-.69-.25-1.12-.44-1.12-.96 0-.56.59-.92 1.43-.92.34 0 .87.04 1.51.44.12.08.25.17.47.17.42 0 .83-.47.83-.87 0-.25-.16-.47-.34-.61-.86-.65-1.75-.74-2.47-.74-1.96 0-3.19 1.01-3.19 2.54s.86 2.03 2.31 2.56l1.22.46c.66.25 1.07.51 1.07 1 0 .62-.57.99-1.42.99s-1.37-.25-1.83-.61c-.17-.13-.34-.26-.57-.26-.43 0-.87.51-.87.86 0 .26.12.43.25.56.64.64 1.64 1.07 3.03 1.07 1.9 0 3.17-.99 3.17-2.6 0-1.33-.83-2.05-2.28-2.6l.01-.02zM9.83 7c-1.09 0-1.91.17-2.63.98-.52.6-.77 1.85-.77 3.6s.25 3 .77 3.6c.71.81 1.53.97 2.63.97 1.1 0 1.91-.17 2.63-.97.52-.6.77-1.85.77-3.6s-.25-3-.77-3.6C11.75 7.17 10.93 7 9.83 7zm1.38 6.86c-.34.65-1.01.65-1.38.65-.37 0-1.04 0-1.38-.65-.26-.49-.26-1.26-.26-2.29s.01-1.79.26-2.29c.34-.68 1.01-.68 1.38-.68.37 0 1.03 0 1.38.68.25.49.26 1.26.26 2.29s0 1.79-.26 2.29z",
            fill: "currentColor"
        })
    });



const $3976b1fffb56f534$export$b886ba1cdab9ad66 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 7h-7v-.93a2 2 0 011.5-2 2 2 0 012 .63.999.999 0 00.72.31A1 1 0 0015 3.32 4 4 0 0011.41 2 4.13 4.13 0 008 6.17V7H7a3 3 0 00-3 3v9a3 3 0 003 3h10a3 3 0 003-3v-9a3 3 0 00-3-3zm-5 9a2 2 0 110-3.999 2 2 0 010 4z",
            fill: "currentColor"
        })
    });



const $9b286e67094416dd$export$420eb649ef5399c6 = (l)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M15.648 12.125h-.66v-.66a2.633 2.633 0 00-4.488-1.86c-.49.491-.77 1.16-.77 1.86v.66h-.659c-.52 0-1.03.21-1.4.58-.37.37-.579.87-.579 1.399v5.917c0 .52.21 1.03.58 1.4.37.37.87.579 1.399.579h6.577c.52 0 1.03-.21 1.399-.58.37-.37.58-.87.58-1.399v-5.917c0-.52-.21-1.03-.58-1.4-.37-.37-.87-.58-1.4-.58zm-2.36 5.537a1.31 1.31 0 01-1.658.17c-.22-.14-.39-.35-.48-.59a1.319 1.319 0 011.72-1.719c.239.09.449.27.589.48a1.309 1.309 0 01-.17 1.66zm-2.248-5.537v-.66c0-.35.14-.68.39-.93s.58-.39.93-.39c.35 0 .679.14.929.39s.39.58.39.93v.66H11.04z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M7.952 9.446c.37.19.83.05 1.03-.32.679-1.279 1.948-2.069 3.417-2.069 1.47 0 2.689.81 3.359 2.12.13.26.4.41.68.41.12 0 .24-.03.35-.08.369-.19.519-.65.329-1.02a5.329 5.329 0 00-4.798-2.939c-1.939 0-3.738 1.1-4.677 2.879-.2.37-.05.83.32 1.03l-.01-.01z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M20.066 6.428A8.813 8.813 0 0012.439 2h-.16a8.801 8.801 0 00-7.626 4.428c-.21.36-.08.83.28 1.04.37.21.83.08 1.04-.28a7.286 7.286 0 016.306-3.669h.16a7.286 7.286 0 016.307 3.668c.14.25.4.38.66.38.13 0 .26-.03.38-.1.36-.21.49-.67.28-1.04z",
                fill: "currentColor"
            })
        ]
    });



const $9915aaaa8ca39755$export$932a71886431ad92 = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 22 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18.578 14.267V9.772a1.975 1.975 0 10-1.97-3.425L12.717 4.1c0-1.09-.891-1.98-1.98-1.98-1.09 0-1.98.89-1.98 1.98l-3.88 2.237h-.01a1.983 1.983 0 00-2.704.723 1.983 1.983 0 00.723 2.702h.02v4.475h-.03a1.977 1.977 0 101.98 3.426l3.871 2.247v.02a1.98 1.98 0 103.96 0l3.89-2.238c.951.545 2.159.218 2.703-.722a1.985 1.985 0 00-.712-2.703h.01zM4.876 9.753l2.94 1.702c-.03.178-.06.357-.06.545 0 .188.02.346.05.515l-2.95 1.702V9.753h.02zm4.87 8.444l-3.9-2.257 2.95-1.703c.278.238.594.426.941.555v3.415l.01-.01zm0-8.989a2.846 2.846 0 00-.92.535L5.866 8.04l3.88-2.228v3.406-.01zm1.98-3.415l3.862 2.237-2.95 1.703a2.88 2.88 0 00-.911-.525V5.793zm3.882 10.167l-3.881 2.227v-3.405c.346-.12.663-.307.93-.545l2.95 1.703v.02zm.99-1.723l-2.94-1.703c.029-.178.049-.346.049-.534 0-.188-.02-.376-.06-.565l2.93-1.692s.01 0 .02.01v4.484z",
            fill: "currentColor"
        })
    });



const $e2aea2f74856a1d1$export$2380d4d407b6b09b = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15 2H9a3 3 0 00-3 3v14a3 3 0 003 3h6a3 3 0 003-3V5a3 3 0 00-3-3zm-3 18a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5z",
            fill: "currentColor"
        })
    });



const $e06c37f27e760e04$export$ee5ce2ba922d5764 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10.38 3.08a1 1 0 00-1.09.21l-6 6a1.004 1.004 0 001.42 1.42L9 6.41V20a1 1 0 102 0V4a1 1 0 00-.62-.92zm10.33 10.21a1.002 1.002 0 00-1.42 0L15 17.59V4a1 1 0 00-2 0v16a1 1 0 00.62.92.84.84 0 00.38.08 1 1 0 00.71-.29l6-6a1.002 1.002 0 000-1.42z",
            fill: "currentColor"
        })
    });



const $e7fc66320124678f$export$55344ff6edd418e5 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15 4a1 1 0 00-2 0v2.76l2-2V4zM4.71 10.71L9 6.41v4.35l2-2V4a1 1 0 00-.62-.92 1 1 0 00-1.09.21l-6 6a1.004 1.004 0 001.42 1.42zm16 2.58a1.002 1.002 0 00-1.42 0L15 17.59v-7.15L20.49 5a1.055 1.055 0 00-1.148-1.718c-.128.053-.244.13-.342.228L3.51 19A1.054 1.054 0 105 20.49l4-4V20a1 1 0 102 0v-5.56l2-2V20a1 1 0 00.62.92.84.84 0 00.38.08 1 1 0 00.71-.29l6-6a1.002 1.002 0 000-1.42z",
            fill: "currentColor"
        })
    });



const $eea944fbbbff202b$export$fade213f9393def4 = (s)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...s,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15 2H9C7.34 2 6 3.34 6 5v14c0 1.66 1.34 3 3 3h6c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3zM9 20c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm0-3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm3 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm0-3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm3 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm0-3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm1-5c0 .55-.45 1-1 1H9c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h6c.55 0 1 .45 1 1v7z",
            fill: "currentColor"
        })
    });



const $c2411d516e41abd9$export$2f2008cf98717641 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M2 9v6a3 3 0 003 3h14a3 3 0 003-3V9a3 3 0 00-3-3H5a3 3 0 00-3 3zm18 3a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0z",
            fill: "currentColor"
        })
    });



const $0e602ab7deb3d034$export$a81a015a46ad3643 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 4h-4c-.94 0-1.84.45-2.4 1.2l-2 2.67c-.39.52-.6 1.15-.6 1.8V18c0 1.65 1.35 3 3 3h6c1.65 0 3-1.35 3-3V7c0-1.65-1.35-3-3-3zm-7 7h2v3h-2v-3zm4 8h-3c-.55 0-1-.45-1-1v-2h4v3zm4-1c0 .55-.45 1-1 1h-1v-3h2v2zm0-4h-4v-3h4v3zM8 9.19c0-.06.01-.12.02-.19H8c-.94 0-1.84.45-2.4 1.2l-2 2.67c-.39.52-.6 1.15-.6 1.8V18c0 1.65 1.35 3 3 3h3.03C8.4 20.16 8 19.13 8 18V9.19zM9.71 4.3l-2-2A.996.996 0 106.3 3.71l.29.29H3c-.55 0-1 .45-1 1s.45 1 1 1h3.59l-.29.29a.996.996 0 00.71 1.7c.26 0 .51-.1.71-.29l2-2a.996.996 0 000-1.41l-.01.01z",
            fill: "currentColor"
        })
    });



const $c864c33a124f157b$export$f5e1747f28b587d1 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15 2H9a3 3 0 00-3 3v8.76l11-11A3 3 0 0015 2zm5.49 1.51a1 1 0 00-1.45 0L3.51 19A1.053 1.053 0 105 20.49l1-1.09A3 3 0 009 22h6a3 3 0 003-3V7.44L20.49 5a.998.998 0 000-1.49zM12 20a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5z",
            fill: "currentColor"
        })
    });



const $a4a3b0ff1f4e8a8d$export$4c36bb98446f93be = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17.12 2.88C16.56 2.32 15.79 2 15 2H9c-.8 0-1.56.32-2.12.88S6 4.21 6 5v14c0 .8.32 1.56.88 2.12S8.21 22 9 22h6c.8 0 1.56-.32 2.12-.88S18 19.79 18 19V5c0-.8-.32-1.56-.88-2.12zm-4.24 16.76c-.23.23-.55.37-.88.37-.25 0-.49-.07-.69-.21-.21-.14-.37-.33-.46-.56a1.27 1.27 0 01-.07-.72c.05-.24.17-.47.34-.64.17-.17.4-.29.64-.34.24-.05.49-.02.72.07.23.09.42.25.56.46.14.21.21.45.21.69 0 .33-.13.65-.37.88zm1.82-6.94l-2 2c-.09.09-.2.17-.33.22-.12.05-.25.08-.38.08s-.26-.03-.38-.08-.23-.12-.33-.22l-2-2a.996.996 0 111.41-1.41l.29.29V4.99c0-.55.45-1 1-1s1 .45 1 1v6.59l.29-.29a.996.996 0 111.41 1.41h.02z",
            fill: "currentColor"
        })
    });



const $64039b78aae87393$export$996f81ccf54ff59e = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17.12 2.88C16.56 2.32 15.79 2 15 2H9c-.8 0-1.56.32-2.12.88S6 4.21 6 5v14c0 .8.32 1.56.88 2.12S8.21 22 9 22h6c.8 0 1.56-.32 2.12-.88S18 19.79 18 19V5c0-.8-.32-1.56-.88-2.12zm-4.24 16.75c-.23.23-.55.37-.88.37-.25 0-.49-.07-.69-.21-.21-.14-.37-.33-.46-.56a1.27 1.27 0 01-.07-.72c.05-.24.17-.47.34-.64.17-.17.4-.29.64-.34.24-.05.49-.02.72.07.23.09.42.25.56.46.14.21.21.45.21.69 0 .33-.13.65-.37.88zM14.71 7.7a.996.996 0 01-1.41 0l-.29-.29V14c0 .55-.45 1-1 1s-1-.45-1-1V7.41l-.29.29a.996.996 0 11-1.41-1.41l2-2c.09-.09.2-.17.33-.22.12-.05.25-.08.38-.08s.26.03.38.08.23.12.33.22l2 2c.39.39.39 1.02 0 1.41h-.02z",
            fill: "currentColor"
        })
    });



const $00091ed54bf19ade$export$1fb5df7f311ab070 = (z)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...z,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M22 12c0-1.31-1.18-2.28-2.94-2.93 1.06-2.33.61-3.54 0-4.14-.92-.93-2.44-.77-4.14 0C14.27 3.18 13.31 2 12 2c-1.31 0-2.27 1.18-2.93 2.93-1.7-.77-3.22-.93-4.14 0-.6.6-1 1.81 0 4.14C3.18 9.72 2 10.69 2 12s1.18 2.28 2.94 2.93c-1.06 2.33-.61 3.54 0 4.14a2.3 2.3 0 001.69.64 6.18 6.18 0 002.45-.65C9.72 20.82 10.69 22 12 22c1.31 0 2.28-1.18 2.93-2.94a6.181 6.181 0 002.45.65 2.3 2.3 0 001.69-.64c.6-.6 1.05-1.81 0-4.14C20.82 14.28 22 13.31 22 12zm-4.62-5.73a.41.41 0 01.28.07c.06.06.2.68-.53 2.17-.45-.1-.92-.18-1.39-.25-.07-.47-.15-.93-.25-1.37a4.94 4.94 0 011.89-.62zM14 12v.8c-.2.21-.38.41-.58.61l-.59.58h-1.65l-.59-.58c-.2-.2-.38-.4-.58-.61V12v-.8c.2-.21.38-.41.58-.61.2-.2.4-.39.6-.58h1.62c.2.19.4.37.6.58l.58.61c.01.26.01.52.01.8zm-.36-3.95h.06v.07l-.06-.07zm-3.28 0V8h.06l-.06.05zm-2.31 2.32v-.06h.06l-.06.06zm0 3.26H8v-.06l.05.06zM10.37 16h-.07a.169.169 0 000-.07l.07.07zm3.26 0h-.07.07zM16 13.63v.06-.06zm0-3.26v.06-.06zM12 4c.25 0 .73.65 1.15 1.91-.38.25-.77.52-1.15.8-.38-.28-.77-.55-1.15-.8C11.27 4.65 11.75 4 12 4zM6.34 6.34a.41.41 0 01.28-.07 4.94 4.94 0 011.89.62c-.1.44-.18.9-.25 1.37-.47.07-.94.15-1.39.25C6.14 7 6.28 6.4 6.34 6.34zM4 12c0-.25.65-.73 1.91-1.15.25.38.52.76.81 1.15-.29.39-.56.77-.81 1.15C4.65 12.73 4 12.25 4 12zm2.34 5.66c-.06-.06-.2-.68.53-2.17.45.1.92.18 1.39.25.07.47.15.93.25 1.38-1.19.59-1.99.71-2.17.54zM12 20c-.25 0-.73-.65-1.15-1.92.38-.24.77-.51 1.15-.8.38.29.77.56 1.15.8-.42 1.27-.9 1.92-1.15 1.92zm5.66-2.34c-.18.17-1 .05-2.17-.54.1-.45.18-.91.25-1.38.47-.07.94-.15 1.39-.25.73 1.51.59 2.11.53 2.17zm.43-4.51c-.25-.38-.52-.76-.81-1.15.29-.39.56-.77.81-1.15 1.26.42 1.91.9 1.91 1.15 0 .25-.65.73-1.91 1.15z",
            fill: "currentColor"
        })
    });



const $c40b2f315e0ec0b6$export$d40169537b53b688 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 3H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-3-3zm-8 13a1 1 0 11-2 0V8a1 1 0 01.53-.88 1 1 0 011 0l3 2a1 1 0 01-1.1 1.66L10 9.87V16zm6 0a1 1 0 01-.53.88 1 1 0 01-1-.05l-3-2a1 1 0 111.1-1.66l1.45 1V8a1 1 0 012 0L16 16z",
            fill: "currentColor"
        })
    });



const $377ecec5c3645435$export$5690c71dc4b8398c = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18.12 2.88A3 3 0 0016 2h-5a2.86 2.86 0 00-1.32.29 3 3 0 00-1.06.84l-3 3.7A3 3 0 005 8.7V19a3 3 0 003 3h8a3 3 0 003-3V5a3 3 0 00-.88-2.12zm-3.41 13.41a1.002 1.002 0 01-.325 1.64 1 1 0 01-1.095-.22L12 16.41l-1.29 1.3a1.002 1.002 0 01-1.639-.325 1 1 0 01.219-1.095l1.3-1.29-1.3-1.29a1.004 1.004 0 111.42-1.42l1.29 1.3 1.29-1.3a1.004 1.004 0 111.42 1.42L13.41 15l1.3 1.29z",
            fill: "currentColor"
        })
    });



const $cab771ae87e6ead3$export$46f77c43d6639be7 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10 11H8.24l.87-1.5a1 1 0 00-1.72-1L6.5 10l-.89-1.5a1 1 0 10-1.72 1l.87 1.5H3a1 1 0 100 2h1.76l-.87 1.5a1 1 0 00.36 1.36.9.9 0 00.5.14 1 1 0 00.86-.5L6.5 14l.89 1.51a1 1 0 00.86.5.9.9 0 00.5-.14 1 1 0 00.36-1.36L8.24 13H10a1 1 0 000-2zm11 0h-1.76l.87-1.5a1 1 0 10-1.72-1L17.5 10l-.89-1.5a1 1 0 10-1.72 1l.87 1.5H14a1 1 0 100 2h1.76l-.87 1.5a1 1 0 00.36 1.36.9.9 0 00.5.14 1 1 0 00.86-.5l.89-1.5.89 1.51a1 1 0 00.86.5.9.9 0 00.5-.14 1 1 0 00.36-1.36L19.24 13H21a1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $5db88c845c7b3622$export$dbd92b953944c415 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 2c-1.65 0-3 1.35-3 3 0 .47.12.9.31 1.3l-1.99 1.98s-.02 0-.02.01 0 .01-.01.02l-.98.98a.996.996 0 000 1.41.992.992 0 001.41.01l.3-.29.29.29c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 000-1.41l-.29-.29 1.31-1.3c.39.18.82.29 1.27.29 1.65 0 3-1.35 3-3s-1.35-3-3-3H19zm0 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-8 4V3c0-.35.07-.69.18-1H9C7.34 2 6 3.34 6 5v14c0 1.66 1.34 3 3 3h6c1.66 0 3-1.34 3-3v-6h-4c-1.66 0-3-1.34-3-3zm1 10c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z",
            fill: "currentColor"
        })
    });



const $535bc4fbc2954841$export$8f544f291efadb70 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M11 7.5V2H9C7.34 2 6 3.34 6 5v14c0 1.66 1.34 3 3 3h6c1.66 0 3-1.34 3-3v-5.03c-.17.01-.33.03-.5.03A6.5 6.5 0 0111 7.5zM12 20c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm9.73-16.66c-.17-.18-.4-.3-.65-.33-1.1-.12-2.18-.42-3.17-.91a.99.99 0 00-.41-.1c-.14 0-.28.03-.41.1-.99.49-2.05.8-3.15.91-.25.02-.49.14-.66.32-.17.18-.27.43-.28.68v2.5C13 9.88 16.38 12 17.5 12S22 9.88 22 6.51v-2.5c0-.25-.1-.49-.27-.67z",
            fill: "currentColor"
        })
    });



const $e1fa3f00a89b98fc$export$23e9c3bad7b749db = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.46 4.68a2 2 0 00-1.3-.68 18.78 18.78 0 01-6.34-1.83 1.86 1.86 0 00-1.64 0A18.5 18.5 0 014.88 4 2.06 2.06 0 003 6v5c0 6.74 6.75 11 9 11s9-4.25 9-11V6a2 2 0 00-.54-1.32zm-4.75 6l-4 4a1.002 1.002 0 01-1.42 0l-2-2a1.004 1.004 0 011.42-1.42L11 12.59l3.29-3.3a1.004 1.004 0 011.42 1.42v-.03z",
            fill: "currentColor"
        })
    });



const $21b71f341631ef4e$export$20032360f912cc16 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 14.28V14a3 3 0 00-6 0v.28A2 2 0 0013 16v4a2 2 0 002 2h4a2 2 0 002-2v-4a2 2 0 00-1-1.72zM17 19a1 1 0 110-2 1 1 0 010 2zm-1-5a1 1 0 012 0h-2zm4.46-9.31a2 2 0 00-1.3-.69 18.78 18.78 0 01-6.34-1.83 1.86 1.86 0 00-1.64 0A18.5 18.5 0 014.88 4 2.06 2.06 0 003 6v5c0 5.92 5.21 9.93 8 10.81V15a6 6 0 016-6 5.93 5.93 0 014 1.54V6a2 2 0 00-.54-1.31z",
            fill: "currentColor"
        })
    });



const $feab0c9e3282fe59$export$986b1230bcaa7a32 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.46 4.68a2 2 0 00-1.3-.68 18.78 18.78 0 01-6.34-1.83 1.86 1.86 0 00-1.64 0A18.5 18.5 0 014.88 4 2.06 2.06 0 003 6v5c0 6.74 6.75 11 9 11s9-4.25 9-11V6a2 2 0 00-.54-1.32zM11 6.5a1 1 0 012 0v6a1 1 0 01-2 0v-6zm2.06 11.56a1.5 1.5 0 01-2.45-.49 1.49 1.49 0 01-.08-.86 1.49 1.49 0 011.18-1.18 1.49 1.49 0 01.86.08 1.5 1.5 0 01.49 2.45z",
            fill: "currentColor"
        })
    });



const $53d7e67db0f83653$export$94685f252e2dd998 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 14h-3a1 1 0 01.29-.71 1 1 0 011.21-.15 1 1 0 101-1.73 3 3 0 00-3.62.47 2.999 2.999 0 00-.88 2.38A2 2 0 0013 16v4a2 2 0 002 2h4a2 2 0 002-2v-4a2 2 0 00-2-2zm-2 5a1 1 0 110-2 1 1 0 010 2zm3.46-14.31a2 2 0 00-1.3-.69 18.78 18.78 0 01-6.34-1.83 1.86 1.86 0 00-1.64 0A18.5 18.5 0 014.88 4 2.06 2.06 0 003 6v5c0 5.92 5.21 9.93 8 10.81V15a6 6 0 016-6 5.93 5.93 0 014 1.54V6a2 2 0 00-.54-1.31z",
            fill: "currentColor"
        })
    });



const $b15781be9784ec3a$export$ba0505852dbf512 = (r)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M16.56 15.06c.28-.28.44-.66.44-1.06v-2.5c0-.23-.05-.45-.14-.66-.1-.21-.24-.39-.42-.53l-1.85-1.5c-.27-.21-.6-.31-.93-.31H8.51a1.499 1.499 0 00-1.5 1.5v4a1.499 1.499 0 001.5 1.5h7c.4 0 .78-.16 1.06-.44h-.01z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 4c1.35 0 2.67.35 3.85 1H15a1.014 1.014 0 00-.99 1.2 1.03 1.03 0 00.61.73c.12.05.25.07.38.07h3c.27 0 .52-.11.71-.29A.99.99 0 0019 6V3c0-.27-.11-.52-.29-.71A.99.99 0 0018 2c-.27 0-.52.11-.71.29A.99.99 0 0017 3v.36c-1.52-.88-3.24-1.35-5-1.36-1.75 0-3.48.46-4.99 1.34C5.49 4.22 4.23 5.48 3.35 7A9.973 9.973 0 002 12c0 .27.11.52.29.71.19.19.44.29.71.29.27 0 .52-.11.71-.29A.99.99 0 004 12c0-2.12.84-4.16 2.34-5.66S9.88 4 12 4zm9.71 7.29a1.03 1.03 0 00-.51-.28.964.964 0 00-.58.06c-.18.08-.34.21-.45.37-.11.17-.17.36-.17.56 0 1.39-.37 2.75-1.06 3.95a8.008 8.008 0 01-2.87 2.91 7.91 7.91 0 01-3.94 1.11 7.95 7.95 0 01-3.97-.98H9c.27 0 .52-.11.71-.29a.99.99 0 00.29-.71c0-.27-.11-.52-.29-.71a.99.99 0 00-.71-.29H6c-.27 0-.52.11-.71.29a.99.99 0 00-.29.71v3a1.014 1.014 0 001.2.99 1.03 1.03 0 00.73-.61c.05-.12.07-.25.07-.38v-.36c1.52.88 3.24 1.35 5 1.36 1.76 0 3.48-.46 5-1.34 1.52-.88 2.78-2.14 3.66-3.66a9.963 9.963 0 001.34-5 .986.986 0 00-.29-.71v.01z",
                fill: "currentColor"
            })
        ]
    });



const $6af08eb38ae9869d$export$a7ac381fd84cbdfd = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4 6a1 1 0 00-1 1v10a1 1 0 102 0V7a1 1 0 00-1-1zm16 0a1 1 0 00-1 1v10a1 1 0 002 0V7a1 1 0 00-1-1zm-5-3H9a2 2 0 00-2 2v14a2 2 0 002 2h6a2 2 0 002-2V5a2 2 0 00-2-2zm-3 16a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $3aaf985cbabddd67$export$cb3435f5e3fc1383 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.69 7.31l-4-4A1 1 0 0015 4v16a1 1 0 002 0V6.45l2.27 2.28a1.003 1.003 0 101.42-1.42zM8 11a.93.93 0 00.45-.11 1 1 0 00.44-1.34l-.73-1.47A3 3 0 006 3H4a1 1 0 00-1 1v6a1 1 0 102 0V9h1c.12.01.24.01.36 0l.75 1.49A1 1 0 008 11zM6 7H5V5h1a1 1 0 010 2zm6-4a1 1 0 00-1 1v13.59l-2.29-2.3a1.005 1.005 0 00-1.714.71c0 .266.106.522.294.71l4 4A1 1 0 0012 21a.84.84 0 00.38-.08A1 1 0 0013 20V4a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $d171c2c070a68673$export$6cb3d345e0aff7b2 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M8.16 8.08A3 3 0 006 3H4a1 1 0 00-1 1v6a1 1 0 002 0V9h1c.12.01.24.01.36 0l.75 1.49A1 1 0 008 11a.931.931 0 00.45-.11 1 1 0 00.44-1.34l-.73-1.47zM6 7H5V5h1a1 1 0 110 2zm0 10a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1zM18.71 3.29A1 1 0 0017 4v16a1 1 0 002 0V4a1 1 0 00-.29-.71zM14 7a1 1 0 00-1 1v12a1 1 0 002 0V8a1 1 0 00-1-1zm-4 6a1 1 0 00-1 1v6a1 1 0 002 0v-6a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $fb28c5440751c355$export$4ec2e6be328079b = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15.62 3.12A1 1 0 0015 4v.72l1.55-1.55a1 1 0 00-.93-.05zM13 4a1 1 0 10-2 0v4.76l2-2V4zm-9 7a1 1 0 001-1V9h1c.12.01.24.01.36 0l.75 1.49A1 1 0 008 11a.931.931 0 00.45-.11 1 1 0 00.44-1.34l-.73-1.47A3 3 0 006 3H4a1 1 0 00-1 1v6a1 1 0 001 1zm1-6h1a1 1 0 110 2H5V5zm14.39 1l1.32-1.31a1.004 1.004 0 00-1.42-1.42l-16 16a.999.999 0 000 1.42 1 1 0 001.42 0L8 17.41l3.29 3.3A1.001 1.001 0 0012 21a.842.842 0 00.38-.08A1 1 0 0013 20v-7.59l2-2V20a1 1 0 002 0V8.41l1-1 1.29 1.3a1.004 1.004 0 001.42-1.42L19.39 6zM11 17.59L9.41 16 11 14.41v3.18z",
            fill: "currentColor"
        })
    });



const $2b337a0db3c7c563$export$44b5d6689a196f = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zm1.09 10.11l.83 3.14a1 1 0 01-1 1.25h-1.69a1 1 0 01-1-1.21l.68-3.2a.5.5 0 00-.12-.42l-.09-.08A2.25 2.25 0 019.88 9a.781.781 0 010-.14 2.25 2.25 0 011-1h.14l.14-.06a2.3 2.3 0 01.43-.12h.75a2.28 2.28 0 011.87 2.21 2.25 2.25 0 01-.95 1.83.38.38 0 00-.09.09.49.49 0 00-.08.3z",
            fill: "currentColor"
        })
    });



const $7fd12651f4552be2$export$3da515048369eda0 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.46 4.68a2 2 0 00-1.3-.68 18.78 18.78 0 01-6.34-1.83 1.86 1.86 0 00-1.64 0A18.5 18.5 0 014.88 4 2.06 2.06 0 003 6v5c0 6.74 6.75 11 9 11s9-4.25 9-11V6a2 2 0 00-.54-1.32zm-6.54 10.57a1 1 0 01-1 1.25h-1.69a1 1 0 01-1-1.21l.68-3.2a.5.5 0 00-.12-.42l-.09-.08A2.25 2.25 0 019.88 9a.78.78 0 010-.14 2.25 2.25 0 011-1h.14l.14-.06a2.3 2.3 0 01.43-.12h.75a2.28 2.28 0 011.87 2.21 2.25 2.25 0 01-.95 1.83.38.38 0 00-.09.09.49.49 0 00-.12.45l.87 2.99z",
            fill: "currentColor"
        })
    });



const $f21d2b72bdc4a92f$export$ad189c5a58fbe2f6 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18.12 2.88A3 3 0 0016 2h-5a3 3 0 00-2.38 1.13l-3 3.7A3 3 0 005 8.7V19a3 3 0 003 3h8a3 3 0 003-3V5a3 3 0 00-.88-2.12zM13.5 16a1 1 0 01-2 0v-5l-.88.7a1 1 0 01-1.24-1.57l2.5-2A1 1 0 0113.5 9v7z",
            fill: "currentColor"
        })
    });



const $1d447d409b9f7621$export$f2ffa0fbb9665df5 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18.12 2.88A3 3 0 0016 2h-5a3 3 0 00-2.38 1.13l-3 3.7A3 3 0 005 8.7V19a3 3 0 003 3h8a3 3 0 003-3V5a3 3 0 00-.88-2.12zM14.5 17H10a1 1 0 01-.77-1.63l3.26-4a.82.82 0 00.07-1.19.79.79 0 00-1.12 0 .61.61 0 00-.12.16.769.769 0 00-.1.25.71.71 0 000 .15 1 1 0 01-2 0 2.76 2.76 0 010-.51 2.5 2.5 0 01.32-.89 2.71 2.71 0 01.46-.56 2.807 2.807 0 113.94 4L12.11 15h2.39a1 1 0 110 2z",
            fill: "currentColor"
        })
    });



const $6414bddc46a7108f$export$2815562bbb0d4179 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.71 3.29a.999.999 0 00-1.42 0l-16 16a1 1 0 00.325 1.64 1 1 0 001.095-.22l.53-.54A3 3 0 008 22h8a3 3 0 003-3V6.41l1.71-1.7a.998.998 0 000-1.42zM12 20H8a1 1 0 01-1-1v-.59L8.41 17H12v3zm5-1a1 1 0 01-1 1h-2v-3h3v2zm0-4h-5v-1.59L13.41 12H17v3zM7 12h.76l9.64-9.64A3 3 0 0016 2h-5a2.86 2.86 0 00-1.32.29 3 3 0 00-1.06.84l-3 3.7A3 3 0 005 8.7v6.06l2-2V12z",
            fill: "currentColor"
        })
    });



const $c99d7aa4edd4bc67$export$d727151bf79ab81d = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M8 20a1 1 0 01-1-1v-2h3a7 7 0 019-6.71V5a3 3 0 00-3-3h-5a3 3 0 00-2.38 1.13l-3 3.7A3 3 0 005 8.7V19a3 3 0 003 3h4.11a6.998 6.998 0 01-1.43-2H8zm-1-8h3v3H7v-3zm10 0a5 5 0 100 10 5 5 0 000-10zm1.5 6a1 1 0 01-1 1h-2a1 1 0 010-2h1v-1.5a1 1 0 112 0V18z",
            fill: "currentColor"
        })
    });



const $3ea8b2671697c0b4$export$f118a3e652ecfd00 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M9.6 8.82a1 1 0 00-1.2-1.6 6 6 0 000 9.56A1 1 0 009 17a1 1 0 00.6-1.8 4 4 0 010-6.36v-.02zM4 12a8 8 0 013.56-6.61 1.001 1.001 0 00-1.12-1.66 9.92 9.92 0 000 16.54 1 1 0 001.03.053 1 1 0 00.09-1.713A8 8 0 014 12zm14 0a5.93 5.93 0 00-2.4-4.78 1 1 0 10-1.2 1.6 4.001 4.001 0 010 6.36 1 1 0 001.2 1.6A5.929 5.929 0 0018 12zm-6-2a2 2 0 100 4 2 2 0 000-4zm5.56-6.27a1.001 1.001 0 10-1.12 1.66 7.92 7.92 0 010 13.22 1 1 0 101.12 1.66 9.92 9.92 0 000-16.54z",
            fill: "currentColor"
        })
    });



const $94ddef7a7feed5d0$export$c6f852cab5ba4791 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4.65 15.11A7.88 7.88 0 014 12a8 8 0 013.56-6.61 1.001 1.001 0 10-1.12-1.66 9.89 9.89 0 00-3.29 12.88l1.5-1.5zM6 12a6.16 6.16 0 00.21 1.55L8 11.73a4 4 0 011.6-2.91 1 1 0 10-1.2-1.6A5.93 5.93 0 006 12zm13.71-6.3l1-1a1.004 1.004 0 10-1.42-1.42l-6.78 6.78A2.089 2.089 0 0012 10a2 2 0 00-2 2c.002.172.026.344.07.51l-6.78 6.78a1 1 0 000 1.42.998.998 0 001.42 0l1-1c.24.2.48.38.74.56a1 1 0 00.56.17.998.998 0 00.973-1.191 1 1 0 00-.423-.64 4.45 4.45 0 01-.43-.33l1.42-1.42c.138.08.292.128.45.14a1 1 0 00.8-.4 1 1 0 00.08-1l1.61-1.6c.17.022.34.022.51 0a2 2 0 002-2 2.087 2.087 0 00-.07-.51L15.42 10a3.86 3.86 0 01.58 2 3.93 3.93 0 01-1.6 3.18 1 1 0 001.2 1.6A5.929 5.929 0 0018 12a5.86 5.86 0 00-1.12-3.46l1.41-1.41A7.85 7.85 0 0120 12a8 8 0 01-3.56 6.61 1.001 1.001 0 101.12 1.66A10 10 0 0022 12a9.85 9.85 0 00-2.29-6.3z",
            fill: "currentColor"
        })
    });



const $f514aac8aa505fa1$export$31e6640672b31e6d = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 7a1 1 0 001-1V3a1 1 0 00-2 0v3a1 1 0 001 1zm-3.71.82a1 1 0 00.25-1.39L6.82 4a1 1 0 10-1.64 1.12L6.9 7.57a1 1 0 001.39.25zm10-4.1A1 1 0 0016.9 4l-1.72 2.43a1 1 0 101.64 1.14l1.72-2.45a1 1 0 00-.25-1.4zM16 9H8a2 2 0 00-1.85 1.23 2 2 0 00.44 2.18L9 14.83V19a3 3 0 006 0v-4.17l2.41-2.42a2 2 0 00.44-2.18A2 2 0 0016 9zm-4 7a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $cb0027bf920b9f92$export$dedb66c8c8113b = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17.41 12.41a2 2 0 00.44-2.18A2 2 0 0016 9h-2.76L17 12.79l.41-.38zm-.59-4.84l1.72-2.45a.999.999 0 00-.996-1.628A1 1 0 0016.9 4l-1.72 2.43a1.001 1.001 0 101.64 1.14zm3.89 11.72l-16-16a1.004 1.004 0 00-1.42 1.42l4.35 4.34a2 2 0 00-1 3.36L9 14.83V19a3 3 0 006 0v-2.59l4.29 4.3a1.001 1.001 0 001.639-.325 1 1 0 00-.22-1.095zM12 16a1 1 0 110-2 1 1 0 010 2zm0-9a1 1 0 001-1V3a1 1 0 10-2 0v3a1 1 0 001 1z",
            fill: "currentColor"
        })
    });



const $6a91e31ccb2b758c$export$5bfe30c1f54ea0d6 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M11 4h2c.55 0 1-.45 1-1s-.45-1-1-1h-2c-.55 0-1 .45-1 1s.45 1 1 1zm10 7h-2c-.55 0-1 .45-1 1s.45 1 1 1h2c.55 0 1-.45 1-1s-.45-1-1-1zM6 12c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1s.45 1 1 1h2c.55 0 1-.45 1-1zm.34-4.24a.996.996 0 101.41-1.41L6.34 4.94a.996.996 0 10-1.41 1.41l1.41 1.41zm11.31 8.49a.996.996 0 10-1.41 1.41l1.41 1.41a.996.996 0 101.41-1.41l-1.41-1.41zm-11.31 0l-1.41 1.41a.996.996 0 101.41 1.41l1.41-1.41a.996.996 0 10-1.41-1.41zm11.31-8.49l1.41-1.41a.996.996 0 10-1.41-1.41l-1.41 1.41a.996.996 0 101.41 1.41zM11.99 18c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1s1-.45 1-1v-2c0-.55-.45-1-1-1zM14.5 7.68c-.3-.18-.51-.48-.51-.84v-1a.85.85 0 00-.85-.85H10.8c-.45 0-.81.36-.81.81v1c0 .34-.17.68-.47.85-1.75.99-2.84 3-2.46 5.23.34 1.97 1.89 3.59 3.85 4a5.01 5.01 0 006.08-4.89 5 5 0 00-2.49-4.32v.01z",
            fill: "currentColor"
        })
    });



const $e3838130c7fbc35e$export$f574cadc71dafb78 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M14 8H7a2 2 0 00-2 2v9a2 2 0 002 2h7a2 2 0 002-2v-9a2 2 0 00-2-2zM13 7c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1s-1 .45-1 1v2c0 .55.45 1 1 1zM18 7.41L19.41 6A.996.996 0 1018 4.59L16.59 6a.996.996 0 00.71 1.7c.26 0 .51-.1.71-.29H18zM20 10h-2c-.55 0-1 .45-1 1s.45 1 1 1h2c.55 0 1-.45 1-1s-.45-1-1-1z",
            fill: "currentColor"
        })
    });



const $467957c3fb4a9cd5$export$59207937ef70dd2e = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.46 4.68a2 2 0 00-1.3-.68 18.78 18.78 0 01-6.34-1.83 1.86 1.86 0 00-1.64 0A18.5 18.5 0 014.88 4 2.06 2.06 0 003 6v5c0 6.74 6.75 11 9 11s9-4.25 9-11V6a2 2 0 00-.54-1.32zM14.8 12.6l-3 4a.999.999 0 11-1.6-1.2L12 13h-2a1 1 0 01-.8-1.6l3-4a1 1 0 111.6 1.2L12 11h2a1 1 0 01.8 1.6z",
            fill: "currentColor"
        })
    });



const $7d0358c14dae988e$export$982adb36bbd5fdad = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10 11a1 1 0 00-1 1v8a1 1 0 102 0v-8a1 1 0 00-1-1zm-4 4a1 1 0 00-1 1v4a1 1 0 102 0v-4a1 1 0 00-1-1zM20.88 3.53A1 1 0 0020 3h-4a1 1 0 00-.88.53 1 1 0 00.05 1L17 7.3V20a1 1 0 002 0V7.3l1.83-2.75a1 1 0 00.05-1.02zM14 7a1 1 0 00-1 1v12a1 1 0 002 0V8a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $1472e80a7ce87aff$export$4268c660c1f700eb = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M8.41 14.21a1 1 0 101.2 1.6 4 4 0 014.78 0 1 1 0 001.2-1.6 6 6 0 00-7.18 0zM12 17a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm9.34-8.41a13.94 13.94 0 00-18.68 0A1.002 1.002 0 004 10.08a11.93 11.93 0 0116 0 1 1 0 00.67.25 1 1 0 00.67-1.74zM12 9a10 10 0 00-6.49 2.4 1 1 0 001.3 1.52 8 8 0 0110.38 0 1 1 0 101.3-1.52A10 10 0 0012 9z",
            fill: "currentColor"
        })
    });



const $bd02fef8bdc92eec$export$29c93001094ea913 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.45 10.94a2 2 0 00.15-2.58A12.38 12.38 0 0012 4a12.27 12.27 0 00-9.6 4.37 2 2 0 00.15 2.57l8 8.44A1.998 1.998 0 0012 20a1.998 1.998 0 001.45-.62l.12-.13A4.898 4.898 0 0113 17a5 5 0 015-5c.69.005 1.372.155 2 .44l1.45-1.5zM17 14a1 1 0 00-1 1v2a1 1 0 00-.71 1.71l1 1A.998.998 0 0017 20a.84.84 0 00.38-.08A1 1 0 0018 19v-4a1 1 0 00-1-1zm4.71 1.29l-1-1a1 1 0 00-1.09-.21A1 1 0 0019 15v4a1 1 0 102 0v-2a.998.998 0 00.71-1.71z",
            fill: "currentColor"
        })
    });



const $b4a5050b75014765$export$545b9475e149966f = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.6 8.36A12.38 12.38 0 0012 4a12.27 12.27 0 00-9.6 4.37 2 2 0 00.15 2.57l8 8.44A1.998 1.998 0 0012 20a1.998 1.998 0 001.45-.62l8-8.44a2 2 0 00.15-2.58z",
            fill: "currentColor"
        })
    });



const $f59dac1600a341d8$export$6e9bd4863500a66d = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12.15 17H12a1.5 1.5 0 101.4 2 4 4 0 01-1.25-2zM12 13a6 6 0 00-3.59 1.19 1 1 0 101.2 1.6A4 4 0 0112 15v-2zm.14-2a4.068 4.068 0 01.91-1.7v-.24a9.78 9.78 0 00-7.54 2.34 1 1 0 001.3 1.52A8 8 0 0112 11h.14zm8.86-.72V10a3 3 0 00-6 0v.28A2 2 0 0014 12v4a2 2 0 002 2h4a2 2 0 002-2v-4a2 2 0 00-1-1.72zM18 15a1 1 0 110-2 1 1 0 010 2zm-1-5a1 1 0 112 0h-2zm-1.2-4.47A13.78 13.78 0 0012 5a14 14 0 00-9.34 3.59A1.002 1.002 0 104 10.08 11.94 11.94 0 0112 7c.64.003 1.278.057 1.91.16a5.05 5.05 0 011.89-1.63z",
            fill: "currentColor"
        })
    });



const $c18f223378960ce3$export$98213da826302670 = (o)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                opacity: .2,
                d: "M12 13a6 6 0 00-3.59 1.19 1 1 0 101.2 1.6A4 4 0 0112 15v-2zm0-8a14 14 0 00-9.34 3.59A1.002 1.002 0 104 10.08 11.94 11.94 0 0112 7c.64.003 1.278.057 1.91.16a5.05 5.05 0 011.89-1.63A13.78 13.78 0 0012 5zm.14 6a4.068 4.068 0 01.91-1.7v-.24a9.78 9.78 0 00-7.54 2.34 1 1 0 001.3 1.52A8 8 0 0112 11h.14zm0 6H12a1.5 1.5 0 101.4 2 4 4 0 01-1.25-2h-.01z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M21 10.28V10a3 3 0 00-6 0v.28A2 2 0 0014 12v4a2 2 0 002 2h4a2 2 0 002-2v-4a2 2 0 00-1-1.72zM18 15a1 1 0 110-2 1 1 0 010 2zm-1-5a1 1 0 012 0h-2z",
                fill: "currentColor"
            })
        ]
    });



const $320d4fa14ff75165$export$82bd4dc389bb7b87 = (o)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                opacity: .2,
                d: "M12 13a6 6 0 00-3.59 1.19 1 1 0 101.2 1.6A4 4 0 0112 15v-2zm0-8a14 14 0 00-9.34 3.59A1.002 1.002 0 104 10.08 11.94 11.94 0 0112 7c.64.003 1.278.057 1.91.16a5.05 5.05 0 011.89-1.63A13.78 13.78 0 0012 5zm.14 6a4.068 4.068 0 01.91-1.7v-.24a9.78 9.78 0 00-7.54 2.34 1 1 0 001.3 1.52A8 8 0 0112 11h.14zm0 6H12a1.5 1.5 0 101.4 2 4 4 0 01-1.25-2h-.01z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12.15 17H12a1.501 1.501 0 101.4 2 4 4 0 01-1.25-2zM21 10.28V10a3 3 0 10-6 0v.28A2 2 0 0014 12v4a2 2 0 002 2h4a2 2 0 002-2v-4a2 2 0 00-1-1.72zM18 15a1 1 0 110-1.999A1 1 0 0118 15zm-1-5a1 1 0 012 0h-2z",
                fill: "currentColor"
            })
        ]
    });



const $52951f90a8217499$export$83ae0bfa0b0ce7ef = (o)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                opacity: .2,
                d: "M12 13a6 6 0 00-3.59 1.19 1 1 0 101.2 1.6A4 4 0 0112 15v-2zm0-8a14 14 0 00-9.34 3.59A1.002 1.002 0 104 10.08 11.94 11.94 0 0112 7c.64.003 1.278.057 1.91.16a5.05 5.05 0 011.89-1.63A13.78 13.78 0 0012 5zm.14 6a4.068 4.068 0 01.91-1.7v-.24a9.78 9.78 0 00-7.54 2.34 1 1 0 001.3 1.52A8 8 0 0112 11h.14zm0 6H12a1.5 1.5 0 101.4 2 4 4 0 01-1.25-2h-.01z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M11.99 13a6 6 0 00-3.59 1.19 1 1 0 101.2 1.6 4 4 0 012.39-.79v-2zm.15 4h-.15a1.5 1.5 0 101.4 2 4 4 0 01-1.25-2zm8.85-6.72V10a3 3 0 00-6 0v.28a2 2 0 00-1 1.72v4a2 2 0 002 2h4a2 2 0 002-2v-4a2 2 0 00-1-1.72zm-3 4.72a1 1 0 110-2 1 1 0 010 2zm-1-5a1 1 0 012 0h-2z",
                fill: "currentColor"
            })
        ]
    });



const $b83fa737811b9d20$export$7d456b1eb4d0b5c8 = (o)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                opacity: .2,
                d: "M12 13a6 6 0 00-3.59 1.19 1 1 0 101.2 1.6A4 4 0 0112 15v-2zm0-8a14 14 0 00-9.34 3.59A1.002 1.002 0 104 10.08 11.94 11.94 0 0112 7c.64.003 1.278.057 1.91.16a5.05 5.05 0 011.89-1.63A13.78 13.78 0 0012 5zm.14 6a4.068 4.068 0 01.91-1.7v-.24a9.78 9.78 0 00-7.54 2.34 1 1 0 001.3 1.52A8 8 0 0112 11h.14zm0 6H12a1.5 1.5 0 101.4 2 4 4 0 01-1.25-2h-.01z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12.14 11a4.068 4.068 0 01.91-1.7v-.24a9.78 9.78 0 00-7.54 2.34 1 1 0 001.3 1.52A8 8 0 0112 11h.14zM12 13a6 6 0 00-3.59 1.19 1 1 0 101.2 1.6A4 4 0 0112 15v-2zm9-2.74V10a3 3 0 00-6 0v.28A2 2 0 0014 12v4a2 2 0 002 2h4a2 2 0 002-2v-4a2 2 0 00-1-1.72v-.02zM18 15a1 1 0 110-2 1 1 0 010 2zm-1-5a1 1 0 112 0h-2zm-4.85 7H12a1.5 1.5 0 101.4 2 4 4 0 01-1.25-2z",
                fill: "currentColor"
            })
        ]
    });



const $b7653c3eacaa4669$export$98ae144b390ced11 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.6 8.36A12.38 12.38 0 0012 4a12.27 12.27 0 00-9.6 4.37 2 2 0 00.15 2.57l8 8.44A1.998 1.998 0 0012 20a1.998 1.998 0 001.45-.62l.12-.13A4.898 4.898 0 0113 17a5 5 0 015-5c.69.005 1.372.155 2 .44l1.42-1.5a2 2 0 00.18-2.58zM20 16h-1v-1a1 1 0 00-2 0v1h-1a1 1 0 000 2h1v1a1 1 0 102 0v-1h1a1 1 0 100-2z",
            fill: "currentColor"
        })
    });



const $b3d448d3526736be$export$e89c9edbb090e6e7 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.12 14.88a1 1 0 00-1.41 0l-.71.71-.71-.71a1 1 0 00-1.41 1.41l.71.71-.71.71a1 1 0 001.41 1.41l.71-.71.71.71a1 1 0 001.41-1.41l-.71-.71.71-.71a1 1 0 000-1.41zm1.48-6.52A12.38 12.38 0 0012 4a12.27 12.27 0 00-9.6 4.37 2 2 0 00.15 2.57l8 8.44A1.998 1.998 0 0012 20a1.998 1.998 0 001.45-.62l.12-.13A4.898 4.898 0 0113 17a5 5 0 015-5c.69.005 1.372.155 2 .44l1.42-1.5a2 2 0 00.18-2.58z",
            fill: "currentColor"
        })
    });



const $e2f8de55112740aa$export$b7a1ae3453d75c27 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 20a1 1 0 100 2 1 1 0 000-2zm-.5-6a1 1 0 000 2 .5.5 0 110 1 1 1 0 000 2 2.5 2.5 0 100-5zm4.1-5.64A12.38 12.38 0 0012 4a12.27 12.27 0 00-9.6 4.37 2 2 0 00.15 2.57l8 8.44A1.998 1.998 0 0012 20a1.998 1.998 0 001.45-.62l.12-.13A4.898 4.898 0 0113 17a5 5 0 015-5c.69.005 1.372.155 2 .44l1.42-1.5a2 2 0 00.18-2.58z",
            fill: "currentColor"
        })
    });



const $bda6ef50f09499d0$export$63acd73115474b77 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M5.4 12.81a1 1 0 001.41.11l.12-.1 3.73-3.72a10.06 10.06 0 00-5.15 2.3.999.999 0 00-.11 1.41zM4 10.08A11.94 11.94 0 0112 7h.72l1.81-1.8A14.26 14.26 0 0012 5a14 14 0 00-9.34 3.59A1.002 1.002 0 004 10.08zm17.34-1.49a13.891 13.891 0 00-2.63-1.85L20.49 5a1.055 1.055 0 00-1.148-1.719c-.128.053-.244.13-.342.229L3.51 19A1.052 1.052 0 105 20.49l4.7-4.71a4 4 0 014.73 0 1 1 0 001.2-1.6 5.999 5.999 0 00-3.2-1.16l1.76-1.75a8 8 0 013 1.62 1 1 0 001.3-1.52 9.848 9.848 0 00-2.78-1.67l1.52-1.52c1.008.5 1.94 1.14 2.77 1.9a1 1 0 001.075.163 1 1 0 00.265-1.653zM12 17a1.5 1.5 0 100 2.999 1.5 1.5 0 000-3z",
            fill: "currentColor"
        })
    });



const $baa563710408889e$export$b3c485f779e390eb = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18.29 15.29L17 16.59l-.29-.3a1.004 1.004 0 00-1.42 1.42l1 1a.998.998 0 001.42 0l2-2a1.004 1.004 0 10-1.42-1.42zm3.31-6.93A12.38 12.38 0 0012 4a12.27 12.27 0 00-9.6 4.37 2 2 0 00.15 2.57l8 8.44a2 2 0 002.239.459c.249-.107.474-.263.661-.46l.12-.13A4.9 4.9 0 0113 17a5 5 0 015-5 4.93 4.93 0 012 .44l1.42-1.5a2 2 0 00.18-2.58z",
            fill: "currentColor"
        })
    });



const $97e4567822ca1981$export$bf58bfadc8003a7 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 14a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1zm0 5a1 1 0 100 2 1 1 0 000-2zm3.6-10.64A12.38 12.38 0 0012 4a12.27 12.27 0 00-9.6 4.37 2 2 0 00.15 2.57l8 8.44a2 2 0 002.239.459c.249-.107.474-.263.661-.46l.12-.13A4.9 4.9 0 0113 17a5 5 0 015-5 4.93 4.93 0 012 .44l1.42-1.5a2 2 0 00.18-2.58z",
            fill: "currentColor"
        })
    });



const $47054456a913adf0$export$991600d097a755d8 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            opacity: .2,
            d: "M21.34 8.59a13.94 13.94 0 00-18.68 0A1.002 1.002 0 004 10.08a11.93 11.93 0 0116 0 1 1 0 00.67.25 1 1 0 00.67-1.74zM12 17a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm-3.59-2.79a1 1 0 101.2 1.6 4 4 0 014.78 0 1 1 0 001.2-1.6 6 6 0 00-7.18 0zM12 9a10 10 0 00-6.49 2.4 1 1 0 001.3 1.52 8 8 0 0110.38 0 1 1 0 101.3-1.52A10 10 0 0012 9z",
            fill: "currentColor"
        })
    });



const $e194761d9903ba3e$export$7aec9b30ebc88f67 = (t)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                opacity: .2,
                d: "M21.34 8.59a13.94 13.94 0 00-18.68 0A1.002 1.002 0 004 10.08a11.93 11.93 0 0116 0 1 1 0 00.67.25 1 1 0 00.67-1.74zM12 17a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm-3.59-2.79a1 1 0 101.2 1.6 4 4 0 014.78 0 1 1 0 001.2-1.6 6 6 0 00-7.18 0zM12 9a10 10 0 00-6.49 2.4 1 1 0 001.3 1.52 8 8 0 0110.38 0 1 1 0 101.3-1.52A10 10 0 0012 9z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 20a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
                fill: "currentColor"
            })
        ]
    });



const $a2ca1b219147d651$export$5d80088a3bb1edad = (t)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                opacity: .2,
                d: "M21.34 8.59a13.94 13.94 0 00-18.68 0A1.002 1.002 0 004 10.08a11.93 11.93 0 0116 0 1 1 0 00.67.25 1 1 0 00.67-1.74zM12 17a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm-3.59-2.79a1 1 0 101.2 1.6 4 4 0 014.78 0 1 1 0 001.2-1.6 6 6 0 00-7.18 0zM12 9a10 10 0 00-6.49 2.4 1 1 0 001.3 1.52 8 8 0 0110.38 0 1 1 0 101.3-1.52A10 10 0 0012 9z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M15.58 14.21a6 6 0 00-7.18 0 1 1 0 101.2 1.6 4 4 0 014.78 0 1 1 0 001.2-1.6zM11.99 17a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
                fill: "currentColor"
            })
        ]
    });



const $d14d7473f535002e$export$e5af9e79295a98fd = (o)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                opacity: .2,
                d: "M21.34 8.59a13.94 13.94 0 00-18.68 0A1.002 1.002 0 004 10.08a11.93 11.93 0 0116 0 1 1 0 00.67.25 1 1 0 00.67-1.74zM12 17a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm-3.59-2.79a1 1 0 101.2 1.6 4 4 0 014.78 0 1 1 0 001.2-1.6 6 6 0 00-7.18 0zM12 9a10 10 0 00-6.49 2.4 1 1 0 001.3 1.52 8 8 0 0110.38 0 1 1 0 101.3-1.52A10 10 0 0012 9z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 17a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm-3.59-2.79a1 1 0 101.2 1.6 4 4 0 014.78 0 1 1 0 001.2-1.6 6 6 0 00-7.18 0zm10.08-2.81a10 10 0 00-13 0 1 1 0 001.3 1.52 8 8 0 0110.38 0 1 1 0 001.3-1.52h.02z",
                fill: "currentColor"
            })
        ]
    });



const $79d276ca6d56703b$export$26e36401050318f = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18.24 10.67c2.29 0 2.61-1.82 2.61-4.02 0-2.2-.32-4.02-2.61-4.02s-2.61 1.82-2.61 4.02c0 2.2.32 4.02 2.61 4.02zM17.1 6.59c0-1.22 0-2.59 1.14-2.59s1.14 1.37 1.14 2.59v.13c0 1.21 0 2.59-1.14 2.59S17.1 7.93 17.1 6.72v-.13zM5.92 9.31c-.53 0-.93-.33-1.11-.54-.15-.16-.34-.25-.48-.25-.4 0-.77.45-.77.73 0 .18.11.37.21.47.25.27.85.95 2.15.95 1.6 0 2.62-.97 2.62-2.43 0-.69-.31-1.22-.85-1.61a.12.12 0 01-.05-.09c0-.03.01-.06.05-.09.41-.39.63-.91.63-1.55 0-1.41-.96-2.26-2.4-2.26-.87 0-1.52.32-1.95.77-.16.17-.31.34-.31.58 0 .39.41.69.74.69.23 0 .35-.09.47-.19.35-.32.58-.47 1.05-.47.55 0 .91.35.91.95s-.37.91-.91.91h-.11c-.48 0-.65.3-.65.66 0 .36.17.66.65.66h.11c.71 0 1.13.42 1.13 1.05 0 .63-.42 1.07-1.13 1.07v-.01zM12.12 10.67c1.74 0 2.51-1.22 2.51-2.72 0-1.31-.67-2.47-2.41-2.47-.23 0-.59.07-.87.18-.15.06-.18.1-.26.1-.09 0-.09-.11-.09-.17.07-1.2.5-1.6 1.22-1.6.15 0 .48.03.78.22.21.11.32.17.46.17.37 0 .69-.41.69-.73s-.25-.5-.43-.62a2.72 2.72 0 00-1.44-.41c-2.13 0-2.75 1.21-2.75 4.02 0 2.21.32 4.02 2.61 4.02l-.02.01zm0-3.82c.94 0 1.09.73 1.09 1.22S13 9.3 12.12 9.3c-.88 0-1.09-.75-1.09-1.23s.15-1.22 1.09-1.22zM18.2 12.04a.962.962 0 00-1.17.71.946.946 0 00.71 1.16c1.78.43 2.44.93 2.57 1.12-.18.3-1.83 1.23-5.75 1.56-.53.04-.92.51-.88 1.04.04.5.46.88.96.88h.09c2.26-.19 7.52-.92 7.52-3.51 0-.91-.7-2.17-4.06-2.97l.01.01zm-.29.23s.04-.01.07-.01c.06 0 .11 0 .17.02a.488.488 0 00-.24 0v-.01zM12.89 17.29l-.02-.05c-.03-.06-.07-.12-.11-.18l-.15-.16-1.25-1.25a.952.952 0 00-.68-.28.952.952 0 00-.96.96c0 .1.01.19.04.29-3.8-.28-5.84-1.22-6.07-1.6.14-.19.8-.69 2.57-1.11.25-.06.46-.21.6-.43.13-.22.18-.48.11-.73a.964.964 0 00-.94-.74c-.08 0-.15 0-.23.03-3.35.81-4.06 2.06-4.06 2.97 0 2.22 4.08 3.28 8.07 3.55-.07.13-.1.28-.1.43a.952.952 0 00.96.96c.26 0 .5-.1.68-.28l1.33-1.33c.09-.09.16-.19.21-.31.05-.12.07-.25.07-.37 0-.11-.02-.22-.06-.32l-.02-.05h.01zm-6.86-5.03s.04 0 .07.01c-.08 0-.15-.01-.23 0 .06-.01.11-.02.17-.02l-.01.01z",
            fill: "currentColor"
        })
    });



const $11e76de3bc53f1bd$export$d0446f354ac466ab = (e)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...e,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.34 10.53c-.04-.11-.04-.2-.09-.2-.05 0-.06.08-.09.2l-.39 1.39v.04c0 .03.02.05.05.05h.88s.05-.02.05-.05v-.04l-.39-1.39h-.02z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.51 5.04c-1.17-.04-2.52.28-3.93.9-.36.16-.59.52-.58.91v11.13c0 .17.08.33.23.42.14.09.32.11.48.04 3.96-1.84 6.87.34 7 .44a.501.501 0 00.8-.4V6.53a.49.49 0 00-.22-.41 7.196 7.196 0 00-3.78-1.09v.01zm1.18 8.93c-.21 0-.43-.1-.52-.39l-.13-.43c-.02-.06-.06-.08-.1-.08H6.57s-.08.03-.1.08l-.13.43c-.09.29-.31.39-.52.39-.29 0-.62-.17-.62-.52 0-.07.01-.15.04-.24l1.21-3.54c.19-.55.54-.64.81-.64s.62.09.8.64l1.21 3.54c.03.09.04.17.04.24 0 .33-.3.52-.62.52zM20.42 5.93a9.863 9.863 0 00-3.92-.91 7.28 7.28 0 00-3.77 1.09c-.14.09-.22.24-.22.41v11.93c0 .14.05.27.14.37.09.1.22.16.36.16.11 0 .22-.03.3-.1.13-.09 3.04-2.27 6.99-.43a.504.504 0 00.7-.46V6.85c-.02-.39-.24-.74-.58-.91v-.01zm-2.22 7.99h-2.61c-.46 0-.52-.34-.52-.5 0-.16.06-.32.16-.47l1.68-2.67s.02-.04.02-.06c0-.04-.04-.04-.05-.04h-1.15c-.39 0-.51-.27-.51-.56 0-.29.12-.57.51-.57h2.34c.37 0 .54.27.54.56 0 .12-.03.24-.1.34l-1.78 2.75s-.02.04-.02.05c0 .03.01.05.05.05h1.44c.39 0 .51.27.51.57 0 .3-.12.56-.51.56v-.01z",
                fill: "currentColor"
            })
        ]
    });



const $bb4f5b5df1535879$export$fbe8109b7f24d33c = (s)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 31 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...s,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7.618 15h10.157c2.095 0 3.81-1.35 3.81-3s-1.715-3-3.81-3H7.618c-.698 0-1.27-.45-1.27-1s.572-1 1.27-1h6.348c1.397 0 2.54-.9 2.54-2V4c0-.55-.572-1-1.27-1-.698 0-1.27.45-1.27 1v1H7.618C5.523 5 3.809 6.35 3.809 8s1.714 3 3.809 3h10.157c.699 0 1.27.45 1.27 1s-.571 1-1.27 1H7.618c-2.095 0-3.809 1.35-3.809 3s1.714 3 3.809 3h8.888v1c0 .55.571 1 1.27 1 .698 0 1.269-.45 1.269-1v-1c0-1.1-1.143-2-2.54-2H7.619c-.698 0-1.27-.45-1.27-1s.572-1 1.27-1zm15.236-5c.33 0 .648-.1.901-.29l1.27-1c.495-.39.495-1.02 0-1.41-.495-.39-1.295-.39-1.79 0l-1.27 1c-.495.39-.495 1.02 0 1.41.254.2.572.29.902.29h-.013zm.901 4.29c-.495-.39-1.295-.39-1.79 0-.495.39-.495 1.02 0 1.41l1.27 1c.254.2.571.29.901.29.33 0 .648-.1.902-.29.495-.39.495-1.02 0-1.41l-1.27-1h-.013zM26.663 11h-1.27c-.698 0-1.27.45-1.27 1s.572 1 1.27 1h1.27c.698 0 1.27-.45 1.27-1s-.572-1-1.27-1z",
            fill: "currentColor"
        })
    });



const $f83274ac80073aac$export$808e114401e5aedf = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c.83 0 1.5.67 1.5 1.5S12.83 8 12 8s-1.5-.67-1.5-1.5S11.17 5 12 5zm5.24 4.97l-3.74.94v1.86l2.39 4.79c.25.49.05 1.09-.45 1.34a1.007 1.007 0 01-1.35-.44l-2.11-4.21-2.11 4.21a1.007 1.007 0 01-1.35.44 1.01 1.01 0 01-.45-1.34l2.39-4.79v-1.86l-3.74-.94a1 1 0 01.48-1.94l3.88.97h1.75l3.88-.97a.995.995 0 011.21.73.995.995 0 01-.73 1.21h.05z",
            fill: "currentColor"
        })
    });



const $b34dad647748b0f1$export$79ea55336a453b02 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21 11h-.14a4.1 4.1 0 00-1.13-1.91 4 4 0 00-5.93.52 2.89 2.89 0 00-3.6 0 4 4 0 00-5.93-.52A4.1 4.1 0 003.14 11H3a.999.999 0 00-.71.3.999.999 0 000 1.42A1 1 0 003 13h.14a4 4 0 004.37 3A4 4 0 0011 12a1 1 0 112 0 4 4 0 003.49 4 4 4 0 004.37-3H21a1.001 1.001 0 00.71-.3.999.999 0 000-1.42A1 1 0 0021 11z",
            fill: "currentColor"
        })
    });



const $2d1f0a8c465fb63d$export$e5e2befee55740d8 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M13.84 3l-.49-.45a2 2 0 00-2.7 0l-.49.45C5.63 7.14 3 10.2 3 13.56A5.36 5.36 0 008.4 19a5.16 5.16 0 002.28-.59l-1.07 2.14A1 1 0 0010.5 22h3a1 1 0 00.89-1.45l-1.07-2.14a5.16 5.16 0 002.28.59 5.36 5.36 0 005.4-5.44c0-3.37-2.63-6.43-7.16-10.56z",
            fill: "currentColor"
        })
    });



const $a1932e9067005193$export$226c6949ceccf8f5 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.87 19.5l-2.87-5a1 1 0 00-1.73 0l-1.51 2.61L10.63 10V8.5h3.67a1 1 0 00.89-.5 1 1 0 00-.07-1l-.65-1 .66-1a1 1 0 000-1 1 1 0 00-.88-.53h-3.8A1 1 0 009.63 3a1 1 0 00-1 1v6l-5.5 9.5A1 1 0 004 21h16a1 1 0 00.87-1.5z",
            fill: "currentColor"
        })
    });



const $077b25b159194840$export$4a6d2737e2780f2d = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm7 1H5a1 1 0 000 2h6v5.07a6.32 6.32 0 00-3.8 1.75A8.49 8.49 0 005 21a1 1 0 102 0 6.66 6.66 0 011.61-4.76 4.3 4.3 0 012.5-1.17c.74 3.89 5.31 5.77 5.52 5.86a1 1 0 10.74-1.86S13 17.29 13 14V8h6a1 1 0 100-2z",
            fill: "currentColor"
        })
    });



const $32fbe70abc9cbd00$export$e4d9ca3ec4d54b6f = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M14.62 14.45c-.15-.09-.32-.16-.5-.23-.38-.14-.88-.27-1.37-.41-.49-.13-1-.26-1.39-.37-.2-.05-.36-.11-.48-.15l-.11-.05s-.03-.07-.05-.11c-.04-.12-.1-.28-.15-.48-.11-.39-.24-.9-.37-1.39-.13-.49-.26-.99-.4-1.37-.08-.2-.14-.36-.23-.5a.872.872 0 00-.18-.22.558.558 0 00-.76 0c-.08.07-.13.14-.18.22-.09.15-.16.32-.23.5-.14.38-.27.88-.42 1.37-.13.49-.26 1-.37 1.39-.05.2-.11.36-.15.48l-.05.11-.11.05c-.12.04-.28.1-.48.15-.39.11-.89.24-1.39.37-.49.13-.98.26-1.37.41-.2.08-.36.14-.5.23-.08.04-.14.1-.22.18a.58.58 0 00-.15.38c0 .17.09.31.15.38.07.08.14.13.22.18.15.09.32.16.5.23.38.14.88.27 1.37.41.49.13 1 .26 1.39.37.2.05.36.11.48.15.04.02.08.03.11.05.01.02.03.07.05.11.04.12.1.28.15.48.11.39.24.89.37 1.39.13.49.26.99.42 1.37.08.2.14.36.23.5.04.08.1.14.18.22.08.07.21.15.38.15s.31-.09.38-.15c.08-.07.13-.14.18-.22.09-.15.16-.32.23-.5.14-.38.27-.88.4-1.37.13-.49.26-1 .37-1.39.05-.2.11-.36.15-.48l.05-.11.11-.05c.12-.04.28-.1.48-.15.39-.11.89-.24 1.39-.37.49-.13.98-.26 1.37-.41.2-.08.36-.14.5-.23.08-.04.14-.1.22-.18a.58.58 0 00.15-.38c0-.17-.09-.31-.15-.38a.916.916 0 00-.22-.18zM20.87 7.16c-.06-.07-.12-.11-.18-.15-.12-.08-.25-.12-.39-.18-.29-.11-.65-.21-1.02-.3-.37-.1-.74-.19-1.02-.27-.15-.04-.26-.08-.35-.11l-.04-.02-.02-.04c-.03-.08-.07-.2-.11-.35-.08-.28-.18-.65-.27-1.02-.1-.37-.2-.73-.3-1.02-.06-.15-.1-.27-.18-.39a.597.597 0 00-.15-.18.51.51 0 00-.68 0c-.07.07-.11.12-.15.18-.08.12-.12.25-.18.39-.11.29-.2.65-.3 1.02-.1.37-.19.74-.27 1.02-.04.15-.08.27-.11.35l-.02.04-.04.02c-.08.03-.2.07-.35.11-.28.08-.65.18-1.02.27-.37.1-.73.2-1.02.3-.15.06-.27.1-.39.18-.06.03-.12.08-.18.15a.51.51 0 00-.13.34c0 .16.08.27.13.34.06.07.12.11.18.15.12.08.25.12.39.18.29.11.65.21 1.02.3.37.1.74.19 1.02.27.15.04.26.08.35.11l.04.02.02.04c.03.08.07.2.11.35.08.28.18.65.27 1.02.1.37.2.73.3 1.02.06.15.11.27.18.39.03.06.08.12.15.18.07.06.18.13.34.13.16 0 .27-.08.34-.13.07-.06.11-.12.15-.18.08-.12.12-.25.18-.39.11-.29.2-.65.3-1.02.1-.37.19-.74.27-1.02.04-.15.08-.27.11-.35l.02-.04.04-.02c.08-.03.2-.07.35-.11.28-.08.65-.18 1.02-.27.37-.1.73-.2 1.02-.3.15-.06.27-.1.39-.18.06-.03.12-.08.18-.15A.51.51 0 0021 7.5c0-.16-.08-.27-.13-.34z",
            fill: "currentColor"
        })
    });



const $b5729425eeb359ef$export$2be0221e0d49167d = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.53 4.47a4.51 4.51 0 00-6.36-.3A4 4 0 0013 7.08a6.54 6.54 0 00-2 0 4 4 0 00-1.17-2.91 4.51 4.51 0 00-6.36.3 4.51 4.51 0 00-.3 6.36 4 4 0 002.14 1.09A7.17 7.17 0 005 14a7 7 0 1014 0c0-.705-.105-1.406-.31-2.08a4.001 4.001 0 002.14-1.09 4.51 4.51 0 00-.3-6.36z",
            fill: "currentColor"
        })
    });



const $98c5bcdbc53ceccc$export$93fdc9a86901353b = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.94 3.42c-.7-.61-1.67-.78-2.54-.45L14.68 4.4c-.85-.26-1.75-.41-2.68-.41-.93 0-1.83.14-2.68.41L5.6 2.97c-.87-.33-1.84-.16-2.54.45s-1 1.55-.8 2.45l1.08 4.69c-.22.78-.35 1.6-.35 2.44a9 9 0 0018 0c0-.85-.13-1.67-.35-2.44l1.08-4.69c.21-.9-.1-1.84-.8-2.45h.02zM4.72 7.62l-.51-2.2c-.06-.26.09-.43.16-.49.05-.04.17-.12.32-.12.06 0 .12.01.18.04l2 .77c-.74.52-1.4 1.14-1.96 1.86l-.19.16v-.02zm4.55 4.12c-.11-.52-.66-.91-1.27-.91s-1.15.39-1.27.91a.75.75 0 01-.89.57.75.75 0 01-.57-.89C5.53 10.21 6.68 9.33 8 9.33s2.47.88 2.73 2.09c.09.41-.17.8-.57.89-.05.01-.11.02-.16.02-.34 0-.66-.24-.73-.59zm4.78 5.53l-1.17 2.65c-.34.76-1.42.76-1.75 0l-1.17-2.65c-.2-.46-.04-1 .39-1.26l1.44-.89-.91-1.16c-.31-.4-.02-.96.5-.96h1.25c.51 0 .81.56.5.96l-.91 1.16 1.44.89c.43.26.59.8.39 1.26zm4.11-4.96c-.05.01-.11.02-.16.02-.34 0-.66-.24-.73-.59-.11-.52-.66-.91-1.27-.91s-1.15.39-1.27.91a.75.75 0 01-.89.57.75.75 0 01-.57-.89c.26-1.21 1.41-2.09 2.73-2.09s2.47.88 2.73 2.09c.09.41-.17.8-.57.89zM17.13 5.6l2-.77c.25-.1.44.03.51.09s.22.23.16.49l-.51 2.2-.19-.16a9.348 9.348 0 00-1.96-1.86l-.01.01z",
            fill: "currentColor"
        })
    });



const $81ac951a36476ad2$export$fcd7e1b81cecad5c = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4 11h.4a5 5 0 001.06 1.6l.3.29-.47.46a1 1 0 00-.09 1.27l9.36-9.42a1 1 0 00-1.27.09l-.46.47-.29-.3a5 5 0 00-1.6-1.06v-.2a1.019 1.019 0 10-2-.4L9 4a5 5 0 00-2.74.83l-.53-.54a1.011 1.011 0 00-1.44 1.42l.54.53A5 5 0 004 9h-.2a1.005 1.005 0 00.2 2zm3-3a1 1 0 110 2 1 1 0 010-2zm12.8 5h-.2a5 5 0 00-1.06-1.6l-.3-.29.47-.46A1.005 1.005 0 0018 8.936a1.004 1.004 0 00-.71.294l-.46.47-.59-.59 4.47-4.46A1.005 1.005 0 0020 2.936a1.004 1.004 0 00-.71.294l-16 16a.999.999 0 000 1.42 1 1 0 001.42 0l4.46-4.47.59.59-.47.46a.999.999 0 000 1.42 1 1 0 001.42 0l.46-.47.29.3a5 5 0 001.6 1.06v.2A1 1 0 0013.8 21h.2a1 1 0 001-.8V20a5 5 0 002.74-.83l.53.54a1.002 1.002 0 001.639-.326 1 1 0 00-.219-1.094l-.54-.53A5 5 0 0020 15h.2a1.02 1.02 0 00-.4-2zM14 18a1 1 0 110-2.002A1 1 0 0114 18zm2-4a1 1 0 110-2.002A1 1 0 0116 14z",
            fill: "currentColor"
        })
    });



const $30647e431bd37d41$export$59807052d9d2df23 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15 4H9c-3.87 0-7 3.13-7 7 0 3.53 2.61 6.43 6 6.92V20c0 1.24 1.41 1.94 2.4 1.2l4.27-3.2H15c3.87 0 7-3.13 7-7s-3.13-7-7-7zm-7 6c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1-1-.45-1-1zm6.89 4.74c-.19.17-.43.26-.67.26a.98.98 0 01-.74-.33c-.78-.87-2.18-.87-2.96 0a.997.997 0 11-1.48-1.34C9.8 12.49 10.88 12 12 12c1.12 0 2.2.49 2.96 1.33.37.41.34 1.04-.07 1.41zM15 11c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z",
            fill: "currentColor"
        })
    });



const $7b61c0fe77f6fcd1$export$fa15d0e7685b28d5 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.2 16.4l-8-6a.753.753 0 00-.2-.1v-.48A3 3 0 109 7a1 1 0 002 0 1 1 0 111 1 1 1 0 00-1 1v1.3a.753.753 0 00-.2.1l-8 6A2 2 0 004 20h16a2 2 0 001.2-3.6zM4 18l8-6 8 6H4z",
            fill: "currentColor"
        })
    });



const $939dc67a9645bd2a$export$1b425ab0f2bc3953 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17.87 7.35a6.55 6.55 0 00-4.88.3V7a4.53 4.53 0 00-2.55-3.89 1.07 1.07 0 00-.39-.11 1.09 1.09 0 00-.4 0 .84.84 0 00-.36.19.82.82 0 00-.29.33.87.87 0 00-.1.39.91.91 0 00.06.4 1 1 0 00.21.35 1 1 0 00.34.23c.403.194.748.49 1 .86.268.368.437.798.49 1.25v.65a6.55 6.55 0 00-4.88-.3C4 8.2 3 10.16 3 13.34c0 3 1.08 5.43 3 6.71a5.69 5.69 0 003.2.95 8.062 8.062 0 002.18-.34c.405-.12.835-.12 1.24 0a8.062 8.062 0 002.18.34 5.701 5.701 0 003.2-1c1.9-1.28 3-3.72 3-6.71 0-2.99-1-5.09-3.13-5.94z",
            fill: "currentColor"
        })
    });



const $ee13914c68e60bd2$export$a8d7438d7c499144 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 18h-2v-.5a1.5 1.5 0 00-1.5-1.5H13v-5.14a4 4 0 10-2 0V16H9.5A1.5 1.5 0 008 17.5v.5H6a2 2 0 000 4h12a2 2 0 000-4z",
            fill: "currentColor"
        })
    });



const $2b9d89b2a17e22c5$export$5f77d27f791d82c3 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M3 13.11V19c0 1.43 3 2.62 7 2.92V19a2 2 0 014 0v2.92c4-.3 7-1.49 7-2.92v-5.89C18.83 14.46 15.25 15 12 15s-6.83-.54-9-1.89zm9-.11c5 0 9-1.34 9-3 0-.89-1.16-1.68-3-2.23v-2l1.32-.83a.5.5 0 000-.84l-2.55-1.6a.5.5 0 00-.77.4v4.42A24.658 24.658 0 0012 7V5.75l1.32-.83a.5.5 0 000-.84l-2.55-1.6a.5.5 0 00-.77.42v4.18a18.61 18.61 0 00-4 .69v-2l1.32-.83a.5.5 0 000-.84L4.77 2.48A.5.5 0 004 2.9v5.73A1.78 1.78 0 003 10c0 1.66 4 3 9 3z",
            fill: "currentColor"
        })
    });



const $dad0f9cf1835fe81$export$f712d65b49a2635a = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 2H6a1 1 0 000 2h1v13a5 5 0 1010 0V4h1a1 1 0 100-2zm-5.36 9.23A3.08 3.08 0 0114 13.67a2.68 2.68 0 01-.7 1.82A2 2 0 1110 17a3 3 0 011.36-2.43c.51-.43.64-.58.64-.9 0-.32-.16-.5-.64-.9A3 3 0 0110 10.33a3 3 0 011.36-2.43c.48-.4.64-.56.64-.9a1 1 0 012 0 3.08 3.08 0 01-1.36 2.44c-.48.4-.64.56-.64.89 0 .33.16.5.64.9z",
            fill: "currentColor"
        })
    });



const $f5ae5d56862cecf3$export$66a64b099b2fa7d5 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 3H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-3-3zm-1.4 9.29a1 1 0 01-1.2-1.6A1.5 1.5 0 1013 9.5V17a1 1 0 01-2 0V9.5a1.5 1.5 0 10-2.4 1.19 1 1 0 11-1.2 1.6A3.49 3.49 0 1112 7.06a3.49 3.49 0 114.6 5.23z",
            fill: "currentColor"
        })
    });



const $e71d2ed1fe1031da$export$f9c0b84d37f7699c = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M22 10.07a1.53 1.53 0 00-.48-.76L13.85 2.7a2.79 2.79 0 00-3.7 0L2.53 9.31A1.53 1.53 0 002.08 11c.098.29.283.54.53.72.242.187.535.295.84.31H4v7a3 3 0 003 3h10a3 3 0 003-3V12h.55a1.49 1.49 0 00.84-.31c.247-.18.432-.43.53-.72a1.54 1.54 0 00.08-.9zM12 10a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm2 8h-4a1 1 0 01-1-1 3 3 0 116 0 1 1 0 01-1 1z",
            fill: "currentColor"
        })
    });



const $ff2faa0a0f8162ca$export$747a5545821d28e2 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M22 10.07a1.53 1.53 0 00-.48-.76L13.85 2.7a2.79 2.79 0 00-3.7 0L2.53 9.31A1.53 1.53 0 002.08 11c.098.29.283.54.53.72.242.187.535.295.84.31H4v7a3 3 0 003 3h10a3 3 0 003-3V12h.55a1.49 1.49 0 00.84-.31c.247-.18.432-.43.53-.72a1.54 1.54 0 00.08-.9zM11 7a1 1 0 112 0v6a1 1 0 01-2 0V7zm2.06 11.56a1.5 1.5 0 01-2.45-.49 1.49 1.49 0 01-.08-.86A1.49 1.49 0 0111.71 16a1.49 1.49 0 01.86.08 1.5 1.5 0 01.49 2.45v.03z",
            fill: "currentColor"
        })
    });



const $e2fce21407b27fd6$export$a69a116bfec01fb1 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 9h-1.44v-.33a2.23 2.23 0 00-2.23-2.23h-1.11V4.22a2.22 2.22 0 00-4.44 0v2.22H8.67a2.23 2.23 0 00-2.23 2.23V9H5a1 1 0 000 2h14a1 1 0 000-2zM6.44 19.78A2.23 2.23 0 008.67 22h6.66a2.23 2.23 0 002.23-2.22V13H6.44v6.78z",
            fill: "currentColor"
        })
    });



const $89366ecee8f6583a$export$fc0f67e906d0da2a = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M8.87 6.07c.11-.27.14-.58.09-.87-.06-.29-.2-.56-.41-.77-.21-.21-.48-.35-.77-.41a1.45 1.45 0 00-.87.09c-.27.11-.51.31-.67.55a1.499 1.499 0 001.25 2.33c.3 0 .59-.09.83-.25.25-.16.44-.4.55-.67zm7.53 5.13c.1 0 .2-.04.28-.12l.4-.4c.16-.16.16-.41 0-.57a.387.387 0 00-.56 0l-.4.4c-.16.16-.16.41 0 .57.08.08.18.12.28.12zm.29 1.72a.387.387 0 00-.56 0c-.16.16-.16.41 0 .57l.4.4c.08.08.18.12.28.12.1 0 .2-.04.28-.12.16-.16.16-.41 0-.57l-.4-.4zm.91-1.32h-.4c-.22 0-.4.18-.4.4 0 .22.18.4.4.4h.4c.22 0 .4-.18.4-.4 0-.22-.18-.4-.4-.4zm-1.62-2.68c0-.06 0-.12-.02-.18s-.05-.12-.07-.18c-.03-.06-.05-.11-.09-.16a.8.8 0 00-.13-.13.61.61 0 00-.16-.12c-.02-.01-.03-.03-.05-.04-.04-.02-.09-.02-.13-.03-.04-.01-.08-.04-.12-.05l-5-1a.856.856 0 00-.39 0 .994.994 0 00-.79 1.17c.02.12.07.24.14.35v.02l2.75 4.12-2.62 2.62s-.02.04-.04.06a.99.99 0 00-.11.17c-.03.06-.07.12-.09.18 0 .02-.02.04-.03.06l-1 4A.995.995 0 009 21.02c.45 0 .86-.3.97-.76l.93-3.73 1.81-1.81-.66 1.98s0 .08-.01.11c-.01.07-.02.13-.02.2s.01.14.02.2c0 .04 0 .08.01.11l1 3c.14.42.53.68.95.68.1 0 .21-.02.32-.05.52-.17.81-.74.63-1.26l-.89-2.68.89-2.68v-.06c.02-.07.02-.14.03-.21v-.18c0-.06-.03-.12-.05-.18a.64.64 0 00-.08-.19c-.01-.02-.01-.04-.02-.06l-.54-.8 1.6-3.2s.01-.07.03-.1c.02-.05.05-.1.06-.15v-.07-.21zm-2.96 1.8l-.85-1.27 1.35.27-.5 1z",
            fill: "currentColor"
        })
    });



const $4407ea91bbef142b$export$170c7014b97a34bf = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M5.05 9.15a3 3 0 00.39 5.79 3 3 0 004.64 3.71 3 3 0 002.27 2.28 3 3 0 003.58-2.28L17.62 11l-4.55-4.52-8.02 2.67zm15-5.33a3 3 0 00-4.24.1l-1.2 1.28 4.24 4.24 1.32-1.38a3 3 0 00-.11-4.24h-.01z",
            fill: "currentColor"
        })
    });



const $8841aeb1937b8bb5$export$5aec238a09885e1c = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.68 19.13l-.68-.56a.63.63 0 01-.17-.73 15.43 15.43 0 000-11.68.63.63 0 01.17-.73l.62-.52a1.093 1.093 0 000-1.55A1.14 1.14 0 0019.9 3H4.1a1.1 1.1 0 00-.78 1.87l.68.56a.63.63 0 01.17.73 15.43 15.43 0 000 11.68.63.63 0 01-.17.73l-.62.52a1.09 1.09 0 000 1.55c.188.204.444.331.72.36h15.8a1.1 1.1 0 00.78-1.87zM11 17h-.05A2.713 2.713 0 018 14.5a3.53 3.53 0 010-.5 2.722 2.722 0 013 2.5c.012.166.012.334 0 .5zm0-4h-.05A2.713 2.713 0 018 10.5a3.53 3.53 0 010-.5 2.72 2.72 0 013 2.5c.012.166.012.334 0 .5zm1-2a1.927 1.927 0 01-.33-.31A2.5 2.5 0 0112 7c.12.09.23.19.33.3A2.49 2.49 0 0112 11zm1 6a3.496 3.496 0 010-.46A2.719 2.719 0 0116 14c.01.153.01.307 0 .46A2.71 2.71 0 0113.06 17H13zm0-4a3.496 3.496 0 010-.46A2.719 2.719 0 0116 10c.01.153.01.307 0 .46A2.71 2.71 0 0113.06 13H13z",
            fill: "currentColor"
        })
    });



const $776f9c963920654d$export$1b277416e1639ded = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M3.65 6.49A10 10 0 002.05 11h3.73a7.91 7.91 0 00-2.13-4.51zM2.05 13a10 10 0 001.6 4.51A7.91 7.91 0 005.78 13H2.05zM22 11a9.999 9.999 0 00-1.6-4.51A7.91 7.91 0 0018.22 11H22zm-2.93-6.07A9.93 9.93 0 0013 2.05v9h3.2a10 10 0 012.87-6.12zM4.93 19.07A9.93 9.93 0 0011 22v-9H7.8a10 10 0 01-2.87 6.07zm0-14.14A10 10 0 017.8 11H11V2.05a9.93 9.93 0 00-6.07 2.88zm15.42 12.58A9.998 9.998 0 0022 13h-3.78a7.91 7.91 0 002.13 4.51zM13 13v9a9.93 9.93 0 006.07-2.88A10 10 0 0116.2 13H13z",
            fill: "currentColor"
        })
    });



const $030a3cd5b0f8a0a6$export$35f00fa388022bc0 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12.5 5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm6.5 7.32a1.002 1.002 0 00-.63-1.27l-2-.67a2 2 0 01-1-.79l-1.13-1.7a2.93 2.93 0 00-1.16-1l-1.52-.76a1 1 0 00-.8-.13l-2.84.71a3 3 0 00-2.18 2.21L5 11.76A1 1 0 005.76 13H6a1 1 0 001-.76l.71-2.83a1 1 0 01.73-.73l1.15-.29L6 20.73A1 1 0 006.73 22c.09.015.18.015.27 0a1 1 0 001-.73l2-7.21 1.76.59L10 20.73a1 1 0 00.73 1.27c.09.015.18.015.27 0a1 1 0 001-.73l1.7-6.07a2 2 0 00-1.29-2.45l-1.84-.61 1.06-3.71.45.23a.89.89 0 01.38.34l1.14 1.7a4 4 0 002.06 1.57l2 .68a1 1 0 001.34-.63zM18.5 14a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
            fill: "currentColor"
        })
    });



const $fd11774942e3078a$export$999a4501f7e321ef = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 11h-2a3 3 0 00-3 3v6a1 1 0 001 1h6a1 1 0 001-1v-6a3 3 0 00-3-3zm-8-7a1 1 0 00-.55-.89 1 1 0 00-1 .09l-4 3A1 1 0 004 7v4h6V4zm0 9H4a1 1 0 00-1 1v6a1 1 0 001 1h6a1 1 0 001-1v-6a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $3adbd08bc0b5da60$export$f4f38cbfc6e26320 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M9 4a1 1 0 00-.17-.56 1 1 0 00-.45-.36A1 1 0 007.8 3a1 1 0 00-.51.27l-2 2a1 1 0 00-.22.32c-.05.13-.074.27-.07.41v4h4V4zM4 19a2 2 0 002 2h2a2 2 0 002-2v-7H4v7zm10 0a2 2 0 004 0v-7h-4v7zm6.89-13.44a5.33 5.33 0 00-2.09-2A5.91 5.91 0 0016 3a6 6 0 00-2.81.6 5.35 5.35 0 00-2.1 2 1.1 1.1 0 00-.09.51c.02.175.082.343.18.49l2.56 3.4h4.51l2.55-3.39a1.07 1.07 0 00.2-.52 1 1 0 00-.11-.53z",
            fill: "currentColor"
        })
    });



const $e54eaa410f0f5364$export$fabf94146c6783cf = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21 13V6a3 3 0 00-3-3H6a3 3 0 00-3 3v11.5A3.5 3.5 0 006.5 21H20a1 1 0 000-2h-1v-3.18A3 3 0 0021 13zm-4 6H6.5a1.5 1.5 0 110-3H17v3z",
            fill: "currentColor"
        })
    });



const $3c4a119da61174ea$export$cb95f44b89d3c4d7 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.85 3.47A1 1 0 0020 3h-6C7.21 3 3 7.6 3 15c0 2.81.73 4.33 1.63 5.13A.25.25 0 005 20c.33-6 3.54-10.29 9.57-12.87a1 1 0 11.78 1.84C9.83 11.3 7.09 15.17 7 20.73a.28.28 0 00.27.27C16 20.9 20 15.77 20 11c0-4.59.88-6.51.9-6.56a1 1 0 00-.05-.97z",
            fill: "currentColor"
        })
    });



const $489c0799a7467895$export$6ae8625657ba99a3 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M14 7h-4v2h4V7zm-2-1c.348 0 .682-.137.93-.38a1.3 1.3 0 00.38-.93 1.28 1.28 0 00-.38-.92l-.67-.66a.36.36 0 00-.52 0l-.67.66a1.28 1.28 0 00-.38.92 1.301 1.301 0 00.38.93c.248.243.582.38.93.38zm-4.5 9a2.11 2.11 0 001.58-.75 4 4 0 015.83 0 1.999 1.999 0 003.17 0A4.44 4.44 0 0120 13.12V12a2 2 0 00-2-2H6a2 2 0 00-2 2v1.12a4.5 4.5 0 011.91 1.13A2.12 2.12 0 007.5 15zM20 19v-3.72c-.207.143-.404.3-.59.47a4 4 0 01-5.83 0 2 2 0 00-3.17 0 4 4 0 01-5.83 0 4.303 4.303 0 00-.58-.46V19a1 1 0 000 2h16a1 1 0 100-2z",
            fill: "currentColor"
        })
    });



const $0a25b114880c9803$export$2786353b6b7a99d2 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M14.4 13.44c-.65-.24-1.21-.44-2.41-.44-1.2 0-1.76.2-2.41.44-.72.26-1.54.56-3.09.56-.28 0-.52-.01-.76-.03 1.17 2.16 3.5 3.35 5.26 3.83V20c0 .55.45 1 1 1s1-.45 1-1v-2.2c1.76-.48 4.1-1.66 5.26-3.83-.24.02-.49.03-.77.03-1.55 0-2.37-.3-3.09-.56h.01zM20 3c-.55 0-1 .45-1 1v2c0 .8-.48 1.49-1.16 1.81C16.71 6.62 14.77 6 12 6s-4.72.61-5.84 1.81A2.008 2.008 0 015 6V4c0-.55-.45-1-1-1s-1 .45-1 1v2c0 1.56.9 2.89 2.2 3.55-.12.45-.2.92-.2 1.45 0 .3.02.58.06.86.38.08.82.14 1.43.14 1.2 0 1.76-.2 2.41-.44.72-.26 1.54-.56 3.09-.56 1.55 0 2.37.3 3.09.56.65.24 1.21.44 2.41.44.62 0 1.07-.05 1.44-.14.04-.28.06-.56.06-.86 0-.53-.08-1-.2-1.45 1.3-.66 2.2-2 2.2-3.55V4c0-.55-.45-1-1-1H20z",
            fill: "currentColor"
        })
    });



const $5ea8b105716b89b6$export$2524669270ced198 = (s)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...s,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M14 10H9c-.55 0-1 .45-1 1s.45 1 1 1h5c1.65 0 3-1.35 3-3s-1.35-3-3-3c-.55 0-1 .45-1 1s.45 1 1 1 1 .45 1 1-.45 1-1 1zm3 6H7c-.55 0-1 .45-1 1s.45 1 1 1h10c.55 0 1 .45 1 1s-.45 1-1 1-1 .45-1 1 .45 1 1 1c1.65 0 3-1.35 3-3s-1.35-3-3-3zm2-7c-.55 0-1 .45-1 1s.45 1 1 1 1 .45 1 1-.45 1-1 1H3c-.55 0-1 .45-1 1s.45 1 1 1h16c1.65 0 3-1.35 3-3s-1.35-3-3-3zM2.17 7.95c.19.29.51.45.83.45.19 0 .38-.05.55-.17l.8-.53v.96c0 .55.45 1 1 1s1-.45 1-1V7.7l.8.53c.17.11.36.17.55.17.32 0 .64-.16.83-.45.31-.46.18-1.08-.28-1.39l-1.11-.74 1.11-.74c.46-.31.58-.93.28-1.39-.3-.46-.93-.58-1.39-.28l-.8.53v-.96c0-.55-.45-1-1-1s-1 .45-1 1v.96l-.8-.53a1.001 1.001 0 10-1.11 1.67l1.11.74-1.11.74c-.46.31-.58.93-.28 1.39h.02zM13 19H5c-.55 0-1 .45-1 1s.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1z",
            fill: "currentColor"
        })
    });



const $a767b9b65c2434dd$export$fa422f5133887f87 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17.7 10.4l-4.85-7.92c-.36-.59-1.34-.59-1.71 0L6.29 10.4a8.763 8.763 0 00-1.3 4.6c0 3.86 3.14 7 7 7s7-3.14 7-7c0-1.62-.45-3.21-1.3-4.6h.01zM16 16h-1v1c0 .55-.45 1-1 1s-1-.45-1-1v-1h-1c-.55 0-1-.45-1-1s.45-1 1-1h1v-1c0-.55.45-1 1-1s1 .45 1 1v1h1c.55 0 1 .45 1 1s-.45 1-1 1z",
            fill: "currentColor"
        })
    });



const $09633567d635990f$export$f28ed26449baa7e2 = (v)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...v,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 16c-1.65 0-3 1.35-3 3 0 .55-.45 1-1 1h-1c-.55 0-1-.45-1-1v-1c1.1 0 2-.9 2-2v-.28l1.63-.54a2 2 0 001.37-1.9V4c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v9.28c0 .86.55 1.62 1.37 1.9l1.63.54V16c0 1.1.9 2 2 2v1c0 1.65 1.35 3 3 3h1c1.65 0 3-1.35 3-3 0-.55.45-1 1-1s1 .45 1 1v2c0 .55.45 1 1 1s1-.45 1-1v-2c0-1.65-1.35-3-3-3zm-7-4c-.55 0-1-.45-1-1v-1H8c-.55 0-1-.45-1-1s.45-1 1-1h1V7c0-.55.45-1 1-1s1 .45 1 1v1h1c.55 0 1 .45 1 1s-.45 1-1 1h-1v1c0 .55-.45 1-1 1z",
            fill: "currentColor"
        })
    });



const $d2f6a804e3886fbc$export$d4b0e389aff5791c = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7 9c2.21 0 4-1.34 4-3S9.21 3 7 3 3 4.34 3 6s1.79 3 4 3zm11 8c-1.66 0-3 .9-3 2s1.34 2 3 2 3-.9 3-2-1.34-2-3-2zM16.15 6.15c.58-.58.42-1.68-.35-2.45-.77-.77-1.87-.93-2.45-.35-.58.58-.42 1.68.35 2.45.77.77 1.87.93 2.45.35zm-12.2 6.3C2.38 14.02 2.8 17 4.9 19.1c2.1 2.1 5.08 2.52 6.65.95 1.57-1.57 1.15-4.55-.95-6.65-2.1-2.1-5.08-2.52-6.65-.95zM19.3 13.8c1.88-1.88 2.26-4.54.85-5.95-1.41-1.41-4.07-1.03-5.95.85s-2.26 4.54-.85 5.95c1.41 1.41 4.07 1.03 5.95-.85z",
            fill: "currentColor"
        })
    });



const $ec0afbe93764a438$export$6282bc186e96eea4 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10 22c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-1h-4v1zm7-19H7C5.34 3 4 4.34 4 6v8c0 3.31 2.69 6 6 6h4c3.31 0 6-2.69 6-6V6c0-1.66-1.34-3-3-3zm-4 13h-2c-.55 0-1-.45-1-1s.45-1 1-1h2c.55 0 1 .45 1 1s-.45 1-1 1zm3-6c0 .55-.45 1-1 1H9c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1h6c.55 0 1 .45 1 1v2z",
            fill: "currentColor"
        })
    });



const $d4cc65db03617a05$export$b82fa030efc0a7ec = (s)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...s,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 4h-6c-1.1 0-2 .9-2 2v5c0 1.1.9 2 2 2h2v3.5a2.5 2.5 0 01-5 0V11c0-2.21-1.79-4-4-4s-4 1.79-4 4v.28c-.6.35-1 .98-1 1.72v3c0 1.1.9 2 2 2s2-.9 2-2v-3c0-.74-.4-1.38-1-1.72V11c0-1.1.9-2 2-2s2 .9 2 2v5.5c0 2.48 2.02 4.5 4.5 4.5s4.5-2.02 4.5-4.5V13h2c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-2 5v-.5c0-.55-.45-1-1-1s-1 .45-1 1V9h-2c0-1.65 1.35-3 3-3s3 1.35 3 3h-2z",
            fill: "currentColor"
        })
    });



const $1605d65c6552fb00$export$aa841a4f615fc525 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M11 14.52a5.43 5.43 0 011.62-3.89L14 9.26V5h.5a1.5 1.5 0 000-3h-9a1.5 1.5 0 000 3H6v13a4 4 0 007.78 1.26A5.37 5.37 0 0111 14.52zM8 9V5h4v4H8zm11 3.05l-1.76-1.76a1.002 1.002 0 00-1.42 0L14 12.05A3.481 3.481 0 0014 17a3.51 3.51 0 005 0 3.4 3.4 0 001-2.46 3.46 3.46 0 00-1-2.49z",
            fill: "currentColor"
        })
    });



const $302fbf7c0ed13aa6$export$bd303802550365df = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 13c.55 0 1-.45 1-1s-.45-1-1-1h-1V9h1c.55 0 1-.45 1-1s-.45-1-1-1h-1l-.13.03C17.43 5.3 15.87 4 14 4V3c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1v5c-2.21 0-4 1.79-4 4v3H5c-.55 0-1 .45-1 1s.45 1 1 1h1v1c0 .55-.45 1-1 1s-1 .45-1 1 .45 1 1 1c1.65 0 3-1.35 3-3v-6c0-1.1.9-2 2-2v11c0 .55.45 1 1 1h2c.55 0 1-.45 1-1V6c1.1 0 2 .9 2 2v6c0 1.65 1.35 3 3 3 .55 0 1-.45 1-1s-.45-1-1-1-1-.45-1-1v-1h1z",
            fill: "currentColor"
        })
    });



const $66f3db6da52c6d5b$export$c9fbe21b52922657 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M14 8c.55 0 1 .45 1 1s-.45 1-1 1H9c-.55 0-1 .45-1 1s.45 1 1 1h5c1.65 0 3-1.35 3-3s-1.35-3-3-3c-.55 0-1 .45-1 1s.45 1 1 1zm2 8H6c-.55 0-1 .45-1 1s.45 1 1 1h10c.55 0 1 .45 1 1s-.45 1-1 1-1 .45-1 1 .45 1 1 1c1.65 0 3-1.35 3-3s-1.35-3-3-3zm3-7c-.55 0-1 .45-1 1s.45 1 1 1 1 .45 1 1-.45 1-1 1H3c-.55 0-1 .45-1 1s.45 1 1 1h16c1.65 0 3-1.35 3-3s-1.35-3-3-3zM7.29 5.71c.2.2.45.29.71.29.26 0 .51-.1.71-.29L9 5.42l.29.29c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 000-1.41l-.29-.29.29-.29A.996.996 0 109.3 2.31l-.29.29-.29-.29a.996.996 0 10-1.41 1.41l.29.29-.29.29a.996.996 0 000 1.41h-.02zm-5 4c.2.2.45.29.71.29.26 0 .51-.1.71-.29L4 9.42l.29.29c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 000-1.41l-.29-.29.29-.29A.996.996 0 104.3 6.31l-.29.29-.29-.29a.996.996 0 10-1.41 1.41l.29.29-.29.29a.996.996 0 000 1.41h-.02z",
            fill: "currentColor"
        })
    });



const $12a51acb7b7d8c2a$export$d177927873c16c4b = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M14 8c.55 0 1 .45 1 1s-.45 1-1 1H9c-.55 0-1 .45-1 1s.45 1 1 1h5c1.65 0 3-1.35 3-3s-1.35-3-3-3c-.55 0-1 .45-1 1s.45 1 1 1zm2 8H6c-.55 0-1 .45-1 1s.45 1 1 1h10c.55 0 1 .45 1 1s-.45 1-1 1-1 .45-1 1 .45 1 1 1c1.65 0 3-1.35 3-3s-1.35-3-3-3zm3-7c-.55 0-1 .45-1 1s.45 1 1 1 1 .45 1 1-.45 1-1 1H3c-.55 0-1 .45-1 1s.45 1 1 1h16c1.65 0 3-1.35 3-3s-1.35-3-3-3zM3 10c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1zm.5-3.5C4.33 6.5 5 5.83 5 5s-.67-1.5-1.5-1.5S2 4.17 2 5s.67 1.5 1.5 1.5zM8 8c.83 0 1.5-.67 1.5-1.5S8.83 5 8 5s-1.5.67-1.5 1.5S7.17 8 8 8zm3-3.5c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1z",
            fill: "currentColor"
        })
    });



const $43d9a44a819eb51e$export$235c0ff540e08686 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7.19 20a2 2 0 002 2h5.62a2 2 0 002-2v-1H7.19v1zM18.51 2.65A1.88 1.88 0 0017.09 2H6.91a1.88 1.88 0 00-1.42.65 1.86 1.86 0 00-.44 1.5L7 17h10l2-12.85a1.86 1.86 0 00-.49-1.5z",
            fill: "currentColor"
        })
    });



const $f7d2c4a985f108a6$export$e0561e8e0cd8dbf7 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 4h-1.54c-1.1-1.22-2.69-2-4.46-2s-3.36.78-4.46 2H6C4.34 4 3 5.34 3 7v11c0 1.66 1.34 3 3 3h12c1.66 0 3-1.34 3-3V7c0-1.66-1.34-3-3-3zm-5 7.86V18c0 .55-.45 1-1 1s-1-.45-1-1v-6.14c-1.72-.45-3-2-3-3.86 0-2.21 1.79-4 4-4s4 1.79 4 4c0 1.86-1.28 3.41-3 3.86zM12 6c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1s1-.45 1-1V7c0-.55-.45-1-1-1z",
            fill: "currentColor"
        })
    });



const $279e16fed3bac7ea$export$2a73bcdd74873674 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 2h-4C9.24 2 7 3.24 7 6v4a1 1 0 001 1h7v-1a1 1 0 012 0v1a2 2 0 01-2 2H8a3 3 0 01-3-3V6a3 3 0 00-3 3v4a4 4 0 004 4v2a3 3 0 003 3h6a3 3 0 003-3v-3l2.12-2.12a3 3 0 00.88-2.12V7a5 5 0 00-5-5z",
            fill: "currentColor"
        })
    });



const $b048bd6e893bc514$export$bb7d42377ea17511 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M9 3c-1.1 0-2 .9-2 2-1.45 0-2.66 1.03-2.94 2.39C4.66 7.14 5.31 7 6 7c.96 0 1.85.27 2.61.74.52.32.6 1.04.17 1.47l-.08.08c-.32.32-.8.34-1.19.11a2.969 2.969 0 00-3.11.06c-.21.13-.4.29-.57.47h-.01a3.359 3.359 0 00-.47.69c-.08.15-.15.32-.2.49l-.06.18c-.06.23-.09.46-.09.71 0 1.07.56 2 1.4 2.53-.25.44-.4.93-.4 1.47 0 1.66 1.34 3 3 3 0 1.1.9 2 2 2s2-.9 2-2V5c0-1.1-.9-2-2-2zm10.6 6.47c.25-.44.4-.93.4-1.47 0-1.66-1.34-3-3-3 0-1.1-.9-2-2-2s-2 .9-2 2v8.5c0 1.1.9 2 2 2 .38 0 .74-.11 1.05-.3.39-.24.9-.19 1.22.14a1 1 0 01-.17 1.55 3.906 3.906 0 01-4.11.05V19c0 1.1.9 2 2 2s2-.9 2-2c1.66 0 3-1.34 3-3 0-.15-.02-.29-.04-.44-.01-.09-.03-.17-.05-.25 0-.04-.02-.08-.03-.12-.07-.23-.16-.45-.28-.66a2.969 2.969 0 00-1.81-1.42c-.46-.13-.8-.5-.8-.98 0-.65.62-1.14 1.25-.97 1.05.27 1.96.88 2.62 1.69.08-.27.13-.55.13-.85 0-1.07-.56-2-1.4-2.53h.02z",
            fill: "currentColor"
        })
    });



const $dd0743056e3c692a$export$f903d68c8a008e83 = (s)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...s,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.6 9.47c.25-.44.4-.93.4-1.47 0-1.66-1.34-3-3-3 0-1.1-.9-2-2-2s-2 .9-2 2v8.5c0 1.1.9 2 2 2 .38 0 .74-.11 1.05-.3.39-.24.9-.19 1.22.14a1 1 0 01-.17 1.55 3.906 3.906 0 01-4.11.05V19c0 1.1.9 2 2 2s2-.9 2-2c1.66 0 3-1.34 3-3 0-.15-.02-.29-.04-.44-.01-.09-.03-.17-.05-.25 0-.04-.02-.08-.03-.12-.07-.23-.16-.45-.28-.66a2.969 2.969 0 00-1.81-1.42c-.46-.13-.8-.5-.8-.98 0-.65.62-1.14 1.25-.97 1.05.27 1.96.88 2.62 1.69.08-.27.13-.55.13-.85 0-1.07-.56-2-1.4-2.53h.02zM9 17H8v-1c0-.55-.45-1-1-1s-1 .45-1 1v1H5c-.55 0-1 .45-1 1s.45 1 1 1h1v1c0 .55.45 1 1 1s1-.45 1-1v-1h1c.55 0 1-.45 1-1s-.45-1-1-1zM9 3c-1.1 0-2 .9-2 2-1.45 0-2.66 1.03-2.94 2.39C4.66 7.14 5.31 7 6 7c.96 0 1.85.27 2.61.74.52.32.6 1.04.17 1.47l-.08.08c-.32.32-.8.34-1.19.11a2.969 2.969 0 00-3.11.06c-.21.13-.4.29-.57.47h-.01a3.359 3.359 0 00-.47.69c-.08.15-.15.32-.2.49l-.06.18c-.06.23-.09.46-.09.71 0 .83.35 1.57.89 2.11A4.94 4.94 0 017 13c1.64 0 3.09.8 4 2.03V5c0-1.1-.9-2-2-2z",
            fill: "currentColor"
        })
    });



const $cc757ca174138294$export$fa658b3ae8cf52e1 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M22 12c0-1.31-.85-2.41-2.02-2.82 0-.06.02-.12.02-.18 0-1.66-1.34-3-3-3-.24 0-.48.04-.7.09A2.986 2.986 0 0014 5c-.77 0-1.47.3-2 .78-.53-.48-1.23-.78-2-.78-.93 0-1.75.43-2.3 1.09C7.47 6.04 7.24 6 7 6 5.34 6 4 7.34 4 9c0 .06.01.12.02.18C2.85 9.59 2 10.69 2 12c0 1.66 1.34 3 3 3h4.01c0 1.66 1.33 3 2.99 3h1v2c0 .55.45 1 1 1s1-.45 1-1v-.17c0-1.01.82-1.83 1.83-1.83 1.62 0 3.08-1.22 3.17-2.84 0-.12-.01-.23-.02-.34C21.15 14.41 22 13.31 22 12zm-5.55.11c.29.14.49.42.54.73.05.32-.05.64-.28.87l-2 2c-.2.2-.45.29-.71.29-.26 0-.51-.1-.71-.29a.996.996 0 010-1.41l1.02-1.02-.76-.38a.99.99 0 01-.54-.73c-.05-.32.05-.64.28-.87l2-2a.996.996 0 111.41 1.41l-1.02 1.02.76.38h.01z",
            fill: "currentColor"
        })
    });



const $be195c343d2dc96e$export$a3159966190dee10 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M13 2C8.68 2 5.15 5.45 5.01 9.74L3.1 13.56a.993.993 0 00.45 1.34l1.45.72V17c0 1.1.9 2 2 2h2v1c0 1.1.9 2 2 2h5c1.1 0 2-.9 2-2v-3.76c1.83-1.47 3-3.72 3-6.24 0-4.41-3.59-8-8-8zm5 8c0 .74-.4 1.38-1 1.72V13c0 .55-.45 1-1 1s-1-.45-1-1v-1h-2c-1.1 0-2-.9-2-2H9c-.55 0-1-.45-1-1s.45-1 1-1c0-.81.49-1.51 1.18-1.82C10.49 5.49 11.19 5 12 5c.37 0 .7.11 1 .28.3-.17.63-.28 1-.28.75 0 1.39.42 1.74 1.03.09-.01.17-.03.26-.03 1.1 0 2 .9 2 2 0 .37-.11.7-.28 1 .17.3.28.63.28 1z",
            fill: "currentColor"
        })
    });



const $dc01d66afbafd112$export$21d6119a20f6c357 = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M3 10h10c1.65 0 3-1.35 3-3s-1.35-3-3-3c-.55 0-1 .45-1 1s.45 1 1 1 1 .45 1 1-.45 1-1 1H3c-.55 0-1 .45-1 1s.45 1 1 1zm10 4H3c-.55 0-1 .45-1 1s.45 1 1 1h10c.55 0 1 .45 1 1s-.45 1-1 1-1 .45-1 1 .45 1 1 1c1.65 0 3-1.35 3-3s-1.35-3-3-3zm6-7c-.55 0-1 .45-1 1s.45 1 1 1 1 .45 1 1-.45 1-1 1H3c-.55 0-1 .45-1 1s.45 1 1 1h16c1.65 0 3-1.35 3-3s-1.35-3-3-3z",
            fill: "currentColor"
        })
    });



const $fb9014ae7a6c4b86$export$9190c2f499a13d03 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15.5 15.467a2.267 2.267 0 100-4.534 2.267 2.267 0 000 4.534zM9.833 3h-6.8C2.407 3 1.9 3.507 1.9 4.133v3.4c0 .626.507 1.134 1.133 1.134h6.8c.626 0 1.134-.508 1.134-1.134v-3.4c0-.626-.508-1.133-1.134-1.133zM9.833 10.933h-6.8c-.626 0-1.133.508-1.133 1.134v3.4c0 .626.507 1.133 1.133 1.133h6.8c.626 0 1.134-.507 1.134-1.133v-3.4c0-.626-.508-1.134-1.134-1.134zM21.167 3h-6.8c-.626 0-1.134.507-1.134 1.133v3.4c0 .626.508 1.134 1.134 1.134h6.8c.625 0 1.133-.508 1.133-1.134v-3.4C22.3 3.507 21.792 3 21.167 3zM20.033 20h-6.8c-.623 0-1.133-.51-1.133-1.133 0-.624.51-1.134 1.133-1.134h6.8c.624 0 1.134.51 1.134 1.134 0 .623-.51 1.133-1.134 1.133z",
            fill: "currentColor"
        })
    });



const $b6fd6cd48def125b$export$3d9f923f8294bbf6 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M2.84 12a1 1 0 00-.55 1.7l1 1A1 1 0 004 15h1v1a1 1 0 00.29.71l5 5a1 1 0 001.02.24 1 1 0 00.68-.79l.7-4.23-5.62-5.62-4.23.69zm18.57-9.41a2 2 0 00-2.82 0l-7.3 7.29-.58-.59a1.004 1.004 0 10-1.42 1.42l4 4a1.002 1.002 0 001.64-.326 1.002 1.002 0 00-.22-1.094l-.59-.58 7.29-7.3a2 2 0 000-2.82z",
            fill: "currentColor"
        })
    });



const $c8d57002458f8659$export$b525d53a4e10bc3a = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7.4 7.9a1 1 0 000-1.41l-.7-.71A1.004 1.004 0 105.28 7.2l.72.7a1 1 0 001.41 0H7.4zm-2.9 3.6h-1a1 1 0 000 2h1a1 1 0 000-2zM12 6a1 1 0 001-1V4a1 1 0 00-2 0v1a1 1 0 001 1zm2 13h-4a1 1 0 000 2h4a1 1 0 000-2zm6.5-7.5h-1a1 1 0 000 2h1a1 1 0 000-2zm-1.78-5.72a1 1 0 00-1.42 0l-.7.71a1 1 0 000 1.41 1 1 0 001.4 0l.71-.7a1 1 0 00.01-1.42zM12 7a5.87 5.87 0 00-3.1 10.85 1 1 0 00.53.15h5.14a1 1 0 00.53-.15A5.87 5.87 0 0012 7z",
            fill: "currentColor"
        })
    });



const $68ac6df81e28afe2$export$6fac6fa9ffe308b2 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.42 8.11c.081-.061.158-.128.23-.2A5.85 5.85 0 0021 4a1 1 0 00-1.89-.42A3.38 3.38 0 0116 5H8a3.41 3.41 0 01-3.11-1.45A1 1 0 003.79 3 1 1 0 003 4a5.87 5.87 0 001.31 4c.08.08.17.14.25.21A2.24 2.24 0 003 10.25a.76.76 0 00.75.75h1.5c.256-.001.51-.049.75-.14V14a4.92 4.92 0 013-1h6a4.92 4.92 0 013 1v-3.14c.24.091.494.139.75.14h1.5a.76.76 0 00.75-.75 2.25 2.25 0 00-1.58-2.14zM9 11a1 1 0 110-2.001 1 1 0 010 2zm6 0a1 1 0 110-2.002A1 1 0 0115 11zm0 4H9a3 3 0 000 6h6a3 3 0 000-6z",
            fill: "currentColor"
        })
    });



const $a7817a092998cf3a$export$e312a152bb5ad7a1 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 15a1 1 0 100 2 1 1 0 000-2zm0-4a1 1 0 100 2 1 1 0 000-2zM8.5 6a.48.48 0 00.2 0L12 4.54 15.3 6a.48.48 0 00.2 0 .5.5 0 00.27-.08.48.48 0 00.23-.42v-3a.48.48 0 00-.23-.42.49.49 0 00-.47 0L12 3.46 8.7 2a.51.51 0 00-.48 0 .5.5 0 00-.22.5v3a.5.5 0 00.22.42.57.57 0 00.28.08zM12 7a1 1 0 100 2 1 1 0 000-2zm5-3v10a5 5 0 01-10 0V4a3 3 0 00-3 3v12a3 3 0 003 3h10a3 3 0 003-3V7a3 3 0 00-3-3z",
            fill: "currentColor"
        })
    });



const $27eb9616b9afc678$export$2aad32f03b190bbb = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18.75 8h-.82c-.45-3.66-3.38-5-5.93-5S6.52 4.34 6.07 8h-.82A2.25 2.25 0 003 10.25a.76.76 0 00.75.75h1.5c.3.002.596-.06.87-.18a25.6 25.6 0 00.48 2.61c.06.27.12.53.17.78A5 5 0 0110 13h4a5 5 0 013.23 1.21c.05-.25.11-.51.17-.78.205-.861.365-1.732.48-2.61.274.12.57.182.87.18h1.5a.76.76 0 00.75-.75A2.25 2.25 0 0018.75 8zM9 11a1 1 0 110-2 1 1 0 010 2zm6 0a1 1 0 110-2 1 1 0 010 2zm-1 4h-4a3 3 0 000 6h4a3 3 0 000-6z",
            fill: "currentColor"
        })
    });



const $62d3bec3a5aa6970$export$bdcf586bb60d0359 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M6.16 19.08L8 20l.97 1.93 1.62-1.62-2.83-2.83-1.6 1.6zM9 9c0-.8.31-1.55.88-2.12A3 3 0 0112 6c.77 0 1.54.29 2.12.88.57.57.88 1.32.88 2.12s-.31 1.55-.88 2.12l-.71.71 2.83 2.83.71-.71a7.007 7.007 0 000-9.9 7.007 7.007 0 00-9.9 0 7.007 7.007 0 000 9.9l7.98 7.98L16 20l1.84-.92-7.96-7.96C9.31 10.55 9 9.8 9 9z",
            fill: "currentColor"
        })
    });



const $0fe4b1d825974450$export$1471c534432fd63f = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 12a8 8 0 00-8 8v1a1 1 0 102 0v-1a6 6 0 01.31-1.9h.05a9.05 9.05 0 013.75 3.34A1 1 0 0011 22h2a1 1 0 00.89-.55 9 9 0 013.74-3.33h.06A6 6 0 0118 20v1a1 1 0 002 0v-1a8 8 0 00-8-8zm0 5a27.878 27.878 0 01-4.7-.72 6 6 0 019.4 0A27.878 27.878 0 0112 17zm0-6a4.5 4.5 0 10-4.5-4.5A4.51 4.51 0 0012 11z",
            fill: "currentColor"
        })
    });



const $252a90fcaba7740b$export$c7d83139291afc79 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.77 11.16L19.4 7.05a3 3 0 00-2.84-2H7.41a3 3 0 00-2.85 2.02l-1.34 4.09A2 2 0 002 13v3a2 2 0 001 1.72V19a1 1 0 102 0v-1h14v1a1 1 0 102 0v-1.28A2 2 0 0022 16v-3a2 2 0 00-1.23-1.84zM6.46 7.69a1 1 0 011-.69h9.15a1 1 0 011 .68l1 3.32H5.38l1.08-3.31zm.25 7a1 1 0 01-1.27.12.94.94 0 01-.36-.45A1 1 0 015 13.8a1 1 0 01.8-.8c.195-.038.397-.017.58.06a.94.94 0 01.45.36 1 1 0 01-.12 1.27zm12 0a1 1 0 01-1.27.12.94.94 0 01-.36-.45c-.08-.175-.108-.37-.08-.56a1 1 0 01.8-.8c.195-.038.397-.017.58.06a.94.94 0 01.45.36 1 1 0 01-.12 1.27z",
            fill: "currentColor"
        })
    });



const $8bcf68e5a131a4c9$export$e0550a2b6c00563e = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.5 15h-1.45l1.38-1.63c.41-.49.46-1.18.11-1.71-.24-.37-.62-.61-1.06-.65-.44-.04-.86.1-1.17.41l-.17.17c-.19.2-.19.51 0 .71.2.19.51.19.71 0l.17-.17c.1-.09.23-.13.36-.13.08 0 .22.05.32.2.1.16.09.38-.03.52l-2.08 2.45c-.13.15-.15.36-.07.53.08.17.26.29.45.29h2.53c.28 0 .5-.22.5-.5s-.22-.5-.5-.5V15zm-14-6h1c.55 0 1-.45 1-1s-.45-1-1-1h-1C5.02 7 3 9.02 3 11.5S5.02 16 7.5 16h1c.55 0 1-.45 1-1s-.45-1-1-1h-1a2.5 2.5 0 010-5zM14 7c-2.21 0-4 2.02-4 4.5s1.79 4.5 4 4.5 4-2.02 4-4.5S16.21 7 14 7zm0 7c-1.1 0-2-1.12-2-2.5S12.9 9 14 9s2 1.12 2 2.5-.9 2.5-2 2.5z",
            fill: "currentColor"
        })
    });



const $8d7a49b5adaa0885$export$d9897d032225b9eb = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 7H6V3c0-.55-.45-1-1-1s-1 .45-1 1v11c0 4.42 3.58 8 8 8h5c1.66 0 3-1.34 3-3v-4c0-4.42-3.58-8-8-8zm1-3h2c.55 0 1-.45 1-1s-.45-1-1-1h-2c-2.41 0-4.43 1.72-4.9 4h2.08c.41-1.16 1.51-2 2.82-2z",
            fill: "currentColor"
        })
    });



const $b7b3356c7458474a$export$d3f9cdc848f1b079 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M13 4h2c.55 0 1-.45 1-1s-.45-1-1-1h-2c-2.41 0-4.43 1.72-4.9 4h2.08c.41-1.16 1.51-2 2.82-2zm4.54 12l-1.7 2.55c-.19.28-.5.45-.83.45h-.06a.984.984 0 01-.83-.55l-2.23-4.46-1.04 1.57c-.19.28-.5.45-.83.45h-2c-.55 0-1-.45-1-1s.45-1 1-1h1.46l1.7-2.55c.2-.3.52-.46.89-.44.36.02.67.23.83.55l2.23 4.46 1.04-1.57c.19-.28.5-.45.83-.45h2.93c-.49-3.95-3.85-7-7.93-7H6V3c0-.55-.45-1-1-1s-1 .45-1 1v11c0 4.42 3.58 8 8 8h5c1.66 0 3-1.34 3-3v-3h-2.46z",
            fill: "currentColor"
        })
    });



const $2a4a0cd010007079$export$b6c0847e0d44645d = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M13 4h2c.55 0 1-.45 1-1s-.45-1-1-1h-2c-2.41 0-4.43 1.72-4.9 4h2.08c.41-1.16 1.51-2 2.82-2zm-1 3H8v.54c0 1.66 1.04 3.16 2.6 3.75l1.95.73c2.07.78 3.46 2.78 3.46 4.99 0 .55-.45 1-1 1s-1-.45-1-1c0-1.38-.87-2.63-2.16-3.12l-.84-.31v2.43c0 .55-.45 1-1 1s-1-.45-1-1v-3.28c-1.83-1.06-3-3.04-3-5.19V3c0-.55-.45-1-1-1s-1 .45-1 1v11c0 4.42 3.58 8 8 8h5c1.66 0 3-1.34 3-3v-4c0-4.42-3.58-8-8-8H12z",
            fill: "currentColor"
        })
    });



const $4645711f79a44bd7$export$730ccb4877a8018 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.71 13.29a1.002 1.002 0 00-1.42 0L16.59 16H14a1 1 0 000-2H7.83a2 2 0 00-1.42.59l-3.12 3.12a1 1 0 00-.29.7V21a1 1 0 001 1h.59a1 1 0 00.7-.29l1.42-1.42a1 1 0 01.7-.29h7.18a2 2 0 001.41-.59l4.71-4.7a1.002 1.002 0 000-1.42zm-9.57-1.75l.22.21A.92.92 0 0012 12a.9.9 0 00.63-.25l.23-.21c2.14-2 3.38-3.4 3.38-5A2.53 2.53 0 0013.69 4a2.62 2.62 0 00-1.69.69A2.62 2.62 0 0010.31 4a2.53 2.53 0 00-2.55 2.56c0 1.58 1.24 3.02 3.38 4.98z",
            fill: "currentColor"
        })
    });



const $bf54e08e452c6398$export$70087a8932f9f56c = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M3.29 16.29a1 1 0 000 1.42l2 2A1 1 0 006 20h.16a1 1 0 00.73-.54L7.62 18H9a1 1 0 00.89-.55l.73-1.45H12a1 1 0 00.89-.55l.73-1.45H15a.999.999 0 00.97-.79l-4.8-4.8-7.88 7.88zM21 6.59L18.41 4a2 2 0 00-2.82 0l-1.3 1.29-.29.3L12.59 7 14 8.41l.79.8 1.8 1.79a2 2 0 002.82 0L21 9.41a2 2 0 000-2.82zm-2.29 2.12a.999.999 0 01-1.42 0l-1-1a1.004 1.004 0 111.42-1.42l1 1a.998.998 0 010 1.42z",
            fill: "currentColor"
        })
    });



const $4fde131687b61708$export$a76283f9cc1a5cde = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M8.5 19a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm8.5-7a5 5 0 100 10 5 5 0 000-10zm1.5 6a1 1 0 01-1 1h-2a1 1 0 110-2h1v-1.5a1 1 0 012 0V18zM17 10a6.92 6.92 0 014 1.28l.88-2.65a2 2 0 00-1-2.41A2 2 0 0020 6H6.58l-.41-1.52A2 2 0 004.23 3H3a1 1 0 100 2h1.23l2.83 10.48a2 2 0 00.71 1.09A2 2 0 009 17h1a7 7 0 017-7z",
            fill: "currentColor"
        })
    });



const $f444f1d09d390603$export$2887b265a883aad3 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M14.5 14a.5.5 0 00.5-.5 1.5 1.5 0 00-1.5-1.5h-.13C14.87 10.3 15 9.29 15 9a1 1 0 00-1.82-.57c-.418.5-.936.909-1.52 1.2A2.79 2.79 0 0010 9H8a2.79 2.79 0 00-1.66.63 4.83 4.83 0 01-1.51-1.19A1 1 0 003 9c0 .29.13 1.3 1.63 3H4.5A1.5 1.5 0 003 13.5a.5.5 0 00.5.5h1c.192 0 .382-.037.56-.11.08.54.21 1.073.39 1.59A9.73 9.73 0 016 19a2 2 0 002 2h2a2 2 0 002-2 9.73 9.73 0 01.55-3.52c.18-.517.31-1.05.39-1.59.178.073.368.11.56.11h1zm4.92-5.89A7.2 7.2 0 0021 4v-.1a1.628 1.628 0 000-.19 1.348 1.348 0 00-.07-.18l-.1-.15a1.851 1.851 0 00-.14-.14s0-.05-.07-.07h-.09l-.17-.07h-.22L20 3h-.08a.79.79 0 00-.22 0l-.15.05-.18.13-.12.11-.08.08a11.84 11.84 0 01-1.67 1.94A5.42 5.42 0 0014 4h-4a3.9 3.9 0 00-3.09 1.67 11.59 11.59 0 01-2.08-2.23l-.07-.06a1 1 0 00-.14-.15l-.15-.1-.18-.07L4.1 3h-.38a.64.64 0 00-.19.08h-.09l-.06.06c-.06 0-.1.1-.15.15l-.1.15A1.621 1.621 0 003 3.9V4a6.42 6.42 0 00.43 2.06A3.68 3.68 0 014 6a3 3 0 012.43 1.23v.06A4.41 4.41 0 018 7h2a4.31 4.31 0 011.52.29l.06-.06A3 3 0 0114 6a3 3 0 013 3 4.94 4.94 0 01-.72 2.38A3.48 3.48 0 0117 13.5a2.5 2.5 0 01-2.5 2.5v.1A7.84 7.84 0 0014 19a3.91 3.91 0 01-.56 2H15a3 3 0 003-3 24.002 24.002 0 01.57-5.51c.1-.5.2-1 .28-1.49h1.4a.76.76 0 00.75-.75 2.26 2.26 0 00-1.58-2.14z",
            fill: "currentColor"
        })
    });



const $c875603c54a14b4b$export$2e468f7d507a73a0 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M13 15a1 1 0 100 2 1 1 0 000-2zm0 4a1 1 0 100 2 1 1 0 000-2zm6 0h-3a1 1 0 100 2h3a1 1 0 000-2zm-.25-11h-.09C20.93 6.05 21 4.23 21 4a1 1 0 00-.62-.92 1 1 0 00-1.09.21 12.77 12.77 0 01-2.82 2A5.45 5.45 0 0013 4h-2a5.45 5.45 0 00-3.47 1.28 12.77 12.77 0 01-2.82-2 1 1 0 00-1.09-.21A1 1 0 003 4c0 .23.07 2.05 2.34 4h-.09A2.25 2.25 0 003 10.25a.76.76 0 00.75.75h1.5a2.16 2.16 0 00.88-.18c.08.58.18 1.12.3 1.67A24.54 24.54 0 017 18a3 3 0 003 3v-5a3 3 0 013-3h4.47c0-.18.07-.35.1-.51.12-.55.22-1.09.3-1.67.277.12.577.182.88.18h1.5a.76.76 0 00.75-.75A2.25 2.25 0 0018.75 8zm.25 7h-3a1 1 0 100 2h3a1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $99259f80d5191ff8$export$4ab851a82e1e73c7 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10.54 9.44a1.48 1.48 0 00-.54-.37A1.61 1.61 0 009.27 9a1.5 1.5 0 00-1.1.76l-5 9a1.52 1.52 0 00-.19.75c0 .261.073.517.21.74.13.227.32.414.55.54.225.13.48.2.74.2a1.42 1.42 0 00.73-.19l9-5a1.5 1.5 0 00.76-1.1c.03-.232.01-.467-.06-.69a1.48 1.48 0 00-.37-.58l-4-3.99zm4.94.06a1 1 0 00.38-.07 1 1 0 00.33-.22l2-2a1.004 1.004 0 00-1.42-1.42l-2 2c-.095.094-.17.206-.22.33a.94.94 0 000 .76 1 1 0 00.55.55 1 1 0 00.38.07zm-3.58-.64a1 1 0 00.51.14 1.13 1.13 0 00.5-.13 1 1 0 00.36-.36 4.81 4.81 0 000-5 .998.998 0 00-.27-.29.88.88 0 00-.74-.17 1 1 0 00-.83.736 1 1 0 00.1.754 2.83 2.83 0 010 3 1 1 0 00.36 1.35l.01-.03zM20 5a1 1 0 00.56-.17.94.94 0 00.36-.45A1 1 0 0021 3.8a1 1 0 00-.82-.8 1 1 0 00-.58.06.94.94 0 00-.45.36 1 1 0 00.12 1.27c.194.195.456.306.73.31zm.51 5.71a4.809 4.809 0 00-5 0 .9.9 0 00-.33.25.82.82 0 00-.21.36.942.942 0 000 .41.901.901 0 00.13.39c.068.123.164.23.28.31a1.001 1.001 0 00.79.17 1 1 0 00.38-.17 2.83 2.83 0 013 0 1 1 0 001.12-.07.93.93 0 00.35-.53 1 1 0 00-.45-1.12h-.06zM18 14a1 1 0 00-.56.17.94.94 0 00-.36.45 1.001 1.001 0 00-.06.58 1 1 0 00.79.78.93.93 0 00.57-.06.94.94 0 00.45-.36A1 1 0 0018 14zM9 7a1 1 0 00.56-.17.94.94 0 00.36-.45A1 1 0 0010 5.8a1 1 0 00-.82-.8 1 1 0 00-.58.06.94.94 0 00-.45.36 1 1 0 00.12 1.27c.194.195.456.306.73.31z",
            fill: "currentColor"
        })
    });



const $8f87144ae90080d3$export$167668224d9eada2 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12.99 8.99H11c-.55 0-1 .42-1 .93v12.07h4V9.93c0-.52-.45-.94-1.01-.94zM18.98 11.99h-1.96c-.56 0-1.02.42-1.02.93v9.07h4v-9.07c0-.51-.46-.93-1.02-.93zM6.99 15.99H5.01c-.56 0-1.01.39-1.01.86v5.14h4v-5.14c0-.48-.45-.86-1.01-.86zM14.21 3.56l-1.06-.11c-.11 0-.22-.08-.27-.19l-.44-.98a.474.474 0 00-.87 0l-.44.98c-.05.11-.14.19-.27.19l-1.06.11c-.41.05-.57.54-.27.82l.79.71c.08.08.14.19.11.3l-.22 1.03c-.08.41.35.71.71.52l.93-.52c.11-.05.22-.05.33 0l.93.52c.35.19.79-.11.71-.52l-.22-1.03c-.03-.11.03-.22.11-.3l.79-.71c.3-.27.14-.79-.27-.82h-.02z",
            fill: "currentColor"
        })
    });



const $bedc22fdb32ef78a$export$20173823fb6c8122 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18.96 12c2.26-2.09 3.59-4.37 2.83-6.18-.21-.5-.68-1.17-1.74-1.54-2.21-.78-6.06.07-10.05 2.22-.1.05-.2.11-.3.17-2.32-.72-4.37-.88-5.76-.39-1.06.37-1.53 1.04-1.74 1.54-.52 1.24-.05 2.7 1.02 4.18-1.07 1.47-1.54 2.94-1.02 4.18.21.5.68 1.17 1.74 1.54.54.19 1.18.28 1.9.28 1.13 0 2.44-.23 3.86-.68.1.06.2.11.3.17 3.01 1.62 5.94 2.51 8.15 2.51.72 0 1.36-.09 1.9-.28 1.06-.37 1.53-1.04 1.74-1.54.76-1.81-.57-4.09-2.83-6.18zm-.78-6c.49 0 .9.06 1.21.17.45.16.53.36.56.43.3.72-.58 2.34-2.54 4.1a26.43 26.43 0 00-5.2-3.06c2.46-1.15 4.56-1.63 5.97-1.63V6zM4.05 8.6c.03-.07.11-.27.56-.43.31-.11.71-.17 1.21-.17.44 0 .95.05 1.52.15-1.02.72-1.96 1.49-2.75 2.28-.51-.79-.7-1.45-.54-1.83zm.56 7.23c-.45-.16-.53-.36-.56-.43-.16-.39.03-1.04.54-1.83.79.79 1.73 1.56 2.74 2.27-1.19.21-2.14.19-2.72-.01zm5.3-.69C8.2 14.11 6.84 13.01 5.86 12c.98-1.01 2.34-2.11 4.06-3.14.97.35 2.01.81 3.12 1.41 1.03.56 1.95 1.14 2.76 1.73-.81.59-1.73 1.18-2.76 1.73-1.11.6-2.16 1.05-3.13 1.4v.01zm10.03 2.26c-.03.07-.11.27-.56.43-1.18.42-3.85.09-7.17-1.47a26.43 26.43 0 005.2-3.06c1.95 1.77 2.84 3.38 2.54 4.1h-.01z",
            fill: "currentColor"
        })
    });



const $64d173f14d2b83c5$export$aa5902c1842e2da8 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7.21 10.79a1.004 1.004 0 10-1.42 1.42L7 13.37a.77.77 0 11-1.09 1.09l-1.32-1.29A2 2 0 014 11.76V7.53a1 1 0 00-2 0v4.23a4 4 0 001.17 2.83l2.54 2.53a.999.999 0 01.29.71V19a1 1 0 001 1h3a1 1 0 001-1v-3.17a3 3 0 00-.88-2.12l-2.91-2.92zm9-4.23A2.528 2.528 0 0013.69 4a2.62 2.62 0 00-1.69.69A2.62 2.62 0 0010.31 4a2.53 2.53 0 00-2.55 2.56c0 1.58 1.24 3 3.38 5l.22.21A.92.92 0 0012 12a.9.9 0 00.63-.25l.23-.21c2.14-1.96 3.38-3.4 3.38-4.98h-.03zm4.76 0a1 1 0 00-1 1v4.23a2 2 0 01-.59 1.41l-1.28 1.29a.785.785 0 01-1.1-1.12l1.17-1.16a1.004 1.004 0 10-1.42-1.42l-2.91 2.92a3 3 0 00-.84 2.12V19a1 1 0 001 1h3a1 1 0 001-1v-1.17a1 1 0 01.29-.71l2.54-2.53A4 4 0 0022 11.76V7.53a1 1 0 00-1-1l-.03.03z",
            fill: "currentColor"
        })
    });



const $24b385130c66734e$export$13a6f1ea5caadecf = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.64 17.25L16 9.21V5h1a1 1 0 100-2H7a1 1 0 000 2h1v4.21l-4.64 8a2.44 2.44 0 000 2.5A2.47 2.47 0 005.52 21h13a2.471 2.471 0 002.484-2.506 2.44 2.44 0 00-.364-1.244zM12.5 16a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm3 2.5a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $d4ead4078030d310$export$3e92e69ba5235b48 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16.73 11a4.39 4.39 0 00-1.27.21L12.38 5h1.9a1 1 0 100-2h-7a1 1 0 000 2H9.4L7 12.5a4.25 4.25 0 102 .35l2-6.19 2.76 5.58a4.26 4.26 0 103-1.23l-.03-.01z",
            fill: "currentColor"
        })
    });



const $b5353737edb939f0$export$db492086fd60c0d4 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 5h-3V4c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v1H6C3.79 5 2 6.79 2 9v1c0 .55.45 1 1 1h3v8c0 .55.45 1 1 1h10c.55 0 1-.45 1-1v-8h3c.55 0 1-.45 1-1V9c0-2.21-1.79-4-4-4zm-2.55 6.11c.29.14.49.42.54.73.05.32-.05.64-.28.87l-2 2c-.2.2-.45.29-.71.29-.26 0-.51-.1-.71-.29a.996.996 0 010-1.41l1.02-1.02-.76-.38a.99.99 0 01-.54-.73c-.05-.32.05-.64.28-.87l2-2a.996.996 0 111.41 1.41l-1.02 1.02.76.38h.01z",
            fill: "currentColor"
        })
    });



const $b43195369d1cc3aa$export$4421e913464c116a = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 3H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-3-3zm-3 4a2 2 0 110 4 2 2 0 010-4zM7 8a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1H8a1 1 0 01-1-1V8zm4.14 7.39l-.75 1.25a.752.752 0 01-.64.36h-1.5a.75.75 0 01-.64-.36l-.75-1.25a.73.73 0 010-.78l.75-1.25a.75.75 0 01.64-.36h1.5a.75.75 0 01.64.36l.75 1.25a.73.73 0 010 .78zM17 16.63a.74.74 0 01-.64.37h-2.74a.74.74 0 01-.64-1.11l1.37-2.5a.79.79 0 011.32 0l1.33 2.5a.73.73 0 010 .74z",
            fill: "currentColor"
        })
    });



const $ddfc22e4b1ed08dd$export$9574db7a705f07ca = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21 4h-3.67c-1.07 0-2.14.35-3 1l-.53.4c-1.06.8-2.54.79-3.6 0L9.67 5c-.86-.64-1.93-1-3-1H3c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h3.67c1.07 0 2.14-.35 3-1l.53-.4a3.03 3.03 0 013.6 0l.53.4c.86.64 1.93 1 3 1H21c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zM5 12c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm3 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm3-4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm8 2c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z",
            fill: "currentColor"
        })
    });



const $1378f3a382be97c0$export$9dc5f928acdbc111 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12.45 5a5 5 0 011.26.3l-.6 1.22a1 1 0 00.44 1.34A.93.93 0 0014 8a1 1 0 00.89-.55l.23-.45H17a2 2 0 002-2.34A2.07 2.07 0 0016.89 3H12.5a.5.5 0 00-.5.5v1a.51.51 0 00.45.5zM20 12h-2l-1-3.3a1 1 0 00-1.9 0L14 12h-2v-1a2 2 0 00-2-2H8a2 2 0 00-2 2v1H4a1 1 0 000 2h.13l.76 5.28a2 2 0 002 1.72h10.24a2 2 0 002-1.72l.74-5.28H20a1 1 0 100-2zm-9-6a1 1 0 00-1-1H8a1 1 0 00-1 1v1h4V6z",
            fill: "currentColor"
        })
    });



const $f6a511aa055b8eca$export$fa3f04dee4590f07 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12.45 5a5 5 0 011.26.3l-.6 1.22a1 1 0 00.44 1.34A.93.93 0 0014 8a1 1 0 00.89-.55l.23-.45H17a2 2 0 002-2.34A2.07 2.07 0 0016.89 3H12.5a.5.5 0 00-.5.5v1a.51.51 0 00.45.5zM11 6a1 1 0 00-1-1H8a1 1 0 00-1 1v1h4V6zm0 11h-1v-1a1 1 0 10-2 0v1H7a1 1 0 000 2h1v1a1 1 0 102 0v-1h1a1 1 0 100-2zm9-5h-2l-1-3.3a1 1 0 00-1.9 0L14 12h-2v-1a2 2 0 00-2-2H8a2 2 0 00-2 2v1H4a1 1 0 000 2h.13l.29 2A5 5 0 1113 21h4.15a2 2 0 002-1.72l.72-5.28H20a1 1 0 100-2z",
            fill: "currentColor"
        })
    });



const $3d31e8da524b393a$export$8061a8fc83b2e9f0 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 11a4.5 4.5 0 10-4.5-4.5A4.51 4.51 0 0012 11zm2.47 1.39l-1.9 1.41a1 1 0 01-1.2 0l-1.88-1.39A8 8 0 004 20a2 2 0 002 2h12a2 2 0 002-2 8 8 0 00-5.53-7.61zM16 20a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $8f98457a79f979e1$export$13fcae1f6d78aa5a = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M13.5 5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm4.5 5h-2a1 1 0 01-.8-.4l-2.4-3.2a1 1 0 00-1-.38 1 1 0 00-.78.69L8.25 16a2.79 2.79 0 01-.48.94L5.2 20.4a1 1 0 001.6 1.2l2.57-3.43a4.89 4.89 0 00.79-1.56l.74-2.47 1.51 1a1.998 1.998 0 01.85 1.28L14 20.2a1 1 0 001 .8h.2a1 1 0 00.8-1.2l-.78-3.8a3.93 3.93 0 00-1.7-2.54l-2-1.31h-.05l.89-3 1.24 1.65A3 3 0 0016 12h2a1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $50c3b38b694e88c6$export$1749b307004ab18a = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.9 11.5a5.002 5.002 0 00-4.9-6c-1.67 0-3.15.83-4.06 2.1-.31-.06-.62-.1-.94-.1-2.61 0-4.72 2-4.95 4.55A3.487 3.487 0 002 15.5C2 17.43 3.57 19 5.5 19H18c2.21 0 4-1.79 4-4 0-1.52-.86-2.82-2.1-3.5z",
            fill: "currentColor"
        })
    });



const $51f659b2c29bdc1b$export$c683b37e85d32ae7 = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7.26 15.9a5.028 5.028 0 014.27-3.38A5.99 5.99 0 0116 10.5c2.37 0 4.48 1.42 5.44 3.51.35-.59.56-1.27.56-2.01 0-1.52-.86-2.82-2.1-3.5a5.002 5.002 0 00-4.9-6c-1.67 0-3.15.83-4.06 2.1-.31-.06-.62-.1-.94-.1-2.61 0-4.72 2-4.95 4.55A3.487 3.487 0 002 12.5C2 14.43 3.57 16 5.5 16h1.58c.06-.03.12-.07.18-.1zm12.64-.24a4.001 4.001 0 00-3.91-3.15c-1.5 0-2.79.83-3.47 2.05a2.996 2.996 0 00-3.53 2.95c-1.1 0-2 .9-2 2s.9 2 2 2h10a2.996 2.996 0 00.91-5.85z",
            fill: "currentColor"
        })
    });



const $5716183f2e07e20d$export$4461fa71518668cb = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 5.5a2.5 2.5 0 00-5 0v8.39c-.94.75-1.5 1.9-1.5 3.11 0 2.21 1.79 4 4 4s4-1.79 4-4c0-1.21-.56-2.35-1.5-3.11V5.5zM7.5 17c0-.71.38-1.35 1-1.72l.5-.29V5.5c0-.28.22-.5.5-.5s.5.22.5.5v9.49l.5.29c.63.37 1 1.01 1 1.72h-4zM20 9h-1.09l.79-.79a.996.996 0 10-1.41-1.41l-2.21 2.21h-1.09V7.92l2.21-2.21a.996.996 0 10-1.41-1.41l-.79.79V4c0-.55-.45-1-1-1s-1 .45-1 1v8.5c0 .13.03.26.08.38s.12.23.22.33l2.5 2.5c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 000-1.41l-2.21-2.21V11h1.09l2.21 2.21c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 000-1.41l-.79-.79h1.09c.55 0 1-.45 1-1s-.45-1-1-1L20 9z",
            fill: "currentColor"
        })
    });



const $bf931deed0aab186$export$55a94c4a36699e33 = (s)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...s,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15 3c-2.21 0-4 1.79-4 4v1c-1.1 0-2-.9-2-2V4c0-.55-.45-1-1-1s-1 .45-1 1v2c0 2.21 1.79 4 4 4v6c0 .55-.45 1-1 1s-1-.45-1-1c0-1.65-1.35-3-3-3s-3 1.35-3 3v4c0 .55.45 1 1 1s1-.45 1-1v-4c0-.55.45-1 1-1s1 .45 1 1v1c0 1.65 1.35 3 3 3h3c4.42 0 8-3.58 8-8V9c0-3.31-2.69-6-6-6zm-2 9c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1-1-.45-1-1zm2 5c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm3-3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z",
            fill: "currentColor"
        })
    });



const $f418687956ff9adb$export$f257b7544945d89e = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 3.41A14.62 14.62 0 0012 2a17 17 0 00-6.82 1.14A2 2 0 004 5v9a8 8 0 1016 0V5.15a2 2 0 00-1-1.74zM6.2 8.4a2.87 2.87 0 014.6 0 1 1 0 01-1.6 1.2.91.91 0 00-1.4 0 1 1 0 11-1.6-1.2zM12 19a5 5 0 01-5-5 1 1 0 011-1h8a1 1 0 011 1 5 5 0 01-5 5zm5.6-9.2a1 1 0 01-1.4-.2.91.91 0 00-1.4 0 1 1 0 01-1.6-1.2 2.88 2.88 0 014.6 0 1 1 0 01-.2 1.4z",
            fill: "currentColor"
        })
    });



const $9747a93b728ae95f$export$437c0b5f8ccc99e = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 3H6a3 3 0 00-3 3v9a3 3 0 003 3v2a1 1 0 00.54.89c.143.07.3.108.46.11a1 1 0 00.58-.19L11.52 18H18a3 3 0 003-3V6a3 3 0 00-3-3zm-7 8a3 3 0 01-3 3 1 1 0 010-2 1 1 0 001-1 2.007 2.007 0 01.34-4A2.08 2.08 0 0111 9.11V11zm6 0a3 3 0 01-3 3 1 1 0 010-2 1 1 0 001-1 2.007 2.007 0 01.34-4A2.08 2.08 0 0117 9.11V11z",
            fill: "currentColor"
        })
    });



const $03ea0b00d9ddd7c1$export$3a250b7ba774f3b = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M14.466 7.047H9.519A2.473 2.473 0 007.046 9.52v4.947a2.473 2.473 0 002.473 2.474h4.947a2.473 2.473 0 002.473-2.474V9.52a2.473 2.473 0 00-2.473-2.473zM21.7 2.286a.612.612 0 00-.877 0l-2.66 2.659v-.977a.612.612 0 00-.618-.619.612.612 0 00-.618.619V6.44c0 .346.272.618.618.618h2.474a.612.612 0 00.618-.618.612.612 0 00-.618-.618h-.977l2.659-2.66a.612.612 0 000-.877zM6.427 16.94H3.954a.612.612 0 00-.619.62c0 .346.272.617.619.617h.977l-2.647 2.66a.612.612 0 000 .878.621.621 0 00.433.185.6.6 0 00.433-.185l2.659-2.66v.978c0 .346.272.618.618.618a.612.612 0 00.619-.618v-2.474a.612.612 0 00-.619-.618z",
            fill: "currentColor"
        })
    });



const $8c41eab03ba42d4c$export$ba8e5dc1de2db5e1 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M8.08 9.19c0-.65-.45-1.19-1-1.19s-1 .53-1 1.19v4.75h2V9.19zm-2 5.76v.63c0 2.45 1.76 4.43 3.94 4.43h1.69c.31 0 .56-.28.56-.63v-.63h.56c1.24 0 2.25-1.13 2.25-2.53v-1.26h-9v-.01zm11.6-2.65a.773.773 0 00-.6-.29h-3.6l1.45-3.63a.994.994 0 00-.56-1.3.994.994 0 00-1.3.56l-2 5a.994.994 0 00.93 1.37h4.08v5.12c0 .48.43.88.96.88s.96-.39.96-.88v-6.19c0-.26-.13-.49-.33-.65l.01.01zm-1.17-5.29c.3 0 .59-.09.83-.25.25-.16.44-.4.55-.67.11-.27.14-.58.09-.87-.06-.29-.2-.56-.41-.77-.21-.21-.48-.35-.77-.41a1.45 1.45 0 00-.87.09c-.27.11-.51.31-.67.55a1.499 1.499 0 001.25 2.33z",
            fill: "currentColor"
        })
    });



const $16cf6979ece1accf$export$1199d625757db308 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 20H7a1 1 0 100 2h10a1 1 0 000-2zm0-15h-.4a5 5 0 00-9.2 0H7a5 5 0 00-1 9.9V17a1 1 0 001 1h10a1 1 0 001-1v-2.1A5 5 0 0017 5z",
            fill: "currentColor"
        })
    });



const $6a18689e61bc4c67$export$11988a852133c75f = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.29 15.63l-1.37-.79.4-.11a1.001 1.001 0 00-.123-1.969 1 1 0 00-.397.039l-2.33.63L14 12l2.47-1.43 2.33.63h.26a1.008 1.008 0 10.26-2l-.4-.11 1.37-.79a1.004 1.004 0 00-1-1.74l-1.37.8L18 7a1 1 0 10-1.93-.52l-.63 2.33L13 10.27V7.41l1.71-1.7a1.004 1.004 0 10-1.42-1.42l-.29.3V3a1 1 0 00-2 0v1.59l-.29-.3a1.003 1.003 0 10-1.42 1.42L11 7.41v2.86L8.53 8.84 7.9 6.51a1 1 0 00-1.22-.71A1 1 0 006 7l.11.4-1.37-.8a1.003 1.003 0 00-1 1.74l1.37.79-.4.11a1.008 1.008 0 00.26 2h.26l2.33-.63L10 12l-2.47 1.43-2.33-.63a1 1 0 10-.52 1.93l.4.11-1.37.79a1.003 1.003 0 101 1.74l1.37-.8L6 17a1 1 0 00.71 1.23c.086.01.174.01.26 0a1 1 0 001-.74l.63-2.33 2.4-1.43v2.86l-1.71 1.7a1 1 0 00.325 1.639 1 1 0 001.095-.219l.29-.3V21a1 1 0 102 0v-1.59l.29.3a1.002 1.002 0 001.639-.325 1.002 1.002 0 00-.219-1.095L13 16.59v-2.86l2.47 1.43.63 2.33a1 1 0 001 .74c.086.01.174.01.26 0A1 1 0 0018 17l-.11-.4 1.37.8a1 1 0 00.5.13 1 1 0 00.5-1.87l.03-.03z",
            fill: "currentColor"
        })
    });



const $7e654e91dc1f33ca$export$7bf58a3af26a3a1 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M14.44 8.32A1 1 0 0015.8 8l.5-.86a1.001 1.001 0 10-1.73-1l-.5.86a1 1 0 00.37 1.32zm4.5 3.27h-1a1 1 0 000 2h1a1 1 0 000-2zM12 7a1 1 0 001-1V4a1 1 0 00-2 0v2a1 1 0 001 1zm4.17 2.33a1 1 0 00.1.76 1 1 0 00.99.486 1 1 0 00.37-.126l1.74-1a1 1 0 00-1-1.73l-1.74 1a1 1 0 00-.46.61zM12 18a1 1 0 00-1 1v2a1 1 0 102 0v-2a1 1 0 00-1-1zm7.37-2.28l-1.74-1a1 1 0 00-1 1.73l1.74 1a1 1 0 001-1.73zm-3.57 1.63a1 1 0 00-1.36-.35 1 1 0 00-.37 1.37l.5.86a1 1 0 101.73-1l-.5-.88zm.14-4.76A4 4 0 0013 8.76v7.65a4 4 0 002.94-3.82zM11 10.27L8.53 8.84 7.9 6.51a1 1 0 00-1.22-.71A1 1 0 006 7l.11.4-1.37-.8a1.003 1.003 0 00-1 1.74l1.37.79-.4.11a1.008 1.008 0 00.26 2h.26l2.33-.63L10 12l-2.47 1.43-2.33-.63a1 1 0 10-.52 1.93l.4.11-1.37.79a1.003 1.003 0 101 1.74l1.37-.8L6 17a1 1 0 00.71 1.23c.086.01.174.01.26 0a1 1 0 001-.74l.63-2.33 2.4-1.43v-3.46z",
            fill: "currentColor"
        })
    });



const $4f7875ea6f198bb9$export$b61cb29356c7cf89 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10.44 5.62c.27.26.6.44.97.54.38.1.78.1 1.16 0 .38-.1.72-.29 1-.55.28-.27.48-.6.57-.96.1-.36.1-.75-.01-1.11-.1-.35-.29-.67-.56-.93-.27-.26-.6-.44-.97-.54-.38-.1-.78-.1-1.16 0-.38.1-.72.29-1 .55-.28.27-.48.6-.57.96-.1.36-.1.75.01 1.11.1.35.29.67.56.93zm8.88 6.13H5.02V10.36c0-.91.42-1.24.72-1.39.39.57 1.16.72 1.73.32.57-.4.71-1.18.31-1.75a1.23 1.23 0 00-1.73-.32c-.27.19-.46.48-.52.8-.64.22-1.46.86-1.46 2.33v1.8c-.04.09-.07.19-.07.29v1.63c0 .38.31.68.68.68H8v5.98c0 .56.45 1.01 1.01 1.01h5.98c.56 0 1.01-.45 1.01-1.01v-5.98h3.32c.38 0 .68-.31.68-.68v-1.63a.68.68 0 00-.68-.68v-.01zm-3.61-1.49c0-1.93-1.57-3.5-3.5-3.5h-.41c-1.93 0-3.5 1.57-3.5 3.5V11h7.41v-.74z",
            fill: "currentColor"
        })
    });



const $97a1d4b59687b111$export$9a420151e2fd75fb = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M6 16c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1s.45 1 1 1h2c.55 0 1-.45 1-1zm-.71 1.79l-1.5 1.5a.996.996 0 00.71 1.7c.26 0 .51-.1.71-.29l1.5-1.5a.996.996 0 10-1.41-1.41h-.01zM13.5 3A6.5 6.5 0 007 9.5l-1.55 3.49c-.24.54.04 1.17.6 1.35l1.96.65v1c0 1.1.9 2 2 2h1v2c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-5.82c1.23-1.18 2-2.84 2-4.68a6.5 6.5 0 00-6.5-6.5L13.5 3z",
            fill: "currentColor"
        })
    });



const $cb4f24992a067197$export$25b86bfb43fd014b = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21 10a1 1 0 00-1 1h-1.08a7 7 0 00-1.32-3.19l.76-.76a1 1 0 101.42-1.41l-1.42-1.42a1 1 0 10-1.41 1.42l-.76.76A7 7 0 0013 5.08V4a1 1 0 100-2h-2a1 1 0 100 2v1.08A7 7 0 007.81 6.4l-.76-.76a1 1 0 10-1.41-1.42L4.22 5.64a1 1 0 101.42 1.41l.76.76A7 7 0 005.08 11H4a1 1 0 10-2 0v2a1 1 0 102 0h1.08a7 7 0 001.32 3.19l-.76.81a1 1 0 10-1.42 1.41l1.42 1.42a1 1 0 101.41-1.42l.76-.76A7 7 0 0011 18.92V20a1 1 0 000 2h2a1 1 0 000-2v-1.08a7 7 0 003.19-1.32l.76.76a1.002 1.002 0 00.705 1.71 1 1 0 00.705-.29l1.42-1.42a1 1 0 10-1.42-1.41l-.76-.76A7 7 0 0018.92 13H20a1 1 0 002 0v-2a1 1 0 00-1-1zm-11 2a2 2 0 110-4 2 2 0 010 4zm2 5a1 1 0 110-2 1 1 0 010 2zm4-5a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $0e6e198b301ac1e4$export$7ca10e6b3348f033 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18.75 8h-.09C20.93 6.05 21 4.23 21 4a1 1 0 00-.62-.92 1 1 0 00-1.09.21 12.61 12.61 0 01-2.62 1.88A3.87 3.87 0 0014 4h-4a3.87 3.87 0 00-2.67 1.17 12.61 12.61 0 01-2.62-1.88 1 1 0 00-1.09-.21A1 1 0 003 4c0 .23.07 2.05 2.34 4h-.09A2.25 2.25 0 003 10.25a.76.76 0 00.75.75h1.5c.307 0 .61-.065.89-.19.08.48.19.9.3 1.32.11.42.22.87.32 1.43A4.83 4.83 0 019 13h6a4.83 4.83 0 012.24.56c.1-.56.21-1 .32-1.43.11-.43.22-.84.3-1.32.28.125.583.19.89.19h1.5a.76.76 0 00.75-.75A2.25 2.25 0 0018.75 8zM9 11a1 1 0 110-2.001 1 1 0 010 2zm6 0a1 1 0 110-2.002A1 1 0 0115 11zm0 4H9a3 3 0 000 6h6a3 3 0 000-6z",
            fill: "currentColor"
        })
    });



const $48901044e33c40fc$export$56566760f5cb36c7 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M2 10v4a1 1 0 001 1h1V9H3a1 1 0 00-1 1zm13-4H9a3 3 0 00-3 3v6a3 3 0 003 3h6a3 3 0 003-3V9a3 3 0 00-3-3zm-3 8a2 2 0 110-4 2 2 0 010 4zm9-5h-1v6h1a1 1 0 001-1v-4a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $3bb8240315b7af81$export$d5eb40dbe4cf403e = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.71 4.71a1.004 1.004 0 10-1.42-1.42l-16 16a1 1 0 000 1.42.998.998 0 001.42 0l3-3A3 3 0 009 18h6a3 3 0 003-3V9a2.999 2.999 0 00-.3-1.29l3.01-3zM12 14a2.087 2.087 0 01-.51-.07l2.44-2.44c.044.166.068.338.07.51a2 2 0 01-2 2zM9 6a3 3 0 00-3 3v4.76L13.76 6H9zm-5 9V9H3a1 1 0 00-1 1v4a1 1 0 001 1h1zm17-6h-1v6h1a1 1 0 001-1v-4a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $214bcae4eee5bb81$export$fdbb58f722fe795b = (v)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...v,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 5h-1a1.001 1.001 0 00-.17 0A3 3 0 0014 3H9a1 1 0 00-1 1v2h2a5 5 0 014.08 2.12A5 5 0 0117 10V7h1a1 1 0 011 1v2a1 1 0 002 0V8a3 3 0 00-3-3zm-5 5h-.18A3 3 0 0010 8H4a1 1 0 00-1 1v6a1 1 0 001 1h5.5a1.5 1.5 0 011.5 1.5V20a1 1 0 002 0v-8a1 1 0 011 1v2a1 1 0 002 0v-2a3 3 0 00-3-3zm-3.5 7H4v1a1 1 0 102 0v1a1 1 0 102 0v-1a1 1 0 102 0v-.5a.5.5 0 00-.5-.5z",
            fill: "currentColor"
        })
    });



const $73148d38f4f038c0$export$8dbcb2594cf086b9 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M14 15h-4a3 3 0 000 6h4a3 3 0 100-6zm4.75-6h-.14A7.31 7.31 0 0021 4a1 1 0 00-1.83-.56A11.45 11.45 0 0116.68 6 4.31 4.31 0 0014 5h-4a4.31 4.31 0 00-2.68 1 11.45 11.45 0 01-2.49-2.56A1 1 0 003 4a7.31 7.31 0 002.39 5h-.14A2.25 2.25 0 003 11.25a.76.76 0 00.75.75h1.5c.379-.002.75-.102 1.08-.29 0 .14.07.28.11.42.176.657.31 1.325.4 2A5 5 0 0110 13h4a5 5 0 013.16 1.15c.09-.675.224-1.343.4-2 0-.14.07-.28.11-.42.33.188.701.288 1.08.29h1.5a.76.76 0 00.75-.75A2.25 2.25 0 0018.75 9zM9 11a1 1 0 110-2 1 1 0 010 2zm6 0a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $8933373109ff79ee$export$1060b160d9d3d6a1 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18.75 8h-.09C20.93 6.05 21 4.23 21 4a1 1 0 00-.62-.92 1 1 0 00-1.09.21 12.77 12.77 0 01-2.82 2A5.45 5.45 0 0013 4h-2a5.45 5.45 0 00-3.47 1.28 12.77 12.77 0 01-2.82-2 1 1 0 00-1.09-.21A1 1 0 003 4c0 .23.07 2.05 2.34 4h-.09A2.25 2.25 0 003 10.25a.76.76 0 00.75.75h1.5c.256-.001.51-.049.75-.14V14a4.92 4.92 0 013-1h6a4.92 4.92 0 013 1v-3.14c.24.091.494.139.75.14h1.5a.76.76 0 00.75-.75A2.25 2.25 0 0018.75 8zM9 11a1 1 0 110-2.001 1 1 0 010 2zm6 0a1 1 0 110-2.002A1 1 0 0115 11zm0 4H9a3 3 0 000 6h6a3 3 0 000-6z",
            fill: "currentColor"
        })
    });



const $6e5e8fa13db9272a$export$fc24d33d133991a3 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15.994 17.008a2 2 0 100 4 2 2 0 000-4zm-13.41 2.41l2 2a2 2 0 002.82 0l10-10a2 2 0 00.59-1.41v-2a2.087 2.087 0 00-.07-.51l3.78-3.78a1 1 0 00-.325-1.638 1 1 0 00-1.095.218l-3.78 3.78a2.09 2.09 0 00-.51-.07h-2a2 2 0 00-1.41.59l-10 10a2 2 0 000 2.82z",
            fill: "currentColor"
        })
    });



const $10964f19d0e5c40f$export$e9948a7d183ed41d = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.48 13.89a.417.417 0 010-.05l-.5-3A1 1 0 0018 10V9A6 6 0 106 9v1a1 1 0 00-1 .84l-.5 3a.43.43 0 010 .05 4 4 0 105 0 .43.43 0 010-.05l-.5-3A1 1 0 008 10V9a4 4 0 018 0v1a1 1 0 00-1 .84l-.5 3a.417.417 0 010 .05 4 4 0 105 0h-.02zM9 17a2 2 0 11-4 0 2 2 0 014 0zm8 2a2 2 0 110-4 2 2 0 010 4z",
            fill: "currentColor"
        })
    });



const $89e4cdce3722d554$export$9e84ee40bf1ba0a6 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.82 16.11a6.08 6.08 0 00-1.46.48l-.36.15v-2.33l2.71-2.7a1.004 1.004 0 00-1.42-1.42L18 11.59V9.41l1.71-1.7a1.004 1.004 0 10-1.42-1.42l-.29.3V4a1 1 0 00-2 0v2.59l-.29-.3a1.004 1.004 0 00-1.42 1.42L16 9.41v2.18l-1.29-1.3a1.004 1.004 0 00-1.42 1.42l2.71 2.7V17a3.84 3.84 0 01-1.35-.38A5.66 5.66 0 0012 16a5.67 5.67 0 00-2.66.59A3.79 3.79 0 018 17v-2.59l1.71-1.7a1.004 1.004 0 10-1.42-1.42l-.29.3V9a1 1 0 00-2 0v2.59l-.29-.3a1.004 1.004 0 10-1.42 1.42L6 14.41v2.33l-.37-.15a6.002 6.002 0 00-1.45-.48 1 1 0 00-.82.21 1 1 0 00-.36.77V20a1 1 0 001 1h16a1 1 0 001-1v-2.91a1.001 1.001 0 00-.36-.77 1 1 0 00-.82-.21z",
            fill: "currentColor"
        })
    });



const $18b41e06ff48fe76$export$e0878e688159f281 = (v)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...v,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.64 16.32a1 1 0 00-.82-.21 6.08 6.08 0 00-1.46.48l-.36.15v-2.86a4.23 4.23 0 003-3.29.481.481 0 00-.11-.41.49.49 0 00-.39-.18 3.82 3.82 0 00-2.5.86v-2a4.23 4.23 0 003-3.29.481.481 0 00-.11-.41.49.49 0 00-.39-.16 3.82 3.82 0 00-2.5.86V4a1 1 0 00-2 0v1.86A3.82 3.82 0 0013.5 5a.49.49 0 00-.38.18.48.48 0 00-.11.41 4.23 4.23 0 003 3.29v2A3.82 3.82 0 0013.5 10a.49.49 0 00-.38.18.48.48 0 00-.11.41 4.23 4.23 0 003 3.29V17a3.91 3.91 0 01-1.35-.38A5.66 5.66 0 0012 16a5.67 5.67 0 00-2.66.59A3.79 3.79 0 018 17v-2.12a4.23 4.23 0 003-3.29.481.481 0 00-.11-.41.49.49 0 00-.39-.18 3.82 3.82 0 00-2.5.86v-2a4.23 4.23 0 003-3.29.481.481 0 00-.11-.41.49.49 0 00-.39-.16 3.82 3.82 0 00-2.5.86V5a1 1 0 10-2 0v1.86A3.82 3.82 0 003.5 6a.49.49 0 00-.38.18.48.48 0 00-.12.41 4.23 4.23 0 003 3.29v2A3.82 3.82 0 003.5 11a.489.489 0 00-.38.18.48.48 0 00-.11.41 4.23 4.23 0 003 3.29v1.86l-.37-.15a6.002 6.002 0 00-1.45-.48 1 1 0 00-.82.21 1 1 0 00-.36.77V20a1 1 0 001 1H20a1 1 0 001-1v-2.91a1.001 1.001 0 00-.36-.77z",
            fill: "currentColor"
        })
    });



const $437ccf382314705a$export$5203cf9ebb6efaf7 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.55 11.83l.07-.07a1 1 0 00.15-.14l.1-.15c.028-.058.051-.118.07-.18a1.172 1.172 0 000-.2L21 11V5a1 1 0 00-2 0v1.46l-1 .67V4a1 1 0 00-2 0v3.13l-1-.67V5a1 1 0 00-2 0v6.09a1.172 1.172 0 000 .2c.02.062.043.122.07.18.03.052.063.102.1.15a1 1 0 00.15.14l.07.07L16 13.54V17a3.84 3.84 0 01-1.35-.38A5.66 5.66 0 0012 16a5.67 5.67 0 00-2.66.59A3.79 3.79 0 018 17v-2.46l2.55-1.71.07-.07a1 1 0 00.15-.14c.037-.048.07-.098.1-.15.028-.058.051-.118.07-.18a1.172 1.172 0 000-.2L11 12V6a1 1 0 00-2 0v1.46l-1 .67V5a1 1 0 10-2 0v3.13l-1-.67V6a1 1 0 10-2 0v6.09a1.18 1.18 0 000 .2c.02.062.042.122.07.18l.1.15a1 1 0 00.15.14l.07.07L6 14.54v2.2l-.37-.15a6.002 6.002 0 00-1.45-.48 1 1 0 00-.82.21 1 1 0 00-.36.77V20a1 1 0 001 1h16a1 1 0 001-1v-2.91a1.001 1.001 0 00-.36-.77 1 1 0 00-.82-.21 6.08 6.08 0 00-1.46.48l-.36.15v-3.2l2.55-1.71zM18 9.54l1-.67v1.59l-1 .67V9.54zm-10 1l1-.67v1.59l-1 .67v-1.59zm-2 1.59l-1-.67V9.87l1 .67v1.59zm10-1l-1-.67V8.87l1 .67v1.59z",
            fill: "currentColor"
        })
    });



const $3314caf4ed9e4c8e$export$7b53319552eb812 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18.5 16h-13c-.83 0-1.5.67-1.5 1.5S4.67 19 5.5 19h13c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5zm.96-8.89l-1.38 1.16c-1.01.85-2.57.54-3.16-.63l-.63-1.25c-.94-1.86-3.63-1.86-4.58 0l-.63 1.25c-.6 1.17-2.15 1.48-3.16.63L4.54 7.11c-1.15-.97-2.88.11-2.48 1.55l1.34 4.86c.24.88 1.05 1.49 1.97 1.49h13.25c.92 0 1.73-.61 1.97-1.49l1.34-4.86c.4-1.44-1.33-2.52-2.48-1.55h.01z",
            fill: "currentColor"
        })
    });



const $9babd8383a0a33ca$export$6377bea22f76df57 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 4.28V3a1 1 0 00-1-1H7a1 1 0 00-1 1v1.28a4.46 4.46 0 00.28 8.52A6 6 0 0011 16.91V20H9a1 1 0 000 2h6a1 1 0 000-2h-2v-3.09a6 6 0 004.72-4.11A4.46 4.46 0 0018 4.28zM6 10.49a2.47 2.47 0 010-4v4zm7.8-2l-.57.51.14.79a.49.49 0 01-.5.58.46.46 0 01-.23-.06l-.7-.37-.71.37a.49.49 0 01-.52 0 .51.51 0 01-.2-.49l.13-.82-.57-.55A.5.5 0 0110 8a.47.47 0 01.4-.34l.79-.12.35-.71a.52.52 0 01.89 0l.36.71.78.12a.5.5 0 01.41.34.49.49 0 01-.18.46v.03zm4.2 2v-4a2.47 2.47 0 010 4z",
            fill: "currentColor"
        })
    });



const $6b01eb5134c970fe$export$ebfac7affe5cac18 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 4h-3.18a3 3 0 00-5.64 0H6a2 2 0 00-2 2v14a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2zm-6 0a1 1 0 110 2 1 1 0 010-2zm0 4.5a2.5 2.5 0 110 5 2.5 2.5 0 010-5zm4.31 9.5a1 1 0 01-.86.5h-6.9a1 1 0 01-.86-1.5 5 5 0 018.62 0 1 1 0 010 1z",
            fill: "currentColor"
        })
    });



const $dd0d50749ea30272$export$520545025a8ff6d1 = (c)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M15.01 10.94c.38.57 1.01.9 1.69.9h1.51c.55 0 1-.45 1-1s-.45-1-1-1h-1.53l-1.25-1.89a2.02 2.02 0 00-2.59-.69L8.98 9.19c-.63.32-1.05.92-1.11 1.63-.06.71.24 1.38.8 1.8l2.38 1.79V18c0 .55.45 1 1 1s1-.45 1-1v-3.59c0-.63-.3-1.24-.81-1.62l-2.36-1.82 3.89-1.92 1.25 1.87-.01.02zM17.69 7.71a1.54 1.54 0 10-.001-3.081 1.54 1.54 0 00.001 3.08zM5.74 12.89C3.68 12.89 2 14.57 2 16.63c0 2.06 1.68 3.74 3.74 3.74 2.06 0 3.74-1.68 3.74-3.74 0-2.06-1.68-3.74-3.74-3.74zm0 5.48a1.741 1.741 0 010-3.48 1.741 1.741 0 010 3.48z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M18.26 12.89c-2.06 0-3.74 1.68-3.74 3.74 0 2.06 1.68 3.74 3.74 3.74 2.06 0 3.74-1.68 3.74-3.74 0-2.06-1.68-3.74-3.74-3.74zm0 5.48a1.741 1.741 0 010-3.48 1.741 1.741 0 010 3.48z",
                fill: "currentColor"
            })
        ]
    });



const $09a0aee9f21540ae$export$d83009e1d7b2d9be = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm7.71.29a.999.999 0 00-1.42 0l-2 2a1 1 0 01-1.15.19l-1.82-.91a3 3 0 00-2.68 0l-1.82.91a1 1 0 01-1.15-.19l-2-2a1 1 0 00-1.38 1.42l2 2a3 3 0 003.47.56L11 8.62v3.81l-3.06 1.84A4 4 0 006 17.7V21a1 1 0 102 0v-3.3A2 2 0 019 16l2.51-1.5 2.58 6.87A1.002 1.002 0 0015 22a1 1 0 00.684-.265 1.002 1.002 0 00.256-1.085L13 12.82v-4.2l1.26.63c.42.208.882.317 1.35.32a3 3 0 002.12-.88l2-2a1 1 0 00-.02-1.4z",
            fill: "currentColor"
        })
    });



const $3939888afe35b492$export$b7096aefc5df90b8 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 5h-3.14A4 4 0 008 6v1h11a1 1 0 100-2zm-4.59 8.43L12.6 14.8a1 1 0 01-1.19.01l-1.86-1.36A7 7 0 005 20a2 2 0 002 2h10a2 2 0 002-2 7 7 0 00-4.59-6.57zM16 20h-2a1 1 0 110-2h2a1 1 0 010 2zm-.14-11H8.14a4 4 0 007.72 0z",
            fill: "currentColor"
        })
    });



const $559a868e9c3014fa$export$9218596a61fba5cb = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M22 17.68l-1-3a1 1 0 00-1-.68h-2.5a1 1 0 00.81-.42 1 1 0 00.14-.9l-1-3A1 1 0 0016.5 9h-2a1 1 0 00.81-.42 1 1 0 00.14-.9l-1-3A1 1 0 0013.5 4h-3a1 1 0 00-.95.68l-1 3a1 1 0 00.14.9A1 1 0 009.5 9H7a1 1 0 00-1 .68l-1 3a1 1 0 00.14.9A1 1 0 006 14H4a1 1 0 00-1 .68l-1 3a1 1 0 00.14.9A1 1 0 003 19h18a1 1 0 00.81-.42.999.999 0 00.19-.9zm-12.4-3L8.78 17h-.06L8 14.68A1 1 0 007 14h3.5a1 1 0 00-.95.68h.05zm3-5L11.78 12h-.06L11 9.68A1 1 0 0010 9h3.5a1 1 0 00-.95.68h.05zm3.5 5L15.28 17h-.06l-.77-2.32a1 1 0 00-.95-.68H17a1 1 0 00-.95.68h.05z",
            fill: "currentColor"
        })
    });



const $2f4149d70490d4a8$export$841c0630557fd2f = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12.87 9.5a1 1 0 00-1.74 0l-2.88 5a1 1 0 00.86 1.5H10v3a1 1 0 001 1h2a1 1 0 001-1v-3h.89a1 1 0 00.86-1.5l-2.88-5zM20 8a2 2 0 10-1.72-3H14a1 1 0 00-1-1h-2a1 1 0 00-1 1H5.72a2 2 0 100 2h1.16a7.57 7.57 0 00-2.48 5.6v2.25a2.2 2.2 0 102 0V12.6a5.6 5.6 0 013.67-5.25A1 1 0 0011 8h2a1 1 0 00.93-.65 5.6 5.6 0 013.67 5.25v2.25a2.2 2.2 0 102 0V12.6A7.57 7.57 0 0017.12 7h1.16A2 2 0 0020 8z",
            fill: "currentColor"
        })
    });



const $4b2e540468196e2c$export$60e06bebca137bbc = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 4H5a3 3 0 00-3 3v10a3 3 0 003 3h14a3 3 0 003-3V7a3 3 0 00-3-3zM8 13a1 1 0 01-.71-.29l-2-2a1 1 0 010-1.42l2-2a1.004 1.004 0 011.42 1.42L7.41 10l1.3 1.29A1 1 0 018 13zm2.93 4.37a1 1 0 01-1.628.348 1 1 0 01-.232-1.088l4-10a1 1 0 111.86.74l-4 10zm7.78-2.66l-2 2a1.002 1.002 0 01-1.639-.325 1 1 0 01.219-1.095l1.3-1.29-1.3-1.29a1.004 1.004 0 011.42-1.42l2 2a1.002 1.002 0 010 1.42z",
            fill: "currentColor"
        })
    });



const $417bdeef00294e01$export$f951bf12ffbee03a = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 5a1.5 1.5 0 001.39-.93 1.49 1.49 0 00.08-.86A1.49 1.49 0 0012.29 2a1.49 1.49 0 00-.86.08 1.55 1.55 0 00-.68.56A1.5 1.5 0 0012 5zm7.71 14.29A1 1 0 0019 19h-8l5.6-4.2a1 1 0 00.37-.54 1 1 0 000-.65l-3-7a1.209 1.209 0 00-.24-.35 1 1 0 00-.37-.21 1 1 0 00-.42 0 .94.94 0 00-.4.13L8 8.82 5.55 7.17A1 1 0 005.18 7a1.12 1.12 0 00-.41 0 1 1 0 00-.68.44.84.84 0 00-.15.38.94.94 0 000 .41c.038.133.099.258.18.37.09.108.198.2.32.27l3 2a1 1 0 001.06 0l4-2.41 2.24 5.22L7.4 19.2a1 1 0 00-.35.5.94.94 0 000 .62A1 1 0 008 21h11a1 1 0 00.71-1.71z",
            fill: "currentColor"
        })
    });



const $b3f6d9549e0036be$export$b0836cd82783d129 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 7a1 1 0 001-1V4a1 1 0 10-2 0v2a1 1 0 001 1zm3.55-.11A.93.93 0 0016 7a1 1 0 00.89-.55l.5-1a1 1 0 10-1.78-.9l-.5 1a1 1 0 00.44 1.34zm-8.44-.44A1 1 0 008 7a.93.93 0 00.45-.11 1 1 0 00.44-1.34l-.5-1a1 1 0 00-1.78.9l.5 1zm13.3 5.14l-3-3A2 2 0 0016 8H8a2 2 0 00-1.41.59l-3 3A2 2 0 003 13.08a2 2 0 00.7 1.44l7 6a2 2 0 002.6 0l7-6a2 2 0 00.7-1.44 2 2 0 00-.59-1.49z",
            fill: "currentColor"
        })
    });



const $f9710c8c0eb94442$export$e9a67cef0a53a41e = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M14 15a3 3 0 003-3V7a3 3 0 00-3-3H5a3 3 0 00-3 3v5a3 3 0 003 3v1a1 1 0 00.55.89A.91.91 0 006 17a1 1 0 00.6-.2L9 15h5zM6 6.5h7a1 1 0 110 2H6a1 1 0 010-2zm2 6H6a1 1 0 010-2h2a1 1 0 010 2zM19 8h-.09v4A4.91 4.91 0 0114 16.91H9.78L8 18.24a3 3 0 002 .76h5l2.4 1.8a1 1 0 00.6.2.91.91 0 00.45-.11A1 1 0 0019 20v-1a3 3 0 003-3v-5a3 3 0 00-3-3z",
            fill: "currentColor"
        })
    });



const $8360212dca364828$export$abbe37a6cdeb1fe3 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 6V5a3 3 0 00-3-3H5a3 3 0 00-3 3v8a3 3 0 003 3h1v-5a5 5 0 015-5h5zm3 2h-8a3 3 0 00-3 3v8a3 3 0 003 3h8a3 3 0 003-3v-8a3 3 0 00-3-3zm-6.5 6a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm5 5a1.5 1.5 0 110-3 1.5 1.5 0 010 3z",
            fill: "currentColor"
        })
    });



const $a6cb4ba922fd1534$export$7556c43e8ef070e5 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M3 16h18a1 1 0 001-1 10 10 0 00-9-9.95 1 1 0 00-2 0A10 10 0 002 15a1 1 0 001 1zm18 2H3a1 1 0 000 2h18a1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $1c2821fa612003c9$export$5e39e6542ab03567 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15 8V7a1 1 0 00-1-1h-1V4h.51a2 2 0 01.64.1l2.53.9c.106.014.214.014.32 0a1 1 0 001.05-1.068 1 1 0 00-.68-.882l-2.54-.84A3.93 3.93 0 0013.51 2H9a1 1 0 000 2h2v2h-1a1 1 0 00-1 1v1a3 3 0 00-3 3v8a3 3 0 003 3h6a3 3 0 003-3v-8a3 3 0 00-3-3zm-1 8h-1v1a1 1 0 01-2 0v-1h-1a1 1 0 010-2h1v-1a1 1 0 012 0v1h1a1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $1b34597611549c3f$export$b85bd9f4a6b107b4 = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm2 16c-2.76 0-5-2.24-5-5 0-1.65 1.35-3 3-3s3 1.35 3 3c0 .55-.45 1-1 1s-1-.45-1-1-.45-1-1-1-1 .45-1 1c0 1.65 1.35 3 3 3s3-1.35 3-3c0-2.76-2.24-5-5-5s-5 2.24-5 5c0 .55-.45 1-1 1s-1-.45-1-1c0-3.86 3.14-7 7-7s7 3.14 7 7c0 2.76-2.24 5-5 5z",
            fill: "currentColor"
        })
    });



const $d073881c6a2ab1b3$export$966211ed1849c212 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.71 6.29a.999.999 0 00-1.42 0c-.096.098-.2.189-.31.27L17.44 4c.084-.112.174-.219.27-.32a1 1 0 10-1.42-1.41 6.432 6.432 0 00-1.83 5.16 6.39 6.39 0 00-7 7 6.48 6.48 0 00-5.16 1.84 1 1 0 00.325 1.639 1 1 0 001.095-.22c.087-.09.18-.173.28-.25L6.56 20c-.081.111-.172.215-.27.31a1 1 0 00.325 1.64 1 1 0 001.095-.22 6.48 6.48 0 001.84-5.16 6.39 6.39 0 007-7 6.47 6.47 0 005.16-1.84 1 1 0 000-1.44zM7.47 18.05L6 16.53a8.38 8.38 0 011.6-.08 8.37 8.37 0 01-.13 1.6zm2-3.51A8.31 8.31 0 019.53 13l1.52 1.52a7.647 7.647 0 01-1.6.02h.02zm3.84-1.25c-.096.098-.2.189-.31.27L10.44 11c.166-.22.361-.414.58-.58L13.56 13c-.082.104-.173.2-.27.29h.02zm1.18-2.24L13 9.53a7.65 7.65 0 011.6-.07 7.563 7.563 0 01-.13 1.59h.02zm2-3.51A7.574 7.574 0 0116.54 6l1.51 1.52a7.58 7.58 0 01-1.59.02h.03z",
            fill: "currentColor"
        })
    });



const $83930e3c31cedced$export$4e63f4736998225d = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 11a4.5 4.5 0 10-4.5-4.5A4.51 4.51 0 0012 11zm2.47 1.39l-1.9 1.41a1 1 0 01-1.2 0l-1.88-1.39A8 8 0 004 20a2 2 0 002 2h12a2 2 0 002-2 8 8 0 00-5.53-7.61zM17 18.5h-1v1a1 1 0 01-2 0v-1h-1a1 1 0 010-2h1v-1a1 1 0 012 0v1h1a1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $34ba17182628c3d4$export$af0d9c5a256f0041 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21 20h-3a10 10 0 10-6 2h9a1 1 0 000-2zM6 14a2 2 0 110-4 2 2 0 010 4zm6 6a2 2 0 110-4 2 2 0 010 4zm-1-8a1 1 0 112 0 1 1 0 01-2 0zm1-4a2 2 0 110-4 2 2 0 010 4zm4 4a2 2 0 114 0 2 2 0 01-4 0z",
            fill: "currentColor"
        })
    });



const $2dd170945c29cde4$export$8acfad98e44669b = (s)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...s,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 3H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 15H8c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1zm0-5H8c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1zm0-5H8c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1z",
            fill: "currentColor"
        })
    });



const $e8d373faa9bfedb8$export$c8a79a1f6f2f7934 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 2H8a3 3 0 00-3 3v14a3 3 0 003 3h8a3 3 0 003-3V5a3 3 0 00-3-3zm0 11a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $4a09b5a608b523b9$export$2c6dd8f0a7cd49ea = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.71 8.29A1 1 0 0020 8H9a1 1 0 00-1 1v6c0 4.65 5.91 6.85 6.16 6.94a1 1 0 00.68 0C15.09 21.85 21 19.65 21 15V9a1 1 0 00-.29-.71zm-9.92 3a1 1 0 011.27-.12.94.94 0 01.36.45 1 1 0 01.06.58 1 1 0 01-.78.78 1 1 0 01-.58-.06.94.94 0 01-.45-.36 1 1 0 01.12-1.27zm7.46 5a4.93 4.93 0 01-1.69 1.27 4.94 4.94 0 01-4.12 0 4.93 4.93 0 01-1.69-1.27.999.999 0 01-.26-.34.9.9 0 01-.1-.42c0-.145.03-.288.09-.42a1 1 0 01.26-.35 1.07 1.07 0 01.38-.2.901.901 0 01.43 0 .83.83 0 01.4.16 1 1 0 01.3.31 3 3 0 001 .75 2.94 2.94 0 002.46 0 3 3 0 001-.75 1 1 0 011.72.61 1 1 0 01-.18.68v-.03zm0-3.61a1 1 0 01-1.27.12.94.94 0 01-.36-.45 1 1 0 01-.06-.58 1 1 0 01.74-.77 1 1 0 01.58.06.94.94 0 01.45.36 1 1 0 01-.12 1.27l.04-.01zM16 6V3a1 1 0 00-1-1H4a1 1 0 00-1 1v6a6.64 6.64 0 003 5.19V9a3 3 0 01.24-1.17 2.85 2.85 0 01.67-1 2.93 2.93 0 011-.65A3.1 3.1 0 019.08 6H16z",
            fill: "currentColor"
        })
    });



const $10fa8a70c0febb66$export$96db68b220c7499 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M5 7H3a1 1 0 000 2h2a2 2 0 002 2h2V5H7a2 2 0 00-2 2zm14.3 4.77A4 4 0 0018 4h-5a2 2 0 00-2 2v4a2 2 0 002 2h1.28l1.33 4H14a2 2 0 000 4h4.38a2.62 2.62 0 002.38-3.71l-1.46-4.52z",
            fill: "currentColor"
        })
    });



const $f3a4f246d5119424$export$e8183a5bfe9af0f1 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M8 20.33A2 2 0 0010 22h6a2 2 0 002-1.67L19.36 12H6.64L8 20.33zM21 2h-4a1 1 0 00-.95.68L15 6h-5a4 4 0 10-4 4H19.69L20 8.33a2 2 0 00-1.14-2.15A2 2 0 0018 6h-.95l.67-2H21a1 1 0 100-2zM6.47 6.71A2 2 0 006 8a2 2 0 112-2 2 2 0 00-1.53.71z",
            fill: "currentColor"
        })
    });



const $0994a8790c407530$export$4af086fa88bc3294 = (o)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M6.05 10.89A2.985 2.985 0 018.84 9H19.3a2.99 2.99 0 00-2.82-2h-4.33l-.44-1.32c-.14-.4-.52-.68-.95-.68H6.48c-1.31 0-2.42.83-2.82 2-.12.31-.18.65-.18 1v8c0 .32.06.63.16.92v-.04l2.4-6 .01.01z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M18.05 18.37l2.4-6c.12-.31.09-.65-.1-.93a.986.986 0 00-.83-.44H8.83a1 1 0 00-.93.63l-2.4 6c-.12.31-.09.65.1.93s.49.44.83.44h10.69a1 1 0 00.93-.63z",
                fill: "currentColor"
            })
        ]
    });



const $102d594eb5a8310a$export$406db9011dbef2f = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7 16c-.5 0-1.5 1.67-1.5 2.5 0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5S7.5 16 7 16zm5 1.5c-.5 0-1.5 1.67-1.5 2.5 0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5-1-2.5-1.5-2.5zm5-1.5c-.5 0-1.5 1.67-1.5 2.5 0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5-1-2.5-1.5-2.5zm2.44-7.62c.03-.21.06-.42.06-.63C19.5 5.13 17.37 3 14.75 3c-1.64 0-3.08.83-3.93 2.09A3.68 3.68 0 0010 5a3.98 3.98 0 00-3.86 3.01C6.09 8.01 6.05 8 6 8c-1.66 0-3 1.34-3 3s1.34 3 3 3h12c1.66 0 3-1.34 3-3 0-1.13-.64-2.11-1.56-2.62z",
            fill: "currentColor"
        })
    });



const $8a4922b9a5565ae7$export$3090778efcdaa981 = (s)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...s,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 8h-.5V6H21c.55 0 1-.45 1-1s-.45-1-1-1h-5c-.55 0-1 .45-1 1s.45 1 1 1h1.5v2h-11V6H8c.55 0 1-.45 1-1s-.45-1-1-1H3c-.55 0-1 .45-1 1s.45 1 1 1h1.5v2H4c-1.1 0-2 .9-2 2s.9 2 2 2h1.59l-1.71 1.71c-.57.57-.88 1.32-.88 2.12V19c0 .55.45 1 1 1s1-.45 1-1v-3.17c0-.26.11-.52.29-.71l1.74-1.74c.2 2.58 2.33 4.62 4.96 4.62s4.77-2.04 4.96-4.62l1.74 1.74c.19.19.29.44.29.71V19c0 .55.45 1 1 1s1-.45 1-1v-3.17c0-.8-.31-1.55-.88-2.12L18.39 12h1.59c1.1 0 2-.9 2-2s-.9-2-2-2H20zm-8 8c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z",
            fill: "currentColor"
        })
    });



const $7d921319e2a023a8$export$1fafe506e2f3d58c = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4 9h7a3 3 0 10-2.59-4.5 1 1 0 001.73 1A1 1 0 1111 7H4a1 1 0 000 2zm14-2a3 3 0 00-2.59 1.5 1 1 0 001.73 1A1 1 0 1118 11H4a1 1 0 100 2h14a3 3 0 000-6zm-6 8H4a1 1 0 100 2h8a1 1 0 11-.86 1.5 1 1 0 00-1.73 1A3 3 0 1012 15z",
            fill: "currentColor"
        })
    });



const $ffa0544f12943b09$export$3c66274ec621edf3 = (l)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M14.104 9.073A2.13 2.13 0 0011.98 6.95a2.13 2.13 0 00-2.123 2.123c0 .647.297 1.22.754 1.613l-1.794 9.861a1.06 1.06 0 00.849 1.232c.064.01.127.021.191.021.499 0 .945-.36 1.04-.87l1.083-5.923 1.083 5.923c.095.51.541.87 1.04.87.064 0 .127 0 .191-.021a1.06 1.06 0 00.85-1.232l-1.795-9.86c.457-.393.754-.967.754-1.614zM20.24 2.396a1.063 1.063 0 10-1.656 1.337 8.494 8.494 0 011.889 5.34c0 1.942-.648 3.81-1.89 5.34a1.063 1.063 0 101.656 1.337 10.65 10.65 0 002.357-6.677c0-2.43-.839-4.798-2.357-6.677z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M15.59 5.04a1.065 1.065 0 00-.212 1.485 4.249 4.249 0 010 5.095 1.064 1.064 0 00.849 1.699c.318 0 .637-.149.849-.425a6.269 6.269 0 001.274-3.821c0-1.39-.446-2.717-1.274-3.821a1.065 1.065 0 00-1.486-.213zM5.22 2.237a1.063 1.063 0 00-1.497.16 10.671 10.671 0 00-2.357 6.676c0 2.42.839 4.798 2.357 6.677a1.07 1.07 0 001.497.16c.456-.373.53-1.041.159-1.498a8.494 8.494 0 01-1.89-5.34c0-1.942.648-3.81 1.89-5.338a1.063 1.063 0 00-.16-1.497z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8.372 5.04a1.065 1.065 0 00-1.486.212 6.27 6.27 0 00-1.274 3.82c0 1.392.446 2.718 1.274 3.822.212.276.53.425.85.425a1.065 1.065 0 00.85-1.698 4.248 4.248 0 01-.002-5.096 1.065 1.065 0 00-.212-1.486z",
                fill: "currentColor"
            })
        ]
    });



const $81c72172cf06862f$export$e16ed40a33cc7612 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M13 2c-4.42 0-8 3.58-8 8v7c0 2.76 2.24 5 5 5 2.5 0 4.56-1.84 4.92-4.24 3.49-.86 6.08-4 6.08-7.76 0-4.42-3.58-8-8-8zm-3 18c-.55 0-1-.45-1-1s.45-1 1-1 1-.45 1-1 .45-1 1-1 1 .45 1 1c0 1.65-1.35 3-3 3zm7.24-5.76c-.2.2-.45.29-.71.29-.26 0-.51-.1-.71-.29a.996.996 0 010-1.41c.76-.76 1.17-1.76 1.17-2.83 0-2.21-1.79-4-4-4a4.01 4.01 0 00-3.92 3.21c1.12.44 1.92 1.52 1.92 2.79 0 1.65-1.35 3-3 3-.55 0-1-.45-1-1s.45-1 1-1 1-.45 1-1-.45-1-1-1-1-.45-1-1c0-3.31 2.69-6 6-6s6 2.69 6 6c0 1.6-.62 3.11-1.76 4.24h.01z",
            fill: "currentColor"
        })
    });



const $ba5c4fd3a1918d19$export$5778ea3fe2a53271 = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M13 2C8.68 2 5.15 5.45 5.01 9.74L3.1 13.56a.993.993 0 00.45 1.34l1.45.72V17c0 1.1.9 2 2 2h2v1c0 1.1.9 2 2 2h5c1.1 0 2-.9 2-2v-3.76c1.83-1.47 3-3.72 3-6.24 0-4.41-3.59-8-8-8zm2.45 8.11c.29.14.49.42.54.73.05.32-.05.64-.28.87l-2 2c-.2.2-.45.29-.71.29-.26 0-.51-.1-.71-.29a.996.996 0 010-1.41l1.02-1.02-.76-.38a.99.99 0 01-.54-.73c-.05-.32.05-.64.28-.87l2-2a.996.996 0 111.41 1.41l-1.02 1.02.76.38h.01z",
            fill: "currentColor"
        })
    });



const $1c6e32063c3324c7$export$6ec6b4c647475d8e = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.07 7.61l-8.5-3.5a1.5 1.5 0 00-1.14 0l-8.5 3.5C2.37 7.84 2 8.39 2 9v7c0 .55.45 1 1 1s1-.45 1-1v-5.17l7.43 3.06c.18.08.38.11.57.11.19 0 .39-.04.57-.11l8.5-3.5a1.505 1.505 0 000-2.78zM12 16c-.46 0-.91-.09-1.33-.26L6 13.82v3.69c0 .59.36 1.13.9 1.37l4.5 1.96c.19.08.39.12.6.12.21 0 .41-.04.6-.12l4.5-1.96c.55-.24.9-.77.9-1.37v-3.69l-4.67 1.92c-.43.18-.87.26-1.33.26z",
            fill: "currentColor"
        })
    });



const $2d3dfa99cd02c914$export$5c035366fbd89cfe = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10 6c.83 0 1.5-.67 1.5-1.5S10.83 3 10 3s-1.5.67-1.5 1.5S9.17 6 10 6zm5.99 6.98c0-.14-.03-.29-.1-.43l-3-6s-.06-.07-.09-.11c-.04-.06-.08-.12-.14-.17-.05-.04-.1-.07-.15-.1-.06-.04-.11-.07-.17-.1-.06-.02-.13-.03-.2-.04-.05 0-.1-.03-.15-.03h-.03c-.06 0-.12.02-.19.04s-.14.02-.2.05h-.03c-.04.02-.07.06-.11.09-.06.04-.12.08-.17.13-.04.05-.07.1-.11.16-.03.05-.07.1-.09.17-.03.07-.03.14-.04.21 0 .05-.03.09-.03.14v3.46l-2.55 1.7c-.46.31-.58.93-.28 1.39.09.13.2.23.33.31v7.64c0 .28.22.5.5.5s.5-.22.5-.5v-7.64s.04-.01.05-.03l3-2s.04-.05.07-.07c.05-.04.1-.09.14-.15.04-.05.07-.1.1-.15.03-.06.05-.11.07-.17.01-.03.03-.06.04-.1l1.02 2.04v7.9c0 .48.45.86 1 .86s1-.39 1-.86V13v-.03l.01.01z",
            fill: "currentColor"
        })
    });



const $1fe4b434ac68cc6c$export$b38fd63457254996 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 3h-4a4 4 0 00-4 4c.001.338.048.675.14 1 .058.235.142.463.25.68.044.111.098.218.16.32a3 3 0 00.29.44c.06.07.11.15.18.22.183.207.383.398.6.57a1.002 1.002 0 01.21 1.4.999.999 0 01-1.4.2A6 6 0 017.09 8H6a3 3 0 00-3 3v9a1 1 0 001 1h2a1 1 0 001-1v-2h4v2a1 1 0 001 1h2a1 1 0 001-1v-7a1 1 0 012 0v3a2 2 0 004 0V7a4 4 0 00-4-4zm-1 5a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $5f5db391a1cfd46f$export$66e1059c742b52e8 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7 18h10v-6a5 5 0 00-10 0v6zm3-6h1v-1a1 1 0 012 0v1h1a1 1 0 010 2h-1v1a1 1 0 01-2 0v-1h-1a1 1 0 010-2zm2-6a1 1 0 001-1V4a1 1 0 00-2 0v1a1 1 0 001 1zm5.66 1.76l.7-.71A1 1 0 1017 5.64l-.71.7a1.004 1.004 0 101.42 1.42h-.05zm-11.32 0a1.004 1.004 0 001.42-1.42l-.71-.7a1 1 0 00-1.41 1.41l.7.71zM6 12a1 1 0 00-1-1H4a1 1 0 000 2h1a1 1 0 001-1zm14-1h-1a1 1 0 000 2h1a1 1 0 000-2zm-2 8H6a1 1 0 000 2h12a1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $68280537ef5a002e$export$8b08d9ece4bf4a1f = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.06 4c-1.3-.02-2.51.55-3.33 1.49-.5.58-.79 1.32-.92 2.08l-.65 3.54c-.09.52-.55.89-1.07.89-.6 0-1.09-.49-1.09-1.09V9c0-.55-.45-1-1-1s-1 .45-1 1v1.91c0 .6-.49 1.09-1.09 1.09-.53 0-.98-.38-1.07-.89l-.65-3.54c-.14-.76-.42-1.5-.92-2.08A4.338 4.338 0 003.94 4C2.86 4.02 2 4.92 2 6v12c0 1.08.87 1.99 1.95 2 1.86.02 3.56-1.02 4.39-2.68.4-.81 1.23-1.32 2.13-1.32h3.06c.9 0 1.73.51 2.13 1.32.83 1.66 2.53 2.7 4.39 2.68 1.08-.01 1.95-.92 1.95-2V6c0-1.08-.86-1.98-1.94-2z",
            fill: "currentColor"
        })
    });



const $d5f99f24552c47d7$export$b2f29e21bbd57f9a = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zM4 12a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm14 0a6 6 0 01-1.11 3.47l.82.82a1.002 1.002 0 01-.325 1.639 1 1 0 01-1.095-.219l-.82-.82a6 6 0 01-7 0l-.81.82a1 1 0 01-1.639-.325 1 1 0 01.219-1.095l1.47-1.46a1 1 0 011.41 0 4 4 0 100-5.66 1 1 0 01-1.41 0L6.29 7.71a1.004 1.004 0 011.42-1.42l.81.82a6 6 0 017 0l.82-.82a1.003 1.003 0 111.42 1.42l-.82.82A6 6 0 0118 12z",
            fill: "currentColor"
        })
    });



const $ecf2ab236633f851$export$cfadd35368d3d7ad = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zm2.8 10.6l-3 4a.999.999 0 11-1.6-1.2L12 13h-2a1 1 0 01-.89-.55 1 1 0 01.09-1l3-4a1 1 0 111.6 1.2L12 11h2a1 1 0 01.8 1.6z",
            fill: "currentColor"
        })
    });



const $f7e3d44c400ef441$export$dbf16b0beb122e3d = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 13a3.809 3.809 0 00-1 .15L10.85 8c.094-.325.145-.661.15-1a4 4 0 00-4-4h-.21a1 1 0 00-.65 1.7l.86.89L5.59 7l-.87-.86a1 1 0 00-1-.21 1 1 0 00-.72.84A1.79 1.79 0 003 7a4 4 0 004 4 3.808 3.808 0 001-.15L13.15 16a3.809 3.809 0 00-.15 1 4 4 0 104-4zm0 6a2 2 0 110-4 2 2 0 010 4zm0-8a4 4 0 004-4 .998.998 0 000-.2 1 1 0 00-1.7-.66l-.89.86L17 5.59l.86-.87a1 1 0 00.21-1 1 1 0 00-.84-.72H17a4 4 0 100 8zM7 13a4 4 0 00-4 4 .999.999 0 000 .2 1 1 0 001.7.66l.89-.86L7 18.41l-.86.87a1 1 0 00.63 1.67L7 21a4 4 0 100-8z",
            fill: "currentColor"
        })
    });



const $098fb5d4da549e63$export$5e38bd40810f5aaa = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4.38 16c-.67.67-1 2.6-1.12 3.8a.84.84 0 00.94.94c1.2-.13 3.13-.45 3.8-1.12A2.56 2.56 0 004.38 16zM21 4.09A1.001 1.001 0 0019.91 3c-.64.06-6.32.63-8.74 3a13.43 13.43 0 00-1.91 2.5 3.81 3.81 0 00-3.79.67l-2.18 2.18a1 1 0 00-.25 1 1 1 0 00.74.7l4.73 1.07 1.38 1.38L11 20.22a1 1 0 00.7.74.9.9 0 00.28 0 1 1 0 00.71-.29l2.18-2.18a3.44 3.44 0 00.91-2.48 4.003 4.003 0 00-.24-1.31A13.433 13.433 0 0018 12.83c2.37-2.42 2.94-8.1 3-8.74zm-4.2 5.23a1.5 1.5 0 110-2.12 1.51 1.51 0 010 2.12z",
            fill: "currentColor"
        })
    });



const $8298fe1a8ef556ea$export$2455ed066abfc407 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12.46 8l2.67-4h-3.59L8.87 8h3.59zM9.13 4H7a3 3 0 00-3 3v1h2.46l2.67-4zM4 17a3 3 0 003 3h10a3 3 0 003-3v-7H4v7zM19.29 5.07a3 3 0 00-1.79-1L14.87 8H20V7a3 3 0 00-.71-1.93z",
            fill: "currentColor"
        })
    });



const $d636042afd74bc53$export$1f1f73dffebd3902 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M9.13 3H6a3 3 0 00-3 3v1h3.46l2.67-4zm3.33 4l2.67-4h-3.59L8.87 7h3.59zm7.66-3.12A3 3 0 0018 3h-.46l-2.67 4H21V6a3 3 0 00-.88-2.12zM3 18a3 3 0 003 3h12a3 3 0 003-3V9H3v9zm7-5a1 1 0 01.14-.51 1.06 1.06 0 01.39-.37A1 1 0 0111 12a1 1 0 01.49.16l3 2a.92.92 0 01.32.36 1 1 0 010 .94.92.92 0 01-.32.36l-3 2A1 1 0 0111 18a.92.92 0 01-.51-.12 1 1 0 01-.37-.36A.89.89 0 0110 17v-4z",
            fill: "currentColor"
        })
    });



const $c83ff748c0d3bd72$export$95314e1e32c99e39 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.46 4.68c-.34-.37-.8-.6-1.3-.66-2.2-.23-4.35-.85-6.34-1.83-.26-.13-.54-.19-.82-.19-.28 0-.56.07-.82.19-1.97.98-4.11 1.6-6.3 1.83-.5.04-.97.27-1.32.64-.35.37-.55.85-.56 1.36v4.99C3 17.75 9.75 22 12 22s9-4.25 9-10.99V6.02c-.01-.5-.2-.97-.54-1.34zm-6.94 5.82c.55 0 1 .45 1 1s-.45 1-1 1H10.5v2h4c.55 0 1 .45 1 1s-.45 1-1 1h-5c-.55 0-1-.45-1-1v-8c0-.55.45-1 1-1h5c.55 0 1 .45 1 1s-.45 1-1 1h-4v2h3.02z",
            fill: "currentColor"
        })
    });



const $097dae6556129c4b$export$6b61f4b9d1e2b6e2 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.82 4.98a.617.617 0 00-.42-.18h-.6V3.6a.56.56 0 00-.18-.42.637.637 0 00-.42-.18c-.15 0-.31.06-.42.18-.11.12-.18.27-.18.42v1.2h-1.2V3.6a.56.56 0 00-.18-.42.637.637 0 00-.42-.18c-.15 0-.31.06-.42.18-.11.12-.18.27-.18.42v1.2h-.6a.56.56 0 00-.42.18c-.11.11-.18.27-.18.42v2.4c0 .48.19.94.53 1.27.34.34.8.53 1.27.53h.2V18c0 .55-.45 1-1 1s-1-.45-1-1v-7c0-1.1-.9-2-2-2h-2V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v15c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-9h2v7c0 1.65 1.35 3 3 3s3-1.35 3-3V9.6h.2c.48 0 .94-.19 1.27-.53.34-.34.53-.8.53-1.27V5.4a.56.56 0 00-.18-.42zM9.49 9.3l-2.96 3.51c-.09.1-.22.16-.35.18-.13.02-.27 0-.38-.08a.569.569 0 01-.25-.3.58.58 0 01-.01-.39l.71-1.85H5.13c-.15 0-.29-.05-.42-.13a.785.785 0 01-.36-.76c.02-.15.07-.29.16-.41L7.6 5.21c.09-.11.21-.18.35-.21.14-.03.28 0 .4.07s.22.18.26.31c.05.13.05.28 0 .41l-.8 2.2h1.07c.15 0 .29.05.42.13.12.08.22.2.29.33a.8.8 0 01-.1.84v.01z",
            fill: "currentColor"
        })
    });



const $44e335b2115f468b$export$ddbbeb441f20c09c = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17.476 9.97l.9-.9a1.803 1.803 0 000-2.546 1.803 1.803 0 00-2.546 0l-.9.9-.9-.9a1.803 1.803 0 00-2.546 0 1.803 1.803 0 000 2.546l-6.72 6.721a.89.89 0 00-.262.639v3.068c0 .495.405.9.9.9H8.47a.93.93 0 00.639-.261l6.72-6.721c.352.35.81.53 1.27.53a1.803 1.803 0 001.269-3.077l-.9-.899h.008zm-9.375 8.628h-1.8v-1.8l2.7-2.698H12.6L8.1 18.598z",
            fill: "currentColor"
        })
    });



const $da896ff606f19556$export$b4c5a2f865fb9862 = (v)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...v,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18.65 6.07C17.73 4.87 15.1 4 12 4c-3.1 0-5.73.87-6.65 2.07C3.45 6.38 2 8.02 2 10v6c0 2.21 1.79 4 4 4h1c1.1 0 2-.9 2-2s-.9-2-2-2c-1.01 0-1.84.76-1.97 1.74C4.42 17.4 4 16.75 4 16v-6c0-.92.63-1.69 1.48-1.92.46.51 1.22.95 2.2 1.28.81.27 1.32 1.06 1.32 1.91v2.56c0 1.33.82 2.53 2 2.97v4.19c0 .55.45 1 1 1s1-.45 1-1v-4.18a3 3 0 002-2.82v-2.73c0-.85.52-1.64 1.32-1.91.98-.33 1.74-.77 2.2-1.28.85.23 1.48 1 1.48 1.92v6c0 .75-.42 1.39-1.03 1.74-.13-.98-.96-1.74-1.97-1.74-1.1 0-2 .9-2 2s.9 2 2 2h1c2.21 0 4-1.79 4-4v-6c0-1.98-1.45-3.62-3.35-3.93v.01z",
            fill: "currentColor"
        })
    });



const $74159036cff07b02$export$b42c5d5bcaf9fb89 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M3.36 13.29C1.75 14.89 2 19.18 2 20a1 1 0 00.92.92c.24 0 .75.05 1.38.05 1.65 0 4.21-.21 5.37-1.37A4.47 4.47 0 0011 17.07L5.92 12a4.45 4.45 0 00-2.56 1.29zM6 7a1 1 0 100-2 1 1 0 000 2zm7-2a1 1 0 100-2 1 1 0 000 2zm4.5 8a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM20 3.78a1 1 0 00-.779-.779 1 1 0 00-1.031.419l-1.86 2.8-3.75 1.87a.9.9 0 00-.38.34l-1.28 1.91-.18-.19a.83.83 0 00-.33-.22 1 1 0 00-.41-.08 1.09 1.09 0 00-.39.08.87.87 0 00-.32.22l-.51.52-1.21-1.23a1 1 0 00-.69-.24 1 1 0 00-.66.29 1 1 0 00-.3.67 1 1 0 00.24.68l6 6a1 1 0 001.41 0 1 1 0 000-1.41l-1.23-1.23.52-.51c.09-.098.164-.21.22-.33a1.07 1.07 0 000-.76 1.119 1.119 0 00-.22-.33l-.5-.49 1.35-2 3.76-1.88a1 1 0 00.38-.4l2-3a1 1 0 00.15-.72z",
            fill: "currentColor"
        })
    });



const $fbbfbd7c8adac0a6$export$737e5f2921842540 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.46 4.68c-.34-.37-.8-.6-1.3-.66-2.2-.23-4.35-.85-6.34-1.83-.26-.13-.54-.19-.82-.19-.28 0-.56.07-.82.19-1.97.98-4.11 1.6-6.3 1.83-.5.04-.97.27-1.32.64-.35.37-.55.85-.56 1.36v4.99C3 17.75 9.75 22 12 22s9-4.25 9-10.99V6.02c-.01-.5-.2-.97-.54-1.34zM15 9h-4v2h3.02c.55 0 1 .45 1 1s-.45 1-1 1H11v3c0 .55-.45 1-1 1s-1-.45-1-1V8c0-.55.45-1 1-1h5c.55 0 1 .45 1 1s-.45 1-1 1z",
            fill: "currentColor"
        })
    });



const $091f00d1cfff484b$export$2c2514f31da1fe77 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.7 4.94l-5-1.87a1 1 0 00-1.17.35 3 3 0 01-5 0 1 1 0 00-1.17-.35l-5 1.87A2 2 0 002.1 7.45l1 3A2 2 0 005 11.82h.28l.72-.13V19a2 2 0 002 2h8a2 2 0 002-2v-7.31l.72.11H19a2 2 0 001.9-1.37l1-3a2 2 0 00-1.2-2.49z",
            fill: "currentColor"
        })
    });



const $a95bcf1c0fb70982$export$d259db434768f2a1 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.89 4.21l-4-2A1.94 1.94 0 0016 2h-.12a1.35 1.35 0 00-1.19.8 3 3 0 01-5.38 0A1.35 1.35 0 008.12 2H8a2 2 0 00-.9.21l-4 2a2 2 0 00-1 2.42l1 3a2 2 0 002.39 1.31L7 10.56V17a1 1 0 001 1 2 2 0 012 2v1a1 1 0 001 1h2a1 1 0 001-1v-1a2 2 0 012-2 1 1 0 001-1v-6.44l1.51.38a2 2 0 002.39-1.31l1-3a2 2 0 00-1.01-2.42z",
            fill: "currentColor"
        })
    });



const $ee07b88282cd06d4$export$d2a3eff8f903d303 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7.74 8h8.52a5.32 5.32 0 00-.45-6l-1.41.38a1 1 0 00-.61.49 2 2 0 01-3.58 0 1 1 0 00-.61-.49L8.19 2a5.32 5.32 0 00-.45 6zm8.66 3a3.091 3.091 0 01-.4-1H8.05a3.09 3.09 0 01-.45 1C6.12 13.09 4 16.28 4 19c0 4 16 4 16 0 0-2.72-2.12-5.91-3.6-8z",
            fill: "currentColor"
        })
    });



const $33c7220d1112c339$export$d62e0dd87c8ce667 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 9.28V5a1 1 0 00-2 0v4.28A2 2 0 0017 11a2 2 0 004 0 2 2 0 00-1-1.72zM11 11a4.5 4.5 0 10-4.5-4.5A4.51 4.51 0 0011 11zm-1-4h2a1 1 0 110 2h-2a1 1 0 010-2zm1 5a8 8 0 00-8 8 2 2 0 002 2h12a2 2 0 002-2 8 8 0 00-8-8z",
            fill: "currentColor"
        })
    });



const $48f5b2bb4869003d$export$d0ede75368534b88 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M5.05 18a.91.91 0 01-1 1h-1a1 1 0 000 2h1a2.92 2.92 0 003-3 .91.91 0 011-1 2.54 2.54 0 001.27-.32L7.66 15a2.86 2.86 0 00-2.61 3zM20.62 3.58a.611.611 0 00-.07-.14 2.824 2.824 0 00-.2-.28 1.653 1.653 0 00-.12-.16l-.06-.06-.05-.06a1.558 1.558 0 00-.2-.16 1.919 1.919 0 00-.22-.18 1.613 1.613 0 00-.28-.17c-.08 0-.16-.09-.24-.12a1.918 1.918 0 00-.31-.11l-.25-.07h-.33L18 2h-.54c-.116.023-.23.056-.34.1a1.555 1.555 0 00-.23.06 2.378 2.378 0 00-.35.19l-.18.09a2.93 2.93 0 00-.48.39l-8.59 8.63a1 1 0 000 1.42l2.83 2.83a1.001 1.001 0 001.42 0L20 7.24l.12-.12a3 3 0 00.5-3.54z",
            fill: "currentColor"
        })
    });



const $2b465ffdb14a7e64$export$7f284d63f9e4d7fe = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M9.56 13a2.59 2.59 0 00-1.76.8 2.41 2.41 0 00-.8 2.08.49.49 0 01-.19.36c-.15.13-.21.14-.54.13a2.57 2.57 0 00-2.75 2.35c-.05.33-.06.39-.21.52a1 1 0 001.3 1.52A2.579 2.579 0 005.54 19c0-.33.06-.39.21-.52s.22-.13.55-.13a2.58 2.58 0 001.86-.62c.251-.201.462-.45.62-.73a2.66 2.66 0 001.42-.76 2 2 0 00.4-2.8A1.44 1.44 0 009.56 13zM14 3a7 7 0 00-6.78 8.73A4.33 4.33 0 019.56 11 3.399 3.399 0 0112 12a3.491 3.491 0 011 3 4.49 4.49 0 01-.69 1.78A7 7 0 1014 3zm0 8.5a1.499 1.499 0 110-2.998 1.499 1.499 0 010 2.998z",
            fill: "currentColor"
        })
    });



const $6a74d25a07f3a38e$export$1d32a54febbaa99 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.44 18.65a1 1 0 010-1A10.57 10.57 0 0021 12a10.57 10.57 0 00-1.52-5.68 1 1 0 010-1l.45-.9A1 1 0 0019 3H5a1 1 0 00-.89 1.45l.45.9a1 1 0 010 1A10.57 10.57 0 003 12a10.57 10.57 0 001.52 5.68 1 1 0 010 1l-.45.9A1 1 0 005 21h14a1 1 0 00.89-1.45l-.45-.9zM8.5 7A2.5 2.5 0 0111 9.5a.5.5 0 01-.5.5A2.5 2.5 0 018 7.5a.5.5 0 01.5-.5zM15 18H9a1 1 0 110-2h6a1 1 0 010 2zm-1.5-4a.5.5 0 01-.5-.5 2.5 2.5 0 012.5-2.5.5.5 0 01.5.5 2.5 2.5 0 01-2.5 2.5z",
            fill: "currentColor"
        })
    });



const $0b09707606e310fd$export$4cbe76da45b6f323 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M5 2a1 1 0 00-1 1v19h2V3a1 1 0 00-1-1zm14.37 1.07c-2.75-1.1-5-.58-7.11-.07A14.56 14.56 0 018 3.56v12h.45a18.264 18.264 0 004.27-.56c2-.48 3.75-.89 5.91 0a.999.999 0 001.27-.49A1 1 0 0020 14V4a1 1 0 00-.63-.93z",
            fill: "currentColor"
        })
    });



const $629a4d953701c8cc$export$461aadfd147fed8f = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M11.73 2.77l-.52-.48a1 1 0 00-1.7.87 7.91 7.91 0 01-.9 4.52A14.999 14.999 0 017 10a7.55 7.55 0 00-2 5 6.86 6.86 0 007 7 6.858 6.858 0 007-7c0-5.74-5.28-10.46-7.27-12.23zM12 20a2.43 2.43 0 01-1.81-4.12 3.2 3.2 0 00.51-.83 5.51 5.51 0 00.3-1.55.5.5 0 01.31-.46.47.47 0 01.54.11l.17.15c.68.6 2.48 2.21 2.48 4.2A2.45 2.45 0 0112 20z",
            fill: "currentColor"
        })
    });



const $7b01447d1c4f6492$export$bb4c21b28e775606 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 11c3.87 0 7-1.34 7-3 0-.94-1-1.78-2.58-2.33a4.5 4.5 0 00-8.84 0C6 6.22 5 7.06 5 8c0 1.66 3.13 3 7 3zm0-7a1 1 0 110 2 1 1 0 010-2zm2.47 8.39l-1.9 1.41a1 1 0 01-1.2 0l-1.88-1.39A8 8 0 004 20a2 2 0 002 2h12a2 2 0 002-2 8 8 0 00-5.53-7.61zM16 20a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $8a730e6673b6d521$export$9eb19feb7c84c58a = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 11c3.87 0 7-1.34 7-3 0-.94-1-1.78-2.58-2.33a4.5 4.5 0 00-8.84 0C6 6.22 5 7.06 5 8c0 1.66 3.13 3 7 3zm0-7a1 1 0 110 2 1 1 0 010-2zm2.47 8.39l-1.9 1.41a1 1 0 01-1.2 0l-1.88-1.39A8 8 0 004 20a2 2 0 002 2h12a2 2 0 002-2 8 8 0 00-5.53-7.61zM17 18.5a.469.469 0 01-.15.35l-1 1a.48.48 0 01-.7 0l-1-1a.47.47 0 01-.15-.35v-2a.5.5 0 01.5-.5h2a.5.5 0 01.5.5v2z",
            fill: "currentColor"
        })
    });



const $acc83cff4e6c0bed$export$df3bdca41094d7a4 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 11c3.87 0 7-1.34 7-3 0-.94-1-1.78-2.58-2.33a4.5 4.5 0 00-8.84 0C6 6.22 5 7.06 5 8c0 1.66 3.13 3 7 3zm0-7a1 1 0 110 2 1 1 0 010-2zm2.47 8.39l-1.9 1.41a1 1 0 01-1.2 0l-1.88-1.39A8 8 0 004 20a2 2 0 002 2h12a2 2 0 002-2 8 8 0 00-5.53-7.61zM9 20H7a1 1 0 010-2h2a1 1 0 010 2zm7 0a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $a65080afd8e4799d$export$dc48e81c603288d7 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 19h-2a1 1 0 000 2h2a1 1 0 000-2zm-9 0H6a1 1 0 000 2h2a1 1 0 000-2zm11.77-4.85l-4.23-1.81L17.68 7H19a1 1 0 00.89-.55l1-2a1 1 0 00-1.78-.9L18.38 5H15a1 1 0 100 2h.52l-1.82 4.55-4.93-2.1a4.54 4.54 0 00-1.1-.34L6.62 7H8a1 1 0 000-2H4a1 1 0 100 2h.38l1.16 2.31a3.87 3.87 0 00-1.37.86 4 4 0 000 5.66A4 4 0 006.71 17h.12l12 1H19a2 2 0 00.77-3.85zM7 14.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3z",
            fill: "currentColor"
        })
    });



const $4240eb8398cb2939$export$827304f2a41fb7eb = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M3 14a1 1 0 00-.71.28A1 1 0 002 15v1a1 1 0 002 0v-1a1 1 0 00-.29-.68A1 1 0 003 14zm0-5a1 1 0 00.71-.28A1 1 0 004 8V7a1 1 0 00-2 0v1a1 1 0 00.29.68A1 1 0 003 9zm15 10A1 1 0 1018 21 1 1 0 0018 19zm-3-3A1 1 0 1015 18 1 1 0 0015 16zm6.81-10.58a1 1 0 00-.49-.37.94.94 0 00-.62 0 1 1 0 00-.5.35l-2.2 3h-2.2l-1.65-1.69a3.82 3.82 0 00-3.92-.94 3.62 3.62 0 00-2.45 2.61h-.06a3.25 3.25 0 00-3.08 2.24H3a1 1 0 00-.71.29 1.05 1.05 0 00-.29.71 1 1 0 00.29.71 1 1 0 00.71.29h1.64a3.32 3.32 0 001.21 1.64 3.25 3.25 0 002 .61l13.28-1.12a1 1 0 00.92-1V6a.94.94 0 00-.24-.58zm-11.9 3c.22-.34.553-.591.94-.71a1.89 1.89 0 011 0c.333.078.638.247.88.49l.25.26-3.07-.04z",
            fill: "currentColor"
        })
    });



const $1be18e2168f803ec$export$eef7c56f035e4236 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 15a7.55 7.55 0 00-5 1.81v-2a2.87 2.87 0 01-2 0v2A7.55 7.55 0 006 15a1 1 0 00-1 1c0 3.31 3.14 6 7 6s7-2.69 7-6a1 1 0 00-1-1zM6.8 11a2 2 0 002.74.73l.46-.27V12a2 2 0 004 0v-.54l.46.27A2.001 2.001 0 0017.2 11a1.999 1.999 0 00-.74-2.73L16 8l.46-.27a2 2 0 10-2-3.46l-.46.27V4a2 2 0 10-4 0v.54l-.46-.27a2 2 0 10-2 3.46L8 8l-.46.27A2 2 0 006.8 11zM12 6.5a1.5 1.5 0 110 3 1.5 1.5 0 010-3z",
            fill: "currentColor"
        })
    });



const $21d3298a3bea3534$export$15527a65aee6fca9 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.44 8.38c.03-.21.06-.42.06-.63C19.5 5.13 17.37 3 14.75 3c-1.64 0-3.08.83-3.93 2.09A3.68 3.68 0 0010 5a3.98 3.98 0 00-3.86 3.01C6.09 8.01 6.05 8 6 8c-1.66 0-3 1.34-3 3s1.34 3 3 3h12c1.66 0 3-1.34 3-3 0-1.13-.64-2.11-1.56-2.62zM12 17c-.97 0-1.75.78-1.75 1.75s.78 1.75 1.75 1.75 1.75-.78 1.75-1.75S12.97 17 12 17zm5-1.5c-.97 0-1.75.78-1.75 1.75S16.03 19 17 19s1.75-.78 1.75-1.75-.78-1.75-1.75-1.75zm-10 0c-.97 0-1.75.78-1.75 1.75S6.03 19 7 19s1.75-.78 1.75-1.75S7.97 15.5 7 15.5z",
            fill: "currentColor"
        })
    });



const $be4b293c592ccc5d$export$b3a776660e7d6381 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21 13H3c-.55 0-1 .45-1 1s.45 1 1 1h18c.55 0 1-.45 1-1s-.45-1-1-1zm-5 4c0-.55-.45-1-1-1H4.5c-.55 0-1 .45-1 1s.45 1 1 1H15c.55 0 1-.45 1-1zm3 2h-8c-.55 0-1 .45-1 1s.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1zm2.06-8c.58-.6.95-1.42.95-2.33 0-1.49-.97-2.73-2.3-3.16-.43-2-2.19-3.51-4.3-3.51-1.65 0-3.07.93-3.82 2.28-.19-.03-.38-.06-.58-.06-1.82 0-3.3 1.49-3.3 3.33-1.22 0-2.2.99-2.2 2.22 0 .45.14.87.36 1.22h15.19V11z",
            fill: "currentColor"
        })
    });



const $43139793329877ba$export$5437d3f9189fc995 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M14.71 8.71A1 1 0 0014 7h-2.72l.5-2H13a1 1 0 100-2h-1.22a2 2 0 00-1.23.43 2 2 0 00-.71 1.09L9.22 7H4a1 1 0 000 2h10a1 1 0 00.71-.29zM9 16a7.05 7.05 0 012.1-5H4.3l.7 9.08a1 1 0 00.32.66A1 1 0 006 21h5.11A7.05 7.05 0 019 16zm11.45-2.27a5 5 0 00-2.71-2.41 3.1 3.1 0 001.26-.76A3.86 3.86 0 0020 8a.51.51 0 00-.49-.49 3.38 3.38 0 00-1.37.23 3.34 3.34 0 00-1.14.8 3.71 3.71 0 00-.94 2.46 5 5 0 00-1 9.91 5 5 0 005.74-3.57 5.07 5.07 0 00-.34-3.61h-.01z",
            fill: "currentColor"
        })
    });



const $58c8bf3d7e60ba36$export$729a7eabd209d3c2 = (m)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...m,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zM5.21 9.78l-1.06.66a8 8 0 01.63-1.86l.43 1.2zm1.36 1.52l1.43.42.93 2.86-.84 1.2-3 .1a7.93 7.93 0 01-1-3l2.48-1.58zm1.24 6.49L8.1 19a8.379 8.379 0 01-1.56-1.15l1.27-.06zm8.42 0l1.17.08A7.6 7.6 0 0115.88 19l.35-1.21zm-.2-2l-.91-1.23.93-2.84 1.39-.45 2.5 1.7a8.1 8.1 0 01-1 3l-2.91-.18zm2.8-6l.45-1.09c.261.568.453 1.166.57 1.78l-1.02-.69zM18 6.67l-1.1 2.68-1.49.48L13 8.12V6.61l2.39-1.85A8.14 8.14 0 0118 6.67zm-5-2.6l-1 .77-.93-.79c.309-.033.62-.05.93-.05a8.42 8.42 0 011 .07zm-4.25.63L11 6.59v1.53L8.63 9.84 7.2 9.4l-1-2.86A8 8 0 018.75 4.7zm1.62 15.13L9.67 17l.83-1.2h3l.86 1.17-.85 2.91a8 8 0 01-3.18 0l.04-.05z",
            fill: "currentColor"
        })
    });



const $36bff45c3b3ab742$export$6a714f23f799b057 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10 3a1.06 1.06 0 00-1 1.11V11H8V4a1 1 0 00-.29-.71A1.05 1.05 0 007 3a1 1 0 00-.71.29A1 1 0 006 4v7H5V4.11a1.11 1.11 0 00-.27-.76A1.08 1.08 0 004 3a1.06 1.06 0 00-1 1.11V12a1 1 0 00.29.71A1 1 0 004 13h2v7a1 1 0 00.29.71A1 1 0 007 21a1.05 1.05 0 00.71-.29A.999.999 0 008 20v-7h2a1.05 1.05 0 00.71-.29A.998.998 0 0011 12V4.11a1.11 1.11 0 00-.27-.76A1.08 1.08 0 0010 3zm7 0c-2.21 0-4 2.46-4 5.5 0 2.56 1.28 4.71 3 5.32V20a1 1 0 002 0v-6.18c1.72-.61 3-2.76 3-5.32C21 5.46 19.21 3 17 3z",
            fill: "currentColor"
        })
    });



const $1e6ee4005d63e551$export$8dbb97dcc6cbaac8 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10.5 15c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm7.5.5c-.5 0-1.5 1.67-1.5 2.5 0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5-1-2.5-1.5-2.5zM6.5 17C6 17 5 18.67 5 19.5c0 .83.67 1.5 1.5 1.5S8 20.33 8 19.5 7 17 6.5 17zm7.5 2c-.83 0-1.5.67-1.5 1.5S13.17 22 14 22s1.5-.67 1.5-1.5S14.83 19 14 19zm5.44-10.62c.03-.21.06-.42.06-.63C19.5 5.13 17.37 3 14.75 3c-1.64 0-3.08.83-3.93 2.09A3.68 3.68 0 0010 5a3.98 3.98 0 00-3.86 3.01C6.09 8.01 6.05 8 6 8c-1.66 0-3 1.34-3 3s1.34 3 3 3h12c1.66 0 3-1.34 3-3 0-1.13-.64-2.11-1.56-2.62z",
            fill: "currentColor"
        })
    });



const $172eac253783874f$export$68358bc1d5577e68 = (s)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...s,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.44 8.38c.03-.21.06-.42.06-.63C19.5 5.13 17.37 3 14.75 3c-1.64 0-3.08.83-3.93 2.09A3.68 3.68 0 0010 5a3.98 3.98 0 00-3.86 3.01C6.09 8.01 6.05 8 6 8c-1.66 0-3 1.34-3 3s1.34 3 3 3h12c1.66 0 3-1.34 3-3 0-1.13-.64-2.11-1.56-2.62zm-8.94 7.25c-.48-.28-1.09-.11-1.37.37l-2 3.46c-.28.48-.11 1.09.37 1.37s1.09.11 1.37-.37l2-3.46c.28-.48.11-1.09-.37-1.37zm4 0c-.48-.28-1.09-.11-1.37.37l-2 3.46c-.28.48-.11 1.09.37 1.37s1.09.11 1.37-.37l2-3.46c.28-.48.11-1.09-.37-1.37zm-9-.13c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5S7 17.83 7 17s-.67-1.5-1.5-1.5zm12 0c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5S19 17.83 19 17s-.67-1.5-1.5-1.5z",
            fill: "currentColor"
        })
    });



const $ece92248913a3db1$export$10c72c3bbcfd2e41 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.12 7.71l-2.41-2.42a1.003 1.003 0 10-1.42 1.42l1.49 1.48A1.5 1.5 0 0018.5 11c.17-.004.339-.034.5-.09V18a1 1 0 01-2 0v-2a3 3 0 00-3-3h-1V6a3 3 0 00-3-3H6a3 3 0 00-3 3v14a1 1 0 001 1h8a1 1 0 001-1v-5h1a1 1 0 011 1v2a3 3 0 006 0V9.83a3 3 0 00-.88-2.12zM11 9a1 1 0 01-1 1H6a1 1 0 01-1-1V7a1 1 0 011-1h4a1 1 0 011 1v2z",
            fill: "currentColor"
        })
    });



const $a23a1d6f3abe3ccf$export$ba310394403eda57 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.19 7.77a5.979 5.979 0 00-4.23-1.75H7.98a5.979 5.979 0 00-4.23 10.21 5.979 5.979 0 004.23 1.75c1.17 0 2.3-.35 3.27-1h1.44c.97.65 2.11.99 3.27 1a5.979 5.979 0 004.23-10.21zM6.61 12.25c-.03.08-.08.16-.15.22-.06.06-.14.11-.22.15-.08.03-.17.05-.26.05s-.18-.02-.26-.05a.541.541 0 01-.22-.15l-1.35-1.35A.855.855 0 014 10.9a.751.751 0 01-.05-.26c0-.09.02-.18.05-.26.03-.08.08-.16.15-.22L5.5 8.81a.673.673 0 01.96 0 .673.673 0 010 .96l-.88.87.88.87c.06.06.11.14.15.22.03.08.05.17.05.26s-.02.18-.05.26zm4.3 1.37c-.03.08-.08.16-.15.22l-1.35 1.35c-.06.06-.14.11-.22.15-.08.04-.17.05-.26.05s-.18-.02-.26-.05a.541.541 0 01-.22-.15.855.855 0 01-.15-.22.751.751 0 01-.05-.26c0-.09.02-.18.05-.26.03-.08.08-.16.15-.22l.88-.87-.88-.87a.855.855 0 01-.15-.22.751.751 0 01-.05-.26c0-.09.02-.18.05-.26.03-.08.08-.16.15-.22.06-.06.14-.11.22-.15.08-.03.17-.05.26-.05s.18.02.26.05c.08.03.16.08.22.15l1.35 1.35c.06.06.11.14.15.22.03.08.05.17.05.26s-.02.18-.05.26zm5.52-5.21a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zm-2.33 4.84a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5zm2.33 2.34a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5zm2.34-2.34a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5z",
            fill: "currentColor"
        })
    });



const $bde9d680b2c8431c$export$5ac6ca114d0dc06b = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 8h-3a3 3 0 00-3-3 1 1 0 01-1-1 1 1 0 00-2 0 3 3 0 003 3 1 1 0 011 1H8a6 6 0 100 12 5.93 5.93 0 003.28-1h1.44A5.93 5.93 0 0016 20a6 6 0 100-12zm-7 7H8v1a1 1 0 11-2 0v-1H5a1 1 0 010-2h1v-1a1 1 0 112 0v1h1a1 1 0 010 2zm7.07-3.38c.056-.12.13-.232.22-.33a1 1 0 011.09-.21c.061.02.119.05.17.09.057.035.11.075.16.12a1 1 0 01.21.33 1 1 0 01-.21 1.09 1.15 1.15 0 01-.33.21.94.94 0 01-.76 0 1 1 0 01-.33-.21 1 1 0 01-.22-1.09zm-.36 3.09a1.15 1.15 0 01-.33.21.94.94 0 01-.76 0 1 1 0 01-.33-.21A1 1 0 0114 14a1 1 0 112 0 1 1 0 01-.29.71zm2.21 1.67a1.15 1.15 0 01-.21.33.999.999 0 01-1.09.21 1 1 0 01-.33-.21 1 1 0 01-.22-1.09c.056-.12.13-.232.22-.33a.999.999 0 011.09-.21c.121.05.233.122.33.21a1 1 0 01.21.33.94.94 0 010 .76zm1.78-1.67a1 1 0 01-1.41-1.42l.15-.12a.762.762 0 01.18-.09.639.639 0 01.18-.08 1 1 0 011.125.604c.052.126.077.26.075.396a1 1 0 01-.3.71z",
            fill: "currentColor"
        })
    });



const $66e020c23d138167$export$3dceeab59b953c79 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M22 16.51A5.15 5.15 0 0016.78 12H13v-1a1 1 0 011-1h1.88a3.08 3.08 0 003.06-2.4A3 3 0 0016 4h-2a1 1 0 01-1-1 1.05 1.05 0 00-.29-.71A.999.999 0 0011 3a3 3 0 003 3h2a1 1 0 110 2h-2a3 3 0 00-3 3v1H7.22A5.15 5.15 0 002 16.51a5 5 0 008.66 3.85 1 1 0 01.77-.36h1.1a1 1 0 01.77.36 5 5 0 008.7-3.85zM9 18H8v1a1 1 0 11-2 0v-1H5a1 1 0 110-2h1v-1a1 1 0 012 0v1h1a1 1 0 010 2zm8-4a1 1 0 110 2 1 1 0 010-2zm-2 4A1 1 0 1115 16 1 1 0 0115 18zm2 2A1 1 0 1117 18 1 1 0 0117 20zm2-2A1 1 0 1119 16 1 1 0 0119 18z",
            fill: "currentColor"
        })
    });



const $e53736864aa05262$export$2945b7c1f85c73cd = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7 10h10a2 2 0 100-4 4 4 0 00-7.49-1.92A1.7 1.7 0 009 4a2 2 0 00-2 2 2 2 0 100 4zm15 6.51A5.15 5.15 0 0016.78 12H7.22A5.15 5.15 0 002 16.51a5 5 0 008.66 3.85 1 1 0 01.77-.36h1.1a1 1 0 01.77.36 5 5 0 008.7-3.85zM9 18H8v1a1 1 0 11-2 0v-1H5a1 1 0 010-2h1v-1a1 1 0 112 0v1h1a1 1 0 110 2zm8-4a1 1 0 110 2 1 1 0 010-2zm-2 4a1 1 0 110-2 1 1 0 010 2zm2 2a1 1 0 110-2 1 1 0 010 2zm2-2a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $df0197f881587c3f$export$4a93a4426a5919c4 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7 5.13a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm-2 5h4a1 1 0 001-1 3 3 0 10-6 0 1 1 0 001 1zm17 6.38A5.15 5.15 0 0016.78 12H13v-1a1 1 0 011-1h1.88a3.08 3.08 0 003.06-2.4A3 3 0 0016 4h-2a1 1 0 01-1-1 1.05 1.05 0 00-.29-.71A.999.999 0 0011 3a3 3 0 003 3h2a1 1 0 110 2h-2a3 3 0 00-3 3v1H7.22A5.15 5.15 0 002 16.51a5 5 0 008.66 3.85 1 1 0 01.77-.36h1.1a1 1 0 01.77.36 5 5 0 008.7-3.85zM9 18H8v1a1 1 0 11-2 0v-1H5a1 1 0 110-2h1v-1a1 1 0 012 0v1h1a1 1 0 010 2zm8-4a1 1 0 110 2 1 1 0 010-2zm-2 4A1 1 0 1115 16 1 1 0 0115 18zm2 2A1 1 0 1117 18 1 1 0 0117 20zm2-2A1 1 0 1119 16 1 1 0 0119 18z",
            fill: "currentColor"
        })
    });



const $1f65d042944ac60d$export$aa90dfbc7b6a4c9e = (v)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...v,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M13 9c0-2.76-3-6-5-6S3 6.24 3 9v3a1 1 0 001 1h3v2.28A2 2 0 006 17v2a2 2 0 004 0v-2a2 2 0 00-1-1.72V13h3a1 1 0 001-1V9zm5 4v-2.28A2 2 0 0019 9V5a2 2 0 10-4 0v4a2 2 0 001 1.72V13a3 3 0 00-3 3v4a1 1 0 002 0v-4a1 1 0 011-1v5a1 1 0 002 0v-5a1 1 0 011 1v4a1 1 0 002 0v-4a3 3 0 00-3-3z",
            fill: "currentColor"
        })
    });



const $403f5ac53c59cbfb$export$f66ff26eccc40741 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 6V4a1 1 0 100-2H8a1 1 0 000 2v2a3 3 0 00-3 3v8a3 3 0 002 2.82A1.1 1.1 0 007 20a2 2 0 002 2h6a2 2 0 002-2c.005-.06.005-.12 0-.18A3 3 0 0019 17V9a3 3 0 00-3-3zm-3 0h-2a1 1 0 110-2h2a1 1 0 110 2z",
            fill: "currentColor"
        })
    });



const $fde124287abbd252$export$ad0d81716a3a0c6a = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21 9a1 1 0 00-1 1h-3.54A6 6 0 0013 8.09V6h1a1 1 0 100-2h-4a1 1 0 000 2h1v2.09A6 6 0 007.54 10H4a1 1 0 00-2 0v8a1 1 0 102 0h3.54a6 6 0 008.92 0H20a1 1 0 002 0v-8a1 1 0 00-1-1zm-9 6.5a1.5 1.5 0 01-1.5-1.5v-.08l-1.21-1.21a1.004 1.004 0 011.42-1.42l1.21 1.22H12a1.5 1.5 0 110 3v-.01z",
            fill: "currentColor"
        })
    });



const $c89eb713180bddcd$export$c7e22917b000ab3f = (s)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...s,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15 3H7C4.79 3 3 4.79 3 7s1.79 4 4 4h4c.55 0 1 .45 1 1s-.45 1-1 1c-1.65 0-3 1.35-3 3 0 .35.07.69.18 1H7c-.55 0-1 .45-1 1s.45 1 1 1h6v2c0 .55.45 1 1 1s1-.45 1-1v-2c0-1.1-.9-2-2-2h-2c-.55 0-1-.45-1-1s.45-1 1-1h4c3.31 0 6-2.69 6-6s-2.69-6-6-6z",
            fill: "currentColor"
        })
    });



const $a768b1cc16c57679$export$77a3ac64dca0440 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4 14h.11l2.38-.26a.93.93 0 00.6-.29l6.62-6.61a1.001 1.001 0 000-1.42l-2.12-2.13a1 1 0 00-1.42 0L3.56 9.91a.93.93 0 00-.29.6L3 12.89A1 1 0 004 14zM20.38 3.08a1 1 0 00-1.09.21l-16 16a1 1 0 00-.21 1.09A1 1 0 004 21h16a1 1 0 001-1V4a1 1 0 00-.62-.92zM17 16a1 1 0 01-1 1h-3a.999.999 0 01-.92-.62 1 1 0 01.21-1.09l3-3a1 1 0 011.09-.21A1 1 0 0117 13v3z",
            fill: "currentColor"
        })
    });



const $63936740cfbee9c4$export$63d1186579b07cfc = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a8 8 0 00-8 8v9.82a.94.94 0 001 .95.88.88 0 00.73-.37l.24-.31a1 1 0 01.74-.37.93.93 0 01.77.41l1 1.42a1 1 0 00.79.41.92.92 0 00.73-.35l1.3-1.58a.909.909 0 01.73-.34.94.94 0 01.76.4l1 1.47a.93.93 0 00.77.4.92.92 0 00.73-.35L16.55 20a1.001 1.001 0 01.73-.35.9.9 0 01.74.37l.29.38a.91.91 0 00.74.37.94.94 0 00.95-.95V10a8 8 0 00-8-8zM8.71 12.16a2.51 2.51 0 11-.02-5.02 2.51 2.51 0 01.02 5.02zm6.57 0a2.51 2.51 0 11-.02-5.02 2.51 2.51 0 01.02 5.02z",
            fill: "currentColor"
        })
    });



const $e5227be92ff3493c$export$fd02767896f34761 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 7a6.5 6.5 0 00-6.5 6.5v.5h4.06a.51.51 0 11.2 1L5.5 16.79v2.7A2 2 0 008 21.43l8.22-1.89a3.001 3.001 0 002.33-2.93V13.5A6.498 6.498 0 0012 7zm9.84 3.26A10 10 0 003 7.72 1 1 0 003.26 9l.58.45a1 1 0 001.45-.26 8 8 0 017.53-3.62 8.08 8.08 0 017 6.5c.195 1.3.255 2.617.18 3.93a2.87 2.87 0 001.83-2.18 9.669 9.669 0 00.01-3.56z",
            fill: "currentColor"
        })
    });



const $3985e595ac29fdb8$export$4fadcbf47cabd6ca = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12.21 5.62s-.05-.07-.09-.09A.266.266 0 0012 5.5c-.04 0-.08.01-.12.03-.04.02-.07.05-.09.09L10.61 7.6c-.21.35-.32.74-.32 1.15 0 .46.18.91.5 1.24a1.665 1.665 0 002.4 0c.32-.33.5-.77.5-1.24 0-.41-.11-.8-.32-1.15l-1.18-1.98h.02zM16.48 2H7.53C6.69 2 6 2.68 6 3.53V10c0 2.62 1.69 4.85 4.03 5.66A2 2 0 0112 14c.99 0 1.8.72 1.97 1.66A5.984 5.984 0 0018 10V3.53C18 2.69 17.32 2 16.47 2h.01zm-.47 8.9c0 .61-.49 1.1-1.1 1.1H9.12c-.61 0-1.1-.49-1.1-1.1V5.11c0-.61.49-1.1 1.1-1.1h5.79c.61 0 1.1.49 1.1 1.1v5.79zm-4 4.1c-.55 0-1 .45-1 1v5c0 .55.45 1 1 1s1-.45 1-1v-5c0-.55-.45-1-1-1z",
            fill: "currentColor"
        })
    });



const $49f3af6e71d68f01$export$8b3aac5713023307 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18.71 11.71a1.002 1.002 0 01-1.42 0L16 10.41l-1.29 1.3a1.002 1.002 0 01-1.42 0L12 10.41l-1.29 1.3a1.002 1.002 0 01-1.42 0L8 10.41l-1.29 1.3a1 1 0 01-1.42 0L4 10.41V20a2 2 0 002 2h12a2 2 0 002-2v-9.59l-1.29 1.3zm-2-3.42L18 9.59l1-1V3a1 1 0 00-1-1h-2a1 1 0 00-1 1v5.59l.29-.3a1 1 0 011.42 0zm-9.42 0a1 1 0 011.42 0L10 9.59l1.29-1.3a1 1 0 011.42 0l.29.3V6a4 4 0 10-8 0v2.59l1 1 1.29-1.3z",
            fill: "currentColor"
        })
    });



const $e9d10b11cdf40ca4$export$5102574c1636a62 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 15H5a1 1 0 00-1 1v1a1 1 0 00.45.83l2.24 1.5a4 4 0 002.22.67h6.18a4 4 0 002.22-.67l2.24-1.5A1 1 0 0020 17v-1a1 1 0 00-1-1zm2.86-6.73a2 2 0 00-1.16-1.14l-8-3a2 2 0 00-1.4 0l-8 3a2 2 0 00-1.09 2.76l1 2A2 2 0 005 13h14a2 2 0 001.79-1.11l1-2a2 2 0 00.07-1.62zm-8.36.23a1.5 1.5 0 01-3 0V8a1 1 0 011-1h1a1 1 0 011 1v.5z",
            fill: "currentColor"
        })
    });



const $ad3abf98c9e1d6cd$export$74c1b266c9f4c5d9 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7.25 15.5a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zm-1.5 3a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zm6.5-3a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zm-1.5 3a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zm6.5-3a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zm-1.5 3a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zm3.69-10.12c.03-.21.06-.42.06-.63C19.5 5.13 17.37 3 14.75 3c-1.64 0-3.08.83-3.93 2.09A3.68 3.68 0 0010 5a3.98 3.98 0 00-3.86 3.01C6.09 8.01 6.05 8 6 8c-1.66 0-3 1.34-3 3s1.34 3 3 3h12c1.66 0 3-1.34 3-3 0-1.13-.64-2.11-1.56-2.62z",
            fill: "currentColor"
        })
    });



const $36c01fa1b596ed8f$export$663a8373f8f15dc1 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.58 6.19a1 1 0 00-.9-.14l-4.22 1.41-.46 3.66a.999.999 0 01-.15.42l3.52-1A3.69 3.69 0 0022 7a1 1 0 00-.42-.81zm-8.8 9.06l.27-2.65 1.4-.71a1 1 0 00.54-.77l1-8A1 1 0 0015 2a3.19 3.19 0 00-3.19 2.89l-.6 5.91-2.77.81A3.49 3.49 0 109 13.53l2-.59-.21 2.13a3.52 3.52 0 102 .18h-.01zM5.5 15a1.5 1.5 0 110-2.999A1.5 1.5 0 015.5 15zm6 5a1.5 1.5 0 110-2.999 1.5 1.5 0 010 2.999z",
            fill: "currentColor"
        })
    });



const $6f72cbb755034692$export$dff8cac5d11fb0f7 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M9.84 15.08l.18.16a2.69 2.69 0 001.86.76H12a3 3 0 002.92-2.33c.049-.22.076-.444.08-.67 0-.201-.02-.402-.06-.6a7.887 7.887 0 00-.47-1.4 4.64 4.64 0 01.24-4.78c.36-.55.74-1.08 1.1-1.6a1 1 0 00-1.59-1.2A14.822 14.822 0 0013.08 5C11.44 7.41 9 11.27 9 12.86V13a3 3 0 00.84 2.08zM20 11h-3.42A5 5 0 117 13c0-.689.142-1.37.42-2H4a2 2 0 00-2 2v5a2 2 0 002 2h16a2 2 0 002-2v-5a2 2 0 00-2-2z",
            fill: "currentColor"
        })
    });



const $4fe12c31bdbb91ae$export$28c3d7eeaba712b3 = (v)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...v,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M9.84 14.08c.05.06.12.11.17.16.5.47 1.15.76 1.86.76h.12c1.43 0 2.62-1 2.92-2.33v-.03c.04-.21.07-.42.07-.64 0-.2-.02-.4-.06-.6v-.02c-.1-.49-.28-.96-.47-1.42-.51-1.27-1.03-2.57.23-4.79.37-.54.74-1.08 1.11-1.6.31-.44.22-1.05-.21-1.38a.994.994 0 00-1.38.17 13.4 13.4 0 00-1.13 1.62c-1.64 2.41-4.08 6.27-4.08 7.86v.14c0 .81.32 1.54.84 2.08l.01.02zM7 12v-.14c0-.38 0-1.12.8-2.86H4c-1.1 0-2 .9-2 2v2h5.11c-.07-.33-.11-.66-.11-1zm13-3h-3.76c.03.07.06.14.09.22.23.56.44 1.12.56 1.72v.04l.02.03v.03c.07.34.1.65.1.96 0 .32-.04.66-.11 1h5.11v-2c0-1.1-.9-2-2-2H20zm-7.98 8h-.14c-1.18 0-2.32-.46-3.21-1.29-.02-.02-.05-.04-.07-.06l-.04-.03-.13-.13-.1-.1-.02-.03c-.1-.11-.18-.23-.26-.35H2v2c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-2h-6.02a4.962 4.962 0 01-3.96 2V17z",
            fill: "currentColor"
        })
    });



const $ca3a229af81505de$export$3b7a117924a2fdbc = (v)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...v,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10.21 11.99c.01.06.04.12.06.18.18.51.52.93 1 1.12.01 0 .03.01.04.02.01 0 .03.01.04.02.96.39 2.08-.09 2.72-1.08v-.02c.1-.16.18-.32.26-.5.07-.16.12-.33.16-.5v-.02c.1-.42.13-.85.16-1.27.08-1.16.15-2.35 1.73-3.79.43-.33.85-.67 1.27-.98.35-.27.49-.78.31-1.17-.18-.38-.62-.49-.98-.24-.5.33-.92.67-1.29.99-1.89 1.49-4.79 3.93-5.31 5.21 0 .02-.02.04-.02.06 0 .02-.02.04-.02.06a2.86 2.86 0 00-.12 1.9V12l-.01-.01zm-1.9 2.15v-.12c0-.33 0-.97.69-2.47H5.72c-.95 0-1.73.78-1.73 1.73v1.73h4.42c-.06-.29-.1-.57-.1-.86v-.01zm9.93-2.67h-3.33c.03.06.05.12.08.19.2.49.39.99.49 1.52v.04l.02.03v.03c.06.3.09.57.09.85s-.04.58-.1.88H20v-1.77c0-.97-.79-1.77-1.77-1.77h.01zM12.02 18l-.11-.01c-.94 0-1.86-.46-2.57-1.29l-.06-.06-.03-.03-.1-.13-.08-.1-.02-.03c-.08-.11-.14-.23-.21-.35H4v2c0 1.1.72 2 1.6 2h12.8c.88 0 1.6-.9 1.6-2v-2h-4.82c-.73 1.22-1.88 1.99-3.17 2h.01z",
            fill: "currentColor"
        })
    });



const $a07b799fe4c76341$export$432d0108df49ba8 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 6a1 1 0 100-2 1 1 0 000 2zm-6 3a1 1 0 100-2 1 1 0 000 2zm-8.08-.92c.367.36.817.625 1.31.77a3.09 3.09 0 002.12-.08 3.13 3.13 0 001.59-1.41.63.63 0 00.06-.27.62.62 0 00-.09-.27.63.63 0 00-.22-.18.57.57 0 00-.29 0 2.76 2.76 0 01-2.86-1.92 2.54 2.54 0 01-.14-1.13.47.47 0 00-.05-.28.55.55 0 00-.18-.22A.62.62 0 004.9 3a.43.43 0 00-.27.06 3.13 3.13 0 00-1.48 3.71c.145.494.41.944.77 1.31zM19.72 15H20a1 1 0 001-1.07 1.05 1.05 0 00-.35-.69.999.999 0 00-.34-.19l-2.06-.68.7-2a.999.999 0 00-.06-.77 1 1 0 00-1.34-.45 1 1 0 00-.51.58l-.68 2.06-2.06-.69a1 1 0 00-.39 0 1.001 1.001 0 00-.38.1 1.06 1.06 0 00-.5.58 1 1 0 00.06.77c.124.233.331.411.58.5l2 .68-1.25 3.76a3.84 3.84 0 00-3.95.34l-.9-2.11L11.3 15a1 1 0 00.55-.54 1 1 0 00-.52-1.31 1 1 0 00-.77 0l-1.78.71L8 11.61a1.08 1.08 0 00-.21-.34 1.23 1.23 0 00-.35-.27 1 1 0 00-1.12.23 1 1 0 00-.21.34A1 1 0 006 12c.008.135.042.268.1.39l.9 2.14-1.36.54a.93.93 0 00-.33.21.87.87 0 00-.22.32.91.91 0 000 .77 1 1 0 00.36.45A.94.94 0 006 17a1 1 0 00.37-.07l1.41-.57L8.5 18h-.06a3.06 3.06 0 00-1.39.33 2.94 2.94 0 00-1.05.94 2 2 0 00-2.91 1.11.51.51 0 00.1.43.39.39 0 00.17.14.59.59 0 00.22.05h16.9a.44.44 0 00.22-.05.49.49 0 00.18-.14.539.539 0 00.1-.2.59.59 0 000-.23 2 2 0 00-.75-1A2 2 0 0019 19a2 2 0 00-.69.12A3 3 0 0016.4 18l1.26-3.78 2.06.78z",
            fill: "currentColor"
        })
    });



const $36cac2306771a329$export$328c14297e555104 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.71 11.29l-.71-.7a2 2 0 00-1.41-.59H19a3 3 0 00-.7-3.12l-3.59-3.59a3.84 3.84 0 00-5.42 0 1 1 0 000 1.42l1 1a1.811 1.811 0 010 2.58 1.001 1.001 0 000 1.42l2.59 2.58A3 3 0 0016 13v.6a2 2 0 00.59 1.4l.7.71a1.002 1.002 0 001.42 0l3-3a1.002 1.002 0 000-1.42zm-12.26.4l-5.86 5.85A2 2 0 004.75 21H5a2 2 0 001.49-.66l5.56-6.11a6.108 6.108 0 01-.62-.52l-1.98-2.02z",
            fill: "currentColor"
        })
    });



const $b8f3abcb4c7ec1eb$export$cd8cff056806450b = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.55 9.59a2 2 0 00-2-1.83h-1.5v-.71a4.05 4.05 0 00-8.1 0v.71H6.44a2 2 0 00-2 1.83l-.69 8.16a3 3 0 003 3.25h10.5a3 3 0 003-3.25l-.7-8.16zm-5.5-1.83H10v-.71a2.05 2.05 0 114.1 0l-.05.71z",
            fill: "currentColor"
        })
    });



const $950af54543ffd970$export$fa316100b437fe1f = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15 8V7a1 1 0 00-1-1h-1V4h.51a2 2 0 01.64.1l2.53.9c.106.014.214.014.32 0a1 1 0 001.05-1.068 1 1 0 00-.68-.882l-2.54-.84A3.93 3.93 0 0013.51 2H9a1 1 0 000 2h2v2h-1a1 1 0 00-1 1v1a3 3 0 00-3 3v8a3 3 0 003 3h6a3 3 0 003-3v-8a3 3 0 00-3-3z",
            fill: "currentColor"
        })
    });



const $ba93c2a02d10bf15$export$7e9a60d3fe23c257 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16.5 2a5.49 5.49 0 00-4.89 3H11a1 1 0 00-1 1v.5h-.5a3 3 0 00-3 3v.5H6a1 1 0 00-1 1v.61a5.5 5.5 0 105 0V11a1 1 0 00-1-1h-.5v-.5a1 1 0 011-1h.5V9a1 1 0 001 1h.61a5.5 5.5 0 104.89-8zM11 16.5a3.5 3.5 0 11-7 0 3.5 3.5 0 017 0zm5.5-5.5a3.5 3.5 0 110-7.002 3.5 3.5 0 010 7.002z",
            fill: "currentColor"
        })
    });



const $052c3c1b1172a648$export$b8f93ffdb05d88b3 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10 10a1 1 0 00-1 1v3a1 1 0 11-2 0V9.91a2 2 0 01.34-1.11l3.49-5.25a1 1 0 00-1.66-1.1l-3.5 5.24A4 4 0 005 9.91V17a5 5 0 01-.26 1.58l-.25.76A2 2 0 006.39 22h1.83a2 2 0 001.94-1.52l.54-2.16c.2-.795.3-1.61.3-2.43V11a1 1 0 00-1-1zm9.51 9.37l-.25-.76A5 5 0 0119 17V9.91a4 4 0 00-.67-2.22l-3.5-5.24a1 1 0 10-1.66 1.1l3.49 5.25A2 2 0 0117 9.91V14a1 1 0 01-2 0v-3a1 1 0 00-2 0v4.89c0 .82.1 1.635.3 2.43l.54 2.16A2 2 0 0015.78 22h1.83a2 2 0 001.9-2.63z",
            fill: "currentColor"
        })
    });



const $5caa2810da495332$export$d3fc1d088e5dfb53 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.25 5.47l-.33-.32A7.29 7.29 0 0013.74 3a.5.5 0 00-.35.85l3.78 3.78a2.59 2.59 0 01.27 3.44 2.509 2.509 0 01-3.73.18l-.51-.49a1.49 1.49 0 00-2.1 0l-2.16 2.18-.35-.35a1.001 1.001 0 00-1.42 0l-2.29 2.29-1 1a3 3 0 000 4.24 3 3 0 004.24 0l1-1 2.29-2.29a.999.999 0 000-1.42l-.35-.35 1.15-1.15a5.512 5.512 0 007.73-1.16 5.63 5.63 0 00-.69-7.28z",
            fill: "currentColor"
        })
    });



const $38dc85eff358ffbf$export$48d9a3dfa71ed3fe = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.5 13.59h-3.21l.64-3h2.57c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5h-1.92l.54-2.5a1.498 1.498 0 10-2.93-.63l-.67 3.13h-3.13l.54-2.5A1.498 1.498 0 109 4.46l-.67 3.13H4.52c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h3.16l-.64 3H4.51c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h1.88l-.5 2.33c-.17.81.34 1.61 1.15 1.78.11.02.21.03.32.03.69 0 1.31-.48 1.46-1.19l.63-2.95h3.13l-.5 2.33c-.17.81.34 1.61 1.15 1.78.11.02.21.03.32.03.69 0 1.31-.48 1.46-1.19l.63-2.95h3.85c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5h.01zm-9.4 0l.64-3h3.13l-.64 3H10.1z",
            fill: "currentColor"
        })
    });



const $e8f7417c235e8de6$export$58b75d9a5cd5428f = (C)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...C,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21 14c-.75 0-1.08-.3-1.59-.75C18.82 12.72 18 12 16.5 12c-1.5 0-2.32.72-2.91 1.25-.51.45-.84.75-1.59.75-.75 0-1.08-.3-1.59-.75C9.82 12.72 9 12 7.5 12c-1.5 0-2.32.72-2.91 1.25-.51.45-.84.75-1.59.75-.55 0-1 .45-1 1s.45 1 1 1c1.5 0 2.32-.72 2.91-1.25.51-.45.84-.75 1.59-.75.75 0 1.08.3 1.59.75C9.68 15.28 10.5 16 12 16c1.5 0 2.32-.72 2.91-1.25.51-.45.84-.75 1.59-.75.75 0 1.08.3 1.59.75.59.53 1.41 1.25 2.91 1.25.55 0 1-.45 1-1s-.45-1-1-1zm0 4c-.75 0-1.08-.3-1.59-.75C18.82 16.72 18 16 16.5 16c-1.5 0-2.32.72-2.91 1.25-.51.45-.84.75-1.59.75-.75 0-1.08-.3-1.59-.75C9.82 16.72 9 16 7.5 16c-1.5 0-2.32.72-2.91 1.25-.51.45-.84.75-1.59.75-.55 0-1 .45-1 1s.45 1 1 1c1.5 0 2.32-.72 2.91-1.25.51-.45.84-.75 1.59-.75.75 0 1.08.3 1.59.75C9.68 19.28 10.5 20 12 20c1.5 0 2.32-.72 2.91-1.25.51-.45.84-.75 1.59-.75.75 0 1.08.3 1.59.75.59.53 1.41 1.25 2.91 1.25.55 0 1-.45 1-1s-.45-1-1-1zM3 8c1.5 0 2.32-.72 2.91-1.25C6.42 6.3 6.75 6 7.5 6c.75 0 1.08.3 1.59.75C9.68 7.28 10.5 8 12 8c1.5 0 2.32-.72 2.91-1.25.51-.45.84-.75 1.59-.75.75 0 1.08.3 1.59.75C18.68 7.28 19.5 8 21 8c.55 0 1-.45 1-1s-.45-1-1-1c-.75 0-1.08-.3-1.59-.75C18.82 4.72 18 4 16.5 4c-1.5 0-2.32.72-2.91 1.25-.51.45-.84.75-1.59.75-.75 0-1.08-.3-1.59-.75C9.82 4.72 9 4 7.5 4 6 4 5.18 4.72 4.59 5.25 4.08 5.7 3.75 6 3 6c-.55 0-1 .45-1 1s.45 1 1 1zm18 2c-.75 0-1.08-.3-1.59-.75C18.82 8.72 18 8 16.5 8c-1.5 0-2.32.72-2.91 1.25-.51.45-.84.75-1.59.75-.75 0-1.08-.3-1.59-.75C9.82 8.72 9 8 7.5 8 6 8 5.18 8.72 4.59 9.25 4.08 9.7 3.75 10 3 10c-.55 0-1 .45-1 1s.45 1 1 1c1.5 0 2.32-.72 2.91-1.25.51-.45.84-.75 1.59-.75.75 0 1.08.3 1.59.75C9.68 11.28 10.5 12 12 12c1.5 0 2.32-.72 2.91-1.25.51-.45.84-.75 1.59-.75.75 0 1.08.3 1.59.75.59.53 1.41 1.25 2.91 1.25.55 0 1-.45 1-1s-.45-1-1-1z",
            fill: "currentColor"
        })
    });



const $1d637d9123949777$export$5c20080853bcf3eb = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7.63 15.07l-5 2a1 1 0 10.74 1.86l5-2a1.002 1.002 0 00-.74-1.86zM14 4h-1a2 2 0 00-2 2v12a2 2 0 002 2h1a8 8 0 000-16zm-6 9a1 1 0 000-2H3a1 1 0 000 2h5zm.37-5.93l-5-2a1 1 0 10-.74 1.86l5 2a1 1 0 10.74-1.86z",
            fill: "currentColor"
        })
    });



const $20b24f48a781769b$export$cfaaebc73654f54f = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.12 2.88C18.56 2.32 17.79 2 17 2H7c-.8 0-1.56.32-2.12.88S4 4.21 4 5v14c0 .8.32 1.56.88 2.12S6.21 22 7 22h10c.8 0 1.56-.32 2.12-.88S20 19.79 20 19V5c0-.8-.32-1.56-.88-2.12zM9.29 7.29A.99.99 0 0110 7h1V6c0-.27.11-.52.29-.71.18-.19.44-.29.71-.29.27 0 .52.11.71.29.19.18.29.44.29.71v1h1c.27 0 .52.11.71.29.19.19.29.44.29.71 0 .27-.11.52-.29.71-.18.19-.44.29-.71.29h-1v1c0 .27-.11.52-.29.71A.99.99 0 0112 11c-.27 0-.52-.11-.71-.29A.99.99 0 0111 10V9h-1c-.27 0-.52-.11-.71-.29A.99.99 0 019 8c0-.27.11-.52.29-.71zM15.7 18.7a.99.99 0 01-.71.29h-6c-.27 0-.52-.11-.71-.29a.99.99 0 01-.29-.71c0-.27.11-.52.29-.71a.99.99 0 01.71-.29h6c.27 0 .52.11.71.29.19.18.29.44.29.71 0 .27-.11.52-.29.71zm1-4a.99.99 0 01-.71.29H8c-.27 0-.52-.11-.71-.29a.99.99 0 01-.29-.71c0-.27.11-.52.29-.71a.99.99 0 01.71-.29h8c.27 0 .52.11.71.29.19.18.29.44.29.71 0 .27-.11.52-.29.71h-.01z",
            fill: "currentColor"
        })
    });



const $ff1fb639e8182e5c$export$890502011b47a624 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.46 4.68a2 2 0 00-1.3-.68 18.78 18.78 0 01-6.34-1.83 1.86 1.86 0 00-1.64 0A18.5 18.5 0 014.88 4 2.06 2.06 0 003 6v5c0 6.74 6.75 11 9 11s9-4.25 9-11V6a2 2 0 00-.54-1.32zM17 10h-1v1a1 1 0 01-2 0v-1h-1a1 1 0 110-2h1V7a1 1 0 012 0v1h1a1 1 0 110 2z",
            fill: "currentColor"
        })
    });



const $050c2a2ff590a491$export$36c5800fb0eabdc7 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17.87 7.36a6.55 6.55 0 00-4.88.3v-.65c-.03-.82-.29-1.61-.74-2.29a4.63 4.63 0 00-1.81-1.59c-.12-.06-.25-.1-.39-.11a1.34 1.34 0 00-.4 0c-.13.03-.26.1-.36.19-.12.08-.23.2-.29.33-.06.12-.1.25-.1.39-.01.14.01.27.06.4.05.13.12.25.21.35.1.1.21.18.34.23.4.19.75.49 1 .86.27.37.44.8.49 1.25v.65a6.55 6.55 0 00-4.88-.3C4 8.22 3 10.18 3 13.35c0 3 1.08 5.42 3 6.7.95.63 2.06.96 3.2.95.74-.01 1.47-.13 2.18-.34.4-.12.84-.12 1.24 0 .09.03.19.04.29.07-1.85-1.92-2.91-3.51-2.91-5.34 0-.5.08-.99.26-1.46s.45-.9.79-1.26c.35-.37.75-.66 1.21-.86.46-.2.94-.3 1.43-.3h.02c.64.02 1.26.21 1.79.52.54-.32 1.14-.5 1.77-.52h.05c.49 0 .97.1 1.43.3.46.2.86.49 1.21.86.34.37.61.79.79 1.27.08.21.14.44.18.66.05-.42.08-.84.08-1.29 0-2.99-1-5.08-3.13-5.93l-.01-.02zm.52 6.79c-.2-.21-.43-.37-.68-.49-.26-.11-.53-.17-.81-.17-.52.02-1.02.23-1.4.6-.39-.37-.88-.58-1.4-.6-.28 0-.55.06-.81.17-.26.11-.49.28-.68.49-.2.21-.35.46-.45.73-.1.27-.16.56-.15.86 0 1.38 1.02 2.65 2.78 4.36l.19.18c.14.14.33.22.52.22s.38-.08.53-.22l.19-.18c1.77-1.71 2.78-2.98 2.78-4.36 0-.29-.05-.59-.15-.86-.1-.27-.26-.52-.45-.73h-.01z",
            fill: "currentColor"
        })
    });



const $8a8394b5a05f54e9$export$f6e03babf1fc9bc4 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15.6 4A5.6 5.6 0 0012 5.46 5.6 5.6 0 008.4 4 5.36 5.36 0 003 9.44c.002.526.07 1.05.2 1.56h2.26l1.71-2.55A1 1 0 018.06 8a1 1 0 01.83.55L11.12 13l1.05-1.56A1 1 0 0113 11h2a1 1 0 010 2h-1.46l-1.71 2.55A1 1 0 0111 16h-.06a1 1 0 01-.83-.55L7.88 11l-1 1.56A1 1 0 016 13H4c1.15 2.14 3.27 4.35 6.18 7l.49.45a2 2 0 002.7 0l.49-.44C18.37 15.86 21 12.8 21 9.44A5.36 5.36 0 0015.6 4z",
            fill: "currentColor"
        })
    });



const $8bfc3b720a3c8ca0$export$daef3f6eb81d0f23 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21 6c-.75 0-1.08-.3-1.59-.75C18.82 4.72 18 4 16.5 4c-1.5 0-2.32.72-2.91 1.25-.51.45-.84.75-1.59.75-.75 0-1.08-.3-1.59-.75C9.82 4.72 9 4 7.5 4 6 4 5.18 4.72 4.59 5.25 4.08 5.7 3.75 6 3 6c-.55 0-1 .45-1 1s.45 1 1 1c1.5 0 2.32-.72 2.91-1.25C6.42 6.3 6.75 6 7.5 6c.75 0 1.08.3 1.59.75C9.68 7.28 10.5 8 12 8c1.5 0 2.32-.72 2.91-1.25.51-.45.84-.75 1.59-.75.75 0 1.08.3 1.59.75C18.68 7.28 19.5 8 21 8c.55 0 1-.45 1-1s-.45-1-1-1zm-5.68 3.05a.996.996 0 00-1.26.63l-3 9a1 1 0 00.63 1.26c.11.04.21.05.32.05.42 0 .81-.26.95-.68l3-9a1 1 0 00-.63-1.26h-.01zm4 0a.996.996 0 00-1.26.63l-3 9a1 1 0 00.63 1.26c.11.04.21.05.32.05.42 0 .81-.26.95-.68l3-9a1 1 0 00-.63-1.26h-.01zm-8 0a.996.996 0 00-1.26.63l-3 9a1 1 0 00.63 1.26c.11.04.21.05.32.05.42 0 .81-.26.95-.68l3-9a1 1 0 00-.63-1.26h-.01zm-4 0a.996.996 0 00-1.26.63l-3 9a1 1 0 00.63 1.26c.11.04.21.05.32.05.42 0 .81-.26.95-.68l3-9a1 1 0 00-.63-1.26h-.01z",
            fill: "currentColor"
        })
    });



const $90fa89813a8fc73b$export$bf77a33be825d02f = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M9.69 13.88a1.01 1.01 0 00-1.39-.28l-.8.53v-.96c0-.55-.45-1-1-1s-1 .45-1 1v.96l-.8-.53a1.001 1.001 0 10-1.11 1.67l1.11.74-1.11.74c-.46.31-.58.93-.28 1.39.19.29.51.45.83.45.19 0 .38-.05.55-.17l.8-.53v.96c0 .55.45 1 1 1s1-.45 1-1v-.96l.8.53c.17.11.36.17.55.17.32 0 .64-.16.83-.45.31-.46.18-1.08-.28-1.39l-1.11-.74 1.11-.74c.46-.31.58-.93.28-1.39h.02zM19.31 16l1.11-.74c.46-.31.58-.93.28-1.39a1.01 1.01 0 00-1.39-.28l-.8.53v-.96c0-.55-.45-1-1-1s-1 .45-1 1v.96l-.8-.53a1.001 1.001 0 10-1.11 1.67l1.11.74-1.11.74c-.46.31-.58.93-.28 1.39.19.29.51.45.83.45.19 0 .38-.05.55-.17l.8-.53v.96c0 .55.45 1 1 1s1-.45 1-1v-.96l.8.53c.17.11.36.17.55.17.32 0 .64-.16.83-.45.31-.46.18-1.08-.28-1.39L19.29 16h.02zm-4.12-6.88c.31-.46.18-1.08-.28-1.39l-1.11-.74 1.11-.74c.46-.31.58-.93.28-1.39a1.01 1.01 0 00-1.39-.28l-.8.53v-.96c0-.55-.45-1-1-1s-1 .45-1 1v.96l-.8-.53a1.001 1.001 0 10-1.11 1.67l1.11.74-1.11.74c-.46.31-.58.93-.28 1.39.19.29.51.45.83.45.19 0 .38-.05.55-.17l.8-.53v.96c0 .55.45 1 1 1s1-.45 1-1v-.96l.8.53c.17.11.36.17.55.17.32 0 .64-.16.83-.45h.02z",
            fill: "currentColor"
        })
    });



const $3ae81be120f0ed1e$export$c6de8d8949680123 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16.17 11A3.009 3.009 0 0119 7c.16 0 .31.03.47.05.01-.1.03-.2.03-.3C19.5 4.13 17.37 2 14.75 2c-1.64 0-3.08.83-3.93 2.09A3.68 3.68 0 0010 4a3.98 3.98 0 00-3.86 3.01C6.09 7.01 6.05 7 6 7c-1.66 0-3 1.34-3 3s1.34 3 3 3h4.18c.41-1.16 1.51-2 2.82-2h3.17zM19 9c-.55 0-1 .45-1 1s.45 1 1 1 1 .45 1 1-.45 1-1 1h-6c-.55 0-1 .45-1 1s.45 1 1 1h6c1.65 0 3-1.35 3-3s-1.35-3-3-3zm1 7h-3c-.55 0-1 .45-1 1s.45 1 1 1h3c.55 0 1-.45 1-1s-.45-1-1-1zm-10.46.05a1.01 1.01 0 00-1.39-.28l-.8.53v-.96c0-.55-.45-1-1-1s-1 .45-1 1v.96l-.8-.53a1.001 1.001 0 10-1.11 1.67l1.11.74-1.11.74c-.46.31-.58.93-.28 1.39.19.29.51.45.83.45.19 0 .38-.05.55-.17l.8-.53v.96c0 .55.45 1 1 1s1-.45 1-1v-.96l.8.53c.17.11.36.17.55.17.32 0 .64-.16.83-.45.31-.46.18-1.08-.28-1.39l-1.11-.74 1.11-.74c.46-.31.58-.93.28-1.39h.02zm5.17.25a.996.996 0 00-1.41 0l-.29.29-.29-.29a.996.996 0 10-1.41 1.41l.29.29-.29.29a.996.996 0 00.71 1.7c.26 0 .51-.1.71-.29l.29-.29.29.29c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 000-1.41l-.29-.29.29-.29a.996.996 0 000-1.41h-.02z",
            fill: "currentColor"
        })
    });



const $36295501721e71fc$export$8b6d88516a2f9836 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7.6 15.2c-.44-.33-1.07-.24-1.4.2l-3 4c-.33.44-.24 1.07.2 1.4.18.13.39.2.6.2.3 0 .6-.14.8-.4l3-4c.33-.44.24-1.07-.2-1.4zm2.6.2l-3 4c-.33.44-.24 1.07.2 1.4.18.13.39.2.6.2.3 0 .6-.14.8-.4l3-4c.33-.44.24-1.07-.2-1.4-.44-.33-1.07-.24-1.4.2zM6 13h4c0-2.76 2.24-5 5-5a3.009 3.009 0 012.83 4h2.39c.48-.53.78-1.23.78-2 0-1.13-.64-2.11-1.56-2.62.03-.21.06-.42.06-.63C19.5 4.13 17.37 2 14.75 2c-1.64 0-3.08.83-3.93 2.09A3.68 3.68 0 0010 4a3.98 3.98 0 00-3.86 3.01C6.09 7.01 6.05 7 6 7c-1.66 0-3 1.34-3 3s1.34 3 3 3zm15 1h-6c-.55 0-1-.45-1-1s.45-1 1-1 1-.45 1-1-.45-1-1-1c-1.65 0-3 1.35-3 3s1.35 3 3 3h6c.55 0 1-.45 1-1s-.45-1-1-1zm-2 3h-5c-.55 0-1 .45-1 1s.45 1 1 1h5c.55 0 1-.45 1-1s-.45-1-1-1z",
            fill: "currentColor"
        })
    });



const $f8978146c9aa05fd$export$501ca9e1b0f89368 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18.75 8h-.66c.552-1.264.86-2.621.91-4a1 1 0 00-1.89-.45 5.66 5.66 0 01-.77 1.14A6 6 0 0012 3a6 6 0 00-4.34 1.69 5.82 5.82 0 01-.77-1.14A1 1 0 005 4a11 11 0 00.91 4h-.66A2.25 2.25 0 003 10.25a.76.76 0 00.75.75h1.5c.307 0 .61-.065.89-.19.09.476.206.947.35 1.41.19.617.327 1.25.41 1.89A5 5 0 0110 13h4a5 5 0 013.1 1.11c.083-.64.22-1.273.41-1.89.144-.463.26-.934.35-1.41.28.125.583.19.89.19h1.5a.76.76 0 00.75-.75A2.25 2.25 0 0018.75 8zM9 11a1 1 0 110-2 1 1 0 010 2zm6 0a1 1 0 110-2 1 1 0 010 2zm-1 4h-4a3 3 0 000 6h4a3 3 0 100-6z",
            fill: "currentColor"
        })
    });



const $a94debf5d494cbe1$export$a020746047073b56 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M11.47 2A8.18 8.18 0 004 10.27v8.12a3 3 0 001.34 2.5l.66.41a1 1 0 001.49-.48l2.05-5.47A1 1 0 008.56 14H8a2 2 0 01-2-2h4a1 1 0 011 1v4a1 1 0 002 0v-4a1 1 0 011-1h4a2 2 0 01-2 2h-.56a1 1 0 00-.93 1.35l2 5.47a1.002 1.002 0 001.49.48l.61-.41a3 3 0 001.39-2.5V10a8.001 8.001 0 00-8.53-8z",
            fill: "currentColor"
        })
    });



const $9317bbf58795c529$export$2f3a554b339dd4d0 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18.75 8h-.66c.552-1.264.86-2.621.91-4a1 1 0 00-1.89-.45 5.66 5.66 0 01-.77 1.14A6 6 0 0012 3a6 6 0 00-4.34 1.69 5.82 5.82 0 01-.77-1.14A1 1 0 005 4a11 11 0 00.91 4h-.66A2.25 2.25 0 003 10.25a.76.76 0 00.75.75h1.5c.307 0 .61-.065.89-.19.09.476.206.947.35 1.41.19.617.327 1.25.41 1.89A5 5 0 0110 13h4c.51.005 1.016.09 1.5.25.484-.16.99-.244 1.5-.25h.3c.06-.29.14-.56.21-.81.144-.463.26-.934.35-1.41.28.125.583.19.89.19h1.5a.76.76 0 00.75-.75A2.25 2.25 0 0018.75 8zM9 11a1 1 0 110-2 1 1 0 010 2zm6 0a1 1 0 110-2 1 1 0 010 2zm-5 4a3 3 0 000 6h3a4.92 4.92 0 010-6h-3zm9.12.88a1 1 0 00-1.41 0l-.71.71-.71-.71a1 1 0 00-1.41 1.41l.71.71-.71.71a1 1 0 000 1.41 1 1 0 001.41 0l.71-.71.71.71a1 1 0 001.41 0 1 1 0 000-1.41l-.71-.71.71-.71a1 1 0 000-1.41z",
            fill: "currentColor"
        })
    });



const $75c9f9ac80c5ac04$export$71f10c3fa87e51e4 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18.29 15.29L16 17.59l-.29-.3a1.003 1.003 0 00-1.638.326 1.005 1.005 0 00.218 1.094l1 1a.999.999 0 001.42 0l3-3a1.004 1.004 0 10-1.42-1.42zM10 15a3 3 0 000 6h3a4.92 4.92 0 010-6h-3zm8.75-7h-.66c.552-1.264.86-2.621.91-4a1 1 0 00-1.89-.45 5.66 5.66 0 01-.77 1.14A6 6 0 0012 3a6 6 0 00-4.34 1.69 5.82 5.82 0 01-.77-1.14A1 1 0 005 4a11 11 0 00.91 4h-.66A2.25 2.25 0 003 10.25a.76.76 0 00.75.75h1.5c.307 0 .61-.065.89-.19.09.476.206.947.35 1.41.19.617.327 1.25.41 1.89A5 5 0 0110 13h4c.51.005 1.016.09 1.5.25.484-.16.99-.244 1.5-.25h.3c.06-.29.14-.56.21-.81.144-.463.26-.934.35-1.41.28.125.583.19.89.19h1.5a.76.76 0 00.75-.75A2.25 2.25 0 0018.75 8zM9 11a1 1 0 110-2 1 1 0 010 2zm6 0a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $583d2a809dc2556f$export$bc400afd404eb99f = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.93 12.83A10 10 0 0013.23 4a10 10 0 00-8.16 2.74 9.94 9.94 0 00-2.43 3.69A10 10 0 003.36 19c.18.3.43.55.73.73a2 2 0 001 .27h13.83a2.049 2.049 0 001-.27 2 2 0 00.72-.73 9.86 9.86 0 001.29-6.17zM6.57 16.59a1 1 0 01-1.43 1.28 1 1 0 01-.38-.42A8 8 0 014 14a8 8 0 017.526-7.967 8 8 0 013.904.757c.129.051.248.126.35.22.091.1.166.215.22.34.048.131.072.27.07.41a1.07 1.07 0 01-.1.39.899.899 0 01-.25.33.92.92 0 01-.35.19 1 1 0 01-.41.05 1.12 1.12 0 01-.39-.13 6 6 0 00-3.6-.5 5.94 5.94 0 00-3.22 1.67 6 6 0 00-1.18 6.83zm6.83-.53c-.08.182-.191.348-.33.49-.135.147-.303.26-.49.33-.183.08-.38.12-.58.12a1.5 1.5 0 010-3h.14l5.18-4.75a1 1 0 01.34-.2 1 1 0 01.77 0 .87.87 0 01.31.23c.088.097.16.209.21.33.036.127.053.258.05.39-.01.13-.04.259-.09.38-.06.12-.14.229-.24.32l-5.17 4.78c.008.198-.027.396-.1.58zm5.82 1.37a1 1 0 01-.37.42 1 1 0 01-.54.15 1 1 0 01-.94-.67 1.05 1.05 0 010-.76A5.868 5.868 0 0018 14a1 1 0 011.384-.926c.122.05.233.123.326.216A1.001 1.001 0 0120 14a7.69 7.69 0 01-.78 3.43z",
            fill: "currentColor"
        })
    });



const $802d6a4a3635cc81$export$b21b0ef874502508 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21 11h-2a1 1 0 000 2h2a1 1 0 000-2zm-9-5a1 1 0 001-1V3a1 1 0 00-2 0v2a1 1 0 001 1zm5.66 1.76l1.41-1.42a1 1 0 10-1.41-1.41l-1.42 1.41a1.005 1.005 0 00.71 1.714 1.004 1.004 0 00.71-.294zM6 12a1 1 0 00-1-1H3a1 1 0 000 2h2a1 1 0 001-1zm5.31-4.93l5.62 5.62c.039-.228.062-.459.07-.69a5 5 0 00-5-5 5.2 5.2 0 00-.69.07zm-5 9.17l-1.38 1.42a1 1 0 101.41 1.41l1.42-1.41a1.004 1.004 0 00-1.42-1.42h-.03zM4.71 3.29a1.004 1.004 0 10-1.42 1.42l4.54 4.54a5 5 0 006.92 6.92l4.54 4.54a1.002 1.002 0 001.639-.325 1 1 0 00-.219-1.095l-16-16zM12 18a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $a8144e39e1f8c240$export$129adf318b5363eb = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17.5 15a2.5 2.5 0 100 5 2.5 2.5 0 000-5zm1.75-9.2a1.472 1.472 0 10-2.44-1.65L15.16 6.6l2.44 1.65 1.65-2.45zm-5.2 2.44l-6.31 9.37a1 1 0 01-1.36.27 1 1 0 01-.27-1.37l.83-1.22a1.48 1.48 0 00-2.45-1.65l-.82 1.22a3.931 3.931 0 106.51 4.41l6.31-9.38-2.44-1.65z",
            fill: "currentColor"
        })
    });



const $149bbac7f8b22346$export$935ce3fab9aa5b9 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4.5 14h3A1.5 1.5 0 009 12.5v-1A1.5 1.5 0 007.5 10h-3A1.5 1.5 0 003 11.5v1A1.5 1.5 0 004.5 14zm16-10.89a1 1 0 00-1.1.132 1 1 0 00-.24.308L12.88 16H5a2 2 0 00-2 2v1a2 2 0 002 2h5.76a3 3 0 002.69-1.66l7.44-14.89a1 1 0 00.11-.76 1 1 0 00-.5-.58z",
            fill: "currentColor"
        })
    });



const $4a78db6adccf1dbf$export$d4a3f2a9fc438c56 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.69 15.06a1 1 0 00-1.41 0l-2.17 2.28a2 2 0 01-1.45.62H12a1 1 0 110-2h1.66a1 1 0 100-2H8a2 2 0 00-2 2H4a1 1 0 00-1 1v2a1 1 0 001 1h11.66a4 4 0 002.89-1.24l2.17-2.28a1 1 0 00-.03-1.38zM14 9v2a1 1 0 001 1h4a1 1 0 001-1V9a1 1 0 00.92-.62 1 1 0 00-.21-1.09l-3-3a1 1 0 00-1.42 0l-3 3a1 1 0 00-.21 1.09A1 1 0 0014 9z",
            fill: "currentColor"
        })
    });



const $befbc5018ec75b6a$export$c366a9275f92f9d7 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M22 10.07a1.53 1.53 0 00-.48-.76L13.85 2.7a2.79 2.79 0 00-3.7 0L2.53 9.31A1.53 1.53 0 002.08 11c.098.29.283.54.53.72.242.187.535.295.84.31H4v7a3 3 0 003 3h10a3 3 0 003-3V12h.55a1.49 1.49 0 00.84-.31c.247-.18.432-.43.53-.72a1.54 1.54 0 00.08-.9zm-5.54 8.34a2 2 0 01-2.82 0L12 16.85a3.813 3.813 0 01-1 .15 4 4 0 01-4-4 1.79 1.79 0 010-.23 1.06 1.06 0 01.67-.84 1 1 0 011 .21l1.57 1.57 1.42-1.42-1.57-1.57a1 1 0 01.7-1.72H11a4 4 0 014 4 3.813 3.813 0 01-.15 1l1.56 1.57a2 2 0 010 2.84h.05z",
            fill: "currentColor"
        })
    });



const $45a961d26574dc6a$export$50a435c8aa14eab3 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.94 10.65c-.05-.13-.12-.24-.21-.34a.938.938 0 00-.33-.23c-.12-.05-.26-.08-.39-.08H4c-.27 0-.52.11-.71.29A.99.99 0 003 11c0 1.67.47 3.31 1.35 4.74A8.967 8.967 0 008 19.05V20c0 .27.11.52.29.71.19.19.44.29.71.29h6c.27 0 .52-.11.71-.29.19-.18.29-.44.29-.71v-.95a9 9 0 005-8c0-.14-.01-.27-.06-.4zm-.09-3.44a.993.993 0 00-.36-1.35l-2.12-1.23a.993.993 0 00-1.35.36c0 1.3-.4 2.56-1.14 3.63l-.26.38h3.08c.53-.79 1.28-1.41 2.16-1.79h-.01zM7.73 9h2.78c0-.83-.67-1.5-1.5-1.5-.39 0-.74.15-1.01.4C7.95 6.84 7.08 6 6.01 6c-1.07 0-2 .9-2 2 0 .37.11.71.28 1h3.44z",
            fill: "currentColor"
        })
    });



const $bce86da4a3e61744$export$be85ffe5402d4fb8 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M3 5v14a2 2 0 002 2h1V3H5a2 2 0 00-2 2zm16-2H8v18h11a2 2 0 002-2V5a2 2 0 00-2-2zm-2 7a1 1 0 01-1 1h-4a1 1 0 01-1-1V8a1 1 0 011-1h4a1 1 0 011 1v2z",
            fill: "currentColor"
        })
    });



const $1b86314d56c3371d$export$d87730ecda20159a = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10.6 2.14a7 7 0 00-4.26 11A8.33 8.33 0 018 18a4 4 0 008 0 7.83 7.83 0 011.56-4.76 7 7 0 00-7-11.1h.04zM9 11a1.5 1.5 0 01-1.5-1.5v-1a1.5 1.5 0 113 0v1A1.5 1.5 0 019 11zm5 7a2 2 0 11-4 0v-3a2 2 0 014 0v3zm2.5-8.5a1.5 1.5 0 11-3 0v-1a1.5 1.5 0 113 0v1z",
            fill: "currentColor"
        })
    });



const $2a402a5c9c0b58ec$export$f3cc90ba9860f723 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 5.5a2.5 2.5 0 00-5 0v8.39c-.94.75-1.5 1.9-1.5 3.11 0 2.21 1.79 4 4 4s4-1.79 4-4c0-1.21-.56-2.35-1.5-3.11V5.5zM10 8H9V5.5c0-.28.22-.5.5-.5s.5.22.5.5V8zm4-2c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1s-1 .45-1 1v1c0 .55.45 1 1 1zm7 4h-1c-.55 0-1 .45-1 1s.45 1 1 1h1c.55 0 1-.45 1-1s-.45-1-1-1zm-2.05-2.54l.71-.71a.996.996 0 10-1.41-1.41l-.71.71a.996.996 0 101.41 1.41zm0 7.07a.996.996 0 10-1.41 1.41l.71.71a.996.996 0 101.41-1.41l-.71-.71zM14 6.99c-.35 0-.68.06-1 .14v6.31c.45.44.8.97 1.06 1.55A3.997 3.997 0 0018 11c0-2.18-1.79-4-4-4v-.01z",
            fill: "currentColor"
        })
    });



const $4ce2ee04fac5e6ac$export$5e63c74153c31b7f = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21 19c-.75 0-1.08-.3-1.59-.75C18.82 17.72 18 17 16.5 17c-1.5 0-2.32.72-2.91 1.25-.51.45-.84.75-1.59.75-.75 0-1.08-.3-1.59-.75C9.82 17.72 9 17 7.5 17c-1.5 0-2.32.72-2.91 1.25-.51.45-.84.75-1.59.75-.55 0-1 .45-1 1s.45 1 1 1c1.5 0 2.32-.72 2.91-1.25.51-.45.84-.75 1.59-.75.75 0 1.08.3 1.59.75C9.68 20.28 10.5 21 12 21c1.5 0 2.32-.72 2.91-1.25.51-.45.84-.75 1.59-.75.75 0 1.08.3 1.59.75.59.53 1.41 1.25 2.91 1.25.55 0 1-.45 1-1s-.45-1-1-1zm-4.06-8c0 .59.47 1.06 1.06 1.06h2c.59 0 1.06-.47 1.06-1.06 0-.59-.47-1.06-1.06-1.06h-2c-.59 0-1.06.47-1.06 1.06zM12 6.06c.59 0 1.06-.47 1.06-1.06V3c0-.59-.47-1.06-1.06-1.06-.59 0-1.06.47-1.06 1.06v2c0 .59.47 1.06 1.06 1.06zm4.24 1.76c.27 0 .54-.1.75-.31l1.42-1.42c.41-.41.41-1.09 0-1.5-.41-.41-1.09-.41-1.5 0l-1.42 1.42c-.41.41-.41 1.09 0 1.5.21.21.48.31.75.31zM3 17c1.5 0 2.32-.72 2.91-1.25.51-.45.84-.75 1.59-.75.75 0 1.08.3 1.59.75C9.68 16.28 10.5 17 12 17c1.5 0 2.32-.72 2.91-1.25.51-.45.84-.75 1.59-.75.75 0 1.08.3 1.59.75.59.53 1.41 1.25 2.91 1.25.55 0 1-.45 1-1s-.45-1-1-1c-.75 0-1.08-.3-1.59-.75C18.82 13.72 18 13 16.5 13c-.44 0-.81.07-1.14.17A3.999 3.999 0 0012 7a3.999 3.999 0 00-3.36 6.17c-.33-.1-.71-.17-1.14-.17-1.5 0-2.32.72-2.91 1.25-.51.45-.84.75-1.59.75-.55 0-1 .45-1 1s.45 1 1 1zm1-4.94h2c.59 0 1.06-.47 1.06-1.06 0-.59-.47-1.06-1.06-1.06H4c-.59 0-1.06.47-1.06 1.06 0 .59.47 1.06 1.06 1.06zm3.01-4.55c.21.21.48.31.75.31s.54-.1.75-.31c.41-.41.41-1.09 0-1.5L7.09 4.59c-.41-.41-1.09-.41-1.5 0-.41.41-.41 1.09 0 1.5l1.42 1.42z",
            fill: "currentColor"
        })
    });



const $ce4dddf140b25bef$export$dd77d32cd12746d = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.47 2.64A2 2 0 0018 2H6a2 2 0 00-2 2.15l1 13a2 2 0 001 1.56l5 3a2 2 0 002.06 0l5-3a2.002 2.002 0 001-1.56l1-13a1.999 1.999 0 00-.59-1.51zM13.5 16h-4a1 1 0 010-2h4a.911.911 0 001-1 .91.91 0 00-1-1h-4a1 1 0 01-1-1V7a1 1 0 011-1H15a1 1 0 110 2h-4.5v2h3a2.911 2.911 0 013 3 2.911 2.911 0 01-3 3z",
            fill: "currentColor"
        })
    });



const $02ec8881e0380f49$export$3c04bfdd3af05004 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17.7 10.4l-4.85-7.92a1 1 0 00-1.7 0L6.3 10.4A8.82 8.82 0 005 15a7 7 0 0014 0 8.82 8.82 0 00-1.3-4.6zM9.25 10a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zm5.5 8a1.25 1.25 0 110-2.501 1.25 1.25 0 010 2.501zm1-6.29l-6 6a1 1 0 01-1.42 0 1 1 0 010-1.42l6-6a1.004 1.004 0 111.42 1.42z",
            fill: "currentColor"
        })
    });



const $8bb2b02c0388d80e$export$d422a1fde530aa5a = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.76 3.7c.4-.25.24-.86-.22-.92-9-1.11-13.58 3.4-14.39 7.8 0 .02 0 .04-.01.06-.03.19-.07.39-.09.58-.03.26-.05.52-.05.78 0 1.94.79 3.7 2.07 4.97L7 17s0 1.56-2.76 3.3c-.4.25-.24.86.22.92 9 1.11 13.58-3.4 14.39-7.8 0-.02 0-.04.01-.06.03-.19.07-.39.09-.58.03-.26.05-.52.05-.78 0-1.94-.79-3.7-2.07-4.97L17 7s0-1.56 2.76-3.3zM12 15c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3z",
            fill: "currentColor"
        })
    });



const $658dfd7bd224e191$export$7cacb64a62e06243 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 11h-1a1 1 0 00-1-1h-1V8a1 1 0 100-2h-.1a5 5 0 00-9.8 0H7a1 1 0 100 2v2H6a1 1 0 00-1 1H4a1 1 0 00-1 1v2a1 1 0 001 1h1a1 1 0 001 1h1v5a1 1 0 001 1h8a1 1 0 001-1v-5h1a1 1 0 001-1h1a1 1 0 001-1v-2a1 1 0 00-1-1zm-8 4a2 2 0 110-4 2 2 0 010 4z",
            fill: "currentColor"
        })
    });



const $dfe44bcf30fee9a8$export$24578a6b1a15a1cc = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.29 15.63l-1.37-.79 1.08-.29c.53-.14.85-.69.71-1.22s-.69-.85-1.22-.71l-3.01.81L14.01 12l2.47-1.43 3.01.81c.09.02.17.03.26.03.44 0 .85-.29.97-.74a.994.994 0 00-.71-1.22l-1.08-.29 1.37-.79c.48-.28.64-.89.37-1.37a1.01 1.01 0 00-1.37-.37l-1.37.79.29-1.08a.994.994 0 00-.71-1.22.994.994 0 00-1.22.71l-.81 3.01-2.47 1.43V7.42l2.21-2.21a.996.996 0 10-1.41-1.41l-.79.79V3c0-.55-.45-1-1-1s-1 .45-1 1v1.59l-.79-.79a.996.996 0 10-1.41 1.41l2.21 2.21v2.85L8.56 8.84l-.81-3.01c-.14-.53-.69-.85-1.22-.71s-.85.69-.71 1.22l.29 1.08-1.37-.79c-.48-.28-1.09-.11-1.37.37s-.11 1.09.37 1.37l1.37.79-1.08.29c-.53.14-.85.69-.71 1.22.12.45.52.74.97.74.09 0 .17-.01.26-.03l3.01-.81L10.03 12l-2.47 1.43-3.01-.81a.994.994 0 00-1.22.71c-.14.53.17 1.08.71 1.22l1.08.29-1.37.79c-.48.28-.64.89-.37 1.37.19.32.52.5.87.5.17 0 .34-.04.5-.13l1.37-.79-.29 1.08a.994.994 0 00.97 1.25c.44 0 .85-.29.97-.74l.81-3.01 2.47-1.43v2.85l-2.21 2.21a.996.996 0 101.41 1.41l.79-.79V21c0 .55.45 1 1 1s1-.45 1-1v-1.59l.79.79c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 000-1.41l-2.21-2.21v-2.85l2.47 1.43.81 3.01c.12.45.52.74.97.74.09 0 .17-.01.26-.03.53-.14.85-.69.71-1.22l-.29-1.08 1.37.79c.16.09.33.13.5.13a1.002 1.002 0 00.5-1.87h-.05z",
            fill: "currentColor"
        })
    });



const $e7ef837f366e7a4f$export$7d73e4fd73bbafa9 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17.5 6a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM20 17a1 1 0 00-1 1v1h-2v-5a1 1 0 00-.45-.83l-2.78-1.86 2-2.71a1 1 0 00.09-1A1 1 0 0015 7H8a1 1 0 000 2h5l-4.5 6H5v-2a1 1 0 10-2 0v6a2 2 0 002 2h1a1 1 0 000-2H5v-2h4a.999.999 0 00.8-.4l2.77-3.69L15 14.54V19h-2a1 1 0 000 2h6a2 2 0 002-2v-1a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $bbbee9674ffc1887$export$6aefbbfa9e84b5b4 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.98 3.37c-.12-.12-.26-.21-.42-.28-.16-.06-.32-.1-.49-.1H4.93a1.296 1.296 0 00-1.29 1.29v7.71c0 5.98 7.6 8.81 7.92 8.92.28.1.59.1.87 0 .32-.12 7.92-2.94 7.92-8.92V4.28c0-.17-.03-.34-.1-.49-.06-.16-.16-.3-.28-.42h.01zM7.23 7.23c.21-.21.49-.34.79-.37.3-.03.6.05.84.22.21.14.37.34.46.58a1.258 1.258 0 01-.27 1.4c-.18.18-.41.3-.65.35-.25.05-.51.02-.75-.08-.24-.09-.44-.25-.58-.46-.17-.25-.25-.55-.22-.84.03-.3.16-.58.37-.79l.01-.01zm9.59 6.43c-.6.69-1.34 1.25-2.17 1.63a6.356 6.356 0 01-7.47-1.63c-.14-.12-.26-.27-.33-.44-.09-.17-.13-.35-.13-.54 0-.19.04-.37.12-.54.08-.17.19-.33.33-.45s.31-.21.49-.26c.18-.04.37-.04.55 0 .19.02.36.09.51.21.16.1.29.24.39.4.36.41.79.74 1.29.96.5.23 1.04.35 1.58.35s1.09-.12 1.58-.35c.49-.23.93-.56 1.29-.96.17-.18.39-.31.63-.36.24-.06.49-.04.73.04.23.08.44.23.59.43.15.2.24.43.26.68.03.31-.05.62-.23.87v-.04h-.01zm0-4.64c-.21.21-.49.34-.79.37-.3.03-.6-.05-.84-.22-.21-.14-.37-.34-.46-.58-.1-.24-.13-.49-.08-.75.05-.24.16-.46.33-.63.17-.18.38-.3.62-.36.25-.05.51-.02.75.08.24.09.44.25.58.46.17.25.25.55.22.84-.03.3-.16.58-.37.79h.05-.01z",
            fill: "currentColor"
        })
    });



const $f63bbacf29e372ce$export$aef1c0a0e081a57c = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 17h-1.11a3 3 0 00-5.63 0h-2.44a3 3 0 00-5.64 0H4a1 1 0 000 2h1.18a3 3 0 005.64 0h2.44a3 3 0 005.63 0H20a1 1 0 100-2zm1-6h-1.56l-2.51-6.75a1.94 1.94 0 00-1.2-1.16 1.82 1.82 0 00-1.56.2 5.15 5.15 0 01-4.34 0 1.82 1.82 0 00-1.56-.2 1.94 1.94 0 00-1.2 1.16L4.56 11H3a1 1 0 000 2h18a1 1 0 100-2z",
            fill: "currentColor"
        })
    });



const $6c1a02778eeb9aa6$export$71953571c26894cb = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.46 4.68c-.34-.37-.8-.6-1.3-.66-2.2-.23-4.35-.85-6.34-1.83-.26-.13-.54-.19-.82-.19-.28 0-.56.07-.82.19-1.97.98-4.11 1.6-6.3 1.83-.5.04-.97.27-1.32.64-.35.37-.55.85-.56 1.36v4.99C3 17.75 9.75 22 12 22s9-4.25 9-10.99V6.02c-.01-.5-.2-.97-.54-1.34zM9.5 6.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5S8 8.83 8 8s.67-1.5 1.5-1.5zm8.21 2.77l-5.55 5.55c-.24.24-.59.34-.93.27l-.62-.14-1.93 1.93c-.29.29-.77.29-1.06 0a.754.754 0 010-1.06l1.93-1.93-.14-.62c-.08-.33.03-.68.27-.93l5.55-5.55a.996.996 0 011.41 0l1.06 1.06c.39.39.39 1.02 0 1.41l.01.01z",
            fill: "currentColor"
        })
    });



const $ff931ff18fe9e772$export$ab978c2aa8b81066 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M9 20a13.648 13.648 0 01-1.57-.11A6 6 0 0018 16v-.09A12 12 0 019 20zm7.52-5.42A7.94 7.94 0 016 13.27V16a6 6 0 00.22 1.6A9.89 9.89 0 009 18a9.998 9.998 0 007.52-3.42zM12 14a6 6 0 100-12 6 6 0 000 12zm2.5-8a1 1 0 110 2 1 1 0 010-2zm-.28 3a1 1 0 01.92.59 1 1 0 01-.14 1.08 4.001 4.001 0 01-5.92 0 1 1 0 01-.18-1.08A1 1 0 019.78 9h4.44zM9.5 6a1 1 0 110 2 1 1 0 010-2z",
            fill: "currentColor"
        })
    });



const $314b53a10a47391f$export$2d9c0359f0133190 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.75 9.19c-1.65-1.56-4.32-1.56-5.96-.02L9 13.72c-.98.93-2.61.93-3.6-.02-.47-.45-.74-1.06-.74-1.71 0-.65.26-1.26.76-1.71.98-.93 2.61-.93 3.6.02l.71.68c.31.3.8.3 1.11 0 .34-.32.34-.85 0-1.17l-.67-.64c-1.63-1.55-4.3-1.56-5.94-.02-1.63 1.56-1.65 4.12 0 5.68.8.76 1.84 1.17 2.97 1.17 1.13 0 2.2-.41 2.99-1.17l4.79-4.55c.98-.93 2.61-.93 3.6.02.98.95.98 2.48-.02 3.42-.98.93-2.61.93-3.6-.02l-.71-.68c-.31-.3-.8-.3-1.11 0-.34.32-.34.85 0 1.17l.65.62c.8.76 1.87 1.19 2.99 1.19s2.18-.41 2.97-1.17c.8-.76 1.23-1.76 1.25-2.82a3.939 3.939 0 00-1.25-2.82z",
            fill: "currentColor"
        })
    });



const $7ae077533b8accc9$export$391f58e37e6636e5 = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 19h-4V9c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1s.45 1 1 1h4v9H7c-.55 0-1 .45-1 1s.45 1 1 1h10c.55 0 1-.45 1-1s-.45-1-1-1zM12 6c.83 0 1.5-.67 1.5-1.5S12.83 3 12 3s-1.5.67-1.5 1.5S11.17 6 12 6z",
            fill: "currentColor"
        })
    });



const $750b250001dc630b$export$d57beb8206a01353 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 4c-1.68-1.69-4.75-1.26-7 1-1.91 1.91-2.49 4.43-1.57 6.17l-.14.12a2.71 2.71 0 00-.57 2.58c.1.58.1.72 0 .83-.1.11-.26.11-.83 0a2.662 2.662 0 00-2.58.57 2.69 2.69 0 00-.58 2.58c.1.58.1.72 0 .84s-.26.11-.83 0a2.701 2.701 0 00-2.59.57 1 1 0 000 1.42.998.998 0 001.42 0c.11-.11.26-.12.83 0a2.66 2.66 0 002.58-.57 2.69 2.69 0 00.58-2.58c-.1-.58-.1-.73 0-.84.1-.11.26-.11.83 0a2.68 2.68 0 002.58-.57 2.69 2.69 0 00.58-2.58c-.1-.58-.1-.73 0-.83a.31.31 0 01.23-.09c.527.256 1.104.39 1.69.39A6.36 6.36 0 0019 11c2.23-2.23 2.67-5.3 1-7z",
            fill: "currentColor"
        })
    });



const $94e66ee6ea7a492f$export$66a24afe24da6da1 = (z)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...z,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 6a1 1 0 100-2 1 1 0 000 2zm3-1a1 1 0 100-2 1 1 0 000 2zm5 2a1 1 0 100-2 1 1 0 000 2zm0 2a1 1 0 100 2 1 1 0 000-2zM9 5a1 1 0 100-2 1 1 0 000 2zm9 4a1 1 0 100-2 1 1 0 000 2zM4 11a1 1 0 100-2 1 1 0 000 2zm16 8h-6v-3h1a1 1 0 001-1v-2a1 1 0 00-1-1H9a1 1 0 00-1 1v2a1 1 0 001 1h1v3H4a1 1 0 000 2h16a1 1 0 000-2zM6 9a1 1 0 100-2 1 1 0 000 2zm3 0h1v1a1 1 0 001 1h2a1 1 0 001-1V9h1a1 1 0 100-2H9a1 1 0 000 2zM4 7a1 1 0 100-2 1 1 0 000 2z",
            fill: "currentColor"
        })
    });



const $1b7eb08213c84cf7$export$5d161bf1c75bbc5f = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 5h-3V4c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v1H6C3.79 5 2 6.79 2 9v1c0 .55.45 1 1 1h3v9c0 .55.45 1 1 1h10c.55 0 1-.45 1-1v-9h3c.55 0 1-.45 1-1V9c0-2.21-1.79-4-4-4zm-7 12c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm0-5c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm4 2c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z",
            fill: "currentColor"
        })
    });



const $e842183909f1431b$export$9f2d9b323ab49035 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10.78 10.84a4.51 4.51 0 005.56-5.56 4.46 4.46 0 00-3.12-3.12 4.51 4.51 0 00-5.56 5.56 4.46 4.46 0 003.12 3.12zm4.49 1.86l-.38.75a1 1 0 01-.73.54H14a1 1 0 01-.71-.29L12 12.41l-1.29 1.3A1 1 0 0110 14h-.16a1 1 0 01-.73-.54l-.38-.75A8 8 0 004 20a2 2 0 002 2h12a2 2 0 002-2 8 8 0 00-4.73-7.3z",
            fill: "currentColor"
        })
    });



const $c16260e1b2e57dd6$export$afb32f3002f49929 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.14 8.66l-3.6-4A2.001 2.001 0 0016.05 4H8a2 2 0 00-1.49.66l-3.6 4a2 2 0 000 2.68l8.4 9.33a1 1 0 001.48 0l8.4-9.33a2 2 0 00-.05-2.68z",
            fill: "currentColor"
        })
    });



const $48745a62c1427e4f$export$1b4e94b67c60f84f = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M13.25 6.11l1.29-1.44a1 1 0 000-1.34l-.9-1A1 1 0 0012.9 2h-1.8a1 1 0 00-.74.33l-.9 1a1 1 0 000 1.34l1.29 1.44a8 8 0 102.5 0zM12 20a6 6 0 110-12 6 6 0 010 12z",
            fill: "currentColor"
        })
    });



const $6cc09450895cd413$export$90e8372153216fdc = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 12h-3.1A5 5 0 0013 8.1V7h2a1 1 0 001-1V4a1 1 0 00-1-1h-3a1 1 0 00-1 1v4.1A5 5 0 007.1 12H4a1 1 0 00-1 1v7a1 1 0 001 1h6v-4a2 2 0 014 0v4h6a1 1 0 001-1v-7a1 1 0 00-1-1zm-8 1a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $f858821dfd932289$export$7c95d9ad33c8b358 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M9.34 10.93c.68.15 1.33.06 1.89-.2a1.88 1.88 0 011.54 0c.56.26 1.2.35 1.89.2 1.15-.25 2.07-1.2 2.29-2.35.21-1.11-.19-2.13-.93-2.79C15.41 5.24 15 4.5 15 3.68V3.1c0-.66-.45-1.11-1-1.11h-4c-.55 0-1 .45-1 1v.68c0 .82-.41 1.56-1.02 2.11-.73.66-1.13 1.68-.93 2.79.22 1.15 1.14 2.1 2.29 2.35v.01zm7.6 4.49a3.016 3.016 0 00-2.29-2.35 2.94 2.94 0 00-1.89.2c-.49.22-1.05.22-1.54 0-.56-.26-1.2-.35-1.89-.2-1.15.25-2.07 1.2-2.29 2.35-.21 1.11.19 2.13.93 2.79.61.55 1.02 1.29 1.02 2.11V21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-.68c0-.82.41-1.56 1.02-2.11.73-.66 1.13-1.68.93-2.79z",
            fill: "currentColor"
        })
    });



const $c921a60b15e2ba2c$export$b82f4a0184df2beb = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16.5 7a1.5 1.5 0 001.39-.93c.121-.27.16-.569.11-.86A1.49 1.49 0 0016.79 4a1.49 1.49 0 00-.86.08 1.55 1.55 0 00-.68.56A1.5 1.5 0 0016.5 7zm-8 0a1.5 1.5 0 001.39-.93c.121-.27.16-.569.11-.86A1.49 1.49 0 008.79 4a1.49 1.49 0 00-.86.08 1.55 1.55 0 00-.68.56A1.5 1.5 0 008.5 7zM22 18.71l-3-10a1 1 0 00-.38-.53A1 1 0 0018 8h-5a1 1 0 00-.71.29A1.05 1.05 0 0012 9a1 1 0 00.29.71A1.001 1.001 0 0013 10h4.26l.74 2.47-2.55 1.7a1 1 0 00-.45 1.07l1 4a1 1 0 00.46.64 1.06 1.06 0 001.147-.044c.11-.08.203-.18.273-.296a1.06 1.06 0 00.12-.78l-.83-3.32 1.46-1L20 19.29c.038.132.103.254.19.36.081.11.188.2.31.26.12.068.253.113.39.13.132.025.268.025.4 0a1 1 0 00.36-.19.86.86 0 00.26-.31.89.89 0 00.12-.38.94.94 0 00-.03-.45zm-9.51-7.57l-5-3a1.07 1.07 0 00-.96-.05 1 1 0 00-.38.3 1.06 1.06 0 00-.15.45l-1 5.75-2.81 3.81A1 1 0 003 20a1 1 0 00.8-.4l3-4a1 1 0 00.2-.44l.11-.65.9.9V19a1 1 0 002 0v-4a1 1 0 00-.07-.38 1 1 0 00-.22-.33l-2-2c-.07-.052-.143-.1-.22-.14l.26-1.54 3.74 2.25a1 1 0 001.28-.41 1 1 0 00.11-.71 1 1 0 00-.4-.6z",
            fill: "currentColor"
        })
    });



const $5fd0ef0fc99ba592$export$ab8b2e4347724774 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.66 3.25a1 1 0 00-1.41.09l-6.39 7.3-2.75-2.06 2.05-1.47A2 2 0 0013 5.49V4a1 1 0 00-2 0v1.49l-6.16 4.4A2 2 0 004 11.51V14a1 1 0 102 0v-2.49L8.4 9.8l3.6 2.7V20a1 1 0 002 0v-7.62l6.75-7.72a1 1 0 00-.09-1.41zM6 6.5a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0z",
            fill: "currentColor"
        })
    });



const $4932c1d034a2db3d$export$cec7a18e87975354 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.68 5.66a2.997 2.997 0 00-5.36 2.68c.1.2.17.42.24.66h-.55c-1.2 0-2.27.54-3 1.38-.73-.84-1.8-1.38-3-1.38h-.55c.06-.24.14-.46.24-.66a2.997 2.997 0 00-5.36-2.68c-1.43 2.85-1.43 6.83 0 9.68A3.004 3.004 0 006.03 17c.45 0 .91-.1 1.34-.32a2.997 2.997 0 001.34-4.02c-.23-.45-.36-1.04-.41-1.66h.73c1.1 0 2 .9 2 2v7c0 .55.45 1 1 1s1-.45 1-1v-7c0-1.1.9-2 2-2h.73c-.05.62-.18 1.21-.41 1.66a2.997 2.997 0 001.34 4.02c.43.22.89.32 1.34.32 1.1 0 2.16-.61 2.69-1.66 1.43-2.85 1.43-6.83 0-9.68h-.04z",
            fill: "currentColor"
        })
    });



const $d0d6d117f2130e16$export$b2aa8d0d0a839742 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.68 5.66a3.004 3.004 0 00-4.73-.86c-1.02.91-1.12 2.41-.58 3.66.07.17.13.35.18.54H15c-1.2 0-2.27.54-3 1.38C11.27 9.54 10.2 9 9 9h-.55c.05-.19.11-.37.18-.54.54-1.25.43-2.75-.58-3.66a3.005 3.005 0 00-4.73.86c-1.43 2.85-1.43 6.83 0 9.68A3.004 3.004 0 006.01 17c.75 0 1.53-.29 2.16-.91.92-.91 1.04-2.32.49-3.49-.21-.44-.33-1.01-.38-1.6h.73c1.1 0 2 .9 2 2v3c-1.1 0-2 .9-2 2s.9 2 2 2c0 .55.45 1 1 1s1-.45 1-1c1.1 0 2-.9 2-2s-.9-2-2-2v-3c0-1.1.9-2 2-2h.73c-.05.59-.17 1.15-.38 1.6-.55 1.17-.43 2.59.49 3.49.63.62 1.41.91 2.16.91 1.1 0 2.16-.61 2.69-1.66 1.43-2.85 1.43-6.83 0-9.68h-.02z",
            fill: "currentColor"
        })
    });



const $0b798837083ce685$export$1d2258421869e484 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16.44 11.54l.61.2a2.11 2.11 0 002.76-2.24 2.069 2.069 0 00-1-1.57l-5.5-3.31.59-1.17a1 1 0 00-.13-1.09A1 1 0 0012.71 2a10.92 10.92 0 00-6 5.11c-1.43 2.74-1.52 6.08-.29 9.92A3 3 0 004 20v1a1 1 0 001 1h13a1 1 0 001-1v-1a3 3 0 00-2.81-3c.42-1.07-.15-2.61-1.81-4.84a.11.11 0 010-.14 2 2 0 012.06-.48z",
            fill: "currentColor"
        })
    });



const $626839df080971a9$export$b8df08e13e9318af = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.12 6.88A3 3 0 0019 6h-6.59l-1.12-1.12A3 3 0 009.17 4H5a3 3 0 00-3 3v10a3 3 0 003 3h14a3 3 0 003-3V9a3 3 0 00-.88-2.12zM18 14h-1v1a1 1 0 01-2 0v-1h-1a1 1 0 010-2h1v-1a1 1 0 012 0v1h1a1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $be3dc01fdc95235e$export$8487d4e1dc78e00 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 11a4.5 4.5 0 10-4.5-4.5A4.51 4.51 0 0012 11zm2.47 1.39l-1.9 1.41a1 1 0 01-1.2 0l-1.88-1.39A8 8 0 004 20a2 2 0 002 2h12a2 2 0 002-2 8 8 0 00-5.53-7.61zM16 19h-2a1 1 0 010-2h2a1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $83aa77bc382adade$export$cdba8ce7d15aadb2 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 11a4.5 4.5 0 10-4.5-4.5A4.51 4.51 0 0012 11zm2.47 1.39l-1.9 1.41a1 1 0 01-1.2 0l-1.88-1.39A8 8 0 004 20a2 2 0 002 2h12a2 2 0 002-2 8 8 0 00-5.53-7.61zM17 18.5a.469.469 0 01-.15.35l-1 1a.48.48 0 01-.7 0l-1-1a.47.47 0 01-.15-.35v-2a.5.5 0 01.5-.5h2a.5.5 0 01.5.5v2z",
            fill: "currentColor"
        })
    });



const $6bb02d5997138052$export$4732333d7648adf5 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 11a4.5 4.5 0 10-4.5-4.5A4.51 4.51 0 0012 11zm2.47 1.39l-1.9 1.41a1 1 0 01-1.2 0l-1.88-1.39A8 8 0 004 20a2 2 0 002 2h12a2 2 0 002-2 8 8 0 00-5.53-7.61zM10 20H7a1 1 0 010-2h3a1 1 0 010 2zm6 0a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $7655b27ef12de96d$export$a48b792f79593ffd = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.94 11.51l-2-8A2 2 0 0016 2H8a2 2 0 00-1.94 1.51l-2 8A2 2 0 006 14h5v6H8a1 1 0 000 2h8a1 1 0 000-2h-3v-6h5a2 2 0 001.94-2.49z",
            fill: "currentColor"
        })
    });



const $9e9a89ad48a9da67$export$af74cfcf355383c9 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21 4a5.67 5.67 0 00-2.66.59A3.82 3.82 0 0116.5 5a3.84 3.84 0 01-1.85-.41A5.66 5.66 0 0012 4a5.67 5.67 0 00-2.66.59A3.82 3.82 0 017.5 5a3.84 3.84 0 01-1.85-.41A5.59 5.59 0 003 4a1 1 0 00-1 1v14a1 1 0 001 1h18a1 1 0 001-1V5a1 1 0 00-1-1zM4 9a1 1 0 011-1h2a1 1 0 010 2H5a1 1 0 01-1-1zm6 5H8a1 1 0 010-2h2a1 1 0 110 2zm0-5a1 1 0 011-1h2a1 1 0 110 2h-2a1 1 0 01-1-1zm6 5h-2a1 1 0 010-2h2a1 1 0 110 2zm3-4h-2a1 1 0 110-2h2a1 1 0 110 2z",
            fill: "currentColor"
        })
    });



const $9085c81869a1154d$export$3faa0bb8b7d67c62 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.45 13.28c-.28-.14-1.89-.78-5.82.79-1.7.68-2.46 0-3.88-1.59S7.4 8.81 3.68 10.05A1 1 0 003 11v9a1 1 0 001 1h16a1 1 0 001-1v-5.83a1 1 0 00-.55-.89zM14 12h1.17a3 3 0 002.12-.88l2.42-2.41a1 1 0 000-1.42l-.8-.79 1.8-1.79a1.004 1.004 0 10-1.42-1.42l-1.79 1.8-.79-.8a1 1 0 00-1.42 0l-2.41 2.42A3 3 0 0012 8.83V10a2 2 0 002 2z",
            fill: "currentColor"
        })
    });



const $58bf7360d8f6cf8c$export$23e340b1238270a5 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 6a1 1 0 001-1V4a1 1 0 00-2 0v1a1 1 0 001 1zM7.4 7.9a1 1 0 000-1.41l-.7-.71a1 1 0 00-.7-.29 1 1 0 00-.921 1.385A1 1 0 005.3 7.2l.7.7a1 1 0 001.4 0zm-2.9 3.6h-1a1 1 0 000 2h1a1 1 0 000-2zm16.71.29a1 1 0 00-.71-.29h-1a1 1 0 000 2h1a1 1 0 00.71-1.71zM19 6.49a1 1 0 00-1.71-.71l-.7.71a1 1 0 000 1.41 1 1 0 001.4 0l.72-.7a1 1 0 00.29-.71zM14 19h-4a1 1 0 000 2h4a1 1 0 000-2zm1.56-10.85a6 6 0 00-7.09 0 5.87 5.87 0 00.43 9.66 1 1 0 00.53.15H11v-3.21l-1-1a1 1 0 01-.22-.33.94.94 0 010-.76 1 1 0 011.63-.33L12 13l.63-.63a1 1 0 011.63.33.94.94 0 010 .76 1 1 0 01-.22.33l-1 1V18h1.57a1 1 0 00.53-.15 5.86 5.86 0 00.38-9.7h.04z",
            fill: "currentColor"
        })
    });



const $a116444a19d71c61$export$565288cc611e825e = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M11.5 6a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM20 17h-4.51a43.381 43.381 0 00-3-4.35V9.8A10 10 0 0017 11a1 1 0 000-2 9 9 0 01-4.88-1.78.53.53 0 00-.1-.06.82.82 0 00-.19-.09h-.37a.65.65 0 00-.2 0 .51.51 0 00-.13 0 11.94 11.94 0 00-5 4.38 1 1 0 00.28 1.38A.94.94 0 007 13a1 1 0 00.83-.45 11.141 11.141 0 012.67-2.8v3.19A10 10 0 018.93 17H4a1 1 0 000 2h2.74c-.065.033-.129.07-.19.11A1 1 0 007 21a.93.93 0 00.45-.11A8.13 8.13 0 009.9 19h4.44c.26.46.52.95.77 1.45A1 1 0 0016 21a.93.93 0 00.45-.11 1 1 0 00.44-1.34c-.09-.18-.18-.37-.28-.55H20a1 1 0 000-2zm-8.73 0c.288-.55.532-1.122.73-1.71.35.49.74 1.06 1.15 1.71h-1.88z",
            fill: "currentColor"
        })
    });



const $ca98090f46bc8d68$export$f3b0fea55b08bf1f = (l)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M13.4 18.15c0-.19.03-.37.06-.56-1.72-.38-3.02-1.92-3.02-3.75 0-2.12 1.73-3.85 3.85-3.85.94 0 1.79.35 2.46.92.28-.23.58-.43.91-.58l-4.81-7.86c-.09-.14-.21-.26-.36-.35-.15-.08-.32-.13-.49-.13-.17 0-.34.04-.49.13a.93.93 0 00-.36.35L6.3 10.39a8.79 8.79 0 00-1.3 4.6 7.001 7.001 0 007 7c1.06 0 2.1-.25 3.04-.7-.99-.7-1.64-1.84-1.64-3.14zM20.74 12.81c-.13-.2-.3-.37-.5-.5a1.821 1.821 0 00-1.4-.28c-.24.05-.46.15-.66.28-.1.07-.19.14-.27.23 0 0 0 .01-.01.02.15.41.24.84.24 1.29 0 .19-.03.37-.06.56.76.17 1.43.56 1.94 1.1.08-.04.15-.07.23-.12.2-.13.37-.3.5-.5a1.821 1.821 0 000-2.06l-.01-.02z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M15.32 12.32a1.821 1.821 0 00-1.75-.17c-.66.28-1.13.94-1.13 1.7s.46 1.42 1.13 1.7c.22.09.46.15.72.15h.03c.44-.52 1.02-.93 1.68-1.15.09-.21.14-.44.14-.69 0-.38-.12-.74-.32-1.03-.06-.09-.13-.18-.21-.26-.09-.09-.18-.17-.29-.24v-.01zM17.97 16.45a1.89 1.89 0 00-.72-.15c-.26 0-.5.05-.72.15-.45.19-.81.56-.99 1.01-.09.21-.14.44-.14.69 0 .76.46 1.42 1.13 1.7.22.09.46.15.72.15.26 0 .5-.05.72-.15.66-.28 1.13-.94 1.13-1.7 0-.17-.03-.33-.07-.48-.15-.55-.54-1-1.06-1.22z",
                fill: "currentColor"
            })
        ]
    });



const $c47e460af04c97ca$export$efcef6ed5d8a0c88 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16.5 12a3.5 3.5 0 100-7 3.5 3.5 0 000 7zm3.05 2.72L18 15.5V14a1 1 0 00-1-1H7a1 1 0 00-1 1v6a1 1 0 001 1h10a1 1 0 001-1v-1.5l1.55.78a1 1 0 001.45-.9v-2.76a1 1 0 00-1.45-.9zM12 7.5A4.5 4.5 0 107.5 12 4.49 4.49 0 0012 7.5z",
            fill: "currentColor"
        })
    });



const $43c8d8aad0ba4fe7$export$4a4be8bdf6b374ee = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.5 6H18V4c0-.55-.45-1-1-1s-1 .45-1 1v8c2.76 0 5-2.24 5-5v-.5c0-.28-.22-.5-.5-.5zM16.45 16.11a2.597 2.597 0 01-1.42-1.86c-.4.64-.91 1.21-1.51 1.68.36.7.98 1.44 2.03 1.97a1.007 1.007 0 001.35-.44.993.993 0 00-.45-1.34v-.01zM13 6H6C4.34 6 3 7.27 3 8.83v7.28c0 .14.02.28.05.42.01.04.03.08.04.13.03.09.06.17.1.26.02.05.05.09.08.13.04.07.09.14.14.21a2.81 2.81 0 00.29.29c.04.03.08.07.13.1.07.05.15.09.23.13.04.02.09.05.13.07.09.04.19.07.29.1.03 0 .07.02.1.03.14.03.28.04.42.04.16 0 .32-.02.48-.06 1.14-.28 2.39-.79 3.1-1.75.16-.22.35-.41.58-.56.23-.15.55-.27.83-.31-.02.01.07-.02 0 0V17c0 .06-.05 1.42-1.45 2.12-.49.25-.69.85-.45 1.34a1.007 1.007 0 001.35.44c2.52-1.26 2.55-3.79 2.55-3.89v-2.47c1.22-.83 2-2.17 2-3.66V7.02c0-.55-.45-1-1-1L13 6z",
            fill: "currentColor"
        })
    });



const $3250bd0d70f3875f$export$78156f0e09933ee7 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4.73 3.32a1 1 0 00-1.46 1.36l6 6.39L8.28 14H6a1 1 0 00-.93.63l-2 5a1 1 0 101.86.74L6.68 16H9a1 1 0 00.95-.68l.86-2.59L12 14v3H9a1 1 0 00-1 1v2a1 1 0 001 1h10a1 1 0 00.73-1.68l-15-16zM11.5 7a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM19 9h-2a1 1 0 00-1 1v2.41l.55.59L20 16.68V10a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $ef50e5b899157e39$export$fd0f8f626bbe56fb = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M6.13 7.1c.431-.94.95-1.837 1.55-2.68A12.568 12.568 0 006 4a1 1 0 00-1.07.62A14.5 14.5 0 004.24 7c.631-.002 1.262.031 1.89.1zM19.76 7c-.15-.807-.367-1.6-.65-2.37A1 1 0 0018 4c-.579.098-1.15.235-1.71.41.61.845 1.14 1.745 1.58 2.69a16.887 16.887 0 011.89-.1zm2.18 2.94a1 1 0 00-.88-.88 11.578 11.578 0 00-1.3-.06c-.34 0-.74 0-1.17.05A11.3 11.3 0 0119 12a14 14 0 01-3.54 8.7 8.49 8.49 0 004-2.12c3.1-3.07 2.54-8.42 2.48-8.64zM5.41 9.05C5 9 4.58 9 4.24 9c-.434-.004-.868.016-1.3.06a1 1 0 00-.88.88c0 .22-.62 5.57 2.44 8.64a8.56 8.56 0 004 2.12A14 14 0 015 12a11.3 11.3 0 01.41-2.95zm7.26-5.8A1 1 0 0012 3a1 1 0 00-.67.25C11.15 3.41 7 7.19 7 12c0 4.81 4.15 8.59 4.33 8.75A1 1 0 0012 21a1 1 0 00.67-.25C12.84 20.59 17 16.81 17 12c0-4.81-4.16-8.59-4.33-8.75z",
            fill: "currentColor"
        })
    });



const $61f33f55121e3960$export$ae29d11d335403e = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M2 10v8a3 3 0 003 3V7a3 3 0 00-3 3zm17-3v14a3 3 0 003-3v-8a3 3 0 00-3-3zm-5-4h-4a3 3 0 00-3 3v15h10V6a3 3 0 00-3-3zm1 4H9V6a1 1 0 011-1h4a1 1 0 011 1v1z",
            fill: "currentColor"
        })
    });



const $aaed93788041533c$export$7514083d2eb10f8b = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 6a2 2 0 00-2 2v.59l-1-1V4a1 1 0 00-2 0v3.59l-1 1V8a2 2 0 00-2-2 5 5 0 00-5 5v8a2 2 0 002 2 2 2 0 001.14-.36l.41-.28A8 8 0 0010 13.78v-2.37l2-2 2 2v2.37a8 8 0 003.45 6.58l.41.28A2 2 0 0019 21a2 2 0 002-2v-8a5 5 0 00-5-5z",
            fill: "currentColor"
        })
    });



const $c205cb92764a5843$export$14bf6fa282077072 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 10a1 1 0 00.58-.19l7-5a1 1 0 10-1.16-1.62l-7 5A1 1 0 0012 10zm7 1H5a1 1 0 000 2h14a1 1 0 000-2zM8 9a1 1 0 100-2 1 1 0 000 2zM6 20a2 2 0 002 2h8a2 2 0 002-2v-5H6v5zM5.5 5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
            fill: "currentColor"
        })
    });



const $ab9e226e4f0971ed$export$97aff6198d11f1e5 = (o)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M19.7 6.46A2.66 2.66 0 0017.34 5H6.67c-1.03 0-1.92.6-2.36 1.46l7.7 4.62 7.7-4.62h-.01z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12.91 12.6a1.779 1.779 0 01-1.84.01L3.99 8.35v7.98c0 1.48 1.19 2.67 2.67 2.67h10.67c1.48 0 2.67-1.19 2.67-2.67V8.35l-7.08 4.25h-.01z",
                fill: "currentColor"
            })
        ]
    });



const $cafba6fdc340c369$export$a46a560508ae4e64 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10.78 10.84a4.51 4.51 0 005.56-5.56 4.46 4.46 0 00-3.12-3.12 4.51 4.51 0 00-5.56 5.56 4.46 4.46 0 003.12 3.12zm4.49 1.86l-.38.75a1 1 0 01-.73.54H14a1 1 0 01-.71-.29L12 12.41l-1.29 1.3A1 1 0 0110 14h-.16a1 1 0 01-.73-.54l-.38-.75A8 8 0 004 20a2 2 0 002 2h12a2 2 0 002-2 8 8 0 00-4.73-7.3zM10 20H8a1 1 0 010-2h2a1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $becf11a9e233fa20$export$8ddd93fb1fbcb1bb = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10.16 5.87L9.92 7.3a.61.61 0 00.25.59.63.63 0 00.64.04L12 7.27l1.19.66a.63.63 0 00.64-.04.61.61 0 00.25-.59l-.24-1.43 1-1a.6.6 0 00-.34-1l-1.34-.2-.61-1.29a.59.59 0 00-1.08 0l-.61 1.29-1.34.2a.6.6 0 00-.34 1l.98 1zM18 10H6a2 2 0 100 4v6a2 2 0 002 2h8a2 2 0 002-2v-6a2 2 0 000-4z",
            fill: "currentColor"
        })
    });



const $e14cb70cfb039023$export$d5acf4c84a51772a = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 8h-1v-.31a2 2 0 00-1.22-1.84l-4-1.69a2 2 0 00-1.56 0l-4 1.69A2 2 0 006 7.69V8H5a3 3 0 00-3 3v2a3 3 0 003 3h1a4.44 4.44 0 004.35 4h3.2A4.44 4.44 0 0018 16h1a3 3 0 003-3v-2a3 3 0 00-3-3zM6 14H5a1 1 0 01-1-1v-2a1 1 0 011-1h1v4zm14-1a1 1 0 01-1 1h-1v-4h1a1 1 0 011 1v2z",
            fill: "currentColor"
        })
    });



const $de8439f31c00961d$export$db1f674ce900d408 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M5.76 14H5a1 1 0 01-1-1v-2a1 1 0 011-1h1v3.76L14.76 5l-2-.84a2 2 0 00-1.56 0l-4 1.69A2 2 0 006 7.69V8H5a3 3 0 00-3 3v2a3 3 0 002 2.8L5.76 14zM19 8h-1v-.31a2.128 2.128 0 000-.25l2.73-2.73a1.005 1.005 0 00-.71-1.714 1.004 1.004 0 00-.71.294l-16 16a1 1 0 000 1.42.998.998 0 001.42 0l2.34-2.35A4.28 4.28 0 0010.4 20h3.2a4.44 4.44 0 004.4-4h1a3 3 0 003-3v-2a3 3 0 00-3-3zm1 5a1 1 0 01-1 1h-1v-4h1a1 1 0 011 1v2z",
            fill: "currentColor"
        })
    });



const $bb0a26902b98436b$export$1e2c678254c30f4e = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.27 2.73a2.52 2.52 0 00-3.54 0l-1.5 1.5a2.51 2.51 0 00-.56 2.68l-1.38 1.38a1 1 0 00-.24 1l.81 2.41-1.65 1.65-1.8-1.79a2 2 0 00-2.82 0l-1 1A2 2 0 005 13.67l-1 6A2 2 0 006 22c.11.01.22.01.33 0l6-1a2 2 0 001.08-.56l1-1a2 2 0 000-2.82l-1.79-1.8 2.09-2.08a1 1 0 00.24-1l-.81-2.41.95-.94c.294.09.603.128.91.11a2.49 2.49 0 001.77-.73l1.5-1.5a2.52 2.52 0 000-3.54z",
            fill: "currentColor"
        })
    });



const $f41d0bf6974b6fad$export$acbb8463c98860d2 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 7a1 1 0 00.71-.29A.998.998 0 0013 6a1.05 1.05 0 00-.29-.71A1.001 1.001 0 0012 5H7a1 1 0 00-1 .68L4.7 9.74l-.87-1.29A1.1 1.1 0 003.19 8a.94.94 0 00-.41 0 .84.84 0 00-.38.15 1 1 0 00-.29.29.93.93 0 00-.11.33 1.12 1.12 0 000 .41 1 1 0 00.19.37l2 3A1 1 0 005 13h.13a1 1 0 00.87-.68L7.72 7H12zm-3 5.5a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0zm5 2.5H7a1 1 0 000 2h7a1 1 0 100-2zm-3.5 3a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm11.21-8.71A1.001 1.001 0 0021 9h-2V7a1 1 0 00-2 0v2h-2a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 00.71-1.71z",
            fill: "currentColor"
        })
    });



const $92b78d91c8115fc9$export$2a48653e7ad7bf8 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.12 6.88A3 3 0 0019 6h-6.59l-1.12-1.12A3 3 0 009.17 4H5a3 3 0 00-3 3v10a3 3 0 003 3h14a3 3 0 003-3V9a3 3 0 00-.88-2.12zm-5.58 9.66a5 5 0 01-8.16-1.63A4.93 4.93 0 017.1 12 5 5 0 0111 8.1a4.93 4.93 0 012.89.28 5 5 0 011.63 8.16h.02zM14 12h-1v-1a1 1 0 00-2 0v1h-1a1 1 0 000 2h1v1a1 1 0 002 0v-1h1a1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $453094ea31c40d93$export$b51205ce4dda5850 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M14 14h-1v-1a1 1 0 00-2 0v1h-1a1 1 0 000 2h1v1a1 1 0 002 0v-1h1a1 1 0 000-2zm5.12-10.12A3 3 0 0017 3h-1.28a2 2 0 00-.72-.73A2 2 0 0014 2h-4a2 2 0 00-1 .27 2 2 0 00-.72.73H7a3 3 0 00-3 3v13a3 3 0 003 3h10a3 3 0 003-3V6a3 3 0 00-.88-2.12zm-3.58 14.66a5 5 0 01-8.16-1.63A4.93 4.93 0 017.1 14a5 5 0 013.9-3.9 4.93 4.93 0 012.89.28 5 5 0 011.63 8.16h.02zM18 8H6V6a1 1 0 011-1h1.28a2 2 0 00.72.73A2 2 0 0010 6h4a2 2 0 001-.27 2 2 0 00.72-.73H17a1 1 0 011 1v2z",
            fill: "currentColor"
        })
    });



const $81cb4038a91db092$export$8a3a3d745ba24845 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M14 11h-1v-1a1 1 0 00-2 0v1h-1a1 1 0 000 2h1v1a1 1 0 002 0v-1h1a1 1 0 000-2zm6.46-6.32a2 2 0 00-1.3-.68 18.78 18.78 0 01-6.34-1.83 1.86 1.86 0 00-1.64 0A18.5 18.5 0 014.88 4 2.06 2.06 0 003 6v5c0 6.74 6.75 11 9 11s9-4.25 9-11V6a2 2 0 00-.54-1.32zm-4.92 10.86a5 5 0 01-8.16-1.63A4.93 4.93 0 017.1 11 5 5 0 0111 7.1a4.93 4.93 0 012.89.28 5 5 0 011.63 8.16h.02z",
            fill: "currentColor"
        })
    });



const $a7901c29a9acd328$export$f9b11b388597c961 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.12 8.71L18 7.59A2 2 0 0016.59 7H17a2 2 0 002-2V4a2 2 0 00-2-2H7a2 2 0 00-2 2v1a2 2 0 002 2h.41A2 2 0 006 7.59L4.88 8.71A3 3 0 004 10.83V19a3 3 0 003 3h10a3 3 0 003-3v-8.17a3 3 0 00-.88-2.12zM14 15h-1v1a1 1 0 01-2 0v-1h-1a1 1 0 010-2h1v-1a1 1 0 012 0v1h1a1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $a6b6170b2f3fe20f$export$2a9cd6c5931ab59f = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.63 6.16a2 2 0 00-3.26-2.32L14.4 8h4.92l1.31-1.84zM20 10H4a1 1 0 00-1 1 9 9 0 005 8.05V20a1 1 0 001 1h6a1 1 0 001-1v-.95a9 9 0 005-8A1 1 0 0020 10zm-6 6h-1v1a1 1 0 01-2 0v-1h-1a1 1 0 010-2h1v-1a1 1 0 012 0v1h1a1 1 0 110 2z",
            fill: "currentColor"
        })
    });



const $9bb33afea0f9fb47$export$d78ee7c5a667ef68 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4 7h1v1a1 1 0 102 0V7h1a1 1 0 000-2H7V4a1 1 0 00-2 0v1H4a1 1 0 000 2zm16-2a4.44 4.44 0 00-6.43-.42l-4 3.6 6.29 6.29 3.71-3.36A4.44 4.44 0 0020 5zM4.4 12.89a4.44 4.44 0 106 6.53l4-3.6-6.29-6.29-3.71 3.36z",
            fill: "currentColor"
        })
    });



const $e95e2e893db57749$export$ed1be55c0cd96d88 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21 4a1 1 0 00-1 1v.5L4 10a1 1 0 00-2 0v4a1 1 0 102 0l3 .85A.77.77 0 007 15a4 4 0 007.47 2L20 18.5v.5a1 1 0 002 0V5a1 1 0 00-1-1zM11 17a2 2 0 01-1.95-1.58l3.4 1A2 2 0 0111 17z",
            fill: "currentColor"
        })
    });



const $b3479ef643a5447b$export$440a0f8f9ac395f2 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16.74 12.33A5.995 5.995 0 0013 10.09V5.41l2.29 2.3c.09.09.2.17.33.22.12.05.25.08.38.08s.26-.03.38-.08.23-.13.33-.22c.09-.09.17-.2.22-.33.05-.12.08-.25.08-.38s-.03-.26-.08-.38a1.19 1.19 0 00-.22-.33l-4-4a.955.955 0 00-.33-.22.995.995 0 00-.38-.08c-.13 0-.26.03-.38.08s-.23.13-.33.22l-4 4a1.036 1.036 0 00-.3.71c0 .13.03.26.08.38a1.004 1.004 0 00.55.55c.12.05.25.08.38.08s.26-.03.38-.08.23-.12.33-.22L11 5.41v4.68a5.995 5.995 0 00-3.74 2.24 6.043 6.043 0 00-1.24 4.18c.13 1.5.81 2.9 1.92 3.91A5.998 5.998 0 0012 22c1.5 0 2.95-.57 4.06-1.58a6.023 6.023 0 001.92-3.91c.13-1.5-.32-2.99-1.24-4.18zm-1.91 6.5a4.004 4.004 0 01-5.05.5 3.93 3.93 0 01-1.47-1.8c-.3-.73-.38-1.54-.23-2.31.15-.78.54-1.49 1.09-2.05.55-.56 1.27-.94 2.05-1.09a3.97 3.97 0 012.31.23c.73.3 1.36.82 1.8 1.47a4.004 4.004 0 01-.5 5.05zm-1.18-4.45c-.11-.12-.24-.21-.39-.28-.15-.06-.3-.1-.46-.1-.3.01-.58.13-.8.34-.22-.21-.5-.33-.8-.34-.16 0-.32.03-.46.1-.15.06-.28.16-.39.28-.11.12-.2.26-.26.42-.06.16-.09.32-.09.49 0 .79.58 1.51 1.59 2.49l.11.1c.08.08.19.12.3.12.11 0 .22-.04.3-.12l.11-.1c1.01-.98 1.59-1.7 1.59-2.49 0-.17-.03-.33-.09-.49-.06-.16-.15-.3-.26-.42z",
            fill: "currentColor"
        })
    });



const $141e73a6373ab44c$export$e7060ce45e6f3b41 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 2H7a3 3 0 00-3 3v14a3 3 0 003 3h10a3 3 0 003-3V5a3 3 0 00-3-3zm-3 16h-4a1 1 0 010-2h4a1 1 0 010 2zm1-6v1a1 1 0 01-1 1h-4a1 1 0 01-1-1v-1a2 2 0 110-4h.18a3 3 0 015.64 0H15a2 2 0 010 4z",
            fill: "currentColor"
        })
    });



const $8a98ffacea5e5039$export$3d1a2ab37ffc5d77 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 2H7a3 3 0 00-3 3v14a3 3 0 003 3h10a3 3 0 003-3V5a3 3 0 00-3-3zm-1 15H8a1 1 0 010-2h8a1 1 0 010 2zm0-4H8a1 1 0 010-2 4 4 0 013-3.86V7a1 1 0 012 0v.14A4 4 0 0116 11a1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $177fce6ac8ad6989$export$26101ef99ad7de12 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10 13a1 1 0 00-1-1V6a1 1 0 00-2 0v6H6v-2a1 1 0 00-2 0v2a1 1 0 100 2h5a1 1 0 001-1zm10.71-8.71l-1-1a1 1 0 00-1.58 1.17l-1.76 1.75a2 2 0 00-2.42.3l-3.72 3.72a1 1 0 000 1.42l2.12 2.12a1.002 1.002 0 001.42 0l1.71-1.71A4 4 0 019.36 17H10a1 1 0 000-2H6a1 1 0 100 2h.82a6 6 0 001.87 2H7.5a1 1 0 100 2h9a1 1 0 000-2h-1.19A6 6 0 0018 14a5.91 5.91 0 00-1.07-3.39l.56-.56a2 2 0 00.3-2.42l1.75-1.76A1 1 0 0020 6a1 1 0 00.71-1.71z",
            fill: "currentColor"
        })
    });



const $043d8242e6942453$export$4bf60c32123440dd = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16.83 6.41L15.6 5.19A2 2 0 0016 4a2 2 0 00-2-2h-4a2 2 0 00-2 2 2 2 0 00.4 1.19L7.17 6.41A4 4 0 006 9.24V19a3 3 0 003 3h6a3 3 0 003-3V9.24a4 4 0 00-1.17-2.83zM16 10c-3.71.23-4.29 1.71-8 1.94v-2.7a2 2 0 01.59-1.41L10.41 6h3.18l1.82 1.83A2 2 0 0116 9.24V10z",
            fill: "currentColor"
        })
    });



const $c9a749160297a270$export$7779d411bc029143 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16.83 6.41L15.6 5.19A2 2 0 0016 4a2 2 0 00-2-2h-4a2 2 0 00-2 2 2 2 0 00.4 1.19L7.17 6.41A4 4 0 006 9.24V19a3 3 0 003 3h6a3 3 0 003-3V9.24a4 4 0 00-1.17-2.83zM16 15c-3.71.23-4.29 1.71-8 1.94v-7.7a2 2 0 01.59-1.41L10.41 6h3.18l1.82 1.83A2 2 0 0116 9.24V15z",
            fill: "currentColor"
        })
    });



const $0bf2a51236a2c541$export$61892328a023fa40 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M6.25 15.5a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zm-1.5 3a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zm13.5-3a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zm-1.5 3a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zm2.69-10.12c.03-.21.06-.42.06-.63C19.5 5.13 17.37 3 14.75 3c-1.64 0-3.08.83-3.93 2.09A3.68 3.68 0 0010 5a3.98 3.98 0 00-3.86 3.01C6.09 8.01 6.05 8 6 8c-1.66 0-3 1.34-3 3s1.34 3 3 3h12c1.66 0 3-1.34 3-3 0-1.13-.64-2.11-1.56-2.62zM11 15.63c-.48-.28-1.09-.11-1.37.37l-2 3.46c-.28.48-.11 1.09.37 1.37s1.09.11 1.37-.37l2-3.46c.28-.48.11-1.09-.37-1.37zm4 0c-.48-.28-1.09-.11-1.37.37l-2 3.46c-.28.48-.11 1.09.37 1.37s1.09.11 1.37-.37l2-3.46c.28-.48.11-1.09-.37-1.37z",
            fill: "currentColor"
        })
    });



const $28f1317b5c4f2463$export$19d16c8b2097b21 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.89 9.68a8 8 0 00-2.54-4.62l1.36-1.35a1.004 1.004 0 10-1.42-1.42L15.68 3.9a8 8 0 00-7.36 0L6.71 2.29a1 1 0 00-.33-.22 1.07 1.07 0 00-.76 0 1 1 0 00-.33 1.64l1.36 1.35A8 8 0 005 14.87V19a1 1 0 102 0v-1.76c.605.486 1.28.88 2 1.17V21a1 1 0 102 0v-2.07c.332.043.666.067 1 .07a8.38 8.38 0 001-.07V21a1 1 0 102 0v-2.59a7.888 7.888 0 002-1.17V19a1 1 0 102 0v-4.13a8.07 8.07 0 00.89-5.19zm-12.6 1a1 1 0 01-.12-1.27.94.94 0 01.45-.36A1 1 0 018.2 9a1 1 0 01.8.8 1 1 0 01-.06.58.94.94 0 01-.36.45 1 1 0 01-1.27-.12l-.02-.03zm8.3 3.53a1 1 0 01-.31.51 4.93 4.93 0 01-6.56 0 1 1 0 01-.31-.51 1.08 1.08 0 010-.59 1 1 0 01.36-.47 1 1 0 01.61-.15h5.24a1 1 0 01.57.18 1 1 0 01.36.47c.068.19.082.393.04.59v-.03zm1.12-3.53a1 1 0 01-1.27.12.94.94 0 01-.36-.45A1 1 0 0115 9.8a1 1 0 01.8-.8 1 1 0 01.58.06.94.94 0 01.45.36 1 1 0 01-.12 1.27v-.01z",
            fill: "currentColor"
        })
    });



const $835f513f58dfc294$export$941115b64be482bc = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.95 10.98a9.781 9.781 0 00-.74-2.87c-.21-.49-.46-.94-.73-1.39-.39-.62-.84-1.21-1.35-1.73l-.06-.06-.06-.06c-.52-.51-1.1-.96-1.73-1.35-.44-.28-.9-.53-1.39-.73-.3-.13-.61-.24-.92-.34-.63-.19-1.28-.33-1.95-.4C12.68 2.02 12.34 2 12 2 6.48 2 2 6.48 2 12s4.48 10 10 10a9.781 9.781 0 002.97-.45c.63-.2 1.23-.45 1.79-.76 1.13-.62 2.13-1.44 2.95-2.43a9.6 9.6 0 001.5-2.47c.51-1.2.79-2.51.79-3.89 0-.35-.02-.69-.05-1.02zM4 12c0-4.41 3.59-8 8-8v16c-4.41 0-8-3.59-8-8z",
            fill: "currentColor"
        })
    });



const $4b0626270662670c$export$936dcbbffba5c0f1 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2c-1.38 0-2.7.28-3.89.79a9.6 9.6 0 00-2.47 1.5c-1.98 1.63-3.31 4-3.59 6.69-.03.34-.05.68-.05 1.02 0 5.52 4.48 10 10 10s10-4.48 10-10S17.52 2 12 2zm0 18V4c4.41 0 8 3.59 8 8s-3.59 8-8 8z",
            fill: "currentColor"
        })
    });



const $13a74de0397f995b$export$b6b92e6479e5c77a = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z",
            fill: "currentColor"
        })
    });



const $8bc55ec8839d9c0a$export$e442101b663fb8ec = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 4c4.41 0 8 3.59 8 8s-3.59 8-8 8-8-3.59-8-8 3.59-8 8-8zm0-2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z",
            fill: "currentColor"
        })
    });



const $65fafb1ced35f48e$export$6a438c4a3730972b = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M8.05 14.96c-1.66.21-3.24-.09-4.6-.77-.87-.44-1.77.49-1.34 1.35.71 1.41 1.75 2.62 3 3.55a4.034 4.034 0 012.15-2.69c.18-.53.45-1.01.78-1.44h.01zm5.61-3.47c.73-.32 1.53-.49 2.34-.49 1.9 0 3.64.92 4.75 2.37.13-.53.22-1.08.26-1.64a9.976 9.976 0 00-5.48-9.61c-.87-.44-1.79.47-1.35 1.34.71 1.41 1.02 3.05.76 4.79-.17 1.19-.64 2.29-1.29 3.25l.01-.01zm6.25 4.66A4.001 4.001 0 0016 13c-1.5 0-2.79.83-3.47 2.05A2.996 2.996 0 009 18c-1.1 0-2 .9-2 2s.9 2 2 2h10a2.996 2.996 0 00.91-5.85z",
            fill: "currentColor"
        })
    });



const $40311e2ac206c372$export$baf5fe533c27eadf = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 22c5.52 0 10-4.48 10-10S17.52 2 12 2 2 6.48 2 12s4.48 10 10 10zm8-10c0 4.41-3.59 8-8 8-.85 0-1.67-.14-2.44-.38C7.39 17.79 6 15.07 6 12c0-3.07 1.39-5.78 3.56-7.62C10.33 4.13 11.15 4 12 4c4.41 0 8 3.59 8 8z",
            fill: "currentColor"
        })
    });



const $1e060e7a98a1a274$export$bf6004b5cd1fe7c6 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 22c5.52 0 10-4.48 10-10S17.52 2 12 2 2 6.48 2 12s4.48 10 10 10zm8-10c0 4.4-3.57 7.98-7.97 8C9.59 18.18 8 15.28 8 12c0-3.28 1.59-6.18 4.03-8 4.4.02 7.97 3.6 7.97 8z",
            fill: "currentColor"
        })
    });



const $287aee4453800780$export$7bd5a186a9bca887 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 22c5.52 0 10-4.48 10-10S17.52 2 12 2 2 6.48 2 12s4.48 10 10 10zm8-10c0 4.41-3.59 8-8 8h-.03c2.44-1.82 4.03-4.72 4.03-8 0-3.28-1.59-6.18-4.03-8H12c4.41 0 8 3.59 8 8z",
            fill: "currentColor"
        })
    });



const $7bbd549e030a7820$export$5c22245ea70164f0 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 22c5.52 0 10-4.48 10-10S17.52 2 12 2 2 6.48 2 12s4.48 10 10 10zm8-10c0 3.56-2.34 6.58-5.56 7.62C16.61 17.79 18 15.07 18 12c0-3.07-1.39-5.78-3.56-7.62C17.66 5.42 20 8.44 20 12z",
            fill: "currentColor"
        })
    });



const $16bd7741c91bcc47$export$2be10b69258c7e3e = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-4.41 3.59-8 8-8 .85 0 1.67.14 2.44.38C16.61 6.21 18 8.93 18 12c0 3.07-1.39 5.78-3.56 7.62-.77.25-1.59.38-2.44.38-4.41 0-8-3.59-8-8z",
            fill: "currentColor"
        })
    });



const $ed12add4615e5a7d$export$4354490fa8408d89 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-4.4 3.57-7.98 7.97-8C14.41 5.82 16 8.72 16 12c0 3.28-1.59 6.18-4.03 8C7.57 19.98 4 16.4 4 12z",
            fill: "currentColor"
        })
    });



const $cade93cdc920503c$export$e74e6c5822c7fdb5 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-4.41 3.59-8 8-8h.03C9.59 5.82 8 8.72 8 12c0 3.28 1.59 6.18 4.03 8H12c-4.41 0-8-3.59-8-8z",
            fill: "currentColor"
        })
    });



const $669e29de774b304b$export$16df943d9a0b8bbe = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-3.56 2.34-6.58 5.56-7.62C7.39 6.21 6 8.93 6 12c0 3.07 1.39 5.78 3.56 7.62C6.34 18.58 4 15.56 4 12z",
            fill: "currentColor"
        })
    });



const $4d35520ffa677725$export$5c671a1e279740f = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15 18H9c-.27 0-.52.11-.71.29A.99.99 0 008 19c0 .27.11.52.29.71.19.19.44.29.71.29h6c.27 0 .52-.11.71-.29.19-.18.29-.44.29-.71 0-.27-.11-.52-.29-.71A.973.973 0 0015 18zm3-4h-2.17a6.943 6.943 0 002.07-3.69c.56-2.86-.7-5.63-2.95-7.15-.74-.5-1.66.21-1.49 1.08.18.93.14 1.93-.17 2.92-.73 2.36-2.94 4.07-5.41 4.19-.59.03-1.15-.03-1.68-.15-.88-.21-1.51.82-1.02 1.58.29.44.63.85 1.01 1.21h-.18c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1L18 14z",
            fill: "currentColor"
        })
    });



const $00378bcae5b39e77$export$cb94a1dd3288de45 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 14H6c-.27 0-.52.11-.71.29-.19.18-.29.44-.29.71 0 .27.11.52.29.71.18.19.44.29.71.29h12c.27 0 .52-.11.71-.29.19-.18.29-.44.29-.71 0-.27-.11-.52-.29-.71A.973.973 0 0018 14zm-2 4H8c-.27 0-.52.11-.71.29-.19.18-.29.44-.29.71 0 .27.11.52.29.71.18.19.44.29.71.29h8c.27 0 .52-.11.71-.29.19-.18.29-.44.29-.71 0-.27-.11-.52-.29-.71A.973.973 0 0016 18zm4-8h-2.28c.07-.22.13-.45.18-.69.56-2.86-.7-5.63-2.95-7.15-.74-.5-1.66.21-1.49 1.08.18.93.14 1.93-.17 2.92-.56 1.79-1.96 3.2-3.69 3.83H4c-.55 0-1 .45-1 1s.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1V10z",
            fill: "currentColor"
        })
    });



const $f81813aa125f21d6$export$bf51f2bb7ef8d17f = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M11 6.13l-.39.24 2.76 2.76A12.81 12.81 0 0018 10a1 1 0 100-2 10.31 10.31 0 01-5.88-1.78A1 1 0 0011 6.13zM11.5 5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm9.21 14.29l-16-16a1.004 1.004 0 00-1.42 1.42l4.13 4.13a15.171 15.171 0 00-2.25 2.61 1 1 0 00.28 1.38A.94.94 0 006 13a1 1 0 00.83-.45 13.538 13.538 0 012-2.3l1.66 1.66v1c-.47 3.53-5.08 7.26-5.12 7.3a1 1 0 00-.16 1.4A1 1 0 006 22a1 1 0 00.62-.22c.19-.15 3.88-3.14 5.33-6.71 1.37 1.65 3.49 4.4 4.1 6.25A1 1 0 0017 22c.108-.003.216-.02.32-.05a1 1 0 00.68-1.27A13.994 13.994 0 0016.6 18l2.69 2.7a1.001 1.001 0 101.42-1.41z",
            fill: "currentColor"
        })
    });



const $3cbe2d37fe71c157$export$da2428f060f42398 = (o)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 15a3 3 0 100-6 3 3 0 000 6z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M6 19c-.26 0-.51-.1-.71-.29a.996.996 0 010-1.41l11.5-11.5a.996.996 0 111.41 1.41L6.7 18.71c-.2.2-.45.29-.71.29H6z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M18 9a3 3 0 100-6 3 3 0 000 6zM6 21a3 3 0 100-6 3 3 0 000 6zM18 15c-.59 0-1.14.18-1.61.48L8.52 7.61C8.82 7.14 9 6.59 9 6c0-1.66-1.34-3-3-3S3 4.34 3 6s1.34 3 3 3c.33 0 .63-.06.93-.16l8.24 8.24c-.1.29-.16.6-.16.93 0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3L18 15z",
                fill: "currentColor"
            })
        ]
    });



const $0d7d8bef060dc072$export$926e9a7894f55d8d = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18.56 3.17a1 1 0 00-.93-.1l-10 4A1 1 0 007 8v7.18A3.001 3.001 0 109 18V8.68l8-3.2v6.7A3.001 3.001 0 1019 15V4a1 1 0 00-.44-.83z",
            fill: "currentColor"
        })
    });



const $54761d13db33ce4e$export$96187277b46fb7db = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17.79 6.713c.008.296-.08.592-.256.832a1.35 1.35 0 01-.712.495l-3.678 1v7.636a3.32 3.32 0 01-2.047 3.07 3.351 3.351 0 01-1.918.192 3.32 3.32 0 01-1.704-.912 3.32 3.32 0 01-.72-3.622 3.275 3.275 0 011.224-1.487 3.301 3.301 0 011.847-.56c.224 0 .448.025.664.064V6.713c-.008-.296.08-.591.256-.831.175-.24.431-.416.711-.496l4.646-1.335c.2-.056.4-.064.6-.032.2.04.391.12.551.24.168.12.296.287.392.471.096.184.144.392.144.592v1.391z",
            fill: "currentColor"
        })
    });



const $9fe4a056ab6b31b0$export$c1a27d59a23d7838 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17.5 5.5a1 1 0 011 1 .5.5 0 001 0 1 1 0 011-1 .5.5 0 00.35-.85.47.47 0 00-.35-.15 1 1 0 01-1-1 .5.5 0 00-1 0 1 1 0 01-1 1 .5.5 0 00-.35.85.47.47 0 00.35.15zm-9 13a1 1 0 01-1-1 .5.5 0 00-1 0 1 1 0 01-1 1 .5.5 0 000 1 1 1 0 011 1 .5.5 0 101 0 1 1 0 011-1 .5.5 0 000-1zm12.08-8.32a1.16 1.16 0 00-.43-.18 1.06 1.06 0 00-.47 0l-3 1a1 1 0 00-.49.37.94.94 0 00-.19.63v5a2.17 2.17 0 00-.75.22 2 2 0 00-.62.49c-.166.2-.292.431-.37.68-.079.252-.11.517-.09.78.018.266.093.526.22.76a2 2 0 00.48.61c.204.169.438.297.69.38.252.081.517.108.78.08a2 2 0 001.22-.75 2.08 2.08 0 00.44-1.37v-5.17l2.32-.71a1 1 0 00.51-.38A1 1 0 0021 12v-1a.999.999 0 00-.11-.45 1.08 1.08 0 00-.31-.37zm-7-7a.93.93 0 00-.41-.2.9.9 0 00-.46 0l-7 2a1 1 0 00-.54.37A1 1 0 005 6v5a2 2 0 102 2V7.75l5-1.42V10a2 2 0 102 2V4a1 1 0 00-.11-.45.9.9 0 00-.29-.35l-.02-.02z",
            fill: "currentColor"
        })
    });



const $9de3f6c6ea51a62d$export$395dec7dca51f1af = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 7a4 4 0 10-8 0 4 4 0 008 0zm-8.79 3.79a1.004 1.004 0 10-1.42 1.42L7 13.37a.77.77 0 11-1.09 1.09l-1.32-1.29A2 2 0 014 11.76V7.53a1 1 0 00-2 0v4.23a4 4 0 001.17 2.83l2.54 2.53a1 1 0 01.29.71V19a1 1 0 001 1h3a1 1 0 001-1v-3.17a3 3 0 00-.88-2.12l-2.91-2.92zM21 6.53a1 1 0 00-1 1v4.23a2 2 0 01-.59 1.41l-1.28 1.29A.785.785 0 0117 13.37l1.17-1.16a1.004 1.004 0 10-1.42-1.42l-2.91 2.92a3 3 0 00-.84 2.12V19a1 1 0 001 1h3a1 1 0 001-1v-1.17a1 1 0 01.29-.71l2.54-2.53A3.999 3.999 0 0022 11.76V7.53a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $57ceee0dbece7e44$export$c2bb0381deb59187 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10.1 3a1 1 0 00-.71.18 1 1 0 00-.39.63l-1.92 9.71-.76.75-.46-.77A1.059 1.059 0 005 13H4a1 1 0 00-.85.48A1 1 0 003 14a.93.93 0 00.11.49l3 6c.07.142.173.265.3.36.129.09.275.152.43.18H7a1 1 0 00.38-.07c.123-.052.235-.127.33-.22l1-1a.94.94 0 00.29-.61 1 1 0 00-.13-.64l-.35-.59 1.9-1.9a2 2 0 00.58-1.4V4a1 1 0 00-.9-1zm10.75 10.5a1 1 0 00-.37-.34 1 1 0 00-.48-.12h-1a1 1 0 00-.49.13.998.998 0 00-.37.35l-.46.77-.76-.75L15 3.9a.941.941 0 00-.36-.67A1 1 0 0013.9 3a1 1 0 00-.67.37.999.999 0 00-.23.73v10.53a2 2 0 00.58 1.4l1.9 1.89-.35.58a1 1 0 00-.13.64c.031.218.129.42.28.58l1 1c.097.091.208.166.33.22A1 1 0 0017 21h.16a1.09 1.09 0 00.43-.18c.127-.095.23-.218.3-.36l3-6c.073-.142.11-.3.11-.46a1.08 1.08 0 00-.15-.49v-.01z",
            fill: "currentColor"
        })
    });



const $1c52f9f6f0e0f14a$export$998b5e55b33ec5c4 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17.89 9.11c.072-.366.11-.737.11-1.11A6 6 0 106 8c.001.373.038.744.11 1.11A4 4 0 007 17h4v3H9a1 1 0 000 2h6a1 1 0 100-2h-2v-3h4a4 4 0 00.89-7.89z",
            fill: "currentColor"
        })
    });



const $927f974b76c7f979$export$715c27260c4c096d = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16.12 3.64A6 6 0 006 8c0 .373.038.745.11 1.11a4 4 0 00-2.05 6.59L16.12 3.64zm1.77 5.47c.072-.365.109-.737.11-1.11.01-.176.01-.353 0-.53L20.49 5A1.053 1.053 0 0019 3.51L3.51 19A1.055 1.055 0 005 20.49L8.44 17H11v3H9a1 1 0 000 2h6a1 1 0 100-2h-2v-3h4a4 4 0 00.89-7.89z",
            fill: "currentColor"
        })
    });



const $f33f6566e36d1ea7$export$183bd45845e54110 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M14.94 8.24c-.5 3.43-3.28 6.2-6.7 6.7-1.74.26-3.38-.05-4.79-.76-.87-.44-1.77.49-1.34 1.35 1.74 3.45 5.42 5.76 9.61 5.48 4.91-.33 8.96-4.37 9.29-9.29a9.976 9.976 0 00-5.48-9.61c-.87-.44-1.79.47-1.35 1.34.71 1.41 1.02 3.05.76 4.79z",
            fill: "currentColor"
        })
    });



const $9ef769ec1947402d$export$c2f11e186632950a = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21 19c-.75 0-1.08-.3-1.59-.75C18.82 17.72 18 17 16.5 17c-1.5 0-2.32.72-2.91 1.25-.51.45-.84.75-1.59.75-.75 0-1.08-.3-1.59-.75C9.82 17.72 9 17 7.5 17c-1.5 0-2.32.72-2.91 1.25-.51.45-.84.75-1.59.75-.55 0-1 .45-1 1s.45 1 1 1c1.5 0 2.32-.72 2.91-1.25.51-.45.84-.75 1.59-.75.75 0 1.08.3 1.59.75C9.68 20.28 10.5 21 12 21c1.5 0 2.32-.72 2.91-1.25.51-.45.84-.75 1.59-.75.75 0 1.08.3 1.59.75.59.53 1.41 1.25 2.91 1.25.55 0 1-.45 1-1s-.45-1-1-1zm-9-4c-.55 0-1 .45-1 1s.45 1 1 1c1.35 0 2.2-.68 2.87-1.22.62-.5 1.01-.78 1.63-.78.62 0 1 .28 1.63.78.68.54 1.52 1.22 2.87 1.22.55 0 1-.45 1-1s-.45-1-1-1c-.62 0-1-.28-1.63-.78-.68-.54-1.52-1.22-2.87-1.22s-2.2.68-2.87 1.22c-.62.5-1.01.78-1.63.78zm-3 .98A3.002 3.002 0 0111.92 13c.12-.08.35-.26.45-.34.65-.52 1.68-1.33 3.2-1.58.22-.61.36-1.26.4-1.93.19-2.75-1.15-5.2-3.24-6.61-.8-.53-1.84.25-1.51 1.15.36.99.46 2.1.23 3.26-.46 2.24-2.27 4.05-4.51 4.51a5.85 5.85 0 01-3.26-.23c-.88-.32-1.69.69-1.17 1.48a7.37 7.37 0 006.48 3.28l.01-.01z",
            fill: "currentColor"
        })
    });



const $faffb7bcb25dceee$export$dcf1be572a14dffb = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15.17 14.5c.79-.64 1.78-1 2.83-1 .92 0 1.77.29 2.49.77.28-.81.46-1.66.52-2.54a9.976 9.976 0 00-5.48-9.61c-.87-.44-1.79.47-1.35 1.34.71 1.41 1.02 3.05.76 4.79-.5 3.43-3.28 6.2-6.7 6.7-1.74.26-3.38-.05-4.79-.76-.87-.44-1.77.49-1.34 1.35a9.957 9.957 0 007.43 5.38c-.02-.14-.04-.28-.04-.42 0-1.27.68-2.38 1.69-2.99a4.26 4.26 0 013.99-3.01h-.01zm5.32 3.57V18a2.5 2.5 0 00-4.58-1.39c-.21-.07-.44-.11-.67-.11-1.24 0-2.25 1.01-2.25 2.25 0 .09.02.17.03.25h-.03c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h7c1.1 0 2-.9 2-2 0-.93-.64-1.71-1.51-1.93h.01zM4.35 12.4c.66.33 1.37.53 2.1.6h1.03c.16-.01.31-.01.47-.03 2.42-.35 4.43-2.3 4.94-4.68a2.496 2.496 0 00-4.47-.68c-.21-.07-.44-.11-.67-.11-1.24 0-2.25 1.01-2.25 2.25 0 .09.02.17.03.25H5.5a1.498 1.498 0 00-1.22 2.37c.02.01.05.01.07.03z",
            fill: "currentColor"
        })
    });



const $ce9124e2680ae27a$export$879f7465bc64caf7 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.49 18.07V18a2.5 2.5 0 00-4.58-1.39c-.21-.07-.44-.11-.67-.11-1.24 0-2.25 1.01-2.25 2.25 0 .09.02.17.03.25h-.03c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h7c1.1 0 2-.9 2-2 0-.93-.64-1.71-1.51-1.93h.01zm-5.32-3.57c.79-.64 1.78-1 2.83-1 .91 0 1.75.28 2.46.75.28-.8.46-1.65.52-2.52a9.976 9.976 0 00-5.48-9.61c-.87-.44-1.79.47-1.35 1.34.71 1.41 1.02 3.05.76 4.79-.5 3.43-3.28 6.2-6.7 6.7-1.74.26-3.38-.05-4.79-.76-.87-.44-1.77.49-1.34 1.35a9.995 9.995 0 007.46 5.39c-.02-.14-.04-.28-.04-.42 0-1.27.68-2.38 1.69-2.99a4.26 4.26 0 013.99-3.01l-.01-.01z",
            fill: "currentColor"
        })
    });



const $7872ea92efc51ee8$export$f68205dc9eed048 = (s)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...s,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.77 10.51C19.36 8.51 17.65 7 15.6 7c-1.6 0-2.97.93-3.71 2.28-.18-.03-.37-.06-.56-.06-1.77 0-3.2 1.49-3.2 3.33-1.18 0-2.13.99-2.13 2.22 0 1.23.96 2.22 2.13 2.22H18.8c1.77 0 3.2-1.49 3.2-3.33 0-1.49-.94-2.73-2.23-3.16v.01zM13.5 18.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5S15 20.83 15 20s-.67-1.5-1.5-1.5zm5 0c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5S20 20.83 20 20s-.67-1.5-1.5-1.5zm-10 0c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5S10 20.83 10 20s-.67-1.5-1.5-1.5zm2.37-11.26c.45-.53.97-.98 1.55-1.34a5.693 5.693 0 00-2.21-3.73c-.65-.49-1.6.15-1.36.94.33 1.08.28 2.33-.34 3.6A3.92 3.92 0 016.7 8.52c-1.27.61-2.52.67-3.6.34-.78-.24-1.43.71-.94 1.36.68.9 1.63 1.58 2.72 1.96.39-.51.9-.93 1.48-1.21.62-2.02 2.38-3.52 4.5-3.72l.01-.01z",
            fill: "currentColor"
        })
    });



const $30d9d608488f98b7$export$9d79e705045d32e5 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.77 10.51C19.36 8.51 17.65 7 15.6 7c-1.6 0-2.97.93-3.71 2.28-.18-.03-.37-.06-.56-.06-1.77 0-3.2 1.49-3.2 3.33-1.18 0-2.13.99-2.13 2.22 0 1.23.96 2.22 2.13 2.22H18.8c1.77 0 3.2-1.49 3.2-3.33 0-1.49-.94-2.73-2.23-3.16v.01zM9.2 18.41l-1.5 2c-.33.44-.24 1.07.2 1.4.18.13.39.2.6.2.3 0 .6-.14.8-.4l1.5-2c.33-.44.24-1.07-.2-1.4-.44-.33-1.07-.24-1.4.2zm4 0l-1.5 2c-.33.44-.24 1.07.2 1.4.18.13.39.2.6.2.3 0 .6-.14.8-.4l1.5-2c.33-.44.24-1.07-.2-1.4-.44-.33-1.07-.24-1.4.2zm4 0l-1.5 2c-.33.44-.24 1.07.2 1.4.18.13.39.2.6.2.3 0 .6-.14.8-.4l1.5-2c.33-.44.24-1.07-.2-1.4-.44-.33-1.07-.24-1.4.2zM10.87 7.25c.45-.53.97-.98 1.55-1.34a5.693 5.693 0 00-2.21-3.73c-.65-.49-1.6.15-1.36.94.33 1.08.28 2.33-.34 3.6A3.92 3.92 0 016.7 8.53c-1.27.61-2.52.67-3.6.34-.78-.24-1.43.71-.94 1.36.68.9 1.63 1.58 2.72 1.96.39-.51.9-.93 1.48-1.21.62-2.02 2.38-3.52 4.5-3.72l.01-.01z",
            fill: "currentColor"
        })
    });



const $4ae04b059e7f8e21$export$90e6c6caee639f62 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.77 10.51C19.36 8.51 17.65 7 15.6 7c-1.6 0-2.97.93-3.71 2.28-.18-.03-.37-.06-.56-.06-1.77 0-3.2 1.49-3.2 3.33-1.18 0-2.13.99-2.13 2.22 0 1.23.96 2.22 2.13 2.22H18.8c1.77 0 3.2-1.49 3.2-3.33 0-1.49-.94-2.73-2.23-3.16v.01zM8.71 18.3a.996.996 0 00-1.41 0l-.29.29-.29-.29a.996.996 0 10-1.41 1.41l.29.29-.29.29a.996.996 0 00.71 1.7c.26 0 .51-.1.71-.29l.29-.29.29.29c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 000-1.41L8.44 20l.29-.29a.996.996 0 000-1.41h-.02zm6 0a.996.996 0 00-1.41 0l-.29.29-.29-.29a.996.996 0 10-1.41 1.41l.29.29-.29.29a.996.996 0 00.71 1.7c.26 0 .51-.1.71-.29l.29-.29.29.29c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 000-1.41l-.29-.29.29-.29a.996.996 0 000-1.41h-.02zm6 0a.996.996 0 00-1.41 0l-.29.29-.29-.29a.996.996 0 10-1.41 1.41l.29.29-.29.29a.996.996 0 00.71 1.7c.26 0 .51-.1.71-.29l.29-.29.29.29c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 000-1.41l-.29-.29.29-.29a.996.996 0 000-1.41h-.02zM6.37 10.97c.62-2.02 2.38-3.52 4.5-3.72.45-.53.97-.98 1.55-1.34a5.693 5.693 0 00-2.21-3.73c-.65-.49-1.6.15-1.36.94.33 1.08.28 2.33-.34 3.6A3.92 3.92 0 016.7 8.53c-1.27.61-2.52.67-3.6.34-.78-.24-1.43.71-.94 1.36.68.9 1.63 1.58 2.72 1.96.39-.51.9-.93 1.48-1.21l.01-.01z",
            fill: "currentColor"
        })
    });



const $542ff217df416f07$export$440bb568da36d464 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M6.7 18.4l-1.5 2c-.33.44-.24 1.07.2 1.4.18.13.39.2.6.2.3 0 .6-.14.8-.4l1.5-2c.33-.44.24-1.07-.2-1.4-.44-.33-1.07-.24-1.4.2zm4 0l-1.5 2c-.33.44-.24 1.07.2 1.4.18.13.39.2.6.2.3 0 .6-.14.8-.4l1.5-2c.33-.44.24-1.07-.2-1.4-.44-.33-1.07-.24-1.4.2zm4 0l-1.5 2c-.33.44-.24 1.07.2 1.4.18.13.39.2.6.2.3 0 .6-.14.8-.4l1.5-2c.33-.44.24-1.07-.2-1.4-.44-.33-1.07-.24-1.4.2zm-3.37-9.18c-1.77 0-3.2 1.49-3.2 3.33-1.18 0-2.13.99-2.13 2.22 0 1.23.96 2.22 2.13 2.22H15c0-.64.2-1.27.6-1.8l3-4c.29-.39.68-.69 1.11-.9-.49-1.9-2.13-3.3-4.11-3.3-1.6 0-2.97.93-3.71 2.28-.18-.03-.37-.06-.56-.06v.01zm11.06 7.33a1 1 0 00-.89-.55H20l1.8-2.4c.33-.44.24-1.07-.2-1.4-.44-.33-1.07-.24-1.4.2l-3 4c-.23.3-.26.71-.09 1.05A1 1 0 0018 18h1.5l-1.8 2.4c-.33.44-.24 1.07.2 1.4.18.13.39.2.6.2.3 0 .6-.14.8-.4l3-4c.23-.3.26-.71.09-1.05zM6.37 10.96c.62-2.02 2.38-3.52 4.5-3.72.45-.53.97-.98 1.55-1.34a5.693 5.693 0 00-2.21-3.73c-.65-.49-1.6.15-1.36.94.33 1.08.28 2.33-.34 3.6A3.92 3.92 0 016.7 8.52c-1.27.61-2.52.67-3.6.34-.78-.24-1.43.71-.94 1.36.68.9 1.63 1.58 2.72 1.96.39-.51.9-.93 1.48-1.21l.01-.01z",
            fill: "currentColor"
        })
    });



const $1dffe2fca54a72ae$export$49c986f5a568c3c9 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.19 11.8C19.85 10.2 18.47 9 16.8 9c-1.3 0-2.42.74-3.01 1.82-.15-.03-.3-.05-.46-.05-1.44 0-2.6 1.19-2.6 2.67-.96 0-1.73.8-1.73 1.78S9.78 17 10.73 17h8.67c1.44 0 2.6-1.19 2.6-2.67 0-1.19-.77-2.19-1.81-2.53zM13 18.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm5 0c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm-5.22-9.69c.34-.38.73-.7 1.15-.96.15-2.31-.9-4.38-2.58-5.65-.74-.56-1.83.17-1.55 1.06.38 1.23.31 2.65-.38 4.09-.43.89-1.16 1.62-2.05 2.05-1.44.7-2.86.76-4.09.38-.89-.27-1.63.81-1.06 1.55a6.488 6.488 0 005.04 2.59c.32-.89.95-1.62 1.77-2.06.58-1.64 2.03-2.85 3.78-3.07l-.03.02z",
            fill: "currentColor"
        })
    });



const $bf8b49eca02334f3$export$d484fbd67a7e4bf8 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.19 11.8C19.85 10.2 18.47 9 16.8 9c-1.3 0-2.42.74-3.01 1.82-.15-.03-.3-.05-.46-.05-1.44 0-2.6 1.19-2.6 2.67-.96 0-1.73.8-1.73 1.78S9.78 17 10.73 17h8.67c1.44 0 2.6-1.19 2.6-2.67 0-1.19-.77-2.19-1.81-2.53zm-9.99 6.6l-1.5 2c-.33.44-.24 1.07.2 1.4.18.13.39.2.6.2.3 0 .6-.14.8-.4l1.5-2c.33-.44.24-1.07-.2-1.4-.44-.33-1.07-.24-1.4.2zm4 0l-1.5 2c-.33.44-.24 1.07.2 1.4.18.13.39.2.6.2.3 0 .6-.14.8-.4l1.5-2c.33-.44.24-1.07-.2-1.4-.44-.33-1.07-.24-1.4.2zm4 0l-1.5 2c-.33.44-.24 1.07.2 1.4.18.13.39.2.6.2.3 0 .6-.14.8-.4l1.5-2c.33-.44.24-1.07-.2-1.4-.44-.33-1.07-.24-1.4.2zm-5.42-9.59c.34-.38.73-.7 1.15-.96.15-2.31-.9-4.38-2.58-5.65-.74-.56-1.83.17-1.55 1.06.38 1.23.31 2.65-.38 4.09-.43.89-1.16 1.62-2.05 2.05-1.44.7-2.86.76-4.09.38-.89-.27-1.63.81-1.06 1.55a6.488 6.488 0 005.04 2.59c.32-.89.95-1.62 1.77-2.06.58-1.64 2.03-2.85 3.78-3.07l-.03.02z",
            fill: "currentColor"
        })
    });



const $8e4981dc88353bd2$export$23827d3d0df6b5b7 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.19 11.8C19.85 10.2 18.47 9 16.8 9c-1.3 0-2.42.74-3.01 1.82-.15-.03-.3-.05-.46-.05-1.44 0-2.6 1.19-2.6 2.67-.96 0-1.73.8-1.73 1.78S9.78 17 10.73 17h8.67c1.44 0 2.6-1.19 2.6-2.67 0-1.19-.77-2.19-1.81-2.53zm-6.48 6.49a.996.996 0 00-1.41 0l-.29.29-.29-.29a.996.996 0 10-1.41 1.41l.29.29-.29.29a.996.996 0 00.71 1.7c.26 0 .51-.1.71-.29l.29-.29.29.29c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 000-1.41l-.29-.29.29-.29a.996.996 0 000-1.41h-.02zm6 0a.996.996 0 00-1.41 0l-.29.29-.29-.29a.996.996 0 10-1.41 1.41l.29.29-.29.29a.996.996 0 00.71 1.7c.26 0 .51-.1.71-.29l.29-.29.29.29c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 000-1.41l-.29-.29.29-.29a.996.996 0 000-1.41h-.02zm-6.93-9.48c.34-.38.73-.7 1.15-.96.15-2.31-.9-4.38-2.58-5.65-.74-.56-1.83.17-1.55 1.06.38 1.23.31 2.65-.38 4.09-.43.89-1.16 1.62-2.05 2.05-1.44.7-2.86.76-4.09.38-.89-.27-1.63.81-1.06 1.55a6.488 6.488 0 005.04 2.59c.32-.89.95-1.62 1.77-2.06.58-1.64 2.03-2.85 3.78-3.07l-.03.02z",
            fill: "currentColor"
        })
    });



const $ba2a82409719be54$export$ee385eb265c91a0f = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10.2 18.4l-1.5 2c-.33.44-.24 1.07.2 1.4.18.13.39.2.6.2.3 0 .6-.14.8-.4l1.5-2c.33-.44.24-1.07-.2-1.4-.44-.33-1.07-.24-1.4.2zm4 0l-1.5 2c-.33.44-.24 1.07.2 1.4.18.13.39.2.6.2.3 0 .6-.14.8-.4l1.5-2c.33-.44.24-1.07-.2-1.4-.44-.33-1.07-.24-1.4.2zm-.87-7.62c-1.44 0-2.6 1.19-2.6 2.67-.96 0-1.73.8-1.73 1.78s.78 1.78 1.73 1.78H15c0-.64.2-1.27.6-1.8l3-4c.25-.34.58-.6.94-.8-.63-.84-1.62-1.4-2.74-1.4-1.3 0-2.42.74-3.01 1.82-.15-.03-.3-.05-.46-.05zm9.06 5.77a1 1 0 00-.89-.55H20l1.8-2.4c.33-.44.24-1.07-.2-1.4-.44-.33-1.07-.24-1.4.2l-3 4c-.23.3-.26.71-.09 1.05A1 1 0 0018 18h1.5l-1.8 2.4c-.33.44-.24 1.07.2 1.4.18.13.39.2.6.2.3 0 .6-.14.8-.4l3-4c.23-.3.26-.71.09-1.05zm-9.61-7.74c.34-.38.73-.7 1.15-.96.15-2.31-.9-4.38-2.58-5.65-.74-.56-1.83.17-1.55 1.06.38 1.23.31 2.65-.38 4.09-.43.89-1.16 1.62-2.05 2.05-1.44.7-2.86.76-4.09.38-.89-.27-1.63.81-1.06 1.55a6.488 6.488 0 005.04 2.59c.32-.89.95-1.62 1.77-2.06.58-1.64 2.03-2.85 3.78-3.07l-.03.02z",
            fill: "currentColor"
        })
    });



const $92069945779882d9$export$c1f2e84cc0b9e29 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 3H6C4.35 3 3 4.35 3 6v12c0 1.65 1.35 3 3 3h12c1.65 0 3-1.35 3-3V6c0-1.65-1.35-3-3-3zm1 15c0 .55-.45 1-1 1H6c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v12zm-6.14-9.5c-.36-.62-1.37-.62-1.73 0l-3.5 6c-.18.31-.18.69 0 1 .18.31.51.5.87.5h7c.36 0 .69-.19.87-.5.18-.31.18-.69 0-1l-3.5-6h-.01z",
            fill: "currentColor"
        })
    });



const $a584a56d8ecacd15$export$499eca1c12efd5a7 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.19 13.41l-2.39-1.33-1.1-4.41A4.836 4.836 0 0012 4C9.77 4 7.84 5.51 7.3 7.67l-1.1 4.41-2.39 1.33C2.69 14.03 2 15.21 2 16.49c0 1.94 1.58 3.52 3.52 3.52h1.91a4.94 4.94 0 01-.42-2h-1c-.55 0-1-.45-1-1s.45-1 1-1h1c1.1 0 2 .9 2 2 0 1.65 1.35 3 3 3s3-1.35 3-3c0-1.1.9-2 2-2h1c.55 0 1 .45 1 1s-.45 1-1 1h-1c0 .71-.15 1.39-.42 2h1.91c1.94 0 3.52-1.58 3.52-3.52 0-1.28-.69-2.46-1.81-3.08h-.02z",
            fill: "currentColor"
        })
    });



const $8ee29051689d3a95$export$b3bd04f86f169792 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 18a3 3 0 00-3 3 1 1 0 001 1h4a1 1 0 001-1 3 3 0 00-3-3zm1.5-2.5a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0zm8.5-5.43a1.53 1.53 0 00-.48-.76L13.85 2.7a2.79 2.79 0 00-3.7 0L2.53 9.31A1.53 1.53 0 002.08 11c.098.29.283.54.53.72.242.187.535.295.84.31H4v7a3 3 0 003 3V15a3 3 0 013-3h4a3 3 0 013 3v7a3 3 0 003-3v-7h.55a1.49 1.49 0 00.84-.31c.247-.18.432-.43.53-.72a1.54 1.54 0 00.08-.9z",
            fill: "currentColor"
        })
    });



const $41e09dba7498e712$export$9b6315ddd4a04a3c = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4.53 15.51c-.54 1.32-1.07 3.67.55 6.05.19.27.5.44.83.44h5.1v-2.56c-.23-.07-.45-.17-.66-.3l-5.81-3.63h-.01zm14.74-.47l-5.59 4c-.21.15-.44.26-.67.35V22h5.1c.33 0 .64-.16.83-.44 1.83-2.7.91-5.36.34-6.52h-.01zM5.91 14H5.9l5.51 3.44c.35.21.78.2 1.11-.03L17.29 14H5.9h.01zm.21-2H17.9c1 0 1.92-.68 2.08-1.66.17-1.03-.45-1.94-1.35-2.24-.39-.13-.62-.53-.62-.94V3c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v4.16c0 .41-.24.81-.62.94-.9.3-1.52 1.21-1.35 2.24.16.98 1.09 1.66 2.08 1.66h.01zm5.89-5c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1z",
            fill: "currentColor"
        })
    });



const $17458687392e8cbb$export$8992d2e8661f2d6a = (c)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M10.86 11h-5v2h5v-2zM17.86 11h-5v2h5v-2zM9.86 9c-.26 0-.51-.1-.71-.29a.996.996 0 010-1.41l2-2a.996.996 0 111.41 1.41l-2 2c-.2.2-.45.29-.71.29h.01z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M13.86 9c-.26 0-.51-.1-.71-.29l-2-2a.996.996 0 111.41-1.41l2 2a.996.996 0 01-.71 1.7h.01z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.567 15.293a1 1 0 010 1.414l-2 2a1 1 0 01-1.414-1.414l2-2a1 1 0 011.414 0z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.153 15.293a1 1 0 011.414 0l2 2a1 1 0 01-1.414 1.414l-2-2a1 1 0 010-1.414z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M15.86 15c-.26 0-.51-.1-.71-.29a.996.996 0 010-1.41l2-2a.996.996 0 111.41 1.41l-2 2c-.2.2-.45.29-.71.29h.01zM5.86 13c-.26 0-.51-.1-.71-.29a.996.996 0 010-1.41l2-2a.996.996 0 111.41 1.41l-2 2c-.2.2-.45.29-.71.29h.01zM12.86 18v-4.28a2 2 0 001-1.72c0-.74-.4-1.38-1-1.72V6h-2v4.28a1.98 1.98 0 000 3.44V18h2z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M16.57 9.29a.996.996 0 10-1.41 1.41l2 2c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 000-1.41l-2-2h-.01zM6.57 11.29a.996.996 0 10-1.41 1.41l2 2c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 000-1.41l-2-2h-.01zM10.45 4.43c.32-.19.97-.49 1.79-.42.46.04.91.19 1.3.44.16.1.35.15.53.15.33 0 .66-.17.85-.47.29-.47.15-1.09-.32-1.38-.66-.41-1.42-.66-2.19-.73a5.06 5.06 0 00-2.98.69c-.48.28-.63.9-.35 1.37.28.47.89.63 1.37.35zM13.55 19.57c-.32.19-.97.49-1.79.42-.46-.04-.91-.19-1.3-.44a1.003 1.003 0 00-1.06 1.7A5.038 5.038 0 0012 22c.89 0 1.79-.25 2.57-.71.48-.28.63-.9.35-1.37-.28-.47-.89-.63-1.37-.35zM21.29 9.43c-.28-.47-.89-.63-1.37-.35-.48.28-.63.9-.35 1.37.19.32.49.97.42 1.79-.04.46-.19.91-.44 1.3-.29.47-.15 1.09.32 1.38.16.1.35.15.53.15.33 0 .66-.17.85-.47.41-.66.66-1.42.73-2.19a5.06 5.06 0 00-.69-2.98zM4.12 9.09c-.47-.29-1.09-.15-1.38.32-.41.66-.66 1.42-.73 2.19a5.06 5.06 0 00.69 2.98c.19.32.52.49.86.49a.998.998 0 00.86-1.51c-.19-.32-.49-.97-.42-1.79.04-.46.19-.91.44-1.3.29-.47.15-1.09-.32-1.38z",
                fill: "currentColor"
            })
        ]
    });



const $d7e3817a7b1e7e72$export$f2f6bff576294528 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16.71 12.29A1 1 0 0016 12H8a1 1 0 00-1 1v2a1 1 0 001 1h.72L10 21.24a1 1 0 001 .76h2a1 1 0 001-.76L15.28 16H16a1 1 0 001-1v-2a1 1 0 00-.29-.71zM8.15 10H9c0-2 1.72-1.11 2-3.28a.53.53 0 01.66-.42C13.81 6.89 14 9 14 10h1a1 1 0 001-1 8.12 8.12 0 00-4.6-6.84 1 1 0 00-1.48 1.01c.39 2.12-2.06 3.32-2.75 5.62A1 1 0 008.15 10z",
            fill: "currentColor"
        })
    });



const $a7e909a9d28efea8$export$8eae42c7c38a3ae8 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17.78 8.71c.19.19.44.29.71.29.27 0 .52-.11.71-.29.82-.83 1.01-2.05.57-3.05l.95-.95a.996.996 0 10-1.41-1.41l-.94.94a2.76 2.76 0 00-3.06.57.996.996 0 000 1.41l2.49 2.49h-.02zM19 11H8.07L6.66 8.89a1.987 1.987 0 00-2.77-.55c-.92.61-1.17 1.85-.55 2.77l1.41 2.11A3.979 3.979 0 008.08 15h2.93v4h-2c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1h-2v-4h6c1.1 0 2-.9 2-2s-.9-2-2-2H19z",
            fill: "currentColor"
        })
    });



const $eb4299de8013efac$export$eee91b708864508a = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10.78 10.84a4.51 4.51 0 005.56-5.56 4.46 4.46 0 00-3.12-3.12 4.51 4.51 0 00-5.56 5.56 4.46 4.46 0 003.12 3.12zm4.49 1.86l-.38.75a1 1 0 01-.73.54H14a1 1 0 01-.71-.29L12 12.41l-1.29 1.3A1 1 0 0110 14h-.16a1 1 0 01-.73-.54l-.38-.75A8 8 0 004 20a2 2 0 002 2h12a2 2 0 002-2 8 8 0 00-4.73-7.3zM16 20a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $217ddad95ecc63be$export$6dd2459f50e40885 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4 18a3 3 0 003 3h10a3 3 0 003-3V9H4v9zm5.29-4.29a1.004 1.004 0 011.42-1.42l1.29 1.3 1.29-1.3a1.004 1.004 0 111.42 1.42L13.41 15l1.3 1.29a1.002 1.002 0 01-.325 1.639 1 1 0 01-1.095-.219L12 16.41l-1.29 1.3a1.002 1.002 0 01-1.639-.325 1 1 0 01.219-1.095l1.3-1.29-1.3-1.29zM21.41 3.59A2 2 0 0020 3H4a2 2 0 00-2 2v1a1 1 0 001 1h18a1 1 0 001-1V5a2 2 0 00-.59-1.41z",
            fill: "currentColor"
        })
    });



const $45a53309c02478f6$export$9999965211de0174 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18.5 15h-1.45l1.38-1.63c.41-.49.46-1.18.11-1.71-.24-.37-.62-.61-1.06-.65-.44-.04-.86.1-1.17.41l-.17.17c-.19.2-.19.51 0 .71.2.19.51.19.71 0l.17-.17c.09-.09.23-.13.36-.13.08 0 .22.05.32.2.1.16.09.38-.03.52l-2.08 2.45c-.13.15-.15.36-.07.53.08.17.26.29.45.29h2.53c.28 0 .5-.22.5-.5s-.22-.5-.5-.5V15zM11 7c-2.21 0-4 2.02-4 4.5S8.79 16 11 16s4-2.02 4-4.5S13.21 7 11 7zm0 7c-1.1 0-2-1.12-2-2.5S9.9 9 11 9s2 1.12 2 2.5-.9 2.5-2 2.5z",
            fill: "currentColor"
        })
    });



const $e208790a6bad5615$export$6676ee973c2b8c51 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 4a2 2 0 00-2-2H6a2 2 0 00-2 2 1 1 0 000 2 2 2 0 002 2h10a2 2 0 002-2 1 1 0 011 1v2.23a1 1 0 01-.88 1l-5.37.67a2 2 0 00-1.75 2V14h-1a1 1 0 00-1 1v4a3 3 0 006 0v-4a1 1 0 00-1-1h-1v-1.12l5.37-.67a3 3 0 002.63-3V7a3 3 0 00-3-3z",
            fill: "currentColor"
        })
    });



const $738f21b035e88f47$export$76fecbfa7e80c359 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M14 7c-2.21 0-4 2.02-4 4.5s1.79 4.5 4 4.5 4-2.02 4-4.5S16.21 7 14 7zm0 7c-1.1 0-2-1.12-2-2.5S12.9 9 14 9s2 1.12 2 2.5-.9 2.5-2 2.5zm7.5 1h-1.45l1.38-1.63c.41-.49.46-1.18.11-1.71-.24-.37-.62-.61-1.06-.65-.44-.04-.86.1-1.17.41l-.17.17c-.19.2-.19.51 0 .71.2.19.51.19.71 0l.17-.17c.1-.09.23-.13.36-.13.08 0 .22.05.32.2.1.16.09.38-.03.52l-2.08 2.45c-.13.15-.15.36-.07.53.08.17.26.29.45.29h2.53c.28 0 .5-.22.5-.5s-.22-.5-.5-.5V15zM6 7H4c-.55 0-1 .45-1 1v7c0 .55.45 1 1 1s1-.45 1-1v-2h1c1.65 0 3-1.35 3-3S7.65 7 6 7zm0 4H5V9h1c.55 0 1 .45 1 1s-.45 1-1 1z",
            fill: "currentColor"
        })
    });



const $2ed1195fe564d274$export$4cbfde2132ad9586 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18.04 8c.52 0 1.02.1 1.48.29l-1.07-2.93a1.965 1.965 0 00-2.52-1.17L5.46 8.04c.16-.03.33-.04.5-.04h12.08zM20 13.57v-1.64A1.963 1.963 0 0018.04 10H5.96C4.88 10 4 10.88 4 11.96v1.61c.21.07.39.18.54.34.28.26.46.65.46 1.07 0 .05 0 .1-.01.14-.05.59-.45 1.08-.99 1.27v1.65C4 19.12 4.88 20 5.96 20h12.08c1.08 0 1.96-.88 1.96-1.96v-1.65a1.495 1.495 0 010-2.82zM8 19c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm0-3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm0-3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z",
            fill: "currentColor"
        })
    });



const $553e1f747d99007b$export$6cb88ffad922669b = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M9 10.98c1.93 0 3.5-1.57 3.5-3.5s-1.57-3.5-3.5-3.5-3.5 1.57-3.5 3.5 1.57 3.5 3.5 3.5zm10.24-6.99h-3.48a.76.76 0 00-.76.76v4.74c0 1.02.62 1.9 1.5 2.29v1.41c0 .34.21.62.5.74v5.06h-2v-1c0-3.31-2.69-6-6-6s-6 2.69-6 6v2h14.5c.28 0 .5-.22.5-.5v-5.56c.29-.12.5-.41.5-.74v-1.41c.88-.39 1.5-1.26 1.5-2.29V4.75a.76.76 0 00-.76-.76zM19 6.79a.2.2 0 01-.2.2H18v.8a.2.2 0 01-.2.2h-.6a.2.2 0 01-.2-.2v-.8h-.8a.2.2 0 01-.2-.2v-.6c0-.11.09-.2.2-.2h.8v-.8c0-.11.09-.2.2-.2h.6c.11 0 .2.09.2.2v.8h.8c.11 0 .2.09.2.2v.6z",
            fill: "currentColor"
        })
    });



const $97fe67a9a45f5490$export$7cc3b642633a7bb5 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M14.62 16.4a5.47 5.47 0 010-7.77l.63-.63H6V6a1 1 0 011-1h1.28a2 2 0 00.72.73A2 2 0 0010 6h4a2 2 0 001-.27 2 2 0 00.72-.73H17a1 1 0 011 1 2.73 2.73 0 01.5 0 3 3 0 011.5.41V6a3 3 0 00-3-3h-1.28a2 2 0 00-.72-.73A2 2 0 0014 2h-4a2 2 0 00-1 .27 2 2 0 00-.72.73H7a3 3 0 00-3 3v13a3 3 0 003 3h10a3 3 0 003-3v-1.23a5.34 5.34 0 01-1.5.23 5.45 5.45 0 01-3.88-1.6zM21 10.05l-1.79-1.76a1 1 0 00-1.42 0L16 10.05A3.481 3.481 0 0016 15a3.51 3.51 0 005 0 3.4 3.4 0 001-2.46 3.46 3.46 0 00-1-2.49z",
            fill: "currentColor"
        })
    });



const $e4a705bd3e43fda1$export$11d611be313fedce = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17.5 7a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm-9 0a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm1.18 6.58l-1.54-1 .53-2.11 2.88 1.44a1 1 0 10.9-1.78l-4-2-4-2a1 1 0 00-.9 1.78l3.29 1.63-.77 3.05-3.9 5.86a1 1 0 00.28 1.38A.94.94 0 003 20a1 1 0 00.83-.45l3.45-5.16 1.29.86L6.2 18.4a1 1 0 001.6 1.2l2.37-3.15a1.999 1.999 0 00-.49-2.87zm11.77-3.47l-4-2-4-2a1 1 0 00-.9 1.78l3.29 1.65-.77 3.05-3.9 5.86a1 1 0 00.28 1.38.94.94 0 00.55.17 1 1 0 00.83-.45l3.45-5.16 1.29.86-2.37 3.15a1 1 0 101.6 1.2l2.37-3.15a1.999 1.999 0 00-.49-2.87l-1.54-1 .53-2.11 2.88 1.44a1 1 0 00.9-1.78v-.02z",
            fill: "currentColor"
        })
    });



const $29f3e24cabcf2307$export$2a96ad26e3f02316 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 13a4 4 0 014-4h.06a14.06 14.06 0 01.84-4.57 1 1 0 000-1A1 1 0 0020 3h-6a2 2 0 01-3.9.6C5.64 5.06 3 9.15 3 15c0 2.81.73 4.33 1.63 5.13a.252.252 0 00.311-.035A.25.25 0 005 20c.33-6 3.54-10.29 9.57-12.87a1 1 0 11.78 1.84C9.83 11.3 7.09 15.17 7 20.73a.27.27 0 00.27.27 19.198 19.198 0 004.37-.54A2 2 0 1115 19v.13a10.43 10.43 0 003.08-2.64A4 4 0 0116 13z",
            fill: "currentColor"
        })
    });



const $84474c24e511342d$export$24e0104c0f7dd79f = (v)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...v,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 3a1 1 0 00-1-1H9a1 1 0 00-1 1v1h8V3zm1 3H7a3 3 0 00-3 3v11a2 2 0 002 2h12a2 2 0 002-2V9a3 3 0 00-3-3zm1 5a2 2 0 01-2 2h-1v2h1a2 2 0 012 2v1a1 1 0 01-2 0v-1h-1.18a3 3 0 01-5.64 0H8v1a1 1 0 11-2 0v-1a2 2 0 012-2h1v-2H8a2 2 0 01-2-2v-1a1 1 0 012 0v1h1.18a3 3 0 015.64 0H16v-1a1 1 0 012 0v1zm-6 0a1 1 0 00-1 1v4a1 1 0 002 0v-4a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $829ad7d84cd56bb9$export$4c1d989b2e70b4d5 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.89 14.55l-.62-1.26a3.002 3.002 0 00-1.74-1.5L17 11.28v-.56l1-.32a3 3 0 002-2.84V6a1 1 0 00-2 0v1.56a1 1 0 01-.68 1l-.76.25A2 2 0 0015 8a3 3 0 00-.69-1.89l1.4-1.4a1.004 1.004 0 00-1.42-1.42l-1.76 1.76a2.83 2.83 0 00-1.06 0L9.71 3.29a1.004 1.004 0 10-1.42 1.42l1.4 1.4A3 3 0 009 8a2 2 0 00-1.56.76l-.76-.25a1 1 0 01-.68-1V6a1 1 0 10-2 0v1.56a3 3 0 002.05 2.84l1 .32v.56l-1.53.51a3 3 0 00-1.74 1.5l-.62 1.26a1 1 0 00.44 1.34c.123.066.26.104.4.11a1 1 0 00.89-.55l.63-1.26a1 1 0 01.58-.5l.9-.3V15a5 5 0 00.19 1.29l-1 .52a3 3 0 00-1.34 1.34l-.7 1.4a1 1 0 00.44 1.34A.929.929 0 005 21a1 1 0 00.89-.55L6.6 19a.94.94 0 01.4-.4l1-.52a4.94 4.94 0 007.82 0l1.18.52a.94.94 0 01.44.44l.71 1.41A1 1 0 0019 21a.929.929 0 00.45-.11 1 1 0 00.44-1.34l-.7-1.4a3 3 0 00-1.34-1.34l-1-.52c.106-.422.156-.855.15-1.29v-1.61l.9.3a1 1 0 01.58.5l.63 1.26A1 1 0 0020 16a.929.929 0 00.45-.11 1 1 0 00.44-1.34z",
            fill: "currentColor"
        })
    });



const $bcf66750abc7664e$export$8786085363deb3d1 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7.08 8a2.94 2.94 0 002-.89 2.49 2.49 0 00.3-3.52 2.49 2.49 0 00-3.52.3 2.49 2.49 0 00-.3 3.52A2.07 2.07 0 007.08 8zm6.19.77a3.28 3.28 0 002.27-1 2.76 2.76 0 00.35-3.89 2.76 2.76 0 00-3.89.35 2.76 2.76 0 00-.35 3.89 2.23 2.23 0 001.62.65zM17.74 13A3.27 3.27 0 0020 12c.53-.5.881-1.16 1-1.88a2.32 2.32 0 00-.62-2 2.76 2.76 0 00-3.89.35 3.39 3.39 0 00-1 1.88 2.34 2.34 0 00.62 2 2.27 2.27 0 001.63.65zm2.67 1.58a2.489 2.489 0 00-3.52.3 2.49 2.49 0 00-.3 3.52 2.071 2.071 0 001.49.59 2.94 2.94 0 002-.89 2.49 2.49 0 00.33-3.51v-.01zM9.14 9.05l-3.53.64A3.18 3.18 0 003 12.82V13a3 3 0 003 3 2 2 0 012 2 3 3 0 003 3h.18a3.18 3.18 0 003.13-2.61l.69-3.53a5 5 0 00-5.86-5.81z",
            fill: "currentColor"
        })
    });



const $bce5c2676a0e56b7$export$aca60b97a4985597 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.56 12.9L18 12l1.56-.9a2 2 0 00.73-2.73l-1-1.74a2 2 0 00-2.73-.73L15 6.8V5a2 2 0 00-2-2h-2a2 2 0 00-2 2v1.8l-1.56-.9a2 2 0 00-2.73.73l-1 1.74a2 2 0 00.73 2.73L6 12l-1.56.9a2 2 0 00-.73 2.73l1 1.74a2 2 0 002.73.73L9 17.2V19a2 2 0 002 2h2a2 2 0 002-2v-1.8l1.56.9a2 2 0 002.73-.73l1-1.74a2 2 0 00-.73-2.73zM14 13h-1v1a1 1 0 01-2 0v-1h-1a1 1 0 010-2h1v-1a1 1 0 112 0v1h1a1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $6acadc193e29154e$export$1d11e42f8d2aeec7 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21 8a1 1 0 00-1 1h-3.54A6 6 0 0013 7.09V5h1a1 1 0 100-2h-4a1 1 0 000 2h1v2.09A6 6 0 007.54 9H4a1 1 0 00-2 0v8a1 1 0 102 0h3.54a6 6 0 008.92 0H20a1 1 0 002 0V9a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $1d137a0115aff5e4$export$f80fcd1e1fbc5dbd = (l)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M7.18 16.13H4.44c-.55 0-1-.45-1-1s.45-1 1-1h2.74v-3.78c0-.55.45-1 1-1s1 .45 1 1v3.78c0 1.1-.9 2-2 2z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M20.69 14.15L14 12.88c-.1-.03-.19-.06-.24-.09L8.73 9.52a1 1 0 00-1.38.29 1 1 0 00.29 1.38l5.07 3.29c.25.14.5.25.85.34l6.76 1.29a.995.995 0 001.17-.79c.1-.54-.25-1.07-.79-1.17h-.01zM5.58 8.98c-.27-.11-.58-.14-.87-.09-.29.06-.56.2-.77.41-.21.21-.35.48-.41.77-.06.29-.03.59.09.87.11.27.31.51.55.67a1.499 1.499 0 002.33-1.25c0-.3-.09-.59-.25-.83-.16-.25-.4-.44-.67-.55z",
                fill: "currentColor"
            })
        ]
    });



const $f1033641963744b9$export$3ec29cf540019e84 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 17c-.479 0-.95.12-1.37.35A4 4 0 0013 15.14V12h1a3.32 3.32 0 002.44-1C18 9.46 18 6.62 18 6.5a.5.5 0 00-.5-.5A5.15 5.15 0 0013 8.11V3a1 1 0 00-2 0v1.11A5.15 5.15 0 006.5 2a.5.5 0 00-.5.5c0 .12 0 3 1.56 4.52A3.32 3.32 0 0010 8h1v7.14a4 4 0 00-2.63 2.21A2.87 2.87 0 007 17a3 3 0 00-3 3v1a1 1 0 001 1h14a1 1 0 001-1v-1a3 3 0 00-3-3z",
            fill: "currentColor"
        })
    });



const $5f27ebe1148c4887$export$631fab1c6e0bcce5 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.64 14.32a1 1 0 00-.82-.21 6.076 6.076 0 00-1.46.48 3.91 3.91 0 01-1.86.41 3.84 3.84 0 01-1.85-.41 5.837 5.837 0 00-1.65-.52V8.42c3.94-.62 4-4.87 4-4.92a.5.5 0 00-.5-.5A4.48 4.48 0 0012 5.81 4.48 4.48 0 007.5 3a.5.5 0 00-.5.5s.06 4.3 4 4.92v5.65a5.807 5.807 0 00-1.66.52A3.82 3.82 0 017.5 15a4 4 0 01-1.87-.41 5.838 5.838 0 00-1.45-.48 1 1 0 00-.82.21 1 1 0 00-.36.77V20a1 1 0 001 1h16a1 1 0 001-1v-4.91a1.001 1.001 0 00-.36-.77z",
            fill: "currentColor"
        })
    });



const $ca75e679b819d766$export$7f0ab612c549df2 = (l)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M15.03 11.27l-4.44-3.11a.932.932 0 00-.51-.16c-.14 0-.28.03-.41.1-.14.07-.27.19-.35.33a.94.94 0 00-.13.46v6.22c0 .16.05.32.13.46s.21.25.35.33c.13.07.27.1.41.1.18 0 .36-.06.51-.16l4.44-3.11c.12-.08.21-.19.28-.32.07-.13.1-.27.1-.41 0-.14-.03-.28-.1-.41a.867.867 0 00-.28-.32z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M17 21H7c-2.21 0-4-1.79-4-4V7c0-2.21 1.79-4 4-4h10c2.21 0 4 1.79 4 4v10c0 2.21-1.79 4-4 4zM7 5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2H7z",
                fill: "currentColor"
            })
        ]
    });



const $9ec02784879cfd35$export$bc9e3a84852d75cc = (l)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M17 21H7c-2.21 0-4-1.79-4-4V7c0-2.21 1.79-4 4-4h6c.55 0 1 .45 1 1s-.45 1-1 1H7c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2v-6c0-.55.45-1 1-1s1 .45 1 1v6c0 2.21-1.79 4-4 4z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M20 5h-1V4c0-.55-.45-1-1-1s-1 .45-1 1v1h-1c-.55 0-1 .45-1 1s.45 1 1 1h1v1c0 .55.45 1 1 1s1-.45 1-1V7h1c.55 0 1-.45 1-1s-.45-1-1-1zM15.03 11.27l-4.44-3.11a.932.932 0 00-.51-.16c-.14 0-.28.03-.41.1-.14.07-.27.19-.35.33a.94.94 0 00-.13.46v6.22c0 .16.05.32.13.46s.21.25.35.33c.13.07.27.1.41.1.18 0 .36-.06.51-.16l4.44-3.11c.12-.08.21-.19.28-.32.07-.13.1-.27.1-.41 0-.14-.03-.28-.1-.41a.867.867 0 00-.28-.32z",
                fill: "currentColor"
            })
        ]
    });



const $735e10f28243cadd$export$a167ccd81e7e43d4 = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M18.3 7.29c.2.32.32.68.37 1.06 1.44.69 2.11 3.52-.04 3.65h-1.94a2.7 2.7 0 00-2.2 1.16c-.31-.36-.69-.64-1.11-.84-.43-.2-.89-.3-1.36-.3-.47 0-.93.1-1.36.3-.43.2-.81.48-1.11.84-.25-.36-.57-.65-.96-.85-.38-.2-.81-.31-1.24-.31H5.41c-2.16-.12-1.49-2.96-.04-3.65.07-.57.32-1.11.71-1.52.4-.42.92-.7 1.48-.8.21-.46.56-.85 1.01-1.09.45-.24.96-.33 1.46-.25.27-.26.59-.46.95-.57.36-.11.74-.14 1.1-.08.37.06.72.21 1.02.44.3.22.54.52.7.85.61.03 1.18.3 1.6.75.37-.09.75-.1 1.12-.03.37.07.72.22 1.03.43.31.22.57.49.77.82l-.02-.01zM9.53 8.86c.13-.13.3-.2.47-.2.17 0 .35-.07.47-.2a.65.65 0 000-.94c-.13-.13-.3-.2-.47-.2-.53 0-1.04.21-1.42.59-.38.38-.59.88-.59 1.42 0 .18.07.35.2.47a.65.65 0 00.94 0c.13-.13.2-.29.2-.47s.07-.35.2-.47zm5.34 1.61a.65.65 0 00.94 0c.13-.13.2-.29.2-.47 0-.53-.21-1.04-.59-1.42-.38-.38-.89-.59-1.42-.59-.18 0-.35.07-.47.2a.65.65 0 000 .94c.13.13.3.2.47.2.17 0 .35.07.47.2.13.13.2.29.2.47s.07.35.2.47zM9.25 20l-.59-5.34a1.333 1.333 0 00-1.33-1.33H5.45l.85 4.25c.14.68.51 1.3 1.05 1.74.54.44 1.22.68 1.91.68h-.01zm9.31-6.67h-1.88a1.333 1.333 0 00-1.33 1.33L14.76 20a3.014 3.014 0 002.96-2.42l.85-4.25h-.01zm-4.62 1.92l-.53 4.76H10.6l-.53-4.76c0-.51.2-1.01.57-1.37.36-.36.86-.57 1.37-.57.51 0 1.01.2 1.37.57.36.36.57.85.57 1.37h-.01z",
            fill: "currentColor"
        })
    });



const $b6f881c87b06d7b6$export$62d139385f69513e = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4.5 5.25a1.25 1.25 0 10-2.5 0 1.25 1.25 0 002.5 0zM21.98 11.47C21.7 7.22 17.98 4 13.72 4H6.74a1.25 1.25 0 000 2.5h.75c.55 0 1 .45 1 1s-.45 1-1 1H3.25a1.25 1.25 0 000 2.5H5.5c.55 0 1 .45 1 1s-.45 1-1 1H3.25a1.25 1.25 0 000 2.5H7.5c.55 0 1 .45 1 1s-.45 1-1 1H5.75a1.25 1.25 0 000 2.5H14a8 8 0 007.98-8.53zM15 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm2.9-6.72l-1.47-.21-.66-1.33c-.31-.64-1.22-.64-1.54 0l-.66 1.33-1.47.21c-.7.1-.98.97-.48 1.46l1.07 1.04-.25 1.47c-.12.7.62 1.23 1.24.9l1.32-.69 1.32.69c.63.33 1.36-.2 1.24-.9l-.25-1.47 1.07-1.04c.51-.5.23-1.36-.48-1.46z",
            fill: "currentColor"
        })
    });



const $b5009624f03186a3$export$ddb8ae74b8e59c47 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.41 3.59a2 2 0 00-2.3-.38L12.45 6 18 11.55l2.83-5.66a2 2 0 00-.42-2.3zM4.17 14.17a4.002 4.002 0 005.66 5.66L16.62 13 11 7.38l-6.83 6.79zm7.54-2.88l1 1a1 1 0 010 1.42 1 1 0 01-1.42 0l-1-1a1.004 1.004 0 011.42-1.42z",
            fill: "currentColor"
        })
    });



const $b58b62f697d7616c$export$672b4d7135822d06 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 15c0 1.1-.9 2-2 2h-5v1.38c.31.27.5.67.5 1.12 0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5c0-.45.19-.84.5-1.12V17H6c-1.1 0-2-.9-2-2V7h16v8zm0-12c.55 0 1 .45 1 1s-.45 1-1 1H4c-.55 0-1-.45-1-1s.45-1 1-1h16z",
            fill: "currentColor"
        })
    });



const $4d3a00e5ffdb7c36$export$44606573b568859b = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M2.93 17.3a3 3 0 003 2.7h12.15a3 3 0 003-2.7l.13-1.3H2.8l.13 1.3zM21.74 7a2 2 0 00-2.09-1 2 2 0 00-1.07.56l-.86.85a1 1 0 01-.32.22 1 1 0 01-.38.07 1 1 0 01-.71-.3l-2.78-2.8a2 2 0 00-2.79 0l-3 2.92a1 1 0 01-.74.26 1 1 0 01-.7-.29l-.9-.9A2 2 0 004.36 6a2 2 0 00-2.11 1A2.07 2.07 0 002 8.2l.6 5.8h18.8l.6-5.8a2.06 2.06 0 00-.26-1.2z",
            fill: "currentColor"
        })
    });



const $6b2f6540c4603ed3$export$7bfc8268e4a7744a = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7.5 11H7v1h.5a.5.5 0 000-1zM12 2a10 10 0 100 20 10 10 0 000-20zM7.5 13H7v.5a.5.5 0 01-1 0v-3a.5.5 0 01.5-.5h1a1.5 1.5 0 110 3zm5.28.08a.51.51 0 01.14.7.52.52 0 01-.42.22.57.57 0 01-.28-.08L11 13.1v.4a.5.5 0 01-1 0v-3a.5.5 0 01.5-.5h1a1.5 1.5 0 011.314 2.221c-.123.22-.3.406-.514.539l.48.32zM16 14a2 2 0 110-4 2 2 0 010 4zm-4.5-3H11v1h.5a.5.5 0 000-1zm4.5 0a1 1 0 100 2 1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $5cedb6f9fbd99424$export$f36ca9faaafb885f = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 2H7c-1.1 0-2 .9-2 2v11c0 3.87 3.13 7 7 7s7-3.13 7-7V4c0-1.1-.9-2-2-2zm-5 16.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4-7.5c0 .55-.45 1-1 1H9c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h6c.55 0 1 .45 1 1v5z",
            fill: "currentColor"
        })
    });



const $3efaa83fde95e451$export$8eca46d6a25c9370 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18.46 8.5c-.86 0-1.56.7-1.56 1.56 0 .86.7 1.56 1.56 1.56.86 0 1.56-.7 1.56-1.56 0-.86-.7-1.56-1.56-1.56zM16.37 12.05a2.253 2.253 0 00-2.78-1.11l-9.95 3.62c-.52.19-.79.76-.6 1.28a.998.998 0 001.28.6l9.95-3.62c.12-.04.25.01.31.12l1.5 3c.25.49.85.69 1.34.45.49-.25.69-.85.45-1.34l-1.5-3z",
            fill: "currentColor"
        })
    });



const $f73da4025eeabaf6$export$34be6b6d8e92c25 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 10a2.19 2.19 0 00-.63.1.999.999 0 01-1.37-.9V7a3 3 0 00-3-3H5a3 3 0 00-3 3v10a3 3 0 003 3h2.2a.999.999 0 00.9-1.37 2 2 0 113.8 0 .999.999 0 00.9 1.37H15a3 3 0 003-3v-2.2a.999.999 0 011.37-.9A2 2 0 1020 10z",
            fill: "currentColor"
        })
    });



const $ea926b4ed065af0e$export$fbea415b4939da93 = (v)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...v,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.5 16a1 1 0 00-1 1v1h-2.09L16.2 7h2.3v1a1 1 0 002 0V4a1 1 0 00-2 0v1H16v-.16A3.37 3.37 0 0012.5 2 3.37 3.37 0 009 4.84V5H6.5V4a1 1 0 00-2 0v4a1 1 0 002 0V7h2.3L7.59 18H5.5v-1a1 1 0 10-2 0v4a1 1 0 002 0v-1h2.19a3 3 0 002.81 2h4a3 3 0 002.82-2h2.18v1a1 1 0 002 0v-4a1 1 0 00-1-1zm-6.22 3h-3.56a1 1 0 01-1-1.2l.39-1.8a2.44 2.44 0 014.78 0l.37 1.84a1 1 0 01-.98 1.16zm-1.78-3a1 1 0 100 2 1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $7a8cd58b86dd3784$export$26552631ce75c52d = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 19h-3v-4h3.19a.5.5 0 00.45-.72L20 13l.64-1.28a.5.5 0 00-.45-.72H15v8h-3a7 7 0 010-14h8a1 1 0 100-2h-8a9 9 0 100 18h8a1 1 0 000-2zm0-12h-8a5 5 0 100 10h1v-2h-1a3 3 0 010-6h8a1 1 0 100-2z",
            fill: "currentColor"
        })
    });



const $78b1aebe5b203c0e$export$9e611fc728968919 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.91 11.15A4.001 4.001 0 0016 8c-1.5 0-2.79.83-3.47 2.05A2.996 2.996 0 009 13c-1.1 0-2 .9-2 2s.9 2 2 2h10a2.996 2.996 0 00.91-5.85zm-8.38-3.13c.88-.99 2.07-1.66 3.36-1.91C14.48 4.33 12.9 3 11 3c-1.5 0-2.79.83-3.47 2.05A2.996 2.996 0 004 8c-1.1 0-2 .9-2 2s.9 2 2 2h2.36c.27-.24.58-.44.9-.6a5.028 5.028 0 014.27-3.38zM9.2 18.4l-1.5 2c-.33.44-.24 1.07.2 1.4.18.13.39.2.6.2.3 0 .6-.14.8-.4l1.5-2c.33-.44.24-1.07-.2-1.4-.44-.33-1.07-.24-1.4.2zm4 0l-1.5 2c-.33.44-.24 1.07.2 1.4.18.13.39.2.6.2.3 0 .6-.14.8-.4l1.5-2c.33-.44.24-1.07-.2-1.4-.44-.33-1.07-.24-1.4.2zm4 0l-1.5 2c-.33.44-.24 1.07.2 1.4.18.13.39.2.6.2.3 0 .6-.14.8-.4l1.5-2c.33-.44.24-1.07-.2-1.4-.44-.33-1.07-.24-1.4.2z",
            fill: "currentColor"
        })
    });



const $8f4b2ad495f5d42d$export$86a0a2a590a50e1a = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4.5 15.5C4 15.5 3 17.17 3 18c0 .83.67 1.5 1.5 1.5S6 18.83 6 18s-1-2.5-1.5-2.5zm15.21.29a.996.996 0 00-1.41 0l-.29.29-.29-.29a.996.996 0 10-1.41 1.41l.29.29-.29.29a.996.996 0 00.71 1.7c.26 0 .51-.1.71-.29l.29-.29.29.29c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 000-1.41l-.29-.29.29-.29a.996.996 0 000-1.41h-.02zm-.27-7.41c.03-.21.06-.42.06-.63C19.5 5.13 17.37 3 14.75 3c-1.64 0-3.08.83-3.93 2.09A3.68 3.68 0 0010 5a3.98 3.98 0 00-3.86 3.01C6.09 8.01 6.05 8 6 8c-1.66 0-3 1.34-3 3s1.34 3 3 3h12c1.66 0 3-1.34 3-3 0-1.13-.64-2.11-1.56-2.62zm-4.94 7.25c-.48-.28-1.09-.11-1.37.37l-2 3.46c-.28.48-.11 1.09.37 1.37s1.09.11 1.37-.37l2-3.46c.28-.48.11-1.09-.37-1.37zm-4 0c-.48-.28-1.09-.11-1.37.37l-2 3.46c-.28.48-.11 1.09.37 1.37s1.09.11 1.37-.37l2-3.46c.28-.48.11-1.09-.37-1.37z",
            fill: "currentColor"
        })
    });



const $a00950ef24ac080f$export$133393244e33fc32 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.44 8.38c.03-.21.06-.42.06-.63C19.5 5.13 17.37 3 14.75 3c-1.64 0-3.08.83-3.93 2.09A3.68 3.68 0 0010 5a3.98 3.98 0 00-3.86 3.01C6.09 8.01 6.05 8 6 8c-1.66 0-3 1.34-3 3s1.34 3 3 3h12c1.66 0 3-1.34 3-3 0-1.13-.64-2.11-1.56-2.62zM8.71 15.79a.996.996 0 00-1.41 0l-.29.29-.29-.29a.996.996 0 10-1.41 1.41l.29.29-.29.29a.996.996 0 00.71 1.7c.26 0 .51-.1.71-.29l.29-.29.29.29c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 000-1.41l-.29-.29.29-.29a.996.996 0 000-1.41h-.02zm4.79-.16c-.48-.28-1.09-.11-1.37.37l-2 3.46c-.28.48-.11 1.09.37 1.37s1.09.11 1.37-.37l2-3.46c.28-.48.11-1.09-.37-1.37zm4 0c-.48-.28-1.09-.11-1.37.37l-2 3.46c-.28.48-.11 1.09.37 1.37s1.09.11 1.37-.37l2-3.46c.28-.48.11-1.09-.37-1.37z",
            fill: "currentColor"
        })
    });



const $8e450dae85c3c0af$export$1eae32e0027c8d25 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 14.5a3 3 0 00-2.08-2.84 3 3 0 00-3.62-3.57 3.001 3.001 0 00-4.6 0 3 3 0 00-3.62 3.57 3 3 0 000 5.68 3 3 0 003.62 3.57 3 3 0 004.6 0 3 3 0 003.62-3.57A3 3 0 0020 14.5zm-10-2a1 1 0 112 0 1 1 0 01-2 0zm2.71 5.71a1 1 0 11-1.409-1.42 1 1 0 011.409 1.42zM15 15.5a1 1 0 110-2.002 1 1 0 010 2.002zM12 6c2.31 0 3.3-2.24 3.49-3.42a.46.46 0 00-.11-.4A.46.46 0 0015 2a3.83 3.83 0 00-3 2 3.83 3.83 0 00-3-2 .46.46 0 00-.38.18.46.46 0 00-.11.4C8.7 3.76 9.69 6 12 6z",
            fill: "currentColor"
        })
    });



const $8211ac5f4e9a5e99$export$cdec042689f71776 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 2H5a1 1 0 000 2h1v12a6 6 0 1012 0V4h1a1 1 0 100-2zm-8.25 11.5a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5zM13.5 17a1 1 0 110-2 1 1 0 010 2zm0-7a1.5 1.5 0 110-3 1.5 1.5 0 010 3z",
            fill: "currentColor"
        })
    });



const $ce16939cb34f9663$export$6c59520e7e79e2d2 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7.43 17.25a.45.45 0 00-.18-.18.5.5 0 00-.68.17l-.89 1.5c-.15.29-.21.617-.17.94.048.323.195.623.42.86.142.139.308.25.49.33a1.46 1.46 0 001.16 0 1.51 1.51 0 00.49-.33 1.62 1.62 0 00.42-.87 1.57 1.57 0 00-.18-.95l-.88-1.47zM21 3h-4a3 3 0 00-3 3v1h-3V6a3 3 0 00-3-3H6a3 3 0 00-3 3v5a3 3 0 002 2.82V15a1 1 0 001 1h2a1 1 0 001-1v-1.18A3 3 0 0011 11h2v1a1 1 0 001 1h2a1 1 0 001-1v-1h2a1 1 0 002 0V7a1 1 0 00-2 0h-3V6a1 1 0 011-1h4a1 1 0 100-2z",
            fill: "currentColor"
        })
    });



const $bfcd1094bae49ee6$export$4a6bbbf446e8b7d = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 8h-5V6.72A2 2 0 0014 5a2 2 0 10-4 0 2 2 0 001 1.72V8H6a3 3 0 00-3 3v7a3 3 0 003 3h12a3 3 0 003-3v-7a3 3 0 00-3-3zM7.5 11a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm9.5 7H7a1 1 0 010-2h10a1 1 0 010 2zm-.5-4a1.5 1.5 0 110-3 1.5 1.5 0 010 3z",
            fill: "currentColor"
        })
    });



const $34947c503598e183$export$198fa77749932a71 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4.14 16.14a1 1 0 00-1.65.39l-.27.81a.5.5 0 00.47.66H4l-1.33 2.66a.5.5 0 00.67.67L6 20v1.31a.5.5 0 00.66.47l.8-.27a1 1 0 00.4-1.65l-3.72-3.72zm16.17-14A20.18 20.18 0 0010.88 5H7.24a2 2 0 00-1.79 1.11l-2.73 5.44a1 1 0 00.9 1.45h1.57c-.06.33-.12.65-.15 1a2.05 2.05 0 00.58 1.63l2.76 2.76A2.05 2.05 0 0010 19c.34 0 .66-.09 1-.14v1.56a1 1 0 001.45.9l5.44-2.73A2 2 0 0019 16.76v-3.6a20.119 20.119 0 002.92-9.47 1.52 1.52 0 00-1.61-1.6v.05zM12 14a2 2 0 110-4 2 2 0 010 4z",
            fill: "currentColor"
        })
    });



const $8b98cbf61db27744$export$8b0a70e3ba90f2dd = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4 5h1v5.5a.5.5 0 00.5.5h5a.5.5 0 00.5-.5V5h2v5.5a.5.5 0 00.5.5h5a.5.5 0 00.5-.5V5h1a1 1 0 100-2H4a1 1 0 000 2zm16 14h-1v-5.5a.5.5 0 00-.5-.5h-5a.5.5 0 00-.5.5V19h-2v-5.5a.5.5 0 00-.5-.5h-5a.5.5 0 00-.5.5V19H4a1 1 0 000 2h16a1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $a2c7237e7b184b54$export$6a02761bc5ba304c = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.5 12h-15a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h15a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5zm.5-2.5a.5.5 0 00-.5-.5h-15a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h15a.5.5 0 00.5-.5v-1zM4 5h16a1 1 0 100-2H4a1 1 0 000 2zm16 14h-1v-2.5a.5.5 0 00-.5-.5h-5a.5.5 0 00-.5.5V19h-2v-2.5a.5.5 0 00-.5-.5h-5a.5.5 0 00-.5.5V19H4a1 1 0 000 2h16a1 1 0 000-2zm0-12.5a.5.5 0 00-.5-.5h-15a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h15a.5.5 0 00.5-.5v-1z",
            fill: "currentColor"
        })
    });



const $3225e931f0a8c904$export$a469d2f14361768 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15.7 8.5a4.39 4.39 0 011.8.39 4.39 4.39 0 011.8-.39c.205.005.409.025.61.06A5.33 5.33 0 0014.6 4 5.6 5.6 0 0011 5.46 5.6 5.6 0 007.4 4 5.36 5.36 0 002 9.44C2 12.81 4.63 15.87 9.16 20l.49.45a2 2 0 002.7 0l.49-.44c.43-.39.83-.78 1.23-1.15-1.72-1.68-3.07-3.45-3.07-5.64a4.659 4.659 0 014.7-4.72zm3.6 2a2.82 2.82 0 00-1.8.73 2.84 2.84 0 00-1.8-.73 2.689 2.689 0 00-2.7 2.72c0 1.68 1.31 3.21 3.58 5.29l.24.22a1 1 0 001.35 0l.25-.22C20.69 16.43 22 14.9 22 13.22a2.69 2.69 0 00-2.7-2.72z",
            fill: "currentColor"
        })
    });



const $0ad120f90a67118f$export$daa8f7da4e6e32e7 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7.52 6.11a.51.51 0 00.64 0 6.88 6.88 0 012.43-1 .49.49 0 00.41-.44v-2a.51.51 0 00-.57-.5 9.86 9.86 0 00-4.3 1.79.49.49 0 000 .75l1.39 1.4zM2.62 11h2.05a.49.49 0 00.48-.41 6.88 6.88 0 011-2.43.51.51 0 000-.64L4.66 6.08a.49.49 0 00-.75 0 9.86 9.86 0 00-1.79 4.3.51.51 0 00.5.62zm15.22-2.84a6.879 6.879 0 011 2.43.49.49 0 00.48.41h2.05a.512.512 0 00.5-.57 9.86 9.86 0 00-1.79-4.3.49.49 0 00-.75 0l-1.44 1.39a.51.51 0 00-.05.64zm-4.43-3a6.88 6.88 0 012.43 1 .51.51 0 00.64 0l1.44-1.45a.49.49 0 00-.05-.75 9.86 9.86 0 00-4.3-1.79.51.51 0 00-.57.5v2a.49.49 0 00.41.48v.01zM6.16 15.84a6.88 6.88 0 01-1-2.43.49.49 0 00-.49-.41h-2a.51.51 0 00-.5.57 9.86 9.86 0 001.79 4.3.49.49 0 00.75.05l1.45-1.44a.51.51 0 000-.64zm10.32 2.05a.51.51 0 00-.64-.05 6.88 6.88 0 01-2.43 1 .49.49 0 00-.41.48v2.05a.509.509 0 00.57.5 9.86 9.86 0 004.3-1.79.49.49 0 00.05-.75l-1.44-1.44zm4.9-4.89h-2.05a.49.49 0 00-.48.41 6.88 6.88 0 01-1 2.43.51.51 0 00.05.64l1.45 1.44a.492.492 0 00.75-.05 9.86 9.86 0 001.79-4.3.51.51 0 00-.51-.57zM12 11a1 1 0 100 2 1 1 0 000-2zm5 1a5 5 0 10-10 0 5 5 0 0010 0zm-5 3A3 3 0 1112 9 3 3 0 0112 15zm-1.41 3.85a6.88 6.88 0 01-2.43-1 .51.51 0 00-.64.05l-1.44 1.44a.49.49 0 000 .75 9.859 9.859 0 004.3 1.79.509.509 0 00.57-.5v-2.05a.49.49 0 00-.36-.48z",
            fill: "currentColor"
        })
    });



const $3f70e925ca262bf4$export$d4466e1b99926d4c = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M14.5 6a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM20 9.68a1 1 0 00-1.27-.63l-2 .67a1 1 0 01-.92-.15l-2.89-2.13a3 3 0 00-1.07-.51L9.1 6.25a3 3 0 00-2.39.41L4.45 8.17a1 1 0 101.1 1.66l2.27-1.51a1.06 1.06 0 01.8-.14l2.38.6-3.38 7.63a1 1 0 01-.92.59H4a1 1 0 000 2h2.7a3 3 0 002.74-1.78l1.06-2.38c.056.043.117.08.18.11l1.9.63a1 1 0 01.67.75L14 20.2a1 1 0 001 .8h.2a1 1 0 00.8-1.2l-.77-3.86a3 3 0 00-2-2.26l-1.89-.63 1.4-3.25 1.82 1.37a3 3 0 001.8.6c.323 0 .643-.05.95-.15l2-.67A1 1 0 0020 9.68z",
            fill: "currentColor"
        })
    });



const $32ec2d1ff39cfa75$export$d1557674b29beb12 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 3H5c-1.1 0-2 .9-2 2s.9 2 2 2v11c0 1.66 1.34 3 3 3h8c1.66 0 3-1.34 3-3V7c1.1 0 2-.9 2-2s-.9-2-2-2zm-3 11c0 .55-.45 1-1 1H9c-.55 0-1-.45-1-1v-3c0-.55.45-1 1-1h6c.55 0 1 .45 1 1v3z",
            fill: "currentColor"
        })
    });



const $89eed8f1e07c9ff2$export$8d986a53eb8bf871 = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M13.29 12.71c.2.2.45.29.71.29.26 0 .51-.1.71-.29l6-6a.996.996 0 000-1.41l-2-2a.996.996 0 00-1.41 0l-6 6a.996.996 0 000 1.41l2 2h-.01zm-3.21-.21l-6.79 6.79c-.29.29-.37.72-.22 1.09.15.37.52.62.92.62h1.7c.4 0 .78-.12 1.11-.34l2.75-1.83c.28-.19.45-.5.45-.83v-2.59l1.5-1.5-1.41-1.41h-.01zm3.91 6.5h-2c-.55 0-1 .45-1 1s.45 1 1 1h2c.55 0 1-.45 1-1s-.45-1-1-1zm6 0h-2c-.55 0-1 .45-1 1s.45 1 1 1h2c.55 0 1-.45 1-1s-.45-1-1-1z",
            fill: "currentColor"
        })
    });



const $d185c1ebfc63b0a5$export$b624e966f7931a44 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.12 3.88A3 3 0 0018 3h-1a1 1 0 00-2 0H9a1 1 0 00-2 0H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-.88-2.12zM18 13h-1v1a1 1 0 01-2 0v-1h-1a1 1 0 010-2h1v-1a1 1 0 012 0v1h1a1 1 0 010 2zm1-6H5V6a1 1 0 011-1h1a1 1 0 002 0h6a1 1 0 002 0h1a1 1 0 011 1v1z",
            fill: "currentColor"
        })
    });



const $9bf40e45e8b71646$export$ed9b7d672c845b32 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.12 3.88A3 3 0 0018 3h-1a1 1 0 00-2 0H9a1 1 0 00-2 0H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-.88-2.12zm-4.58 13.66a5 5 0 01-8.16-1.63A4.93 4.93 0 017.1 13 5 5 0 0111 9.1a4.93 4.93 0 012.89.28 5 5 0 011.63 8.16h.02zM19 7H5V6a1 1 0 011-1h1a1 1 0 002 0h6a1 1 0 002 0h1a1 1 0 011 1v1zm-5 6h-1v-1a1 1 0 00-2 0v1h-1a1 1 0 000 2h1v1a1 1 0 002 0v-1h1a1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $971b10b9a604f953$export$f6534d0e8058beae = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 8a1 1 0 00-1 1v5h-2a2.001 2.001 0 00-1.18-1.82l-1.9-7.53A2 2 0 0012 3a2 2 0 00-1.92 1.65l-1.9 7.53A2 2 0 007 14H5V9a1 1 0 00-2 0v9a1 1 0 00.07.35v.08a.81.81 0 00.4.41l4 2A1 1 0 008 21h8a1 1 0 00.42-.1l4-2a.81.81 0 00.4-.41.298.298 0 000-.08A1 1 0 0021 18V9a1 1 0 00-1-1zM4 6a1 1 0 001-1V4a1 1 0 00-2 0v1a1 1 0 001 1zm16-3a1 1 0 00-1 1v1a1 1 0 002 0V4a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $34397ca0e2dd9673$export$77ecb41bc0be538 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7.29 4.71A1 1 0 008 5h8a1 1 0 00.71-.29l1-1a1 1 0 00.21-1.09A1 1 0 0017 2H7a1 1 0 00-.92.62 1 1 0 00.21 1.09l1 1zm7.18 7.68l-1.9 1.41a1 1 0 01-1.2 0l-1.88-1.39A8 8 0 004 20a2 2 0 002 2h12a2 2 0 002-2 8 8 0 00-5.53-7.61zM16 20a1 1 0 110-2 1 1 0 010 2zm-4-9a4.48 4.48 0 004.45-4h-8.9A4.48 4.48 0 0012 11z",
            fill: "currentColor"
        })
    });



const $56a37e06a11fbb6e$export$de8452cba52914de = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7.29 4.71A1 1 0 008 5h8a1 1 0 00.71-.29l1-1a1 1 0 00.21-1.09A1 1 0 0017 2H7a1 1 0 00-.92.62 1 1 0 00.21 1.09l1 1zm7.18 7.68l-1.9 1.41a1 1 0 01-1.2 0l-1.88-1.39A8 8 0 004 20a2 2 0 002 2h12a2 2 0 002-2 8 8 0 00-5.53-7.61zM17 18.5a.469.469 0 01-.15.35l-1 1a.48.48 0 01-.7 0l-1-1a.47.47 0 01-.15-.35v-2a.5.5 0 01.5-.5h2a.5.5 0 01.5.5v2zM12 11a4.48 4.48 0 004.45-4h-8.9A4.48 4.48 0 0012 11z",
            fill: "currentColor"
        })
    });



const $f295323296d5971e$export$e33eb52853e7f696 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M14.47 12.39l-1.9 1.41a1 1 0 01-1.2 0l-1.88-1.39A8 8 0 004 20a2 2 0 002 2h12a2 2 0 002-2 8 8 0 00-5.53-7.61zM10 20H8a1 1 0 010-2h2a1 1 0 010 2zm6 0a1 1 0 110-2 1 1 0 010 2zM7.29 4.71A1 1 0 008 5h8a1 1 0 00.71-.29l1-1a1 1 0 00.21-1.09A1 1 0 0017 2H7a1 1 0 00-.92.62 1 1 0 00.21 1.09l1 1zM12 11a4.48 4.48 0 004.45-4h-8.9A4.48 4.48 0 0012 11z",
            fill: "currentColor"
        })
    });



const $83b29c066cbf2323$export$a8e7da0a4f04346c = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 17c-.479 0-.95.12-1.37.35A4 4 0 0013 15.14V10a2.65 2.65 0 001.72-.79A5.86 5.86 0 0016 5.5a.5.5 0 00-.5-.5 4.66 4.66 0 00-2.73.77A5 5 0 007.5 2a.5.5 0 00-.5.5c0 .12 0 3 1.56 4.52A3.32 3.32 0 0011 8v7.14a4 4 0 00-2.63 2.21A2.87 2.87 0 007 17a3 3 0 00-3 3v1a1 1 0 001 1h14a1 1 0 001-1v-1a3 3 0 00-3-3z",
            fill: "currentColor"
        })
    });



const $1e897bc413d08cb0$export$47c1c184c11de616 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 3H7a3 3 0 00-3 3v3a2 2 0 002 2v1a1 1 0 102 0v-1a2 2 0 002-2h3a2 2 0 012 2v1a2 2 0 01-2 2H6a3 3 0 00-3 3v2a1 1 0 001 1h1a1 1 0 102 0h10a1 1 0 002 0h1a1 1 0 001-1V6a3 3 0 00-3-3z",
            fill: "currentColor"
        })
    });



const $dffb0019e49505fa$export$73b07e8c665fab30 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.48 7.65A2 2 0 0018 7h-2V6a4 4 0 10-8 0v1H6a2 2 0 00-2 2.18l1 11a2 2 0 00.65 1.3A2 2 0 007 22h10a2 2 0 001.35-.52 2 2 0 00.65-1.3l1-11a2.001 2.001 0 00-.52-1.53zM14 7h-4V6a2 2 0 114 0v1z",
            fill: "currentColor"
        })
    });



const $98005e3715a14615$export$533cf055f5eac840 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 6h-1a4 4 0 10-8 0H7a3 3 0 00-3 3v10a3 3 0 003 3h1.56A3.91 3.91 0 018 20v-5a4 4 0 012.28-3.6 5 5 0 019.44 0c.09.05.19.09.28.15V9a3 3 0 00-3-3zm-7 0a2 2 0 114 0h-4zm8 7a3 3 0 00-6 0 2 2 0 00-2 2v5a2 2 0 002 2h6a2 2 0 002-2v-5a2 2 0 00-2-2zm-4 0a1 1 0 012 0h-2z",
            fill: "currentColor"
        })
    });



const $d8ffbb6392675069$export$b92bfed4c7628a0d = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12.5 15.67c-.48-.28-1.09-.11-1.37.37l-2 3.46c-.28.48-.11 1.09.37 1.37s1.09.11 1.37-.37l2-3.46c.28-.48.11-1.09-.37-1.37zm-4 0c-.48-.28-1.09-.11-1.37.37l-2 3.46c-.28.48-.11 1.09.37 1.37s1.09.11 1.37-.37l2-3.46c.28-.48.11-1.09-.37-1.37zm10.94-7.29c.03-.21.06-.42.06-.63C19.5 5.13 17.37 3 14.75 3c-1.64 0-3.08.83-3.93 2.09A3.68 3.68 0 0010 5a3.98 3.98 0 00-3.86 3.01C6.09 8.01 6.05 8 6 8c-1.66 0-3 1.34-3 3s1.34 3 3 3h12c1.66 0 3-1.34 3-3 0-1.13-.64-2.11-1.56-2.62zm-2.94 7.29c-.48-.28-1.09-.11-1.37.37l-2 3.46c-.28.48-.11 1.09.37 1.37s1.09.11 1.37-.37l2-3.46c.28-.48.11-1.09-.37-1.37z",
            fill: "currentColor"
        })
    });



const $6be18b36a4c5a90f$export$5148c323a832726d = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17.5 6a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM20 19h-3v-3.93a3 3 0 00-1.34-2.5l-1.89-1.26 2-2.71A1 1 0 0015 7H8a1 1 0 000 2h5l-4.2 5.6a1 1 0 01-.8.4H5v-1a1 1 0 10-2 0 1 1 0 000 2v2a1 1 0 000 2 1 1 0 102 0v-3h3a3 3 0 002.4-1.2l2.17-2.89 2 1.33a1 1 0 01.45.83V19H14a1 1 0 000 2 1 1 0 002 0h2a1 1 0 002 0 1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $e5ded062ac01c832$export$64e967779cf5416f = (s)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...s,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18.93 10.1a.992.992 0 00-1.26.34L15.96 13a.25.25 0 01-.46-.14V5c0-.55-.45-1-1-1s-1 .45-1 1v5.5c0 .28-.22.5-.5.5s-.5-.22-.5-.5V3c0-.55-.45-1-1-1s-1 .45-1 1v7.5c0 .28-.22.5-.5.5s-.5-.22-.5-.5V4c0-.55-.45-1-1-1s-1 .45-1 1v7.5c0 .28-.22.5-.5.5s-.5-.22-.5-.5V7c0-.55-.45-1-1-1s-1 .45-1 1v7.99c0 3.71 2.88 6.93 6.59 7.01 3.06.06 5.72-1.88 6.6-4.8l1.77-5.91a.998.998 0 00-.53-1.19zM6.5 15c-.28 0-.5-.22-.5-.5s.22-.5.5-.5.5.22.5.5-.22.5-.5.5zm1 4c-.28 0-.5-.22-.5-.5s.22-.5.5-.5.5.22.5.5-.22.5-.5.5zm0-3c-.28 0-.5-.22-.5-.5s.22-.5.5-.5.5.22.5.5-.22.5-.5.5zm0-2c-.28 0-.5-.22-.5-.5s.22-.5.5-.5.5.22.5.5-.22.5-.5.5zm2 6c-.28 0-.5-.22-.5-.5s.22-.5.5-.5.5.22.5.5-.22.5-.5.5zm4-3c-.28 0-.5-.22-.5-.5s.22-.5.5-.5.5.22.5.5-.22.5-.5.5zm1 2c-.28 0-.5-.22-.5-.5s.22-.5.5-.5.5.22.5.5-.22.5-.5.5zm1-3c-.28 0-.5-.22-.5-.5s.22-.5.5-.5.5.22.5.5-.22.5-.5.5z",
            fill: "currentColor"
        })
    });



const $7f4225c298d60c8c$export$bbe0655d29ebd27a = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12.02 5.08c.28 0 .55-.08.78-.23.23-.15.41-.37.51-.63.1-.26.13-.54.08-.81-.06-.27-.19-.52-.38-.72-.2-.2-.45-.33-.72-.38a1.33 1.33 0 00-.81.08c-.25.1-.48.29-.63.51-.15.23-.23.5-.23.78 0 .37.15.73.41.99s.62.41.99.41zm7.27 4.1c.16-.18.27-.41.27-.67 0-.55-.45-1-1-1h-2.78c-.15 0-.29-.04-.43-.12l-1.92-1.08a2.83 2.83 0 00-1.41-.37h-.01c-.02 0-.04.01-.07.01-.45.01-.91.13-1.32.36L8.7 7.39c-.13.07-.28.11-.42.11H5.49c-.55 0-1 .45-1 1 0 .24.1.46.24.63-.08.4-.15.8-.19 1.23-.03.3-.04.59-.04.89 0 3.01 1.3 5.67 3.26 7.26l-.37.74a.993.993 0 00.45 1.34 1.007 1.007 0 001.35-.44l.3-.61c.79.33 1.63.52 2.51.52 4.14 0 7.5-3.95 7.5-8.81 0-.29-.02-.57-.04-.88-.03-.41-.09-.82-.17-1.21v.02zM8.22 17.61c-1.65-1.42-2.72-3.73-2.72-6.34 0-.26 0-.53.04-.8.03-.33.08-.65.13-.96h2.61c.49 0 .98-.13 1.41-.37l1.32-.74v3.64l-2.79 5.57zM12 19.08c-.72 0-1.42-.15-2.07-.41l2.09-4.17.05.1c.36.71 1 1.24 1.75 1.47.27.08.55.12.82.12.5 0 .99-.13 1.43-.39l.89-.51c.48-.28.64-.89.36-1.37a.998.998 0 00-1.37-.36l-.89.51c-.21.12-.45.15-.68.08a.922.922 0 01-.54-.45l-.83-1.65V8.39l1.34.75c.43.24.92.37 1.41.37h2.56a9.673 9.673 0 01.16 1.76c0 4.31-2.92 7.81-6.5 7.81H12z",
            fill: "currentColor"
        })
    });



const $19cc5b310ec3cef3$export$1976aa36df1b03a7 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a8.51 8.51 0 00-8.5 8.5c0 2.82.38 5.32 2.5 6.86V20a2 2 0 002 2h1v-2a1 1 0 112 0v2h2v-2a1 1 0 012 0v2h1a2 2 0 002-2v-2.64c2.12-1.54 2.5-4 2.5-6.86A8.51 8.51 0 0012 2zM8.5 15a2.5 2.5 0 110-5 2.5 2.5 0 010 5zm7 0a2.5 2.5 0 110-5 2.5 2.5 0 010 5z",
            fill: "currentColor"
        })
    });



const $b68b5187473e9abf$export$4db3538fea45b47c = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10 17H5c0 1.1.9 2 2 2h2v1c0 1.1.9 2 2 2h1v-3c0-1.1-.9-2-2-2zm3-14.99C8.68 2 5.15 5.45 5.01 9.74L3.1 13.56a.993.993 0 00.45 1.34l.21.11H10c2.21 0 4 1.79 4 4v3h2c1.1 0 2-.9 2-2v-3.76c1.83-1.47 3-3.72 3-6.24 0-4.41-3.59-8-8-8zm.3 7.99c.12 0 .24.05.33.15.09.1.14.22.14.35a.5.5 0 01-.47.5h-1.85c-.09 0-.18-.03-.26-.09a.525.525 0 01-.2-.51c.02-.1.06-.19.13-.25L12.17 9h-.73c-.12 0-.24-.05-.33-.15a.5.5 0 01-.14-.35.5.5 0 01.47-.5h1.85c.1 0 .19.02.28.07.08.06.15.14.18.24.03.09.04.2.01.29-.02.1-.08.18-.15.25L12.56 10h.74zm3.56-2.15c-.09.09-.2.15-.33.15h-1.85c-.09 0-.18-.03-.26-.09a.525.525 0 01-.2-.51c.02-.1.06-.19.13-.25L15.4 6h-.73c-.12 0-.24-.05-.33-.15a.518.518 0 01-.14-.35.5.5 0 01.47-.5h1.85c.09 0 .18.03.26.09a.525.525 0 01.2.51c-.02.1-.06.19-.13.25L15.8 7h.73c.12 0 .24.05.33.15a.5.5 0 01.14.35.5.5 0 01-.14.35z",
            fill: "currentColor"
        })
    });



const $dcdf94e2ac95bf78$export$a7ad59ef45ee311 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M13.24 7h.79l-1.14 1.15c-.07.07-.12.16-.14.25-.02.1 0 .2.03.29.04.09.1.17.18.22.08.05.18.08.28.09h2c.13 0 .26-.05.35-.15.09-.1.15-.22.15-.35a.47.47 0 00-.15-.35.529.529 0 00-.35-.15h-.79l1.14-1.15a.42.42 0 00.16-.25c.03-.1.02-.2-.01-.29a.52.52 0 00-.2-.24.462.462 0 00-.3-.07h-2a.47.47 0 00-.35.15c-.09.1-.15.22-.15.35 0 .13.05.26.15.35.1.09.22.15.35.15zm2.5-4h.79l-1.14 1.15c-.07.07-.12.16-.14.25-.02.1 0 .2.03.29.04.09.1.17.18.22.08.05.18.08.28.09h2c.13 0 .26-.05.35-.15.09-.1.15-.22.15-.35a.47.47 0 00-.15-.35.529.529 0 00-.35-.15h-.79l1.14-1.15c.07-.07.12-.16.14-.25.02-.1 0-.2-.03-.29a.489.489 0 00-.18-.22.66.66 0 00-.28-.09h-2a.47.47 0 00-.35.15c-.09.1-.15.22-.15.35 0 .13.05.26.15.35.1.09.22.15.35.15zM9 9c.4 0 .78-.12 1.11-.34.33-.22.59-.53.74-.9a2.004 2.004 0 00-.44-2.18c-.28-.28-.64-.47-1.02-.55-.38-.08-.79-.04-1.16.11a2.014 2.014 0 00-1.24 1.85c0 .53.21 1.04.59 1.41.38.38.88.59 1.41.59L9 9zm11.63 5H9v-3c0-1.1-.9-2-2-2s-2 .9-2 2v3H4V8c0-.55-.45-1-1-1s-1 .45-1 1v12c0 .55.45 1 1 1s1-.45 1-1v-1h16v1c0 .55.45 1 1 1s1-.45 1-1v-4.63c0-.76-.61-1.37-1.37-1.37z",
            fill: "currentColor"
        })
    });



const $bccc5875682d215c$export$4299fc56e8e2dedf = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18.82 14.75a7 7 0 01-8-10 1 1 0 00-1.16-1.43A9 9 0 1020 16.18a1 1 0 00-1.15-1.43h-.03zM14.5 8h.79l-1.14 1.15a.47.47 0 00-.11.54.5.5 0 00.46.31h2a.5.5 0 000-1h-.79l1.14-1.15a.47.47 0 00-.05-.776.5.5 0 00-.3-.074h-2a.5.5 0 000 1zm6-3h-.79l1.14-1.15a.47.47 0 00-.05-.776.5.5 0 00-.3-.074h-2a.5.5 0 000 1h.79l-1.14 1.15a.47.47 0 00-.11.54.5.5 0 00.46.31h2a.5.5 0 000-1z",
            fill: "currentColor"
        })
    });



const $59f94be56a90040b$export$44efe4bebd73a4e6 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M8.71 15.29a.996.996 0 00-1.41 0l-.29.29-.29-.29a.996.996 0 10-1.41 1.41l.29.29-.29.29a.996.996 0 00.71 1.7c.26 0 .51-.1.71-.29l.29-.29.29.29c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 000-1.41l-.29-.29.29-.29a.996.996 0 000-1.41h-.02zm10.73-6.91c.03-.21.06-.42.06-.63C19.5 5.13 17.37 3 14.75 3c-1.64 0-3.08.83-3.93 2.09A3.68 3.68 0 0010 5a3.98 3.98 0 00-3.86 3.01C6.09 8.01 6.05 8 6 8c-1.66 0-3 1.34-3 3s1.34 3 3 3h12c1.66 0 3-1.34 3-3 0-1.13-.64-2.11-1.56-2.62zM12 17c-.5 0-1.5 1.67-1.5 2.5 0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5-1-2.5-1.5-2.5zm5-2c-.5 0-1.5 1.67-1.5 2.5 0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5-1-2.5-1.5-2.5z",
            fill: "currentColor"
        })
    });



const $a4a59a73f1681dee$export$2947358186f68876 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M14 20h-4a1 1 0 000 2h4a1 1 0 000-2zM11.88 2A7.1 7.1 0 005 8.74a7 7 0 002.85 5.89A2.9 2.9 0 019 17a1 1 0 001 1h4a1 1 0 001-1 2.858 2.858 0 011.13-2.34A7 7 0 0011.88 2z",
            fill: "currentColor"
        })
    });



const $9adb86df9e726531$export$8c9ff36c8241be13 = (v)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...v,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M8.71 5.13c.39-.39.44-.41 1.24.12.76.51 2.18 1.46 3.76-.12.39-.39.44-.41 1.24.12.45.3 1.12.75 1.92.75.56 0 1.19-.22 1.84-.87a.996.996 0 10-1.41-1.41c-.39.39-.44.41-1.24-.12-.76-.51-2.18-1.46-3.76.12-.39.39-.44.41-1.24-.12-.76-.51-2.18-1.46-3.76.12a.996.996 0 101.41 1.41zm11.85 4.59L16.01 12v-1.48c0-.72-.73-1.2-1.39-.92L9.01 12v-1.48c0-.72-.73-1.2-1.39-.92l-1.61.69V4c0-.55-.45-1-1-1h-1c-.55 0-1 .45-1 1v7.61c-.61.36-1 .99-1 1.71V19c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-8.38c0-.74-.78-1.23-1.45-.89v-.01zM12.01 17h-2v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2z",
            fill: "currentColor"
        })
    });



const $4cc34830424d9dcc$export$5f1b41283ba747d6 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4 21a1 1 0 001 1h14a1 1 0 001-1v-2H4v2zm.38-4h15.24L19 15.76V8.24L19.62 7H4.38L5 8.24v7.52L4.38 17zM19 2H5a1 1 0 00-1 1v2h16V3a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $c4f8cf1bf3188851$export$31b2cf36df66d842 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.5 17H18V5.5c0-.83-.67-1.5-1.5-1.5h-5c-.83 0-1.5.67-1.5 1.5V17H7v-5.61c.61-.55 1-1.41 1-2.39 0-1.43-.83-2.62-1.95-2.92.03-.11.05-.22.11-.32.13-.25.3-.47.49-.67.08-.08.16-.17.21-.27.08-.18.05-.41-.09-.55a.517.517 0 00-.54-.12c-.12.05-.21.14-.29.23-.15.16-.28.33-.4.51h-.02c-.11-.17-.21-.36-.34-.53a.92.92 0 00-.26-.26c-.17-.1-.4-.07-.55.05-.15.12-.21.35-.15.54.04.11.11.2.18.3.17.22.32.45.41.71.04.13.07.26.08.4-1.09.33-1.9 1.5-1.9 2.91 0 .98.4 1.84 1 2.39v7.11c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5V7h2v11.5c0 .83.67 1.5 1.5 1.5h4c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5h.01z",
            fill: "currentColor"
        })
    });



const $69dce4fabb1a87e6$export$d3ff6471e46391ec = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.44 8.38c.03-.21.06-.42.06-.63C19.5 5.13 17.37 3 14.75 3c-1.64 0-3.08.83-3.93 2.09A3.68 3.68 0 0010 5a3.98 3.98 0 00-3.86 3.01C6.09 8.01 6.05 8 6 8c-1.66 0-3 1.34-3 3s1.34 3 3 3h12c1.66 0 3-1.34 3-3 0-1.13-.64-2.11-1.56-2.62zM7.71 15.79a.996.996 0 00-1.41 0l-.29.29-.29-.29a.996.996 0 10-1.41 1.41l.29.29-.29.29a.996.996 0 00.71 1.7c.26 0 .51-.1.71-.29l.29-.29.29.29c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 000-1.41l-.29-.29.29-.29a.996.996 0 000-1.41h-.02zm12 0a.996.996 0 00-1.41 0l-.29.29-.29-.29a.996.996 0 10-1.41 1.41l.29.29-.29.29a.996.996 0 00.71 1.7c.26 0 .51-.1.71-.29l.29-.29.29.29c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 000-1.41l-.29-.29.29-.29a.996.996 0 000-1.41h-.02zm-6 2a.996.996 0 00-1.41 0l-.29.29-.29-.29a.996.996 0 10-1.41 1.41l.29.29-.29.29a.996.996 0 00.71 1.7c.26 0 .51-.1.71-.29l.29-.29.29.29c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 000-1.41l-.29-.29.29-.29a.996.996 0 000-1.41h-.02z",
            fill: "currentColor"
        })
    });



const $232b1df9fb9f590a$export$ccb0025b8df9e2b5 = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M8.71 16.29a.996.996 0 00-1.41 0l-.29.29-.29-.29a.996.996 0 10-1.41 1.41l.29.29-.29.29a.996.996 0 00.71 1.7c.26 0 .51-.1.71-.29l.29-.29.29.29c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 000-1.41l-.29-.29.29-.29a.996.996 0 000-1.41h-.02zm9.32.46a1.01 1.01 0 00-1.37-.37l-.67.38v-.77c0-.55-.45-1-1-1s-1 .45-1 1v.77l-.67-.38c-.48-.28-1.09-.11-1.37.37s-.11 1.09.37 1.37l.67.38-.67.38c-.48.28-.64.89-.37 1.37.27.48.89.64 1.37.37l.67-.38v.77c0 .55.45 1 1 1s1-.45 1-1v-.77l.67.38c.48.28 1.09.11 1.37-.37s.11-1.09-.37-1.37l-.67-.38.67-.38c.48-.28.64-.89.37-1.37zm1.41-8.37c.03-.21.06-.42.06-.63C19.5 5.13 17.37 3 14.75 3c-1.64 0-3.08.83-3.93 2.09A3.68 3.68 0 0010 5a3.98 3.98 0 00-3.86 3.01C6.09 8.01 6.05 8 6 8c-1.66 0-3 1.34-3 3s1.34 3 3 3h12c1.66 0 3-1.34 3-3 0-1.13-.64-2.11-1.56-2.62z",
            fill: "currentColor"
        })
    });



const $3d878641ae0d7425$export$7289d80a8799946c = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21 4a5.67 5.67 0 00-2.66.59A3.82 3.82 0 0116.5 5a3.84 3.84 0 01-1.85-.41A5.66 5.66 0 0012 4a5.67 5.67 0 00-2.66.59A3.82 3.82 0 017.5 5a3.84 3.84 0 01-1.85-.41A5.59 5.59 0 003 4a1 1 0 00-1 1v14a1 1 0 001 1h18a1 1 0 001-1V5a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $8a3acfe5b5b6d790$export$c263bdea35863f9c = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M2 19a1 1 0 001 1h18a1 1 0 001-1v-6H2v6zM21 4a5.67 5.67 0 00-2.66.59A3.82 3.82 0 0116.5 5a3.84 3.84 0 01-1.85-.41A5.66 5.66 0 0012 4a5.67 5.67 0 00-2.66.59A3.82 3.82 0 017.5 5a3.84 3.84 0 01-1.85-.41A5.59 5.59 0 003 4a1 1 0 00-1 1v6h20V5a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $d3cbe8a6deef251c$export$71834720d7a5b1fa = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M5.5 11h-1a.5.5 0 010-1h2a1 1 0 000-2h-2a2.5 2.5 0 100 5h1a.5.5 0 010 1h-2a1 1 0 000 2h2a2.5 2.5 0 000-5zM12 8a3 3 0 00-3 3v2a3 3 0 006 0v-2a3 3 0 00-3-3zm1 5a1 1 0 01-2 0v-2a1 1 0 012 0v2zm6.5-2h-1a.5.5 0 010-1h2a1 1 0 100-2h-2a2.5 2.5 0 000 5h1a.5.5 0 010 1h-2a1 1 0 000 2h2a2.5 2.5 0 000-5z",
            fill: "currentColor"
        })
    });



const $4bde19bfd757bd07$export$2f4ed9b9f63a87fe = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zM7.75 14h-1.5a.5.5 0 010-1h1.5a.25.25 0 100-.5h-1a1.25 1.25 0 010-2.5h1.5a.5.5 0 010 1h-1.5a.25.25 0 100 .5h1a1.25 1.25 0 010 2.5zM12 14a2 2 0 110-4 2 2 0 010 4zm5.25 0h-1.5a.5.5 0 010-1h1.5a.25.25 0 100-.5h-1a1.25 1.25 0 010-2.5h1.5a.5.5 0 010 1h-1.5a.25.25 0 100 .5h1a1.25 1.25 0 010 2.5zM12 11a1 1 0 100 2 1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $60a4571ec5b37520$export$63cdb60a9a539f85 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16.5 15.5a1 1 0 100-2 1 1 0 000 2zM12 13a1 1 0 102 0 1 1 0 00-2 0zm8.64 3.32a1 1 0 00-.82-.21 6.08 6.08 0 00-1.46.48 3.909 3.909 0 01-1.86.41 3.839 3.839 0 01-1.85-.41A5.66 5.66 0 0012 16a5.671 5.671 0 00-2.66.59A3.82 3.82 0 017.5 17a3.998 3.998 0 01-1.87-.41 5.846 5.846 0 00-1.45-.48 1.001 1.001 0 00-.82.21 1 1 0 00-.36.77V20a1 1 0 001 1h16a1 1 0 001-1v-2.91a1 1 0 00-.36-.77zM8.29 12.71a.998.998 0 001.42 0l3-3a.998.998 0 000-1.42l-5-5a1 1 0 00-1.42 0l-3 3a1 1 0 000 1.42l5 5z",
            fill: "currentColor"
        })
    });



const $8d2d02f5d5e5cb0f$export$6d0e9d7ed5558950 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 11h-3V9h.13a1 1 0 001-.86L14.58 5a2.61 2.61 0 10-5.16 0l.46 3.17a1 1 0 001 .86H11v2H8a2 2 0 00-2 2v4.38a3 3 0 001.66 2.69l3.45 1.72a2 2 0 001.78 0l3.45-1.72A3 3 0 0018 17.38V13a2 2 0 00-2-2z",
            fill: "currentColor"
        })
    });



const $a14390f7b5cde627$export$2ed7bfe5ab085a34 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.12 15.88l-5.33-5.33A6.101 6.101 0 0015 9a6 6 0 00-6-6 5.521 5.521 0 00-.72.06h-.1a1 1 0 00-.82.67 1 1 0 00.24 1l2.64 2.63-2.83 2.88L4.78 7.6a1 1 0 00-1-.24 1 1 0 00-.67.82v.1A5.52 5.52 0 003 9a6 6 0 006 6 6.101 6.101 0 001.55-.21l5.33 5.33a3 3 0 004.24 0 3 3 0 000-4.24z",
            fill: "currentColor"
        })
    });



const $987380103c99ad2d$export$d95fda17a4fb8827 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.1 4.21L3.91 9.9c-.55.21-.91.73-.91 1.32v2.49c0 .62.4 1.16.99 1.34l.57.18c-.25.86-.15 1.77.29 2.56a3.31 3.31 0 002.01 1.6c.31.09.62.13.93.13.56 0 1.12-.14 1.62-.42.74-.41 1.28-1.08 1.55-1.88l8.21 2.57c.91.28 1.83-.39 1.83-1.34V5.53c0-.98-.98-1.66-1.9-1.32zM8.33 17.14c-.26.15-.56.18-.85.1a1.11 1.11 0 01-.67-.53c-.14-.25-.17-.53-.1-.8l2.1.66c-.09.24-.26.45-.49.58l.01-.01z",
            fill: "currentColor"
        })
    });



const $76f5306c812b8837$export$cdf25c626d5129c9 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 5h-3V4c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v1H6C3.79 5 2 6.79 2 9v1c0 .55.45 1 1 1h3v9c0 .55.45 1 1 1h10c.55 0 1-.45 1-1v-9h3c.55 0 1-.45 1-1V9c0-2.21-1.79-4-4-4zm-5.17 12.55c-.19.29-.51.45-.83.45-.19 0-.38-.05-.55-.17a1.01 1.01 0 01-.28-1.39c.68-1.01.42-1.79-.1-3.07-.53-1.33-1.2-2.99.1-4.93.31-.46.93-.58 1.39-.28.46.31.58.93.28 1.39-.68 1.01-.42 1.79.1 3.07.53 1.33 1.2 2.99-.1 4.93h-.01z",
            fill: "currentColor"
        })
    });



const $a6605e6e9f738769$export$919737df5c5e76d7 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M14.79 5.63c.3.3.68.5 1.09.58.41.08.84.04 1.23-.12s.72-.43.96-.78c.23-.35.36-.76.36-1.18 0-.56-.23-1.1-.62-1.5-.4-.4-.94-.62-1.51-.62a2.126 2.126 0 00-1.96 1.31c-.16.39-.2.81-.12 1.23.08.41.28.79.58 1.09l-.01-.01zm-4.72 10.41l-1.6-1.63a.66.66 0 00-.2-.14.687.687 0 00-.24-.05c-.08 0-.17.02-.24.05-.08.03-.15.08-.2.14l-4.06 3.84c-.31.31-.49.72-.53 1.15 0 .22.03.43.11.64.08.2.2.39.35.54.3.31.72.49 1.15.49.38 0 .75-.14 1.05-.39l4.35-3.71c.13-.11.21-.27.22-.44.01-.09 0-.18-.02-.26a.438.438 0 00-.14-.22v-.01zm10.79-7.13a1.49 1.49 0 00-1.05-.73c-.11-.03-.22-.04-.33-.04-.34 0-.66.12-.93.32l-2.64 1.93c-.1.08-.17.18-.22.29-.05.11-.06.24-.04.36.02.12.07.24.16.33.09.09.2.15.32.18l.93.22c.31.07.63.11.94.11.91 0 1.8-.32 2.5-.91.61-.57.75-1.42.35-2.05l.01-.01zm-7.59 3.06l.09-.08c.66-.6 1.48-1.53 1.68-2.58a2.617 2.617 0 00-.46-2.08.304.304 0 01-.05-.07c0-.01 0-.02-.02-.03-1.2-1.37-2.93-1.98-5.13-1.83-1.74.15-3.44.65-4.98 1.47a1.584 1.584 0 00-.83.93c-.07.2-.1.42-.08.63a1.595 1.595 0 00.58 1.1c.17.13.36.23.56.29.21.06.42.07.63.05.21-.03.42-.1.6-.21.59-.31 2.51-1.13 4.19-1.13.6-.03 1.19.12 1.7.43l.09.06-.07.09c-.53.61-1.15 1.12-1.86 1.51-.21.13-.39.31-.52.52-.13.21-.22.45-.25.7-.02.25.02.5.12.73.1.23.25.43.44.59l3.35 2.81-2.56 3.65c-.23.35-.32.77-.25 1.18.07.41.3.77.63 1.02.27.17.58.27.9.28.25 0 .5-.07.73-.18.22-.12.42-.28.57-.48l3.35-4.82a1.546 1.546 0 00-.28-2.09l-2.89-2.45.02-.01z",
            fill: "currentColor"
        })
    });



const $1db6f721b94424de$export$9e95c387d28bc03f = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7.89 11.97c.05 0 .1.03.15.03l2.11 3.52c.19.31.52.49.86.49a.995.995 0 00.85-1.51l-2.67-4.46 1.56-2.33 1.45.97c.33.22.71.34 1.11.34h2.7c.55 0 1-.45 1-1s-.45-1-1-1h-2.7l-2.5-1.66a1.99 1.99 0 00-1.11-.34H6.42c-.53 0-1.04.21-1.41.59l-.71.71a.996.996 0 101.41 1.41l.71-.71H8.8l-3.33 5H3c-.55 0-1 .45-1 1s.45 1 1 1h2.46c.67 0 1.29-.33 1.66-.89l.76-1.14.01-.02zM12.5 5c.83 0 1.5-.67 1.5-1.5S13.33 2 12.5 2 11 2.67 11 3.5 11.67 5 12.5 5zm8 11.5c-.44 0-.84.2-1.11.5h-1.57l-.84-4.2a1 1 0 00-.9-.8.999.999 0 00-1.02.65l-2.31 6.17-.92-1.38c-.19-.28-.5-.45-.83-.45H8c-.55 0-1 .45-1 1s.45 1 1 1h2.46l1.7 2.55c.19.28.5.45.83.45h.11c.37-.04.69-.29.82-.64l1.77-4.72.31 1.57c.09.47.5.8.98.8h2.39c.27.3.67.5 1.11.5.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5h.02z",
            fill: "currentColor"
        })
    });



const $8bd18573d22a3495$export$8f536612125e6d2d = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M14 7h-4a3 3 0 00-3 3v1h10v-1a3 3 0 00-3-3zm0-4a1 1 0 00-1-1h-2a1 1 0 00-1 1v2h4V3zM7 21a1 1 0 001 1h8a1 1 0 001-1v-8H7v8zM18 5h2a1 1 0 100-2h-2a1 1 0 100 2zm2.24 1.53l-2-.5A1.014 1.014 0 0017.76 8l2 .5H20a1.007 1.007 0 00.24-2v.03z",
            fill: "currentColor"
        })
    });



const $c037babd58811086$export$371d83f12baee276 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10.5 10h-6a.5.5 0 00-.5.5v3a.5.5 0 00.5.5h6a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5zM19.5 10h-6a.5.5 0 00-.5.5v3a.5.5 0 00.5.5h6a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5zM10.5 16h-6a.5.5 0 00-.5.5v3a.5.5 0 00.5.5h6a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5zM19.5 16h-6a.5.5 0 00-.5.5v3a.5.5 0 00.5.5h6a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5zM10.5 4h-6a.5.5 0 00-.5.5v3a.5.5 0 00.5.5h6a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5zM19.5 4h-6a.5.5 0 00-.5.5v3a.5.5 0 00.5.5h6a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5z",
            fill: "currentColor"
        })
    });



const $af9914244f53954f$export$fb6b4bdc924873e8 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17.23 6.01h-7.05c-.88 0-1.66.55-1.95 1.38l-2.29 5.2c-.28.64-.22 1.37.16 1.96.38.58 1.03.93 1.73.93l3.41.02-1.11 5.29c-.12.54.23 1.07.77 1.19.07.01.14.02.21.02.46 0 .88-.32.98-.79l1.09-5.12c.17-.62.04-1.28-.35-1.79-.39-.51-.99-.81-1.64-.81H7.83l2.35-5.47h7.05c.55 0 1-.45 1-1s-.45-1.01-1-1.01zM11.26 5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
            fill: "currentColor"
        })
    });



const $a20c0631c4c29f21$export$f141c2abea7a7c02 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zM4.61 9a8 8 0 0114.78 0 1 1 0 01-.62 1.32 1 1 0 01-1.21-.58 6 6 0 00-11.08 0 1 1 0 01-1.21.58A1 1 0 014.61 9zm5.69 9.78a.998.998 0 01-1.3.61A8 8 0 014.61 15a1 1 0 01.62-1.33 1 1 0 011.21.58 6 6 0 003.26 3.26 1 1 0 01.6 1.24v.03zM8 12a4 4 0 118 0 4 4 0 01-8 0zm11.39 3A8 8 0 0115 19.39a1 1 0 01-1.33-.62 1 1 0 01.58-1.21 6 6 0 003.26-3.26 1 1 0 011.21-.58 1 1 0 01.67 1.28zM12 11a1 1 0 100 2 1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $df3072b2b66247cb$export$452252ac83567d12 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M6.5 2C4.57 2 3 4.69 3 8a8.36 8.36 0 001.17 4.46 45.348 45.348 0 015-.68A8.9 8.9 0 0010 8c0-3.31-1.57-6-3.5-6zM5.33 14.29A4.49 4.49 0 005 16c0 1.93 1.12 4 2.5 4s2.5-2.07 2.5-4a4.42 4.42 0 00-.57-2.21c-1.58.12-2.97.31-4.1.5zM17.5 4C15.57 4 14 6.69 14 10a8.93 8.93 0 00.77 3.74c1.708.104 3.406.335 5.08.69A8.37 8.37 0 0021 10c0-3.31-1.57-6-3.5-6zm-2.9 11.74A4.36 4.36 0 0014 18c0 1.93 1.12 4 2.5 4s2.5-2.07 2.5-4a4.37 4.37 0 00-.36-1.77 34.199 34.199 0 00-4.04-.49z",
            fill: "currentColor"
        })
    });



const $6fea123098c9db86$export$fb441a685a4de20c = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17.62 3H6.38C4.52 3 3 4.51 3 6.38v11.25c0 1.86 1.51 3.38 3.38 3.38h4.55v-3.63c-2.37-.43-4.31-2.27-4.8-4.69-.11-.54.24-1.07.78-1.18.54-.11 1.07.24 1.18.78.31 1.53 1.5 2.7 2.97 3.06.54-2.55 2.8-4.47 5.5-4.47h4.45v-4.5C21.01 4.52 19.5 3 17.63 3h-.01zm-7.33 5.51a1.639 1.639 0 01-1.3 1.3c-.32.06-.66.03-.96-.09-.3-.13-.56-.34-.75-.61A1.66 1.66 0 017 8.19c0-.44.17-.86.49-1.17.32-.31.73-.49 1.17-.49.33 0 .65.1.92.28.27.18.49.44.61.75s.17.63.1.95zm6.68 0a1.639 1.639 0 01-1.3 1.3c-.32.06-.66.03-.96-.09-.3-.13-.56-.34-.75-.61a1.66 1.66 0 01-.28-.92c0-.44.17-.86.49-1.17.32-.31.73-.49 1.17-.49.33 0 .65.1.92.28.27.18.49.44.61.75.13.3.17.63.1.95zm-.42 4.62H21L13.18 21v-4.5c0-1.86 1.5-3.37 3.37-3.37z",
            fill: "currentColor"
        })
    });



const $b114755c052c541c$export$88dbaeb33f8e9931 = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M3.98 11.65c.21 0 .41-.14.48-.35a.515.515 0 00-.33-.63l-.96-.3a.51.51 0 00-.63.33c-.08.26.07.54.33.63l.96.3s.1.02.15.02zM6.05 10h.05c.27-.03.48-.27.45-.55l-.1-.99c-.03-.28-.28-.49-.55-.45-.27.03-.48.27-.45.55l.1.99a.5.5 0 00.5.45zM4.5 14.71l.71-.71c.2-.2.2-.51 0-.71-.2-.2-.51-.2-.71 0l-.71.71c-.2.2-.2.51 0 .71a.485.485 0 00.7 0h.01zm15.23-5.08c-.57-2.13-2.2-3.69-4.07-3.93-1.4-.17-2.87.47-3.77 1.6-.1.13-.27.2-.47.2-.23 0-.77-.03-1.27-1.16-.23-.57-.27-1.23-.3-1.86l-.03-.47-2.33.07v.3c-.07 1.73.3 3.39 1.1 4.69.6.93 1.57 1.36 2.33 1.7.43.17.83.33 1.03.57.3.27.63 1.23.5 2.16-.1.8-.5 1.4-1.17 1.76-.7.4-1.6.3-2.37.17h-.1c-.87-.13-1.83-.3-2.7.07-.7.3-1.3.9-1.67 1.7-.3.67-.47 1.43-.47 2.3v.33H6.2l-.07-.4c-.07-.43.03-.83.27-1.1.33-.37 1-.33 1.47-.13.27.13.53.3.8.5.3.2.57.4.9.53 1.23.53 2.4.8 3.5.8.87 0 1.7-.2 2.5-.53 2.3-1.03 3.5-3.33 3.73-4.06.73-2.23.87-4.12.4-5.79l.03-.02z",
            fill: "currentColor"
        })
    });



const $393d76e6bf35a610$export$875a4698883b6907 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 2H7a3 3 0 00-3 3v14a3 3 0 003 3h11a2 2 0 002-2V4a2 2 0 00-2-2zM9.1 8l1.47-.22.66-1.33a.86.86 0 011.54 0l.66 1.33L14.9 8a.86.86 0 01.48 1.46l-1.07 1 .25 1.54a.85.85 0 01-1.24.9L12 12.21l-1.32.69a.85.85 0 01-1.24-.9l.25-1.47-1.07-1A.86.86 0 019.1 8zM18 19.67a.33.33 0 01-.33.33H7a1 1 0 010-2h10.67a.33.33 0 01.33.33v1.34z",
            fill: "currentColor"
        })
    });



const $5e22992bb862f442$export$261b3f7c3f7009a = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 6a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm1.84-4C11.26 3.11 7.06 6.54 5 20.86A1 1 0 005.86 22H6a1 1 0 001-.86A57.692 57.692 0 018.18 15l2.94 5.48a1 1 0 001.76-.94L9.38 13h.67a2.998 2.998 0 002.78-4.11l-.81-2A10 10 0 0118.16 4a1.013 1.013 0 00-.32-2zm-7 8.55a1 1 0 01-.82.44h-.54c.323-.784.704-1.543 1.14-2.27l.35.9a1.001 1.001 0 01-.1.94l-.03-.01z",
            fill: "currentColor"
        })
    });



const $f82911028f733107$export$c3742f943ae2774d = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4 8h8V4a1 1 0 00-1-1h-1a7 7 0 00-6.45 4.29A.5.5 0 004 8zm3.5 10a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM20 6h-2a1 1 0 00-1 .76L16.22 10H4a1 1 0 00-1 1v1a5 5 0 005 5h5a5 5 0 005-5v-.88L18.78 8H20a1 1 0 100-2zm-6.5 12a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
            fill: "currentColor"
        })
    });



const $63233033afc210b5$export$978f3a8e6bc4ffbb = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M14.47 12.39l-1.9 1.41a1 1 0 01-1.2 0l-1.88-1.39A8 8 0 004 20a2 2 0 002 2h12a2 2 0 002-2 8 8 0 00-5.53-7.61zM5 8a1 1 0 001-1V4h1.5v2.5a4.5 4.5 0 009 0V4H19a1 1 0 100-2H5a1 1 0 00-1 1v4a1 1 0 001 1z",
            fill: "currentColor"
        })
    });



const $f402760d16d6e38c$export$44832ad00cb51df7 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 8a4 4 0 100 8 4 4 0 000-8zm0-1a1 1 0 001-1V4a1 1 0 00-2 0v2a1 1 0 001 1zm-3.87.37a1 1 0 001.37.36 1 1 0 00.37-1.36l-.5-.87a1.003 1.003 0 00-1.74 1l.5.87zm6.37.36a1 1 0 001.37-.36l.5-.87a1.002 1.002 0 00-1.132-1.469 1.004 1.004 0 00-.608.469l-.5.87a1 1 0 00.37 1.36zM19 11h-1a1 1 0 000 2h1a1 1 0 000-2zm-2.77-2.26a1 1 0 00.71 1.26c.257.063.528.027.76-.1l1.73-1a1 1 0 00.46-.61 1 1 0 00-.1-.76 1 1 0 00-.6-.47 1.05 1.05 0 00-.76.1l-1.73 1a1.06 1.06 0 00-.47.58zm-.36 8a1.003 1.003 0 00-1.74 1l.5.86a1 1 0 00.87.5 1 1 0 00.87-1.5l-.5-.86zM12 17a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1zM4.57 8.87l1.73 1c.232.127.503.163.76.1a1 1 0 00.536-1.582A1 1 0 007.3 8.13l-1.73-1A1.05 1.05 0 004.81 7a1 1 0 00-.6.47 1 1 0 00-.1.76 1 1 0 00.46.64zm14.86 6.26l-1.73-1a1.06 1.06 0 00-.76-.1.998.998 0 00-.71 1.23c.075.255.242.473.47.61l1.73 1c.232.128.503.164.76.1a1 1 0 00.6-.47 1 1 0 00.1-.76 1 1 0 00-.46-.61zM9.5 16.39a1 1 0 00-1.37.37l-.5.86a1 1 0 00.87 1.5 1 1 0 00.87-.5l.5-.86a1 1 0 00-.37-1.37zm-1.73-1.13A1 1 0 007.06 14a1.06 1.06 0 00-.76.1l-1.73 1a1 1 0 00-.46.61 1 1 0 00.1.76 1 1 0 00.6.47c.257.064.528.028.76-.1l1.73-1a1.06 1.06 0 00.47-.58zM5 13h1a1 1 0 000-2H5a1 1 0 000 2z",
            fill: "currentColor"
        })
    });



const $98272918aaa74a36$export$940e3ad40bbc0867 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M6.34 16.24l-1.41 1.41a.996.996 0 101.41 1.41l1.41-1.41a.996.996 0 10-1.41-1.41zm0-8.49a.996.996 0 101.41-1.41L6.34 4.93a.996.996 0 10-1.41 1.41l1.41 1.41zM6 11.99c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1s.45 1 1 1h2c.55 0 1-.45 1-1zm6-6c.55 0 1-.45 1-1v-2c0-.55-.45-1-1-1s-1 .45-1 1v2c0 .55.45 1 1 1zm5.66 1.76l1.41-1.41a.996.996 0 10-1.41-1.41l-1.41 1.41a.996.996 0 101.41 1.41zM21 10.99h-2c-.55 0-1 .45-1 1s.45 1 1 1h2c.55 0 1-.45 1-1s-.45-1-1-1zm-3.34 5.24a.996.996 0 10-1.41 1.41l1.41 1.41a.996.996 0 101.41-1.41l-1.41-1.41zM12 17.99c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1s1-.45 1-1v-2c0-.55-.45-1-1-1zm0-11c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5z",
            fill: "currentColor"
        })
    });



const $0d48b023f3c33f2b$export$d199e9f226487f5c = (s)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...s,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21 19c-.75 0-1.08-.3-1.59-.75C18.82 17.72 18 17 16.5 17c-1.5 0-2.32.72-2.91 1.25-.51.45-.84.75-1.59.75-.75 0-1.08-.3-1.59-.75C9.82 17.72 9 17 7.5 17c-1.5 0-2.32.72-2.91 1.25-.51.45-.84.75-1.59.75-.55 0-1 .45-1 1s.45 1 1 1c1.5 0 2.32-.72 2.91-1.25.51-.45.84-.75 1.59-.75.75 0 1.08.3 1.59.75C9.68 20.28 10.5 21 12 21c1.5 0 2.32-.72 2.91-1.25.51-.45.84-.75 1.59-.75.75 0 1.08.3 1.59.75.59.53 1.41 1.25 2.91 1.25.55 0 1-.45 1-1s-.45-1-1-1zM12 6c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1s-1 .45-1 1v2c0 .55.45 1 1 1zm-9 7h2c.55 0 1-.45 1-1s-.45-1-1-1H3c-.55 0-1 .45-1 1s.45 1 1 1zm3.34-5.24a.996.996 0 101.41-1.41L6.34 4.94a.996.996 0 10-1.41 1.41l1.41 1.41zm11.31 0l1.41-1.41a.996.996 0 10-1.41-1.41l-1.41 1.41a.996.996 0 101.41 1.41zm-4.03 6.46c-.62.5-1.01.78-1.63.78-.55 0-1 .45-1 1s.45 1 1 1c1.35 0 2.2-.68 2.87-1.22.62-.5 1.01-.78 1.63-.78.62 0 1 .28 1.63.78.68.54 1.52 1.22 2.87 1.22.55 0 1-.45 1-1s-.45-1-1-1c-.62 0-1-.28-1.63-.78-.68-.54-1.52-1.22-2.87-1.22s-2.2.68-2.87 1.22zm-5.57.82c.37.04.73.1 1.05.19.33-1.26 1.46-2.2 2.81-2.24.12-.08.35-.26.45-.34.77-.62 2.07-1.66 4.12-1.66.14 0 .27.02.4.03a5 5 0 00-4.9-4.03c-2.76 0-5 2.24-5 5 0 1.15.4 2.2 1.06 3.04l.01.01z",
            fill: "currentColor"
        })
    });



const $ee931cb805411815$export$55f1d9393618571e = (s)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...s,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 6c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1s-1 .45-1 1v2c0 .55.45 1 1 1zm-9 7h2c.55 0 1-.45 1-1s-.45-1-1-1H3c-.55 0-1 .45-1 1s.45 1 1 1zm15-1c0 .55.45 1 1 1h2c.55 0 1-.45 1-1s-.45-1-1-1h-2c-.55 0-1 .45-1 1zM6.34 7.76a.996.996 0 101.41-1.41L6.34 4.94a.996.996 0 10-1.41 1.41l1.41 1.41zm11.31 0l1.41-1.41a.996.996 0 10-1.41-1.41l-1.41 1.41a.996.996 0 101.41 1.41zm2.84 10.31V18a2.5 2.5 0 00-4.58-1.39c-.21-.07-.44-.11-.67-.11-1.24 0-2.25 1.01-2.25 2.25 0 .09.02.17.03.25h-.03c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h7c1.1 0 2-.9 2-2 0-.93-.64-1.71-1.51-1.93h.01zM8.5 14c-.87 0-1.63.44-2.08 1.11-.21-.07-.44-.11-.67-.11-1.24 0-2.25 1.01-2.25 2.25 0 .09.02.17.03.25H3.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h6c0-1.27.68-2.38 1.69-2.99.08-.26.19-.5.31-.73C11.5 15.4 9.89 14 8.51 14H8.5zm-1.48-1.75c.23-.08.48-.14.72-.19a4.482 4.482 0 011.39-.01l.21.03c.19.04.39.08.57.15.04.01.08.03.13.05 1.35.48 2.5 1.55 3.07 2.81.61-.36 1.3-.58 2.05-.59.45-.36.96-.62 1.51-.79.2-.54.32-1.11.32-1.71 0-2.76-2.24-5-5-5s-5 2.24-5 5c0 .09.02.17.02.25h.01z",
            fill: "currentColor"
        })
    });



const $4259728b52c15fb7$export$d944ce5debf82e34 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 6c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1s-1 .45-1 1v2c0 .55.45 1 1 1zm-6 6c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1s.45 1 1 1h2c.55 0 1-.45 1-1zm12 0c0 .55.45 1 1 1h2c.55 0 1-.45 1-1s-.45-1-1-1h-2c-.55 0-1 .45-1 1zM6.34 7.76a.996.996 0 101.41-1.41L6.34 4.94a.996.996 0 10-1.41 1.41l1.41 1.41zm0 8.49l-1.41 1.41a.996.996 0 101.41 1.41l1.41-1.41a.996.996 0 10-1.41-1.41zm11.31-8.49l1.41-1.41a.996.996 0 10-1.41-1.41l-1.41 1.41a.996.996 0 101.41 1.41zm-2.49 5.74c.51-.42 1.12-.7 1.76-.86.03-.21.06-.42.06-.64 0-2.76-2.24-5-5-5s-5 2.24-5 5c0 2.33 1.6 4.27 3.75 4.82.14-.11.28-.22.43-.32a4.26 4.26 0 013.99-3.01l.01.01zm5.32 3.57V17a2.5 2.5 0 00-4.58-1.39c-.21-.07-.44-.11-.67-.11-1.24 0-2.25 1.01-2.25 2.25 0 .09.02.17.03.25h-.03c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h7c1.1 0 2-.9 2-2 0-.93-.64-1.71-1.51-1.93h.01z",
            fill: "currentColor"
        })
    });



const $0124c44d6d665a66$export$c550aa07966e7ac6 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 6c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1s-1 .45-1 1v2c0 .55.45 1 1 1zm-6 6c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1s.45 1 1 1h2c.55 0 1-.45 1-1zm.34-4.24a.996.996 0 101.41-1.41L6.34 4.94a.996.996 0 10-1.41 1.41l1.41 1.41zm0 8.49l-1.41 1.41a.996.996 0 101.41 1.41l1.41-1.41a.996.996 0 10-1.41-1.41zm11.31-8.49l1.41-1.41a.996.996 0 10-1.41-1.41l-1.41 1.41a.996.996 0 101.41 1.41zM13.19 18.4l-1.5 2c-.33.44-.24 1.07.2 1.4.18.13.39.2.6.2.3 0 .6-.14.8-.4l1.5-2c.33-.44.24-1.07-.2-1.4-.44-.33-1.07-.24-1.4.2zm4 0l-1.5 2c-.33.44-.24 1.07.2 1.4.18.13.39.2.6.2.3 0 .6-.14.8-.4l1.5-2c.33-.44.24-1.07-.2-1.4-.44-.33-1.07-.24-1.4.2zm-2.03-8.9c.25-.2.52-.36.8-.51-.91-1.2-2.35-2-3.97-2-2.76 0-5 2.24-5 5 0 1.9 1.07 3.53 2.62 4.37a3.58 3.58 0 01-.12-.87c0-1.27.68-2.38 1.69-2.99a4.26 4.26 0 013.99-3.01l-.01.01zm5.32 3.57V13a2.5 2.5 0 00-4.58-1.39c-.21-.07-.44-.11-.67-.11-1.24 0-2.25 1.01-2.25 2.25 0 .09.02.17.03.25h-.03c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h7c1.1 0 2-.9 2-2 0-.93-.64-1.71-1.51-1.93h.01z",
            fill: "currentColor"
        })
    });



const $d0ad5d9f6a5b5916$export$176641269df25d25 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.91 16.15A4.001 4.001 0 0016 13c-1.5 0-2.79.83-3.47 2.05A2.996 2.996 0 009 18c-1.1 0-2 .9-2 2s.9 2 2 2h10a2.996 2.996 0 00.91-5.85zm-6.28-4.65c.74-.32 1.54-.5 2.37-.5 1.9 0 3.64.92 4.75 2.37.13-.53.22-1.08.26-1.64a9.976 9.976 0 00-5.48-9.61c-.87-.44-1.79.47-1.35 1.34.71 1.41 1.02 3.05.76 4.79-.18 1.2-.65 2.3-1.32 3.26l.01-.01zm-8.51 7.58s.01-.05.02-.08h-.13s.08.05.11.08zm5.96-5.98l-.09-.03V13a2.5 2.5 0 00-4.58-1.39c-.21-.07-.44-.11-.67-.11-1.24 0-2.25 1.01-2.25 2.25 0 .09.02.17.03.25h-.03c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h2.86c.27-.24.58-.44.9-.6a5.012 5.012 0 013.81-3.3h.02z",
            fill: "currentColor"
        })
    });



const $65ffb2266cbd1f83$export$53d515a43e8b684e = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M6.94 4.33c.12.54.65.88 1.19.76.54-.12.88-.65.76-1.19l-.22-.98a.996.996 0 00-1.19-.76c-.54.12-.88.65-.76 1.19l.22.98zM3.9 9.1l-.98.22c-.54.12-.88.65-.76 1.19.12.54.65.88 1.19.76l.98-.22c.54-.12.88-.65.76-1.19A.996.996 0 003.9 9.1zm1.42-3.64l-.84-.54a.994.994 0 00-1.38.31c-.3.47-.16 1.08.31 1.38l.84.54c.47.3 1.08.16 1.38-.31.3-.47.16-1.08-.31-1.38zm5.83.16c.47.3 1.08.16 1.38-.31l.54-.84c.3-.47.16-1.08-.31-1.38a.994.994 0 00-1.38.31l-.54.84c-.3.47-.16 1.08.31 1.38zm-.28 1.62c.09-.11.19-.21.29-.31A2.99 2.99 0 006 9c0 .61.18 1.17.49 1.64.7-1.86 2.37-3.22 4.38-3.4zm8.9 3.26c-.41-2-2.12-3.51-4.17-3.51-1.6 0-2.97.93-3.71 2.28-.18-.03-.37-.06-.56-.06-1.77 0-3.2 1.49-3.2 3.33-1.18 0-2.13.99-2.13 2.22 0 1.23.96 2.22 2.13 2.22H18.8c1.77 0 3.2-1.49 3.2-3.33 0-1.49-.94-2.73-2.23-3.16v.01zm-6.52 7.99c-.97 0-1.75.78-1.75 1.75s.78 1.75 1.75 1.75S15 21.21 15 20.24s-.78-1.75-1.75-1.75zm5 0c-.97 0-1.75.78-1.75 1.75s.78 1.75 1.75 1.75S20 21.21 20 20.24s-.78-1.75-1.75-1.75zm-10 0c-.97 0-1.75.78-1.75 1.75s.78 1.75 1.75 1.75S10 21.21 10 20.24s-.78-1.75-1.75-1.75z",
            fill: "currentColor"
        })
    });



const $61a07a1ad9e59c99$export$852ace578ebc1a6d = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M6.94 4.33c.12.54.65.88 1.19.76.54-.12.88-.65.76-1.19l-.22-.98a.996.996 0 00-1.19-.76c-.54.12-.88.65-.76 1.19l.22.98zM3.9 9.1l-.98.22c-.54.12-.88.65-.76 1.19.12.54.65.88 1.19.76l.98-.22c.54-.12.88-.65.76-1.19A.996.996 0 003.9 9.1zm1.42-3.64l-.84-.54a.994.994 0 00-1.38.31c-.3.47-.16 1.08.31 1.38l.84.54c.47.3 1.08.16 1.38-.31.3-.47.16-1.08-.31-1.38zm5.83.16c.47.3 1.08.16 1.38-.31l.54-.84c.3-.47.16-1.08-.31-1.38a.994.994 0 00-1.38.31l-.54.84c-.3.47-.16 1.08.31 1.38zm-.28 1.62c.09-.11.19-.21.29-.31A2.99 2.99 0 006 9c0 .61.18 1.17.49 1.64.7-1.86 2.37-3.22 4.38-3.4zm8.9 3.26c-.41-2-2.12-3.51-4.17-3.51-1.6 0-2.97.93-3.71 2.28-.18-.03-.37-.06-.56-.06-1.77 0-3.2 1.49-3.2 3.33-1.18 0-2.13.99-2.13 2.22 0 1.23.96 2.22 2.13 2.22H18.8c1.77 0 3.2-1.49 3.2-3.33 0-1.49-.94-2.73-2.23-3.16v.01zM9.2 18.4l-1.5 2c-.33.44-.24 1.07.2 1.4.18.13.39.2.6.2.3 0 .6-.14.8-.4l1.5-2c.33-.44.24-1.07-.2-1.4-.44-.33-1.07-.24-1.4.2zm4 0l-1.5 2c-.33.44-.24 1.07.2 1.4.18.13.39.2.6.2.3 0 .6-.14.8-.4l1.5-2c.33-.44.24-1.07-.2-1.4-.44-.33-1.07-.24-1.4.2zm4 0l-1.5 2c-.33.44-.24 1.07.2 1.4.18.13.39.2.6.2.3 0 .6-.14.8-.4l1.5-2c.33-.44.24-1.07-.2-1.4-.44-.33-1.07-.24-1.4.2z",
            fill: "currentColor"
        })
    });



const $a26f99b443d245f2$export$df15324caf60e98e = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M6.94 4.33c.12.54.65.88 1.19.76.54-.12.88-.65.76-1.19l-.22-.98a.996.996 0 00-1.19-.76c-.54.12-.88.65-.76 1.19l.22.98zM5.09 9.86A.996.996 0 003.9 9.1l-.98.22c-.54.12-.88.65-.76 1.19.12.54.65.88 1.19.76l.98-.22c.54-.12.88-.65.76-1.19zM3.4 6.61l.84.54c.47.3 1.08.16 1.38-.31.3-.47.16-1.08-.31-1.38l-.84-.54a.994.994 0 00-1.38.31c-.3.47-.16 1.08.31 1.38zm7.75-.99c.47.3 1.08.16 1.38-.31l.54-.84c.3-.47.16-1.08-.31-1.38a.994.994 0 00-1.38.31l-.54.84c-.3.47-.16 1.08.31 1.38zm-.28 1.62c.09-.11.19-.21.29-.31A2.99 2.99 0 006 9c0 .61.18 1.17.49 1.64.7-1.86 2.37-3.22 4.38-3.4zm8.9 3.26c-.41-2-2.12-3.51-4.17-3.51-1.6 0-2.97.93-3.71 2.28-.18-.03-.37-.06-.56-.06-1.77 0-3.2 1.49-3.2 3.33-1.18 0-2.13.99-2.13 2.22 0 1.23.96 2.22 2.13 2.22H18.8c1.77 0 3.2-1.49 3.2-3.33 0-1.49-.94-2.73-2.23-3.16v.01zm.94 7.79a.996.996 0 00-1.41 0l-.29.29-.29-.29a.996.996 0 10-1.41 1.41l.29.29-.29.29a.996.996 0 00.71 1.7c.26 0 .51-.1.71-.29l.29-.29.29.29c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 000-1.41l-.29-.29.29-.29a.996.996 0 000-1.41h-.02zm-6 0a.996.996 0 00-1.41 0l-.29.29-.29-.29a.996.996 0 10-1.41 1.41l.29.29-.29.29a.996.996 0 00.71 1.7c.26 0 .51-.1.71-.29l.29-.29.29.29c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 000-1.41l-.29-.29.29-.29a.996.996 0 000-1.41h-.02zm-6 0a.996.996 0 00-1.41 0l-.29.29-.29-.29a.996.996 0 10-1.41 1.41l.29.29-.29.29a.996.996 0 00.71 1.7c.26 0 .51-.1.71-.29l.29-.29.29.29c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 000-1.41l-.29-.29.29-.29a.996.996 0 000-1.41h-.02z",
            fill: "currentColor"
        })
    });



const $9bffd9e0f9569b8a$export$517f12716df68f19 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M6.94 4.33c.12.54.65.88 1.19.76.54-.12.88-.65.76-1.19l-.22-.98a.996.996 0 00-1.19-.76c-.54.12-.88.65-.76 1.19l.22.98zM5.09 9.86A.996.996 0 003.9 9.1l-.98.22c-.54.12-.88.65-.76 1.19.12.54.65.88 1.19.76l.98-.22c.54-.12.88-.65.76-1.19zM3.4 6.61l.84.54c.47.3 1.08.16 1.38-.31.3-.47.16-1.08-.31-1.38l-.84-.54a.994.994 0 00-1.38.31c-.3.47-.16 1.08.31 1.38zm7.75-.99c.47.3 1.08.16 1.38-.31l.54-.84c.3-.47.16-1.08-.31-1.38a.994.994 0 00-1.38.31l-.54.84c-.3.47-.16 1.08.31 1.38zm-.28 1.62c.09-.11.19-.21.29-.31A2.99 2.99 0 006 9c0 .61.18 1.17.49 1.64.7-1.86 2.37-3.22 4.38-3.4zM6.7 18.4l-1.5 2c-.33.44-.24 1.07.2 1.4.18.13.39.2.6.2.3 0 .6-.14.8-.4l1.5-2c.33-.44.24-1.07-.2-1.4-.44-.33-1.07-.24-1.4.2zm4 0l-1.5 2c-.33.44-.24 1.07.2 1.4.18.13.39.2.6.2.3 0 .6-.14.8-.4l1.5-2c.33-.44.24-1.07-.2-1.4-.44-.33-1.07-.24-1.4.2zm4 0l-1.5 2c-.33.44-.24 1.07.2 1.4.18.13.39.2.6.2.3 0 .6-.14.8-.4l1.5-2c.33-.44.24-1.07-.2-1.4-.44-.33-1.07-.24-1.4.2zM8.13 17H15c0-.64.2-1.27.6-1.8l3-4c.29-.39.68-.69 1.11-.9C19.22 8.4 17.58 7 15.6 7c-1.6 0-2.97.93-3.71 2.28-.18-.03-.37-.06-.56-.06-1.77 0-3.2 1.49-3.2 3.33-1.18 0-2.13.99-2.13 2.22 0 1.23.96 2.22 2.13 2.22V17zm14.26-.45a1 1 0 00-.89-.55H20l1.8-2.4c.33-.44.24-1.07-.2-1.4-.44-.33-1.07-.24-1.4.2l-3 4c-.23.3-.26.71-.09 1.05A1 1 0 0018 18h1.5l-1.8 2.4c-.33.44-.24 1.07.2 1.4.18.13.39.2.6.2.3 0 .6-.14.8-.4l3-4c.23-.3.26-.71.09-1.05z",
            fill: "currentColor"
        })
    });



const $a8a0be27538a8c39$export$31a6eb06ad20eb2f = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M8.4 5.92c.21.51.8.75 1.31.54.51-.21.75-.8.54-1.31L9.48 3.3c-.21-.51-.8-.75-1.31-.54-.51.21-.75.8-.54 1.31l.77 1.85zm-3.25 7.84l-1.85.77c-.51.21-.75.8-.54 1.31.21.51.8.75 1.31.54l1.85-.77c.51-.21.75-.8.54-1.31-.21-.51-.8-.75-1.31-.54zm13.7-3.51l1.85-.77c.51-.21.75-.8.54-1.31-.21-.51-.8-.75-1.31-.54l-1.85.77c-.51.21-.75.8-.54 1.31.21.51.8.75 1.31.54zM5.92 8.4l-1.85-.77c-.51-.21-1.1.03-1.31.54-.21.51.03 1.1.54 1.31l1.85.77c.51.21 1.1-.03 1.31-.54.21-.51-.03-1.1-.54-1.31zm8.38-1.94c.51.21 1.1-.03 1.31-.54l.77-1.85c.21-.51-.03-1.1-.54-1.31-.51-.21-1.1.03-1.31.54l-.77 1.85c-.21.51.03 1.1.54 1.31zm-2.77 6.56A5.99 5.99 0 0116 11c.31 0 .61.02.91.07A4.993 4.993 0 0012 7c-2.76 0-5 2.24-5 5 0 1.13.39 2.16 1.02 2.99a4.967 4.967 0 013.51-1.97zm8.38 3.13A4.001 4.001 0 0016 13c-1.5 0-2.79.83-3.47 2.05A2.996 2.996 0 009 18c-1.1 0-2 .9-2 2s.9 2 2 2h10a2.996 2.996 0 00.91-5.85z",
            fill: "currentColor"
        })
    });



const $70486d24b5cd3c39$export$60dedef481aa8953 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10 5c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1s-1 .45-1 1v1c0 .55.45 1 1 1zm-5 5c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1s.45 1 1 1h1c.55 0 1-.45 1-1zm.05-3.54a.996.996 0 101.41-1.41l-.71-.71a.996.996 0 10-1.41 1.41l.71.71zm0 7.07l-.71.71a.996.996 0 101.41 1.41l.71-.71a.996.996 0 10-1.41-1.41zm8.49-7.07c.39.39 1.02.39 1.41 0l.71-.71a.996.996 0 10-1.41-1.41l-.71.71a.996.996 0 000 1.41zm-.75 2.35c.22-.25.47-.47.74-.68A3.99 3.99 0 0010.01 6c-2.21 0-4 1.79-4 4 0 1.3.63 2.45 1.6 3.18.35-.55.83-1 1.4-1.3.58-1.64 2.03-2.85 3.78-3.07zm7.4 2.99C19.85 10.2 18.47 9 16.8 9c-1.3 0-2.42.74-3.01 1.82-.15-.03-.3-.05-.46-.05-1.44 0-2.6 1.19-2.6 2.67-.96 0-1.73.8-1.73 1.78S9.78 17 10.73 17h8.67c1.44 0 2.6-1.19 2.6-2.67 0-1.19-.77-2.19-1.81-2.53zm-7.44 6.7c-.97 0-1.75.78-1.75 1.75S11.78 22 12.75 22s1.75-.78 1.75-1.75-.78-1.75-1.75-1.75zm5 0c-.97 0-1.75.78-1.75 1.75S16.78 22 17.75 22s1.75-.78 1.75-1.75-.78-1.75-1.75-1.75z",
            fill: "currentColor"
        })
    });



const $df7d8acd5584c8a7$export$8599dc081f15e632 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10 5c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1s-1 .45-1 1v1c0 .55.45 1 1 1zm-5 5c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1s.45 1 1 1h1c.55 0 1-.45 1-1zm.05-3.54a.996.996 0 101.41-1.41l-.71-.71a.996.996 0 10-1.41 1.41l.71.71zm0 7.07l-.71.71a.996.996 0 101.41 1.41l.71-.71a.996.996 0 10-1.41-1.41zm8.49-7.07c.39.39 1.02.39 1.41 0l.71-.71a.996.996 0 10-1.41-1.41l-.71.71a.996.996 0 000 1.41zm-.75 2.35c.22-.25.47-.47.74-.68A3.99 3.99 0 0010.01 6c-2.21 0-4 1.79-4 4 0 1.3.63 2.45 1.6 3.18.35-.55.83-1 1.4-1.3.58-1.64 2.03-2.85 3.78-3.07zm7.4 2.99C19.85 10.2 18.47 9 16.8 9c-1.3 0-2.42.74-3.01 1.82-.15-.03-.3-.05-.46-.05-1.44 0-2.6 1.19-2.6 2.67-.96 0-1.73.8-1.73 1.78S9.78 17 10.73 17h8.67c1.44 0 2.6-1.19 2.6-2.67 0-1.19-.77-2.19-1.81-2.53zm-9.99 6.6l-1.5 2c-.33.44-.24 1.07.2 1.4.18.13.39.2.6.2.3 0 .6-.14.8-.4l1.5-2c.33-.44.24-1.07-.2-1.4-.44-.33-1.07-.24-1.4.2zm4 0l-1.5 2c-.33.44-.24 1.07.2 1.4.18.13.39.2.6.2.3 0 .6-.14.8-.4l1.5-2c.33-.44.24-1.07-.2-1.4-.44-.33-1.07-.24-1.4.2zm4 0l-1.5 2c-.33.44-.24 1.07.2 1.4.18.13.39.2.6.2.3 0 .6-.14.8-.4l1.5-2c.33-.44.24-1.07-.2-1.4-.44-.33-1.07-.24-1.4.2z",
            fill: "currentColor"
        })
    });



const $bd625acd88775158$export$491208da8b561f78 = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10 5c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1s-1 .45-1 1v1c0 .55.45 1 1 1zm-5 5c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1s.45 1 1 1h1c.55 0 1-.45 1-1zm.05-3.54a.996.996 0 101.41-1.41l-.71-.71a.996.996 0 10-1.41 1.41l.71.71zm0 7.07l-.71.71a.996.996 0 101.41 1.41l.71-.71a.996.996 0 10-1.41-1.41zm8.49-7.07c.39.39 1.02.39 1.41 0l.71-.71a.996.996 0 10-1.41-1.41l-.71.71a.996.996 0 000 1.41zm-.75 2.35c.22-.25.47-.47.74-.68A3.99 3.99 0 0010.01 6c-2.21 0-4 1.79-4 4 0 1.3.63 2.45 1.6 3.18.35-.55.83-1 1.4-1.3.58-1.64 2.03-2.85 3.78-3.07zm7.4 2.99C19.85 10.2 18.47 9 16.8 9c-1.3 0-2.42.74-3.01 1.82-.15-.03-.3-.05-.46-.05-1.44 0-2.6 1.19-2.6 2.67-.96 0-1.73.8-1.73 1.78S9.78 17 10.73 17h8.67c1.44 0 2.6-1.19 2.6-2.67 0-1.19-.77-2.19-1.81-2.53zm-.48 6.49a.996.996 0 00-1.41 0l-.29.29-.29-.29a.996.996 0 10-1.41 1.41l.29.29-.29.29a.996.996 0 00.71 1.7c.26 0 .51-.1.71-.29l.29-.29.29.29c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 000-1.41l-.29-.29.29-.29a.996.996 0 000-1.41h-.02zm-6 0a.996.996 0 00-1.41 0l-.29.29-.29-.29a.996.996 0 10-1.41 1.41l.29.29-.29.29a.996.996 0 00.71 1.7c.26 0 .51-.1.71-.29l.29-.29.29.29c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 000-1.41l-.29-.29.29-.29a.996.996 0 000-1.41h-.02z",
            fill: "currentColor"
        })
    });



const $ddaca9614ae1107a$export$e8392afb8f02059d = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10 5c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1s-1 .45-1 1v1c0 .55.45 1 1 1zm-5 5c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1s.45 1 1 1h1c.55 0 1-.45 1-1zm.05-3.54a.996.996 0 101.41-1.41l-.71-.71a.996.996 0 10-1.41 1.41l.71.71zm0 7.07l-.71.71a.996.996 0 101.41 1.41l.71-.71a.996.996 0 10-1.41-1.41zm8.49-7.07c.39.39 1.02.39 1.41 0l.71-.71a.996.996 0 10-1.41-1.41l-.71.71a.996.996 0 000 1.41zm-.75 2.35c.22-.25.47-.47.74-.68A3.99 3.99 0 0010.01 6c-2.21 0-4 1.79-4 4 0 1.3.63 2.45 1.6 3.18.35-.55.83-1 1.4-1.3.58-1.64 2.03-2.85 3.78-3.07zm-2.58 9.59l-1.5 2c-.33.44-.24 1.07.2 1.4.18.13.39.2.6.2.3 0 .6-.14.8-.4l1.5-2c.33-.44.24-1.07-.2-1.4-.44-.33-1.07-.24-1.4.2zm4 0l-1.5 2c-.33.44-.24 1.07.2 1.4.18.13.39.2.6.2.3 0 .6-.14.8-.4l1.5-2c.33-.44.24-1.07-.2-1.4-.44-.33-1.07-.24-1.4.2zm-.41-7.58c-.15-.03-.3-.05-.46-.05-1.44 0-2.6 1.19-2.6 2.67-.96 0-1.73.8-1.73 1.78S9.79 17 10.74 17h4.27c0-.64.2-1.27.6-1.8l3-4c.25-.34.58-.6.94-.8-.63-.84-1.62-1.4-2.74-1.4-1.3 0-2.42.74-3.01 1.82zm8.61 5.73a1 1 0 00-.89-.55h-1.5l1.8-2.4c.33-.44.24-1.07-.2-1.4-.44-.33-1.07-.24-1.4.2l-3 4c-.23.3-.26.71-.09 1.05a1 1 0 00.89.55h1.5l-1.8 2.4c-.33.44-.24 1.07.2 1.4.18.13.39.2.6.2.3 0 .6-.14.8-.4l3-4c.23-.3.26-.71.09-1.05z",
            fill: "currentColor"
        })
    });



const $31bd3d415c09e4a1$export$17dd2ba12c2bc970 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 6c.27 0 .52-.11.71-.29.19-.18.29-.44.29-.71V3c0-.27-.11-.52-.29-.71A.99.99 0 0012 2c-.27 0-.52.11-.71.29A.99.99 0 0011 3v2c0 .27.11.52.29.71.18.19.44.29.71.29zm3.57 1.48c.09.09.21.17.33.22a1.036 1.036 0 00.78-.01c.13-.05.23-.13.32-.23l1.41-1.41c.1-.09.19-.2.25-.32.06-.13.09-.26.1-.4 0-.14-.02-.27-.07-.4s-.13-.25-.22-.35c-.1-.09-.22-.17-.35-.22-.13-.05-.26-.07-.4-.07s-.27.04-.4.1c-.12.06-.23.15-.32.25l-1.46 1.41c-.09.1-.16.21-.21.33a1.036 1.036 0 00.01.78c.05.12.13.23.23.32zm5.42 3.32a1.03 1.03 0 00-.61-.73A.986.986 0 0020 10h-2c-.27 0-.52.11-.71.29-.19.18-.29.44-.29.71 0 .27.11.52.29.71.19.19.44.29.71.29h2a1.014 1.014 0 00.99-1.2zM7.05 7.46a1.001 1.001 0 001.36-.05c.18-.18.28-.42.29-.67 0-.25-.08-.5-.24-.69L7.05 4.64a1.02 1.02 0 00-.69-.24c-.27 0-.52.11-.71.29a.99.99 0 00-.29.71c0 .25.08.5.24.69l1.45 1.37zM18 14h-3.38a4.01 4.01 0 001.26-2.03c.2-.79.16-1.62-.13-2.39-.29-.76-.8-1.42-1.47-1.89-.67-.46-1.47-.71-2.28-.71-.81 0-1.61.25-2.28.71-.67.47-1.18 1.12-1.47 1.89A3.982 3.982 0 009.38 14H6c-.27 0-.52.11-.71.29A.99.99 0 005 15c0 .27.11.52.29.71.19.19.44.29.71.29h12c.27 0 .52-.11.71-.29A.99.99 0 0019 15c0-.27-.11-.52-.29-.71A.973.973 0 0018 14zM6.38 11.93a1.03 1.03 0 00.61-.73c.04-.19.02-.4-.06-.58-.08-.18-.21-.34-.37-.45A.999.999 0 006 10H4c-.27 0-.52.11-.71.29A.99.99 0 003 11c0 .27.11.52.29.71.19.19.44.29.71.29h2c.13 0 .26-.02.38-.07zM15 18H9c-.27 0-.52.11-.71.29A.99.99 0 008 19c0 .27.11.52.29.71.19.19.44.29.71.29h6c.27 0 .52-.11.71-.29.19-.18.29-.44.29-.71 0-.27-.11-.52-.29-.71A.973.973 0 0015 18z",
            fill: "currentColor"
        })
    });



const $8cd9ec695dea7829$export$8e1a31ce72222a50 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 6c.27 0 .52-.11.71-.29.19-.18.29-.44.29-.71V3c0-.27-.11-.52-.29-.71A.99.99 0 0012 2c-.27 0-.52.11-.71.29A.99.99 0 0011 3v2c0 .27.11.52.29.71.18.19.44.29.71.29zM7.05 7.46c.19.16.44.25.69.24.25 0 .49-.11.67-.29.18-.18.28-.42.29-.67 0-.25-.08-.5-.24-.69L7.05 4.64a1.02 1.02 0 00-.69-.24c-.27 0-.52.11-.71.29a.99.99 0 00-.29.71c0 .25.08.5.24.69l1.45 1.37zm8.52.02c.09.09.21.17.33.22a1.036 1.036 0 00.78-.01c.13-.05.23-.13.32-.23l1.41-1.41c.1-.09.19-.2.25-.32.06-.13.09-.26.1-.4 0-.14-.02-.27-.07-.4s-.13-.25-.22-.35c-.1-.09-.22-.17-.35-.22-.13-.05-.26-.07-.4-.07s-.27.04-.4.1c-.12.06-.23.15-.32.25l-1.46 1.41c-.09.1-.16.21-.21.33a1.036 1.036 0 00.01.78c.05.12.13.23.23.32zm5.14 2.81A.99.99 0 0020 10h-4.14c-.23-.85-.73-1.6-1.43-2.13-.7-.53-1.55-.82-2.43-.82-.88 0-1.73.29-2.43.82-.7.53-1.2 1.28-1.43 2.13H4c-.27 0-.52.11-.71.29A.99.99 0 003 11c0 .27.11.52.29.71.19.19.44.29.71.29h16c.27 0 .52-.11.71-.29A.99.99 0 0021 11c0-.27-.11-.52-.29-.71zM16 18H8c-.27 0-.52.11-.71.29-.19.18-.29.44-.29.71 0 .27.11.52.29.71.18.19.44.29.71.29h8c.27 0 .52-.11.71-.29.19-.18.29-.44.29-.71 0-.27-.11-.52-.29-.71A.973.973 0 0016 18zm2-4H6c-.27 0-.52.11-.71.29-.19.18-.29.44-.29.71 0 .27.11.52.29.71.18.19.44.29.71.29h12c.27 0 .52-.11.71-.29.19-.18.29-.44.29-.71 0-.27-.11-.52-.29-.71A.973.973 0 0018 14z",
            fill: "currentColor"
        })
    });



const $cc7e68746bf96c8a$export$4d6b37fa39f14735 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10.78 10.84a4.51 4.51 0 005.56-5.56 4.46 4.46 0 00-3.12-3.12 4.51 4.51 0 00-5.56 5.56 4.46 4.46 0 003.12 3.12zm4.49 1.86l-.38.75a1 1 0 01-.73.54H14a1 1 0 01-.71-.29L12 12.41l-1.29 1.3A1 1 0 0110 14h-.16a1 1 0 01-.73-.54l-.38-.75A8 8 0 004 20a2 2 0 002 2h12a2 2 0 002-2 8 8 0 00-4.73-7.3zM10 20H8a1 1 0 010-2h2a1 1 0 010 2zm6 0a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $3ddedb40f02d9f2a$export$f33c2aba1ad4d465 = (A)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...A,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21 17a5.67 5.67 0 00-2.66.59 3.82 3.82 0 01-1.84.41 3.84 3.84 0 01-1.85-.41A5.661 5.661 0 0012 17a5.67 5.67 0 00-2.66.59A3.82 3.82 0 017.5 18a3.84 3.84 0 01-1.85-.41A5.59 5.59 0 003 17a1 1 0 000 2 3.82 3.82 0 011.84.41c.826.41 1.739.613 2.66.59a5.66 5.66 0 002.65-.59A3.84 3.84 0 0112 19a3.82 3.82 0 011.84.41c.825.41 1.739.613 2.66.59a5.7 5.7 0 002.66-.59A3.82 3.82 0 0121 19a1 1 0 000-2zM8 7h1.59a2 2 0 011.55.73l1.63 1.89-2.26 1.5A9.07 9.07 0 0112 11a7.641 7.641 0 013.46.76 2 2 0 001 .24 1.84 1.84 0 00.83-.15l-4.62-5.41A4 4 0 009.59 5H8a1 1 0 100 2zm9.5 2a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM3 15a3.82 3.82 0 011.84.41c.826.41 1.739.613 2.66.59a5.66 5.66 0 002.65-.59A3.84 3.84 0 0112 15a3.82 3.82 0 011.84.41c.825.41 1.739.613 2.66.59a5.7 5.7 0 002.66-.59A3.82 3.82 0 0121 15a1 1 0 000-2 5.67 5.67 0 00-2.66.59 3.82 3.82 0 01-1.84.41 3.84 3.84 0 01-1.85-.41A5.661 5.661 0 0012 13a5.67 5.67 0 00-2.66.59A3.82 3.82 0 017.5 14a3.84 3.84 0 01-1.85-.41A5.59 5.59 0 003 13a1 1 0 000 2z",
            fill: "currentColor"
        })
    });



const $14fe83bb9facf19c$export$3b4b5a860e5f90eb = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M13.82 4.4a1 1 0 00-1.42 0l-1.87 1.88-2.4-2.4a3.08 3.08 0 00-4.24 0 3 3 0 000 4.24l2.4 2.4L4.4 12.4a1 1 0 00.325 1.639 1 1 0 001.095-.22l8-8a1 1 0 000-1.42zm6.75 7.78L14.44 8l-2.53 2.5 4.3 4.29a1 1 0 010 1.42 1.001 1.001 0 01-1.42 0l-4.29-4.3L8 14.44l4.2 6.13a1 1 0 00.8.43h7a1 1 0 001-1v-7a1 1 0 00-.43-.82z",
            fill: "currentColor"
        })
    });



const $f811d8ba1901f510$export$777dea00f5ff4aa6 = (l)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M18 3H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-3-3z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12.643 16h-1.356V9.16c-.272.144-.608.3-1.008.468a7.032 7.032 0 01-.96.348V8.788c.296-.096.676-.252 1.14-.468.464-.216.848-.42 1.152-.612h1.032V16z",
                fill: "#fff"
            })
        ]
    });



const $d2bbe26fba424ea1$export$6607bc35192b8499 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M8 3H6C4.34 3 3 4.34 3 6v2h5V3zM10 21h8c1.66 0 3-1.34 3-3v-8H10v11zM21 8V6c0-1.66-1.34-3-3-3h-8v5h11zM3 10v8c0 1.66 1.34 3 3 3h2V10H3z",
            fill: "currentColor"
        })
    });



const $ca0c8a906e46e112$export$8b897fae9d5d06e3 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 17a2 2 0 100 4 2 2 0 000-4zM6.22 14l-2.63 2.59a2 2 0 102.82 2.82l2.94-2.93A7.07 7.07 0 0012 17c.46 0 .92-.047 1.37-.14L5 10.25A7 7 0 006.22 14zM12 3a7 7 0 00-6.69 4.93L15.54 16A7 7 0 0012 3z",
            fill: "currentColor"
        })
    });



const $8f0e19c8cb2d4457$export$f35bc74495ae340b = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 10a2 2 0 100 4 2 2 0 000-4zm0-4a6 6 0 100 12 6 6 0 000-12zm0 10a4 4 0 110-8 4 4 0 010 8zm0-14a10 10 0 100 20 10 10 0 000-20zm0 18a8 8 0 110-16.001A8 8 0 0112 20z",
            fill: "currentColor"
        })
    });



const $63ff8bbef2af57de$export$c0cf6a0669b4616e = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 9.5a2.5 2.5 0 100 5 2.5 2.5 0 000-5zm9 1.5h-1.07A8 8 0 0013 4.07V3a1 1 0 00-2 0v1.07A8 8 0 004.07 11H3a1 1 0 000 2h1.07A8 8 0 0011 19.93V21a1 1 0 002 0v-1.07A8 8 0 0019.93 13H21a1 1 0 000-2zm-4 2h.91A6 6 0 0113 17.91V17a1 1 0 00-2 0v.91A6 6 0 016.09 13H7a1 1 0 000-2h-.91A6 6 0 0111 6.09V7a1 1 0 002 0v-.91A6 6 0 0117.91 11H17a1 1 0 000 2z",
            fill: "currentColor"
        })
    });



const $8469da7fc6c49f95$export$488e9647b49d99ee = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm6.55-1.83a1 1 0 00-1.38.28l-1.41 2.1a1 1 0 01-.83.45H12a1 1 0 00-.71.29l-5 5a1 1 0 00.325 1.639 1 1 0 001.095-.219L11 9.41v3.35l-3.89 7.79a1 1 0 00.44 1.34A.93.93 0 008 22a1 1 0 00.89-.55L12 15.24l3.11 6.21A1 1 0 0016 22a.93.93 0 00.45-.11 1 1 0 00.44-1.34L13 12.76V8h1.93a3 3 0 002.5-1.34l1.4-2.11a1 1 0 00-.28-1.38z",
            fill: "currentColor"
        })
    });



const $0b3a874bbfca6c06$export$45a875840ed91eb1 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 18.29l-.49-.29a4.198 4.198 0 00-.05-4 2 2 0 00-.85-3.9l-2.4.48A4.469 4.469 0 0017 6.5a4.41 4.41 0 00-.08-.73A2 2 0 0016 2a2 2 0 00-1.46.64 5.36 5.36 0 00-5.08 0A2 2 0 008 2a2 2 0 00-.92 3.77c-.047.24-.074.485-.08.73a4.47 4.47 0 002.79 4l-2.4-.5a2 2 0 00-.85 3.9 4.2 4.2 0 000 4l-.54.39A2 2 0 007 22a1.94 1.94 0 001-.29l1.8-1.06c1.43.467 2.97.467 4.4 0l1.8 1.06c.3.186.646.286 1 .29a2 2 0 001-3.71zm-7-13a1 1 0 001.9 0 2 2 0 11-1.9 0zm1 13.21a3 3 0 110-6 3 3 0 010 6z",
            fill: "currentColor"
        })
    });



const $29f66a32bcbcc83a$export$73366264264e8de3 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 18.29l-.49-.29a4.198 4.198 0 00-.05-4 2 2 0 00-.85-3.9l-2.4.48A4.469 4.469 0 0017 6.5a4.41 4.41 0 00-.08-.73A2 2 0 0016 2a2 2 0 00-1.46.64 5.36 5.36 0 00-5.08 0A2 2 0 008 2a2 2 0 00-.92 3.77c-.047.24-.074.485-.08.73a4.47 4.47 0 002.79 4l-2.4-.5a2 2 0 00-.85 3.9 4.2 4.2 0 000 4l-.54.39A2 2 0 007 22a1.94 1.94 0 001-.29l1.8-1.06c1.43.467 2.97.467 4.4 0l1.8 1.06c.3.186.646.286 1 .29a2 2 0 001-3.71zm-7-13a1 1 0 001.9 0 2 2 0 11-1.9 0zm3.86 11.16l-2.56 2.5a.5.5 0 01-.7 0l-2.56-2.5a2 2 0 01.6-3.25 2 2 0 012.23.43l.08.08.08-.08a2 2 0 012.88 2.78l-.05.04z",
            fill: "currentColor"
        })
    });



const $43670949fdffccdf$export$764e880fc2435b1a = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 14V6a4 4 0 10-8 0v8a4.94 4.94 0 00-1 3 5 5 0 1010 0 4.94 4.94 0 00-1-3zm-4 5a2 2 0 01-2-2 2 2 0 011-1.72V8a1 1 0 012 0v7.28A2 2 0 0114 17a2 2 0 01-2 2z",
            fill: "currentColor"
        })
    });



const $acd37184dea3c5f8$export$6182a2d21e4cfe36 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.71 16.29a1 1 0 00-1.42 0l-.29.3V5a1 1 0 10-2 0v11.59l-.29-.3a1.004 1.004 0 10-1.42 1.42l2 2a1.001 1.001 0 001.42 0l2-2a.999.999 0 000-1.42zM12 7a4 4 0 10-8 0v6a4.94 4.94 0 00-1 3 5 5 0 1010 0 4.94 4.94 0 00-1-3V7zM8 18a2 2 0 01-2-2 2 2 0 011-1.72V8a1 1 0 012 0v6.28A2 2 0 0110 16a2 2 0 01-2 2z",
            fill: "currentColor"
        })
    });



const $3478667a4cc8e32f$export$65588d5b6f350a2b = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.714 19.29l-16-16a1.004 1.004 0 10-1.42 1.42l4.71 4.7V14a5 5 0 007.54 6.54 5.05 5.05 0 001.28-2.3l2.47 2.47a1.002 1.002 0 001.639-.325 1 1 0 00-.219-1.095zm-7.3-1.75a1.43 1.43 0 01-.56.7 1.52 1.52 0 01-1.7 0 1.47 1.47 0 01-.61-1.59 1.47 1.47 0 01.46-.76v-3.48l2 2v1.48c.228.2.389.465.46.76.08.294.062.606-.05.89zM11.004 6a1 1 0 112 0v2.76l3 3V6a4 4 0 00-6.83-2.83 4.07 4.07 0 00-.72 1l2.55 2.59V6z",
            fill: "currentColor"
        })
    });



const $2a94a8c93a22c9e3$export$90428b1d948b4222 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.71 6.29l-2-2a.999.999 0 00-1.42 0l-2 2a1.004 1.004 0 101.42 1.42l.29-.3V19a1 1 0 002 0V7.41l.29.3a1 1 0 001.42 0 .998.998 0 000-1.42zM12 7a4 4 0 10-8 0v6a4.94 4.94 0 00-1 3 5 5 0 1010 0 4.94 4.94 0 00-1-3V7zM8 18a2 2 0 01-2-2 2 2 0 011-1.72V8a1 1 0 012 0v6.28A2 2 0 0110 16a2 2 0 01-2 2z",
            fill: "currentColor"
        })
    });



const $a11fbdb7273a41bc$export$df4cc5cb608e1549 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2A10 10 0 002 12a10 10 0 0110 10 10 10 0 0010-10A10 10 0 0112 2zm9.8 8A10 10 0 0014 2.2a8 8 0 007.8 7.8zM2.2 14a10 10 0 007.8 7.8A8 8 0 002.2 14z",
            fill: "currentColor"
        })
    });



const $dcb835c6f3acc7cd$export$bc1e46dba593b982 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18.5 2h-13a1.5 1.5 0 000 3H6v11a6 6 0 1012 0V5h.5a1.5 1.5 0 000-3zM16 10H8V5h8v5z",
            fill: "currentColor"
        })
    });



const $959de075a5781c65$export$acc79e140bd02831 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M3.176 18.941h3.53c.65 0 1.176-.526 1.176-1.176v-3.53c0-.65-.526-1.176-1.176-1.176h-3.53c-.65 0-1.176.527-1.176 1.176v3.53c0 .65.527 1.176 1.176 1.176zM10.235 18.941h3.53c.65 0 1.176-.526 1.176-1.176v-3.53c0-.65-.527-1.176-1.176-1.176h-3.53c-.65 0-1.176.527-1.176 1.176v3.53c0 .65.527 1.176 1.176 1.176zM10.235 11.882h3.53c.65 0 1.176-.526 1.176-1.176v-3.53c0-.65-.527-1.176-1.176-1.176h-3.53c-.65 0-1.176.527-1.176 1.176v3.53c0 .65.527 1.176 1.176 1.176zM17.294 11.882h3.53c.65 0 1.176-.526 1.176-1.176v-3.53C22 6.526 21.473 6 20.823 6h-3.529c-.65 0-1.176.527-1.176 1.176v3.53c0 .65.526 1.176 1.176 1.176z",
            fill: "currentColor"
        })
    });



const $e854725e35868ead$export$d210ac85392dbe7 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.89 13.54l-2-3.86A8 8 0 107 17.92V20a1 1 0 001 1h6a1 1 0 001-1v-1h1a3 3 0 003-3v-1h1a1 1 0 00.89-1.46zm-6.32-4.46l-7.06 4.09a1.12 1.12 0 01-1.63-.65 5.14 5.14 0 010-2.83 5.43 5.43 0 014.58-3.87 5.28 5.28 0 014.32 1.52 1.1 1.1 0 01-.21 1.74z",
            fill: "currentColor"
        })
    });



const $ff7a55b64573ccc6$export$d94d1668f73224ca = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.17 8.66a1 1 0 100-2 1 1 0 000 2zM21 9h-3.65a1 1 0 100 2H21a1 1 0 000-2zm-8.91-3.25h.75v.75a1 1 0 102 0v-.75h.75a1 1 0 100-2h-.75V3a1 1 0 00-2 0v.75h-.75a1 1 0 100 2zm7.08 5.59a1 1 0 100 2 1 1 0 000-2zm-3 1.44A3 3 0 0114.35 10c-.01-.11-.01-.22 0-.33v-.23h-.22a1.27 1.27 0 01-.34 0A3 3 0 0111 7.56a3 3 0 01-1.86-2.28 6.93 6.93 0 00-5 5.46l-1.08 2.92A1 1 0 004 15h.5v1A3 3 0 007 19v1a1 1 0 001 1h7a1 1 0 001-1v-3.11a6.75 6.75 0 001.41-2.14 2.94 2.94 0 01-1.19-1.97h-.05z",
            fill: "currentColor"
        })
    });



const $86a489e767a9d129$export$d8271eec803ce99f = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10 17H5c0 1.1.9 2 2 2h2v1c0 1.1.9 2 2 2h1v-3c0-1.1-.9-2-2-2zm3-15C8.68 2 5.15 5.45 5.01 9.74L3.1 13.56a.993.993 0 00.45 1.34l.21.11H10c2.21 0 4 1.79 4 4v3h2c1.1 0 2-.9 2-2v-3.76c1.83-1.47 3-3.72 3-6.24 0-4.41-3.59-8-8-8V2z",
            fill: "currentColor"
        })
    });



const $b1af43b5b08967c8$export$5a8c67020fdfbf87 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M14.5 15.67c-.48-.28-1.09-.11-1.37.37l-2 3.46c-.28.48-.11 1.09.37 1.37s1.09.11 1.37-.37l2-3.46c.28-.48.11-1.09-.37-1.37zm-4 0c-.48-.28-1.09-.11-1.37.37l-2 3.46c-.28.48-.11 1.09.37 1.37s1.09.11 1.37-.37l2-3.46c.28-.48.11-1.09-.37-1.37zm-4 0c-.48-.28-1.09-.11-1.37.37l-2 3.46c-.28.48-.11 1.09.37 1.37s1.09.11 1.37-.37l2-3.46c.28-.48.11-1.09-.37-1.37zM6 14h8.42c.03-.05.05-.11.08-.17l3-4.5c.45-.69 1.17-1.13 1.96-1.27.01-.1.03-.21.03-.32 0-2.62-2.13-4.75-4.75-4.75-1.64 0-3.08.83-3.93 2.09a3.68 3.68 0 00-.82-.09A3.98 3.98 0 006.13 8c-.05 0-.09-.01-.14-.01-1.66 0-3 1.34-3 3s1.34 3 3 3L6 14zm15.36.99a.99.99 0 00-.86-.49h-1.63l1.96-2.95a1.001 1.001 0 10-1.67-1.11l-3 4.5c-.2.31-.22.7-.05 1.03.17.33.51.53.88.53h1.8l-1.67 3.01c-.27.48-.09 1.09.39 1.36.15.09.32.13.48.13.35 0 .69-.19.88-.51l2.5-4.5c.17-.31.17-.69-.01-.99v-.01z",
            fill: "currentColor"
        })
    });



const $e16a12e2618f8ae8$export$61d55c1eb3683775 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 15.67c-.48-.28-1.09-.11-1.37.37l-2 3.46c-.28.48-.11 1.09.37 1.37s1.09.11 1.37-.37l2-3.46c.28-.48.11-1.09-.37-1.37zm-4 0c-.48-.28-1.09-.11-1.37.37l-2 3.46c-.28.48-.11 1.09.37 1.37s1.09.11 1.37-.37l2-3.46c.28-.48.11-1.09-.37-1.37zM18.5 8c.33 0 .65.06.96.16.02-.14.04-.27.04-.41C19.5 5.13 17.37 3 14.75 3c-1.64 0-3.08.83-3.93 2.09A3.68 3.68 0 0010 5a3.98 3.98 0 00-3.86 3.01C6.09 8.01 6.05 8 6 8c-1.66 0-3 1.34-3 3s1.34 3 3 3h6.92c.03-.05.05-.11.08-.17l3-4.5c.56-.84 1.49-1.34 2.5-1.34V8zm1.36 6.99a.99.99 0 00-.86-.49h-1.63l1.96-2.95a1.001 1.001 0 10-1.67-1.11l-3 4.5c-.2.31-.22.7-.05 1.03.17.33.51.53.88.53h1.8l-1.67 3.01c-.27.48-.09 1.09.39 1.36.15.09.32.13.48.13.35 0 .69-.19.88-.51l2.5-4.5c.17-.31.17-.69-.01-.99v-.01z",
            fill: "currentColor"
        })
    });



const $26443e9476ed7856$export$a8b99ac992e19a6a = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10.54 5a.49.49 0 00-.49.49v1.02c0 .27.22.49.49.49h2.93c.27 0 .49-.22.49-.49V5.49a.49.49 0 00-.49-.49h-2.93zm2.93 15h-2.93a.49.49 0 00-.49.49v1.02c0 .27.22.49.49.49h2.93c.27 0 .49-.22.49-.49v-1.02a.49.49 0 00-.49-.49zM9.69 3.97h4.62c.27 0 .49-.22.49-.49v-.96a.49.49 0 00-.49-.49H9.69a.49.49 0 00-.49.49v.96c0 .27.22.49.49.49zm3.47 13.35c-.76-.42-1.59-.42-2.32 0-.24.15-.62.12-.8.34-.12.16 0 .8 0 .8 0 .3.22.54.49.54h2.93c.27 0 .49-.24.49-.54 0 0 .12-.64 0-.8-.17-.23-.55-.19-.8-.34h.01zm6.22-5.81c0-.76-.32-1.49-.88-2.01.23-.85.05-1.76-.49-2.45a2.704 2.704 0 00-2.26-1.03c-.4 0-.77.21-.99.55-1.72 2.79-1.27 2.59-3.29 2.59-.4 0-.77-.21-.99-.55L9.22 6.58c-.93-1.5-4.53.16-3.74 2.93-.55.52-.87 1.25-.87 2.01 0 .76.31 1.49.87 2.01-.23.84-.05 1.75.49 2.44s1.37 1.08 2.23 1.04c1.84 0 2.92-2.01 5.18-.87 1.07.54 1.55.87 2.4.87.87.03 1.7-.36 2.23-1.04.54-.69.72-1.59.49-2.44.55-.52.86-1.25.86-2.02h.02z",
            fill: "currentColor"
        })
    });



const $4ff905a96a835fe8$export$b9960baefb01c43c = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 11h-.07A8 8 0 0012 4a7.67 7.67 0 00-1.45.14l-.84-.85a1.004 1.004 0 00-1.42 1.42l.14.14A8 8 0 004.07 11H4a1 1 0 000 2h.07a8 8 0 0015.86 0H20a1 1 0 100-2zm-13-.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm8.28 5.25a4.93 4.93 0 01-6.56 0 1 1 0 01.094-1.57A1 1 0 019.38 14h5.24a1 1 0 01.966 1.242 1 1 0 01-.306.508zM15.5 12a1.5 1.5 0 110-3 1.5 1.5 0 010 3z",
            fill: "currentColor"
        })
    });



const $b8ffd0f932a630ca$export$29e67036301075d = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M8 4c0-1.1-.9-2-2-2s-2 .9-2 2v8h4V4zm10 6h-6c-1.1 0-2 .9-2 2h10c0-1.1-.9-2-2-2zm-4 4H4v1c0 3.87 3.13 7 7 7h3c.55 0 1-.45 1-1v-1h1c2.21 0 4-1.79 4-4v-2h-6z",
            fill: "currentColor"
        })
    });



const $cd77374ea2cac05a$export$b1959dcd46c7e654 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M11 3a1 1 0 00-1-1H8a1 1 0 00-1 .84L6.15 8H11V3zm10 7H3a1 1 0 00-1 1v2a1 1 0 102 0v-1h16v1a1 1 0 002 0v-2a1 1 0 00-1-1zm-4-7.16A1 1 0 0016 2h-2a1 1 0 00-1 1v5h4.85L17 2.84zm-13 18a1 1 0 00.576 1.07A1 1 0 005 22h5a1 1 0 001-1v-7H5.15L4 20.84zM13 14v7a1 1 0 001 1h5a1 1 0 00.99-1.16L18.85 14H13z",
            fill: "currentColor"
        })
    });



const $272036740f2fc99b$export$2be96e22caf5972e = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.93 7.12c-.34-2.03-1.98-3.68-4.01-4.04-1.08-.19-2.1-.04-2.98.37-1.22.56-2.65.56-3.87 0-.88-.41-1.9-.56-2.98-.37-2.03.36-3.66 2.01-4.01 4.04-.32 1.91.44 3.66 1.77 4.74.72.58 1.16 1.44 1.16 2.36v2.77c0 2.04 1.39 4.07 3.08 4 .52-.02.92-.48.92-1v-4c0-1.1.9-2 2-2s2 .9 2 2v4c0 .52.4.98.92 1 1.69.07 3.08-1.96 3.08-4v-2.77c0-.92.44-1.78 1.16-2.36a4.988 4.988 0 001.77-4.74h-.01z",
            fill: "currentColor"
        })
    });



const $f65a7389116599ac$export$94df958657ecb95a = (s)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...s,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 4c.55 0 1-.45 1-1s-.45-1-1-1H3c-.55 0-1 .45-1 1s.45 1 1 1h17zm-1 2c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1h14c.55 0 1-.45 1-1zm2 3c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1s.45 1 1 1h13c.55 0 1-.45 1-1zm0 2H10c-.55 0-1 .45-1 1s.45 1 1 1h11c.55 0 1-.45 1-1s-.45-1-1-1zm-2 3h-8c-.55 0-1 .45-1 1s.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1zm-5 3h-4c-.55 0-1 .45-1 1s.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1zm-3 3h-1c-.55 0-1 .45-1 1s.45 1 1 1h1c.55 0 1-.45 1-1s-.45-1-1-1z",
            fill: "currentColor"
        })
    });



const $ac43bfee4da9483e$export$7856e2e687879519 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 2h-.5a1 1 0 00-1 1v1a1 1 0 01-2 0V3a1 1 0 00-1-1h-3a1 1 0 00-1 1v1a1 1 0 01-2 0V3a1 1 0 00-1-1H6a2 2 0 00-2 2v3a2 2 0 001.92 2h12.16A2 2 0 0020 7V4a2 2 0 00-2-2zm-1.23 9H7.19a1 1 0 00-1 .92l-1.1 7.93a2 2 0 002 2.15H9a1 1 0 001-1v-2.85A2.11 2.11 0 0111.71 16 2 2 0 0114 18v3a1 1 0 001 1h1.92a2 2 0 002-2.15L17.81 12a1 1 0 00-1.04-1z",
            fill: "currentColor"
        })
    });



const $e02c7ba2756f1624$export$44047b5f96096afd = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 3H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-3-3zm0 13h-5.38l-.73 1.45a1 1 0 01-1.78 0L9 15.24l-.11.21A1 1 0 018 16H6a1 1 0 010-2h1.38l.73-1.45a1 1 0 011.78 0L11 14.76l.11-.21A1 1 0 0112 14h6a1 1 0 010 2zm0-6h-1.38l-.73 1.45a1 1 0 01-1.78 0L13 9.24l-.11.21A1 1 0 0112 10H6a1 1 0 010-2h5.38l.73-1.45a1 1 0 011.78 0L15 8.76l.11-.21A1 1 0 0116 8h2a1 1 0 110 2z",
            fill: "currentColor"
        })
    });



const $c92b37e044953dd0$export$b819839a0f4d4e9a = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15.6 4A5.6 5.6 0 0012 5.46 5.6 5.6 0 008.4 4 5.36 5.36 0 003 9.44c0 3.37 2.63 6.43 7.16 10.56l.49.45a2 2 0 002.7 0l.49-.44C18.37 15.86 21 12.8 21 9.44A5.36 5.36 0 0015.6 4zm1.4 8h-1v1a1 1 0 01-2 0v-1h-1a1 1 0 110-2h1V9a1 1 0 112 0v1h1a1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $aab2af9344dff206$export$5c934bd7a02f554e = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M14 3.7a1 1 0 00-1-.7h-2a1 1 0 00-.95.7L8.7 8h6.6L14 3.7zM20 19h-1.26l-.94-3H6.2l-.94 3H4a1 1 0 100 2h16a1 1 0 000-2zm-4.08-9H8.08l-1.25 4h10.34l-1.25-4z",
            fill: "currentColor"
        })
    });



const $ccee449c38dabe41$export$1815aee8a4be5e47 = (r)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M9.61 12.74l.31-.82 1.76.59s.09.06.1.11l.74 3.72c.09.48.51.8.98.8.06 0 .13 0 .2-.02.54-.11.89-.63.78-1.18l-.74-3.72c-.15-.75-.7-1.37-1.43-1.61l-1.69-.56.8-2.14 2.14 1.07c.48.24 1.01.28 1.52.11l2.24-.75c.52-.17.81-.74.63-1.26a.996.996 0 00-1.26-.63l-2.23.75-2.35-1.17-.99-.47-3.08-.77c-.54-.13-1.11-.03-1.57.27L4.2 6.57c-.46.31-.58.93-.28 1.39.19.29.51.45.83.45.19 0 .38-.05.55-.17l2.25-1.51 1.99.5-1.81 4.82c-.11.29-.39.48-.69.48H3c-.55 0-1 .45-1 1s.45 1 1 1h4.04c1.14 0 2.17-.71 2.57-1.78v-.01zM13.32 5.04c.3 0 .59-.09.83-.25s.44-.4.55-.67c.11-.27.14-.58.09-.87-.06-.29-.2-.56-.41-.77-.21-.21-.48-.35-.77-.41a1.45 1.45 0 00-.87.09c-.27.11-.51.31-.67.55a1.499 1.499 0 001.25 2.33z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M21.35 10.06a1.01 1.01 0 00-1.29.58l-2.76 7.35H6c-.55 0-1 .45-1 1s.45 1 1 1h12c.12 0 .24-.03.35-.07.04-.01.07-.03.1-.05.07-.04.14-.08.2-.14.03-.03.06-.05.08-.08.06-.07.11-.14.15-.22.01-.03.03-.05.04-.08 0 0 0-.01.01-.02l3-8a1.01 1.01 0 00-.58-1.29v.02z",
                fill: "currentColor"
            })
        ]
    });



const $7b589ea6c59dcae2$export$1104373045d9a510 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 6V5a3 3 0 00-3-3H5a3 3 0 00-3 3v8a3 3 0 003 3h1v-5a5 5 0 015-5h5zm3 2h-8a3 3 0 00-3 3v8a3 3 0 003 3h8a3 3 0 003-3v-8a3 3 0 00-3-3zm-2.28 9a.5.5 0 01-.67-.23l-.11-.22h-1.88l-.11.22a.502.502 0 01-.9-.44l1.5-3a.52.52 0 01.9 0l1.5 3a.51.51 0 01-.23.67zm-2.16-1.5h.88l-.44-.88-.44.88z",
            fill: "currentColor"
        })
    });



const $bdffd945ba6cfdb8$export$7c20ea93b2bd1c99 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7.5 10h9a1 1 0 001-1A5.17 5.17 0 0013 4.08.193.193 0 0013 4a1 1 0 00-2 0 .19.19 0 000 .08A5.17 5.17 0 006.5 9a1 1 0 001 1zm14.31 1.42A1.002 1.002 0 0021 11H3a1 1 0 00-.81.42 1 1 0 00-.14.9l2 6A1 1 0 005 19h1.59a1.64 1.64 0 00-.09.5 1.5 1.5 0 003 0 1.64 1.64 0 00-.09-.5h5.18c-.056.161-.086.33-.09.5a1.5 1.5 0 103 0 1.645 1.645 0 00-.09-.5H19a1 1 0 00.95-.68l2-6a1.002 1.002 0 00-.14-.9z",
            fill: "currentColor"
        })
    });



const $024cd691c9a55e63$export$65dae79a3cb3b778 = (s)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...s,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 6s.7-1.39 3.25-2.44c.46-.19.4-.87-.09-.96C9.65.72 6 7 6 7s-1.39-.7-2.43-3.25c-.19-.46-.87-.4-.96.09C.73 14.4 7.01 18 7.01 18s-.69 1.39-3.24 2.43c-.47.19-.4.88.09.96C14.38 23.16 18 16 18 16s1.4 1.4 2.44 4.19c.18.47.87.41.96-.09C23.26 9.52 17 5.99 17 5.99V6zm-5 9c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3z",
            fill: "currentColor"
        })
    });



const $bd00637853b508c3$export$ffb54a9fada412e8 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M22 14v-1.54a3.059 3.059 0 00-.32-1.33l-1.24-2.47A3 3 0 0017.76 7H16V6a2 2 0 00-2-2H4a2 2 0 00-2 2v1h6a1 1 0 010 2H2v2h3a1 1 0 010 2H2v3a2 2 0 002 2h.18a3 3 0 005.64 0h4.36a3 3 0 005.64 0H20a2 2 0 002-2v-2zM7 18a1 1 0 110-2 1 1 0 010 2zm10 0a1 1 0 110-2 1 1 0 010 2zm-1-6V9h1.76a1 1 0 01.89.55L19.88 12H16z",
            fill: "currentColor"
        })
    });



const $7c47168fba0a2de0$export$84c1d15a3f8895c2 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M2.76 6.86c-.47.21-.76.68-.76 1.19v9.33c0 .63.67 1.03 1.22.73.97-.53 2.38-1.12 4.06-1.12 1.78 0 2.74.14 4.22 1.06V7.49C10.44 6.43 9.3 5.8 7.51 5.8c-2.03 0-3.78.63-4.75 1.06zM21.24 6.86c-.98-.44-2.73-1.06-4.75-1.06-1.79 0-2.93.64-3.99 1.69v10.56c1.48-.92 2.44-1.06 4.22-1.06 1.68 0 3.09.6 4.06 1.12.55.3 1.22-.1 1.22-.73V8.05c0-.51-.29-.98-.76-1.19z",
            fill: "currentColor"
        })
    });



const $9a531b5242f2daa5$export$94e8fcfc88e964c5 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.15 13A10 10 0 0022 6a1 1 0 00-1-1H3a1 1 0 00-1 1 10 10 0 002.85 7l-1.41 1.75a2 2 0 003.12 2.5l1.61-2c.592.239 1.205.423 1.83.55V19a2 2 0 004 0v-3.2c.626-.13 1.238-.318 1.83-.56l1.61 2A2 2 0 0019 18a2 2 0 001.56-3.25L19.15 13z",
            fill: "currentColor"
        })
    });



const $dc87c086b6348eb3$export$ce3a62ac26a07ae8 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M3.44 14.75a2 2 0 00-.33 1.9L14.76 5H3a1 1 0 00-1 1 10 10 0 002.85 7l-1.41 1.75zM19.15 13A10 10 0 0022 6a1 1 0 00-1-1h-.59l.3-.29a1.004 1.004 0 10-1.42-1.42l-16 16a1 1 0 000 1.42.998.998 0 001.42 0l5-5 .31.08V19a2 2 0 104 0v-3.2c.626-.13 1.238-.318 1.83-.56l1.61 2A1.999 1.999 0 0019 18a2 2 0 001.56-3.25L19.15 13z",
            fill: "currentColor"
        })
    });



const $79ec87037c198529$export$418f405b1e14ecf4 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 3H6C4.34 3 3 4.34 3 6v12c0 1.66 1.34 3 3 3h12c1.66 0 3-1.34 3-3V6c0-1.66-1.34-3-3-3zm-1.5 12.5c0 .55-.45 1-1 1h-7c-.55 0-1-.45-1-1v-7c0-.55.45-1 1-1s1 .45 1 1v6h5v-6c0-.55.45-1 1-1s1 .45 1 1v7z",
            fill: "currentColor"
        })
    });



const $b76783a21cac0511$export$b34761634da3313e = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M6.88 12.88a3 3 0 00-.83 1.61 2.9 2.9 0 00.25 1.79l-3 3a1 1 0 00-.22 1.1.87.87 0 00.22.32 1.001 1.001 0 00.7.3.999.999 0 00.71-.3l3-3c.4.2.842.303 1.29.3a3 3 0 002.12-.88l1.79-1.79-4.24-4.24-1.79 1.79zm14-7.26a1.15 1.15 0 00-.21-.33l-2-2a1.15 1.15 0 00-.33-.21A1 1 0 0018 3a1 1 0 00-.921 1.385 1 1 0 00.22.325l.3.29L16 6.59l-2.29-2.3A1.05 1.05 0 0013 4a1 1 0 00-.92 1.385 1 1 0 00.22.325l.88.88-3.09 3.08 4.24 4.24 3.08-3.08.88.88a.87.87 0 00.32.22A1 1 0 0019 12a1 1 0 00.92-.62A.85.85 0 0020 11a.84.84 0 00-.08-.38 1.15 1.15 0 00-.21-.33L17.41 8 19 6.41l.29.3a.87.87 0 00.32.22A1 1 0 0020 7a1 1 0 00.92-.62A.85.85 0 0021 6a.84.84 0 00-.08-.38h-.04z",
            fill: "currentColor"
        })
    });



const $67803a07c4dabc3d$export$22dc78a3867a1dce = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21 18h-1a1 1 0 00-1-1h-2a1 1 0 00-1 1h-1a1 1 0 00-1 1v1a1 1 0 001 1h6a1 1 0 001-1v-1a1 1 0 00-1-1zM9 8.1V7a2 2 0 012-2h4a2 2 0 012 2v9h2V7a4 4 0 00-4-4h-4a4 4 0 00-4 4v1.1A5 5 0 003 13v6a1 1 0 001 1 1 1 0 102 0h4a1 1 0 002 0 1 1 0 001-1v-6a5 5 0 00-4-4.9zm.5 9.4h-3a1 1 0 010-2h3a1 1 0 010 2zm0-4h-3a1 1 0 010-2h3a1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $1dcad20d1f426109$export$34af4b51525c75cd = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.73 8.22l-2.56-5.11A2 2 0 0015.38 2H8.62a2 2 0 00-1.79 1.11L4.27 8.22a2 2 0 00-.15 1.38l2.72 10.89A2 2 0 008.78 22h6.44a2 2 0 001.94-1.51L19.88 9.6a2 2 0 00-.15-1.38zM14.5 10H13v5a1 1 0 11-2 0v-5H9.5a1 1 0 010-2H11V7a1 1 0 012 0v1h1.5a1 1 0 110 2z",
            fill: "currentColor"
        })
    });



const $e1a9d9e60a92a050$export$b1512f4c12971de9 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 7.5c-2.49 0-4.5 2.01-4.5 4.5s2.01 4.5 4.5 4.5 4.5-2.01 4.5-4.5-2.01-4.5-4.5-4.5zM18 3H6C4.35 3 3 4.35 3 6v12c0 1.65 1.35 3 3 3h12c1.65 0 3-1.35 3-3V6c0-1.65-1.35-3-3-3zm1 15c0 .55-.45 1-1 1H6c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v12z",
            fill: "currentColor"
        })
    });



const $ad30543f8560c789$export$83a446a006c3e861 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21 10a1 1 0 00-1 1h-1.08a7 7 0 00-1.32-3.19l.76-.76a1 1 0 101.42-1.41l-1.42-1.42a1 1 0 10-1.41 1.42l-.76.76A7 7 0 0013 5.08V4a1 1 0 100-2h-2a1 1 0 100 2v1.08A7 7 0 007.81 6.4l-.76-.76a1 1 0 10-1.41-1.42L4.22 5.64a1 1 0 101.42 1.41l.76.76A7 7 0 005.08 11H4a1 1 0 10-2 0v2a1 1 0 102 0h1.08a7 7 0 001.32 3.19l-.76.81a1 1 0 10-1.42 1.41l1.42 1.42a1 1 0 101.41-1.42l.76-.76A7 7 0 0011 18.92V20a1 1 0 000 2h2a1 1 0 000-2v-1.08a7 7 0 003.19-1.32l.76.76a1.002 1.002 0 00.705 1.71 1 1 0 00.705-.29l1.42-1.42a1 1 0 10-1.42-1.41l-.76-.76A7 7 0 0018.92 13H20a1 1 0 002 0v-2a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $827a7b0fc8455654$export$f3daa23e28867585 = (l)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M7.64 19.85c.32-.54.42-1.2.31-1.82 0-.02 0-.05-.01-.07-.08-.39-.24-.76-.49-1.08a.996.996 0 00-.1-.11c-.1-.11-.21-.22-.34-.31l-.12-.09c-.17-.11-.35-.2-.56-.26-.03-.01-.07-.01-.11-.02-.18-.05-.37-.07-.57-.08-.04 0-.07-.01-.1-.01-.11 0-.22 0-.33.02-3.22.32-2.83 5.23.5 4.97.92-.07 1.55-.52 1.91-1.13v-.01h.01zM18.22 3.02c-.89.09-1.49.53-1.85 1.12-.33.54-.43 1.21-.31 1.83 0 .02.01.06.01.06.08.39.25.76.5 1.08.03.04.06.07.1.11.11.12.22.22.36.32.03.03.07.05.1.08.17.11.5.22.71.29-.05-.01.05.01 0 0 .17.04.47.09.66.09-.05 0 .08 0 0 0s.08 0 0 0c.23-.02.67-.06.86-.12 2.59-.81 2.05-5.18-1.14-4.86zM11.27 11.31h.88c.25 0 .44-.17.44-.46 0-.3-.19-.47-.44-.47h-.88c-.06 0-.08.03-.08.08v.78c0 .06.02.07.08.07zM12.33 12.67l-1.06-.01c-.06 0-.08.03-.08.08v.8c0 .06.02.08.08.08h1.06c.23 0 .42-.17.42-.48 0-.31-.19-.47-.42-.47z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M20.64 9.49c-.53.27-1.12.44-1.77.49-.13.01-.27.02-.39.02-2.46 0-4.34-1.8-4.47-4.29-.04-.86.15-1.66.5-2.35C13.71 3.13 12.87 3 12 3a9 9 0 00-9 9c0 .87.13 1.71.36 2.51.5-.25 1.05-.42 1.66-.48.18-.02.36-.03.53-.03 2.44 0 4.36 1.87 4.45 4.34.03.85-.16 1.62-.51 2.29.8.23 1.64.36 2.51.36a9 9 0 009-9c0-.87-.13-1.71-.36-2.51v.01zM12.4 15h-1.98c-.36 0-.69-.16-.69-.65V9.66c0-.49.33-.66.69-.66h1.76c1.01 0 1.91.59 1.91 1.79 0 .65-.32.94-.42 1.03-.03.03-.05.04-.05.08 0 .02 0 .03.03.05.27.27.63.61.63 1.28 0 1.11-.87 1.77-1.88 1.77z",
                fill: "currentColor"
            })
        ]
    });



const $84b7685303e953a0$export$3ab3548eba1bc8de = (l)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M7.64 19.85c.32-.54.42-1.2.31-1.82 0-.02 0-.021-.01-.07-.08-.39-.24-.76-.49-1.08-.03-.04-.06-.07-.1-.11-.1-.11-.21-.22-.34-.31l-.12-.09a2.054 2.054 0 00-.56-.26c-.18-.05-.48-.09-.68-.1-.04 0 .03 0 0 0-.11 0-.32-.01-.43.01-3.22.32-2.83 5.23.5 4.97.92-.07 1.55-.52 1.91-1.13v-.01h.01zM18.22 3.02c-.89.09-1.49.53-1.85 1.12-.33.54-.43 1.21-.31 1.83 0 .02 0 .04.01.06.08.39.25.76.5 1.08.03.04.06.07.1.11.11.12.22.22.36.32.03.03.07.05.1.08.17.11.35.19.56.26l.15.03c.17.04.47.09.66.09-.05 0 .04 0 0 0h.24c.23-.02.43-.06.62-.12h.01c2.59-.81 2.04-5.18-1.15-4.86z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M20.64 9.49c-.53.27-1.12.44-1.77.49-.13.01-.27.02-.39.02-2.46 0-4.34-1.8-4.47-4.29-.04-.86.15-1.66.5-2.35C13.71 3.13 12.87 3 12 3a9 9 0 00-9 9c0 .87.13 1.71.36 2.51.5-.25 1.05-.42 1.66-.48.18-.02.36-.03.53-.03 2.44 0 4.36 1.87 4.45 4.34.03.85-.16 1.62-.51 2.29.8.23 1.64.36 2.51.36a9 9 0 009-9c0-.87-.13-1.7-.36-2.5zm-6.79 4.78c-.47.59-1.12.73-1.81.73h-1.63c-.36 0-.69-.16-.69-.65V9.66c0-.49.33-.66.69-.66h1.63c.69 0 1.34.15 1.81.73.36.44.44 1.22.44 2.27s-.08 1.83-.44 2.27z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M11.97 10.4h-.72c-.06 0-.08.02-.08.08v3.05c0 .06.02.08.08.08h.72c.26 0 .51-.09.65-.32.13-.22.15-.74.15-1.28s0-1.05-.15-1.28c-.13-.22-.39-.33-.65-.33z",
                fill: "currentColor"
            })
        ]
    });



const $3ba9fedf64b743b6$export$afe41c094ed71a32 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 3h-1a1 1 0 00-1-1h-4a1 1 0 00-1 1H8a4 4 0 00-4 4v11.28A2 2 0 003 20a2 2 0 004 0 2 2 0 00-1-1.72V16h12v5a1 1 0 002 0V7a4 4 0 00-4-4zm-5 11H6v-3h5v3zm7 0h-5v-3h5v3zm0-5H6V7a2 2 0 012-2h1a1 1 0 001 1h4a1 1 0 001-1h1a2 2 0 012 2v2z",
            fill: "currentColor"
        })
    });



const $971f4ba413c605b6$export$1881db11abd29d0e = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M14 8h6a1 1 0 100-2h-6a2 2 0 00-2-2H7a2 2 0 00-2 2v4h9V8zm6.83 5.17A3.999 3.999 0 0018 12H6a4 4 0 100 8h12a4 4 0 002.83-6.83zM6.71 16.71a1 1 0 01-1.27.12.94.94 0 01-.36-.45A1 1 0 015 15.8a1 1 0 01.8-.8 1 1 0 01.58.06.94.94 0 01.45.36 1 1 0 01-.12 1.27v.02zm4 0a1 1 0 01-1.27.12.94.94 0 01-.36-.45A1 1 0 019 15.8a1 1 0 01.8-.8 1 1 0 01.58.06.94.94 0 01.45.36 1 1 0 01-.12 1.27v.02zm4 0a1 1 0 01-1.27.12.94.94 0 01-.36-.45 1 1 0 01-.08-.58 1 1 0 01.8-.8 1 1 0 01.58.06.94.94 0 01.45.36 1 1 0 01-.12 1.27v.02zm4 0a1 1 0 01-1.27.12.94.94 0 01-.36-.45 1 1 0 01-.08-.58 1 1 0 01.8-.8 1 1 0 01.58.06.94.94 0 01.45.36 1 1 0 01-.12 1.27v.02z",
            fill: "currentColor"
        })
    });



const $fe13378dcd3a1145$export$712bee8c9ae3685 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17.7 10.4l-4.85-7.92a1 1 0 00-1.7 0L6.3 10.4A8.82 8.82 0 005 15a7 7 0 0014 0 8.82 8.82 0 00-1.3-4.6z",
            fill: "currentColor"
        })
    });



const $bf39a9991855ef47$export$be586cb62c86696d = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10 5h4a1 1 0 001-1V3a1 1 0 00-1-1h-4a1 1 0 00-1 1v1a1 1 0 001 1zm7 8a2 2 0 00-2-2 2 2 0 000-4H9a2 2 0 100 4 2 2 0 100 4 2 2 0 00-2 2v3a2 2 0 002 2h6a2 2 0 002-2v-3a2 2 0 00-2-2 2 2 0 002-2z",
            fill: "currentColor"
        })
    });



const $9de7c330167da12d$export$1372be702c8c1710 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7 11.27a.93.93 0 00.46.84 1 1 0 010 1.78.93.93 0 00-.46.84V20a2 2 0 002 2h6a2 2 0 002-2v-5.27a.93.93 0 00-.46-.84 1 1 0 010-1.78.93.93 0 00.46-.84V10H7v1.27zM15 5h-1V3a1 1 0 00-1-1h-2a1 1 0 00-1 1v2H9a2 2 0 00-2 2v1h10V7a2 2 0 00-2-2z",
            fill: "currentColor"
        })
    });



const $c469d23566064425$export$ef136d12c866f019 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17.7 10.39l-4.85-7.93c-.36-.59-1.34-.59-1.71 0l-4.85 7.92a8.763 8.763 0 00-1.3 4.6c0 3.86 3.14 7 7 7s7-3.14 7-7c0-1.62-.45-3.21-1.3-4.6l.01.01zm-2 3.32l-4 4c-.2.2-.45.29-.71.29-.26 0-.51-.1-.71-.29l-2-2a.996.996 0 111.41-1.41l1.29 1.29 3.29-3.29a.996.996 0 111.41 1.41h.02z",
            fill: "currentColor"
        })
    });



const $1875fa550a359c10$export$e6ecbc158f4cbbc1 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 17.28V14a5 5 0 00-5-5V8a1 1 0 00-1-1h-1V5h1a1 1 0 100-2h-4a1 1 0 000 2h1v2h-1a1 1 0 00-1 1v1H6.72A2 2 0 005 8a2 2 0 00-2 2v4a2 2 0 002 2 2 2 0 001.72-1H14v2.28A2 2 0 0013 19a2 2 0 002 2h4a2 2 0 002-2 2 2 0 00-1-1.72z",
            fill: "currentColor"
        })
    });



const $2feda5988a149962$export$15ed81471035cb9d = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18.71 15.29a1.002 1.002 0 00-1.42 0l-.59.6a1.79 1.79 0 00-.53 1.28 1.82 1.82 0 003.12 1.29 1.81 1.81 0 000-2.55l-.58-.62zM13 19h-1v-5H8v5H7a1 1 0 000 2h6a1 1 0 000-2zm2-12h-1.18A3 3 0 0012 5.18V5a2 2 0 10-4 0v.18A3 3 0 006.18 7H6a2 2 0 100 4h.18A3 3 0 009 13h2a3 3 0 002.82-2H15a1 1 0 011 1v1a1 1 0 001 1h2a1 1 0 001-1v-1a5 5 0 00-5-5z",
            fill: "currentColor"
        })
    });



const $5bc82cb19e6a421f$export$59f13be10dd7505c = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15 15a1 1 0 100-2 1 1 0 000 2zm5.16-2a1 1 0 00-1.15.83l-.72 4.32a1 1 0 01-1 .84h-2.6a1 1 0 01-1-.84L13 13.84a1.013 1.013 0 10-2 .32l.73 4.33A3 3 0 0014.69 21h2.62a3 3 0 003-2.51l.69-4.33a1 1 0 00-.84-1.16zM17 17a1 1 0 100-2 1 1 0 000 2zm0-4a1 1 0 100-2 1 1 0 000 2zm1-10H4a1 1 0 00-1 1v3a1 1 0 001 1h9a2 2 0 002 2h2a2 2 0 002-2h1a1 1 0 001-1V6a3 3 0 00-3-3z",
            fill: "currentColor"
        })
    });



const $d390ba42d13b09f9$export$d1bb1d80aba0a8a7 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M9 7h1V5.73a1 1 0 01.86-1L16.14 4a1.006 1.006 0 10-.23-2l-9.18.84A3 3 0 004 5.83V7h5zm9 2H4v11a2 2 0 002 2h2a2 2 0 002-2v-7a1 1 0 011-1h6v1a1 1 0 001 1h1a1 1 0 001-1v-2a2 2 0 00-2-2zm.93 7.25a.45.45 0 00-.18-.18.5.5 0 00-.68.17l-.89 1.5c-.15.29-.21.617-.17.94.048.323.195.623.42.86.142.139.308.25.49.33a1.46 1.46 0 001.16 0 1.51 1.51 0 00.49-.33 1.62 1.62 0 00.42-.87 1.57 1.57 0 00-.18-.95l-.88-1.47z",
            fill: "currentColor"
        })
    });



const $bc9486096630d4da$export$88d6775659ce0dd5 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.29 12a1 1 0 00-1.12.41l-1.33 2-2.22-1 1.88-2.15a2 2 0 00-.09-2.73l-4-4A2 2 0 0011.93 4a2 2 0 00-1.43.68l-.56.63a4 4 0 10-5.22 6L3.5 12.68a2 2 0 00.09 2.73l4 4A2 2 0 009 20h.07a2 2 0 001.43-.68l2-2.32h4.93l1.71 2.55A1 1 0 0020 20a1 1 0 00.29 0 1 1 0 00.71-1v-6a1.001 1.001 0 00-.71-1zM5 8a2 2 0 013.62-1.17L6.06 9.75A2 2 0 015 8z",
            fill: "currentColor"
        })
    });



const $eb8ca86dca45b23d$export$48a03c4b40d55e95 = (A)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...A,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 6.84a9.74 9.74 0 00-2.89-3.45A2 2 0 0015.9 3a2 2 0 00-1.19.39l1.95 1.95A8 8 0 115.34 16.65L3.39 14.7A2 2 0 003 15.89a2 2 0 00.39 1.19A9.78 9.78 0 0021 11.21a9.58 9.58 0 00-1-4.37zM8.72 16.55A6.16 6.16 0 0011 17a6 6 0 005.54-3.7 6.06 6.06 0 00.34-3.47 6 6 0 00-1.64-3.07l-2-2-8.45 8.5 2 2a6.11 6.11 0 001.93 1.29zm3.57-8.27A1.05 1.05 0 0113 8a1 1 0 01.56.17 1 1 0 01.36.45 1 1 0 01.06.58 1 1 0 01-.78.78 1 1 0 01-.58-.05A1 1 0 0112 9a1.05 1.05 0 01.29-.72zm0 4A1.05 1.05 0 0113 12a1 1 0 01.56.17 1 1 0 01.36.45 1 1 0 01.06.58 1 1 0 01-.78.78 1 1 0 01-.58-.06 1 1 0 01-.45-.36A1 1 0 0112 13a1.05 1.05 0 01.29-.72zm-4 0A1.05 1.05 0 019 12a1 1 0 01.56.17c.162.113.29.269.37.45a1 1 0 01.05.58 1 1 0 01-.78.8 1 1 0 01-.58-.06 1 1 0 01-.45-.36A1 1 0 018 13a1.05 1.05 0 01.29-.72z",
            fill: "currentColor"
        })
    });



const $a12b95fd19242073$export$147bff986bdcd56e = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17.05 5.68h-1.3A5.055 5.055 0 0011.99 4c-1.49 0-2.83.66-3.76 1.68h-1.3c-1.4 0-2.53 1.13-2.53 2.53v9.26c0 1.4 1.13 2.53 2.53 2.53h10.11c1.4 0 2.53-1.13 2.53-2.53V8.21c0-1.4-1.13-2.53-2.53-2.53h.01zM12 11.99c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm0-4.63c-.46 0-.84.38-.84.84v.84c0 .46.38.84.84.84.46 0 .84-.38.84-.84V8.2c0-.46-.38-.84-.84-.84z",
            fill: "currentColor"
        })
    });



const $a838260e235f97fc$export$b0fe15733748c41f = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18.91 6.5l1.8-1.79a1 1 0 00-.326-1.639 1 1 0 00-1.094.219l-1.79 1.8-1.79-1.8a1 1 0 00-1.42 0L13 4.59l-.29-.3a1 1 0 00-1.42 0l-1 1a1 1 0 000 1.41l2.79 2.8-3.55 3.56-2.8-2.79a1 1 0 00-1.41 0l-1 1a1 1 0 000 1.42l.3.29-1.3 1.29a1 1 0 000 1.42l1.8 1.79-1.8 1.79a1.005 1.005 0 001.42 1.42l1.79-1.8 1.79 1.8a.998.998 0 001.42 0L11 19.41l.29.3a.997.997 0 001.095.219.998.998 0 00.325-.22l1-1a1 1 0 000-1.41l-2.79-2.8 3.53-3.53 2.8 2.79a1 1 0 001.41 0l1-1a1 1 0 000-1.42l-.3-.29 1.3-1.29a1 1 0 000-1.42L18.91 6.5z",
            fill: "currentColor"
        })
    });



const $6ec117353a3c2432$export$9eb8ad5b9df6bf96 = (s)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...s,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M3 9h10c1.65 0 3-1.35 3-3s-1.35-3-3-3c-.55 0-1 .45-1 1s.45 1 1 1 1 .45 1 1-.45 1-1 1H3c-.55 0-1 .45-1 1s.45 1 1 1zm16 7H9c-.55 0-1 .45-1 1s.45 1 1 1h10c.55 0 1 .45 1 1s-.45 1-1 1-1 .45-1 1 .45 1 1 1c1.65 0 3-1.35 3-3s-1.35-3-3-3zM3 12h16c1.65 0 3-1.35 3-3s-1.35-3-3-3c-.55 0-1 .45-1 1s.45 1 1 1 1 .45 1 1-.45 1-1 1H3c-.55 0-1 .45-1 1s.45 1 1 1zm16 2c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1s.45 1 1 1h15c.55 0 1-.45 1-1z",
            fill: "currentColor"
        })
    });



const $3a401511f91d3f88$export$fc293225c40d082c = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.44 8.38c.03-.21.06-.42.06-.63C19.5 5.13 17.37 3 14.75 3c-1.64 0-3.08.83-3.93 2.09A3.68 3.68 0 0010 5a3.98 3.98 0 00-3.86 3.01C6.09 8.01 6.05 8 6 8c-1.66 0-3 1.34-3 3s1.34 3 3 3h12c1.66 0 3-1.34 3-3 0-1.13-.64-2.11-1.56-2.62zm-4.94 7.29c-.48-.28-1.09-.11-1.37.37l-2 3.46c-.28.48-.11 1.09.37 1.37s1.09.11 1.37-.37l2-3.46c.28-.48.11-1.09-.37-1.37zm4 0c-.48-.28-1.09-.11-1.37.37l-2 3.46c-.28.48-.11 1.09.37 1.37s1.09.11 1.37-.37l2-3.46c.28-.48.11-1.09-.37-1.37zm-8.9.83a1.01 1.01 0 00-1.37-.37l-.23.13v-.27c0-.55-.45-1-1-1s-1 .45-1 1v.27l-.23-.13c-.48-.28-1.09-.11-1.37.37s-.11 1.09.37 1.37L5 18l-.23.13c-.48.28-.64.89-.37 1.37.28.48.89.64 1.37.37l.23-.13v.27c0 .55.45 1 1 1s1-.45 1-1v-.27l.23.13c.48.28 1.09.11 1.37-.37s.11-1.09-.37-1.37L9 18l.23-.13c.48-.28.64-.89.37-1.37z",
            fill: "currentColor"
        })
    });



const $b7f5733d62e27cc6$export$65d66d18eed1dace = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 16h-3v-2.09a5.995 5.995 0 003.74-2.24 6.043 6.043 0 001.24-4.18c-.13-1.5-.81-2.9-1.92-3.91A5.998 5.998 0 0012 2c-1.5 0-2.95.57-4.06 1.58a6.023 6.023 0 00-1.92 3.91c-.13 1.5.32 2.99 1.24 4.18A5.995 5.995 0 0011 13.91V16H8c-.27 0-.52.11-.71.29A.99.99 0 007 17c0 .27.11.52.29.71.19.19.44.29.71.29h3v3c0 .27.11.52.29.71.19.19.44.29.71.29.27 0 .52-.11.71-.29A.99.99 0 0013 21v-3h3c.27 0 .52-.11.71-.29A.99.99 0 0017 17c0-.27-.11-.52-.29-.71A.99.99 0 0016 16zm-4-4c-1.06 0-2.08-.42-2.83-1.17a4.004 4.004 0 01-.5-5.05 3.93 3.93 0 011.8-1.47c.73-.3 1.54-.38 2.31-.23.78.15 1.49.54 2.05 1.09.56.56.94 1.27 1.09 2.05.15.78.08 1.58-.23 2.31-.3.73-.82 1.36-1.47 1.8-.65.44-1.43.67-2.22.67zm1.65-5.34c-.11-.12-.24-.21-.39-.28-.15-.06-.3-.1-.46-.1-.3.01-.58.13-.8.34-.22-.21-.5-.33-.8-.34-.16 0-.32.03-.46.1-.15.06-.28.16-.39.28-.11.12-.2.26-.26.42-.06.16-.09.32-.09.49 0 .79.58 1.51 1.59 2.49l.11.1c.08.08.19.12.3.12.11 0 .22-.04.3-.12l.11-.1C13.42 9.08 14 8.36 14 7.57c0-.17-.03-.33-.09-.49-.06-.16-.15-.3-.26-.42z",
            fill: "currentColor"
        })
    });



const $1846cf0dd5176cc9$export$96ae3ac912a4dc00 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 3H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-3-3zm-2.55 7.72l-1.5 3a.5.5 0 01-.9 0L12 11.62l-1 2.1a.52.52 0 01-.9 0l-1.5-3a.5.5 0 11.9-.44l1.05 2.1 1.05-2.1a.52.52 0 01.9 0l1.05 2.1 1.05-2.1a.501.501 0 01.9.44h-.05z",
            fill: "currentColor"
        })
    });



const $b1b9e5e0c4d2d926$export$2ba5b2a596cf8918 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 7h-2V6a3 3 0 00-3-3h-4a3 3 0 00-3 3v1H5a3 3 0 00-3 3v8a3 3 0 003 3h14a3 3 0 003-3v-8a3 3 0 00-3-3zM9 6a1 1 0 011-1h4a1 1 0 011 1v1H9V6z",
            fill: "currentColor"
        })
    });



const $14ad6a9b627ee4d0$export$efca9ef9b910964 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18.52 15.59l-1.29-1.3a1 1 0 00-1.41 0l-1.59-1.58 1-1c.44.17.907.267 1.38.29a4.51 4.51 0 004.5-4.5 4.46 4.46 0 00-.7-2.39l-2.3 2.3L16.7 6 19 3.7a4.46 4.46 0 00-2.39-.7 4.51 4.51 0 00-4.5 4.5c.005.484.09.963.25 1.42l-1 1-2.43-2.51L7 3.55A1 1 0 006.27 3a1 1 0 00-.87.28l-2 2a1 1 0 00.25 1.61l3.87 1.93 2.47 2.47-6.29 6.3a2 2 0 102.82 2.82l6.3-6.29 1.58 1.59a1 1 0 000 1.41l1.3 1.29 2 2a2 2 0 002.82-2.82l-2-2z",
            fill: "currentColor"
        })
    });



const $cd33b3b7cfc127da$export$4d9278aabe4371d2 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M3.5 10a1.5 1.5 0 001.39-.93c.121-.27.16-.569.11-.86A1.49 1.49 0 003.79 7a1.49 1.49 0 00-.86.08 1.55 1.55 0 00-.68.56A1.5 1.5 0 003.5 10zm12.31 0l4.81 1.93c.122.044.25.068.38.07a1 1 0 00.64-.23 1 1 0 00.36-.57 1 1 0 00-.1-.67 1 1 0 00-.51-.45l-5-2A1 1 0 0016 8h-1.76l1.92-1 4.67 1a.86.86 0 00.39 0 1 1 0 00.63-.45 1 1 0 00.15-.38 1 1 0 000-.39.9.9 0 00-.16-.36 1.06 1.06 0 00-.69-.42l-5-1a1 1 0 00-.61.1L11.71 7l.5 3h3.6zM6.5 14a1.5 1.5 0 00-1.47 1.79A1.49 1.49 0 006.21 17c.288.059.587.031.86-.08a1.55 1.55 0 00.68-.56A1.5 1.5 0 006.5 14zm-.39-4.16l-2.54 1.28a.94.94 0 00-.5.57l-1 3a1.14 1.14 0 00-.07.41 1 1 0 00.34.71c.106.09.228.157.36.2.1.014.201.01.3-.01a1 1 0 001-.68l.86-2.6 1.62-.81-.37-2.07zm13.77 5.71a.94.94 0 00-.52-.48l-5-2a.91.91 0 00-.61 0l-2.94.74-.81-5a1 1 0 00-.14-.37 1.06 1.06 0 00-.27-.29A1 1 0 009.24 8a1 1 0 00-.39 0 1 1 0 00-.37.14 1.06 1.06 0 00-.29.27 1 1 0 00-.19.36 1.08 1.08 0 000 .4l1 6a1 1 0 00.44.68.84.84 0 00.38.15 1 1 0 00.41 0l3.21-.81L14.88 18l-.77 1.55a1 1 0 00.132 1.1 1 1 0 00.308.24c.14.071.293.11.45.11a1 1 0 00.52-.15 1 1 0 00.37-.4l1-2A1 1 0 0017 18a1.001 1.001 0 00-.1-.45l-.82-1.64 2.2.88 1.83 3.66a1 1 0 00.37.4.93.93 0 00.52.15 1 1 0 00.94-.69 1 1 0 00-.05-.76l-2.01-4z",
            fill: "currentColor"
        })
    });



const $7de1e89b3b0fd7e1$export$b669350aea456373 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 17h-1.44l2.2-2.6a1 1 0 00.08-1.19L13 2.7v7.58a2 2 0 11-2 0V2.7L4.16 13.21a1 1 0 00.08 1.19l2.2 2.6H5a1 1 0 00-1 1v3a1 1 0 001 1h14a1 1 0 001-1v-3a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $352dccb6cf1192a0$export$f9ebec4557c656fb = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M8 3H6C4.34 3 3 4.34 3 6v4.54A5.98 5.98 0 017 9h4V6.86c-1.72-.45-3-2-3-3.86zM7 13h2c1.1 0 2-.9 2-2H7c-2.21 0-4 1.79-4 4v3c0 1.66 1.34 3 3 3h5v-2.56c-.59.34-1.27.56-2 .56H7c-.55 0-1-.45-1-1s.45-1 1-1h2c1.1 0 2-.9 2-2v-.56c-.59.34-1.27.56-2 .56H7c-.55 0-1-.45-1-1s.45-1 1-1zm10-2h-4c0 1.1.9 2 2 2h2c.55 0 1 .45 1 1s-.45 1-1 1h-2c-.73 0-1.41-.21-2-.56V15c0 1.1.9 2 2 2h2c.55 0 1 .45 1 1s-.45 1-1 1h-2c-.73 0-1.41-.21-2-.56V21h5c1.66 0 3-1.34 3-3v-3c0-2.21-1.79-4-4-4zm-3-8h-4c0 1.1.9 2 2 2s2-.9 2-2zm4 0h-2c0 1.86-1.28 3.41-3 3.86V9h4c1.54 0 2.94.59 4 1.54V6c0-1.66-1.34-3-3-3z",
            fill: "currentColor"
        })
    });



const $0a8cd1ebfe9a5b81$export$f7d325464ac1aed0 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 2H7C5.34 2 4 3.34 4 5v14c0 1.66 1.34 3 3 3v-2.17c0-.8.31-1.55.88-2.12L9.59 16H9c-.55 0-1-.45-1-1s.45-1 1-1h2v-2H7c-.55 0-1-.45-1-1s.45-1 1-1h4V8H9c-.55 0-1-.45-1-1s.45-1 1-1h2V5c0-.55.45-1 1-1s1 .45 1 1v1h2c.55 0 1 .45 1 1s-.45 1-1 1h-2v2h4c.55 0 1 .45 1 1s-.45 1-1 1h-4v2h2c.55 0 1 .45 1 1s-.45 1-1 1h-.59l1.71 1.71c.57.57.88 1.32.88 2.12V22c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3zm-5 14.41l-2.71 2.71a.99.99 0 00-.29.71V22h6v-2.17c0-.26-.11-.52-.29-.71L12 16.41z",
            fill: "currentColor"
        })
    });



const $914564ebd5d5e76e$export$a2c9076541424138 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M6.47 19.07l3.63-1L6.26 17a1.033 1.033 0 00-.52 2l.59.17a.845.845 0 01.14-.1zM12 8a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm-2 3.62V17l2 .54 2-.54v-5.4a5.5 5.5 0 003.5-5.1 5.44 5.44 0 00-2.11-4.29 1.001 1.001 0 10-1.23 1.58A3.43 3.43 0 0115.5 6.5a3.5 3.5 0 11-7 0 3.43 3.43 0 011.34-2.71 1.002 1.002 0 00-1.23-1.58A5.44 5.44 0 007.46 9.6 5.5 5.5 0 0010 11.62zm9 6.12a1 1 0 00-1.22-.7l-11 3A1 1 0 006 21.26 1 1 0 007 22a.747.747 0 00.26 0l11-3a1 1 0 00.74-1.26zm-1.39 2.45l-3.67 1 2.84.77A.779.779 0 0017 22a1 1 0 001-.74 1 1 0 00-.43-1.07h.04z",
            fill: "currentColor"
        })
    });



const $0a6a815bee38ef96$export$a90a3480ab7db219 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 6a2 2 0 100-4 2 2 0 000 4zm6.76 11L12 18.72 5.24 17a1.028 1.028 0 10-.48 2l3.12.78-1.12.22A1.007 1.007 0 107 22c.08.01.16.01.24 0L12 20.78 16.76 22a1 1 0 001.24-.76 1.001 1.001 0 00-.76-1.24l-1.12-.28 3.12-.72a1.028 1.028 0 00-.48-2zM5 16a.93.93 0 00.45-.11l1.26-.63a3 3 0 001.5-1.73l1.28-3.85a1 1 0 01.95-.68H11v8.41l1 .25 1-.25V9h.56a1 1 0 01.95.68l1.28 3.85a3 3 0 001.5 1.73l1.26.63A.93.93 0 0019 16a1 1 0 00.45-1.89l-1.26-.63a1 1 0 01-.5-.58L16.4 9.05A3 3 0 0013.56 7h-3.12A3 3 0 007.6 9.05L6.31 12.9a1 1 0 01-.5.58l-1.26.63A1 1 0 005 16z",
            fill: "currentColor"
        })
    });



const $b4ef48b44fc331cd$export$daa18852d69ea222 = (v)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...v,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 4a1 1 0 00-1 1v2.33a.658.658 0 01-.66.67.67.67 0 01-.67-.67V4a1 1 0 10-2 0v3.33a.67.67 0 01-.925.619.66.66 0 01-.405-.619V3a1 1 0 10-2 0v4.33a.658.658 0 01-.66.67.67.67 0 01-.68-.67V4a1 1 0 10-2 0v4a1 1 0 01-2 0V7a1 1 0 00-2 0v3a4.94 4.94 0 001 3 5 5 0 004 2v1.17A3 3 0 0010 22a2.759 2.759 0 002-.79 3 3 0 103-5V15a5 5 0 004-2 4.94 4.94 0 001-3V5a1 1 0 00-1-1zm-5 16a1 1 0 01-.68-.26 2 2 0 00-2.64 0A1 1 0 0110 20a1 1 0 010-2 1 1 0 001-1v-2h2v2a1 1 0 001 1 1 1 0 110 2z",
            fill: "currentColor"
        })
    });



const $12ffcdc1a6c65a9a$export$4e084bc18e57658 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 4H5a3 3 0 00-3 3v8a3 3 0 003 3h3v1a2 2 0 003.2 1.6l3.47-2.6H19a3 3 0 003-3V7a3 3 0 00-3-3zM7 8h3a1 1 0 110 2H7a1 1 0 010-2zm10 6H7a1 1 0 010-2h10a1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $cb2c6e2b2ad140c4$export$a375f4644e915198 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 6h1v1a1 1 0 002 0V6h1a1 1 0 100-2h-1V3a1 1 0 00-2 0v1h-1a1 1 0 100 2zm2 4a3 3 0 01-2.87-2.13 3 3 0 01-2-3.87H5a3 3 0 00-3 3v8a3 3 0 003 3h3v1a2 2 0 003.2 1.6l3.47-2.6H19a3 3 0 003-3V7.82h-.13A3 3 0 0119 10zM7 8h3a1 1 0 110 2H7a1 1 0 010-2zm10 6H7a1 1 0 010-2h10a1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $d8bcac1b48819499$export$4a9861f0a7e1b916 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 4H5a3 3 0 00-3 3v8a3 3 0 003 3h3v1a2 2 0 003.2 1.6l3.47-2.6H19a3 3 0 003-3V7a3 3 0 00-3-3zm-7 9.71l-1.32.69a.85.85 0 01-1.24-.9l.25-1.5-1.07-1a.86.86 0 01.48-1.47l1.47-.22.66-1.31a.86.86 0 011.54 0l.66 1.33 1.47.22a.86.86 0 01.48 1.45l-1.07 1 .25 1.47a.85.85 0 01-1.24.9L12 13.71z",
            fill: "currentColor"
        })
    });



const $29de88b1ca099c1c$export$b66d5e89ae86ad8d = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.71 6.29a1 1 0 00-1.42 0L8 16.59l-4.29-4.3a1.004 1.004 0 00-1.42 1.42l5 5a.998.998 0 001.42 0l11-11a1 1 0 000-1.42zM20.5 16a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm-5 0a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
            fill: "currentColor"
        })
    });



const $ed88506054e9b8fc$export$34fc949ec71b565a = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 15a1.002 1.002 0 00.71-.29l7-7a1.004 1.004 0 00-1.42-1.42l-7 7A1 1 0 0012 15zm-8.29-2.71a1.004 1.004 0 00-1.42 1.42l5 5a1 1 0 001.64-.325 1 1 0 00-.22-1.095l-5-5zm18-4a1 1 0 00-1.42 0L12 16.59l-4.29-4.3a1.004 1.004 0 00-1.42 1.42l5 5a1 1 0 001.42 0l9-9a1.001 1.001 0 000-1.42z",
            fill: "currentColor"
        })
    });



const $6650de8667b72f62$export$a9466820d7879b1b = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zm3.5 6a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm-7 0a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm9 6.4a6 6 0 01-11 0 1 1 0 01.92-1.4h9.16a1 1 0 01.91 1.4h.01z",
            fill: "currentColor"
        })
    });



const $22bbad0af81db980$export$3c776ef51f2b0e85 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zM7 9.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm7 7.5h-4a1 1 0 010-2h4a1 1 0 010 2zm1.5-6a1.5 1.5 0 110-3 1.5 1.5 0 010 3z",
            fill: "currentColor"
        })
    });



const $c0d62f678c3cc934$export$a5b2dd6bad70bc7 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zm3.5 6a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm-7 0a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm-2 8.6a6 6 0 0111 0 1 1 0 01-.91 1.4H7.42a1 1 0 01-.91-1.4H6.5z",
            fill: "currentColor"
        })
    });



const $6512d49f30c29e57$export$40fb61d3f4445d5b = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zM7 9.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm9.24 6.74a6 6 0 01-8.48 0 1 1 0 011.41-1.41 4.1 4.1 0 005.66 0 1 1 0 011.41 1.41zM15.5 11a1.5 1.5 0 110-3 1.5 1.5 0 010 3z",
            fill: "currentColor"
        })
    });



const $fda3042e3e05dac5$export$f13e0e45147e9cb = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zM7 9.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm9.24 7.21a1 1 0 01-1.41 0 4.1 4.1 0 00-5.66 0 1 1 0 11-1.41-1.42 6 6 0 018.48 0 1.002 1.002 0 010 1.42zM15.5 11a1.5 1.5 0 110-3 1.5 1.5 0 010 3z",
            fill: "currentColor"
        })
    });



const $a1e58e4fc090542a$export$ad944822d9bc99e7 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M9 16.5a2.5 2.5 0 10-5 0 2.5 2.5 0 005 0zm.5 2.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm8-15a3.71 3.71 0 00-.48 0A5 5 0 008.4 5H8a4 4 0 000 8 4.18 4.18 0 001.33-.24 5 5 0 009.31.08A4.49 4.49 0 0017.5 4z",
            fill: "currentColor"
        })
    });



const $e5c9b373f554e6a2$export$634dfacc4f00a005 = (v)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...v,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 12a1 1 0 00-1 1v1a1 1 0 002 0v-1a1 1 0 00-1-1zm7-8H5a3 3 0 00-3 3v10a3 3 0 003 3h14a3 3 0 003-3V7a3 3 0 00-3-3zm-8 2a1 1 0 110 2 1 1 0 010-2zM4 7a1 1 0 112 0 1 1 0 01-2 0zm4.5 8H8v.5a.5.5 0 01-1 0V15H5.5a.52.52 0 01-.41-.21.48.48 0 01-.09-.45l1-3a.5.5 0 01.94.32L6.19 14H7v-.5a.5.5 0 011 0v.5h.5a.5.5 0 010 1zM8 8a1 1 0 110-2 1 1 0 010 2zm6 6a2 2 0 01-4 0v-1a2 2 0 014 0v1zm4.5 1H18v.5a.5.5 0 01-1 0V15h-1.5a.52.52 0 01-.41-.21.48.48 0 01-.06-.45l1-3a.5.5 0 11.94.32L16.19 14H17v-.5a.5.5 0 011 0v.5h.5a.5.5 0 010 1z",
            fill: "currentColor"
        })
    });



const $0c717c0c719066c4$export$f641ac39c6d78099 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15 10H9a3 3 0 00-3 3v6a3 3 0 003 3h6a3 3 0 003-3v-6a3 3 0 00-3-3zm-1.5 7H13v.5a.5.5 0 01-1 0V17h-1.5a.52.52 0 01-.41-.21.482.482 0 01-.06-.45l1-3a.5.5 0 11.94.32L11.19 16H12v-.5a.5.5 0 011 0v.5h.5a.5.5 0 110 1zm5.17-12.44a10 10 0 00-13.34 0 1.002 1.002 0 001.34 1.49 8 8 0 0110.66 0 1 1 0 00.67.25 1 1 0 00.74-.3.999.999 0 00-.07-1.44zM9.61 8.82a4 4 0 014.78 0 1.002 1.002 0 101.22-1.59 6 6 0 00-7.22 0 1.002 1.002 0 101.22 1.59z",
            fill: "currentColor"
        })
    });



const $842c869a6ca2be44$export$f7e44018dfd8dda5 = (m)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...m,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 7a1 1 0 100 2 1 1 0 000-2zm2-5h-4a3 3 0 00-3 3v14a3 3 0 003 3h4a3 3 0 003-3V5a3 3 0 00-3-3zm-4 18a1 1 0 110-2 1 1 0 010 2zm0-4a1 1 0 110-2 1 1 0 010 2zm4 4a1 1 0 110-2 1 1 0 010 2zm0-4a1 1 0 110-2 1 1 0 010 2zm-2-5a3 3 0 110-5.999A3 3 0 0112 11z",
            fill: "currentColor"
        })
    });



const $afd2f27afeb1ae44$export$6d1cb6c0296817ab = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 15a1 1 0 00-1 1v3a1 1 0 002 0v-3a1 1 0 00-1-1zm-4 0a1 1 0 00-1 1v1a1 1 0 01-1 1 1 1 0 000 2 3 3 0 003-3v-1a1 1 0 00-1-1zm10 3a1 1 0 01-1-1v-1a1 1 0 00-2 0v1a3 3 0 003 3 1 1 0 000-2zm0-14H6a3 3 0 00-3 3v3a3 3 0 003 3h12a3 3 0 003-3V7a3 3 0 00-3-3zm-1 6H7a1 1 0 010-2h10a1 1 0 110 2z",
            fill: "currentColor"
        })
    });



const $15b6c5430d223277$export$e3ee5f985383a7d5 = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M14 17.82c.36-1.08.58-2.34-1.4-3.65a1 1 0 10-1.1 1.66c.86.58.81.73.6 1.35-.36 1.08-.58 2.34 1.4 3.65a.94.94 0 00.5.17 1 1 0 00.55-1.83c-.86-.58-.81-.73-.55-1.35zm-5 0c.36-1.08.58-2.34-1.4-3.65a1 1 0 00-1.1 1.66c.86.58.81.73.6 1.35-.36 1.08-.58 2.34 1.4 3.65A.94.94 0 009 21a1 1 0 00.55-1.83c-.86-.58-.81-.73-.55-1.35zM18 3H6a3 3 0 00-3 3v3a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-3-3zm-1 6H7a1 1 0 010-2h10a1 1 0 110 2zm2 8.82c.36-1.08.58-2.34-1.4-3.65a1 1 0 10-1.1 1.66c.86.58.81.73.6 1.35-.36 1.08-.58 2.34 1.4 3.65a.94.94 0 00.5.17 1 1 0 00.55-1.83c-.86-.58-.81-.73-.55-1.35z",
            fill: "currentColor"
        })
    });



const $ea0fac93be3d3619$export$d1cc2048b006060c = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 22a2 2 0 002-2h-4a2 2 0 002 2zm4-5v-3a4 4 0 10-8 0v3a1 1 0 100 2h8a1 1 0 000-2zM9.61 8.82a4 4 0 014.78 0 1.002 1.002 0 101.22-1.59 6 6 0 00-7.22 0 1.002 1.002 0 101.22 1.59zm9.06-4.26a10 10 0 00-13.34 0 1.002 1.002 0 001.34 1.49 8 8 0 0110.66 0 1 1 0 00.67.25 1 1 0 00.74-.3.999.999 0 00-.07-1.44z",
            fill: "currentColor"
        })
    });



const $88e5cb8845759928$export$2bcdca9c5e7dfc = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 16a5 5 0 005-5 6.29 6.29 0 00-.91-3.24l-3.24-5.28a1 1 0 00-1.7 0L7.91 7.76A6.29 6.29 0 007 11a5 5 0 005 5zm7 2H5a1 1 0 100 2h.59l-.3.29a.999.999 0 000 1.42 1 1 0 001.42 0L8.41 20h2.18l-.3.29a1 1 0 000 1.42 1 1 0 001.42 0l1.7-1.71h2.18l-.3.29a1 1 0 000 1.42 1 1 0 001.42 0l1.7-1.71H19a1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $ec4b83732584c80a$export$434fad3979adeb78 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M14 8h-1V3a1 1 0 00-2 0v5h-1a2 2 0 00-2 2v5a4 4 0 003 3.86V21a1 1 0 002 0v-2.14A4 4 0 0016 15v-5a2 2 0 00-2-2z",
            fill: "currentColor"
        })
    });



const $aaf87efb226a1d38$export$d3b5730656122850 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M13 3a1 1 0 00-2 0v1h2V3zm1 5h-1V6h-2v2h-1a2 2 0 00-2 2v5a4 4 0 003 3.86V21a1 1 0 002 0v-2.14A4 4 0 0016 15v-5a2 2 0 00-2-2z",
            fill: "currentColor"
        })
    });



const $52350f4f59e1ffb8$export$87f874c9721fab2e = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 9c-1.6 0-3 1.4-3 3s1.4 3 3 3 3-1.4 3-3-1.4-3-3-3zm0 4c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm7-4c-1.6 0-3 1.4-3 3s1.4 3 3 3 3-1.4 3-3-1.4-3-3-3zm0 4c-.5 0-1-.4-1-1s.5-1 1-1 1 .4 1 1-.5 1-1 1zM5 9c-1.7 0-3 1.4-3 3s1.3 3 3 3 3-1.4 3-3-1.3-3-3-3zm0 4c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z",
            fill: "currentColor"
        })
    });



const $1faff47aa75ce593$export$1add26d59b074222 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 9a2 2 0 100 4 2 2 0 000-4zm0-5a7 7 0 00-3 .68V3a1 1 0 00-2 0v3a.29.29 0 000 .09A6.94 6.94 0 005 11v8a3 3 0 003 3h8a3 3 0 003-3v-8a7 7 0 00-7-7zM9 19a1 1 0 110-2 1 1 0 010 2zm6 0h-2a1 1 0 010-2h2a1 1 0 010 2zm-3-4a4 4 0 110-8 4 4 0 010 8z",
            fill: "currentColor"
        })
    });



const $13097060b7983302$export$a0d1506b9103bb66 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 7a4.94 4.94 0 00-8 0H5a3 3 0 00-3 3v4a3 3 0 002 2.82V18a1 1 0 102 0v-1h11v1a1 1 0 002 0v-1a3 3 0 003-3v-4a3 3 0 00-3-3zm-4 6a3 3 0 110-6 3 3 0 010 6z",
            fill: "currentColor"
        })
    });



const $652eba864defd3a8$export$83c072bae00d4395 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7.5 14a1 1 0 00-1 1v1a1 1 0 102 0v-1a1 1 0 00-1-1zm9 0a1 1 0 00-1 1v1a1 1 0 002 0v-1a1 1 0 00-1-1zM18 3H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-3-3zm-2.5 4a.5.5 0 010-1h1a.5.5 0 01.5.5V10h.5a.5.5 0 010 1h-2a.5.5 0 010-1h.5V7h-.5zm-9 0a.5.5 0 110-1h1a.5.5 0 01.5.5V10h.5a.5.5 0 010 1h-2a.5.5 0 010-1H7V7h-.5zm3 9a2 2 0 01-4 0v-1a2 2 0 014 0v1zm3.5 2h-2a.5.5 0 010-1h.5v-3H11a.5.5 0 010-1h1a.5.5 0 01.5.5V17h.5a.5.5 0 010 1zm1-9a2 2 0 11-4 0V8a2 2 0 114 0v1zm4.5 7a2 2 0 01-4 0v-1a2 2 0 014 0v1zM12 7a1 1 0 00-1 1v1a1 1 0 002 0V8a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $0a6d1f424bdd9c26$export$f415a520fa98f3c3 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 16a1 1 0 000-2h-2a1 1 0 00-1-1h-1a3 3 0 00-3 3H6.19A1.18 1.18 0 016 13.65l12.4-2.33a3.22 3.22 0 00-.59-6.38H14A2 2 0 0012 3H5a2 2 0 00-2 2v2a2 2 0 002 2h7a2 2 0 002-2v-.06h3.81A1.2 1.2 0 0119 8.19a1.18 1.18 0 01-1 1.16L5.6 11.68A3.19 3.19 0 006.19 18H13a3 3 0 003 3h1a1 1 0 001-1h2a1 1 0 000-2h-2v-2h2z",
            fill: "currentColor"
        })
    });



const $21bacae8f19e8c93$export$f114054e8fea1636 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 6h-2V3a1 1 0 00-2 0v3h-4V3a1 1 0 00-2 0v3H6a2 2 0 00-2 2v7a2 2 0 002 2h5v4a1 1 0 002 0v-4h5a2 2 0 002-2V8a2 2 0 00-2-2z",
            fill: "currentColor"
        })
    });



const $cc784c51a1dc1362$export$9795da043c531b16 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 13v-1c0-.55-.45-1-1-1V9.24c0-.53.21-1.03.59-1.41l1.12-1.12A.996.996 0 1016.3 5.3l-1.12 1.12c-.76.76-1.17 1.76-1.17 2.83v1.76h-1v-7c0-.55-.45-1-1-1s-1 .45-1 1v7h-1V9.25c0-1.07-.42-2.07-1.17-2.83L7.72 5.3a.996.996 0 10-1.41 1.41l1.12 1.12c.38.38.59.88.59 1.41V11c-.55 0-1 .45-1 1v1h-1c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2H17z",
            fill: "currentColor"
        })
    });



const $3f29ed159e1b586f$export$741cc44746f72846 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 7a1 1 0 100 2 1 1 0 000-2zM5 19a3 3 0 003 3h8a3 3 0 003-3v-2H5v2zM16 2H8a3 3 0 00-3 3v9h14V5a3 3 0 00-3-3zm-4 9a3 3 0 110-5.999A3 3 0 0112 11z",
            fill: "currentColor"
        })
    });



const $9b591861f31accbc$export$6a05b1dc5f3adb27 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M11.978 13a1 1 0 100 2 1 1 0 000-2zm9.71-3l-3-5a2 2 0 00-1.71-1h-10a2 2 0 00-1.71 1l-3 5a2 2 0 001.71 3h1v4a3 3 0 003 3h8a3 3 0 003-3v-4h1a2 2 0 001.74-1 2 2 0 00-.03-2zm-9.71 7a3 3 0 110-6 3 3 0 010 6z",
            fill: "currentColor"
        })
    });



const $f83cb10b295f7e71$export$6ba0175f783c247c = (m)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...m,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 3H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-3-3zm-2 4a1 1 0 110 2 1 1 0 010-2zm-4-2a1 1 0 110 2 1 1 0 010-2zM8 7a1 1 0 110 2 1 1 0 010-2zm-2 6a1 1 0 110-2 1 1 0 010 2zm2 4a1 1 0 110-2 1 1 0 010 2zm4 2a1 1 0 110-2 1 1 0 010 2zm0-4a3 3 0 110-5.999A3 3 0 0112 15zm4 2a1 1 0 110-2 1 1 0 010 2zm2-4a1 1 0 110-2 1 1 0 010 2zm-6-2a1 1 0 100 2 1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $838675cf3e200ac5$export$427bc0614e4ab2fa = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15 8H9a1 1 0 00-1 1v6a1 1 0 001 1h6a1 1 0 001-1V9a1 1 0 00-1-1zm6 5a1 1 0 000-2h-1V9h1a1 1 0 100-2h-1.14A4 4 0 0017 4.14V3a1 1 0 00-2 0v1h-2V3a1 1 0 00-2 0v1H9V3a1 1 0 00-2 0v1.14A4 4 0 004.14 7H3a1 1 0 000 2h1v2H3a1 1 0 000 2h1v2H3a1 1 0 000 2h1.14A4 4 0 007 19.86V21a1 1 0 102 0v-1h2v1a1 1 0 002 0v-1h2v1a1 1 0 002 0v-1.14A4 4 0 0019.86 17H21a1 1 0 000-2h-1v-2h1zm-3.29 3A1.7 1.7 0 0116 17.71H8A1.7 1.7 0 016.29 16V8A1.7 1.7 0 018 6.29h8A1.7 1.7 0 0117.71 8v8z",
            fill: "currentColor"
        })
    });



const $5569ef271c911f0b$export$44b2ed2cffcebe2b = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M11 18.86V21a1 1 0 002 0v-2.14A4 4 0 0016 15H8a4 4 0 003 3.86zm4-10.58V7.5a1.51 1.51 0 00-1-1.41V5a1 1 0 00-1-1V3a1 1 0 00-2 0v1a1 1 0 00-1 1v1.09A1.51 1.51 0 009 7.5v.78A2 2 0 008 10v3h8v-3a2 2 0 00-1-1.72z",
            fill: "currentColor"
        })
    });



const $6b31dcf955085b00$export$5a537b74f55757fa = (v)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...v,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 20h-1a1 1 0 01-1-1v-1a3 3 0 00-6 0v1a1 1 0 01-1 1H9a1 1 0 01-1-1v-.14A4 4 0 0011 15H3a4 4 0 003 3.86V19a3 3 0 003 3h2a3 3 0 003-3v-1a1 1 0 012 0v1a3 3 0 003 3h1a1 1 0 000-2zm-9-10a2 2 0 00-1-1.72V7.5a1.51 1.51 0 00-1-1.41V5a1 1 0 00-1-1V3a1 1 0 00-2 0v1a1 1 0 00-1 1v1.09A1.51 1.51 0 004 7.5v.78A2 2 0 003 10v3h8v-3z",
            fill: "currentColor"
        })
    });



const $619eca330c6943ed$export$966a629f4af01a6f = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7 15h10a4.001 4.001 0 002-7.47 5 5 0 00-9-2.38A3 3 0 009 5a3 3 0 00-2.85 2.09A4 4 0 007 15zm1 1a1 1 0 00-1 1v1.5H5.61a1.5 1.5 0 100 2H7a2 2 0 002-2V17a1 1 0 00-1-1zm11.5 2a1.5 1.5 0 00-1.11.5H17V17a1 1 0 10-2 0v1.5a2 2 0 002 2h1.39a1.501 1.501 0 002.374-1.821 1.5 1.5 0 00-1.264-.68zM13 17a1 1 0 10-2 0v1.39a1.5 1.5 0 102 0V17z",
            fill: "currentColor"
        })
    });



const $2d48252e1ffa8a23$export$549a837f209cb695 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7.71 7.29a.996.996 0 00-1.41 0l-4.01 4a.996.996 0 000 1.41l4 4c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 000-1.41L4.42 12l3.29-3.29a.996.996 0 000-1.41v-.01zm14 4l-4-4A.996.996 0 1016.3 8.7l3.29 3.29-3.29 3.29a.996.996 0 00.71 1.7c.26 0 .51-.1.71-.29l4-4a.996.996 0 000-1.41l-.01.01zm-7.43-7.25c-.53-.15-1.08.16-1.24.69l-4 14a1.012 1.012 0 00.97 1.28c.44 0 .84-.29.96-.73l3.99-14.01c.15-.53-.16-1.08-.69-1.24l.01.01z",
            fill: "currentColor"
        })
    });



const $1b91b8ec52279468$export$8d194fca25086aa9 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17.5 2H10a2 2 0 00-1.41.59l-3 3A2 2 0 005 7v12.5A2.5 2.5 0 007.5 22h10a2.5 2.5 0 002.5-2.5v-15A2.5 2.5 0 0017.5 2zm-6.79 11.29a1.002 1.002 0 01-.325 1.639 1 1 0 01-1.095-.219l-2-2a1 1 0 010-1.42l2-2a1.004 1.004 0 011.42 1.42L9.41 12l1.3 1.29zm7-.58l-2 2a1.002 1.002 0 01-1.639-.325 1 1 0 01.219-1.095l1.3-1.29-1.3-1.29a1.004 1.004 0 111.42-1.42l2 2a1.002 1.002 0 010 1.42z",
            fill: "currentColor"
        })
    });



const $108322c338919829$export$99a66f9d994787 = (a)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M11.7 13.6h-.6v-1.2c0-.64-.25-1.25-.7-1.7-.45-.45-1.06-.7-1.7-.7H6.3c-.64 0-1.25.25-1.7.7-.45.45-.7 1.06-.7 1.7v1.2h-.6a.56.56 0 00-.42.18c-.11.11-.18.27-.18.42 0 .15.06.31.18.42.11.11.27.18.42.18h.6v4.8c0 .64.25 1.25.7 1.7.45.45 1.06.7 1.7.7h2.4c.64 0 1.25-.25 1.7-.7.45-.45.7-1.06.7-1.7v-4.8h.6c.16 0 .31-.06.42-.18.11-.11.18-.27.18-.42 0-.15-.06-.31-.18-.42a.617.617 0 00-.42-.18zm-2.06 6.34a.9.9 0 01-.64.26H6a.9.9 0 01-.64-.26.9.9 0 01-.26-.64c0-.08.03-.16.09-.21.06-.06.13-.09.21-.09h4.2c.08 0 .16.03.21.09.06.06.09.13.09.21a.9.9 0 01-.26.64zm.17-4.63c-.06.06-.13.09-.21.09H5.4c-.08 0-.16-.03-.21-.09a.288.288 0 01-.09-.21c0-.56.22-1.09.62-1.48.39-.39.93-.62 1.48-.62h.6c.56 0 1.09.22 1.48.62.39.39.62.93.62 1.48 0 .08-.03.16-.09.21zM11.18 6c-.07 0-.14 0-.21.03a.523.523 0 00-.3.28.492.492 0 00-.01.41.543.543 0 00.46.34c1.03.06 2 .49 2.73 1.22s1.16 1.7 1.22 2.73c0 .14.07.27.17.36a.533.533 0 00.74-.04c.09-.1.14-.24.13-.38-.07-1.29-.61-2.5-1.53-3.42A5.248 5.248 0 0011.16 6h.02z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M11.33 8.12a.537.537 0 00-.39.1.537.537 0 00-.1.74c.08.11.21.18.35.2.45.07.86.27 1.18.59.32.32.53.73.59 1.18 0 .07.03.13.07.19a.537.537 0 00.53.25c.07 0 .13-.03.19-.07.06-.04.11-.08.15-.14.04-.05.07-.12.09-.18.02-.07.02-.14.01-.2-.09-.68-.41-1.3-.89-1.78-.48-.48-1.11-.79-1.78-.89v.01zM14 3v.84C14 5.03 14.97 6 16.16 6h2.68C20.03 6 21 5.03 21 3.84V3h-7z",
                fill: "currentColor"
            })
        ]
    });



const $206707e4137b6e83$export$d0eeff86954dc931 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 3H5a2 2 0 00-2 2v10a2 2 0 002 2h6v2H9a1 1 0 000 2h6a1 1 0 000-2h-2v-2h6a2 2 0 002-2V5a2 2 0 00-2-2zm0 10H5V5.5a.5.5 0 01.5-.5h13a.5.5 0 01.5.5V13z",
            fill: "currentColor"
        })
    });



const $0387cd0167f60425$export$e7534a471c3d63e0 = (v)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...v,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M8 10a1 1 0 00-1 1v1a1 1 0 102 0v-1a1 1 0 00-1-1zm4-3a1 1 0 00-1 1v4a1 1 0 002 0V8a1 1 0 00-1-1zm4 2a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1zm4.41-4.41A2 2 0 0019 4H5a2 2 0 00-2 2v10a2 2 0 002 2h6v2H9a1 1 0 000 2h6a1 1 0 000-2h-2v-2h6a2 2 0 002-2V6a2 2 0 00-.59-1.41zM19 14H5V6.5a.51.51 0 01.5-.5h13a.51.51 0 01.5.5V14z",
            fill: "currentColor"
        })
    });



const $7bddbc980e90ee3c$export$f38dd657e4d14f2 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10 17a7 7 0 01.68-3H5V6.5a.5.5 0 01.5-.5h13a.5.5 0 01.5.5v3.79c.715.226 1.39.564 2 1V6a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2h5.08a6.63 6.63 0 01-.08-1zm7-5a5 5 0 100 10 5 5 0 000-10zm1.5 6a1 1 0 01-1 1h-2a1 1 0 010-2h1v-1.5a1 1 0 012 0V18zM9 20a1 1 0 000 2h3.11a7 7 0 01-1.43-2H9z",
            fill: "currentColor"
        })
    });



const $f2851584c1f3ae8b$export$1564b0d065b4b1e1 = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.89 10.1a2 2 0 00-.58-1l-7.38-6.38a3 3 0 00-3.86 0L2.69 9.09a2 2 0 00.21 3.09c.322.23.705.358 1.1.37V18a3 3 0 003 3h10a3 3 0 003-3v-5.45a1.999 1.999 0 001.81-1.29 2 2 0 00.08-1.16zm-7.66-.86a1.23 1.23 0 01.31-.37 1.24 1.24 0 011.38-.12c.22.117.397.299.51.52.116.218.165.465.14.71a1.3 1.3 0 01-.29.67c-.158.185-.366.32-.6.39a1.32 1.32 0 01-1.28-.45c-.1-.13-.177-.275-.23-.43a1.269 1.269 0 01.11-1l-.05.08zm-6.75.26a1.26 1.26 0 01.22-.43 1.2 1.2 0 01.6-.41 1.18 1.18 0 01.72 0c.232.052.444.17.61.34.16.19.261.423.29.67a1.26 1.26 0 01-.13.71c-.116.219-.293.4-.51.52a1.24 1.24 0 01-.71.16A1.28 1.28 0 017.43 10a1.37 1.37 0 01.05-.5zm.65 5.16a1.247 1.247 0 01-1-.11 1.12 1.12 0 01-.38-.34 1.17 1.17 0 01-.21-.47 1.1 1.1 0 010-.51c.031-.17.1-.33.2-.47a1.27 1.27 0 01.37-.36c.145-.092.31-.15.48-.17a1.25 1.25 0 011 .11c.151.082.281.199.38.34.104.139.176.3.21.47a1.1 1.1 0 010 .51c-.03.17-.1.33-.2.47a1.27 1.27 0 01-.37.36c-.145.092-.31.15-.48.17zm3.15 2.21a1.26 1.26 0 01-.49.53 1.19 1.19 0 01-.71.17 1.229 1.229 0 01-.68-.25 1.3 1.3 0 01-.4-.58A1.21 1.21 0 019 16a1.21 1.21 0 011-.92 1.19 1.19 0 01.72.11c.148.07.28.168.39.29.106.125.19.267.25.42.05.158.07.324.06.49a1.31 1.31 0 01-.14.48zm-.16-7.74a1.218 1.218 0 01-.37-.88 1.25 1.25 0 01.77-1.15 1.27 1.27 0 01.72-.1 1.3 1.3 0 011 1 1.27 1.27 0 01-.08.72 1.25 1.25 0 01-1.638.684 1.22 1.22 0 01-.402-.274zM15 16.74a1.22 1.22 0 01-.64.72 1.28 1.28 0 01-1 .05 1.26 1.26 0 01-.836-1.105A1.25 1.25 0 0113.7 15.08a1.3 1.3 0 01.91.31c.12.114.22.245.3.39a1.261 1.261 0 010 1l.09-.04zm2.36-3c-.034.16-.098.313-.19.45a1.35 1.35 0 01-.81.51 1.27 1.27 0 01-1.49-1 1.28 1.28 0 01.09-.72 1.32 1.32 0 01.47-.55 1.26 1.26 0 01.71-.19c.247.012.485.091.69.23.2.142.353.34.44.57.105.21.146.446.12.68l-.03.02z",
            fill: "currentColor"
        })
    });



const $853685a1a80601bf$export$7bab8ba5b042fbf9 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16.92 15.43a6 6 0 110-6.86 1 1 0 001.64-1.14A8 8 0 004.07 11H3a1 1 0 000 2h1.07a8 8 0 0014.49 3.57 1 1 0 00-1.64-1.14zM21 11h-5.14a4 4 0 100 2H21a1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $62623e4cc60d77d7$export$452b443271691350 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 3H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-3-3zm-7 2h2a1 1 0 110 2h-2a1 1 0 110-2zm3 7a1 1 0 01-1 1h-2a1 1 0 010-2h2a1 1 0 011 1zM8 8a1 1 0 012 0v2a1 1 0 11-2 0V8zm1 9a1 1 0 01-1-1v-2a1 1 0 112 0v2a1 1 0 01-1 1zm4 2h-2a1 1 0 010-2h2a1 1 0 010 2zm3-3a1 1 0 01-2 0v-2a1 1 0 012 0v2zm0-6a1 1 0 01-2 0V8a1 1 0 012 0v2z",
            fill: "currentColor"
        })
    });



const $28da65178e65ac0d$export$effc39daef45e49 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17.894 6.55a1 1 0 00-1.78 0 5.719 5.719 0 01-1.24 1.6 14.55 14.55 0 00-2-5.7 1 1 0 00-1.16-.45 1 1 0 00-.71 1 3.82 3.82 0 01-1.26 2.5l10.06 10.06c.55-3.2-.75-6.7-1.91-9.01zm2.82 12.74l-16-16a1.004 1.004 0 00-1.42 1.42L6.634 8a8 8 0 001.62 13 3.13 3.13 0 01.88-2.9c1-1.08 1.87-2 1.87-2.73a.5.5 0 01.73-.37 4.64 4.64 0 012.14 2.52c1.05-2.13 2.34 2.19 2 3.45a9 9 0 002.13-1.61l1.34 1.35a.999.999 0 001.42 0 1 1 0 00-.05-1.42z",
            fill: "currentColor"
        })
    });



const $3aef4c9344b8be43$export$da016c70f68239ff = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M9 2H7a3 3 0 00-3 3v2h8V5a3 3 0 00-3-3zM4 19a3 3 0 003 3h2a3 3 0 003-3V9H4v10zM19.9 6.57a1.07 1.07 0 00-.3-.37 1 1 0 00-.43-.2 1 1 0 00-.46 0L14 7.44v2.13l4-1.19V13a2 2 0 00-1.41 3.42c.27.279.619.467 1 .54a2 2 0 002.05-.85A2 2 0 0020 15V7a1 1 0 00-.1-.43z",
            fill: "currentColor"
        })
    });



const $22ebddfdee10dea2$export$30a13a2c56f277b4 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4 19a3 3 0 003 3h2a3 3 0 003-3V9H4v10zM9 2H7a3 3 0 00-3 3v2h8V5a3 3 0 00-3-3zm10.6 9.2l-4-3a1 1 0 00-1-.09A1 1 0 0014 9v6a1 1 0 00.55.89 1 1 0 001-.09l4-3a.999.999 0 000-1.6h.05z",
            fill: "currentColor"
        })
    });



const $27ffdda8cdc3f2d8$export$fe14394a41ac1514 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 9a6 6 0 013 .81V5a3 3 0 00-3-3H8a3 3 0 00-3 3v14a3 3 0 003 3h2.09a6.637 6.637 0 01-.09-1v-6a6 6 0 016-6zm-8 4a1 1 0 110-2 1 1 0 010 2zm8 9a2 2 0 002-2h-4a2 2 0 002 2zm3-5v-2a3 3 0 00-6 0v2a1 1 0 000 2h6a1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $02e0fd5da028d128$export$578256bc76c6d459 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M5 19a3 3 0 003 3h8a3 3 0 003-3v-3H5v3zm7-1a1 1 0 110 2 1 1 0 010-2zm4-16H8a3 3 0 00-3 3v9h14V5a3 3 0 00-3-3zm-4 10a4 4 0 110-8 4 4 0 010 8zm0-6a2 2 0 100 4 2 2 0 000-4z",
            fill: "currentColor"
        })
    });



const $f064e51cc2d5407e$export$c44772bfc325fdda = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 9a6 6 0 013 .81V5a3 3 0 00-3-3H8a3 3 0 00-3 3v14a3 3 0 003 3h2.09a6.637 6.637 0 01-.09-1v-6a6 6 0 016-6zm-8 4a1 1 0 110-2 1 1 0 010 2zm11 1.28V14a3 3 0 00-6 0v.27A2 2 0 0012 16v4a2 2 0 002 2h4a2 2 0 002-2v-4a2 2 0 00-1-1.72zM16 19a1 1 0 110-2 1 1 0 010 2zm-1-5a1 1 0 012 0h-2z",
            fill: "currentColor"
        })
    });



const $47d77ae7e99082b3$export$d1a5248b201c818a = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 2h-6.53l3.26 1.22A3.52 3.52 0 0117 6.5V20h1a2 2 0 002-2V4a2 2 0 00-2-2zm-4 3.1l-8-3a1.39 1.39 0 00-.5-.1 1.46 1.46 0 00-.85.27A1.49 1.49 0 004 3.5v13.3a1.5 1.5 0 00.87 1.36l8 3.7c.198.09.413.138.63.14a1.51 1.51 0 001.5-1.5v-14a1.5 1.5 0 00-1-1.4zm-2 8.4a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $1a0dd15f225b489b$export$d176f81564344d70 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15.23 2.42a2 2 0 00-1.72-.36l-8 2A2 2 0 004 6v12a2 2 0 001.51 1.94l8 2a2 2 0 002.288-1.06c.133-.275.202-.575.202-.88V4a2.001 2.001 0 00-.77-1.58zM13 13a1 1 0 110-2 1 1 0 010 2zm6-9a1 1 0 00-1 1v14a1 1 0 002 0V5a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $aa5372aaf3e18949$export$a723a57bbbccff19 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 9a6 6 0 013 .81V5a3 3 0 00-3-3H8a3 3 0 00-3 3v14a3 3 0 003 3h2.09a6.637 6.637 0 01-.09-1v-6a6 6 0 016-6zm-8 4a1 1 0 110-2 1 1 0 010 2zm10 1h-3a1 1 0 01.29-.71 1 1 0 011.21-.15 1 1 0 101-1.73 3 3 0 00-3.62.47 2.999 2.999 0 00-.88 2.38A2 2 0 0012 16v4a2 2 0 002 2h4a2 2 0 002-2v-4a2 2 0 00-2-2zm-2 5a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $e5de5604d6fa7f33$export$413bf1212921480c = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M11 13a4 4 0 112.62-7H17V5a3 3 0 00-3-3H8a3 3 0 00-3 3v14a3 3 0 003 3h6a3 3 0 003-3v-7h-3.38A4 4 0 0111 13zm1 4.61V19a1 1 0 01-2 0v-1.39a1.5 1.5 0 112 0zM19 8h-6.28a2 2 0 100 2H19a1 1 0 100-2z",
            fill: "currentColor"
        })
    });



const $b660502fa8a637de$export$2ea3e215bcd1f21e = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 15a1 1 0 100 2 1 1 0 000-2zm0-13a6 6 0 00-6 6v8a6 6 0 1012 0V8a6 6 0 00-6-6zm0 17a3 3 0 110-5.999A3 3 0 0112 19zm0-8a3 3 0 110-5.999A3 3 0 0112 11zm0-4a1 1 0 100 2 1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $ec384805fd0bb15f$export$7a908cb1d2f68b93 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M8 11a1 1 0 100 2 1 1 0 000-2zm8-5H8a6 6 0 100 12h8a6 6 0 100-12zm-8 9a3 3 0 110-6 3 3 0 010 6zm8 0a3 3 0 110-5.999A3 3 0 0116 15zm0-4a1 1 0 100 2 1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $447ea602b260a410$export$c5e242a918160e3a = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 14H5a3 3 0 000 6h14a3 3 0 000-6zm-8 4H5a1 1 0 010-2h6a1 1 0 010 2zm4 0a1 1 0 110-2 1 1 0 010 2zm4 0a1 1 0 110-2 1 1 0 010 2zM8 12a4 4 0 100-8 4 4 0 000 8zm0-5a1 1 0 110 2 1 1 0 010-2z",
            fill: "currentColor"
        })
    });



const $9c0ea393e6c6e3c2$export$e65a6bc56bfd8fc1 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 2H7a3 3 0 00-3 3v14a3 3 0 003 3h10a3 3 0 003-3V5a3 3 0 00-3-3zm-5 18a1 1 0 110-2 1 1 0 010 2zm2-9H8a1 1 0 010-2h6a1 1 0 110 2zm2-4H8a1 1 0 010-2h8a1 1 0 110 2z",
            fill: "currentColor"
        })
    });



const $10062e84a5f4bbe5$export$35bc895f147c9d6b = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M8 11a1 1 0 100 2 1 1 0 000-2zm4 0a1 1 0 100 2 1 1 0 000-2zm-7.59 1l3.3-3.29a1.004 1.004 0 10-1.42-1.42l-4 4a.999.999 0 000 1.42l4 4a1 1 0 001.639-.325 1 1 0 00-.22-1.095L4.41 12zm17.3-.71l-4-4a1.004 1.004 0 10-1.42 1.42l3.3 3.29-3.3 3.29a1 1 0 000 1.42 1.001 1.001 0 001.42 0l4-4a.999.999 0 000-1.42zM17 12a1 1 0 10-2 0 1 1 0 002 0z",
            fill: "currentColor"
        })
    });



const $6d3043367ab83c03$export$fe4785905153b66a = (r)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                opacity: .2,
                d: "M7.713 7.289a.996.996 0 00-1.41 0l-4.01 4a.996.996 0 000 1.41l4 4c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 000-1.41l-3.29-3.29 3.29-3.29a.996.996 0 000-1.41v-.01zm14 4l-4-4a.996.996 0 10-1.41 1.41l3.29 3.29-3.29 3.29a.996.996 0 00.71 1.7c.26 0 .51-.1.71-.29l4-4a.996.996 0 000-1.41l-.01.01z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M13.25 16.17c-.16-.25-.4-.44-.67-.55-.27-.11-.58-.14-.87-.09-.29.06-.56.2-.77.41-.21.21-.35.48-.41.77-.06.29-.03.59.09.87s.31.51.55.67A1.499 1.499 0 0013.5 17c0-.3-.09-.59-.25-.83zM12 13.5c.27 0 .52-.11.71-.29.19-.18.29-.44.29-.71v-6c0-.27-.11-.52-.29-.71A.99.99 0 0012 5.5c-.27 0-.52.11-.71.29a.99.99 0 00-.29.71v6c0 .27.11.52.29.71.18.19.44.29.71.29z",
                fill: "currentColor"
            })
        ]
    });



const $1774b8a35075e0b4$export$1ea6ae2002d0ad9b = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M9 9H5a2 2 0 00-2 2v9a2 2 0 002 2h4a2 2 0 002-2v-9a2 2 0 00-2-2zM7 20A1 1 0 117 18 1 1 0 017 20zM19 2h-4a2 2 0 00-2 2v9a2 2 0 002 2h4a2 2 0 002-2V4a2 2 0 00-2-2zm-2 11A1 1 0 1117 11 1 1 0 0117 13zm3 5h-3.59l.3-.29a1.004 1.004 0 10-1.42-1.42l-2 2a1 1 0 000 1.42l2 2a1.002 1.002 0 001.639-.325 1 1 0 00-.219-1.095l-.3-.29H20a1 1 0 000-2zM8.71 2.29a1.004 1.004 0 10-1.42 1.42l.3.29H4a1 1 0 100 2h3.59l-.3.29a1 1 0 000 1.42 1 1 0 001.42 0l2-2a1.001 1.001 0 000-1.42l-2-2z",
            fill: "currentColor"
        })
    });



const $ae5b853447527c75$export$b67096cd7619dd11 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M9.5 16A6.5 6.5 0 103 9.5 6.51 6.51 0 009.5 16zm0-8.5a2 2 0 110 4 2 2 0 010-4zM19 7a2 2 0 000 4v3a4 4 0 01-4 4h-.5v-1.64a8.44 8.44 0 01-10 0V19a2 2 0 002 2h6a2 2 0 001.72-1H15a6 6 0 006-6V9a2 2 0 00-2-2z",
            fill: "currentColor"
        })
    });



const $4d7eef60744328ac$export$70d0548ff7ff8579 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.41 5.34l-1.75-1.75A2 2 0 0017.25 3H6.75a2 2 0 00-1.41.59L3.59 5.34A2 2 0 003 6.75V9h18V6.75a2 2 0 00-.59-1.41zM8 7a1 1 0 110-2 1 1 0 010 2zm4 0a1 1 0 110-2 1 1 0 010 2zm4 0a1 1 0 110-2 1 1 0 010 2zM3 14.62A2 2 0 003.59 16L8 20.41a2 2 0 001.38.59h5.24a2 2 0 001.38-.59L20.41 16a2 2 0 00.59-1.38V11H3v3.62z",
            fill: "currentColor"
        })
    });



const $ecef886615cc4269$export$b5e0b43bb0c62485 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.7 8.53a5.94 5.94 0 00-5.53-4H8a6 6 0 00-6 5.83c-.09 3.39 2.56 9.17 5.83 9.17 2.17 0 2.06-3.29 2.91-3.8a2.52 2.52 0 012.53 0c1 .57.74 3.8 3.29 3.8s5.24-5.64 5.44-8.61a5.69 5.69 0 00-.3-2.39zm-12 2.68a1 1 0 01-.7.29H8v1a1 1 0 01-.29.71 1 1 0 01-.71.29 1 1 0 01-1-1v-1H5a1 1 0 010-2h1v-1a1 1 0 011.384-.926 1 1 0 01.326.216A1 1 0 018 8.5v1h1a1 1 0 01.71 1.71H9.7zm6 0a1.001 1.001 0 01-1.26.12.91.91 0 01-.37-.45 1 1 0 01-.07-.58 1 1 0 01.648-.741 1 1 0 011.332.94 1 1 0 01-.27.71h-.01zm.59-3.42A.999.999 0 0117 7.5a1 1 0 01.93.62 1 1 0 01.07.58 1 1 0 01-.78.78 1 1 0 01-.58-.06 1 1 0 01-.45-.36A1 1 0 0116 8.5a.999.999 0 01.3-.71h-.01zm1.41 5.42a1.001 1.001 0 01-1.26.12.91.91 0 01-.37-.45 1 1 0 01-.07-.58 1 1 0 01.648-.741.999.999 0 011.332.94 1 1 0 01-.27.71h-.01zm2-2a1.001 1.001 0 01-1.26.12.91.91 0 01-.37-.45 1 1 0 01-.07-.58 1 1 0 01.648-.741 1 1 0 011.332.94 1 1 0 01-.27.71h-.01z",
            fill: "currentColor"
        })
    });



const $445ecae49876e228$export$1b56cb1d089bf05f = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 10a6 6 0 100 12.001 6 6 0 000-12zm0 10a2.09 2.09 0 01-2-2 2.318 2.318 0 01.8-1.67 1.122 1.122 0 00.25-1.61.501.501 0 01.67-.67A4.44 4.44 0 0114 18a2.09 2.09 0 01-2 2zM9.61 8.82a4 4 0 014.78 0 1.002 1.002 0 101.22-1.59 6 6 0 00-7.22 0 1.002 1.002 0 101.22 1.59zm9.06-4.26a10 10 0 00-13.34 0 1.002 1.002 0 001.34 1.49 8 8 0 0110.66 0 1 1 0 00.67.25 1 1 0 00.74-.3.999.999 0 00-.07-1.44z",
            fill: "currentColor"
        })
    });



const $149e994fa83ec13d$export$d976574c57d2f21 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M8.4 9.22a1 1 0 101.2 1.6 4 4 0 014.8 0 1 1 0 001.2-1.6 6 6 0 00-7.2 0zM5.78 9a8 8 0 0112.44 0 1 1 0 00.78.37 1 1 0 00.78-1.63 10 10 0 00-15.56 0A1.003 1.003 0 105.78 9zm15.34 3.9A3 3 0 0019 12H5a3 3 0 00-3 3v2a3 3 0 003 3h14a3 3 0 003-3v-2a3 3 0 00-.88-2.12v.02zM9 17H6a1 1 0 110-2h3a1 1 0 010 2zm4 0a1 1 0 110-2 1 1 0 010 2zm4 0a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $53f5901daa2dcafa$export$5411ac4dcd554cf = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.12 12.88A3 3 0 0019 12V9a1 1 0 00-2 0v3H7V9a1 1 0 00-2 0v3a3 3 0 00-3 3v2a3 3 0 003 3h14a3 3 0 003-3v-2a3 3 0 00-.88-2.12zM9 17H6a1 1 0 110-2h3a1 1 0 010 2zm4 0a1 1 0 110-2 1 1 0 010 2zm4 0a1 1 0 110-2 1 1 0 010 2zM8.36 6.89a7.93 7.93 0 017.28 0 1 1 0 10.91-1.78 9.94 9.94 0 00-9.1 0 1 1 0 00.91 1.78zm1.23 1.64a1.003 1.003 0 00.82 1.83 3.691 3.691 0 013.18 0c.129.059.268.09.41.09a1 1 0 00.91-.59 1.001 1.001 0 00-.5-1.33 5.79 5.79 0 00-4.82 0z",
            fill: "currentColor"
        })
    });



const $bea0e5ecaa48f856$export$15468cea8f40de74 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 2H7a3 3 0 00-3 3v3h4.14a4 4 0 017.72 0H20V5a3 3 0 00-3-3zm-5 11a4 4 0 01-3.86-3H4v7a3 3 0 003 3h1v1a1 1 0 102 0v-1h4v1a1 1 0 002 0v-1h1a3 3 0 003-3v-7h-4.14A4 4 0 0112 13zm2 4h-4a1 1 0 010-2h4a1 1 0 010 2zm0-8a2 2 0 10-4 0 2 2 0 004 0z",
            fill: "currentColor"
        })
    });



const $45af1b62244a6aad$export$c0c9731eeb58763 = (r)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M18 8.99h-6l2 3-2 3 2 3-1.33 2H18c1.1 0 2-.9 2-2v-7c0-1.1-.9-2-2-2zM12 11.99l-2-3H6c-1.1 0-2 .9-2 2v7c0 1.1.9 2 2 2h4.67l1.33-2-2-3 2-3zM18.85 4.87c-.06-.12-.14-.23-.24-.32A10.004 10.004 0 0011.94 2c-2.46 0-4.84.91-6.67 2.55a.987.987 0 00-.07 1.41.987.987 0 001.41.07A7.996 7.996 0 0111.94 4c1.97 0 3.86.72 5.33 2.03.18.16.42.25.67.25a.976.976 0 00.74-.3c.09-.1.16-.21.21-.34.05-.13.07-.26.06-.4 0-.13-.04-.27-.1-.39v.02z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M11.93 5.01c-1.3 0-2.57.42-3.61 1.21-.1.08-.19.18-.26.29-.07.11-.11.24-.13.37-.02.13 0 .26.03.39s.09.25.17.35a.978.978 0 001.05.35.88.88 0 00.35-.17 4.03 4.03 0 012.39-.79c.86 0 1.7.28 2.39.79.21.16.48.23.74.2s.5-.17.66-.38c.16-.21.23-.48.2-.74a.978.978 0 00-.38-.66 6.031 6.031 0 00-3.61-1.21h.01z",
                fill: "currentColor"
            })
        ]
    });



const $c27aaf9ad2081bd3$export$9c06a77ac6cc17d6 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18.5 13a2.691 2.691 0 00-.7.11l-4.7-5.37a2.5 2.5 0 10-2.2 0l-4.7 5.37a2.691 2.691 0 00-.7-.11A2.5 2.5 0 108 15.5c0-.383-.093-.76-.27-1.1L11 10.66v5.55a2.5 2.5 0 102 0v-5.55l3.27 3.74a2.39 2.39 0 00-.27 1.1 2.5 2.5 0 102.5-2.5z",
            fill: "currentColor"
        })
    });



const $e4f44df99e5c444f$export$af0c68c40e20309f = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 11.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM17 2H7a3 3 0 00-3 3v14a3 3 0 003 3h10a3 3 0 003-3V5a3 3 0 00-3-3zm-5 4a4 4 0 11-1.34 7.75h.05a1.004 1.004 0 10-1.42-1.42L9 12.6A4 4 0 0112 6zm6 13a1 1 0 01-1 1H7a1 1 0 01-1-1v-1a1 1 0 011-1h10a1 1 0 011 1v1z",
            fill: "currentColor"
        })
    });



const $0dfd2954a8dcf63e$export$7af63d5d2373872c = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 2H7a3 3 0 00-3 3v10a4.92 4.92 0 013-1h10a4.92 4.92 0 013 1V5a3 3 0 00-3-3zm0 14H7a3 3 0 000 6h10a3 3 0 000-6zm0 4a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $7ea70a6f40e5fc0b$export$8b507dae8bf48cc1 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15 2H9a3 3 0 00-3 3v14a3 3 0 003 3h6a3 3 0 003-3V5a3 3 0 00-3-3zm-5 3a1 1 0 110 2 1 1 0 010-2zm6 14a1 1 0 01-1 1H9a1 1 0 01-1-1v-8a1 1 0 01.29-.71l1-1a1 1 0 011.42 0l1.29 1.3 2.29-2.3a1 1 0 011.09-.21A1 1 0 0116 9v10zm-4-3a1 1 0 100 2 1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $a76184c00ecc5f3a$export$3b3650c8bc758fda = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.23 6H4.77A2.77 2.77 0 002 8.77v4.45a2.77 2.77 0 002.77 2.77h.82l1.12 1.12c.56.56 1.32.88 2.12.88h6.34c.8 0 1.56-.32 2.12-.88l1.12-1.12h.82A2.77 2.77 0 0022 13.22V8.77A2.77 2.77 0 0019.23 6zm-1.52 5.71A.99.99 0 0117 12H7c-.27 0-.52-.11-.71-.29A.99.99 0 016 11c0-.27.11-.52.29-.71A.99.99 0 017 10h10c.27 0 .52.11.71.29.19.18.29.44.29.71 0 .27-.11.52-.29.71z",
            fill: "currentColor"
        })
    });



const $a2350633264c9cc2$export$27263824ca45ffbe = (l)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M18.91 4.87c-.06-.12-.14-.23-.24-.32A10.004 10.004 0 0012 2c-2.46 0-4.84.91-6.67 2.55a.987.987 0 00-.07 1.41.987.987 0 001.41.07A7.996 7.996 0 0112 4c1.97 0 3.86.72 5.33 2.03.18.16.42.25.67.25a.976.976 0 00.74-.3c.09-.1.16-.21.21-.34.05-.13.07-.26.06-.4 0-.13-.04-.27-.1-.39v.02z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M11.99 5.02c-1.3 0-2.57.42-3.61 1.21-.1.08-.19.18-.26.29-.07.11-.11.24-.13.37-.02.13 0 .26.03.39s.09.25.17.35a.978.978 0 001.05.35.88.88 0 00.35-.17 4.03 4.03 0 012.39-.79c.86 0 1.7.28 2.39.79.21.16.48.23.74.2s.5-.17.66-.38c.16-.21.23-.48.2-.74a.978.978 0 00-.38-.66 6.031 6.031 0 00-3.61-1.21h.01z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M14 14.55V10c0-1.1-.9-2-2-2s-2 .9-2 2v4.55c-1.19.69-2 1.97-2 3.45 0 2.21 1.79 4 4 4s4-1.79 4-4c0-1.48-.81-2.75-2-3.45zM12 20c-1.1 0-2-.9-2-2 0-.93.64-1.71 1.5-1.93V10.5c0-.28.22-.5.5-.5s.5.22.5.5v5.57c.86.22 1.5 1 1.5 1.93 0 1.1-.9 2-2 2z",
                fill: "currentColor"
            })
        ]
    });



const $8603c168c2a27fff$export$e32d2258b9b8a3d6 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M22 10.07a1.53 1.53 0 00-.48-.76L13.85 2.7a2.79 2.79 0 00-3.7 0L2.53 9.31A1.53 1.53 0 002.08 11c.098.29.283.54.53.72.242.187.535.295.84.31H4v7a3 3 0 003 3h10a3 3 0 003-3V12h.55a1.49 1.49 0 00.84-.31c.247-.18.432-.43.53-.72a1.54 1.54 0 00.08-.9zM12 19A1 1 0 1112 17 1 1 0 0112 19zm3.38-3.77a1 1 0 01-1.37.35 3.79 3.79 0 00-4 0 1 1 0 01-1-1.72 5.83 5.83 0 016.08 0 1 1 0 01.29 1.37zm2.45-3.15a1 1 0 01-1.39.27 8.09 8.09 0 00-8.88 0 1.002 1.002 0 01-1.12-1.66 10.15 10.15 0 0111.12 0 1 1 0 01.27 1.39z",
            fill: "currentColor"
        })
    });



const $04f7004aaa9f5cd3$export$35b7d12c405aafae = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 14H8a3 3 0 00-3 3v4a1 1 0 001 1h12a1 1 0 001-1v-4a3 3 0 00-3-3zm-.82-4.4a1 1 0 101.6-1.2 6 6 0 00-9.56 0 1 1 0 001.6 1.2 4 4 0 016.36 0zm4.26-4.27a10 10 0 00-14.88 0 1.002 1.002 0 001.49 1.34 8 8 0 0111.9 0 1 1 0 00.75.33 1 1 0 00.66-.26 1 1 0 00.08-1.41zM11 11a1 1 0 102 0 1 1 0 00-2 0z",
            fill: "currentColor"
        })
    });



const $ca1437d19748d10a$export$9591a6be05a4838d = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M8.82 14.39a4 4 0 010-4.78 1.002 1.002 0 10-1.59-1.22 6 6 0 000 7.22 1.002 1.002 0 001.59-1.22zM4 12a8 8 0 012.05-5.33A1 1 0 006.3 6a1 1 0 00-.3-.74 1 1 0 00-1.41.07 10 10 0 000 13.34 1.002 1.002 0 001.49-1.34A8 8 0 014 12zm7.43-3.11c.272.111.572.139.86.08a1.49 1.49 0 001.18-1.18c.059-.288.03-.588-.08-.86a1.55 1.55 0 00-.56-.68 1.5 1.5 0 10-1.4 2.64zm8-3.56A1 1 0 0018 6.67a8 8 0 010 10.66 1 1 0 00-.25.67 1 1 0 001.74.67 10 10 0 000-13.34h-.06zm-2.66 3.06a1.002 1.002 0 00-1.59 1.22 4 4 0 010 4.78 1.002 1.002 0 101.59 1.22 6 6 0 000-7.22zM14 16h-1v-4a1 1 0 00-1-1h-1a1 1 0 100 2v3h-1a1 1 0 100 2h4a1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $8e9a5351319dc939$export$34d8667ee9319c98 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M9 11h-.5v1H9a.5.5 0 000-1zm3.5 1.5a.5.5 0 101 0 .5.5 0 00-1 0zM12 2a10 10 0 100 20 10 10 0 000-20zM6.5 13.5a.5.5 0 01-1 0v-3a.5.5 0 011 0v3zM9 13h-.5v.5a.5.5 0 01-1 0v-3A.5.5 0 018 10h1a1.5 1.5 0 110 3zm5.5-.5a1.5 1.5 0 11-3 0V12a2 2 0 012-2h.5a.5.5 0 010 1h-.5a.578.578 0 00-.18 0 1.49 1.49 0 011.18 1.5zm3.95-1.78l-1.5 3a.5.5 0 01-.9-.44L17.19 11H16a.5.5 0 010-1h2a.52.52 0 01.43.24.51.51 0 01.02.48z",
            fill: "currentColor"
        })
    });



const $b16397601861a665$export$e3817388b1a16813 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 8a1 1 0 100 2 1 1 0 000-2zm3 10h-2v-2.08a7 7 0 10-2 0V18H9a3 3 0 00-3 3 1 1 0 001 1h10a1 1 0 001-1 3 3 0 00-3-3zM9 9a3 3 0 116 0 3 3 0 01-6 0z",
            fill: "currentColor"
        })
    });



const $2117b298d5e55bdf$export$352e10ee429dd73 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 10H6V9a1 1 0 011-1h6a2 2 0 000-4H7a5 5 0 00-5 5v6a1 1 0 001 1h19a6 6 0 00-6-6zM4 19a1 1 0 001 1h17v-2H4v1z",
            fill: "currentColor"
        })
    });



const $5004268b0ad8c7a5$export$7e4f27dc29c98c82 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 2H8a3 3 0 00-3 3v14a3 3 0 003 3h8a3 3 0 003-3V5a3 3 0 00-3-3zm0 7a1 1 0 01-1 1H9a1 1 0 01-1-1V7a1 1 0 011-1h6a1 1 0 011 1v2z",
            fill: "currentColor"
        })
    });



const $8347519f9efc8ffb$export$8a5f4809f4a5bee1 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M13 2h-2a4 4 0 00-4 4v12a4 4 0 004 4h2a4 4 0 004-4V6a4 4 0 00-4-4zm1 7a1 1 0 01-1 1h-2a1 1 0 01-1-1V7a1 1 0 011-1h2a1 1 0 011 1v2z",
            fill: "currentColor"
        })
    });



const $6886c8e288bedb16$export$8fb51bdf8697d2a3 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 3H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-3-3zm-6 14a1 1 0 110-2 1 1 0 010 2zm3.38-3.77a1 1 0 01-1.37.35 3.79 3.79 0 00-4 0 1 1 0 01-1-1.72 5.83 5.83 0 016.08 0 1 1 0 01.29 1.37zm2.45-3.15a1 1 0 01-1.39.27 8.09 8.09 0 00-8.88 0 1.002 1.002 0 01-1.12-1.66 10.15 10.15 0 0111.12 0 1 1 0 01.27 1.39z",
            fill: "currentColor"
        })
    });



const $0977166f072177b1$export$17c35d8f60b4f005 = (m)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...m,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 4H5a3 3 0 00-3 3v10a3 3 0 003 3h14a3 3 0 003-3V7a3 3 0 00-3-3zm-5 3a1 1 0 110 2 1 1 0 010-2zm-4 0a1 1 0 110 2 1 1 0 010-2zm0 4a1 1 0 110 2 1 1 0 010-2zm-4 6a1 1 0 110-2 1 1 0 010 2zm0-4a1 1 0 110-2 1 1 0 010 2zm0-4a1 1 0 110-2 1 1 0 010 2zm8 8h-4a1 1 0 010-2h4a1 1 0 010 2zm4 0a1 1 0 110-2 1 1 0 010 2zm1-5a1 1 0 01-1 1h-4a1 1 0 010-2h3V8a1 1 0 012 0v4z",
            fill: "currentColor"
        })
    });



const $7e5ca48bd43dbf0d$export$bf188e0c34a399fc = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.313 3H4.688C3.753 3 3 3.754 3 4.688v11.25c0 .933.754 1.687 1.688 1.687.933 0 1.687.754 1.687 1.688 0 .933.754 1.687 1.688 1.687h7.874c.934 0 1.688-.754 1.688-1.688 0-.933.754-1.687 1.688-1.687.933 0 1.687-.754 1.687-1.688V4.688C21 3.755 20.246 3 19.312 3zM8.624 10.875C8.625 11.494 8.119 12 7.5 12a1.128 1.128 0 01-1.125-1.125V7.5c0-.619.506-1.125 1.125-1.125s1.125.506 1.125 1.125v3.375zm4.489 0c0 .619-.507 1.125-1.125 1.125a1.128 1.128 0 01-1.125-1.125V7.5c0-.619.506-1.125 1.125-1.125.618 0 1.125.506 1.125 1.125v3.375zm4.511 0c0 .619-.506 1.125-1.125 1.125a1.128 1.128 0 01-1.125-1.125V7.5c0-.619.506-1.125 1.125-1.125s1.125.506 1.125 1.125v3.375z",
            fill: "currentColor"
        })
    });



const $e1304288381bed16$export$75d93211ace74892 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21 18h-2a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2H3a1 1 0 000 2h18a1 1 0 000-2zm-2.5-2h-13a.5.5 0 01-.5-.5v-9a.5.5 0 01.5-.5h13a.5.5 0 01.5.5v9a.5.5 0 01-.5.5z",
            fill: "currentColor"
        })
    });



const $220f5c566818c611$export$f06eea2c41e5d2dc = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 3H5a3 3 0 00-3 3v8a3 3 0 003 3h8v-7a4 4 0 014-4h3a3.91 3.91 0 012 .56V6a3 3 0 00-3-3zM3 19a1 1 0 000 2h10.56a3.91 3.91 0 01-.56-2H3zM20 8h-3a2 2 0 00-2 2v9a2 2 0 002 2h3a2 2 0 002-2v-9a2 2 0 00-2-2zm-1.5 11a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $31e7904d7b7a8871$export$83fe86fa23db6ca4 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M5 17h14a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v9a2 2 0 002 2zm16 1H3a1 1 0 000 2h18a1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $0001c067bfea972b$export$8388dc5ec6cf7f3f = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21 14h-1.02v-4H21c.55 0 1-.45 1-1s-.45-1-1-1h-1.15c-.36-1.15-1.5-2-2.87-2H6.99c-1.36 0-2.5.85-2.87 2H3c-.55 0-1 .45-1 1s.45 1 1 1h.99v1.01H3c-.55 0-1 .45-1 1s.45 1 1 1h.99V14H3c-.55 0-1 .45-1 1s.45 1 1 1h1.12c.36 1.15 1.5 2 2.87 2h9.99c1.36 0 2.5-.85 2.87-2H21c.55 0 1-.45 1-1s-.45-1-1-1z",
            fill: "currentColor"
        })
    });



const $9c70258d605f3f9c$export$5e3dbb9004d23295 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16.5 5.5a.5.5 0 01.5.5 1 1 0 002 0 2.5 2.5 0 00-2.5-2.5 1 1 0 100 2zM5 7a1 1 0 001-1 .5.5 0 01.5-.5 1 1 0 000-2A2.5 2.5 0 004 6a1 1 0 001 1zm14 1h-4a2 2 0 00-2 2v9a2 2 0 002 2h4a2 2 0 002-2v-9a2 2 0 00-2-2zm-2 11A1 1 0 1117 17 1 1 0 0117 19zM14.21 6.71a1.001 1.001 0 000-1.42l-.8-.79.8-.79a1.005 1.005 0 00-.71-1.714 1.004 1.004 0 00-.71.294l-.79.8-.79-.8a1.004 1.004 0 10-1.42 1.42l.8.79-.8.79a1 1 0 000 1.42 1 1 0 001.42 0l.79-.8.79.8a1.001 1.001 0 001.42 0zM9 8H5a2 2 0 00-2 2v9a2 2 0 002 2h4a2 2 0 002-2v-9a2 2 0 00-2-2zM7 19A1 1 0 117 17 1 1 0 017 19z",
            fill: "currentColor"
        })
    });



const $2d166d2ca323262b$export$e7933c908c5117af = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.73 7.34a1 1 0 00-.65-.34 9.7 9.7 0 01-3.17-.91.89.89 0 00-.82 0 9.59 9.59 0 01-3.15.91 1 1 0 00-.66.32A1.07 1.07 0 0012 8v2.5c0 3.38 3.38 5.5 4.5 5.5s4.5-2.12 4.5-5.49V8a1 1 0 00-.27-.66zM10 11.5V7a3 3 0 013-3h4.82A3 3 0 0015 2H9a3 3 0 00-3 3v14a3 3 0 003 3h6a3 3 0 003-3v-1.18a6.694 6.694 0 01-1.5.18 6.5 6.5 0 01-6.5-6.5zm2 8.5a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $8d489c1f14940e44$export$2e267f7b9595b3d0 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.12 4.88A3 3 0 0019 4H5a3 3 0 00-3 3v10a3 3 0 003 3h14a3 3 0 003-3V7a3 3 0 00-.88-2.12zM12 18a1 1 0 110-2 1 1 0 010 2zm5-8H7a1 1 0 010-2h10a1 1 0 110 2z",
            fill: "currentColor"
        })
    });



const $7d8f2b1b62de9d7a$export$36a23647e0f823a6 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 2h-5.76a3 3 0 00-2.12.88L5.88 5.12A3 3 0 005 7.24V19a3 3 0 003 3h8a3 3 0 003-3V5a3 3 0 00-3-3zm-3 5a1 1 0 01-2 0V5a1 1 0 012 0v2zm4 0a1 1 0 01-2 0V5a1 1 0 012 0v2z",
            fill: "currentColor"
        })
    });



const $84d63f8b37105234$export$cd43dc20dd6239ff = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 5H5a3 3 0 00-3 3v8a3 3 0 003 3v1a1 1 0 102 0v-1h10v1a1 1 0 002 0v-1a3 3 0 003-3V8a3 3 0 00-3-3zm-4 10a1 1 0 01-1 1H5a1 1 0 01-1-1V9a1 1 0 011-1h9a1 1 0 011 1v6zm3 0a1 1 0 110-2 1 1 0 010 2zm0-4a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $a56164b8fe058c22$export$baf7762211157f5c = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 6h1a3 3 0 00-3-3H6a3 3 0 00-3 3v12a3 3 0 003 3h6.56a3.91 3.91 0 01-.56-2v-9a4 4 0 014-4zm-6 13a1 1 0 110-2 1 1 0 010 2zm9-11h-3a2 2 0 00-2 2v9a2 2 0 002 2h3a2 2 0 002-2v-9a2 2 0 00-2-2zm-1.5 11a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $b824273ca0709ef4$export$8770930175692e21 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M6.67 8.05a8 8 0 0110.66 0 1 1 0 00.67.25 1 1 0 00.74-.3 1 1 0 00-.07-1.41 10 10 0 00-13.34 0 1 1 0 001.34 1.46zm1.72 1.18a1.002 1.002 0 001.22 1.59 4 4 0 014.78 0 1.002 1.002 0 001.22-1.59 6 6 0 00-7.22 0zm12.73 3.65A3 3 0 0019 12H5a3 3 0 00-3 3v2a3 3 0 003 3h14a3 3 0 003-3v-2a3 3 0 00-.88-2.12zM6.71 16.71a1 1 0 01-1.27.12.94.94 0 01-.36-.45A1 1 0 015 15.8a1 1 0 01.8-.8 1 1 0 01.58.06.94.94 0 01.45.36 1 1 0 01-.12 1.27v.02zM10 17a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $4dbd4591287c838c$export$de2a0c0c8f6156b = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a6 6 0 00-6 6v8a6 6 0 1012 0V8a6 6 0 00-6-6zm1 6a1 1 0 01-2 0V6a1 1 0 012 0v2z",
            fill: "currentColor"
        })
    });



const $d19bf62d44c45d40$export$a9070905ccbae99a = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M9.61 8.82a4 4 0 014.78 0 1.002 1.002 0 101.22-1.59 6 6 0 00-7.22 0 1.002 1.002 0 101.22 1.59zM15 10H9a3 3 0 00-3 3v6a3 3 0 003 3h6a3 3 0 003-3v-6a3 3 0 00-3-3zm-5 9a1 1 0 110-2 1 1 0 010 2zm0-4a1 1 0 110-2 1 1 0 010 2zm4 4a1 1 0 110-2 1 1 0 010 2zm0-4a1 1 0 110-2 1 1 0 010 2zm4.67-10.44a10 10 0 00-13.34 0 1.002 1.002 0 001.34 1.49 8 8 0 0110.66 0 1 1 0 00.67.25 1 1 0 00.74-.3.999.999 0 00-.07-1.44z",
            fill: "currentColor"
        })
    });



const $db77309ffe8ec70c$export$47674d74a1166ea = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 3H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-3-3zM6 12a1 1 0 110-2 1 1 0 010 2zm0-4a1 1 0 110-2 1 1 0 010 2zm5 11H9.5a.5.5 0 01-.5-.5v-13a.5.5 0 01.5-.5H11v14zm4 0h-2V5h2v14zm4-.5a.5.5 0 01-.5.5H17V5h1.5a.5.5 0 01.5.5v13z",
            fill: "currentColor"
        })
    });



const $c0e86971e4534258$export$796c5ecb9c01c361 = (v)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...v,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 15h-1v-2a2 2 0 00-2-2h-3V9h1a2 2 0 002-2V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2a2 2 0 002 2h1v2H8a2 2 0 00-2 2v2H5a2 2 0 00-2 2v2a2 2 0 002 2h4a2 2 0 002-2v-2a2 2 0 00-2-2H8v-2h8v2h-1a2 2 0 00-2 2v2a2 2 0 002 2h4a2 2 0 002-2v-2a2 2 0 00-2-2z",
            fill: "currentColor"
        })
    });



const $cb6b35e04d15337d$export$d78c6dc9fa8ce659 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15.94 8.47c.04-.153.06-.311.06-.47a2 2 0 00-2-2c-.159 0-.317.02-.47.06L9.77 2.29a1 1 0 00-1.42 0 8 8 0 00-1.69 8.86 2.94 2.94 0 00.42 4.13L5.31 20H5a1 1 0 000 2h8a1 1 0 100-2h-.54l-1.6-4.66a8 8 0 008.85-1.69 1 1 0 000-1.42l-3.77-3.76zM7.44 20L9 16l1.38 4H7.44zM14 4a4 4 0 014 4 1 1 0 002 0 6 6 0 00-6-6 1 1 0 100 2z",
            fill: "currentColor"
        })
    });



const $2694a584815fad89$export$be34765d7ae00c59 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 6H6a3 3 0 00-3-3 1 1 0 000 2 1 1 0 011 1v3H3a1 1 0 00-1 1v4a1 1 0 001 1h1v4a1 1 0 102 0v-1h4v1a1 1 0 002 0v-1h2v1a1 1 0 002 0v-1h2v1a1 1 0 002 0v-1.18A3 3 0 0022 15V9a3 3 0 00-3-3zm0 6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2a1 1 0 011-1h2a1 1 0 011 1v2z",
            fill: "currentColor"
        })
    });



const $6c6ef9fd3835b760$export$bd6c231cdc8259b = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4.785 3.29a1.004 1.004 0 10-1.42 1.42l5.88 5.88-5.29 5.29a3 3 0 104.24 4.24l5.29-5.29 5.88 5.88a.998.998 0 001.42 0 .997.997 0 00.219-1.095.998.998 0 00-.22-.325l-16-16zm17 0l-1-1a1 1 0 00-1.16-.18l-2 1a1 1 0 00-.5.57l-.92 2.78-2.72 2.71 1.42 1.42 2.71-2.72 2.78-.87a1 1 0 00.57-.5l1-2a1 1 0 00-.18-1.21z",
            fill: "currentColor"
        })
    });



const $e33368ab053ac7cd$export$c6b6bf3cac1131d2 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zM8 16.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zM12 9a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm4 7.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3z",
            fill: "currentColor"
        })
    });



const $cdf75d3c10d2f810$export$8ef49873bff7dfe1 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.71 3.29a.999.999 0 00-1.42 0l-2.46 2.47-.71-.71a3 3 0 00-4.24 0l-2 2a1 1 0 000 1.41l5.66 5.66a1 1 0 001.41 0l2-2a3 3 0 000-4.24l-.71-.71 2.47-2.46a.998.998 0 000-1.42zM8.46 9.88a1 1 0 00-1.41 0l-2 2a3 3 0 000 4.24l.71.71-2.47 2.46a1 1 0 000 1.42.998.998 0 001.42 0l2.46-2.47.71.71a3 3 0 004.24 0l2-2a1 1 0 000-1.41L8.46 9.88z",
            fill: "currentColor"
        })
    });



const $9ebc0c82e84bb37e$export$ef31b9fadfe9aa9b = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M8 12a1 1 0 001 1h6a1 1 0 000-2H9a1 1 0 00-1 1zm2 4H8a4 4 0 110-8h2a1 1 0 100-2H8a6 6 0 100 12h2a1 1 0 000-2zm6-10h-2a1 1 0 100 2h2a4 4 0 110 8h-2a1 1 0 000 2h2a6 6 0 100-12z",
            fill: "currentColor"
        })
    });



const $5a7b8f751a813184$export$64a430758b83acce = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 6H8a6 6 0 100 12h8a6 6 0 100-12zm0 7H8a1 1 0 010-2h8a1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $a3a6a375877bb2f0$export$31ffe04dc67a9721 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 3H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-3-3zm-6 13a4 4 0 110-8 4 4 0 010 8z",
            fill: "currentColor"
        })
    });



const $d6f8675d8c4c9ff2$export$343d9752eff88cee = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 5.28V5a3 3 0 00-6 0v.27A2 2 0 0012 7v4a2 2 0 002 2h4a2 2 0 002-2V7a2 2 0 00-1-1.72zM16 10a1 1 0 110-2 1 1 0 010 2zm-1-5a1 1 0 012 0h-2zm-5 6V6a5.93 5.93 0 011.54-4H9a3 3 0 00-3 3v14a3 3 0 003 3h6a3 3 0 003-3v-4h-4a4 4 0 01-4-4zm2 9a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $fe0208d83ebf5cde$export$7faa52daed8702d4 = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.852 4.662h.011a1.831 1.831 0 00-1.243-.671 17.656 17.656 0 01-6.127-1.804A1.678 1.678 0 0011.701 2c-.264 0-.55.055-.792.187a17.483 17.483 0 01-6.094 1.804 1.942 1.942 0 00-1.265.627A2.023 2.023 0 003 5.971v4.95C3 17.587 9.523 21.8 11.69 21.8s8.69-4.202 8.69-10.879v-4.95c0-.473-.198-.957-.528-1.309zm-5.918 6.754c.055-.187.154-.363.286-.506a.971.971 0 01.506-.286 1.12 1.12 0 01.572 0c.187.055.352.143.484.286.132.132.231.297.286.484.055.187.055.385 0 .572a1.286 1.286 0 01-.286.506 1.016 1.016 0 01-.506.286 1.12 1.12 0 01-.572 0 1.035 1.035 0 01-.484-.286 1.135 1.135 0 01-.286-.484 1.012 1.012 0 010-.572zM7.895 8.05c.099-.374.297-.726.572-1.001a2.232 2.232 0 011.001-.572 2.283 2.283 0 011.155 0c.363.099.693.297.968.561.264.264.462.605.561.968.11.374.11.781 0 1.155a2.232 2.232 0 01-.572 1.001 2.232 2.232 0 01-1.001.572 2.283 2.283 0 01-1.155 0 2.268 2.268 0 01-.968-.561 2.104 2.104 0 01-.561-.968 2.063 2.063 0 010-1.155zm9.141 8.085a.565.565 0 01-.407.165H7.136a.958.958 0 01-.682-.286.985.985 0 01-.286-.682c0-1.023.407-1.991 1.122-2.717a3.846 3.846 0 012.717-1.122c1.023 0 1.991.407 2.717 1.122.352.352.627.77.814 1.221.396-.275.858-.44 1.342-.44.616 0 1.199.242 1.639.682.44.44.682 1.023.682 1.639a.642.642 0 01-.165.418z",
            fill: "currentColor"
        })
    });



const $c63f113da2553e09$export$c3ce4360a0a07132 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 16a4 4 0 01-4-4v-1H2v6a3 3 0 003 3h14a3 3 0 003-3v-1.55a4 4 0 01-2 .55h-4zm-4-9a6 6 0 01.81-3H5a3 3 0 00-3 3v2h10V7zM5 8a1 1 0 110-2 1 1 0 010 2zm3 0a1 1 0 110-2 1 1 0 010 2zm13-1.72V6a3 3 0 00-6 0v.27A2 2 0 0014 8v4a2 2 0 002 2h4a2 2 0 002-2V8a2 2 0 00-1-1.72zM18 11a1 1 0 110-2 1 1 0 010 2zm-1-5a1 1 0 012 0h-2z",
            fill: "currentColor"
        })
    });



const $bb5b1bfe22244cf3$export$b66e5506c7c007f2 = (a)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M16.9 9.2h-.7V7.8c0-.74-.29-1.45-.82-1.98S14.14 5 13.4 5h-2.8c-.74 0-1.45.29-1.98.82S7.8 7.06 7.8 7.8v1.4h-.7a.65.65 0 00-.49.21.697.697 0 000 .98c.13.13.31.21.49.21h.7v5.6c0 .74.29 1.45.82 1.98s1.24.82 1.98.82h2.8c.74 0 1.45-.29 1.98-.82s.82-1.24.82-1.98v-5.6h.7c.19 0 .36-.07.49-.21a.697.697 0 000-.98.707.707 0 00-.49-.21zm-2.41 7.39c-.2.2-.46.31-.74.31h-3.5c-.28 0-.55-.11-.74-.31-.2-.2-.31-.46-.31-.74 0-.09.04-.18.1-.25.07-.07.15-.1.25-.1h4.9c.09 0 .18.04.25.1.07.07.1.15.1.25 0 .28-.11.55-.31.74zm.21-5.39c-.07.07-.15.1-.25.1h-4.9c-.09 0-.18-.04-.25-.1a.332.332 0 01-.1-.25c0-.65.26-1.27.72-1.73.46-.46 1.08-.72 1.73-.72h.7c.65 0 1.27.26 1.73.72.46.46.72 1.08.72 1.73 0 .09-.04.18-.1.25zM20.55 10.2a.622.622 0 00-.18-.14.795.795 0 00-.22-.06c-.08 0-.15 0-.23.03-.07.03-.14.07-.19.12-.06.05-.1.12-.13.19s-.04.15-.04.23c0 .14.05.28.14.38.75.84 1.16 1.92 1.16 3.04s-.41 2.2-1.16 3.04a.61.61 0 00-.15.41c0 .15.08.29.19.39.11.1.26.15.41.15.15 0 .29-.08.39-.19.94-1.05 1.45-2.4 1.45-3.8s-.51-2.75-1.44-3.79z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M19.02 11.94a.573.573 0 00-.8-.11.573.573 0 00-.11.8c.29.39.45.87.45 1.36 0 .49-.16.97-.45 1.36a.538.538 0 00-.11.42.573.573 0 00.42.48c.07.02.15.02.22.01.07 0 .15-.03.21-.07.06-.04.12-.09.17-.15.45-.59.69-1.32.69-2.06s-.24-1.44-.69-2.04zM3.13 14.01c0-1.12.42-2.21 1.17-3.05.09-.11.14-.24.14-.38 0-.08-.01-.16-.04-.23a.497.497 0 00-.13-.19.76.76 0 00-.19-.12c-.07-.03-.15-.04-.23-.03-.08 0-.15.02-.22.06-.07.03-.13.08-.18.14A5.686 5.686 0 002 14.01c0 1.4.52 2.76 1.45 3.8.1.11.24.18.39.19.15 0 .3-.04.41-.15.11-.1.18-.24.19-.39 0-.15-.04-.3-.15-.41a4.558 4.558 0 01-1.16-3.04z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M6 12.22a.573.573 0 00-.22-.38.572.572 0 00-.8.11c-.45.59-.69 1.32-.69 2.06s.24 1.46.69 2.06c.05.06.1.11.17.15.06.04.14.06.21.07.07 0 .15 0 .22-.01A.573.573 0 006 15.8c0-.07 0-.15-.01-.22a.538.538 0 00-.1-.2c-.29-.39-.45-.87-.45-1.36 0-.49.16-.97.45-1.36.09-.12.13-.29.11-.44z",
                fill: "currentColor"
            })
        ]
    });



const $9359c80fc21bc3f1$export$e062686843f52be3 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17.12 2.88A3 3 0 0015 2H9a3 3 0 00-3 3v14a3 3 0 003 3h6a3 3 0 003-3V5a3 3 0 00-.88-2.12zm-4.24 16.75A1.218 1.218 0 0112 20a1.25 1.25 0 01-1.15-.77 1.27 1.27 0 01-.08-.72 1.3 1.3 0 011-1 1.27 1.27 0 011.279.539 1.25 1.25 0 01.113 1.175 1.22 1.22 0 01-.282.406zm2.83-9.92l-3 3a1.002 1.002 0 01-1.42 0L10 11.41l-.29.3a1.004 1.004 0 11-1.42-1.42l1-1a1 1 0 011.42 0l1.29 1.3 2.29-2.3a1.004 1.004 0 011.42 1.42z",
            fill: "currentColor"
        })
    });



const $3f5dc7853cde16bc$export$be5dee3e0b3028d6 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 3h-6a3 3 0 00-3 3H7a1 1 0 00-1 1v1H4a1 1 0 000 2h2v2H4a1 1 0 000 2h2v1a1 1 0 001 1h2v2a3 3 0 003 3h6a3 3 0 003-3V6a3 3 0 00-3-3z",
            fill: "currentColor"
        })
    });



const $181f022e3ccf7b0e$export$cbbf5221fdf9ef8 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 3h-6a3 3 0 00-3 3H7a1 1 0 00-1 1v1H4a1 1 0 000 2h2v2H4a1 1 0 000 2h2v1a1 1 0 001 1h2v2a3 3 0 003 3h6a3 3 0 003-3V6a3 3 0 00-3-3zm-.2 9.6l-3 4a.999.999 0 11-1.6-1.2L15 13h-2a1 1 0 01-.89-.55 1 1 0 01.09-1l3-4a1 1 0 111.6 1.2L15 11h2a1 1 0 01.8 1.6z",
            fill: "currentColor"
        })
    });



const $80c5766f294c5fcd$export$921d3cbdc0caa5ca = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 3h-6a3 3 0 00-3 3H7a1 1 0 00-1 1v1H4a1 1 0 000 2h2v2H4a1 1 0 000 2h2v1a1 1 0 001 1h2v2a3 3 0 003 3h6a3 3 0 003-3V6a3 3 0 00-3-3zm-3 14a1 1 0 110-2 1 1 0 010 2zm2.86-3.92a1 1 0 01-1.37.35 2.81 2.81 0 00-3 0 1 1 0 11-1-1.72 4.82 4.82 0 015 0 1 1 0 01.37 1.37zM18.93 9a1 1 0 01-.93.62 1 1 0 01-.38-.07 6.89 6.89 0 00-5.24 0 1 1 0 01-.76-1.85 8.89 8.89 0 016.76 0 1 1 0 01.55 1.3z",
            fill: "currentColor"
        })
    });



const $ea9689aab5c07324$export$b9fc2309d1470c41 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zm5 12a3 3 0 01-3 3h-4a3 3 0 01-3-3v-4a1 1 0 011-1h1V7a1 1 0 012 0v2h2V7a1 1 0 012 0v2h1a1 1 0 011 1v4z",
            fill: "currentColor"
        })
    });



const $ddc6582c4026fd7a$export$35a5a84127a4a39f = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 3H5a2 2 0 00-2 2v10a2 2 0 002 2h1a2 2 0 002 2h1a2 2 0 002 2h2a2 2 0 002-2h1a2 2 0 002-2h1a2 2 0 002-2V5a2 2 0 00-2-2zm-4.2 8.6l-3 4a.999.999 0 11-1.6-1.2L12 12h-2a1 1 0 01-.89-.55 1 1 0 01.09-1l3-4a1 1 0 111.6 1.2L12 10h2a1 1 0 01.8 1.6z",
            fill: "currentColor"
        })
    });



const $7274bd34fd5f574d$export$2d0256828cc5937f = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 6a1.5 1.5 0 10-1.23-2.36l-13 2.94A3.49 3.49 0 003 10v8a3 3 0 003 3h12a3 3 0 003-3v-8a3 3 0 00-3-3h-5l6-1.37A1.46 1.46 0 0020 6zm-7 8a3 3 0 11-5.999 0A3 3 0 0113 14z",
            fill: "currentColor"
        })
    });



const $f7d478b29c7c8b94$export$8e89734eacb86bd = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M13.5 6h-3a.5.5 0 00-.5.5v11a.5.5 0 00.5.5h3a.5.5 0 00.5-.5v-11a.5.5 0 00-.5-.5zM19 9a1 1 0 100-2h-1V5h1a1 1 0 100-2h-1.78A3 3 0 0015 2H9a3 3 0 00-2.22 1H5a1 1 0 000 2h1v2H5a1 1 0 000 2h1v2H5a1 1 0 000 2h1v2H5a1 1 0 000 2h1v2H5a1 1 0 000 2h1.78A3 3 0 009 22h6a3 3 0 002.22-1H19a1 1 0 000-2h-1v-2h1a1 1 0 000-2h-1v-2h1a1 1 0 000-2h-1V9h1zm-3 10a1 1 0 01-1 1H9a1 1 0 01-1-1V5a1 1 0 011-1h6a1 1 0 011 1v14z",
            fill: "currentColor"
        })
    });



const $04a0c360d10eb9cc$export$fe4bb917a6f968b9 = (v)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...v,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17.5 10h-11a.5.5 0 00-.5.5v3a.5.5 0 00.5.5h11a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5zM21 6.78V5a1 1 0 00-2 0v1h-2V5a1 1 0 00-2 0v1h-2V5a1 1 0 00-2 0v1H9V5a1 1 0 00-2 0v1H5V5a1 1 0 00-2 0v1.78A3 3 0 002 9v6a3 3 0 001 2.22V19a1 1 0 102 0v-1h2v1a1 1 0 102 0v-1h2v1a1 1 0 002 0v-1h2v1a1 1 0 002 0v-1h2v1a1 1 0 002 0v-1.78A3 3 0 0022 15V9a3 3 0 00-1-2.22zM20 15a1 1 0 01-1 1H5a1 1 0 01-1-1V9a1 1 0 011-1h14a1 1 0 011 1v6z",
            fill: "currentColor"
        })
    });



const $f26647a0a648a1ee$export$592a2be57744d2cc = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7.23 13.36a1 1 0 001 .76h.24a1 1 0 00.74-1.2l-.66-2.75a1 1 0 00-1.24-.77l-2.75.66A1 1 0 105 12l.37-.08L2.3 17A2 2 0 004 20h4a1 1 0 100-2H4l3.13-5.08.1.44zm7.31-4.23L14 9a1.025 1.025 0 10-.45 2l2.75.64h.23a1 1 0 00.53-.15 1 1 0 00.44-.62l.64-2.76a1 1 0 10-1.95-.45l-.07.3L13.7 4a2 2 0 00-3.4 0L8.61 6.69a1 1 0 101.7 1.05L12 5l2.54 4.13zM21.7 17l-2.14-3.48a1 1 0 00-1.7 1L20 18h-5.59l.3-.29a1.004 1.004 0 10-1.42-1.42l-2 2a1.001 1.001 0 000 1.42l2 2a.997.997 0 001.095.219.999.999 0 00.325-.219 1 1 0 000-1.42l-.3-.29H20a2 2 0 001.7-3z",
            fill: "currentColor"
        })
    });



const $69bef117f5bd8adf$export$d4bd74a224d6ebcd = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18.67 4.56a10 10 0 00-13.34 0 1.002 1.002 0 001.34 1.49 8 8 0 0110.66 0 1 1 0 00.67.25 1 1 0 00.74-.3.999.999 0 00-.07-1.44zM9.61 8.82a4 4 0 014.78 0 1.002 1.002 0 101.22-1.59 6 6 0 00-7.22 0 1.002 1.002 0 101.22 1.59zM12 10a6 6 0 100 12.001 6 6 0 000-12zm0 8a2 2 0 110-3.999 2 2 0 010 4z",
            fill: "currentColor"
        })
    });



const $25283d26581c95ba$export$a2b03f6a33f4c816 = (v)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...v,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 12.88V12c.55 0 1-.45 1-1V7c0-.55-.45-1-1-1h-2V4c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v2H7c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1v.88c0 .58.44 1.03 1 1.1v.78c0 .53-.21 1.03-.59 1.41l-1.12 1.12a.996.996 0 00.71 1.7c.26 0 .51-.1.71-.29l1.12-1.12c.76-.76 1.17-1.76 1.17-2.83v-.76h1v6c0 .55.45 1 1 1s1-.45 1-1v-6h1v.76c0 1.07.42 2.07 1.17 2.83l1.12 1.12c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 000-1.41l-1.12-1.12c-.38-.38-.59-.88-.59-1.41v-.78c.56-.06 1-.52 1-1.1zM12 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1z",
            fill: "currentColor"
        })
    });



const $625e4a0bbaa8dfae$export$479f090f4ba12b6b = (m)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...m,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M14 2h-4a3 3 0 00-3 3v14a3 3 0 003 3h4a3 3 0 003-3V5a3 3 0 00-3-3zm-4 12a1 1 0 110-2 1 1 0 010 2zm0-4a1 1 0 110-2 1 1 0 010 2zm0-4a1 1 0 110-2 1 1 0 010 2zm4 8a1 1 0 110-2 1 1 0 010 2zm0-4a1 1 0 110-2 1 1 0 010 2zm0-4a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $8c42070b17f23ab0$export$d59a4c7b809548ae = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.71 2.29a.996.996 0 00-1.41 0l-18.01 18a.996.996 0 00.71 1.7c.26 0 .51-.1.71-.29L7 18.41V19c0 .8.32 1.56.88 2.12S9.21 22 10 22h4c.8 0 1.56-.32 2.12-.88S17 19.79 17 19V8.41l4.71-4.71a.996.996 0 000-1.41zm-7 11.42A.99.99 0 0114 14c-.2 0-.39-.06-.56-.17-.16-.11-.29-.27-.37-.45a.956.956 0 01-.06-.58c.04-.19.13-.37.27-.51s.32-.24.51-.27a1.014 1.014 0 011.2.99c0 .27-.11.52-.29.71l.01-.01zM9.44 9.83c-.16-.11-.29-.27-.37-.45a.956.956 0 01-.06-.58c.04-.19.13-.37.27-.51s.32-.24.51-.27a1.014 1.014 0 011.03.43c.08.12.12.25.14.39l2.86-2.86c-.14-.02-.27-.07-.39-.14-.16-.11-.29-.27-.37-.45a.956.956 0 01-.06-.58c.04-.19.13-.37.27-.51s.32-.24.51-.27a1.014 1.014 0 011.03.43c.08.12.12.25.14.39l1.51-1.51a3.13 3.13 0 00-.36-.44c-.56-.56-1.33-.88-2.12-.88h-4c-.8 0-1.56.32-2.12.88s-.88 1.33-.88 2.12v7.81L9.81 10c-.14-.02-.27-.07-.39-.14l.02-.03zM9.01 4.8c.04-.19.13-.37.27-.51s.32-.24.51-.27a1.014 1.014 0 011.2.99c0 .27-.11.52-.29.71a.99.99 0 01-.71.29A1.014 1.014 0 019 4.81l.01-.01z",
            fill: "currentColor"
        })
    });



const $87b1d923be5c76be$export$552ff3ad70213cdb = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17.12 2.88A3 3 0 0015 2H9a3 3 0 00-3 3v14a3 3 0 003 3h6a3 3 0 003-3V5a3 3 0 00-.88-2.12zM9 8h6l-3 1.83L9 8zm3.88 11.63A1.218 1.218 0 0112 20a1.25 1.25 0 01-1.15-.77 1.27 1.27 0 01-.08-.72 1.3 1.3 0 011-1 1.27 1.27 0 011.279.539 1.25 1.25 0 01.113 1.175 1.22 1.22 0 01-.282.406zM16 13a1 1 0 01-1 1H9a1 1 0 01-1-1V9.77l3.49 2.09a1 1 0 001 0L16 9.77V13z",
            fill: "currentColor"
        })
    });



const $c6d76a6d91c09044$export$47306750519a7ecf = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 15a1 1 0 100 2 1 1 0 000-2zm4.12-12.12A3 3 0 0014 2h-4a3 3 0 00-3 3v14a3 3 0 003 3h4a3 3 0 003-3V5a3 3 0 00-.88-2.12zM10 4a1 1 0 110 2 1 1 0 010-2zm0 4a1 1 0 110 2 1 1 0 010-2zm2 11a3 3 0 110-5.999A3 3 0 0112 19zm2-9a1 1 0 110-2 1 1 0 010 2zm0-4a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $d9c89994c7dda3e0$export$b41904a0915b3479 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M11.6 16h.8l-.4-1.08-.4 1.08zm4.52-13.12A3 3 0 0014 2h-4a3 3 0 00-3 3v14a3 3 0 003 3h4a3 3 0 003-3V5a3 3 0 00-.88-2.12zM9 4.8a1 1 0 01.8-.8 1 1 0 01.58.06.94.94 0 01.45.36 1 1 0 01-1.39 1.41.94.94 0 01-.36-.45A1 1 0 019 4.8zm.42 5a.94.94 0 01-.36-.45A1 1 0 019 8.8a1 1 0 01.8-.8 1 1 0 01.58.06.94.94 0 01.45.36 1 1 0 01-1.39 1.41l-.02-.03zm4.26 8.2c-.06.01-.12.01-.18 0a.51.51 0 01-.47-.32l-.25-.68h-1.56l-.25.68a.503.503 0 11-.94-.36l1.5-4a.52.52 0 01.94 0l1.5 4a.518.518 0 01-.29.68zm1-8.26a1 1 0 01-1.27.12.94.94 0 01-.36-.45A1 1 0 0113 8.8a1 1 0 01.8-.8 1 1 0 01.58.06.94.94 0 01.45.36 1 1 0 01-.12 1.27l-.03.05zm0-4a1 1 0 01-1.27.12.94.94 0 01-.36-.45A1 1 0 0113 4.8a1 1 0 01.8-.8 1 1 0 01.58.06.94.94 0 01.45.36 1 1 0 01-.12 1.27l-.03.05z",
            fill: "currentColor"
        })
    });



const $d3f5d2a482d0d922$export$743d1566f796c49d = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12.5 14H11v1h1.5a.5.5 0 000-1zm3.62-11.12A3 3 0 0014 2h-4a3 3 0 00-3 3v14a3 3 0 003 3h4a3 3 0 003-3V5a3 3 0 00-.88-2.12zM9 4.8a1 1 0 01.8-.8 1 1 0 01.58.06.94.94 0 01.45.36 1 1 0 01-1.39 1.41.94.94 0 01-.36-.45A1 1 0 019 4.8zm.42 5a.94.94 0 01-.36-.45A1 1 0 019 8.8a1 1 0 01.8-.8 1 1 0 01.58.06.94.94 0 01.45.36 1 1 0 01-1.39 1.41l-.02-.03zM14 16.5a1.5 1.5 0 01-1.5 1.5h-2a.5.5 0 01-.5-.5v-4a.5.5 0 01.5-.5h2a1.5 1.5 0 011.5 1.5c0 .37-.139.728-.39 1 .25.273.389.63.39 1zm.71-6.79a1 1 0 01-1.27.12.94.94 0 01-.36-.45A1 1 0 0113 8.8a1 1 0 01.8-.8 1 1 0 01.58.06.94.94 0 01.45.36 1 1 0 01-.12 1.27v.02zm0-4a1 1 0 01-1.27.12.94.94 0 01-.36-.45A1 1 0 0113 4.8a1 1 0 01.8-.8 1 1 0 01.58.06.94.94 0 01.45.36 1 1 0 01-.12 1.27v.02zM12.5 16H11v1h1.5a.5.5 0 000-1z",
            fill: "currentColor"
        })
    });



const $428a1cba26c30f89$export$b4b1cdf940c95bdf = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16.12 2.88A3 3 0 0014 2h-4a3 3 0 00-3 3v14a3 3 0 003 3h4a3 3 0 003-3V5a3 3 0 00-.88-2.12zM9 4.8a1 1 0 01.8-.8 1 1 0 01.58.06.94.94 0 01.45.36 1 1 0 01-1.39 1.41.94.94 0 01-.36-.45A1 1 0 019 4.8zm.42 5a.94.94 0 01-.36-.45A1 1 0 019 8.8a1 1 0 01.8-.8 1 1 0 01.58.06.94.94 0 01.45.36 1 1 0 01-1.39 1.41l-.02-.03zM14 16a2 2 0 01-4 0v-2.5a.5.5 0 011 0V16a1 1 0 002 0v-2.5a.5.5 0 011 0V16zm.71-6.29a1 1 0 01-1.27.12.94.94 0 01-.36-.45A1 1 0 0113 8.8a1 1 0 01.8-.8 1 1 0 01.58.06.94.94 0 01.45.36 1 1 0 01-.12 1.27v.02zm0-4a1 1 0 01-1.27.12.94.94 0 01-.36-.45A1 1 0 0113 4.8a1 1 0 01.8-.8 1 1 0 01.58.06.94.94 0 01.45.36 1 1 0 01-.12 1.27v.02z",
            fill: "currentColor"
        })
    });



const $e31f816f468883d6$export$5bc3c319c69ba117 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 2H8a3 3 0 00-3 3v3h14V5a3 3 0 00-3-3zm-4 4H8a1 1 0 010-2h4a1 1 0 110 2zm4 0a1 1 0 110-2 1 1 0 010 2zM5 18a2 2 0 002 2v1a1 1 0 102 0v-1h6v1a1 1 0 002 0v-1a2 2 0 002-2v-8H5v8z",
            fill: "currentColor"
        })
    });



const $a239266167876b70$export$ea1846a327a432be = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15 13a3 3 0 00-6 0 2 2 0 00-2 2v5a2 2 0 002 2h6a2 2 0 002-2v-5a2 2 0 00-2-2zm-3 5.5a1 1 0 110-2 1 1 0 010 2zM11 13a1 1 0 112 0h-2zm7.67-8.44a10 10 0 00-13.34 0 1.002 1.002 0 001.34 1.49 8 8 0 0110.66 0 1 1 0 00.67.25 1 1 0 00.74-.3.999.999 0 00-.07-1.44zM9.61 8.82a4 4 0 014.78 0 1.002 1.002 0 101.22-1.59 6 6 0 00-7.22 0 1.002 1.002 0 101.22 1.59z",
            fill: "currentColor"
        })
    });



const $22e7d3102305820e$export$b2544e09e12e1f23 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 4H4a2 2 0 00-2 2v9a2 2 0 002 2h7v2H9a1 1 0 000 2h6a1 1 0 000-2h-2v-2h7a2 2 0 002-2V6a2 2 0 00-2-2z",
            fill: "currentColor"
        })
    });



const $c773ab8f4e8bafde$export$8ef7bcb8326e8f36 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 2H9a3 3 0 00-3 3v5.59l-1.12 1.12A3 3 0 004 13.83V19a3 3 0 003 3h10a3 3 0 003-3V5a3 3 0 00-3-3zm-7 5a1 1 0 01-2 0V5a1 1 0 012 0v2zm4 0a1 1 0 01-2 0V5a1 1 0 012 0v2zm4 0a1 1 0 01-2 0V5a1 1 0 012 0v2z",
            fill: "currentColor"
        })
    });



const $eb7186b0d9726ea4$export$c7ba2cadc7467112 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17.64 8.34a8 8 0 00-10.1-1 8 8 0 00-1.21 12.3 7.91 7.91 0 004.1 2.19 8 8 0 007.21-13.5v.01zm-3.53 7.78a3 3 0 01-4.89-1 3 3 0 013.92-3.92 3 3 0 011 4.89l-.03.03zM12 13a1 1 0 100 2 1 1 0 000-2zM7.25 4.49c.095.1.211.175.34.22a.89.89 0 00.4.07.93.93 0 00.4-.09 10 10 0 017.28 0 1 1 0 00.36.07 1 1 0 00.63-.24.94.94 0 00.34-.58 1 1 0 00-.61-1.11 11.93 11.93 0 00-8.72 0 .89.89 0 00-.36.17.9.9 0 00-.25.33.9.9 0 00-.1.39 1 1 0 00.04.43c.06.129.145.244.25.34z",
            fill: "currentColor"
        })
    });



const $0a068399283a7549$export$65b3e0d1fec0fbf7 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.41 3.59A2 2 0 0019 3H5a2 2 0 000 4h14a2 2 0 001.41-3.41zM18 9H6a1 1 0 00-1 1v4a7 7 0 1014 0v-4a1 1 0 00-1-1zm-3.88 8.12A3 3 0 0112 18a3 3 0 01-.584-5.941A3 3 0 0115 15a3 3 0 01-.88 2.12zM12 14a1 1 0 100 2 1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $f85b1cf9a50fd05c$export$d2ec55a374e9b7ca = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18.67 4.56a10 10 0 00-13.34 0 1.002 1.002 0 001.34 1.49 8 8 0 0110.66 0 1 1 0 00.67.25 1 1 0 00.74-.3.999.999 0 00-.07-1.44zm-2.38 6.65a11.22 11.22 0 01-3.8-1.1 1.15 1.15 0 00-1 0c-1.184.59-2.464.963-3.78 1.1a1.22 1.22 0 00-.79.39 1.18 1.18 0 00-.33.81v3c0 4 4 6.59 5.39 6.59 1.39 0 5.39-2.55 5.39-6.59v-3a1.16 1.16 0 00-.32-.79 1.2 1.2 0 00-.76-.41zM9.61 8.82a4 4 0 014.78 0 1.002 1.002 0 101.22-1.59 6 6 0 00-7.22 0 1.002 1.002 0 101.22 1.59z",
            fill: "currentColor"
        })
    });



const $b252625a29743a31$export$27be1ec1e2331f7a = (c)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M5 14.73h2.21c.08 0 .15-.04.18-.11l1.27-2.55c.08-.17.33-.15.38.03l2 6.73c.06.19.32.2.39.01l3.45-9.73c.07-.19.34-.18.39.02l1.35 5.44c.02.09.11.16.2.16h2.17",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeMiterlimit: 10,
                strokeLinecap: "round"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M14.38 2.58c-.11-.08-.23-.14-.36-.18A10.01 10.01 0 002.07 8.34c-.1.25-.09.52.01.77.11.24.3.44.55.53.25.1.52.09.77-.01.24-.11.44-.3.53-.55a8.022 8.022 0 013.87-4.2 7.979 7.979 0 015.68-.55c.24.06.49.04.71-.07.12-.06.24-.14.33-.24.09-.1.16-.22.2-.35.04-.13.05-.26.04-.4-.01-.13-.06-.26-.12-.38a.942.942 0 00-.26-.3v-.01z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8.26 5.79a5.938 5.938 0 00-2.69 2.69c-.06.12-.09.25-.1.38 0 .13 0 .26.05.39a1.034 1.034 0 00.51.58c.24.12.51.13.77.05a1.034 1.034 0 00.58-.51C7.77 8.6 8.4 7.98 9.17 7.6c.77-.38 1.65-.51 2.49-.35a.994.994 0 001.17-.79.994.994 0 00-.79-1.17c-1.28-.24-2.6-.05-3.77.53l-.01-.03z",
                fill: "currentColor"
            })
        ]
    });



const $62ba47d601e934d6$export$e30dd4db64408778 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M6 11h12a4 4 0 100-8H6a4 4 0 000 8zm0-5.5a1.5 1.5 0 110 3 1.5 1.5 0 010-3zM18 13H6a4 4 0 100 8h12a4 4 0 100-8zM6 18.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3z",
            fill: "currentColor"
        })
    });



const $042aab31c203d077$export$1d4392acde97be65 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 9a2 2 0 00-1.75 1.05A.94.94 0 0016 11a2 2 0 000 4h4a2 2 0 001-3.74c.01-.086.01-.174 0-.26a2 2 0 00-2-2zM5.5 11h6.59A6 6 0 0118 6h3.65a3.49 3.49 0 00-3.15-2h-13a3.5 3.5 0 100 7zm4-4.5a1 1 0 110 2 1 1 0 010-2zm-4 0a1 1 0 110 2 1 1 0 010-2zm6.59 6.5H5.5a3.5 3.5 0 100 7h13a3.49 3.49 0 003.15-2H18a6 6 0 01-5.91-5zM5.5 17.5a1 1 0 110-2 1 1 0 010 2zm4 0a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $5f7d20f0dc1f80ad$export$8dae4f515820f9d0 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M5.5 11h6.59A6 6 0 0118 6h3.65a3.49 3.49 0 00-3.15-2h-13a3.5 3.5 0 100 7zm4-4.5a1 1 0 110 2 1 1 0 010-2zm-4 0a1 1 0 110 2 1 1 0 010-2zm6.59 6.5H5.5a3.5 3.5 0 100 7h13a3.49 3.49 0 003.15-2H18a6 6 0 01-5.91-5zM5.5 17.5a1 1 0 110-2 1 1 0 010 2zm4 0a1 1 0 110-2 1 1 0 010 2zm12.21-6.21l-3-3a1 1 0 00-1.42 0l-3 3a.999.999 0 00-.21 1.09A1 1 0 0015 13v2a1 1 0 001 1h4a1 1 0 001-1v-2a1 1 0 00.92-.62 1 1 0 00-.21-1.09z",
            fill: "currentColor"
        })
    });



const $6640e1438e89041b$export$c09772b814367fd4 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 13h-1.86a4 4 0 100-2H16a1 1 0 010 2zm-3.91 0H5.5a3.5 3.5 0 100 7h13a3.49 3.49 0 003.15-2H18a6 6 0 01-5.91-5zM5.5 17.5a1 1 0 110-2 1 1 0 010 2zm4 0a1 1 0 110-2 1 1 0 010 2zm-4-6.5h6.59A6 6 0 0118 6h3.65a3.49 3.49 0 00-3.15-2h-13a3.5 3.5 0 100 7zm4-4.5a1 1 0 110 2 1 1 0 010-2zm-4 0a1 1 0 110 2 1 1 0 010-2z",
            fill: "currentColor"
        })
    });



const $1f9902f2a3681fbb$export$44fed703a44a249e = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.5 13a1.46 1.46 0 00-.55.11L17.74 12 20 10.89c.174.072.361.11.55.11a1.5 1.5 0 10-1.44-1.9l-3 1.51a1.46 1.46 0 00-.55-.11 1.5 1.5 0 100 3c.189 0 .375-.038.55-.11l3 1.51A1.5 1.5 0 1020.5 13zm-15-2h6.59A6 6 0 0118 6h3.65a3.49 3.49 0 00-3.15-2h-13a3.5 3.5 0 100 7zm4-4.5a1 1 0 110 2 1 1 0 010-2zm-4 0a1 1 0 110 2 1 1 0 010-2zm6.59 6.5H5.5a3.5 3.5 0 100 7h13a3.49 3.49 0 003.15-2H18a6 6 0 01-5.91-5zM5.5 17.5a1 1 0 110-2 1 1 0 010 2zm4 0a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $2fa0bcf09b9ceb07$export$4fd64f45cddc7ecf = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.23 12.77a1 1 0 00-.45-1.34l-.4-.18a3.942 3.942 0 00-3.17.18 1.002 1.002 0 10.9 1.79 1.86 1.86 0 011.56-.09c.076.024.15.054.22.09a1 1 0 00.45.11 1 1 0 00.89-.56zM18 14a1 1 0 100 2 1 1 0 000-2zM5.5 11h6.59A6 6 0 0118 6h3.65a3.49 3.49 0 00-3.15-2h-13a3.5 3.5 0 100 7zm4-4.5a1 1 0 110 2 1 1 0 010-2zm-4 0a1 1 0 110 2 1 1 0 010-2zm6.59 6.5H5.5a3.5 3.5 0 100 7h13a3.49 3.49 0 003.15-2H18a6 6 0 01-5.91-5zM5.5 17.5a1 1 0 110-2 1 1 0 010 2zm4 0a1 1 0 110-2 1 1 0 010 2zm12.08-7.41a1 1 0 00-.45-1.35 7 7 0 00-6.26 0 1.001 1.001 0 10.9 1.79 5 5 0 014.46 0 1 1 0 001.35-.44z",
            fill: "currentColor"
        })
    });



const $e0754c2a97f2e24f$export$4bae3e272efef126 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.12 8.88C20.56 8.32 19.8 8 19 8H5c-.8 0-1.56.32-2.12.88S2 10.21 2 11v2c0 .8.32 1.56.88 2.12.32.32.7.55 1.12.7v.68c0 .28.23.5.5.5h.99c.28 0 .5-.23.5-.5v-.49h12v.49c0 .28.23.5.5.5h.99c.28 0 .5-.23.5-.5v-.68c.42-.15.8-.38 1.12-.7.56-.56.88-1.33.88-2.12v-2c0-.8-.32-1.56-.88-2.12h.02zm-8.41 3.83A.99.99 0 0112 13c-.2 0-.39-.06-.56-.17-.16-.11-.29-.27-.37-.45a.956.956 0 01-.06-.58c.04-.19.13-.37.27-.51s.32-.23.51-.27a1.014 1.014 0 011.2.99c0 .27-.11.52-.29.71l.01-.01z",
            fill: "currentColor"
        })
    });



const $8f680a42280b15c3$export$c21c2fc721cb19ce = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 7a1 1 0 001-1V4a1 1 0 00-2 0v2a1 1 0 001 1zm4.74 1.26a1 1 0 00.71-.3l1.41-1.41a1 1 0 10-1.41-1.41L16 6.55A1 1 0 0016 8a1 1 0 00.74.26zM6.55 8a1 1 0 00.71.3A1 1 0 008 8a1 1 0 000-1.45L6.55 5.14a1 1 0 00-1.41 1.41L6.55 8zm.65 7.42a1 1 0 001 1.12h7.62a1 1 0 001-1.12l-.7-5.63a2 2 0 00-2-1.75H9.88a2 2 0 00-2 1.75l-.68 5.63zM20 11h-2a1 1 0 000 2h2a1 1 0 000-2zm-3.63 6.5H7.63A1.58 1.58 0 006 19v1a1 1 0 001 1h10a1 1 0 001-1v-1a1.58 1.58 0 00-1.63-1.5zM7 12a1 1 0 00-1-1H4a1 1 0 000 2h2a1 1 0 001-1z",
            fill: "currentColor"
        })
    });



const $9078981abaf6672a$export$1b01c20b680068ca = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M11.88 2A7.1 7.1 0 005 8.74a7 7 0 002.85 5.89A2.9 2.9 0 019 17a1 1 0 001 1h4a1 1 0 001-1 2.858 2.858 0 011.13-2.34A7 7 0 0011.88 2zm3 10.07a1 1 0 01-1.37.35 2.85 2.85 0 00-3 0 1 1 0 01-1-1.72 5 5 0 015 0 1 1 0 01.35 1.37h.02zm1.14-3A.9.9 0 0115.5 9a7.05 7.05 0 00-7 0 1 1 0 01-1-1.72 9 9 0 019 0 1 1 0 01-.5 1.81l.02-.02zM14 20h-4a1 1 0 000 2h4a1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $2562076394bc4aee$export$6658134dc022a94 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M14 20h-4a1 1 0 000 2h4a1 1 0 000-2zM11.88 2A7.1 7.1 0 005 8.74a7 7 0 002.85 5.89A2.9 2.9 0 019 17a1 1 0 001 1h4a1 1 0 001-1 2.858 2.858 0 011.13-2.34A7 7 0 0011.88 2zm2.83 9.71l-2 2A1.001 1.001 0 0112 14a.84.84 0 01-.38-.08A1 1 0 0111 13V8.41l-.29.3a1.004 1.004 0 01-1.42-1.42l2-2a1 1 0 011.09-.21A1 1 0 0113 6v4.59l.29-.3a1.004 1.004 0 011.42 1.42z",
            fill: "currentColor"
        })
    });



const $ee2b7908c52972a9$export$a1857d067a7b8dc5 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M14 20h-4a1 1 0 000 2h4a1 1 0 000-2zM11.88 2A7.1 7.1 0 005 8.74a7 7 0 002.85 5.89A2.9 2.9 0 019 17a1 1 0 001 1h4a1 1 0 001-1 2.858 2.858 0 011.13-2.34A7 7 0 0011.88 2zM10 11a1 1 0 110-2.002A1 1 0 0110 11zm2-3a1 1 0 110-2 1 1 0 010 2zm2 3a1 1 0 110-2.001 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $f3c408b1d6cb4a50$export$f3f61c44e0fdb6d7 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 4a7.92 7.92 0 014.9 1.69l1.42-1.43a10 10 0 00-12.64 0L7.1 5.69A7.92 7.92 0 0112 4zm0 2a6 6 0 100 12 6 6 0 000-12zm1 5a1 1 0 01-2 0V9a1 1 0 112 0v2zm-9 1a7.92 7.92 0 011.69-4.9L4.26 5.68a10 10 0 000 12.64l1.43-1.42A7.92 7.92 0 014 12zm15.74-6.32L18.31 7.1a7.95 7.95 0 010 9.8l1.43 1.42a10 10 0 000-12.64zM12 20a7.92 7.92 0 01-4.9-1.69l-1.42 1.43a10 10 0 0012.64 0l-1.42-1.43A7.92 7.92 0 0112 20z",
            fill: "currentColor"
        })
    });



const $6d09cd4923370ce2$export$43a804d103d45c70 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 8h-4V6a3 3 0 00-3-3H6a3 3 0 00-3 3v12a3 3 0 003 3h6a3 3 0 003-3v-6h4a2 2 0 000-4zM9 12h3.44a4 4 0 110-4H9a2 2 0 100 4z",
            fill: "currentColor"
        })
    });



const $ec57af836098e5e9$export$a0d47a08cf5eec5b = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M5 19a3 3 0 003 3h8a3 3 0 003-3v-7H5v7zm2-4a1 1 0 112 0v4a1 1 0 11-2 0v-4zm9-13H8a3 3 0 00-3 3v5h14V5a3 3 0 00-3-3zM9 7a1 1 0 01-2 0V5a1 1 0 012 0v2z",
            fill: "currentColor"
        })
    });



const $3e63f1240e3cbec8$export$10ceeee301caa196 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 4a8 8 0 017.93 7h2a10 10 0 00-19.9 0h2A8 8 0 0112 4zm6 8.21a6.15 6.15 0 00-5.21-6.16A5.289 5.289 0 0012 6a5.29 5.29 0 00-.79 0A6.15 6.15 0 006 12.21a.79.79 0 01-.79.79H2.05A10 10 0 0022 13h-3.21a.79.79 0 01-.79-.79zM8 19a1 1 0 110-2.001 1 1 0 010 2zm4 1a1 1 0 110-2.002A1 1 0 0112 20zm2-7h-4a1 1 0 010-2h4a1 1 0 110 2zm2 6a1 1 0 110-2.002A1 1 0 0116 19z",
            fill: "currentColor"
        })
    });



const $0a1eb45173bd65e4$export$57c803999fedef22 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 3H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-3-3zm-9 9a1 1 0 11-2 0V8a1 1 0 012 0v4zm3 6a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm5-6a1 1 0 01-2 0V8a1 1 0 012 0v4z",
            fill: "currentColor"
        })
    });



const $4452c397fb5106d4$export$93d158e65e561efa = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 6h-1V3a1 1 0 00-2 0v3H9V3a1 1 0 00-2 0v3H6a2 2 0 00-2 2v10a4 4 0 004 4h8a4 4 0 004-4V8a2 2 0 00-2-2zm-6 11a3 3 0 110-5.999A3 3 0 0112 17z",
            fill: "currentColor"
        })
    });



const $8cdec3e2949f6402$export$a9e2a7036cd7714d = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 6h-3v12h3a6 6 0 100-12zm2 7a1 1 0 01-2 0v-2a1 1 0 012 0v2zM2 12a6 6 0 006 6h3V6H8a6 6 0 00-6 6zm6.5 0a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z",
            fill: "currentColor"
        })
    });



const $12e4afcbc106f85c$export$527b7d6e96e444c0 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15 19H9a1 1 0 00-.89 1.45l.5 1a1 1 0 00.89.55h5a1 1 0 00.89-.55l.5-1A1 1 0 0015 19zM9 5h6a1 1 0 00.89-1.45l-.5-1A1 1 0 0014.5 2h-5a1 1 0 00-.89.55l-.5 1A1 1 0 009 5zm6 1H9a3 3 0 00-3 3v6a3 3 0 003 3h6a3 3 0 003-3V9a3 3 0 00-3-3zm-1.5 6.5a1 1 0 01-1 1h-2a1 1 0 010-2h1v-2a1 1 0 012 0v3z",
            fill: "currentColor"
        })
    });



const $ca064246b92abb4d$export$b327a08fb57f8ee5 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15.61 16.77a1.002 1.002 0 00-1.22-1.59 4 4 0 01-4.78 0 1.002 1.002 0 10-1.22 1.59 5.91 5.91 0 007.22 0zM17.33 18a8 8 0 01-10.66 0 1.002 1.002 0 00-1.34 1.49 10 10 0 0013.34 0A1.002 1.002 0 0017.33 18zm2.43-15.6A1.002 1.002 0 0019 2H5a1 1 0 00-.76.35 1 1 0 00-.24.81l.86 5.17a2 2 0 002 1.67h.43l.54 1.63A2 2 0 009.72 13h4.56a2 2 0 001.9-1.37l.54-1.63h.43a2 2 0 002-1.67L20 3.16a1.001 1.001 0 00-.24-.81v.05z",
            fill: "currentColor"
        })
    });



const $477a19c5f1a845b4$export$7bd7c7df29fdcdc0 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 9a3 3 0 100 6 3 3 0 000-6zm0-7a10 10 0 100 20 10 10 0 000-20zm0 18a8 8 0 110-16.001A8 8 0 0112 20z",
            fill: "currentColor"
        })
    });



const $18e06209cb708f3d$export$a7336b9a0abe572b = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zm0 13a3 3 0 110-5.999A3 3 0 0112 15z",
            fill: "currentColor"
        })
    });



const $d957f7a575409d6d$export$48ef124f61ed84c2 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 2H7a3 3 0 00-3 3v14a3 3 0 003 3h10a3 3 0 003-3V5a3 3 0 00-3-3zm-5 2a2 2 0 110 4 2 2 0 010-4zm0 16a5 5 0 110-9.999A5 5 0 0112 20zm0-8a3 3 0 100 5.999A3 3 0 0012 12z",
            fill: "currentColor"
        })
    });



const $f248df517e9a48fc$export$d48704f86d01158c = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 4H5a3 3 0 00-3 3v10a3 3 0 003 3h14a3 3 0 003-3V7a3 3 0 00-3-3zM8 15a1 1 0 11-2 0V9a1 1 0 012 0v6zm10 0a1 1 0 01-2 0V9a1 1 0 012 0v6z",
            fill: "currentColor"
        })
    });



const $6323dbf4612c041a$export$87be7169cbe2aabf = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 2H7a3 3 0 00-3 3v14a3 3 0 003 3h10a3 3 0 003-3V5a3 3 0 00-3-3zm-5 18a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $2fc7226fabfda3f6$export$414d423c8bb601e9 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16.82 13.9a6.608 6.608 0 001.75-5l-.43-6a1 1 0 00-1-.93h-2l-2 1.64.86 1.67a.51.51 0 01-.17.64l-3 2a.57.57 0 01-.33.08.51.51 0 01-.39-.18.5.5 0 010-.67l1.65-1.66-1.64-1.6a.51.51 0 01-.12-.37.48.48 0 01.16-.35L11.39 2H6.86a1 1 0 00-1 .93l-.43 6a6.56 6.56 0 005.57 7V20H9a1 1 0 000 2h6a1 1 0 100-2h-2v-4.09a6.55 6.55 0 003.82-2.01z",
            fill: "currentColor"
        })
    });



const $e7b27975f80babed$export$b777722ef5c1e06d = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 3H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-3-3zM9.71 9.71l-2 2a1 1 0 01-1.639-.325 1 1 0 01.219-1.095L7.59 9l-1.3-1.29a1.004 1.004 0 011.42-1.42l2 2a1 1 0 010 1.42zM17 12h-4a1 1 0 010-2h4a1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $d77409ad1d6b51de$export$34e65c1ae2783268 = (a)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 15a3 3 0 100-6 3 3 0 000 6zM5 19.99c-.26 0-.51-.1-.71-.29a.996.996 0 010-1.41l3-3A.996.996 0 118.7 16.7l-3 3c-.2.2-.45.29-.71.29H5zM16.03 8.96c-.26 0-.51-.1-.71-.29a.996.996 0 010-1.41l3-3a.996.996 0 111.41 1.41l-3 3c-.2.2-.45.29-.71.29h.01zM2.04 12.35c-.04-.13-.06-.27-.04-.4.21-2.52 1.33-4.93 3.16-6.76s4.24-2.96 6.76-3.16c.27-.02.54.07.73.24.2.18.31.43.32.7 0 .27-.09.54-.28.75-.19.21-.45.34-.72.36a8.72 8.72 0 00-5.4 2.53 8.696 8.696 0 00-2.53 5.4c-.02.25-.14.49-.32.67-.1.1-.22.19-.35.25-.13.06-.27.09-.41.09-.14 0-.27-.03-.4-.08a.94.94 0 01-.52-.58v-.01z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M7.28 7.31c.97-.97 2.21-1.61 3.54-1.83.13-.02.27-.02.4.02.13.03.25.09.35.17.1.08.19.18.26.29.06.12.1.24.12.38.03.27-.05.54-.22.76-.08.11-.19.2-.31.27s-.25.12-.38.14c-.88.15-1.7.58-2.34 1.22-.64.64-1.07 1.46-1.22 2.34-.04.27-.19.52-.41.69-.22.17-.5.25-.76.22a.95.95 0 01-.85-1.12c.22-1.33.86-2.57 1.83-3.54l-.01-.01zM12.33 21.98c.13.03.27.04.41.02 2.5-.36 4.83-1.63 6.55-3.57 1.72-1.94 2.69-4.41 2.73-6.94 0-.27-.1-.53-.29-.72a.964.964 0 00-.72-.28c-.27 0-.53.13-.73.33-.2.2-.31.47-.31.74-.04 2.02-.82 3.99-2.19 5.54-1.37 1.55-3.23 2.57-5.23 2.86-.25.04-.48.17-.65.36-.1.11-.17.23-.22.36-.05.13-.07.28-.07.42 0 .14.05.27.11.39s.15.23.25.31c.1.08.23.14.36.18z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M17.03 16.44a6.52 6.52 0 001.61-3.64c.01-.14 0-.27-.04-.4a.879.879 0 00-.19-.34c-.09-.1-.19-.18-.31-.24a1.02 1.02 0 00-.38-.1 1.101 1.101 0 00-1 .59c-.06.12-.1.26-.11.39-.1.88-.47 1.73-1.07 2.41-.6.68-1.39 1.16-2.26 1.36-.27.06-.51.22-.66.45-.16.23-.22.51-.18.78a.979.979 0 001.18.79c1.31-.3 2.51-1.02 3.41-2.05z",
                fill: "currentColor"
            })
        ]
    });



const $55d3532e4f3b3024$export$88f47e9904747179 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15 19H9a1 1 0 000 2h6a1 1 0 000-2zm5-14H4a2 2 0 00-2 2v9a2 2 0 002 2h16a2 2 0 002-2V7a2 2 0 00-2-2z",
            fill: "currentColor"
        })
    });



const $03c25f07b928d408$export$ab68d0ae3fda9e01 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15 19H9a1 1 0 000 2h6a1 1 0 000-2zm6.41-13.41A2 2 0 0020 5H4a2 2 0 00-2 2v9a2 2 0 002 2h16a2 2 0 002-2V7a2 2 0 00-.59-1.41zM17.5 13a.77.77 0 01-.37.65.77.77 0 01-.74.01L15 12.9v.1a1.5 1.5 0 01-1.5 1.5h-5A1.5 1.5 0 017 13v-3a1.5 1.5 0 011.5-1.5h5A1.5 1.5 0 0115 10v.1l1.39-.76a.75.75 0 01.74 0 .77.77 0 01.37.65V13z",
            fill: "currentColor"
        })
    });



const $0ea259459b52d7f7$export$e2dbcd480b3b99ea = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 7a1 1 0 100-2 1 1 0 000 2zm8-2h-5v1a3 3 0 01-3 3 3.11 3.11 0 01-1.67-.5A3 3 0 019 6V5H4a2 2 0 00-2 2v9a2 2 0 002 2h16a2 2 0 002-2V7a2 2 0 00-2-2zm-5 14H9a1 1 0 000 2h6a1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $e4639d0fed06a8f6$export$2d74004ca6205d68 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 5H4a2 2 0 00-2 2v9a2 2 0 002 2h16a2 2 0 002-2V7a2 2 0 00-2-2zm0 6a1 1 0 01-2 0v-.59l-2.29 2.3a1.002 1.002 0 01-1.639-.325 1 1 0 01.219-1.095L16.59 9H16a1 1 0 110-2h3a1 1 0 01.38.08 1 1 0 01.54.54c.051.12.078.25.08.38v3zm-5 8H9a1 1 0 000 2h6a1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $fc3fd7ec62156245$export$d9f70a0432dc5654 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15 19H9a1 1 0 000 2h6a1 1 0 000-2zm5-14H4a2 2 0 00-2 2v9a2 2 0 002 2h16a2 2 0 002-2V7a2 2 0 00-2-2zm-5.45 7.33l-3 2A1 1 0 0110 13.5v-4a1 1 0 01.53-.88 1 1 0 011 .05l3 2a1 1 0 010 1.66h.02z",
            fill: "currentColor"
        })
    });



const $4489629692ad8ee4$export$6257e38ba4fc5b96 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15 19H9a1 1 0 000 2h6a1 1 0 000-2zm6.41-13.41A2 2 0 0020 5H4a2 2 0 00-2 2v9a2 2 0 002 2h16a2 2 0 002-2V7a2 2 0 00-.59-1.41zm-1.7 5.12A1 1 0 0119 11h-1v1a1 1 0 01-2 0v-1h-1a1 1 0 010-2h1V8a1 1 0 012 0v1h1a1 1 0 01.71 1.71z",
            fill: "currentColor"
        })
    });



const $080d48be539290c0$export$e96b39092b457159 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M13.71 13.29a1 1 0 00-1.42 0l-.91.92-1.59-1.59.92-.91a1.004 1.004 0 00-1.42-1.42l-.91.92-.62-.62a1.001 1.001 0 00-1.42 0l-1.29 1.29a3 3 0 000 4.24l.71.71-2.47 2.46a1 1 0 000 1.42.998.998 0 001.42 0l2.46-2.47.71.71a3 3 0 004.24 0l1.29-1.29a.997.997 0 00.219-1.095.998.998 0 00-.22-.325l-.62-.62.92-.91a.997.997 0 00.22-1.095.998.998 0 00-.22-.325zm7-10a.999.999 0 00-1.42 0l-2.46 2.47-.71-.71a3 3 0 00-4.24 0l-1.29 1.29a1 1 0 000 1.42l5.65 5.65a.998.998 0 001.42 0L19 12.12a3 3 0 000-4.24l-.71-.71 2.47-2.46a1 1 0 00-.05-1.42z",
            fill: "currentColor"
        })
    });



const $8471df078445ee73$export$fe721d73312c1b5c = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 6h-2a1 1 0 00-1 1v2a1 1 0 001 1c0 .9-.77 1.4-2 2.14-.31.19-.64.39-1 .6V6h.25a1 1 0 00.85-1.53l-1.25-2a1 1 0 00-1.7 0l-1.25 2A1 1 0 0010.75 6H11v8.06l-.75-.39c-1.19-.6-1.94-1-2.17-2a2 2 0 10-2 .08c.32 2.19 2 3.06 3.28 3.69.496.214.958.5 1.37.85a3 3 0 102.27-.1v-.28c0-.83.75-1.32 2-2 1.25-.68 3-1.79 3-3.87a1 1 0 001-1V7a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $5ccfae736caabd12$export$1614765182b632dc = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 17h-1.28A2 2 0 0016 16h-2a2 2 0 00-2 2H8.5a2.5 2.5 0 010-5h7a4.5 4.5 0 100-9H12a2 2 0 00-2-2H8a2 2 0 00-1.72 1H5a1 1 0 00-1 1v2a1 1 0 001 1h1.28A2 2 0 008 8h2a2 2 0 002-2h3.5a2.5 2.5 0 010 5h-7a4.5 4.5 0 100 9H12a2 2 0 002 2h2a2 2 0 001.72-1H19a1 1 0 001-1v-2a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $ea2627123efd6288$export$8b3e69a0452e3340 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M8 8h8a1 1 0 001-1V3a1 1 0 00-1-1H8a1 1 0 00-1 1v4a1 1 0 001 1zm5-3.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1zm-4 0a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1zm9 5.5H6a1 1 0 00-1 1v4a7 7 0 1014 0v-4a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $4c65236c5c8beffe$export$5e665bb8f50e61f4 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 8h-1V3a1 1 0 00-1-1H8a1 1 0 00-1 1v5H6a1 1 0 00-1 1v10a3 3 0 003 3h8a3 3 0 003-3V9a1 1 0 00-1-1zm-7-2.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1zm4 0a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1z",
            fill: "currentColor"
        })
    });



const $e090b03e9049ecc9$export$897ed5cd1443a9c9 = (a)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4.92 5.97c.1.1.22.17.36.23.13.05.28.08.42.07.26 0 .51-.09.7-.25C7.94 4.71 9.94 3.99 12 3.99c2.06 0 4.06.72 5.6 2.03.21.18.48.27.76.25.28-.01.54-.13.73-.33.19-.2.28-.46.27-.72a.97.97 0 00-.35-.69C17.08 2.89 14.59 1.99 12 1.99s-5.08.91-7.01 2.54c-.11.09-.19.2-.26.32-.06.12-.1.25-.1.39s.01.27.06.39c.05.13.12.24.22.34h.01z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M15.8 6.2A6.547 6.547 0 0012 5c-1.37 0-2.7.42-3.8 1.2a.966.966 0 00-.19 1.4c.17.21.42.35.7.38.28.03.56-.04.78-.2.73-.51 1.61-.79 2.51-.79.9 0 1.79.28 2.51.79.11.08.23.14.37.17.13.03.27.04.41.03.28-.03.53-.17.7-.38.08-.1.15-.22.18-.35.04-.13.04-.26.03-.39a.963.963 0 00-.4-.66zM13 8.99h-2a2 2 0 00-2 2v8a2 2 0 002 2h2a2 2 0 002-2v-8a2 2 0 00-2-2zM6.63 8.3a.996.996 0 00-1.41 0l-1.85 1.85c-.47.47-.47 1.24 0 1.72l1.14 1.14-1.14 1.14c-.47.47-.47 1.24 0 1.72l1.14 1.14-1.14 1.14c-.47.47-.47 1.24 0 1.72l1.85 1.85c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 000-1.41l-1.29-1.29 1.14-1.14c.47-.47.47-1.24 0-1.72l-1.14-1.14 1.14-1.14c.47-.47.47-1.24 0-1.72l-1.14-1.14 1.29-1.29a.996.996 0 000-1.41l-.01-.02zM20.65 14.17l-1.14-1.14 1.14-1.14c.47-.47.47-1.24 0-1.72L18.8 8.32a.996.996 0 10-1.41 1.41l1.29 1.29-1.15 1.15c-.47.47-.47 1.24 0 1.71l1.14 1.14-1.15 1.15c-.47.47-.47 1.24 0 1.71l1.14 1.14-1.29 1.29a.996.996 0 00.71 1.7c.26 0 .51-.1.71-.29l1.85-1.85c.47-.47.47-1.24 0-1.72l-1.14-1.14 1.14-1.14c.47-.47.47-1.24 0-1.72l.01.02z",
                fill: "currentColor"
            })
        ]
    });



const $b18eb07e7c393d5d$export$25bb0ff56954dcf1 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18.13 8.05L8.42 3.3a3 3 0 00-3.95 1.34L2.3 9a2.93 2.93 0 001.35 4l4.22 2-1.49 3H3a1 1 0 000 2h4a1 1 0 00.89-.55l1.78-3.55 3.68 1.8a3 3 0 004-1.34L19.47 12a2.93 2.93 0 00-1.34-3.95zm3.32 4.35a1 1 0 00-1.32.45l-1.73 3.51a1 1 0 00.45 1.3 1 1 0 001.31-.44l1.74-3.51a1 1 0 00-.45-1.31z",
            fill: "currentColor"
        })
    });



const $e7c5f964c1edbc2e$export$9cdd79580b3df325 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.83 6.17A4 4 0 0018 5H6a4 4 0 00-4 4v6a4 4 0 004 4h2.8a1.93 1.93 0 00.94-.24 2 2 0 00.72-.65l.71-1.06a1 1 0 011.66 0l.71 1.06a2 2 0 00.72.65c.288.159.611.241.94.24H18a4 4 0 004-4V9a4 4 0 00-1.17-2.83zM9.41 13.41A2 2 0 018 14a2 2 0 112-2 2 2 0 01-.59 1.41zm8 0A2 2 0 0116 14a2 2 0 112-2 2 2 0 01-.59 1.41z",
            fill: "currentColor"
        })
    });



const $20d937bb310a16b5$export$3d6bdc7fbf1023fb = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 2H7a3 3 0 00-3 3v14a3 3 0 003 3h10a3 3 0 003-3V5a3 3 0 00-3-3zM7 4h2a1 1 0 010 2H7a1 1 0 010-2zm5 16a6 6 0 110-12 6 6 0 010 12zm5-14a1 1 0 110-2 1 1 0 010 2zm-5 4a4 4 0 00-4 4 1.66 1.66 0 011.26.56 1 1 0 001.48 0A1.649 1.649 0 0112 14a1.701 1.701 0 011.26.56 1 1 0 001.48 0A1.701 1.701 0 0116 14a4 4 0 00-4-4z",
            fill: "currentColor"
        })
    });



const $d2652e46a4f99c57$export$baa49ad6c2abb40a = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18.67 4.56a10 10 0 00-13.34 0 1.002 1.002 0 001.34 1.49 8 8 0 0110.66 0 1 1 0 00.67.25 1 1 0 00.74-.3.999.999 0 00-.07-1.44zm-6 5.82a.899.899 0 00-1.47 0l-2.73 4.54a5.35 5.35 0 00-.78 2.78 4.3 4.3 0 108.59 0c0-.982-.273-1.945-.79-2.78l-2.82-4.54zM9.61 8.82a4 4 0 014.78 0 1.002 1.002 0 101.22-1.59 6 6 0 00-7.22 0 1.002 1.002 0 101.22 1.59z",
            fill: "currentColor"
        })
    });



const $361185c76998125a$export$7af105e78092d879 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 4H5a3 3 0 00-3 3v10a3 3 0 003 3h14a3 3 0 003-3V7a3 3 0 00-3-3zm-8 2a1 1 0 110 2 1 1 0 010-2zM8 6a1 1 0 110 2 1 1 0 010-2zM5 6a1 1 0 110 2 1 1 0 010-2z",
            fill: "currentColor"
        })
    });



const $7905f35300c4101e$export$27eb2f2fe6edd6a5 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.39 16.08l-3.5-1.5a1 1 0 00-1.31 1.31l1.5 3.5A1 1 0 0019 20h.2a1 1 0 00.8-1v-1h1a1 1 0 00.39-1.92zM19 4H5a3 3 0 00-3 3v10a3 3 0 003 3h10a5 5 0 017-7V7a3 3 0 00-3-3zM5 8a1 1 0 110-2 1 1 0 010 2zm3 0a1 1 0 110-2 1 1 0 010 2zm3 0a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $5df0e17df8ba82ec$export$abfa4efe103ea6dd = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 4H5a3 3 0 00-3 3v10a3 3 0 003 3h7v-8a4 4 0 014-4h4a4 4 0 012 .56V7a3 3 0 00-3-3zM5 8a1 1 0 110-2 1 1 0 010 2zm3 0a1 1 0 110-2 1 1 0 010 2zm3 0a1 1 0 110-2 1 1 0 010 2zm9 2h-4a2 2 0 00-2 2v8a2 2 0 002 2h4a2 2 0 002-2v-8a2 2 0 00-2-2zm-2 10a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $21f3a12e813c08a1$export$902dfcd9193b2555 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 4H5a3 3 0 00-3 3v10a3 3 0 003 3h14a3 3 0 003-3V7a3 3 0 00-3-3zm-8 2a1 1 0 110 2 1 1 0 010-2zM5 8a1 1 0 110-2 1 1 0 010 2zm2-1a1 1 0 112 0 1 1 0 01-2 0zm9.71 4.71l-5 5a1.002 1.002 0 01-1.42 0l-2-2a1.004 1.004 0 011.42-1.42l1.29 1.3 4.29-4.3a1.004 1.004 0 011.42 1.42z",
            fill: "currentColor"
        })
    });



const $baac49381bd2b92c$export$f182537a08e2144c = (r)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5 4h14c1.1 0 2 .9 2 2v4c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2zm9 4c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12.77 11h-1.54c-.68 0-1.23.55-1.23 1.23v6.54c0 .68.55 1.23 1.23 1.23h1.54c.68 0 1.23-.55 1.23-1.23v-6.54c0-.68-.55-1.23-1.23-1.23z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M15.57 17H8.43C7.64 17 7 17.67 7 18.5S7.64 20 8.43 20h7.14c.79 0 1.43-.67 1.43-1.5s-.64-1.5-1.43-1.5z",
                fill: "currentColor"
            })
        ]
    });



const $4327600a42b7a2f8$export$cc7e67019cadf7d6 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.92 9.86a1 1 0 001.37-.35 4.79 4.79 0 000-5 1 1 0 00-1.72 1c.274.45.423.964.43 1.49a2.94 2.94 0 01-.43 1.49 1 1 0 00.35 1.37zM19 12h-1V5a1 1 0 00-2 0v7H5a3 3 0 00-3 3v2a3 3 0 003 3h14a3 3 0 003-3v-2a3 3 0 00-3-3zM6 17a1 1 0 110-2 1 1 0 010 2zm4 0a1 1 0 110-2 1 1 0 010 2zm3.57-7a1 1 0 00.86-1.51A2.94 2.94 0 0114 7a2.94 2.94 0 01.43-1.49 1 1 0 00-1.72-1 4.79 4.79 0 000 5 1 1 0 00.86.49z",
            fill: "currentColor"
        })
    });



const $f19f7c79149633a2$export$af573fd10c15b544 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.5 3.5a2 2 0 00-2.83 0L14.13 7 4.7 5.81a1.5 1.5 0 00-1 2.76L9.18 12l-1.41 1.4-3 .27a1.5 1.5 0 00-.6 2.8l2.14 1.21 1.21 2.14a1.5 1.5 0 002.8-.6l.27-3 1.41-1.4 3.42 5.47a1.5 1.5 0 002.76-1L17 9.87l3.5-3.54a1.999 1.999 0 000-2.83z",
            fill: "currentColor"
        })
    });



const $945f83f1382c241e$export$233591d926806180 = (v)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...v,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 3H4a1 1 0 000 2v14a2 2 0 002 2h4v-5h4v5h4a2 2 0 002-2V5a1 1 0 100-2zM9 13H7v-2h2v2zm0-4H7V7h2v2zm4 4h-2v-2h2v2zm0-4h-2V7h2v2zm4 4h-2v-2h2v2zm0-4h-2V7h2v2z",
            fill: "currentColor"
        })
    });



const $c4cb16584a3ef8a1$export$47cf969134664525 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 3H8a1 1 0 000 2v2H4a1 1 0 000 2v10a2 2 0 002 2h6.5v-5h3v5H18a2 2 0 002-2V5a1 1 0 100-2zM8 17H6v-2h2v2zm0-4H6v-2h2v2zm5 0h-2v-2h2v2zm0-4h-2V7h2v2zm4 4h-2v-2h2v2zm0-4h-2V7h2v2z",
            fill: "currentColor"
        })
    });



const $35868e7891c2b240$export$8b8a87672bd60409 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M5 20a2 2 0 002 2h10a2 2 0 002-2v-7H5v7zm5-4h4a1 1 0 010 2h-4a1 1 0 010-2zM20 2H4a1 1 0 000 2h1v7h14V4h1a1 1 0 100-2zm-6 6h-4a1 1 0 010-2h4a1 1 0 110 2z",
            fill: "currentColor"
        })
    });



const $07fae0ecb63d91a8$export$489504400861a963 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M3 7v11a3 3 0 003 3h1.17L10 8.65 3 7zm15-4H6a3 3 0 00-2.82 2L21 9.13V6a3 3 0 00-3-3zM9.22 21H18a3 3 0 003-3v-6.82L12 9.1 9.22 21zm5.08-8.06a2.006 2.006 0 013.51 1.94l-1.36 2.84a.5.5 0 01-.9 0l-1.36-2.84a2 2 0 01.11-1.94z",
            fill: "currentColor"
        })
    });



const $9f651b328425ecc6$export$326c94c419a04418 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 5H6.63a3 3 0 00-2.94 2.42l-1.63 9A3.08 3.08 0 002 17a3 3 0 005.82 1h7.36A3 3 0 0021 17V8a3 3 0 00-3-3zM9 7h6v4h-3a1 1 0 00-1 1v4H9V7zM6.63 7H7v3H5.25l.4-2.2a1 1 0 01.98-.8zM5 18a1 1 0 110-2 1 1 0 010 2zm13 0a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $da1afe04299179b5$export$fe36b511e03106b3 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.5 16a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM8.5 6a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM12 9a1 1 0 00-1-1H8.42L6.71 6.29a1 1 0 00-.9-.29 1 1 0 00-.73.61l-2 5A.94.94 0 003 12v8a1 1 0 102 0v-7.81l1.37-3.41.93.93A1 1 0 008 10h3a1 1 0 001-1zm0 7h4a1 1 0 001-1v-2a1 1 0 00-2 0v1h-2.59l-1.7-1.71a1.004 1.004 0 10-1.42 1.42l2 2A1 1 0 0012 16zm8 2h-8a1 1 0 000 2h8a1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $1364e6d7e0528210$export$2865c23c31d851e = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 11a1 1 0 001-1V5a1 1 0 00-1-1h-4.5a1 1 0 00-1 1c0 4.75 3.6 6 5.5 6zm2 1H3a1 1 0 000 2v4a2.08 2.08 0 002.14 2h13.72A2.08 2.08 0 0021 18v-4a1 1 0 000-2zM7 18H5v-3.95a.22.22 0 01.14-.05H7v4zm4 0H9v-4h2v4zm4 0h-2v-4h2v4zm3.86 0H17v-4h2v4a.22.22 0 01-.14 0zM5 11c1.9 0 5.5-1.25 5.5-6a1 1 0 00-1-1H5a1 1 0 00-1 1v5a1 1 0 001 1z",
            fill: "currentColor"
        })
    });



const $41370812f0378c6f$export$f90ec8d3acce2ac7 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.93 10.64L19.1 6a2 2 0 00-1.22-1.2L13 3.15a3.08 3.08 0 00-1.9 0L6.12 4.8A2 2 0 004.9 6l-1.83 4.64A1 1 0 004 12h1v6a3 3 0 003 3h1v-7h6v7h1a3 3 0 003-3v-6h1a1 1 0 00.93-1.36zM13 8.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1z",
            fill: "currentColor"
        })
    });



const $a8c48b6516a8eefd$export$18b85fee0d0f0f1e = (v)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...v,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M9 21h6v-2H9v2zm0-4h6v-2H9v2zm11.93-6.36L19.1 6a2 2 0 00-1.22-1.2L13 3.15a3.08 3.08 0 00-1.9 0L6.12 4.8A2 2 0 004.9 6l-1.83 4.64A1 1 0 004 12h1v7a2 2 0 002 2v-6.5A1.5 1.5 0 018.5 13h7a1.5 1.5 0 011.5 1.5V21a2 2 0 002-2v-7h1a1 1 0 00.93-1.36zM13 8.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1z",
            fill: "currentColor"
        })
    });



const $b617f42dc49aa84b$export$6eb974fd2e25972f = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 10H8v4h4v-4zm9 0h-3V7a3 3 0 00-6 0 1 1 0 002 0 1 1 0 012 0v3h-2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4H3a1 1 0 000 2h.15l.45 2.66A4 4 0 007 18v1a1 1 0 102 0v-1h6v1a1 1 0 002 0v-1a4 4 0 003.4-3.29l.45-2.71H21a1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $43b09bbbae9c342f$export$f59985d83b02359c = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21 10h-3a1 1 0 00-1-1V7a3 3 0 00-6 0 1 1 0 002 0 1 1 0 012 0v2a1 1 0 00-1 1H3a1 1 0 000 2h1v2a4 4 0 003 3.86V19a1 1 0 102 0v-1h6v1a1 1 0 002 0v-1.14A4 4 0 0020 14v-2h1a1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $4cd9a5056685df5a$export$5e018ee65771beb8 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M6 9a1 1 0 011-1h3a1 1 0 011 1v2h2V9a1 1 0 011-1h3a1 1 0 011 1v2h2V7a2 2 0 00-2-2H6a2 2 0 00-2 2v4h2V9zm14 3H4a2 2 0 00-2 2v5a1 1 0 102 0v-1h16v1a1 1 0 002 0v-5a2 2 0 00-2-2z",
            fill: "currentColor"
        })
    });



const $2cecf079bf55f8c2$export$fb5d58e7a20ab9 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 8h1v1a1 1 0 002 0V8h1a1 1 0 100-2h-1V5a1 1 0 00-2 0v1h-1a1 1 0 100 2zm2 4H8v-1a3 3 0 00-3-3H4V5a1 1 0 00-2 0v14a1 1 0 102 0v-1h16v1a1 1 0 002 0v-4a3 3 0 00-3-3z",
            fill: "currentColor"
        })
    });



const $d0a554463d837eea$export$7c5a57bdd85cc7f = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 8h-7a3 3 0 00-3 3v1H7v-1a3 3 0 00-3-3V5a1 1 0 00-2 0v14a1 1 0 102 0v-1h16v1a1 1 0 002 0v-8a3 3 0 00-3-3z",
            fill: "currentColor"
        })
    });



const $4b7e267ff8ce8160$export$a4aeacd795664674 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M14 3h.79l-1.14 1.15a.47.47 0 00-.11.54A.5.5 0 0014 5h2a.5.5 0 000-1h-.79l1.14-1.15a.47.47 0 00.11-.54A.5.5 0 0016 2h-2a.5.5 0 000 1zm-3.5 3h.79l-1.14 1.15a.47.47 0 00-.11.54.5.5 0 00.46.31h2a.5.5 0 000-1h-.79l1.14-1.15a.47.47 0 00-.05-.776.5.5 0 00-.3-.074h-2a.5.5 0 000 1zM7 12a2 2 0 100-4 2 2 0 000 4zm12-3h-6a3 3 0 00-3 3v1a1 1 0 001 1h11v-2a3 3 0 00-3-3zM8 13H4V6a1 1 0 00-2 0v13a1 1 0 102 0v-1h16v1a1 1 0 002 0v-3H11a3 3 0 01-3-3z",
            fill: "currentColor"
        })
    });



const $403cfd4674966f3f$export$a5c11ce6ebf4e475 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21 10h-1.15l.15-.84A1 1 0 0019 8h-6a1 1 0 00-1 1.16l.14.84H11a1 1 0 000 2h1.49l.51 3.16a1 1 0 00.8.81 3 3 0 014.38 0 1 1 0 00.8-.81l.53-3.16H21a1 1 0 000-2zm-5 2a1 1 0 110-2 1 1 0 010 2zM6 7H4a2 2 0 00-2 2v5a2 2 0 002 2v4a1 1 0 102 0v-4a2 2 0 002-2V9a2 2 0 00-2-2zM5 6a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm11 11a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $5b14581957b4a904$export$e1173e25d274ffa0 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21 16.55l-1.76-1.76a1 1 0 00-1.42 0L16 16.55A3.46 3.46 0 0015 19a3.4 3.4 0 001 2.46 3.5 3.5 0 004.94 0A3.4 3.4 0 0022 19a3.46 3.46 0 00-1-2.45zM13 19v-9h3v3.76l.38-.39a3 3 0 011.62-.82V10h1a2 2 0 00.79-3.84l-7-3a2.06 2.06 0 00-1.58 0l-7 3A2 2 0 005 10h1v9H4a1 1 0 000 2h9.38a5.528 5.528 0 01-.38-2zm-2 0H8v-9h3v9z",
            fill: "currentColor"
        })
    });



const $a352b81c09aae041$export$bbb790486f9696b = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 2H8a4 4 0 00-4 4v13a1 1 0 001 1v1a1 1 0 102 0v-1h10v1a1 1 0 002 0v-1a1 1 0 001-1V6a4 4 0 00-4-4zM7 17a1 1 0 110-2 1 1 0 010 2zm10 0a1 1 0 110-2 1 1 0 010 2zm1-5a1 1 0 01-1 1H7a1 1 0 01-1-1V7a1 1 0 011-1h10a1 1 0 011 1v5z",
            fill: "currentColor"
        })
    });



const $453c76b1c6425d4f$export$24c22f43d1d9bfb = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M3 18a1 1 0 000 2h18a1 1 0 100-2H3zm17.82-2H21a1 1 0 001-1v-2.62a3.711 3.711 0 00-.13-1L20.47 6a.56.56 0 000-.12A3 3 0 0017.65 4H5a3 3 0 00-3 3v8a1 1 0 001 1h.18a3 3 0 005.64 0h6.36a3 3 0 005.64 0zM6 16a1 1 0 110-2 1 1 0 010 2zm2-7H4V7a1 1 0 011-1h3v3zm6 0h-4V6h4v3zm4 7a1 1 0 110-2 1 1 0 010 2zm0-5l-2-2V6h1.65a1 1 0 01.9.58L20 11h-2z",
            fill: "currentColor"
        })
    });



const $9f392e4f068ff7e5$export$f618dfe396bbfc75 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.87 11.38L20.47 6a.56.56 0 000-.12A3 3 0 0017.65 4H5a3 3 0 00-3 3v10a1 1 0 001 1h.18a3 3 0 005.64 0h6.36a3 3 0 005.64 0H21a1 1 0 001-1v-4.62a3.711 3.711 0 00-.13-1zM6 18a1 1 0 110-2 1 1 0 010 2zm2-8H4V7a1 1 0 011-1h3v4zm6 0h-4V6h4v4zm4 8a1 1 0 110-2 1 1 0 010 2zm0-6l-2-2V6h1.65a1 1 0 01.9.58l1.39 5.3V12H18z",
            fill: "currentColor"
        })
    });



const $613e687bbee619e8$export$f09efb92064ae104 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.79 7.34l-1.34-2.68A3 3 0 0016.76 3h-5.52a3 3 0 00-2.69 1.66L7.88 6h4.88a5 5 0 014.48 2.76l1.34 2.69c.274.557.418 1.17.42 1.79V15a1 1 0 002 0V8.24a2 2 0 00-.21-.9zm-5.34 2.32A3 3 0 0012.76 8H7.24a3 3 0 00-2.69 1.66l-1.34 2.68a2 2 0 00-.21.9V20a1 1 0 102 0v-1h10v1a1 1 0 002 0v-6.76a2 2 0 00-.21-.9l-1.34-2.68zm-9.11.89a1 1 0 01.9-.55h5.52a1 1 0 01.9.55L14.88 13H5.12l1.22-2.45zm.37 6.16a1 1 0 01-1.27.12.94.94 0 01-.36-.45A1 1 0 015 15.8a1 1 0 01.8-.8 1 1 0 01.58.06.94.94 0 01.45.36 1 1 0 01-.12 1.27v.02zm8 0a1 1 0 01-1.27.12.94.94 0 01-.36-.45 1 1 0 01-.08-.58 1 1 0 01.8-.8 1 1 0 01.58.06.94.94 0 01.45.36 1 1 0 01-.12 1.27v.02z",
            fill: "currentColor"
        })
    });



const $fef8260f1169be6c$export$fe869c4ef98066bc = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.5 17c-.189 0-.375.038-.55.11L17.74 16 20 14.89c.174.072.361.11.55.11a1.5 1.5 0 10-1.44-1.9l-3 1.51a1.462 1.462 0 00-.55-.11 1.5 1.5 0 000 3c.189 0 .375-.038.55-.11l3 1.51A1.5 1.5 0 1020.5 17zm-14-9.31a1 1 0 011-.69h9.15a1 1 0 011 .68l.63 2.32h2.11l-1-2.95a3 3 0 00-2.84-2H7.41a3 3 0 00-2.85 2.02l-1.34 4.09A2 2 0 002 13v3a2 2 0 001 1.72V19a1 1 0 102 0v-1h7v-5a3 3 0 01.78-2h-7.4L6.5 7.69zM5.8 13c.195-.038.397-.017.58.06a1 1 0 11-1.3 1.3A1 1 0 015 13.8a1 1 0 01.8-.8z",
            fill: "currentColor"
        })
    });



const $72063c04356db482$export$ac6aca55180df0dd = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 10h-2.41l-1.37-2.46A3 3 0 0013.6 6H8.46a3 3 0 00-2.6 1.5l-1.47 2.56A3 3 0 002 13v1a2 2 0 002 2h.18a3 3 0 005.64 0h4.36a3 3 0 005.64 0H20a2 2 0 002-2v-2a2 2 0 00-2-2zM7 16a1 1 0 110-2 1 1 0 010 2zm2-6H7l.72-1.45a1 1 0 01.9-.55H9v2zm2 0V8h2.38a1 1 0 01.9.55L15 10h-4zm6 6a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $eac5fd359fd4b05f$export$cf2b28e50a7b3566 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 8h-1V6a4 4 0 00-4-4h-4a4 4 0 00-4 4v2H5a1 1 0 000 2h1v8a4 4 0 004 4h4a4 4 0 004-4v-8h1a1 1 0 100-2zm-4.5 11h-5A1.5 1.5 0 018 17.5a.5.5 0 01.5-.5h7a.5.5 0 01.5.5 1.5 1.5 0 01-1.5 1.5zm1-8h-7a.5.5 0 01-.5-.5A3.5 3.5 0 0111.5 7h1a3.5 3.5 0 013.5 3.5.5.5 0 01-.5.5z",
            fill: "currentColor"
        })
    });



const $ce45659b266142cb$export$96e538f373840a49 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M9 8a1 1 0 100 2 1 1 0 000-2zm11.78 4.16L19.4 7.05a3 3 0 00-2.84-2H7.41a3 3 0 00-2.87 2.07l-1.33 5.05A2 2 0 002 14v2a2 2 0 001 1.72V19a1 1 0 002 0v-1h14v1a1 1 0 002 0v-1.28A2 2 0 0022 16v-2a2 2 0 00-1.22-1.84zM6.71 15.71a1 1 0 01-1.27.12.94.94 0 01-.36-.45A1 1 0 015 14.8a1 1 0 01.8-.8 1 1 0 01.58.06.94.94 0 01.45.36 1 1 0 01-.12 1.27v.02zM15 11a2 2 0 00-1.72 1h-2.56a2 2 0 00-3.44 0h-2l1.18-4.31a1 1 0 011-.69h9.15a1 1 0 01.93.63L18.67 12h-2A2 2 0 0015 11zm3.71 4.71a1 1 0 01-1.27.12.94.94 0 01-.36-.45 1 1 0 01-.08-.58 1 1 0 01.8-.8 1 1 0 01.58.06.94.94 0 01.45.36 1 1 0 01-.12 1.27v.02zM15 8a1 1 0 100 2 1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $214ab24e52d33491$export$1febfda10c428844 = (m)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...m,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 3h-2a2 2 0 00-2 2v6H9V9a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2h14a2 2 0 002-2V5a2 2 0 00-2-2zM6 19a1 1 0 110-2 1 1 0 010 2zm0-4a1 1 0 110-2 1 1 0 010 2zm0-4a1 1 0 110-2 1 1 0 010 2zm4 8a1 1 0 110-2 1 1 0 010 2zm0-4a1 1 0 110-2 1 1 0 010 2zm4 4a1 1 0 110-2 1 1 0 010 2zm0-4a1 1 0 110-2 1 1 0 010 2zm4 4a1 1 0 110-2 1 1 0 010 2zm0-4a1 1 0 110-2 1 1 0 010 2zm0-4a1 1 0 110-2 1 1 0 010 2zm0-4a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $c0887eaa6d74a389$export$917e5e8b7b8ba4e3 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4 4v14a2 2 0 002 2v1a1 1 0 102 0v-1h3V2H6a2 2 0 00-2 2zm4 6a1 1 0 110 2 1 1 0 010-2zm10-8h-5v18h3v1a1 1 0 002 0v-1a2 2 0 002-2V4a2 2 0 00-2-2zm-2 10a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $042ce556911e71b1$export$cad873c9b1c8d9ef = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zm4.71 8.71l-2 2a1.002 1.002 0 01-1.639-.325 1 1 0 01.219-1.095l.3-.29H11a1.88 1.88 0 00-2 2v2a1 1 0 11-2 0v-2a3.89 3.89 0 014-4h2.59l-.3-.29a1.004 1.004 0 111.42-1.42l2 2a1 1 0 010 1.42z",
            fill: "currentColor"
        })
    });



const $b0d7407581c162ac$export$53a182447548cea0 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a9.84 9.84 0 00-4.62 1.14L13.24 9h.35l-.3-.29a1.004 1.004 0 011.42-1.42l2 2a1 1 0 010 1.42l-.88.88 5 5A9.84 9.84 0 0022 12 10 10 0 0012 2zM5 3.51A1.053 1.053 0 103.51 5l.74.73a10 10 0 0014.06 14.02l.73.74A1.04 1.04 0 0020.49 19L5 3.51zM9 13v2a1 1 0 11-2 0v-2a3.76 3.76 0 011.43-3.12l1.43 1.42A1.8 1.8 0 009 13z",
            fill: "currentColor"
        })
    });



const $1ea1b5a6f710e0d4$export$5e486af98d28d1d0 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10 5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm11.89 13.55a1 1 0 00-1.34-.44l-1.1.55-2.56-5.11A1 1 0 0016 13h-5v-2h4a1 1 0 000-2h-4V7a1 1 0 00-2 0v2a6.49 6.49 0 107 7.14l2.14 4.28A1 1 0 0019 21a.93.93 0 00.45-.11l2-1a1 1 0 00.44-1.34zM14 15.5a4.5 4.5 0 11-5-4.45V14a1 1 0 001 1h4v.5z",
            fill: "currentColor"
        })
    });



const $ad71395c13f96fe8$export$769730a046b3bf77 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M3 5v14a2 2 0 002 2h6V3H5a2 2 0 00-2 2zm2.17 6.77l1.25-1.5a.789.789 0 011.16 0l1.25 1.5a.77.77 0 01.1.8.75.75 0 01-.68.43h-2.5a.75.75 0 01-.68-.43.77.77 0 01.1-.8zM19 3h-6v18h6a2 2 0 002-2V5a2 2 0 00-2-2zm-.17 9.23l-1.25 1.5a.758.758 0 01-1.16 0l-1.25-1.5a.77.77 0 01-.1-.8.75.75 0 01.68-.43h2.5a.75.75 0 01.68.43.77.77 0 01-.1.8z",
            fill: "currentColor"
        })
    });



const $4f29e32a1f0e614f$export$c0869f1c79633aa0 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 7h-2V6a3 3 0 00-3-3h-4a3 3 0 00-3 3v1H5a3 3 0 00-3 3v8a3 3 0 003 3h14a3 3 0 003-3v-8a3 3 0 00-3-3zm-5 8h-1v1a1 1 0 01-2 0v-1h-1a1 1 0 010-2h1v-1a1 1 0 012 0v1h1a1 1 0 010 2zM9 6a1 1 0 011-1h4a1 1 0 011 1v1H9V6z",
            fill: "currentColor"
        })
    });



const $fffa23490557bdb6$export$e38745f2b956b85f = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 10h-.21a4.32 4.32 0 00-.16-3.21C17.94 5.4 16.45 4.47 14.2 4a5.15 5.15 0 01-1.6-.82l-.09-.05a.18.18 0 01-.07 0h-.54a.701.701 0 00-.14 0h-.13l-.08.05h-.09A4.55 4.55 0 019.81 4c-2.24.42-3.74 1.34-4.43 2.72A4.36 4.36 0 005.21 10H5a2 2 0 00-2 2v7a2 2 0 002 2h5v-4a2 2 0 114 0v4h5a2 2 0 002-2v-7a2 2 0 00-2-2z",
            fill: "currentColor"
        })
    });



const $2908d5575463f58e$export$aa78383db5fa069b = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 15a1 1 0 00-1 1v3H5v-3a1 1 0 10-2 0v4a1 1 0 001 1h16a1 1 0 001-1v-4a1 1 0 00-1-1zm-2-6A6 6 0 106 9v9h12V9zm-3 3a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $60d22b50c5cded0d$export$89676024f58a7b6c = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M5 7h14a1 1 0 00.76-1.65A10.23 10.23 0 0012 2a10.23 10.23 0 00-7.76 3.35A1 1 0 005 7zm5 2H5a1 1 0 00-1 1v11a1 1 0 001 1h5a1 1 0 001-1V10a1 1 0 00-1-1zm-2 7a1 1 0 110-2 1 1 0 010 2zm11-7h-5a1 1 0 00-1 1v11a1 1 0 001 1h5a1 1 0 001-1V10a1 1 0 00-1-1zm-3 7a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $7e6bec12105a6ebc$export$5e1be1247553c274 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7 21h10v-2H7v2zm0-4h10v-2H7v2zm0-4h10v-2H7v2zm13.06-5.32l-7-4.38a2 2 0 00-2.12 0l-7 4.38A2 2 0 003 9.38V19a2 2 0 002 2V10.5A1.5 1.5 0 016.5 9h11a1.5 1.5 0 011.5 1.5V21a2 2 0 002-2V9.38a2 2 0 00-.94-1.7z",
            fill: "currentColor"
        })
    });



const $8e5d10c22315749e$export$e6fcd6af087bedb0 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21 12a2.5 2.5 0 00-2.5-2.5H18l.32-.33a2.5 2.5 0 00-3.53-3.53L14.5 6v-.5a2.5 2.5 0 00-5 0V6l-.33-.32a2.5 2.5 0 00-3.53 3.49L6 9.5h-.5a2.5 2.5 0 000 5H6l-.32.33a2.5 2.5 0 003.53 3.53L9.5 18v.46a2.5 2.5 0 005 0V18l.33.32a2.5 2.5 0 003.53-3.53L18 14.5h.46A2.5 2.5 0 0021 12zm-9 3a3 3 0 110-5.999A3 3 0 0112 15z",
            fill: "currentColor"
        })
    });



const $d996ac1ada01262c$export$5096376be6ede5fc = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zm-1 17.93A8 8 0 014 12a8.12 8.12 0 01.21-1.79L9 15v1a1 1 0 001 1h1v2.93zm7.72-3.61A1 1 0 0018 16h-3v-3a1 1 0 00-1-1H9v-2h2a1 1 0 001-1V7h3V4.59A8 8 0 0120 12a7.91 7.91 0 01-1.28 4.32z",
            fill: "currentColor"
        })
    });



const $5aca8a5cbeaa7950$export$3c50b44dda44118b = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7 20h10v-5H7v5zm7-16h-4a3 3 0 00-3 3v6h4v-1a1 1 0 012 0v1h4V7a3 3 0 00-3-3zm1 4H9V7a1 1 0 011-1h4a1 1 0 011 1v1zM2 10v8a2 2 0 002 2h1V8H4a2 2 0 00-2 2zm18-2h-1v12h1a2 2 0 002-2v-8a2 2 0 00-2-2z",
            fill: "currentColor"
        })
    });



const $ae451de98a74fc8f$export$475078afcff89e1a = (v)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...v,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 6V5a3 3 0 00-3-3h-2a3 3 0 00-3 3v1a3 3 0 00-3 3v8a3 3 0 002 2.82V21a1 1 0 102 0v-1h6v1a1 1 0 002 0v-1.18A3 3 0 0019 17V9a3 3 0 00-3-3zm-6 10a1 1 0 11-2 0v-6a1 1 0 012 0v6zm0-11a1 1 0 011-1h2a1 1 0 011 1v1h-4V5zm6 11a1 1 0 01-2 0v-6a1 1 0 012 0v6z",
            fill: "currentColor"
        })
    });



const $cb2bd1b7b250665c$export$ea622f1d1319701e = (v)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...v,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 11v-.76a2 2 0 00-.21-.9L17 7.76V7h1a1 1 0 100-2h-1v-.5a1 1 0 00-.17-.5c-.13-.25-1.39-2-4.83-2-3.44 0-4.7 1.75-4.83 2a1 1 0 00-.17.5V5H6a1 1 0 000 2h1v.76l-.79 1.58a2 2 0 00-.21.9V11a2 2 0 00-2 2v4a2 2 0 002 2 3 3 0 003 3h6a3 3 0 003-3 2 2 0 002-2v-4a2 2 0 00-2-2zm-7 7a1 1 0 01-2 0v-8a1 1 0 012 0v8zm4 0a1 1 0 01-2 0v-8a1 1 0 012 0v8zm-.33-12H9.33A.33.33 0 019 5.67 1.67 1.67 0 0110.67 4h2.66A1.67 1.67 0 0115 5.67a.33.33 0 01-.33.33z",
            fill: "currentColor"
        })
    });



const $ed9b40f9f12943ba$export$1ae736159ccc3dd0 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.06 7.68l-7-4.38a2 2 0 00-2.12 0l-7 4.38A2 2 0 003 9.37V19a2 2 0 002 2h14a2 2 0 002-2V9.37a2 2 0 00-.94-1.69zM15 14h-2v2a1 1 0 01-2 0v-2H9a1 1 0 010-2h2v-2a1 1 0 012 0v2h2a1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $dc40a338f835380e$export$f85cc607063e110e = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10 8h9a1 1 0 001-1 3 3 0 00-3-3h-5a3 3 0 00-3 3 1 1 0 001 1zM6.5 8a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM18 9H6a3 3 0 00-3 3 1 1 0 001 1h.5v5.39a1.5 1.5 0 102 0V17h11v1.39a1.5 1.5 0 102 0V13h.5a1 1 0 001-1 3 3 0 00-3-3zm-.5 6h-11v-2h11v2z",
            fill: "currentColor"
        })
    });



const $3aba290790dae05e$export$555011d8049a95da = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.26 7.25c-.19-.07-.63 0-.81.1-.39.21-1.22.71-1.36 1.13-.04.12.09.51.09.51l-1.21.21s-.41-.13-.5-.24c-.08-.11 0-.45-.09-.54-.09-.08-.43-.1-.49.01-.11.21.27.76.12.93-.14.16-.83.02-.83.02-.27 0-.54-.03-.8-.12l-1.05-.34c-.16-.05-.32-.12-.47-.21 0 0-1.16-.36-1.23-.7-.05-.23.47-.62.41-.85-.08-.31-1.05-.74-1.05-.74s-.24-.62-.09-.72c.07-.04.2.16.28.18.09.02.28-.11.3-.2.05-.18-.35-.68-.35-.68l.65-.62s.2-.39.14-.5c-.06-.12-.38-.19-.52-.19-.24 0-.96.18-.96.18l-.18-.17c-.52-.5-1.21-.75-1.9-.7 0 0-.37.32-.35.46.03.25.74.37.78.61.01.07-.19.21-.19.21s-.16 0-.19.04c-.15.18-.17.77-.01.95.13.16.65.24.69.44.16.82-1.94 2.74-1.94 2.74s-.63-.15-.82-.08c-.21.08-.55.51-.52.73.06.4.92 1.01.8 1.39-.05.16-.45.29-.62.3-.17 0-.51-.15-.69-.12-.11.02-.33.2-.33.32 0 .21.56.61.56.61s-.09.41-.05.54c.09.31.64.85.96.86l.02-.02s.71-.41.92-.29c.11.06.12.51.12.51v1.06c.02.29.06.58.15.86l1.11 3.43.3.61.41 1.41s.22.33.33.39c.13.07.47.05.58-.05.08-.06.11-.38.11-.38l.98-1.17v-.11l-.02-.54.02-.08.27-.94-.03-.02v-.03l.03.04v-.05l-.15-.94s.06-.33.12-.42c.39-.57 2.2-1.66 2.2-1.66l.39-.54s.15-.33.24-.4c.14-.1.53-.08.67-.18.24-.18.39-.81.58-1.05.07-.09.26-.23.37-.23.14 0 .44.25.54.15.41-.38-.47-2.18-.47-2.18s-.18-.68-.02-.81c.13-.11.66.13.66.13l.11.47.32.17s.96-.21 1.12.02c.05.07-.11.3-.11.3l.1.52s0 .91.24.95c.19.03.4-.64.4-.64l-.08-.57.39.04s.21-.75.29-.99c.06-.2.27-.79.27-.79l.78-.52s.29-.31.29-.45c0-.27-.48-.71-.74-.81l.01.05z",
            fill: "currentColor"
        })
    });



const $731e4325c1eeb058$export$853819ec679c1039 = (v)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...v,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M5 6a1 1 0 01-.71-1.71 3.67 3.67 0 014-.76c1 .25 1.48.34 2-.24a1.003 1.003 0 111.42 1.42 3.67 3.67 0 01-4 .76c-1-.25-1.48-.34-2 .24A1 1 0 015 6zM20.55 10.17a1 1 0 00-.94-.09L16 11.63V11a1 1 0 00-1.39-.92L11 11.63V11a1 1 0 00-1.39-.92L7 11.2V8a1 1 0 00-1-1H4a1 1 0 00-1 1v11a2 2 0 002 2h14a2 2 0 002-2v-8a1 1 0 00-.45-.83zM9 16.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1zm4 0a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1zm4 0a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1z",
            fill: "currentColor"
        })
    });



const $c0f86e8c5b813d16$export$c658fdbf195bb472 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7 11a2 2 0 100-4 2 2 0 000 4zm1 1H4V5a1 1 0 00-2 0v14a1 1 0 102 0v-1h16v1a1 1 0 002 0v-4H11a3 3 0 01-3-3zm11-4h-6a3 3 0 00-3 3v1a1 1 0 001 1h11v-2a3 3 0 00-3-3z",
            fill: "currentColor"
        })
    });



const $ee701b5c64630149$export$a9cadbab8e35ce8e = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 4a1 1 0 00-1 1v1H5V5a1 1 0 00-2 0v14.5a.5.5 0 00.5.5h1a.5.5 0 00.5-.5V18h14v1.5a.5.5 0 00.5.5h1a.5.5 0 00.5-.5V5a1 1 0 00-1-1zM7 14H5V8h2v6zm4 0H9V8h2v6zm4 0h-2V8h2v6zm4 0h-2V8h2v6z",
            fill: "currentColor"
        })
    });



const $4357d86c8d3ba13e$export$42604c7cf1c2ad3a = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 3H7a3 3 0 00-3 3v4a1 1 0 001 1 2.62 2.62 0 001.82-.74c.25-.22.31-.26.52-.26.21 0 .26 0 .51.26a2.62 2.62 0 001.82.74 2.58 2.58 0 001.82-.74c.26-.22.31-.26.52-.26.21 0 .26 0 .51.26a2.61 2.61 0 003.64 0c.25-.22.3-.26.51-.26.21 0 .26 0 .51.26A2.62 2.62 0 0019 11a1 1 0 001-1V6a3 3 0 00-3-3zM20 19h-1v-6a4.47 4.47 0 01-2-.46V15H7v-2.46A4.47 4.47 0 015 13v6H4a1 1 0 000 2h16a1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $68e1888e6cda27fd$export$cd8fa2085d0ac140 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M6 9h6a1 1 0 00.92-.62 1 1 0 00-.21-1.09L11 5.59V4a1 1 0 00-1-1H8a1 1 0 00-1 1v1.59l-1.71 1.7a1 1 0 00-.21 1.09A1 1 0 006 9zm13 4v-1a3 3 0 00-3-3 1 1 0 100 2 1 1 0 011 1v1h-2a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h14a2 2 0 002-2v-4a2 2 0 00-2-2zm-6 1.5a.5.5 0 01-.5.5h-7a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h7a.5.5 0 01.5.5v1z",
            fill: "currentColor"
        })
    });



const $31fe4a3041094837$export$4f12396611cab47 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M6 17a1 1 0 000 2 1 1 0 011 1v1a1 1 0 102 0v-1a3 3 0 00-3-3zm6 0a1 1 0 00-1 1v3a1 1 0 002 0v-3a1 1 0 00-1-1zm7.41-5.41l-3-3a1.53 1.53 0 00-.41-.31V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v4.28a1.53 1.53 0 00-.41.31l-3 3a2 2 0 00-.44 2.18A2 2 0 006 15h12a2 2 0 001.85-1.23 2 2 0 00-.44-2.18zM18 17a3 3 0 00-3 3v1a1 1 0 002 0v-1a1 1 0 011-1 1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $9321671b6046bc2b$export$2735186534927e21 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 6h-2a3 3 0 00-6 0H7a3 3 0 00-3 3h16a3 3 0 00-3-3zm-6 0a1 1 0 012 0h-2zm9 5H4a1 1 0 000 2v5a3 3 0 003 3h10a3 3 0 003-3v-5a1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $8589a335374d3249$export$fd1cbcfe57f94b4c = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 11h-2V6a3 3 0 00-6 0 1 1 0 002 0 1 1 0 012 0v5H7V9h1a1 1 0 000-2H4a1 1 0 000 2h1v2a2 2 0 100 4v4a2 2 0 002 2h10a2 2 0 002-2v-4a2 2 0 000-4z",
            fill: "currentColor"
        })
    });



const $e1b969d012d791c7$export$7bd96c3ed405c0b3 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18.45 6.11L17 5.38V4.5a1.001 1.001 0 00-.17-.5c-.13-.25-1.39-2-4.83-2-3.44 0-4.7 1.75-4.83 2a1 1 0 00-.17.5v.88l-1.45.73A1 1 0 006 8a.93.93 0 00.45-.11L7 7.62v.14l-.79 1.58a2 2 0 00-.21.9V19a3 3 0 003 3h6a3 3 0 003-3v-8.76a2 2 0 00-.21-.9L17 7.76v-.14l.55.27A.93.93 0 0018 8a1 1 0 00.45-1.89zM10.67 4h2.66A1.67 1.67 0 0115 5.67a.33.33 0 01-.33.33H9.33A.33.33 0 019 5.67 1.67 1.67 0 0110.67 4zm3.83 8h-5A1.5 1.5 0 018 10.5a.5.5 0 01.5-.5h7a.5.5 0 01.5.5 1.5 1.5 0 01-1.5 1.5z",
            fill: "currentColor"
        })
    });



const $f9f6dd74bc16c4c8$export$b3556d7ff1fe592c = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M22.71 18.29l-2-2s-.11-.07-.16-.11c.28-.5.45-1.07.45-1.69 0-1.93-1.57-3.5-3.5-3.5s-3.5 1.57-3.5 3.5 1.57 3.5 3.5 3.5c.61 0 1.18-.17 1.69-.45.04.05.06.11.11.16l2 2c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 000-1.41h-.01zM17.5 16c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4.5-4.65v-1.02c0-.8-.32-1.56-.88-2.12l-4-4c-.17-.17-.37-.3-.58-.4v5.27c.31-.05.63-.09.96-.09 1.86 0 3.51.93 4.5 2.35v.01zm-6.5-1.97V3.61c-.29.02-.57.1-.83.24L9.5 6.8v13.69c.28-.04.54-.15.77-.31l3.02-2.15c-.8-.96-1.29-2.19-1.29-3.53a5.51 5.51 0 013.5-5.12zM3.61 3.51c-.27-.02-.55.04-.79.16-.24.13-.45.32-.59.55-.14.23-.22.5-.22.78v8.71c0 .43.08.86.25 1.25.17.39.43.75.75 1.03l4.81 4.1c.2.17.44.3.69.37V6.73L4.38 3.78c-.22-.16-.49-.25-.76-.27h-.01z",
            fill: "currentColor"
        })
    });



const $bd5b4ec2c522f2ed$export$2984cf69b7ccb210 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M14 9h-1V8a1 1 0 00-2 0v1h-1a1 1 0 000 2h1v1a1 1 0 002 0v-1h1a1 1 0 100-2zm3.57-4.92A7.79 7.79 0 0012 1.93a7.82 7.82 0 00-8 7.6c0 5.08 5.91 11.14 6.59 11.81a2 2 0 002.82 0c.68-.67 6.59-6.73 6.59-11.81a7.81 7.81 0 00-2.43-5.45zM12 15.86a5.93 5.93 0 01-1.16-11.75 6 6 0 013.43.34A5.93 5.93 0 0112 15.86z",
            fill: "currentColor"
        })
    });



const $4dcca97ab634f7e2$export$31fd5080e8e8a0a8 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M14 7a1 1 0 00-1 1v1h-2V8a1 1 0 00-2 0v4a1 1 0 102 0v-1h2v1a1 1 0 002 0V8a1 1 0 00-1-1zm3.57-2.92A7.79 7.79 0 0012 1.93a7.82 7.82 0 00-8 7.6c0 5.08 5.91 11.14 6.59 11.81a2 2 0 002.82 0c.68-.67 6.59-6.73 6.59-11.81a7.81 7.81 0 00-2.43-5.45zM12 15.86a5.93 5.93 0 01-1.16-11.75 6 6 0 013.43.34A5.93 5.93 0 0112 15.86z",
            fill: "currentColor"
        })
    });



const $10f5ddf89196c1b3$export$95370c06e572a672 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 13a1 1 0 00.71-.29C18 12.37 21 9.34 21 6.8A3.93 3.93 0 0017 3a3.93 3.93 0 00-4 3.8c0 2.54 3 5.57 3.29 5.91A.998.998 0 0017 13zm-1-6a1 1 0 112 0 1 1 0 01-2 0zm1 8a1 1 0 00-1 1v2h-3a1 1 0 100 2h3a2 2 0 002-2v-2a1 1 0 00-1-1zM11 4H8a2 2 0 00-2 2v1a1 1 0 002 0V6h3a1 1 0 100-2zM8 9H5a2 2 0 00-2 2v8a2 2 0 002 2h3a2 2 0 002-2v-8a2 2 0 00-2-2zM6.5 19a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $e7677f8dc08d6469$export$5030803b733fa252 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17.66 4.34A8 8 0 004 10c0 5 5.94 10.8 6.62 11.45a2 2 0 002.76 0C14.06 20.8 20 15 20 10a8 8 0 00-2.34-5.66zM12 16a6 6 0 110-12 6 6 0 010 12z",
            fill: "currentColor"
        })
    });



const $649d0620865346a0$export$c5d4ab0bf1e2e70e = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17.66 4.34A8 8 0 004 10c0 5 5.94 10.8 6.62 11.45a2 2 0 002.76 0C14.06 20.8 20 15 20 10a8 8 0 00-2.34-5.66zM12 16a6 6 0 110-12 6 6 0 010 12zm0-9a3 3 0 100 6 3 3 0 000-6z",
            fill: "currentColor"
        })
    });



const $c5f1cb3445dba27c$export$71ce4e346b6fce52 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17.66 4.34A8 8 0 004 10c0 5 5.94 10.8 6.62 11.45a2 2 0 002.76 0C14.06 20.8 20 15 20 10a8 8 0 00-2.34-5.66zM12 16a6 6 0 01-5.54-3.71 5.86 5.86 0 01-.34-3.46 6 6 0 011.64-3.07 6.08 6.08 0 013.07-1.65A6 6 0 1112 16zm0-4a1 1 0 00-.56.17.94.94 0 00-.36.45.93.93 0 00-.06.57 1 1 0 00.78.79c.195.038.397.017.58-.06a.91.91 0 00.45-.37 1 1 0 00-.12-1.26A.999.999 0 0012 12zm0-3a4 4 0 00-2.67 1 1 1 0 00-.26.31 1 1 0 00-.07.39 1.07 1.07 0 000 .4c.04.13.109.25.2.35.096.097.208.178.33.24.127.055.262.085.4.09a.881.881 0 00.39-.08 1 1 0 00.34-.22 2 2 0 012.66 0 1 1 0 00.67.26.902.902 0 00.4-.09 1 1 0 00.28-1.65A4 4 0 0012 9zm3.5-2.1a7.12 7.12 0 00-7 0 .93.93 0 00-.3.26.88.88 0 00-.2.35c-.02.13-.02.26 0 .39a1 1 0 00.39.66.88.88 0 00.35.17 1 1 0 00.39 0 1 1 0 00.37-.13 5.06 5.06 0 015 0 1 1 0 001.11-.07A.93.93 0 0016 8a1 1 0 000-.65 1.05 1.05 0 00-.5-.45z",
            fill: "currentColor"
        })
    });



const $747f7d5d994b0e6e$export$7f0fb0ddd870252e = (r)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8 3c-1.24-.03-2.44.43-3.34 1.29-.9.85-1.42 2.03-1.46 3.27 0 3.05 3.55 6.69 3.96 7.09.22.22.53.35.85.35.32 0 .62-.13.85-.35.41-.4 3.96-4.04 3.96-7.09a4.662 4.662 0 00-1.46-3.27c-.9-.85-2.1-1.32-3.34-1.29H8zm0 6.6c-.36 0-.7-.11-1-.3-.3-.2-.53-.48-.66-.81-.14-.33-.17-.69-.1-1.04.07-.35.24-.67.49-.92s.57-.42.92-.49c.35-.07.71-.03 1.04.1.33.14.61.37.81.66.2.3.3.64.3 1 0 .48-.19.94-.53 1.27-.34.33-.8.53-1.27.53z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M20.71 13.96c-.19-.28-.45-.5-.76-.62l-1.16-3.49c-.18-.5-.5-.93-.94-1.23-.43-.3-.95-.47-1.48-.47h-1.61c-.05.56-.18 1.11-.35 1.66h2.01c.19 0 .37.04.52.15.15.1.27.26.33.43l.85 2.82h-5.47c-1 1.44-2.04 2.51-2.4 2.87-.6.6-1.41.93-2.26.93-.85 0-1.65-.33-2.25-.92-.26-.26-.9-.91-1.61-1.81-.08.2-.14.41-.14.63v2.55c0 .3.08.59.23.84.15.26.36.47.62.62v1.09a.857.857 0 00.85.85.857.857 0 00.85-.85v-.85h11.9v.85a.857.857 0 00.85.85.857.857 0 00.85-.85v-1.09c.26-.15.47-.36.62-.62.15-.26.23-.55.23-.84v-2.55c0-.33-.1-.66-.29-.94l.01-.01zm-2.51 2.38a.852.852 0 01-1.08.11.821.821 0 01-.31-.38c-.07-.15-.09-.31-.07-.48.03-.17.11-.32.23-.45.12-.12.28-.2.45-.23a.9.9 0 01.49.05c.16.06.29.17.38.31a.852.852 0 01-.11 1.08l.02-.01z",
                fill: "currentColor"
            })
        ]
    });



const $9f80f88a86bc642d$export$f40ec615c60c394e = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M8 20H6a1 1 0 000 2h2a1 1 0 000-2zm6-18h-4a6 6 0 00-6 6v7a3 3 0 003 3h10a3 3 0 003-3V8a6 6 0 00-6-6zM7 15a1 1 0 110-2 1 1 0 010 2zm4-5a1 1 0 01-1 1H7a1 1 0 01-1-1V8a1 1 0 011-1h3a1 1 0 011 1v2zm6 5a1 1 0 110-2 1 1 0 010 2zm1-5a1 1 0 01-1 1h-3a1 1 0 01-1-1V8a1 1 0 011-1h3a1 1 0 011 1v2zm0 10h-2a1 1 0 000 2h2a1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $9a3ee9600211c0d2$export$50545dbe524fcdfc = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M2.59 7.91l9 4a1 1 0 00.82 0l9-4a1 1 0 000-1.82l-9-4a1 1 0 00-.82 0l-9 4a1 1 0 000 1.82zm18.82 8.18l-1.11-.5-7.08 3.15a3 3 0 01-2.44 0L3.7 15.59l-1.11.5a1 1 0 000 1.82l9 4a1 1 0 00.82 0l9-4a1 1 0 000-1.82zm0-5l-1.11-.5-7.08 3.15a3 3 0 01-2.44 0L3.7 10.59l-1.11.5a1 1 0 000 1.82l9 4a1 1 0 00.82 0l9-4a1 1 0 000-1.82z",
            fill: "currentColor"
        })
    });



const $9062c1d046c552ab$export$6991f68eb2ed8c3 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M3 9h6a1 1 0 001-1V5a1 1 0 00-1-1H7v2H5V4H3a1 1 0 00-1 1v3a1 1 0 001 1zm17 5.18v-2.35a3 3 0 00-.88-2.12L18 8.59V8h1a1 1 0 001-1V5a1 1 0 00-.9-1A2 2 0 0017 6h-2a1 1 0 100 2h1v4.5a1.5 1.5 0 01-1.5 1.5h-3a1.5 1.5 0 01-1.5-1.5V11a1 1 0 00-1-1H5a3 3 0 00-3 3v3a1 1 0 001 1h1a3 3 0 006 0h6a3 3 0 104-2.82zM7 18a1 1 0 01-1-1h2a1 1 0 01-1 1zm12 0a1 1 0 01-1-1h1a1 1 0 00.85-.5 1 1 0 01.15.5 1 1 0 01-1 1z",
            fill: "currentColor"
        })
    });



const $04002c3c873ce88b$export$694152775a809df = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 14.18v-2.35a3 3 0 00-.88-2.12L18 8.59V8h1a1 1 0 001-1V5a1 1 0 00-.9-1A2 2 0 0017 6h-2a1 1 0 100 2h1v4.5a1.5 1.5 0 01-1.5 1.5h-3a1.5 1.5 0 01-1.5-1.5V9a1 1 0 00-1-1H4a1 1 0 000 2h1a3 3 0 00-3 3v3a1 1 0 001 1h1a3 3 0 006 0h6a3 3 0 104-2.82zM7 18a1 1 0 01-1-1h2a1 1 0 01-1 1zm12 0a1 1 0 01-1-1h1a1 1 0 00.85-.5 1 1 0 01.15.5 1 1 0 01-1 1z",
            fill: "currentColor"
        })
    });



const $cbeea5e097738ef3$export$178eb0e7516e134b = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.83 13.13L18.6 7.6A2 2 0 0020.5 9a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5 2 2 0 00-2 2c-.01.086-.01.173 0 .26L18 4.78A1 1 0 0017 4h-2a1 1 0 100 2h1.2l.37 1.7A3.4 3.4 0 0014.5 7h-2a3.5 3.5 0 00-3.15 2H4a2 2 0 100 4h1a3 3 0 102.82 4h5.35a3 3 0 002.12-.88l.79-.79a2.999 2.999 0 103.75-2.2zM5 17a1 1 0 110-2 1 1 0 010 2zm14 0a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $a94f52c1525826d7$export$8182dc45652372f2 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M22 14v-1.53a3.26 3.26 0 00-.32-1.34l-1.24-2.47A3 3 0 0017.76 7H16V6a2 2 0 00-2-2h-2v5a1 1 0 01-.62.92.84.84 0 01-.38.08.999.999 0 01-.71-.29L9 8.41l-1.29 1.3a1 1 0 01-1.09.21A1 1 0 016 9V4H4a2 2 0 00-2 2v10a2 2 0 002 2h.18a3 3 0 005.64 0h4.36a3 3 0 005.64 0H20a2 2 0 002-2v-2zM7 18a1 1 0 110-2 1 1 0 010 2zm10 0a1 1 0 110-2 1 1 0 010 2zm-1-6V9h1.76a1 1 0 01.89.55L19.88 12H16z",
            fill: "currentColor"
        })
    });



const $b126157518b2ee9e$export$af70a3258973579c = (h)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 2a10 10 0 100 20 10 10 0 000-20zm1.5 11.5h-3v2a1 1 0 01-2 0v-7a1 1 0 011-1h4a3 3 0 110 6z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M13.5 9.5h-3v2h3a1 1 0 000-2z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M13.5 9.5h-3v2h3a1 1 0 000-2zM12 2a10 10 0 100 20 10 10 0 000-20zm1.5 11.5h-3v2a1 1 0 01-2 0v-7a1 1 0 011-1h4a3 3 0 110 6z",
                fill: "currentColor"
            })
        ]
    });



const $ba105b798c19158b$export$ef0dab24a86134d3 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.25 15.16l-2.77-1.38-2.07-7.06a1 1 0 00-.52-.61l-2-1a1 1 0 00-1.44.95l.27 4.85-2.51-1.26-.16-2.89a1 1 0 00-.56-.84l-2-1a1 1 0 00-.91 0 1 1 0 00-.52.74l-.48 3.39a3 3 0 00.57 2.23l.1.13c.58.78 1.338 1.41 2.21 1.84l11.11 5.54a2.001 2.001 0 002.76-1.09 2.07 2.07 0 00-1.08-2.54z",
            fill: "currentColor"
        })
    });



const $271a4d20e24d17fb$export$ad0efef0e637cb88 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.61 7.82A2.06 2.06 0 0019 7.26l-2.76 1.39-6.89-2.59a1 1 0 00-.8.05l-2 1a1 1 0 00-.55.83 1 1 0 00.45.89l4 2.69L8 12.78l-2.45-1.61a1 1 0 00-1-.06l-2 1a1 1 0 00-.505 1.199 1 1 0 00.245.401l2.42 2.41a3 3 0 002.12.88H7a6.29 6.29 0 002.79-.66l11.1-5.55a2 2 0 00.72-2.97z",
            fill: "currentColor"
        })
    });



const $4f5f042f8ecbb356$export$5598ad067fe5e6b4 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M5 15a1 1 0 000 2h14a1 1 0 000-2h-1v-4h1a1 1 0 000-2h-1A6 6 0 106 9H5a1 1 0 000 2h1v4H5zm3-4h8v4H8v-4zm12 8H4a1 1 0 000 2h16a1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $d1b8df33bbdf7e89$export$e624cda0b8efc09f = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 13a6.209 6.209 0 00-4.71 2.29l-.29.29V6a1 1 0 012 0 1 1 0 002 0 3 3 0 00-6 0v2H7V6a1 1 0 012 0 1 1 0 002 0 3 3 0 00-6 0v7.09A6.197 6.197 0 004 13a1 1 0 00-1 1v6a1 1 0 001 1h16a1 1 0 001-1v-6a1 1 0 00-1-1zm-7 3.88a4.28 4.28 0 01-1 .12c-1.59 0-2.34-.75-3.29-1.71A11.31 11.31 0 007.23 14H13v2.88zM13 12H7v-2h6v2z",
            fill: "currentColor"
        })
    });



const $284aee5cf66a6108$export$5d90abf6335088f0 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.55 8.17l-7.13-4.73a2.52 2.52 0 00-2.82 0L3.45 8.17a1 1 0 101.1 1.66l7.17-4.74a.5.5 0 01.58 0l7.15 4.73A.94.94 0 0020 10a1 1 0 00.55-1.83zM18 14h-.18l-.68-3.39a2 2 0 00-2-1.61H8.82a2 2 0 00-2 1.61L6.18 14H6a1 1 0 00-1 1v3a1 1 0 001 1v1a1 1 0 002 0v-1h8v1a1 1 0 002 0v-1a1 1 0 001-1v-3a1 1 0 00-1-1zm-9.18-3h6.36l.6 3H8.22l.6-3zM8 17.5a1 1 0 110-2 1 1 0 010 2zm8 0a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $7cf6e3362bad90cd$export$a12e5d6aa4d2d367 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M11 3a1.06 1.06 0 00-1 1.11V11H9V4a1 1 0 10-2 0v7H6V4.11A1.06 1.06 0 005 3a1.06 1.06 0 00-1 1.11V12a1 1 0 001 1h2v7a1 1 0 102 0v-7h2a1 1 0 001-1v-.05-7.84A1.06 1.06 0 0011 3zm4 0a1 1 0 00-1 1v16a1 1 0 002 0v-4h3a1 1 0 001-1V8a5 5 0 00-5-5z",
            fill: "currentColor"
        })
    });



const $721c120bd8a13165$export$e8c3414c683075ca = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 15h-4a3 3 0 00-3 3 1 1 0 01-1 1H7a1 1 0 100 2h4a3 3 0 003-3 1 1 0 011-1h4a1 1 0 000-2zm-2-2a1 1 0 00.71-.29C18 12.37 21 9.34 21 6.8A3.93 3.93 0 0017 3a3.93 3.93 0 00-4 3.8c0 2.54 3 5.57 3.29 5.91A.998.998 0 0017 13zm-1-6a1 1 0 112 0 1 1 0 01-2 0zM7 17a1 1 0 00.71-.29C8 16.37 11 13.34 11 10.8A3.93 3.93 0 007 7a3.93 3.93 0 00-4 3.8c0 2.54 3 5.57 3.29 5.91A.999.999 0 007 17zm-1-6a1 1 0 112 0 1 1 0 01-2 0z",
            fill: "currentColor"
        })
    });



const $8e78652c50c99390$export$278c782a46f3886d = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17.65 2.07a3 3 0 00-3.58 2.28L13.48 7H12a4 4 0 00-4 4H7a3 3 0 000 6h3v2H7a1 1 0 000 2h8a1 1 0 000-2h-3v-2h3a3 3 0 002.93-2.35l2-9a3 3 0 00-2.28-3.58zM10 11a2 2 0 012-2h1l-.45 2H10z",
            fill: "currentColor"
        })
    });



const $d12fed82ddbc1118$export$9c4e36747a9ca39e = (v)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...v,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M9 8a1 1 0 100 2 1 1 0 000-2zm11.78 4.16L19.4 7.05a3 3 0 00-2.84-2h-.06V4a1 1 0 00-1-1h-1a1 1 0 00-1 1v1H7.41a3 3 0 00-2.87 2.12l-1.33 5.05A2 2 0 002 14v2a2 2 0 001 1.72V19a1 1 0 102 0v-1h14v1a1 1 0 002 0v-1.28A2 2 0 0022 16v-2a2 2 0 00-1.22-1.84zM6.71 15.71a1 1 0 01-1.27.12.94.94 0 01-.36-.45A1 1 0 015 14.8a1 1 0 01.8-.8 1 1 0 01.58.06.94.94 0 01.45.36 1 1 0 01-.12 1.27v.02zM15 11a2 2 0 00-1.72 1h-2.56a2 2 0 00-3.44 0h-2l1.18-4.31a1 1 0 011-.69h9.15a1 1 0 01.93.63L18.67 12h-2A2 2 0 0015 11zm3.71 4.71a1 1 0 01-1.27.12.94.94 0 01-.36-.45 1 1 0 01-.08-.58 1 1 0 01.8-.8 1 1 0 01.58.06.94.94 0 01.45.36 1 1 0 01-.12 1.27v.02zM15 8a1 1 0 100 2 1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $d465b85f14db6972$export$c8151f99d3823830 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 10h-3V9h-2v1h-4a3 3 0 00-6 0H4a1 1 0 000 2v7a2 2 0 002 2h12a2 2 0 002-2v-7a1 1 0 000-2zm-7-2h6a1 1 0 001-1V4a1 1 0 00-1-1h-6a1 1 0 00-1 1v3a1 1 0 001 1zM8 6a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
            fill: "currentColor"
        })
    });



const $7e570c073025fb6e$export$4ce4fb6fdde132bd = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 10H6v6h13a3 3 0 000-6zM2 16h2v-6H2v6zm9-12a1 1 0 00-2 0 1 1 0 01-1 1H5a3 3 0 00-3 3 1 1 0 002 0 1 1 0 011-1h3a3 3 0 003-3z",
            fill: "currentColor"
        })
    });



const $e58d9b435fd8653b$export$32a58a90b0c39316 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 10h-3.56l5-5A1.036 1.036 0 0019 3.51L3.51 19A1.054 1.054 0 105 20.49L9.44 16H19a3 3 0 000-6zM3 9a1 1 0 001-1 1 1 0 011-1h3a3 3 0 003-3 1 1 0 00-2 0 1 1 0 01-1 1H5a3 3 0 00-3 3 1 1 0 001 1zm3 4.76L9.76 10H6v3.76zM4 10H2v6h2v-6z",
            fill: "currentColor"
        })
    });



const $cff6b75427eb4e2f$export$43ccf526f7f654ef = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 7a2 2 0 00-2-2H7a2 2 0 00-2 2v5h14V7zm2 2a1 1 0 00-1 1v3H4v-3a1 1 0 00-2 0v6a1 1 0 001 1h1v1a1 1 0 102 0v-1h12v1a1 1 0 002 0v-1h1a1 1 0 001-1v-6a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $0b302c27d54083c0$export$161970f9a4bbefed = (v)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...v,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a8 8 0 00-8 8v11a1 1 0 001 1h14a1 1 0 001-1V10a8 8 0 00-8-8zm6 18H6v-1a1 1 0 011-1h11v2zm0-4H8v-1a1 1 0 011-1h9v2zm0-4h-8v-1a1 1 0 011-1h7v2z",
            fill: "currentColor"
        })
    });



const $bf076ada164e5bd5$export$f8a7988c9a3be656 = (v)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...v,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7 8h3a1 1 0 001-1V5a1 1 0 00-1-1H7a1 1 0 00-1 1v2a1 1 0 001 1zm7 8h3a1 1 0 001-1v-2a1 1 0 00-1-1h-3a1 1 0 00-1 1v2a1 1 0 001 1zm-7 0h3a1 1 0 001-1v-2a1 1 0 00-1-1H7a1 1 0 00-1 1v2a1 1 0 001 1zM20 3a1 1 0 00-1 1v5H5V4a1 1 0 00-2 0v16a1 1 0 102 0v-1h14v1a1 1 0 002 0V4a1 1 0 00-1-1zm-1 14H5v-6h14v6z",
            fill: "currentColor"
        })
    });



const $82665610512922a1$export$9f32ff50e49198cc = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.77 11.16L19.4 7.05a3 3 0 00-2.84-2H15V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v1H7.41a3 3 0 00-2.85 2.07l-1.34 4.09A2 2 0 002 13v3a2 2 0 001 1.72V19a1 1 0 102 0v-1h14v1a1 1 0 002 0v-1.28A2 2 0 0022 16v-3a2 2 0 00-1.23-1.84zM6.46 7.69a1 1 0 011-.69h9.15a1 1 0 011 .68l1 3.32H5.38l1.08-3.31zm.25 7a1 1 0 01-1.27.12.94.94 0 01-.36-.45A1 1 0 015 13.8a1 1 0 01.8-.8 1 1 0 01.58.06.94.94 0 01.45.36 1 1 0 01-.12 1.27zm12 0a1 1 0 01-1.27.12.94.94 0 01-.36-.45 1 1 0 01-.08-.56 1 1 0 01.8-.8 1 1 0 01.58.06.94.94 0 01.45.36 1 1 0 01-.12 1.27z",
            fill: "currentColor"
        })
    });



const $18adaa44e9772e87$export$978c0ec05eb7caff = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18.74 9.14a4.31 4.31 0 00-.11-3.35C17.94 4.4 16.45 3.47 14.2 3a5.15 5.15 0 01-1.6-.82l-.09-.05a.18.18 0 01-.07 0h-.54a.701.701 0 00-.14 0h-.13l-.08.05h-.09A4.55 4.55 0 019.81 3c-2.24.42-3.74 1.34-4.43 2.72a4.36 4.36 0 00-.12 3.4A2 2 0 004 11v9a2 2 0 002 2h4v-4.89A2.07 2.07 0 0111.66 15 2 2 0 0114 17v5h4a2 2 0 002-2v-9a2 2 0 00-1.26-1.86z",
            fill: "currentColor"
        })
    });



const $ccd81e9c2e735803$export$34a7a229711bf25b = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M6 12h12a1 1 0 001-1V5a1 1 0 00-1-1H6a1 1 0 00-1 1v6a1 1 0 001 1zm14 2H4a2 2 0 00-2 2v2a2 2 0 002 2h16a2 2 0 002-2v-2a2 2 0 00-2-2zM5.5 18.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zM14 18h-4a1 1 0 010-2h4a1 1 0 010 2zm4.5.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3z",
            fill: "currentColor"
        })
    });



const $1a823f332deaa190$export$dc99d9cb786617b6 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 4H5a3 3 0 00-3 3v10a3 3 0 003 3h14a3 3 0 003-3V7a3 3 0 00-3-3zm-7 12a1 1 0 01-2 0v-5l-.88.7a1 1 0 01-1.24-1.57l2.5-2A1 1 0 0112 9v7zm5 1a1 1 0 110-2 1 1 0 010 2zm0-4a1 1 0 110-2 1 1 0 010 2zm0-4a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $3b773d85680146e4$export$d542207e9751cbf7 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 4H5a3 3 0 00-3 3v10a3 3 0 003 3h14a3 3 0 003-3V7a3 3 0 00-3-3zM6 7h2a1 1 0 010 2H6a1 1 0 010-2zm6 10H6a1 1 0 010-2h6a1 1 0 010 2zm0-4H6a1 1 0 010-2h6a1 1 0 010 2zm5 4a1 1 0 110-2 1 1 0 010 2zm0-4a1 1 0 110-2 1 1 0 010 2zm0-4a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $c37dbba3c453fe04$export$f84ee556c24d8b4b = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7.78 13h1.94l.5-2H8.28l-.5 2zM19 4H5a3 3 0 00-3 3v10a3 3 0 003 3h14a3 3 0 003-3V7a3 3 0 00-3-3zm-6 7h-.72l-.5 2H12a1 1 0 010 2h-.72L11 16.24a1.029 1.029 0 01-2-.48l.22-.76H7.28L7 16.24a1.028 1.028 0 11-2-.48l.22-.76H5a1 1 0 010-2h.72l.5-2H6a1 1 0 010-2h.72L7 7.76a1.028 1.028 0 112 .48L8.78 9h1.94L11 7.76a1.029 1.029 0 012 .48l-.22.76H13a1 1 0 110 2zm4 6a1 1 0 110-2 1 1 0 010 2zm0-4a1 1 0 110-2 1 1 0 010 2zm0-4a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $bce0092993b4dbe4$export$860da00231e8eb32 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7 16H6v-1a1 1 0 10-2 0v1H3a1 1 0 000 2h1v1a1 1 0 102 0v-1h1a1 1 0 000-2zM19 4H5a3 3 0 00-3 3v6a5 5 0 017 7h10a3 3 0 003-3V7a3 3 0 00-3-3zm-2 13a1 1 0 110-2 1 1 0 010 2zm0-4a1 1 0 110-2 1 1 0 010 2zm0-4a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $20e6d5cf173cd7b4$export$64bf3411fa58b008 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 4H5a3 3 0 00-3 3v10a3 3 0 003 3h14a3 3 0 003-3V7a3 3 0 00-3-3zm-6.29 6.71l-4 4a1 1 0 01-1.42 0l-2-2a1.004 1.004 0 011.42-1.42L8 12.59l3.29-3.3a1.004 1.004 0 011.42 1.42zM17 17a1 1 0 110-2 1 1 0 010 2zm0-4a1 1 0 110-2 1 1 0 010 2zm0-4a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $6c10d497c8e70016$export$b3b6083cb173fdee = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 4H5a3 3 0 00-3 3v10a3 3 0 003 3h14a3 3 0 003-3V7a3 3 0 00-3-3zm-2 13a1 1 0 110-2 1 1 0 010 2zm0-4a1 1 0 110-2 1 1 0 010 2zm0-4a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $a88b1117640a3e14$export$8611ba96a0b712fb = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M8 8.61a2 2 0 00-4 0l-1 5a2 2 0 00.41 1.66A2 2 0 005 16v4a1 1 0 102 0v-4a2.001 2.001 0 001.55-.73A2 2 0 009 13.61l-1-5zM6 6a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm12 0a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm-6-3a1 1 0 00-1 1v16a1 1 0 002 0V4a1 1 0 00-1-1zm7 4h-2a2 2 0 00-2 2v5a2 2 0 002 2v4a1 1 0 002 0v-4a2 2 0 002-2V9a2 2 0 00-2-2z",
            fill: "currentColor"
        })
    });



const $9133282efd333668$export$a1acfef2579e52f8 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21 7h-3a1 1 0 00-1-1h-3a1 1 0 00-1 1h-2a3 3 0 00-3-3H6a3 3 0 00-3 3v11a1 1 0 000 2h8a1 1 0 000-2V9h2a1 1 0 001 1h3a1 1 0 001-1h2v10a1 1 0 002 0V8a1 1 0 00-1-1zM7 9a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $a2389053046807af$export$4c1962a6c64ce60f = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 12a5 5 0 100 10 5 5 0 000-10zm1.5 6a1 1 0 01-1 1h-2a1 1 0 010-2h1v-1.5a1 1 0 012 0V18zm-8.19-3.06c-.1.035-.204.055-.31.06H7a1 1 0 01-1-1v-4a1 1 0 011-1h3a1 1 0 011 1v3.41a7.08 7.08 0 012-2.15V10a1 1 0 011-1h3a1 1 0 011 1v.08c.694.098 1.37.304 2 .61V10a6 6 0 00-4-5.66V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v.34A6 6 0 004 10v9a3 3 0 003 3h5.11a7 7 0 01-1.8-7.06zM7 19a1 1 0 110-2 1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $2e1b496b558abb98$export$d8fa2c79a1245d14 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 5.09V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v.09A6 6 0 003 11v7a3 3 0 003 3h12a3 3 0 003-3v-7a6 6 0 00-5-5.91zM6 18a1 1 0 110-2 1 1 0 010 2zm5-5a1 1 0 01-1 1H6a1 1 0 01-1-1v-2a1 1 0 011-1h4a1 1 0 011 1v2zm7 5a1 1 0 110-2 1 1 0 010 2zm1-5a1 1 0 01-1 1h-4a1 1 0 01-1-1v-2a1 1 0 011-1h4a1 1 0 011 1v2z",
            fill: "currentColor"
        })
    });



const $29315215575fdf19$export$aadaaa99c465ec63 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7 14h10a2 2 0 002-2V6a4 4 0 00-4-4H9a4 4 0 00-4 4v6a2 2 0 002 2zm9-2a1 1 0 110-2 1 1 0 010 2zm-3-6a1 1 0 011-1h2a1 1 0 011 1v1a1 1 0 01-1 1h-2a1 1 0 01-1-1V6zM7 6a1 1 0 011-1h2a1 1 0 011 1v1a1 1 0 01-1 1H8a1 1 0 01-1-1V6zm1 4a1 1 0 110 2 1 1 0 010-2zm11 10H5a1 1 0 000 2h14a1 1 0 000-2zM8 16a1 1 0 000 2h8a1 1 0 000-2H8z",
            fill: "currentColor"
        })
    });



const $6237efc8094da17d$export$7c266bee79a87e14 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 4.34V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v.34A6 6 0 004 10v9a3 3 0 003 3h10a3 3 0 003-3v-9a6 6 0 00-4-5.66zM7 19a1 1 0 110-2 1 1 0 010 2zm4-5a1 1 0 01-1 1H7a1 1 0 01-1-1v-4a1 1 0 011-1h3a1 1 0 011 1v4zm6 5a1 1 0 110-2 1 1 0 010 2zm1-5a1 1 0 01-1 1h-3a1 1 0 01-1-1v-4a1 1 0 011-1h3a1 1 0 011 1v4z",
            fill: "currentColor"
        })
    });



const $2bf89bc9e2e921e8$export$d2ea0d5ac0d75ae = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M2 6v10a2 2 0 002 2h.18a3 3 0 005.64 0h4.36a3 3 0 005.64 0H20a2 2 0 002-2V12.47a3.3 3.3 0 00-.32-1.34l-1.24-2.47A3 3 0 0017.76 7H16V6a2 2 0 00-2-2H4a2 2 0 00-2 2zm14 11a1 1 0 112 0 1 1 0 01-2 0zm0-8h1.76a1 1 0 01.89.55L19.88 12H16V9zM6 17a1 1 0 112 0 1 1 0 01-2 0z",
            fill: "currentColor"
        })
    });



const $57bf53a230b75633$export$54e516415536b4f1 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm7 3.68a1 1 0 00-1.27-.63c-2.36.79-4.94-1.72-5-1.76a.81.81 0 00-.29-.19h-.09A.86.86 0 0012 6h-.08a.69.69 0 00-.24.05.42.42 0 00-.14.06.25.25 0 00-.09 0 20.87 20.87 0 00-5.28 5.28 1 1 0 00.28 1.38A.94.94 0 007 13a1 1 0 00.83-.45A18.458 18.458 0 0111 9.05v3.84a13.72 13.72 0 01-4.6 7.31 1 1 0 101.2 1.6 14.83 14.83 0 004.79-6.64 28.18 28.18 0 013.66 6.16A1 1 0 0017 22c.108-.003.216-.02.32-.05a1 1 0 00.68-1.27c-.92-2.75-4.08-6.91-4.95-8V9a6.4 6.4 0 005.32.93A1 1 0 0019 8.68z",
            fill: "currentColor"
        })
    });



const $e9ad4611ccfbcfa3$export$b594758813357e95 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.06 7.68l-7-4.38a2 2 0 00-2.12 0l-7 4.38A2 2 0 003 9.37V19a2 2 0 002 2v-8.5A1.5 1.5 0 016.5 11h11a1.5 1.5 0 011.5 1.5V21a2 2 0 002-2V9.37a2 2 0 00-.94-1.69zM14 9h-4a1 1 0 010-2h4a1 1 0 110 2zm-3.5 9h-3a.5.5 0 00-.5.5v2a.5.5 0 00.5.5h3a.5.5 0 00.5-.5v-2a.5.5 0 00-.5-.5zm0-5h-3a.5.5 0 00-.5.5v2a.5.5 0 00.5.5h3a.5.5 0 00.5-.5v-2a.5.5 0 00-.5-.5zm6 5h-3a.5.5 0 00-.5.5v2a.5.5 0 00.5.5h3a.5.5 0 00.5-.5v-2a.5.5 0 00-.5-.5zm0-5h-3a.5.5 0 00-.5.5v2a.5.5 0 00.5.5h3a.5.5 0 00.5-.5v-2a.5.5 0 00-.5-.5z",
            fill: "currentColor"
        })
    });



const $7bd3315ab766c870$export$97206720ba0829b4 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.12 4.88A3 3 0 0019 4H5a3 3 0 00-3 3v10a3 3 0 003 3h14a3 3 0 003-3V7a3 3 0 00-.88-2.12zM10.75 14v1a1 1 0 01-2 0v-1h-2.5a1 1 0 01-.99-1.12l.5-4a1.007 1.007 0 012 .24L7.38 12h1.37v-1a1 1 0 112 0v1a1 1 0 010 2zm7.82.43a1 1 0 01-1.64 1.14l-1.48-2.1-.7.88V15a1 1 0 01-2 0V9a1 1 0 012 0v2.15L17 8.38a1 1 0 011.56 1.24l-1.77 2.22 1.78 2.59z",
            fill: "currentColor"
        })
    });



const $74080882d871a25c$export$cdef3ad90e0a9ab7 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M8.32 12.77c-.47 0-.77.26-.77.79 0 .42.26.79.77.79s.77-.37.77-.79c0-.53-.3-.79-.77-.79zm0-1.61c.43 0 .7-.25.7-.75 0-.41-.24-.76-.7-.76-.46 0-.7.35-.7.76 0 .5.26.75.7.75zM19 4H5C3.34 4 2 5.34 2 7v10c0 1.66 1.34 3 3 3h14c1.66 0 3-1.34 3-3V7c0-1.66-1.34-3-3-3zM8.32 16.22c-1.63 0-2.77-.96-2.77-2.45 0-.76.22-1.31.8-1.8.05-.02.06-.06.06-.1 0-.04-.01-.06-.05-.1-.29-.31-.56-.94-.56-1.63 0-1.46 1.07-2.38 2.52-2.38s2.52.91 2.52 2.38c0 .7-.28 1.32-.56 1.63-.04.04-.05.06-.05.1 0 .04.01.07.06.1.59.49.8 1.04.8 1.8 0 1.49-1.14 2.45-2.77 2.45zm9.03 0c-.26 0-.53-.13-.76-.49l-1.64-2.62c-.04-.06-.06-.08-.11-.08-.04 0-.06.02-.08.05l-.38.47c-.07.1-.08.24-.08.36v1.46c0 .68-.55.85-1.03.85s-1.01-.17-1.01-.85V8.63c0-.68.55-.85 1.01-.85.48 0 1.03.17 1.03.85v1.73c0 .08.02.13.08.13.04 0 .06-.02.07-.04l1.75-2.27c.23-.3.48-.41.72-.41.47 0 1.09.47 1.09 1 0 .18-.07.38-.24.6l-1.54 1.93s-.06.07-.06.11c0 .04.04.1.06.13l2.03 3.15c.13.2.18.38.18.55 0 .52-.61.97-1.09.97v.01z",
            fill: "currentColor"
        })
    });



const $6b24b0fa120f9ddf$export$bc0e3c62b30173c1 = (l)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M20.12 6.77c-.56-.5-1.33-.78-2.12-.78H6c-.8 0-1.56.28-2.12.78S3 7.95 3 8.66v10.67c0 .71.32 1.39.88 1.89S5.21 22 6 22h12c.8 0 1.56-.28 2.12-.78s.88-1.18.88-1.89V8.66c0-.71-.32-1.39-.88-1.89zM19 15.08l-2.79-2.8a.955.955 0 00-.33-.22.995.995 0 00-.38-.08c-.13 0-.26.03-.38.08s-.23.13-.33.22l-4.29 4.3-1.29-1.3a.955.955 0 00-.33-.22.995.995 0 00-.38-.08c-.13 0-.26.03-.38.08s-.23.13-.33.22L5 18.08V8.99c0-.27.11-.52.29-.71.18-.19.44-.29.71-.29h12c.27 0 .52.11.71.29.19.18.29.44.29.71v6.09z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8.5 10c-.3 0-.59.09-.83.25s-.44.4-.55.67c-.11.27-.14.58-.09.87.05.29.2.56.41.77.21.21.48.35.77.41.29.06.59.03.87-.09.27-.11.51-.31.67-.55A1.499 1.499 0 008.5 10zM6 4.99h12c.55 0 1-.45 1-1s-.45-1-1-1H6c-.55 0-1 .45-1 1s.45 1 1 1z",
                fill: "currentColor"
            })
        ]
    });



const $d3d53862bc778ea5$export$87cf9b376f268d1c = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M20.11 6.16L15.5 8.82a.996.996 0 000 1.73l6.26 3.61c.15-.7.24-1.42.24-2.17 0-2.18-.71-4.19-1.89-5.84v.01zM12.5 8.24l6.26-3.61A9.97 9.97 0 0011 2.06v5.32c0 .77.83 1.25 1.5.87v-.01zM9 9.68V2.47c-.68.22-1.35.5-2 .87A9.931 9.931 0 002.89 7.9l4.61 2.66c.67.38 1.5-.1 1.5-.87v-.01zm-.5 3.75L2.24 9.82c-.15.7-.24 1.42-.24 2.17 0 2.18.71 4.19 1.89 5.84l4.61-2.66a.996.996 0 000-1.73v-.01zm3 2.31l-6.26 3.61A9.97 9.97 0 0013 21.92V16.6c0-.77-.83-1.25-1.5-.87v.01zM15 14.3v7.23c.68-.22 1.35-.5 2-.87a9.931 9.931 0 004.11-4.56l-4.61-2.66c-.67-.38-1.5.1-1.5.87v-.01z",
            fill: "currentColor"
        })
    });



const $f8cf0d38e2ee897f$export$95dcf9de0672d52e = (v)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...v,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M6 6a1 1 0 00-1 1v10a1 1 0 102 0V7a1 1 0 00-1-1zm3 3a1 1 0 00-1 1v4a1 1 0 102 0v-4a1 1 0 00-1-1zM3 9a1 1 0 00-1 1v4a1 1 0 102 0v-4a1 1 0 00-1-1zm18 1a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1zm-9-7a1 1 0 00-1 1v16a1 1 0 002 0V4a1 1 0 00-1-1zm6 3a1 1 0 00-1 1v10a1 1 0 002 0V7a1 1 0 00-1-1zm-3 2a1 1 0 00-1 1v6a1 1 0 002 0V9a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $d2bcf8cb4bbe47cf$export$ece4e3a218ef6263 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7.76 14.83L5.64 17a1 1 0 000 1.41 1 1 0 00.7.3 1 1 0 00.71-.3l2.12-2.12a1 1 0 00-1.41-1.41v-.05zM8 12a1 1 0 00-1-1H4a1 1 0 000 2h3a1 1 0 001-1zm7.54-2.54a1 1 0 00.7-.29l2.12-2.12A1 1 0 1017 5.64l-2.17 2.12a1 1 0 000 1.41 1 1 0 00.71.29zM7.05 5.64a1 1 0 00-1.41 1.41l2.12 2.12a1 1 0 001.41 0 1 1 0 000-1.41L7.05 5.64zM20 11h-3a1 1 0 000 2h3a1 1 0 000-2zm-8 5a1 1 0 00-1 1v3a1 1 0 002 0v-3a1 1 0 00-1-1zm4.24-1.17a1 1 0 00-1.41 1.41L17 18.36a1 1 0 00.71.3 1 1 0 00.7-.3 1 1 0 000-1.41l-2.17-2.12zM12 3a1 1 0 00-1 1v3a1 1 0 002 0V4a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $2bdaa38947e6d4b2$export$fbce3a8efe1c222e = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 8a4 4 0 100 8 4 4 0 000-8zm9 3h-1.07A8 8 0 0013 4.07V3a1 1 0 00-2 0v1.07A8 8 0 004.07 11H3a1 1 0 000 2h1.07A8 8 0 0011 19.93V21a1 1 0 002 0v-1-.07A8 8 0 0019.93 13H21a1 1 0 000-2zm-9 7a6 6 0 110-12 6 6 0 010 12z",
            fill: "currentColor"
        })
    });



const $ed9c8b5b9a9c6075$export$fefb51290df4435a = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 4H5a3 3 0 00-3 3v10a3 3 0 003 3h14a3 3 0 003-3V7a3 3 0 00-3-3zM7 16a1 1 0 01-1-1V9a1 1 0 011-1 4 4 0 010 8zm11-1a1 1 0 01-1 1 4 4 0 110-8 1 1 0 011 1v6z",
            fill: "currentColor"
        })
    });



const $23595d2a0709aae4$export$3bb7f3e47b53ed61 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 11h-9.18a3 3 0 00-5.64 0H4a1 1 0 000 2h1.18a3 3 0 005.64 0H20a1 1 0 100-2zM8 13a1 1 0 110-2 1 1 0 010 2zm12 4h-1.18a3 3 0 00-5.64 0H5a1 1 0 000 2h8.18a3 3 0 005.64 0H20a1 1 0 100-2zm-4 2a1 1 0 110-2 1 1 0 010 2zM4 7h9.18a3 3 0 005.64 0H20a1 1 0 100-2h-1.18a3 3 0 00-5.64 0H4a1 1 0 000 2zm12-2a1 1 0 110 2 1 1 0 010-2z",
            fill: "currentColor"
        })
    });



const $68f240c38fc6e053$export$98e7e2d91768aa2 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16.54 9.47h-2.67l2-5.48a1.48 1.48 0 00-2.54-1.43l-7.7 9.62a2 2 0 001.54 3.2h2.8L8.16 20a1.48 1.48 0 002.52 1.48l7.37-8.75a2 2 0 00-1.51-3.26zM6 7.68a.51.51 0 00.5.32c.06.01.12.01.18 0A.52.52 0 007 7.32l-1.5-4a.52.52 0 00-.94 0L3 7.32a.52.52 0 00.32.68.51.51 0 00.68-.32L4.22 7h1.56l.22.68zM4.6 6L5 4.92 5.4 6h-.8z",
            fill: "currentColor"
        })
    });



const $91711f8c81672703$export$f495aad6f8d051b = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M14.71 11.29l-7-7a1.004 1.004 0 10-1.42 1.42l6.3 6.29-6.3 6.29a.999.999 0 000 1.42 1 1 0 001.42 0l7-7a.999.999 0 000-1.42zm5 0l-7-7a1.004 1.004 0 10-1.42 1.42l6.3 6.29-6.3 6.29a1 1 0 000 1.42 1.001 1.001 0 001.42 0l7-7a.999.999 0 000-1.42z",
            fill: "currentColor"
        })
    });



const $7e67006901b5035e$export$fd044e8f4482bb09 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17.69 7.39c-.44 0-.85-.09-1.28-.39-.18-.13-.36-.25-.55-.25-.42 0-.83.42-.83.82 0 .26.15.43.26.56.49.55 1.39.88 2.4.88 1.51 0 2.56-.81 2.56-2.12 0-1.04-.66-1.67-1.87-2.08l-.88-.3c-.38-.13-.6-.29-.6-.48 0-.25.32-.42.8-.42.32 0 .74.13 1.07.32.13.07.24.15.45.15.36 0 .79-.44.79-.85 0-.25-.12-.45-.35-.62-.45-.33-1.04-.62-1.96-.62-1.54 0-2.55.88-2.55 2.03s.71 1.7 1.84 2.08l.89.3c.4.14.63.25.63.48 0 .32-.33.51-.81.51h-.01zM10.19 9c.4 0 .85-.14.85-.71V6.74c0-.07.02-.09.09-.09h1.25c1.19 0 2.14-.75 2.14-2.3 0-1.55-.94-2.32-2.14-2.32h-2.24c-.42 0-.8.2-.8.77v5.49c0 .57.46.71.84.71h.01zm.85-5.25c0-.07.02-.09.09-.09h1c.38 0 .64.26.64.7 0 .44-.26.68-.64.68h-1c-.07 0-.09-.02-.09-.09v-1.2zM4.59 9c.4 0 .85-.14.85-.71V6.28c0-.07.02-.09.09-.09H7.1c.56 0 .73-.39.73-.8 0-.41-.17-.82-.73-.82H5.53c-.07 0-.09-.02-.09-.09v-.76c0-.07.02-.09.09-.09h2.2c.56 0 .73-.39.73-.8 0-.41-.17-.82-.73-.82H4.55c-.42 0-.8.2-.8.77v5.49c0 .57.46.71.84.71V9zM19 10H5c-1.66 0-3 1.34-3 3v6c0 1.66 1.34 3 3 3h14c1.66 0 3-1.34 3-3v-6c0-1.66-1.34-3-3-3zM7.64 19.18c0 .62-.45.82-.92.82-.47 0-.92-.19-.92-.82v-3.86s0-.1-.06-.1c-.04 0-.07.02-.1.06-.2.2-.41.28-.6.28-.45 0-.98-.45-.98-.94 0-.2.09-.43.32-.66l1.68-1.66c.25-.25.53-.3.67-.3.45 0 .91.24.91.97v6.22-.01zm3.68-.98h1.53c.64 0 .86.4.86.87s-.23.88-.86.88H9.79c-.74 0-1.01-.41-1.01-.88 0-.72.33-1.38 1.22-2.29l1.39-1.45c.34-.35.5-.61.5-.89 0-.4-.22-.67-.64-.67-.35 0-.59.16-.89.42-.14.12-.31.24-.59.24-.42 0-.93-.41-.93-.9 0-.32.17-.51.35-.7.45-.47 1.17-.83 2.06-.83 1.66 0 2.49 1 2.49 2.43 0 .59-.28 1.27-.95 1.99l-1.2 1.27c-.19.2-.25.28-.33.4 0 0-.02.03-.02.06 0 .06.09.06.09.06l-.01-.01zm5.95 1.8c-2.34 0-2.66-1.81-2.66-4s.32-4 2.66-4c2.34 0 2.66 1.81 2.66 4s-.32 4-2.66 4zm0-6.23c-.72 0-.77.7-.77 2.17v.11c0 1.47.06 2.17.77 2.17s.77-.7.77-2.17v-.1c0-1.48-.06-2.18-.77-2.18z",
            fill: "currentColor"
        })
    });



const $4241ed341d6ff4e8$export$971eb1399cfbea4c = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17.69 7.39c-.44 0-.85-.09-1.28-.39-.18-.13-.36-.25-.55-.25-.42 0-.83.42-.83.82 0 .26.15.43.26.56.49.55 1.39.88 2.4.88 1.51 0 2.56-.81 2.56-2.12 0-1.04-.66-1.67-1.87-2.08l-.88-.3c-.38-.13-.6-.29-.6-.48 0-.25.32-.42.8-.42.32 0 .74.13 1.07.32.13.07.24.15.45.15.36 0 .79-.44.79-.85 0-.25-.12-.45-.35-.62-.45-.33-1.04-.62-1.96-.62-1.54 0-2.55.88-2.55 2.03s.71 1.7 1.84 2.08l.89.3c.4.14.63.25.63.48 0 .32-.33.51-.81.51h-.01zM10.19 9c.4 0 .85-.14.85-.71V6.74c0-.07.02-.09.09-.09h1.25c1.19 0 2.14-.75 2.14-2.3 0-1.55-.94-2.32-2.14-2.32h-2.24c-.42 0-.8.2-.8.77v5.49c0 .57.46.71.84.71h.01zm.85-5.25c0-.07.02-.09.09-.09h1c.38 0 .64.26.64.7 0 .44-.26.68-.64.68h-1c-.07 0-.09-.02-.09-.09v-1.2zM4.59 9c.4 0 .85-.14.85-.71V6.28c0-.07.02-.09.09-.09H7.1c.56 0 .73-.39.73-.8 0-.41-.17-.82-.73-.82H5.53c-.07 0-.09-.02-.09-.09v-.76c0-.07.02-.09.09-.09h2.2c.56 0 .73-.39.73-.8 0-.41-.17-.82-.73-.82H4.55c-.42 0-.8.2-.8.77v5.49c0 .57.46.71.84.71V9zM19 10H5c-1.66 0-3 1.34-3 3v6c0 1.66 1.34 3 3 3h14c1.66 0 3-1.34 3-3v-6c0-1.66-1.34-3-3-3zM8.79 20c-1.32 0-1.92-.68-2.18-.97-.11-.12-.25-.36-.25-.6 0-.36.45-.9.94-.9.18 0 .33.03.63.32.16.16.45.4.86.4.45 0 .75-.3.75-.76s-.33-.77-.78-.77h-.11c-.52 0-.76-.34-.76-.83 0-.49.26-.81.77-.81h.11c.38 0 .65-.28.65-.67 0-.41-.25-.66-.62-.66-.35 0-.55.19-.83.4-.15.14-.31.25-.6.25-.42 0-.93-.39-.93-.87 0-.31.23-.59.41-.78.43-.43 1-.74 1.95-.74 1.55 0 2.48.93 2.48 2.28 0 .69-.28 1.19-.65 1.51-.03.02-.06.06-.06.09s.02.06.06.09c.37.31.78.81.78 1.62 0 1.33-.94 2.4-2.61 2.4h-.01zm6.2 0c-2.34 0-2.66-1.81-2.66-4s.32-4 2.66-4c2.34 0 2.66 1.81 2.66 4s-.32 4-2.66 4zm0-6.23c-.72 0-.77.7-.77 2.17v.11c0 1.47.06 2.17.77 2.17s.77-.7.77-2.17v-.1c0-1.48-.06-2.18-.77-2.18z",
            fill: "currentColor"
        })
    });



const $4a1d634101d54416$export$f16ae2aade18839a = (v)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...v,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10.19 9c.4 0 .85-.14.85-.71V6.74c0-.07.02-.09.09-.09h1.25c1.19 0 2.14-.75 2.14-2.3 0-1.55-.94-2.32-2.14-2.32h-2.24c-.42 0-.8.2-.8.77v5.49c0 .57.46.71.84.71h.01zm.85-5.25c0-.07.02-.09.09-.09h1c.38 0 .64.26.64.7 0 .44-.26.68-.64.68h-1c-.07 0-.09-.02-.09-.09v-1.2zm6.64 3.64c-.44 0-.85-.09-1.28-.39-.18-.13-.36-.25-.55-.25-.42 0-.83.42-.83.82 0 .26.15.43.26.56.49.55 1.39.88 2.4.88 1.51 0 2.56-.81 2.56-2.12 0-1.04-.66-1.67-1.87-2.08l-.88-.3c-.38-.13-.6-.29-.6-.48 0-.25.32-.42.8-.42.32 0 .74.13 1.07.32.13.07.24.15.45.15.36 0 .79-.44.79-.85 0-.25-.12-.45-.35-.62-.45-.33-1.04-.62-1.96-.62-1.54 0-2.55.88-2.55 2.03s.71 1.7 1.84 2.08l.89.3c.4.14.63.25.63.48 0 .32-.33.51-.81.51h-.01zM4.59 9c.4 0 .85-.14.85-.71V6.28c0-.07.02-.09.09-.09H7.1c.56 0 .73-.39.73-.8 0-.41-.17-.82-.73-.82H5.53c-.07 0-.09-.02-.09-.09v-.76c0-.07.02-.09.09-.09h2.2c.56 0 .73-.39.73-.8 0-.41-.17-.82-.73-.82H4.55c-.42 0-.8.2-.8.77v5.49c0 .57.46.71.84.71V9zM19 10H5c-1.66 0-3 1.34-3 3v6c0 1.66 1.34 3 3 3h14c1.66 0 3-1.34 3-3v-6c0-1.66-1.34-3-3-3zM8.98 20c-2.3 0-2.66-1.73-2.66-4s.33-4 2.82-4c.43 0 .95.1 1.49.43.23.14.53.37.53.78 0 .41-.42.9-.87.9-.19 0-.32-.05-.55-.18a1.12 1.12 0 00-.58-.18c-.39 0-.68.14-.78.39-.08.18-.11.41-.12.66 0 .05 0 .08.07.08.02 0 .11-.03.11-.03.24-.08.43-.1.66-.1 1.56 0 2.44.92 2.44 2.5 0 1.69-.85 2.76-2.56 2.76V20zm6.09 0c-2.34 0-2.66-1.81-2.66-4s.32-4 2.66-4c2.34 0 2.66 1.81 2.66 4s-.32 4-2.66 4zm-6.09-3.56c-.6 0-.69.53-.69.9v.05c0 .33.15.85.69.85.54 0 .7-.55.7-.9s-.14-.9-.7-.9zm6.09-2.67c-.72 0-.77.7-.77 2.17v.11c0 1.47.06 2.17.77 2.17s.77-.7.77-2.17v-.1c0-1.48-.06-2.18-.77-2.18z",
            fill: "currentColor"
        })
    });



const $6bbe9a4a862c34a1$export$b1708ec8191b64d5 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12.39 5l.32-.31A1.005 1.005 0 0012 2.976c-.266 0-.522.106-.71.294l-2 2a1 1 0 000 1.42l2 2a1.001 1.001 0 001.639-.325 1 1 0 00-.219-1.095L12.44 7A6 6 0 116 13a1 1 0 10-2 0 8 8 0 108.39-8z",
            fill: "currentColor"
        })
    });



const $3224d2919ebb6ffa$export$2adfe3018ff381d8 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10.5 15a.5.5 0 00.5-.5v-3a.5.5 0 00-.31-.46.47.47 0 00-.54.11l-1 1a.495.495 0 10.7.7l.15-.14v1.79a.5.5 0 00.5.5zm4.5-1.5v-1a1.5 1.5 0 10-3 0v1a1.5 1.5 0 103 0zm-2 0v-1a.5.5 0 011 0v1a.5.5 0 01-1 0zM12.39 5l.32-.31A1.005 1.005 0 0012 2.976c-.266 0-.522.106-.71.294l-2 2a1 1 0 000 1.42l2 2a1.001 1.001 0 001.639-.325 1 1 0 00-.219-1.095L12.44 7A6 6 0 116 13a1 1 0 10-2 0 8 8 0 108.39-8z",
            fill: "currentColor"
        })
    });



const $29929acb503c007d$export$ec54ed90fb3ef2ad = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M9.75 14H9a.5.5 0 100 1h.75A1.25 1.25 0 0011 13.75a1.18 1.18 0 00-.28-.75 1.18 1.18 0 00.28-.75A1.25 1.25 0 009.75 11H9a.5.5 0 100 1h.75a.25.25 0 110 .5h-.31a.5.5 0 100 1h.31a.25.25 0 110 .5zm5.25-.5v-1a1.5 1.5 0 10-3 0v1a1.5 1.5 0 103 0zm-2 0v-1a.5.5 0 011 0v1a.5.5 0 01-1 0zM12.39 5l.32-.31A1.005 1.005 0 0012 2.976c-.266 0-.522.106-.71.294l-2 2a1 1 0 000 1.42l2 2a1.001 1.001 0 001.639-.325 1 1 0 00-.219-1.095L12.44 7A6 6 0 116 13a1 1 0 10-2 0 8 8 0 108.39-8z",
            fill: "currentColor"
        })
    });



const $87197102f9b83eea$export$91e72ec40aec46a7 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 12a1 1 0 00-1 1 6 6 0 11-6.44-6l-.27.27a1 1 0 00.325 1.64 1 1 0 001.095-.22l2-2a1.001 1.001 0 000-1.42l-2-2a1.003 1.003 0 10-1.42 1.42l.32.31A8 8 0 1020 13a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $4d1979af963ee7b0$export$492ffa10478321d2 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 12a1 1 0 00-1 1 6 6 0 11-6.44-6l-.27.27a1 1 0 00.325 1.64 1 1 0 001.095-.22l2-2a1.001 1.001 0 000-1.42l-2-2a1.003 1.003 0 10-1.42 1.42l.32.31A8 8 0 1020 13a1 1 0 00-1-1zm-5.5-1a1.5 1.5 0 00-1.5 1.5v1a1.5 1.5 0 103 0v-1a1.5 1.5 0 00-1.5-1.5zm.5 2.5a.5.5 0 11-1 0v-1a.5.5 0 011 0v1zM10.5 15a.5.5 0 00.5-.5v-3a.5.5 0 00-.31-.46.47.47 0 00-.54.11l-1 1a.495.495 0 10.7.7l.15-.14v1.79a.5.5 0 00.5.5z",
            fill: "currentColor"
        })
    });



const $648266c4b738240c$export$c10c21d3b2ff2207 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 12a1 1 0 00-1 1 6 6 0 11-6.44-6l-.27.27a1 1 0 00.325 1.64 1 1 0 001.095-.22l2-2a1.001 1.001 0 000-1.42l-2-2a1.003 1.003 0 10-1.42 1.42l.32.31A8 8 0 1020 13a1 1 0 00-1-1zm-9.25-1H9a.5.5 0 100 1h.75a.25.25 0 110 .5h-.31a.5.5 0 100 1h.31a.25.25 0 110 .5H9a.5.5 0 100 1h.75A1.25 1.25 0 0011 13.75a1.18 1.18 0 00-.28-.75 1.18 1.18 0 00.28-.75A1.25 1.25 0 009.75 11zm3.75 0a1.5 1.5 0 00-1.5 1.5v1a1.5 1.5 0 103 0v-1a1.5 1.5 0 00-1.5-1.5zm.5 2.5a.5.5 0 11-1 0v-1a.5.5 0 011 0v1z",
            fill: "currentColor"
        })
    });



const $0545fbadd36ceb44$export$2064352e8e563936 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.12 4.88A3 3 0 0019 4H5a3 3 0 00-3 3v10a3 3 0 003 3h14a3 3 0 003-3V7a3 3 0 00-.88-2.12zM11.5 15a1 1 0 01-2 0v-2h-2v2a1 1 0 01-.62.93 1 1 0 01-1.31-.54A1 1 0 015.5 15V9a1 1 0 01.62-.93 1 1 0 011.31.54A1 1 0 017.5 9v2h2V9a1 1 0 012 0v6zm4.5 1h-2a1 1 0 01-1-1V9a1 1 0 011-1h2c1 0 3 .84 3 4s-2 4-3 4zm0-6h-1v4h1c.19 0 1-.16 1-2s-.83-2-1-2z",
            fill: "currentColor"
        })
    });



const $5a0eba0ec3353ae2$export$fe597d677ed5a06b = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 11h-1v-1a7 7 0 10-14 0v1H4a2 2 0 00-2 2v4a2 2 0 002 2h1a2 2 0 002-2v-7a5 5 0 1110 0v7a2 2 0 002 2h1a2 2 0 002-2v-4a2 2 0 00-2-2z",
            fill: "currentColor"
        })
    });



const $04e526c8f66dec8a$export$be687bb18192ac7 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 10h-1V9A7 7 0 105 9v1H4a2 2 0 00-2 2v4a2 2 0 002 2h1a2 2 0 002-2V9a5 5 0 1110 0v10a1 1 0 01-1 1h-3a1 1 0 000 2h3a3 3 0 003-3v-1h1a2 2 0 002-2v-4a2 2 0 00-2-2z",
            fill: "currentColor"
        })
    });



const $f4f081a542fe2932$export$2c53cdc9d4dd0ed1 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 3H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-3-3zm-1.5 5a1 1 0 01-.73 1L13 9.75v5.75a2.5 2.5 0 11-2-2.45V8a1 1 0 01.73-1l3.5-1a1 1 0 011.164.513c.07.139.106.292.106.447V8z",
            fill: "currentColor"
        })
    });



const $094e9775774e0f13$export$a821664501fae5c2 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15 20H9c-.27 0-.52.11-.71.29A.99.99 0 008 21c0 .27.11.52.29.71.19.19.44.29.71.29h6c.27 0 .52-.11.71-.29.19-.18.29-.44.29-.71 0-.27-.11-.52-.29-.71A.973.973 0 0015 20zm-3-5c.25 0 .5-.04.74-.11A5.997 5.997 0 0115 6.81V5c0-.8-.32-1.56-.88-2.12S12.79 2 12 2s-1.56.32-2.12.88S9 4.21 9 5v7c0 .8.32 1.56.88 2.12S11.21 15 12 15zm0 2c-1.33 0-2.6-.53-3.54-1.46A4.994 4.994 0 017 12v-1c0-.27-.11-.52-.29-.71A.99.99 0 006 10c-.27 0-.52.11-.71.29A.99.99 0 005 11v1a7.001 7.001 0 007 7c1.47 0 2.9-.47 4.08-1.32-.74-.25-1.42-.64-2-1.15-.65.3-1.35.47-2.08.47zm2-5c0 2.21 1.79 4 4 4 .74 0 1.43-.21 2.02-.57l-5.45-5.45c-.35.59-.57 1.28-.57 2.02zm4-4c-.74 0-1.43.21-2.02.57l5.45 5.45c.35-.59.57-1.28.57-2.02 0-2.21-1.79-4-4-4z",
            fill: "currentColor"
        })
    });



const $8f75f72ddc84e596$export$2f63e0582c03c534 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 5H5a3 3 0 00-3 3v8a3 3 0 003 3h14a3 3 0 003-3V8a3 3 0 00-3-3zM5.42 7h1a1 1 0 010 2h-1a1 1 0 010-2zM6.5 17h-1a1 1 0 010-2h1a1 1 0 010 2zm6 0h-1a1 1 0 010-2h1a1 1 0 010 2zm0-8h-1a1 1 0 110-2h1a1 1 0 110 2zm6 8h-1a1 1 0 010-2h1a1 1 0 010 2zm0-8h-1a1 1 0 110-2h1a1 1 0 110 2z",
            fill: "currentColor"
        })
    });



const $121b17a6da720023$export$bdf58bba06a2bd58 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.19 2.4a2 2 0 00-1.76-.31l-8 2.4A2 2 0 009 6.4v8.15A4 4 0 1011 18V6.4L19 4v8.55A4 4 0 1021 16V4a2 2 0 00-.81-1.6z",
            fill: "currentColor"
        })
    });



const $e353460370411147$export$a6d442534a0a6bc4 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16.2 10.4l-8-6A2 2 0 005 6v12a2 2 0 003.2 1.6l8-6a2 2 0 000-3.2zM18 4a1 1 0 00-1 1v14a1 1 0 002 0V5a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $842638e2d66eed54$export$d9f0f571c93d4827 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zm-1 13a1.5 1.5 0 11-3 0V9a1.5 1.5 0 013 0v6zm5 0a1.5 1.5 0 11-3 0V9a1.5 1.5 0 113 0v6z",
            fill: "currentColor"
        })
    });



const $73b539da8bb0c283$export$d2c9e094e19ca745 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M8.5 7a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM18 3H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-3-3zm1 9.09l-2.79-2.8a1 1 0 00-1.42 0l-4.29 4.3-1.29-1.3a1 1 0 00-1.42 0L5 15.09V6a1 1 0 011-1h12a1 1 0 011 1v6.09z",
            fill: "currentColor"
        })
    });



const $685cea142631c30f$export$1318099871ebb9ec = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 6h-7V5a1 1 0 00-1-1H7a1 1 0 00-1 1v1H5a3.12 3.12 0 00-3 3.23v7.54A3.12 3.12 0 005 20h14a3.12 3.12 0 003-3.23V9.23A3.12 3.12 0 0019 6zm-7 10a3 3 0 110-5.999A3 3 0 0112 16z",
            fill: "currentColor"
        })
    });



const $2a9d0eac107e92be$export$9c7a7ff0291edea6 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M8.5 7a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM18 3h-3a1 1 0 100 2h3a1 1 0 011 1v3a1 1 0 002 0V6a3 3 0 00-3-3zM4 10a1 1 0 001-1V6a1 1 0 011-1h3a1 1 0 000-2H6a3 3 0 00-3 3v3a1 1 0 001 1zm12.21-.71a1 1 0 00-1.41 0l-4.29 4.3-1.29-1.3a1 1 0 00-1.41 0L5 15.09V15a1 1 0 10-2 0v3a3 3 0 003 3h3a1 1 0 000-2H6a1 1 0 01-1-1v-.09l3.5-3.5 1.29 1.3a1 1 0 001.41 0l4.29-4.3 3.5 3.5V18a1 1 0 01-1 1H15a1 1 0 000 2h3a3 3 0 003-3v-3.5a1 1 0 00-.29-.71l-4.5-4.5z",
            fill: "currentColor"
        })
    });



const $a46e1f747c2053c7$export$9f459cf02f25b426 = (m)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...m,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.89 13.42c.067-.47.104-.945.11-1.42a11.01 11.01 0 00-.11-1.42 10 10 0 00-1.36-3.78 10.13 10.13 0 00-3.32-3.32 10 10 0 00-3.78-1.36A10.999 10.999 0 0012 2a11 11 0 00-1.42.11A10 10 0 006.8 3.47a10.13 10.13 0 00-3.33 3.32 10 10 0 00-1.36 3.78A11 11 0 002 12a11 11 0 00.11 1.42 10 10 0 001.36 3.78 10.13 10.13 0 003.32 3.32 10 10 0 003.78 1.36c.473.071.951.111 1.43.12.475-.006.95-.043 1.42-.11a10 10 0 003.78-1.36 10.13 10.13 0 003.32-3.32 10 10 0 001.37-3.79zM17.6 17.7a2 2 0 11.1-.1.47.47 0 01-.1.1zm-11.3-.1a2 2 0 11.1.1.47.47 0 01-.1-.1zM4 12c0-.627.077-1.252.23-1.86a1.9 1.9 0 01.7.45 2 2 0 010 2.82 1.9 1.9 0 01-.7.45A7.58 7.58 0 014 12zm2.4-5.7a2 2 0 11-.1.1l.1-.1zm11.3.1a2 2 0 11-.1-.1.47.47 0 01.1.1zm1.37 7a2 2 0 010-2.82 1.9 1.9 0 01.7-.45 7.64 7.64 0 010 3.72 1.9 1.9 0 01-.7-.44v-.01zm-5.21-9.17a1.9 1.9 0 01-.45.7 2 2 0 01-2.82 0 1.9 1.9 0 01-.45-.7 7.64 7.64 0 013.72 0zm-.45 9.18a2 2 0 11-2.836-2.82 2 2 0 012.836 2.82zm-3.27 6.36a1.9 1.9 0 01.45-.7 2 2 0 012.82 0c.2.197.354.436.45.7a7.64 7.64 0 01-3.72 0z",
            fill: "currentColor"
        })
    });



const $b40589f37f9890ab$export$1b6ecfd59bfd3099 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M6 13a1 1 0 100 2 1 1 0 000-2zM20 2H9a2 2 0 00-2 2v6H4a2 2 0 00-2 2v8a2 2 0 002 2h11a2 2 0 002-2v-6h3a2 2 0 002-2V4a2 2 0 00-2-2zm-7.29 12.29a1.002 1.002 0 00-1.42 0L8 17.59l-1.29-1.3a1 1 0 00-1.42 0L4 17.59V12h11v4.59l-2.29-2.3zM17 12a2 2 0 00-2-2H9V4h11v8h-3zm-3-5.92a.5.5 0 00-.78.42v2a.51.51 0 00.26.44.53.53 0 00.24.06.57.57 0 00.28-.08l1.5-1a.51.51 0 000-.84l-1.5-1z",
            fill: "currentColor"
        })
    });



const $3cd1841dc269b33e$export$be66ef5b9ff0f232 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zm3.66 11.1l-4.24 3.27A1.5 1.5 0 019 15.18V8.64a1.5 1.5 0 012.42-1.19l4.24 3.27a1.5 1.5 0 010 2.38z",
            fill: "currentColor"
        })
    });



const $cd950e9f6fc33ef9$export$ac4cd276720f70aa = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M11.27 10.52L5 5.69a1.86 1.86 0 00-3 1.48v9.66a1.86 1.86 0 003 1.48l6.27-4.83a1.87 1.87 0 000-2.96zM15.5 6A1.5 1.5 0 0014 7.5v9a1.5 1.5 0 003 0v-9A1.5 1.5 0 0015.5 6zm5 0A1.5 1.5 0 0019 7.5v9a1.5 1.5 0 003 0v-9A1.5 1.5 0 0020.5 6z",
            fill: "currentColor"
        })
    });



const $e5a8f3df6f454ccf$export$bb9ee180d3bd0f7b = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M6 4a1 1 0 00-1 1v14a1 1 0 102 0V5a1 1 0 00-1-1zm11.89.21a2 2 0 00-2.09.19l-8 6a2 2 0 000 3.2l8 6A2 2 0 0019 18V6a2 2 0 00-1.11-1.79z",
            fill: "currentColor"
        })
    });



const $5befdb2d0ea019b7$export$4000327a900bfd96 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 10a2 2 0 100 4 2 2 0 000-4zm-8 2a8 8 0 012.34-5.66 1 1 0 00-1.41-1.41 10 10 0 000 14.14 1 1 0 001.41 0 1 1 0 000-1.41A8 8 0 014 12zm5.17-4.24a1 1 0 00-1.41 0 6 6 0 000 8.48 1 1 0 001.41 0 1 1 0 000-1.41 4 4 0 010-5.66 1 1 0 000-1.41zm7.07 0a1 1 0 00-1.41 1.41 4 4 0 010 5.66 1 1 0 000 1.41 1 1 0 001.41 0 6 6 0 000-8.48zm2.83-2.83a1 1 0 00-1.41 1.41 7.999 7.999 0 010 11.32 1 1 0 000 1.41 1 1 0 001.41 0 10 10 0 000-14.14z",
            fill: "currentColor"
        })
    });



const $1f62dca1940ec8c2$export$96692af1df672c7c = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M9.17 5.76a1 1 0 00-1.41 0 6 6 0 000 8.48 1 1 0 001.41 0 1 1 0 000-1.41 4 4 0 010-5.66 1 1 0 000-1.41zM4 10a8 8 0 012.34-5.66 1 1 0 10-1.41-1.41 10 10 0 000 14.14 1 1 0 001.41 0 1 1 0 000-1.41A8 8 0 014 10zm12.24-4.24a1 1 0 00-1.41 1.41 4 4 0 010 5.66 1 1 0 000 1.41 1 1 0 001.41 0 6 6 0 000-8.48zm2.83-2.83a1 1 0 00-1.41 1.41 7.999 7.999 0 010 11.32 1 1 0 000 1.41 1 1 0 001.41 0 10 10 0 000-14.14zM12 8a2 2 0 00-2 2 2 2 0 001 1.72V21a1 1 0 002 0v-9.28A2 2 0 0014 10a2 2 0 00-2-2z",
            fill: "currentColor"
        })
    });



const $3f60954c0094a570$export$13755e81ed102341 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M14 14a1 1 0 000-2h-2V9a1 1 0 00-2 0v4a1 1 0 001 1h3zm3.86-7.43a1.829 1.829 0 00-.15-.23A8 8 0 0012.05 4H12a8 8 0 00-8 7.61l-.31-.32a1.004 1.004 0 10-1.42 1.42l2 2a1 1 0 00.22.14c.033.03.07.053.11.07A1 1 0 005 15a.938.938 0 00.37-.07l.11-.07a.86.86 0 00.2-.13l2-1.88a1 1 0 00.05-1.41 1 1 0 00-1.41 0l-.25.23A6 6 0 0112 6a6 6 0 110 12 1 1 0 000 2 7.999 7.999 0 005.86-13.43z",
            fill: "currentColor"
        })
    });



const $3942451142e9294f$export$387e0e6a121a278 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4 12a5 5 0 015-5h3.59l-.3.29a1.001 1.001 0 00.326 1.64 1 1 0 001.094-.22l2-2a1 1 0 00.21-.33 1 1 0 000-.76.999.999 0 00-.21-.33l-2-2a1.004 1.004 0 10-1.42 1.42l.3.29H9a7 7 0 00-7 7 6.94 6.94 0 002.59 5.43 1 1 0 101.26-1.55A5 5 0 014 12zm15.41-5.43a.999.999 0 10-1.26 1.55A5 5 0 0115 17h-3.59l.3-.29a1.004 1.004 0 10-1.42-1.42l-2 2a1 1 0 00-.21.33 1 1 0 000 .76 1 1 0 00.21.33l2 2a1.001 1.001 0 001.639-.325 1 1 0 00-.219-1.095l-.3-.29H15a7 7 0 007-7 6.939 6.939 0 00-2.59-5.43z",
            fill: "currentColor"
        })
    });



const $0d4f1cf2a00756d3$export$69f9928e19025c00 = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4 12a5 5 0 015-5h3.59l-.3.29a1 1 0 00.326 1.639 1 1 0 001.094-.22l2-2a1 1 0 00.21-.33 1 1 0 000-.76 1 1 0 00-.21-.33l-2-2a1.004 1.004 0 10-1.42 1.42l.3.29H9a7 7 0 00-7 7 6.94 6.94 0 002.59 5.43 1.001 1.001 0 101.26-1.55A5 5 0 014 12zm17.69-9a.48.48 0 00-.54.11l-1 1a.495.495 0 00.7.7l.15-.1V6.5a.5.5 0 001 0v-3a.5.5 0 00-.31-.5zm-2.28 3.57a.999.999 0 10-1.26 1.55A5 5 0 0115 17h-3.59l.3-.29a1.004 1.004 0 10-1.42-1.42l-2 2a1 1 0 00-.21.33 1 1 0 000 .76 1 1 0 00.21.33l2 2a.998.998 0 001.42 0 .997.997 0 00.219-1.095.998.998 0 00-.219-.325l-.3-.29H15a7 7 0 007-7 6.939 6.939 0 00-2.59-5.43z",
            fill: "currentColor"
        })
    });



const $1d46218615f882f4$export$ed500ad0104072db = (v)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...v,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 11H5c-1.66 0-3 1.34-3 3v5c0 1.66 1.34 3 3 3h14c1.66 0 3-1.34 3-3v-5c0-1.66-1.34-3-3-3zm-7.64 8.29c0 .57-.46.71-.85.71-.39 0-.84-.14-.84-.71v-1.91c0-.07-.03-.09-.09-.09H7.82c-.07 0-.09.02-.09.09v1.91c0 .57-.46.71-.85.71-.39 0-.84-.14-.84-.71V13.7c0-.57.46-.71.84-.71.4 0 .85.14.85.71v1.89c0 .07.02.09.09.09h1.76c.06 0 .09-.02.09-.09V13.7c0-.57.45-.71.84-.71.39 0 .85.14.85.71v5.59zm6.1-.18c-.55.68-1.29.85-2.09.85h-1.88c-.42 0-.8-.18-.8-.75V13.8c0-.57.38-.77.8-.77h1.88c.8 0 1.54.17 2.09.85.42.51.51 1.41.51 2.61s-.09 2.11-.51 2.62zm-2.16-4.46h-.83c-.07 0-.09.02-.09.09v3.52c0 .07.02.09.09.09h.83c.3 0 .59-.1.75-.37.15-.26.17-.85.17-1.48s0-1.21-.17-1.48c-.15-.26-.45-.37-.75-.37zm.77-4.65c.73 0 .95-.3.95-.77 0-.47-.18-.76-.53-.76-.22 0-.33-.15-.33-.39V3.72c0-.55-.4-.72-.8-.72s-.8.17-.8.72v4.59c0 1.04.44 1.7 1.51 1.7V10zM4.83 10c.4 0 .85-.14.85-.71V7.28c0-.07.02-.09.09-.09h1.57c.56 0 .73-.39.73-.79s-.17-.81-.73-.81H5.77c-.07 0-.09-.02-.09-.09v-.75c0-.07.02-.09.09-.09h2.19c.56 0 .72-.39.72-.79s-.17-.81-.72-.81H4.78c-.42 0-.79.2-.79.76V9.3c0 .57.46.71.83.71l.01-.01zm14.47 0c.73 0 .95-.3.95-.77 0-.47-.18-.76-.53-.76-.22 0-.33-.15-.33-.39V3.72c0-.55-.4-.72-.8-.72s-.8.17-.8.72v4.59c0 1.04.44 1.7 1.51 1.7V10zm-8.59 0c.55 0 .91-.28 1.09-.42 0 0 .04-.03.07-.03.04 0 .05.02.07.07.11.28.44.38.73.38.39 0 .78-.17.78-.72V5.42c0-.55-.41-.72-.8-.72-.39 0-.8.17-.8.72v2.32c0 .18-.02.35-.1.48-.09.14-.22.23-.45.23-.2 0-.31-.1-.39-.23-.08-.13-.1-.33-.1-.48V5.42c0-.55-.41-.72-.8-.72-.39 0-.8.17-.8.72v2.87c0 .77.39 1.71 1.5 1.71z",
            fill: "currentColor"
        })
    });



const $b705e938b1b9b8d8$export$91c67b57c73aacce = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M6.41 12l6.3-6.29a1 1 0 00-.325-1.639 1 1 0 00-1.095.219l-7 7a1 1 0 000 1.42l7 7a1.004 1.004 0 101.42-1.42L6.41 12zm5 0l6.3-6.29a1 1 0 00-.325-1.639 1 1 0 00-1.095.219l-7 7a1 1 0 000 1.42l7 7a1.004 1.004 0 101.42-1.42L11.41 12z",
            fill: "currentColor"
        })
    });



const $5662475e76f96c31$export$2aeb9362cead36ae = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 3H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-3-3zm0 7a1 1 0 01-2 0v-.59L9.41 16H10a1 1 0 010 2H7a1.001 1.001 0 01-.38-.08 1 1 0 01-.54-.54A1 1 0 016 17v-3a1 1 0 112 0v.59L14.59 8H14a1 1 0 110-2h3a1 1 0 01.38.08 1 1 0 01.54.54c.051.12.078.25.08.38v3z",
            fill: "currentColor"
        })
    });



const $5e84c20c25bb1b08$export$68be9e77b22fecd1 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 3H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-3-3zm-7 14a1 1 0 01-2 0v-.59l-2.29 2.3a1 1 0 01-1.639-.325 1 1 0 01.219-1.095L7.59 15H7a1 1 0 010-2h3c.13.002.26.029.38.08a1 1 0 01.54.54c.051.12.078.25.08.38v3zm7.71-10.29L16.41 9H17a1 1 0 110 2h-3a1.001 1.001 0 01-.38-.08 1 1 0 01-.54-.54A1.001 1.001 0 0113 10V7a1 1 0 012 0v.59l2.29-2.3a1.004 1.004 0 011.42 1.42z",
            fill: "currentColor"
        })
    });



const $2dba103a666e7188$export$5e4d0255a2d14294 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 13h-2a3 3 0 00-3 3v2a3 3 0 003 3h2a3 3 0 003-3v-2a3 3 0 00-3-3zm0-10H6a3 3 0 00-3 3v12a3 3 0 003 3h6a4.92 4.92 0 01-1-3v-2a5 5 0 015-5h2a4.92 4.92 0 013 1V6a3 3 0 00-3-3zm-7 7c-.002.13-.029.26-.08.38a1 1 0 01-.54.54c-.12.051-.25.078-.38.08H7a1 1 0 010-2h.59l-2.3-2.29a1.004 1.004 0 011.42-1.42L9 7.59V7a1 1 0 012 0v3z",
            fill: "currentColor"
        })
    });



const $8952c1a30f900cc6$export$e295d70197f4f97a = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15.67 9.77h-1c-.08 0-.11.02-.11.11v4.25c0 .08.02.11.11.11h1c.36 0 .71-.12.9-.44.18-.31.2-1.03.2-1.79s-.01-1.46-.2-1.79c-.18-.31-.54-.44-.9-.44v-.01zM19 4H5C3.34 4 2 5.34 2 7v10c0 1.66 1.34 3 3 3h14c1.66 0 3-1.34 3-3V7c0-1.66-1.34-3-3-3zM8.32 16.22c-1.21 0-2.3-.4-2.89-1.06-.13-.16-.31-.36-.31-.67 0-.48.49-.98 1-.98.23 0 .44.14.66.3.53.36 1.02.47 1.55.47.58 0 .97-.23.97-.61 0-.28-.28-.41-.76-.58l-1.07-.36c-1.37-.46-2.22-1.13-2.22-2.51s1.21-2.45 3.07-2.45c1.1 0 1.82.35 2.36.74.28.2.42.44.42.74 0 .49-.52 1.02-.95 1.02-.25 0-.38-.1-.54-.18-.41-.23-.91-.38-1.3-.38-.58 0-.96.2-.96.5 0 .23.26.42.72.58l1.07.36c1.46.49 2.25 1.25 2.25 2.51 0 1.58-1.26 2.55-3.08 2.55l.01.01zm9.96-1.07c-.66.82-1.56 1.02-2.52 1.02h-2.27c-.5 0-.96-.22-.96-.9V8.75c0-.68.46-.92.96-.92h2.27c.96 0 1.86.2 2.52 1.02.5.61.61 1.7.61 3.15s-.11 2.54-.61 3.15z",
            fill: "currentColor"
        })
    });



const $8f13a7c0d97cdb52$export$24cb64a5f6990db4 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16.49 15.33a8.19 8.19 0 001.76-5.08C18.25 5.7 14.55 2 10 2s-8.25 3.7-8.25 8.25a8.24 8.24 0 002.91 6.28C3.62 17.09 3 17.77 3 18.5c0 1.93 4.25 3.5 9.5 3.5s9.5-1.57 9.5-3.5c0-1.41-2.26-2.62-5.51-3.17zM3.75 10.25C3.75 6.8 6.55 4 10 4s6.25 2.8 6.25 6.25-2.8 6.25-6.25 6.25-6.25-2.8-6.25-6.25z",
            fill: "currentColor"
        })
    });



const $1257d5a28ec70e20$export$a058e013ce0355fa = (l)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M7.67 10.25c-.25.16-.44.4-.55.67-.11.27-.14.58-.09.87.06.29.2.56.41.77.21.21.48.35.77.41.29.06.59.03.87-.09.27-.11.51-.31.67-.55A1.499 1.499 0 008.5 10c-.3 0-.59.09-.83.25zM6 4.99h12c.55 0 1-.45 1-1s-.45-1-1-1H6c-.55 0-1 .45-1 1s.45 1 1 1z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M17.13 14.21l-1.92-1.93a.955.955 0 00-.33-.22.995.995 0 00-.38-.08c-.13 0-.26.03-.38.08s-.23.13-.33.22l-4.29 4.3-1.29-1.3a.955.955 0 00-.33-.22.995.995 0 00-.38-.08c-.13 0-.26.03-.38.08s-.23.13-.33.22L4 18.08V8.99c0-.26.11-.52.29-.71A.99.99 0 015 7.99h12c.27 0 .52.11.71.29.19.19.29.44.29.71v5.05c.17-.02.33-.05.5-.05.53 0 1.02.1 1.5.25V8.65c0-.71-.32-1.39-.88-1.89s-1.33-.78-2.12-.78H5c-.8 0-1.56.28-2.12.78S2 7.94 2 8.65v10.67c0 .71.32 1.39.88 1.89s1.33.78 2.12.78h9.52a4.98 4.98 0 01-1.02-3c0-2.28 1.54-4.19 3.63-4.79v.01z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M18.87 16.04c-.23-.06-.48-.07-.71 0a1.34 1.34 0 00-.96.96c-.06.23-.06.48 0 .71.06.22.18.43.34.59a1.347 1.347 0 001.3.34c.23-.07.44-.18.61-.35.17-.17.29-.38.35-.61.06-.23.06-.48 0-.71-.06-.22-.18-.43-.34-.59-.16-.16-.37-.28-.59-.34zM20.2 19.7c-.45-.45-1.06-.7-1.7-.7-.64 0-1.25.25-1.7.7-.45.45-.7 1.06-.7 1.7 0 .16.06.31.18.42.11.11.27.18.42.18h3.6c.16 0 .31-.06.42-.18.11-.11.18-.26.18-.42 0-.64-.25-1.25-.7-1.7z",
                fill: "currentColor"
            })
        ]
    });



const $6d5bff1be94e0e4d$export$54d433f90dd7768a = (a)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17.24 8h1.35l-.3.29a1 1 0 00.325 1.64 1 1 0 001.095-.22l2-2a1.001 1.001 0 000-1.42l-2-2a1.003 1.003 0 10-1.42 1.42l.3.29h-1.35a4.06 4.06 0 00-2.83 1.17l-8.24 8.24a2 2 0 01-1.41.59H3a1 1 0 100 2h1.76a4.06 4.06 0 002.83-1.17l8.24-8.24A2 2 0 0117.24 8zM3 8h1.76a2 2 0 011.41.59l2 2 1.42-1.42-2-2A4.06 4.06 0 004.76 6H3a1 1 0 100 2zm16.71 6.29a1.004 1.004 0 10-1.42 1.42l.3.29h-1.35a2 2 0 01-1.41-.59l-2-2-1.42 1.42 2 2A4.06 4.06 0 0017.24 18h1.35l-.3.29a1 1 0 000 1.42 1.002 1.002 0 001.42 0l2-2a1.002 1.002 0 000-1.42l-2-2z",
            fill: "currentColor"
        })
    });



const $aed296e5467c6f87$export$c4466affc522b670 = (r)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM7.81 15.38c0 .66-.48.87-.98.87s-.98-.21-.98-.87v-4.11s0-.11-.06-.11c-.04 0-.07.02-.11.06-.22.22-.43.3-.64.3-.48 0-1.04-.48-1.04-1 0-.22.1-.46.34-.7l1.79-1.76c.27-.27.57-.31.71-.31.48 0 .97.25.97 1.03v6.6zm3.9.87c-2.49 0-2.83-1.92-2.83-4.25s.34-4.25 2.83-4.25 2.82 1.92 2.82 4.25-.34 4.25-2.82 4.25zm5.92 0c-.91 0-1.65-.27-2.11-.69-.22-.19-.3-.4-.3-.59 0-.45.41-.94.89-.94.15 0 .3.06.47.17.34.23.68.34 1.05.34.27 0 .46-.11.46-.31 0-.18-.16-.27-.46-.36l-.49-.16c-1.16-.36-1.81-1.04-1.81-1.91 0-1.28.92-1.98 2.31-1.98.51 0 1.16.12 1.63.42.28.17.42.42.42.68 0 .48-.33.92-.82.92-.12 0-.24-.04-.39-.1-.37-.17-.59-.21-.85-.21s-.41.13-.41.28c0 .12.12.22.41.31l.48.17c1.32.46 1.87.97 1.87 1.93 0 1.32-.97 2.03-2.35 2.03z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M11.72 9.63c-.76 0-.82.75-.82 2.31v.12c0 1.56.06 2.31.82 2.31s.82-.75.82-2.31v-.11c0-1.57-.06-2.32-.82-2.32z",
                fill: "currentColor"
            })
        ]
    });



const $ef7dcf45a6beb071$export$c0dbc24bc95b8e2c = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM8.98 17c-1.65 0-2.4-.85-2.73-1.21-.14-.16-.31-.45-.31-.75 0-.45.57-1.12 1.18-1.12.23 0 .41.04.78.4.2.2.57.5 1.08.5.57 0 .94-.37.94-.95s-.41-.97-.98-.97H8.8c-.65 0-.95-.43-.95-1.04 0-.61.33-1.01.97-1.01h.14c.47 0 .81-.36.81-.84 0-.51-.31-.82-.78-.82-.44 0-.68.24-1.04.5-.18.17-.38.31-.75.31-.53 0-1.17-.48-1.17-1.09 0-.38.28-.74.51-.98.54-.54 1.25-.92 2.44-.92 1.93 0 3.1 1.17 3.1 2.85 0 .87-.35 1.49-.81 1.89-.04.03-.07.07-.07.11 0 .04.03.07.07.11.47.38.98 1.01.98 2.03 0 1.66-1.18 3-3.27 3zm6.7 0c-.91 0-1.67-.27-2.13-.69-.22-.19-.3-.4-.3-.6 0-.45.41-.95.9-.95.15 0 .3.06.47.17.34.23.68.34 1.06.34.27 0 .46-.11.46-.32 0-.18-.16-.27-.46-.37l-.5-.16c-1.17-.37-1.82-1.05-1.82-1.92 0-1.29.92-1.99 2.32-1.99.51 0 1.17.12 1.64.43.28.17.43.43.43.68 0 .49-.33.92-.83.92-.12 0-.24-.04-.39-.1-.38-.17-.6-.21-.85-.21s-.41.13-.41.28c0 .12.12.22.41.32l.49.17c1.33.46 1.89.97 1.89 1.95 0 1.33-.97 2.04-2.37 2.04l-.01.01z",
            fill: "currentColor"
        })
    });



const $9f7b378d287252f7$export$2871fe91bc847b2 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM8.95 17c-1.64 0-2.36-.7-2.71-1.14-.13-.17-.31-.46-.31-.76 0-.46.57-1.13 1.2-1.13.24 0 .46.1.79.41.21.2.53.41 1.04.41s.9-.3.9-1.31c0-.51-.09-1.2-.9-1.2-.29 0-.54.1-.84.34-.21.17-.4.33-.84.33-.7 0-1.27-.31-1.27-1.13V8.06c0-.67.43-1.07 1.04-1.07h3.44c.87 0 1.1.56 1.1 1.11 0 .6-.23 1.11-1.1 1.11H8.45c-.11 0-.13.04-.13.13v1.07c0 .06.03.1.1.1.06 0 .1-.03.29-.09.34-.1.56-.13.9-.13 1.8 0 2.59 1.42 2.59 3.13 0 2.41-1.3 3.56-3.23 3.56l-.02.02zm6.75 0c-.92 0-1.68-.27-2.14-.7-.22-.2-.31-.4-.31-.6 0-.45.42-.95.91-.95.15 0 .31.06.48.17.34.23.69.34 1.06.34.27 0 .47-.11.47-.32 0-.18-.16-.27-.47-.37l-.5-.16c-1.17-.37-1.83-1.05-1.83-1.93 0-1.3.93-2.01 2.34-2.01.51 0 1.17.12 1.65.43.28.17.43.43.43.69 0 .49-.33.93-.83.93-.12 0-.25-.04-.39-.1-.38-.17-.6-.21-.86-.21s-.42.13-.42.28c0 .12.12.22.42.32l.49.17c1.33.47 1.9.98 1.9 1.96 0 1.33-.98 2.05-2.39 2.05l-.01.01z",
            fill: "currentColor"
        })
    });



const $4c7ceaff9613825c$export$39b176c829989aa3 = (e)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...e,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.06 4.037a1.966 1.966 0 012.178-.43 1.973 1.973 0 011.235 1.845v13.215c0 .808-.46 1.51-1.2 1.833a1.98 1.98 0 01-2.16-.365l-4.285-3.973h-3.08a2.198 2.198 0 01-2.198-2.195l-.05-3.13c0-1.332.825-2.292 1.962-2.292h3.065l4.533-4.508zm7.797 14.585a.745.745 0 01-.577-.273.747.747 0 01.1-1.055c1.59-1.317 2.62-3.362 2.62-5.207 0-1.85-1.028-3.893-2.62-5.208a.747.747 0 01-.1-1.055.747.747 0 011.055-.1C21.257 7.312 22.5 9.81 22.5 12.087c0 2.275-1.243 4.773-3.165 6.363a.734.734 0 01-.478.172zm-1.927-2.41a.749.749 0 01-.44-1.357c.737-.538 1.62-1.453 1.62-2.768 0-1.315-.88-2.23-1.62-2.767a.748.748 0 01-.165-1.048.748.748 0 011.047-.165c1.443 1.05 2.238 2.463 2.238 3.983s-.795 2.932-2.238 3.982a.767.767 0 01-.442.14z",
            fill: "currentColor"
        })
    });



const $3465f2aea720bdf5$export$735e6a1fa9c9d72e = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M11.6 3.8L6 8H4a2 2 0 00-2 2v4a2 2 0 002 2h2l5.6 4.2A1.5 1.5 0 0014 19V5a1.5 1.5 0 00-2.4-1.2zm8.81 8.2l1.3-1.29a1.005 1.005 0 00-1.42-1.42L19 10.59l-1.29-1.3a1.004 1.004 0 00-1.42 1.42l1.3 1.29-1.3 1.29a1.002 1.002 0 00.325 1.639 1 1 0 001.095-.219l1.29-1.3 1.29 1.3a1.002 1.002 0 001.639-.325 1 1 0 00-.219-1.095L20.41 12z",
            fill: "currentColor"
        })
    });



const $a764724423ba3a01$export$666078c45e444917 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M11.6 3.8L6 8H4a2 2 0 00-2 2v4a2 2 0 002 2h2l5.6 4.2A1.5 1.5 0 0014 19V5a1.5 1.5 0 00-2.4-1.2zm4.11 6.08a1 1 0 000 1.41 1.002 1.002 0 010 1.42 1 1 0 000 1.41 1 1 0 001.41 0 3 3 0 000-4.24 1 1 0 00-1.41 0zM20 7.05a1 1 0 00-1.41 0 1 1 0 000 1.41 5 5 0 010 7.08 1 1 0 000 1.41 1 1 0 00.7.29A1 1 0 0020 17a6.999 6.999 0 000-9.9v-.05z",
            fill: "currentColor"
        })
    });



const $7a68f57be710ec82$export$798ddd2b9c4242da = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M11.6 3.8L6 8H4a2 2 0 00-2 2v4a2 2 0 002 2h2l5.6 4.2A1.5 1.5 0 0014 19V5a1.5 1.5 0 00-2.4-1.2zm5.52 6.08a1 1 0 10-1.41 1.41 1.002 1.002 0 010 1.42 1 1 0 000 1.41 1 1 0 001.41 0 3 3 0 000-4.24z",
            fill: "currentColor"
        })
    });



const $0ccd7688ee3e5bd2$export$6768b8b2bd0d6bdf = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M13.8 4.4L9 8H7a2 2 0 00-2 2v4a2 2 0 002 2h2l4.8 3.6A2 2 0 0017 18V6a2 2 0 00-3.2-1.6z",
            fill: "currentColor"
        })
    });



const $33db3e7e81390ca9$export$39dd6172b73752db = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4.11 13.24A8.35 8.35 0 014 12a8.23 8.23 0 01.11-1.24 1.012 1.012 0 00-2-.31 9.31 9.31 0 000 3.1 1 1 0 001 .85h.15a1.001 1.001 0 00.85-1.16zm1.31 3.31a1.001 1.001 0 00-1.863.354 1 1 0 00.223.776A9.93 9.93 0 006 20a1 1 0 001.18.012 1 1 0 00.03-1.602 8.06 8.06 0 01-1.79-1.86zM12 2a10.3 10.3 0 00-2 .2 1.02 1.02 0 10.4 2A7.85 7.85 0 0112 4a8 8 0 010 16 7.85 7.85 0 01-1.61-.16 1.019 1.019 0 10-.4 2 10.3 10.3 0 002 .2A10.02 10.02 0 0012 2zM6 4.05a9.93 9.93 0 00-2.22 2.27A1 1 0 004 7.71a1 1 0 001.39-.26 8.06 8.06 0 011.77-1.81A1 1 0 106 4.05zm6 9.36l2.29 2.3a1 1 0 001.42 0 1.002 1.002 0 000-1.42L13.41 12l2.3-2.29a1.004 1.004 0 10-1.42-1.42L12 10.59l-2.29-2.3a1.004 1.004 0 00-1.42 1.42l2.3 2.29-2.3 2.29a1 1 0 00.325 1.639 1 1 0 001.095-.219l2.29-2.3z",
            fill: "currentColor"
        })
    });



const $6449c85cbf485d35$export$7abb57f9507f85ac = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4.11 13.24A8.23 8.23 0 014 12a8.23 8.23 0 01.11-1.24 1.012 1.012 0 00-2-.31 9.31 9.31 0 000 3.1 1 1 0 001 .85h.15a1.001 1.001 0 00.85-1.16zm1.31 3.31a1.001 1.001 0 00-1.863.354 1 1 0 00.223.776A9.93 9.93 0 006 20a1 1 0 001.18.012 1 1 0 00.03-1.602 8.06 8.06 0 01-1.79-1.86zM12 2a10.3 10.3 0 00-2 .2 1.02 1.02 0 10.4 2A7.85 7.85 0 0112 4a8 8 0 010 16 7.85 7.85 0 01-1.61-.16 1.019 1.019 0 10-.4 2 10.3 10.3 0 002 .2A10.02 10.02 0 0012 2zM6 4.05a9.93 9.93 0 00-2.22 2.27A1 1 0 004 7.71a1 1 0 001.39-.26 8.06 8.06 0 011.77-1.81A1 1 0 106 4.05z",
            fill: "currentColor"
        })
    });



const $6cfef88bd445e8b4$export$e71de051933b1536 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4.6 7.88a1 1 0 00.82-.43 8.06 8.06 0 011.74-1.81A1 1 0 106 4.05a9.93 9.93 0 00-2.22 2.27A1 1 0 004 7.71a1 1 0 00.6.17zm-.49 5.36A8.35 8.35 0 014 12a8.23 8.23 0 01.11-1.24 1.012 1.012 0 00-2-.31 9.31 9.31 0 000 3.1 1 1 0 001 .85h.15a1.001 1.001 0 00.85-1.16zM12 2a10.3 10.3 0 00-2 .2 1.02 1.02 0 10.4 2A7.85 7.85 0 0112 4a8 8 0 010 16 7.85 7.85 0 01-1.61-.16 1.019 1.019 0 10-.4 2 10.3 10.3 0 002 .2A10.02 10.02 0 0012 2zM5.42 16.55a1.001 1.001 0 00-1.863.354 1 1 0 00.223.776A9.93 9.93 0 006 20a1 1 0 001.18.012 1 1 0 00.03-1.602 8.06 8.06 0 01-1.79-1.86zm1.37-5.26a1 1 0 000 1.42l3 3a1 1 0 001.42 0l6-6a1.004 1.004 0 00-1.42-1.42l-5.29 5.3-2.29-2.3a1.001 1.001 0 00-1.42 0z",
            fill: "currentColor"
        })
    });



const $a63b218c8d4296ca$export$dd4cc6991b34159 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 4H5C3.34 4 2 5.34 2 7v10c0 1.66 1.34 3 3 3h14c1.66 0 3-1.34 3-3V7c0-1.66-1.34-3-3-3zM8.5 14h2c.55 0 1 .45 1 1s-.45 1-1 1h-2c-1.65 0-3-1.35-3-3v-2c0-1.65 1.35-3 3-3h2c.55 0 1 .45 1 1s-.45 1-1 1h-2c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1zm7 0h2c.55 0 1 .45 1 1s-.45 1-1 1h-2c-1.65 0-3-1.35-3-3v-2c0-1.65 1.35-3 3-3h2c.55 0 1 .45 1 1s-.45 1-1 1h-2c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1z",
            fill: "currentColor"
        })
    });



const $992d3d10a4610123$export$26725f8191e92ed4 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 5H5a3 3 0 00-3 3v8a3 3 0 003 3h14a3 3 0 003-3V8a3 3 0 00-3-3zm-4.45 7.83l-3 2A1 1 0 0110 14v-4a1 1 0 01.53-.88 1 1 0 011 .05l3 2a1 1 0 010 1.66h.02z",
            fill: "currentColor"
        })
    });



const $33c51e0937ca61c9$export$d7e550d9719f077 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18.71 14.29a1 1 0 00-1.42 0L13 18.59V3a1 1 0 10-2 0v15.59l-4.29-4.3a1.004 1.004 0 10-1.42 1.42l6 6a1.001 1.001 0 001.42 0l6-6a.999.999 0 000-1.42z",
            fill: "currentColor"
        })
    });



const $b88a189e585913b5$export$829cfb49bcb1dd0d = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18.71 8.29l-6-6a.999.999 0 00-1.42 0l-6 6a1.004 1.004 0 001.42 1.42L11 5.41V21a1 1 0 102 0V5.41l4.29 4.3a1 1 0 001.42 0 .998.998 0 000-1.42z",
            fill: "currentColor"
        })
    });



const $f418d61f807dfdc9$export$2d464064bc39ad6c = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zm4.71 9.21l-4 4a1.002 1.002 0 01-1.42 0l-4-4a1.003 1.003 0 111.42-1.42l3.29 3.3 3.29-3.3a1.004 1.004 0 011.42 1.42z",
            fill: "currentColor"
        })
    });



const $871e280509b4edc8$export$878b3b9f5d0dcd91 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zm2.21 13.29a1.002 1.002 0 01-.325 1.639 1 1 0 01-1.095-.219l-4-4a1.001 1.001 0 010-1.42l4-4a1.003 1.003 0 111.42 1.42L10.91 12l3.3 3.29z",
            fill: "currentColor"
        })
    });



const $690fffe62e5051b5$export$3899b8236f1ec80c = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zm3.21 10.71l-4 4a1.002 1.002 0 01-1.639-.325 1 1 0 01.219-1.095l3.3-3.29-3.3-3.29a1.004 1.004 0 011.42-1.42l4 4a1.002 1.002 0 010 1.42z",
            fill: "currentColor"
        })
    });



const $ecca53f6c6822664$export$57f236eb277ec7a3 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zm4.71 12.21a1.002 1.002 0 01-1.42 0L12 10.91l-3.29 3.3a1.005 1.005 0 01-1.42-1.42l4-4a1 1 0 011.42 0l4 4a1.002 1.002 0 010 1.42z",
            fill: "currentColor"
        })
    });



const $53bdb04e72430f6d$export$e7797a1f2b80e00d = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M14.32 3.37l-9.97 7.01a1.973 1.973 0 000 3.23l9.97 7.01c1.33.94 3.18 0 3.18-1.61V4.99c0-1.61-1.85-2.55-3.18-1.61v-.01z",
            fill: "currentColor"
        })
    });



const $4ce04ddc5501a9eb$export$9f8d5132e39c7f64 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 21a9 9 0 100-18 9 9 0 000 18z",
            fill: "currentColor"
        })
    });



const $f507c9d33bc4cfdd$export$4947ba61c811a943 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10.67 2.51L4.01 8.43C3.37 9 3 9.82 3 10.67V18c0 1.66 1.34 3 3 3h12c1.66 0 3-1.34 3-3v-7.33c0-.86-.37-1.67-1.01-2.24l-6.66-5.92c-.76-.67-1.9-.67-2.66 0z",
            fill: "currentColor"
        })
    });



const $4ef177948d613f96$export$36897591b4ceadb6 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 3H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-3-3z",
            fill: "currentColor"
        })
    });



const $d915fc531b5645af$export$778887eb04ce5848 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10.29 14.29a1.002 1.002 0 00.325 1.639 1 1 0 001.095-.219l3-3a1.002 1.002 0 000-1.42l-3-3a1.004 1.004 0 00-1.42 1.42l1.3 1.29H3a1 1 0 000 2h8.59l-1.3 1.29zM12 2a10.06 10.06 0 00-8.09 4.13 1 1 0 00.575 1.565A1 1 0 005.53 7.31a8 8 0 110 9.38 1.002 1.002 0 10-1.62 1.18A10 10 0 1012 2z",
            fill: "currentColor"
        })
    });



const $4d36205392b50d9a$export$66989aaa748ae7a4 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.9 11.61a.867.867 0 00-.22-.32l-3-3A1 1 0 0018 8a1 1 0 00-.38.08A1.002 1.002 0 0017 9c.007.264.11.517.29.71L18.56 11H10a1 1 0 00-.92.62 1 1 0 00-.006.764c.05.122.123.233.216.326A1 1 0 0010 13h8.59l-1.31 1.29c-.09.092-.161.201-.21.32A1 1 0 0017 15c.002.13.029.26.08.38.048.123.119.235.21.33.097.091.209.166.33.22A1 1 0 0018 16a1 1 0 00.39-.07.87.87 0 00.32-.22l3-3a.829.829 0 00.22-.33A.998.998 0 0022 12a1.088 1.088 0 00-.1-.39zm-3.71 6.56a1 1 0 00-.61-.17 1 1 0 00-.63.23 7.54 7.54 0 01-2.5 1.37 8.001 8.001 0 01-3.73.31 8.12 8.12 0 01-3.46-1.43A8 8 0 014.83 8.36a8 8 0 019.62-4A7.68 7.68 0 0117 5.77a1 1 0 00.6.23.92.92 0 00.58-.17 1 1 0 00.38-.47 1.06 1.06 0 000-.61 1 1 0 00-.32-.51 9.519 9.519 0 00-2.1-1.32 10 10 0 102.06 16.89.91.91 0 00.37-.51 1 1 0 000-.63.999.999 0 00-.38-.5z",
            fill: "currentColor"
        })
    });



const $ad3e6771d9e5993c$export$cd8e942809851b6 = (v)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...v,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 3H4a1 1 0 00-1 1v16a1 1 0 001 1h8.61v-7h-2.33v-2.68h2.33v-2a3.279 3.279 0 013.51-3.59 13.31 13.31 0 012.09.11v2.41h-1.43c-1.13 0-1.35.54-1.35 1.33v1.73h2.7L17.78 14h-2.35v7H20a1 1 0 001-1V4a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $7f7a460e6fee40b2$export$dd19003a6685499 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.79 11.51a9.373 9.373 0 00-.14-1.2h-8.47v3.51h4.9a4.219 4.219 0 01-1.79 2.77 5.001 5.001 0 01-2 .78c-.71.13-1.44.13-2.15 0a5.46 5.46 0 01-3.93-3.3 3.062 3.062 0 01-.13-.32 5.35 5.35 0 010-3.49A5.61 5.61 0 018.4 8.13a5.29 5.29 0 012.69-1.49 5.36 5.36 0 012.64.1 4.8 4.8 0 011.94 1.15l1.65-1.66c.3-.29.6-.58.88-.88a8.54 8.54 0 00-2.9-1.79A9 9 0 004.14 8a9 9 0 002.44 11.09 9.1 9.1 0 003.27 1.61 9.59 9.59 0 004.61 0 7.93 7.93 0 006-5.65c.319-1.151.43-2.35.33-3.54z",
            fill: "currentColor"
        })
    });



const $abc6fa51e3a30eab$export$f74420886324c907 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 7.38a4.62 4.62 0 100 9.24 4.62 4.62 0 000-9.24zM12 15a3 3 0 110-6 3 3 0 010 6zm9-6.71a6.809 6.809 0 00-.42-2.19 4.66 4.66 0 00-2.68-2.63 6.81 6.81 0 00-2.19-.42H8.29a6.81 6.81 0 00-2.19.42A4.66 4.66 0 003.47 6.1a6.81 6.81 0 00-.42 2.19v7.42a6.81 6.81 0 00.42 2.19 4.66 4.66 0 002.63 2.63c.699.276 1.439.435 2.19.47 1 0 1.27.05 3.71.05s2.75 0 3.71-.05a6.81 6.81 0 002.19-.42 4.66 4.66 0 002.63-2.63c.282-.715.44-1.472.47-2.24 0-1 .05-1.27.05-3.71S21 9.25 21 8.29zm-1.62 7.35a5.3 5.3 0 01-.38 1.67A3.058 3.058 0 0117.31 19c-.537.192-1.1.297-1.67.31-1 0-1.24.05-3.64.05-2.4 0-2.69 0-3.64-.05A5.302 5.302 0 016.69 19 3.06 3.06 0 015 17.31a5.3 5.3 0 01-.31-1.67V12 8.36A5.3 5.3 0 015 6.69 3.06 3.06 0 016.69 5a5.3 5.3 0 011.67-.31h7.28a5.3 5.3 0 011.67.31A3.06 3.06 0 0119 6.69c.192.536.297 1.1.31 1.67 0 1 .05 1.24.05 3.64 0 2.4.01 2.69-.03 3.64h.05zM16.8 6.12a1.08 1.08 0 100 2.16 1.08 1.08 0 000-2.16z",
            fill: "currentColor"
        })
    });



const $c044191577618eea$export$ee16e935a368e4f = (v)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...v,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.65 3H4.35A1.33 1.33 0 003 4.31v15.38A1.33 1.33 0 004.35 21h15.3A1.33 1.33 0 0021 19.69V4.31A1.33 1.33 0 0019.65 3zM8.33 18.34H5.7V9.79h2.63v8.55zM7.05 8.59A1.59 1.59 0 015.47 7a1.54 1.54 0 011.58-1.56 1.58 1.58 0 010 3.15zm11.4 9.67h-2.7v-4.2c0-1 0-2.32-1.42-2.32s-1.58 1.12-1.58 2.17v4.28h-2.63v-8.4h2.48v1.12h.07a3 3 0 012.55-1.42c2.7 0 3.23 1.8 3.23 4.12v4.65z",
            fill: "currentColor"
        })
    });



const $2074d2c092e43637$export$fdabec1e24108fa0 = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21 7.21a5.201 5.201 0 00-.09-1 3.819 3.819 0 00-.36-1.13 3.998 3.998 0 00-.75-1 3.75 3.75 0 00-1.64-.94A6.65 6.65 0 0016.41 3H6.59a4.92 4.92 0 00-1.06.24 3.84 3.84 0 00-2.34 2.61A6.21 6.21 0 003 7.57v8.85c0 .4 0 .8.08 1.2.062.42.187.827.37 1.21.26.51.628.958 1.08 1.31.325.26.694.46 1.09.59A6.229 6.229 0 007.4 21h9.36a6.481 6.481 0 001.08-.11 3.75 3.75 0 001.81-.89 3.7 3.7 0 001.19-2 6.999 6.999 0 00.16-1.58v-.1-9.11zm-2.41 8.33c-.11.27-.69.49-1.68.65-.09 0-.13.16-.18.41 0 .1-.05.2-.08.3a.19.19 0 01-.19.15h-.28a3.652 3.652 0 00-.74-.08 3.07 3.07 0 00-.53.05 2.54 2.54 0 00-1 .51 2.93 2.93 0 01-1.78.7h-.16a2.91 2.91 0 01-1.78-.7 2.54 2.54 0 00-1-.51 3.271 3.271 0 00-.53-.05 3.652 3.652 0 00-.74.08.9.9 0 01-.28 0 .18.18 0 01-.21-.15c0-.1-.06-.2-.08-.3 0-.25-.09-.4-.18-.41-1-.15-1.57-.38-1.69-.65v-.09a.16.16 0 01.14-.16 3.43 3.43 0 001.98-1.23c.287-.317.526-.674.71-1.06a.71.71 0 00.07-.6c-.13-.3-.55-.43-.83-.52l-.18-.06c-.25-.1-.65-.3-.6-.59a.54.54 0 01.53-.35.51.51 0 01.17 0c.203.11.429.171.66.18a.55.55 0 00.39-.12v-.39a6.63 6.63 0 01.15-2.66 3.47 3.47 0 013.21-2.07h.27a3.46 3.46 0 013.21 2.07 6.63 6.63 0 01.16 2.66v.35c.1.08.223.121.35.12a2 2 0 00.63-.17.46.46 0 01.2-.05c.082.002.163.019.24.05a.43.43 0 01.33.36c0 .14-.1.34-.6.54l-.19.06c-.28.09-.7.23-.82.53a.69.69 0 00.07.59 4.059 4.059 0 002.77 2.33.15.15 0 01.13.16.29.29 0 01-.06.12h.02z",
            fill: "currentColor"
        })
    });



const $e5818c112b7a67fa$export$64b6807a803a1c01 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15.865 11.522a5.478 5.478 0 00-.213-.096c-.125-2.309-1.386-3.63-3.504-3.644h-.029c-1.266 0-2.32.541-2.968 1.525l1.164.799c.485-.735 1.245-.892 1.805-.892h.02c.697.005 1.223.208 1.563.603.248.288.414.686.496 1.188a8.909 8.909 0 00-2.002-.097c-2.013.116-3.308 1.29-3.22 2.922.043.828.456 1.54 1.16 2.005.596.393 1.363.586 2.16.542 1.054-.057 1.88-.46 2.456-1.194.438-.558.715-1.28.837-2.192.502.303.874.702 1.08 1.18.349.815.369 2.154-.723 3.245-.957.956-2.107 1.37-3.845 1.382-1.928-.014-3.387-.633-4.335-1.838-.887-1.129-1.346-2.759-1.363-4.845.017-2.086.476-3.717 1.363-4.845.948-1.205 2.407-1.824 4.335-1.838 1.942.014 3.425.636 4.41 1.847.482.594.846 1.34 1.086 2.211l1.365-.364c-.29-1.072-.748-1.995-1.37-2.761C16.33 4.812 14.484 4.016 12.106 4h-.01c-2.373.016-4.198.815-5.424 2.374C5.582 7.76 5.019 9.69 5 12.109v.012c.019 2.419.582 4.348 1.673 5.735 1.226 1.559 3.05 2.358 5.424 2.374h.01c2.11-.015 3.597-.567 4.822-1.791 1.603-1.602 1.555-3.609 1.026-4.841-.379-.884-1.101-1.602-2.09-2.076zm-3.643 3.425c-.882.05-1.799-.346-1.844-1.194-.034-.63.447-1.332 1.899-1.415.166-.01.329-.014.489-.014.527 0 1.02.05 1.468.149-.167 2.088-1.148 2.427-2.012 2.474z",
            fill: "currentColor"
        })
    });



const $18ca43e86a8fa5cb$export$8774a7d7e6a9f97c = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M3.042 4l6.709 8.952L3 20.23h1.52l5.91-6.372 4.775 6.372h5.17l-7.086-9.455L19.573 4h-1.52L12.61 9.869 8.213 4h-5.17zm2.235 1.117h2.375L18.14 19.113h-2.375L5.277 5.117z",
            fill: "currentColor"
        })
    });



const $02e6e2c276f2a72e$export$11fe3d68d37e8c65 = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16.44 13.62c-.22-.11-1.35-.66-1.56-.74-.21-.08-.36-.11-.51.12-.15.23-.59.74-.73.89-.14.15-.26.17-.49 0a6.113 6.113 0 01-1.84-1.12A6.841 6.841 0 0110 11.25c-.14-.23 0-.35.1-.47s.23-.26.34-.39c.093-.116.17-.244.23-.38a.4.4 0 000-.4c-.06-.11-.51-1.23-.71-1.68-.2-.45-.38-.38-.51-.38L9 7.53a.87.87 0 00-.61.28 2.55 2.55 0 00-.8 1.9 4.33 4.33 0 00.94 2.34 9.33 9.33 0 003.9 3.43c2.33.91 2.33.6 2.75.56A2.26 2.26 0 0016.75 15a1.85 1.85 0 00.13-1.08c-.05-.13-.21-.18-.44-.3zM12.17 2.5a9.28 9.28 0 00-9.32 9.26 9.12 9.12 0 001.33 4.77l-1.68 5 5.16-1.64A9.41 9.41 0 0012.17 21a9.259 9.259 0 100-18.51v.01zm0 17a7.86 7.86 0 01-4.31-1.29l-3 1 1-2.89a7.71 7.71 0 01-1.5-4.56 7.84 7.84 0 117.84 7.78l-.03-.04z",
            fill: "currentColor"
        })
    });



const $eee34f8f9fdeabfd$export$cc14ca5181ed4f33 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.58 7.19a2.51 2.51 0 00-1.77-1.77C18.26 5 12 5 12 5s-6.26 0-7.81.42a2.51 2.51 0 00-1.77 1.77A25.83 25.83 0 002 12a25.83 25.83 0 00.42 4.81 2.51 2.51 0 001.77 1.77C5.74 19 12 19 12 19s6.26 0 7.81-.42a2.51 2.51 0 001.77-1.77c.29-1.587.43-3.197.42-4.81.01-1.613-.13-3.223-.42-4.81zM10 15V9l5.19 3L10 15z",
            fill: "currentColor"
        })
    });



const $a8100697dd0fca41$export$fde65d50f0ae096a = (e)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...e,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("mask", {
                id: "ic_flag_gb_svg__a",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: 0,
                y: 0,
                width: 24,
                height: 24,
                children: (0, $7b02d682eb115277$exports.jsx)("circle", {
                    cx: 12,
                    cy: 12,
                    r: 12,
                    fill: "#C4C4C4"
                })
            }),
            (0, $7b02d682eb115277$exports.jsxs)("g", {
                mask: "url(#ic_flag_gb_svg__a)",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M14.5 0h-5v9.5H0v5h9.5V24h5v-9.5H24v-5h-9.5V0z",
                        fill: "#C3283A"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M23.04 8H24v-.58l-.96.58zM24 2.18V0h-8v6.98l8-4.8zM8 6.98V0H0v2.18l8 4.8zM0 7.42V8h.96L0 7.42zM24 16.58V16h-.96l.96.58zM16 17.02V24h8v-2.18l-8-4.8zM.96 16H0v.58L.96 16zM0 21.82V24h8v-6.98l-8 4.8z",
                        fill: "#162667"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M24 17.68L21.21 16h-2.92L24 19.43v-1.75zM24 3.33L16.21 8h2.92L24 5.08V3.33zM0 4.53v1.75L2.88 8h2.91L0 4.53zM0 20.73L7.88 16H4.96L0 18.98v1.75z",
                        fill: "#C3283A"
                    })
                ]
            })
        ]
    });



const $5d7d0ed9a2353880$export$c9ff8af729b11eec = (c)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("mask", {
                id: "ic_flag_in_svg__a",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: 2,
                y: 2,
                width: 20,
                height: 20,
                children: (0, $7b02d682eb115277$exports.jsx)("circle", {
                    cx: 12,
                    cy: 12,
                    r: 10,
                    fill: "#C4C4C4"
                })
            }),
            (0, $7b02d682eb115277$exports.jsxs)("g", {
                mask: "url(#ic_flag_in_svg__a)",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M27.179 2H-3.18v20.179H27.18V2z",
                        fill: "#fff"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M27.179 2H-3.18v6.726H27.18V2z",
                        fill: "#FF9932"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M27.178 15.453H-3.179v6.726h30.357v-6.726z",
                        fill: "#128808"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M12.463 12.067a.456.456 0 00-.01-.076l.457-.064 1.287-.425-1.328.274-.427.172a.464.464 0 00-.03-.071l.425-.179 1.132-.742-1.21.606-.368.277a.478.478 0 00-.047-.062l.363-.281.901-1.01-1.013.899-.282.361a.464.464 0 00-.062-.047l.277-.366.609-1.207-.745 1.129-.18.422a.446.446 0 00-.07-.03l.172-.424.274-1.324-.426 1.283-.063.454a.46.46 0 00-.077-.01l.057-.454-.08-1.35-.078 1.35.057.453a.46.46 0 00-.077.01l-.063-.454L11.41 9.9l.275 1.324.172.424a.451.451 0 00-.071.03l-.18-.422-.744-1.13.608 1.208.277.366a.465.465 0 00-.06.047l-.283-.361-1.013-.9.901 1.01.363.282a.478.478 0 00-.047.062l-.367-.277-1.212-.606 1.133.742.424.179a.455.455 0 00-.03.071l-.426-.172-1.328-.274 1.287.425.456.064a.456.456 0 00-.01.076l-.457-.056-1.353.078 1.353.079.458-.057a.456.456 0 00.01.076l-.457.064-1.287.425 1.328-.273.428-.173a.445.445 0 00.03.07l-.426.18-1.133.743 1.212-.607.368-.277c.014.021.03.042.048.06l-.365.284-.901 1.01 1.013-.9.284-.363c.019.018.04.033.061.047l-.279.369-.608 1.208.745-1.13.18-.424a.45.45 0 00.071.03l-.173.426-.275 1.323.427-1.283.064-.457c.025.006.05.01.076.01l-.057.458.079 1.35.079-1.35-.057-.458a.446.446 0 00.076-.01l.064.457.426 1.283-.274-1.323-.173-.428a.448.448 0 00.07-.03l.181.425.745 1.13-.609-1.207-.278-.368a.472.472 0 00.061-.047l.284.363 1.013.899-.901-1.01-.365-.283a.454.454 0 00.047-.061l.37.277 1.211.607-1.133-.743-.426-.18a.445.445 0 00.03-.07l.428.173 1.328.273-1.287-.425-.457-.064a.446.446 0 00.01-.076l.458.057 1.353-.079-1.353-.078-.458.056z",
                        fill: "#000089"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M14.675 11.738a2.686 2.686 0 00-1.977-2.247 2.706 2.706 0 00-2.84.96 2.686 2.686 0 00.948 4.051 2.705 2.705 0 003.334-.775 2.684 2.684 0 00.535-1.989zm-.32.535a.126.126 0 00-.033.25c-.023.12-.054.237-.095.351a.127.127 0 00-.162.164c.012.03.035.055.065.069-.053.11-.114.214-.183.315a.127.127 0 00-.198.116c.004.033.02.062.044.083-.079.092-.165.178-.258.257a.126.126 0 00-.173-.018.126.126 0 00-.027.172c-.1.069-.206.13-.316.182a.126.126 0 00-.233.096c-.115.04-.233.072-.353.094a.126.126 0 00-.25.033c-.121.01-.243.01-.365 0a.126.126 0 00-.2-.112.126.126 0 00-.05.08 2.346 2.346 0 01-.353-.094.126.126 0 00-.07-.16.126.126 0 00-.163.063 2.376 2.376 0 01-.316-.182.126.126 0 00-.117-.202.127.127 0 00-.084.048 2.374 2.374 0 01-.258-.257.126.126 0 00-.154-.199 2.34 2.34 0 01-.183-.315.126.126 0 00-.096-.233 2.35 2.35 0 01-.095-.351.127.127 0 00.105-.141.126.126 0 00-.139-.109 2.347 2.347 0 010-.364.126.126 0 00.14-.11.126.126 0 00-.107-.14 2.32 2.32 0 01.095-.352.127.127 0 00.16-.164.126.126 0 00-.064-.068c.053-.11.114-.215.183-.316a.127.127 0 00.174-.026.125.125 0 00-.02-.174 2.38 2.38 0 01.258-.258.127.127 0 00.225-.06.125.125 0 00-.025-.093c.1-.07.206-.13.316-.183a.126.126 0 00.234-.095c.115-.04.233-.072.353-.094a.126.126 0 00.224.059.126.126 0 00.026-.092c.122-.01.244-.01.366 0a.125.125 0 00.108.142.127.127 0 00.142-.108c.12.022.238.053.353.093a.126.126 0 00.165.163.126.126 0 00.068-.067c.11.053.216.114.317.183a.126.126 0 00.026.172.126.126 0 00.174-.019c.093.08.179.165.258.257a.126.126 0 00.061.223.127.127 0 00.093-.023c.07.1.13.206.183.315a.126.126 0 00.096.233c.04.115.072.232.094.352a.126.126 0 00.033.25c.01.121.01.243 0 .364z",
                        fill: "#000089"
                    })
                ]
            })
        ]
    });



const $5afa8f53ec11e1fc$export$3b2bd1d2762dcaa3 = (a)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: [
            (0, $7b02d682eb115277$exports.jsxs)("g", {
                clipPath: "url(#ic_virtualcurrency_beta_svg__clip0_28944_150118)",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M23.79 5.19l-3.93 2.265a4.51 4.51 0 00-3.33-3.315L18.81.21a6.874 6.874 0 014.98 4.98z",
                        fill: "#fff"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M23.79 5.19l-3.93 2.265a4.51 4.51 0 00-3.33-3.315L18.81.21a6.874 6.874 0 014.98 4.98z",
                        fill: "#fff"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M7.455 4.14a4.557 4.557 0 00-3.33 3.315L.21 5.19A6.874 6.874 0 015.19.21l2.265 3.93z",
                        fill: "#7F4B10"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M4.005 15.435c0 .375.045.75.135 1.095L.21 18.81A6.995 6.995 0 010 17.115V6.885C0 6.3.075 5.73.21 5.19l3.93 2.265c-.09.36-.135.72-.135 1.095v6.885z",
                        fill: "#AC660C"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M7.455 19.86L5.19 23.79a6.874 6.874 0 01-4.98-4.98l3.93-2.265a4.552 4.552 0 003.33 3.33l-.015-.015z",
                        fill: "#FFE3AE"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M18.81 23.79c-.54.135-1.11.21-1.695.21H6.885a6.995 6.995 0 01-1.695-.21l2.265-3.93c.36.09.72.135 1.095.135h6.885c.375 0 .75-.045 1.095-.135l2.265 3.93h.015z",
                        fill: "#FFD947"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M23.79 18.81a6.898 6.898 0 01-4.98 4.98l-2.265-3.93a4.576 4.576 0 003.33-3.33l3.93 2.265-.015.015z",
                        fill: "#7F4B10"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M18.81.21l-2.265 3.93a4.38 4.38 0 00-1.095-.135H8.565c-.375 0-.75.045-1.095.135L5.19.21C5.73.075 6.3 0 6.885 0h10.23c.585 0 1.155.075 1.68.21h.015z",
                        fill: "#FFD947"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M24 6.885v10.23c0 .585-.075 1.155-.21 1.695l-3.93-2.265c.09-.345.135-.72.135-1.095V8.565c0-.375-.045-.75-.135-1.095l3.93-2.265c.135.54.21 1.11.21 1.695v-.015z",
                        fill: "#AC660C"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M21 8.13v7.74c0 .42-.06.84-.15 1.23a5.131 5.131 0 01-3.735 3.735 4.8 4.8 0 01-1.245.15H8.13A5.108 5.108 0 013.165 17.1c-.105-.39-.15-.81-.15-1.23V8.13c0-.42.06-.84.15-1.23A5.084 5.084 0 016.9 3.165c.39-.105.81-.15 1.23-.15h7.74c.435 0 .84.06 1.245.15A5.084 5.084 0 0120.85 6.9c.105.39.15.81.15 1.23z",
                        fill: "#F7AB20"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M16.995 9.72l-.135.75-.84 4.8a.3.3 0 01-.195.225c-1.215.33-2.505.495-3.825.495h-.405c-.69-.015-1.38-.09-2.04-.195-.315-.06-.645-.12-.945-.195-.135-.03-.285-.075-.42-.105a.274.274 0 01-.195-.225L7.02 9.72c-.045-.24.195-.42.39-.3l2.22 1.29c.12.075.285.03.36-.09l1.8-2.835a.266.266 0 01.45 0l.21.345 1.32 2.07.27.42c.075.12.24.165.36.09l.06-.03 2.16-1.26c.195-.12.435.06.39.3h-.015z",
                        fill: "#fff"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M16.995 9.72l-.135.75-.84 4.8a.3.3 0 01-.195.225c-1.215.33-2.505.495-3.825.495h-.405c-.69-.015-1.38-.09-2.04-.195-.315-.06-.645-.12-.945-.195-.135-.03-.285-.075-.42-.105a.274.274 0 01-.195-.225L7.02 9.72c-.045-.24.195-.42.39-.3l2.22 1.29c.12.075.285.03.36-.09l1.8-2.835a.266.266 0 01.45 0l.21.345 1.32 2.07.27.42c.075.12.24.165.36.09l.06-.03 2.16-1.26c.195-.12.435.06.39.3h-.015z",
                        fill: "#fff"
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsx)("defs", {
                children: (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                    id: "ic_virtualcurrency_beta_svg__clip0_28944_150118",
                    children: (0, $7b02d682eb115277$exports.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h24v24H0z"
                    })
                })
            })
        ]
    });



const $ea9dc6b4f2b52f64$export$2212409c2125ed01 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7.81 9.7c.55.55 1.23.94 1.97 1.15a4.5 4.5 0 002.36.02c.77-.2 1.48-.61 2.05-1.17.57-.57.97-1.27 1.17-2.05.2-.77.2-1.59-.02-2.36-.2-.75-.6-1.43-1.15-1.97-.55-.55-1.23-.94-1.97-1.15a4.5 4.5 0 00-2.36-.02c-.77.2-1.48.61-2.05 1.17-.57.56-.97 1.27-1.17 2.05-.2.77-.2 1.59.02 2.36.2.75.6 1.43 1.15 1.97zM14.42 12.77A7.998 7.998 0 003 20v.03C3 21.12 3.88 22 4.97 22h7.05A6.523 6.523 0 0111 18.5c0-2.48 1.38-4.63 3.42-5.73zM18.92 18.5l1.79-1.79c.39-.39.39-1.03 0-1.42a.996.996 0 00-1.41 0l-1.8 1.8-1.79-1.8a.996.996 0 00-1.41 0c-.39.39-.39 1.03 0 1.42l1.79 1.79-1.79 1.79c-.39.39-.39 1.03 0 1.42a1.001 1.001 0 001.41 0l1.79-1.8 1.8 1.8a1.001 1.001 0 001.41 0c.39-.39.39-1.03 0-1.42l-1.79-1.79z",
            fill: "currentColor"
        })
    });



const $cc1d665a7e9bceb0$export$abcfcc5512bbe0dd = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7 12a5 5 0 00-5 5 2 2 0 002 2h6a2 2 0 002-2 5 5 0 00-5-5zm0-1a3 3 0 100-6 3 3 0 000 6zm14 4h-5a1 1 0 000 2h5a1 1 0 000-2zm0-6a1 1 0 100-2h-8a1 1 0 100 2h8zm0 2h-7a1 1 0 000 2h7a1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $edaf10db685b0f0a$export$9e6a17c11e2266e0 = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M8.81 9.7c.55.55 1.23.94 1.97 1.15a4.5 4.5 0 002.36.02c.77-.2 1.48-.61 2.05-1.17.57-.57.97-1.27 1.17-2.05.2-.77.2-1.59-.02-2.36-.2-.75-.6-1.43-1.15-1.97-.55-.55-1.23-.94-1.97-1.15a4.5 4.5 0 00-2.36-.02c-.77.2-1.48.61-2.05 1.17-.57.56-.97 1.27-1.17 2.05-.2.77-.2 1.59.02 2.36.2.75.6 1.43 1.15 1.97zM15.7 12.91L13.24 18l-.73-3.84C14.16 12 12.35 12 12 12c-.38 0-2.16 0-.51 2.16L10.76 18 8.3 12.91A7.993 7.993 0 004 20v.03C4 21.12 4.88 22 5.97 22h12.06c1.09 0 1.97-.88 1.97-1.97V20a8 8 0 00-4.3-7.09z",
            fill: "currentColor"
        })
    });



const $b79375b1e749e729$export$4983b2222736bd7b = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 11a4.5 4.5 0 10-4.5-4.5A4.51 4.51 0 0012 11zm2.47 1.39l-1.9 1.41a1 1 0 01-1.2 0l-1.88-1.39A8 8 0 004 20a2 2 0 002 2h12a2 2 0 002-2 8 8 0 00-5.53-7.61zM17 20h-4a1 1 0 010-2h4a1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $ee2c5af0a1dbde06$export$a95ae993f7c699c2 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M8 11c1.93 0 3.5-1.57 3.5-3.5S9.93 4 8 4 4.5 5.57 4.5 7.5 6.07 11 8 11zm0 1c-3.31 0-6 2.69-6 6 0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2 0-3.31-2.69-6-6-6zm13-2h-2V8c0-.55-.45-1-1-1s-1 .45-1 1v2h-2c-.55 0-1 .45-1 1s.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1v-2h2c.55 0 1-.45 1-1s-.45-1-1-1z",
            fill: "currentColor"
        })
    });



const $6c9a1d35d60afe3d$export$4e67185d936c4146 = (c)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M8 11c1.93 0 3.5-1.57 3.5-3.5S9.93 4 8 4 4.5 5.57 4.5 7.5 6.07 11 8 11zm0 1c-3.31 0-6 2.69-6 6 0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2 0-3.31-2.69-6-6-6zm13.71-3.71l-2-2A.996.996 0 1018.3 7.7l.29.29H16c-1.65 0-3 1.35-3 3v1c0 .55.45 1 1 1s1-.45 1-1v-1c0-.55.45-1 1-1h2.59l-.29.29a.996.996 0 00.71 1.7c.26 0 .51-.1.71-.29l2-2a.996.996 0 000-1.41l-.01.01z",
            fill: "currentColor"
        })
    });



const $5e8d9b7c07f3a078$export$cf13649a16d99db4 = (h)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7.1 9.47h.29c.61 0 1.1-.49 1.1-1.1V7.08s0-.03-.01-.05c0-.02.01-.03.01-.05 0-.44.1-1.31.7-2.11 1.04-1.38 2.73-1.4 2.8-1.4.07 0 1.76.02 2.8 1.4.6.8.7 1.66.7 2.11 0 .02 0 .03.01.05 0 .02-.01.03-.01.05v2.24c0 .78-.31 1.19-.4 1.22h-1.1c-.28 0-.5.22-.5.5s.22.5.5.5h1.1c.28 0 .55-.12.77-.34.37-.37.59-1.02.62-1.74.04 0 .07.02.11.02h.29c.61 0 1.1-.49 1.1-1.1V7.09c0-.61-.49-1.1-1.1-1.1h-.29c-.08 0-.14.03-.22.04-.11-.53-.34-1.15-.79-1.74-1.31-1.75-3.37-1.8-3.6-1.8-.23 0-2.29.05-3.6 1.8-.45.6-.67 1.22-.79 1.74-.07-.01-.14-.04-.22-.04h-.29c-.61 0-1.1.49-1.1 1.1v1.29c0 .61.49 1.1 1.1 1.1l.02-.01zm7.9 2.56c-.04 1.72-.49 4.25-1.52 5.93l-1-3.96c1.53-2-.15-2-.47-2-.35 0-2 0-.47 2l-1 3.96c-1.04-1.68-1.48-4.21-1.52-5.93-2.89.86-5 2.83-5 6v1a2 2 0 002 2h12.01a2 2 0 002-2v-1c0-3.17-2.11-5.14-5-6H15z",
            fill: "currentColor"
        })
    });



const $aff25ef88da1de46$export$fb0f3c17ac0fe2e3 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.12 6.88A3 3 0 0019 6h-6.59l-1.12-1.12A3 3 0 009.17 4H5a3 3 0 00-3 3v10a3 3 0 003 3h14a3 3 0 003-3V9a3 3 0 00-.88-2.12zM13 9a1.5 1.5 0 110 3 1.5 1.5 0 010-3zM8 9a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm7 8H6a1 1 0 01-1-1 3 3 0 015.5-1.65A3 3 0 0116 16a1 1 0 01-1 1z",
            fill: "currentColor"
        })
    });



const $02fc754dbdceec75$export$2393d6ac903e8d62 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7 8a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm5 7a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm5-7a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm2.72 1.93A3.81 3.81 0 0017 9c-.61 0-1.213.13-1.77.38a4.44 4.44 0 01.35 5.81A6 6 0 0118 20c0 .341-.06.68-.18 1H19a1.911 1.911 0 002-1.83V12.5a3.78 3.78 0 00-1.28-2.57zm-12.21 2.3a4.4 4.4 0 011.26-2.84A4.33 4.33 0 007 9a3.76 3.76 0 00-4 3.5v6.67A1.91 1.91 0 005 21h1.18A2.85 2.85 0 016 20a6 6 0 012.42-4.8 4.41 4.41 0 01-.91-2.97zM12 16a4 4 0 00-4 4 1 1 0 001 1h6a1 1 0 001-1 4 4 0 00-4-4z",
            fill: "currentColor"
        })
    });



const $b2c85c1068152a0b$export$2720c7bea29dbb9f = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 16h-3v-2.09a6 6 0 10-2 0V16H8a1 1 0 000 2h3v3a1 1 0 002 0v-3h3a1 1 0 100-2zM8 8a4 4 0 118 0 4 4 0 01-8 0z",
            fill: "currentColor"
        })
    });



const $92270f2233606ab4$export$682158cb82204161 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M22 9a5 5 0 10-6 4.9V16h-1a1 1 0 000 2h1v2a1 1 0 102 0v-2h1a1 1 0 100-2h-1v-2.1A5 5 0 0022 9zm-5 3a3 3 0 110-6 3 3 0 010 6zm-9-.9V6.41l.29.3a1 1 0 001.42 0 1 1 0 000-1.42l-2-2a1 1 0 00-1.42 0l-2 2a1.004 1.004 0 001.42 1.42l.29-.3v4.69a5 5 0 102 0zM7 19a3 3 0 110-6 3 3 0 010 6z",
            fill: "currentColor"
        })
    });



const $bd9cc7b930682e7e$export$b31f1242c5d1fcd7 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10 11a4.5 4.5 0 10-4.5-4.5A4.51 4.51 0 0010 11zm8 1a3 3 0 100-5.999A3 3 0 0018 12zm0 1a4 4 0 00-2.67 1A8 8 0 002 20a2 2 0 002 2h12a2 2 0 002-2 8.259 8.259 0 00-.07-1H20a2 2 0 002-2 4 4 0 00-4-4z",
            fill: "currentColor"
        })
    });



const $bff939906bee27fc$export$c07cde1798e4de8c = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16.5 12c2.49 0 4.5-2.01 4.5-4.5S18.99 3 16.5 3 12 5.01 12 7.5s2.01 4.5 4.5 4.5zM12 7.5C12 5.01 9.99 3 7.5 3S3 5.01 3 7.5 5.01 12 7.5 12 12 9.99 12 7.5zm4.5 4.5c-2.49 0-4.5 2.01-4.5 4.5s2.01 4.5 4.5 4.5 4.5-2.01 4.5-4.5-2.01-4.5-4.5-4.5zm-9 0C5.01 12 3 14.01 3 16.5S5.01 21 7.5 21s4.5-2.01 4.5-4.5S9.99 12 7.5 12z",
            fill: "currentColor"
        })
    });



const $7c88dda8aafb9de8$export$f05476cd2591c50f = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 5H5a3 3 0 00-3 3v8a3 3 0 003 3h14a3 3 0 003-3V8a3 3 0 00-3-3zM8 8a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm2 8H6a1 1 0 01-1-1 3 3 0 016 0 1 1 0 01-1 1zm8-3h-1v1a1 1 0 01-2 0v-1h-1a1 1 0 010-2h1v-1a1 1 0 012 0v1h1a1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $87e3d41724680748$export$f3c26cf8ea02fe1a = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 5H5a3 3 0 00-3 3v8a3 3 0 003 3h14a3 3 0 003-3V8a3 3 0 00-3-3zM8 8a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm2 8H6a1 1 0 01-1-1 3 3 0 016 0 1 1 0 01-1 1zm9.71-5.29l-4 4a1.002 1.002 0 01-1.42 0l-2-2a1.004 1.004 0 111.42-1.42l1.29 1.3 3.29-3.3a1.004 1.004 0 011.42 1.42z",
            fill: "currentColor"
        })
    });



const $0354988169498eb6$export$7b949a9109ba1bda = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 8H6a3 3 0 00-3 3v8a3 3 0 003 3h6a3 3 0 003-3v-8a3 3 0 00-3-3zm-4.06 3.44a1.5 1.5 0 012.45.49c.111.273.139.572.08.86A1.49 1.49 0 019.29 14a1.49 1.49 0 01-.86-.08 1.5 1.5 0 01-.49-2.45v-.03zm3.77 7.27A1 1 0 0111 19H7a1 1 0 01-1-1 3 3 0 016 0 1 1 0 01-.29.71zM18 2h-6a3 3 0 00-3 3v1h3a5 5 0 015 5v5h1a3 3 0 003-3V5a3 3 0 00-3-3z",
            fill: "currentColor"
        })
    });



const $1ba213c17eadcfd7$export$e359c90e430f86c3 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M13 10.09V5.41l2.29 2.3a1 1 0 001.639-.325 1 1 0 00-.219-1.095l-4-4a1 1 0 00-1.42 0l-4 4a1.004 1.004 0 101.42 1.42L11 5.41v4.68a6 6 0 102 0zM12 20a4 4 0 110-8 4 4 0 010 8z",
            fill: "currentColor"
        })
    });



const $d750f4bd041776fa$export$9d482b3cc6e5bc2e = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 2h-3a1 1 0 100 2h.59l-1.84 1.83A5 5 0 1011 14.9V17H9a1 1 0 000 2h2v2a1 1 0 002 0v-2h2a1 1 0 000-2h-2v-2.1a5 5 0 003.17-7.65L18 5.41V6a1 1 0 002 0V3a1 1 0 00-1-1zm-7 11a3 3 0 110-5.999A3 3 0 0112 13z",
            fill: "currentColor"
        })
    });



const $7c36b80b0bfbde5e$export$e190f6d1d2464f24 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20.5 8.61a1.49 1.49 0 00-1-2.61 1.71 1.71 0 00-.51.09l-5.54-2.95a1.49 1.49 0 00-2.9 0L5 6.09a1.49 1.49 0 00-1.5 2.52v6.78A1.49 1.49 0 005 17.91l5.54 2.95a1.49 1.49 0 002.9 0L19 17.91c.165.056.337.086.51.09a1.49 1.49 0 001-2.61l-.01-6.78zM12 8a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm2 8h-4a1 1 0 01-1-1 3 3 0 016 0 1 1 0 01-1 1z",
            fill: "currentColor"
        })
    });



const $7855f0ab58c047ca$export$21480f3d89fe9360 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.12 6.88A3 3 0 0019 6h-6.59l-1.12-1.12A3 3 0 009.17 4H5a3 3 0 00-3 3v10a3 3 0 003 3h14a3 3 0 003-3V9a3 3 0 00-.88-2.12zM12 9a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm2 8h-4a1 1 0 01-1-1 3 3 0 016 0 1 1 0 01-1 1z",
            fill: "currentColor"
        })
    });



const $e99c98f84e8011ef$export$53d9f7efd5c9356c = (r)=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M9.57 5.71c0-.42-.18-.42-.28-.42h-.96v.84h.96c.1 0 .28 0 .28-.42z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M16.52 2H7.48A2.48 2.48 0 005 4.48v15.04A2.48 2.48 0 007.48 22h9.04A2.48 2.48 0 0019 19.52V4.48A2.48 2.48 0 0016.52 2zM7 4.62c0-.36.27-.62.64-.62H9.3c.79 0 1.6.53 1.6 1.71 0 1.08-.67 1.61-1.4 1.69l.57.85.72-1.09c.42-.53 1.21-.23 1.21.37v.12l-.08.17-1.05 1.58 1.1 1.72.03.22c0 .39-.36.66-.68.66-.21 0-.4-.11-.52-.29l-.73-1.14-.72 1.13c-.13.2-.32.3-.53.3-.32 0-.68-.27-.68-.66v-.12l.08-.18L9.28 9.4l-.94-1.38v.43c0 .37-.28.64-.67.64S7 8.82 7 8.45V4.62zM8 15h5c.55 0 1 .45 1 1s-.45 1-1 1H8c-.55 0-1-.45-1-1s.45-1 1-1zm8 5H8c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1z",
                fill: "currentColor"
            })
        ]
    });



const $c5ad73ccf8a21d3a$export$45f52cb19ed59922 = (l)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 12a8 8 0 00-8 8 2 2 0 002 2h12a2 2 0 002-2 8 8 0 00-8-8zm0-1a6 6 0 005.2-2.6l.3-.53-.41-.46a5.279 5.279 0 01-.9-1.67C15.79 4.45 15.05 2.05 12 2 9 2 8.22 4.45 7.83 5.74a5 5 0 01-.92 1.66l-.41.47.31.53A6 6 0 0012 11z",
            fill: "currentColor"
        })
    });



const $39834098ad2b8c29$export$5194690703787f94 = (o)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10.78 10.84a4.51 4.51 0 005.56-5.56 4.46 4.46 0 00-3.12-3.12 4.51 4.51 0 00-5.56 5.56 4.46 4.46 0 003.12 3.12zM12 12a8 8 0 00-8 8 2 2 0 002 2h12a2 2 0 002-2 8 8 0 00-8-8z",
            fill: "currentColor"
        })
    });



const $446cee63ed979417$export$87dfd3f55b043a15 = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7 11a3.1 3.1 0 00.69-.09A5.48 5.48 0 017.1 5H7a3 3 0 100 6zm5 0a3.5 3.5 0 100-7 3.5 3.5 0 000 7zm5 0a3 3 0 000-6h-.1a5.48 5.48 0 01-.59 5.9 3.1 3.1 0 00.69.1zm-5 1a6 6 0 00-6 6 2 2 0 002 2h8a2 2 0 002-2 6 6 0 00-6-6zm5.31 0A7.999 7.999 0 0120 18a4.09 4.09 0 01-.14 1H20a2 2 0 002-2 5 5 0 00-4.69-5zM6.69 12A5 5 0 002 17a2 2 0 002 2h.14A4.09 4.09 0 014 18a8 8 0 012.69-6z",
            fill: "currentColor"
        })
    });



const $2268bec76c3130e9$export$b55022dc20ad835c = (r)=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm6 11a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM6 16a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm12 1a3 3 0 00-3 3 1 1 0 001 1h4a1 1 0 001-1 3 3 0 00-3-3zM6 17a3 3 0 00-3 3 1 1 0 001 1h4a1 1 0 001-1 3 3 0 00-3-3zm8.45-1.89L13 14.38V13a1 1 0 00-2 0v1.38l-1.45.73A1 1 0 0010 17a.93.93 0 00.45-.11l1.55-.77 1.55.77A.93.93 0 0014 17a1 1 0 00.45-1.89zM10 10h4a1 1 0 001-1 3 3 0 00-6 0 1 1 0 001 1z",
            fill: "currentColor"
        })
    });






var $acw62 = parcelRequire("acw62");

'use strict';
function $e5cb5cefd6507f7e$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $c319b2c832c2914a$var$toString } = Object.prototype;
const { getPrototypeOf: $c319b2c832c2914a$var$getPrototypeOf } = Object;
const { iterator: $c319b2c832c2914a$var$iterator, toStringTag: $c319b2c832c2914a$var$toStringTag } = Symbol;
/* Creating a function that will check if an object has a property. */ const $c319b2c832c2914a$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
const $c319b2c832c2914a$var$isUnsafeObjectKey = (prop)=>typeof prop === 'string' && (prop === '__proto__' || prop === 'constructor' || prop === 'prototype');
/**
 * Determine whether an inherited object must be treated as a shared-prototype
 * boundary. Cross-realm Object.prototype objects cannot be distinguished
 * reliably from application-created null-prototype objects because their
 * properties are mutable, so all inherited terminal prototypes are excluded
 * as a fail-closed boundary. A null-prototype source still keeps its own
 * properties, as produced by mergeConfig and other safe materialization paths.
 *
 * @param {*} obj The object to inspect
 * @param {*} prototype The object's prototype
 * @param {boolean} source Whether obj is the original traversal source
 *
 * @returns {boolean} True when obj is a safe prototype traversal boundary
 */ const $c319b2c832c2914a$var$isPrototypeBoundary = (obj, prototype, source)=>obj === Object.prototype || !source && prototype === null;
/**
 * Determine whether an object can retain its identity through code paths that
 * add, replace, and remove config properties without bypassing unsafe-key
 * filtering. Immutable objects, unsafe-key-bearing objects, and objects with
 * accessor or restricted data properties must be materialized instead.
 *
 * @param {*} obj The object to inspect
 *
 * @returns {boolean} True when every own property is safe and fully mutable
 */ const $c319b2c832c2914a$var$isSafeAndFullyMutable = (obj)=>{
    if (!Object.isExtensible(obj)) return false;
    const props = Object.getOwnPropertyNames(obj);
    if (Object.getOwnPropertySymbols) props.push(...Object.getOwnPropertySymbols(obj));
    return props.every((prop)=>{
        if ($c319b2c832c2914a$var$isUnsafeObjectKey(prop)) return false;
        const descriptor = Object.getOwnPropertyDescriptor(obj, prop);
        return !!descriptor && descriptor.configurable && descriptor.writable === true;
    });
};
/**
 * Walk the prototype chain (excluding the source realm's Object.prototype)
 * looking for an own `prop`. This distinguishes genuine own/inherited members
 * — including class accessors and template prototypes — from members injected
 * via Object.prototype pollution (e.g. `Object.prototype.username = '...'`),
 * which live on Object.prototype itself and are therefore never matched.
 *
 * @param {*} thing The value whose chain to inspect
 * @param {string|symbol} prop The property key to look for
 *
 * @returns {boolean} True when `prop` is owned below Object.prototype
 */ const $c319b2c832c2914a$var$hasOwnInPrototypeChain = (thing, prop)=>{
    let obj = thing;
    const seen = [];
    while(obj != null){
        if (seen.indexOf(obj) !== -1) return false;
        seen.push(obj);
        const prototype = $c319b2c832c2914a$var$getPrototypeOf(obj);
        if ($c319b2c832c2914a$var$isPrototypeBoundary(obj, prototype, obj === thing)) return false;
        if ($c319b2c832c2914a$var$hasOwnProperty(obj, prop)) return true;
        obj = prototype;
    }
    return false;
};
/**
 * Read `obj[prop]` only when it is safe from Object.prototype pollution. Own
 * properties and members inherited from a non-Object.prototype source (a class
 * instance or template object) are honored; a value reachable only through a
 * polluted Object.prototype is ignored and `undefined` is returned.
 *
 * @param {*} obj The source object
 * @param {string|symbol} prop The property key to read
 *
 * @returns {*} The resolved value, or undefined when unsafe/absent
 */ const $c319b2c832c2914a$var$getSafeProp = (obj, prop)=>obj != null && $c319b2c832c2914a$var$hasOwnInPrototypeChain(obj, prop) ? obj[prop] : undefined;
/**
 * Flatten an object and its application-defined prototype chain into a
 * null-prototype object. Members inherited only from the source realm's
 * Object.prototype are deliberately excluded, while class/template members
 * below that boundary are preserved.
 *
 * @param {*} thing The value to flatten
 *
 * @returns {*} A null-prototype copy, or the original value when it is already
 * structurally safe or is not an object
 */ const $c319b2c832c2914a$var$toSafeFlatObject = (thing)=>{
    if (thing == null || typeof thing !== 'object' && typeof thing !== 'function') return thing;
    const sourcePrototype = $c319b2c832c2914a$var$getPrototypeOf(thing);
    if (sourcePrototype === null && $c319b2c832c2914a$var$isSafeAndFullyMutable(thing)) return thing;
    const result = Object.create(null);
    const merged = Object.create(null);
    const seen = [];
    let current = thing;
    while(current != null){
        if (seen.indexOf(current) !== -1) break;
        seen.push(current);
        const prototype = current === thing ? sourcePrototype : $c319b2c832c2914a$var$getPrototypeOf(current);
        if ($c319b2c832c2914a$var$isPrototypeBoundary(current, prototype, current === thing)) break;
        const props = Object.getOwnPropertyNames(current);
        if (Object.getOwnPropertySymbols) props.push(...Object.getOwnPropertySymbols(current));
        for (const prop of props){
            if ($c319b2c832c2914a$var$isUnsafeObjectKey(prop)) continue;
            if (!$c319b2c832c2914a$var$hasOwnProperty(merged, prop)) {
                result[prop] = thing[prop];
                merged[prop] = true;
            }
        }
        current = prototype;
    }
    return result;
};
const $c319b2c832c2914a$var$kindOf = ((cache)=>(thing)=>{
        const str = $c319b2c832c2914a$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $c319b2c832c2914a$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$c319b2c832c2914a$var$kindOf(thing) === type;
};
const $c319b2c832c2914a$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is a non-null object
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $c319b2c832c2914a$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $c319b2c832c2914a$var$isUndefined = $c319b2c832c2914a$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $c319b2c832c2914a$var$isBuffer(val) {
    return val !== null && !$c319b2c832c2914a$var$isUndefined(val) && val.constructor !== null && !$c319b2c832c2914a$var$isUndefined(val.constructor) && $c319b2c832c2914a$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $c319b2c832c2914a$var$isArrayBuffer = $c319b2c832c2914a$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $c319b2c832c2914a$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $c319b2c832c2914a$var$isString = $c319b2c832c2914a$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $c319b2c832c2914a$var$isFunction = $c319b2c832c2914a$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $c319b2c832c2914a$var$isNumber = $c319b2c832c2914a$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $c319b2c832c2914a$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $c319b2c832c2914a$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $c319b2c832c2914a$var$isPlainObject = (val)=>{
    if (!$c319b2c832c2914a$var$isObject(val)) return false;
    const prototype = $c319b2c832c2914a$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || $c319b2c832c2914a$var$getPrototypeOf(prototype) === null) && // Treat safe own/inherited Symbol.toStringTag or Symbol.iterator members as
    // evidence the value is tagged/iterable, while ignoring members reachable
    // only through shared or terminal prototype boundaries.
    !$c319b2c832c2914a$var$hasOwnInPrototypeChain(val, $c319b2c832c2914a$var$toStringTag) && !$c319b2c832c2914a$var$hasOwnInPrototypeChain(val, $c319b2c832c2914a$var$iterator);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const $c319b2c832c2914a$var$isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$c319b2c832c2914a$var$isObject(val) || $c319b2c832c2914a$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $c319b2c832c2914a$var$isDate = $c319b2c832c2914a$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c319b2c832c2914a$var$isFile = $c319b2c832c2914a$var$kindOfTest('File');
/**
 * Determine if a value is a React Native Blob
 * React Native "blob": an object with a `uri` attribute. Optionally, it can
 * also have a `name` and `type` attribute to specify filename and content type
 *
 * @see https://github.com/facebook/react-native/blob/26684cf3adf4094eb6c405d345a75bf8c7c0bf88/Libraries/Network/FormData.js#L68-L71
 *
 * @param {*} value The value to test
 *
 * @returns {boolean} True if value is a React Native Blob, otherwise false
 */ const $c319b2c832c2914a$var$isReactNativeBlob = (value)=>{
    return !!(value && typeof value.uri !== 'undefined');
};
/**
 * Determine if environment is React Native
 * ReactNative `FormData` has a non-standard `getParts()` method
 *
 * @param {*} formData The formData to test
 *
 * @returns {boolean} True if environment is React Native, otherwise false
 */ const $c319b2c832c2914a$var$isReactNative = (formData)=>formData && typeof formData.getParts !== 'undefined';
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $c319b2c832c2914a$var$isBlob = $c319b2c832c2914a$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a FileList, otherwise false
 */ const $c319b2c832c2914a$var$isFileList = $c319b2c832c2914a$var$kindOfTest('FileList');
const $c319b2c832c2914a$var$isSet = $c319b2c832c2914a$var$kindOfTest('Set');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $c319b2c832c2914a$var$isStream = (val)=>$c319b2c832c2914a$var$isObject(val) && $c319b2c832c2914a$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $c319b2c832c2914a$var$getGlobal() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    return {};
}
const $c319b2c832c2914a$var$G = $c319b2c832c2914a$var$getGlobal();
const $c319b2c832c2914a$var$FormDataCtor = typeof $c319b2c832c2914a$var$G.FormData !== 'undefined' ? $c319b2c832c2914a$var$G.FormData : undefined;
const $c319b2c832c2914a$var$isFormData = (thing)=>{
    if (!thing) return false;
    if ($c319b2c832c2914a$var$FormDataCtor && thing instanceof $c319b2c832c2914a$var$FormDataCtor) return true;
    // Reject plain objects inheriting directly from Object.prototype so prototype-pollution gadgets can't spoof FormData.
    const proto = $c319b2c832c2914a$var$getPrototypeOf(thing);
    if (!proto || proto === Object.prototype) return false;
    if (!$c319b2c832c2914a$var$isFunction(thing.append)) return false;
    const kind = $c319b2c832c2914a$var$kindOf(thing);
    return kind === 'formdata' || // detect form-data instance
    kind === 'object' && $c319b2c832c2914a$var$isFunction(thing.toString) && thing.toString() === '[object FormData]';
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $c319b2c832c2914a$var$isURLSearchParams = $c319b2c832c2914a$var$kindOfTest('URLSearchParams');
const [$c319b2c832c2914a$var$isReadableStream, $c319b2c832c2914a$var$isRequest, $c319b2c832c2914a$var$isResponse, $c319b2c832c2914a$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($c319b2c832c2914a$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $c319b2c832c2914a$var$trim = (str)=>{
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array<unknown>} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys = false]
 * @returns {any}
 */ function $c319b2c832c2914a$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($c319b2c832c2914a$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($c319b2c832c2914a$var$isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
/**
 * Finds a key in an object, case-insensitive, returning the actual key name.
 * Returns null if the object is a Buffer or if no match is found.
 *
 * @param {Object} obj - The object to search.
 * @param {string} key - The key to find (case-insensitive).
 * @returns {?string} The actual key name if found, otherwise null.
 */ function $c319b2c832c2914a$var$findKey(obj, key) {
    if ($c319b2c832c2914a$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $c319b2c832c2914a$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== 'undefined') return globalThis;
    return typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $c319b2c832c2914a$var$isContextDefined = (context)=>!$c319b2c832c2914a$var$isUndefined(context) && context !== $c319b2c832c2914a$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * const result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $c319b2c832c2914a$var$merge(...objs) {
    const { caseless: caseless, skipUndefined: skipUndefined } = $c319b2c832c2914a$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        // Skip dangerous property names to prevent prototype pollution
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        // findKey lowercases the key, so caseless lookup only applies to strings —
        // symbol keys are identity-matched.
        const targetKey = caseless && typeof key === 'string' && $c319b2c832c2914a$var$findKey(result, key) || key;
        // Read via own-prop only — a bare `result[targetKey]` walks the prototype
        // chain, so a polluted Object.prototype value could surface here and get
        // copied into the merged result.
        const existing = $c319b2c832c2914a$var$hasOwnProperty(result, targetKey) ? result[targetKey] : undefined;
        if ($c319b2c832c2914a$var$isPlainObject(existing) && $c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge(existing, val);
        else if ($c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge({}, val);
        else if ($c319b2c832c2914a$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$c319b2c832c2914a$var$isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = objs.length; i < l; i++){
        const source = objs[i];
        if (!source || $c319b2c832c2914a$var$isBuffer(source)) continue;
        $c319b2c832c2914a$var$forEach(source, assignValue);
        if (typeof source !== 'object' || $c319b2c832c2914a$var$isArray(source)) continue;
        const symbols = Object.getOwnPropertySymbols(source);
        for(let j = 0; j < symbols.length; j++){
            const symbol = symbols[j];
            if ($c319b2c832c2914a$var$propertyIsEnumerable.call(source, symbol)) assignValue(source[symbol], symbol);
        }
    }
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $c319b2c832c2914a$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $c319b2c832c2914a$var$forEach(b, (val, key)=>{
        if (thisArg && $c319b2c832c2914a$var$isFunction(val)) Object.defineProperty(a, key, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot
            // hijack defineProperty's accessor-vs-data resolution.
            __proto__: null,
            value: (0, $e5cb5cefd6507f7e$export$2e2bcd8739ae039)(val, thisArg),
            writable: true,
            enumerable: true,
            configurable: true
        });
        else Object.defineProperty(a, key, {
            __proto__: null,
            value: val,
            writable: true,
            enumerable: true,
            configurable: true
        });
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $c319b2c832c2914a$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xfeff) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    Object.defineProperty(constructor.prototype, 'constructor', {
        __proto__: null,
        value: constructor,
        writable: true,
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(constructor, 'super', {
        __proto__: null,
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $c319b2c832c2914a$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $c319b2c832c2914a$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $c319b2c832c2914a$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $c319b2c832c2914a$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($c319b2c832c2914a$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$c319b2c832c2914a$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $c319b2c832c2914a$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $c319b2c832c2914a$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$c319b2c832c2914a$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $c319b2c832c2914a$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $c319b2c832c2914a$var$isHTMLForm = $c319b2c832c2914a$var$kindOfTest('HTMLFormElement');
const $c319b2c832c2914a$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
const { propertyIsEnumerable: $c319b2c832c2914a$var$propertyIsEnumerable } = Object.prototype;
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $c319b2c832c2914a$var$isRegExp = $c319b2c832c2914a$var$kindOfTest('RegExp');
const $c319b2c832c2914a$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $c319b2c832c2914a$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $c319b2c832c2914a$var$freezeMethods = (obj)=>{
    $c319b2c832c2914a$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($c319b2c832c2914a$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].includes(name)) return false;
        const value = obj[name];
        if (!$c319b2c832c2914a$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
/**
 * Converts an array or a delimited string into an object set with values as keys and true as values.
 * Useful for fast membership checks.
 *
 * @param {Array|string} arrayOrString - The array or string to convert.
 * @param {string} delimiter - The delimiter to use if input is a string.
 * @returns {Object} An object with keys from the array or string, values set to true.
 */ const $c319b2c832c2914a$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $c319b2c832c2914a$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $c319b2c832c2914a$var$noop = ()=>{};
const $c319b2c832c2914a$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $c319b2c832c2914a$var$isSpecCompliantForm(thing) {
    return !!(thing && $c319b2c832c2914a$var$isFunction(thing.append) && thing[$c319b2c832c2914a$var$toStringTag] === 'FormData' && thing[$c319b2c832c2914a$var$iterator]);
}
/**
 * Recursively converts an object to a JSON-compatible object, handling circular references and Buffers.
 *
 * @param {Object} obj - The object to convert.
 * @returns {Object} The JSON-compatible object.
 */ const $c319b2c832c2914a$var$toJSONObject = (obj)=>{
    const visited = new WeakSet();
    const visit = (source)=>{
        if ($c319b2c832c2914a$var$isObject(source)) {
            if (visited.has(source)) return;
            //Buffer check
            if ($c319b2c832c2914a$var$isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                // add-on descent / delete-on-ascent: preserves path semantics, so DAG nodes serialise at every occurrence (see #7230).
                visited.add(source);
                let target;
                if ($c319b2c832c2914a$var$isSet(source)) {
                    target = [];
                    for (const value of source){
                        const reducedValue = visit(value);
                        !$c319b2c832c2914a$var$isUndefined(reducedValue) && target.push(reducedValue);
                    }
                } else {
                    target = $c319b2c832c2914a$var$isArray(source) ? [] : {};
                    $c319b2c832c2914a$var$forEach(source, (value, key)=>{
                        const reducedValue = visit(value);
                        !$c319b2c832c2914a$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                    });
                }
                visited.delete(source);
                return target;
            }
        }
        return source;
    };
    return visit(obj);
};
/**
 * Determines if a value is an async function.
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is an async function, otherwise false.
 */ const $c319b2c832c2914a$var$isAsyncFn = $c319b2c832c2914a$var$kindOfTest('AsyncFunction');
/**
 * Determines if a value is thenable (has then and catch methods).
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is thenable, otherwise false.
 */ const $c319b2c832c2914a$var$isThenable = (thing)=>thing && ($c319b2c832c2914a$var$isObject(thing) || $c319b2c832c2914a$var$isFunction(thing)) && $c319b2c832c2914a$var$isFunction(thing.then) && $c319b2c832c2914a$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
/**
 * Provides a cross-platform setImmediate implementation.
 * Uses native setImmediate if available, otherwise falls back to postMessage or setTimeout.
 *
 * @param {boolean} setImmediateSupported - Whether setImmediate is supported.
 * @param {boolean} postMessageSupported - Whether postMessage is supported.
 * @returns {Function} A function to schedule a callback asynchronously.
 */ const $c319b2c832c2914a$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $c319b2c832c2914a$var$_global.addEventListener('message', ({ source: source, data: data })=>{
            if (source === $c319b2c832c2914a$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $c319b2c832c2914a$var$_global.postMessage(token, '*');
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $c319b2c832c2914a$var$isFunction($c319b2c832c2914a$var$_global.postMessage));
/**
 * Schedules a microtask or asynchronous callback as soon as possible.
 * Uses queueMicrotask if available, otherwise falls back to process.nextTick or _setImmediate.
 *
 * @type {Function}
 */ const $c319b2c832c2914a$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($c319b2c832c2914a$var$_global) : $c319b2c832c2914a$var$_setImmediate;
// *********************
const $c319b2c832c2914a$var$isIterable = (thing)=>thing != null && $c319b2c832c2914a$var$isFunction(thing[$c319b2c832c2914a$var$iterator]);
/**
 * Determine if a value is iterable via an iterator that is NOT sourced solely
 * from a polluted Object.prototype. Use this instead of `isIterable` whenever
 * the iterable comes from untrusted input (e.g. user-supplied header sources),
 * so `Object.prototype[Symbol.iterator] = ...` cannot turn an ordinary object
 * into an attacker-controlled entries iterator.
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value has a non-polluted iterator
 */ const $c319b2c832c2914a$var$isSafeIterable = (thing)=>thing != null && $c319b2c832c2914a$var$hasOwnInPrototypeChain(thing, $c319b2c832c2914a$var$iterator) && $c319b2c832c2914a$var$isIterable(thing);
var $c319b2c832c2914a$export$2e2bcd8739ae039 = {
    isArray: $c319b2c832c2914a$var$isArray,
    isArrayBuffer: $c319b2c832c2914a$var$isArrayBuffer,
    isBuffer: $c319b2c832c2914a$var$isBuffer,
    isFormData: $c319b2c832c2914a$var$isFormData,
    isArrayBufferView: $c319b2c832c2914a$var$isArrayBufferView,
    isString: $c319b2c832c2914a$var$isString,
    isNumber: $c319b2c832c2914a$var$isNumber,
    isBoolean: $c319b2c832c2914a$var$isBoolean,
    isObject: $c319b2c832c2914a$var$isObject,
    isPlainObject: $c319b2c832c2914a$var$isPlainObject,
    isEmptyObject: $c319b2c832c2914a$var$isEmptyObject,
    isReadableStream: $c319b2c832c2914a$var$isReadableStream,
    isRequest: $c319b2c832c2914a$var$isRequest,
    isResponse: $c319b2c832c2914a$var$isResponse,
    isHeaders: $c319b2c832c2914a$var$isHeaders,
    isUndefined: $c319b2c832c2914a$var$isUndefined,
    isDate: $c319b2c832c2914a$var$isDate,
    isFile: $c319b2c832c2914a$var$isFile,
    isReactNativeBlob: $c319b2c832c2914a$var$isReactNativeBlob,
    isReactNative: $c319b2c832c2914a$var$isReactNative,
    isBlob: $c319b2c832c2914a$var$isBlob,
    isRegExp: $c319b2c832c2914a$var$isRegExp,
    isFunction: $c319b2c832c2914a$var$isFunction,
    isStream: $c319b2c832c2914a$var$isStream,
    isURLSearchParams: $c319b2c832c2914a$var$isURLSearchParams,
    isTypedArray: $c319b2c832c2914a$var$isTypedArray,
    isFileList: $c319b2c832c2914a$var$isFileList,
    forEach: $c319b2c832c2914a$var$forEach,
    merge: $c319b2c832c2914a$var$merge,
    extend: $c319b2c832c2914a$var$extend,
    trim: $c319b2c832c2914a$var$trim,
    stripBOM: $c319b2c832c2914a$var$stripBOM,
    inherits: $c319b2c832c2914a$var$inherits,
    toFlatObject: $c319b2c832c2914a$var$toFlatObject,
    kindOf: $c319b2c832c2914a$var$kindOf,
    kindOfTest: $c319b2c832c2914a$var$kindOfTest,
    endsWith: $c319b2c832c2914a$var$endsWith,
    toArray: $c319b2c832c2914a$var$toArray,
    forEachEntry: $c319b2c832c2914a$var$forEachEntry,
    matchAll: $c319b2c832c2914a$var$matchAll,
    isHTMLForm: $c319b2c832c2914a$var$isHTMLForm,
    hasOwnProperty: $c319b2c832c2914a$var$hasOwnProperty,
    hasOwnProp: $c319b2c832c2914a$var$hasOwnProperty,
    hasOwnInPrototypeChain: $c319b2c832c2914a$var$hasOwnInPrototypeChain,
    getSafeProp: $c319b2c832c2914a$var$getSafeProp,
    toSafeFlatObject: $c319b2c832c2914a$var$toSafeFlatObject,
    reduceDescriptors: $c319b2c832c2914a$var$reduceDescriptors,
    freezeMethods: $c319b2c832c2914a$var$freezeMethods,
    toObjectSet: $c319b2c832c2914a$var$toObjectSet,
    toCamelCase: $c319b2c832c2914a$var$toCamelCase,
    noop: $c319b2c832c2914a$var$noop,
    toFiniteNumber: $c319b2c832c2914a$var$toFiniteNumber,
    findKey: $c319b2c832c2914a$var$findKey,
    global: $c319b2c832c2914a$var$_global,
    isContextDefined: $c319b2c832c2914a$var$isContextDefined,
    isSpecCompliantForm: $c319b2c832c2914a$var$isSpecCompliantForm,
    toJSONObject: $c319b2c832c2914a$var$toJSONObject,
    isAsyncFn: $c319b2c832c2914a$var$isAsyncFn,
    isThenable: $c319b2c832c2914a$var$isThenable,
    setImmediate: $c319b2c832c2914a$var$_setImmediate,
    asap: $c319b2c832c2914a$var$asap,
    isIterable: $c319b2c832c2914a$var$isIterable,
    isSafeIterable: $c319b2c832c2914a$var$isSafeIterable
};









'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $fc026bbf9ee156f1$var$ignoreDuplicateOf = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $fc026bbf9ee156f1$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        const hasKey = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(parsed, key);
        if (!key || hasKey && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp($fc026bbf9ee156f1$var$ignoreDuplicateOf, key)) return;
        if (key === 'set-cookie') {
            if (hasKey) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = hasKey ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};



'use strict';
function $f8f5102fdfcbfec9$var$trimSPorHTAB(str) {
    let start = 0;
    let end = str.length;
    while(start < end){
        const code = str.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = str.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === str.length ? str : str.slice(start, end);
}
// The control-code ranges are intentional: header sanitization strips C0/DEL bytes.
// eslint-disable-next-line no-control-regex
const $f8f5102fdfcbfec9$var$INVALID_UNICODE_HEADER_VALUE_CHARS = new RegExp('[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+', 'g');
// eslint-disable-next-line no-control-regex
const $f8f5102fdfcbfec9$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS = new RegExp('[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+', 'g');
function $f8f5102fdfcbfec9$var$sanitizeValue(value, invalidChars) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value)) return value.map((item)=>$f8f5102fdfcbfec9$var$sanitizeValue(item, invalidChars));
    return $f8f5102fdfcbfec9$var$trimSPorHTAB(String(value).replace(invalidChars, ''));
}
const $f8f5102fdfcbfec9$export$9e344cffce061a22 = (value)=>$f8f5102fdfcbfec9$var$sanitizeValue(value, $f8f5102fdfcbfec9$var$INVALID_UNICODE_HEADER_VALUE_CHARS);
const $f8f5102fdfcbfec9$export$59dd66c2a12d8f62 = (value)=>$f8f5102fdfcbfec9$var$sanitizeValue(value, $f8f5102fdfcbfec9$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS);
function $f8f5102fdfcbfec9$export$c30c72bb7e677d54(headers) {
    const byteStringHeaders = Object.create(null);
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(headers.toJSON(), (value, header)=>{
        byteStringHeaders[header] = $f8f5102fdfcbfec9$export$59dd66c2a12d8f62(value);
    });
    return byteStringHeaders;
}


'use strict';
const $866cce54f6bdfb0c$var$$internals = Symbol('internals');
function $866cce54f6bdfb0c$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $866cce54f6bdfb0c$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) ? value.map($866cce54f6bdfb0c$var$normalizeValue) : (0, $f8f5102fdfcbfec9$export$9e344cffce061a22)(String(value));
}
function $866cce54f6bdfb0c$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $866cce54f6bdfb0c$var$parameterNameRE = /^[!#$%&'*+\-.^_`|~0-9A-Za-z]+$/;
function $866cce54f6bdfb0c$var$trimOWS(value) {
    let start = 0;
    let end = value.length;
    while(start < end){
        const code = value.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = value.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === value.length ? value : value.slice(start, end);
}
function $866cce54f6bdfb0c$var$decodeQuotedString(value) {
    const last = value.length - 1;
    if (last < 1 || value.charCodeAt(0) !== 0x22 || value.charCodeAt(last) !== 0x22) return value;
    let decoded = '';
    for(let i = 1; i < last; i++){
        const code = value.charCodeAt(i);
        if (code === 0x22) return value;
        if (code === 0x5c) {
            i += 1;
            if (i >= last) return value;
        }
        decoded += value[i];
    }
    return decoded;
}
function $866cce54f6bdfb0c$var$parseParameters(value) {
    const parameters = Object.create(null);
    const str = String(value);
    let start = 0;
    let quoted = false;
    let escaped = false;
    function parseParameter(end) {
        const part = $866cce54f6bdfb0c$var$trimOWS(str.slice(start, end));
        const equals = part.indexOf('=');
        if (equals < 1) return;
        const name = $866cce54f6bdfb0c$var$trimOWS(part.slice(0, equals));
        if (!$866cce54f6bdfb0c$var$parameterNameRE.test(name)) return;
        const normalizedName = name.toLowerCase();
        if (normalizedName === '__proto__' || normalizedName === 'constructor' || normalizedName === 'prototype') return;
        const parameterValue = $866cce54f6bdfb0c$var$trimOWS(part.slice(equals + 1));
        parameters[normalizedName] = $866cce54f6bdfb0c$var$decodeQuotedString(parameterValue);
    }
    for(let i = 0; i < str.length; i++){
        const code = str.charCodeAt(i);
        if (quoted) {
            if (escaped) escaped = false;
            else if (code === 0x5c) escaped = true;
            else if (code === 0x22) quoted = false;
        } else if (code === 0x22) quoted = true;
        else if (code === 0x2c || code === 0x3b) {
            parseParameter(i);
            start = i + 1;
        }
    }
    parseParameter(str.length);
    return parameters;
}
const $866cce54f6bdfb0c$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $866cce54f6bdfb0c$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $866cce54f6bdfb0c$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $866cce54f6bdfb0c$var$buildAccessors(obj, header) {
    const accessorName = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $866cce54f6bdfb0c$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!lHeader) return;
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $866cce54f6bdfb0c$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$866cce54f6bdfb0c$var$isValidHeaderName(header)) setHeaders((0, $fc026bbf9ee156f1$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(header) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isSafeIterable(header)) {
            let obj = Object.create(null), dest, key;
            for (const entry of header){
                if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(entry)) throw new TypeError('Object iterator must return a key-value pair');
                key = entry[0];
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(obj, key)) {
                    dest = obj[key];
                    obj[key] = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(dest) ? [
                        ...dest,
                        entry[1]
                    ] : [
                        dest,
                        entry[1]
                    ];
                } else obj[key] = entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $866cce54f6bdfb0c$var$parseTokens(value);
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $866cce54f6bdfb0c$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $866cce54f6bdfb0c$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $866cce54f6bdfb0c$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        const value = this.get('set-cookie');
        return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) ? value : value == null || value === false ? [] : [
            value
        ];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static parseParameters(value) {
        return $866cce54f6bdfb0c$var$parseParameters(value);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$866cce54f6bdfb0c$var$$internals] = this[$866cce54f6bdfb0c$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $866cce54f6bdfb0c$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$866cce54f6bdfb0c$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).reduceDescriptors($866cce54f6bdfb0c$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).freezeMethods($866cce54f6bdfb0c$var$AxiosHeaders);
var $866cce54f6bdfb0c$export$2e2bcd8739ae039 = $866cce54f6bdfb0c$var$AxiosHeaders;


'use strict';
const $4e2395edb77acf3a$export$6acd2efa8ac62a1b = '[REDACTED ****]';
function $4e2395edb77acf3a$var$hasOwnOrPrototypeToJSON(source) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(source, 'toJSON')) return true;
    let prototype = Object.getPrototypeOf(source);
    while(prototype && prototype !== Object.prototype){
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(prototype, 'toJSON')) return true;
        prototype = Object.getPrototypeOf(prototype);
    }
    return false;
}
// Build a plain-object snapshot of `config` and replace the value of any key
// (case-insensitive) listed in `redactKeys` with REDACTED. Walks through arrays
// and AxiosHeaders, and short-circuits on circular references.
function $4e2395edb77acf3a$var$redactConfig(config, redactKeys) {
    const lowerKeys = new Set(redactKeys.map((k)=>String(k).toLowerCase()));
    const seen = [];
    const visit = (source)=>{
        if (source === null || typeof source !== 'object') return source;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBuffer(source)) return source;
        if (seen.indexOf(source) !== -1) return undefined;
        if (source instanceof (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039)) source = source.toJSON();
        seen.push(source);
        let result;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(source)) {
            result = [];
            source.forEach((v, i)=>{
                const reducedValue = visit(v);
                if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(reducedValue)) result[i] = reducedValue;
            });
        } else {
            if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(source) && $4e2395edb77acf3a$var$hasOwnOrPrototypeToJSON(source)) {
                seen.pop();
                return source;
            }
            result = Object.create(null);
            for (const [key, value] of Object.entries(source)){
                const reducedValue = lowerKeys.has(key.toLowerCase()) ? $4e2395edb77acf3a$export$6acd2efa8ac62a1b : visit(value);
                if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(reducedValue)) result[key] = reducedValue;
            }
        }
        seen.pop();
        return result;
    };
    return visit(config);
}
function $4e2395edb77acf3a$var$stringifySafely(value) {
    try {
        return String(value);
    } catch (err) {
        return '';
    }
}
function $4e2395edb77acf3a$var$aggregateErrorMessage(error) {
    const message = error.errors.map((entry)=>{
        try {
            return entry && entry.message ? $4e2395edb77acf3a$var$stringifySafely(entry.message) : $4e2395edb77acf3a$var$stringifySafely(entry);
        } catch (err) {
            return '';
        }
    }).filter(Boolean).join('; ');
    return message || error.name || 'AggregateError';
}
class $4e2395edb77acf3a$var$AxiosError extends Error {
    static from(error, code, config, request, response, customProps) {
        // `AggregateError` (thrown by Node on dual-stack/Happy-Eyeballs connection
        // failures) has an empty `message`; its detail lives in `errors[]`. Without
        // this, the wrapped error surfaces with a blank message (see #6721).
        let message = error.message;
        if (!message && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(error.errors) && error.errors.length) message = $4e2395edb77acf3a$var$aggregateErrorMessage(error);
        const axiosError = new $4e2395edb77acf3a$var$AxiosError(message, code || error.code, config, request, response);
        // Match native `Error` `cause` semantics: non-enumerable. The wrapped
        // error often carries circular internals (sockets, requests, agents), so
        // an enumerable `cause` makes structured loggers (pino/winston) and any
        // own-property walk throw "Converting circular structure to JSON".
        // Regression from #6982; see #7205. `__proto__: null` mirrors the
        // `message` descriptor below (prototype-pollution-safe descriptor).
        Object.defineProperty(axiosError, 'cause', {
            __proto__: null,
            value: error,
            writable: true,
            enumerable: false,
            configurable: true
        });
        axiosError.name = error.name;
        // Preserve status from the original error if not already set from response
        if (error.status != null && axiosError.status == null) axiosError.status = error.status;
        customProps && Object.assign(axiosError, customProps);
        return axiosError;
    }
    /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */ constructor(message, code, config, request, response){
        super(message);
        // Make message enumerable to maintain backward compatibility
        // The native Error constructor sets message as non-enumerable,
        // but axios < v1.13.3 had it as enumerable
        Object.defineProperty(this, 'message', {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: message,
            enumerable: true,
            writable: true,
            configurable: true
        });
        this.name = 'AxiosError';
        this.isAxiosError = true;
        code && (this.code = code);
        config && (this.config = config);
        request && (this.request = request);
        if (response) {
            this.response = response;
            this.status = response.status;
        }
    }
    toJSON() {
        // Opt-in redaction: when the request config carries a `redact` array, the
        // value of any matching key (case-insensitive, at any depth) is replaced
        // with REDACTED in the serialized snapshot. Undefined or empty leaves the
        // existing serialization behavior unchanged.
        const config = this.config;
        const redactKeys = config && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config, 'redact') ? config.redact : undefined;
        const serializedConfig = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(redactKeys) && redactKeys.length > 0 ? $4e2395edb77acf3a$var$redactConfig(config, redactKeys) : (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toJSONObject(config);
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: serializedConfig,
            code: this.code,
            status: this.status
        };
    }
}
// This can be changed to static properties as soon as the parser options in .eslint.cjs are updated.
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_OPTION_VALUE = 'ERR_BAD_OPTION_VALUE';
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_OPTION = 'ERR_BAD_OPTION';
$4e2395edb77acf3a$var$AxiosError.ECONNABORTED = 'ECONNABORTED';
$4e2395edb77acf3a$var$AxiosError.ETIMEDOUT = 'ETIMEDOUT';
$4e2395edb77acf3a$var$AxiosError.ECONNREFUSED = 'ECONNREFUSED';
$4e2395edb77acf3a$var$AxiosError.ERR_NETWORK = 'ERR_NETWORK';
$4e2395edb77acf3a$var$AxiosError.ERR_FR_TOO_MANY_REDIRECTS = 'ERR_FR_TOO_MANY_REDIRECTS';
$4e2395edb77acf3a$var$AxiosError.ERR_DEPRECATED = 'ERR_DEPRECATED';
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_RESPONSE = 'ERR_BAD_RESPONSE';
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_REQUEST = 'ERR_BAD_REQUEST';
$4e2395edb77acf3a$var$AxiosError.ERR_CANCELED = 'ERR_CANCELED';
$4e2395edb77acf3a$var$AxiosError.ERR_NOT_SUPPORT = 'ERR_NOT_SUPPORT';
$4e2395edb77acf3a$var$AxiosError.ERR_INVALID_URL = 'ERR_INVALID_URL';
$4e2395edb77acf3a$var$AxiosError.ERR_FORM_DATA_DEPTH_EXCEEDED = 'ERR_FORM_DATA_DEPTH_EXCEEDED';
var $4e2395edb77acf3a$export$2e2bcd8739ae039 = $4e2395edb77acf3a$var$AxiosError;


// eslint-disable-next-line strict
var $4023ac50ad132196$export$2e2bcd8739ae039 = null;



'use strict';
const $e6cbd383b18c9625$export$659081b45d03227d = 100;
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isVisitable(thing) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $e6cbd383b18c9625$var$removeBrackets(key) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $e6cbd383b18c9625$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $e6cbd383b18c9625$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isFlatArray(arr) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(arr) && !arr.some($e6cbd383b18c9625$var$isVisitable);
}
const $e6cbd383b18c9625$var$predicates = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject((0, $c319b2c832c2914a$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $e6cbd383b18c9625$var$toFormData(obj, formData, options) {
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $4023ac50ad132196$export$2e2bcd8739ae039) || FormData)();
    const option = (name, fallback)=>{
        const value = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).getSafeProp(options, name);
        return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(value) ? fallback : value;
    };
    const metaTokens = option('metaTokens', true);
    // eslint-disable-next-line no-use-before-define
    const visitor = option('visitor') || defaultVisitor;
    const dots = option('dots', false);
    const indexes = option('indexes', false);
    const _Blob = option('Blob') || typeof Blob !== 'undefined' && Blob;
    const maxDepth = option('maxDepth', $e6cbd383b18c9625$export$659081b45d03227d);
    const useBlob = _Blob && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    const stack = [];
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.');
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isTypedArray(value)) {
            if (useBlob && typeof _Blob === 'function') return new _Blob([
                value
            ]);
            if ((0, $4023ac50ad132196$export$2e2bcd8739ae039) && (0, $4023ac50ad132196$export$2e2bcd8739ae039).isBufferAvailable()) return (0, $4023ac50ad132196$export$2e2bcd8739ae039).from(value);
            throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NOT_SUPPORT);
        }
        return value;
    }
    function throwIfMaxDepthExceeded(depth) {
        if (depth > maxDepth) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Object is too deeply nested (' + depth + ' levels). Max depth: ' + maxDepth, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_FORM_DATA_DEPTH_EXCEEDED);
    }
    function stringifyWithDepthLimit(value, depth) {
        if (maxDepth === Infinity) return JSON.stringify(value);
        const ancestors = [];
        return JSON.stringify(value, function limitDepth(_key, currentValue) {
            if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(currentValue)) return currentValue;
            while(ancestors.length && ancestors[ancestors.length - 1] !== this)ancestors.pop();
            ancestors.push(currentValue);
            throwIfMaxDepthExceeded(depth + ancestors.length - 1);
            return currentValue;
        });
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReactNative(formData) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReactNativeBlob(value)) {
            formData.append($e6cbd383b18c9625$var$renderKey(path, key, dots), convertValue(value));
            return false;
        }
        if (value && !path && typeof value === 'object') {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = stringifyWithDepthLimit(value, 1);
            } else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) && $e6cbd383b18c9625$var$isFlatArray(value) || ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFileList(value) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, '[]')) && (arr = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $e6cbd383b18c9625$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $e6cbd383b18c9625$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($e6cbd383b18c9625$var$isVisitable(value)) return true;
        formData.append($e6cbd383b18c9625$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const exposedHelpers = Object.assign($e6cbd383b18c9625$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $e6cbd383b18c9625$var$isVisitable
    });
    function build(value, path, depth = 0) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(value)) return;
        throwIfMaxDepthExceeded(depth);
        if (stack.indexOf(value) !== -1) throw new Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ], depth + 1);
        });
        stack.pop();
    }
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $e6cbd383b18c9625$export$2e2bcd8739ae039 = $e6cbd383b18c9625$var$toFormData;


'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $f66f8c7b4f247caf$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $f66f8c7b4f247caf$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(params, this, options);
}
const $f66f8c7b4f247caf$var$prototype = $f66f8c7b4f247caf$var$AxiosURLSearchParams.prototype;
$f66f8c7b4f247caf$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$f66f8c7b4f247caf$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? (value)=>encoder.call(this, value, $f66f8c7b4f247caf$var$encode) : $f66f8c7b4f247caf$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $f66f8c7b4f247caf$export$2e2bcd8739ae039 = $f66f8c7b4f247caf$var$AxiosURLSearchParams;


'use strict';
function $8df8fedf1c1e4428$export$c564cdbbe6da493(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function $8df8fedf1c1e4428$export$2e2bcd8739ae039(url, params, options) {
    if (!params) return url;
    url = url || '';
    const _options = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(options) ? {
        serialize: options
    } : options;
    // Read serializer options pollution-safely: own properties and methods on a
    // class/template prototype are honored, but values injected onto a polluted
    // Object.prototype are ignored.
    const _encode = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).getSafeProp(_options, 'encode') || $8df8fedf1c1e4428$export$c564cdbbe6da493;
    const serializeFn = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).getSafeProp(_options, 'serialize');
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, _options);
    else serializedParams = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $f66f8c7b4f247caf$export$2e2bcd8739ae039)(params, _options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}



'use strict';
const $5de878cd737ef277$var$$internals = Symbol('internals');
// `handlers` is public and may be replaced with a nullish value by user code;
// `clear()` has always tolerated that. Treat it as an empty stack rather than
// dereferencing it.
function $5de878cd737ef277$var$countHandlers(handlers) {
    return handlers ? handlers.length : 0;
}
function $5de878cd737ef277$var$trimHandlers(handlers) {
    if (!handlers) return;
    while(handlers.length && handlers[handlers.length - 1] === null)handlers.pop();
}
function $5de878cd737ef277$var$syncHandlerEntries(manager, internals) {
    const handlers = manager.handlers;
    const length = $5de878cd737ef277$var$countHandlers(handlers);
    if (handlers !== internals.handlersRef) {
        internals.handlersRef = handlers;
        internals.handlerEntries.clear();
    } else if (length !== internals.handlersLength) {
        if (!length) internals.handlerEntries.clear();
        else internals.handlerEntries.forEach(function removeStaleEntry(entry, id) {
            if (handlers[entry.index] !== entry.handler) internals.handlerEntries.delete(id);
        });
    }
    internals.handlersLength = length;
}
class $5de878cd737ef277$var$InterceptorManager {
    constructor(){
        this.handlers = [];
        this[$5de878cd737ef277$var$$internals] = {
            handlersRef: this.handlers,
            handlersLength: this.handlers.length,
            handlerEntries: new Map(),
            iterationDepth: 0,
            nextId: 0
        };
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        const handler = {
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        };
        const internals = this[$5de878cd737ef277$var$$internals];
        if (this.handlers == null) this.handlers = [];
        $5de878cd737ef277$var$syncHandlerEntries(this, internals);
        const id = internals.nextId++;
        this.handlers.push(handler);
        internals.handlerEntries.set(id, {
            handler: handler,
            index: this.handlers.length - 1
        });
        internals.handlersLength = this.handlers.length;
        return id;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ eject(id) {
        const internals = this[$5de878cd737ef277$var$$internals];
        $5de878cd737ef277$var$syncHandlerEntries(this, internals);
        const entry = internals.handlerEntries.get(id);
        if (entry) {
            internals.handlerEntries.delete(id);
            // Ignore IDs invalidated by clear or direct replacement of handlers.
            if (this.handlers[entry.index] !== entry.handler) return;
            this.handlers[entry.index] = null;
            // Do not reuse an index while forEach is walking its length snapshot.
            if (!internals.iterationDepth) {
                $5de878cd737ef277$var$trimHandlers(this.handlers);
                internals.handlersLength = this.handlers.length;
            }
        }
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) {
            this.handlers = [];
            $5de878cd737ef277$var$syncHandlerEntries(this, this[$5de878cd737ef277$var$$internals]);
        }
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        const internals = this[$5de878cd737ef277$var$$internals];
        $5de878cd737ef277$var$syncHandlerEntries(this, internals);
        internals.iterationDepth++;
        try {
            (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
                if (h !== null) fn(h);
            });
        } finally{
            if (!--internals.iterationDepth) {
                $5de878cd737ef277$var$syncHandlerEntries(this, internals);
                $5de878cd737ef277$var$trimHandlers(this.handlers);
                internals.handlersLength = $5de878cd737ef277$var$countHandlers(this.handlers);
            }
        }
    }
}
var $5de878cd737ef277$export$2e2bcd8739ae039 = $5de878cd737ef277$var$InterceptorManager;





'use strict';
var $51466d41a76e5b4b$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false,
    legacyInterceptorReqResOrdering: true,
    advertiseZstdAcceptEncoding: false,
    validateStatusUndefinedResolves: true
};






'use strict';
var $6eeff4490c995137$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $f66f8c7b4f247caf$export$2e2bcd8739ae039);


'use strict';
var $86d275a264afb13f$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;


'use strict';
var $59c79e94740631e4$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;


var $2f71637df772b183$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $6eeff4490c995137$export$2e2bcd8739ae039,
        FormData: $86d275a264afb13f$export$2e2bcd8739ae039,
        Blob: $59c79e94740631e4$export$2e2bcd8739ae039
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};


var $565e85ead8bde60a$exports = {};

$parcel$export($565e85ead8bde60a$exports, "hasBrowserEnv", () => $565e85ead8bde60a$export$c4996c4b7b93b0bf);
$parcel$export($565e85ead8bde60a$exports, "navigator", () => $565e85ead8bde60a$export$ec7c8efa7f5790ae);
$parcel$export($565e85ead8bde60a$exports, "hasStandardBrowserEnv", () => $565e85ead8bde60a$export$c0bcc9250309d66);
$parcel$export($565e85ead8bde60a$exports, "hasStandardBrowserWebWorkerEnv", () => $565e85ead8bde60a$export$c81692cf5af97dac);
$parcel$export($565e85ead8bde60a$exports, "origin", () => $565e85ead8bde60a$export$f710a83a91838a36);
const $565e85ead8bde60a$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $565e85ead8bde60a$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $565e85ead8bde60a$export$c0bcc9250309d66 = $565e85ead8bde60a$export$c4996c4b7b93b0bf && (!$565e85ead8bde60a$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($565e85ead8bde60a$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $565e85ead8bde60a$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $565e85ead8bde60a$export$f710a83a91838a36 = $565e85ead8bde60a$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';


var $bb8180acb278e187$export$2e2bcd8739ae039 = {
    ...$565e85ead8bde60a$exports,
    ...(0, $2f71637df772b183$export$2e2bcd8739ae039)
};


'use strict';
function $f6f250f62cadb740$export$2e2bcd8739ae039(data, options) {
    return (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(data, new (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.URLSearchParams(), {
        visitor: function(value, key, path, helpers) {
            if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).isNode && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        },
        ...options
    });
}






'use strict';
const $5f8142930b3b943f$var$MAX_DEPTH = (0, $e6cbd383b18c9625$export$659081b45d03227d);
function $5f8142930b3b943f$var$throwIfDepthExceeded(index) {
    if (index > $5f8142930b3b943f$var$MAX_DEPTH) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('FormData field is too deeply nested (' + index + ' levels). Max depth: ' + $5f8142930b3b943f$var$MAX_DEPTH, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_FORM_DATA_DEPTH_EXCEEDED);
}
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $5f8142930b3b943f$var$parsePropPath(name) {
    // foo[x][y][z] -> ['foo', 'x', 'y', 'z']
    // foo.x.y.z    -> ['foo', 'x', 'y', 'z']
    // A path is split on `.` and on `[...]` groups. A segment — whether written
    // in dot notation or captured inside brackets — may contain any character
    // except `.`, `[` and `]`, so a key like `user-name` or `user name` is kept
    // literal instead of being split (#5402). `.`, `[` and `]` keep their existing
    // meaning, e.g. `foo[bar.baz]` -> ['foo', 'bar', 'baz'] and `[]` is an array push.
    // Excluding `[` from the bracket group also makes the match fail fast at the
    // next `[`, so a malformed name cannot rescan to the end of the string from
    // every unmatched `[` — parsing stays linear in the length of the name.
    const path = [];
    const pattern = /[^.[\]]+|\[([^.[\]]*)]/g;
    let match;
    while((match = pattern.exec(name)) !== null){
        $5f8142930b3b943f$var$throwIfDepthExceeded(path.length);
        path.push(match[0] === '[]' ? '' : match[1] || match[0]);
    }
    return path;
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $5f8142930b3b943f$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $5f8142930b3b943f$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        $5f8142930b3b943f$var$throwIfDepthExceeded(index);
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(target[name]) ? target[name].concat(value) : [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(target, name) || !(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $5f8142930b3b943f$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(formData) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($5f8142930b3b943f$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $5f8142930b3b943f$export$2e2bcd8739ae039 = $5f8142930b3b943f$var$formDataToJSON;


'use strict';
const $2fec45dc063f0c4b$var$methodList = Object.freeze([
    'get',
    'delete',
    'head',
    'options',
    'post',
    'put',
    'patch',
    'purge',
    'link',
    'unlink',
    'query'
]);
var $2fec45dc063f0c4b$export$2e2bcd8739ae039 = $2fec45dc063f0c4b$var$methodList;


'use strict';
const $843bf0209bc94df8$var$own = (obj, key)=>obj != null && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(obj, key) ? obj[key] : undefined;
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $843bf0209bc94df8$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $843bf0209bc94df8$var$defaults = {
    transitional: (0, $51466d41a76e5b4b$export$2e2bcd8739ae039),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $5f8142930b3b943f$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBuffer(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isStream(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFile(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                const formSerializer = $843bf0209bc94df8$var$own(this, 'formSerializer');
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $f6f250f62cadb740$export$2e2bcd8739ae039)(data, formSerializer).toString();
                if ((isFileList = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const env = $843bf0209bc94df8$var$own(this, 'env');
                    const _FormData = env && env.FormData;
                    return (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $843bf0209bc94df8$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = $843bf0209bc94df8$var$own(this, 'transitional') || $843bf0209bc94df8$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const responseType = $843bf0209bc94df8$var$own(this, 'responseType');
            const JSONRequested = responseType === 'json';
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isResponse(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, $843bf0209bc94df8$var$own(this, 'parseReviver'));
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).from(e, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, $843bf0209bc94df8$var$own(this, 'response'));
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach((0, $2fec45dc063f0c4b$export$2e2bcd8739ae039), (method)=>{
    $843bf0209bc94df8$var$defaults.headers[method] = {};
});
var $843bf0209bc94df8$export$2e2bcd8739ae039 = $843bf0209bc94df8$var$defaults;



'use strict';
function $5cf10c777cce5f4f$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $843bf0209bc94df8$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


'use strict';
function $5a60afef8b0dd173$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}




'use strict';
class $9fd0919e266b4fda$var$CanceledError extends (0, $4e2395edb77acf3a$export$2e2bcd8739ae039) {
    /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */ constructor(message, config, request){
        super(message == null ? 'canceled' : message, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
        this.name = 'CanceledError';
        this.__CANCEL__ = true;
    }
}
var $9fd0919e266b4fda$export$2e2bcd8739ae039 = $9fd0919e266b4fda$var$CanceledError;







'use strict';
function $ecb62d5372993dcf$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Request failed with status code ' + response.status, response.status >= 400 && response.status < 500 ? (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_REQUEST : (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, response.config, response.request, response));
}





'use strict';
const $503871fd6eafbe9c$var$urlParserControlCharacters = /[\t\n\r]/g;
function $503871fd6eafbe9c$export$2e2bcd8739ae039(url) {
    if (typeof url !== 'string') return url;
    let start = 0;
    while(start < url.length && url.charCodeAt(start) <= 0x20)start++;
    return url.slice(start).replace($503871fd6eafbe9c$var$urlParserControlCharacters, '');
}


'use strict';
function $23607f53e4fda918$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25}):(?:\/\/)?/.exec(url);
    return match && match[1] || '';
}




'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $4a9d49cd0e6b8acc$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $4a9d49cd0e6b8acc$export$2e2bcd8739ae039 = $4a9d49cd0e6b8acc$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Array<Function>}
 */ function $9b3ced92bc7bdc99$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    const flushWith = (...args)=>invoke(args);
    return [
        throttled,
        flush,
        flushWith
    ];
}
var $9b3ced92bc7bdc99$export$2e2bcd8739ae039 = $9b3ced92bc7bdc99$var$throttle;



const $1a6c80b567b74091$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $4a9d49cd0e6b8acc$export$2e2bcd8739ae039)(50, 250);
    return (0, $9b3ced92bc7bdc99$export$2e2bcd8739ae039)((e)=>{
        if (!e || !(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isNumber(e.loaded)) return;
        const rawLoaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const loaded = Math.max(0, total != null ? Math.min(rawLoaded, total) : rawLoaded);
        const progressBytes = Math.max(0, loaded - bytesNotified);
        const rate = _speedometer(progressBytes);
        bytesNotified = Math.max(bytesNotified, loaded);
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $1a6c80b567b74091$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $1a6c80b567b74091$export$5d35863c355a22a9 = (fn, scheduler = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).asap)=>(...args)=>scheduler(()=>fn(...args));






var $5eb63b558e1fb85a$export$2e2bcd8739ae039 = (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $bb8180acb278e187$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $bb8180acb278e187$export$2e2bcd8739ae039).origin), (0, $bb8180acb278e187$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $bb8180acb278e187$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $65cc14c0704b5541$export$2e2bcd8739ae039 = (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv ? {
    write (name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === 'undefined') return;
        const cookie = [
            `${name}=${encodeURIComponent(value)}`
        ];
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isNumber(expires)) cookie.push(`expires=${new Date(expires).toUTCString()}`);
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(path)) cookie.push(`path=${path}`);
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(domain)) cookie.push(`domain=${domain}`);
        if (secure === true) cookie.push('secure');
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(sameSite)) cookie.push(`SameSite=${sameSite}`);
        document.cookie = cookie.join('; ');
    },
    read (name) {
        if (typeof document === 'undefined') return null;
        // Match name=value by splitting on the semicolon separator instead of building a
        // RegExp from `name` — interpolating an unescaped string into a RegExp would let
        // metacharacters (e.g. `.+?` in an attacker-influenced cookie name) cause ReDoS or
        // match the wrong cookie. Browsers may serialize cookie pairs as either ";" or
        // "; ", so ignore optional whitespace before each cookie name.
        const cookies = document.cookie.split(';');
        for(let i = 0; i < cookies.length; i++){
            const cookie = cookies[i].replace(/^\s+/, '');
            const eq = cookie.indexOf('=');
            if (eq !== -1 && cookie.slice(0, eq) === name) try {
                return decodeURIComponent(cookie.slice(eq + 1));
            } catch (e) {
                return cookie.slice(eq + 1);
            }
        }
        return null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000, '/');
    }
} : {
    write () {},
    read () {
        return null;
    },
    remove () {}
};



'use strict';
function $8fa91c1a59edb5d9$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    if (typeof url !== 'string') return false;
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


'use strict';
function $b63e12c1e0b9e0be$export$2e2bcd8739ae039(baseURL, relativeURL) {
    if (!relativeURL) return baseURL;
    let end = baseURL.length;
    while(end > 0 && baseURL.charCodeAt(end - 1) === 47)end--;
    return baseURL.slice(0, end) + '/' + relativeURL.replace(/^\/+/, '');
}



'use strict';
const $598acbfafd2c63c5$var$malformedHttpProtocol = /^https?:(?!\/\/)/i;
// Redact the parts of a URL that can carry secrets before it is embedded in an
// error message. AxiosError.toJSON() serializes `message` verbatim and errors
// are commonly logged, while the opt-in `config.redact` model only cleans
// config keys — it cannot reach the message. Redact only the genuinely
// sensitive substrings — userinfo (credentials), query parameter values and
// fragment contents — with the same REDACTED marker the config redaction uses,
// while keeping the scheme, host, path and parameter names so the offending
// request stays accurately identifiable.
function $598acbfafd2c63c5$var$redactFragment(fragment) {
    if (!fragment) return fragment;
    return fragment.replace(/(^|&)([^=&]*=)?[^&]+/g, (match, separator, parameterName = '')=>{
        return `${separator}${parameterName}${0, $4e2395edb77acf3a$export$6acd2efa8ac62a1b}`;
    });
}
function $598acbfafd2c63c5$var$redactSensitiveURLParts(url) {
    const redactedURL = url.replace(/^(https?:\/{0,2})[^/?#]*@/i, `$1${(0, $4e2395edb77acf3a$export$6acd2efa8ac62a1b)}@`);
    const fragmentIndex = redactedURL.indexOf('#');
    const urlWithoutFragment = fragmentIndex === -1 ? redactedURL : redactedURL.slice(0, fragmentIndex);
    const redactedURLWithoutFragment = urlWithoutFragment.replace(/([?&][^=&#]*=)[^&#]*/g, `$1${(0, $4e2395edb77acf3a$export$6acd2efa8ac62a1b)}`);
    if (fragmentIndex === -1) return redactedURLWithoutFragment;
    return `${redactedURLWithoutFragment}#${$598acbfafd2c63c5$var$redactFragment(redactedURL.slice(fragmentIndex + 1))}`;
}
function $598acbfafd2c63c5$var$assertValidHttpProtocolURL(url, config) {
    if (typeof url === 'string') {
        const normalizedURL = (0, $503871fd6eafbe9c$export$2e2bcd8739ae039)(url);
        if ($598acbfafd2c63c5$var$malformedHttpProtocol.test(normalizedURL)) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`Invalid URL ${JSON.stringify($598acbfafd2c63c5$var$redactSensitiveURLParts(normalizedURL))}: missing "//" after protocol`, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_INVALID_URL, config);
    }
}
function $598acbfafd2c63c5$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls, config) {
    $598acbfafd2c63c5$var$assertValidHttpProtocolURL(requestedURL, config);
    let isRelativeUrl = !(0, $8fa91c1a59edb5d9$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls === false)) {
        $598acbfafd2c63c5$var$assertValidHttpProtocolURL(baseURL, config);
        return (0, $b63e12c1e0b9e0be$export$2e2bcd8739ae039)(baseURL, requestedURL);
    }
    return requestedURL;
}




'use strict';
const $f85fda54cd977b19$var$headersToObject = (thing)=>thing instanceof (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
const $f85fda54cd977b19$var$ownEnumerableKeys = (thing)=>{
    if (Object.getOwnPropertySymbols && Object.getOwnPropertyDescriptor) return Object.keys(thing).concat(Object.getOwnPropertySymbols(thing).filter((symbol)=>Object.getOwnPropertyDescriptor(thing, symbol).enumerable));
    return Object.keys(thing);
};
function $f85fda54cd977b19$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config1 = config1 || {};
    config2 = config2 || {};
    // Use a null-prototype object so that downstream reads such as `config.auth`
    // or `config.baseURL` cannot inherit polluted values from Object.prototype.
    // `hasOwnProperty` is restored as a non-enumerable own slot to preserve
    // ergonomics for user code that relies on it.
    const config = Object.create(null);
    Object.defineProperty(config, 'hasOwnProperty', {
        // Null-proto descriptor so a polluted Object.prototype.get cannot turn
        // this data descriptor into an accessor descriptor on the way in.
        __proto__: null,
        value: Object.prototype.hasOwnProperty,
        enumerable: false,
        writable: true,
        configurable: true
    });
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(target) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    function getMergedTransitionalOption(prop) {
        const transitional2 = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config2, 'transitional') ? config2.transitional : undefined;
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(transitional2)) {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(transitional2)) {
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(transitional2, prop)) return transitional2[prop];
            } else return undefined;
        }
        const transitional1 = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config1, 'transitional') ? config1.transitional : undefined;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(transitional1) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(transitional1, prop)) return transitional1[prop];
        return undefined;
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config2, prop)) return getMergedValue(a, b);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config1, prop)) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutErrorMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        allowedSocketPaths: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($f85fda54cd977b19$var$headersToObject(a), $f85fda54cd977b19$var$headersToObject(b), prop, true)
    };
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach($f85fda54cd977b19$var$ownEnumerableKeys({
        ...config1,
        ...config2
    }), function computeConfigValue(prop) {
        if (prop === '__proto__' || prop === 'constructor' || prop === 'prototype') return;
        const merge = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
        const a = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config1, prop) ? config1[prop] : undefined;
        const b = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config2, prop) ? config2[prop] : undefined;
        const configValue = merge(a, b, prop);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config2, 'validateStatus') && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(config2.validateStatus) && getMergedTransitionalOption('validateStatusUndefinedResolves') === false) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config1, 'validateStatus')) config.validateStatus = getMergedValue(undefined, config1.validateStatus);
        else delete config.validateStatus;
    }
    return config;
}



'use strict';
const $ff840e6c220d182f$var$FORM_DATA_CONTENT_HEADERS = [
    'content-type',
    'content-length'
];
function $ff840e6c220d182f$export$2e2bcd8739ae039(headers, formHeaders, policy) {
    if (policy !== 'content-only') {
        headers.set(formHeaders);
        return;
    }
    Object.entries(formHeaders || {}).forEach(([key, val])=>{
        if ($ff840e6c220d182f$var$FORM_DATA_CONTENT_HEADERS.includes(key.toLowerCase())) headers.set(key, val);
    });
}



/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $ab4625fac3104691$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
function $ab4625fac3104691$var$resolveConfig(config) {
    const newConfig = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)({}, config);
    // Read only own properties to prevent prototype pollution gadgets
    // (e.g. Object.prototype.baseURL = 'https://evil.com').
    const own = (key)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(newConfig, key) ? newConfig[key] : undefined;
    const data = own('data');
    let withXSRFToken = own('withXSRFToken');
    const xsrfHeaderName = own('xsrfHeaderName');
    const xsrfCookieName = own('xsrfCookieName');
    let headers = own('headers');
    const auth = own('auth');
    const baseURL = own('baseURL');
    const allowAbsoluteUrls = own('allowAbsoluteUrls');
    const url = own('url');
    newConfig.headers = headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $8df8fedf1c1e4428$export$2e2bcd8739ae039)((0, $598acbfafd2c63c5$export$2e2bcd8739ae039)(baseURL, url, allowAbsoluteUrls, newConfig), own('params'), own('paramsSerializer'));
    // HTTP basic authentication
    if (auth) {
        const username = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).getSafeProp(auth, 'username') || '';
        const password = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).getSafeProp(auth, 'password') || '';
        try {
            headers.set('Authorization', 'Basic ' + btoa(username + ':' + (password ? $ab4625fac3104691$var$encodeUTF8(password) : '')));
        } catch (e) {
            throw (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).from(e, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE, config);
        }
    }
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data)) {
        const getHeaders = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).getSafeProp(data, 'getHeaders');
        if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReactNative(data)) headers.setContentType(undefined); // browser/web worker/RN handles it
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(getHeaders)) // Node.js FormData (like form-data package)
        (0, $ff840e6c220d182f$export$2e2bcd8739ae039)(headers, getHeaders.call(data), own('formDataHeaderPolicy'));
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(withXSRFToken)) withXSRFToken = withXSRFToken(newConfig);
        // Strict boolean check — prevents proto-pollution gadgets (e.g. Object.prototype.withXSRFToken = 1)
        // and misconfigurations (e.g. "false") from short-circuiting the same-origin check and leaking
        // the XSRF token cross-origin.
        const shouldSendXSRF = withXSRFToken === true || withXSRFToken == null && (0, $5eb63b558e1fb85a$export$2e2bcd8739ae039)(newConfig.url);
        if (shouldSendXSRF) {
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $65cc14c0704b5541$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
}
var $ab4625fac3104691$export$2e2bcd8739ae039 = $ab4625fac3104691$var$resolveConfig;



const $79f0a48d5eb7919b$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $79f0a48d5eb7919b$export$2e2bcd8739ae039 = $79f0a48d5eb7919b$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $ab4625fac3104691$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload, flushDownloadWithEvent;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend(event) {
            if (!request) return;
            // Status 0 means no response was received, which onerror and onabort normally
            // reject before this runs. Firefox 152 fires only readystatechange and loadend for
            // navigation-canceled requests (https://bugzilla.mozilla.org/show_bug.cgi?id=1505389),
            // leaving settle() to resolve them as an empty success. ECONNABORTED is the error
            // onabort raised on Firefox 151. Reads over file:, which some environments report as
            // status 0 on success, are excluded by the request URL's scheme after browser-style
            // preprocessing, by the page origin's scheme for relative URLs (which inherit it), or
            // by responseURL where implemented.
            if (request.status === 0 && ((0, $23607f53e4fda918$export$2e2bcd8739ae039)((0, $503871fd6eafbe9c$export$2e2bcd8739ae039)(_config.url)) || (0, $23607f53e4fda918$export$2e2bcd8739ae039)((0, $bb8180acb278e187$export$2e2bcd8739ae039).origin)) !== 'file' && !(request.responseURL && request.responseURL.startsWith('file:'))) {
                reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Request aborted', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ECONNABORTED, config, request));
                done();
                // Clean up request
                request = null;
                return;
            }
            // When loadend is still dispatching, flushing with it gives progress
            // listeners a final delivery whose event has a live target. The legacy
            // ready-state fallback has no event, so replay its pending progress.
            // A throwing listener must not block settlement; rethrow asynchronously,
            // matching how listener errors surface on the throttle timer path.
            try {
                if (event) flushDownloadWithEvent && flushDownloadWithEvent(event);
                else flushDownload && flushDownload();
            } catch (err) {
                setTimeout(()=>{
                    throw err;
                });
            }
            // A final progress callback can cancel the request synchronously.
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $ecb62d5372993dcf$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.startsWith('file:'))) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Request aborted', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : 'Network Error';
            const err = new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(msg, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            done();
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $51466d41a76e5b4b$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ETIMEDOUT : (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach((0, $f8f5102fdfcbfec9$export$c30c72bb7e677d54)(requestHeaders), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload, flushDownloadWithEvent] = (0, $1a6c80b567b74091$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $1a6c80b567b74091$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                done();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $23607f53e4fda918$export$2e2bcd8739ae039)(_config.url);
        if (protocol && !(0, $bb8180acb278e187$export$2e2bcd8739ae039).protocols.includes(protocol)) {
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Unsupported protocol ' + protocol + ':', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            done();
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};








const $a052b9a6636aacdc$var$composeSignals = (signals, timeout)=>{
    signals = signals ? signals.filter(Boolean) : [];
    if (!timeout && !signals.length) return;
    const controller = new AbortController();
    let aborted = false;
    const onabort = function(reason) {
        if (!aborted) {
            aborted = true;
            unsubscribe();
            const err = reason instanceof Error ? reason : this.reason;
            controller.abort(err instanceof (0, $4e2395edb77acf3a$export$2e2bcd8739ae039) ? err : new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
        }
    };
    let timer = timeout && setTimeout(()=>{
        timer = null;
        onabort(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`timeout of ${timeout}ms exceeded`, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ETIMEDOUT));
    }, timeout);
    const unsubscribe = ()=>{
        if (!signals) return;
        timer && clearTimeout(timer);
        timer = null;
        signals.forEach((signal)=>{
            signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
        });
        signals = null;
    };
    signals.forEach((signal)=>{
        if (aborted) return;
        if (signal.aborted) {
            onabort.call(signal);
            return;
        }
        signal.addEventListener('abort', onabort, {
            once: true
        });
    });
    const { signal: signal } = controller;
    signal.unsubscribe = ()=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).asap(unsubscribe);
    return signal;
};
var $a052b9a6636aacdc$export$2e2bcd8739ae039 = $a052b9a6636aacdc$var$composeSignals;


const $c9465135abb26626$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $c9465135abb26626$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $c9465135abb26626$var$readStream(iterable))yield* $c9465135abb26626$export$71b051935044bd5d(chunk, chunkSize);
};
const $c9465135abb26626$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $c9465135abb26626$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $c9465135abb26626$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






/**
 * Estimate data: URL byte lengths *without* allocating large buffers.
 * - Fetch percent-decodes a base64 body before decoding it.
 * - Node's Buffer.from(body, 'base64') sizes its backing allocation from the
 *   raw body, including ignored characters and content after padding.
 * - Non-base64 data is percent-decoded and then encoded as UTF-8.
 */ const $da69a2069c6136ea$var$isHexDigit = (charCode)=>charCode >= 48 && charCode <= 57 || charCode >= 65 && charCode <= 70 || charCode >= 97 && charCode <= 102;
const $da69a2069c6136ea$var$isPercentEncodedByte = (str, i, len)=>i + 2 < len && $da69a2069c6136ea$var$isHexDigit(str.charCodeAt(i + 1)) && $da69a2069c6136ea$var$isHexDigit(str.charCodeAt(i + 2));
const $da69a2069c6136ea$var$hexValue = (charCode)=>charCode <= 57 ? charCode - 48 : (charCode & 0xdf) - 55;
const $da69a2069c6136ea$var$isBase64Char = (charCode)=>charCode >= 65 && charCode <= 90 || // A-Z
    charCode >= 97 && charCode <= 122 || // a-z
    charCode >= 48 && charCode <= 57 || // 0-9
    charCode === 43 || // +
    charCode === 47 || // /
    charCode === 45 || // - (base64url)
    charCode === 95; // _ (base64url)
const $da69a2069c6136ea$var$isBase64Whitespace = (charCode)=>charCode === 9 || charCode === 10 || charCode === 12 || charCode === 13 || charCode === 32;
const $da69a2069c6136ea$var$base64Bytes = (significant)=>{
    const groups = Math.floor(significant / 4);
    const remainder = significant % 4;
    return groups * 3 + (remainder === 2 ? 1 : remainder === 3 ? 2 : 0);
};
// Buffer.byteLength(body, 'base64') uses the raw string length as an allocation
// upper bound even when Buffer.from later ignores characters or stops at '='.
const $da69a2069c6136ea$var$estimateBase64BufferAllocation = (body)=>{
    const len = body.length;
    let padding = 0;
    if (len > 0 && body.charCodeAt(len - 1) === 61 /* '=' */ ) {
        padding++;
        if (len > 1 && body.charCodeAt(len - 2) === 61 /* '=' */ ) padding++;
    }
    return Math.floor((len - padding) * 3 / 4);
};
const $da69a2069c6136ea$var$estimatePercentDecodedBase64Bytes = (body)=>{
    const len = body.length;
    let significant = 0;
    let padding = 0;
    let invalid = false;
    for(let i = 0; i < len; i++){
        let code = body.charCodeAt(i);
        if (code === 37 /* '%' */  && $da69a2069c6136ea$var$isPercentEncodedByte(body, i, len)) {
            code = $da69a2069c6136ea$var$hexValue(body.charCodeAt(i + 1)) * 16 + $da69a2069c6136ea$var$hexValue(body.charCodeAt(i + 2));
            i += 2;
        }
        if ($da69a2069c6136ea$var$isBase64Whitespace(code)) continue;
        if (code === 61 /* '=' */ ) {
            padding++;
            continue;
        }
        if (!$da69a2069c6136ea$var$isBase64Char(code) || padding > 0) {
            invalid = true;
            continue;
        }
        significant++;
    }
    // Fetch rejects malformed forgiving-base64 input. Returning the raw-size
    // allocation bound keeps that invalid input from becoming a pre-check bypass.
    if (invalid || padding > 2 || padding > 0 && (significant + padding) % 4 !== 0 || significant % 4 === 1) return $da69a2069c6136ea$var$estimateBase64BufferAllocation(body);
    return $da69a2069c6136ea$var$base64Bytes(significant);
};
const $da69a2069c6136ea$var$estimateDataURLBytes = (url, estimateBase64)=>{
    if (!url || typeof url !== 'string') return 0;
    if (!url.startsWith('data:')) return 0;
    const comma = url.indexOf(',');
    if (comma < 0) return 0;
    const meta = url.slice(5, comma);
    const body = url.slice(comma + 1);
    const isBase64 = /;base64/i.test(meta);
    if (isBase64) return estimateBase64(body);
    // Compute UTF-8 byte length directly from UTF-16 code units without allocating
    // a byte buffer (TextEncoder.encode would defeat the DoS guard on large bodies).
    // Valid %XX triplets count as one decoded byte; this matches the bytes that
    // decodeURIComponent(body) would produce before Buffer re-encodes the string.
    let bytes = 0;
    for(let i = 0, len = body.length; i < len; i++){
        const c = body.charCodeAt(i);
        if (c === 37 /* '%' */  && $da69a2069c6136ea$var$isPercentEncodedByte(body, i, len)) {
            bytes += 1;
            i += 2;
        } else if (c < 0x80) bytes += 1;
        else if (c < 0x800) bytes += 2;
        else if (c >= 0xd800 && c <= 0xdbff && i + 1 < len) {
            const next = body.charCodeAt(i + 1);
            if (next >= 0xdc00 && next <= 0xdfff) {
                bytes += 4;
                i++;
            } else bytes += 3;
        } else bytes += 3;
    }
    return bytes;
};
function $da69a2069c6136ea$export$2e2bcd8739ae039(url) {
    // Fetch removes URL fragments before processing a data: URL.
    const fragmentIndex = typeof url === 'string' ? url.indexOf('#') : -1;
    return $da69a2069c6136ea$var$estimateDataURLBytes(fragmentIndex === -1 ? url : url.slice(0, fragmentIndex), $da69a2069c6136ea$var$estimatePercentDecodedBase64Bytes);
}
function $da69a2069c6136ea$export$1f39e64b554a246f(url) {
    return $da69a2069c6136ea$var$estimateDataURLBytes(url, $da69a2069c6136ea$var$estimateBase64BufferAllocation);
}


const $23ff3f1a5c7912d5$export$a4ad2735b021c132 = "1.20.0";



const $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE = 65536;
const $e52be20a9fc15e96$var$DEFAULT_REQUEST_OPTIONS = {
    cache: 'default',
    redirect: 'follow',
    referrer: 'about:client',
    referrerPolicy: '',
    mode: 'cors',
    integrity: '',
    keepalive: false,
    priority: 'auto',
    window: null
};
const { isFunction: $e52be20a9fc15e96$var$isFunction } = (0, $c319b2c832c2914a$export$2e2bcd8739ae039);
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $e52be20a9fc15e96$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
// Node's WHATWG URL parser returns `username` and `password` percent-encoded.
// Decode before composing the `auth` option so credentials such as
// `my%40email.com:pass` are sent as `my@email.com:pass`. Falls back to the
// original value for malformed input so a bad encoding never throws.
const $e52be20a9fc15e96$var$decodeURIComponentSafe = (value)=>{
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(value)) return value;
    try {
        return decodeURIComponent(value);
    } catch (error) {
        return value;
    }
};
const $e52be20a9fc15e96$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $e52be20a9fc15e96$var$maybeWithAuthCredentials = (url)=>{
    const protocolIndex = url.indexOf('://');
    let urlToCheck = url;
    if (protocolIndex !== -1) urlToCheck = urlToCheck.slice(protocolIndex + 3);
    return urlToCheck.includes('@') || urlToCheck.includes(':');
};
const $e52be20a9fc15e96$var$factory = (env)=>{
    const globalObject = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).global !== undefined && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).global !== null ? (0, $c319b2c832c2914a$export$2e2bcd8739ae039).global : globalThis;
    const { ReadableStream: ReadableStream, TextEncoder: TextEncoder } = globalObject;
    env = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge.call({
        skipUndefined: true
    }, {
        Request: globalObject.Request,
        Response: globalObject.Response
    }, env);
    const { fetch: envFetch, Request: Request, Response: Response } = env;
    const isFetchSupported = envFetch ? $e52be20a9fc15e96$var$isFunction(envFetch) : typeof fetch === 'function';
    const isRequestSupported = $e52be20a9fc15e96$var$isFunction(Request);
    const isResponseSupported = $e52be20a9fc15e96$var$isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && $e52be20a9fc15e96$var$isFunction(ReadableStream);
    const encodeText = isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && $e52be20a9fc15e96$var$test(()=>{
        let duplexAccessed = false;
        const request = new Request((0, $bb8180acb278e187$export$2e2bcd8739ae039).origin, {
            body: new ReadableStream(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        });
        const hasContentType = request.headers.has('Content-Type');
        if (request.body != null) request.body.cancel();
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && $e52be20a9fc15e96$var$test(()=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(new Response('').body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(body)) return body.size;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
            const _request = new Request((0, $bb8180acb278e187$export$2e2bcd8739ae039).origin, {
                method: 'POST',
                body: body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + '';
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions, maxContentLength: maxContentLength, maxBodyLength: maxBodyLength, maxRedirects: maxRedirects } = (0, $ab4625fac3104691$export$2e2bcd8739ae039)(config);
        const hasMaxContentLength = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isNumber(maxContentLength) && maxContentLength > -1;
        const hasMaxBodyLength = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isNumber(maxBodyLength) && maxBodyLength > -1;
        const own = (key)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config, key) ? config[key] : undefined;
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
        let composedSignal = (0, $a052b9a6636aacdc$export$2e2bcd8739ae039)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        // AxiosError we raise while the request body is being streamed. Captured
        // by identity so the catch block can surface it directly, regardless of
        // how the runtime wraps the resulting fetch rejection (undici exposes it
        // as `err.cause`; some browsers drop the original error entirely).
        let pendingBodyError = null;
        const maxBodyLengthError = ()=>new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Request body larger than maxBodyLength limit', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config, request);
        try {
            // HTTP basic authentication
            let auth = undefined;
            const configAuth = own('auth');
            if (configAuth) {
                const username = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).getSafeProp(configAuth, 'username') || '';
                const password = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).getSafeProp(configAuth, 'password') || '';
                auth = {
                    username: username,
                    password: password
                };
            }
            if ($e52be20a9fc15e96$var$maybeWithAuthCredentials(url)) {
                const parsedURL = new URL(url, (0, $bb8180acb278e187$export$2e2bcd8739ae039).origin);
                if (!auth && (parsedURL.username || parsedURL.password)) {
                    const urlUsername = $e52be20a9fc15e96$var$decodeURIComponentSafe(parsedURL.username);
                    const urlPassword = $e52be20a9fc15e96$var$decodeURIComponentSafe(parsedURL.password);
                    auth = {
                        username: urlUsername,
                        password: urlPassword
                    };
                }
                if (parsedURL.username || parsedURL.password) {
                    parsedURL.username = '';
                    parsedURL.password = '';
                    url = parsedURL.href;
                }
            }
            if (auth) {
                headers.delete('authorization');
                headers.set('Authorization', 'Basic ' + btoa($e52be20a9fc15e96$var$encodeUTF8((auth.username || '') + ':' + (auth.password || ''))));
            }
            // Enforce maxContentLength for data: URLs up-front so we never materialize
            // an oversized payload. The HTTP adapter applies the same check (see http.js
            // "if (protocol === 'data:')" branch).
            if (hasMaxContentLength && typeof url === 'string' && url.startsWith('data:')) {
                const estimated = (0, $da69a2069c6136ea$export$2e2bcd8739ae039)(url);
                if (estimated > maxContentLength) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            // Enforce maxBodyLength against known-size bodies before dispatch using
            // the body's *actual* size — never a caller-declared Content-Length,
            // which could under-report to slip an oversized body past the check.
            // Unknown-size streams return undefined here and are counted per-chunk
            // below as fetch consumes them.
            if (hasMaxBodyLength && method !== 'get' && method !== 'head') {
                const outboundLength = await getBodyLength(data);
                if (typeof outboundLength === 'number' && isFinite(outboundLength)) {
                    requestContentLength = outboundLength;
                    if (outboundLength > maxBodyLength) throw maxBodyLengthError();
                }
            }
            // A streamed body under maxBodyLength must be counted as fetch consumes
            // it; its size is never trusted from a caller-declared Content-Length.
            const mustEnforceStreamBody = hasMaxBodyLength && ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isStream(data));
            const trackRequestStream = (stream, onProgress, flush)=>(0, $c9465135abb26626$export$b0119225647bd83)(stream, $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE, (loadedBytes)=>{
                    if (hasMaxBodyLength && loadedBytes > maxBodyLength) throw pendingBodyError = maxBodyLengthError();
                    onProgress && onProgress(loadedBytes);
                }, flush);
            if (supportsRequestStream && method !== 'get' && method !== 'head' && (onUploadProgress || mustEnforceStreamBody)) {
                requestContentLength = requestContentLength == null ? await resolveBodyLength(headers, data) : requestContentLength;
                // A declared length of 0 is only trusted to skip the wrap when we are
                // not enforcing a stream limit (which must not rely on that header).
                if (requestContentLength !== 0 || mustEnforceStreamBody) {
                    let _request = new Request(url, {
                        method: 'POST',
                        body: data,
                        duplex: 'half'
                    });
                    let contentTypeHeader;
                    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                    if (_request.body) {
                        const [onProgress, flush] = onUploadProgress && (0, $1a6c80b567b74091$export$d9fadd12586c18d6)(requestContentLength, (0, $1a6c80b567b74091$export$c1b28109d46c3592)((0, $1a6c80b567b74091$export$5d35863c355a22a9)(onUploadProgress))) || [];
                        data = trackRequestStream(_request.body, onProgress, flush);
                    }
                }
            } else if (mustEnforceStreamBody && !isRequestSupported && isReadableStreamSupported && method !== 'get' && method !== 'head') data = trackRequestStream(data);
            else if (mustEnforceStreamBody && isRequestSupported && !supportsRequestStream && method !== 'get' && method !== 'head') throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Stream request bodies are not supported by the current fetch implementation', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config, request);
            if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && 'credentials' in Request.prototype;
            // If data is FormData and Content-Type is multipart/form-data without boundary,
            // delete it so fetch can set it correctly with the boundary
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data)) {
                const contentType = headers.getContentType();
                if (contentType && /^multipart\/form-data/i.test(contentType) && !/boundary=/i.test(contentType)) headers.delete('content-type');
            }
            // Set User-Agent header if not already set (fetch defaults to 'node' in Node.js)
            headers.set('User-Agent', 'axios/' + (0, $23ff3f1a5c7912d5$export$a4ad2735b021c132), false);
            const safeFetchOptions = fetchOptions == null ? fetchOptions : Object.assign(Object.create(null), fetchOptions);
            if (safeFetchOptions) {
                // These options are owned by Axios and are already reflected in the
                // resolved Request passed to fetch.
                delete safeFetchOptions.body;
                delete safeFetchOptions.headers;
                delete safeFetchOptions.method;
                delete safeFetchOptions.signal;
                delete safeFetchOptions.duplex;
                delete safeFetchOptions.credentials;
            }
            const resolvedOptions = Object.assign(Object.create(null), safeFetchOptions, {
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: (0, $f8f5102fdfcbfec9$export$c30c72bb7e677d54)(headers.normalize()),
                body: data,
                duplex: 'half',
                credentials: isCredentialsSupported ? withCredentials : undefined
            });
            if (isRequestSupported) {
                (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach($e52be20a9fc15e96$var$DEFAULT_REQUEST_OPTIONS, (value, key)=>{
                    if (resolvedOptions[key] === undefined) resolvedOptions[key] = value;
                });
                if (resolvedOptions.signal === undefined) resolvedOptions.signal = null;
                if (resolvedOptions.body === undefined) resolvedOptions.body = null;
            }
            if (maxRedirects === 0) {
                resolvedOptions.redirect = 'manual';
                if (safeFetchOptions) safeFetchOptions.redirect = 'manual';
            }
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, safeFetchOptions) : _fetch(url, resolvedOptions));
            const responseHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(response.headers);
            // Cheap pre-check: if the server honestly declares a content-length that
            // already exceeds the cap, reject before we start streaming.
            if (hasMaxContentLength) {
                const declaredLength = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFiniteNumber(responseHeaders.getContentLength());
                if (declaredLength != null && declaredLength > maxContentLength) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
            if (supportsResponseStream && response.body && (onDownloadProgress || hasMaxContentLength || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    'status',
                    'statusText',
                    'headers'
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFiniteNumber(responseHeaders.getContentLength());
                const [onProgress, flush] = onDownloadProgress && (0, $1a6c80b567b74091$export$d9fadd12586c18d6)(responseContentLength, (0, $1a6c80b567b74091$export$c1b28109d46c3592)((0, $1a6c80b567b74091$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
                let bytesRead = 0;
                const onChunkProgress = (loadedBytes)=>{
                    if (hasMaxContentLength) {
                        bytesRead = loadedBytes;
                        if (bytesRead > maxContentLength) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
                    }
                    onProgress && onProgress(loadedBytes);
                };
                response = new Response((0, $c9465135abb26626$export$b0119225647bd83)(response.body, $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE, onChunkProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || 'text';
            let responseData = await resolvers[(0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(resolvers, responseType) || 'text'](response, config);
            // Fallback enforcement for environments without ReadableStream support
            // (legacy runtimes). Detect materialized size from typed output; skip
            // streams/Response passthrough since the user will read those themselves.
            if (hasMaxContentLength && !supportsResponseStream && !isStreamResponse) {
                let materializedSize;
                if (responseData != null) {
                    if (typeof responseData.byteLength === 'number') materializedSize = responseData.byteLength;
                    else if (typeof responseData.size === 'number') materializedSize = responseData.size;
                    else if (typeof responseData === 'string') materializedSize = typeof TextEncoder === 'function' ? new TextEncoder().encode(responseData).byteLength : responseData.length;
                }
                if (typeof materializedSize === 'number' && materializedSize > maxContentLength) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, $ecb62d5372993dcf$export$2e2bcd8739ae039)(resolve, reject, {
                    data: responseData,
                    headers: (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config: config,
                    request: request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            // Safari can surface fetch aborts as a DOMException-like object whose
            // branded getters throw. Prefer our composed signal reason before reading
            // the caught error, preserving timeout vs cancellation semantics.
            if (composedSignal && composedSignal.aborted && composedSignal.reason instanceof (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)) {
                const canceledError = composedSignal.reason;
                canceledError.config = config;
                request && (canceledError.request = request);
                if (err !== canceledError) // Non-enumerable to match native Error `cause` semantics so loggers
                // don't recurse into circular fetch internals (see #7205).
                Object.defineProperty(canceledError, 'cause', {
                    __proto__: null,
                    value: err,
                    writable: true,
                    enumerable: false,
                    configurable: true
                });
                throw canceledError;
            }
            // Surface a maxBodyLength violation we raised while the request body was
            // being streamed. Matching by identity (rather than reading
            // `err.cause.isAxiosError`) keeps the error deterministic across runtimes
            // and avoids both prototype-pollution reads and mis-attributing a foreign
            // AxiosError that merely happened to land in `err.cause`.
            if (pendingBodyError) {
                request && !pendingBodyError.request && (pendingBodyError.request = request);
                throw pendingBodyError;
            }
            // Re-throw AxiosErrors we raised synchronously (data: URL / content-length
            // pre-checks, response size enforcement) without re-wrapping them.
            if (err instanceof (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)) {
                request && !err.request && (err.request = request);
                throw err;
            }
            if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) {
                const networkError = new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Network Error', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NETWORK, config, request, err && err.response);
                // Non-enumerable to match native Error `cause` semantics so loggers
                // don't recurse into circular fetch internals (see #7205).
                Object.defineProperty(networkError, 'cause', {
                    __proto__: null,
                    value: err.cause || err,
                    writable: true,
                    enumerable: false,
                    configurable: true
                });
                throw networkError;
            }
            throw (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).from(err, err && err.code, config, request, err && err.response);
        }
    };
};
const $e52be20a9fc15e96$var$seedCache = new Map();
const $e52be20a9fc15e96$export$3105c6651375d4fa = (config)=>{
    let env = config && config.env || {};
    const { fetch: fetch1, Request: Request, Response: Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = $e52be20a9fc15e96$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $e52be20a9fc15e96$var$factory(env));
        map = target;
    }
    return target;
};
const $e52be20a9fc15e96$var$adapter = $e52be20a9fc15e96$export$3105c6651375d4fa();
var $e52be20a9fc15e96$export$2e2bcd8739ae039 = $e52be20a9fc15e96$var$adapter;



/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 *
 * @type {Object<string, Function|Object>}
 */ const $e8c8c7960873e9ee$var$knownAdapters = {
    http: (0, $4023ac50ad132196$export$2e2bcd8739ae039),
    xhr: (0, $79f0a48d5eb7919b$export$2e2bcd8739ae039),
    fetch: {
        get: $e52be20a9fc15e96$export$3105c6651375d4fa
    }
};
// Assign adapter names for easier debugging and identification
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach($e8c8c7960873e9ee$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            // Null-proto descriptors so a polluted Object.prototype.get cannot turn
            // these data descriptors into accessor descriptors on the way in.
            Object.defineProperty(fn, 'name', {
                __proto__: null,
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            __proto__: null,
            value: value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 *
 * @param {string} reason
 * @returns {string}
 */ const $e8c8c7960873e9ee$var$renderReason = (reason)=>`- ${reason}`;
/**
 * Check if the adapter is resolved (function, null, or false)
 *
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ const $e8c8c7960873e9ee$var$isResolvedHandle = (adapter)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 *
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function $e8c8c7960873e9ee$var$getAdapter(adapters, config) {
    adapters = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
        adapters
    ];
    const { length: length } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for(let i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        let id;
        adapter = nameOrAdapter;
        if (!$e8c8c7960873e9ee$var$isResolvedHandle(nameOrAdapter)) {
            adapter = $e8c8c7960873e9ee$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
        }
        if (adapter && ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
        let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($e8c8c7960873e9ee$var$renderReason).join('\n') : ' ' + $e8c8c7960873e9ee$var$renderReason(reasons[0]) : 'as no adapter specified';
        throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NOT_SUPPORT);
    }
    return adapter;
}
var /**
 * Exports Axios adapters and utility to resolve an adapter
 */ $e8c8c7960873e9ee$export$2e2bcd8739ae039 = {
    getAdapter: /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ $e8c8c7960873e9ee$var$getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: $e8c8c7960873e9ee$var$knownAdapters
};



'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $9b8d10189805ccc0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(null, config);
}
function $9b8d10189805ccc0$export$2e2bcd8739ae039(_config) {
    // Interceptors may replace the merged config with an ordinary object. Flatten
    // it at the dispatch boundary so shared prototype members cannot become
    // request behavior, while preserving intentional template/class members.
    const config = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toSafeFlatObject(_config);
    $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
    config.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from((0, $c319b2c832c2914a$export$2e2bcd8739ae039).getSafeProp(config, 'headers'));
    // Transform request data
    config.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $e8c8c7960873e9ee$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $843bf0209bc94df8$export$2e2bcd8739ae039).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
        // Expose the current response on config so that transformResponse can
        // attach it to any AxiosError it throws (e.g. on JSON parse failure).
        // We clean it up afterwards to avoid polluting the config object.
        config.response = response;
        try {
            response.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        } finally{
            delete config.response;
        }
        response.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $5a60afef8b0dd173$export$2e2bcd8739ae039)(reason)) {
            $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                config.response = reason.response;
                try {
                    reason.response.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                } finally{
                    delete config.response;
                }
                reason.response.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}







'use strict';
const $85f59389941e7907$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $85f59389941e7907$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $85f59389941e7907$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $85f59389941e7907$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $23ff3f1a5c7912d5$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$85f59389941e7907$var$deprecatedWarnings[opt]) {
            $85f59389941e7907$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$85f59389941e7907$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $85f59389941e7907$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object' || options === null) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('options must be an object', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        // Use hasOwnProperty so a polluted Object.prototype.<opt> cannot supply
        // a non-function validator and cause a TypeError.
        const validator = Object.prototype.hasOwnProperty.call(schema, opt) ? schema[opt] : undefined;
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('option ' + opt + ' must be ' + result, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Unknown option ' + opt, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $85f59389941e7907$export$2e2bcd8739ae039 = {
    assertOptions: $85f59389941e7907$var$assertOptions,
    validators: $85f59389941e7907$var$validators
};




'use strict';
const $a93486d2307f31c3$var$validators = (0, $85f59389941e7907$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $a93486d2307f31c3$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $5de878cd737ef277$export$2e2bcd8739ae039)(),
            response: new (0, $5de878cd737ef277$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) try {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                const dummyStack = dummy.stack;
                let stack = '';
                // slice off the Error: ... line
                if (typeof dummyStack === 'string') {
                    const firstNewlineIndex = dummyStack.indexOf('\n');
                    stack = firstNewlineIndex === -1 ? '' : dummyStack.slice(firstNewlineIndex + 1);
                }
                if (!err.stack) err.stack = stack;
                else if (stack) {
                    const firstNewlineIndex = stack.indexOf('\n');
                    const secondNewlineIndex = firstNewlineIndex === -1 ? -1 : stack.indexOf('\n', firstNewlineIndex + 1);
                    const stackWithoutTwoTopLines = secondNewlineIndex === -1 ? '' : stack.slice(secondNewlineIndex + 1);
                    if (!String(err.stack).endsWith(stackWithoutTwoTopLines)) err.stack += '\n' + stack;
                }
            } catch (e) {
            // Ignore failures from custom stack hooks or un-writable stack properties.
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            forcedJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            clarifyTimeoutError: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            legacyInterceptorReqResOrdering: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            advertiseZstdAcceptEncoding: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            validateStatusUndefinedResolves: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $a93486d2307f31c3$var$validators.function,
                serialize: $a93486d2307f31c3$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $a93486d2307f31c3$var$validators.spelling('baseURL'),
            withXsrfToken: $a93486d2307f31c3$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).getSafeProp(config, 'method') || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).getSafeProp(this.defaults, 'method') || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach((0, $2fec45dc063f0c4b$export$2e2bcd8739ae039).concat('common'), (method)=>{
            delete headers[method];
        });
        config.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            const transitional = config.transitional || (0, $51466d41a76e5b4b$export$2e2bcd8739ae039);
            const legacyInterceptorReqResOrdering = transitional && transitional.legacyInterceptorReqResOrdering;
            if (legacyInterceptorReqResOrdering) requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
            else requestInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $9b8d10189805ccc0$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled ? onFulfilled(newConfig) : newConfig;
            } catch (error) {
                if (!onRejected) {
                    promise = Promise.reject(error);
                    break;
                }
                try {
                    const rejectedResult = onRejected.call(this, error);
                    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isThenable(rejectedResult)) promise = Promise.resolve(rejectedResult).then(()=>(0, $9b8d10189805ccc0$export$2e2bcd8739ae039).call(this, newConfig));
                } catch (rejectedError) {
                    promise = Promise.reject(rejectedError);
                }
                break;
            }
        }
        if (!promise) try {
            promise = (0, $9b8d10189805ccc0$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            promise = Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $598acbfafd2c63c5$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls, config);
        return (0, $8df8fedf1c1e4428$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: config && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(config, 'data') ? config.data : undefined
        }));
    };
});
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    'post',
    'put',
    'patch',
    'query'
], function forEachMethodWithData(method) {
    function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $a93486d2307f31c3$var$Axios.prototype[method] = generateHTTPMethod();
    // QUERY is a safe/idempotent read method; multipart form bodies don't fit
    // its semantics, so no queryForm shorthand is generated.
    if (method !== 'query') $a93486d2307f31c3$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $a93486d2307f31c3$export$2e2bcd8739ae039 = $a93486d2307f31c3$var$Axios;







'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $fb81495929d8a282$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $fb81495929d8a282$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $fb81495929d8a282$export$2e2bcd8739ae039 = $fb81495929d8a282$var$CancelToken;






'use strict';
function $089369673aa7c1c3$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



'use strict';
function $9db8da59db12cd94$export$2e2bcd8739ae039(payload) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $f919374d785e9fb8$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    /**
   * @deprecated Use `ContentTooLarge` instead.
   */ PayloadTooLarge: 413,
    ContentTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    /**
   * @deprecated Use `UnprocessableContent` instead.
   */ UnprocessableEntity: 422,
    UnprocessableContent: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerReturnsAnUnknownError: 520,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries($f919374d785e9fb8$var$HttpStatusCode).forEach(([key, value])=>{
    if ($f919374d785e9fb8$var$HttpStatusCode[value] === undefined) $f919374d785e9fb8$var$HttpStatusCode[value] = key;
});
var $f919374d785e9fb8$export$2e2bcd8739ae039 = $f919374d785e9fb8$var$HttpStatusCode;


'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $57966c7e0affc4cb$var$createInstance(defaultConfig) {
    const context = new (0, $a93486d2307f31c3$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $e5cb5cefd6507f7e$export$2e2bcd8739ae039)((0, $a93486d2307f31c3$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).extend(instance, (0, $a93486d2307f31c3$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $57966c7e0affc4cb$var$createInstance((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $57966c7e0affc4cb$var$axios = $57966c7e0affc4cb$var$createInstance((0, $843bf0209bc94df8$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$57966c7e0affc4cb$var$axios.Axios = (0, $a93486d2307f31c3$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$57966c7e0affc4cb$var$axios.CanceledError = (0, $9fd0919e266b4fda$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.CancelToken = (0, $fb81495929d8a282$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.isCancel = (0, $5a60afef8b0dd173$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.VERSION = (0, $23ff3f1a5c7912d5$export$a4ad2735b021c132);
$57966c7e0affc4cb$var$axios.toFormData = (0, $e6cbd383b18c9625$export$2e2bcd8739ae039);
// Expose AxiosError class
$57966c7e0affc4cb$var$axios.AxiosError = (0, $4e2395edb77acf3a$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$57966c7e0affc4cb$var$axios.Cancel = $57966c7e0affc4cb$var$axios.CanceledError;
// Expose all/spread
$57966c7e0affc4cb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$57966c7e0affc4cb$var$axios.spread = (0, $089369673aa7c1c3$export$2e2bcd8739ae039);
// Expose isAxiosError
$57966c7e0affc4cb$var$axios.isAxiosError = (0, $9db8da59db12cd94$export$2e2bcd8739ae039);
// Expose mergeConfig
$57966c7e0affc4cb$var$axios.mergeConfig = (0, $f85fda54cd977b19$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.AxiosHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.formToJSON = (thing)=>(0, $5f8142930b3b943f$export$2e2bcd8739ae039)((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$57966c7e0affc4cb$var$axios.getAdapter = (0, $e8c8c7960873e9ee$export$2e2bcd8739ae039).getAdapter;
$57966c7e0affc4cb$var$axios.HttpStatusCode = (0, $f919374d785e9fb8$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.default = $57966c7e0affc4cb$var$axios;
var // this module should only have a default export
$57966c7e0affc4cb$export$2e2bcd8739ae039 = $57966c7e0affc4cb$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $b302555736d21bd7$export$1c00760e9e5a4e95, AxiosError: $b302555736d21bd7$export$c1fbed17c2f6a328, CanceledError: $b302555736d21bd7$export$1ab0c6b20d94fa14, isCancel: $b302555736d21bd7$export$3b22524397b493c6, CancelToken: $b302555736d21bd7$export$fd08e3cb425f0d61, VERSION: $b302555736d21bd7$export$a4ad2735b021c132, all: $b302555736d21bd7$export$84bf76cd7afc7469, Cancel: $b302555736d21bd7$export$848c9b7ead0df967, isAxiosError: $b302555736d21bd7$export$fbafdbe06a5b5a9a, spread: $b302555736d21bd7$export$3ae0fd4797ed47c8, toFormData: $b302555736d21bd7$export$10ae0d317ea97f8b, AxiosHeaders: $b302555736d21bd7$export$4e7d6ff0f3e6520, HttpStatusCode: $b302555736d21bd7$export$a972f69c851492b3, formToJSON: $b302555736d21bd7$export$86d7c59254d6a2c9, getAdapter: $b302555736d21bd7$export$17ddc20a97d669e2, mergeConfig: $b302555736d21bd7$export$7ec1ebcfa9d8bd6a, create: $b302555736d21bd7$export$185802fd694ee1f5 } = (0, $57966c7e0affc4cb$export$2e2bcd8739ae039);


const $9810156153020e5d$export$bb173986169374ad = async (url, method, body, headers)=>{
    console.log("Insidee APICall.js");
    try {
        headers.method = method;
        let apiObjAxios = {
            url: url,
            method: method
        };
        apiObjAxios.headers = headers;
        if (method === "POST" || method === "PUT" || method === "PATCH") apiObjAxios.data = body;
        return new Promise((resolve, reject)=>{
            (0, $57966c7e0affc4cb$export$2e2bcd8739ae039)(apiObjAxios).then(async (response)=>{
                resolve(response);
            }).catch((err)=>{
                if (err.response && err.response.data) reject(err.response.data);
                else reject(err);
            });
        });
    } catch (error) {
        throw new Error("Something went wrong", error.response ? error.response.data : error);
    }
};


const $dee2f92127058cd3$export$cc9d05b5f479a635 = "SAVE_LOGIN_INFO";
const $dee2f92127058cd3$export$2ff9a07d0ddfe920 = "SAVE_DPO_CONFIG_ID";
const $dee2f92127058cd3$export$b9ba16bb18608137 = "SAVE_SYSTEM_CONFIG_CONFIG_ID";
const $dee2f92127058cd3$export$ef40a3ef4f5aca15 = "SAVE_DATA_PROCESSOR_ID";
const $dee2f92127058cd3$export$29c75c224be84a95 = "SAVE_PURPOSE_ID";
const $dee2f92127058cd3$export$96bbbe02b0f41653 = "SAVE_LOGIN_USER_PROFILE_DETAILS";
const $dee2f92127058cd3$export$8754a668aecb2a04 = "SET_PORTAL_THEME";
const $dee2f92127058cd3$export$86bb12488d35783 = "SAVE_SIGNUP_INFO";
const $dee2f92127058cd3$export$b1b164fc453b59c0 = "SAVE_ONBOARD_INFO";
const $dee2f92127058cd3$export$ed8e9a22a73d5238 = "SAVE_USER_PROFILE";
const $dee2f92127058cd3$export$e28a0e7733933219 = "CLEAR_SESSION";
const $dee2f92127058cd3$export$d0b6080278ff0075 = "SAVE_TEMPLATES";
const $dee2f92127058cd3$export$c829181dc407b03f = "SAVE_CUSID_TNTID";
const $dee2f92127058cd3$export$9feaa1032f771c36 = "SET_BUSINESS_NAME";
const $dee2f92127058cd3$export$c81870bc2191aec7 = "SET_BUSINESS_LOGO";
const $dee2f92127058cd3$export$f21702b540d6bf35 = {
    GRIEVANCE_RAISED: "RAISED",
    GRIEVANCE_INPROCESS: "INPROCESS",
    GRIEVANCE_L1_ESCALATED: "L1_ESCALATED",
    GRIEVANCE_L2_ESCALATED: "L2_ESCALATED",
    GRIEVANCE_RESOLVED: "RESOLVED",
    NEW: "NEW"
};
const $dee2f92127058cd3$export$6027aad055c44279 = "SET_PARENT_CONSENT_METADATA";
const $dee2f92127058cd3$export$8a030116ef1d058b = "SET_PARENT_CODE";
const $dee2f92127058cd3$export$aa27936551104482 = "SET_PARENT_STATE";
const $dee2f92127058cd3$export$b2c0b9812d26261f = "SAVE_INTEGRATION_IDS";
const $dee2f92127058cd3$export$7dc30384a9e2138c = "SET_CURRENT_LANGUAGE";
const $dee2f92127058cd3$export$61812dfd55580ecf = "SET_TRANSLATIONS";
const $dee2f92127058cd3$export$a7d24a17944978e7 = "SET_IS_TRANSLATING";


const $d27dbe10f1bffb7d$var$BASE_URL = undefined;
const $d27dbe10f1bffb7d$var$CONSENT_URL = undefined;
const $d27dbe10f1bffb7d$var$META_URL = undefined;
const $d27dbe10f1bffb7d$var$GRIEVANCE_URL = undefined;
const $d27dbe10f1bffb7d$var$TRANSLATE_URL = undefined;
const $d27dbe10f1bffb7d$var$login_init_otp = `${$d27dbe10f1bffb7d$var$BASE_URL}/tenant/otp/init`;
const $d27dbe10f1bffb7d$var$getConsentsByCustomerId = `${$d27dbe10f1bffb7d$var$CONSENT_URL}/v1.0/consent/searchConsentByIdentity`;
const $d27dbe10f1bffb7d$var$getConsentsByTemplateId = `${$d27dbe10f1bffb7d$var$CONSENT_URL}/v1.0/consent/search`;
const $d27dbe10f1bffb7d$var$getBusinessLogoByBusinessId = `${$d27dbe10f1bffb7d$var$BASE_URL}/v1.0/system-config/search`;
const $d27dbe10f1bffb7d$var$getConsentHandleById = `${$d27dbe10f1bffb7d$var$CONSENT_URL}/v1.0/consent-handle/get/`;
const $d27dbe10f1bffb7d$var$sendParentalConsentRequest = `${$d27dbe10f1bffb7d$var$CONSENT_URL}/v1.0/consent-handle/parental-consent`;
const $d27dbe10f1bffb7d$var$getconsentMetaId = `${$d27dbe10f1bffb7d$var$CONSENT_URL}/v1.0/consent-meta/`;
const $d27dbe10f1bffb7d$var$withdrawConsentByConsentId = `${$d27dbe10f1bffb7d$var$CONSENT_URL}/v1.0/consent/update/`;
const $d27dbe10f1bffb7d$var$createParentalConsent = `${$d27dbe10f1bffb7d$var$CONSENT_URL}/v1.0/consent/create`;
const $d27dbe10f1bffb7d$var$searchConsentHandleByCustomerId = `${$d27dbe10f1bffb7d$var$CONSENT_URL}/v1.0/consent-handle/search`;
const $d27dbe10f1bffb7d$var$fetchDocumentById = `${$d27dbe10f1bffb7d$var$CONSENT_URL}/v1.0/documents/view-document/`;
const $d27dbe10f1bffb7d$var$getGrievnaceTemplateDataById = `${$d27dbe10f1bffb7d$var$GRIEVANCE_URL}/api/v1/grievance-templates`;
const $d27dbe10f1bffb7d$var$getGrievnaceTemplateData = `${$d27dbe10f1bffb7d$var$GRIEVANCE_URL}/api/v1/ITSM/grievance-templates/search`;
const $d27dbe10f1bffb7d$var$getGrievnaceRequest = `${$d27dbe10f1bffb7d$var$GRIEVANCE_URL}/api/v1/ITSM/grievances/search`;
const $d27dbe10f1bffb7d$var$getGrievnaceReq = `${$d27dbe10f1bffb7d$var$GRIEVANCE_URL}/api/v1/ITSM/grievances`;
const $d27dbe10f1bffb7d$var$createGrievanceRequest = `${$d27dbe10f1bffb7d$var$GRIEVANCE_URL}/api/v1/ITSM/grievances`;
const $d27dbe10f1bffb7d$var$createGrievanceFeedback = `${$d27dbe10f1bffb7d$var$GRIEVANCE_URL}/api/v1/grievances`;
const $d27dbe10f1bffb7d$var$translateConfig = `${$d27dbe10f1bffb7d$var$TRANSLATE_URL}/translateConfig`;
const $d27dbe10f1bffb7d$var$translateInputs = `${$d27dbe10f1bffb7d$var$TRANSLATE_URL}/translate`;
const $d27dbe10f1bffb7d$var$createConsent = `${$d27dbe10f1bffb7d$var$CONSENT_URL}/v1.0/consent/create`;
const $d27dbe10f1bffb7d$var$getBusinessDetailsByBusinessid = `${$d27dbe10f1bffb7d$var$BASE_URL}/v1.0/business-application/search`;
const $d27dbe10f1bffb7d$var$getDigilockerDetails = `${$d27dbe10f1bffb7d$var$BASE_URL}/v1.0/digilocker/credential/search`;
const $d27dbe10f1bffb7d$var$createParenytalConsentMeta = `${$d27dbe10f1bffb7d$var$CONSENT_URL}/v1.0/consent-meta/create`;
const $d27dbe10f1bffb7d$var$metaurl = `${$d27dbe10f1bffb7d$var$META_URL}/consent-meta/`;
const $d27dbe10f1bffb7d$var$user_dashboard_theme_get = `${$d27dbe10f1bffb7d$var$BASE_URL}/v1.0/user-dashboard-theme/get`;
var $d27dbe10f1bffb7d$export$2e2bcd8739ae039 = {
    login_init_otp: $d27dbe10f1bffb7d$var$login_init_otp,
    sendParentalConsentRequest: $d27dbe10f1bffb7d$var$sendParentalConsentRequest,
    getConsentsByCustomerId: $d27dbe10f1bffb7d$var$getConsentsByCustomerId,
    getConsentsByTemplateId: $d27dbe10f1bffb7d$var$getConsentsByTemplateId,
    getConsentHandleById: $d27dbe10f1bffb7d$var$getConsentHandleById,
    getconsentMetaId: $d27dbe10f1bffb7d$var$getconsentMetaId,
    withdrawConsentByConsentId: $d27dbe10f1bffb7d$var$withdrawConsentByConsentId,
    searchConsentHandleByCustomerId: $d27dbe10f1bffb7d$var$searchConsentHandleByCustomerId,
    getGrievnaceTemplateData: $d27dbe10f1bffb7d$var$getGrievnaceTemplateData,
    getGrievnaceRequest: $d27dbe10f1bffb7d$var$getGrievnaceRequest,
    getGrievnaceTemplateDataById: $d27dbe10f1bffb7d$var$getGrievnaceTemplateDataById,
    getGrievnaceReq: $d27dbe10f1bffb7d$var$getGrievnaceReq,
    createGrievanceRequest: $d27dbe10f1bffb7d$var$createGrievanceRequest,
    createGrievanceFeedback: $d27dbe10f1bffb7d$var$createGrievanceFeedback,
    fetchDocumentById: $d27dbe10f1bffb7d$var$fetchDocumentById,
    translateConfig: $d27dbe10f1bffb7d$var$translateConfig,
    translateInputs: $d27dbe10f1bffb7d$var$translateInputs,
    createConsent: $d27dbe10f1bffb7d$var$createConsent,
    createParentalConsent: $d27dbe10f1bffb7d$var$createParentalConsent,
    getBusinessDetailsByBusinessid: $d27dbe10f1bffb7d$var$getBusinessDetailsByBusinessid,
    getDigilockerDetails: $d27dbe10f1bffb7d$var$getDigilockerDetails,
    createParenytalConsentMeta: $d27dbe10f1bffb7d$var$createParenytalConsentMeta,
    metaurl: $d27dbe10f1bffb7d$var$metaurl,
    getBusinessLogoByBusinessId: $d27dbe10f1bffb7d$var$getBusinessLogoByBusinessId,
    user_dashboard_theme_get: $d27dbe10f1bffb7d$var$user_dashboard_theme_get
};




var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");
function $f2ccb2ae3c8742b7$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $f2ccb2ae3c8742b7$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $f2ccb2ae3c8742b7$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $f2ccb2ae3c8742b7$export$2e2bcd8739ae039 = $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37;


"use client";
var $b00d3e7401eac195$var$L = (t)=>typeof t == "number" && !isNaN(t), $b00d3e7401eac195$var$N = (t)=>typeof t == "string", $b00d3e7401eac195$var$P = (t)=>typeof t == "function", $b00d3e7401eac195$var$ut = (t)=>$b00d3e7401eac195$var$N(t) || $b00d3e7401eac195$var$L(t), $b00d3e7401eac195$var$z = (t)=>$b00d3e7401eac195$var$N(t) || $b00d3e7401eac195$var$P(t) ? t : null, $b00d3e7401eac195$var$yt = (t, o)=>t === !1 || $b00d3e7401eac195$var$L(t) && t > 0 ? t : o, $b00d3e7401eac195$var$F = (t)=>(0, $acw62.isValidElement)(t) || $b00d3e7401eac195$var$N(t) || $b00d3e7401eac195$var$P(t) || $b00d3e7401eac195$var$L(t);
function $b00d3e7401eac195$export$184cca501f1aed7f(t, o, e = 300) {
    let { scrollHeight: r, style: a } = t;
    requestAnimationFrame(()=>{
        a.minHeight = "initial", a.height = r + "px", a.transition = `all ${e}ms`, requestAnimationFrame(()=>{
            a.height = "0", a.padding = "0", a.margin = "0", setTimeout(o, e);
        });
    });
}
function $b00d3e7401eac195$export$3ff7dc44d332d222({ enter: t, exit: o, appendPosition: e = !1, collapse: r = !0, collapseDuration: a = 300 }) {
    return function({ children: s, position: f, preventExitTransition: c, done: T, nodeRef: g, isIn: v, playToast: x }) {
        let C = e ? `${t}--${f}` : t, S = e ? `${o}--${f}` : o, E = (0, $acw62.useRef)(0);
        return (0, $acw62.useLayoutEffect)(()=>{
            let d = g.current, p = C.split(" "), b = (n)=>{
                n.target === g.current && (x(), d.removeEventListener("animationend", b), d.removeEventListener("animationcancel", b), E.current === 0 && n.type !== "animationcancel" && d.classList.remove(...p));
            };
            d.classList.add(...p), d.addEventListener("animationend", b), d.addEventListener("animationcancel", b);
        }, []), (0, $acw62.useEffect)(()=>{
            let d = g.current, p = ()=>{
                d.removeEventListener("animationend", p), r ? $b00d3e7401eac195$export$184cca501f1aed7f(d, T, a) : T();
            };
            v || (c ? p() : (E.current = 1, d.className += ` ${S}`, d.addEventListener("animationend", p)));
        }, [
            v
        ]), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, s);
    };
}
function $b00d3e7401eac195$var$tt(t, o) {
    return {
        content: $b00d3e7401eac195$var$ot(t.content, t.props),
        containerId: t.props.containerId,
        id: t.props.toastId,
        theme: t.props.theme,
        type: t.props.type,
        data: t.props.data || {},
        isLoading: t.props.isLoading,
        icon: t.props.icon,
        reason: t.removalReason,
        status: o
    };
}
function $b00d3e7401eac195$var$ot(t, o, e = !1) {
    return (0, $acw62.isValidElement)(t) && !$b00d3e7401eac195$var$N(t.type) ? (0, $acw62.cloneElement)(t, {
        closeToast: o.closeToast,
        toastProps: o,
        data: o.data,
        isPaused: e
    }) : $b00d3e7401eac195$var$P(t) ? t({
        closeToast: o.closeToast,
        toastProps: o,
        data: o.data,
        isPaused: e
    }) : t;
}
function $b00d3e7401eac195$var$gt({ closeToast: t, theme: o, ariaLabel: e = "close" }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: `Toastify__close-button Toastify__close-button--${o}`,
        type: "button",
        onClick: (r)=>{
            r.stopPropagation(), t(!0);
        },
        "aria-label": e
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        "aria-hidden": "true",
        viewBox: "0 0 14 16"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fillRule: "evenodd",
        d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
    })));
}
function $b00d3e7401eac195$var$bt({ delay: t, isRunning: o, closeToast: e, type: r = "default", hide: a, className: l, controlledProgress: s, progress: f, rtl: c, isIn: T, theme: g }) {
    let v = a || s && f === 0, x = {
        animationDuration: `${t}ms`,
        animationPlayState: o ? "running" : "paused"
    };
    s && (x.transform = `scaleX(${f})`);
    let C = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("Toastify__progress-bar", s ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", `Toastify__progress-bar-theme--${g}`, `Toastify__progress-bar--${r}`, {
        ["Toastify__progress-bar--rtl"]: c
    }), S = $b00d3e7401eac195$var$P(l) ? l({
        rtl: c,
        type: r,
        defaultClassName: C
    }) : (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(C, l), E = {
        [s && f >= 1 ? "onTransitionEnd" : "onAnimationEnd"]: s && f < 1 ? null : ()=>{
            T && e();
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "Toastify__progress-bar--wrp",
        "data-hidden": v
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: `Toastify__progress-bar--bg Toastify__progress-bar-theme--${g} Toastify__progress-bar--${r}`
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "progressbar",
        "aria-hidden": v ? "true" : "false",
        "aria-label": "notification timer",
        "aria-valuenow": s ? Math.round(f * 100) : void 0,
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        className: S,
        style: x,
        ...E
    }));
}
var $b00d3e7401eac195$var$Qt = 1, $b00d3e7401eac195$var$st = ()=>`${$b00d3e7401eac195$var$Qt++}`;
function $b00d3e7401eac195$var$vt(t, o, e) {
    let r = 1, a = 0, l = [], s = [], f = o, c = new Map, T = new Set, g = (i)=>(T.add(i), ()=>T.delete(i)), v = ()=>{
        s = Array.from(c.values()), T.forEach((i)=>i());
    }, x = ({ containerId: i, toastId: n, updateId: u })=>{
        let h = i ? i !== t : t !== 1, m = c.has(n) && u == null;
        return h || m;
    }, C = (i, n)=>{
        c.forEach((u)=>{
            var h;
            (n == null || n === u.props.toastId) && ((h = u.toggle) == null || h.call(u, i));
        });
    }, S = (i)=>{
        var n, u;
        i.isActive && ((u = (n = i.props) == null ? void 0 : n.onClose) == null || u.call(n, i.removalReason), i.isActive = !1, e($b00d3e7401eac195$var$tt(i, "removed")));
    }, E = (i)=>{
        if (i == null) c.forEach(S);
        else {
            let n = c.get(i);
            n && S(n);
        }
        v();
    }, d = ()=>{
        a -= l.length, l = [];
    }, p = (i)=>{
        var m, _;
        let { toastId: n, updateId: u } = i.props, h = u == null;
        i.staleId && c.delete(i.staleId), i.isActive = !0, c.set(n, i), v(), e($b00d3e7401eac195$var$tt(i, h ? "added" : "updated")), h && ((_ = (m = i.props).onOpen) == null || _.call(m));
    };
    return {
        id: t,
        props: f,
        observe: g,
        toggle: C,
        removeToast: E,
        toasts: c,
        clearQueue: d,
        buildToast: (i, n)=>{
            if (x(n)) return;
            let { toastId: u, updateId: h, data: m, staleId: _, delay: k } = n, D = h == null;
            D && a++;
            let A = {
                ...f,
                style: f.toastStyle,
                key: r++,
                ...Object.fromEntries(Object.entries(n).filter(([M, $])=>$ != null)),
                toastId: u,
                updateId: h,
                data: m,
                isIn: !1,
                className: $b00d3e7401eac195$var$z(n.className || f.toastClassName),
                progressClassName: $b00d3e7401eac195$var$z(n.progressClassName || f.progressClassName),
                autoClose: n.isLoading ? !1 : $b00d3e7401eac195$var$yt(n.autoClose, f.autoClose),
                closeToast (M) {
                    let $ = c.get(u);
                    $ && ($.removalReason = M, E(u));
                },
                deleteToast () {
                    if (c.get(u) != null) {
                        if (c.delete(u), a--, a < 0 && (a = 0), l.length > 0) {
                            p(l.shift());
                            return;
                        }
                        v();
                    }
                }
            };
            A.closeButton = f.closeButton, n.closeButton === !1 || $b00d3e7401eac195$var$F(n.closeButton) ? A.closeButton = n.closeButton : n.closeButton === !0 && (A.closeButton = $b00d3e7401eac195$var$F(f.closeButton) ? f.closeButton : !0);
            let B = {
                content: i,
                props: A,
                staleId: _
            };
            f.limit && f.limit > 0 && a > f.limit && D ? l.push(B) : $b00d3e7401eac195$var$L(k) ? setTimeout(()=>{
                p(B);
            }, k) : p(B);
        },
        setProps (i) {
            f = i;
        },
        setToggle: (i, n)=>{
            let u = c.get(i);
            u && (u.toggle = n);
        },
        isToastActive: (i)=>{
            var n;
            return (n = c.get(i)) == null ? void 0 : n.isActive;
        },
        getSnapshot: ()=>s
    };
}
var $b00d3e7401eac195$var$I = new Map, $b00d3e7401eac195$var$U = [], $b00d3e7401eac195$var$rt = new Set, $b00d3e7401eac195$var$Wt = (t)=>$b00d3e7401eac195$var$rt.forEach((o)=>o(t)), $b00d3e7401eac195$var$ht = ()=>$b00d3e7401eac195$var$I.size > 0;
function $b00d3e7401eac195$var$Gt() {
    $b00d3e7401eac195$var$U.forEach((t)=>$b00d3e7401eac195$var$nt(t.content, t.options)), $b00d3e7401eac195$var$U = [];
}
var $b00d3e7401eac195$var$Ct = (t, { containerId: o })=>{
    var e;
    return (e = $b00d3e7401eac195$var$I.get(o || 1)) == null ? void 0 : e.toasts.get(t);
};
function $b00d3e7401eac195$var$X(t, o) {
    var r;
    if (o) return !!((r = $b00d3e7401eac195$var$I.get(o)) != null && r.isToastActive(t));
    let e = !1;
    return $b00d3e7401eac195$var$I.forEach((a)=>{
        a.isToastActive(t) && (e = !0);
    }), e;
}
function $b00d3e7401eac195$var$xt(t) {
    if (!$b00d3e7401eac195$var$ht()) {
        $b00d3e7401eac195$var$U = $b00d3e7401eac195$var$U.filter((o)=>t != null && o.options.toastId !== t);
        return;
    }
    if (t == null || $b00d3e7401eac195$var$ut(t)) $b00d3e7401eac195$var$I.forEach((o)=>{
        o.removeToast(t);
    });
    else if (t && ("containerId" in t || "id" in t)) {
        let o = $b00d3e7401eac195$var$I.get(t.containerId);
        o ? o.removeToast(t.id) : $b00d3e7401eac195$var$I.forEach((e)=>{
            e.removeToast(t.id);
        });
    }
}
var $b00d3e7401eac195$var$Et = (t = {})=>{
    $b00d3e7401eac195$var$I.forEach((o)=>{
        o.props.limit && (!t.containerId || o.id === t.containerId) && o.clearQueue();
    });
};
function $b00d3e7401eac195$var$nt(t, o) {
    $b00d3e7401eac195$var$F(t) && ($b00d3e7401eac195$var$ht() || $b00d3e7401eac195$var$U.push({
        content: t,
        options: o
    }), $b00d3e7401eac195$var$I.forEach((e)=>{
        e.buildToast(t, o);
    }));
}
function $b00d3e7401eac195$var$Pt(t) {
    var o;
    (o = $b00d3e7401eac195$var$I.get(t.containerId || 1)) == null || o.setToggle(t.id, t.fn);
}
function $b00d3e7401eac195$var$it(t, o) {
    $b00d3e7401eac195$var$I.forEach((e)=>{
        (o == null || !(o != null && o.containerId) || (o == null ? void 0 : o.containerId) === e.id) && e.toggle(t, o == null ? void 0 : o.id);
    });
}
function $b00d3e7401eac195$var$It(t) {
    let o = t.containerId || 1;
    return {
        subscribe (e) {
            let r = $b00d3e7401eac195$var$vt(o, t, $b00d3e7401eac195$var$Wt);
            $b00d3e7401eac195$var$I.set(o, r);
            let a = r.observe(e);
            return $b00d3e7401eac195$var$Gt(), ()=>{
                a(), $b00d3e7401eac195$var$I.delete(o);
            };
        },
        setProps (e) {
            var r;
            (r = $b00d3e7401eac195$var$I.get(o)) == null || r.setProps(e);
        },
        getSnapshot () {
            var e;
            return (e = $b00d3e7401eac195$var$I.get(o)) == null ? void 0 : e.getSnapshot();
        }
    };
}
function $b00d3e7401eac195$var$St(t) {
    return $b00d3e7401eac195$var$rt.add(t), ()=>{
        $b00d3e7401eac195$var$rt.delete(t);
    };
}
function $b00d3e7401eac195$var$qt(t) {
    return t && ($b00d3e7401eac195$var$N(t.toastId) || $b00d3e7401eac195$var$L(t.toastId)) ? t.toastId : $b00d3e7401eac195$var$st();
}
function $b00d3e7401eac195$var$H(t, o) {
    return $b00d3e7401eac195$var$nt(t, o), o.toastId;
}
function $b00d3e7401eac195$var$Q(t, o) {
    return {
        ...o,
        type: o && o.type || t,
        toastId: $b00d3e7401eac195$var$qt(o)
    };
}
function $b00d3e7401eac195$var$W(t) {
    return (o, e)=>$b00d3e7401eac195$var$H(o, $b00d3e7401eac195$var$Q(t, e));
}
function $b00d3e7401eac195$export$b410431fab84fa58(t, o) {
    return $b00d3e7401eac195$var$H(t, $b00d3e7401eac195$var$Q("default", o));
}
$b00d3e7401eac195$export$b410431fab84fa58.loading = (t, o)=>$b00d3e7401eac195$var$H(t, $b00d3e7401eac195$var$Q("default", {
        isLoading: !0,
        autoClose: !1,
        closeOnClick: !1,
        closeButton: !1,
        draggable: !1,
        ...o
    }));
function $b00d3e7401eac195$var$Kt(t, { pending: o, error: e, success: r }, a) {
    let l;
    o && (l = $b00d3e7401eac195$var$N(o) ? $b00d3e7401eac195$export$b410431fab84fa58.loading(o, a) : $b00d3e7401eac195$export$b410431fab84fa58.loading(o.render, {
        ...a,
        ...o
    }));
    let s = {
        isLoading: null,
        autoClose: null,
        closeOnClick: null,
        closeButton: null,
        draggable: null
    }, f = (T, g, v)=>{
        if (g == null) {
            $b00d3e7401eac195$export$b410431fab84fa58.dismiss(l);
            return;
        }
        let x = {
            type: T,
            ...s,
            ...a,
            data: v
        }, C = $b00d3e7401eac195$var$N(g) ? {
            render: g
        } : g;
        return l ? $b00d3e7401eac195$export$b410431fab84fa58.update(l, {
            ...x,
            ...C
        }) : $b00d3e7401eac195$export$b410431fab84fa58(C.render, {
            ...x,
            ...C
        }), v;
    }, c = $b00d3e7401eac195$var$P(t) ? t() : t;
    return c.then((T)=>f("success", r, T)).catch((T)=>f("error", e, T)), c;
}
$b00d3e7401eac195$export$b410431fab84fa58.promise = $b00d3e7401eac195$var$Kt;
$b00d3e7401eac195$export$b410431fab84fa58.success = $b00d3e7401eac195$var$W("success");
$b00d3e7401eac195$export$b410431fab84fa58.info = $b00d3e7401eac195$var$W("info");
$b00d3e7401eac195$export$b410431fab84fa58.error = $b00d3e7401eac195$var$W("error");
$b00d3e7401eac195$export$b410431fab84fa58.warning = $b00d3e7401eac195$var$W("warning");
$b00d3e7401eac195$export$b410431fab84fa58.warn = $b00d3e7401eac195$export$b410431fab84fa58.warning;
$b00d3e7401eac195$export$b410431fab84fa58.dark = (t, o)=>$b00d3e7401eac195$var$H(t, $b00d3e7401eac195$var$Q("default", {
        theme: "dark",
        ...o
    }));
function $b00d3e7401eac195$var$Yt(t) {
    $b00d3e7401eac195$var$xt(t);
}
$b00d3e7401eac195$export$b410431fab84fa58.dismiss = $b00d3e7401eac195$var$Yt;
$b00d3e7401eac195$export$b410431fab84fa58.clearWaitingQueue = $b00d3e7401eac195$var$Et;
$b00d3e7401eac195$export$b410431fab84fa58.isActive = $b00d3e7401eac195$var$X;
$b00d3e7401eac195$export$b410431fab84fa58.update = (t, o = {})=>{
    let e = $b00d3e7401eac195$var$Ct(t, o);
    if (e) {
        let { props: r, content: a } = e, l = {
            delay: 100,
            ...r,
            ...o,
            toastId: o.toastId || t,
            updateId: $b00d3e7401eac195$var$st()
        };
        l.toastId !== t && (l.staleId = t);
        let s = l.render || a;
        delete l.render, $b00d3e7401eac195$var$H(s, l);
    }
};
$b00d3e7401eac195$export$b410431fab84fa58.done = (t)=>{
    $b00d3e7401eac195$export$b410431fab84fa58.update(t, {
        progress: 1
    });
};
$b00d3e7401eac195$export$b410431fab84fa58.onChange = $b00d3e7401eac195$var$St;
$b00d3e7401eac195$export$b410431fab84fa58.play = (t)=>$b00d3e7401eac195$var$it(!0, t);
$b00d3e7401eac195$export$b410431fab84fa58.pause = (t)=>$b00d3e7401eac195$var$it(!1, t);
function $b00d3e7401eac195$var$kt(t) {
    var s;
    let { subscribe: o, getSnapshot: e, setProps: r } = (0, $acw62.useRef)($b00d3e7401eac195$var$It(t)).current;
    r(t);
    let a = (s = (0, $acw62.useSyncExternalStore)(o, e, e)) == null ? void 0 : s.slice();
    function l(f) {
        if (!a) return [];
        let c = new Map;
        return t.newestOnTop && a.reverse(), a.forEach((T)=>{
            let { position: g } = T.props;
            c.has(g) || c.set(g, []), c.get(g).push(T);
        }), Array.from(c, (T)=>f(T[0], T[1]));
    }
    return {
        getToastToRender: l,
        isToastActive: $b00d3e7401eac195$var$X,
        count: a == null ? void 0 : a.length
    };
}
function $b00d3e7401eac195$var$Nt(t) {
    let [o, e] = (0, $acw62.useState)(!1), [r, a] = (0, $acw62.useState)(!1), l = (0, $acw62.useRef)(null), s = (0, $acw62.useRef)({
        start: 0,
        delta: 0,
        removalDistance: 0,
        canCloseOnClick: !0,
        canDrag: !1,
        didMove: !1
    }).current, { autoClose: f, pauseOnHover: c, closeToast: T, onClick: g, closeOnClick: v } = t;
    $b00d3e7401eac195$var$Pt({
        id: t.toastId,
        containerId: t.containerId,
        fn: e
    }), (0, $acw62.useEffect)(()=>{
        if (t.pauseOnFocusLoss) return x(), ()=>{
            C();
        };
    }, [
        t.pauseOnFocusLoss
    ]);
    function x() {
        document.hasFocus() || p(), window.addEventListener("focus", d), window.addEventListener("blur", p);
    }
    function C() {
        window.removeEventListener("focus", d), window.removeEventListener("blur", p);
    }
    function S(m) {
        if (t.draggable === !0 || t.draggable === m.pointerType) {
            b();
            let _ = l.current;
            s.canCloseOnClick = !0, s.canDrag = !0, _.style.transition = "none", t.draggableDirection === "x" ? (s.start = m.clientX, s.removalDistance = _.offsetWidth * (t.draggablePercent / 100)) : (s.start = m.clientY, s.removalDistance = _.offsetHeight * (t.draggablePercent === 80 ? t.draggablePercent * 1.5 : t.draggablePercent) / 100);
        }
    }
    function E(m) {
        let { top: _, bottom: k, left: D, right: A } = l.current.getBoundingClientRect();
        m.pointerType === "mouse" && t.pauseOnHover && m.clientX >= D && m.clientX <= A && m.clientY >= _ && m.clientY <= k ? p() : d();
    }
    function d() {
        e(!0);
    }
    function p() {
        e(!1);
    }
    function b() {
        s.didMove = !1, document.addEventListener("pointermove", n), document.addEventListener("pointerup", u);
    }
    function i() {
        document.removeEventListener("pointermove", n), document.removeEventListener("pointerup", u);
    }
    function n(m) {
        let _ = l.current;
        if (s.canDrag && _) {
            s.didMove = !0, o && p(), t.draggableDirection === "x" ? s.delta = m.clientX - s.start : s.delta = m.clientY - s.start, s.start !== m.clientX && (s.canCloseOnClick = !1);
            let k = t.draggableDirection === "x" ? `${s.delta}px, var(--y)` : `0, calc(${s.delta}px + var(--y))`;
            _.style.transform = `translate3d(${k},0)`, _.style.opacity = `${1 - Math.abs(s.delta / s.removalDistance)}`;
        }
    }
    function u() {
        i();
        let m = l.current;
        if (s.canDrag && s.didMove && m) {
            if (s.canDrag = !1, Math.abs(s.delta) > s.removalDistance) {
                a(!0), t.closeToast(!0), t.collapseAll();
                return;
            }
            m.style.transition = "transform 0.2s, opacity 0.2s", m.style.removeProperty("transform"), m.style.removeProperty("opacity");
        }
    }
    let h = {
        onPointerDown: S,
        onPointerUp: E
    };
    return f && c && (h.onMouseEnter = p, t.stacked || (h.onMouseLeave = d)), v && (h.onClick = (m)=>{
        g && g(m), s.canCloseOnClick && T(!0);
    }), {
        playToast: d,
        pauseToast: p,
        isRunning: o,
        preventExitTransition: r,
        toastRef: l,
        eventHandlers: h
    };
}
var $b00d3e7401eac195$var$G = typeof window != "undefined" ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
var $b00d3e7401eac195$var$K = ({ theme: t, type: o, isLoading: e, ...r })=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        fill: t === "colored" ? "currentColor" : `var(--toastify-icon-color-${o})`,
        ...r
    });
function $b00d3e7401eac195$var$ro(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b00d3e7401eac195$var$K, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z"
    }));
}
function $b00d3e7401eac195$var$no(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b00d3e7401eac195$var$K, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z"
    }));
}
function $b00d3e7401eac195$var$io(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b00d3e7401eac195$var$K, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"
    }));
}
function $b00d3e7401eac195$var$lo(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b00d3e7401eac195$var$K, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z"
    }));
}
function $b00d3e7401eac195$var$fo() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "Toastify__spinner"
    });
}
var $b00d3e7401eac195$export$4f13f83fd8bb1dac = {
    info: $b00d3e7401eac195$var$no,
    warning: $b00d3e7401eac195$var$ro,
    success: $b00d3e7401eac195$var$io,
    error: $b00d3e7401eac195$var$lo,
    spinner: $b00d3e7401eac195$var$fo
}, $b00d3e7401eac195$var$co = (t)=>t in $b00d3e7401eac195$export$4f13f83fd8bb1dac;
function $b00d3e7401eac195$var$wt({ theme: t, type: o, isLoading: e, icon: r }) {
    let a = null, l = {
        theme: t,
        type: o
    };
    return r === !1 || ($b00d3e7401eac195$var$P(r) ? a = r({
        ...l,
        isLoading: e
    }) : (0, $acw62.isValidElement)(r) ? a = (0, $acw62.cloneElement)(r, l) : e ? a = $b00d3e7401eac195$export$4f13f83fd8bb1dac.spinner() : $b00d3e7401eac195$var$co(o) && (a = $b00d3e7401eac195$export$4f13f83fd8bb1dac[o](l))), a;
}
var $b00d3e7401eac195$var$Dt = (t)=>{
    let { isRunning: o, preventExitTransition: e, toastRef: r, eventHandlers: a, playToast: l } = $b00d3e7401eac195$var$Nt(t), { closeButton: s, children: f, autoClose: c, onClick: T, type: g, hideProgressBar: v, closeToast: x, transition: C, position: S, className: E, style: d, progressClassName: p, updateId: b, role: i, progress: n, rtl: u, toastId: h, deleteToast: m, isIn: _, isLoading: k, closeOnClick: D, theme: A, ariaLabel: B } = t, M = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("Toastify__toast", `Toastify__toast-theme--${A}`, `Toastify__toast--${g}`, {
        ["Toastify__toast--rtl"]: u
    }, {
        ["Toastify__toast--close-on-click"]: D
    }), $ = $b00d3e7401eac195$var$P(E) ? E({
        rtl: u,
        position: S,
        type: g,
        defaultClassName: M
    }) : (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(M, E), mt = $b00d3e7401eac195$var$wt(t), pt = !!n || !c, Z = {
        closeToast: x,
        type: g,
        theme: A
    }, V = null;
    return s === !1 || ($b00d3e7401eac195$var$P(s) ? V = s(Z) : (0, $acw62.isValidElement)(s) ? V = (0, $acw62.cloneElement)(s, Z) : V = $b00d3e7401eac195$var$gt(Z)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(C, {
        isIn: _,
        done: m,
        position: S,
        preventExitTransition: e,
        nodeRef: r,
        playToast: l
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        id: h,
        tabIndex: 0,
        onClick: T,
        "data-in": _,
        className: $,
        ...a,
        style: d,
        ref: r,
        ..._ && {
            role: i,
            "aria-label": B
        }
    }, mt != null && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("Toastify__toast-icon", {
            ["Toastify--animate-icon Toastify__zoom-enter"]: !k
        })
    }, mt), $b00d3e7401eac195$var$ot(f, t, !o), V, !t.customProgressBar && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b00d3e7401eac195$var$bt, {
        ...b && !pt ? {
            key: `p-${b}`
        } : {},
        rtl: u,
        theme: A,
        delay: c,
        isRunning: o,
        isIn: _,
        closeToast: x,
        hide: v,
        type: g,
        className: p,
        controlledProgress: pt,
        progress: n || 0
    })));
};
var $b00d3e7401eac195$var$j = (t, o = !1)=>({
        enter: `Toastify--animate Toastify__${t}-enter`,
        exit: `Toastify--animate Toastify__${t}-exit`,
        appendPosition: o
    }), $b00d3e7401eac195$export$d20e79fdc3899e95 = $b00d3e7401eac195$export$3ff7dc44d332d222($b00d3e7401eac195$var$j("bounce", !0)), $b00d3e7401eac195$export$d8dc01b5c85a37b9 = $b00d3e7401eac195$export$3ff7dc44d332d222($b00d3e7401eac195$var$j("slide", !0)), $b00d3e7401eac195$export$65cfd44a2050f99 = $b00d3e7401eac195$export$3ff7dc44d332d222($b00d3e7401eac195$var$j("zoom")), $b00d3e7401eac195$export$4d2fae537bd90431 = $b00d3e7401eac195$export$3ff7dc44d332d222($b00d3e7401eac195$var$j("flip"));
var $b00d3e7401eac195$var$vo = {
    position: "top-right",
    transition: $b00d3e7401eac195$export$d20e79fdc3899e95,
    autoClose: 5e3,
    closeButton: !0,
    pauseOnHover: !0,
    pauseOnFocusLoss: !0,
    draggable: "touch",
    draggablePercent: 80,
    draggableDirection: "x",
    role: "alert",
    theme: "light",
    "aria-label": "Notifications Alt+T",
    hotKeys: (t)=>t.altKey && t.code === "KeyT"
};
function $b00d3e7401eac195$var$dt(t) {
    let o = {
        ...$b00d3e7401eac195$var$vo,
        ...t
    }, e = t.stacked, [r, a] = (0, $acw62.useState)(!0), l = (0, $acw62.useRef)(null), { getToastToRender: s, isToastActive: f, count: c } = $b00d3e7401eac195$var$kt(o), { className: T, style: g, rtl: v, containerId: x, hotKeys: C } = o;
    function S(d) {
        let p = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("Toastify__toast-container", `Toastify__toast-container--${d}`, {
            ["Toastify__toast-container--rtl"]: v
        });
        return $b00d3e7401eac195$var$P(T) ? T({
            position: d,
            rtl: v,
            defaultClassName: p
        }) : (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(p, $b00d3e7401eac195$var$z(T));
    }
    function E() {
        e && (a(!0), $b00d3e7401eac195$export$b410431fab84fa58.play());
    }
    return $b00d3e7401eac195$var$G(()=>{
        var d;
        if (e) {
            let p = l.current.querySelectorAll('[data-in="true"]'), b = 12, i = (d = o.position) == null ? void 0 : d.includes("top"), n = 0, u = 0;
            Array.from(p).reverse().forEach((h, m)=>{
                let _ = h;
                _.classList.add("Toastify__toast--stacked"), m > 0 && (_.dataset.collapsed = `${r}`), _.dataset.pos || (_.dataset.pos = i ? "top" : "bot");
                let k = n * (r ? .2 : 1) + (r ? 0 : b * m), D = Math.max(.5, 1 - (r ? u : 0));
                _.style.setProperty("--y", `${i ? k : k * -1}px`), _.style.setProperty("--g", `${b}`), _.style.setProperty("--s", `${D}`), n += _.offsetHeight, u += .025;
            });
        }
    }, [
        r,
        c,
        e
    ]), (0, $acw62.useEffect)(()=>{
        function d(p) {
            var i;
            let b = l.current;
            C(p) && ((i = b == null ? void 0 : b.querySelector('[tabIndex="0"]')) == null || i.focus(), a(!1), $b00d3e7401eac195$export$b410431fab84fa58.pause()), p.key === "Escape" && (document.activeElement === b || b != null && b.contains(document.activeElement)) && (a(!0), $b00d3e7401eac195$export$b410431fab84fa58.play());
        }
        return document.addEventListener("keydown", d), ()=>{
            document.removeEventListener("keydown", d);
        };
    }, [
        C
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
        ref: l,
        className: "Toastify",
        id: x,
        onMouseEnter: ()=>{
            e && (a(!1), $b00d3e7401eac195$export$b410431fab84fa58.pause());
        },
        onMouseLeave: E,
        "aria-live": "polite",
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        "aria-label": o["aria-label"]
    }, s((d, p)=>{
        let b = p.length ? {
            ...g
        } : {
            ...g,
            pointerEvents: "none"
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            tabIndex: -1,
            className: S(d),
            "data-stacked": e,
            style: b,
            key: `c-${d}`
        }, p.map(({ content: i, props: n })=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b00d3e7401eac195$var$Dt, {
                ...n,
                stacked: e,
                collapseAll: E,
                isIn: f(n.toastId, n.containerId),
                key: `t-${n.key}`
            }, i)));
    }));
}
var $b00d3e7401eac195$var$Mt = `:root {
  --toastify-color-light: #fff;
  --toastify-color-dark: #121212;
  --toastify-color-info: #3498db;
  --toastify-color-success: #07bc0c;
  --toastify-color-warning: #f1c40f;
  --toastify-color-error: hsl(6, 78%, 57%);
  --toastify-color-transparent: rgba(255, 255, 255, 0.7);

  --toastify-icon-color-info: var(--toastify-color-info);
  --toastify-icon-color-success: var(--toastify-color-success);
  --toastify-icon-color-warning: var(--toastify-color-warning);
  --toastify-icon-color-error: var(--toastify-color-error);

  --toastify-container-width: fit-content;
  --toastify-toast-width: 320px;
  --toastify-toast-offset: 16px;
  --toastify-toast-top: max(var(--toastify-toast-offset), env(safe-area-inset-top));
  --toastify-toast-right: max(var(--toastify-toast-offset), env(safe-area-inset-right));
  --toastify-toast-left: max(var(--toastify-toast-offset), env(safe-area-inset-left));
  --toastify-toast-bottom: max(var(--toastify-toast-offset), env(safe-area-inset-bottom));
  --toastify-toast-background: #fff;
  --toastify-toast-padding: 14px;
  --toastify-toast-min-height: 64px;
  --toastify-toast-max-height: 800px;
  --toastify-toast-bd-radius: 6px;
  --toastify-toast-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  --toastify-font-family: sans-serif;
  --toastify-z-index: 9999;
  --toastify-text-color-light: #757575;
  --toastify-text-color-dark: #fff;

  /* Used only for colored theme */
  --toastify-text-color-info: #fff;
  --toastify-text-color-success: #fff;
  --toastify-text-color-warning: #fff;
  --toastify-text-color-error: #fff;

  --toastify-spinner-color: #616161;
  --toastify-spinner-color-empty-area: #e0e0e0;
  --toastify-color-progress-light: linear-gradient(to right, #4cd964, #5ac8fa, #007aff, #34aadc, #5856d6, #ff2d55);
  --toastify-color-progress-dark: #bb86fc;
  --toastify-color-progress-info: var(--toastify-color-info);
  --toastify-color-progress-success: var(--toastify-color-success);
  --toastify-color-progress-warning: var(--toastify-color-warning);
  --toastify-color-progress-error: var(--toastify-color-error);
  /* used to control the opacity of the progress trail */
  --toastify-color-progress-bgo: 0.2;
}

.Toastify__toast-container {
  z-index: var(--toastify-z-index);
  -webkit-transform: translate3d(0, 0, var(--toastify-z-index));
  position: fixed;
  width: var(--toastify-container-width);
  box-sizing: border-box;
  color: #fff;
  display: flex;
  flex-direction: column;
}

.Toastify__toast-container--top-left {
  top: var(--toastify-toast-top);
  left: var(--toastify-toast-left);
}
.Toastify__toast-container--top-center {
  top: var(--toastify-toast-top);
  left: 50%;
  transform: translateX(-50%);
  align-items: center;
}
.Toastify__toast-container--top-right {
  top: var(--toastify-toast-top);
  right: var(--toastify-toast-right);
  align-items: end;
}
.Toastify__toast-container--bottom-left {
  bottom: var(--toastify-toast-bottom);
  left: var(--toastify-toast-left);
}
.Toastify__toast-container--bottom-center {
  bottom: var(--toastify-toast-bottom);
  left: 50%;
  transform: translateX(-50%);
  align-items: center;
}
.Toastify__toast-container--bottom-right {
  bottom: var(--toastify-toast-bottom);
  right: var(--toastify-toast-right);
  align-items: end;
}

.Toastify__toast {
  --y: 0px;
  position: relative;
  touch-action: none;
  width: var(--toastify-toast-width);
  min-height: var(--toastify-toast-min-height);
  box-sizing: border-box;
  margin-bottom: 1rem;
  padding: var(--toastify-toast-padding);
  border-radius: var(--toastify-toast-bd-radius);
  box-shadow: var(--toastify-toast-shadow);
  max-height: var(--toastify-toast-max-height);
  font-family: var(--toastify-font-family);
  /* webkit only issue #791 */
  z-index: 0;
  /* inner swag */
  display: flex;
  flex: 1 auto;
  align-items: center;
  word-break: break-word;
}

@media only screen and (max-width: 480px) {
  .Toastify__toast-container {
    width: 100vw;
    left: env(safe-area-inset-left);
    margin: 0;
  }
  .Toastify__toast-container--top-left,
  .Toastify__toast-container--top-center,
  .Toastify__toast-container--top-right {
    top: env(safe-area-inset-top);
    transform: translateX(0);
  }
  .Toastify__toast-container--bottom-left,
  .Toastify__toast-container--bottom-center,
  .Toastify__toast-container--bottom-right {
    bottom: env(safe-area-inset-bottom);
    transform: translateX(0);
  }
  .Toastify__toast-container--rtl {
    right: env(safe-area-inset-right);
    left: initial;
  }
  .Toastify__toast {
    --toastify-toast-width: 100%;
    margin-bottom: 0;
    border-radius: 0;
  }
}

.Toastify__toast-container[data-stacked='true'] {
  width: var(--toastify-toast-width);
}

@media only screen and (max-width: 480px) {
  .Toastify__toast-container[data-stacked='true'] {
    width: 100vw;
  }
}

.Toastify__toast--stacked {
  position: absolute;
  width: 100%;
  transform: translate3d(0, var(--y), 0) scale(var(--s));
  transition: transform 0.3s;
}

.Toastify__toast--stacked[data-collapsed] .Toastify__toast-body,
.Toastify__toast--stacked[data-collapsed] .Toastify__close-button {
  transition: opacity 0.1s;
}

.Toastify__toast--stacked[data-collapsed='false'] {
  overflow: visible;
}

.Toastify__toast--stacked[data-collapsed='true']:not(:last-child) > * {
  opacity: 0;
}

.Toastify__toast--stacked:after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  height: calc(var(--g) * 1px);
  bottom: 100%;
}

.Toastify__toast--stacked[data-pos='top'] {
  top: 0;
}

.Toastify__toast--stacked[data-pos='bot'] {
  bottom: 0;
}

.Toastify__toast--stacked[data-pos='bot'].Toastify__toast--stacked:before {
  transform-origin: top;
}

.Toastify__toast--stacked[data-pos='top'].Toastify__toast--stacked:before {
  transform-origin: bottom;
}

.Toastify__toast--stacked:before {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100%;
  transform: scaleY(3);
  z-index: -1;
}

.Toastify__toast--rtl {
  direction: rtl;
}

.Toastify__toast--close-on-click {
  cursor: pointer;
}

.Toastify__toast-icon {
  margin-inline-end: 10px;
  width: 22px;
  flex-shrink: 0;
  display: flex;
}

.Toastify--animate {
  animation-fill-mode: both;
  animation-duration: 0.5s;
}

.Toastify--animate-icon {
  animation-fill-mode: both;
  animation-duration: 0.3s;
}

.Toastify__toast-theme--dark {
  background: var(--toastify-color-dark);
  color: var(--toastify-text-color-dark);
}

.Toastify__toast-theme--light {
  background: var(--toastify-color-light);
  color: var(--toastify-text-color-light);
}

.Toastify__toast-theme--colored.Toastify__toast--default {
  background: var(--toastify-color-light);
  color: var(--toastify-text-color-light);
}

.Toastify__toast-theme--colored.Toastify__toast--info {
  color: var(--toastify-text-color-info);
  background: var(--toastify-color-info);
}

.Toastify__toast-theme--colored.Toastify__toast--success {
  color: var(--toastify-text-color-success);
  background: var(--toastify-color-success);
}

.Toastify__toast-theme--colored.Toastify__toast--warning {
  color: var(--toastify-text-color-warning);
  background: var(--toastify-color-warning);
}

.Toastify__toast-theme--colored.Toastify__toast--error {
  color: var(--toastify-text-color-error);
  background: var(--toastify-color-error);
}

.Toastify__progress-bar-theme--light {
  background: var(--toastify-color-progress-light);
}

.Toastify__progress-bar-theme--dark {
  background: var(--toastify-color-progress-dark);
}

.Toastify__progress-bar--info {
  background: var(--toastify-color-progress-info);
}

.Toastify__progress-bar--success {
  background: var(--toastify-color-progress-success);
}

.Toastify__progress-bar--warning {
  background: var(--toastify-color-progress-warning);
}

.Toastify__progress-bar--error {
  background: var(--toastify-color-progress-error);
}

.Toastify__progress-bar-theme--colored.Toastify__progress-bar--info,
.Toastify__progress-bar-theme--colored.Toastify__progress-bar--success,
.Toastify__progress-bar-theme--colored.Toastify__progress-bar--warning,
.Toastify__progress-bar-theme--colored.Toastify__progress-bar--error {
  background: var(--toastify-color-transparent);
}

.Toastify__close-button {
  color: #fff;
  position: absolute;
  top: 6px;
  right: 6px;
  background: transparent;
  outline: none;
  border: none;
  padding: 0;
  cursor: pointer;
  opacity: 0.7;
  transition: 0.3s ease;
  z-index: 1;
}

.Toastify__toast--rtl .Toastify__close-button {
  left: 6px;
  right: unset;
}

.Toastify__close-button--light {
  color: #000;
  opacity: 0.3;
}

.Toastify__close-button > svg {
  fill: currentColor;
  height: 16px;
  width: 14px;
}

.Toastify__close-button:hover,
.Toastify__close-button:focus {
  opacity: 1;
}

@keyframes Toastify__trackProgress {
  0% {
    transform: scaleX(1);
  }
  100% {
    transform: scaleX(0);
  }
}

.Toastify__progress-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  opacity: 0.7;
  transform-origin: left;
}

.Toastify__progress-bar--animated {
  animation: Toastify__trackProgress linear 1 forwards;
}

.Toastify__progress-bar--controlled {
  transition: transform 0.2s;
}

.Toastify__progress-bar--rtl {
  right: 0;
  left: initial;
  transform-origin: right;
  border-bottom-left-radius: initial;
}

.Toastify__progress-bar--wrp {
  position: absolute;
  overflow: hidden;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 5px;
  border-bottom-left-radius: var(--toastify-toast-bd-radius);
  border-bottom-right-radius: var(--toastify-toast-bd-radius);
}

.Toastify__progress-bar--wrp[data-hidden='true'] {
  opacity: 0;
}

.Toastify__progress-bar--bg {
  opacity: var(--toastify-color-progress-bgo);
  width: 100%;
  height: 100%;
}

.Toastify__spinner {
  width: 20px;
  height: 20px;
  box-sizing: border-box;
  border: 2px solid;
  border-radius: 100%;
  border-color: var(--toastify-spinner-color-empty-area);
  border-right-color: var(--toastify-spinner-color);
  animation: Toastify__spin 0.65s linear infinite;
}

@keyframes Toastify__bounceInRight {
  from,
  60%,
  75%,
  90%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  from {
    opacity: 0;
    transform: translate3d(3000px, 0, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(-25px, 0, 0);
  }
  75% {
    transform: translate3d(10px, 0, 0);
  }
  90% {
    transform: translate3d(-5px, 0, 0);
  }
  to {
    transform: none;
  }
}

@keyframes Toastify__bounceOutRight {
  20% {
    opacity: 1;
    transform: translate3d(-20px, var(--y), 0);
  }
  to {
    opacity: 0;
    transform: translate3d(2000px, var(--y), 0);
  }
}

@keyframes Toastify__bounceInLeft {
  from,
  60%,
  75%,
  90%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    transform: translate3d(-3000px, 0, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(25px, 0, 0);
  }
  75% {
    transform: translate3d(-10px, 0, 0);
  }
  90% {
    transform: translate3d(5px, 0, 0);
  }
  to {
    transform: none;
  }
}

@keyframes Toastify__bounceOutLeft {
  20% {
    opacity: 1;
    transform: translate3d(20px, var(--y), 0);
  }
  to {
    opacity: 0;
    transform: translate3d(-2000px, var(--y), 0);
  }
}

@keyframes Toastify__bounceInUp {
  from,
  60%,
  75%,
  90%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  from {
    opacity: 0;
    transform: translate3d(0, 3000px, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(0, -20px, 0);
  }
  75% {
    transform: translate3d(0, 10px, 0);
  }
  90% {
    transform: translate3d(0, -5px, 0);
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}

@keyframes Toastify__bounceOutUp {
  20% {
    transform: translate3d(0, calc(var(--y) - 10px), 0);
  }
  40%,
  45% {
    opacity: 1;
    transform: translate3d(0, calc(var(--y) + 20px), 0);
  }
  to {
    opacity: 0;
    transform: translate3d(0, -2000px, 0);
  }
}

@keyframes Toastify__bounceInDown {
  from,
  60%,
  75%,
  90%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    transform: translate3d(0, -3000px, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(0, 25px, 0);
  }
  75% {
    transform: translate3d(0, -10px, 0);
  }
  90% {
    transform: translate3d(0, 5px, 0);
  }
  to {
    transform: none;
  }
}

@keyframes Toastify__bounceOutDown {
  20% {
    transform: translate3d(0, calc(var(--y) - 10px), 0);
  }
  40%,
  45% {
    opacity: 1;
    transform: translate3d(0, calc(var(--y) + 20px), 0);
  }
  to {
    opacity: 0;
    transform: translate3d(0, 2000px, 0);
  }
}

.Toastify__bounce-enter--top-left,
.Toastify__bounce-enter--bottom-left {
  animation-name: Toastify__bounceInLeft;
}

.Toastify__bounce-enter--top-right,
.Toastify__bounce-enter--bottom-right {
  animation-name: Toastify__bounceInRight;
}

.Toastify__bounce-enter--top-center {
  animation-name: Toastify__bounceInDown;
}

.Toastify__bounce-enter--bottom-center {
  animation-name: Toastify__bounceInUp;
}

.Toastify__bounce-exit--top-left,
.Toastify__bounce-exit--bottom-left {
  animation-name: Toastify__bounceOutLeft;
}

.Toastify__bounce-exit--top-right,
.Toastify__bounce-exit--bottom-right {
  animation-name: Toastify__bounceOutRight;
}

.Toastify__bounce-exit--top-center {
  animation-name: Toastify__bounceOutUp;
}

.Toastify__bounce-exit--bottom-center {
  animation-name: Toastify__bounceOutDown;
}

@keyframes Toastify__zoomIn {
  from {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }
  50% {
    opacity: 1;
  }
}

@keyframes Toastify__zoomOut {
  from {
    opacity: 1;
  }
  50% {
    opacity: 0;
    transform: translate3d(0, var(--y), 0) scale3d(0.3, 0.3, 0.3);
  }
  to {
    opacity: 0;
  }
}

.Toastify__zoom-enter {
  animation-name: Toastify__zoomIn;
}

.Toastify__zoom-exit {
  animation-name: Toastify__zoomOut;
}

@keyframes Toastify__flipIn {
  from {
    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
    animation-timing-function: ease-in;
    opacity: 0;
  }
  40% {
    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
    animation-timing-function: ease-in;
  }
  60% {
    transform: perspective(400px) rotate3d(1, 0, 0, 10deg);
    opacity: 1;
  }
  80% {
    transform: perspective(400px) rotate3d(1, 0, 0, -5deg);
  }
  to {
    transform: perspective(400px);
  }
}

@keyframes Toastify__flipOut {
  from {
    transform: translate3d(0, var(--y), 0) perspective(400px);
  }
  30% {
    transform: translate3d(0, var(--y), 0) perspective(400px) rotate3d(1, 0, 0, -20deg);
    opacity: 1;
  }
  to {
    transform: translate3d(0, var(--y), 0) perspective(400px) rotate3d(1, 0, 0, 90deg);
    opacity: 0;
  }
}

.Toastify__flip-enter {
  animation-name: Toastify__flipIn;
}

.Toastify__flip-exit {
  animation-name: Toastify__flipOut;
}

@keyframes Toastify__slideInRight {
  from {
    transform: translate3d(110%, 0, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, var(--y), 0);
  }
}

@keyframes Toastify__slideInLeft {
  from {
    transform: translate3d(-110%, 0, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, var(--y), 0);
  }
}

@keyframes Toastify__slideInUp {
  from {
    transform: translate3d(0, 110%, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, var(--y), 0);
  }
}

@keyframes Toastify__slideInDown {
  from {
    transform: translate3d(0, -110%, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, var(--y), 0);
  }
}

@keyframes Toastify__slideOutRight {
  from {
    transform: translate3d(0, var(--y), 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(110%, var(--y), 0);
  }
}

@keyframes Toastify__slideOutLeft {
  from {
    transform: translate3d(0, var(--y), 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(-110%, var(--y), 0);
  }
}

@keyframes Toastify__slideOutDown {
  from {
    transform: translate3d(0, var(--y), 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(0, 500px, 0);
  }
}

@keyframes Toastify__slideOutUp {
  from {
    transform: translate3d(0, var(--y), 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(0, -500px, 0);
  }
}

.Toastify__slide-enter--top-left,
.Toastify__slide-enter--bottom-left {
  animation-name: Toastify__slideInLeft;
}

.Toastify__slide-enter--top-right,
.Toastify__slide-enter--bottom-right {
  animation-name: Toastify__slideInRight;
}

.Toastify__slide-enter--top-center {
  animation-name: Toastify__slideInDown;
}

.Toastify__slide-enter--bottom-center {
  animation-name: Toastify__slideInUp;
}

.Toastify__slide-exit--top-left,
.Toastify__slide-exit--bottom-left {
  animation-name: Toastify__slideOutLeft;
  animation-timing-function: ease-in;
  animation-duration: 0.3s;
}

.Toastify__slide-exit--top-right,
.Toastify__slide-exit--bottom-right {
  animation-name: Toastify__slideOutRight;
  animation-timing-function: ease-in;
  animation-duration: 0.3s;
}

.Toastify__slide-exit--top-center {
  animation-name: Toastify__slideOutUp;
  animation-timing-function: ease-in;
  animation-duration: 0.3s;
}

.Toastify__slide-exit--bottom-center {
  animation-name: Toastify__slideOutDown;
  animation-timing-function: ease-in;
  animation-duration: 0.3s;
}

@keyframes Toastify__spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
`;
var $b00d3e7401eac195$var$$t = new Map, $b00d3e7401eac195$var$Rt = (t, o)=>{
    $b00d3e7401eac195$var$G(()=>{
        if (!t || typeof document == "undefined") return;
        let e = document, r = $b00d3e7401eac195$var$$t.get(e);
        if (r) {
            o && r.setAttribute("nonce", o);
            return;
        }
        let a = e.createElement("style");
        a.textContent = t, o && a.setAttribute("nonce", o), e.head.appendChild(a), $b00d3e7401eac195$var$$t.set(e, a);
    }, [
        o
    ]);
};
function $b00d3e7401eac195$export$f2815235e76a62b9(t) {
    return $b00d3e7401eac195$var$Rt($b00d3e7401eac195$var$Mt, t.nonce), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b00d3e7401eac195$var$dt, {
        ...t
    });
}



parcelRequire("acw62");


const $482ccd6e8e9b33b1$var$CustomToast = ({ type: type, message: message, closeToast: closeToast })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "toast-container",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "toast-icon",
                children: type === "success" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$f04a61298a47a40f), {
                    ic: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5a00847d48e39b4f$export$13b8539f4be0c), {
                        width: 15,
                        height: 15
                    }),
                    color: "feedback_success_50"
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$f04a61298a47a40f), {
                    ic: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b5ba81d287aab3e$export$7e7b259dce3cfe53), {
                        width: 15,
                        height: 15
                    }),
                    color: "feedback_error_50"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "toast-message",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                    appearance: "body-s-bold",
                    color: "primary-background",
                    children: message
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "toast-close",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$f04a61298a47a40f), {
                    ic: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4b407a2b367f43e3$export$48672c81f0c3f574), {}),
                    color: "none",
                    onClick: closeToast
                })
            })
        ]
    });
};
var $482ccd6e8e9b33b1$export$2e2bcd8739ae039 = $482ccd6e8e9b33b1$var$CustomToast;


const $0646ab069e0ffc07$var$ParentConsent = ()=>{
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [statusIcon, setStatusIcon] = (0, $acw62.useState)(null);
    const queryParams = new URLSearchParams(location.search);
    const code = queryParams.get("code");
    const state = queryParams.get("state");
    let tenantId = "";
    let consentMetaId = "";
    let secure_code_from_state = "";
    if (state) {
        const parts = state.split(":");
        tenantId = parts[0];
        consentMetaId = `${parts[0]}:${parts[1]}`;
        secure_code_from_state = parts[2];
    }
    (0, $acw62.useEffect)(()=>{
        const fetchData = async ()=>{
            if (tenantId && consentMetaId) {
                setLoading(true);
                setStatusIcon(null);
                try {
                    const status = await dispatch((0, $6eea01a75b53fee5$export$1b2979642431f51e)(consentMetaId, tenantId, code, state, secure_code_from_state));
                    if (status === 200) {
                        const captureStatus = await dispatch((0, $6eea01a75b53fee5$export$d6956a215d1fce9d)(tenantId, code, state));
                        if (captureStatus === 200 || captureStatus === 201) setStatusIcon("success");
                        else setStatusIcon("error");
                    } else if (status === 404) {
                        (0, $b00d3e7401eac195$export$b410431fab84fa58).error((props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482ccd6e8e9b33b1$export$2e2bcd8739ae039), {
                                ...props,
                                type: "error",
                                message: "Data Not Found."
                            }), {
                            icon: false
                        });
                        setStatusIcon("error");
                    } else {
                        (0, $b00d3e7401eac195$export$b410431fab84fa58).error((props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482ccd6e8e9b33b1$export$2e2bcd8739ae039), {
                                ...props,
                                type: "error",
                                message: "Something went wrong. Please try again."
                            }), {
                            icon: false
                        });
                        setStatusIcon("error");
                    }
                } catch (error) {
                    console.log("Unexpected error:", error);
                    (0, $b00d3e7401eac195$export$b410431fab84fa58).error((props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482ccd6e8e9b33b1$export$2e2bcd8739ae039), {
                            ...props,
                            type: "error",
                            message: "Something went wrong. Please try again."
                        }), {
                        icon: false
                    });
                    setStatusIcon("error");
                } finally{
                    setLoading(false);
                }
            }
        };
        fetchData();
    }, [
        tenantId,
        consentMetaId,
        dispatch
    ]);
    (0, $acw62.useEffect)(()=>{
        if (statusIcon === "error" || statusIcon === "success") {
            const timer = setTimeout(()=>{
                window.close();
            }, 5000);
            return ()=>clearTimeout(timer);
        }
    }, [
        statusIcon
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "pageConfig"
            }),
            (loading || statusIcon) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "overlay",
                children: [
                    loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "loader"
                    }),
                    statusIcon === "success" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "success-icon",
                        children: "\u2714"
                    }),
                    statusIcon === "error" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "error-icon",
                        children: "\u2716"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b00d3e7401eac195$export$f2815235e76a62b9), {
                position: "bottom-left",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                closeButton: false,
                toastClassName: ()=>"toast-wrapper",
                transition: (0, $b00d3e7401eac195$export$d8dc01b5c85a37b9)
            })
        ]
    });
};
var $0646ab069e0ffc07$export$2e2bcd8739ae039 = $0646ab069e0ffc07$var$ParentConsent;


/**
 * Apply decoded user-dashboard-theme payload (theme + typographySettings) to the DOM.
 * Matches partner portal save shape from UserDashboard.js.
 */ const $f9365a33f363598f$var$STYLE_ID = "portal-dashboard-theme-font";
const $f9365a33f363598f$var$CASCADE_STYLE_ID = "portal-dashboard-theme-cascade";
const $f9365a33f363598f$var$CSS_VARS = [
    "--portal-sidenav-bg",
    "--portal-table-header-bg",
    "--portal-card-bg",
    "--portal-page-bg",
    "--portal-card-font",
    "--portal-button-bg",
    "--portal-button-font",
    "--portal-link-font",
    "--portal-font-family",
    "--portal-font-size",
    "--portal-font-weight",
    "--portal-font-style",
    "--portal-header-bg"
];
// Supports UTF-8 theme payloads (translated titles etc.) and legacy Latin1 base64
const $f9365a33f363598f$var$base64ToUtf8 = (b64)=>{
    const raw = atob(String(b64 ?? ""));
    try {
        return decodeURIComponent(escape(raw));
    } catch  {
        return raw;
    }
};
const $f9365a33f363598f$export$be17e2f99780cf70 = (themeBase64)=>{
    if (!themeBase64) return null;
    try {
        return JSON.parse($f9365a33f363598f$var$base64ToUtf8(themeBase64));
    } catch (err) {
        console.error("Failed to decode portal theme:", err);
        return null;
    }
};
const $f9365a33f363598f$export$bcf5ddda9eb40971 = (typographyBase64)=>{
    if (!typographyBase64) return null;
    try {
        return JSON.parse($f9365a33f363598f$var$base64ToUtf8(typographyBase64));
    } catch (err) {
        console.error("Failed to decode portal typography:", err);
        return null;
    }
};
const $f9365a33f363598f$export$f8041d2359059a89 = (theme)=>{
    if (!theme || typeof theme !== "object") return false;
    const status = theme.status;
    if (!status) return true; // legacy payloads without status
    return String(status).toUpperCase() === "PUBLISHED";
};
const $f9365a33f363598f$var$clearPortalThemeFromDom = ()=>{
    if (typeof document === "undefined") return;
    const root = document.documentElement;
    $f9365a33f363598f$var$CSS_VARS.forEach((name)=>root.style.removeProperty(name));
    const fontStyle = document.getElementById($f9365a33f363598f$var$STYLE_ID);
    if (fontStyle) fontStyle.remove();
    const cascadeStyle = document.getElementById($f9365a33f363598f$var$CASCADE_STYLE_ID);
    if (cascadeStyle) cascadeStyle.remove();
    if (document.body) {
        document.body.style.removeProperty("font-family");
        document.body.style.removeProperty("font-size");
        document.body.style.removeProperty("font-weight");
        document.body.style.removeProperty("font-style");
        document.body.classList.remove("portal-theme-applied");
    }
};
const $f9365a33f363598f$var$buildFontDataUrl = (typography)=>{
    if (!typography?.fontFile) return null;
    if (typography.fontFile.startsWith("data:")) return typography.fontFile;
    const mime = typography.fontMime || "application/octet-stream";
    return `data:${mime};base64,${typography.fontFile}`;
};
const $f9365a33f363598f$export$163b7a9b655fc3e2 = (portalTheme)=>{
    if (typeof document === "undefined") return;
    if (!portalTheme || !$f9365a33f363598f$export$f8041d2359059a89(portalTheme)) {
        $f9365a33f363598f$var$clearPortalThemeFromDom();
        return;
    }
    const root = document.documentElement;
    const colors = portalTheme.colors || {};
    const darkColors = portalTheme.darkColors || {};
    const useDark = !!portalTheme._previewDark;
    const palette = useDark && Object.keys(darkColors).length ? darkColors : colors;
    const pageBg = palette.cardBackground || (useDark ? "#000000" : "#FFFFFF");
    const adjust = (hex, percent)=>{
        if (!hex || !String(hex).startsWith("#")) return hex;
        const num = parseInt(String(hex).replace("#", ""), 16);
        if (Number.isNaN(num)) return hex;
        const r = Math.max(0, Math.min(255, (num >> 16) + Math.round(percent * 255 / 100)));
        const g = Math.max(0, Math.min(255, (num >> 8 & 0xff) + Math.round(percent * 255 / 100)));
        const b = Math.max(0, Math.min(255, (num & 0xff) + Math.round(percent * 255 / 100)));
        return `#${(r << 16 | g << 8 | b).toString(16).padStart(6, "0").toUpperCase()}`;
    };
    // Card background owns the screen; sidenav/header/table are slight variations
    const sidenavBg = portalTheme.sidenav && !useDark ? portalTheme.sidenav : adjust(pageBg, useDark ? 14 : -6);
    const tableHeaderBg = portalTheme.tableHeader && !useDark ? portalTheme.tableHeader : adjust(pageBg, useDark ? 22 : -8);
    const headerBg = adjust(pageBg, useDark ? 10 : -4);
    if (sidenavBg) root.style.setProperty("--portal-sidenav-bg", sidenavBg);
    if (tableHeaderBg) root.style.setProperty("--portal-table-header-bg", tableHeaderBg);
    if (pageBg) {
        root.style.setProperty("--portal-card-bg", pageBg);
        root.style.setProperty("--portal-page-bg", pageBg);
        root.style.setProperty("--portal-header-bg", headerBg || pageBg);
    }
    if (palette.cardFont) root.style.setProperty("--portal-card-font", palette.cardFont);
    if (palette.buttonBackground) root.style.setProperty("--portal-button-bg", palette.buttonBackground);
    if (palette.buttonFont) root.style.setProperty("--portal-button-font", palette.buttonFont);
    if (palette.linkFont) root.style.setProperty("--portal-link-font", palette.linkFont);
    const typography = portalTheme.typography?.ENGLISH || {};
    const family = typography.fontFamily || (typography.fontFile ? "PortalCustomFont" : "");
    const fontSize = typography.fontSize != null ? `${typography.fontSize}`.replace(/px$/i, "") + "px" : "14px";
    const fontWeight = typography.fontWeight || "400";
    const fontStyle = typography.fontStyle || "normal";
    const fontSrc = $f9365a33f363598f$var$buildFontDataUrl(typography);
    if (fontSrc && family) {
        let style = document.getElementById($f9365a33f363598f$var$STYLE_ID);
        if (!style) {
            style = document.createElement("style");
            style.id = $f9365a33f363598f$var$STYLE_ID;
            document.head.appendChild(style);
        }
        const safeFamily = String(family).replace(/'/g, "\\'");
        style.textContent = `
      @font-face {
        font-family: '${safeFamily}';
        src: url('${fontSrc}');
        font-weight: ${fontWeight};
        font-style: ${fontStyle};
        font-display: swap;
      }
    `;
        root.style.setProperty("--portal-font-family", `'${safeFamily}', system-ui, sans-serif`);
    } else if (family) {
        const safeFamily = String(family).replace(/'/g, "\\'");
        root.style.setProperty("--portal-font-family", `'${safeFamily}', system-ui, sans-serif`);
    }
    root.style.setProperty("--portal-font-size", fontSize);
    root.style.setProperty("--portal-font-weight", fontWeight);
    root.style.setProperty("--portal-font-style", fontStyle);
    let cascade = document.getElementById($f9365a33f363598f$var$CASCADE_STYLE_ID);
    if (!cascade) {
        cascade = document.createElement("style");
        cascade.id = $f9365a33f363598f$var$CASCADE_STYLE_ID;
        document.head.appendChild(cascade);
    }
    cascade.textContent = `
    body.portal-theme-applied {
      font-family: var(--portal-font-family, inherit);
      font-size: var(--portal-font-size, 14px);
      font-weight: var(--portal-font-weight, 400);
      font-style: var(--portal-font-style, normal);
    }
    body.portal-theme-applied *:not(svg):not(path):not(circle):not(rect):not(line):not(polyline):not(polygon) {
      font-family: inherit;
      font-style: inherit;
    }
    body.portal-theme-applied a,
    body.portal-theme-applied .portal-themed-link {
      color: var(--portal-link-font, inherit);
    }
    body.portal-theme-applied .sideBar-menu-click.active {
      background-color: var(--portal-button-bg, #fff) !important;
    }
    body.portal-theme-applied .sideBar-menu-click.active [class*="jds-text"],
    body.portal-theme-applied .sideBar-menu-click.active .jds-text {
      color: var(--portal-button-font, inherit) !important;
    }
    body.portal-theme-applied .status-card,
    body.portal-theme-applied .fiduciaryHeaderContainer {
      color: var(--portal-card-font, inherit);
    }
    body.portal-theme-applied button[class*="jds"],
    body.portal-theme-applied .jds-button-primary {
      background-color: var(--portal-button-bg, inherit);
      color: var(--portal-button-font, inherit);
    }
  `;
    if (document.body) {
        document.body.classList.add("portal-theme-applied");
        if (root.style.getPropertyValue("--portal-font-family")) document.body.style.fontFamily = "var(--portal-font-family)";
        document.body.style.fontSize = "var(--portal-font-size)";
        document.body.style.fontWeight = "var(--portal-font-weight)";
        document.body.style.fontStyle = "var(--portal-font-style)";
    }
};


const $6eea01a75b53fee5$var$uuidv4 = ()=>{
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0, v = c == "x" ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
};
const $6eea01a75b53fee5$export$27a2fc8f71b19442 = (businessId)=>{
    return async (dispatch, getState)=>{
        const tenant_id = getState().common.tenant_id;
        let secure_code = getState().common.secure_id;
        try {
            const headers = {
                txn: $6eea01a75b53fee5$var$uuidv4(),
                "tenant-id": tenant_id,
                "X-Secure-Code": secure_code
            };
            const body = {};
            const url = `${(0, $d27dbe10f1bffb7d$export$2e2bcd8739ae039).getBusinessLogoByBusinessId}?businessId=${businessId}`;
            let response = await (0, $9810156153020e5d$export$bb173986169374ad)(url, "GET", body, headers);
            let re = response?.data?.searchList;
            const businessData = response?.data?.searchList?.[0];
            if (businessData?.configurationJson?.logo) dispatch({
                type: (0, $dee2f92127058cd3$export$c81870bc2191aec7),
                payload: businessData?.configurationJson?.logo
            });
            // return businessData;
            return re;
        } catch (error) {
            throw error;
        }
    };
};
const $6eea01a75b53fee5$export$b35eea761c43ace8 = ()=>{
    return async (dispatch, getState)=>{
        const tenant_id = getState().common.tenant_id;
        const business_id = getState().common.business_id;
        const secure_code = getState().common.secure_id;
        if (!tenant_id || !business_id) return null;
        try {
            const headers = {
                Accept: "application/json",
                txn: $6eea01a75b53fee5$var$uuidv4(),
                "tenant-id": tenant_id,
                "business-id": business_id,
                ...secure_code ? {
                    "X-Secure-Code": secure_code
                } : {}
            };
            const response = await (0, $9810156153020e5d$export$bb173986169374ad)((0, $d27dbe10f1bffb7d$export$2e2bcd8739ae039).user_dashboard_theme_get, "GET", {}, headers);
            // Support both flat and wrapped API envelopes
            const data = response?.data?.data || response?.data || {};
            const themeRaw = data.theme;
            const typographyRaw = data.typographySettings;
            const decodedTheme = (0, $f9365a33f363598f$export$be17e2f99780cf70)(themeRaw);
            const decodedTypography = (0, $f9365a33f363598f$export$bcf5ddda9eb40971)(typographyRaw);
            if (!decodedTheme && !decodedTypography) {
                dispatch({
                    type: (0, $dee2f92127058cd3$export$8754a668aecb2a04),
                    payload: null
                });
                return null;
            }
            // Draft (and non-published) themes stay partner-only
            if (decodedTheme && !(0, $f9365a33f363598f$export$f8041d2359059a89)(decodedTheme)) {
                dispatch({
                    type: (0, $dee2f92127058cd3$export$8754a668aecb2a04),
                    payload: null
                });
                return null;
            }
            const portalTheme = {
                ...decodedTheme || {},
                typography: decodedTypography || null
            };
            dispatch({
                type: (0, $dee2f92127058cd3$export$8754a668aecb2a04),
                payload: portalTheme
            });
            // Branding logo only when toggle is on; otherwise keep system-config logo
            if (decodedTheme?.displayLogoInHeader && decodedTheme?.logo) dispatch({
                type: (0, $dee2f92127058cd3$export$c81870bc2191aec7),
                payload: decodedTheme.logo
            });
            return portalTheme;
        } catch (error) {
            console.log("Failed to load user dashboard theme:", error);
            return null;
        }
    };
};
const $6eea01a75b53fee5$export$7ff2f08ac86399e2 = async (cusId, tenantId, secure_code)=>{
    try {
        const headers = {
            txn: $6eea01a75b53fee5$var$uuidv4(),
            "tenant-id": tenantId,
            "X-Secure-Code": secure_code,
            Accept: "*/*"
        };
        const body = {};
        const url = `${(0, $d27dbe10f1bffb7d$export$2e2bcd8739ae039).getConsentsByCustomerId}?customerIdentifiers.value=${cusId}`;
        let response = await (0, $9810156153020e5d$export$bb173986169374ad)(url, "GET", body, headers);
        let re = response?.data?.searchList;
        return re;
    } catch (error) {
        throw error;
    }
};
const $6eea01a75b53fee5$export$b2b0abb095842b3c = (consentId)=>{
    return async (dispatch, getState)=>{
        let tenant_id = getState().common.tenant_id;
        let secure_code = getState().common.secure_id;
        try {
            const headers = {
                "tenant-id": tenant_id,
                Accept: "*/*",
                txn: $6eea01a75b53fee5$var$uuidv4(),
                "X-Secure-Code": secure_code
            };
            const body = {};
            const url = `${(0, $d27dbe10f1bffb7d$export$2e2bcd8739ae039).getConsentsByTemplateId}?consentId=${consentId}`;
            let response = await (0, $9810156153020e5d$export$bb173986169374ad)(url, "GET", body, headers);
            return response?.data?.searchList;
        } catch (error) {
            console.log(" Error fetching consent by ID:", error);
            throw error;
        }
    };
};
const $6eea01a75b53fee5$export$8010e91ba8c855a9 = (consentHandleId)=>{
    return async (dispatch, getState)=>{
        let tenant_id = getState().common.tenant_id;
        let secure_code = getState().common.secure_id;
        try {
            const headers = {
                "tenant-id": tenant_id,
                Accept: "*/*",
                txn: $6eea01a75b53fee5$var$uuidv4(),
                "X-Secure-Code": secure_code
            };
            const body = {};
            const url = `${(0, $d27dbe10f1bffb7d$export$2e2bcd8739ae039).getConsentHandleById}${consentHandleId}`;
            let response = await (0, $9810156153020e5d$export$bb173986169374ad)(url, "GET", body, headers);
            return response?.data;
        } catch (error) {
            console.log(" Error fetching consent by ID:", error);
            throw error;
        }
    };
};
const $6eea01a75b53fee5$export$1b2979642431f51e = (parentconsentMetaId, tenantId, code, state, secure_code_from_state)=>{
    return async (dispatch, getState)=>{
        let tenant_id = tenantId;
        let secure_code = secure_code_from_state;
        try {
            const headers = {
                consentMetaId: parentconsentMetaId,
                "tenant-id": tenant_id,
                txn: $6eea01a75b53fee5$var$uuidv4(),
                "X-Secure-Code": secure_code
            };
            const body = {};
            const url = `${(0, $d27dbe10f1bffb7d$export$2e2bcd8739ae039).metaurl}${parentconsentMetaId}`;
            let response = await (0, $9810156153020e5d$export$bb173986169374ad)(url, "GET", body, headers);
            if (response?.status === 200) {
                dispatch({
                    type: (0, $dee2f92127058cd3$export$6027aad055c44279),
                    payload: response?.data
                });
                dispatch({
                    type: (0, $dee2f92127058cd3$export$8a030116ef1d058b),
                    payload: code
                });
                dispatch({
                    type: (0, $dee2f92127058cd3$export$aa27936551104482),
                    payload: state
                });
            }
            return response?.status;
        } catch (error) {
            console.log(" Error fetching consent by consentMetaId:", error);
            throw error;
        }
    };
};
const $6eea01a75b53fee5$export$d6956a215d1fce9d = (tenantId, code, state)=>{
    return async (dispatch, getState)=>{
        const meta = getState().common.parentConsentMetaData;
        let tenant_id = tenantId;
        try {
            const headers = {
                "tenant-id": tenant_id,
                txn: $6eea01a75b53fee5$var$uuidv4(),
                "X-Secure-Code": meta?.secId
            };
            const body = {
                consentHandleId: meta?.consentHandleId,
                languagePreferences: meta?.languagePreference,
                preferencesStatus: meta?.preferencesStatus,
                isParentalConsent: true,
                parentalKYCType: "DIGILOCKER",
                code: code,
                state: state
            };
            let response = await (0, $9810156153020e5d$export$bb173986169374ad)((0, $d27dbe10f1bffb7d$export$2e2bcd8739ae039).createParentalConsent, "POST", body, headers);
            return response?.status;
        } catch (error) {
            console.log(" Error fetching consent by consentMetaId:", error);
            throw error;
        }
    };
};
const $6eea01a75b53fee5$export$12697f183ed46e90 = (selectedConsentId, selectedLanguagePreferences, selectedPrefereneces, status)=>{
    return async (dispatch, getState)=>{
        let tenant_id = getState().common.tenant_id;
        let secure_code = getState().common.secure_id;
        try {
            const headers = {
                "tenant-id": tenant_id,
                Accept: "*/*",
                txn: $6eea01a75b53fee5$var$uuidv4(),
                "X-Secure-Code": secure_code
            };
            const body = {
                languagePreferences: selectedLanguagePreferences,
                preferencesStatus: selectedPrefereneces,
                status: status
            };
            const url = `${(0, $d27dbe10f1bffb7d$export$2e2bcd8739ae039).withdrawConsentByConsentId}${selectedConsentId}`;
            let response = await (0, $9810156153020e5d$export$bb173986169374ad)(url, "PUT", body, headers);
            return response;
        } catch (error) {
            console.log(" Error fetching consent by ID:", error);
            throw error;
        }
    };
};
const $6eea01a75b53fee5$export$39ac483db754750 = (selectedConsentId, selectedLanguagePreferences, selectedPrefereneces, status)=>{
    return async (dispatch, getState)=>{
        let tenant_id = getState().common.tenant_id;
        let secure_code = getState().common.secure_id;
        try {
            const headers = {
                "tenant-id": tenant_id,
                Accept: "*/*",
                txn: $6eea01a75b53fee5$var$uuidv4(),
                "X-Secure-Code": secure_code
            };
            const body = {
                languagePreferences: selectedLanguagePreferences,
                preferencesStatus: selectedPrefereneces,
                status: "ACTIVE"
            };
            const url = `${(0, $d27dbe10f1bffb7d$export$2e2bcd8739ae039).withdrawConsentByConsentId}${selectedConsentId}`;
            let response = await (0, $9810156153020e5d$export$bb173986169374ad)(url, "PUT", body, headers);
            return response;
        } catch (error) {
            console.log(" Error fetching consent by ID:", error);
            throw error;
        }
    };
};
const $6eea01a75b53fee5$export$2212ba0d271add57 = (selectedConsentId, selectedLanguagePreferences, selectedPrefereneces, status)=>{
    return async (dispatch, getState)=>{
        let tenant_id = getState().common.tenant_id;
        let secure_code = getState().common.secure_id;
        try {
            const headers = {
                "tenant-id": tenant_id,
                Accept: "*/*",
                txn: $6eea01a75b53fee5$var$uuidv4(),
                "X-Secure-Code": secure_code
            };
            const body = {
                consentHandleId: selectedConsentId,
                languagePreference: selectedLanguagePreferences,
                preferencesStatus: selectedPrefereneces
            };
            let response = await (0, $9810156153020e5d$export$bb173986169374ad)((0, $d27dbe10f1bffb7d$export$2e2bcd8739ae039).createConsent, "POST", body, headers);
            return response;
        } catch (error) {
            console.log(" Error fetching consent by ID:", error);
            throw error;
        }
    };
};
const $6eea01a75b53fee5$export$78d225ba46c95956 = ()=>{
    return async (dispatch, getState)=>{
        let tenant_id = getState().common.tenant_id;
        let business_id = getState().common.business_id;
        let secure_code = getState().common.secure_id;
        try {
            const headers = {
                tenantid: tenant_id,
                businessid: business_id,
                "Content-Type": "application/json",
                txn: $6eea01a75b53fee5$var$uuidv4(),
                "X-Secure-Code": secure_code
            };
            const body = {
                scopeLevel: "BUSINESS",
                config: {
                    provider: "BHASHINI",
                    apiBaseUrl: "https://meity-auth.ulcacontrib.org",
                    modelPipelineEndpoint: "/ulca/apis/v0/model/getModelsPipeline",
                    callbackUrl: "https://dhruva-api.bhashini.gov.in/services/inference/pipeline",
                    userId: "02c3fec39bbf46cda8ece45ba52e78cb",
                    apiKey: "058a0399da-ea84-4077-9e3e-984ff46f8b77",
                    pipelineId: "64392f96daac500b55c543cd"
                }
            };
            const response = await fetch((0, $d27dbe10f1bffb7d$export$2e2bcd8739ae039).translateConfig, {
                method: "POST",
                headers: headers,
                body: JSON.stringify(body)
            });
            const data = await response.json();
            if (!response.ok) {
                const errMsg = data?.errorMsg || data?.message || `Error ${response.status}: ${JSON.stringify(data)}`;
                throw new Error(errMsg);
            }
            return data;
        } catch (error) {
            console.log("Error fetching consent by ID:", error);
            throw error;
        }
    };
};
const $6eea01a75b53fee5$export$7d0f208153a27d67 = (currentLangCode, targetLang, finalInputs)=>{
    return async (dispatch, getState)=>{
        let tenant_id = getState().common.tenant_id;
        let business_id = getState().common.business_id;
        let secure_code = getState().common.secure_id;
        try {
            const headers = {
                "Content-Type": "application/json",
                tenantid: tenant_id,
                businessid: business_id,
                Accept: "*/*",
                txn: $6eea01a75b53fee5$var$uuidv4(),
                "X-Secure-Code": secure_code
            };
            const body = {
                configId: "e66b0624-61fb-44e9-b087-8bb312b5387b",
                provider: "BHASHINI",
                source: "CONSENTPOPUP",
                language: {
                    sourceLanguage: currentLangCode,
                    targetLanguage: targetLang
                },
                input: finalInputs
            };
            let response = await (0, $9810156153020e5d$export$bb173986169374ad)((0, $d27dbe10f1bffb7d$export$2e2bcd8739ae039).translateInputs, "POST", body, headers);
            return response;
        } catch (error) {
            console.log("Error fetching consent by ID:", error);
            throw error;
        }
    };
};
const $6eea01a75b53fee5$export$5aa62db8a1a167b3 = (docId)=>{
    return async (dispatch, getState)=>{
        const tenant_id = getState().common.tenant_id;
        let secure_code = getState().common.secure_id;
        try {
            const headers = {
                "tenant-id": tenant_id,
                Accept: "*/*",
                txn: $6eea01a75b53fee5$var$uuidv4(),
                "X-Secure-Code": secure_code
            };
            const url = `${(0, $d27dbe10f1bffb7d$export$2e2bcd8739ae039).fetchDocumentById}${docId}`;
            const response = await fetch(url, {
                method: "GET",
                headers: headers
            });
            if (!response.ok) throw new Error(`Failed to fetch document: ${response.status}`);
            const blob = await response.blob();
            return blob;
        } catch (error) {
            console.log("Error fetching document by ID:", error);
            throw error;
        }
    };
};
const $6eea01a75b53fee5$export$530d27bddecbf714 = (cusId, tntId, bsnId, gtId, scCode, recievedCallBackUrl)=>{
    return async (dispatch, getState)=>{
        let customerId = cusId;
        let tenantId = tntId;
        let businessId = bsnId;
        let grievanceTemplateId = gtId;
        let secureCode = scCode;
        let parentlCbUrl = recievedCallBackUrl;
        dispatch({
            type: (0, $dee2f92127058cd3$export$c829181dc407b03f),
            payload: {
                customerId: customerId,
                tenantId: tenantId,
                businessId: businessId,
                grievanceTemplateId: grievanceTemplateId,
                secureCode: secureCode,
                parentlCbUrl: parentlCbUrl
            }
        });
    };
};
const $6eea01a75b53fee5$export$6b4b986bcb95c892 = ()=>{
    return async (dispatch, getState)=>{
        let tenant_id = getState().common.tenant_id;
        let customer_id = getState().common.customer_id;
        let secure_code = getState().common.secure_id;
        try {
            const headers = {
                "tenant-id": tenant_id,
                Accept: "*/*",
                txn: $6eea01a75b53fee5$var$uuidv4(),
                "X-Secure-Code": secure_code
            };
            const body = {};
            const url = `${(0, $d27dbe10f1bffb7d$export$2e2bcd8739ae039).searchConsentHandleByCustomerId}?customerIdentifiers.value=${customer_id}`;
            let response = await (0, $9810156153020e5d$export$bb173986169374ad)(url, "GET", body, headers);
            return response?.data?.searchList;
        } catch (error) {
            console.log(" Error fetching consent by Customer Id:", error);
            throw error;
        }
    };
};
const $6eea01a75b53fee5$export$d8842388fb193136 = (businessId)=>{
    return async (dispatch, getState)=>{
        const tenant_id = getState().common.tenant_id;
        let secure_code = getState().common.secure_id;
        try {
            const headers = {
                "tenant-id": tenant_id,
                Accept: "*/*",
                txn: $6eea01a75b53fee5$var$uuidv4(),
                "X-Secure-Code": secure_code
            };
            const url = `${(0, $d27dbe10f1bffb7d$export$2e2bcd8739ae039).getBusinessDetailsByBusinessid}?businessId=${businessId}`;
            const response = await (0, $9810156153020e5d$export$bb173986169374ad)(url, "GET", {}, headers);
            const businessData = response?.data?.searchList?.[0];
            if (businessData?.name) dispatch({
                type: (0, $dee2f92127058cd3$export$9feaa1032f771c36),
                payload: businessData.name
            });
            return businessData;
        } catch (error) {
            console.log("Error fetching business Data:", error);
            throw error;
        }
    };
};
const $6eea01a75b53fee5$export$6a9543e1c857ef52 = ()=>{
    return async (dispatch, getState)=>{
        let tenant_id = getState().common.tenant_id;
        let business_id = getState().common.business_id;
        let grievanceTemplateId = getState().common.grievance_template_id;
        let secure_code = getState().common.secure_id;
        try {
            const headers = {
                "X-Tenant-ID": tenant_id,
                "X-Business-ID": business_id,
                "X-Transaction-ID": $6eea01a75b53fee5$var$uuidv4(),
                "X-Scope-Level": "TENANT",
                Accept: "application/json",
                "X-Secure-Code": secure_code
            };
            const body = {};
            const url = `${(0, $d27dbe10f1bffb7d$export$2e2bcd8739ae039).getGrievnaceTemplateDataById}/${grievanceTemplateId}`;
            let response = await (0, $9810156153020e5d$export$bb173986169374ad)(url, "GET", body, headers);
            return response;
        } catch (error) {
            throw error;
        }
    };
};
const $6eea01a75b53fee5$export$815763d6d21fa26e = ()=>{
    return async (dispatch, getState)=>{
        let tenant_id = getState().common.tenant_id;
        let business_id = getState().common.business_id;
        let secure_code = getState().common.secure_id;
        let grievanceTemplateId = getState().common.grievance_template_id;
        try {
            const headers = {
                "X-Tenant-ID": tenant_id,
                "X-Business-ID": business_id,
                "X-Transaction-ID": $6eea01a75b53fee5$var$uuidv4(),
                "X-Scope-Level": "TENANT",
                Accept: "application/json",
                "X-Secure-Code": secure_code
            };
            const body = {};
            const url = `${(0, $d27dbe10f1bffb7d$export$2e2bcd8739ae039).getGrievnaceTemplateData}?grievanceTemplateId=${grievanceTemplateId}`;
            let response = await (0, $9810156153020e5d$export$bb173986169374ad)(url, "GET", body, headers);
            let finalResponse = response?.data?.[0]?.multilingual?.userInformation?.[0]?.userItems;
            return finalResponse;
        } catch (error) {
            throw error;
        }
    };
};
const $6eea01a75b53fee5$export$455a512fa53a6e64 = (identity)=>{
    return async (dispatch, getState)=>{
        let tenant_id = getState().common.tenant_id;
        let business_id = getState().common.business_id;
        let secure_code = getState().common.secure_id;
        let grievanceTemplateId = getState().common.grievance_template_id;
        let customerIdentity = getState().common.customer_id;
        try {
            const headers = {
                "X-Tenant-ID": tenant_id,
                "X-Business-ID": business_id,
                "X-Transaction-ID": $6eea01a75b53fee5$var$uuidv4(),
                "X-Scope-Level": "TENANT",
                Accept: "application/json",
                "X-Secure-Code": secure_code
            };
            const body = {};
            const url = `${(0, $d27dbe10f1bffb7d$export$2e2bcd8739ae039).getGrievnaceRequest}?userDetails.${identity}=${customerIdentity}`;
            let response = await (0, $9810156153020e5d$export$bb173986169374ad)(url, "GET", body, headers);
            let finalResponse = response?.data?.[0]?.multilingual?.userInformation?.[0]?.userItems;
            return response;
        } catch (error) {
            throw error;
        }
    };
};
const $6eea01a75b53fee5$export$608685fe67c0820b = ()=>{
    return async (dispatch, getState)=>{
        let tenant_id = getState().common.tenant_id;
        let business_id = getState().common.business_id;
        let secure_code = getState().common.secure_id;
        try {
            const headers = {
                "X-Tenant-ID": tenant_id,
                "X-Business-ID": business_id,
                "X-Transaction-ID": $6eea01a75b53fee5$var$uuidv4(),
                "X-Scope-Level": "TENANT",
                Accept: "application/json",
                "X-Secure-Code": secure_code
            };
            const body = {};
            let response = await (0, $9810156153020e5d$export$bb173986169374ad)((0, $d27dbe10f1bffb7d$export$2e2bcd8739ae039).getGrievnaceRequest, "GET", body, headers);
            return response;
        } catch (error) {
            throw error;
        }
    };
};
const $6eea01a75b53fee5$export$14b19d7002b6d302 = (tenantId, businessId, grievanceTemplateId)=>{
    return async (dispatch, getState)=>{
        let secure_code = getState().common.secure_id;
        try {
            dispatch({
                type: (0, $dee2f92127058cd3$export$b2c0b9812d26261f),
                payload: {
                    tenantId: tenantId,
                    businessId: businessId,
                    grievanceTemplateId: grievanceTemplateId
                }
            });
            const headers = {
                "X-Tenant-ID": tenantId,
                "X-Business-ID": businessId,
                "X-Transaction-ID": $6eea01a75b53fee5$var$uuidv4(),
                "X-Scope-Level": "TENANT",
                Accept: "application/json",
                "X-Secure-Code": secure_code
            };
            const body = {};
            const response = await (0, $9810156153020e5d$export$bb173986169374ad)((0, $d27dbe10f1bffb7d$export$2e2bcd8739ae039).getGrievnaceRequest, "GET", body, headers);
            return response;
        } catch (error) {
            throw error;
        }
    };
};
const $6eea01a75b53fee5$export$51695d7c85207ef7 = (grievanceId)=>{
    return async (dispatch, getState)=>{
        let tenant_id = getState().common.tenant_id;
        let business_id = getState().common.business_id;
        let secure_code = getState().common.secure_id;
        try {
            const headers = {
                "X-Tenant-ID": tenant_id,
                "X-Business-ID": business_id,
                "X-Transaction-ID": $6eea01a75b53fee5$var$uuidv4(),
                "X-Scope-Level": "TENANT",
                Accept: "application/json",
                "X-Secure-Code": secure_code
            };
            const body = {};
            const url = `${(0, $d27dbe10f1bffb7d$export$2e2bcd8739ae039).getGrievnaceReq}/${grievanceId}`;
            let response = await (0, $9810156153020e5d$export$bb173986169374ad)(url, "GET", body, headers);
            return response;
        } catch (error) {
            throw error;
        }
    };
};
const $6eea01a75b53fee5$export$412e0b0e0a4fa73b = (grievanceId)=>{
    return async (dispatch, getState)=>{
        let tenant_id = getState().common.integration_tenant_id;
        let business_id = getState().common.integration_business_id;
        let secure_code = getState().common.secure_id;
        try {
            const headers = {
                "X-Tenant-ID": tenant_id,
                "X-Business-ID": business_id,
                "X-Transaction-ID": $6eea01a75b53fee5$var$uuidv4(),
                "X-Scope-Level": "TENANT",
                Accept: "application/json",
                "X-Secure-Code": secure_code
            };
            const body = {};
            const url = `${(0, $d27dbe10f1bffb7d$export$2e2bcd8739ae039).getGrievnaceRequest}/${grievanceId}`;
            let response = await (0, $9810156153020e5d$export$bb173986169374ad)(url, "GET", body, headers);
            return response;
        } catch (error) {
            throw error;
        }
    };
};
const $6eea01a75b53fee5$var$buildAttachmentFileFromSupportingDoc = (doc)=>{
    if (!doc) return null;
    if (doc.doc instanceof File) return doc.doc;
    return null;
};
const $6eea01a75b53fee5$export$7dc761133dcd61bc = ({ grievanceTemplateId: grievanceTemplateId, body: body, attachmentFile: attachmentFile })=>{
    return async (dispatch, getState)=>{
        const tenant_id = getState().common.tenant_id;
        const business_id = getState().common.business_id;
        const secure_code = getState().common.secure_id;
        const source = "USERPORTAL";
        try {
            const formData = new FormData();
            // "request" part MUST be application/json so the backend can parse it
            formData.append("request", JSON.stringify(body));
            // "attachments" part is the raw binary file
            if (attachmentFile) formData.append("attachments", attachmentFile);
            const headers = {
                // NO "Content-Type" here — browser sets multipart/form-data + boundary
                "X-Tenant-ID": tenant_id,
                "X-Business-ID": business_id,
                "X-Transaction-ID": $6eea01a75b53fee5$var$uuidv4(),
                "X-Scope-Level": "TENANT",
                "X-GRIEVANCE-TEMPLATE-ID": grievanceTemplateId,
                "X-Secure-Code": secure_code,
                "X-Source-ID": source,
                Accept: "*/*"
            };
            const response = await (0, $9810156153020e5d$export$bb173986169374ad)((0, $d27dbe10f1bffb7d$export$2e2bcd8739ae039).createGrievanceRequest, "POST", formData, headers);
            return response;
        } catch (error) {
            console.log("Error creating grievance request:", error);
            return error;
        }
    };
};
const $6eea01a75b53fee5$export$499d1caee87874d7 = ({ grievanceTemplateId: grievanceTemplateId, body: body, tenantId: tenantId, businessId: businessId, secureCode: secureCode })=>{
    return async (dispatch, getState)=>{
        let tenant_id = tenantId;
        let business_id = businessId;
        let secure_code = getState().common.secure_id;
        try {
            const headers = {
                "Content-Type": "application/json",
                "X-Tenant-ID": tenant_id,
                "X-Business-ID": business_id,
                "X-Transaction-ID": $6eea01a75b53fee5$var$uuidv4(),
                "X-Scope-Level": "TENANT",
                "X-GRIEVANCE-TEMPLATE-ID": grievanceTemplateId,
                "X-Secure-Code": secureCode,
                Accept: "*/*"
            };
            let response = await (0, $9810156153020e5d$export$bb173986169374ad)((0, $d27dbe10f1bffb7d$export$2e2bcd8739ae039).createGrievanceRequest, "POST", body, headers);
            return response;
        } catch (error) {
            console.log(" Error creating grievance request:", error);
            return error;
        }
    };
};
const $6eea01a75b53fee5$export$2e667524e0c28366 = (tenantId, businessId, integrationGrievanceTemplateId, secureCode)=>{
    return async (dispatch, getState)=>{
        let tenant_id = tenantId;
        let business_id = businessId;
        let grievanceTemplateId = integrationGrievanceTemplateId;
        try {
            const headers = {
                "X-Tenant-ID": tenant_id,
                "X-Business-ID": business_id,
                "X-Transaction-ID": $6eea01a75b53fee5$var$uuidv4(),
                "X-Scope-Level": "TENANT",
                Accept: "application/json",
                "X-Secure-Code": secureCode
            };
            const body = {};
            const url = `${(0, $d27dbe10f1bffb7d$export$2e2bcd8739ae039).getGrievnaceTemplateData}/${grievanceTemplateId}`;
            let response = await (0, $9810156153020e5d$export$bb173986169374ad)(url, "GET", body, headers);
            return response;
        } catch (error) {
            throw error;
        }
    };
};
const $6eea01a75b53fee5$export$70084a25e4847b62 = ({ grievanceId: grievanceId, newRating: newRating })=>{
    return async (dispatch, getState)=>{
        let tenant_id = getState().common.tenant_id;
        let business_id = getState().common.business_id;
        let secure_code = getState().common.secure_id;
        try {
            const headers = {
                "Content-Type": "application/json",
                "X-Tenant-ID": tenant_id,
                "X-Business-ID": business_id,
                "X-Transaction-ID": $6eea01a75b53fee5$var$uuidv4(),
                "X-Scope-Level": "TENANT",
                "X-Secure-Code": secure_code,
                Accept: "*/*"
            };
            const url = `${(0, $d27dbe10f1bffb7d$export$2e2bcd8739ae039).createGrievanceFeedback}/${grievanceId}/feedback`;
            const body = {
                feedback: newRating
            };
            let response = await (0, $9810156153020e5d$export$bb173986169374ad)(url, "PUT", body, headers);
            return response;
        } catch (error) {
            console.log(" Error creating grievance request:", error);
            return error;
        }
    };
};
const $6eea01a75b53fee5$export$494cd92f20bd53b8 = ({ grievanceId: grievanceId, newRating: newRating })=>{
    return async (dispatch, getState)=>{
        let tenant_id = getState().common.integration_tenant_id;
        let business_id = getState().common.integration_business_id;
        let secure_code = getState().common.secure_id;
        try {
            const headers = {
                "Content-Type": "application/json",
                "X-Tenant-ID": tenant_id,
                "X-Business-ID": business_id,
                "X-Transaction-ID": $6eea01a75b53fee5$var$uuidv4(),
                "X-Scope-Level": "TENANT",
                Accept: "*/*",
                "X-Secure-Code": secure_code
            };
            const url = `${(0, $d27dbe10f1bffb7d$export$2e2bcd8739ae039).createGrievanceFeedback}/${grievanceId}/feedback`;
            const body = {
                feedback: newRating
            };
            let response = await (0, $9810156153020e5d$export$bb173986169374ad)(url, "PUT", body, headers);
            return response;
        } catch (error) {
            console.log(" Error creating grievance request:", error);
            return error;
        }
    };
};
const $6eea01a75b53fee5$export$9b0d6ab01c55202e = ()=>{
    return async (dispatch, getState)=>{
        let tenant_id = getState().common.tenant_id;
        let business_id = getState().common.business_id;
        let secure_code = getState().common.secure_id;
        try {
            const headers = {
                txn: $6eea01a75b53fee5$var$uuidv4(),
                "tenant-id": tenant_id,
                "x-session-token": "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJpc3MiOiJwYXJ0bmVyLXBvcnRhbCIsInRlbmFudElkIjoiNTg5Yzk1YzYtNGJiOC00Njc4LThjMGItYzE1YzczNmNiNDZkIiwic3ViIjoiMzA1NWEwNDItOTFkZi00MWI2LWIxZDMtNDc2YWM5M2ZiNGM2IiwiZXhwIjoxNzYxODg4ODc4LCJpYXQiOjE3NjE4ODUyNzh9.bLREZVmrQrIwxxvIj0BjFmfa9wUiwtbu9GqXmQcmfaznl8UMAuhFq3OEVEKC4wXTh6Ahk_2uwUs0_EmN_wtBc2gVmrZ7tESijFTUPlelzm3NExFXfMR6HcfQxyyvkcZh9Ih_JqEgpJG0akQDdjK0tUd--usZMhFz069T-h5PavvCl6hODDxCwNEtJCWWo0RJ3YEkj6JTjvSRkbIvFULjrA8Qd0uj_31UswcKWheInajoNG-rhEwYO62hpbxFw7svJFDd4whY5JtfXWSV5jC1l1-zy5HaFYn8_q9Euf-S7FP6zCICqGQ7cIK5bgstJhV2QsvdZE6SpRnuabRznzkucg",
                Accept: "application/json",
                "X-Secure-Code": secure_code
            };
            const body = {};
            let response = await (0, $9810156153020e5d$export$bb173986169374ad)((0, $d27dbe10f1bffb7d$export$2e2bcd8739ae039).getDigilockerDetails, "GET", body, headers);
            return response;
        } catch (error) {
            console.log(" Error in fetching digilocker details:", error);
            return error;
        }
    };
};
const $6eea01a75b53fee5$export$f71b29283611213f = (selectedConsentId, selectedLanguagePreferences, selectedPrefereneces, relationship)=>{
    return async (dispatch, getState)=>{
        let tenant_id = getState().common.tenant_id;
        let business_id = getState().common.business_id;
        let secure_code = getState().common.secure_id;
        try {
            const headers = {
                txn: $6eea01a75b53fee5$var$uuidv4(),
                "Content-Type": "application/json",
                "tenant-id": tenant_id,
                "X-Secure-Code": secure_code
            };
            const body = {
                consentHandleId: selectedConsentId,
                preferencesStatus: selectedPrefereneces,
                languagePreferences: selectedLanguagePreferences,
                isParentalConsent: true,
                secId: secure_code,
                relation: relationship
            };
            let response = await (0, $9810156153020e5d$export$bb173986169374ad)((0, $d27dbe10f1bffb7d$export$2e2bcd8739ae039).createParenytalConsentMeta, "POST", body, headers);
            return response;
        } catch (error) {
            console.log(" Error in fetching digilocker details:", error);
            return error;
        }
    };
};
const $6eea01a75b53fee5$export$6a68a8e86e9560f1 = (parentName, parentIdentity, parentIdentityType, selectedConsentId)=>{
    return async (dispatch, getState)=>{
        let tenant_id = getState().common.tenant_id;
        let business_id = getState().common.business_id;
        let secure_code = getState().common.secure_id;
        let redirect_Url = getState().common.parental_redirect_url;
        try {
            const headers = {
                accept: "*/*",
                txn: $6eea01a75b53fee5$var$uuidv4(),
                "tenant-id": tenant_id,
                "Content-Type": "application/json",
                "X-Secure-Code": secure_code
            };
            const body = {
                consentHandleId: selectedConsentId,
                parentIdentity: parentIdentity.toUpperCase(),
                parentIdentityType: parentIdentityType,
                isParental: true,
                parentName: parentName,
                redirectUri: redirect_Url
            };
            let response = await (0, $9810156153020e5d$export$bb173986169374ad)((0, $d27dbe10f1bffb7d$export$2e2bcd8739ae039).sendParentalConsentRequest, "POST", body, headers);
            return response;
        } catch (error) {
            console.log(" Error in sending parent consent request:", error);
            return error;
        }
    };
};



const $dbe8cedc9e1aa4ce$export$3f3ac271cdeb0aca = [
    {
        value: "ENGLISH",
        label: "English",
        apiValue: "en"
    },
    {
        value: "HINDI",
        label: "\u0939\u093F\u0902\u0926\u0940",
        apiValue: "hi"
    },
    {
        value: "BENGALI",
        label: "\u09AC\u09BE\u0982\u09B2\u09BE",
        apiValue: "bn"
    },
    {
        value: "TAMIL",
        label: "\u0BA4\u0BAE\u0BBF\u0BB4\u0BCD",
        apiValue: "ta"
    },
    {
        value: "TELUGU",
        label: "\u0C24\u0C46\u0C32\u0C41\u0C17\u0C41",
        apiValue: "te"
    },
    {
        value: "KANNADA",
        label: "\u0C95\u0CA8\u0CCD\u0CA8\u0CA1",
        apiValue: "kn"
    },
    {
        value: "MALAYALAM",
        label: "\u0D2E\u0D32\u0D2F\u0D3E\u0D33\u0D02",
        apiValue: "ml"
    },
    {
        value: "GUJARATI",
        label: "\u0A97\u0AC1\u0A9C\u0AB0\u0ABE\u0AA4\u0AC0",
        apiValue: "gu"
    },
    {
        value: "MARATHI",
        label: "\u092E\u0930\u093E\u0920\u0940",
        apiValue: "mr"
    },
    {
        value: "ODIA",
        label: "\u0B13\u0B21\u0B3C\u0B3F\u0B06",
        apiValue: "or"
    },
    {
        value: "PUNJABI",
        label: "\u0A2A\u0A70\u0A1C\u0A3E\u0A2C\u0A40",
        apiValue: "pa"
    },
    {
        value: "ASSAMESE",
        label: "\u0985\u09B8\u09AE\u09C0\u09AF\u09BC\u09BE",
        apiValue: "as"
    },
    {
        value: "NEPALI",
        label: "\u0928\u0947\u092A\u093E\u0932\u0940",
        apiValue: "ne"
    },
    {
        value: "SINDHI",
        label: "\u0633\u0646\u068C\u064A",
        apiValue: "sd"
    },
    {
        value: "KASHMIRI",
        label: "\u0915\u0949\u0936\u0941\u0930",
        apiValue: "ks"
    },
    {
        value: "DOGRI",
        label: "\u0921\u094B\u0917\u0930\u0940",
        apiValue: "doi"
    },
    {
        value: "KONKANI",
        label: "\u0915\u094B\u0902\u0915\u0923\u0940",
        apiValue: "gom"
    },
    {
        value: "MAITHILI",
        label: "\u092E\u0948\u0925\u093F\u0932\u0940",
        apiValue: "mai"
    },
    {
        value: "SANSKRIT",
        label: "\u0938\u0902\u0938\u094D\u0915\u0943\u0924",
        apiValue: "sa"
    },
    {
        value: "SANTALI",
        label: "\u1C65\u1C5F\u1C71\u1C5B\u1C5F\u1C72\u1C64",
        apiValue: "sat"
    },
    {
        value: "BODO",
        label: "\u092C\u0921\u093C\u094B",
        apiValue: "brx"
    },
    {
        value: "MANIPURI",
        label: "\u09AE\u09C8\u09A4\u09C8\u09B2\u09CB\u09A8\u09CD",
        apiValue: "mni"
    }
];
const $dbe8cedc9e1aa4ce$export$d340805709eeec9f = (languageKey)=>{
    const option = $dbe8cedc9e1aa4ce$export$3f3ac271cdeb0aca.find((opt)=>opt.value === languageKey);
    return option ? option.apiValue : "en";
};
/**
 * Custom hook for handling Bhashini translations
 * @param {Array} translationInputs - Array of {id, source} objects to translate
 * @returns {Object} - Translation utilities and state
 */ const $dbe8cedc9e1aa4ce$var$useTranslation = (translationInputs = [])=>{
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const currentLanguage = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.common?.currentLanguage) || "ENGLISH";
    const currentSourceLang = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.common?.currentSourceLang) || "en";
    const globalTranslations = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.common?.translations) || {};
    const isTranslating = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.common?.isTranslating) || false;
    const [localTranslations, setLocalTranslations] = (0, $acw62.useState)({});
    const [previousLanguage, setPreviousLanguage] = (0, $acw62.useState)("ENGLISH");
    const [sourceLangTracker, setSourceLangTracker] = (0, $acw62.useState)("en");
    // Initialize Bhashini configuration
    const initializeBhashini = (0, $acw62.useCallback)(async ()=>{
        try {
            await dispatch((0, $6eea01a75b53fee5$export$78d225ba46c95956)());
        } catch (error) {
            console.log("Error initializing Bhashini config:", error);
        }
    }, [
        dispatch
    ]);
    // Translate content using Bhashini API
    const translateContent = (0, $acw62.useCallback)(async (inputs, targetLanguageKey = currentLanguage)=>{
        if (!inputs || inputs.length === 0) return null;
        // If switching to English, reset translations
        if (targetLanguageKey === "ENGLISH") {
            setLocalTranslations({});
            setSourceLangTracker("en");
            return null;
        }
        dispatch({
            type: (0, $dee2f92127058cd3$export$a7d24a17944978e7),
            payload: true
        });
        try {
            const targetLang = $dbe8cedc9e1aa4ce$export$d340805709eeec9f(targetLanguageKey);
            const response = await dispatch((0, $6eea01a75b53fee5$export$7d0f208153a27d67)(sourceLangTracker, targetLang, inputs));
            if (response?.status === 200 && response?.data?.output) {
                const translatedMap = {};
                response.data.output.forEach((item)=>{
                    translatedMap[item.id] = item.target;
                });
                setLocalTranslations((prev)=>({
                        ...prev,
                        ...translatedMap
                    }));
                setSourceLangTracker(targetLang);
                // Also update global Redux state
                dispatch({
                    type: (0, $dee2f92127058cd3$export$61812dfd55580ecf),
                    payload: translatedMap
                });
                return translatedMap;
            }
            return null;
        } catch (error) {
            console.log("Translation error:", error);
            return null;
        } finally{
            dispatch({
                type: (0, $dee2f92127058cd3$export$a7d24a17944978e7),
                payload: false
            });
        }
    }, [
        dispatch,
        sourceLangTracker,
        currentLanguage
    ]);
    // Get translated text by ID with fallback to default
    const getTranslation = (0, $acw62.useCallback)((id, defaultText)=>{
        if (!currentLanguage || currentLanguage === "ENGLISH") return defaultText;
        // Add safety checks for undefined objects
        const localValue = localTranslations ? localTranslations[id] : null;
        const globalValue = globalTranslations ? globalTranslations[id] : null;
        return localValue || globalValue || defaultText;
    }, [
        localTranslations,
        globalTranslations,
        currentLanguage
    ]);
    // Auto-translate when language changes
    (0, $acw62.useEffect)(()=>{
        if (currentLanguage !== previousLanguage && translationInputs.length > 0) {
            translateContent(translationInputs, currentLanguage);
            setPreviousLanguage(currentLanguage);
        }
    }, [
        currentLanguage,
        previousLanguage,
        translationInputs,
        translateContent
    ]);
    // Reset translations
    const resetTranslations = (0, $acw62.useCallback)(()=>{
        setLocalTranslations({});
        setSourceLangTracker("en");
    }, []);
    return {
        currentLanguage: currentLanguage || "ENGLISH",
        isTranslating: isTranslating || false,
        translations: {
            ...globalTranslations || {},
            ...localTranslations || {}
        },
        translateContent: translateContent,
        getTranslation: getTranslation,
        resetTranslations: resetTranslations,
        initializeBhashini: initializeBhashini,
        LANGUAGE_OPTIONS: $dbe8cedc9e1aa4ce$export$3f3ac271cdeb0aca
    };
};
var $dbe8cedc9e1aa4ce$export$2e2bcd8739ae039 = $dbe8cedc9e1aa4ce$var$useTranslation;


const $b3b62c205a9c34b0$var$SideNav = ({ mobileNavOpen: mobileNavOpen, onMobileNavClose: onMobileNavClose })=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const path = location.pathname;
    const cusId = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.common.customer_id);
    const portalTheme = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.common.portal_theme);
    const activeNavBg = portalTheme?.colors?.buttonBackground;
    const activeNavFont = portalTheme?.colors?.buttonFont;
    // Translation inputs for navigation labels
    const translationInputs = (0, $acw62.useMemo)(()=>[
            {
                id: "nav_consent",
                source: "Consent"
            },
            {
                id: "nav_granted_consents",
                source: "Granted consents"
            },
            {
                id: "nav_pending_requests",
                source: "Pending requests"
            },
            {
                id: "nav_grievance_redressal",
                source: "Grievance redressal"
            },
            {
                id: "nav_requests",
                source: "Requests"
            }
        ], []);
    const { getTranslation: getTranslation, translateContent: translateContent, currentLanguage: currentLanguage } = (0, $dbe8cedc9e1aa4ce$export$2e2bcd8739ae039)(translationInputs);
    // Translate content when language changes
    (0, $acw62.useEffect)(()=>{
        if (currentLanguage !== "ENGLISH") translateContent(translationInputs, currentLanguage);
    }, [
        currentLanguage,
        translationInputs,
        translateContent
    ]);
    const grantedLabel = portalTheme?.portalTitle || getTranslation("nav_granted_consents", "Granted consents");
    const menuItems = [
        {
            type: "heading",
            label: getTranslation("nav_consent", "Consent")
        },
        {
            label: grantedLabel,
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6cfef88bd445e8b4$export$e71de051933b1536), {
                height: 23,
                width: 23,
                "aria-hidden": "true"
            }),
            path: "/"
        },
        {
            label: getTranslation("nav_pending_requests", "Pending requests"),
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8c66bf8a36364e42$export$7f3df200d95b839b), {
                height: 23,
                width: 23,
                "aria-hidden": "true"
            }),
            path: "/systemRequests"
        },
        {
            type: "heading",
            label: getTranslation("nav_grievance_redressal", "Grievance redressal")
        },
        {
            label: getTranslation("nav_requests", "Requests"),
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6cfef88bd445e8b4$export$e71de051933b1536), {
                height: 23,
                width: 23,
                "aria-hidden": "true"
            }),
            path: "/requests"
        }
    ];
    const handleNavigation = (path)=>{
        navigate(path);
        if (onMobileNavClose) onMobileNavClose();
    };
    if (path === "/adminLogin" || path === "/app-documents" || path === "/home" || path === "/createRequest") return null;
    else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("nav", {
        id: "main-side-navigation",
        className: `sideBar-outer-container${mobileNavOpen ? " open" : ""}`,
        "aria-label": "Main Navigation",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            role: "menu",
            "aria-label": "Navigation menu",
            children: [
                cusId && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "sideBar-menu-click inactive",
                    "aria-label": `Customer ID: ${cusId}`,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$f04a61298a47a40f), {
                            kind: "default",
                            ic: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $807fef1d289a1edd$export$255f0ef2dfc5eb49), {
                                height: 23,
                                width: 23,
                                "aria-hidden": "true"
                            }),
                            color: "primary_grey_80",
                            size: "medium"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "sideBar-cusId",
                            title: cusId,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                appearance: "body-xs-bold",
                                color: "primary-grey-80",
                                children: cusId
                            })
                        })
                    ]
                }),
                menuItems.map((item)=>{
                    if (item.type === "heading") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                        appearance: "body-xs-bold",
                        color: "primary-grey-80",
                        className: "sideBar-menu-item",
                        "aria-label": `${item.label} section`,
                        children: item.label
                    }, item.label);
                    const isActive = location.pathname === item.path;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: `sideBar-menu-click ${isActive ? "active" : "inactive"}`,
                        style: isActive && activeNavBg ? {
                            backgroundColor: activeNavBg
                        } : undefined,
                        onClick: ()=>handleNavigation(item.path),
                        onKeyDown: (e)=>{
                            if (e.key === "Enter" || e.key === " ") {
                                e.preventDefault();
                                handleNavigation(item.path);
                            }
                        },
                        tabIndex: 0,
                        role: "menuitem",
                        "aria-label": `Navigate to ${item.label}`,
                        "aria-current": isActive ? "page" : undefined,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$f04a61298a47a40f), {
                                kind: isActive ? "background-bold" : "default",
                                ic: item.icon,
                                color: isActive ? "primary_60" : "primary_grey_80",
                                size: "medium"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                appearance: "body-xs-bold",
                                color: isActive ? "primary_60" : "primary-grey-80",
                                style: {
                                    marginLeft: "8px",
                                    ...isActive && activeNavFont ? {
                                        color: activeNavFont
                                    } : {}
                                },
                                children: item.label
                            })
                        ]
                    }, item.path);
                })
            ]
        })
    });
};
var $b3b62c205a9c34b0$export$2e2bcd8739ae039 = $b3b62c205a9c34b0$var$SideNav;








var $4249f69807f0687b$exports = {};
/* xlsx-js-style 1.2.0-beta @ 2022-04-05T01:40:40.843Z */ 
var $kjyEk = parcelRequire("kjyEk");
var $4249f69807f0687b$require$Buffer = $kjyEk.Buffer;
var $4249f69807f0687b$var$XLSX = {};




function $4249f69807f0687b$var$make_xlsx_lib(a) {
    a.version = "0.18.5", a.style_version = "1.2.0";
    var re, f = 1200, _ = 1252;
    "undefined" != typeof cptable ? re = cptable : re = (parcelRequire("joOgL"));
    var t = [
        874,
        932,
        936,
        949,
        950,
        1250,
        1251,
        1252,
        1253,
        1254,
        1255,
        1256,
        1257,
        1258,
        1e4
    ], l = {
        0: 1252,
        1: 65001,
        2: 65001,
        77: 1e4,
        128: 932,
        129: 949,
        130: 1361,
        134: 936,
        136: 950,
        161: 1253,
        162: 1254,
        163: 1258,
        177: 1255,
        178: 1256,
        186: 1257,
        204: 1251,
        222: 874,
        238: 1250,
        255: 1252,
        69: 6969
    }, c = function(e) {
        -1 != t.indexOf(e) && (_ = l[0] = e);
    };
    var ie = function(e) {
        c(f = e);
    };
    function h() {
        ie(1200), c(1252);
    }
    function ae(e) {
        for(var t = [], r = 0, a = e.length; r < a; ++r)t[r] = e.charCodeAt(r);
        return t;
    }
    function s(e) {
        for(var t = [], r = 0; r < e.length >> 1; ++r)t[r] = String.fromCharCode(e.charCodeAt(2 * r + 1) + (e.charCodeAt(2 * r) << 8));
        return t.join("");
    }
    var ne = function(e) {
        var t = e.charCodeAt(0), r = e.charCodeAt(1);
        return 255 == t && 254 == r ? function(e) {
            for(var t = [], r = 0; r < e.length >> 1; ++r)t[r] = String.fromCharCode(e.charCodeAt(2 * r) + (e.charCodeAt(2 * r + 1) << 8));
            return t.join("");
        }(e.slice(2)) : 254 == t && 255 == r ? s(e.slice(2)) : 65279 == t ? e.slice(1) : e;
    }, u = function(e) {
        return String.fromCharCode(e);
    }, n = function(e) {
        return String.fromCharCode(e);
    };
    void 0 !== re && (ie = function(e) {
        c(f = e);
    }, ne = function(e) {
        return 255 === e.charCodeAt(0) && 254 === e.charCodeAt(1) ? re.utils.decode(1200, ae(e.slice(2))) : e;
    }, u = function(e) {
        return 1200 === f ? String.fromCharCode(e) : re.utils.decode(f, [
            255 & e,
            e >> 8
        ])[0];
    }, n = function(e) {
        return re.utils.decode(_, [
            e
        ])[0];
    });
    var oe = null, d = !0, p = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    function ee(e) {
        for(var t, r, a, n, s, i = "", o = 0, c = 0, l = 0; l < e.length;)n = (t = e.charCodeAt(l++)) >> 2, s = (3 & t) << 4 | (r = e.charCodeAt(l++)) >> 4, o = (15 & r) << 2 | (a = e.charCodeAt(l++)) >> 6, c = 63 & a, isNaN(r) ? o = c = 64 : isNaN(a) && (c = 64), i += p.charAt(n) + p.charAt(s) + p.charAt(o) + p.charAt(c);
        return i;
    }
    function te(e) {
        var t, r, a, n, s, i, o = "";
        e = e.replace(/[^\w\+\/\=]/g, "");
        for(var c = 0; c < e.length;)t = p.indexOf(e.charAt(c++)) << 2 | (n = p.indexOf(e.charAt(c++))) >> 4, o += String.fromCharCode(t), r = (15 & n) << 4 | (s = p.indexOf(e.charAt(c++))) >> 2, 64 !== s && (o += String.fromCharCode(r)), a = (3 & s) << 6 | (i = p.indexOf(e.charAt(c++))), 64 !== i && (o += String.fromCharCode(a));
        return o;
    }
    var se = "undefined" != typeof $4249f69807f0687b$require$Buffer && false, ce = function() {
        if ("undefined" == typeof $4249f69807f0687b$require$Buffer) return function() {};
        var t = !$4249f69807f0687b$require$Buffer.from;
        if (!t) try {
            $4249f69807f0687b$require$Buffer.from("foo", "utf8");
        } catch (e) {
            t = !0;
        }
        return t ? function(e, t) {
            return t ? new $4249f69807f0687b$require$Buffer(e, t) : new $4249f69807f0687b$require$Buffer(e);
        } : $4249f69807f0687b$require$Buffer.from.bind($4249f69807f0687b$require$Buffer);
    }();
    function le(e) {
        return se ? $4249f69807f0687b$require$Buffer.alloc ? $4249f69807f0687b$require$Buffer.alloc(e) : new $4249f69807f0687b$require$Buffer(e) : new ("undefined" != typeof Uint8Array ? Uint8Array : Array)(e);
    }
    function fe(e) {
        return se ? $4249f69807f0687b$require$Buffer.allocUnsafe ? $4249f69807f0687b$require$Buffer.allocUnsafe(e) : new $4249f69807f0687b$require$Buffer(e) : new ("undefined" != typeof Uint8Array ? Uint8Array : Array)(e);
    }
    var he = function(e) {
        return se ? ce(e, "binary") : e.split("").map(function(e) {
            return 255 & e.charCodeAt(0);
        });
    };
    function o(e) {
        if ("undefined" == typeof ArrayBuffer) return he(e);
        for(var t = new ArrayBuffer(e.length), r = new Uint8Array(t), a = 0; a != e.length; ++a)r[a] = 255 & e.charCodeAt(a);
        return t;
    }
    function i(e) {
        if (Array.isArray(e)) return e.map(function(e) {
            return String.fromCharCode(e);
        }).join("");
        for(var t = [], r = 0; r < e.length; ++r)t[r] = String.fromCharCode(e[r]);
        return t.join("");
    }
    function m(e) {
        if ("undefined" == typeof ArrayBuffer) throw new Error("Unsupported");
        if (e instanceof ArrayBuffer) return m(new Uint8Array(e));
        for(var t = new Array(e.length), r = 0; r < e.length; ++r)t[r] = e[r];
        return t;
    }
    var ue = se ? function(e) {
        return $4249f69807f0687b$require$Buffer.concat(e.map(function(e) {
            return $4249f69807f0687b$require$Buffer.isBuffer(e) ? e : ce(e);
        }));
    } : function(e) {
        if ("undefined" == typeof Uint8Array) return [].concat.apply([], e.map(function(e) {
            return Array.isArray(e) ? e : [].slice.call(e);
        }));
        for(var t = 0, r = 0, t = 0; t < e.length; ++t)r += e[t].length;
        for(var a, n = new Uint8Array(r), r = t = 0; t < e.length; r += a, ++t)if (a = e[t].length, e[t] instanceof Uint8Array) n.set(e[t], r);
        else {
            if ("string" == typeof e[t]) throw "wtf";
            n.set(new Uint8Array(e[t]), r);
        }
        return n;
    };
    var de = /\u0000/g, pe = /[\u0001-\u0006]/g;
    function v(e) {
        for(var t = "", r = e.length - 1; 0 <= r;)t += e.charAt(r--);
        return t;
    }
    function x(e, t) {
        e = "" + e;
        return t <= e.length ? e : Ge("0", t - e.length) + e;
    }
    function w(e, t) {
        e = "" + e;
        return t <= e.length ? e : Ge(" ", t - e.length) + e;
    }
    function T(e, t) {
        e = "" + e;
        return t <= e.length ? e : e + Ge(" ", t - e.length);
    }
    var g = Math.pow(2, 32);
    function E(e, t) {
        if (g < e || e < -g) return r = e, a = t, r = "" + Math.round(r), a <= r.length ? r : Ge("0", a - r.length) + r;
        var r, a, e = Math.round(e);
        return t <= (e = "" + e).length ? e : Ge("0", t - e.length) + e;
    }
    function A(e, t) {
        return t = t || 0, e.length >= 7 + t && 103 == (32 | e.charCodeAt(t)) && 101 == (32 | e.charCodeAt(t + 1)) && 110 == (32 | e.charCodeAt(t + 2)) && 101 == (32 | e.charCodeAt(t + 3)) && 114 == (32 | e.charCodeAt(t + 4)) && 97 == (32 | e.charCodeAt(t + 5)) && 108 == (32 | e.charCodeAt(t + 6));
    }
    var C = [
        [
            "Sun",
            "Sunday"
        ],
        [
            "Mon",
            "Monday"
        ],
        [
            "Tue",
            "Tuesday"
        ],
        [
            "Wed",
            "Wednesday"
        ],
        [
            "Thu",
            "Thursday"
        ],
        [
            "Fri",
            "Friday"
        ],
        [
            "Sat",
            "Saturday"
        ]
    ], R = [
        [
            "J",
            "Jan",
            "January"
        ],
        [
            "F",
            "Feb",
            "February"
        ],
        [
            "M",
            "Mar",
            "March"
        ],
        [
            "A",
            "Apr",
            "April"
        ],
        [
            "M",
            "May",
            "May"
        ],
        [
            "J",
            "Jun",
            "June"
        ],
        [
            "J",
            "Jul",
            "July"
        ],
        [
            "A",
            "Aug",
            "August"
        ],
        [
            "S",
            "Sep",
            "September"
        ],
        [
            "O",
            "Oct",
            "October"
        ],
        [
            "N",
            "Nov",
            "November"
        ],
        [
            "D",
            "Dec",
            "December"
        ]
    ];
    var me = {
        0: "General",
        1: "0",
        2: "0.00",
        3: "#,##0",
        4: "#,##0.00",
        9: "0%",
        10: "0.00%",
        11: "0.00E+00",
        12: "# ?/?",
        13: "# ??/??",
        14: "m/d/yy",
        15: "d-mmm-yy",
        16: "d-mmm",
        17: "mmm-yy",
        18: "h:mm AM/PM",
        19: "h:mm:ss AM/PM",
        20: "h:mm",
        21: "h:mm:ss",
        22: "m/d/yy h:mm",
        37: "#,##0 ;(#,##0)",
        38: "#,##0 ;[Red](#,##0)",
        39: "#,##0.00;(#,##0.00)",
        40: "#,##0.00;[Red](#,##0.00)",
        45: "mm:ss",
        46: "[h]:mm:ss",
        47: "mmss.0",
        48: "##0.0E+0",
        49: "@",
        56: '"\u4E0A\u5348/\u4E0B\u5348 "hh"\u6642"mm"\u5206"ss"\u79D2 "'
    }, b = {
        5: 37,
        6: 38,
        7: 39,
        8: 40,
        23: 0,
        24: 0,
        25: 0,
        26: 0,
        27: 14,
        28: 14,
        29: 14,
        30: 14,
        31: 14,
        50: 14,
        51: 14,
        52: 14,
        53: 14,
        54: 14,
        55: 14,
        56: 14,
        57: 14,
        58: 14,
        59: 1,
        60: 2,
        61: 3,
        62: 4,
        67: 9,
        68: 10,
        69: 12,
        70: 13,
        71: 14,
        72: 14,
        73: 15,
        74: 16,
        75: 17,
        76: 20,
        77: 21,
        78: 22,
        79: 45,
        80: 46,
        81: 47,
        82: 0
    }, k = {
        5: '"$"#,##0_);\\("$"#,##0\\)',
        63: '"$"#,##0_);\\("$"#,##0\\)',
        6: '"$"#,##0_);[Red]\\("$"#,##0\\)',
        64: '"$"#,##0_);[Red]\\("$"#,##0\\)',
        7: '"$"#,##0.00_);\\("$"#,##0.00\\)',
        65: '"$"#,##0.00_);\\("$"#,##0.00\\)',
        8: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
        66: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
        41: '_(* #,##0_);_(* \\(#,##0\\);_(* "-"_);_(@_)',
        42: '_("$"* #,##0_);_("$"* \\(#,##0\\);_("$"* "-"_);_(@_)',
        43: '_(* #,##0.00_);_(* \\(#,##0.00\\);_(* "-"??_);_(@_)',
        44: '_("$"* #,##0.00_);_("$"* \\(#,##0.00\\);_("$"* "-"??_);_(@_)'
    };
    function y(e, t, r) {
        for(var a = e < 0 ? -1 : 1, n = e * a, s = 0, i = 1, o = 0, c = 1, l = 0, f = 0, h = Math.floor(n); l < t && (o = (h = Math.floor(n)) * i + s, f = h * l + c, !(n - h < 5e-8));)n = 1 / (n - h), s = i, i = o, c = l, l = f;
        if (t < f && (o = t < l ? (f = c, s) : (f = l, i)), !r) return [
            0,
            a * o,
            f
        ];
        r = Math.floor(a * o / f);
        return [
            r,
            a * o - r * f,
            f
        ];
    }
    function L(e, t, r) {
        if (2958465 < e || e < 0) return null;
        var a = 0 | e, n = Math.floor(86400 * (e - a)), s = 0, i = [], e = {
            D: a,
            T: n,
            u: 86400 * (e - a) - n,
            y: 0,
            m: 0,
            d: 0,
            H: 0,
            M: 0,
            S: 0,
            q: 0
        };
        return Math.abs(e.u) < 1e-6 && (e.u = 0), t && t.date1904 && (a += 1462), .9999 < e.u && (e.u = 0, 86400 == ++n && (e.T = n = 0, ++a, ++e.D)), 60 === a ? (i = r ? [
            1317,
            10,
            29
        ] : [
            1900,
            2,
            29
        ], s = 3) : 0 === a ? (i = r ? [
            1317,
            8,
            29
        ] : [
            1900,
            1,
            0
        ], s = 6) : (60 < a && --a, (t = new Date(1900, 0, 1)).setDate(t.getDate() + a - 1), i = [
            t.getFullYear(),
            t.getMonth() + 1,
            t.getDate()
        ], s = t.getDay(), a < 60 && (s = (s + 6) % 7), r && (s = function(e, t) {
            t[0] -= 581;
            t = e.getDay();
            e < 60 && (t = (t + 6) % 7);
            return t;
        }(t, i))), e.y = i[0], e.m = i[1], e.d = i[2], e.S = n % 60, n = Math.floor(n / 60), e.M = n % 60, n = Math.floor(n / 60), e.H = n, e.q = s, e;
    }
    var S = new Date(1899, 11, 31, 0, 0, 0), O = S.getTime(), I = new Date(1900, 2, 1, 0, 0, 0);
    function N(e, t) {
        var r = e.getTime();
        return t ? r -= 1262304e5 : I <= e && (r += 864e5), (r - (O + 6e4 * (e.getTimezoneOffset() - S.getTimezoneOffset()))) / 864e5;
    }
    function F(e) {
        return -1 == e.indexOf(".") ? e : e.replace(/(?:\.0*|(\.\d*[1-9])0+)$/, "$1");
    }
    function D(e) {
        var t, r, a, n = Math.floor(Math.log(Math.abs(e)) * Math.LOG10E), s = -4 <= n && n <= -1 ? e.toPrecision(10 + n) : Math.abs(n) <= 9 ? (r = (t = e) < 0 ? 12 : 11, (a = F(t.toFixed(12))).length <= r || (a = t.toPrecision(10)).length <= r ? a : t.toExponential(5)) : 10 === n ? e.toFixed(10).substr(0, 12) : (s = F(e.toFixed(11))).length > (e < 0 ? 12 : 11) || "0" === s || "-0" === s ? e.toPrecision(6) : s;
        return F(-1 == (s = s.toUpperCase()).indexOf("E") ? s : s.replace(/(?:\.0*|(\.\d*[1-9])0+)[Ee]/, "$1E").replace(/(E[+-])(\d)$/, "$10$2"));
    }
    function P(e, t) {
        switch(typeof e){
            case "string":
                return e;
            case "boolean":
                return e ? "TRUE" : "FALSE";
            case "number":
                return (0 | e) === e ? e.toString(10) : D(e);
            case "undefined":
                return "";
            case "object":
                if (null == e) return "";
                if (e instanceof Date) return ve(14, N(e, t && t.date1904), t);
        }
        throw new Error("unsupported value in General format: " + e);
    }
    function M(e) {
        if (e.length <= 3) return e;
        for(var t = e.length % 3, r = e.substr(0, t); t != e.length; t += 3)r += (0 < r.length ? "," : "") + e.substr(t, 3);
        return r;
    }
    var U = /%/g;
    var B = /# (\?+)( ?)\/( ?)(\d+)/;
    var W = /^#*0*\.([0#]+)/, H = /\).*[0#]/, z = /\(###\) ###\\?-####/;
    function V(e) {
        for(var t, r = "", a = 0; a != e.length; ++a)switch(t = e.charCodeAt(a)){
            case 35:
                break;
            case 63:
                r += " ";
                break;
            case 48:
                r += "0";
                break;
            default:
                r += String.fromCharCode(t);
        }
        return r;
    }
    function G(e, t) {
        t = Math.pow(10, t);
        return "" + Math.round(e * t) / t;
    }
    function j(e, t) {
        var r = e - Math.floor(e), e = Math.pow(10, t);
        return t < ("" + Math.round(r * e)).length ? 0 : Math.round(r * e);
    }
    function X(e, t, r) {
        if (40 === e.charCodeAt(0) && !t.match(H)) {
            var a = t.replace(/\( */, "").replace(/ \)/, "").replace(/\)/, "");
            return 0 <= r ? X("n", a, r) : "(" + X("n", a, -r) + ")";
        }
        if (44 === t.charCodeAt(t.length - 1)) return function(e, t, r) {
            for(var a = t.length - 1; 44 === t.charCodeAt(a - 1);)--a;
            return K(e, t.substr(0, a), r / Math.pow(10, 3 * (t.length - a)));
        }(e, t, r);
        if (-1 !== t.indexOf("%")) return o = e, l = r, c = (f = t).replace(U, ""), f = f.length - c.length, K(o, c, l * Math.pow(10, 2 * f)) + Ge("%", f);
        var n;
        if (-1 !== t.indexOf("E")) return function e(t, r) {
            var a, n = t.indexOf("E") - t.indexOf(".") - 1;
            if (t.match(/^#+0.0E\+0$/)) {
                if (0 == r) return "0.0E+0";
                if (r < 0) return "-" + e(t, -r);
                var s = t.indexOf(".");
                -1 === s && (s = t.indexOf("E"));
                var i = Math.floor(Math.log(r) * Math.LOG10E) % s;
                if (i < 0 && (i += s), -1 === (a = (r / Math.pow(10, i)).toPrecision(1 + n + (s + i) % s)).indexOf("e")) {
                    var o = Math.floor(Math.log(r) * Math.LOG10E);
                    for(-1 === a.indexOf(".") ? a = a.charAt(0) + "." + a.substr(1) + "E+" + (o - a.length + i) : a += "E+" + (o - i); "0." === a.substr(0, 2);)a = (a = a.charAt(0) + a.substr(2, s) + "." + a.substr(2 + s)).replace(/^0+([1-9])/, "$1").replace(/^0+\./, "0.");
                    a = a.replace(/\+-/, "-");
                }
                a = a.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function(e, t, r, a) {
                    return t + r + a.substr(0, (s + i) % s) + "." + a.substr(i) + "E";
                });
            } else a = r.toExponential(n);
            return t.match(/E\+00$/) && a.match(/e[+-]\d$/) && (a = a.substr(0, a.length - 1) + "0" + a.charAt(a.length - 1)), (a = t.match(/E\-/) && a.match(/e\+/) ? a.replace(/e\+/, "e") : a).replace("e", "E");
        }(t, r);
        if (36 === t.charCodeAt(0)) return "$" + X(e, t.substr(" " == t.charAt(1) ? 2 : 1), r);
        var s, i, o, c, l, f, h, u = Math.abs(r), d = r < 0 ? "-" : "";
        if (t.match(/^00+$/)) return d + E(u, t.length);
        if (t.match(/^[#?]+$/)) return (n = "0" === (n = E(r, 0)) ? "" : n).length > t.length ? n : V(t.substr(0, t.length - n.length)) + n;
        if (s = t.match(B)) return h = s, o = u, c = d, l = parseInt(h[4], 10), f = Math.round(o * l), o = Math.floor(f / l), l, c + (0 === o ? "" : "" + o) + " " + (0 == (f -= o * l) ? Ge(" ", h[1].length + 1 + h[4].length) : w(f, h[1].length) + h[2] + "/" + h[3] + x(l, h[4].length));
        if (t.match(/^#+0+$/)) return d + E(u, t.length - t.indexOf("0"));
        if (s = t.match(W)) return n = G(r, s[1].length).replace(/^([^\.]+)$/, "$1." + V(s[1])).replace(/\.$/, "." + V(s[1])).replace(/\.(\d*)$/, function(e, t) {
            return "." + t + Ge("0", V(s[1]).length - t.length);
        }), -1 !== t.indexOf("0.") ? n : n.replace(/^0\./, ".");
        if (t = t.replace(/^#+([0.])/, "$1"), s = t.match(/^(0*)\.(#*)$/)) return d + G(u, s[2].length).replace(/\.(\d*[1-9])0*$/, ".$1").replace(/^(-?\d*)$/, "$1.").replace(/^0\./, s[1].length ? "0." : ".");
        if (s = t.match(/^#{1,3},##0(\.?)$/)) return d + M(E(u, 0));
        if (s = t.match(/^#,##0\.([#0]*0)$/)) return r < 0 ? "-" + X(e, t, -r) : M("" + (Math.floor(r) + (h = r, (p = s[1].length) < ("" + Math.round((h - Math.floor(h)) * Math.pow(10, p))).length ? 1 : 0))) + "." + x(j(r, s[1].length), s[1].length);
        if (s = t.match(/^#,#*,#0/)) return X(e, t.replace(/^#,#*,/, ""), r);
        if (s = t.match(/^([0#]+)(\\?-([0#]+))+$/)) return n = v(X(e, t.replace(/[\\-]/g, ""), r)), i = 0, v(v(t.replace(/\\/g, "")).replace(/[0#]/g, function(e) {
            return i < n.length ? n.charAt(i++) : "0" === e ? "0" : "";
        }));
        if (t.match(z)) return "(" + (n = X(e, "##########", r)).substr(0, 3) + ") " + n.substr(3, 3) + "-" + n.substr(6);
        var p = "";
        if (s = t.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)) return i = Math.min(s[4].length, 7), m = y(u, Math.pow(10, i) - 1, !1), n = d, " " == (p = K("n", s[1], m[1])).charAt(p.length - 1) && (p = p.substr(0, p.length - 1) + "0"), n += p + s[2] + "/" + s[3], (p = T(m[2], i)).length < s[4].length && (p = V(s[4].substr(s[4].length - p.length)) + p), n += p;
        if (s = t.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)) return i = Math.min(Math.max(s[1].length, s[4].length), 7), d + ((m = y(u, Math.pow(10, i) - 1, !0))[0] || (m[1] ? "" : "0")) + " " + (m[1] ? w(m[1], i) + s[2] + "/" + s[3] + T(m[2], i) : Ge(" ", 2 * i + 1 + s[2].length + s[3].length));
        if (s = t.match(/^[#0?]+$/)) return n = E(r, 0), t.length <= n.length ? n : V(t.substr(0, t.length - n.length)) + n;
        if (s = t.match(/^([#0?]+)\.([#0]+)$/)) {
            n = "" + r.toFixed(Math.min(s[2].length, 10)).replace(/([^0])0+$/, "$1"), i = n.indexOf(".");
            var m = t.indexOf(".") - i, g = t.length - n.length - m;
            return V(t.substr(0, m) + n + t.substr(t.length - g));
        }
        if (s = t.match(/^00,000\.([#0]*0)$/)) return i = j(r, s[1].length), r < 0 ? "-" + X(e, t, -r) : M((g = r) < 2147483647 && -2147483648 < g ? "" + (0 <= g ? 0 | g : g - 1 | 0) : "" + Math.floor(g)).replace(/^\d,\d{3}$/, "0$&").replace(/^\d*$/, function(e) {
            return "00," + (e.length < 3 ? x(0, 3 - e.length) : "") + e;
        }) + "." + x(i, s[1].length);
        switch(t){
            case "###,##0.00":
                return X(e, "#,##0.00", r);
            case "###,###":
            case "##,###":
            case "#,###":
                var b = M(E(u, 0));
                return "0" !== b ? d + b : "";
            case "###,###.00":
                return X(e, "###,##0.00", r).replace(/^0\./, ".");
            case "#,###.00":
                return X(e, "#,##0.00", r).replace(/^0\./, ".");
        }
        throw new Error("unsupported format |" + t + "|");
    }
    function Y(e, t, r) {
        if (40 === e.charCodeAt(0) && !t.match(H)) {
            var a = t.replace(/\( */, "").replace(/ \)/, "").replace(/\)/, "");
            return 0 <= r ? Y("n", a, r) : "(" + Y("n", a, -r) + ")";
        }
        if (44 === t.charCodeAt(t.length - 1)) return function(e, t, r) {
            for(var a = t.length - 1; 44 === t.charCodeAt(a - 1);)--a;
            return K(e, t.substr(0, a), r / Math.pow(10, 3 * (t.length - a)));
        }(e, t, r);
        if (-1 !== t.indexOf("%")) return n = e, i = r, a = (s = t).replace(U, ""), s = s.length - a.length, K(n, a, i * Math.pow(10, 2 * s)) + Ge("%", s);
        var n, s, i, o;
        if (-1 !== t.indexOf("E")) return function e(t, r) {
            var a, n = t.indexOf("E") - t.indexOf(".") - 1;
            if (t.match(/^#+0.0E\+0$/)) {
                if (0 == r) return "0.0E+0";
                if (r < 0) return "-" + e(t, -r);
                var s = t.indexOf(".");
                -1 === s && (s = t.indexOf("E"));
                var i, o = Math.floor(Math.log(r) * Math.LOG10E) % s;
                o < 0 && (o += s), (a = (r / Math.pow(10, o)).toPrecision(1 + n + (s + o) % s)).match(/[Ee]/) || (i = Math.floor(Math.log(r) * Math.LOG10E), -1 === a.indexOf(".") ? a = a.charAt(0) + "." + a.substr(1) + "E+" + (i - a.length + o) : a += "E+" + (i - o), a = a.replace(/\+-/, "-")), a = a.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function(e, t, r, a) {
                    return t + r + a.substr(0, (s + o) % s) + "." + a.substr(o) + "E";
                });
            } else a = r.toExponential(n);
            return t.match(/E\+00$/) && a.match(/e[+-]\d$/) && (a = a.substr(0, a.length - 1) + "0" + a.charAt(a.length - 1)), (a = t.match(/E\-/) && a.match(/e\+/) ? a.replace(/e\+/, "e") : a).replace("e", "E");
        }(t, r);
        if (36 === t.charCodeAt(0)) return "$" + Y(e, t.substr(" " == t.charAt(1) ? 2 : 1), r);
        var c, l, f = Math.abs(r), h = r < 0 ? "-" : "";
        if (t.match(/^00+$/)) return h + x(f, t.length);
        if (t.match(/^[#?]+$/)) return (o = 0 === r ? "" : "" + r).length > t.length ? o : V(t.substr(0, t.length - o.length)) + o;
        if (c = t.match(B)) return h + (0 === (u = f) ? "" : "" + u) + Ge(" ", (u = c)[1].length + 2 + u[4].length);
        if (t.match(/^#+0+$/)) return h + x(f, t.length - t.indexOf("0"));
        if (c = t.match(W)) return o = (o = ("" + r).replace(/^([^\.]+)$/, "$1." + V(c[1])).replace(/\.$/, "." + V(c[1]))).replace(/\.(\d*)$/, function(e, t) {
            return "." + t + Ge("0", V(c[1]).length - t.length);
        }), -1 !== t.indexOf("0.") ? o : o.replace(/^0\./, ".");
        if (t = t.replace(/^#+([0.])/, "$1"), c = t.match(/^(0*)\.(#*)$/)) return h + ("" + f).replace(/\.(\d*[1-9])0*$/, ".$1").replace(/^(-?\d*)$/, "$1.").replace(/^0\./, c[1].length ? "0." : ".");
        if (c = t.match(/^#{1,3},##0(\.?)$/)) return h + M("" + f);
        if (c = t.match(/^#,##0\.([#0]*0)$/)) return r < 0 ? "-" + Y(e, t, -r) : M("" + r) + "." + Ge("0", c[1].length);
        if (c = t.match(/^#,#*,#0/)) return Y(e, t.replace(/^#,#*,/, ""), r);
        if (c = t.match(/^([0#]+)(\\?-([0#]+))+$/)) return o = v(Y(e, t.replace(/[\\-]/g, ""), r)), l = 0, v(v(t.replace(/\\/g, "")).replace(/[0#]/g, function(e) {
            return l < o.length ? o.charAt(l++) : "0" === e ? "0" : "";
        }));
        if (t.match(z)) return "(" + (o = Y(e, "##########", r)).substr(0, 3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
        var u = "";
        if (c = t.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)) return l = Math.min(c[4].length, 7), d = y(f, Math.pow(10, l) - 1, !1), o = h, " " == (u = K("n", c[1], d[1])).charAt(u.length - 1) && (u = u.substr(0, u.length - 1) + "0"), o += u + c[2] + "/" + c[3], (u = T(d[2], l)).length < c[4].length && (u = V(c[4].substr(c[4].length - u.length)) + u), o += u;
        if (c = t.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)) return l = Math.min(Math.max(c[1].length, c[4].length), 7), h + ((d = y(f, Math.pow(10, l) - 1, !0))[0] || (d[1] ? "" : "0")) + " " + (d[1] ? w(d[1], l) + c[2] + "/" + c[3] + T(d[2], l) : Ge(" ", 2 * l + 1 + c[2].length + c[3].length));
        if (c = t.match(/^[#0?]+$/)) return o = "" + r, t.length <= o.length ? o : V(t.substr(0, t.length - o.length)) + o;
        if (c = t.match(/^([#0]+)\.([#0]+)$/)) {
            o = "" + r.toFixed(Math.min(c[2].length, 10)).replace(/([^0])0+$/, "$1"), l = o.indexOf(".");
            var u = t.indexOf(".") - l, d = t.length - o.length - u;
            return V(t.substr(0, u) + o + t.substr(t.length - d));
        }
        if (c = t.match(/^00,000\.([#0]*0)$/)) return r < 0 ? "-" + Y(e, t, -r) : M("" + r).replace(/^\d,\d{3}$/, "0$&").replace(/^\d*$/, function(e) {
            return "00," + (e.length < 3 ? x(0, 3 - e.length) : "") + e;
        }) + "." + x(0, c[1].length);
        switch(t){
            case "###,###":
            case "##,###":
            case "#,###":
                var p = M("" + f);
                return "0" !== p ? h + p : "";
            default:
                if (t.match(/\.[0#?]*$/)) return Y(e, t.slice(0, t.lastIndexOf(".")), r) + V(t.slice(t.lastIndexOf(".")));
        }
        throw new Error("unsupported format |" + t + "|");
    }
    function K(e, t, r) {
        return ((0 | r) === r ? Y : X)(e, t, r);
    }
    var J = /\[[HhMmSs\u0E0A\u0E19\u0E17]*\]/;
    function q(e) {
        for(var t = 0, r = "", a = ""; t < e.length;)switch(r = e.charAt(t)){
            case "G":
                A(e, t) && (t += 6), t++;
                break;
            case '"':
                for(; 34 !== e.charCodeAt(++t) && t < e.length;);
                ++t;
                break;
            case "\\":
            case "_":
                t += 2;
                break;
            case "@":
                ++t;
                break;
            case "B":
            case "b":
                if ("1" === e.charAt(t + 1) || "2" === e.charAt(t + 1)) return !0;
            case "M":
            case "D":
            case "Y":
            case "H":
            case "S":
            case "E":
            case "m":
            case "d":
            case "y":
            case "h":
            case "s":
            case "e":
            case "g":
                return !0;
            case "A":
            case "a":
            case "\u4E0A":
                if ("A/P" === e.substr(t, 3).toUpperCase()) return !0;
                if ("AM/PM" === e.substr(t, 5).toUpperCase()) return !0;
                if ("\u4E0A\u5348/\u4E0B\u5348" === e.substr(t, 5).toUpperCase()) return !0;
                ++t;
                break;
            case "[":
                for(a = r; "]" !== e.charAt(t++) && t < e.length;)a += e.charAt(t);
                if (a.match(J)) return !0;
                break;
            case ".":
            case "0":
            case "#":
                for(; t < e.length && (-1 < "0#?.,E+-%".indexOf(r = e.charAt(++t)) || "\\" == r && "-" == e.charAt(t + 1) && -1 < "0#".indexOf(e.charAt(t + 2))););
                break;
            case "?":
                for(; e.charAt(++t) === r;);
                break;
            case "*":
                ++t, " " != e.charAt(t) && "*" != e.charAt(t) || ++t;
                break;
            case "(":
            case ")":
                ++t;
                break;
            case "1":
            case "2":
            case "3":
            case "4":
            case "5":
            case "6":
            case "7":
            case "8":
            case "9":
                for(; t < e.length && -1 < "0123456789".indexOf(e.charAt(++t)););
                break;
            case " ":
            default:
                ++t;
        }
        return !1;
    }
    function Z(e, t, r, a) {
        for(var n, s, i, o = [], c = "", l = 0, f = "", h = "t", u = "H"; l < e.length;)switch(f = e.charAt(l)){
            case "G":
                if (!A(e, l)) throw new Error("unrecognized character " + f + " in " + e);
                o[o.length] = {
                    t: "G",
                    v: "General"
                }, l += 7;
                break;
            case '"':
                for(c = ""; 34 !== (i = e.charCodeAt(++l)) && l < e.length;)c += String.fromCharCode(i);
                o[o.length] = {
                    t: "t",
                    v: c
                }, ++l;
                break;
            case "\\":
                var d = e.charAt(++l), p = "(" === d || ")" === d ? d : "t";
                o[o.length] = {
                    t: p,
                    v: d
                }, ++l;
                break;
            case "_":
                o[o.length] = {
                    t: "t",
                    v: " "
                }, l += 2;
                break;
            case "@":
                o[o.length] = {
                    t: "T",
                    v: t
                }, ++l;
                break;
            case "B":
            case "b":
                if ("1" === e.charAt(l + 1) || "2" === e.charAt(l + 1)) {
                    if (null == n && null == (n = L(t, r, "2" === e.charAt(l + 1)))) return "";
                    o[o.length] = {
                        t: "X",
                        v: e.substr(l, 2)
                    }, h = f, l += 2;
                    break;
                }
            case "M":
            case "D":
            case "Y":
            case "H":
            case "S":
            case "E":
                f = f.toLowerCase();
            case "m":
            case "d":
            case "y":
            case "h":
            case "s":
            case "e":
            case "g":
                if (t < 0) return "";
                if (null == n && null == (n = L(t, r))) return "";
                for(c = f; ++l < e.length && e.charAt(l).toLowerCase() === f;)c += f;
                "h" === (f = "m" === f && "h" === h.toLowerCase() ? "M" : f) && (f = u), o[o.length] = {
                    t: f,
                    v: c
                }, h = f;
                break;
            case "A":
            case "a":
            case "\u4E0A":
                d = {
                    t: f,
                    v: f
                };
                if (null == n && (n = L(t, r)), "A/P" === e.substr(l, 3).toUpperCase() ? (null != n && (d.v = 12 <= n.H ? "P" : "A"), d.t = "T", u = "h", l += 3) : "AM/PM" === e.substr(l, 5).toUpperCase() ? (null != n && (d.v = 12 <= n.H ? "PM" : "AM"), d.t = "T", l += 5, u = "h") : "\u4E0A\u5348/\u4E0B\u5348" === e.substr(l, 5).toUpperCase() ? (null != n && (d.v = 12 <= n.H ? "\u4E0B\u5348" : "\u4E0A\u5348"), d.t = "T", l += 5, u = "h") : (d.t = "t", ++l), null == n && "T" === d.t) return "";
                o[o.length] = d, h = f;
                break;
            case "[":
                for(c = f; "]" !== e.charAt(l++) && l < e.length;)c += e.charAt(l);
                if ("]" !== c.slice(-1)) throw 'unterminated "[" block: |' + c + "|";
                if (c.match(J)) {
                    if (null == n && null == (n = L(t, r))) return "";
                    o[o.length] = {
                        t: "Z",
                        v: c.toLowerCase()
                    }, h = c.charAt(1);
                } else -1 < c.indexOf("$") && (c = (c.match(/\$([^-\[\]]*)/) || [])[1] || "$", q(e) || (o[o.length] = {
                    t: "t",
                    v: c
                }));
                break;
            case ".":
                if (null != n) {
                    for(c = f; ++l < e.length && "0" === (f = e.charAt(l));)c += f;
                    o[o.length] = {
                        t: "s",
                        v: c
                    };
                    break;
                }
            case "0":
            case "#":
                for(c = f; ++l < e.length && -1 < "0#?.,E+-%".indexOf(f = e.charAt(l));)c += f;
                o[o.length] = {
                    t: "n",
                    v: c
                };
                break;
            case "?":
                for(c = f; e.charAt(++l) === f;)c += f;
                o[o.length] = {
                    t: f,
                    v: c
                }, h = f;
                break;
            case "*":
                ++l, " " != e.charAt(l) && "*" != e.charAt(l) || ++l;
                break;
            case "(":
            case ")":
                o[o.length] = {
                    t: 1 === a ? "t" : f,
                    v: f
                }, ++l;
                break;
            case "1":
            case "2":
            case "3":
            case "4":
            case "5":
            case "6":
            case "7":
            case "8":
            case "9":
                for(c = f; l < e.length && -1 < "0123456789".indexOf(e.charAt(++l));)c += e.charAt(l);
                o[o.length] = {
                    t: "D",
                    v: c
                };
                break;
            case " ":
                o[o.length] = {
                    t: f,
                    v: f
                }, ++l;
                break;
            case "$":
                o[o.length] = {
                    t: "t",
                    v: "$"
                }, ++l;
                break;
            default:
                if (-1 === ",$-+/():!^&'~{}<>=\u20ACacfijklopqrtuvwxzP".indexOf(f)) throw new Error("unrecognized character " + f + " in " + e);
                o[o.length] = {
                    t: "t",
                    v: f
                }, ++l;
        }
        var m, g = 0, b = 0;
        for(l = o.length - 1, h = "t"; 0 <= l; --l)switch(o[l].t){
            case "h":
            case "H":
                o[l].t = u, h = "h", g < 1 && (g = 1);
                break;
            case "s":
                (m = o[l].v.match(/\.0+$/)) && (b = Math.max(b, m[0].length - 1)), g < 3 && (g = 3);
            case "d":
            case "y":
            case "M":
            case "e":
                h = o[l].t;
                break;
            case "m":
                "s" === h && (o[l].t = "M", g < 2 && (g = 2));
                break;
            case "X":
                break;
            case "Z":
                (g = (g = g < 1 && o[l].v.match(/[Hh]/) ? 1 : g) < 2 && o[l].v.match(/[Mm]/) ? 2 : g) < 3 && o[l].v.match(/[Ss]/) && (g = 3);
        }
        switch(g){
            case 0:
                break;
            case 1:
                .5 <= n.u && (n.u = 0, ++n.S), 60 <= n.S && (n.S = 0, ++n.M), 60 <= n.M && (n.M = 0, ++n.H);
                break;
            case 2:
                .5 <= n.u && (n.u = 0, ++n.S), 60 <= n.S && (n.S = 0, ++n.M);
        }
        var v, w = "";
        for(l = 0; l < o.length; ++l)switch(o[l].t){
            case "t":
            case "T":
            case " ":
            case "D":
                break;
            case "X":
                o[l].v = "", o[l].t = ";";
                break;
            case "d":
            case "m":
            case "y":
            case "h":
            case "H":
            case "M":
            case "s":
            case "e":
            case "b":
            case "Z":
                o[l].v = function(e, t, r, a) {
                    var n, s = "", i = 0, o = 0, c = r.y, l = 0;
                    switch(e){
                        case 98:
                            c = r.y + 543;
                        case 121:
                            switch(t.length){
                                case 1:
                                case 2:
                                    n = c % 100, l = 2;
                                    break;
                                default:
                                    n = c % 1e4, l = 4;
                            }
                            break;
                        case 109:
                            switch(t.length){
                                case 1:
                                case 2:
                                    n = r.m, l = t.length;
                                    break;
                                case 3:
                                    return R[r.m - 1][1];
                                case 5:
                                    return R[r.m - 1][0];
                                default:
                                    return R[r.m - 1][2];
                            }
                            break;
                        case 100:
                            switch(t.length){
                                case 1:
                                case 2:
                                    n = r.d, l = t.length;
                                    break;
                                case 3:
                                    return C[r.q][0];
                                default:
                                    return C[r.q][1];
                            }
                            break;
                        case 104:
                            switch(t.length){
                                case 1:
                                case 2:
                                    n = 1 + (r.H + 11) % 12, l = t.length;
                                    break;
                                default:
                                    throw "bad hour format: " + t;
                            }
                            break;
                        case 72:
                            switch(t.length){
                                case 1:
                                case 2:
                                    n = r.H, l = t.length;
                                    break;
                                default:
                                    throw "bad hour format: " + t;
                            }
                            break;
                        case 77:
                            switch(t.length){
                                case 1:
                                case 2:
                                    n = r.M, l = t.length;
                                    break;
                                default:
                                    throw "bad minute format: " + t;
                            }
                            break;
                        case 115:
                            if ("s" != t && "ss" != t && ".0" != t && ".00" != t && ".000" != t) throw "bad second format: " + t;
                            return 0 !== r.u || "s" != t && "ss" != t ? (60 * (o = 2 <= a ? 3 === a ? 1e3 : 100 : 1 === a ? 10 : 1) <= (i = Math.round(o * (r.S + r.u))) && (i = 0), "s" === t ? 0 === i ? "0" : "" + i / o : (s = x(i, 2 + a), "ss" === t ? s.substr(0, 2) : "." + s.substr(2, t.length - 1))) : x(r.S, t.length);
                        case 90:
                            switch(t){
                                case "[h]":
                                case "[hh]":
                                    n = 24 * r.D + r.H;
                                    break;
                                case "[m]":
                                case "[mm]":
                                    n = 60 * (24 * r.D + r.H) + r.M;
                                    break;
                                case "[s]":
                                case "[ss]":
                                    n = 60 * (60 * (24 * r.D + r.H) + r.M) + Math.round(r.S + r.u);
                                    break;
                                default:
                                    throw "bad abstime format: " + t;
                            }
                            l = 3 === t.length ? 1 : 2;
                            break;
                        case 101:
                            n = c, l = 1;
                    }
                    return 0 < l ? x(n, l) : "";
                }(o[l].t.charCodeAt(0), o[l].v, n, b), o[l].t = "t";
                break;
            case "n":
            case "?":
                for(v = l + 1; null != o[v] && ("?" === (f = o[v].t) || "D" === f || (" " === f || "t" === f) && null != o[v + 1] && ("?" === o[v + 1].t || "t" === o[v + 1].t && "/" === o[v + 1].v) || "(" === o[l].t && (" " === f || "n" === f || ")" === f) || "t" === f && ("/" === o[v].v || " " === o[v].v && null != o[v + 1] && "?" == o[v + 1].t));)o[l].v += o[v].v, o[v] = {
                    v: "",
                    t: ";"
                }, ++v;
                w += o[l].v, l = v - 1;
                break;
            case "G":
                o[l].t = "t", o[l].v = P(t, r);
        }
        var T, E, k = "";
        if (0 < w.length) {
            40 == w.charCodeAt(0) ? (T = t < 0 && 45 === w.charCodeAt(0) ? -t : t, E = K("n", w, T)) : (E = K("n", w, T = t < 0 && 1 < a ? -t : t), T < 0 && o[0] && "t" == o[0].t && (E = E.substr(1), o[0].v = "-" + o[0].v)), v = E.length - 1;
            for(var y = o.length, l = 0; l < o.length; ++l)if (null != o[l] && "t" != o[l].t && -1 < o[l].v.indexOf(".")) {
                y = l;
                break;
            }
            var S = o.length;
            if (y === o.length && -1 === E.indexOf("E")) {
                for(l = o.length - 1; 0 <= l; --l)null != o[l] && -1 !== "n?".indexOf(o[l].t) && (v >= o[l].v.length - 1 ? (v -= o[l].v.length, o[l].v = E.substr(v + 1, o[l].v.length)) : v < 0 ? o[l].v = "" : (o[l].v = E.substr(0, v + 1), v = -1), o[l].t = "t", S = l);
                0 <= v && S < o.length && (o[S].v = E.substr(0, v + 1) + o[S].v);
            } else if (y !== o.length && -1 === E.indexOf("E")) {
                for(v = E.indexOf(".") - 1, l = y; 0 <= l; --l)if (null != o[l] && -1 !== "n?".indexOf(o[l].t)) {
                    for(s = -1 < o[l].v.indexOf(".") && l === y ? o[l].v.indexOf(".") - 1 : o[l].v.length - 1, k = o[l].v.substr(s + 1); 0 <= s; --s)0 <= v && ("0" === o[l].v.charAt(s) || "#" === o[l].v.charAt(s)) && (k = E.charAt(v--) + k);
                    o[l].v = k, o[l].t = "t", S = l;
                }
                for(0 <= v && S < o.length && (o[S].v = E.substr(0, v + 1) + o[S].v), v = E.indexOf(".") + 1, l = y; l < o.length; ++l)if (null != o[l] && (-1 !== "n?(".indexOf(o[l].t) || l === y)) {
                    for(s = -1 < o[l].v.indexOf(".") && l === y ? o[l].v.indexOf(".") + 1 : 0, k = o[l].v.substr(0, s); s < o[l].v.length; ++s)v < E.length && (k += E.charAt(v++));
                    o[l].v = k, o[l].t = "t", S = l;
                }
            }
        }
        for(l = 0; l < o.length; ++l)null != o[l] && -1 < "n?".indexOf(o[l].t) && (T = 1 < a && t < 0 && 0 < l && "-" === o[l - 1].v ? -t : t, o[l].v = K(o[l].t, o[l].v, T), o[l].t = "t");
        var _ = "";
        for(l = 0; l !== o.length; ++l)null != o[l] && (_ += o[l].v);
        return _;
    }
    var Q = /\[(=|>[=]?|<[>=]?)(-?\d+(?:\.\d*)?)\]/;
    function ge(e, t) {
        if (null != t) {
            var r = parseFloat(t[2]);
            switch(t[1]){
                case "=":
                    if (e == r) return 1;
                    break;
                case ">":
                    if (r < e) return 1;
                    break;
                case "<":
                    if (e < r) return 1;
                    break;
                case "<>":
                    if (e != r) return 1;
                    break;
                case ">=":
                    if (r <= e) return 1;
                    break;
                case "<=":
                    if (e <= r) return 1;
            }
        }
    }
    function be(e, t) {
        var r = function(e) {
            for(var t = [], r = !1, a = 0, n = 0; a < e.length; ++a)switch(e.charCodeAt(a)){
                case 34:
                    r = !r;
                    break;
                case 95:
                case 42:
                case 92:
                    ++a;
                    break;
                case 59:
                    t[t.length] = e.substr(n, a - n), n = a + 1;
            }
            if (t[t.length] = e.substr(n), !0 === r) throw new Error("Format |" + e + "| unterminated string ");
            return t;
        }(e), a = r.length, n = r[a - 1].indexOf("@");
        if (a < 4 && -1 < n && --a, 4 < r.length) throw new Error("cannot find right format for |" + r.join("|") + "|");
        if ("number" != typeof t) return [
            4,
            4 === r.length || -1 < n ? r[r.length - 1] : "@"
        ];
        switch(r.length){
            case 1:
                r = -1 < n ? [
                    "General",
                    "General",
                    "General",
                    r[0]
                ] : [
                    r[0],
                    r[0],
                    r[0],
                    "@"
                ];
                break;
            case 2:
                r = -1 < n ? [
                    r[0],
                    r[0],
                    r[0],
                    r[1]
                ] : [
                    r[0],
                    r[1],
                    r[0],
                    "@"
                ];
                break;
            case 3:
                r = -1 < n ? [
                    r[0],
                    r[1],
                    r[0],
                    r[2]
                ] : [
                    r[0],
                    r[1],
                    r[2],
                    "@"
                ];
        }
        var s = 0 < t ? r[0] : t < 0 ? r[1] : r[2];
        if (-1 === r[0].indexOf("[") && -1 === r[1].indexOf("[")) return [
            a,
            s
        ];
        if (null == r[0].match(/\[[=<>]/) && null == r[1].match(/\[[=<>]/)) return [
            a,
            s
        ];
        e = r[0].match(Q), s = r[1].match(Q);
        return ge(t, e) ? [
            a,
            r[0]
        ] : ge(t, s) ? [
            a,
            r[1]
        ] : [
            a,
            r[null != e && null != s ? 2 : 1]
        ];
    }
    function ve(e, t, r) {
        null == r && (r = {});
        var a = "";
        switch(typeof e){
            case "string":
                a = "m/d/yy" == e && r.dateNF ? r.dateNF : e;
                break;
            case "number":
                null == (a = null == (a = 14 == e && r.dateNF ? r.dateNF : (null != r.table ? r.table : me)[e]) ? r.table && r.table[b[e]] || me[b[e]] : a) && (a = k[e] || "General");
        }
        if (A(a, 0)) return P(t, r);
        var n = be(a, t = t instanceof Date ? N(t, r.date1904) : t);
        if (A(n[1])) return P(t, r);
        if (!0 === t) t = "TRUE";
        else if (!1 === t) t = "FALSE";
        else if ("" === t || null == t) return "";
        return Z(n[1], t, r, n[0]);
    }
    function we(e, t) {
        if ("number" != typeof t) {
            t = +t || -1;
            for(var r = 0; r < 392; ++r)if (null != me[r]) {
                if (me[r] == e) {
                    t = r;
                    break;
                }
            } else t < 0 && (t = r);
            t < 0 && (t = 391);
        }
        return me[t] = e, t;
    }
    function Te(e) {
        for(var t = 0; 392 != t; ++t)void 0 !== e[t] && we(e[t], t);
    }
    function Ee() {
        var e;
        (e = e || {})[0] = "General", e[1] = "0", e[2] = "0.00", e[3] = "#,##0", e[4] = "#,##0.00", e[9] = "0%", e[10] = "0.00%", e[11] = "0.00E+00", e[12] = "# ?/?", e[13] = "# ??/??", e[14] = "m/d/yy", e[15] = "d-mmm-yy", e[16] = "d-mmm", e[17] = "mmm-yy", e[18] = "h:mm AM/PM", e[19] = "h:mm:ss AM/PM", e[20] = "h:mm", e[21] = "h:mm:ss", e[22] = "m/d/yy h:mm", e[37] = "#,##0 ;(#,##0)", e[38] = "#,##0 ;[Red](#,##0)", e[39] = "#,##0.00;(#,##0.00)", e[40] = "#,##0.00;[Red](#,##0.00)", e[45] = "mm:ss", e[46] = "[h]:mm:ss", e[47] = "mmss.0", e[48] = "##0.0E+0", e[49] = "@", e[56] = '"\u4E0A\u5348/\u4E0B\u5348 "hh"\u6642"mm"\u5206"ss"\u79D2 "', me = e;
    }
    var e = {
        format: ve,
        load: we,
        _table: me,
        load_table: Te,
        parse_date_code: L,
        is_date: q,
        get_table: function() {
            return e._table = me;
        }
    }, ke = {
        5: '"$"#,##0_);\\("$"#,##0\\)',
        6: '"$"#,##0_);[Red]\\("$"#,##0\\)',
        7: '"$"#,##0.00_);\\("$"#,##0.00\\)',
        8: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
        23: "General",
        24: "General",
        25: "General",
        26: "General",
        27: "m/d/yy",
        28: "m/d/yy",
        29: "m/d/yy",
        30: "m/d/yy",
        31: "m/d/yy",
        32: "h:mm:ss",
        33: "h:mm:ss",
        34: "h:mm:ss",
        35: "h:mm:ss",
        36: "m/d/yy",
        41: '_(* #,##0_);_(* (#,##0);_(* "-"_);_(@_)',
        42: '_("$"* #,##0_);_("$"* (#,##0);_("$"* "-"_);_(@_)',
        43: '_(* #,##0.00_);_(* (#,##0.00);_(* "-"??_);_(@_)',
        44: '_("$"* #,##0.00_);_("$"* (#,##0.00);_("$"* "-"??_);_(@_)',
        50: "m/d/yy",
        51: "m/d/yy",
        52: "m/d/yy",
        53: "m/d/yy",
        54: "m/d/yy",
        55: "m/d/yy",
        56: "m/d/yy",
        57: "m/d/yy",
        58: "m/d/yy",
        59: "0",
        60: "0.00",
        61: "#,##0",
        62: "#,##0.00",
        63: '"$"#,##0_);\\("$"#,##0\\)',
        64: '"$"#,##0_);[Red]\\("$"#,##0\\)',
        65: '"$"#,##0.00_);\\("$"#,##0.00\\)',
        66: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
        67: "0%",
        68: "0.00%",
        69: "# ?/?",
        70: "# ??/??",
        71: "m/d/yy",
        72: "m/d/yy",
        73: "d-mmm-yy",
        74: "d-mmm",
        75: "mmm-yy",
        76: "h:mm",
        77: "h:mm:ss",
        78: "m/d/yy h:mm",
        79: "mm:ss",
        80: "[h]:mm:ss",
        81: "mmss.0"
    }, ye = /[dD]+|[mM]+|[yYeE]+|[Hh]+|[Ss]+/g;
    var Se, _e = function() {
        var e = {};
        e.version = "1.2.0";
        var o = function() {
            for(var e = 0, t = new Array(256), r = 0; 256 != r; ++r)e = 1 & (e = 1 & (e = 1 & (e = 1 & (e = 1 & (e = 1 & (e = 1 & (e = 1 & (e = r) ? -306674912 ^ e >>> 1 : e >>> 1) ? -306674912 ^ e >>> 1 : e >>> 1) ? -306674912 ^ e >>> 1 : e >>> 1) ? -306674912 ^ e >>> 1 : e >>> 1) ? -306674912 ^ e >>> 1 : e >>> 1) ? -306674912 ^ e >>> 1 : e >>> 1) ? -306674912 ^ e >>> 1 : e >>> 1) ? -306674912 ^ e >>> 1 : e >>> 1, t[r] = e;
            return "undefined" != typeof Int32Array ? new Int32Array(t) : t;
        }();
        var t = function(e) {
            for(var t = 0, r = 0, a = 0, n = new ("undefined" != typeof Int32Array ? Int32Array : Array)(4096), a = 0; 256 != a; ++a)n[a] = e[a];
            for(a = 0; 256 != a; ++a)for(r = e[a], t = 256 + a; t < 4096; t += 256)r = n[t] = r >>> 8 ^ e[255 & r];
            var s = [];
            for(a = 1; 16 != a; ++a)s[a - 1] = "undefined" != typeof Int32Array ? n.subarray(256 * a, 256 * a + 256) : n.slice(256 * a, 256 * a + 256);
            return s;
        }(o), s = t[0], i = t[1], c = t[2], l = t[3], f = t[4], h = t[5], u = t[6], d = t[7], p = t[8], m = t[9], g = t[10], b = t[11], v = t[12], w = t[13], T = t[14];
        return e.table = o, e.bstr = function(e, t) {
            for(var r = -1 ^ t, a = 0, n = e.length; a < n;)r = r >>> 8 ^ o[255 & (r ^ e.charCodeAt(a++))];
            return ~r;
        }, e.buf = function(e, t) {
            for(var r = -1 ^ t, a = e.length - 15, n = 0; n < a;)r = T[e[n++] ^ 255 & r] ^ w[e[n++] ^ r >> 8 & 255] ^ v[e[n++] ^ r >> 16 & 255] ^ b[e[n++] ^ r >>> 24] ^ g[e[n++]] ^ m[e[n++]] ^ p[e[n++]] ^ d[e[n++]] ^ u[e[n++]] ^ h[e[n++]] ^ f[e[n++]] ^ l[e[n++]] ^ c[e[n++]] ^ i[e[n++]] ^ s[e[n++]] ^ o[e[n++]];
            for(a += 15; n < a;)r = r >>> 8 ^ o[255 & (r ^ e[n++])];
            return ~r;
        }, e.str = function(e, t) {
            for(var r, a = -1 ^ t, n = 0, s = e.length, i = 0; n < s;)a = (i = e.charCodeAt(n++)) < 128 ? a >>> 8 ^ o[255 & (a ^ i)] : i < 2048 ? (a = a >>> 8 ^ o[255 & (a ^ (192 | i >> 6 & 31))]) >>> 8 ^ o[255 & (a ^ (128 | 63 & i))] : 55296 <= i && i < 57344 ? (i = 64 + (1023 & i), r = 1023 & e.charCodeAt(n++), (a = (a = (a = a >>> 8 ^ o[255 & (a ^ (240 | i >> 8 & 7))]) >>> 8 ^ o[255 & (a ^ (128 | i >> 2 & 63))]) >>> 8 ^ o[255 & (a ^ (128 | r >> 6 & 15 | (3 & i) << 4))]) >>> 8 ^ o[255 & (a ^ (128 | 63 & r))]) : (a = (a = a >>> 8 ^ o[255 & (a ^ (224 | i >> 12 & 15))]) >>> 8 ^ o[255 & (a ^ (128 | i >> 6 & 63))]) >>> 8 ^ o[255 & (a ^ (128 | 63 & i))];
            return ~a;
        }, e;
    }(), xe = function() {
        var s, e = {};
        function d(e) {
            if ("/" == e.charAt(e.length - 1)) return -1 === e.slice(0, -1).indexOf("/") ? e : d(e.slice(0, -1));
            var t = e.lastIndexOf("/");
            return -1 === t ? e : e.slice(0, t + 1);
        }
        function p(e) {
            if ("/" == e.charAt(e.length - 1)) return p(e.slice(0, -1));
            var t = e.lastIndexOf("/");
            return -1 === t ? e : e.slice(t + 1);
        }
        function g(e) {
            Dr(e, 0);
            for(var t, r = {}; e.l <= e.length - 4;){
                var a = e.read_shift(2), n = e.read_shift(2), s = e.l + n, i = {};
                21589 === a && (1 & (t = e.read_shift(1)) && (i.mtime = e.read_shift(4)), 5 < n && (2 & t && (i.atime = e.read_shift(4)), 4 & t && (i.ctime = e.read_shift(4))), i.mtime && (i.mt = new Date(1e3 * i.mtime))), e.l = s, r[a] = i;
            }
            return r;
        }
        function i() {
            return s = s || (parcelRequire("kjyEk"));
        }
        function o(e, t) {
            if (80 == e[0] && 75 == e[1]) return q(e, t);
            if (109 == (32 | e[0]) && 105 == (32 | e[1])) return function(e, t) {
                if ("mime-version:" != _(e.slice(0, 13)).toLowerCase()) throw new Error("Unsupported MAD header");
                var r = t && t.root || "", a = (se && $4249f69807f0687b$require$Buffer.isBuffer(e) ? e.toString("binary") : _(e)).split("\r\n"), n = 0, s = "";
                for(n = 0; n < a.length; ++n)if (s = a[n], /^Content-Location:/i.test(s) && (s = s.slice(s.indexOf("file")), r = r || s.slice(0, s.lastIndexOf("/") + 1), s.slice(0, r.length) != r)) for(; 0 < r.length && (r = (r = r.slice(0, r.length - 1)).slice(0, r.lastIndexOf("/") + 1), s.slice(0, r.length) != r););
                e = (a[1] || "").match(/boundary="(.*?)"/);
                if (!e) throw new Error("MAD cannot find boundary");
                var i = "--" + (e[1] || ""), o = {
                    FileIndex: [],
                    FullPaths: []
                };
                w(o);
                var c, l = 0;
                for(n = 0; n < a.length; ++n){
                    var f = a[n];
                    f !== i && f !== i + "--" || (l++ && function(e, t, r) {
                        for(var a, n = "", s = "", i = "", o = 0; o < 10; ++o){
                            var c = t[o];
                            if (!c || c.match(/^\s*$/)) break;
                            var l = c.match(/^(.*?):\s*([^\s].*)$/);
                            if (l) switch(l[1].toLowerCase()){
                                case "content-location":
                                    n = l[2].trim();
                                    break;
                                case "content-type":
                                    i = l[2].trim();
                                    break;
                                case "content-transfer-encoding":
                                    s = l[2].trim();
                            }
                        }
                        switch(++o, s.toLowerCase()){
                            case "base64":
                                a = he(te(t.slice(o).join("")));
                                break;
                            case "quoted-printable":
                                a = function(e) {
                                    for(var t = [], r = 0; r < e.length; ++r){
                                        for(var a = e[r]; r <= e.length && "=" == a.charAt(a.length - 1);)a = a.slice(0, a.length - 1) + e[++r];
                                        t.push(a);
                                    }
                                    for(var n = 0; n < t.length; ++n)t[n] = t[n].replace(/[=][0-9A-Fa-f]{2}/g, function(e) {
                                        return String.fromCharCode(parseInt(e.slice(1), 16));
                                    });
                                    return he(t.join("\r\n"));
                                }(t.slice(o));
                                break;
                            default:
                                throw new Error("Unsupported Content-Transfer-Encoding " + s);
                        }
                        r = Q(e, n.slice(r.length), a, {
                            unsafe: !0
                        }), i && (r.ctype = i);
                    }(o, a.slice(c, n), r), c = n);
                }
                return o;
            }(e, t);
            if (e.length < 512) throw new Error("CFB file size " + e.length + " < 512");
            var r, m, a, n = 3, s = 512, i = 0, o = [], c = e.slice(0, 512);
            Dr(c, 0);
            var l = function(e) {
                if (80 == e[e.l] && 75 == e[e.l + 1]) return [
                    0,
                    0
                ];
                e.chk(y, "Header Signature: "), e.l += 16;
                var t = e.read_shift(2, "u");
                return [
                    e.read_shift(2, "u"),
                    t
                ];
            }(c);
            switch(n = l[0]){
                case 3:
                    s = 512;
                    break;
                case 4:
                    s = 4096;
                    break;
                case 0:
                    if (0 == l[1]) return q(e, t);
                default:
                    throw new Error("Major Version: Expected 3 or 4 saw " + n);
            }
            512 !== s && Dr(c = e.slice(0, s), 28);
            var f = e.slice(0, s);
            !function(e, t) {
                var r = 9;
                switch(e.l += 2, r = e.read_shift(2)){
                    case 9:
                        if (3 != t) throw new Error("Sector Shift: Expected 9 saw " + r);
                        break;
                    case 12:
                        if (4 != t) throw new Error("Sector Shift: Expected 12 saw " + r);
                        break;
                    default:
                        throw new Error("Sector Shift: Expected 9 or 12 saw " + r);
                }
                e.chk("0600", "Mini Sector Shift: "), e.chk("000000000000", "Reserved: ");
            }(c, n);
            var h = c.read_shift(4, "i");
            if (3 === n && 0 !== h) throw new Error("# Directory Sectors: Expected 0 saw " + h);
            c.l += 4, m = c.read_shift(4, "i"), c.l += 4, c.chk("00100000", "Mini Stream Cutoff Size: "), a = c.read_shift(4, "i"), r = c.read_shift(4, "i"), b = c.read_shift(4, "i"), i = c.read_shift(4, "i");
            for(var u, d = 0; d < 109 && !((u = c.read_shift(4, "i")) < 0); ++d)o[d] = u;
            var p = function(e, t) {
                for(var r = Math.ceil(e.length / t) - 1, a = [], n = 1; n < r; ++n)a[n - 1] = e.slice(n * t, (n + 1) * t);
                return a[r - 1] = e.slice(r * t), a;
            }(e, s);
            !function e(t, r, a, n, s) {
                var i = k;
                if (t === k) {
                    if (0 !== r) throw new Error("DIFAT chain shorter than expected");
                } else if (-1 !== t) {
                    var o = a[t], c = (n >>> 2) - 1;
                    if (o) {
                        for(var l = 0; l < c && (i = xr(o, 4 * l)) !== k; ++l)s.push(i);
                        e(xr(o, n - 4), r - 1, a, n, s);
                    }
                }
            }(b, i, p, s, o);
            var g = function(e, t, r, a) {
                var n = e.length, s = [], i = [], o = [], c = [], l = a - 1, f = 0, h = 0, u = 0, d = 0;
                for(f = 0; f < n; ++f)if (o = [], n <= (u = f + t) && (u -= n), !i[u]) {
                    c = [];
                    var p = [];
                    for(h = u; 0 <= h;){
                        p[h] = !0, i[h] = !0, o[o.length] = h, c.push(e[h]);
                        var m = r[Math.floor(4 * h / a)];
                        if (a < 4 + (d = 4 * h & l)) throw new Error("FAT boundary crossed: " + h + " 4 " + a);
                        if (!e[m]) break;
                        if (h = xr(e[m], d), p[h]) break;
                    }
                    s[u] = {
                        nodes: o,
                        data: hr([
                            c
                        ])
                    };
                }
                return s;
            }(p, m, o, s);
            g[m].name = "!Directory", 0 < r && a !== k && (g[a].name = "!MiniFAT"), g[o[0]].name = "!FAT", g.fat_addrs = o, g.ssz = s;
            var h = [], b = [], i = [];
            !function(e, t, r, a, n, s, i) {
                for(var o, c = 0, l = r.length ? 2 : 0, f = e[m].data, h = 0, u = 0; h < f.length; h += 128){
                    var d = f.slice(h, h + 128);
                    Dr(d, 64), u = d.read_shift(2), o = ur(d, 0, u - l), r.push(o);
                    var p = {
                        name: o,
                        type: d.read_shift(1),
                        color: d.read_shift(1),
                        L: d.read_shift(4, "i"),
                        R: d.read_shift(4, "i"),
                        C: d.read_shift(4, "i"),
                        clsid: d.read_shift(16),
                        state: d.read_shift(4, "i"),
                        start: 0,
                        size: 0
                    };
                    0 !== d.read_shift(2) + d.read_shift(2) + d.read_shift(2) + d.read_shift(2) && (p.ct = v(d, d.l - 8)), 0 !== d.read_shift(2) + d.read_shift(2) + d.read_shift(2) + d.read_shift(2) && (p.mt = v(d, d.l - 8)), p.start = d.read_shift(4, "i"), p.size = d.read_shift(4, "i"), p.size < 0 && p.start < 0 && (p.size = p.type = 0, p.start = k, p.name = ""), 5 === p.type ? (c = p.start, 0 < a && c !== k && (e[c].name = "!StreamData")) : 4096 <= p.size ? (p.storage = "fat", void 0 === e[p.start] && (e[p.start] = function(e, t, r, a, n) {
                        var s = [], i = [];
                        n = n || [];
                        var o = a - 1, c = 0, l = 0;
                        for(c = t; 0 <= c;){
                            n[c] = !0, s[s.length] = c, i.push(e[c]);
                            var f = r[Math.floor(4 * c / a)];
                            if (a < 4 + (l = 4 * c & o)) throw new Error("FAT boundary crossed: " + c + " 4 " + a);
                            if (!e[f]) break;
                            c = xr(e[f], l);
                        }
                        return {
                            nodes: s,
                            data: hr([
                                i
                            ])
                        };
                    }(t, p.start, e.fat_addrs, e.ssz)), e[p.start].name = p.name, p.content = e[p.start].data.slice(0, p.size)) : (p.storage = "minifat", p.size < 0 ? p.size = 0 : c !== k && p.start !== k && e[c] && (p.content = function(e, t, r) {
                        var a = e.start, n = e.size, s = [], i = a;
                        for(; r && 0 < n && 0 <= i;)s.push(t.slice(i * E, i * E + E)), n -= E, i = xr(r, 4 * i);
                        return 0 === s.length ? Lr(0) : ue(s).slice(0, e.size);
                    }(p, e[c].data, (e[i] || {}).data))), p.content && Dr(p.content, 0), n[o] = p, s.push(p);
                }
            }(g, p, h, r, {}, b, a), function(e, t, r) {
                for(var a = 0, n = 0, s = 0, i = 0, o = 0, c = r.length, l = [], f = []; a < c; ++a)l[a] = f[a] = a, t[a] = r[a];
                for(; o < f.length; ++o)a = f[o], n = e[a].L, s = e[a].R, i = e[a].C, l[a] === a && (-1 !== n && l[n] !== n && (l[a] = l[n]), -1 !== s && l[s] !== s && (l[a] = l[s])), -1 !== i && (l[i] = a), -1 !== n && a != l[a] && (l[n] = l[a], f.lastIndexOf(n) < o && f.push(n)), -1 !== s && a != l[a] && (l[s] = l[a], f.lastIndexOf(s) < o && f.push(s));
                for(a = 1; a < c; ++a)l[a] === a && (-1 !== s && l[s] !== s ? l[a] = l[s] : -1 !== n && l[n] !== n && (l[a] = l[n]));
                for(a = 1; a < c; ++a)if (0 !== e[a].type) {
                    if ((o = a) != l[o]) for(; o = l[o], t[a] = t[o] + "/" + t[a], 0 !== o && -1 !== l[o] && o != l[o];);
                    l[a] = -1;
                }
                for(t[0] += "/", a = 1; a < c; ++a)2 !== e[a].type && (t[a] += "/");
            }(b, i, h), h.shift();
            i = {
                FileIndex: b,
                FullPaths: i
            };
            return t && t.raw && (i.raw = {
                header: f,
                sectors: p
            }), i;
        }
        function v(e, t) {
            return new Date(1e3 * (_r(e, t + 4) / 1e7 * Math.pow(2, 32) + _r(e, t) / 1e7 - 11644473600));
        }
        function w(e, t) {
            var r = t || {}, t = r.root || "Root Entry";
            if (e.FullPaths || (e.FullPaths = []), e.FileIndex || (e.FileIndex = []), e.FullPaths.length !== e.FileIndex.length) throw new Error("inconsistent CFB structure");
            0 === e.FullPaths.length && (e.FullPaths[0] = t + "/", e.FileIndex[0] = {
                name: t,
                type: 5
            }), r.CLSID && (e.FileIndex[0].clsid = r.CLSID), t = e, r = "Sh33tJ5", xe.find(t, "/" + r) || ((e = Lr(4))[0] = 55, e[1] = e[3] = 50, e[2] = 54, t.FileIndex.push({
                name: r,
                type: 2,
                content: e,
                size: 4,
                L: 69,
                R: 69,
                C: 69
            }), t.FullPaths.push(t.FullPaths[0] + r), u(t));
        }
        function u(e, t) {
            w(e);
            for(var r = !1, a = !1, n = e.FullPaths.length - 1; 0 <= n; --n){
                var s = e.FileIndex[n];
                switch(s.type){
                    case 0:
                        a ? r = !0 : (e.FileIndex.pop(), e.FullPaths.pop());
                        break;
                    case 1:
                    case 2:
                    case 5:
                        a = !0, isNaN(s.R * s.L * s.C) && (r = !0), -1 < s.R && -1 < s.L && s.R == s.L && (r = !0);
                        break;
                    default:
                        r = !0;
                }
            }
            if (r || t) {
                for(var i = new Date(1987, 1, 19), o = 0, c = Object.create ? Object.create(null) : {}, l = [], n = 0; n < e.FullPaths.length; ++n)c[e.FullPaths[n]] = !0, 0 !== e.FileIndex[n].type && l.push([
                    e.FullPaths[n],
                    e.FileIndex[n]
                ]);
                for(n = 0; n < l.length; ++n){
                    var f = d(l[n][0]);
                    (a = c[f]) || (l.push([
                        f,
                        {
                            name: p(f).replace("/", ""),
                            type: 1,
                            clsid: b,
                            ct: i,
                            mt: i,
                            content: null
                        }
                    ]), c[f] = !0);
                }
                for(l.sort(function(e, t) {
                    return function(e, t) {
                        for(var r, a = e.split("/"), n = t.split("/"), s = 0, i = Math.min(a.length, n.length); s < i; ++s){
                            if (r = a[s].length - n[s].length) return r;
                            if (a[s] != n[s]) return a[s] < n[s] ? -1 : 1;
                        }
                        return a.length - n.length;
                    }(e[0], t[0]);
                }), e.FullPaths = [], e.FileIndex = [], n = 0; n < l.length; ++n)e.FullPaths[n] = l[n][0], e.FileIndex[n] = l[n][1];
                for(n = 0; n < l.length; ++n){
                    var h = e.FileIndex[n], u = e.FullPaths[n];
                    if (h.name = p(u).replace("/", ""), h.L = h.R = h.C = -(h.color = 1), h.size = h.content ? h.content.length : 0, h.start = 0, h.clsid = h.clsid || b, 0 === n) h.C = 1 < l.length ? 1 : -1, h.size = 0, h.type = 5;
                    else if ("/" == u.slice(-1)) {
                        for(o = n + 1; o < l.length && d(e.FullPaths[o]) != u; ++o);
                        for(h.C = o >= l.length ? -1 : o, o = n + 1; o < l.length && d(e.FullPaths[o]) != d(u); ++o);
                        h.R = o >= l.length ? -1 : o, h.type = 1;
                    } else d(e.FullPaths[n + 1] || "") == d(u) && (h.R = n + 1), h.type = 2;
                }
            }
        }
        function a(e, t) {
            var r = t || {};
            if ("mad" == r.fileType) return function(e, t) {
                for(var r = t || {}, a = r.boundary || "SheetJS", n = [
                    "MIME-Version: 1.0",
                    'Content-Type: multipart/related; boundary="' + (a = "------=" + a).slice(2) + '"',
                    "",
                    "",
                    ""
                ], s = e.FullPaths[0], i = s, o = e.FileIndex[0], c = 1; c < e.FullPaths.length; ++c)if (i = e.FullPaths[c].slice(s.length), (o = e.FileIndex[c]).size && o.content && "Sh33tJ5" != i) {
                    i = i.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF]/g, function(e) {
                        return "_x" + e.charCodeAt(0).toString(16) + "_";
                    }).replace(/[\u0080-\uFFFF]/g, function(e) {
                        return "_u" + e.charCodeAt(0).toString(16) + "_";
                    });
                    for(var l = o.content, f = se && $4249f69807f0687b$require$Buffer.isBuffer(l) ? l.toString("binary") : _(l), h = 0, u = Math.min(1024, f.length), d = 0, p = 0; p <= u; ++p)32 <= (d = f.charCodeAt(p)) && d < 128 && ++h;
                    l = 4 * u / 5 <= h;
                    n.push(a), n.push("Content-Location: " + (r.root || "file:///C:/SheetJS/") + i), n.push("Content-Transfer-Encoding: " + (l ? "quoted-printable" : "base64")), n.push("Content-Type: " + function(e, t) {
                        if (e.ctype) return e.ctype;
                        var r = e.name || "", e = r.match(/\.([^\.]+)$/);
                        if (e && Z[e[1]]) return Z[e[1]];
                        if (t && (e = (r = t).match(/[\.\\]([^\.\\])+$/)) && Z[e[1]]) return Z[e[1]];
                        return "application/octet-stream";
                    }(o, i)), n.push(""), n.push((l ? function(e) {
                        e = e.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF=]/g, function(e) {
                            e = e.charCodeAt(0).toString(16).toUpperCase();
                            return "=" + (1 == e.length ? "0" + e : e);
                        });
                        "\n" == (e = e.replace(/ $/gm, "=20").replace(/\t$/gm, "=09")).charAt(0) && (e = "=0D" + e.slice(1));
                        e = e.replace(/\r(?!\n)/gm, "=0D").replace(/\n\n/gm, "\n=0A").replace(/([^\r\n])\n/gm, "$1=0A");
                        for(var t = [], r = e.split("\r\n"), a = 0; a < r.length; ++a){
                            var n = r[a];
                            if (0 != n.length) for(var s = 0; s < n.length;){
                                var i = 76, o = n.slice(s, s + i);
                                "=" == o.charAt(i - 1) ? i-- : "=" == o.charAt(i - 2) ? i -= 2 : "=" == o.charAt(i - 3) && (i -= 3), o = n.slice(s, s + i), (s += i) < n.length && (o += "="), t.push(o);
                            }
                            else t.push("");
                        }
                        return t.join("\r\n");
                    } : function(e) {
                        for(var t = ee(e), r = [], a = 0; a < t.length; a += 76)r.push(t.slice(a, a + 76));
                        return r.join("\r\n") + "\r\n";
                    })(f));
                }
                return n.push(a + "--\r\n"), n.join("\r\n");
            }(e, r);
            if (u(e), "zip" === r.fileType) return function(e, t) {
                var t = t || {}, r = [], a = [], n = Lr(1), s = t.compression ? 8 : 0, i = 0;
                var o = 0, c = 0, l = 0, f = 0, h = e.FullPaths[0], u = h, d = e.FileIndex[0], p = [], m = 0;
                for(o = 1; o < e.FullPaths.length; ++o)if (u = e.FullPaths[o].slice(h.length), (d = e.FileIndex[o]).size && d.content && "Sh33tJ5" != u) {
                    var g = l, b = Lr(u.length);
                    for(c = 0; c < u.length; ++c)b.write_shift(1, 127 & u.charCodeAt(c));
                    b = b.slice(0, b.l), p[f] = _e.buf(d.content, 0);
                    var v = d.content;
                    8 == s && (v = function(e) {
                        return T ? T.deflateRawSync(e) : V(e);
                    }(v)), (n = Lr(30)).write_shift(4, 67324752), n.write_shift(2, 20), n.write_shift(2, i), n.write_shift(2, s), d.mt ? function(e, t) {
                        var r = (t = "string" == typeof t ? new Date(t) : t).getHours();
                        r = (r = r << 6 | t.getMinutes()) << 5 | t.getSeconds() >>> 1, e.write_shift(2, r), r = (r = (r = t.getFullYear() - 1980) << 4 | t.getMonth() + 1) << 5 | t.getDate(), e.write_shift(2, r);
                    }(n, d.mt) : n.write_shift(4, 0), n.write_shift(-4, 8 & i ? 0 : p[f]), n.write_shift(4, 8 & i ? 0 : v.length), n.write_shift(4, 8 & i ? 0 : d.content.length), n.write_shift(2, b.length), n.write_shift(2, 0), l += n.length, r.push(n), l += b.length, r.push(b), l += v.length, r.push(v), 8 & i && ((n = Lr(12)).write_shift(-4, p[f]), n.write_shift(4, v.length), n.write_shift(4, d.content.length), l += n.l, r.push(n)), (n = Lr(46)).write_shift(4, 33639248), n.write_shift(2, 0), n.write_shift(2, 20), n.write_shift(2, i), n.write_shift(2, s), n.write_shift(4, 0), n.write_shift(-4, p[f]), n.write_shift(4, v.length), n.write_shift(4, d.content.length), n.write_shift(2, b.length), n.write_shift(2, 0), n.write_shift(2, 0), n.write_shift(2, 0), n.write_shift(2, 0), n.write_shift(4, 0), n.write_shift(4, g), m += n.l, a.push(n), m += b.length, a.push(b), ++f;
                }
                return (n = Lr(22)).write_shift(4, 101010256), n.write_shift(2, 0), n.write_shift(2, 0), n.write_shift(2, f), n.write_shift(2, f), n.write_shift(4, m), n.write_shift(4, l), n.write_shift(2, 0), ue([
                    ue(r),
                    ue(a),
                    n
                ]);
            }(e, r);
            for(var a = function(e) {
                for(var t = 0, r = 0, a = 0; a < e.FileIndex.length; ++a){
                    var n = e.FileIndex[a];
                    n.content && 0 < (n = n.content.length) && (n < 4096 ? t += n + 63 >> 6 : r += n + 511 >> 9);
                }
                for(var s = e.FullPaths.length + 3 >> 2, i = t + 127 >> 7, o = (t + 7 >> 3) + r + s + i, c = o + 127 >> 7, l = c <= 109 ? 0 : Math.ceil((c - 109) / 127); c < o + c + l + 127 >> 7;)l = ++c <= 109 ? 0 : Math.ceil((c - 109) / 127);
                s = [
                    1,
                    l,
                    c,
                    i,
                    s,
                    r,
                    t,
                    0
                ];
                return e.FileIndex[0].size = t << 6, s[7] = (e.FileIndex[0].start = s[0] + s[1] + s[2] + s[3] + s[4] + s[5]) + (s[6] + 7 >> 3), s;
            }(e), n = Lr(a[7] << 9), s = 0, i = 0, s = 0; s < 8; ++s)n.write_shift(1, m[s]);
            for(s = 0; s < 8; ++s)n.write_shift(2, 0);
            for(n.write_shift(2, 62), n.write_shift(2, 3), n.write_shift(2, 65534), n.write_shift(2, 9), n.write_shift(2, 6), s = 0; s < 3; ++s)n.write_shift(2, 0);
            for(n.write_shift(4, 0), n.write_shift(4, a[2]), n.write_shift(4, a[0] + a[1] + a[2] + a[3] - 1), n.write_shift(4, 0), n.write_shift(4, 4096), n.write_shift(4, a[3] ? a[0] + a[1] + a[2] - 1 : k), n.write_shift(4, a[3]), n.write_shift(-4, a[1] ? a[0] - 1 : k), n.write_shift(4, a[1]), s = 0; s < 109; ++s)n.write_shift(-4, s < a[2] ? a[1] + s : -1);
            if (a[1]) for(i = 0; i < a[1]; ++i){
                for(; s < 236 + 127 * i; ++s)n.write_shift(-4, s < a[2] ? a[1] + s : -1);
                n.write_shift(-4, i === a[1] - 1 ? k : i + 1);
            }
            function o(e) {
                for(i += e; s < i - 1; ++s)n.write_shift(-4, s + 1);
                e && (++s, n.write_shift(-4, k));
            }
            i = s = 0;
            for(i += a[1]; s < i; ++s)n.write_shift(-4, S.DIFSECT);
            for(i += a[2]; s < i; ++s)n.write_shift(-4, S.FATSECT);
            o(a[3]), o(a[4]);
            for(var c = 0, l = 0, f = e.FileIndex[0]; c < e.FileIndex.length; ++c)(f = e.FileIndex[c]).content && ((l = f.content.length) < 4096 || (f.start = i, o(l + 511 >> 9)));
            for(o(a[6] + 7 >> 3); 511 & n.l;)n.write_shift(-4, S.ENDOFCHAIN);
            for(c = i = s = 0; c < e.FileIndex.length; ++c)(f = e.FileIndex[c]).content && (!(l = f.content.length) || 4096 <= l || (f.start = i, o(l + 63 >> 6)));
            for(; 511 & n.l;)n.write_shift(-4, S.ENDOFCHAIN);
            for(s = 0; s < a[4] << 2; ++s){
                var h = e.FullPaths[s];
                if (h && 0 !== h.length) {
                    f = e.FileIndex[s], 0 === s && (f.start = f.size ? f.start - 1 : k);
                    h = 0 === s && r.root || f.name, l = 2 * (h.length + 1);
                    if (n.write_shift(64, h, "utf16le"), n.write_shift(2, l), n.write_shift(1, f.type), n.write_shift(1, f.color), n.write_shift(-4, f.L), n.write_shift(-4, f.R), n.write_shift(-4, f.C), f.clsid) n.write_shift(16, f.clsid, "hex");
                    else for(c = 0; c < 4; ++c)n.write_shift(4, 0);
                    n.write_shift(4, f.state || 0), n.write_shift(4, 0), n.write_shift(4, 0), n.write_shift(4, 0), n.write_shift(4, 0), n.write_shift(4, f.start), n.write_shift(4, f.size), n.write_shift(4, 0);
                } else {
                    for(c = 0; c < 17; ++c)n.write_shift(4, 0);
                    for(c = 0; c < 3; ++c)n.write_shift(4, -1);
                    for(c = 0; c < 12; ++c)n.write_shift(4, 0);
                }
            }
            for(s = 1; s < e.FileIndex.length; ++s)if (4096 <= (f = e.FileIndex[s]).size) {
                if (n.l = f.start + 1 << 9, se && $4249f69807f0687b$require$Buffer.isBuffer(f.content)) f.content.copy(n, n.l, 0, f.size), n.l += f.size + 511 & -512;
                else {
                    for(c = 0; c < f.size; ++c)n.write_shift(1, f.content[c]);
                    for(; 511 & c; ++c)n.write_shift(1, 0);
                }
            }
            for(s = 1; s < e.FileIndex.length; ++s)if (0 < (f = e.FileIndex[s]).size && f.size < 4096) {
                if (se && $4249f69807f0687b$require$Buffer.isBuffer(f.content)) f.content.copy(n, n.l, 0, f.size), n.l += f.size + 63 & -64;
                else {
                    for(c = 0; c < f.size; ++c)n.write_shift(1, f.content[c]);
                    for(; 63 & c; ++c)n.write_shift(1, 0);
                }
            }
            if (se) n.l = n.length;
            else for(; n.l < n.length;)n.write_shift(1, 0);
            return n;
        }
        e.version = "1.2.1";
        var T, E = 64, k = -2, y = "d0cf11e0a1b11ae1", m = [
            208,
            207,
            17,
            224,
            161,
            177,
            26,
            225
        ], b = "00000000000000000000000000000000", S = {
            MAXREGSECT: -6,
            DIFSECT: -4,
            FATSECT: -3,
            ENDOFCHAIN: k,
            FREESECT: -1,
            HEADER_SIGNATURE: y,
            HEADER_MINOR_VERSION: "3e00",
            MAXREGSID: -6,
            NOSTREAM: -1,
            HEADER_CLSID: b,
            EntryTypes: [
                "unknown",
                "storage",
                "stream",
                "lockbytes",
                "property",
                "root"
            ]
        };
        function _(e) {
            for(var t = new Array(e.length), r = 0; r < e.length; ++r)t[r] = String.fromCharCode(e[r]);
            return t.join("");
        }
        var x = [
            16,
            17,
            18,
            0,
            8,
            7,
            9,
            6,
            10,
            5,
            11,
            4,
            12,
            3,
            13,
            2,
            14,
            1,
            15
        ], A = [
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            13,
            15,
            17,
            19,
            23,
            27,
            31,
            35,
            43,
            51,
            59,
            67,
            83,
            99,
            115,
            131,
            163,
            195,
            227,
            258
        ], C = [
            1,
            2,
            3,
            4,
            5,
            7,
            9,
            13,
            17,
            25,
            33,
            49,
            65,
            97,
            129,
            193,
            257,
            385,
            513,
            769,
            1025,
            1537,
            2049,
            3073,
            4097,
            6145,
            8193,
            12289,
            16385,
            24577
        ];
        for(var t, R = "undefined" != typeof Uint8Array, O = R ? new Uint8Array(256) : [], r = 0; r < 256; ++r)O[r] = 255 & ((t = 139536 & ((t = r) << 1 | t << 11) | 558144 & (t << 5 | t << 15)) >> 16 | t >> 8 | t);
        function I(e, t) {
            var r = 7 & t, t = t >>> 3;
            return (e[t] | (r <= 5 ? 0 : e[1 + t] << 8)) >>> r & 7;
        }
        function N(e, t) {
            var r = 7 & t, t = t >>> 3;
            return (e[t] | (r <= 3 ? 0 : e[1 + t] << 8)) >>> r & 31;
        }
        function F(e, t) {
            var r = 7 & t, t = t >>> 3;
            return (e[t] | (r <= 1 ? 0 : e[1 + t] << 8)) >>> r & 127;
        }
        function D(e, t, r) {
            var a = 7 & t, n = t >>> 3, s = (1 << r) - 1, t = e[n] >>> a;
            return r < 8 - a ? t & s : (t |= e[1 + n] << 8 - a, r < 16 - a ? t & s : (t |= e[2 + n] << 16 - a, r < 24 - a ? t & s : (t |= e[3 + n] << 24 - a) & s));
        }
        function P(e, t, r) {
            var a = 7 & t, n = t >>> 3;
            return a <= 5 ? e[n] |= (7 & r) << a : (e[n] |= r << a & 255, e[1 + n] = (7 & r) >> 8 - a), t + 3;
        }
        function L(e, t, r) {
            var a = t >>> 3;
            return r <<= 7 & t, e[a] |= 255 & r, r >>>= 8, e[1 + a] = r, t + 8;
        }
        function M(e, t, r) {
            var a = t >>> 3;
            return r <<= 7 & t, e[a] |= 255 & r, r >>>= 8, e[1 + a] = 255 & r, e[2 + a] = r >>> 8, t + 16;
        }
        function U(e, t) {
            var r = e.length, a = t < 2 * r ? 2 * r : t + 5, n = 0;
            if (t <= r) return e;
            if (se) {
                var s = fe(a);
                if (e.copy) e.copy(s);
                else for(; n < e.length; ++n)s[n] = e[n];
                return s;
            }
            if (R) {
                var i = new Uint8Array(a);
                if (i.set) i.set(e);
                else for(; n < r; ++n)i[n] = e[n];
                return i;
            }
            return e.length = a, e;
        }
        function B(e) {
            for(var t = new Array(e), r = 0; r < e; ++r)t[r] = 0;
            return t;
        }
        function W(e, t, r) {
            for(var a, n = 1, s = 0, i = 0, o = 0, c = e.length, l = R ? new Uint16Array(32) : B(32), s = 0; s < 32; ++s)l[s] = 0;
            for(s = c; s < r; ++s)e[s] = 0;
            c = e.length;
            var f = R ? new Uint16Array(c) : B(c);
            for(s = 0; s < c; ++s)l[a = e[s]]++, n < a && (n = a), f[s] = 0;
            for(l[0] = 0, s = 1; s <= n; ++s)l[s + 16] = o = o + l[s - 1] << 1;
            for(s = 0; s < c; ++s)0 != (o = e[s]) && (f[s] = l[o + 16]++);
            var h, u, d, p;
            for(s = 0; s < c; ++s)if (0 != (h = e[s])) for(u = f[s], d = n, p = void 0, p = O[255 & u], o = (d <= 8 ? p >>> 8 - d : (p = p << 8 | O[u >> 8 & 255], d <= 16 ? p >>> 16 - d : (p = p << 8 | O[u >> 16 & 255]) >>> 24 - d)) >> n - h, i = (1 << n + 4 - h) - 1; 0 <= i; --i)t[o | i << h] = 15 & h | s << 4;
            return n;
        }
        var H = R ? new Uint16Array(512) : B(512), z = R ? new Uint16Array(32) : B(32);
        if (!R) {
            for(var n = 0; n < 512; ++n)H[n] = 0;
            for(n = 0; n < 32; ++n)z[n] = 0;
        }
        !function() {
            for(var e = [], t = 0; t < 32; t++)e.push(5);
            W(e, z, 32);
            for(var r = [], t = 0; t <= 143; t++)r.push(8);
            for(; t <= 255; t++)r.push(9);
            for(; t <= 279; t++)r.push(7);
            for(; t <= 287; t++)r.push(8);
            W(r, H, 288);
        }();
        var c = function() {
            for(var d = R ? new Uint8Array(32768) : [], e = 0, t = 0; e < C.length - 1; ++e)for(; t < C[e + 1]; ++t)d[t] = e;
            for(; t < 32768; ++t)d[t] = 29;
            for(var p = R ? new Uint8Array(259) : [], e = 0, t = 0; e < A.length - 1; ++e)for(; t < A[e + 1]; ++t)p[t] = e;
            return function(e, t) {
                return (e.length < 8 ? function(e, t) {
                    for(var r = 0; r < e.length;){
                        var a = Math.min(65535, e.length - r), n = r + a == e.length;
                        for(t.write_shift(1, +n), t.write_shift(2, a), t.write_shift(2, 65535 & ~a); 0 < a--;)t[t.l++] = e[r++];
                    }
                    return t.l;
                } : function(e, t) {
                    for(var r = 0, a = 0, n = R ? new Uint16Array(32768) : []; a < e.length;){
                        var s = Math.min(65535, e.length - a);
                        if (s < 10) {
                            for(7 & (r = P(t, r, +!(a + s != e.length))) && (r += 8 - (7 & r)), t.l = r / 8 | 0, t.write_shift(2, s), t.write_shift(2, 65535 & ~s); 0 < s--;)t[t.l++] = e[a++];
                            r = 8 * t.l;
                        } else {
                            r = P(t, r, +!(a + s != e.length) + 2);
                            for(var i = 0; 0 < s--;){
                                var o = e[a], i = 32767 & (i << 5 ^ o), c = -1, l = 0;
                                if ((c = n[i]) && (a < (c |= -32768 & a) && (c -= 32768), c < a)) for(; e[c + l] == e[a + l] && l < 250;)++l;
                                if (2 < l) {
                                    (o = p[l]) <= 22 ? r = L(t, r, O[o + 1] >> 1) - 1 : (L(t, r, 3), L(t, r += 5, O[o - 23] >> 5), r += 3);
                                    var f = o < 8 ? 0 : o - 4 >> 2;
                                    0 < f && (M(t, r, l - A[o]), r += f), o = d[a - c], r = L(t, r, O[o] >> 3), r -= 3;
                                    var h = o < 4 ? 0 : o - 2 >> 1;
                                    0 < h && (M(t, r, a - c - C[o]), r += h);
                                    for(var u = 0; u < l; ++u)n[i] = 32767 & a, i = 32767 & (i << 5 ^ e[a]), ++a;
                                    s -= l - 1;
                                } else o <= 143 ? o += 48 : (f = ((f = 1) & f) << (7 & (h = r)), t[h >>> 3] |= f, r = h + 1), r = L(t, r, O[o]), n[i] = 32767 & a, ++a;
                            }
                            r = L(t, r, 0) - 1;
                        }
                    }
                    return t.l = (r + 7) / 8 | 0, t.l;
                })(e, t);
            };
        }();
        function V(e) {
            var t = Lr(50 + Math.floor(1.1 * e.length)), e = c(e, t);
            return t.slice(0, e);
        }
        var G = R ? new Uint16Array(32768) : B(32768), j = R ? new Uint16Array(32768) : B(32768), $1 = R ? new Uint16Array(128) : B(128), X = 1, Y = 1;
        function l(e, t) {
            if (3 == e[0] && !(3 & e[1])) return [
                le(t),
                2
            ];
            for(var r = 0, a = 0, n = fe(t || 262144), s = 0, i = n.length >>> 0, o = 0, c = 0; 0 == (1 & a);)if (a = I(e, r), r += 3, a >>> 1 != 0) for(c = a >> 1 == 1 ? (o = 9, 5) : (r = function(e, t) {
                var r, a, n, s = N(e, t) + 257, i = N(e, t += 5) + 1, o = (n = 7 & (a = t += 5), 4 + (((r = e)[a = a >>> 3] | (n <= 4 ? 0 : r[1 + a] << 8)) >>> n & 15));
                t += 4;
                for(var c = 0, l = R ? new Uint8Array(19) : B(19), f = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ], h = 1, u = R ? new Uint8Array(8) : B(8), d = R ? new Uint8Array(8) : B(8), p = l.length, m = 0; m < o; ++m)l[x[m]] = c = I(e, t), h < c && (h = c), u[c]++, t += 3;
                var g = 0;
                for(u[0] = 0, m = 1; m <= h; ++m)d[m] = g = g + u[m - 1] << 1;
                for(m = 0; m < p; ++m)0 != (g = l[m]) && (f[m] = d[g]++);
                for(var b, m = 0; m < p; ++m)if (0 != (b = l[m])) {
                    g = O[f[m]] >> 8 - b;
                    for(var v = (1 << 7 - b) - 1; 0 <= v; --v)$1[g | v << b] = 7 & b | m << 3;
                }
                for(var w, T, E, k = [], h = 1; k.length < s + i;)switch(t += 7 & (g = $1[F(e, t)]), g >>>= 3){
                    case 16:
                        for(c = 3 + (E = void 0, E = 7 & (T = t), ((w = e)[T = T >>> 3] | (E <= 6 ? 0 : w[1 + T] << 8)) >>> E & 3), t += 2, g = k[k.length - 1]; 0 < c--;)k.push(g);
                        break;
                    case 17:
                        for(c = 3 + I(e, t), t += 3; 0 < c--;)k.push(0);
                        break;
                    case 18:
                        for(c = 11 + F(e, t), t += 7; 0 < c--;)k.push(0);
                        break;
                    default:
                        k.push(g), h < g && (h = g);
                }
                var y = k.slice(0, s), S = k.slice(s);
                for(m = s; m < 286; ++m)y[m] = 0;
                for(m = i; m < 30; ++m)S[m] = 0;
                return X = W(y, G, 286), Y = W(S, j, 30), t;
            }(e, r), o = X, Y);;){
                !t && i < s + 32767 && (i = (n = U(n, s + 32767)).length);
                var l = D(e, r, o), f = (a >>> 1 == 1 ? H : G)[l];
                if (r += 15 & f, 0 == ((f >>>= 4) >>> 8 & 255)) n[s++] = f;
                else {
                    if (256 == f) break;
                    var h = (f -= 257) < 8 ? 0 : f - 4 >> 2;
                    5 < h && (h = 0);
                    var u = s + A[f];
                    0 < h && (u += D(e, r, h), r += h), l = D(e, r, c), r += 15 & (f = (a >>> 1 == 1 ? z : j)[l]);
                    var l = (f >>>= 4) < 4 ? 0 : f - 2 >> 1, d = C[f];
                    for(0 < l && (d += D(e, r, l), r += l), !t && i < u && (i = (n = U(n, u + 100)).length); s < u;)n[s] = n[s - d], ++s;
                }
            }
            else {
                7 & r && (r += 8 - (7 & r));
                var p = e[r >>> 3] | e[1 + (r >>> 3)] << 8;
                if (r += 32, 0 < p) for(!t && i < s + p && (i = (n = U(n, s + p)).length); 0 < p--;)n[s++] = e[r >>> 3], r += 8;
            }
            return t ? [
                n,
                r + 7 >>> 3
            ] : [
                n.slice(0, s),
                r + 7 >>> 3
            ];
        }
        function K(e, t) {
            t = l(e.slice(e.l || 0), t);
            return e.l += t[1], t[0];
        }
        function J(e, t) {
            if (!e) throw new Error(t);
            "undefined" != typeof console && console.error(t);
        }
        function q(e, t) {
            var r = e;
            Dr(r, 0);
            var a = {
                FileIndex: [],
                FullPaths: []
            };
            w(a, {
                root: t.root
            });
            for(var n = r.length - 4; (80 != r[n] || 75 != r[n + 1] || 5 != r[n + 2] || 6 != r[n + 3]) && 0 <= n;)--n;
            r.l = n + 4, r.l += 4;
            var s = r.read_shift(2);
            r.l += 6;
            t = r.read_shift(4);
            for(r.l = t, n = 0; n < s; ++n){
                r.l += 20;
                var i = r.read_shift(4), o = r.read_shift(4), c = r.read_shift(2), l = r.read_shift(2), f = r.read_shift(2);
                r.l += 8;
                var h = r.read_shift(4), u = g(r.slice(r.l + c, r.l + c + l));
                r.l += c + l + f;
                f = r.l;
                r.l = h + 4, function(e, t, r, a, n) {
                    e.l += 2;
                    var s = e.read_shift(2), i = e.read_shift(2), o = function(e) {
                        var t = 65535 & e.read_shift(2), r = 65535 & e.read_shift(2), a = new Date, n = 31 & r, e = 15 & (r >>>= 5);
                        return r >>>= 4, a.setMilliseconds(0), a.setFullYear(1980 + r), a.setMonth(e - 1), a.setDate(n), e = 31 & t, n = 63 & (t >>>= 5), t >>>= 6, a.setHours(t), a.setMinutes(n), a.setSeconds(e << 1), a;
                    }(e);
                    if (8257 & s) throw new Error("Unsupported ZIP encryption");
                    e.read_shift(4);
                    for(var c, l = e.read_shift(4), f = e.read_shift(4), h = e.read_shift(2), u = e.read_shift(2), d = "", p = 0; p < h; ++p)d += String.fromCharCode(e[e.l++]);
                    u && (((c = g(e.slice(e.l, e.l + u)))[21589] || {}).mt && (o = c[21589].mt), ((n || {})[21589] || {}).mt && (o = n[21589].mt)), e.l += u;
                    var m = e.slice(e.l, e.l + l);
                    switch(i){
                        case 8:
                            m = function(e, t) {
                                if (!T) return K(e, t);
                                var r = new T.InflateRaw, t = r._processChunk(e.slice(e.l), r._finishFlushFlag);
                                return e.l += r.bytesRead, t;
                            }(e, f);
                            break;
                        case 0:
                            break;
                        default:
                            throw new Error("Unsupported ZIP Compression method " + i);
                    }
                    u = !1, 8 & s && (134695760 == e.read_shift(4) && (e.read_shift(4), u = !0), l = e.read_shift(4), f = e.read_shift(4)), l != t && J(u, "Bad compressed size: " + t + " != " + l), f != r && J(u, "Bad uncompressed size: " + r + " != " + f), Q(a, d, m, {
                        unsafe: !0,
                        mt: o
                    });
                }(r, i, o, a, u), r.l = f;
            }
            return a;
        }
        var Z = {
            htm: "text/html",
            xml: "text/xml",
            gif: "image/gif",
            jpg: "image/jpeg",
            png: "image/png",
            mso: "application/x-mso",
            thmx: "application/vnd.ms-officetheme",
            sh33tj5: "application/octet-stream"
        };
        function Q(e, t, r, a) {
            var n = a && a.unsafe;
            n || w(e);
            var s, i = !n && xe.find(e, t);
            return i || (s = e.FullPaths[0], s = t.slice(0, s.length) == s ? t : ("/" != s.slice(-1) && (s += "/"), (s + t).replace("//", "/")), i = {
                name: p(t),
                type: 2
            }, e.FileIndex.push(i), e.FullPaths.push(s), n || xe.utils.cfb_gc(e)), i.content = r, i.size = r ? r.length : 0, a && (a.CLSID && (i.clsid = a.CLSID), a.mt && (i.mt = a.mt), a.ct && (i.ct = a.ct)), i;
        }
        return e.find = function(e, t) {
            var r = e.FullPaths.map(function(e) {
                return e.toUpperCase();
            }), a = r.map(function(e) {
                var t = e.split("/");
                return t[t.length - ("/" == e.slice(-1) ? 2 : 1)];
            }), n = !1;
            47 === t.charCodeAt(0) ? (n = !0, t = r[0].slice(0, -1) + t) : n = -1 !== t.indexOf("/");
            var s = t.toUpperCase(), i = (!0 === n ? r : a).indexOf(s);
            if (-1 !== i) return e.FileIndex[i];
            var o = !s.match(pe), s = s.replace(de, "");
            for(o && (s = s.replace(pe, "!")), i = 0; i < r.length; ++i){
                if ((o ? r[i].replace(pe, "!") : r[i]).replace(de, "") == s) return e.FileIndex[i];
                if ((o ? a[i].replace(pe, "!") : a[i]).replace(de, "") == s) return e.FileIndex[i];
            }
            return null;
        }, e.read = function(e, t) {
            var r, a, n = t && t.type;
            switch(n || se && $4249f69807f0687b$require$Buffer.isBuffer(e) && (n = "buffer"), n || "base64"){
                case "file":
                    return r = e, a = t, i(), o(s.readFileSync(r), a);
                case "base64":
                    return o(he(te(e)), t);
                case "binary":
                    return o(he(e), t);
            }
            return o(e, t);
        }, e.parse = o, e.write = function(e, t) {
            var r = a(e, t);
            switch(t && t.type || "buffer"){
                case "file":
                    return i(), s.writeFileSync(t.filename, r), r;
                case "binary":
                    return "string" == typeof r ? r : _(r);
                case "base64":
                    return ee("string" == typeof r ? r : _(r));
                case "buffer":
                    if (se) return $4249f69807f0687b$require$Buffer.isBuffer(r) ? r : ce(r);
                case "array":
                    return "string" == typeof r ? he(r) : r;
            }
            return r;
        }, e.writeFile = function(e, t, r) {
            i(), r = a(e, r), s.writeFileSync(t, r);
        }, e.utils = {
            cfb_new: function(e) {
                var t = {};
                return w(t, e), t;
            },
            cfb_add: Q,
            cfb_del: function(e, t) {
                w(e);
                var r = xe.find(e, t);
                if (r) {
                    for(var a = 0; a < e.FileIndex.length; ++a)if (e.FileIndex[a] == r) return e.FileIndex.splice(a, 1), e.FullPaths.splice(a, 1), !0;
                }
                return !1;
            },
            cfb_mov: function(e, t, r) {
                w(e);
                var a = xe.find(e, t);
                if (a) {
                    for(var n = 0; n < e.FileIndex.length; ++n)if (e.FileIndex[n] == a) return e.FileIndex[n].name = p(r), e.FullPaths[n] = r, !0;
                }
                return !1;
            },
            cfb_gc: function(e) {
                u(e, !0);
            },
            ReadShift: Cr,
            CheckField: Fr,
            prep_blob: Dr,
            bconcat: ue,
            use_zlib: function(e) {
                try {
                    var t = new e.InflateRaw;
                    if (t._processChunk(new Uint8Array([
                        3,
                        0
                    ]), t._finishFlushFlag), !t.bytesRead) throw new Error("zlib does not expose bytesRead");
                    T = e;
                } catch (e) {
                    console.error("cannot use native zlib: " + (e.message || e));
                }
            },
            _deflateRaw: V,
            _inflateRaw: K,
            consts: S
        }, e;
    }();
    try {
        Se = (parcelRequire("kjyEk"));
    } catch (e) {}
    function Ae(e) {
        return "string" == typeof e ? o(e) : Array.isArray(e) ? function(e) {
            if ("undefined" == typeof Uint8Array) throw new Error("Unsupported");
            return new Uint8Array(e);
        }(e) : e;
    }
    function Ce(e, t, r) {
        if (void 0 !== Se && Se.writeFileSync) return r ? Se.writeFileSync(e, t, r) : Se.writeFileSync(e, t);
        if ("undefined" != typeof Deno) {
            if (r && "string" == typeof t) switch(r){
                case "utf8":
                    t = new TextEncoder(r).encode(t);
                    break;
                case "binary":
                    t = o(t);
                    break;
                default:
                    throw new Error("Unsupported encoding " + r);
            }
            return Deno.writeFileSync(e, t);
        }
        var a = "utf8" == r ? Ut(t) : t;
        if ("undefined" != typeof IE_SaveFile) return IE_SaveFile(a, e);
        if ("undefined" != typeof Blob) {
            a = new Blob([
                Ae(a)
            ], {
                type: "application/octet-stream"
            });
            if ("undefined" != typeof navigator && navigator.msSaveBlob) return navigator.msSaveBlob(a, e);
            if ("undefined" != typeof saveAs) return saveAs(a, e);
            if ("undefined" != typeof URL && "undefined" != typeof document && document.createElement && URL.createObjectURL) {
                var n = URL.createObjectURL(a);
                if ("object" == typeof chrome && "function" == typeof (chrome.downloads || {}).download) return URL.revokeObjectURL && "undefined" != typeof setTimeout && setTimeout(function() {
                    URL.revokeObjectURL(n);
                }, 6e4), chrome.downloads.download({
                    url: n,
                    filename: e,
                    saveAs: !0
                });
                a = document.createElement("a");
                if (null != a.download) return a.download = e, a.href = n, document.body.appendChild(a), a.click(), document.body.removeChild(a), URL.revokeObjectURL && "undefined" != typeof setTimeout && setTimeout(function() {
                    URL.revokeObjectURL(n);
                }, 6e4), n;
            }
        }
        if ("undefined" != typeof $ && "undefined" != typeof File && "undefined" != typeof Folder) try {
            var s = File(e);
            return s.open("w"), s.encoding = "binary", Array.isArray(t) && (t = i(t)), s.write(t), s.close(), t;
        } catch (e) {
            if (!e.message || !e.message.match(/onstruct/)) throw e;
        }
        throw new Error("cannot save file " + e);
    }
    function Re(e) {
        for(var t = Object.keys(e), r = [], a = 0; a < t.length; ++a)Object.prototype.hasOwnProperty.call(e, t[a]) && r.push(t[a]);
        return r;
    }
    function Oe(e, t) {
        for(var r = [], a = Re(e), n = 0; n !== a.length; ++n)null == r[e[a[n]][t]] && (r[e[a[n]][t]] = a[n]);
        return r;
    }
    function Ie(e) {
        for(var t = [], r = Re(e), a = 0; a !== r.length; ++a)t[e[r[a]]] = r[a];
        return t;
    }
    function Ne(e) {
        for(var t = [], r = Re(e), a = 0; a !== r.length; ++a)t[e[r[a]]] = parseInt(r[a], 10);
        return t;
    }
    var Fe = new Date(1899, 11, 30, 0, 0, 0);
    function De(e, t) {
        var r = e.getTime();
        return t && (r -= 1263168e5), (r - (Fe.getTime() + 6e4 * (e.getTimezoneOffset() - Fe.getTimezoneOffset()))) / 864e5;
    }
    var r = new Date, Pe = Fe.getTime() + 6e4 * (r.getTimezoneOffset() - Fe.getTimezoneOffset()), Le = r.getTimezoneOffset();
    function Me(e) {
        var t = new Date;
        return t.setTime(24 * e * 3600000 + Pe), t.getTimezoneOffset() !== Le && t.setTime(t.getTime() + 6e4 * (t.getTimezoneOffset() - Le)), t;
    }
    var Ue = new Date("2017-02-19T19:06:09.000Z"), Be = isNaN(Ue.getFullYear()) ? new Date("2/19/17") : Ue, We = 2017 == Be.getFullYear();
    function He(e, t) {
        var r = new Date(e);
        if (We) return 0 < t ? r.setTime(r.getTime() + 60 * r.getTimezoneOffset() * 1e3) : t < 0 && r.setTime(r.getTime() - 60 * r.getTimezoneOffset() * 1e3), r;
        if (e instanceof Date) return e;
        if (1917 == Be.getFullYear() && !isNaN(r.getFullYear())) {
            t = r.getFullYear();
            return -1 < e.indexOf("" + t) ? r : (r.setFullYear(r.getFullYear() + 100), r);
        }
        r = e.match(/\d+/g) || [
            "2017",
            "2",
            "19",
            "0",
            "0",
            "0"
        ], r = new Date(+r[0], +r[1] - 1, +r[2], +r[3] || 0, +r[4] || 0, +r[5] || 0);
        return r = -1 < e.indexOf("Z") ? new Date(r.getTime() - 60 * r.getTimezoneOffset() * 1e3) : r;
    }
    function ze(e, t) {
        if (se && $4249f69807f0687b$require$Buffer.isBuffer(e)) {
            if (t) {
                if (255 == e[0] && 254 == e[1]) return Ut(e.slice(2).toString("utf16le"));
                if (254 == e[1] && 255 == e[2]) return Ut(s(e.slice(2).toString("binary")));
            }
            return e.toString("binary");
        }
        if ("undefined" != typeof TextDecoder) try {
            if (t) {
                if (255 == e[0] && 254 == e[1]) return Ut(new TextDecoder("utf-16le").decode(e.slice(2)));
                if (254 == e[0] && 255 == e[1]) return Ut(new TextDecoder("utf-16be").decode(e.slice(2)));
            }
            var r = {
                "\u20AC": "\x80",
                "\u201A": "\x82",
                "\u0192": "\x83",
                "\u201E": "\x84",
                "\u2026": "\x85",
                "\u2020": "\x86",
                "\u2021": "\x87",
                "\u02C6": "\x88",
                "\u2030": "\x89",
                "\u0160": "\x8a",
                "\u2039": "\x8b",
                "\u0152": "\x8c",
                "\u017D": "\x8e",
                "\u2018": "\x91",
                "\u2019": "\x92",
                "\u201C": "\x93",
                "\u201D": "\x94",
                "\u2022": "\x95",
                "\u2013": "\x96",
                "\u2014": "\x97",
                "\u02DC": "\x98",
                "\u2122": "\x99",
                "\u0161": "\x9a",
                "\u203A": "\x9b",
                "\u0153": "\x9c",
                "\u017E": "\x9e",
                "\u0178": "\x9f"
            };
            return Array.isArray(e) && (e = new Uint8Array(e)), new TextDecoder("latin1").decode(e).replace(/[€‚ƒ„…†‡ˆ‰Š‹ŒŽ‘’“”•–—˜™š›œžŸ]/g, function(e) {
                return r[e] || e;
            });
        } catch (e) {}
        for(var a = [], n = 0; n != e.length; ++n)a.push(String.fromCharCode(e[n]));
        return a.join("");
    }
    function Ve(e) {
        if ("undefined" != typeof JSON && !Array.isArray(e)) return JSON.parse(JSON.stringify(e));
        if ("object" != typeof e || null == e) return e;
        if (e instanceof Date) return new Date(e.getTime());
        var t, r = {};
        for(t in e)Object.prototype.hasOwnProperty.call(e, t) && (r[t] = Ve(e[t]));
        return r;
    }
    function Ge(e, t) {
        for(var r = ""; r.length < t;)r += e;
        return r;
    }
    function je(e) {
        var t = Number(e);
        if (!isNaN(t)) return isFinite(t) ? t : NaN;
        if (!/\d/.test(e)) return t;
        var r = 1, e = e.replace(/([\d]),([\d])/g, "$1$2").replace(/[$]/g, "").replace(/[%]/g, function() {
            return r *= 100, "";
        });
        return isNaN(t = Number(e)) ? (e = e.replace(/[(](.*)[)]/, function(e, t) {
            return r = -r, t;
        }), isNaN(t = Number(e)) ? t : t / r) : t / r;
    }
    var $e = [
        "january",
        "february",
        "march",
        "april",
        "may",
        "june",
        "july",
        "august",
        "september",
        "october",
        "november",
        "december"
    ];
    function Xe(e) {
        var t = new Date(e), r = new Date(NaN), a = t.getYear(), n = t.getMonth(), s = t.getDate();
        if (isNaN(s)) return r;
        var i = e.toLowerCase();
        if (i.match(/jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec/)) {
            if (3 < (i = i.replace(/[^a-z]/g, "").replace(/([^a-z]|^)[ap]m?([^a-z]|$)/, "")).length && -1 == $e.indexOf(i)) return r;
        } else if (i.match(/[a-z]/)) return r;
        return a < 0 || 8099 < a || (!(0 < n || 1 < s) || 101 == a) && e.match(/[^-0-9:,\/\\]/) ? r : t;
    }
    var Ye, Ke = (Ye = 5 == "abacaba".split(/(:?b)/i).length, function(e, t, r) {
        if (Ye || "string" == typeof t) return e.split(t);
        for(var a = e.split(t), n = [
            a[0]
        ], s = 1; s < a.length; ++s)n.push(r), n.push(a[s]);
        return n;
    });
    function Je(e) {
        return e ? e.content && e.type ? ze(e.content, !0) : e.data ? ne(e.data) : e.asNodeBuffer && se ? ne(e.asNodeBuffer().toString("binary")) : e.asBinary ? ne(e.asBinary()) : e._data && e._data.getContent ? ne(ze(Array.prototype.slice.call(e._data.getContent(), 0))) : null : null;
    }
    function qe(e) {
        if (!e) return null;
        if (e.data) return ae(e.data);
        if (e.asNodeBuffer && se) return e.asNodeBuffer();
        if (e._data && e._data.getContent) {
            var t = e._data.getContent();
            return "string" == typeof t ? ae(t) : Array.prototype.slice.call(t);
        }
        return e.content && e.type ? e.content : null;
    }
    function Ze(e, t) {
        for(var r = e.FullPaths || Re(e.files), a = t.toLowerCase().replace(/[\/]/g, "\\"), n = a.replace(/\\/g, "/"), s = 0; s < r.length; ++s){
            var i = r[s].replace(/^Root Entry[\/]/, "").toLowerCase();
            if (a == i || n == i) return e.files ? e.files[r[s]] : e.FileIndex[s];
        }
        return null;
    }
    function Qe(e, t) {
        e = Ze(e, t);
        if (null == e) throw new Error("Cannot find file " + t + " in zip");
        return e;
    }
    function et(e, t, r) {
        if (!r) return ((r = Qe(e, t)) && ".bin" === r.name.slice(-4) ? qe : Je)(r);
        if (!t) return null;
        try {
            return et(e, t);
        } catch (e) {
            return null;
        }
    }
    function tt(e, t, r) {
        if (!r) return Je(Qe(e, t));
        if (!t) return null;
        try {
            return tt(e, t);
        } catch (e) {
            return null;
        }
    }
    function rt(e) {
        for(var t = e.FullPaths || Re(e.files), r = [], a = 0; a < t.length; ++a)"/" != t[a].slice(-1) && r.push(t[a].replace(/^Root Entry[\/]/, ""));
        return r.sort();
    }
    function at(e, t, r) {
        if (e.FullPaths) {
            if ("string" == typeof r) {
                var a = (se ? ce : function(e) {
                    for(var t = [], r = 0, a = e.length + 250, n = le(e.length + 255), s = 0; s < e.length; ++s){
                        var i, o = e.charCodeAt(s);
                        o < 128 ? n[r++] = o : o < 2048 ? (n[r++] = 192 | o >> 6 & 31, n[r++] = 128 | 63 & o) : 55296 <= o && o < 57344 ? (o = 64 + (1023 & o), i = 1023 & e.charCodeAt(++s), n[r++] = 240 | o >> 8 & 7, n[r++] = 128 | o >> 2 & 63, n[r++] = 128 | i >> 6 & 15 | (3 & o) << 4, n[r++] = 128 | 63 & i) : (n[r++] = 224 | o >> 12 & 15, n[r++] = 128 | o >> 6 & 63, n[r++] = 128 | 63 & o), a < r && (t.push(n.slice(0, r)), r = 0, n = le(65535), a = 65530);
                    }
                    return t.push(n.slice(0, r)), ue(t);
                })(r);
                return xe.utils.cfb_add(e, t, a);
            }
            xe.utils.cfb_add(e, t, r);
        } else e.file(t, r);
    }
    function nt() {
        return xe.utils.cfb_new();
    }
    function st(e, t) {
        switch(t.type){
            case "base64":
                return xe.read(e, {
                    type: "base64"
                });
            case "binary":
                return xe.read(e, {
                    type: "binary"
                });
            case "buffer":
            case "array":
                return xe.read(e, {
                    type: "buffer"
                });
        }
        throw new Error("Unrecognized type " + t.type);
    }
    function it(e, t) {
        if ("/" == e.charAt(0)) return e.slice(1);
        var r = t.split("/");
        "/" != t.slice(-1) && r.pop();
        for(var a = e.split("/"); 0 !== a.length;){
            var n = a.shift();
            ".." === n ? r.pop() : "." !== n && r.push(n);
        }
        return r.join("/");
    }
    var ot = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r\n', ct = /([^"\s?>\/]+)\s*=\s*((?:")([^"]*)(?:")|(?:')([^']*)(?:')|([^'">\s]+))/g, lt = /<[\/\?]?[a-zA-Z0-9:_-]+(?:\s+[^"\s?>\/]+\s*=\s*(?:"[^"]*"|'[^']*'|[^'">\s=]+))*\s*[\/\?]?>/gm, ft = ot.match(lt) ? lt : /<[^>]*>/g, ht = /<\w*:/, ut = /<(\/?)\w+:/;
    function dt(e, t, r) {
        for(var a = {}, n = 0, s = 0; n !== e.length && 32 !== (s = e.charCodeAt(n)) && 10 !== s && 13 !== s; ++n);
        if (t || (a[0] = e.slice(0, n)), n === e.length) return a;
        var i, o, c, l = e.match(ct), f = 0, h = 0, u = "", d = "";
        if (l) for(h = 0; h != l.length; ++h){
            for(d = l[h], s = 0; s != d.length && 61 !== d.charCodeAt(s); ++s);
            for(u = d.slice(0, s).trim(); 32 == d.charCodeAt(s + 1);)++s;
            for(o = 34 == (n = d.charCodeAt(s + 1)) || 39 == n ? 1 : 0, i = d.slice(s + 1 + o, d.length - o), f = 0; f != u.length && 58 !== u.charCodeAt(f); ++f);
            f === u.length ? (a[u = 0 < u.indexOf("_") ? u.slice(0, u.indexOf("_")) : u] = i, r || (a[u.toLowerCase()] = i)) : a[c = (5 === f && "xmlns" === u.slice(0, 5) ? "xmlns" : "") + u.slice(f + 1)] && "ext" == u.slice(f - 3, f) || (a[c] = i, r || (a[c.toLowerCase()] = i));
        }
        return a;
    }
    function pt(e) {
        return e.replace(ut, "<$1");
    }
    var mt, gt, bt = {
        "&quot;": '"',
        "&apos;": "'",
        "&gt;": ">",
        "&lt;": "<",
        "&amp;": "&"
    }, vt = Ie(bt), wt = (mt = /&(?:quot|apos|gt|lt|amp|#x?([\da-fA-F]+));/gi, gt = /_x([\da-fA-F]{4})_/gi, function e(t) {
        var r = t + "", a = r.indexOf("<![CDATA[");
        if (-1 == a) return r.replace(mt, function(e, t) {
            return bt[e] || String.fromCharCode(parseInt(t, -1 < e.indexOf("x") ? 16 : 10)) || e;
        }).replace(gt, function(e, t) {
            return String.fromCharCode(parseInt(t, 16));
        });
        t = r.indexOf("]]>");
        return e(r.slice(0, a)) + r.slice(a + 9, t) + e(r.slice(t + 3));
    }), Tt = /[&<>'"]/g, Et = /[\u0000-\u0008\u000b-\u001f]/g;
    function kt(e) {
        return (e + "").replace(Tt, function(e) {
            return vt[e];
        }).replace(Et, function(e) {
            return "_x" + ("000" + e.charCodeAt(0).toString(16)).slice(-4) + "_";
        });
    }
    function yt(e) {
        return kt(e).replace(/ /g, "_x0020_");
    }
    var St = /[\u0000-\u001f]/g;
    function _t(e) {
        return (e + "").replace(Tt, function(e) {
            return vt[e];
        }).replace(/\n/g, "<br/>").replace(St, function(e) {
            return "&#x" + ("000" + e.charCodeAt(0).toString(16)).slice(-4) + ";";
        });
    }
    var xt, At = (xt = /&#(\d+);/g, function(e) {
        return e.replace(xt, Ct);
    });
    function Ct(e, t) {
        return String.fromCharCode(parseInt(t, 10));
    }
    function Rt(e) {
        switch(e){
            case 1:
            case !0:
            case "1":
            case "true":
            case "TRUE":
                return !0;
            default:
                return !1;
        }
    }
    function Ot(e) {
        for(var t, r, a, n, s = "", i = 0, o = 0; i < e.length;)(t = e.charCodeAt(i++)) < 128 ? s += String.fromCharCode(t) : (r = e.charCodeAt(i++), 191 < t && t < 224 ? (o = (31 & t) << 6, o |= 63 & r, s += String.fromCharCode(o)) : (a = e.charCodeAt(i++), t < 240 ? s += String.fromCharCode((15 & t) << 12 | (63 & r) << 6 | 63 & a) : (n = ((7 & t) << 18 | (63 & r) << 12 | (63 & a) << 6 | 63 & (o = e.charCodeAt(i++))) - 65536, s += String.fromCharCode(55296 + (n >>> 10 & 1023)), s += String.fromCharCode(56320 + (1023 & n)))));
        return s;
    }
    function It(e) {
        for(var t, r, a = le(2 * e.length), n = 1, s = 0, i = 0, o = 0; o < e.length; o += n)n = 1, (r = e.charCodeAt(o)) < 128 ? t = r : r < 224 ? (t = 64 * (31 & r) + (63 & e.charCodeAt(o + 1)), n = 2) : r < 240 ? (t = 4096 * (15 & r) + 64 * (63 & e.charCodeAt(o + 1)) + (63 & e.charCodeAt(o + 2)), n = 3) : (n = 4, t = 262144 * (7 & r) + 4096 * (63 & e.charCodeAt(o + 1)) + 64 * (63 & e.charCodeAt(o + 2)) + (63 & e.charCodeAt(o + 3)), i = 55296 + ((t -= 65536) >>> 10 & 1023), t = 56320 + (1023 & t)), 0 !== i && (a[s++] = 255 & i, a[s++] = i >>> 8, i = 0), a[s++] = t % 256, a[s++] = t >>> 8;
        return a.slice(0, s).toString("ucs2");
    }
    function Nt(e) {
        return ce(e, "binary").toString("utf8");
    }
    var Ft, Dt, Pt, Lt = "foo bar baz\xe2\x98\x83\xf0\x9f\x8d\xa3", Mt = se && (Nt(Lt) == Ot(Lt) ? Nt : It(Lt) == Ot(Lt) && It) || Ot, Ut = se ? function(e) {
        return ce(e, "utf8").toString("binary");
    } : function(e) {
        for(var t, r = [], a = 0, n = 0; a < e.length;)switch(!0){
            case (n = e.charCodeAt(a++)) < 128:
                r.push(String.fromCharCode(n));
                break;
            case n < 2048:
                r.push(String.fromCharCode(192 + (n >> 6))), r.push(String.fromCharCode(128 + (63 & n)));
                break;
            case 55296 <= n && n < 57344:
                n -= 55296, t = e.charCodeAt(a++) - 56320 + (n << 10), r.push(String.fromCharCode(240 + (t >> 18 & 7))), r.push(String.fromCharCode(144 + (t >> 12 & 63))), r.push(String.fromCharCode(128 + (t >> 6 & 63))), r.push(String.fromCharCode(128 + (63 & t)));
                break;
            default:
                r.push(String.fromCharCode(224 + (n >> 12))), r.push(String.fromCharCode(128 + (n >> 6 & 63))), r.push(String.fromCharCode(128 + (63 & n)));
        }
        return r.join("");
    }, Bt = (Ft = {}, function(e, t) {
        var r = e + "|" + (t || "");
        return Ft[r] || (Ft[r] = new RegExp("<(?:\\w+:)?" + e + '(?: xml:space="preserve")?(?:[^>]*)>([\\s\\S]*?)</(?:\\w+:)?' + e + ">", t || ""));
    }), Wt = (Dt = [
        [
            "nbsp",
            " "
        ],
        [
            "middot",
            "\xb7"
        ],
        [
            "quot",
            '"'
        ],
        [
            "apos",
            "'"
        ],
        [
            "gt",
            ">"
        ],
        [
            "lt",
            "<"
        ],
        [
            "amp",
            "&"
        ]
    ].map(function(e) {
        return [
            new RegExp("&" + e[0] + ";", "ig"),
            e[1]
        ];
    }), function(e) {
        for(var t = e.replace(/^[\t\n\r ]+/, "").replace(/[\t\n\r ]+$/, "").replace(/>\s+/g, ">").replace(/\s+</g, "<").replace(/[\t\n\r ]+/g, " ").replace(/<\s*[bB][rR]\s*\/?>/g, "\n").replace(/<[^>]*>/g, ""), r = 0; r < Dt.length; ++r)t = t.replace(Dt[r][0], Dt[r][1]);
        return t;
    }), Ht = (Pt = {}, function(e) {
        return void 0 !== Pt[e] ? Pt[e] : Pt[e] = new RegExp("<(?:vt:)?" + e + ">([\\s\\S]*?)</(?:vt:)?" + e + ">", "g");
    }), zt = /<\/?(?:vt:)?variant>/g, Vt = /<(?:vt:)([^>]*)>([\s\S]*)</;
    function Gt(e, t) {
        var r = dt(e), e = e.match(Ht(r.baseType)) || [], a = [];
        if (e.length == r.size) return e.forEach(function(e) {
            e = e.replace(zt, "").match(Vt);
            e && a.push({
                v: Mt(e[2]),
                t: e[1]
            });
        }), a;
        if (t.WTF) throw new Error("unexpected vector length " + e.length + " != " + r.size);
        return a;
    }
    var jt = /(^\s|\s$|\n)/;
    function $t(e, t) {
        return "<" + e + (t.match(jt) ? ' xml:space="preserve"' : "") + ">" + t + "</" + e + ">";
    }
    function Xt(t) {
        return Re(t).map(function(e) {
            return " " + e + '="' + t[e] + '"';
        }).join("");
    }
    function Yt(e, t, r) {
        return "<" + e + (null != r ? Xt(r) : "") + (null != t ? (t.match(jt) ? ' xml:space="preserve"' : "") + ">" + t + "</" + e : "/") + ">";
    }
    function Kt(e, t) {
        try {
            return e.toISOString().replace(/\.\d*/, "");
        } catch (e) {
            if (t) throw e;
        }
        return "";
    }
    function Jt(e) {
        if (se && $4249f69807f0687b$require$Buffer.isBuffer(e)) return e.toString("utf8");
        if ("string" == typeof e) return e;
        if ("undefined" != typeof Uint8Array && e instanceof Uint8Array) return Mt(i(m(e)));
        throw new Error("Bad input format: expected Buffer or string");
    }
    var qt = /<(\/?)([^\s?><!\/:]*:|)([^\s?<>:\/]+)(?:[\s?:\/][^>]*)?>/gm, Zt = {
        CORE_PROPS: "http://schemas.openxmlformats.org/package/2006/metadata/core-properties",
        CUST_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/custom-properties",
        EXT_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/extended-properties",
        CT: "http://schemas.openxmlformats.org/package/2006/content-types",
        RELS: "http://schemas.openxmlformats.org/package/2006/relationships",
        TCMNT: "http://schemas.microsoft.com/office/spreadsheetml/2018/threadedcomments",
        dc: "http://purl.org/dc/elements/1.1/",
        dcterms: "http://purl.org/dc/terms/",
        dcmitype: "http://purl.org/dc/dcmitype/",
        mx: "http://schemas.microsoft.com/office/mac/excel/2008/main",
        r: "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
        sjs: "http://schemas.openxmlformats.org/package/2006/sheetjs/core-properties",
        vt: "http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes",
        xsi: "http://www.w3.org/2001/XMLSchema-instance",
        xsd: "http://www.w3.org/2001/XMLSchema"
    }, Qt = [
        "http://schemas.openxmlformats.org/spreadsheetml/2006/main",
        "http://purl.oclc.org/ooxml/spreadsheetml/main",
        "http://schemas.microsoft.com/office/excel/2006/main",
        "http://schemas.microsoft.com/office/excel/2006/2"
    ], er = {
        o: "urn:schemas-microsoft-com:office:office",
        x: "urn:schemas-microsoft-com:office:excel",
        ss: "urn:schemas-microsoft-com:office:spreadsheet",
        dt: "uuid:C2F41010-65B3-11d1-A29F-00AA00C14882",
        mv: "http://macVmlSchemaUri",
        v: "urn:schemas-microsoft-com:vml",
        html: "http://www.w3.org/TR/REC-html40"
    };
    function tr(e) {
        for(var t = [], r = 0; r < e[0].length; ++r)if (e[0][r]) for(var a = 0, n = e[0][r].length; a < n; a += 10240)t.push.apply(t, e[0][r].slice(a, a + 10240));
        return t;
    }
    function rr(e, t, r) {
        for(var a = [], n = t; n < r; n += 2)a.push(String.fromCharCode(yr(e, n)));
        return a.join("").replace(de, "");
    }
    function ar(e, t, r) {
        for(var a = [], n = t; n < t + r; ++n)a.push(("0" + e[n].toString(16)).slice(-2));
        return a.join("");
    }
    function nr(e, t, r) {
        for(var a = [], n = t; n < r; n++)a.push(String.fromCharCode(kr(e, n)));
        return a.join("");
    }
    function sr(e, t) {
        var r = _r(e, t);
        return 0 < r ? pr(e, t + 4, t + 4 + r - 1) : "";
    }
    function ir(e, t) {
        var r = _r(e, t);
        return 0 < r ? pr(e, t + 4, t + 4 + r - 1) : "";
    }
    function or(e, t) {
        var r = 2 * _r(e, t);
        return 0 < r ? pr(e, t + 4, t + 4 + r - 1) : "";
    }
    function cr(e, t) {
        var r = _r(e, t);
        return 0 < r ? ur(e, t + 4, t + 4 + r) : "";
    }
    function lr(e, t) {
        var r = _r(e, t);
        return 0 < r ? pr(e, t + 4, t + 4 + r) : "";
    }
    function fr(e, t) {
        for(var r = 1 - 2 * (e[t + 7] >>> 7), a = ((127 & e[t + 7]) << 4) + (e[t + 6] >>> 4 & 15), n = 15 & e[t + 6], s = 5; 0 <= s; --s)n = 256 * n + e[t + s];
        return 2047 == a ? 0 == n ? 1 / 0 * r : NaN : (0 == a ? a = -1022 : (a -= 1023, n += Math.pow(2, 52)), r * Math.pow(2, a - 52) * n);
    }
    var hr = se ? function(e) {
        return 0 < e[0].length && $4249f69807f0687b$require$Buffer.isBuffer(e[0][0]) ? $4249f69807f0687b$require$Buffer.concat(e[0].map(function(e) {
            return $4249f69807f0687b$require$Buffer.isBuffer(e) ? e : ce(e);
        })) : tr(e);
    } : tr, ur = se ? function(e, t, r) {
        return $4249f69807f0687b$require$Buffer.isBuffer(e) ? e.toString("utf16le", t, r).replace(de, "") : rr(e, t, r);
    } : rr, dr = se ? function(e, t, r) {
        return $4249f69807f0687b$require$Buffer.isBuffer(e) ? e.toString("hex", t, t + r) : ar(e, t, r);
    } : ar, pr = se ? function(e, t, r) {
        return $4249f69807f0687b$require$Buffer.isBuffer(e) ? e.toString("utf8", t, r) : nr(e, t, r);
    } : nr, mr = sr, gr = ir, br = or, vr = cr, wr = lr, Tr = fr, Er = function(e) {
        return Array.isArray(e) || "undefined" != typeof Uint8Array && e instanceof Uint8Array;
    };
    se && (mr = function(e, t) {
        if (!$4249f69807f0687b$require$Buffer.isBuffer(e)) return sr(e, t);
        var r = e.readUInt32LE(t);
        return 0 < r ? e.toString("utf8", t + 4, t + 4 + r - 1) : "";
    }, gr = function(e, t) {
        if (!$4249f69807f0687b$require$Buffer.isBuffer(e)) return ir(e, t);
        var r = e.readUInt32LE(t);
        return 0 < r ? e.toString("utf8", t + 4, t + 4 + r - 1) : "";
    }, br = function(e, t) {
        if (!$4249f69807f0687b$require$Buffer.isBuffer(e)) return or(e, t);
        var r = 2 * e.readUInt32LE(t);
        return e.toString("utf16le", t + 4, t + 4 + r - 1);
    }, vr = function(e, t) {
        if (!$4249f69807f0687b$require$Buffer.isBuffer(e)) return cr(e, t);
        var r = e.readUInt32LE(t);
        return e.toString("utf16le", t + 4, t + 4 + r);
    }, wr = function(e, t) {
        if (!$4249f69807f0687b$require$Buffer.isBuffer(e)) return lr(e, t);
        var r = e.readUInt32LE(t);
        return e.toString("utf8", t + 4, t + 4 + r);
    }, Tr = function(e, t) {
        return $4249f69807f0687b$require$Buffer.isBuffer(e) ? e.readDoubleLE(t) : fr(e, t);
    }, Er = function(e) {
        return $4249f69807f0687b$require$Buffer.isBuffer(e) || Array.isArray(e) || "undefined" != typeof Uint8Array && e instanceof Uint8Array;
    }), void 0 !== re && (ur = function(e, t, r) {
        return re.utils.decode(1200, e.slice(t, r)).replace(de, "");
    }, pr = function(e, t, r) {
        return re.utils.decode(65001, e.slice(t, r));
    }, mr = function(e, t) {
        var r = _r(e, t);
        return 0 < r ? re.utils.decode(_, e.slice(t + 4, t + 4 + r - 1)) : "";
    }, gr = function(e, t) {
        var r = _r(e, t);
        return 0 < r ? re.utils.decode(f, e.slice(t + 4, t + 4 + r - 1)) : "";
    }, br = function(e, t) {
        var r = 2 * _r(e, t);
        return 0 < r ? re.utils.decode(1200, e.slice(t + 4, t + 4 + r - 1)) : "";
    }, vr = function(e, t) {
        var r = _r(e, t);
        return 0 < r ? re.utils.decode(1200, e.slice(t + 4, t + 4 + r)) : "";
    }, wr = function(e, t) {
        var r = _r(e, t);
        return 0 < r ? re.utils.decode(65001, e.slice(t + 4, t + 4 + r)) : "";
    });
    var kr = function(e, t) {
        return e[t];
    }, yr = function(e, t) {
        return 256 * e[t + 1] + e[t];
    }, Sr = function(e, t) {
        t = 256 * e[t + 1] + e[t];
        return t < 32768 ? t : -1 * (65535 - t + 1);
    }, _r = function(e, t) {
        return e[t + 3] * 16777216 + (e[t + 2] << 16) + (e[t + 1] << 8) + e[t];
    }, xr = function(e, t) {
        return e[t + 3] << 24 | e[t + 2] << 16 | e[t + 1] << 8 | e[t];
    }, Ar = function(e, t) {
        return e[t] << 24 | e[t + 1] << 16 | e[t + 2] << 8 | e[t + 3];
    };
    function Cr(e, t) {
        var r, a, n, s, i, o, c = "", l = [];
        switch(t){
            case "dbcs":
                if (o = this.l, se && $4249f69807f0687b$require$Buffer.isBuffer(this)) c = this.slice(this.l, this.l + 2 * e).toString("utf16le");
                else for(i = 0; i < e; ++i)c += String.fromCharCode(yr(this, o)), o += 2;
                e *= 2;
                break;
            case "utf8":
                c = pr(this, this.l, this.l + e);
                break;
            case "utf16le":
                e *= 2, c = ur(this, this.l, this.l + e);
                break;
            case "wstr":
                if (void 0 === re) return Cr.call(this, e, "dbcs");
                c = re.utils.decode(f, this.slice(this.l, this.l + 2 * e)), e *= 2;
                break;
            case "lpstr-ansi":
                c = mr(this, this.l), e = 4 + _r(this, this.l);
                break;
            case "lpstr-cp":
                c = gr(this, this.l), e = 4 + _r(this, this.l);
                break;
            case "lpwstr":
                c = br(this, this.l), e = 4 + 2 * _r(this, this.l);
                break;
            case "lpp4":
                e = 4 + _r(this, this.l), c = vr(this, this.l), 2 & e && (e += 2);
                break;
            case "8lpp4":
                e = 4 + _r(this, this.l), c = wr(this, this.l), 3 & e && (e += 4 - (3 & e));
                break;
            case "cstr":
                for(e = 0, c = ""; 0 !== (n = kr(this, this.l + e++));)l.push(u(n));
                c = l.join("");
                break;
            case "_wstr":
                for(e = 0, c = ""; 0 !== (n = yr(this, this.l + e));)l.push(u(n)), e += 2;
                e += 2, c = l.join("");
                break;
            case "dbcs-cont":
                for(c = "", o = this.l, i = 0; i < e; ++i){
                    if (this.lens && -1 !== this.lens.indexOf(o)) return n = kr(this, o), this.l = o + 1, s = Cr.call(this, e - i, n ? "dbcs-cont" : "sbcs-cont"), l.join("") + s;
                    l.push(u(yr(this, o))), o += 2;
                }
                c = l.join(""), e *= 2;
                break;
            case "cpstr":
                if (void 0 !== re) {
                    c = re.utils.decode(f, this.slice(this.l, this.l + e));
                    break;
                }
            case "sbcs-cont":
                for(c = "", o = this.l, i = 0; i != e; ++i){
                    if (this.lens && -1 !== this.lens.indexOf(o)) return n = kr(this, o), this.l = o + 1, s = Cr.call(this, e - i, n ? "dbcs-cont" : "sbcs-cont"), l.join("") + s;
                    l.push(u(kr(this, o))), o += 1;
                }
                c = l.join("");
                break;
            default:
                switch(e){
                    case 1:
                        return r = kr(this, this.l), this.l++, r;
                    case 2:
                        return r = ("i" === t ? Sr : yr)(this, this.l), this.l += 2, r;
                    case 4:
                    case -4:
                        return "i" === t || 0 == (128 & this[this.l + 3]) ? (r = (0 < e ? xr : Ar)(this, this.l), this.l += 4, r) : (a = _r(this, this.l), this.l += 4, a);
                    case 8:
                    case -8:
                        if ("f" === t) return a = 8 == e ? Tr(this, this.l) : Tr([
                            this[this.l + 7],
                            this[this.l + 6],
                            this[this.l + 5],
                            this[this.l + 4],
                            this[this.l + 3],
                            this[this.l + 2],
                            this[this.l + 1],
                            this[this.l + 0]
                        ], 0), this.l += 8, a;
                        e = 8;
                    case 16:
                        c = dr(this, this.l, e);
                }
        }
        return this.l += e, c;
    }
    var Rr = function(e, t, r) {
        e[r] = 255 & t, e[r + 1] = t >>> 8 & 255, e[r + 2] = t >>> 16 & 255, e[r + 3] = t >>> 24 & 255;
    }, Or = function(e, t, r) {
        e[r] = 255 & t, e[r + 1] = t >> 8 & 255, e[r + 2] = t >> 16 & 255, e[r + 3] = t >> 24 & 255;
    }, Ir = function(e, t, r) {
        e[r] = 255 & t, e[r + 1] = t >>> 8 & 255;
    };
    function Nr(e, t, r) {
        var a = 0, n = 0;
        if ("dbcs" === r) {
            for(n = 0; n != t.length; ++n)Ir(this, t.charCodeAt(n), this.l + 2 * n);
            a = 2 * t.length;
        } else if ("sbcs" === r) {
            if (void 0 !== re && 874 == _) for(n = 0; n != t.length; ++n){
                var s = re.utils.encode(_, t.charAt(n));
                this[this.l + n] = s[0];
            }
            else for(t = t.replace(/[^\x00-\x7F]/g, "_"), n = 0; n != t.length; ++n)this[this.l + n] = 255 & t.charCodeAt(n);
            a = t.length;
        } else {
            if ("hex" === r) {
                for(; n < e; ++n)this[this.l++] = parseInt(t.slice(2 * n, 2 * n + 2), 16) || 0;
                return this;
            }
            if ("utf16le" === r) {
                for(var i = Math.min(this.l + e, this.length), n = 0; n < Math.min(t.length, e); ++n){
                    var o = t.charCodeAt(n);
                    this[this.l++] = 255 & o, this[this.l++] = o >> 8;
                }
                for(; this.l < i;)this[this.l++] = 0;
                return this;
            }
            switch(e){
                case 1:
                    a = 1, this[this.l] = 255 & t;
                    break;
                case 2:
                    a = 2, this[this.l] = 255 & t, t >>>= 8, this[this.l + 1] = 255 & t;
                    break;
                case 3:
                    a = 3, this[this.l] = 255 & t, t >>>= 8, this[this.l + 1] = 255 & t, t >>>= 8, this[this.l + 2] = 255 & t;
                    break;
                case 4:
                    a = 4, Rr(this, t, this.l);
                    break;
                case 8:
                    if (a = 8, "f" === r) {
                        !function(e, t, r) {
                            var a = (t < 0 || 1 / t == -1 / 0 ? 1 : 0) << 7, n = 0, s = 0, i = a ? -t : t;
                            isFinite(i) ? 0 == i ? n = s = 0 : (n = Math.floor(Math.log(i) / Math.LN2), s = i * Math.pow(2, 52 - n), n <= -1023 && (!isFinite(s) || s < Math.pow(2, 52)) ? n = -1022 : (s -= Math.pow(2, 52), n += 1023)) : (n = 2047, s = isNaN(t) ? 26985 : 0);
                            for(var o = 0; o <= 5; ++o, s /= 256)e[r + o] = 255 & s;
                            e[r + 6] = (15 & n) << 4 | 15 & s, e[r + 7] = n >> 4 | a;
                        }(this, t, this.l);
                        break;
                    }
                case 16:
                    break;
                case -4:
                    a = 4, Or(this, t, this.l);
            }
        }
        return this.l += a, this;
    }
    function Fr(e, t) {
        var r = dr(this, this.l, e.length >> 1);
        if (r !== e) throw new Error(t + "Expected " + e + " saw " + r);
        this.l += e.length >> 1;
    }
    function Dr(e, t) {
        e.l = t, e.read_shift = Cr, e.chk = Fr, e.write_shift = Nr;
    }
    function Pr(e, t) {
        e.l += t;
    }
    function Lr(e) {
        e = le(e);
        return Dr(e, 0), e;
    }
    function Mr(e, t, r) {
        if (e) {
            Dr(e, e.l || 0);
            for(var a, n = e.length, s = 0; e.l < n;){
                128 & (s = e.read_shift(1)) && (s = (127 & s) + ((127 & e.read_shift(1)) << 7));
                for(var i, o = Df[s] || Df[65535], c = 127 & (i = e.read_shift(1)), l = 1; l < 4 && 128 & i; ++l)c += (127 & (i = e.read_shift(1))) << 7 * l;
                a = e.l + c;
                var f = o.f && o.f(e, c, r);
                if (e.l = a, t(f, o, s)) return;
            }
        }
    }
    function Ur() {
        function t(e) {
            return Dr(e = Lr(e), 0), e;
        }
        function r() {
            s && (s.length > s.l && ((s = s.slice(0, s.l)).l = s.length), 0 < s.length && e.push(s), s = null);
        }
        function a(e) {
            return s && e < s.length - s.l ? s : (r(), s = t(Math.max(e + 1, n)));
        }
        var e = [], n = se ? 256 : 2048, s = t(n);
        return {
            next: a,
            push: function(e) {
                r(), null == (s = e).l && (s.l = s.length), a(n);
            },
            end: function() {
                return r(), ue(e);
            },
            _bufs: e
        };
    }
    function Br(e, t, r, a) {
        var n = +t;
        if (!isNaN(n)) {
            t = 1 + (128 <= n ? 1 : 0) + 1, 128 <= (a = a || Df[n].p || (r || []).length || 0) && ++t, 16384 <= a && ++t, 2097152 <= a && ++t;
            var s = e.next(t);
            n <= 127 ? s.write_shift(1, n) : (s.write_shift(1, 128 + (127 & n)), s.write_shift(1, n >> 7));
            for(var i = 0; 4 != i; ++i){
                if (!(128 <= a)) {
                    s.write_shift(1, a);
                    break;
                }
                s.write_shift(1, 128 + (127 & a)), a >>= 7;
            }
            0 < a && Er(r) && e.push(r);
        }
    }
    function Wr(e, t, r) {
        var a = Ve(e);
        if (t.s ? (a.cRel && (a.c += t.s.c), a.rRel && (a.r += t.s.r)) : (a.cRel && (a.c += t.c), a.rRel && (a.r += t.r)), !r || r.biff < 12) {
            for(; 256 <= a.c;)a.c -= 256;
            for(; 65536 <= a.r;)a.r -= 65536;
        }
        return a;
    }
    function Hr(e, t, r) {
        e = Ve(e);
        return e.s = Wr(e.s, t.s, r), e.e = Wr(e.e, t.s, r), e;
    }
    function zr(e, t) {
        if (e.cRel && e.c < 0) for(e = Ve(e); e.c < 0;)e.c += 8 < t ? 16384 : 256;
        if (e.rRel && e.r < 0) for(e = Ve(e); e.r < 0;)e.r += 8 < t ? 1048576 : 5 < t ? 65536 : 16384;
        var r = Kr(e);
        return e.cRel || null == e.cRel || (r = r.replace(/^([A-Z])/, "$$$1")), r = !e.rRel && null != e.rRel ? r.replace(/([A-Z]|^)(\d+)$/, "$1$$$2") : r;
    }
    function Vr(e, t) {
        return 0 != e.s.r || e.s.rRel || e.e.r != (12 <= t.biff ? 1048575 : 8 <= t.biff ? 65536 : 16384) || e.e.rRel ? 0 != e.s.c || e.s.cRel || e.e.c != (12 <= t.biff ? 16383 : 255) || e.e.cRel ? zr(e.s, t.biff) + ":" + zr(e.e, t.biff) : (e.s.rRel ? "" : "$") + jr(e.s.r) + ":" + (e.e.rRel ? "" : "$") + jr(e.e.r) : (e.s.cRel ? "" : "$") + Xr(e.s.c) + ":" + (e.e.cRel ? "" : "$") + Xr(e.e.c);
    }
    function Gr(e) {
        return parseInt(e.replace(/\$(\d+)$/, "$1"), 10) - 1;
    }
    function jr(e) {
        return "" + (e + 1);
    }
    function $r(e) {
        for(var t = e.replace(/^\$([A-Z])/, "$1"), r = 0, a = 0; a !== t.length; ++a)r = 26 * r + t.charCodeAt(a) - 64;
        return r - 1;
    }
    function Xr(e) {
        if (e < 0) throw new Error("invalid column " + e);
        var t = "";
        for(++e; e; e = Math.floor((e - 1) / 26))t = String.fromCharCode((e - 1) % 26 + 65) + t;
        return t;
    }
    function Yr(e) {
        for(var t = 0, r = 0, a = 0; a < e.length; ++a){
            var n = e.charCodeAt(a);
            48 <= n && n <= 57 ? t = 10 * t + (n - 48) : 65 <= n && n <= 90 && (r = 26 * r + (n - 64));
        }
        return {
            c: r - 1,
            r: t - 1
        };
    }
    function Kr(e) {
        for(var t = e.c + 1, r = ""; t; t = (t - 1) / 26 | 0)r = String.fromCharCode((t - 1) % 26 + 65) + r;
        return r + (e.r + 1);
    }
    function Jr(e) {
        var t = e.indexOf(":");
        return -1 == t ? {
            s: Yr(e),
            e: Yr(e)
        } : {
            s: Yr(e.slice(0, t)),
            e: Yr(e.slice(t + 1))
        };
    }
    function qr(e, t) {
        return void 0 === t || "number" == typeof t ? qr(e.s, e.e) : (e = "string" != typeof e ? Kr(e) : e) == (t = "string" != typeof t ? Kr(t) : t) ? e : e + ":" + t;
    }
    function Zr(e) {
        for(var t = {
            s: {
                c: 0,
                r: 0
            },
            e: {
                c: 0,
                r: 0
            }
        }, r = 0, a = 0, n = 0, s = e.length, r = 0; a < s && !((n = e.charCodeAt(a) - 64) < 1 || 26 < n); ++a)r = 26 * r + n;
        for(t.s.c = --r, r = 0; a < s && !((n = e.charCodeAt(a) - 48) < 0 || 9 < n); ++a)r = 10 * r + n;
        if (t.s.r = --r, a === s || 10 != n) return t.e.c = t.s.c, t.e.r = t.s.r, t;
        for(++a, r = 0; a != s && !((n = e.charCodeAt(a) - 64) < 1 || 26 < n); ++a)r = 26 * r + n;
        for(t.e.c = --r, r = 0; a != s && !((n = e.charCodeAt(a) - 48) < 0 || 9 < n); ++a)r = 10 * r + n;
        return t.e.r = --r, t;
    }
    function Qr(e, t) {
        var r = "d" == e.t && t instanceof Date;
        if (null != e.z) try {
            return e.w = ve(e.z, r ? De(t) : t);
        } catch (e) {}
        try {
            return e.w = ve((e.XF || {}).numFmtId || (r ? 14 : 0), r ? De(t) : t);
        } catch (e) {
            return "" + t;
        }
    }
    function ea(e, t, r) {
        return null == e || null == e.t || "z" == e.t ? "" : void 0 !== e.w ? e.w : ("d" == e.t && !e.z && r && r.dateNF && (e.z = r.dateNF), "e" == e.t ? Wa[e.v] || e.v : Qr(e, null == t ? e.v : t));
    }
    function ta(e, t) {
        var r = t && t.sheet ? t.sheet : "Sheet1", t = {};
        return t[r] = e, {
            SheetNames: [
                r
            ],
            Sheets: t
        };
    }
    function ra(e, t, r) {
        var a = r || {}, n = e ? Array.isArray(e) : a.dense;
        null != oe && null == n && (n = oe);
        var s = e || (n ? [] : {}), i = 0, o = 0;
        s && null != a.origin && ("number" == typeof a.origin ? i = a.origin : (i = (c = "string" == typeof a.origin ? Yr(a.origin) : a.origin).r, o = c.c), s["!ref"] || (s["!ref"] = "A1:A1"));
        var c, l = {
            s: {
                c: 1e7,
                r: 1e7
            },
            e: {
                c: 0,
                r: 0
            }
        };
        s["!ref"] && (c = Zr(s["!ref"]), l.s.c = c.s.c, l.s.r = c.s.r, l.e.c = Math.max(l.e.c, c.e.c), l.e.r = Math.max(l.e.r, c.e.r), -1 == i && (l.e.r = i = c.e.r + 1));
        for(var f = 0; f != t.length; ++f)if (t[f]) {
            if (!Array.isArray(t[f])) throw new Error("aoa_to_sheet expects an array of arrays");
            for(var h = 0; h != t[f].length; ++h)if (void 0 !== t[f][h]) {
                var u = {
                    v: t[f][h]
                }, d = i + f, p = o + h;
                if (l.s.r > d && (l.s.r = d), l.s.c > p && (l.s.c = p), l.e.r < d && (l.e.r = d), l.e.c < p && (l.e.c = p), !t[f][h] || "object" != typeof t[f][h] || Array.isArray(t[f][h]) || t[f][h] instanceof Date) {
                    if (Array.isArray(u.v) && (u.f = t[f][h][1], u.v = u.v[0]), null === u.v) {
                        if (u.f) u.t = "n";
                        else if (a.nullError) u.t = "e", u.v = 0;
                        else {
                            if (!a.sheetStubs) continue;
                            u.t = "z";
                        }
                    } else "number" == typeof u.v ? u.t = "n" : "boolean" == typeof u.v ? u.t = "b" : u.v instanceof Date ? (u.z = a.dateNF || me[14], a.cellDates ? (u.t = "d", u.w = ve(u.z, De(u.v))) : (u.t = "n", u.v = De(u.v), u.w = ve(u.z, u.v))) : u.t = "s";
                } else u = t[f][h];
                n ? (s[d] || (s[d] = []), s[d][p] && s[d][p].z && (u.z = s[d][p].z), s[d][p] = u) : (s[d = Kr({
                    c: p,
                    r: d
                })] && s[d].z && (u.z = s[d].z), s[d] = u);
            }
        }
        return l.s.c < 1e7 && (s["!ref"] = qr(l)), s;
    }
    function aa(e, t) {
        return ra(null, e, t);
    }
    function na(e, t) {
        return (t = t || Lr(4)).write_shift(4, e), t;
    }
    function sa(e) {
        var t = e.read_shift(4);
        return 0 === t ? "" : e.read_shift(t, "dbcs");
    }
    function ia(e, t) {
        var r = !1;
        return null == t && (r = !0, t = Lr(4 + 2 * e.length)), t.write_shift(4, e.length), 0 < e.length && t.write_shift(0, e, "dbcs"), r ? t.slice(0, t.l) : t;
    }
    function oa(e, t) {
        var r, a = e.l, n = e.read_shift(1), s = sa(e), i = [], s = {
            t: s,
            h: s
        };
        if (0 != (1 & n)) {
            for(var o = e.read_shift(4), c = 0; c != o; ++c)i.push({
                ich: (r = e).read_shift(2),
                ifnt: r.read_shift(2)
            });
            s.r = i;
        } else s.r = [
            {
                ich: 0,
                ifnt: 0
            }
        ];
        return e.l = a + t, s;
    }
    var ca = oa;
    function la(e, t) {
        var r, a = !1;
        return null == t && (a = !0, t = Lr(23 + 4 * e.t.length)), t.write_shift(1, 1), ia(e.t, t), t.write_shift(4, 1), r = {
            ich: 0,
            ifnt: 0
        }, (e = (e = t) || Lr(4)).write_shift(2, r.ich || 0), e.write_shift(2, r.ifnt || 0), a ? t.slice(0, t.l) : t;
    }
    function fa(e) {
        var t = e.read_shift(4), r = e.read_shift(2);
        return r += e.read_shift(1) << 16, e.l++, {
            c: t,
            iStyleRef: r
        };
    }
    function ha(e, t) {
        return (t = null == t ? Lr(8) : t).write_shift(-4, e.c), t.write_shift(3, e.iStyleRef || e.s), t.write_shift(1, 0), t;
    }
    function ua(e) {
        var t = e.read_shift(2);
        return t += e.read_shift(1) << 16, e.l++, {
            c: -1,
            iStyleRef: t
        };
    }
    function da(e, t) {
        return (t = null == t ? Lr(4) : t).write_shift(3, e.iStyleRef || e.s), t.write_shift(1, 0), t;
    }
    var pa = sa, ma = ia;
    function ga(e) {
        var t = e.read_shift(4);
        return 0 === t || 4294967295 === t ? "" : e.read_shift(t, "dbcs");
    }
    function ba(e, t) {
        var r = !1;
        return null == t && (r = !0, t = Lr(127)), t.write_shift(4, 0 < e.length ? e.length : 4294967295), 0 < e.length && t.write_shift(0, e, "dbcs"), r ? t.slice(0, t.l) : t;
    }
    var va = sa, wa = ga, Ta = ba;
    function Ea(e) {
        var t = e.slice(e.l, e.l + 4), r = 1 & t[0], a = 2 & t[0];
        e.l += 4;
        t = 0 == a ? Tr([
            0,
            0,
            0,
            0,
            252 & t[0],
            t[1],
            t[2],
            t[3]
        ], 0) : xr(t, 0) >> 2;
        return r ? t / 100 : t;
    }
    function ka(e, t) {
        null == t && (t = Lr(4));
        var r = 0, a = 0, n = 100 * e;
        if (e == (0 | e) && -536870912 <= e && e < 536870912 ? a = 1 : n == (0 | n) && -536870912 <= n && n < 536870912 && (r = a = 1), !a) throw new Error("unsupported RkNumber " + e);
        t.write_shift(-4, ((r ? n : e) << 2) + (r + 2));
    }
    function ya(e) {
        var t = {
            s: {},
            e: {}
        };
        return t.s.r = e.read_shift(4), t.e.r = e.read_shift(4), t.s.c = e.read_shift(4), t.e.c = e.read_shift(4), t;
    }
    var Sa = ya, _a = function(e, t) {
        return (t = t || Lr(16)).write_shift(4, e.s.r), t.write_shift(4, e.e.r), t.write_shift(4, e.s.c), t.write_shift(4, e.e.c), t;
    };
    function xa(e) {
        if (e.length - e.l < 8) throw "XLS Xnum Buffer underflow";
        return e.read_shift(8, "f");
    }
    function Aa(e, t) {
        return (t || Lr(8)).write_shift(8, e, "f");
    }
    function Ca(e, t) {
        if (t = t || Lr(8), !e || e.auto) return t.write_shift(4, 0), t.write_shift(4, 0), t;
        null != e.index ? (t.write_shift(1, 2), t.write_shift(1, e.index)) : null != e.theme ? (t.write_shift(1, 6), t.write_shift(1, e.theme)) : (t.write_shift(1, 5), t.write_shift(1, 0));
        var r = e.tint || 0;
        return 0 < r ? r *= 32767 : r < 0 && (r *= 32768), t.write_shift(2, r), e.rgb && null == e.theme ? ("number" == typeof (e = e.rgb || "FFFFFF") && (e = ("000000" + e.toString(16)).slice(-6)), t.write_shift(1, parseInt(e.slice(0, 2), 16)), t.write_shift(1, parseInt(e.slice(2, 4), 16)), t.write_shift(1, parseInt(e.slice(4, 6), 16)), t.write_shift(1, 255)) : (t.write_shift(2, 0), t.write_shift(1, 0), t.write_shift(1, 0)), t;
    }
    function Ra(e, t) {
        var r = e.read_shift(4);
        switch(r){
            case 0:
                return "";
            case 4294967295:
            case 4294967294:
                return ({
                    2: "BITMAP",
                    3: "METAFILEPICT",
                    8: "DIB",
                    14: "ENHMETAFILE"
                })[e.read_shift(4)] || "";
        }
        if (400 < r) throw new Error("Unsupported Clipboard: " + r.toString(16));
        return e.l -= 4, e.read_shift(0, 1 == t ? "lpstr" : "lpwstr");
    }
    var Oa = 2, Ia = 3, Na = 12, Fa = 81, Da = [
        80,
        Fa
    ], Pa = {
        1: {
            n: "CodePage",
            t: Oa
        },
        2: {
            n: "Category",
            t: 80
        },
        3: {
            n: "PresentationFormat",
            t: 80
        },
        4: {
            n: "ByteCount",
            t: Ia
        },
        5: {
            n: "LineCount",
            t: Ia
        },
        6: {
            n: "ParagraphCount",
            t: Ia
        },
        7: {
            n: "SlideCount",
            t: Ia
        },
        8: {
            n: "NoteCount",
            t: Ia
        },
        9: {
            n: "HiddenCount",
            t: Ia
        },
        10: {
            n: "MultimediaClipCount",
            t: Ia
        },
        11: {
            n: "ScaleCrop",
            t: 11
        },
        12: {
            n: "HeadingPairs",
            t: 4108
        },
        13: {
            n: "TitlesOfParts",
            t: 4126
        },
        14: {
            n: "Manager",
            t: 80
        },
        15: {
            n: "Company",
            t: 80
        },
        16: {
            n: "LinksUpToDate",
            t: 11
        },
        17: {
            n: "CharacterCount",
            t: Ia
        },
        19: {
            n: "SharedDoc",
            t: 11
        },
        22: {
            n: "HyperlinksChanged",
            t: 11
        },
        23: {
            n: "AppVersion",
            t: Ia,
            p: "version"
        },
        24: {
            n: "DigSig",
            t: 65
        },
        26: {
            n: "ContentType",
            t: 80
        },
        27: {
            n: "ContentStatus",
            t: 80
        },
        28: {
            n: "Language",
            t: 80
        },
        29: {
            n: "Version",
            t: 80
        },
        255: {},
        2147483648: {
            n: "Locale",
            t: 19
        },
        2147483651: {
            n: "Behavior",
            t: 19
        },
        1919054434: {}
    }, La = {
        1: {
            n: "CodePage",
            t: Oa
        },
        2: {
            n: "Title",
            t: 80
        },
        3: {
            n: "Subject",
            t: 80
        },
        4: {
            n: "Author",
            t: 80
        },
        5: {
            n: "Keywords",
            t: 80
        },
        6: {
            n: "Comments",
            t: 80
        },
        7: {
            n: "Template",
            t: 80
        },
        8: {
            n: "LastAuthor",
            t: 80
        },
        9: {
            n: "RevNumber",
            t: 80
        },
        10: {
            n: "EditTime",
            t: 64
        },
        11: {
            n: "LastPrinted",
            t: 64
        },
        12: {
            n: "CreatedDate",
            t: 64
        },
        13: {
            n: "ModifiedDate",
            t: 64
        },
        14: {
            n: "PageCount",
            t: Ia
        },
        15: {
            n: "WordCount",
            t: Ia
        },
        16: {
            n: "CharCount",
            t: Ia
        },
        17: {
            n: "Thumbnail",
            t: 71
        },
        18: {
            n: "Application",
            t: 80
        },
        19: {
            n: "DocSecurity",
            t: Ia
        },
        255: {},
        2147483648: {
            n: "Locale",
            t: 19
        },
        2147483651: {
            n: "Behavior",
            t: 19
        },
        1919054434: {}
    }, Ma = {
        1: "US",
        2: "CA",
        3: "",
        7: "RU",
        20: "EG",
        30: "GR",
        31: "NL",
        32: "BE",
        33: "FR",
        34: "ES",
        36: "HU",
        39: "IT",
        41: "CH",
        43: "AT",
        44: "GB",
        45: "DK",
        46: "SE",
        47: "NO",
        48: "PL",
        49: "DE",
        52: "MX",
        55: "BR",
        61: "AU",
        64: "NZ",
        66: "TH",
        81: "JP",
        82: "KR",
        84: "VN",
        86: "CN",
        90: "TR",
        105: "JS",
        213: "DZ",
        216: "MA",
        218: "LY",
        351: "PT",
        354: "IS",
        358: "FI",
        420: "CZ",
        886: "TW",
        961: "LB",
        962: "JO",
        963: "SY",
        964: "IQ",
        965: "KW",
        966: "SA",
        971: "AE",
        972: "IL",
        974: "QA",
        981: "IR",
        65535: "US"
    }, Ua = [
        null,
        "solid",
        "mediumGray",
        "darkGray",
        "lightGray",
        "darkHorizontal",
        "darkVertical",
        "darkDown",
        "darkUp",
        "darkGrid",
        "darkTrellis",
        "lightHorizontal",
        "lightVertical",
        "lightDown",
        "lightUp",
        "lightGrid",
        "lightTrellis",
        "gray125",
        "gray0625"
    ];
    var Ba = Ve([
        0,
        16777215,
        16711680,
        65280,
        255,
        16776960,
        16711935,
        65535,
        0,
        16777215,
        16711680,
        65280,
        255,
        16776960,
        16711935,
        65535,
        8388608,
        32768,
        128,
        8421376,
        8388736,
        32896,
        12632256,
        8421504,
        10066431,
        10040166,
        16777164,
        13434879,
        6684774,
        16744576,
        26316,
        13421823,
        128,
        16711935,
        16776960,
        65535,
        8388736,
        8388608,
        32896,
        255,
        52479,
        13434879,
        13434828,
        16777113,
        10079487,
        16751052,
        13408767,
        16764057,
        3368703,
        3394764,
        10079232,
        16763904,
        16750848,
        16737792,
        6710937,
        9868950,
        13158,
        3381606,
        13056,
        3355392,
        10040064,
        10040166,
        3355545,
        3355443,
        16777215,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ].map(function(e) {
        return [
            e >> 16 & 255,
            e >> 8 & 255,
            255 & e
        ];
    })), Wa = {
        0: "#NULL!",
        7: "#DIV/0!",
        15: "#VALUE!",
        23: "#REF!",
        29: "#NAME?",
        36: "#NUM!",
        42: "#N/A",
        43: "#GETTING_DATA",
        255: "#WTF?"
    }, Ha = {
        "#NULL!": 0,
        "#DIV/0!": 7,
        "#VALUE!": 15,
        "#REF!": 23,
        "#NAME?": 29,
        "#NUM!": 36,
        "#N/A": 42,
        "#GETTING_DATA": 43,
        "#WTF?": 255
    }, za = {
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml": "workbooks",
        "application/vnd.ms-excel.sheet.macroEnabled.main+xml": "workbooks",
        "application/vnd.ms-excel.sheet.binary.macroEnabled.main": "workbooks",
        "application/vnd.ms-excel.addin.macroEnabled.main+xml": "workbooks",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml": "workbooks",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml": "sheets",
        "application/vnd.ms-excel.worksheet": "sheets",
        "application/vnd.ms-excel.binIndexWs": "TODO",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml": "charts",
        "application/vnd.ms-excel.chartsheet": "charts",
        "application/vnd.ms-excel.macrosheet+xml": "macros",
        "application/vnd.ms-excel.macrosheet": "macros",
        "application/vnd.ms-excel.intlmacrosheet": "TODO",
        "application/vnd.ms-excel.binIndexMs": "TODO",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml": "dialogs",
        "application/vnd.ms-excel.dialogsheet": "dialogs",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml": "strs",
        "application/vnd.ms-excel.sharedStrings": "strs",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml": "styles",
        "application/vnd.ms-excel.styles": "styles",
        "application/vnd.openxmlformats-package.core-properties+xml": "coreprops",
        "application/vnd.openxmlformats-officedocument.custom-properties+xml": "custprops",
        "application/vnd.openxmlformats-officedocument.extended-properties+xml": "extprops",
        "application/vnd.openxmlformats-officedocument.customXmlProperties+xml": "TODO",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.customProperty": "TODO",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml": "comments",
        "application/vnd.ms-excel.comments": "comments",
        "application/vnd.ms-excel.threadedcomments+xml": "threadedcomments",
        "application/vnd.ms-excel.person+xml": "people",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml": "metadata",
        "application/vnd.ms-excel.sheetMetadata": "metadata",
        "application/vnd.ms-excel.pivotTable": "TODO",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotTable+xml": "TODO",
        "application/vnd.openxmlformats-officedocument.drawingml.chart+xml": "TODO",
        "application/vnd.ms-office.chartcolorstyle+xml": "TODO",
        "application/vnd.ms-office.chartstyle+xml": "TODO",
        "application/vnd.ms-office.chartex+xml": "TODO",
        "application/vnd.ms-excel.calcChain": "calcchains",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.calcChain+xml": "calcchains",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.printerSettings": "TODO",
        "application/vnd.ms-office.activeX": "TODO",
        "application/vnd.ms-office.activeX+xml": "TODO",
        "application/vnd.ms-excel.attachedToolbars": "TODO",
        "application/vnd.ms-excel.connections": "TODO",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml": "TODO",
        "application/vnd.ms-excel.externalLink": "links",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.externalLink+xml": "links",
        "application/vnd.ms-excel.pivotCacheDefinition": "TODO",
        "application/vnd.ms-excel.pivotCacheRecords": "TODO",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheDefinition+xml": "TODO",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheRecords+xml": "TODO",
        "application/vnd.ms-excel.queryTable": "TODO",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.queryTable+xml": "TODO",
        "application/vnd.ms-excel.userNames": "TODO",
        "application/vnd.ms-excel.revisionHeaders": "TODO",
        "application/vnd.ms-excel.revisionLog": "TODO",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionHeaders+xml": "TODO",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionLog+xml": "TODO",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.userNames+xml": "TODO",
        "application/vnd.ms-excel.tableSingleCells": "TODO",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.tableSingleCells+xml": "TODO",
        "application/vnd.ms-excel.slicer": "TODO",
        "application/vnd.ms-excel.slicerCache": "TODO",
        "application/vnd.ms-excel.slicer+xml": "TODO",
        "application/vnd.ms-excel.slicerCache+xml": "TODO",
        "application/vnd.ms-excel.wsSortMap": "TODO",
        "application/vnd.ms-excel.table": "TODO",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml": "TODO",
        "application/vnd.openxmlformats-officedocument.theme+xml": "themes",
        "application/vnd.openxmlformats-officedocument.themeOverride+xml": "TODO",
        "application/vnd.ms-excel.Timeline+xml": "TODO",
        "application/vnd.ms-excel.TimelineCache+xml": "TODO",
        "application/vnd.ms-office.vbaProject": "vba",
        "application/vnd.ms-office.vbaProjectSignature": "TODO",
        "application/vnd.ms-office.volatileDependencies": "TODO",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.volatileDependencies+xml": "TODO",
        "application/vnd.ms-excel.controlproperties+xml": "TODO",
        "application/vnd.openxmlformats-officedocument.model+data": "TODO",
        "application/vnd.ms-excel.Survey+xml": "TODO",
        "application/vnd.openxmlformats-officedocument.drawing+xml": "drawings",
        "application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml": "TODO",
        "application/vnd.openxmlformats-officedocument.drawingml.diagramColors+xml": "TODO",
        "application/vnd.openxmlformats-officedocument.drawingml.diagramData+xml": "TODO",
        "application/vnd.openxmlformats-officedocument.drawingml.diagramLayout+xml": "TODO",
        "application/vnd.openxmlformats-officedocument.drawingml.diagramStyle+xml": "TODO",
        "application/vnd.openxmlformats-officedocument.vmlDrawing": "TODO",
        "application/vnd.openxmlformats-package.relationships+xml": "rels",
        "application/vnd.openxmlformats-officedocument.oleObject": "TODO",
        "image/png": "TODO",
        sheet: "js"
    }, Va = {
        workbooks: {
            xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml",
            xlsm: "application/vnd.ms-excel.sheet.macroEnabled.main+xml",
            xlsb: "application/vnd.ms-excel.sheet.binary.macroEnabled.main",
            xlam: "application/vnd.ms-excel.addin.macroEnabled.main+xml",
            xltx: "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml"
        },
        strs: {
            xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml",
            xlsb: "application/vnd.ms-excel.sharedStrings"
        },
        comments: {
            xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml",
            xlsb: "application/vnd.ms-excel.comments"
        },
        sheets: {
            xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml",
            xlsb: "application/vnd.ms-excel.worksheet"
        },
        charts: {
            xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml",
            xlsb: "application/vnd.ms-excel.chartsheet"
        },
        dialogs: {
            xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml",
            xlsb: "application/vnd.ms-excel.dialogsheet"
        },
        macros: {
            xlsx: "application/vnd.ms-excel.macrosheet+xml",
            xlsb: "application/vnd.ms-excel.macrosheet"
        },
        metadata: {
            xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml",
            xlsb: "application/vnd.ms-excel.sheetMetadata"
        },
        styles: {
            xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml",
            xlsb: "application/vnd.ms-excel.styles"
        }
    };
    function Ga() {
        return {
            workbooks: [],
            sheets: [],
            charts: [],
            dialogs: [],
            macros: [],
            rels: [],
            strs: [],
            comments: [],
            threadedcomments: [],
            links: [],
            coreprops: [],
            extprops: [],
            custprops: [],
            themes: [],
            styles: [],
            calcchains: [],
            vba: [],
            drawings: [],
            metadata: [],
            people: [],
            TODO: [],
            xmlns: ""
        };
    }
    function ja(r, a) {
        var t, n = function(e) {
            for(var t = [], r = Re(e), a = 0; a !== r.length; ++a)null == t[e[r[a]]] && (t[e[r[a]]] = []), t[e[r[a]]].push(r[a]);
            return t;
        }(za), s = [];
        s[s.length] = ot, s[s.length] = Yt("Types", null, {
            xmlns: Zt.CT,
            "xmlns:xsd": Zt.xsd,
            "xmlns:xsi": Zt.xsi
        }), s = s.concat([
            [
                "xml",
                "application/xml"
            ],
            [
                "bin",
                "application/vnd.ms-excel.sheet.binary.macroEnabled.main"
            ],
            [
                "vml",
                "application/vnd.openxmlformats-officedocument.vmlDrawing"
            ],
            [
                "data",
                "application/vnd.openxmlformats-officedocument.model+data"
            ],
            [
                "bmp",
                "image/bmp"
            ],
            [
                "png",
                "image/png"
            ],
            [
                "gif",
                "image/gif"
            ],
            [
                "emf",
                "image/x-emf"
            ],
            [
                "wmf",
                "image/x-wmf"
            ],
            [
                "jpg",
                "image/jpeg"
            ],
            [
                "jpeg",
                "image/jpeg"
            ],
            [
                "tif",
                "image/tiff"
            ],
            [
                "tiff",
                "image/tiff"
            ],
            [
                "pdf",
                "application/pdf"
            ],
            [
                "rels",
                "application/vnd.openxmlformats-package.relationships+xml"
            ]
        ].map(function(e) {
            return Yt("Default", null, {
                Extension: e[0],
                ContentType: e[1]
            });
        }));
        function e(e) {
            r[e] && 0 < r[e].length && (t = r[e][0], s[s.length] = Yt("Override", null, {
                PartName: ("/" == t[0] ? "" : "/") + t,
                ContentType: Va[e][a.bookType] || Va[e].xlsx
            }));
        }
        function i(t) {
            (r[t] || []).forEach(function(e) {
                s[s.length] = Yt("Override", null, {
                    PartName: ("/" == e[0] ? "" : "/") + e,
                    ContentType: Va[t][a.bookType] || Va[t].xlsx
                });
            });
        }
        function o(t) {
            (r[t] || []).forEach(function(e) {
                s[s.length] = Yt("Override", null, {
                    PartName: ("/" == e[0] ? "" : "/") + e,
                    ContentType: n[t][0]
                });
            });
        }
        return e("workbooks"), i("sheets"), i("charts"), o("themes"), [
            "strs",
            "styles"
        ].forEach(e), [
            "coreprops",
            "extprops",
            "custprops"
        ].forEach(o), o("vba"), o("comments"), o("threadedcomments"), o("drawings"), i("metadata"), o("people"), 2 < s.length && (s[s.length] = "</Types>", s[1] = s[1].replace("/>", ">")), s.join("");
    }
    var $a = {
        WB: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
        SHEET: "http://sheetjs.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
        HLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",
        VML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",
        XPATH: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLinkPath",
        XMISS: "http://schemas.microsoft.com/office/2006/relationships/xlExternalLinkPath/xlPathMissing",
        XLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLink",
        CXML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXml",
        CXMLP: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXmlProps",
        CMNT: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments",
        CORE_PROPS: "http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties",
        EXT_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties",
        CUST_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/custom-properties",
        SST: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings",
        STY: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles",
        THEME: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme",
        CHART: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chart",
        CHARTEX: "http://schemas.microsoft.com/office/2014/relationships/chartEx",
        CS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chartsheet",
        WS: [
            "http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet",
            "http://purl.oclc.org/ooxml/officeDocument/relationships/worksheet"
        ],
        DS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/dialogsheet",
        MS: "http://schemas.microsoft.com/office/2006/relationships/xlMacrosheet",
        IMG: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image",
        DRAW: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing",
        XLMETA: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sheetMetadata",
        TCMNT: "http://schemas.microsoft.com/office/2017/10/relationships/threadedComment",
        PEOPLE: "http://schemas.microsoft.com/office/2017/10/relationships/person",
        VBA: "http://schemas.microsoft.com/office/2006/relationships/vbaProject"
    };
    function Xa(e) {
        var t = e.lastIndexOf("/");
        return e.slice(0, t + 1) + "_rels/" + e.slice(t + 1) + ".rels";
    }
    function Ya(e, a) {
        var n = {
            "!id": {}
        };
        if (!e) return n;
        "/" !== a.charAt(0) && (a = "/" + a);
        var s = {};
        return (e.match(ft) || []).forEach(function(e) {
            var t, r = dt(e);
            "<Relationship" === r[0] && ((t = {}).Type = r.Type, t.Target = r.Target, t.Id = r.Id, r.TargetMode && (t.TargetMode = r.TargetMode), e = "External" === r.TargetMode ? r.Target : it(r.Target, a), n[e] = t, s[r.Id] = t);
        }), n["!id"] = s, n;
    }
    function Ka(t) {
        var r = [
            ot,
            Yt("Relationships", null, {
                xmlns: Zt.RELS
            })
        ];
        return Re(t["!id"]).forEach(function(e) {
            r[r.length] = Yt("Relationship", null, t["!id"][e]);
        }), 2 < r.length && (r[r.length] = "</Relationships>", r[1] = r[1].replace("/>", ">")), r.join("");
    }
    function Ja(e, t, r, a, n, s) {
        if (n = n || {}, e["!id"] || (e["!id"] = {}), e["!idx"] || (e["!idx"] = 1), t < 0) for(t = e["!idx"]; e["!id"]["rId" + t]; ++t);
        if (e["!idx"] = t + 1, n.Id = "rId" + t, n.Type = a, n.Target = r, s ? n.TargetMode = s : -1 < [
            $a.HLINK,
            $a.XPATH,
            $a.XMISS
        ].indexOf(n.Type) && (n.TargetMode = "External"), e["!id"][n.Id]) throw new Error("Cannot rewrite rId " + t);
        return e["!id"][n.Id] = n, e[("/" + n.Target).replace("//", "/")] = n, t;
    }
    var qa = "application/vnd.oasis.opendocument.spreadsheet";
    function Za(e, t, r) {
        return [
            '  <rdf:Description rdf:about="' + e + '">\n',
            '    <rdf:type rdf:resource="http://docs.oasis-open.org/ns/office/1.2/meta/' + (r || "odf") + "#" + t + '"/>\n',
            "  </rdf:Description>\n"
        ].join("");
    }
    function Qa() {
        return '<office:document-meta xmlns:office="urn:oasis:names:tc:opendocument:xmlns:office:1.0" xmlns:meta="urn:oasis:names:tc:opendocument:xmlns:meta:1.0" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:xlink="http://www.w3.org/1999/xlink" office:version="1.2"><office:meta><meta:generator>SheetJS ' + a.version + "</meta:generator></office:meta></office:document-meta>";
    }
    var en = [
        [
            "cp:category",
            "Category"
        ],
        [
            "cp:contentStatus",
            "ContentStatus"
        ],
        [
            "cp:keywords",
            "Keywords"
        ],
        [
            "cp:lastModifiedBy",
            "LastAuthor"
        ],
        [
            "cp:lastPrinted",
            "LastPrinted"
        ],
        [
            "cp:revision",
            "RevNumber"
        ],
        [
            "cp:version",
            "Version"
        ],
        [
            "dc:creator",
            "Author"
        ],
        [
            "dc:description",
            "Comments"
        ],
        [
            "dc:identifier",
            "Identifier"
        ],
        [
            "dc:language",
            "Language"
        ],
        [
            "dc:subject",
            "Subject"
        ],
        [
            "dc:title",
            "Title"
        ],
        [
            "dcterms:created",
            "CreatedDate",
            "date"
        ],
        [
            "dcterms:modified",
            "ModifiedDate",
            "date"
        ]
    ], tn = function() {
        for(var e = new Array(en.length), t = 0; t < en.length; ++t){
            var r = en[t], r = "(?:" + r[0].slice(0, r[0].indexOf(":")) + ":)" + r[0].slice(r[0].indexOf(":") + 1);
            e[t] = new RegExp("<" + r + "[^>]*>([\\s\\S]*?)</" + r + ">");
        }
        return e;
    }();
    function rn(e) {
        var t = {};
        e = Mt(e);
        for(var r = 0; r < en.length; ++r){
            var a = en[r], n = e.match(tn[r]);
            null != n && 0 < n.length && (t[a[1]] = wt(n[1])), "date" === a[2] && t[a[1]] && (t[a[1]] = He(t[a[1]]));
        }
        return t;
    }
    function an(e, t, r, a, n) {
        null == n[e] && null != t && "" !== t && (t = kt(n[e] = t), a[a.length] = r ? Yt(e, t, r) : $t(e, t));
    }
    function nn(e, t) {
        var r = t || {}, a = [
            ot,
            Yt("cp:coreProperties", null, {
                "xmlns:cp": Zt.CORE_PROPS,
                "xmlns:dc": Zt.dc,
                "xmlns:dcterms": Zt.dcterms,
                "xmlns:dcmitype": Zt.dcmitype,
                "xmlns:xsi": Zt.xsi
            })
        ], n = {};
        if (!e && !r.Props) return a.join("");
        e && (null != e.CreatedDate && an("dcterms:created", "string" == typeof e.CreatedDate ? e.CreatedDate : Kt(e.CreatedDate, r.WTF), {
            "xsi:type": "dcterms:W3CDTF"
        }, a, n), null != e.ModifiedDate && an("dcterms:modified", "string" == typeof e.ModifiedDate ? e.ModifiedDate : Kt(e.ModifiedDate, r.WTF), {
            "xsi:type": "dcterms:W3CDTF"
        }, a, n));
        for(var s = 0; s != en.length; ++s){
            var i = en[s], o = r.Props && null != r.Props[i[1]] ? r.Props[i[1]] : e ? e[i[1]] : null;
            !0 === o ? o = "1" : !1 === o ? o = "0" : "number" == typeof o && (o = String(o)), null != o && an(i[0], o, null, a, n);
        }
        return 2 < a.length && (a[a.length] = "</cp:coreProperties>", a[1] = a[1].replace("/>", ">")), a.join("");
    }
    var sn = [
        [
            "Application",
            "Application",
            "string"
        ],
        [
            "AppVersion",
            "AppVersion",
            "string"
        ],
        [
            "Company",
            "Company",
            "string"
        ],
        [
            "DocSecurity",
            "DocSecurity",
            "string"
        ],
        [
            "Manager",
            "Manager",
            "string"
        ],
        [
            "HyperlinksChanged",
            "HyperlinksChanged",
            "bool"
        ],
        [
            "SharedDoc",
            "SharedDoc",
            "bool"
        ],
        [
            "LinksUpToDate",
            "LinksUpToDate",
            "bool"
        ],
        [
            "ScaleCrop",
            "ScaleCrop",
            "bool"
        ],
        [
            "HeadingPairs",
            "HeadingPairs",
            "raw"
        ],
        [
            "TitlesOfParts",
            "TitlesOfParts",
            "raw"
        ]
    ], on = [
        "Worksheets",
        "SheetNames",
        "NamedRanges",
        "DefinedNames",
        "Chartsheets",
        "ChartNames"
    ];
    function cn(e, t, r, a) {
        var n = [];
        if ("string" == typeof e) n = Gt(e, a);
        else for(var s = 0; s < e.length; ++s)n = n.concat(e[s].map(function(e) {
            return {
                v: e
            };
        }));
        var i, o = "string" == typeof t ? Gt(t, a).map(function(e) {
            return e.v;
        }) : t, c = 0;
        if (0 < o.length) for(var l = 0; l !== n.length; l += 2){
            switch(i = +n[l + 1].v, n[l].v){
                case "Worksheets":
                case "\u5DE5\u4F5C\u8868":
                case "\u041B\u0438\u0441\u0442\u044B":
                case "\u0623\u0648\u0631\u0627\u0642 \u0627\u0644\u0639\u0645\u0644":
                case "\u30EF\u30FC\u30AF\u30B7\u30FC\u30C8":
                case "\u05D2\u05DC\u05D9\u05D5\u05E0\u05D5\u05EA \u05E2\u05D1\u05D5\u05D3\u05D4":
                case "Arbeitsbl\xe4tter":
                case "\xc7al\u0131\u015Fma Sayfalar\u0131":
                case "Feuilles de calcul":
                case "Fogli di lavoro":
                case "Folhas de c\xe1lculo":
                case "Planilhas":
                case "Regneark":
                case "Hojas de c\xe1lculo":
                case "Werkbladen":
                    r.Worksheets = i, r.SheetNames = o.slice(c, c + i);
                    break;
                case "Named Ranges":
                case "Rangos con nombre":
                case "\u540D\u524D\u4ED8\u304D\u4E00\u89A7":
                case "Benannte Bereiche":
                case "Navngivne omr\xe5der":
                    r.NamedRanges = i, r.DefinedNames = o.slice(c, c + i);
                    break;
                case "Charts":
                case "Diagramme":
                    r.Chartsheets = i, r.ChartNames = o.slice(c, c + i);
            }
            c += i;
        }
    }
    function ln(r) {
        var a = [], n = Yt;
        return (r = r || {}).Application = "SheetJS", a[a.length] = ot, a[a.length] = Yt("Properties", null, {
            xmlns: Zt.EXT_PROPS,
            "xmlns:vt": Zt.vt
        }), sn.forEach(function(e) {
            if (void 0 !== r[e[1]]) {
                var t;
                switch(e[2]){
                    case "string":
                        t = kt(String(r[e[1]]));
                        break;
                    case "bool":
                        t = r[e[1]] ? "true" : "false";
                }
                void 0 !== t && (a[a.length] = n(e[0], t));
            }
        }), a[a.length] = n("HeadingPairs", n("vt:vector", n("vt:variant", "<vt:lpstr>Worksheets</vt:lpstr>") + n("vt:variant", n("vt:i4", String(r.Worksheets))), {
            size: 2,
            baseType: "variant"
        })), a[a.length] = n("TitlesOfParts", n("vt:vector", r.SheetNames.map(function(e) {
            return "<vt:lpstr>" + kt(e) + "</vt:lpstr>";
        }).join(""), {
            size: r.Worksheets,
            baseType: "lpstr"
        })), 2 < a.length && (a[a.length] = "</Properties>", a[1] = a[1].replace("/>", ">")), a.join("");
    }
    var fn = /<[^>]+>[^<]*/g;
    function hn(t) {
        var r = [
            ot,
            Yt("Properties", null, {
                xmlns: Zt.CUST_PROPS,
                "xmlns:vt": Zt.vt
            })
        ];
        if (!t) return r.join("");
        var a = 1;
        return Re(t).forEach(function(e) {
            ++a, r[r.length] = Yt("property", function(e, t) {
                switch(typeof e){
                    case "string":
                        var r = Yt("vt:lpwstr", kt(e));
                        return r = t ? r.replace(/&quot;/g, "_x0022_") : r;
                    case "number":
                        return Yt((0 | e) == e ? "vt:i4" : "vt:r8", kt(String(e)));
                    case "boolean":
                        return Yt("vt:bool", e ? "true" : "false");
                }
                if (e instanceof Date) return Yt("vt:filetime", Kt(e));
                throw new Error("Unable to serialize " + e);
            }(t[e], !0), {
                fmtid: "{D5CDD505-2E9C-101B-9397-08002B2CF9AE}",
                pid: a,
                name: kt(e)
            });
        }), 2 < r.length && (r[r.length] = "</Properties>", r[1] = r[1].replace("/>", ">")), r.join("");
    }
    var un, dn = {
        Title: "Title",
        Subject: "Subject",
        Author: "Author",
        Keywords: "Keywords",
        Comments: "Description",
        LastAuthor: "LastAuthor",
        RevNumber: "Revision",
        Application: "AppName",
        LastPrinted: "LastPrinted",
        CreatedDate: "Created",
        ModifiedDate: "LastSaved",
        Category: "Category",
        Manager: "Manager",
        Company: "Company",
        AppVersion: "Version",
        ContentStatus: "ContentStatus",
        Identifier: "Identifier",
        Language: "Language"
    };
    function pn(e) {
        var t = e.read_shift(4), e = e.read_shift(4);
        return new Date(1e3 * (e / 1e7 * Math.pow(2, 32) + t / 1e7 - 11644473600)).toISOString().replace(/\.000/, "");
    }
    function mn(e, t, r) {
        var a = e.l, n = e.read_shift(0, "lpstr-cp");
        if (r) for(; e.l - a & 3;)++e.l;
        return n;
    }
    function gn(e, t, r) {
        var a = e.read_shift(0, "lpwstr");
        return r && (e.l += 4 - (a.length + 1 & 3) & 3), a;
    }
    function bn(e, t, r) {
        return 31 === t ? gn(e) : mn(e, 0, r);
    }
    function vn(e, t, r) {
        return bn(e, t, !1 === r ? 0 : 4);
    }
    function wn(e) {
        for(var t, r, a, n = e.read_shift(4), s = [], i = 0; i < n / 2; ++i)s.push((a = r = void 0, r = (t = e).l, a = kn(t, Fa), 0 == t[t.l] && 0 == t[t.l + 1] && t.l - r & 2 && (t.l += 2), [
            a,
            kn(t, Ia)
        ]));
        return s;
    }
    function Tn(e, t) {
        for(var r = e.read_shift(4), a = {}, n = 0; n != r; ++n){
            var s = e.read_shift(4), i = e.read_shift(4);
            a[s] = e.read_shift(i, 1200 === t ? "utf16le" : "utf8").replace(de, "").replace(pe, "!"), 1200 === t && i % 2 && (e.l += 2);
        }
        return 3 & e.l && (e.l = e.l >> 3 << 2), a;
    }
    function En(e) {
        var t = e.read_shift(4), r = e.slice(e.l, e.l + t);
        return e.l += t, 0 < (3 & t) && (e.l += 4 - (3 & t) & 3), r;
    }
    function kn(e, t, r) {
        var a, n, s = e.read_shift(2), i = r || {};
        if (e.l += 2, t !== Na && s !== t && -1 === Da.indexOf(t) && (4126 != (65534 & t) || 4126 != (65534 & s))) throw new Error("Expected type " + t + " saw " + s);
        switch(t === Na ? s : t){
            case 2:
                return a = e.read_shift(2, "i"), i.raw || (e.l += 2), a;
            case 3:
                return a = e.read_shift(4, "i");
            case 11:
                return 0 !== e.read_shift(4);
            case 19:
                return a = e.read_shift(4);
            case 30:
                return mn(e, 0, 4).replace(de, "");
            case 31:
                return gn(e);
            case 64:
                return pn(e);
            case 65:
                return En(e);
            case 71:
                return (n = {}).Size = (a = e).read_shift(4), a.l += n.Size + 3 - (n.Size - 1) % 4, n;
            case 80:
                return vn(e, s, !i.raw).replace(de, "");
            case 81:
                return (function(e, t) {
                    if (!t) throw new Error("VtUnalignedString must have positive length");
                    return bn(e, t, 0);
                })(e, s).replace(de, "");
            case 4108:
                return wn(e);
            case 4126:
            case 4127:
                return (4127 == s ? function(e) {
                    for(var t = e.read_shift(4), r = [], a = 0; a != t; ++a){
                        var n = e.l;
                        r[a] = e.read_shift(0, "lpwstr").replace(de, ""), e.l - n & 2 && (e.l += 2);
                    }
                    return r;
                } : function(e) {
                    for(var t = e.read_shift(4), r = [], a = 0; a != t; ++a)r[a] = e.read_shift(0, "lpstr-cp").replace(de, "");
                    return r;
                })(e);
            default:
                throw new Error("TypedPropertyValue unrecognized type " + t + " " + s);
        }
    }
    function yn(e, t) {
        var r, a, n, s = Lr(4), i = Lr(4);
        switch(s.write_shift(4, 80 == e ? 31 : e), e){
            case 3:
                i.write_shift(-4, t);
                break;
            case 5:
                (i = Lr(8)).write_shift(8, t, "f");
                break;
            case 11:
                i.write_shift(4, t ? 1 : 0);
                break;
            case 64:
                a = ("string" == typeof (r = t) ? new Date(Date.parse(r)) : r).getTime() / 1e3 + 11644473600, n = a % Math.pow(2, 32), r = (a - n) / Math.pow(2, 32), r *= 1e7, 0 < (a = (n *= 1e7) / Math.pow(2, 32) | 0) && (n %= Math.pow(2, 32), r += a), (a = Lr(8)).write_shift(4, n), a.write_shift(4, r), i = a;
                break;
            case 31:
            case 80:
                for((i = Lr(4 + 2 * (t.length + 1) + (t.length % 2 ? 0 : 2))).write_shift(4, t.length + 1), i.write_shift(0, t, "dbcs"); i.l != i.length;)i.write_shift(1, 0);
                break;
            default:
                throw new Error("TypedPropertyValue unrecognized type " + e + " " + t);
        }
        return ue([
            s,
            i
        ]);
    }
    function Sn(e, t) {
        for(var r = e.l, a = e.read_shift(4), n = e.read_shift(4), s = [], i = 0, o = 0, c = -1, l = {}, i = 0; i != n; ++i){
            var f = e.read_shift(4), h = e.read_shift(4);
            s[i] = [
                f,
                h + r
            ];
        }
        s.sort(function(e, t) {
            return e[1] - t[1];
        });
        var u = {};
        for(i = 0; i != n; ++i){
            if (e.l !== s[i][1]) {
                var d = !0;
                if (0 < i && t) switch(t[s[i - 1][0]].t){
                    case 2:
                        e.l + 2 === s[i][1] && (e.l += 2, d = !1);
                        break;
                    case 80:
                    case 4108:
                        e.l <= s[i][1] && (e.l = s[i][1], d = !1);
                }
                if ((!t || 0 == i) && e.l <= s[i][1] && (d = !1, e.l = s[i][1]), d) throw new Error("Read Error: Expected address " + s[i][1] + " at " + e.l + " :" + i);
            }
            if (t) {
                var p = t[s[i][0]];
                if (u[p.n] = kn(e, p.t, {
                    raw: !0
                }), "version" === p.p && (u[p.n] = String(u[p.n] >> 16) + "." + ("0000" + String(65535 & u[p.n])).slice(-4)), "CodePage" == p.n) switch(u[p.n]){
                    case 0:
                        u[p.n] = 1252;
                    case 874:
                    case 932:
                    case 936:
                    case 949:
                    case 950:
                    case 1250:
                    case 1251:
                    case 1253:
                    case 1254:
                    case 1255:
                    case 1256:
                    case 1257:
                    case 1258:
                    case 1e4:
                    case 1200:
                    case 1201:
                    case 1252:
                    case 65e3:
                    case -536:
                    case 65001:
                    case -535:
                        ie(o = u[p.n] >>> 0 & 65535);
                        break;
                    default:
                        throw new Error("Unsupported CodePage: " + u[p.n]);
                }
            } else if (1 === s[i][0]) {
                o = u.CodePage = kn(e, Oa);
                ie(o), -1 !== c && (g = e.l, e.l = s[c][1], l = Tn(e, o), e.l = g);
            } else if (0 === s[i][0]) 0 !== o ? l = Tn(e, o) : (c = i, e.l = s[i + 1][1]);
            else {
                var m, g = l[s[i][0]];
                switch(e[e.l]){
                    case 65:
                        e.l += 4, m = En(e);
                        break;
                    case 30:
                    case 31:
                        e.l += 4, m = vn(e, e[e.l - 4]).replace(/\u0000+$/, "");
                        break;
                    case 3:
                        e.l += 4, m = e.read_shift(4, "i");
                        break;
                    case 19:
                        e.l += 4, m = e.read_shift(4);
                        break;
                    case 5:
                        e.l += 4, m = e.read_shift(8, "f");
                        break;
                    case 11:
                        e.l += 4, m = On(e, 4);
                        break;
                    case 64:
                        e.l += 4, m = He(pn(e));
                        break;
                    default:
                        throw new Error("unparsed value: " + e[e.l]);
                }
                u[g] = m;
            }
        }
        return e.l = r + a, u;
    }
    var _n = [
        "CodePage",
        "Thumbnail",
        "_PID_LINKBASE",
        "_PID_HLINKS",
        "SystemIdentifier",
        "FMTID"
    ];
    function xn(e, t, r) {
        var a, n, s, i, o = Lr(8), c = [], l = [], f = 8, h = 0, u = Lr(8), d = Lr(8);
        if (u.write_shift(4, 2), u.write_shift(4, 1200), d.write_shift(4, 1), l.push(u), c.push(d), f += 8 + u.length, !t) {
            (d = Lr(8)).write_shift(4, 0), c.unshift(d);
            var p = [
                Lr(4)
            ];
            for(p[0].write_shift(4, e.length), h = 0; h < e.length; ++h){
                var m = e[h][0];
                for((u = Lr(8 + 2 * (m.length + 1) + (m.length % 2 ? 0 : 2))).write_shift(4, h + 2), u.write_shift(4, m.length + 1), u.write_shift(0, m, "dbcs"); u.l != u.length;)u.write_shift(1, 0);
                p.push(u);
            }
            u = ue(p), l.unshift(u), f += 8 + u.length;
        }
        for(h = 0; h < e.length; ++h)t && !t[e[h][0]] || -1 < _n.indexOf(e[h][0]) || -1 < on.indexOf(e[h][0]) || null != e[h][1] && (s = e[h][1], a = 0, u = t ? ("version" == (i = r[a = +t[e[h][0]]]).p && "string" == typeof s && (s = (+(n = s.split("."))[0] << 16) + (+n[1] || 0)), yn(i.t, s)) : (-1 == (i = function(e) {
            switch(typeof e){
                case "boolean":
                    return 11;
                case "number":
                    return (0 | e) == e ? 3 : 5;
                case "string":
                    return 31;
                case "object":
                    if (e instanceof Date) return 64;
            }
            return -1;
        }(s)) && (i = 31, s = String(s)), yn(i, s)), l.push(u), (d = Lr(8)).write_shift(4, t ? a : 2 + h), c.push(d), f += 8 + u.length);
        for(var g = 8 * (l.length + 1), h = 0; h < l.length; ++h)c[h].write_shift(4, g), g += l[h].length;
        return o.write_shift(4, f), o.write_shift(4, l.length), ue([
            o
        ].concat(c).concat(l));
    }
    function An(e, t, r) {
        var a = e.content;
        if (!a) return {};
        Dr(a, 0);
        var n, s = 0;
        a.chk("feff", "Byte Order: "), a.read_shift(2);
        var i = a.read_shift(4), o = a.read_shift(16);
        if (o !== xe.utils.consts.HEADER_CLSID && o !== r) throw new Error("Bad PropertySet CLSID " + o);
        if (1 !== (e = a.read_shift(4)) && 2 !== e) throw new Error("Unrecognized #Sets: " + e);
        if (r = a.read_shift(16), o = a.read_shift(4), 1 === e && o !== a.l) throw new Error("Length mismatch: " + o + " !== " + a.l);
        2 === e && (n = a.read_shift(16), s = a.read_shift(4));
        var c, l, f = Sn(a, t), h = {
            SystemIdentifier: i
        };
        for(c in f)h[c] = f[c];
        if (h.FMTID = r, 1 === e) return h;
        if (s - a.l == 2 && (a.l += 2), a.l !== s) throw new Error("Length mismatch 2: " + a.l + " !== " + s);
        try {
            l = Sn(a, null);
        } catch (e) {}
        for(c in l)h[c] = l[c];
        return h.FMTID = [
            r,
            n
        ], h;
    }
    function Cn(e, t, r, a, n, s) {
        var i = Lr(n ? 68 : 48), o = [
            i
        ];
        i.write_shift(2, 65534), i.write_shift(2, 0), i.write_shift(4, 842412599), i.write_shift(16, xe.utils.consts.HEADER_CLSID, "hex"), i.write_shift(4, n ? 2 : 1), i.write_shift(16, t, "hex"), i.write_shift(4, n ? 68 : 48);
        a = xn(e, r, a);
        return o.push(a), n && (n = xn(n, null, null), i.write_shift(16, s, "hex"), i.write_shift(4, 68 + a.length), o.push(n)), ue(o);
    }
    function Rn(e, t) {
        return e.read_shift(t), null;
    }
    function On(e, t) {
        return 1 === e.read_shift(t);
    }
    function In(e, t) {
        return (t = t || Lr(2)).write_shift(2, +!!e), t;
    }
    function Nn(e) {
        return e.read_shift(2, "u");
    }
    function Fn(e, t) {
        return (t = t || Lr(2)).write_shift(2, e), t;
    }
    function Dn(e, t) {
        return function(e, t, r) {
            for(var a = [], n = e.l + t; e.l < n;)a.push(r(e, n - e.l));
            if (n !== e.l) throw new Error("Slurp error");
            return a;
        }(e, t, Nn);
    }
    function Pn(e, t, r) {
        return (r = r || Lr(2)).write_shift(1, "e" == t ? +e : +!!e), r.write_shift(1, "e" == t ? 1 : 0), r;
    }
    function Ln(e, t, r) {
        var a = e.read_shift(r && 12 <= r.biff ? 2 : 1), n = "sbcs-cont", s = f;
        r && 8 <= r.biff && (f = 1200), r && 8 != r.biff ? 12 == r.biff && (n = "wstr") : e.read_shift(1) && (n = "dbcs-cont"), 2 <= r.biff && r.biff <= 5 && (n = "cpstr");
        n = a ? e.read_shift(a, n) : "";
        return f = s, n;
    }
    function Mn(e, t, r) {
        if (r) {
            if (2 <= r.biff && r.biff <= 5) return e.read_shift(t, "cpstr");
            if (12 <= r.biff) return e.read_shift(t, "dbcs-cont");
        }
        return 0 === e.read_shift(1) ? e.read_shift(t, "sbcs-cont") : e.read_shift(t, "dbcs-cont");
    }
    function Un(e, t, r) {
        var a = e.read_shift(r && 2 == r.biff ? 1 : 2);
        return 0 === a ? (e.l++, "") : Mn(e, a, r);
    }
    function Bn(e, t, r) {
        if (5 < r.biff) return Un(e, 0, r);
        var a = e.read_shift(1);
        return 0 === a ? (e.l++, "") : e.read_shift(a, r.biff <= 4 || !e.lens ? "cpstr" : "sbcs-cont");
    }
    function Wn(e, t, r) {
        return (r = r || Lr(3 + 2 * e.length)).write_shift(2, e.length), r.write_shift(1, 1), r.write_shift(31, e, "utf16le"), r;
    }
    function Hn(e) {
        var t, r, a, n, s = e.read_shift(16);
        switch(s){
            case "e0c9ea79f9bace118c8200aa004ba90b":
                return r = (t = e).read_shift(4), a = t.l, n = !1, 24 < r && (t.l += r - 24, "795881f43b1d7f48af2c825dc4852763" === t.read_shift(16) && (n = !0), t.l = a), r = t.read_shift((n ? r - 24 : r) >> 1, "utf16le").replace(de, ""), n && (t.l += 24), r;
            case "0303000000000000c000000000000046":
                return function(e) {
                    for(var t = e.read_shift(2), r = ""; 0 < t--;)r += "../";
                    var a = e.read_shift(0, "lpstr-ansi");
                    if (e.l += 2, 57005 != e.read_shift(2)) throw new Error("Bad FileMoniker");
                    if (0 === e.read_shift(4)) return r + a.replace(/\\/g, "/");
                    if (a = e.read_shift(4), 3 != e.read_shift(2)) throw new Error("Bad FileMoniker");
                    return r + e.read_shift(a >> 1, "utf16le").replace(de, "");
                }(e);
            default:
                throw new Error("Unsupported Moniker " + s);
        }
    }
    function zn(e) {
        var t = e.read_shift(4);
        return 0 < t ? e.read_shift(t, "utf16le").replace(de, "") : "";
    }
    function Vn(e, t) {
        (t = t || Lr(6 + 2 * e.length)).write_shift(4, 1 + e.length);
        for(var r = 0; r < e.length; ++r)t.write_shift(2, e.charCodeAt(r));
        return t.write_shift(2, 0), t;
    }
    function Gn(e) {
        return [
            e.read_shift(1),
            e.read_shift(1),
            e.read_shift(1),
            e.read_shift(1)
        ];
    }
    function jn(e) {
        e = Gn(e);
        return e[3] = 0, e;
    }
    function $n(e) {
        return {
            r: e.read_shift(2),
            c: e.read_shift(2),
            ixfe: e.read_shift(2)
        };
    }
    function Xn(e, t, r, a) {
        return (a = a || Lr(6)).write_shift(2, e), a.write_shift(2, t), a.write_shift(2, r || 0), a;
    }
    function Yn(e) {
        return [
            e.read_shift(2),
            Ea(e)
        ];
    }
    function Kn(e) {
        var t = e.read_shift(2), r = e.read_shift(2);
        return {
            s: {
                c: e.read_shift(2),
                r: t
            },
            e: {
                c: e.read_shift(2),
                r: r
            }
        };
    }
    function Jn(e, t) {
        return (t = t || Lr(8)).write_shift(2, e.s.r), t.write_shift(2, e.e.r), t.write_shift(2, e.s.c), t.write_shift(2, e.e.c), t;
    }
    function qn(e) {
        var t = e.read_shift(2), r = e.read_shift(2);
        return {
            s: {
                c: e.read_shift(1),
                r: t
            },
            e: {
                c: e.read_shift(1),
                r: r
            }
        };
    }
    var Zn = qn;
    function Qn(e) {
        e.l += 4;
        var t = e.read_shift(2), r = e.read_shift(2), a = e.read_shift(2);
        return e.l += 12, [
            r,
            t,
            a
        ];
    }
    function es(e) {
        e.l += 2, e.l += e.read_shift(2);
    }
    var ts = {
        0: es,
        4: es,
        5: es,
        6: es,
        7: function(e) {
            return e.l += 4, e.cf = e.read_shift(2), {};
        },
        8: es,
        9: es,
        10: es,
        11: es,
        12: es,
        13: function(e) {
            var t = {};
            return e.l += 4, e.l += 16, t.fSharedNote = e.read_shift(2), e.l += 4, t;
        },
        14: es,
        15: es,
        16: es,
        17: es,
        18: es,
        19: es,
        20: es,
        21: Qn
    };
    function rs(e, t) {
        var r = {
            BIFFVer: 0,
            dt: 0
        };
        switch(r.BIFFVer = e.read_shift(2), 2 <= (t -= 2) && (r.dt = e.read_shift(2), e.l -= 2), r.BIFFVer){
            case 1536:
            case 1280:
            case 1024:
            case 768:
            case 512:
            case 2:
            case 7:
                break;
            default:
                if (6 < t) throw new Error("Unexpected BIFF Ver " + r.BIFFVer);
        }
        return e.read_shift(t), r;
    }
    function as(e, t, r) {
        var a = 1536, n = 16;
        switch(r.bookType){
            case "biff8":
                break;
            case "biff5":
                a = 1280, n = 8;
                break;
            case "biff4":
                a = 4, n = 6;
                break;
            case "biff3":
                a = 3, n = 6;
                break;
            case "biff2":
                a = 2, n = 4;
                break;
            case "xla":
                break;
            default:
                throw new Error("unsupported BIFF version");
        }
        r = Lr(n);
        return r.write_shift(2, a), r.write_shift(2, t), 4 < n && r.write_shift(2, 29282), 6 < n && r.write_shift(2, 1997), 8 < n && (r.write_shift(2, 49161), r.write_shift(2, 1), r.write_shift(2, 1798), r.write_shift(2, 0)), r;
    }
    function ns(e) {
        var t = Lr(8);
        t.write_shift(4, e.Count), t.write_shift(4, e.Unique);
        for(var r, a, n, s = [], i = 0; i < e.length; ++i)s[i] = (r = e[i], n = a = void 0, a = r.t || "", (n = Lr(3)).write_shift(2, a.length), n.write_shift(1, 1), (r = Lr(2 * a.length)).write_shift(2 * a.length, a, "utf16le"), ue([
            n,
            r
        ]));
        var o = ue([
            t
        ].concat(s));
        return o.parts = [
            t.length
        ].concat(s.map(function(e) {
            return e.length;
        })), o;
    }
    function ss(e, t, r) {
        var a = 0;
        r && 2 == r.biff || (a = e.read_shift(2));
        e = e.read_shift(2);
        return r && 2 == r.biff && (a = 1 - (e >> 15), e &= 32767), [
            {
                Unsynced: 1 & a,
                DyZero: (2 & a) >> 1,
                ExAsc: (4 & a) >> 2,
                ExDsc: (8 & a) >> 3
            },
            e
        ];
    }
    var is = Bn;
    function os(e, t, r) {
        var a = e.l + t, n = 8 != r.biff && r.biff ? 2 : 4, s = e.read_shift(n), t = e.read_shift(n), r = e.read_shift(2), n = e.read_shift(2);
        return e.l = a, {
            s: {
                r: s,
                c: r
            },
            e: {
                r: t,
                c: n
            }
        };
    }
    function cs(e, t, r, a) {
        r = r && 5 == r.biff;
        (a = a || Lr(r ? 16 : 20)).write_shift(2, 0), e.style ? (a.write_shift(2, e.numFmtId || 0), a.write_shift(2, 65524)) : (a.write_shift(2, e.numFmtId || 0), a.write_shift(2, t << 4));
        t = 0;
        return 0 < e.numFmtId && r && (t |= 1024), a.write_shift(4, t), a.write_shift(4, 0), r || a.write_shift(4, 0), a.write_shift(2, 0), a;
    }
    function ls(e, t, r) {
        var a = $n(e);
        2 != r.biff && 9 != t || ++e.l;
        e = (t = e).read_shift(1), e = 1 === t.read_shift(1) ? e : 1 === e;
        return a.val = e, a.t = !0 === e || !1 === e ? "b" : "e", a;
    }
    function fs(e, t, r) {
        return 0 === t ? "" : Bn(e, 0, r);
    }
    function hs(e, t, r) {
        var a, n = e.read_shift(2), n = {
            fBuiltIn: 1 & n,
            fWantAdvise: n >>> 1 & 1,
            fWantPict: n >>> 2 & 1,
            fOle: n >>> 3 & 1,
            fOleLink: n >>> 4 & 1,
            cf: n >>> 5 & 1023,
            fIcon: n >>> 15 & 1
        };
        return 14849 === r.sbcch && (a = function(e, t, r) {
            e.l += 4, t -= 4;
            var a = e.l + t, t = Ln(e, 0, r);
            if ((r = e.read_shift(2)) !== (a -= e.l)) throw new Error("Malformed AddinUdf: padding = " + a + " != " + r);
            return e.l += r, t;
        }(e, t - 2, r)), n.body = a || e.read_shift(t - 2), "string" == typeof a && (n.Name = a), n;
    }
    var us = [
        "_xlnm.Consolidate_Area",
        "_xlnm.Auto_Open",
        "_xlnm.Auto_Close",
        "_xlnm.Extract",
        "_xlnm.Database",
        "_xlnm.Criteria",
        "_xlnm.Print_Area",
        "_xlnm.Print_Titles",
        "_xlnm.Recorder",
        "_xlnm.Data_Form",
        "_xlnm.Auto_Activate",
        "_xlnm.Auto_Deactivate",
        "_xlnm.Sheet_Title",
        "_xlnm._FilterDatabase"
    ];
    function ds(e, t, r) {
        var a = e.l + t, n = e.read_shift(2), s = e.read_shift(1), i = e.read_shift(1), o = e.read_shift(r && 2 == r.biff ? 1 : 2), t = 0;
        (!r || 5 <= r.biff) && (5 != r.biff && (e.l += 2), t = e.read_shift(2), 5 == r.biff && (e.l += 2), e.l += 4);
        i = Mn(e, i, r);
        32 & n && (i = us[i.charCodeAt(0)]);
        n = a - e.l;
        return r && 2 == r.biff && --n, {
            chKey: s,
            Name: i,
            itab: t,
            rgce: a != e.l && 0 !== o && 0 < n ? function(e, t, r, a) {
                var n, t = e.l + t, a = Ic(e, a, r);
                t !== e.l && (n = Oc(e, t - e.l, a, r));
                return [
                    a,
                    n
                ];
            }(e, n, r, o) : []
        };
    }
    function ps(e, t, r) {
        if (r.biff < 8) return function(e, t) {
            3 == e[e.l + 1] && e[e.l]++;
            t = Ln(e, 0, t);
            return 3 == t.charCodeAt(0) ? t.slice(1) : t;
        }(e, r);
        for(var a, n, s = [], t = e.l + t, i = e.read_shift(8 < r.biff ? 4 : 2); 0 != i--;)s.push((a = e, r.biff, n = 8 < (n = r).biff ? 4 : 2, [
            a.read_shift(n),
            a.read_shift(n, "i"),
            a.read_shift(n, "i")
        ]));
        if (e.l != t) throw new Error("Bad ExternSheet: " + e.l + " != " + t);
        return s;
    }
    function ms(e, t, r) {
        var a = Zn(e, 6);
        switch(r.biff){
            case 2:
                e.l++, t -= 7;
                break;
            case 3:
            case 4:
                e.l += 2, t -= 8;
                break;
            default:
                e.l += 6, t -= 12;
        }
        return [
            a,
            function(e, t, r) {
                var a, n = e.l + t, s = 2 == r.biff ? 1 : 2, i = e.read_shift(s);
                if (65535 == i) return [
                    [],
                    Pr(e, t - 2)
                ];
                var o = Ic(e, i, r);
                t !== i + s && (a = Oc(e, t - i - s, o, r));
                return e.l = n, [
                    o,
                    a
                ];
            }(e, t, r)
        ];
    }
    var gs = {
        8: function(e, t) {
            var r = e.l + t;
            e.l += 10;
            var a = e.read_shift(2);
            e.l += 4, e.l += 2, e.l += 2, e.l += 2, e.l += 4;
            t = e.read_shift(1);
            return e.l += t, e.l = r, {
                fmt: a
            };
        }
    };
    function bs(e) {
        var t = Lr(24), r = Yr(e[0]);
        t.write_shift(2, r.r), t.write_shift(2, r.r), t.write_shift(2, r.c), t.write_shift(2, r.c);
        for(var a = "d0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" "), n = 0; n < 16; ++n)t.write_shift(1, parseInt(a[n], 16));
        return ue([
            t,
            function(e) {
                var t = Lr(512), r = 0, a = e.Target, n = -1 < (e = (a = "file://" == a.slice(0, 7) ? a.slice(7) : a).indexOf("#")) ? 31 : 23;
                switch(a.charAt(0)){
                    case "#":
                        n = 28;
                        break;
                    case ".":
                        n &= -3;
                }
                t.write_shift(4, 2), t.write_shift(4, n);
                for(var s = [
                    8,
                    6815827,
                    6619237,
                    4849780,
                    83
                ], r = 0; r < s.length; ++r)t.write_shift(4, s[r]);
                if (28 == n) Vn(a = a.slice(1), t);
                else if (2 & n) {
                    for(s = "e0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" "), r = 0; r < s.length; ++r)t.write_shift(1, parseInt(s[r], 16));
                    var i = -1 < e ? a.slice(0, e) : a;
                    for(t.write_shift(4, 2 * (i.length + 1)), r = 0; r < i.length; ++r)t.write_shift(2, i.charCodeAt(r));
                    t.write_shift(2, 0), 8 & n && Vn(-1 < e ? a.slice(e + 1) : "", t);
                } else {
                    for(s = "03 03 00 00 00 00 00 00 c0 00 00 00 00 00 00 46".split(" "), r = 0; r < s.length; ++r)t.write_shift(1, parseInt(s[r], 16));
                    for(var o = 0; "../" == a.slice(3 * o, 3 * o + 3) || "..\\" == a.slice(3 * o, 3 * o + 3);)++o;
                    for(t.write_shift(2, o), t.write_shift(4, a.length - 3 * o + 1), r = 0; r < a.length - 3 * o; ++r)t.write_shift(1, 255 & a.charCodeAt(r + 3 * o));
                    for(t.write_shift(1, 0), t.write_shift(2, 65535), t.write_shift(2, 57005), r = 0; r < 6; ++r)t.write_shift(4, 0);
                }
                return t.slice(0, t.l);
            }(e[1])
        ]);
    }
    function vs(e, t, r) {
        if (!r.cellStyles) return Pr(e, t);
        var a = r && 12 <= r.biff ? 4 : 2, n = e.read_shift(a), s = e.read_shift(a), i = e.read_shift(a), o = e.read_shift(a), t = e.read_shift(2);
        2 == a && (e.l += 2);
        o = {
            s: n,
            e: s,
            w: i,
            ixfe: o,
            flags: t
        };
        return (5 <= r.biff || !r.biff) && (o.level = t >> 8 & 7), o;
    }
    var ws = $n, Ts = Dn, Es = Un;
    var ks, ys, Ss, _s = [
        2,
        3,
        48,
        49,
        131,
        139,
        140,
        245
    ], xs = (ks = {
        1: 437,
        2: 850,
        3: 1252,
        4: 1e4,
        100: 852,
        101: 866,
        102: 865,
        103: 861,
        104: 895,
        105: 620,
        106: 737,
        107: 857,
        120: 950,
        121: 949,
        122: 936,
        123: 932,
        124: 874,
        125: 1255,
        126: 1256,
        150: 10007,
        151: 10029,
        152: 10006,
        200: 1250,
        201: 1251,
        202: 1254,
        203: 1253,
        0: 20127,
        8: 865,
        9: 437,
        10: 850,
        11: 437,
        13: 437,
        14: 850,
        15: 437,
        16: 850,
        17: 437,
        18: 850,
        19: 932,
        20: 850,
        21: 437,
        22: 850,
        23: 865,
        24: 437,
        25: 437,
        26: 850,
        27: 437,
        28: 863,
        29: 850,
        31: 852,
        34: 852,
        35: 852,
        36: 860,
        37: 850,
        38: 866,
        55: 850,
        64: 852,
        77: 936,
        78: 949,
        79: 950,
        80: 874,
        87: 1252,
        88: 1252,
        89: 1252,
        108: 863,
        134: 737,
        135: 852,
        136: 857,
        204: 1257,
        255: 16969
    }, ys = Ie({
        1: 437,
        2: 850,
        3: 1252,
        4: 1e4,
        100: 852,
        101: 866,
        102: 865,
        103: 861,
        104: 895,
        105: 620,
        106: 737,
        107: 857,
        120: 950,
        121: 949,
        122: 936,
        123: 932,
        124: 874,
        125: 1255,
        126: 1256,
        150: 10007,
        151: 10029,
        152: 10006,
        200: 1250,
        201: 1251,
        202: 1254,
        203: 1253,
        0: 20127
    }), Ss = {
        B: 8,
        C: 250,
        L: 1,
        D: 8,
        "?": 0,
        "": 0
    }, {
        to_workbook: function(e, t) {
            try {
                return ta(As(e, t), t);
            } catch (e) {
                if (t && t.WTF) throw e;
            }
            return {
                SheetNames: [],
                Sheets: {}
            };
        },
        to_sheet: As,
        from_sheet: function(e, t) {
            if (0 <= +(t = t || {}).codepage && ie(+t.codepage), "string" == t.type) throw new Error("Cannot write DBF to JS string");
            for(var r = Ur(), a = (t = iu(e, {
                header: 1,
                raw: !0,
                cellDates: !0
            }))[0], n = t.slice(1), s = e["!cols"] || [], i = 0, o = 0, c = 0, l = 1, i = 0; i < a.length; ++i)if (((s[i] || {}).DBF || {}).name) a[i] = s[i].DBF.name, ++c;
            else if (null != a[i]) {
                if (++c, "number" == typeof a[i] && (a[i] = a[i].toString(10)), "string" != typeof a[i]) throw new Error("DBF Invalid column name " + a[i] + " |" + typeof a[i] + "|");
                if (a.indexOf(a[i]) !== i) {
                    for(o = 0; o < 1024; ++o)if (-1 == a.indexOf(a[i] + "_" + o)) {
                        a[i] += "_" + o;
                        break;
                    }
                }
            }
            var f = Zr(e["!ref"]), h = [], u = [], d = [];
            for(i = 0; i <= f.e.c - f.s.c; ++i){
                for(var p = "", m = "", g = 0, b = [], o = 0; o < n.length; ++o)null != n[o][i] && b.push(n[o][i]);
                if (0 != b.length && null != a[i]) {
                    for(o = 0; o < b.length; ++o){
                        switch(typeof b[o]){
                            case "number":
                                m = "B";
                                break;
                            case "string":
                                m = "C";
                                break;
                            case "boolean":
                                m = "L";
                                break;
                            case "object":
                                m = b[o] instanceof Date ? "D" : "C";
                                break;
                            default:
                                m = "C";
                        }
                        g = Math.max(g, String(b[o]).length), p = p && p != m ? "C" : m;
                    }
                    250 < g && (g = 250), "C" == (m = ((s[i] || {}).DBF || {}).type) && s[i].DBF.len > g && (g = s[i].DBF.len), "B" == p && "N" == m && (p = "N", d[i] = s[i].DBF.dec, g = s[i].DBF.len), u[i] = "C" == p || "N" == m ? g : Ss[p] || 0, l += u[i], h[i] = p;
                } else h[i] = "?";
            }
            var v, w, T = r.next(32);
            for(T.write_shift(4, 318902576), T.write_shift(4, n.length), T.write_shift(2, 296 + 32 * c), T.write_shift(2, l), i = 0; i < 4; ++i)T.write_shift(4, 0);
            for(T.write_shift(4, 0 | (+ys[_] || 3) << 8), o = i = 0; i < a.length; ++i)null != a[i] && (v = r.next(32), w = (a[i].slice(-10) + "\0\0\0\0\0\0\0\0\0\0\0").slice(0, 11), v.write_shift(1, w, "sbcs"), v.write_shift(1, "?" == h[i] ? "C" : h[i], "sbcs"), v.write_shift(4, o), v.write_shift(1, u[i] || Ss[h[i]] || 0), v.write_shift(1, d[i] || 0), v.write_shift(1, 2), v.write_shift(4, 0), v.write_shift(1, 0), v.write_shift(4, 0), v.write_shift(4, 0), o += u[i] || Ss[h[i]] || 0);
            var E = r.next(264);
            for(E.write_shift(4, 13), i = 0; i < 65; ++i)E.write_shift(4, 0);
            for(i = 0; i < n.length; ++i){
                var k = r.next(l);
                for(k.write_shift(1, 0), o = 0; o < a.length; ++o)if (null != a[o]) switch(h[o]){
                    case "L":
                        k.write_shift(1, null == n[i][o] ? 63 : n[i][o] ? 84 : 70);
                        break;
                    case "B":
                        k.write_shift(8, n[i][o] || 0, "f");
                        break;
                    case "N":
                        var y = "0";
                        for("number" == typeof n[i][o] && (y = n[i][o].toFixed(d[o] || 0)), c = 0; c < u[o] - y.length; ++c)k.write_shift(1, 32);
                        k.write_shift(1, y, "sbcs");
                        break;
                    case "D":
                        n[i][o] ? (k.write_shift(4, ("0000" + n[i][o].getFullYear()).slice(-4), "sbcs"), k.write_shift(2, ("00" + (n[i][o].getMonth() + 1)).slice(-2), "sbcs"), k.write_shift(2, ("00" + n[i][o].getDate()).slice(-2), "sbcs")) : k.write_shift(8, "00000000", "sbcs");
                        break;
                    case "C":
                        var S = String(null != n[i][o] ? n[i][o] : "").slice(0, u[o]);
                        for(k.write_shift(1, S, "sbcs"), c = 0; c < u[o] - S.length; ++c)k.write_shift(1, 32);
                }
            }
            return r.next(1).write_shift(1, 26), r.end();
        }
    });
    function As(e, t) {
        t = t || {};
        t.dateNF || (t.dateNF = "yyyymmdd");
        e = aa(function(e, t) {
            var r = [], a = le(1);
            switch(t.type){
                case "base64":
                    a = he(te(e));
                    break;
                case "binary":
                    a = he(e);
                    break;
                case "buffer":
                case "array":
                    a = e;
            }
            Dr(a, 0);
            var n = a.read_shift(1), s = !!(136 & n), i = !1, o = !1;
            switch(n){
                case 2:
                case 3:
                    break;
                case 48:
                case 49:
                    s = i = !0;
                    break;
                case 131:
                case 139:
                    break;
                case 140:
                    o = !0;
                    break;
                case 245:
                    break;
                default:
                    throw new Error("DBF Unsupported Version: " + n.toString(16));
            }
            var c = 0, l = 521;
            2 == n && (c = a.read_shift(2)), a.l += 3, 1048576 < (c = 2 != n ? a.read_shift(4) : c) && (c = 1e6), 2 != n && (l = a.read_shift(2));
            var f = a.read_shift(2), h = t.codepage || 1252;
            2 != n && (a.l += 16, a.read_shift(1), 0 !== a[a.l] && (h = ks[a[a.l]]), a.l += 1, a.l += 2), o && (a.l += 36);
            for(var u = [], d = {}, p = Math.min(a.length, 2 == n ? 521 : l - 10 - (i ? 264 : 0)), m = o ? 32 : 11; a.l < p && 13 != a[a.l];)switch((d = {}).name = re.utils.decode(h, a.slice(a.l, a.l + m)).replace(/[\u0000\r\n].*$/g, ""), a.l += m, d.type = String.fromCharCode(a.read_shift(1)), 2 == n || o || (d.offset = a.read_shift(4)), d.len = a.read_shift(1), 2 == n && (d.offset = a.read_shift(2)), d.dec = a.read_shift(1), d.name.length && u.push(d), 2 != n && (a.l += o ? 13 : 14), d.type){
                case "B":
                    i && 8 == d.len || !t.WTF || console.log("Skipping " + d.name + ":" + d.type);
                    break;
                case "G":
                case "P":
                    t.WTF && console.log("Skipping " + d.name + ":" + d.type);
                    break;
                case "+":
                case "0":
                case "@":
                case "C":
                case "D":
                case "F":
                case "I":
                case "L":
                case "M":
                case "N":
                case "O":
                case "T":
                case "Y":
                    break;
                default:
                    throw new Error("Unknown Field Type: " + d.type);
            }
            if (13 !== a[a.l] && (a.l = l - 1), 13 !== a.read_shift(1)) throw new Error("DBF Terminator not found " + a.l + " " + a[a.l]);
            a.l = l;
            var g = 0, b = 0;
            for(r[0] = [], b = 0; b != u.length; ++b)r[0][b] = u[b].name;
            for(; 0 < c--;)if (42 !== a[a.l]) for(++a.l, r[++g] = [], b = b = 0; b != u.length; ++b){
                var v = a.slice(a.l, a.l + u[b].len);
                a.l += u[b].len, Dr(v, 0);
                var w = re.utils.decode(h, v);
                switch(u[b].type){
                    case "C":
                        w.trim().length && (r[g][b] = w.replace(/\s+$/, ""));
                        break;
                    case "D":
                        8 === w.length ? r[g][b] = new Date(+w.slice(0, 4), +w.slice(4, 6) - 1, +w.slice(6, 8)) : r[g][b] = w;
                        break;
                    case "F":
                        r[g][b] = parseFloat(w.trim());
                        break;
                    case "+":
                    case "I":
                        r[g][b] = o ? 2147483648 ^ v.read_shift(-4, "i") : v.read_shift(4, "i");
                        break;
                    case "L":
                        switch(w.trim().toUpperCase()){
                            case "Y":
                            case "T":
                                r[g][b] = !0;
                                break;
                            case "N":
                            case "F":
                                r[g][b] = !1;
                                break;
                            case "":
                            case "?":
                                break;
                            default:
                                throw new Error("DBF Unrecognized L:|" + w + "|");
                        }
                        break;
                    case "M":
                        if (!s) throw new Error("DBF Unexpected MEMO for type " + n.toString(16));
                        r[g][b] = "##MEMO##" + (o ? parseInt(w.trim(), 10) : v.read_shift(4));
                        break;
                    case "N":
                        (w = w.replace(/\u0000/g, "").trim()) && "." != w && (r[g][b] = +w || 0);
                        break;
                    case "@":
                        r[g][b] = new Date(v.read_shift(-8, "f") - 621356832e5);
                        break;
                    case "T":
                        r[g][b] = new Date(864e5 * (v.read_shift(4) - 2440588) + v.read_shift(4));
                        break;
                    case "Y":
                        r[g][b] = v.read_shift(4, "i") / 1e4 + v.read_shift(4, "i") / 1e4 * Math.pow(2, 32);
                        break;
                    case "O":
                        r[g][b] = -v.read_shift(-8, "f");
                        break;
                    case "B":
                        if (i && 8 == u[b].len) {
                            r[g][b] = v.read_shift(8, "f");
                            break;
                        }
                    case "G":
                    case "P":
                        v.l += u[b].len;
                        break;
                    case "0":
                        if ("_NullFlags" === u[b].name) break;
                    default:
                        throw new Error("DBF Unsupported data type " + u[b].type);
                }
            }
            else a.l += f;
            if (2 != n && a.l < a.length && 26 != a[a.l++]) throw new Error("DBF EOF Marker missing " + (a.l - 1) + " of " + a.length + " " + a[a.l - 1].toString(16));
            return t && t.sheetRows && (r = r.slice(0, t.sheetRows)), t.DBF = u, r;
        }(e, t), t);
        return e["!cols"] = t.DBF.map(function(e) {
            return {
                wch: e.len,
                DBF: e
            };
        }), delete t.DBF, e;
    }
    var Cs, Rs, Os, Is, Ns = (Cs = {
        AA: "\xc0",
        BA: "\xc1",
        CA: "\xc2",
        DA: 195,
        HA: "\xc4",
        JA: 197,
        AE: "\xc8",
        BE: "\xc9",
        CE: "\xca",
        HE: "\xcb",
        AI: "\xcc",
        BI: "\xcd",
        CI: "\xce",
        HI: "\xcf",
        AO: "\xd2",
        BO: "\xd3",
        CO: "\xd4",
        DO: 213,
        HO: "\xd6",
        AU: "\xd9",
        BU: "\xda",
        CU: "\xdb",
        HU: "\xdc",
        Aa: "\xe0",
        Ba: "\xe1",
        Ca: "\xe2",
        Da: 227,
        Ha: "\xe4",
        Ja: 229,
        Ae: "\xe8",
        Be: "\xe9",
        Ce: "\xea",
        He: "\xeb",
        Ai: "\xec",
        Bi: "\xed",
        Ci: "\xee",
        Hi: "\xef",
        Ao: "\xf2",
        Bo: "\xf3",
        Co: "\xf4",
        Do: 245,
        Ho: "\xf6",
        Au: "\xf9",
        Bu: "\xfa",
        Cu: "\xfb",
        Hu: "\xfc",
        KC: "\xc7",
        Kc: "\xe7",
        q: "\xe6",
        z: "\u0153",
        a: "\xc6",
        j: "\u0152",
        DN: 209,
        Dn: 241,
        Hy: 255,
        S: 169,
        c: 170,
        R: 174,
        "B ": 180,
        0: 176,
        1: 177,
        2: 178,
        3: 179,
        5: 181,
        6: 182,
        7: 183,
        Q: 185,
        k: 186,
        b: 208,
        i: 216,
        l: 222,
        s: 240,
        y: 248,
        "!": 161,
        '"': 162,
        "#": 163,
        "(": 164,
        "%": 165,
        "'": 167,
        "H ": 168,
        "+": 171,
        ";": 187,
        "<": 188,
        "=": 189,
        ">": 190,
        "?": 191,
        "{": 223
    }, Rs = new RegExp("N(" + Re(Cs).join("|").replace(/\|\|\|/, "|\\||").replace(/([?()+])/g, "\\$1") + "|\\|)", "gm"), Os = function(e, t) {
        t = Cs[t];
        return "number" == typeof t ? n(t) : t;
    }, Is = function(e, t, r) {
        r = t.charCodeAt(0) - 32 << 4 | r.charCodeAt(0) - 48;
        return 59 == r ? e : n(r);
    }, Cs["|"] = 254, {
        to_workbook: function(e, t) {
            return ta(Ds(e, t), t);
        },
        to_sheet: Ds,
        from_sheet: function(e, t) {
            var r, a, n = [
                "ID;PWXL;N;E"
            ], s = [], i = Zr(e["!ref"]), o = Array.isArray(e), c = "\r\n";
            n.push("P;PGeneral"), n.push("F;P0;DG0G8;M255"), e["!cols"] && (r = n, e["!cols"].forEach(function(e, t) {
                t = "F;W" + (t + 1) + " " + (t + 1) + " ";
                e.hidden ? t += "0" : ("number" != typeof e.width || e.wpx || (e.wpx = so(e.width)), "number" != typeof e.wpx || e.wch || (e.wch = io(e.wpx)), "number" == typeof e.wch && (t += Math.round(e.wch))), " " != t.charAt(t.length - 1) && r.push(t);
            })), e["!rows"] && (a = n, e["!rows"].forEach(function(e, t) {
                var r = "F;";
                e.hidden ? r += "M0;" : e.hpt ? r += "M" + 20 * e.hpt + ";" : e.hpx && (r += "M" + 20 * uo(e.hpx) + ";"), 2 < r.length && a.push(r + "R" + (t + 1));
            })), n.push("B;Y" + (i.e.r - i.s.r + 1) + ";X" + (i.e.c - i.s.c + 1) + ";D" + [
                i.s.c,
                i.s.r,
                i.e.c,
                i.e.r
            ].join(" "));
            for(var l = i.s.r; l <= i.e.r; ++l)for(var f = i.s.c; f <= i.e.c; ++f){
                var h = Kr({
                    r: l,
                    c: f
                });
                (h = o ? (e[l] || [])[f] : e[h]) && (null != h.v || h.f && !h.F) && s.push(function(e, t, r) {
                    var a = "C;Y" + (t + 1) + ";X" + (r + 1) + ";K";
                    switch(e.t){
                        case "n":
                            a += e.v || 0, e.f && !e.F && (a += ";E" + fc(e.f, {
                                r: t,
                                c: r
                            }));
                            break;
                        case "b":
                            a += e.v ? "TRUE" : "FALSE";
                            break;
                        case "e":
                            a += e.w || e.v;
                            break;
                        case "d":
                            a += '"' + (e.w || e.v) + '"';
                            break;
                        case "s":
                            a += '"' + e.v.replace(/"/g, "").replace(/;/g, ";;") + '"';
                    }
                    return a;
                }(h, l, f));
            }
            return n.join(c) + c + s.join(c) + c + "E" + c;
        }
    });
    function Fs(e, t) {
        var r, a, n = e.split(/[\n\r]+/), s = -1, i = -1, o = 0, c = 0, l = [], f = [], h = null, e = {}, u = [], d = [], p = 0;
        for(0 <= +t.codepage && ie(+t.codepage); o !== n.length; ++o){
            p = 0;
            var m, g = n[o].trim().replace(/\x1B([\x20-\x2F])([\x30-\x3F])/g, Is).replace(Rs, Os), b = g.replace(/;;/g, "\0").split(";").map(function(e) {
                return e.replace(/\u0000/g, ";");
            }), v = b[0];
            if (0 < g.length) switch(v){
                case "ID":
                case "E":
                case "B":
                case "O":
                case "W":
                    break;
                case "P":
                    "P" == b[1].charAt(0) && f.push(g.slice(3).replace(/;;/g, ";"));
                    break;
                case "C":
                    for(var w = !1, T = !1, E = !1, k = !1, y = -1, S = -1, c = 1; c < b.length; ++c)switch(b[c].charAt(0)){
                        case "A":
                            break;
                        case "X":
                            i = parseInt(b[c].slice(1)) - 1, T = !0;
                            break;
                        case "Y":
                            for(s = parseInt(b[c].slice(1)) - 1, T || (i = 0), a = l.length; a <= s; ++a)l[a] = [];
                            break;
                        case "K":
                            '"' === (m = b[c].slice(1)).charAt(0) ? m = m.slice(1, m.length - 1) : "TRUE" === m ? m = !0 : "FALSE" === m ? m = !1 : isNaN(je(m)) ? isNaN(Xe(m).getDate()) || (m = He(m)) : (m = je(m), null !== h && q(h) && (m = Me(m))), void 0 !== re && "string" == typeof m && "string" != (t || {}).type && (t || {}).codepage && (m = re.utils.decode(t.codepage, m)), w = !0;
                            break;
                        case "E":
                            k = !0;
                            var _ = oc(b[c].slice(1), {
                                r: s,
                                c: i
                            });
                            l[s][i] = [
                                l[s][i],
                                _
                            ];
                            break;
                        case "S":
                            E = !0, l[s][i] = [
                                l[s][i],
                                "S5S"
                            ];
                            break;
                        case "G":
                            break;
                        case "R":
                            y = parseInt(b[c].slice(1)) - 1;
                            break;
                        case "C":
                            S = parseInt(b[c].slice(1)) - 1;
                            break;
                        default:
                            if (t && t.WTF) throw new Error("SYLK bad record " + g);
                    }
                    if (w && (l[s][i] && 2 == l[s][i].length ? l[s][i][0] = m : l[s][i] = m, h = null), E) {
                        if (k) throw new Error("SYLK shared formula cannot have own formula");
                        var x = -1 < y && l[y][S];
                        if (!x || !x[1]) throw new Error("SYLK shared formula cannot find base");
                        l[s][i][1] = hc(x[1], {
                            r: s - y,
                            c: i - S
                        });
                    }
                    break;
                case "F":
                    var A = 0;
                    for(c = 1; c < b.length; ++c)switch(b[c].charAt(0)){
                        case "X":
                            i = parseInt(b[c].slice(1)) - 1, ++A;
                            break;
                        case "Y":
                            for(s = parseInt(b[c].slice(1)) - 1, a = l.length; a <= s; ++a)l[a] = [];
                            break;
                        case "M":
                            p = parseInt(b[c].slice(1)) / 20;
                            break;
                        case "F":
                        case "G":
                            break;
                        case "P":
                            h = f[parseInt(b[c].slice(1))];
                            break;
                        case "S":
                        case "D":
                        case "N":
                            break;
                        case "W":
                            for(r = b[c].slice(1).split(" "), a = parseInt(r[0], 10); a <= parseInt(r[1], 10); ++a)p = parseInt(r[2], 10), d[a - 1] = 0 === p ? {
                                hidden: !0
                            } : {
                                wch: p
                            }, fo(d[a - 1]);
                            break;
                        case "C":
                            d[i = parseInt(b[c].slice(1)) - 1] || (d[i] = {});
                            break;
                        case "R":
                            u[s = parseInt(b[c].slice(1)) - 1] || (u[s] = {}), 0 < p ? (u[s].hpt = p, u[s].hpx = po(p)) : 0 === p && (u[s].hidden = !0);
                            break;
                        default:
                            if (t && t.WTF) throw new Error("SYLK bad record " + g);
                    }
                    A < 1 && (h = null);
                    break;
                default:
                    if (t && t.WTF) throw new Error("SYLK bad record " + g);
            }
        }
        return 0 < u.length && (e["!rows"] = u), 0 < d.length && (e["!cols"] = d), [
            l = t && t.sheetRows ? l.slice(0, t.sheetRows) : l,
            e
        ];
    }
    function Ds(e, t) {
        var r = function(e, t) {
            switch(t.type){
                case "base64":
                    return Fs(te(e), t);
                case "binary":
                    return Fs(e, t);
                case "buffer":
                    return Fs(se && $4249f69807f0687b$require$Buffer.isBuffer(e) ? e.toString("binary") : i(e), t);
                case "array":
                    return Fs(ze(e), t);
            }
            throw new Error("Unrecognized type " + t.type);
        }(e, t), e = r[0], a = r[1], n = aa(e, t);
        return Re(a).forEach(function(e) {
            n[e] = a[e];
        }), n;
    }
    var Ps = {
        to_workbook: function(e, t) {
            return ta(Ms(e, t), t);
        },
        to_sheet: Ms,
        from_sheet: function(e) {
            var t = [], r = Zr(e["!ref"]), a = Array.isArray(e);
            Us(t, "TABLE", 0, 1, "sheetjs"), Us(t, "VECTORS", 0, r.e.r - r.s.r + 1, ""), Us(t, "TUPLES", 0, r.e.c - r.s.c + 1, ""), Us(t, "DATA", 0, 0, "");
            for(var n = r.s.r; n <= r.e.r; ++n){
                Bs(t, -1, 0, "BOT");
                for(var s = r.s.c; s <= r.e.c; ++s){
                    var i, o = Kr({
                        r: n,
                        c: s
                    });
                    if (i = a ? (e[n] || [])[s] : e[o]) switch(i.t){
                        case "n":
                            var c = d ? i.w : i.v;
                            null == (c = !c && null != i.v ? i.v : c) ? d && i.f && !i.F ? Bs(t, 1, 0, "=" + i.f) : Bs(t, 1, 0, "") : Bs(t, 0, c, "V");
                            break;
                        case "b":
                            Bs(t, 0, i.v ? 1 : 0, i.v ? "TRUE" : "FALSE");
                            break;
                        case "s":
                            Bs(t, 1, 0, !d || isNaN(i.v) ? i.v : '="' + i.v + '"');
                            break;
                        case "d":
                            i.w || (i.w = ve(i.z || me[14], De(He(i.v)))), d ? Bs(t, 0, i.w, "V") : Bs(t, 1, 0, i.w);
                            break;
                        default:
                            Bs(t, 1, 0, "");
                    }
                    else Bs(t, 1, 0, "");
                }
            }
            Bs(t, -1, 0, "EOD");
            return t.join("\r\n");
        }
    };
    function Ls(e, t) {
        for(var r = e.split("\n"), a = -1, n = -1, s = 0, i = []; s !== r.length; ++s)if ("BOT" !== r[s].trim()) {
            if (!(a < 0)) {
                for(var o = r[s].trim().split(","), c = o[0], l = o[1], f = r[++s] || ""; 1 & (f.match(/["]/g) || []).length && s < r.length - 1;)f += "\n" + r[++s];
                switch(f = f.trim(), +c){
                    case -1:
                        if ("BOT" === f) {
                            i[++a] = [], n = 0;
                            continue;
                        }
                        if ("EOD" !== f) throw new Error("Unrecognized DIF special command " + f);
                        break;
                    case 0:
                        "TRUE" === f ? i[a][n] = !0 : "FALSE" === f ? i[a][n] = !1 : isNaN(je(l)) ? isNaN(Xe(l).getDate()) ? i[a][n] = l : i[a][n] = He(l) : i[a][n] = je(l), ++n;
                        break;
                    case 1:
                        f = (f = f.slice(1, f.length - 1)).replace(/""/g, '"'), d && f && f.match(/^=".*"$/) && (f = f.slice(2, -1)), i[a][n++] = "" !== f ? f : null;
                }
                if ("EOD" === f) break;
            }
        } else i[++a] = [], n = 0;
        return i = t && t.sheetRows ? i.slice(0, t.sheetRows) : i;
    }
    function Ms(e, t) {
        return aa(function(e, t) {
            switch(t.type){
                case "base64":
                    return Ls(te(e), t);
                case "binary":
                    return Ls(e, t);
                case "buffer":
                    return Ls(se && $4249f69807f0687b$require$Buffer.isBuffer(e) ? e.toString("binary") : i(e), t);
                case "array":
                    return Ls(ze(e), t);
            }
            throw new Error("Unrecognized type " + t.type);
        }(e, t), t);
    }
    function Us(e, t, r, a, n) {
        e.push(t), e.push(r + "," + a), e.push('"' + n.replace(/"/g, '""') + '"');
    }
    function Bs(e, t, r, a) {
        e.push(t + "," + r), e.push(1 == t ? '"' + a.replace(/"/g, '""') + '"' : a);
    }
    var Ws, Hs, zs, Vs, Gs = (Ws = [
        "socialcalc:version:1.5",
        "MIME-Version: 1.0",
        "Content-Type: multipart/mixed; boundary=SocialCalcSpreadsheetControlSave"
    ].join("\n"), Hs = [
        "--SocialCalcSpreadsheetControlSave",
        "Content-type: text/plain; charset=UTF-8"
    ].join("\n") + "\n", zs = [
        "# SocialCalc Spreadsheet Control Save",
        "part:sheet"
    ].join("\n"), Vs = "--SocialCalcSpreadsheetControlSave--", {
        to_workbook: function(e, t) {
            return ta($s(e, t), t);
        },
        to_sheet: $s,
        from_sheet: function(e) {
            return [
                Ws,
                Hs,
                zs,
                Hs,
                function(e) {
                    if (!e || !e["!ref"]) return "";
                    for(var t, r, a = [], n = [], s = Jr(e["!ref"]), i = Array.isArray(e), o = s.s.r; o <= s.e.r; ++o)for(var c = s.s.c; c <= s.e.c; ++c)if (r = Kr({
                        r: o,
                        c: c
                    }), (t = i ? (e[o] || [])[c] : e[r]) && null != t.v && "z" !== t.t) {
                        switch(n = [
                            "cell",
                            r,
                            "t"
                        ], t.t){
                            case "s":
                            case "str":
                                n.push(js(t.v));
                                break;
                            case "n":
                                t.f ? (n[2] = "vtf", n[3] = "n", n[4] = t.v, n[5] = js(t.f)) : (n[2] = "v", n[3] = t.v);
                                break;
                            case "b":
                                n[2] = "vt" + (t.f ? "f" : "c"), n[3] = "nl", n[4] = t.v ? "1" : "0", n[5] = js(t.f || (t.v ? "TRUE" : "FALSE"));
                                break;
                            case "d":
                                var l = De(He(t.v));
                                n[2] = "vtc", n[3] = "nd", n[4] = "" + l, n[5] = t.w || ve(t.z || me[14], l);
                                break;
                            case "e":
                                continue;
                        }
                        a.push(n.join(":"));
                    }
                    return a.push("sheet:c:" + (s.e.c - s.s.c + 1) + ":r:" + (s.e.r - s.s.r + 1) + ":tvf:1"), a.push("valueformat:1:text-wiki"), a.join("\n");
                }(e),
                Vs
            ].join("\n");
        }
    });
    function js(e) {
        return e.replace(/\\/g, "\\b").replace(/:/g, "\\c").replace(/\n/g, "\\n");
    }
    function $s(e, t) {
        return aa(function(e, t) {
            for(var r, a = e.split("\n"), n = -1, s = 0, i = []; s !== a.length; ++s){
                var o = a[s].trim().split(":");
                if ("cell" === o[0]) {
                    var c = Yr(o[1]);
                    if (i.length <= c.r) for(n = i.length; n <= c.r; ++n)i[n] || (i[n] = []);
                    switch(n = c.r, r = c.c, o[2]){
                        case "t":
                            i[n][r] = o[3].replace(/\\b/g, "\\").replace(/\\c/g, ":").replace(/\\n/g, "\n");
                            break;
                        case "v":
                            i[n][r] = +o[3];
                            break;
                        case "vtf":
                            var l = o[o.length - 1];
                        case "vtc":
                            "nl" === o[3] ? i[n][r] = !!+o[4] : i[n][r] = +o[4], "vtf" == o[2] && (i[n][r] = [
                                i[n][r],
                                l
                            ]);
                    }
                }
            }
            return i = t && t.sheetRows ? i.slice(0, t.sheetRows) : i;
        }(e, t), t);
    }
    var Xs, Ys, Ks = (Xs = {
        44: ",",
        9: "\t",
        59: ";",
        124: "|"
    }, Ys = {
        44: 3,
        9: 2,
        59: 1,
        124: 0
    }, {
        to_workbook: function(e, t) {
            return ta(ei(e, t), t);
        },
        to_sheet: ei,
        from_sheet: function(e) {
            for(var t = [], r = Zr(e["!ref"]), a = Array.isArray(e), n = r.s.r; n <= r.e.r; ++n){
                for(var s = [], i = r.s.c; i <= r.e.c; ++i){
                    var o = Kr({
                        r: n,
                        c: i
                    });
                    if ((o = a ? (e[n] || [])[i] : e[o]) && null != o.v) {
                        for(var c = (o.w || (ea(o), o.w) || "").slice(0, 10); c.length < 10;)c += " ";
                        s.push(c + (0 === i ? " " : ""));
                    } else s.push("          ");
                }
                t.push(s.join(""));
            }
            return t.join("\n");
        }
    });
    function Js(e, t, r, a, n) {
        n.raw ? t[r][a] = e : "" === e || ("TRUE" === e ? t[r][a] = !0 : "FALSE" === e ? t[r][a] = !1 : isNaN(je(e)) ? isNaN(Xe(e).getDate()) ? t[r][a] = e : t[r][a] = He(e) : t[r][a] = je(e));
    }
    function qs(e) {
        for(var t = {}, r = !1, a = 0, n = 0; a < e.length; ++a)34 == (n = e.charCodeAt(a)) ? r = !r : !r && n in Xs && (t[n] = (t[n] || 0) + 1);
        for(a in n = [], t)Object.prototype.hasOwnProperty.call(t, a) && n.push([
            t[a],
            a
        ]);
        if (!n.length) for(a in t = Ys)Object.prototype.hasOwnProperty.call(t, a) && n.push([
            t[a],
            a
        ]);
        return n.sort(function(e, t) {
            return e[0] - t[0] || Ys[e[1]] - Ys[t[1]];
        }), Xs[n.pop()[1]] || 44;
    }
    function Zs(a, e) {
        var n = e || {}, e = "";
        null != oe && null == n.dense && (n.dense = oe);
        var s = n.dense ? [] : {}, i = {
            s: {
                c: 0,
                r: 0
            },
            e: {
                c: 0,
                r: 0
            }
        };
        "sep=" == a.slice(0, 4) ? 13 == a.charCodeAt(5) && 10 == a.charCodeAt(6) ? (e = a.charAt(4), a = a.slice(7)) : 13 == a.charCodeAt(5) || 10 == a.charCodeAt(5) ? (e = a.charAt(4), a = a.slice(6)) : e = qs(a.slice(0, 1024)) : e = n && n.FS ? n.FS : qs(a.slice(0, 1024));
        var o = 0, c = 0, l = 0, f = 0, h = 0, u = e.charCodeAt(0), t = !1, d = 0, p = a.charCodeAt(0);
        a = a.replace(/\r\n/gm, "\n");
        var m = null != n.dateNF ? (e = (e = "number" == typeof (e = n.dateNF) ? me[e] : e).replace(ye, "(\\d+)"), new RegExp("^" + e + "$")) : null;
        function r() {
            var e, t = a.slice(f, h), r = {};
            if (0 === (t = '"' == t.charAt(0) && '"' == t.charAt(t.length - 1) ? t.slice(1, -1).replace(/""/g, '"') : t).length ? r.t = "z" : n.raw || 0 === t.trim().length ? (r.t = "s", r.v = t) : 61 == t.charCodeAt(0) ? 34 == t.charCodeAt(1) && 34 == t.charCodeAt(t.length - 1) ? (r.t = "s", r.v = t.slice(2, -1).replace(/""/g, '"')) : 1 != t.length ? (r.t = "n", r.f = t.slice(1)) : (r.t = "s", r.v = t) : "TRUE" == t ? (r.t = "b", r.v = !0) : "FALSE" == t ? (r.t = "b", r.v = !1) : isNaN(l = je(t)) ? !isNaN(Xe(t).getDate()) || m && t.match(m) ? (r.z = n.dateNF || me[14], e = 0, m && t.match(m) && (t = function(e, a) {
                var n = -1, s = -1, i = -1, o = -1, c = -1, l = -1;
                (e.match(ye) || []).forEach(function(e, t) {
                    var r = parseInt(a[t + 1], 10);
                    switch(e.toLowerCase().charAt(0)){
                        case "y":
                            n = r;
                            break;
                        case "d":
                            i = r;
                            break;
                        case "h":
                            o = r;
                            break;
                        case "s":
                            l = r;
                            break;
                        case "m":
                            0 <= o ? c = r : s = r;
                    }
                }), 0 <= l && -1 == c && 0 <= s && (c = s, s = -1);
                var t = ("" + (0 <= n ? n : (new Date).getFullYear())).slice(-4) + "-" + ("00" + (1 <= s ? s : 1)).slice(-2) + "-" + ("00" + (1 <= i ? i : 1)).slice(-2);
                return 8 == (t = 7 == t.length ? "0" + t : t).length && (t = "20" + t), e = ("00" + (0 <= o ? o : 0)).slice(-2) + ":" + ("00" + (0 <= c ? c : 0)).slice(-2) + ":" + ("00" + (0 <= l ? l : 0)).slice(-2), -1 == o && -1 == c && -1 == l ? t : -1 == n && -1 == s && -1 == i ? e : t + "T" + e;
            }(n.dateNF, t.match(m) || []), e = 1), n.cellDates ? (r.t = "d", r.v = He(t, e)) : (r.t = "n", r.v = De(He(t, e))), !1 !== n.cellText && (r.w = ve(r.z, r.v instanceof Date ? De(r.v) : r.v)), n.cellNF || delete r.z) : (r.t = "s", r.v = t) : ((r.t = "n", false) !== n.cellText && (r.w = t), r.v = l), "z" == r.t || (n.dense ? (s[o] || (s[o] = []), s[o][c] = r) : s[Kr({
                c: c,
                r: o
            })] = r), f = h + 1, p = a.charCodeAt(f), i.e.c < c && (i.e.c = c), i.e.r < o && (i.e.r = o), d != u) return c = 0, ++o, n.sheetRows && n.sheetRows <= o ? 1 : void 0;
            ++c;
        }
        e: for(; h < a.length; ++h)switch(d = a.charCodeAt(h)){
            case 34:
                34 === p && (t = !t);
                break;
            case u:
            case 10:
            case 13:
                if (!t && r()) break e;
        }
        return 0 < h - f && r(), s["!ref"] = qr(i), s;
    }
    function Qs(e, t) {
        return !t || !t.PRN || t.FS || "sep=" == e.slice(0, 4) || 0 <= e.indexOf("\t") || 0 <= e.indexOf(",") || 0 <= e.indexOf(";") ? Zs(e, t) : aa(function(e, t) {
            var r = t || {}, a = [];
            if (!e || 0 === e.length) return a;
            for(var n = e.split(/[\r\n]/), s = n.length - 1; 0 <= s && 0 === n[s].length;)--s;
            for(var i = 10, o = 0, c = 0; c <= s; ++c)-1 == (o = n[c].indexOf(" ")) ? o = n[c].length : o++, i = Math.max(i, o);
            for(c = 0; c <= s; ++c){
                a[c] = [];
                var l = 0;
                for(Js(n[c].slice(0, i).trim(), a, c, l, r), l = 1; l <= (n[c].length - i) / 10 + 1; ++l)Js(n[c].slice(i + 10 * (l - 1), i + 10 * l).trim(), a, c, l, r);
            }
            return a = r.sheetRows ? a.slice(0, r.sheetRows) : a;
        }(e, t), t);
    }
    function ei(e, t) {
        var r = "", a = "string" == t.type ? [
            0,
            0,
            0,
            0
        ] : $h(e, t);
        switch(t.type){
            case "base64":
                r = te(e);
                break;
            case "binary":
                r = e;
                break;
            case "buffer":
                r = 65001 == t.codepage ? e.toString("utf8") : t.codepage && void 0 !== re ? re.utils.decode(t.codepage, e) : se && $4249f69807f0687b$require$Buffer.isBuffer(e) ? e.toString("binary") : i(e);
                break;
            case "array":
                r = ze(e);
                break;
            case "string":
                r = e;
                break;
            default:
                throw new Error("Unrecognized type " + t.type);
        }
        return 239 == a[0] && 187 == a[1] && 191 == a[2] ? r = Mt(r.slice(3)) : "string" != t.type && "buffer" != t.type && 65001 == t.codepage ? r = Mt(r) : "binary" == t.type && void 0 !== re && t.codepage && (r = re.utils.decode(t.codepage, re.utils.encode(28591, r))), "socialcalc:version:" == r.slice(0, 19) ? Gs.to_sheet("string" == t.type ? r : Mt(r), t) : Qs(r, t);
    }
    var ti, ri, ai, ni, si = (ti = {
        51: [
            "FALSE",
            0
        ],
        52: [
            "TRUE",
            0
        ],
        70: [
            "LEN",
            1
        ],
        80: [
            "SUM",
            69
        ],
        81: [
            "AVERAGEA",
            69
        ],
        82: [
            "COUNTA",
            69
        ],
        83: [
            "MINA",
            69
        ],
        84: [
            "MAXA",
            69
        ],
        111: [
            "T",
            1
        ]
    }, ri = [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "+",
        "-",
        "*",
        "/",
        "^",
        "=",
        "<>",
        "<=",
        ">=",
        "<",
        ">",
        "",
        "",
        "",
        "",
        "&",
        "",
        "",
        "",
        "",
        "",
        "",
        ""
    ], ai = {
        0: {
            n: "BOF",
            f: Nn
        },
        1: {
            n: "EOF"
        },
        2: {
            n: "CALCMODE"
        },
        3: {
            n: "CALCORDER"
        },
        4: {
            n: "SPLIT"
        },
        5: {
            n: "SYNC"
        },
        6: {
            n: "RANGE",
            f: function(e, t, r) {
                var a = {
                    s: {
                        c: 0,
                        r: 0
                    },
                    e: {
                        c: 0,
                        r: 0
                    }
                };
                return 8 == t && r.qpro ? (a.s.c = e.read_shift(1), e.l++, a.s.r = e.read_shift(2), a.e.c = e.read_shift(1), e.l++, a.e.r = e.read_shift(2)) : (a.s.c = e.read_shift(2), a.s.r = e.read_shift(2), 12 == t && r.qpro && (e.l += 2), a.e.c = e.read_shift(2), a.e.r = e.read_shift(2), 12 == t && r.qpro && (e.l += 2), 65535 == a.s.c && (a.s.c = a.e.c = a.s.r = a.e.r = 0)), a;
            }
        },
        7: {
            n: "WINDOW1"
        },
        8: {
            n: "COLW1"
        },
        9: {
            n: "WINTWO"
        },
        10: {
            n: "COLW2"
        },
        11: {
            n: "NAME"
        },
        12: {
            n: "BLANK"
        },
        13: {
            n: "INTEGER",
            f: function(e, t, r) {
                return (r = ci(e, 0, r))[1].v = e.read_shift(2, "i"), r;
            }
        },
        14: {
            n: "NUMBER",
            f: function(e, t, r) {
                return (r = ci(e, 0, r))[1].v = e.read_shift(8, "f"), r;
            }
        },
        15: {
            n: "LABEL",
            f: li
        },
        16: {
            n: "FORMULA",
            f: function(e, t, r) {
                var a = e.l + t;
                return (t = ci(e, 0, r))[1].v = e.read_shift(8, "f"), r.qpro ? e.l = a : (a = e.read_shift(2), function(e, t) {
                    Dr(e, 0);
                    for(var r = [], a = 0, n = "", s = "", i = "", o = ""; e.l < e.length;){
                        var c = e[e.l++];
                        switch(c){
                            case 0:
                                r.push(e.read_shift(8, "f"));
                                break;
                            case 1:
                                s = fi(t[0].c, e.read_shift(2), !0), n = fi(t[0].r, e.read_shift(2), !1), r.push(s + n);
                                break;
                            case 2:
                                var l = fi(t[0].c, e.read_shift(2), !0), f = fi(t[0].r, e.read_shift(2), !1);
                                s = fi(t[0].c, e.read_shift(2), !0), n = fi(t[0].r, e.read_shift(2), !1), r.push(l + f + ":" + s + n);
                                break;
                            case 3:
                                if (e.l < e.length) return console.error("WK1 premature formula end");
                                break;
                            case 4:
                                r.push("(" + r.pop() + ")");
                                break;
                            case 5:
                                r.push(e.read_shift(2));
                                break;
                            case 6:
                                for(var h = ""; c = e[e.l++];)h += String.fromCharCode(c);
                                r.push('"' + h.replace(/"/g, '""') + '"');
                                break;
                            case 8:
                                r.push("-" + r.pop());
                                break;
                            case 23:
                                r.push("+" + r.pop());
                                break;
                            case 22:
                                r.push("NOT(" + r.pop() + ")");
                                break;
                            case 20:
                            case 21:
                                o = r.pop(), i = r.pop(), r.push([
                                    "AND",
                                    "OR"
                                ][c - 20] + "(" + i + "," + o + ")");
                                break;
                            default:
                                if (c < 32 && ri[c]) o = r.pop(), i = r.pop(), r.push(i + ri[c] + o);
                                else {
                                    if (!ti[c]) return c <= 7 ? console.error("WK1 invalid opcode " + c.toString(16)) : c <= 24 ? console.error("WK1 unsupported op " + c.toString(16)) : c <= 30 ? console.error("WK1 invalid opcode " + c.toString(16)) : c <= 115 ? console.error("WK1 unsupported function opcode " + c.toString(16)) : console.error("WK1 unrecognized opcode " + c.toString(16));
                                    if ((a = 69 == (a = ti[c][1]) ? e[e.l++] : a) > r.length) return console.error("WK1 bad formula parse 0x" + c.toString(16) + ":|" + r.join("|") + "|");
                                    f = r.slice(-a);
                                    r.length -= a, r.push(ti[c][0] + "(" + f.join(",") + ")");
                                }
                        }
                    }
                    1 == r.length ? t[1].f = "" + r[0] : console.error("WK1 bad formula parse |" + r.join("|") + "|");
                }(e.slice(e.l, e.l + a), t), e.l += a), t;
            }
        },
        24: {
            n: "TABLE"
        },
        25: {
            n: "ORANGE"
        },
        26: {
            n: "PRANGE"
        },
        27: {
            n: "SRANGE"
        },
        28: {
            n: "FRANGE"
        },
        29: {
            n: "KRANGE1"
        },
        32: {
            n: "HRANGE"
        },
        35: {
            n: "KRANGE2"
        },
        36: {
            n: "PROTEC"
        },
        37: {
            n: "FOOTER"
        },
        38: {
            n: "HEADER"
        },
        39: {
            n: "SETUP"
        },
        40: {
            n: "MARGINS"
        },
        41: {
            n: "LABELFMT"
        },
        42: {
            n: "TITLES"
        },
        43: {
            n: "SHEETJS"
        },
        45: {
            n: "GRAPH"
        },
        46: {
            n: "NGRAPH"
        },
        47: {
            n: "CALCCOUNT"
        },
        48: {
            n: "UNFORMATTED"
        },
        49: {
            n: "CURSORW12"
        },
        50: {
            n: "WINDOW"
        },
        51: {
            n: "STRING",
            f: li
        },
        55: {
            n: "PASSWORD"
        },
        56: {
            n: "LOCKED"
        },
        60: {
            n: "QUERY"
        },
        61: {
            n: "QUERYNAME"
        },
        62: {
            n: "PRINT"
        },
        63: {
            n: "PRINTNAME"
        },
        64: {
            n: "GRAPH2"
        },
        65: {
            n: "GRAPHNAME"
        },
        66: {
            n: "ZOOM"
        },
        67: {
            n: "SYMSPLIT"
        },
        68: {
            n: "NSROWS"
        },
        69: {
            n: "NSCOLS"
        },
        70: {
            n: "RULER"
        },
        71: {
            n: "NNAME"
        },
        72: {
            n: "ACOMM"
        },
        73: {
            n: "AMACRO"
        },
        74: {
            n: "PARSE"
        },
        102: {
            n: "PRANGES??"
        },
        103: {
            n: "RRANGES??"
        },
        104: {
            n: "FNAME??"
        },
        105: {
            n: "MRANGES??"
        },
        204: {
            n: "SHEETNAMECS",
            f: pi
        },
        222: {
            n: "SHEETNAMELP",
            f: function(e, t) {
                var r = e[e.l++];
                t - 1 < r && (r = t - 1);
                for(var a = ""; a.length < r;)a += String.fromCharCode(e[e.l++]);
                return a;
            }
        },
        65535: {
            n: ""
        }
    }, ni = {
        0: {
            n: "BOF"
        },
        1: {
            n: "EOF"
        },
        2: {
            n: "PASSWORD"
        },
        3: {
            n: "CALCSET"
        },
        4: {
            n: "WINDOWSET"
        },
        5: {
            n: "SHEETCELLPTR"
        },
        6: {
            n: "SHEETLAYOUT"
        },
        7: {
            n: "COLUMNWIDTH"
        },
        8: {
            n: "HIDDENCOLUMN"
        },
        9: {
            n: "USERRANGE"
        },
        10: {
            n: "SYSTEMRANGE"
        },
        11: {
            n: "ZEROFORCE"
        },
        12: {
            n: "SORTKEYDIR"
        },
        13: {
            n: "FILESEAL"
        },
        14: {
            n: "DATAFILLNUMS"
        },
        15: {
            n: "PRINTMAIN"
        },
        16: {
            n: "PRINTSTRING"
        },
        17: {
            n: "GRAPHMAIN"
        },
        18: {
            n: "GRAPHSTRING"
        },
        19: {
            n: "??"
        },
        20: {
            n: "ERRCELL"
        },
        21: {
            n: "NACELL"
        },
        22: {
            n: "LABEL16",
            f: function(e, t) {
                var r = hi(e);
                return r[1].t = "s", r[1].v = e.read_shift(t - 4, "cstr"), r;
            }
        },
        23: {
            n: "NUMBER17",
            f: ui
        },
        24: {
            n: "NUMBER18",
            f: function(e, t) {
                var r = hi(e);
                r[1].v = e.read_shift(2);
                var a = r[1].v >> 1;
                if (1 & r[1].v) switch(7 & a){
                    case 0:
                        a = 5e3 * (a >> 3);
                        break;
                    case 1:
                        a = 500 * (a >> 3);
                        break;
                    case 2:
                        a = (a >> 3) / 20;
                        break;
                    case 3:
                        a = (a >> 3) / 200;
                        break;
                    case 4:
                        a = (a >> 3) / 2e3;
                        break;
                    case 5:
                        a = (a >> 3) / 2e4;
                        break;
                    case 6:
                        a = (a >> 3) / 16;
                        break;
                    case 7:
                        a = (a >> 3) / 64;
                }
                return r[1].v = a, r;
            }
        },
        25: {
            n: "FORMULA19",
            f: function(e, t) {
                var r = ui(e);
                return e.l += t - 14, r;
            }
        },
        26: {
            n: "FORMULA1A"
        },
        27: {
            n: "XFORMAT",
            f: function(e, t) {
                for(var r = {}, a = e.l + t; e.l < a;){
                    var n = e.read_shift(2);
                    if (14e3 == n) {
                        for(r[n] = [
                            0,
                            ""
                        ], r[n][0] = e.read_shift(2); e[e.l];)r[n][1] += String.fromCharCode(e[e.l]), e.l++;
                        e.l++;
                    }
                }
                return r;
            }
        },
        28: {
            n: "DTLABELMISC"
        },
        29: {
            n: "DTLABELCELL"
        },
        30: {
            n: "GRAPHWINDOW"
        },
        31: {
            n: "CPA"
        },
        32: {
            n: "LPLAUTO"
        },
        33: {
            n: "QUERY"
        },
        34: {
            n: "HIDDENSHEET"
        },
        35: {
            n: "??"
        },
        37: {
            n: "NUMBER25",
            f: function(e, t) {
                var r = hi(e), e = e.read_shift(4);
                return r[1].v = e >> 6, r;
            }
        },
        38: {
            n: "??"
        },
        39: {
            n: "NUMBER27",
            f: di
        },
        40: {
            n: "FORMULA28",
            f: function(e, t) {
                var r = di(e);
                return e.l += t - 10, r;
            }
        },
        142: {
            n: "??"
        },
        147: {
            n: "??"
        },
        150: {
            n: "??"
        },
        151: {
            n: "??"
        },
        152: {
            n: "??"
        },
        153: {
            n: "??"
        },
        154: {
            n: "??"
        },
        155: {
            n: "??"
        },
        156: {
            n: "??"
        },
        163: {
            n: "??"
        },
        174: {
            n: "??"
        },
        175: {
            n: "??"
        },
        176: {
            n: "??"
        },
        177: {
            n: "??"
        },
        184: {
            n: "??"
        },
        185: {
            n: "??"
        },
        186: {
            n: "??"
        },
        187: {
            n: "??"
        },
        188: {
            n: "??"
        },
        195: {
            n: "??"
        },
        201: {
            n: "??"
        },
        204: {
            n: "SHEETNAMECS",
            f: pi
        },
        205: {
            n: "??"
        },
        206: {
            n: "??"
        },
        207: {
            n: "??"
        },
        208: {
            n: "??"
        },
        256: {
            n: "??"
        },
        259: {
            n: "??"
        },
        260: {
            n: "??"
        },
        261: {
            n: "??"
        },
        262: {
            n: "??"
        },
        263: {
            n: "??"
        },
        265: {
            n: "??"
        },
        266: {
            n: "??"
        },
        267: {
            n: "??"
        },
        268: {
            n: "??"
        },
        270: {
            n: "??"
        },
        271: {
            n: "??"
        },
        384: {
            n: "??"
        },
        389: {
            n: "??"
        },
        390: {
            n: "??"
        },
        393: {
            n: "??"
        },
        396: {
            n: "??"
        },
        512: {
            n: "??"
        },
        514: {
            n: "??"
        },
        513: {
            n: "??"
        },
        516: {
            n: "??"
        },
        517: {
            n: "??"
        },
        640: {
            n: "??"
        },
        641: {
            n: "??"
        },
        642: {
            n: "??"
        },
        643: {
            n: "??"
        },
        644: {
            n: "??"
        },
        645: {
            n: "??"
        },
        646: {
            n: "??"
        },
        647: {
            n: "??"
        },
        648: {
            n: "??"
        },
        658: {
            n: "??"
        },
        659: {
            n: "??"
        },
        660: {
            n: "??"
        },
        661: {
            n: "??"
        },
        662: {
            n: "??"
        },
        665: {
            n: "??"
        },
        666: {
            n: "??"
        },
        768: {
            n: "??"
        },
        772: {
            n: "??"
        },
        1537: {
            n: "SHEETINFOQP",
            f: function(e, t, r) {
                if (r.qpro && !(t < 21)) {
                    r = e.read_shift(1);
                    return e.l += 17, e.l += 1, e.l += 2, [
                        r,
                        e.read_shift(t - 21, "cstr")
                    ];
                }
            }
        },
        1600: {
            n: "??"
        },
        1602: {
            n: "??"
        },
        1793: {
            n: "??"
        },
        1794: {
            n: "??"
        },
        1795: {
            n: "??"
        },
        1796: {
            n: "??"
        },
        1920: {
            n: "??"
        },
        2048: {
            n: "??"
        },
        2049: {
            n: "??"
        },
        2052: {
            n: "??"
        },
        2688: {
            n: "??"
        },
        10998: {
            n: "??"
        },
        12849: {
            n: "??"
        },
        28233: {
            n: "??"
        },
        28484: {
            n: "??"
        },
        65535: {
            n: ""
        }
    }, {
        sheet_to_wk1: function(e, t) {
            var r = t || {};
            if (0 <= +r.codepage && ie(+r.codepage), "string" == r.type) throw new Error("Cannot write WK1 to JS string");
            var a = Ur(), n = Zr(e["!ref"]), s = Array.isArray(e), i = [];
            Lf(a, 0, (t = 1030, (r = Lr(2)).write_shift(2, t), r)), Lf(a, 6, (t = n, (r = Lr(8)).write_shift(2, t.s.c), r.write_shift(2, t.s.r), r.write_shift(2, t.e.c), r.write_shift(2, t.e.r), r));
            for(var o, c, l, f, h = Math.min(n.e.r, 8191), u = n.s.r; u <= h; ++u)for(var d = jr(u), p = n.s.c; p <= n.e.c; ++p){
                u === n.s.r && (i[p] = Xr(p));
                var m = i[p] + d, m = s ? (e[u] || [])[p] : e[m];
                m && "z" != m.t && ("n" == m.t ? (0 | m.v) == m.v && -32768 <= m.v && m.v <= 32767 ? Lf(a, 13, (o = u, c = p, l = m.v, f = void 0, (f = Lr(7)).write_shift(1, 255), f.write_shift(2, c), f.write_shift(2, o), f.write_shift(2, l, "i"), f)) : Lf(a, 14, (c = u, o = p, l = m.v, f = void 0, (f = Lr(13)).write_shift(1, 255), f.write_shift(2, o), f.write_shift(2, c), f.write_shift(8, l, "f"), f)) : Lf(a, 15, function(e, t, r) {
                    var a = Lr(7 + r.length);
                    a.write_shift(1, 255), a.write_shift(2, t), a.write_shift(2, e), a.write_shift(1, 39);
                    for(var n = 0; n < a.length; ++n){
                        var s = r.charCodeAt(n);
                        a.write_shift(1, 128 <= s ? 95 : s);
                    }
                    return a.write_shift(1, 0), a;
                }(u, p, ea(m).slice(0, 239))));
            }
            return Lf(a, 1), a.end();
        },
        book_to_wk3: function(e, t) {
            if (0 <= +(t = t || {}).codepage && ie(+t.codepage), "string" == t.type) throw new Error("Cannot write WK3 to JS string");
            var r = Ur();
            Lf(r, 0, function(e) {
                var t = Lr(26);
                t.write_shift(2, 4096), t.write_shift(2, 4), t.write_shift(4, 0);
                for(var r = 0, a = 0, n = 0, s = 0; s < e.SheetNames.length; ++s){
                    var i = e.SheetNames[s], i = e.Sheets[i];
                    i && i["!ref"] && (++n, i = Jr(i["!ref"]), r < i.e.r && (r = i.e.r), a < i.e.c && (a = i.e.c));
                }
                8191 < r && (r = 8191);
                return t.write_shift(2, r), t.write_shift(1, n), t.write_shift(1, a), t.write_shift(2, 0), t.write_shift(2, 0), t.write_shift(1, 1), t.write_shift(1, 2), t.write_shift(4, 0), t.write_shift(4, 0), t;
            }(e));
            for(var a = 0, n = 0; a < e.SheetNames.length; ++a)(e.Sheets[e.SheetNames[a]] || {})["!ref"] && Lf(r, 27, function(e, t) {
                var r = Lr(5 + e.length);
                r.write_shift(2, 14e3), r.write_shift(2, t);
                for(var a = 0; a < e.length; ++a){
                    var n = e.charCodeAt(a);
                    r[r.l++] = 127 < n ? 95 : n;
                }
                return r[r.l++] = 0, r;
            }(e.SheetNames[a], n++));
            for(var s = 0, a = 0; a < e.SheetNames.length; ++a){
                var i = e.Sheets[e.SheetNames[a]];
                if (i && i["!ref"]) {
                    for(var o = Zr(i["!ref"]), c = Array.isArray(i), l = [], f = Math.min(o.e.r, 8191), h = o.s.r; h <= f; ++h)for(var u = jr(h), d = o.s.c; d <= o.e.c; ++d){
                        h === o.s.r && (l[d] = Xr(d));
                        var p = l[d] + u, p = c ? (i[h] || [])[d] : i[p];
                        p && "z" != p.t && ("n" == p.t ? Lf(r, 23, function(e, t, r, a) {
                            var n = Lr(14);
                            if (n.write_shift(2, e), n.write_shift(1, r), n.write_shift(1, t), 0 == a) return n.write_shift(4, 0), n.write_shift(4, 0), n.write_shift(2, 65535), n;
                            var s = 0, e = 0, r = 0, t = 0;
                            a < 0 && (s = 1, a = -a);
                            e = 0 | Math.log2(a), a /= Math.pow(2, e - 31), 0 == (2147483648 & (t = a >>> 0)) && (++e, t = (a /= 2) >>> 0);
                            return a -= t, t |= 2147483648, t >>>= 0, a *= Math.pow(2, 32), r = a >>> 0, n.write_shift(4, r), n.write_shift(4, t), e += 16383 + (s ? 32768 : 0), n.write_shift(2, e), n;
                        }(h, d, s, p.v)) : Lf(r, 22, function(e, t, r, a) {
                            var n = Lr(6 + a.length);
                            n.write_shift(2, e), n.write_shift(1, r), n.write_shift(1, t), n.write_shift(1, 39);
                            for(var s = 0; s < a.length; ++s){
                                var i = a.charCodeAt(s);
                                n.write_shift(1, 128 <= i ? 95 : i);
                            }
                            return n.write_shift(1, 0), n;
                        }(h, d, s, ea(p).slice(0, 239))));
                    }
                    ++s;
                }
            }
            return Lf(r, 1), r.end();
        },
        to_workbook: function(e, t) {
            switch(t.type){
                case "base64":
                    return oi(he(te(e)), t);
                case "binary":
                    return oi(he(e), t);
                case "buffer":
                case "array":
                    return oi(e, t);
            }
            throw "Unsupported type " + t.type;
        }
    });
    function ii(e, t, r) {
        if (e) {
            Dr(e, e.l || 0);
            for(var a = r.Enum || ai; e.l < e.length;){
                var n = e.read_shift(2), s = a[n] || a[65535], i = e.read_shift(2), o = e.l + i, i = s.f && s.f(e, i, r);
                if (e.l = o, t(i, s, n)) return;
            }
        }
    }
    function oi(e, t) {
        if (!e) return e;
        var n = t || {};
        null != oe && null == n.dense && (n.dense = oe);
        var s = n.dense ? [] : {}, i = "Sheet1", o = "", c = 0, l = {}, f = [], a = [], h = {
            s: {
                r: 0,
                c: 0
            },
            e: {
                r: 0,
                c: 0
            }
        }, u = n.sheetRows || 0;
        if (0 == e[2] && (8 == e[3] || 9 == e[3]) && 16 <= e.length && 5 == e[14] && 108 === e[15]) throw new Error("Unsupported Works 3 for Mac file");
        if (2 == e[2]) n.Enum = ai, ii(e, function(e, t, r) {
            switch(r){
                case 0:
                    4096 <= (n.vers = e) && (n.qpro = !0);
                    break;
                case 6:
                    h = e;
                    break;
                case 204:
                    e && (o = e);
                    break;
                case 222:
                    o = e;
                    break;
                case 15:
                case 51:
                    n.qpro || (e[1].v = e[1].v.slice(1));
                case 13:
                case 14:
                case 16:
                    14 == r && 112 == (112 & e[2]) && 1 < (15 & e[2]) && (15 & e[2]) < 15 && (e[1].z = n.dateNF || me[14], n.cellDates && (e[1].t = "d", e[1].v = Me(e[1].v))), n.qpro && e[3] > c && (s["!ref"] = qr(h), l[i] = s, f.push(i), s = n.dense ? [] : {}, h = {
                        s: {
                            r: 0,
                            c: 0
                        },
                        e: {
                            r: 0,
                            c: 0
                        }
                    }, c = e[3], i = o || "Sheet" + (c + 1), o = "");
                    var a = n.dense ? (s[e[0].r] || [])[e[0].c] : s[Kr(e[0])];
                    if (a) {
                        a.t = e[1].t, a.v = e[1].v, null != e[1].z && (a.z = e[1].z), null != e[1].f && (a.f = e[1].f);
                        break;
                    }
                    n.dense ? (s[e[0].r] || (s[e[0].r] = []), s[e[0].r][e[0].c] = e[1]) : s[Kr(e[0])] = e[1];
            }
        }, n);
        else {
            if (26 != e[2] && 14 != e[2]) throw new Error("Unrecognized LOTUS BOF " + e[2]);
            n.Enum = ni, 14 == e[2] && (n.qpro = !0, e.l = 0), ii(e, function(e, t, r) {
                switch(r){
                    case 204:
                        i = e;
                        break;
                    case 22:
                        e[1].v = e[1].v.slice(1);
                    case 23:
                    case 24:
                    case 25:
                    case 37:
                    case 39:
                    case 40:
                        if (e[3] > c && (s["!ref"] = qr(h), l[i] = s, f.push(i), s = n.dense ? [] : {}, h = {
                            s: {
                                r: 0,
                                c: 0
                            },
                            e: {
                                r: 0,
                                c: 0
                            }
                        }, c = e[3], i = "Sheet" + (c + 1)), 0 < u && e[0].r >= u) break;
                        n.dense ? (s[e[0].r] || (s[e[0].r] = []), s[e[0].r][e[0].c] = e[1]) : s[Kr(e[0])] = e[1], h.e.c < e[0].c && (h.e.c = e[0].c), h.e.r < e[0].r && (h.e.r = e[0].r);
                        break;
                    case 27:
                        e[14e3] && (a[e[14e3][0]] = e[14e3][1]);
                        break;
                    case 1537:
                        a[e[0]] = e[1], e[0] == c && (i = e[1]);
                }
            }, n);
        }
        if (s["!ref"] = qr(h), l[o || i] = s, f.push(o || i), !a.length) return {
            SheetNames: f,
            Sheets: l
        };
        for(var r = {}, d = [], p = 0; p < a.length; ++p)l[f[p]] ? (d.push(a[p] || f[p]), r[a[p]] = l[a[p]] || l[f[p]]) : (d.push(a[p]), r[a[p]] = {
            "!ref": "A1"
        });
        return {
            SheetNames: d,
            Sheets: r
        };
    }
    function ci(e, t, r) {
        var a = [
            {
                c: 0,
                r: 0
            },
            {
                t: "n",
                v: 0
            },
            0,
            0
        ];
        return r.qpro && 20768 != r.vers ? (a[0].c = e.read_shift(1), a[3] = e.read_shift(1), a[0].r = e.read_shift(2), e.l += 2) : (a[2] = e.read_shift(1), a[0].c = e.read_shift(2), a[0].r = e.read_shift(2)), a;
    }
    function li(e, t, r) {
        var a = e.l + t, t = ci(e, 0, r);
        if (t[1].t = "s", 20768 != r.vers) return r.qpro && e.l++, t[1].v = e.read_shift(a - e.l, "cstr"), t;
        e.l++;
        a = e.read_shift(1);
        return t[1].v = e.read_shift(a, "utf8"), t;
    }
    function fi(e, t, r) {
        var a = 32768 & t;
        return (a ? "" : "$") + (r ? Xr : jr)(t = (a ? e : 0) + (8192 <= (t &= -32769) ? t - 16384 : t));
    }
    function hi(e) {
        var t = [
            {
                c: 0,
                r: 0
            },
            {
                t: "n",
                v: 0
            },
            0
        ];
        return t[0].r = e.read_shift(2), t[3] = e[e.l++], t[0].c = e[e.l++], t;
    }
    function ui(e, t) {
        var r = hi(e), a = e.read_shift(4), n = e.read_shift(4);
        if (65535 == (s = e.read_shift(2))) return 0 === a && 3221225472 === n ? (r[1].t = "e", r[1].v = 15) : 0 === a && 3489660928 === n ? (r[1].t = "e", r[1].v = 42) : r[1].v = 0, r;
        var e = 32768 & s, s = (32767 & s) - 16446;
        return r[1].v = (1 - 2 * e) * (n * Math.pow(2, 32 + s) + a * Math.pow(2, s)), r;
    }
    function di(e, t) {
        var r = hi(e), e = e.read_shift(8, "f");
        return r[1].v = e, r;
    }
    function pi(e, t) {
        return 0 == e[e.l + t - 1] ? e.read_shift(t, "cstr") : "";
    }
    var mi, gi, bi, vi, wi = (mi = Bt("t"), gi = Bt("rPr"), bi = /<(?:\w+:)?r>/g, vi = /<\/(?:\w+:)?r>/, function(e) {
        return e.replace(bi, "").split(vi).map(Ti).filter(function(e) {
            return e.v;
        });
    });
    function Ti(e) {
        var t = e.match(mi);
        if (!t) return {
            t: "s",
            v: ""
        };
        t = {
            t: "s",
            v: wt(t[1])
        }, e = e.match(gi);
        return e && (t.s = function(e) {
            var t = {}, r = e.match(ft), a = 0, n = !1;
            if (r) for(; a != r.length; ++a){
                var s = dt(r[a]);
                switch(s[0].replace(/\w*:/g, "")){
                    case "<condense":
                    case "<extend":
                        break;
                    case "<shadow":
                        if (!s.val) break;
                    case "<shadow>":
                    case "<shadow/>":
                        t.shadow = 1;
                        break;
                    case "</shadow>":
                        break;
                    case "<charset":
                        if ("1" == s.val) break;
                        t.cp = l[parseInt(s.val, 10)];
                        break;
                    case "<outline":
                        if (!s.val) break;
                    case "<outline>":
                    case "<outline/>":
                        t.outline = 1;
                        break;
                    case "</outline>":
                        break;
                    case "<rFont":
                        t.name = s.val;
                        break;
                    case "<sz":
                        t.sz = s.val;
                        break;
                    case "<strike":
                        if (!s.val) break;
                    case "<strike>":
                    case "<strike/>":
                        t.strike = 1;
                        break;
                    case "</strike>":
                        break;
                    case "<u":
                        if (!s.val) break;
                        switch(s.val){
                            case "double":
                                t.uval = "double";
                                break;
                            case "singleAccounting":
                                t.uval = "single-accounting";
                                break;
                            case "doubleAccounting":
                                t.uval = "double-accounting";
                        }
                    case "<u>":
                    case "<u/>":
                        t.u = 1;
                        break;
                    case "</u>":
                        break;
                    case "<b":
                        if ("0" == s.val) break;
                    case "<b>":
                    case "<b/>":
                        t.b = 1;
                        break;
                    case "</b>":
                        break;
                    case "<i":
                        if ("0" == s.val) break;
                    case "<i>":
                    case "<i/>":
                        t.i = 1;
                        break;
                    case "</i>":
                        break;
                    case "<color":
                        s.rgb && (t.color = s.rgb.slice(2, 8));
                        break;
                    case "<color>":
                    case "<color/>":
                    case "</color>":
                        break;
                    case "<family":
                        t.family = s.val;
                        break;
                    case "<family>":
                    case "<family/>":
                    case "</family>":
                        break;
                    case "<vertAlign":
                        t.valign = s.val;
                        break;
                    case "<vertAlign>":
                    case "<vertAlign/>":
                    case "</vertAlign>":
                    case "<scheme":
                        break;
                    case "<scheme>":
                    case "<scheme/>":
                    case "</scheme>":
                        break;
                    case "<extLst":
                    case "<extLst>":
                    case "</extLst>":
                        break;
                    case "<ext":
                        n = !0;
                        break;
                    case "</ext>":
                        n = !1;
                        break;
                    default:
                        if (47 !== s[0].charCodeAt(1) && !n) throw new Error("Unrecognized rich format " + s[0]);
                }
            }
            return t;
        }(e[1])), t;
    }
    var Ei, ki = (Ei = /(\r\n|\n)/g, function(e) {
        return e.map(yi).join("");
    });
    function yi(e) {
        var t, r, a, n = [
            [],
            e.v,
            []
        ];
        return e.v ? (e.s && (t = e.s, r = n[0], a = n[2], e = [], t.u && e.push("text-decoration: underline;"), t.uval && e.push("text-underline-style:" + t.uval + ";"), t.sz && e.push("font-size:" + t.sz + "pt;"), t.outline && e.push("text-effect: outline;"), t.shadow && e.push("text-shadow: auto;"), r.push('<span style="' + e.join("") + '">'), t.b && (r.push("<b>"), a.push("</b>")), t.i && (r.push("<i>"), a.push("</i>")), t.strike && (r.push("<s>"), a.push("</s>")), "superscript" == (e = t.valign || "") || "super" == e ? e = "sup" : "subscript" == e && (e = "sub"), "" != e && (r.push("<" + e + ">"), a.push("</" + e + ">")), a.push("</span>")), n[0].join("") + n[1].replace(Ei, "<br/>") + n[2].join("")) : "";
    }
    var Si = /<(?:\w+:)?t[^>]*>([^<]*)<\/(?:\w+:)?t>/g, _i = /<(?:\w+:)?r>/, xi = /<(?:\w+:)?rPh.*?>([\s\S]*?)<\/(?:\w+:)?rPh>/g;
    function Ai(e, t) {
        var r = !t || t.cellHTML, t = {};
        return e ? (e.match(/^\s*<(?:\w+:)?t[^>]*>/) ? (t.t = wt(Mt(e.slice(e.indexOf(">") + 1).split(/<\/(?:\w+:)?t>/)[0] || "")), t.r = Mt(e), r && (t.h = _t(t.t))) : e.match(_i) && (t.r = Mt(e), t.t = wt(Mt((e.replace(xi, "").match(Si) || []).join("").replace(ft, ""))), r && (t.h = ki(wi(t.r)))), t) : {
            t: ""
        };
    }
    var Ci = /<(?:\w+:)?sst([^>]*)>([\s\S]*)<\/(?:\w+:)?sst>/, Ri = /<(?:\w+:)?(?:si|sstItem)>/g, Oi = /<\/(?:\w+:)?(?:si|sstItem)>/;
    var Ii = /^\s|\s$|[\t\n\r]/;
    function Ni(e, t) {
        if (!t.bookSST) return "";
        var r = [
            ot
        ];
        r[r.length] = Yt("sst", null, {
            xmlns: Qt[0],
            count: e.Count,
            uniqueCount: e.Unique
        });
        for(var a, n, s = 0; s != e.length; ++s)null != e[s] && (n = "<si>", (a = e[s]).r ? n += a.r : (n += "<t", a.t || (a.t = ""), a.t.match(Ii) && (n += ' xml:space="preserve"'), n += ">" + kt(a.t) + "</t>"), n += "</si>", r[r.length] = n);
        return 2 < r.length && (r[r.length] = "</sst>", r[1] = r[1].replace("/>", ">")), r.join("");
    }
    var Fi = function(e, t) {
        var r = !1;
        return null == t && (r = !0, t = Lr(15 + 4 * e.t.length)), t.write_shift(1, 0), ia(e.t, t), r ? t.slice(0, t.l) : t;
    };
    function Di(e) {
        var t, r, a = Ur();
        Br(a, 159, (t = e, (r = r || Lr(8)).write_shift(4, t.Count), r.write_shift(4, t.Unique), r));
        for(var n = 0; n < e.length; ++n)Br(a, 19, Fi(e[n]));
        return Br(a, 160), a.end();
    }
    function Pi(e) {
        if (void 0 !== re) return re.utils.encode(_, e);
        for(var t = [], r = e.split(""), a = 0; a < r.length; ++a)t[a] = r[a].charCodeAt(0);
        return t;
    }
    function Li(e, t) {
        var r = {};
        return r.Major = e.read_shift(2), r.Minor = e.read_shift(2), 4 <= t && (e.l += t - 4), r;
    }
    function Mi(e) {
        var t = [];
        e.l += 4;
        for(var r = e.read_shift(4); 0 < r--;)t.push(function(e) {
            for(var t = e.read_shift(4), r = e.l + t - 4, t = {}, a = e.read_shift(4), n = []; 0 < a--;)n.push({
                t: e.read_shift(4),
                v: e.read_shift(0, "lpp4")
            });
            if (t.name = e.read_shift(0, "lpp4"), t.comps = n, e.l != r) throw new Error("Bad DataSpaceMapEntry: " + e.l + " != " + r);
            return t;
        }(e));
        return t;
    }
    function Ui(e) {
        var t, r, r = (r = {}, (t = e).read_shift(4), t.l += 4, r.id = t.read_shift(0, "lpp4"), r.name = t.read_shift(0, "lpp4"), r.R = Li(t, 4), r.U = Li(t, 4), r.W = Li(t, 4), r);
        if (r.ename = e.read_shift(0, "8lpp4"), r.blksz = e.read_shift(4), r.cmode = e.read_shift(4), 4 != e.read_shift(4)) throw new Error("Bad !Primary record");
        return r;
    }
    function Bi(e, t) {
        var t = e.l + t, r = {};
        r.Flags = 63 & e.read_shift(4), e.l += 4, r.AlgID = e.read_shift(4);
        var a = !1;
        switch(r.AlgID){
            case 26126:
            case 26127:
            case 26128:
                a = 36 == r.Flags;
                break;
            case 26625:
                a = 4 == r.Flags;
                break;
            case 0:
                a = 16 == r.Flags || 4 == r.Flags || 36 == r.Flags;
                break;
            default:
                throw "Unrecognized encryption algorithm: " + r.AlgID;
        }
        if (!a) throw new Error("Encryption Flags/AlgID mismatch");
        return r.AlgIDHash = e.read_shift(4), r.KeySize = e.read_shift(4), r.ProviderType = e.read_shift(4), e.l += 8, r.CSPName = e.read_shift(t - e.l >> 1, "utf16le"), e.l = t, r;
    }
    function Wi(e, t) {
        var r = {}, t = e.l + t;
        return e.l += 4, r.Salt = e.slice(e.l, e.l + 16), e.l += 16, r.Verifier = e.slice(e.l, e.l + 16), e.l += 16, e.read_shift(4), r.VerifierHash = e.slice(e.l, t), e.l = t, r;
    }
    function Hi(e) {
        var t = Li(e);
        switch(t.Minor){
            case 2:
                return [
                    t.Minor,
                    function(e) {
                        if (36 != (63 & e.read_shift(4))) throw new Error("EncryptionInfo mismatch");
                        var t = e.read_shift(4), t = Bi(e, t), e = Wi(e, e.length - e.l);
                        return {
                            t: "Std",
                            h: t,
                            v: e
                        };
                    }(e)
                ];
            case 3:
                return [
                    t.Minor,
                    function() {
                        throw new Error("File is password-protected: ECMA-376 Extensible");
                    }()
                ];
            case 4:
                return [
                    t.Minor,
                    function(e) {
                        var r = [
                            "saltSize",
                            "blockSize",
                            "keyBits",
                            "hashSize",
                            "cipherAlgorithm",
                            "cipherChaining",
                            "hashAlgorithm",
                            "saltValue"
                        ];
                        e.l += 4;
                        var e = e.read_shift(e.length - e.l, "utf8"), a = {};
                        return e.replace(ft, function(e) {
                            var t = dt(e);
                            switch(pt(t[0])){
                                case "<?xml":
                                    break;
                                case "<encryption":
                                case "</encryption>":
                                    break;
                                case "<keyData":
                                    r.forEach(function(e) {
                                        a[e] = t[e];
                                    });
                                    break;
                                case "<dataIntegrity":
                                    a.encryptedHmacKey = t.encryptedHmacKey, a.encryptedHmacValue = t.encryptedHmacValue;
                                    break;
                                case "<keyEncryptors>":
                                case "<keyEncryptors":
                                    a.encs = [];
                                    break;
                                case "</keyEncryptors>":
                                    break;
                                case "<keyEncryptor":
                                    a.uri = t.uri;
                                    break;
                                case "</keyEncryptor>":
                                    break;
                                case "<encryptedKey":
                                    a.encs.push(t);
                                    break;
                                default:
                                    throw t[0];
                            }
                        }), a;
                    }(e)
                ];
        }
        throw new Error("ECMA-376 Encrypted file unrecognized Version: " + t.Minor);
    }
    function zi(e) {
        var t, r = 0, a = Pi(e), n = a.length + 1, s = le(n);
        for(s[0] = a.length, t = 1; t != n; ++t)s[t] = a[t - 1];
        for(t = n - 1; 0 <= t; --t)r = ((0 == (16384 & r) ? 0 : 1) | r << 1 & 32767) ^ s[t];
        return 52811 ^ r;
    }
    var Vi, Gi, ji, $i = (Vi = [
        187,
        255,
        255,
        186,
        255,
        255,
        185,
        128,
        0,
        190,
        15,
        0,
        191,
        15,
        0
    ], Gi = [
        57840,
        7439,
        52380,
        33984,
        4364,
        3600,
        61902,
        12606,
        6258,
        57657,
        54287,
        34041,
        10252,
        43370,
        20163
    ], ji = [
        44796,
        19929,
        39858,
        10053,
        20106,
        40212,
        10761,
        31585,
        63170,
        64933,
        60267,
        50935,
        40399,
        11199,
        17763,
        35526,
        1453,
        2906,
        5812,
        11624,
        23248,
        885,
        1770,
        3540,
        7080,
        14160,
        28320,
        56640,
        55369,
        41139,
        20807,
        41614,
        21821,
        43642,
        17621,
        28485,
        56970,
        44341,
        19019,
        38038,
        14605,
        29210,
        60195,
        50791,
        40175,
        10751,
        21502,
        43004,
        24537,
        18387,
        36774,
        3949,
        7898,
        15796,
        31592,
        63184,
        47201,
        24803,
        49606,
        37805,
        14203,
        28406,
        56812,
        17824,
        35648,
        1697,
        3394,
        6788,
        13576,
        27152,
        43601,
        17539,
        35078,
        557,
        1114,
        2228,
        4456,
        30388,
        60776,
        51953,
        34243,
        7079,
        14158,
        28316,
        14128,
        28256,
        56512,
        43425,
        17251,
        34502,
        7597,
        13105,
        26210,
        52420,
        35241,
        883,
        1766,
        3532,
        4129,
        8258,
        16516,
        33032,
        4657,
        9314,
        18628
    ], function(e) {
        for(var t, r, a = Pi(e), n = function(e) {
            for(var t = Gi[e.length - 1], r = 104, a = e.length - 1; 0 <= a; --a)for(var n = e[a], s = 0; 7 != s; ++s)64 & n && (t ^= ji[r]), n *= 2, --r;
            return t;
        }(a), s = a.length, i = le(16), o = 0; 16 != o; ++o)i[o] = 0;
        for(1 == (1 & s) && (t = n >> 8, i[s] = Xi(Vi[0], t), --s, t = 255 & n, e = a[a.length - 1], i[s] = Xi(e, t)); 0 < s;)t = n >> 8, i[--s] = Xi(a[s], t), t = 255 & n, i[--s] = Xi(a[s], t);
        for(r = (s = 15) - a.length; 0 < r;)t = n >> 8, i[s] = Xi(Vi[r], t), --r, t = 255 & n, i[--s] = Xi(a[s], t), --s, --r;
        return i;
    });
    function Xi(e, t) {
        return 255 & ((t = e ^ t) / 2 | 128 * t);
    }
    var Yi = function(e) {
        var t = 0, r = $i(e);
        return function(e) {
            e = function(e, t, r, a, n) {
                var s, i;
                for(n = n || t, a = a || $i(e), s = 0; s != t.length; ++s)i = t[s], i = 255 & ((i ^= a[r]) >> 5 | i << 3), n[s] = i, ++r;
                return [
                    n,
                    r,
                    a
                ];
            }("", e, t, r);
            return t = e[1], e[0];
        };
    };
    function Ki(e, t, r) {
        r = r || {};
        return r.Info = e.read_shift(2), e.l -= 2, 1 === r.Info ? r.Data = function(e) {
            var t = {}, r = t.EncryptionVersionInfo = Li(e, 4);
            if (1 != r.Major || 1 != r.Minor) throw "unrecognized version code " + r.Major + " : " + r.Minor;
            return t.Salt = e.read_shift(16), t.EncryptedVerifier = e.read_shift(16), t.EncryptedVerifierHash = e.read_shift(16), t;
        }(e) : r.Data = function(e, t) {
            var r = {}, a = r.EncryptionVersionInfo = Li(e, 4);
            if (t -= 4, 2 != a.Minor) throw new Error("unrecognized minor version code: " + a.Minor);
            if (4 < a.Major || a.Major < 2) throw new Error("unrecognized major version code: " + a.Major);
            return r.Flags = e.read_shift(4), t -= 4, a = e.read_shift(4), t -= 4, r.EncryptionHeader = Bi(e, a), t -= a, r.EncryptionVerifier = Wi(e, t), r;
        }(e, t), r;
    }
    var Ji = {
        to_workbook: function(e, t) {
            return ta(qi(e, t), t);
        },
        to_sheet: qi,
        from_sheet: function(e) {
            for(var t = [
                "{\\rtf1\\ansi"
            ], r = Zr(e["!ref"]), a = Array.isArray(e), n = r.s.r; n <= r.e.r; ++n){
                t.push("\\trowd\\trautofit1");
                for(var s = r.s.c; s <= r.e.c; ++s)t.push("\\cellx" + (s + 1));
                for(t.push("\\pard\\intbl"), s = r.s.c; s <= r.e.c; ++s){
                    var i = Kr({
                        r: n,
                        c: s
                    });
                    (i = a ? (e[n] || [])[s] : e[i]) && (null != i.v || i.f && !i.F) && (t.push(" " + (i.w || (ea(i), i.w))), t.push("\\cell"));
                }
                t.push("\\pard\\intbl\\row");
            }
            return t.join("") + "}";
        }
    };
    function qi(e, t) {
        switch(t.type){
            case "base64":
                return Zi(te(e), t);
            case "binary":
                return Zi(e, t);
            case "buffer":
                return Zi(se && $4249f69807f0687b$require$Buffer.isBuffer(e) ? e.toString("binary") : i(e), t);
            case "array":
                return Zi(ze(e), t);
        }
        throw new Error("Unrecognized type " + t.type);
    }
    function Zi(e, t) {
        var i = (t || {}).dense ? [] : {}, e = e.match(/\\trowd.*?\\row\b/g);
        if (!e.length) throw new Error("RTF missing table");
        var o = {
            s: {
                c: 0,
                r: 0
            },
            e: {
                c: 0,
                r: e.length - 1
            }
        };
        return e.forEach(function(e, t) {
            Array.isArray(i) && (i[t] = []);
            for(var r, a = /\\\w+\b/g, n = 0, s = -1; r = a.exec(e);)"\\cell" === r[0] && (++s, (r = " " == (r = e.slice(n, a.lastIndex - r[0].length))[0] ? r.slice(1) : r).length && (r = {
                v: r,
                t: "s"
            }, Array.isArray(i) ? i[t][s] = r : i[Kr({
                r: t,
                c: s
            })] = r)), n = a.lastIndex;
            s > o.e.c && (o.e.c = s);
        }), i["!ref"] = qr(o), i;
    }
    function Qi(e) {
        for(var t = 0, r = 1; 3 != t; ++t)r = 256 * r + (255 < e[t] ? 255 : e[t] < 0 ? 0 : e[t]);
        return r.toString(16).toUpperCase().slice(1);
    }
    function eo(e, t) {
        if (0 === t) return e;
        e = function(e) {
            var t = e[0] / 255, r = e[1] / 255, a = e[2] / 255, n = Math.max(t, r, a), s = Math.min(t, r, a), i = n - s;
            if (0 == i) return [
                0,
                0,
                t
            ];
            var o = 0, e = 0, e = i / (1 < (s = n + s) ? 2 - s : s);
            switch(n){
                case t:
                    o = ((r - a) / i + 6) % 6;
                    break;
                case r:
                    o = (a - t) / i + 2;
                    break;
                case a:
                    o = (t - r) / i + 4;
            }
            return [
                o / 6,
                e,
                s / 2
            ];
        }((e = e.slice("#" === e[0] ? 1 : 0).slice(0, 6), [
            parseInt(e.slice(0, 2), 16),
            parseInt(e.slice(2, 4), 16),
            parseInt(e.slice(4, 6), 16)
        ]));
        return e[2] = t < 0 ? e[2] * (1 + t) : 1 - (1 - e[2]) * (1 - t), Qi(function(e) {
            var t, r = e[0], a = e[1], e = e[2], n = 2 * a * (e < .5 ? e : 1 - e), s = [
                e = e - n / 2,
                e,
                e
            ], i = 6 * r;
            if (0 !== a) switch(0 | i){
                case 0:
                case 6:
                    t = n * i, s[0] += n, s[1] += t;
                    break;
                case 1:
                    t = n * (2 - i), s[0] += t, s[1] += n;
                    break;
                case 2:
                    t = n * (i - 2), s[1] += n, s[2] += t;
                    break;
                case 3:
                    t = n * (4 - i), s[1] += t, s[2] += n;
                    break;
                case 4:
                    t = n * (i - 4), s[2] += n, s[0] += t;
                    break;
                case 5:
                    t = n * (6 - i), s[2] += t, s[0] += n;
            }
            for(var o = 0; 3 != o; ++o)s[o] = Math.round(255 * s[o]);
            return s;
        }(e));
    }
    var to = 6, ro = 15, ao = 1, no = to;
    function so(e) {
        return Math.floor((e + Math.round(128 / no) / 256) * no);
    }
    function io(e) {
        return Math.floor((e - 5) / no * 100 + .5) / 100;
    }
    function oo(e) {
        return Math.round((e * no + 5) / no * 256) / 256;
    }
    function co(e) {
        return oo(io(so(e)));
    }
    function lo(e) {
        var t = Math.abs(e - co(e)), r = no;
        if (.005 < t) for(no = ao; no < ro; ++no)Math.abs(e - co(e)) <= t && (t = Math.abs(e - co(e)), r = no);
        no = r;
    }
    function fo(e) {
        e.width ? (e.wpx = so(e.width), e.wch = io(e.wpx), e.MDW = no) : e.wpx ? (e.wch = io(e.wpx), e.width = oo(e.wch), e.MDW = no) : "number" == typeof e.wch && (e.width = oo(e.wch), e.wpx = so(e.width), e.MDW = no), e.customWidth && delete e.customWidth;
    }
    var ho = 96;
    function uo(e) {
        return 96 * e / ho;
    }
    function po(e) {
        return e * ho / 96;
    }
    var mo = {
        None: "none",
        Solid: "solid",
        Gray50: "mediumGray",
        Gray75: "darkGray",
        Gray25: "lightGray",
        HorzStripe: "darkHorizontal",
        VertStripe: "darkVertical",
        ReverseDiagStripe: "darkDown",
        DiagStripe: "darkUp",
        DiagCross: "darkGrid",
        ThickDiagCross: "darkTrellis",
        ThinHorzStripe: "lightHorizontal",
        ThinVertStripe: "lightVertical",
        ThinReverseDiagStripe: "lightDown",
        ThinHorzCross: "lightGrid"
    };
    var go = [
        "numFmtId",
        "fillId",
        "fontId",
        "borderId",
        "xfId"
    ], bo = [
        "applyAlignment",
        "applyBorder",
        "applyFill",
        "applyFont",
        "applyNumberFormat",
        "applyProtection",
        "pivotButton",
        "quotePrefix"
    ];
    var vo, wo, To, Eo, ko, yo, So = (vo = /<(?:\w+:)?numFmts([^>]*)>[\S\s]*?<\/(?:\w+:)?numFmts>/, wo = /<(?:\w+:)?cellXfs([^>]*)>[\S\s]*?<\/(?:\w+:)?cellXfs>/, To = /<(?:\w+:)?fills([^>]*)>[\S\s]*?<\/(?:\w+:)?fills>/, Eo = /<(?:\w+:)?fonts([^>]*)>[\S\s]*?<\/(?:\w+:)?fonts>/, ko = /<(?:\w+:)?borders([^>]*)>[\S\s]*?<\/(?:\w+:)?borders>/, function(e, t, r) {
        var a, n, s, i, o, c = {};
        return e && ((a = (e = e.replace(/<!--([\s\S]*?)-->/gm, "").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm, "")).match(vo)) && function(e, t, r) {
            t.NumberFmt = [];
            for(var a = Re(me), n = 0; n < a.length; ++n)t.NumberFmt[a[n]] = me[a[n]];
            var s = e[0].match(ft);
            if (s) for(n = 0; n < s.length; ++n){
                var i = dt(s[n]);
                switch(pt(i[0])){
                    case "<numFmts":
                    case "</numFmts>":
                    case "<numFmts/>":
                    case "<numFmts>":
                        break;
                    case "<numFmt":
                        var o = wt(Mt(i.formatCode)), c = parseInt(i.numFmtId, 10);
                        if (t.NumberFmt[c] = o, 0 < c) {
                            if (392 < c) {
                                for(c = 392; 60 < c && null != t.NumberFmt[c]; --c);
                                t.NumberFmt[c] = o;
                            }
                            we(o, c);
                        }
                        break;
                    case "</numFmt>":
                        break;
                    default:
                        if (r.WTF) throw new Error("unrecognized " + i[0] + " in numFmts");
                }
            }
        }(a, c, r), (a = e.match(Eo)) && function(e, a, n, s) {
            a.Fonts = [];
            var i = {}, o = !1;
            (e[0].match(ft) || []).forEach(function(e) {
                var t, r = dt(e);
                switch(pt(r[0])){
                    case "<fonts":
                    case "<fonts>":
                    case "</fonts>":
                        break;
                    case "<font":
                    case "<font>":
                        break;
                    case "</font>":
                    case "<font/>":
                        a.Fonts.push(i), i = {};
                        break;
                    case "<name":
                        r.val && (i.name = Mt(r.val));
                        break;
                    case "<name/>":
                    case "</name>":
                        break;
                    case "<b":
                        i.bold = r.val ? Rt(r.val) : 1;
                        break;
                    case "<b/>":
                        i.bold = 1;
                        break;
                    case "<i":
                        i.italic = r.val ? Rt(r.val) : 1;
                        break;
                    case "<i/>":
                        i.italic = 1;
                        break;
                    case "<u":
                        switch(r.val){
                            case "none":
                                i.underline = 0;
                                break;
                            case "single":
                                i.underline = 1;
                                break;
                            case "double":
                                i.underline = 2;
                                break;
                            case "singleAccounting":
                                i.underline = 33;
                                break;
                            case "doubleAccounting":
                                i.underline = 34;
                        }
                        break;
                    case "<u/>":
                        i.underline = 1;
                        break;
                    case "<strike":
                        i.strike = r.val ? Rt(r.val) : 1;
                        break;
                    case "<strike/>":
                        i.strike = 1;
                        break;
                    case "<outline":
                        i.outline = r.val ? Rt(r.val) : 1;
                        break;
                    case "<outline/>":
                        i.outline = 1;
                        break;
                    case "<shadow":
                        i.shadow = r.val ? Rt(r.val) : 1;
                        break;
                    case "<shadow/>":
                        i.shadow = 1;
                        break;
                    case "<condense":
                        i.condense = r.val ? Rt(r.val) : 1;
                        break;
                    case "<condense/>":
                        i.condense = 1;
                        break;
                    case "<extend":
                        i.extend = r.val ? Rt(r.val) : 1;
                        break;
                    case "<extend/>":
                        i.extend = 1;
                        break;
                    case "<sz":
                        r.val && (i.sz = +r.val);
                        break;
                    case "<sz/>":
                    case "</sz>":
                        break;
                    case "<vertAlign":
                        r.val && (i.vertAlign = r.val);
                        break;
                    case "<vertAlign/>":
                    case "</vertAlign>":
                        break;
                    case "<family":
                        r.val && (i.family = parseInt(r.val, 10));
                        break;
                    case "<family/>":
                    case "</family>":
                        break;
                    case "<scheme":
                        r.val && (i.scheme = r.val);
                        break;
                    case "<scheme/>":
                    case "</scheme>":
                        break;
                    case "<charset":
                        if ("1" == r.val) break;
                        r.codepage = l[parseInt(r.val, 10)];
                        break;
                    case "<color":
                        i.color || (i.color = {}), r.auto && (i.color.auto = Rt(r.auto)), r.rgb ? i.color.rgb = r.rgb.slice(-6) : r.indexed ? (i.color.index = parseInt(r.indexed, 10), t = Ba[i.color.index], t = (t = 81 == i.color.index ? Ba[1] : t) || Ba[1], i.color.rgb = t[0].toString(16) + t[1].toString(16) + t[2].toString(16)) : r.theme && (i.color.theme = parseInt(r.theme, 10), r.tint && (i.color.tint = parseFloat(r.tint)), r.theme && n.themeElements && n.themeElements.clrScheme && (i.color.rgb = eo(n.themeElements.clrScheme[i.color.theme].rgb, i.color.tint || 0)));
                        break;
                    case "<color/>":
                    case "</color>":
                        break;
                    case "<AlternateContent":
                        o = !0;
                        break;
                    case "</AlternateContent>":
                        o = !1;
                        break;
                    case "<extLst":
                    case "<extLst>":
                    case "</extLst>":
                        break;
                    case "<ext":
                        o = !0;
                        break;
                    case "</ext>":
                        o = !1;
                        break;
                    default:
                        if (s && s.WTF && !o) throw new Error("unrecognized " + r[0] + " in fonts");
                }
            });
        }(a, c, t, r), (a = e.match(To)) && function(e, r, a) {
            r.Fills = [];
            var n = {}, s = !1;
            (e[0].match(ft) || []).forEach(function(e) {
                var t = dt(e);
                switch(pt(t[0])){
                    case "<fills":
                    case "<fills>":
                    case "</fills>":
                        break;
                    case "<fill>":
                    case "<fill":
                    case "<fill/>":
                        n = {}, r.Fills.push(n);
                        break;
                    case "</fill>":
                    case "<gradientFill>":
                        break;
                    case "<gradientFill":
                    case "</gradientFill>":
                        r.Fills.push(n), n = {};
                        break;
                    case "<patternFill":
                    case "<patternFill>":
                        t.patternType && (n.patternType = t.patternType);
                        break;
                    case "<patternFill/>":
                    case "</patternFill>":
                        break;
                    case "<bgColor":
                        n.bgColor || (n.bgColor = {}), t.indexed && (n.bgColor.indexed = parseInt(t.indexed, 10)), t.theme && (n.bgColor.theme = parseInt(t.theme, 10)), t.tint && (n.bgColor.tint = parseFloat(t.tint)), t.rgb && (n.bgColor.rgb = t.rgb.slice(-6));
                        break;
                    case "<bgColor/>":
                    case "</bgColor>":
                        break;
                    case "<fgColor":
                        n.fgColor || (n.fgColor = {}), t.theme && (n.fgColor.theme = parseInt(t.theme, 10)), t.tint && (n.fgColor.tint = parseFloat(t.tint)), null != t.rgb && (n.fgColor.rgb = t.rgb.slice(-6));
                        break;
                    case "<fgColor/>":
                    case "</fgColor>":
                        break;
                    case "<stop":
                    case "<stop/>":
                    case "</stop>":
                        break;
                    case "<color":
                    case "<color/>":
                    case "</color>":
                        break;
                    case "<extLst":
                    case "<extLst>":
                    case "</extLst>":
                        break;
                    case "<ext":
                        s = !0;
                        break;
                    case "</ext>":
                        s = !1;
                        break;
                    default:
                        if (a && a.WTF && !s) throw new Error("unrecognized " + t[0] + " in fills");
                }
            });
        }(a, c, r), (a = e.match(ko)) && function(e, r, a) {
            r.Borders = [];
            var n = {}, s = !1;
            (e[0].match(ft) || []).forEach(function(e) {
                var t = dt(e);
                switch(pt(t[0])){
                    case "<borders":
                    case "<borders>":
                    case "</borders>":
                        break;
                    case "<border":
                    case "<border>":
                    case "<border/>":
                        n = {}, t.diagonalUp && (n.diagonalUp = Rt(t.diagonalUp)), t.diagonalDown && (n.diagonalDown = Rt(t.diagonalDown)), r.Borders.push(n);
                        break;
                    case "</border>":
                    case "<left/>":
                        break;
                    case "<left":
                    case "<left>":
                    case "</left>":
                    case "<right/>":
                        break;
                    case "<right":
                    case "<right>":
                    case "</right>":
                    case "<top/>":
                        break;
                    case "<top":
                    case "<top>":
                    case "</top>":
                    case "<bottom/>":
                        break;
                    case "<bottom":
                    case "<bottom>":
                    case "</bottom>":
                        break;
                    case "<diagonal":
                    case "<diagonal>":
                    case "<diagonal/>":
                    case "</diagonal>":
                        break;
                    case "<horizontal":
                    case "<horizontal>":
                    case "<horizontal/>":
                    case "</horizontal>":
                        break;
                    case "<vertical":
                    case "<vertical>":
                    case "<vertical/>":
                    case "</vertical>":
                        break;
                    case "<start":
                    case "<start>":
                    case "<start/>":
                    case "</start>":
                        break;
                    case "<end":
                    case "<end>":
                    case "<end/>":
                    case "</end>":
                        break;
                    case "<color":
                    case "<color>":
                        break;
                    case "<color/>":
                    case "</color>":
                        break;
                    case "<extLst":
                    case "<extLst>":
                    case "</extLst>":
                        break;
                    case "<ext":
                        s = !0;
                        break;
                    case "</ext>":
                        s = !1;
                        break;
                    default:
                        if (a && a.WTF && !s) throw new Error("unrecognized " + t[0] + " in borders");
                }
            });
        }(a, c, r), (a = e.match(wo)) && (a, s = r, o = ((n = c).CellXf = [], false), (a[0].match(ft) || []).forEach(function(e) {
            var t = dt(e), r = 0;
            switch(pt(t[0])){
                case "<cellXfs":
                case "<cellXfs>":
                case "<cellXfs/>":
                case "</cellXfs>":
                    break;
                case "<xf":
                case "<xf/>":
                    for(delete (i = t)[0], r = 0; r < go.length; ++r)i[go[r]] && (i[go[r]] = parseInt(i[go[r]], 10));
                    for(r = 0; r < bo.length; ++r)i[bo[r]] && (i[bo[r]] = Rt(i[bo[r]]));
                    if (n.NumberFmt && 392 < i.numFmtId) {
                        for(r = 392; 60 < r; --r)if (n.NumberFmt[i.numFmtId] == n.NumberFmt[r]) {
                            i.numFmtId = r;
                            break;
                        }
                    }
                    n.CellXf.push(i);
                    break;
                case "</xf>":
                    break;
                case "<alignment":
                case "<alignment/>":
                    var a = {};
                    t.vertical && (a.vertical = t.vertical), t.horizontal && (a.horizontal = t.horizontal), null != t.textRotation && (a.textRotation = t.textRotation), t.indent && (a.indent = t.indent), t.wrapText && (a.wrapText = Rt(t.wrapText)), i.alignment = a;
                    break;
                case "</alignment>":
                case "<protection":
                    break;
                case "</protection>":
                case "<protection/>":
                    break;
                case "<AlternateContent":
                    o = !0;
                    break;
                case "</AlternateContent>":
                    o = !1;
                    break;
                case "<extLst":
                case "<extLst>":
                case "</extLst>":
                    break;
                case "<ext":
                    o = !0;
                    break;
                case "</ext>":
                    o = !1;
                    break;
                default:
                    if (s && s.WTF && !o) throw new Error("unrecognized " + t[0] + " in cellXfs");
            }
        }))), c;
    });
    function _o(e, t) {
        if (void 0 !== yo) return yo.toXml();
        var r, a, n, s, i = [
            ot,
            Yt("styleSheet", null, {
                xmlns: Qt[0],
                "xmlns:vt": Zt.vt
            })
        ];
        return e.SSF && null != (a = e.SSF, n = [
            "<numFmts>"
        ], [
            [
                5,
                8
            ],
            [
                23,
                26
            ],
            [
                41,
                44
            ],
            [
                50,
                392
            ]
        ].forEach(function(e) {
            for(var t = e[0]; t <= e[1]; ++t)null != a[t] && (n[n.length] = Yt("numFmt", null, {
                numFmtId: t,
                formatCode: kt(a[t])
            }));
        }), r = 1 === n.length ? "" : (n[n.length] = "</numFmts>", n[0] = Yt("numFmts", null, {
            count: n.length - 2
        }).replace("/>", ">"), n.join(""))) && (i[i.length] = r), i[i.length] = '<fonts count="1"><font><sz val="12"/><color theme="1"/><name val="Calibri"/><family val="2"/><scheme val="minor"/></font></fonts>', i[i.length] = '<fills count="2"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill></fills>', i[i.length] = '<borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders>', i[i.length] = '<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>', t = t.cellXfs, (s = [])[s.length] = "<cellXfs/>", t.forEach(function(e) {
            s[s.length] = Yt("xf", null, e);
        }), s[s.length] = "</cellXfs>", (r = 2 === s.length ? "" : (s[0] = Yt("cellXfs", null, {
            count: s.length - 2
        }).replace("/>", ">"), s.join(""))) && (i[i.length] = r), i[i.length] = '<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>', i[i.length] = '<dxfs count="0"/>', i[i.length] = '<tableStyles count="0" defaultTableStyle="TableStyleMedium9" defaultPivotStyle="PivotStyleMedium4"/>', 2 < i.length && (i[i.length] = "</styleSheet>", i[1] = i[1].replace("/>", ">")), i.join("");
    }
    function xo(e, t) {
        var r;
        (t = t || Lr(153)).write_shift(2, 20 * e.sz), r = e, a = (a = t) || Lr(2), r = (r.italic ? 2 : 0) | (r.strike ? 8 : 0) | (r.outline ? 16 : 0) | (r.shadow ? 32 : 0) | (r.condense ? 64 : 0) | (r.extend ? 128 : 0), a.write_shift(1, r), a.write_shift(1, 0), t.write_shift(2, e.bold ? 700 : 400);
        var a = 0;
        "superscript" == e.vertAlign ? a = 1 : "subscript" == e.vertAlign && (a = 2), t.write_shift(2, a), t.write_shift(1, e.underline || 0), t.write_shift(1, e.family || 0), t.write_shift(1, e.charset || 0), t.write_shift(1, 0), Ca(e.color, t);
        a = 0;
        return "major" == e.scheme && (a = 1), "minor" == e.scheme && (a = 2), t.write_shift(1, a), ia(e.name, t), t.length > t.l ? t.slice(0, t.l) : t;
    }
    var Ao, Co = [
        "none",
        "solid",
        "mediumGray",
        "darkGray",
        "lightGray",
        "darkHorizontal",
        "darkVertical",
        "darkDown",
        "darkUp",
        "darkGrid",
        "darkTrellis",
        "lightHorizontal",
        "lightVertical",
        "lightDown",
        "lightUp",
        "lightGrid",
        "lightTrellis",
        "gray125",
        "gray0625"
    ], Ro = Pr;
    function Oo(e, t) {
        t = t || Lr(84);
        e = (Ao = Ao || Ie(Co))[e.patternType];
        null == e && (e = 40), t.write_shift(4, e);
        var r = 0;
        if (40 != e) for(Ca({
            auto: 1
        }, t), Ca({
            auto: 1
        }, t); r < 12; ++r)t.write_shift(4, 0);
        else {
            for(; r < 4; ++r)t.write_shift(4, 0);
            for(; r < 12; ++r)t.write_shift(4, 0);
        }
        return t.length > t.l ? t.slice(0, t.l) : t;
    }
    function Io(e, t, r) {
        (r = r || Lr(16)).write_shift(2, t || 0), r.write_shift(2, e.numFmtId || 0), r.write_shift(2, 0), r.write_shift(2, 0), r.write_shift(2, 0), r.write_shift(1, 0), r.write_shift(1, 0);
        return r.write_shift(1, 0), r.write_shift(1, 0), r.write_shift(1, 0), r.write_shift(1, 0), r;
    }
    function No(e, t) {
        return (t = t || Lr(10)).write_shift(1, 0), t.write_shift(1, 0), t.write_shift(4, 0), t.write_shift(4, 0), t;
    }
    r = Pr;
    function Fo(s, i) {
        var r;
        i && (r = 0, [
            [
                5,
                8
            ],
            [
                23,
                26
            ],
            [
                41,
                44
            ],
            [
                50,
                392
            ]
        ].forEach(function(e) {
            for(var t = e[0]; t <= e[1]; ++t)null != i[t] && ++r;
        }), 0 != r && (Br(s, 615, na(r)), [
            [
                5,
                8
            ],
            [
                23,
                26
            ],
            [
                41,
                44
            ],
            [
                50,
                392
            ]
        ].forEach(function(e) {
            for(var t, r, a, n = e[0]; n <= e[1]; ++n)null != i[n] && Br(s, 44, (t = n, r = i[n], (a = (a = void 0, Lr(6 + 4 * r.length))).write_shift(2, t), ia(r, a), r = a.length > a.l ? a.slice(0, a.l) : a, null == a.l && (a.l = a.length), r));
        }), Br(s, 616)));
    }
    function Do(e) {
        var t;
        Br(e, 613, na(1)), Br(e, 46, ((t = t || Lr(51)).write_shift(1, 0), No(0, t), No(0, t), No(0, t), No(0, t), No(0, t), t.length > t.l ? t.slice(0, t.l) : t)), Br(e, 614);
    }
    function Po(e) {
        var t, r;
        Br(e, 619, na(1)), Br(e, 48, (t = {
            xfId: 0,
            builtinId: 0,
            name: "Normal"
        }, (r = r || Lr(52)).write_shift(4, t.xfId), r.write_shift(2, 1), r.write_shift(1, +t.builtinId), r.write_shift(1, 0), ba(t.name || "", r), r.length > r.l ? r.slice(0, r.l) : r)), Br(e, 620);
    }
    function Lo(e) {
        var t, r, a, n;
        Br(e, 508, (t = 0, r = "TableStyleMedium9", a = "PivotStyleMedium4", (n = Lr(2052)).write_shift(4, t), ba(r, n), ba(a, n), n.length > n.l ? n.slice(0, n.l) : n)), Br(e, 509);
    }
    function Mo(e, t) {
        var r, a = Ur();
        return Br(a, 278), Fo(a, e.SSF), Br(e = a, 611, na(1)), Br(e, 43, xo({
            sz: 12,
            color: {
                theme: 1
            },
            name: "Calibri",
            family: 2,
            scheme: "minor"
        })), Br(e, 612), Br(e = a, 603, na(2)), Br(e, 45, Oo({
            patternType: "none"
        })), Br(e, 45, Oo({
            patternType: "gray125"
        })), Br(e, 604), Do(a), Br(e = a, 626, na(1)), Br(e, 47, Io({
            numFmtId: 0,
            fontId: 0,
            fillId: 0,
            borderId: 0
        }, 65535)), Br(e, 627), r = a, t = t.cellXfs, Br(r, 617, na(t.length)), t.forEach(function(e) {
            Br(r, 47, Io(e, 0));
        }), Br(r, 618), Po(a), Br(t = a, 505, na(0)), Br(t, 506), Lo(a), Br(a, 279), a.end();
    }
    var Uo = [
        "</a:lt1>",
        "</a:dk1>",
        "</a:lt2>",
        "</a:dk2>",
        "</a:accent1>",
        "</a:accent2>",
        "</a:accent3>",
        "</a:accent4>",
        "</a:accent5>",
        "</a:accent6>",
        "</a:hlink>",
        "</a:folHlink>"
    ];
    function Bo(e, r, a) {
        r.themeElements.clrScheme = [];
        var n = {};
        (e[0].match(ft) || []).forEach(function(e) {
            var t = dt(e);
            switch(t[0]){
                case "<a:clrScheme":
                case "</a:clrScheme>":
                    break;
                case "<a:srgbClr":
                    n.rgb = t.val;
                    break;
                case "<a:sysClr":
                    n.rgb = t.lastClr;
                    break;
                case "<a:dk1>":
                case "</a:dk1>":
                case "<a:lt1>":
                case "</a:lt1>":
                case "<a:dk2>":
                case "</a:dk2>":
                case "<a:lt2>":
                case "</a:lt2>":
                case "<a:accent1>":
                case "</a:accent1>":
                case "<a:accent2>":
                case "</a:accent2>":
                case "<a:accent3>":
                case "</a:accent3>":
                case "<a:accent4>":
                case "</a:accent4>":
                case "<a:accent5>":
                case "</a:accent5>":
                case "<a:accent6>":
                case "</a:accent6>":
                case "<a:hlink>":
                case "</a:hlink>":
                case "<a:folHlink>":
                case "</a:folHlink>":
                    "/" === t[0].charAt(1) ? (r.themeElements.clrScheme[Uo.indexOf(t[0])] = n, n = {}) : n.name = t[0].slice(3, t[0].length - 1);
                    break;
                default:
                    if (a && a.WTF) throw new Error("Unrecognized " + t[0] + " in clrScheme");
            }
        });
    }
    function Wo() {}
    function Ho() {}
    var zo = /<a:clrScheme([^>]*)>[\s\S]*<\/a:clrScheme>/, Vo = /<a:fontScheme([^>]*)>[\s\S]*<\/a:fontScheme>/, Go = /<a:fmtScheme([^>]*)>[\s\S]*<\/a:fmtScheme>/;
    var jo = /<a:themeElements([^>]*)>[\s\S]*<\/a:themeElements>/;
    function $o(e, t) {
        var r, a, n, s, i, o = {};
        if (!(r = (e = !e || 0 === e.length ? Xo() : e).match(jo))) throw new Error("themeElements not found in theme");
        return a = r[0], s = t, (n = o).themeElements = {}, [
            [
                "clrScheme",
                zo,
                Bo
            ],
            [
                "fontScheme",
                Vo,
                Wo
            ],
            [
                "fmtScheme",
                Go,
                Ho
            ]
        ].forEach(function(e) {
            if (!(i = a.match(e[1]))) throw new Error(e[0] + " not found in themeElements");
            e[2](i, n, s);
        }), o.raw = e, o;
    }
    function Xo(e, t) {
        if (t && t.themeXLSX) return t.themeXLSX;
        if (e && "string" == typeof e.raw) return e.raw;
        e = [
            ot
        ];
        return e[e.length] = '<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme">', e[e.length] = "<a:themeElements>", e[e.length] = '<a:clrScheme name="Office">', e[e.length] = '<a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1>', e[e.length] = '<a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1>', e[e.length] = '<a:dk2><a:srgbClr val="1F497D"/></a:dk2>', e[e.length] = '<a:lt2><a:srgbClr val="EEECE1"/></a:lt2>', e[e.length] = '<a:accent1><a:srgbClr val="4F81BD"/></a:accent1>', e[e.length] = '<a:accent2><a:srgbClr val="C0504D"/></a:accent2>', e[e.length] = '<a:accent3><a:srgbClr val="9BBB59"/></a:accent3>', e[e.length] = '<a:accent4><a:srgbClr val="8064A2"/></a:accent4>', e[e.length] = '<a:accent5><a:srgbClr val="4BACC6"/></a:accent5>', e[e.length] = '<a:accent6><a:srgbClr val="F79646"/></a:accent6>', e[e.length] = '<a:hlink><a:srgbClr val="0000FF"/></a:hlink>', e[e.length] = '<a:folHlink><a:srgbClr val="800080"/></a:folHlink>', e[e.length] = "</a:clrScheme>", e[e.length] = '<a:fontScheme name="Office">', e[e.length] = "<a:majorFont>", e[e.length] = '<a:latin typeface="Cambria"/>', e[e.length] = '<a:ea typeface=""/>', e[e.length] = '<a:cs typeface=""/>', e[e.length] = '<a:font script="Jpan" typeface="\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF"/>', e[e.length] = '<a:font script="Hang" typeface="\uB9D1\uC740 \uACE0\uB515"/>', e[e.length] = '<a:font script="Hans" typeface="\u5B8B\u4F53"/>', e[e.length] = '<a:font script="Hant" typeface="\u65B0\u7D30\u660E\u9AD4"/>', e[e.length] = '<a:font script="Arab" typeface="Times New Roman"/>', e[e.length] = '<a:font script="Hebr" typeface="Times New Roman"/>', e[e.length] = '<a:font script="Thai" typeface="Tahoma"/>', e[e.length] = '<a:font script="Ethi" typeface="Nyala"/>', e[e.length] = '<a:font script="Beng" typeface="Vrinda"/>', e[e.length] = '<a:font script="Gujr" typeface="Shruti"/>', e[e.length] = '<a:font script="Khmr" typeface="MoolBoran"/>', e[e.length] = '<a:font script="Knda" typeface="Tunga"/>', e[e.length] = '<a:font script="Guru" typeface="Raavi"/>', e[e.length] = '<a:font script="Cans" typeface="Euphemia"/>', e[e.length] = '<a:font script="Cher" typeface="Plantagenet Cherokee"/>', e[e.length] = '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>', e[e.length] = '<a:font script="Tibt" typeface="Microsoft Himalaya"/>', e[e.length] = '<a:font script="Thaa" typeface="MV Boli"/>', e[e.length] = '<a:font script="Deva" typeface="Mangal"/>', e[e.length] = '<a:font script="Telu" typeface="Gautami"/>', e[e.length] = '<a:font script="Taml" typeface="Latha"/>', e[e.length] = '<a:font script="Syrc" typeface="Estrangelo Edessa"/>', e[e.length] = '<a:font script="Orya" typeface="Kalinga"/>', e[e.length] = '<a:font script="Mlym" typeface="Kartika"/>', e[e.length] = '<a:font script="Laoo" typeface="DokChampa"/>', e[e.length] = '<a:font script="Sinh" typeface="Iskoola Pota"/>', e[e.length] = '<a:font script="Mong" typeface="Mongolian Baiti"/>', e[e.length] = '<a:font script="Viet" typeface="Times New Roman"/>', e[e.length] = '<a:font script="Uigh" typeface="Microsoft Uighur"/>', e[e.length] = '<a:font script="Geor" typeface="Sylfaen"/>', e[e.length] = "</a:majorFont>", e[e.length] = "<a:minorFont>", e[e.length] = '<a:latin typeface="Calibri"/>', e[e.length] = '<a:ea typeface=""/>', e[e.length] = '<a:cs typeface=""/>', e[e.length] = '<a:font script="Jpan" typeface="\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF"/>', e[e.length] = '<a:font script="Hang" typeface="\uB9D1\uC740 \uACE0\uB515"/>', e[e.length] = '<a:font script="Hans" typeface="\u5B8B\u4F53"/>', e[e.length] = '<a:font script="Hant" typeface="\u65B0\u7D30\u660E\u9AD4"/>', e[e.length] = '<a:font script="Arab" typeface="Arial"/>', e[e.length] = '<a:font script="Hebr" typeface="Arial"/>', e[e.length] = '<a:font script="Thai" typeface="Tahoma"/>', e[e.length] = '<a:font script="Ethi" typeface="Nyala"/>', e[e.length] = '<a:font script="Beng" typeface="Vrinda"/>', e[e.length] = '<a:font script="Gujr" typeface="Shruti"/>', e[e.length] = '<a:font script="Khmr" typeface="DaunPenh"/>', e[e.length] = '<a:font script="Knda" typeface="Tunga"/>', e[e.length] = '<a:font script="Guru" typeface="Raavi"/>', e[e.length] = '<a:font script="Cans" typeface="Euphemia"/>', e[e.length] = '<a:font script="Cher" typeface="Plantagenet Cherokee"/>', e[e.length] = '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>', e[e.length] = '<a:font script="Tibt" typeface="Microsoft Himalaya"/>', e[e.length] = '<a:font script="Thaa" typeface="MV Boli"/>', e[e.length] = '<a:font script="Deva" typeface="Mangal"/>', e[e.length] = '<a:font script="Telu" typeface="Gautami"/>', e[e.length] = '<a:font script="Taml" typeface="Latha"/>', e[e.length] = '<a:font script="Syrc" typeface="Estrangelo Edessa"/>', e[e.length] = '<a:font script="Orya" typeface="Kalinga"/>', e[e.length] = '<a:font script="Mlym" typeface="Kartika"/>', e[e.length] = '<a:font script="Laoo" typeface="DokChampa"/>', e[e.length] = '<a:font script="Sinh" typeface="Iskoola Pota"/>', e[e.length] = '<a:font script="Mong" typeface="Mongolian Baiti"/>', e[e.length] = '<a:font script="Viet" typeface="Arial"/>', e[e.length] = '<a:font script="Uigh" typeface="Microsoft Uighur"/>', e[e.length] = '<a:font script="Geor" typeface="Sylfaen"/>', e[e.length] = "</a:minorFont>", e[e.length] = "</a:fontScheme>", e[e.length] = '<a:fmtScheme name="Office">', e[e.length] = "<a:fillStyleLst>", e[e.length] = '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>', e[e.length] = '<a:gradFill rotWithShape="1">', e[e.length] = "<a:gsLst>", e[e.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs>', e[e.length] = '<a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs>', e[e.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="350000"/></a:schemeClr></a:gs>', e[e.length] = "</a:gsLst>", e[e.length] = '<a:lin ang="16200000" scaled="1"/>', e[e.length] = "</a:gradFill>", e[e.length] = '<a:gradFill rotWithShape="1">', e[e.length] = "<a:gsLst>", e[e.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="100000"/><a:shade val="100000"/><a:satMod val="130000"/></a:schemeClr></a:gs>', e[e.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="50000"/><a:shade val="100000"/><a:satMod val="350000"/></a:schemeClr></a:gs>', e[e.length] = "</a:gsLst>", e[e.length] = '<a:lin ang="16200000" scaled="0"/>', e[e.length] = "</a:gradFill>", e[e.length] = "</a:fillStyleLst>", e[e.length] = "<a:lnStyleLst>", e[e.length] = '<a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"><a:shade val="95000"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln>', e[e.length] = '<a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>', e[e.length] = '<a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>', e[e.length] = "</a:lnStyleLst>", e[e.length] = "<a:effectStyleLst>", e[e.length] = "<a:effectStyle>", e[e.length] = "<a:effectLst>", e[e.length] = '<a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw>', e[e.length] = "</a:effectLst>", e[e.length] = "</a:effectStyle>", e[e.length] = "<a:effectStyle>", e[e.length] = "<a:effectLst>", e[e.length] = '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>', e[e.length] = "</a:effectLst>", e[e.length] = "</a:effectStyle>", e[e.length] = "<a:effectStyle>", e[e.length] = "<a:effectLst>", e[e.length] = '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>', e[e.length] = "</a:effectLst>", e[e.length] = '<a:scene3d><a:camera prst="orthographicFront"><a:rot lat="0" lon="0" rev="0"/></a:camera><a:lightRig rig="threePt" dir="t"><a:rot lat="0" lon="0" rev="1200000"/></a:lightRig></a:scene3d>', e[e.length] = '<a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d>', e[e.length] = "</a:effectStyle>", e[e.length] = "</a:effectStyleLst>", e[e.length] = "<a:bgFillStyleLst>", e[e.length] = '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>', e[e.length] = '<a:gradFill rotWithShape="1">', e[e.length] = "<a:gsLst>", e[e.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs>', e[e.length] = '<a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs>', e[e.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs>', e[e.length] = "</a:gsLst>", e[e.length] = '<a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path>', e[e.length] = "</a:gradFill>", e[e.length] = '<a:gradFill rotWithShape="1">', e[e.length] = "<a:gsLst>", e[e.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="300000"/></a:schemeClr></a:gs>', e[e.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="30000"/><a:satMod val="200000"/></a:schemeClr></a:gs>', e[e.length] = "</a:gsLst>", e[e.length] = '<a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path>', e[e.length] = "</a:gradFill>", e[e.length] = "</a:bgFillStyleLst>", e[e.length] = "</a:fmtScheme>", e[e.length] = "</a:themeElements>", e[e.length] = "<a:objectDefaults>", e[e.length] = "<a:spDef>", e[e.length] = '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="1"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="3"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="2"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="lt1"/></a:fontRef></a:style>', e[e.length] = "</a:spDef>", e[e.length] = "<a:lnDef>", e[e.length] = '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="2"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="0"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="1"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="tx1"/></a:fontRef></a:style>', e[e.length] = "</a:lnDef>", e[e.length] = "</a:objectDefaults>", e[e.length] = "<a:extraClrSchemeLst/>", e[e.length] = "</a:theme>", e.join("");
    }
    function Yo(e) {
        var t = {};
        switch(t.xclrType = e.read_shift(2), t.nTintShade = e.read_shift(2), t.xclrType){
            case 0:
                e.l += 4;
                break;
            case 1:
                t.xclrValue = Pr(e, 4);
                break;
            case 2:
                t.xclrValue = Gn(e);
                break;
            case 3:
                t.xclrValue = e.read_shift(4);
                break;
            case 4:
                e.l += 4;
        }
        return e.l += 8, t;
    }
    function Ko(e) {
        var t = e.read_shift(2), r = e.read_shift(2) - 4, a = [
            t
        ];
        switch(t){
            case 4:
            case 5:
            case 7:
            case 8:
            case 9:
            case 10:
            case 11:
            case 13:
                a[1] = Yo(e);
                break;
            case 6:
                a[1] = Pr(e, r);
                break;
            case 14:
            case 15:
                a[1] = e.read_shift(1 == r ? 1 : 2);
                break;
            default:
                throw new Error("Unrecognized ExtProp type: " + t + " " + r);
        }
        return a;
    }
    function Jo() {
        var e, t, r, a = Ur();
        return Br(a, 332), Br(a, 334, na(1)), Br(a, 335, ((r = Lr(12 + 2 * (t = {
            name: "XLDAPR",
            version: 12e4,
            flags: 3496657072
        }).name.length)).write_shift(4, t.flags), r.write_shift(4, t.version), ia(t.name, r), r.slice(0, r.l))), Br(a, 336), Br(a, 339, (e = 1, (r = Lr(8 + 2 * (t = "XLDAPR").length)).write_shift(4, e), ia(t, r), r.slice(0, r.l))), Br(a, 52), Br(a, 35, na(514)), Br(a, 4096, na(0)), Br(a, 4097, Fn(1)), Br(a, 36), Br(a, 53), Br(a, 340), Br(a, 337, (e = 1, t = !0, (r = Lr(8)).write_shift(4, e), r.write_shift(4, t ? 1 : 0), r)), Br(a, 51, function(e) {
            var t = Lr(4 + 8 * e.length);
            t.write_shift(4, e.length);
            for(var r = 0; r < e.length; ++r)t.write_shift(4, e[r][0]), t.write_shift(4, e[r][1]);
            return t;
        }([
            [
                1,
                0
            ]
        ])), Br(a, 338), Br(a, 333), a.end();
    }
    function qo() {
        var e = [
            ot
        ];
        return e.push('<metadata xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:xlrd="http://schemas.microsoft.com/office/spreadsheetml/2017/richdata" xmlns:xda="http://schemas.microsoft.com/office/spreadsheetml/2017/dynamicarray">\n  <metadataTypes count="1">\n    <metadataType name="XLDAPR" minSupportedVersion="120000" copy="1" pasteAll="1" pasteValues="1" merge="1" splitFirst="1" rowColShift="1" clearFormats="1" clearComments="1" assign="1" coerce="1" cellMeta="1"/>\n  </metadataTypes>\n  <futureMetadata name="XLDAPR" count="1">\n    <bk>\n      <extLst>\n        <ext uri="{bdbb8cdc-fa1e-496e-a857-3c3f30c029c3}">\n          <xda:dynamicArrayProperties fDynamic="1" fCollapsed="0"/>\n        </ext>\n      </extLst>\n    </bk>\n  </futureMetadata>\n  <cellMetadata count="1">\n    <bk>\n      <rc t="1" v="0"/>\n    </bk>\n  </cellMetadata>\n</metadata>'), e.join("");
    }
    var Zo = 1024;
    function Qo(e, t) {
        for(var r = [
            21600,
            21600
        ], a = [
            "m0,0l0",
            r[1],
            r[0],
            r[1],
            r[0],
            "0xe"
        ].join(","), n = [
            Yt("xml", null, {
                "xmlns:v": er.v,
                "xmlns:o": er.o,
                "xmlns:x": er.x,
                "xmlns:mv": er.mv
            }).replace(/\/>/, ">"),
            Yt("o:shapelayout", Yt("o:idmap", null, {
                "v:ext": "edit",
                data: e
            }), {
                "v:ext": "edit"
            }),
            Yt("v:shapetype", [
                Yt("v:stroke", null, {
                    joinstyle: "miter"
                }),
                Yt("v:path", null, {
                    gradientshapeok: "t",
                    "o:connecttype": "rect"
                })
            ].join(""), {
                id: "_x0000_t202",
                "o:spt": 202,
                coordsize: r.join(","),
                path: a
            })
        ]; Zo < 1e3 * e;)Zo += 1e3;
        return t.forEach(function(e) {
            var t = Yr(e[0]), r = {
                color2: "#BEFF82",
                type: "gradient"
            };
            "gradient" == r.type && (r.angle = "-180");
            var a = "gradient" == r.type ? Yt("o:fill", null, {
                type: "gradientUnscaled",
                "v:ext": "view"
            }) : null, r = Yt("v:fill", a, r);
            ++Zo, n = n.concat([
                "<v:shape" + Xt({
                    id: "_x0000_s" + Zo,
                    type: "#_x0000_t202",
                    style: "position:absolute; margin-left:80pt;margin-top:5pt;width:104pt;height:64pt;z-index:10" + (e[1].hidden ? ";visibility:hidden" : ""),
                    fillcolor: "#ECFAD4",
                    strokecolor: "#edeaa1"
                }) + ">",
                r,
                Yt("v:shadow", null, {
                    on: "t",
                    obscured: "t"
                }),
                Yt("v:path", null, {
                    "o:connecttype": "none"
                }),
                '<v:textbox><div style="text-align:left"></div></v:textbox>',
                '<x:ClientData ObjectType="Note">',
                "<x:MoveWithCells/>",
                "<x:SizeWithCells/>",
                $t("x:Anchor", [
                    t.c + 1,
                    0,
                    t.r + 1,
                    0,
                    t.c + 3,
                    20,
                    t.r + 5,
                    20
                ].join(",")),
                $t("x:AutoFill", "False"),
                $t("x:Row", String(t.r)),
                $t("x:Column", String(t.c)),
                e[1].hidden ? "" : "<x:Visible/>",
                "</x:ClientData>",
                "</v:shape>"
            ]);
        }), n.push("</xml>"), n.join("");
    }
    function ec(s, e, i, o) {
        var c, l = Array.isArray(s);
        e.forEach(function(e) {
            var t, r = Yr(e.ref);
            (c = l ? (s[r.r] || (s[r.r] = []), s[r.r][r.c]) : s[e.ref]) || (c = {
                t: "z"
            }, l ? s[r.r][r.c] = c : s[e.ref] = c, (t = Zr(s["!ref"] || "BDWGO1000001:A1")).s.r > r.r && (t.s.r = r.r), t.e.r < r.r && (t.e.r = r.r), t.s.c > r.c && (t.s.c = r.c), t.e.c < r.c && (t.e.c = r.c), (t = qr(t)) !== s["!ref"] && (s["!ref"] = t)), c.c || (c.c = []);
            var a = {
                a: e.author,
                t: e.t,
                r: e.r,
                T: i
            };
            e.h && (a.h = e.h);
            for(var n = c.c.length - 1; 0 <= n; --n){
                if (!i && c.c[n].T) return;
                i && !c.c[n].T && c.c.splice(n, 1);
            }
            if (i && o) {
                for(n = 0; n < o.length; ++n)if (a.a == o[n].id) {
                    a.a = o[n].name || a.a;
                    break;
                }
            }
            c.c.push(a);
        });
    }
    function tc(e) {
        var s = [
            ot,
            Yt("comments", null, {
                xmlns: Qt[0]
            })
        ], i = [];
        return s.push("<authors>"), e.forEach(function(e) {
            e[1].forEach(function(e) {
                var t = kt(e.a);
                -1 == i.indexOf(t) && (i.push(t), s.push("<author>" + t + "</author>")), e.T && e.ID && -1 == i.indexOf("tc=" + e.ID) && (i.push("tc=" + e.ID), s.push("<author>tc=" + e.ID + "</author>"));
            });
        }), 0 == i.length && (i.push("SheetJ5"), s.push("<author>SheetJ5</author>")), s.push("</authors>"), s.push("<commentList>"), e.forEach(function(e) {
            var t = 0, r = [];
            if (e[1][0] && e[1][0].T && e[1][0].ID ? t = i.indexOf("tc=" + e[1][0].ID) : e[1].forEach(function(e) {
                e.a && (t = i.indexOf(kt(e.a))), r.push(e.t || "");
            }), s.push('<comment ref="' + e[0] + '" authorId="' + t + '"><text>'), r.length <= 1) s.push($t("t", kt(r[0] || "")));
            else {
                for(var a = "Comment:\n    " + r[0] + "\n", n = 1; n < r.length; ++n)a += "Reply:\n    " + r[n] + "\n";
                s.push($t("t", kt(a)));
            }
            s.push("</text></comment>");
        }), s.push("</commentList>"), 2 < s.length && (s[s.length] = "</comments>", s[1] = s[1].replace("/>", ">")), s.join("");
    }
    Ue = sa;
    function rc(e) {
        var n = Ur(), s = [];
        return Br(n, 628), Br(n, 630), e.forEach(function(e) {
            e[1].forEach(function(e) {
                -1 < s.indexOf(e.a) || (s.push(e.a.slice(0, 54)), Br(n, 632, ia(e.a.slice(0, 54))));
            });
        }), Br(n, 631), Br(n, 633), e.forEach(function(a) {
            a[1].forEach(function(e) {
                e.iauthor = s.indexOf(e.a);
                var t, r = {
                    s: Yr(a[0]),
                    e: Yr(a[0])
                };
                Br(n, 635, (r = [
                    r,
                    e
                ], (t = null == t ? Lr(36) : t).write_shift(4, r[1].iauthor), _a(r[0], t), t.write_shift(4, 0), t.write_shift(4, 0), t.write_shift(4, 0), t.write_shift(4, 0), t)), e.t && 0 < e.t.length && Br(n, 637, la(e)), Br(n, 636), delete e.iauthor;
            });
        }), Br(n, 634), Br(n, 629), n.end();
    }
    var ac = "application/vnd.ms-office.vbaProject";
    var nc = [
        "xlsb",
        "xlsm",
        "xlam",
        "biff8",
        "xla"
    ];
    var sc, ic, oc = (ic = /(^|[^A-Za-z_])R(\[?-?\d+\]|[1-9]\d*|)C(\[?-?\d+\]|[1-9]\d*|)(?![A-Za-z0-9_])/g, function(e, t) {
        return sc = t, e.replace(ic, cc);
    });
    function cc(e, t, r, a) {
        var n = !1, s = !1;
        0 == r.length ? s = !0 : "[" == r.charAt(0) && (s = !0, r = r.slice(1, -1)), 0 == a.length ? n = !0 : "[" == a.charAt(0) && (n = !0, a = a.slice(1, -1));
        r = 0 < r.length ? 0 | parseInt(r, 10) : 0, a = 0 < a.length ? 0 | parseInt(a, 10) : 0;
        return n ? a += sc.c : --a, s ? r += sc.r : --r, t + (n ? "" : "$") + Xr(a) + (s ? "" : "$") + jr(r);
    }
    var lc = /(^|[^._A-Z0-9])([$]?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])([$]?)(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})(?![_.\(A-Za-z0-9])/g, fc = function(e, i) {
        return e.replace(lc, function(e, t, r, a, n, s) {
            a = $r(a) - (r ? 0 : i.c), s = Gr(s) - (n ? 0 : i.r);
            return t + "R" + (0 == s ? "" : n ? 1 + s : "[" + s + "]") + "C" + (0 == a ? "" : r ? 1 + a : "[" + a + "]");
        });
    };
    function hc(e, i) {
        return e.replace(lc, function(e, t, r, a, n, s) {
            return t + ("$" == r ? r + a : Xr($r(a) + i.c)) + ("$" == n ? n + s : jr(Gr(s) + i.r));
        });
    }
    function uc(e) {
        return e.replace(/_xlfn\./g, "");
    }
    function dc(e) {
        e.l += 1;
    }
    function pc(e, t) {
        t = e.read_shift(1 == t ? 1 : 2);
        return [
            16383 & t,
            t >> 14 & 1,
            t >> 15 & 1
        ];
    }
    function mc(e, t, r) {
        var a = 2;
        if (r) {
            if (2 <= r.biff && r.biff <= 5) return gc(e);
            12 == r.biff && (a = 4);
        }
        var n = e.read_shift(a), r = e.read_shift(a), a = pc(e, 2), e = pc(e, 2);
        return {
            s: {
                r: n,
                c: a[0],
                cRel: a[1],
                rRel: a[2]
            },
            e: {
                r: r,
                c: e[0],
                cRel: e[1],
                rRel: e[2]
            }
        };
    }
    function gc(e) {
        var t = pc(e, 2), r = pc(e, 2), a = e.read_shift(1), e = e.read_shift(1);
        return {
            s: {
                r: t[0],
                c: a,
                cRel: t[1],
                rRel: t[2]
            },
            e: {
                r: r[0],
                c: e,
                cRel: r[1],
                rRel: r[2]
            }
        };
    }
    function bc(e, t, r) {
        if (r && 2 <= r.biff && r.biff <= 5) return n = pc(a = e, 2), a = a.read_shift(1), {
            r: n[0],
            c: a,
            cRel: n[1],
            rRel: n[2]
        };
        var a, n, r = e.read_shift(r && 12 == r.biff ? 4 : 2), e = pc(e, 2);
        return {
            r: r,
            c: e[0],
            cRel: e[1],
            rRel: e[2]
        };
    }
    function vc(e, t, r) {
        r = r && r.biff ? r.biff : 8;
        if (2 <= r && r <= 5) return function(e) {
            var t = e.read_shift(2), r = e.read_shift(1), a = (32768 & t) >> 15, e = (16384 & t) >> 14;
            t &= 16383, 1 == a && 8192 <= t && (t -= 16384);
            1 == e && 128 <= r && (r -= 256);
            return {
                r: t,
                c: r,
                cRel: e,
                rRel: a
            };
        }(e);
        var a = e.read_shift(12 <= r ? 4 : 2), n = e.read_shift(2), r = (16384 & n) >> 14, e = (32768 & n) >> 15;
        if (n &= 16383, 1 == e) for(; 524287 < a;)a -= 1048576;
        if (1 == r) for(; 8191 < n;)n -= 16384;
        return {
            r: a,
            c: n,
            cRel: r,
            rRel: e
        };
    }
    function wc(e) {
        var t = 1 & e[e.l + 1];
        return e.l += 4, [
            t,
            1
        ];
    }
    function Tc(e) {
        return [
            e.read_shift(1),
            e.read_shift(1)
        ];
    }
    function Ec(e, t, r) {
        var a = 0, n = 0;
        12 == r.biff ? (a = e.read_shift(4), n = e.read_shift(4)) : (n = 1 + e.read_shift(1), a = 1 + e.read_shift(2)), 2 <= r.biff && r.biff < 8 && (--a, 0 == --n && (n = 256));
        for(var s = 0, i = []; s != a && (i[s] = []); ++s)for(var o = 0; o != n; ++o)i[s][o] = function(e, t) {
            var r = [
                e.read_shift(1)
            ];
            if (12 == t) switch(r[0]){
                case 2:
                    r[0] = 4;
                    break;
                case 4:
                    r[0] = 16;
                    break;
                case 0:
                    r[0] = 1;
                    break;
                case 1:
                    r[0] = 2;
            }
            switch(r[0]){
                case 4:
                    r[1] = On(e, 1) ? "TRUE" : "FALSE", 12 != t && (e.l += 7);
                    break;
                case 37:
                case 16:
                    r[1] = Wa[e[e.l]], e.l += 12 == t ? 4 : 8;
                    break;
                case 0:
                    e.l += 8;
                    break;
                case 1:
                    r[1] = xa(e);
                    break;
                case 2:
                    r[1] = Bn(e, 0, {
                        biff: 0 < t && t < 8 ? 2 : t
                    });
                    break;
                default:
                    throw new Error("Bad SerAr: " + r[0]);
            }
            return r;
        }(e, r.biff);
        return i;
    }
    function kc(e, t, r) {
        var a;
        return e.l += 2, [
            (e = (a = e).read_shift(2), a = a.read_shift(2), {
                r: e,
                c: 255 & a,
                fQuoted: !!(16384 & a),
                cRel: a >> 15,
                rRel: a >> 15
            })
        ];
    }
    function yc(e) {
        return e.l += 6, [];
    }
    function Sc(e) {
        return e.l += 2, [
            Nn(e),
            1 & e.read_shift(2)
        ];
    }
    var _c = [
        "Data",
        "All",
        "Headers",
        "??",
        "?Data2",
        "??",
        "?DataHeaders",
        "??",
        "Totals",
        "??",
        "??",
        "??",
        "?DataTotals",
        "??",
        "??",
        "??",
        "?Current"
    ];
    var xc = {
        1: {
            n: "PtgExp",
            f: function(e, t, r) {
                return e.l++, r && 12 == r.biff ? [
                    e.read_shift(4, "i"),
                    0
                ] : [
                    e.read_shift(2),
                    e.read_shift(r && 2 == r.biff ? 1 : 2)
                ];
            }
        },
        2: {
            n: "PtgTbl",
            f: Pr
        },
        3: {
            n: "PtgAdd",
            f: dc
        },
        4: {
            n: "PtgSub",
            f: dc
        },
        5: {
            n: "PtgMul",
            f: dc
        },
        6: {
            n: "PtgDiv",
            f: dc
        },
        7: {
            n: "PtgPower",
            f: dc
        },
        8: {
            n: "PtgConcat",
            f: dc
        },
        9: {
            n: "PtgLt",
            f: dc
        },
        10: {
            n: "PtgLe",
            f: dc
        },
        11: {
            n: "PtgEq",
            f: dc
        },
        12: {
            n: "PtgGe",
            f: dc
        },
        13: {
            n: "PtgGt",
            f: dc
        },
        14: {
            n: "PtgNe",
            f: dc
        },
        15: {
            n: "PtgIsect",
            f: dc
        },
        16: {
            n: "PtgUnion",
            f: dc
        },
        17: {
            n: "PtgRange",
            f: dc
        },
        18: {
            n: "PtgUplus",
            f: dc
        },
        19: {
            n: "PtgUminus",
            f: dc
        },
        20: {
            n: "PtgPercent",
            f: dc
        },
        21: {
            n: "PtgParen",
            f: dc
        },
        22: {
            n: "PtgMissArg",
            f: dc
        },
        23: {
            n: "PtgStr",
            f: function(e, t, r) {
                return e.l++, Ln(e, 0, r);
            }
        },
        26: {
            n: "PtgSheet",
            f: function(e, t, r) {
                return e.l += 5, e.l += 2, e.l += 2 == r.biff ? 1 : 4, [
                    "PTGSHEET"
                ];
            }
        },
        27: {
            n: "PtgEndSheet",
            f: function(e, t, r) {
                return e.l += 2 == r.biff ? 4 : 5, [
                    "PTGENDSHEET"
                ];
            }
        },
        28: {
            n: "PtgErr",
            f: function(e) {
                return e.l++, Wa[e.read_shift(1)];
            }
        },
        29: {
            n: "PtgBool",
            f: function(e) {
                return e.l++, 0 !== e.read_shift(1);
            }
        },
        30: {
            n: "PtgInt",
            f: function(e) {
                return e.l++, e.read_shift(2);
            }
        },
        31: {
            n: "PtgNum",
            f: function(e) {
                return e.l++, xa(e);
            }
        },
        32: {
            n: "PtgArray",
            f: function(e, t, r) {
                var a = (96 & e[e.l++]) >> 5;
                return e.l += 2 == r.biff ? 6 : 12 == r.biff ? 14 : 7, [
                    a
                ];
            }
        },
        33: {
            n: "PtgFunc",
            f: function(e, t, r) {
                var a = (96 & e[e.l]) >> 5;
                return e.l += 1, r = e.read_shift(r && r.biff <= 3 ? 1 : 2), [
                    jc[r],
                    Gc[r],
                    a
                ];
            }
        },
        34: {
            n: "PtgFuncVar",
            f: function(e, t, r) {
                var a = e[e.l++], n = e.read_shift(1), s = r && r.biff <= 3 ? [
                    88 == a ? -1 : 0,
                    e.read_shift(1)
                ] : [
                    (s = e)[s.l + 1] >> 7,
                    32767 & s.read_shift(2)
                ];
                return [
                    n,
                    (0 === s[0] ? Gc : Vc)[s[1]]
                ];
            }
        },
        35: {
            n: "PtgName",
            f: function(e, t, r) {
                var a = e.read_shift(1) >>> 5 & 3, n = !r || 8 <= r.biff ? 4 : 2, n = e.read_shift(n);
                switch(r.biff){
                    case 2:
                        e.l += 5;
                        break;
                    case 3:
                    case 4:
                        e.l += 8;
                        break;
                    case 5:
                        e.l += 12;
                }
                return [
                    a,
                    0,
                    n
                ];
            }
        },
        36: {
            n: "PtgRef",
            f: function(e, t, r) {
                var a = (96 & e[e.l]) >> 5;
                return e.l += 1, [
                    a,
                    bc(e, 0, r)
                ];
            }
        },
        37: {
            n: "PtgArea",
            f: function(e, t, r) {
                return [
                    (96 & e[e.l++]) >> 5,
                    mc(e, 2 <= r.biff && r.biff, r)
                ];
            }
        },
        38: {
            n: "PtgMemArea",
            f: function(e, t, r) {
                var a = e.read_shift(1) >>> 5 & 3;
                return e.l += r && 2 == r.biff ? 3 : 4, [
                    a,
                    e.read_shift(r && 2 == r.biff ? 1 : 2)
                ];
            }
        },
        39: {
            n: "PtgMemErr",
            f: Pr
        },
        40: {
            n: "PtgMemNoMem",
            f: Pr
        },
        41: {
            n: "PtgMemFunc",
            f: function(e, t, r) {
                return [
                    e.read_shift(1) >>> 5 & 3,
                    e.read_shift(r && 2 == r.biff ? 1 : 2)
                ];
            }
        },
        42: {
            n: "PtgRefErr",
            f: function(e, t, r) {
                var a = e.read_shift(1) >>> 5 & 3;
                return e.l += 4, r.biff < 8 && e.l--, 12 == r.biff && (e.l += 2), [
                    a
                ];
            }
        },
        43: {
            n: "PtgAreaErr",
            f: function(e, t, r) {
                var a = (96 & e[e.l++]) >> 5;
                return e.l += r && 8 < r.biff ? 12 : r.biff < 8 ? 6 : 8, [
                    a
                ];
            }
        },
        44: {
            n: "PtgRefN",
            f: function(e, t, r) {
                var a = (96 & e[e.l]) >> 5;
                return e.l += 1, [
                    a,
                    vc(e, 0, r)
                ];
            }
        },
        45: {
            n: "PtgAreaN",
            f: function(e, t, r) {
                return [
                    (96 & e[e.l++]) >> 5,
                    function(e, t) {
                        if (t.biff < 8) return gc(e);
                        var r = e.read_shift(12 == t.biff ? 4 : 2), a = e.read_shift(12 == t.biff ? 4 : 2), t = pc(e, 2), e = pc(e, 2);
                        return {
                            s: {
                                r: r,
                                c: t[0],
                                cRel: t[1],
                                rRel: t[2]
                            },
                            e: {
                                r: a,
                                c: e[0],
                                cRel: e[1],
                                rRel: e[2]
                            }
                        };
                    }(e, r)
                ];
            }
        },
        46: {
            n: "PtgMemAreaN",
            f: function(e) {
                return [
                    e.read_shift(1) >>> 5 & 3,
                    e.read_shift(2)
                ];
            }
        },
        47: {
            n: "PtgMemNoMemN",
            f: function(e) {
                return [
                    e.read_shift(1) >>> 5 & 3,
                    e.read_shift(2)
                ];
            }
        },
        57: {
            n: "PtgNameX",
            f: function(e, t, r) {
                return 5 == r.biff ? function(e) {
                    var t = e.read_shift(1) >>> 5 & 3, r = e.read_shift(2, "i");
                    e.l += 8;
                    var a = e.read_shift(2);
                    return e.l += 12, [
                        t,
                        r,
                        a
                    ];
                }(e) : [
                    e.read_shift(1) >>> 5 & 3,
                    e.read_shift(2),
                    e.read_shift(4)
                ];
            }
        },
        58: {
            n: "PtgRef3d",
            f: function(e, t, r) {
                var a = (96 & e[e.l]) >> 5;
                e.l += 1;
                var n = e.read_shift(2);
                return r && 5 == r.biff && (e.l += 12), [
                    a,
                    n,
                    bc(e, 0, r)
                ];
            }
        },
        59: {
            n: "PtgArea3d",
            f: function(e, t, r) {
                var a = (96 & e[e.l++]) >> 5, n = e.read_shift(2, "i");
                if (r) switch(r.biff){
                    case 5:
                        e.l += 12;
                        break;
                    case 12:
                }
                return [
                    a,
                    n,
                    mc(e, 0, r)
                ];
            }
        },
        60: {
            n: "PtgRefErr3d",
            f: function(e, t, r) {
                var a = (96 & e[e.l++]) >> 5, n = e.read_shift(2), s = 4;
                if (r) switch(r.biff){
                    case 5:
                        s = 15;
                        break;
                    case 12:
                        s = 6;
                }
                return e.l += s, [
                    a,
                    n
                ];
            }
        },
        61: {
            n: "PtgAreaErr3d",
            f: function(e, t, r) {
                var a = (96 & e[e.l++]) >> 5, n = e.read_shift(2), s = 8;
                if (r) switch(r.biff){
                    case 5:
                        e.l += 12, s = 6;
                        break;
                    case 12:
                        s = 12;
                }
                return e.l += s, [
                    a,
                    n
                ];
            }
        },
        255: {}
    }, Ac = {
        64: 32,
        96: 32,
        65: 33,
        97: 33,
        66: 34,
        98: 34,
        67: 35,
        99: 35,
        68: 36,
        100: 36,
        69: 37,
        101: 37,
        70: 38,
        102: 38,
        71: 39,
        103: 39,
        72: 40,
        104: 40,
        73: 41,
        105: 41,
        74: 42,
        106: 42,
        75: 43,
        107: 43,
        76: 44,
        108: 44,
        77: 45,
        109: 45,
        78: 46,
        110: 46,
        79: 47,
        111: 47,
        88: 34,
        120: 34,
        89: 57,
        121: 57,
        90: 58,
        122: 58,
        91: 59,
        123: 59,
        92: 60,
        124: 60,
        93: 61,
        125: 61
    }, Cc = {
        1: {
            n: "PtgElfLel",
            f: Sc
        },
        2: {
            n: "PtgElfRw",
            f: kc
        },
        3: {
            n: "PtgElfCol",
            f: kc
        },
        6: {
            n: "PtgElfRwV",
            f: kc
        },
        7: {
            n: "PtgElfColV",
            f: kc
        },
        10: {
            n: "PtgElfRadical",
            f: kc
        },
        11: {
            n: "PtgElfRadicalS",
            f: yc
        },
        13: {
            n: "PtgElfColS",
            f: yc
        },
        15: {
            n: "PtgElfColSV",
            f: yc
        },
        16: {
            n: "PtgElfRadicalLel",
            f: Sc
        },
        25: {
            n: "PtgList",
            f: function(e) {
                e.l += 2;
                var t = e.read_shift(2), r = e.read_shift(2), a = e.read_shift(4), n = e.read_shift(2), e = e.read_shift(2);
                return {
                    ixti: t,
                    coltype: 3 & r,
                    rt: _c[r >> 2 & 31],
                    idx: a,
                    c: n,
                    C: e
                };
            }
        },
        29: {
            n: "PtgSxName",
            f: function(e) {
                return e.l += 2, [
                    e.read_shift(4)
                ];
            }
        },
        255: {}
    }, Rc = {
        0: {
            n: "PtgAttrNoop",
            f: function(e) {
                return e.l += 4, [
                    0,
                    0
                ];
            }
        },
        1: {
            n: "PtgAttrSemi",
            f: function(e, t, r) {
                var a = 255 & e[e.l + 1] ? 1 : 0;
                return e.l += r && 2 == r.biff ? 3 : 4, [
                    a
                ];
            }
        },
        2: {
            n: "PtgAttrIf",
            f: function(e, t, r) {
                var a = 255 & e[e.l + 1] ? 1 : 0;
                return e.l += 2, [
                    a,
                    e.read_shift(r && 2 == r.biff ? 1 : 2)
                ];
            }
        },
        4: {
            n: "PtgAttrChoose",
            f: function(e, t, r) {
                e.l += 2;
                for(var a = e.read_shift(r && 2 == r.biff ? 1 : 2), n = [], s = 0; s <= a; ++s)n.push(e.read_shift(r && 2 == r.biff ? 1 : 2));
                return n;
            }
        },
        8: {
            n: "PtgAttrGoto",
            f: function(e, t, r) {
                var a = 255 & e[e.l + 1] ? 1 : 0;
                return e.l += 2, [
                    a,
                    e.read_shift(r && 2 == r.biff ? 1 : 2)
                ];
            }
        },
        16: {
            n: "PtgAttrSum",
            f: function(e, t, r) {
                e.l += r && 2 == r.biff ? 3 : 4;
            }
        },
        32: {
            n: "PtgAttrBaxcel",
            f: wc
        },
        33: {
            n: "PtgAttrBaxcel",
            f: wc
        },
        64: {
            n: "PtgAttrSpace",
            f: function(e) {
                return e.read_shift(2), Tc(e);
            }
        },
        65: {
            n: "PtgAttrSpaceSemi",
            f: function(e) {
                return e.read_shift(2), Tc(e);
            }
        },
        128: {
            n: "PtgAttrIfError",
            f: function(e) {
                var t = 255 & e[e.l + 1] ? 1 : 0;
                return e.l += 2, [
                    t,
                    e.read_shift(2)
                ];
            }
        },
        255: {}
    };
    function Oc(e, t, r, a) {
        if (a.biff < 8) return Pr(e, t);
        for(var n = e.l + t, s = [], i = 0; i !== r.length; ++i)switch(r[i][0]){
            case "PtgArray":
                r[i][1] = Ec(e, 0, a), s.push(r[i][1]);
                break;
            case "PtgMemArea":
                r[i][2] = function(e, t) {
                    for(var r = e.read_shift(12 == t.biff ? 4 : 2), a = [], n = 0; n != r; ++n)a.push((12 == t.biff ? Sa : Kn)(e, 8));
                    return a;
                }(e, (r[i][1], a)), s.push(r[i][2]);
                break;
            case "PtgExp":
                a && 12 == a.biff && (r[i][1][1] = e.read_shift(4), s.push(r[i][1]));
                break;
            case "PtgList":
            case "PtgElfRadicalS":
            case "PtgElfColS":
            case "PtgElfColSV":
                throw "Unsupported " + r[i][0];
        }
        return 0 !== (t = n - e.l) && s.push(Pr(e, t)), s;
    }
    function Ic(e, t, r) {
        for(var a, n, s = e.l + t, i = []; s != e.l;)t = s - e.l, n = e[e.l], a = xc[n] || xc[Ac[n]], (a = 24 === n || 25 === n ? (24 === n ? Cc : Rc)[e[e.l + 1]] : a) && a.f ? i.push([
            a.n,
            a.f(e, t, r)
        ]) : Pr(e, t);
        return i;
    }
    var Nc = {
        PtgAdd: "+",
        PtgConcat: "&",
        PtgDiv: "/",
        PtgEq: "=",
        PtgGe: ">=",
        PtgGt: ">",
        PtgLe: "<=",
        PtgLt: "<",
        PtgMul: "*",
        PtgNe: "<>",
        PtgPower: "^",
        PtgSub: "-"
    };
    function Fc(e, t, r) {
        if (!e) return "SH33TJSERR0";
        if (8 < r.biff && (!e.XTI || !e.XTI[t])) return e.SheetNames[t];
        if (!e.XTI) return "SH33TJSERR6";
        var a = e.XTI[t];
        if (r.biff < 8) return 1e4 < t && (t -= 65536), 0 == (t = t < 0 ? -t : t) ? "" : e.XTI[t - 1];
        if (!a) return "SH33TJSERR1";
        var n = "";
        if (8 < r.biff) switch(e[a[0]][0]){
            case 357:
                return n = -1 == a[1] ? "#REF" : e.SheetNames[a[1]], a[1] == a[2] ? n : n + ":" + e.SheetNames[a[2]];
            case 358:
                return null != r.SID ? e.SheetNames[r.SID] : "SH33TJSSAME" + e[a[0]][0];
            case 355:
            default:
                return "SH33TJSSRC" + e[a[0]][0];
        }
        switch(e[a[0]][0][0]){
            case 1025:
                return n = -1 == a[1] ? "#REF" : e.SheetNames[a[1]] || "SH33TJSERR3", a[1] == a[2] ? n : n + ":" + e.SheetNames[a[2]];
            case 14849:
                return e[a[0]].slice(1).map(function(e) {
                    return e.Name;
                }).join(";;");
            default:
                return e[a[0]][0][3] ? (n = -1 == a[1] ? "#REF" : e[a[0]][0][3][a[1]] || "SH33TJSERR4", a[1] == a[2] ? n : n + ":" + e[a[0]][0][3][a[2]]) : "SH33TJSERR2";
        }
    }
    function Dc(e, t, r) {
        t = Fc(e, t, r);
        return "#REF" == t ? t : function(e, t) {
            if (!(e || t && t.biff <= 5 && 2 <= t.biff)) throw new Error("empty sheet name");
            return /[^\w\u4E00-\u9FFF\u3040-\u30FF]/.test(e) ? "'" + e + "'" : e;
        }(t, r);
    }
    function Pc(e, t, r, a, n) {
        var s, i, o, c = n && n.biff || 8, l = {
            s: {
                c: 0,
                r: 0
            },
            e: {
                c: 0,
                r: 0
            }
        }, f = [], h = 0, u = 0, d = "";
        if (!e[0] || !e[0][0]) return "";
        for(var p = -1, m = "", g = 0, b = e[0].length; g < b; ++g){
            var v = e[0][g];
            switch(v[0]){
                case "PtgUminus":
                    f.push("-" + f.pop());
                    break;
                case "PtgUplus":
                    f.push("+" + f.pop());
                    break;
                case "PtgPercent":
                    f.push(f.pop() + "%");
                    break;
                case "PtgAdd":
                case "PtgConcat":
                case "PtgDiv":
                case "PtgEq":
                case "PtgGe":
                case "PtgGt":
                case "PtgLe":
                case "PtgLt":
                case "PtgMul":
                case "PtgNe":
                case "PtgPower":
                case "PtgSub":
                    if (O = f.pop(), s = f.pop(), 0 <= p) {
                        switch(e[0][p][1][0]){
                            case 0:
                                m = Ge(" ", e[0][p][1][1]);
                                break;
                            case 1:
                                m = Ge("\r", e[0][p][1][1]);
                                break;
                            default:
                                if (m = "", n.WTF) throw new Error("Unexpected PtgAttrSpaceType " + e[0][p][1][0]);
                        }
                        s += m, p = -1;
                    }
                    f.push(s + Nc[v[0]] + O);
                    break;
                case "PtgIsect":
                    O = f.pop(), s = f.pop(), f.push(s + " " + O);
                    break;
                case "PtgUnion":
                    O = f.pop(), s = f.pop(), f.push(s + "," + O);
                    break;
                case "PtgRange":
                    O = f.pop(), s = f.pop(), f.push(s + ":" + O);
                    break;
                case "PtgAttrChoose":
                case "PtgAttrGoto":
                case "PtgAttrIf":
                case "PtgAttrIfError":
                    break;
                case "PtgRef":
                    i = Wr(v[1][1], l, n), f.push(zr(i, c));
                    break;
                case "PtgRefN":
                    i = r ? Wr(v[1][1], r, n) : v[1][1], f.push(zr(i, c));
                    break;
                case "PtgRef3d":
                    h = v[1][1], i = Wr(v[1][2], l, n);
                    d = Dc(a, h, n);
                    f.push(d + "!" + zr(i, c));
                    break;
                case "PtgFunc":
                case "PtgFuncVar":
                    var w = v[1][0], T = v[1][1], w = w || 0, E = 0 == (w &= 127) ? [] : f.slice(-w);
                    f.length -= w, "User" === T && (T = E.shift()), f.push(T + "(" + E.join(",") + ")");
                    break;
                case "PtgBool":
                    f.push(v[1] ? "TRUE" : "FALSE");
                    break;
                case "PtgInt":
                    f.push(v[1]);
                    break;
                case "PtgNum":
                    f.push(String(v[1]));
                    break;
                case "PtgStr":
                    f.push('"' + v[1].replace(/"/g, '""') + '"');
                    break;
                case "PtgErr":
                    f.push(v[1]);
                    break;
                case "PtgAreaN":
                    o = Hr(v[1][1], r ? {
                        s: r
                    } : l, n), f.push(Vr(o, n));
                    break;
                case "PtgArea":
                    o = Hr(v[1][1], l, n), f.push(Vr(o, n));
                    break;
                case "PtgArea3d":
                    h = v[1][1], o = v[1][2], d = Dc(a, h, n), f.push(d + "!" + Vr(o, n));
                    break;
                case "PtgAttrSum":
                    f.push("SUM(" + f.pop() + ")");
                    break;
                case "PtgAttrBaxcel":
                case "PtgAttrSemi":
                    break;
                case "PtgName":
                    u = v[1][2];
                    var k = (a.names || [])[u - 1] || (a[0] || [])[u], y = k ? k.Name : "SH33TJSNAME" + String(u);
                    y && "_xlfn." == y.slice(0, 6) && !n.xlfn && (y = y.slice(6)), f.push(y);
                    break;
                case "PtgNameX":
                    var S, _ = v[1][1], u = v[1][2];
                    if (!(n.biff <= 5)) {
                        k = "";
                        14849 == ((a[_] || [])[0] || [])[0] || (1025 == ((a[_] || [])[0] || [])[0] ? a[_][u] && 0 < a[_][u].itab && (k = a.SheetNames[a[_][u].itab - 1] + "!") : k = a.SheetNames[u - 1] + "!"), a[_] && a[_][u] ? k += a[_][u].Name : a[0] && a[0][u] ? k += a[0][u].Name : (y = (Fc(a, _, n) || "").split(";;"))[u - 1] ? k = y[u - 1] : k += "SH33TJSERRX", f.push(k);
                        break;
                    }
                    S = (S = a[_ = _ < 0 ? -_ : _] ? a[_][u] : S) || {
                        Name: "SH33TJSERRY"
                    }, f.push(S.Name);
                    break;
                case "PtgParen":
                    var x = "(", A = ")";
                    if (0 <= p) {
                        switch(m = "", e[0][p][1][0]){
                            case 2:
                                x = Ge(" ", e[0][p][1][1]) + x;
                                break;
                            case 3:
                                x = Ge("\r", e[0][p][1][1]) + x;
                                break;
                            case 4:
                                A = Ge(" ", e[0][p][1][1]) + A;
                                break;
                            case 5:
                                A = Ge("\r", e[0][p][1][1]) + A;
                                break;
                            default:
                                if (n.WTF) throw new Error("Unexpected PtgAttrSpaceType " + e[0][p][1][0]);
                        }
                        p = -1;
                    }
                    f.push(x + f.pop() + A);
                    break;
                case "PtgRefErr":
                case "PtgRefErr3d":
                    f.push("#REF!");
                    break;
                case "PtgExp":
                    i = {
                        c: v[1][1],
                        r: v[1][0]
                    };
                    var C = {
                        c: r.c,
                        r: r.r
                    };
                    if (a.sharedf[Kr(i)]) {
                        _ = a.sharedf[Kr(i)];
                        f.push(Pc(_, 0, C, a, n));
                    } else {
                        for(var R = !1, O = 0; O != a.arrayf.length; ++O)if (s = a.arrayf[O], !(i.c < s[0].s.c || i.c > s[0].e.c || i.r < s[0].s.r || i.r > s[0].e.r)) {
                            f.push(Pc(s[1], 0, C, a, n)), R = !0;
                            break;
                        }
                        R || f.push(v[1]);
                    }
                    break;
                case "PtgArray":
                    f.push("{" + function(e) {
                        for(var t = [], r = 0; r < e.length; ++r){
                            for(var a = e[r], n = [], s = 0; s < a.length; ++s){
                                var i = a[s];
                                i ? 2 === i[0] ? n.push('"' + i[1].replace(/"/g, '""') + '"') : n.push(i[1]) : n.push("");
                            }
                            t.push(n.join(","));
                        }
                        return t.join(";");
                    }(v[1]) + "}");
                    break;
                case "PtgMemArea":
                    break;
                case "PtgAttrSpace":
                case "PtgAttrSpaceSemi":
                    p = g;
                    break;
                case "PtgTbl":
                case "PtgMemErr":
                    break;
                case "PtgMissArg":
                    f.push("");
                    break;
                case "PtgAreaErr":
                case "PtgAreaErr3d":
                    f.push("#REF!");
                    break;
                case "PtgList":
                    f.push("Table" + v[1].idx + "[#" + v[1].rt + "]");
                    break;
                case "PtgMemAreaN":
                case "PtgMemNoMemN":
                case "PtgAttrNoop":
                case "PtgSheet":
                case "PtgEndSheet":
                case "PtgMemFunc":
                case "PtgMemNoMem":
                    break;
                case "PtgElfCol":
                case "PtgElfColS":
                case "PtgElfColSV":
                case "PtgElfColV":
                case "PtgElfLel":
                case "PtgElfRadical":
                case "PtgElfRadicalLel":
                case "PtgElfRadicalS":
                case "PtgElfRw":
                case "PtgElfRwV":
                    throw new Error("Unsupported ELFs");
                case "PtgSxName":
                default:
                    throw new Error("Unrecognized Formula Token: " + String(v));
            }
            if (3 != n.biff && 0 <= p && -1 == [
                "PtgAttrSpace",
                "PtgAttrSpaceSemi",
                "PtgAttrGoto"
            ].indexOf(e[0][g][0])) {
                var I = !0;
                switch((v = e[0][p])[1][0]){
                    case 4:
                        I = !1;
                    case 0:
                        m = Ge(" ", v[1][1]);
                        break;
                    case 5:
                        I = !1;
                    case 1:
                        m = Ge("\r", v[1][1]);
                        break;
                    default:
                        if (m = "", n.WTF) throw new Error("Unexpected PtgAttrSpaceType " + v[1][0]);
                }
                f.push((I ? m : "") + f.pop() + (I ? "" : m)), p = -1;
            }
        }
        if (1 < f.length && n.WTF) throw new Error("bad formula stack");
        return f[0];
    }
    function Lc(e, t, r) {
        var a = e.l + t, n = $n(e);
        2 == r.biff && ++e.l;
        var s = function(e) {
            var t;
            if (65535 !== yr(e, e.l + 6)) return [
                xa(e),
                "n"
            ];
            switch(e[e.l]){
                case 0:
                    return e.l += 8, [
                        "String",
                        "s"
                    ];
                case 1:
                    return t = 1 === e[e.l + 2], e.l += 8, [
                        t,
                        "b"
                    ];
                case 2:
                    return t = e[e.l + 2], e.l += 8, [
                        t,
                        "e"
                    ];
                case 3:
                    return e.l += 8, [
                        "",
                        "s"
                    ];
            }
            return [];
        }(e), t = e.read_shift(1);
        2 != r.biff && (e.read_shift(1), 5 <= r.biff && e.read_shift(4));
        r = function(e, t, r) {
            var a, n = e.l + t, s = 2 == r.biff ? 1 : 2, i = e.read_shift(s);
            if (65535 == i) return [
                [],
                Pr(e, t - 2)
            ];
            var o = Ic(e, i, r);
            return t !== i + s && (a = Oc(e, t - i - s, o, r)), e.l = n, [
                o,
                a
            ];
        }(e, a - e.l, r);
        return {
            cell: n,
            val: s[0],
            formula: r,
            shared: t >> 3 & 1,
            tt: s[1]
        };
    }
    function Mc(e, t, r, a, n) {
        t = Xn(t, r, n), n = null != (r = e.v) ? Aa("number" == typeof r ? r : 0) : ((r = Lr(8)).write_shift(1, 3), r.write_shift(1, 0), r.write_shift(2, 0), r.write_shift(2, 0), r.write_shift(2, 65535), r), r = Lr(6);
        r.write_shift(2, 33), r.write_shift(4, 0);
        for(var s = Lr(e.bf.length), i = 0; i < e.bf.length; ++i)s[i] = e.bf[i];
        return ue([
            t,
            n,
            r,
            s
        ]);
    }
    function Uc(e, t, r) {
        var a = e.read_shift(4), n = Ic(e, a, r), a = e.read_shift(4);
        return [
            n,
            0 < a ? Oc(e, a, n, r) : null
        ];
    }
    var Bc = Uc, Wc = Uc, Hc = Uc, zc = Uc, Vc = {
        0: "BEEP",
        1: "OPEN",
        2: "OPEN.LINKS",
        3: "CLOSE.ALL",
        4: "SAVE",
        5: "SAVE.AS",
        6: "FILE.DELETE",
        7: "PAGE.SETUP",
        8: "PRINT",
        9: "PRINTER.SETUP",
        10: "QUIT",
        11: "NEW.WINDOW",
        12: "ARRANGE.ALL",
        13: "WINDOW.SIZE",
        14: "WINDOW.MOVE",
        15: "FULL",
        16: "CLOSE",
        17: "RUN",
        22: "SET.PRINT.AREA",
        23: "SET.PRINT.TITLES",
        24: "SET.PAGE.BREAK",
        25: "REMOVE.PAGE.BREAK",
        26: "FONT",
        27: "DISPLAY",
        28: "PROTECT.DOCUMENT",
        29: "PRECISION",
        30: "A1.R1C1",
        31: "CALCULATE.NOW",
        32: "CALCULATION",
        34: "DATA.FIND",
        35: "EXTRACT",
        36: "DATA.DELETE",
        37: "SET.DATABASE",
        38: "SET.CRITERIA",
        39: "SORT",
        40: "DATA.SERIES",
        41: "TABLE",
        42: "FORMAT.NUMBER",
        43: "ALIGNMENT",
        44: "STYLE",
        45: "BORDER",
        46: "CELL.PROTECTION",
        47: "COLUMN.WIDTH",
        48: "UNDO",
        49: "CUT",
        50: "COPY",
        51: "PASTE",
        52: "CLEAR",
        53: "PASTE.SPECIAL",
        54: "EDIT.DELETE",
        55: "INSERT",
        56: "FILL.RIGHT",
        57: "FILL.DOWN",
        61: "DEFINE.NAME",
        62: "CREATE.NAMES",
        63: "FORMULA.GOTO",
        64: "FORMULA.FIND",
        65: "SELECT.LAST.CELL",
        66: "SHOW.ACTIVE.CELL",
        67: "GALLERY.AREA",
        68: "GALLERY.BAR",
        69: "GALLERY.COLUMN",
        70: "GALLERY.LINE",
        71: "GALLERY.PIE",
        72: "GALLERY.SCATTER",
        73: "COMBINATION",
        74: "PREFERRED",
        75: "ADD.OVERLAY",
        76: "GRIDLINES",
        77: "SET.PREFERRED",
        78: "AXES",
        79: "LEGEND",
        80: "ATTACH.TEXT",
        81: "ADD.ARROW",
        82: "SELECT.CHART",
        83: "SELECT.PLOT.AREA",
        84: "PATTERNS",
        85: "MAIN.CHART",
        86: "OVERLAY",
        87: "SCALE",
        88: "FORMAT.LEGEND",
        89: "FORMAT.TEXT",
        90: "EDIT.REPEAT",
        91: "PARSE",
        92: "JUSTIFY",
        93: "HIDE",
        94: "UNHIDE",
        95: "WORKSPACE",
        96: "FORMULA",
        97: "FORMULA.FILL",
        98: "FORMULA.ARRAY",
        99: "DATA.FIND.NEXT",
        100: "DATA.FIND.PREV",
        101: "FORMULA.FIND.NEXT",
        102: "FORMULA.FIND.PREV",
        103: "ACTIVATE",
        104: "ACTIVATE.NEXT",
        105: "ACTIVATE.PREV",
        106: "UNLOCKED.NEXT",
        107: "UNLOCKED.PREV",
        108: "COPY.PICTURE",
        109: "SELECT",
        110: "DELETE.NAME",
        111: "DELETE.FORMAT",
        112: "VLINE",
        113: "HLINE",
        114: "VPAGE",
        115: "HPAGE",
        116: "VSCROLL",
        117: "HSCROLL",
        118: "ALERT",
        119: "NEW",
        120: "CANCEL.COPY",
        121: "SHOW.CLIPBOARD",
        122: "MESSAGE",
        124: "PASTE.LINK",
        125: "APP.ACTIVATE",
        126: "DELETE.ARROW",
        127: "ROW.HEIGHT",
        128: "FORMAT.MOVE",
        129: "FORMAT.SIZE",
        130: "FORMULA.REPLACE",
        131: "SEND.KEYS",
        132: "SELECT.SPECIAL",
        133: "APPLY.NAMES",
        134: "REPLACE.FONT",
        135: "FREEZE.PANES",
        136: "SHOW.INFO",
        137: "SPLIT",
        138: "ON.WINDOW",
        139: "ON.DATA",
        140: "DISABLE.INPUT",
        142: "OUTLINE",
        143: "LIST.NAMES",
        144: "FILE.CLOSE",
        145: "SAVE.WORKBOOK",
        146: "DATA.FORM",
        147: "COPY.CHART",
        148: "ON.TIME",
        149: "WAIT",
        150: "FORMAT.FONT",
        151: "FILL.UP",
        152: "FILL.LEFT",
        153: "DELETE.OVERLAY",
        155: "SHORT.MENUS",
        159: "SET.UPDATE.STATUS",
        161: "COLOR.PALETTE",
        162: "DELETE.STYLE",
        163: "WINDOW.RESTORE",
        164: "WINDOW.MAXIMIZE",
        166: "CHANGE.LINK",
        167: "CALCULATE.DOCUMENT",
        168: "ON.KEY",
        169: "APP.RESTORE",
        170: "APP.MOVE",
        171: "APP.SIZE",
        172: "APP.MINIMIZE",
        173: "APP.MAXIMIZE",
        174: "BRING.TO.FRONT",
        175: "SEND.TO.BACK",
        185: "MAIN.CHART.TYPE",
        186: "OVERLAY.CHART.TYPE",
        187: "SELECT.END",
        188: "OPEN.MAIL",
        189: "SEND.MAIL",
        190: "STANDARD.FONT",
        191: "CONSOLIDATE",
        192: "SORT.SPECIAL",
        193: "GALLERY.3D.AREA",
        194: "GALLERY.3D.COLUMN",
        195: "GALLERY.3D.LINE",
        196: "GALLERY.3D.PIE",
        197: "VIEW.3D",
        198: "GOAL.SEEK",
        199: "WORKGROUP",
        200: "FILL.GROUP",
        201: "UPDATE.LINK",
        202: "PROMOTE",
        203: "DEMOTE",
        204: "SHOW.DETAIL",
        206: "UNGROUP",
        207: "OBJECT.PROPERTIES",
        208: "SAVE.NEW.OBJECT",
        209: "SHARE",
        210: "SHARE.NAME",
        211: "DUPLICATE",
        212: "APPLY.STYLE",
        213: "ASSIGN.TO.OBJECT",
        214: "OBJECT.PROTECTION",
        215: "HIDE.OBJECT",
        216: "SET.EXTRACT",
        217: "CREATE.PUBLISHER",
        218: "SUBSCRIBE.TO",
        219: "ATTRIBUTES",
        220: "SHOW.TOOLBAR",
        222: "PRINT.PREVIEW",
        223: "EDIT.COLOR",
        224: "SHOW.LEVELS",
        225: "FORMAT.MAIN",
        226: "FORMAT.OVERLAY",
        227: "ON.RECALC",
        228: "EDIT.SERIES",
        229: "DEFINE.STYLE",
        240: "LINE.PRINT",
        243: "ENTER.DATA",
        249: "GALLERY.RADAR",
        250: "MERGE.STYLES",
        251: "EDITION.OPTIONS",
        252: "PASTE.PICTURE",
        253: "PASTE.PICTURE.LINK",
        254: "SPELLING",
        256: "ZOOM",
        259: "INSERT.OBJECT",
        260: "WINDOW.MINIMIZE",
        265: "SOUND.NOTE",
        266: "SOUND.PLAY",
        267: "FORMAT.SHAPE",
        268: "EXTEND.POLYGON",
        269: "FORMAT.AUTO",
        272: "GALLERY.3D.BAR",
        273: "GALLERY.3D.SURFACE",
        274: "FILL.AUTO",
        276: "CUSTOMIZE.TOOLBAR",
        277: "ADD.TOOL",
        278: "EDIT.OBJECT",
        279: "ON.DOUBLECLICK",
        280: "ON.ENTRY",
        281: "WORKBOOK.ADD",
        282: "WORKBOOK.MOVE",
        283: "WORKBOOK.COPY",
        284: "WORKBOOK.OPTIONS",
        285: "SAVE.WORKSPACE",
        288: "CHART.WIZARD",
        289: "DELETE.TOOL",
        290: "MOVE.TOOL",
        291: "WORKBOOK.SELECT",
        292: "WORKBOOK.ACTIVATE",
        293: "ASSIGN.TO.TOOL",
        295: "COPY.TOOL",
        296: "RESET.TOOL",
        297: "CONSTRAIN.NUMERIC",
        298: "PASTE.TOOL",
        302: "WORKBOOK.NEW",
        305: "SCENARIO.CELLS",
        306: "SCENARIO.DELETE",
        307: "SCENARIO.ADD",
        308: "SCENARIO.EDIT",
        309: "SCENARIO.SHOW",
        310: "SCENARIO.SHOW.NEXT",
        311: "SCENARIO.SUMMARY",
        312: "PIVOT.TABLE.WIZARD",
        313: "PIVOT.FIELD.PROPERTIES",
        314: "PIVOT.FIELD",
        315: "PIVOT.ITEM",
        316: "PIVOT.ADD.FIELDS",
        318: "OPTIONS.CALCULATION",
        319: "OPTIONS.EDIT",
        320: "OPTIONS.VIEW",
        321: "ADDIN.MANAGER",
        322: "MENU.EDITOR",
        323: "ATTACH.TOOLBARS",
        324: "VBAActivate",
        325: "OPTIONS.CHART",
        328: "VBA.INSERT.FILE",
        330: "VBA.PROCEDURE.DEFINITION",
        336: "ROUTING.SLIP",
        338: "ROUTE.DOCUMENT",
        339: "MAIL.LOGON",
        342: "INSERT.PICTURE",
        343: "EDIT.TOOL",
        344: "GALLERY.DOUGHNUT",
        350: "CHART.TREND",
        352: "PIVOT.ITEM.PROPERTIES",
        354: "WORKBOOK.INSERT",
        355: "OPTIONS.TRANSITION",
        356: "OPTIONS.GENERAL",
        370: "FILTER.ADVANCED",
        373: "MAIL.ADD.MAILER",
        374: "MAIL.DELETE.MAILER",
        375: "MAIL.REPLY",
        376: "MAIL.REPLY.ALL",
        377: "MAIL.FORWARD",
        378: "MAIL.NEXT.LETTER",
        379: "DATA.LABEL",
        380: "INSERT.TITLE",
        381: "FONT.PROPERTIES",
        382: "MACRO.OPTIONS",
        383: "WORKBOOK.HIDE",
        384: "WORKBOOK.UNHIDE",
        385: "WORKBOOK.DELETE",
        386: "WORKBOOK.NAME",
        388: "GALLERY.CUSTOM",
        390: "ADD.CHART.AUTOFORMAT",
        391: "DELETE.CHART.AUTOFORMAT",
        392: "CHART.ADD.DATA",
        393: "AUTO.OUTLINE",
        394: "TAB.ORDER",
        395: "SHOW.DIALOG",
        396: "SELECT.ALL",
        397: "UNGROUP.SHEETS",
        398: "SUBTOTAL.CREATE",
        399: "SUBTOTAL.REMOVE",
        400: "RENAME.OBJECT",
        412: "WORKBOOK.SCROLL",
        413: "WORKBOOK.NEXT",
        414: "WORKBOOK.PREV",
        415: "WORKBOOK.TAB.SPLIT",
        416: "FULL.SCREEN",
        417: "WORKBOOK.PROTECT",
        420: "SCROLLBAR.PROPERTIES",
        421: "PIVOT.SHOW.PAGES",
        422: "TEXT.TO.COLUMNS",
        423: "FORMAT.CHARTTYPE",
        424: "LINK.FORMAT",
        425: "TRACER.DISPLAY",
        430: "TRACER.NAVIGATE",
        431: "TRACER.CLEAR",
        432: "TRACER.ERROR",
        433: "PIVOT.FIELD.GROUP",
        434: "PIVOT.FIELD.UNGROUP",
        435: "CHECKBOX.PROPERTIES",
        436: "LABEL.PROPERTIES",
        437: "LISTBOX.PROPERTIES",
        438: "EDITBOX.PROPERTIES",
        439: "PIVOT.REFRESH",
        440: "LINK.COMBO",
        441: "OPEN.TEXT",
        442: "HIDE.DIALOG",
        443: "SET.DIALOG.FOCUS",
        444: "ENABLE.OBJECT",
        445: "PUSHBUTTON.PROPERTIES",
        446: "SET.DIALOG.DEFAULT",
        447: "FILTER",
        448: "FILTER.SHOW.ALL",
        449: "CLEAR.OUTLINE",
        450: "FUNCTION.WIZARD",
        451: "ADD.LIST.ITEM",
        452: "SET.LIST.ITEM",
        453: "REMOVE.LIST.ITEM",
        454: "SELECT.LIST.ITEM",
        455: "SET.CONTROL.VALUE",
        456: "SAVE.COPY.AS",
        458: "OPTIONS.LISTS.ADD",
        459: "OPTIONS.LISTS.DELETE",
        460: "SERIES.AXES",
        461: "SERIES.X",
        462: "SERIES.Y",
        463: "ERRORBAR.X",
        464: "ERRORBAR.Y",
        465: "FORMAT.CHART",
        466: "SERIES.ORDER",
        467: "MAIL.LOGOFF",
        468: "CLEAR.ROUTING.SLIP",
        469: "APP.ACTIVATE.MICROSOFT",
        470: "MAIL.EDIT.MAILER",
        471: "ON.SHEET",
        472: "STANDARD.WIDTH",
        473: "SCENARIO.MERGE",
        474: "SUMMARY.INFO",
        475: "FIND.FILE",
        476: "ACTIVE.CELL.FONT",
        477: "ENABLE.TIPWIZARD",
        478: "VBA.MAKE.ADDIN",
        480: "INSERTDATATABLE",
        481: "WORKGROUP.OPTIONS",
        482: "MAIL.SEND.MAILER",
        485: "AUTOCORRECT",
        489: "POST.DOCUMENT",
        491: "PICKLIST",
        493: "VIEW.SHOW",
        494: "VIEW.DEFINE",
        495: "VIEW.DELETE",
        509: "SHEET.BACKGROUND",
        510: "INSERT.MAP.OBJECT",
        511: "OPTIONS.MENONO",
        517: "MSOCHECKS",
        518: "NORMAL",
        519: "LAYOUT",
        520: "RM.PRINT.AREA",
        521: "CLEAR.PRINT.AREA",
        522: "ADD.PRINT.AREA",
        523: "MOVE.BRK",
        545: "HIDECURR.NOTE",
        546: "HIDEALL.NOTES",
        547: "DELETE.NOTE",
        548: "TRAVERSE.NOTES",
        549: "ACTIVATE.NOTES",
        620: "PROTECT.REVISIONS",
        621: "UNPROTECT.REVISIONS",
        647: "OPTIONS.ME",
        653: "WEB.PUBLISH",
        667: "NEWWEBQUERY",
        673: "PIVOT.TABLE.CHART",
        753: "OPTIONS.SAVE",
        755: "OPTIONS.SPELL",
        808: "HIDEALL.INKANNOTS"
    }, Gc = {
        0: "COUNT",
        1: "IF",
        2: "ISNA",
        3: "ISERROR",
        4: "SUM",
        5: "AVERAGE",
        6: "MIN",
        7: "MAX",
        8: "ROW",
        9: "COLUMN",
        10: "NA",
        11: "NPV",
        12: "STDEV",
        13: "DOLLAR",
        14: "FIXED",
        15: "SIN",
        16: "COS",
        17: "TAN",
        18: "ATAN",
        19: "PI",
        20: "SQRT",
        21: "EXP",
        22: "LN",
        23: "LOG10",
        24: "ABS",
        25: "INT",
        26: "SIGN",
        27: "ROUND",
        28: "LOOKUP",
        29: "INDEX",
        30: "REPT",
        31: "MID",
        32: "LEN",
        33: "VALUE",
        34: "TRUE",
        35: "FALSE",
        36: "AND",
        37: "OR",
        38: "NOT",
        39: "MOD",
        40: "DCOUNT",
        41: "DSUM",
        42: "DAVERAGE",
        43: "DMIN",
        44: "DMAX",
        45: "DSTDEV",
        46: "VAR",
        47: "DVAR",
        48: "TEXT",
        49: "LINEST",
        50: "TREND",
        51: "LOGEST",
        52: "GROWTH",
        53: "GOTO",
        54: "HALT",
        55: "RETURN",
        56: "PV",
        57: "FV",
        58: "NPER",
        59: "PMT",
        60: "RATE",
        61: "MIRR",
        62: "IRR",
        63: "RAND",
        64: "MATCH",
        65: "DATE",
        66: "TIME",
        67: "DAY",
        68: "MONTH",
        69: "YEAR",
        70: "WEEKDAY",
        71: "HOUR",
        72: "MINUTE",
        73: "SECOND",
        74: "NOW",
        75: "AREAS",
        76: "ROWS",
        77: "COLUMNS",
        78: "OFFSET",
        79: "ABSREF",
        80: "RELREF",
        81: "ARGUMENT",
        82: "SEARCH",
        83: "TRANSPOSE",
        84: "ERROR",
        85: "STEP",
        86: "TYPE",
        87: "ECHO",
        88: "SET.NAME",
        89: "CALLER",
        90: "DEREF",
        91: "WINDOWS",
        92: "SERIES",
        93: "DOCUMENTS",
        94: "ACTIVE.CELL",
        95: "SELECTION",
        96: "RESULT",
        97: "ATAN2",
        98: "ASIN",
        99: "ACOS",
        100: "CHOOSE",
        101: "HLOOKUP",
        102: "VLOOKUP",
        103: "LINKS",
        104: "INPUT",
        105: "ISREF",
        106: "GET.FORMULA",
        107: "GET.NAME",
        108: "SET.VALUE",
        109: "LOG",
        110: "EXEC",
        111: "CHAR",
        112: "LOWER",
        113: "UPPER",
        114: "PROPER",
        115: "LEFT",
        116: "RIGHT",
        117: "EXACT",
        118: "TRIM",
        119: "REPLACE",
        120: "SUBSTITUTE",
        121: "CODE",
        122: "NAMES",
        123: "DIRECTORY",
        124: "FIND",
        125: "CELL",
        126: "ISERR",
        127: "ISTEXT",
        128: "ISNUMBER",
        129: "ISBLANK",
        130: "T",
        131: "N",
        132: "FOPEN",
        133: "FCLOSE",
        134: "FSIZE",
        135: "FREADLN",
        136: "FREAD",
        137: "FWRITELN",
        138: "FWRITE",
        139: "FPOS",
        140: "DATEVALUE",
        141: "TIMEVALUE",
        142: "SLN",
        143: "SYD",
        144: "DDB",
        145: "GET.DEF",
        146: "REFTEXT",
        147: "TEXTREF",
        148: "INDIRECT",
        149: "REGISTER",
        150: "CALL",
        151: "ADD.BAR",
        152: "ADD.MENU",
        153: "ADD.COMMAND",
        154: "ENABLE.COMMAND",
        155: "CHECK.COMMAND",
        156: "RENAME.COMMAND",
        157: "SHOW.BAR",
        158: "DELETE.MENU",
        159: "DELETE.COMMAND",
        160: "GET.CHART.ITEM",
        161: "DIALOG.BOX",
        162: "CLEAN",
        163: "MDETERM",
        164: "MINVERSE",
        165: "MMULT",
        166: "FILES",
        167: "IPMT",
        168: "PPMT",
        169: "COUNTA",
        170: "CANCEL.KEY",
        171: "FOR",
        172: "WHILE",
        173: "BREAK",
        174: "NEXT",
        175: "INITIATE",
        176: "REQUEST",
        177: "POKE",
        178: "EXECUTE",
        179: "TERMINATE",
        180: "RESTART",
        181: "HELP",
        182: "GET.BAR",
        183: "PRODUCT",
        184: "FACT",
        185: "GET.CELL",
        186: "GET.WORKSPACE",
        187: "GET.WINDOW",
        188: "GET.DOCUMENT",
        189: "DPRODUCT",
        190: "ISNONTEXT",
        191: "GET.NOTE",
        192: "NOTE",
        193: "STDEVP",
        194: "VARP",
        195: "DSTDEVP",
        196: "DVARP",
        197: "TRUNC",
        198: "ISLOGICAL",
        199: "DCOUNTA",
        200: "DELETE.BAR",
        201: "UNREGISTER",
        204: "USDOLLAR",
        205: "FINDB",
        206: "SEARCHB",
        207: "REPLACEB",
        208: "LEFTB",
        209: "RIGHTB",
        210: "MIDB",
        211: "LENB",
        212: "ROUNDUP",
        213: "ROUNDDOWN",
        214: "ASC",
        215: "DBCS",
        216: "RANK",
        219: "ADDRESS",
        220: "DAYS360",
        221: "TODAY",
        222: "VDB",
        223: "ELSE",
        224: "ELSE.IF",
        225: "END.IF",
        226: "FOR.CELL",
        227: "MEDIAN",
        228: "SUMPRODUCT",
        229: "SINH",
        230: "COSH",
        231: "TANH",
        232: "ASINH",
        233: "ACOSH",
        234: "ATANH",
        235: "DGET",
        236: "CREATE.OBJECT",
        237: "VOLATILE",
        238: "LAST.ERROR",
        239: "CUSTOM.UNDO",
        240: "CUSTOM.REPEAT",
        241: "FORMULA.CONVERT",
        242: "GET.LINK.INFO",
        243: "TEXT.BOX",
        244: "INFO",
        245: "GROUP",
        246: "GET.OBJECT",
        247: "DB",
        248: "PAUSE",
        251: "RESUME",
        252: "FREQUENCY",
        253: "ADD.TOOLBAR",
        254: "DELETE.TOOLBAR",
        255: "User",
        256: "RESET.TOOLBAR",
        257: "EVALUATE",
        258: "GET.TOOLBAR",
        259: "GET.TOOL",
        260: "SPELLING.CHECK",
        261: "ERROR.TYPE",
        262: "APP.TITLE",
        263: "WINDOW.TITLE",
        264: "SAVE.TOOLBAR",
        265: "ENABLE.TOOL",
        266: "PRESS.TOOL",
        267: "REGISTER.ID",
        268: "GET.WORKBOOK",
        269: "AVEDEV",
        270: "BETADIST",
        271: "GAMMALN",
        272: "BETAINV",
        273: "BINOMDIST",
        274: "CHIDIST",
        275: "CHIINV",
        276: "COMBIN",
        277: "CONFIDENCE",
        278: "CRITBINOM",
        279: "EVEN",
        280: "EXPONDIST",
        281: "FDIST",
        282: "FINV",
        283: "FISHER",
        284: "FISHERINV",
        285: "FLOOR",
        286: "GAMMADIST",
        287: "GAMMAINV",
        288: "CEILING",
        289: "HYPGEOMDIST",
        290: "LOGNORMDIST",
        291: "LOGINV",
        292: "NEGBINOMDIST",
        293: "NORMDIST",
        294: "NORMSDIST",
        295: "NORMINV",
        296: "NORMSINV",
        297: "STANDARDIZE",
        298: "ODD",
        299: "PERMUT",
        300: "POISSON",
        301: "TDIST",
        302: "WEIBULL",
        303: "SUMXMY2",
        304: "SUMX2MY2",
        305: "SUMX2PY2",
        306: "CHITEST",
        307: "CORREL",
        308: "COVAR",
        309: "FORECAST",
        310: "FTEST",
        311: "INTERCEPT",
        312: "PEARSON",
        313: "RSQ",
        314: "STEYX",
        315: "SLOPE",
        316: "TTEST",
        317: "PROB",
        318: "DEVSQ",
        319: "GEOMEAN",
        320: "HARMEAN",
        321: "SUMSQ",
        322: "KURT",
        323: "SKEW",
        324: "ZTEST",
        325: "LARGE",
        326: "SMALL",
        327: "QUARTILE",
        328: "PERCENTILE",
        329: "PERCENTRANK",
        330: "MODE",
        331: "TRIMMEAN",
        332: "TINV",
        334: "MOVIE.COMMAND",
        335: "GET.MOVIE",
        336: "CONCATENATE",
        337: "POWER",
        338: "PIVOT.ADD.DATA",
        339: "GET.PIVOT.TABLE",
        340: "GET.PIVOT.FIELD",
        341: "GET.PIVOT.ITEM",
        342: "RADIANS",
        343: "DEGREES",
        344: "SUBTOTAL",
        345: "SUMIF",
        346: "COUNTIF",
        347: "COUNTBLANK",
        348: "SCENARIO.GET",
        349: "OPTIONS.LISTS.GET",
        350: "ISPMT",
        351: "DATEDIF",
        352: "DATESTRING",
        353: "NUMBERSTRING",
        354: "ROMAN",
        355: "OPEN.DIALOG",
        356: "SAVE.DIALOG",
        357: "VIEW.GET",
        358: "GETPIVOTDATA",
        359: "HYPERLINK",
        360: "PHONETIC",
        361: "AVERAGEA",
        362: "MAXA",
        363: "MINA",
        364: "STDEVPA",
        365: "VARPA",
        366: "STDEVA",
        367: "VARA",
        368: "BAHTTEXT",
        369: "THAIDAYOFWEEK",
        370: "THAIDIGIT",
        371: "THAIMONTHOFYEAR",
        372: "THAINUMSOUND",
        373: "THAINUMSTRING",
        374: "THAISTRINGLENGTH",
        375: "ISTHAIDIGIT",
        376: "ROUNDBAHTDOWN",
        377: "ROUNDBAHTUP",
        378: "THAIYEAR",
        379: "RTD",
        380: "CUBEVALUE",
        381: "CUBEMEMBER",
        382: "CUBEMEMBERPROPERTY",
        383: "CUBERANKEDMEMBER",
        384: "HEX2BIN",
        385: "HEX2DEC",
        386: "HEX2OCT",
        387: "DEC2BIN",
        388: "DEC2HEX",
        389: "DEC2OCT",
        390: "OCT2BIN",
        391: "OCT2HEX",
        392: "OCT2DEC",
        393: "BIN2DEC",
        394: "BIN2OCT",
        395: "BIN2HEX",
        396: "IMSUB",
        397: "IMDIV",
        398: "IMPOWER",
        399: "IMABS",
        400: "IMSQRT",
        401: "IMLN",
        402: "IMLOG2",
        403: "IMLOG10",
        404: "IMSIN",
        405: "IMCOS",
        406: "IMEXP",
        407: "IMARGUMENT",
        408: "IMCONJUGATE",
        409: "IMAGINARY",
        410: "IMREAL",
        411: "COMPLEX",
        412: "IMSUM",
        413: "IMPRODUCT",
        414: "SERIESSUM",
        415: "FACTDOUBLE",
        416: "SQRTPI",
        417: "QUOTIENT",
        418: "DELTA",
        419: "GESTEP",
        420: "ISEVEN",
        421: "ISODD",
        422: "MROUND",
        423: "ERF",
        424: "ERFC",
        425: "BESSELJ",
        426: "BESSELK",
        427: "BESSELY",
        428: "BESSELI",
        429: "XIRR",
        430: "XNPV",
        431: "PRICEMAT",
        432: "YIELDMAT",
        433: "INTRATE",
        434: "RECEIVED",
        435: "DISC",
        436: "PRICEDISC",
        437: "YIELDDISC",
        438: "TBILLEQ",
        439: "TBILLPRICE",
        440: "TBILLYIELD",
        441: "PRICE",
        442: "YIELD",
        443: "DOLLARDE",
        444: "DOLLARFR",
        445: "NOMINAL",
        446: "EFFECT",
        447: "CUMPRINC",
        448: "CUMIPMT",
        449: "EDATE",
        450: "EOMONTH",
        451: "YEARFRAC",
        452: "COUPDAYBS",
        453: "COUPDAYS",
        454: "COUPDAYSNC",
        455: "COUPNCD",
        456: "COUPNUM",
        457: "COUPPCD",
        458: "DURATION",
        459: "MDURATION",
        460: "ODDLPRICE",
        461: "ODDLYIELD",
        462: "ODDFPRICE",
        463: "ODDFYIELD",
        464: "RANDBETWEEN",
        465: "WEEKNUM",
        466: "AMORDEGRC",
        467: "AMORLINC",
        468: "CONVERT",
        724: "SHEETJS",
        469: "ACCRINT",
        470: "ACCRINTM",
        471: "WORKDAY",
        472: "NETWORKDAYS",
        473: "GCD",
        474: "MULTINOMIAL",
        475: "LCM",
        476: "FVSCHEDULE",
        477: "CUBEKPIMEMBER",
        478: "CUBESET",
        479: "CUBESETCOUNT",
        480: "IFERROR",
        481: "COUNTIFS",
        482: "SUMIFS",
        483: "AVERAGEIF",
        484: "AVERAGEIFS"
    }, jc = {
        2: 1,
        3: 1,
        10: 0,
        15: 1,
        16: 1,
        17: 1,
        18: 1,
        19: 0,
        20: 1,
        21: 1,
        22: 1,
        23: 1,
        24: 1,
        25: 1,
        26: 1,
        27: 2,
        30: 2,
        31: 3,
        32: 1,
        33: 1,
        34: 0,
        35: 0,
        38: 1,
        39: 2,
        40: 3,
        41: 3,
        42: 3,
        43: 3,
        44: 3,
        45: 3,
        47: 3,
        48: 2,
        53: 1,
        61: 3,
        63: 0,
        65: 3,
        66: 3,
        67: 1,
        68: 1,
        69: 1,
        70: 1,
        71: 1,
        72: 1,
        73: 1,
        74: 0,
        75: 1,
        76: 1,
        77: 1,
        79: 2,
        80: 2,
        83: 1,
        85: 0,
        86: 1,
        89: 0,
        90: 1,
        94: 0,
        95: 0,
        97: 2,
        98: 1,
        99: 1,
        101: 3,
        102: 3,
        105: 1,
        106: 1,
        108: 2,
        111: 1,
        112: 1,
        113: 1,
        114: 1,
        117: 2,
        118: 1,
        119: 4,
        121: 1,
        126: 1,
        127: 1,
        128: 1,
        129: 1,
        130: 1,
        131: 1,
        133: 1,
        134: 1,
        135: 1,
        136: 2,
        137: 2,
        138: 2,
        140: 1,
        141: 1,
        142: 3,
        143: 4,
        144: 4,
        161: 1,
        162: 1,
        163: 1,
        164: 1,
        165: 2,
        172: 1,
        175: 2,
        176: 2,
        177: 3,
        178: 2,
        179: 1,
        184: 1,
        186: 1,
        189: 3,
        190: 1,
        195: 3,
        196: 3,
        197: 1,
        198: 1,
        199: 3,
        201: 1,
        207: 4,
        210: 3,
        211: 1,
        212: 2,
        213: 2,
        214: 1,
        215: 1,
        225: 0,
        229: 1,
        230: 1,
        231: 1,
        232: 1,
        233: 1,
        234: 1,
        235: 3,
        244: 1,
        247: 4,
        252: 2,
        257: 1,
        261: 1,
        271: 1,
        273: 4,
        274: 2,
        275: 2,
        276: 2,
        277: 3,
        278: 3,
        279: 1,
        280: 3,
        281: 3,
        282: 3,
        283: 1,
        284: 1,
        285: 2,
        286: 4,
        287: 3,
        288: 2,
        289: 4,
        290: 3,
        291: 3,
        292: 3,
        293: 4,
        294: 1,
        295: 3,
        296: 1,
        297: 3,
        298: 1,
        299: 2,
        300: 3,
        301: 3,
        302: 4,
        303: 2,
        304: 2,
        305: 2,
        306: 2,
        307: 2,
        308: 2,
        309: 3,
        310: 2,
        311: 2,
        312: 2,
        313: 2,
        314: 2,
        315: 2,
        316: 4,
        325: 2,
        326: 2,
        327: 2,
        328: 2,
        331: 2,
        332: 2,
        337: 2,
        342: 1,
        343: 1,
        346: 2,
        347: 1,
        350: 4,
        351: 3,
        352: 1,
        353: 2,
        360: 1,
        368: 1,
        369: 1,
        370: 1,
        371: 1,
        372: 1,
        373: 1,
        374: 1,
        375: 1,
        376: 1,
        377: 1,
        378: 1,
        382: 3,
        385: 1,
        392: 1,
        393: 1,
        396: 2,
        397: 2,
        398: 2,
        399: 1,
        400: 1,
        401: 1,
        402: 1,
        403: 1,
        404: 1,
        405: 1,
        406: 1,
        407: 1,
        408: 1,
        409: 1,
        410: 1,
        414: 4,
        415: 1,
        416: 1,
        417: 2,
        420: 1,
        421: 1,
        422: 2,
        424: 1,
        425: 2,
        426: 2,
        427: 2,
        428: 2,
        430: 3,
        438: 3,
        439: 3,
        440: 3,
        443: 2,
        444: 2,
        445: 2,
        446: 2,
        447: 6,
        448: 6,
        449: 2,
        450: 2,
        464: 2,
        468: 3,
        476: 2,
        479: 1,
        480: 2,
        65535: 0
    };
    function $c(e) {
        return (e = (e = (e = (e = 61 == (e = "of:" == e.slice(0, 3) ? e.slice(3) : e).charCodeAt(0) && 61 == (e = e.slice(1)).charCodeAt(0) ? e.slice(1) : e).replace(/COM\.MICROSOFT\./g, "")).replace(/\[((?:\.[A-Z]+[0-9]+)(?::\.[A-Z]+[0-9]+)?)\]/g, function(e, t) {
            return t.replace(/\./g, "");
        })).replace(/\[.(#[A-Z]*[?!])\]/g, "$1")).replace(/[;~]/g, ",").replace(/\|/g, ";");
    }
    function Xc(e) {
        e = e.split(":");
        return [
            e[0].split(".")[0],
            e[0].split(".")[1] + (1 < e.length ? ":" + (e[1].split(".")[1] || e[1].split(".")[0]) : "")
        ];
    }
    var Yc = {}, Kc = {}, Jc = "undefined" != typeof Map;
    function qc(e, t, r) {
        var a = 0, n = e.length;
        if (r) {
            if (Jc ? r.has(t) : Object.prototype.hasOwnProperty.call(r, t)) {
                for(var s = Jc ? r.get(t) : r[t]; a < s.length; ++a)if (e[s[a]].t === t) return e.Count++, s[a];
            }
        } else for(; a < n; ++a)if (e[a].t === t) return e.Count++, a;
        return e[n] = {
            t: t
        }, e.Count++, e.Unique++, r && (Jc ? (r.has(t) || r.set(t, []), r.get(t).push(n)) : (Object.prototype.hasOwnProperty.call(r, t) || (r[t] = []), r[t].push(n))), n;
    }
    function Zc(e, t) {
        var r = {
            min: e + 1,
            max: e + 1
        }, e = -1;
        return t.MDW && (no = t.MDW), null != t.width ? r.customWidth = 1 : null != t.wpx ? e = io(t.wpx) : null != t.wch && (e = t.wch), -1 < e ? (r.width = oo(e), r.customWidth = 1) : null != t.width && (r.width = t.width), t.hidden && (r.hidden = !0), null != t.level && (r.outlineLevel = r.level = t.level), r;
    }
    function Qc(e, t) {
        e && (t = "xlml" == t ? [
            1,
            1,
            1,
            1,
            .5,
            .5
        ] : [
            .7,
            .7,
            .75,
            .75,
            .3,
            .3
        ], null == e.left && (e.left = t[0]), null == e.right && (e.right = t[1]), null == e.top && (e.top = t[2]), null == e.bottom && (e.bottom = t[3]), null == e.header && (e.header = t[4]), null == e.footer && (e.footer = t[5]));
    }
    function el(e, t, r) {
        if (void 0 !== yo) {
            if (/^\d+$/.exec(t.s)) return t.s;
            if (t.s && t.s == +t.s) return t.s;
            var a = t.s || {};
            return t.z && (a.numFmt = t.z), yo.addStyle(a);
        }
        var n = r.revssf[null != t.z ? t.z : "General"], s = 60, i = e.length;
        if (null == n && r.ssf) {
            for(; s < 392; ++s)if (null == r.ssf[s]) {
                we(t.z, s), r.ssf[s] = t.z, r.revssf[t.z] = n = s;
                break;
            }
        }
        for(s = 0; s != i; ++s)if (e[s].numFmtId === n) return s;
        return e[i] = {
            numFmtId: n,
            fontId: 0,
            fillId: 0,
            borderId: 0,
            xfId: 0,
            applyNumberFormat: 1
        }, i;
    }
    function tl(e, t, r, a, n, s) {
        try {
            a.cellNF && (e.z = me[t]);
        } catch (e) {
            if (a.WTF) throw e;
        }
        if ("z" !== e.t || a.cellStyles) {
            if ("d" === e.t && "string" == typeof e.v && (e.v = He(e.v)), (!a || !1 !== a.cellText) && "z" !== e.t) try {
                if (null == me[t] && we(ke[t] || "General", t), "e" === e.t) e.w = e.w || Wa[e.v];
                else if (0 === t) {
                    if ("n" === e.t) (0 | e.v) === e.v ? e.w = e.v.toString(10) : e.w = D(e.v);
                    else if ("d" === e.t) {
                        var i = De(e.v);
                        e.w = (0 | i) === i ? i.toString(10) : D(i);
                    } else {
                        if (void 0 === e.v) return;
                        e.w = P(e.v, Kc);
                    }
                } else "d" === e.t ? e.w = ve(t, De(e.v), Kc) : e.w = ve(t, e.v, Kc);
            } catch (e) {
                if (a.WTF) throw e;
            }
            if (a.cellStyles && null != r) try {
                e.s = s.Fills[r], e.s.fgColor && e.s.fgColor.theme && !e.s.fgColor.rgb && (e.s.fgColor.rgb = eo(n.themeElements.clrScheme[e.s.fgColor.theme].rgb, e.s.fgColor.tint || 0), a.WTF && (e.s.fgColor.raw_rgb = n.themeElements.clrScheme[e.s.fgColor.theme].rgb)), e.s.bgColor && e.s.bgColor.theme && (e.s.bgColor.rgb = eo(n.themeElements.clrScheme[e.s.bgColor.theme].rgb, e.s.bgColor.tint || 0), a.WTF && (e.s.bgColor.raw_rgb = n.themeElements.clrScheme[e.s.bgColor.theme].rgb));
            } catch (e) {
                if (a.WTF && s.Fills) throw e;
            }
        }
    }
    var rl = /<(?:\w:)?mergeCell ref="[A-Z0-9:]+"\s*[\/]?>/g, al = /<(?:\w+:)?sheetData[^>]*>([\s\S]*)<\/(?:\w+:)?sheetData>/, nl = /<(?:\w:)?hyperlink [^>]*>/gm, sl = /"(\w*:\w*)"/, il = /<(?:\w:)?col\b[^>]*[\/]?>/g, ol = /<(?:\w:)?autoFilter[^>]*([\/]|>([\s\S]*)<\/(?:\w:)?autoFilter)>/g, cl = /<(?:\w:)?pageMargins[^>]*\/>/g, ll = /<(?:\w:)?sheetPr\b(?:[^>a-z][^>]*)?\/>/, fl = /<(?:\w:)?sheetPr[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetPr)>/, hl = /<(?:\w:)?sheetViews[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetViews)>/;
    function ul(e, t, r, a, n, s, i) {
        if (!e) return e;
        a = a || {
            "!id": {}
        }, null != oe && null == t.dense && (t.dense = oe);
        var o = t.dense ? [] : {}, c = {
            s: {
                r: 2e6,
                c: 2e6
            },
            e: {
                r: 0,
                c: 0
            }
        }, l = "", f = "", h = e.match(al);
        h ? (l = e.slice(0, h.index), f = e.slice(h.index + h[0].length)) : l = f = e;
        var u = l.match(ll);
        u ? dl(u[0], 0, n, r) : (u = l.match(fl)) && (e = u[0], u[1], u = o, d = n, p = r, dl(e.slice(0, e.indexOf(">")), 0, d, p));
        var d, p, m = (l.match(/<(?:\w*:)?dimension/) || {
            index: -1
        }).index;
        0 < m && (d = l.slice(m, m + 50).match(sl)) && (p = o, (b = Zr(b = d[1])).s.r <= b.e.r && b.s.c <= b.e.c && 0 <= b.s.r && 0 <= b.s.c && (p["!ref"] = qr(b)));
        var g, b = l.match(hl);
        b && b[1] && (w = b[1], (g = n).Views || (g.Views = [
            {}
        ]), (w.match(gl) || []).forEach(function(e, t) {
            e = dt(e);
            g.Views[t] || (g.Views[t] = {}), +e.zoomScale && (g.Views[t].zoom = +e.zoomScale), Rt(e.rightToLeft) && (g.Views[t].RTL = !0);
        }));
        var v, w = [];
        t.cellStyles && (v = l.match(il)) && function(e, t) {
            for(var r = !1, a = 0; a != t.length; ++a){
                var n = dt(t[a], !0);
                n.hidden && (n.hidden = Rt(n.hidden));
                var s = parseInt(n.min, 10) - 1, i = parseInt(n.max, 10) - 1;
                for(n.outlineLevel && (n.level = +n.outlineLevel || 0), delete n.min, delete n.max, n.width = +n.width, !r && n.width && (r = !0, lo(n.width)), fo(n); s <= i;)e[s++] = Ve(n);
            }
        }(w, v), h && Sl(h[1], o, t, c, s, i);
        i = f.match(ol);
        i && (o["!autofilter"] = {
            ref: (i[0].match(/ref="([^"]*)"/) || [])[1]
        });
        var T = [], E = f.match(rl);
        if (E) for(m = 0; m != E.length; ++m)T[m] = Zr(E[m].slice(E[m].indexOf('"') + 1));
        i = f.match(nl);
        i && function(e, t, r) {
            for(var a = Array.isArray(e), n = 0; n != t.length; ++n){
                var s = dt(Mt(t[n]), !0);
                if (!s.ref) return;
                var i = ((r || {})["!id"] || [])[s.id];
                i ? (s.Target = i.Target, s.location && (s.Target += "#" + wt(s.location))) : (s.Target = "#" + wt(s.location), i = {
                    Target: s.Target,
                    TargetMode: "Internal"
                }), s.Rel = i, s.tooltip && (s.Tooltip = s.tooltip, delete s.tooltip);
                for(var o = Zr(s.ref), c = o.s.r; c <= o.e.r; ++c)for(var l = o.s.c; l <= o.e.c; ++l){
                    var f = Kr({
                        c: l,
                        r: c
                    });
                    a ? (e[c] || (e[c] = []), e[c][l] || (e[c][l] = {
                        t: "z",
                        v: void 0
                    }), e[c][l].l = s) : (e[f] || (e[f] = {
                        t: "z",
                        v: void 0
                    }), e[f].l = s);
                }
            }
        }(o, i, a);
        var k, y, f = f.match(cl);
        return f && (o["!margins"] = (k = dt(f[0]), y = {}, [
            "left",
            "right",
            "top",
            "bottom",
            "header",
            "footer"
        ].forEach(function(e) {
            k[e] && (y[e] = parseFloat(k[e]));
        }), y)), !o["!ref"] && c.e.c >= c.s.c && c.e.r >= c.s.r && (o["!ref"] = qr(c)), 0 < t.sheetRows && o["!ref"] && (f = Zr(o["!ref"]), t.sheetRows <= +f.e.r && (f.e.r = t.sheetRows - 1, f.e.r > c.e.r && (f.e.r = c.e.r), f.e.r < f.s.r && (f.s.r = f.e.r), f.e.c > c.e.c && (f.e.c = c.e.c), f.e.c < f.s.c && (f.s.c = f.e.c), o["!fullref"] = o["!ref"], o["!ref"] = qr(f))), 0 < w.length && (o["!cols"] = w), 0 < T.length && (o["!merges"] = T), o;
    }
    function dl(e, t, r, a) {
        e = dt(e);
        r.Sheets[a] || (r.Sheets[a] = {}), e.codeName && (r.Sheets[a].CodeName = wt(Mt(e.codeName)));
    }
    var pl = [
        "objects",
        "scenarios",
        "selectLockedCells",
        "selectUnlockedCells"
    ], ml = [
        "formatColumns",
        "formatRows",
        "formatCells",
        "insertColumns",
        "insertRows",
        "insertHyperlinks",
        "deleteColumns",
        "deleteRows",
        "sort",
        "autoFilter",
        "pivotTables"
    ];
    var gl = /<(?:\w:)?sheetView(?:[^>a-z][^>]*)?\/?>/;
    var bl, vl, wl, Tl, El, kl, yl, Sl = (bl = /<(?:\w+:)?c[ \/>]/, vl = /<\/(?:\w+:)?row>/, wl = /r=["']([^"']*)["']/, Tl = /<(?:\w+:)?is>([\S\s]*?)<\/(?:\w+:)?is>/, El = /ref=["']([^"']*)["']/, kl = Bt("v"), yl = Bt("f"), function(e, t, r, a, n, s) {
        for(var i, o, c, l, f, h, u = 0, d = "", p = [], m = [], g = 0, b = 0, v = "", w = 0, T = 0, E = 0, k = 0, y = Array.isArray(s.CellXf), S = [], _ = [], x = Array.isArray(t), A = [], C = {}, R = !1, O = !!r.sheetStubs, I = e.split(vl), N = 0, F = I.length; N != F; ++N){
            var D = (d = I[N].trim()).length;
            if (0 !== D) {
                var P = 0;
                e: for(u = 0; u < D; ++u)switch(d[u]){
                    case ">":
                        if ("/" != d[u - 1]) {
                            ++u;
                            break e;
                        }
                        if (r && r.cellStyles) {
                            if (w = null != (c = dt(d.slice(P, u), !0)).r ? parseInt(c.r, 10) : w + 1, T = -1, r.sheetRows && r.sheetRows < w) continue;
                            R = (C = {}, false), c.ht && (R = !0, C.hpt = parseFloat(c.ht), C.hpx = po(C.hpt)), "1" == c.hidden && (R = !0, C.hidden = !0), null != c.outlineLevel && (R = !0, C.level = +c.outlineLevel), R && (A[w - 1] = C);
                        }
                        break;
                    case "<":
                        P = u;
                }
                if (u <= P) break;
                if (w = null != (c = dt(d.slice(P, u), !0)).r ? parseInt(c.r, 10) : w + 1, T = -1, !(r.sheetRows && r.sheetRows < w)) {
                    a.s.r > w - 1 && (a.s.r = w - 1), a.e.r < w - 1 && (a.e.r = w - 1), r && r.cellStyles && (R = (C = {}, false), c.ht && (R = !0, C.hpt = parseFloat(c.ht), C.hpx = po(C.hpt)), "1" == c.hidden && (R = !0, C.hidden = !0), null != c.outlineLevel && (R = !0, C.level = +c.outlineLevel), R && (A[w - 1] = C)), p = d.slice(u).split(bl);
                    for(var L, M = 0; M != p.length && "<" == p[M].trim().charAt(0); ++M);
                    for(p = p.slice(M), u = 0; u != p.length; ++u)if (0 !== (d = p[u].trim()).length) {
                        if (m = d.match(wl), g = u, b = 0, d = "<c " + ("<" == d.slice(0, 1) ? ">" : "") + d, null != m && 2 === m.length) {
                            for(g = 0, v = m[1], b = 0; b != v.length && !((i = v.charCodeAt(b) - 64) < 1 || 26 < i); ++b)g = 26 * g + i;
                            T = --g;
                        } else ++T;
                        for(b = 0; b != d.length && 62 !== d.charCodeAt(b); ++b);
                        if (++b, (c = dt(d.slice(0, b), !0)).r || (c.r = Kr({
                            r: w - 1,
                            c: T
                        })), o = {
                            t: ""
                        }, null != (m = (v = d.slice(b)).match(kl)) && "" !== m[1] && (o.v = wt(m[1])), r.cellFormula) {
                            null != (m = v.match(yl)) && "" !== m[1] ? (o.f = wt(Mt(m[1])).replace(/\r\n/g, "\n"), r.xlfn || (o.f = uc(o.f)), -1 < m[0].indexOf('t="array"') ? (o.F = (v.match(El) || [])[1], -1 < o.F.indexOf(":") && S.push([
                                Zr(o.F),
                                o.F
                            ])) : -1 < m[0].indexOf('t="shared"') && (f = dt(m[0]), L = wt(Mt(m[1])), r.xlfn || (L = uc(L)), _[parseInt(f.si, 10)] = [
                                f,
                                L,
                                c.r
                            ])) : (m = v.match(/<f[^>]*\/>/)) && _[(f = dt(m[0])).si] && (o.f = (h = _[f.si][1], W = _[f.si][2], L = c.r, W = Jr(W).s, L = Yr(L), hc(h, {
                                r: L.r - W.r,
                                c: L.c - W.c
                            })));
                            for(var U = Yr(c.r), b = 0; b < S.length; ++b)U.r >= S[b][0].s.r && U.r <= S[b][0].e.r && U.c >= S[b][0].s.c && U.c <= S[b][0].e.c && (o.F = S[b][1]);
                        }
                        if (null == c.t && void 0 === o.v) {
                            if (o.f || o.F) o.v = 0, o.t = "n";
                            else {
                                if (!O) continue;
                                o.t = "z";
                            }
                        } else o.t = c.t || "n";
                        switch(a.s.c > T && (a.s.c = T), a.e.c < T && (a.e.c = T), o.t){
                            case "n":
                                if ("" == o.v || null == o.v) {
                                    if (!O) continue;
                                    o.t = "z";
                                } else o.v = parseFloat(o.v);
                                break;
                            case "s":
                                if (void 0 === o.v) {
                                    if (!O) continue;
                                    o.t = "z";
                                } else l = Yc[parseInt(o.v, 10)], o.v = l.t, o.r = l.r, r.cellHTML && (o.h = l.h);
                                break;
                            case "str":
                                o.t = "s", o.v = null != o.v ? Mt(o.v) : "", r.cellHTML && (o.h = _t(o.v));
                                break;
                            case "inlineStr":
                                m = v.match(Tl), o.t = "s", null != m && (l = Ai(m[1])) ? (o.v = l.t, r.cellHTML && (o.h = l.h)) : o.v = "";
                                break;
                            case "b":
                                o.v = Rt(o.v);
                                break;
                            case "d":
                                r.cellDates ? o.v = He(o.v, 1) : (o.v = De(He(o.v, 1)), o.t = "n");
                                break;
                            case "e":
                                r && !1 === r.cellText || (o.w = o.v), o.v = Ha[o.v];
                        }
                        var B, E = k = 0, W = null;
                        y && void 0 !== c.s && null != (W = s.CellXf[c.s]) && (null != W.numFmtId && (E = W.numFmtId), r.cellStyles && null != W.fillId && (k = W.fillId)), tl(o, E, k, r, n, s), r.cellDates && y && "n" == o.t && q(me[E]) && (o.t = "d", o.v = Me(o.v)), c.cm && r.xlmeta && (B = (r.xlmeta.Cell || [])[+c.cm - 1]) && "XLDAPR" == B.type && (o.D = !0), x ? (t[(B = Yr(c.r)).r] || (t[B.r] = []), t[B.r][B.c] = o) : t[c.r] = o;
                    }
                }
            }
        }
        0 < A.length && (t["!rows"] = A);
    });
    function _l(e, t) {
        for(var r, a, n, s, i = [], o = [], c = Zr(e["!ref"]), l = [], f = 0, h = 0, u = e["!rows"], d = Array.isArray(e), p = {
            r: ""
        }, m = -1, h = c.s.c; h <= c.e.c; ++h)l[h] = Xr(h);
        for(f = c.s.r; f <= c.e.r; ++f){
            for(o = [], n = jr(f), h = c.s.c; h <= c.e.c; ++h){
                a = l[h] + n;
                var g = d ? (e[f] || [])[h] : e[a];
                void 0 !== g && null != (r = function(e, t, r, a) {
                    if (e.c && r["!comments"].push([
                        t,
                        e.c
                    ]), void 0 === e.v && "string" != typeof e.f || "z" === e.t && !e.f) return "";
                    var n = "", s = e.t, i = e.v;
                    if ("z" !== e.t) switch(e.t){
                        case "b":
                            n = e.v ? "1" : "0";
                            break;
                        case "n":
                            n = "" + e.v;
                            break;
                        case "e":
                            n = Wa[e.v];
                            break;
                        case "d":
                            n = a && a.cellDates ? He(e.v, -1).toISOString() : ((e = Ve(e)).t = "n", "" + (e.v = De(He(e.v)))), void 0 === e.z && (e.z = me[14]);
                            break;
                        default:
                            n = e.v;
                    }
                    var o = $t("v", kt(n)), c = {
                        r: t
                    }, l = el(a.cellXfs, e, a);
                    switch(0 !== l && (c.s = l), e.t){
                        case "n":
                            break;
                        case "d":
                            c.t = "d";
                            break;
                        case "b":
                            c.t = "b";
                            break;
                        case "e":
                            c.t = "e";
                            break;
                        case "z":
                            break;
                        default:
                            if (null == e.v) {
                                delete e.t;
                                break;
                            }
                            if (32767 < e.v.length) throw new Error("Text length must not exceed 32767 characters");
                            if (a && a.bookSST) {
                                o = $t("v", "" + qc(a.Strings, e.v, a.revStrings)), c.t = "s";
                                break;
                            }
                            c.t = "str";
                    }
                    return e.t != s && (e.t = s, e.v = i), "string" == typeof e.f && e.f && (i = e.F && e.F.slice(0, t.length) == t ? {
                        t: "array",
                        ref: e.F
                    } : null, o = Yt("f", kt(e.f), i) + (null != e.v ? o : "")), e.l && r["!links"].push([
                        t,
                        e.l
                    ]), e.D && (c.cm = 1), Yt("c", o, c);
                }(g, a, e, t)) && o.push(r);
            }
            (0 < o.length || u && u[f]) && (p = {
                r: n
            }, u && u[f] && ((s = u[f]).hidden && (p.hidden = 1), m = -1, s.hpx ? m = uo(s.hpx) : s.hpt && (m = s.hpt), -1 < m && (p.ht = m, p.customHeight = 1), s.level && (p.outlineLevel = s.level)), i[i.length] = Yt("row", o.join(""), p));
        }
        if (u) for(; f < u.length; ++f)u && u[f] && (p = {
            r: f + 1
        }, (s = u[f]).hidden && (p.hidden = 1), m = -1, s.hpx ? m = uo(s.hpx) : s.hpt && (m = s.hpt), -1 < m && (p.ht = m, p.customHeight = 1), s.level && (p.outlineLevel = s.level), i[i.length] = Yt("row", "", p));
        return i.join("");
    }
    function xl(e, t, r, a) {
        var n, s, i = [
            ot,
            Yt("worksheet", null, {
                xmlns: Qt[0],
                "xmlns:r": Zt.r
            })
        ], o = r.SheetNames[e], c = r.Sheets[o], l = (c = null == c ? {} : c)["!ref"] || "A1", f = Zr(l);
        if (16383 < f.e.c || 1048575 < f.e.r) {
            if (t.WTF) throw new Error("Range " + l + " exceeds format limit A1:XFD1048576");
            f.e.c = Math.min(f.e.c, 16383), f.e.r = Math.min(f.e.c, 1048575), l = qr(f);
        }
        a = a || {}, c["!comments"] = [];
        var h, u, d = [];
        !function(e, t, r, a, n) {
            var s = !1, i = {}, o = null;
            if ("xlsx" !== a.bookType && t.vbaraw) {
                var c = t.SheetNames[r];
                try {
                    t.Workbook && (c = t.Workbook.Sheets[r].CodeName || c);
                } catch (e) {}
                s = !0, i.codeName = Ut(kt(c));
            }
            e && e["!outline"] && (a = {
                summaryBelow: 1,
                summaryRight: 1
            }, e["!outline"].above && (a.summaryBelow = 0), e["!outline"].left && (a.summaryRight = 0), o = (o || "") + Yt("outlinePr", null, a)), (s || o) && (n[n.length] = Yt("sheetPr", o, i));
        }(c, r, e, t, i), i[i.length] = Yt("dimension", null, {
            ref: l
        }), i[i.length] = (o = {
            workbookViewId: "0"
        }, ((((f = r) || {}).Workbook || {}).Views || [])[0] && (o.rightToLeft = f.Workbook.Views[0].RTL ? "1" : "0"), Yt("sheetViews", Yt("sheetView", null, o), {})), t.sheetFormat && (i[i.length] = Yt("sheetFormatPr", null, {
            defaultRowHeight: t.sheetFormat.defaultRowHeight || "16",
            baseColWidth: t.sheetFormat.baseColWidth || "10",
            outlineLevelRow: t.sheetFormat.outlineLevelRow || "7"
        })), null != c["!cols"] && 0 < c["!cols"].length && (i[i.length] = function(e) {
            for(var t, r = [
                "<cols>"
            ], a = 0; a != e.length; ++a)(t = e[a]) && (r[r.length] = Yt("col", null, Zc(a, t)));
            return r[r.length] = "</cols>", r.join("");
        }(c["!cols"])), i[n = i.length] = "<sheetData/>", c["!links"] = [], null != c["!ref"] && 0 < (s = _l(c, t)).length && (i[i.length] = s), i.length > n + 1 && (i[i.length] = "</sheetData>", i[n] = i[n].replace("/>", ">")), c["!protect"] && (i[i.length] = (h = c["!protect"], u = {
            sheet: 1
        }, pl.forEach(function(e) {
            null != h[e] && h[e] && (u[e] = "1");
        }), ml.forEach(function(e) {
            null == h[e] || h[e] || (u[e] = "0");
        }), h.password && (u.password = zi(h.password).toString(16).toUpperCase()), Yt("sheetProtection", null, u))), null != c["!autofilter"] && (i[i.length] = function(e, t, r, a) {
            var n = "string" == typeof e.ref ? e.ref : qr(e.ref);
            r.Workbook || (r.Workbook = {
                Sheets: []
            }), r.Workbook.Names || (r.Workbook.Names = []);
            var s = r.Workbook.Names;
            (e = Jr(n)).s.r == e.e.r && (e.e.r = Jr(t["!ref"]).e.r, n = qr(e));
            for(var i = 0; i < s.length; ++i){
                var o = s[i];
                if ("_xlnm._FilterDatabase" == o.Name && o.Sheet == a) {
                    o.Ref = "'" + r.SheetNames[a] + "'!" + n;
                    break;
                }
            }
            return i == s.length && s.push({
                Name: "_xlnm._FilterDatabase",
                Sheet: a,
                Ref: "'" + r.SheetNames[a] + "'!" + n
            }), Yt("autoFilter", null, {
                ref: n
            });
        }(c["!autofilter"], c, r, e)), null != c["!merges"] && 0 < c["!merges"].length && (i[i.length] = function(e) {
            if (0 === e.length) return "";
            for(var t = '<mergeCells count="' + e.length + '">', r = 0; r != e.length; ++r)t += '<mergeCell ref="' + qr(e[r]) + '"/>';
            return t + "</mergeCells>";
        }(c["!merges"]));
        var p, m, g = -1;
        return 0 < c["!links"].length && (i[i.length] = "<hyperlinks>", c["!links"].forEach(function(e) {
            e[1].Target && (m = {
                ref: e[0]
            }, "#" != e[1].Target.charAt(0) && (g = Ja(a, -1, kt(e[1].Target).replace(/#.*$/, ""), $a.HLINK), m["r:id"] = "rId" + g), -1 < (p = e[1].Target.indexOf("#")) && (m.location = kt(e[1].Target.slice(p + 1))), e[1].Tooltip && (m.tooltip = kt(e[1].Tooltip)), i[i.length] = Yt("hyperlink", null, m));
        }), i[i.length] = "</hyperlinks>"), delete c["!links"], null != c["!margins"] && (i[i.length] = (Qc(r = c["!margins"]), Yt("pageMargins", null, r))), t && !t.ignoreEC && null != t.ignoreEC || (i[i.length] = $t("ignoredErrors", Yt("ignoredError", null, {
            numberStoredAsText: 1,
            sqref: l
        }))), 0 < d.length && (g = Ja(a, -1, "../drawings/drawing" + (e + 1) + ".xml", $a.DRAW), i[i.length] = Yt("drawing", null, {
            "r:id": "rId" + g
        }), c["!drawing"] = d), 0 < c["!comments"].length && (g = Ja(a, -1, "../drawings/vmlDrawing" + (e + 1) + ".vml", $a.VML), i[i.length] = Yt("legacyDrawing", null, {
            "r:id": "rId" + g
        }), c["!legacy"] = g), 1 < i.length && (i[i.length] = "</worksheet>", i[1] = i[1].replace("/>", ">")), i.join("");
    }
    function Al(e, t, r, a) {
        r = function(e, t, r) {
            var a = Lr(145), n = (r["!rows"] || [])[e] || {};
            a.write_shift(4, e), a.write_shift(4, 0);
            var s = 320;
            n.hpx ? s = 20 * uo(n.hpx) : n.hpt && (s = 20 * n.hpt), a.write_shift(2, s), a.write_shift(1, 0), s = 0, n.level && (s |= n.level), n.hidden && (s |= 16), (n.hpx || n.hpt) && (s |= 32), a.write_shift(1, s), a.write_shift(1, 0);
            var i = 0, s = a.l;
            a.l += 4;
            for(var o = {
                r: e,
                c: 0
            }, c = 0; c < 16; ++c)if (!(t.s.c > c + 1 << 10 || t.e.c < c << 10)) {
                for(var l = -1, f = -1, h = c << 10; h < c + 1 << 10; ++h)o.c = h, (Array.isArray(r) ? (r[o.r] || [])[o.c] : r[Kr(o)]) && (l < 0 && (l = h), f = h);
                l < 0 || (++i, a.write_shift(4, l), a.write_shift(4, f));
            }
            return e = a.l, a.l = s, a.write_shift(4, i), a.l = e, a.length > a.l ? a.slice(0, a.l) : a;
        }(a, r, t);
        (17 < r.length || (t["!rows"] || [])[a]) && Br(e, 0, r);
    }
    var lt = Sa, Cl = _a;
    function Rl(e) {
        return [
            ua(e),
            xa(e),
            "n"
        ];
    }
    var Lt = Sa, Ol = _a;
    var Il = [
        "left",
        "right",
        "top",
        "bottom",
        "header",
        "footer"
    ];
    function Nl(e, t, r, a, n, s, i) {
        if (void 0 === t.v) return !1;
        var o = "";
        switch(t.t){
            case "b":
                o = t.v ? "1" : "0";
                break;
            case "d":
                (t = Ve(t)).z = t.z || me[14], t.v = De(He(t.v)), t.t = "n";
                break;
            case "n":
            case "e":
                o = "" + t.v;
                break;
            default:
                o = t.v;
        }
        var c, l, f, h, u, d, p, m, g, b, v, w, T, E, k, y, S, _, x, A, C = {
            r: r,
            c: a
        };
        switch(C.s = el(n.cellXfs, t, n), t.l && s["!links"].push([
            Kr(C),
            t.l
        ]), t.c && s["!comments"].push([
            Kr(C),
            t.c
        ]), t.t){
            case "s":
            case "str":
                return n.bookSST ? (o = qc(n.Strings, t.v, n.revStrings), C.t = "s", C.v = o, i ? Br(e, 18, (da(S = C, _ = null == _ ? Lr(8) : _), _.write_shift(4, S.v), _)) : Br(e, 7, (ha(S = C, y = null == y ? Lr(12) : y), y.write_shift(4, S.v), y))) : (C.t = "str", i ? Br(e, 17, (E = t, da(C, k = null == k ? Lr(8 + 4 * E.v.length) : k), ia(E.v, k), k.length > k.l ? k.slice(0, k.l) : k)) : Br(e, 6, (E = t, ha(C, T = null == T ? Lr(12 + 4 * E.v.length) : T), ia(E.v, T), T.length > T.l ? T.slice(0, T.l) : T))), !0;
            case "n":
                return t.v == (0 | t.v) && -1000 < t.v && t.v < 1e3 ? i ? Br(e, 13, (v = t, da(C, w = null == w ? Lr(8) : w), ka(v.v, w), w)) : Br(e, 2, (v = t, ha(C, b = null == b ? Lr(12) : b), ka(v.v, b), b)) : i ? Br(e, 16, (m = t, da(C, g = null == g ? Lr(12) : g), Aa(m.v, g), g)) : Br(e, 5, (m = t, ha(C, p = null == p ? Lr(16) : p), Aa(m.v, p), p)), !0;
            case "b":
                return C.t = "b", i ? Br(e, 15, (u = t, da(C, d = null == d ? Lr(5) : d), d.write_shift(1, u.v ? 1 : 0), d)) : Br(e, 4, (u = t, ha(C, h = null == h ? Lr(9) : h), h.write_shift(1, u.v ? 1 : 0), h)), !0;
            case "e":
                return C.t = "e", i ? Br(e, 14, (l = t, da(C, f = null == f ? Lr(8) : f), f.write_shift(1, l.v), f.write_shift(2, 0), f.write_shift(1, 0), f)) : Br(e, 3, (l = t, ha(C, c = null == c ? Lr(9) : c), c.write_shift(1, l.v), c)), !0;
        }
        return i ? Br(e, 12, da(C, A = null == A ? Lr(4) : A)) : Br(e, 1, ha(C, x = null == x ? Lr(8) : x)), !0;
    }
    function Fl(t, e) {
        var r, a;
        e && e["!merges"] && (Br(t, 177, (r = e["!merges"].length, (a = null == a ? Lr(4) : a).write_shift(4, r), a)), e["!merges"].forEach(function(e) {
            Br(t, 176, Ol(e));
        }), Br(t, 178));
    }
    function Dl(r, e) {
        e && e["!cols"] && (Br(r, 390), e["!cols"].forEach(function(e, t) {
            e && Br(r, 60, function(e, t, r) {
                null == r && (r = Lr(18));
                var a = Zc(e, t);
                return r.write_shift(-4, e), r.write_shift(-4, e), r.write_shift(4, 256 * (a.width || 10)), r.write_shift(4, 0), e = 0, t.hidden && (e |= 1), "number" == typeof a.width && (e |= 2), t.level && (e |= t.level << 8), r.write_shift(2, e), r;
            }(t, e));
        }), Br(r, 391));
    }
    function Pl(e, t) {
        var r;
        t && t["!ref"] && (Br(e, 648), Br(e, 649, (r = Zr(t["!ref"]), (t = Lr(24)).write_shift(4, 4), t.write_shift(4, 1), _a(r, t), t)), Br(e, 650));
    }
    function Ll(a, e, n) {
        e["!links"].forEach(function(e) {
            var t, r;
            e[1].Target && (t = Ja(n, -1, e[1].Target.replace(/#.*$/, ""), $a.HLINK), Br(a, 494, (r = t, e = Lr(50 + 4 * ((t = e)[1].Target.length + (t[1].Tooltip || "").length)), _a({
                s: Yr(t[0]),
                e: Yr(t[0])
            }, e), Ta("rId" + r, e), ia((-1 == (r = t[1].Target.indexOf("#")) ? "" : t[1].Target.slice(r + 1)) || "", e), ia(t[1].Tooltip || "", e), ia("", e), e.slice(0, e.l))));
        }), delete e["!links"];
    }
    function Ml(e, t, r) {
        Br(e, 133), Br(e, 137, function(e, t) {
            null == t && (t = Lr(30));
            var r = 924;
            return (((e || {}).Views || [])[0] || {}).RTL && (r |= 32), t.write_shift(2, r), t.write_shift(4, 0), t.write_shift(4, 0), t.write_shift(4, 0), t.write_shift(1, 0), t.write_shift(1, 0), t.write_shift(2, 0), t.write_shift(2, 100), t.write_shift(2, 0), t.write_shift(2, 0), t.write_shift(2, 0), t.write_shift(4, 0), t;
        }(r)), Br(e, 138), Br(e, 134);
    }
    function Ul(e, t) {
        var r, a;
        t["!protect"] && Br(e, 535, (r = t["!protect"], (a = null == a ? Lr(66) : a).write_shift(2, r.password ? zi(r.password) : 0), a.write_shift(4, 1), [
            [
                "objects",
                !1
            ],
            [
                "scenarios",
                !1
            ],
            [
                "formatCells",
                !0
            ],
            [
                "formatColumns",
                !0
            ],
            [
                "formatRows",
                !0
            ],
            [
                "insertColumns",
                !0
            ],
            [
                "insertRows",
                !0
            ],
            [
                "insertHyperlinks",
                !0
            ],
            [
                "deleteColumns",
                !0
            ],
            [
                "deleteRows",
                !0
            ],
            [
                "selectLockedCells",
                !1
            ],
            [
                "sort",
                !0
            ],
            [
                "autoFilter",
                !0
            ],
            [
                "pivotTables",
                !0
            ],
            [
                "selectUnlockedCells",
                !1
            ]
        ].forEach(function(e) {
            e[1] ? a.write_shift(4, null == r[e[0]] || r[e[0]] ? 0 : 1) : a.write_shift(4, null != r[e[0]] && r[e[0]] ? 0 : 1);
        }), a));
    }
    function Bl(e, t, r, a) {
        var n = Ur(), s = r.SheetNames[e], i = r.Sheets[s] || {}, o = s;
        try {
            r && r.Workbook && (o = r.Workbook.Sheets[e].CodeName || o);
        } catch (e) {}
        var c, l, s = Zr(i["!ref"] || "A1");
        if (16383 < s.e.c || 1048575 < s.e.r) {
            if (t.WTF) throw new Error("Range " + (i["!ref"] || "A1") + " exceeds format limit A1:XFD1048576");
            s.e.c = Math.min(s.e.c, 16383), s.e.r = Math.min(s.e.c, 1048575);
        }
        return i["!links"] = [], i["!comments"] = [], Br(n, 129), (r.vbaraw || i["!outline"]) && Br(n, 147, function(e, t, r) {
            null == r && (r = Lr(84 + 4 * e.length));
            var a = 192;
            t && (t.above && (a &= -65), t.left && (a &= -129)), r.write_shift(1, a);
            for(var n = 1; n < 3; ++n)r.write_shift(1, 0);
            return Ca({
                auto: 1
            }, r), r.write_shift(-4, -1), r.write_shift(-4, -1), ma(e, r), r.slice(0, r.l);
        }(o, i["!outline"])), Br(n, 148, Cl(s)), Ml(n, 0, r.Workbook), Dl(n, i), function(e, t, r) {
            var a, n = Zr(t["!ref"] || "A1"), s = [];
            Br(e, 145);
            var i = Array.isArray(t), o = n.e.r;
            t["!rows"] && (o = Math.max(n.e.r, t["!rows"].length - 1));
            for(var c = n.s.r; c <= o; ++c){
                a = jr(c), Al(e, t, n, c);
                var l = !1;
                if (c <= n.e.r) for(var f = n.s.c; f <= n.e.c; ++f){
                    c === n.s.r && (s[f] = Xr(f)), h = s[f] + a;
                    var h = i ? (t[c] || [])[f] : t[h];
                    h ? l = Nl(e, h, c, f, r, t, l) : l = !1;
                }
            }
            Br(e, 146);
        }(n, i, t), Ul(n, i), function(e, t, r, a) {
            if (t["!autofilter"]) {
                var n = t["!autofilter"], s = "string" == typeof n.ref ? n.ref : qr(n.ref);
                r.Workbook || (r.Workbook = {
                    Sheets: []
                }), r.Workbook.Names || (r.Workbook.Names = []);
                var i = r.Workbook.Names, n = Jr(s);
                n.s.r == n.e.r && (n.e.r = Jr(t["!ref"]).e.r, s = qr(n));
                for(var o = 0; o < i.length; ++o){
                    var c = i[o];
                    if ("_xlnm._FilterDatabase" == c.Name && c.Sheet == a) {
                        c.Ref = "'" + r.SheetNames[a] + "'!" + s;
                        break;
                    }
                }
                o == i.length && i.push({
                    Name: "_xlnm._FilterDatabase",
                    Sheet: a,
                    Ref: "'" + r.SheetNames[a] + "'!" + s
                }), Br(e, 161, _a(Zr(s))), Br(e, 162);
            }
        }(n, i, r, e), Fl(n, i), Ll(n, i, a), i["!margins"] && Br(n, 476, (c = i["!margins"], null == l && (l = Lr(48)), Qc(c), Il.forEach(function(e) {
            Aa(c[e], l);
        }), l)), t && !t.ignoreEC && null != t.ignoreEC || Pl(n, i), s = n, t = e, a, 0 < i["!comments"].length && (t = Ja(a, -1, "../drawings/vmlDrawing" + (t + 1) + ".vml", $a.VML), Br(s, 551, Ta("rId" + t)), i["!legacy"] = t), Br(n, 130), n.end();
    }
    function Wl(e, t, r, a, n, s) {
        var i = s || {
            "!type": "chart"
        };
        if (!e) return s;
        var o, c = 0, l = 0, f = {
            s: {
                r: 2e6,
                c: 2e6
            },
            e: {
                r: 0,
                c: 0
            }
        };
        return (e.match(/<c:numCache>[\s\S]*?<\/c:numCache>/gm) || []).forEach(function(e) {
            var r = function(e) {
                var t, r = [], a = e.match(/^<c:numCache>/);
                (e.match(/<c:pt idx="(\d*)">(.*?)<\/c:pt>/gm) || []).forEach(function(e) {
                    e = e.match(/<c:pt idx="(\d*?)"><c:v>(.*)<\/c:v><\/c:pt>/);
                    e && (r[+e[1]] = a ? +e[2] : e[2]);
                });
                var n = wt((e.match(/<c:formatCode>([\s\S]*?)<\/c:formatCode>/) || [
                    "",
                    "General"
                ])[1]);
                return (e.match(/<c:f>(.*?)<\/c:f>/gm) || []).forEach(function(e) {
                    t = e.replace(/<.*?>/g, "");
                }), [
                    r,
                    n,
                    t
                ];
            }(e);
            f.s.r = f.s.c = 0, f.e.c = c, o = Xr(c), r[0].forEach(function(e, t) {
                i[o + jr(t)] = {
                    t: "n",
                    v: e,
                    z: r[1]
                }, l = t;
            }), f.e.r < l && (f.e.r = l), ++c;
        }), 0 < c && (i["!ref"] = qr(f)), i;
    }
    var Hl = [
        [
            "allowRefreshQuery",
            !1,
            "bool"
        ],
        [
            "autoCompressPictures",
            !0,
            "bool"
        ],
        [
            "backupFile",
            !1,
            "bool"
        ],
        [
            "checkCompatibility",
            !1,
            "bool"
        ],
        [
            "CodeName",
            ""
        ],
        [
            "date1904",
            !1,
            "bool"
        ],
        [
            "defaultThemeVersion",
            0,
            "int"
        ],
        [
            "filterPrivacy",
            !1,
            "bool"
        ],
        [
            "hidePivotFieldList",
            !1,
            "bool"
        ],
        [
            "promptedSolutions",
            !1,
            "bool"
        ],
        [
            "publishItems",
            !1,
            "bool"
        ],
        [
            "refreshAllConnections",
            !1,
            "bool"
        ],
        [
            "saveExternalLinkValues",
            !0,
            "bool"
        ],
        [
            "showBorderUnselectedTables",
            !0,
            "bool"
        ],
        [
            "showInkAnnotation",
            !0,
            "bool"
        ],
        [
            "showObjects",
            "all"
        ],
        [
            "showPivotChartFilter",
            !1,
            "bool"
        ],
        [
            "updateLinks",
            "userSet"
        ]
    ], zl = [
        [
            "activeTab",
            0,
            "int"
        ],
        [
            "autoFilterDateGrouping",
            !0,
            "bool"
        ],
        [
            "firstSheet",
            0,
            "int"
        ],
        [
            "minimized",
            !1,
            "bool"
        ],
        [
            "showHorizontalScroll",
            !0,
            "bool"
        ],
        [
            "showSheetTabs",
            !0,
            "bool"
        ],
        [
            "showVerticalScroll",
            !0,
            "bool"
        ],
        [
            "tabRatio",
            600,
            "int"
        ],
        [
            "visibility",
            "visible"
        ]
    ], Vl = [], Gl = [
        [
            "calcCompleted",
            "true"
        ],
        [
            "calcMode",
            "auto"
        ],
        [
            "calcOnSave",
            "true"
        ],
        [
            "concurrentCalc",
            "true"
        ],
        [
            "fullCalcOnLoad",
            "false"
        ],
        [
            "fullPrecision",
            "true"
        ],
        [
            "iterate",
            "false"
        ],
        [
            "iterateCount",
            "100"
        ],
        [
            "iterateDelta",
            "0.001"
        ],
        [
            "refMode",
            "A1"
        ]
    ];
    function jl(e, t) {
        for(var r = 0; r != e.length; ++r)for(var a = e[r], n = 0; n != t.length; ++n){
            var s = t[n];
            if (null == a[s[0]]) a[s[0]] = s[1];
            else switch(s[2]){
                case "bool":
                    "string" == typeof a[s[0]] && (a[s[0]] = Rt(a[s[0]]));
                    break;
                case "int":
                    "string" == typeof a[s[0]] && (a[s[0]] = parseInt(a[s[0]], 10));
            }
        }
    }
    function $l(e, t) {
        for(var r = 0; r != t.length; ++r){
            var a = t[r];
            if (null == e[a[0]]) e[a[0]] = a[1];
            else switch(a[2]){
                case "bool":
                    "string" == typeof e[a[0]] && (e[a[0]] = Rt(e[a[0]]));
                    break;
                case "int":
                    "string" == typeof e[a[0]] && (e[a[0]] = parseInt(e[a[0]], 10));
            }
        }
    }
    function Xl(e) {
        $l(e.WBProps, Hl), $l(e.CalcPr, Gl), jl(e.WBView, zl), jl(e.Sheets, Vl), Kc.date1904 = Rt(e.WBProps.date1904);
    }
    var Yl = "][*?/\\".split("");
    function Kl(t, r) {
        if (31 < t.length) {
            if (r) return;
            throw new Error("Sheet names cannot exceed 31 chars");
        }
        var a = !0;
        return Yl.forEach(function(e) {
            if (-1 != t.indexOf(e)) {
                if (!r) throw new Error("Sheet name cannot contain : \\ / ? * [ ]");
                a = !1;
            }
        }), a;
    }
    function Jl(e) {
        if (!e || !e.SheetNames || !e.Sheets) throw new Error("Invalid Workbook");
        if (!e.SheetNames.length) throw new Error("Workbook is empty");
        var n, s, i, t = e.Workbook && e.Workbook.Sheets || [];
        n = e.SheetNames, s = t, i = !!e.vbaraw, n.forEach(function(e, t) {
            Kl(e);
            for(var r = 0; r < t; ++r)if (e == n[r]) throw new Error("Duplicate Sheet Name: " + e);
            if (i) {
                var a = s && s[t] && s[t].CodeName || e;
                if (95 == a.charCodeAt(0) && 22 < a.length) throw new Error("Bad Code Name: Worksheet" + a);
            }
        });
        for(var r = 0; r < e.SheetNames.length; ++r)!function(e, t) {
            if (e && e["!ref"]) {
                var r = Zr(e["!ref"]);
                if (r.e.c < r.s.c || r.e.r < r.s.r) throw new Error("Bad range (" + t + "): " + e["!ref"]);
            }
        }(e.Sheets[e.SheetNames[r]], (e.SheetNames[r], r));
    }
    var ql = /<\w+:workbook/;
    function Zl(t) {
        var r = [
            ot
        ];
        r[r.length] = Yt("workbook", null, {
            xmlns: Qt[0],
            "xmlns:r": Zt.r
        });
        var e = t.Workbook && 0 < (t.Workbook.Names || []).length, a = {
            codeName: "ThisWorkbook"
        };
        t.Workbook && t.Workbook.WBProps && (Hl.forEach(function(e) {
            null != t.Workbook.WBProps[e[0]] && t.Workbook.WBProps[e[0]] != e[1] && (a[e[0]] = t.Workbook.WBProps[e[0]]);
        }), t.Workbook.WBProps.CodeName && (a.codeName = t.Workbook.WBProps.CodeName, delete a.CodeName)), r[r.length] = Yt("workbookPr", null, a);
        var n = t.Workbook && t.Workbook.Sheets || [], s = 0;
        if (n && n[0] && n[0].Hidden) {
            for(r[r.length] = "<bookViews>", s = 0; s != t.SheetNames.length && n[s] && n[s].Hidden; ++s);
            s == t.SheetNames.length && (s = 0), r[r.length] = '<workbookView firstSheet="' + s + '" activeTab="' + s + '"/>', r[r.length] = "</bookViews>";
        }
        for(r[r.length] = "<sheets>", s = 0; s != t.SheetNames.length; ++s){
            var i = {
                name: kt(t.SheetNames[s].slice(0, 31))
            };
            if (i.sheetId = "" + (s + 1), i["r:id"] = "rId" + (s + 1), n[s]) switch(n[s].Hidden){
                case 1:
                    i.state = "hidden";
                    break;
                case 2:
                    i.state = "veryHidden";
            }
            r[r.length] = Yt("sheet", null, i);
        }
        return r[r.length] = "</sheets>", e && (r[r.length] = "<definedNames>", t.Workbook && t.Workbook.Names && t.Workbook.Names.forEach(function(e) {
            var t = {
                name: e.Name
            };
            e.Comment && (t.comment = e.Comment), null != e.Sheet && (t.localSheetId = "" + e.Sheet), e.Hidden && (t.hidden = "1"), e.Ref && (r[r.length] = Yt("definedName", kt(e.Ref), t));
        }), r[r.length] = "</definedNames>"), 2 < r.length && (r[r.length] = "</workbook>", r[1] = r[1].replace("/>", ">")), r.join("");
    }
    function Ql(e, t) {
        var r = {};
        return e.read_shift(4), r.ArchID = e.read_shift(4), e.l += t - 8, r;
    }
    function ef(e, t) {
        Br(e, 143);
        for(var r, a = 0; a != t.SheetNames.length; ++a){
            var n = {
                Hidden: t.Workbook && t.Workbook.Sheets && t.Workbook.Sheets[a] && t.Workbook.Sheets[a].Hidden || 0,
                iTabID: a + 1,
                strRelID: "rId" + (a + 1),
                name: t.SheetNames[a]
            };
            Br(e, 156, (r = n, (n = (n = void 0, Lr(127))).write_shift(4, r.Hidden), n.write_shift(4, r.iTabID), Ta(r.strRelID, n), ia(r.name.slice(0, 31), n), n.length > n.l ? n.slice(0, n.l) : n));
        }
        Br(e, 144);
    }
    function tf(e, t) {
        if (t.Workbook && t.Workbook.Sheets) {
            for(var r, a = t.Workbook.Sheets, n = 0, s = -1, i = -1; n < a.length; ++n)!a[n] || !a[n].Hidden && -1 == s ? s = n : 1 == a[n].Hidden && -1 == i && (i = n);
            s < i || (Br(e, 135), Br(e, 158, (t = s, (r = r || Lr(29)).write_shift(-4, 0), r.write_shift(-4, 460), r.write_shift(4, 28800), r.write_shift(4, 17600), r.write_shift(4, 500), r.write_shift(4, t), r.write_shift(4, t), r.write_shift(1, 120), r.length > r.l ? r.slice(0, r.l) : r)), Br(e, 136));
        }
    }
    function rf(e, t) {
        var r = Ur();
        return Br(r, 131), Br(r, 128, function(e) {
            e = e || Lr(127);
            for(var t = 0; 4 != t; ++t)e.write_shift(4, 0);
            return ia("SheetJS", e), ia(a.version, e), ia(a.version, e), ia("7262", e), e.length > e.l ? e.slice(0, e.l) : e;
        }()), Br(r, 153, function(e, t) {
            t = t || Lr(72);
            var r = 0;
            return e && e.filterPrivacy && (r |= 8), t.write_shift(4, r), t.write_shift(4, 0), ma(e && e.CodeName || "ThisWorkbook", t), t.slice(0, t.l);
        }(e.Workbook && e.Workbook.WBProps || null)), tf(r, e), ef(r, e), Br(r, 132), r.end();
    }
    function af(e, t, r) {
        return (".bin" === t.slice(-4) ? function(e, a) {
            var n = {
                AppVersion: {},
                WBProps: {},
                WBView: [],
                Sheets: [],
                CalcPr: {},
                xmlns: ""
            }, s = [], i = !1;
            (a = a || {}).biff = 12;
            var o = [], c = [
                []
            ];
            return c.SheetNames = [], c.XTI = [], Df[16] = {
                n: "BrtFRTArchID$",
                f: Ql
            }, Mr(e, function(e, t, r) {
                switch(r){
                    case 156:
                        c.SheetNames.push(e.name), n.Sheets.push(e);
                        break;
                    case 153:
                        n.WBProps = e;
                        break;
                    case 39:
                        null != e.Sheet && (a.SID = e.Sheet), e.Ref = Pc(e.Ptg, 0, null, c, a), delete a.SID, delete e.Ptg, o.push(e);
                        break;
                    case 1036:
                        break;
                    case 357:
                    case 358:
                    case 355:
                    case 667:
                        c[0].length ? c.push([
                            r,
                            e
                        ]) : c[0] = [
                            r,
                            e
                        ], c[c.length - 1].XTI = [];
                        break;
                    case 362:
                        0 === c.length && (c[0] = [], c[0].XTI = []), c[c.length - 1].XTI = c[c.length - 1].XTI.concat(e), c.XTI = c.XTI.concat(e);
                        break;
                    case 361:
                        break;
                    case 2071:
                    case 158:
                    case 143:
                    case 664:
                    case 353:
                        break;
                    case 3072:
                    case 3073:
                    case 534:
                    case 677:
                    case 157:
                    case 610:
                    case 2050:
                    case 155:
                    case 548:
                    case 676:
                    case 128:
                    case 665:
                    case 2128:
                    case 2125:
                    case 549:
                    case 2053:
                    case 596:
                    case 2076:
                    case 2075:
                    case 2082:
                    case 397:
                    case 154:
                    case 1117:
                    case 553:
                    case 2091:
                        break;
                    case 35:
                        s.push(r), i = !0;
                        break;
                    case 36:
                        s.pop(), i = !1;
                        break;
                    case 37:
                        s.push(r), i = !0;
                        break;
                    case 38:
                        s.pop(), i = !1;
                        break;
                    case 16:
                        break;
                    default:
                        if (!t.T && (!i || a.WTF && 37 != s[s.length - 1] && 35 != s[s.length - 1])) throw new Error("Unexpected record 0x" + r.toString(16));
                }
            }, a), Xl(n), n.Names = o, n.supbooks = c, n;
        } : function(a, n) {
            if (!a) throw new Error("Could not find file");
            var s = {
                AppVersion: {},
                WBProps: {},
                WBView: [],
                Sheets: [],
                CalcPr: {},
                Names: [],
                xmlns: ""
            }, i = !1, o = "xmlns", c = {}, l = 0;
            if (a.replace(ft, function(e, t) {
                var r = dt(e);
                switch(pt(r[0])){
                    case "<?xml":
                        break;
                    case "<workbook":
                        e.match(ql) && (o = "xmlns" + e.match(/<(\w+):/)[1]), s.xmlns = r[o];
                        break;
                    case "</workbook>":
                        break;
                    case "<fileVersion":
                        delete r[0], s.AppVersion = r;
                        break;
                    case "<fileVersion/>":
                    case "</fileVersion>":
                    case "<fileSharing":
                    case "<fileSharing/>":
                        break;
                    case "<workbookPr":
                    case "<workbookPr/>":
                        Hl.forEach(function(e) {
                            if (null != r[e[0]]) switch(e[2]){
                                case "bool":
                                    s.WBProps[e[0]] = Rt(r[e[0]]);
                                    break;
                                case "int":
                                    s.WBProps[e[0]] = parseInt(r[e[0]], 10);
                                    break;
                                default:
                                    s.WBProps[e[0]] = r[e[0]];
                            }
                        }), r.codeName && (s.WBProps.CodeName = Mt(r.codeName));
                        break;
                    case "</workbookPr>":
                    case "<workbookProtection":
                    case "<workbookProtection/>":
                        break;
                    case "<bookViews":
                    case "<bookViews>":
                    case "</bookViews>":
                        break;
                    case "<workbookView":
                    case "<workbookView/>":
                        delete r[0], s.WBView.push(r);
                        break;
                    case "</workbookView>":
                        break;
                    case "<sheets":
                    case "<sheets>":
                    case "</sheets>":
                        break;
                    case "<sheet":
                        switch(r.state){
                            case "hidden":
                                r.Hidden = 1;
                                break;
                            case "veryHidden":
                                r.Hidden = 2;
                                break;
                            default:
                                r.Hidden = 0;
                        }
                        delete r.state, r.name = wt(Mt(r.name)), delete r[0], s.Sheets.push(r);
                        break;
                    case "</sheet>":
                        break;
                    case "<functionGroups":
                    case "<functionGroups/>":
                    case "<functionGroup":
                        break;
                    case "<externalReferences":
                    case "</externalReferences>":
                    case "<externalReferences>":
                    case "<externalReference":
                    case "<definedNames/>":
                        break;
                    case "<definedNames>":
                    case "<definedNames":
                        i = !0;
                        break;
                    case "</definedNames>":
                        i = !1;
                        break;
                    case "<definedName":
                        (c = {}).Name = Mt(r.name), r.comment && (c.Comment = r.comment), r.localSheetId && (c.Sheet = +r.localSheetId), Rt(r.hidden || "0") && (c.Hidden = !0), l = t + e.length;
                        break;
                    case "</definedName>":
                        c.Ref = wt(Mt(a.slice(l, t))), s.Names.push(c);
                        break;
                    case "<definedName/>":
                        break;
                    case "<calcPr":
                    case "<calcPr/>":
                        delete r[0], s.CalcPr = r;
                        break;
                    case "</calcPr>":
                    case "<oleSize":
                        break;
                    case "<customWorkbookViews>":
                    case "</customWorkbookViews>":
                    case "<customWorkbookViews":
                        break;
                    case "<customWorkbookView":
                    case "</customWorkbookView>":
                        break;
                    case "<pivotCaches>":
                    case "</pivotCaches>":
                    case "<pivotCaches":
                    case "<pivotCache":
                        break;
                    case "<smartTagPr":
                    case "<smartTagPr/>":
                        break;
                    case "<smartTagTypes":
                    case "<smartTagTypes>":
                    case "</smartTagTypes>":
                    case "<smartTagType":
                        break;
                    case "<webPublishing":
                    case "<webPublishing/>":
                        break;
                    case "<fileRecoveryPr":
                    case "<fileRecoveryPr/>":
                        break;
                    case "<webPublishObjects>":
                    case "<webPublishObjects":
                    case "</webPublishObjects>":
                    case "<webPublishObject":
                        break;
                    case "<extLst":
                    case "<extLst>":
                    case "</extLst>":
                    case "<extLst/>":
                        break;
                    case "<ext":
                        i = !0;
                        break;
                    case "</ext>":
                        i = !1;
                        break;
                    case "<ArchID":
                        break;
                    case "<AlternateContent":
                    case "<AlternateContent>":
                        i = !0;
                        break;
                    case "</AlternateContent>":
                        i = !1;
                        break;
                    case "<revisionPtr":
                        break;
                    default:
                        if (!i && n.WTF) throw new Error("unrecognized " + r[0] + " in workbook");
                }
                return e;
            }), -1 === Qt.indexOf(s.xmlns)) throw new Error("Unknown Namespace: " + s.xmlns);
            return Xl(s), s;
        })(e, r);
    }
    function nf(e, t, r, a, n, s, i, o) {
        return (".bin" === t.slice(-4) ? function(e, t, s, i, o, c, l) {
            if (!e) return e;
            var f = t || {};
            i = i || {
                "!id": {}
            }, null != oe && null == f.dense && (f.dense = oe);
            var h, u, d, p, m, g, b, v, w, T, E = f.dense ? [] : {}, k = {
                s: {
                    r: 2e6,
                    c: 2e6
                },
                e: {
                    r: 0,
                    c: 0
                }
            }, y = [], S = !1, _ = !1, x = [];
            f.biff = 12;
            var A = f["!row"] = 0, C = !1, R = [], O = {}, I = f.supbooks || o.supbooks || [
                []
            ];
            if (I.sharedf = O, I.arrayf = R, I.SheetNames = o.SheetNames || o.Sheets.map(function(e) {
                return e.name;
            }), !f.supbooks && (f.supbooks = I, o.Names)) for(var r = 0; r < o.Names.length; ++r)I[0][r + 1] = o.Names[r];
            var N, F = [], D = [], P = !1;
            return Df[16] = {
                n: "BrtShortReal",
                f: Rl
            }, Mr(e, function(e, t, r) {
                if (!_) switch(r){
                    case 148:
                        h = e;
                        break;
                    case 0:
                        u = e, f.sheetRows && f.sheetRows <= u.r && (_ = !0), w = jr(m = u.r), f["!row"] = u.r, (e.hidden || e.hpt || null != e.level) && (e.hpt && (e.hpx = po(e.hpt)), D[e.r] = e);
                        break;
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 8:
                    case 9:
                    case 10:
                    case 11:
                    case 13:
                    case 14:
                    case 15:
                    case 16:
                    case 17:
                    case 18:
                    case 62:
                        switch(d = {
                            t: e[2]
                        }, e[2]){
                            case "n":
                                d.v = e[1];
                                break;
                            case "s":
                                v = Yc[e[1]], d.v = v.t, d.r = v.r;
                                break;
                            case "b":
                                d.v = !!e[1];
                                break;
                            case "e":
                                d.v = e[1], !1 !== f.cellText && (d.w = Wa[d.v]);
                                break;
                            case "str":
                                d.t = "s", d.v = e[1];
                                break;
                            case "is":
                                d.t = "s", d.v = e[1].t;
                        }
                        if ((p = l.CellXf[e[0].iStyleRef]) && tl(d, p.numFmtId, null, f, c, l), g = -1 == e[0].c ? g + 1 : e[0].c, f.dense ? (E[m] || (E[m] = []), E[m][g] = d) : E[Xr(g) + w] = d, f.cellFormula) {
                            for(C = !1, A = 0; A < R.length; ++A){
                                var a = R[A];
                                u.r >= a[0].s.r && u.r <= a[0].e.r && g >= a[0].s.c && g <= a[0].e.c && (d.F = qr(a[0]), C = !0);
                            }
                            !C && 3 < e.length && (d.f = e[3]);
                        }
                        k.s.r > u.r && (k.s.r = u.r), k.s.c > g && (k.s.c = g), k.e.r < u.r && (k.e.r = u.r), k.e.c < g && (k.e.c = g), f.cellDates && p && "n" == d.t && q(me[p.numFmtId]) && (n = L(d.v)) && (d.t = "d", d.v = new Date(n.y, n.m - 1, n.d, n.H, n.M, n.S, n.u)), N && ("XLDAPR" == N.type && (d.D = !0), N = void 0);
                        break;
                    case 1:
                    case 12:
                        if (!f.sheetStubs || S) break;
                        d = {
                            t: "z",
                            v: void 0
                        }, g = -1 == e[0].c ? g + 1 : e[0].c, f.dense ? (E[m] || (E[m] = []), E[m][g] = d) : E[Xr(g) + w] = d, k.s.r > u.r && (k.s.r = u.r), k.s.c > g && (k.s.c = g), k.e.r < u.r && (k.e.r = u.r), k.e.c < g && (k.e.c = g), N && ("XLDAPR" == N.type && (d.D = !0), N = void 0);
                        break;
                    case 176:
                        x.push(e);
                        break;
                    case 49:
                        N = ((f.xlmeta || {}).Cell || [])[e - 1];
                        break;
                    case 494:
                        var n = i["!id"][e.relId];
                        for(n ? (e.Target = n.Target, e.loc && (e.Target += "#" + e.loc), e.Rel = n) : "" == e.relId && (e.Target = "#" + e.loc), m = e.rfx.s.r; m <= e.rfx.e.r; ++m)for(g = e.rfx.s.c; g <= e.rfx.e.c; ++g)f.dense ? (E[m] || (E[m] = []), E[m][g] || (E[m][g] = {
                            t: "z",
                            v: void 0
                        }), E[m][g].l = e) : (b = Kr({
                            c: g,
                            r: m
                        }), E[b] || (E[b] = {
                            t: "z",
                            v: void 0
                        }), E[b].l = e);
                        break;
                    case 426:
                        if (!f.cellFormula) break;
                        R.push(e), (T = f.dense ? E[m][g] : E[Xr(g) + w]).f = Pc(e[1], 0, {
                            r: u.r,
                            c: g
                        }, I, f), T.F = qr(e[0]);
                        break;
                    case 427:
                        if (!f.cellFormula) break;
                        O[Kr(e[0].s)] = e[1], (T = f.dense ? E[m][g] : E[Xr(g) + w]).f = Pc(e[1], 0, {
                            r: u.r,
                            c: g
                        }, I, f);
                        break;
                    case 60:
                        if (!f.cellStyles) break;
                        for(; e.e >= e.s;)F[e.e--] = {
                            width: e.w / 256,
                            hidden: !!(1 & e.flags),
                            level: e.level
                        }, P || (P = !0, lo(e.w / 256)), fo(F[e.e + 1]);
                        break;
                    case 161:
                        E["!autofilter"] = {
                            ref: qr(e)
                        };
                        break;
                    case 476:
                        E["!margins"] = e;
                        break;
                    case 147:
                        o.Sheets[s] || (o.Sheets[s] = {}), e.name && (o.Sheets[s].CodeName = e.name), (e.above || e.left) && (E["!outline"] = {
                            above: e.above,
                            left: e.left
                        });
                        break;
                    case 137:
                        o.Views || (o.Views = [
                            {}
                        ]), o.Views[0] || (o.Views[0] = {}), e.RTL && (o.Views[0].RTL = !0);
                        break;
                    case 485:
                        break;
                    case 64:
                    case 1053:
                    case 151:
                        break;
                    case 152:
                    case 175:
                    case 644:
                    case 625:
                    case 562:
                    case 396:
                    case 1112:
                    case 1146:
                    case 471:
                    case 1050:
                    case 649:
                    case 1105:
                    case 589:
                    case 607:
                    case 564:
                    case 1055:
                    case 168:
                    case 174:
                    case 1180:
                    case 499:
                    case 507:
                    case 550:
                    case 171:
                    case 167:
                    case 1177:
                    case 169:
                    case 1181:
                    case 551:
                    case 552:
                    case 661:
                    case 639:
                    case 478:
                    case 537:
                    case 477:
                    case 536:
                    case 1103:
                    case 680:
                    case 1104:
                    case 1024:
                    case 663:
                    case 535:
                    case 678:
                    case 504:
                    case 1043:
                    case 428:
                    case 170:
                    case 3072:
                    case 50:
                    case 2070:
                    case 1045:
                        break;
                    case 35:
                        S = !0;
                        break;
                    case 36:
                        S = !1;
                        break;
                    case 37:
                        y.push(r), S = !0;
                        break;
                    case 38:
                        y.pop(), S = !1;
                        break;
                    default:
                        if (!t.T && (!S || f.WTF)) throw new Error("Unexpected record 0x" + r.toString(16));
                }
            }, f), delete f.supbooks, delete f["!row"], !E["!ref"] && (k.s.r < 2e6 || h && (0 < h.e.r || 0 < h.e.c || 0 < h.s.r || 0 < h.s.c)) && (E["!ref"] = qr(h || k)), f.sheetRows && E["!ref"] && (e = Zr(E["!ref"]), f.sheetRows <= +e.e.r && (e.e.r = f.sheetRows - 1, e.e.r > k.e.r && (e.e.r = k.e.r), e.e.r < e.s.r && (e.s.r = e.e.r), e.e.c > k.e.c && (e.e.c = k.e.c), e.e.c < e.s.c && (e.s.c = e.e.c), E["!fullref"] = E["!ref"], E["!ref"] = qr(e))), 0 < x.length && (E["!merges"] = x), 0 < F.length && (E["!cols"] = F), 0 < D.length && (E["!rows"] = D), E;
        } : ul)(e, a, r, n, s, i, o);
    }
    function sf(e, t, r, a, n, s) {
        return ".bin" === t.slice(-4) ? function(e, a, n, t, s) {
            if (!e) return e;
            t = t || {
                "!id": {}
            };
            var i = {
                "!type": "chart",
                "!drawel": null,
                "!rel": ""
            }, o = [], c = !1;
            return Mr(e, function(e, t, r) {
                switch(r){
                    case 550:
                        i["!rel"] = e;
                        break;
                    case 651:
                        s.Sheets[n] || (s.Sheets[n] = {}), e.name && (s.Sheets[n].CodeName = e.name);
                        break;
                    case 562:
                    case 652:
                    case 669:
                    case 679:
                    case 551:
                    case 552:
                    case 476:
                    case 3072:
                        break;
                    case 35:
                        c = !0;
                        break;
                    case 36:
                        c = !1;
                        break;
                    case 37:
                        o.push(r);
                        break;
                    case 38:
                        o.pop();
                        break;
                    default:
                        if (0 < t.T) o.push(r);
                        else if (t.T < 0) o.pop();
                        else if (!c || a.WTF) throw new Error("Unexpected record 0x" + r.toString(16));
                }
            }, a), t["!id"][i["!rel"]] && (i["!drawel"] = t["!id"][i["!rel"]]), i;
        }(e, a, r, n, s) : function(e, t, r, a) {
            if (!e) return e;
            r = r || {
                "!id": {}
            };
            var n = {
                "!type": "chart",
                "!drawel": null,
                "!rel": ""
            }, s = e.match(ll);
            return s && dl(s[0], 0, a, t), (e = e.match(/drawing r:id="(.*?)"/)) && (n["!rel"] = e[1]), r["!id"][n["!rel"]] && (n["!drawel"] = r["!id"][n["!rel"]]), n;
        }(e, r, n, s);
    }
    function of(e, t, r, a) {
        return (".bin" === t.slice(-4) ? function(e, a, n) {
            var t, s = {
                NumberFmt: []
            };
            for(t in me)s.NumberFmt[t] = me[t];
            s.CellXf = [], s.Fonts = [];
            var i = [], o = !1;
            return Mr(e, function(e, t, r) {
                switch(r){
                    case 44:
                        s.NumberFmt[e[0]] = e[1], we(e[1], e[0]);
                        break;
                    case 43:
                        s.Fonts.push(e), null != e.color.theme && a && a.themeElements && a.themeElements.clrScheme && (e.color.rgb = eo(a.themeElements.clrScheme[e.color.theme].rgb, e.color.tint || 0));
                        break;
                    case 1025:
                    case 45:
                    case 46:
                        break;
                    case 47:
                        617 == i[i.length - 1] && s.CellXf.push(e);
                        break;
                    case 48:
                    case 507:
                    case 572:
                    case 475:
                        break;
                    case 1171:
                    case 2102:
                    case 1130:
                    case 512:
                    case 2095:
                    case 3072:
                        break;
                    case 35:
                        o = !0;
                        break;
                    case 36:
                        o = !1;
                        break;
                    case 37:
                        i.push(r), o = !0;
                        break;
                    case 38:
                        i.pop(), o = !1;
                        break;
                    default:
                        if (0 < t.T) i.push(r);
                        else if (t.T < 0) i.pop();
                        else if (!o || n.WTF && 37 != i[i.length - 1]) throw new Error("Unexpected record 0x" + r.toString(16));
                }
            }), s;
        } : So)(e, r, a);
    }
    function cf(e, t, r) {
        var a, n, s;
        return ".bin" === t.slice(-4) ? (a = r, s = (n = [], false), Mr(e, function(e, t, r) {
            switch(r){
                case 159:
                    n.Count = e[0], n.Unique = e[1];
                    break;
                case 19:
                    n.push(e);
                    break;
                case 160:
                    return 1;
                case 35:
                    s = !0;
                    break;
                case 36:
                    s = !1;
                    break;
                default:
                    if (t.T, !s || a.WTF) throw new Error("Unexpected record 0x" + r.toString(16));
            }
        }), n) : function(e, t) {
            var r = [], a = "";
            if (!e) return r;
            if (e = e.match(Ci)) {
                a = e[2].replace(Ri, "").split(Oi);
                for(var n = 0; n != a.length; ++n){
                    var s = Ai(a[n].trim(), t);
                    null != s && (r[r.length] = s);
                }
                e = dt(e[1]), r.Count = e.count, r.Unique = e.uniqueCount;
            }
            return r;
        }(e, r);
    }
    function lf(e, t, r) {
        var a, n, s, i, o;
        return ".bin" === t.slice(-4) ? (a = r, n = [], s = [], o = (i = {}, false), Mr(e, function(e, t, r) {
            switch(r){
                case 632:
                    s.push(e);
                    break;
                case 635:
                    i = e;
                    break;
                case 637:
                    i.t = e.t, i.h = e.h, i.r = e.r;
                    break;
                case 636:
                    if (i.author = s[i.iauthor], delete i.iauthor, a.sheetRows && i.rfx && a.sheetRows <= i.rfx.r) break;
                    i.t || (i.t = ""), delete i.rfx, n.push(i);
                    break;
                case 3072:
                    break;
                case 35:
                    o = !0;
                    break;
                case 36:
                    o = !1;
                    break;
                case 37:
                case 38:
                    break;
                default:
                    if (!t.T && (!o || a.WTF)) throw new Error("Unexpected record 0x" + r.toString(16));
            }
        }), n) : function(e, a) {
            if (e.match(/<(?:\w+:)?comments *\/>/)) return [];
            var n = [], s = [], t = e.match(/<(?:\w+:)?authors>([\s\S]*)<\/(?:\w+:)?authors>/);
            return t && t[1] && t[1].split(/<\/\w*:?author>/).forEach(function(e) {
                "" === e || "" === e.trim() || (e = e.match(/<(?:\w+:)?author[^>]*>(.*)/)) && n.push(e[1]);
            }), (e = e.match(/<(?:\w+:)?commentList>([\s\S]*)<\/(?:\w+:)?commentList>/)) && e[1] && e[1].split(/<\/\w*:?comment>/).forEach(function(e) {
                var t, r;
                "" === e || "" === e.trim() || (t = e.match(/<(?:\w+:)?comment[^>]*>/)) && (t = {
                    author: (r = dt(t[0])).authorId && n[r.authorId] || "sheetjsghost",
                    ref: r.ref,
                    guid: r.guid
                }, r = Yr(r.ref), a.sheetRows && a.sheetRows <= r.r || (e = !!(e = e.match(/<(?:\w+:)?text>([\s\S]*)<\/(?:\w+:)?text>/)) && !!e[1] && Ai(e[1]) || {
                    r: "",
                    t: "",
                    h: ""
                }, t.r = e.r, "<t></t>" == e.r && (e.t = e.h = ""), t.t = (e.t || "").replace(/\r\n/g, "\n").replace(/\r/g, "\n"), a.cellHTML && (t.h = e.h), s.push(t)));
            }), s;
        }(e, r);
    }
    function ff(e, t) {
        var a;
        return ".bin" === t.slice(-4) ? (a = [], Mr(e, function(e, t, r) {
            if (63 === r) a.push(e);
            else if (!t.T) throw new Error("Unexpected record 0x" + r.toString(16));
        }), a) : function(e) {
            var r = [];
            if (!e) return r;
            var a = 1;
            return (e.match(ft) || []).forEach(function(e) {
                var t = dt(e);
                switch(t[0]){
                    case "<?xml":
                        break;
                    case "<calcChain":
                    case "<calcChain>":
                    case "</calcChain>":
                        break;
                    case "<c":
                        delete t[0], t.i ? a = t.i : t.i = a, r.push(t);
                }
            }), r;
        }(e);
    }
    function hf(e, t, r, a) {
        if (".bin" === r.slice(-4)) return function(e, t) {
            if (!e) return e;
            var a = t || {}, n = !1;
            Mr(e, function(e, t, r) {
                switch(r){
                    case 359:
                    case 363:
                    case 364:
                    case 366:
                    case 367:
                    case 368:
                    case 369:
                    case 370:
                    case 371:
                    case 472:
                    case 577:
                    case 578:
                    case 579:
                    case 580:
                    case 581:
                    case 582:
                    case 583:
                    case 584:
                    case 585:
                    case 586:
                    case 587:
                        break;
                    case 35:
                        n = !0;
                        break;
                    case 36:
                        n = !1;
                        break;
                    default:
                        if (!t.T && (!n || a.WTF)) throw new Error("Unexpected record 0x" + r.toString(16));
                }
            }, a);
        }(e, a);
    }
    function uf(e, t, r) {
        var a, n, s, i, o;
        return ".bin" === t.slice(-4) ? (a = {
            Types: [],
            Cell: [],
            Value: []
        }, n = r || {}, i = (s = [], false), o = 2, Mr(e, function(e, t, r) {
            switch(r){
                case 335:
                    a.Types.push({
                        name: e.name
                    });
                    break;
                case 51:
                    e.forEach(function(e) {
                        1 == o ? a.Cell.push({
                            type: a.Types[e[0] - 1].name,
                            index: e[1]
                        }) : 0 == o && a.Value.push({
                            type: a.Types[e[0] - 1].name,
                            index: e[1]
                        });
                    });
                    break;
                case 337:
                    o = e ? 1 : 0;
                    break;
                case 338:
                    o = 2;
                    break;
                case 35:
                    s.push(r), i = !0;
                    break;
                case 36:
                    s.pop(), i = !1;
                    break;
                default:
                    if (!t.T && (!i || n.WTF && 35 != s[s.length - 1])) throw new Error("Unexpected record 0x" + r.toString(16));
            }
        }), a) : function(e, a) {
            var n = {
                Types: [],
                Cell: [],
                Value: []
            };
            if (!e) return n;
            var s, i = !1, o = 2;
            return e.replace(ft, function(e) {
                var t = dt(e);
                switch(pt(t[0])){
                    case "<?xml":
                        break;
                    case "<metadata":
                    case "</metadata>":
                        break;
                    case "<metadataTypes":
                    case "</metadataTypes>":
                        break;
                    case "<metadataType":
                        n.Types.push({
                            name: t.name
                        });
                        break;
                    case "</metadataType>":
                        break;
                    case "<futureMetadata":
                        for(var r = 0; r < n.Types.length; ++r)n.Types[r].name == t.name && (s = n.Types[r]);
                        break;
                    case "</futureMetadata>":
                    case "<bk>":
                    case "</bk>":
                        break;
                    case "<rc":
                        1 == o ? n.Cell.push({
                            type: n.Types[t.t - 1].name,
                            index: +t.v
                        }) : 0 == o && n.Value.push({
                            type: n.Types[t.t - 1].name,
                            index: +t.v
                        });
                        break;
                    case "</rc>":
                        break;
                    case "<cellMetadata":
                        o = 1;
                        break;
                    case "</cellMetadata>":
                        o = 2;
                        break;
                    case "<valueMetadata":
                        o = 0;
                        break;
                    case "</valueMetadata>":
                        o = 2;
                        break;
                    case "<extLst":
                    case "<extLst>":
                    case "</extLst>":
                    case "<extLst/>":
                        break;
                    case "<ext":
                        i = !0;
                        break;
                    case "</ext>":
                        i = !1;
                        break;
                    case "<rvb":
                        if (!s) break;
                        s.offsets || (s.offsets = []), s.offsets.push(+t.i);
                        break;
                    default:
                        if (!i && a.WTF) throw new Error("unrecognized " + t[0] + " in metadata");
                }
                return e;
            }), n;
        }(e, r);
    }
    var df, pf = /([\w:]+)=((?:")([^"]*)(?:")|(?:')([^']*)(?:'))/g, mf = /([\w:]+)=((?:")(?:[^"]*)(?:")|(?:')(?:[^']*)(?:'))/;
    function gf(e, t) {
        var r = e.split(/\s+/), a = [];
        if (t || (a[0] = r[0]), 1 === r.length) return a;
        var n, s, i, o = e.match(pf);
        if (o) for(i = 0; i != o.length; ++i)-1 === (s = (n = o[i].match(mf))[1].indexOf(":")) ? a[n[1]] = n[2].slice(1, n[2].length - 1) : a["xmlns:" === n[1].slice(0, 6) ? "xmlns" + n[1].slice(6) : n[1].slice(s + 1)] = n[2].slice(1, n[2].length - 1);
        return a;
    }
    function bf(e, t, r) {
        if ("z" !== e.t) {
            if (!r || !1 !== r.cellText) try {
                "e" === e.t ? e.w = e.w || Wa[e.v] : "General" === t ? "n" === e.t ? (0 | e.v) === e.v ? e.w = e.v.toString(10) : e.w = D(e.v) : e.w = P(e.v) : e.w = (a = t || "General", n = e.v, "General" === (a = df[a] || wt(a)) ? P(n) : ve(a, n));
            } catch (e) {
                if (r.WTF) throw e;
            }
            var a, n;
            try {
                var s = df[t] || t || "General";
                r.cellNF && (e.z = s), r.cellDates && "n" == e.t && q(s) && (s = L(e.v)) && (e.t = "d", e.v = new Date(s.y, s.m - 1, s.d, s.H, s.M, s.S, s.u));
            } catch (e) {
                if (r.WTF) throw e;
            }
        }
    }
    function vf(e, t) {
        var r = t || {};
        Ee();
        var a, n = ne(Jt(e)), s = (n = "binary" == r.type || "array" == r.type || "base64" == r.type ? void 0 !== re ? re.utils.decode(65001, ae(n)) : Mt(n) : n).slice(0, 1024).toLowerCase(), i = !1;
        if ((1023 & (s = s.replace(/".*?"/g, "")).indexOf(">")) > Math.min(1023 & s.indexOf(","), 1023 & s.indexOf(";"))) {
            var o = Ve(r);
            return o.type = "string", Ks.to_workbook(n, o);
        }
        if (-1 == s.indexOf("<?xml") && [
            "html",
            "table",
            "head",
            "meta",
            "script",
            "style",
            "div"
        ].forEach(function(e) {
            0 <= s.indexOf("<" + e) && (i = !0);
        }), i) return function(e, r) {
            e = e.match(/<table[\s\S]*?>[\s\S]*?<\/table>/gi);
            if (!e || 0 == e.length) throw new Error("Invalid HTML: could not find <table>");
            if (1 == e.length) return ta(Yf(e[0], r), r);
            var a = du();
            return e.forEach(function(e, t) {
                pu(a, Yf(e, r), "Sheet" + (t + 1));
            }), a;
        }(n, r);
        df = {
            "General Number": "General",
            "General Date": me[22],
            "Long Date": "dddd, mmmm dd, yyyy",
            "Medium Date": me[15],
            "Short Date": me[14],
            "Long Time": me[19],
            "Medium Time": me[18],
            "Short Time": me[20],
            Currency: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
            Fixed: me[2],
            Standard: me[4],
            Percent: me[10],
            Scientific: me[11],
            "Yes/No": '"Yes";"Yes";"No";@',
            "True/False": '"True";"True";"False";@',
            "On/Off": '"Yes";"Yes";"No";@'
        };
        var c, l = [];
        null != oe && null == r.dense && (r.dense = oe);
        var f, h = {}, u = [], d = r.dense ? [] : {}, p = "", m = {}, g = {}, b = gf('<Data ss:Type="String">'), v = 0, w = 0, T = 0, E = {
            s: {
                r: 2e6,
                c: 2e6
            },
            e: {
                r: 0,
                c: 0
            }
        }, k = {}, y = {}, S = "", _ = 0, x = [], A = {}, C = {}, R = 0, O = [], I = [], N = {}, F = [], D = !1, P = [], L = [], M = {}, U = 0, B = 0, W = {
            Sheets: [],
            WBProps: {
                date1904: !1
            }
        }, H = {};
        qt.lastIndex = 0, n = n.replace(/<!--([\s\S]*?)-->/gm, "");
        for(var z, V, G, j, $1 = ""; a = qt.exec(n);)switch(a[3] = ($1 = a[3]).toLowerCase()){
            case "data":
                if ("data" == $1) {
                    if ("/" === a[1]) {
                        if ((c = l.pop())[0] !== a[3]) throw new Error("Bad state: " + c.join("|"));
                    } else "/" !== a[0].charAt(a[0].length - 2) && l.push([
                        a[3],
                        !0
                    ]);
                    break;
                }
                if (l[l.length - 1][1]) break;
                "/" === a[1] ? function(e, t, r, a, n, s, i, o, c, l) {
                    var f = "General", h = a.StyleID, u = {};
                    l = l || {};
                    var d = [], p = 0;
                    for(void 0 === (h = void 0 === h && o ? o.StyleID : h) && i && (h = i.StyleID); void 0 !== s[h] && (s[h].nf && (f = s[h].nf), s[h].Interior && d.push(s[h].Interior), s[h].Parent);)h = s[h].Parent;
                    switch(r.Type){
                        case "Boolean":
                            a.t = "b", a.v = Rt(e);
                            break;
                        case "String":
                            a.t = "s", a.r = At(wt(e)), a.v = -1 < e.indexOf("<") ? wt(t || e).replace(/<.*?>/g, "") : a.r;
                            break;
                        case "DateTime":
                            "Z" != e.slice(-1) && (e += "Z"), a.v = (He(e) - new Date(Date.UTC(1899, 11, 30))) / 864e5, a.v != a.v ? a.v = wt(e) : a.v < 60 && (a.v = a.v - 1), f && "General" != f || (f = "yyyy-mm-dd");
                        case "Number":
                            void 0 === a.v && (a.v = +e), a.t || (a.t = "n");
                            break;
                        case "Error":
                            a.t = "e", a.v = Ha[e], !1 !== l.cellText && (a.w = e);
                            break;
                        default:
                            "" == e && "" == t ? a.t = "z" : (a.t = "s", a.v = At(t || e));
                    }
                    if (bf(a, f, l), !1 !== l.cellFormula) {
                        if (a.Formula) {
                            r = wt(a.Formula);
                            61 == r.charCodeAt(0) && (r = r.slice(1)), a.f = oc(r, n), delete a.Formula, "RC" == a.ArrayRange ? a.F = oc("RC:RC", n) : a.ArrayRange && (a.F = oc(a.ArrayRange, n), c.push([
                                Zr(a.F),
                                a.F
                            ]));
                        } else for(p = 0; p < c.length; ++p)n.r >= c[p][0].s.r && n.r <= c[p][0].e.r && n.c >= c[p][0].s.c && n.c <= c[p][0].e.c && (a.F = c[p][1]);
                    }
                    l.cellStyles && (d.forEach(function(e) {
                        !u.patternType && e.patternType && (u.patternType = e.patternType);
                    }), a.s = u), void 0 !== a.StyleID && (a.ixfe = a.StyleID);
                }(n.slice(v, a.index), S, b, "comment" == l[l.length - 1][0] ? N : m, {
                    c: w,
                    r: T
                }, k, F[w], g, P, r) : (S = "", b = gf(a[0]), v = a.index + a[0].length);
                break;
            case "cell":
                if ("/" === a[1]) {
                    if (0 < I.length && (m.c = I), (!r.sheetRows || r.sheetRows > T) && void 0 !== m.v && (r.dense ? (d[T] || (d[T] = []), d[T][w] = m) : d[Xr(w) + jr(T)] = m), m.HRef && (m.l = {
                        Target: wt(m.HRef)
                    }, m.HRefScreenTip && (m.l.Tooltip = m.HRefScreenTip), delete m.HRef, delete m.HRefScreenTip), (m.MergeAcross || m.MergeDown) && (U = w + (0 | parseInt(m.MergeAcross, 10)), B = T + (0 | parseInt(m.MergeDown, 10)), x.push({
                        s: {
                            c: w,
                            r: T
                        },
                        e: {
                            c: U,
                            r: B
                        }
                    })), r.sheetStubs) {
                        if (m.MergeAcross || m.MergeDown) {
                            for(var X = w; X <= U; ++X)for(var Y = T; Y <= B; ++Y)(w < X || T < Y) && (r.dense ? (d[Y] || (d[Y] = []), d[Y][X] = {
                                t: "z"
                            }) : d[Xr(X) + jr(Y)] = {
                                t: "z"
                            });
                            w = U + 1;
                        } else ++w;
                    } else m.MergeAcross ? w = U + 1 : ++w;
                } else (w = (m = function(e) {
                    var t = {};
                    if (1 === e.split(/\s+/).length) return t;
                    var r, a, n, s = e.match(pf);
                    if (s) for(n = 0; n != s.length; ++n)-1 === (a = (r = s[n].match(mf))[1].indexOf(":")) ? t[r[1]] = r[2].slice(1, r[2].length - 1) : t["xmlns:" === r[1].slice(0, 6) ? "xmlns" + r[1].slice(6) : r[1].slice(a + 1)] = r[2].slice(1, r[2].length - 1);
                    return t;
                }(a[0])).Index ? +m.Index - 1 : w) < E.s.c && (E.s.c = w), w > E.e.c && (E.e.c = w), "/>" === a[0].slice(-2) && ++w, I = [];
                break;
            case "row":
                "/" === a[1] || "/>" === a[0].slice(-2) ? (T < E.s.r && (E.s.r = T), T > E.e.r && (E.e.r = T), "/>" === a[0].slice(-2) && (g = gf(a[0])).Index && (T = +g.Index - 1), w = 0, ++T) : ((g = gf(a[0])).Index && (T = +g.Index - 1), M = {}, "0" != g.AutoFitHeight && !g.Height || (M.hpx = parseInt(g.Height, 10), M.hpt = uo(M.hpx), L[T] = M), "1" == g.Hidden && (M.hidden = !0, L[T] = M));
                break;
            case "worksheet":
                if ("/" === a[1]) {
                    if ((c = l.pop())[0] !== a[3]) throw new Error("Bad state: " + c.join("|"));
                    u.push(p), E.s.r <= E.e.r && E.s.c <= E.e.c && (d["!ref"] = qr(E), r.sheetRows && r.sheetRows <= E.e.r && (d["!fullref"] = d["!ref"], E.e.r = r.sheetRows - 1, d["!ref"] = qr(E))), x.length && (d["!merges"] = x), 0 < F.length && (d["!cols"] = F), 0 < L.length && (d["!rows"] = L), h[p] = d;
                } else E = {
                    s: {
                        r: 2e6,
                        c: 2e6
                    },
                    e: {
                        r: 0,
                        c: 0
                    }
                }, T = w = 0, l.push([
                    a[3],
                    !1
                ]), c = gf(a[0]), p = wt(c.Name), d = r.dense ? [] : {}, x = [], P = [], L = [], H = {
                    name: p,
                    Hidden: 0
                }, W.Sheets.push(H);
                break;
            case "table":
                if ("/" === a[1]) {
                    if ((c = l.pop())[0] !== a[3]) throw new Error("Bad state: " + c.join("|"));
                } else {
                    if ("/>" == a[0].slice(-2)) break;
                    l.push([
                        a[3],
                        !1
                    ]), D = (F = [], false);
                }
                break;
            case "style":
                "/" === a[1] ? (V = k, G = y, (j = r).cellStyles && (!G.Interior || (j = G.Interior).Pattern && (j.patternType = mo[j.Pattern] || j.Pattern)), V[G.ID] = G) : y = gf(a[0]);
                break;
            case "numberformat":
                y.nf = wt(gf(a[0]).Format || "General"), df[y.nf] && (y.nf = df[y.nf]);
                for(var K = 0; 392 != K && me[K] != y.nf; ++K);
                if (392 == K) {
                    for(K = 57; 392 != K; ++K)if (null == me[K]) {
                        we(y.nf, K);
                        break;
                    }
                }
                break;
            case "column":
                if ("table" !== l[l.length - 1][0]) break;
                if ((f = gf(a[0])).Hidden && (f.hidden = !0, delete f.Hidden), f.Width && (f.wpx = parseInt(f.Width, 10)), !D && 10 < f.wpx) {
                    D = !0, no = to;
                    for(var J = 0; J < F.length; ++J)F[J] && fo(F[J]);
                }
                D && fo(f), F[f.Index - 1 || F.length] = f;
                for(var q = 0; q < +f.Span; ++q)F[F.length] = Ve(f);
                break;
            case "namedrange":
                if ("/" === a[1]) break;
                W.Names || (W.Names = []);
                var Z = dt(a[0]), Q = {
                    Name: Z.Name,
                    Ref: oc(Z.RefersTo.slice(1), {
                        r: 0,
                        c: 0
                    })
                };
                0 < W.Sheets.length && (Q.Sheet = W.Sheets.length - 1), W.Names.push(Q);
                break;
            case "namedcell":
            case "b":
            case "i":
            case "u":
            case "s":
            case "em":
            case "h2":
            case "h3":
            case "sub":
            case "sup":
            case "span":
            case "alignment":
            case "borders":
            case "border":
                break;
            case "font":
                if ("/>" === a[0].slice(-2)) break;
                "/" === a[1] ? S += n.slice(_, a.index) : _ = a.index + a[0].length;
                break;
            case "interior":
                if (!r.cellStyles) break;
                y.Interior = gf(a[0]);
                break;
            case "protection":
                break;
            case "author":
            case "title":
            case "description":
            case "created":
            case "keywords":
            case "subject":
            case "category":
            case "company":
            case "lastauthor":
            case "lastsaved":
            case "lastprinted":
            case "version":
            case "revision":
            case "totaltime":
            case "hyperlinkbase":
            case "manager":
            case "contentstatus":
            case "identifier":
            case "language":
            case "appname":
                if ("/>" === a[0].slice(-2)) break;
                "/" === a[1] ? (G = A, Z = $1, Q = n.slice(R, a.index), G[Z = (un = un || Ie(dn))[Z] || Z] = Q) : R = a.index + a[0].length;
                break;
            case "paragraphs":
                break;
            case "styles":
            case "workbook":
                if ("/" === a[1]) {
                    if ((c = l.pop())[0] !== a[3]) throw new Error("Bad state: " + c.join("|"));
                } else l.push([
                    a[3],
                    !1
                ]);
                break;
            case "comment":
                if ("/" === a[1]) {
                    if ((c = l.pop())[0] !== a[3]) throw new Error("Bad state: " + c.join("|"));
                    (z = N).t = z.v || "", z.t = z.t.replace(/\r\n/g, "\n").replace(/\r/g, "\n"), z.v = z.w = z.ixfe = void 0, I.push(N);
                } else l.push([
                    a[3],
                    !1
                ]), N = {
                    a: (c = gf(a[0])).Author
                };
                break;
            case "autofilter":
                if ("/" === a[1]) {
                    if ((c = l.pop())[0] !== a[3]) throw new Error("Bad state: " + c.join("|"));
                } else "/" !== a[0].charAt(a[0].length - 2) && (z = gf(a[0]), d["!autofilter"] = {
                    ref: oc(z.Range).replace(/\$/g, "")
                }, l.push([
                    a[3],
                    !0
                ]));
                break;
            case "name":
                break;
            case "datavalidation":
                if ("/" === a[1]) {
                    if ((c = l.pop())[0] !== a[3]) throw new Error("Bad state: " + c.join("|"));
                } else "/" !== a[0].charAt(a[0].length - 2) && l.push([
                    a[3],
                    !0
                ]);
                break;
            case "pixelsperinch":
                break;
            case "componentoptions":
            case "documentproperties":
            case "customdocumentproperties":
            case "officedocumentsettings":
            case "pivottable":
            case "pivotcache":
            case "names":
            case "mapinfo":
            case "pagebreaks":
            case "querytable":
            case "sorting":
            case "schema":
            case "conditionalformatting":
            case "smarttagtype":
            case "smarttags":
            case "excelworkbook":
            case "workbookoptions":
            case "worksheetoptions":
                if ("/" === a[1]) {
                    if ((c = l.pop())[0] !== a[3]) throw new Error("Bad state: " + c.join("|"));
                } else "/" !== a[0].charAt(a[0].length - 2) && l.push([
                    a[3],
                    !0
                ]);
                break;
            case "null":
                break;
            default:
                if (0 == l.length && "document" == a[3]) return ih(n, r);
                if (0 == l.length && "uof" == a[3]) return ih(n, r);
                var ee = !0;
                switch(l[l.length - 1][0]){
                    case "officedocumentsettings":
                        switch(a[3]){
                            case "allowpng":
                            case "removepersonalinformation":
                            case "downloadcomponents":
                            case "locationofcomponents":
                            case "colors":
                            case "color":
                            case "index":
                            case "rgb":
                            case "targetscreensize":
                            case "readonlyrecommended":
                                break;
                            default:
                                ee = !1;
                        }
                        break;
                    case "componentoptions":
                        switch(a[3]){
                            case "toolbar":
                            case "hideofficelogo":
                            case "spreadsheetautofit":
                            case "label":
                            case "caption":
                            case "maxheight":
                            case "maxwidth":
                            case "nextsheetnumber":
                                break;
                            default:
                                ee = !1;
                        }
                        break;
                    case "excelworkbook":
                        switch(a[3]){
                            case "date1904":
                                W.WBProps.date1904 = !0;
                                break;
                            case "windowheight":
                            case "windowwidth":
                            case "windowtopx":
                            case "windowtopy":
                            case "tabratio":
                            case "protectstructure":
                            case "protectwindow":
                            case "protectwindows":
                            case "activesheet":
                            case "displayinknotes":
                            case "firstvisiblesheet":
                            case "supbook":
                            case "sheetname":
                            case "sheetindex":
                            case "sheetindexfirst":
                            case "sheetindexlast":
                            case "dll":
                            case "acceptlabelsinformulas":
                            case "donotsavelinkvalues":
                            case "iteration":
                            case "maxiterations":
                            case "maxchange":
                            case "path":
                            case "xct":
                            case "count":
                            case "selectedsheets":
                            case "calculation":
                            case "uncalced":
                            case "startupprompt":
                            case "crn":
                            case "externname":
                            case "formula":
                            case "colfirst":
                            case "collast":
                            case "wantadvise":
                            case "boolean":
                            case "error":
                            case "text":
                            case "ole":
                            case "noautorecover":
                            case "publishobjects":
                            case "donotcalculatebeforesave":
                            case "number":
                            case "refmoder1c1":
                            case "embedsavesmarttags":
                                break;
                            default:
                                ee = !1;
                        }
                        break;
                    case "workbookoptions":
                        switch(a[3]){
                            case "owcversion":
                            case "height":
                            case "width":
                                break;
                            default:
                                ee = !1;
                        }
                        break;
                    case "worksheetoptions":
                        switch(a[3]){
                            case "visible":
                                if ("/>" !== a[0].slice(-2)) {
                                    if ("/" === a[1]) switch(n.slice(R, a.index)){
                                        case "SheetHidden":
                                            H.Hidden = 1;
                                            break;
                                        case "SheetVeryHidden":
                                            H.Hidden = 2;
                                    }
                                    else R = a.index + a[0].length;
                                }
                                break;
                            case "header":
                                d["!margins"] || Qc(d["!margins"] = {}, "xlml"), isNaN(+dt(a[0]).Margin) || (d["!margins"].header = +dt(a[0]).Margin);
                                break;
                            case "footer":
                                d["!margins"] || Qc(d["!margins"] = {}, "xlml"), isNaN(+dt(a[0]).Margin) || (d["!margins"].footer = +dt(a[0]).Margin);
                                break;
                            case "pagemargins":
                                var te = dt(a[0]);
                                d["!margins"] || Qc(d["!margins"] = {}, "xlml"), isNaN(+te.Top) || (d["!margins"].top = +te.Top), isNaN(+te.Left) || (d["!margins"].left = +te.Left), isNaN(+te.Right) || (d["!margins"].right = +te.Right), isNaN(+te.Bottom) || (d["!margins"].bottom = +te.Bottom);
                                break;
                            case "displayrighttoleft":
                                W.Views || (W.Views = []), W.Views[0] || (W.Views[0] = {}), W.Views[0].RTL = !0;
                                break;
                            case "freezepanes":
                            case "frozennosplit":
                                break;
                            case "splithorizontal":
                            case "splitvertical":
                            case "donotdisplaygridlines":
                            case "activerow":
                            case "activecol":
                            case "toprowbottompane":
                            case "leftcolumnrightpane":
                            case "unsynced":
                            case "print":
                            case "printerrors":
                            case "panes":
                            case "scale":
                            case "pane":
                            case "number":
                            case "layout":
                            case "pagesetup":
                            case "selected":
                            case "protectobjects":
                            case "enableselection":
                            case "protectscenarios":
                            case "validprinterinfo":
                            case "horizontalresolution":
                            case "verticalresolution":
                            case "numberofcopies":
                            case "activepane":
                            case "toprowvisible":
                            case "leftcolumnvisible":
                            case "fittopage":
                            case "rangeselection":
                            case "papersizeindex":
                            case "pagelayoutzoom":
                            case "pagebreakzoom":
                            case "filteron":
                            case "fitwidth":
                            case "fitheight":
                            case "commentslayout":
                            case "zoom":
                            case "lefttoright":
                            case "gridlines":
                            case "allowsort":
                            case "allowfilter":
                            case "allowinsertrows":
                            case "allowdeleterows":
                            case "allowinsertcols":
                            case "allowdeletecols":
                            case "allowinserthyperlinks":
                            case "allowformatcells":
                            case "allowsizecols":
                            case "allowsizerows":
                                break;
                            case "nosummaryrowsbelowdetail":
                                d["!outline"] || (d["!outline"] = {}), d["!outline"].above = !0;
                                break;
                            case "tabcolorindex":
                            case "donotdisplayheadings":
                            case "showpagelayoutzoom":
                                break;
                            case "nosummarycolumnsrightdetail":
                                d["!outline"] || (d["!outline"] = {}), d["!outline"].left = !0;
                                break;
                            case "blackandwhite":
                            case "donotdisplayzeros":
                            case "displaypagebreak":
                            case "rowcolheadings":
                            case "donotdisplayoutline":
                            case "noorientation":
                            case "allowusepivottables":
                            case "zeroheight":
                            case "viewablerange":
                            case "selection":
                            case "protectcontents":
                                break;
                            default:
                                ee = !1;
                        }
                        break;
                    case "pivottable":
                    case "pivotcache":
                        switch(a[3]){
                            case "immediateitemsondrop":
                            case "showpagemultipleitemlabel":
                            case "compactrowindent":
                            case "location":
                            case "pivotfield":
                            case "orientation":
                            case "layoutform":
                            case "layoutsubtotallocation":
                            case "layoutcompactrow":
                            case "position":
                            case "pivotitem":
                            case "datatype":
                            case "datafield":
                            case "sourcename":
                            case "parentfield":
                            case "ptlineitems":
                            case "ptlineitem":
                            case "countofsameitems":
                            case "item":
                            case "itemtype":
                            case "ptsource":
                            case "cacheindex":
                            case "consolidationreference":
                            case "filename":
                            case "reference":
                            case "nocolumngrand":
                            case "norowgrand":
                            case "blanklineafteritems":
                            case "hidden":
                            case "subtotal":
                            case "basefield":
                            case "mapchilditems":
                            case "function":
                            case "refreshonfileopen":
                            case "printsettitles":
                            case "mergelabels":
                            case "defaultversion":
                            case "refreshname":
                            case "refreshdate":
                            case "refreshdatecopy":
                            case "versionlastrefresh":
                            case "versionlastupdate":
                            case "versionupdateablemin":
                            case "versionrefreshablemin":
                            case "calculation":
                                break;
                            default:
                                ee = !1;
                        }
                        break;
                    case "pagebreaks":
                        switch(a[3]){
                            case "colbreaks":
                            case "colbreak":
                            case "rowbreaks":
                            case "rowbreak":
                            case "colstart":
                            case "colend":
                            case "rowend":
                                break;
                            default:
                                ee = !1;
                        }
                        break;
                    case "autofilter":
                        switch(a[3]){
                            case "autofiltercolumn":
                            case "autofiltercondition":
                            case "autofilterand":
                            case "autofilteror":
                                break;
                            default:
                                ee = !1;
                        }
                        break;
                    case "querytable":
                        switch(a[3]){
                            case "id":
                            case "autoformatfont":
                            case "autoformatpattern":
                            case "querysource":
                            case "querytype":
                            case "enableredirections":
                            case "refreshedinxl9":
                            case "urlstring":
                            case "htmltables":
                            case "connection":
                            case "commandtext":
                            case "refreshinfo":
                            case "notitles":
                            case "nextid":
                            case "columninfo":
                            case "overwritecells":
                            case "donotpromptforfile":
                            case "textwizardsettings":
                            case "source":
                            case "number":
                            case "decimal":
                            case "thousandseparator":
                            case "trailingminusnumbers":
                            case "formatsettings":
                            case "fieldtype":
                            case "delimiters":
                            case "tab":
                            case "comma":
                            case "autoformatname":
                            case "versionlastedit":
                            case "versionlastrefresh":
                                break;
                            default:
                                ee = !1;
                        }
                        break;
                    case "datavalidation":
                        switch(a[3]){
                            case "range":
                            case "type":
                            case "min":
                            case "max":
                            case "sort":
                            case "descending":
                            case "order":
                            case "casesensitive":
                            case "value":
                            case "errorstyle":
                            case "errormessage":
                            case "errortitle":
                            case "inputmessage":
                            case "inputtitle":
                            case "combohide":
                            case "inputhide":
                            case "condition":
                            case "qualifier":
                            case "useblank":
                            case "value1":
                            case "value2":
                            case "format":
                            case "cellrangelist":
                                break;
                            default:
                                ee = !1;
                        }
                        break;
                    case "sorting":
                    case "conditionalformatting":
                        switch(a[3]){
                            case "range":
                            case "type":
                            case "min":
                            case "max":
                            case "sort":
                            case "descending":
                            case "order":
                            case "casesensitive":
                            case "value":
                            case "errorstyle":
                            case "errormessage":
                            case "errortitle":
                            case "cellrangelist":
                            case "inputmessage":
                            case "inputtitle":
                            case "combohide":
                            case "inputhide":
                            case "condition":
                            case "qualifier":
                            case "useblank":
                            case "value1":
                            case "value2":
                            case "format":
                                break;
                            default:
                                ee = !1;
                        }
                        break;
                    case "mapinfo":
                    case "schema":
                    case "data":
                        switch(a[3]){
                            case "map":
                            case "entry":
                            case "range":
                            case "xpath":
                            case "field":
                            case "xsdtype":
                            case "filteron":
                            case "aggregate":
                            case "elementtype":
                            case "attributetype":
                                break;
                            case "schema":
                            case "element":
                            case "complextype":
                            case "datatype":
                            case "all":
                            case "attribute":
                            case "extends":
                            case "row":
                                break;
                            default:
                                ee = !1;
                        }
                        break;
                    case "smarttags":
                        break;
                    default:
                        ee = !1;
                }
                if (ee) break;
                if (a[3].match(/!\[CDATA/)) break;
                if (!l[l.length - 1][1]) throw "Unrecognized tag: " + a[3] + "|" + l.join("|");
                if ("customdocumentproperties" === l[l.length - 1][0]) {
                    if ("/>" === a[0].slice(-2)) break;
                    "/" === a[1] ? function(e, t, r, a) {
                        var n = a;
                        switch((r[0].match(/dt:dt="([\w.]+)"/) || [
                            "",
                            ""
                        ])[1]){
                            case "boolean":
                                n = Rt(a);
                                break;
                            case "i2":
                            case "int":
                                n = parseInt(a, 10);
                                break;
                            case "r4":
                            case "float":
                                n = parseFloat(a);
                                break;
                            case "date":
                            case "dateTime.tz":
                                n = He(a);
                                break;
                            case "i8":
                            case "string":
                            case "fixed":
                            case "uuid":
                            case "bin.base64":
                                break;
                            default:
                                throw new Error("bad custprop:" + r[0]);
                        }
                        e[wt(t)] = n;
                    }(C, $1, O, n.slice(R, a.index)) : R = (O = a).index + a[0].length;
                    break;
                }
                if (r.WTF) throw "Unrecognized tag: " + a[3] + "|" + l.join("|");
        }
        o = {};
        return r.bookSheets || r.bookProps || (o.Sheets = h), o.SheetNames = u, o.Workbook = W, o.SSF = Ve(me), o.Props = A, o.Custprops = C, o;
    }
    function wf(e, t) {
        switch(Mh(t = t || {}), t.type || "base64"){
            case "base64":
                return vf(te(e), t);
            case "binary":
            case "buffer":
            case "file":
                return vf(e, t);
            case "array":
                return vf(i(e), t);
        }
    }
    function Tf(e, t) {
        var r, a, n, s, i, o, c, l = [];
        return e.Props && l.push((r = e.Props, a = t, n = [], Re(dn).map(function(e) {
            for(var t = 0; t < en.length; ++t)if (en[t][1] == e) return en[t];
            for(t = 0; t < sn.length; ++t)if (sn[t][1] == e) return sn[t];
            throw e;
        }).forEach(function(e) {
            var t;
            null != r[e[1]] && (t = (a && a.Props && null != a.Props[e[1]] ? a.Props : r)[e[1]], "number" == typeof (t = "date" === e[2] ? new Date(t).toISOString().replace(/\.\d*Z/, "Z") : t) ? t = String(t) : !0 === t || !1 === t ? t = t ? "1" : "0" : t instanceof Date && (t = new Date(t).toISOString().replace(/\.\d*Z/, "")), n.push($t(dn[e[1]] || e[1], t)));
        }), Yt("DocumentProperties", n.join(""), {
            xmlns: er.o
        }))), e.Custprops && l.push((s = e.Props, i = e.Custprops, o = [
            "Worksheets",
            "SheetNames"
        ], e = "CustomDocumentProperties", c = [], s && Re(s).forEach(function(e) {
            if (Object.prototype.hasOwnProperty.call(s, e)) {
                for(var t = 0; t < en.length; ++t)if (e == en[t][1]) return;
                for(t = 0; t < sn.length; ++t)if (e == sn[t][1]) return;
                for(t = 0; t < o.length; ++t)if (e == o[t]) return;
                var r = "string", a = "number" == typeof (a = s[e]) ? (r = "float", String(a)) : !0 === a || !1 === a ? (r = "boolean", a ? "1" : "0") : String(a);
                c.push(Yt(yt(e), a, {
                    "dt:dt": r
                }));
            }
        }), i && Re(i).forEach(function(e) {
            var t, r;
            Object.prototype.hasOwnProperty.call(i, e) && (s && Object.prototype.hasOwnProperty.call(s, e) || (t = "string", r = "number" == typeof (r = i[e]) ? (t = "float", String(r)) : !0 === r || !1 === r ? (t = "boolean", r ? "1" : "0") : r instanceof Date ? (t = "dateTime.tz", r.toISOString()) : String(r), c.push(Yt(yt(e), r, {
                "dt:dt": t
            }))));
        }), "<" + e + ' xmlns="' + er.o + '">' + c.join("") + "</" + e + ">")), l.join("");
    }
    function Ef(e) {
        return Yt("NamedRange", null, {
            "ss:Name": e.Name,
            "ss:RefersTo": "=" + fc(e.Ref, {
                r: 0,
                c: 0
            })
        });
    }
    function kf(e, t, r, a, n, s, i) {
        if (!e || null == e.v && null == e.f) return "";
        var o = {};
        if (e.f && (o["ss:Formula"] = "=" + kt(fc(e.f, i))), e.F && e.F.slice(0, t.length) == t && (t = Yr(e.F.slice(t.length + 1)), o["ss:ArrayRange"] = "RC:R" + (t.r == i.r ? "" : "[" + (t.r - i.r) + "]") + "C" + (t.c == i.c ? "" : "[" + (t.c - i.c) + "]")), e.l && e.l.Target && (o["ss:HRef"] = kt(e.l.Target), e.l.Tooltip && (o["x:HRefScreenTip"] = kt(e.l.Tooltip))), r["!merges"]) for(var c = r["!merges"], l = 0; l != c.length; ++l)c[l].s.c == i.c && c[l].s.r == i.r && (c[l].e.c > c[l].s.c && (o["ss:MergeAcross"] = c[l].e.c - c[l].s.c), c[l].e.r > c[l].s.r && (o["ss:MergeDown"] = c[l].e.r - c[l].s.r));
        var f = "", h = "";
        switch(e.t){
            case "z":
                if (!a.sheetStubs) return "";
                break;
            case "n":
                f = "Number", h = String(e.v);
                break;
            case "b":
                f = "Boolean", h = e.v ? "1" : "0";
                break;
            case "e":
                f = "Error", h = Wa[e.v];
                break;
            case "d":
                f = "DateTime", h = new Date(e.v).toISOString(), null == e.z && (e.z = e.z || me[14]);
                break;
            case "s":
                f = "String", h = ((e.v || "") + "").replace(Tt, function(e) {
                    return vt[e];
                }).replace(St, function(e) {
                    return "&#x" + e.charCodeAt(0).toString(16).toUpperCase() + ";";
                });
        }
        r = el(a.cellXfs, e, a);
        o["ss:StyleID"] = "s" + (21 + r), o["ss:Index"] = i.c + 1;
        r = null != e.v ? h : "", r = "z" == e.t ? "" : '<Data ss:Type="' + f + '">' + r + "</Data>";
        return 0 < (e.c || []).length && (r += e.c.map(function(e) {
            var t = Yt("ss:Data", (e.t || "").replace(/(\r\n|[\r\n])/g, "&#10;"), {
                xmlns: "http://www.w3.org/TR/REC-html40"
            });
            return Yt("Comment", t, {
                "ss:Author": e.a
            });
        }).join("")), Yt("Cell", r, o);
    }
    function yf(e, t) {
        if (!e["!ref"]) return "";
        var r = Zr(e["!ref"]), a = e["!merges"] || [], n = 0, s = [];
        e["!cols"] && e["!cols"].forEach(function(e, t) {
            fo(e);
            var r = !!e.width, a = Zc(t, e), t = {
                "ss:Index": t + 1
            };
            r && (t["ss:Width"] = so(a.width)), e.hidden && (t["ss:Hidden"] = "1"), s.push(Yt("Column", null, t));
        });
        for(var i, o, c = Array.isArray(e), l = r.s.r; l <= r.e.r; ++l){
            for(var f = [
                (i = l, o = (e["!rows"] || [])[l], i = '<Row ss:Index="' + (i + 1) + '"', o && (o.hpt && !o.hpx && (o.hpx = po(o.hpt)), o.hpx && (i += ' ss:AutoFitHeight="0" ss:Height="' + o.hpx + '"'), o.hidden && (i += ' ss:Hidden="1"')), i + ">")
            ], h = r.s.c; h <= r.e.c; ++h){
                for(var u, d, p, m = !1, n = 0; n != a.length; ++n)if (!(a[n].s.c > h || a[n].s.r > l || a[n].e.c < h || a[n].e.r < l)) {
                    a[n].s.c == h && a[n].s.r == l || (m = !0);
                    break;
                }
                m || (d = Kr(u = {
                    r: l,
                    c: h
                }), p = c ? (e[l] || [])[h] : e[d], f.push(kf(p, d, e, t, 0, 0, u)));
            }
            f.push("</Row>"), 2 < f.length && s.push(f.join(""));
        }
        return s.join("");
    }
    function Sf(e, t, r) {
        var a = [], n = r.SheetNames[e], s = r.Sheets[n], n = s ? function(e, t, r) {
            if (!e) return "";
            if (!((r || {}).Workbook || {}).Names) return "";
            for(var a = r.Workbook.Names, n = [], s = 0; s < a.length; ++s){
                var i = a[s];
                i.Sheet == t && (i.Name.match(/^_xlfn\./) || n.push(Ef(i)));
            }
            return n.join("");
        }(s, e, r) : "";
        return 0 < n.length && a.push("<Names>" + n + "</Names>"), 0 < (n = s ? yf(s, t) : "").length && a.push("<Table>" + n + "</Table>"), a.push(function(t, e, r) {
            if (!t) return "";
            var a = [];
            if (t["!margins"] && (a.push("<PageSetup>"), t["!margins"].header && a.push(Yt("Header", null, {
                "x:Margin": t["!margins"].header
            })), t["!margins"].footer && a.push(Yt("Footer", null, {
                "x:Margin": t["!margins"].footer
            })), a.push(Yt("PageMargins", null, {
                "x:Bottom": t["!margins"].bottom || "0.75",
                "x:Left": t["!margins"].left || "0.7",
                "x:Right": t["!margins"].right || "0.7",
                "x:Top": t["!margins"].top || "0.75"
            })), a.push("</PageSetup>")), r && r.Workbook && r.Workbook.Sheets && r.Workbook.Sheets[e]) {
                if (r.Workbook.Sheets[e].Hidden) a.push(Yt("Visible", 1 == r.Workbook.Sheets[e].Hidden ? "SheetHidden" : "SheetVeryHidden", {}));
                else {
                    for(var n = 0; n < e && (!r.Workbook.Sheets[n] || r.Workbook.Sheets[n].Hidden); ++n);
                    n == e && a.push("<Selected/>");
                }
            }
            return ((((r || {}).Workbook || {}).Views || [])[0] || {}).RTL && a.push("<DisplayRightToLeft/>"), t["!protect"] && (a.push($t("ProtectContents", "True")), t["!protect"].objects && a.push($t("ProtectObjects", "True")), t["!protect"].scenarios && a.push($t("ProtectScenarios", "True")), null == t["!protect"].selectLockedCells || t["!protect"].selectLockedCells ? null == t["!protect"].selectUnlockedCells || t["!protect"].selectUnlockedCells || a.push($t("EnableSelection", "UnlockedCells")) : a.push($t("EnableSelection", "NoSelection")), [
                [
                    "formatCells",
                    "AllowFormatCells"
                ],
                [
                    "formatColumns",
                    "AllowSizeCols"
                ],
                [
                    "formatRows",
                    "AllowSizeRows"
                ],
                [
                    "insertColumns",
                    "AllowInsertCols"
                ],
                [
                    "insertRows",
                    "AllowInsertRows"
                ],
                [
                    "insertHyperlinks",
                    "AllowInsertHyperlinks"
                ],
                [
                    "deleteColumns",
                    "AllowDeleteCols"
                ],
                [
                    "deleteRows",
                    "AllowDeleteRows"
                ],
                [
                    "sort",
                    "AllowSort"
                ],
                [
                    "autoFilter",
                    "AllowFilter"
                ],
                [
                    "pivotTables",
                    "AllowUsePivotTables"
                ]
            ].forEach(function(e) {
                t["!protect"][e[0]] && a.push("<" + e[1] + "/>");
            })), 0 == a.length ? "" : Yt("WorksheetOptions", a.join(""), {
                xmlns: er.x
            });
        }(s, e, r)), a.join("");
    }
    function _f(e, t) {
        t = t || {}, e.SSF || (e.SSF = Ve(me)), e.SSF && (Ee(), Te(e.SSF), t.revssf = Ne(e.SSF), t.revssf[e.SSF[65535]] = 0, t.ssf = e.SSF, t.cellXfs = [], el(t.cellXfs, {}, {
            revssf: {
                General: 0
            }
        }));
        var r = [];
        r.push(Tf(e, t)), r.push(""), r.push(""), r.push("");
        for(var a, n = 0; n < e.SheetNames.length; ++n)r.push(Yt("Worksheet", Sf(n, t, e), {
            "ss:Name": kt(e.SheetNames[n])
        }));
        return r[2] = (a = [
            '<Style ss:ID="Default" ss:Name="Normal"><NumberFormat/></Style>'
        ], t.cellXfs.forEach(function(e, t) {
            var r = [];
            r.push(Yt("NumberFormat", null, {
                "ss:Format": kt(me[e.numFmtId])
            }));
            t = {
                "ss:ID": "s" + (21 + t)
            };
            a.push(Yt("Style", r.join(""), t));
        }), Yt("Styles", a.join(""))), r[3] = function(e) {
            if (!((e || {}).Workbook || {}).Names) return "";
            for(var t = e.Workbook.Names, r = [], a = 0; a < t.length; ++a){
                var n = t[a];
                null == n.Sheet && (n.Name.match(/^_xlfn\./) || r.push(Ef(n)));
            }
            return Yt("Names", r.join(""));
        }(e), ot + Yt("Workbook", r.join(""), {
            xmlns: er.ss,
            "xmlns:o": er.o,
            "xmlns:x": er.x,
            "xmlns:ss": er.ss,
            "xmlns:dt": er.dt,
            "xmlns:html": er.html
        });
    }
    function xf(e) {
        var t = {}, r = e.content;
        if (r.l = 28, t.AnsiUserType = r.read_shift(0, "lpstr-ansi"), t.AnsiClipboardFormat = Ra(r, 1), r.length - r.l <= 4) return t;
        e = r.read_shift(4);
        return 0 == e || 40 < e ? t : (r.l -= 4, t.Reserved1 = r.read_shift(0, "lpstr-ansi"), r.length - r.l <= 4 || 1907505652 !== (e = r.read_shift(4)) ? t : (t.UnicodeClipboardFormat = Ra(r, 2), 0 == (e = r.read_shift(4)) || 40 < e ? t : (r.l -= 4, void (t.Reserved2 = r.read_shift(0, "lpwstr")))));
    }
    var Af = [
        60,
        1084,
        2066,
        2165,
        2175
    ];
    function Cf(e, t, r) {
        if ("z" !== e.t && e.XF) {
            var a, n = 0;
            try {
                n = e.z || e.XF.numFmtId || 0, t.cellNF && (e.z = me[n]);
            } catch (e) {
                if (t.WTF) throw e;
            }
            if (!t || !1 !== t.cellText) try {
                "e" === e.t ? e.w = e.w || Wa[e.v] : 0 === n || "General" == n ? "n" === e.t ? (0 | e.v) === e.v ? e.w = e.v.toString(10) : e.w = D(e.v) : e.w = P(e.v) : e.w = ve(n, e.v, {
                    date1904: !!r,
                    dateNF: t && t.dateNF
                });
            } catch (e) {
                if (t.WTF) throw e;
            }
            t.cellDates && n && "n" == e.t && q(me[n] || String(n)) && (a = L(e.v)) && (e.t = "d", e.v = new Date(a.y, a.m - 1, a.d, a.H, a.M, a.S, a.u));
        }
    }
    function Rf(e, t, r) {
        return {
            v: e,
            ixfe: t,
            t: r
        };
    }
    function Of(e, t) {
        var r = {
            opts: {}
        }, a = {};
        null != oe && null == t.dense && (t.dense = oe);
        function o(e) {
            return !(e < 8) && e < 64 && k[e - 8] || Ba[e];
        }
        function n(e, t, r) {
            if (!(1 < D || r.sheetRows && e.r >= r.sheetRows)) {
                var a, n, s;
                if (r.cellStyles && t.XF && t.XF.data && (n = r, (s = (a = t).XF.data) && s.patternType && n && n.cellStyles && (a.s = {}, a.s.patternType = s.patternType, (n = Qi(o(s.icvFore))) && (a.s.fgColor = {
                    rgb: n
                }), (n = Qi(o(s.icvBack))) && (a.s.bgColor = {
                    rgb: n
                }))), delete t.ixfe, delete t.XF, v = Kr(c = e), d && d.s && d.e || (d = {
                    s: {
                        r: 0,
                        c: 0
                    },
                    e: {
                        r: 0,
                        c: 0
                    }
                }), e.r < d.s.r && (d.s.r = e.r), e.c < d.s.c && (d.s.c = e.c), e.r + 1 > d.e.r && (d.e.r = e.r + 1), e.c + 1 > d.e.c && (d.e.c = e.c + 1), r.cellFormula && t.f) {
                    for(var i = 0; i < T.length; ++i)if (!(T[i][0].s.c > e.c || T[i][0].s.r > e.r || T[i][0].e.c < e.c || T[i][0].e.r < e.r)) {
                        t.F = qr(T[i][0]), T[i][0].s.c == e.c && T[i][0].s.r == e.r || delete t.f, t.f && (t.f = "" + Pc(T[i][1], 0, e, I, _));
                        break;
                    }
                }
                r.dense ? (h[e.r] || (h[e.r] = []), h[e.r][e.c] = t) : h[v] = t;
            }
        }
        var c, s, i, l, f, h = t.dense ? [] : {}, u = {}, d = {}, p = null, m = [], g = "", b = {}, v = "", w = {}, T = [], E = [], k = [], y = {
            Sheets: [],
            WBProps: {
                date1904: !1
            },
            Views: [
                {}
            ]
        }, S = {}, _ = {
            enc: !1,
            sbcch: 0,
            snames: [],
            sharedf: w,
            arrayf: T,
            rrtabid: [],
            lastuser: "",
            biff: 8,
            codepage: 0,
            winlocked: 0,
            cellStyles: !!t && !!t.cellStyles,
            WTF: !!t && !!t.wtf
        };
        t.password && (_.password = t.password);
        var x = [], A = [], C = [], R = [], O = !1, I = [];
        I.SheetNames = _.snames, I.sharedf = _.sharedf, I.arrayf = _.arrayf, I.names = [], I.XTI = [];
        var N, F = 0, D = 0, P = 0, L = [], M = [];
        _.codepage = 1200, ie(1200);
        for(var U = !1; e.l < e.length - 1;){
            var B = e.l, W = e.read_shift(2);
            if (0 === W && 10 === F) break;
            var H = e.l === e.length ? 0 : e.read_shift(2), z = Pf[W];
            if (z && z.f) {
                if (t.bookSheets && 133 === F && 133 !== W) break;
                if (F = W, 2 === z.r || 12 == z.r) {
                    var V = e.read_shift(2);
                    if (H -= 2, !_.enc && V !== W && ((255 & V) << 8 | V >> 8) !== W) throw new Error("rt mismatch: " + V + "!=" + W);
                    12 == z.r && (e.l += 10, H -= 10);
                }
                var G, j, $1, X = {}, X = 10 === W ? z.f(e, H, _) : function(e, t, r, a, n) {
                    var s = a, i = [], o = r.slice(r.l, r.l + s);
                    if (n && n.enc && n.enc.insitu && 0 < o.length) switch(e){
                        case 9:
                        case 521:
                        case 1033:
                        case 2057:
                        case 47:
                        case 405:
                        case 225:
                        case 406:
                        case 312:
                        case 404:
                        case 10:
                        case 133:
                            break;
                        default:
                            n.enc.insitu(o);
                    }
                    i.push(o), r.l += s;
                    for(var c = yr(r, r.l), l = Pf[c], f = 0; null != l && -1 < Af.indexOf(c);)s = yr(r, r.l + 2), f = r.l + 4, 2066 == c ? f += 4 : 2165 != c && 2175 != c || (f += 12), o = r.slice(f, r.l + 4 + s), i.push(o), r.l += 4 + s, l = Pf[c = yr(r, r.l)];
                    var h = ue(i);
                    Dr(h, 0);
                    var u = 0;
                    h.lens = [];
                    for(var d = 0; d < i.length; ++d)h.lens.push(u), u += i[d].length;
                    if (h.length < a) throw "XLS Record 0x" + e.toString(16) + " Truncated: " + h.length + " < " + a;
                    return t.f(h, h.length, n);
                }(W, z, e, H, _);
                if (0 != D || -1 !== [
                    9,
                    521,
                    1033,
                    2057
                ].indexOf(F)) switch(W){
                    case 34:
                        r.opts.Date1904 = y.WBProps.date1904 = X;
                        break;
                    case 134:
                        r.opts.WriteProtect = !0;
                        break;
                    case 47:
                        if (_.enc || (e.l = 0), _.enc = X, !t.password) throw new Error("File is password-protected");
                        if (null == X.valid) throw new Error("Encryption scheme unsupported");
                        if (!X.valid) throw new Error("Password is incorrect");
                        break;
                    case 92:
                        _.lastuser = X;
                        break;
                    case 66:
                        var Y = Number(X);
                        switch(Y){
                            case 21010:
                                Y = 1200;
                                break;
                            case 32768:
                                Y = 1e4;
                                break;
                            case 32769:
                                Y = 1252;
                        }
                        ie(_.codepage = Y), U = !0;
                        break;
                    case 317:
                        _.rrtabid = X;
                        break;
                    case 25:
                        _.winlocked = X;
                        break;
                    case 439:
                        r.opts.RefreshAll = X;
                        break;
                    case 12:
                        r.opts.CalcCount = X;
                        break;
                    case 16:
                        r.opts.CalcDelta = X;
                        break;
                    case 17:
                        r.opts.CalcIter = X;
                        break;
                    case 13:
                        r.opts.CalcMode = X;
                        break;
                    case 14:
                        r.opts.CalcPrecision = X;
                        break;
                    case 95:
                        r.opts.CalcSaveRecalc = X;
                        break;
                    case 15:
                        _.CalcRefMode = X;
                        break;
                    case 2211:
                        r.opts.FullCalc = X;
                        break;
                    case 129:
                        X.fDialog && (h["!type"] = "dialog"), X.fBelow || ((h["!outline"] || (h["!outline"] = {})).above = !0), X.fRight || ((h["!outline"] || (h["!outline"] = {})).left = !0);
                        break;
                    case 224:
                        E.push(X);
                        break;
                    case 430:
                        I.push([
                            X
                        ]), I[I.length - 1].XTI = [];
                        break;
                    case 35:
                    case 547:
                        I[I.length - 1].push(X);
                        break;
                    case 24:
                    case 536:
                        N = {
                            Name: X.Name,
                            Ref: Pc(X.rgce, 0, null, I, _)
                        }, 0 < X.itab && (N.Sheet = X.itab - 1), I.names.push(N), I[0] || (I[0] = [], I[0].XTI = []), I[I.length - 1].push(X), "_xlnm._FilterDatabase" == X.Name && 0 < X.itab && X.rgce && X.rgce[0] && X.rgce[0][0] && "PtgArea3d" == X.rgce[0][0][0] && (M[X.itab - 1] = {
                            ref: qr(X.rgce[0][0][1][2])
                        });
                        break;
                    case 22:
                        _.ExternCount = X;
                        break;
                    case 23:
                        0 == I.length && (I[0] = [], I[0].XTI = []), I[I.length - 1].XTI = I[I.length - 1].XTI.concat(X), I.XTI = I.XTI.concat(X);
                        break;
                    case 2196:
                        if (_.biff < 8) break;
                        null != N && (N.Comment = X[1]);
                        break;
                    case 18:
                        h["!protect"] = X;
                        break;
                    case 19:
                        0 !== X && _.WTF && console.error("Password verifier: " + X);
                        break;
                    case 133:
                        u[X.pos] = X, _.snames.push(X.name);
                        break;
                    case 10:
                        if (--D) break;
                        d.e && (0 < d.e.r && 0 < d.e.c && (d.e.r--, d.e.c--, h["!ref"] = qr(d), t.sheetRows && t.sheetRows <= d.e.r && (K = d.e.r, d.e.r = t.sheetRows - 1, h["!fullref"] = h["!ref"], h["!ref"] = qr(d), d.e.r = K), d.e.r++, d.e.c++), 0 < x.length && (h["!merges"] = x), 0 < A.length && (h["!objects"] = A), 0 < C.length && (h["!cols"] = C), 0 < R.length && (h["!rows"] = R), y.Sheets.push(S)), "" === g ? b = h : a[g] = h, h = t.dense ? [] : {};
                        break;
                    case 9:
                    case 521:
                    case 1033:
                    case 2057:
                        if (8 === _.biff && (_.biff = ({
                            9: 2,
                            521: 3,
                            1033: 4
                        })[W] || ({
                            512: 2,
                            768: 3,
                            1024: 4,
                            1280: 5,
                            1536: 8,
                            2: 2,
                            7: 2
                        })[X.BIFFVer] || 8), _.biffguess = 0 == X.BIFFVer, 0 == X.BIFFVer && 4096 == X.dt && (_.biff = 5, U = !0, ie(_.codepage = 28591)), 8 == _.biff && 0 == X.BIFFVer && 16 == X.dt && (_.biff = 2), D++) break;
                        var K, h = t.dense ? [] : {};
                        _.biff < 8 && !U && (U = !0, ie(_.codepage = t.codepage || 1252)), _.biff < 5 || 0 == X.BIFFVer && 4096 == X.dt ? ("" === g && (g = "Sheet1"), d = {
                            s: {
                                r: 0,
                                c: 0
                            },
                            e: {
                                r: 0,
                                c: 0
                            }
                        }, K = {
                            pos: e.l - H,
                            name: g
                        }, u[K.pos] = K, _.snames.push(g)) : g = (u[B] || {
                            name: ""
                        }).name, 32 == X.dt && (h["!type"] = "chart"), 64 == X.dt && (h["!type"] = "macro"), x = [], A = [], _.arrayf = T = [], C = [], O = (R = [], false), S = {
                            Hidden: (u[B] || {
                                hs: 0
                            }).hs,
                            name: g
                        };
                        break;
                    case 515:
                    case 3:
                    case 2:
                        "chart" == h["!type"] && (t.dense ? (h[X.r] || [])[X.c] : h[Kr({
                            c: X.c,
                            r: X.r
                        })]) && ++X.c, Z = {
                            ixfe: X.ixfe,
                            XF: E[X.ixfe] || {},
                            v: X.val,
                            t: "n"
                        }, 0 < P && (Z.z = L[Z.ixfe >> 8 & 63]), Cf(Z, t, r.opts.Date1904), n({
                            c: X.c,
                            r: X.r
                        }, Z, t);
                        break;
                    case 5:
                    case 517:
                        Z = {
                            ixfe: X.ixfe,
                            XF: E[X.ixfe],
                            v: X.val,
                            t: X.t
                        }, 0 < P && (Z.z = L[Z.ixfe >> 8 & 63]), Cf(Z, t, r.opts.Date1904), n({
                            c: X.c,
                            r: X.r
                        }, Z, t);
                        break;
                    case 638:
                        Z = {
                            ixfe: X.ixfe,
                            XF: E[X.ixfe],
                            v: X.rknum,
                            t: "n"
                        }, 0 < P && (Z.z = L[Z.ixfe >> 8 & 63]), Cf(Z, t, r.opts.Date1904), n({
                            c: X.c,
                            r: X.r
                        }, Z, t);
                        break;
                    case 189:
                        for(var J = X.c; J <= X.C; ++J){
                            var q = X.rkrec[J - X.c][0], Z = {
                                ixfe: q,
                                XF: E[q],
                                v: X.rkrec[J - X.c][1],
                                t: "n"
                            };
                            0 < P && (Z.z = L[Z.ixfe >> 8 & 63]), Cf(Z, t, r.opts.Date1904), n({
                                c: J,
                                r: X.r
                            }, Z, t);
                        }
                        break;
                    case 6:
                    case 518:
                    case 1030:
                        if ("String" == X.val) {
                            p = X;
                            break;
                        }
                        (Z = Rf(X.val, X.cell.ixfe, X.tt)).XF = E[Z.ixfe], t.cellFormula && (!((Q = X.formula) && Q[0] && Q[0][0] && "PtgExp" == Q[0][0][0]) || w[$1 = Kr({
                            r: G = Q[0][0][1][0],
                            c: j = Q[0][0][1][1]
                        })] ? Z.f = "" + Pc(X.formula, 0, X.cell, I, _) : Z.F = ((t.dense ? (h[G] || [])[j] : h[$1]) || {}).F), 0 < P && (Z.z = L[Z.ixfe >> 8 & 63]), Cf(Z, t, r.opts.Date1904), n(X.cell, Z, t), p = X;
                        break;
                    case 7:
                    case 519:
                        if (!p) throw new Error("String record expects Formula");
                        (Z = Rf(p.val = X, p.cell.ixfe, "s")).XF = E[Z.ixfe], t.cellFormula && (Z.f = "" + Pc(p.formula, 0, p.cell, I, _)), 0 < P && (Z.z = L[Z.ixfe >> 8 & 63]), Cf(Z, t, r.opts.Date1904), n(p.cell, Z, t), p = null;
                        break;
                    case 33:
                    case 545:
                        T.push(X);
                        var Q = Kr(X[0].s), ee = t.dense ? (h[X[0].s.r] || [])[X[0].s.c] : h[Q];
                        if (t.cellFormula && ee) {
                            if (!p) break;
                            if (!Q || !ee) break;
                            ee.f = "" + Pc(X[1], 0, X[0], I, _), ee.F = qr(X[0]);
                        }
                        break;
                    case 1212:
                        if (!t.cellFormula) break;
                        if (v) {
                            if (!p) break;
                            w[Kr(p.cell)] = X[0], ((ee = t.dense ? (h[p.cell.r] || [])[p.cell.c] : h[Kr(p.cell)]) || {}).f = "" + Pc(X[0], 0, c, I, _);
                        }
                        break;
                    case 253:
                        Z = Rf(m[X.isst].t, X.ixfe, "s"), m[X.isst].h && (Z.h = m[X.isst].h), Z.XF = E[Z.ixfe], 0 < P && (Z.z = L[Z.ixfe >> 8 & 63]), Cf(Z, t, r.opts.Date1904), n({
                            c: X.c,
                            r: X.r
                        }, Z, t);
                        break;
                    case 513:
                        t.sheetStubs && (Z = {
                            ixfe: X.ixfe,
                            XF: E[X.ixfe],
                            t: "z"
                        }, 0 < P && (Z.z = L[Z.ixfe >> 8 & 63]), Cf(Z, t, r.opts.Date1904), n({
                            c: X.c,
                            r: X.r
                        }, Z, t));
                        break;
                    case 190:
                        if (t.sheetStubs) for(var te = X.c; te <= X.C; ++te){
                            var re = X.ixfe[te - X.c];
                            Z = {
                                ixfe: re,
                                XF: E[re],
                                t: "z"
                            }, 0 < P && (Z.z = L[Z.ixfe >> 8 & 63]), Cf(Z, t, r.opts.Date1904), n({
                                c: te,
                                r: X.r
                            }, Z, t);
                        }
                        break;
                    case 214:
                    case 516:
                    case 4:
                        (Z = Rf(X.val, X.ixfe, "s")).XF = E[Z.ixfe], 0 < P && (Z.z = L[Z.ixfe >> 8 & 63]), Cf(Z, t, r.opts.Date1904), n({
                            c: X.c,
                            r: X.r
                        }, Z, t);
                        break;
                    case 0:
                    case 512:
                        1 === D && (d = X);
                        break;
                    case 252:
                        m = X;
                        break;
                    case 1054:
                        if (4 == _.biff) {
                            L[P++] = X[1];
                            for(var ae = 0; ae < P + 163 && me[ae] != X[1]; ++ae);
                            163 <= ae && we(X[1], P + 163);
                        } else we(X[1], X[0]);
                        break;
                    case 30:
                        L[P++] = X;
                        for(var ne = 0; ne < P + 163 && me[ne] != X; ++ne);
                        163 <= ne && we(X, P + 163);
                        break;
                    case 229:
                        x = x.concat(X);
                        break;
                    case 93:
                        A[X.cmo[0]] = _.lastobj = X;
                        break;
                    case 438:
                        _.lastobj.TxO = X;
                        break;
                    case 127:
                        _.lastobj.ImData = X;
                        break;
                    case 440:
                        for(i = X[0].s.r; i <= X[0].e.r; ++i)for(s = X[0].s.c; s <= X[0].e.c; ++s)(ee = t.dense ? (h[i] || [])[s] : h[Kr({
                            c: s,
                            r: i
                        })]) && (ee.l = X[1]);
                        break;
                    case 2048:
                        for(i = X[0].s.r; i <= X[0].e.r; ++i)for(s = X[0].s.c; s <= X[0].e.c; ++s)(ee = t.dense ? (h[i] || [])[s] : h[Kr({
                            c: s,
                            r: i
                        })]) && ee.l && (ee.l.Tooltip = X[1]);
                        break;
                    case 28:
                        if (_.biff <= 5 && 2 <= _.biff) break;
                        ee = t.dense ? (h[X[0].r] || [])[X[0].c] : h[Kr(X[0])];
                        var se = A[X[2]];
                        ee || (ee = t.dense ? (h[X[0].r] || (h[X[0].r] = []), h[X[0].r][X[0].c] = {
                            t: "z"
                        }) : h[Kr(X[0])] = {
                            t: "z"
                        }, d.e.r = Math.max(d.e.r, X[0].r), d.s.r = Math.min(d.s.r, X[0].r), d.e.c = Math.max(d.e.c, X[0].c), d.s.c = Math.min(d.s.c, X[0].c)), ee.c || (ee.c = []), se = {
                            a: X[1],
                            t: se.TxO.t
                        }, ee.c.push(se);
                        break;
                    case 2173:
                        E[X.ixfe], X.ext.forEach(function(e) {
                            e[0];
                        });
                        break;
                    case 125:
                        if (!_.cellStyles) break;
                        for(; X.e >= X.s;)C[X.e--] = {
                            width: X.w / 256,
                            level: X.level || 0,
                            hidden: !!(1 & X.flags)
                        }, O || (O = !0, lo(X.w / 256)), fo(C[X.e + 1]);
                        break;
                    case 520:
                        se = {};
                        null != X.level && ((R[X.r] = se).level = X.level), X.hidden && ((R[X.r] = se).hidden = !0), X.hpt && ((R[X.r] = se).hpt = X.hpt, se.hpx = po(X.hpt));
                        break;
                    case 38:
                    case 39:
                    case 40:
                    case 41:
                        h["!margins"] || Qc(h["!margins"] = {}), h["!margins"][({
                            38: "left",
                            39: "right",
                            40: "top",
                            41: "bottom"
                        })[W]] = X;
                        break;
                    case 161:
                        h["!margins"] || Qc(h["!margins"] = {}), h["!margins"].header = X.header, h["!margins"].footer = X.footer;
                        break;
                    case 574:
                        X.RTL && (y.Views[0].RTL = !0);
                        break;
                    case 146:
                        k = X;
                        break;
                    case 2198:
                        f = X;
                        break;
                    case 140:
                        l = X;
                        break;
                    case 442:
                        g ? S.CodeName = X || S.name : y.WBProps.CodeName = X || "ThisWorkbook";
                }
            } else z || console.error("Missing Info for XLS Record 0x" + W.toString(16)), e.l += H;
        }
        return r.SheetNames = Re(u).sort(function(e, t) {
            return Number(e) - Number(t);
        }).map(function(e) {
            return u[e].name;
        }), t.bookSheets || (r.Sheets = a), !r.SheetNames.length && b["!ref"] ? (r.SheetNames.push("Sheet1"), r.Sheets && (r.Sheets.Sheet1 = b)) : r.Preamble = b, r.Sheets && M.forEach(function(e, t) {
            r.Sheets[r.SheetNames[t]]["!autofilter"] = e;
        }), r.Strings = m, r.SSF = Ve(me), _.enc && (r.Encryption = _.enc), f && (r.Themes = f), r.Metadata = {}, void 0 !== l && (r.Metadata.Country = l), 0 < I.names.length && (y.Names = I.names), r.Workbook = y, r;
    }
    var If = {
        SI: "e0859ff2f94f6810ab9108002b27b3d9",
        DSI: "02d5cdd59c2e1b10939708002b2cf9ae",
        UDI: "05d5cdd59c2e1b10939708002b2cf9ae"
    };
    function Nf(e, t) {
        var r, a, n, s, i;
        if (Mh(t = t || {}), h(), t.codepage && c(t.codepage), e.FullPaths) {
            if (xe.find(e, "/encryption")) throw new Error("File is password-protected");
            r = xe.find(e, "!CompObj"), n = xe.find(e, "/Workbook") || xe.find(e, "/Book");
        } else {
            switch(t.type){
                case "base64":
                    e = he(te(e));
                    break;
                case "binary":
                    e = he(e);
                    break;
                case "buffer":
                    break;
                case "array":
                    Array.isArray(e) || (e = Array.prototype.slice.call(e));
            }
            Dr(e, 0), n = {
                content: e
            };
        }
        if (r && xf(r), t.bookProps && !t.bookSheets) a = {};
        else {
            var o = se ? "buffer" : "array";
            if (n && n.content) a = Of(n.content, t);
            else if ((n = xe.find(e, "PerfectOffice_MAIN")) && n.content) a = si.to_workbook(n.content, (t.type = o, t));
            else {
                if (!(n = xe.find(e, "NativeContent_MAIN")) || !n.content) throw (n = xe.find(e, "MN0")) && n.content ? new Error("Unsupported Works 4 for Mac file") : new Error("Cannot find Workbook stream");
                a = si.to_workbook(n.content, (t.type = o, t));
            }
            t.bookVBA && e.FullPaths && xe.find(e, "/_VBA_PROJECT_CUR/VBA/dir") && (a.vbaraw = (s = e, i = xe.utils.cfb_new({
                root: "R"
            }), s.FullPaths.forEach(function(e, t) {
                "/" !== e.slice(-1) && e.match(/_VBA_PROJECT_CUR/) && (e = e.replace(/^[^\/]*/, "R").replace(/\/_VBA_PROJECT_CUR\u0000*/, ""), xe.utils.cfb_add(i, e, s.FileIndex[t].content));
            }), xe.write(i)));
        }
        o = {};
        return e.FullPaths && function(e, t, r) {
            var a = xe.find(e, "/!DocumentSummaryInformation");
            if (a && 0 < a.size) try {
                var n, s = An(a, Pa, If.DSI);
                for(n in s)t[n] = s[n];
            } catch (e) {
                if (r.WTF) throw e;
            }
            var i = xe.find(e, "/!SummaryInformation");
            if (i && 0 < i.size) try {
                var o, c = An(i, La, If.SI);
                for(o in c)null == t[o] && (t[o] = c[o]);
            } catch (e) {
                if (r.WTF) throw e;
            }
            t.HeadingPairs && t.TitlesOfParts && (cn(t.HeadingPairs, t.TitlesOfParts, t, r), delete t.HeadingPairs, delete t.TitlesOfParts);
        }(e, o, t), a.Props = a.Custprops = o, t.bookFiles && (a.cfb = e), a;
    }
    function Ff(e, t) {
        var r, a, n = t || {}, t = xe.utils.cfb_new({
            root: "R"
        }), s = "/Workbook";
        switch(n.bookType || "xls"){
            case "xls":
                n.bookType = "biff8";
            case "xla":
                n.bookType || (n.bookType = "xla");
            case "biff8":
                s = "/Workbook", n.biff = 8;
                break;
            case "biff5":
                s = "/Book", n.biff = 5;
                break;
            default:
                throw new Error("invalid type " + n.bookType + " for XLS CFB");
        }
        return xe.utils.cfb_add(t, s, Xf(e, n)), 8 == n.biff && (e.Props || e.Custprops) && function(e, t) {
            var r, a = [], n = [], s = [], i = 0, o = Oe(Pa, "n"), c = Oe(La, "n");
            if (e.Props) for(r = Re(e.Props), i = 0; i < r.length; ++i)(Object.prototype.hasOwnProperty.call(o, r[i]) ? a : Object.prototype.hasOwnProperty.call(c, r[i]) ? n : s).push([
                r[i],
                e.Props[r[i]]
            ]);
            if (e.Custprops) for(r = Re(e.Custprops), i = 0; i < r.length; ++i)Object.prototype.hasOwnProperty.call(e.Props || {}, r[i]) || (Object.prototype.hasOwnProperty.call(o, r[i]) ? a : Object.prototype.hasOwnProperty.call(c, r[i]) ? n : s).push([
                r[i],
                e.Custprops[r[i]]
            ]);
            for(var l = [], i = 0; i < s.length; ++i)-1 < _n.indexOf(s[i][0]) || -1 < on.indexOf(s[i][0]) || null != s[i][1] && l.push(s[i]);
            n.length && xe.utils.cfb_add(t, "/SummaryInformation", Cn(n, If.SI, c, La)), (a.length || l.length) && xe.utils.cfb_add(t, "/DocumentSummaryInformation", Cn(a, If.DSI, o, Pa, l.length ? l : null, If.UDI));
        }(e, t), 8 == n.biff && e.vbaraw && (r = t, (a = xe.read(e.vbaraw, {
            type: "string" == typeof e.vbaraw ? "binary" : "buffer"
        })).FullPaths.forEach(function(e, t) {
            0 == t || "/" !== (e = e.replace(/[^\/]*[\/]/, "/_VBA_PROJECT_CUR/")).slice(-1) && xe.utils.cfb_add(r, e, a.FileIndex[t].content);
        })), t;
    }
    var Df = {
        0: {
            f: function(e, t) {
                var r = {}, a = e.l + t;
                r.r = e.read_shift(4), e.l += 4;
                var n = e.read_shift(2);
                return e.l += 1, t = e.read_shift(1), e.l = a, 7 & t && (r.level = 7 & t), 16 & t && (r.hidden = !0), 32 & t && (r.hpt = n / 20), r;
            }
        },
        1: {
            f: function(e) {
                return [
                    fa(e)
                ];
            }
        },
        2: {
            f: function(e) {
                return [
                    fa(e),
                    Ea(e),
                    "n"
                ];
            }
        },
        3: {
            f: function(e) {
                return [
                    fa(e),
                    e.read_shift(1),
                    "e"
                ];
            }
        },
        4: {
            f: function(e) {
                return [
                    fa(e),
                    e.read_shift(1),
                    "b"
                ];
            }
        },
        5: {
            f: function(e) {
                return [
                    fa(e),
                    xa(e),
                    "n"
                ];
            }
        },
        6: {
            f: function(e) {
                return [
                    fa(e),
                    sa(e),
                    "str"
                ];
            }
        },
        7: {
            f: function(e) {
                return [
                    fa(e),
                    e.read_shift(4),
                    "s"
                ];
            }
        },
        8: {
            f: function(e, t, r) {
                var a = e.l + t, n = fa(e);
                n.r = r["!row"];
                var s = [
                    n,
                    sa(e),
                    "str"
                ];
                return r.cellFormula ? (e.l += 2, t = Wc(e, a - e.l, r), s[3] = Pc(t, 0, n, r.supbooks, r)) : e.l = a, s;
            }
        },
        9: {
            f: function(e, t, r) {
                var a = e.l + t, n = fa(e);
                n.r = r["!row"];
                var s = [
                    n,
                    xa(e),
                    "n"
                ];
                return r.cellFormula ? (e.l += 2, t = Wc(e, a - e.l, r), s[3] = Pc(t, 0, n, r.supbooks, r)) : e.l = a, s;
            }
        },
        10: {
            f: function(e, t, r) {
                var a = e.l + t, n = fa(e);
                n.r = r["!row"];
                var s = [
                    n,
                    e.read_shift(1),
                    "b"
                ];
                return r.cellFormula ? (e.l += 2, t = Wc(e, a - e.l, r), s[3] = Pc(t, 0, n, r.supbooks, r)) : e.l = a, s;
            }
        },
        11: {
            f: function(e, t, r) {
                var a = e.l + t, n = fa(e);
                n.r = r["!row"];
                var s = [
                    n,
                    e.read_shift(1),
                    "e"
                ];
                return r.cellFormula ? (e.l += 2, t = Wc(e, a - e.l, r), s[3] = Pc(t, 0, n, r.supbooks, r)) : e.l = a, s;
            }
        },
        12: {
            f: function(e) {
                return [
                    ua(e)
                ];
            }
        },
        13: {
            f: function(e) {
                return [
                    ua(e),
                    Ea(e),
                    "n"
                ];
            }
        },
        14: {
            f: function(e) {
                return [
                    ua(e),
                    e.read_shift(1),
                    "e"
                ];
            }
        },
        15: {
            f: function(e) {
                return [
                    ua(e),
                    e.read_shift(1),
                    "b"
                ];
            }
        },
        16: {
            f: Rl
        },
        17: {
            f: function(e) {
                return [
                    ua(e),
                    sa(e),
                    "str"
                ];
            }
        },
        18: {
            f: function(e) {
                return [
                    ua(e),
                    e.read_shift(4),
                    "s"
                ];
            }
        },
        19: {
            f: oa
        },
        20: {},
        21: {},
        22: {},
        23: {},
        24: {},
        25: {},
        26: {},
        27: {},
        28: {},
        29: {},
        30: {},
        31: {},
        32: {},
        33: {},
        34: {},
        35: {
            T: 1
        },
        36: {
            T: -1
        },
        37: {
            T: 1
        },
        38: {
            T: -1
        },
        39: {
            f: function(e, t, r) {
                var a = e.l + t;
                e.l += 4, e.l += 1;
                var n = e.read_shift(4), s = va(e), t = Hc(e, 0, r), r = ga(e);
                return e.l = a, t = {
                    Name: s,
                    Ptg: t
                }, n < 268435455 && (t.Sheet = n), r && (t.Comment = r), t;
            }
        },
        40: {},
        42: {},
        43: {
            f: function(e, t, r) {
                var a = {};
                a.sz = e.read_shift(2) / 20;
                var n, s = (s = (n = e).read_shift(1), n.l++, {
                    fBold: 1 & s,
                    fItalic: 2 & s,
                    fUnderline: 4 & s,
                    fStrikeout: 8 & s,
                    fOutline: 16 & s,
                    fShadow: 32 & s,
                    fCondense: 64 & s,
                    fExtend: 128 & s
                });
                switch(s.fItalic && (a.italic = 1), s.fCondense && (a.condense = 1), s.fExtend && (a.extend = 1), s.fShadow && (a.shadow = 1), s.fOutline && (a.outline = 1), s.fStrikeout && (a.strike = 1), 700 === e.read_shift(2) && (a.bold = 1), e.read_shift(2)){
                    case 1:
                        a.vertAlign = "superscript";
                        break;
                    case 2:
                        a.vertAlign = "subscript";
                }
                switch(0 != (s = e.read_shift(1)) && (a.underline = s), 0 < (s = e.read_shift(1)) && (a.family = s), 0 < (s = e.read_shift(1)) && (a.charset = s), e.l++, a.color = function(e) {
                    var t = {}, r = e.read_shift(1) >>> 1, a = e.read_shift(1), n = e.read_shift(2, "i"), s = e.read_shift(1), i = e.read_shift(1), o = e.read_shift(1);
                    switch(e.l++, r){
                        case 0:
                            t.auto = 1;
                            break;
                        case 1:
                            t.index = a;
                            var c = Ba[a];
                            c && (t.rgb = Qi(c));
                            break;
                        case 2:
                            t.rgb = Qi([
                                s,
                                i,
                                o
                            ]);
                            break;
                        case 3:
                            t.theme = a;
                    }
                    return 0 != n && (t.tint = 0 < n ? n / 32767 : n / 32768), t;
                }(e), e.read_shift(1)){
                    case 1:
                        a.scheme = "major";
                        break;
                    case 2:
                        a.scheme = "minor";
                }
                return a.name = sa(e), a;
            }
        },
        44: {
            f: function(e, t) {
                return [
                    e.read_shift(2),
                    sa(e)
                ];
            }
        },
        45: {
            f: Ro
        },
        46: {
            f: r
        },
        47: {
            f: function(e, t) {
                var r = e.l + t, a = e.read_shift(2), t = e.read_shift(2);
                return e.l = r, {
                    ixfe: a,
                    numFmtId: t
                };
            }
        },
        48: {},
        49: {
            f: function(e) {
                return e.read_shift(4, "i");
            }
        },
        50: {},
        51: {
            f: function(e) {
                for(var t = [], r = e.read_shift(4); 0 < r--;)t.push([
                    e.read_shift(4),
                    e.read_shift(4)
                ]);
                return t;
            }
        },
        52: {
            T: 1
        },
        53: {
            T: -1
        },
        54: {
            T: 1
        },
        55: {
            T: -1
        },
        56: {
            T: 1
        },
        57: {
            T: -1
        },
        58: {},
        59: {},
        60: {
            f: vs
        },
        62: {
            f: function(e) {
                return [
                    fa(e),
                    oa(e),
                    "is"
                ];
            }
        },
        63: {
            f: function(e) {
                var t = {};
                t.i = e.read_shift(4);
                var r = {};
                return r.r = e.read_shift(4), r.c = e.read_shift(4), t.r = Kr(r), 2 & (e = e.read_shift(1)) && (t.l = "1"), 8 & e && (t.a = "1"), t;
            }
        },
        64: {
            f: function() {}
        },
        65: {},
        66: {},
        67: {},
        68: {},
        69: {},
        70: {},
        128: {},
        129: {
            T: 1
        },
        130: {
            T: -1
        },
        131: {
            T: 1,
            f: Pr,
            p: 0
        },
        132: {
            T: -1
        },
        133: {
            T: 1
        },
        134: {
            T: -1
        },
        135: {
            T: 1
        },
        136: {
            T: -1
        },
        137: {
            T: 1,
            f: function(e) {
                var t = e.read_shift(2);
                return e.l += 28, {
                    RTL: 32 & t
                };
            }
        },
        138: {
            T: -1
        },
        139: {
            T: 1
        },
        140: {
            T: -1
        },
        141: {
            T: 1
        },
        142: {
            T: -1
        },
        143: {
            T: 1
        },
        144: {
            T: -1
        },
        145: {
            T: 1
        },
        146: {
            T: -1
        },
        147: {
            f: function(e, t) {
                var r = {}, a = e[e.l];
                return ++e.l, r.above = !(64 & a), r.left = !(128 & a), e.l += 18, r.name = pa(e, t - 19), r;
            }
        },
        148: {
            f: lt,
            p: 16
        },
        151: {
            f: function() {}
        },
        152: {},
        153: {
            f: function(e, t) {
                var r = {}, a = e.read_shift(4);
                return r.defaultThemeVersion = e.read_shift(4), 0 < (e = 8 < t ? sa(e) : "").length && (r.CodeName = e), r.autoCompressPictures = !!(65536 & a), r.backupFile = !!(64 & a), r.checkCompatibility = !!(4096 & a), r.date1904 = !!(1 & a), r.filterPrivacy = !!(8 & a), r.hidePivotFieldList = !!(1024 & a), r.promptedSolutions = !!(16 & a), r.publishItems = !!(2048 & a), r.refreshAllConnections = !!(262144 & a), r.saveExternalLinkValues = !!(128 & a), r.showBorderUnselectedTables = !!(4 & a), r.showInkAnnotation = !!(32 & a), r.showObjects = [
                    "all",
                    "placeholders",
                    "none"
                ][a >> 13 & 3], r.showPivotChartFilter = !!(32768 & a), r.updateLinks = [
                    "userSet",
                    "never",
                    "always"
                ][a >> 8 & 3], r;
            }
        },
        154: {},
        155: {},
        156: {
            f: function(e, t) {
                var r = {};
                return r.Hidden = e.read_shift(4), r.iTabID = e.read_shift(4), r.strRelID = wa(e, t - 8), r.name = sa(e), r;
            }
        },
        157: {},
        158: {},
        159: {
            T: 1,
            f: function(e) {
                return [
                    e.read_shift(4),
                    e.read_shift(4)
                ];
            }
        },
        160: {
            T: -1
        },
        161: {
            T: 1,
            f: Sa
        },
        162: {
            T: -1
        },
        163: {
            T: 1
        },
        164: {
            T: -1
        },
        165: {
            T: 1
        },
        166: {
            T: -1
        },
        167: {},
        168: {},
        169: {},
        170: {},
        171: {},
        172: {
            T: 1
        },
        173: {
            T: -1
        },
        174: {},
        175: {},
        176: {
            f: Lt
        },
        177: {
            T: 1
        },
        178: {
            T: -1
        },
        179: {
            T: 1
        },
        180: {
            T: -1
        },
        181: {
            T: 1
        },
        182: {
            T: -1
        },
        183: {
            T: 1
        },
        184: {
            T: -1
        },
        185: {
            T: 1
        },
        186: {
            T: -1
        },
        187: {
            T: 1
        },
        188: {
            T: -1
        },
        189: {
            T: 1
        },
        190: {
            T: -1
        },
        191: {
            T: 1
        },
        192: {
            T: -1
        },
        193: {
            T: 1
        },
        194: {
            T: -1
        },
        195: {
            T: 1
        },
        196: {
            T: -1
        },
        197: {
            T: 1
        },
        198: {
            T: -1
        },
        199: {
            T: 1
        },
        200: {
            T: -1
        },
        201: {
            T: 1
        },
        202: {
            T: -1
        },
        203: {
            T: 1
        },
        204: {
            T: -1
        },
        205: {
            T: 1
        },
        206: {
            T: -1
        },
        207: {
            T: 1
        },
        208: {
            T: -1
        },
        209: {
            T: 1
        },
        210: {
            T: -1
        },
        211: {
            T: 1
        },
        212: {
            T: -1
        },
        213: {
            T: 1
        },
        214: {
            T: -1
        },
        215: {
            T: 1
        },
        216: {
            T: -1
        },
        217: {
            T: 1
        },
        218: {
            T: -1
        },
        219: {
            T: 1
        },
        220: {
            T: -1
        },
        221: {
            T: 1
        },
        222: {
            T: -1
        },
        223: {
            T: 1
        },
        224: {
            T: -1
        },
        225: {
            T: 1
        },
        226: {
            T: -1
        },
        227: {
            T: 1
        },
        228: {
            T: -1
        },
        229: {
            T: 1
        },
        230: {
            T: -1
        },
        231: {
            T: 1
        },
        232: {
            T: -1
        },
        233: {
            T: 1
        },
        234: {
            T: -1
        },
        235: {
            T: 1
        },
        236: {
            T: -1
        },
        237: {
            T: 1
        },
        238: {
            T: -1
        },
        239: {
            T: 1
        },
        240: {
            T: -1
        },
        241: {
            T: 1
        },
        242: {
            T: -1
        },
        243: {
            T: 1
        },
        244: {
            T: -1
        },
        245: {
            T: 1
        },
        246: {
            T: -1
        },
        247: {
            T: 1
        },
        248: {
            T: -1
        },
        249: {
            T: 1
        },
        250: {
            T: -1
        },
        251: {
            T: 1
        },
        252: {
            T: -1
        },
        253: {
            T: 1
        },
        254: {
            T: -1
        },
        255: {
            T: 1
        },
        256: {
            T: -1
        },
        257: {
            T: 1
        },
        258: {
            T: -1
        },
        259: {
            T: 1
        },
        260: {
            T: -1
        },
        261: {
            T: 1
        },
        262: {
            T: -1
        },
        263: {
            T: 1
        },
        264: {
            T: -1
        },
        265: {
            T: 1
        },
        266: {
            T: -1
        },
        267: {
            T: 1
        },
        268: {
            T: -1
        },
        269: {
            T: 1
        },
        270: {
            T: -1
        },
        271: {
            T: 1
        },
        272: {
            T: -1
        },
        273: {
            T: 1
        },
        274: {
            T: -1
        },
        275: {
            T: 1
        },
        276: {
            T: -1
        },
        277: {},
        278: {
            T: 1
        },
        279: {
            T: -1
        },
        280: {
            T: 1
        },
        281: {
            T: -1
        },
        282: {
            T: 1
        },
        283: {
            T: 1
        },
        284: {
            T: -1
        },
        285: {
            T: 1
        },
        286: {
            T: -1
        },
        287: {
            T: 1
        },
        288: {
            T: -1
        },
        289: {
            T: 1
        },
        290: {
            T: -1
        },
        291: {
            T: 1
        },
        292: {
            T: -1
        },
        293: {
            T: 1
        },
        294: {
            T: -1
        },
        295: {
            T: 1
        },
        296: {
            T: -1
        },
        297: {
            T: 1
        },
        298: {
            T: -1
        },
        299: {
            T: 1
        },
        300: {
            T: -1
        },
        301: {
            T: 1
        },
        302: {
            T: -1
        },
        303: {
            T: 1
        },
        304: {
            T: -1
        },
        305: {
            T: 1
        },
        306: {
            T: -1
        },
        307: {
            T: 1
        },
        308: {
            T: -1
        },
        309: {
            T: 1
        },
        310: {
            T: -1
        },
        311: {
            T: 1
        },
        312: {
            T: -1
        },
        313: {
            T: -1
        },
        314: {
            T: 1
        },
        315: {
            T: -1
        },
        316: {
            T: 1
        },
        317: {
            T: -1
        },
        318: {
            T: 1
        },
        319: {
            T: -1
        },
        320: {
            T: 1
        },
        321: {
            T: -1
        },
        322: {
            T: 1
        },
        323: {
            T: -1
        },
        324: {
            T: 1
        },
        325: {
            T: -1
        },
        326: {
            T: 1
        },
        327: {
            T: -1
        },
        328: {
            T: 1
        },
        329: {
            T: -1
        },
        330: {
            T: 1
        },
        331: {
            T: -1
        },
        332: {
            T: 1
        },
        333: {
            T: -1
        },
        334: {
            T: 1
        },
        335: {
            f: function(e, t) {
                return {
                    flags: e.read_shift(4),
                    version: e.read_shift(4),
                    name: sa(e)
                };
            }
        },
        336: {
            T: -1
        },
        337: {
            f: function(e) {
                return e.l += 4, 0 != e.read_shift(4);
            },
            T: 1
        },
        338: {
            T: -1
        },
        339: {
            T: 1
        },
        340: {
            T: -1
        },
        341: {
            T: 1
        },
        342: {
            T: -1
        },
        343: {
            T: 1
        },
        344: {
            T: -1
        },
        345: {
            T: 1
        },
        346: {
            T: -1
        },
        347: {
            T: 1
        },
        348: {
            T: -1
        },
        349: {
            T: 1
        },
        350: {
            T: -1
        },
        351: {},
        352: {},
        353: {
            T: 1
        },
        354: {
            T: -1
        },
        355: {
            f: wa
        },
        357: {},
        358: {},
        359: {},
        360: {
            T: 1
        },
        361: {},
        362: {
            f: ps
        },
        363: {},
        364: {},
        366: {},
        367: {},
        368: {},
        369: {},
        370: {},
        371: {},
        372: {
            T: 1
        },
        373: {
            T: -1
        },
        374: {
            T: 1
        },
        375: {
            T: -1
        },
        376: {
            T: 1
        },
        377: {
            T: -1
        },
        378: {
            T: 1
        },
        379: {
            T: -1
        },
        380: {
            T: 1
        },
        381: {
            T: -1
        },
        382: {
            T: 1
        },
        383: {
            T: -1
        },
        384: {
            T: 1
        },
        385: {
            T: -1
        },
        386: {
            T: 1
        },
        387: {
            T: -1
        },
        388: {
            T: 1
        },
        389: {
            T: -1
        },
        390: {
            T: 1
        },
        391: {
            T: -1
        },
        392: {
            T: 1
        },
        393: {
            T: -1
        },
        394: {
            T: 1
        },
        395: {
            T: -1
        },
        396: {},
        397: {},
        398: {},
        399: {},
        400: {},
        401: {
            T: 1
        },
        403: {},
        404: {},
        405: {},
        406: {},
        407: {},
        408: {},
        409: {},
        410: {},
        411: {},
        412: {},
        413: {},
        414: {},
        415: {},
        416: {},
        417: {},
        418: {},
        419: {},
        420: {},
        421: {},
        422: {
            T: 1
        },
        423: {
            T: 1
        },
        424: {
            T: -1
        },
        425: {
            T: -1
        },
        426: {
            f: function(e, t, r) {
                var a = e.l + t, n = ya(e), t = e.read_shift(1);
                return (n = [
                    n
                ])[2] = t, r.cellFormula ? (r = Bc(e, a - e.l, r), n[1] = r) : e.l = a, n;
            }
        },
        427: {
            f: function(e, t, r) {
                var a = e.l + t, t = [
                    Sa(e, 16)
                ];
                return r.cellFormula && (r = zc(e, a - e.l, r), t[1] = r), e.l = a, t;
            }
        },
        428: {},
        429: {
            T: 1
        },
        430: {
            T: -1
        },
        431: {
            T: 1
        },
        432: {
            T: -1
        },
        433: {
            T: 1
        },
        434: {
            T: -1
        },
        435: {
            T: 1
        },
        436: {
            T: -1
        },
        437: {
            T: 1
        },
        438: {
            T: -1
        },
        439: {
            T: 1
        },
        440: {
            T: -1
        },
        441: {
            T: 1
        },
        442: {
            T: -1
        },
        443: {
            T: 1
        },
        444: {
            T: -1
        },
        445: {
            T: 1
        },
        446: {
            T: -1
        },
        447: {
            T: 1
        },
        448: {
            T: -1
        },
        449: {
            T: 1
        },
        450: {
            T: -1
        },
        451: {
            T: 1
        },
        452: {
            T: -1
        },
        453: {
            T: 1
        },
        454: {
            T: -1
        },
        455: {
            T: 1
        },
        456: {
            T: -1
        },
        457: {
            T: 1
        },
        458: {
            T: -1
        },
        459: {
            T: 1
        },
        460: {
            T: -1
        },
        461: {
            T: 1
        },
        462: {
            T: -1
        },
        463: {
            T: 1
        },
        464: {
            T: -1
        },
        465: {
            T: 1
        },
        466: {
            T: -1
        },
        467: {
            T: 1
        },
        468: {
            T: -1
        },
        469: {
            T: 1
        },
        470: {
            T: -1
        },
        471: {},
        472: {},
        473: {
            T: 1
        },
        474: {
            T: -1
        },
        475: {},
        476: {
            f: function(t) {
                var r = {};
                return Il.forEach(function(e) {
                    r[e] = xa(t);
                }), r;
            }
        },
        477: {},
        478: {},
        479: {
            T: 1
        },
        480: {
            T: -1
        },
        481: {
            T: 1
        },
        482: {
            T: -1
        },
        483: {
            T: 1
        },
        484: {
            T: -1
        },
        485: {
            f: function() {}
        },
        486: {
            T: 1
        },
        487: {
            T: -1
        },
        488: {
            T: 1
        },
        489: {
            T: -1
        },
        490: {
            T: 1
        },
        491: {
            T: -1
        },
        492: {
            T: 1
        },
        493: {
            T: -1
        },
        494: {
            f: function(e, t) {
                var r = e.l + t, a = Sa(e, 16), n = ga(e), s = sa(e), i = sa(e), t = sa(e);
                return e.l = r, t = {
                    rfx: a,
                    relId: n,
                    loc: s,
                    display: t
                }, i && (t.Tooltip = i), t;
            }
        },
        495: {
            T: 1
        },
        496: {
            T: -1
        },
        497: {
            T: 1
        },
        498: {
            T: -1
        },
        499: {},
        500: {
            T: 1
        },
        501: {
            T: -1
        },
        502: {
            T: 1
        },
        503: {
            T: -1
        },
        504: {},
        505: {
            T: 1
        },
        506: {
            T: -1
        },
        507: {},
        508: {
            T: 1
        },
        509: {
            T: -1
        },
        510: {
            T: 1
        },
        511: {
            T: -1
        },
        512: {},
        513: {},
        514: {
            T: 1
        },
        515: {
            T: -1
        },
        516: {
            T: 1
        },
        517: {
            T: -1
        },
        518: {
            T: 1
        },
        519: {
            T: -1
        },
        520: {
            T: 1
        },
        521: {
            T: -1
        },
        522: {},
        523: {},
        524: {},
        525: {},
        526: {},
        527: {},
        528: {
            T: 1
        },
        529: {
            T: -1
        },
        530: {
            T: 1
        },
        531: {
            T: -1
        },
        532: {
            T: 1
        },
        533: {
            T: -1
        },
        534: {},
        535: {},
        536: {},
        537: {},
        538: {
            T: 1
        },
        539: {
            T: -1
        },
        540: {
            T: 1
        },
        541: {
            T: -1
        },
        542: {
            T: 1
        },
        548: {},
        549: {},
        550: {
            f: wa
        },
        551: {},
        552: {},
        553: {},
        554: {
            T: 1
        },
        555: {
            T: -1
        },
        556: {
            T: 1
        },
        557: {
            T: -1
        },
        558: {
            T: 1
        },
        559: {
            T: -1
        },
        560: {
            T: 1
        },
        561: {
            T: -1
        },
        562: {},
        564: {},
        565: {
            T: 1
        },
        566: {
            T: -1
        },
        569: {
            T: 1
        },
        570: {
            T: -1
        },
        572: {},
        573: {
            T: 1
        },
        574: {
            T: -1
        },
        577: {},
        578: {},
        579: {},
        580: {},
        581: {},
        582: {},
        583: {},
        584: {},
        585: {},
        586: {},
        587: {},
        588: {
            T: -1
        },
        589: {},
        590: {
            T: 1
        },
        591: {
            T: -1
        },
        592: {
            T: 1
        },
        593: {
            T: -1
        },
        594: {
            T: 1
        },
        595: {
            T: -1
        },
        596: {},
        597: {
            T: 1
        },
        598: {
            T: -1
        },
        599: {
            T: 1
        },
        600: {
            T: -1
        },
        601: {
            T: 1
        },
        602: {
            T: -1
        },
        603: {
            T: 1
        },
        604: {
            T: -1
        },
        605: {
            T: 1
        },
        606: {
            T: -1
        },
        607: {},
        608: {
            T: 1
        },
        609: {
            T: -1
        },
        610: {},
        611: {
            T: 1
        },
        612: {
            T: -1
        },
        613: {
            T: 1
        },
        614: {
            T: -1
        },
        615: {
            T: 1
        },
        616: {
            T: -1
        },
        617: {
            T: 1
        },
        618: {
            T: -1
        },
        619: {
            T: 1
        },
        620: {
            T: -1
        },
        625: {},
        626: {
            T: 1
        },
        627: {
            T: -1
        },
        628: {
            T: 1
        },
        629: {
            T: -1
        },
        630: {
            T: 1
        },
        631: {
            T: -1
        },
        632: {
            f: Ue
        },
        633: {
            T: 1
        },
        634: {
            T: -1
        },
        635: {
            T: 1,
            f: function(e) {
                var t = {};
                t.iauthor = e.read_shift(4);
                var r = Sa(e, 16);
                return t.rfx = r.s, t.ref = Kr(r.s), e.l += 16, t;
            }
        },
        636: {
            T: -1
        },
        637: {
            f: ca
        },
        638: {
            T: 1
        },
        639: {},
        640: {
            T: -1
        },
        641: {
            T: 1
        },
        642: {
            T: -1
        },
        643: {
            T: 1
        },
        644: {},
        645: {
            T: -1
        },
        646: {
            T: 1
        },
        648: {
            T: 1
        },
        649: {},
        650: {
            T: -1
        },
        651: {
            f: function(e, t) {
                return e.l += 10, {
                    name: sa(e)
                };
            }
        },
        652: {},
        653: {
            T: 1
        },
        654: {
            T: -1
        },
        655: {
            T: 1
        },
        656: {
            T: -1
        },
        657: {
            T: 1
        },
        658: {
            T: -1
        },
        659: {},
        660: {
            T: 1
        },
        661: {},
        662: {
            T: -1
        },
        663: {},
        664: {
            T: 1
        },
        665: {},
        666: {
            T: -1
        },
        667: {},
        668: {},
        669: {},
        671: {
            T: 1
        },
        672: {
            T: -1
        },
        673: {
            T: 1
        },
        674: {
            T: -1
        },
        675: {},
        676: {},
        677: {},
        678: {},
        679: {},
        680: {},
        681: {},
        1024: {},
        1025: {},
        1026: {
            T: 1
        },
        1027: {
            T: -1
        },
        1028: {
            T: 1
        },
        1029: {
            T: -1
        },
        1030: {},
        1031: {
            T: 1
        },
        1032: {
            T: -1
        },
        1033: {
            T: 1
        },
        1034: {
            T: -1
        },
        1035: {},
        1036: {},
        1037: {},
        1038: {
            T: 1
        },
        1039: {
            T: -1
        },
        1040: {},
        1041: {
            T: 1
        },
        1042: {
            T: -1
        },
        1043: {},
        1044: {},
        1045: {},
        1046: {
            T: 1
        },
        1047: {
            T: -1
        },
        1048: {
            T: 1
        },
        1049: {
            T: -1
        },
        1050: {},
        1051: {
            T: 1
        },
        1052: {
            T: 1
        },
        1053: {
            f: function() {}
        },
        1054: {
            T: 1
        },
        1055: {},
        1056: {
            T: 1
        },
        1057: {
            T: -1
        },
        1058: {
            T: 1
        },
        1059: {
            T: -1
        },
        1061: {},
        1062: {
            T: 1
        },
        1063: {
            T: -1
        },
        1064: {
            T: 1
        },
        1065: {
            T: -1
        },
        1066: {
            T: 1
        },
        1067: {
            T: -1
        },
        1068: {
            T: 1
        },
        1069: {
            T: -1
        },
        1070: {
            T: 1
        },
        1071: {
            T: -1
        },
        1072: {
            T: 1
        },
        1073: {
            T: -1
        },
        1075: {
            T: 1
        },
        1076: {
            T: -1
        },
        1077: {
            T: 1
        },
        1078: {
            T: -1
        },
        1079: {
            T: 1
        },
        1080: {
            T: -1
        },
        1081: {
            T: 1
        },
        1082: {
            T: -1
        },
        1083: {
            T: 1
        },
        1084: {
            T: -1
        },
        1085: {},
        1086: {
            T: 1
        },
        1087: {
            T: -1
        },
        1088: {
            T: 1
        },
        1089: {
            T: -1
        },
        1090: {
            T: 1
        },
        1091: {
            T: -1
        },
        1092: {
            T: 1
        },
        1093: {
            T: -1
        },
        1094: {
            T: 1
        },
        1095: {
            T: -1
        },
        1096: {},
        1097: {
            T: 1
        },
        1098: {},
        1099: {
            T: -1
        },
        1100: {
            T: 1
        },
        1101: {
            T: -1
        },
        1102: {},
        1103: {},
        1104: {},
        1105: {},
        1111: {},
        1112: {},
        1113: {
            T: 1
        },
        1114: {
            T: -1
        },
        1115: {
            T: 1
        },
        1116: {
            T: -1
        },
        1117: {},
        1118: {
            T: 1
        },
        1119: {
            T: -1
        },
        1120: {
            T: 1
        },
        1121: {
            T: -1
        },
        1122: {
            T: 1
        },
        1123: {
            T: -1
        },
        1124: {
            T: 1
        },
        1125: {
            T: -1
        },
        1126: {},
        1128: {
            T: 1
        },
        1129: {
            T: -1
        },
        1130: {},
        1131: {
            T: 1
        },
        1132: {
            T: -1
        },
        1133: {
            T: 1
        },
        1134: {
            T: -1
        },
        1135: {
            T: 1
        },
        1136: {
            T: -1
        },
        1137: {
            T: 1
        },
        1138: {
            T: -1
        },
        1139: {
            T: 1
        },
        1140: {
            T: -1
        },
        1141: {},
        1142: {
            T: 1
        },
        1143: {
            T: -1
        },
        1144: {
            T: 1
        },
        1145: {
            T: -1
        },
        1146: {},
        1147: {
            T: 1
        },
        1148: {
            T: -1
        },
        1149: {
            T: 1
        },
        1150: {
            T: -1
        },
        1152: {
            T: 1
        },
        1153: {
            T: -1
        },
        1154: {
            T: -1
        },
        1155: {
            T: -1
        },
        1156: {
            T: -1
        },
        1157: {
            T: 1
        },
        1158: {
            T: -1
        },
        1159: {
            T: 1
        },
        1160: {
            T: -1
        },
        1161: {
            T: 1
        },
        1162: {
            T: -1
        },
        1163: {
            T: 1
        },
        1164: {
            T: -1
        },
        1165: {
            T: 1
        },
        1166: {
            T: -1
        },
        1167: {
            T: 1
        },
        1168: {
            T: -1
        },
        1169: {
            T: 1
        },
        1170: {
            T: -1
        },
        1171: {},
        1172: {
            T: 1
        },
        1173: {
            T: -1
        },
        1177: {},
        1178: {
            T: 1
        },
        1180: {},
        1181: {},
        1182: {},
        2048: {
            T: 1
        },
        2049: {
            T: -1
        },
        2050: {},
        2051: {
            T: 1
        },
        2052: {
            T: -1
        },
        2053: {},
        2054: {},
        2055: {
            T: 1
        },
        2056: {
            T: -1
        },
        2057: {
            T: 1
        },
        2058: {
            T: -1
        },
        2060: {},
        2067: {},
        2068: {
            T: 1
        },
        2069: {
            T: -1
        },
        2070: {},
        2071: {},
        2072: {
            T: 1
        },
        2073: {
            T: -1
        },
        2075: {},
        2076: {},
        2077: {
            T: 1
        },
        2078: {
            T: -1
        },
        2079: {},
        2080: {
            T: 1
        },
        2081: {
            T: -1
        },
        2082: {},
        2083: {
            T: 1
        },
        2084: {
            T: -1
        },
        2085: {
            T: 1
        },
        2086: {
            T: -1
        },
        2087: {
            T: 1
        },
        2088: {
            T: -1
        },
        2089: {
            T: 1
        },
        2090: {
            T: -1
        },
        2091: {},
        2092: {},
        2093: {
            T: 1
        },
        2094: {
            T: -1
        },
        2095: {},
        2096: {
            T: 1
        },
        2097: {
            T: -1
        },
        2098: {
            T: 1
        },
        2099: {
            T: -1
        },
        2100: {
            T: 1
        },
        2101: {
            T: -1
        },
        2102: {},
        2103: {
            T: 1
        },
        2104: {
            T: -1
        },
        2105: {},
        2106: {
            T: 1
        },
        2107: {
            T: -1
        },
        2108: {},
        2109: {
            T: 1
        },
        2110: {
            T: -1
        },
        2111: {
            T: 1
        },
        2112: {
            T: -1
        },
        2113: {
            T: 1
        },
        2114: {
            T: -1
        },
        2115: {},
        2116: {},
        2117: {},
        2118: {
            T: 1
        },
        2119: {
            T: -1
        },
        2120: {},
        2121: {
            T: 1
        },
        2122: {
            T: -1
        },
        2123: {
            T: 1
        },
        2124: {
            T: -1
        },
        2125: {},
        2126: {
            T: 1
        },
        2127: {
            T: -1
        },
        2128: {},
        2129: {
            T: 1
        },
        2130: {
            T: -1
        },
        2131: {
            T: 1
        },
        2132: {
            T: -1
        },
        2133: {
            T: 1
        },
        2134: {},
        2135: {},
        2136: {},
        2137: {
            T: 1
        },
        2138: {
            T: -1
        },
        2139: {
            T: 1
        },
        2140: {
            T: -1
        },
        2141: {},
        3072: {},
        3073: {},
        4096: {
            T: 1
        },
        4097: {
            T: -1
        },
        5002: {
            T: 1
        },
        5003: {
            T: -1
        },
        5081: {
            T: 1
        },
        5082: {
            T: -1
        },
        5083: {},
        5084: {
            T: 1
        },
        5085: {
            T: -1
        },
        5086: {
            T: 1
        },
        5087: {
            T: -1
        },
        5088: {},
        5089: {},
        5090: {},
        5092: {
            T: 1
        },
        5093: {
            T: -1
        },
        5094: {},
        5095: {
            T: 1
        },
        5096: {
            T: -1
        },
        5097: {},
        5099: {},
        65535: {
            n: ""
        }
    }, Pf = {
        6: {
            f: Lc
        },
        10: {
            f: Rn
        },
        12: {
            f: Nn
        },
        13: {
            f: Nn
        },
        14: {
            f: On
        },
        15: {
            f: On
        },
        16: {
            f: xa
        },
        17: {
            f: On
        },
        18: {
            f: On
        },
        19: {
            f: Nn
        },
        20: {
            f: fs
        },
        21: {
            f: fs
        },
        23: {
            f: ps
        },
        24: {
            f: ds
        },
        25: {
            f: On
        },
        26: {},
        27: {},
        28: {
            f: function(e, t, r) {
                return function(e, t) {
                    if (!(t.biff < 8)) {
                        var r = e.read_shift(2), a = e.read_shift(2), n = e.read_shift(2), s = e.read_shift(2), i = Bn(e, 0, t);
                        return t.biff < 8 && e.read_shift(1), [
                            {
                                r: r,
                                c: a
                            },
                            i,
                            s,
                            n
                        ];
                    }
                }(e, r);
            }
        },
        29: {},
        34: {
            f: On
        },
        35: {
            f: hs
        },
        38: {
            f: xa
        },
        39: {
            f: xa
        },
        40: {
            f: xa
        },
        41: {
            f: xa
        },
        42: {
            f: On
        },
        43: {
            f: On
        },
        47: {
            f: function(e, t, r) {
                var a = {
                    Type: 8 <= r.biff ? e.read_shift(2) : 0
                };
                return a.Type ? Ki(e, t - 2, a) : (t = e, r.biff, e = r, r = a, t = {
                    key: Nn(t),
                    verificationBytes: Nn(t)
                }, e.password && (t.verifier = zi(e.password)), r.valid = t.verificationBytes === t.verifier, r.valid && (r.insitu = Yi(e.password))), a;
            }
        },
        49: {
            f: function(e, t, r) {
                var a = {
                    dyHeight: e.read_shift(2),
                    fl: e.read_shift(2)
                };
                switch(r && r.biff || 8){
                    case 2:
                        break;
                    case 3:
                    case 4:
                        e.l += 2;
                        break;
                    default:
                        e.l += 10;
                }
                return a.name = Ln(e, 0, r), a;
            }
        },
        51: {
            f: Nn
        },
        60: {},
        61: {
            f: function(e) {
                return {
                    Pos: [
                        e.read_shift(2),
                        e.read_shift(2)
                    ],
                    Dim: [
                        e.read_shift(2),
                        e.read_shift(2)
                    ],
                    Flags: e.read_shift(2),
                    CurTab: e.read_shift(2),
                    FirstTab: e.read_shift(2),
                    Selected: e.read_shift(2),
                    TabRatio: e.read_shift(2)
                };
            }
        },
        64: {
            f: On
        },
        65: {
            f: function() {}
        },
        66: {
            f: Nn
        },
        77: {},
        80: {},
        81: {},
        82: {},
        85: {
            f: Nn
        },
        89: {},
        90: {},
        91: {},
        92: {
            f: function(e, t, r) {
                if (r.enc) return e.l += t, "";
                var a = e.l, r = Bn(e, 0, r);
                return e.read_shift(t + a - e.l), r;
            }
        },
        93: {
            f: function(e, t, r) {
                return r && r.biff < 8 ? function(e, t, r) {
                    e.l += 4;
                    var a = e.read_shift(2), n = e.read_shift(2), s = e.read_shift(2);
                    e.l += 2, e.l += 2, e.l += 2, e.l += 2, e.l += 2, e.l += 2, e.l += 2, e.l += 2, e.l += 2, e.l += 6, t -= 36;
                    var i = [];
                    return i.push((gs[a] || Pr)(e, t, r)), {
                        cmo: [
                            n,
                            a,
                            s
                        ],
                        ft: i
                    };
                }(e, t, r) : {
                    cmo: r = Qn(e),
                    ft: function(t, e) {
                        for(var r = t.l + e, a = []; t.l < r;){
                            var n = t.read_shift(2);
                            t.l -= 2;
                            try {
                                a.push(ts[n](t, r - t.l));
                            } catch (e) {
                                return t.l = r, a;
                            }
                        }
                        return t.l != r && (t.l = r), a;
                    }(e, t - 22, r[1])
                };
            }
        },
        94: {},
        95: {
            f: On
        },
        96: {},
        97: {},
        99: {
            f: On
        },
        125: {
            f: vs
        },
        128: {
            f: function(e) {
                if (e.l += 4, 0 !== (e = [
                    e.read_shift(2),
                    e.read_shift(2)
                ])[0] && e[0]--, 0 !== e[1] && e[1]--, 7 < e[0] || 7 < e[1]) throw new Error("Bad Gutters: " + e.join("|"));
                return e;
            }
        },
        129: {
            f: function(e, t, r) {
                return {
                    fDialog: 16 & (t = r && 8 == r.biff || 2 == t ? e.read_shift(2) : (e.l += t, 0)),
                    fBelow: 64 & t,
                    fRight: 128 & t
                };
            }
        },
        130: {
            f: Nn
        },
        131: {
            f: On
        },
        132: {
            f: On
        },
        133: {
            f: function(e, t, r) {
                var a = e.read_shift(4), n = 3 & e.read_shift(1), s = e.read_shift(1);
                switch(s){
                    case 0:
                        s = "Worksheet";
                        break;
                    case 1:
                        s = "Macrosheet";
                        break;
                    case 2:
                        s = "Chartsheet";
                        break;
                    case 6:
                        s = "VBAModule";
                }
                return r = Ln(e, 0, r), {
                    pos: a,
                    hs: n,
                    dt: s,
                    name: r = 0 === r.length ? "Sheet1" : r
                };
            }
        },
        134: {},
        140: {
            f: function(e) {
                var t = [
                    0,
                    0
                ], r = e.read_shift(2);
                return t[0] = Ma[r] || r, r = e.read_shift(2), t[1] = Ma[r] || r, t;
            }
        },
        141: {
            f: Nn
        },
        144: {},
        146: {
            f: function(e) {
                for(var t = e.read_shift(2), r = []; 0 < t--;)r.push(jn(e));
                return r;
            }
        },
        151: {},
        152: {},
        153: {},
        154: {},
        155: {},
        156: {
            f: Nn
        },
        157: {},
        158: {},
        160: {
            f: Ts
        },
        161: {
            f: function(e, t) {
                var r = {};
                return t < 32 || (e.l += 16, r.header = xa(e), r.footer = xa(e), e.l += 2), r;
            }
        },
        174: {},
        175: {},
        176: {},
        177: {},
        178: {},
        180: {},
        181: {},
        182: {},
        184: {},
        185: {},
        189: {
            f: function(e, t) {
                for(var r = e.l + t - 2, a = e.read_shift(2), n = e.read_shift(2), s = []; e.l < r;)s.push(Yn(e));
                if (e.l !== r) throw new Error("MulRK read error");
                if (t = e.read_shift(2), s.length != t - n + 1) throw new Error("MulRK length mismatch");
                return {
                    r: a,
                    c: n,
                    C: t,
                    rkrec: s
                };
            }
        },
        190: {
            f: function(e, t) {
                for(var r = e.l + t - 2, a = e.read_shift(2), n = e.read_shift(2), s = []; e.l < r;)s.push(e.read_shift(2));
                if (e.l !== r) throw new Error("MulBlank read error");
                if (t = e.read_shift(2), s.length != t - n + 1) throw new Error("MulBlank length mismatch");
                return {
                    r: a,
                    c: n,
                    C: t,
                    ixfe: s
                };
            }
        },
        193: {
            f: Rn
        },
        197: {},
        198: {},
        199: {},
        200: {},
        201: {},
        202: {
            f: On
        },
        203: {},
        204: {},
        205: {},
        206: {},
        207: {},
        208: {},
        209: {},
        210: {},
        211: {},
        213: {},
        215: {},
        216: {},
        217: {},
        218: {
            f: Nn
        },
        220: {},
        221: {
            f: On
        },
        222: {},
        224: {
            f: function(e, t, r) {
                var a, n, s, i = {};
                return i.ifnt = e.read_shift(2), i.numFmtId = e.read_shift(2), i.flags = e.read_shift(2), i.fStyle = i.flags >> 2 & 1, t -= 6, i.data = (a = e, i.fStyle, n = r, s = {}, t = a.read_shift(4), e = a.read_shift(4), r = a.read_shift(4), a = a.read_shift(2), s.patternType = Ua[r >> 26], n.cellStyles && (s.alc = 7 & t, s.fWrap = t >> 3 & 1, s.alcV = t >> 4 & 7, s.fJustLast = t >> 7 & 1, s.trot = t >> 8 & 255, s.cIndent = t >> 16 & 15, s.fShrinkToFit = t >> 20 & 1, s.iReadOrder = t >> 22 & 2, s.fAtrNum = t >> 26 & 1, s.fAtrFnt = t >> 27 & 1, s.fAtrAlc = t >> 28 & 1, s.fAtrBdr = t >> 29 & 1, s.fAtrPat = t >> 30 & 1, s.fAtrProt = t >> 31 & 1, s.dgLeft = 15 & e, s.dgRight = e >> 4 & 15, s.dgTop = e >> 8 & 15, s.dgBottom = e >> 12 & 15, s.icvLeft = e >> 16 & 127, s.icvRight = e >> 23 & 127, s.grbitDiag = e >> 30 & 3, s.icvTop = 127 & r, s.icvBottom = r >> 7 & 127, s.icvDiag = r >> 14 & 127, s.dgDiag = r >> 21 & 15, s.icvFore = 127 & a, s.icvBack = a >> 7 & 127, s.fsxButton = a >> 14 & 1), s), i;
            }
        },
        225: {
            f: function(e, t) {
                return 0 === t || e.read_shift(2), 1200;
            }
        },
        226: {
            f: Rn
        },
        227: {},
        229: {
            f: function(e, t) {
                for(var r = [], a = e.read_shift(2); a--;)r.push(Kn(e));
                return r;
            }
        },
        233: {},
        235: {},
        236: {},
        237: {},
        239: {},
        240: {},
        241: {},
        242: {},
        244: {},
        245: {},
        246: {},
        247: {},
        248: {},
        249: {},
        251: {},
        252: {
            f: function(e, t) {
                for(var r = e.l + t, t = e.read_shift(4), a = e.read_shift(4), n = [], s = 0; s != a && e.l < r; ++s)n.push(function(e) {
                    var t = f;
                    f = 1200;
                    var r, a = e.read_shift(2), n = 4 & (c = e.read_shift(1)), s = 8 & c, i = 1 + (1 & c), o = 0, c = {};
                    return s && (o = e.read_shift(2)), n && (r = e.read_shift(4)), i = 2 == i ? "dbcs-cont" : "sbcs-cont", i = 0 === a ? "" : e.read_shift(a, i), s && (e.l += 4 * o), n && (e.l += r), c.t = i, s || (c.raw = "<t>" + c.t + "</t>", c.r = c.t), f = t, c;
                }(e));
                return n.Count = t, n.Unique = a, n;
            }
        },
        253: {
            f: function(e) {
                var t = $n(e);
                return t.isst = e.read_shift(4), t;
            }
        },
        255: {
            f: function(e, t) {
                var r = {};
                return r.dsst = e.read_shift(2), e.l += t - 2, r;
            }
        },
        256: {},
        259: {},
        290: {},
        311: {},
        312: {},
        315: {},
        317: {
            f: Dn
        },
        318: {},
        319: {},
        320: {},
        330: {},
        331: {},
        333: {},
        334: {},
        335: {},
        336: {},
        337: {},
        338: {},
        339: {},
        340: {},
        351: {},
        352: {
            f: On
        },
        353: {
            f: Rn
        },
        401: {},
        402: {},
        403: {},
        404: {},
        405: {},
        406: {},
        407: {},
        408: {},
        425: {},
        426: {},
        427: {},
        428: {},
        429: {},
        430: {
            f: function(e, t, r) {
                var a = e.l + t, n = e.read_shift(2), t = e.read_shift(2);
                if (1025 == (r.sbcch = t) || 14849 == t) return [
                    t,
                    n
                ];
                if (t < 1 || 255 < t) throw new Error("Unexpected SupBook type: " + t);
                for(var r = Mn(e, t), s = []; a > e.l;)s.push(Un(e));
                return [
                    t,
                    n,
                    r,
                    s
                ];
            }
        },
        431: {
            f: On
        },
        432: {},
        433: {},
        434: {},
        437: {},
        438: {
            f: function(t, r, e) {
                var a = t.l, n = "";
                try {
                    t.l += 4;
                    var s = (e.lastobj || {
                        cmo: [
                            0,
                            0
                        ]
                    }).cmo[1];
                    -1 == [
                        0,
                        5,
                        7,
                        11,
                        12,
                        14
                    ].indexOf(s) ? t.l += 6 : function(e) {
                        var t = e.read_shift(1);
                        e.l++;
                        var r = e.read_shift(2);
                        e.l += 2;
                    }(t);
                    var i = t.read_shift(2);
                    t.read_shift(2), Nn(t);
                    s = t.read_shift(2);
                    t.l += s;
                    for(var o = 1; o < t.lens.length - 1; ++o){
                        if (t.l - a != t.lens[o]) throw new Error("TxO: bad continue record");
                        var c = t[t.l];
                        if ((n += Mn(t, t.lens[o + 1] - t.lens[o] - 1)).length >= (c ? i : 2 * i)) break;
                    }
                    if (n.length !== i && n.length !== 2 * i) throw new Error("cchText: " + i + " != " + n.length);
                    return t.l = a + r, {
                        t: n
                    };
                } catch (e) {
                    return t.l = a + r, {
                        t: n
                    };
                }
            }
        },
        439: {
            f: On
        },
        440: {
            f: function(e, t) {
                var r = Kn(e);
                return e.l += 16, [
                    r,
                    function(e, t) {
                        var r = e.l + t;
                        if (2 !== (c = e.read_shift(4))) throw new Error("Unrecognized streamVersion: " + c);
                        t = e.read_shift(2), e.l += 2;
                        var a, n, s, i, o, c = "";
                        16 & t && (a = zn(e, e.l)), 128 & t && (n = zn(e, e.l)), 257 == (257 & t) && (s = zn(e, e.l)), 1 == (257 & t) && (l = Hn(e, e.l)), 8 & t && (c = zn(e, e.l)), 32 & t && (i = e.read_shift(16)), 64 & t && (o = pn(e)), e.l = r;
                        var l = n || s || l || "";
                        return l && c && (l += "#" + c), l = l || "#" + c, l = {
                            Target: l = 2 & t && "/" == l.charAt(0) && "/" != l.charAt(1) ? "file://" + l : l
                        }, i && (l.guid = i), o && (l.time = o), a && (l.Tooltip = a), l;
                    }(e, t - 24)
                ];
            }
        },
        441: {},
        442: {
            f: Un
        },
        443: {},
        444: {
            f: Nn
        },
        445: {},
        446: {},
        448: {
            f: Rn
        },
        449: {
            f: function(e) {
                return e.read_shift(2), e.read_shift(4);
            },
            r: 2
        },
        450: {
            f: Rn
        },
        512: {
            f: os
        },
        513: {
            f: ws
        },
        515: {
            f: function(e, t, r) {
                return r.biffguess && 2 == r.biff && (r.biff = 5), r = $n(e), e = xa(e), r.val = e, r;
            }
        },
        516: {
            f: function(e, t, r) {
                return r.biffguess && 2 == r.biff && (r.biff = 5), e.l, t = $n(e), 2 == r.biff && e.l++, r = Un(e, e.l, r), t.val = r, t;
            }
        },
        517: {
            f: ls
        },
        519: {
            f: Es
        },
        520: {
            f: function(e) {
                var t = {};
                t.r = e.read_shift(2), t.c = e.read_shift(2), t.cnt = e.read_shift(2) - t.c;
                var r = e.read_shift(2);
                e.l += 4;
                var a = e.read_shift(1);
                return e.l += 3, 7 & a && (t.level = 7 & a), 32 & a && (t.hidden = !0), 64 & a && (t.hpt = r / 20), t;
            }
        },
        523: {},
        545: {
            f: ms
        },
        549: {
            f: ss
        },
        566: {},
        574: {
            f: function(e, t, r) {
                return r && 2 <= r.biff && r.biff < 5 ? {} : {
                    RTL: 64 & e.read_shift(2)
                };
            }
        },
        638: {
            f: function(e) {
                var t = e.read_shift(2), r = e.read_shift(2), e = Yn(e);
                return {
                    r: t,
                    c: r,
                    ixfe: e[0],
                    rknum: e[1]
                };
            }
        },
        659: {},
        1048: {},
        1054: {
            f: function(e, t, r) {
                return [
                    e.read_shift(2),
                    Bn(e, 0, r)
                ];
            }
        },
        1084: {},
        1212: {
            f: function(e, t, r) {
                var a = qn(e);
                e.l++;
                var n = e.read_shift(1);
                return [
                    function(e, t, r) {
                        var a, n = e.l + t, s = e.read_shift(2), i = Ic(e, s, r);
                        if (65535 == s) return [
                            [],
                            Pr(e, t - 2)
                        ];
                        t !== s + 2 && (a = Oc(e, n - s - 2, i, r));
                        return [
                            i,
                            a
                        ];
                    }(e, t -= 8, r),
                    n,
                    a
                ];
            }
        },
        2048: {
            f: function(e, t) {
                return e.read_shift(2), [
                    Kn(e),
                    e.read_shift((t - 10) / 2, "dbcs-cont").replace(de, "")
                ];
            }
        },
        2049: {},
        2050: {},
        2051: {},
        2052: {},
        2053: {},
        2054: {},
        2055: {},
        2056: {},
        2057: {
            f: rs
        },
        2058: {},
        2059: {},
        2060: {},
        2061: {},
        2062: {},
        2063: {},
        2064: {},
        2066: {},
        2067: {},
        2128: {},
        2129: {},
        2130: {},
        2131: {},
        2132: {},
        2133: {},
        2134: {},
        2135: {},
        2136: {},
        2137: {},
        2138: {},
        2146: {},
        2147: {
            r: 12
        },
        2148: {},
        2149: {},
        2150: {},
        2151: {
            f: Rn
        },
        2152: {},
        2154: {},
        2155: {},
        2156: {},
        2161: {},
        2162: {},
        2164: {},
        2165: {},
        2166: {},
        2167: {},
        2168: {},
        2169: {},
        2170: {},
        2171: {},
        2172: {
            f: function(e) {
                e.l += 2;
                var t = {
                    cxfs: 0,
                    crc: 0
                };
                return t.cxfs = e.read_shift(2), t.crc = e.read_shift(4), t;
            },
            r: 12
        },
        2173: {
            f: function(e, t) {
                e.l, e.l += 2, t = e.read_shift(2), e.l += 2;
                for(var r = e.read_shift(2), a = []; 0 < r--;)a.push(Ko(e, e.l));
                return {
                    ixfe: t,
                    ext: a
                };
            },
            r: 12
        },
        2174: {},
        2175: {},
        2180: {},
        2181: {},
        2182: {},
        2183: {},
        2184: {},
        2185: {},
        2186: {},
        2187: {},
        2188: {
            f: On,
            r: 12
        },
        2189: {},
        2190: {
            r: 12
        },
        2191: {},
        2192: {},
        2194: {},
        2195: {},
        2196: {
            f: function(e, t, r) {
                if (!(r.biff < 8)) {
                    var a = e.read_shift(2), n = e.read_shift(2);
                    return [
                        Mn(e, a, r),
                        Mn(e, n, r)
                    ];
                }
                e.l += t;
            },
            r: 12
        },
        2197: {},
        2198: {
            f: function(e, t, r) {
                var a = e.l + t;
                if (124226 !== e.read_shift(4)) {
                    if (r.cellStyles) {
                        var n, s = e.slice(e.l);
                        e.l = a;
                        try {
                            n = st(s, {
                                type: "array"
                            });
                        } catch (e) {
                            return;
                        }
                        t = tt(n, "theme/theme/theme1.xml", !0);
                        if (t) return $o(t, r);
                    } else e.l = a;
                }
            },
            r: 12
        },
        2199: {},
        2200: {},
        2201: {},
        2202: {
            f: function(e) {
                return [
                    0 !== e.read_shift(4),
                    0 !== e.read_shift(4),
                    e.read_shift(4)
                ];
            },
            r: 12
        },
        2203: {
            f: Rn
        },
        2204: {},
        2205: {},
        2206: {},
        2207: {},
        2211: {
            f: function(e) {
                var t, r, a = (r = (t = e).read_shift(2), a = t.read_shift(2), t.l += 8, {
                    type: r,
                    flags: a
                });
                if (2211 != a.type) throw new Error("Invalid Future Record " + a.type);
                return 0 !== e.read_shift(4);
            }
        },
        2212: {},
        2213: {},
        2214: {},
        2215: {},
        4097: {},
        4098: {},
        4099: {},
        4102: {},
        4103: {},
        4105: {},
        4106: {},
        4107: {},
        4108: {},
        4109: {},
        4116: {},
        4117: {},
        4118: {},
        4119: {},
        4120: {},
        4121: {},
        4122: {},
        4123: {},
        4124: {},
        4125: {},
        4126: {},
        4127: {},
        4128: {},
        4129: {},
        4130: {},
        4132: {},
        4133: {},
        4134: {
            f: Nn
        },
        4135: {},
        4146: {},
        4147: {},
        4148: {},
        4149: {},
        4154: {},
        4156: {},
        4157: {},
        4158: {},
        4159: {},
        4160: {},
        4161: {},
        4163: {},
        4164: {
            f: function(e, t, r) {
                var a = {
                    area: !1
                };
                return 5 != r.biff ? e.l += t : (t = e.read_shift(1), e.l += 3, 16 & t && (a.area = !0)), a;
            }
        },
        4165: {},
        4166: {},
        4168: {},
        4170: {},
        4171: {},
        4174: {},
        4175: {},
        4176: {},
        4177: {},
        4187: {},
        4188: {
            f: function(e) {
                for(var t = e.read_shift(2), r = []; 0 < t--;)r.push(jn(e));
                return r;
            }
        },
        4189: {},
        4191: {},
        4192: {},
        4193: {},
        4194: {},
        4195: {},
        4196: {},
        4197: {},
        4198: {},
        4199: {},
        4200: {},
        0: {
            f: os
        },
        1: {},
        2: {
            f: function(e) {
                var t = $n(e);
                return ++e.l, e = e.read_shift(2), t.t = "n", t.val = e, t;
            }
        },
        3: {
            f: function(e) {
                var t = $n(e);
                return ++e.l, e = xa(e), t.t = "n", t.val = e, t;
            }
        },
        4: {
            f: function(e, t, r) {
                r.biffguess && 5 == r.biff && (r.biff = 2);
                var a = $n(e);
                return ++e.l, r = Bn(e, 0, r), a.t = "str", a.val = r, a;
            }
        },
        5: {
            f: ls
        },
        7: {
            f: function(e) {
                var t = e.read_shift(1);
                return 0 === t ? (e.l++, "") : e.read_shift(t, "sbcs-cont");
            }
        },
        8: {},
        9: {
            f: rs
        },
        11: {},
        22: {
            f: Nn
        },
        30: {
            f: is
        },
        31: {},
        32: {},
        33: {
            f: ms
        },
        36: {},
        37: {
            f: ss
        },
        50: {
            f: function(e, t) {
                e.l += 6, e.l += 2, e.l += 1, e.l += 3, e.l += 1, e.l += t - 13;
            }
        },
        62: {},
        52: {},
        67: {},
        68: {
            f: Nn
        },
        69: {},
        86: {},
        126: {},
        127: {
            f: function(e) {
                var t = e.read_shift(2), r = e.read_shift(2), a = e.read_shift(4), r = {
                    fmt: t,
                    env: r,
                    len: a,
                    data: e.slice(e.l, e.l + a)
                };
                return e.l += a, r;
            }
        },
        135: {},
        136: {},
        137: {},
        145: {},
        148: {},
        149: {},
        150: {},
        169: {},
        171: {},
        188: {},
        191: {},
        192: {},
        194: {},
        195: {},
        214: {
            f: function(e, t, r) {
                var a = e.l + t, n = $n(e), t = e.read_shift(2), r = Mn(e, t, r);
                return e.l = a, n.t = "str", n.val = r, n;
            }
        },
        223: {},
        234: {},
        354: {},
        421: {},
        518: {
            f: Lc
        },
        521: {
            f: rs
        },
        536: {
            f: ds
        },
        547: {
            f: hs
        },
        561: {},
        579: {},
        1030: {
            f: Lc
        },
        1033: {
            f: rs
        },
        1091: {},
        2157: {},
        2163: {},
        2177: {},
        2240: {},
        2241: {},
        2242: {},
        2243: {},
        2244: {},
        2245: {},
        2246: {},
        2247: {},
        2248: {},
        2249: {},
        2250: {},
        2251: {},
        2262: {
            r: 12
        },
        29282: {}
    };
    function Lf(e, t, r, a) {
        var n = t;
        isNaN(n) || (t = a || (r || []).length || 0, (a = e.next(4)).write_shift(2, n), a.write_shift(2, t), 0 < t && Er(r) && e.push(r));
    }
    function Mf(e, t, r) {
        return (e = e || Lr(7)).write_shift(2, t), e.write_shift(2, r), e.write_shift(2, 0), e.write_shift(1, 0), e;
    }
    function Uf(e, t, r, a) {
        if (null != t.v) switch(t.t){
            case "d":
            case "n":
                var n = "d" == t.t ? De(He(t.v)) : t.v;
                return void (n == (0 | n) && 0 <= n && n < 65536 ? Lf(e, 2, (f = r, h = a, u = n, Mf(d = Lr(9), f, h), d.write_shift(2, u), d)) : Lf(e, 3, (u = r, d = a, n, Mf(l = Lr(15), u, d), l.write_shift(8, n, "f"), l)));
            case "b":
            case "e":
                return void Lf(e, 5, (l = r, s = a, i = t.v, o = t.t, Mf(c = Lr(9), l, s), Pn(i, o || "b", c), c));
            case "s":
            case "str":
                return void Lf(e, 4, (s = r, i = a, o = (t.v || "").slice(0, 255), Mf(c = Lr(8 + 2 * o.length), s, i), c.write_shift(1, o.length), c.write_shift(o.length, o, "sbcs"), c.l < c.length ? c.slice(0, c.l) : c));
        }
        var s, i, o, c, l, f, h, u, d;
        Lf(e, 1, Mf(null, r, a));
    }
    function Bf(e, t) {
        var r = t || {};
        null != oe && null == r.dense && (r.dense = oe);
        for(var t = Ur(), a = 0, n = 0; n < e.SheetNames.length; ++n)e.SheetNames[n] == r.sheet && (a = n);
        if (0 == a && r.sheet && e.SheetNames[0] != r.sheet) throw new Error("Sheet not found: " + r.sheet);
        return Lf(t, 4 == r.biff ? 1033 : 3 == r.biff ? 521 : 9, as(0, 16, r)), function(e, t, r) {
            var a, n, s = Array.isArray(t), i = Zr(t["!ref"] || "A1"), o = [];
            if (255 < i.e.c || 16383 < i.e.r) {
                if (r.WTF) throw new Error("Range " + (t["!ref"] || "A1") + " exceeds format limit A1:IV16384");
                i.e.c = Math.min(i.e.c, 255), i.e.r = Math.min(i.e.c, 16383), a = qr(i);
            }
            for(var c = i.s.r; c <= i.e.r; ++c){
                n = jr(c);
                for(var l = i.s.c; l <= i.e.c; ++l){
                    c === i.s.r && (o[l] = Xr(l)), a = o[l] + n;
                    var f = s ? (t[c] || [])[l] : t[a];
                    f && Uf(e, f, c, l);
                }
            }
        }(t, e.Sheets[e.SheetNames[a]], r), Lf(t, 10), t.end();
    }
    function Wf(e, t, r) {
        var a, n;
        Lf(e, 49, (n = (a = {
            sz: 12,
            color: {
                theme: 1
            },
            name: "Arial",
            family: 2,
            scheme: "minor"
        }).name || "Arial", (e = Lr((r = (e = r) && 5 == e.biff) ? 15 + n.length : 16 + 2 * n.length)).write_shift(2, 20 * (a.sz || 12)), e.write_shift(4, 0), e.write_shift(2, 400), e.write_shift(4, 0), e.write_shift(2, 0), e.write_shift(1, n.length), r || e.write_shift(1, 1), e.write_shift((r ? 1 : 2) * n.length, n, r ? "sbcs" : "utf16le"), e));
    }
    function Hf(i, o, c) {
        o && [
            [
                5,
                8
            ],
            [
                23,
                26
            ],
            [
                41,
                44
            ],
            [
                50,
                392
            ]
        ].forEach(function(e) {
            for(var t, r, a, n, s = e[0]; s <= e[1]; ++s)null != o[s] && Lf(i, 1054, (t = s, r = o[s], n = void 0, a = (a = c) && 5 == a.biff, (n = n || Lr(a ? 3 + r.length : 5 + 2 * r.length)).write_shift(2, t), n.write_shift(a ? 1 : 2, r.length), a || n.write_shift(1, 1), n.write_shift((a ? 1 : 2) * r.length, r, a ? "sbcs" : "utf16le"), null == (n = n.length > n.l ? n.slice(0, n.l) : n).l && (n.l = n.length), n));
        });
    }
    function zf(e, t) {
        for(var r = 0; r < t["!links"].length; ++r){
            var a = t["!links"][r];
            Lf(e, 440, bs(a)), a[1].Tooltip && Lf(e, 2048, function(e) {
                var t = e[1].Tooltip, r = Lr(10 + 2 * (t.length + 1));
                r.write_shift(2, 2048), e = Yr(e[0]), r.write_shift(2, e.r), r.write_shift(2, e.r), r.write_shift(2, e.c), r.write_shift(2, e.c);
                for(var a = 0; a < t.length; ++a)r.write_shift(2, t.charCodeAt(a));
                return r.write_shift(2, 0), r;
            }(a));
        }
        delete t["!links"];
    }
    function Vf(a, e) {
        var n;
        e && (n = 0, e.forEach(function(e, t) {
            var r;
            ++n <= 256 && e && Lf(a, 125, (r = Zc(t, e), e = t, (t = Lr(12)).write_shift(2, e), t.write_shift(2, e), t.write_shift(2, 256 * r.width), t.write_shift(2, 0), e = 0, r.hidden && (e |= 1), t.write_shift(1, e), e = r.level || 0, t.write_shift(1, e), t.write_shift(2, 0), t));
        }));
    }
    function Gf(e, t, r, a, n) {
        var s, i, o, c, l, f, h, u, d, p, m, g = 16 + el(n.cellXfs, t, n);
        if (null != t.v || t.bf) {
            if (t.bf) Lf(e, 6, Mc(t, r, a, 0, g));
            else switch(t.t){
                case "d":
                case "n":
                    var b = "d" == t.t ? De(He(t.v)) : t.v;
                    Lf(e, 515, (f = r, h = a, u = b, d = g, p = Lr(14), Xn(f, h, d, p), Aa(u, p), p));
                    break;
                case "b":
                case "e":
                    Lf(e, 517, (b = r, f = a, h = t.v, d = g, u = t.t, p = Lr(8), Xn(b, f, d, p), Pn(h, u, p), p));
                    break;
                case "s":
                case "str":
                    n.bookSST ? (m = qc(n.Strings, t.v, n.revStrings), Lf(e, 253, (s = r, i = a, o = m, c = g, l = Lr(10), Xn(s, i, c, l), l.write_shift(4, o), l))) : Lf(e, 516, (m = r, s = a, i = (t.v || "").slice(0, 255), c = g, o = Lr(+(l = !(o = n) || 8 == o.biff) + 8 + (1 + l) * i.length), Xn(m, s, c, o), o.write_shift(2, i.length), l && o.write_shift(1, 1), o.write_shift((1 + l) * i.length, i, l ? "utf16le" : "sbcs"), o));
                    break;
                default:
                    Lf(e, 513, Xn(r, a, g));
            }
        } else Lf(e, 513, Xn(r, a, g));
    }
    function jf(e, t, r) {
        var a, n, s = Ur(), i = r.SheetNames[e], o = r.Sheets[i] || {}, c = (r || {}).Workbook || {}, l = (c.Sheets || [])[e] || {}, f = Array.isArray(o), h = 8 == t.biff, u = [], d = Zr(o["!ref"] || "A1"), p = h ? 65536 : 16384;
        if (255 < d.e.c || d.e.r >= p) {
            if (t.WTF) throw new Error("Range " + (o["!ref"] || "A1") + " exceeds format limit A1:IV16384");
            d.e.c = Math.min(d.e.c, 255), d.e.r = Math.min(d.e.c, p - 1);
        }
        Lf(s, 2057, as(0, 16, t)), Lf(s, 13, Fn(1)), Lf(s, 12, Fn(100)), Lf(s, 15, In(!0)), Lf(s, 17, In(!1)), Lf(s, 16, Aa(.001)), Lf(s, 95, In(!0)), Lf(s, 42, In(!1)), Lf(s, 43, In(!1)), Lf(s, 130, Fn(1)), Lf(s, 128, (r = [
            0,
            0
        ], (e = Lr(8)).write_shift(4, 0), e.write_shift(2, r[0] ? r[0] + 1 : 0), e.write_shift(2, r[1] ? r[1] + 1 : 0), e)), Lf(s, 131, In(!1)), Lf(s, 132, In(!1)), h && Vf(s, o["!cols"]), Lf(s, 512, (p = d, (r = Lr(2 * (e = 8 != (r = t).biff && r.biff ? 2 : 4) + 6)).write_shift(e, p.s.r), r.write_shift(e, p.e.r + 1), r.write_shift(2, p.s.c), r.write_shift(2, p.e.c + 1), r.write_shift(2, 0), r)), h && (o["!links"] = []);
        for(var m = d.s.r; m <= d.e.r; ++m){
            n = jr(m);
            for(var g = d.s.c; g <= d.e.c; ++g){
                m === d.s.r && (u[g] = Xr(g)), a = u[g] + n;
                var b = f ? (o[m] || [])[g] : o[a];
                b && (Gf(s, b, m, g, t), h && b.l && o["!links"].push([
                    a,
                    b.l
                ]));
            }
        }
        var v, w, i = l.CodeName || l.name || i;
        return h && Lf(s, 574, (c = (c.Views || [])[0], w = Lr(18), v = 1718, c && c.RTL && (v |= 64), w.write_shift(2, v), w.write_shift(4, 0), w.write_shift(4, 64), w.write_shift(4, 0), w.write_shift(4, 0), w)), h && (o["!merges"] || []).length && Lf(s, 229, function(e) {
            var t = Lr(2 + 8 * e.length);
            t.write_shift(2, e.length);
            for(var r = 0; r < e.length; ++r)Jn(e[r], t);
            return t;
        }(o["!merges"])), h && zf(s, o), Lf(s, 442, Wn(i)), h && (v = s, w = o, (i = Lr(19)).write_shift(4, 2151), i.write_shift(4, 0), i.write_shift(4, 0), i.write_shift(2, 3), i.write_shift(1, 1), i.write_shift(4, 0), Lf(v, 2151, i), (i = Lr(39)).write_shift(4, 2152), i.write_shift(4, 0), i.write_shift(4, 0), i.write_shift(2, 3), i.write_shift(1, 0), i.write_shift(4, 0), i.write_shift(2, 1), i.write_shift(4, 4), i.write_shift(2, 0), Jn(Zr(w["!ref"] || "A1"), i), i.write_shift(4, 4), Lf(v, 2152, i)), Lf(s, 10), s.end();
    }
    function $f(e, t, r) {
        var a = Ur(), n = (e || {}).Workbook || {}, s = n.Sheets || [], i = n.WBProps || {}, o = 8 == r.biff, n = 5 == r.biff;
        Lf(a, 2057, as(0, 5, r)), "xla" == r.bookType && Lf(a, 135), Lf(a, 225, o ? Fn(1200) : null), Lf(a, 193, function(e, t) {
            t = t || Lr(e);
            for(var r = 0; r < e; ++r)t.write_shift(1, 0);
            return t;
        }(2)), n && Lf(a, 191), n && Lf(a, 192), Lf(a, 226), Lf(a, 92, function(e) {
            var t = !e || 8 == e.biff, r = Lr(t ? 112 : 54);
            for(r.write_shift(8 == e.biff ? 2 : 1, 7), t && r.write_shift(1, 0), r.write_shift(4, 859007059), r.write_shift(4, 5458548 | (t ? 0 : 536870912)); r.l < r.length;)r.write_shift(1, t ? 0 : 32);
            return r;
        }(r)), Lf(a, 66, Fn(o ? 1200 : 1252)), o && Lf(a, 353, Fn(0)), o && Lf(a, 448), Lf(a, 317, function(e) {
            for(var t = Lr(2 * e), r = 0; r < e; ++r)t.write_shift(2, r + 1);
            return t;
        }(e.SheetNames.length)), o && e.vbaraw && Lf(a, 211), o && e.vbaraw && Lf(a, 442, Wn(i.CodeName || "ThisWorkbook")), Lf(a, 156, Fn(17)), Lf(a, 25, In(!1)), Lf(a, 18, In(!1)), Lf(a, 19, Fn(0)), o && Lf(a, 431, In(!1)), o && Lf(a, 444, Fn(0)), Lf(a, 61, ((n = Lr(18)).write_shift(2, 0), n.write_shift(2, 0), n.write_shift(2, 29280), n.write_shift(2, 17600), n.write_shift(2, 56), n.write_shift(2, 0), n.write_shift(2, 0), n.write_shift(2, 1), n.write_shift(2, 500), n)), Lf(a, 64, In(!1)), Lf(a, 141, Fn(0)), Lf(a, 34, In("true" == ((i = e).Workbook && i.Workbook.WBProps && Rt(i.Workbook.WBProps.date1904) ? "true" : "false"))), Lf(a, 14, In(!0)), o && Lf(a, 439, In(!1)), Lf(a, 218, Fn(0)), Wf(a, 0, r), Hf(a, e.SSF, r), function(t, r) {
            for(var e = 0; e < 16; ++e)Lf(t, 224, cs({
                numFmtId: 0,
                style: !0
            }, 0, r));
            r.cellXfs.forEach(function(e) {
                Lf(t, 224, cs(e, 0, r));
            });
        }(a, r), o && Lf(a, 352, In(!1));
        n = a.end(), i = Ur();
        o && Lf(i, 140, ((g = g || Lr(4)).write_shift(2, 1), g.write_shift(2, 1), g)), o && r.Strings && function(e, t, r) {
            var a = (r || []).length || 0;
            if (a <= 8224) return Lf(e, t, r, a);
            if (!isNaN(t)) {
                for(var n = r.parts || [], s = 0, i = 0, o = 0; o + (n[s] || 8224) <= 8224;)o += n[s] || 8224, s++;
                var c = e.next(4);
                for(c.write_shift(2, t), c.write_shift(2, o), e.push(r.slice(i, i + o)), i += o; i < a;){
                    for((c = e.next(4)).write_shift(2, 60), o = 0; o + (n[s] || 8224) <= 8224;)o += n[s] || 8224, s++;
                    c.write_shift(2, o), e.push(r.slice(i, i + o)), i += o;
                }
            }
        }(i, 252, ns(r.Strings)), Lf(i, 10);
        for(var a = i.end(), c = Ur(), l = 0, f = 0, f = 0; f < e.SheetNames.length; ++f)l += (o ? 12 : 11) + (o ? 2 : 1) * e.SheetNames[f].length;
        var h, u, d, p, m = n.length + l + a.length;
        for(f = 0; f < e.SheetNames.length; ++f)Lf(c, 133, (h = {
            pos: m,
            hs: (s[f] || {}).Hidden || 0,
            dt: 0,
            name: e.SheetNames[f]
        }, p = d = void 0, d = !(u = r) || 8 <= u.biff ? 2 : 1, (p = Lr(8 + d * h.name.length)).write_shift(4, h.pos), p.write_shift(1, h.hs || 0), p.write_shift(1, h.dt), p.write_shift(1, h.name.length), 8 <= u.biff && p.write_shift(1, 1), p.write_shift(d * h.name.length, h.name, u.biff < 8 ? "sbcs" : "utf16le"), (u = p.slice(0, p.l)).l = p.l, u)), m += t[f].length;
        var g = c.end();
        if (l != g.length) throw new Error("BS8 " + l + " != " + g.length);
        i = [];
        return n.length && i.push(n), g.length && i.push(g), a.length && i.push(a), ue(i);
    }
    function Xf(e, t) {
        for(var r = 0; r <= e.SheetNames.length; ++r){
            var a = e.Sheets[e.SheetNames[r]];
            a && a["!ref"] && 255 < Jr(a["!ref"]).e.c && "undefined" != typeof console && console.error && console.error("Worksheet '" + e.SheetNames[r] + "' extends beyond column IV (255).  Data may be lost.");
        }
        var n = t || {};
        switch(n.biff || 2){
            case 8:
            case 5:
                return function(e, t) {
                    var r = t || {}, a = [];
                    e && !e.SSF && (e.SSF = Ve(me)), e && e.SSF && (Ee(), Te(e.SSF), r.revssf = Ne(e.SSF), r.revssf[e.SSF[65535]] = 0, r.ssf = e.SSF), r.Strings = [], r.Strings.Count = 0, r.Strings.Unique = 0, Uh(r), r.cellXfs = [], el(r.cellXfs, {}, {
                        revssf: {
                            General: 0
                        }
                    }), e.Props || (e.Props = {});
                    for(var n = 0; n < e.SheetNames.length; ++n)a[a.length] = jf(n, r, e);
                    return a.unshift($f(e, a, r)), ue(a);
                }(e, t);
            case 4:
            case 3:
            case 2:
                return Bf(e, t);
        }
        throw new Error("invalid type " + n.bookType + " for BIFF");
    }
    function Yf(e, t) {
        var r = t || {};
        null != oe && null == r.dense && (r.dense = oe);
        var a = r.dense ? [] : {}, n = (e = e.replace(/<!--.*?-->/g, "")).match(/<table/i);
        if (!n) throw new Error("Invalid HTML: could not find <table>");
        for(var s, t = e.match(/<\/table/i), i = n.index, o = t && t.index || e.length, c = Ke(e.slice(i, o), /(:?<tr[^>]*>)/i, "<tr>"), l = -1, f = 0, h = {
            s: {
                r: 1e7,
                c: 1e7
            },
            e: {
                r: 0,
                c: 0
            }
        }, u = [], i = 0; i < c.length; ++i){
            var d = c[i].trim(), p = d.slice(0, 3).toLowerCase();
            if ("<tr" != p) {
                if ("<td" == p || "<th" == p) for(var m = d.split(/<\/t[dh]>/i), o = 0; o < m.length; ++o){
                    var g = m[o].trim();
                    if (g.match(/<t[dh]/i)) {
                        for(var b = g, v = 0; "<" == b.charAt(0) && -1 < (v = b.indexOf(">"));)b = b.slice(v + 1);
                        for(var w = 0; w < u.length; ++w){
                            var T = u[w];
                            T.s.c == f && T.s.r < l && l <= T.e.r && (f = T.e.c + 1, w = -1);
                        }
                        var E = dt(g.slice(0, g.indexOf(">"))), k = E.colspan ? +E.colspan : 1;
                        (1 < (s = +E.rowspan) || 1 < k) && u.push({
                            s: {
                                r: l,
                                c: f
                            },
                            e: {
                                r: l + (s || 1) - 1,
                                c: f + k - 1
                            }
                        });
                        g = E.t || E["data-t"] || "";
                        b.length && (b = Wt(b), h.s.r > l && (h.s.r = l), h.e.r < l && (h.e.r = l), h.s.c > f && (h.s.c = f), h.e.c < f && (h.e.c = f), b.length && (E = {
                            t: "s",
                            v: b
                        }, r.raw || !b.trim().length || "s" == g || ("TRUE" === b ? E = {
                            t: "b",
                            v: !0
                        } : "FALSE" === b ? E = {
                            t: "b",
                            v: !1
                        } : isNaN(je(b)) ? isNaN(Xe(b).getDate()) || (E = {
                            t: "d",
                            v: He(b)
                        }, (E = !r.cellDates ? {
                            t: "n",
                            v: De(E.v)
                        } : E).z = r.dateNF || me[14]) : E = {
                            t: "n",
                            v: je(b)
                        }), r.dense ? (a[l] || (a[l] = []), a[l][f] = E) : a[Kr({
                            r: l,
                            c: f
                        })] = E)), f += k;
                    }
                }
            } else {
                if (++l, r.sheetRows && r.sheetRows <= l) {
                    --l;
                    break;
                }
                f = 0;
            }
        }
        return a["!ref"] = qr(h), u.length && (a["!merges"] = u), a;
    }
    function Kf(e, t, r, a) {
        for(var n = e["!merges"] || [], s = [], i = t.s.c; i <= t.e.c; ++i){
            for(var o, c, l, f, h = 0, u = 0, d = 0; d < n.length; ++d)if (!(n[d].s.r > r || n[d].s.c > i || n[d].e.r < r || n[d].e.c < i)) {
                if (n[d].s.r < r || n[d].s.c < i) {
                    h = -1;
                    break;
                }
                h = n[d].e.r - n[d].s.r + 1, u = n[d].e.c - n[d].s.c + 1;
                break;
            }
            h < 0 || (o = Kr({
                r: r,
                c: i
            }), l = (c = a.dense ? (e[r] || [])[i] : e[o]) && null != c.v && (c.h || _t(c.w || (ea(c), c.w) || "")) || "", f = {}, 1 < h && (f.rowspan = h), 1 < u && (f.colspan = u), a.editable ? l = '<span contenteditable="true">' + l + "</span>" : c && (f["data-t"] = c && c.t || "z", null != c.v && (f["data-v"] = c.v), null != c.z && (f["data-z"] = c.z), c.l && "#" != (c.l.Target || "#").charAt(0) && (l = '<a href="' + c.l.Target + '">' + l + "</a>")), f.id = (a.id || "sjs") + "-" + o, s.push(Yt("td", l, f)));
        }
        return "<tr>" + s.join("") + "</tr>";
    }
    var Jf = '<html><head><meta charset="utf-8"/><title>SheetJS Table Export</title></head><body>', qf = "</body></html>";
    function Zf(e, t, r) {
        return [].join("") + "<table" + (r && r.id ? ' id="' + r.id + '"' : "") + ">";
    }
    function Qf(e, t) {
        var r = t || {}, a = null != r.header ? r.header : Jf, t = null != r.footer ? r.footer : qf, n = [
            a
        ], s = Jr(e["!ref"]);
        r.dense = Array.isArray(e), n.push(Zf(0, 0, r));
        for(var i = s.s.r; i <= s.e.r; ++i)n.push(Kf(e, s, i, r));
        return n.push("</table>" + t), n.join("");
    }
    function eh(e, t, r) {
        var a = r || {};
        null != oe && (a.dense = oe);
        var n = 0, s = 0;
        null != a.origin && ("number" == typeof a.origin ? n = a.origin : (n = (r = "string" == typeof a.origin ? Yr(a.origin) : a.origin).r, s = r.c));
        var i = t.getElementsByTagName("tr"), o = Math.min(a.sheetRows || 1e7, i.length), c = {
            s: {
                r: 0,
                c: 0
            },
            e: {
                r: n,
                c: s
            }
        };
        e["!ref"] && (t = Jr(e["!ref"]), c.s.r = Math.min(c.s.r, t.s.r), c.s.c = Math.min(c.s.c, t.s.c), c.e.r = Math.max(c.e.r, t.e.r), c.e.c = Math.max(c.e.c, t.e.c), -1 == n && (c.e.r = n = t.e.r + 1));
        var l, f, h = [], u = 0, d = e["!rows"] || (e["!rows"] = []), p = 0, m = 0, g = 0, b = 0;
        for(e["!cols"] || (e["!cols"] = []); p < i.length && m < o; ++p){
            var v = i[p];
            if (rh(v)) {
                if (a.display) continue;
                d[m] = {
                    hidden: !0
                };
            }
            for(var w = v.children, g = b = 0; g < w.length; ++g){
                var T = w[g];
                if (!a.display || !rh(T)) {
                    for(var E = T.hasAttribute("data-v") ? T.getAttribute("data-v") : T.hasAttribute("v") ? T.getAttribute("v") : Wt(T.innerHTML), k = T.getAttribute("data-z") || T.getAttribute("z"), u = 0; u < h.length; ++u){
                        var y = h[u];
                        y.s.c == b + s && y.s.r < m + n && m + n <= y.e.r && (b = y.e.c + 1 - s, u = -1);
                    }
                    f = +T.getAttribute("colspan") || 1, (1 < (l = +T.getAttribute("rowspan") || 1) || 1 < f) && h.push({
                        s: {
                            r: m + n,
                            c: b + s
                        },
                        e: {
                            r: m + n + (l || 1) - 1,
                            c: b + s + (f || 1) - 1
                        }
                    });
                    var S = {
                        t: "s",
                        v: E
                    }, _ = T.getAttribute("data-t") || T.getAttribute("t") || "";
                    null != E && (0 == E.length ? S.t = _ || "z" : a.raw || 0 == E.trim().length || "s" == _ || ("TRUE" === E ? S = {
                        t: "b",
                        v: !0
                    } : "FALSE" === E ? S = {
                        t: "b",
                        v: !1
                    } : isNaN(je(E)) ? isNaN(Xe(E).getDate()) || (S = {
                        t: "d",
                        v: He(E)
                    }, (S = !a.cellDates ? {
                        t: "n",
                        v: De(S.v)
                    } : S).z = a.dateNF || me[14]) : S = {
                        t: "n",
                        v: je(E)
                    })), void 0 === S.z && null != k && (S.z = k);
                    var x = "", A = T.getElementsByTagName("A");
                    if (A && A.length) for(var C = 0; C < A.length && (!A[C].hasAttribute("href") || "#" == (x = A[C].getAttribute("href")).charAt(0)); ++C);
                    x && "#" != x.charAt(0) && (S.l = {
                        Target: x
                    }), a.dense ? (e[m + n] || (e[m + n] = []), e[m + n][b + s] = S) : e[Kr({
                        c: b + s,
                        r: m + n
                    })] = S, c.e.c < b + s && (c.e.c = b + s), b += f;
                }
            }
            ++m;
        }
        return h.length && (e["!merges"] = (e["!merges"] || []).concat(h)), c.e.r = Math.max(c.e.r, m - 1 + n), e["!ref"] = qr(c), o <= m && (e["!fullref"] = qr((c.e.r = i.length - p + m - 1 + n, c))), e;
    }
    function th(e, t) {
        return eh((t || {}).dense ? [] : {}, e, t);
    }
    function rh(e) {
        var t, r = "", t = (t = e).ownerDocument.defaultView && "function" == typeof t.ownerDocument.defaultView.getComputedStyle ? t.ownerDocument.defaultView.getComputedStyle : "function" == typeof getComputedStyle ? getComputedStyle : null;
        return "none" === (r = (r = t ? t(e).getPropertyValue("display") : r) || e.style && e.style.display);
    }
    var ah = {
        day: [
            "d",
            "dd"
        ],
        month: [
            "m",
            "mm"
        ],
        year: [
            "y",
            "yy"
        ],
        hours: [
            "h",
            "hh"
        ],
        minutes: [
            "m",
            "mm"
        ],
        seconds: [
            "s",
            "ss"
        ],
        "am-pm": [
            "A/P",
            "AM/PM"
        ],
        "day-of-week": [
            "ddd",
            "dddd"
        ],
        era: [
            "e",
            "ee"
        ],
        quarter: [
            "\\Qm",
            'm\\"th quarter"'
        ]
    };
    function nh(e, t) {
        var r = t || {};
        null != oe && null == r.dense && (r.dense = oe);
        var a, n, s, i, o, c = Jt(e), l = [], f = {
            name: ""
        }, h = "", u = 0, d = {}, p = [], m = r.dense ? [] : {}, g = {
            value: ""
        }, b = "", v = 0, w = [], T = -1, E = -1, k = {
            s: {
                r: 1e6,
                c: 1e7
            },
            e: {
                r: 0,
                c: 0
            }
        }, y = 0, S = {}, _ = [], x = {}, A = [], C = 1, R = 1, O = [], I = {
            Names: []
        }, N = {}, F = [
            "",
            ""
        ], D = [], P = {}, L = "", M = 0, U = !1, B = !1, W = 0;
        for(qt.lastIndex = 0, c = c.replace(/<!--([\s\S]*?)-->/gm, "").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm, ""); i = qt.exec(c);)switch(i[3] = i[3].replace(/_.*$/, "")){
            case "table":
            case "\u5DE5\u4F5C\u8868":
                "/" === i[1] ? (k.e.c >= k.s.c && k.e.r >= k.s.r ? m["!ref"] = qr(k) : m["!ref"] = "A1:A1", 0 < r.sheetRows && r.sheetRows <= k.e.r && (m["!fullref"] = m["!ref"], k.e.r = r.sheetRows - 1, m["!ref"] = qr(k)), _.length && (m["!merges"] = _), A.length && (m["!rows"] = A), s.name = s["\u540D\u79F0"] || s.name, "undefined" != typeof JSON && JSON.stringify(s), p.push(s.name), d[s.name] = m, B = !1) : "/" !== i[0].charAt(i[0].length - 2) && (s = dt(i[0], !1), T = E = -1, k.s.r = k.s.c = 1e7, k.e.r = k.e.c = 0, m = r.dense ? [] : {}, _ = [], A = [], B = !0);
                break;
            case "table-row-group":
                "/" === i[1] ? --y : ++y;
                break;
            case "table-row":
            case "\u884C":
                if ("/" === i[1]) {
                    T += C, C = 1;
                    break;
                }
                if ((H = dt(i[0], !1))["\u884C\u53F7"] ? T = H["\u884C\u53F7"] - 1 : -1 == T && (T = 0), (C = +H["number-rows-repeated"] || 1) < 10) for(W = 0; W < C; ++W)0 < y && (A[T + W] = {
                    level: y
                });
                E = -1;
                break;
            case "covered-table-cell":
                "/" !== i[1] && ++E, r.sheetStubs && (r.dense ? (m[T] || (m[T] = []), m[T][E] = {
                    t: "z"
                }) : m[Kr({
                    r: T,
                    c: E
                })] = {
                    t: "z"
                }), b = "", w = [];
                break;
            case "table-cell":
            case "\u6570\u636E":
                if ("/" === i[0].charAt(i[0].length - 2)) ++E, g = dt(i[0], !1), R = parseInt(g["number-columns-repeated"] || "1", 10), o = {
                    t: "z",
                    v: null
                }, g.formula && 0 != r.cellFormula && (o.f = $c(wt(g.formula))), "string" == (g["\u6570\u636E\u7C7B\u578B"] || g["value-type"]) && (o.t = "s", o.v = wt(g["string-value"] || ""), r.dense ? (m[T] || (m[T] = []), m[T][E] = o) : m[Kr({
                    r: T,
                    c: E
                })] = o), E += R - 1;
                else if ("/" !== i[1]) {
                    b = "", v = 0, w = [], R = 1;
                    var H = C ? T + C - 1 : T;
                    if (++E > k.e.c && (k.e.c = E), E < k.s.c && (k.s.c = E), T < k.s.r && (k.s.r = T), H > k.e.r && (k.e.r = H), D = [], P = {}, o = {
                        t: (g = dt(i[0], !1))["\u6570\u636E\u7C7B\u578B"] || g["value-type"],
                        v: null
                    }, r.cellFormula) {
                        if (g.formula && (g.formula = wt(g.formula)), g["number-matrix-columns-spanned"] && g["number-matrix-rows-spanned"] && (x = {
                            s: {
                                r: T,
                                c: E
                            },
                            e: {
                                r: T + (parseInt(g["number-matrix-rows-spanned"], 10) || 0) - 1,
                                c: E + (parseInt(g["number-matrix-columns-spanned"], 10) || 0) - 1
                            }
                        }, o.F = qr(x), O.push([
                            x,
                            o.F
                        ])), g.formula) o.f = $c(g.formula);
                        else for(W = 0; W < O.length; ++W)T >= O[W][0].s.r && T <= O[W][0].e.r && E >= O[W][0].s.c && E <= O[W][0].e.c && (o.F = O[W][1]);
                    }
                    switch((g["number-columns-spanned"] || g["number-rows-spanned"]) && (x = {
                        s: {
                            r: T,
                            c: E
                        },
                        e: {
                            r: T + (parseInt(g["number-rows-spanned"], 10) || 0) - 1,
                            c: E + (parseInt(g["number-columns-spanned"], 10) || 0) - 1
                        }
                    }, _.push(x)), g["number-columns-repeated"] && (R = parseInt(g["number-columns-repeated"], 10)), o.t){
                        case "boolean":
                            o.t = "b", o.v = Rt(g["boolean-value"]);
                            break;
                        case "float":
                        case "percentage":
                        case "currency":
                            o.t = "n", o.v = parseFloat(g.value);
                            break;
                        case "date":
                            o.t = "d", o.v = He(g["date-value"]), r.cellDates || (o.t = "n", o.v = De(o.v)), o.z = "m/d/yy";
                            break;
                        case "time":
                            o.t = "n", o.v = function(e) {
                                var t = 0, r = 0, a = !1, n = e.match(/P([0-9\.]+Y)?([0-9\.]+M)?([0-9\.]+D)?T([0-9\.]+H)?([0-9\.]+M)?([0-9\.]+S)?/);
                                if (!n) throw new Error("|" + e + "| is not an ISO8601 Duration");
                                for(var s = 1; s != n.length; ++s)if (n[s]) {
                                    switch(r = 1, 3 < s && (a = !0), n[s].slice(n[s].length - 1)){
                                        case "Y":
                                            throw new Error("Unsupported ISO Duration Field: " + n[s].slice(n[s].length - 1));
                                        case "D":
                                            r *= 24;
                                        case "H":
                                            r *= 60;
                                        case "M":
                                            if (!a) throw new Error("Unsupported ISO Duration Field: M");
                                            r *= 60;
                                    }
                                    t += r * parseInt(n[s], 10);
                                }
                                return t;
                            }(g["time-value"]) / 86400, r.cellDates && (o.t = "d", o.v = Me(o.v)), o.z = "HH:MM:SS";
                            break;
                        case "number":
                            o.t = "n", o.v = parseFloat(g["\u6570\u636E\u6570\u503C"]);
                            break;
                        default:
                            if ("string" !== o.t && "text" !== o.t && o.t) throw new Error("Unsupported value type " + o.t);
                            o.t = "s", null != g["string-value"] && (b = wt(g["string-value"]), w = []);
                    }
                } else {
                    if (U = !1, "s" === o.t && (o.v = b || "", w.length && (o.R = w), U = 0 == v), N.Target && (o.l = N), 0 < D.length && (o.c = D, D = []), b && !1 !== r.cellText && (o.w = b), U && (o.t = "z", delete o.v), (!U || r.sheetStubs) && !(r.sheetRows && r.sheetRows <= T)) for(var z = 0; z < C; ++z){
                        if (R = parseInt(g["number-columns-repeated"] || "1", 10), r.dense) for(m[T + z] || (m[T + z] = []), m[T + z][E] = 0 == z ? o : Ve(o); 0 < --R;)m[T + z][E + R] = Ve(o);
                        else for(m[Kr({
                            r: T + z,
                            c: E
                        })] = o; 0 < --R;)m[Kr({
                            r: T + z,
                            c: E + R
                        })] = Ve(o);
                        k.e.c <= E && (k.e.c = E);
                    }
                    E += (R = parseInt(g["number-columns-repeated"] || "1", 10)) - 1, R = 0, o = {}, b = "", w = [];
                }
                N = {};
                break;
            case "document":
            case "document-content":
            case "\u7535\u5B50\u8868\u683C\u6587\u6863":
            case "spreadsheet":
            case "\u4E3B\u4F53":
            case "scripts":
            case "styles":
            case "font-face-decls":
            case "master-styles":
                if ("/" === i[1]) {
                    if ((a = l.pop())[0] !== i[3]) throw "Bad state: " + a;
                } else "/" !== i[0].charAt(i[0].length - 2) && l.push([
                    i[3],
                    !0
                ]);
                break;
            case "annotation":
                if ("/" === i[1]) {
                    if ((a = l.pop())[0] !== i[3]) throw "Bad state: " + a;
                    P.t = b, w.length && (P.R = w), P.a = L, D.push(P);
                } else "/" !== i[0].charAt(i[0].length - 2) && l.push([
                    i[3],
                    !1
                ]);
                b = L = "", v = M = 0, w = [];
                break;
            case "creator":
                "/" === i[1] ? L = c.slice(M, i.index) : M = i.index + i[0].length;
                break;
            case "meta":
            case "\u5143\u6570\u636E":
            case "settings":
            case "config-item-set":
            case "config-item-map-indexed":
            case "config-item-map-entry":
            case "config-item-map-named":
            case "shapes":
            case "frame":
            case "text-box":
            case "image":
            case "data-pilot-tables":
            case "list-style":
            case "form":
            case "dde-links":
            case "event-listeners":
            case "chart":
                if ("/" === i[1]) {
                    if ((a = l.pop())[0] !== i[3]) throw "Bad state: " + a;
                } else "/" !== i[0].charAt(i[0].length - 2) && l.push([
                    i[3],
                    !1
                ]);
                b = "", v = 0, w = [];
                break;
            case "scientific-number":
            case "currency-symbol":
            case "currency-style":
                break;
            case "number-style":
            case "percentage-style":
            case "date-style":
            case "time-style":
                if ("/" === i[1]) {
                    if (S[f.name] = h, (a = l.pop())[0] !== i[3]) throw "Bad state: " + a;
                } else "/" !== i[0].charAt(i[0].length - 2) && (h = "", f = dt(i[0], !1), l.push([
                    i[3],
                    !0
                ]));
                break;
            case "script":
            case "libraries":
            case "automatic-styles":
                break;
            case "default-style":
            case "page-layout":
            case "style":
            case "map":
            case "font-face":
            case "paragraph-properties":
            case "table-properties":
            case "table-column-properties":
            case "table-row-properties":
            case "table-cell-properties":
                break;
            case "number":
                switch(l[l.length - 1][0]){
                    case "time-style":
                    case "date-style":
                        n = dt(i[0], !1), h += ah[i[3]]["long" === n.style ? 1 : 0];
                }
                break;
            case "fraction":
                break;
            case "day":
            case "month":
            case "year":
            case "era":
            case "day-of-week":
            case "week-of-year":
            case "quarter":
            case "hours":
            case "minutes":
            case "seconds":
            case "am-pm":
                switch(l[l.length - 1][0]){
                    case "time-style":
                    case "date-style":
                        n = dt(i[0], !1), h += ah[i[3]]["long" === n.style ? 1 : 0];
                }
                break;
            case "boolean-style":
            case "boolean":
            case "text-style":
                break;
            case "text":
                if ("/>" === i[0].slice(-2)) break;
                if ("/" === i[1]) switch(l[l.length - 1][0]){
                    case "number-style":
                    case "date-style":
                    case "time-style":
                        h += c.slice(u, i.index);
                }
                else u = i.index + i[0].length;
                break;
            case "named-range":
                F = Xc((n = dt(i[0], !1))["cell-range-address"]);
                var V = {
                    Name: n.name,
                    Ref: F[0] + "!" + F[1]
                };
                B && (V.Sheet = p.length), I.Names.push(V);
                break;
            case "text-content":
            case "text-properties":
            case "embedded-text":
                break;
            case "body":
            case "\u7535\u5B50\u8868\u683C":
            case "forms":
            case "table-column":
            case "table-header-rows":
            case "table-rows":
            case "table-column-group":
            case "table-header-columns":
            case "table-columns":
            case "null-date":
            case "graphic-properties":
            case "calculation-settings":
            case "named-expressions":
            case "label-range":
            case "label-ranges":
            case "named-expression":
            case "sort":
            case "sort-by":
            case "sort-groups":
            case "tab":
            case "line-break":
            case "span":
                break;
            case "p":
            case "\u6587\u672C\u4E32":
                if (-1 < [
                    "master-styles"
                ].indexOf(l[l.length - 1][0])) break;
                "/" !== i[1] || g && g["string-value"] ? (dt(i[0], !1), v = i.index + i[0].length) : (V = (V = c.slice(v, i.index)).replace(/[\t\r\n]/g, " ").trim().replace(/ +/g, " ").replace(/<text:s\/>/g, " ").replace(/<text:s text:c="(\d+)"\/>/g, function(e, t) {
                    return Array(parseInt(t, 10) + 1).join(" ");
                }).replace(/<text:tab[^>]*\/>/g, "\t").replace(/<text:line-break\/>/g, "\n"), V = [
                    wt(V.replace(/<[^>]*>/g, ""))
                ], b = (0 < b.length ? b + "\n" : "") + V[0]);
                break;
            case "s":
                break;
            case "database-range":
                if ("/" === i[1]) break;
                try {
                    d[(F = Xc(dt(i[0])["target-range-address"]))[0]]["!autofilter"] = {
                        ref: F[1]
                    };
                } catch (e) {}
                break;
            case "date":
            case "object":
                break;
            case "title":
            case "\u6807\u9898":
            case "desc":
            case "binary-data":
            case "table-source":
            case "scenario":
            case "iteration":
            case "content-validations":
            case "content-validation":
            case "help-message":
            case "error-message":
            case "database-ranges":
            case "filter":
            case "filter-and":
            case "filter-or":
            case "filter-condition":
            case "list-level-style-bullet":
            case "list-level-style-number":
            case "list-level-properties":
                break;
            case "sender-firstname":
            case "sender-lastname":
            case "sender-initials":
            case "sender-title":
            case "sender-position":
            case "sender-email":
            case "sender-phone-private":
            case "sender-fax":
            case "sender-company":
            case "sender-phone-work":
            case "sender-street":
            case "sender-city":
            case "sender-postal-code":
            case "sender-country":
            case "sender-state-or-province":
            case "author-name":
            case "author-initials":
            case "chapter":
            case "file-name":
            case "template-name":
            case "sheet-name":
            case "event-listener":
                break;
            case "initial-creator":
            case "creation-date":
            case "print-date":
            case "generator":
            case "document-statistic":
            case "user-defined":
            case "editing-duration":
            case "editing-cycles":
            case "config-item":
            case "page-number":
            case "page-count":
            case "time":
            case "cell-range-source":
            case "detective":
            case "operation":
            case "highlighted-range":
                break;
            case "data-pilot-table":
            case "source-cell-range":
            case "source-service":
            case "data-pilot-field":
            case "data-pilot-level":
            case "data-pilot-subtotals":
            case "data-pilot-subtotal":
            case "data-pilot-members":
            case "data-pilot-member":
            case "data-pilot-display-info":
            case "data-pilot-sort-info":
            case "data-pilot-layout-info":
            case "data-pilot-field-reference":
            case "data-pilot-groups":
            case "data-pilot-group":
            case "data-pilot-group-member":
            case "rect":
                break;
            case "dde-connection-decls":
            case "dde-connection-decl":
            case "dde-link":
            case "dde-source":
            case "properties":
            case "property":
                break;
            case "a":
                if ("/" !== i[1]) {
                    if (!(N = dt(i[0], !1)).href) break;
                    N.Target = wt(N.href), delete N.href, "#" == N.Target.charAt(0) && -1 < N.Target.indexOf(".") ? (F = Xc(N.Target.slice(1)), N.Target = "#" + F[0] + "!" + F[1]) : N.Target.match(/^\.\.[\\\/]/) && (N.Target = N.Target.slice(3));
                }
                break;
            case "table-protection":
            case "data-pilot-grand-total":
            case "office-document-common-attrs":
                break;
            default:
                switch(i[2]){
                    case "dc:":
                    case "calcext:":
                    case "loext:":
                    case "ooo:":
                    case "chartooo:":
                    case "draw:":
                    case "style:":
                    case "chart:":
                    case "form:":
                    case "uof:":
                    case "\u8868:":
                    case "\u5B57:":
                        break;
                    default:
                        if (r.WTF) throw new Error(i);
                }
        }
        e = {
            Sheets: d,
            SheetNames: p,
            Workbook: I
        };
        return r.bookSheets && delete e.Sheets, e;
    }
    function sh(e, t) {
        t = t || {}, Ze(e, "META-INF/manifest.xml") && function(e, t) {
            for(var r, a, n = Jt(e); r = qt.exec(n);)switch(r[3]){
                case "manifest":
                    break;
                case "file-entry":
                    if ("/" == (a = dt(r[0], !1)).path && a.type !== qa) throw new Error("This OpenDocument is not a spreadsheet");
                    break;
                case "encryption-data":
                case "algorithm":
                case "start-key-generation":
                case "key-derivation":
                    throw new Error("Unsupported ODS Encryption");
                default:
                    if (t && t.WTF) throw r;
            }
        }(et(e, "META-INF/manifest.xml"), t);
        var r = tt(e, "content.xml");
        if (!r) throw new Error("Missing content.xml in ODS / UOF file");
        t = nh(Mt(r), t);
        return Ze(e, "meta.xml") && (t.Props = rn(et(e, "meta.xml"))), t;
    }
    function ih(e, t) {
        return nh(e, t);
    }
    var oh = function() {
        var e = [
            "<office:master-styles>",
            '<style:master-page style:name="mp1" style:page-layout-name="mp1">',
            "<style:header/>",
            '<style:header-left style:display="false"/>',
            "<style:footer/>",
            '<style:footer-left style:display="false"/>',
            "</style:master-page>",
            "</office:master-styles>"
        ].join(""), t = "<office:document-styles " + Xt({
            "xmlns:office": "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
            "xmlns:table": "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
            "xmlns:style": "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
            "xmlns:text": "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
            "xmlns:draw": "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
            "xmlns:fo": "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
            "xmlns:xlink": "http://www.w3.org/1999/xlink",
            "xmlns:dc": "http://purl.org/dc/elements/1.1/",
            "xmlns:number": "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
            "xmlns:svg": "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
            "xmlns:of": "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
            "office:version": "1.2"
        }) + ">" + e + "</office:document-styles>";
        return function() {
            return ot + t;
        };
    }(), ch = function() {
        function i(e, t, r) {
            var a = [];
            a.push('      <table:table table:name="' + kt(t.SheetNames[r]) + '" table:style-name="ta1">\n');
            var n = 0, s = 0, i = Jr(e["!ref"] || "A1"), o = e["!merges"] || [], c = 0, l = Array.isArray(e);
            if (e["!cols"]) for(s = 0; s <= i.e.c; ++s)a.push("        <table:table-column" + (e["!cols"][s] ? ' table:style-name="co' + e["!cols"][s].ods + '"' : "") + "></table:table-column>\n");
            for(var f = "", h = e["!rows"] || [], n = 0; n < i.s.r; ++n)f = h[n] ? ' table:style-name="ro' + h[n].ods + '"' : "", a.push("        <table:table-row" + f + "></table:table-row>\n");
            for(; n <= i.e.r; ++n){
                for(f = h[n] ? ' table:style-name="ro' + h[n].ods + '"' : "", a.push("        <table:table-row" + f + ">\n"), s = 0; s < i.s.c; ++s)a.push(v);
                for(; s <= i.e.c; ++s){
                    for(var u = !1, d = {}, p = "", c = 0; c != o.length; ++c)if (!(o[c].s.c > s || o[c].s.r > n || o[c].e.c < s || o[c].e.r < n)) {
                        o[c].s.c == s && o[c].s.r == n || (u = !0), d["table:number-columns-spanned"] = o[c].e.c - o[c].s.c + 1, d["table:number-rows-spanned"] = o[c].e.r - o[c].s.r + 1;
                        break;
                    }
                    if (u) a.push("          <table:covered-table-cell/>\n");
                    else {
                        var m = Kr({
                            r: n,
                            c: s
                        }), g = l ? (e[n] || [])[s] : e[m];
                        if (g && g.f && (d["table:formula"] = kt(("of:=" + g.f.replace(lc, "$1[.$2$3$4$5]").replace(/\]:\[/g, ":")).replace(/;/g, "|").replace(/,/g, ";")), g.F && g.F.slice(0, m.length) == m && (b = Jr(g.F), d["table:number-matrix-columns-spanned"] = b.e.c - b.s.c + 1, d["table:number-matrix-rows-spanned"] = b.e.r - b.s.r + 1)), g) {
                            switch(g.t){
                                case "b":
                                    p = g.v ? "TRUE" : "FALSE", d["office:value-type"] = "boolean", d["office:boolean-value"] = g.v ? "true" : "false";
                                    break;
                                case "n":
                                    p = g.w || String(g.v || 0), d["office:value-type"] = "float", d["office:value"] = g.v || 0;
                                    break;
                                case "s":
                                case "str":
                                    p = null == g.v ? "" : g.v, d["office:value-type"] = "string";
                                    break;
                                case "d":
                                    p = g.w || He(g.v).toISOString(), d["office:value-type"] = "date", d["office:date-value"] = He(g.v).toISOString(), d["table:style-name"] = "ce1";
                                    break;
                                default:
                                    a.push(v);
                                    continue;
                            }
                            var b, m = kt(p).replace(/  +/g, function(e) {
                                return '<text:s text:c="' + e.length + '"/>';
                            }).replace(/\t/g, "<text:tab/>").replace(/\n/g, "</text:p><text:p>").replace(/^ /, "<text:s/>").replace(/ $/, "<text:s/>");
                            g.l && g.l.Target && (m = Yt("text:a", m, {
                                "xlink:href": (b = "#" != (b = "#" == (b = g.l.Target).charAt(0) ? "#" + b.slice(1).replace(/\./, "!") : b).charAt(0) && !b.match(/^\w+:/) ? "../" + b : b).replace(/&/g, "&amp;")
                            })), a.push("          " + Yt("table:table-cell", Yt("text:p", m, {}), d) + "\n");
                        } else a.push(v);
                    }
                }
                a.push("        </table:table-row>\n");
            }
            return a.push("      </table:table>\n"), a.join("");
        }
        var v = "          <table:table-cell />\n";
        return function(e, t) {
            var r = [
                ot
            ], a = Xt({
                "xmlns:office": "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
                "xmlns:table": "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
                "xmlns:style": "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
                "xmlns:text": "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
                "xmlns:draw": "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
                "xmlns:fo": "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
                "xmlns:xlink": "http://www.w3.org/1999/xlink",
                "xmlns:dc": "http://purl.org/dc/elements/1.1/",
                "xmlns:meta": "urn:oasis:names:tc:opendocument:xmlns:meta:1.0",
                "xmlns:number": "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
                "xmlns:presentation": "urn:oasis:names:tc:opendocument:xmlns:presentation:1.0",
                "xmlns:svg": "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
                "xmlns:chart": "urn:oasis:names:tc:opendocument:xmlns:chart:1.0",
                "xmlns:dr3d": "urn:oasis:names:tc:opendocument:xmlns:dr3d:1.0",
                "xmlns:math": "http://www.w3.org/1998/Math/MathML",
                "xmlns:form": "urn:oasis:names:tc:opendocument:xmlns:form:1.0",
                "xmlns:script": "urn:oasis:names:tc:opendocument:xmlns:script:1.0",
                "xmlns:ooo": "http://openoffice.org/2004/office",
                "xmlns:ooow": "http://openoffice.org/2004/writer",
                "xmlns:oooc": "http://openoffice.org/2004/calc",
                "xmlns:dom": "http://www.w3.org/2001/xml-events",
                "xmlns:xforms": "http://www.w3.org/2002/xforms",
                "xmlns:xsd": "http://www.w3.org/2001/XMLSchema",
                "xmlns:xsi": "http://www.w3.org/2001/XMLSchema-instance",
                "xmlns:sheet": "urn:oasis:names:tc:opendocument:sh33tjs:1.0",
                "xmlns:rpt": "http://openoffice.org/2005/report",
                "xmlns:of": "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
                "xmlns:xhtml": "http://www.w3.org/1999/xhtml",
                "xmlns:grddl": "http://www.w3.org/2003/g/data-view#",
                "xmlns:tableooo": "http://openoffice.org/2009/table",
                "xmlns:drawooo": "http://openoffice.org/2010/draw",
                "xmlns:calcext": "urn:org:documentfoundation:names:experimental:calc:xmlns:calcext:1.0",
                "xmlns:loext": "urn:org:documentfoundation:names:experimental:office:xmlns:loext:1.0",
                "xmlns:field": "urn:openoffice:names:experimental:ooo-ms-interop:xmlns:field:1.0",
                "xmlns:formx": "urn:openoffice:names:experimental:ooxml-odf-interop:xmlns:form:1.0",
                "xmlns:css3t": "http://www.w3.org/TR/css3-text/",
                "office:version": "1.2"
            }), n = Xt({
                "xmlns:config": "urn:oasis:names:tc:opendocument:xmlns:config:1.0",
                "office:mimetype": "application/vnd.oasis.opendocument.spreadsheet"
            });
            "fods" == t.bookType ? (r.push("<office:document" + a + n + ">\n"), r.push(Qa().replace(/office:document-meta/g, "office:meta"))) : r.push("<office:document-content" + a + ">\n"), function(a, t) {
                a.push(" <office:automatic-styles>\n"), a.push('  <number:date-style style:name="N37" number:automatic-order="true">\n'), a.push('   <number:month number:style="long"/>\n'), a.push("   <number:text>/</number:text>\n"), a.push('   <number:day number:style="long"/>\n'), a.push("   <number:text>/</number:text>\n"), a.push("   <number:year/>\n"), a.push("  </number:date-style>\n");
                var n = 0;
                t.SheetNames.map(function(e) {
                    return t.Sheets[e];
                }).forEach(function(e) {
                    if (e && e["!cols"]) {
                        for(var t = 0; t < e["!cols"].length; ++t)if (e["!cols"][t]) {
                            var r = e["!cols"][t];
                            if (null == r.width && null == r.wpx && null == r.wch) continue;
                            fo(r), r.ods = n;
                            r = e["!cols"][t].wpx + "px";
                            a.push('  <style:style style:name="co' + n + '" style:family="table-column">\n'), a.push('   <style:table-column-properties fo:break-before="auto" style:column-width="' + r + '"/>\n'), a.push("  </style:style>\n"), ++n;
                        }
                    }
                });
                var s = 0;
                t.SheetNames.map(function(e) {
                    return t.Sheets[e];
                }).forEach(function(e) {
                    if (e && e["!rows"]) for(var t, r = 0; r < e["!rows"].length; ++r)e["!rows"][r] && (e["!rows"][r].ods = s, t = e["!rows"][r].hpx + "px", a.push('  <style:style style:name="ro' + s + '" style:family="table-row">\n'), a.push('   <style:table-row-properties fo:break-before="auto" style:row-height="' + t + '"/>\n'), a.push("  </style:style>\n"), ++s);
                }), a.push('  <style:style style:name="ta1" style:family="table" style:master-page-name="mp1">\n'), a.push('   <style:table-properties table:display="true" style:writing-mode="lr-tb"/>\n'), a.push("  </style:style>\n"), a.push('  <style:style style:name="ce1" style:family="table-cell" style:parent-style-name="Default" style:data-style-name="N37"/>\n'), a.push(" </office:automatic-styles>\n");
            }(r, e), r.push("  <office:body>\n"), r.push("    <office:spreadsheet>\n");
            for(var s = 0; s != e.SheetNames.length; ++s)r.push(i(e.Sheets[e.SheetNames[s]], e, s));
            return r.push("    </office:spreadsheet>\n"), r.push("  </office:body>\n"), "fods" == t.bookType ? r.push("</office:document>") : r.push("</office:document-content>"), r.join("");
        };
    }();
    function lh(e, t) {
        if ("fods" == t.bookType) return ch(e, t);
        var r = nt(), a = [], n = [];
        return at(r, "mimetype", "application/vnd.oasis.opendocument.spreadsheet"), at(r, "content.xml", ch(e, t)), a.push([
            "content.xml",
            "text/xml"
        ]), n.push([
            "content.xml",
            "ContentFile"
        ]), at(r, "styles.xml", oh(e, t)), a.push([
            "styles.xml",
            "text/xml"
        ]), n.push([
            "styles.xml",
            "StylesFile"
        ]), at(r, "meta.xml", ot + Qa()), a.push([
            "meta.xml",
            "text/xml"
        ]), n.push([
            "meta.xml",
            "MetadataFile"
        ]), at(r, "manifest.rdf", function(e) {
            var t = [
                ot
            ];
            t.push('<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">\n');
            for(var r = 0; r != e.length; ++r)t.push(Za(e[r][0], e[r][1])), t.push([
                '  <rdf:Description rdf:about="">\n',
                '    <ns0:hasPart xmlns:ns0="http://docs.oasis-open.org/ns/office/1.2/meta/pkg#" rdf:resource="' + e[r][0] + '"/>\n',
                "  </rdf:Description>\n"
            ].join(""));
            return t.push(Za("", "Document", "pkg")), t.push("</rdf:RDF>"), t.join("");
        }(n)), a.push([
            "manifest.rdf",
            "application/rdf+xml"
        ]), at(r, "META-INF/manifest.xml", function(e) {
            var t = [
                ot
            ];
            t.push('<manifest:manifest xmlns:manifest="urn:oasis:names:tc:opendocument:xmlns:manifest:1.0" manifest:version="1.2">\n'), t.push('  <manifest:file-entry manifest:full-path="/" manifest:version="1.2" manifest:media-type="application/vnd.oasis.opendocument.spreadsheet"/>\n');
            for(var r = 0; r < e.length; ++r)t.push('  <manifest:file-entry manifest:full-path="' + e[r][0] + '" manifest:media-type="' + e[r][1] + '"/>\n');
            return t.push("</manifest:manifest>"), t.join("");
        }(a)), r;
    }
    function fh(e) {
        return new DataView(e.buffer, e.byteOffset, e.byteLength);
    }
    function hh(e) {
        return "undefined" != typeof TextDecoder ? (new TextDecoder).decode(e) : Mt(i(e));
    }
    function uh(e) {
        return "undefined" != typeof TextEncoder ? (new TextEncoder).encode(e) : he(Ut(e));
    }
    function dh(e) {
        var t = e.reduce(function(e, t) {
            return e + t.length;
        }, 0), r = new Uint8Array(t), a = 0;
        return e.forEach(function(e) {
            r.set(e, a), a += e.length;
        }), r;
    }
    function ph(e) {
        return 16843009 * ((e = (858993459 & (e -= e >> 1 & 1431655765)) + (e >> 2 & 858993459)) + (e >> 4) & 252645135) >>> 24;
    }
    function mh(e, t) {
        var r = t ? t[0] : 0, a = 127 & e[r];
        return 128 <= e[r++] && (a |= (127 & e[r]) << 7, e[r++] < 128 || (a |= (127 & e[r]) << 14, e[r++] < 128 || (a |= (127 & e[r]) << 21, e[r++] < 128 || (a += (127 & e[r]) * Math.pow(2, 28), ++r, e[r++] < 128 || (a += (127 & e[r]) * Math.pow(2, 35), ++r, e[r++] < 128 || (a += (127 & e[r]) * Math.pow(2, 42), ++r, e[r++])))))), t && (t[0] = r), a;
    }
    function gh(e) {
        var t = new Uint8Array(7);
        t[0] = 127 & e;
        var r = 1;
        return 127 < e && (t[r - 1] |= 128, t[r] = e >> 7 & 127, ++r, e <= 16383 || (t[r - 1] |= 128, t[r] = e >> 14 & 127, ++r, e <= 2097151 || (t[r - 1] |= 128, t[r] = e >> 21 & 127, ++r, e <= 268435455 || (t[r - 1] |= 128, t[r] = e / 256 >>> 21 & 127, ++r, e <= 34359738367 || (t[r - 1] |= 128, t[r] = e / 65536 >>> 21 & 127, ++r, e <= 4398046511103 || (t[r - 1] |= 128, t[r] = e / 16777216 >>> 21 & 127, ++r)))))), t.slice(0, r);
    }
    function bh(e) {
        var t = 0, r = 127 & e[0];
        return 128 <= e[t++] && (r |= (127 & e[1]) << 7, e[t++] < 128 || (r |= (127 & e[2]) << 14, e[t++] < 128 || (r |= (127 & e[3]) << 21, e[+t] < 128 || (r |= (127 & e[4]) << 28)))), r;
    }
    function vh(e) {
        for(var t = [], r = [
            0
        ]; r[0] < e.length;){
            var a, n = r[0], s = mh(e, r), i = 7 & s, o = 0;
            if (0 == (s = Math.floor(s / 8))) break;
            switch(i){
                case 0:
                    for(var c = r[0]; 128 <= e[r[0]++];);
                    a = e.slice(c, r[0]);
                    break;
                case 5:
                    o = 4, a = e.slice(r[0], r[0] + o), r[0] += o;
                    break;
                case 1:
                    o = 8, a = e.slice(r[0], r[0] + o), r[0] += o;
                    break;
                case 2:
                    o = mh(e, r), a = e.slice(r[0], r[0] + o), r[0] += o;
                    break;
                case 3:
                case 4:
                default:
                    throw new Error("PB Type ".concat(i, " for Field ").concat(s, " at offset ").concat(n));
            }
            var l = {
                data: a,
                type: i
            };
            null == t[s] ? t[s] = [
                l
            ] : t[s].push(l);
        }
        return t;
    }
    function wh(e) {
        var r = [];
        return e.forEach(function(e, t) {
            0 != t && e.forEach(function(e) {
                e.data && (r.push(gh(8 * t + e.type)), 2 == e.type && r.push(gh(e.data.length)), r.push(e.data));
            });
        }), dh(r);
    }
    function Th(e, t) {
        return (null == e ? void 0 : e.map(function(e) {
            return t(e.data);
        })) || [];
    }
    function Eh(r) {
        for(var e = [], a = [
            0
        ]; a[0] < r.length;){
            var t = mh(r, a), n = vh(r.slice(a[0], a[0] + t));
            a[0] += t;
            var s = {
                id: bh(n[1][0].data),
                messages: []
            };
            n[2].forEach(function(e) {
                var t = vh(e.data), e = bh(t[3][0].data);
                s.messages.push({
                    meta: t,
                    data: r.slice(a[0], a[0] + e)
                }), a[0] += e;
            }), null != (t = n[3]) && t[0] && (s.merge = 0 < bh(n[3][0].data) >>> 0), e.push(s);
        }
        return e;
    }
    function kh(e) {
        var a = [];
        return e.forEach(function(e) {
            var t = [
                [],
                [
                    {
                        data: gh(e.id),
                        type: 0
                    }
                ],
                []
            ];
            null != e.merge && (t[3] = [
                {
                    data: gh(+!!e.merge),
                    type: 0
                }
            ]);
            var r = [];
            e.messages.forEach(function(e) {
                r.push(e.data), e.meta[3] = [
                    {
                        type: 0,
                        data: gh(e.data.length)
                    }
                ], t[2].push({
                    data: wh(e.meta),
                    type: 2
                });
            });
            e = wh(t);
            a.push(gh(e.length)), a.push(e), r.forEach(function(e) {
                return a.push(e);
            });
        }), dh(a);
    }
    function yh(e) {
        for(var t = [], r = 0; r < e.length;){
            var a = e[r++], n = e[r] | e[r + 1] << 8 | e[r + 2] << 16;
            r += 3, t.push(function(e, t) {
                if (0 != e) throw new Error("Unexpected Snappy chunk type ".concat(e));
                for(var r = [
                    0
                ], a = mh(t, r), n = []; r[0] < t.length;){
                    var s = 3 & t[r[0]];
                    if (0 != s) {
                        var i = 0, o = 0;
                        if (1 == s ? (o = 4 + (t[r[0]] >> 2 & 7), i = (224 & t[r[0]++]) << 3, i |= t[r[0]++]) : (o = 1 + (t[r[0]++] >> 2), 2 == s ? (i = t[r[0]] | t[r[0] + 1] << 8, r[0] += 2) : (i = (t[r[0]] | t[r[0] + 1] << 8 | t[r[0] + 2] << 16 | t[r[0] + 3] << 24) >>> 0, r[0] += 4)), n = [
                            dh(n)
                        ], 0 == i) throw new Error("Invalid offset 0");
                        if (i > n[0].length) throw new Error("Invalid offset beyond length");
                        if (i <= o) for(n.push(n[0].slice(-i)), o -= i; o >= n[n.length - 1].length;)n.push(n[n.length - 1]), o -= n[n.length - 1].length;
                        n.push(n[0].slice(-i, -i + o));
                    } else {
                        s = t[r[0]++] >> 2;
                        s < 60 ? ++s : (i = s - 59, s = t[r[0]], 1 < i && (s |= t[r[0] + 1] << 8), 2 < i && (s |= t[r[0] + 2] << 16), 3 < i && (s |= t[r[0] + 3] << 24), s >>>= 0, s++, r[0] += i), n.push(t.slice(r[0], r[0] + s)), r[0] += s;
                    }
                }
                if ((e = dh(n)).length != a) throw new Error("Unexpected length: ".concat(e.length, " != ").concat(a));
                return e;
            }(a, e.slice(r, r + n))), r += n;
        }
        if (r !== e.length) throw new Error("data is not a valid framed stream!");
        return dh(t);
    }
    function Sh(e) {
        for(var t = [], r = 0; r < e.length;){
            var a = Math.min(e.length - r, 268435455), n = new Uint8Array(4);
            t.push(n);
            var s = gh(a), i = s.length;
            t.push(s), a <= 60 ? (i++, t.push(new Uint8Array([
                a - 1 << 2
            ]))) : a <= 256 ? (i += 2, t.push(new Uint8Array([
                240,
                a - 1 & 255
            ]))) : a <= 65536 ? (i += 3, t.push(new Uint8Array([
                244,
                a - 1 & 255,
                a - 1 >> 8 & 255
            ]))) : a <= 16777216 ? (i += 4, t.push(new Uint8Array([
                248,
                a - 1 & 255,
                a - 1 >> 8 & 255,
                a - 1 >> 16 & 255
            ]))) : a <= 4294967296 && (i += 5, t.push(new Uint8Array([
                252,
                a - 1 & 255,
                a - 1 >> 8 & 255,
                a - 1 >> 16 & 255,
                a - 1 >>> 24 & 255
            ]))), t.push(e.slice(r, r + a)), i += a, n[0] = 0, n[1] = 255 & i, n[2] = i >> 8 & 255, n[3] = i >> 16 & 255, r += a;
        }
        return dh(t);
    }
    function _h(e, t, r) {
        var a, n = fh(e), s = n.getUint32(8, !0), i = 12, o = -1, c = -1, l = NaN, f = NaN, h = new Date(2001, 0, 1);
        switch(1 & s && (l = function(e, t) {
            for(var r = (127 & e[t + 15]) << 7 | e[t + 14] >> 1, a = 1 & e[t + 14], n = t + 13; t <= n; --n)a = 256 * a + e[n];
            return (128 & e[t + 15] ? -a : a) * Math.pow(10, r - 6176);
        }(e, i), i += 16), 2 & s && (f = n.getFloat64(i, !0), i += 8), 4 & s && (h.setTime(h.getTime() + 1e3 * n.getFloat64(i, !0)), i += 8), 8 & s && (c = n.getUint32(i, !0), i += 4), 16 & s && (o = n.getUint32(i, !0), i += 4), e[1]){
            case 0:
                break;
            case 2:
                a = {
                    t: "n",
                    v: l
                };
                break;
            case 3:
                a = {
                    t: "s",
                    v: t[c]
                };
                break;
            case 5:
                a = {
                    t: "d",
                    v: h
                };
                break;
            case 6:
                a = {
                    t: "b",
                    v: 0 < f
                };
                break;
            case 7:
                a = {
                    t: "n",
                    v: f / 86400
                };
                break;
            case 8:
                a = {
                    t: "e",
                    v: 0
                };
                break;
            case 9:
                if (!(-1 < o)) throw new Error("Unsupported cell type ".concat(e[1], " : ").concat(31 & s, " : ").concat(e.slice(0, 4)));
                a = {
                    t: "s",
                    v: r[o]
                };
                break;
            case 10:
                a = {
                    t: "n",
                    v: l
                };
                break;
            default:
                throw new Error("Unsupported cell type ".concat(e[1], " : ").concat(31 & s, " : ").concat(e.slice(0, 4)));
        }
        return a;
    }
    function xh(e, t) {
        var r = new Uint8Array(32), a = fh(r), n = 12, s = 0;
        switch(r[0] = 5, e.t){
            case "n":
                r[1] = 2, function(e, t, r) {
                    var a = Math.floor(0 == r ? 0 : Math.LOG10E * Math.log(Math.abs(r))) + 6176 - 16, n = r / Math.pow(10, a - 6176);
                    e[t + 15] |= a >> 7, e[t + 14] |= (127 & a) << 1;
                    for(var s = 0; 1 <= n; ++s, n /= 256)e[t + s] = 255 & n;
                    e[t + 15] |= 0 <= r ? 0 : 128;
                }(r, n, e.v), s |= 1, n += 16;
                break;
            case "b":
                r[1] = 6, a.setFloat64(n, e.v ? 1 : 0, !0), s |= 2, n += 8;
                break;
            case "s":
                if (-1 == t.indexOf(e.v)) throw new Error("Value ".concat(e.v, " missing from SST!"));
                r[1] = 3, a.setUint32(n, t.indexOf(e.v), !0), s |= 8, n += 4;
                break;
            default:
                throw "unsupported cell type " + e.t;
        }
        return a.setUint32(8, s, !0), r.slice(0, n);
    }
    function Ah(e, t) {
        var r = new Uint8Array(32), a = fh(r), n = 12, s = 0;
        switch(r[0] = 3, e.t){
            case "n":
                r[2] = 2, a.setFloat64(n, e.v, !0), s |= 32, n += 8;
                break;
            case "b":
                r[2] = 6, a.setFloat64(n, e.v ? 1 : 0, !0), s |= 32, n += 8;
                break;
            case "s":
                if (-1 == t.indexOf(e.v)) throw new Error("Value ".concat(e.v, " missing from SST!"));
                r[2] = 3, a.setUint32(n, t.indexOf(e.v), !0), s |= 16, n += 4;
                break;
            default:
                throw "unsupported cell type " + e.t;
        }
        return a.setUint32(4, s, !0), r.slice(0, n);
    }
    function Ch(e, t, r) {
        switch(e[0]){
            case 0:
            case 1:
            case 2:
            case 3:
                return function(e, t, r, a) {
                    var n, s = fh(e), i = s.getUint32(4, !0), o = (1 < a ? 12 : 8) + 4 * ph(i & (1 < a ? 3470 : 398)), c = -1, l = -1, f = NaN, h = new Date(2001, 0, 1);
                    switch(512 & i && (c = s.getUint32(o, !0), o += 4), o += 4 * ph(i & (1 < a ? 12288 : 4096)), 16 & i && (l = s.getUint32(o, !0), o += 4), 32 & i && (f = s.getFloat64(o, !0), o += 8), 64 & i && (h.setTime(h.getTime() + 1e3 * s.getFloat64(o, !0)), o += 8), e[2]){
                        case 0:
                            break;
                        case 2:
                            n = {
                                t: "n",
                                v: f
                            };
                            break;
                        case 3:
                            n = {
                                t: "s",
                                v: t[l]
                            };
                            break;
                        case 5:
                            n = {
                                t: "d",
                                v: h
                            };
                            break;
                        case 6:
                            n = {
                                t: "b",
                                v: 0 < f
                            };
                            break;
                        case 7:
                            n = {
                                t: "n",
                                v: f / 86400
                            };
                            break;
                        case 8:
                            n = {
                                t: "e",
                                v: 0
                            };
                            break;
                        case 9:
                            if (-1 < c) n = {
                                t: "s",
                                v: r[c]
                            };
                            else if (-1 < l) n = {
                                t: "s",
                                v: t[l]
                            };
                            else {
                                if (isNaN(f)) throw new Error("Unsupported cell type ".concat(e.slice(0, 4)));
                                n = {
                                    t: "n",
                                    v: f
                                };
                            }
                            break;
                        default:
                            throw new Error("Unsupported cell type ".concat(e.slice(0, 4)));
                    }
                    return n;
                }(e, t, r, e[0]);
            case 5:
                return _h(e, t, r);
            default:
                throw new Error("Unsupported payload version ".concat(e[0]));
        }
    }
    function Rh(e) {
        return mh(vh(e)[1][0].data);
    }
    function Oh(s, e) {
        var e = vh(e.data), i = bh(e[1][0].data), e = e[3], o = [];
        return (e || []).forEach(function(e) {
            var t = vh(e.data), r = bh(t[1][0].data) >>> 0;
            switch(i){
                case 1:
                    o[r] = hh(t[3][0].data);
                    break;
                case 8:
                    var a = vh(s[Rh(t[9][0].data)][0].data), n = s[Rh(a[1][0].data)][0], a = bh(n.meta[1][0].data);
                    if (2001 != a) throw new Error("2000 unexpected reference to ".concat(a));
                    n = vh(n.data);
                    o[r] = n[3].map(function(e) {
                        return hh(e.data);
                    }).join("");
            }
        }), o;
    }
    function Ih(e, t) {
        var r = vh(t.data), a = null != (t = null == r ? void 0 : r[7]) && t[0] ? 0 < bh(r[7][0].data) >>> 0 ? 1 : 0 : -1, t = Th(r[5], function(e) {
            return function(e, t) {
                var r, a, n, s = vh(e), i = bh(s[1][0].data) >>> 0, o = bh(s[2][0].data) >>> 0, c = (null == (e = null == (c = s[8]) ? void 0 : c[0]) ? void 0 : e.data) && 0 < bh(s[8][0].data) || !1;
                if (null != (e = null == (e = s[7]) ? void 0 : e[0]) && e.data && 0 != t) a = null == (r = null == (r = s[7]) ? void 0 : r[0]) ? void 0 : r.data, n = null == (r = null == (r = s[6]) ? void 0 : r[0]) ? void 0 : r.data;
                else {
                    if (null == (r = null == (r = s[4]) ? void 0 : r[0]) || !r.data || 1 == t) throw "NUMBERS Tile missing ".concat(t, " cell storage");
                    a = null == (t = null == (t = s[4]) ? void 0 : t[0]) ? void 0 : t.data, n = null == (s = null == (s = s[3]) ? void 0 : s[0]) ? void 0 : s.data;
                }
                for(var l = c ? 4 : 1, f = fh(a), h = [], u = 0; u < a.length / 2; ++u){
                    var d = f.getUint16(2 * u, !0);
                    d < 65535 && h.push([
                        u,
                        d
                    ]);
                }
                if (h.length != o) throw "Expected ".concat(o, " cells, found ").concat(h.length);
                for(var p = [], u = 0; u < h.length - 1; ++u)p[h[u][0]] = n.subarray(h[u][1] * l, h[u + 1][1] * l);
                return 1 <= h.length && (p[h[h.length - 1][0]] = n.subarray(h[h.length - 1][1] * l)), {
                    R: i,
                    cells: p
                };
            }(e, a);
        });
        return {
            nrows: bh(r[4][0].data) >>> 0,
            data: t.reduce(function(r, a) {
                return r[a.R] || (r[a.R] = []), a.cells.forEach(function(e, t) {
                    if (r[a.R][t]) throw new Error("Duplicate cell r=".concat(a.R, " c=").concat(t));
                    r[a.R][t] = e;
                }), r;
            }, [])
        };
    }
    function Nh(e, t) {
        var r = {
            "!ref": "A1"
        }, a = e[Rh(vh(t.data)[2][0].data)], t = bh(a[0].meta[1][0].data);
        if (6001 != t) throw new Error("6000 unexpected reference to ".concat(t));
        return function(r, e, a) {
            var t = vh(e.data);
            if ((e = {
                s: {
                    r: 0,
                    c: 0
                },
                e: {
                    r: 0,
                    c: 0
                }
            }).e.r = (bh(t[6][0].data) >>> 0) - 1, e.e.r < 0) throw new Error("Invalid row varint ".concat(t[6][0].data));
            if (e.e.c = (bh(t[7][0].data) >>> 0) - 1, e.e.c < 0) throw new Error("Invalid col varint ".concat(t[7][0].data));
            a["!ref"] = qr(e);
            var e = vh(t[4][0].data), n = Oh(r, r[Rh(e[4][0].data)][0]), s = null != (t = e[17]) && t[0] ? Oh(r, r[Rh(e[17][0].data)][0]) : [], t = vh(e[3][0].data), i = 0;
            if (t[1].forEach(function(e) {
                var t = vh(e.data), e = r[Rh(t[2][0].data)][0], t = bh(e.meta[1][0].data);
                if (6002 != t) throw new Error("6001 unexpected reference to ".concat(t));
                e = Ih(0, e);
                e.data.forEach(function(e, r) {
                    e.forEach(function(e, t) {
                        t = Kr({
                            r: i + r,
                            c: t
                        }), e = Ch(e, n, s);
                        e && (a[t] = e);
                    });
                }), i += e.nrows;
            }), null != (t = e[13]) && t[0]) {
                t = r[Rh(e[13][0].data)][0], e = bh(t.meta[1][0].data);
                if (6144 != e) throw new Error("Expected merge type 6144, found ".concat(e));
                a["!merges"] = null == (t = vh(t.data)) ? void 0 : t[1].map(function(e) {
                    var t = vh(e.data), e = fh(vh(t[1][0].data)[1][0].data), t = fh(vh(t[2][0].data)[1][0].data);
                    return {
                        s: {
                            r: e.getUint16(0, !0),
                            c: e.getUint16(2, !0)
                        },
                        e: {
                            r: e.getUint16(0, !0) + t.getUint16(0, !0) - 1,
                            c: e.getUint16(2, !0) + t.getUint16(2, !0) - 1
                        }
                    };
                });
            }
        }(e, a[0], r), r;
    }
    function Fh(s, e) {
        var i = du(), t = vh(e.data);
        if (null != (e = t[2]) && e[0]) throw new Error("Keynote presentations are not supported");
        if (Th(t[1], Rh).forEach(function(e) {
            s[e].forEach(function(e) {
                var r, t, a, n;
                2 == bh(e.meta[1][0].data) && (t = s, e = vh((a = e).data), n = {
                    name: null != (a = e[1]) && a[0] ? hh(e[1][0].data) : "",
                    sheets: []
                }, Th(e[2], Rh).forEach(function(e) {
                    t[e].forEach(function(e) {
                        6e3 == bh(e.meta[1][0].data) && n.sheets.push(Nh(t, e));
                    });
                }), (r = n).sheets.forEach(function(e, t) {
                    pu(i, e, 0 == t ? r.name : r.name + "_" + t, !0);
                }));
            });
        }), 0 == i.SheetNames.length) throw new Error("Empty NUMBERS file");
        return i;
    }
    function Dh(e) {
        var a = {}, n = [];
        if (e.FullPaths.forEach(function(e) {
            if (e.match(/\.iwpv2/)) throw new Error("Unsupported password protection");
        }), e.FileIndex.forEach(function(t) {
            if (t.name.match(/\.iwa$/)) {
                var e, r;
                try {
                    e = yh(t.content);
                } catch (e) {
                    return console.log("?? " + t.content.length + " " + (e.message || e));
                }
                try {
                    r = Eh(e);
                } catch (e) {
                    return console.log("## " + (e.message || e));
                }
                r.forEach(function(e) {
                    a[e.id] = e.messages, n.push(e.id);
                });
            }
        }), !n.length) throw new Error("File has no messages");
        if (null != (e = null == (e = null == (e = null == (e = null == a ? void 0 : a[1]) ? void 0 : e[0]) ? void 0 : e.meta) ? void 0 : e[1]) && e[0].data && 1e4 == bh(a[1][0].meta[1][0].data)) throw new Error("Pages documents are not supported");
        var t = (null == (e = null == (e = null == (e = null == (e = null == a ? void 0 : a[1]) ? void 0 : e[0]) ? void 0 : e.meta) ? void 0 : e[1]) ? void 0 : e[0].data) && 1 == bh(a[1][0].meta[1][0].data) && a[1][0];
        if (t || n.forEach(function(e) {
            a[e].forEach(function(e) {
                if (1 == bh(e.meta[1][0].data) >>> 0) {
                    if (t) throw new Error("Document has multiple roots");
                    t = e;
                }
            });
        }), !t) throw new Error("Cannot find Document root");
        return Fh(a, t);
    }
    function Ph(e, t) {
        if (!t || !t.numbers) throw new Error("Must pass a `numbers` option -- check the README");
        var r = e.Sheets[e.SheetNames[0]];
        1 < e.SheetNames.length && console.error("The Numbers writer currently writes only the first table");
        var f = Jr(r["!ref"]);
        f.s.r = f.s.c = 0;
        var a = !1;
        9 < f.e.c && (a = !0, f.e.c = 9), 49 < f.e.r && (a = !0, f.e.r = 49), a && console.error("The Numbers writer is currently limited to ".concat(qr(f)));
        var h = iu(r, {
            range: f,
            header: 1
        }), u = [
            "~Sh33tJ5~"
        ];
        h.forEach(function(e) {
            return e.forEach(function(e) {
                "string" == typeof e && u.push(e);
            });
        });
        var d = {}, n = [], p = xe.read(t.numbers, {
            type: "base64"
        });
        p.FileIndex.map(function(e, t) {
            return [
                e,
                p.FullPaths[t]
            ];
        }).forEach(function(e) {
            var t = e[0], r = e[1];
            2 == t.type && t.name.match(/\.iwa/) && Eh(yh(t.content)).forEach(function(e) {
                n.push(e.id), d[e.id] = {
                    deps: [],
                    location: r,
                    type: bh(e.messages[0].meta[1][0].data)
                };
            });
        }), n.sort(function(e, t) {
            return e - t;
        });
        var s = n.filter(function(e) {
            return 1 < e;
        }).map(function(e) {
            return [
                e,
                gh(e)
            ];
        });
        p.FileIndex.map(function(e, t) {
            return [
                e,
                p.FullPaths[t]
            ];
        }).forEach(function(e) {
            var t = e[0];
            e[1];
            t.name.match(/\.iwa/) && Eh(yh(t.content)).forEach(function(r) {
                r.messages.forEach(function(e) {
                    s.forEach(function(t) {
                        r.messages.some(function(e) {
                            return 11006 != bh(e.meta[1][0].data) && function(e, t) {
                                e: for(var r = 0; r <= e.length - t.length; ++r){
                                    for(var a = 0; a < t.length; ++a)if (e[r + a] != t[a]) continue e;
                                    return !0;
                                }
                                return !1;
                            }(e.data, t[1]);
                        }) && d[t[0]].deps.push(r.id);
                    });
                });
            });
        });
        for(var i, o = xe.find(p, d[1].location), c = Eh(yh(o.content)), l = 0; l < c.length; ++l){
            var m = c[l];
            1 == m.id && (i = m);
        }
        for(var g = Rh(vh(i.messages[0].data)[1][0].data), c = Eh(yh((o = xe.find(p, d[g].location)).content)), l = 0; l < c.length; ++l)(m = c[l]).id == g && (i = m);
        var b = vh(i.messages[0].data);
        for(b[1] = [
            {
                type: 2,
                data: uh(e.SheetNames[0])
            }
        ], i.messages[0].data = wh(b), o.content = Sh(kh(c)), o.size = o.content.length, g = Rh(b[2][0].data), c = Eh(yh((o = xe.find(p, d[g].location)).content)), l = 0; l < c.length; ++l)(m = c[l]).id == g && (i = m);
        for(g = Rh(vh(i.messages[0].data)[2][0].data), c = Eh(yh((o = xe.find(p, d[g].location)).content)), l = 0; l < c.length; ++l)(m = c[l]).id == g && (i = m);
        a = vh(i.messages[0].data);
        a[6][0].data = gh(f.e.r + 1), a[7][0].data = gh(f.e.c + 1);
        for(var v = Rh(a[46][0].data), t = xe.find(p, d[v].location), w = Eh(yh(t.content)), T = 0; T < w.length && w[T].id != v; ++T);
        if (w[T].id != v) throw "Bad ColumnRowUIDMapArchive";
        var E = vh(w[T].messages[0].data);
        E[1] = [], E[2] = [], E[3] = [];
        for(var k = 0; k <= f.e.c; ++k)E[1].push({
            type: 2,
            data: wh([
                [],
                [
                    {
                        type: 0,
                        data: gh(k + 420690)
                    }
                ],
                [
                    {
                        type: 0,
                        data: gh(k + 420690)
                    }
                ]
            ])
        }), E[2].push({
            type: 0,
            data: gh(k)
        }), E[3].push({
            type: 0,
            data: gh(k)
        });
        E[4] = [], E[5] = [], E[6] = [];
        for(var y = 0; y <= f.e.r; ++y)E[4].push({
            type: 2,
            data: wh([
                [],
                [
                    {
                        type: 0,
                        data: gh(y + 726270)
                    }
                ],
                [
                    {
                        type: 0,
                        data: gh(y + 726270)
                    }
                ]
            ])
        }), E[5].push({
            type: 0,
            data: gh(y)
        }), E[6].push({
            type: 0,
            data: gh(y)
        });
        w[T].messages[0].data = wh(E), t.content = Sh(kh(w)), t.size = t.content.length, delete a[46];
        e = vh(a[4][0].data);
        e[7][0].data = gh(f.e.r + 1);
        b = Rh(vh(e[1][0].data)[2][0].data);
        if ((w = Eh(yh((t = xe.find(p, d[b].location)).content)))[0].id != b) throw "Bad HeaderStorageBucket";
        for(var S = vh(w[0].messages[0].data), y = 0; y < h.length; ++y){
            var _ = vh(S[2][0].data);
            _[1][0].data = gh(y), _[4][0].data = gh(h[y].length), S[2][y] = {
                type: S[2][0].type,
                data: wh(_)
            };
        }
        w[0].messages[0].data = wh(S), t.content = Sh(kh(w)), t.size = t.content.length;
        var x, b = Rh(e[2][0].data);
        if ((w = Eh(yh((t = xe.find(p, d[b].location)).content)))[0].id != b) throw "Bad HeaderStorageBucket";
        for(S = vh(w[0].messages[0].data), k = 0; k <= f.e.c; ++k)(_ = vh(S[2][0].data))[1][0].data = gh(k), _[4][0].data = gh(f.e.r + 1), S[2][k] = {
            type: S[2][0].type,
            data: wh(_)
        };
        w[0].messages[0].data = wh(S), t.content = Sh(kh(w)), t.size = t.content.length, r["!merges"] && (O = function(e) {
            for(var t = 927262; t < 2e6; ++t)if (!d[t]) return d[t] = e, t;
            throw new Error("Too many messages");
        }({
            type: 6144,
            deps: [
                g
            ],
            location: d[g].location
        }), x = [
            [],
            []
        ], r["!merges"].forEach(function(e) {
            x[1].push({
                type: 2,
                data: wh([
                    [],
                    [
                        {
                            type: 2,
                            data: wh([
                                [],
                                [
                                    {
                                        type: 5,
                                        data: new Uint8Array(new Uint16Array([
                                            e.s.r,
                                            e.s.c
                                        ]).buffer)
                                    }
                                ]
                            ])
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: wh([
                                [],
                                [
                                    {
                                        type: 5,
                                        data: new Uint8Array(new Uint16Array([
                                            e.e.r - e.s.r + 1,
                                            e.e.c - e.s.c + 1
                                        ]).buffer)
                                    }
                                ]
                            ])
                        }
                    ]
                ])
            });
        }), e[13] = [
            {
                type: 2,
                data: wh([
                    [],
                    [
                        {
                            type: 0,
                            data: gh(O)
                        }
                    ]
                ])
            }
        ], c.push({
            id: O,
            messages: [
                (R = 6144, O = wh(x), {
                    meta: [
                        [],
                        [
                            {
                                type: 0,
                                data: gh(R)
                            }
                        ]
                    ],
                    data: O
                })
            ]
        }));
        var A = Rh(e[4][0].data);
        !function() {
            for(var e, t = xe.find(p, d[A].location), r = Eh(yh(t.content)), a = 0; a < r.length; ++a){
                var n = r[a];
                n.id == A && (e = n);
            }
            var s = vh(e.messages[0].data);
            s[3] = [], u.forEach(function(e, t) {
                s[3].push({
                    type: 2,
                    data: wh([
                        [],
                        [
                            {
                                type: 0,
                                data: gh(t)
                            }
                        ],
                        [
                            {
                                type: 0,
                                data: gh(1)
                            }
                        ],
                        [
                            {
                                type: 2,
                                data: uh(e)
                            }
                        ]
                    ])
                });
            }), e.messages[0].data = wh(s), t.content = Sh(kh(r)), t.size = t.content.length;
        }();
        var C = vh(e[3][0].data), R = C[1][0];
        delete C[2];
        var R, O, O = vh(R.data), I = Rh(O[2][0].data);
        return function() {
            for(var e, t = xe.find(p, d[I].location), r = Eh(yh(t.content)), a = 0; a < r.length; ++a){
                var n = r[a];
                n.id == I && (e = n);
            }
            var s = vh(e.messages[0].data);
            delete s[6], delete C[7];
            var i = new Uint8Array(s[5][0].data);
            s[5] = [];
            for(var o = 0, c = 0; c <= f.e.r; ++c){
                var l = vh(i);
                o += function(e, t, r) {
                    var a, n;
                    if (null == (a = e[6]) || !a[0] || null == (n = e[7]) || !n[0]) throw "Mutation only works on post-BNC storages!";
                    if ((null == (n = null == (n = e[8]) ? void 0 : n[0]) ? void 0 : n.data) && 0 < bh(e[8][0].data) || !1) throw "Math only works with normal offsets";
                    for(var s, i, o = 0, c = fh(e[7][0].data), l = 0, f = [], h = fh(e[4][0].data), u = 0, d = [], p = 0; p < t.length; ++p)if (null != t[p]) {
                        switch(c.setUint16(2 * p, l, !0), h.setUint16(2 * p, u, !0), typeof t[p]){
                            case "string":
                                s = xh({
                                    t: "s",
                                    v: t[p]
                                }, r), i = Ah({
                                    t: "s",
                                    v: t[p]
                                }, r);
                                break;
                            case "number":
                                s = xh({
                                    t: "n",
                                    v: t[p]
                                }, r), i = Ah({
                                    t: "n",
                                    v: t[p]
                                }, r);
                                break;
                            case "boolean":
                                s = xh({
                                    t: "b",
                                    v: t[p]
                                }, r), i = Ah({
                                    t: "b",
                                    v: t[p]
                                }, r);
                                break;
                            default:
                                throw new Error("Unsupported value " + t[p]);
                        }
                        f.push(s), l += s.length, d.push(i), u += i.length, ++o;
                    } else c.setUint16(2 * p, 65535, !0), h.setUint16(2 * p, 65535);
                    for(e[2][0].data = gh(o); p < e[7][0].data.length / 2; ++p)c.setUint16(2 * p, 65535, !0), h.setUint16(2 * p, 65535, !0);
                    return e[6][0].data = dh(f), e[3][0].data = dh(d), o;
                }(l, h[c], u), l[1][0].data = gh(c), s[5].push({
                    data: wh(l),
                    type: 2
                });
            }
            s[1] = [
                {
                    type: 0,
                    data: gh(f.e.c + 1)
                }
            ], s[2] = [
                {
                    type: 0,
                    data: gh(f.e.r + 1)
                }
            ], s[3] = [
                {
                    type: 0,
                    data: gh(o)
                }
            ], s[4] = [
                {
                    type: 0,
                    data: gh(f.e.r + 1)
                }
            ], e.messages[0].data = wh(s), t.content = Sh(kh(r)), t.size = t.content.length;
        }(), R.data = wh(O), e[3][0].data = wh(C), a[4][0].data = wh(e), i.messages[0].data = wh(a), o.content = Sh(kh(c)), o.size = o.content.length, p;
    }
    function Lh(a) {
        return function(e) {
            for(var t = 0; t != a.length; ++t){
                var r = a[t];
                void 0 === e[r[0]] && (e[r[0]] = r[1]), "n" === r[2] && (e[r[0]] = Number(e[r[0]]));
            }
        };
    }
    function Mh(e) {
        Lh([
            [
                "cellNF",
                !1
            ],
            [
                "cellHTML",
                !0
            ],
            [
                "cellFormula",
                !0
            ],
            [
                "cellStyles",
                !1
            ],
            [
                "cellText",
                !0
            ],
            [
                "cellDates",
                !1
            ],
            [
                "sheetStubs",
                !1
            ],
            [
                "sheetRows",
                0,
                "n"
            ],
            [
                "bookDeps",
                !1
            ],
            [
                "bookSheets",
                !1
            ],
            [
                "bookProps",
                !1
            ],
            [
                "bookFiles",
                !1
            ],
            [
                "bookVBA",
                !1
            ],
            [
                "password",
                ""
            ],
            [
                "WTF",
                !1
            ]
        ])(e);
    }
    function Uh(e) {
        Lh([
            [
                "cellDates",
                !1
            ],
            [
                "bookSST",
                !1
            ],
            [
                "bookType",
                "xlsx"
            ],
            [
                "compression",
                !1
            ],
            [
                "WTF",
                !1
            ]
        ])(e);
    }
    function Bh(t, e) {
        if (!t) return 0;
        try {
            t = e.map(function(e) {
                return e.id || (e.id = e.strRelID), [
                    e.name,
                    t["!id"][e.id].Target,
                    (e = t["!id"][e.id].Type, -1 < $a.WS.indexOf(e) ? "sheet" : $a.CS && e == $a.CS ? "chart" : $a.DS && e == $a.DS ? "dialog" : $a.MS && e == $a.MS ? "macro" : e && e.length ? e : "sheet")
                ];
            });
        } catch (e) {
            return null;
        }
        return t && 0 !== t.length ? t : null;
    }
    function Wh(l, f, e, h, t, u, r, a, d, n, s, i) {
        try {
            u[h] = Ya(tt(l, e, !0), f);
            var o = et(l, f);
            switch(a){
                case "sheet":
                    g = nf(o, f, t, d, u[h], n, s, i);
                    break;
                case "chart":
                    if (!(g = sf(o, f, t, d, u[h], n)) || !g["!drawel"]) break;
                    var c = it(g["!drawel"].Target, f), p = Xa(c), m = it((m = tt(l, c, !0), p = Ya(tt(l, p, !0), c), m ? (m = (m.match(/<c:chart [^>]*r:id="([^"]*)"/) || [
                        "",
                        ""
                    ])[1], p["!id"][m].Target) : "??"), c), c = Xa(m), g = Wl(tt(l, m, !0), 0, 0, Ya(tt(l, c, !0), m), 0, g);
                    break;
                case "macro":
                    v = f, u[h], v.slice(-4), g = {
                        "!type": "macro"
                    };
                    break;
                case "dialog":
                    v = f, u[h], v.slice(-4), g = {
                        "!type": "dialog"
                    };
                    break;
                default:
                    throw new Error("Unrecognized sheet type " + a);
            }
            r[h] = g;
            var b = [];
            u && u[h] && Re(u[h]).forEach(function(e) {
                var a, n, s, i, o, c, t = "";
                if (u[h][e].Type == $a.CMNT) {
                    t = it(u[h][e].Target, f);
                    var r = lf(et(l, t, !0), t, d);
                    if (!r || !r.length) return;
                    ec(g, r, !1);
                }
                u[h][e].Type == $a.TCMNT && (t = it(u[h][e].Target, f), b = b.concat((a = et(l, t, !0), n = d, i = (s = [], false), o = {}, c = 0, a.replace(ft, function(e, t) {
                    var r = dt(e);
                    switch(pt(r[0])){
                        case "<?xml":
                        case "<ThreadedComments":
                        case "</ThreadedComments>":
                            break;
                        case "<threadedComment":
                            o = {
                                author: r.personId,
                                guid: r.id,
                                ref: r.ref,
                                T: 1
                            };
                            break;
                        case "</threadedComment>":
                            null != o.t && s.push(o);
                            break;
                        case "<text>":
                        case "<text":
                            c = t + e.length;
                            break;
                        case "</text>":
                            o.t = a.slice(c, t).replace(/\r\n/g, "\n").replace(/\r/g, "\n");
                            break;
                        case "<mentions":
                        case "<mentions>":
                            i = !0;
                            break;
                        case "</mentions>":
                            i = !1;
                            break;
                        case "<extLst":
                        case "<extLst>":
                        case "</extLst>":
                        case "<extLst/>":
                            break;
                        case "<ext":
                            i = !0;
                            break;
                        case "</ext>":
                            i = !1;
                            break;
                        default:
                            if (!i && n.WTF) throw new Error("unrecognized " + r[0] + " in threaded comments");
                    }
                    return e;
                }), s)));
            }), b && b.length && ec(g, b, !0, d.people || []);
        } catch (e) {
            if (d.WTF) throw e;
        }
        var v, m;
    }
    function Hh(e) {
        return "/" == e.charAt(0) ? e.slice(1) : e;
    }
    function zh(r, t) {
        if (Ee(), Mh(t = t || {}), Ze(r, "META-INF/manifest.xml")) return sh(r, t);
        if (Ze(r, "objectdata.xml")) return sh(r, t);
        if (Ze(r, "Index/Document.iwa")) {
            if ("undefined" == typeof Uint8Array) throw new Error("NUMBERS file parsing requires Uint8Array support");
            if (r.FileIndex) return Dh(r);
            var a = xe.utils.cfb_new();
            return rt(r).forEach(function(e) {
                at(a, e, function e(t, r, a) {
                    if (!a) return qe(Qe(t, r));
                    if (!r) return null;
                    try {
                        return e(t, r);
                    } catch (e) {
                        return null;
                    }
                }(r, e));
            }), Dh(a);
        }
        if (!Ze(r, "[Content_Types].xml")) {
            if (Ze(r, "index.xml.gz")) throw new Error("Unsupported NUMBERS 08 file");
            if (Ze(r, "index.xml")) throw new Error("Unsupported NUMBERS 09 file");
            throw new Error("Unsupported ZIP file");
        }
        var e, n, s = rt(r), i = function(e) {
            var r = Ga();
            if (!e || !e.match) return r;
            var a = {};
            if ((e.match(ft) || []).forEach(function(e) {
                var t = dt(e);
                switch(t[0].replace(ht, "<")){
                    case "<?xml":
                        break;
                    case "<Types":
                        r.xmlns = t["xmlns" + (t[0].match(/<(\w+):/) || [
                            "",
                            ""
                        ])[1]];
                        break;
                    case "<Default":
                        a[t.Extension] = t.ContentType;
                        break;
                    case "<Override":
                        void 0 !== r[za[t.ContentType]] && r[za[t.ContentType]].push(t.PartName);
                }
            }), r.xmlns !== Zt.CT) throw new Error("Unknown Namespace: " + r.xmlns);
            return r.calcchain = 0 < r.calcchains.length ? r.calcchains[0] : "", r.sst = 0 < r.strs.length ? r.strs[0] : "", r.style = 0 < r.styles.length ? r.styles[0] : "", r.defaults = a, delete r.calcchains, r;
        }(tt(r, "[Content_Types].xml")), o = !1;
        if (0 === i.workbooks.length && et(r, n = "xl/workbook.xml", !0) && i.workbooks.push(n), 0 === i.workbooks.length) {
            if (!et(r, n = "xl/workbook.bin", !0)) throw new Error("Could not find workbook");
            i.workbooks.push(n), o = !0;
        }
        "bin" == i.workbooks[0].slice(-3) && (o = !0);
        var c = {}, l = {};
        if (!t.bookSheets && !t.bookProps) {
            if (Yc = [], i.sst) try {
                Yc = cf(et(r, Hh(i.sst)), i.sst, t);
            } catch (e) {
                if (t.WTF) throw e;
            }
            t.cellStyles && i.themes.length && (m = tt(r, i.themes[0].replace(/^\//, ""), !0) || "", i.themes[0], c = $o(m, t)), i.style && (l = of(et(r, Hh(i.style)), i.style, c, t));
        }
        i.links.map(function(e) {
            try {
                Ya(tt(r, Xa(Hh(e))), e);
                return hf(et(r, Hh(e)), 0, e, t);
            } catch (e) {}
        });
        var f, h, u, d = af(et(r, Hh(i.workbooks[0])), i.workbooks[0], t), p = {}, m = "";
        i.coreprops.length && ((m = et(r, Hh(i.coreprops[0]), !0)) && (p = rn(m)), 0 !== i.extprops.length && (m = et(r, Hh(i.extprops[0]), !0)) && (g = t, u = {}, h = (h = p) || {}, f = Mt(f = m), sn.forEach(function(e) {
            var t = (f.match(Bt(e[0])) || [])[1];
            switch(e[2]){
                case "string":
                    t && (h[e[1]] = wt(t));
                    break;
                case "bool":
                    h[e[1]] = "true" === t;
                    break;
                case "raw":
                    var r = f.match(new RegExp("<" + e[0] + "[^>]*>([\\s\\S]*?)</" + e[0] + ">"));
                    r && 0 < r.length && (u[e[1]] = r[1]);
            }
        }), u.HeadingPairs && u.TitlesOfParts && cn(u.HeadingPairs, u.TitlesOfParts, h, g)));
        var g = {};
        t.bookSheets && !t.bookProps || 0 !== i.custprops.length && (m = tt(r, Hh(i.custprops[0]), !0)) && (g = function(e, t) {
            var r = {}, a = "", n = e.match(fn);
            if (n) for(var s = 0; s != n.length; ++s){
                var i = n[s], o = dt(i);
                switch(o[0]){
                    case "<?xml":
                    case "<Properties":
                        break;
                    case "<property":
                        a = wt(o.name);
                        break;
                    case "</property>":
                        a = null;
                        break;
                    default:
                        if (0 === i.indexOf("<vt:")) {
                            var c = i.split(">"), l = c[0].slice(4), f = c[1];
                            switch(l){
                                case "lpstr":
                                case "bstr":
                                case "lpwstr":
                                    r[a] = wt(f);
                                    break;
                                case "bool":
                                    r[a] = Rt(f);
                                    break;
                                case "i1":
                                case "i2":
                                case "i4":
                                case "i8":
                                case "int":
                                case "uint":
                                    r[a] = parseInt(f, 10);
                                    break;
                                case "r4":
                                case "r8":
                                case "decimal":
                                    r[a] = parseFloat(f);
                                    break;
                                case "filetime":
                                case "date":
                                    r[a] = He(f);
                                    break;
                                case "cy":
                                case "error":
                                    r[a] = wt(f);
                                    break;
                                default:
                                    if ("/" == l.slice(-1)) break;
                                    t.WTF && "undefined" != typeof console && console.warn("Unexpected", i, l, c);
                            }
                        } else if ("</" !== i.slice(0, 2) && t.WTF) throw new Error(i);
                }
            }
            return r;
        }(m, t));
        var b = {};
        if ((t.bookSheets || t.bookProps) && (d.Sheets ? e = d.Sheets.map(function(e) {
            return e.name;
        }) : p.Worksheets && 0 < p.SheetNames.length && (e = p.SheetNames), t.bookProps && (b.Props = p, b.Custprops = g), t.bookSheets && void 0 !== e && (b.SheetNames = e), t.bookSheets ? b.SheetNames : t.bookProps)) return b;
        e = {};
        m = {};
        t.bookDeps && i.calcchain && (m = ff(et(r, Hh(i.calcchain)), i.calcchain));
        var v, w, T = 0, E = {}, k = d.Sheets;
        p.Worksheets = k.length, p.SheetNames = [];
        for(var y = 0; y != k.length; ++y)p.SheetNames[y] = k[y].name;
        var S = o ? "bin" : "xml", o = i.workbooks[0].lastIndexOf("/"), _ = (i.workbooks[0].slice(0, o + 1) + "_rels/" + i.workbooks[0].slice(o + 1) + ".rels").replace(/^\//, "");
        Ze(r, _) || (_ = "xl/_rels/workbook." + S + ".rels");
        var x, A, C, R = Ya(tt(r, _, !0), _.replace(/_rels.*/, "s5s"));
        1 <= (i.metadata || []).length && (t.xlmeta = uf(et(r, Hh(i.metadata[0])), i.metadata[0], t)), 1 <= (i.people || []).length && (t.people = (o = et(r, Hh(i.people[0])), x = t, C = (A = [], false), o.replace(ft, function(e) {
            var t = dt(e);
            switch(pt(t[0])){
                case "<?xml":
                case "<personList":
                case "</personList>":
                    break;
                case "<person":
                    A.push({
                        name: t.displayname,
                        id: t.id
                    });
                    break;
                case "</person>":
                    break;
                case "<extLst":
                case "<extLst>":
                case "</extLst>":
                case "<extLst/>":
                    break;
                case "<ext":
                    C = !0;
                    break;
                case "</ext>":
                    C = !1;
                    break;
                default:
                    if (!C && x.WTF) throw new Error("unrecognized " + t[0] + " in threaded comments");
            }
            return e;
        }), A)), R = R && Bh(R, d.Sheets);
        var O = et(r, "xl/worksheets/sheet.xml", !0) ? 1 : 0;
        e: for(T = 0; T != p.Worksheets; ++T){
            var I = "sheet";
            if (R && R[T] ? (v = "xl/" + R[T][1].replace(/[\/]?xl\//, ""), Ze(r, v) || (v = R[T][1]), Ze(r, v) || (v = _.replace(/_rels\/.*$/, "") + R[T][1]), I = R[T][2]) : v = (v = "xl/worksheets/sheet" + (T + 1 - O) + "." + S).replace(/sheet0\./, "sheet."), w = v.replace(/^(.*)(\/)([^\/]*)$/, "$1/_rels/$3.rels"), t && null != t.sheets) switch(typeof t.sheets){
                case "number":
                    if (T != t.sheets) continue e;
                    break;
                case "string":
                    if (p.SheetNames[T].toLowerCase() != t.sheets.toLowerCase()) continue e;
                    break;
                default:
                    if (Array.isArray && Array.isArray(t.sheets)) {
                        for(var N = !1, F = 0; F != t.sheets.length; ++F)"number" == typeof t.sheets[F] && t.sheets[F] == T && (N = 1), "string" == typeof t.sheets[F] && t.sheets[F].toLowerCase() == p.SheetNames[T].toLowerCase() && (N = 1);
                        if (!N) continue e;
                    }
            }
            Wh(r, v, w, p.SheetNames[T], T, E, e, I, t, d, c, l);
        }
        return b = {
            Directory: i,
            Workbook: d,
            Props: p,
            Custprops: g,
            Deps: m,
            Sheets: e,
            SheetNames: p.SheetNames,
            Strings: Yc,
            Styles: l,
            Themes: c,
            SSF: Ve(me)
        }, t && t.bookFiles && (r.files ? (b.keys = s, b.files = r.files) : (b.keys = [], b.files = {}, r.FullPaths.forEach(function(e, t) {
            e = e.replace(/^Root Entry[\/]/, ""), b.keys.push(e), b.files[e] = r.FileIndex[t];
        }))), t && t.bookVBA && (0 < i.vba.length ? b.vbaraw = et(r, Hh(i.vba[0]), !0) : i.defaults && i.defaults.bin === ac && (b.vbaraw = et(r, "xl/vbaProject.bin", !0))), b;
    }
    function Vh(e, t) {
        var r, a = t || {}, n = "Workbook", s = xe.find(e, n);
        try {
            if (n = "/!DataSpaces/Version", !(s = xe.find(e, n)) || !s.content) throw new Error("ECMA-376 Encrypted file missing " + n);
            if (i = s.content, (r = {}).id = i.read_shift(0, "lpp4"), r.R = Li(i, 4), r.U = Li(i, 4), r.W = Li(i, 4), n = "/!DataSpaces/DataSpaceMap", !(s = xe.find(e, n)) || !s.content) throw new Error("ECMA-376 Encrypted file missing " + n);
            var i = Mi(s.content);
            if (1 !== i.length || 1 !== i[0].comps.length || 0 !== i[0].comps[0].t || "StrongEncryptionDataSpace" !== i[0].name || "EncryptedPackage" !== i[0].comps[0].v) throw new Error("ECMA-376 Encrypted file bad " + n);
            if (n = "/!DataSpaces/DataSpaceInfo/StrongEncryptionDataSpace", !(s = xe.find(e, n)) || !s.content) throw new Error("ECMA-376 Encrypted file missing " + n);
            i = function(e) {
                var t = [];
                e.l += 4;
                for(var r = e.read_shift(4); 0 < r--;)t.push(e.read_shift(0, "lpp4"));
                return t;
            }(s.content);
            if (1 != i.length || "StrongEncryptionTransform" != i[0]) throw new Error("ECMA-376 Encrypted file bad " + n);
            if (n = "/!DataSpaces/TransformInfo/StrongEncryptionTransform/!Primary", !(s = xe.find(e, n)) || !s.content) throw new Error("ECMA-376 Encrypted file missing " + n);
            Ui(s.content);
        } catch (e) {}
        if (n = "/EncryptionInfo", !(s = xe.find(e, n)) || !s.content) throw new Error("ECMA-376 Encrypted file missing " + n);
        t = Hi(s.content), n = "/EncryptedPackage";
        if (!(s = xe.find(e, n)) || !s.content) throw new Error("ECMA-376 Encrypted file missing " + n);
        if (4 == t[0] && "undefined" != typeof decrypt_agile) return decrypt_agile(t[1], s.content, a.password || "", a);
        if (2 == t[0] && "undefined" != typeof decrypt_std76) return decrypt_std76(t[1], s.content, a.password || "", a);
        throw new Error("File is password-protected");
    }
    function Gh(e, t) {
        return ("ods" == t.bookType ? lh : "numbers" == t.bookType ? Ph : "xlsb" == t.bookType ? function(e, t) {
            Zo = 1024, e && !e.SSF && (e.SSF = Ve(me));
            e && e.SSF && (Ee(), Te(e.SSF), t.revssf = Ne(e.SSF), t.revssf[e.SSF[65535]] = 0, t.ssf = e.SSF);
            t.rels = {}, t.wbrels = {}, t.Strings = [], t.Strings.Count = 0, t.Strings.Unique = 0, Jc ? t.revStrings = new Map : (t.revStrings = {}, t.revStrings.foo = [], delete t.revStrings.foo);
            var r = "xlsb" == t.bookType ? "bin" : "xml", a = -1 < nc.indexOf(t.bookType), n = Ga();
            Uh(t = t || {});
            var s = nt(), i = "", o = 0;
            t.cellXfs = [], el(t.cellXfs, {}, {
                revssf: {
                    General: 0
                }
            }), e.Props || (e.Props = {});
            if (at(s, i = "docProps/core.xml", nn(e.Props, t)), n.coreprops.push(i), Ja(t.rels, 2, i, $a.CORE_PROPS), i = "docProps/app.xml", !e.Props || !e.Props.SheetNames) {
                if (e.Workbook && e.Workbook.Sheets) {
                    for(var c = [], l = 0; l < e.SheetNames.length; ++l)2 != (e.Workbook.Sheets[l] || {}).Hidden && c.push(e.SheetNames[l]);
                    e.Props.SheetNames = c;
                } else e.Props.SheetNames = e.SheetNames;
            }
            e.Props.Worksheets = e.Props.SheetNames.length, at(s, i, ln(e.Props)), n.extprops.push(i), Ja(t.rels, 3, i, $a.EXT_PROPS), e.Custprops !== e.Props && 0 < Re(e.Custprops || {}).length && (at(s, i = "docProps/custom.xml", hn(e.Custprops)), n.custprops.push(i), Ja(t.rels, 4, i, $a.CUST_PROPS));
            for(o = 1; o <= e.SheetNames.length; ++o){
                var f, h, u, d = {
                    "!id": {}
                }, p = e.Sheets[e.SheetNames[o - 1]];
                at(s, i = "xl/worksheets/sheet" + o + "." + r, function(e, t, r, a, n) {
                    return (".bin" === t.slice(-4) ? Bl : xl)(e, r, a, n);
                }(o - 1, i, t, e, d)), n.sheets.push(i), Ja(t.wbrels, -1, "worksheets/sheet" + o + "." + r, $a.WS[0]), p && (f = p["!comments"], h = !1, u = "", f && 0 < f.length && (at(s, u = "xl/comments" + o + "." + r, function(e, t, r) {
                    return (".bin" === t.slice(-4) ? rc : tc)(e, r);
                }(f, u, t)), n.comments.push(u), Ja(d, -1, "../comments" + o + "." + r, $a.CMNT), h = !0), p["!legacy"] && h && at(s, "xl/drawings/vmlDrawing" + o + ".vml", Qo(o, p["!comments"])), delete p["!comments"], delete p["!legacy"]), d["!id"].rId1 && at(s, Xa(i), Ka(d));
            }
            null != t.Strings && 0 < t.Strings.length && (at(s, i = "xl/sharedStrings." + r, function(e, t, r) {
                return (".bin" === t.slice(-4) ? Di : Ni)(e, r);
            }(t.Strings, i, t)), n.strs.push(i), Ja(t.wbrels, -1, "sharedStrings." + r, $a.SST));
            at(s, i = "xl/workbook." + r, function(e, t, r) {
                return (".bin" === t.slice(-4) ? rf : Zl)(e, r);
            }(e, i, t)), n.workbooks.push(i), Ja(t.rels, 1, i, $a.WB), at(s, i = "xl/theme/theme1.xml", Xo(e.Themes, t)), n.themes.push(i), Ja(t.wbrels, -1, "theme/theme1.xml", $a.THEME), at(s, i = "xl/styles." + r, function(e, t, r) {
                return (".bin" === t.slice(-4) ? Mo : _o)(e, r);
            }(e, i, t)), n.styles.push(i), Ja(t.wbrels, -1, "styles." + r, $a.STY), e.vbaraw && a && (at(s, i = "xl/vbaProject.bin", e.vbaraw), n.vba.push(i), Ja(t.wbrels, -1, "vbaProject.bin", $a.VBA));
            return at(s, i = "xl/metadata." + r, function(e) {
                return (".bin" === e.slice(-4) ? Jo : qo)();
            }(i)), n.metadata.push(i), Ja(t.wbrels, -1, "metadata." + r, $a.XLMETA), at(s, "[Content_Types].xml", ja(n, t)), at(s, "_rels/.rels", Ka(t.rels)), at(s, "xl/_rels/workbook." + r + ".rels", Ka(t.wbrels)), delete t.revssf, delete t.ssf, s;
        } : jh)(e, t);
    }
    function jh(e, t) {
        Zo = 1024, e && !e.SSF && (e.SSF = Ve(me)), e && e.SSF && (Ee(), Te(e.SSF), t.revssf = Ne(e.SSF), t.revssf[e.SSF[65535]] = 0, t.ssf = e.SSF), t.rels = {}, t.wbrels = {}, t.Strings = [], t.Strings.Count = 0, t.Strings.Unique = 0, Jc ? t.revStrings = new Map : (t.revStrings = {}, t.revStrings.foo = [], delete t.revStrings.foo);
        var r = "xml", a = -1 < nc.indexOf(t.bookType), n = Ga();
        Uh(t = t || {});
        var s = nt(), i = "", o = 0;
        if (t.cellXfs = [], el(t.cellXfs, {}, {
            revssf: {
                General: 0
            }
        }), e.Props || (e.Props = {}), i = "docProps/core.xml", at(s, i, nn(e.Props, t)), n.coreprops.push(i), Ja(t.rels, 2, i, $a.CORE_PROPS), i = "docProps/app.xml", !e.Props || !e.Props.SheetNames) {
            if (e.Workbook && e.Workbook.Sheets) {
                for(var c = [], l = 0; l < e.SheetNames.length; ++l)2 != (e.Workbook.Sheets[l] || {}).Hidden && c.push(e.SheetNames[l]);
                e.Props.SheetNames = c;
            } else e.Props.SheetNames = e.SheetNames;
        }
        e.Props.Worksheets = e.Props.SheetNames.length, at(s, i, ln(e.Props)), n.extprops.push(i), Ja(t.rels, 3, i, $a.EXT_PROPS), e.Custprops !== e.Props && 0 < Re(e.Custprops || {}).length && (at(s, i = "docProps/custom.xml", hn(e.Custprops)), n.custprops.push(i), Ja(t.rels, 4, i, $a.CUST_PROPS));
        var f, h = [
            "SheetJ5"
        ];
        for(t.tcid = 0, o = 1; o <= e.SheetNames.length; ++o){
            var u, d, p, m, g = {
                "!id": {}
            }, b = e.Sheets[e.SheetNames[o - 1]];
            at(s, i = "xl/worksheets/sheet" + o + "." + r, xl(o - 1, t, e, g)), n.sheets.push(i), Ja(t.wbrels, -1, "worksheets/sheet" + o + "." + r, $a.WS[0]), b && (d = !1, p = "", (u = b["!comments"]) && 0 < u.length && (m = !1, u.forEach(function(e) {
                e[1].forEach(function(e) {
                    1 == e.T && (m = !0);
                });
            }), m && (at(s, p = "xl/threadedComments/threadedComment" + o + "." + r, function(e, s, i) {
                var o = [
                    ot,
                    Yt("ThreadedComments", null, {
                        xmlns: Zt.TCMNT
                    }).replace(/[\/]>/, ">")
                ];
                return e.forEach(function(a) {
                    var n = "";
                    (a[1] || []).forEach(function(e, t) {
                        var r;
                        e.T ? (e.a && -1 == s.indexOf(e.a) && s.push(e.a), r = {
                            ref: a[0],
                            id: "{54EE7951-7262-4200-6969-" + ("000000000000" + i.tcid++).slice(-12) + "}"
                        }, 0 == t ? n = r.id : r.parentId = n, e.ID = r.id, e.a && (r.personId = "{54EE7950-7262-4200-6969-" + ("000000000000" + s.indexOf(e.a)).slice(-12) + "}"), o.push(Yt("threadedComment", $t("text", e.t || ""), r))) : delete e.ID;
                    });
                }), o.push("</ThreadedComments>"), o.join("");
            }(u, h, t)), n.threadedcomments.push(p), Ja(g, -1, "../threadedComments/threadedComment" + o + "." + r, $a.TCMNT)), at(s, p = "xl/comments" + o + "." + r, tc(u)), n.comments.push(p), Ja(g, -1, "../comments" + o + "." + r, $a.CMNT), d = !0), b["!legacy"] && d && at(s, "xl/drawings/vmlDrawing" + o + ".vml", Qo(o, b["!comments"])), delete b["!comments"], delete b["!legacy"]), g["!id"].rId1 && at(s, Xa(i), Ka(g));
        }
        return null != t.Strings && 0 < t.Strings.length && (at(s, i = "xl/sharedStrings.xml", Ni(t.Strings, t)), n.strs.push(i), Ja(t.wbrels, -1, "sharedStrings.xml", $a.SST)), at(s, i = "xl/workbook.xml", Zl(e)), n.workbooks.push(i), Ja(t.rels, 1, i, $a.WB), at(s, i = "xl/theme/theme1.xml", Xo(e.Themes, t)), n.themes.push(i), Ja(t.wbrels, -1, "theme/theme1.xml", $a.THEME), at(s, i = "xl/styles.xml", _o(e, t)), n.styles.push(i), Ja(t.wbrels, -1, "styles.xml", $a.STY), e.vbaraw && a && (at(s, i = "xl/vbaProject.bin", e.vbaraw), n.vba.push(i), Ja(t.wbrels, -1, "vbaProject.bin", $a.VBA)), at(s, i = "xl/metadata.xml", qo()), n.metadata.push(i), Ja(t.wbrels, -1, "metadata.xml", $a.XLMETA), 1 < h.length && (at(s, i = "xl/persons/person.xml", (a = h, f = [
            ot,
            Yt("personList", null, {
                xmlns: Zt.TCMNT,
                "xmlns:x": Qt[0]
            }).replace(/[\/]>/, ">")
        ], a.forEach(function(e, t) {
            f.push(Yt("person", null, {
                displayName: e,
                id: "{54EE7950-7262-4200-6969-" + ("000000000000" + t).slice(-12) + "}",
                userId: e,
                providerId: "None"
            }));
        }), f.push("</personList>"), f.join(""))), n.people.push(i), Ja(t.wbrels, -1, "persons/person.xml", $a.PEOPLE)), at(s, "[Content_Types].xml", ja(n, t)), at(s, "_rels/.rels", Ka(t.rels)), at(s, "xl/_rels/workbook.xml.rels", Ka(t.wbrels)), delete t.revssf, delete t.ssf, s;
    }
    function $h(e, t) {
        var r = "";
        switch((t || {}).type || "base64"){
            case "buffer":
                return [
                    e[0],
                    e[1],
                    e[2],
                    e[3],
                    e[4],
                    e[5],
                    e[6],
                    e[7]
                ];
            case "base64":
                r = te(e.slice(0, 12));
                break;
            case "binary":
                r = e;
                break;
            case "array":
                return [
                    e[0],
                    e[1],
                    e[2],
                    e[3],
                    e[4],
                    e[5],
                    e[6],
                    e[7]
                ];
            default:
                throw new Error("Unrecognized type " + (t && t.type || "undefined"));
        }
        return [
            r.charCodeAt(0),
            r.charCodeAt(1),
            r.charCodeAt(2),
            r.charCodeAt(3),
            r.charCodeAt(4),
            r.charCodeAt(5),
            r.charCodeAt(6),
            r.charCodeAt(7)
        ];
    }
    function Xh(e, t) {
        var r = 0;
        e: for(; r < e.length;)switch(e.charCodeAt(r)){
            case 10:
            case 13:
            case 32:
                ++r;
                break;
            case 60:
                return wf(e.slice(r), t);
            default:
                break e;
        }
        return Ks.to_workbook(e, t);
    }
    function Yh(e, t, r, a) {
        return a ? (r.type = "string", Ks.to_workbook(e, r)) : Ks.to_workbook(t, r);
    }
    function Kh(e, t) {
        h();
        var r = t || {};
        if ("undefined" != typeof ArrayBuffer && e instanceof ArrayBuffer) return Kh(new Uint8Array(e), ((r = Ve(r)).type = "array", r));
        "undefined" != typeof Uint8Array && e instanceof Uint8Array && !r.type && (r.type = "undefined" != typeof Deno ? "buffer" : "array");
        var a, n, s, i, o, c = e, l = !1;
        if (r.cellStyles && (r.cellNF = !0, r.sheetStubs = !0), Kc = {}, r.dateNF && (Kc.dateNF = r.dateNF), r.type || (r.type = se && $4249f69807f0687b$require$Buffer.isBuffer(e) ? "buffer" : "base64"), "file" == r.type && (r.type = se ? "buffer" : "binary", c = function(e) {
            if (void 0 !== Se) return Se.readFileSync(e);
            if ("undefined" != typeof Deno) return Deno.readFileSync(e);
            if ("undefined" != typeof $ && "undefined" != typeof File && "undefined" != typeof Folder) try {
                var t = File(e);
                t.open("r"), t.encoding = "binary";
                var r = t.read();
                return t.close(), r;
            } catch (e) {
                if (!e.message || !e.message.match(/onstruct/)) throw e;
            }
            throw new Error("Cannot access file " + e);
        }(e), "undefined" == typeof Uint8Array || se || (r.type = "array")), "string" == r.type && (l = !0, r.type = "binary", r.codepage = 65001, c = (f = e).match(/[^\x00-\x7F]/) ? Ut(f) : f), "array" == r.type && "undefined" != typeof Uint8Array && e instanceof Uint8Array && "undefined" != typeof ArrayBuffer) {
            var f = new ArrayBuffer(3), f = new Uint8Array(f);
            if (f.foo = "bar", !f.foo) return (r = Ve(r)).type = "array", Kh(m(c), r);
        }
        switch((a = $h(c, r))[0]){
            case 208:
                if (207 === a[1] && 17 === a[2] && 224 === a[3] && 161 === a[4] && 177 === a[5] && 26 === a[6] && 225 === a[7]) return i = xe.read(c, r), o = r, (xe.find(i, "EncryptedPackage") ? Vh : Nf)(i, o);
                break;
            case 9:
                if (a[1] <= 8) return Nf(c, r);
                break;
            case 60:
                return wf(c, r);
            case 73:
                if (73 === a[1] && 42 === a[2] && 0 === a[3]) throw new Error("TIFF Image File is not a spreadsheet");
                if (68 === a[1]) return function(t, r) {
                    var a = r || {}, n = !!a.WTF;
                    a.WTF = !0;
                    try {
                        var e = Ns.to_workbook(t, a);
                        return a.WTF = n, e;
                    } catch (e) {
                        if (a.WTF = n, !e.message.match(/SYLK bad record ID/) && n) throw e;
                        return Ks.to_workbook(t, r);
                    }
                }(c, r);
                break;
            case 84:
                if (65 === a[1] && 66 === a[2] && 76 === a[3]) return Ps.to_workbook(c, r);
                break;
            case 80:
                return 75 === a[1] && a[2] < 9 && a[3] < 9 ? (s = o = c, (n = (n = r) || {}).type || (n.type = se && $4249f69807f0687b$require$Buffer.isBuffer(o) ? "buffer" : "base64"), zh(st(s, n), n)) : Yh(e, c, r, l);
            case 239:
                return 60 === a[3] ? wf(c, r) : Yh(e, c, r, l);
            case 255:
                if (254 === a[1]) return s = c, "base64" == (n = r).type && (s = te(s)), s = re.utils.decode(1200, s.slice(2), "str"), n.type = "binary", Xh(s, n);
                if (0 === a[1] && 2 === a[2] && 0 === a[3]) return si.to_workbook(c, r);
                break;
            case 0:
                if (0 === a[1]) {
                    if (2 <= a[2] && 0 === a[3]) return si.to_workbook(c, r);
                    if (0 === a[2] && (8 === a[3] || 9 === a[3])) return si.to_workbook(c, r);
                }
                break;
            case 3:
            case 131:
            case 139:
            case 140:
                return xs.to_workbook(c, r);
            case 123:
                if (92 === a[1] && 114 === a[2] && 116 === a[3]) return Ji.to_workbook(c, r);
                break;
            case 10:
            case 13:
            case 32:
                return function(e, t) {
                    var r = "", a = $h(e, t);
                    switch(t.type){
                        case "base64":
                            r = te(e);
                            break;
                        case "binary":
                            r = e;
                            break;
                        case "buffer":
                            r = e.toString("binary");
                            break;
                        case "array":
                            r = ze(e);
                            break;
                        default:
                            throw new Error("Unrecognized type " + t.type);
                    }
                    return 239 == a[0] && 187 == a[1] && 191 == a[2] && (r = Mt(r)), t.type = "binary", Xh(r, t);
                }(c, r);
            case 137:
                if (80 === a[1] && 78 === a[2] && 71 === a[3]) throw new Error("PNG Image File is not a spreadsheet");
        }
        return -1 < _s.indexOf(a[0]) && a[2] <= 12 && a[3] <= 31 ? xs.to_workbook(c, r) : Yh(e, c, r, l);
    }
    function Jh(e, t) {
        t = t || {};
        return t.type = "file", Kh(e, t);
    }
    function qh(e, t) {
        switch(t.type){
            case "base64":
            case "binary":
                break;
            case "buffer":
            case "array":
                t.type = "";
                break;
            case "file":
                return Ce(t.file, xe.write(e, {
                    type: se ? "buffer" : ""
                }));
            case "string":
                throw new Error("'string' output type invalid for '" + t.bookType + "' files");
            default:
                throw new Error("Unrecognized type " + t.type);
        }
        return xe.write(e, t);
    }
    function Zh(e, t) {
        var r = {}, a = se ? "nodebuffer" : "undefined" != typeof Uint8Array ? "array" : "string";
        if (t.compression && (r.compression = "DEFLATE"), t.password) r.type = a;
        else switch(t.type){
            case "base64":
                r.type = "base64";
                break;
            case "binary":
                r.type = "string";
                break;
            case "string":
                throw new Error("'string' output type invalid for '" + t.bookType + "' files");
            case "buffer":
            case "file":
                r.type = a;
                break;
            default:
                throw new Error("Unrecognized type " + t.type);
        }
        e = e.FullPaths ? xe.write(e, {
            fileType: "zip",
            type: {
                nodebuffer: "buffer",
                string: "binary"
            }[r.type] || r.type,
            compression: !!t.compression
        }) : e.generate(r);
        if ("undefined" != typeof Deno && "string" == typeof e) {
            if ("binary" == t.type || "base64" == t.type) return e;
            e = new Uint8Array(o(e));
        }
        return t.password && "undefined" != typeof encrypt_agile ? qh(encrypt_agile(e, t.password), t) : "file" === t.type ? Ce(t.file, e) : "string" == t.type ? Mt(e) : e;
    }
    function Qh(e, t, r) {
        var a = (r = r || "") + e;
        switch(t.type){
            case "base64":
                return ee(Ut(a));
            case "binary":
                return Ut(a);
            case "string":
                return e;
            case "file":
                return Ce(t.file, a, "utf8");
            case "buffer":
                return se ? ce(a, "utf8") : "undefined" != typeof TextEncoder ? (new TextEncoder).encode(a) : Qh(a, {
                    type: "binary"
                }).split("").map(function(e) {
                    return e.charCodeAt(0);
                });
        }
        throw new Error("Unrecognized type " + t.type);
    }
    function eu(e, t) {
        switch(t.type){
            case "string":
            case "base64":
            case "binary":
                for(var r = "", a = 0; a < e.length; ++a)r += String.fromCharCode(e[a]);
                return "base64" == t.type ? ee(r) : "string" == t.type ? Mt(r) : r;
            case "file":
                return Ce(t.file, e);
            case "buffer":
                return e;
            default:
                throw new Error("Unrecognized type " + t.type);
        }
    }
    function tu(e, t) {
        h(), Jl(e);
        var r, a = Ve(t || {});
        if (a.cellStyles && (a.cellNF = !0, a.sheetStubs = !0), "array" != a.type) return r = e, t = Ve((t = a) || {}), Zh(jh(r, t), t);
        a.type = "binary";
        e = tu(e, a);
        return a.type = "array", o(e);
    }
    function ru(e, t) {
        h(), Jl(e);
        var r = Ve(t || {});
        if (r.cellStyles && (r.cellNF = !0, r.sheetStubs = !0), "array" == r.type) {
            r.type = "binary";
            t = ru(e, r);
            return r.type = "array", o(t);
        }
        var a, n, s, i = 0;
        if (r.sheet && (i = "number" == typeof r.sheet ? r.sheet : e.SheetNames.indexOf(r.sheet), !e.SheetNames[i])) throw new Error("Sheet not found: " + r.sheet + " : " + typeof r.sheet);
        switch(r.bookType || "xlsb"){
            case "xml":
            case "xlml":
                return Qh(_f(e, r), r);
            case "slk":
            case "sylk":
                return Qh(Ns.from_sheet(e.Sheets[e.SheetNames[i]], r), r);
            case "htm":
            case "html":
                return Qh(Qf(e.Sheets[e.SheetNames[i]], r), r);
            case "txt":
                return function(e, t) {
                    switch(t.type){
                        case "base64":
                            return ee(e);
                        case "binary":
                        case "string":
                            return e;
                        case "file":
                            return Ce(t.file, e, "binary");
                        case "buffer":
                            return se ? ce(e, "binary") : e.split("").map(function(e) {
                                return e.charCodeAt(0);
                            });
                    }
                    throw new Error("Unrecognized type " + t.type);
                }(fu(e.Sheets[e.SheetNames[i]], r), r);
            case "csv":
                return Qh(lu(e.Sheets[e.SheetNames[i]], r), r, "\ufeff");
            case "dif":
                return Qh(Ps.from_sheet(e.Sheets[e.SheetNames[i]], r), r);
            case "dbf":
                return eu(xs.from_sheet(e.Sheets[e.SheetNames[i]], r), r);
            case "prn":
                return Qh(Ks.from_sheet(e.Sheets[e.SheetNames[i]], r), r);
            case "rtf":
                return Qh(Ji.from_sheet(e.Sheets[e.SheetNames[i]], r), r);
            case "eth":
                return Qh(Gs.from_sheet(e.Sheets[e.SheetNames[i]], r), r);
            case "fods":
                return Qh(lh(e, r), r);
            case "wk1":
                return eu(si.sheet_to_wk1(e.Sheets[e.SheetNames[i]], r), r);
            case "wk3":
                return eu(si.book_to_wk3(e, r), r);
            case "biff2":
                r.biff || (r.biff = 2);
            case "biff3":
                r.biff || (r.biff = 3);
            case "biff4":
                return r.biff || (r.biff = 4), eu(Xf(e, r), r);
            case "biff5":
                r.biff || (r.biff = 5);
            case "biff8":
            case "xla":
            case "xls":
                return r.biff || (r.biff = 8), qh(Ff(e, s = (s = r) || {}), s);
            case "xlsx":
            case "xlsm":
            case "xlam":
            case "xlsb":
            case "numbers":
            case "ods":
                return a = e, s = Ve((n = r) || {}), yo = new wu(n), Zh(Gh(a, s), s);
            default:
                throw new Error("Unrecognized bookType |" + r.bookType + "|");
        }
    }
    function au(e) {
        var t;
        e.bookType || ((t = e.file.slice(e.file.lastIndexOf(".")).toLowerCase()).match(/^\.[a-z]+$/) && (e.bookType = t.slice(1)), e.bookType = ({
            xls: "biff8",
            htm: "html",
            slk: "sylk",
            socialcalc: "eth",
            Sh33tJS: "WTF"
        })[e.bookType] || e.bookType);
    }
    function nu(e, t, r) {
        r = r || {};
        return r.type = "file", r.file = t, au(r), ru(e, r);
    }
    function su(e, t, r, a, n, s, i, o) {
        var c = jr(r), l = o.defval, f = o.raw || !Object.prototype.hasOwnProperty.call(o, "raw"), h = !0, u = 1 === n ? [] : {};
        if (1 !== n) {
            if (Object.defineProperty) try {
                Object.defineProperty(u, "__rowNum__", {
                    value: r,
                    enumerable: !1
                });
            } catch (e) {
                u.__rowNum__ = r;
            }
            else u.__rowNum__ = r;
        }
        if (!i || e[r]) for(var d = t.s.c; d <= t.e.c; ++d){
            var p = i ? e[r][d] : e[a[d] + c];
            if (void 0 !== p && void 0 !== p.t) {
                var m = p.v;
                switch(p.t){
                    case "z":
                        if (null == m) break;
                        continue;
                    case "e":
                        m = 0 == m ? null : void 0;
                        break;
                    case "s":
                    case "d":
                    case "b":
                    case "n":
                        break;
                    default:
                        throw new Error("unrecognized type " + p.t);
                }
                if (null != s[d]) {
                    if (null == m) {
                        if ("e" == p.t && null === m) u[s[d]] = null;
                        else if (void 0 !== l) u[s[d]] = l;
                        else {
                            if (!f || null !== m) continue;
                            u[s[d]] = null;
                        }
                    } else u[s[d]] = f && ("n" !== p.t || "n" === p.t && !1 !== o.rawNumbers) ? m : ea(p, m, o);
                    null != m && (h = !1);
                }
            } else void 0 !== l && null != s[d] && (u[s[d]] = l);
        }
        return {
            row: u,
            isempty: h
        };
    }
    function iu(e, t) {
        if (null == e || null == e["!ref"]) return [];
        var r, a = {
            t: "n",
            v: 0
        }, n = 0, s = 1, i = [], o = "", c = {
            s: {
                r: 0,
                c: 0
            },
            e: {
                r: 0,
                c: 0
            }
        }, l = t || {}, f = null != l.range ? l.range : e["!ref"];
        switch(1 === l.header ? n = 1 : "A" === l.header ? n = 2 : Array.isArray(l.header) ? n = 3 : null == l.header && (n = 0), typeof f){
            case "string":
                c = Zr(f);
                break;
            case "number":
                (c = Zr(e["!ref"])).s.r = f;
                break;
            default:
                c = f;
        }
        0 < n && (s = 0);
        var h = jr(c.s.r), u = [], d = [], p = 0, m = 0, g = Array.isArray(e), b = c.s.r, v = 0, w = {};
        g && !e[b] && (e[b] = []);
        for(var T, E = l.skipHidden && e["!cols"] || [], k = l.skipHidden && e["!rows"] || [], v = c.s.c; v <= c.e.c; ++v)if (!(E[v] || {}).hidden) switch(u[v] = Xr(v), a = g ? e[b][v] : e[u[v] + h], n){
            case 1:
                i[v] = v - c.s.c;
                break;
            case 2:
                i[v] = u[v];
                break;
            case 3:
                i[v] = l.header[v - c.s.c];
                break;
            default:
                if (o = r = ea(a = null == a ? {
                    w: "__EMPTY",
                    t: "s"
                } : a, null, l), m = w[r] || 0) {
                    for(; o = r + "_" + m++, w[o];);
                    w[r] = m, w[o] = 1;
                } else w[r] = 1;
                i[v] = o;
        }
        for(b = c.s.r + s; b <= c.e.r; ++b)(k[b] || {}).hidden || !1 !== (T = su(e, c, b, u, n, i, g, l)).isempty && (1 === n ? !1 === l.blankrows : !l.blankrows) || (d[p++] = T.row);
        return d.length = p, d;
    }
    var ou = /"/g;
    function cu(e, t, r, a, n, s, i, o) {
        for(var c = !0, l = [], f = "", h = jr(r), u = t.s.c; u <= t.e.c; ++u)if (a[u]) {
            var d = o.dense ? (e[r] || [])[u] : e[a[u] + h];
            if (null == d) f = "";
            else if (null != d.v) {
                c = !1, f = "" + (o.rawNumbers && "n" == d.t ? d.v : ea(d, null, o));
                for(var p, m = 0; m !== f.length; ++m)if ((p = f.charCodeAt(m)) === n || p === s || 34 === p || o.forceQuotes) {
                    f = '"' + f.replace(ou, '""') + '"';
                    break;
                }
                "ID" == f && (f = '"ID"');
            } else null == d.f || d.F ? f = "" : (c = !1, 0 <= (f = "=" + d.f).indexOf(",") && (f = '"' + f.replace(ou, '""') + '"'));
            l.push(f);
        }
        return !1 === o.blankrows && c ? null : l.join(i);
    }
    function lu(e, t) {
        var r = [], a = null == t ? {} : t;
        if (null == e || null == e["!ref"]) return "";
        var n = Zr(e["!ref"]), s = void 0 !== a.FS ? a.FS : ",", i = s.charCodeAt(0), o = void 0 !== a.RS ? a.RS : "\n", c = o.charCodeAt(0), l = new RegExp(("|" == s ? "\\|" : s) + "+$"), f = "", h = [];
        a.dense = Array.isArray(e);
        for(var u = a.skipHidden && e["!cols"] || [], d = a.skipHidden && e["!rows"] || [], p = n.s.c; p <= n.e.c; ++p)(u[p] || {}).hidden || (h[p] = Xr(p));
        for(var m = 0, g = n.s.r; g <= n.e.r; ++g)(d[g] || {}).hidden || null != (f = cu(e, n, g, h, i, c, s, a)) && (!(f = a.strip ? f.replace(l, "") : f) && !1 === a.blankrows || r.push((m++ ? o : "") + f));
        return delete a.dense, r.join("");
    }
    function fu(e, t) {
        (t = t || {}).FS = "\t", t.RS = "\n";
        e = lu(e, t);
        if (void 0 === re || "string" == t.type) return e;
        e = re.utils.encode(1200, e, "str");
        return String.fromCharCode(255) + String.fromCharCode(254) + e;
    }
    function hu(e, t, r) {
        var i, o = r || {}, c = +!o.skipHeader, l = e || {}, f = 0, h = 0;
        l && null != o.origin && ("number" == typeof o.origin ? f = o.origin : (a = "string" == typeof o.origin ? Yr(o.origin) : o.origin, f = a.r, h = a.c));
        var a, e = {
            s: {
                c: 0,
                r: 0
            },
            e: {
                c: h,
                r: f + t.length - 1 + c
            }
        };
        l["!ref"] ? (a = Zr(l["!ref"]), e.e.c = Math.max(e.e.c, a.e.c), e.e.r = Math.max(e.e.r, a.e.r), -1 == f && (f = a.e.r + 1, e.e.r = f + t.length - 1 + c)) : -1 == f && (f = 0, e.e.r = t.length - 1 + c);
        var u = o.header || [], d = 0;
        t.forEach(function(n, s) {
            Re(n).forEach(function(e) {
                -1 == (d = u.indexOf(e)) && (u[d = u.length] = e);
                var t = n[e], r = "z", a = "", e = Kr({
                    c: h + d,
                    r: f + s + c
                });
                i = uu(l, e), !t || "object" != typeof t || t instanceof Date ? ("number" == typeof t ? r = "n" : "boolean" == typeof t ? r = "b" : "string" == typeof t ? r = "s" : t instanceof Date ? (r = "d", o.cellDates || (r = "n", t = De(t)), a = o.dateNF || me[14]) : null === t && o.nullError && (r = "e", t = 0), i ? (i.t = r, i.v = t, delete i.w, delete i.R, a && (i.z = a)) : l[e] = i = {
                    t: r,
                    v: t
                }, a && (i.z = a)) : l[e] = t;
            });
        }), e.e.c = Math.max(e.e.c, h + u.length - 1);
        var n = jr(f);
        if (c) for(d = 0; d < u.length; ++d)l[Xr(d + h) + n] = {
            t: "s",
            v: u[d]
        };
        return l["!ref"] = qr(e), l;
    }
    function uu(e, t, r) {
        if ("string" != typeof t) return uu(e, Kr("number" != typeof t ? t : {
            r: t,
            c: r || 0
        }));
        if (Array.isArray(e)) {
            r = Yr(t);
            return e[r.r] || (e[r.r] = []), e[r.r][r.c] || (e[r.r][r.c] = {
                t: "z"
            });
        }
        return e[t] || (e[t] = {
            t: "z"
        });
    }
    function du() {
        return {
            SheetNames: [],
            Sheets: {}
        };
    }
    function pu(e, t, r, a) {
        var n = 1;
        if (!r) for(; n <= 65535 && -1 != e.SheetNames.indexOf(r = "Sheet" + n); ++n, r = void 0);
        if (!r || 65535 <= e.SheetNames.length) throw new Error("Too many worksheets");
        if (a && 0 <= e.SheetNames.indexOf(r)) {
            var a = r.match(/(^.*?)(\d+)$/), n = a && +a[2] || 0, s = a && a[1] || r;
            for(++n; n <= 65535 && -1 != e.SheetNames.indexOf(r = s + n); ++n);
        }
        if (Kl(r), 0 <= e.SheetNames.indexOf(r)) throw new Error("Worksheet with name |" + r + "| already exists!");
        return e.SheetNames.push(r), e.Sheets[r] = t, r;
    }
    function mu(e, t, r) {
        return t ? (e.l = {
            Target: t
        }, r && (e.l.Tooltip = r)) : delete e.l, e;
    }
    var gu, Es = {
        encode_col: Xr,
        encode_row: jr,
        encode_cell: Kr,
        encode_range: qr,
        decode_col: $r,
        decode_row: Gr,
        split_cell: function(e) {
            return e.replace(/(\$?[A-Z]*)(\$?\d*)/, "$1,$2").split(",");
        },
        decode_cell: Yr,
        decode_range: Jr,
        format_cell: ea,
        sheet_add_aoa: ra,
        sheet_add_json: hu,
        sheet_add_dom: eh,
        aoa_to_sheet: aa,
        json_to_sheet: function(e, t) {
            return hu(null, e, t);
        },
        table_to_sheet: th,
        table_to_book: function(e, t) {
            return ta(th(e, t), t);
        },
        sheet_to_csv: lu,
        sheet_to_txt: fu,
        sheet_to_json: iu,
        sheet_to_html: Qf,
        sheet_to_formulae: function(e) {
            var t, r = "", a = "";
            if (null == e || null == e["!ref"]) return [];
            for(var n, s = Zr(e["!ref"]), i = [], o = [], c = Array.isArray(e), l = s.s.c; l <= s.e.c; ++l)i[l] = Xr(l);
            for(var f = s.s.r; f <= s.e.r; ++f)for(n = jr(f), l = s.s.c; l <= s.e.c; ++l)if (r = i[l] + n, a = "", void 0 !== (t = c ? (e[f] || [])[l] : e[r])) {
                if (null != t.F) {
                    if (r = t.F, !t.f) continue;
                    a = t.f, -1 == r.indexOf(":") && (r = r + ":" + r);
                }
                if (null != t.f) a = t.f;
                else {
                    if ("z" == t.t) continue;
                    if ("n" == t.t && null != t.v) a = "" + t.v;
                    else if ("b" == t.t) a = t.v ? "TRUE" : "FALSE";
                    else if (void 0 !== t.w) a = "'" + t.w;
                    else {
                        if (void 0 === t.v) continue;
                        a = "s" == t.t ? "'" + t.v : "" + t.v;
                    }
                }
                o[o.length] = r + "=" + a;
            }
            return o;
        },
        sheet_to_row_object_array: iu,
        sheet_get_cell: uu,
        book_new: du,
        book_append_sheet: pu,
        book_set_sheet_visibility: function(e, t, r) {
            switch(e.Workbook || (e.Workbook = {}), e.Workbook.Sheets || (e.Workbook.Sheets = []), t = function(e, t) {
                if ("number" == typeof t) {
                    if (0 <= t && e.SheetNames.length > t) return t;
                    throw new Error("Cannot find sheet # " + t);
                }
                if ("string" != typeof t) throw new Error("Cannot find sheet |" + t + "|");
                if (-1 < (e = e.SheetNames.indexOf(t))) return e;
                throw new Error("Cannot find sheet name |" + t + "|");
            }(e, t), e.Workbook.Sheets[t] || (e.Workbook.Sheets[t] = {}), r){
                case 0:
                case 1:
                case 2:
                    break;
                default:
                    throw new Error("Bad sheet visibility setting " + r);
            }
            e.Workbook.Sheets[t].Hidden = r;
        },
        cell_set_number_format: function(e, t) {
            return e.z = t, e;
        },
        cell_set_hyperlink: mu,
        cell_set_internal_link: function(e, t, r) {
            return mu(e, "#" + t, r);
        },
        cell_add_comment: function(e, t, r) {
            e.c || (e.c = []), e.c.push({
                t: t,
                a: r || "SheetJS"
            });
        },
        sheet_set_array_formula: function(e, t, r, a) {
            for(var n = "string" != typeof t ? t : Zr(t), s = "string" == typeof t ? t : qr(t), i = n.s.r; i <= n.e.r; ++i)for(var o = n.s.c; o <= n.e.c; ++o){
                var c = uu(e, i, o);
                c.t = "n", c.F = s, delete c.v, i == n.s.r && o == n.s.c && (c.f = r, a && (c.D = !0));
            }
            return e;
        },
        consts: {
            SHEET_VISIBLE: 0,
            SHEET_HIDDEN: 1,
            SHEET_VERY_HIDDEN: 2
        }
    };
    function bu(e) {
        gu = e;
    }
    var is = {
        to_json: function(t, e) {
            var r = gu({
                objectMode: !0
            });
            if (null == t || null == t["!ref"]) return r.push(null), r;
            var a, n = {
                t: "n",
                v: 0
            }, s = 0, i = 1, o = [], c = "", l = {
                s: {
                    r: 0,
                    c: 0
                },
                e: {
                    r: 0,
                    c: 0
                }
            }, f = e || {}, h = null != f.range ? f.range : t["!ref"];
            switch(1 === f.header ? s = 1 : "A" === f.header ? s = 2 : Array.isArray(f.header) && (s = 3), typeof h){
                case "string":
                    l = Zr(h);
                    break;
                case "number":
                    (l = Zr(t["!ref"])).s.r = h;
                    break;
                default:
                    l = h;
            }
            0 < s && (i = 0);
            var u = jr(l.s.r), d = [], p = 0, m = Array.isArray(t), g = l.s.r, b = 0, v = {};
            m && !t[g] && (t[g] = []);
            for(var w = f.skipHidden && t["!cols"] || [], T = f.skipHidden && t["!rows"] || [], b = l.s.c; b <= l.e.c; ++b)if (!(w[b] || {}).hidden) switch(d[b] = Xr(b), n = m ? t[g][b] : t[d[b] + u], s){
                case 1:
                    o[b] = b - l.s.c;
                    break;
                case 2:
                    o[b] = d[b];
                    break;
                case 3:
                    o[b] = f.header[b - l.s.c];
                    break;
                default:
                    if (c = a = ea(n = null == n ? {
                        w: "__EMPTY",
                        t: "s"
                    } : n, null, f), p = v[a] || 0) {
                        for(; c = a + "_" + p++, v[c];);
                        v[a] = p, v[c] = 1;
                    } else v[a] = 1;
                    o[b] = c;
            }
            return g = l.s.r + i, r._read = function() {
                for(; g <= l.e.r;)if (!(T[g - 1] || {}).hidden) {
                    var e = su(t, l, g, d, s, o, m, f);
                    if (++g, !1 === e.isempty || (1 === s ? !1 !== f.blankrows : f.blankrows)) return void r.push(e.row);
                }
                return r.push(null);
            }, r;
        },
        to_html: function(e, t) {
            var r = gu(), a = t || {}, t = null != a.header ? a.header : Jf, n = null != a.footer ? a.footer : qf;
            r.push(t);
            var s = Jr(e["!ref"]);
            a.dense = Array.isArray(e), r.push(Zf(0, 0, a));
            var i = s.s.r, o = !1;
            return r._read = function() {
                if (i > s.e.r) return o || (o = !0, r.push("</table>" + n)), r.push(null);
                for(; i <= s.e.r;){
                    r.push(Kf(e, s, i, a)), ++i;
                    break;
                }
            }, r;
        },
        to_csv: function(e, t) {
            var r = gu(), a = null == t ? {} : t;
            if (null == e || null == e["!ref"]) return r.push(null), r;
            var n = Zr(e["!ref"]), s = void 0 !== a.FS ? a.FS : ",", i = s.charCodeAt(0), o = void 0 !== a.RS ? a.RS : "\n", c = o.charCodeAt(0), l = new RegExp(("|" == s ? "\\|" : s) + "+$"), f = "", h = [];
            a.dense = Array.isArray(e);
            for(var u = a.skipHidden && e["!cols"] || [], d = a.skipHidden && e["!rows"] || [], p = n.s.c; p <= n.e.c; ++p)(u[p] || {}).hidden || (h[p] = Xr(p));
            var m = n.s.r, g = !1, b = 0;
            return r._read = function() {
                if (!g) return g = !0, r.push("\ufeff");
                for(; m <= n.e.r;)if (++m, !(d[m - 1] || {}).hidden && (f = cu(e, n, m - 1, h, i, c, s, a), null != f && ((f = a.strip ? f.replace(l, "") : f) || !1 !== a.blankrows))) return r.push((b++ ? o : "") + f);
                return r.push(null);
            }, r;
        },
        set_readable: bu
    }, vu = function() {
        function a(e, t, r) {
            return this instanceof a ? (this.tagName = e, this._attributes = t || {}, this._children = r || [], this._prefix = "", this) : new a(e, t, r);
        }
        a.prototype.createElement = function() {
            return new a(arguments);
        }, a.prototype.children = function() {
            return this._children;
        }, a.prototype.append = function(e) {
            return this._children.push(e), this;
        }, a.prototype.prefix = function(e) {
            return 0 == arguments.length ? this._prefix : (this._prefix = e, this);
        }, a.prototype.attr = function(e, t) {
            if (null == t) return delete this._attributes[e], this;
            if (0 == arguments.length) return this._attributes;
            if ("string" == typeof e && 1 == arguments.length) return this._attributes.attr[e];
            if ("object" == typeof e && 1 == arguments.length) for(var r in e)this._attributes[r] = e[r];
            else 2 == arguments.length && "string" == typeof e && (this._attributes[e] = t);
            return this;
        };
        return a.prototype.escapeAttributeValue = function(e) {
            return '"' + e.replace(/\"/g, "&quot;") + '"';
        }, a.prototype.toXml = function(e) {
            var t = (e = e || this)._prefix;
            if (t += "<" + e.tagName, e._attributes) for(var r in e._attributes)t += " " + r + "=" + this.escapeAttributeValue("" + e._attributes[r]);
            if (e._children && 0 < e._children.length) {
                t += ">";
                for(var a = 0; a < e._children.length; a++)t += this.toXml(e._children[a]);
                t += "</" + e.tagName + ">";
            } else t += "/>";
            return t;
        }, a;
    }(), wu = function(e) {
        var t, r = 164, a = {
            0: "General",
            1: "0",
            2: "0.00",
            3: "#,##0",
            4: "#,##0.00",
            9: "0%",
            10: "0.00%",
            11: "0.00E+00",
            12: "# ?/?",
            13: "# ??/??",
            14: "m/d/yy",
            15: "d-mmm-yy",
            16: "d-mmm",
            17: "mmm-yy",
            18: "h:mm AM/PM",
            19: "h:mm:ss AM/PM",
            20: "h:mm",
            21: "h:mm:ss",
            22: "m/d/yy h:mm",
            37: "#,##0 ;(#,##0)",
            38: "#,##0 ;[Red](#,##0)",
            39: "#,##0.00;(#,##0.00)",
            40: "#,##0.00;[Red](#,##0.00)",
            45: "mm:ss",
            46: "[h]:mm:ss",
            47: "mmss.0",
            48: "##0.0E+0",
            49: "@",
            56: '"\u4E0A\u5348/\u4E0B\u5348 "hh"\u6642"mm"\u5206"ss"\u79D2 "'
        }, n = {};
        for(t in a)n[a[t]] = t;
        var s = {};
        return ({
            initialize: function(e) {
                this.$fonts = vu("fonts").attr("count", 0).attr("x14ac:knownFonts", "1"), this.$fills = vu("fills").attr("count", 0), this.$borders = vu("borders").attr("count", 0), this.$numFmts = vu("numFmts").attr("count", 0), this.$cellStyleXfs = vu("cellStyleXfs"), this.$xf = vu("xf").attr("numFmtId", 0).attr("fontId", 0).attr("fillId", 0).attr("borderId", 0), this.$cellXfs = vu("cellXfs").attr("count", 0), this.$cellStyles = vu("cellStyles").append(vu("cellStyle").attr("name", "Normal").attr("xfId", 0).attr("builtinId", 0)), this.$dxfs = vu("dxfs").attr("count", "0"), this.$tableStyles = vu("tableStyles").attr("count", "0").attr("defaultTableStyle", "TableStyleMedium9").attr("defaultPivotStyle", "PivotStyleMedium4"), this.$styles = vu("styleSheet").attr("xmlns:mc", "http://schemas.openxmlformats.org/markup-compatibility/2006").attr("xmlns:x14ac", "http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac").attr("xmlns", "http://schemas.openxmlformats.org/spreadsheetml/2006/main").attr("mc:Ignorable", "x14ac").prefix('<?xml version="1.0" encoding="UTF-8" standalone="yes"?>').append(this.$numFmts).append(this.$fonts).append(this.$fills).append(this.$borders).append(this.$cellStyleXfs.append(this.$xf)).append(this.$cellXfs).append(this.$cellStyles).append(this.$dxfs).append(this.$tableStyles);
                var t = e.defaultCellStyle || {};
                t.font || (t.font = {
                    name: "Calibri",
                    sz: "11"
                }), t.font.name || (t.font.name = "Calibri"), t.font.sz || (t.font.sz = 11), t.fill || (t.fill = {
                    patternType: "none",
                    fgColor: {}
                }), t.border || (t.border = {}), t.numFmt || (t.numFmt = 0), this.defaultStyle = t;
                e = JSON.parse(JSON.stringify(t));
                return e.fill = {
                    patternType: "gray125",
                    fgColor: {}
                }, this.addStyles([
                    t,
                    e
                ]), this;
            },
            addStyle: function(e) {
                var t = JSON.stringify(e), r = s[t];
                return null == r ? (r = this._addXf(e), s[t] = r) : r = s[t], r;
            },
            addStyles: function(e) {
                var t = this;
                return e.map(function(e) {
                    return t.addStyle(e);
                });
            },
            _duckTypeStyle: function(e) {
                return "object" == typeof e && (e.patternFill || e.fgColor) ? {
                    fill: e
                } : e.font || e.numFmt || e.border || e.fill ? e : this._getStyleCSS(e);
            },
            _getStyleCSS: function(e) {
                return e;
            },
            _addXf: function(e) {
                var t = this._addFont(e.font), r = this._addFill(e.fill), a = this._addBorder(e.border), n = this._addNumFmt(e.numFmt), s = vu("xf").attr("numFmtId", n).attr("fontId", t).attr("fillId", r).attr("borderId", a).attr("xfId", "0");
                0 < t && s.attr("applyFont", "1"), 0 < r && s.attr("applyFill", "1"), 0 < a && s.attr("applyBorder", "1"), 0 < n && s.attr("applyNumberFormat", "1"), e.alignment && (n = vu("alignment"), e.alignment.horizontal && n.attr("horizontal", e.alignment.horizontal), e.alignment.vertical && n.attr("vertical", e.alignment.vertical), e.alignment.indent && n.attr("indent", e.alignment.indent), e.alignment.readingOrder && n.attr("readingOrder", e.alignment.readingOrder), e.alignment.wrapText && n.attr("wrapText", e.alignment.wrapText), null != e.alignment.textRotation && n.attr("textRotation", e.alignment.textRotation), s.append(n).attr("applyAlignment", 1)), this.$cellXfs.append(s);
                s = +this.$cellXfs.children().length;
                return this.$cellXfs.attr("count", s), s - 1;
            },
            _addFont: function(e) {
                if (!e) return 0;
                var t = vu("font").append(vu("sz").attr("val", e.sz || this.defaultStyle.font.sz)).append(vu("name").attr("val", e.name || this.defaultStyle.font.name));
                e.bold && t.append(vu("b")), e.underline && t.append(vu("u")), e.italic && t.append(vu("i")), e.strike && t.append(vu("strike")), e.outline && t.append(vu("outline")), e.shadow && t.append(vu("shadow")), e.vertAlign && t.append(vu("vertAlign").attr("val", e.vertAlign)), e.color && (e.color.theme ? (t.append(vu("color").attr("theme", e.color.theme)), e.color.tint && t.append(vu("tint").attr("theme", e.color.tint))) : e.color.rgb && t.append(vu("color").attr("rgb", e.color.rgb))), this.$fonts.append(t);
                t = this.$fonts.children().length;
                return this.$fonts.attr("count", t), t - 1;
            },
            _addNumFmt: function(e) {
                if (!e) return 0;
                if ("string" == typeof e) {
                    var t = n[e];
                    if (0 <= t) return t;
                }
                if (/^[0-9]+$/.exec(e)) return e;
                e = e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
                e = vu("numFmt").attr("numFmtId", ++r).attr("formatCode", e);
                this.$numFmts.append(e);
                e = this.$numFmts.children().length;
                return this.$numFmts.attr("count", e), r;
            },
            _addFill: function(e) {
                if (!e) return 0;
                var t, r = vu("patternFill").attr("patternType", e.patternType || "solid");
                e.fgColor && (t = vu("fgColor"), e.fgColor.rgb ? (6 == e.fgColor.rgb.length && (e.fgColor.rgb = "FF" + e.fgColor.rgb), t.attr("rgb", e.fgColor.rgb), r.append(t)) : e.fgColor.theme && (t.attr("theme", e.fgColor.theme), e.fgColor.tint && t.attr("tint", e.fgColor.tint), r.append(t)), e.bgColor || (e.bgColor = {
                    indexed: "64"
                })), e.bgColor && (e = vu("bgColor").attr(e.bgColor), r.append(e));
                r = vu("fill").append(r);
                this.$fills.append(r);
                r = this.$fills.children().length;
                return this.$fills.attr("count", r), r - 1;
            },
            _getSubBorder: function(e, t) {
                var r = vu(e);
                return t && (r.attr("style", t.style || "medium"), t.color && (e = vu("color"), t.color.auto ? e.attr("auto", t.color.auto) : t.color.rgb ? e.attr("rgb", t.color.rgb) : (t.color.theme || t.color.tint) && (e.attr("theme", t.color.theme || "1"), e.attr("tint", t.color.tint || "0")), r.append(e))), r;
            },
            _addBorder: function(t) {
                if (!t) return 0;
                var r = this, a = vu("border").attr("diagonalUp", t.diagonalUp).attr("diagonalDown", t.diagonalDown);
                [
                    "left",
                    "right",
                    "top",
                    "bottom",
                    "diagonal"
                ].forEach(function(e) {
                    a.append(r._getSubBorder(e, t[e]));
                }), this.$borders.append(a);
                var e = this.$borders.children().length;
                return this.$borders.attr("count", e), e - 1;
            },
            toXml: function() {
                return this.$styles.toXml();
            }
        }).initialize(e || {});
    };
    void 0 !== Nf && (a.parse_xlscfb = Nf), a.parse_zip = zh, a.read = Kh, a.readFile = Jh, a.readFileSync = Jh, a.write = ru, a.writeFile = nu, a.writeFileSync = nu, a.writeFileAsync = function(e, t, r, a) {
        var n = r || {};
        return n.type = "file", n.file = e, au(n), n.type = "buffer", a instanceof Function || (a = r), Se.writeFile(e, ru(t, n), a);
    }, a.utils = Es, a.writeXLSX = tu, a.writeFileXLSX = function(e, t, r) {
        return (r = r || {}).type = "file", r.file = t, au(r), tu(e, r);
    }, a.SSF = e, void 0 !== is && (a.stream = is), void 0 !== xe && (a.CFB = xe), ((is = (parcelRequire("kjyEk"))) || {}).Readable && bu(is.Readable);
}
if ($4249f69807f0687b$var$make_xlsx_lib($4249f69807f0687b$exports), "undefined" != typeof window && !window.XLSX) try {
    window.XLSX = $4249f69807f0687b$var$XLSX;
} catch (e) {}



var $acw62 = parcelRequire("acw62");




var $90f256c567e4c320$exports = {};
(function(a, b) {
    if ("function" == typeof define && define.amd) define([], b);
    else b();
})($90f256c567e4c320$exports, function() {
    "use strict";
    function b(a, b) {
        return "undefined" == typeof b ? b = {
            autoBom: !1
        } : "object" != typeof b && (console.warn("Deprecated: Expected third argument to be a object"), b = {
            autoBom: !b
        }), b.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type) ? new Blob([
            "\uFEFF",
            a
        ], {
            type: a.type
        }) : a;
    }
    function c(a, b, c) {
        var d = new XMLHttpRequest;
        d.open("GET", a), d.responseType = "blob", d.onload = function() {
            g(d.response, b, c);
        }, d.onerror = function() {
            console.error("could not download file");
        }, d.send();
    }
    function d(a) {
        var b = new XMLHttpRequest;
        b.open("HEAD", a, !1);
        try {
            b.send();
        } catch (a) {}
        return 200 <= b.status && 299 >= b.status;
    }
    function e(a) {
        try {
            a.dispatchEvent(new MouseEvent("click"));
        } catch (c) {
            var b = document.createEvent("MouseEvents");
            b.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), a.dispatchEvent(b);
        }
    }
    var f = "object" == typeof window && window.window === window ? window : "object" == typeof self && self.self === self ? self : "object" == typeof $parcel$global && $parcel$global.global === $parcel$global ? $parcel$global : void 0, a = f.navigator && /Macintosh/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Safari/.test(navigator.userAgent), g = f.saveAs || ("object" != typeof window || window !== f ? function() {} : "download" in HTMLAnchorElement.prototype && !a ? function(b, g, h) {
        var i = f.URL || f.webkitURL, j = document.createElement("a");
        g = g || b.name || "download", j.download = g, j.rel = "noopener", "string" == typeof b ? (j.href = b, j.origin === location.origin ? e(j) : d(j.href) ? c(b, g, h) : e(j, j.target = "_blank")) : (j.href = i.createObjectURL(b), setTimeout(function() {
            i.revokeObjectURL(j.href);
        }, 4E4), setTimeout(function() {
            e(j);
        }, 0));
    } : "msSaveOrOpenBlob" in navigator ? function(f, g, h) {
        if (g = g || f.name || "download", "string" != typeof f) navigator.msSaveOrOpenBlob(b(f, h), g);
        else if (d(f)) c(f, g, h);
        else {
            var i = document.createElement("a");
            i.href = f, i.target = "_blank", setTimeout(function() {
                e(i);
            });
        }
    } : function(b, d, e, g) {
        if (g = g || open("", "_blank"), g && (g.document.title = g.document.body.innerText = "downloading..."), "string" == typeof b) return c(b, d, e);
        var h = "application/octet-stream" === b.type, i = /constructor/i.test(f.HTMLElement) || f.safari, j = /CriOS\/[\d]+/.test(navigator.userAgent);
        if ((j || h && i || a) && "undefined" != typeof FileReader) {
            var k = new FileReader;
            k.onloadend = function() {
                var a = k.result;
                a = j ? a : a.replace(/^data:[^;]*;/, "data:attachment/file;"), g ? g.location.href = a : location = a, g = null;
            }, k.readAsDataURL(b);
        } else {
            var l = f.URL || f.webkitURL, m = l.createObjectURL(b);
            g ? g.location = m : location.href = m, g = null, setTimeout(function() {
                l.revokeObjectURL(m);
            }, 4E4);
        }
    });
    f.saveAs = g.saveAs = g, $90f256c567e4c320$exports = g;
});









var $acw62 = parcelRequire("acw62");



const $637cc7b74c89b097$var$FilterPanel = ({ open: open, onClose: onClose, onApply: onApply, onClear: onClear, showStatus: showStatus = true })=>{
    const [search, setSearch] = (0, $acw62.useState)("");
    const [status, setStatus] = (0, $acw62.useState)([]);
    const [startDate, setStartDate] = (0, $acw62.useState)("");
    const [endDate, setEndDate] = (0, $acw62.useState)("");
    // Toggle status selection
    const toggleStatus = (value)=>{
        setStatus((prev)=>prev.includes(value) ? prev.filter((s)=>s !== value) : [
                ...prev,
                value
            ]);
    };
    // Clear all filters
    const handleClear = ()=>{
        setSearch("");
        setStatus([]);
        setStartDate("");
        setEndDate("");
        onClear?.(); // Inform parent
    };
    // Apply filter
    const handleApply = ()=>{
        onApply?.({
            search: search.toLowerCase().trim().replace(/\s+/g, " "),
            status: status,
            startDate: startDate,
            endDate: endDate
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "filter-overlay",
                style: {
                    display: open ? "block" : "none"
                },
                onClick: onClose
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: `filter-panel ${open ? "open" : ""}`,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "filter-header",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "0.5rem"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$f04a61298a47a40f), {
                                        size: "m",
                                        ic: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a9dbc27ea69a373d$export$26f46b9510140fcc), {}),
                                        color: "primary_grey_100"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                        appearance: "heading-xs",
                                        color: "primary_grey_100",
                                        id: "filterPanelTitle",
                                        children: "Filters"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$cfc7921d29ef7b80), {
                                ariaLabel: "Close filter panel",
                                onClick: onClose,
                                kind: "tertiary",
                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$f04a61298a47a40f), {
                                    ic: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4b407a2b367f43e3$export$48672c81f0c3f574), {}),
                                    size: "l",
                                    color: "primary_grey_100"
                                }),
                                size: "medium"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "filter-body",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "search-input-wrapper",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$f04a61298a47a40f), {
                                        ic: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $52f7703976716e4f$export$6da2c307edd95198), {}),
                                        size: "m",
                                        color: "primary_grey_100"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "text",
                                        className: "search-input",
                                        placeholder: "Search data item, type and purpose",
                                        value: search,
                                        onChange: (e)=>setSearch(e.target.value),
                                        "aria-label": "Search data item, type and purpose"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                appearance: "body-s-bold",
                                color: "primary_grey_80",
                                className: "filter-label",
                                children: "Status"
                            }),
                            showStatus && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "status-options",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: `status-box ${status.includes("ACTIVE") ? "selected" : ""}`,
                                        "aria-label": status.includes("ACTIVE") ? "Remove Active filter" : "Add Active filter",
                                        "aria-pressed": status.includes("ACTIVE"),
                                        onClick: ()=>toggleStatus("ACTIVE"),
                                        children: status.includes("ACTIVE") ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                gap: "0.5rem",
                                                alignItems: "center"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                    appearance: "body-s",
                                                    color: "primary_grey_100",
                                                    children: "Active"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4b407a2b367f43e3$export$48672c81f0c3f574), {
                                                    height: 20,
                                                    width: 20
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                gap: "0.5rem",
                                                alignItems: "center"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                    appearance: "body-s",
                                                    color: "primary_grey_100",
                                                    children: "Active"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4c1f85da286cc021$export$27c4cbfb69a3e993), {
                                                    height: 20,
                                                    width: 20
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: `status-box ${status.includes("WITHDRAWN") ? "selected" : ""}`,
                                        onClick: ()=>toggleStatus("WITHDRAWN"),
                                        "aria-label": status.includes("WITHDRAWN") ? "Remove Withdrawn filter" : "Add Withdrawn filter",
                                        "aria-pressed": status.includes("WITHDRAWN"),
                                        children: status.includes("WITHDRAWN") ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                gap: "0.5rem",
                                                alignItems: "center"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                    appearance: "body-s",
                                                    color: "primary_grey_100",
                                                    children: "Withdrawn"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4b407a2b367f43e3$export$48672c81f0c3f574), {
                                                    height: 20,
                                                    width: 20
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                gap: "0.5rem",
                                                alignItems: "center"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                    appearance: "body-s",
                                                    color: "primary_grey_100",
                                                    children: "Withdrawn"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4c1f85da286cc021$export$27c4cbfb69a3e993), {
                                                    height: 20,
                                                    width: 20
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: `status-box ${status.includes("EXPIRED") ? "selected" : ""}`,
                                        onClick: ()=>toggleStatus("EXPIRED"),
                                        "aria-label": status.includes("EXPIRED") ? "Remove Expired filter" : "Add Expired filter",
                                        "aria-pressed": status.includes("EXPIRED"),
                                        children: status.includes("EXPIRED") ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                gap: "0.5rem",
                                                alignItems: "center"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                    appearance: "body-s",
                                                    color: "primary_grey_100",
                                                    children: "Expired"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4b407a2b367f43e3$export$48672c81f0c3f574), {
                                                    height: 20,
                                                    width: 20
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                gap: "0.5rem",
                                                alignItems: "center"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                    appearance: "body-s",
                                                    color: "primary_grey_100",
                                                    children: "Expired"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4c1f85da286cc021$export$27c4cbfb69a3e993), {
                                                    height: 20,
                                                    width: 20
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                appearance: "body-s-bold",
                                color: "primary_grey_80",
                                className: "filter-label",
                                children: "Created Date Range"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "date-range-row",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "date",
                                        className: "date-input",
                                        value: startDate,
                                        onChange: (e)=>setStartDate(e.target.value),
                                        onFocus: (e)=>e.target.showPicker?.(),
                                        "aria-label": "Start Date"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "date",
                                        className: "date-input",
                                        "aria-label": "End Date",
                                        value: endDate,
                                        onChange: (e)=>setEndDate(e.target.value),
                                        onFocus: (e)=>e.target.showPicker?.()
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "filter-footer",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$cfc7921d29ef7b80), {
                                kind: "secondary",
                                label: "Clear All",
                                onClick: handleClear,
                                ariaLabel: "Clear All Filter"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$cfc7921d29ef7b80), {
                                kind: "primary",
                                label: "Apply",
                                onClick: handleApply,
                                ariaLabel: "Apply filters"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $637cc7b74c89b097$export$2e2bcd8739ae039 = $637cc7b74c89b097$var$FilterPanel;



parcelRequire("acw62");


const $63ff59473b55bad2$var$SessionExpiredModal = ({ isOpen: isOpen, onClose: onClose })=>{
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "session-overlay",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "session-modal",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                    className: "session-title",
                    children: "Your Session is Expired"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "session-subtitle",
                    children: "You may close the window"
                })
            ]
        })
    });
};
var $63ff59473b55bad2$export$2e2bcd8739ae039 = $63ff59473b55bad2$var$SessionExpiredModal;



const $164dc338fd404bfa$var$FiduciaryRequests = ()=>{
    const parentNameRef = (0, $acw62.useRef)();
    var PageLoaderFlag = 0;
    const [consentLanguageList, setConsentLanguageList] = (0, $acw62.useState)([]);
    const parentIdentityRef = (0, $acw62.useRef)();
    const otpRef = (0, $acw62.useRef)(null);
    const modalRef = (0, $acw62.useRef)(null);
    const [isDigiLockerLoading, setIsDigiLockerLoading] = (0, $acw62.useState)(false);
    const businessName = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.common.business_name);
    const [showModal, setShowModal] = (0, $acw62.useState)(false);
    const [isParentChecked, setIsParentChecked] = (0, $acw62.useState)(false);
    const [showParentModal, setShowParentModal] = (0, $acw62.useState)(false);
    const [showAcceptWllModal, setShowAcceptAllModal] = (0, $acw62.useState)(false);
    const [showUpdateModal, setShowUpdateModal] = (0, $acw62.useState)(false);
    const [showRenewModal, setShowRenewModal] = (0, $acw62.useState)(false);
    const [consentIdListForAutoRenew, setConsentidListForAutoRenew] = (0, $acw62.useState)({});
    const [showConfirmationModal, setConfirmationModal] = (0, $acw62.useState)(false);
    const [activeModal, setActiveModal] = (0, $acw62.useState)(null);
    const [targetLanguage, setTargetLanguage] = (0, $acw62.useState)("");
    const [isDarkMode, setIsDarkMode] = (0, $acw62.useState)(false);
    const [parentCheckBox, setParentCheckBox] = (0, $acw62.useState)(false);
    const [showFilter, setShowFilter] = (0, $acw62.useState)(false);
    const [modalHeading, setModalHeading] = (0, $acw62.useState)("Manage Consent");
    const [activeBadge, setActiveBadge] = (0, $acw62.useState)("Always Active");
    const [ageSentence, setAgeSentence] = (0, $acw62.useState)("I am below 18 years of age");
    const [otherAccordionHeader, setOtherAccordionHeader] = (0, $acw62.useState)("Others");
    const [isOpenParent, setIsOpenParent] = (0, $acw62.useState)(false);
    const [selectedKYCMethod, setSelectedKYCMethod] = (0, $acw62.useState)("");
    const [searchText, setSearchText] = (0, $acw62.useState)("");
    const [pendingTranslationLang, setPendingTranslationLang] = (0, $acw62.useState)(null);
    const [filters, setFilters] = (0, $acw62.useState)({
        search: "",
        status: [],
        startDate: "",
        endDate: ""
    });
    const [withdrawConsentBtnText, setWithdrawConsentBtnText] = (0, $acw62.useState)("Withdraw Consent");
    const [updateConsentBtnText, setUpdateConsentBtnText] = (0, $acw62.useState)("Update Consent");
    const [renewConsentBtnText, setRenewConsentBtnText] = (0, $acw62.useState)("Renew");
    const [customerIdLabel, setCustomerIdLabel] = (0, $acw62.useState)("Customer ID");
    const [topDescription, setTopDescription] = (0, $acw62.useState)("");
    const [rightsDescription, setRightsDescription] = (0, $acw62.useState)("");
    const [permissionDescription, setPermissionDescription] = (0, $acw62.useState)("");
    const [requiredText, setRequiredText] = (0, $acw62.useState)("");
    const [prefereneceArray, setPreferenceArray] = (0, $acw62.useState)([]);
    const [selectedConsentId, setSelectedConsentId] = (0, $acw62.useState)("");
    const [selectedConsentStartDate, setSelectedConsentStartDate] = (0, $acw62.useState)("");
    const [selectedConsentHandleId, setSelectedConsentHandleId] = (0, $acw62.useState)("");
    const [selectedLanguagePreferences, setSelectedLanguagePreferences] = (0, $acw62.useState)("");
    const [selectedPrefereneces, setSelectedPreferences] = (0, $acw62.useState)({});
    const [listOfRenewPref, setListOfRenewPref] = (0, $acw62.useState)({});
    const [selectedPReferencesForRenewal, setSelectedPrefrenecesForRenewal] = (0, $acw62.useState)({});
    const [selectedConsentStatus, setSelectedConsentStatus] = (0, $acw62.useState)("");
    const [showREquiredDetails, setShowRequiredDetails] = (0, $acw62.useState)(true);
    const [showOhersDetails, setShowOthersDetails] = (0, $acw62.useState)(true);
    const [expandedRequiredItems, setExpandedRequiredItems] = (0, $acw62.useState)({});
    const [expandedOtherItems, setExpandedOtherItems] = (0, $acw62.useState)({});
    const [showLoader, setShowLoader] = (0, $acw62.useState)(false);
    const [lightTheme, setLightTheme] = (0, $acw62.useState)({});
    const [parentalControl, setParentalControl] = (0, $acw62.useState)(false);
    const [dataItemToBeShown, setDataItemToBeShown] = (0, $acw62.useState)(false);
    const [darkModeToBeShown, setDarkModeToBeShown] = (0, $acw62.useState)(false);
    const [validitytoBeShown, setValiditytoBeShown] = (0, $acw62.useState)(false);
    const [withdrawLoader, setWithdrawLoader] = (0, $acw62.useState)(false);
    const [updateLoader, setUpdateLoader] = (0, $acw62.useState)(false);
    const [renewLoader, setRenewLoader] = (0, $acw62.useState)(false);
    const [translationLoader, setTranslationLoader] = (0, $acw62.useState)(false);
    const [pageLoader, setPageLoader] = (0, $acw62.useState)(false);
    const [processActivityNameToBeShown, setProcessActivityNameToBeShown] = (0, $acw62.useState)(false);
    const [processorNameToBeShown, setProcessorNameToBeShown] = (0, $acw62.useState)(false);
    const [darkTheme, setDarkTheme] = (0, $acw62.useState)({});
    const [purposeLabel, setPurposeLabel] = (0, $acw62.useState)("Purpose");
    const [durationLabel, setDurationLabel] = (0, $acw62.useState)("Duration");
    const [usedbyLabel, setUsedByLabel] = (0, $acw62.useState)("Used by");
    const [dataItemLabel, setDataItemLabel] = (0, $acw62.useState)("Data item");
    const [dataTypeLabel, setDataTypeLabel] = (0, $acw62.useState)("Data type");
    const [processingActivityLabel, setProcessingActivityLabel] = (0, $acw62.useState)("Processing activity");
    const [withdrawCount, setWithdrawCount] = (0, $acw62.useState)(0);
    const [activeCount, setActiveCount] = (0, $acw62.useState)(0);
    const [expiredCount, setExpiredCount] = (0, $acw62.useState)(0);
    const [tableData, setTableData] = (0, $acw62.useState)([]);
    const [currentLangCode, setCurrentLangCode] = (0, $acw62.useState)("en"); // default English
    const currentLangRef = (0, $acw62.useRef)("en");
    const currentPageLoadRef = (0, $acw62.useRef)(0);
    const [dynamicTranslations, setDynamicTranslations] = (0, $acw62.useState)({}); // Store translated dynamic content
    const customerId = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.common.customer_id);
    const tntId = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.common.tenant_id);
    const businssId = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.common.business_id);
    const secureCode = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.common.secure_id);
    const portalTheme = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.common.portal_theme);
    const grievanceId = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.common.grievance_template_id);
    const parentalRedirectUrl = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.common.parental_redirect_url);
    // Translation hook for header language dropdown integration
    const translationInputs = (0, $acw62.useMemo)(()=>[
            {
                id: "fid_granted_consents",
                source: "Granted consents"
            },
            {
                id: "fid_consent_badge",
                source: "Consent"
            },
            {
                id: "fid_description",
                source: "View and respond to your consent requests awaiting your action."
            },
            {
                id: "fid_active",
                source: "Active"
            },
            {
                id: "fid_withdrawn",
                source: "Withdrawn"
            },
            {
                id: "fid_expired",
                source: "Expired"
            },
            {
                id: "fid_consent_id",
                source: "Consent ID"
            },
            {
                id: "fid_created_date",
                source: "Created date"
            },
            {
                id: "fid_expiry_date",
                source: "Expiry date"
            },
            {
                id: "fid_status",
                source: "Status"
            },
            {
                id: "fid_actions",
                source: "Actions"
            },
            {
                id: "fid_no_data",
                source: "No Data to Display"
            },
            {
                id: "fid_search_placeholder",
                source: "Search data item, type and purpose"
            },
            {
                id: "fid_page",
                source: "Page"
            },
            {
                id: "fid_of",
                source: "of"
            },
            {
                id: "fid_status_active",
                source: "ACTIVE"
            },
            {
                id: "fid_status_withdrawn",
                source: "WITHDRAWN"
            },
            {
                id: "fid_status_expired",
                source: "EXPIRED"
            },
            {
                id: "fid_status_pending",
                source: "PENDING"
            },
            // Expanded row labels
            {
                id: "fid_purpose_name",
                source: "Purpose Name"
            },
            {
                id: "fid_data_type",
                source: "Data type"
            },
            {
                id: "fid_data_item",
                source: "Data Item"
            },
            {
                id: "fid_data_used_by",
                source: "Data used by"
            },
            {
                id: "fid_pref_accepted",
                source: "ACCEPTED"
            },
            {
                id: "fid_pref_not_accepted",
                source: "NOTACCEPTED"
            },
            {
                id: "fid_data_status",
                source: "Status"
            }
        ], []);
    // Helper to translate dynamic status values
    const getTranslatedStatus = (status)=>{
        const statusMap = {
            ACTIVE: "fid_status_active",
            WITHDRAWN: "fid_status_withdrawn",
            EXPIRED: "fid_status_expired",
            PENDING: "fid_status_pending"
        };
        const translationId = statusMap[status?.toUpperCase()];
        return translationId ? getTranslation(translationId, status) : status;
    };
    // Helper to translate preference status values
    const getTranslatedPrefStatus = (status)=>{
        const statusMap = {
            ACCEPTED: "fid_pref_accepted",
            NOTACCEPTED: "fid_pref_not_accepted"
        };
        const translationId = statusMap[status?.toUpperCase()];
        return translationId ? getTranslation(translationId, status) : status;
    };
    // Helper to get dynamic translation with fallback
    const getDynamicTranslation = (text)=>{
        if (!text || currentLanguage === "ENGLISH") return text;
        return dynamicTranslations[text] || text;
    };
    // Function to translate dynamic table data
    const translateDynamicData = async (consents, targetLang)=>{
        if (!consents || consents.length === 0 || targetLang === "en") {
            setDynamicTranslations({});
            return;
        }
        // Collect all unique translatable text from consents
        const uniqueTexts = new Set();
        consents.forEach((consent)=>{
            consent.preferences?.forEach((pref)=>{
                pref.purposeList?.forEach((purpose)=>{
                    if (purpose.purposeInfo?.purposeName) uniqueTexts.add(purpose.purposeInfo.purposeName);
                });
                pref.processorActivityList?.forEach((pa)=>{
                    if (pa.processActivityInfo?.processorName) uniqueTexts.add(pa.processActivityInfo.processorName);
                    pa.processActivityInfo?.dataTypesList?.forEach((dt)=>{
                        if (dt.dataTypeName) uniqueTexts.add(dt.dataTypeName);
                        dt.dataItems?.forEach((item)=>uniqueTexts.add(item));
                    });
                });
            });
        });
        if (uniqueTexts.size === 0) return;
        // Create translation inputs
        const inputs = Array.from(uniqueTexts).map((text, idx)=>({
                id: `dynamic_${idx}`,
                source: text
            }));
        try {
            const response = await dispatch((0, $6eea01a75b53fee5$export$7d0f208153a27d67)("en", targetLang, inputs));
            if (response?.status === 200 && response?.data?.output) {
                const translatedMap = {};
                response.data.output.forEach((item, idx)=>{
                    const originalText = inputs[idx].source;
                    translatedMap[originalText] = item.target;
                });
                setDynamicTranslations(translatedMap);
            }
        } catch (error) {
            console.log("Error translating dynamic data:", error);
        }
    };
    const { getTranslation: getTranslation, translateContent: translateContent, currentLanguage: currentLanguage } = (0, $dbe8cedc9e1aa4ce$export$2e2bcd8739ae039)(translationInputs);
    // Sync with header language dropdown (static translations only)
    (0, $acw62.useEffect)(()=>{
        if (currentLanguage && currentLanguage !== "ENGLISH") {
            const targetLang = (0, $dbe8cedc9e1aa4ce$export$d340805709eeec9f)(currentLanguage);
            if (targetLang !== currentLangCode) {
                setCurrentLangCode(targetLang);
                translateContent(translationInputs, currentLanguage);
            }
        } else if (currentLanguage === "ENGLISH" && currentLangCode !== "en") {
            setCurrentLangCode("en");
            setDynamicTranslations({}); // Reset dynamic translations for English
        }
    }, [
        currentLanguage,
        currentLangCode,
        translationInputs,
        translateContent
    ]);
    var cusId;
    var tenantId;
    var businessId;
    var grievanceTemplateId;
    var scCode;
    var recievedCallBackUrl;
    const [allSelected, setAllSelected] = (0, $acw62.useState)(false);
    function isExpiringSoon(endDate) {
        const end = new Date(endDate);
        const today = new Date();
        // Difference in milliseconds
        const diffMs = end - today;
        // Convert to days
        const diffDays = diffMs / 86400000;
        return diffDays <= 30 && diffDays >= 0;
    }
    const formatToIST = (utcDateString)=>{
        const normalized = utcDateString.endsWith("Z") ? utcDateString : `${utcDateString}Z`;
        const date = new Date(normalized);
        return date.toLocaleString("en-IN", {
            timeZone: "Asia/Kolkata",
            hour12: false,
            year: "numeric",
            month: "short",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit"
        });
    };
    const [sessionExpired, setSessionExpired] = (0, $acw62.useState)(false);
    const [consentsByTempId, setConsentsByTempId] = (0, $acw62.useState)([]);
    // Translate dynamic table data when language or data changes
    (0, $acw62.useEffect)(()=>{
        if (currentLanguage && currentLanguage !== "ENGLISH" && consentsByTempId && consentsByTempId.length > 0) {
            const targetLang = (0, $dbe8cedc9e1aa4ce$export$d340805709eeec9f)(currentLanguage);
            translateDynamicData(consentsByTempId, targetLang);
        }
    }, [
        currentLanguage,
        consentsByTempId
    ]);
    const [currentPage, setCurrentPage] = (0, $acw62.useState)(1);
    const rowsPerPage = 10;
    var totalPages;
    var startIdx;
    var endIdx;
    var paginatedConsents;
    const [expandedRow, setExpandedRow] = (0, $acw62.useState)(null);
    const [loadLogs, setLoadLogs] = (0, $acw62.useState)(true);
    const [withdrawConsentLoader, setWithdrawConsentLoader] = (0, $acw62.useState)(false);
    const [documentName, setDocumentName] = (0, $acw62.useState)("");
    const [documentId, setDocumentId] = (0, $acw62.useState)("");
    const [logoUrl, setLogoUrl] = (0, $acw62.useState)("");
    const [linkFontColor, setLinkFont] = (0, $acw62.useState)("");
    const [selectedLang, setSelectedLang] = (0, $acw62.useState)("ENGLISH");
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    const [currentModalStep, setCurrentModalStep] = (0, $acw62.useState)(1);
    const activeTheme = isDarkMode ? darkTheme : lightTheme;
    const [parentName, setParentName] = (0, $acw62.useState)("");
    const [parentIdentity, setParentIdentity] = (0, $acw62.useState)("");
    const [otp, setOtp] = (0, $acw62.useState)("");
    const [digilockerClientId, setDigilockerClientId] = (0, $acw62.useState)("");
    const [digilockerClientSecret, setDigilockerClientSecret] = (0, $acw62.useState)("");
    const [digilockerCodeVerifier, setDigilockerCodeVerifier] = (0, $acw62.useState)("");
    const [digilockerRedirectUri, setDigilockerRedirectUri] = (0, $acw62.useState)("");
    const languages = [
        {
            value: "ENGLISH",
            label: "English",
            apiValue: "en"
        },
        {
            value: "HINDI",
            label: "Hindi",
            apiValue: "hi"
        },
        {
            value: "BENGALI",
            label: "Bengali",
            apiValue: "bn"
        },
        {
            value: "TAMIL",
            label: "Tamil",
            apiValue: "ta"
        },
        {
            value: "TELUGU",
            label: "Telugu",
            apiValue: "te"
        },
        {
            value: "KANNADA",
            label: "Kannada",
            apiValue: "kn"
        },
        {
            value: "MALAYALAM",
            label: "Malayalam",
            apiValue: "ml"
        },
        {
            value: "GUJARATI",
            label: "Gujarati",
            apiValue: "gu"
        },
        {
            value: "MARATHI",
            label: "Marathi",
            apiValue: "mr"
        },
        {
            value: "ODIA",
            label: "Odia",
            apiValue: "or"
        },
        {
            value: "PUNJABI",
            label: "Punjabi",
            apiValue: "pa"
        },
        {
            value: "ASSAMESE",
            label: "Assamese",
            apiValue: "as"
        },
        {
            value: "NEPALI",
            label: "Nepali",
            apiValue: "ne"
        },
        {
            value: "SINDHI",
            label: "Sindhi",
            apiValue: "sd"
        },
        {
            value: "KASHMIRI",
            label: "Kashmiri",
            apiValue: "ks"
        },
        {
            value: "DOGRI",
            label: "Dogri",
            apiValue: "doi"
        },
        {
            value: "KONKANI",
            label: "Konkani",
            apiValue: "gom"
        },
        {
            value: "MAITHILI",
            label: "Maithili",
            apiValue: "mai"
        },
        {
            value: "SANSKRIT",
            label: "Sanskrit",
            apiValue: "sa"
        },
        {
            value: "SANTALI",
            label: "Santali",
            apiValue: "sat"
        },
        {
            value: "BODO",
            label: "Bodo",
            apiValue: "brx"
        },
        {
            value: "MANIPURI",
            label: "Manipuri",
            apiValue: "mni"
        }
    ];
    const generateAutoRenewStatus = (consentsByTemplateId)=>{
        const result = {};
        consentsByTemplateId.forEach((consent)=>{
            let isExpiring = false;
            consent.preferences.forEach((pref)=>{
                if (pref.autoRenew) {
                    const remainingDays = calculateValidityInDays(pref.endDate);
                    if (!isNaN(remainingDays) && remainingDays < 30) isExpiring = true;
                }
            });
            result[consent.consentId] = isExpiring;
        });
        setConsentidListForAutoRenew(result);
    };
    function closeParentModal() {
        setShowParentModal(false);
        function closeParentModal() {
            setShowParentModal(false);
            setIsParentChecked(false);
            setCurrentModalStep(1);
            setSelectedKYCMethod(null);
            if (parentNameRef.current) parentNameRef.current.value = "";
            if (parentIdentityRef.current) parentIdentityRef.current.value = "";
            if (otpRef.current) otpRef.current.value = "";
        }
        setCurrentModalStep(1);
        setSelectedKYCMethod(null);
        if (parentNameRef.current) parentNameRef.current.value = "";
        if (parentIdentityRef.current) parentIdentityRef.current.value = "";
        if (otpRef.current) otpRef.current.value = "";
    }
    async function generateCodeChallenge(codeVerifier) {
        const encoder = new TextEncoder();
        const data = encoder.encode(codeVerifier);
        const hashBuffer = await crypto.subtle.digest("SHA-256", data);
        const base64Hash = btoa(String.fromCharCode(...new Uint8Array(hashBuffer))).replace(/\+/g, "-") // replace '+' with '-'
        .replace(/\//g, "_") // replace '/' with '_'
        .replace(/=+$/, ""); // remove '=' padding
        return base64Hash;
    }
    const generateConsentMetaId = async ()=>{
        try {
            let response = await dispatch((0, $6eea01a75b53fee5$export$f71b29283611213f)(selectedConsentHandleId, selectedLanguagePreferences, selectedPrefereneces));
            return response?.data?.consentMetaId;
        } catch (error) {
            console.log("Error in generating consentMetaId", error);
            throw error;
        }
    };
    const checkParentKYC = (checked)=>{
        if (parentCheckBox) {
            (0, $b00d3e7401eac195$export$b410431fab84fa58).error((props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482ccd6e8e9b33b1$export$2e2bcd8739ae039), {
                    ...props,
                    type: "error",
                    message: "KYC for this customer id is already done."
                }), {
                icon: false
            });
            return;
        } else {
            setIsParentChecked(checked);
            if (checked) {
                setShowParentModal(true);
                setShowUpdateModal(false);
            } else {
                closeParentModal();
                setShowUpdateModal(true);
            }
        }
    };
    const openDocument = async ()=>{
        try {
            const blob = await dispatch((0, $6eea01a75b53fee5$export$5aa62db8a1a167b3)(documentId));
            const pdfUrl = URL.createObjectURL(blob);
            if (pdfUrl) window.open(pdfUrl, "_blank");
            else (0, $b00d3e7401eac195$export$b410431fab84fa58).error((props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482ccd6e8e9b33b1$export$2e2bcd8739ae039), {
                    ...props,
                    type: "error",
                    message: "Error Occurred while fetching document"
                }), {
                icon: false
            });
        } catch (err) {
            console.log("Error opening document:", err);
        }
    };
    const withdrawConsent = async ()=>{
        setWithdrawLoader(true);
        // const filteredPreferences = Object.fromEntries(
        //   Object.entries(selectedPrefereneces).filter(
        //     ([_, value]) => value === "ACCEPTED"
        //   )
        // );
        try {
            let status = "WITHDRAWN";
            let res = await dispatch((0, $6eea01a75b53fee5$export$12697f183ed46e90)(selectedConsentId, selectedLang, selectedPrefereneces, status));
            if (res?.status === 202) {
                (0, $b00d3e7401eac195$export$b410431fab84fa58).success((props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482ccd6e8e9b33b1$export$2e2bcd8739ae039), {
                        ...props,
                        type: "success",
                        message: "Consent withdrawn successfully!"
                    }), {
                    icon: false
                });
                currentLangRef.current = "en";
                setShowModal(false);
                setShowUpdateModal(false);
                setConfirmationModal(false);
                setWithdrawLoader(false);
                setTimeout(()=>{
                    window.location.reload();
                }, 3000);
            } else {
                (0, $b00d3e7401eac195$export$b410431fab84fa58).error((props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482ccd6e8e9b33b1$export$2e2bcd8739ae039), {
                        ...props,
                        type: "error",
                        message: "Failed to withdraw consent. Please try again."
                    }), {
                    icon: false
                });
                setWithdrawLoader(false);
                return;
            }
        } catch (err) {
            console.log("Withdraw API failed:", err);
            (0, $b00d3e7401eac195$export$b410431fab84fa58).error((props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482ccd6e8e9b33b1$export$2e2bcd8739ae039), {
                    ...props,
                    type: "error",
                    message: "An error occurred while withdrawing consent."
                }), {
                icon: false
            });
            setWithdrawLoader(false);
            return;
        }
    };
    const handleConfirm = ()=>{
        setShowModal(false);
        setConfirmationModal(true);
        setActiveModal("withdraw");
    };
    const handleUpdateConfirm = ()=>{
        setShowUpdateModal(false);
        setConfirmationModal(true);
        setActiveModal("update");
    };
    const updateConsent = async ()=>{
        try {
            setUpdateLoader(true);
            let status = "ACTIVE";
            let filteredPreferences = {};
            filteredPreferences = Object.fromEntries(Object.entries(selectedPrefereneces).filter(([_, value])=>value === "ACCEPTED"));
            if (Object.keys(filteredPreferences).length === 0) filteredPreferences = Object.fromEntries(Object.entries(selectedPrefereneces).map(([key, _])=>[
                    key,
                    "NOTACCEPTED"
                ]));
            let res = await dispatch((0, $6eea01a75b53fee5$export$12697f183ed46e90)(selectedConsentId, selectedLang, filteredPreferences, status));
            if (res?.status === 202) {
                (0, $b00d3e7401eac195$export$b410431fab84fa58).success((props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482ccd6e8e9b33b1$export$2e2bcd8739ae039), {
                        ...props,
                        type: "success",
                        message: "Consent updated successfully!"
                    }), {
                    icon: false
                });
                currentLangRef.current = "en";
                setShowModal(false);
                setShowUpdateModal(false);
                setConfirmationModal(false);
                setUpdateLoader(false);
                setTimeout(()=>{
                    window.location.reload();
                }, 3000);
            } else {
                (0, $b00d3e7401eac195$export$b410431fab84fa58).error((props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482ccd6e8e9b33b1$export$2e2bcd8739ae039), {
                        ...props,
                        type: "error",
                        message: "Failed to update consent. Please try again."
                    }), {
                    icon: false
                });
                setUpdateLoader(false);
                return;
            }
        } catch (err) {
            console.log("Withdraw API failed:", err);
            (0, $b00d3e7401eac195$export$b410431fab84fa58).error((props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482ccd6e8e9b33b1$export$2e2bcd8739ae039), {
                    ...props,
                    type: "error",
                    message: "An error occurred while updating consent."
                }), {
                icon: false
            });
            setUpdateLoader(false);
            return;
        }
    };
    const renewConsent = async ()=>{
        try {
            setRenewLoader(true);
            const selectedRenewIds = Object.keys(listOfRenewPref).filter((id)=>listOfRenewPref[id] === "RENEW");
            if (selectedRenewIds.length === 0) {
                (0, $b00d3e7401eac195$export$b410431fab84fa58).error((props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482ccd6e8e9b33b1$export$2e2bcd8739ae039), {
                        ...props,
                        type: "error",
                        message: "Please select at least one purpose for renewal."
                    }), {
                    icon: false
                });
                setRenewLoader(false);
                return;
            }
            const updatedPreferences = {
                ...selectedPReferencesForRenewal
            };
            selectedRenewIds.forEach((id)=>{
                updatedPreferences[id] = "RENEW";
            });
            const res = await dispatch((0, $6eea01a75b53fee5$export$12697f183ed46e90)(selectedConsentId, selectedLang, updatedPreferences, "ACTIVE"));
            if (res?.status === 202) {
                (0, $b00d3e7401eac195$export$b410431fab84fa58).success((props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482ccd6e8e9b33b1$export$2e2bcd8739ae039), {
                        ...props,
                        type: "success",
                        message: "Consent renewed successfully!"
                    }), {
                    icon: false
                });
                setShowRenewModal(false);
                setRenewLoader(false);
                setTimeout(()=>{
                    window.location.reload();
                }, 3000);
            } else {
                (0, $b00d3e7401eac195$export$b410431fab84fa58).error((props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482ccd6e8e9b33b1$export$2e2bcd8739ae039), {
                        ...props,
                        type: "error",
                        message: "Failed to renew consent. Please try again."
                    }), {
                    icon: false
                });
                setRenewLoader(false);
            }
        } catch (err) {
            console.log("Renew API failed:", err);
            (0, $b00d3e7401eac195$export$b410431fab84fa58).error((props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482ccd6e8e9b33b1$export$2e2bcd8739ae039), {
                    ...props,
                    type: "error",
                    message: "An error occurred while updating consent."
                }), {
                icon: false
            });
            setRenewLoader(false);
        }
    };
    const handleUpdateConsent = ()=>{
        updateConsent();
    };
    const handleRenewConsent = ()=>{
        renewConsent();
    };
    const handleConfirmationModalClose = ()=>{
        if (activeModal === "withdraw") setShowModal(true);
        if (activeModal === "update") setShowUpdateModal(true);
        setConfirmationModal(false);
    };
    const closeWithdrawConsentModal = ()=>{
        currentLangRef.current = "en";
        setShowModal(false);
        setLightTheme({});
        setIsDarkMode(false);
        setSelectedLang("ENGLISH");
        setCustomerIdLabel("Customer ID");
        setActiveBadge("Always Active");
        setOtherAccordionHeader("Others");
        setPurposeLabel("");
        setPurposeLabel("Purpose");
        setDurationLabel("Duration");
        setUsedByLabel("Used by");
        setDataItemLabel("Data item");
        setDataTypeLabel("Data type");
        setModalHeading("Manage Consent");
        setProcessingActivityLabel("Processing activity");
        setWithdrawConsentBtnText("Withdraw Consent");
        setUpdateConsentBtnText("Update Consent");
        setDocumentName("");
        setAgeSentence("I am below 18 years of age");
    };
    const callBhashiniAPI = async (lang)=>{
        if (currentPageLoadRef.current == 1) {
            setPageLoader(true);
            currentPageLoadRef.current = 0;
        } else setTranslationLoader(true);
        const options = [
            {
                value: "ENGLISH",
                label: "English",
                apiValue: "en"
            },
            {
                value: "HINDI",
                label: "Hindi",
                apiValue: "hi"
            },
            {
                value: "BENGALI",
                label: "Bengali",
                apiValue: "bn"
            },
            {
                value: "TAMIL",
                label: "Tamil",
                apiValue: "ta"
            },
            {
                value: "TELUGU",
                label: "Telugu",
                apiValue: "te"
            },
            {
                value: "KANNADA",
                label: "Kannada",
                apiValue: "kn"
            },
            {
                value: "MALAYALAM",
                label: "Malayalam",
                apiValue: "ml"
            },
            {
                value: "GUJARATI",
                label: "Gujarati",
                apiValue: "gu"
            },
            {
                value: "MARATHI",
                label: "Marathi",
                apiValue: "mr"
            },
            {
                value: "ODIA",
                label: "Odia",
                apiValue: "or"
            },
            {
                value: "PUNJABI",
                label: "Punjabi",
                apiValue: "pa"
            },
            {
                value: "ASSAMESE",
                label: "Assamese",
                apiValue: "as"
            },
            {
                value: "NEPALI",
                label: "Nepali",
                apiValue: "ne"
            },
            {
                value: "SINDHI",
                label: "Sindhi",
                apiValue: "sd"
            },
            {
                value: "KASHMIRI",
                label: "Kashmiri",
                apiValue: "ks"
            },
            {
                value: "DOGRI",
                label: "Dogri",
                apiValue: "doi"
            },
            {
                value: "KONKANI",
                label: "Konkani",
                apiValue: "gom"
            },
            {
                value: "MAITHILI",
                label: "Maithili",
                apiValue: "mai"
            },
            {
                value: "SANSKRIT",
                label: "Sanskrit",
                apiValue: "sa"
            },
            {
                value: "SANTALI",
                label: "Santali",
                apiValue: "sat"
            },
            {
                value: "BODO",
                label: "Bodo",
                apiValue: "brx"
            },
            {
                value: "MANIPURI",
                label: "Manipuri",
                apiValue: "mni"
            }
        ];
        function toText(value) {
            if (Array.isArray(value)) return value.join(", ");
            else if (typeof value === "object" && value !== null) {
                if ("value" in value && "unit" in value) return `${value.value} ${value.unit}`;
                return JSON.stringify(value);
            } else return value;
        }
        const selectedOption = options.find((opt)=>opt.value === lang);
        const targetLang = selectedOption ? selectedOption.apiValue : "";
        setTargetLanguage(targetLang);
        console.log("Target language for translation:", targetLang);
        if (currentLangRef.current === targetLang) {
            setPageLoader(false);
            setTranslationLoader(false);
            if (modalRef.current === "view") setShowModal(true);
            if (modalRef.current === "edit") setShowUpdateModal(true);
            if (modalRef.current === "renew") setShowRenewModal(true);
            return;
        }
        const staticInputs = [
            {
                id: "topDesc",
                source: topDescription
            },
            {
                id: "permissionDesc",
                source: permissionDescription
            },
            {
                id: "rightsDesc",
                source: rightsDescription
            },
            {
                id: "parentCheck",
                source: ageSentence
            },
            {
                id: "updateConsent",
                source: updateConsentBtnText
            },
            {
                id: "withdrawConsent",
                source: withdrawConsentBtnText
            },
            {
                id: "renewConsent",
                source: renewConsentBtnText
            },
            {
                id: "badge",
                source: activeBadge
            },
            {
                id: "requiredHeader",
                source: requiredText
            },
            {
                id: "othersHeader",
                source: otherAccordionHeader
            },
            {
                id: "customerId",
                source: customerIdLabel
            },
            {
                id: "modalHeading",
                source: modalHeading
            },
            {
                id: "documentTitle",
                source: documentName
            },
            // { id: "click", source: "click here" },
            // add label translations
            {
                id: "Purpose",
                source: purposeLabel
            },
            {
                id: "Data item",
                source: dataItemLabel
            },
            {
                id: "Processing activity",
                source: processingActivityLabel
            },
            {
                id: "Used by",
                source: usedbyLabel
            },
            {
                id: "Duration",
                source: durationLabel
            },
            {
                id: "Data type",
                source: dataTypeLabel
            },
            {
                id: "Id",
                source: "Id"
            }
        ];
        const dynamicInputs = formData.map((item, index)=>{
            const reqNo = index + 1;
            // Replace flatMap → map + reduce
            const processorActivityInputs = item.processorActivities.map((activity, actIdx)=>{
                const dataTypeInputs = activity.dataTypes.map((dt, dtIdx)=>({
                        id: `dataTypeName_req_${reqNo}_${actIdx}_${dtIdx}`,
                        source: dt.dataTypeName
                    }));
                return [
                    {
                        id: `activityName_req_${reqNo}_${actIdx}`,
                        source: toText(activity.activityName)
                    },
                    {
                        id: `processorName_req_${reqNo}_${actIdx}`,
                        source: toText(activity.processorName)
                    },
                    ...activity.dataTypes.map((dt, dtIdx)=>({
                            id: `dataItems_req_${reqNo}_${actIdx}_${dtIdx}`,
                            source: toText(dt.dataItems)
                        })),
                    // <-- add datatype names here
                    ...dataTypeInputs
                ];
            }).reduce((acc, curr)=>acc.concat(curr), []);
            return [
                {
                    id: `purpose_req_${reqNo}`,
                    source: toText(item.purpose)
                },
                {
                    id: `usedBy_req_${reqNo}`,
                    source: toText(item.usedBy)
                },
                {
                    id: `duration_req_${reqNo}`,
                    source: toText(item.duration)
                },
                {
                    id: `id_req_${reqNo}`,
                    source: item.id
                },
                ...processorActivityInputs
            ];
        }).reduce((acc, curr)=>acc.concat(curr), []);
        const dynamicInputs2 = formOtherData.map((item, index)=>{
            const reqNo = index + 1;
            const processorActivityInputs = item.processorActivities.map((activity, actIdx)=>{
                // Add datatype names (same as main list)
                const dataTypeInputs = activity.dataTypes.map((dt, dtIdx)=>({
                        id: `dataTypeName_otr_${reqNo}_${actIdx}_${dtIdx}`,
                        source: dt.dataTypeName
                    }));
                return [
                    {
                        id: `activityName_otr_${reqNo}_${actIdx}`,
                        source: toText(activity.activityName)
                    },
                    {
                        id: `processorName_otr_${reqNo}_${actIdx}`,
                        source: toText(activity.processorName)
                    },
                    ...activity.dataTypes.map((dt, dtIdx)=>({
                            id: `dataItems_otr_${reqNo}_${actIdx}_${dtIdx}`,
                            source: toText(dt.dataItems)
                        })),
                    // Add datatype inputs here (same as req version)
                    ...dataTypeInputs
                ];
            }).reduce((acc, curr)=>acc.concat(curr), []); // flatten
            return [
                {
                    id: `purpose_otr_${reqNo}`,
                    source: toText(item.purpose)
                },
                {
                    id: `usedBy_otr_${reqNo}`,
                    source: toText(item.usedBy)
                },
                {
                    id: `duration_otr_${reqNo}`,
                    source: toText(item.duration)
                },
                {
                    id: `id_otr_${reqNo}`,
                    source: item.id
                },
                ...processorActivityInputs
            ];
        }).reduce((acc, curr)=>acc.concat(curr), []);
        const finalInputs = [
            ...staticInputs,
            ...dynamicInputs,
            ...dynamicInputs2
        ];
        let response;
        try {
            response = await dispatch((0, $6eea01a75b53fee5$export$7d0f208153a27d67)(currentLangRef.current, targetLang, finalInputs));
        } catch (translationError) {
            // Translation service (Bhashini) failed — fall back to the already
            // loaded default-language content and still open the modal instead of
            // throwing an unhandled rejection.
            console.log("Translation failed, showing default language:", translationError);
            setTranslationLoader(false);
            setPageLoader(false);
            (0, $b00d3e7401eac195$export$b410431fab84fa58).error((props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482ccd6e8e9b33b1$export$2e2bcd8739ae039), {
                    ...props,
                    type: "error",
                    message: "Translation service is unavailable. Showing content in the default language."
                }), {
                icon: false
            });
            if (modalRef.current === "view") setShowModal(true);
            if (modalRef.current === "edit") setShowUpdateModal(true);
            if (modalRef.current === "renew") setShowRenewModal(true);
            return;
        }
        setTranslationLoader(false);
        setPageLoader(false);
        const data2 = await response?.data;
        currentLangRef.current = targetLang;
        console.log("current Lang code after translation", currentLangCode);
        const purposeText = data2.output.find((o)=>o.id === "Purpose")?.target || "topDescription";
        setPurposeLabel(purposeText);
        const dataItemText = data2.output.find((o)=>o.id === "Data item")?.target || "topDescription";
        setDataItemLabel(dataItemText);
        const dataTypeText = data2.output.find((o)=>o.id === "Data type")?.target || "topDescription";
        setDataTypeLabel(dataTypeText);
        const processingActivityText = data2.output.find((o)=>o.id === "Processing activity")?.target || "topDescription";
        setProcessingActivityLabel(processingActivityText);
        const usedByText = data2.output.find((o)=>o.id === "Used by")?.target || "topDescription";
        setUsedByLabel(usedByText);
        const durationText = data2.output.find((o)=>o.id === "Duration")?.target || "topDescription";
        setDurationLabel(durationText);
        const topDesc = data2.output.find((o)=>o.id === null)?.target || data2.output.find((o)=>o.id === "topDesc")?.target || "topDescription";
        setTopDescription(topDesc);
        const pDesc = data2.output.find((o)=>o.id === "permissionDesc")?.target || "Description";
        setPermissionDescription(pDesc);
        const rDesc = data2.output.find((o)=>o.id === "rightsDesc")?.target || "Description";
        setRightsDescription(rDesc);
        const docName = data2.output.find((o)=>o.id === "documentTitle")?.target || "topDescription";
        setDocumentName(docName);
        const cus = data2.output.find((o)=>o.id === "customerId")?.target || "Description";
        setCustomerIdLabel(cus);
        const heading = data2.output.find((o)=>o.id === "modalHeading")?.target || "Description";
        setModalHeading(heading);
        const badgeLabel = data2.output.find((o)=>o.id === "badge")?.target || "Description";
        setActiveBadge(badgeLabel);
        const reqLabel = data2.output.find((o)=>o.id === "requiredHeader")?.target || "Description";
        setRequiredText(reqLabel);
        const otrLabel = data2.output.find((o)=>o.id === "othersHeader")?.target || "Description";
        setOtherAccordionHeader(otrLabel);
        const ageDesc = data2.output.find((o)=>o.id === "parentCheck")?.target || "Description";
        setAgeSentence(ageDesc);
        const wconsent = data2.output.find((o)=>o.id === "withdrawConsent")?.target || "Description";
        setWithdrawConsentBtnText(wconsent);
        const renewText = data2.output.find((o)=>o.id === "renewConsent")?.target || "Description";
        setRenewConsentBtnText(renewText);
        const upconsent = data2.output.find((o)=>o.id === "updateConsent")?.target || "Description";
        setUpdateConsentBtnText(upconsent);
        const translatedTemplateList = formData.map((item, index)=>{
            const reqNo = index + 1;
            const getTranslated = (id)=>data2.output.find((o)=>o.id === id)?.target?.trim() || null; // return null instead of ""
            const translatedProcessorActivities = item.processorActivities.map((activity, actIdx)=>{
                const translatedActivityName = getTranslated(`activityName_req_${reqNo}_${actIdx}`) || activity.activityName;
                const translatedProcessorName = getTranslated(`processorName_req_${reqNo}_${actIdx}`) || activity.processorName;
                // Translate dataTypes
                const translatedDataTypes = activity.dataTypes.map((dt, dtIdx)=>{
                    const dtNameId = `dataTypeName_req_${reqNo}_${actIdx}_${dtIdx}`;
                    const translatedDataTypeName = getTranslated(dtNameId) || dt.dataTypeName;
                    // FIX: translate whole list at once
                    const dataItemsId = `dataItems_req_${reqNo}_${actIdx}_${dtIdx}`;
                    const translatedItemsString = getTranslated(dataItemsId);
                    const translatedDataItems = translatedItemsString ? translatedItemsString.split(",").map((i)=>i.trim()) : dt.dataItems;
                    return {
                        dataTypeName: translatedDataTypeName,
                        dataItems: translatedDataItems
                    };
                });
                return {
                    activityName: translatedActivityName,
                    processorName: translatedProcessorName,
                    dataTypes: translatedDataTypes
                };
            });
            return {
                purpose: [
                    getTranslated(`purpose_req_${reqNo}`) || item.purpose.join(", ")
                ],
                usedBy: [
                    getTranslated(`usedBy_req_${reqNo}`) || item.usedBy.join(", ")
                ],
                duration: {
                    value: getTranslated(`duration_req_${reqNo}`)?.split(" ")[0] || item.duration.value,
                    unit: getTranslated(`duration_req_${reqNo}`)?.split(" ")[1] || item.duration.unit
                },
                processorActivities: translatedProcessorActivities,
                id: item.id,
                status: item.status
            };
        });
        const translatedTemplateList2 = formOtherData.map((item, index)=>{
            const reqNo = index + 1;
            const getTranslated = (id)=>data2.output.find((o)=>o.id === id)?.target?.trim() || null;
            const translatedProcessorActivities = item.processorActivities.map((activity, actIdx)=>{
                const translatedActivityName = getTranslated(`activityName_otr_${reqNo}_${actIdx}`) || activity.activityName;
                const translatedProcessorName = getTranslated(`processorName_otr_${reqNo}_${actIdx}`) || activity.processorName;
                // Translate data types
                const translatedDataTypes = activity.dataTypes.map((dt, dtIdx)=>{
                    const dtNameId = `dataTypeName_otr_${reqNo}_${actIdx}_${dtIdx}`;
                    const translatedDataTypeName = getTranslated(dtNameId) || dt.dataTypeName;
                    // FIX: translate entire dataItems list at once
                    const dataItemsId = `dataItems_otr_${reqNo}_${actIdx}_${dtIdx}`;
                    const translatedItemsString = getTranslated(dataItemsId);
                    const translatedDataItems = translatedItemsString ? translatedItemsString.split(",").map((i)=>i.trim()) : dt.dataItems;
                    return {
                        dataTypeName: translatedDataTypeName,
                        dataItems: translatedDataItems
                    };
                });
                return {
                    activityName: translatedActivityName,
                    processorName: translatedProcessorName,
                    dataTypes: translatedDataTypes
                };
            });
            return {
                purpose: [
                    getTranslated(`purpose_otr_${reqNo}`) || item.purpose.join(", ")
                ],
                usedBy: [
                    getTranslated(`usedBy_otr_${reqNo}`) || item.usedBy.join(", ")
                ],
                duration: {
                    value: getTranslated(`duration_otr_${reqNo}`)?.split(" ")[0] || item.duration.value,
                    unit: getTranslated(`duration_otr_${reqNo}`)?.split(" ")[1] || item.duration.unit
                },
                processorActivities: translatedProcessorActivities,
                id: item.id,
                status: item.status
            };
        });
        setFormData(translatedTemplateList);
        setformOtherData(translatedTemplateList2);
        if (modalRef.current === "view") setShowModal(true);
        if (modalRef.current === "edit") setShowUpdateModal(true);
        if (modalRef.current === "renew") setShowRenewModal(true);
    };
    const handleLanguageChange = (e)=>{
        const lang = e.target.value;
        setSelectedLang(lang);
        callBhashiniAPI(lang);
    };
    const closeEditConsentModal = ()=>{
        currentLangRef.current = "en";
        setShowUpdateModal(false);
        setLightTheme({});
        setIsDarkMode(false);
        setSelectedLang("ENGLISH");
        setCustomerIdLabel("Customer ID");
        setActiveBadge("Always Active");
        setOtherAccordionHeader("Others");
        setPurposeLabel("");
        setPurposeLabel("Purpose");
        setDurationLabel("Duration");
        setUsedByLabel("Used by");
        setDataItemLabel("Data item");
        setDataTypeLabel("Data type");
        setProcessingActivityLabel("Processing activity");
        setWithdrawConsentBtnText("Withdraw Consent");
        setUpdateConsentBtnText("Update Consent");
        setModalHeading("Manage Consent");
        setAgeSentence("I am below 18 years of age");
        setDocumentName("");
    };
    const closeRenewConsentModal = ()=>{
        currentLangRef.current = "en";
        setShowRenewModal(false);
        setLightTheme({});
        setIsDarkMode(false);
        setSelectedLang("ENGLISH");
        setCustomerIdLabel("Customer ID");
        setActiveBadge("Always Active");
        setOtherAccordionHeader("Others");
        setPurposeLabel("");
        setPurposeLabel("Purpose");
        setDurationLabel("Duration");
        setUsedByLabel("Used by");
        setDataItemLabel("Data item");
        setDataTypeLabel("Data type");
        setProcessingActivityLabel("Processing activity");
        setWithdrawConsentBtnText("Withdraw Consent");
        setUpdateConsentBtnText("Update Consent");
        setModalHeading("Manage Consent");
        setRenewConsentBtnText("Renew");
        setAgeSentence("I am below 18 years of age");
        setDocumentName("");
    };
    const downloadConsentExcel = (consentsByTempId)=>{
        try {
            const wb = $4249f69807f0687b$exports.utils.book_new();
            const ws_data = [];
            consentsByTempId.forEach((consent)=>{
                ws_data.push([
                    "Consent ID",
                    "Created Date",
                    "Expiry Date",
                    "Status",
                    "Action"
                ]);
                ws_data.push([
                    consent.consentId || "",
                    formatToIST(consent.startDate),
                    formatToIST(consent.endDate),
                    consent.status || "",
                    ""
                ]);
                ws_data.push([]);
                ws_data.push([
                    "Purpose Name",
                    "Data Type",
                    "Data Item",
                    "Data Used By",
                    "Preference Status"
                ]);
                consent.preferences?.forEach((pref)=>{
                    pref.purposeList?.forEach((purpose)=>{
                        const dataTypes = pref.processorActivityList?.flatMap((pa)=>pa.processActivityInfo.dataTypesList.map((dt)=>dt.dataTypeName))?.join(", ") || "";
                        const dataItems = pref.processorActivityList?.flatMap((pa)=>pa.processActivityInfo.dataTypesList.flatMap((dt)=>dt.dataItems))?.join(", ") || "";
                        const processors = pref.processorActivityList?.map((pa)=>pa.processActivityInfo.processorName)?.join(", ") || "";
                        ws_data.push([
                            purpose.purposeInfo?.purposeName || "",
                            dataTypes,
                            dataItems,
                            processors,
                            pref.preferenceStatus || ""
                        ]);
                    });
                });
                ws_data.push([]);
                ws_data.push([]);
            });
            const ws = $4249f69807f0687b$exports.utils.aoa_to_sheet(ws_data);
            ws["!cols"] = [
                {
                    wch: 30
                },
                {
                    wch: 20
                },
                {
                    wch: 20
                },
                {
                    wch: 25
                },
                {
                    wch: 20
                }
            ];
            const borderStyle = {
                top: {
                    style: "thin",
                    color: {
                        rgb: "CCCCCC"
                    }
                },
                bottom: {
                    style: "thin",
                    color: {
                        rgb: "CCCCCC"
                    }
                },
                left: {
                    style: "thin",
                    color: {
                        rgb: "CCCCCC"
                    }
                },
                right: {
                    style: "thin",
                    color: {
                        rgb: "CCCCCC"
                    }
                }
            };
            const range = $4249f69807f0687b$exports.utils.decode_range(ws["!ref"]);
            for(let R = range.s.r; R <= range.e.r; ++R){
                const row = ws_data[R];
                if (!row) continue;
                for(let C = 0; C < row.length; ++C){
                    const cellRef = $4249f69807f0687b$exports.utils.encode_cell({
                        r: R,
                        c: C
                    });
                    const cell = ws[cellRef];
                    if (!cell) continue;
                    cell.s = cell.s || {};
                    cell.s.border = borderStyle;
                    cell.s.alignment = {
                        vertical: "center",
                        wrapText: true
                    };
                }
                if (row[0] === "Consent ID") for(let C = 0; C < row.length; ++C){
                    const cellRef = $4249f69807f0687b$exports.utils.encode_cell({
                        r: R,
                        c: C
                    });
                    const cell = ws[cellRef];
                    if (!cell) continue;
                    cell.s = {
                        font: {
                            bold: true,
                            color: {
                                rgb: "FFFFFF"
                            }
                        },
                        fill: {
                            fgColor: {
                                rgb: "4472C4"
                            }
                        },
                        alignment: {
                            horizontal: "center",
                            vertical: "center"
                        },
                        border: borderStyle
                    };
                }
                if (row[0] === "Purpose Name") for(let C = 0; C < row.length; ++C){
                    const cellRef = $4249f69807f0687b$exports.utils.encode_cell({
                        r: R,
                        c: C
                    });
                    const cell = ws[cellRef];
                    if (!cell) continue;
                    cell.s = {
                        font: {
                            bold: true,
                            color: {
                                rgb: "FFFFFF"
                            }
                        },
                        fill: {
                            fgColor: {
                                rgb: "808080"
                            }
                        },
                        alignment: {
                            horizontal: "center",
                            vertical: "center"
                        },
                        border: borderStyle
                    };
                }
            }
            $4249f69807f0687b$exports.utils.book_append_sheet(wb, ws, "Consent Logs");
            const wbout = $4249f69807f0687b$exports.write(wb, {
                bookType: "xlsx",
                type: "array"
            });
            const blob = new Blob([
                wbout
            ], {
                type: "application/octet-stream"
            });
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "Consent_Report.xlsx";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        } catch (err) {
            console.log("Excel download failed:", err);
        }
    };
    // const templateId = "7387531101";
    const params = new URLSearchParams(window.location.search);
    const encodedData = params.get("customerDetails");
    if (encodedData) try {
        const decoded = atob(encodedData);
        const parsed = JSON.parse(decoded);
        cusId = parsed.cusId || customerId;
        tenantId = parsed.tenantId || tntId;
        businessId = parsed.businessId || businssId;
        scCode = parsed.secureCode || secureCode;
        grievanceTemplateId = parsed.grievanceTemplateId || grievanceId;
        recievedCallBackUrl = parsed.callBackUrl || parentalRedirectUrl;
        dispatch((0, $6eea01a75b53fee5$export$530d27bddecbf714)(cusId, tenantId, businessId, grievanceTemplateId, scCode, recievedCallBackUrl));
    } catch (err) {
        console.log("Error decoding Base64 data param:", err);
    }
    else {
        cusId = customerId;
        tenantId = tntId;
        businessId;
        grievanceTemplateId = grievanceId;
        scCode = secureCode;
    }
    const calculateValidityInDays = (endDateString)=>{
        // Convert "23 Nov 2025, 18:25:39" into valid Date
        endDateString = formatToIST(endDateString);
        const endDate = new Date(endDateString);
        const now = new Date();
        const diffMs = endDate - now;
        const remainingDays = Math.ceil(diffMs / 86400000);
        return remainingDays;
    };
    const transformConsentData = (apiResponse)=>{
        const data = Array.isArray(apiResponse) ? apiResponse[0] : apiResponse;
        if (!data || !data.preferences) return {
            mandatory: [],
            others: []
        };
        const mandatory = [];
        const others = [];
        const preferencesStatus = {};
        data.preferences.forEach((pref)=>{
            const purpose = pref.purposeList.map((p)=>p?.purposeInfo?.purposeName).filter(Boolean);
            if (purpose.length === 0) throw new Error("Invalid purpose data");
            const rawUnit = pref?.preferenceValidity?.unit || "";
            console.log("Raw duration unit:", String(rawUnit));
            if (rawUnit === "") throw new Error("Missing duration unit");
            const processedUnit = pref?.preferenceValidity?.value === 1 ? rawUnit.toLowerCase().replace(/s$/, "") : rawUnit.toLowerCase();
            // Capitalize first letter
            const capitalizedUnit = processedUnit.charAt(0).toUpperCase() + processedUnit.slice(1);
            const duration = {
                value: pref?.preferenceValidity?.value ?? "",
                unit: capitalizedUnit
            };
            const usedBy = pref.processorActivityList.map((p)=>p?.processActivityInfo?.processorName).filter(Boolean);
            if (usedBy.length === 0) throw new Error("Invalid processor data");
            const dataItems = pref.processorActivityList.flatMap((p)=>p?.processActivityInfo?.dataTypesList.flatMap((d)=>d.dataItems)).filter(Boolean);
            if (dataItems.length === 0) throw new Error("Invalid data items");
            const processorActivities = (pref.processorActivityList || []).map((p)=>{
                const activityName = p?.processActivityInfo?.activityName;
                const processorName = p?.processActivityInfo?.processorName;
                const dataTypes = (p?.processActivityInfo?.dataTypesList || []).map((d)=>({
                        dataTypeName: d?.dataTypeName,
                        dataItems: d?.dataItems || []
                    })).filter((d)=>d.dataTypeName);
                if (!activityName || !processorName || dataTypes.length === 0) return null;
                return {
                    activityName: activityName,
                    processorName: processorName,
                    dataTypes: dataTypes
                };
            }).filter(Boolean);
            console.log("Processor Acti", processorActivities);
            if (processorActivities.length === 0) throw new Error("Invalid processor activities");
            const autoRenewStatus = pref.autoRenew;
            const id = pref.preferenceId;
            const status = pref.preferenceStatus;
            const preferenceExpiry = calculateValidityInDays(pref.endDate);
            const formattedObj = {
                purpose: purpose,
                duration: duration,
                usedBy: usedBy,
                dataItems: dataItems,
                processorActivities: processorActivities,
                id: id,
                status: status,
                preferenceExpiry: preferenceExpiry,
                autoRenewStatus: autoRenewStatus
            };
            preferencesStatus[id] = status;
            console.log("Formatted preference object:", formattedObj);
            if (pref.mandatory === true) mandatory.push(formattedObj);
            else others.push(formattedObj);
        });
        return {
            mandatory: mandatory,
            others: others,
            preferencesStatus: preferencesStatus
        };
    };
    const [formData, setFormData] = (0, $acw62.useState)({});
    const [formOtherData, setformOtherData] = (0, $acw62.useState)({});
    const isAllChecked = formOtherData.length > 0 && formOtherData.every((item)=>item.status == "ACCEPTED");
    // const othersWithChecked = formOtherData.map((item) => ({
    //   ...item,
    //   checked: item.status === "ACCEPTED",
    // }));
    // const handleMainCheckboxChange = (e) => {
    //   const isChecked = e.target.checked;
    //   const updated = formOtherData.map((item) => ({
    //     ...item,
    //     checked: isChecked,
    //   }));
    //   setformOtherData(updated);
    // };
    const handleCallAPI = async (id, handleId, languagePreferences, status, startDate)=>{
        console.log("Inside View");
        modalRef.current = "view";
        setSelectedConsentId(id);
        currentPageLoadRef.current = 1;
        const consentObj = consentLanguageList.find((item)=>item.consentHandleId === handleId);
        setSelectedLanguagePreferences(languagePreferences);
        setSelectedConsentStatus(status);
        const response = await dispatch((0, $6eea01a75b53fee5$export$b2b0abb095842b3c)(id));
        //alert("response?.searchList?.parentalKyc" + response[0]?.parentalKyc);
        if (response[0]?.parentalKyc) {
            //alert("response[0]?.parentalKyc " + response[0]?.parentalKyc);
            setIsParentChecked(true);
            setParentCheckBox(true);
        } else {
            setIsParentChecked(false);
            setParentCheckBox(false);
        }
        console.log("API response for consent details:", response);
        try {
            const { mandatory: mandatory, others: others, preferencesStatus: preferencesStatus } = transformConsentData(response);
            console.log("Mandatory:", mandatory);
            const response1 = await dispatch((0, $6eea01a75b53fee5$export$8010e91ba8c855a9)(handleId));
            setFormData(mandatory);
            setformOtherData(others);
            setSelectedPreferences(preferencesStatus);
            var theme = response1?.uiConfig?.theme;
            setParentalControl(response1?.uiConfig?.parentalControl);
            setDarkModeToBeShown(response1?.uiConfig?.darkMode);
            setDataItemToBeShown(response1?.uiConfig?.dataItemToBeShown);
            setDocumentName(response1?.documentMeta?.name);
            setDocumentId(response1?.documentMeta?.documentId);
            setLogoUrl(response1?.uiConfig?.logo);
            setProcessActivityNameToBeShown(response1?.uiConfig?.processActivityNameToBeShown);
            setProcessorNameToBeShown(response1?.uiConfig?.processorNameToBeShown);
            setValiditytoBeShown(response1?.uiConfig?.validitytoBeShown);
            if (theme) {
                var decodedThemeStr = atob(theme);
                var decodedTheme = JSON.parse(decodedThemeStr);
                setLightTheme(JSON.parse(decodedTheme.light));
                setDarkTheme(JSON.parse(decodedTheme.dark));
            }
            setTopDescription(response1?.multilingual?.languageSpecificContentMap?.ENGLISH?.description);
            setRightsDescription(response1?.multilingual?.languageSpecificContentMap?.ENGLISH?.rightsText);
            setPermissionDescription(response1?.multilingual?.languageSpecificContentMap?.ENGLISH?.permissionText);
            setRequiredText(response1?.multilingual?.languageSpecificContentMap?.ENGLISH?.label);
            //setShowModal(true);
            setPendingTranslationLang(consentObj?.languagePreferences || "ENGLISH");
            console.log("Current selected langiage is", consentObj?.languagePreferences || "ENGLISH");
            setSelectedLang(consentObj?.languagePreferences || "ENGLISH");
        } catch (err) {
            console.log(err);
            (0, $b00d3e7401eac195$export$b410431fab84fa58).error((props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482ccd6e8e9b33b1$export$2e2bcd8739ae039), {
                    ...props,
                    type: "error",
                    message: "Something went wrong while fetching consent details."
                }), {
                icon: false
            });
            return;
        }
        const handleRowCheckboxChange = (index, e)=>{
            const updated = [
                ...formOtherData
            ];
            updated[index].checked = e.target.checked;
            setformOtherData(updated);
        };
    };
    (0, $acw62.useEffect)(()=>{
        if (pendingTranslationLang && Array.isArray(formData) && Array.isArray(formOtherData) && formData.length >= 0) {
            callBhashiniAPI(pendingTranslationLang);
            setPendingTranslationLang(null); // reset
        }
    }, [
        pendingTranslationLang,
        formData,
        formOtherData
    ]);
    const handleCallAPI2 = async (id, handleId, languagePreferences, status, startDate)=>{
        modalRef.current = "edit";
        setSelectedConsentStartDate(formatToIST(startDate));
        setSelectedConsentId(id);
        currentPageLoadRef.current = 1;
        const consentObj = consentLanguageList.find((item)=>item.consentHandleId === handleId);
        setSelectedConsentHandleId(handleId);
        setSelectedLanguagePreferences(languagePreferences);
        setSelectedConsentStatus(status);
        const response = await dispatch((0, $6eea01a75b53fee5$export$b2b0abb095842b3c)(id));
        try {
            const { mandatory: mandatory, others: others, preferencesStatus: preferencesStatus } = transformConsentData(response);
            if (response[0]?.parentalKyc) {
                //alert("response[0]?.parentalKyc " + response[0]?.parentalKyc);
                setIsParentChecked(true);
                setParentCheckBox(true);
            } else {
                setIsParentChecked(false);
                setParentCheckBox(false);
            }
            const response1 = await dispatch((0, $6eea01a75b53fee5$export$8010e91ba8c855a9)(handleId));
            setDarkModeToBeShown(response1?.uiConfig?.darkMode);
            var theme = response1?.uiConfig?.theme;
            setFormData(mandatory);
            setformOtherData(others);
            setSelectedPreferences(preferencesStatus);
            setSelectedPrefrenecesForRenewal(preferencesStatus);
            setDocumentName(response1?.documentMeta?.name);
            setDocumentId(response1?.documentMeta?.documentId);
            setLogoUrl(response1?.uiConfig?.logo);
            setParentalControl(response1?.uiConfig?.parentalControl);
            setDataItemToBeShown(response1?.uiConfig?.dataItemToBeShown);
            setProcessActivityNameToBeShown(response1?.uiConfig?.processActivityNameToBeShown);
            setValiditytoBeShown(response1?.uiConfig?.validitytoBeShown);
            if (theme) {
                var decodedThemeStr = atob(theme);
                var decodedTheme = JSON.parse(decodedThemeStr);
                setLightTheme(JSON.parse(decodedTheme.light));
                setDarkTheme(JSON.parse(decodedTheme.dark));
            }
            setTopDescription(response1?.multilingual?.languageSpecificContentMap?.ENGLISH?.description);
            setRightsDescription(response1?.multilingual?.languageSpecificContentMap?.ENGLISH?.rightsText);
            setPermissionDescription(response1?.multilingual?.languageSpecificContentMap?.ENGLISH?.permissionText);
            setRequiredText(response1?.multilingual?.languageSpecificContentMap?.ENGLISH?.label);
            //setShowUpdateModal(true);
            setPendingTranslationLang(consentObj?.languagePreferences || "ENGLISH");
            setSelectedLang(consentObj?.languagePreferences || "ENGLISH");
        } catch (err) {
            console.log(err);
            (0, $b00d3e7401eac195$export$b410431fab84fa58).error((props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482ccd6e8e9b33b1$export$2e2bcd8739ae039), {
                    ...props,
                    type: "error",
                    message: "Something went wrong while fetching consent details."
                }), {
                icon: false
            });
            return;
        }
    };
    const handleCallAPI3 = async (id, handleId, languagePreferences, status)=>{
        setSelectedConsentId(id);
        modalRef.current = "renew";
        currentPageLoadRef.current = 1;
        const consentObj = consentLanguageList.find((item)=>item.consentHandleId === handleId);
        setSelectedConsentHandleId(handleId);
        setSelectedLanguagePreferences(languagePreferences);
        setSelectedConsentStatus(status);
        const response = await dispatch((0, $6eea01a75b53fee5$export$b2b0abb095842b3c)(id));
        try {
            const { mandatory: mandatory, others: others, preferencesStatus: preferencesStatus } = transformConsentData(response);
            if (response[0]?.parentalKyc) {
                //alert("response[0]?.parentalKyc " + response[0]?.parentalKyc);
                setIsParentChecked(true);
                setParentCheckBox(true);
            } else {
                setIsParentChecked(false);
                setParentCheckBox(false);
            }
            const response1 = await dispatch((0, $6eea01a75b53fee5$export$8010e91ba8c855a9)(handleId));
            setDarkModeToBeShown(response1?.uiConfig?.darkMode);
            var theme = response1?.uiConfig?.theme;
            setFormData(mandatory);
            setformOtherData(others);
            setSelectedPreferences(preferencesStatus);
            setSelectedPrefrenecesForRenewal(preferencesStatus);
            setDocumentName(response1?.documentMeta?.name);
            setDocumentId(response1?.documentMeta?.documentId);
            setLogoUrl(response1?.uiConfig?.logo);
            setParentalControl(response1?.uiConfig?.parentalControl);
            setDataItemToBeShown(response1?.uiConfig?.dataItemToBeShown);
            setProcessActivityNameToBeShown(response1?.uiConfig?.processActivityNameToBeShown);
            setValiditytoBeShown(response1?.uiConfig?.validitytoBeShown);
            if (theme) {
                var decodedThemeStr = atob(theme);
                var decodedTheme = JSON.parse(decodedThemeStr);
                setLightTheme(JSON.parse(decodedTheme.light));
                setDarkTheme(JSON.parse(decodedTheme.dark));
            }
            setTopDescription(response1?.multilingual?.languageSpecificContentMap?.ENGLISH?.description);
            setRightsDescription(response1?.multilingual?.languageSpecificContentMap?.ENGLISH?.rightsText);
            setPermissionDescription(response1?.multilingual?.languageSpecificContentMap?.ENGLISH?.permissionText);
            setRequiredText(response1?.multilingual?.languageSpecificContentMap?.ENGLISH?.label);
            //setShowRenewModal(true);
            setPendingTranslationLang(consentObj?.languagePreferences || "ENGLISH");
            setSelectedLang(consentObj?.languagePreferences || "ENGLISH");
        } catch (err) {
            console.log(err);
            (0, $b00d3e7401eac195$export$b410431fab84fa58).error((props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482ccd6e8e9b33b1$export$2e2bcd8739ae039), {
                    ...props,
                    type: "error",
                    message: "Something went wrong while fetching consent details."
                }), {
                icon: false
            });
            return;
        }
    };
    const [renewConsentList, setRenewConsentList] = (0, $acw62.useState)([]);
    const handleRenewToggle = (id, isChecked)=>{
        setRenewConsentList((prev)=>{
            let updated;
            if (isChecked) // ADD
            updated = [
                ...prev,
                {
                    [id]: "RENEW"
                }
            ];
            else // REMOVE
            updated = prev.filter((item)=>!item[id]);
            return updated;
        });
    };
    const handlePreferenceChange = (id, isChecked)=>{
        setSelectedPreferences((prev)=>({
                ...prev,
                [id]: isChecked ? "ACCEPTED" : "NOTACCEPTED"
            }));
    };
    const handleRenewPrefereneceChange = (id, isChecked)=>{
        setListOfRenewPref((prev)=>({
                ...prev,
                [id]: isChecked ? "RENEW" : ""
            }));
    };
    const handleSelectAll = (isChecked)=>{
        setAllSelected(isChecked);
        setSelectedPreferences((prev)=>{
            const mandatoryEntries = Object.fromEntries(Object.entries(prev).filter(([_, value])=>value === "ACCEPTED"));
            const updatedOthers = {};
            formOtherData.forEach((item)=>{
                updatedOthers[item.id] = isChecked ? "ACCEPTED" : "NOTACCEPTED";
            });
            return {
                ...mandatoryEntries,
                ...updatedOthers
            };
        });
    };
    (0, $acw62.useEffect)(()=>{
        const allChecked = formOtherData.length > 0 && formOtherData.every((item)=>selectedPrefereneces[item.id] === "ACCEPTED");
        setAllSelected(allChecked);
    }, [
        formOtherData,
        selectedPrefereneces
    ]);
    (0, $acw62.useEffect)(()=>{}, [
        selectedPrefereneces
    ]);
    const getConsentData = async ()=>{
        try {
            setShowLoader(true);
            const jsonResponse = await (0, $6eea01a75b53fee5$export$7ff2f08ac86399e2)(cusId, tenantId, scCode);
            if (!jsonResponse) return;
            setShowLoader(false);
            const grouped = {};
            jsonResponse.forEach((consent)=>{
                const consentId = consent.consentId;
                const created = new Date(consent.createdAt).toLocaleDateString("en-GB");
                consent.preferences?.forEach((pref)=>{
                    const consentStatus = pref.preferenceStatus;
                    pref.processorActivityList?.forEach((activity)=>{
                        const usedBy = `${activity.processActivityInfo.processorName} (Created: ${created})`;
                        pref.purposeList?.forEach((purpose)=>{
                            const purposeName = purpose.purposeInfo.purposeName;
                            const purposeStatus = purpose.purposeInfo.status;
                            const key = `${consentId}||${usedBy}||${purposeName}`;
                            if (!grouped[key]) grouped[key] = {
                                consentId: consentId,
                                usedBy: usedBy,
                                purpose: purposeName,
                                dataItems: [],
                                consentStatus: consentStatus,
                                purposeStatus: purposeStatus
                            };
                            activity.processActivityInfo.dataTypesList?.forEach((dt)=>{
                                grouped[key].dataItems.push(...dt.dataItems || []);
                            });
                        });
                    });
                });
            });
            const formatted = Object.values(grouped).map((r)=>({
                    ...r,
                    dataItems: [
                        ...new Set(r.dataItems)
                    ].join(", ")
                }));
            formatted.sort((a, b)=>{
                if (a.consentId < b.consentId) return -1;
                if (a.consentId > b.consentId) return 1;
                if (a.usedBy < b.usedBy) return -1;
                if (a.usedBy > b.usedBy) return 1;
                if (a.purpose < b.purpose) return -1;
                if (a.purpose > b.purpose) return 1;
                return 0;
            });
            setTableData(formatted);
        } catch (err) {
            console.log("Error fetching consent data:", err);
            const firstError = Array.isArray(err) ? err[0] : err?.errors?.[0];
            if (!firstError) return;
            console.log("Error code:", firstError.errorCode);
            if (firstError.errorCode === "JCMP2001") {
                setShowLoader(false);
                (0, $b00d3e7401eac195$export$b410431fab84fa58).error((props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482ccd6e8e9b33b1$export$2e2bcd8739ae039), {
                        ...props,
                        type: "error",
                        message: "Please enter valid tenant ID."
                    }), {
                    icon: false
                });
            }
            if (firstError.errorCode === "JCMP3001") {
                setShowLoader(false);
                (0, $b00d3e7401eac195$export$b410431fab84fa58).error((props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482ccd6e8e9b33b1$export$2e2bcd8739ae039), {
                        ...props,
                        type: "error",
                        message: "No data available for provided Email Id/Phone Number."
                    }), {
                    icon: false
                });
            }
        }
    };
    const getRowSpanInfo = (data, accessor)=>{
        const info = [];
        let prev = null;
        let prevIndex = -1;
        let count = 0;
        data.forEach((row, idx)=>{
            const val = accessor(row);
            if (val === prev) {
                count++;
                info[prevIndex].rowSpan = count + 1;
                info.push({
                    show: false
                });
            } else {
                count = 0;
                info.push({
                    show: true,
                    rowSpan: 1
                });
                prev = val;
                prevIndex = idx;
            }
        });
        return info;
    };
    const consentRowSpanInfo = getRowSpanInfo(tableData, (r)=>r.consentId);
    const usedByRowSpanInfo = getRowSpanInfo(tableData, (r)=>r.usedBy);
    // useEffect(() => {
    //   if (templateId) {
    //     getConsentData();
    //   }
    // }, [templateId]); // run whenever templateId changes
    const handleToggle = (rowId)=>{
        setExpandedRow(expandedRow === rowId ? null : rowId);
    };
    (0, $acw62.useEffect)(()=>{
        const fetchTranslationConfig = async ()=>{
            try {
                const res = await dispatch((0, $6eea01a75b53fee5$export$78d225ba46c95956)());
            } catch (error) {
                console.log("Error in translation configuration:", error.message || error);
            }
        };
        fetchTranslationConfig();
    }, [
        dispatch
    ]);
    (0, $acw62.useEffect)(()=>{
        const fetchBusiness = async ()=>{
            try {
                if (businessId) {
                    const res = await dispatch((0, $6eea01a75b53fee5$export$d8842388fb193136)(businessId));
                    const res2 = await dispatch((0, $6eea01a75b53fee5$export$27a2fc8f71b19442)(businessId));
                    const portalTheme = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.common.portal_theme);
                }
            } catch (error) {
                console.log("Error in translation configuration:", error.message || error);
            }
        };
        fetchBusiness();
    }, [
        dispatch
    ]);
    (0, $acw62.useEffect)(()=>{
        const fetchDigilockerDetails = async ()=>{
            try {
                if (tenantId) {
                    const res = await dispatch((0, $6eea01a75b53fee5$export$9b0d6ab01c55202e)(tenantId));
                    const response = res?.data;
                    if (response?.searchList) {
                        setDigilockerClientId(response.searchList[0]?.clientId || "");
                        setDigilockerClientSecret(response.searchList[0]?.clientSecret || "");
                        setDigilockerCodeVerifier(response.searchList[0]?.codeVerifier || "");
                        setDigilockerRedirectUri(response.searchList[0]?.redirectUri || "");
                    }
                }
            } catch (error) {
                console.log("Error in Digilocker api:", error.message || error);
            }
        };
        fetchDigilockerDetails();
    }, [
        dispatch,
        tenantId
    ]);
    (0, $acw62.useEffect)(()=>{
        setLoadLogs(true);
        (0, $6eea01a75b53fee5$export$7ff2f08ac86399e2)(cusId, tenantId, scCode).then((searchList)=>{
            setConsentsByTempId(searchList);
            console.log("SearchList recieved", JSON.stringify(searchList));
            const consentLanguageList2 = searchList.map((item)=>({
                    consentHandleId: item.consentHandleId,
                    languagePreferences: item.languagePreferences
                }));
            setConsentLanguageList(consentLanguageList2);
            console.log("Consent Language List", JSON.stringify(consentLanguageList2));
            generateAutoRenewStatus(searchList);
            const withdraw = searchList.filter((item)=>item.status === "WITHDRAWN").length;
            const active = searchList.filter((item)=>item.status === "ACTIVE").length;
            const expire = searchList.filter((item)=>item.status === "EXPIRED").length;
            setWithdrawCount(withdraw);
            setActiveCount(active);
            setExpiredCount(expire);
            setLoadLogs(false);
        }).catch((err)=>{
            console.log("Error occured in getConsentsByTemplateId", err);
            if (err?.[0]?.errorCode === "JCMP3001") setConsentsByTempId([]);
            if (err.code === "ERR_NETWORK") setSessionExpired(true);
            setLoadLogs(false);
        });
    }, [
        cusId,
        tenantId
    ]);
    const applyFilters = (consents)=>{
        return consents.filter((consent)=>{
            if (filters.search?.trim()) {
                const text = filters.search.toLowerCase().trim().replace(/\s+/g, " ");
                const consentValues = [
                    consent.consentId,
                    formatToIST(consent.startDate),
                    formatToIST(consent.endDate),
                    consent.status
                ];
                consent.preferences?.forEach((pref)=>{
                    pref.purposeList?.forEach((p)=>consentValues.push(p.purposeInfo?.purposeName));
                    pref.processorActivityList?.forEach((pa)=>{
                        consentValues.push(pa.processActivityInfo?.processorName);
                        pa.processActivityInfo?.dataTypesList?.forEach((dt)=>{
                            consentValues.push(dt.dataTypeName);
                            consentValues.push(...dt.dataItems || []);
                        });
                    });
                });
                const match = consentValues.some((value)=>{
                    if (typeof value !== "string") return false;
                    const clean = value.toLowerCase().trim().replace(/\s+/g, " ");
                    return clean.includes(text);
                });
                if (!match) return false;
            }
            // ----- 2. STATUS FILTER -----
            if (filters.status?.length > 0) {
                if (!filters.status.includes(consent.status)) return false;
            }
            // ----- 3. CREATED DATE FILTER (startDate → start of day, endDate → end of day) -----
            const start = filters.startDate ? new Date(filters.startDate + "T00:00:00") : null;
            const end = filters.endDate ? new Date(filters.endDate + "T23:59:59") : null;
            const created = new Date(consent.startDate);
            if (start && created < start) return false;
            if (end && created > end) return false;
            return true;
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("main", {
        role: "main",
        "aria-label": "Granted Consents Page",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "pageConfig granted-consents-page",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("header", {
                        className: "fiduciaryHeaderContainer",
                        role: "banner",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "fiduciaryHeader",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                        appearance: "heading-s",
                                        color: "primary-grey-100",
                                        children: portalTheme?.portalTitle || getTranslation("fid_granted_consents", "Granted consents")
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "badge",
                                    role: "status",
                                    "aria-label": "Page type: Consent",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                        appearance: "body-xs-bold",
                                        color: "primary-grey-80",
                                        children: getTranslation("fid_consent_badge", "Consent")
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                        appearance: "body-s",
                        color: "primary-grey-80",
                        children: getTranslation("fid_description", "View and respond to your consent requests awaiting your action.")
                    }),
                    portalTheme?.privacyText ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                        appearance: "body-xs",
                        color: "primary-grey-80",
                        style: {
                            display: "block",
                            marginTop: "8px"
                        },
                        children: portalTheme.privacyText
                    }) : null,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "status-container",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "status-card active-card",
                                "aria-label": `${getTranslation("fid_active", "Active")}: ${activeCount} consents`,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "status-content",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dd949b1a0491130c$export$50c1b72d39add9), {
                                            height: 35,
                                            width: 35
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "status-text",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                    appearance: "body-xs-bold",
                                                    color: "primary-grey-100",
                                                    children: String(activeCount)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                    appearance: "body-xs",
                                                    color: "primary-grey-80",
                                                    children: getTranslation("fid_active", "Active")
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "status-card withdrawn-card",
                                "aria-label": `${getTranslation("fid_withdrawn", "Withdrawn")}: ${withdrawCount} consents`,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "status-content",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $87c0f97f25197d00$export$ed1619aa732c6643), {
                                            height: 35,
                                            width: 35
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "status-text",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                    appearance: "body-xs-bold",
                                                    color: "primary-grey-100",
                                                    children: String(withdrawCount)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                    appearance: "body-xs",
                                                    color: "primary-grey-80",
                                                    children: getTranslation("fid_withdrawn", "Withdrawn")
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "status-card withdrawn-card",
                                // style={{ backgroundColor: "#fef0e7" }}
                                "aria-label": `${getTranslation("fid_expired", "Expired")}: ${expiredCount} consents`,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "status-content",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7dab575aad091c08$export$47407925ae9f1f0e), {
                                            height: 35,
                                            width: 35
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "status-text",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                    appearance: "body-xs-bold",
                                                    color: "primary-grey-100",
                                                    children: String(expiredCount)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                    appearance: "body-xs",
                                                    color: "primary-grey-80",
                                                    children: getTranslation("fid_expired", "Expired")
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "fiduciaryHeaderButtonContainer",
                        style: {
                            justifyContent: "flex-end",
                            opacity: consentsByTempId.length === 0 ? 0.5 : 1,
                            pointerEvents: consentsByTempId.length === 0 ? "none" : "auto"
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "search-input-wrapper page-toolbar-search",
                                style: {
                                    width: "100%"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$f04a61298a47a40f), {
                                        ic: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $52f7703976716e4f$export$6da2c307edd95198), {}),
                                        size: "m",
                                        color: "primary_grey_100"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "text",
                                        className: "search-input",
                                        placeholder: getTranslation("fid_search_placeholder", "Search data item, type and purpose"),
                                        value: searchText,
                                        onChange: (e)=>setSearchText(e.target.value),
                                        "aria-label": getTranslation("fid_search_placeholder", "Search data item, type and purpose")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$cfc7921d29ef7b80), {
                                kind: "tertiary",
                                ariaLabel: "Open filter panel",
                                onClick: ()=>setShowFilter(true),
                                ariaExpanded: showFilter,
                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$f04a61298a47a40f), {
                                    ic: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a9dbc27ea69a373d$export$26f46b9510140fcc), {}),
                                    size: "m",
                                    color: "primary_grey_80"
                                }),
                                size: "medium"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $637cc7b74c89b097$export$2e2bcd8739ae039), {
                                open: showFilter,
                                showStatus: true,
                                onClose: ()=>setShowFilter(false),
                                onApply: (data)=>{
                                    setFilters(data); // <-- IMPORTANT
                                },
                                onClear: ()=>setFilters({
                                        search: "",
                                        status: [],
                                        startDate: "",
                                        endDate: ""
                                    })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$cfc7921d29ef7b80), {
                                kind: "tertiary",
                                ariaLabel: "downlod Report",
                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$f04a61298a47a40f), {
                                    ic: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $60bea030b4289a81$export$bb264a5644c93858), {}),
                                    size: "m",
                                    color: "primary_grey_80"
                                }),
                                onClick: ()=>downloadConsentExcel(consentsByTempId),
                                size: "medium"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "responsive-table-scroll",
                        style: {
                            overflowX: "auto",
                            paddingBottom: "1rem"
                        },
                        "aria-label": "Consent Information Table.",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                            className: "consentLog-table",
                            "aria-label": "details such as Consent ID, Created Date, Expiry Date, Status and Actions",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("colgroup", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                            style: {
                                                width: "3rem"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                            style: {
                                                width: "25%"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                            style: {
                                                width: "20%"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                            style: {
                                                width: "20%"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                            style: {
                                                width: "15%"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                            style: {
                                                width: "15%"
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                scope: "col"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "parentheader",
                                                scope: "col",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "header-with-icon",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                        appearance: "body-xs-bold",
                                                        color: "primary-grey-80",
                                                        children: getTranslation("fid_consent_id", "Consent ID")
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "parentheader",
                                                scope: "col",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "header-with-icon",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                        appearance: "body-xs-bold",
                                                        color: "primary-grey-80",
                                                        children: getTranslation("fid_created_date", "Created date")
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "parentheader",
                                                scope: "col",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "header-with-icon",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                        appearance: "body-xs-bold",
                                                        color: "primary-grey-80",
                                                        children: getTranslation("fid_expiry_date", "Expiry date")
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "parentheader",
                                                scope: "col",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "header-with-icon",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                        appearance: "body-xs-bold",
                                                        color: "primary-grey-80",
                                                        children: getTranslation("fid_status", "Status")
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "parentheader",
                                                scope: "col",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "header-with-icon",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                        appearance: "body-xs-bold",
                                                        color: "primary-grey-80",
                                                        children: getTranslation("fid_actions", "Actions")
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                    children: loadLogs ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            colSpan: "6",
                                            style: {
                                                textAlign: "center",
                                                padding: "1rem"
                                            },
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "customerActivityLoader",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$7f7cbe89f1eacd2), {
                                                    kind: "normal",
                                                    labelPosition: "right",
                                                    size: "small"
                                                })
                                            })
                                        })
                                    }) : !Array.isArray(consentsByTempId) || consentsByTempId.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            colSpan: "6",
                                            style: {
                                                textAlign: "center",
                                                padding: "1rem"
                                            },
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                appearance: "body-xs-bold",
                                                color: "primary-grey-80",
                                                children: getTranslation("fid_no_data", "No Data to Display")
                                            })
                                        })
                                    }) : (()=>{
                                        const dataAfterFilters = applyFilters(consentsByTempId || []);
                                        const sortedConsents = [
                                            ...dataAfterFilters
                                        ].sort((a, b)=>{
                                            return new Date(b.startDate) - new Date(a.startDate); // latest first
                                        });
                                        const filteredConsents = sortedConsents.filter((consent)=>{
                                            const text = searchText.toLowerCase().trim().replace(/\s+/g, " ");
                                            if (!text) return true;
                                            const consentValues = [
                                                consent.consentId,
                                                formatToIST(consent.startDate),
                                                formatToIST(consent.endDate),
                                                consent.status
                                            ];
                                            consent.preferences?.forEach((pref)=>{
                                                pref.purposeList?.forEach((p)=>{
                                                    consentValues.push(p.purposeInfo?.purposeName);
                                                });
                                                pref.processorActivityList?.forEach((pa)=>{
                                                    consentValues.push(pa.processActivityInfo?.processorName);
                                                    pa.processActivityInfo?.dataTypesList?.forEach((dt)=>{
                                                        consentValues.push(dt.dataTypeName);
                                                        consentValues.push(...dt.dataItems || []);
                                                    });
                                                });
                                            });
                                            return consentValues.some((val)=>{
                                                if (typeof val !== "string") return false;
                                                const normalizedVal = val.toLowerCase().trim().replace(/\s+/g, " ");
                                                return normalizedVal.includes(text);
                                            });
                                        });
                                        totalPages = Math.ceil(filteredConsents.length / rowsPerPage);
                                        startIdx = (currentPage - 1) * rowsPerPage;
                                        endIdx = startIdx + rowsPerPage;
                                        paginatedConsents = filteredConsents.slice(startIdx, endIdx);
                                        return filteredConsents.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                colSpan: "6",
                                                style: {
                                                    textAlign: "center",
                                                    padding: "1rem"
                                                },
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                    appearance: "body-xs-bold",
                                                    color: "primary-grey-80",
                                                    children: "No matching records found"
                                                })
                                            })
                                        }) : paginatedConsents.map((consent, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                        onClick: ()=>handleToggle(`row${index}`),
                                                        className: expandedRow === `row${index}` ? "expanded-row-parent" : "",
                                                        role: "button",
                                                        "aria-expanded": expandedRow === `row${index}` ? "true" : "false",
                                                        "aria-label": `Consent ${consent.consentId} details`,
                                                        tabIndex: "0",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                className: "chevron-cell",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                    className: "chevron-wrapper",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                                        appearance: "body-xs",
                                                                        color: "primary-grey-100",
                                                                        children: expandedRow === `row${index}` ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9efe7828a40b52f7$export$acd925e63e14000f), {
                                                                            height: 25,
                                                                            width: 25
                                                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fdc94045ec0e5793$export$ec7db1c418c1ec5a), {
                                                                            height: 25,
                                                                            width: 25
                                                                        })
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                                    appearance: "body-xs-bold",
                                                                    color: "primary-grey-80",
                                                                    children: consent.consentId
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                                    appearance: "body-xs-bold",
                                                                    color: "primary-grey-80",
                                                                    children: formatToIST(consent.startDate)
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                                    appearance: "body-xs-bold",
                                                                    color: "primary-grey-80",
                                                                    children: formatToIST(consent.endDate)
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                    className: consent.status === "ACTIVE" ? "badge-active" : consent.status === "WITHDRAWN" ? "badge-withdraw" : consent.status === "EXPIRED" ? "badge-expired" : "badge-text",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                        className: consent.status === "ACTIVE" ? "badge-text-active" : consent.status === "WITHDRAWN" ? "badge-text-withdraw" : consent.status === "EXPIRED" ? "badge-text-expired" : "badge-text",
                                                                        children: getTranslatedStatus(consent.status)
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    style: {
                                                                        display: "flex",
                                                                        gap: "2rem",
                                                                        alignItems: "center"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35aa9dff24458a00$export$fd7adc84612ab6c3), {
                                                                            "aria-label": `View details for consent ${consent.consentId}`,
                                                                            role: "button",
                                                                            tabIndex: "0",
                                                                            height: 20,
                                                                            width: 20,
                                                                            style: {
                                                                                cursor: "pointer"
                                                                            },
                                                                            onClick: ()=>handleCallAPI(consent.consentId, consent.consentHandleId, consent.languagePreferences, consent.status, consent.startDate)
                                                                        }),
                                                                        consent.status === "ACTIVE" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482699419fe250fb$export$55e8bf91189d440f), {
                                                                            "aria-label": `Edit consent ${consent.consentId}`,
                                                                            role: "button",
                                                                            tabIndex: "0",
                                                                            height: 20,
                                                                            width: 20,
                                                                            style: {
                                                                                cursor: "pointer"
                                                                            },
                                                                            onClick: ()=>handleCallAPI2(consent.consentId, consent.consentHandleId, consent.languagePreferences, consent.status, consent.startDate)
                                                                        }),
                                                                        consent.status != "WITHDRAWN" && consent.status != "EXPIRED" && consentIdListForAutoRenew[consent.consentId] === true && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7dab575aad091c08$export$47407925ae9f1f0e), {
                                                                            height: 20,
                                                                            width: 20,
                                                                            onClick: ()=>handleCallAPI3(consent.consentId, consent.consentHandleId, consent.languagePreferences, consent.status, consent.startDate)
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    expandedRow === `row${index}` && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                        className: "expanded-row",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {}),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                colSpan: "5",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                                                    className: "inner-table",
                                                                    role: "table",
                                                                    "aria-label": "Detailed purpose, data type, data item, processor, and status information",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("colgroup", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                                                                    style: {
                                                                                        width: "25%"
                                                                                    }
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                                                                    style: {
                                                                                        width: "20%"
                                                                                    }
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                                                                    style: {
                                                                                        width: "20%"
                                                                                    }
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                                                                    style: {
                                                                                        width: "15%"
                                                                                    }
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                                                                    style: {
                                                                                        width: "15%"
                                                                                    }
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                                                            appearance: "body-xs-bold",
                                                                                            color: "primary-grey-80",
                                                                                            children: getTranslation("fid_purpose_name", "Purpose Name")
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                                                            appearance: "body-xs-bold",
                                                                                            color: "primary-grey-80",
                                                                                            children: getTranslation("fid_data_type", "Data type")
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                                                            appearance: "body-xs-bold",
                                                                                            color: "primary-grey-80",
                                                                                            children: getTranslation("fid_data_item", "Data Item")
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                                                            appearance: "body-xs-bold",
                                                                                            color: "primary-grey-80",
                                                                                            children: getTranslation("fid_data_used_by", "Data used by")
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                                                            appearance: "body-xs-bold",
                                                                                            color: "primary-grey-80",
                                                                                            children: getTranslation("fid_data_status", "Status")
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                                                            children: consent.preferences.map((pref)=>pref.purposeList.map((purpose)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                                                                    appearance: "body-xs-bold",
                                                                                                    color: "primary-grey-80",
                                                                                                    children: getDynamicTranslation(purpose?.purposeInfo?.purposeName)
                                                                                                })
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                                                                    appearance: "body-xs-bold",
                                                                                                    color: "primary-grey-80",
                                                                                                    children: pref.processorActivityList.flatMap((pa)=>pa?.processActivityInfo?.dataTypesList.map((dt)=>getDynamicTranslation(dt.dataTypeName))).join(", ")
                                                                                                })
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                                                                    appearance: "body-xs-bold",
                                                                                                    color: "primary-grey-80",
                                                                                                    children: pref.processorActivityList.flatMap((pa)=>pa?.processActivityInfo?.dataTypesList.flatMap((dt)=>dt.dataItems.map((item)=>getDynamicTranslation(item)))).join(", ")
                                                                                                })
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                                                                    appearance: "body-xs-bold",
                                                                                                    color: "primary-grey-80",
                                                                                                    children: pref.processorActivityList.flatMap((pa)=>getDynamicTranslation(pa?.processActivityInfo?.processorName)).join(", ")
                                                                                                })
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                                    className: pref.preferenceStatus === "ACCEPTED" ? "accepted" : "not-accepted",
                                                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                                                                        appearance: "body-xs-bold",
                                                                                                        color: "primary-grey-80",
                                                                                                        children: getTranslatedPrefStatus(pref?.preferenceStatus)
                                                                                                    })
                                                                                                })
                                                                                            })
                                                                                        ]
                                                                                    }, purpose.purposeId)))
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, consent.consentId));
                                    })()
                                })
                            ]
                        })
                    }),
                    Array.isArray(paginatedConsents) && paginatedConsents.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "pagination-container",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$cfc7921d29ef7b80), {
                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $575ba915d2bd5d5b$export$740276c76f223dd4), {}),
                                kind: "secondary",
                                onClick: ()=>setCurrentPage((p)=>Math.max(p - 1, 1)),
                                disabled: currentPage === 1
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "pagination-text",
                                children: [
                                    getTranslation("fid_page", "Page"),
                                    " ",
                                    currentPage,
                                    " ",
                                    getTranslation("fid_of", "of"),
                                    " ",
                                    totalPages
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$cfc7921d29ef7b80), {
                                kind: "secondary",
                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b59efb8c56ba82c0$export$17beb55fda7072f9), {}),
                                onClick: ()=>setCurrentPage((p)=>Math.min(p + 1, totalPages)),
                                disabled: currentPage === totalPages
                            })
                        ]
                    }),
                    showModal && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "modal-outer-container",
                        children: [
                            darkModeToBeShown && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "theme-toggle-container",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    className: "theme-switch",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "checkbox",
                                            checked: isDarkMode,
                                            onChange: ()=>setIsDarkMode(!isDarkMode)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "slider round"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "modal-container",
                                style: {
                                    backgroundColor: activeTheme.cardBackground,
                                    color: activeTheme.cardFont,
                                    fontFamily: "var(--portal-font-family, system-ui)",
                                    "--consent-main-acc-bg": activeTheme.mainAccordionBackground,
                                    "--consent-main-acc-fg": activeTheme.mainAccordionFont,
                                    "--consent-sub-acc-bg": activeTheme.subAccordionBackground,
                                    "--consent-sub-acc-fg": activeTheme.subAccordionFont,
                                    "--consent-lang-bg": activeTheme.languageDropdownBackground,
                                    "--consent-lang-fg": activeTheme.languageDropdownFont,
                                    "--consent-badge-fg": activeTheme.activeBadgeFont
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "container-1",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            class: "close-btn",
                                            style: {
                                                "--close-color": activeTheme.buttonBackground
                                            },
                                            onClick: closeWithdrawConsentModal
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "fidu-heading-container",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "container-2-left",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "container-2-left-1",
                                                        children: modalHeading
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "container-2-left-2",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "container-2-left-2-dropdown",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab6d9bfa47542205$export$28390bfec38e5c4f), {
                                                                    height: 20,
                                                                    width: 20,
                                                                    className: "container-2-left-2-dropdown-Icon",
                                                                    style: {
                                                                        color: `${activeTheme.cardFont}`
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                                                    className: "container-2-left-2-dropdown-select",
                                                                    value: selectedLang,
                                                                    onChange: handleLanguageChange,
                                                                    // disabled={selectedConsentStatus !== "ACTIVE"}
                                                                    disabled: true,
                                                                    onClick: ()=>setIsOpen((prev)=>!prev),
                                                                    onBlur: ()=>setIsOpen(false),
                                                                    style: {
                                                                        backgroundColor: activeTheme.languageDropdownBackground,
                                                                        color: activeTheme.languageDropdownFont
                                                                    },
                                                                    children: languages.map((lang)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                            value: lang.value,
                                                                            children: lang.label
                                                                        }, lang.value))
                                                                }),
                                                                isOpen ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9efe7828a40b52f7$export$acd925e63e14000f), {
                                                                    height: 20,
                                                                    width: 20,
                                                                    className: "container-2-left-2-dropdown-Icon-right"
                                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fdc94045ec0e5793$export$ec7db1c418c1ec5a), {
                                                                    height: 20,
                                                                    width: 20,
                                                                    className: "container-2-left-2-dropdown-Icon-right"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                src: logoUrl,
                                                alt: "Logo",
                                                className: "logo-image"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mainScrollableContainer",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "container-3",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    children: topDescription
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "container-4",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                    children: [
                                                        customerIdLabel,
                                                        ": ",
                                                        cusId
                                                    ]
                                                })
                                            }),
                                            formData && Object.keys(formData).length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                onClick: ()=>setShowRequiredDetails(!showREquiredDetails),
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "container-5-required",
                                                        style: showREquiredDetails ? {
                                                            borderBottom: "none",
                                                            borderBottomLeftRadius: 0,
                                                            borderBottomRightRadius: 0
                                                        } : {},
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                style: {
                                                                    display: "flex",
                                                                    justifyContent: "flex-start"
                                                                },
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                                                    width: "30",
                                                                    height: "30",
                                                                    viewBox: "5 0 12 23",
                                                                    style: {
                                                                        // position: "absolute",
                                                                        top: "50%",
                                                                        right: "10px",
                                                                        transform: showREquiredDetails ? "translateY(0%) rotate(180deg)" : "translateY(0%) rotate(0deg)",
                                                                        pointerEvents: "none",
                                                                        transition: "transform 0.3s ease",
                                                                        color: activeTheme.buttonBackground
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                        d: "M12 15a1.002 1.002 0 01-.71-.29l-4-4a1.004 1.004 0 111.42-1.42l3.29 3.3 3.29-3.3a1.004 1.004 0 111.42 1.42l-4 4A1.001 1.001 0 0112 15z",
                                                                        fill: "currentColor"
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "container-Heading-fs",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                    children: requiredText
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "badge-container-outer",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "badge-container",
                                                                        style: {
                                                                            border: `1px solid ${activeTheme.cardFont}`,
                                                                            backgroundColor: activeTheme.cardBackground
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                            className: "modal-badge",
                                                                            children: activeBadge
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                        type: "checkbox",
                                                                        disabled: true,
                                                                        checked: true,
                                                                        readOnly: true,
                                                                        style: {
                                                                            appearance: "none",
                                                                            WebkitAppearance: "none",
                                                                            MozAppearance: "none",
                                                                            height: "20px",
                                                                            width: "20px",
                                                                            borderRadius: "4px",
                                                                            border: `1px solid ${activeTheme.mainAccordionFont || activeTheme.cardFont}`,
                                                                            cursor: "default",
                                                                            flexShrink: 0,
                                                                            marginLeft: "8px",
                                                                            backgroundColor: activeTheme.buttonBackground,
                                                                            backgroundImage: "url(\"data:image/svg+xml;utf8,<svg viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg'><path d='M3 8l3 3 7-7' stroke='white' stroke-width='2' fill='none' stroke-linecap='round' stroke-linejoin='round'/></svg>\")",
                                                                            backgroundRepeat: "no-repeat",
                                                                            backgroundPosition: "center"
                                                                        }
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "required-details-container"
                                                    })
                                                ]
                                            }),
                                            showREquiredDetails && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                children: formData.map((item, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "sub-acc-item",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                style: {
                                                                    backgroundColor: activeTheme.subAccordionBackground,
                                                                    color: activeTheme.subAccordionFont,
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "space-between",
                                                                    padding: "10px 14px",
                                                                    cursor: "pointer"
                                                                },
                                                                onClick: ()=>setExpandedRequiredItems((prev)=>({
                                                                            ...prev,
                                                                            [index]: !prev[index]
                                                                        })),
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        style: {
                                                                            display: "flex",
                                                                            alignItems: "flex-start",
                                                                            gap: "8px",
                                                                            flex: 1
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                                                                width: "20",
                                                                                height: "20",
                                                                                viewBox: "5 0 12 23",
                                                                                style: {
                                                                                    flexShrink: 0,
                                                                                    transform: expandedRequiredItems[index] ? "rotate(180deg)" : "rotate(0deg)",
                                                                                    transition: "transform 0.3s ease",
                                                                                    color: activeTheme.buttonBackground,
                                                                                    pointerEvents: "none"
                                                                                },
                                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                    d: "M12 15a1.002 1.002 0 01-.71-.29l-4-4a1.004 1.004 0 111.42-1.42l3.29 3.3 3.29-3.3a1.004 1.004 0 111.42 1.42l-4 4A1.001 1.001 0 0112 15z",
                                                                                    fill: "currentColor"
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                style: {
                                                                                    fontWeight: 700,
                                                                                    fontSize: "14px"
                                                                                },
                                                                                children: item.purpose.join(", ")
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                        type: "checkbox",
                                                                        disabled: true,
                                                                        checked: true,
                                                                        readOnly: true,
                                                                        style: {
                                                                            appearance: "none",
                                                                            WebkitAppearance: "none",
                                                                            MozAppearance: "none",
                                                                            height: "20px",
                                                                            width: "20px",
                                                                            borderRadius: "4px",
                                                                            border: `1px solid ${activeTheme.subAccordionFont || activeTheme.cardFont}`,
                                                                            cursor: "default",
                                                                            flexShrink: 0,
                                                                            marginLeft: "8px",
                                                                            backgroundColor: activeTheme.buttonBackground,
                                                                            backgroundImage: "url(\"data:image/svg+xml;utf8,<svg viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg'><path d='M3 8l3 3 7-7' stroke='white' stroke-width='2' fill='none' stroke-linecap='round' stroke-linejoin='round'/></svg>\")",
                                                                            backgroundRepeat: "no-repeat",
                                                                            backgroundPosition: "center"
                                                                        }
                                                                    })
                                                                ]
                                                            }),
                                                            expandedRequiredItems[index] && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                style: {
                                                                    padding: "8px 14px",
                                                                    backgroundColor: activeTheme.cardBackground,
                                                                    color: activeTheme.cardFont
                                                                },
                                                                children: [
                                                                    validitytoBeShown && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                        className: "data-row",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                style: {
                                                                                    fontWeight: 500
                                                                                },
                                                                                children: [
                                                                                    durationLabel,
                                                                                    ":"
                                                                                ]
                                                                            }),
                                                                            " ",
                                                                            item.duration.value,
                                                                            " ",
                                                                            item.duration.unit
                                                                        ]
                                                                    }),
                                                                    !(dataItemToBeShown === false && processActivityNameToBeShown === false && processorNameToBeShown === false) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "required-details-container"
                                                                    }),
                                                                    item.processorActivities.map((activity, idx)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                                    style: {
                                                                                        marginTop: "0.5rem"
                                                                                    },
                                                                                    children: [
                                                                                        processActivityNameToBeShown && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                            className: "data-row",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                                    style: {
                                                                                                        fontWeight: 500
                                                                                                    },
                                                                                                    children: [
                                                                                                        processingActivityLabel,
                                                                                                        ":"
                                                                                                    ]
                                                                                                }),
                                                                                                " ",
                                                                                                activity.activityName
                                                                                            ]
                                                                                        }),
                                                                                        processorNameToBeShown && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                            className: "data-row",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                                    style: {
                                                                                                        fontWeight: 500
                                                                                                    },
                                                                                                    children: [
                                                                                                        usedbyLabel,
                                                                                                        ":"
                                                                                                    ]
                                                                                                }),
                                                                                                " ",
                                                                                                activity.processorName
                                                                                            ]
                                                                                        }),
                                                                                        dataItemToBeShown && activity.dataTypes.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                                    className: "data-row",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                                            style: {
                                                                                                                fontWeight: 500
                                                                                                            },
                                                                                                            children: [
                                                                                                                dataTypeLabel,
                                                                                                                ":"
                                                                                                            ]
                                                                                                        }),
                                                                                                        " ",
                                                                                                        activity.dataTypes.map((dt)=>dt.dataTypeName).join(", ")
                                                                                                    ]
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                                    className: "data-row",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                                            style: {
                                                                                                                fontWeight: 500
                                                                                                            },
                                                                                                            children: [
                                                                                                                dataItemLabel,
                                                                                                                ":"
                                                                                                            ]
                                                                                                        }),
                                                                                                        " ",
                                                                                                        activity.dataTypes.flatMap((dt)=>dt.dataItems).join(", ")
                                                                                                    ]
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                !(dataItemToBeShown === false && processActivityNameToBeShown === false && processorNameToBeShown === false) && idx !== item.processorActivities.length - 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                                    className: "required-details-container"
                                                                                })
                                                                            ]
                                                                        }, idx))
                                                                ]
                                                            })
                                                        ]
                                                    }, index))
                                            }),
                                            formOtherData && Object.keys(formOtherData).length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "container-6",
                                                        onClick: ()=>setShowOthersDetails(!showOhersDetails),
                                                        style: showOhersDetails ? {
                                                            borderBottom: "none",
                                                            borderBottomLeftRadius: 0,
                                                            borderBottomRightRadius: 0
                                                        } : {},
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                style: {
                                                                    display: "flex",
                                                                    justifyContent: "flex-start",
                                                                    alignItems: "center"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                                                        width: "30",
                                                                        height: "30",
                                                                        viewBox: "5 0 12 23",
                                                                        style: {
                                                                            // position: "absolute",
                                                                            top: "50%",
                                                                            right: "10px",
                                                                            transform: showOhersDetails ? "translateY(0%) rotate(180deg)" : "translateY(0%) rotate(0deg)",
                                                                            pointerEvents: "none",
                                                                            transition: "transform 0.3s ease",
                                                                            color: activeTheme.buttonBackground
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                            d: "M12 15a1.002 1.002 0 01-.71-.29l-4-4a1.004 1.004 0 111.42-1.42l3.29 3.3 3.29-3.3a1.004 1.004 0 111.42 1.42l-4 4A1.001 1.001 0 0112 15z",
                                                                            fill: "currentColor"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "container-Heading-fs",
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                            children: otherAccordionHeader
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                type: "checkbox",
                                                                className: "container-6-checkbox",
                                                                checked: allSelected,
                                                                disabled: true,
                                                                onChange: (e)=>handleSelectAll(e.target.checked),
                                                                style: {
                                                                    appearance: "none",
                                                                    WebkitAppearance: "none",
                                                                    MozAppearance: "none",
                                                                    height: "20px",
                                                                    width: "20px",
                                                                    borderRadius: "4px",
                                                                    border: `1px solid ${activeTheme.cardFont}`,
                                                                    cursor: "pointer",
                                                                    backgroundColor: activeTheme.buttonBackground,
                                                                    backgroundImage: allSelected ? "url(\"data:image/svg+xml;utf8,<svg viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg'><path d='M3 8l3 3 7-7' stroke='white' stroke-width='2' fill='none' stroke-linecap='round' stroke-linejoin='round'/></svg>\")" : "none",
                                                                    backgroundRepeat: "no-repeat",
                                                                    backgroundPosition: "center"
                                                                }
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "required-details-container"
                                                    })
                                                ]
                                            }),
                                            showOhersDetails && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                children: formOtherData.map((item, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "sub-acc-item",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                style: {
                                                                    backgroundColor: activeTheme.subAccordionBackground,
                                                                    color: activeTheme.subAccordionFont,
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "space-between",
                                                                    padding: "10px 16px",
                                                                    cursor: "pointer"
                                                                },
                                                                onClick: ()=>setExpandedOtherItems((prev)=>({
                                                                            ...prev,
                                                                            [index]: !prev[index]
                                                                        })),
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        style: {
                                                                            display: "flex",
                                                                            alignItems: "flex-start",
                                                                            gap: "8px",
                                                                            flex: 1
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                                                                width: "20",
                                                                                height: "20",
                                                                                viewBox: "5 0 12 23",
                                                                                style: {
                                                                                    flexShrink: 0,
                                                                                    transform: expandedOtherItems[index] ? "rotate(180deg)" : "rotate(0deg)",
                                                                                    transition: "transform 0.3s ease",
                                                                                    color: activeTheme.buttonBackground,
                                                                                    pointerEvents: "none"
                                                                                },
                                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                    d: "M12 15a1.002 1.002 0 01-.71-.29l-4-4a1.004 1.004 0 111.42-1.42l3.29 3.3 3.29-3.3a1.004 1.004 0 111.42 1.42l-4 4A1.001 1.001 0 0112 15z",
                                                                                    fill: "currentColor"
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                style: {
                                                                                    fontWeight: 700,
                                                                                    fontSize: "14px"
                                                                                },
                                                                                children: item.purpose.join(", ")
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                        type: "checkbox",
                                                                        checked: selectedPrefereneces[item.id] === "ACCEPTED",
                                                                        disabled: true,
                                                                        onChange: (e)=>handlePreferenceChange(item.id, e.target.checked),
                                                                        onClick: (e)=>e.stopPropagation(),
                                                                        style: {
                                                                            appearance: "none",
                                                                            WebkitAppearance: "none",
                                                                            MozAppearance: "none",
                                                                            height: "20px",
                                                                            width: "20px",
                                                                            borderRadius: "4px",
                                                                            border: `1px solid ${activeTheme.subAccordionFont || activeTheme.cardFont}`,
                                                                            cursor: "pointer",
                                                                            flexShrink: 0,
                                                                            backgroundColor: selectedPrefereneces[item.id] === "ACCEPTED" ? activeTheme.buttonBackground : "white",
                                                                            backgroundImage: selectedPrefereneces[item.id] === "ACCEPTED" ? "url(\"data:image/svg+xml;utf8,<svg viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg'><path d='M3 8l3 3 7-7' stroke='white' stroke-width='2' fill='none' stroke-linecap='round' stroke-linejoin='round'/></svg>\")" : "none",
                                                                            backgroundRepeat: "no-repeat",
                                                                            backgroundPosition: "center"
                                                                        }
                                                                    })
                                                                ]
                                                            }),
                                                            expandedOtherItems[index] && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                style: {
                                                                    padding: "8px 14px",
                                                                    backgroundColor: activeTheme.cardBackground,
                                                                    color: activeTheme.cardFont
                                                                },
                                                                children: [
                                                                    validitytoBeShown && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                        className: "data-row",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                style: {
                                                                                    fontWeight: 500
                                                                                },
                                                                                children: [
                                                                                    durationLabel,
                                                                                    ":"
                                                                                ]
                                                                            }),
                                                                            " ",
                                                                            item.duration.value,
                                                                            " ",
                                                                            item.duration.unit
                                                                        ]
                                                                    }),
                                                                    !(dataItemToBeShown === false && processActivityNameToBeShown === false && processorNameToBeShown === false) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "required-details-container"
                                                                    }),
                                                                    item.processorActivities.map((activity, idx)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                                    style: {
                                                                                        marginTop: "0.5rem"
                                                                                    },
                                                                                    children: [
                                                                                        processActivityNameToBeShown && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                            className: "data-row",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                                    style: {
                                                                                                        fontWeight: 500
                                                                                                    },
                                                                                                    children: [
                                                                                                        processingActivityLabel,
                                                                                                        ":"
                                                                                                    ]
                                                                                                }),
                                                                                                " ",
                                                                                                activity.activityName
                                                                                            ]
                                                                                        }),
                                                                                        processorNameToBeShown && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                            className: "data-row",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                                    style: {
                                                                                                        fontWeight: 500
                                                                                                    },
                                                                                                    children: [
                                                                                                        usedbyLabel,
                                                                                                        ":"
                                                                                                    ]
                                                                                                }),
                                                                                                " ",
                                                                                                activity.processorName
                                                                                            ]
                                                                                        }),
                                                                                        dataItemToBeShown && activity.dataTypes.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                                    className: "data-row",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                                            style: {
                                                                                                                fontWeight: 500
                                                                                                            },
                                                                                                            children: [
                                                                                                                dataTypeLabel,
                                                                                                                ":"
                                                                                                            ]
                                                                                                        }),
                                                                                                        " ",
                                                                                                        activity.dataTypes.map((dt)=>dt.dataTypeName).join(", ")
                                                                                                    ]
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                                    className: "data-row",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                                            style: {
                                                                                                                fontWeight: 500
                                                                                                            },
                                                                                                            children: [
                                                                                                                dataItemLabel,
                                                                                                                ":"
                                                                                                            ]
                                                                                                        }),
                                                                                                        " ",
                                                                                                        activity.dataTypes.flatMap((dt)=>dt.dataItems).join(", ")
                                                                                                    ]
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                !(dataItemToBeShown === false && processActivityNameToBeShown === false && processorNameToBeShown === false) && idx !== item.processorActivities.length - 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                                    className: "required-details-container"
                                                                                })
                                                                            ]
                                                                        }, idx))
                                                                ]
                                                            })
                                                        ]
                                                    }, index))
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "documentText",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    style: {
                                                        cursor: "not-allowed",
                                                        color: "#aaa",
                                                        pointerEvents: "none"
                                                    },
                                                    onClick: openDocument,
                                                    children: documentName
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "container-7",
                                                children: parentalControl && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                    className: "container-7-outer",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                            type: "checkbox",
                                                            disabled: true,
                                                            className: "container-7-checkbox",
                                                            checked: isParentChecked,
                                                            onChange: (e)=>checkParentKYC(e.target.checked),
                                                            style: {
                                                                border: `1px solid ${activeTheme.cardFont}`,
                                                                backgroundColor: isParentChecked ? activeTheme.buttonBackground : "white",
                                                                backgroundImage: isParentChecked ? "url(\"data:image/svg+xml;utf8,<svg viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg'><path d='M3 8l3 3 7-7' stroke='white' stroke-width='2' fill='none' stroke-linecap='round' stroke-linejoin='round'/></svg>\")" : "none",
                                                                backgroundRepeat: "no-repeat",
                                                                backgroundPosition: "center"
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "container-7-text",
                                                            children: ageSentence
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "container-8",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                    children: [
                                                        rightsDescription,
                                                        " ",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            style: {
                                                                cursor: "pointer",
                                                                color: activeTheme.linkFont
                                                            }
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "container-9",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    children: permissionDescription
                                                })
                                            })
                                        ]
                                    }),
                                    selectedConsentStatus === "ACTIVE" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "container-10",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            className: "container-10-button",
                                            style: {
                                                backgroundColor: activeTheme.buttonFont,
                                                border: "1px solid rgb(181, 181, 181)"
                                            },
                                            onClick: handleConfirm,
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                style: {
                                                    fontFamily: "system-ui",
                                                    fontWeight: 700,
                                                    // color: "rgba(102, 0, 20, 1)",
                                                    color: activeTheme.buttonBackground,
                                                    fontSize: "18px"
                                                },
                                                children: withdrawConsentBtnText
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    sessionExpired && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63ff59473b55bad2$export$2e2bcd8739ae039), {
                        isOpen: sessionExpired,
                        onClose: ()=>setSessionExpired(false)
                    }),
                    showUpdateModal && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "modal-outer-container",
                        children: [
                            darkModeToBeShown && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "theme-toggle-container",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    className: "theme-switch",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "checkbox",
                                            checked: isDarkMode,
                                            onChange: ()=>setIsDarkMode(!isDarkMode)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "slider round"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "modal-container",
                                style: {
                                    backgroundColor: activeTheme.cardBackground,
                                    color: activeTheme.cardFont,
                                    fontFamily: "var(--portal-font-family, system-ui)",
                                    "--consent-main-acc-bg": activeTheme.mainAccordionBackground,
                                    "--consent-main-acc-fg": activeTheme.mainAccordionFont,
                                    "--consent-sub-acc-bg": activeTheme.subAccordionBackground,
                                    "--consent-sub-acc-fg": activeTheme.subAccordionFont,
                                    "--consent-lang-bg": activeTheme.languageDropdownBackground,
                                    "--consent-lang-fg": activeTheme.languageDropdownFont,
                                    "--consent-badge-fg": activeTheme.activeBadgeFont
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "container-1",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            class: "close-btn",
                                            style: {
                                                "--close-color": activeTheme.buttonBackground
                                            },
                                            onClick: closeEditConsentModal
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "fidu-heading-container",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "container-2-left",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "container-2-left-1",
                                                        children: modalHeading
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "container-2-left-2",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "container-2-left-2-dropdown",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab6d9bfa47542205$export$28390bfec38e5c4f), {
                                                                    height: 20,
                                                                    width: 20,
                                                                    className: "container-2-left-2-dropdown-Icon",
                                                                    style: {
                                                                        color: `${activeTheme.cardFont}`
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                                                    className: "container-2-left-2-dropdown-select",
                                                                    value: selectedLang,
                                                                    onChange: handleLanguageChange,
                                                                    disabled: selectedConsentStatus !== "ACTIVE",
                                                                    onClick: ()=>setIsOpen((prev)=>!prev),
                                                                    onBlur: ()=>setIsOpen(false),
                                                                    style: {
                                                                        backgroundColor: activeTheme.languageDropdownBackground,
                                                                        color: activeTheme.languageDropdownFont
                                                                    },
                                                                    children: languages.map((lang)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                            value: lang.value,
                                                                            children: lang.label
                                                                        }, lang.value))
                                                                }),
                                                                isOpen ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9efe7828a40b52f7$export$acd925e63e14000f), {
                                                                    height: 20,
                                                                    width: 20,
                                                                    className: "container-2-left-2-dropdown-Icon-right",
                                                                    style: {
                                                                        color: `${activeTheme.cardFont}`
                                                                    }
                                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fdc94045ec0e5793$export$ec7db1c418c1ec5a), {
                                                                    height: 20,
                                                                    width: 20,
                                                                    className: "container-2-left-2-dropdown-Icon-right",
                                                                    style: {
                                                                        color: `${activeTheme.cardFont}`
                                                                    }
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                src: logoUrl,
                                                alt: "Logo",
                                                className: "logo-image"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mainScrollableContainer",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "container-3",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    children: topDescription
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "container-4",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                    children: [
                                                        customerIdLabel,
                                                        ": ",
                                                        cusId
                                                    ]
                                                })
                                            }),
                                            formData && Object.keys(formData).length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                onClick: ()=>setShowRequiredDetails(!showREquiredDetails),
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "container-5-required",
                                                        style: showREquiredDetails ? {
                                                            borderBottom: "none",
                                                            borderBottomLeftRadius: 0,
                                                            borderBottomRightRadius: 0
                                                        } : {},
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                style: {
                                                                    display: "flex",
                                                                    justifyContent: "flex-start"
                                                                },
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                                                    width: "30",
                                                                    height: "30",
                                                                    viewBox: "5 0 12 23",
                                                                    style: {
                                                                        // position: "absolute",
                                                                        top: "50%",
                                                                        right: "10px",
                                                                        transform: showREquiredDetails ? "translateY(0%) rotate(180deg)" : "translateY(0%) rotate(0deg)",
                                                                        pointerEvents: "none",
                                                                        transition: "transform 0.3s ease",
                                                                        color: activeTheme.buttonBackground
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                        d: "M12 15a1.002 1.002 0 01-.71-.29l-4-4a1.004 1.004 0 111.42-1.42l3.29 3.3 3.29-3.3a1.004 1.004 0 111.42 1.42l-4 4A1.001 1.001 0 0112 15z",
                                                                        fill: "currentColor"
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "container-Heading-fs",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                    children: requiredText
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "badge-container-outer",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "badge-container",
                                                                        style: {
                                                                            border: `1px solid ${activeTheme.cardFont}`,
                                                                            backgroundColor: activeTheme.cardBackground
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                            className: "modal-badge",
                                                                            children: activeBadge
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                        type: "checkbox",
                                                                        disabled: true,
                                                                        checked: true,
                                                                        readOnly: true,
                                                                        style: {
                                                                            appearance: "none",
                                                                            WebkitAppearance: "none",
                                                                            MozAppearance: "none",
                                                                            height: "20px",
                                                                            width: "20px",
                                                                            borderRadius: "4px",
                                                                            border: `1px solid ${activeTheme.mainAccordionFont || activeTheme.cardFont}`,
                                                                            cursor: "default",
                                                                            flexShrink: 0,
                                                                            marginLeft: "8px",
                                                                            backgroundColor: activeTheme.buttonBackground,
                                                                            backgroundImage: "url(\"data:image/svg+xml;utf8,<svg viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg'><path d='M3 8l3 3 7-7' stroke='white' stroke-width='2' fill='none' stroke-linecap='round' stroke-linejoin='round'/></svg>\")",
                                                                            backgroundRepeat: "no-repeat",
                                                                            backgroundPosition: "center"
                                                                        }
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "required-details-container"
                                                    })
                                                ]
                                            }),
                                            showREquiredDetails && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                children: formData.map((item, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "sub-acc-item",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                style: {
                                                                    backgroundColor: activeTheme.subAccordionBackground,
                                                                    color: activeTheme.subAccordionFont,
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "space-between",
                                                                    padding: "10px 14px",
                                                                    cursor: "pointer"
                                                                },
                                                                onClick: ()=>setExpandedRequiredItems((prev)=>({
                                                                            ...prev,
                                                                            [index]: !prev[index]
                                                                        })),
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        style: {
                                                                            display: "flex",
                                                                            alignItems: "flex-start",
                                                                            gap: "8px",
                                                                            flex: 1
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                                                                width: "20",
                                                                                height: "20",
                                                                                viewBox: "5 0 12 23",
                                                                                style: {
                                                                                    flexShrink: 0,
                                                                                    transform: expandedRequiredItems[index] ? "rotate(180deg)" : "rotate(0deg)",
                                                                                    transition: "transform 0.3s ease",
                                                                                    color: activeTheme.buttonBackground,
                                                                                    pointerEvents: "none"
                                                                                },
                                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                    d: "M12 15a1.002 1.002 0 01-.71-.29l-4-4a1.004 1.004 0 111.42-1.42l3.29 3.3 3.29-3.3a1.004 1.004 0 111.42 1.42l-4 4A1.001 1.001 0 0112 15z",
                                                                                    fill: "currentColor"
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                style: {
                                                                                    fontWeight: 700,
                                                                                    fontSize: "14px"
                                                                                },
                                                                                children: item.purpose.join(", ")
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                        type: "checkbox",
                                                                        disabled: true,
                                                                        checked: true,
                                                                        readOnly: true,
                                                                        style: {
                                                                            appearance: "none",
                                                                            WebkitAppearance: "none",
                                                                            MozAppearance: "none",
                                                                            height: "20px",
                                                                            width: "20px",
                                                                            borderRadius: "4px",
                                                                            border: `1px solid ${activeTheme.subAccordionFont || activeTheme.cardFont}`,
                                                                            cursor: "default",
                                                                            flexShrink: 0,
                                                                            marginLeft: "8px",
                                                                            backgroundColor: activeTheme.buttonBackground,
                                                                            backgroundImage: "url(\"data:image/svg+xml;utf8,<svg viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg'><path d='M3 8l3 3 7-7' stroke='white' stroke-width='2' fill='none' stroke-linecap='round' stroke-linejoin='round'/></svg>\")",
                                                                            backgroundRepeat: "no-repeat",
                                                                            backgroundPosition: "center"
                                                                        }
                                                                    })
                                                                ]
                                                            }),
                                                            expandedRequiredItems[index] && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                style: {
                                                                    padding: "8px 14px",
                                                                    backgroundColor: activeTheme.cardBackground,
                                                                    color: activeTheme.cardFont
                                                                },
                                                                children: [
                                                                    validitytoBeShown && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                        className: "data-row",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                style: {
                                                                                    fontWeight: 500
                                                                                },
                                                                                children: [
                                                                                    durationLabel,
                                                                                    ":"
                                                                                ]
                                                                            }),
                                                                            " ",
                                                                            item.duration.value,
                                                                            " ",
                                                                            item.duration.unit
                                                                        ]
                                                                    }),
                                                                    !(dataItemToBeShown === false && processActivityNameToBeShown === false && processorNameToBeShown === false) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "required-details-container"
                                                                    }),
                                                                    item.processorActivities.map((activity, idx)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                                    style: {
                                                                                        marginTop: "0.5rem"
                                                                                    },
                                                                                    children: [
                                                                                        processActivityNameToBeShown && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                            className: "data-row",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                                    style: {
                                                                                                        fontWeight: 500
                                                                                                    },
                                                                                                    children: [
                                                                                                        processingActivityLabel,
                                                                                                        ":"
                                                                                                    ]
                                                                                                }),
                                                                                                " ",
                                                                                                activity.activityName
                                                                                            ]
                                                                                        }),
                                                                                        processorNameToBeShown && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                            className: "data-row",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                                    style: {
                                                                                                        fontWeight: 500
                                                                                                    },
                                                                                                    children: [
                                                                                                        usedbyLabel,
                                                                                                        ":"
                                                                                                    ]
                                                                                                }),
                                                                                                " ",
                                                                                                activity.processorName
                                                                                            ]
                                                                                        }),
                                                                                        dataItemToBeShown && activity.dataTypes.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                                    className: "data-row",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                                            style: {
                                                                                                                fontWeight: 500
                                                                                                            },
                                                                                                            children: [
                                                                                                                dataTypeLabel,
                                                                                                                ":"
                                                                                                            ]
                                                                                                        }),
                                                                                                        " ",
                                                                                                        activity.dataTypes.map((dt)=>dt.dataTypeName).join(", ")
                                                                                                    ]
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                                    className: "data-row",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                                            style: {
                                                                                                                fontWeight: 500
                                                                                                            },
                                                                                                            children: [
                                                                                                                dataItemLabel,
                                                                                                                ":"
                                                                                                            ]
                                                                                                        }),
                                                                                                        " ",
                                                                                                        activity.dataTypes.flatMap((dt)=>dt.dataItems).join(", ")
                                                                                                    ]
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                !(dataItemToBeShown === false && processActivityNameToBeShown === false && processorNameToBeShown === false) && idx !== item.processorActivities.length - 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                                    className: "required-details-container"
                                                                                })
                                                                            ]
                                                                        }, idx))
                                                                ]
                                                            })
                                                        ]
                                                    }, index))
                                            }),
                                            formOtherData && Object.keys(formOtherData).length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "container-6",
                                                        onClick: ()=>setShowOthersDetails(!showOhersDetails),
                                                        style: showOhersDetails ? {
                                                            borderBottom: "none",
                                                            borderBottomLeftRadius: 0,
                                                            borderBottomRightRadius: 0
                                                        } : {},
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                style: {
                                                                    display: "flex",
                                                                    justifyContent: "flex-start",
                                                                    alignItems: "center"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                                                        width: "30",
                                                                        height: "30",
                                                                        viewBox: "5 0 12 23",
                                                                        style: {
                                                                            // position: "absolute",
                                                                            top: "50%",
                                                                            right: "10px",
                                                                            transform: showOhersDetails ? "translateY(0%) rotate(180deg)" : "translateY(0%) rotate(0deg)",
                                                                            pointerEvents: "none",
                                                                            transition: "transform 0.3s ease",
                                                                            color: activeTheme.buttonBackground
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                            d: "M12 15a1.002 1.002 0 01-.71-.29l-4-4a1.004 1.004 0 111.42-1.42l3.29 3.3 3.29-3.3a1.004 1.004 0 111.42 1.42l-4 4A1.001 1.001 0 0112 15z",
                                                                            fill: "currentColor"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "container-Heading-fs",
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                            children: otherAccordionHeader
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                type: "checkbox",
                                                                className: "container-6-checkbox",
                                                                checked: allSelected,
                                                                onChange: (e)=>handleSelectAll(e.target.checked),
                                                                style: {
                                                                    appearance: "none",
                                                                    WebkitAppearance: "none",
                                                                    MozAppearance: "none",
                                                                    height: "25px",
                                                                    width: "25px",
                                                                    borderRadius: "4px",
                                                                    border: `1px solid ${activeTheme.mainAccordionFont || activeTheme.cardFont}`,
                                                                    cursor: "pointer",
                                                                    backgroundColor: activeTheme.buttonBackground,
                                                                    backgroundImage: allSelected ? "url(\"data:image/svg+xml;utf8,<svg viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg'><path d='M3 8l3 3 7-7' stroke='white' stroke-width='2' fill='none' stroke-linecap='round' stroke-linejoin='round'/></svg>\")" : "none",
                                                                    backgroundRepeat: "no-repeat",
                                                                    backgroundPosition: "center"
                                                                }
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "required-details-container"
                                                    })
                                                ]
                                            }),
                                            showOhersDetails && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                children: formOtherData.map((item, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "sub-acc-item",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                style: {
                                                                    backgroundColor: activeTheme.subAccordionBackground,
                                                                    color: activeTheme.subAccordionFont,
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "space-between",
                                                                    padding: "10px 16px",
                                                                    cursor: "pointer"
                                                                },
                                                                onClick: ()=>setExpandedOtherItems((prev)=>({
                                                                            ...prev,
                                                                            [index]: !prev[index]
                                                                        })),
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        style: {
                                                                            display: "flex",
                                                                            alignItems: "flex-start",
                                                                            gap: "8px",
                                                                            flex: 1
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                                                                width: "20",
                                                                                height: "20",
                                                                                viewBox: "5 0 12 23",
                                                                                style: {
                                                                                    flexShrink: 0,
                                                                                    transform: expandedOtherItems[index] ? "rotate(180deg)" : "rotate(0deg)",
                                                                                    transition: "transform 0.3s ease",
                                                                                    color: activeTheme.buttonBackground,
                                                                                    pointerEvents: "none"
                                                                                },
                                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                    d: "M12 15a1.002 1.002 0 01-.71-.29l-4-4a1.004 1.004 0 111.42-1.42l3.29 3.3 3.29-3.3a1.004 1.004 0 111.42 1.42l-4 4A1.001 1.001 0 0112 15z",
                                                                                    fill: "currentColor"
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                style: {
                                                                                    fontWeight: 700,
                                                                                    fontSize: "14px"
                                                                                },
                                                                                children: item.purpose.join(", ")
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                        type: "checkbox",
                                                                        checked: selectedPrefereneces[item.id] === "ACCEPTED",
                                                                        onChange: (e)=>handlePreferenceChange(item.id, e.target.checked),
                                                                        onClick: (e)=>e.stopPropagation(),
                                                                        style: {
                                                                            appearance: "none",
                                                                            WebkitAppearance: "none",
                                                                            MozAppearance: "none",
                                                                            height: "20px",
                                                                            width: "20px",
                                                                            borderRadius: "4px",
                                                                            border: `1px solid ${activeTheme.subAccordionFont || activeTheme.cardFont}`,
                                                                            cursor: "pointer",
                                                                            flexShrink: 0,
                                                                            backgroundColor: selectedPrefereneces[item.id] === "ACCEPTED" ? activeTheme.buttonBackground : "white",
                                                                            backgroundImage: selectedPrefereneces[item.id] === "ACCEPTED" ? "url(\"data:image/svg+xml;utf8,<svg viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg'><path d='M3 8l3 3 7-7' stroke='white' stroke-width='2' fill='none' stroke-linecap='round' stroke-linejoin='round'/></svg>\")" : "none",
                                                                            backgroundRepeat: "no-repeat",
                                                                            backgroundPosition: "center"
                                                                        }
                                                                    })
                                                                ]
                                                            }),
                                                            expandedOtherItems[index] && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                style: {
                                                                    padding: "8px 14px",
                                                                    backgroundColor: activeTheme.cardBackground,
                                                                    color: activeTheme.cardFont
                                                                },
                                                                children: [
                                                                    validitytoBeShown && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                        className: "data-row",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                style: {
                                                                                    fontWeight: 500
                                                                                },
                                                                                children: [
                                                                                    durationLabel,
                                                                                    ":"
                                                                                ]
                                                                            }),
                                                                            " ",
                                                                            item.duration.value,
                                                                            " ",
                                                                            item.duration.unit
                                                                        ]
                                                                    }),
                                                                    !(dataItemToBeShown === false && processActivityNameToBeShown === false && processorNameToBeShown === false) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "required-details-container"
                                                                    }),
                                                                    item.processorActivities.map((activity, idx)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                                    style: {
                                                                                        marginTop: "0.5rem"
                                                                                    },
                                                                                    children: [
                                                                                        processActivityNameToBeShown && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                            className: "data-row",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                                    style: {
                                                                                                        fontWeight: 500
                                                                                                    },
                                                                                                    children: [
                                                                                                        processingActivityLabel,
                                                                                                        ":"
                                                                                                    ]
                                                                                                }),
                                                                                                " ",
                                                                                                activity.activityName
                                                                                            ]
                                                                                        }),
                                                                                        processorNameToBeShown && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                            className: "data-row",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                                    style: {
                                                                                                        fontWeight: 500
                                                                                                    },
                                                                                                    children: [
                                                                                                        usedbyLabel,
                                                                                                        ":"
                                                                                                    ]
                                                                                                }),
                                                                                                " ",
                                                                                                activity.processorName
                                                                                            ]
                                                                                        }),
                                                                                        dataItemToBeShown && activity.dataTypes.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                                    className: "data-row",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                                            style: {
                                                                                                                fontWeight: 500
                                                                                                            },
                                                                                                            children: [
                                                                                                                dataTypeLabel,
                                                                                                                ":"
                                                                                                            ]
                                                                                                        }),
                                                                                                        " ",
                                                                                                        activity.dataTypes.map((dt)=>dt.dataTypeName).join(", ")
                                                                                                    ]
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                                    className: "data-row",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                                            style: {
                                                                                                                fontWeight: 500
                                                                                                            },
                                                                                                            children: [
                                                                                                                dataItemLabel,
                                                                                                                ":"
                                                                                                            ]
                                                                                                        }),
                                                                                                        " ",
                                                                                                        activity.dataTypes.flatMap((dt)=>dt.dataItems).join(", ")
                                                                                                    ]
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                !(dataItemToBeShown === false && processActivityNameToBeShown === false && processorNameToBeShown === false) && idx !== item.processorActivities.length - 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                                    className: "required-details-container"
                                                                                })
                                                                            ]
                                                                        }, idx))
                                                                ]
                                                            })
                                                        ]
                                                    }, index))
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "documentText",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    style: {
                                                        cursor: "pointer",
                                                        color: activeTheme.linkFont
                                                    },
                                                    onClick: openDocument,
                                                    children: documentName
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "container-7",
                                                children: parentalControl && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                    className: "container-7-outer",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                            type: "checkbox",
                                                            disabled: true,
                                                            className: "container-7-checkbox",
                                                            checked: isParentChecked,
                                                            onChange: (e)=>checkParentKYC(e.target.checked),
                                                            style: {
                                                                border: `1px solid ${activeTheme.cardFont}`,
                                                                backgroundColor: isParentChecked ? activeTheme.buttonBackground : "white",
                                                                backgroundImage: isParentChecked ? "url(\"data:image/svg+xml;utf8,<svg viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg'><path d='M3 8l3 3 7-7' stroke='white' stroke-width='2' fill='none' stroke-linecap='round' stroke-linejoin='round'/></svg>\")" : "none",
                                                                backgroundRepeat: "no-repeat",
                                                                backgroundPosition: "center"
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "container-7-text",
                                                            children: ageSentence
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "container-8",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                    children: [
                                                        rightsDescription,
                                                        " ",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            style: {
                                                                cursor: "pointer",
                                                                color: activeTheme.linkFont
                                                            }
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "container-9",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    children: permissionDescription
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "container-10-update",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                className: "container-10-update-withdraw",
                                                onClick: handleUpdateConfirm,
                                                style: {
                                                    backgroundColor: activeTheme.buttonFont,
                                                    border: "1px solid rgb(181, 181, 181)"
                                                },
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "container-10-update-withdraw-text",
                                                    style: {
                                                        color: activeTheme.buttonBackground
                                                    },
                                                    children: withdrawConsentBtnText
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                className: "container-10-update-consent",
                                                onClick: handleUpdateConsent,
                                                style: {
                                                    backgroundColor: activeTheme.buttonBackground,
                                                    border: "1px solid rgb(181, 181, 181)"
                                                },
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "container-10-update-consent-text ",
                                                    style: {
                                                        color: activeTheme.buttonFont
                                                    },
                                                    children: updateConsentBtnText
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    showRenewModal && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "modal-outer-container",
                        children: [
                            darkModeToBeShown && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "theme-toggle-container",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    className: "theme-switch",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "checkbox",
                                            checked: isDarkMode,
                                            onChange: ()=>setIsDarkMode(!isDarkMode)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "slider round"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "modal-container",
                                style: {
                                    backgroundColor: activeTheme.cardBackground,
                                    color: activeTheme.cardFont,
                                    fontFamily: "var(--portal-font-family, system-ui)",
                                    "--consent-main-acc-bg": activeTheme.mainAccordionBackground,
                                    "--consent-main-acc-fg": activeTheme.mainAccordionFont,
                                    "--consent-sub-acc-bg": activeTheme.subAccordionBackground,
                                    "--consent-sub-acc-fg": activeTheme.subAccordionFont,
                                    "--consent-lang-bg": activeTheme.languageDropdownBackground,
                                    "--consent-lang-fg": activeTheme.languageDropdownFont,
                                    "--consent-badge-fg": activeTheme.activeBadgeFont
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "container-1",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            class: "close-btn",
                                            style: {
                                                "--close-color": activeTheme.buttonBackground
                                            },
                                            onClick: closeRenewConsentModal
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "fidu-heading-container",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "container-2-left",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "container-2-left-1",
                                                        children: modalHeading
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "container-2-left-2",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "container-2-left-2-dropdown",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab6d9bfa47542205$export$28390bfec38e5c4f), {
                                                                    height: 20,
                                                                    width: 20,
                                                                    className: "container-2-left-2-dropdown-Icon",
                                                                    style: {
                                                                        color: `${activeTheme.cardFont}`
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                                                    className: "container-2-left-2-dropdown-select",
                                                                    value: selectedLang,
                                                                    onChange: handleLanguageChange,
                                                                    disabled: selectedConsentStatus !== "ACTIVE",
                                                                    onClick: ()=>setIsOpen((prev)=>!prev),
                                                                    onBlur: ()=>setIsOpen(false),
                                                                    style: {
                                                                        backgroundColor: activeTheme.languageDropdownBackground,
                                                                        color: activeTheme.languageDropdownFont
                                                                    },
                                                                    children: languages.map((lang)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                            value: lang.value,
                                                                            children: lang.label
                                                                        }, lang.value))
                                                                }),
                                                                isOpen ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9efe7828a40b52f7$export$acd925e63e14000f), {
                                                                    height: 20,
                                                                    width: 20,
                                                                    className: "container-2-left-2-dropdown-Icon-right",
                                                                    style: {
                                                                        color: `${activeTheme.cardFont}`
                                                                    }
                                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fdc94045ec0e5793$export$ec7db1c418c1ec5a), {
                                                                    height: 20,
                                                                    width: 20,
                                                                    className: "container-2-left-2-dropdown-Icon-right",
                                                                    style: {
                                                                        color: `${activeTheme.cardFont}`
                                                                    }
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                src: logoUrl,
                                                alt: "Logo",
                                                className: "logo-image"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mainScrollableContainer",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "container-3",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    children: topDescription
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "container-4",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                    children: [
                                                        customerIdLabel,
                                                        ": ",
                                                        cusId
                                                    ]
                                                })
                                            }),
                                            formData && Object.keys(formData).length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                onClick: ()=>setShowRequiredDetails(!showREquiredDetails),
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "container-5-required",
                                                        style: showREquiredDetails ? {
                                                            borderBottom: "none",
                                                            borderBottomLeftRadius: 0,
                                                            borderBottomRightRadius: 0
                                                        } : {},
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                style: {
                                                                    display: "flex",
                                                                    justifyContent: "flex-start"
                                                                },
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                                                    width: "30",
                                                                    height: "30",
                                                                    viewBox: "5 0 12 23",
                                                                    style: {
                                                                        // position: "absolute",
                                                                        top: "50%",
                                                                        right: "10px",
                                                                        transform: showREquiredDetails ? "translateY(0%) rotate(180deg)" : "translateY(0%) rotate(0deg)",
                                                                        pointerEvents: "none",
                                                                        transition: "transform 0.3s ease",
                                                                        color: activeTheme.buttonBackground
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                        d: "M12 15a1.002 1.002 0 01-.71-.29l-4-4a1.004 1.004 0 111.42-1.42l3.29 3.3 3.29-3.3a1.004 1.004 0 111.42 1.42l-4 4A1.001 1.001 0 0112 15z",
                                                                        fill: "currentColor"
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "container-Heading-fs",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                    children: requiredText
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "badge-container-outer",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "badge-container",
                                                                        style: {
                                                                            border: `1px solid ${activeTheme.cardFont}`,
                                                                            backgroundColor: activeTheme.cardBackground
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                            className: "modal-badge",
                                                                            children: activeBadge
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                        type: "checkbox",
                                                                        disabled: true,
                                                                        checked: true,
                                                                        readOnly: true,
                                                                        style: {
                                                                            appearance: "none",
                                                                            WebkitAppearance: "none",
                                                                            MozAppearance: "none",
                                                                            height: "20px",
                                                                            width: "20px",
                                                                            borderRadius: "4px",
                                                                            border: `1px solid ${activeTheme.mainAccordionFont || activeTheme.cardFont}`,
                                                                            cursor: "default",
                                                                            flexShrink: 0,
                                                                            marginLeft: "8px",
                                                                            backgroundColor: activeTheme.buttonBackground,
                                                                            backgroundImage: "url(\"data:image/svg+xml;utf8,<svg viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg'><path d='M3 8l3 3 7-7' stroke='white' stroke-width='2' fill='none' stroke-linecap='round' stroke-linejoin='round'/></svg>\")",
                                                                            backgroundRepeat: "no-repeat",
                                                                            backgroundPosition: "center"
                                                                        }
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "required-details-container"
                                                    })
                                                ]
                                            }),
                                            showREquiredDetails && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                children: formData.map((item, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "sub-acc-item",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                style: {
                                                                    backgroundColor: activeTheme.subAccordionBackground,
                                                                    color: activeTheme.subAccordionFont,
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "space-between",
                                                                    padding: "10px 14px",
                                                                    cursor: "pointer",
                                                                    opacity: Number(item.preferenceExpiry) < 30 && item.autoRenewStatus === true ? 1 : 0.5,
                                                                    pointerEvents: Number(item.preferenceExpiry) < 30 && item.autoRenewStatus === true ? "auto" : "none"
                                                                },
                                                                onClick: ()=>setExpandedRequiredItems((prev)=>({
                                                                            ...prev,
                                                                            [index]: !prev[index]
                                                                        })),
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        style: {
                                                                            display: "flex",
                                                                            alignItems: "flex-start",
                                                                            gap: "8px",
                                                                            flex: 1
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                                                                width: "20",
                                                                                height: "20",
                                                                                viewBox: "5 0 12 23",
                                                                                style: {
                                                                                    flexShrink: 0,
                                                                                    transform: expandedRequiredItems[index] ? "rotate(180deg)" : "rotate(0deg)",
                                                                                    transition: "transform 0.3s ease",
                                                                                    color: activeTheme.buttonBackground,
                                                                                    pointerEvents: "none"
                                                                                },
                                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                    d: "M12 15a1.002 1.002 0 01-.71-.29l-4-4a1.004 1.004 0 111.42-1.42l3.29 3.3 3.29-3.3a1.004 1.004 0 111.42 1.42l-4 4A1.001 1.001 0 0112 15z",
                                                                                    fill: "currentColor"
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                style: {
                                                                                    fontWeight: 700,
                                                                                    fontSize: "14px"
                                                                                },
                                                                                children: item.purpose.join(", ")
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                        type: "checkbox",
                                                                        onChange: (e)=>{
                                                                            e.stopPropagation();
                                                                            handleRenewPrefereneceChange(item.id, e.target.checked);
                                                                        },
                                                                        checked: listOfRenewPref[item.id] === "RENEW",
                                                                        onClick: (e)=>e.stopPropagation(),
                                                                        style: {
                                                                            appearance: "none",
                                                                            WebkitAppearance: "none",
                                                                            MozAppearance: "none",
                                                                            height: "20px",
                                                                            width: "20px",
                                                                            borderRadius: "4px",
                                                                            border: `1px solid ${activeTheme.subAccordionFont}`,
                                                                            cursor: "pointer",
                                                                            flexShrink: 0,
                                                                            backgroundColor: listOfRenewPref[item.id] === "RENEW" ? activeTheme.buttonBackground : "white",
                                                                            backgroundImage: listOfRenewPref[item.id] === "RENEW" ? "url(\"data:image/svg+xml;utf8,<svg viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg'><path d='M3 8l3 3 7-7' stroke='white' stroke-width='2' fill='none' stroke-linecap='round' stroke-linejoin='round'/></svg>\")" : "none",
                                                                            backgroundRepeat: "no-repeat",
                                                                            backgroundPosition: "center"
                                                                        }
                                                                    })
                                                                ]
                                                            }),
                                                            expandedRequiredItems[index] && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                style: {
                                                                    padding: "8px 14px",
                                                                    backgroundColor: activeTheme.cardBackground,
                                                                    color: activeTheme.cardFont
                                                                },
                                                                children: [
                                                                    validitytoBeShown && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                        className: "data-row",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                style: {
                                                                                    fontWeight: 500
                                                                                },
                                                                                children: [
                                                                                    durationLabel,
                                                                                    ":"
                                                                                ]
                                                                            }),
                                                                            " ",
                                                                            item.duration.value,
                                                                            " ",
                                                                            item.duration.unit
                                                                        ]
                                                                    }),
                                                                    item.processorActivities.map((activity, idx)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                                    style: {
                                                                                        marginTop: "0.5rem"
                                                                                    },
                                                                                    children: [
                                                                                        processActivityNameToBeShown && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                            className: "data-row",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                                    style: {
                                                                                                        fontWeight: 500
                                                                                                    },
                                                                                                    children: [
                                                                                                        processingActivityLabel,
                                                                                                        ":"
                                                                                                    ]
                                                                                                }),
                                                                                                " ",
                                                                                                activity.activityName
                                                                                            ]
                                                                                        }),
                                                                                        processorNameToBeShown && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                            className: "data-row",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                                    style: {
                                                                                                        fontWeight: 500
                                                                                                    },
                                                                                                    children: [
                                                                                                        usedbyLabel,
                                                                                                        ":"
                                                                                                    ]
                                                                                                }),
                                                                                                " ",
                                                                                                activity.processorName
                                                                                            ]
                                                                                        }),
                                                                                        dataItemToBeShown && activity.dataTypes.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                                    className: "data-row",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                                            style: {
                                                                                                                fontWeight: 500
                                                                                                            },
                                                                                                            children: [
                                                                                                                dataTypeLabel,
                                                                                                                ":"
                                                                                                            ]
                                                                                                        }),
                                                                                                        " ",
                                                                                                        activity.dataTypes.map((dt)=>dt.dataTypeName).join(", ")
                                                                                                    ]
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                                    className: "data-row",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                                            style: {
                                                                                                                fontWeight: 500
                                                                                                            },
                                                                                                            children: [
                                                                                                                dataItemLabel,
                                                                                                                ":"
                                                                                                            ]
                                                                                                        }),
                                                                                                        " ",
                                                                                                        activity.dataTypes.flatMap((dt)=>dt.dataItems).join(", ")
                                                                                                    ]
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                !(dataItemToBeShown === false && processActivityNameToBeShown === false && processorNameToBeShown === false) && idx !== item.processorActivities.length - 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                                    className: "required-details-container"
                                                                                })
                                                                            ]
                                                                        }, idx))
                                                                ]
                                                            })
                                                        ]
                                                    }, index))
                                            }),
                                            formOtherData && Object.keys(formOtherData).length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "container-6",
                                                        onClick: ()=>setShowOthersDetails(!showOhersDetails),
                                                        style: showOhersDetails ? {
                                                            borderBottom: "none",
                                                            borderBottomLeftRadius: 0,
                                                            borderBottomRightRadius: 0
                                                        } : {},
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                style: {
                                                                    display: "flex",
                                                                    justifyContent: "flex-start",
                                                                    alignItems: "center"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                                                        width: "30",
                                                                        height: "30",
                                                                        viewBox: "5 0 12 23",
                                                                        style: {
                                                                            top: "50%",
                                                                            right: "10px",
                                                                            transform: showOhersDetails ? "translateY(0%) rotate(180deg)" : "translateY(0%) rotate(0deg)",
                                                                            pointerEvents: "none",
                                                                            transition: "transform 0.3s ease",
                                                                            color: activeTheme.buttonBackground
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                            d: "M12 15a1.002 1.002 0 01-.71-.29l-4-4a1.004 1.004 0 111.42-1.42l3.29 3.3 3.29-3.3a1.004 1.004 0 111.42 1.42l-4 4A1.001 1.001 0 0112 15z",
                                                                            fill: "currentColor"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "container-Heading-fs",
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                            children: otherAccordionHeader
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "required-details-container"
                                                            })
                                                        ]
                                                    }),
                                                    showOhersDetails && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        children: formOtherData.map((item, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "sub-acc-item",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        style: {
                                                                            backgroundColor: activeTheme.subAccordionBackground,
                                                                            color: activeTheme.subAccordionFont,
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            justifyContent: "space-between",
                                                                            padding: "10px 16px",
                                                                            cursor: "pointer",
                                                                            opacity: Number(item.preferenceExpiry) < 30 && item.autoRenewStatus === true ? 1 : 0.5,
                                                                            pointerEvents: Number(item.preferenceExpiry) < 30 && item.autoRenewStatus === true ? "auto" : "none"
                                                                        },
                                                                        onClick: ()=>setExpandedOtherItems((prev)=>({
                                                                                    ...prev,
                                                                                    [index]: !prev[index]
                                                                                })),
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                                style: {
                                                                                    display: "flex",
                                                                                    alignItems: "flex-start",
                                                                                    gap: "8px",
                                                                                    flex: 1
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                                                                        width: "20",
                                                                                        height: "20",
                                                                                        viewBox: "5 0 12 23",
                                                                                        style: {
                                                                                            flexShrink: 0,
                                                                                            transform: expandedOtherItems[index] ? "rotate(180deg)" : "rotate(0deg)",
                                                                                            transition: "transform 0.3s ease",
                                                                                            color: activeTheme.buttonBackground,
                                                                                            pointerEvents: "none"
                                                                                        },
                                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                            d: "M12 15a1.002 1.002 0 01-.71-.29l-4-4a1.004 1.004 0 111.42-1.42l3.29 3.3 3.29-3.3a1.004 1.004 0 111.42 1.42l-4 4A1.001 1.001 0 0112 15z",
                                                                                            fill: "currentColor"
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                        style: {
                                                                                            fontWeight: 700,
                                                                                            fontSize: "14px"
                                                                                        },
                                                                                        children: item.purpose.join(", ")
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                                type: "checkbox",
                                                                                onChange: (e)=>{
                                                                                    e.stopPropagation();
                                                                                    handleRenewPrefereneceChange(item.id, e.target.checked);
                                                                                },
                                                                                checked: listOfRenewPref[item.id] === "RENEW",
                                                                                onClick: (e)=>e.stopPropagation(),
                                                                                style: {
                                                                                    appearance: "none",
                                                                                    WebkitAppearance: "none",
                                                                                    MozAppearance: "none",
                                                                                    height: "20px",
                                                                                    width: "20px",
                                                                                    borderRadius: "4px",
                                                                                    border: `1px solid ${activeTheme.subAccordionFont}`,
                                                                                    cursor: "pointer",
                                                                                    flexShrink: 0,
                                                                                    backgroundColor: listOfRenewPref[item.id] === "RENEW" ? activeTheme.buttonBackground : "white",
                                                                                    backgroundImage: listOfRenewPref[item.id] === "RENEW" ? "url(\"data:image/svg+xml;utf8,<svg viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg'><path d='M3 8l3 3 7-7' stroke='white' stroke-width='2' fill='none' stroke-linecap='round' stroke-linejoin='round'/></svg>\")" : "none",
                                                                                    backgroundRepeat: "no-repeat",
                                                                                    backgroundPosition: "center"
                                                                                }
                                                                            })
                                                                        ]
                                                                    }),
                                                                    expandedOtherItems[index] && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        style: {
                                                                            padding: "8px 14px",
                                                                            backgroundColor: activeTheme.cardBackground,
                                                                            color: activeTheme.cardFont
                                                                        },
                                                                        children: [
                                                                            validitytoBeShown && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                className: "data-row",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                        style: {
                                                                                            fontWeight: 500
                                                                                        },
                                                                                        children: [
                                                                                            durationLabel,
                                                                                            ":"
                                                                                        ]
                                                                                    }),
                                                                                    " ",
                                                                                    item.duration.value,
                                                                                    " ",
                                                                                    item.duration.unit
                                                                                ]
                                                                            }),
                                                                            item.processorActivities.map((activity, idx)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                                            style: {
                                                                                                marginTop: "0.5rem"
                                                                                            },
                                                                                            children: [
                                                                                                processActivityNameToBeShown && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                                    className: "data-row",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                                            style: {
                                                                                                                fontWeight: 500
                                                                                                            },
                                                                                                            children: [
                                                                                                                processingActivityLabel,
                                                                                                                ":"
                                                                                                            ]
                                                                                                        }),
                                                                                                        " ",
                                                                                                        activity.activityName
                                                                                                    ]
                                                                                                }),
                                                                                                processorNameToBeShown && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                                    className: "data-row",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                                            style: {
                                                                                                                fontWeight: 500
                                                                                                            },
                                                                                                            children: [
                                                                                                                usedbyLabel,
                                                                                                                ":"
                                                                                                            ]
                                                                                                        }),
                                                                                                        " ",
                                                                                                        activity.processorName
                                                                                                    ]
                                                                                                }),
                                                                                                dataItemToBeShown && activity.dataTypes.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                                            className: "data-row",
                                                                                                            children: [
                                                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                                                    style: {
                                                                                                                        fontWeight: 500
                                                                                                                    },
                                                                                                                    children: [
                                                                                                                        dataTypeLabel,
                                                                                                                        ":"
                                                                                                                    ]
                                                                                                                }),
                                                                                                                " ",
                                                                                                                activity.dataTypes.map((dt)=>dt.dataTypeName).join(", ")
                                                                                                            ]
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                                            className: "data-row",
                                                                                                            children: [
                                                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                                                    style: {
                                                                                                                        fontWeight: 500
                                                                                                                    },
                                                                                                                    children: [
                                                                                                                        dataItemLabel,
                                                                                                                        ":"
                                                                                                                    ]
                                                                                                                }),
                                                                                                                " ",
                                                                                                                activity.dataTypes.flatMap((dt)=>dt.dataItems).join(", ")
                                                                                                            ]
                                                                                                        })
                                                                                                    ]
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        !(dataItemToBeShown === false && processActivityNameToBeShown === false && processorNameToBeShown === false) && idx !== item.processorActivities.length - 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                                            className: "required-details-container"
                                                                                        })
                                                                                    ]
                                                                                }, idx))
                                                                        ]
                                                                    })
                                                                ]
                                                            }, index))
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "documentText",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    style: {
                                                        cursor: "pointer",
                                                        color: activeTheme.linkFont
                                                    },
                                                    onClick: openDocument,
                                                    children: documentName
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "container-7",
                                                children: parentalControl && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                    className: "container-7-outer",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                            type: "checkbox",
                                                            disabled: true,
                                                            className: "container-7-checkbox",
                                                            checked: isParentChecked,
                                                            onChange: (e)=>checkParentKYC(e.target.checked),
                                                            style: {
                                                                border: `1px solid ${activeTheme.cardFont}`,
                                                                backgroundColor: isParentChecked ? activeTheme.buttonBackground : "white",
                                                                backgroundImage: isParentChecked ? "url(\"data:image/svg+xml;utf8,<svg viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg'><path d='M3 8l3 3 7-7' stroke='white' stroke-width='2' fill='none' stroke-linecap='round' stroke-linejoin='round'/></svg>\")" : "none",
                                                                backgroundRepeat: "no-repeat",
                                                                backgroundPosition: "center"
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "container-7-text",
                                                            children: ageSentence
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "container-8",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                    children: [
                                                        rightsDescription,
                                                        " ",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            style: {
                                                                cursor: "pointer",
                                                                color: activeTheme.linkFont
                                                            }
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "container-9",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    children: permissionDescription
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "container-10-update",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            className: "container-10-update-consent",
                                            onClick: handleRenewConsent,
                                            style: {
                                                backgroundColor: activeTheme.buttonBackground,
                                                border: "1px solid rgb(181, 181, 181)"
                                            },
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "container-10-update-consent-text ",
                                                style: {
                                                    color: activeTheme.buttonFont
                                                },
                                                children: renewConsentBtnText
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    showParentModal && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "modal-outer-container",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "modal-container",
                            style: {
                                backgroundColor: activeTheme.cardBackground,
                                color: activeTheme.cardFont
                            },
                            children: [
                                selectedKYCMethod === "I am away from my parent" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "step-header-parent",
                                    style: {
                                        display: "flex",
                                        justifyContent: currentModalStep === 2 ? "space-between" : "flex-end",
                                        alignItems: "center",
                                        marginBottom: "16px"
                                    },
                                    children: [
                                        currentModalStep === 2 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            onClick: ()=>setCurrentModalStep(1),
                                            style: {
                                                background: "none",
                                                border: "none",
                                                cursor: "pointer",
                                                padding: 0,
                                                display: "flex",
                                                alignItems: "center",
                                                color: activeTheme.buttonBackground
                                            },
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                                width: "24",
                                                height: "24",
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                    d: "M15 20a1.003 1.003 0 01-.71-.29l-7-7a1 1 0 010-1.42l7-7a1.005 1.005 0 011.42 1.42L9.41 12l6.3 6.29a.997.997 0 01.219 1.095.999.999 0 01-.93.615z",
                                                    fill: "currentColor"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "step-text-parent",
                                            style: {
                                                fontWeight: 700,
                                                fontSize: "16px"
                                            },
                                            children: [
                                                "Step ",
                                                currentModalStep,
                                                "/2"
                                            ]
                                        })
                                    ]
                                }),
                                currentModalStep === 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "parentTextStyle1",
                                            children: "Select verification method (Required)"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "dropdown-container-parent",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "dropdown-wrapper-parent",
                                                style: {
                                                    position: "relative"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                        className: "custom-select-parent",
                                                        value: selectedKYCMethod,
                                                        onChange: (e)=>setSelectedKYCMethod(e.target.value),
                                                        onClick: ()=>setIsOpenParent((prev)=>!prev),
                                                        onBlur: ()=>setIsOpenParent(false),
                                                        style: {
                                                            width: "100%",
                                                            height: "40px",
                                                            borderRadius: "8px",
                                                            border: "1px solid rgba(181, 181, 181, 1)",
                                                            paddingLeft: "8px",
                                                            paddingRight: "8px",
                                                            appearance: "none",
                                                            fontSize: "14px"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                value: "",
                                                                children: "Select Method"
                                                            }),
                                                            digilockerClientId && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                value: "digilocker",
                                                                children: "Digilocker"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                value: "declaration",
                                                                children: "Declaration based"
                                                            })
                                                        ]
                                                    }),
                                                    isOpenParent ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9efe7828a40b52f7$export$acd925e63e14000f), {
                                                        height: 20,
                                                        width: 20,
                                                        style: {
                                                            position: "absolute",
                                                            right: "8px",
                                                            top: "50%",
                                                            transform: "translateY(-50%)"
                                                        }
                                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fdc94045ec0e5793$export$ec7db1c418c1ec5a), {
                                                        height: 20,
                                                        width: 20,
                                                        style: {
                                                            position: "absolute",
                                                            right: "8px",
                                                            top: "50%",
                                                            transform: "translateY(-50%)"
                                                        }
                                                    })
                                                ]
                                            })
                                        }),
                                        selectedKYCMethod === "declaration" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "parentTextStyle1",
                                                    children: "Parent's name (Required)"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    className: "input-parent",
                                                    ref: parentNameRef
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "parentTextStyle1",
                                                    children: "Identity (Email or Mobile)"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    className: "input-parent",
                                                    ref: parentIdentityRef
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                currentModalStep === 2 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "parentTextStyle3",
                                            children: "OTP Verification"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "parentTextStyle1",
                                            style: {
                                                marginBottom: "16px"
                                            },
                                            children: [
                                                "Please enter the 6-digit OTP sent to ",
                                                parentIdentity,
                                                "."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "text",
                                            ref: otpRef,
                                            maxLength: 6,
                                            placeholder: "000000",
                                            className: "otp-input-parent",
                                            onInput: (e)=>{
                                                e.target.value = e.target.value.replace(/\D/g, "");
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "container-10",
                                    style: {
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        gap: "10px"
                                    },
                                    children: [
                                        currentModalStep < 2 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            className: "container-10-button",
                                            style: {
                                                backgroundColor: activeTheme.buttonFont,
                                                border: "1px solid rgba(181, 181, 181, 1)"
                                            },
                                            onClick: ()=>{
                                                closeParentModal();
                                                setIsParentChecked(false);
                                                setShowUpdateModal(true);
                                            },
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                style: {
                                                    fontFamily: "system-ui",
                                                    fontWeight: 700,
                                                    color: activeTheme.buttonBackground,
                                                    fontSize: "18px"
                                                },
                                                children: "Cancel"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            className: "container-10-button",
                                            style: {
                                                backgroundColor: activeTheme.buttonBackground,
                                                border: "1px solid rgba(181, 181, 181, 1)"
                                            },
                                            onClick: ()=>{
                                                if (!selectedKYCMethod) {
                                                    (0, $b00d3e7401eac195$export$b410431fab84fa58).error((props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482ccd6e8e9b33b1$export$2e2bcd8739ae039), {
                                                            ...props,
                                                            type: "error",
                                                            message: "Please select a method"
                                                        }), {
                                                        icon: false
                                                    });
                                                    return;
                                                }
                                                if (selectedKYCMethod === "digilocker") {
                                                    var responseType = "code";
                                                    var codeChallengeMethod = "S256";
                                                    generateConsentMetaId().then((consentMetaId)=>{
                                                        if (!consentMetaId) return;
                                                        const state = consentMetaId;
                                                        generateCodeChallenge(digilockerCodeVerifier).then((codeChallenge)=>{
                                                            const digilockerAuthUrl = `https://api.digitallocker.gov.in/public/oauth2/1/authorize?response_type=${responseType}&client_id=${digilockerClientId}&redirect_uri=${digilockerRedirectUri}&code_challenge=${codeChallenge}&code_challenge_method=${codeChallengeMethod}&state=${state}`;
                                                            setIsDigiLockerLoading(true);
                                                            // Try opening new tab
                                                            const newTab = window.open(digilockerAuthUrl, "_blank", "noopener,noreferrer");
                                                            if (!newTab) {
                                                                setIsDigiLockerLoading(false);
                                                                return;
                                                            }
                                                            // Wait for the new tab to initialize before checking
                                                            const checkInterval = setInterval(()=>{
                                                                if (newTab?.closed) clearInterval(checkInterval);
                                                            }, 1000);
                                                        });
                                                    });
                                                    return;
                                                }
                                                if (selectedKYCMethod === "declaration") {
                                                    if (currentModalStep === 1) {
                                                        let name = parentNameRef.current.value.trim();
                                                        let identity = parentIdentityRef.current.value.trim();
                                                        name = name.replace(/\s+/g, " ");
                                                        parentNameRef.current.value = name;
                                                        const errors = [];
                                                        const nameRegex = /^[A-Za-z]+(?:\s[A-Za-z]+)*$/;
                                                        if (!name) errors.push("Please enter parent's name");
                                                        else if (!nameRegex.test(name)) {
                                                            if (/[0-9]/.test(name)) errors.push("Please enter valid name (no numbers allowed)");
                                                            else if (/[^A-Za-z\s]/.test(name)) errors.push("Please enter valid name (no special characters allowed)");
                                                        }
                                                        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                                                        const mobileRegex = /^\d{10}$/;
                                                        identity = identity.replace(/\s+/g, "");
                                                        parentIdentityRef.current.value = identity;
                                                        if (!identity) errors.push("Please enter parent's identity (email or mobile)");
                                                        else if (!emailRegex.test(identity) && !mobileRegex.test(identity)) errors.push("Please enter valid identity (email or 10-digit mobile number)");
                                                        if (errors.length > 0) {
                                                            (0, $b00d3e7401eac195$export$b410431fab84fa58).error((props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482ccd6e8e9b33b1$export$2e2bcd8739ae039), {
                                                                    ...props,
                                                                    type: "error",
                                                                    message: errors.map((err, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                            children: `${index + 1}. ${err}`
                                                                        }, index))
                                                                }), {
                                                                icon: false
                                                            });
                                                            return;
                                                        }
                                                        setCurrentModalStep(2);
                                                    } else if (currentModalStep === 2) {
                                                        const otp = otpRef.current.value.trim();
                                                        if (!otp || otp.length !== 6) {
                                                            (0, $b00d3e7401eac195$export$b410431fab84fa58).error((props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482ccd6e8e9b33b1$export$2e2bcd8739ae039), {
                                                                    ...props,
                                                                    type: "error",
                                                                    message: "Enter a valid 6-digit OTP"
                                                                }), {
                                                                icon: false
                                                            });
                                                            return;
                                                        }
                                                        (0, $b00d3e7401eac195$export$b410431fab84fa58).success((props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482ccd6e8e9b33b1$export$2e2bcd8739ae039), {
                                                                ...props,
                                                                type: "success",
                                                                message: "OTP verified!"
                                                            }), {
                                                            icon: false
                                                        });
                                                        closeParentModal();
                                                    }
                                                }
                                            },
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                style: {
                                                    fontFamily: "system-ui",
                                                    fontWeight: 700,
                                                    color: activeTheme.buttonFont,
                                                    fontSize: "18px"
                                                },
                                                children: currentModalStep === 2 ? "Verify" : "Next"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    isDigiLockerLoading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            backgroundColor: "rgba(255, 255, 255, 0.8)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            zIndex: 9999
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "loader"
                        })
                    }),
                    showConfirmationModal && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$2b77a92f1a5ad772), {
                        close: false,
                        kind: "acknowledgement",
                        onClose: handleConfirmationModalClose,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                    appearance: "heading-xs",
                                    color: "primary-grey-100",
                                    children: "Are you sure like to revoke consent?"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                    appearance: "body-s",
                                    color: "primary-grey-80",
                                    children: [
                                        "You might not be able to continue using some/all of",
                                        " ",
                                        businessName,
                                        " features.",
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "confirm-modal-buttton-contaier",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "confirm-modal-buttton",
                                        onClick: withdrawConsent,
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "confirm-modal-text",
                                            children: "Withdraw consent"
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    withdrawLoader && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "withdraw-overlay",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "blinking-text",
                            children: [
                                "Withdrawing your consent",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "dots"
                                })
                            ]
                        })
                    }),
                    translationLoader && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "withdraw-overlay",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "blinking-text",
                            children: [
                                "Translating",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "dots"
                                })
                            ]
                        })
                    }),
                    pageLoader && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "withdraw-overlay",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "blinking-text",
                            children: [
                                "Loading Pop Up",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "dots"
                                })
                            ]
                        })
                    }),
                    updateLoader && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "withdraw-overlay",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "blinking-text",
                            children: [
                                "Updating your consent",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "dots"
                                })
                            ]
                        })
                    }),
                    renewLoader && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "withdraw-overlay",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "blinking-text",
                            children: [
                                "Renewing your consent",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "dots"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b00d3e7401eac195$export$f2815235e76a62b9), {
                position: "bottom-left",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                closeButton: false,
                toastClassName: ()=>"toast-wrapper",
                transition: (0, $b00d3e7401eac195$export$d8dc01b5c85a37b9)
            })
        ]
    });
};
var $164dc338fd404bfa$export$2e2bcd8739ae039 = $164dc338fd404bfa$var$FiduciaryRequests;








var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");




const $5bbdedc36a585072$var$StarRating = ({ grievanceId: grievanceId, initialRating: initialRating, readOnly: readOnly = false, iconSize: iconSize = "m", className: className = "" })=>{
    const [rating, setRating] = (0, $acw62.useState)(initialRating || 0);
    const [hover, setHover] = (0, $acw62.useState)(0);
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    (0, $acw62.useEffect)(()=>{
        setRating(initialRating || 0);
    }, [
        initialRating
    ]);
    const handleRatingClick = async (newRating)=>{
        if (readOnly) return;
        setRating(newRating);
        try {
            await dispatch((0, $6eea01a75b53fee5$export$70084a25e4847b62)({
                grievanceId: grievanceId,
                newRating: newRating
            }));
        } catch (error) {
            console.error("Error updating rating:", error);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: className,
        style: {
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            flexWrap: "nowrap"
        },
        children: Array.from({
            length: 5
        }, (_, i)=>{
            const starNumber = i + 1;
            const isFilled = starNumber <= (hover || rating);
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                onMouseEnter: ()=>!readOnly && setHover(starNumber),
                onMouseLeave: ()=>!readOnly && setHover(0),
                onClick: ()=>handleRatingClick(starNumber),
                style: {
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                    marginRight: iconSize === "s" ? 1 : 2,
                    cursor: readOnly ? "default" : "pointer"
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$f04a61298a47a40f), {
                    ic: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eaaa4115f4b10cc9$export$e5c12eca07fe7b2d), {}),
                    size: iconSize,
                    color: isFilled ? "primary_blue" : "primary_grey_60",
                    style: {
                        opacity: isFilled ? 1 : 0.4,
                        transition: "opacity 0.2s ease"
                    }
                })
            }, starNumber);
        })
    });
};
var $5bbdedc36a585072$export$2e2bcd8739ae039 = $5bbdedc36a585072$var$StarRating;




const $bc816806ba2f8e50$var$formatGrievanceDate = (dateString)=>{
    if (!dateString) return "";
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) return dateString;
    return date.toLocaleString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit"
    });
};
const $bc816806ba2f8e50$var$getGrievanceStatusBadgeClass = (status)=>{
    if (status === (0, $dee2f92127058cd3$export$f21702b540d6bf35).GRIEVANCE_L1_ESCALATED || status === (0, $dee2f92127058cd3$export$f21702b540d6bf35).GRIEVANCE_L2_ESCALATED) return "grievance-status-badge grievance-status-badge--escalated";
    if (status === (0, $dee2f92127058cd3$export$f21702b540d6bf35).GRIEVANCE_RESOLVED) return "grievance-status-badge grievance-status-badge--resolved";
    if (status === (0, $dee2f92127058cd3$export$f21702b540d6bf35).GRIEVANCE_INPROCESS) return "grievance-status-badge grievance-status-badge--inprocess";
    return "grievance-status-badge grievance-status-badge--default";
};
const $bc816806ba2f8e50$var$Requests = ()=>{
    const [loadLogs, setLoadLogs] = (0, $acw62.useState)(true);
    const tenantId = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.common.tenant_id);
    const [expandedRow, setExpandedRow] = (0, $acw62.useState)(null);
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const [grievanceData, setGrievanceData] = (0, $acw62.useState)([]);
    const [resolvedCount, setResolvedCount] = (0, $acw62.useState)(0);
    const [inProgressCount, setInProgressCount] = (0, $acw62.useState)(0);
    const [newCount, setNewCount] = (0, $acw62.useState)(0);
    const [sessionExpired, setSessionExpired] = (0, $acw62.useState)(false);
    const grievanceId = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.common.grievance_template_id);
    // Calculate counts when grievanceData changes
    (0, $acw62.useEffect)(()=>{
        if (grievanceData && grievanceData.length > 0) {
            let newCnt = 0;
            let inProcessCnt = 0;
            let resolvedCnt = 0;
            grievanceData.forEach((grievance)=>{
                const status = grievance?.status;
                if (status === (0, $dee2f92127058cd3$export$f21702b540d6bf35).NEW) newCnt++;
                else if (status === (0, $dee2f92127058cd3$export$f21702b540d6bf35).GRIEVANCE_RESOLVED) resolvedCnt++;
                else if (status === (0, $dee2f92127058cd3$export$f21702b540d6bf35).GRIEVANCE_RAISED || status === (0, $dee2f92127058cd3$export$f21702b540d6bf35).GRIEVANCE_INPROCESS || status === (0, $dee2f92127058cd3$export$f21702b540d6bf35).GRIEVANCE_L1_ESCALATED || status === (0, $dee2f92127058cd3$export$f21702b540d6bf35).GRIEVANCE_L2_ESCALATED) inProcessCnt++;
            });
            setNewCount(newCnt);
            setInProgressCount(inProcessCnt);
            setResolvedCount(resolvedCnt);
        } else {
            setNewCount(0);
            setInProgressCount(0);
            setResolvedCount(0);
        }
    }, [
        grievanceData
    ]);
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const createGrievanceRequest = ()=>{
        navigate("/createRequest");
    };
    const customerIdentity = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.common.customer_id);
    const [emailMobile, setEmailMobile] = (0, $acw62.useState)("");
    const [grievanceSearch, setGrievanceSearch] = (0, $acw62.useState)("");
    const [disableRaiseButton, setDisableRaiseButton] = (0, $acw62.useState)(false);
    const [dynamicTranslations, setDynamicTranslations] = (0, $acw62.useState)({}); // Store translated dynamic content
    // Translation inputs for static text in Requests page
    const translationInputs = (0, $acw62.useMemo)(()=>[
            {
                id: "requests_title",
                source: "Requests"
            },
            {
                id: "requests_description",
                source: "View and track your grievance requests and respond when required."
            },
            {
                id: "requests_search_placeholder",
                source: "Search grievance ID, status, or type"
            },
            {
                id: "requests_badge",
                source: "Grievance redressal"
            },
            {
                id: "requests_raise_new",
                source: "Raise new request"
            },
            {
                id: "requests_new",
                source: "New"
            },
            {
                id: "requests_in_process",
                source: "In Process"
            },
            {
                id: "requests_resolved",
                source: "Resolved"
            },
            {
                id: "requests_grievance_id",
                source: "Grievance ID"
            },
            {
                id: "requests_date_submitted",
                source: "Date submitted"
            },
            {
                id: "requests_last_updated",
                source: "Last updated"
            },
            {
                id: "requests_grievance_type",
                source: "Grievance type"
            },
            {
                id: "requests_remarks",
                source: "Remarks"
            },
            {
                id: "requests_status",
                source: "Status"
            },
            {
                id: "requests_actions",
                source: "Actions"
            },
            {
                id: "requests_feedback",
                source: "Feedback"
            },
            {
                id: "requests_no_data",
                source: "No Data to Display"
            },
            // Dynamic status values
            {
                id: "requests_status_raised",
                source: "RAISED"
            },
            {
                id: "requests_status_inprocess",
                source: "INPROCESS"
            },
            {
                id: "requests_status_l1_escalated",
                source: "L1_ESCALATED"
            },
            {
                id: "requests_status_l2_escalated",
                source: "L2_ESCALATED"
            },
            {
                id: "requests_status_resolved",
                source: "RESOLVED"
            },
            {
                id: "requests_status_new",
                source: "NEW"
            },
            {
                id: "requests_status_to_do",
                source: "TO_DO"
            },
            // Grievance type categories
            {
                id: "requests_type_consent_related",
                source: "Consent Related Grievance"
            },
            {
                id: "requests_type_data_principal",
                source: "Data Principal Rights"
            },
            {
                id: "requests_type_legal",
                source: "Legal Grievances"
            }
        ], []);
    // Use translation hook
    const { getTranslation: getTranslation, translateContent: translateContent, currentLanguage: currentLanguage, isTranslating: isTranslating } = (0, $dbe8cedc9e1aa4ce$export$2e2bcd8739ae039)(translationInputs);
    // Helper to translate dynamic status values (API returns "state", e.g. TO_DO)
    const getTranslatedStatus = (status)=>{
        const statusMap = {
            "RAISED": "requests_status_raised",
            "INPROCESS": "requests_status_inprocess",
            "L1_ESCALATED": "requests_status_l1_escalated",
            "L2_ESCALATED": "requests_status_l2_escalated",
            "RESOLVED": "requests_status_resolved",
            "NEW": "requests_status_new",
            "TO_DO": "requests_status_to_do"
        };
        const translationId = statusMap[status?.toUpperCase()];
        return translationId ? getTranslation(translationId, status) : status;
    };
    // Helper to translate grievance type categories
    const getTranslatedGrievanceType = (type)=>{
        const typeMap = {
            "Consent Related Grievance": "requests_type_consent_related",
            "Data Principal Rights": "requests_type_data_principal",
            "Legal Grievances": "requests_type_legal"
        };
        const translationId = typeMap[type];
        return translationId ? getTranslation(translationId, type) : type;
    };
    // Helper to get dynamic translation with fallback
    const getDynamicTranslation = (text)=>{
        if (!text || currentLanguage === "ENGLISH") return text;
        return dynamicTranslations[text] || text;
    };
    const filteredGrievanceData = (0, $acw62.useMemo)(()=>{
        if (!Array.isArray(grievanceData)) return grievanceData;
        const q = (grievanceSearch || "").trim().toLowerCase();
        if (!q) return grievanceData;
        return grievanceData.filter((g)=>{
            const hay = [
                g?.grievanceId,
                g?.createdAt,
                g?.updatedAt,
                g?.grievanceType,
                g?.grievanceDescription,
                g?.state,
                g?.status
            ].join(" ").toLowerCase();
            return hay.includes(q);
        });
    }, [
        grievanceData,
        grievanceSearch
    ]);
    // Function to translate dynamic table data (remarks/descriptions)
    const translateDynamicData = async (data, targetLang)=>{
        if (!data || data.length === 0 || targetLang === "en") {
            setDynamicTranslations({});
            return;
        }
        // Collect all unique translatable text
        const uniqueTexts = new Set();
        data.forEach((item)=>{
            if (item.grievanceDescription) uniqueTexts.add(item.grievanceDescription);
        });
        if (uniqueTexts.size === 0) return;
        // Create translation inputs
        const inputs = Array.from(uniqueTexts).map((text, idx)=>({
                id: `dynamic_${idx}`,
                source: text
            }));
        try {
            const response = await dispatch((0, $6eea01a75b53fee5$export$7d0f208153a27d67)("en", targetLang, inputs));
            if (response?.status === 200 && response?.data?.output) {
                const translatedMap = {};
                response.data.output.forEach((item, idx)=>{
                    const originalText = inputs[idx].source;
                    translatedMap[originalText] = item.target;
                });
                setDynamicTranslations(translatedMap);
            }
        } catch (error) {
            console.log("Error translating dynamic data:", error);
        }
    };
    // Translate content when language changes
    (0, $acw62.useEffect)(()=>{
        if (currentLanguage !== "ENGLISH") {
            translateContent(translationInputs, currentLanguage);
            // Also translate dynamic table data (remarks/descriptions)
            if (grievanceData && grievanceData.length > 0) {
                const targetLang = (0, $dbe8cedc9e1aa4ce$export$d340805709eeec9f)(currentLanguage);
                translateDynamicData(grievanceData, targetLang);
            }
        } else setDynamicTranslations({}); // Reset for English
    }, [
        currentLanguage,
        translationInputs,
        translateContent,
        grievanceData
    ]);
    (0, $acw62.useEffect)(()=>{
        const fetchData = async ()=>{
            try {
                const mobileRegex = /^[6-9]\d{9}$/;
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                let emailMobile = "";
                if (mobileRegex.test(customerIdentity)) emailMobile = "mob";
                else if (emailRegex.test(customerIdentity)) emailMobile = "ema";
                const searchList = await dispatch((0, $6eea01a75b53fee5$export$815763d6d21fa26e)());
                if (emailMobile === "mob" && searchList.includes("Mobile Number")) {
                    let res = await dispatch((0, $6eea01a75b53fee5$export$455a512fa53a6e64)("Mobile Number"));
                    setGrievanceData(res?.data?.data);
                }
                if (emailMobile === "ema" && searchList.includes("Email address")) {
                    let res = await dispatch((0, $6eea01a75b53fee5$export$455a512fa53a6e64)("Email address"));
                    setGrievanceData(res?.data?.data);
                }
            } catch (err) {
                setDisableRaiseButton(true);
                if (err.code === "ERR_NETWORK") setSessionExpired(true);
                console.log("Error occured in getConsentsByTemplateId", JSON.stringify(err));
                if (err?.[0]?.errorCode === "JCMP3001") setGrievanceData([]);
            } finally{
                setLoadLogs(false);
            }
        };
        fetchData();
    }, [
        customerIdentity,
        dispatch
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("main", {
        role: "main",
        "aria-label": "Grievance Requests Page",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "pageConfig",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("header", {
                    className: "fiduciaryHeaderContainer requests-page-header",
                    role: "banner",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "fiduciaryHeader",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                        appearance: "heading-s",
                                        color: "primary-grey-100",
                                        children: getTranslation("requests_title", "Requests")
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "badge",
                                    role: "status",
                                    "aria-label": "Page type: Grievance redressal",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                        appearance: "body-xs-bold",
                                        color: "primary-grey-80",
                                        children: getTranslation("requests_badge", "Grievance redressal")
                                    })
                                }),
                                sessionExpired && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63ff59473b55bad2$export$2e2bcd8739ae039), {
                                    isOpen: sessionExpired,
                                    onClose: ()=>setSessionExpired(false)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "requestsButtonContainer",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$cfc7921d29ef7b80), {
                                kind: "primary",
                                size: "large",
                                label: getTranslation("requests_raise_new", "Raise new request"),
                                onClick: createGrievanceRequest,
                                state: disableRaiseButton ? "disabled" : "normal",
                                ariaLabel: "Raise a new grievance request"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "requests-page-meta-row",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "pending-requests-description-wrap",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                appearance: "body-s",
                                color: "primary-grey-80",
                                children: getTranslation("requests_description", "View and track your grievance requests and respond when required.")
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "fiduciaryHeaderButtonContainer requests-page-toolbar",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "search-input-wrapper page-toolbar-search",
                                style: {
                                    width: "100%"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$f04a61298a47a40f), {
                                        ic: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $52f7703976716e4f$export$6da2c307edd95198), {}),
                                        size: "m",
                                        color: "primary_grey_100"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "text",
                                        className: "search-input",
                                        placeholder: getTranslation("requests_search_placeholder", "Search grievance ID, status, or type"),
                                        value: grievanceSearch,
                                        onChange: (e)=>setGrievanceSearch(e.target.value),
                                        "aria-label": getTranslation("requests_search_placeholder", "Search grievance ID, status, or type")
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "requests-status-cards",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: {
                                width: "214px",
                                height: "90px",
                                backgroundColor: "rgba(245, 245, 245, 1)",
                                borderRadius: "12px",
                                display: "flex",
                                gap: "0.5rem",
                                alignItems: "center"
                            },
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    paddingTop: "1rem",
                                    paddingLeft: "1rem",
                                    paddingBottom: "1rem",
                                    gap: "0.5rem",
                                    alignItems: "center"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f2a56b92690f077c$export$556fe0871d9b7899), {
                                        height: 35,
                                        width: 35
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "flex-start"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                appearance: "body-xs-bold",
                                                color: "primary-grey-100",
                                                children: newCount || "0"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                appearance: "body-xs",
                                                color: "primary-grey-80",
                                                children: getTranslation("requests_new", "New")
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: {
                                width: "214px",
                                height: "90px",
                                backgroundColor: "rgba(231, 235, 248, 1)",
                                borderRadius: "12px",
                                display: "flex",
                                gap: "0.5rem",
                                alignItems: "center"
                            },
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    paddingTop: "1rem",
                                    paddingLeft: "1rem",
                                    paddingBottom: "1rem",
                                    gap: "0.5rem",
                                    alignItems: "center"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$f04a61298a47a40f), {
                                        ic: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8c66bf8a36364e42$export$7f3df200d95b839b), {
                                            height: 35,
                                            width: 35
                                        }),
                                        color: "primary_60",
                                        size: "large"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "flex-start"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                appearance: "body-xs-bold",
                                                color: "primary-grey-100",
                                                children: inProgressCount || "0"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                appearance: "body-xs",
                                                color: "primary-grey-80",
                                                children: getTranslation("requests_in_process", "In Process")
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: {
                                width: "214px",
                                height: "90px",
                                backgroundColor: "rgba(233, 247, 233, 1)",
                                borderRadius: "12px",
                                display: "flex",
                                alignItems: "center"
                            },
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    paddingTop: "1rem",
                                    paddingLeft: "1rem",
                                    paddingBottom: "1rem",
                                    alignItems: "center",
                                    gap: "0.5rem"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dd949b1a0491130c$export$50c1b72d39add9), {
                                        height: 35,
                                        width: 35
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "flex-start"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                appearance: "body-xs-bold",
                                                color: "primary-grey-100",
                                                children: resolvedCount || "0"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                appearance: "body-xs",
                                                color: "primary-grey-80",
                                                children: getTranslation("requests_resolved", "Resolved")
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "responsive-table-scroll",
                    style: {
                        overflowX: "auto"
                    },
                    role: "region",
                    "aria-label": "Grievance Requests Table",
                    tabIndex: 0,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                        className: "consentLog-table grievance-requests-table",
                        role: "table",
                        "aria-label": "List of grievance requests with details",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    role: "row",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "parentheader",
                                            scope: "col",
                                            role: "columnheader",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "header-with-icon",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                        appearance: "body-xs-bold",
                                                        color: "primary-grey-80",
                                                        children: getTranslation("requests_grievance_id", "Grievance ID")
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$f04a61298a47a40f), {
                                                        ic: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c07aaad5de81ca37$export$d802d08b192014d8), {}),
                                                        color: "primary_60",
                                                        size: "small",
                                                        "aria-hidden": "true"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "parentheader",
                                            scope: "col",
                                            role: "columnheader",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "header-with-icon",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                        appearance: "body-xs-bold",
                                                        color: "primary-grey-80",
                                                        children: getTranslation("requests_date_submitted", "Date submitted")
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$f04a61298a47a40f), {
                                                        ic: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c07aaad5de81ca37$export$d802d08b192014d8), {}),
                                                        color: "primary_60",
                                                        size: "small",
                                                        "aria-hidden": "true"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "parentheader",
                                            scope: "col",
                                            role: "columnheader",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "header-with-icon",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                        appearance: "body-xs-bold",
                                                        color: "primary-grey-80",
                                                        children: getTranslation("requests_last_updated", "Last updated")
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$f04a61298a47a40f), {
                                                        ic: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c07aaad5de81ca37$export$d802d08b192014d8), {}),
                                                        color: "primary_60",
                                                        size: "small",
                                                        "aria-hidden": "true"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "parentheader",
                                            scope: "col",
                                            role: "columnheader",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "header-with-icon",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                        appearance: "body-xs-bold",
                                                        color: "primary-grey-80",
                                                        children: getTranslation("requests_grievance_type", "Grievance type")
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$f04a61298a47a40f), {
                                                        ic: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c07aaad5de81ca37$export$d802d08b192014d8), {}),
                                                        color: "primary_60",
                                                        size: "small",
                                                        "aria-hidden": "true"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "parentheader",
                                            scope: "col",
                                            role: "columnheader",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "header-with-icon",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                    appearance: "body-xs-bold",
                                                    color: "primary-grey-80",
                                                    children: getTranslation("requests_remarks", "Remarks")
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "parentheader",
                                            scope: "col",
                                            role: "columnheader",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "header-with-icon",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                        appearance: "body-xs-bold",
                                                        color: "primary-grey-80",
                                                        children: getTranslation("requests_status", "Status")
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$f04a61298a47a40f), {
                                                        ic: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c07aaad5de81ca37$export$d802d08b192014d8), {}),
                                                        color: "primary_60",
                                                        size: "small",
                                                        "aria-hidden": "true"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "parentheader",
                                            scope: "col",
                                            role: "columnheader",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "header-with-icon",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                    appearance: "body-xs-bold",
                                                    color: "primary-grey-80",
                                                    children: getTranslation("requests_actions", "Actions")
                                                })
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                children: loadLogs ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        colSpan: "7",
                                        style: {
                                            textAlign: "center",
                                            padding: "1rem"
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "customerActivityLoader",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$7f7cbe89f1eacd2), {
                                                kind: "normal",
                                                labelPosition: "right",
                                                size: "small"
                                            })
                                        })
                                    })
                                }) : !Array.isArray(grievanceData) || grievanceData.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        colSpan: "7",
                                        style: {
                                            textAlign: "center",
                                            padding: "1rem"
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                            appearance: "body-xs-bold",
                                            color: "primary-grey-80",
                                            children: getTranslation("requests_no_data", "No Data to Display")
                                        })
                                    })
                                }) : !Array.isArray(filteredGrievanceData) || filteredGrievanceData.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        colSpan: "7",
                                        style: {
                                            textAlign: "center",
                                            padding: "1rem"
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                            appearance: "body-xs-bold",
                                            color: "primary-grey-80",
                                            children: getTranslation("requests_no_data", "No Data to Display")
                                        })
                                    })
                                }) : Array.isArray(filteredGrievanceData) && filteredGrievanceData?.map((grievance, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        className: expandedRow === `row${index}` ? "expanded-row-parent" : "",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "grievance-id-cell",
                                                title: grievance.grievanceId || "",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "grievance-id-text",
                                                    children: grievance.grievanceId || ""
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "grievance-date-cell",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                    appearance: "body-xs",
                                                    color: "primary-grey-100",
                                                    children: $bc816806ba2f8e50$var$formatGrievanceDate(grievance.createdAt)
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "grievance-date-cell",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                    appearance: "body-xs",
                                                    color: "primary-grey-100",
                                                    children: $bc816806ba2f8e50$var$formatGrievanceDate(grievance.updatedAt)
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "grievance-type-cell",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                    appearance: "body-xs",
                                                    color: "primary-grey-100",
                                                    children: getTranslatedGrievanceType(grievance.grievanceType) || ""
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "grievance-remarks-cell",
                                                title: getDynamicTranslation(grievance.grievanceDescription) || "",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "grievance-remarks-text",
                                                    children: getDynamicTranslation(grievance.grievanceDescription) || ""
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "grievance-status-cell",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: $bc816806ba2f8e50$var$getGrievanceStatusBadgeClass(grievance?.state || grievance?.status),
                                                    children: getTranslatedStatus(grievance.state || grievance.status) || ""
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                className: "grievance-actions-cell",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    type: "button",
                                                    className: "grievance-view-action",
                                                    "aria-label": `View grievance ${grievance.grievanceId}`,
                                                    onClick: ()=>grievance?.grievanceId && navigate(`/requests/${grievance.grievanceId}`),
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35aa9dff24458a00$export$fd7adc84612ab6c3), {
                                                        height: 20,
                                                        width: 20,
                                                        "aria-hidden": "true"
                                                    })
                                                })
                                            })
                                        ]
                                    }, grievance?.grievanceId || `grievance-${index}`))
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var $bc816806ba2f8e50$export$2e2bcd8739ae039 = $bc816806ba2f8e50$var$Requests;













var $acw62 = parcelRequire("acw62");






const $2e1c888804f61777$var$SystemRequests = ()=>{
    const [currentModalStep, setCurrentModalStep] = (0, $acw62.useState)(1);
    const [showParentModal, setShowParentModal] = (0, $acw62.useState)(false);
    const [openRelationPopUp, setOpenRelationPopUp] = (0, $acw62.useState)(false);
    const [guardianType, setGuardianType] = (0, $acw62.useState)("PARENT");
    const [otherText, setOtherText] = (0, $acw62.useState)("");
    const [selectedKYCMethod, setSelectedKYCMethod] = (0, $acw62.useState)("");
    const [isOpenParent, setIsOpenParent] = (0, $acw62.useState)(false);
    const [isParentChecked, setIsParentChecked] = (0, $acw62.useState)(false);
    const [parentIdentity, setParentIdentity] = (0, $acw62.useState)("");
    const [isDigiLockerLoading, setIsDigiLockerLoading] = (0, $acw62.useState)(false);
    const [payloadForCaptureAll, setPayloadForCaptureAll] = (0, $acw62.useState)({});
    const [sessionExpired, setSessionExpired] = (0, $acw62.useState)(false);
    const [currentPage, setCurrentPage] = (0, $acw62.useState)(1);
    const rowsPerPage = 3;
    var totalPages;
    var startIdx;
    var endIdx;
    var paginatedConsents;
    const parentNameRef = (0, $acw62.useRef)();
    const parentIdentityRef = (0, $acw62.useRef)();
    const otherTextRef = (0, $acw62.useRef)();
    const otpRef = (0, $acw62.useRef)(null);
    const digiLockerTabRef = (0, $acw62.useRef)(null);
    const [showAcceptWllModal, setShowAcceptAllModal] = (0, $acw62.useState)(false);
    const [showUpdateModal, setShowUpdateModal] = (0, $acw62.useState)(false);
    const [showConfirmationModal, setConfirmationModal] = (0, $acw62.useState)(false);
    const [modalHeading, setModalHeading] = (0, $acw62.useState)("Manage Consent");
    const [parentsName, setParentsName] = (0, $acw62.useState)("Parent's Name");
    const [parentsIdentity, setParentsIdentity] = (0, $acw62.useState)("Identity (Email or Mobile");
    const [relationshipModalHeader, setRelationshipModalHeader] = (0, $acw62.useState)("Select your relationship with the child");
    const [parentModalHeader, setParentModalHeader] = (0, $acw62.useState)("Select verification method (Required)");
    const [parentModalCancelBtnText, setParentModalCancelBtnText] = (0, $acw62.useState)("Cancel");
    const [parentModalNextBtnText, setParentModalNextBtnText] = (0, $acw62.useState)("Next");
    const [relationModalClearBtnText, setRelationModalClearBtnText] = (0, $acw62.useState)("Clear");
    const [relationModalSaveBtnText, setRelationModalSaveBtnText] = (0, $acw62.useState)("Save");
    const [relationParent, setRelationParent] = (0, $acw62.useState)("Parent");
    const [relationLegalGuardian, setRelationGuardian] = (0, $acw62.useState)("Legal Gurdian");
    const [relationOther, setRelationOther] = (0, $acw62.useState)("Other");
    const [activeBadge, setActiveBadge] = (0, $acw62.useState)("Always Active");
    const [ageSentence, setAgeSentence] = (0, $acw62.useState)("I am below 18 years of age");
    const [searchText, setSearchText] = (0, $acw62.useState)("");
    const [otherAccordionHeader, setOtherAccordionHeader] = (0, $acw62.useState)("Others");
    const [withdrawConsentBtnText, setWithdrawConsentBtnText] = (0, $acw62.useState)("Save my choices");
    const [updateConsentBtnText, setUpdateConsentBtnText] = (0, $acw62.useState)("Allow all");
    const [customerIdLabel, setCustomerIdLabel] = (0, $acw62.useState)("Customer ID");
    const [topDescription, setTopDescription] = (0, $acw62.useState)("");
    const [rightsDescription, setRightsDescription] = (0, $acw62.useState)("");
    const [permissionDescription, setPermissionDescription] = (0, $acw62.useState)("");
    const [requiredText, setRequiredText] = (0, $acw62.useState)("");
    const [prefereneceArray, setPreferenceArray] = (0, $acw62.useState)([]);
    const [selectedConsentId, setSelectedConsentId] = (0, $acw62.useState)("");
    const [selectedLanguagePreferences, setSelectedLanguagePreferences] = (0, $acw62.useState)("ENGLISH");
    const [pendingTranslationLang, setPendingTranslationLang] = (0, $acw62.useState)(null);
    const [pageLoader, setPageLoader] = (0, $acw62.useState)(false);
    const currentPageLoadRef = (0, $acw62.useRef)(0);
    const currentLangRef = (0, $acw62.useRef)("en");
    const [selectedPrefereneces, setSelectedPreferences] = (0, $acw62.useState)({});
    const [selectedConsentStatus, setSelectedConsentStatus] = (0, $acw62.useState)("");
    const [showREquiredDetails, setShowRequiredDetails] = (0, $acw62.useState)(true);
    const [showOhersDetails, setShowOthersDetails] = (0, $acw62.useState)(true);
    const [showLoader, setShowLoader] = (0, $acw62.useState)(false);
    const [lightTheme, setLightTheme] = (0, $acw62.useState)({});
    const [parentalControl, setParentalControl] = (0, $acw62.useState)(false);
    const [dataItemToBeShown, setDataItemToBeShown] = (0, $acw62.useState)(false);
    const [validitytoBeShown, setValiditytoBeShown] = (0, $acw62.useState)(false);
    const [translationLoader, setTranslationLoader] = (0, $acw62.useState)(false);
    const [withdrawLoader, setWithdrawLoader] = (0, $acw62.useState)(false);
    const [digiLoader, setDigiLoader] = (0, $acw62.useState)(false);
    const [updateLoader, setUpdateLoader] = (0, $acw62.useState)(false);
    const modalRef = (0, $acw62.useRef)(null);
    const formatToIST = (utcDateString)=>{
        const normalized = utcDateString.endsWith("Z") ? utcDateString : `${utcDateString}Z`;
        const date = new Date(normalized);
        return date.toLocaleString("en-IN", {
            timeZone: "Asia/Kolkata",
            hour12: false,
            year: "numeric",
            month: "short",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit"
        });
    };
    const [processActivityNameToBeShown, setProcessActivityNameToBeShown] = (0, $acw62.useState)(false);
    const [processorNameToBeShown, setProcessorNameToBeShown] = (0, $acw62.useState)(false);
    const [darkTheme, setDarkTheme] = (0, $acw62.useState)({});
    const [purposeLabel, setPurposeLabel] = (0, $acw62.useState)("Purpose");
    const [durationLabel, setDurationLabel] = (0, $acw62.useState)("Duration");
    const [usedbyLabel, setUsedByLabel] = (0, $acw62.useState)("Used by");
    const [dataItemLabel, setDataItemLabel] = (0, $acw62.useState)("Data item");
    const [dataTypeLabel, setDataTypeLabel] = (0, $acw62.useState)("Data type");
    const [processingActivityLabel, setProcessingActivityLabel] = (0, $acw62.useState)("Processing activity");
    const [withdrawCount, setWithdrawCount] = (0, $acw62.useState)(0);
    const [activeCount, setActiveCount] = (0, $acw62.useState)(0);
    const [tableData, setTableData] = (0, $acw62.useState)([]);
    const [currentLangCode, setCurrentLangCode] = (0, $acw62.useState)("en");
    const customerId = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.common.customer_id);
    const tntId = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.common.tenant_id);
    const secure_code_for_state = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.common.secure_id);
    var cusId;
    var tenantId;
    cusId = customerId;
    tenantId = tntId;
    const [allSelected, setAllSelected] = (0, $acw62.useState)(false);
    const [expandedRequiredItems, setExpandedRequiredItems] = (0, $acw62.useState)({});
    const [expandedOtherItems, setExpandedOtherItems] = (0, $acw62.useState)({});
    // Translation hook for header language dropdown integration
    const translationInputs = (0, $acw62.useMemo)(()=>[
            {
                id: "sys_pending_requests",
                source: "Pending requests"
            },
            {
                id: "sys_consent_badge",
                source: "Consent"
            },
            {
                id: "sys_description",
                source: "View and respond to new or updated consent requests awaiting your action."
            },
            {
                id: "sys_request_id",
                source: "Request ID"
            },
            {
                id: "sys_request_date",
                source: "Request date"
            },
            {
                id: "sys_request_type",
                source: "Request type"
            },
            {
                id: "sys_status",
                source: "Status"
            },
            {
                id: "sys_actions",
                source: "Actions"
            },
            {
                id: "sys_renewal_request",
                source: "Renewal request"
            },
            {
                id: "sys_status_pending",
                source: "PENDING"
            },
            {
                id: "sys_status_active",
                source: "ACTIVE"
            },
            {
                id: "sys_status_withdrawn",
                source: "WITHDRAWN"
            },
            {
                id: "sys_status_expired",
                source: "EXPIRED"
            },
            {
                id: "sys_no_data",
                source: "No Data to Display"
            },
            {
                id: "sys_search_placeholder",
                source: "Search data item, type and purpose"
            },
            {
                id: "sys_page",
                source: "Page"
            },
            {
                id: "sys_of",
                source: "of"
            },
            // Expanded row headers
            {
                id: "sys_purpose_name",
                source: "Purpose Name"
            },
            {
                id: "sys_data_type",
                source: "Data type"
            },
            {
                id: "sys_data_item",
                source: "Data Item"
            },
            {
                id: "sys_data_used_by",
                source: "Data used by"
            }
        ], []);
    const sendConsentRequest = async ()=>{
        try {
            const identityValue = parentIdentityRef.current.value.trim();
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            const emailMobileVal = emailRegex.test(identityValue) ? "EMAIL" : "MOBILE";
            let successMessage = emailRegex.test(identityValue) ? "A consent request has been sent to your parent's email. Please ask them to approve it." : "A consent request has been sent to your parent's mobile. Please ask them to approve it.";
            const res = await dispatch((0, $6eea01a75b53fee5$export$6a68a8e86e9560f1)(parentNameRef.current.value, identityValue, emailMobileVal, selectedConsentId));
            if (res?.status === 200) {
                (0, $b00d3e7401eac195$export$b410431fab84fa58).success((props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482ccd6e8e9b33b1$export$2e2bcd8739ae039), {
                        ...props,
                        type: "success",
                        message: successMessage
                    }), {
                    icon: false
                });
                setShowUpdateModal(false);
            } else (0, $b00d3e7401eac195$export$b410431fab84fa58).error((props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482ccd6e8e9b33b1$export$2e2bcd8739ae039), {
                    ...props,
                    type: "error",
                    message: "Failed to send parental consent request."
                }), {
                icon: false
            });
        } catch (error) {
            console.log("Error while sending consent:", error);
            (0, $b00d3e7401eac195$export$b410431fab84fa58).error((props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482ccd6e8e9b33b1$export$2e2bcd8739ae039), {
                    ...props,
                    type: "error",
                    message: "Something went wrong. Please try again."
                }), {
                icon: false
            });
        }
    };
    const handleSave = ()=>{
        if (!guardianType) {
            alert("Please select a relationship");
            return;
        }
        if (guardianType === "OTHER" && !otherTextRef.current.value.trim()) {
            alert("Please specify the relationship");
            return;
        }
        // ✅ Build relationship string
        let relationship = "";
        switch(guardianType){
            case "PARENT":
                relationship = "Parent";
                break;
            case "LEGAL_GUARDIAN":
                relationship = "Legal Guardian";
                break;
            case "OTHER":
                relationship = otherTextRef.current.value.trim();
                break;
            default:
                break;
        }
        const responseType = "code";
        const codeChallengeMethod = "S256";
        //  OPEN BLANK TAB IMMEDIATELY (user gesture)
        const newTab = window.open("", "_blank");
        if (!newTab) {
            alert("Popup blocked. Please allow popups for this site.");
            return;
        }
        digiLockerTabRef.current = newTab;
        // Close popup / show loader if you have one
        setOpenRelationPopUp(false);
        // setIsDigiLockerLoading(true); // optional
        //  Async flow AFTER tab is opened
        (async ()=>{
            try {
                const consentMetaId = await generateConsentMetaId(relationship);
                if (!consentMetaId) throw new Error("ConsentMetaId missing");
                const state = consentMetaId;
                const state2 = `${consentMetaId}:${secure_code_for_state}`;
                const codeChallenge = await generateCodeChallenge(digilockerCodeVerifier);
                const digilockerAuthUrl = `https://api.digitallocker.gov.in/public/oauth2/1/authorize` + `?response_type=${responseType}` + `&client_id=${digilockerClientId}` + `&redirect_uri=${digilockerRedirectUri}` + `&code_challenge=${codeChallenge}` + `&code_challenge_method=${codeChallengeMethod}` + `&state=${state2}`;
                //  Redirect the already-opened tab
                digiLockerTabRef.current.location.href = digilockerAuthUrl;
            } catch (err) {
                console.error(err);
                digiLockerTabRef.current?.close();
            // setIsDigiLockerLoading(false);
            }
        })();
    };
    const handleClear = ()=>{
        setGuardianType("PARENT");
        setOtherText("");
    };
    // Helper to translate dynamic status values
    const getTranslatedStatus = (status)=>{
        const statusMap = {
            PENDING: "sys_status_pending",
            ACTIVE: "sys_status_active",
            WITHDRAWN: "sys_status_withdrawn",
            EXPIRED: "sys_status_expired"
        };
        const translationId = statusMap[status?.toUpperCase()];
        return translationId ? getTranslation(translationId, status) : status;
    };
    // State for dynamic translations
    const [dynamicTranslations, setDynamicTranslations] = (0, $acw62.useState)({});
    // Helper to get dynamic translation with fallback
    const getDynamicTranslation = (text)=>{
        if (!text || currentLanguage === "ENGLISH") return text;
        return dynamicTranslations[text] || text;
    };
    // Function to translate dynamic table data
    const translateDynamicData = async (consents, targetLang)=>{
        if (!consents || consents.length === 0 || targetLang === "en") {
            setDynamicTranslations({});
            return;
        }
        // Collect all unique translatable text from consents
        const uniqueTexts = new Set();
        consents.forEach((consent)=>{
            consent.preferences?.forEach((pref)=>{
                pref.purposeList?.forEach((purpose)=>{
                    if (purpose.purposeInfo?.purposeName) uniqueTexts.add(purpose.purposeInfo.purposeName);
                });
                pref.processorActivityList?.forEach((pa)=>{
                    if (pa.processActivityInfo?.processorName) uniqueTexts.add(pa.processActivityInfo.processorName);
                    pa.processActivityInfo?.dataTypesList?.forEach((dt)=>{
                        if (dt.dataTypeName) uniqueTexts.add(dt.dataTypeName);
                        dt.dataItems?.forEach((item)=>uniqueTexts.add(item));
                    });
                });
            });
        });
        if (uniqueTexts.size === 0) return;
        // Create translation inputs
        const inputs = Array.from(uniqueTexts).map((text, idx)=>({
                id: `dynamic_${idx}`,
                source: text
            }));
        try {
            const response = await dispatch((0, $6eea01a75b53fee5$export$7d0f208153a27d67)("en", targetLang, inputs));
            if (response?.status === 200 && response?.data?.output) {
                const translatedMap = {};
                response.data.output.forEach((item, idx)=>{
                    const originalText = inputs[idx].source;
                    translatedMap[originalText] = item.target;
                });
                setDynamicTranslations(translatedMap);
            }
        } catch (error) {
            console.log("Error translating dynamic data:", error);
        }
    };
    const { getTranslation: getTranslation, translateContent: translateContent, currentLanguage: currentLanguage } = (0, $dbe8cedc9e1aa4ce$export$2e2bcd8739ae039)(translationInputs);
    // Sync with header language dropdown
    (0, $acw62.useEffect)(()=>{
        if (currentLanguage && currentLanguage !== "ENGLISH") {
            const targetLang = (0, $dbe8cedc9e1aa4ce$export$d340805709eeec9f)(currentLanguage);
            if (targetLang !== currentLangCode) {
                setCurrentLangCode(targetLang);
                translateContent(translationInputs, currentLanguage);
            }
        } else if (currentLanguage === "ENGLISH" && currentLangCode !== "en") setCurrentLangCode("en");
    }, [
        currentLanguage,
        currentLangCode,
        translationInputs,
        translateContent
    ]);
    const [consentsByTempId, setConsentsByTempId] = (0, $acw62.useState)([]);
    const [expandedRow, setExpandedRow] = (0, $acw62.useState)(null);
    const [loadLogs, setLoadLogs] = (0, $acw62.useState)(true);
    const [withdrawConsentLoader, setWithdrawConsentLoader] = (0, $acw62.useState)(false);
    const [documentName, setDocumentName] = (0, $acw62.useState)("");
    const [documentId, setDocumentId] = (0, $acw62.useState)("");
    const [logoUrl, setLogoUrl] = (0, $acw62.useState)("");
    const [linkFontColor, setLinkFont] = (0, $acw62.useState)("");
    const [selectedLang, setSelectedLang] = (0, $acw62.useState)("ENGLISH");
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    const [formData, setFormData] = (0, $acw62.useState)({});
    const [formOtherData, setformOtherData] = (0, $acw62.useState)({});
    const [digilockerClientId, setDigilockerClientId] = (0, $acw62.useState)("");
    const [digilockerClientSecret, setDigilockerClientSecret] = (0, $acw62.useState)("");
    const [digilockerCodeVerifier, setDigilockerCodeVerifier] = (0, $acw62.useState)("");
    const [digilockerRedirectUri, setDigilockerRedirectUri] = (0, $acw62.useState)("");
    const [darkModeToBeShown, setDarkModeToBeShown] = (0, $acw62.useState)(false);
    const [isDarkMode, setIsDarkMode] = (0, $acw62.useState)(false);
    const activeTheme = isDarkMode ? darkTheme : lightTheme;
    const languages = [
        {
            value: "ENGLISH",
            label: "English",
            apiValue: "en"
        },
        {
            value: "HINDI",
            label: "Hindi",
            apiValue: "hi"
        },
        {
            value: "BENGALI",
            label: "Bengali",
            apiValue: "bn"
        },
        {
            value: "TAMIL",
            label: "Tamil",
            apiValue: "ta"
        },
        {
            value: "TELUGU",
            label: "Telugu",
            apiValue: "te"
        },
        {
            value: "KANNADA",
            label: "Kannada",
            apiValue: "kn"
        },
        {
            value: "MALAYALAM",
            label: "Malayalam",
            apiValue: "ml"
        },
        {
            value: "GUJARATI",
            label: "Gujarati",
            apiValue: "gu"
        },
        {
            value: "MARATHI",
            label: "Marathi",
            apiValue: "mr"
        },
        {
            value: "ODIA",
            label: "Odia",
            apiValue: "or"
        },
        {
            value: "PUNJABI",
            label: "Punjabi",
            apiValue: "pa"
        },
        {
            value: "ASSAMESE",
            label: "Assamese",
            apiValue: "as"
        },
        {
            value: "NEPALI",
            label: "Nepali",
            apiValue: "ne"
        },
        {
            value: "SINDHI",
            label: "Sindhi",
            apiValue: "sd"
        },
        {
            value: "KASHMIRI",
            label: "Kashmiri",
            apiValue: "ks"
        },
        {
            value: "DOGRI",
            label: "Dogri",
            apiValue: "doi"
        },
        {
            value: "KONKANI",
            label: "Konkani",
            apiValue: "gom"
        },
        {
            value: "MAITHILI",
            label: "Maithili",
            apiValue: "mai"
        },
        {
            value: "SANSKRIT",
            label: "Sanskrit",
            apiValue: "sa"
        },
        {
            value: "SANTALI",
            label: "Santali",
            apiValue: "sat"
        },
        {
            value: "BODO",
            label: "Bodo",
            apiValue: "brx"
        },
        {
            value: "MANIPURI",
            label: "Manipuri",
            apiValue: "mni"
        }
    ];
    const generateConsentMetaId = async (relationship)=>{
        let finalPreferences;
        try {
            if (allSelected) {
                const filteredPreferences = Object.fromEntries(Object.entries(selectedPrefereneces).map(([key, _])=>[
                        key,
                        "ACCEPTED"
                    ]));
                finalPreferences = filteredPreferences;
            } else {
                const filteredPreferences = Object.fromEntries(Object.entries(selectedPrefereneces).filter(([_, value])=>value === "ACCEPTED"));
                if (Object.keys(filteredPreferences).length === 0) (0, $b00d3e7401eac195$export$b410431fab84fa58).error((props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482ccd6e8e9b33b1$export$2e2bcd8739ae039), {
                        ...props,
                        type: "error",
                        message: "Please select at least one Preference."
                    }), {
                    icon: false
                });
                else finalPreferences = filteredPreferences;
            }
            let response = await dispatch((0, $6eea01a75b53fee5$export$f71b29283611213f)(selectedConsentId, selectedLanguagePreferences, finalPreferences, relationship));
            return response?.data?.consentMetaId;
        } catch (error) {
            console.log("Erroro in generating consentMetaId", error);
            throw error;
        }
    };
    async function generateCodeChallenge(codeVerifier) {
        if (window.crypto && window.crypto.subtle) {
            const encoder = new TextEncoder();
            const data = encoder.encode(codeVerifier);
            const hashBuffer = await window.crypto.subtle.digest("SHA-256", data);
            const base64Hash = btoa(String.fromCharCode(...new Uint8Array(hashBuffer))).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
            return base64Hash;
        } else {
            console.warn("crypto.subtle not available. Using fallback SHA-256.");
            function sha256(ascii) {
                const rightRotate = (value, amount)=>value >>> amount | value << 32 - amount;
                let mathPow = Math.pow;
                let maxWord = mathPow(2, 32);
                let lengthProperty = "length";
                let i, j;
                let result = "";
                let words = [];
                let asciiBitLength = ascii[lengthProperty] * 8;
                let hash = sha256.h = sha256.h || [];
                let k = sha256.k = sha256.k || [];
                let primeCounter = k[lengthProperty];
                let isComposite = {};
                const fractionalPart = (n)=>n - Math.floor(n);
                function getPrime(n) {
                    let num = 2;
                    while(n > 0){
                        if (!isComposite[num]) {
                            for(let i = num * num; i < 312; i += num)isComposite[i] = true;
                            if (--n === 0) return num;
                        }
                        num++;
                    }
                }
                if (!primeCounter) {
                    let n = 0;
                    let prime = 2;
                    while(n < 64){
                        while(isComposite[prime])prime++;
                        hash[n] = fractionalPart(Math.pow(prime, 0.5)) * maxWord | 0;
                        k[n++] = fractionalPart(Math.pow(prime, 1 / 3)) * maxWord | 0;
                        for(i = prime * prime; i < 312; i += prime)isComposite[i] = true;
                        prime++;
                    }
                }
                ascii += "\x80"; // append '1' bit (plus zero padding)
                while(ascii[lengthProperty] % 64 - 56)ascii += "\x00"; // pad until length ≡ 56 mod 64
                for(i = 0; i < ascii[lengthProperty]; i++){
                    j = ascii.charCodeAt(i);
                    if (j >> 8) return; // ASCII check
                    words[i >> 2] |= j << (3 - i) % 4 * 8;
                }
                words[words[lengthProperty]] = asciiBitLength / maxWord | 0;
                words[words[lengthProperty]] = asciiBitLength;
                for(j = 0; j < words[lengthProperty];){
                    const w = words.slice(j, j += 16);
                    const oldHash = hash.slice(0);
                    for(i = 16; i < 64; i++){
                        const s0 = rightRotate(w[i - 15], 7) ^ rightRotate(w[i - 15], 18) ^ w[i - 15] >>> 3;
                        const s1 = rightRotate(w[i - 2], 17) ^ rightRotate(w[i - 2], 19) ^ w[i - 2] >>> 10;
                        w[i] = w[i - 16] + s0 + w[i - 7] + s1 | 0;
                    }
                    let a = hash[0], b = hash[1], c = hash[2], d = hash[3], e = hash[4], f = hash[5], g = hash[6], h = hash[7];
                    for(i = 0; i < 64; i++){
                        const S1 = rightRotate(e, 6) ^ rightRotate(e, 11) ^ rightRotate(e, 25);
                        const ch = e & f ^ ~e & g;
                        const temp1 = h + S1 + ch + k[i] + w[i] | 0;
                        const S0 = rightRotate(a, 2) ^ rightRotate(a, 13) ^ rightRotate(a, 22);
                        const maj = a & b ^ a & c ^ b & c;
                        const temp2 = S0 + maj | 0;
                        h = g;
                        g = f;
                        f = e;
                        e = d + temp1 | 0;
                        d = c;
                        c = b;
                        b = a;
                        a = temp1 + temp2 | 0;
                    }
                    for(i = 0; i < 8; i++)hash[i] = hash[i] + [
                        a,
                        b,
                        c,
                        d,
                        e,
                        f,
                        g,
                        h
                    ][i] | 0;
                }
                for(i = 0; i < 8; i++)for(j = 3; j + 1; j--){
                    const b = hash[i] >> j * 8 & 255;
                    result += (b < 16 ? "0" : "") + b.toString(16);
                }
                return result;
            }
            function hexToBase64Url(hex) {
                let bytes = [];
                for(let c = 0; c < hex.length; c += 2)bytes.push(parseInt(hex.substr(c, 2), 16));
                let base64 = btoa(String.fromCharCode(...bytes));
                return base64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
            }
            const hashHex = sha256(codeVerifier);
            return hexToBase64Url(hashHex);
        }
    }
    const downloadPendingRequestExcel = (consentsByTempId, listOfObjects)=>{
        try {
            const wb = $4249f69807f0687b$exports.utils.book_new();
            const ws_data = [];
            consentsByTempId.forEach((consent)=>{
                // --- Parent Header ---
                ws_data.push([
                    "Request ID",
                    "Request Date",
                    // "Request Expiry",
                    "Request Type",
                    "Status",
                    "Action"
                ]);
                // --- Parent Row ---
                ws_data.push([
                    consent.consentHandleId || "",
                    formatToIST(consent.createdAt) ? new Date(formatToIST(consent.createdAt)).toLocaleDateString("en-GB") : "",
                    // "-",
                    "Renewal Request",
                    consent.status || "",
                    ""
                ]);
                ws_data.push([]); // spacing
                // --- Child Header ---
                ws_data.push([
                    "Purpose Name",
                    "Data Type",
                    "Data Item",
                    "Data Used By"
                ]);
                // --- Child Rows ---
                const matchedConsent = listOfObjects.find((obj)=>obj.consentHandleId === consent.consentHandleId);
                if (matchedConsent && Array.isArray(matchedConsent.preferences)) matchedConsent.preferences.forEach((pref)=>{
                    pref.purposeList?.forEach((purpose)=>{
                        const dataTypes = pref.processorActivityList?.flatMap((pa)=>pa.processActivityInfo.dataTypesList.map((dt)=>dt.dataTypeName))?.join(", ") || "";
                        const dataItems = pref.processorActivityList?.flatMap((pa)=>pa.processActivityInfo.dataTypesList.flatMap((dt)=>dt.dataItems))?.join(", ") || "";
                        const processors = pref.processorActivityList?.map((pa)=>pa.processActivityInfo.processorName)?.join(", ") || "";
                        ws_data.push([
                            purpose.purposeInfo?.purposeName || "",
                            dataTypes,
                            dataItems,
                            processors
                        ]);
                    });
                });
                else ws_data.push([
                    "No detailed preferences available",
                    "",
                    "",
                    "",
                    ""
                ]);
                ws_data.push([]);
            });
            const ws = $4249f69807f0687b$exports.utils.aoa_to_sheet(ws_data);
            ws["!cols"] = [
                {
                    wch: 30
                },
                {
                    wch: 20
                },
                {
                    wch: 20
                },
                {
                    wch: 25
                },
                {
                    wch: 15
                },
                {
                    wch: 15
                }
            ];
            const borderStyle = {
                top: {
                    style: "thin",
                    color: {
                        rgb: "CCCCCC"
                    }
                },
                bottom: {
                    style: "thin",
                    color: {
                        rgb: "CCCCCC"
                    }
                },
                left: {
                    style: "thin",
                    color: {
                        rgb: "CCCCCC"
                    }
                },
                right: {
                    style: "thin",
                    color: {
                        rgb: "CCCCCC"
                    }
                }
            };
            const range = $4249f69807f0687b$exports.utils.decode_range(ws["!ref"]);
            for(let R = range.s.r; R <= range.e.r; ++R){
                const row = ws_data[R];
                if (!row) continue;
                for(let C = 0; C < (row?.length || 0); ++C){
                    const cellRef = $4249f69807f0687b$exports.utils.encode_cell({
                        r: R,
                        c: C
                    });
                    const cell = ws[cellRef];
                    if (!cell) continue;
                    cell.s = cell.s || {};
                    cell.s.border = borderStyle;
                    cell.s.alignment = {
                        vertical: "center",
                        wrapText: true
                    };
                }
                if (row[0] === "Request ID") for(let C = 0; C < row.length; ++C){
                    const cellRef = $4249f69807f0687b$exports.utils.encode_cell({
                        r: R,
                        c: C
                    });
                    const cell = ws[cellRef];
                    if (!cell) continue;
                    cell.s = {
                        font: {
                            bold: true,
                            color: {
                                rgb: "FFFFFF"
                            }
                        },
                        fill: {
                            fgColor: {
                                rgb: "4472C4"
                            }
                        },
                        alignment: {
                            horizontal: "center",
                            vertical: "center"
                        },
                        border: borderStyle
                    };
                }
                if (row[0] === "Purpose Name") for(let C = 0; C < row.length; ++C){
                    const cellRef = $4249f69807f0687b$exports.utils.encode_cell({
                        r: R,
                        c: C
                    });
                    const cell = ws[cellRef];
                    if (!cell) continue;
                    cell.s = {
                        font: {
                            bold: true,
                            color: {
                                rgb: "FFFFFF"
                            }
                        },
                        fill: {
                            fgColor: {
                                rgb: "808080"
                            }
                        },
                        alignment: {
                            horizontal: "center",
                            vertical: "center"
                        },
                        border: borderStyle
                    };
                }
            }
            $4249f69807f0687b$exports.utils.book_append_sheet(wb, ws, "Request Logs");
            const wbout = $4249f69807f0687b$exports.write(wb, {
                bookType: "xlsx",
                type: "array"
            });
            const blob = new Blob([
                wbout
            ], {
                type: "application/octet-stream"
            });
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "Request_Report.xlsx";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        } catch (err) {
            console.log("Excel download failed:", err);
        }
    };
    function closeParentModal() {
        setShowParentModal(false);
        setCurrentModalStep(1);
        setIsParentChecked(false);
        setSelectedKYCMethod(null);
        if (parentNameRef.current) parentNameRef.current.value = "";
        if (parentIdentityRef.current) parentIdentityRef.current.value = "";
        if (otpRef.current) otpRef.current.value = "";
    }
    const callBhashiniAPI = async (lang)=>{
        if (currentPageLoadRef.current == 1) {
            setPageLoader(true);
            currentPageLoadRef.current = 0;
        } else setTranslationLoader(true);
        const options = [
            {
                value: "ENGLISH",
                label: "English",
                apiValue: "en"
            },
            {
                value: "HINDI",
                label: "Hindi",
                apiValue: "hi"
            },
            {
                value: "BENGALI",
                label: "Bengali",
                apiValue: "bn"
            },
            {
                value: "TAMIL",
                label: "Tamil",
                apiValue: "ta"
            },
            {
                value: "TELUGU",
                label: "Telugu",
                apiValue: "te"
            },
            {
                value: "KANNADA",
                label: "Kannada",
                apiValue: "kn"
            },
            {
                value: "MALAYALAM",
                label: "Malayalam",
                apiValue: "ml"
            },
            {
                value: "GUJARATI",
                label: "Gujarati",
                apiValue: "gu"
            },
            {
                value: "MARATHI",
                label: "Marathi",
                apiValue: "mr"
            },
            {
                value: "ODIA",
                label: "Odia",
                apiValue: "or"
            },
            {
                value: "PUNJABI",
                label: "Punjabi",
                apiValue: "pa"
            },
            {
                value: "ASSAMESE",
                label: "Assamese",
                apiValue: "as"
            },
            {
                value: "NEPALI",
                label: "Nepali",
                apiValue: "ne"
            },
            {
                value: "SINDHI",
                label: "Sindhi",
                apiValue: "sd"
            },
            {
                value: "KASHMIRI",
                label: "Kashmiri",
                apiValue: "ks"
            },
            {
                value: "DOGRI",
                label: "Dogri",
                apiValue: "doi"
            },
            {
                value: "KONKANI",
                label: "Konkani",
                apiValue: "gom"
            },
            {
                value: "MAITHILI",
                label: "Maithili",
                apiValue: "mai"
            },
            {
                value: "SANSKRIT",
                label: "Sanskrit",
                apiValue: "sa"
            },
            {
                value: "SANTALI",
                label: "Santali",
                apiValue: "sat"
            },
            {
                value: "BODO",
                label: "Bodo",
                apiValue: "brx"
            },
            {
                value: "MANIPURI",
                label: "Manipuri",
                apiValue: "mni"
            }
        ];
        function toText(value) {
            if (Array.isArray(value)) return value.join(", ");
            else if (typeof value === "object" && value !== null) {
                if ("value" in value && "unit" in value) return `${value.value} ${value.unit}`;
                return JSON.stringify(value);
            } else return value;
        }
        const selectedOption = options.find((opt)=>opt.value === lang);
        const targetLang = selectedOption ? selectedOption.apiValue : "";
        if (currentLangRef.current === targetLang) {
            setPageLoader(false);
            setTranslationLoader(false);
            if (modalRef.current === "edit") setShowUpdateModal(true);
            return;
        }
        const staticInputs = [
            {
                id: "topDesc",
                source: topDescription
            },
            {
                id: "permissionDesc",
                source: permissionDescription
            },
            {
                id: "rightsDesc",
                source: rightsDescription
            },
            {
                id: "parentCheck",
                source: ageSentence
            },
            {
                id: "updateConsent",
                source: updateConsentBtnText
            },
            {
                id: "withdrawConsent",
                source: withdrawConsentBtnText
            },
            {
                id: "badge",
                source: activeBadge
            },
            {
                id: "requiredHeader",
                source: requiredText
            },
            {
                id: "othersHeader",
                source: otherAccordionHeader
            },
            {
                id: "customerId",
                source: customerIdLabel
            },
            {
                id: "modalHeading",
                source: modalHeading
            },
            {
                id: "documentTitle",
                source: documentName
            },
            {
                id: "parentName",
                source: parentsName
            },
            {
                id: "parentIdentity",
                source: parentsIdentity
            },
            {
                id: "relationshipModalHeader",
                source: relationshipModalHeader
            },
            {
                id: "relationParent",
                source: relationParent
            },
            {
                id: "relationLegalGuardian",
                source: relationLegalGuardian
            },
            {
                id: "relationOther",
                source: relationOther
            },
            {
                id: "parentModalHeader",
                source: parentModalHeader
            },
            {
                id: "parentalModalCancelBtn",
                source: parentModalCancelBtnText
            },
            {
                id: "parentalModalNextBtn",
                source: parentModalNextBtnText
            },
            {
                id: "relationModalClearBtn",
                source: relationModalClearBtnText
            },
            {
                id: "relationModalSaveBtn",
                source: relationModalSaveBtnText
            },
            // { id: "click", source: "click here" },
            // add label translations
            {
                id: "Purpose",
                source: purposeLabel
            },
            {
                id: "Data item",
                source: dataItemLabel
            },
            {
                id: "Processing activity",
                source: processingActivityLabel
            },
            {
                id: "Used by",
                source: usedbyLabel
            },
            {
                id: "Duration",
                source: durationLabel
            },
            {
                id: "Data type",
                source: dataTypeLabel
            },
            {
                id: "Id",
                source: "Id"
            }
        ];
        const dynamicInputs = formData.map((item, index)=>{
            const reqNo = index + 1;
            // Replace flatMap → map + reduce
            const processorActivityInputs = item.processorActivities.map((activity, actIdx)=>{
                const dataTypeInputs = activity.dataTypes.map((dt, dtIdx)=>({
                        id: `dataTypeName_req_${reqNo}_${actIdx}_${dtIdx}`,
                        source: dt.dataTypeName
                    }));
                return [
                    {
                        id: `activityName_req_${reqNo}_${actIdx}`,
                        source: toText(activity.activityName)
                    },
                    {
                        id: `processorName_req_${reqNo}_${actIdx}`,
                        source: toText(activity.processorName)
                    },
                    ...activity.dataTypes.map((dt, dtIdx)=>({
                            id: `dataItems_req_${reqNo}_${actIdx}_${dtIdx}`,
                            source: toText(dt.dataItems)
                        })),
                    // <-- add datatype names here
                    ...dataTypeInputs
                ];
            }).reduce((acc, curr)=>acc.concat(curr), []);
            return [
                {
                    id: `purpose_req_${reqNo}`,
                    source: toText(item.purpose)
                },
                {
                    id: `usedBy_req_${reqNo}`,
                    source: toText(item.usedBy)
                },
                {
                    id: `duration_req_${reqNo}`,
                    source: toText(item.duration)
                },
                {
                    id: `id_req_${reqNo}`,
                    source: item.id
                },
                ...processorActivityInputs
            ];
        }).reduce((acc, curr)=>acc.concat(curr), []);
        const dynamicInputs2 = formOtherData.map((item, index)=>{
            const reqNo = index + 1;
            const processorActivityInputs = item.processorActivities.map((activity, actIdx)=>{
                // Add datatype names (same as main list)
                const dataTypeInputs = activity.dataTypes.map((dt, dtIdx)=>({
                        id: `dataTypeName_otr_${reqNo}_${actIdx}_${dtIdx}`,
                        source: dt.dataTypeName
                    }));
                return [
                    {
                        id: `activityName_otr_${reqNo}_${actIdx}`,
                        source: toText(activity.activityName)
                    },
                    {
                        id: `processorName_otr_${reqNo}_${actIdx}`,
                        source: toText(activity.processorName)
                    },
                    ...activity.dataTypes.map((dt, dtIdx)=>({
                            id: `dataItems_otr_${reqNo}_${actIdx}_${dtIdx}`,
                            source: toText(dt.dataItems)
                        })),
                    // Add datatype inputs here (same as req version)
                    ...dataTypeInputs
                ];
            }).reduce((acc, curr)=>acc.concat(curr), []); // flatten
            return [
                {
                    id: `purpose_otr_${reqNo}`,
                    source: toText(item.purpose)
                },
                {
                    id: `usedBy_otr_${reqNo}`,
                    source: toText(item.usedBy)
                },
                {
                    id: `duration_otr_${reqNo}`,
                    source: toText(item.duration)
                },
                {
                    id: `id_otr_${reqNo}`,
                    source: item.id
                },
                ...processorActivityInputs
            ];
        }).reduce((acc, curr)=>acc.concat(curr), []);
        const finalInputs = [
            ...staticInputs,
            ...dynamicInputs,
            ...dynamicInputs2
        ];
        const response = await dispatch((0, $6eea01a75b53fee5$export$7d0f208153a27d67)(currentLangRef.current, targetLang, finalInputs));
        setTranslationLoader(false);
        setPageLoader(false);
        const data2 = await response?.data;
        // setCurrentLangCode(targetLang);
        currentLangRef.current = targetLang;
        const purposeText = data2.output.find((o)=>o.id === "Purpose")?.target || "topDescription";
        setPurposeLabel(purposeText);
        const dataItemText = data2.output.find((o)=>o.id === "Data item")?.target || "topDescription";
        setDataItemLabel(dataItemText);
        const dataTypeText = data2.output.find((o)=>o.id === "Data type")?.target || "topDescription";
        setDataTypeLabel(dataTypeText);
        const pName = data2.output.find((o)=>o.id === "parentName")?.target || "Parent's Name";
        setParentsName(pName);
        const pIdentity = data2.output.find((o)=>o.id === "parentIdentity")?.target || "Identity";
        setParentsIdentity(pIdentity);
        const radioParent = data2.output.find((o)=>o.id === "relationParent")?.target || "Parent";
        setRelationParent(radioParent);
        const radioLegalGurdian = data2.output.find((o)=>o.id === "relationLegalGuardian")?.target || "Legal Gurdian";
        setRelationGuardian(radioLegalGurdian);
        const relationModalHeader = data2.output.find((o)=>o.id === "relationshipModalHeader")?.target || "Select your relationship with the child";
        setRelationshipModalHeader(relationModalHeader);
        const parentModalHeader2 = data2.output.find((o)=>o.id === "parentModalHeader")?.target || "Select Verification Method";
        setParentModalHeader(parentModalHeader2);
        const pModalClBtn = data2.output.find((o)=>o.id === "parentalModalCancelBtn")?.target || "Cancel";
        setParentModalCancelBtnText(pModalClBtn);
        const pModalNxtBtn = data2.output.find((o)=>o.id === "parentalModalNextBtn")?.target || "Next";
        setParentModalNextBtnText(pModalNxtBtn);
        const relModalClrBtn = data2.output.find((o)=>o.id === "relationModalClearBtn")?.target || "Clear";
        setRelationModalClearBtnText(relModalClrBtn);
        const relModalSaveBtn = data2.output.find((o)=>o.id === "relationModalSaveBtn")?.target || "Save";
        setRelationModalSaveBtnText(relModalSaveBtn);
        const relOtherTxt = data2.output.find((o)=>o.id === "relationOther")?.target || "Others";
        setRelationOther(relOtherTxt);
        const docName = data2.output.find((o)=>o.id === "documentTitle")?.target || "topDescription";
        setDocumentName(docName);
        const processingActivityText = data2.output.find((o)=>o.id === "Processing activity")?.target || "topDescription";
        setProcessingActivityLabel(processingActivityText);
        const usedByText = data2.output.find((o)=>o.id === "Used by")?.target || "topDescription";
        setUsedByLabel(usedByText);
        const durationText = data2.output.find((o)=>o.id === "Duration")?.target || "topDescription";
        setDurationLabel(durationText);
        const topDesc = data2.output.find((o)=>o.id === null)?.target || data2.output.find((o)=>o.id === "topDesc")?.target || "topDescription";
        setTopDescription(topDesc);
        const pDesc = data2.output.find((o)=>o.id === "permissionDesc")?.target || "Description";
        setPermissionDescription(pDesc);
        const rDesc = data2.output.find((o)=>o.id === "rightsDesc")?.target || "Description";
        setRightsDescription(rDesc);
        const cus = data2.output.find((o)=>o.id === "customerId")?.target || "Description";
        setCustomerIdLabel(cus);
        const heading = data2.output.find((o)=>o.id === "modalHeading")?.target || "Description";
        setModalHeading(heading);
        const badgeLabel = data2.output.find((o)=>o.id === "badge")?.target || "Description";
        setActiveBadge(badgeLabel);
        const reqLabel = data2.output.find((o)=>o.id === "requiredHeader")?.target || "Description";
        setRequiredText(reqLabel);
        const otrLabel = data2.output.find((o)=>o.id === "othersHeader")?.target || "Description";
        setOtherAccordionHeader(otrLabel);
        const ageDesc = data2.output.find((o)=>o.id === "parentCheck")?.target || "Description";
        setAgeSentence(ageDesc);
        const wconsent = data2.output.find((o)=>o.id === "withdrawConsent")?.target || "Description";
        setWithdrawConsentBtnText(wconsent);
        const upconsent = data2.output.find((o)=>o.id === "updateConsent")?.target || "Description";
        setUpdateConsentBtnText(upconsent);
        const translatedTemplateList = formData.map((item, index)=>{
            const reqNo = index + 1;
            const getTranslated = (id)=>data2.output.find((o)=>o.id === id)?.target?.trim() || null; // return null instead of ""
            const translatedProcessorActivities = item.processorActivities.map((activity, actIdx)=>{
                const translatedActivityName = getTranslated(`activityName_req_${reqNo}_${actIdx}`) || activity.activityName;
                const translatedProcessorName = getTranslated(`processorName_req_${reqNo}_${actIdx}`) || activity.processorName;
                // Translate dataTypes
                const translatedDataTypes = activity.dataTypes.map((dt, dtIdx)=>{
                    const dtNameId = `dataTypeName_req_${reqNo}_${actIdx}_${dtIdx}`;
                    const translatedDataTypeName = getTranslated(dtNameId) || dt.dataTypeName;
                    // FIX: translate whole list at once
                    const dataItemsId = `dataItems_req_${reqNo}_${actIdx}_${dtIdx}`;
                    const translatedItemsString = getTranslated(dataItemsId);
                    const translatedDataItems = translatedItemsString ? translatedItemsString.split(",").map((i)=>i.trim()) : dt.dataItems;
                    return {
                        dataTypeName: translatedDataTypeName,
                        dataItems: translatedDataItems
                    };
                });
                return {
                    activityName: translatedActivityName,
                    processorName: translatedProcessorName,
                    dataTypes: translatedDataTypes
                };
            });
            return {
                purpose: [
                    getTranslated(`purpose_req_${reqNo}`) || item.purpose.join(", ")
                ],
                usedBy: [
                    getTranslated(`usedBy_req_${reqNo}`) || item.usedBy.join(", ")
                ],
                duration: {
                    value: getTranslated(`duration_req_${reqNo}`)?.split(" ")[0] || item.duration.value,
                    unit: getTranslated(`duration_req_${reqNo}`)?.split(" ")[1] || item.duration.unit
                },
                processorActivities: translatedProcessorActivities,
                id: item.id,
                status: item.status
            };
        });
        const translatedTemplateList2 = formOtherData.map((item, index)=>{
            const reqNo = index + 1;
            const getTranslated = (id)=>data2.output.find((o)=>o.id === id)?.target?.trim() || null;
            const translatedProcessorActivities = item.processorActivities.map((activity, actIdx)=>{
                const translatedActivityName = getTranslated(`activityName_otr_${reqNo}_${actIdx}`) || activity.activityName;
                const translatedProcessorName = getTranslated(`processorName_otr_${reqNo}_${actIdx}`) || activity.processorName;
                // Translate data types
                const translatedDataTypes = activity.dataTypes.map((dt, dtIdx)=>{
                    const dtNameId = `dataTypeName_otr_${reqNo}_${actIdx}_${dtIdx}`;
                    const translatedDataTypeName = getTranslated(dtNameId) || dt.dataTypeName;
                    // FIX: translate entire dataItems list at once
                    const dataItemsId = `dataItems_otr_${reqNo}_${actIdx}_${dtIdx}`;
                    const translatedItemsString = getTranslated(dataItemsId);
                    const translatedDataItems = translatedItemsString ? translatedItemsString.split(",").map((i)=>i.trim()) : dt.dataItems;
                    return {
                        dataTypeName: translatedDataTypeName,
                        dataItems: translatedDataItems
                    };
                });
                return {
                    activityName: translatedActivityName,
                    processorName: translatedProcessorName,
                    dataTypes: translatedDataTypes
                };
            });
            return {
                purpose: [
                    getTranslated(`purpose_otr_${reqNo}`) || item.purpose.join(", ")
                ],
                usedBy: [
                    getTranslated(`usedBy_otr_${reqNo}`) || item.usedBy.join(", ")
                ],
                duration: {
                    value: getTranslated(`duration_otr_${reqNo}`)?.split(" ")[0] || item.duration.value,
                    unit: getTranslated(`duration_otr_${reqNo}`)?.split(" ")[1] || item.duration.unit
                },
                processorActivities: translatedProcessorActivities,
                id: item.id,
                status: item.status
            };
        });
        setFormData(translatedTemplateList);
        setformOtherData(translatedTemplateList2);
        if (modalRef.current === "edit") setShowUpdateModal(true);
    };
    const handleSelectAll = (isChecked)=>{
        setAllSelected(isChecked);
        setSelectedPreferences((prev)=>{
            const mandatoryEntries = Object.fromEntries(Object.entries(prev).filter(([_, value])=>value === "ACCEPTED"));
            const updatedOthers = {};
            formOtherData.forEach((item)=>{
                updatedOthers[item.id] = isChecked ? "ACCEPTED" : "NOT ACCEPTED";
            });
            return {
                ...mandatoryEntries,
                ...updatedOthers
            };
        });
    };
    const captureConsent = async ()=>{
        try {
            if (isParentChecked === true) setShowParentModal(true);
            else {
                setUpdateLoader(true);
                let status = "ACTIVE";
                // Filter only ACCEPTED preferences
                const filteredPreferences = Object.fromEntries(Object.entries(selectedPrefereneces).filter(([_, value])=>value === "ACCEPTED"));
                // Check if no preferences are selected
                if (Object.keys(filteredPreferences).length === 0) {
                    (0, $b00d3e7401eac195$export$b410431fab84fa58).error((props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482ccd6e8e9b33b1$export$2e2bcd8739ae039), {
                            ...props,
                            type: "error",
                            message: "Please select at least one Preference."
                        }), {
                        icon: false
                    });
                    setUpdateLoader(false);
                    return;
                }
                let res = await dispatch((0, $6eea01a75b53fee5$export$2212ba0d271add57)(selectedConsentId, selectedLang, filteredPreferences, status));
                if (res?.status === 201) {
                    (0, $b00d3e7401eac195$export$b410431fab84fa58).success((props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482ccd6e8e9b33b1$export$2e2bcd8739ae039), {
                            ...props,
                            type: "success",
                            message: "Consent updated successfully!"
                        }), {
                        icon: false
                    });
                    setShowUpdateModal(false);
                    setConfirmationModal(false);
                    setUpdateLoader(false);
                    setTimeout(()=>{
                        window.location.reload();
                    }, 3000);
                } else {
                    (0, $b00d3e7401eac195$export$b410431fab84fa58).error((props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482ccd6e8e9b33b1$export$2e2bcd8739ae039), {
                            ...props,
                            type: "error",
                            message: "Failed to update consent. Please try again."
                        }), {
                        icon: false
                    });
                    setUpdateLoader(false);
                    return;
                }
            }
        } catch (err) {
            console.log("Withdraw API failed:", err);
            (0, $b00d3e7401eac195$export$b410431fab84fa58).error((props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482ccd6e8e9b33b1$export$2e2bcd8739ae039), {
                    ...props,
                    type: "error",
                    message: "An error occurred while updating consent."
                }), {
                icon: false
            });
            setWithdrawLoader(false);
            setUpdateLoader(false);
            return;
        }
    };
    const captureAllConsents = async ()=>{
        try {
            setAllSelected(true);
            if (isParentChecked === true) setShowParentModal(true);
            else {
                setUpdateLoader(true);
                let status = "ACTIVE";
                // Map all selected preferences to ACCEPTED
                const filteredPreferences = Object.fromEntries(Object.entries(selectedPrefereneces).map(([key, _])=>[
                        key,
                        "ACCEPTED"
                    ]));
                //  Check if filteredPreferences is empty
                if (Object.keys(filteredPreferences).length === 0) {
                    (0, $b00d3e7401eac195$export$b410431fab84fa58).error((props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482ccd6e8e9b33b1$export$2e2bcd8739ae039), {
                            ...props,
                            type: "error",
                            message: "Please select at least one Preference."
                        }), {
                        icon: false
                    });
                    setUpdateLoader(false);
                    return;
                }
                let res = await dispatch((0, $6eea01a75b53fee5$export$2212ba0d271add57)(selectedConsentId, selectedLang, filteredPreferences, status));
                if (res?.status === 201) {
                    (0, $b00d3e7401eac195$export$b410431fab84fa58).success((props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482ccd6e8e9b33b1$export$2e2bcd8739ae039), {
                            ...props,
                            type: "success",
                            message: "Consent updated successfully!"
                        }), {
                        icon: false
                    });
                    setShowUpdateModal(false);
                    setConfirmationModal(false);
                    setTimeout(()=>{
                        window.location.reload();
                    }, 3000);
                } else (0, $b00d3e7401eac195$export$b410431fab84fa58).error((props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482ccd6e8e9b33b1$export$2e2bcd8739ae039), {
                        ...props,
                        type: "error",
                        message: "Failed to update consent. Please try again."
                    }), {
                    icon: false
                });
                setUpdateLoader(false);
            }
        } catch (err) {
            console.log("Withdraw API failed:", err);
            (0, $b00d3e7401eac195$export$b410431fab84fa58).error((props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482ccd6e8e9b33b1$export$2e2bcd8739ae039), {
                    ...props,
                    type: "error",
                    message: "An error occurred while updating consent."
                }), {
                icon: false
            });
            setUpdateLoader(false);
        }
    };
    const handleToggle = (rowId)=>{
        setExpandedRow(expandedRow === rowId ? null : rowId);
    };
    const handleUpdateConsent = ()=>{
        updateConsent();
    };
    const openDocument = async ()=>{
        try {
            const blob = await dispatch((0, $6eea01a75b53fee5$export$5aa62db8a1a167b3)(documentId));
            const pdfUrl = URL.createObjectURL(blob);
            if (pdfUrl) window.open(pdfUrl, "_blank");
            else (0, $b00d3e7401eac195$export$b410431fab84fa58).error((props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482ccd6e8e9b33b1$export$2e2bcd8739ae039), {
                    ...props,
                    type: "error",
                    message: "Error Occurred while fetching document"
                }), {
                icon: false
            });
        } catch (err) {
            console.log("Error opening document:", err);
        }
    };
    const handleLanguageChange = (e)=>{
        const lang = e.target.value;
        setSelectedLang(lang);
        callBhashiniAPI(lang);
    };
    const closeEditConsentModal = ()=>{
        setShowUpdateModal(false);
        setAllSelected(false);
        setDarkModeToBeShown(false);
        setIsDarkMode(false);
        setLightTheme({});
        setDataTypeLabel("Data type");
        setSelectedLang("ENGLISH");
        setCustomerIdLabel("Customer ID");
        setActiveBadge("Always Active");
        setOtherAccordionHeader("Others");
        setPurposeLabel("");
        setPurposeLabel("Purpose");
        setDurationLabel("Duration");
        setUsedByLabel("Used by");
        setDataItemLabel("Data item");
        setProcessingActivityLabel("Processing activity");
        setWithdrawConsentBtnText("Save my choices");
        setUpdateConsentBtnText("Allow all");
        setModalHeading("Manage Consent");
        setDocumentName("");
        setAgeSentence("I am below 18 years of age");
    };
    const transformConsentData = (apiResponse)=>{
        const data = Array.isArray(apiResponse) ? apiResponse[0] : apiResponse;
        if (!data || !data.preferences) return {
            mandatory: [],
            others: []
        };
        const mandatory = [];
        const others = [];
        const preferencesStatus = {};
        data.preferences.forEach((pref)=>{
            const purpose = pref.purposeList.map((p)=>p?.purposeInfo?.purposeName).filter(Boolean);
            if (purpose.length === 0) throw new Error("Invalid purpose data");
            const rawUnit = pref?.preferenceValidity?.unit || "";
            if (rawUnit === "") throw new Error("Missing duration unit");
            const processedUnit = pref?.preferenceValidity?.value === 1 ? rawUnit.toLowerCase().replace(/s$/, "") : rawUnit.toLowerCase();
            // Capitalize first letter
            const capitalizedUnit = processedUnit.charAt(0).toUpperCase() + processedUnit.slice(1);
            const duration = {
                value: pref?.preferenceValidity?.value ?? "",
                unit: capitalizedUnit
            };
            const usedBy = pref.processorActivityList.map((p)=>p?.processActivityInfo?.processorName).filter(Boolean);
            if (usedBy.length === 0) throw new Error("Invalid processor data");
            const dataItems = pref.processorActivityList.flatMap((p)=>p?.processActivityInfo?.dataTypesList.flatMap((d)=>d.dataItems)).filter(Boolean);
            if (dataItems.length === 0) throw new Error("Invalid data items");
            // const processingActivity = pref.processorActivityList.map(
            //   (p) => p.processActivityInfo.activityName
            // );
            const processorActivities = (pref.processorActivityList || []).map((p)=>{
                const activityName = p?.processActivityInfo?.activityName;
                const processorName = p?.processActivityInfo?.processorName;
                const dataTypes = (p?.processActivityInfo?.dataTypesList || []).map((d)=>({
                        dataTypeName: d?.dataTypeName,
                        dataItems: d?.dataItems || []
                    })).filter((d)=>d.dataTypeName);
                if (!activityName || !processorName || dataTypes.length === 0) return null;
                return {
                    activityName: activityName,
                    processorName: processorName,
                    dataTypes: dataTypes
                };
            }).filter(Boolean);
            if (processorActivities.length === 0) throw new Error("Invalid processor activities");
            const id = pref.preferenceId;
            const status = pref.preferenceStatus;
            const formattedObj = {
                purpose: purpose,
                duration: duration,
                usedBy: usedBy,
                dataItems: dataItems,
                processorActivities: processorActivities,
                id: id,
                status: status
            };
            if (pref.mandatory) preferencesStatus[id] = "ACCEPTED";
            else preferencesStatus[id] = "NOTACCEPTED";
            if (pref.mandatory === true) mandatory.push(formattedObj);
            else others.push(formattedObj);
        });
        return {
            mandatory: mandatory,
            others: others,
            preferencesStatus: preferencesStatus
        };
    };
    const transformConsentData123 = (apiResponse)=>{
        const data = Array.isArray(apiResponse) ? apiResponse[0] : apiResponse;
        if (!data || !data.preferences) return {
            mandatory: [],
            others: []
        };
        const mandatory123 = [];
        const others123 = [];
        const preferencesStatus123 = {};
        data.preferences.forEach((pref)=>{
            // Extract purpose info
            const purpose = pref.purposeList.map((p)=>`${p.purposeInfo.purposeName}`);
            // Extract duration
            const duration = {
                value: pref.preferenceValidity?.value || "",
                unit: pref.preferenceValidity?.unit?.toLowerCase() || ""
            };
            // Extract processor names (usedBy)
            const usedBy = pref.processorActivityList.map((p)=>p.processActivityInfo.processorName);
            // Extract all dataItems under all dataTypesList
            const dataItems = pref.processorActivityList.flatMap((p)=>p.processActivityInfo.dataTypesList.flatMap((d)=>d.dataItems));
            // const processingActivity = pref.processorActivityList.map(
            //   (p) => p.processActivityInfo.activityName
            // );
            const processorActivities = pref.processorActivityList.map((p)=>({
                    activityName: p.processActivityInfo.activityName,
                    processorName: p.processActivityInfo.processorName,
                    dataItems: p.processActivityInfo.dataTypesList.flatMap((d)=>d.dataItems)
                }));
            const id = pref.preferenceId;
            const status = pref.preferenceStatus;
            const formattedObj = {
                purpose: purpose,
                duration: duration,
                usedBy: usedBy,
                dataItems: dataItems,
                processorActivities: processorActivities,
                id: id,
                status: status
            };
            preferencesStatus123[id] = status;
            // Separate based on preference type
            if (pref.mandatory === true) mandatory123.push(formattedObj);
            else others123.push(formattedObj);
        });
        return {
            mandatory123: mandatory123,
            others123: others123,
            preferencesStatus123: preferencesStatus123
        };
    };
    const handleCallAPI2 = async (id, handleId, languagePreferences, status)=>{
        setSelectedConsentId(handleId);
        setSelectedLanguagePreferences(languagePreferences);
        setSelectedConsentStatus(status);
        const response = await dispatch((0, $6eea01a75b53fee5$export$8010e91ba8c855a9)(handleId));
        if (response?.multilingual?.supportedLanguages.length === 1) {
            setPendingTranslationLang(response?.multilingual?.supportedLanguages[0]);
            setSelectedLang(response?.multilingual?.supportedLanguages[0]);
        } else {
            setPendingTranslationLang("ENGLISH");
            setSelectedLang("ENGLISH");
        }
        currentPageLoadRef.current = 1;
        try {
            const { mandatory: mandatory, others: others, preferencesStatus: preferencesStatus } = transformConsentData(response);
            var theme = response?.uiConfig?.theme;
            setFormData(mandatory);
            setformOtherData(others);
            setSelectedPreferences(preferencesStatus);
            setDocumentName(response?.documentMeta?.name);
            setDocumentId(response?.documentMeta?.documentId);
            setDarkModeToBeShown(response?.uiConfig?.darkMode);
            setLogoUrl(response?.uiConfig?.logo);
            setParentalControl(response?.uiConfig?.parentalControl);
            setDataItemToBeShown(response?.uiConfig?.dataItemToBeShown);
            setProcessActivityNameToBeShown(response?.uiConfig?.processActivityNameToBeShown);
            setValiditytoBeShown(response?.uiConfig?.validitytoBeShown);
            if (theme) {
                var decodedThemeStr = atob(theme);
                var decodedTheme = JSON.parse(decodedThemeStr);
                setLightTheme(JSON.parse(decodedTheme.light));
                setDarkTheme(JSON.parse(decodedTheme.dark));
            }
            setTopDescription(response?.multilingual?.languageSpecificContentMap?.ENGLISH?.description);
            setRightsDescription(response?.multilingual?.languageSpecificContentMap?.ENGLISH?.rightsText);
            setPermissionDescription(response?.multilingual?.languageSpecificContentMap?.ENGLISH?.permissionText);
            setRequiredText(response?.multilingual?.languageSpecificContentMap?.ENGLISH?.label);
            modalRef.current = "edit";
        } catch (err) {
            console.log(err);
            (0, $b00d3e7401eac195$export$b410431fab84fa58).error((props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482ccd6e8e9b33b1$export$2e2bcd8739ae039), {
                    ...props,
                    type: "error",
                    message: "Something went wrong while fetching consent details."
                }), {
                icon: false
            });
            //setShowUpdateModal(false);
            modalRef.current = null;
            return;
        }
    };
    (0, $acw62.useEffect)(()=>{
        if (pendingTranslationLang && Array.isArray(formData) && Array.isArray(formOtherData) && formData.length >= 0) {
            callBhashiniAPI(pendingTranslationLang);
            setPendingTranslationLang(null); // reset
        }
    }, [
        pendingTranslationLang,
        formData,
        formOtherData
    ]);
    var consentHandleIds = [];
    const [listOfObjects, setListOfObjects] = (0, $acw62.useState)([]);
    // Translate dynamic table data when language or data changes
    (0, $acw62.useEffect)(()=>{
        if (currentLanguage && currentLanguage !== "ENGLISH" && listOfObjects && listOfObjects.length > 0) {
            const targetLang = (0, $dbe8cedc9e1aa4ce$export$d340805709eeec9f)(currentLanguage);
            translateDynamicData(listOfObjects, targetLang);
        } else if (currentLanguage === "ENGLISH") setDynamicTranslations({});
    }, [
        currentLanguage,
        listOfObjects
    ]);
    (0, $acw62.useEffect)(()=>{
        const fetchData = async ()=>{
            try {
                const searchList = await dispatch((0, $6eea01a75b53fee5$export$6b4b986bcb95c892)());
                const pendingList = Array.isArray(searchList) ? searchList.filter((item)=>item.status === "PENDING") : [];
                setConsentsByTempId(pendingList);
                const consentHandleIds = pendingList.map((item)=>item.consentHandleId);
                const fetchedObjects = await Promise.all(consentHandleIds.map(async (id)=>{
                    const response = await dispatch((0, $6eea01a75b53fee5$export$8010e91ba8c855a9)(id));
                    return response;
                }));
                setListOfObjects(fetchedObjects); // store in state
            } catch (err) {
                console.log("Error occurred in getConsentsByTemplateId", err);
                if (err?.[0]?.errorCode === "JCMP3001") setConsentsByTempId([]);
                if (err.code === "ERR_NETWORK") setSessionExpired(true);
            } finally{
                setLoadLogs(false);
            }
        };
        fetchData();
    }, [
        dispatch
    ]);
    (0, $acw62.useEffect)(()=>{
        const fetchDigilockerDetails = async ()=>{
            try {
                if (tenantId) {
                    const res = await dispatch((0, $6eea01a75b53fee5$export$9b0d6ab01c55202e)(tenantId));
                    const response = res?.data;
                    if (response?.searchList) {
                        setDigilockerClientId(response.searchList[0]?.clientId || "");
                        setDigilockerClientSecret(response.searchList[0]?.clientSecret || "");
                        setDigilockerCodeVerifier(response.searchList[0]?.codeVerifier || "");
                        setDigilockerRedirectUri(response.searchList[0]?.redirectUri || "");
                    }
                }
            } catch (error) {
                console.log("Error in Digilocker api:", error.message || error);
            }
        };
        fetchDigilockerDetails();
    }, [
        dispatch,
        tenantId
    ]);
    const handlePreferenceChange = (id, isChecked)=>{
        setSelectedPreferences((prev)=>{
            const updated = {
                ...prev,
                [id]: isChecked ? "ACCEPTED" : "NOT ACCEPTED"
            };
            // Check if all others are now accepted
            const allAccepted = formOtherData.every((item)=>updated[item.id] === "ACCEPTED");
            setAllSelected(allAccepted); // keep the Select All checkbox synced
            return updated;
        });
    };
    const handleConfirm = ()=>{
        setShowModal(false);
        setConfirmationModal(true);
    };
    const handleConfirmationModalClose = ()=>{
        setShowModal(true);
        setConfirmationModal(false);
    };
    const closeWithdrawConsentModal = ()=>{
        setShowModal(false);
    };
    const data = [
        {
            purpose: [
                "Account creation (collect data to create user account)",
                "Marketing"
            ],
            duration: {
                value: 1,
                unit: "year"
            },
            usedBy: [
                "Jio Platforms Limited",
                "Subsidiary ABC"
            ],
            dataItems: [
                "Jio Platforms Limited",
                "Subsidiary ABC"
            ]
        },
        {
            purpose: [
                "Profile Management"
            ],
            duration: {
                value: 2,
                unit: "years"
            },
            usedBy: [
                "XYZ Ltd."
            ],
            dataItems: [
                "Jio Platforms Limited",
                "Subsidiary ABC"
            ]
        },
        {
            purpose: [
                "Profile Management"
            ],
            duration: {
                value: 2,
                unit: "years"
            },
            usedBy: [
                "XYZ Ltd."
            ],
            dataItems: [
                "Jio Platforms Limited",
                "Subsidiary ABC"
            ]
        },
        {
            purpose: [
                "Profile Management"
            ],
            duration: {
                value: 2,
                unit: "years"
            },
            usedBy: [
                "XYZ Ltd."
            ],
            dataItems: [
                "Jio Platforms Limited",
                "Subsidiary ABC"
            ]
        }
    ];
    const [showFilter, setShowFilter] = (0, $acw62.useState)(false);
    const [filters, setFilters] = (0, $acw62.useState)({
        search: "",
        status: [],
        startDate: "",
        endDate: ""
    });
    const applyFilters = (consents)=>{
        return consents.filter((consent)=>{
            // ----- 1. SEARCH FILTER -----
            if (filters.search?.trim()) {
                const text = filters.search.toLowerCase().trim().replace(/\s+/g, " ");
                const consentValues = [
                    consent.consentId,
                    consent.consentHandleId,
                    consent.status,
                    formatToIST(consent.createdAt)
                ];
                consent.preferences?.forEach((pref)=>{
                    pref.purposeList?.forEach((p)=>consentValues.push(p.purposeInfo?.purposeName));
                    pref.processorActivityList?.forEach((pa)=>{
                        consentValues.push(pa.processActivityInfo?.processorName);
                        pa.processActivityInfo?.dataTypesList?.forEach((dt)=>{
                            consentValues.push(dt.dataTypeName);
                            consentValues.push(...dt.dataItems || []);
                        });
                    });
                });
                const match = consentValues.some((value)=>{
                    if (typeof value !== "string") return false;
                    const clean = value.toLowerCase().trim().replace(/\s+/g, " ");
                    return clean.includes(text);
                });
                if (!match) return false;
            }
            // ----- 2. CREATED DATE FILTER -----
            // Full day boundaries
            const start = filters.startDate ? new Date(filters.startDate + "T00:00:00") : null;
            const end = filters.endDate ? new Date(filters.endDate + "T23:59:59") : null;
            const created = new Date(consent.createdAt);
            if (start && created < start) return false;
            if (end && created > end) return false;
            return true;
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("main", {
        role: "main",
        "aria-label": "Pending Requests Page",
        children: [
            isDigiLockerLoading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(255, 255, 255, 0.8)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 9999
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "loader"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "pageConfig",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("header", {
                        className: "fiduciaryHeaderContainer",
                        role: "banner",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "fiduciaryHeader",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                        appearance: "heading-s",
                                        color: "primary-grey-100",
                                        children: getTranslation("sys_pending_requests", "Pending requests")
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "badge",
                                    role: "status",
                                    "aria-label": "Page type: Consent",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                        appearance: "body-xs-bold",
                                        color: "primary-grey-80",
                                        children: getTranslation("sys_consent_badge", "Consent")
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "pending-requests-meta-row",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "pending-requests-description-wrap",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                    appearance: "body-s",
                                    color: "primary-grey-80",
                                    children: getTranslation("sys_description", "View and respond to new or updated consent requests awaiting your action.")
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "fiduciaryHeaderButtonContainer pending-requests-actions",
                                style: {
                                    justifyContent: "flex-end",
                                    opacity: consentsByTempId.length === 0 ? 0.5 : 1,
                                    pointerEvents: consentsByTempId.length === 0 ? "none" : "auto"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "search-input-wrapper page-toolbar-search",
                                        style: {
                                            width: "100%"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$f04a61298a47a40f), {
                                                ic: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $52f7703976716e4f$export$6da2c307edd95198), {}),
                                                size: "m",
                                                color: "primary_grey_100"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "text",
                                                className: "search-input",
                                                placeholder: getTranslation("sys_search_placeholder", "Search data item, type and purpose"),
                                                value: searchText,
                                                onChange: (e)=>setSearchText(e.target.value),
                                                "aria-label": getTranslation("sys_search_placeholder", "Search data item, type and purpose")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$cfc7921d29ef7b80), {
                                        kind: "tertiary",
                                        ariaLabel: "Open filter panel",
                                        onClick: ()=>setShowFilter(true),
                                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$f04a61298a47a40f), {
                                            ic: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a9dbc27ea69a373d$export$26f46b9510140fcc), {}),
                                            size: "m",
                                            color: "primary_grey_80"
                                        }),
                                        size: "medium"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $637cc7b74c89b097$export$2e2bcd8739ae039), {
                                        open: showFilter,
                                        showStatus: false,
                                        onClose: ()=>setShowFilter(false),
                                        onApply: (data)=>{
                                            setFilters(data); // <-- IMPORTANT
                                        },
                                        onClear: ()=>setFilters({
                                                search: "",
                                                status: [],
                                                startDate: "",
                                                endDate: ""
                                            })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$cfc7921d29ef7b80), {
                                        kind: "tertiary",
                                        ariaLabel: "downlod Report",
                                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$f04a61298a47a40f), {
                                            ic: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $60bea030b4289a81$export$bb264a5644c93858), {}),
                                            size: "m",
                                            color: "primary_grey_80"
                                        }),
                                        onClick: ()=>downloadPendingRequestExcel(consentsByTempId, listOfObjects),
                                        size: "medium"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "responsive-table-scroll",
                        style: {
                            overflowX: "auto",
                            paddingBottom: "1rem"
                        },
                        "aria-label": "Consent Information Table.",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                            className: "consentLog-table",
                            "aria-label": "details such as Request ID, Request Date, Status and Actions",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("colgroup", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                            style: {
                                                width: "3rem"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                            style: {
                                                width: "25%"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                            style: {
                                                width: "20%"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                            style: {
                                                width: "20%"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                            style: {
                                                width: "15%"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                            style: {
                                                width: "19%"
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {}),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "parentheader",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "header-with-icon",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                        appearance: "body-xs-bold",
                                                        color: "primary-grey-80",
                                                        children: getTranslation("sys_request_id", "Request ID")
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "parentheader",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "header-with-icon",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                        appearance: "body-xs-bold",
                                                        color: "primary-grey-80",
                                                        children: getTranslation("sys_request_date", "Request date")
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "parentheader",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "header-with-icon",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                        appearance: "body-xs-bold",
                                                        color: "primary-grey-80",
                                                        children: getTranslation("sys_request_type", "Request type")
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "parentheader",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "header-with-icon",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                        appearance: "body-xs-bold",
                                                        color: "primary-grey-80",
                                                        children: getTranslation("sys_status", "Status")
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "parentheader",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "header-with-icon",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                        appearance: "body-xs-bold",
                                                        color: "primary-grey-80",
                                                        children: getTranslation("sys_actions", "Actions")
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                    children: loadLogs ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            colSpan: "6",
                                            style: {
                                                textAlign: "center",
                                                padding: "1rem"
                                            },
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "customerActivityLoader",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$7f7cbe89f1eacd2), {
                                                    kind: "normal",
                                                    labelPosition: "right",
                                                    size: "small"
                                                })
                                            })
                                        })
                                    }) : !Array.isArray(consentsByTempId) || consentsByTempId.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            colSpan: "6",
                                            style: {
                                                textAlign: "center",
                                                padding: "1rem"
                                            },
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                appearance: "body-xs-bold",
                                                color: "primary-grey-80",
                                                children: getTranslation("sys_no_data", "No Data to Display")
                                            })
                                        })
                                    }) : (()=>{
                                        const dataAfterFilters = applyFilters(consentsByTempId || []);
                                        const filteredConsents = dataAfterFilters.filter((consent)=>{
                                            // Normalize search text
                                            const text = searchText.toLowerCase().trim().replace(/\s+/g, " ");
                                            if (!text) return true; // Show all if search is empty
                                            const consentValues = [
                                                consent.consentId,
                                                consent.consentHandleId,
                                                consent.status,
                                                formatToIST(consent.createdAt)
                                            ];
                                            // Try to include preference info if available in listOfObjects
                                            const matchedConsent = listOfObjects.find((obj)=>obj.consentHandleId === consent.consentHandleId);
                                            if (matchedConsent) matchedConsent.preferences?.forEach((pref)=>{
                                                pref.purposeList?.forEach((p)=>{
                                                    consentValues.push(p.purposeInfo?.purposeName);
                                                });
                                                pref.processorActivityList?.forEach((pa)=>{
                                                    consentValues.push(pa.processActivityInfo?.processorName);
                                                    pa.processActivityInfo?.dataTypesList?.forEach((dt)=>{
                                                        consentValues.push(dt.dataTypeName);
                                                        consentValues.push(...dt.dataItems || []);
                                                    });
                                                });
                                            });
                                            return consentValues.some((val)=>{
                                                if (typeof val !== "string") return false;
                                                const normalizedVal = val.toLowerCase().trim().replace(/\s+/g, " ");
                                                return normalizedVal.includes(text);
                                            });
                                        });
                                        totalPages = Math.ceil(filteredConsents.length / rowsPerPage);
                                        startIdx = (currentPage - 1) * rowsPerPage;
                                        endIdx = startIdx + rowsPerPage;
                                        paginatedConsents = filteredConsents.slice(startIdx, endIdx);
                                        return filteredConsents.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                colSpan: "6",
                                                style: {
                                                    textAlign: "center",
                                                    padding: "1rem"
                                                },
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                    appearance: "body-xs-bold",
                                                    color: "primary-grey-80",
                                                    children: "No matching records found"
                                                })
                                            })
                                        }) : paginatedConsents.map((consent, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                        onClick: ()=>handleToggle(`row${index}`),
                                                        className: expandedRow === `row${index}` ? "expanded-row-parent" : "",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                className: "chevron-cell",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                    className: "chevron-wrapper",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                                        appearance: "body-xs",
                                                                        color: "primary-grey-100",
                                                                        children: expandedRow === `row${index}` ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9efe7828a40b52f7$export$acd925e63e14000f), {
                                                                            height: 25,
                                                                            width: 25
                                                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fdc94045ec0e5793$export$ec7db1c418c1ec5a), {
                                                                            height: 25,
                                                                            width: 25
                                                                        })
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                                    appearance: "body-xs-bold",
                                                                    color: "primary-grey-80",
                                                                    children: consent.consentHandleId
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                                    appearance: "body-xs-bold",
                                                                    color: "primary-grey-80",
                                                                    children: formatToIST(consent.createdAt)
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                                    appearance: "body-xs-bold",
                                                                    color: "primary-grey-80",
                                                                    children: getTranslation("sys_renewal_request", "Renewal request")
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                    className: "warningbadge",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                        className: "warningbadge-text",
                                                                        children: getTranslatedStatus(consent.status)
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                    style: {
                                                                        display: "flex",
                                                                        gap: "2rem",
                                                                        alignItems: "center"
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482699419fe250fb$export$55e8bf91189d440f), {
                                                                        height: 20,
                                                                        width: 20,
                                                                        style: {
                                                                            cursor: "pointer"
                                                                        },
                                                                        onClick: ()=>handleCallAPI2(consent.consentId, consent.consentHandleId, consent.languagePreferences, consent.status)
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    expandedRow === `row${index}` && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                        className: "expanded-row",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {}),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                colSpan: "6",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                                                    className: "inner-table",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("colgroup", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                                                                    style: {
                                                                                        width: "25%"
                                                                                    }
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                                                                    style: {
                                                                                        width: "25%"
                                                                                    }
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                                                                    style: {
                                                                                        width: "24%"
                                                                                    }
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                                                                    style: {
                                                                                        width: "20%"
                                                                                    }
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                                                            appearance: "body-xs-bold",
                                                                                            color: "primary-grey-80",
                                                                                            children: getTranslation("sys_purpose_name", "Purpose Name")
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                                                            appearance: "body-xs-bold",
                                                                                            color: "primary-grey-80",
                                                                                            children: getTranslation("sys_data_type", "Data type")
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                                                            appearance: "body-xs-bold",
                                                                                            color: "primary-grey-80",
                                                                                            children: getTranslation("sys_data_item", "Data Item")
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                                                            appearance: "body-xs-bold",
                                                                                            color: "primary-grey-80",
                                                                                            children: getTranslation("sys_data_used_by", "Data used by")
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                                                            children: (()=>{
                                                                                const matchedConsent = listOfObjects.find((obj)=>obj.consentHandleId === consent.consentHandleId);
                                                                                if (!matchedConsent) return null;
                                                                                return matchedConsent.preferences.map((pref)=>pref.purposeList.map((purpose)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                                                                        appearance: "body-xs-bold",
                                                                                                        color: "primary-grey-80",
                                                                                                        children: getDynamicTranslation(purpose?.purposeInfo?.purposeName)
                                                                                                    })
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                                                                        appearance: "body-xs-bold",
                                                                                                        color: "primary-grey-80",
                                                                                                        children: pref.processorActivityList.flatMap((pa)=>pa?.processActivityInfo?.dataTypesList.map((dt)=>getDynamicTranslation(dt.dataTypeName))).join(", ")
                                                                                                    })
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                                                                        appearance: "body-xs-bold",
                                                                                                        color: "primary-grey-80",
                                                                                                        children: pref.processorActivityList.flatMap((pa)=>pa?.processActivityInfo?.dataTypesList.flatMap((dt)=>dt.dataItems.map((item)=>getDynamicTranslation(item)))).join(", ")
                                                                                                    })
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                                                                        appearance: "body-xs-bold",
                                                                                                        color: "primary-grey-80",
                                                                                                        children: pref.processorActivityList.map((pa)=>getDynamicTranslation(pa?.processActivityInfo?.processorName)).join(", ")
                                                                                                    })
                                                                                                })
                                                                                            ]
                                                                                        }, purpose.purposeId)));
                                                                            })()
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, consent.consentId));
                                    })()
                                })
                            ]
                        })
                    }),
                    Array.isArray(paginatedConsents) && paginatedConsents.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "pagination-container",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$cfc7921d29ef7b80), {
                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $575ba915d2bd5d5b$export$740276c76f223dd4), {}),
                                kind: "secondary",
                                onClick: ()=>setCurrentPage((p)=>Math.max(p - 1, 1)),
                                disabled: currentPage === 1
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "pagination-text",
                                children: [
                                    getTranslation("sys_page", "Page"),
                                    " ",
                                    currentPage,
                                    " ",
                                    getTranslation("sys_of", "of"),
                                    " ",
                                    totalPages
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$cfc7921d29ef7b80), {
                                kind: "secondary",
                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b59efb8c56ba82c0$export$17beb55fda7072f9), {}),
                                onClick: ()=>setCurrentPage((p)=>Math.min(p + 1, totalPages)),
                                disabled: currentPage === totalPages
                            })
                        ]
                    }),
                    showUpdateModal && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "modal-outer-container",
                        children: [
                            darkModeToBeShown && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "theme-toggle-container",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    className: "theme-switch",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "checkbox",
                                            checked: isDarkMode,
                                            onChange: ()=>setIsDarkMode(!isDarkMode)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "slider round"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "modal-container",
                                style: {
                                    backgroundColor: activeTheme.cardBackground,
                                    color: activeTheme.cardFont,
                                    fontFamily: "var(--portal-font-family, system-ui)",
                                    "--consent-main-acc-bg": activeTheme.mainAccordionBackground,
                                    "--consent-main-acc-fg": activeTheme.mainAccordionFont,
                                    "--consent-sub-acc-bg": activeTheme.subAccordionBackground,
                                    "--consent-sub-acc-fg": activeTheme.subAccordionFont,
                                    "--consent-lang-bg": activeTheme.languageDropdownBackground,
                                    "--consent-lang-fg": activeTheme.languageDropdownFont,
                                    "--consent-badge-fg": activeTheme.activeBadgeFont
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "container-1",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            class: "close-btn",
                                            style: {
                                                "--close-color": activeTheme.buttonBackground
                                            },
                                            onClick: closeEditConsentModal
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "fidu-heading-container",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "container-2-left",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "container-2-left-1",
                                                        children: modalHeading
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "container-2-left-2",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "container-2-left-2-dropdown",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab6d9bfa47542205$export$28390bfec38e5c4f), {
                                                                    height: 20,
                                                                    width: 20,
                                                                    className: "container-2-left-2-dropdown-Icon",
                                                                    style: {
                                                                        color: `${activeTheme.cardFont}`
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                                                    className: "container-2-left-2-dropdown-select",
                                                                    value: selectedLang,
                                                                    onChange: handleLanguageChange,
                                                                    // disabled={selectedConsentStatus !== "ACTIVE"}
                                                                    onClick: ()=>setIsOpen((prev)=>!prev),
                                                                    onBlur: ()=>setIsOpen(false),
                                                                    style: {
                                                                        backgroundColor: activeTheme.languageDropdownBackground,
                                                                        color: activeTheme.languageDropdownFont
                                                                    },
                                                                    children: languages.map((lang)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                            value: lang.value,
                                                                            children: lang.label
                                                                        }, lang.value))
                                                                }),
                                                                isOpen ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9efe7828a40b52f7$export$acd925e63e14000f), {
                                                                    height: 20,
                                                                    width: 20,
                                                                    className: "container-2-left-2-dropdown-Icon-right",
                                                                    style: {
                                                                        color: `${activeTheme.cardFont}`
                                                                    }
                                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fdc94045ec0e5793$export$ec7db1c418c1ec5a), {
                                                                    height: 20,
                                                                    width: 20,
                                                                    className: "container-2-left-2-dropdown-Icon-right",
                                                                    style: {
                                                                        color: `${activeTheme.cardFont}`
                                                                    }
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                src: logoUrl,
                                                alt: "Logo",
                                                className: "logo-image"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mainScrollableContainer",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "container-3",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    children: topDescription
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "container-4",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                    children: [
                                                        customerIdLabel,
                                                        ": ",
                                                        cusId
                                                    ]
                                                })
                                            }),
                                            formData && Object.keys(formData).length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                onClick: ()=>setShowRequiredDetails(!showREquiredDetails),
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "container-5-required",
                                                        style: showREquiredDetails ? {
                                                            borderBottom: "none",
                                                            borderBottomLeftRadius: 0,
                                                            borderBottomRightRadius: 0
                                                        } : {},
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                style: {
                                                                    display: "flex",
                                                                    justifyContent: "flex-start"
                                                                },
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                                                    width: "30",
                                                                    height: "30",
                                                                    viewBox: "5 0 12 23",
                                                                    style: {
                                                                        // position: "absolute",
                                                                        top: "50%",
                                                                        right: "10px",
                                                                        transform: showREquiredDetails ? "translateY(0%) rotate(180deg)" : "translateY(0%) rotate(0deg)",
                                                                        pointerEvents: "none",
                                                                        transition: "transform 0.3s ease",
                                                                        color: activeTheme.buttonBackground
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                        d: "M12 15a1.002 1.002 0 01-.71-.29l-4-4a1.004 1.004 0 111.42-1.42l3.29 3.3 3.29-3.3a1.004 1.004 0 111.42 1.42l-4 4A1.001 1.001 0 0112 15z",
                                                                        fill: "currentColor"
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "container-Heading-fs",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                    children: requiredText
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "badge-container-outer",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "badge-container",
                                                                        style: {
                                                                            border: `1px solid ${activeTheme.cardFont}`,
                                                                            backgroundColor: activeTheme.cardBackground
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                            className: "modal-badge",
                                                                            style: {
                                                                                color: activeTheme.cardFont
                                                                            },
                                                                            children: activeBadge
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                        type: "checkbox",
                                                                        disabled: true,
                                                                        checked: true,
                                                                        readOnly: true,
                                                                        style: {
                                                                            appearance: "none",
                                                                            WebkitAppearance: "none",
                                                                            MozAppearance: "none",
                                                                            height: "20px",
                                                                            width: "20px",
                                                                            borderRadius: "4px",
                                                                            border: `1px solid ${activeTheme.mainAccordionFont || activeTheme.cardFont}`,
                                                                            cursor: "default",
                                                                            flexShrink: 0,
                                                                            marginLeft: "8px",
                                                                            backgroundColor: activeTheme.buttonBackground,
                                                                            backgroundImage: "url(\"data:image/svg+xml;utf8,<svg viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg'><path d='M3 8l3 3 7-7' stroke='white' stroke-width='2' fill='none' stroke-linecap='round' stroke-linejoin='round'/></svg>\")",
                                                                            backgroundRepeat: "no-repeat",
                                                                            backgroundPosition: "center"
                                                                        }
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "required-details-container"
                                                    })
                                                ]
                                            }),
                                            showREquiredDetails && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                children: formData.map((item, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "sub-acc-item",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                style: {
                                                                    backgroundColor: activeTheme.subAccordionBackground,
                                                                    color: activeTheme.subAccordionFont,
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "space-between",
                                                                    padding: "10px 14px",
                                                                    cursor: "pointer"
                                                                },
                                                                onClick: ()=>setExpandedRequiredItems((prev)=>({
                                                                            ...prev,
                                                                            [index]: !prev[index]
                                                                        })),
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        style: {
                                                                            display: "flex",
                                                                            alignItems: "flex-start",
                                                                            gap: "8px",
                                                                            flex: 1
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                                                                width: "20",
                                                                                height: "20",
                                                                                viewBox: "5 0 12 23",
                                                                                style: {
                                                                                    flexShrink: 0,
                                                                                    transform: expandedRequiredItems[index] ? "rotate(180deg)" : "rotate(0deg)",
                                                                                    transition: "transform 0.3s ease",
                                                                                    color: activeTheme.buttonBackground,
                                                                                    pointerEvents: "none"
                                                                                },
                                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                    d: "M12 15a1.002 1.002 0 01-.71-.29l-4-4a1.004 1.004 0 111.42-1.42l3.29 3.3 3.29-3.3a1.004 1.004 0 111.42 1.42l-4 4A1.001 1.001 0 0112 15z",
                                                                                    fill: "currentColor"
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                style: {
                                                                                    fontWeight: 700,
                                                                                    fontSize: "14px"
                                                                                },
                                                                                children: item.purpose.join(", ")
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                        type: "checkbox",
                                                                        disabled: true,
                                                                        checked: true,
                                                                        readOnly: true,
                                                                        style: {
                                                                            appearance: "none",
                                                                            WebkitAppearance: "none",
                                                                            MozAppearance: "none",
                                                                            height: "20px",
                                                                            width: "20px",
                                                                            borderRadius: "4px",
                                                                            border: `1px solid ${activeTheme.subAccordionFont || activeTheme.cardFont}`,
                                                                            cursor: "default",
                                                                            flexShrink: 0,
                                                                            marginLeft: "8px",
                                                                            backgroundColor: activeTheme.buttonBackground,
                                                                            backgroundImage: "url(\"data:image/svg+xml;utf8,<svg viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg'><path d='M3 8l3 3 7-7' stroke='white' stroke-width='2' fill='none' stroke-linecap='round' stroke-linejoin='round'/></svg>\")",
                                                                            backgroundRepeat: "no-repeat",
                                                                            backgroundPosition: "center"
                                                                        }
                                                                    })
                                                                ]
                                                            }),
                                                            expandedRequiredItems[index] && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                style: {
                                                                    padding: "8px 14px",
                                                                    backgroundColor: activeTheme.cardBackground,
                                                                    color: activeTheme.cardFont
                                                                },
                                                                children: [
                                                                    validitytoBeShown && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                        className: "data-row",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                style: {
                                                                                    fontWeight: 500
                                                                                },
                                                                                children: [
                                                                                    durationLabel,
                                                                                    ":"
                                                                                ]
                                                                            }),
                                                                            " ",
                                                                            item.duration.value,
                                                                            " ",
                                                                            item.duration.unit
                                                                        ]
                                                                    }),
                                                                    !(dataItemToBeShown === false && processActivityNameToBeShown === false && processorNameToBeShown === false) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "required-details-container"
                                                                    }),
                                                                    item.processorActivities.map((activity, idx)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                                    style: {
                                                                                        marginTop: "0.5rem"
                                                                                    },
                                                                                    children: [
                                                                                        processActivityNameToBeShown && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                            className: "data-row",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                                    style: {
                                                                                                        fontWeight: 500
                                                                                                    },
                                                                                                    children: [
                                                                                                        processingActivityLabel,
                                                                                                        ":"
                                                                                                    ]
                                                                                                }),
                                                                                                " ",
                                                                                                activity.activityName
                                                                                            ]
                                                                                        }),
                                                                                        processorNameToBeShown && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                            className: "data-row",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                                    style: {
                                                                                                        fontWeight: 500
                                                                                                    },
                                                                                                    children: [
                                                                                                        usedbyLabel,
                                                                                                        ":"
                                                                                                    ]
                                                                                                }),
                                                                                                " ",
                                                                                                activity.processorName
                                                                                            ]
                                                                                        }),
                                                                                        dataItemToBeShown && activity.dataTypes.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                                    className: "data-row",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                                            style: {
                                                                                                                fontWeight: 500
                                                                                                            },
                                                                                                            children: [
                                                                                                                dataTypeLabel,
                                                                                                                ":"
                                                                                                            ]
                                                                                                        }),
                                                                                                        " ",
                                                                                                        activity.dataTypes.map((dt)=>dt.dataTypeName).join(", ")
                                                                                                    ]
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                                    className: "data-row",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                                            style: {
                                                                                                                fontWeight: 500
                                                                                                            },
                                                                                                            children: [
                                                                                                                dataItemLabel,
                                                                                                                ":"
                                                                                                            ]
                                                                                                        }),
                                                                                                        " ",
                                                                                                        activity.dataTypes.flatMap((dt)=>dt.dataItems).join(", ")
                                                                                                    ]
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                !(dataItemToBeShown === false && processActivityNameToBeShown === false && processorNameToBeShown === false) && idx !== item.processorActivities.length - 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                                    className: "required-details-container"
                                                                                })
                                                                            ]
                                                                        }, idx))
                                                                ]
                                                            })
                                                        ]
                                                    }, index))
                                            }),
                                            formOtherData && Object.keys(formOtherData).length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "container-6",
                                                        onClick: ()=>setShowOthersDetails(!showOhersDetails),
                                                        style: showOhersDetails ? {
                                                            borderBottom: "none",
                                                            borderBottomLeftRadius: 0,
                                                            borderBottomRightRadius: 0
                                                        } : {},
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                style: {
                                                                    display: "flex",
                                                                    justifyContent: "flex-start",
                                                                    alignItems: "center"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                                                        width: "30",
                                                                        height: "30",
                                                                        viewBox: "5 0 12 23",
                                                                        style: {
                                                                            // position: "absolute",
                                                                            top: "50%",
                                                                            right: "10px",
                                                                            transform: showOhersDetails ? "translateY(0%) rotate(180deg)" : "translateY(0%) rotate(0deg)",
                                                                            pointerEvents: "none",
                                                                            transition: "transform 0.3s ease",
                                                                            color: activeTheme.buttonBackground
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                            d: "M12 15a1.002 1.002 0 01-.71-.29l-4-4a1.004 1.004 0 111.42-1.42l3.29 3.3 3.29-3.3a1.004 1.004 0 111.42 1.42l-4 4A1.001 1.001 0 0112 15z",
                                                                            fill: "currentColor"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "container-Heading-fs",
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                            children: otherAccordionHeader
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                type: "checkbox",
                                                                className: "container-6-checkbox",
                                                                checked: allSelected,
                                                                onChange: (e)=>handleSelectAll(e.target.checked),
                                                                style: {
                                                                    appearance: "none",
                                                                    WebkitAppearance: "none",
                                                                    MozAppearance: "none",
                                                                    height: "25px",
                                                                    width: "25px",
                                                                    borderRadius: "4px",
                                                                    border: `1px solid ${activeTheme.cardFont}`,
                                                                    cursor: "pointer",
                                                                    backgroundColor: activeTheme.buttonBackground,
                                                                    backgroundImage: allSelected ? "url(\"data:image/svg+xml;utf8,<svg viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg'><path d='M3 8l3 3 7-7' stroke='white' stroke-width='2' fill='none' stroke-linecap='round' stroke-linejoin='round'/></svg>\")" : "none",
                                                                    backgroundRepeat: "no-repeat",
                                                                    backgroundPosition: "center"
                                                                }
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "required-details-container"
                                                    })
                                                ]
                                            }),
                                            showOhersDetails && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                children: formOtherData.map((item, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "sub-acc-item",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                style: {
                                                                    backgroundColor: activeTheme.subAccordionBackground,
                                                                    color: activeTheme.subAccordionFont,
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "space-between",
                                                                    padding: "10px 14px",
                                                                    cursor: "pointer"
                                                                },
                                                                onClick: ()=>setExpandedOtherItems((prev)=>({
                                                                            ...prev,
                                                                            [index]: !prev[index]
                                                                        })),
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        style: {
                                                                            display: "flex",
                                                                            alignItems: "flex-start",
                                                                            gap: "8px",
                                                                            flex: 1
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                                                                width: "20",
                                                                                height: "20",
                                                                                viewBox: "5 0 12 23",
                                                                                style: {
                                                                                    flexShrink: 0,
                                                                                    transform: expandedOtherItems[index] ? "rotate(180deg)" : "rotate(0deg)",
                                                                                    transition: "transform 0.3s ease",
                                                                                    color: activeTheme.buttonBackground,
                                                                                    pointerEvents: "none"
                                                                                },
                                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                                    d: "M12 15a1.002 1.002 0 01-.71-.29l-4-4a1.004 1.004 0 111.42-1.42l3.29 3.3 3.29-3.3a1.004 1.004 0 111.42 1.42l-4 4A1.001 1.001 0 0112 15z",
                                                                                    fill: "currentColor"
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                style: {
                                                                                    fontWeight: 700,
                                                                                    fontSize: "14px"
                                                                                },
                                                                                children: item.purpose.join(", ")
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                        type: "checkbox",
                                                                        checked: selectedPrefereneces[item.id] === "ACCEPTED",
                                                                        onChange: (e)=>handlePreferenceChange(item.id, e.target.checked),
                                                                        onClick: (e)=>e.stopPropagation(),
                                                                        style: {
                                                                            appearance: "none",
                                                                            WebkitAppearance: "none",
                                                                            MozAppearance: "none",
                                                                            height: "20px",
                                                                            width: "20px",
                                                                            borderRadius: "4px",
                                                                            border: `1px solid ${activeTheme.subAccordionFont || activeTheme.cardFont}`,
                                                                            cursor: "pointer",
                                                                            flexShrink: 0,
                                                                            backgroundColor: selectedPrefereneces[item.id] === "ACCEPTED" ? activeTheme.buttonBackground : "white",
                                                                            backgroundImage: selectedPrefereneces[item.id] === "ACCEPTED" ? "url(\"data:image/svg+xml;utf8,<svg viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg'><path d='M3 8l3 3 7-7' stroke='white' stroke-width='2' fill='none' stroke-linecap='round' stroke-linejoin='round'/></svg>\")" : "none",
                                                                            backgroundRepeat: "no-repeat",
                                                                            backgroundPosition: "center"
                                                                        }
                                                                    })
                                                                ]
                                                            }),
                                                            expandedOtherItems[index] && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                style: {
                                                                    padding: "8px 14px",
                                                                    backgroundColor: activeTheme.cardBackground,
                                                                    color: activeTheme.cardFont
                                                                },
                                                                children: [
                                                                    validitytoBeShown && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                        className: "data-row",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                style: {
                                                                                    fontWeight: 500
                                                                                },
                                                                                children: [
                                                                                    durationLabel,
                                                                                    ":"
                                                                                ]
                                                                            }),
                                                                            " ",
                                                                            item.duration.value,
                                                                            " ",
                                                                            item.duration.unit
                                                                        ]
                                                                    }),
                                                                    !(dataItemToBeShown === false && processActivityNameToBeShown === false && processorNameToBeShown === false) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "required-details-container"
                                                                    }),
                                                                    item.processorActivities.map((activity, idx)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                                    style: {
                                                                                        marginTop: "0.5rem"
                                                                                    },
                                                                                    children: [
                                                                                        processActivityNameToBeShown && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                            className: "data-row",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                                    style: {
                                                                                                        fontWeight: 500
                                                                                                    },
                                                                                                    children: [
                                                                                                        processingActivityLabel,
                                                                                                        ":"
                                                                                                    ]
                                                                                                }),
                                                                                                " ",
                                                                                                activity.activityName
                                                                                            ]
                                                                                        }),
                                                                                        processorNameToBeShown && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                            className: "data-row",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                                    style: {
                                                                                                        fontWeight: 500
                                                                                                    },
                                                                                                    children: [
                                                                                                        usedbyLabel,
                                                                                                        ":"
                                                                                                    ]
                                                                                                }),
                                                                                                " ",
                                                                                                activity.processorName
                                                                                            ]
                                                                                        }),
                                                                                        dataItemToBeShown && activity.dataTypes.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                                    className: "data-row",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                                            style: {
                                                                                                                fontWeight: 500
                                                                                                            },
                                                                                                            children: [
                                                                                                                dataTypeLabel,
                                                                                                                ":"
                                                                                                            ]
                                                                                                        }),
                                                                                                        " ",
                                                                                                        activity.dataTypes.map((dt)=>dt.dataTypeName).join(", ")
                                                                                                    ]
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                                    className: "data-row",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                                            style: {
                                                                                                                fontWeight: 500
                                                                                                            },
                                                                                                            children: [
                                                                                                                dataItemLabel,
                                                                                                                ":"
                                                                                                            ]
                                                                                                        }),
                                                                                                        " ",
                                                                                                        activity.dataTypes.flatMap((dt)=>dt.dataItems).join(", ")
                                                                                                    ]
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                !(dataItemToBeShown === false && processActivityNameToBeShown === false && processorNameToBeShown === false) && idx !== item.processorActivities.length - 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                                    className: "required-details-container"
                                                                                })
                                                                            ]
                                                                        }, idx))
                                                                ]
                                                            })
                                                        ]
                                                    }, index))
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "documentText",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    style: {
                                                        cursor: "pointer",
                                                        color: activeTheme.linkFont
                                                    },
                                                    onClick: openDocument,
                                                    children: documentName
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "container-7",
                                                children: parentalControl && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                    className: "container-7-outer",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                            type: "checkbox",
                                                            className: "checkbox-new",
                                                            checked: isParentChecked,
                                                            onChange: (e)=>{
                                                                const checked = e.target.checked;
                                                                setIsParentChecked(checked);
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "container-7-text",
                                                            children: ageSentence
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "container-8",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                    children: [
                                                        rightsDescription,
                                                        " ",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            style: {
                                                                cursor: "pointer",
                                                                color: activeTheme.linkFont
                                                            }
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "container-9",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    children: permissionDescription
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "container-10-update",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                className: "container-10-update-withdraw",
                                                onClick: captureConsent,
                                                style: {
                                                    backgroundColor: activeTheme.buttonFont,
                                                    border: "1px solid rgb(181, 181, 181)"
                                                },
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "container-10-update-withdraw-text",
                                                    style: {
                                                        color: activeTheme.buttonBackground
                                                    },
                                                    children: withdrawConsentBtnText
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                className: "container-10-update-consent",
                                                onClick: captureAllConsents,
                                                style: {
                                                    backgroundColor: activeTheme.buttonBackground,
                                                    border: "1px solid rgb(181, 181, 181)"
                                                },
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "container-10-update-consent-text ",
                                                    style: {
                                                        color: activeTheme.buttonFont
                                                    },
                                                    children: updateConsentBtnText
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    sessionExpired && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63ff59473b55bad2$export$2e2bcd8739ae039), {
                        isOpen: sessionExpired,
                        onClose: ()=>setSessionExpired(false)
                    }),
                    isDigiLockerLoading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            backgroundColor: "rgba(255, 255, 255, 0.8)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            zIndex: 9999
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "loader"
                        })
                    }),
                    openRelationPopUp && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "modal-outer-container",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "modal-container",
                            style: {
                                backgroundColor: activeTheme.cardBackground,
                                color: activeTheme.cardFont
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "container-1",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        class: "close-btn",
                                        style: {
                                            "--close-color": activeTheme.buttonBackground
                                        },
                                        onClick: ()=>{
                                            setOpenRelationPopUp(false);
                                            setShowParentModal(true);
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                    style: {
                                        fontSize: "18px",
                                        fontWeight: "700",
                                        marginBottom: "20px"
                                    },
                                    children: relationshipModalHeader
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                            style: {
                                                display: "block",
                                                marginBottom: "12px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    type: "radio",
                                                    name: "guardianType",
                                                    value: "PARENT",
                                                    checked: guardianType === "PARENT",
                                                    onChange: ()=>setGuardianType("PARENT"),
                                                    style: {
                                                        marginRight: "8px"
                                                    }
                                                }),
                                                relationParent
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                            style: {
                                                display: "block",
                                                marginBottom: "12px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    type: "radio",
                                                    name: "guardianType",
                                                    value: "LEGAL_GUARDIAN",
                                                    checked: guardianType === "LEGAL_GUARDIAN",
                                                    onChange: ()=>setGuardianType("LEGAL_GUARDIAN"),
                                                    style: {
                                                        marginRight: "8px"
                                                    }
                                                }),
                                                relationLegalGuardian
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                            style: {
                                                display: "block",
                                                marginBottom: "8px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    type: "radio",
                                                    name: "guardianType",
                                                    value: "OTHER",
                                                    checked: guardianType === "OTHER",
                                                    onChange: ()=>setGuardianType("OTHER"),
                                                    style: {
                                                        marginRight: "8px"
                                                    }
                                                }),
                                                relationOther
                                            ]
                                        }),
                                        guardianType === "OTHER" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            style: {
                                                marginLeft: "24px",
                                                marginTop: "8px"
                                            },
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "text",
                                                placeholder: "Please specify relationship",
                                                ref: otherTextRef,
                                                style: {
                                                    width: "90%",
                                                    padding: "6px 10px",
                                                    borderRadius: "6px",
                                                    border: "1px solid #ccc",
                                                    fontSize: "14px"
                                                }
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        gap: "10px",
                                        marginTop: "24px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            onClick: handleClear,
                                            style: {
                                                padding: "8px 18px",
                                                borderRadius: "24px",
                                                fontFamily: "system-ui",
                                                fontWeight: 700,
                                                color: activeTheme.buttonBackground,
                                                fontSize: "18px",
                                                backgroundColor: activeTheme.buttonFont,
                                                border: "1px solid rgba(181, 181, 181, 1)",
                                                cursor: "pointer"
                                            },
                                            children: relationModalClearBtnText
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            onClick: handleSave,
                                            style: {
                                                padding: "8px 20px",
                                                borderRadius: "24px",
                                                backgroundColor: activeTheme.buttonBackground,
                                                border: "1px solid rgba(181, 181, 181, 1)",
                                                fontSize: "18px",
                                                fontFamily: "system-ui",
                                                fontWeight: 700,
                                                color: activeTheme.buttonFont,
                                                cursor: "pointer"
                                            },
                                            children: relationModalSaveBtnText
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    showParentModal && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "modal-outer-container",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "modal-container",
                            style: {
                                backgroundColor: activeTheme.cardBackground,
                                color: activeTheme.cardFont
                            },
                            children: [
                                selectedKYCMethod === "declaration" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "step-header-parent",
                                    style: {
                                        display: "flex",
                                        justifyContent: currentModalStep === 2 ? "space-between" : "flex-end",
                                        alignItems: "center",
                                        marginBottom: "16px"
                                    },
                                    children: currentModalStep === 2 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        onClick: ()=>setCurrentModalStep(1),
                                        style: {
                                            background: "none",
                                            border: "none",
                                            cursor: "pointer",
                                            padding: 0,
                                            display: "flex",
                                            alignItems: "center",
                                            color: activeTheme.buttonBackground
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                            width: "24",
                                            height: "24",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                d: "M15 20a1.003 1.003 0 01-.71-.29l-7-7a1 1 0 010-1.42l7-7a1.005 1.005 0 011.42 1.42L9.41 12l6.3 6.29a.997.997 0 01.219 1.095.999.999 0 01-.93.615z",
                                                fill: "currentColor"
                                            })
                                        })
                                    })
                                }),
                                currentModalStep === 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "parentTextStyle1",
                                            children: parentModalHeader
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "dropdown-container-parent",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "dropdown-wrapper-parent",
                                                style: {
                                                    position: "relative"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                        className: "custom-select-parent",
                                                        value: selectedKYCMethod,
                                                        onChange: (e)=>setSelectedKYCMethod(e.target.value),
                                                        onClick: ()=>setIsOpenParent((prev)=>!prev),
                                                        onBlur: ()=>setIsOpenParent(false),
                                                        style: {
                                                            width: "100%",
                                                            height: "40px",
                                                            borderRadius: "8px",
                                                            border: "1px solid rgba(181, 181, 181, 1)",
                                                            paddingLeft: "8px",
                                                            paddingRight: "8px",
                                                            appearance: "none",
                                                            fontSize: "14px"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                value: "",
                                                                children: "Select Method"
                                                            }),
                                                            digilockerClientId && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                value: "digilocker",
                                                                children: "Proceed with KYC of the parent/legal guardian using DigiLocker"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                value: "declaration",
                                                                children: "Send the consent link to the parent/legal guardian over SMS/email and obtain approval"
                                                            })
                                                        ]
                                                    }),
                                                    isOpenParent ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9efe7828a40b52f7$export$acd925e63e14000f), {
                                                        height: 20,
                                                        width: 20,
                                                        style: {
                                                            position: "absolute",
                                                            right: "8px",
                                                            top: "50%",
                                                            transform: "translateY(-50%)"
                                                        }
                                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fdc94045ec0e5793$export$ec7db1c418c1ec5a), {
                                                        height: 20,
                                                        width: 20,
                                                        style: {
                                                            position: "absolute",
                                                            right: "8px",
                                                            top: "50%",
                                                            transform: "translateY(-50%)"
                                                        }
                                                    })
                                                ]
                                            })
                                        }),
                                        selectedKYCMethod === "declaration" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "parentTextStyle1",
                                                    children: parentsName
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    className: "input-parent",
                                                    ref: parentNameRef
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "parentTextStyle1",
                                                    children: parentsIdentity
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    className: "input-parent",
                                                    ref: parentIdentityRef
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "container-10",
                                    style: {
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        gap: "10px"
                                    },
                                    children: [
                                        currentModalStep < 2 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            className: "container-10-button",
                                            style: {
                                                backgroundColor: activeTheme.buttonFont,
                                                border: "1px solid rgba(181, 181, 181, 1)"
                                            },
                                            onClick: ()=>{
                                                closeParentModal();
                                                setShowUpdateModal(true);
                                            },
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                style: {
                                                    fontFamily: "system-ui",
                                                    fontWeight: 700,
                                                    color: activeTheme.buttonBackground,
                                                    fontSize: "18px"
                                                },
                                                children: parentModalCancelBtnText
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            className: "container-10-button",
                                            style: {
                                                backgroundColor: activeTheme.buttonBackground,
                                                border: "1px solid rgba(181, 181, 181, 1)"
                                            },
                                            onClick: ()=>{
                                                if (!selectedKYCMethod) {
                                                    (0, $b00d3e7401eac195$export$b410431fab84fa58).error((props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482ccd6e8e9b33b1$export$2e2bcd8739ae039), {
                                                            ...props,
                                                            type: "error",
                                                            message: "Please select a method"
                                                        }), {
                                                        icon: false
                                                    });
                                                    return;
                                                }
                                                if (selectedKYCMethod === "declaration") {
                                                    if (currentModalStep === 1) {
                                                        let name = parentNameRef.current.value.trim();
                                                        let identity = parentIdentityRef.current.value.trim();
                                                        name = name.replace(/\s+/g, " ");
                                                        parentNameRef.current.value = name;
                                                        const errors = [];
                                                        const nameRegex = /^[A-Za-z]+(?:\s[A-Za-z]+)*$/;
                                                        if (!name) errors.push("Please enter parent's name");
                                                        else if (!nameRegex.test(name)) {
                                                            if (/[0-9]/.test(name)) errors.push("Please enter valid name (no numbers allowed)");
                                                            else if (/[^A-Za-z\s]/.test(name)) errors.push("Please enter valid name (no special characters allowed)");
                                                        }
                                                        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                                                        const mobileRegex = /^\d{10}$/;
                                                        identity = identity.replace(/\s+/g, "");
                                                        parentIdentityRef.current.value = identity;
                                                        if (!identity) errors.push("Please enter parent's identity (email or mobile)");
                                                        else if (!emailRegex.test(identity) && !mobileRegex.test(identity)) errors.push("Please enter valid identity (email or 10-digit mobile number)");
                                                        if (errors.length > 0) {
                                                            (0, $b00d3e7401eac195$export$b410431fab84fa58).error((props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482ccd6e8e9b33b1$export$2e2bcd8739ae039), {
                                                                    ...props,
                                                                    type: "error",
                                                                    message: errors.map((err, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                            children: `${index + 1}. ${err}`
                                                                        }, index))
                                                                }), {
                                                                icon: false
                                                            });
                                                            return;
                                                        } else {
                                                            setShowParentModal(false);
                                                            sendConsentRequest();
                                                        }
                                                    }
                                                }
                                                if (selectedKYCMethod === "digilocker") {
                                                    const responseType = "code";
                                                    const codeChallengeMethod = "S256";
                                                    const newTab = window.open("", "_blank");
                                                    if (!newTab) {
                                                        alert("Popup blocked. Please allow popups for this site.");
                                                        return;
                                                    }
                                                    digiLockerTabRef.current = newTab;
                                                    // Close modals & show loader
                                                    setShowUpdateModal(false);
                                                    setShowParentModal(false);
                                                    setIsParentChecked(false);
                                                    setIsDigiLockerLoading(true);
                                                    // Now async work is SAFE
                                                    (async ()=>{
                                                        try {
                                                            const consentMetaId = await generateConsentMetaId("parent");
                                                            if (!consentMetaId) throw new Error("ConsentMetaId missing");
                                                            const state = consentMetaId;
                                                            const state2 = `${consentMetaId}:${secure_code_for_state}`;
                                                            const codeChallenge = await generateCodeChallenge(digilockerCodeVerifier);
                                                            const digilockerAuthUrl = `https://api.digitallocker.gov.in/public/oauth2/1/authorize` + `?response_type=${responseType}` + `&client_id=${digilockerClientId}` + `&redirect_uri=${digilockerRedirectUri}` + `&code_challenge=${codeChallenge}` + `&code_challenge_method=${codeChallengeMethod}` + `&state=${state2}`;
                                                            //  Redirect already-opened tab
                                                            digiLockerTabRef.current.location.href = digilockerAuthUrl;
                                                            //  Watch tab close
                                                            const checkInterval = setInterval(()=>{
                                                                if (!digiLockerTabRef.current || digiLockerTabRef.current.closed) {
                                                                    clearInterval(checkInterval);
                                                                    setIsDigiLockerLoading(false);
                                                                }
                                                            }, 1000);
                                                        } catch (err) {
                                                            console.error(err);
                                                            setIsDigiLockerLoading(false);
                                                            digiLockerTabRef.current?.close();
                                                        }
                                                    })();
                                                    return;
                                                }
                                            },
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                style: {
                                                    fontFamily: "system-ui",
                                                    fontWeight: 700,
                                                    color: activeTheme.buttonFont,
                                                    fontSize: "18px"
                                                },
                                                children: parentModalNextBtnText
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    withdrawLoader && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "withdraw-overlay",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "blinking-text",
                            children: [
                                "Withdrawing your consent",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "dots"
                                })
                            ]
                        })
                    }),
                    digiLoader && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "withdraw-overlay",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "blinking-text",
                            children: [
                                "Processing your consent",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "dots"
                                })
                            ]
                        })
                    }),
                    translationLoader && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "withdraw-overlay",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "blinking-text",
                            children: [
                                "Translating",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "dots"
                                })
                            ]
                        })
                    }),
                    pageLoader && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "withdraw-overlay",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "blinking-text",
                            children: [
                                "Loading Pop Up",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "dots"
                                })
                            ]
                        })
                    }),
                    updateLoader && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "withdraw-overlay",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "blinking-text",
                            children: [
                                "Processing your consent",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "dots"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b00d3e7401eac195$export$f2815235e76a62b9), {
                position: "bottom-left",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                closeButton: false,
                toastClassName: ()=>"toast-wrapper",
                transition: (0, $b00d3e7401eac195$export$d8dc01b5c85a37b9)
            })
        ]
    });
};
var $2e1c888804f61777$export$2e2bcd8739ae039 = $2e1c888804f61777$var$SystemRequests;




var $acw62 = parcelRequire("acw62");













var $0ce165fce4857ef1$exports = {};
$0ce165fce4857ef1$exports = import.meta.resolve("P4kTU");


const $106ac01a8584f523$var$CreateRequest = ()=>{
    const logos = new URL($0ce165fce4857ef1$exports).href;
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const [mobile, setMobile] = (0, $acw62.useState)(true);
    const [backButtonSizeSmall, setBackButtonSizeSmall] = (0, $acw62.useState)(()=>typeof window !== "undefined" ? window.matchMedia("(max-width: 767px)").matches : false);
    const [title, setTitle] = (0, $acw62.useState)("Register your grievance");
    const [purposeHeading, setPurposeHeading] = (0, $acw62.useState)("Purpose: ");
    const [processingHeading, setProcessingHeading] = (0, $acw62.useState)("Processing activity: ");
    const [usedByHeading, setUsedByHeading] = (0, $acw62.useState)("Used By: ");
    const [durationHeading, setDurationHeading] = (0, $acw62.useState)("Duration: ");
    const [dataItemHeading, setDataItemHeading] = (0, $acw62.useState)("Data item: ");
    const [selectedType, setSelectedType] = (0, $acw62.useState)("");
    const [selectedGrievanceType, setSelectedGrievanceType] = (0, $acw62.useState)("");
    const [selectedDetail, setSelectedDetail] = (0, $acw62.useState)("");
    const [grievanceFormTemplate, setGrievanceFormTemplate] = (0, $acw62.useState)({});
    const [dynamicTranslations, setDynamicTranslations] = (0, $acw62.useState)({});
    // Helper to get dynamic translation
    const getDynamicTranslation = (text)=>{
        if (!text || currentLanguage === "ENGLISH") return text;
        return dynamicTranslations[text] || text;
    };
    // Translation inputs for static text
    const translationInputs = (0, $acw62.useMemo)(()=>[
            {
                id: "create_title",
                source: "Register your grievance"
            },
            {
                id: "create_description",
                source: "Please provide the following details to register your grievance."
            },
            {
                id: "create_purpose",
                source: "Purpose: "
            },
            {
                id: "create_processing",
                source: "Processing activity: "
            },
            {
                id: "create_used_by",
                source: "Used By: "
            },
            {
                id: "create_duration",
                source: "Duration: "
            },
            {
                id: "create_data_item",
                source: "Data item: "
            },
            {
                id: "create_grievance_details",
                source: "Grievance Details"
            },
            {
                id: "create_select_category",
                source: "Select Category"
            },
            {
                id: "create_grievance_category",
                source: "Grievance Category"
            },
            {
                id: "create_grievance_subcategory",
                source: "Grievance Subcategory"
            },
            {
                id: "create_enter_subcategory",
                source: "Enter Grievance Subcategory"
            },
            {
                id: "create_description",
                source: "Description (Required)"
            },
            {
                id: "create_description_placeholder",
                source: "Enter description of the group's function or scope."
            },
            {
                id: "create_user_details",
                source: "User Details"
            },
            {
                id: "create_user_type",
                source: "User Type"
            },
            {
                id: "create_select_user_type",
                source: "Select user type"
            },
            {
                id: "create_upload_files",
                source: "Upload Files"
            },
            {
                id: "create_upload",
                source: "Upload"
            },
            {
                id: "create_upload_instruction",
                source: "Drag and drop or upload a document with hyperlink with the consent banner in .pdf or .doc format."
            },
            {
                id: "create_required",
                source: "Required"
            },
            {
                id: "create_enter",
                source: "Enter"
            },
            {
                id: "create_submit_request",
                source: "Submit Request"
            },
            {
                id: "create_always_active",
                source: "Always Active"
            }
        ], []);
    // Use translation hook
    const { getTranslation: getTranslation, translateContent: translateContent, currentLanguage: currentLanguage, isTranslating: isTranslating } = (0, $dbe8cedc9e1aa4ce$export$2e2bcd8739ae039)(translationInputs);
    // Function to translate form field values
    const translateFormFields = async (template, targetLang)=>{
        if (!template || targetLang === "en") {
            setDynamicTranslations({});
            return;
        }
        const uniqueTexts = new Set();
        // Collect grievance types and subcategories
        template.multilingual?.grievanceInformation?.forEach((info)=>{
            if (info.grievanceType) uniqueTexts.add(info.grievanceType);
            info.grievanceSubCategory?.forEach((sub)=>uniqueTexts.add(sub));
            // Also collect grievanceItems (used in dropdown)
            info.grievanceItems?.forEach((item)=>uniqueTexts.add(item));
        });
        // Collect user types and field names
        template.multilingual?.userInformation?.forEach((info)=>{
            info.userType?.forEach((type)=>uniqueTexts.add(type));
            // Collect field names from userItems
            info.userItems?.forEach((item)=>uniqueTexts.add(item));
            // Also collect from userDetails if exists
            info.userDetails?.forEach((detail)=>{
                if (detail.detailName) uniqueTexts.add(detail.detailName);
            });
        });
        if (uniqueTexts.size === 0) return;
        const inputs = Array.from(uniqueTexts).map((text, idx)=>({
                id: `form_${idx}`,
                source: text
            }));
        try {
            const response = await dispatch((0, $6eea01a75b53fee5$export$7d0f208153a27d67)("en", targetLang, inputs));
            if (response?.status === 200 && response?.data?.output) {
                const translatedMap = {};
                response.data.output.forEach((item, idx)=>{
                    translatedMap[inputs[idx].source] = item.target;
                });
                setDynamicTranslations(translatedMap);
            }
        } catch (error) {
            console.log("Error translating form fields:", error);
        }
    };
    // Translate content when language changes
    (0, $acw62.useEffect)(()=>{
        if (currentLanguage !== "ENGLISH") {
            translateContent(translationInputs, currentLanguage);
            if (grievanceFormTemplate && Object.keys(grievanceFormTemplate).length > 0) {
                const targetLang = (0, $dbe8cedc9e1aa4ce$export$d340805709eeec9f)(currentLanguage);
                translateFormFields(grievanceFormTemplate, targetLang);
            }
        } else setDynamicTranslations({});
    }, [
        currentLanguage,
        translationInputs,
        translateContent,
        grievanceFormTemplate
    ]);
    (0, $acw62.useEffect)(()=>{
        const mq = window.matchMedia("(max-width: 767px)");
        const syncBackButtonSize = ()=>setBackButtonSizeSmall(mq.matches);
        syncBackButtonSize();
        mq.addEventListener("change", syncBackButtonSize);
        return ()=>mq.removeEventListener("change", syncBackButtonSize);
    }, []);
    (0, $acw62.useEffect)(()=>{
        const fetchData = async ()=>{
            try {
                const response = await dispatch((0, $6eea01a75b53fee5$export$6a9543e1c857ef52)());
                if (response.status === 200) {
                    setGrievanceFormTemplate(response.data);
                    const data = response.data;
                    const supportedLanguages = data?.multilingual?.supportedLanguages;
                    const selectedLanguage = supportedLanguages?.[0];
                    let title = "";
                    let text = "";
                    if (selectedLanguage && data?.languages) {
                        // Find the entry in languages where key corresponds to that language
                        const matchingLanguageEntry = Object.values(data.languages).find((lang)=>lang.language?.toUpperCase() === selectedLanguage.toUpperCase() || lang.heading?.toUpperCase().includes(selectedLanguage.toUpperCase()));
                        if (matchingLanguageEntry) {
                            title = matchingLanguageEntry.heading || "";
                            text = matchingLanguageEntry.description || "";
                        }
                    }
                    setTitle(title);
                    setText(text);
                    setLogoPreviewUrl(data?.uiConfig.logo || logos);
                }
            } catch (err) {
                console.log("Error occured in getConsentsByTemplateId", err);
                if (err?.[0]?.errorCode === "JCMP3001") grievanceFormTemplate({});
            } finally{
            // setLoadLogs(false);
            }
        };
        fetchData();
    }, []);
    const [grievanceDesc, setGrievanceDesc] = (0, $acw62.useState)("");
    const [grievanceTitle, setGrievanceTitle] = (0, $acw62.useState)("");
    const [grievancePriority, setGrievancePriority] = (0, $acw62.useState)("");
    const [initialComment, setInitialComment] = (0, $acw62.useState)("");
    const [isSubmitting, setIsSubmitting] = (0, $acw62.useState)(false);
    // for upload component
    const uploadFileInputRef = (0, $acw62.useRef)(null);
    const [uploadFileName, setUploadFileName] = (0, $acw62.useState)("");
    const [uploadFileBase64, setUploadFileBase64] = (0, $acw62.useState)("");
    const [uploadFile, setUploadFile] = (0, $acw62.useState)(null);
    const [upoladFilePreviewUrl, setUploadFilePreviewUrl] = (0, $acw62.useState)("");
    const [selectedUserType, setSelectedUserType] = (0, $acw62.useState)("");
    const [userDetailInputs, setUserDetailInputs] = (0, $acw62.useState)({});
    // for translation - using translation hook
    const [text, setText] = (0, $acw62.useState)("While using JioMeet, your activities create data which will be used with your consent to offer customised services. Details of data usage are provided below. ");
    // Get translated labels from hook
    const grievanceDetailsHeading = getTranslation("create_grievance_details", "Grievance Details");
    const selectCategoryPlaceholder = getTranslation("create_select_category", "Select Category");
    const grievanceCategoryLabel = getTranslation("create_grievance_category", "Grievance Category");
    const grievanceSubCategoryLabel = getTranslation("create_grievance_subcategory", "Grievance Subcategory");
    const subCategoryPlaceholder = getTranslation("create_enter_subcategory", "Enter Grievance Subcategory");
    const descriptionLabel = getTranslation("create_description", "Description (Required)");
    const descriptionPlaceholder = getTranslation("create_description_placeholder", "Enter description of the group's function or scope.");
    const userDetailsHeading = getTranslation("create_user_details", "User Details");
    const userTypeLabel = getTranslation("create_user_type", "User Type");
    const userTypePlaceholder = getTranslation("create_select_user_type", "Select user type");
    const uploadFilesHeading = getTranslation("create_upload_files", "Upload Files");
    const uploadButtonText = getTranslation("create_upload", "Upload");
    const uploadInstruction = getTranslation("create_upload_instruction", "Drag and drop or upload a document with hyperlink with the consent banner in .pdf or .doc format.");
    const requiredLable = getTranslation("create_required", "Required");
    const enterLable = getTranslation("create_enter", "Enter");
    const handleTextAreaChange = (e)=>{
        setGrievanceDesc(e.target.value);
    };
    const toTitleCase = (str)=>{
        return str.toLowerCase().replace(/\b\w/g, (char)=>char.toUpperCase());
    };
    const [purposes, setPurposes] = (0, $acw62.useState)([
        {
            purposeIds: [],
            purposeNames: [],
            isMandatory: "",
            autoRenew: "",
            preferenceValidity: {
                value: 1,
                unit: ""
            },
            purposeActivityIds: [],
            usedBy: [],
            dataItems: [],
            processingAct: []
        }
    ]);
    // upoad component
    const handleUploadFilesClick = ()=>{
        uploadFileInputRef.current?.click();
    };
    const handleUploadFilesDragOver = (e)=>{
        e.preventDefault();
        e.stopPropagation();
    };
    const handleUploadFilesDragLeave = (e)=>{
        e.preventDefault();
        e.stopPropagation();
    };
    const handleUploadFilesDrop = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        const file = e.dataTransfer.files[0];
        if (file) processUploadFile(file);
    };
    const handleUploadFilieChange = (e)=>{
        const file = e.target.files[0];
        if (file) processUploadFile(file);
    };
    const processUploadFile = (file)=>{
        setUploadFileName(file.name);
        setUploadFile(file);
        const reader = new FileReader();
        reader.onloadend = ()=>{
            const base64String = reader.result.split(",")[1];
            setUploadFileBase64(base64String);
            setUploadFilePreviewUrl(reader.result);
        };
        reader.readAsDataURL(file);
    };
    const handleRemoveUploadFile = ()=>{
        setUploadFileName("");
        setUploadFileBase64("");
        setUploadFile(null);
        setUploadFilePreviewUrl("");
        if (uploadFileInputRef.current) uploadFileInputRef.current.value = "";
    };
    const handlePreviewUploadFile = ()=>{
        if (upoladFilePreviewUrl) window.open(upoladFilePreviewUrl, "_blank");
    };
    // Custom style for select
    const customStyles = {
        control: (base, state)=>({
                ...base,
                color: "#333",
                backgroundColor: "#fff",
                border: "1px solid #ccc",
                borderRadius: "8px",
                padding: "2px 4px",
                fontSize: "14px",
                minHeight: "40px",
                boxShadow: "none",
                borderColor: state.isFocused ? "#ccc" : "#ccc",
                "&:hover": {
                    borderColor: "#999"
                }
            }),
        valueContainer: (base)=>({
                ...base,
                padding: "0 8px",
                gap: "4px"
            }),
        placeholder: (base)=>({
                ...base,
                color: "#666",
                fontSize: "14px"
            }),
        multiValue: (base)=>({
                ...base,
                borderRadius: "6px",
                backgroundColor: "#f0f0f0",
                padding: "2px 6px"
            }),
        multiValueLabel: (base)=>({
                ...base,
                color: "#333",
                fontSize: "13px"
            }),
        multiValueRemove: (base)=>({
                ...base,
                color: "#666",
                cursor: "pointer",
                ":hover": {
                    backgroundColor: "#e0e0e0",
                    color: "#000"
                }
            }),
        menu: (base)=>({
                ...base,
                borderRadius: "8px",
                border: "1px solid #ccc",
                marginTop: "4px",
                zIndex: 9999
            }),
        menuList: (base)=>({
                ...base,
                padding: "4px 0"
            }),
        option: (base, state)=>({
                ...base,
                fontSize: "14px",
                padding: "8px 12px",
                cursor: "pointer",
                backgroundColor: state.isSelected ? "#e6f0ff" : state.isFocused ? "#f5f5f5" : "#fff",
                color: "#333",
                ":active": {
                    backgroundColor: "#e6f0ff"
                }
            }),
        dropdownIndicator: (base)=>({
                ...base,
                color: "#666",
                padding: "0 8px",
                "&:hover": {
                    color: "#333"
                }
            }),
        clearIndicator: (base)=>({
                ...base,
                padding: "0 8px"
            })
    };
    //language container states
    const AccordionItem = ({ title: title, alwaysActive: alwaysActive, hasCheckbox: hasCheckbox, items: items })=>{
        const [isOpen, setIsOpen] = (0, $acw62.useState)(true);
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "accordion-item",
            style: {
                backgroundColor: activePopupColors.cardBackground,
                color: activePopupColors.cardFont
            },
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "accordion-header",
                    onClick: ()=>setIsOpen(!isOpen),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "accordion-left",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: `accordion-icon ${isOpen ? "open" : ""}`,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fdc94045ec0e5793$export$ec7db1c418c1ec5a), {
                                        height: 25,
                                        width: 25
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "accordion-title",
                                    children: title
                                })
                            ]
                        }),
                        alwaysActive && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "accordion-label",
                            children: getTranslation("create_always_active", "Always Active")
                        }),
                        hasCheckbox && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "checkbox"
                        })
                    ]
                }),
                isOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "accordion-content",
                    style: {
                        backgroundColor: activePopupColors.cardBackground,
                        color: activePopupColors.cardFont
                    },
                    children: items.map((item, idx)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "accordion-block",
                            children: [
                                item.purposeNames?.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: purposeHeading
                                        }),
                                        " ",
                                        item.purposeNames.join(", ")
                                    ]
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: purposeHeading
                                        }),
                                        " Not provided"
                                    ]
                                }),
                                validitytoBeShown && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: durationHeading
                                        }),
                                        " ",
                                        item.preferenceValidity?.value ? `${item.preferenceValidity.value} ${toTitleCase(item.preferenceValidity.value === 1 ? item.preferenceValidity.unit.replace(/s$/i, "") // singular
                                         : item.preferenceValidity.unit)}` : "N/A"
                                    ]
                                }),
                                item.usedBy?.length > 0 && processorNameToBeShown && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: usedByHeading
                                        }),
                                        " ",
                                        item.usedBy.join(", ")
                                    ]
                                }),
                                processActivityNameToBeShown && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: processingHeading
                                        }),
                                        " ",
                                        item.processingAct?.join(", ")
                                    ]
                                }),
                                dataItemToBeShown && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: dataItemHeading
                                        }),
                                        " ",
                                        item.dataItems?.join(", ")
                                    ]
                                }),
                                idx !== items.length - 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                                    className: "accordion-separator"
                                })
                            ]
                        }, idx))
                })
            ]
        });
    };
    const [rights, setRights] = (0, $acw62.useState)("To withdraw your consent, exercise your rights, or file complaints with the Board click here.");
    const [permission, setPermission] = (0, $acw62.useState)("By clicking \u2018Allow all\u2019 or \u2019Save my choices\u2019, you are providing your consent to Reliance Medlab using your data as outlined above.");
    const [supportedLanguages, setSupportedLanguages] = (0, $acw62.useState)([]);
    const [language, setLanguage] = (0, $acw62.useState)("");
    const [label, setLabel] = (0, $acw62.useState)("Required");
    const [languageSpecificContentMap, setLanguageSpecificContentMap] = (0, $acw62.useState)({
        ENGLISH: {
            description: text,
            heading: "Register your grievance"
        }
    });
    //purpose container states
    const [purposeItems, setPurposeItems] = (0, $acw62.useState)([
        0
    ]);
    const [counter, setCounter] = (0, $acw62.useState)(1);
    const [processingActivityList, setProcessingActivityList] = (0, $acw62.useState)([]);
    const [activityOptions, setActivityOptions] = (0, $acw62.useState)([]);
    const [purposeOptions, setPurposeOptions] = (0, $acw62.useState)([]);
    const [processingActivityOptions, setProcessingActivityOptions] = (0, $acw62.useState)([]);
    const [purposeList, setPurposeList] = (0, $acw62.useState)([]);
    //branding states
    const [fileName, setFileName] = (0, $acw62.useState)("");
    const [certificatePreviewUrl, setCertificatePreviewUrl] = (0, $acw62.useState)("");
    const fileInputRef = (0, $acw62.useRef)(null);
    const [fileBase64, setFileBase64] = (0, $acw62.useState)(null);
    const [logoPreviewUrl, setLogoPreviewUrl] = (0, $acw62.useState)("");
    const [logoName, setLogoName] = (0, $acw62.useState)("");
    const logoInputRef = (0, $acw62.useRef)(null);
    const [logoBase64, setLogoBase64] = (0, $acw62.useState)("");
    const [fileSize, setFileSize] = (0, $acw62.useState)(0);
    const [darkMode, setDarkMode] = (0, $acw62.useState)(false);
    const [mobileView, setMobileView] = (0, $acw62.useState)(true);
    const [parentalControl, setParentalControl] = (0, $acw62.useState)(true);
    const [dataTypeToBeShown, setDataTypeToBeShown] = (0, $acw62.useState)(true);
    const [dataItemToBeShown, setDataItemToBeShown] = (0, $acw62.useState)(true);
    const [processActivityNameToBeShown, setProcessActivityNameToBeShown] = (0, $acw62.useState)(true);
    const [processorNameToBeShown, setProcessorNameToBeShown] = (0, $acw62.useState)(true);
    const [validitytoBeShown, setValiditytoBeShown] = (0, $acw62.useState)(true);
    const [colors, setColors] = (0, $acw62.useState)({
        cardBackground: "#FFFFFF",
        cardFont: "#000000",
        buttonBackground: "#0F3CC9",
        buttonFont: "#FFFFFF",
        linkFont: "#0A2885"
    });
    const [darkColors, setDarkColors] = (0, $acw62.useState)({
        cardBackground: "#000000",
        cardFont: "#FFFFFF",
        buttonBackground: "#FFFFFF",
        buttonFont: "#0F3CC9",
        linkFont: "#0A2885"
    });
    const activePopupColors = darkMode ? darkColors : colors;
    const [languageContent, setLanguageContent] = (0, $acw62.useState)({
        ENGLISH: {
            description: "sample description",
            label: "Required",
            rightsText: "sample rights text",
            permissionText: "sample permission text"
        }
    });
    const lightString = JSON.stringify(colors);
    const darkString = JSON.stringify(darkColors);
    const themeObj = {
        light: lightString,
        ...darkString ? {
            dark: darkString
        } : {}
    };
    // Convert to JSON string
    const themeJson = JSON.stringify(themeObj);
    // Convert JSON string → Base64
    const themeBase64 = btoa(themeJson);
    const addPurpose = ()=>{
        setPurposeItems([
            ...purposeItems,
            counter
        ]);
        setCounter(counter + 1);
        setPurposes([
            ...purposes,
            {
                purposeIds: [],
                isMandatory: "",
                autoRenew: "",
                preferenceValidity: {
                    value: "1",
                    unit: ""
                },
                purposeActivityIds: [],
                usedBy: [],
                dataItems: []
            }
        ]);
    };
    const removePurpose = (id, index)=>{
        if (purposeItems.length === 1) return;
        setPurposeItems(purposeItems.filter((item)=>item !== id));
        setPurposes(purposes.filter((_, i)=>i !== index));
    };
    const handleBack = ()=>{
        navigate("/requests");
    };
    const buildPayload = (purposes)=>{
        return purposes.map((p)=>({
                purposeIds: p.purposeIds,
                mandatory: p.isMandatory === "Required",
                autoRenew: p.autoRenew === "Yes",
                preferenceValidity: p.preferenceValidity,
                processorActivityIds: p.purposeActivityIds,
                preferenceStatus: "ACCEPTED"
            }));
    };
    const openCertificate = (certificatePreviewUrl)=>{
        if (certificatePreviewUrl) window.open(certificatePreviewUrl, "_blank");
    };
    const [finalPayload, setFinalPayload] = (0, $acw62.useState)([]);
    const handlePublish = async ()=>{
        const errors = [];
        if (!grievanceTitle.trim()) errors.push("Please enter Title.");
        if (!grievancePriority) errors.push("Please select Priority.");
        if (!initialComment.trim()) errors.push("Please enter Initial Comment.");
        // --- 1. Grievance Type ---
        if (!selectedGrievanceType) errors.push("Please select a Grievance Category.");
        // --- 2. Grievance Detail/Sub-category ---
        if (selectedGrievanceType && !selectedDetail) errors.push("Please select a Grievance Sub-Category.");
        // --- 3. Description ---
        if (grievanceFormTemplate?.multilingual?.descriptionCheck && !grievanceDesc.trim()) errors.push("Please enter Description.");
        // --- 4. User Type ---
        if (grievanceFormTemplate?.multilingual.userInformation[0]?.userType?.length > 0 && !selectedUserType) errors.push("Please select a User Type.");
        // --- 5. User Item inputs ---
        if (grievanceFormTemplate?.multilingual.userInformation[0]?.userItems?.length > 0) grievanceFormTemplate?.multilingual.userInformation[0].userItems.forEach((item)=>{
            if (!userDetailInputs[item] || userDetailInputs[item].trim() === "") errors.push(`Please enter ${item}.`);
        });
        // --- 6. Upload File ---
        if (grievanceFormTemplate?.multilingual.uploadFiles && !uploadFileName) errors.push("Please upload a supporting document.");
        // --- Show Toast if errors exist ---
        if (errors.length > 1) {
            (0, $b00d3e7401eac195$export$b410431fab84fa58).error((props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482ccd6e8e9b33b1$export$2e2bcd8739ae039), {
                    ...props,
                    type: "error",
                    message: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                        style: {
                            margin: 0
                        },
                        children: errors.map((err, idx)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                children: err
                            }, idx))
                    })
                }), {
                icon: false
            });
            return;
        } else if (errors.length === 1) {
            (0, $b00d3e7401eac195$export$b410431fab84fa58).error((props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482ccd6e8e9b33b1$export$2e2bcd8739ae039), {
                    ...props,
                    type: "error",
                    message: errors[0]
                }), {
                icon: false
            });
            return;
        } else {
            // Format grievance information (if needed for later use)
            const formattedGrievanceInformation = Object.entries(grievanceFormTemplate?.grievances || {}).map(([grievanceType, grievanceItems])=>({
                    grievanceType: grievanceType,
                    grievanceItems: grievanceItems
                }));
            // --- Build userDetails object ---
            const userDetails = grievanceFormTemplate?.multilingual?.userInformation?.[0]?.userItems?.reduce((acc, label)=>{
                // Normalize to uppercase and underscore format like backend expects
                // const key = label.toUpperCase().replace(/\s+/g, "_");
                const key = label;
                acc[key] = userDetailInputs[label] || "";
                return acc;
            }, {});
            // --- Final request body ---
            // --- Final request body ---
            const body = {
                title: grievanceTitle.trim(),
                priority: Number(grievancePriority),
                grievanceDescription: initialComment.trim(),
                grievanceType: selectedGrievanceType || "",
                grievanceSubcategory: selectedDetail || "",
                userDetails: userDetails || {},
                userType: selectedUserType || ""
            };
            console.log("BODY for create grievance", body);
            (0, $11492dca620dcaa5$exports.flushSync)(()=>{
                setIsSubmitting(true);
            });
            try {
                const res = await dispatch((0, $6eea01a75b53fee5$export$7dc761133dcd61bc)({
                    grievanceTemplateId: grievanceFormTemplate.grievanceTemplateId,
                    body: body,
                    attachmentFile: uploadFile || undefined
                }));
                if (res?.status === 201) {
                    (0, $b00d3e7401eac195$export$b410431fab84fa58).success((props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482ccd6e8e9b33b1$export$2e2bcd8739ae039), {
                            ...props,
                            type: "success",
                            message: "Grievance Request Raised Succesfully!"
                        }), {
                        icon: false
                    });
                    // Delay navigation so toast remains visible (ToastContainer unmounts on leave)
                    setTimeout(()=>{
                        navigate("/requests");
                    }, 2500);
                    return;
                }
                (0, $b00d3e7401eac195$export$b410431fab84fa58).success((props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482ccd6e8e9b33b1$export$2e2bcd8739ae039), {
                        ...props,
                        type: "success",
                        message: "Grievance Request Saved Succesfully!"
                    }), {
                    icon: false,
                    autoClose: 5000
                });
            } finally{
                setIsSubmitting(false);
            }
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("main", {
        className: "page-container create-request-route",
        role: "main",
        "aria-label": "Create Grievance Request",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "main-content",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "right-half",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("nav", {
                        className: "preview-header",
                        "aria-label": "Page navigation",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "header-left",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$353f5b6fc5456de1), {
                                        ariaControls: "navigation",
                                        ariaDescribedby: "back-button-desc",
                                        ariaLabel: "Go back to previous page",
                                        className: "Button create-request-back-btn",
                                        icon: "ic_back",
                                        iconAriaLabel: "Back arrow",
                                        iconLeft: "ic_back",
                                        kind: "secondary",
                                        onClick: handleBack,
                                        size: backButtonSizeSmall ? "small" : "medium",
                                        state: "normal"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        id: "back-button-desc",
                                        className: "sr-only",
                                        children: "Navigate to previous page"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "header-right",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "popup-mobile",
                                    style: {
                                        backgroundColor: activePopupColors.cardBackground,
                                        color: activePopupColors.cardFont,
                                        "--create-request-card-bg": activePopupColors.cardBackground,
                                        "--create-request-card-fg": activePopupColors.cardFont
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "popup-header",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "create-request-heading-wrap",
                                                    style: {
                                                        display: "flex",
                                                        flexDirection: "row",
                                                        gap: "20px",
                                                        alignItems: "flex-start"
                                                    },
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                                        className: "custom-head",
                                                        style: {
                                                            backgroundColor: activePopupColors.cardBackground,
                                                            color: activePopupColors.cardFont
                                                        },
                                                        children: title ? title : getTranslation("create_title", "Register your grievance")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    src: logoPreviewUrl,
                                                    alt: "Logo",
                                                    style: {
                                                        width: mobile ? "28px" : "40px",
                                                        height: mobile ? "28px" : "40px",
                                                        marginLeft: mobile ? "5px" : "10px"
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "popup-body",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "custom-text-p",
                                                    style: {
                                                        backgroundColor: activePopupColors.cardBackground,
                                                        color: activePopupColors.cardFont,
                                                        marginBottom: "8px",
                                                        fontSize: "14px",
                                                        letterSpacing: "-0.5px",
                                                        color: "rgba(0, 0, 0, 0.65)",
                                                        fontWeight: "500"
                                                    },
                                                    children: text ? text : getTranslation("create_description", "Please provide the following details to register your grievance.")
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "dropdown-group",
                                                    role: "group",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                            htmlFor: "grievance-title",
                                                            children: "Title"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                            id: "grievance-title",
                                                            type: "text",
                                                            placeholder: "Enter",
                                                            value: grievanceTitle,
                                                            onChange: (e)=>setGrievanceTitle(e.target.value),
                                                            "aria-label": "Title"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "dropdown-group",
                                                    role: "group",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                            htmlFor: "grievance-priority",
                                                            children: "Priority"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                            id: "grievance-priority",
                                                            value: grievancePriority,
                                                            onChange: (e)=>setGrievancePriority(e.target.value),
                                                            "aria-label": "Priority",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: "",
                                                                    disabled: true,
                                                                    children: "Select"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: "1",
                                                                    children: "1"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: "2",
                                                                    children: "2"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: "3",
                                                                    children: "3"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: "4",
                                                                    children: "4"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: "5",
                                                                    children: "5"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "dropdown-group",
                                                    role: "group",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                            htmlFor: "grievance-initial-comment",
                                                            children: "Initial Comment"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                                            id: "grievance-initial-comment",
                                                            placeholder: "Enter description of processor",
                                                            value: initialComment,
                                                            onChange: (e)=>setInitialComment(e.target.value),
                                                            rows: "3",
                                                            className: "custom-text-area",
                                                            "aria-label": "Initial Comment"
                                                        })
                                                    ]
                                                }),
                                                grievanceFormTemplate?.multilingual?.grievanceInformation?.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            style: {
                                                                marginBottom: "10px"
                                                            },
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                                appearance: "heading-xxs",
                                                                color: "primary-grey-80",
                                                                children: grievanceDetailsHeading
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "dropdown-group",
                                                            role: "group",
                                                            "aria-labelledby": "grievance-category-label",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                    id: "grievance-category-label",
                                                                    htmlFor: "grievance-category-select",
                                                                    children: grievanceCategoryLabel
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                                    id: "grievance-category-select",
                                                                    value: selectedGrievanceType,
                                                                    onChange: (e)=>{
                                                                        const newType = e.target.value;
                                                                        setSelectedGrievanceType(newType);
                                                                        setSelectedDetail("");
                                                                    },
                                                                    "aria-label": grievanceCategoryLabel,
                                                                    "aria-required": "true",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                            value: "",
                                                                            disabled: true,
                                                                            children: selectCategoryPlaceholder
                                                                        }),
                                                                        grievanceFormTemplate?.multilingual.grievanceInformation.map((info, idx)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                                value: info.grievanceType,
                                                                                children: getDynamicTranslation(info.grievanceType)
                                                                            }, idx))
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        selectedGrievanceType && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "dropdown-group",
                                                            role: "group",
                                                            "aria-labelledby": "grievance-subcategory-label",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                    id: "grievance-subcategory-label",
                                                                    htmlFor: "grievance-subcategory-select",
                                                                    children: grievanceSubCategoryLabel
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                                    id: "grievance-subcategory-select",
                                                                    value: selectedDetail,
                                                                    onChange: (e)=>setSelectedDetail(e.target.value),
                                                                    "aria-label": grievanceSubCategoryLabel,
                                                                    "aria-required": "true",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                            value: "",
                                                                            disabled: true,
                                                                            children: subCategoryPlaceholder
                                                                        }),
                                                                        (grievanceFormTemplate?.multilingual.grievanceInformation.find((info)=>info.grievanceType === selectedGrievanceType)?.grievanceItems || []).map((item, idx)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                                value: item,
                                                                                children: getDynamicTranslation(item)
                                                                            }, idx))
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                grievanceFormTemplate?.multilingual?.descriptionCheck && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "dropdown-group",
                                                    role: "group",
                                                    "aria-labelledby": "description-label",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                            id: "description-label",
                                                            htmlFor: "grievance-description",
                                                            children: descriptionLabel
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                                            id: "grievance-description",
                                                            placeholder: descriptionPlaceholder,
                                                            value: grievanceDesc,
                                                            onChange: handleTextAreaChange,
                                                            rows: "3",
                                                            className: "custom-text-area",
                                                            "aria-label": descriptionLabel,
                                                            "aria-required": "true",
                                                            "aria-describedby": "description-hint"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            id: "description-hint",
                                                            className: "sr-only",
                                                            children: descriptionPlaceholder
                                                        })
                                                    ]
                                                }),
                                                (grievanceFormTemplate?.multilingual?.userInformation[0]?.userType?.length > 0 || grievanceFormTemplate?.multilingual?.userInformation[0]?.userItems?.length > 0) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                    appearance: "heading-xxs",
                                                    color: "primary-grey-80",
                                                    children: userDetailsHeading
                                                }),
                                                grievanceFormTemplate?.multilingual?.userInformation[0]?.userType && grievanceFormTemplate?.multilingual?.userInformation[0]?.userType.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "dropdown-group",
                                                    style: {
                                                        marginBottom: "0px"
                                                    },
                                                    role: "group",
                                                    "aria-labelledby": "user-type-label",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                            id: "user-type-label",
                                                            htmlFor: "user-type-select",
                                                            children: userTypeLabel
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                            id: "user-type-select",
                                                            value: selectedUserType,
                                                            onChange: (e)=>setSelectedUserType(e.target.value),
                                                            "aria-label": userTypeLabel,
                                                            "aria-required": "true",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: "",
                                                                    disabled: true,
                                                                    children: userTypePlaceholder
                                                                }),
                                                                grievanceFormTemplate?.multilingual?.userInformation[0]?.userType.map((type, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                        value: type,
                                                                        children: getDynamicTranslation(type)
                                                                    }, index))
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                grievanceFormTemplate?.multilingual?.userInformation?.[0]?.userItems?.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    role: "group",
                                                    "aria-label": "User Details Form Fields",
                                                    children: grievanceFormTemplate?.multilingual?.userInformation[0]?.userItems.map((detailName, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            style: {
                                                                padding: "10px 0px"
                                                            },
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "systemConfig-input",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                        id: `user-field-label-${index}`,
                                                                        htmlFor: `user-field-input-${index}`,
                                                                        style: {
                                                                            display: "block",
                                                                            fontSize: "13px",
                                                                            fontWeight: "600",
                                                                            fontFamily: "Arial, sans-serif",
                                                                            marginBottom: "5px",
                                                                            color: "#767676"
                                                                        },
                                                                        children: `${getDynamicTranslation(detailName)} (${requiredLable})`
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                        id: `user-field-input-${index}`,
                                                                        type: "text",
                                                                        value: userDetailInputs[detailName] || "",
                                                                        onChange: (e)=>setUserDetailInputs({
                                                                                ...userDetailInputs,
                                                                                [detailName]: e.target.value
                                                                            }),
                                                                        placeholder: `${enterLable} ${getDynamicTranslation(detailName).toLowerCase()}`,
                                                                        "aria-label": getDynamicTranslation(detailName),
                                                                        "aria-required": "true",
                                                                        "aria-labelledby": `user-field-label-${index}`,
                                                                        style: {
                                                                            width: "100%",
                                                                            padding: "10px 12px",
                                                                            border: "1px solid #ccc",
                                                                            borderRadius: "8px",
                                                                            fontSize: "14px",
                                                                            fontWeight: 400,
                                                                            color: "rgba(20, 20, 20, 1)",
                                                                            outline: "none",
                                                                            fontFamily: "Arial, sans-serif"
                                                                        }
                                                                    })
                                                                ]
                                                            })
                                                        }, index))
                                                }),
                                                grievanceFormTemplate?.multilingual?.uploadFiles && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    role: "group",
                                                    "aria-labelledby": "upload-section-label",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                                id: "upload-section-label",
                                                                appearance: "heading-xxs",
                                                                color: "primary-grey-80",
                                                                children: uploadFilesHeading
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            style: {
                                                                marginBottom: "20px"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    className: "fileUploader-custom1",
                                                                    onClick: handleUploadFilesClick,
                                                                    onDragOver: handleUploadFilesDragOver,
                                                                    onDragLeave: handleUploadFilesDragLeave,
                                                                    onDrop: handleUploadFilesDrop,
                                                                    role: "button",
                                                                    tabIndex: 0,
                                                                    "aria-label": `${uploadButtonText}. ${uploadInstruction}`,
                                                                    onKeyDown: (e)=>{
                                                                        if (e.key === "Enter" || e.key === " ") {
                                                                            e.preventDefault();
                                                                            handleUploadFilesClick();
                                                                        }
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                            type: "file",
                                                                            ref: uploadFileInputRef,
                                                                            style: {
                                                                                display: "none"
                                                                            },
                                                                            onChange: handleUploadFilieChange,
                                                                            accept: ".pdf,.doc,.docx",
                                                                            "aria-label": "Upload file"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                            className: "upload-content",
                                                                            "aria-hidden": "true",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$f04a61298a47a40f), {
                                                                                    ic: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $170225ee6a03579c$export$7a525547346e73a), {
                                                                                        height: 23,
                                                                                        width: 23
                                                                                    }),
                                                                                    color: "primary_60"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                                                    appearance: "button",
                                                                                    color: "primary-60",
                                                                                    children: uploadButtonText
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                    id: "upload-instruction",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                                        appearance: "body-xs",
                                                                        color: "primary-grey-80",
                                                                        children: uploadInstruction
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                uploadFileName && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "systemConfiguration-file-uploader",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            onClick: handlePreviewUploadFile,
                                                            className: "previewFile",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "iconandText",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$f04a61298a47a40f), {
                                                                        ic: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5a00847d48e39b4f$export$13b8539f4be0c), {
                                                                            width: 15,
                                                                            height: 15
                                                                        }),
                                                                        color: "feedback_success_50"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                                        appearance: "body-xs",
                                                                        color: "primary-grey-80",
                                                                        children: uploadFileName
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$f04a61298a47a40f), {
                                                            ic: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4b407a2b367f43e3$export$48672c81f0c3f574), {
                                                                width: 15,
                                                                height: 15
                                                            }),
                                                            color: "primary_60",
                                                            className: "selecetd-file-display",
                                                            onClick: handleRemoveUploadFile
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: `popup-button ${mobile ? "popup-button-mobile" : ""}`,
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {},
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$cfc7921d29ef7b80), {
                                                    kind: "primary",
                                                    size: "medium",
                                                    state: "normal",
                                                    label: getTranslation("create_submit_request", "Submit Request"),
                                                    onClick: handlePublish
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b00d3e7401eac195$export$f2815235e76a62b9), {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                closeButton: false,
                toastClassName: ()=>"toast-wrapper",
                transition: (0, $b00d3e7401eac195$export$d8dc01b5c85a37b9)
            }),
            isSubmitting && /*#__PURE__*/ (0, $11492dca620dcaa5$exports.createPortal)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "overlay",
                "aria-busy": "true",
                "aria-live": "polite",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "loader"
                })
            }), document.body)
        ]
    });
};
var $106ac01a8584f523$export$2e2bcd8739ae039 = $106ac01a8584f523$var$CreateRequest;




var $acw62 = parcelRequire("acw62");















const $f71dd81b43a79c0d$var$RequestDetails = ()=>{
    const DEFAULT_DETAILS = {
        "User access": [
            "Submit request",
            "Access data",
            "Erase data"
        ],
        Legal: [
            "Raise issue",
            "Add data",
            "File complaint"
        ]
    };
    const logos = new URL($0ce165fce4857ef1$exports).href;
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const { grievanceId: grievanceId } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const [isChecked, setIsChecked] = (0, $acw62.useState)(false);
    const [templateName, setTemplateName] = (0, $acw62.useState)("");
    const [dark, setDark] = (0, $acw62.useState)(false);
    const [backButtonSizeSmall, setBackButtonSizeSmall] = (0, $acw62.useState)(()=>typeof window !== "undefined" ? window.matchMedia("(max-width: 767px)").matches : false);
    const [view, setView] = (0, $acw62.useState)("popup");
    const [title, setTitle] = (0, $acw62.useState)("Register your grievance");
    const [cid, setCid] = (0, $acw62.useState)("Customer ID");
    const [age, setAge] = (0, $acw62.useState)("I'm below 18 years of age.");
    const [purposeHeading, setPurposeHeading] = (0, $acw62.useState)("Purpose: ");
    const [processingHeading, setProcessingHeading] = (0, $acw62.useState)("Processing activity: ");
    const [usedByHeading, setUsedByHeading] = (0, $acw62.useState)("Used By: ");
    const [durationHeading, setDurationHeading] = (0, $acw62.useState)("Duration: ");
    const [dataItemHeading, setDataItemHeading] = (0, $acw62.useState)("Data item: ");
    const [selectedGrievanceType, setSelectedGrievanceType] = (0, $acw62.useState)("");
    const [grievanceTitle, setGrievanceTitle] = (0, $acw62.useState)("");
    const [grievancePriority, setGrievancePriority] = (0, $acw62.useState)("");
    const [initialComment, setInitialComment] = (0, $acw62.useState)("");
    const [selectedDetail, setSelectedDetail] = (0, $acw62.useState)("");
    const [isViewMode, setIsViewMode] = (0, $acw62.useState)(false);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(true);
    const [grievanceFormTemplate, setGrievanceFormTemplate] = (0, $acw62.useState)({});
    const [dynamicTranslations, setDynamicTranslations] = (0, $acw62.useState)({});
    // Helper to get dynamic translation
    const getDynamicTranslation = (text)=>{
        if (!text || currentLanguage === "ENGLISH") return text;
        return dynamicTranslations[text] || text;
    };
    // Translation inputs for static text
    const translationInputs = (0, $acw62.useMemo)(()=>[
            {
                id: "details_title",
                source: "Register your grievance"
            },
            {
                id: "details_description_text",
                source: "Please provide the following details to register your grievance."
            },
            {
                id: "details_purpose",
                source: "Purpose: "
            },
            {
                id: "details_processing",
                source: "Processing activity: "
            },
            {
                id: "details_used_by",
                source: "Used By: "
            },
            {
                id: "details_duration",
                source: "Duration: "
            },
            {
                id: "details_data_item",
                source: "Data item: "
            },
            {
                id: "details_grievance_details",
                source: "Grievance Details"
            },
            {
                id: "details_select_category",
                source: "Select Category"
            },
            {
                id: "details_grievance_category",
                source: "Grievance Category"
            },
            {
                id: "details_grievance_subcategory",
                source: "Grievance Subcategory"
            },
            {
                id: "details_enter_subcategory",
                source: "Enter Grievance Subcategory"
            },
            {
                id: "details_description",
                source: "Description (Required)"
            },
            {
                id: "details_description_placeholder",
                source: "Enter description of the group's function or scope."
            },
            {
                id: "details_user_details",
                source: "User Details"
            },
            {
                id: "details_user_type",
                source: "User Type"
            },
            {
                id: "details_select_user_type",
                source: "Select user type"
            },
            {
                id: "details_upload_files",
                source: "Upload Files"
            },
            {
                id: "details_upload",
                source: "Upload"
            },
            {
                id: "details_upload_instruction",
                source: "Drag and drop or upload a document with hyperlink with the consent banner in .pdf or .doc format."
            },
            {
                id: "details_required",
                source: "Required"
            },
            {
                id: "details_enter",
                source: "Enter"
            },
            {
                id: "details_submit_request",
                source: "Submit Request"
            },
            {
                id: "details_always_active",
                source: "Always Active"
            }
        ], []);
    // Use translation hook
    const { getTranslation: getTranslation, translateContent: translateContent, currentLanguage: currentLanguage, isTranslating: isTranslating } = (0, $dbe8cedc9e1aa4ce$export$2e2bcd8739ae039)(translationInputs);
    // Function to translate form field values
    const translateFormFields = async (template, targetLang)=>{
        if (!template || targetLang === "en") {
            setDynamicTranslations({});
            return;
        }
        const uniqueTexts = new Set();
        // Collect grievance types and subcategories
        template.multilingual?.grievanceInformation?.forEach((info)=>{
            if (info.grievanceType) uniqueTexts.add(info.grievanceType);
            info.grievanceSubCategory?.forEach((sub)=>uniqueTexts.add(sub));
            // Also collect grievanceItems (used in dropdown)
            info.grievanceItems?.forEach((item)=>uniqueTexts.add(item));
        });
        // Collect user types and field names
        template.multilingual?.userInformation?.forEach((info)=>{
            info.userType?.forEach((type)=>uniqueTexts.add(type));
            // Collect field names from userItems
            info.userItems?.forEach((item)=>uniqueTexts.add(item));
            // Also collect from userDetails if exists
            info.userDetails?.forEach((detail)=>{
                if (detail.detailName) uniqueTexts.add(detail.detailName);
            });
        });
        if (uniqueTexts.size === 0) return;
        const inputs = Array.from(uniqueTexts).map((text, idx)=>({
                id: `form_${idx}`,
                source: text
            }));
        try {
            const response = await dispatch((0, $6eea01a75b53fee5$export$7d0f208153a27d67)("en", targetLang, inputs));
            if (response?.status === 200 && response?.data?.output) {
                const translatedMap = {};
                response.data.output.forEach((item, idx)=>{
                    translatedMap[inputs[idx].source] = item.target;
                });
                setDynamicTranslations(translatedMap);
            }
        } catch (error) {
            console.log("Error translating form fields:", error);
        }
    };
    // Translate content when language changes
    (0, $acw62.useEffect)(()=>{
        if (currentLanguage !== "ENGLISH") {
            translateContent(translationInputs, currentLanguage);
            if (grievanceFormTemplate && Object.keys(grievanceFormTemplate).length > 0) {
                const targetLang = (0, $dbe8cedc9e1aa4ce$export$d340805709eeec9f)(currentLanguage);
                translateFormFields(grievanceFormTemplate, targetLang);
            }
        } else setDynamicTranslations({});
    }, [
        currentLanguage,
        translationInputs,
        translateContent,
        grievanceFormTemplate
    ]);
    (0, $acw62.useEffect)(()=>{
        const mq = window.matchMedia("(max-width: 767px)");
        const syncBackButtonSize = ()=>setBackButtonSizeSmall(mq.matches);
        syncBackButtonSize();
        mq.addEventListener("change", syncBackButtonSize);
        return ()=>mq.removeEventListener("change", syncBackButtonSize);
    }, []);
    (0, $acw62.useEffect)(()=>{
        const fetchData = async ()=>{
            setIsLoading(true);
            try {
                const templateRes = await dispatch((0, $6eea01a75b53fee5$export$6a9543e1c857ef52)());
                if (templateRes.status === 200) {
                    const data = templateRes.data;
                    setGrievanceFormTemplate(data);
                    // --- Handle multilingual title/text ---
                    const supportedLanguages = data?.multilingual?.supportedLanguages;
                    const selectedLanguage = supportedLanguages?.[0];
                    let title = "";
                    let text = "";
                    if (selectedLanguage && data?.languages) {
                        const matchingLanguageEntry = Object.values(data.languages).find((lang)=>lang.language?.toUpperCase() === selectedLanguage.toUpperCase() || lang.heading?.toUpperCase()?.includes(selectedLanguage.toUpperCase()));
                        if (matchingLanguageEntry) {
                            title = matchingLanguageEntry.heading || "";
                            text = matchingLanguageEntry.description || "";
                        }
                    }
                    setTitle(title);
                    setText(text);
                    setLogoPreviewUrl(data?.uiConfig.logo || logos);
                }
                if (grievanceId) {
                    const grievanceRes = await dispatch((0, $6eea01a75b53fee5$export$51695d7c85207ef7)(grievanceId));
                    if (grievanceRes.status === 200) {
                        const grievanceData = grievanceRes.data;
                        // --- Prefill base fields ---
                        setSelectedGrievanceType(grievanceData.grievanceType || "");
                        setGrievanceTitle(grievanceData.title || "");
                        setGrievancePriority(grievanceData.priority || "");
                        setSelectedDetail(grievanceData.grievanceSubCategory || "");
                        setSelectedUserType(grievanceData.userType || "");
                        setGrievanceDesc(grievanceData.grievanceDescription || "");
                        // --- Prefill user details ---
                        const filledInputs = {
                            ...userDetailInputs
                        };
                        const userItems = templateRes.data?.multilingual?.userInformation?.[0]?.userItems || [];
                        userItems.forEach((label)=>{
                            const normalizedLabel = label.toUpperCase().replace(/[^A-Z0-9]/g, "");
                            const matchedKey = Object.keys(grievanceData.userDetails || {}).find((key)=>key.toUpperCase().replace(/[^A-Z0-9]/g, "") === normalizedLabel);
                            if (matchedKey) filledInputs[label] = grievanceData.userDetails[matchedKey];
                        });
                        setUserDetailInputs(filledInputs);
                        // --- Handle uploaded documents ---
                        if (grievanceData.attachments?.length > 0) {
                            const doc = grievanceData.attachments[0];
                            setUploadFileName(doc.fileName || "");
                            setUploadFileBase64(doc.documentId || "");
                            setUploadFilePreviewUrl(doc.url || "");
                        }
                        setIsViewMode(true);
                    }
                }
            } catch (err) {
                console.log("Error fetching data:", err);
                if (err?.[0]?.errorCode === "JCMP3001") setConsentsByTempId([]);
            } finally{
                setIsLoading(false);
            }
        };
        fetchData();
    }, [
        grievanceId
    ]);
    const [grievanceDesc, setGrievanceDesc] = (0, $acw62.useState)("");
    // for upload component
    const uploadFileInputRef = (0, $acw62.useRef)(null);
    const [uploadFileName, setUploadFileName] = (0, $acw62.useState)("");
    const [uploadFileBase64, setUploadFileBase64] = (0, $acw62.useState)("");
    const [upoladFilePreviewUrl, setUploadFilePreviewUrl] = (0, $acw62.useState)("");
    const [selectedUserType, setSelectedUserType] = (0, $acw62.useState)("");
    const [userDetailInputs, setUserDetailInputs] = (0, $acw62.useState)({});
    // Get translated labels from hook
    const grievanceDetailsHeading = getTranslation("details_grievance_details", "Grievance Details");
    const selectCategoryPlaceholder = getTranslation("details_select_category", "Select Category");
    const grievanceCategoryLabel = getTranslation("details_grievance_category", "Grievance Category");
    const grievanceSubCategoryLabel = getTranslation("details_grievance_subcategory", "Grievance Subcategory");
    const subCategoryPlaceholder = getTranslation("details_enter_subcategory", "Enter Grievance Subcategory");
    const descriptionLabel = getTranslation("details_description", "Description (Required)");
    const descriptionPlaceholder = getTranslation("details_description_placeholder", "Enter description of the group's function or scope.");
    const userDetailsHeading = getTranslation("details_user_details", "User Details");
    const userTypeLabel = getTranslation("details_user_type", "User Type");
    const userTypePlaceholder = getTranslation("details_select_user_type", "Select user type");
    const uploadFilesHeading = getTranslation("details_upload_files", "Upload Files");
    const uploadButtonText = getTranslation("details_upload", "Upload");
    const uploadInstruction = getTranslation("details_upload_instruction", "Drag and drop or upload a document with hyperlink with the consent banner in .pdf or .doc format.");
    const requiredLable = getTranslation("details_required", "Required");
    const enterLable = getTranslation("details_enter", "Enter");
    const handleDetailSelect = (e)=>{
        setSelectedDetail(e.target.value);
    };
    const handleTextAreaChange = (e)=>{
        setGrievanceDesc(e.target.value);
    };
    const toTitleCase = (str)=>{
        return str.toLowerCase().replace(/\b\w/g, (char)=>char.toUpperCase());
    };
    const [purposes, setPurposes] = (0, $acw62.useState)([
        {
            purposeIds: [],
            purposeNames: [],
            isMandatory: "",
            autoRenew: "",
            preferenceValidity: {
                value: 1,
                unit: ""
            },
            purposeActivityIds: [],
            usedBy: [],
            dataItems: [],
            processingAct: []
        }
    ]);
    // upoad component
    const handleUploadFilesClick = ()=>{
        uploadFileInputRef.current?.click();
    };
    const handleUploadFilesDragOver = (e)=>{
        e.preventDefault();
        e.stopPropagation();
    };
    const handleUploadFilesDragLeave = (e)=>{
        e.preventDefault();
        e.stopPropagation();
    };
    const handleUploadFilesDrop = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        const file = e.dataTransfer.files[0];
        if (file) processUploadFile(file);
    };
    const handleUploadFilieChange = (e)=>{
        const file = e.target.files[0];
        if (file) processUploadFile(file);
    };
    const processUploadFile = (file)=>{
        setUploadFileName(file.name);
        const reader = new FileReader();
        reader.onloadend = ()=>{
            const base64String = reader.result.split(",")[1];
            setUploadFileBase64(base64String);
            setUploadFilePreviewUrl(reader.result);
        };
        reader.readAsDataURL(file);
    };
    const handleRemoveUploadFile = ()=>{
        setUploadFileName("");
        setUploadFileBase64("");
        setUploadFilePreviewUrl("");
        if (uploadFileInputRef.current) uploadFileInputRef.current.value = "";
    };
    const handlePreviewUploadFile = ()=>{
        if (upoladFilePreviewUrl) {
            window.open(upoladFilePreviewUrl, "_blank", "noopener,noreferrer");
            return;
        }
        (0, $b00d3e7401eac195$export$b410431fab84fa58).error((props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482ccd6e8e9b33b1$export$2e2bcd8739ae039), {
                ...props,
                type: "error",
                message: "You cannot view this file"
            }), {
            icon: false
        });
    };
    //language container states
    const AccordionItem = ({ title: title, alwaysActive: alwaysActive, hasCheckbox: hasCheckbox, items: items })=>{
        const [isOpen, setIsOpen] = (0, $acw62.useState)(true);
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "accordion-item",
            style: {
                backgroundColor: activePopupColors.cardBackground,
                color: activePopupColors.cardFont
            },
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "accordion-header",
                    onClick: ()=>setIsOpen(!isOpen),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "accordion-left",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: `accordion-icon ${isOpen ? "open" : ""}`,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fdc94045ec0e5793$export$ec7db1c418c1ec5a), {
                                        height: 25,
                                        width: 25
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "accordion-title",
                                    children: title
                                })
                            ]
                        }),
                        alwaysActive && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "accordion-label",
                            children: getTranslation("details_always_active", "Always Active")
                        }),
                        hasCheckbox && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "checkbox"
                        })
                    ]
                }),
                isOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "accordion-content",
                    style: {
                        backgroundColor: activePopupColors.cardBackground,
                        color: activePopupColors.cardFont
                    },
                    children: items.map((item, idx)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "accordion-block",
                            children: [
                                item.purposeNames?.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: purposeHeading
                                        }),
                                        " ",
                                        item.purposeNames.join(", ")
                                    ]
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: purposeHeading
                                        }),
                                        " Not provided"
                                    ]
                                }),
                                validitytoBeShown && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: durationHeading
                                        }),
                                        " ",
                                        item.preferenceValidity?.value ? `${item.preferenceValidity.value} ${toTitleCase(item.preferenceValidity.value === 1 ? item.preferenceValidity.unit.replace(/s$/i, "") // singular
                                         : item.preferenceValidity.unit)}` : "N/A"
                                    ]
                                }),
                                item.usedBy?.length > 0 && processorNameToBeShown && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: usedByHeading
                                        }),
                                        " ",
                                        item.usedBy.join(", ")
                                    ]
                                }),
                                processActivityNameToBeShown && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: processingHeading
                                        }),
                                        " ",
                                        item.processingAct?.join(", ")
                                    ]
                                }),
                                dataItemToBeShown && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: dataItemHeading
                                        }),
                                        " ",
                                        item.dataItems?.join(", ")
                                    ]
                                }),
                                idx !== items.length - 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                                    className: "accordion-separator"
                                })
                            ]
                        }, idx))
                })
            ]
        });
    };
    const [text, setText] = (0, $acw62.useState)("While using JioMeet, your activities create data which will be used with your consent to offer customised services. Details of data usage are provided below. ");
    //purpose container states
    const [purposeItems, setPurposeItems] = (0, $acw62.useState)([
        0
    ]);
    const [counter, setCounter] = (0, $acw62.useState)(1);
    const [logoPreviewUrl, setLogoPreviewUrl] = (0, $acw62.useState)("");
    const [darkMode, setDarkMode] = (0, $acw62.useState)(false);
    const [processActivityNameToBeShown, setProcessActivityNameToBeShown] = (0, $acw62.useState)(true);
    const [processorNameToBeShown, setProcessorNameToBeShown] = (0, $acw62.useState)(true);
    const [validitytoBeShown, setValiditytoBeShown] = (0, $acw62.useState)(true);
    const [colors, setColors] = (0, $acw62.useState)({
        cardBackground: "#FFFFFF",
        cardFont: "#000000",
        buttonBackground: "#0F3CC9",
        buttonFont: "#FFFFFF",
        linkFont: "#0A2885"
    });
    const [darkColors, setDarkColors] = (0, $acw62.useState)({
        cardBackground: "#000000",
        cardFont: "#FFFFFF",
        buttonBackground: "#FFFFFF",
        buttonFont: "#0F3CC9",
        linkFont: "#0A2885"
    });
    const activePopupColors = darkMode ? darkColors : colors;
    const [languageContent, setLanguageContent] = (0, $acw62.useState)({
        ENGLISH: {
            description: "sample description",
            label: "Required",
            rightsText: "sample rights text",
            permissionText: "sample permission text"
        }
    });
    const lightString = JSON.stringify(colors);
    const darkString = JSON.stringify(darkColors);
    const handleBack = ()=>{
        navigate("/requests");
    };
    const handlePublish = async ()=>{
        const errors = [];
        // --- 1. Grievance Type ---
        if (!selectedGrievanceType) errors.push("Please select a Grievance Category.");
        // --- 2. Grievance Detail/Sub-category ---
        if (selectedGrievanceType && !selectedDetail) errors.push("Please select a Grievance Sub-Category.");
        // --- 3. Description ---
        if (grievanceFormTemplate.multilingual.descriptionCheck && !grievanceDesc.trim()) errors.push("Please enter Description.");
        // --- 4. User Type ---
        if (grievanceFormTemplate.multilingual.userInformation[0]?.userType?.length > 0 && !selectedUserType) errors.push("Please select a User Type.");
        // --- 5. User Item inputs ---
        if (grievanceFormTemplate.multilingual.userInformation[0]?.userItems?.length > 0) grievanceFormTemplate.multilingual.userInformation[0].userItems.forEach((item)=>{
            if (!userDetailInputs[item] || userDetailInputs[item].trim() === "") errors.push(`Please enter ${item}.`);
        });
        // --- 6. Upload File ---
        if (grievanceFormTemplate.multilingual.uploadFiles && !uploadFileName) errors.push("Please upload a supporting document.");
        // --- Show Toast if errors exist ---
        if (errors.length > 1) {
            (0, $b00d3e7401eac195$export$b410431fab84fa58).error((props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482ccd6e8e9b33b1$export$2e2bcd8739ae039), {
                    ...props,
                    type: "error",
                    message: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                        style: {
                            margin: 0
                        },
                        children: errors.map((err, idx)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                children: err
                            }, idx))
                    })
                }), {
                icon: false
            });
            return;
        } else if (errors.length === 1) {
            (0, $b00d3e7401eac195$export$b410431fab84fa58).error((props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482ccd6e8e9b33b1$export$2e2bcd8739ae039), {
                    ...props,
                    type: "error",
                    message: errors[0]
                }), {
                icon: false
            });
            return;
        } else {
            const formattedGrievanceInformation = Object.entries(grievanceFormTemplate?.grievances || {}).map(([grievanceType, grievanceItems])=>({
                    grievanceType: grievanceType,
                    grievanceItems: grievanceItems
                }));
            const userDetails = grievanceFormTemplate.multilingual.userInformation[0].userItems.reduce((acc, label)=>{
                const key = label.toLowerCase().replace(/\s+/g, "_");
                acc[key] = userDetailInputs[label] || "";
                return acc;
            }, {});
            // request body
            const requestBody = {
                grievanceRelatedTo: selectedGrievanceType,
                grievanceRaisedBy: selectedUserType,
                grievanceDescription: grievanceDesc,
                ...userDetails,
                supportingDocs: uploadFileName ? [
                    {
                        docName: uploadFileName,
                        doc: uploadFileBase64
                    }
                ] : []
            };
            const res = await (0, $6eea01a75b53fee5$export$7dc761133dcd61bc)(requestBody);
            if (res.status === 201) (0, $b00d3e7401eac195$export$b410431fab84fa58).success((props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482ccd6e8e9b33b1$export$2e2bcd8739ae039), {
                    ...props,
                    type: "success",
                    message: "Form Template Published successfully."
                }), {
                icon: false
            });
            (0, $b00d3e7401eac195$export$b410431fab84fa58).success((props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482ccd6e8e9b33b1$export$2e2bcd8739ae039), {
                    ...props,
                    type: "success",
                    message: "Grievance Request Raised Succesfully!"
                }), {
                icon: false
            });
        // navigate("/grievanceFormTemplates");
        }
    };
    const [activeTab, setActiveTab] = (0, $acw62.useState)("popup");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("main", {
        className: "page-container create-request-route",
        role: "main",
        "aria-label": "Grievance request details",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "main-content",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "right-half",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("nav", {
                        className: "preview-header",
                        "aria-label": "Page navigation",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "header-left",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$353f5b6fc5456de1), {
                                        ariaControls: "navigation",
                                        ariaDescribedby: "request-details-back-desc",
                                        ariaLabel: "Go back to previous page",
                                        className: "Button create-request-back-btn",
                                        icon: "ic_back",
                                        iconAriaLabel: "Back arrow",
                                        iconLeft: "ic_back",
                                        kind: "secondary",
                                        onClick: handleBack,
                                        size: backButtonSizeSmall ? "small" : "medium",
                                        state: "normal"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        id: "request-details-back-desc",
                                        className: "sr-only",
                                        children: "Navigate to previous page"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "header-right",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "popup-mobile",
                                    style: {
                                        backgroundColor: activePopupColors.cardBackground,
                                        color: activePopupColors.cardFont,
                                        "--create-request-card-bg": activePopupColors.cardBackground,
                                        "--create-request-card-fg": activePopupColors.cardFont
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "popup-header",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "create-request-heading-wrap",
                                                    style: {
                                                        display: "flex",
                                                        flexDirection: "row",
                                                        gap: "20px",
                                                        alignItems: "flex-start"
                                                    },
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                                        className: "custom-head",
                                                        style: {
                                                            backgroundColor: activePopupColors.cardBackground,
                                                            color: activePopupColors.cardFont
                                                        },
                                                        children: title ? title : getTranslation("details_title", "Register your grievance")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    src: logoPreviewUrl,
                                                    alt: "Logo",
                                                    style: {
                                                        width: backButtonSizeSmall ? "28px" : "40px",
                                                        height: backButtonSizeSmall ? "28px" : "40px",
                                                        marginLeft: backButtonSizeSmall ? "5px" : "10px"
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "popup-body",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "custom-text-p",
                                                    style: {
                                                        backgroundColor: activePopupColors.cardBackground,
                                                        color: activePopupColors.cardFont,
                                                        marginBottom: "8px",
                                                        fontSize: "14px",
                                                        letterSpacing: "-0.5px",
                                                        color: "rgba(0, 0, 0, 0.65)",
                                                        fontWeight: "500"
                                                    },
                                                    children: text ? text : getTranslation("details_description_text", "Please provide the following details to register your grievance.")
                                                }),
                                                grievanceFormTemplate?.multilingual?.grievanceInformation?.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "dropdown-group",
                                                            role: "group",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                    htmlFor: "grievance-title",
                                                                    children: "Title"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                    id: "grievance-title",
                                                                    type: "text",
                                                                    placeholder: "Enter",
                                                                    value: grievanceTitle,
                                                                    // onChange={(e) => setGrievanceTitle(e.target.value)}
                                                                    "aria-label": "Title"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "dropdown-group",
                                                            role: "group",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                    htmlFor: "grievance-priority",
                                                                    children: "Priority"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                                    id: "grievance-priority",
                                                                    value: grievancePriority,
                                                                    // onChange={(e) => setGrievancePriority(e.target.value)}
                                                                    "aria-label": "Priority",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                            value: "",
                                                                            disabled: true,
                                                                            children: "Select"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                            value: "1",
                                                                            children: "1"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                            value: "2",
                                                                            children: "2"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                            value: "3",
                                                                            children: "3"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                            value: "4",
                                                                            children: "4"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                            value: "5",
                                                                            children: "5"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "dropdown-group",
                                                            role: "group",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                    htmlFor: "grievance-initial-comment",
                                                                    children: "Initial Comment"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                                                    id: "grievance-initial-comment",
                                                                    placeholder: "Enter description of processor",
                                                                    value: initialComment,
                                                                    // onChange={(e) => setInitialComment(e.target.value)}
                                                                    rows: "3",
                                                                    className: "custom-text-area",
                                                                    "aria-label": "Initial Comment"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            style: {
                                                                marginBottom: "10px"
                                                            },
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                                appearance: "heading-xxs",
                                                                color: "primary-grey-80",
                                                                children: grievanceDetailsHeading
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "dropdown-group",
                                                            role: "group",
                                                            "aria-labelledby": "details-category-label",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                    id: "details-category-label",
                                                                    htmlFor: "details-category-select",
                                                                    children: grievanceCategoryLabel
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                                    id: "details-category-select",
                                                                    disabled: isViewMode,
                                                                    value: selectedGrievanceType,
                                                                    onChange: (e)=>{
                                                                        const newType = e.target.value;
                                                                        setSelectedGrievanceType(newType);
                                                                        setSelectedDetail("");
                                                                    },
                                                                    "aria-label": grievanceCategoryLabel,
                                                                    "aria-required": "true",
                                                                    "aria-disabled": isViewMode,
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                            value: "",
                                                                            disabled: true,
                                                                            children: selectCategoryPlaceholder
                                                                        }),
                                                                        grievanceFormTemplate.multilingual.grievanceInformation.map((info, idx)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                                value: info.grievanceType,
                                                                                children: getDynamicTranslation(info.grievanceType)
                                                                            }, idx))
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        selectedGrievanceType && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "dropdown-group",
                                                            role: "group",
                                                            "aria-labelledby": "details-subcategory-label",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                    id: "details-subcategory-label",
                                                                    htmlFor: "details-subcategory-select",
                                                                    children: grievanceSubCategoryLabel
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                                    id: "details-subcategory-select",
                                                                    value: selectedDetail,
                                                                    disabled: isViewMode,
                                                                    "aria-label": grievanceSubCategoryLabel,
                                                                    "aria-required": "true",
                                                                    "aria-disabled": isViewMode,
                                                                    style: {
                                                                        pointerEvents: isViewMode ? "none" : "auto",
                                                                        color: "#333"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                            value: "",
                                                                            disabled: true,
                                                                            children: subCategoryPlaceholder
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                            value: selectedDetail,
                                                                            children: getDynamicTranslation(selectedDetail)
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                grievanceFormTemplate?.multilingual?.descriptionCheck && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "dropdown-group",
                                                    role: "group",
                                                    "aria-labelledby": "details-description-label",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                            id: "details-description-label",
                                                            htmlFor: "details-description",
                                                            children: descriptionLabel
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                                            id: "details-description",
                                                            disabled: isViewMode,
                                                            placeholder: descriptionPlaceholder,
                                                            value: grievanceDesc,
                                                            onChange: handleTextAreaChange,
                                                            rows: "3",
                                                            className: "custom-text-area",
                                                            "aria-label": descriptionLabel,
                                                            "aria-required": "true",
                                                            "aria-disabled": isViewMode
                                                        })
                                                    ]
                                                }),
                                                (grievanceFormTemplate?.multilingual?.userInformation[0]?.userType?.length > 0 || grievanceFormTemplate?.multilingual?.userInformation[0]?.userItems?.length > 0) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                    appearance: "heading-xxs",
                                                    color: "primary-grey-80",
                                                    children: userDetailsHeading
                                                }),
                                                grievanceFormTemplate?.multilingual?.userInformation[0].userType && grievanceFormTemplate?.multilingual?.userInformation[0].userType.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "dropdown-group",
                                                    style: {
                                                        marginBottom: "0px"
                                                    },
                                                    role: "group",
                                                    "aria-labelledby": "details-usertype-label",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                            id: "details-usertype-label",
                                                            htmlFor: "details-usertype-select",
                                                            children: userTypeLabel
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                            id: "details-usertype-select",
                                                            disabled: isViewMode,
                                                            value: selectedUserType,
                                                            onChange: (e)=>setSelectedUserType(e.target.value),
                                                            "aria-label": userTypeLabel,
                                                            "aria-required": "true",
                                                            "aria-disabled": isViewMode,
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: "",
                                                                    disabled: true,
                                                                    children: userTypePlaceholder
                                                                }),
                                                                grievanceFormTemplate.multilingual.userInformation[0].userType.map((type, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                        value: type,
                                                                        children: getDynamicTranslation(type)
                                                                    }, index))
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                grievanceFormTemplate?.multilingual?.userInformation?.[0]?.userItems?.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    children: grievanceFormTemplate?.multilingual?.userInformation[0].userItems.map((detailName, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            style: {
                                                                padding: "10px 0px"
                                                            },
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "systemConfig-input",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                        style: {
                                                                            display: "block",
                                                                            fontSize: "13px",
                                                                            fontWeight: "600",
                                                                            fontFamily: "Arial, sans-serif",
                                                                            marginBottom: "5px",
                                                                            color: "#767676"
                                                                        },
                                                                        children: `${getDynamicTranslation(detailName)} (${requiredLable})`
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                        type: "text",
                                                                        disabled: isViewMode,
                                                                        value: userDetailInputs[detailName] || "",
                                                                        onChange: (e)=>setUserDetailInputs({
                                                                                ...userDetailInputs,
                                                                                [detailName]: e.target.value
                                                                            }),
                                                                        placeholder: `${enterLable} ${getDynamicTranslation(detailName).toLowerCase()}`,
                                                                        style: {
                                                                            width: "100%",
                                                                            padding: "10px 12px",
                                                                            border: "1px solid #ccc",
                                                                            borderRadius: "8px",
                                                                            fontSize: "14px",
                                                                            fontWeight: 400,
                                                                            color: "#333",
                                                                            outline: "none",
                                                                            fontFamily: "Arial, sans-serif"
                                                                        }
                                                                    })
                                                                ]
                                                            })
                                                        }, index))
                                                }),
                                                grievanceFormTemplate?.multilingual?.uploadFiles && !isViewMode && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                                appearance: "heading-xxs",
                                                                color: "primary-grey-80",
                                                                children: uploadFilesHeading
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            style: {
                                                                marginBottom: "20px"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    className: "fileUploader-custom1",
                                                                    onClick: handleUploadFilesClick,
                                                                    onDragOver: handleUploadFilesDragOver,
                                                                    onDragLeave: handleUploadFilesDragLeave,
                                                                    onDrop: handleUploadFilesDrop,
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                            type: "file",
                                                                            ref: uploadFileInputRef,
                                                                            style: {
                                                                                display: "none"
                                                                            },
                                                                            onChange: handleUploadFilieChange,
                                                                            accept: ".pdf,.doc,.docx"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                            className: "upload-content",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$f04a61298a47a40f), {
                                                                                    ic: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $170225ee6a03579c$export$7a525547346e73a), {
                                                                                        height: 23,
                                                                                        width: 23
                                                                                    }),
                                                                                    color: "primary_60"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                                                    appearance: "button",
                                                                                    color: "primary-60",
                                                                                    children: uploadButtonText
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                    style: {},
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                                        appearance: "body-xs",
                                                                        color: "primary-grey-80",
                                                                        children: uploadInstruction
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                uploadFileName && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "systemConfiguration-file-uploader",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            onClick: handlePreviewUploadFile,
                                                            className: "previewFile",
                                                            role: "button",
                                                            tabIndex: 0,
                                                            onKeyDown: (e)=>{
                                                                if (e.key === "Enter" || e.key === " ") {
                                                                    e.preventDefault();
                                                                    handlePreviewUploadFile();
                                                                }
                                                            },
                                                            title: uploadFileName,
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "iconandText",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$f04a61298a47a40f), {
                                                                        ic: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5a00847d48e39b4f$export$13b8539f4be0c), {
                                                                            width: 15,
                                                                            height: 15
                                                                        }),
                                                                        color: "feedback_success_50"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                                        appearance: "body-xs",
                                                                        color: "primary-grey-80",
                                                                        children: uploadFileName
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        !isViewMode && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$f04a61298a47a40f), {
                                                            ic: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4b407a2b367f43e3$export$48672c81f0c3f574), {
                                                                width: 15,
                                                                height: 15
                                                            }),
                                                            color: "primary_60",
                                                            className: "selecetd-file-display",
                                                            onClick: handleRemoveUploadFile
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: `popup-button ${backButtonSizeSmall ? "popup-button-mobile" : ""}`,
                                            children: !isViewMode && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {},
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$cfc7921d29ef7b80), {
                                                    kind: "primary",
                                                    size: "medium",
                                                    state: "normal",
                                                    label: "Submit Request",
                                                    onClick: handlePublish
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b00d3e7401eac195$export$f2815235e76a62b9), {
                position: "bottom-left",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                closeButton: false,
                toastClassName: ()=>"toast-wrapper",
                transition: (0, $b00d3e7401eac195$export$d8dc01b5c85a37b9)
            }),
            isLoading && /*#__PURE__*/ (0, $11492dca620dcaa5$exports.createPortal)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "overlay",
                "aria-busy": "true",
                "aria-live": "polite",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "loader"
                })
            }), document.body)
        ]
    });
};
var $f71dd81b43a79c0d$export$2e2bcd8739ae039 = $f71dd81b43a79c0d$var$RequestDetails;





var $acw62 = parcelRequire("acw62");













const $f09704f440a7e179$var$IntegrationGrievanceRequestsDetails = ()=>{
    const DEFAULT_DETAILS = {
        "User access": [
            "Submit request",
            "Access data",
            "Erase data"
        ],
        Legal: [
            "Raise issue",
            "Add data",
            "File complaint"
        ]
    };
    const logos = new URL($0ce165fce4857ef1$exports).href;
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const { grievanceId: grievanceId } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const [isChecked, setIsChecked] = (0, $acw62.useState)(false);
    const [templateName, setTemplateName] = (0, $acw62.useState)("");
    const [dark, setDark] = (0, $acw62.useState)(false);
    const [mobile, setMobile] = (0, $acw62.useState)(true);
    const [view, setView] = (0, $acw62.useState)("popup");
    const [title, setTitle] = (0, $acw62.useState)("Register your grievance");
    const [cid, setCid] = (0, $acw62.useState)("Customer ID");
    const [age, setAge] = (0, $acw62.useState)("I'm below 18 years of age.");
    const [purposeHeading, setPurposeHeading] = (0, $acw62.useState)("Purpose: ");
    const [processingHeading, setProcessingHeading] = (0, $acw62.useState)("Processing activity: ");
    const [usedByHeading, setUsedByHeading] = (0, $acw62.useState)("Used By: ");
    const [durationHeading, setDurationHeading] = (0, $acw62.useState)("Duration: ");
    const [dataItemHeading, setDataItemHeading] = (0, $acw62.useState)("Data item: ");
    const [selectedGrievanceType, setSelectedGrievanceType] = (0, $acw62.useState)("");
    const [selectedDetail, setSelectedDetail] = (0, $acw62.useState)("");
    const [isViewMode, setIsViewMode] = (0, $acw62.useState)(false);
    const [grievanceFormTemplate, setGrievanceFormTemplate] = (0, $acw62.useState)({});
    // Translation inputs for static text
    const translationInputs = (0, $acw62.useMemo)(()=>[
            {
                id: "int_details_title",
                source: "Register your grievance"
            },
            {
                id: "int_details_grievance_details",
                source: "Grievance Details"
            },
            {
                id: "int_details_select_category",
                source: "Select Category"
            },
            {
                id: "int_details_grievance_category",
                source: "Grievance Category"
            },
            {
                id: "int_details_grievance_subcategory",
                source: "Grievance Subcategory"
            },
            {
                id: "int_details_enter_subcategory",
                source: "Enter Grievance Subcategory"
            },
            {
                id: "int_details_description",
                source: "Description (Required)"
            },
            {
                id: "int_details_description_placeholder",
                source: "Enter description of the group's function or scope."
            },
            {
                id: "int_details_user_details",
                source: "User Details"
            },
            {
                id: "int_details_user_type",
                source: "User Type"
            },
            {
                id: "int_details_select_user_type",
                source: "Select user type"
            },
            {
                id: "int_details_upload_files",
                source: "Upload Files"
            },
            {
                id: "int_details_upload",
                source: "Upload"
            },
            {
                id: "int_details_upload_instruction",
                source: "Drag and drop or upload a document with hyperlink with the consent banner in .pdf or .doc format."
            },
            {
                id: "int_details_required",
                source: "Required"
            },
            {
                id: "int_details_enter",
                source: "Enter"
            },
            {
                id: "int_details_submit_request",
                source: "Submit Request"
            },
            {
                id: "int_details_always_active",
                source: "Always Active"
            }
        ], []);
    // Use translation hook
    const { getTranslation: getTranslation, translateContent: translateContent, currentLanguage: currentLanguage } = (0, $dbe8cedc9e1aa4ce$export$2e2bcd8739ae039)(translationInputs);
    // Translate content when language changes
    (0, $acw62.useEffect)(()=>{
        if (currentLanguage !== "ENGLISH") translateContent(translationInputs, currentLanguage);
    }, [
        currentLanguage,
        translationInputs,
        translateContent
    ]);
    (0, $acw62.useEffect)(()=>{
        const fetchData = async ()=>{
            try {
                const templateRes = await dispatch((0, $6eea01a75b53fee5$export$2e667524e0c28366)());
                if (templateRes.status === 200) {
                    const data = templateRes.data;
                    setGrievanceFormTemplate(data);
                    // --- Handle multilingual title/text ---
                    const supportedLanguages = data?.multilingual?.supportedLanguages;
                    const selectedLanguage = supportedLanguages?.[0];
                    let title = "";
                    let text = "";
                    if (selectedLanguage && data?.languages) {
                        const matchingLanguageEntry = Object.values(data.languages).find((lang)=>lang.language?.toUpperCase() === selectedLanguage.toUpperCase() || lang.heading?.toUpperCase()?.includes(selectedLanguage.toUpperCase()));
                        if (matchingLanguageEntry) {
                            title = matchingLanguageEntry.heading || "";
                            text = matchingLanguageEntry.description || "";
                        }
                    }
                    setTitle(title);
                    setText(text);
                    setLogoPreviewUrl(data?.uiConfig.logo || logos);
                }
                if (grievanceId) {
                    const grievanceRes = await dispatch((0, $6eea01a75b53fee5$export$412e0b0e0a4fa73b)(grievanceId));
                    if (grievanceRes.status === 200) {
                        const grievanceData = grievanceRes.data;
                        // --- Prefill base fields ---
                        setSelectedGrievanceType(grievanceData.grievanceType || "");
                        setSelectedDetail(grievanceData.grievanceDetail || "");
                        setSelectedUserType(grievanceData.userType || "");
                        setGrievanceDesc(grievanceData.grievanceDescription || "");
                        // --- Prefill user details ---
                        const filledInputs = {
                            ...userDetailInputs
                        };
                        const userItems = templateRes.data?.multilingual?.userInformation?.[0]?.userItems || [];
                        userItems.forEach((label)=>{
                            const normalizedLabel = label.toUpperCase().replace(/[^A-Z0-9]/g, "");
                            const matchedKey = Object.keys(grievanceData.userDetails || {}).find((key)=>key.toUpperCase().replace(/[^A-Z0-9]/g, "") === normalizedLabel);
                            if (matchedKey) filledInputs[label] = grievanceData.userDetails[matchedKey];
                        });
                        setUserDetailInputs(filledInputs);
                        // --- Handle uploaded documents ---
                        if (grievanceData.supportingDocs?.length > 0) {
                            const doc = grievanceData.supportingDocs[0];
                            setUploadFileName(doc.name);
                            setUploadFileBase64(doc.documentId || "");
                        }
                        setIsViewMode(true);
                    }
                }
            } catch (err) {
                console.log("Error fetching data:", err);
                if (err?.[0]?.errorCode === "JCMP3001") setConsentsByTempId([]);
            }
        };
        fetchData();
    }, [
        grievanceId
    ]);
    const [grievanceDesc, setGrievanceDesc] = (0, $acw62.useState)("");
    // for upload component
    const uploadFileInputRef = (0, $acw62.useRef)(null);
    const [uploadFileName, setUploadFileName] = (0, $acw62.useState)("");
    const [uploadFileBase64, setUploadFileBase64] = (0, $acw62.useState)("");
    const [upoladFilePreviewUrl, setUploadFilePreviewUrl] = (0, $acw62.useState)("");
    const [selectedUserType, setSelectedUserType] = (0, $acw62.useState)("");
    const [userDetailInputs, setUserDetailInputs] = (0, $acw62.useState)({});
    // Get translated labels from hook
    const grievanceDetailsHeading = getTranslation("int_details_grievance_details", "Grievance Details");
    const selectCategoryPlaceholder = getTranslation("int_details_select_category", "Select Category");
    const grievanceCategoryLabel = getTranslation("int_details_grievance_category", "Grievance Category");
    const grievanceSubCategoryLabel = getTranslation("int_details_grievance_subcategory", "Grievance Subcategory");
    const subCategoryPlaceholder = getTranslation("int_details_enter_subcategory", "Enter Grievance Subcategory");
    const descriptionLabel = getTranslation("int_details_description", "Description (Required)");
    const descriptionPlaceholder = getTranslation("int_details_description_placeholder", "Enter description of the group's function or scope.");
    const userDetailsHeading = getTranslation("int_details_user_details", "User Details");
    const userTypeLabel = getTranslation("int_details_user_type", "User Type");
    const userTypePlaceholder = getTranslation("int_details_select_user_type", "Select user type");
    const uploadFilesHeading = getTranslation("int_details_upload_files", "Upload Files");
    const uploadButtonText = getTranslation("int_details_upload", "Upload");
    const uploadInstruction = getTranslation("int_details_upload_instruction", "Drag and drop or upload a document with hyperlink with the consent banner in .pdf or .doc format.");
    const requiredLable = getTranslation("int_details_required", "Required");
    const enterLable = getTranslation("int_details_enter", "Enter");
    const handleDetailSelect = (e)=>{
        setSelectedDetail(e.target.value);
    };
    const handleTextAreaChange = (e)=>{
        setGrievanceDesc(e.target.value);
    };
    const toTitleCase = (str)=>{
        return str.toLowerCase().replace(/\b\w/g, (char)=>char.toUpperCase());
    };
    const [purposes, setPurposes] = (0, $acw62.useState)([
        {
            purposeIds: [],
            purposeNames: [],
            isMandatory: "",
            autoRenew: "",
            preferenceValidity: {
                value: 1,
                unit: ""
            },
            purposeActivityIds: [],
            usedBy: [],
            dataItems: [],
            processingAct: []
        }
    ]);
    // upoad component
    const handleUploadFilesClick = ()=>{
        uploadFileInputRef.current?.click();
    };
    const handleUploadFilesDragOver = (e)=>{
        e.preventDefault();
        e.stopPropagation();
    };
    const handleUploadFilesDragLeave = (e)=>{
        e.preventDefault();
        e.stopPropagation();
    };
    const handleUploadFilesDrop = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        const file = e.dataTransfer.files[0];
        if (file) processUploadFile(file);
    };
    const handleUploadFilieChange = (e)=>{
        const file = e.target.files[0];
        if (file) processUploadFile(file);
    };
    const processUploadFile = (file)=>{
        setUploadFileName(file.name);
        const reader = new FileReader();
        reader.onloadend = ()=>{
            const base64String = reader.result.split(",")[1];
            setUploadFileBase64(base64String);
            setUploadFilePreviewUrl(reader.result);
        };
        reader.readAsDataURL(file);
    };
    const handleRemoveUploadFile = ()=>{
        setUploadFileName("");
        setUploadFileBase64("");
        setUploadFilePreviewUrl("");
        if (uploadFileInputRef.current) uploadFileInputRef.current.value = "";
    };
    const handlePreviewUploadFile = ()=>{
        if (upoladFilePreviewUrl) window.open(upoladFilePreviewUrl, "_blank");
    };
    //language container states
    const AccordionItem = ({ title: title, alwaysActive: alwaysActive, hasCheckbox: hasCheckbox, items: items })=>{
        const [isOpen, setIsOpen] = (0, $acw62.useState)(true);
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "accordion-item",
            style: {
                backgroundColor: activePopupColors.cardBackground,
                color: activePopupColors.cardFont
            },
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "accordion-header",
                    onClick: ()=>setIsOpen(!isOpen),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "accordion-left",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: `accordion-icon ${isOpen ? "open" : ""}`,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fdc94045ec0e5793$export$ec7db1c418c1ec5a), {
                                        height: 25,
                                        width: 25
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "accordion-title",
                                    children: title
                                })
                            ]
                        }),
                        alwaysActive && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "accordion-label",
                            children: "Always Active"
                        }),
                        hasCheckbox && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "checkbox"
                        })
                    ]
                }),
                isOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "accordion-content",
                    style: {
                        backgroundColor: activePopupColors.cardBackground,
                        color: activePopupColors.cardFont
                    },
                    children: items.map((item, idx)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "accordion-block",
                            children: [
                                item.purposeNames?.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: purposeHeading
                                        }),
                                        " ",
                                        item.purposeNames.join(", ")
                                    ]
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: purposeHeading
                                        }),
                                        " Not provided"
                                    ]
                                }),
                                validitytoBeShown && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: durationHeading
                                        }),
                                        " ",
                                        item.preferenceValidity?.value ? `${item.preferenceValidity.value} ${toTitleCase(item.preferenceValidity.value === 1 ? item.preferenceValidity.unit.replace(/s$/i, "") // singular
                                         : item.preferenceValidity.unit // plural
                                        )}` : "N/A"
                                    ]
                                }),
                                item.usedBy?.length > 0 && processorNameToBeShown && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: usedByHeading
                                        }),
                                        " ",
                                        item.usedBy.join(", ")
                                    ]
                                }),
                                processActivityNameToBeShown && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: processingHeading
                                        }),
                                        " ",
                                        item.processingAct?.join(", ")
                                    ]
                                }),
                                dataItemToBeShown && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: dataItemHeading
                                        }),
                                        " ",
                                        item.dataItems?.join(", ")
                                    ]
                                }),
                                idx !== items.length - 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                                    className: "accordion-separator"
                                })
                            ]
                        }, idx))
                })
            ]
        });
    };
    const [text, setText] = (0, $acw62.useState)("While using JioMeet, your activities create data which will be used with your consent to offer customised services. Details of data usage are provided below. ");
    //purpose container states
    const [purposeItems, setPurposeItems] = (0, $acw62.useState)([
        0
    ]);
    const [counter, setCounter] = (0, $acw62.useState)(1);
    const [logoPreviewUrl, setLogoPreviewUrl] = (0, $acw62.useState)("");
    const [darkMode, setDarkMode] = (0, $acw62.useState)(false);
    const [processActivityNameToBeShown, setProcessActivityNameToBeShown] = (0, $acw62.useState)(true);
    const [processorNameToBeShown, setProcessorNameToBeShown] = (0, $acw62.useState)(true);
    const [validitytoBeShown, setValiditytoBeShown] = (0, $acw62.useState)(true);
    const [colors, setColors] = (0, $acw62.useState)({
        cardBackground: "#FFFFFF",
        cardFont: "#000000",
        buttonBackground: "#0F3CC9",
        buttonFont: "#FFFFFF",
        linkFont: "#0A2885"
    });
    const [darkColors, setDarkColors] = (0, $acw62.useState)({
        cardBackground: "#000000",
        cardFont: "#FFFFFF",
        buttonBackground: "#FFFFFF",
        buttonFont: "#0F3CC9",
        linkFont: "#0A2885"
    });
    const activePopupColors = darkMode ? darkColors : colors;
    const [languageContent, setLanguageContent] = (0, $acw62.useState)({
        ENGLISH: {
            description: "sample description",
            label: "Required",
            rightsText: "sample rights text",
            permissionText: "sample permission text"
        }
    });
    const lightString = JSON.stringify(colors);
    const darkString = JSON.stringify(darkColors);
    const handleBack = ()=>{
        navigate("/integrationGrievanceRequests");
    };
    const handlePublish = async ()=>{
        const errors = [];
        // --- 1. Grievance Type ---
        if (!selectedGrievanceType) errors.push("Please select a Grievance Category.");
        // --- 2. Grievance Detail/Sub-category ---
        if (selectedGrievanceType && !selectedDetail) errors.push("Please select a Grievance Sub-Category.");
        // --- 3. Description ---
        if (grievanceFormTemplate.multilingual.descriptionCheck && !grievanceDesc.trim()) errors.push("Please enter Description.");
        // --- 4. User Type ---
        if (grievanceFormTemplate.multilingual.userInformation[0]?.userType?.length > 0 && !selectedUserType) errors.push("Please select a User Type.");
        // --- 5. User Item inputs ---
        if (grievanceFormTemplate.multilingual.userInformation[0]?.userItems?.length > 0) grievanceFormTemplate.multilingual.userInformation[0].userItems.forEach((item)=>{
            if (!userDetailInputs[item] || userDetailInputs[item].trim() === "") errors.push(`Please enter ${item}.`);
        });
        // --- 6. Upload File ---
        if (grievanceFormTemplate.multilingual.uploadFiles && !uploadFileName) errors.push("Please upload a supporting document.");
        // --- Show Toast if errors exist ---
        if (errors.length > 1) {
            (0, $b00d3e7401eac195$export$b410431fab84fa58).error((props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482ccd6e8e9b33b1$export$2e2bcd8739ae039), {
                    ...props,
                    type: "error",
                    message: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                        style: {
                            margin: 0
                        },
                        children: errors.map((err, idx)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                children: err
                            }, idx))
                    })
                }), {
                icon: false
            });
            return;
        } else if (errors.length === 1) {
            (0, $b00d3e7401eac195$export$b410431fab84fa58).error((props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482ccd6e8e9b33b1$export$2e2bcd8739ae039), {
                    ...props,
                    type: "error",
                    message: errors[0]
                }), {
                icon: false
            });
            return;
        } else {
            const formattedGrievanceInformation = Object.entries(grievanceFormTemplate?.grievances || {}).map(([grievanceType, grievanceItems])=>({
                    grievanceType: grievanceType,
                    grievanceItems: grievanceItems
                }));
            const userDetails = grievanceFormTemplate.multilingual.userInformation[0].userItems.reduce((acc, label)=>{
                const key = label.toLowerCase().replace(/\s+/g, "_");
                acc[key] = userDetailInputs[label] || "";
                return acc;
            }, {});
            // request body
            const requestBody = {
                grievanceRelatedTo: selectedGrievanceType,
                grievanceRaisedBy: selectedUserType,
                grievanceDescription: grievanceDesc,
                ...userDetails,
                supportingDocs: uploadFileName ? [
                    {
                        docName: uploadFileName,
                        doc: uploadFileBase64
                    }
                ] : []
            };
            const res = await (0, $6eea01a75b53fee5$export$499d1caee87874d7)(requestBody);
            if (res.status === 201) (0, $b00d3e7401eac195$export$b410431fab84fa58).success((props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482ccd6e8e9b33b1$export$2e2bcd8739ae039), {
                    ...props,
                    type: "success",
                    message: "Form Template Published successfully."
                }), {
                icon: false
            });
            (0, $b00d3e7401eac195$export$b410431fab84fa58).success((props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482ccd6e8e9b33b1$export$2e2bcd8739ae039), {
                    ...props,
                    type: "success",
                    message: "Grievance Request Raised Succesfully!"
                }), {
                icon: false
            });
        // navigate("/grievanceFormTemplates");
        }
    };
    const [activeTab, setActiveTab] = (0, $acw62.useState)("popup");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "page-container",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "main-content",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "right-half",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "preview-header",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "header-left",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$353f5b6fc5456de1), {
                                    ariaControls: "Button Clickable",
                                    ariaDescribedby: "Button",
                                    ariaExpanded: "Expanded",
                                    ariaLabel: "Button",
                                    className: "Button",
                                    icon: "ic_back",
                                    iconAriaLabel: "Icon Favorite",
                                    iconLeft: "ic_back",
                                    kind: "secondary",
                                    onClick: handleBack,
                                    size: "medium",
                                    state: "normal"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "header-right",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "popup-mobile",
                                    style: {
                                        backgroundColor: activePopupColors.cardBackground,
                                        color: activePopupColors.cardFont
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "popup-header",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    style: {
                                                        display: "flex",
                                                        flexDirection: "row",
                                                        gap: "20px",
                                                        alignItems: "center"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                                            className: "custom-head",
                                                            style: {
                                                                backgroundColor: activePopupColors.cardBackground,
                                                                color: activePopupColors.cardFont
                                                            },
                                                            children: title ? title : "Register your grievance"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$353f5b6fc5456de1), {
                                                            ariaControls: "Button Clickable",
                                                            ariaDescribedby: "Button",
                                                            ariaExpanded: "Expanded",
                                                            ariaLabel: "Button",
                                                            className: "Button",
                                                            icon: "ic_chevron_down",
                                                            iconLeft: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab6d9bfa47542205$export$28390bfec38e5c4f), {}),
                                                            iconAriaLabel: "Icon Favorite",
                                                            kind: "secondary",
                                                            label: "English",
                                                            size: "small",
                                                            state: "normal"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    src: logoPreviewUrl,
                                                    alt: "Logo",
                                                    style: {
                                                        width: mobile ? "28px" : "40px",
                                                        height: mobile ? "28px" : "40px",
                                                        marginLeft: mobile ? "5px" : "10px"
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "popup-body",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "custom-text-p",
                                                    style: {
                                                        backgroundColor: activePopupColors.cardBackground,
                                                        color: activePopupColors.cardFont,
                                                        marginBottom: "8px",
                                                        fontSize: "14px",
                                                        letterSpacing: "-0.5px",
                                                        color: "rgba(0, 0, 0, 0.65)",
                                                        fontWeight: "500"
                                                    },
                                                    children: text ? text : "Please provide the following details to register your grievance."
                                                }),
                                                grievanceFormTemplate?.multilingual?.grievanceInformation?.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            style: {
                                                                marginBottom: "10px"
                                                            },
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                                appearance: "heading-xxs",
                                                                color: "primary-grey-80",
                                                                children: grievanceDetailsHeading
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "dropdown-group",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                    children: grievanceCategoryLabel
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                                    disabled: isViewMode,
                                                                    value: selectedGrievanceType,
                                                                    onChange: (e)=>{
                                                                        const newType = e.target.value;
                                                                        setSelectedGrievanceType(newType);
                                                                        setSelectedDetail("");
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                            value: "",
                                                                            disabled: true,
                                                                            children: selectCategoryPlaceholder
                                                                        }),
                                                                        grievanceFormTemplate.multilingual.grievanceInformation.map((info, idx)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                                value: info.grievanceType,
                                                                                children: info.grievanceType
                                                                            }, idx))
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        selectedGrievanceType && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "dropdown-group",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                    htmlFor: "grievanceTypeSelect",
                                                                    children: grievanceSubCategoryLabel
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                                    id: "grievanceTypeSelect",
                                                                    value: selectedDetail,
                                                                    // onChange={(e) => setSelectedDetail(e.target.value)}
                                                                    disabled: isViewMode,
                                                                    style: {
                                                                        pointerEvents: isViewMode ? "none" : "auto",
                                                                        color: "#333"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                            value: "",
                                                                            disabled: true,
                                                                            children: subCategoryPlaceholder
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                            value: selectedDetail,
                                                                            children: selectedDetail
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                grievanceFormTemplate?.multilingual?.descriptionCheck && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "dropdown-group",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                            children: descriptionLabel
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                                            disabled: isViewMode,
                                                            placeholder: descriptionPlaceholder,
                                                            value: grievanceDesc,
                                                            onChange: handleTextAreaChange,
                                                            rows: "3",
                                                            className: "custom-text-area"
                                                        })
                                                    ]
                                                }),
                                                (grievanceFormTemplate?.multilingual?.userInformation[0]?.userType?.length > 0 || grievanceFormTemplate?.multilingual?.userInformation[0]?.userItems?.length > 0) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                    appearance: "heading-xxs",
                                                    color: "primary-grey-80",
                                                    children: userDetailsHeading
                                                }),
                                                grievanceFormTemplate?.multilingual?.userInformation[0].userType && grievanceFormTemplate?.multilingual?.userInformation[0].userType.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "dropdown-group",
                                                    style: {
                                                        marginBottom: "0px"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                            children: userTypeLabel
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                            disabled: isViewMode,
                                                            value: selectedUserType,
                                                            onChange: (e)=>setSelectedUserType(e.target.value),
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: "",
                                                                    disabled: true,
                                                                    children: userTypePlaceholder
                                                                }),
                                                                grievanceFormTemplate.multilingual.userInformation[0].userType.map((type, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                        value: type,
                                                                        children: type
                                                                    }, index))
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                grievanceFormTemplate?.multilingual?.userInformation?.[0]?.userItems?.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    children: grievanceFormTemplate?.multilingual?.userInformation[0].userItems.map((detailName, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            style: {
                                                                padding: "10px 0px"
                                                            },
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "systemConfig-input",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                        style: {
                                                                            display: "block",
                                                                            fontSize: "13px",
                                                                            fontWeight: "600",
                                                                            fontFamily: "Arial, sans-serif",
                                                                            marginBottom: "5px",
                                                                            color: "#767676"
                                                                        },
                                                                        children: `${detailName} (${requiredLable})`
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                        type: "text",
                                                                        disabled: isViewMode,
                                                                        value: userDetailInputs[detailName] || "",
                                                                        onChange: (e)=>setUserDetailInputs({
                                                                                ...userDetailInputs,
                                                                                [detailName]: e.target.value
                                                                            }),
                                                                        placeholder: `${enterLable} ${detailName.toLowerCase()}`,
                                                                        style: {
                                                                            width: "100%",
                                                                            padding: "10px 12px",
                                                                            border: "1px solid #ccc",
                                                                            borderRadius: "8px",
                                                                            fontSize: "14px",
                                                                            fontWeight: 400,
                                                                            color: "#333",
                                                                            outline: "none",
                                                                            fontFamily: "Arial, sans-serif"
                                                                        }
                                                                    })
                                                                ]
                                                            })
                                                        }, index))
                                                }),
                                                grievanceFormTemplate?.multilingual?.uploadFiles && !isViewMode && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                                appearance: "heading-xxs",
                                                                color: "primary-grey-80",
                                                                children: uploadFilesHeading
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            style: {
                                                                marginBottom: "20px"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    className: "fileUploader-custom1",
                                                                    onClick: handleUploadFilesClick,
                                                                    onDragOver: handleUploadFilesDragOver,
                                                                    onDragLeave: handleUploadFilesDragLeave,
                                                                    onDrop: handleUploadFilesDrop,
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                            type: "file",
                                                                            ref: uploadFileInputRef,
                                                                            style: {
                                                                                display: "none"
                                                                            },
                                                                            onChange: handleUploadFilieChange,
                                                                            accept: ".pdf,.doc,.docx"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                            className: "flex items-center justify-center",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$f04a61298a47a40f), {
                                                                                    ic: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $170225ee6a03579c$export$7a525547346e73a), {
                                                                                        height: 23,
                                                                                        width: 23
                                                                                    }),
                                                                                    color: "primary_60"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                                                    appearance: "button",
                                                                                    color: "primary-60",
                                                                                    children: uploadButtonText
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                    style: {},
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                                        appearance: "body-xs",
                                                                        color: "primary-grey-80",
                                                                        children: uploadInstruction
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                uploadFileName && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "systemConfiguration-file-uploader",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            onClick: handlePreviewUploadFile,
                                                            className: "previewFile",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$f04a61298a47a40f), {
                                                                    ic: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5a00847d48e39b4f$export$13b8539f4be0c), {
                                                                        width: 15,
                                                                        height: 15
                                                                    }),
                                                                    color: "feedback_success_50"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                                    appearance: "body-xs",
                                                                    color: "primary-grey-80",
                                                                    children: uploadFileName
                                                                })
                                                            ]
                                                        }),
                                                        !isViewMode && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$f04a61298a47a40f), {
                                                            ic: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4b407a2b367f43e3$export$48672c81f0c3f574), {
                                                                width: 15,
                                                                height: 15
                                                            }),
                                                            color: "primary_60",
                                                            className: "selecetd-file-display",
                                                            onClick: handleRemoveUploadFile
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: `popup-button ${mobile ? "popup-button-mobile" : ""}`,
                                            children: !isViewMode && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {},
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$cfc7921d29ef7b80), {
                                                    kind: "primary",
                                                    size: "medium",
                                                    state: "normal",
                                                    label: "Submit Request",
                                                    onClick: handlePublish
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b00d3e7401eac195$export$f2815235e76a62b9), {
                position: "bottom-left",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                closeButton: false,
                toastClassName: ()=>"toast-wrapper",
                transition: (0, $b00d3e7401eac195$export$d8dc01b5c85a37b9)
            })
        ]
    });
};
var $f09704f440a7e179$export$2e2bcd8739ae039 = $f09704f440a7e179$var$IntegrationGrievanceRequestsDetails;




var $acw62 = parcelRequire("acw62");













const $d9216057e8fe75fb$var$IntegrationCreateRequest = ()=>{
    const logos = new URL($0ce165fce4857ef1$exports).href;
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const [mobile, setMobile] = (0, $acw62.useState)(true);
    const [title, setTitle] = (0, $acw62.useState)("Register your grievance");
    const [purposeHeading, setPurposeHeading] = (0, $acw62.useState)("Purpose: ");
    const [processingHeading, setProcessingHeading] = (0, $acw62.useState)("Processing activity: ");
    const [usedByHeading, setUsedByHeading] = (0, $acw62.useState)("Used By: ");
    const [durationHeading, setDurationHeading] = (0, $acw62.useState)("Duration: ");
    const [dataItemHeading, setDataItemHeading] = (0, $acw62.useState)("Data item: ");
    const [selectedType, setSelectedType] = (0, $acw62.useState)("");
    const [selectedGrievanceType, setSelectedGrievanceType] = (0, $acw62.useState)("");
    const [selectedDetail, setSelectedDetail] = (0, $acw62.useState)("");
    const [grievanceFormTemplate, setGrievanceFormTemplate] = (0, $acw62.useState)({});
    // Translation inputs for static text
    const translationInputs = (0, $acw62.useMemo)(()=>[
            {
                id: "int_create_title",
                source: "Register your grievance"
            },
            {
                id: "int_create_grievance_details",
                source: "Grievance Details"
            },
            {
                id: "int_create_select_category",
                source: "Select Category"
            },
            {
                id: "int_create_grievance_category",
                source: "Grievance Category"
            },
            {
                id: "int_create_grievance_subcategory",
                source: "Grievance Subcategory"
            },
            {
                id: "int_create_enter_subcategory",
                source: "Enter Grievance Subcategory"
            },
            {
                id: "int_create_description",
                source: "Description (Required)"
            },
            {
                id: "int_create_description_placeholder",
                source: "Enter description of the group's function or scope."
            },
            {
                id: "int_create_user_details",
                source: "User Details"
            },
            {
                id: "int_create_user_type",
                source: "User Type"
            },
            {
                id: "int_create_select_user_type",
                source: "Select user type"
            },
            {
                id: "int_create_upload_files",
                source: "Upload Files"
            },
            {
                id: "int_create_upload",
                source: "Upload"
            },
            {
                id: "int_create_upload_instruction",
                source: "Drag and drop or upload a document with hyperlink with the consent banner in .pdf or .doc format."
            },
            {
                id: "int_create_required",
                source: "Required"
            },
            {
                id: "int_create_enter",
                source: "Enter"
            },
            {
                id: "int_create_submit_request",
                source: "Submit Request"
            }
        ], []);
    // Use translation hook
    const { getTranslation: getTranslation, translateContent: translateContent, currentLanguage: currentLanguage } = (0, $dbe8cedc9e1aa4ce$export$2e2bcd8739ae039)(translationInputs);
    // Translate content when language changes
    (0, $acw62.useEffect)(()=>{
        if (currentLanguage !== "ENGLISH") translateContent(translationInputs, currentLanguage);
    }, [
        currentLanguage,
        translationInputs,
        translateContent
    ]);
    let tenantId = "";
    let businessId = "";
    let grievanceTemplateId = "";
    let secureCode = "";
    const params = new URLSearchParams(window.location.search);
    const encodedData = params.get("data");
    if (encodedData) try {
        const decoded = atob(encodedData);
        const parsed = JSON.parse(decoded);
        tenantId = parsed.tenantId || "";
        businessId = parsed.businessId || "";
        grievanceTemplateId = parsed.grievanceTemplateId || "";
        secureCode = parsed.secureCode || "";
    } catch (err) {
        console.log("Error decoding Base64 data param:", err);
    }
    (0, $acw62.useEffect)(()=>{
        const fetchData = async ()=>{
            try {
                const response = await dispatch((0, $6eea01a75b53fee5$export$2e667524e0c28366)(tenantId, businessId, grievanceTemplateId, secureCode));
                if (response.status === 200) {
                    setGrievanceFormTemplate(response.data);
                    const data = response.data;
                    const supportedLanguages = data?.multilingual?.supportedLanguages;
                    const selectedLanguage = supportedLanguages?.[0];
                    let title = "";
                    let text = "";
                    if (selectedLanguage && data?.languages) {
                        // Find the entry in languages where key corresponds to that language
                        const matchingLanguageEntry = Object.values(data.languages).find((lang)=>lang.language?.toUpperCase() === selectedLanguage.toUpperCase() || lang.heading?.toUpperCase().includes(selectedLanguage.toUpperCase()));
                        if (matchingLanguageEntry) {
                            title = matchingLanguageEntry.heading || "";
                            text = matchingLanguageEntry.description || "";
                        }
                    }
                    setTitle(title);
                    setText(text);
                    setLogoPreviewUrl(data?.uiConfig.logo || logos);
                }
            } catch (err) {
                console.log("Error occured in getConsentsByTemplateId", err);
                if (err?.[0]?.errorCode === "JCMP3001") grievanceFormTemplate({});
            } finally{
            // setLoadLogs(false);
            }
        };
        fetchData();
    }, []);
    const [grievanceDesc, setGrievanceDesc] = (0, $acw62.useState)("");
    // for upload component
    const uploadFileInputRef = (0, $acw62.useRef)(null);
    const [uploadFileName, setUploadFileName] = (0, $acw62.useState)("");
    const [uploadFileBase64, setUploadFileBase64] = (0, $acw62.useState)("");
    const [upoladFilePreviewUrl, setUploadFilePreviewUrl] = (0, $acw62.useState)("");
    const [selectedUserType, setSelectedUserType] = (0, $acw62.useState)("");
    const [userDetailInputs, setUserDetailInputs] = (0, $acw62.useState)({});
    // for translation
    const [grievanceDetailsHeading, setGrievanceDetailsHeading] = (0, $acw62.useState)("Grievance Details");
    const [selectCategoryPlaceholder, setSelectCategoryPlaceholder] = (0, $acw62.useState)("Select Category");
    const [grievanceCategoryLabel, setGrievanceCategoryLabel] = (0, $acw62.useState)("Grievance Category");
    const [grievanceSubCategoryLabel, setGrievanceSubCategoryLabel] = (0, $acw62.useState)("Grievance Subcategory");
    const [text, setText] = (0, $acw62.useState)("While using JioMeet, your activities create data which will be used with your consent to offer customised services. Details of data usage are provided below. ");
    const [subCategoryPlaceholder, setSubCategoryPlaceholder] = (0, $acw62.useState)("Enter Grievance Subcategory");
    const [descriptionLabel, setDescriptionLabel] = (0, $acw62.useState)("Description (Required)");
    const [descriptionPlaceholder, setDescriptionPlaceholder] = (0, $acw62.useState)("Enter description of the group's function or scope.");
    const [userDetailsHeading, setUserDetailsHeading] = (0, $acw62.useState)("User Details");
    const [userTypeLabel, setUserTypeLabel] = (0, $acw62.useState)("User Type");
    const [userTypePlaceholder, setUserTypePlaceholder] = (0, $acw62.useState)("Select user type");
    const [uploadFilesHeading, setUploadFilesHeading] = (0, $acw62.useState)("Upload Files");
    const [uploadButtonText, setUploadButtonText] = (0, $acw62.useState)("Upload");
    const [uploadInstruction, setUploadInstruction] = (0, $acw62.useState)("Drag and drop or upload a document with hyperlink with the consent banner in .pdf or .doc format.");
    const [requiredLable, setRequiredLable] = (0, $acw62.useState)("Required");
    const [enterLable, setEnterLable] = (0, $acw62.useState)("Enter");
    const handleTextAreaChange = (e)=>{
        setGrievanceDesc(e.target.value);
    };
    const toTitleCase = (str)=>{
        return str.toLowerCase().replace(/\b\w/g, (char)=>char.toUpperCase());
    };
    const [purposes, setPurposes] = (0, $acw62.useState)([
        {
            purposeIds: [],
            purposeNames: [],
            isMandatory: "",
            autoRenew: "",
            preferenceValidity: {
                value: 1,
                unit: ""
            },
            purposeActivityIds: [],
            usedBy: [],
            dataItems: [],
            processingAct: []
        }
    ]);
    // upoad component
    const handleUploadFilesClick = ()=>{
        uploadFileInputRef.current?.click();
    };
    const handleUploadFilesDragOver = (e)=>{
        e.preventDefault();
        e.stopPropagation();
    };
    const handleUploadFilesDragLeave = (e)=>{
        e.preventDefault();
        e.stopPropagation();
    };
    const handleUploadFilesDrop = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        const file = e.dataTransfer.files[0];
        if (file) processUploadFile(file);
    };
    const handleUploadFilieChange = (e)=>{
        const file = e.target.files[0];
        if (file) processUploadFile(file);
    };
    const processUploadFile = (file)=>{
        setUploadFileName(file.name);
        const reader = new FileReader();
        reader.onloadend = ()=>{
            const base64String = reader.result.split(",")[1];
            setUploadFileBase64(base64String);
            setUploadFilePreviewUrl(reader.result);
        };
        reader.readAsDataURL(file);
    };
    const handleRemoveUploadFile = ()=>{
        setUploadFileName("");
        setUploadFileBase64("");
        setUploadFilePreviewUrl("");
        if (uploadFileInputRef.current) uploadFileInputRef.current.value = "";
    };
    const handlePreviewUploadFile = ()=>{
        if (upoladFilePreviewUrl) window.open(upoladFilePreviewUrl, "_blank");
    };
    // Custom style for select
    const customStyles = {
        control: (base, state)=>({
                ...base,
                color: "#333",
                backgroundColor: "#fff",
                border: "1px solid #ccc",
                borderRadius: "8px",
                padding: "2px 4px",
                fontSize: "14px",
                minHeight: "40px",
                boxShadow: "none",
                borderColor: state.isFocused ? "#ccc" : "#ccc",
                "&:hover": {
                    borderColor: "#999"
                }
            }),
        valueContainer: (base)=>({
                ...base,
                padding: "0 8px",
                gap: "4px"
            }),
        placeholder: (base)=>({
                ...base,
                color: "#666",
                fontSize: "14px"
            }),
        multiValue: (base)=>({
                ...base,
                borderRadius: "6px",
                backgroundColor: "#f0f0f0",
                padding: "2px 6px"
            }),
        multiValueLabel: (base)=>({
                ...base,
                color: "#333",
                fontSize: "13px"
            }),
        multiValueRemove: (base)=>({
                ...base,
                color: "#666",
                cursor: "pointer",
                ":hover": {
                    backgroundColor: "#e0e0e0",
                    color: "#000"
                }
            }),
        menu: (base)=>({
                ...base,
                borderRadius: "8px",
                border: "1px solid #ccc",
                marginTop: "4px",
                zIndex: 9999
            }),
        menuList: (base)=>({
                ...base,
                padding: "4px 0"
            }),
        option: (base, state)=>({
                ...base,
                fontSize: "14px",
                padding: "8px 12px",
                cursor: "pointer",
                backgroundColor: state.isSelected ? "#e6f0ff" : state.isFocused ? "#f5f5f5" : "#fff",
                color: "#333",
                ":active": {
                    backgroundColor: "#e6f0ff"
                }
            }),
        dropdownIndicator: (base)=>({
                ...base,
                color: "#666",
                padding: "0 8px",
                "&:hover": {
                    color: "#333"
                }
            }),
        clearIndicator: (base)=>({
                ...base,
                padding: "0 8px"
            })
    };
    //language container states
    const AccordionItem = ({ title: title, alwaysActive: alwaysActive, hasCheckbox: hasCheckbox, items: items })=>{
        const [isOpen, setIsOpen] = (0, $acw62.useState)(true);
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "accordion-item",
            style: {
                backgroundColor: activePopupColors.cardBackground,
                color: activePopupColors.cardFont
            },
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "accordion-header",
                    onClick: ()=>setIsOpen(!isOpen),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "accordion-left",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: `accordion-icon ${isOpen ? "open" : ""}`,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fdc94045ec0e5793$export$ec7db1c418c1ec5a), {
                                        height: 25,
                                        width: 25
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "accordion-title",
                                    children: title
                                })
                            ]
                        }),
                        alwaysActive && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "accordion-label",
                            children: "Always Active"
                        }),
                        hasCheckbox && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "checkbox"
                        })
                    ]
                }),
                isOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "accordion-content",
                    style: {
                        backgroundColor: activePopupColors.cardBackground,
                        color: activePopupColors.cardFont
                    },
                    children: items.map((item, idx)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "accordion-block",
                            children: [
                                item.purposeNames?.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: purposeHeading
                                        }),
                                        " ",
                                        item.purposeNames.join(", ")
                                    ]
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: purposeHeading
                                        }),
                                        " Not provided"
                                    ]
                                }),
                                validitytoBeShown && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: durationHeading
                                        }),
                                        " ",
                                        item.preferenceValidity?.value ? `${item.preferenceValidity.value} ${toTitleCase(item.preferenceValidity.value === 1 ? item.preferenceValidity.unit.replace(/s$/i, "") // singular
                                         : item.preferenceValidity.unit // plural
                                        )}` : "N/A"
                                    ]
                                }),
                                item.usedBy?.length > 0 && processorNameToBeShown && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: usedByHeading
                                        }),
                                        " ",
                                        item.usedBy.join(", ")
                                    ]
                                }),
                                processActivityNameToBeShown && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: processingHeading
                                        }),
                                        " ",
                                        item.processingAct?.join(", ")
                                    ]
                                }),
                                dataItemToBeShown && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: dataItemHeading
                                        }),
                                        " ",
                                        item.dataItems?.join(", ")
                                    ]
                                }),
                                idx !== items.length - 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                                    className: "accordion-separator"
                                })
                            ]
                        }, idx))
                })
            ]
        });
    };
    const [rights, setRights] = (0, $acw62.useState)("To withdraw your consent, exercise your rights, or file complaints with the Board click here.");
    const [permission, setPermission] = (0, $acw62.useState)("By clicking \u2018Allow all\u2019 or \u2019Save my choices\u2019, you are providing your consent to Reliance Medlab using your data as outlined above.");
    const [supportedLanguages, setSupportedLanguages] = (0, $acw62.useState)([]);
    const [language, setLanguage] = (0, $acw62.useState)("");
    const [label, setLabel] = (0, $acw62.useState)("Required");
    const [languageSpecificContentMap, setLanguageSpecificContentMap] = (0, $acw62.useState)({
        ENGLISH: {
            description: text,
            heading: "Register your grievance"
        }
    });
    //purpose container states
    const [purposeItems, setPurposeItems] = (0, $acw62.useState)([
        0
    ]);
    const [counter, setCounter] = (0, $acw62.useState)(1);
    const [processingActivityList, setProcessingActivityList] = (0, $acw62.useState)([]);
    const [activityOptions, setActivityOptions] = (0, $acw62.useState)([]);
    const [purposeOptions, setPurposeOptions] = (0, $acw62.useState)([]);
    const [processingActivityOptions, setProcessingActivityOptions] = (0, $acw62.useState)([]);
    const [purposeList, setPurposeList] = (0, $acw62.useState)([]);
    //branding states
    const [fileName, setFileName] = (0, $acw62.useState)("");
    const [certificatePreviewUrl, setCertificatePreviewUrl] = (0, $acw62.useState)("");
    const fileInputRef = (0, $acw62.useRef)(null);
    const [fileBase64, setFileBase64] = (0, $acw62.useState)(null);
    const [logoPreviewUrl, setLogoPreviewUrl] = (0, $acw62.useState)("");
    const [logoName, setLogoName] = (0, $acw62.useState)("");
    const logoInputRef = (0, $acw62.useRef)(null);
    const [logoBase64, setLogoBase64] = (0, $acw62.useState)("");
    const [fileSize, setFileSize] = (0, $acw62.useState)(0);
    const [darkMode, setDarkMode] = (0, $acw62.useState)(false);
    const [mobileView, setMobileView] = (0, $acw62.useState)(true);
    const [parentalControl, setParentalControl] = (0, $acw62.useState)(true);
    const [dataTypeToBeShown, setDataTypeToBeShown] = (0, $acw62.useState)(true);
    const [dataItemToBeShown, setDataItemToBeShown] = (0, $acw62.useState)(true);
    const [processActivityNameToBeShown, setProcessActivityNameToBeShown] = (0, $acw62.useState)(true);
    const [processorNameToBeShown, setProcessorNameToBeShown] = (0, $acw62.useState)(true);
    const [validitytoBeShown, setValiditytoBeShown] = (0, $acw62.useState)(true);
    const [colors, setColors] = (0, $acw62.useState)({
        cardBackground: "#FFFFFF",
        cardFont: "#000000",
        buttonBackground: "#0F3CC9",
        buttonFont: "#FFFFFF",
        linkFont: "#0A2885"
    });
    const [darkColors, setDarkColors] = (0, $acw62.useState)({
        cardBackground: "#000000",
        cardFont: "#FFFFFF",
        buttonBackground: "#FFFFFF",
        buttonFont: "#0F3CC9",
        linkFont: "#0A2885"
    });
    const activePopupColors = darkMode ? darkColors : colors;
    const [languageContent, setLanguageContent] = (0, $acw62.useState)({
        ENGLISH: {
            description: "sample description",
            label: "Required",
            rightsText: "sample rights text",
            permissionText: "sample permission text"
        }
    });
    const lightString = JSON.stringify(colors);
    const darkString = JSON.stringify(darkColors);
    const themeObj = {
        light: lightString,
        ...darkString ? {
            dark: darkString
        } : {}
    };
    // Convert to JSON string
    const themeJson = JSON.stringify(themeObj);
    // Convert JSON string → Base64
    const themeBase64 = btoa(themeJson);
    const addPurpose = ()=>{
        setPurposeItems([
            ...purposeItems,
            counter
        ]);
        setCounter(counter + 1);
        setPurposes([
            ...purposes,
            {
                purposeIds: [],
                isMandatory: "",
                autoRenew: "",
                preferenceValidity: {
                    value: "1",
                    unit: ""
                },
                purposeActivityIds: [],
                usedBy: [],
                dataItems: []
            }
        ]);
    };
    const removePurpose = (id, index)=>{
        if (purposeItems.length === 1) return;
        setPurposeItems(purposeItems.filter((item)=>item !== id));
        setPurposes(purposes.filter((_, i)=>i !== index));
    };
    const handleBack = ()=>{
        navigate("/integrationGrievanceRequests");
    };
    const buildPayload = (purposes)=>{
        return purposes.map((p)=>({
                purposeIds: p.purposeIds,
                mandatory: p.isMandatory === "Required",
                autoRenew: p.autoRenew === "Yes",
                preferenceValidity: p.preferenceValidity,
                processorActivityIds: p.purposeActivityIds,
                preferenceStatus: "ACCEPTED"
            }));
    };
    const openCertificate = (certificatePreviewUrl)=>{
        if (certificatePreviewUrl) window.open(certificatePreviewUrl, "_blank");
    };
    const [finalPayload, setFinalPayload] = (0, $acw62.useState)([]);
    const [showSuccessTick, setShowSuccessTick] = (0, $acw62.useState)(false);
    const handlePublish = async ()=>{
        const errors = [];
        // --- 1. Grievance Type ---
        if (!selectedGrievanceType) errors.push("Please select a Grievance Category.");
        // --- 2. Grievance Detail/Sub-category ---
        if (selectedGrievanceType && !selectedDetail) errors.push("Please select a Grievance Sub-Category.");
        // --- 3. Description ---
        if (grievanceFormTemplate?.multilingual?.descriptionCheck && !grievanceDesc.trim()) errors.push("Please enter Description.");
        // --- 4. User Type ---
        if (grievanceFormTemplate?.multilingual.userInformation[0]?.userType?.length > 0 && !selectedUserType) errors.push("Please select a User Type.");
        // --- 5. User Item inputs ---
        if (grievanceFormTemplate?.multilingual.userInformation[0]?.userItems?.length > 0) grievanceFormTemplate?.multilingual.userInformation[0].userItems.forEach((item)=>{
            if (!userDetailInputs[item] || userDetailInputs[item].trim() === "") errors.push(`Please enter ${item}.`);
        });
        // --- 6. Upload File ---
        if (grievanceFormTemplate?.multilingual.uploadFiles && !uploadFileName) errors.push("Please upload a supporting document.");
        // --- Show Toast if errors exist ---
        if (errors.length > 1) {
            (0, $b00d3e7401eac195$export$b410431fab84fa58).error((props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482ccd6e8e9b33b1$export$2e2bcd8739ae039), {
                    ...props,
                    type: "error",
                    message: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                        style: {
                            margin: 0
                        },
                        children: errors.map((err, idx)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                children: err
                            }, idx))
                    })
                }), {
                icon: false
            });
            return;
        } else if (errors.length === 1) {
            (0, $b00d3e7401eac195$export$b410431fab84fa58).error((props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482ccd6e8e9b33b1$export$2e2bcd8739ae039), {
                    ...props,
                    type: "error",
                    message: errors[0]
                }), {
                icon: false
            });
            return;
        } else {
            // Format grievance information (if needed for later use)
            const formattedGrievanceInformation = Object.entries(grievanceFormTemplate?.grievances || {}).map(([grievanceType, grievanceItems])=>({
                    grievanceType: grievanceType,
                    grievanceItems: grievanceItems
                }));
            // --- Build userDetails object ---
            const userDetails = grievanceFormTemplate?.multilingual?.userInformation?.[0]?.userItems?.reduce((acc, label)=>{
                // Normalize to uppercase and underscore format like backend expects
                // const key = label.toUpperCase().replace(/\s+/g, "_");
                const key = label;
                acc[key] = userDetailInputs[label] || "";
                return acc;
            }, {});
            // --- Final request body ---
            const body = {
                userType: selectedUserType || "",
                grievanceType: selectedGrievanceType || "",
                grievanceDetail: selectedDetail || "",
                userDetails: userDetails,
                grievanceDescription: grievanceDesc || "",
                supportingDocs: uploadFileName ? [
                    {
                        docName: uploadFileName,
                        doc: uploadFileBase64
                    }
                ] : []
            };
            const res = await dispatch((0, $6eea01a75b53fee5$export$499d1caee87874d7)({
                grievanceTemplateId: grievanceFormTemplate.grievanceTemplateId,
                body: body,
                tenantId: tenantId,
                businessId: businessId,
                secureCode: secureCode
            }));
            if (res?.status === 201) {
                (0, $b00d3e7401eac195$export$b410431fab84fa58).success((props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $482ccd6e8e9b33b1$export$2e2bcd8739ae039), {
                        ...props,
                        type: "success",
                        message: "Grievance Request Raised Succesfully!"
                    }), {
                    icon: false
                });
                setShowSuccessTick(true);
            }
        // toast.success(
        //   (props) => (
        //     <CustomToast
        //       {...props}
        //       type="success"
        //       message={"Grievance Request Saved Succesfully!"}
        //     />
        //   ),
        //   { icon: false }
        // );
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "page-container",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "main-content",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "right-half",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "preview-header",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "header-right",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "popup-mobile",
                                    style: {
                                        backgroundColor: activePopupColors.cardBackground,
                                        color: activePopupColors.cardFont
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "popup-header",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    style: {
                                                        display: "flex",
                                                        flexDirection: "row",
                                                        gap: "20px",
                                                        alignItems: "center"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                                            className: "custom-head",
                                                            style: {
                                                                backgroundColor: activePopupColors.cardBackground,
                                                                color: activePopupColors.cardFont
                                                            },
                                                            children: title ? title : "Register your grievance"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$353f5b6fc5456de1), {
                                                            ariaControls: "Button Clickable",
                                                            ariaDescribedby: "Button",
                                                            ariaExpanded: "Expanded",
                                                            ariaLabel: "Button",
                                                            className: "Button",
                                                            icon: "ic_chevron_down",
                                                            iconLeft: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab6d9bfa47542205$export$28390bfec38e5c4f), {}),
                                                            iconAriaLabel: "Icon Favorite",
                                                            kind: "secondary",
                                                            label: "English",
                                                            size: "small",
                                                            state: "normal"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    src: logoPreviewUrl,
                                                    alt: "Logo",
                                                    style: {
                                                        width: mobile ? "28px" : "40px",
                                                        height: mobile ? "28px" : "40px",
                                                        marginLeft: mobile ? "5px" : "10px"
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "popup-body",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "custom-text-p",
                                                    style: {
                                                        backgroundColor: activePopupColors.cardBackground,
                                                        color: activePopupColors.cardFont,
                                                        marginBottom: "8px",
                                                        fontSize: "14px",
                                                        letterSpacing: "-0.5px",
                                                        color: "rgba(0, 0, 0, 0.65)",
                                                        fontWeight: "500"
                                                    },
                                                    children: text ? text : "Please provide the following details to register your grievance."
                                                }),
                                                grievanceFormTemplate?.multilingual?.grievanceInformation?.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            style: {
                                                                marginBottom: "10px"
                                                            },
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                                appearance: "heading-xxs",
                                                                color: "primary-grey-80",
                                                                children: grievanceDetailsHeading
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "dropdown-group",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                    children: grievanceCategoryLabel
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                                    value: selectedGrievanceType,
                                                                    onChange: (e)=>{
                                                                        const newType = e.target.value;
                                                                        setSelectedGrievanceType(newType);
                                                                        setSelectedDetail("");
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                            value: "",
                                                                            disabled: true,
                                                                            children: selectCategoryPlaceholder
                                                                        }),
                                                                        grievanceFormTemplate?.multilingual.grievanceInformation.map((info, idx)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                                value: info.grievanceType,
                                                                                children: info.grievanceType
                                                                            }, idx))
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        selectedGrievanceType && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "dropdown-group",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                    htmlFor: `grievanceTypeSelect`,
                                                                    children: grievanceSubCategoryLabel
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                                    id: `grievanceTypeSelect`,
                                                                    value: selectedDetail,
                                                                    onChange: (e)=>setSelectedDetail(e.target.value),
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                            value: "",
                                                                            disabled: true,
                                                                            children: subCategoryPlaceholder
                                                                        }),
                                                                        (grievanceFormTemplate?.multilingual.grievanceInformation.find((info)=>info.grievanceType === selectedGrievanceType)?.grievanceItems || []).map((item, idx)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                                value: item,
                                                                                children: item
                                                                            }, idx))
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                grievanceFormTemplate?.multilingual?.descriptionCheck && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "dropdown-group",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                            children: descriptionLabel
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                                            placeholder: descriptionPlaceholder,
                                                            value: grievanceDesc,
                                                            onChange: handleTextAreaChange,
                                                            rows: "3",
                                                            className: "custom-text-area"
                                                        })
                                                    ]
                                                }),
                                                (grievanceFormTemplate?.multilingual?.userInformation[0]?.userType?.length > 0 || grievanceFormTemplate?.multilingual?.userInformation[0]?.userItems?.length > 0) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                    appearance: "heading-xxs",
                                                    color: "primary-grey-80",
                                                    children: userDetailsHeading
                                                }),
                                                grievanceFormTemplate?.multilingual?.userInformation[0]?.userType && grievanceFormTemplate?.multilingual?.userInformation[0]?.userType.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "dropdown-group",
                                                    style: {
                                                        marginBottom: "0px"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                            children: userTypeLabel
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                            value: selectedUserType,
                                                            onChange: (e)=>setSelectedUserType(e.target.value),
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                    value: "",
                                                                    disabled: true,
                                                                    children: userTypePlaceholder
                                                                }),
                                                                grievanceFormTemplate?.multilingual?.userInformation[0]?.userType.map((type, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                        value: type,
                                                                        children: type
                                                                    }, index))
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                grievanceFormTemplate?.multilingual?.userInformation?.[0]?.userItems?.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    children: grievanceFormTemplate?.multilingual?.userInformation[0]?.userItems.map((detailName, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            style: {
                                                                padding: "10px 0px"
                                                            },
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "systemConfig-input",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                        style: {
                                                                            display: "block",
                                                                            fontSize: "13px",
                                                                            fontWeight: "600",
                                                                            fontFamily: "Arial, sans-serif",
                                                                            marginBottom: "5px",
                                                                            color: "#767676"
                                                                        },
                                                                        children: `${detailName} (${requiredLable})`
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                        type: "text",
                                                                        value: userDetailInputs[detailName] || "",
                                                                        onChange: (e)=>setUserDetailInputs({
                                                                                ...userDetailInputs,
                                                                                [detailName]: e.target.value
                                                                            }),
                                                                        placeholder: `${enterLable} ${detailName.toLowerCase()}`,
                                                                        style: {
                                                                            width: "100%",
                                                                            padding: "10px 12px",
                                                                            border: "1px solid #ccc",
                                                                            borderRadius: "8px",
                                                                            fontSize: "14px",
                                                                            fontWeight: 400,
                                                                            color: "rgba(20, 20, 20, 1)",
                                                                            outline: "none",
                                                                            fontFamily: "Arial, sans-serif"
                                                                        }
                                                                    })
                                                                ]
                                                            })
                                                        }, index))
                                                }),
                                                grievanceFormTemplate?.multilingual?.uploadFiles && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                                appearance: "heading-xxs",
                                                                color: "primary-grey-80",
                                                                children: uploadFilesHeading
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            style: {
                                                                marginBottom: "20px"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    className: "fileUploader-custom1",
                                                                    onClick: handleUploadFilesClick,
                                                                    onDragOver: handleUploadFilesDragOver,
                                                                    onDragLeave: handleUploadFilesDragLeave,
                                                                    onDrop: handleUploadFilesDrop,
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                            type: "file",
                                                                            ref: uploadFileInputRef,
                                                                            style: {
                                                                                display: "none"
                                                                            },
                                                                            onChange: handleUploadFilieChange,
                                                                            accept: ".pdf,.doc,.docx"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                            className: "flex items-center justify-center",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$f04a61298a47a40f), {
                                                                                    ic: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $170225ee6a03579c$export$7a525547346e73a), {
                                                                                        height: 23,
                                                                                        width: 23
                                                                                    }),
                                                                                    color: "primary_60"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                                                    appearance: "button",
                                                                                    color: "primary-60",
                                                                                    children: uploadButtonText
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                    style: {},
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                                        appearance: "body-xs",
                                                                        color: "primary-grey-80",
                                                                        children: uploadInstruction
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                uploadFileName && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "systemConfiguration-file-uploader",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            onClick: handlePreviewUploadFile,
                                                            className: "previewFile",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "iconandText",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$f04a61298a47a40f), {
                                                                        ic: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5a00847d48e39b4f$export$13b8539f4be0c), {
                                                                            width: 15,
                                                                            height: 15
                                                                        }),
                                                                        color: "feedback_success_50"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                                        appearance: "body-xs",
                                                                        color: "primary-grey-80",
                                                                        children: uploadFileName
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$f04a61298a47a40f), {
                                                            ic: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4b407a2b367f43e3$export$48672c81f0c3f574), {
                                                                width: 15,
                                                                height: 15
                                                            }),
                                                            color: "primary_60",
                                                            className: "selecetd-file-display",
                                                            onClick: handleRemoveUploadFile
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: `popup-button ${mobile ? "popup-button-mobile" : ""}`,
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {},
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$cfc7921d29ef7b80), {
                                                    kind: "primary",
                                                    size: "medium",
                                                    state: "normal",
                                                    label: "Submit Request",
                                                    onClick: handlePublish
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    }),
                    showSuccessTick && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "Integrationoverlay",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "success-icon",
                            children: "\u2714"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b00d3e7401eac195$export$f2815235e76a62b9), {
                position: "bottom-left",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                closeButton: false,
                toastClassName: ()=>"toast-wrapper",
                transition: (0, $b00d3e7401eac195$export$d8dc01b5c85a37b9)
            })
        ]
    });
};
var $d9216057e8fe75fb$export$2e2bcd8739ae039 = $d9216057e8fe75fb$var$IntegrationCreateRequest;







var $acw62 = parcelRequire("acw62");








var $acw62 = parcelRequire("acw62");




const $6c478d1ca3813b9b$var$StarIntegrationRating = ({ grievanceId: grievanceId, initialRating: initialRating, readOnly: readOnly = false })=>{
    const [rating, setRating] = (0, $acw62.useState)(initialRating || 0);
    const [hover, setHover] = (0, $acw62.useState)(0);
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    (0, $acw62.useEffect)(()=>{
        setRating(initialRating || 0);
    }, [
        initialRating
    ]);
    const handleRatingClick = async (newRating)=>{
        if (readOnly) return;
        setRating(newRating);
        try {
            await dispatch((0, $6eea01a75b53fee5$export$494cd92f20bd53b8)({
                grievanceId: grievanceId,
                newRating: newRating
            }));
        } catch (error) {
            console.error("Error updating rating:", error);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center"
        },
        children: Array.from({
            length: 5
        }, (_, i)=>{
            const starNumber = i + 1;
            const isFilled = starNumber <= (hover || rating);
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                onMouseEnter: ()=>!readOnly && setHover(starNumber),
                onMouseLeave: ()=>!readOnly && setHover(0),
                onClick: ()=>handleRatingClick(starNumber),
                style: {
                    display: "inline-block",
                    marginRight: 2,
                    cursor: readOnly ? "default" : "pointer"
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$f04a61298a47a40f), {
                    ic: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eaaa4115f4b10cc9$export$e5c12eca07fe7b2d), {}),
                    size: "m",
                    color: isFilled ? "primary_blue" : "primary_grey_60",
                    style: {
                        opacity: isFilled ? 1 : 0.4,
                        transition: "opacity 0.2s ease"
                    }
                })
            }, starNumber);
        })
    });
};
var $6c478d1ca3813b9b$export$2e2bcd8739ae039 = $6c478d1ca3813b9b$var$StarIntegrationRating;



const $0ebe88db37548d3d$var$IntegrationGrievanceRequests = ()=>{
    const [loadLogs, setLoadLogs] = (0, $acw62.useState)(true);
    const [expandedRow, setExpandedRow] = (0, $acw62.useState)(null);
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const [grievanceData, setGrievanceData] = (0, $acw62.useState)([]);
    const [resolvedCount, setResolvedCount] = (0, $acw62.useState)(0);
    const [inProgressCount, setInProgressCount] = (0, $acw62.useState)(0);
    const [newCount, setNewCount] = (0, $acw62.useState)(0);
    const integration_tenant_id = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.common.integration_tenant_id);
    const integration_business_id = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.common.integration_business_id);
    const integration_grievanceTemplate_id = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.common.integration_grievanceTemplate_id);
    // Translation inputs for static text
    const translationInputs = (0, $acw62.useMemo)(()=>[
            {
                id: "int_requests_title",
                source: "Requests"
            },
            {
                id: "int_requests_badge",
                source: "Grievance redressal"
            },
            {
                id: "int_requests_raise_new",
                source: "Raise new request"
            },
            {
                id: "int_requests_new",
                source: "New"
            },
            {
                id: "int_requests_in_process",
                source: "In Process"
            },
            {
                id: "int_requests_resolved",
                source: "Resolved"
            },
            {
                id: "int_requests_grievance_id",
                source: "Grievance ID"
            },
            {
                id: "int_requests_date_submitted",
                source: "Date submitted"
            },
            {
                id: "int_requests_last_updated",
                source: "Last updated"
            },
            {
                id: "int_requests_grievance_type",
                source: "Grievance type"
            },
            {
                id: "int_requests_remarks",
                source: "Remarks"
            },
            {
                id: "int_requests_status",
                source: "Status"
            },
            {
                id: "int_requests_actions",
                source: "Actions"
            },
            {
                id: "int_requests_feedback",
                source: "Feedback"
            },
            {
                id: "int_requests_no_data",
                source: "No Data to Display"
            }
        ], []);
    // Use translation hook
    const { getTranslation: getTranslation, translateContent: translateContent, currentLanguage: currentLanguage } = (0, $dbe8cedc9e1aa4ce$export$2e2bcd8739ae039)(translationInputs);
    // Translate content when language changes
    (0, $acw62.useEffect)(()=>{
        if (currentLanguage !== "ENGLISH") translateContent(translationInputs, currentLanguage);
    }, [
        currentLanguage,
        translationInputs,
        translateContent
    ]);
    const params = new URLSearchParams(window.location.search);
    const encodedData = params.get("data");
    let tenantId = "";
    let businessId = "";
    let grievanceTemplateId = "";
    if (encodedData) try {
        const decoded = atob(encodedData);
        const parsed = JSON.parse(decoded);
        tenantId = parsed.tenantId || "";
        businessId = parsed.businessId || "";
        grievanceTemplateId = parsed.grievanceTemplateId || "";
    } catch (err) {
        console.log("Error decoding Base64 data param:", err);
    }
    tenantId = tenantId || integration_tenant_id;
    businessId = businessId || integration_business_id;
    grievanceTemplateId = grievanceTemplateId || integration_grievanceTemplate_id;
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const createGrievanceRequest = ()=>{
        navigate("/integrationCreateRequest");
    };
    (0, $acw62.useEffect)(()=>{
        const fetchData = async ()=>{
            try {
                const searchList = await dispatch((0, $6eea01a75b53fee5$export$14b19d7002b6d302)(tenantId, businessId, grievanceTemplateId));
                if (searchList.status === 200) {
                    const data = [
                        ...searchList?.data?.data || []
                    ].reverse();
                    const resolved = data.filter((item)=>item.status === (0, $dee2f92127058cd3$export$f21702b540d6bf35).GRIEVANCE_RESOLVED).length;
                    const inProgress = data.filter((item)=>item.status === (0, $dee2f92127058cd3$export$f21702b540d6bf35).GRIEVANCE_INPROCESS).length;
                    const newReqCount = data.filter((item)=>item.status === (0, $dee2f92127058cd3$export$f21702b540d6bf35).NEW).length;
                    // Update states
                    setResolvedCount(resolved);
                    setInProgressCount(inProgress);
                    setNewCount(newReqCount);
                    setGrievanceData(data);
                }
            } catch (err) {
                console.log("Error occured in getConsentsByTemplateId", err);
                if (err?.[0]?.errorCode === "JCMP3001") setGrievanceData([]);
            } finally{
                setLoadLogs(false);
            }
        };
        fetchData();
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "pageConfig",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "fiduciaryHeaderContainer",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "fiduciaryHeader",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                    appearance: "heading-s",
                                    color: "primary-grey-100",
                                    children: "Requests"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "badge",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                        appearance: "body-xs-bold",
                                        color: "primary-grey-80",
                                        children: "Grievance redressal"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "requestsButtonContainer",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$cfc7921d29ef7b80), {
                                kind: "primary",
                                size: "large",
                                label: "Raise new request",
                                onClick: createGrievanceRequest
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        display: "flex",
                        alignItems: "center",
                        gap: "1rem",
                        marginTop: "2rem",
                        marginBottom: "2rem"
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: {
                                width: "214px",
                                height: "90px",
                                backgroundColor: "rgba(245, 245, 245, 1)",
                                borderRadius: "12px",
                                display: "flex",
                                gap: "0.5rem",
                                alignItems: "center"
                            },
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    paddingTop: "1rem",
                                    paddingLeft: "1rem",
                                    paddingBottom: "1rem",
                                    gap: "0.5rem",
                                    alignItems: "center"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f2a56b92690f077c$export$556fe0871d9b7899), {
                                        height: 35,
                                        width: 35
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "flex-start"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                appearance: "body-xs-bold",
                                                color: "primary-grey-100",
                                                children: newCount || "0"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                appearance: "body-xs",
                                                color: "primary-grey-80",
                                                children: "New"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: {
                                width: "214px",
                                height: "90px",
                                backgroundColor: "rgba(231, 235, 248, 1)",
                                borderRadius: "12px",
                                display: "flex",
                                gap: "0.5rem",
                                alignItems: "center"
                            },
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    paddingTop: "1rem",
                                    paddingLeft: "1rem",
                                    paddingBottom: "1rem",
                                    gap: "0.5rem",
                                    alignItems: "center"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$f04a61298a47a40f), {
                                        ic: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8c66bf8a36364e42$export$7f3df200d95b839b), {
                                            height: 35,
                                            width: 35
                                        }),
                                        color: "primary_60",
                                        size: "large"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "flex-start"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                appearance: "body-xs-bold",
                                                color: "primary-grey-100",
                                                children: inProgressCount || "0"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                appearance: "body-xs",
                                                color: "primary-grey-80",
                                                children: "In Process"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: {
                                width: "214px",
                                height: "90px",
                                backgroundColor: "rgba(233, 247, 233, 1)",
                                borderRadius: "12px",
                                display: "flex",
                                alignItems: "center"
                            },
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    paddingTop: "1rem",
                                    paddingLeft: "1rem",
                                    paddingBottom: "1rem",
                                    alignItems: "center",
                                    gap: "0.5rem"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dd949b1a0491130c$export$50c1b72d39add9), {
                                        height: 35,
                                        width: 35
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "flex-start"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                appearance: "body-xs-bold",
                                                color: "primary-grey-100",
                                                children: resolvedCount || "0"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                appearance: "body-xs",
                                                color: "primary-grey-80",
                                                children: "Resolved"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    style: {
                        overflowX: "auto"
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                        className: "consentLog-table",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "parentheader",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "header-with-icon",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                        appearance: "body-xs-bold",
                                                        color: "primary-grey-80",
                                                        children: "Grievance ID"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$f04a61298a47a40f), {
                                                        ic: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c07aaad5de81ca37$export$d802d08b192014d8), {}),
                                                        color: "primary_60",
                                                        size: "small"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "parentheader",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "header-with-icon",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                        appearance: "body-xs-bold",
                                                        color: "primary-grey-80",
                                                        children: "Date submitted"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$f04a61298a47a40f), {
                                                        ic: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c07aaad5de81ca37$export$d802d08b192014d8), {}),
                                                        color: "primary_60",
                                                        size: "small"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "parentheader",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "header-with-icon",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                        appearance: "body-xs-bold",
                                                        color: "primary-grey-80",
                                                        children: "Last updated"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$f04a61298a47a40f), {
                                                        ic: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c07aaad5de81ca37$export$d802d08b192014d8), {}),
                                                        color: "primary_60",
                                                        size: "small"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "parentheader",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "header-with-icon",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                        appearance: "body-xs-bold",
                                                        color: "primary-grey-80",
                                                        children: "Grievance type"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$f04a61298a47a40f), {
                                                        ic: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c07aaad5de81ca37$export$d802d08b192014d8), {}),
                                                        color: "primary_60",
                                                        size: "small"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "parentheader",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "header-with-icon",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                    appearance: "body-xs-bold",
                                                    color: "primary-grey-80",
                                                    children: "Remarks"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "parentheader",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "header-with-icon",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                        appearance: "body-xs-bold",
                                                        color: "primary-grey-80",
                                                        children: "Status"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$f04a61298a47a40f), {
                                                        ic: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c07aaad5de81ca37$export$d802d08b192014d8), {}),
                                                        color: "primary_60",
                                                        size: "small"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "parentheader",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "header-with-icon",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                    appearance: "body-xs-bold",
                                                    color: "primary-grey-80",
                                                    children: "Actions"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                            className: "parentheader",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "header-with-icon",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                    appearance: "body-xs-bold",
                                                    color: "primary-grey-80",
                                                    children: "Feedback"
                                                })
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                children: loadLogs ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        colSpan: "6",
                                        style: {
                                            textAlign: "center",
                                            padding: "1rem"
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "customerActivityLoader",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$7f7cbe89f1eacd2), {
                                                kind: "normal",
                                                labelPosition: "right",
                                                size: "small"
                                            })
                                        })
                                    })
                                }) : !Array.isArray(grievanceData) || grievanceData.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        colSpan: "6",
                                        style: {
                                            textAlign: "center",
                                            padding: "1rem"
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                            appearance: "body-xs-bold",
                                            color: "primary-grey-80",
                                            children: "No Data to Display"
                                        })
                                    })
                                }) : Array.isArray(grievanceData) && grievanceData?.map((grievance, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        className: expandedRow === `row${index}` ? "expanded-row-parent" : "",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                style: {
                                                    textAlign: "left"
                                                },
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                    appearance: "body-xs",
                                                    color: "primary-grey-100",
                                                    children: grievance.grievanceId || ""
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                    appearance: "body-xs",
                                                    color: "primary-grey-100",
                                                    children: grievance.createdAt || ""
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                    appearance: "body-xs",
                                                    color: "primary-grey-100",
                                                    children: grievance.updatedAt || ""
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                    appearance: "body-xs",
                                                    color: "primary-grey-100",
                                                    children: grievance.grievanceType || ""
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                                    appearance: "body-xs",
                                                    color: "primary-grey-100",
                                                    children: grievance.grievanceDescription || ""
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    style: {
                                                        display: "inline-block",
                                                        fontWeight: "700",
                                                        fontSize: "14px",
                                                        lineHeight: "24px",
                                                        borderRadius: "6px",
                                                        padding: "0 10px",
                                                        textAlign: "center",
                                                        whiteSpace: "nowrap",
                                                        ...grievance?.status === (0, $dee2f92127058cd3$export$f21702b540d6bf35).GRIEVANCE_L1_ESCALATED || grievance?.status === (0, $dee2f92127058cd3$export$f21702b540d6bf35).GRIEVANCE_L2_ESCALATED ? {
                                                            backgroundColor: "rgba(255, 242, 236, 1)",
                                                            color: "rgba(245, 0, 49, 1)"
                                                        } : grievance?.status === (0, $dee2f92127058cd3$export$f21702b540d6bf35).GRIEVANCE_RESOLVED ? {
                                                            backgroundColor: "rgba(233, 247, 233, 1)",
                                                            color: "rgba(19, 86, 16, 1)"
                                                        } : grievance?.status === (0, $dee2f92127058cd3$export$f21702b540d6bf35).GRIEVANCE_INPROCESS ? {
                                                            backgroundColor: "rgba(231, 235, 248, 1)",
                                                            color: "rgba(10, 40, 133, 1)"
                                                        } : {
                                                            backgroundColor: "#f1f1f1",
                                                            color: "#333"
                                                        }
                                                    },
                                                    children: grievance.status || ""
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35aa9dff24458a00$export$fd7adc84612ab6c3), {
                                                    height: 20,
                                                    width: 20,
                                                    style: {
                                                        cursor: "pointer"
                                                    },
                                                    onClick: ()=>grievance?.grievanceId && navigate(`/integrationGrievanceRequests/${grievance.grievanceId}`)
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                style: {
                                                    whiteSpace: "nowrap"
                                                },
                                                children: grievance.status === (0, $dee2f92127058cd3$export$f21702b540d6bf35).GRIEVANCE_RESOLVED && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6c478d1ca3813b9b$export$2e2bcd8739ae039), {
                                                    initialRating: grievance.feedback || 0,
                                                    readOnly: false,
                                                    grievanceId: grievance.grievanceId
                                                })
                                            })
                                        ]
                                    }, grievance?.grievanceId || `grievance-${index}`))
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var $0ebe88db37548d3d$export$2e2bcd8739ae039 = $0ebe88db37548d3d$var$IntegrationGrievanceRequests;


const $1ea0bcfb5b0a50ad$var$Nav = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7939e29d663dd3ed$export$3565eb3d00ca5a74), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                path: "/",
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $164dc338fd404bfa$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                path: "/requests",
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bc816806ba2f8e50$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                path: "/createRequest",
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $106ac01a8584f523$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                path: "/requests/:grievanceId",
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f71dd81b43a79c0d$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                path: "/systemRequests",
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2e1c888804f61777$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                path: "/app-documents",
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0646ab069e0ffc07$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                path: "/integrationGrievanceRequests",
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0ebe88db37548d3d$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                path: "/integrationCreateRequest",
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d9216057e8fe75fb$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                path: "/integrationGrievanceRequests/:grievanceId",
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f09704f440a7e179$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $1ea0bcfb5b0a50ad$export$2e2bcd8739ae039 = $1ea0bcfb5b0a50ad$var$Nav;




parcelRequire("acw62");






const $355f3e6615574795$var$FooterComponent = ()=>{
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const path = location.pathname;
    const portalTheme = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.common.portal_theme);
    const footerBg = portalTheme?.colors?.cardBackground ? undefined : "rgba(245, 245, 245, 1)";
    const footerStyle = {
        height: portalTheme?.privacyText ? "auto" : "55px",
        minHeight: "55px",
        backgroundColor: portalTheme?.colors?.cardBackground ? "var(--portal-header-bg, rgba(245, 245, 245, 1))" : footerBg,
        color: portalTheme?.colors?.cardFont || undefined,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        paddingLeft: "3rem",
        paddingRight: "3rem",
        paddingTop: portalTheme?.privacyText ? "10px" : undefined,
        paddingBottom: portalTheme?.privacyText ? "10px" : undefined,
        gap: "12px",
        flexWrap: "wrap"
    };
    const openalert = ()=>{};
    // Hide footer on specific routes
    if (path === "/adminLogin" || path === "/app-documents" || path.startsWith("/home")) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8bd3c5c9ee0d1eb4$export$e5cf4eff53e7947d), {
        value: {
            theme: "JioBase",
            mode: "light"
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "app-footer",
            style: footerStyle,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "app-footer-brand",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc7e21f78fe2b481$export$faf9e552d710fc5c), {
                            height: 25,
                            width: 25,
                            color: "primary"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                    color: "primary-grey-80",
                                    appearance: "body-xs",
                                    children: "Copyright \xa9 2025 Jio Platforms Limited. All rights reserved."
                                }),
                                portalTheme?.privacyText ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                    color: "primary-grey-80",
                                    appearance: "body-xs",
                                    style: {
                                        display: "block",
                                        marginTop: "4px"
                                    },
                                    children: portalTheme.privacyText
                                }) : null
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "app-footer-links",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                            color: "primary-grey-80",
                            appearance: "body-xs",
                            style: {
                                cursor: "pointer"
                            },
                            children: "Regulatory"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: {
                                backgroundColor: "rgba(224, 224, 224, 1)",
                                height: "16px",
                                width: "1px"
                            }
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                            color: "primary-grey-80",
                            appearance: "body-xs",
                            style: {
                                cursor: "pointer"
                            },
                            children: "Policies"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: {
                                backgroundColor: "rgba(224, 224, 224, 1)",
                                height: "16px",
                                width: "1px"
                            }
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                            color: "primary-grey-80",
                            appearance: "body-xs",
                            style: {
                                cursor: "pointer"
                            },
                            children: "Terms & Conditions"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: {
                                backgroundColor: "rgba(224, 224, 224, 1)",
                                height: "16px",
                                width: "1px"
                            }
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            onClick: openalert,
                            style: {
                                cursor: "pointer"
                            },
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                                color: "primary-grey-80",
                                appearance: "body-xs",
                                children: "Help & Support"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $355f3e6615574795$export$2e2bcd8739ae039 = $355f3e6615574795$var$FooterComponent;








// Language options with API values for Bhashini translation
const $4661258b4f20c3cd$var$LANGUAGE_OPTIONS = [
    {
        value: "ENGLISH",
        label: "English",
        apiValue: "en"
    },
    {
        value: "HINDI",
        label: "\u0939\u093F\u0902\u0926\u0940",
        apiValue: "hi"
    },
    {
        value: "BENGALI",
        label: "\u09AC\u09BE\u0982\u09B2\u09BE",
        apiValue: "bn"
    },
    {
        value: "TAMIL",
        label: "\u0BA4\u0BAE\u0BBF\u0BB4\u0BCD",
        apiValue: "ta"
    },
    {
        value: "TELUGU",
        label: "\u0C24\u0C46\u0C32\u0C41\u0C17\u0C41",
        apiValue: "te"
    },
    {
        value: "KANNADA",
        label: "\u0C95\u0CA8\u0CCD\u0CA8\u0CA1",
        apiValue: "kn"
    },
    {
        value: "MALAYALAM",
        label: "\u0D2E\u0D32\u0D2F\u0D3E\u0D33\u0D02",
        apiValue: "ml"
    },
    {
        value: "GUJARATI",
        label: "\u0A97\u0AC1\u0A9C\u0AB0\u0ABE\u0AA4\u0AC0",
        apiValue: "gu"
    },
    {
        value: "MARATHI",
        label: "\u092E\u0930\u093E\u0920\u0940",
        apiValue: "mr"
    },
    {
        value: "ODIA",
        label: "\u0B13\u0B21\u0B3C\u0B3F\u0B06",
        apiValue: "or"
    },
    {
        value: "PUNJABI",
        label: "\u0A2A\u0A70\u0A1C\u0A3E\u0A2C\u0A40",
        apiValue: "pa"
    },
    {
        value: "ASSAMESE",
        label: "\u0985\u09B8\u09AE\u09C0\u09AF\u09BC\u09BE",
        apiValue: "as"
    },
    {
        value: "NEPALI",
        label: "\u0928\u0947\u092A\u093E\u0932\u0940",
        apiValue: "ne"
    },
    {
        value: "SINDHI",
        label: "\u0633\u0646\u068C\u064A",
        apiValue: "sd"
    },
    {
        value: "KASHMIRI",
        label: "\u0915\u0949\u0936\u0941\u0930",
        apiValue: "ks"
    },
    {
        value: "DOGRI",
        label: "\u0921\u094B\u0917\u0930\u0940",
        apiValue: "doi"
    },
    {
        value: "KONKANI",
        label: "\u0915\u094B\u0902\u0915\u0923\u0940",
        apiValue: "gom"
    },
    {
        value: "MAITHILI",
        label: "\u092E\u0948\u0925\u093F\u0932\u0940",
        apiValue: "mai"
    },
    {
        value: "SANSKRIT",
        label: "\u0938\u0902\u0938\u094D\u0915\u0943\u0924",
        apiValue: "sa"
    },
    {
        value: "SANTALI",
        label: "\u1C65\u1C5F\u1C71\u1C5B\u1C5F\u1C72\u1C64",
        apiValue: "sat"
    },
    {
        value: "BODO",
        label: "\u092C\u0921\u093C\u094B",
        apiValue: "brx"
    },
    {
        value: "MANIPURI",
        label: "\u09AE\u09C8\u09A4\u09C8\u09B2\u09CB\u09A8\u09CD",
        apiValue: "mni"
    }
];
const $4661258b4f20c3cd$var$HeaderComponent = ({ showMobileNavToggle: showMobileNavToggle = false, mobileNavOpen: mobileNavOpen = false, onMobileNavToggle: onMobileNavToggle })=>{
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const businessName = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.common.business_name);
    const businessLogo = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.common.business_logo);
    const portalTheme = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.common.portal_theme);
    console.log("Business Logo in Header:", businessLogo);
    const currentLanguage = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.common.currentLanguage);
    const companyName = portalTheme?.companyName && String(portalTheme.companyName).trim() || "Company Name";
    const initials = businessName ? businessName.charAt(0).toUpperCase() : "";
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const headerLogo = portalTheme?.displayLogoInHeader === true ? portalTheme?.logo || businessLogo : businessLogo;
    const headerBg = portalTheme?.colors?.cardBackground || "var(--portal-header-bg, rgba(255, 255, 255, 1))";
    const headerFont = portalTheme?.colors?.cardFont;
    const languageOptions = Array.isArray(portalTheme?.supportedLanguages) && portalTheme.supportedLanguages.length > 0 ? $4661258b4f20c3cd$var$LANGUAGE_OPTIONS.filter((opt)=>{
        const codes = portalTheme.supportedLanguages.map((l)=>String(l).toLowerCase());
        return codes.includes(String(opt.value).toLowerCase()) || codes.includes(String(opt.apiValue).toLowerCase()) || codes.includes(String(opt.label).toLowerCase());
    }) : $4661258b4f20c3cd$var$LANGUAGE_OPTIONS;
    const handleLanguageChange = (e)=>{
        const selectedValue = e.target.value;
        const selectedOption = $4661258b4f20c3cd$var$LANGUAGE_OPTIONS.find((opt)=>opt.value === selectedValue);
        if (selectedOption) dispatch({
            type: (0, $dee2f92127058cd3$export$7dc30384a9e2138c),
            payload: {
                language: selectedOption.value,
                sourceLang: selectedOption.apiValue
            }
        });
    };
    const path = location.pathname;
    if (path === "/adminLogin" || path === "/app-documents" || path === "/home") return null;
    else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("header", {
        className: "app-header",
        role: "banner",
        "aria-label": "Application Header",
        style: {
            backgroundColor: headerBg,
            color: headerFont || undefined,
            height: "55px",
            boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.08)",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            paddingLeft: "3rem",
            paddingRight: "3rem"
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "app-header-left",
                "aria-label": "Business Information",
                children: [
                    showMobileNavToggle ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        className: `mobile-nav-toggle${mobileNavOpen ? " mobile-nav-toggle--open" : ""}`,
                        onClick: ()=>onMobileNavToggle?.(),
                        "aria-expanded": mobileNavOpen,
                        "aria-controls": "main-side-navigation",
                        "aria-label": mobileNavOpen ? "Close navigation menu" : "Open navigation menu",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "mobile-nav-toggle__bar",
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "mobile-nav-toggle__bar",
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "mobile-nav-toggle__bar",
                                "aria-hidden": "true"
                            })
                        ]
                    }) : null,
                    headerLogo ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: headerLogo,
                        alt: `${businessName || "Business"} logo`,
                        style: {
                            width: 40,
                            height: 40,
                            objectFit: "contain",
                            borderRadius: 4
                        }
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc7e21f78fe2b481$export$faf9e552d710fc5c), {
                        height: 40,
                        width: 40,
                        "aria-hidden": "true"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "app-header-titles",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$5f1af8db9871e1d6), {
                            appearance: "body-s-bold",
                            color: "primary-grey-100",
                            style: headerFont ? {
                                color: headerFont
                            } : undefined,
                            "aria-label": `Company name: ${companyName}`,
                            children: companyName
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "app-header-right",
                style: {
                    display: "flex",
                    alignItems: "center",
                    gap: "1rem"
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            position: "relative"
                        },
                        role: "group",
                        "aria-labelledby": "language-select-label",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                id: "language-select-label",
                                className: "sr-only",
                                children: "Language Selection"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                id: "language-selector",
                                value: currentLanguage || "ENGLISH",
                                onChange: handleLanguageChange,
                                "aria-label": "Select preferred language for the application",
                                "aria-describedby": "language-select-label",
                                style: {
                                    appearance: "none",
                                    WebkitAppearance: "none",
                                    MozAppearance: "none",
                                    backgroundColor: "#fff",
                                    border: "1px solid #d1d5db",
                                    borderRadius: "8px",
                                    padding: "10px 40px 10px 16px",
                                    fontSize: "16px",
                                    fontWeight: "500",
                                    color: "#1a1a1a",
                                    cursor: "pointer",
                                    outline: "none",
                                    minWidth: "140px",
                                    fontFamily: "inherit"
                                },
                                children: languageOptions.map((lang)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: lang.value,
                                        children: lang.label
                                    }, lang.value))
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    position: "absolute",
                                    right: "14px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    pointerEvents: "none"
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                    width: "12",
                                    height: "8",
                                    viewBox: "0 0 12 8",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    "aria-hidden": "true",
                                    focusable: "false",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                        d: "M1 1.5L6 6.5L11 1.5",
                                        stroke: "#1a1a1a",
                                        strokeWidth: "2",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    })
                                })
                            })
                        ]
                    }),
                    initials && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "header-icons",
                        "aria-label": `User avatar for ${businessName}`,
                        children: businessLogo ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: businessLogo,
                            alt: `${businessName} logo`,
                            className: "business-logo-avatar",
                            style: {
                                width: "40px",
                                height: "40px",
                                borderRadius: "50%"
                            }
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe5170bdd3625759$export$e2255cf6045e8d47), {
                            kind: "initials",
                            initials: initials || "J",
                            "aria-label": `User profile: ${initials}`
                        })
                    })
                ]
            })
        ]
    });
};
var $4661258b4f20c3cd$export$2e2bcd8739ae039 = $4661258b4f20c3cd$var$HeaderComponent;





function $4c8cda5d2c6d1d8b$var$App() {
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const [mobileNavOpen, setMobileNavOpen] = (0, $acw62.useState)(false);
    const businessId = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.common.business_id);
    const secureId = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.common.secure_id);
    const tenantId = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.common.tenant_id);
    const portalTheme = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.common.portal_theme);
    (0, $acw62.useEffect)(()=>{
        if (tenantId && businessId) dispatch((0, $6eea01a75b53fee5$export$b35eea761c43ace8)());
    }, [
        dispatch,
        tenantId,
        businessId,
        secureId
    ]);
    (0, $acw62.useEffect)(()=>{
        (0, $f9365a33f363598f$export$163b7a9b655fc3e2)(portalTheme);
        if (portalTheme?.portalTitle) document.title = portalTheme.portalTitle;
    }, [
        portalTheme
    ]);
    const hideSideNavRoutes = [
        "/app-documents",
        "/requests/",
        "/createRequest",
        "/integrationGrievanceRequests",
        "/integrationCreateRequest",
        "/integrationGrievanceRequests/:grievanceId"
    ];
    const hideSideNav = hideSideNavRoutes.some((p)=>location.pathname.startsWith(p));
    (0, $acw62.useEffect)(()=>{
        setMobileNavOpen(false);
    }, [
        location.pathname
    ]);
    (0, $acw62.useEffect)(()=>{
        const shouldLock = !hideSideNav && mobileNavOpen;
        document.body.style.overflow = shouldLock ? "hidden" : "";
        return ()=>{
            document.body.style.overflow = "";
        };
    }, [
        hideSideNav,
        mobileNavOpen
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8bd3c5c9ee0d1eb4$export$e5cf4eff53e7947d), {
        theme: "JioBase",
        mode: "light",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4661258b4f20c3cd$export$2e2bcd8739ae039), {
                showMobileNavToggle: !hideSideNav,
                mobileNavOpen: mobileNavOpen,
                onMobileNavToggle: ()=>setMobileNavOpen((open)=>!open)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: !hideSideNav ? "app-layout" : "",
                children: [
                    !hideSideNav && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            mobileNavOpen ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "mobile-nav-backdrop",
                                onClick: ()=>setMobileNavOpen(false),
                                "aria-hidden": "true"
                            }) : null,
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b3b62c205a9c34b0$export$2e2bcd8739ae039), {
                                mobileNavOpen: mobileNavOpen,
                                onMobileNavClose: ()=>setMobileNavOpen(false)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1ea0bcfb5b0a50ad$export$2e2bcd8739ae039), {})
                ]
            }),
            !hideSideNav && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $355f3e6615574795$export$2e2bcd8739ae039), {})
        ]
    });
}
var $4c8cda5d2c6d1d8b$export$2e2bcd8739ae039 = $4c8cda5d2c6d1d8b$var$App;


// store/store.js
// src/utils/formatProdErrorMessage.ts
function $d2bed10dff9b4968$var$formatProdErrorMessage(code) {
    return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
// src/utils/symbol-observable.ts
var $d2bed10dff9b4968$var$$$observable = /* @__PURE__ */ (()=>typeof Symbol === "function" && Symbol.observable || "@@observable")();
var $d2bed10dff9b4968$var$symbol_observable_default = $d2bed10dff9b4968$var$$$observable;
// src/utils/actionTypes.ts
var $d2bed10dff9b4968$var$randomString = ()=>Math.random().toString(36).substring(7).split("").join(".");
var $d2bed10dff9b4968$var$ActionTypes = {
    INIT: `@@redux/INIT${$d2bed10dff9b4968$var$randomString()}`,
    REPLACE: `@@redux/REPLACE${$d2bed10dff9b4968$var$randomString()}`,
    PROBE_UNKNOWN_ACTION: ()=>`@@redux/PROBE_UNKNOWN_ACTION${$d2bed10dff9b4968$var$randomString()}`
};
var $d2bed10dff9b4968$export$4219e499db7ca678 = $d2bed10dff9b4968$var$ActionTypes;
// src/utils/isPlainObject.ts
function $d2bed10dff9b4968$export$53b83ca8eaab0383(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $d2bed10dff9b4968$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    const type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($d2bed10dff9b4968$var$isDate(val)) return "date";
    if ($d2bed10dff9b4968$var$isError(val)) return "error";
    const constructorName = $d2bed10dff9b4968$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $d2bed10dff9b4968$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $d2bed10dff9b4968$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $d2bed10dff9b4968$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $d2bed10dff9b4968$var$kindOf(val) {
    let typeOfVal = typeof val;
    return typeOfVal;
}
// src/createStore.ts
function $d2bed10dff9b4968$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(1));
        return enhancer($d2bed10dff9b4968$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    let currentReducer = reducer;
    let currentState = preloadedState;
    let currentListeners = /* @__PURE__ */ new Map();
    let nextListeners = currentListeners;
    let listenerIdCounter = 0;
    let isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach((listener, key)=>{
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(5));
        let isSubscribed = true;
        ensureCanMutateNextListeners();
        const listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$d2bed10dff9b4968$export$53b83ca8eaab0383(action)) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        const listeners = currentListeners = nextListeners;
        listeners.forEach((listener)=>{
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $d2bed10dff9b4968$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        const outerSubscribe = subscribe;
        return {
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe (observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(11));
                function observeState() {
                    const observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                const unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            },
            [$d2bed10dff9b4968$var$symbol_observable_default] () {
                return this;
            }
        };
    }
    dispatch({
        type: $d2bed10dff9b4968$export$4219e499db7ca678.INIT
    });
    const store = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer,
        [$d2bed10dff9b4968$var$symbol_observable_default]: observable
    };
    return store;
}
function $d2bed10dff9b4968$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $d2bed10dff9b4968$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $d2bed10dff9b4968$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $d2bed10dff9b4968$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    const reducerKeys = Object.keys(reducers);
    const argumentName = action && action.type === $d2bed10dff9b4968$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$d2bed10dff9b4968$export$53b83ca8eaab0383(inputState)) return `The ${argumentName} has unexpected type of "${$d2bed10dff9b4968$var$kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
    const unexpectedKeys = Object.keys(inputState).filter((key)=>!reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
    unexpectedKeys.forEach((key)=>{
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $d2bed10dff9b4968$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
}
function $d2bed10dff9b4968$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach((key)=>{
        const reducer = reducers[key];
        const initialState = reducer(void 0, {
            type: $d2bed10dff9b4968$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $d2bed10dff9b4968$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(13));
    });
}
function $d2bed10dff9b4968$export$66e4520cdb265d18(reducers) {
    const reducerKeys = Object.keys(reducers);
    const finalReducers = {};
    for(let i = 0; i < reducerKeys.length; i++){
        const key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    const finalReducerKeys = Object.keys(finalReducers);
    let unexpectedKeyCache;
    let shapeAssertionError;
    try {
        $d2bed10dff9b4968$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state = {}, action) {
        if (shapeAssertionError) throw shapeAssertionError;
        let hasChanged = false;
        const nextState = {};
        for(let i = 0; i < finalReducerKeys.length; i++){
            const key = finalReducerKeys[i];
            const reducer = finalReducers[key];
            const previousStateForKey = state[key];
            const nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                const actionType = action && action.type;
                throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $d2bed10dff9b4968$var$bindActionCreator(actionCreator, dispatch) {
    return function(...args) {
        return dispatch(actionCreator.apply(this, args));
    };
}
function $d2bed10dff9b4968$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $d2bed10dff9b4968$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(16));
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $d2bed10dff9b4968$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $d2bed10dff9b4968$export$f672e0b6f7222cd7(...funcs) {
    if (funcs.length === 0) return (arg)=>arg;
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce((a, b)=>(...args)=>a(b(...args)));
}
// src/applyMiddleware.ts
function $d2bed10dff9b4968$export$9ff26e0402cc7b7(...middlewares) {
    return (createStore2)=>(reducer, preloadedState)=>{
            const store = createStore2(reducer, preloadedState);
            let dispatch = ()=>{
                throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(15));
            };
            const middlewareAPI = {
                getState: store.getState,
                dispatch: (action, ...args)=>dispatch(action, ...args)
            };
            const chain = middlewares.map((middleware)=>middleware(middlewareAPI));
            dispatch = $d2bed10dff9b4968$export$f672e0b6f7222cd7(...chain)(store.dispatch);
            return {
                ...store,
                dispatch: dispatch
            };
        };
}
// src/utils/isAction.ts
function $d2bed10dff9b4968$export$b956e38827fca970(action) {
    return $d2bed10dff9b4968$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}


var $5f9e38360d79f95a$var$__defProp = Object.defineProperty;
var $5f9e38360d79f95a$var$__defProps = Object.defineProperties;
var $5f9e38360d79f95a$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $5f9e38360d79f95a$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $5f9e38360d79f95a$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $5f9e38360d79f95a$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $5f9e38360d79f95a$var$__defNormalProp = (obj, key, value)=>key in obj ? $5f9e38360d79f95a$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $5f9e38360d79f95a$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($5f9e38360d79f95a$var$__hasOwnProp.call(b, prop)) $5f9e38360d79f95a$var$__defNormalProp(a, prop, b[prop]);
    if ($5f9e38360d79f95a$var$__getOwnPropSymbols) {
        for (var prop of $5f9e38360d79f95a$var$__getOwnPropSymbols(b))if ($5f9e38360d79f95a$var$__propIsEnum.call(b, prop)) $5f9e38360d79f95a$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $5f9e38360d79f95a$var$__spreadProps = (a, b)=>$5f9e38360d79f95a$var$__defProps(a, $5f9e38360d79f95a$var$__getOwnPropDescs(b));
// src/utils/env.ts
var $5f9e38360d79f95a$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $5f9e38360d79f95a$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $5f9e38360d79f95a$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $5f9e38360d79f95a$var$errors = [];
function $5f9e38360d79f95a$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $5f9e38360d79f95a$var$O = Object;
var $5f9e38360d79f95a$var$getPrototypeOf = $5f9e38360d79f95a$var$O.getPrototypeOf;
var $5f9e38360d79f95a$var$CONSTRUCTOR = "constructor";
var $5f9e38360d79f95a$var$PROTOTYPE = "prototype";
var $5f9e38360d79f95a$var$CONFIGURABLE = "configurable";
var $5f9e38360d79f95a$var$ENUMERABLE = "enumerable";
var $5f9e38360d79f95a$var$WRITABLE = "writable";
var $5f9e38360d79f95a$var$VALUE = "value";
var $5f9e38360d79f95a$export$541ac630993a4c84 = (value)=>!!value && !!value[$5f9e38360d79f95a$var$DRAFT_STATE];
function $5f9e38360d79f95a$export$16e3aed3edb85946(value) {
    var _a;
    if (!value) return false;
    return $5f9e38360d79f95a$var$isPlainObject(value) || $5f9e38360d79f95a$var$isArray(value) || !!value[$5f9e38360d79f95a$export$6ee2082928bcb0ee] || !!((_a = value[$5f9e38360d79f95a$var$CONSTRUCTOR]) == null ? void 0 : _a[$5f9e38360d79f95a$export$6ee2082928bcb0ee]) || $5f9e38360d79f95a$var$isMap(value) || $5f9e38360d79f95a$var$isSet(value);
}
var $5f9e38360d79f95a$var$objectCtorString = $5f9e38360d79f95a$var$O[$5f9e38360d79f95a$var$PROTOTYPE][$5f9e38360d79f95a$var$CONSTRUCTOR].toString();
var $5f9e38360d79f95a$var$cachedCtorStrings = /* @__PURE__ */ new WeakMap();
function $5f9e38360d79f95a$var$isPlainObject(value) {
    if (!value || !$5f9e38360d79f95a$var$isObjectish(value)) return false;
    const proto = $5f9e38360d79f95a$var$getPrototypeOf(value);
    if (proto === null || proto === $5f9e38360d79f95a$var$O[$5f9e38360d79f95a$var$PROTOTYPE]) return true;
    const Ctor = $5f9e38360d79f95a$var$O.hasOwnProperty.call(proto, $5f9e38360d79f95a$var$CONSTRUCTOR) && proto[$5f9e38360d79f95a$var$CONSTRUCTOR];
    if (Ctor === Object) return true;
    if (!$5f9e38360d79f95a$var$isFunction(Ctor)) return false;
    let ctorString = $5f9e38360d79f95a$var$cachedCtorStrings.get(Ctor);
    if (ctorString === void 0) {
        ctorString = Function.toString.call(Ctor);
        $5f9e38360d79f95a$var$cachedCtorStrings.set(Ctor, ctorString);
    }
    return ctorString === $5f9e38360d79f95a$var$objectCtorString;
}
function $5f9e38360d79f95a$export$22e8af3f75a010e3(value) {
    if (!$5f9e38360d79f95a$export$541ac630993a4c84(value)) $5f9e38360d79f95a$var$die(15, value);
    return value[$5f9e38360d79f95a$var$DRAFT_STATE].base_;
}
function $5f9e38360d79f95a$var$each(obj, iter, strict = true) {
    if ($5f9e38360d79f95a$var$getArchtype(obj) === 0 /* Object */ ) {
        const keys = strict ? Reflect.ownKeys(obj) : $5f9e38360d79f95a$var$O.keys(obj);
        keys.forEach((key)=>{
            iter(key, obj[key], obj);
        });
    } else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $5f9e38360d79f95a$var$getArchtype(thing) {
    const state = thing[$5f9e38360d79f95a$var$DRAFT_STATE];
    return state ? state.type_ : $5f9e38360d79f95a$var$isArray(thing) ? 1 /* Array */  : $5f9e38360d79f95a$var$isMap(thing) ? 2 /* Map */  : $5f9e38360d79f95a$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
var $5f9e38360d79f95a$var$has = (thing, prop, type = $5f9e38360d79f95a$var$getArchtype(thing))=>type === 2 /* Map */  ? thing.has(prop) : $5f9e38360d79f95a$var$O[$5f9e38360d79f95a$var$PROTOTYPE].hasOwnProperty.call(thing, prop);
var $5f9e38360d79f95a$var$get = (thing, prop, type = $5f9e38360d79f95a$var$getArchtype(thing))=>// @ts-ignore
    type === 2 /* Map */  ? thing.get(prop) : thing[prop];
var $5f9e38360d79f95a$var$set = (thing, propOrOldValue, value, type = $5f9e38360d79f95a$var$getArchtype(thing))=>{
    if (type === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (type === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
};
function $5f9e38360d79f95a$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
var $5f9e38360d79f95a$var$isArray = Array.isArray;
var $5f9e38360d79f95a$var$isMap = (target)=>target instanceof Map;
var $5f9e38360d79f95a$var$isSet = (target)=>target instanceof Set;
var $5f9e38360d79f95a$var$isObjectish = (target)=>typeof target === "object";
var $5f9e38360d79f95a$var$isFunction = (target)=>typeof target === "function";
var $5f9e38360d79f95a$var$isBoolean = (target)=>typeof target === "boolean";
function $5f9e38360d79f95a$var$isArrayIndex(value) {
    const n = +value;
    return Number.isInteger(n) && String(n) === value;
}
var $5f9e38360d79f95a$var$getProxyDraft = (value)=>{
    if (!$5f9e38360d79f95a$var$isObjectish(value)) return null;
    return value == null ? void 0 : value[$5f9e38360d79f95a$var$DRAFT_STATE];
};
var $5f9e38360d79f95a$var$latest = (state)=>state.copy_ || state.base_;
var $5f9e38360d79f95a$var$getValue = (value)=>{
    const proxyDraft = $5f9e38360d79f95a$var$getProxyDraft(value);
    return proxyDraft ? $5f9e38360d79f95a$var$getFinalValue(proxyDraft) : value;
};
var $5f9e38360d79f95a$var$getFinalValue = (state)=>state.modified_ ? state.copy_ : state.base_;
function $5f9e38360d79f95a$var$shallowCopy(base, strict) {
    if ($5f9e38360d79f95a$var$isMap(base)) return new Map(base);
    if ($5f9e38360d79f95a$var$isSet(base)) return new Set(base);
    if ($5f9e38360d79f95a$var$isArray(base)) return Array[$5f9e38360d79f95a$var$PROTOTYPE].slice.call(base);
    const isPlain = $5f9e38360d79f95a$var$isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = $5f9e38360d79f95a$var$O.getOwnPropertyDescriptors(base);
        delete descriptors[$5f9e38360d79f95a$var$DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc[$5f9e38360d79f95a$var$WRITABLE] === false) {
                desc[$5f9e38360d79f95a$var$WRITABLE] = true;
                desc[$5f9e38360d79f95a$var$CONFIGURABLE] = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                [$5f9e38360d79f95a$var$CONFIGURABLE]: true,
                [$5f9e38360d79f95a$var$WRITABLE]: true,
                // could live with !!desc.set as well here...
                [$5f9e38360d79f95a$var$ENUMERABLE]: desc[$5f9e38360d79f95a$var$ENUMERABLE],
                [$5f9e38360d79f95a$var$VALUE]: base[key]
            };
        }
        return $5f9e38360d79f95a$var$O.create($5f9e38360d79f95a$var$getPrototypeOf(base), descriptors);
    } else {
        const proto = $5f9e38360d79f95a$var$getPrototypeOf(base);
        if (proto !== null && isPlain) return $5f9e38360d79f95a$var$__spreadValues({}, base);
        const obj = $5f9e38360d79f95a$var$O.create(proto);
        return $5f9e38360d79f95a$var$O.assign(obj, base);
    }
}
function $5f9e38360d79f95a$export$792f3d81ea979f55(obj, deep = false) {
    if ($5f9e38360d79f95a$var$isFrozen(obj) || $5f9e38360d79f95a$export$541ac630993a4c84(obj) || !$5f9e38360d79f95a$export$16e3aed3edb85946(obj)) return obj;
    if ($5f9e38360d79f95a$var$getArchtype(obj) > 1) $5f9e38360d79f95a$var$O.defineProperties(obj, {
        set: $5f9e38360d79f95a$var$dontMutateMethodOverride,
        add: $5f9e38360d79f95a$var$dontMutateMethodOverride,
        clear: $5f9e38360d79f95a$var$dontMutateMethodOverride,
        delete: $5f9e38360d79f95a$var$dontMutateMethodOverride
    });
    $5f9e38360d79f95a$var$O.freeze(obj);
    if (deep) $5f9e38360d79f95a$var$each(obj, (_key, value)=>{
        $5f9e38360d79f95a$export$792f3d81ea979f55(value, true);
    }, false);
    return obj;
}
function $5f9e38360d79f95a$var$dontMutateFrozenCollections() {
    $5f9e38360d79f95a$var$die(2);
}
var $5f9e38360d79f95a$var$dontMutateMethodOverride = {
    [$5f9e38360d79f95a$var$VALUE]: $5f9e38360d79f95a$var$dontMutateFrozenCollections
};
function $5f9e38360d79f95a$var$isFrozen(obj) {
    if (obj === null || !$5f9e38360d79f95a$var$isObjectish(obj)) return true;
    return $5f9e38360d79f95a$var$O.isFrozen(obj);
}
// src/utils/plugins.ts
var $5f9e38360d79f95a$var$PluginMapSet = "MapSet";
var $5f9e38360d79f95a$var$PluginPatches = "Patches";
var $5f9e38360d79f95a$var$PluginArrayMethods = "ArrayMethods";
var $5f9e38360d79f95a$var$plugins = {};
function $5f9e38360d79f95a$var$getPlugin(pluginKey) {
    const plugin = $5f9e38360d79f95a$var$plugins[pluginKey];
    if (!plugin) $5f9e38360d79f95a$var$die(0, pluginKey);
    return plugin;
}
var $5f9e38360d79f95a$var$isPluginLoaded = (pluginKey)=>!!$5f9e38360d79f95a$var$plugins[pluginKey];
function $5f9e38360d79f95a$var$loadPlugin(pluginKey, implementation) {
    if (!$5f9e38360d79f95a$var$plugins[pluginKey]) $5f9e38360d79f95a$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $5f9e38360d79f95a$var$currentScope;
var $5f9e38360d79f95a$var$getCurrentScope = ()=>$5f9e38360d79f95a$var$currentScope;
var $5f9e38360d79f95a$var$createScope = (parent_, immer_)=>({
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0,
        handledSet_: /* @__PURE__ */ new Set(),
        processedForPatches_: /* @__PURE__ */ new Set(),
        mapSetPlugin_: $5f9e38360d79f95a$var$isPluginLoaded($5f9e38360d79f95a$var$PluginMapSet) ? $5f9e38360d79f95a$var$getPlugin($5f9e38360d79f95a$var$PluginMapSet) : void 0,
        arrayMethodsPlugin_: $5f9e38360d79f95a$var$isPluginLoaded($5f9e38360d79f95a$var$PluginArrayMethods) ? $5f9e38360d79f95a$var$getPlugin($5f9e38360d79f95a$var$PluginArrayMethods) : void 0
    });
function $5f9e38360d79f95a$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        scope.patchPlugin_ = $5f9e38360d79f95a$var$getPlugin($5f9e38360d79f95a$var$PluginPatches);
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $5f9e38360d79f95a$var$revokeScope(scope) {
    $5f9e38360d79f95a$var$leaveScope(scope);
    scope.drafts_.forEach($5f9e38360d79f95a$var$revokeDraft);
    scope.drafts_ = null;
}
function $5f9e38360d79f95a$var$leaveScope(scope) {
    if (scope === $5f9e38360d79f95a$var$currentScope) $5f9e38360d79f95a$var$currentScope = scope.parent_;
}
var $5f9e38360d79f95a$var$enterScope = (immer2)=>$5f9e38360d79f95a$var$currentScope = $5f9e38360d79f95a$var$createScope($5f9e38360d79f95a$var$currentScope, immer2);
function $5f9e38360d79f95a$var$revokeDraft(draft) {
    const state = draft[$5f9e38360d79f95a$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $5f9e38360d79f95a$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$5f9e38360d79f95a$var$DRAFT_STATE].modified_) {
            $5f9e38360d79f95a$var$revokeScope(scope);
            $5f9e38360d79f95a$var$die(4);
        }
        if ($5f9e38360d79f95a$export$16e3aed3edb85946(result)) result = $5f9e38360d79f95a$var$finalize(scope, result);
        const { patchPlugin_: patchPlugin_ } = scope;
        if (patchPlugin_) patchPlugin_.generateReplacementPatches_(baseDraft[$5f9e38360d79f95a$var$DRAFT_STATE].base_, result, scope);
    } else result = $5f9e38360d79f95a$var$finalize(scope, baseDraft);
    $5f9e38360d79f95a$var$maybeFreeze(scope, result, true);
    $5f9e38360d79f95a$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $5f9e38360d79f95a$export$45b790e32b2810ee ? result : void 0;
}
function $5f9e38360d79f95a$var$finalize(rootScope, value) {
    if ($5f9e38360d79f95a$var$isFrozen(value)) return value;
    const state = value[$5f9e38360d79f95a$var$DRAFT_STATE];
    if (!state) {
        const finalValue = $5f9e38360d79f95a$var$handleValue(value, rootScope.handledSet_, rootScope);
        return finalValue;
    }
    if (!$5f9e38360d79f95a$var$isSameScope(state, rootScope)) return value;
    if (!state.modified_) return state.base_;
    if (!state.finalized_) {
        const { callbacks_: callbacks_ } = state;
        if (callbacks_) while(callbacks_.length > 0){
            const callback = callbacks_.pop();
            callback(rootScope);
        }
        $5f9e38360d79f95a$var$generatePatchesAndFinalize(state, rootScope);
    }
    return state.copy_;
}
function $5f9e38360d79f95a$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $5f9e38360d79f95a$export$792f3d81ea979f55(value, deep);
}
function $5f9e38360d79f95a$var$markStateFinalized(state) {
    state.finalized_ = true;
    state.scope_.unfinalizedDrafts_--;
}
var $5f9e38360d79f95a$var$isSameScope = (state, rootScope)=>state.scope_ === rootScope;
var $5f9e38360d79f95a$var$EMPTY_LOCATIONS_RESULT = [];
function $5f9e38360d79f95a$var$updateDraftInParent(parent, draftValue, finalizedValue, originalKey) {
    var _a;
    const parentCopy = $5f9e38360d79f95a$var$latest(parent);
    const parentType = parent.type_;
    if (originalKey !== void 0) {
        const currentValue = $5f9e38360d79f95a$var$get(parentCopy, originalKey, parentType);
        if (currentValue === draftValue) {
            $5f9e38360d79f95a$var$set(parentCopy, originalKey, finalizedValue, parentType);
            return;
        }
    }
    if (!parent.draftLocations_) {
        const draftLocations = parent.draftLocations_ = /* @__PURE__ */ new Map();
        $5f9e38360d79f95a$var$each(parentCopy, (key, value)=>{
            if ($5f9e38360d79f95a$export$541ac630993a4c84(value)) {
                const keys = draftLocations.get(value) || [];
                keys.push(key);
                draftLocations.set(value, keys);
            }
        });
    }
    const locations = (_a = parent.draftLocations_.get(draftValue)) != null ? _a : $5f9e38360d79f95a$var$EMPTY_LOCATIONS_RESULT;
    for (const location of locations)$5f9e38360d79f95a$var$set(parentCopy, location, finalizedValue, parentType);
}
function $5f9e38360d79f95a$var$registerChildFinalizationCallback(parent, child, key) {
    parent.callbacks_.push(function childCleanup(rootScope) {
        var _a, _b;
        const state = child;
        if (!state || !$5f9e38360d79f95a$var$isSameScope(state, rootScope)) return;
        (_a = rootScope.mapSetPlugin_) == null || _a.fixSetContents(state);
        const finalizedValue = $5f9e38360d79f95a$var$getFinalValue(state);
        $5f9e38360d79f95a$var$updateDraftInParent(parent, (_b = state.draft_) != null ? _b : state, finalizedValue, key);
        $5f9e38360d79f95a$var$generatePatchesAndFinalize(state, rootScope);
    });
}
function $5f9e38360d79f95a$var$generatePatchesAndFinalize(state, rootScope) {
    var _a, _b;
    const shouldFinalize = state.modified_ && !state.finalized_ && (state.type_ === 3 /* Set */  || state.type_ === 1 /* Array */  && state.allIndicesReassigned_ || ((_b = (_a = state.assigned_) == null ? void 0 : _a.size) != null ? _b : 0) > 0);
    if (shouldFinalize) {
        const { patchPlugin_: patchPlugin_ } = rootScope;
        if (patchPlugin_) {
            const basePath = patchPlugin_.getPath(state);
            if (basePath) patchPlugin_.generatePatches_(state, basePath, rootScope);
        }
        $5f9e38360d79f95a$var$markStateFinalized(state);
    }
}
function $5f9e38360d79f95a$var$handleCrossReference(target, key, value) {
    const { scope_: scope_ } = target;
    if ($5f9e38360d79f95a$export$541ac630993a4c84(value)) {
        const state = value[$5f9e38360d79f95a$var$DRAFT_STATE];
        if ($5f9e38360d79f95a$var$isSameScope(state, scope_)) state.callbacks_.push(function crossReferenceCleanup() {
            $5f9e38360d79f95a$var$prepareCopy(target);
            const finalizedValue = $5f9e38360d79f95a$var$getFinalValue(state);
            $5f9e38360d79f95a$var$updateDraftInParent(target, value, finalizedValue, key);
        });
    } else if ($5f9e38360d79f95a$export$16e3aed3edb85946(value)) target.callbacks_.push(function nestedDraftCleanup() {
        var _a;
        const targetCopy = $5f9e38360d79f95a$var$latest(target);
        if (target.type_ === 3 /* Set */ ) {
            if (targetCopy.has(value)) $5f9e38360d79f95a$var$handleValue(value, scope_.handledSet_, scope_);
        } else {
            if ($5f9e38360d79f95a$var$get(targetCopy, key, target.type_) === value) {
                if (scope_.drafts_.length > 1 && ((_a = target.assigned_.get(key)) != null ? _a : false) === true && target.copy_) $5f9e38360d79f95a$var$handleValue($5f9e38360d79f95a$var$get(target.copy_, key, target.type_), scope_.handledSet_, scope_);
            }
        }
    });
}
function $5f9e38360d79f95a$var$handleValue(target, handledSet, rootScope) {
    if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return target;
    if ($5f9e38360d79f95a$export$541ac630993a4c84(target) || handledSet.has(target) || !$5f9e38360d79f95a$export$16e3aed3edb85946(target) || $5f9e38360d79f95a$var$isFrozen(target)) return target;
    handledSet.add(target);
    $5f9e38360d79f95a$var$each(target, (key, value)=>{
        if ($5f9e38360d79f95a$export$541ac630993a4c84(value)) {
            const state = value[$5f9e38360d79f95a$var$DRAFT_STATE];
            if ($5f9e38360d79f95a$var$isSameScope(state, rootScope)) {
                const updatedValue = $5f9e38360d79f95a$var$getFinalValue(state);
                $5f9e38360d79f95a$var$set(target, key, updatedValue, target.type_);
                $5f9e38360d79f95a$var$markStateFinalized(state);
            }
        } else if ($5f9e38360d79f95a$export$16e3aed3edb85946(value)) $5f9e38360d79f95a$var$handleValue(value, handledSet, rootScope);
    });
    return target;
}
// src/core/proxy.ts
function $5f9e38360d79f95a$var$createProxyProxy(base, parent) {
    const baseIsArray = $5f9e38360d79f95a$var$isArray(base);
    const state = {
        type_: baseIsArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $5f9e38360d79f95a$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        // actually instantiated in `prepareCopy()`
        assigned_: void 0,
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false,
        // `callbacks` actually gets assigned in `createProxy`
        callbacks_: void 0
    };
    let target = state;
    let traps = $5f9e38360d79f95a$var$objectTraps;
    if (baseIsArray) {
        target = [
            state
        ];
        traps = $5f9e38360d79f95a$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return [
        proxy,
        state
    ];
}
var $5f9e38360d79f95a$var$objectTraps = {
    get (state, prop) {
        if (prop === $5f9e38360d79f95a$var$DRAFT_STATE) return state;
        let arrayPlugin = state.scope_.arrayMethodsPlugin_;
        const isArrayWithStringProp = state.type_ === 1 /* Array */  && typeof prop === "string";
        if (isArrayWithStringProp) {
            if (arrayPlugin == null ? void 0 : arrayPlugin.isArrayOperationMethod(prop)) return arrayPlugin.createMethodInterceptor(state, prop);
        }
        const source = $5f9e38360d79f95a$var$latest(state);
        if (!$5f9e38360d79f95a$var$has(source, prop, state.type_)) return $5f9e38360d79f95a$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$5f9e38360d79f95a$export$16e3aed3edb85946(value)) return value;
        if (isArrayWithStringProp && state.operationMethod && (arrayPlugin == null ? void 0 : arrayPlugin.isMutatingArrayMethod(state.operationMethod)) && $5f9e38360d79f95a$var$isArrayIndex(prop)) return value;
        if (value === $5f9e38360d79f95a$var$peek(state.base_, prop) || $5f9e38360d79f95a$var$isRelocatedBaseRef(state, prop, value)) {
            $5f9e38360d79f95a$var$prepareCopy(state);
            const childKey = state.type_ === 1 /* Array */  ? +prop : prop;
            const childDraft = $5f9e38360d79f95a$var$createProxy(state.scope_, value, state, childKey);
            return state.copy_[childKey] = childDraft;
        }
        return value;
    },
    has (state, prop) {
        return prop in $5f9e38360d79f95a$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($5f9e38360d79f95a$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $5f9e38360d79f95a$var$getDescriptorFromProto($5f9e38360d79f95a$var$latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $5f9e38360d79f95a$var$peek($5f9e38360d79f95a$var$latest(state), prop);
            const currentState = current2 == null ? void 0 : current2[$5f9e38360d79f95a$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_.delete(prop);
                return true;
            }
            if ($5f9e38360d79f95a$var$is(value, current2) && (value !== void 0 || $5f9e38360d79f95a$var$has(state.base_, prop, state.type_))) return true;
            $5f9e38360d79f95a$var$prepareCopy(state);
            $5f9e38360d79f95a$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || $5f9e38360d79f95a$var$has(state.copy_, prop, state.type_)) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_.set(prop, true);
        $5f9e38360d79f95a$var$handleCrossReference(state, prop, value);
        return true;
    },
    deleteProperty (state, prop) {
        $5f9e38360d79f95a$var$prepareCopy(state);
        if ($5f9e38360d79f95a$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_.set(prop, false);
            $5f9e38360d79f95a$var$markChanged(state);
        } else state.assigned_.delete(prop);
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $5f9e38360d79f95a$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            [$5f9e38360d79f95a$var$WRITABLE]: true,
            [$5f9e38360d79f95a$var$CONFIGURABLE]: state.type_ !== 1 /* Array */  || prop !== "length",
            [$5f9e38360d79f95a$var$ENUMERABLE]: desc[$5f9e38360d79f95a$var$ENUMERABLE],
            [$5f9e38360d79f95a$var$VALUE]: owner[prop]
        };
    },
    defineProperty () {
        $5f9e38360d79f95a$var$die(11);
    },
    getPrototypeOf (state) {
        return $5f9e38360d79f95a$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $5f9e38360d79f95a$var$die(12);
    }
};
var $5f9e38360d79f95a$var$arrayTraps = {};
for(let key in $5f9e38360d79f95a$var$objectTraps){
    let fn = $5f9e38360d79f95a$var$objectTraps[key];
    $5f9e38360d79f95a$var$arrayTraps[key] = function() {
        const args = arguments;
        args[0] = args[0][0];
        return fn.apply(this, args);
    };
}
$5f9e38360d79f95a$var$arrayTraps.deleteProperty = function(state, prop) {
    return $5f9e38360d79f95a$var$arrayTraps.set.call(this, state, prop, void 0);
};
$5f9e38360d79f95a$var$arrayTraps.set = function(state, prop, value) {
    return $5f9e38360d79f95a$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $5f9e38360d79f95a$var$peek(draft, prop) {
    const state = draft[$5f9e38360d79f95a$var$DRAFT_STATE];
    const source = state ? $5f9e38360d79f95a$var$latest(state) : draft;
    return source[prop];
}
function $5f9e38360d79f95a$var$isRelocatedBaseRef(state, prop, value) {
    var _a;
    if (state.type_ !== 1 /* Array */  || !state.allIndicesReassigned_ || ((_a = state.assigned_) == null ? void 0 : _a.get(prop)) || !$5f9e38360d79f95a$export$16e3aed3edb85946(value) || value[$5f9e38360d79f95a$var$DRAFT_STATE]) return false;
    return state.baseRefs_.has(value);
}
function $5f9e38360d79f95a$var$readPropFromProto(state, source, prop) {
    var _a;
    const desc = $5f9e38360d79f95a$var$getDescriptorFromProto(source, prop);
    return desc ? $5f9e38360d79f95a$var$VALUE in desc ? desc[$5f9e38360d79f95a$var$VALUE] : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function $5f9e38360d79f95a$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $5f9e38360d79f95a$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $5f9e38360d79f95a$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $5f9e38360d79f95a$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $5f9e38360d79f95a$var$markChanged(state.parent_);
    }
}
function $5f9e38360d79f95a$var$prepareCopy(state) {
    if (!state.copy_) {
        state.assigned_ = /* @__PURE__ */ new Map();
        state.copy_ = $5f9e38360d79f95a$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
    }
}
// src/core/immerClass.ts
var $5f9e38360d79f95a$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        this.useStrictIteration_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if ($5f9e38360d79f95a$var$isFunction(base) && !$5f9e38360d79f95a$var$isFunction(recipe)) {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (!$5f9e38360d79f95a$var$isFunction(recipe)) $5f9e38360d79f95a$var$die(6);
            if (patchListener !== void 0 && !$5f9e38360d79f95a$var$isFunction(patchListener)) $5f9e38360d79f95a$var$die(7);
            let result;
            if ($5f9e38360d79f95a$export$16e3aed3edb85946(base)) {
                const scope = $5f9e38360d79f95a$var$enterScope(this);
                const proxy = $5f9e38360d79f95a$var$createProxy(scope, base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $5f9e38360d79f95a$var$revokeScope(scope);
                    else $5f9e38360d79f95a$var$leaveScope(scope);
                }
                $5f9e38360d79f95a$var$usePatchesInScope(scope, patchListener);
                return $5f9e38360d79f95a$var$processResult(result, scope);
            } else if (!base || !$5f9e38360d79f95a$var$isObjectish(base)) {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $5f9e38360d79f95a$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $5f9e38360d79f95a$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $5f9e38360d79f95a$var$getPlugin($5f9e38360d79f95a$var$PluginPatches).generateReplacementPatches_(base, result, {
                        patches_: p,
                        inversePatches_: ip
                    });
                    patchListener(p, ip);
                }
                return result;
            } else $5f9e38360d79f95a$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if ($5f9e38360d79f95a$var$isFunction(base)) return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if ($5f9e38360d79f95a$var$isBoolean(config == null ? void 0 : config.autoFreeze)) this.setAutoFreeze(config.autoFreeze);
        if ($5f9e38360d79f95a$var$isBoolean(config == null ? void 0 : config.useStrictShallowCopy)) this.setUseStrictShallowCopy(config.useStrictShallowCopy);
        if ($5f9e38360d79f95a$var$isBoolean(config == null ? void 0 : config.useStrictIteration)) this.setUseStrictIteration(config.useStrictIteration);
    }
    createDraft(base) {
        if (!$5f9e38360d79f95a$export$16e3aed3edb85946(base)) $5f9e38360d79f95a$var$die(8);
        if ($5f9e38360d79f95a$export$541ac630993a4c84(base)) base = $5f9e38360d79f95a$export$97aac956da55dae9(base);
        const scope = $5f9e38360d79f95a$var$enterScope(this);
        const proxy = $5f9e38360d79f95a$var$createProxy(scope, base, void 0);
        proxy[$5f9e38360d79f95a$var$DRAFT_STATE].isManual_ = true;
        $5f9e38360d79f95a$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$5f9e38360d79f95a$var$DRAFT_STATE];
        if (!state || !state.isManual_) $5f9e38360d79f95a$var$die(9);
        const { scope_: scope } = state;
        $5f9e38360d79f95a$var$usePatchesInScope(scope, patchListener);
        return $5f9e38360d79f95a$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    /**
   * Pass false to use faster iteration that skips non-enumerable properties
   * but still handles symbols for compatibility.
   *
   * By default, strict iteration is enabled (includes all own properties).
   */ setUseStrictIteration(value) {
        this.useStrictIteration_ = value;
    }
    shouldUseStrictIteration() {
        return this.useStrictIteration_;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $5f9e38360d79f95a$var$getPlugin($5f9e38360d79f95a$var$PluginPatches).applyPatches_;
        if ($5f9e38360d79f95a$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $5f9e38360d79f95a$var$createProxy(rootScope, value, parent, key) {
    var _a, _b;
    const [draft, state] = $5f9e38360d79f95a$var$isMap(value) ? $5f9e38360d79f95a$var$getPlugin($5f9e38360d79f95a$var$PluginMapSet).proxyMap_(value, parent) : $5f9e38360d79f95a$var$isSet(value) ? $5f9e38360d79f95a$var$getPlugin($5f9e38360d79f95a$var$PluginMapSet).proxySet_(value, parent) : $5f9e38360d79f95a$var$createProxyProxy(value, parent);
    const scope = (_a = parent == null ? void 0 : parent.scope_) != null ? _a : $5f9e38360d79f95a$var$getCurrentScope();
    scope.drafts_.push(draft);
    state.callbacks_ = (_b = parent == null ? void 0 : parent.callbacks_) != null ? _b : [];
    state.key_ = key;
    if (parent && key !== void 0) $5f9e38360d79f95a$var$registerChildFinalizationCallback(parent, state, key);
    else state.callbacks_.push(function rootDraftCleanup(rootScope2) {
        var _a2;
        (_a2 = rootScope2.mapSetPlugin_) == null || _a2.fixSetContents(state);
        const { patchPlugin_: patchPlugin_ } = rootScope2;
        if (state.modified_ && patchPlugin_) patchPlugin_.generatePatches_(state, [], rootScope2);
    });
    return draft;
}
// src/core/current.ts
function $5f9e38360d79f95a$export$97aac956da55dae9(value) {
    if (!$5f9e38360d79f95a$export$541ac630993a4c84(value)) $5f9e38360d79f95a$var$die(10, value);
    return $5f9e38360d79f95a$var$currentImpl(value);
}
function $5f9e38360d79f95a$var$currentImpl(value) {
    if (!$5f9e38360d79f95a$export$16e3aed3edb85946(value) || $5f9e38360d79f95a$var$isFrozen(value)) return value;
    const state = value[$5f9e38360d79f95a$var$DRAFT_STATE];
    let copy;
    let strict = true;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $5f9e38360d79f95a$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
        strict = state.scope_.immer_.shouldUseStrictIteration();
    } else copy = $5f9e38360d79f95a$var$shallowCopy(value, true);
    $5f9e38360d79f95a$var$each(copy, (key, childValue)=>{
        $5f9e38360d79f95a$var$set(copy, key, $5f9e38360d79f95a$var$currentImpl(childValue));
    }, strict);
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $5f9e38360d79f95a$export$d3a6659991a0696c() {
    const errorOffset = 16;
    function getPath(state, path = []) {
        var _a;
        if (state.key_ !== void 0) {
            const parentCopy = (_a = state.parent_.copy_) != null ? _a : state.parent_.base_;
            const proxyDraft = $5f9e38360d79f95a$var$getProxyDraft($5f9e38360d79f95a$var$get(parentCopy, state.key_));
            const valueAtKey = $5f9e38360d79f95a$var$get(parentCopy, state.key_);
            if (valueAtKey === void 0) return null;
            if (valueAtKey !== state.draft_ && valueAtKey !== state.base_ && valueAtKey !== state.copy_) return null;
            if (proxyDraft != null && proxyDraft.base_ !== state.base_) return null;
            const isSet2 = state.parent_.type_ === 3 /* Set */ ;
            let key;
            if (isSet2) {
                const setParent = state.parent_;
                key = Array.from(setParent.drafts_.keys()).indexOf(state.key_);
            } else key = state.key_;
            if (!(isSet2 && parentCopy.size > key || $5f9e38360d79f95a$var$has(parentCopy, key))) return null;
            path.push(key);
        }
        if (state.parent_) return getPath(state.parent_, path);
        path.reverse();
        try {
            resolvePath(state.copy_, path);
        } catch (e) {
            return null;
        }
        return path;
    }
    function resolvePath(base, path) {
        let current2 = base;
        for(let i = 0; i < path.length - 1; i++){
            const key = path[i];
            current2 = $5f9e38360d79f95a$var$get(current2, key);
            if (!$5f9e38360d79f95a$var$isObjectish(current2) || current2 === null) throw new Error(`Cannot resolve path at '${path.join("/")}'`);
        }
        return current2;
    }
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, scope) {
        if (state.scope_.processedForPatches_.has(state)) return;
        state.scope_.processedForPatches_.add(state);
        const { patches_: patches_, inversePatches_: inversePatches_ } = scope;
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches_, inversePatches_);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches_, inversePatches_);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches_, inversePatches_);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        const allReassigned = state.allIndicesReassigned_ === true;
        for(let i = 0; i < base_.length; i++){
            const copiedItem = copy_[i];
            const baseItem = base_[i];
            const isAssigned = allReassigned || (assigned_ == null ? void 0 : assigned_.get(i.toString()));
            if (isAssigned && copiedItem !== baseItem) {
                const childState = copiedItem == null ? void 0 : copiedItem[$5f9e38360d79f95a$var$DRAFT_STATE];
                if (childState && childState.modified_) continue;
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REPLACE,
                    path: path,
                    // Need to maybe clone it, as it can in fact be the original value
                    // due to the base/copy inversion at the start of this function
                    value: clonePatchValueIfNeeded(copiedItem)
                });
                inversePatches.push({
                    op: REPLACE,
                    path: path,
                    value: clonePatchValueIfNeeded(baseItem)
                });
            }
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_, type_: type_ } = state;
        $5f9e38360d79f95a$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $5f9e38360d79f95a$var$get(base_, key, type_);
            const value = $5f9e38360d79f95a$var$get(copy_, key, type_);
            const op = !assignedValue ? REMOVE : $5f9e38360d79f95a$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: clonePatchValueIfNeeded(value)
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, scope) {
        const { patches_: patches_, inversePatches_: inversePatches_ } = scope;
        patches_.push({
            op: REPLACE,
            path: [],
            value: replacement === $5f9e38360d79f95a$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches_.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $5f9e38360d79f95a$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === $5f9e38360d79f95a$var$CONSTRUCTOR)) $5f9e38360d79f95a$var$die(errorOffset + 3);
                if ($5f9e38360d79f95a$var$isFunction(base) && p === $5f9e38360d79f95a$var$PROTOTYPE) $5f9e38360d79f95a$var$die(errorOffset + 3);
                base = $5f9e38360d79f95a$var$get(base, p);
                if (base === null || !$5f9e38360d79f95a$var$isObjectish(base)) $5f9e38360d79f95a$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $5f9e38360d79f95a$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $5f9e38360d79f95a$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $5f9e38360d79f95a$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$5f9e38360d79f95a$export$16e3aed3edb85946(obj)) return obj;
        if ($5f9e38360d79f95a$var$isArray(obj)) return obj.map(deepClonePatchValue);
        if ($5f9e38360d79f95a$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($5f9e38360d79f95a$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($5f9e38360d79f95a$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($5f9e38360d79f95a$var$has(obj, $5f9e38360d79f95a$export$6ee2082928bcb0ee)) cloned[$5f9e38360d79f95a$export$6ee2082928bcb0ee] = obj[$5f9e38360d79f95a$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($5f9e38360d79f95a$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $5f9e38360d79f95a$var$loadPlugin($5f9e38360d79f95a$var$PluginPatches, {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_,
        getPath: getPath
    });
}
// src/plugins/mapset.ts
var $5f9e38360d79f95a$var$_globalIterator = globalThis.Iterator;
var $5f9e38360d79f95a$var$hasIteratorFrom = typeof ($5f9e38360d79f95a$var$_globalIterator == null ? void 0 : $5f9e38360d79f95a$var$_globalIterator.from) === "function";
function $5f9e38360d79f95a$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$5f9e38360d79f95a$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $5f9e38360d79f95a$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false,
                callbacks_: []
            };
        }
        get size() {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            return $5f9e38360d79f95a$var$latest(state).size;
        }
        has(key) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            return $5f9e38360d79f95a$var$latest(state).has(key);
        }
        set(key, value) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$5f9e38360d79f95a$var$latest(state).has(key) || $5f9e38360d79f95a$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $5f9e38360d79f95a$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
                $5f9e38360d79f95a$var$handleCrossReference(state, key, value);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $5f9e38360d79f95a$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($5f9e38360d79f95a$var$latest(state).size) {
                prepareMapCopy(state);
                $5f9e38360d79f95a$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $5f9e38360d79f95a$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            $5f9e38360d79f95a$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $5f9e38360d79f95a$var$latest(state).get(key);
            if (state.finalized_ || !$5f9e38360d79f95a$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $5f9e38360d79f95a$var$createProxy(state.scope_, value, state, key);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            return $5f9e38360d79f95a$var$latest(state).keys();
        }
        values() {
            const iterator = this.keys();
            return iteratorFrom({
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            });
        }
        entries() {
            const iterator = this.keys();
            return iteratorFrom({
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            });
        }
        [($5f9e38360d79f95a$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function iteratorFrom(iterable) {
        if ($5f9e38360d79f95a$var$hasIteratorFrom) return $5f9e38360d79f95a$var$_globalIterator.from(iterable);
        const iterator = $5f9e38360d79f95a$var$__spreadProps($5f9e38360d79f95a$var$__spreadValues({}, iterable), {
            [Symbol.iterator]: ()=>iterator
        });
        return iterator;
    }
    function proxyMap_(target, parent) {
        const map = new DraftMap(target, parent);
        return [
            map,
            map[$5f9e38360d79f95a$var$DRAFT_STATE]
        ];
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$5f9e38360d79f95a$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $5f9e38360d79f95a$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false,
                assigned_: void 0,
                callbacks_: []
            };
        }
        get size() {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            return $5f9e38360d79f95a$var$latest(state).size;
        }
        has(value) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $5f9e38360d79f95a$var$markChanged(state);
                state.copy_.add(value);
                $5f9e38360d79f95a$var$handleCrossReference(state, value, value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $5f9e38360d79f95a$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($5f9e38360d79f95a$var$latest(state).size) {
                prepareSetCopy(state);
                $5f9e38360d79f95a$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($5f9e38360d79f95a$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        const set2 = new DraftSet(target, parent);
        return [
            set2,
            set2[$5f9e38360d79f95a$var$DRAFT_STATE]
        ];
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($5f9e38360d79f95a$export$16e3aed3edb85946(value)) {
                    const draft = $5f9e38360d79f95a$var$createProxy(state.scope_, value, state, value);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $5f9e38360d79f95a$var$die(3, JSON.stringify($5f9e38360d79f95a$var$latest(state)));
    }
    function fixSetContents(target) {
        if (target.type_ === 3 /* Set */  && target.copy_) {
            const copy = new Set(target.copy_);
            target.copy_.clear();
            copy.forEach((value)=>{
                target.copy_.add($5f9e38360d79f95a$var$getValue(value));
            });
        }
    }
    $5f9e38360d79f95a$var$loadPlugin($5f9e38360d79f95a$var$PluginMapSet, {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_,
        fixSetContents: fixSetContents
    });
}
// src/plugins/arrayMethods.ts
function $5f9e38360d79f95a$export$5ecc5ed53f504cc5() {
    const SHIFTING_METHODS = /* @__PURE__ */ new Set([
        "shift",
        "unshift"
    ]);
    const QUEUE_METHODS = /* @__PURE__ */ new Set([
        "push",
        "pop"
    ]);
    const RESULT_RETURNING_METHODS = /* @__PURE__ */ new Set([
        ...QUEUE_METHODS,
        ...SHIFTING_METHODS
    ]);
    const REORDERING_METHODS = /* @__PURE__ */ new Set([
        "reverse",
        "sort"
    ]);
    const MUTATING_METHODS = /* @__PURE__ */ new Set([
        ...RESULT_RETURNING_METHODS,
        ...REORDERING_METHODS,
        "splice"
    ]);
    const FIND_METHODS = /* @__PURE__ */ new Set([
        "find",
        "findLast"
    ]);
    const NON_MUTATING_METHODS = /* @__PURE__ */ new Set([
        "filter",
        "slice",
        "concat",
        "flat",
        ...FIND_METHODS,
        "findIndex",
        "findLastIndex",
        "some",
        "every",
        "indexOf",
        "lastIndexOf",
        "includes",
        "join",
        "toString",
        "toLocaleString"
    ]);
    function isMutatingArrayMethod(method) {
        return MUTATING_METHODS.has(method);
    }
    function isNonMutatingArrayMethod(method) {
        return NON_MUTATING_METHODS.has(method);
    }
    function isArrayOperationMethod(method) {
        return isMutatingArrayMethod(method) || isNonMutatingArrayMethod(method);
    }
    function enterOperation(state, method) {
        state.operationMethod = method;
    }
    function exitOperation(state) {
        state.operationMethod = void 0;
    }
    function executeArrayMethod(state, operation, markLength = true) {
        $5f9e38360d79f95a$var$prepareCopy(state);
        const result = operation();
        markArrayChanged(state, markLength);
        return result;
    }
    function markArrayChanged(state, markLength = true) {
        $5f9e38360d79f95a$var$markChanged(state);
        if (markLength) state.assigned_.set("length", true);
    }
    function markAllIndicesReassigned(state) {
        state.allIndicesReassigned_ = true;
        state.baseRefs_ = new Set(state.base_);
    }
    function normalizeSliceIndex(index, length) {
        if (index < 0) return Math.max(length + index, 0);
        return Math.min(index, length);
    }
    function handleInsertedValues(state, startIndex, values) {
        for(let i = 0; i < values.length; i++){
            const index = "" + (startIndex + i);
            state.assigned_.set(index, true);
            $5f9e38360d79f95a$var$handleCrossReference(state, index, values[i]);
        }
    }
    function handleSimpleOperation(state, method, args) {
        const isInsert = method === "push" || method === "unshift";
        if (isInsert ? args.length === 0 : $5f9e38360d79f95a$var$latest(state).length === 0) return isInsert ? $5f9e38360d79f95a$var$latest(state).length : void 0;
        $5f9e38360d79f95a$var$prepareCopy(state);
        const lengthBefore = state.copy_.length;
        const result = state.copy_[method](...args);
        markArrayChanged(state);
        if (SHIFTING_METHODS.has(method)) markAllIndicesReassigned(state);
        if (method === "push") handleInsertedValues(state, lengthBefore, args);
        else if (method === "unshift") handleInsertedValues(state, 0, args);
        return RESULT_RETURNING_METHODS.has(method) ? result : state.draft_;
    }
    function handleReorderingOperation(state, method, args) {
        if ($5f9e38360d79f95a$var$latest(state).length <= 1) return state.draft_;
        return executeArrayMethod(state, ()=>{
            state.copy_[method](...args);
            markAllIndicesReassigned(state);
            return state.draft_;
        }, false);
    }
    function createMethodInterceptor(state, originalMethod) {
        return function interceptedMethod(...args) {
            var _a, _b;
            const method = originalMethod;
            enterOperation(state, method);
            try {
                if (isMutatingArrayMethod(method)) {
                    if (RESULT_RETURNING_METHODS.has(method)) return handleSimpleOperation(state, method, args);
                    if (REORDERING_METHODS.has(method)) return handleReorderingOperation(state, method, args);
                    if (method === "splice") {
                        const insertCount = args.length > 2 ? args.length - 2 : 0;
                        if (insertCount === 0) {
                            const length = $5f9e38360d79f95a$var$latest(state).length;
                            if (args.length === 0 || normalizeSliceIndex((_a = args[0]) != null ? _a : 0, length) === length || args.length > 1 && !(args[1] >= 1)) return [];
                        }
                        $5f9e38360d79f95a$var$prepareCopy(state);
                        const res = state.copy_.splice(...args);
                        if (res.length === 0 && insertCount === 0) return res;
                        markArrayChanged(state);
                        markAllIndicesReassigned(state);
                        if (insertCount > 0) {
                            const startIndex = normalizeSliceIndex((_b = args[0]) != null ? _b : 0, state.copy_.length);
                            handleInsertedValues(state, startIndex, args.slice(2));
                        }
                        return res;
                    }
                } else return handleNonMutatingOperation(state, method, args);
            } finally{
                exitOperation(state);
            }
        };
    }
    function handleNonMutatingOperation(state, method, args) {
        var _a, _b;
        const source = $5f9e38360d79f95a$var$latest(state);
        if (method === "filter") {
            const predicate = args[0];
            const thisArg = args[1];
            const result = [];
            for(let i = 0; i < source.length; i++)if (predicate.call(thisArg, source[i], i, source)) result.push(state.draft_[i]);
            return result;
        }
        if (FIND_METHODS.has(method)) {
            const predicate = args[0];
            const thisArg = args[1];
            const isForward = method === "find";
            const step = isForward ? 1 : -1;
            const start = isForward ? 0 : source.length - 1;
            for(let i = start; i >= 0 && i < source.length; i += step){
                if (predicate.call(thisArg, source[i], i, source)) return state.draft_[i];
            }
            return void 0;
        }
        if (method === "slice") {
            const rawStart = (_a = args[0]) != null ? _a : 0;
            const rawEnd = (_b = args[1]) != null ? _b : source.length;
            const start = normalizeSliceIndex(rawStart, source.length);
            const end = normalizeSliceIndex(rawEnd, source.length);
            const result = [];
            for(let i = start; i < end; i++)result.push(state.draft_[i]);
            return result;
        }
        return source[method](...args);
    }
    $5f9e38360d79f95a$var$loadPlugin($5f9e38360d79f95a$var$PluginArrayMethods, {
        createMethodInterceptor: createMethodInterceptor,
        isArrayOperationMethod: isArrayOperationMethod,
        isMutatingArrayMethod: isMutatingArrayMethod
    });
}
// src/immer.ts
var $5f9e38360d79f95a$var$immer = new $5f9e38360d79f95a$export$aaadc6ff0f822719();
var $5f9e38360d79f95a$export$b46cabe22e78bc00 = $5f9e38360d79f95a$var$immer.produce;
var $5f9e38360d79f95a$export$4da66d41c9492c78 = /* @__PURE__ */ $5f9e38360d79f95a$var$immer.produceWithPatches.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$573f26f60825c493 = /* @__PURE__ */ $5f9e38360d79f95a$var$immer.setAutoFreeze.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$333ce65961cbe047 = /* @__PURE__ */ $5f9e38360d79f95a$var$immer.setUseStrictShallowCopy.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$1045b3be3904c489 = /* @__PURE__ */ $5f9e38360d79f95a$var$immer.setUseStrictIteration.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$a8b8e03e6bbe5473 = /* @__PURE__ */ $5f9e38360d79f95a$var$immer.applyPatches.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$3c3214997190395f = /* @__PURE__ */ $5f9e38360d79f95a$var$immer.createDraft.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$c60f5e69c521b528 = /* @__PURE__ */ $5f9e38360d79f95a$var$immer.finishDraft.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$c05b21e3257751e5 = (value)=>value;
var $5f9e38360d79f95a$export$20f911b3f8cf0b74 = (value)=>value;


var $375276bea32f9eda$var$__defProp = Object.defineProperty;
var $375276bea32f9eda$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $375276bea32f9eda$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $375276bea32f9eda$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $375276bea32f9eda$var$__defNormalProp = (obj, key, value)=>key in obj ? $375276bea32f9eda$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $375276bea32f9eda$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($375276bea32f9eda$var$__hasOwnProp.call(b, prop)) $375276bea32f9eda$var$__defNormalProp(a, prop, b[prop]);
    if ($375276bea32f9eda$var$__getOwnPropSymbols) {
        for (var prop of $375276bea32f9eda$var$__getOwnPropSymbols(b))if ($375276bea32f9eda$var$__propIsEnum.call(b, prop)) $375276bea32f9eda$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
// src/devModeChecks/cacheSizeCheck.ts
var $375276bea32f9eda$var$CACHE_SIZE_CHECK_THRESHOLD = 1e3;
var $375276bea32f9eda$var$runCacheSizeCheck = (cacheSize, funcName)=>{
    let stack = void 0;
    try {
        throw new Error();
    } catch (e) {
        ({ stack: stack } = e);
    }
    console.warn(`A function memoized with weakMapMemoize${funcName ? ` (\`${funcName}\`)` : ""} has seen over ${cacheSize} distinct values for the same primitive argument position.
Results keyed by primitive arguments are held strongly and are only released by \`clearCache()\`, so this cache will keep growing for as long as the function keeps seeing new values.
If it is called with ever-changing primitives (ids, offsets, timestamps), pass the \`maxSize\` option to bound the cache, switch to \`lruMemoize\`, or call \`.clearCache()\` at a suitable point.
See https://reselect.js.org/api/development-only-checks#cachesizecheck for details.`, {
        stack: stack
    });
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $375276bea32f9eda$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once",
    cacheSizeCheck: "once"
};
var $375276bea32f9eda$export$1e290349de99e28c = (devModeChecks)=>{
    Object.assign($375276bea32f9eda$var$globalDevModeChecks, devModeChecks);
};
// src/weakMapMemoize.ts
var $375276bea32f9eda$var$StrongRef = class {
    constructor(value){
        this.value = value;
    }
    deref() {
        return this.value;
    }
};
var $375276bea32f9eda$var$getWeakRef = ()=>typeof WeakRef === "undefined" ? $375276bea32f9eda$var$StrongRef : WeakRef;
var $375276bea32f9eda$var$Ref = /* @__PURE__ */ $375276bea32f9eda$var$getWeakRef();
var $375276bea32f9eda$var$UNTERMINATED = 0;
var $375276bea32f9eda$var$TERMINATED = 1;
function $375276bea32f9eda$var$createCacheNode() {
    return {
        s: $375276bea32f9eda$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $375276bea32f9eda$var$maybeDeref(r) {
    if (r instanceof $375276bea32f9eda$var$Ref) return r.deref();
    return r;
}
function $375276bea32f9eda$export$8402dc26d96f6902(func, options = {}) {
    let fnNode = $375276bea32f9eda$var$createCacheNode();
    const { resultEqualityCheck: resultEqualityCheck, maxSize: maxSize } = options;
    const useGenerations = maxSize !== void 0;
    if (useGenerations && (!Number.isInteger(maxSize) || maxSize < 1)) throw new TypeError(`maxSize must be a positive integer, received: ${maxSize}`);
    let prevNode = null;
    let insertionCount = 0;
    let lastResult;
    let resultsCount = 0;
    let hasWarnedAboutCacheSize = false;
    function maybeFlipGenerations() {
        if (insertionCount >= maxSize) {
            prevNode = fnNode;
            fnNode = $375276bea32f9eda$var$createCacheNode();
            insertionCount = 0;
        }
    }
    function memoized() {
        let cacheNode = fnNode;
        const { length: length } = arguments;
        for(let i = 0, l = length; i < l; i++){
            const arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                let objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                const objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $375276bea32f9eda$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                let primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                const primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $375276bea32f9eda$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                    insertionCount++;
                } else cacheNode = primitiveNode;
            }
        }
        if (cacheNode.s === $375276bea32f9eda$var$TERMINATED) return cacheNode.v;
        if (prevNode !== null) {
            let prevCacheNode = prevNode;
            for(let i = 0, l = length; i < l; i++){
                const arg = arguments[i];
                let next;
                if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                    const prevObjectCache = prevCacheNode.o;
                    next = prevObjectCache !== null ? prevObjectCache.get(arg) : void 0;
                } else {
                    const prevPrimitiveCache = prevCacheNode.p;
                    next = prevPrimitiveCache !== null ? prevPrimitiveCache.get(arg) : void 0;
                }
                if (next === void 0) {
                    prevCacheNode = null;
                    break;
                }
                prevCacheNode = next;
            }
            if (prevCacheNode !== null && prevCacheNode.s === $375276bea32f9eda$var$TERMINATED) {
                const promotedNode = cacheNode;
                promotedNode.s = $375276bea32f9eda$var$TERMINATED;
                promotedNode.v = prevCacheNode.v;
                maybeFlipGenerations();
                return prevCacheNode.v;
            }
        }
        const terminatedNode = cacheNode;
        let result = func.apply(null, arguments);
        resultsCount++;
        if (resultEqualityCheck) {
            const lastResultValue = $375276bea32f9eda$var$maybeDeref(lastResult);
            if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                result = lastResultValue;
                resultsCount !== 0 && resultsCount--;
            }
            const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
            lastResult = needsWeakRef ? /* @__PURE__ */ new $375276bea32f9eda$var$Ref(result) : result;
        }
        terminatedNode.s = $375276bea32f9eda$var$TERMINATED;
        terminatedNode.v = result;
        if (useGenerations) maybeFlipGenerations();
        return result;
    }
    memoized.clearCache = ()=>{
        fnNode = $375276bea32f9eda$var$createCacheNode();
        prevNode = null;
        insertionCount = 0;
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/devModeChecks/identityFunctionCheck.ts
var $375276bea32f9eda$var$runIdentityFunctionCheck = (resultFunc, inputSelectorsResults, outputSelectorResult)=>{
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        let isInputSameAsOutput = false;
        try {
            const emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            let stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                ({ stack: stack } = e);
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $375276bea32f9eda$var$withoutResultEqualityCheck = (option)=>{
    if (option === null || typeof option !== "object" || !("resultEqualityCheck" in option)) return option;
    const optionCopy = $375276bea32f9eda$var$__spreadValues({}, option);
    delete optionCopy.resultEqualityCheck;
    return optionCopy;
};
var $375276bea32f9eda$var$runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs)=>{
    const { memoize: memoize, memoizeOptions: memoizeOptions } = options;
    const { inputSelectorResults: inputSelectorResults, inputSelectorResultsCopy: inputSelectorResultsCopy } = inputSelectorResultsObject;
    const probeMemoizeOptions = [];
    const { length: length } = memoizeOptions;
    for(let i = 0; i < length; i++)probeMemoizeOptions.push($375276bea32f9eda$var$withoutResultEqualityCheck(memoizeOptions[i]));
    const createAnEmptyObject = memoize(()=>({}), ...probeMemoizeOptions);
    const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack: stack } = e);
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/utils.ts
var $375276bea32f9eda$var$NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function $375276bea32f9eda$var$assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $375276bea32f9eda$var$assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function $375276bea32f9eda$var$assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
    if (!array.every((item)=>typeof item === "function")) {
        const itemTypes = array.map((item)=>typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item).join(", ");
        throw new TypeError(`${errorMessage}[${itemTypes}]`);
    }
}
var $375276bea32f9eda$var$ensureIsArray = (item)=>{
    return Array.isArray(item) ? item : [
        item
    ];
};
function $375276bea32f9eda$var$getDependencies(createSelectorArgs) {
    const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $375276bea32f9eda$var$assertIsArrayOfFunctions(dependencies, `createSelector expects all input-selectors to be functions, but received the following types: `);
    return dependencies;
}
function $375276bea32f9eda$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    const inputSelectorResults = [];
    const { length: length } = dependencies;
    for(let i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
// src/createSelectorCreator.ts
function $375276bea32f9eda$export$5943f4447f6ef248(memoizeOrOptions, ...memoizeOptionsFromArgs) {
    const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    const createSelector2 = (...createSelectorArgs)=>{
        let recomputations = 0;
        let dependencyRecomputations = 0;
        let lastResult;
        let directlyPassedOptions = {};
        let resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $375276bea32f9eda$var$assertIsFunction(resultFunc, `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`);
        const combinedOptions = $375276bea32f9eda$var$__spreadValues($375276bea32f9eda$var$__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        const { memoize: memoize, memoizeOptions: memoizeOptions = [], argsMemoize: argsMemoize = $375276bea32f9eda$export$8402dc26d96f6902, argsMemoizeOptions: argsMemoizeOptions = [] } = combinedOptions;
        const finalMemoizeOptions = $375276bea32f9eda$var$ensureIsArray(memoizeOptions);
        const finalArgsMemoizeOptions = $375276bea32f9eda$var$ensureIsArray(argsMemoizeOptions);
        const dependencies = $375276bea32f9eda$var$getDependencies(createSelectorArgs);
        const memoizedResultFunc = memoize(function recomputationWrapper() {
            recomputations++;
            return resultFunc.apply(null, arguments);
        }, ...finalMemoizeOptions);
        let firstRun = true;
        const selector = argsMemoize(function dependenciesChecker() {
            dependencyRecomputations++;
            const { length: length } = dependencies;
            const inputSelectorResults = new Array(length);
            for(let i = 0; i < length; i++)inputSelectorResults[i] = dependencies[i].apply(null, arguments);
            lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
            return lastResult;
        }, ...finalArgsMemoizeOptions);
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: ()=>dependencyRecomputations,
            resetDependencyRecomputations: ()=>{
                dependencyRecomputations = 0;
            },
            lastResult: ()=>lastResult,
            recomputations: ()=>recomputations,
            resetRecomputations: ()=>{
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: ()=>createSelector2
    });
    return createSelector2;
}
var $375276bea32f9eda$export$595d22ed68ca2841 = /* @__PURE__ */ $375276bea32f9eda$export$5943f4447f6ef248($375276bea32f9eda$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $375276bea32f9eda$export$75979cfcd91bf38f = /* @__PURE__ */ Object.assign((inputSelectorsObject, selectorCreator = $375276bea32f9eda$export$595d22ed68ca2841)=>{
    $375276bea32f9eda$var$assertIsObject(inputSelectorsObject, `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`);
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map((key)=>inputSelectorsObject[key]);
    const structuredSelector = selectorCreator(dependencies, (...inputSelectorResults)=>{
        return inputSelectorResults.reduce((composition, value, index)=>{
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: ()=>$375276bea32f9eda$export$75979cfcd91bf38f
});
// src/lruMemoize.ts
function $375276bea32f9eda$var$createSingletonCache(equals) {
    let entry;
    return {
        get (key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $375276bea32f9eda$var$NOT_FOUND;
        },
        put (key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        findMatchingEntry (value, resultEqualityCheck) {
            const current = entry;
            return current !== void 0 && resultEqualityCheck(current.value, value) ? current : void 0;
        },
        clear () {
            entry = void 0;
        }
    };
}
function $375276bea32f9eda$var$createLruCache(maxSize, equals) {
    let entries = [];
    function get(key) {
        const cacheIndex = entries.findIndex((entry)=>equals(entry.key, key));
        if (cacheIndex > -1) {
            const entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $375276bea32f9eda$var$NOT_FOUND;
    }
    function put(key, value) {
        entries.unshift({
            key: key,
            value: value
        });
        if (entries.length > maxSize) entries.pop();
    }
    function findMatchingEntry(value, resultEqualityCheck) {
        const currentEntries = entries;
        const { length: length } = currentEntries;
        for(let i = 0; i < length; i++){
            const entry = currentEntries[i];
            if (resultEqualityCheck(entry.value, value)) return entry;
        }
        return void 0;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        findMatchingEntry: findMatchingEntry,
        clear: clear
    };
}
var $375276bea32f9eda$export$3f025202a230c6dd = (a, b)=>a === b;
function $375276bea32f9eda$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        const { length: length } = prev;
        for(let i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $375276bea32f9eda$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    const { equalityCheck: equalityCheck = $375276bea32f9eda$export$3f025202a230c6dd, maxSize: maxSize = 1, resultEqualityCheck: resultEqualityCheck } = providedOptions;
    const comparator = $375276bea32f9eda$var$createCacheKeyComparator(equalityCheck);
    let resultsCount = 0;
    const cache = maxSize <= 1 ? $375276bea32f9eda$var$createSingletonCache(comparator) : $375276bea32f9eda$var$createLruCache(maxSize, comparator);
    function memoized() {
        let value = cache.get(arguments);
        if (value === $375276bea32f9eda$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const matchingEntry = cache.findMatchingEntry(value, resultEqualityCheck);
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = ()=>{
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}


// src/index.ts
function $44400fc0fe63e7bd$var$createThunkMiddleware(extraArgument) {
    const middleware = ({ dispatch: dispatch, getState: getState })=>(next)=>(action)=>{
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
    return middleware;
}
var $44400fc0fe63e7bd$export$dd164f5517779f15 = $44400fc0fe63e7bd$var$createThunkMiddleware();
var $44400fc0fe63e7bd$export$16d06542a1949d9e = $44400fc0fe63e7bd$var$createThunkMiddleware;


//#region src/createDraftSafeSelector.ts
const $d91034f47eb948f2$export$aab6de9e3dbb1473 = (...args)=>{
    const createSelector = (0, $375276bea32f9eda$export$5943f4447f6ef248)(...args);
    const createDraftSafeSelector = Object.assign((...args)=>{
        const selector = createSelector(...args);
        const wrappedSelector = (value, ...rest)=>selector((0, $5f9e38360d79f95a$export$541ac630993a4c84)(value) ? (0, $5f9e38360d79f95a$export$97aac956da55dae9)(value) : value, ...rest);
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: ()=>createDraftSafeSelector
    });
    return createDraftSafeSelector;
};
const $d91034f47eb948f2$export$a5d3c27355e35910 = /* @__PURE__ */ $d91034f47eb948f2$export$aab6de9e3dbb1473((0, $375276bea32f9eda$export$8402dc26d96f6902));
//#endregion
//#region src/devtoolsExtension.ts
const $d91034f47eb948f2$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $d2bed10dff9b4968$export$f672e0b6f7222cd7;
    return (0, $d2bed10dff9b4968$export$f672e0b6f7222cd7).apply(null, arguments);
};
typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__;
//#endregion
//#region src/tsHelpers.ts
const $d91034f47eb948f2$var$hasMatchFunction = (v)=>{
    return v && typeof v.match === "function";
};
//#endregion
//#region \0@oxc-project+runtime@0.144.0/helpers/esm/typeof.js
function $d91034f47eb948f2$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $d91034f47eb948f2$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $d91034f47eb948f2$var$_typeof(o);
}
//#endregion
//#region \0@oxc-project+runtime@0.144.0/helpers/esm/toPrimitive.js
function $d91034f47eb948f2$var$toPrimitive(t, r) {
    if ("object" != $d91034f47eb948f2$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $d91034f47eb948f2$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
//#endregion
//#region \0@oxc-project+runtime@0.144.0/helpers/esm/toPropertyKey.js
function $d91034f47eb948f2$var$toPropertyKey(t) {
    var i = $d91034f47eb948f2$var$toPrimitive(t, "string");
    return "symbol" == $d91034f47eb948f2$var$_typeof(i) ? i : i + "";
}
//#endregion
//#region \0@oxc-project+runtime@0.144.0/helpers/esm/defineProperty.js
function $d91034f47eb948f2$var$_defineProperty(e, r, t) {
    return (r = $d91034f47eb948f2$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
//#endregion
//#region \0@oxc-project+runtime@0.144.0/helpers/esm/objectSpread2.js
function $d91034f47eb948f2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d91034f47eb948f2$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d91034f47eb948f2$var$ownKeys(Object(t), !0).forEach(function(r) {
            $d91034f47eb948f2$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d91034f47eb948f2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
//#endregion
//#region src/createAction.ts
function $d91034f47eb948f2$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator(...args) {
        if (prepareAction) {
            let prepared = prepareAction(...args);
            if (!prepared) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(0));
            return $d91034f47eb948f2$var$_objectSpread2($d91034f47eb948f2$var$_objectSpread2({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = ()=>`${type}`;
    actionCreator.type = type;
    actionCreator.match = (action)=>(0, $d2bed10dff9b4968$export$b956e38827fca970)(action) && action.type === type;
    return actionCreator;
}
function $d91034f47eb948f2$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && $d91034f47eb948f2$var$hasMatchFunction(action);
}
function $d91034f47eb948f2$export$ebd532f9034651f3(action) {
    return (0, $d2bed10dff9b4968$export$b956e38827fca970)(action) && Object.keys(action).every($d91034f47eb948f2$var$isValidKey);
}
function $d91034f47eb948f2$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
//#endregion
//#region src/actionCreatorInvariantMiddleware.ts
function $d91034f47eb948f2$var$getMessage(type) {
    const splitType = type ? `${type}`.split("/") : [];
    const actionName = splitType[splitType.length - 1] || "actionCreator";
    return `Detected an action creator with type "${type || "unknown"}" being dispatched.
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${actionName}())\` instead of \`dispatch(${actionName})\`. This is necessary even if the action has no payload.`;
}
function $d91034f47eb948f2$export$6a1fcb4ceef578f(options = {}) {
    var next, action;
    return ()=>(next)=>(action)=>next(action);
}
//#endregion
//#region src/utils.ts
function $d91034f47eb948f2$var$getTimeMeasureUtils(maxDelay, fnName) {
    let elapsed = 0;
    return {
        measureTime (fn) {
            const started = Date.now();
            try {
                return fn();
            } finally{
                elapsed += Date.now() - started;
            }
        },
        warnIfExceeded () {
            if (elapsed > maxDelay) console.warn(`${fnName} took ${elapsed}ms, which is more than the warning threshold of ${maxDelay}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
        }
    };
}
var $d91034f47eb948f2$export$1908877435b1d5e9 = class Tuple extends Array {
    constructor(...items){
        super(...items);
        Object.setPrototypeOf(this, Tuple.prototype);
    }
    static get [Symbol.species]() {
        return Tuple;
    }
    concat(...arr) {
        return super.concat.apply(this, arr);
    }
    prepend(...arr) {
        if (arr.length === 1 && Array.isArray(arr[0])) return new Tuple(...arr[0].concat(this));
        return new Tuple(...arr.concat(this));
    }
};
function $d91034f47eb948f2$var$freezeDraftable(val) {
    return (0, $5f9e38360d79f95a$export$16e3aed3edb85946)(val) ? (0, $5f9e38360d79f95a$export$b46cabe22e78bc00)(val, ()=>{}) : val;
}
function $d91034f47eb948f2$var$getOrInsertComputed(map, key, compute) {
    if (map.has(key)) return map.get(key);
    return map.set(key, compute(key)).get(key);
}
//#endregion
//#region src/immutableStateInvariantMiddleware.ts
function $d91034f47eb948f2$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $d91034f47eb948f2$var$trackForMutations(isImmutable, ignoredPaths, obj) {
    const trackedProperties = $d91034f47eb948f2$var$trackProperties(isImmutable, ignoredPaths, obj);
    return {
        detectMutations () {
            return $d91034f47eb948f2$var$detectMutations(isImmutable, ignoredPaths, trackedProperties, obj);
        }
    };
}
function $d91034f47eb948f2$var$trackProperties(isImmutable, ignoredPaths = [], obj, path = "", inProgress = /* @__PURE__ */ new Map()) {
    const tracked = {
        value: obj
    };
    if (!isImmutable(obj)) {
        const alreadyInProgress = inProgress.get(obj);
        if (alreadyInProgress) return alreadyInProgress;
        tracked.children = {};
        inProgress.set(obj, tracked);
        const hasIgnoredPaths = ignoredPaths.length > 0;
        for(const key in obj){
            const nestedPath = path ? path + "." + key : key;
            if (hasIgnoredPaths) {
                if (ignoredPaths.some((ignored)=>{
                    if (ignored instanceof RegExp) return ignored.test(nestedPath);
                    return nestedPath === ignored;
                })) continue;
            }
            tracked.children[key] = $d91034f47eb948f2$var$trackProperties(isImmutable, ignoredPaths, obj[key], nestedPath, inProgress);
        }
        inProgress.delete(obj);
    }
    return tracked;
}
function $d91034f47eb948f2$var$detectMutations(isImmutable, ignoredPaths = [], trackedProperty, obj, sameParentRef = false, path = "", seen = /* @__PURE__ */ new Map()) {
    const prevObj = trackedProperty ? trackedProperty.value : void 0;
    const sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    let seenValues = seen.get(trackedProperty);
    if (!seenValues) {
        seenValues = /* @__PURE__ */ new Set();
        seen.set(trackedProperty, seenValues);
    } else if (seenValues.has(obj)) return {
        wasMutated: false
    };
    seenValues.add(obj);
    const keysToDetect = {};
    for(let key in trackedProperty.children)keysToDetect[key] = true;
    for(let key in obj)keysToDetect[key] = true;
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for(let key in keysToDetect){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            if (ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            })) continue;
        }
        const result = $d91034f47eb948f2$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath, seen);
        if (result.wasMutated) return result;
    }
    return {
        wasMutated: false
    };
}
function $d91034f47eb948f2$export$9181bb1a5474289(options = {}) {
    var stringify, getSerialize, getState, next, action;
    return ()=>(next)=>(action)=>next(action);
}
//#endregion
//#region src/serializableStateInvariantMiddleware.ts
function $d91034f47eb948f2$export$77670485918dab4e(val) {
    const type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, $d2bed10dff9b4968$export$53b83ca8eaab0383)(val);
}
function $d91034f47eb948f2$export$ada5dca0b571bc7(value, path = "", isSerializable = $d91034f47eb948f2$export$77670485918dab4e, getEntries, ignoredPaths = [], cache) {
    let foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache === null || cache === void 0 ? void 0 : cache.has(value)) return false;
    const entries = getEntries != null ? getEntries(value) : Object.entries(value);
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for (const [key, nestedValue] of entries){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            if (ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            })) continue;
        }
        if (!isSerializable(nestedValue)) return {
            keyPath: nestedPath,
            value: nestedValue
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $d91034f47eb948f2$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return foundNestedSerializable;
        }
    }
    if (cache && $d91034f47eb948f2$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $d91034f47eb948f2$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for (const nestedValue of Object.values(value)){
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$d91034f47eb948f2$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $d91034f47eb948f2$export$6dea1aad6dac5ac2(options = {}) {
    var storeAPI, next, action;
    return ()=>(next)=>(action)=>next(action);
}
//#endregion
//#region src/getDefaultMiddleware.ts
function $d91034f47eb948f2$var$isBoolean(x) {
    return typeof x === "boolean";
}
const $d91034f47eb948f2$var$buildGetDefaultMiddleware = ()=>function getDefaultMiddleware(options) {
        const { thunk: thunk$1 = true, immutableCheck: immutableCheck = true, serializableCheck: serializableCheck = true, actionCreatorCheck: actionCreatorCheck = true } = options !== null && options !== void 0 ? options : {};
        let middlewareArray = new $d91034f47eb948f2$export$1908877435b1d5e9();
        if (thunk$1) {
            if ($d91034f47eb948f2$var$isBoolean(thunk$1)) middlewareArray.push((0, $44400fc0fe63e7bd$export$dd164f5517779f15));
            else middlewareArray.push((0, $44400fc0fe63e7bd$export$16d06542a1949d9e)(thunk$1.extraArgument));
        }
        return middlewareArray;
    };
//#endregion
//#region src/autoBatchEnhancer.ts
const $d91034f47eb948f2$export$8fb31c0f05df007b = "RTK_autoBatch";
const $d91034f47eb948f2$export$39fcd5145ec5e4e2 = ()=>(payload)=>({
            payload: payload,
            meta: {
                [$d91034f47eb948f2$export$8fb31c0f05df007b]: true
            }
        });
const $d91034f47eb948f2$var$createQueueWithTimer = (timeout)=>{
    return (notify)=>{
        setTimeout(notify, timeout);
    };
};
const $d91034f47eb948f2$var$createRafWithFallbackTimer = (raf, timeout)=>{
    return (notify)=>{
        let called = false;
        let rafId;
        let timerId;
        const callback = ()=>{
            if (called) return;
            called = true;
            cancelAnimationFrame(rafId);
            clearTimeout(timerId);
            notify();
        };
        rafId = raf(callback);
        timerId = setTimeout(callback, timeout);
    };
};
const $d91034f47eb948f2$export$676277d7dca0f396 = (options = {
    type: "raf"
})=>(next)=>(...args)=>{
            const store = next(...args);
            let notifying = true;
            let shouldNotifyAtEndOfTick = false;
            let notificationQueued = false;
            const listeners = /* @__PURE__ */ new Set();
            const queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? typeof window !== "undefined" && window.requestAnimationFrame ? $d91034f47eb948f2$var$createRafWithFallbackTimer(window.requestAnimationFrame, 100) : $d91034f47eb948f2$var$createQueueWithTimer(10) : options.type === "callback" ? options.queueNotification : $d91034f47eb948f2$var$createQueueWithTimer(options.timeout);
            const notifyListeners = ()=>{
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach((l)=>l());
                }
            };
            return Object.assign({}, store, {
                subscribe (listener) {
                    const wrappedListener = ()=>notifying && listener();
                    const unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener);
                    return ()=>{
                        unsubscribe();
                        listeners.delete(listener);
                    };
                },
                dispatch (action) {
                    try {
                        var _action$meta;
                        notifying = !(action === null || action === void 0 || (_action$meta = action.meta) === null || _action$meta === void 0 ? void 0 : _action$meta[$d91034f47eb948f2$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
//#endregion
//#region src/getDefaultEnhancers.ts
const $d91034f47eb948f2$var$buildGetDefaultEnhancers = (middlewareEnhancer)=>function getDefaultEnhancers(options) {
        const { autoBatch: autoBatch = true } = options !== null && options !== void 0 ? options : {};
        let enhancerArray = new $d91034f47eb948f2$export$1908877435b1d5e9(middlewareEnhancer);
        if (autoBatch) enhancerArray.push($d91034f47eb948f2$export$676277d7dca0f396(typeof autoBatch === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
//#endregion
//#region src/configureStore.ts
function $d91034f47eb948f2$export$7d8a5b498da695ac(options) {
    const getDefaultMiddleware = $d91034f47eb948f2$var$buildGetDefaultMiddleware();
    const { reducer: reducer, middleware: middleware, devTools: devTools = true, duplicateMiddlewareCheck: duplicateMiddlewareCheck = true, preloadedState: preloadedState, enhancers: enhancers } = options || {};
    let rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, $d2bed10dff9b4968$export$53b83ca8eaab0383)(reducer)) rootReducer = (0, $d2bed10dff9b4968$export$66e4520cdb265d18)(reducer);
    else throw new Error($d91034f47eb948f2$export$378fa86b259c0280(1));
    let finalMiddleware;
    if (typeof middleware === "function") finalMiddleware = middleware(getDefaultMiddleware);
    else finalMiddleware = getDefaultMiddleware();
    var middleware1;
    let finalCompose = (0, $d2bed10dff9b4968$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $d91034f47eb948f2$var$composeWithDevTools($d91034f47eb948f2$var$_objectSpread2({
        trace: false
    }, typeof devTools === "object" && devTools));
    const middlewareEnhancer = (0, $d2bed10dff9b4968$export$9ff26e0402cc7b7)(...finalMiddleware);
    const getDefaultEnhancers = $d91034f47eb948f2$var$buildGetDefaultEnhancers(middlewareEnhancer);
    let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    const composedEnhancer = finalCompose(...storeEnhancers);
    return (0, $d2bed10dff9b4968$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
//#endregion
//#region src/mapBuilders.ts
function $d91034f47eb948f2$var$executeReducerBuilderCallback(builderCallback) {
    const actionsMap = {};
    const actionMatchers = [];
    let defaultCaseReducer;
    const builder = {
        addCase (typeOrActionCreator, reducer) {
            const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(28));
            if (type in actionsMap) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addAsyncThunk (asyncThunk, reducers) {
            if (reducers.pending) actionsMap[asyncThunk.pending.type] = reducers.pending;
            if (reducers.rejected) actionsMap[asyncThunk.rejected.type] = reducers.rejected;
            if (reducers.fulfilled) actionsMap[asyncThunk.fulfilled.type] = reducers.fulfilled;
            if (reducers.settled) actionMatchers.push({
                matcher: asyncThunk.settled,
                reducer: reducers.settled
            });
            return builder;
        },
        addMatcher (matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase (reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
//#endregion
//#region src/createReducer.ts
function $d91034f47eb948f2$var$isStateFunction(x) {
    return typeof x === "function";
}
function $d91034f47eb948f2$export$473eb76d322d0290(initialState, mapOrBuilderCallback) {
    let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = $d91034f47eb948f2$var$executeReducerBuilderCallback(mapOrBuilderCallback);
    let getInitialState;
    if ($d91034f47eb948f2$var$isStateFunction(initialState)) getInitialState = ()=>$d91034f47eb948f2$var$freezeDraftable(initialState());
    else {
        const frozenInitialState = $d91034f47eb948f2$var$freezeDraftable(initialState);
        getInitialState = ()=>frozenInitialState;
    }
    function reducer(state = getInitialState(), action) {
        let caseReducers = [
            actionsMap[action.type],
            ...finalActionMatchers.filter(({ matcher: matcher })=>matcher(action)).map(({ reducer: reducer })=>reducer)
        ];
        if (caseReducers.filter((cr)=>!!cr).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce((previousState, caseReducer)=>{
            if (caseReducer) {
                if ((0, $5f9e38360d79f95a$export$541ac630993a4c84)(previousState)) {
                    const result = caseReducer(previousState, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $5f9e38360d79f95a$export$16e3aed3edb85946)(previousState)) {
                    const result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw new Error($d91034f47eb948f2$export$378fa86b259c0280(9));
                    }
                    return result;
                } else return (0, $5f9e38360d79f95a$export$b46cabe22e78bc00)(previousState, (draft)=>{
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
//#endregion
//#region src/matchers.ts
const $d91034f47eb948f2$var$matches = (matcher, action)=>{
    if ($d91034f47eb948f2$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $d91034f47eb948f2$export$2c3435c7647f7b0d(...matchers) {
    return (action)=>{
        return matchers.some((matcher)=>$d91034f47eb948f2$var$matches(matcher, action));
    };
}
function $d91034f47eb948f2$export$9dd1fb32974da385(...matchers) {
    return (action)=>{
        return matchers.every((matcher)=>$d91034f47eb948f2$var$matches(matcher, action));
    };
}
function $d91034f47eb948f2$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    const hasValidRequestId = typeof action.meta.requestId === "string";
    const hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $d91034f47eb948f2$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $d91034f47eb948f2$export$872dec21e9a69476(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$d91034f47eb948f2$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    if (!$d91034f47eb948f2$var$isAsyncThunkArray(asyncThunks)) return $d91034f47eb948f2$export$872dec21e9a69476()(asyncThunks[0]);
    return $d91034f47eb948f2$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.pending));
}
function $d91034f47eb948f2$export$a5c5d27e3994c5be(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$d91034f47eb948f2$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    if (!$d91034f47eb948f2$var$isAsyncThunkArray(asyncThunks)) return $d91034f47eb948f2$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return $d91034f47eb948f2$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.rejected));
}
function $d91034f47eb948f2$export$fcc3388fb56de601(...asyncThunks) {
    const hasFlag = (action)=>{
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return $d91034f47eb948f2$export$9dd1fb32974da385($d91034f47eb948f2$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
    if (!$d91034f47eb948f2$var$isAsyncThunkArray(asyncThunks)) return $d91034f47eb948f2$export$fcc3388fb56de601()(asyncThunks[0]);
    return $d91034f47eb948f2$export$9dd1fb32974da385($d91034f47eb948f2$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
}
function $d91034f47eb948f2$export$1da80a6ef1307441(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$d91034f47eb948f2$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    if (!$d91034f47eb948f2$var$isAsyncThunkArray(asyncThunks)) return $d91034f47eb948f2$export$1da80a6ef1307441()(asyncThunks[0]);
    return $d91034f47eb948f2$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.fulfilled));
}
function $d91034f47eb948f2$export$6aa4142d99c1abce(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$d91034f47eb948f2$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    if (!$d91034f47eb948f2$var$isAsyncThunkArray(asyncThunks)) return $d91034f47eb948f2$export$6aa4142d99c1abce()(asyncThunks[0]);
    return $d91034f47eb948f2$export$2c3435c7647f7b0d(...asyncThunks.flatMap((asyncThunk)=>[
            asyncThunk.pending,
            asyncThunk.rejected,
            asyncThunk.fulfilled
        ]));
}
//#endregion
//#region src/nanoid.ts
let $d91034f47eb948f2$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
let $d91034f47eb948f2$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += $d91034f47eb948f2$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
//#endregion
//#region src/createAsyncThunk.ts
const $d91034f47eb948f2$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $d91034f47eb948f2$var$RejectWithValue = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        $d91034f47eb948f2$var$_defineProperty(this, "_type", void 0);
    }
};
var $d91034f47eb948f2$var$FulfillWithMeta = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        $d91034f47eb948f2$var$_defineProperty(this, "_type", void 0);
    }
};
const $d91034f47eb948f2$export$c97c53d0b2d5d81e = (value)=>{
    if (typeof value === "object" && value !== null) {
        const simpleError = {};
        for (const property of $d91034f47eb948f2$var$commonProperties)if (typeof value[property] === "string") simpleError[property] = value[property];
        return simpleError;
    }
    return {
        message: String(value)
    };
};
const $d91034f47eb948f2$var$externalAbortMessage = "External signal was aborted";
const $d91034f47eb948f2$export$6abd22dc03e5063f = /* @__PURE__ */ (()=>{
    function createAsyncThunk(typePrefix, payloadCreator, options) {
        const fulfilled = $d91034f47eb948f2$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", (payload, requestId, arg, meta)=>({
                payload: payload,
                meta: $d91034f47eb948f2$var$_objectSpread2($d91034f47eb948f2$var$_objectSpread2({}, meta || {}), {}, {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            }));
        const pending = $d91034f47eb948f2$export$309c7a02b0b0bc62(typePrefix + "/pending", (requestId, arg, meta)=>({
                payload: void 0,
                meta: $d91034f47eb948f2$var$_objectSpread2($d91034f47eb948f2$var$_objectSpread2({}, meta || {}), {}, {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            }));
        const rejected = $d91034f47eb948f2$export$309c7a02b0b0bc62(typePrefix + "/rejected", (error, requestId, arg, payload, meta)=>({
                payload: payload,
                error: (options && options.serializeError || $d91034f47eb948f2$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $d91034f47eb948f2$var$_objectSpread2($d91034f47eb948f2$var$_objectSpread2({}, meta || {}), {}, {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: payload !== void 0,
                    requestStatus: "rejected",
                    aborted: (error === null || error === void 0 ? void 0 : error.name) === "AbortError",
                    condition: (error === null || error === void 0 ? void 0 : error.name) === "ConditionError"
                })
            }));
        function actionCreator(arg, { signal: signal } = {}) {
            return (dispatch, getState, extra)=>{
                const requestId = (options === null || options === void 0 ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $d91034f47eb948f2$export$ac4959f4f1338dfc();
                const abortController = new AbortController();
                let abortHandler;
                let abortReason;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                if (signal) {
                    if (signal.aborted) abort($d91034f47eb948f2$var$externalAbortMessage);
                    else signal.addEventListener("abort", ()=>abort($d91034f47eb948f2$var$externalAbortMessage), {
                        once: true
                    });
                }
                const promise = async function() {
                    let finalAction;
                    try {
                        var _options$condition, _options$getPendingMe;
                        let conditionResult = options === null || options === void 0 || (_options$condition = options.condition) === null || _options$condition === void 0 ? void 0 : _options$condition.call(options, arg, {
                            getState: getState,
                            extra: extra
                        });
                        if ($d91034f47eb948f2$var$isThenable(conditionResult)) conditionResult = await conditionResult;
                        if (conditionResult === false) throw {
                            name: "ConditionError",
                            message: "Aborted due to condition callback returning false."
                        };
                        if (abortController.signal.aborted) throw {
                            name: "AbortError",
                            message: abortReason || "Aborted"
                        };
                        const abortedPromise = new Promise((_, reject)=>{
                            abortHandler = ()=>{
                                reject({
                                    name: "AbortError",
                                    message: abortReason || "Aborted"
                                });
                            };
                            abortController.signal.addEventListener("abort", abortHandler, {
                                once: true
                            });
                        });
                        dispatch(pending(requestId, arg, options === null || options === void 0 || (_options$getPendingMe = options.getPendingMeta) === null || _options$getPendingMe === void 0 ? void 0 : _options$getPendingMe.call(options, {
                            requestId: requestId,
                            arg: arg
                        }, {
                            getState: getState,
                            extra: extra
                        })));
                        finalAction = await Promise.race([
                            abortedPromise,
                            Promise.resolve(payloadCreator(arg, {
                                dispatch: dispatch,
                                getState: getState,
                                extra: extra,
                                requestId: requestId,
                                signal: abortController.signal,
                                abort: abort,
                                rejectWithValue: (value, meta)=>{
                                    return new $d91034f47eb948f2$var$RejectWithValue(value, meta);
                                },
                                fulfillWithValue: (value, meta)=>{
                                    return new $d91034f47eb948f2$var$FulfillWithMeta(value, meta);
                                }
                            })).then((result)=>{
                                if (result instanceof $d91034f47eb948f2$var$RejectWithValue) throw result;
                                if (result instanceof $d91034f47eb948f2$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                return fulfilled(result, requestId, arg);
                            })
                        ]);
                    } catch (err) {
                        finalAction = err instanceof $d91034f47eb948f2$var$RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                    } finally{
                        if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                    }
                    if (!(options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition)) dispatch(finalAction);
                    return finalAction;
                }();
                return Object.assign(promise, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap () {
                        return promise.then($d91034f47eb948f2$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            settled: $d91034f47eb948f2$export$2c3435c7647f7b0d(rejected, fulfilled),
            typePrefix: typePrefix
        });
    }
    createAsyncThunk.withTypes = ()=>createAsyncThunk;
    return createAsyncThunk;
})();
function $d91034f47eb948f2$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $d91034f47eb948f2$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
//#endregion
//#region \0@oxc-project+runtime@0.144.0/helpers/esm/objectWithoutPropertiesLoose.js
function $d91034f47eb948f2$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
//#endregion
//#region \0@oxc-project+runtime@0.144.0/helpers/esm/objectWithoutProperties.js
function $d91034f47eb948f2$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $d91034f47eb948f2$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
//#endregion
//#region src/createSlice.ts
const $d91034f47eb948f2$var$_excluded = [
    "reducerPath"
];
const $d91034f47eb948f2$var$asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
const $d91034f47eb948f2$export$343355ed40c51c46 = {
    [$d91034f47eb948f2$var$asyncThunkSymbol]: $d91034f47eb948f2$export$6abd22dc03e5063f
};
let $d91034f47eb948f2$export$23a094319a4b586 = /* @__PURE__ */ function(ReducerType) {
    ReducerType["reducer"] = "reducer";
    ReducerType["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType["asyncThunk"] = "asyncThunk";
    return ReducerType;
}({});
function $d91034f47eb948f2$var$getType(slice, actionKey) {
    return `${slice}/${actionKey}`;
}
function $d91034f47eb948f2$export$affdea4146de9cf5({ creators: creators } = {}) {
    var _creators$asyncThunk;
    const cAT = creators === null || creators === void 0 || (_creators$asyncThunk = creators.asyncThunk) === null || _creators$asyncThunk === void 0 ? void 0 : _creators$asyncThunk[$d91034f47eb948f2$var$asyncThunkSymbol];
    return function createSlice(options) {
        const { name: name, reducerPath: reducerPath = name } = options;
        if (!name) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(11));
        const reducers = (typeof options.reducers === "function" ? options.reducers($d91034f47eb948f2$var$buildReducerCreators()) : options.reducers) || {};
        const reducerNames = Object.keys(reducers);
        const context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        const contextMethods = {
            addCase (typeOrActionCreator, reducer) {
                const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(12));
                if (type in context.sliceCaseReducersByType) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(13));
                context.sliceCaseReducersByType[type] = reducer;
                return contextMethods;
            },
            addMatcher (matcher, reducer) {
                context.sliceMatchers.push({
                    matcher: matcher,
                    reducer: reducer
                });
                return contextMethods;
            },
            exposeAction (name, actionCreator) {
                context.actionCreators[name] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer (name, reducer) {
                context.sliceCaseReducersByName[name] = reducer;
                return contextMethods;
            }
        };
        reducerNames.forEach((reducerName)=>{
            const reducerDefinition = reducers[reducerName];
            const reducerDetails = {
                reducerName: reducerName,
                type: $d91034f47eb948f2$var$getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if ($d91034f47eb948f2$var$isAsyncThunkSliceReducerDefinition(reducerDefinition)) $d91034f47eb948f2$var$handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else $d91034f47eb948f2$var$handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            const [extraReducers = {}, actionMatchers = [], defaultCaseReducer] = typeof options.extraReducers === "function" ? $d91034f47eb948f2$var$executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ];
            const finalCaseReducers = $d91034f47eb948f2$var$_objectSpread2($d91034f47eb948f2$var$_objectSpread2({}, extraReducers), context.sliceCaseReducersByType);
            return $d91034f47eb948f2$export$473eb76d322d0290(options.initialState, (builder)=>{
                for(let key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                for (let sM of context.sliceMatchers)builder.addMatcher(sM.matcher, sM.reducer);
                for (let m of actionMatchers)builder.addMatcher(m.matcher, m.reducer);
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        const selectSelf = (state)=>state;
        const injectedSelectorCache = /* @__PURE__ */ new Map();
        const injectedStateCache = /* @__PURE__ */ new WeakMap();
        let _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath, injected = false) {
            function selectSlice(state) {
                let sliceState = state[reducerPath];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = $d91034f47eb948f2$var$getOrInsertComputed(injectedStateCache, selectSlice, getInitialState);
                }
                return sliceState;
            }
            function getSelectors(selectState = selectSelf) {
                return $d91034f47eb948f2$var$getOrInsertComputed($d91034f47eb948f2$var$getOrInsertComputed(injectedSelectorCache, injected, ()=>/* @__PURE__ */ new WeakMap()), selectState, ()=>{
                    var _options$selectors;
                    const map = {};
                    for (const [name, selector] of Object.entries((_options$selectors = options.selectors) !== null && _options$selectors !== void 0 ? _options$selectors : {}))map[name] = $d91034f47eb948f2$var$wrapSelector(selector, selectState, ()=>$d91034f47eb948f2$var$getOrInsertComputed(injectedStateCache, selectState, getInitialState), injected);
                    return map;
                });
            }
            return {
                reducerPath: reducerPath,
                getSelectors: getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice: selectSlice
            };
        }
        const slice = $d91034f47eb948f2$var$_objectSpread2($d91034f47eb948f2$var$_objectSpread2({
            name: name,
            reducer: reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState: getInitialState
        }, makeSelectorProps(reducerPath)), {}, {
            injectInto (injectable, _ref = {}) {
                let { reducerPath: pathOpt } = _ref, config = $d91034f47eb948f2$var$_objectWithoutProperties(_ref, $d91034f47eb948f2$var$_excluded);
                const newReducerPath = pathOpt !== null && pathOpt !== void 0 ? pathOpt : reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer: reducer
                }, config);
                return $d91034f47eb948f2$var$_objectSpread2($d91034f47eb948f2$var$_objectSpread2({}, slice), makeSelectorProps(newReducerPath, true));
            }
        });
        return slice;
    };
}
function $d91034f47eb948f2$var$wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState, ...args) {
        let sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector(sliceState, ...args);
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
const $d91034f47eb948f2$export$4d8d9bd83c24ae8b = /* @__PURE__ */ $d91034f47eb948f2$export$affdea4146de9cf5();
function $d91034f47eb948f2$var$buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return $d91034f47eb948f2$var$_objectSpread2({
            _reducerDefinitionType: "asyncThunk",
            payloadCreator: payloadCreator
        }, config);
    }
    asyncThunk.withTypes = ()=>asyncThunk;
    return {
        reducer (caseReducer) {
            return Object.assign({
                [caseReducer.name] (...args) {
                    return caseReducer(...args);
                }
            }[caseReducer.name], {
                _reducerDefinitionType: "reducer"
            });
        },
        preparedReducer (prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare",
                prepare: prepare,
                reducer: reducer
            };
        },
        asyncThunk: asyncThunk
    };
}
function $d91034f47eb948f2$var$handleNormalReducerDefinition({ type: type, reducerName: reducerName, createNotation: createNotation }, maybeReducerWithPrepare, context) {
    let caseReducer;
    let prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !$d91034f47eb948f2$var$isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? $d91034f47eb948f2$export$309c7a02b0b0bc62(type, prepareCallback) : $d91034f47eb948f2$export$309c7a02b0b0bc62(type));
}
function $d91034f47eb948f2$var$isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk";
}
function $d91034f47eb948f2$var$isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare";
}
function $d91034f47eb948f2$var$handleThunkCaseReducerDefinition({ type: type, reducerName: reducerName }, reducerDefinition, context, cAT) {
    if (!cAT) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(18));
    const { payloadCreator: payloadCreator, fulfilled: fulfilled, pending: pending, rejected: rejected, settled: settled, options: options } = reducerDefinition;
    const thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || $d91034f47eb948f2$var$noop$1,
        pending: pending || $d91034f47eb948f2$var$noop$1,
        rejected: rejected || $d91034f47eb948f2$var$noop$1,
        settled: settled || $d91034f47eb948f2$var$noop$1
    });
}
function $d91034f47eb948f2$var$noop$1() {}
//#endregion
//#region src/entities/entity_state.ts
function $d91034f47eb948f2$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $d91034f47eb948f2$var$createInitialStateFactory(stateAdapter) {
    function getInitialState(additionalState = {}, entities) {
        const state = Object.assign($d91034f47eb948f2$var$getInitialEntityState(), additionalState);
        return entities ? stateAdapter.setAll(state, entities) : state;
    }
    return {
        getInitialState: getInitialState
    };
}
//#endregion
//#region src/entities/state_selectors.ts
function $d91034f47eb948f2$var$createSelectorsFactory() {
    function getSelectors(selectState, options = {}) {
        const { createSelector: createSelector = $d91034f47eb948f2$export$a5d3c27355e35910 } = options;
        const selectIds = (state)=>state.ids;
        const selectEntities = (state)=>state.entities;
        const selectAll = createSelector(selectIds, selectEntities, (ids, entities)=>ids.map((id)=>entities[id]));
        const selectId = (_, id)=>id;
        const selectById = (entities, id)=>entities[id];
        const selectTotal = createSelector(selectIds, (ids)=>ids.length);
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createSelector(selectEntities, selectId, selectById)
        };
        const selectGlobalizedEntities = createSelector(selectState, selectEntities);
        return {
            selectIds: createSelector(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector(selectState, selectAll),
            selectTotal: createSelector(selectState, selectTotal),
            selectById: createSelector(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
//#endregion
//#region src/entities/state_adapter.ts
const $d91034f47eb948f2$var$isDraftTyped = (0, $5f9e38360d79f95a$export$541ac630993a4c84);
function $d91034f47eb948f2$var$createSingleArgumentStateOperator(mutator) {
    const operator = $d91034f47eb948f2$var$createStateOperator((_, state)=>mutator(state));
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $d91034f47eb948f2$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg) {
            return $d91034f47eb948f2$export$ebd532f9034651f3(arg);
        }
        const runMutator = (draft)=>{
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ($d91034f47eb948f2$var$isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, $5f9e38360d79f95a$export$b46cabe22e78bc00)(state, runMutator);
    };
}
//#endregion
//#region src/entities/utils.ts
function $d91034f47eb948f2$var$selectIdValue(entity, selectId) {
    const key = selectId(entity);
    return key;
}
function $d91034f47eb948f2$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $d91034f47eb948f2$var$getCurrent(value) {
    return (0, $5f9e38360d79f95a$export$541ac630993a4c84)(value) ? (0, $5f9e38360d79f95a$export$97aac956da55dae9)(value) : value;
}
function $d91034f47eb948f2$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
    const existingIdsArray = $d91034f47eb948f2$var$getCurrent(state.ids);
    const existingIds = new Set(existingIdsArray);
    const added = [];
    const addedIds = /* @__PURE__ */ new Set([]);
    const updated = [];
    for (const entity of newEntities){
        const id = $d91034f47eb948f2$var$selectIdValue(entity, selectId);
        if (existingIds.has(id) || addedIds.has(id)) updated.push({
            id: id,
            changes: entity
        });
        else {
            addedIds.add(id);
            added.push(entity);
        }
    }
    return [
        added,
        updated,
        existingIdsArray
    ];
}
//#endregion
//#region src/entities/unsorted_state_adapter.ts
function $d91034f47eb948f2$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        const key = $d91034f47eb948f2$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)addOneMutably(entity, state);
    }
    function setOneMutably(entity, state) {
        const key = $d91034f47eb948f2$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)setOneMutably(entity, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        setManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        let didMutate = false;
        keys.forEach((key)=>{
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter((id)=>id in state.entities);
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        const original = state.entities[update.id];
        if (original === void 0) return false;
        const updated = Object.assign({}, original, update.changes);
        const newKey = $d91034f47eb948f2$var$selectIdValue(updated, selectId);
        const hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        const newKeys = {};
        const updatesPerEntity = {};
        updates.forEach((update)=>{
            if (update.id in state.entities) {
                var _updatesPerEntity$upd;
                updatesPerEntity[update.id] = {
                    id: update.id,
                    changes: $d91034f47eb948f2$var$_objectSpread2($d91034f47eb948f2$var$_objectSpread2({}, (_updatesPerEntity$upd = updatesPerEntity[update.id]) === null || _updatesPerEntity$upd === void 0 ? void 0 : _updatesPerEntity$upd.changes), update.changes)
                };
            }
        });
        updates = Object.values(updatesPerEntity);
        if (updates.length > 0) {
            if (updates.filter((update)=>takeNewKey(newKeys, update, state)).length > 0) state.ids = Object.values(state.entities).map((e)=>$d91034f47eb948f2$var$selectIdValue(e, selectId));
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated] = $d91034f47eb948f2$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        addManyMutably(added, state);
        updateManyMutably(updated, state);
    }
    return {
        removeAll: $d91034f47eb948f2$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $d91034f47eb948f2$var$createStateOperator(addOneMutably),
        addMany: $d91034f47eb948f2$var$createStateOperator(addManyMutably),
        setOne: $d91034f47eb948f2$var$createStateOperator(setOneMutably),
        setMany: $d91034f47eb948f2$var$createStateOperator(setManyMutably),
        setAll: $d91034f47eb948f2$var$createStateOperator(setAllMutably),
        updateOne: $d91034f47eb948f2$var$createStateOperator(updateOneMutably),
        updateMany: $d91034f47eb948f2$var$createStateOperator(updateManyMutably),
        upsertOne: $d91034f47eb948f2$var$createStateOperator(upsertOneMutably),
        upsertMany: $d91034f47eb948f2$var$createStateOperator(upsertManyMutably),
        removeOne: $d91034f47eb948f2$var$createStateOperator(removeOneMutably),
        removeMany: $d91034f47eb948f2$var$createStateOperator(removeManyMutably)
    };
}
//#endregion
//#region src/entities/sorted_state_adapter.ts
function $d91034f47eb948f2$var$findInsertIndex(sortedItems, item, comparisonFunction) {
    let lowIndex = 0;
    let highIndex = sortedItems.length;
    while(lowIndex < highIndex){
        let middleIndex = lowIndex + highIndex >>> 1;
        const currentItem = sortedItems[middleIndex];
        if (comparisonFunction(item, currentItem) >= 0) lowIndex = middleIndex + 1;
        else highIndex = middleIndex;
    }
    return lowIndex;
}
function $d91034f47eb948f2$var$insert(sortedItems, item, comparisonFunction) {
    const insertAtIndex = $d91034f47eb948f2$var$findInsertIndex(sortedItems, item, comparisonFunction);
    sortedItems.splice(insertAtIndex, 0, item);
    return sortedItems;
}
function $d91034f47eb948f2$var$createSortedStateAdapter(selectId, comparer) {
    const { removeOne: removeOne, removeMany: removeMany, removeAll: removeAll } = $d91034f47eb948f2$var$createUnsortedStateAdapter(selectId);
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state, existingIds) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        const existingKeys = new Set(existingIds !== null && existingIds !== void 0 ? existingIds : $d91034f47eb948f2$var$getCurrent(state.ids));
        const addedKeys = /* @__PURE__ */ new Set();
        const models = newEntities.filter((model)=>{
            const modelId = $d91034f47eb948f2$var$selectIdValue(model, selectId);
            const notAdded = !addedKeys.has(modelId);
            if (notAdded) addedKeys.add(modelId);
            return !existingKeys.has(modelId) && notAdded;
        });
        if (models.length !== 0) mergeFunction(state, models);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        let deduplicatedEntities = {};
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            for (const item of newEntities){
                const entityId = selectId(item);
                deduplicatedEntities[entityId] = item;
                delete state.entities[entityId];
            }
            newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(deduplicatedEntities);
            mergeFunction(state, newEntities);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        setManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        let appliedUpdates = false;
        let replacedIds = false;
        const updatesPerEntity = {};
        for (const update of updates)if (update.id in state.entities) {
            var _updatesPerEntity$upd;
            updatesPerEntity[update.id] = {
                id: update.id,
                changes: $d91034f47eb948f2$var$_objectSpread2($d91034f47eb948f2$var$_objectSpread2({}, (_updatesPerEntity$upd = updatesPerEntity[update.id]) === null || _updatesPerEntity$upd === void 0 ? void 0 : _updatesPerEntity$upd.changes), update.changes)
            };
        }
        for (const update of Object.values(updatesPerEntity)){
            const entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            const newId = selectId(entity);
            if (update.id !== newId) {
                replacedIds = true;
                delete state.entities[update.id];
                const oldIndex = state.ids.indexOf(update.id);
                state.ids[oldIndex] = newId;
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) mergeFunction(state, [], appliedUpdates, replacedIds);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated, existingIdsArray] = $d91034f47eb948f2$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        if (added.length) addManyMutably(added, state, existingIdsArray);
        if (updated.length) updateManyMutably(updated, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    function mergeFunction(state, addedItems, appliedUpdates, replacedIds) {
        const currentEntities = $d91034f47eb948f2$var$getCurrent(state.entities);
        const currentIds = $d91034f47eb948f2$var$getCurrent(state.ids);
        const stateEntities = state.entities;
        let ids = currentIds;
        if (replacedIds) ids = new Set(currentIds);
        let sortedEntities = [];
        for (const id of ids){
            const entity = currentEntities[id];
            if (entity) sortedEntities.push(entity);
        }
        const wasPreviouslyEmpty = sortedEntities.length === 0;
        for (const item of addedItems){
            stateEntities[selectId(item)] = item;
            if (!wasPreviouslyEmpty) $d91034f47eb948f2$var$insert(sortedEntities, item, comparer);
        }
        if (wasPreviouslyEmpty) sortedEntities = addedItems.slice().sort(comparer);
        else if (appliedUpdates) sortedEntities.sort(comparer);
        const newSortedIds = sortedEntities.map(selectId);
        if (!areArraysEqual(currentIds, newSortedIds)) state.ids = newSortedIds;
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $d91034f47eb948f2$var$createStateOperator(addOneMutably),
        updateOne: $d91034f47eb948f2$var$createStateOperator(updateOneMutably),
        upsertOne: $d91034f47eb948f2$var$createStateOperator(upsertOneMutably),
        setOne: $d91034f47eb948f2$var$createStateOperator(setOneMutably),
        setMany: $d91034f47eb948f2$var$createStateOperator(setManyMutably),
        setAll: $d91034f47eb948f2$var$createStateOperator(setAllMutably),
        addMany: $d91034f47eb948f2$var$createStateOperator(addManyMutably),
        updateMany: $d91034f47eb948f2$var$createStateOperator(updateManyMutably),
        upsertMany: $d91034f47eb948f2$var$createStateOperator(upsertManyMutably)
    };
}
//#endregion
//#region src/entities/create_adapter.ts
function $d91034f47eb948f2$export$abcf4037b41e0df(options = {}) {
    const { selectId: selectId, sortComparer: sortComparer } = $d91034f47eb948f2$var$_objectSpread2({
        sortComparer: false,
        selectId: (instance)=>instance.id
    }, options);
    const stateAdapter = sortComparer ? $d91034f47eb948f2$var$createSortedStateAdapter(selectId, sortComparer) : $d91034f47eb948f2$var$createUnsortedStateAdapter(selectId);
    const stateFactory = $d91034f47eb948f2$var$createInitialStateFactory(stateAdapter);
    const selectorsFactory = $d91034f47eb948f2$var$createSelectorsFactory();
    return $d91034f47eb948f2$var$_objectSpread2($d91034f47eb948f2$var$_objectSpread2($d91034f47eb948f2$var$_objectSpread2({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
//#endregion
//#region src/listenerMiddleware/exceptions.ts
const $d91034f47eb948f2$var$task = "task";
const $d91034f47eb948f2$var$listener = "listener";
const $d91034f47eb948f2$var$completed = "completed";
const $d91034f47eb948f2$var$cancelled = "cancelled";
const $d91034f47eb948f2$var$taskCancelled = `task-${$d91034f47eb948f2$var$cancelled}`;
const $d91034f47eb948f2$var$taskCompleted = `task-${$d91034f47eb948f2$var$completed}`;
const $d91034f47eb948f2$var$listenerCancelled = `${$d91034f47eb948f2$var$listener}-${$d91034f47eb948f2$var$cancelled}`;
const $d91034f47eb948f2$var$listenerCompleted = `${$d91034f47eb948f2$var$listener}-${$d91034f47eb948f2$var$completed}`;
var $d91034f47eb948f2$export$cb1bdac908fed7f = class {
    constructor(code){
        this.code = code;
        $d91034f47eb948f2$var$_defineProperty(this, "name", "TaskAbortError");
        $d91034f47eb948f2$var$_defineProperty(this, "message", void 0);
        this.message = `${$d91034f47eb948f2$var$task} ${$d91034f47eb948f2$var$cancelled} (reason: ${code})`;
    }
};
//#endregion
//#region src/listenerMiddleware/utils.ts
const $d91034f47eb948f2$var$assertFunction = (func, expected)=>{
    if (typeof func !== "function") throw new TypeError($d91034f47eb948f2$export$378fa86b259c0280(32));
};
const $d91034f47eb948f2$var$noop = ()=>{};
const $d91034f47eb948f2$var$catchRejection = (promise, onError = $d91034f47eb948f2$var$noop)=>{
    promise.catch(onError);
    return promise;
};
const $d91034f47eb948f2$var$addAbortSignalListener = (abortSignal, callback)=>{
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return ()=>abortSignal.removeEventListener("abort", callback);
};
//#endregion
//#region src/listenerMiddleware/task.ts
const $d91034f47eb948f2$var$validateActive = (signal)=>{
    if (signal.aborted) throw new $d91034f47eb948f2$export$cb1bdac908fed7f(signal.reason);
};
function $d91034f47eb948f2$var$raceWithSignal(signal, promise) {
    let cleanup = $d91034f47eb948f2$var$noop;
    return new Promise((resolve, reject)=>{
        const notifyRejection = ()=>reject(new $d91034f47eb948f2$export$cb1bdac908fed7f(signal.reason));
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $d91034f47eb948f2$var$addAbortSignalListener(signal, notifyRejection);
        promise.finally(()=>cleanup()).then(resolve, reject);
    }).finally(()=>{
        cleanup = $d91034f47eb948f2$var$noop;
    });
}
const $d91034f47eb948f2$var$runTask = async (task, cleanUp)=>{
    try {
        await Promise.resolve();
        return {
            status: "ok",
            value: await task()
        };
    } catch (error) {
        return {
            status: error instanceof $d91034f47eb948f2$export$cb1bdac908fed7f ? "cancelled" : "rejected",
            error: error
        };
    } finally{
        cleanUp === null || cleanUp === void 0 || cleanUp();
    }
};
const $d91034f47eb948f2$var$createPause = (signal)=>{
    return (promise)=>{
        return $d91034f47eb948f2$var$catchRejection($d91034f47eb948f2$var$raceWithSignal(signal, promise).then((output)=>{
            $d91034f47eb948f2$var$validateActive(signal);
            return output;
        }));
    };
};
const $d91034f47eb948f2$var$createDelay = (signal)=>{
    const pause = $d91034f47eb948f2$var$createPause(signal);
    return (timeoutMs)=>{
        return pause(new Promise((resolve)=>setTimeout(resolve, timeoutMs)));
    };
};
//#endregion
//#region src/listenerMiddleware/index.ts
const { assign: $d91034f47eb948f2$var$assign } = Object;
const $d91034f47eb948f2$var$INTERNAL_NIL_TOKEN = {};
const $d91034f47eb948f2$var$alm = "listenerMiddleware";
const $d91034f47eb948f2$var$createFork = (parentAbortSignal, parentBlockingPromises)=>{
    const linkControllers = (controller)=>$d91034f47eb948f2$var$addAbortSignalListener(parentAbortSignal, ()=>controller.abort(parentAbortSignal.reason));
    return (taskExecutor, opts)=>{
        $d91034f47eb948f2$var$assertFunction(taskExecutor, "taskExecutor");
        const childAbortController = new AbortController();
        linkControllers(childAbortController);
        const result = $d91034f47eb948f2$var$runTask(async ()=>{
            $d91034f47eb948f2$var$validateActive(parentAbortSignal);
            $d91034f47eb948f2$var$validateActive(childAbortController.signal);
            const result = await taskExecutor({
                pause: $d91034f47eb948f2$var$createPause(childAbortController.signal),
                delay: $d91034f47eb948f2$var$createDelay(childAbortController.signal),
                signal: childAbortController.signal
            });
            $d91034f47eb948f2$var$validateActive(childAbortController.signal);
            return result;
        }, ()=>childAbortController.abort($d91034f47eb948f2$var$taskCompleted));
        if (opts === null || opts === void 0 ? void 0 : opts.autoJoin) parentBlockingPromises.push(result.catch($d91034f47eb948f2$var$noop));
        return {
            result: $d91034f47eb948f2$var$createPause(parentAbortSignal)(result),
            cancel () {
                childAbortController.abort($d91034f47eb948f2$var$taskCancelled);
            }
        };
    };
};
const $d91034f47eb948f2$var$createTakePattern = (startListening, signal)=>{
    const take = async (predicate, timeout)=>{
        $d91034f47eb948f2$var$validateActive(signal);
        let unsubscribe = ()=>{};
        const promises = [
            new Promise((resolve, reject)=>{
                let stopListening = startListening({
                    predicate: predicate,
                    effect: (action, listenerApi)=>{
                        listenerApi.unsubscribe();
                        resolve([
                            action,
                            listenerApi.getState(),
                            listenerApi.getOriginalState()
                        ]);
                    }
                });
                unsubscribe = ()=>{
                    stopListening();
                    reject();
                };
            })
        ];
        if (timeout != null) promises.push(new Promise((resolve)=>setTimeout(resolve, timeout, null)));
        try {
            const output = await $d91034f47eb948f2$var$raceWithSignal(signal, Promise.race(promises));
            $d91034f47eb948f2$var$validateActive(signal);
            return output;
        } finally{
            unsubscribe();
        }
    };
    return (predicate, timeout)=>$d91034f47eb948f2$var$catchRejection(take(predicate, timeout));
};
const $d91034f47eb948f2$var$getListenerEntryPropsFrom = (options)=>{
    let { type: type, actionCreator: actionCreator, matcher: matcher, predicate: predicate, effect: effect } = options;
    if (type) predicate = $d91034f47eb948f2$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error($d91034f47eb948f2$export$378fa86b259c0280(21));
    $d91034f47eb948f2$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
const $d91034f47eb948f2$var$createListenerEntry = /* @__PURE__ */ $d91034f47eb948f2$var$assign((options)=>{
    const { type: type, predicate: predicate, effect: effect } = $d91034f47eb948f2$var$getListenerEntryPropsFrom(options);
    return {
        id: $d91034f47eb948f2$export$ac4959f4f1338dfc(),
        effect: effect,
        type: type,
        predicate: predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: ()=>{
            throw new Error($d91034f47eb948f2$export$378fa86b259c0280(22));
        }
    };
}, {
    withTypes: ()=>$d91034f47eb948f2$var$createListenerEntry
});
const $d91034f47eb948f2$var$findListenerEntry = (listenerMap, options)=>{
    const { type: type, effect: effect, predicate: predicate } = $d91034f47eb948f2$var$getListenerEntryPropsFrom(options);
    return Array.from(listenerMap.values()).find((entry)=>{
        return (typeof type === "string" ? entry.type === type : entry.predicate === predicate) && entry.effect === effect;
    });
};
const $d91034f47eb948f2$var$cancelActiveListeners = (entry)=>{
    entry.pending.forEach((controller)=>{
        controller.abort($d91034f47eb948f2$var$listenerCancelled);
    });
};
const $d91034f47eb948f2$var$createClearListenerMiddleware = (listenerMap, executingListeners)=>{
    return ()=>{
        for (const listener of executingListeners.keys())$d91034f47eb948f2$var$cancelActiveListeners(listener);
        listenerMap.clear();
    };
};
const $d91034f47eb948f2$var$safelyNotifyError = (errorHandler, errorToNotify, errorInfo)=>{
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(()=>{
            throw errorHandlerError;
        }, 0);
    }
};
const $d91034f47eb948f2$export$f03a6b845d3fb58b = /* @__PURE__ */ $d91034f47eb948f2$var$assign(/* @__PURE__ */ $d91034f47eb948f2$export$309c7a02b0b0bc62(`${$d91034f47eb948f2$var$alm}/add`), {
    withTypes: ()=>$d91034f47eb948f2$export$f03a6b845d3fb58b
});
const $d91034f47eb948f2$export$b1b8022855fb2b71 = /* @__PURE__ */ $d91034f47eb948f2$export$309c7a02b0b0bc62(`${$d91034f47eb948f2$var$alm}/removeAll`);
const $d91034f47eb948f2$export$b03e9483f936dccb = /* @__PURE__ */ $d91034f47eb948f2$var$assign(/* @__PURE__ */ $d91034f47eb948f2$export$309c7a02b0b0bc62(`${$d91034f47eb948f2$var$alm}/remove`), {
    withTypes: ()=>$d91034f47eb948f2$export$b03e9483f936dccb
});
const $d91034f47eb948f2$var$defaultErrorHandler = (...args)=>{
    console.error(`${$d91034f47eb948f2$var$alm}/error`, ...args);
};
const $d91034f47eb948f2$export$1228acebbbcb485b = (middlewareOptions = {})=>{
    const listenerMap = /* @__PURE__ */ new Map();
    const executingListeners = /* @__PURE__ */ new Map();
    const trackExecutingListener = (entry)=>{
        var _executingListeners$g;
        const count = (_executingListeners$g = executingListeners.get(entry)) !== null && _executingListeners$g !== void 0 ? _executingListeners$g : 0;
        executingListeners.set(entry, count + 1);
    };
    const untrackExecutingListener = (entry)=>{
        var _executingListeners$g2;
        const count = (_executingListeners$g2 = executingListeners.get(entry)) !== null && _executingListeners$g2 !== void 0 ? _executingListeners$g2 : 1;
        if (count === 1) executingListeners.delete(entry);
        else executingListeners.set(entry, count - 1);
    };
    const { extra: extra, onError: onError = $d91034f47eb948f2$var$defaultErrorHandler } = middlewareOptions;
    $d91034f47eb948f2$var$assertFunction(onError, "onError");
    const insertEntry = (entry)=>{
        entry.unsubscribe = ()=>listenerMap.delete(entry.id);
        listenerMap.set(entry.id, entry);
        return (cancelOptions)=>{
            entry.unsubscribe();
            if (cancelOptions === null || cancelOptions === void 0 ? void 0 : cancelOptions.cancelActive) $d91034f47eb948f2$var$cancelActiveListeners(entry);
        };
    };
    const startListening = (options)=>{
        var _findListenerEntry;
        const entry = (_findListenerEntry = $d91034f47eb948f2$var$findListenerEntry(listenerMap, options)) !== null && _findListenerEntry !== void 0 ? _findListenerEntry : $d91034f47eb948f2$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    $d91034f47eb948f2$var$assign(startListening, {
        withTypes: ()=>startListening
    });
    const stopListening = (options)=>{
        const entry = $d91034f47eb948f2$var$findListenerEntry(listenerMap, options);
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $d91034f47eb948f2$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    $d91034f47eb948f2$var$assign(stopListening, {
        withTypes: ()=>stopListening
    });
    const notifyListener = async (entry, action, api, getOriginalState)=>{
        const internalTaskController = new AbortController();
        const take = $d91034f47eb948f2$var$createTakePattern(startListening, internalTaskController.signal);
        const autoJoinPromises = [];
        try {
            entry.pending.add(internalTaskController);
            trackExecutingListener(entry);
            await Promise.resolve(entry.effect(action, $d91034f47eb948f2$var$assign({}, api, {
                getOriginalState: getOriginalState,
                condition: (predicate, timeout)=>take(predicate, timeout).then(Boolean),
                take: take,
                delay: $d91034f47eb948f2$var$createDelay(internalTaskController.signal),
                pause: $d91034f47eb948f2$var$createPause(internalTaskController.signal),
                extra: extra,
                signal: internalTaskController.signal,
                fork: $d91034f47eb948f2$var$createFork(internalTaskController.signal, autoJoinPromises),
                unsubscribe: entry.unsubscribe,
                subscribe: ()=>{
                    listenerMap.set(entry.id, entry);
                },
                cancelActiveListeners: ()=>{
                    entry.pending.forEach((controller, _, set)=>{
                        if (controller !== internalTaskController) {
                            controller.abort($d91034f47eb948f2$var$listenerCancelled);
                            set.delete(controller);
                        }
                    });
                },
                cancel: ()=>{
                    internalTaskController.abort($d91034f47eb948f2$var$listenerCancelled);
                    entry.pending.delete(internalTaskController);
                },
                throwIfCancelled: ()=>{
                    $d91034f47eb948f2$var$validateActive(internalTaskController.signal);
                }
            })));
        } catch (listenerError) {
            if (!(listenerError instanceof $d91034f47eb948f2$export$cb1bdac908fed7f)) $d91034f47eb948f2$var$safelyNotifyError(onError, listenerError, {
                raisedBy: "effect"
            });
        } finally{
            await Promise.all(autoJoinPromises);
            internalTaskController.abort($d91034f47eb948f2$var$listenerCompleted);
            untrackExecutingListener(entry);
            entry.pending.delete(internalTaskController);
        }
    };
    const clearListenerMiddleware = $d91034f47eb948f2$var$createClearListenerMiddleware(listenerMap, executingListeners);
    const middleware = (api)=>(next)=>(action)=>{
                if (!(0, $d2bed10dff9b4968$export$b956e38827fca970)(action)) return next(action);
                if ($d91034f47eb948f2$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($d91034f47eb948f2$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($d91034f47eb948f2$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                let originalState = api.getState();
                const getOriginalState = ()=>{
                    if (originalState === $d91034f47eb948f2$var$INTERNAL_NIL_TOKEN) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(23));
                    return originalState;
                };
                let result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        const currentState = api.getState();
                        const listenerEntries = Array.from(listenerMap.values());
                        for (const entry of listenerEntries){
                            let runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $d91034f47eb948f2$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $d91034f47eb948f2$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
};
//#endregion
//#region src/dynamicMiddleware/index.ts
const $d91034f47eb948f2$var$createMiddlewareEntry = (middleware)=>({
        middleware: middleware,
        applied: /* @__PURE__ */ new Map()
    });
const $d91034f47eb948f2$var$matchInstance = (instanceId)=>(action)=>{
        var _action$meta;
        return (action === null || action === void 0 || (_action$meta = action.meta) === null || _action$meta === void 0 ? void 0 : _action$meta.instanceId) === instanceId;
    };
const $d91034f47eb948f2$export$4bb1606a79445586 = ()=>{
    const instanceId = $d91034f47eb948f2$export$ac4959f4f1338dfc();
    const middlewareMap = /* @__PURE__ */ new Map();
    let middlewareVersion = 0;
    const withMiddleware = Object.assign($d91034f47eb948f2$export$309c7a02b0b0bc62("dynamicMiddleware/add", (...middlewares)=>({
            payload: middlewares,
            meta: {
                instanceId: instanceId
            }
        })), {
        withTypes: ()=>withMiddleware
    });
    const addMiddleware = Object.assign(function addMiddleware(...middlewares) {
        const previousSize = middlewareMap.size;
        middlewares.forEach((middleware)=>{
            $d91034f47eb948f2$var$getOrInsertComputed(middlewareMap, middleware, $d91034f47eb948f2$var$createMiddlewareEntry);
        });
        if (middlewareMap.size !== previousSize) middlewareVersion++;
    }, {
        withTypes: ()=>addMiddleware
    });
    const getFinalMiddleware = (api)=>{
        const appliedMiddleware = Array.from(middlewareMap.values()).map((entry)=>$d91034f47eb948f2$var$getOrInsertComputed(entry.applied, api, entry.middleware));
        return (0, $d2bed10dff9b4968$export$f672e0b6f7222cd7)(...appliedMiddleware);
    };
    const isWithMiddleware = $d91034f47eb948f2$export$9dd1fb32974da385(withMiddleware, $d91034f47eb948f2$var$matchInstance(instanceId));
    const middleware = (api)=>(next)=>{
            let appliedVersion = -1;
            let dispatch = next;
            return (action)=>{
                if (isWithMiddleware(action)) {
                    addMiddleware(...action.payload);
                    return api.dispatch;
                }
                if (appliedVersion !== middlewareVersion) {
                    dispatch = getFinalMiddleware(api)(next);
                    appliedVersion = middlewareVersion;
                }
                return dispatch(action);
            };
        };
    return {
        middleware: middleware,
        addMiddleware: addMiddleware,
        withMiddleware: withMiddleware,
        instanceId: instanceId
    };
};
//#endregion
//#region src/combineSlices.ts
const $d91034f47eb948f2$var$isSliceLike = (maybeSliceLike)=>"reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
const $d91034f47eb948f2$var$getReducers = (slices)=>slices.flatMap((sliceOrMap)=>$d91034f47eb948f2$var$isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap));
const $d91034f47eb948f2$var$ORIGINAL_STATE = Symbol.for("rtk-state-proxy-original");
const $d91034f47eb948f2$var$isStateProxy = (value)=>!!value && !!value[$d91034f47eb948f2$var$ORIGINAL_STATE];
const $d91034f47eb948f2$var$createStateProxy = (stateProxyMap, state, reducerMap, initialStateCache)=>$d91034f47eb948f2$var$getOrInsertComputed(stateProxyMap, state, ()=>new Proxy(state, {
            get: (target, prop, receiver)=>{
                if (prop === $d91034f47eb948f2$var$ORIGINAL_STATE) return target;
                const result = Reflect.get(target, prop, receiver);
                if (typeof result === "undefined") {
                    const cached = initialStateCache[prop];
                    if (typeof cached !== "undefined") return cached;
                    const reducer = reducerMap[prop];
                    if (reducer) {
                        const reducerResult = reducer(void 0, {
                            type: $d91034f47eb948f2$export$ac4959f4f1338dfc()
                        });
                        if (typeof reducerResult === "undefined") throw new Error($d91034f47eb948f2$export$378fa86b259c0280(24));
                        initialStateCache[prop] = reducerResult;
                        return reducerResult;
                    }
                }
                return result;
            }
        }));
const $d91034f47eb948f2$var$original$1 = (state)=>{
    if (!$d91034f47eb948f2$var$isStateProxy(state)) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(25));
    return state[$d91034f47eb948f2$var$ORIGINAL_STATE];
};
const $d91034f47eb948f2$var$emptyObject = {};
const $d91034f47eb948f2$var$noopReducer = (state = $d91034f47eb948f2$var$emptyObject)=>state;
function $d91034f47eb948f2$export$a3734c7614660b9(...slices) {
    const stateProxyMap = /* @__PURE__ */ new WeakMap();
    const reducerMap = Object.fromEntries($d91034f47eb948f2$var$getReducers(slices));
    const getReducer = ()=>Object.keys(reducerMap).length ? (0, $d2bed10dff9b4968$export$66e4520cdb265d18)(reducerMap) : $d91034f47eb948f2$var$noopReducer;
    let reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = ()=>combinedReducer;
    const initialStateCache = {};
    const inject = (slice, config = {})=>{
        const { reducerPath: reducerPath, reducer: reducerToInject } = slice;
        const currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) return combinedReducer;
        if (config.overrideExisting && currentReducer !== reducerToInject) delete initialStateCache[reducerPath];
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    const selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector(state, ...args) {
            return selectorFn($d91034f47eb948f2$var$createStateProxy(stateProxyMap, selectState ? selectState(state, ...args) : state, reducerMap, initialStateCache), ...args);
        };
    }, {
        original: $d91034f47eb948f2$var$original$1
    });
    return Object.assign(combinedReducer, {
        inject: inject,
        selector: selector
    });
}
//#endregion
//#region src/formatProdErrorMessage.ts
function $d91034f47eb948f2$export$378fa86b259c0280(code) {
    return `Minified Redux Toolkit error #${code}; visit https://redux-toolkit.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}


var $dc4a47ea750d5f98$export$711117ad6ad27992 = 'persist:';
var $dc4a47ea750d5f98$export$2aaee4793dd13a52 = 'persist/FLUSH';
var $dc4a47ea750d5f98$export$1647ef958242c4e2 = 'persist/REHYDRATE';
var $dc4a47ea750d5f98$export$dd1033c27a16bbd3 = 'persist/PAUSE';
var $dc4a47ea750d5f98$export$913fe0e161ed92a2 = 'persist/PERSIST';
var $dc4a47ea750d5f98$export$5514fc3b4067675f = 'persist/PURGE';
var $dc4a47ea750d5f98$export$51e82cdd7353a0e1 = 'persist/REGISTER';
var $dc4a47ea750d5f98$export$363ebe89e6e7aeef = -1;


function $2df6cf986f188332$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $2df6cf986f188332$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $2df6cf986f188332$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $2df6cf986f188332$var$_typeof(obj);
}
function $2df6cf986f188332$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $2df6cf986f188332$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $2df6cf986f188332$var$ownKeys(source, true).forEach(function(key) {
            $2df6cf986f188332$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $2df6cf986f188332$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $2df6cf986f188332$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2df6cf986f188332$export$2e2bcd8739ae039(inboundState, originalState, reducedState, _ref) {
    var debug = _ref.debug;
    var newState = $2df6cf986f188332$var$_objectSpread({}, reducedState); // only rehydrate if inboundState exists and is an object
    if (inboundState && $2df6cf986f188332$var$_typeof(inboundState) === 'object') Object.keys(inboundState).forEach(function(key) {
        // ignore _persist data
        if (key === '_persist') return; // if reducer modifies substate, skip auto rehydration
        if (originalState[key] !== reducedState[key]) return;
         // otherwise hard set the new value
        newState[key] = inboundState[key];
    });
    return newState;
}



function $a17e9ce2c74bd9e8$export$2e2bcd8739ae039(config) {
    // defaults
    var blacklist = config.blacklist || null;
    var whitelist = config.whitelist || null;
    var transforms = config.transforms || [];
    var throttle = config.throttle || 0;
    var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : (0, $dc4a47ea750d5f98$export$711117ad6ad27992)).concat(config.key);
    var storage = config.storage;
    var serialize;
    if (config.serialize === false) serialize = function serialize(x) {
        return x;
    };
    else if (typeof config.serialize === 'function') serialize = config.serialize;
    else serialize = $a17e9ce2c74bd9e8$var$defaultSerialize;
    var writeFailHandler = config.writeFailHandler || null; // initialize stateful values
    var lastState = {};
    var stagedState = {};
    var keysToProcess = [];
    var timeIterator = null;
    var writePromise = null;
    var update = function update(state) {
        // add any changed keys to the queue
        Object.keys(state).forEach(function(key) {
            if (!passWhitelistBlacklist(key)) return; // is keyspace ignored? noop
            if (lastState[key] === state[key]) return; // value unchanged? noop
            if (keysToProcess.indexOf(key) !== -1) return; // is key already queued? noop
            keysToProcess.push(key); // add key to queue
        }); //if any key is missing in the new state which was present in the lastState,
        //add it for processing too
        Object.keys(lastState).forEach(function(key) {
            if (state[key] === undefined && passWhitelistBlacklist(key) && keysToProcess.indexOf(key) === -1 && lastState[key] !== undefined) keysToProcess.push(key);
        }); // start the time iterator if not running (read: throttle)
        if (timeIterator === null) timeIterator = setInterval(processNextKey, throttle);
        lastState = state;
    };
    function processNextKey() {
        if (keysToProcess.length === 0) {
            if (timeIterator) clearInterval(timeIterator);
            timeIterator = null;
            return;
        }
        var key = keysToProcess.shift();
        var endState = transforms.reduce(function(subState, transformer) {
            return transformer.in(subState, key, lastState);
        }, lastState[key]);
        if (endState !== undefined) try {
            stagedState[key] = serialize(endState);
        } catch (err) {
            console.error('redux-persist/createPersistoid: error serializing state', err);
        }
        else //if the endState is undefined, no need to persist the existing serialized content
        delete stagedState[key];
        if (keysToProcess.length === 0) writeStagedState();
    }
    function writeStagedState() {
        // cleanup any removed keys just before write.
        Object.keys(stagedState).forEach(function(key) {
            if (lastState[key] === undefined) delete stagedState[key];
        });
        writePromise = storage.setItem(storageKey, serialize(stagedState)).catch(onWriteFail);
    }
    function passWhitelistBlacklist(key) {
        if (whitelist && whitelist.indexOf(key) === -1 && key !== '_persist') return false;
        if (blacklist && blacklist.indexOf(key) !== -1) return false;
        return true;
    }
    function onWriteFail(err) {
        // @TODO add fail handlers (typically storage full)
        if (writeFailHandler) writeFailHandler(err);
    }
    var flush = function flush() {
        while(keysToProcess.length !== 0)processNextKey();
        return writePromise || Promise.resolve();
    }; // return `persistoid`
    return {
        update: update,
        flush: flush
    };
} // @NOTE in the future this may be exposed via config
function $a17e9ce2c74bd9e8$var$defaultSerialize(data) {
    return JSON.stringify(data);
}



function $0a2c0a3a61a7a1b9$export$2e2bcd8739ae039(config) {
    var transforms = config.transforms || [];
    var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : (0, $dc4a47ea750d5f98$export$711117ad6ad27992)).concat(config.key);
    var storage = config.storage;
    var debug = config.debug;
    var deserialize;
    if (config.deserialize === false) deserialize = function deserialize(x) {
        return x;
    };
    else if (typeof config.deserialize === 'function') deserialize = config.deserialize;
    else deserialize = $0a2c0a3a61a7a1b9$var$defaultDeserialize;
    return storage.getItem(storageKey).then(function(serialized) {
        if (!serialized) return undefined;
        else try {
            var state = {};
            var rawState = deserialize(serialized);
            Object.keys(rawState).forEach(function(key) {
                state[key] = transforms.reduceRight(function(subState, transformer) {
                    return transformer.out(subState, key, rawState);
                }, deserialize(rawState[key]));
            });
            return state;
        } catch (err) {
            throw err;
        }
    });
}
function $0a2c0a3a61a7a1b9$var$defaultDeserialize(serial) {
    return JSON.parse(serial);
}



function $4db55e14b5a1f785$export$2e2bcd8739ae039(config) {
    var storage = config.storage;
    var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : (0, $dc4a47ea750d5f98$export$711117ad6ad27992)).concat(config.key);
    return storage.removeItem(storageKey, $4db55e14b5a1f785$var$warnIfRemoveError);
}
function $4db55e14b5a1f785$var$warnIfRemoveError(err) {}


function $73e435e2fc216b6c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $73e435e2fc216b6c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $73e435e2fc216b6c$var$ownKeys(source, true).forEach(function(key) {
            $73e435e2fc216b6c$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $73e435e2fc216b6c$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $73e435e2fc216b6c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $73e435e2fc216b6c$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $73e435e2fc216b6c$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $73e435e2fc216b6c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $73e435e2fc216b6c$var$DEFAULT_TIMEOUT = 5000;
function $73e435e2fc216b6c$export$2e2bcd8739ae039(config, baseReducer) {
    var version = config.version !== undefined ? config.version : (0, $dc4a47ea750d5f98$export$363ebe89e6e7aeef);
    var debug = config.debug || false;
    var stateReconciler = config.stateReconciler === undefined ? (0, $2df6cf986f188332$export$2e2bcd8739ae039) : config.stateReconciler;
    var getStoredState = config.getStoredState || (0, $0a2c0a3a61a7a1b9$export$2e2bcd8739ae039);
    var timeout = config.timeout !== undefined ? config.timeout : $73e435e2fc216b6c$var$DEFAULT_TIMEOUT;
    var _persistoid = null;
    var _purge = false;
    var _paused = true;
    var conditionalUpdate = function conditionalUpdate(state) {
        // update the persistoid only if we are rehydrated and not paused
        state._persist.rehydrated && _persistoid && !_paused && _persistoid.update(state);
        return state;
    };
    return function(state, action) {
        var _ref = state || {}, _persist = _ref._persist, rest = $73e435e2fc216b6c$var$_objectWithoutProperties(_ref, [
            "_persist"
        ]); // $FlowIgnore need to update State type
        var restState = rest;
        if (action.type === (0, $dc4a47ea750d5f98$export$913fe0e161ed92a2)) {
            var _sealed = false;
            var _rehydrate = function _rehydrate(payload, err) {
                if (!_sealed) {
                    action.rehydrate(config.key, payload, err);
                    _sealed = true;
                }
            };
            timeout && setTimeout(function() {
                !_sealed && _rehydrate(undefined, new Error("redux-persist: persist timed out for persist key \"".concat(config.key, "\"")));
            }, timeout); // @NOTE PERSIST resumes if paused.
            _paused = false; // @NOTE only ever create persistoid once, ensure we call it at least once, even if _persist has already been set
            if (!_persistoid) _persistoid = (0, $a17e9ce2c74bd9e8$export$2e2bcd8739ae039)(config); // @NOTE PERSIST can be called multiple times, noop after the first
            if (_persist) // We still need to call the base reducer because there might be nested
            // uses of persistReducer which need to be aware of the PERSIST action
            return $73e435e2fc216b6c$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: _persist
            });
            if (typeof action.rehydrate !== 'function' || typeof action.register !== 'function') throw new Error('redux-persist: either rehydrate or register is not a function on the PERSIST action. This can happen if the action is being replayed. This is an unexplored use case, please open an issue and we will figure out a resolution.');
            action.register(config.key);
            getStoredState(config).then(function(restoredState) {
                var migrate = config.migrate || function(s, v) {
                    return Promise.resolve(s);
                };
                migrate(restoredState, version).then(function(migratedState) {
                    _rehydrate(migratedState);
                }, function(migrateErr) {
                    _rehydrate(undefined, migrateErr);
                });
            }, function(err) {
                _rehydrate(undefined, err);
            });
            return $73e435e2fc216b6c$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: {
                    version: version,
                    rehydrated: false
                }
            });
        } else if (action.type === (0, $dc4a47ea750d5f98$export$5514fc3b4067675f)) {
            _purge = true;
            action.result((0, $4db55e14b5a1f785$export$2e2bcd8739ae039)(config));
            return $73e435e2fc216b6c$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: _persist
            });
        } else if (action.type === (0, $dc4a47ea750d5f98$export$2aaee4793dd13a52)) {
            action.result(_persistoid && _persistoid.flush());
            return $73e435e2fc216b6c$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: _persist
            });
        } else if (action.type === (0, $dc4a47ea750d5f98$export$dd1033c27a16bbd3)) _paused = true;
        else if (action.type === (0, $dc4a47ea750d5f98$export$1647ef958242c4e2)) {
            // noop on restState if purging
            if (_purge) return $73e435e2fc216b6c$var$_objectSpread({}, restState, {
                _persist: $73e435e2fc216b6c$var$_objectSpread({}, _persist, {
                    rehydrated: true
                }) // @NOTE if key does not match, will continue to default else below
            });
            if (action.key === config.key) {
                var reducedState = baseReducer(restState, action);
                var inboundState = action.payload; // only reconcile state if stateReconciler and inboundState are both defined
                var reconciledRest = stateReconciler !== false && inboundState !== undefined ? stateReconciler(inboundState, state, reducedState, config) : reducedState;
                var _newState = $73e435e2fc216b6c$var$_objectSpread({}, reconciledRest, {
                    _persist: $73e435e2fc216b6c$var$_objectSpread({}, _persist, {
                        rehydrated: true
                    })
                });
                return conditionalUpdate(_newState);
            }
        } // if we have not already handled PERSIST, straight passthrough
        if (!_persist) return baseReducer(state, action); // run base reducer:
        // is state modified ? return original : return updated
        var newState = baseReducer(restState, action);
        if (newState === restState) return state;
        return conditionalUpdate($73e435e2fc216b6c$var$_objectSpread({}, newState, {
            _persist: _persist
        }));
    };
}




function $792f2290643e73f9$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $792f2290643e73f9$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $792f2290643e73f9$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $792f2290643e73f9$var$_typeof(obj);
}
function $792f2290643e73f9$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $792f2290643e73f9$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $792f2290643e73f9$var$ownKeys(source, true).forEach(function(key) {
            $792f2290643e73f9$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $792f2290643e73f9$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $792f2290643e73f9$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $792f2290643e73f9$export$2e2bcd8739ae039(inboundState, originalState, reducedState, _ref) {
    var debug = _ref.debug;
    var newState = $792f2290643e73f9$var$_objectSpread({}, reducedState); // only rehydrate if inboundState exists and is an object
    if (inboundState && $792f2290643e73f9$var$_typeof(inboundState) === 'object') Object.keys(inboundState).forEach(function(key) {
        // ignore _persist data
        if (key === '_persist') return; // if reducer modifies substate, skip auto rehydration
        if (originalState[key] !== reducedState[key]) return;
        if ($792f2290643e73f9$var$isPlainEnoughObject(reducedState[key])) {
            // if object is plain enough shallow merge the new values (hence "Level2")
            newState[key] = $792f2290643e73f9$var$_objectSpread({}, newState[key], {}, inboundState[key]);
            return;
        } // otherwise hard set
        newState[key] = inboundState[key];
    });
    return newState;
}
function $792f2290643e73f9$var$isPlainEnoughObject(o) {
    return o !== null && !Array.isArray(o) && $792f2290643e73f9$var$_typeof(o) === 'object';
}


function $04cffa891861b45f$export$2e2bcd8739ae039(config, reducers) {
    config.stateReconciler = config.stateReconciler === undefined ? (0, $792f2290643e73f9$export$2e2bcd8739ae039) : config.stateReconciler;
    return (0, $73e435e2fc216b6c$export$2e2bcd8739ae039)(config, (0, $d2bed10dff9b4968$export$66e4520cdb265d18)(reducers));
}




function $46c0b3c6eec1f9fa$var$_toConsumableArray(arr) {
    return $46c0b3c6eec1f9fa$var$_arrayWithoutHoles(arr) || $46c0b3c6eec1f9fa$var$_iterableToArray(arr) || $46c0b3c6eec1f9fa$var$_nonIterableSpread();
}
function $46c0b3c6eec1f9fa$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function $46c0b3c6eec1f9fa$var$_iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function $46c0b3c6eec1f9fa$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}
function $46c0b3c6eec1f9fa$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $46c0b3c6eec1f9fa$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $46c0b3c6eec1f9fa$var$ownKeys(source, true).forEach(function(key) {
            $46c0b3c6eec1f9fa$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $46c0b3c6eec1f9fa$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $46c0b3c6eec1f9fa$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $46c0b3c6eec1f9fa$var$initialState = {
    registry: [],
    bootstrapped: false
};
var $46c0b3c6eec1f9fa$var$persistorReducer = function persistorReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $46c0b3c6eec1f9fa$var$initialState;
    var action = arguments.length > 1 ? arguments[1] : undefined;
    switch(action.type){
        case 0, $dc4a47ea750d5f98$export$51e82cdd7353a0e1:
            return $46c0b3c6eec1f9fa$var$_objectSpread({}, state, {
                registry: [].concat($46c0b3c6eec1f9fa$var$_toConsumableArray(state.registry), [
                    action.key
                ])
            });
        case 0, $dc4a47ea750d5f98$export$1647ef958242c4e2:
            var firstIndex = state.registry.indexOf(action.key);
            var registry = $46c0b3c6eec1f9fa$var$_toConsumableArray(state.registry);
            registry.splice(firstIndex, 1);
            return $46c0b3c6eec1f9fa$var$_objectSpread({}, state, {
                registry: registry,
                bootstrapped: registry.length === 0
            });
        default:
            return state;
    }
};
function $46c0b3c6eec1f9fa$export$2e2bcd8739ae039(store, options, cb) {
    var optionsToTest, bannedKeys;
    var boostrappedCb = cb || false;
    var _pStore = (0, $d2bed10dff9b4968$export$f51a9068ac82ea43)($46c0b3c6eec1f9fa$var$persistorReducer, $46c0b3c6eec1f9fa$var$initialState, options && options.enhancer ? options.enhancer : undefined);
    var register = function register(key) {
        _pStore.dispatch({
            type: (0, $dc4a47ea750d5f98$export$51e82cdd7353a0e1),
            key: key
        });
    };
    var rehydrate = function rehydrate(key, payload, err) {
        var rehydrateAction = {
            type: (0, $dc4a47ea750d5f98$export$1647ef958242c4e2),
            payload: payload,
            err: err,
            key: key // dispatch to `store` to rehydrate and `persistor` to track result
        };
        store.dispatch(rehydrateAction);
        _pStore.dispatch(rehydrateAction);
        if (boostrappedCb && persistor.getState().bootstrapped) {
            boostrappedCb();
            boostrappedCb = false;
        }
    };
    var persistor = $46c0b3c6eec1f9fa$var$_objectSpread({}, _pStore, {
        purge: function purge() {
            var results = [];
            store.dispatch({
                type: (0, $dc4a47ea750d5f98$export$5514fc3b4067675f),
                result: function result(purgeResult) {
                    results.push(purgeResult);
                }
            });
            return Promise.all(results);
        },
        flush: function flush() {
            var results = [];
            store.dispatch({
                type: (0, $dc4a47ea750d5f98$export$2aaee4793dd13a52),
                result: function result(flushResult) {
                    results.push(flushResult);
                }
            });
            return Promise.all(results);
        },
        pause: function pause() {
            store.dispatch({
                type: (0, $dc4a47ea750d5f98$export$dd1033c27a16bbd3)
            });
        },
        persist: function persist() {
            store.dispatch({
                type: (0, $dc4a47ea750d5f98$export$913fe0e161ed92a2),
                register: register,
                rehydrate: rehydrate
            });
        }
    });
    if (!(options && options.manualPersist)) persistor.persist();
    return persistor;
}



function $e8e82c4ef51638c8$export$2e2bcd8739ae039(migrations, config) {
    var _ref = config || {}, debug = _ref.debug;
    return function(state, currentVersion) {
        if (!state) return Promise.resolve(undefined);
        var inboundVersion = state._persist && state._persist.version !== undefined ? state._persist.version : (0, $dc4a47ea750d5f98$export$363ebe89e6e7aeef);
        if (inboundVersion === currentVersion) return Promise.resolve(state);
        if (inboundVersion > currentVersion) return Promise.resolve(state);
        var migrationKeys = Object.keys(migrations).map(function(ver) {
            return parseInt(ver);
        }).filter(function(key) {
            return currentVersion >= key && key > inboundVersion;
        }).sort(function(a, b) {
            return a - b;
        });
        try {
            var migratedState = migrationKeys.reduce(function(state, versionKey) {
                return migrations[versionKey](state);
            }, state);
            return Promise.resolve(migratedState);
        } catch (err) {
            return Promise.reject(err);
        }
    };
}


function $a82db8a0418f5db2$export$2e2bcd8739ae039(inbound, outbound) {
    var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var whitelist = config.whitelist || null;
    var blacklist = config.blacklist || null;
    function whitelistBlacklistCheck(key) {
        if (whitelist && whitelist.indexOf(key) === -1) return true;
        if (blacklist && blacklist.indexOf(key) !== -1) return true;
        return false;
    }
    return {
        in: function _in(state, key, fullState) {
            return !whitelistBlacklistCheck(key) && inbound ? inbound(state, key, fullState) : state;
        },
        out: function out(state, key, fullState) {
            return !whitelistBlacklistCheck(key) && outbound ? outbound(state, key, fullState) : state;
        }
    };
}








var $b36a05dffe55b995$export$1e511d4a378977f5;
var $b36a05dffe55b995$export$2e2bcd8739ae039;
"use strict";
$b36a05dffe55b995$export$1e511d4a378977f5 = true;
$b36a05dffe55b995$export$2e2bcd8739ae039 = void 0;

var $b36a05dffe55b995$var$_createWebStorage = $b36a05dffe55b995$var$_interopRequireDefault((parcelRequire("7Asxf")));
function $b36a05dffe55b995$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $b36a05dffe55b995$var$_default = (0, $b36a05dffe55b995$var$_createWebStorage.default)('local');
$b36a05dffe55b995$export$2e2bcd8739ae039 = $b36a05dffe55b995$var$_default;




const $714babfa78423ce1$var$initialState = {
    portal_theme: null,
    tenant_id: "",
    customer_id: "",
    business_id: "",
    business_name: "",
    secure_id: "",
    business_logo: "",
    grievance_template_id: "",
    integration_tenant_id: "",
    integration_business_id: "",
    integration_grievanceTemplate_id: "",
    parentConsentMetaData: null,
    parentCode: "",
    parentState: "",
    // Language/Translation state
    currentLanguage: "ENGLISH",
    currentSourceLang: "en",
    translations: {},
    isTranslating: false,
    parental_redirect_url: ""
};
const $714babfa78423ce1$var$commonReducer = (state = $714babfa78423ce1$var$initialState, action)=>{
    switch(action.type){
        case 0, $dee2f92127058cd3$export$8754a668aecb2a04:
            return {
                ...state,
                portal_theme: action.payload
            };
        case 0, $dee2f92127058cd3$export$e28a0e7733933219:
            return $714babfa78423ce1$var$initialState;
        case 0, $dee2f92127058cd3$export$9feaa1032f771c36:
            return {
                ...state,
                business_name: action.payload
            };
        case 0, $dee2f92127058cd3$export$c81870bc2191aec7:
            return {
                ...state,
                business_logo: action.payload
            };
        case 0, $dee2f92127058cd3$export$c829181dc407b03f:
            return {
                ...state,
                tenant_id: action.payload.tenantId,
                customer_id: action.payload.customerId,
                business_id: action.payload.businessId,
                grievance_template_id: action.payload.grievanceTemplateId,
                secure_id: action.payload.secureCode,
                parental_redirect_url: action.payload.parentlCbUrl
            };
        case 0, $dee2f92127058cd3$export$b2c0b9812d26261f:
            return {
                ...state,
                integration_tenant_id: action.payload.tenantId,
                integration_business_id: action.payload.businessId,
                integration_grievanceTemplate_id: action.payload.grievanceTemplateId
            };
        case 0, $dee2f92127058cd3$export$6027aad055c44279:
            return {
                ...state,
                parentConsentMetaData: action.payload
            };
        case 0, $dee2f92127058cd3$export$8a030116ef1d058b:
            return {
                ...state,
                parentCode: action.payload
            };
        case 0, $dee2f92127058cd3$export$aa27936551104482:
            return {
                ...state,
                parentState: action.payload
            };
        case 0, $dee2f92127058cd3$export$7dc30384a9e2138c:
            return {
                ...state,
                currentLanguage: action.payload.language,
                currentSourceLang: action.payload.sourceLang
            };
        case 0, $dee2f92127058cd3$export$61812dfd55580ecf:
            return {
                ...state,
                translations: {
                    ...state.translations,
                    ...action.payload
                }
            };
        case 0, $dee2f92127058cd3$export$a7d24a17944978e7:
            return {
                ...state,
                isTranslating: action.payload
            };
        default:
            return state;
    }
};
var $714babfa78423ce1$export$2e2bcd8739ae039 = $714babfa78423ce1$var$commonReducer;


// Persist config
const $68f6ed6174fa5191$var$persistConfig = {
    key: "root",
    storage: $b36a05dffe55b995$export$2e2bcd8739ae039
};
// Combine reducers
const $68f6ed6174fa5191$var$rootReducer = (0, $d2bed10dff9b4968$export$66e4520cdb265d18)({
    common: (0, $714babfa78423ce1$export$2e2bcd8739ae039)
});
// Persisted reducer
const $68f6ed6174fa5191$var$persistedReducer = (0, $73e435e2fc216b6c$export$2e2bcd8739ae039)($68f6ed6174fa5191$var$persistConfig, $68f6ed6174fa5191$var$rootReducer);
const $68f6ed6174fa5191$export$6f57813fe9f31bf9 = (0, $d91034f47eb948f2$export$7d8a5b498da695ac)({
    reducer: $68f6ed6174fa5191$var$persistedReducer,
    middleware: (getDefaultMiddleware)=>getDefaultMiddleware({
            serializableCheck: false
        }),
    devTools: true
});
const $68f6ed6174fa5191$export$7b682ac9934ca3e4 = (0, $46c0b3c6eec1f9fa$export$2e2bcd8739ae039)($68f6ed6174fa5191$export$6f57813fe9f31bf9);


const $35da740d59af89ba$var$root = (0, $7e96a608cb33bf79$export$882461b6382ed46c)(document.getElementById("root"));
$35da740d59af89ba$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $55388fc2f116d4d7$export$2881499e37b75b9a), {
    store: (0, $68f6ed6174fa5191$export$6f57813fe9f31bf9),
    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$9ba4e89fdfa1fc54), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4c8cda5d2c6d1d8b$export$2e2bcd8739ae039), {})
    })
}));


//# sourceMappingURL=s.15c1e19f.js.map
